(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[2888],{

/***/ 23541:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Ry": function() { return /* binding */ hideOthers; }
/* harmony export */ });
/* unused harmony exports inertOthers, supportsInert, suppressOthers */
var getDefaultParent = function (originalTarget) {
    if (typeof document === 'undefined') {
        return null;
    }
    var sampleTarget = Array.isArray(originalTarget) ? originalTarget[0] : originalTarget;
    return sampleTarget.ownerDocument.body;
};
var counterMap = new WeakMap();
var uncontrolledNodes = new WeakMap();
var markerMap = {};
var lockCount = 0;
var unwrapHost = function (node) {
    return node && (node.host || unwrapHost(node.parentNode));
};
var correctTargets = function (parent, targets) {
    return targets
        .map(function (target) {
        if (parent.contains(target)) {
            return target;
        }
        var correctedTarget = unwrapHost(target);
        if (correctedTarget && parent.contains(correctedTarget)) {
            return correctedTarget;
        }
        console.error('aria-hidden', target, 'in not contained inside', parent, '. Doing nothing');
        return null;
    })
        .filter(function (x) { return Boolean(x); });
};
/**
 * Marks everything except given node(or nodes) as aria-hidden
 * @param {Element | Element[]} originalTarget - elements to keep on the page
 * @param [parentNode] - top element, defaults to document.body
 * @param {String} [markerName] - a special attribute to mark every node
 * @param {String} [controlAttribute] - html Attribute to control
 * @return {Undo} undo command
 */
var applyAttributeToOthers = function (originalTarget, parentNode, markerName, controlAttribute) {
    var targets = correctTargets(parentNode, Array.isArray(originalTarget) ? originalTarget : [originalTarget]);
    if (!markerMap[markerName]) {
        markerMap[markerName] = new WeakMap();
    }
    var markerCounter = markerMap[markerName];
    var hiddenNodes = [];
    var elementsToKeep = new Set();
    var elementsToStop = new Set(targets);
    var keep = function (el) {
        if (!el || elementsToKeep.has(el)) {
            return;
        }
        elementsToKeep.add(el);
        keep(el.parentNode);
    };
    targets.forEach(keep);
    var deep = function (parent) {
        if (!parent || elementsToStop.has(parent)) {
            return;
        }
        Array.prototype.forEach.call(parent.children, function (node) {
            if (elementsToKeep.has(node)) {
                deep(node);
            }
            else {
                var attr = node.getAttribute(controlAttribute);
                var alreadyHidden = attr !== null && attr !== 'false';
                var counterValue = (counterMap.get(node) || 0) + 1;
                var markerValue = (markerCounter.get(node) || 0) + 1;
                counterMap.set(node, counterValue);
                markerCounter.set(node, markerValue);
                hiddenNodes.push(node);
                if (counterValue === 1 && alreadyHidden) {
                    uncontrolledNodes.set(node, true);
                }
                if (markerValue === 1) {
                    node.setAttribute(markerName, 'true');
                }
                if (!alreadyHidden) {
                    node.setAttribute(controlAttribute, 'true');
                }
            }
        });
    };
    deep(parentNode);
    elementsToKeep.clear();
    lockCount++;
    return function () {
        hiddenNodes.forEach(function (node) {
            var counterValue = counterMap.get(node) - 1;
            var markerValue = markerCounter.get(node) - 1;
            counterMap.set(node, counterValue);
            markerCounter.set(node, markerValue);
            if (!counterValue) {
                if (!uncontrolledNodes.has(node)) {
                    node.removeAttribute(controlAttribute);
                }
                uncontrolledNodes.delete(node);
            }
            if (!markerValue) {
                node.removeAttribute(markerName);
            }
        });
        lockCount--;
        if (!lockCount) {
            // clear
            counterMap = new WeakMap();
            counterMap = new WeakMap();
            uncontrolledNodes = new WeakMap();
            markerMap = {};
        }
    };
};
/**
 * Marks everything except given node(or nodes) as aria-hidden
 * @param {Element | Element[]} originalTarget - elements to keep on the page
 * @param [parentNode] - top element, defaults to document.body
 * @param {String} [markerName] - a special attribute to mark every node
 * @return {Undo} undo command
 */
var hideOthers = function (originalTarget, parentNode, markerName) {
    if (markerName === void 0) { markerName = 'data-aria-hidden'; }
    var targets = Array.from(Array.isArray(originalTarget) ? originalTarget : [originalTarget]);
    var activeParentNode = parentNode || getDefaultParent(originalTarget);
    if (!activeParentNode) {
        return function () { return null; };
    }
    // we should not hide ariaLive elements - https://github.com/theKashey/aria-hidden/issues/10
    targets.push.apply(targets, Array.from(activeParentNode.querySelectorAll('[aria-live]')));
    return applyAttributeToOthers(targets, activeParentNode, markerName, 'aria-hidden');
};
/**
 * Marks everything except given node(or nodes) as inert
 * @param {Element | Element[]} originalTarget - elements to keep on the page
 * @param [parentNode] - top element, defaults to document.body
 * @param {String} [markerName] - a special attribute to mark every node
 * @return {Undo} undo command
 */
var inertOthers = function (originalTarget, parentNode, markerName) {
    if (markerName === void 0) { markerName = 'data-inert-ed'; }
    var activeParentNode = parentNode || getDefaultParent(originalTarget);
    if (!activeParentNode) {
        return function () { return null; };
    }
    return applyAttributeToOthers(originalTarget, activeParentNode, markerName, 'inert');
};
/**
 * @returns if current browser supports inert
 */
var supportsInert = function () {
    return typeof HTMLElement !== 'undefined' && HTMLElement.prototype.hasOwnProperty('inert');
};
/**
 * Automatic function to "suppress" DOM elements - _hide_ or _inert_ in the best possible way
 * @param {Element | Element[]} originalTarget - elements to keep on the page
 * @param [parentNode] - top element, defaults to document.body
 * @param {String} [markerName] - a special attribute to mark every node
 * @return {Undo} undo command
 */
var suppressOthers = function (originalTarget, parentNode, markerName) {
    if (markerName === void 0) { markerName = 'data-suppressed'; }
    return (supportsInert() ? inertOthers : hideOthers)(originalTarget, parentNode, markerName);
};


/***/ }),

/***/ 58363:
/***/ (function(__unused_webpack_module, exports) {

"use strict";
var __webpack_unused_export__;


__webpack_unused_export__ = true;

exports.Z = function (file, acceptedFiles) {
  if (file && acceptedFiles) {
    var acceptedFilesArray = Array.isArray(acceptedFiles) ? acceptedFiles : acceptedFiles.split(',');
    var fileName = file.name || '';
    var mimeType = (file.type || '').toLowerCase();
    var baseMimeType = mimeType.replace(/\/.*$/, '');
    return acceptedFilesArray.some(function (type) {
      var validType = type.trim().toLowerCase();

      if (validType.charAt(0) === '.') {
        return fileName.toLowerCase().endsWith(validType);
      } else if (validType.endsWith('/*')) {
        // This is something like a image/* mime type
        return baseMimeType === validType.replace(/\/.*$/, '');
      }

      return mimeType === validType;
    });
  }

  return true;
};

/***/ }),

/***/ 2350:
/***/ (function() {



/***/ }),

/***/ 6230:
/***/ (function(module) {

/* eslint-env browser */
module.exports = typeof self == 'object' ? self.FormData : window.FormData;


/***/ }),

/***/ 8679:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var reactIs = __webpack_require__(59864);

/**
 * Copyright 2015, Yahoo! Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */
var REACT_STATICS = {
  childContextTypes: true,
  contextType: true,
  contextTypes: true,
  defaultProps: true,
  displayName: true,
  getDefaultProps: true,
  getDerivedStateFromError: true,
  getDerivedStateFromProps: true,
  mixins: true,
  propTypes: true,
  type: true
};
var KNOWN_STATICS = {
  name: true,
  length: true,
  prototype: true,
  caller: true,
  callee: true,
  arguments: true,
  arity: true
};
var FORWARD_REF_STATICS = {
  '$$typeof': true,
  render: true,
  defaultProps: true,
  displayName: true,
  propTypes: true
};
var MEMO_STATICS = {
  '$$typeof': true,
  compare: true,
  defaultProps: true,
  displayName: true,
  propTypes: true,
  type: true
};
var TYPE_STATICS = {};
TYPE_STATICS[reactIs.ForwardRef] = FORWARD_REF_STATICS;
TYPE_STATICS[reactIs.Memo] = MEMO_STATICS;

function getStatics(component) {
  // React v16.11 and below
  if (reactIs.isMemo(component)) {
    return MEMO_STATICS;
  } // React v16.12 and above


  return TYPE_STATICS[component['$$typeof']] || REACT_STATICS;
}

var defineProperty = Object.defineProperty;
var getOwnPropertyNames = Object.getOwnPropertyNames;
var getOwnPropertySymbols = Object.getOwnPropertySymbols;
var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
var getPrototypeOf = Object.getPrototypeOf;
var objectPrototype = Object.prototype;
function hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
  if (typeof sourceComponent !== 'string') {
    // don't hoist over string (html) components
    if (objectPrototype) {
      var inheritedComponent = getPrototypeOf(sourceComponent);

      if (inheritedComponent && inheritedComponent !== objectPrototype) {
        hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
      }
    }

    var keys = getOwnPropertyNames(sourceComponent);

    if (getOwnPropertySymbols) {
      keys = keys.concat(getOwnPropertySymbols(sourceComponent));
    }

    var targetStatics = getStatics(targetComponent);
    var sourceStatics = getStatics(sourceComponent);

    for (var i = 0; i < keys.length; ++i) {
      var key = keys[i];

      if (!KNOWN_STATICS[key] && !(blacklist && blacklist[key]) && !(sourceStatics && sourceStatics[key]) && !(targetStatics && targetStatics[key])) {
        var descriptor = getOwnPropertyDescriptor(sourceComponent, key);

        try {
          // Avoid failures from read-only properties
          defineProperty(targetComponent, key, descriptor);
        } catch (e) {}
      }
    }
  }

  return targetComponent;
}

module.exports = hoistNonReactStatics;


/***/ }),

/***/ 84297:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ createLucideIcon; }
});

// UNUSED EXPORTS: toKebabCase

// EXTERNAL MODULE: ./node_modules/next/dist/compiled/react/index.js
var react = __webpack_require__(55784);
;// CONCATENATED MODULE: ./node_modules/lucide-react/dist/esm/defaultAttributes.js
/**
 * @license lucide-react v0.303.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */

var defaultAttributes = {
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
};


//# sourceMappingURL=defaultAttributes.js.map

;// CONCATENATED MODULE: ./node_modules/lucide-react/dist/esm/createLucideIcon.js
/**
 * @license lucide-react v0.303.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */




const toKebabCase = (string) => string.replace(/([a-z0-9])([A-Z])/g, "$1-$2").toLowerCase().trim();
const createLucideIcon = (iconName, iconNode) => {
  const Component = (0,react.forwardRef)(
    ({ color = "currentColor", size = 24, strokeWidth = 2, absoluteStrokeWidth, className = "", children, ...rest }, ref) => (0,react.createElement)(
      "svg",
      {
        ref,
        ...defaultAttributes,
        width: size,
        height: size,
        stroke: color,
        strokeWidth: absoluteStrokeWidth ? Number(strokeWidth) * 24 / Number(size) : strokeWidth,
        className: ["lucide", `lucide-${toKebabCase(iconName)}`, className].join(" "),
        ...rest
      },
      [
        ...iconNode.map(([tag, attrs]) => (0,react.createElement)(tag, attrs)),
        ...Array.isArray(children) ? children : [children]
      ]
    )
  );
  Component.displayName = `${iconName}`;
  return Component;
};


//# sourceMappingURL=createLucideIcon.js.map


/***/ }),

/***/ 13742:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ Check; }
/* harmony export */ });
/* harmony import */ var _createLucideIcon_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(84297);
/**
 * @license lucide-react v0.303.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */



const Check = (0,_createLucideIcon_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("Check", [["path", { d: "M20 6 9 17l-5-5", key: "1gmf2c" }]]);


//# sourceMappingURL=check.js.map


/***/ }),

/***/ 64998:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ ChevronRight; }
/* harmony export */ });
/* harmony import */ var _createLucideIcon_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(84297);
/**
 * @license lucide-react v0.303.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */



const ChevronRight = (0,_createLucideIcon_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("ChevronRight", [
  ["path", { d: "m9 18 6-6-6-6", key: "mthhwq" }]
]);


//# sourceMappingURL=chevron-right.js.map


/***/ }),

/***/ 50316:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ Circle; }
/* harmony export */ });
/* harmony import */ var _createLucideIcon_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(84297);
/**
 * @license lucide-react v0.303.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */



const Circle = (0,_createLucideIcon_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("Circle", [
  ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }]
]);


//# sourceMappingURL=circle.js.map


/***/ }),

/***/ 65666:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Vietnamese [vi]
//! author : Bang Nguyen : https://github.com/bangnk
//! author : Chien Kira : https://github.com/chienkira

;(function (global, factory) {
    true ? factory(__webpack_require__(30381)) :
   0
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var vi = moment.defineLocale('vi', {
        months: 'tháng 1_tháng 2_tháng 3_tháng 4_tháng 5_tháng 6_tháng 7_tháng 8_tháng 9_tháng 10_tháng 11_tháng 12'.split(
            '_'
        ),
        monthsShort:
            'Thg 01_Thg 02_Thg 03_Thg 04_Thg 05_Thg 06_Thg 07_Thg 08_Thg 09_Thg 10_Thg 11_Thg 12'.split(
                '_'
            ),
        monthsParseExact: true,
        weekdays: 'chủ nhật_thứ hai_thứ ba_thứ tư_thứ năm_thứ sáu_thứ bảy'.split(
            '_'
        ),
        weekdaysShort: 'CN_T2_T3_T4_T5_T6_T7'.split('_'),
        weekdaysMin: 'CN_T2_T3_T4_T5_T6_T7'.split('_'),
        weekdaysParseExact: true,
        meridiemParse: /sa|ch/i,
        isPM: function (input) {
            return /^ch$/i.test(input);
        },
        meridiem: function (hours, minutes, isLower) {
            if (hours < 12) {
                return isLower ? 'sa' : 'SA';
            } else {
                return isLower ? 'ch' : 'CH';
            }
        },
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM [năm] YYYY',
            LLL: 'D MMMM [năm] YYYY HH:mm',
            LLLL: 'dddd, D MMMM [năm] YYYY HH:mm',
            l: 'DD/M/YYYY',
            ll: 'D MMM YYYY',
            lll: 'D MMM YYYY HH:mm',
            llll: 'ddd, D MMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[Hôm nay lúc] LT',
            nextDay: '[Ngày mai lúc] LT',
            nextWeek: 'dddd [tuần tới lúc] LT',
            lastDay: '[Hôm qua lúc] LT',
            lastWeek: 'dddd [tuần trước lúc] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: '%s tới',
            past: '%s trước',
            s: 'vài giây',
            ss: '%d giây',
            m: 'một phút',
            mm: '%d phút',
            h: 'một giờ',
            hh: '%d giờ',
            d: 'một ngày',
            dd: '%d ngày',
            w: 'một tuần',
            ww: '%d tuần',
            M: 'một tháng',
            MM: '%d tháng',
            y: 'một năm',
            yy: '%d năm',
        },
        dayOfMonthOrdinalParse: /\d{1,2}/,
        ordinal: function (number) {
            return number;
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return vi;

})));


/***/ }),

/***/ 30381:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

/* module decorator */ module = __webpack_require__.nmd(module);
//! moment.js
//! version : 2.30.1
//! authors : Tim Wood, Iskren Chernev, Moment.js contributors
//! license : MIT
//! momentjs.com

;(function (global, factory) {
     true ? module.exports = factory() :
    0
}(this, (function () { 'use strict';

    var hookCallback;

    function hooks() {
        return hookCallback.apply(null, arguments);
    }

    // This is done to register the method called with moment()
    // without creating circular dependencies.
    function setHookCallback(callback) {
        hookCallback = callback;
    }

    function isArray(input) {
        return (
            input instanceof Array ||
            Object.prototype.toString.call(input) === '[object Array]'
        );
    }

    function isObject(input) {
        // IE8 will treat undefined and null as object if it wasn't for
        // input != null
        return (
            input != null &&
            Object.prototype.toString.call(input) === '[object Object]'
        );
    }

    function hasOwnProp(a, b) {
        return Object.prototype.hasOwnProperty.call(a, b);
    }

    function isObjectEmpty(obj) {
        if (Object.getOwnPropertyNames) {
            return Object.getOwnPropertyNames(obj).length === 0;
        } else {
            var k;
            for (k in obj) {
                if (hasOwnProp(obj, k)) {
                    return false;
                }
            }
            return true;
        }
    }

    function isUndefined(input) {
        return input === void 0;
    }

    function isNumber(input) {
        return (
            typeof input === 'number' ||
            Object.prototype.toString.call(input) === '[object Number]'
        );
    }

    function isDate(input) {
        return (
            input instanceof Date ||
            Object.prototype.toString.call(input) === '[object Date]'
        );
    }

    function map(arr, fn) {
        var res = [],
            i,
            arrLen = arr.length;
        for (i = 0; i < arrLen; ++i) {
            res.push(fn(arr[i], i));
        }
        return res;
    }

    function extend(a, b) {
        for (var i in b) {
            if (hasOwnProp(b, i)) {
                a[i] = b[i];
            }
        }

        if (hasOwnProp(b, 'toString')) {
            a.toString = b.toString;
        }

        if (hasOwnProp(b, 'valueOf')) {
            a.valueOf = b.valueOf;
        }

        return a;
    }

    function createUTC(input, format, locale, strict) {
        return createLocalOrUTC(input, format, locale, strict, true).utc();
    }

    function defaultParsingFlags() {
        // We need to deep clone this object.
        return {
            empty: false,
            unusedTokens: [],
            unusedInput: [],
            overflow: -2,
            charsLeftOver: 0,
            nullInput: false,
            invalidEra: null,
            invalidMonth: null,
            invalidFormat: false,
            userInvalidated: false,
            iso: false,
            parsedDateParts: [],
            era: null,
            meridiem: null,
            rfc2822: false,
            weekdayMismatch: false,
        };
    }

    function getParsingFlags(m) {
        if (m._pf == null) {
            m._pf = defaultParsingFlags();
        }
        return m._pf;
    }

    var some;
    if (Array.prototype.some) {
        some = Array.prototype.some;
    } else {
        some = function (fun) {
            var t = Object(this),
                len = t.length >>> 0,
                i;

            for (i = 0; i < len; i++) {
                if (i in t && fun.call(this, t[i], i, t)) {
                    return true;
                }
            }

            return false;
        };
    }

    function isValid(m) {
        var flags = null,
            parsedParts = false,
            isNowValid = m._d && !isNaN(m._d.getTime());
        if (isNowValid) {
            flags = getParsingFlags(m);
            parsedParts = some.call(flags.parsedDateParts, function (i) {
                return i != null;
            });
            isNowValid =
                flags.overflow < 0 &&
                !flags.empty &&
                !flags.invalidEra &&
                !flags.invalidMonth &&
                !flags.invalidWeekday &&
                !flags.weekdayMismatch &&
                !flags.nullInput &&
                !flags.invalidFormat &&
                !flags.userInvalidated &&
                (!flags.meridiem || (flags.meridiem && parsedParts));
            if (m._strict) {
                isNowValid =
                    isNowValid &&
                    flags.charsLeftOver === 0 &&
                    flags.unusedTokens.length === 0 &&
                    flags.bigHour === undefined;
            }
        }
        if (Object.isFrozen == null || !Object.isFrozen(m)) {
            m._isValid = isNowValid;
        } else {
            return isNowValid;
        }
        return m._isValid;
    }

    function createInvalid(flags) {
        var m = createUTC(NaN);
        if (flags != null) {
            extend(getParsingFlags(m), flags);
        } else {
            getParsingFlags(m).userInvalidated = true;
        }

        return m;
    }

    // Plugins that add properties should also add the key here (null value),
    // so we can properly clone ourselves.
    var momentProperties = (hooks.momentProperties = []),
        updateInProgress = false;

    function copyConfig(to, from) {
        var i,
            prop,
            val,
            momentPropertiesLen = momentProperties.length;

        if (!isUndefined(from._isAMomentObject)) {
            to._isAMomentObject = from._isAMomentObject;
        }
        if (!isUndefined(from._i)) {
            to._i = from._i;
        }
        if (!isUndefined(from._f)) {
            to._f = from._f;
        }
        if (!isUndefined(from._l)) {
            to._l = from._l;
        }
        if (!isUndefined(from._strict)) {
            to._strict = from._strict;
        }
        if (!isUndefined(from._tzm)) {
            to._tzm = from._tzm;
        }
        if (!isUndefined(from._isUTC)) {
            to._isUTC = from._isUTC;
        }
        if (!isUndefined(from._offset)) {
            to._offset = from._offset;
        }
        if (!isUndefined(from._pf)) {
            to._pf = getParsingFlags(from);
        }
        if (!isUndefined(from._locale)) {
            to._locale = from._locale;
        }

        if (momentPropertiesLen > 0) {
            for (i = 0; i < momentPropertiesLen; i++) {
                prop = momentProperties[i];
                val = from[prop];
                if (!isUndefined(val)) {
                    to[prop] = val;
                }
            }
        }

        return to;
    }

    // Moment prototype object
    function Moment(config) {
        copyConfig(this, config);
        this._d = new Date(config._d != null ? config._d.getTime() : NaN);
        if (!this.isValid()) {
            this._d = new Date(NaN);
        }
        // Prevent infinite loop in case updateOffset creates new moment
        // objects.
        if (updateInProgress === false) {
            updateInProgress = true;
            hooks.updateOffset(this);
            updateInProgress = false;
        }
    }

    function isMoment(obj) {
        return (
            obj instanceof Moment || (obj != null && obj._isAMomentObject != null)
        );
    }

    function warn(msg) {
        if (
            hooks.suppressDeprecationWarnings === false &&
            typeof console !== 'undefined' &&
            console.warn
        ) {
            console.warn('Deprecation warning: ' + msg);
        }
    }

    function deprecate(msg, fn) {
        var firstTime = true;

        return extend(function () {
            if (hooks.deprecationHandler != null) {
                hooks.deprecationHandler(null, msg);
            }
            if (firstTime) {
                var args = [],
                    arg,
                    i,
                    key,
                    argLen = arguments.length;
                for (i = 0; i < argLen; i++) {
                    arg = '';
                    if (typeof arguments[i] === 'object') {
                        arg += '\n[' + i + '] ';
                        for (key in arguments[0]) {
                            if (hasOwnProp(arguments[0], key)) {
                                arg += key + ': ' + arguments[0][key] + ', ';
                            }
                        }
                        arg = arg.slice(0, -2); // Remove trailing comma and space
                    } else {
                        arg = arguments[i];
                    }
                    args.push(arg);
                }
                warn(
                    msg +
                        '\nArguments: ' +
                        Array.prototype.slice.call(args).join('') +
                        '\n' +
                        new Error().stack
                );
                firstTime = false;
            }
            return fn.apply(this, arguments);
        }, fn);
    }

    var deprecations = {};

    function deprecateSimple(name, msg) {
        if (hooks.deprecationHandler != null) {
            hooks.deprecationHandler(name, msg);
        }
        if (!deprecations[name]) {
            warn(msg);
            deprecations[name] = true;
        }
    }

    hooks.suppressDeprecationWarnings = false;
    hooks.deprecationHandler = null;

    function isFunction(input) {
        return (
            (typeof Function !== 'undefined' && input instanceof Function) ||
            Object.prototype.toString.call(input) === '[object Function]'
        );
    }

    function set(config) {
        var prop, i;
        for (i in config) {
            if (hasOwnProp(config, i)) {
                prop = config[i];
                if (isFunction(prop)) {
                    this[i] = prop;
                } else {
                    this['_' + i] = prop;
                }
            }
        }
        this._config = config;
        // Lenient ordinal parsing accepts just a number in addition to
        // number + (possibly) stuff coming from _dayOfMonthOrdinalParse.
        // TODO: Remove "ordinalParse" fallback in next major release.
        this._dayOfMonthOrdinalParseLenient = new RegExp(
            (this._dayOfMonthOrdinalParse.source || this._ordinalParse.source) +
                '|' +
                /\d{1,2}/.source
        );
    }

    function mergeConfigs(parentConfig, childConfig) {
        var res = extend({}, parentConfig),
            prop;
        for (prop in childConfig) {
            if (hasOwnProp(childConfig, prop)) {
                if (isObject(parentConfig[prop]) && isObject(childConfig[prop])) {
                    res[prop] = {};
                    extend(res[prop], parentConfig[prop]);
                    extend(res[prop], childConfig[prop]);
                } else if (childConfig[prop] != null) {
                    res[prop] = childConfig[prop];
                } else {
                    delete res[prop];
                }
            }
        }
        for (prop in parentConfig) {
            if (
                hasOwnProp(parentConfig, prop) &&
                !hasOwnProp(childConfig, prop) &&
                isObject(parentConfig[prop])
            ) {
                // make sure changes to properties don't modify parent config
                res[prop] = extend({}, res[prop]);
            }
        }
        return res;
    }

    function Locale(config) {
        if (config != null) {
            this.set(config);
        }
    }

    var keys;

    if (Object.keys) {
        keys = Object.keys;
    } else {
        keys = function (obj) {
            var i,
                res = [];
            for (i in obj) {
                if (hasOwnProp(obj, i)) {
                    res.push(i);
                }
            }
            return res;
        };
    }

    var defaultCalendar = {
        sameDay: '[Today at] LT',
        nextDay: '[Tomorrow at] LT',
        nextWeek: 'dddd [at] LT',
        lastDay: '[Yesterday at] LT',
        lastWeek: '[Last] dddd [at] LT',
        sameElse: 'L',
    };

    function calendar(key, mom, now) {
        var output = this._calendar[key] || this._calendar['sameElse'];
        return isFunction(output) ? output.call(mom, now) : output;
    }

    function zeroFill(number, targetLength, forceSign) {
        var absNumber = '' + Math.abs(number),
            zerosToFill = targetLength - absNumber.length,
            sign = number >= 0;
        return (
            (sign ? (forceSign ? '+' : '') : '-') +
            Math.pow(10, Math.max(0, zerosToFill)).toString().substr(1) +
            absNumber
        );
    }

    var formattingTokens =
            /(\[[^\[]*\])|(\\)?([Hh]mm(ss)?|Mo|MM?M?M?|Do|DDDo|DD?D?D?|ddd?d?|do?|w[o|w]?|W[o|W]?|Qo?|N{1,5}|YYYYYY|YYYYY|YYYY|YY|y{2,4}|yo?|gg(ggg?)?|GG(GGG?)?|e|E|a|A|hh?|HH?|kk?|mm?|ss?|S{1,9}|x|X|zz?|ZZ?|.)/g,
        localFormattingTokens = /(\[[^\[]*\])|(\\)?(LTS|LT|LL?L?L?|l{1,4})/g,
        formatFunctions = {},
        formatTokenFunctions = {};

    // token:    'M'
    // padded:   ['MM', 2]
    // ordinal:  'Mo'
    // callback: function () { this.month() + 1 }
    function addFormatToken(token, padded, ordinal, callback) {
        var func = callback;
        if (typeof callback === 'string') {
            func = function () {
                return this[callback]();
            };
        }
        if (token) {
            formatTokenFunctions[token] = func;
        }
        if (padded) {
            formatTokenFunctions[padded[0]] = function () {
                return zeroFill(func.apply(this, arguments), padded[1], padded[2]);
            };
        }
        if (ordinal) {
            formatTokenFunctions[ordinal] = function () {
                return this.localeData().ordinal(
                    func.apply(this, arguments),
                    token
                );
            };
        }
    }

    function removeFormattingTokens(input) {
        if (input.match(/\[[\s\S]/)) {
            return input.replace(/^\[|\]$/g, '');
        }
        return input.replace(/\\/g, '');
    }

    function makeFormatFunction(format) {
        var array = format.match(formattingTokens),
            i,
            length;

        for (i = 0, length = array.length; i < length; i++) {
            if (formatTokenFunctions[array[i]]) {
                array[i] = formatTokenFunctions[array[i]];
            } else {
                array[i] = removeFormattingTokens(array[i]);
            }
        }

        return function (mom) {
            var output = '',
                i;
            for (i = 0; i < length; i++) {
                output += isFunction(array[i])
                    ? array[i].call(mom, format)
                    : array[i];
            }
            return output;
        };
    }

    // format date using native date object
    function formatMoment(m, format) {
        if (!m.isValid()) {
            return m.localeData().invalidDate();
        }

        format = expandFormat(format, m.localeData());
        formatFunctions[format] =
            formatFunctions[format] || makeFormatFunction(format);

        return formatFunctions[format](m);
    }

    function expandFormat(format, locale) {
        var i = 5;

        function replaceLongDateFormatTokens(input) {
            return locale.longDateFormat(input) || input;
        }

        localFormattingTokens.lastIndex = 0;
        while (i >= 0 && localFormattingTokens.test(format)) {
            format = format.replace(
                localFormattingTokens,
                replaceLongDateFormatTokens
            );
            localFormattingTokens.lastIndex = 0;
            i -= 1;
        }

        return format;
    }

    var defaultLongDateFormat = {
        LTS: 'h:mm:ss A',
        LT: 'h:mm A',
        L: 'MM/DD/YYYY',
        LL: 'MMMM D, YYYY',
        LLL: 'MMMM D, YYYY h:mm A',
        LLLL: 'dddd, MMMM D, YYYY h:mm A',
    };

    function longDateFormat(key) {
        var format = this._longDateFormat[key],
            formatUpper = this._longDateFormat[key.toUpperCase()];

        if (format || !formatUpper) {
            return format;
        }

        this._longDateFormat[key] = formatUpper
            .match(formattingTokens)
            .map(function (tok) {
                if (
                    tok === 'MMMM' ||
                    tok === 'MM' ||
                    tok === 'DD' ||
                    tok === 'dddd'
                ) {
                    return tok.slice(1);
                }
                return tok;
            })
            .join('');

        return this._longDateFormat[key];
    }

    var defaultInvalidDate = 'Invalid date';

    function invalidDate() {
        return this._invalidDate;
    }

    var defaultOrdinal = '%d',
        defaultDayOfMonthOrdinalParse = /\d{1,2}/;

    function ordinal(number) {
        return this._ordinal.replace('%d', number);
    }

    var defaultRelativeTime = {
        future: 'in %s',
        past: '%s ago',
        s: 'a few seconds',
        ss: '%d seconds',
        m: 'a minute',
        mm: '%d minutes',
        h: 'an hour',
        hh: '%d hours',
        d: 'a day',
        dd: '%d days',
        w: 'a week',
        ww: '%d weeks',
        M: 'a month',
        MM: '%d months',
        y: 'a year',
        yy: '%d years',
    };

    function relativeTime(number, withoutSuffix, string, isFuture) {
        var output = this._relativeTime[string];
        return isFunction(output)
            ? output(number, withoutSuffix, string, isFuture)
            : output.replace(/%d/i, number);
    }

    function pastFuture(diff, output) {
        var format = this._relativeTime[diff > 0 ? 'future' : 'past'];
        return isFunction(format) ? format(output) : format.replace(/%s/i, output);
    }

    var aliases = {
        D: 'date',
        dates: 'date',
        date: 'date',
        d: 'day',
        days: 'day',
        day: 'day',
        e: 'weekday',
        weekdays: 'weekday',
        weekday: 'weekday',
        E: 'isoWeekday',
        isoweekdays: 'isoWeekday',
        isoweekday: 'isoWeekday',
        DDD: 'dayOfYear',
        dayofyears: 'dayOfYear',
        dayofyear: 'dayOfYear',
        h: 'hour',
        hours: 'hour',
        hour: 'hour',
        ms: 'millisecond',
        milliseconds: 'millisecond',
        millisecond: 'millisecond',
        m: 'minute',
        minutes: 'minute',
        minute: 'minute',
        M: 'month',
        months: 'month',
        month: 'month',
        Q: 'quarter',
        quarters: 'quarter',
        quarter: 'quarter',
        s: 'second',
        seconds: 'second',
        second: 'second',
        gg: 'weekYear',
        weekyears: 'weekYear',
        weekyear: 'weekYear',
        GG: 'isoWeekYear',
        isoweekyears: 'isoWeekYear',
        isoweekyear: 'isoWeekYear',
        w: 'week',
        weeks: 'week',
        week: 'week',
        W: 'isoWeek',
        isoweeks: 'isoWeek',
        isoweek: 'isoWeek',
        y: 'year',
        years: 'year',
        year: 'year',
    };

    function normalizeUnits(units) {
        return typeof units === 'string'
            ? aliases[units] || aliases[units.toLowerCase()]
            : undefined;
    }

    function normalizeObjectUnits(inputObject) {
        var normalizedInput = {},
            normalizedProp,
            prop;

        for (prop in inputObject) {
            if (hasOwnProp(inputObject, prop)) {
                normalizedProp = normalizeUnits(prop);
                if (normalizedProp) {
                    normalizedInput[normalizedProp] = inputObject[prop];
                }
            }
        }

        return normalizedInput;
    }

    var priorities = {
        date: 9,
        day: 11,
        weekday: 11,
        isoWeekday: 11,
        dayOfYear: 4,
        hour: 13,
        millisecond: 16,
        minute: 14,
        month: 8,
        quarter: 7,
        second: 15,
        weekYear: 1,
        isoWeekYear: 1,
        week: 5,
        isoWeek: 5,
        year: 1,
    };

    function getPrioritizedUnits(unitsObj) {
        var units = [],
            u;
        for (u in unitsObj) {
            if (hasOwnProp(unitsObj, u)) {
                units.push({ unit: u, priority: priorities[u] });
            }
        }
        units.sort(function (a, b) {
            return a.priority - b.priority;
        });
        return units;
    }

    var match1 = /\d/, //       0 - 9
        match2 = /\d\d/, //      00 - 99
        match3 = /\d{3}/, //     000 - 999
        match4 = /\d{4}/, //    0000 - 9999
        match6 = /[+-]?\d{6}/, // -999999 - 999999
        match1to2 = /\d\d?/, //       0 - 99
        match3to4 = /\d\d\d\d?/, //     999 - 9999
        match5to6 = /\d\d\d\d\d\d?/, //   99999 - 999999
        match1to3 = /\d{1,3}/, //       0 - 999
        match1to4 = /\d{1,4}/, //       0 - 9999
        match1to6 = /[+-]?\d{1,6}/, // -999999 - 999999
        matchUnsigned = /\d+/, //       0 - inf
        matchSigned = /[+-]?\d+/, //    -inf - inf
        matchOffset = /Z|[+-]\d\d:?\d\d/gi, // +00:00 -00:00 +0000 -0000 or Z
        matchShortOffset = /Z|[+-]\d\d(?::?\d\d)?/gi, // +00 -00 +00:00 -00:00 +0000 -0000 or Z
        matchTimestamp = /[+-]?\d+(\.\d{1,3})?/, // 123456789 123456789.123
        // any word (or two) characters or numbers including two/three word month in arabic.
        // includes scottish gaelic two word and hyphenated months
        matchWord =
            /[0-9]{0,256}['a-z\u00A0-\u05FF\u0700-\uD7FF\uF900-\uFDCF\uFDF0-\uFF07\uFF10-\uFFEF]{1,256}|[\u0600-\u06FF\/]{1,256}(\s*?[\u0600-\u06FF]{1,256}){1,2}/i,
        match1to2NoLeadingZero = /^[1-9]\d?/, //         1-99
        match1to2HasZero = /^([1-9]\d|\d)/, //           0-99
        regexes;

    regexes = {};

    function addRegexToken(token, regex, strictRegex) {
        regexes[token] = isFunction(regex)
            ? regex
            : function (isStrict, localeData) {
                  return isStrict && strictRegex ? strictRegex : regex;
              };
    }

    function getParseRegexForToken(token, config) {
        if (!hasOwnProp(regexes, token)) {
            return new RegExp(unescapeFormat(token));
        }

        return regexes[token](config._strict, config._locale);
    }

    // Code from http://stackoverflow.com/questions/3561493/is-there-a-regexp-escape-function-in-javascript
    function unescapeFormat(s) {
        return regexEscape(
            s
                .replace('\\', '')
                .replace(
                    /\\(\[)|\\(\])|\[([^\]\[]*)\]|\\(.)/g,
                    function (matched, p1, p2, p3, p4) {
                        return p1 || p2 || p3 || p4;
                    }
                )
        );
    }

    function regexEscape(s) {
        return s.replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&');
    }

    function absFloor(number) {
        if (number < 0) {
            // -0 -> 0
            return Math.ceil(number) || 0;
        } else {
            return Math.floor(number);
        }
    }

    function toInt(argumentForCoercion) {
        var coercedNumber = +argumentForCoercion,
            value = 0;

        if (coercedNumber !== 0 && isFinite(coercedNumber)) {
            value = absFloor(coercedNumber);
        }

        return value;
    }

    var tokens = {};

    function addParseToken(token, callback) {
        var i,
            func = callback,
            tokenLen;
        if (typeof token === 'string') {
            token = [token];
        }
        if (isNumber(callback)) {
            func = function (input, array) {
                array[callback] = toInt(input);
            };
        }
        tokenLen = token.length;
        for (i = 0; i < tokenLen; i++) {
            tokens[token[i]] = func;
        }
    }

    function addWeekParseToken(token, callback) {
        addParseToken(token, function (input, array, config, token) {
            config._w = config._w || {};
            callback(input, config._w, config, token);
        });
    }

    function addTimeToArrayFromToken(token, input, config) {
        if (input != null && hasOwnProp(tokens, token)) {
            tokens[token](input, config._a, config, token);
        }
    }

    function isLeapYear(year) {
        return (year % 4 === 0 && year % 100 !== 0) || year % 400 === 0;
    }

    var YEAR = 0,
        MONTH = 1,
        DATE = 2,
        HOUR = 3,
        MINUTE = 4,
        SECOND = 5,
        MILLISECOND = 6,
        WEEK = 7,
        WEEKDAY = 8;

    // FORMATTING

    addFormatToken('Y', 0, 0, function () {
        var y = this.year();
        return y <= 9999 ? zeroFill(y, 4) : '+' + y;
    });

    addFormatToken(0, ['YY', 2], 0, function () {
        return this.year() % 100;
    });

    addFormatToken(0, ['YYYY', 4], 0, 'year');
    addFormatToken(0, ['YYYYY', 5], 0, 'year');
    addFormatToken(0, ['YYYYYY', 6, true], 0, 'year');

    // PARSING

    addRegexToken('Y', matchSigned);
    addRegexToken('YY', match1to2, match2);
    addRegexToken('YYYY', match1to4, match4);
    addRegexToken('YYYYY', match1to6, match6);
    addRegexToken('YYYYYY', match1to6, match6);

    addParseToken(['YYYYY', 'YYYYYY'], YEAR);
    addParseToken('YYYY', function (input, array) {
        array[YEAR] =
            input.length === 2 ? hooks.parseTwoDigitYear(input) : toInt(input);
    });
    addParseToken('YY', function (input, array) {
        array[YEAR] = hooks.parseTwoDigitYear(input);
    });
    addParseToken('Y', function (input, array) {
        array[YEAR] = parseInt(input, 10);
    });

    // HELPERS

    function daysInYear(year) {
        return isLeapYear(year) ? 366 : 365;
    }

    // HOOKS

    hooks.parseTwoDigitYear = function (input) {
        return toInt(input) + (toInt(input) > 68 ? 1900 : 2000);
    };

    // MOMENTS

    var getSetYear = makeGetSet('FullYear', true);

    function getIsLeapYear() {
        return isLeapYear(this.year());
    }

    function makeGetSet(unit, keepTime) {
        return function (value) {
            if (value != null) {
                set$1(this, unit, value);
                hooks.updateOffset(this, keepTime);
                return this;
            } else {
                return get(this, unit);
            }
        };
    }

    function get(mom, unit) {
        if (!mom.isValid()) {
            return NaN;
        }

        var d = mom._d,
            isUTC = mom._isUTC;

        switch (unit) {
            case 'Milliseconds':
                return isUTC ? d.getUTCMilliseconds() : d.getMilliseconds();
            case 'Seconds':
                return isUTC ? d.getUTCSeconds() : d.getSeconds();
            case 'Minutes':
                return isUTC ? d.getUTCMinutes() : d.getMinutes();
            case 'Hours':
                return isUTC ? d.getUTCHours() : d.getHours();
            case 'Date':
                return isUTC ? d.getUTCDate() : d.getDate();
            case 'Day':
                return isUTC ? d.getUTCDay() : d.getDay();
            case 'Month':
                return isUTC ? d.getUTCMonth() : d.getMonth();
            case 'FullYear':
                return isUTC ? d.getUTCFullYear() : d.getFullYear();
            default:
                return NaN; // Just in case
        }
    }

    function set$1(mom, unit, value) {
        var d, isUTC, year, month, date;

        if (!mom.isValid() || isNaN(value)) {
            return;
        }

        d = mom._d;
        isUTC = mom._isUTC;

        switch (unit) {
            case 'Milliseconds':
                return void (isUTC
                    ? d.setUTCMilliseconds(value)
                    : d.setMilliseconds(value));
            case 'Seconds':
                return void (isUTC ? d.setUTCSeconds(value) : d.setSeconds(value));
            case 'Minutes':
                return void (isUTC ? d.setUTCMinutes(value) : d.setMinutes(value));
            case 'Hours':
                return void (isUTC ? d.setUTCHours(value) : d.setHours(value));
            case 'Date':
                return void (isUTC ? d.setUTCDate(value) : d.setDate(value));
            // case 'Day': // Not real
            //    return void (isUTC ? d.setUTCDay(value) : d.setDay(value));
            // case 'Month': // Not used because we need to pass two variables
            //     return void (isUTC ? d.setUTCMonth(value) : d.setMonth(value));
            case 'FullYear':
                break; // See below ...
            default:
                return; // Just in case
        }

        year = value;
        month = mom.month();
        date = mom.date();
        date = date === 29 && month === 1 && !isLeapYear(year) ? 28 : date;
        void (isUTC
            ? d.setUTCFullYear(year, month, date)
            : d.setFullYear(year, month, date));
    }

    // MOMENTS

    function stringGet(units) {
        units = normalizeUnits(units);
        if (isFunction(this[units])) {
            return this[units]();
        }
        return this;
    }

    function stringSet(units, value) {
        if (typeof units === 'object') {
            units = normalizeObjectUnits(units);
            var prioritized = getPrioritizedUnits(units),
                i,
                prioritizedLen = prioritized.length;
            for (i = 0; i < prioritizedLen; i++) {
                this[prioritized[i].unit](units[prioritized[i].unit]);
            }
        } else {
            units = normalizeUnits(units);
            if (isFunction(this[units])) {
                return this[units](value);
            }
        }
        return this;
    }

    function mod(n, x) {
        return ((n % x) + x) % x;
    }

    var indexOf;

    if (Array.prototype.indexOf) {
        indexOf = Array.prototype.indexOf;
    } else {
        indexOf = function (o) {
            // I know
            var i;
            for (i = 0; i < this.length; ++i) {
                if (this[i] === o) {
                    return i;
                }
            }
            return -1;
        };
    }

    function daysInMonth(year, month) {
        if (isNaN(year) || isNaN(month)) {
            return NaN;
        }
        var modMonth = mod(month, 12);
        year += (month - modMonth) / 12;
        return modMonth === 1
            ? isLeapYear(year)
                ? 29
                : 28
            : 31 - ((modMonth % 7) % 2);
    }

    // FORMATTING

    addFormatToken('M', ['MM', 2], 'Mo', function () {
        return this.month() + 1;
    });

    addFormatToken('MMM', 0, 0, function (format) {
        return this.localeData().monthsShort(this, format);
    });

    addFormatToken('MMMM', 0, 0, function (format) {
        return this.localeData().months(this, format);
    });

    // PARSING

    addRegexToken('M', match1to2, match1to2NoLeadingZero);
    addRegexToken('MM', match1to2, match2);
    addRegexToken('MMM', function (isStrict, locale) {
        return locale.monthsShortRegex(isStrict);
    });
    addRegexToken('MMMM', function (isStrict, locale) {
        return locale.monthsRegex(isStrict);
    });

    addParseToken(['M', 'MM'], function (input, array) {
        array[MONTH] = toInt(input) - 1;
    });

    addParseToken(['MMM', 'MMMM'], function (input, array, config, token) {
        var month = config._locale.monthsParse(input, token, config._strict);
        // if we didn't find a month name, mark the date as invalid.
        if (month != null) {
            array[MONTH] = month;
        } else {
            getParsingFlags(config).invalidMonth = input;
        }
    });

    // LOCALES

    var defaultLocaleMonths =
            'January_February_March_April_May_June_July_August_September_October_November_December'.split(
                '_'
            ),
        defaultLocaleMonthsShort =
            'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
        MONTHS_IN_FORMAT = /D[oD]?(\[[^\[\]]*\]|\s)+MMMM?/,
        defaultMonthsShortRegex = matchWord,
        defaultMonthsRegex = matchWord;

    function localeMonths(m, format) {
        if (!m) {
            return isArray(this._months)
                ? this._months
                : this._months['standalone'];
        }
        return isArray(this._months)
            ? this._months[m.month()]
            : this._months[
                  (this._months.isFormat || MONTHS_IN_FORMAT).test(format)
                      ? 'format'
                      : 'standalone'
              ][m.month()];
    }

    function localeMonthsShort(m, format) {
        if (!m) {
            return isArray(this._monthsShort)
                ? this._monthsShort
                : this._monthsShort['standalone'];
        }
        return isArray(this._monthsShort)
            ? this._monthsShort[m.month()]
            : this._monthsShort[
                  MONTHS_IN_FORMAT.test(format) ? 'format' : 'standalone'
              ][m.month()];
    }

    function handleStrictParse(monthName, format, strict) {
        var i,
            ii,
            mom,
            llc = monthName.toLocaleLowerCase();
        if (!this._monthsParse) {
            // this is not used
            this._monthsParse = [];
            this._longMonthsParse = [];
            this._shortMonthsParse = [];
            for (i = 0; i < 12; ++i) {
                mom = createUTC([2000, i]);
                this._shortMonthsParse[i] = this.monthsShort(
                    mom,
                    ''
                ).toLocaleLowerCase();
                this._longMonthsParse[i] = this.months(mom, '').toLocaleLowerCase();
            }
        }

        if (strict) {
            if (format === 'MMM') {
                ii = indexOf.call(this._shortMonthsParse, llc);
                return ii !== -1 ? ii : null;
            } else {
                ii = indexOf.call(this._longMonthsParse, llc);
                return ii !== -1 ? ii : null;
            }
        } else {
            if (format === 'MMM') {
                ii = indexOf.call(this._shortMonthsParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._longMonthsParse, llc);
                return ii !== -1 ? ii : null;
            } else {
                ii = indexOf.call(this._longMonthsParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._shortMonthsParse, llc);
                return ii !== -1 ? ii : null;
            }
        }
    }

    function localeMonthsParse(monthName, format, strict) {
        var i, mom, regex;

        if (this._monthsParseExact) {
            return handleStrictParse.call(this, monthName, format, strict);
        }

        if (!this._monthsParse) {
            this._monthsParse = [];
            this._longMonthsParse = [];
            this._shortMonthsParse = [];
        }

        // TODO: add sorting
        // Sorting makes sure if one month (or abbr) is a prefix of another
        // see sorting in computeMonthsParse
        for (i = 0; i < 12; i++) {
            // make the regex if we don't have it already
            mom = createUTC([2000, i]);
            if (strict && !this._longMonthsParse[i]) {
                this._longMonthsParse[i] = new RegExp(
                    '^' + this.months(mom, '').replace('.', '') + '$',
                    'i'
                );
                this._shortMonthsParse[i] = new RegExp(
                    '^' + this.monthsShort(mom, '').replace('.', '') + '$',
                    'i'
                );
            }
            if (!strict && !this._monthsParse[i]) {
                regex =
                    '^' + this.months(mom, '') + '|^' + this.monthsShort(mom, '');
                this._monthsParse[i] = new RegExp(regex.replace('.', ''), 'i');
            }
            // test the regex
            if (
                strict &&
                format === 'MMMM' &&
                this._longMonthsParse[i].test(monthName)
            ) {
                return i;
            } else if (
                strict &&
                format === 'MMM' &&
                this._shortMonthsParse[i].test(monthName)
            ) {
                return i;
            } else if (!strict && this._monthsParse[i].test(monthName)) {
                return i;
            }
        }
    }

    // MOMENTS

    function setMonth(mom, value) {
        if (!mom.isValid()) {
            // No op
            return mom;
        }

        if (typeof value === 'string') {
            if (/^\d+$/.test(value)) {
                value = toInt(value);
            } else {
                value = mom.localeData().monthsParse(value);
                // TODO: Another silent failure?
                if (!isNumber(value)) {
                    return mom;
                }
            }
        }

        var month = value,
            date = mom.date();

        date = date < 29 ? date : Math.min(date, daysInMonth(mom.year(), month));
        void (mom._isUTC
            ? mom._d.setUTCMonth(month, date)
            : mom._d.setMonth(month, date));
        return mom;
    }

    function getSetMonth(value) {
        if (value != null) {
            setMonth(this, value);
            hooks.updateOffset(this, true);
            return this;
        } else {
            return get(this, 'Month');
        }
    }

    function getDaysInMonth() {
        return daysInMonth(this.year(), this.month());
    }

    function monthsShortRegex(isStrict) {
        if (this._monthsParseExact) {
            if (!hasOwnProp(this, '_monthsRegex')) {
                computeMonthsParse.call(this);
            }
            if (isStrict) {
                return this._monthsShortStrictRegex;
            } else {
                return this._monthsShortRegex;
            }
        } else {
            if (!hasOwnProp(this, '_monthsShortRegex')) {
                this._monthsShortRegex = defaultMonthsShortRegex;
            }
            return this._monthsShortStrictRegex && isStrict
                ? this._monthsShortStrictRegex
                : this._monthsShortRegex;
        }
    }

    function monthsRegex(isStrict) {
        if (this._monthsParseExact) {
            if (!hasOwnProp(this, '_monthsRegex')) {
                computeMonthsParse.call(this);
            }
            if (isStrict) {
                return this._monthsStrictRegex;
            } else {
                return this._monthsRegex;
            }
        } else {
            if (!hasOwnProp(this, '_monthsRegex')) {
                this._monthsRegex = defaultMonthsRegex;
            }
            return this._monthsStrictRegex && isStrict
                ? this._monthsStrictRegex
                : this._monthsRegex;
        }
    }

    function computeMonthsParse() {
        function cmpLenRev(a, b) {
            return b.length - a.length;
        }

        var shortPieces = [],
            longPieces = [],
            mixedPieces = [],
            i,
            mom,
            shortP,
            longP;
        for (i = 0; i < 12; i++) {
            // make the regex if we don't have it already
            mom = createUTC([2000, i]);
            shortP = regexEscape(this.monthsShort(mom, ''));
            longP = regexEscape(this.months(mom, ''));
            shortPieces.push(shortP);
            longPieces.push(longP);
            mixedPieces.push(longP);
            mixedPieces.push(shortP);
        }
        // Sorting makes sure if one month (or abbr) is a prefix of another it
        // will match the longer piece.
        shortPieces.sort(cmpLenRev);
        longPieces.sort(cmpLenRev);
        mixedPieces.sort(cmpLenRev);

        this._monthsRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
        this._monthsShortRegex = this._monthsRegex;
        this._monthsStrictRegex = new RegExp(
            '^(' + longPieces.join('|') + ')',
            'i'
        );
        this._monthsShortStrictRegex = new RegExp(
            '^(' + shortPieces.join('|') + ')',
            'i'
        );
    }

    function createDate(y, m, d, h, M, s, ms) {
        // can't just apply() to create a date:
        // https://stackoverflow.com/q/181348
        var date;
        // the date constructor remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0) {
            // preserve leap years using a full 400 year cycle, then reset
            date = new Date(y + 400, m, d, h, M, s, ms);
            if (isFinite(date.getFullYear())) {
                date.setFullYear(y);
            }
        } else {
            date = new Date(y, m, d, h, M, s, ms);
        }

        return date;
    }

    function createUTCDate(y) {
        var date, args;
        // the Date.UTC function remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0) {
            args = Array.prototype.slice.call(arguments);
            // preserve leap years using a full 400 year cycle, then reset
            args[0] = y + 400;
            date = new Date(Date.UTC.apply(null, args));
            if (isFinite(date.getUTCFullYear())) {
                date.setUTCFullYear(y);
            }
        } else {
            date = new Date(Date.UTC.apply(null, arguments));
        }

        return date;
    }

    // start-of-first-week - start-of-year
    function firstWeekOffset(year, dow, doy) {
        var // first-week day -- which january is always in the first week (4 for iso, 1 for other)
            fwd = 7 + dow - doy,
            // first-week day local weekday -- which local weekday is fwd
            fwdlw = (7 + createUTCDate(year, 0, fwd).getUTCDay() - dow) % 7;

        return -fwdlw + fwd - 1;
    }

    // https://en.wikipedia.org/wiki/ISO_week_date#Calculating_a_date_given_the_year.2C_week_number_and_weekday
    function dayOfYearFromWeeks(year, week, weekday, dow, doy) {
        var localWeekday = (7 + weekday - dow) % 7,
            weekOffset = firstWeekOffset(year, dow, doy),
            dayOfYear = 1 + 7 * (week - 1) + localWeekday + weekOffset,
            resYear,
            resDayOfYear;

        if (dayOfYear <= 0) {
            resYear = year - 1;
            resDayOfYear = daysInYear(resYear) + dayOfYear;
        } else if (dayOfYear > daysInYear(year)) {
            resYear = year + 1;
            resDayOfYear = dayOfYear - daysInYear(year);
        } else {
            resYear = year;
            resDayOfYear = dayOfYear;
        }

        return {
            year: resYear,
            dayOfYear: resDayOfYear,
        };
    }

    function weekOfYear(mom, dow, doy) {
        var weekOffset = firstWeekOffset(mom.year(), dow, doy),
            week = Math.floor((mom.dayOfYear() - weekOffset - 1) / 7) + 1,
            resWeek,
            resYear;

        if (week < 1) {
            resYear = mom.year() - 1;
            resWeek = week + weeksInYear(resYear, dow, doy);
        } else if (week > weeksInYear(mom.year(), dow, doy)) {
            resWeek = week - weeksInYear(mom.year(), dow, doy);
            resYear = mom.year() + 1;
        } else {
            resYear = mom.year();
            resWeek = week;
        }

        return {
            week: resWeek,
            year: resYear,
        };
    }

    function weeksInYear(year, dow, doy) {
        var weekOffset = firstWeekOffset(year, dow, doy),
            weekOffsetNext = firstWeekOffset(year + 1, dow, doy);
        return (daysInYear(year) - weekOffset + weekOffsetNext) / 7;
    }

    // FORMATTING

    addFormatToken('w', ['ww', 2], 'wo', 'week');
    addFormatToken('W', ['WW', 2], 'Wo', 'isoWeek');

    // PARSING

    addRegexToken('w', match1to2, match1to2NoLeadingZero);
    addRegexToken('ww', match1to2, match2);
    addRegexToken('W', match1to2, match1to2NoLeadingZero);
    addRegexToken('WW', match1to2, match2);

    addWeekParseToken(
        ['w', 'ww', 'W', 'WW'],
        function (input, week, config, token) {
            week[token.substr(0, 1)] = toInt(input);
        }
    );

    // HELPERS

    // LOCALES

    function localeWeek(mom) {
        return weekOfYear(mom, this._week.dow, this._week.doy).week;
    }

    var defaultLocaleWeek = {
        dow: 0, // Sunday is the first day of the week.
        doy: 6, // The week that contains Jan 6th is the first week of the year.
    };

    function localeFirstDayOfWeek() {
        return this._week.dow;
    }

    function localeFirstDayOfYear() {
        return this._week.doy;
    }

    // MOMENTS

    function getSetWeek(input) {
        var week = this.localeData().week(this);
        return input == null ? week : this.add((input - week) * 7, 'd');
    }

    function getSetISOWeek(input) {
        var week = weekOfYear(this, 1, 4).week;
        return input == null ? week : this.add((input - week) * 7, 'd');
    }

    // FORMATTING

    addFormatToken('d', 0, 'do', 'day');

    addFormatToken('dd', 0, 0, function (format) {
        return this.localeData().weekdaysMin(this, format);
    });

    addFormatToken('ddd', 0, 0, function (format) {
        return this.localeData().weekdaysShort(this, format);
    });

    addFormatToken('dddd', 0, 0, function (format) {
        return this.localeData().weekdays(this, format);
    });

    addFormatToken('e', 0, 0, 'weekday');
    addFormatToken('E', 0, 0, 'isoWeekday');

    // PARSING

    addRegexToken('d', match1to2);
    addRegexToken('e', match1to2);
    addRegexToken('E', match1to2);
    addRegexToken('dd', function (isStrict, locale) {
        return locale.weekdaysMinRegex(isStrict);
    });
    addRegexToken('ddd', function (isStrict, locale) {
        return locale.weekdaysShortRegex(isStrict);
    });
    addRegexToken('dddd', function (isStrict, locale) {
        return locale.weekdaysRegex(isStrict);
    });

    addWeekParseToken(['dd', 'ddd', 'dddd'], function (input, week, config, token) {
        var weekday = config._locale.weekdaysParse(input, token, config._strict);
        // if we didn't get a weekday name, mark the date as invalid
        if (weekday != null) {
            week.d = weekday;
        } else {
            getParsingFlags(config).invalidWeekday = input;
        }
    });

    addWeekParseToken(['d', 'e', 'E'], function (input, week, config, token) {
        week[token] = toInt(input);
    });

    // HELPERS

    function parseWeekday(input, locale) {
        if (typeof input !== 'string') {
            return input;
        }

        if (!isNaN(input)) {
            return parseInt(input, 10);
        }

        input = locale.weekdaysParse(input);
        if (typeof input === 'number') {
            return input;
        }

        return null;
    }

    function parseIsoWeekday(input, locale) {
        if (typeof input === 'string') {
            return locale.weekdaysParse(input) % 7 || 7;
        }
        return isNaN(input) ? null : input;
    }

    // LOCALES
    function shiftWeekdays(ws, n) {
        return ws.slice(n, 7).concat(ws.slice(0, n));
    }

    var defaultLocaleWeekdays =
            'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_'),
        defaultLocaleWeekdaysShort = 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
        defaultLocaleWeekdaysMin = 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
        defaultWeekdaysRegex = matchWord,
        defaultWeekdaysShortRegex = matchWord,
        defaultWeekdaysMinRegex = matchWord;

    function localeWeekdays(m, format) {
        var weekdays = isArray(this._weekdays)
            ? this._weekdays
            : this._weekdays[
                  m && m !== true && this._weekdays.isFormat.test(format)
                      ? 'format'
                      : 'standalone'
              ];
        return m === true
            ? shiftWeekdays(weekdays, this._week.dow)
            : m
              ? weekdays[m.day()]
              : weekdays;
    }

    function localeWeekdaysShort(m) {
        return m === true
            ? shiftWeekdays(this._weekdaysShort, this._week.dow)
            : m
              ? this._weekdaysShort[m.day()]
              : this._weekdaysShort;
    }

    function localeWeekdaysMin(m) {
        return m === true
            ? shiftWeekdays(this._weekdaysMin, this._week.dow)
            : m
              ? this._weekdaysMin[m.day()]
              : this._weekdaysMin;
    }

    function handleStrictParse$1(weekdayName, format, strict) {
        var i,
            ii,
            mom,
            llc = weekdayName.toLocaleLowerCase();
        if (!this._weekdaysParse) {
            this._weekdaysParse = [];
            this._shortWeekdaysParse = [];
            this._minWeekdaysParse = [];

            for (i = 0; i < 7; ++i) {
                mom = createUTC([2000, 1]).day(i);
                this._minWeekdaysParse[i] = this.weekdaysMin(
                    mom,
                    ''
                ).toLocaleLowerCase();
                this._shortWeekdaysParse[i] = this.weekdaysShort(
                    mom,
                    ''
                ).toLocaleLowerCase();
                this._weekdaysParse[i] = this.weekdays(mom, '').toLocaleLowerCase();
            }
        }

        if (strict) {
            if (format === 'dddd') {
                ii = indexOf.call(this._weekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else if (format === 'ddd') {
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else {
                ii = indexOf.call(this._minWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            }
        } else {
            if (format === 'dddd') {
                ii = indexOf.call(this._weekdaysParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._minWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else if (format === 'ddd') {
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._weekdaysParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._minWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else {
                ii = indexOf.call(this._minWeekdaysParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._weekdaysParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            }
        }
    }

    function localeWeekdaysParse(weekdayName, format, strict) {
        var i, mom, regex;

        if (this._weekdaysParseExact) {
            return handleStrictParse$1.call(this, weekdayName, format, strict);
        }

        if (!this._weekdaysParse) {
            this._weekdaysParse = [];
            this._minWeekdaysParse = [];
            this._shortWeekdaysParse = [];
            this._fullWeekdaysParse = [];
        }

        for (i = 0; i < 7; i++) {
            // make the regex if we don't have it already

            mom = createUTC([2000, 1]).day(i);
            if (strict && !this._fullWeekdaysParse[i]) {
                this._fullWeekdaysParse[i] = new RegExp(
                    '^' + this.weekdays(mom, '').replace('.', '\\.?') + '$',
                    'i'
                );
                this._shortWeekdaysParse[i] = new RegExp(
                    '^' + this.weekdaysShort(mom, '').replace('.', '\\.?') + '$',
                    'i'
                );
                this._minWeekdaysParse[i] = new RegExp(
                    '^' + this.weekdaysMin(mom, '').replace('.', '\\.?') + '$',
                    'i'
                );
            }
            if (!this._weekdaysParse[i]) {
                regex =
                    '^' +
                    this.weekdays(mom, '') +
                    '|^' +
                    this.weekdaysShort(mom, '') +
                    '|^' +
                    this.weekdaysMin(mom, '');
                this._weekdaysParse[i] = new RegExp(regex.replace('.', ''), 'i');
            }
            // test the regex
            if (
                strict &&
                format === 'dddd' &&
                this._fullWeekdaysParse[i].test(weekdayName)
            ) {
                return i;
            } else if (
                strict &&
                format === 'ddd' &&
                this._shortWeekdaysParse[i].test(weekdayName)
            ) {
                return i;
            } else if (
                strict &&
                format === 'dd' &&
                this._minWeekdaysParse[i].test(weekdayName)
            ) {
                return i;
            } else if (!strict && this._weekdaysParse[i].test(weekdayName)) {
                return i;
            }
        }
    }

    // MOMENTS

    function getSetDayOfWeek(input) {
        if (!this.isValid()) {
            return input != null ? this : NaN;
        }

        var day = get(this, 'Day');
        if (input != null) {
            input = parseWeekday(input, this.localeData());
            return this.add(input - day, 'd');
        } else {
            return day;
        }
    }

    function getSetLocaleDayOfWeek(input) {
        if (!this.isValid()) {
            return input != null ? this : NaN;
        }
        var weekday = (this.day() + 7 - this.localeData()._week.dow) % 7;
        return input == null ? weekday : this.add(input - weekday, 'd');
    }

    function getSetISODayOfWeek(input) {
        if (!this.isValid()) {
            return input != null ? this : NaN;
        }

        // behaves the same as moment#day except
        // as a getter, returns 7 instead of 0 (1-7 range instead of 0-6)
        // as a setter, sunday should belong to the previous week.

        if (input != null) {
            var weekday = parseIsoWeekday(input, this.localeData());
            return this.day(this.day() % 7 ? weekday : weekday - 7);
        } else {
            return this.day() || 7;
        }
    }

    function weekdaysRegex(isStrict) {
        if (this._weekdaysParseExact) {
            if (!hasOwnProp(this, '_weekdaysRegex')) {
                computeWeekdaysParse.call(this);
            }
            if (isStrict) {
                return this._weekdaysStrictRegex;
            } else {
                return this._weekdaysRegex;
            }
        } else {
            if (!hasOwnProp(this, '_weekdaysRegex')) {
                this._weekdaysRegex = defaultWeekdaysRegex;
            }
            return this._weekdaysStrictRegex && isStrict
                ? this._weekdaysStrictRegex
                : this._weekdaysRegex;
        }
    }

    function weekdaysShortRegex(isStrict) {
        if (this._weekdaysParseExact) {
            if (!hasOwnProp(this, '_weekdaysRegex')) {
                computeWeekdaysParse.call(this);
            }
            if (isStrict) {
                return this._weekdaysShortStrictRegex;
            } else {
                return this._weekdaysShortRegex;
            }
        } else {
            if (!hasOwnProp(this, '_weekdaysShortRegex')) {
                this._weekdaysShortRegex = defaultWeekdaysShortRegex;
            }
            return this._weekdaysShortStrictRegex && isStrict
                ? this._weekdaysShortStrictRegex
                : this._weekdaysShortRegex;
        }
    }

    function weekdaysMinRegex(isStrict) {
        if (this._weekdaysParseExact) {
            if (!hasOwnProp(this, '_weekdaysRegex')) {
                computeWeekdaysParse.call(this);
            }
            if (isStrict) {
                return this._weekdaysMinStrictRegex;
            } else {
                return this._weekdaysMinRegex;
            }
        } else {
            if (!hasOwnProp(this, '_weekdaysMinRegex')) {
                this._weekdaysMinRegex = defaultWeekdaysMinRegex;
            }
            return this._weekdaysMinStrictRegex && isStrict
                ? this._weekdaysMinStrictRegex
                : this._weekdaysMinRegex;
        }
    }

    function computeWeekdaysParse() {
        function cmpLenRev(a, b) {
            return b.length - a.length;
        }

        var minPieces = [],
            shortPieces = [],
            longPieces = [],
            mixedPieces = [],
            i,
            mom,
            minp,
            shortp,
            longp;
        for (i = 0; i < 7; i++) {
            // make the regex if we don't have it already
            mom = createUTC([2000, 1]).day(i);
            minp = regexEscape(this.weekdaysMin(mom, ''));
            shortp = regexEscape(this.weekdaysShort(mom, ''));
            longp = regexEscape(this.weekdays(mom, ''));
            minPieces.push(minp);
            shortPieces.push(shortp);
            longPieces.push(longp);
            mixedPieces.push(minp);
            mixedPieces.push(shortp);
            mixedPieces.push(longp);
        }
        // Sorting makes sure if one weekday (or abbr) is a prefix of another it
        // will match the longer piece.
        minPieces.sort(cmpLenRev);
        shortPieces.sort(cmpLenRev);
        longPieces.sort(cmpLenRev);
        mixedPieces.sort(cmpLenRev);

        this._weekdaysRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
        this._weekdaysShortRegex = this._weekdaysRegex;
        this._weekdaysMinRegex = this._weekdaysRegex;

        this._weekdaysStrictRegex = new RegExp(
            '^(' + longPieces.join('|') + ')',
            'i'
        );
        this._weekdaysShortStrictRegex = new RegExp(
            '^(' + shortPieces.join('|') + ')',
            'i'
        );
        this._weekdaysMinStrictRegex = new RegExp(
            '^(' + minPieces.join('|') + ')',
            'i'
        );
    }

    // FORMATTING

    function hFormat() {
        return this.hours() % 12 || 12;
    }

    function kFormat() {
        return this.hours() || 24;
    }

    addFormatToken('H', ['HH', 2], 0, 'hour');
    addFormatToken('h', ['hh', 2], 0, hFormat);
    addFormatToken('k', ['kk', 2], 0, kFormat);

    addFormatToken('hmm', 0, 0, function () {
        return '' + hFormat.apply(this) + zeroFill(this.minutes(), 2);
    });

    addFormatToken('hmmss', 0, 0, function () {
        return (
            '' +
            hFormat.apply(this) +
            zeroFill(this.minutes(), 2) +
            zeroFill(this.seconds(), 2)
        );
    });

    addFormatToken('Hmm', 0, 0, function () {
        return '' + this.hours() + zeroFill(this.minutes(), 2);
    });

    addFormatToken('Hmmss', 0, 0, function () {
        return (
            '' +
            this.hours() +
            zeroFill(this.minutes(), 2) +
            zeroFill(this.seconds(), 2)
        );
    });

    function meridiem(token, lowercase) {
        addFormatToken(token, 0, 0, function () {
            return this.localeData().meridiem(
                this.hours(),
                this.minutes(),
                lowercase
            );
        });
    }

    meridiem('a', true);
    meridiem('A', false);

    // PARSING

    function matchMeridiem(isStrict, locale) {
        return locale._meridiemParse;
    }

    addRegexToken('a', matchMeridiem);
    addRegexToken('A', matchMeridiem);
    addRegexToken('H', match1to2, match1to2HasZero);
    addRegexToken('h', match1to2, match1to2NoLeadingZero);
    addRegexToken('k', match1to2, match1to2NoLeadingZero);
    addRegexToken('HH', match1to2, match2);
    addRegexToken('hh', match1to2, match2);
    addRegexToken('kk', match1to2, match2);

    addRegexToken('hmm', match3to4);
    addRegexToken('hmmss', match5to6);
    addRegexToken('Hmm', match3to4);
    addRegexToken('Hmmss', match5to6);

    addParseToken(['H', 'HH'], HOUR);
    addParseToken(['k', 'kk'], function (input, array, config) {
        var kInput = toInt(input);
        array[HOUR] = kInput === 24 ? 0 : kInput;
    });
    addParseToken(['a', 'A'], function (input, array, config) {
        config._isPm = config._locale.isPM(input);
        config._meridiem = input;
    });
    addParseToken(['h', 'hh'], function (input, array, config) {
        array[HOUR] = toInt(input);
        getParsingFlags(config).bigHour = true;
    });
    addParseToken('hmm', function (input, array, config) {
        var pos = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos));
        array[MINUTE] = toInt(input.substr(pos));
        getParsingFlags(config).bigHour = true;
    });
    addParseToken('hmmss', function (input, array, config) {
        var pos1 = input.length - 4,
            pos2 = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos1));
        array[MINUTE] = toInt(input.substr(pos1, 2));
        array[SECOND] = toInt(input.substr(pos2));
        getParsingFlags(config).bigHour = true;
    });
    addParseToken('Hmm', function (input, array, config) {
        var pos = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos));
        array[MINUTE] = toInt(input.substr(pos));
    });
    addParseToken('Hmmss', function (input, array, config) {
        var pos1 = input.length - 4,
            pos2 = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos1));
        array[MINUTE] = toInt(input.substr(pos1, 2));
        array[SECOND] = toInt(input.substr(pos2));
    });

    // LOCALES

    function localeIsPM(input) {
        // IE8 Quirks Mode & IE7 Standards Mode do not allow accessing strings like arrays
        // Using charAt should be more compatible.
        return (input + '').toLowerCase().charAt(0) === 'p';
    }

    var defaultLocaleMeridiemParse = /[ap]\.?m?\.?/i,
        // Setting the hour should keep the time, because the user explicitly
        // specified which hour they want. So trying to maintain the same hour (in
        // a new timezone) makes sense. Adding/subtracting hours does not follow
        // this rule.
        getSetHour = makeGetSet('Hours', true);

    function localeMeridiem(hours, minutes, isLower) {
        if (hours > 11) {
            return isLower ? 'pm' : 'PM';
        } else {
            return isLower ? 'am' : 'AM';
        }
    }

    var baseConfig = {
        calendar: defaultCalendar,
        longDateFormat: defaultLongDateFormat,
        invalidDate: defaultInvalidDate,
        ordinal: defaultOrdinal,
        dayOfMonthOrdinalParse: defaultDayOfMonthOrdinalParse,
        relativeTime: defaultRelativeTime,

        months: defaultLocaleMonths,
        monthsShort: defaultLocaleMonthsShort,

        week: defaultLocaleWeek,

        weekdays: defaultLocaleWeekdays,
        weekdaysMin: defaultLocaleWeekdaysMin,
        weekdaysShort: defaultLocaleWeekdaysShort,

        meridiemParse: defaultLocaleMeridiemParse,
    };

    // internal storage for locale config files
    var locales = {},
        localeFamilies = {},
        globalLocale;

    function commonPrefix(arr1, arr2) {
        var i,
            minl = Math.min(arr1.length, arr2.length);
        for (i = 0; i < minl; i += 1) {
            if (arr1[i] !== arr2[i]) {
                return i;
            }
        }
        return minl;
    }

    function normalizeLocale(key) {
        return key ? key.toLowerCase().replace('_', '-') : key;
    }

    // pick the locale from the array
    // try ['en-au', 'en-gb'] as 'en-au', 'en-gb', 'en', as in move through the list trying each
    // substring from most specific to least, but move to the next array item if it's a more specific variant than the current root
    function chooseLocale(names) {
        var i = 0,
            j,
            next,
            locale,
            split;

        while (i < names.length) {
            split = normalizeLocale(names[i]).split('-');
            j = split.length;
            next = normalizeLocale(names[i + 1]);
            next = next ? next.split('-') : null;
            while (j > 0) {
                locale = loadLocale(split.slice(0, j).join('-'));
                if (locale) {
                    return locale;
                }
                if (
                    next &&
                    next.length >= j &&
                    commonPrefix(split, next) >= j - 1
                ) {
                    //the next array item is better than a shallower substring of this one
                    break;
                }
                j--;
            }
            i++;
        }
        return globalLocale;
    }

    function isLocaleNameSane(name) {
        // Prevent names that look like filesystem paths, i.e contain '/' or '\'
        // Ensure name is available and function returns boolean
        return !!(name && name.match('^[^/\\\\]*$'));
    }

    function loadLocale(name) {
        var oldLocale = null,
            aliasedRequire;
        // TODO: Find a better way to register and load all the locales in Node
        if (
            locales[name] === undefined &&
            "object" !== 'undefined' &&
            module &&
            module.exports &&
            isLocaleNameSane(name)
        ) {
            try {
                oldLocale = globalLocale._abbr;
                aliasedRequire = undefined;
                Object(function webpackMissingModule() { var e = new Error("Cannot find module 'undefined'"); e.code = 'MODULE_NOT_FOUND'; throw e; }());
                getSetGlobalLocale(oldLocale);
            } catch (e) {
                // mark as not found to avoid repeating expensive file require call causing high CPU
                // when trying to find en-US, en_US, en-us for every format call
                locales[name] = null; // null means not found
            }
        }
        return locales[name];
    }

    // This function will load locale and then set the global locale.  If
    // no arguments are passed in, it will simply return the current global
    // locale key.
    function getSetGlobalLocale(key, values) {
        var data;
        if (key) {
            if (isUndefined(values)) {
                data = getLocale(key);
            } else {
                data = defineLocale(key, values);
            }

            if (data) {
                // moment.duration._locale = moment._locale = data;
                globalLocale = data;
            } else {
                if (typeof console !== 'undefined' && console.warn) {
                    //warn user if arguments are passed but the locale could not be set
                    console.warn(
                        'Locale ' + key + ' not found. Did you forget to load it?'
                    );
                }
            }
        }

        return globalLocale._abbr;
    }

    function defineLocale(name, config) {
        if (config !== null) {
            var locale,
                parentConfig = baseConfig;
            config.abbr = name;
            if (locales[name] != null) {
                deprecateSimple(
                    'defineLocaleOverride',
                    'use moment.updateLocale(localeName, config) to change ' +
                        'an existing locale. moment.defineLocale(localeName, ' +
                        'config) should only be used for creating a new locale ' +
                        'See http://momentjs.com/guides/#/warnings/define-locale/ for more info.'
                );
                parentConfig = locales[name]._config;
            } else if (config.parentLocale != null) {
                if (locales[config.parentLocale] != null) {
                    parentConfig = locales[config.parentLocale]._config;
                } else {
                    locale = loadLocale(config.parentLocale);
                    if (locale != null) {
                        parentConfig = locale._config;
                    } else {
                        if (!localeFamilies[config.parentLocale]) {
                            localeFamilies[config.parentLocale] = [];
                        }
                        localeFamilies[config.parentLocale].push({
                            name: name,
                            config: config,
                        });
                        return null;
                    }
                }
            }
            locales[name] = new Locale(mergeConfigs(parentConfig, config));

            if (localeFamilies[name]) {
                localeFamilies[name].forEach(function (x) {
                    defineLocale(x.name, x.config);
                });
            }

            // backwards compat for now: also set the locale
            // make sure we set the locale AFTER all child locales have been
            // created, so we won't end up with the child locale set.
            getSetGlobalLocale(name);

            return locales[name];
        } else {
            // useful for testing
            delete locales[name];
            return null;
        }
    }

    function updateLocale(name, config) {
        if (config != null) {
            var locale,
                tmpLocale,
                parentConfig = baseConfig;

            if (locales[name] != null && locales[name].parentLocale != null) {
                // Update existing child locale in-place to avoid memory-leaks
                locales[name].set(mergeConfigs(locales[name]._config, config));
            } else {
                // MERGE
                tmpLocale = loadLocale(name);
                if (tmpLocale != null) {
                    parentConfig = tmpLocale._config;
                }
                config = mergeConfigs(parentConfig, config);
                if (tmpLocale == null) {
                    // updateLocale is called for creating a new locale
                    // Set abbr so it will have a name (getters return
                    // undefined otherwise).
                    config.abbr = name;
                }
                locale = new Locale(config);
                locale.parentLocale = locales[name];
                locales[name] = locale;
            }

            // backwards compat for now: also set the locale
            getSetGlobalLocale(name);
        } else {
            // pass null for config to unupdate, useful for tests
            if (locales[name] != null) {
                if (locales[name].parentLocale != null) {
                    locales[name] = locales[name].parentLocale;
                    if (name === getSetGlobalLocale()) {
                        getSetGlobalLocale(name);
                    }
                } else if (locales[name] != null) {
                    delete locales[name];
                }
            }
        }
        return locales[name];
    }

    // returns locale data
    function getLocale(key) {
        var locale;

        if (key && key._locale && key._locale._abbr) {
            key = key._locale._abbr;
        }

        if (!key) {
            return globalLocale;
        }

        if (!isArray(key)) {
            //short-circuit everything else
            locale = loadLocale(key);
            if (locale) {
                return locale;
            }
            key = [key];
        }

        return chooseLocale(key);
    }

    function listLocales() {
        return keys(locales);
    }

    function checkOverflow(m) {
        var overflow,
            a = m._a;

        if (a && getParsingFlags(m).overflow === -2) {
            overflow =
                a[MONTH] < 0 || a[MONTH] > 11
                    ? MONTH
                    : a[DATE] < 1 || a[DATE] > daysInMonth(a[YEAR], a[MONTH])
                      ? DATE
                      : a[HOUR] < 0 ||
                          a[HOUR] > 24 ||
                          (a[HOUR] === 24 &&
                              (a[MINUTE] !== 0 ||
                                  a[SECOND] !== 0 ||
                                  a[MILLISECOND] !== 0))
                        ? HOUR
                        : a[MINUTE] < 0 || a[MINUTE] > 59
                          ? MINUTE
                          : a[SECOND] < 0 || a[SECOND] > 59
                            ? SECOND
                            : a[MILLISECOND] < 0 || a[MILLISECOND] > 999
                              ? MILLISECOND
                              : -1;

            if (
                getParsingFlags(m)._overflowDayOfYear &&
                (overflow < YEAR || overflow > DATE)
            ) {
                overflow = DATE;
            }
            if (getParsingFlags(m)._overflowWeeks && overflow === -1) {
                overflow = WEEK;
            }
            if (getParsingFlags(m)._overflowWeekday && overflow === -1) {
                overflow = WEEKDAY;
            }

            getParsingFlags(m).overflow = overflow;
        }

        return m;
    }

    // iso 8601 regex
    // 0000-00-00 0000-W00 or 0000-W00-0 + T + 00 or 00:00 or 00:00:00 or 00:00:00.000 + +00:00 or +0000 or +00)
    var extendedIsoRegex =
            /^\s*((?:[+-]\d{6}|\d{4})-(?:\d\d-\d\d|W\d\d-\d|W\d\d|\d\d\d|\d\d))(?:(T| )(\d\d(?::\d\d(?::\d\d(?:[.,]\d+)?)?)?)([+-]\d\d(?::?\d\d)?|\s*Z)?)?$/,
        basicIsoRegex =
            /^\s*((?:[+-]\d{6}|\d{4})(?:\d\d\d\d|W\d\d\d|W\d\d|\d\d\d|\d\d|))(?:(T| )(\d\d(?:\d\d(?:\d\d(?:[.,]\d+)?)?)?)([+-]\d\d(?::?\d\d)?|\s*Z)?)?$/,
        tzRegex = /Z|[+-]\d\d(?::?\d\d)?/,
        isoDates = [
            ['YYYYYY-MM-DD', /[+-]\d{6}-\d\d-\d\d/],
            ['YYYY-MM-DD', /\d{4}-\d\d-\d\d/],
            ['GGGG-[W]WW-E', /\d{4}-W\d\d-\d/],
            ['GGGG-[W]WW', /\d{4}-W\d\d/, false],
            ['YYYY-DDD', /\d{4}-\d{3}/],
            ['YYYY-MM', /\d{4}-\d\d/, false],
            ['YYYYYYMMDD', /[+-]\d{10}/],
            ['YYYYMMDD', /\d{8}/],
            ['GGGG[W]WWE', /\d{4}W\d{3}/],
            ['GGGG[W]WW', /\d{4}W\d{2}/, false],
            ['YYYYDDD', /\d{7}/],
            ['YYYYMM', /\d{6}/, false],
            ['YYYY', /\d{4}/, false],
        ],
        // iso time formats and regexes
        isoTimes = [
            ['HH:mm:ss.SSSS', /\d\d:\d\d:\d\d\.\d+/],
            ['HH:mm:ss,SSSS', /\d\d:\d\d:\d\d,\d+/],
            ['HH:mm:ss', /\d\d:\d\d:\d\d/],
            ['HH:mm', /\d\d:\d\d/],
            ['HHmmss.SSSS', /\d\d\d\d\d\d\.\d+/],
            ['HHmmss,SSSS', /\d\d\d\d\d\d,\d+/],
            ['HHmmss', /\d\d\d\d\d\d/],
            ['HHmm', /\d\d\d\d/],
            ['HH', /\d\d/],
        ],
        aspNetJsonRegex = /^\/?Date\((-?\d+)/i,
        // RFC 2822 regex: For details see https://tools.ietf.org/html/rfc2822#section-3.3
        rfc2822 =
            /^(?:(Mon|Tue|Wed|Thu|Fri|Sat|Sun),?\s)?(\d{1,2})\s(Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec)\s(\d{2,4})\s(\d\d):(\d\d)(?::(\d\d))?\s(?:(UT|GMT|[ECMP][SD]T)|([Zz])|([+-]\d{4}))$/,
        obsOffsets = {
            UT: 0,
            GMT: 0,
            EDT: -4 * 60,
            EST: -5 * 60,
            CDT: -5 * 60,
            CST: -6 * 60,
            MDT: -6 * 60,
            MST: -7 * 60,
            PDT: -7 * 60,
            PST: -8 * 60,
        };

    // date from iso format
    function configFromISO(config) {
        var i,
            l,
            string = config._i,
            match = extendedIsoRegex.exec(string) || basicIsoRegex.exec(string),
            allowTime,
            dateFormat,
            timeFormat,
            tzFormat,
            isoDatesLen = isoDates.length,
            isoTimesLen = isoTimes.length;

        if (match) {
            getParsingFlags(config).iso = true;
            for (i = 0, l = isoDatesLen; i < l; i++) {
                if (isoDates[i][1].exec(match[1])) {
                    dateFormat = isoDates[i][0];
                    allowTime = isoDates[i][2] !== false;
                    break;
                }
            }
            if (dateFormat == null) {
                config._isValid = false;
                return;
            }
            if (match[3]) {
                for (i = 0, l = isoTimesLen; i < l; i++) {
                    if (isoTimes[i][1].exec(match[3])) {
                        // match[2] should be 'T' or space
                        timeFormat = (match[2] || ' ') + isoTimes[i][0];
                        break;
                    }
                }
                if (timeFormat == null) {
                    config._isValid = false;
                    return;
                }
            }
            if (!allowTime && timeFormat != null) {
                config._isValid = false;
                return;
            }
            if (match[4]) {
                if (tzRegex.exec(match[4])) {
                    tzFormat = 'Z';
                } else {
                    config._isValid = false;
                    return;
                }
            }
            config._f = dateFormat + (timeFormat || '') + (tzFormat || '');
            configFromStringAndFormat(config);
        } else {
            config._isValid = false;
        }
    }

    function extractFromRFC2822Strings(
        yearStr,
        monthStr,
        dayStr,
        hourStr,
        minuteStr,
        secondStr
    ) {
        var result = [
            untruncateYear(yearStr),
            defaultLocaleMonthsShort.indexOf(monthStr),
            parseInt(dayStr, 10),
            parseInt(hourStr, 10),
            parseInt(minuteStr, 10),
        ];

        if (secondStr) {
            result.push(parseInt(secondStr, 10));
        }

        return result;
    }

    function untruncateYear(yearStr) {
        var year = parseInt(yearStr, 10);
        if (year <= 49) {
            return 2000 + year;
        } else if (year <= 999) {
            return 1900 + year;
        }
        return year;
    }

    function preprocessRFC2822(s) {
        // Remove comments and folding whitespace and replace multiple-spaces with a single space
        return s
            .replace(/\([^()]*\)|[\n\t]/g, ' ')
            .replace(/(\s\s+)/g, ' ')
            .replace(/^\s\s*/, '')
            .replace(/\s\s*$/, '');
    }

    function checkWeekday(weekdayStr, parsedInput, config) {
        if (weekdayStr) {
            // TODO: Replace the vanilla JS Date object with an independent day-of-week check.
            var weekdayProvided = defaultLocaleWeekdaysShort.indexOf(weekdayStr),
                weekdayActual = new Date(
                    parsedInput[0],
                    parsedInput[1],
                    parsedInput[2]
                ).getDay();
            if (weekdayProvided !== weekdayActual) {
                getParsingFlags(config).weekdayMismatch = true;
                config._isValid = false;
                return false;
            }
        }
        return true;
    }

    function calculateOffset(obsOffset, militaryOffset, numOffset) {
        if (obsOffset) {
            return obsOffsets[obsOffset];
        } else if (militaryOffset) {
            // the only allowed military tz is Z
            return 0;
        } else {
            var hm = parseInt(numOffset, 10),
                m = hm % 100,
                h = (hm - m) / 100;
            return h * 60 + m;
        }
    }

    // date and time from ref 2822 format
    function configFromRFC2822(config) {
        var match = rfc2822.exec(preprocessRFC2822(config._i)),
            parsedArray;
        if (match) {
            parsedArray = extractFromRFC2822Strings(
                match[4],
                match[3],
                match[2],
                match[5],
                match[6],
                match[7]
            );
            if (!checkWeekday(match[1], parsedArray, config)) {
                return;
            }

            config._a = parsedArray;
            config._tzm = calculateOffset(match[8], match[9], match[10]);

            config._d = createUTCDate.apply(null, config._a);
            config._d.setUTCMinutes(config._d.getUTCMinutes() - config._tzm);

            getParsingFlags(config).rfc2822 = true;
        } else {
            config._isValid = false;
        }
    }

    // date from 1) ASP.NET, 2) ISO, 3) RFC 2822 formats, or 4) optional fallback if parsing isn't strict
    function configFromString(config) {
        var matched = aspNetJsonRegex.exec(config._i);
        if (matched !== null) {
            config._d = new Date(+matched[1]);
            return;
        }

        configFromISO(config);
        if (config._isValid === false) {
            delete config._isValid;
        } else {
            return;
        }

        configFromRFC2822(config);
        if (config._isValid === false) {
            delete config._isValid;
        } else {
            return;
        }

        if (config._strict) {
            config._isValid = false;
        } else {
            // Final attempt, use Input Fallback
            hooks.createFromInputFallback(config);
        }
    }

    hooks.createFromInputFallback = deprecate(
        'value provided is not in a recognized RFC2822 or ISO format. moment construction falls back to js Date(), ' +
            'which is not reliable across all browsers and versions. Non RFC2822/ISO date formats are ' +
            'discouraged. Please refer to http://momentjs.com/guides/#/warnings/js-date/ for more info.',
        function (config) {
            config._d = new Date(config._i + (config._useUTC ? ' UTC' : ''));
        }
    );

    // Pick the first defined of two or three arguments.
    function defaults(a, b, c) {
        if (a != null) {
            return a;
        }
        if (b != null) {
            return b;
        }
        return c;
    }

    function currentDateArray(config) {
        // hooks is actually the exported moment object
        var nowValue = new Date(hooks.now());
        if (config._useUTC) {
            return [
                nowValue.getUTCFullYear(),
                nowValue.getUTCMonth(),
                nowValue.getUTCDate(),
            ];
        }
        return [nowValue.getFullYear(), nowValue.getMonth(), nowValue.getDate()];
    }

    // convert an array to a date.
    // the array should mirror the parameters below
    // note: all values past the year are optional and will default to the lowest possible value.
    // [year, month, day , hour, minute, second, millisecond]
    function configFromArray(config) {
        var i,
            date,
            input = [],
            currentDate,
            expectedWeekday,
            yearToUse;

        if (config._d) {
            return;
        }

        currentDate = currentDateArray(config);

        //compute day of the year from weeks and weekdays
        if (config._w && config._a[DATE] == null && config._a[MONTH] == null) {
            dayOfYearFromWeekInfo(config);
        }

        //if the day of the year is set, figure out what it is
        if (config._dayOfYear != null) {
            yearToUse = defaults(config._a[YEAR], currentDate[YEAR]);

            if (
                config._dayOfYear > daysInYear(yearToUse) ||
                config._dayOfYear === 0
            ) {
                getParsingFlags(config)._overflowDayOfYear = true;
            }

            date = createUTCDate(yearToUse, 0, config._dayOfYear);
            config._a[MONTH] = date.getUTCMonth();
            config._a[DATE] = date.getUTCDate();
        }

        // Default to current date.
        // * if no year, month, day of month are given, default to today
        // * if day of month is given, default month and year
        // * if month is given, default only year
        // * if year is given, don't default anything
        for (i = 0; i < 3 && config._a[i] == null; ++i) {
            config._a[i] = input[i] = currentDate[i];
        }

        // Zero out whatever was not defaulted, including time
        for (; i < 7; i++) {
            config._a[i] = input[i] =
                config._a[i] == null ? (i === 2 ? 1 : 0) : config._a[i];
        }

        // Check for 24:00:00.000
        if (
            config._a[HOUR] === 24 &&
            config._a[MINUTE] === 0 &&
            config._a[SECOND] === 0 &&
            config._a[MILLISECOND] === 0
        ) {
            config._nextDay = true;
            config._a[HOUR] = 0;
        }

        config._d = (config._useUTC ? createUTCDate : createDate).apply(
            null,
            input
        );
        expectedWeekday = config._useUTC
            ? config._d.getUTCDay()
            : config._d.getDay();

        // Apply timezone offset from input. The actual utcOffset can be changed
        // with parseZone.
        if (config._tzm != null) {
            config._d.setUTCMinutes(config._d.getUTCMinutes() - config._tzm);
        }

        if (config._nextDay) {
            config._a[HOUR] = 24;
        }

        // check for mismatching day of week
        if (
            config._w &&
            typeof config._w.d !== 'undefined' &&
            config._w.d !== expectedWeekday
        ) {
            getParsingFlags(config).weekdayMismatch = true;
        }
    }

    function dayOfYearFromWeekInfo(config) {
        var w, weekYear, week, weekday, dow, doy, temp, weekdayOverflow, curWeek;

        w = config._w;
        if (w.GG != null || w.W != null || w.E != null) {
            dow = 1;
            doy = 4;

            // TODO: We need to take the current isoWeekYear, but that depends on
            // how we interpret now (local, utc, fixed offset). So create
            // a now version of current config (take local/utc/offset flags, and
            // create now).
            weekYear = defaults(
                w.GG,
                config._a[YEAR],
                weekOfYear(createLocal(), 1, 4).year
            );
            week = defaults(w.W, 1);
            weekday = defaults(w.E, 1);
            if (weekday < 1 || weekday > 7) {
                weekdayOverflow = true;
            }
        } else {
            dow = config._locale._week.dow;
            doy = config._locale._week.doy;

            curWeek = weekOfYear(createLocal(), dow, doy);

            weekYear = defaults(w.gg, config._a[YEAR], curWeek.year);

            // Default to current week.
            week = defaults(w.w, curWeek.week);

            if (w.d != null) {
                // weekday -- low day numbers are considered next week
                weekday = w.d;
                if (weekday < 0 || weekday > 6) {
                    weekdayOverflow = true;
                }
            } else if (w.e != null) {
                // local weekday -- counting starts from beginning of week
                weekday = w.e + dow;
                if (w.e < 0 || w.e > 6) {
                    weekdayOverflow = true;
                }
            } else {
                // default to beginning of week
                weekday = dow;
            }
        }
        if (week < 1 || week > weeksInYear(weekYear, dow, doy)) {
            getParsingFlags(config)._overflowWeeks = true;
        } else if (weekdayOverflow != null) {
            getParsingFlags(config)._overflowWeekday = true;
        } else {
            temp = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy);
            config._a[YEAR] = temp.year;
            config._dayOfYear = temp.dayOfYear;
        }
    }

    // constant that refers to the ISO standard
    hooks.ISO_8601 = function () {};

    // constant that refers to the RFC 2822 form
    hooks.RFC_2822 = function () {};

    // date from string and format string
    function configFromStringAndFormat(config) {
        // TODO: Move this to another part of the creation flow to prevent circular deps
        if (config._f === hooks.ISO_8601) {
            configFromISO(config);
            return;
        }
        if (config._f === hooks.RFC_2822) {
            configFromRFC2822(config);
            return;
        }
        config._a = [];
        getParsingFlags(config).empty = true;

        // This array is used to make a Date, either with `new Date` or `Date.UTC`
        var string = '' + config._i,
            i,
            parsedInput,
            tokens,
            token,
            skipped,
            stringLength = string.length,
            totalParsedInputLength = 0,
            era,
            tokenLen;

        tokens =
            expandFormat(config._f, config._locale).match(formattingTokens) || [];
        tokenLen = tokens.length;
        for (i = 0; i < tokenLen; i++) {
            token = tokens[i];
            parsedInput = (string.match(getParseRegexForToken(token, config)) ||
                [])[0];
            if (parsedInput) {
                skipped = string.substr(0, string.indexOf(parsedInput));
                if (skipped.length > 0) {
                    getParsingFlags(config).unusedInput.push(skipped);
                }
                string = string.slice(
                    string.indexOf(parsedInput) + parsedInput.length
                );
                totalParsedInputLength += parsedInput.length;
            }
            // don't parse if it's not a known token
            if (formatTokenFunctions[token]) {
                if (parsedInput) {
                    getParsingFlags(config).empty = false;
                } else {
                    getParsingFlags(config).unusedTokens.push(token);
                }
                addTimeToArrayFromToken(token, parsedInput, config);
            } else if (config._strict && !parsedInput) {
                getParsingFlags(config).unusedTokens.push(token);
            }
        }

        // add remaining unparsed input length to the string
        getParsingFlags(config).charsLeftOver =
            stringLength - totalParsedInputLength;
        if (string.length > 0) {
            getParsingFlags(config).unusedInput.push(string);
        }

        // clear _12h flag if hour is <= 12
        if (
            config._a[HOUR] <= 12 &&
            getParsingFlags(config).bigHour === true &&
            config._a[HOUR] > 0
        ) {
            getParsingFlags(config).bigHour = undefined;
        }

        getParsingFlags(config).parsedDateParts = config._a.slice(0);
        getParsingFlags(config).meridiem = config._meridiem;
        // handle meridiem
        config._a[HOUR] = meridiemFixWrap(
            config._locale,
            config._a[HOUR],
            config._meridiem
        );

        // handle era
        era = getParsingFlags(config).era;
        if (era !== null) {
            config._a[YEAR] = config._locale.erasConvertYear(era, config._a[YEAR]);
        }

        configFromArray(config);
        checkOverflow(config);
    }

    function meridiemFixWrap(locale, hour, meridiem) {
        var isPm;

        if (meridiem == null) {
            // nothing to do
            return hour;
        }
        if (locale.meridiemHour != null) {
            return locale.meridiemHour(hour, meridiem);
        } else if (locale.isPM != null) {
            // Fallback
            isPm = locale.isPM(meridiem);
            if (isPm && hour < 12) {
                hour += 12;
            }
            if (!isPm && hour === 12) {
                hour = 0;
            }
            return hour;
        } else {
            // this is not supposed to happen
            return hour;
        }
    }

    // date from string and array of format strings
    function configFromStringAndArray(config) {
        var tempConfig,
            bestMoment,
            scoreToBeat,
            i,
            currentScore,
            validFormatFound,
            bestFormatIsValid = false,
            configfLen = config._f.length;

        if (configfLen === 0) {
            getParsingFlags(config).invalidFormat = true;
            config._d = new Date(NaN);
            return;
        }

        for (i = 0; i < configfLen; i++) {
            currentScore = 0;
            validFormatFound = false;
            tempConfig = copyConfig({}, config);
            if (config._useUTC != null) {
                tempConfig._useUTC = config._useUTC;
            }
            tempConfig._f = config._f[i];
            configFromStringAndFormat(tempConfig);

            if (isValid(tempConfig)) {
                validFormatFound = true;
            }

            // if there is any input that was not parsed add a penalty for that format
            currentScore += getParsingFlags(tempConfig).charsLeftOver;

            //or tokens
            currentScore += getParsingFlags(tempConfig).unusedTokens.length * 10;

            getParsingFlags(tempConfig).score = currentScore;

            if (!bestFormatIsValid) {
                if (
                    scoreToBeat == null ||
                    currentScore < scoreToBeat ||
                    validFormatFound
                ) {
                    scoreToBeat = currentScore;
                    bestMoment = tempConfig;
                    if (validFormatFound) {
                        bestFormatIsValid = true;
                    }
                }
            } else {
                if (currentScore < scoreToBeat) {
                    scoreToBeat = currentScore;
                    bestMoment = tempConfig;
                }
            }
        }

        extend(config, bestMoment || tempConfig);
    }

    function configFromObject(config) {
        if (config._d) {
            return;
        }

        var i = normalizeObjectUnits(config._i),
            dayOrDate = i.day === undefined ? i.date : i.day;
        config._a = map(
            [i.year, i.month, dayOrDate, i.hour, i.minute, i.second, i.millisecond],
            function (obj) {
                return obj && parseInt(obj, 10);
            }
        );

        configFromArray(config);
    }

    function createFromConfig(config) {
        var res = new Moment(checkOverflow(prepareConfig(config)));
        if (res._nextDay) {
            // Adding is smart enough around DST
            res.add(1, 'd');
            res._nextDay = undefined;
        }

        return res;
    }

    function prepareConfig(config) {
        var input = config._i,
            format = config._f;

        config._locale = config._locale || getLocale(config._l);

        if (input === null || (format === undefined && input === '')) {
            return createInvalid({ nullInput: true });
        }

        if (typeof input === 'string') {
            config._i = input = config._locale.preparse(input);
        }

        if (isMoment(input)) {
            return new Moment(checkOverflow(input));
        } else if (isDate(input)) {
            config._d = input;
        } else if (isArray(format)) {
            configFromStringAndArray(config);
        } else if (format) {
            configFromStringAndFormat(config);
        } else {
            configFromInput(config);
        }

        if (!isValid(config)) {
            config._d = null;
        }

        return config;
    }

    function configFromInput(config) {
        var input = config._i;
        if (isUndefined(input)) {
            config._d = new Date(hooks.now());
        } else if (isDate(input)) {
            config._d = new Date(input.valueOf());
        } else if (typeof input === 'string') {
            configFromString(config);
        } else if (isArray(input)) {
            config._a = map(input.slice(0), function (obj) {
                return parseInt(obj, 10);
            });
            configFromArray(config);
        } else if (isObject(input)) {
            configFromObject(config);
        } else if (isNumber(input)) {
            // from milliseconds
            config._d = new Date(input);
        } else {
            hooks.createFromInputFallback(config);
        }
    }

    function createLocalOrUTC(input, format, locale, strict, isUTC) {
        var c = {};

        if (format === true || format === false) {
            strict = format;
            format = undefined;
        }

        if (locale === true || locale === false) {
            strict = locale;
            locale = undefined;
        }

        if (
            (isObject(input) && isObjectEmpty(input)) ||
            (isArray(input) && input.length === 0)
        ) {
            input = undefined;
        }
        // object construction must be done this way.
        // https://github.com/moment/moment/issues/1423
        c._isAMomentObject = true;
        c._useUTC = c._isUTC = isUTC;
        c._l = locale;
        c._i = input;
        c._f = format;
        c._strict = strict;

        return createFromConfig(c);
    }

    function createLocal(input, format, locale, strict) {
        return createLocalOrUTC(input, format, locale, strict, false);
    }

    var prototypeMin = deprecate(
            'moment().min is deprecated, use moment.max instead. http://momentjs.com/guides/#/warnings/min-max/',
            function () {
                var other = createLocal.apply(null, arguments);
                if (this.isValid() && other.isValid()) {
                    return other < this ? this : other;
                } else {
                    return createInvalid();
                }
            }
        ),
        prototypeMax = deprecate(
            'moment().max is deprecated, use moment.min instead. http://momentjs.com/guides/#/warnings/min-max/',
            function () {
                var other = createLocal.apply(null, arguments);
                if (this.isValid() && other.isValid()) {
                    return other > this ? this : other;
                } else {
                    return createInvalid();
                }
            }
        );

    // Pick a moment m from moments so that m[fn](other) is true for all
    // other. This relies on the function fn to be transitive.
    //
    // moments should either be an array of moment objects or an array, whose
    // first element is an array of moment objects.
    function pickBy(fn, moments) {
        var res, i;
        if (moments.length === 1 && isArray(moments[0])) {
            moments = moments[0];
        }
        if (!moments.length) {
            return createLocal();
        }
        res = moments[0];
        for (i = 1; i < moments.length; ++i) {
            if (!moments[i].isValid() || moments[i][fn](res)) {
                res = moments[i];
            }
        }
        return res;
    }

    // TODO: Use [].sort instead?
    function min() {
        var args = [].slice.call(arguments, 0);

        return pickBy('isBefore', args);
    }

    function max() {
        var args = [].slice.call(arguments, 0);

        return pickBy('isAfter', args);
    }

    var now = function () {
        return Date.now ? Date.now() : +new Date();
    };

    var ordering = [
        'year',
        'quarter',
        'month',
        'week',
        'day',
        'hour',
        'minute',
        'second',
        'millisecond',
    ];

    function isDurationValid(m) {
        var key,
            unitHasDecimal = false,
            i,
            orderLen = ordering.length;
        for (key in m) {
            if (
                hasOwnProp(m, key) &&
                !(
                    indexOf.call(ordering, key) !== -1 &&
                    (m[key] == null || !isNaN(m[key]))
                )
            ) {
                return false;
            }
        }

        for (i = 0; i < orderLen; ++i) {
            if (m[ordering[i]]) {
                if (unitHasDecimal) {
                    return false; // only allow non-integers for smallest unit
                }
                if (parseFloat(m[ordering[i]]) !== toInt(m[ordering[i]])) {
                    unitHasDecimal = true;
                }
            }
        }

        return true;
    }

    function isValid$1() {
        return this._isValid;
    }

    function createInvalid$1() {
        return createDuration(NaN);
    }

    function Duration(duration) {
        var normalizedInput = normalizeObjectUnits(duration),
            years = normalizedInput.year || 0,
            quarters = normalizedInput.quarter || 0,
            months = normalizedInput.month || 0,
            weeks = normalizedInput.week || normalizedInput.isoWeek || 0,
            days = normalizedInput.day || 0,
            hours = normalizedInput.hour || 0,
            minutes = normalizedInput.minute || 0,
            seconds = normalizedInput.second || 0,
            milliseconds = normalizedInput.millisecond || 0;

        this._isValid = isDurationValid(normalizedInput);

        // representation for dateAddRemove
        this._milliseconds =
            +milliseconds +
            seconds * 1e3 + // 1000
            minutes * 6e4 + // 1000 * 60
            hours * 1000 * 60 * 60; //using 1000 * 60 * 60 instead of 36e5 to avoid floating point rounding errors https://github.com/moment/moment/issues/2978
        // Because of dateAddRemove treats 24 hours as different from a
        // day when working around DST, we need to store them separately
        this._days = +days + weeks * 7;
        // It is impossible to translate months into days without knowing
        // which months you are are talking about, so we have to store
        // it separately.
        this._months = +months + quarters * 3 + years * 12;

        this._data = {};

        this._locale = getLocale();

        this._bubble();
    }

    function isDuration(obj) {
        return obj instanceof Duration;
    }

    function absRound(number) {
        if (number < 0) {
            return Math.round(-1 * number) * -1;
        } else {
            return Math.round(number);
        }
    }

    // compare two arrays, return the number of differences
    function compareArrays(array1, array2, dontConvert) {
        var len = Math.min(array1.length, array2.length),
            lengthDiff = Math.abs(array1.length - array2.length),
            diffs = 0,
            i;
        for (i = 0; i < len; i++) {
            if (
                (dontConvert && array1[i] !== array2[i]) ||
                (!dontConvert && toInt(array1[i]) !== toInt(array2[i]))
            ) {
                diffs++;
            }
        }
        return diffs + lengthDiff;
    }

    // FORMATTING

    function offset(token, separator) {
        addFormatToken(token, 0, 0, function () {
            var offset = this.utcOffset(),
                sign = '+';
            if (offset < 0) {
                offset = -offset;
                sign = '-';
            }
            return (
                sign +
                zeroFill(~~(offset / 60), 2) +
                separator +
                zeroFill(~~offset % 60, 2)
            );
        });
    }

    offset('Z', ':');
    offset('ZZ', '');

    // PARSING

    addRegexToken('Z', matchShortOffset);
    addRegexToken('ZZ', matchShortOffset);
    addParseToken(['Z', 'ZZ'], function (input, array, config) {
        config._useUTC = true;
        config._tzm = offsetFromString(matchShortOffset, input);
    });

    // HELPERS

    // timezone chunker
    // '+10:00' > ['10',  '00']
    // '-1530'  > ['-15', '30']
    var chunkOffset = /([\+\-]|\d\d)/gi;

    function offsetFromString(matcher, string) {
        var matches = (string || '').match(matcher),
            chunk,
            parts,
            minutes;

        if (matches === null) {
            return null;
        }

        chunk = matches[matches.length - 1] || [];
        parts = (chunk + '').match(chunkOffset) || ['-', 0, 0];
        minutes = +(parts[1] * 60) + toInt(parts[2]);

        return minutes === 0 ? 0 : parts[0] === '+' ? minutes : -minutes;
    }

    // Return a moment from input, that is local/utc/zone equivalent to model.
    function cloneWithOffset(input, model) {
        var res, diff;
        if (model._isUTC) {
            res = model.clone();
            diff =
                (isMoment(input) || isDate(input)
                    ? input.valueOf()
                    : createLocal(input).valueOf()) - res.valueOf();
            // Use low-level api, because this fn is low-level api.
            res._d.setTime(res._d.valueOf() + diff);
            hooks.updateOffset(res, false);
            return res;
        } else {
            return createLocal(input).local();
        }
    }

    function getDateOffset(m) {
        // On Firefox.24 Date#getTimezoneOffset returns a floating point.
        // https://github.com/moment/moment/pull/1871
        return -Math.round(m._d.getTimezoneOffset());
    }

    // HOOKS

    // This function will be called whenever a moment is mutated.
    // It is intended to keep the offset in sync with the timezone.
    hooks.updateOffset = function () {};

    // MOMENTS

    // keepLocalTime = true means only change the timezone, without
    // affecting the local hour. So 5:31:26 +0300 --[utcOffset(2, true)]-->
    // 5:31:26 +0200 It is possible that 5:31:26 doesn't exist with offset
    // +0200, so we adjust the time as needed, to be valid.
    //
    // Keeping the time actually adds/subtracts (one hour)
    // from the actual represented time. That is why we call updateOffset
    // a second time. In case it wants us to change the offset again
    // _changeInProgress == true case, then we have to adjust, because
    // there is no such time in the given timezone.
    function getSetOffset(input, keepLocalTime, keepMinutes) {
        var offset = this._offset || 0,
            localAdjust;
        if (!this.isValid()) {
            return input != null ? this : NaN;
        }
        if (input != null) {
            if (typeof input === 'string') {
                input = offsetFromString(matchShortOffset, input);
                if (input === null) {
                    return this;
                }
            } else if (Math.abs(input) < 16 && !keepMinutes) {
                input = input * 60;
            }
            if (!this._isUTC && keepLocalTime) {
                localAdjust = getDateOffset(this);
            }
            this._offset = input;
            this._isUTC = true;
            if (localAdjust != null) {
                this.add(localAdjust, 'm');
            }
            if (offset !== input) {
                if (!keepLocalTime || this._changeInProgress) {
                    addSubtract(
                        this,
                        createDuration(input - offset, 'm'),
                        1,
                        false
                    );
                } else if (!this._changeInProgress) {
                    this._changeInProgress = true;
                    hooks.updateOffset(this, true);
                    this._changeInProgress = null;
                }
            }
            return this;
        } else {
            return this._isUTC ? offset : getDateOffset(this);
        }
    }

    function getSetZone(input, keepLocalTime) {
        if (input != null) {
            if (typeof input !== 'string') {
                input = -input;
            }

            this.utcOffset(input, keepLocalTime);

            return this;
        } else {
            return -this.utcOffset();
        }
    }

    function setOffsetToUTC(keepLocalTime) {
        return this.utcOffset(0, keepLocalTime);
    }

    function setOffsetToLocal(keepLocalTime) {
        if (this._isUTC) {
            this.utcOffset(0, keepLocalTime);
            this._isUTC = false;

            if (keepLocalTime) {
                this.subtract(getDateOffset(this), 'm');
            }
        }
        return this;
    }

    function setOffsetToParsedOffset() {
        if (this._tzm != null) {
            this.utcOffset(this._tzm, false, true);
        } else if (typeof this._i === 'string') {
            var tZone = offsetFromString(matchOffset, this._i);
            if (tZone != null) {
                this.utcOffset(tZone);
            } else {
                this.utcOffset(0, true);
            }
        }
        return this;
    }

    function hasAlignedHourOffset(input) {
        if (!this.isValid()) {
            return false;
        }
        input = input ? createLocal(input).utcOffset() : 0;

        return (this.utcOffset() - input) % 60 === 0;
    }

    function isDaylightSavingTime() {
        return (
            this.utcOffset() > this.clone().month(0).utcOffset() ||
            this.utcOffset() > this.clone().month(5).utcOffset()
        );
    }

    function isDaylightSavingTimeShifted() {
        if (!isUndefined(this._isDSTShifted)) {
            return this._isDSTShifted;
        }

        var c = {},
            other;

        copyConfig(c, this);
        c = prepareConfig(c);

        if (c._a) {
            other = c._isUTC ? createUTC(c._a) : createLocal(c._a);
            this._isDSTShifted =
                this.isValid() && compareArrays(c._a, other.toArray()) > 0;
        } else {
            this._isDSTShifted = false;
        }

        return this._isDSTShifted;
    }

    function isLocal() {
        return this.isValid() ? !this._isUTC : false;
    }

    function isUtcOffset() {
        return this.isValid() ? this._isUTC : false;
    }

    function isUtc() {
        return this.isValid() ? this._isUTC && this._offset === 0 : false;
    }

    // ASP.NET json date format regex
    var aspNetRegex = /^(-|\+)?(?:(\d*)[. ])?(\d+):(\d+)(?::(\d+)(\.\d*)?)?$/,
        // from http://docs.closure-library.googlecode.com/git/closure_goog_date_date.js.source.html
        // somewhat more in line with 4.4.3.2 2004 spec, but allows decimal anywhere
        // and further modified to allow for strings containing both week and day
        isoRegex =
            /^(-|\+)?P(?:([-+]?[0-9,.]*)Y)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)W)?(?:([-+]?[0-9,.]*)D)?(?:T(?:([-+]?[0-9,.]*)H)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)S)?)?$/;

    function createDuration(input, key) {
        var duration = input,
            // matching against regexp is expensive, do it on demand
            match = null,
            sign,
            ret,
            diffRes;

        if (isDuration(input)) {
            duration = {
                ms: input._milliseconds,
                d: input._days,
                M: input._months,
            };
        } else if (isNumber(input) || !isNaN(+input)) {
            duration = {};
            if (key) {
                duration[key] = +input;
            } else {
                duration.milliseconds = +input;
            }
        } else if ((match = aspNetRegex.exec(input))) {
            sign = match[1] === '-' ? -1 : 1;
            duration = {
                y: 0,
                d: toInt(match[DATE]) * sign,
                h: toInt(match[HOUR]) * sign,
                m: toInt(match[MINUTE]) * sign,
                s: toInt(match[SECOND]) * sign,
                ms: toInt(absRound(match[MILLISECOND] * 1000)) * sign, // the millisecond decimal point is included in the match
            };
        } else if ((match = isoRegex.exec(input))) {
            sign = match[1] === '-' ? -1 : 1;
            duration = {
                y: parseIso(match[2], sign),
                M: parseIso(match[3], sign),
                w: parseIso(match[4], sign),
                d: parseIso(match[5], sign),
                h: parseIso(match[6], sign),
                m: parseIso(match[7], sign),
                s: parseIso(match[8], sign),
            };
        } else if (duration == null) {
            // checks for null or undefined
            duration = {};
        } else if (
            typeof duration === 'object' &&
            ('from' in duration || 'to' in duration)
        ) {
            diffRes = momentsDifference(
                createLocal(duration.from),
                createLocal(duration.to)
            );

            duration = {};
            duration.ms = diffRes.milliseconds;
            duration.M = diffRes.months;
        }

        ret = new Duration(duration);

        if (isDuration(input) && hasOwnProp(input, '_locale')) {
            ret._locale = input._locale;
        }

        if (isDuration(input) && hasOwnProp(input, '_isValid')) {
            ret._isValid = input._isValid;
        }

        return ret;
    }

    createDuration.fn = Duration.prototype;
    createDuration.invalid = createInvalid$1;

    function parseIso(inp, sign) {
        // We'd normally use ~~inp for this, but unfortunately it also
        // converts floats to ints.
        // inp may be undefined, so careful calling replace on it.
        var res = inp && parseFloat(inp.replace(',', '.'));
        // apply sign while we're at it
        return (isNaN(res) ? 0 : res) * sign;
    }

    function positiveMomentsDifference(base, other) {
        var res = {};

        res.months =
            other.month() - base.month() + (other.year() - base.year()) * 12;
        if (base.clone().add(res.months, 'M').isAfter(other)) {
            --res.months;
        }

        res.milliseconds = +other - +base.clone().add(res.months, 'M');

        return res;
    }

    function momentsDifference(base, other) {
        var res;
        if (!(base.isValid() && other.isValid())) {
            return { milliseconds: 0, months: 0 };
        }

        other = cloneWithOffset(other, base);
        if (base.isBefore(other)) {
            res = positiveMomentsDifference(base, other);
        } else {
            res = positiveMomentsDifference(other, base);
            res.milliseconds = -res.milliseconds;
            res.months = -res.months;
        }

        return res;
    }

    // TODO: remove 'name' arg after deprecation is removed
    function createAdder(direction, name) {
        return function (val, period) {
            var dur, tmp;
            //invert the arguments, but complain about it
            if (period !== null && !isNaN(+period)) {
                deprecateSimple(
                    name,
                    'moment().' +
                        name +
                        '(period, number) is deprecated. Please use moment().' +
                        name +
                        '(number, period). ' +
                        'See http://momentjs.com/guides/#/warnings/add-inverted-param/ for more info.'
                );
                tmp = val;
                val = period;
                period = tmp;
            }

            dur = createDuration(val, period);
            addSubtract(this, dur, direction);
            return this;
        };
    }

    function addSubtract(mom, duration, isAdding, updateOffset) {
        var milliseconds = duration._milliseconds,
            days = absRound(duration._days),
            months = absRound(duration._months);

        if (!mom.isValid()) {
            // No op
            return;
        }

        updateOffset = updateOffset == null ? true : updateOffset;

        if (months) {
            setMonth(mom, get(mom, 'Month') + months * isAdding);
        }
        if (days) {
            set$1(mom, 'Date', get(mom, 'Date') + days * isAdding);
        }
        if (milliseconds) {
            mom._d.setTime(mom._d.valueOf() + milliseconds * isAdding);
        }
        if (updateOffset) {
            hooks.updateOffset(mom, days || months);
        }
    }

    var add = createAdder(1, 'add'),
        subtract = createAdder(-1, 'subtract');

    function isString(input) {
        return typeof input === 'string' || input instanceof String;
    }

    // type MomentInput = Moment | Date | string | number | (number | string)[] | MomentInputObject | void; // null | undefined
    function isMomentInput(input) {
        return (
            isMoment(input) ||
            isDate(input) ||
            isString(input) ||
            isNumber(input) ||
            isNumberOrStringArray(input) ||
            isMomentInputObject(input) ||
            input === null ||
            input === undefined
        );
    }

    function isMomentInputObject(input) {
        var objectTest = isObject(input) && !isObjectEmpty(input),
            propertyTest = false,
            properties = [
                'years',
                'year',
                'y',
                'months',
                'month',
                'M',
                'days',
                'day',
                'd',
                'dates',
                'date',
                'D',
                'hours',
                'hour',
                'h',
                'minutes',
                'minute',
                'm',
                'seconds',
                'second',
                's',
                'milliseconds',
                'millisecond',
                'ms',
            ],
            i,
            property,
            propertyLen = properties.length;

        for (i = 0; i < propertyLen; i += 1) {
            property = properties[i];
            propertyTest = propertyTest || hasOwnProp(input, property);
        }

        return objectTest && propertyTest;
    }

    function isNumberOrStringArray(input) {
        var arrayTest = isArray(input),
            dataTypeTest = false;
        if (arrayTest) {
            dataTypeTest =
                input.filter(function (item) {
                    return !isNumber(item) && isString(input);
                }).length === 0;
        }
        return arrayTest && dataTypeTest;
    }

    function isCalendarSpec(input) {
        var objectTest = isObject(input) && !isObjectEmpty(input),
            propertyTest = false,
            properties = [
                'sameDay',
                'nextDay',
                'lastDay',
                'nextWeek',
                'lastWeek',
                'sameElse',
            ],
            i,
            property;

        for (i = 0; i < properties.length; i += 1) {
            property = properties[i];
            propertyTest = propertyTest || hasOwnProp(input, property);
        }

        return objectTest && propertyTest;
    }

    function getCalendarFormat(myMoment, now) {
        var diff = myMoment.diff(now, 'days', true);
        return diff < -6
            ? 'sameElse'
            : diff < -1
              ? 'lastWeek'
              : diff < 0
                ? 'lastDay'
                : diff < 1
                  ? 'sameDay'
                  : diff < 2
                    ? 'nextDay'
                    : diff < 7
                      ? 'nextWeek'
                      : 'sameElse';
    }

    function calendar$1(time, formats) {
        // Support for single parameter, formats only overload to the calendar function
        if (arguments.length === 1) {
            if (!arguments[0]) {
                time = undefined;
                formats = undefined;
            } else if (isMomentInput(arguments[0])) {
                time = arguments[0];
                formats = undefined;
            } else if (isCalendarSpec(arguments[0])) {
                formats = arguments[0];
                time = undefined;
            }
        }
        // We want to compare the start of today, vs this.
        // Getting start-of-today depends on whether we're local/utc/offset or not.
        var now = time || createLocal(),
            sod = cloneWithOffset(now, this).startOf('day'),
            format = hooks.calendarFormat(this, sod) || 'sameElse',
            output =
                formats &&
                (isFunction(formats[format])
                    ? formats[format].call(this, now)
                    : formats[format]);

        return this.format(
            output || this.localeData().calendar(format, this, createLocal(now))
        );
    }

    function clone() {
        return new Moment(this);
    }

    function isAfter(input, units) {
        var localInput = isMoment(input) ? input : createLocal(input);
        if (!(this.isValid() && localInput.isValid())) {
            return false;
        }
        units = normalizeUnits(units) || 'millisecond';
        if (units === 'millisecond') {
            return this.valueOf() > localInput.valueOf();
        } else {
            return localInput.valueOf() < this.clone().startOf(units).valueOf();
        }
    }

    function isBefore(input, units) {
        var localInput = isMoment(input) ? input : createLocal(input);
        if (!(this.isValid() && localInput.isValid())) {
            return false;
        }
        units = normalizeUnits(units) || 'millisecond';
        if (units === 'millisecond') {
            return this.valueOf() < localInput.valueOf();
        } else {
            return this.clone().endOf(units).valueOf() < localInput.valueOf();
        }
    }

    function isBetween(from, to, units, inclusivity) {
        var localFrom = isMoment(from) ? from : createLocal(from),
            localTo = isMoment(to) ? to : createLocal(to);
        if (!(this.isValid() && localFrom.isValid() && localTo.isValid())) {
            return false;
        }
        inclusivity = inclusivity || '()';
        return (
            (inclusivity[0] === '('
                ? this.isAfter(localFrom, units)
                : !this.isBefore(localFrom, units)) &&
            (inclusivity[1] === ')'
                ? this.isBefore(localTo, units)
                : !this.isAfter(localTo, units))
        );
    }

    function isSame(input, units) {
        var localInput = isMoment(input) ? input : createLocal(input),
            inputMs;
        if (!(this.isValid() && localInput.isValid())) {
            return false;
        }
        units = normalizeUnits(units) || 'millisecond';
        if (units === 'millisecond') {
            return this.valueOf() === localInput.valueOf();
        } else {
            inputMs = localInput.valueOf();
            return (
                this.clone().startOf(units).valueOf() <= inputMs &&
                inputMs <= this.clone().endOf(units).valueOf()
            );
        }
    }

    function isSameOrAfter(input, units) {
        return this.isSame(input, units) || this.isAfter(input, units);
    }

    function isSameOrBefore(input, units) {
        return this.isSame(input, units) || this.isBefore(input, units);
    }

    function diff(input, units, asFloat) {
        var that, zoneDelta, output;

        if (!this.isValid()) {
            return NaN;
        }

        that = cloneWithOffset(input, this);

        if (!that.isValid()) {
            return NaN;
        }

        zoneDelta = (that.utcOffset() - this.utcOffset()) * 6e4;

        units = normalizeUnits(units);

        switch (units) {
            case 'year':
                output = monthDiff(this, that) / 12;
                break;
            case 'month':
                output = monthDiff(this, that);
                break;
            case 'quarter':
                output = monthDiff(this, that) / 3;
                break;
            case 'second':
                output = (this - that) / 1e3;
                break; // 1000
            case 'minute':
                output = (this - that) / 6e4;
                break; // 1000 * 60
            case 'hour':
                output = (this - that) / 36e5;
                break; // 1000 * 60 * 60
            case 'day':
                output = (this - that - zoneDelta) / 864e5;
                break; // 1000 * 60 * 60 * 24, negate dst
            case 'week':
                output = (this - that - zoneDelta) / 6048e5;
                break; // 1000 * 60 * 60 * 24 * 7, negate dst
            default:
                output = this - that;
        }

        return asFloat ? output : absFloor(output);
    }

    function monthDiff(a, b) {
        if (a.date() < b.date()) {
            // end-of-month calculations work correct when the start month has more
            // days than the end month.
            return -monthDiff(b, a);
        }
        // difference in months
        var wholeMonthDiff = (b.year() - a.year()) * 12 + (b.month() - a.month()),
            // b is in (anchor - 1 month, anchor + 1 month)
            anchor = a.clone().add(wholeMonthDiff, 'months'),
            anchor2,
            adjust;

        if (b - anchor < 0) {
            anchor2 = a.clone().add(wholeMonthDiff - 1, 'months');
            // linear across the month
            adjust = (b - anchor) / (anchor - anchor2);
        } else {
            anchor2 = a.clone().add(wholeMonthDiff + 1, 'months');
            // linear across the month
            adjust = (b - anchor) / (anchor2 - anchor);
        }

        //check for negative zero, return zero if negative zero
        return -(wholeMonthDiff + adjust) || 0;
    }

    hooks.defaultFormat = 'YYYY-MM-DDTHH:mm:ssZ';
    hooks.defaultFormatUtc = 'YYYY-MM-DDTHH:mm:ss[Z]';

    function toString() {
        return this.clone().locale('en').format('ddd MMM DD YYYY HH:mm:ss [GMT]ZZ');
    }

    function toISOString(keepOffset) {
        if (!this.isValid()) {
            return null;
        }
        var utc = keepOffset !== true,
            m = utc ? this.clone().utc() : this;
        if (m.year() < 0 || m.year() > 9999) {
            return formatMoment(
                m,
                utc
                    ? 'YYYYYY-MM-DD[T]HH:mm:ss.SSS[Z]'
                    : 'YYYYYY-MM-DD[T]HH:mm:ss.SSSZ'
            );
        }
        if (isFunction(Date.prototype.toISOString)) {
            // native implementation is ~50x faster, use it when we can
            if (utc) {
                return this.toDate().toISOString();
            } else {
                return new Date(this.valueOf() + this.utcOffset() * 60 * 1000)
                    .toISOString()
                    .replace('Z', formatMoment(m, 'Z'));
            }
        }
        return formatMoment(
            m,
            utc ? 'YYYY-MM-DD[T]HH:mm:ss.SSS[Z]' : 'YYYY-MM-DD[T]HH:mm:ss.SSSZ'
        );
    }

    /**
     * Return a human readable representation of a moment that can
     * also be evaluated to get a new moment which is the same
     *
     * @link https://nodejs.org/dist/latest/docs/api/util.html#util_custom_inspect_function_on_objects
     */
    function inspect() {
        if (!this.isValid()) {
            return 'moment.invalid(/* ' + this._i + ' */)';
        }
        var func = 'moment',
            zone = '',
            prefix,
            year,
            datetime,
            suffix;
        if (!this.isLocal()) {
            func = this.utcOffset() === 0 ? 'moment.utc' : 'moment.parseZone';
            zone = 'Z';
        }
        prefix = '[' + func + '("]';
        year = 0 <= this.year() && this.year() <= 9999 ? 'YYYY' : 'YYYYYY';
        datetime = '-MM-DD[T]HH:mm:ss.SSS';
        suffix = zone + '[")]';

        return this.format(prefix + year + datetime + suffix);
    }

    function format(inputString) {
        if (!inputString) {
            inputString = this.isUtc()
                ? hooks.defaultFormatUtc
                : hooks.defaultFormat;
        }
        var output = formatMoment(this, inputString);
        return this.localeData().postformat(output);
    }

    function from(time, withoutSuffix) {
        if (
            this.isValid() &&
            ((isMoment(time) && time.isValid()) || createLocal(time).isValid())
        ) {
            return createDuration({ to: this, from: time })
                .locale(this.locale())
                .humanize(!withoutSuffix);
        } else {
            return this.localeData().invalidDate();
        }
    }

    function fromNow(withoutSuffix) {
        return this.from(createLocal(), withoutSuffix);
    }

    function to(time, withoutSuffix) {
        if (
            this.isValid() &&
            ((isMoment(time) && time.isValid()) || createLocal(time).isValid())
        ) {
            return createDuration({ from: this, to: time })
                .locale(this.locale())
                .humanize(!withoutSuffix);
        } else {
            return this.localeData().invalidDate();
        }
    }

    function toNow(withoutSuffix) {
        return this.to(createLocal(), withoutSuffix);
    }

    // If passed a locale key, it will set the locale for this
    // instance.  Otherwise, it will return the locale configuration
    // variables for this instance.
    function locale(key) {
        var newLocaleData;

        if (key === undefined) {
            return this._locale._abbr;
        } else {
            newLocaleData = getLocale(key);
            if (newLocaleData != null) {
                this._locale = newLocaleData;
            }
            return this;
        }
    }

    var lang = deprecate(
        'moment().lang() is deprecated. Instead, use moment().localeData() to get the language configuration. Use moment().locale() to change languages.',
        function (key) {
            if (key === undefined) {
                return this.localeData();
            } else {
                return this.locale(key);
            }
        }
    );

    function localeData() {
        return this._locale;
    }

    var MS_PER_SECOND = 1000,
        MS_PER_MINUTE = 60 * MS_PER_SECOND,
        MS_PER_HOUR = 60 * MS_PER_MINUTE,
        MS_PER_400_YEARS = (365 * 400 + 97) * 24 * MS_PER_HOUR;

    // actual modulo - handles negative numbers (for dates before 1970):
    function mod$1(dividend, divisor) {
        return ((dividend % divisor) + divisor) % divisor;
    }

    function localStartOfDate(y, m, d) {
        // the date constructor remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0) {
            // preserve leap years using a full 400 year cycle, then reset
            return new Date(y + 400, m, d) - MS_PER_400_YEARS;
        } else {
            return new Date(y, m, d).valueOf();
        }
    }

    function utcStartOfDate(y, m, d) {
        // Date.UTC remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0) {
            // preserve leap years using a full 400 year cycle, then reset
            return Date.UTC(y + 400, m, d) - MS_PER_400_YEARS;
        } else {
            return Date.UTC(y, m, d);
        }
    }

    function startOf(units) {
        var time, startOfDate;
        units = normalizeUnits(units);
        if (units === undefined || units === 'millisecond' || !this.isValid()) {
            return this;
        }

        startOfDate = this._isUTC ? utcStartOfDate : localStartOfDate;

        switch (units) {
            case 'year':
                time = startOfDate(this.year(), 0, 1);
                break;
            case 'quarter':
                time = startOfDate(
                    this.year(),
                    this.month() - (this.month() % 3),
                    1
                );
                break;
            case 'month':
                time = startOfDate(this.year(), this.month(), 1);
                break;
            case 'week':
                time = startOfDate(
                    this.year(),
                    this.month(),
                    this.date() - this.weekday()
                );
                break;
            case 'isoWeek':
                time = startOfDate(
                    this.year(),
                    this.month(),
                    this.date() - (this.isoWeekday() - 1)
                );
                break;
            case 'day':
            case 'date':
                time = startOfDate(this.year(), this.month(), this.date());
                break;
            case 'hour':
                time = this._d.valueOf();
                time -= mod$1(
                    time + (this._isUTC ? 0 : this.utcOffset() * MS_PER_MINUTE),
                    MS_PER_HOUR
                );
                break;
            case 'minute':
                time = this._d.valueOf();
                time -= mod$1(time, MS_PER_MINUTE);
                break;
            case 'second':
                time = this._d.valueOf();
                time -= mod$1(time, MS_PER_SECOND);
                break;
        }

        this._d.setTime(time);
        hooks.updateOffset(this, true);
        return this;
    }

    function endOf(units) {
        var time, startOfDate;
        units = normalizeUnits(units);
        if (units === undefined || units === 'millisecond' || !this.isValid()) {
            return this;
        }

        startOfDate = this._isUTC ? utcStartOfDate : localStartOfDate;

        switch (units) {
            case 'year':
                time = startOfDate(this.year() + 1, 0, 1) - 1;
                break;
            case 'quarter':
                time =
                    startOfDate(
                        this.year(),
                        this.month() - (this.month() % 3) + 3,
                        1
                    ) - 1;
                break;
            case 'month':
                time = startOfDate(this.year(), this.month() + 1, 1) - 1;
                break;
            case 'week':
                time =
                    startOfDate(
                        this.year(),
                        this.month(),
                        this.date() - this.weekday() + 7
                    ) - 1;
                break;
            case 'isoWeek':
                time =
                    startOfDate(
                        this.year(),
                        this.month(),
                        this.date() - (this.isoWeekday() - 1) + 7
                    ) - 1;
                break;
            case 'day':
            case 'date':
                time = startOfDate(this.year(), this.month(), this.date() + 1) - 1;
                break;
            case 'hour':
                time = this._d.valueOf();
                time +=
                    MS_PER_HOUR -
                    mod$1(
                        time + (this._isUTC ? 0 : this.utcOffset() * MS_PER_MINUTE),
                        MS_PER_HOUR
                    ) -
                    1;
                break;
            case 'minute':
                time = this._d.valueOf();
                time += MS_PER_MINUTE - mod$1(time, MS_PER_MINUTE) - 1;
                break;
            case 'second':
                time = this._d.valueOf();
                time += MS_PER_SECOND - mod$1(time, MS_PER_SECOND) - 1;
                break;
        }

        this._d.setTime(time);
        hooks.updateOffset(this, true);
        return this;
    }

    function valueOf() {
        return this._d.valueOf() - (this._offset || 0) * 60000;
    }

    function unix() {
        return Math.floor(this.valueOf() / 1000);
    }

    function toDate() {
        return new Date(this.valueOf());
    }

    function toArray() {
        var m = this;
        return [
            m.year(),
            m.month(),
            m.date(),
            m.hour(),
            m.minute(),
            m.second(),
            m.millisecond(),
        ];
    }

    function toObject() {
        var m = this;
        return {
            years: m.year(),
            months: m.month(),
            date: m.date(),
            hours: m.hours(),
            minutes: m.minutes(),
            seconds: m.seconds(),
            milliseconds: m.milliseconds(),
        };
    }

    function toJSON() {
        // new Date(NaN).toJSON() === null
        return this.isValid() ? this.toISOString() : null;
    }

    function isValid$2() {
        return isValid(this);
    }

    function parsingFlags() {
        return extend({}, getParsingFlags(this));
    }

    function invalidAt() {
        return getParsingFlags(this).overflow;
    }

    function creationData() {
        return {
            input: this._i,
            format: this._f,
            locale: this._locale,
            isUTC: this._isUTC,
            strict: this._strict,
        };
    }

    addFormatToken('N', 0, 0, 'eraAbbr');
    addFormatToken('NN', 0, 0, 'eraAbbr');
    addFormatToken('NNN', 0, 0, 'eraAbbr');
    addFormatToken('NNNN', 0, 0, 'eraName');
    addFormatToken('NNNNN', 0, 0, 'eraNarrow');

    addFormatToken('y', ['y', 1], 'yo', 'eraYear');
    addFormatToken('y', ['yy', 2], 0, 'eraYear');
    addFormatToken('y', ['yyy', 3], 0, 'eraYear');
    addFormatToken('y', ['yyyy', 4], 0, 'eraYear');

    addRegexToken('N', matchEraAbbr);
    addRegexToken('NN', matchEraAbbr);
    addRegexToken('NNN', matchEraAbbr);
    addRegexToken('NNNN', matchEraName);
    addRegexToken('NNNNN', matchEraNarrow);

    addParseToken(
        ['N', 'NN', 'NNN', 'NNNN', 'NNNNN'],
        function (input, array, config, token) {
            var era = config._locale.erasParse(input, token, config._strict);
            if (era) {
                getParsingFlags(config).era = era;
            } else {
                getParsingFlags(config).invalidEra = input;
            }
        }
    );

    addRegexToken('y', matchUnsigned);
    addRegexToken('yy', matchUnsigned);
    addRegexToken('yyy', matchUnsigned);
    addRegexToken('yyyy', matchUnsigned);
    addRegexToken('yo', matchEraYearOrdinal);

    addParseToken(['y', 'yy', 'yyy', 'yyyy'], YEAR);
    addParseToken(['yo'], function (input, array, config, token) {
        var match;
        if (config._locale._eraYearOrdinalRegex) {
            match = input.match(config._locale._eraYearOrdinalRegex);
        }

        if (config._locale.eraYearOrdinalParse) {
            array[YEAR] = config._locale.eraYearOrdinalParse(input, match);
        } else {
            array[YEAR] = parseInt(input, 10);
        }
    });

    function localeEras(m, format) {
        var i,
            l,
            date,
            eras = this._eras || getLocale('en')._eras;
        for (i = 0, l = eras.length; i < l; ++i) {
            switch (typeof eras[i].since) {
                case 'string':
                    // truncate time
                    date = hooks(eras[i].since).startOf('day');
                    eras[i].since = date.valueOf();
                    break;
            }

            switch (typeof eras[i].until) {
                case 'undefined':
                    eras[i].until = +Infinity;
                    break;
                case 'string':
                    // truncate time
                    date = hooks(eras[i].until).startOf('day').valueOf();
                    eras[i].until = date.valueOf();
                    break;
            }
        }
        return eras;
    }

    function localeErasParse(eraName, format, strict) {
        var i,
            l,
            eras = this.eras(),
            name,
            abbr,
            narrow;
        eraName = eraName.toUpperCase();

        for (i = 0, l = eras.length; i < l; ++i) {
            name = eras[i].name.toUpperCase();
            abbr = eras[i].abbr.toUpperCase();
            narrow = eras[i].narrow.toUpperCase();

            if (strict) {
                switch (format) {
                    case 'N':
                    case 'NN':
                    case 'NNN':
                        if (abbr === eraName) {
                            return eras[i];
                        }
                        break;

                    case 'NNNN':
                        if (name === eraName) {
                            return eras[i];
                        }
                        break;

                    case 'NNNNN':
                        if (narrow === eraName) {
                            return eras[i];
                        }
                        break;
                }
            } else if ([name, abbr, narrow].indexOf(eraName) >= 0) {
                return eras[i];
            }
        }
    }

    function localeErasConvertYear(era, year) {
        var dir = era.since <= era.until ? +1 : -1;
        if (year === undefined) {
            return hooks(era.since).year();
        } else {
            return hooks(era.since).year() + (year - era.offset) * dir;
        }
    }

    function getEraName() {
        var i,
            l,
            val,
            eras = this.localeData().eras();
        for (i = 0, l = eras.length; i < l; ++i) {
            // truncate time
            val = this.clone().startOf('day').valueOf();

            if (eras[i].since <= val && val <= eras[i].until) {
                return eras[i].name;
            }
            if (eras[i].until <= val && val <= eras[i].since) {
                return eras[i].name;
            }
        }

        return '';
    }

    function getEraNarrow() {
        var i,
            l,
            val,
            eras = this.localeData().eras();
        for (i = 0, l = eras.length; i < l; ++i) {
            // truncate time
            val = this.clone().startOf('day').valueOf();

            if (eras[i].since <= val && val <= eras[i].until) {
                return eras[i].narrow;
            }
            if (eras[i].until <= val && val <= eras[i].since) {
                return eras[i].narrow;
            }
        }

        return '';
    }

    function getEraAbbr() {
        var i,
            l,
            val,
            eras = this.localeData().eras();
        for (i = 0, l = eras.length; i < l; ++i) {
            // truncate time
            val = this.clone().startOf('day').valueOf();

            if (eras[i].since <= val && val <= eras[i].until) {
                return eras[i].abbr;
            }
            if (eras[i].until <= val && val <= eras[i].since) {
                return eras[i].abbr;
            }
        }

        return '';
    }

    function getEraYear() {
        var i,
            l,
            dir,
            val,
            eras = this.localeData().eras();
        for (i = 0, l = eras.length; i < l; ++i) {
            dir = eras[i].since <= eras[i].until ? +1 : -1;

            // truncate time
            val = this.clone().startOf('day').valueOf();

            if (
                (eras[i].since <= val && val <= eras[i].until) ||
                (eras[i].until <= val && val <= eras[i].since)
            ) {
                return (
                    (this.year() - hooks(eras[i].since).year()) * dir +
                    eras[i].offset
                );
            }
        }

        return this.year();
    }

    function erasNameRegex(isStrict) {
        if (!hasOwnProp(this, '_erasNameRegex')) {
            computeErasParse.call(this);
        }
        return isStrict ? this._erasNameRegex : this._erasRegex;
    }

    function erasAbbrRegex(isStrict) {
        if (!hasOwnProp(this, '_erasAbbrRegex')) {
            computeErasParse.call(this);
        }
        return isStrict ? this._erasAbbrRegex : this._erasRegex;
    }

    function erasNarrowRegex(isStrict) {
        if (!hasOwnProp(this, '_erasNarrowRegex')) {
            computeErasParse.call(this);
        }
        return isStrict ? this._erasNarrowRegex : this._erasRegex;
    }

    function matchEraAbbr(isStrict, locale) {
        return locale.erasAbbrRegex(isStrict);
    }

    function matchEraName(isStrict, locale) {
        return locale.erasNameRegex(isStrict);
    }

    function matchEraNarrow(isStrict, locale) {
        return locale.erasNarrowRegex(isStrict);
    }

    function matchEraYearOrdinal(isStrict, locale) {
        return locale._eraYearOrdinalRegex || matchUnsigned;
    }

    function computeErasParse() {
        var abbrPieces = [],
            namePieces = [],
            narrowPieces = [],
            mixedPieces = [],
            i,
            l,
            erasName,
            erasAbbr,
            erasNarrow,
            eras = this.eras();

        for (i = 0, l = eras.length; i < l; ++i) {
            erasName = regexEscape(eras[i].name);
            erasAbbr = regexEscape(eras[i].abbr);
            erasNarrow = regexEscape(eras[i].narrow);

            namePieces.push(erasName);
            abbrPieces.push(erasAbbr);
            narrowPieces.push(erasNarrow);
            mixedPieces.push(erasName);
            mixedPieces.push(erasAbbr);
            mixedPieces.push(erasNarrow);
        }

        this._erasRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
        this._erasNameRegex = new RegExp('^(' + namePieces.join('|') + ')', 'i');
        this._erasAbbrRegex = new RegExp('^(' + abbrPieces.join('|') + ')', 'i');
        this._erasNarrowRegex = new RegExp(
            '^(' + narrowPieces.join('|') + ')',
            'i'
        );
    }

    // FORMATTING

    addFormatToken(0, ['gg', 2], 0, function () {
        return this.weekYear() % 100;
    });

    addFormatToken(0, ['GG', 2], 0, function () {
        return this.isoWeekYear() % 100;
    });

    function addWeekYearFormatToken(token, getter) {
        addFormatToken(0, [token, token.length], 0, getter);
    }

    addWeekYearFormatToken('gggg', 'weekYear');
    addWeekYearFormatToken('ggggg', 'weekYear');
    addWeekYearFormatToken('GGGG', 'isoWeekYear');
    addWeekYearFormatToken('GGGGG', 'isoWeekYear');

    // ALIASES

    // PARSING

    addRegexToken('G', matchSigned);
    addRegexToken('g', matchSigned);
    addRegexToken('GG', match1to2, match2);
    addRegexToken('gg', match1to2, match2);
    addRegexToken('GGGG', match1to4, match4);
    addRegexToken('gggg', match1to4, match4);
    addRegexToken('GGGGG', match1to6, match6);
    addRegexToken('ggggg', match1to6, match6);

    addWeekParseToken(
        ['gggg', 'ggggg', 'GGGG', 'GGGGG'],
        function (input, week, config, token) {
            week[token.substr(0, 2)] = toInt(input);
        }
    );

    addWeekParseToken(['gg', 'GG'], function (input, week, config, token) {
        week[token] = hooks.parseTwoDigitYear(input);
    });

    // MOMENTS

    function getSetWeekYear(input) {
        return getSetWeekYearHelper.call(
            this,
            input,
            this.week(),
            this.weekday() + this.localeData()._week.dow,
            this.localeData()._week.dow,
            this.localeData()._week.doy
        );
    }

    function getSetISOWeekYear(input) {
        return getSetWeekYearHelper.call(
            this,
            input,
            this.isoWeek(),
            this.isoWeekday(),
            1,
            4
        );
    }

    function getISOWeeksInYear() {
        return weeksInYear(this.year(), 1, 4);
    }

    function getISOWeeksInISOWeekYear() {
        return weeksInYear(this.isoWeekYear(), 1, 4);
    }

    function getWeeksInYear() {
        var weekInfo = this.localeData()._week;
        return weeksInYear(this.year(), weekInfo.dow, weekInfo.doy);
    }

    function getWeeksInWeekYear() {
        var weekInfo = this.localeData()._week;
        return weeksInYear(this.weekYear(), weekInfo.dow, weekInfo.doy);
    }

    function getSetWeekYearHelper(input, week, weekday, dow, doy) {
        var weeksTarget;
        if (input == null) {
            return weekOfYear(this, dow, doy).year;
        } else {
            weeksTarget = weeksInYear(input, dow, doy);
            if (week > weeksTarget) {
                week = weeksTarget;
            }
            return setWeekAll.call(this, input, week, weekday, dow, doy);
        }
    }

    function setWeekAll(weekYear, week, weekday, dow, doy) {
        var dayOfYearData = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy),
            date = createUTCDate(dayOfYearData.year, 0, dayOfYearData.dayOfYear);

        this.year(date.getUTCFullYear());
        this.month(date.getUTCMonth());
        this.date(date.getUTCDate());
        return this;
    }

    // FORMATTING

    addFormatToken('Q', 0, 'Qo', 'quarter');

    // PARSING

    addRegexToken('Q', match1);
    addParseToken('Q', function (input, array) {
        array[MONTH] = (toInt(input) - 1) * 3;
    });

    // MOMENTS

    function getSetQuarter(input) {
        return input == null
            ? Math.ceil((this.month() + 1) / 3)
            : this.month((input - 1) * 3 + (this.month() % 3));
    }

    // FORMATTING

    addFormatToken('D', ['DD', 2], 'Do', 'date');

    // PARSING

    addRegexToken('D', match1to2, match1to2NoLeadingZero);
    addRegexToken('DD', match1to2, match2);
    addRegexToken('Do', function (isStrict, locale) {
        // TODO: Remove "ordinalParse" fallback in next major release.
        return isStrict
            ? locale._dayOfMonthOrdinalParse || locale._ordinalParse
            : locale._dayOfMonthOrdinalParseLenient;
    });

    addParseToken(['D', 'DD'], DATE);
    addParseToken('Do', function (input, array) {
        array[DATE] = toInt(input.match(match1to2)[0]);
    });

    // MOMENTS

    var getSetDayOfMonth = makeGetSet('Date', true);

    // FORMATTING

    addFormatToken('DDD', ['DDDD', 3], 'DDDo', 'dayOfYear');

    // PARSING

    addRegexToken('DDD', match1to3);
    addRegexToken('DDDD', match3);
    addParseToken(['DDD', 'DDDD'], function (input, array, config) {
        config._dayOfYear = toInt(input);
    });

    // HELPERS

    // MOMENTS

    function getSetDayOfYear(input) {
        var dayOfYear =
            Math.round(
                (this.clone().startOf('day') - this.clone().startOf('year')) / 864e5
            ) + 1;
        return input == null ? dayOfYear : this.add(input - dayOfYear, 'd');
    }

    // FORMATTING

    addFormatToken('m', ['mm', 2], 0, 'minute');

    // PARSING

    addRegexToken('m', match1to2, match1to2HasZero);
    addRegexToken('mm', match1to2, match2);
    addParseToken(['m', 'mm'], MINUTE);

    // MOMENTS

    var getSetMinute = makeGetSet('Minutes', false);

    // FORMATTING

    addFormatToken('s', ['ss', 2], 0, 'second');

    // PARSING

    addRegexToken('s', match1to2, match1to2HasZero);
    addRegexToken('ss', match1to2, match2);
    addParseToken(['s', 'ss'], SECOND);

    // MOMENTS

    var getSetSecond = makeGetSet('Seconds', false);

    // FORMATTING

    addFormatToken('S', 0, 0, function () {
        return ~~(this.millisecond() / 100);
    });

    addFormatToken(0, ['SS', 2], 0, function () {
        return ~~(this.millisecond() / 10);
    });

    addFormatToken(0, ['SSS', 3], 0, 'millisecond');
    addFormatToken(0, ['SSSS', 4], 0, function () {
        return this.millisecond() * 10;
    });
    addFormatToken(0, ['SSSSS', 5], 0, function () {
        return this.millisecond() * 100;
    });
    addFormatToken(0, ['SSSSSS', 6], 0, function () {
        return this.millisecond() * 1000;
    });
    addFormatToken(0, ['SSSSSSS', 7], 0, function () {
        return this.millisecond() * 10000;
    });
    addFormatToken(0, ['SSSSSSSS', 8], 0, function () {
        return this.millisecond() * 100000;
    });
    addFormatToken(0, ['SSSSSSSSS', 9], 0, function () {
        return this.millisecond() * 1000000;
    });

    // PARSING

    addRegexToken('S', match1to3, match1);
    addRegexToken('SS', match1to3, match2);
    addRegexToken('SSS', match1to3, match3);

    var token, getSetMillisecond;
    for (token = 'SSSS'; token.length <= 9; token += 'S') {
        addRegexToken(token, matchUnsigned);
    }

    function parseMs(input, array) {
        array[MILLISECOND] = toInt(('0.' + input) * 1000);
    }

    for (token = 'S'; token.length <= 9; token += 'S') {
        addParseToken(token, parseMs);
    }

    getSetMillisecond = makeGetSet('Milliseconds', false);

    // FORMATTING

    addFormatToken('z', 0, 0, 'zoneAbbr');
    addFormatToken('zz', 0, 0, 'zoneName');

    // MOMENTS

    function getZoneAbbr() {
        return this._isUTC ? 'UTC' : '';
    }

    function getZoneName() {
        return this._isUTC ? 'Coordinated Universal Time' : '';
    }

    var proto = Moment.prototype;

    proto.add = add;
    proto.calendar = calendar$1;
    proto.clone = clone;
    proto.diff = diff;
    proto.endOf = endOf;
    proto.format = format;
    proto.from = from;
    proto.fromNow = fromNow;
    proto.to = to;
    proto.toNow = toNow;
    proto.get = stringGet;
    proto.invalidAt = invalidAt;
    proto.isAfter = isAfter;
    proto.isBefore = isBefore;
    proto.isBetween = isBetween;
    proto.isSame = isSame;
    proto.isSameOrAfter = isSameOrAfter;
    proto.isSameOrBefore = isSameOrBefore;
    proto.isValid = isValid$2;
    proto.lang = lang;
    proto.locale = locale;
    proto.localeData = localeData;
    proto.max = prototypeMax;
    proto.min = prototypeMin;
    proto.parsingFlags = parsingFlags;
    proto.set = stringSet;
    proto.startOf = startOf;
    proto.subtract = subtract;
    proto.toArray = toArray;
    proto.toObject = toObject;
    proto.toDate = toDate;
    proto.toISOString = toISOString;
    proto.inspect = inspect;
    if (typeof Symbol !== 'undefined' && Symbol.for != null) {
        proto[Symbol.for('nodejs.util.inspect.custom')] = function () {
            return 'Moment<' + this.format() + '>';
        };
    }
    proto.toJSON = toJSON;
    proto.toString = toString;
    proto.unix = unix;
    proto.valueOf = valueOf;
    proto.creationData = creationData;
    proto.eraName = getEraName;
    proto.eraNarrow = getEraNarrow;
    proto.eraAbbr = getEraAbbr;
    proto.eraYear = getEraYear;
    proto.year = getSetYear;
    proto.isLeapYear = getIsLeapYear;
    proto.weekYear = getSetWeekYear;
    proto.isoWeekYear = getSetISOWeekYear;
    proto.quarter = proto.quarters = getSetQuarter;
    proto.month = getSetMonth;
    proto.daysInMonth = getDaysInMonth;
    proto.week = proto.weeks = getSetWeek;
    proto.isoWeek = proto.isoWeeks = getSetISOWeek;
    proto.weeksInYear = getWeeksInYear;
    proto.weeksInWeekYear = getWeeksInWeekYear;
    proto.isoWeeksInYear = getISOWeeksInYear;
    proto.isoWeeksInISOWeekYear = getISOWeeksInISOWeekYear;
    proto.date = getSetDayOfMonth;
    proto.day = proto.days = getSetDayOfWeek;
    proto.weekday = getSetLocaleDayOfWeek;
    proto.isoWeekday = getSetISODayOfWeek;
    proto.dayOfYear = getSetDayOfYear;
    proto.hour = proto.hours = getSetHour;
    proto.minute = proto.minutes = getSetMinute;
    proto.second = proto.seconds = getSetSecond;
    proto.millisecond = proto.milliseconds = getSetMillisecond;
    proto.utcOffset = getSetOffset;
    proto.utc = setOffsetToUTC;
    proto.local = setOffsetToLocal;
    proto.parseZone = setOffsetToParsedOffset;
    proto.hasAlignedHourOffset = hasAlignedHourOffset;
    proto.isDST = isDaylightSavingTime;
    proto.isLocal = isLocal;
    proto.isUtcOffset = isUtcOffset;
    proto.isUtc = isUtc;
    proto.isUTC = isUtc;
    proto.zoneAbbr = getZoneAbbr;
    proto.zoneName = getZoneName;
    proto.dates = deprecate(
        'dates accessor is deprecated. Use date instead.',
        getSetDayOfMonth
    );
    proto.months = deprecate(
        'months accessor is deprecated. Use month instead',
        getSetMonth
    );
    proto.years = deprecate(
        'years accessor is deprecated. Use year instead',
        getSetYear
    );
    proto.zone = deprecate(
        'moment().zone is deprecated, use moment().utcOffset instead. http://momentjs.com/guides/#/warnings/zone/',
        getSetZone
    );
    proto.isDSTShifted = deprecate(
        'isDSTShifted is deprecated. See http://momentjs.com/guides/#/warnings/dst-shifted/ for more information',
        isDaylightSavingTimeShifted
    );

    function createUnix(input) {
        return createLocal(input * 1000);
    }

    function createInZone() {
        return createLocal.apply(null, arguments).parseZone();
    }

    function preParsePostFormat(string) {
        return string;
    }

    var proto$1 = Locale.prototype;

    proto$1.calendar = calendar;
    proto$1.longDateFormat = longDateFormat;
    proto$1.invalidDate = invalidDate;
    proto$1.ordinal = ordinal;
    proto$1.preparse = preParsePostFormat;
    proto$1.postformat = preParsePostFormat;
    proto$1.relativeTime = relativeTime;
    proto$1.pastFuture = pastFuture;
    proto$1.set = set;
    proto$1.eras = localeEras;
    proto$1.erasParse = localeErasParse;
    proto$1.erasConvertYear = localeErasConvertYear;
    proto$1.erasAbbrRegex = erasAbbrRegex;
    proto$1.erasNameRegex = erasNameRegex;
    proto$1.erasNarrowRegex = erasNarrowRegex;

    proto$1.months = localeMonths;
    proto$1.monthsShort = localeMonthsShort;
    proto$1.monthsParse = localeMonthsParse;
    proto$1.monthsRegex = monthsRegex;
    proto$1.monthsShortRegex = monthsShortRegex;
    proto$1.week = localeWeek;
    proto$1.firstDayOfYear = localeFirstDayOfYear;
    proto$1.firstDayOfWeek = localeFirstDayOfWeek;

    proto$1.weekdays = localeWeekdays;
    proto$1.weekdaysMin = localeWeekdaysMin;
    proto$1.weekdaysShort = localeWeekdaysShort;
    proto$1.weekdaysParse = localeWeekdaysParse;

    proto$1.weekdaysRegex = weekdaysRegex;
    proto$1.weekdaysShortRegex = weekdaysShortRegex;
    proto$1.weekdaysMinRegex = weekdaysMinRegex;

    proto$1.isPM = localeIsPM;
    proto$1.meridiem = localeMeridiem;

    function get$1(format, index, field, setter) {
        var locale = getLocale(),
            utc = createUTC().set(setter, index);
        return locale[field](utc, format);
    }

    function listMonthsImpl(format, index, field) {
        if (isNumber(format)) {
            index = format;
            format = undefined;
        }

        format = format || '';

        if (index != null) {
            return get$1(format, index, field, 'month');
        }

        var i,
            out = [];
        for (i = 0; i < 12; i++) {
            out[i] = get$1(format, i, field, 'month');
        }
        return out;
    }

    // ()
    // (5)
    // (fmt, 5)
    // (fmt)
    // (true)
    // (true, 5)
    // (true, fmt, 5)
    // (true, fmt)
    function listWeekdaysImpl(localeSorted, format, index, field) {
        if (typeof localeSorted === 'boolean') {
            if (isNumber(format)) {
                index = format;
                format = undefined;
            }

            format = format || '';
        } else {
            format = localeSorted;
            index = format;
            localeSorted = false;

            if (isNumber(format)) {
                index = format;
                format = undefined;
            }

            format = format || '';
        }

        var locale = getLocale(),
            shift = localeSorted ? locale._week.dow : 0,
            i,
            out = [];

        if (index != null) {
            return get$1(format, (index + shift) % 7, field, 'day');
        }

        for (i = 0; i < 7; i++) {
            out[i] = get$1(format, (i + shift) % 7, field, 'day');
        }
        return out;
    }

    function listMonths(format, index) {
        return listMonthsImpl(format, index, 'months');
    }

    function listMonthsShort(format, index) {
        return listMonthsImpl(format, index, 'monthsShort');
    }

    function listWeekdays(localeSorted, format, index) {
        return listWeekdaysImpl(localeSorted, format, index, 'weekdays');
    }

    function listWeekdaysShort(localeSorted, format, index) {
        return listWeekdaysImpl(localeSorted, format, index, 'weekdaysShort');
    }

    function listWeekdaysMin(localeSorted, format, index) {
        return listWeekdaysImpl(localeSorted, format, index, 'weekdaysMin');
    }

    getSetGlobalLocale('en', {
        eras: [
            {
                since: '0001-01-01',
                until: +Infinity,
                offset: 1,
                name: 'Anno Domini',
                narrow: 'AD',
                abbr: 'AD',
            },
            {
                since: '0000-12-31',
                until: -Infinity,
                offset: 1,
                name: 'Before Christ',
                narrow: 'BC',
                abbr: 'BC',
            },
        ],
        dayOfMonthOrdinalParse: /\d{1,2}(th|st|nd|rd)/,
        ordinal: function (number) {
            var b = number % 10,
                output =
                    toInt((number % 100) / 10) === 1
                        ? 'th'
                        : b === 1
                          ? 'st'
                          : b === 2
                            ? 'nd'
                            : b === 3
                              ? 'rd'
                              : 'th';
            return number + output;
        },
    });

    // Side effect imports

    hooks.lang = deprecate(
        'moment.lang is deprecated. Use moment.locale instead.',
        getSetGlobalLocale
    );
    hooks.langData = deprecate(
        'moment.langData is deprecated. Use moment.localeData instead.',
        getLocale
    );

    var mathAbs = Math.abs;

    function abs() {
        var data = this._data;

        this._milliseconds = mathAbs(this._milliseconds);
        this._days = mathAbs(this._days);
        this._months = mathAbs(this._months);

        data.milliseconds = mathAbs(data.milliseconds);
        data.seconds = mathAbs(data.seconds);
        data.minutes = mathAbs(data.minutes);
        data.hours = mathAbs(data.hours);
        data.months = mathAbs(data.months);
        data.years = mathAbs(data.years);

        return this;
    }

    function addSubtract$1(duration, input, value, direction) {
        var other = createDuration(input, value);

        duration._milliseconds += direction * other._milliseconds;
        duration._days += direction * other._days;
        duration._months += direction * other._months;

        return duration._bubble();
    }

    // supports only 2.0-style add(1, 's') or add(duration)
    function add$1(input, value) {
        return addSubtract$1(this, input, value, 1);
    }

    // supports only 2.0-style subtract(1, 's') or subtract(duration)
    function subtract$1(input, value) {
        return addSubtract$1(this, input, value, -1);
    }

    function absCeil(number) {
        if (number < 0) {
            return Math.floor(number);
        } else {
            return Math.ceil(number);
        }
    }

    function bubble() {
        var milliseconds = this._milliseconds,
            days = this._days,
            months = this._months,
            data = this._data,
            seconds,
            minutes,
            hours,
            years,
            monthsFromDays;

        // if we have a mix of positive and negative values, bubble down first
        // check: https://github.com/moment/moment/issues/2166
        if (
            !(
                (milliseconds >= 0 && days >= 0 && months >= 0) ||
                (milliseconds <= 0 && days <= 0 && months <= 0)
            )
        ) {
            milliseconds += absCeil(monthsToDays(months) + days) * 864e5;
            days = 0;
            months = 0;
        }

        // The following code bubbles up values, see the tests for
        // examples of what that means.
        data.milliseconds = milliseconds % 1000;

        seconds = absFloor(milliseconds / 1000);
        data.seconds = seconds % 60;

        minutes = absFloor(seconds / 60);
        data.minutes = minutes % 60;

        hours = absFloor(minutes / 60);
        data.hours = hours % 24;

        days += absFloor(hours / 24);

        // convert days to months
        monthsFromDays = absFloor(daysToMonths(days));
        months += monthsFromDays;
        days -= absCeil(monthsToDays(monthsFromDays));

        // 12 months -> 1 year
        years = absFloor(months / 12);
        months %= 12;

        data.days = days;
        data.months = months;
        data.years = years;

        return this;
    }

    function daysToMonths(days) {
        // 400 years have 146097 days (taking into account leap year rules)
        // 400 years have 12 months === 4800
        return (days * 4800) / 146097;
    }

    function monthsToDays(months) {
        // the reverse of daysToMonths
        return (months * 146097) / 4800;
    }

    function as(units) {
        if (!this.isValid()) {
            return NaN;
        }
        var days,
            months,
            milliseconds = this._milliseconds;

        units = normalizeUnits(units);

        if (units === 'month' || units === 'quarter' || units === 'year') {
            days = this._days + milliseconds / 864e5;
            months = this._months + daysToMonths(days);
            switch (units) {
                case 'month':
                    return months;
                case 'quarter':
                    return months / 3;
                case 'year':
                    return months / 12;
            }
        } else {
            // handle milliseconds separately because of floating point math errors (issue #1867)
            days = this._days + Math.round(monthsToDays(this._months));
            switch (units) {
                case 'week':
                    return days / 7 + milliseconds / 6048e5;
                case 'day':
                    return days + milliseconds / 864e5;
                case 'hour':
                    return days * 24 + milliseconds / 36e5;
                case 'minute':
                    return days * 1440 + milliseconds / 6e4;
                case 'second':
                    return days * 86400 + milliseconds / 1000;
                // Math.floor prevents floating point math errors here
                case 'millisecond':
                    return Math.floor(days * 864e5) + milliseconds;
                default:
                    throw new Error('Unknown unit ' + units);
            }
        }
    }

    function makeAs(alias) {
        return function () {
            return this.as(alias);
        };
    }

    var asMilliseconds = makeAs('ms'),
        asSeconds = makeAs('s'),
        asMinutes = makeAs('m'),
        asHours = makeAs('h'),
        asDays = makeAs('d'),
        asWeeks = makeAs('w'),
        asMonths = makeAs('M'),
        asQuarters = makeAs('Q'),
        asYears = makeAs('y'),
        valueOf$1 = asMilliseconds;

    function clone$1() {
        return createDuration(this);
    }

    function get$2(units) {
        units = normalizeUnits(units);
        return this.isValid() ? this[units + 's']() : NaN;
    }

    function makeGetter(name) {
        return function () {
            return this.isValid() ? this._data[name] : NaN;
        };
    }

    var milliseconds = makeGetter('milliseconds'),
        seconds = makeGetter('seconds'),
        minutes = makeGetter('minutes'),
        hours = makeGetter('hours'),
        days = makeGetter('days'),
        months = makeGetter('months'),
        years = makeGetter('years');

    function weeks() {
        return absFloor(this.days() / 7);
    }

    var round = Math.round,
        thresholds = {
            ss: 44, // a few seconds to seconds
            s: 45, // seconds to minute
            m: 45, // minutes to hour
            h: 22, // hours to day
            d: 26, // days to month/week
            w: null, // weeks to month
            M: 11, // months to year
        };

    // helper function for moment.fn.from, moment.fn.fromNow, and moment.duration.fn.humanize
    function substituteTimeAgo(string, number, withoutSuffix, isFuture, locale) {
        return locale.relativeTime(number || 1, !!withoutSuffix, string, isFuture);
    }

    function relativeTime$1(posNegDuration, withoutSuffix, thresholds, locale) {
        var duration = createDuration(posNegDuration).abs(),
            seconds = round(duration.as('s')),
            minutes = round(duration.as('m')),
            hours = round(duration.as('h')),
            days = round(duration.as('d')),
            months = round(duration.as('M')),
            weeks = round(duration.as('w')),
            years = round(duration.as('y')),
            a =
                (seconds <= thresholds.ss && ['s', seconds]) ||
                (seconds < thresholds.s && ['ss', seconds]) ||
                (minutes <= 1 && ['m']) ||
                (minutes < thresholds.m && ['mm', minutes]) ||
                (hours <= 1 && ['h']) ||
                (hours < thresholds.h && ['hh', hours]) ||
                (days <= 1 && ['d']) ||
                (days < thresholds.d && ['dd', days]);

        if (thresholds.w != null) {
            a =
                a ||
                (weeks <= 1 && ['w']) ||
                (weeks < thresholds.w && ['ww', weeks]);
        }
        a = a ||
            (months <= 1 && ['M']) ||
            (months < thresholds.M && ['MM', months]) ||
            (years <= 1 && ['y']) || ['yy', years];

        a[2] = withoutSuffix;
        a[3] = +posNegDuration > 0;
        a[4] = locale;
        return substituteTimeAgo.apply(null, a);
    }

    // This function allows you to set the rounding function for relative time strings
    function getSetRelativeTimeRounding(roundingFunction) {
        if (roundingFunction === undefined) {
            return round;
        }
        if (typeof roundingFunction === 'function') {
            round = roundingFunction;
            return true;
        }
        return false;
    }

    // This function allows you to set a threshold for relative time strings
    function getSetRelativeTimeThreshold(threshold, limit) {
        if (thresholds[threshold] === undefined) {
            return false;
        }
        if (limit === undefined) {
            return thresholds[threshold];
        }
        thresholds[threshold] = limit;
        if (threshold === 's') {
            thresholds.ss = limit - 1;
        }
        return true;
    }

    function humanize(argWithSuffix, argThresholds) {
        if (!this.isValid()) {
            return this.localeData().invalidDate();
        }

        var withSuffix = false,
            th = thresholds,
            locale,
            output;

        if (typeof argWithSuffix === 'object') {
            argThresholds = argWithSuffix;
            argWithSuffix = false;
        }
        if (typeof argWithSuffix === 'boolean') {
            withSuffix = argWithSuffix;
        }
        if (typeof argThresholds === 'object') {
            th = Object.assign({}, thresholds, argThresholds);
            if (argThresholds.s != null && argThresholds.ss == null) {
                th.ss = argThresholds.s - 1;
            }
        }

        locale = this.localeData();
        output = relativeTime$1(this, !withSuffix, th, locale);

        if (withSuffix) {
            output = locale.pastFuture(+this, output);
        }

        return locale.postformat(output);
    }

    var abs$1 = Math.abs;

    function sign(x) {
        return (x > 0) - (x < 0) || +x;
    }

    function toISOString$1() {
        // for ISO strings we do not use the normal bubbling rules:
        //  * milliseconds bubble up until they become hours
        //  * days do not bubble at all
        //  * months bubble up until they become years
        // This is because there is no context-free conversion between hours and days
        // (think of clock changes)
        // and also not between days and months (28-31 days per month)
        if (!this.isValid()) {
            return this.localeData().invalidDate();
        }

        var seconds = abs$1(this._milliseconds) / 1000,
            days = abs$1(this._days),
            months = abs$1(this._months),
            minutes,
            hours,
            years,
            s,
            total = this.asSeconds(),
            totalSign,
            ymSign,
            daysSign,
            hmsSign;

        if (!total) {
            // this is the same as C#'s (Noda) and python (isodate)...
            // but not other JS (goog.date)
            return 'P0D';
        }

        // 3600 seconds -> 60 minutes -> 1 hour
        minutes = absFloor(seconds / 60);
        hours = absFloor(minutes / 60);
        seconds %= 60;
        minutes %= 60;

        // 12 months -> 1 year
        years = absFloor(months / 12);
        months %= 12;

        // inspired by https://github.com/dordille/moment-isoduration/blob/master/moment.isoduration.js
        s = seconds ? seconds.toFixed(3).replace(/\.?0+$/, '') : '';

        totalSign = total < 0 ? '-' : '';
        ymSign = sign(this._months) !== sign(total) ? '-' : '';
        daysSign = sign(this._days) !== sign(total) ? '-' : '';
        hmsSign = sign(this._milliseconds) !== sign(total) ? '-' : '';

        return (
            totalSign +
            'P' +
            (years ? ymSign + years + 'Y' : '') +
            (months ? ymSign + months + 'M' : '') +
            (days ? daysSign + days + 'D' : '') +
            (hours || minutes || seconds ? 'T' : '') +
            (hours ? hmsSign + hours + 'H' : '') +
            (minutes ? hmsSign + minutes + 'M' : '') +
            (seconds ? hmsSign + s + 'S' : '')
        );
    }

    var proto$2 = Duration.prototype;

    proto$2.isValid = isValid$1;
    proto$2.abs = abs;
    proto$2.add = add$1;
    proto$2.subtract = subtract$1;
    proto$2.as = as;
    proto$2.asMilliseconds = asMilliseconds;
    proto$2.asSeconds = asSeconds;
    proto$2.asMinutes = asMinutes;
    proto$2.asHours = asHours;
    proto$2.asDays = asDays;
    proto$2.asWeeks = asWeeks;
    proto$2.asMonths = asMonths;
    proto$2.asQuarters = asQuarters;
    proto$2.asYears = asYears;
    proto$2.valueOf = valueOf$1;
    proto$2._bubble = bubble;
    proto$2.clone = clone$1;
    proto$2.get = get$2;
    proto$2.milliseconds = milliseconds;
    proto$2.seconds = seconds;
    proto$2.minutes = minutes;
    proto$2.hours = hours;
    proto$2.days = days;
    proto$2.weeks = weeks;
    proto$2.months = months;
    proto$2.years = years;
    proto$2.humanize = humanize;
    proto$2.toISOString = toISOString$1;
    proto$2.toString = toISOString$1;
    proto$2.toJSON = toISOString$1;
    proto$2.locale = locale;
    proto$2.localeData = localeData;

    proto$2.toIsoString = deprecate(
        'toIsoString() is deprecated. Please use toISOString() instead (notice the capitals)',
        toISOString$1
    );
    proto$2.lang = lang;

    // FORMATTING

    addFormatToken('X', 0, 0, 'unix');
    addFormatToken('x', 0, 0, 'valueOf');

    // PARSING

    addRegexToken('x', matchSigned);
    addRegexToken('X', matchTimestamp);
    addParseToken('X', function (input, array, config) {
        config._d = new Date(parseFloat(input) * 1000);
    });
    addParseToken('x', function (input, array, config) {
        config._d = new Date(toInt(input));
    });

    //! moment.js

    hooks.version = '2.30.1';

    setHookCallback(createLocal);

    hooks.fn = proto;
    hooks.min = min;
    hooks.max = max;
    hooks.now = now;
    hooks.utc = createUTC;
    hooks.unix = createUnix;
    hooks.months = listMonths;
    hooks.isDate = isDate;
    hooks.locale = getSetGlobalLocale;
    hooks.invalid = createInvalid;
    hooks.duration = createDuration;
    hooks.isMoment = isMoment;
    hooks.weekdays = listWeekdays;
    hooks.parseZone = createInZone;
    hooks.localeData = getLocale;
    hooks.isDuration = isDuration;
    hooks.monthsShort = listMonthsShort;
    hooks.weekdaysMin = listWeekdaysMin;
    hooks.defineLocale = defineLocale;
    hooks.updateLocale = updateLocale;
    hooks.locales = listLocales;
    hooks.weekdaysShort = listWeekdaysShort;
    hooks.normalizeUnits = normalizeUnits;
    hooks.relativeTimeRounding = getSetRelativeTimeRounding;
    hooks.relativeTimeThreshold = getSetRelativeTimeThreshold;
    hooks.calendarFormat = getCalendarFormat;
    hooks.prototype = proto;

    // currently HTML5 input type only supports 24-hour formats
    hooks.HTML5_FMT = {
        DATETIME_LOCAL: 'YYYY-MM-DDTHH:mm', // <input type="datetime-local" />
        DATETIME_LOCAL_SECONDS: 'YYYY-MM-DDTHH:mm:ss', // <input type="datetime-local" step="1" />
        DATETIME_LOCAL_MS: 'YYYY-MM-DDTHH:mm:ss.SSS', // <input type="datetime-local" step="0.001" />
        DATE: 'YYYY-MM-DD', // <input type="date" />
        TIME: 'HH:mm', // <input type="time" />
        TIME_SECONDS: 'HH:mm:ss', // <input type="time" step="1" />
        TIME_MS: 'HH:mm:ss.SSS', // <input type="time" step="0.001" />
        WEEK: 'GGGG-[W]WW', // <input type="week" />
        MONTH: 'YYYY-MM', // <input type="month" />
    };

    return hooks;

})));


/***/ }),

/***/ 93378:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "cC": function() { return /* reexport */ Trans; },
  "Jc": function() { return /* reexport */ appWithTranslation; },
  "ag": function() { return /* reexport */ globalI18n; },
  "$G": function() { return /* reexport */ useTranslation; },
  "Zh": function() { return /* reexport */ withTranslation; }
});

// UNUSED EXPORTS: I18nContext

;// CONCATENATED MODULE: ./node_modules/react-i18next/node_modules/@babel/runtime/helpers/esm/objectWithoutPropertiesLoose.js
function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;
  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }
  return target;
}
;// CONCATENATED MODULE: ./node_modules/react-i18next/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};
  var target = _objectWithoutPropertiesLoose(source, excluded);
  var key, i;
  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }
  return target;
}
;// CONCATENATED MODULE: ./node_modules/react-i18next/node_modules/@babel/runtime/helpers/esm/typeof.js
function _typeof(obj) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) {
    return typeof obj;
  } : function (obj) {
    return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
  }, _typeof(obj);
}
;// CONCATENATED MODULE: ./node_modules/react-i18next/node_modules/@babel/runtime/helpers/esm/defineProperty.js
function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/react/index.js
var react = __webpack_require__(55784);
// EXTERNAL MODULE: ./node_modules/void-elements/index.js
var void_elements = __webpack_require__(71739);
var void_elements_default = /*#__PURE__*/__webpack_require__.n(void_elements);
;// CONCATENATED MODULE: ./node_modules/html-parse-stringify/dist/html-parse-stringify.module.js
var t=/\s([^'"/\s><]+?)[\s/>]|([^\s=]+)=\s?(".*?"|'.*?')/g;function n(n){var r={type:"tag",name:"",voidElement:!1,attrs:{},children:[]},i=n.match(/<\/?([^\s]+?)[/\s>]/);if(i&&(r.name=i[1],((void_elements_default())[i[1]]||"/"===n.charAt(n.length-2))&&(r.voidElement=!0),r.name.startsWith("!--"))){var s=n.indexOf("--\x3e");return{type:"comment",comment:-1!==s?n.slice(4,s):""}}for(var a=new RegExp(t),c=null;null!==(c=a.exec(n));)if(c[0].trim())if(c[1]){var o=c[1].trim(),l=[o,""];o.indexOf("=")>-1&&(l=o.split("=")),r.attrs[l[0]]=l[1],a.lastIndex--}else c[2]&&(r.attrs[c[2]]=c[3].trim().substring(1,c[3].length-1));return r}var r=/<[a-zA-Z0-9\-\!\/](?:"[^"]*"|'[^']*'|[^'">])*>/g,i=/^\s*$/,s=Object.create(null);function a(e,t){switch(t.type){case"text":return e+t.content;case"tag":return e+="<"+t.name+(t.attrs?function(e){var t=[];for(var n in e)t.push(n+'="'+e[n]+'"');return t.length?" "+t.join(" "):""}(t.attrs):"")+(t.voidElement?"/>":">"),t.voidElement?e:e+t.children.reduce(a,"")+"</"+t.name+">";case"comment":return e+"\x3c!--"+t.comment+"--\x3e"}}var c={parse:function(e,t){t||(t={}),t.components||(t.components=s);var a,c=[],o=[],l=-1,m=!1;if(0!==e.indexOf("<")){var u=e.indexOf("<");c.push({type:"text",content:-1===u?e:e.substring(0,u)})}return e.replace(r,function(r,s){if(m){if(r!=="</"+a.name+">")return;m=!1}var u,f="/"!==r.charAt(1),h=r.startsWith("\x3c!--"),p=s+r.length,d=e.charAt(p);if(h){var v=n(r);return l<0?(c.push(v),c):((u=o[l]).children.push(v),c)}if(f&&(l++,"tag"===(a=n(r)).type&&t.components[a.name]&&(a.type="component",m=!0),a.voidElement||m||!d||"<"===d||a.children.push({type:"text",content:e.slice(p,e.indexOf("<",p))}),0===l&&c.push(a),(u=o[l-1])&&u.children.push(a),o[l]=a),(!f||a.voidElement)&&(l>-1&&(a.voidElement||a.name===r.slice(2,-1))&&(l--,a=-1===l?c:o[l]),!m&&"<"!==d&&d)){u=-1===l?c:o[l].children;var x=e.indexOf("<",p),g=e.slice(p,-1===x?void 0:x);i.test(g)&&(g=" "),(x>-1&&l+u.length>=0||" "!==g)&&u.push({type:"text",content:g})}}),c},stringify:function(e){return e.reduce(function(e,t){return e+a("",t)},"")}};/* harmony default export */ var html_parse_stringify_module = (c);
//# sourceMappingURL=html-parse-stringify.module.js.map

;// CONCATENATED MODULE: ./node_modules/react-i18next/node_modules/@babel/runtime/helpers/esm/classCallCheck.js
function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
;// CONCATENATED MODULE: ./node_modules/react-i18next/node_modules/@babel/runtime/helpers/esm/createClass.js
function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}
function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  Object.defineProperty(Constructor, "prototype", {
    writable: false
  });
  return Constructor;
}
;// CONCATENATED MODULE: ./node_modules/react-i18next/dist/es/unescape.js
var matchHtmlEntity = /&(?:amp|#38|lt|#60|gt|#62|apos|#39|quot|#34|nbsp|#160|copy|#169|reg|#174|hellip|#8230|#x2F|#47);/g;
var htmlEntities = {
  '&amp;': '&',
  '&#38;': '&',
  '&lt;': '<',
  '&#60;': '<',
  '&gt;': '>',
  '&#62;': '>',
  '&apos;': "'",
  '&#39;': "'",
  '&quot;': '"',
  '&#34;': '"',
  '&nbsp;': ' ',
  '&#160;': ' ',
  '&copy;': '©',
  '&#169;': '©',
  '&reg;': '®',
  '&#174;': '®',
  '&hellip;': '…',
  '&#8230;': '…',
  '&#x2F;': '/',
  '&#47;': '/'
};

var unescapeHtmlEntity = function unescapeHtmlEntity(m) {
  return htmlEntities[m];
};

var unescape_unescape = function unescape(text) {
  return text.replace(matchHtmlEntity, unescapeHtmlEntity);
};
;// CONCATENATED MODULE: ./node_modules/react-i18next/dist/es/context.js




function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }



var defaultOptions = {
  bindI18n: 'languageChanged',
  bindI18nStore: '',
  transEmptyNodeValue: '',
  transSupportBasicHtmlNodes: true,
  transWrapTextNodes: '',
  transKeepBasicHtmlNodesFor: ['br', 'strong', 'i', 'p'],
  useSuspense: true,
  unescape: unescape_unescape
};
var i18nInstance;
var I18nContext = (0,react.createContext)();
function setDefaults() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  defaultOptions = _objectSpread(_objectSpread({}, defaultOptions), options);
}
function getDefaults() {
  return defaultOptions;
}
var ReportNamespaces = function () {
  function ReportNamespaces() {
    _classCallCheck(this, ReportNamespaces);

    this.usedNamespaces = {};
  }

  _createClass(ReportNamespaces, [{
    key: "addUsedNamespaces",
    value: function addUsedNamespaces(namespaces) {
      var _this = this;

      namespaces.forEach(function (ns) {
        if (!_this.usedNamespaces[ns]) _this.usedNamespaces[ns] = true;
      });
    }
  }, {
    key: "getUsedNamespaces",
    value: function getUsedNamespaces() {
      return Object.keys(this.usedNamespaces);
    }
  }]);

  return ReportNamespaces;
}();
function setI18n(instance) {
  i18nInstance = instance;
}
function getI18n() {
  return i18nInstance;
}
var initReactI18next = {
  type: '3rdParty',
  init: function init(instance) {
    setDefaults(instance.options.react);
    setI18n(instance);
  }
};
function composeInitialProps(ForComponent) {
  return function (ctx) {
    return new Promise(function (resolve) {
      var i18nInitialProps = getInitialProps();

      if (ForComponent.getInitialProps) {
        ForComponent.getInitialProps(ctx).then(function (componentsInitialProps) {
          resolve(_objectSpread(_objectSpread({}, componentsInitialProps), i18nInitialProps));
        });
      } else {
        resolve(i18nInitialProps);
      }
    });
  };
}
function getInitialProps() {
  var i18n = getI18n();
  var namespaces = i18n.reportNamespaces ? i18n.reportNamespaces.getUsedNamespaces() : [];
  var ret = {};
  var initialI18nStore = {};
  i18n.languages.forEach(function (l) {
    initialI18nStore[l] = {};
    namespaces.forEach(function (ns) {
      initialI18nStore[l][ns] = i18n.getResourceBundle(l, ns) || {};
    });
  });
  ret.initialI18nStore = initialI18nStore;
  ret.initialLanguage = i18n.language;
  return ret;
}
;// CONCATENATED MODULE: ./node_modules/react-i18next/dist/es/utils.js
function warn() {
  if (console && console.warn) {
    var _console;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    if (typeof args[0] === 'string') args[0] = "react-i18next:: ".concat(args[0]);

    (_console = console).warn.apply(_console, args);
  }
}
var alreadyWarned = {};
function warnOnce() {
  for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
    args[_key2] = arguments[_key2];
  }

  if (typeof args[0] === 'string' && alreadyWarned[args[0]]) return;
  if (typeof args[0] === 'string') alreadyWarned[args[0]] = new Date();
  warn.apply(void 0, args);
}
function loadNamespaces(i18n, ns, cb) {
  i18n.loadNamespaces(ns, function () {
    if (i18n.isInitialized) {
      cb();
    } else {
      var initialized = function initialized() {
        setTimeout(function () {
          i18n.off('initialized', initialized);
        }, 0);
        cb();
      };

      i18n.on('initialized', initialized);
    }
  });
}

function oldI18nextHasLoadedNamespace(ns, i18n) {
  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  var lng = i18n.languages[0];
  var fallbackLng = i18n.options ? i18n.options.fallbackLng : false;
  var lastLng = i18n.languages[i18n.languages.length - 1];
  if (lng.toLowerCase() === 'cimode') return true;

  var loadNotPending = function loadNotPending(l, n) {
    var loadState = i18n.services.backendConnector.state["".concat(l, "|").concat(n)];
    return loadState === -1 || loadState === 2;
  };

  if (options.bindI18n && options.bindI18n.indexOf('languageChanging') > -1 && i18n.services.backendConnector.backend && i18n.isLanguageChangingTo && !loadNotPending(i18n.isLanguageChangingTo, ns)) return false;
  if (i18n.hasResourceBundle(lng, ns)) return true;
  if (!i18n.services.backendConnector.backend || i18n.options.resources && !i18n.options.partialBundledLanguages) return true;
  if (loadNotPending(lng, ns) && (!fallbackLng || loadNotPending(lastLng, ns))) return true;
  return false;
}

function hasLoadedNamespace(ns, i18n) {
  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

  if (!i18n.languages || !i18n.languages.length) {
    warnOnce('i18n.languages were undefined or empty', i18n.languages);
    return true;
  }

  var isNewerI18next = i18n.options.ignoreJSONStructure !== undefined;

  if (!isNewerI18next) {
    return oldI18nextHasLoadedNamespace(ns, i18n, options);
  }

  return i18n.hasLoadedNamespace(ns, {
    precheck: function precheck(i18nInstance, loadNotPending) {
      if (options.bindI18n && options.bindI18n.indexOf('languageChanging') > -1 && i18nInstance.services.backendConnector.backend && i18nInstance.isLanguageChangingTo && !loadNotPending(i18nInstance.isLanguageChangingTo, ns)) return false;
    }
  });
}
function getDisplayName(Component) {
  return Component.displayName || Component.name || (typeof Component === 'string' && Component.length > 0 ? Component : 'Unknown');
}
;// CONCATENATED MODULE: ./node_modules/react-i18next/dist/es/Trans.js



var _excluded = ["format"],
    _excluded2 = ["children", "count", "parent", "i18nKey", "context", "tOptions", "values", "defaults", "components", "ns", "i18n", "t", "shouldUnescape"];

function Trans_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function Trans_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { Trans_ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { Trans_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }






function hasChildren(node, checkLength) {
  if (!node) return false;
  var base = node.props ? node.props.children : node.children;
  if (checkLength) return base.length > 0;
  return !!base;
}

function getChildren(node) {
  if (!node) return [];
  return node.props ? node.props.children : node.children;
}

function hasValidReactChildren(children) {
  if (Object.prototype.toString.call(children) !== '[object Array]') return false;
  return children.every(function (child) {
    return (0,react.isValidElement)(child);
  });
}

function getAsArray(data) {
  return Array.isArray(data) ? data : [data];
}

function mergeProps(source, target) {
  var newTarget = Trans_objectSpread({}, target);

  newTarget.props = Object.assign(source.props, target.props);
  return newTarget;
}

function nodesToString(children, i18nOptions) {
  if (!children) return '';
  var stringNode = '';
  var childrenArray = getAsArray(children);
  var keepArray = i18nOptions.transSupportBasicHtmlNodes && i18nOptions.transKeepBasicHtmlNodesFor ? i18nOptions.transKeepBasicHtmlNodesFor : [];
  childrenArray.forEach(function (child, childIndex) {
    if (typeof child === 'string') {
      stringNode += "".concat(child);
    } else if ((0,react.isValidElement)(child)) {
      var childPropsCount = Object.keys(child.props).length;
      var shouldKeepChild = keepArray.indexOf(child.type) > -1;
      var childChildren = child.props.children;

      if (!childChildren && shouldKeepChild && childPropsCount === 0) {
        stringNode += "<".concat(child.type, "/>");
      } else if (!childChildren && (!shouldKeepChild || childPropsCount !== 0)) {
        stringNode += "<".concat(childIndex, "></").concat(childIndex, ">");
      } else if (child.props.i18nIsDynamicList) {
        stringNode += "<".concat(childIndex, "></").concat(childIndex, ">");
      } else if (shouldKeepChild && childPropsCount === 1 && typeof childChildren === 'string') {
        stringNode += "<".concat(child.type, ">").concat(childChildren, "</").concat(child.type, ">");
      } else {
        var content = nodesToString(childChildren, i18nOptions);
        stringNode += "<".concat(childIndex, ">").concat(content, "</").concat(childIndex, ">");
      }
    } else if (child === null) {
      warn("Trans: the passed in value is invalid - seems you passed in a null child.");
    } else if (_typeof(child) === 'object') {
      var format = child.format,
          clone = _objectWithoutProperties(child, _excluded);

      var keys = Object.keys(clone);

      if (keys.length === 1) {
        var value = format ? "".concat(keys[0], ", ").concat(format) : keys[0];
        stringNode += "{{".concat(value, "}}");
      } else {
        warn("react-i18next: the passed in object contained more than one variable - the object should look like {{ value, format }} where format is optional.", child);
      }
    } else {
      warn("Trans: the passed in value is invalid - seems you passed in a variable like {number} - please pass in variables for interpolation as full objects like {{number}}.", child);
    }
  });
  return stringNode;
}

function renderNodes(children, targetString, i18n, i18nOptions, combinedTOpts, shouldUnescape) {
  if (targetString === '') return [];
  var keepArray = i18nOptions.transKeepBasicHtmlNodesFor || [];
  var emptyChildrenButNeedsHandling = targetString && new RegExp(keepArray.join('|')).test(targetString);
  if (!children && !emptyChildrenButNeedsHandling) return [targetString];
  var data = {};

  function getData(childs) {
    var childrenArray = getAsArray(childs);
    childrenArray.forEach(function (child) {
      if (typeof child === 'string') return;
      if (hasChildren(child)) getData(getChildren(child));else if (_typeof(child) === 'object' && !(0,react.isValidElement)(child)) Object.assign(data, child);
    });
  }

  getData(children);
  var ast = html_parse_stringify_module.parse("<0>".concat(targetString, "</0>"));

  var opts = Trans_objectSpread(Trans_objectSpread({}, data), combinedTOpts);

  function renderInner(child, node, rootReactNode) {
    var childs = getChildren(child);
    var mappedChildren = mapAST(childs, node.children, rootReactNode);
    return hasValidReactChildren(childs) && mappedChildren.length === 0 ? childs : mappedChildren;
  }

  function pushTranslatedJSX(child, inner, mem, i, isVoid) {
    if (child.dummy) child.children = inner;
    mem.push((0,react.cloneElement)(child, Trans_objectSpread(Trans_objectSpread({}, child.props), {}, {
      key: i
    }), isVoid ? undefined : inner));
  }

  function mapAST(reactNode, astNode, rootReactNode) {
    var reactNodes = getAsArray(reactNode);
    var astNodes = getAsArray(astNode);
    return astNodes.reduce(function (mem, node, i) {
      var translationContent = node.children && node.children[0] && node.children[0].content && i18n.services.interpolator.interpolate(node.children[0].content, opts, i18n.language);

      if (node.type === 'tag') {
        var tmp = reactNodes[parseInt(node.name, 10)];
        if (!tmp && rootReactNode.length === 1 && rootReactNode[0][node.name]) tmp = rootReactNode[0][node.name];
        if (!tmp) tmp = {};
        var child = Object.keys(node.attrs).length !== 0 ? mergeProps({
          props: node.attrs
        }, tmp) : tmp;
        var isElement = (0,react.isValidElement)(child);
        var isValidTranslationWithChildren = isElement && hasChildren(node, true) && !node.voidElement;
        var isEmptyTransWithHTML = emptyChildrenButNeedsHandling && _typeof(child) === 'object' && child.dummy && !isElement;
        var isKnownComponent = _typeof(children) === 'object' && children !== null && Object.hasOwnProperty.call(children, node.name);

        if (typeof child === 'string') {
          var value = i18n.services.interpolator.interpolate(child, opts, i18n.language);
          mem.push(value);
        } else if (hasChildren(child) || isValidTranslationWithChildren) {
            var inner = renderInner(child, node, rootReactNode);
            pushTranslatedJSX(child, inner, mem, i);
          } else if (isEmptyTransWithHTML) {
          var _inner = mapAST(reactNodes, node.children, rootReactNode);

          mem.push((0,react.cloneElement)(child, Trans_objectSpread(Trans_objectSpread({}, child.props), {}, {
            key: i
          }), _inner));
        } else if (Number.isNaN(parseFloat(node.name))) {
          if (isKnownComponent) {
            var _inner2 = renderInner(child, node, rootReactNode);

            pushTranslatedJSX(child, _inner2, mem, i, node.voidElement);
          } else if (i18nOptions.transSupportBasicHtmlNodes && keepArray.indexOf(node.name) > -1) {
            if (node.voidElement) {
              mem.push((0,react.createElement)(node.name, {
                key: "".concat(node.name, "-").concat(i)
              }));
            } else {
              var _inner3 = mapAST(reactNodes, node.children, rootReactNode);

              mem.push((0,react.createElement)(node.name, {
                key: "".concat(node.name, "-").concat(i)
              }, _inner3));
            }
          } else if (node.voidElement) {
            mem.push("<".concat(node.name, " />"));
          } else {
            var _inner4 = mapAST(reactNodes, node.children, rootReactNode);

            mem.push("<".concat(node.name, ">").concat(_inner4, "</").concat(node.name, ">"));
          }
        } else if (_typeof(child) === 'object' && !isElement) {
          var content = node.children[0] ? translationContent : null;
          if (content) mem.push(content);
        } else if (node.children.length === 1 && translationContent) {
          mem.push((0,react.cloneElement)(child, Trans_objectSpread(Trans_objectSpread({}, child.props), {}, {
            key: i
          }), translationContent));
        } else {
          mem.push((0,react.cloneElement)(child, Trans_objectSpread(Trans_objectSpread({}, child.props), {}, {
            key: i
          })));
        }
      } else if (node.type === 'text') {
        var wrapTextNodes = i18nOptions.transWrapTextNodes;

        var _content = shouldUnescape ? i18nOptions.unescape(i18n.services.interpolator.interpolate(node.content, opts, i18n.language)) : i18n.services.interpolator.interpolate(node.content, opts, i18n.language);

        if (wrapTextNodes) {
          mem.push((0,react.createElement)(wrapTextNodes, {
            key: "".concat(node.name, "-").concat(i)
          }, _content));
        } else {
          mem.push(_content);
        }
      }

      return mem;
    }, []);
  }

  var result = mapAST([{
    dummy: true,
    children: children || []
  }], ast, getAsArray(children || []));
  return getChildren(result[0]);
}

function Trans(_ref) {
  var children = _ref.children,
      count = _ref.count,
      parent = _ref.parent,
      i18nKey = _ref.i18nKey,
      context = _ref.context,
      _ref$tOptions = _ref.tOptions,
      tOptions = _ref$tOptions === void 0 ? {} : _ref$tOptions,
      values = _ref.values,
      defaults = _ref.defaults,
      components = _ref.components,
      ns = _ref.ns,
      i18nFromProps = _ref.i18n,
      tFromProps = _ref.t,
      shouldUnescape = _ref.shouldUnescape,
      additionalProps = _objectWithoutProperties(_ref, _excluded2);

  var _ref2 = (0,react.useContext)(I18nContext) || {},
      i18nFromContext = _ref2.i18n,
      defaultNSFromContext = _ref2.defaultNS;

  var i18n = i18nFromProps || i18nFromContext || getI18n();

  if (!i18n) {
    warnOnce('You will need to pass in an i18next instance by using i18nextReactModule');
    return children;
  }

  var t = tFromProps || i18n.t.bind(i18n) || function (k) {
    return k;
  };

  if (context) tOptions.context = context;

  var reactI18nextOptions = Trans_objectSpread(Trans_objectSpread({}, getDefaults()), i18n.options && i18n.options.react);

  var namespaces = ns || t.ns || defaultNSFromContext || i18n.options && i18n.options.defaultNS;
  namespaces = typeof namespaces === 'string' ? [namespaces] : namespaces || ['translation'];
  var defaultValue = defaults || nodesToString(children, reactI18nextOptions) || reactI18nextOptions.transEmptyNodeValue || i18nKey;
  var hashTransKey = reactI18nextOptions.hashTransKey;
  var key = i18nKey || (hashTransKey ? hashTransKey(defaultValue) : defaultValue);
  var interpolationOverride = values ? tOptions.interpolation : {
    interpolation: Trans_objectSpread(Trans_objectSpread({}, tOptions.interpolation), {}, {
      prefix: '#$?',
      suffix: '?$#'
    })
  };

  var combinedTOpts = Trans_objectSpread(Trans_objectSpread(Trans_objectSpread(Trans_objectSpread({}, tOptions), {}, {
    count: count
  }, values), interpolationOverride), {}, {
    defaultValue: defaultValue,
    ns: namespaces
  });

  var translation = key ? t(key, combinedTOpts) : defaultValue;
  var content = renderNodes(components || children, translation, i18n, reactI18nextOptions, combinedTOpts, shouldUnescape);
  var useAsParent = parent !== undefined ? parent : reactI18nextOptions.defaultTransParent;
  return useAsParent ? (0,react.createElement)(useAsParent, additionalProps, content) : content;
}
;// CONCATENATED MODULE: ./node_modules/react-i18next/node_modules/@babel/runtime/helpers/esm/arrayWithHoles.js
function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}
;// CONCATENATED MODULE: ./node_modules/react-i18next/node_modules/@babel/runtime/helpers/esm/iterableToArrayLimit.js
function _iterableToArrayLimit(arr, i) {
  var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
  if (_i == null) return;
  var _arr = [];
  var _n = true;
  var _d = false;
  var _s, _e;
  try {
    for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);
      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }
  return _arr;
}
;// CONCATENATED MODULE: ./node_modules/react-i18next/node_modules/@babel/runtime/helpers/esm/arrayLikeToArray.js
function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;
  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }
  return arr2;
}
;// CONCATENATED MODULE: ./node_modules/react-i18next/node_modules/@babel/runtime/helpers/esm/unsupportedIterableToArray.js

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
;// CONCATENATED MODULE: ./node_modules/react-i18next/node_modules/@babel/runtime/helpers/esm/nonIterableRest.js
function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
;// CONCATENATED MODULE: ./node_modules/react-i18next/node_modules/@babel/runtime/helpers/esm/slicedToArray.js




function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
;// CONCATENATED MODULE: ./node_modules/react-i18next/dist/es/useTranslation.js



function useTranslation_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function useTranslation_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { useTranslation_ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { useTranslation_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }





var usePrevious = function usePrevious(value, ignore) {
  var ref = (0,react.useRef)();
  (0,react.useEffect)(function () {
    ref.current = ignore ? ref.current : value;
  }, [value, ignore]);
  return ref.current;
};

function useTranslation(ns) {
  var props = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var i18nFromProps = props.i18n;

  var _ref = (0,react.useContext)(I18nContext) || {},
      i18nFromContext = _ref.i18n,
      defaultNSFromContext = _ref.defaultNS;

  var i18n = i18nFromProps || i18nFromContext || getI18n();
  if (i18n && !i18n.reportNamespaces) i18n.reportNamespaces = new ReportNamespaces();

  if (!i18n) {
    warnOnce('You will need to pass in an i18next instance by using initReactI18next');

    var notReadyT = function notReadyT(k) {
      return Array.isArray(k) ? k[k.length - 1] : k;
    };

    var retNotReady = [notReadyT, {}, false];
    retNotReady.t = notReadyT;
    retNotReady.i18n = {};
    retNotReady.ready = false;
    return retNotReady;
  }

  if (i18n.options.react && i18n.options.react.wait !== undefined) warnOnce('It seems you are still using the old wait option, you may migrate to the new useSuspense behaviour.');

  var i18nOptions = useTranslation_objectSpread(useTranslation_objectSpread(useTranslation_objectSpread({}, getDefaults()), i18n.options.react), props);

  var useSuspense = i18nOptions.useSuspense,
      keyPrefix = i18nOptions.keyPrefix;
  var namespaces = ns || defaultNSFromContext || i18n.options && i18n.options.defaultNS;
  namespaces = typeof namespaces === 'string' ? [namespaces] : namespaces || ['translation'];
  if (i18n.reportNamespaces.addUsedNamespaces) i18n.reportNamespaces.addUsedNamespaces(namespaces);
  var ready = (i18n.isInitialized || i18n.initializedStoreOnce) && namespaces.every(function (n) {
    return hasLoadedNamespace(n, i18n, i18nOptions);
  });

  function getT() {
    return i18n.getFixedT(null, i18nOptions.nsMode === 'fallback' ? namespaces : namespaces[0], keyPrefix);
  }

  var _useState = (0,react.useState)(getT),
      _useState2 = _slicedToArray(_useState, 2),
      t = _useState2[0],
      setT = _useState2[1];

  var joinedNS = namespaces.join();
  var previousJoinedNS = usePrevious(joinedNS);
  var isMounted = (0,react.useRef)(true);
  (0,react.useEffect)(function () {
    var bindI18n = i18nOptions.bindI18n,
        bindI18nStore = i18nOptions.bindI18nStore;
    isMounted.current = true;

    if (!ready && !useSuspense) {
      loadNamespaces(i18n, namespaces, function () {
        if (isMounted.current) setT(getT);
      });
    }

    if (ready && previousJoinedNS && previousJoinedNS !== joinedNS && isMounted.current) {
      setT(getT);
    }

    function boundReset() {
      if (isMounted.current) setT(getT);
    }

    if (bindI18n && i18n) i18n.on(bindI18n, boundReset);
    if (bindI18nStore && i18n) i18n.store.on(bindI18nStore, boundReset);
    return function () {
      isMounted.current = false;
      if (bindI18n && i18n) bindI18n.split(' ').forEach(function (e) {
        return i18n.off(e, boundReset);
      });
      if (bindI18nStore && i18n) bindI18nStore.split(' ').forEach(function (e) {
        return i18n.store.off(e, boundReset);
      });
    };
  }, [i18n, joinedNS]);
  var isInitial = (0,react.useRef)(true);
  (0,react.useEffect)(function () {
    if (isMounted.current && !isInitial.current) {
      setT(getT);
    }

    isInitial.current = false;
  }, [i18n, keyPrefix]);
  var ret = [t, i18n, ready];
  ret.t = t;
  ret.i18n = i18n;
  ret.ready = ready;
  if (ready) return ret;
  if (!ready && !useSuspense) return ret;
  throw new Promise(function (resolve) {
    loadNamespaces(i18n, namespaces, function () {
      resolve();
    });
  });
}
;// CONCATENATED MODULE: ./node_modules/react-i18next/dist/es/withTranslation.js



var withTranslation_excluded = ["forwardedRef"];

function withTranslation_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function withTranslation_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { withTranslation_ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { withTranslation_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }




function withTranslation(ns) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  return function Extend(WrappedComponent) {
    function I18nextWithTranslation(_ref) {
      var forwardedRef = _ref.forwardedRef,
          rest = _objectWithoutProperties(_ref, withTranslation_excluded);

      var _useTranslation = useTranslation(ns, withTranslation_objectSpread(withTranslation_objectSpread({}, rest), {}, {
        keyPrefix: options.keyPrefix
      })),
          _useTranslation2 = _slicedToArray(_useTranslation, 3),
          t = _useTranslation2[0],
          i18n = _useTranslation2[1],
          ready = _useTranslation2[2];

      var passDownProps = withTranslation_objectSpread(withTranslation_objectSpread({}, rest), {}, {
        t: t,
        i18n: i18n,
        tReady: ready
      });

      if (options.withRef && forwardedRef) {
        passDownProps.ref = forwardedRef;
      } else if (!options.withRef && forwardedRef) {
        passDownProps.forwardedRef = forwardedRef;
      }

      return (0,react.createElement)(WrappedComponent, passDownProps);
    }

    I18nextWithTranslation.displayName = "withI18nextTranslation(".concat(getDisplayName(WrappedComponent), ")");
    I18nextWithTranslation.WrappedComponent = WrappedComponent;

    var forwardRef = function forwardRef(props, ref) {
      return (0,react.createElement)(I18nextWithTranslation, Object.assign({}, props, {
        forwardedRef: ref
      }));
    };

    return options.withRef ? (0,react.forwardRef)(forwardRef) : I18nextWithTranslation;
  };
}
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__(87462);
;// CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/typeof.js
function typeof_typeof(o) {
  "@babel/helpers - typeof";

  return typeof_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, typeof_typeof(o);
}
;// CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/toPrimitive.js

function toPrimitive(t, r) {
  if ("object" != typeof_typeof(t) || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != typeof_typeof(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
;// CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/toPropertyKey.js


function toPropertyKey(t) {
  var i = toPrimitive(t, "string");
  return "symbol" == typeof_typeof(i) ? i : String(i);
}
;// CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/defineProperty.js

function defineProperty_defineProperty(obj, key, value) {
  key = toPropertyKey(key);
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
// EXTERNAL MODULE: ./node_modules/hoist-non-react-statics/dist/hoist-non-react-statics.cjs.js
var hoist_non_react_statics_cjs = __webpack_require__(8679);
var hoist_non_react_statics_cjs_default = /*#__PURE__*/__webpack_require__.n(hoist_non_react_statics_cjs);
;// CONCATENATED MODULE: ./node_modules/react-i18next/dist/es/I18nextProvider.js


function I18nextProvider(_ref) {
  var i18n = _ref.i18n,
      defaultNS = _ref.defaultNS,
      children = _ref.children;
  var value = (0,react.useMemo)(function () {
    return {
      i18n: i18n,
      defaultNS: defaultNS
    };
  }, [i18n, defaultNS]);
  return (0,react.createElement)(I18nContext.Provider, {
    value: value
  }, children);
}
;// CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/objectWithoutPropertiesLoose.js
function objectWithoutPropertiesLoose_objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;
  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }
  return target;
}
;// CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js

function objectWithoutProperties_objectWithoutProperties(source, excluded) {
  if (source == null) return {};
  var target = objectWithoutPropertiesLoose_objectWithoutPropertiesLoose(source, excluded);
  var key, i;
  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }
  return target;
}
;// CONCATENATED MODULE: ./node_modules/next-i18next/dist/esm/config/defaultConfig.js
var DEFAULT_LOCALE = 'en';
var LOCALES = ['en'];
var DEFAULT_NAMESPACE = 'common';
var LOCALE_PATH = './public/locales';
var LOCALE_STRUCTURE = '{{lng}}/{{ns}}';
var LOCALE_EXTENSION = 'json';
var defaultConfig = {
  defaultNS: DEFAULT_NAMESPACE,
  errorStackTraceLimit: 0,
  i18n: {
    defaultLocale: DEFAULT_LOCALE,
    locales: LOCALES
  },

  get initImmediate() {
    return  true && typeof window !== 'undefined';
  },

  interpolation: {
    escapeValue: false,
    format: function format(value, _format) {
      return _format === 'uppercase' ? value.toUpperCase() : value;
    },
    formatSeparator: ','
  },
  load: 'currentOnly',
  localeExtension: LOCALE_EXTENSION,
  localePath: LOCALE_PATH,
  localeStructure: LOCALE_STRUCTURE,
  react: {
    useSuspense: true
  },
  serializeConfig: true,
  strictMode: true,
  use: []
};
;// CONCATENATED MODULE: ./node_modules/next-i18next/dist/esm/config/createConfig.js



function createConfig_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function createConfig_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { createConfig_ownKeys(Object(source), true).forEach(function (key) { defineProperty_defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { createConfig_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }


var deepMergeObjects = ['backend', 'detection'];
var createConfig = function createConfig(userConfig) {
  if (typeof (userConfig === null || userConfig === void 0 ? void 0 : userConfig.lng) !== 'string') {
    throw new Error('config.lng was not passed into createConfig');
  } //
  // Initial merge of default and user-provided config
  //


  var userI18n = userConfig.i18n,
      userConfigStripped = objectWithoutProperties_objectWithoutProperties(userConfig, ["i18n"]);

  var defaultI18n = defaultConfig.i18n,
      defaultConfigStripped = objectWithoutProperties_objectWithoutProperties(defaultConfig, ["i18n"]);

  var combinedConfig = createConfig_objectSpread(createConfig_objectSpread(createConfig_objectSpread(createConfig_objectSpread({}, defaultConfigStripped), userConfigStripped), defaultI18n), userI18n);

  var defaultNS = combinedConfig.defaultNS,
      lng = combinedConfig.lng,
      locales = combinedConfig.locales,
      localeExtension = combinedConfig.localeExtension,
      localePath = combinedConfig.localePath,
      localeStructure = combinedConfig.localeStructure;
  /**
   * Skips translation file resolution while in cimode
   * https://github.com/isaachinman/next-i18next/pull/851#discussion_r503113620
  */

  if (lng === 'cimode') {
    return combinedConfig;
  }

  if (typeof combinedConfig.fallbackLng === 'undefined') {
    combinedConfig.fallbackLng = combinedConfig.defaultLocale;
  }

  if (false) { var getAllNamespaces, defaultNSExists, defaultNSPath, defaultFile, defaultLocaleStructure, serverLocalePath, path, fs, hasCustomBackend, _userConfig$use; } else {
    var clientLocalePath = localePath; //
    // Remove public prefix from client site config
    //

    if (localePath.match(/^\.?\/public\//)) {
      clientLocalePath = localePath.replace(/^\.?\/public/, '');
    } //
    // Set client side backend
    //


    combinedConfig.backend = {
      addPath: "".concat(clientLocalePath, "/").concat(localeStructure, ".missing.").concat(localeExtension),
      loadPath: "".concat(clientLocalePath, "/").concat(localeStructure, ".").concat(localeExtension)
    };
    combinedConfig.ns = [defaultNS];
  } //
  // Deep merge with overwrite - goes last
  //


  deepMergeObjects.forEach(function (obj) {
    if (userConfig[obj]) {
      combinedConfig[obj] = createConfig_objectSpread(createConfig_objectSpread({}, combinedConfig[obj]), userConfig[obj]);
    }
  });
  return combinedConfig;
};
;// CONCATENATED MODULE: ./node_modules/i18next/node_modules/@babel/runtime/helpers/esm/typeof.js
function esm_typeof_typeof(obj) {
  "@babel/helpers - typeof";

  return esm_typeof_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) {
    return typeof obj;
  } : function (obj) {
    return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
  }, esm_typeof_typeof(obj);
}
;// CONCATENATED MODULE: ./node_modules/i18next/node_modules/@babel/runtime/helpers/esm/defineProperty.js
function esm_defineProperty_defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
;// CONCATENATED MODULE: ./node_modules/i18next/node_modules/@babel/runtime/helpers/esm/objectSpread.js

function objectSpread_objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? Object(arguments[i]) : {};
    var ownKeys = Object.keys(source);
    if (typeof Object.getOwnPropertySymbols === 'function') {
      ownKeys.push.apply(ownKeys, Object.getOwnPropertySymbols(source).filter(function (sym) {
        return Object.getOwnPropertyDescriptor(source, sym).enumerable;
      }));
    }
    ownKeys.forEach(function (key) {
      esm_defineProperty_defineProperty(target, key, source[key]);
    });
  }
  return target;
}
;// CONCATENATED MODULE: ./node_modules/i18next/node_modules/@babel/runtime/helpers/esm/classCallCheck.js
function classCallCheck_classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
;// CONCATENATED MODULE: ./node_modules/i18next/node_modules/@babel/runtime/helpers/esm/createClass.js
function createClass_defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}
function createClass_createClass(Constructor, protoProps, staticProps) {
  if (protoProps) createClass_defineProperties(Constructor.prototype, protoProps);
  if (staticProps) createClass_defineProperties(Constructor, staticProps);
  Object.defineProperty(Constructor, "prototype", {
    writable: false
  });
  return Constructor;
}
;// CONCATENATED MODULE: ./node_modules/i18next/node_modules/@babel/runtime/helpers/esm/assertThisInitialized.js
function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return self;
}
;// CONCATENATED MODULE: ./node_modules/i18next/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn.js


function _possibleConstructorReturn(self, call) {
  if (call && (esm_typeof_typeof(call) === "object" || typeof call === "function")) {
    return call;
  } else if (call !== void 0) {
    throw new TypeError("Derived constructors may only return object or undefined");
  }
  return _assertThisInitialized(self);
}
;// CONCATENATED MODULE: ./node_modules/i18next/node_modules/@babel/runtime/helpers/esm/getPrototypeOf.js
function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}
;// CONCATENATED MODULE: ./node_modules/i18next/node_modules/@babel/runtime/helpers/esm/setPrototypeOf.js
function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };
  return _setPrototypeOf(o, p);
}
;// CONCATENATED MODULE: ./node_modules/i18next/node_modules/@babel/runtime/helpers/esm/inherits.js

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }
  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  Object.defineProperty(subClass, "prototype", {
    writable: false
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}
;// CONCATENATED MODULE: ./node_modules/i18next/dist/esm/i18next.js









var consoleLogger = {
  type: 'logger',
  log: function log(args) {
    this.output('log', args);
  },
  warn: function warn(args) {
    this.output('warn', args);
  },
  error: function error(args) {
    this.output('error', args);
  },
  output: function output(type, args) {
    if (console && console[type]) console[type].apply(console, args);
  }
};

var Logger = function () {
  function Logger(concreteLogger) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    classCallCheck_classCallCheck(this, Logger);

    this.init(concreteLogger, options);
  }

  createClass_createClass(Logger, [{
    key: "init",
    value: function init(concreteLogger) {
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      this.prefix = options.prefix || 'i18next:';
      this.logger = concreteLogger || consoleLogger;
      this.options = options;
      this.debug = options.debug;
    }
  }, {
    key: "setDebug",
    value: function setDebug(bool) {
      this.debug = bool;
    }
  }, {
    key: "log",
    value: function log() {
      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      return this.forward(args, 'log', '', true);
    }
  }, {
    key: "warn",
    value: function warn() {
      for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
        args[_key2] = arguments[_key2];
      }

      return this.forward(args, 'warn', '', true);
    }
  }, {
    key: "error",
    value: function error() {
      for (var _len3 = arguments.length, args = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
        args[_key3] = arguments[_key3];
      }

      return this.forward(args, 'error', '');
    }
  }, {
    key: "deprecate",
    value: function deprecate() {
      for (var _len4 = arguments.length, args = new Array(_len4), _key4 = 0; _key4 < _len4; _key4++) {
        args[_key4] = arguments[_key4];
      }

      return this.forward(args, 'warn', 'WARNING DEPRECATED: ', true);
    }
  }, {
    key: "forward",
    value: function forward(args, lvl, prefix, debugOnly) {
      if (debugOnly && !this.debug) return null;
      if (typeof args[0] === 'string') args[0] = "".concat(prefix).concat(this.prefix, " ").concat(args[0]);
      return this.logger[lvl](args);
    }
  }, {
    key: "create",
    value: function create(moduleName) {
      return new Logger(this.logger, objectSpread_objectSpread({}, {
        prefix: "".concat(this.prefix, ":").concat(moduleName, ":")
      }, this.options));
    }
  }]);

  return Logger;
}();

var baseLogger = new Logger();

var EventEmitter = function () {
  function EventEmitter() {
    classCallCheck_classCallCheck(this, EventEmitter);

    this.observers = {};
  }

  createClass_createClass(EventEmitter, [{
    key: "on",
    value: function on(events, listener) {
      var _this = this;

      events.split(' ').forEach(function (event) {
        _this.observers[event] = _this.observers[event] || [];

        _this.observers[event].push(listener);
      });
      return this;
    }
  }, {
    key: "off",
    value: function off(event, listener) {
      if (!this.observers[event]) return;

      if (!listener) {
        delete this.observers[event];
        return;
      }

      this.observers[event] = this.observers[event].filter(function (l) {
        return l !== listener;
      });
    }
  }, {
    key: "emit",
    value: function emit(event) {
      for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
        args[_key - 1] = arguments[_key];
      }

      if (this.observers[event]) {
        var cloned = [].concat(this.observers[event]);
        cloned.forEach(function (observer) {
          observer.apply(void 0, args);
        });
      }

      if (this.observers['*']) {
        var _cloned = [].concat(this.observers['*']);

        _cloned.forEach(function (observer) {
          observer.apply(observer, [event].concat(args));
        });
      }
    }
  }]);

  return EventEmitter;
}();

function defer() {
  var res;
  var rej;
  var promise = new Promise(function (resolve, reject) {
    res = resolve;
    rej = reject;
  });
  promise.resolve = res;
  promise.reject = rej;
  return promise;
}
function makeString(object) {
  if (object == null) return '';
  return '' + object;
}
function copy(a, s, t) {
  a.forEach(function (m) {
    if (s[m]) t[m] = s[m];
  });
}

function getLastOfPath(object, path, Empty) {
  function cleanKey(key) {
    return key && key.indexOf('###') > -1 ? key.replace(/###/g, '.') : key;
  }

  function canNotTraverseDeeper() {
    return !object || typeof object === 'string';
  }

  var stack = typeof path !== 'string' ? [].concat(path) : path.split('.');

  while (stack.length > 1) {
    if (canNotTraverseDeeper()) return {};
    var key = cleanKey(stack.shift());
    if (!object[key] && Empty) object[key] = new Empty();

    if (Object.prototype.hasOwnProperty.call(object, key)) {
      object = object[key];
    } else {
      object = {};
    }
  }

  if (canNotTraverseDeeper()) return {};
  return {
    obj: object,
    k: cleanKey(stack.shift())
  };
}

function setPath(object, path, newValue) {
  var _getLastOfPath = getLastOfPath(object, path, Object),
      obj = _getLastOfPath.obj,
      k = _getLastOfPath.k;

  obj[k] = newValue;
}
function pushPath(object, path, newValue, concat) {
  var _getLastOfPath2 = getLastOfPath(object, path, Object),
      obj = _getLastOfPath2.obj,
      k = _getLastOfPath2.k;

  obj[k] = obj[k] || [];
  if (concat) obj[k] = obj[k].concat(newValue);
  if (!concat) obj[k].push(newValue);
}
function getPath(object, path) {
  var _getLastOfPath3 = getLastOfPath(object, path),
      obj = _getLastOfPath3.obj,
      k = _getLastOfPath3.k;

  if (!obj) return undefined;
  return obj[k];
}
function getPathWithDefaults(data, defaultData, key) {
  var value = getPath(data, key);

  if (value !== undefined) {
    return value;
  }

  return getPath(defaultData, key);
}
function deepExtend(target, source, overwrite) {
  for (var prop in source) {
    if (prop !== '__proto__' && prop !== 'constructor') {
      if (prop in target) {
        if (typeof target[prop] === 'string' || target[prop] instanceof String || typeof source[prop] === 'string' || source[prop] instanceof String) {
          if (overwrite) target[prop] = source[prop];
        } else {
          deepExtend(target[prop], source[prop], overwrite);
        }
      } else {
        target[prop] = source[prop];
      }
    }
  }

  return target;
}
function regexEscape(str) {
  return str.replace(/[\-\[\]\/\{\}\(\)\*\+\?\.\\\^\$\|]/g, '\\$&');
}
var _entityMap = {
  '&': '&amp;',
  '<': '&lt;',
  '>': '&gt;',
  '"': '&quot;',
  "'": '&#39;',
  '/': '&#x2F;'
};
function i18next_escape(data) {
  if (typeof data === 'string') {
    return data.replace(/[&<>"'\/]/g, function (s) {
      return _entityMap[s];
    });
  }

  return data;
}
var isIE10 = typeof window !== 'undefined' && window.navigator && window.navigator.userAgent && window.navigator.userAgent.indexOf('MSIE') > -1;

function deepFind(obj, path) {
  var keySeparator = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '.';
  if (!obj) return undefined;
  if (obj[path]) return obj[path];
  var paths = path.split(keySeparator);
  var current = obj;

  for (var i = 0; i < paths.length; ++i) {
    if (!current) return undefined;

    if (typeof current[paths[i]] === 'string' && i + 1 < paths.length) {
      return undefined;
    }

    if (current[paths[i]] === undefined) {
      var j = 2;
      var p = paths.slice(i, i + j).join(keySeparator);
      var mix = current[p];

      while (mix === undefined && paths.length > i + j) {
        j++;
        p = paths.slice(i, i + j).join(keySeparator);
        mix = current[p];
      }

      if (mix === undefined) return undefined;
      if (typeof mix === 'string') return mix;
      if (p && typeof mix[p] === 'string') return mix[p];
      var joinedPath = paths.slice(i + j).join(keySeparator);
      if (joinedPath) return deepFind(mix, joinedPath, keySeparator);
      return undefined;
    }

    current = current[paths[i]];
  }

  return current;
}

var ResourceStore = function (_EventEmitter) {
  _inherits(ResourceStore, _EventEmitter);

  function ResourceStore(data) {
    var _this;

    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
      ns: ['translation'],
      defaultNS: 'translation'
    };

    classCallCheck_classCallCheck(this, ResourceStore);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(ResourceStore).call(this));

    if (isIE10) {
      EventEmitter.call(_assertThisInitialized(_this));
    }

    _this.data = data || {};
    _this.options = options;

    if (_this.options.keySeparator === undefined) {
      _this.options.keySeparator = '.';
    }

    if (_this.options.ignoreJSONStructure === undefined) {
      _this.options.ignoreJSONStructure = true;
    }

    return _this;
  }

  createClass_createClass(ResourceStore, [{
    key: "addNamespaces",
    value: function addNamespaces(ns) {
      if (this.options.ns.indexOf(ns) < 0) {
        this.options.ns.push(ns);
      }
    }
  }, {
    key: "removeNamespaces",
    value: function removeNamespaces(ns) {
      var index = this.options.ns.indexOf(ns);

      if (index > -1) {
        this.options.ns.splice(index, 1);
      }
    }
  }, {
    key: "getResource",
    value: function getResource(lng, ns, key) {
      var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
      var keySeparator = options.keySeparator !== undefined ? options.keySeparator : this.options.keySeparator;
      var ignoreJSONStructure = options.ignoreJSONStructure !== undefined ? options.ignoreJSONStructure : this.options.ignoreJSONStructure;
      var path = [lng, ns];
      if (key && typeof key !== 'string') path = path.concat(key);
      if (key && typeof key === 'string') path = path.concat(keySeparator ? key.split(keySeparator) : key);

      if (lng.indexOf('.') > -1) {
        path = lng.split('.');
      }

      var result = getPath(this.data, path);
      if (result || !ignoreJSONStructure || typeof key !== 'string') return result;
      return deepFind(this.data && this.data[lng] && this.data[lng][ns], key, keySeparator);
    }
  }, {
    key: "addResource",
    value: function addResource(lng, ns, key, value) {
      var options = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : {
        silent: false
      };
      var keySeparator = this.options.keySeparator;
      if (keySeparator === undefined) keySeparator = '.';
      var path = [lng, ns];
      if (key) path = path.concat(keySeparator ? key.split(keySeparator) : key);

      if (lng.indexOf('.') > -1) {
        path = lng.split('.');
        value = ns;
        ns = path[1];
      }

      this.addNamespaces(ns);
      setPath(this.data, path, value);
      if (!options.silent) this.emit('added', lng, ns, key, value);
    }
  }, {
    key: "addResources",
    value: function addResources(lng, ns, resources) {
      var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {
        silent: false
      };

      for (var m in resources) {
        if (typeof resources[m] === 'string' || Object.prototype.toString.apply(resources[m]) === '[object Array]') this.addResource(lng, ns, m, resources[m], {
          silent: true
        });
      }

      if (!options.silent) this.emit('added', lng, ns, resources);
    }
  }, {
    key: "addResourceBundle",
    value: function addResourceBundle(lng, ns, resources, deep, overwrite) {
      var options = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : {
        silent: false
      };
      var path = [lng, ns];

      if (lng.indexOf('.') > -1) {
        path = lng.split('.');
        deep = resources;
        resources = ns;
        ns = path[1];
      }

      this.addNamespaces(ns);
      var pack = getPath(this.data, path) || {};

      if (deep) {
        deepExtend(pack, resources, overwrite);
      } else {
        pack = objectSpread_objectSpread({}, pack, resources);
      }

      setPath(this.data, path, pack);
      if (!options.silent) this.emit('added', lng, ns, resources);
    }
  }, {
    key: "removeResourceBundle",
    value: function removeResourceBundle(lng, ns) {
      if (this.hasResourceBundle(lng, ns)) {
        delete this.data[lng][ns];
      }

      this.removeNamespaces(ns);
      this.emit('removed', lng, ns);
    }
  }, {
    key: "hasResourceBundle",
    value: function hasResourceBundle(lng, ns) {
      return this.getResource(lng, ns) !== undefined;
    }
  }, {
    key: "getResourceBundle",
    value: function getResourceBundle(lng, ns) {
      if (!ns) ns = this.options.defaultNS;
      if (this.options.compatibilityAPI === 'v1') return objectSpread_objectSpread({}, {}, this.getResource(lng, ns));
      return this.getResource(lng, ns);
    }
  }, {
    key: "getDataByLanguage",
    value: function getDataByLanguage(lng) {
      return this.data[lng];
    }
  }, {
    key: "toJSON",
    value: function toJSON() {
      return this.data;
    }
  }]);

  return ResourceStore;
}(EventEmitter);

var postProcessor = {
  processors: {},
  addPostProcessor: function addPostProcessor(module) {
    this.processors[module.name] = module;
  },
  handle: function handle(processors, value, key, options, translator) {
    var _this = this;

    processors.forEach(function (processor) {
      if (_this.processors[processor]) value = _this.processors[processor].process(value, key, options, translator);
    });
    return value;
  }
};

var checkedLoadedFor = {};

var Translator = function (_EventEmitter) {
  _inherits(Translator, _EventEmitter);

  function Translator(services) {
    var _this;

    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    classCallCheck_classCallCheck(this, Translator);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(Translator).call(this));

    if (isIE10) {
      EventEmitter.call(_assertThisInitialized(_this));
    }

    copy(['resourceStore', 'languageUtils', 'pluralResolver', 'interpolator', 'backendConnector', 'i18nFormat', 'utils'], services, _assertThisInitialized(_this));
    _this.options = options;

    if (_this.options.keySeparator === undefined) {
      _this.options.keySeparator = '.';
    }

    _this.logger = baseLogger.create('translator');
    return _this;
  }

  createClass_createClass(Translator, [{
    key: "changeLanguage",
    value: function changeLanguage(lng) {
      if (lng) this.language = lng;
    }
  }, {
    key: "exists",
    value: function exists(key) {
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
        interpolation: {}
      };

      if (key === undefined || key === null) {
        return false;
      }

      var resolved = this.resolve(key, options);
      return resolved && resolved.res !== undefined;
    }
  }, {
    key: "extractFromKey",
    value: function extractFromKey(key, options) {
      var nsSeparator = options.nsSeparator !== undefined ? options.nsSeparator : this.options.nsSeparator;
      if (nsSeparator === undefined) nsSeparator = ':';
      var keySeparator = options.keySeparator !== undefined ? options.keySeparator : this.options.keySeparator;
      var namespaces = options.ns || this.options.defaultNS;

      if (nsSeparator && key.indexOf(nsSeparator) > -1) {
        var m = key.match(this.interpolator.nestingRegexp);

        if (m && m.length > 0) {
          return {
            key: key,
            namespaces: namespaces
          };
        }

        var parts = key.split(nsSeparator);
        if (nsSeparator !== keySeparator || nsSeparator === keySeparator && this.options.ns.indexOf(parts[0]) > -1) namespaces = parts.shift();
        key = parts.join(keySeparator);
      }

      if (typeof namespaces === 'string') namespaces = [namespaces];
      return {
        key: key,
        namespaces: namespaces
      };
    }
  }, {
    key: "translate",
    value: function translate(keys, options, lastKey) {
      var _this2 = this;

      if (esm_typeof_typeof(options) !== 'object' && this.options.overloadTranslationOptionHandler) {
        options = this.options.overloadTranslationOptionHandler(arguments);
      }

      if (!options) options = {};
      if (keys === undefined || keys === null) return '';
      if (!Array.isArray(keys)) keys = [String(keys)];
      var keySeparator = options.keySeparator !== undefined ? options.keySeparator : this.options.keySeparator;

      var _this$extractFromKey = this.extractFromKey(keys[keys.length - 1], options),
          key = _this$extractFromKey.key,
          namespaces = _this$extractFromKey.namespaces;

      var namespace = namespaces[namespaces.length - 1];
      var lng = options.lng || this.language;
      var appendNamespaceToCIMode = options.appendNamespaceToCIMode || this.options.appendNamespaceToCIMode;

      if (lng && lng.toLowerCase() === 'cimode') {
        if (appendNamespaceToCIMode) {
          var nsSeparator = options.nsSeparator || this.options.nsSeparator;
          return namespace + nsSeparator + key;
        }

        return key;
      }

      var resolved = this.resolve(keys, options);
      var res = resolved && resolved.res;
      var resUsedKey = resolved && resolved.usedKey || key;
      var resExactUsedKey = resolved && resolved.exactUsedKey || key;
      var resType = Object.prototype.toString.apply(res);
      var noObject = ['[object Number]', '[object Function]', '[object RegExp]'];
      var joinArrays = options.joinArrays !== undefined ? options.joinArrays : this.options.joinArrays;
      var handleAsObjectInI18nFormat = !this.i18nFormat || this.i18nFormat.handleAsObject;
      var handleAsObject = typeof res !== 'string' && typeof res !== 'boolean' && typeof res !== 'number';

      if (handleAsObjectInI18nFormat && res && handleAsObject && noObject.indexOf(resType) < 0 && !(typeof joinArrays === 'string' && resType === '[object Array]')) {
        if (!options.returnObjects && !this.options.returnObjects) {
          if (!this.options.returnedObjectHandler) {
            this.logger.warn('accessing an object - but returnObjects options is not enabled!');
          }

          return this.options.returnedObjectHandler ? this.options.returnedObjectHandler(resUsedKey, res, objectSpread_objectSpread({}, options, {
            ns: namespaces
          })) : "key '".concat(key, " (").concat(this.language, ")' returned an object instead of string.");
        }

        if (keySeparator) {
          var resTypeIsArray = resType === '[object Array]';
          var copy = resTypeIsArray ? [] : {};
          var newKeyToUse = resTypeIsArray ? resExactUsedKey : resUsedKey;

          for (var m in res) {
            if (Object.prototype.hasOwnProperty.call(res, m)) {
              var deepKey = "".concat(newKeyToUse).concat(keySeparator).concat(m);
              copy[m] = this.translate(deepKey, objectSpread_objectSpread({}, options, {
                joinArrays: false,
                ns: namespaces
              }));
              if (copy[m] === deepKey) copy[m] = res[m];
            }
          }

          res = copy;
        }
      } else if (handleAsObjectInI18nFormat && typeof joinArrays === 'string' && resType === '[object Array]') {
        res = res.join(joinArrays);
        if (res) res = this.extendTranslation(res, keys, options, lastKey);
      } else {
        var usedDefault = false;
        var usedKey = false;
        var needsPluralHandling = options.count !== undefined && typeof options.count !== 'string';
        var hasDefaultValue = Translator.hasDefaultValue(options);
        var defaultValueSuffix = needsPluralHandling ? this.pluralResolver.getSuffix(lng, options.count) : '';
        var defaultValue = options["defaultValue".concat(defaultValueSuffix)] || options.defaultValue;

        if (!this.isValidLookup(res) && hasDefaultValue) {
          usedDefault = true;
          res = defaultValue;
        }

        if (!this.isValidLookup(res)) {
          usedKey = true;
          res = key;
        }

        var missingKeyNoValueFallbackToKey = options.missingKeyNoValueFallbackToKey || this.options.missingKeyNoValueFallbackToKey;
        var resForMissing = missingKeyNoValueFallbackToKey && usedKey ? undefined : res;
        var updateMissing = hasDefaultValue && defaultValue !== res && this.options.updateMissing;

        if (usedKey || usedDefault || updateMissing) {
          this.logger.log(updateMissing ? 'updateKey' : 'missingKey', lng, namespace, key, updateMissing ? defaultValue : res);

          if (keySeparator) {
            var fk = this.resolve(key, objectSpread_objectSpread({}, options, {
              keySeparator: false
            }));
            if (fk && fk.res) this.logger.warn('Seems the loaded translations were in flat JSON format instead of nested. Either set keySeparator: false on init or make sure your translations are published in nested format.');
          }

          var lngs = [];
          var fallbackLngs = this.languageUtils.getFallbackCodes(this.options.fallbackLng, options.lng || this.language);

          if (this.options.saveMissingTo === 'fallback' && fallbackLngs && fallbackLngs[0]) {
            for (var i = 0; i < fallbackLngs.length; i++) {
              lngs.push(fallbackLngs[i]);
            }
          } else if (this.options.saveMissingTo === 'all') {
            lngs = this.languageUtils.toResolveHierarchy(options.lng || this.language);
          } else {
            lngs.push(options.lng || this.language);
          }

          var send = function send(l, k, fallbackValue) {
            if (_this2.options.missingKeyHandler) {
              _this2.options.missingKeyHandler(l, namespace, k, updateMissing ? fallbackValue : resForMissing, updateMissing, options);
            } else if (_this2.backendConnector && _this2.backendConnector.saveMissing) {
              _this2.backendConnector.saveMissing(l, namespace, k, updateMissing ? fallbackValue : resForMissing, updateMissing, options);
            }

            _this2.emit('missingKey', l, namespace, k, res);
          };

          if (this.options.saveMissing) {
            if (this.options.saveMissingPlurals && needsPluralHandling) {
              lngs.forEach(function (language) {
                _this2.pluralResolver.getSuffixes(language).forEach(function (suffix) {
                  send([language], key + suffix, options["defaultValue".concat(suffix)] || defaultValue);
                });
              });
            } else {
              send(lngs, key, defaultValue);
            }
          }
        }

        res = this.extendTranslation(res, keys, options, resolved, lastKey);
        if (usedKey && res === key && this.options.appendNamespaceToMissingKey) res = "".concat(namespace, ":").concat(key);
        if ((usedKey || usedDefault) && this.options.parseMissingKeyHandler) res = this.options.parseMissingKeyHandler(res);
      }

      return res;
    }
  }, {
    key: "extendTranslation",
    value: function extendTranslation(res, key, options, resolved, lastKey) {
      var _this3 = this;

      if (this.i18nFormat && this.i18nFormat.parse) {
        res = this.i18nFormat.parse(res, options, resolved.usedLng, resolved.usedNS, resolved.usedKey, {
          resolved: resolved
        });
      } else if (!options.skipInterpolation) {
        if (options.interpolation) this.interpolator.init(objectSpread_objectSpread({}, options, {
          interpolation: objectSpread_objectSpread({}, this.options.interpolation, options.interpolation)
        }));
        var skipOnVariables = options.interpolation && options.interpolation.skipOnVariables || this.options.interpolation.skipOnVariables;
        var nestBef;

        if (skipOnVariables) {
          var nb = res.match(this.interpolator.nestingRegexp);
          nestBef = nb && nb.length;
        }

        var data = options.replace && typeof options.replace !== 'string' ? options.replace : options;
        if (this.options.interpolation.defaultVariables) data = objectSpread_objectSpread({}, this.options.interpolation.defaultVariables, data);
        res = this.interpolator.interpolate(res, data, options.lng || this.language, options);

        if (skipOnVariables) {
          var na = res.match(this.interpolator.nestingRegexp);
          var nestAft = na && na.length;
          if (nestBef < nestAft) options.nest = false;
        }

        if (options.nest !== false) res = this.interpolator.nest(res, function () {
          for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
          }

          if (lastKey && lastKey[0] === args[0] && !options.context) {
            _this3.logger.warn("It seems you are nesting recursively key: ".concat(args[0], " in key: ").concat(key[0]));

            return null;
          }

          return _this3.translate.apply(_this3, args.concat([key]));
        }, options);
        if (options.interpolation) this.interpolator.reset();
      }

      var postProcess = options.postProcess || this.options.postProcess;
      var postProcessorNames = typeof postProcess === 'string' ? [postProcess] : postProcess;

      if (res !== undefined && res !== null && postProcessorNames && postProcessorNames.length && options.applyPostProcessor !== false) {
        res = postProcessor.handle(postProcessorNames, res, key, this.options && this.options.postProcessPassResolved ? objectSpread_objectSpread({
          i18nResolved: resolved
        }, options) : options, this);
      }

      return res;
    }
  }, {
    key: "resolve",
    value: function resolve(keys) {
      var _this4 = this;

      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var found;
      var usedKey;
      var exactUsedKey;
      var usedLng;
      var usedNS;
      if (typeof keys === 'string') keys = [keys];
      keys.forEach(function (k) {
        if (_this4.isValidLookup(found)) return;

        var extracted = _this4.extractFromKey(k, options);

        var key = extracted.key;
        usedKey = key;
        var namespaces = extracted.namespaces;
        if (_this4.options.fallbackNS) namespaces = namespaces.concat(_this4.options.fallbackNS);
        var needsPluralHandling = options.count !== undefined && typeof options.count !== 'string';
        var needsContextHandling = options.context !== undefined && (typeof options.context === 'string' || typeof options.context === 'number') && options.context !== '';
        var codes = options.lngs ? options.lngs : _this4.languageUtils.toResolveHierarchy(options.lng || _this4.language, options.fallbackLng);
        namespaces.forEach(function (ns) {
          if (_this4.isValidLookup(found)) return;
          usedNS = ns;

          if (!checkedLoadedFor["".concat(codes[0], "-").concat(ns)] && _this4.utils && _this4.utils.hasLoadedNamespace && !_this4.utils.hasLoadedNamespace(usedNS)) {
            checkedLoadedFor["".concat(codes[0], "-").concat(ns)] = true;

            _this4.logger.warn("key \"".concat(usedKey, "\" for languages \"").concat(codes.join(', '), "\" won't get resolved as namespace \"").concat(usedNS, "\" was not yet loaded"), 'This means something IS WRONG in your setup. You access the t function before i18next.init / i18next.loadNamespace / i18next.changeLanguage was done. Wait for the callback or Promise to resolve before accessing it!!!');
          }

          codes.forEach(function (code) {
            if (_this4.isValidLookup(found)) return;
            usedLng = code;
            var finalKey = key;
            var finalKeys = [finalKey];

            if (_this4.i18nFormat && _this4.i18nFormat.addLookupKeys) {
              _this4.i18nFormat.addLookupKeys(finalKeys, key, code, ns, options);
            } else {
              var pluralSuffix;
              if (needsPluralHandling) pluralSuffix = _this4.pluralResolver.getSuffix(code, options.count);
              if (needsPluralHandling && needsContextHandling) finalKeys.push(finalKey + pluralSuffix);
              if (needsContextHandling) finalKeys.push(finalKey += "".concat(_this4.options.contextSeparator).concat(options.context));
              if (needsPluralHandling) finalKeys.push(finalKey += pluralSuffix);
            }

            var possibleKey;

            while (possibleKey = finalKeys.pop()) {
              if (!_this4.isValidLookup(found)) {
                exactUsedKey = possibleKey;
                found = _this4.getResource(code, ns, possibleKey, options);
              }
            }
          });
        });
      });
      return {
        res: found,
        usedKey: usedKey,
        exactUsedKey: exactUsedKey,
        usedLng: usedLng,
        usedNS: usedNS
      };
    }
  }, {
    key: "isValidLookup",
    value: function isValidLookup(res) {
      return res !== undefined && !(!this.options.returnNull && res === null) && !(!this.options.returnEmptyString && res === '');
    }
  }, {
    key: "getResource",
    value: function getResource(code, ns, key) {
      var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
      if (this.i18nFormat && this.i18nFormat.getResource) return this.i18nFormat.getResource(code, ns, key, options);
      return this.resourceStore.getResource(code, ns, key, options);
    }
  }], [{
    key: "hasDefaultValue",
    value: function hasDefaultValue(options) {
      var prefix = 'defaultValue';

      for (var option in options) {
        if (Object.prototype.hasOwnProperty.call(options, option) && prefix === option.substring(0, prefix.length) && undefined !== options[option]) {
          return true;
        }
      }

      return false;
    }
  }]);

  return Translator;
}(EventEmitter);

function capitalize(string) {
  return string.charAt(0).toUpperCase() + string.slice(1);
}

var LanguageUtil = function () {
  function LanguageUtil(options) {
    classCallCheck_classCallCheck(this, LanguageUtil);

    this.options = options;
    this.whitelist = this.options.supportedLngs || false;
    this.supportedLngs = this.options.supportedLngs || false;
    this.logger = baseLogger.create('languageUtils');
  }

  createClass_createClass(LanguageUtil, [{
    key: "getScriptPartFromCode",
    value: function getScriptPartFromCode(code) {
      if (!code || code.indexOf('-') < 0) return null;
      var p = code.split('-');
      if (p.length === 2) return null;
      p.pop();
      if (p[p.length - 1].toLowerCase() === 'x') return null;
      return this.formatLanguageCode(p.join('-'));
    }
  }, {
    key: "getLanguagePartFromCode",
    value: function getLanguagePartFromCode(code) {
      if (!code || code.indexOf('-') < 0) return code;
      var p = code.split('-');
      return this.formatLanguageCode(p[0]);
    }
  }, {
    key: "formatLanguageCode",
    value: function formatLanguageCode(code) {
      if (typeof code === 'string' && code.indexOf('-') > -1) {
        var specialCases = ['hans', 'hant', 'latn', 'cyrl', 'cans', 'mong', 'arab'];
        var p = code.split('-');

        if (this.options.lowerCaseLng) {
          p = p.map(function (part) {
            return part.toLowerCase();
          });
        } else if (p.length === 2) {
          p[0] = p[0].toLowerCase();
          p[1] = p[1].toUpperCase();
          if (specialCases.indexOf(p[1].toLowerCase()) > -1) p[1] = capitalize(p[1].toLowerCase());
        } else if (p.length === 3) {
          p[0] = p[0].toLowerCase();
          if (p[1].length === 2) p[1] = p[1].toUpperCase();
          if (p[0] !== 'sgn' && p[2].length === 2) p[2] = p[2].toUpperCase();
          if (specialCases.indexOf(p[1].toLowerCase()) > -1) p[1] = capitalize(p[1].toLowerCase());
          if (specialCases.indexOf(p[2].toLowerCase()) > -1) p[2] = capitalize(p[2].toLowerCase());
        }

        return p.join('-');
      }

      return this.options.cleanCode || this.options.lowerCaseLng ? code.toLowerCase() : code;
    }
  }, {
    key: "isWhitelisted",
    value: function isWhitelisted(code) {
      this.logger.deprecate('languageUtils.isWhitelisted', 'function "isWhitelisted" will be renamed to "isSupportedCode" in the next major - please make sure to rename it\'s usage asap.');
      return this.isSupportedCode(code);
    }
  }, {
    key: "isSupportedCode",
    value: function isSupportedCode(code) {
      if (this.options.load === 'languageOnly' || this.options.nonExplicitSupportedLngs) {
        code = this.getLanguagePartFromCode(code);
      }

      return !this.supportedLngs || !this.supportedLngs.length || this.supportedLngs.indexOf(code) > -1;
    }
  }, {
    key: "getBestMatchFromCodes",
    value: function getBestMatchFromCodes(codes) {
      var _this = this;

      if (!codes) return null;
      var found;
      codes.forEach(function (code) {
        if (found) return;

        var cleanedLng = _this.formatLanguageCode(code);

        if (!_this.options.supportedLngs || _this.isSupportedCode(cleanedLng)) found = cleanedLng;
      });

      if (!found && this.options.supportedLngs) {
        codes.forEach(function (code) {
          if (found) return;

          var lngOnly = _this.getLanguagePartFromCode(code);

          if (_this.isSupportedCode(lngOnly)) return found = lngOnly;
          found = _this.options.supportedLngs.find(function (supportedLng) {
            if (supportedLng.indexOf(lngOnly) === 0) return supportedLng;
          });
        });
      }

      if (!found) found = this.getFallbackCodes(this.options.fallbackLng)[0];
      return found;
    }
  }, {
    key: "getFallbackCodes",
    value: function getFallbackCodes(fallbacks, code) {
      if (!fallbacks) return [];
      if (typeof fallbacks === 'function') fallbacks = fallbacks(code);
      if (typeof fallbacks === 'string') fallbacks = [fallbacks];
      if (Object.prototype.toString.apply(fallbacks) === '[object Array]') return fallbacks;
      if (!code) return fallbacks["default"] || [];
      var found = fallbacks[code];
      if (!found) found = fallbacks[this.getScriptPartFromCode(code)];
      if (!found) found = fallbacks[this.formatLanguageCode(code)];
      if (!found) found = fallbacks[this.getLanguagePartFromCode(code)];
      if (!found) found = fallbacks["default"];
      return found || [];
    }
  }, {
    key: "toResolveHierarchy",
    value: function toResolveHierarchy(code, fallbackCode) {
      var _this2 = this;

      var fallbackCodes = this.getFallbackCodes(fallbackCode || this.options.fallbackLng || [], code);
      var codes = [];

      var addCode = function addCode(c) {
        if (!c) return;

        if (_this2.isSupportedCode(c)) {
          codes.push(c);
        } else {
          _this2.logger.warn("rejecting language code not found in supportedLngs: ".concat(c));
        }
      };

      if (typeof code === 'string' && code.indexOf('-') > -1) {
        if (this.options.load !== 'languageOnly') addCode(this.formatLanguageCode(code));
        if (this.options.load !== 'languageOnly' && this.options.load !== 'currentOnly') addCode(this.getScriptPartFromCode(code));
        if (this.options.load !== 'currentOnly') addCode(this.getLanguagePartFromCode(code));
      } else if (typeof code === 'string') {
        addCode(this.formatLanguageCode(code));
      }

      fallbackCodes.forEach(function (fc) {
        if (codes.indexOf(fc) < 0) addCode(_this2.formatLanguageCode(fc));
      });
      return codes;
    }
  }]);

  return LanguageUtil;
}();

var sets = [{
  lngs: ['ach', 'ak', 'am', 'arn', 'br', 'fil', 'gun', 'ln', 'mfe', 'mg', 'mi', 'oc', 'pt', 'pt-BR', 'tg', 'tl', 'ti', 'tr', 'uz', 'wa'],
  nr: [1, 2],
  fc: 1
}, {
  lngs: ['af', 'an', 'ast', 'az', 'bg', 'bn', 'ca', 'da', 'de', 'dev', 'el', 'en', 'eo', 'es', 'et', 'eu', 'fi', 'fo', 'fur', 'fy', 'gl', 'gu', 'ha', 'hi', 'hu', 'hy', 'ia', 'it', 'kk', 'kn', 'ku', 'lb', 'mai', 'ml', 'mn', 'mr', 'nah', 'nap', 'nb', 'ne', 'nl', 'nn', 'no', 'nso', 'pa', 'pap', 'pms', 'ps', 'pt-PT', 'rm', 'sco', 'se', 'si', 'so', 'son', 'sq', 'sv', 'sw', 'ta', 'te', 'tk', 'ur', 'yo'],
  nr: [1, 2],
  fc: 2
}, {
  lngs: ['ay', 'bo', 'cgg', 'fa', 'ht', 'id', 'ja', 'jbo', 'ka', 'km', 'ko', 'ky', 'lo', 'ms', 'sah', 'su', 'th', 'tt', 'ug', 'vi', 'wo', 'zh'],
  nr: [1],
  fc: 3
}, {
  lngs: ['be', 'bs', 'cnr', 'dz', 'hr', 'ru', 'sr', 'uk'],
  nr: [1, 2, 5],
  fc: 4
}, {
  lngs: ['ar'],
  nr: [0, 1, 2, 3, 11, 100],
  fc: 5
}, {
  lngs: ['cs', 'sk'],
  nr: [1, 2, 5],
  fc: 6
}, {
  lngs: ['csb', 'pl'],
  nr: [1, 2, 5],
  fc: 7
}, {
  lngs: ['cy'],
  nr: [1, 2, 3, 8],
  fc: 8
}, {
  lngs: ['fr'],
  nr: [1, 2],
  fc: 9
}, {
  lngs: ['ga'],
  nr: [1, 2, 3, 7, 11],
  fc: 10
}, {
  lngs: ['gd'],
  nr: [1, 2, 3, 20],
  fc: 11
}, {
  lngs: ['is'],
  nr: [1, 2],
  fc: 12
}, {
  lngs: ['jv'],
  nr: [0, 1],
  fc: 13
}, {
  lngs: ['kw'],
  nr: [1, 2, 3, 4],
  fc: 14
}, {
  lngs: ['lt'],
  nr: [1, 2, 10],
  fc: 15
}, {
  lngs: ['lv'],
  nr: [1, 2, 0],
  fc: 16
}, {
  lngs: ['mk'],
  nr: [1, 2],
  fc: 17
}, {
  lngs: ['mnk'],
  nr: [0, 1, 2],
  fc: 18
}, {
  lngs: ['mt'],
  nr: [1, 2, 11, 20],
  fc: 19
}, {
  lngs: ['or'],
  nr: [2, 1],
  fc: 2
}, {
  lngs: ['ro'],
  nr: [1, 2, 20],
  fc: 20
}, {
  lngs: ['sl'],
  nr: [5, 1, 2, 3],
  fc: 21
}, {
  lngs: ['he', 'iw'],
  nr: [1, 2, 20, 21],
  fc: 22
}];
var _rulesPluralsTypes = {
  1: function _(n) {
    return Number(n > 1);
  },
  2: function _(n) {
    return Number(n != 1);
  },
  3: function _(n) {
    return 0;
  },
  4: function _(n) {
    return Number(n % 10 == 1 && n % 100 != 11 ? 0 : n % 10 >= 2 && n % 10 <= 4 && (n % 100 < 10 || n % 100 >= 20) ? 1 : 2);
  },
  5: function _(n) {
    return Number(n == 0 ? 0 : n == 1 ? 1 : n == 2 ? 2 : n % 100 >= 3 && n % 100 <= 10 ? 3 : n % 100 >= 11 ? 4 : 5);
  },
  6: function _(n) {
    return Number(n == 1 ? 0 : n >= 2 && n <= 4 ? 1 : 2);
  },
  7: function _(n) {
    return Number(n == 1 ? 0 : n % 10 >= 2 && n % 10 <= 4 && (n % 100 < 10 || n % 100 >= 20) ? 1 : 2);
  },
  8: function _(n) {
    return Number(n == 1 ? 0 : n == 2 ? 1 : n != 8 && n != 11 ? 2 : 3);
  },
  9: function _(n) {
    return Number(n >= 2);
  },
  10: function _(n) {
    return Number(n == 1 ? 0 : n == 2 ? 1 : n < 7 ? 2 : n < 11 ? 3 : 4);
  },
  11: function _(n) {
    return Number(n == 1 || n == 11 ? 0 : n == 2 || n == 12 ? 1 : n > 2 && n < 20 ? 2 : 3);
  },
  12: function _(n) {
    return Number(n % 10 != 1 || n % 100 == 11);
  },
  13: function _(n) {
    return Number(n !== 0);
  },
  14: function _(n) {
    return Number(n == 1 ? 0 : n == 2 ? 1 : n == 3 ? 2 : 3);
  },
  15: function _(n) {
    return Number(n % 10 == 1 && n % 100 != 11 ? 0 : n % 10 >= 2 && (n % 100 < 10 || n % 100 >= 20) ? 1 : 2);
  },
  16: function _(n) {
    return Number(n % 10 == 1 && n % 100 != 11 ? 0 : n !== 0 ? 1 : 2);
  },
  17: function _(n) {
    return Number(n == 1 || n % 10 == 1 && n % 100 != 11 ? 0 : 1);
  },
  18: function _(n) {
    return Number(n == 0 ? 0 : n == 1 ? 1 : 2);
  },
  19: function _(n) {
    return Number(n == 1 ? 0 : n == 0 || n % 100 > 1 && n % 100 < 11 ? 1 : n % 100 > 10 && n % 100 < 20 ? 2 : 3);
  },
  20: function _(n) {
    return Number(n == 1 ? 0 : n == 0 || n % 100 > 0 && n % 100 < 20 ? 1 : 2);
  },
  21: function _(n) {
    return Number(n % 100 == 1 ? 1 : n % 100 == 2 ? 2 : n % 100 == 3 || n % 100 == 4 ? 3 : 0);
  },
  22: function _(n) {
    return Number(n == 1 ? 0 : n == 2 ? 1 : (n < 0 || n > 10) && n % 10 == 0 ? 2 : 3);
  }
};

function createRules() {
  var rules = {};
  sets.forEach(function (set) {
    set.lngs.forEach(function (l) {
      rules[l] = {
        numbers: set.nr,
        plurals: _rulesPluralsTypes[set.fc]
      };
    });
  });
  return rules;
}

var PluralResolver = function () {
  function PluralResolver(languageUtils) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    classCallCheck_classCallCheck(this, PluralResolver);

    this.languageUtils = languageUtils;
    this.options = options;
    this.logger = baseLogger.create('pluralResolver');
    this.rules = createRules();
  }

  createClass_createClass(PluralResolver, [{
    key: "addRule",
    value: function addRule(lng, obj) {
      this.rules[lng] = obj;
    }
  }, {
    key: "getRule",
    value: function getRule(code) {
      return this.rules[code] || this.rules[this.languageUtils.getLanguagePartFromCode(code)];
    }
  }, {
    key: "needsPlural",
    value: function needsPlural(code) {
      var rule = this.getRule(code);
      return rule && rule.numbers.length > 1;
    }
  }, {
    key: "getPluralFormsOfKey",
    value: function getPluralFormsOfKey(code, key) {
      return this.getSuffixes(code).map(function (suffix) {
        return key + suffix;
      });
    }
  }, {
    key: "getSuffixes",
    value: function getSuffixes(code) {
      var _this = this;

      var rule = this.getRule(code);

      if (!rule) {
        return [];
      }

      return rule.numbers.map(function (number) {
        return _this.getSuffix(code, number);
      });
    }
  }, {
    key: "getSuffix",
    value: function getSuffix(code, count) {
      var _this2 = this;

      var rule = this.getRule(code);

      if (rule) {
        var idx = rule.noAbs ? rule.plurals(count) : rule.plurals(Math.abs(count));
        var suffix = rule.numbers[idx];

        if (this.options.simplifyPluralSuffix && rule.numbers.length === 2 && rule.numbers[0] === 1) {
          if (suffix === 2) {
            suffix = 'plural';
          } else if (suffix === 1) {
            suffix = '';
          }
        }

        var returnSuffix = function returnSuffix() {
          return _this2.options.prepend && suffix.toString() ? _this2.options.prepend + suffix.toString() : suffix.toString();
        };

        if (this.options.compatibilityJSON === 'v1') {
          if (suffix === 1) return '';
          if (typeof suffix === 'number') return "_plural_".concat(suffix.toString());
          return returnSuffix();
        } else if (this.options.compatibilityJSON === 'v2') {
          return returnSuffix();
        } else if (this.options.simplifyPluralSuffix && rule.numbers.length === 2 && rule.numbers[0] === 1) {
          return returnSuffix();
        }

        return this.options.prepend && idx.toString() ? this.options.prepend + idx.toString() : idx.toString();
      }

      this.logger.warn("no plural rule found for: ".concat(code));
      return '';
    }
  }]);

  return PluralResolver;
}();

var Interpolator = function () {
  function Interpolator() {
    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    classCallCheck_classCallCheck(this, Interpolator);

    this.logger = baseLogger.create('interpolator');
    this.options = options;

    this.format = options.interpolation && options.interpolation.format || function (value) {
      return value;
    };

    this.init(options);
  }

  createClass_createClass(Interpolator, [{
    key: "init",
    value: function init() {
      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      if (!options.interpolation) options.interpolation = {
        escapeValue: true
      };
      var iOpts = options.interpolation;
      this.escape = iOpts.escape !== undefined ? iOpts.escape : i18next_escape;
      this.escapeValue = iOpts.escapeValue !== undefined ? iOpts.escapeValue : true;
      this.useRawValueToEscape = iOpts.useRawValueToEscape !== undefined ? iOpts.useRawValueToEscape : false;
      this.prefix = iOpts.prefix ? regexEscape(iOpts.prefix) : iOpts.prefixEscaped || '{{';
      this.suffix = iOpts.suffix ? regexEscape(iOpts.suffix) : iOpts.suffixEscaped || '}}';
      this.formatSeparator = iOpts.formatSeparator ? iOpts.formatSeparator : iOpts.formatSeparator || ',';
      this.unescapePrefix = iOpts.unescapeSuffix ? '' : iOpts.unescapePrefix || '-';
      this.unescapeSuffix = this.unescapePrefix ? '' : iOpts.unescapeSuffix || '';
      this.nestingPrefix = iOpts.nestingPrefix ? regexEscape(iOpts.nestingPrefix) : iOpts.nestingPrefixEscaped || regexEscape('$t(');
      this.nestingSuffix = iOpts.nestingSuffix ? regexEscape(iOpts.nestingSuffix) : iOpts.nestingSuffixEscaped || regexEscape(')');
      this.nestingOptionsSeparator = iOpts.nestingOptionsSeparator ? iOpts.nestingOptionsSeparator : iOpts.nestingOptionsSeparator || ',';
      this.maxReplaces = iOpts.maxReplaces ? iOpts.maxReplaces : 1000;
      this.alwaysFormat = iOpts.alwaysFormat !== undefined ? iOpts.alwaysFormat : false;
      this.resetRegExp();
    }
  }, {
    key: "reset",
    value: function reset() {
      if (this.options) this.init(this.options);
    }
  }, {
    key: "resetRegExp",
    value: function resetRegExp() {
      var regexpStr = "".concat(this.prefix, "(.+?)").concat(this.suffix);
      this.regexp = new RegExp(regexpStr, 'g');
      var regexpUnescapeStr = "".concat(this.prefix).concat(this.unescapePrefix, "(.+?)").concat(this.unescapeSuffix).concat(this.suffix);
      this.regexpUnescape = new RegExp(regexpUnescapeStr, 'g');
      var nestingRegexpStr = "".concat(this.nestingPrefix, "(.+?)").concat(this.nestingSuffix);
      this.nestingRegexp = new RegExp(nestingRegexpStr, 'g');
    }
  }, {
    key: "interpolate",
    value: function interpolate(str, data, lng, options) {
      var _this = this;

      var match;
      var value;
      var replaces;
      var defaultData = this.options && this.options.interpolation && this.options.interpolation.defaultVariables || {};

      function regexSafe(val) {
        return val.replace(/\$/g, '$$$$');
      }

      var handleFormat = function handleFormat(key) {
        if (key.indexOf(_this.formatSeparator) < 0) {
          var path = getPathWithDefaults(data, defaultData, key);
          return _this.alwaysFormat ? _this.format(path, undefined, lng, objectSpread_objectSpread({}, options, data, {
            interpolationkey: key
          })) : path;
        }

        var p = key.split(_this.formatSeparator);
        var k = p.shift().trim();
        var f = p.join(_this.formatSeparator).trim();
        return _this.format(getPathWithDefaults(data, defaultData, k), f, lng, objectSpread_objectSpread({}, options, data, {
          interpolationkey: k
        }));
      };

      this.resetRegExp();
      var missingInterpolationHandler = options && options.missingInterpolationHandler || this.options.missingInterpolationHandler;
      var skipOnVariables = options && options.interpolation && options.interpolation.skipOnVariables || this.options.interpolation.skipOnVariables;
      var todos = [{
        regex: this.regexpUnescape,
        safeValue: function safeValue(val) {
          return regexSafe(val);
        }
      }, {
        regex: this.regexp,
        safeValue: function safeValue(val) {
          return _this.escapeValue ? regexSafe(_this.escape(val)) : regexSafe(val);
        }
      }];
      todos.forEach(function (todo) {
        replaces = 0;

        while (match = todo.regex.exec(str)) {
          value = handleFormat(match[1].trim());

          if (value === undefined) {
            if (typeof missingInterpolationHandler === 'function') {
              var temp = missingInterpolationHandler(str, match, options);
              value = typeof temp === 'string' ? temp : '';
            } else if (skipOnVariables) {
              value = match[0];
              continue;
            } else {
              _this.logger.warn("missed to pass in variable ".concat(match[1], " for interpolating ").concat(str));

              value = '';
            }
          } else if (typeof value !== 'string' && !_this.useRawValueToEscape) {
            value = makeString(value);
          }

          var safeValue = todo.safeValue(value);
          str = str.replace(match[0], safeValue);

          if (skipOnVariables) {
            todo.regex.lastIndex += safeValue.length;
            todo.regex.lastIndex -= match[0].length;
          } else {
            todo.regex.lastIndex = 0;
          }

          replaces++;

          if (replaces >= _this.maxReplaces) {
            break;
          }
        }
      });
      return str;
    }
  }, {
    key: "nest",
    value: function nest(str, fc) {
      var _this2 = this;

      var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
      var match;
      var value;

      var clonedOptions = objectSpread_objectSpread({}, options);

      clonedOptions.applyPostProcessor = false;
      delete clonedOptions.defaultValue;

      function handleHasOptions(key, inheritedOptions) {
        var sep = this.nestingOptionsSeparator;
        if (key.indexOf(sep) < 0) return key;
        var c = key.split(new RegExp("".concat(sep, "[ ]*{")));
        var optionsString = "{".concat(c[1]);
        key = c[0];
        optionsString = this.interpolate(optionsString, clonedOptions);
        optionsString = optionsString.replace(/'/g, '"');

        try {
          clonedOptions = JSON.parse(optionsString);
          if (inheritedOptions) clonedOptions = objectSpread_objectSpread({}, inheritedOptions, clonedOptions);
        } catch (e) {
          this.logger.warn("failed parsing options string in nesting for key ".concat(key), e);
          return "".concat(key).concat(sep).concat(optionsString);
        }

        delete clonedOptions.defaultValue;
        return key;
      }

      while (match = this.nestingRegexp.exec(str)) {
        var formatters = [];
        var doReduce = false;

        if (match[0].indexOf(this.formatSeparator) !== -1 && !/{.*}/.test(match[1])) {
          var r = match[1].split(this.formatSeparator).map(function (elem) {
            return elem.trim();
          });
          match[1] = r.shift();
          formatters = r;
          doReduce = true;
        }

        value = fc(handleHasOptions.call(this, match[1].trim(), clonedOptions), clonedOptions);
        if (value && match[0] === str && typeof value !== 'string') return value;
        if (typeof value !== 'string') value = makeString(value);

        if (!value) {
          this.logger.warn("missed to resolve ".concat(match[1], " for nesting ").concat(str));
          value = '';
        }

        if (doReduce) {
          value = formatters.reduce(function (v, f) {
            return _this2.format(v, f, options.lng, objectSpread_objectSpread({}, options, {
              interpolationkey: match[1].trim()
            }));
          }, value.trim());
        }

        str = str.replace(match[0], value);
        this.regexp.lastIndex = 0;
      }

      return str;
    }
  }]);

  return Interpolator;
}();

function remove(arr, what) {
  var found = arr.indexOf(what);

  while (found !== -1) {
    arr.splice(found, 1);
    found = arr.indexOf(what);
  }
}

var Connector = function (_EventEmitter) {
  _inherits(Connector, _EventEmitter);

  function Connector(backend, store, services) {
    var _this;

    var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};

    classCallCheck_classCallCheck(this, Connector);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(Connector).call(this));

    if (isIE10) {
      EventEmitter.call(_assertThisInitialized(_this));
    }

    _this.backend = backend;
    _this.store = store;
    _this.services = services;
    _this.languageUtils = services.languageUtils;
    _this.options = options;
    _this.logger = baseLogger.create('backendConnector');
    _this.state = {};
    _this.queue = [];

    if (_this.backend && _this.backend.init) {
      _this.backend.init(services, options.backend, options);
    }

    return _this;
  }

  createClass_createClass(Connector, [{
    key: "queueLoad",
    value: function queueLoad(languages, namespaces, options, callback) {
      var _this2 = this;

      var toLoad = [];
      var pending = [];
      var toLoadLanguages = [];
      var toLoadNamespaces = [];
      languages.forEach(function (lng) {
        var hasAllNamespaces = true;
        namespaces.forEach(function (ns) {
          var name = "".concat(lng, "|").concat(ns);

          if (!options.reload && _this2.store.hasResourceBundle(lng, ns)) {
            _this2.state[name] = 2;
          } else if (_this2.state[name] < 0) ; else if (_this2.state[name] === 1) {
            if (pending.indexOf(name) < 0) pending.push(name);
          } else {
            _this2.state[name] = 1;
            hasAllNamespaces = false;
            if (pending.indexOf(name) < 0) pending.push(name);
            if (toLoad.indexOf(name) < 0) toLoad.push(name);
            if (toLoadNamespaces.indexOf(ns) < 0) toLoadNamespaces.push(ns);
          }
        });
        if (!hasAllNamespaces) toLoadLanguages.push(lng);
      });

      if (toLoad.length || pending.length) {
        this.queue.push({
          pending: pending,
          loaded: {},
          errors: [],
          callback: callback
        });
      }

      return {
        toLoad: toLoad,
        pending: pending,
        toLoadLanguages: toLoadLanguages,
        toLoadNamespaces: toLoadNamespaces
      };
    }
  }, {
    key: "loaded",
    value: function loaded(name, err, data) {
      var s = name.split('|');
      var lng = s[0];
      var ns = s[1];
      if (err) this.emit('failedLoading', lng, ns, err);

      if (data) {
        this.store.addResourceBundle(lng, ns, data);
      }

      this.state[name] = err ? -1 : 2;
      var loaded = {};
      this.queue.forEach(function (q) {
        pushPath(q.loaded, [lng], ns);
        remove(q.pending, name);
        if (err) q.errors.push(err);

        if (q.pending.length === 0 && !q.done) {
          Object.keys(q.loaded).forEach(function (l) {
            if (!loaded[l]) loaded[l] = [];

            if (q.loaded[l].length) {
              q.loaded[l].forEach(function (ns) {
                if (loaded[l].indexOf(ns) < 0) loaded[l].push(ns);
              });
            }
          });
          q.done = true;

          if (q.errors.length) {
            q.callback(q.errors);
          } else {
            q.callback();
          }
        }
      });
      this.emit('loaded', loaded);
      this.queue = this.queue.filter(function (q) {
        return !q.done;
      });
    }
  }, {
    key: "read",
    value: function read(lng, ns, fcName) {
      var _this3 = this;

      var tried = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 0;
      var wait = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : 350;
      var callback = arguments.length > 5 ? arguments[5] : undefined;
      if (!lng.length) return callback(null, {});
      return this.backend[fcName](lng, ns, function (err, data) {
        if (err && data && tried < 5) {
          setTimeout(function () {
            _this3.read.call(_this3, lng, ns, fcName, tried + 1, wait * 2, callback);
          }, wait);
          return;
        }

        callback(err, data);
      });
    }
  }, {
    key: "prepareLoading",
    value: function prepareLoading(languages, namespaces) {
      var _this4 = this;

      var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
      var callback = arguments.length > 3 ? arguments[3] : undefined;

      if (!this.backend) {
        this.logger.warn('No backend was added via i18next.use. Will not load resources.');
        return callback && callback();
      }

      if (typeof languages === 'string') languages = this.languageUtils.toResolveHierarchy(languages);
      if (typeof namespaces === 'string') namespaces = [namespaces];
      var toLoad = this.queueLoad(languages, namespaces, options, callback);

      if (!toLoad.toLoad.length) {
        if (!toLoad.pending.length) callback();
        return null;
      }

      toLoad.toLoad.forEach(function (name) {
        _this4.loadOne(name);
      });
    }
  }, {
    key: "load",
    value: function load(languages, namespaces, callback) {
      this.prepareLoading(languages, namespaces, {}, callback);
    }
  }, {
    key: "reload",
    value: function reload(languages, namespaces, callback) {
      this.prepareLoading(languages, namespaces, {
        reload: true
      }, callback);
    }
  }, {
    key: "loadOne",
    value: function loadOne(name) {
      var _this5 = this;

      var prefix = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
      var s = name.split('|');
      var lng = s[0];
      var ns = s[1];
      this.read(lng, ns, 'read', undefined, undefined, function (err, data) {
        if (err) _this5.logger.warn("".concat(prefix, "loading namespace ").concat(ns, " for language ").concat(lng, " failed"), err);
        if (!err && data) _this5.logger.log("".concat(prefix, "loaded namespace ").concat(ns, " for language ").concat(lng), data);

        _this5.loaded(name, err, data);
      });
    }
  }, {
    key: "saveMissing",
    value: function saveMissing(languages, namespace, key, fallbackValue, isUpdate) {
      var options = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : {};

      if (this.services.utils && this.services.utils.hasLoadedNamespace && !this.services.utils.hasLoadedNamespace(namespace)) {
        this.logger.warn("did not save key \"".concat(key, "\" as the namespace \"").concat(namespace, "\" was not yet loaded"), 'This means something IS WRONG in your setup. You access the t function before i18next.init / i18next.loadNamespace / i18next.changeLanguage was done. Wait for the callback or Promise to resolve before accessing it!!!');
        return;
      }

      if (key === undefined || key === null || key === '') return;

      if (this.backend && this.backend.create) {
        this.backend.create(languages, namespace, key, fallbackValue, null, objectSpread_objectSpread({}, options, {
          isUpdate: isUpdate
        }));
      }

      if (!languages || !languages[0]) return;
      this.store.addResource(languages[0], namespace, key, fallbackValue);
    }
  }]);

  return Connector;
}(EventEmitter);

function get() {
  return {
    debug: false,
    initImmediate: true,
    ns: ['translation'],
    defaultNS: ['translation'],
    fallbackLng: ['dev'],
    fallbackNS: false,
    whitelist: false,
    nonExplicitWhitelist: false,
    supportedLngs: false,
    nonExplicitSupportedLngs: false,
    load: 'all',
    preload: false,
    simplifyPluralSuffix: true,
    keySeparator: '.',
    nsSeparator: ':',
    pluralSeparator: '_',
    contextSeparator: '_',
    partialBundledLanguages: false,
    saveMissing: false,
    updateMissing: false,
    saveMissingTo: 'fallback',
    saveMissingPlurals: true,
    missingKeyHandler: false,
    missingInterpolationHandler: false,
    postProcess: false,
    postProcessPassResolved: false,
    returnNull: true,
    returnEmptyString: true,
    returnObjects: false,
    joinArrays: false,
    returnedObjectHandler: false,
    parseMissingKeyHandler: false,
    appendNamespaceToMissingKey: false,
    appendNamespaceToCIMode: false,
    overloadTranslationOptionHandler: function handle(args) {
      var ret = {};
      if (esm_typeof_typeof(args[1]) === 'object') ret = args[1];
      if (typeof args[1] === 'string') ret.defaultValue = args[1];
      if (typeof args[2] === 'string') ret.tDescription = args[2];

      if (esm_typeof_typeof(args[2]) === 'object' || esm_typeof_typeof(args[3]) === 'object') {
        var options = args[3] || args[2];
        Object.keys(options).forEach(function (key) {
          ret[key] = options[key];
        });
      }

      return ret;
    },
    interpolation: {
      escapeValue: true,
      format: function format(value, _format, lng, options) {
        return value;
      },
      prefix: '{{',
      suffix: '}}',
      formatSeparator: ',',
      unescapePrefix: '-',
      nestingPrefix: '$t(',
      nestingSuffix: ')',
      nestingOptionsSeparator: ',',
      maxReplaces: 1000,
      skipOnVariables: false
    }
  };
}
function transformOptions(options) {
  if (typeof options.ns === 'string') options.ns = [options.ns];
  if (typeof options.fallbackLng === 'string') options.fallbackLng = [options.fallbackLng];
  if (typeof options.fallbackNS === 'string') options.fallbackNS = [options.fallbackNS];

  if (options.whitelist) {
    if (options.whitelist && options.whitelist.indexOf('cimode') < 0) {
      options.whitelist = options.whitelist.concat(['cimode']);
    }

    options.supportedLngs = options.whitelist;
  }

  if (options.nonExplicitWhitelist) {
    options.nonExplicitSupportedLngs = options.nonExplicitWhitelist;
  }

  if (options.supportedLngs && options.supportedLngs.indexOf('cimode') < 0) {
    options.supportedLngs = options.supportedLngs.concat(['cimode']);
  }

  return options;
}

function noop() {}

var I18n = function (_EventEmitter) {
  _inherits(I18n, _EventEmitter);

  function I18n() {
    var _this;

    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var callback = arguments.length > 1 ? arguments[1] : undefined;

    classCallCheck_classCallCheck(this, I18n);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(I18n).call(this));

    if (isIE10) {
      EventEmitter.call(_assertThisInitialized(_this));
    }

    _this.options = transformOptions(options);
    _this.services = {};
    _this.logger = baseLogger;
    _this.modules = {
      external: []
    };

    if (callback && !_this.isInitialized && !options.isClone) {
      if (!_this.options.initImmediate) {
        _this.init(options, callback);

        return _possibleConstructorReturn(_this, _assertThisInitialized(_this));
      }

      setTimeout(function () {
        _this.init(options, callback);
      }, 0);
    }

    return _this;
  }

  createClass_createClass(I18n, [{
    key: "init",
    value: function init() {
      var _this2 = this;

      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var callback = arguments.length > 1 ? arguments[1] : undefined;

      if (typeof options === 'function') {
        callback = options;
        options = {};
      }

      if (options.whitelist && !options.supportedLngs) {
        this.logger.deprecate('whitelist', 'option "whitelist" will be renamed to "supportedLngs" in the next major - please make sure to rename this option asap.');
      }

      if (options.nonExplicitWhitelist && !options.nonExplicitSupportedLngs) {
        this.logger.deprecate('whitelist', 'options "nonExplicitWhitelist" will be renamed to "nonExplicitSupportedLngs" in the next major - please make sure to rename this option asap.');
      }

      this.options = objectSpread_objectSpread({}, get(), this.options, transformOptions(options));
      this.format = this.options.interpolation.format;
      if (!callback) callback = noop;

      function createClassOnDemand(ClassOrObject) {
        if (!ClassOrObject) return null;
        if (typeof ClassOrObject === 'function') return new ClassOrObject();
        return ClassOrObject;
      }

      if (!this.options.isClone) {
        if (this.modules.logger) {
          baseLogger.init(createClassOnDemand(this.modules.logger), this.options);
        } else {
          baseLogger.init(null, this.options);
        }

        var lu = new LanguageUtil(this.options);
        this.store = new ResourceStore(this.options.resources, this.options);
        var s = this.services;
        s.logger = baseLogger;
        s.resourceStore = this.store;
        s.languageUtils = lu;
        s.pluralResolver = new PluralResolver(lu, {
          prepend: this.options.pluralSeparator,
          compatibilityJSON: this.options.compatibilityJSON,
          simplifyPluralSuffix: this.options.simplifyPluralSuffix
        });
        s.interpolator = new Interpolator(this.options);
        s.utils = {
          hasLoadedNamespace: this.hasLoadedNamespace.bind(this)
        };
        s.backendConnector = new Connector(createClassOnDemand(this.modules.backend), s.resourceStore, s, this.options);
        s.backendConnector.on('*', function (event) {
          for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
            args[_key - 1] = arguments[_key];
          }

          _this2.emit.apply(_this2, [event].concat(args));
        });

        if (this.modules.languageDetector) {
          s.languageDetector = createClassOnDemand(this.modules.languageDetector);
          s.languageDetector.init(s, this.options.detection, this.options);
        }

        if (this.modules.i18nFormat) {
          s.i18nFormat = createClassOnDemand(this.modules.i18nFormat);
          if (s.i18nFormat.init) s.i18nFormat.init(this);
        }

        this.translator = new Translator(this.services, this.options);
        this.translator.on('*', function (event) {
          for (var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
            args[_key2 - 1] = arguments[_key2];
          }

          _this2.emit.apply(_this2, [event].concat(args));
        });
        this.modules.external.forEach(function (m) {
          if (m.init) m.init(_this2);
        });
      }

      if (this.options.fallbackLng && !this.services.languageDetector && !this.options.lng) {
        var codes = this.services.languageUtils.getFallbackCodes(this.options.fallbackLng);
        if (codes.length > 0 && codes[0] !== 'dev') this.options.lng = codes[0];
      }

      if (!this.services.languageDetector && !this.options.lng) {
        this.logger.warn('init: no languageDetector is used and no lng is defined');
      }

      var storeApi = ['getResource', 'hasResourceBundle', 'getResourceBundle', 'getDataByLanguage'];
      storeApi.forEach(function (fcName) {
        _this2[fcName] = function () {
          var _this2$store;

          return (_this2$store = _this2.store)[fcName].apply(_this2$store, arguments);
        };
      });
      var storeApiChained = ['addResource', 'addResources', 'addResourceBundle', 'removeResourceBundle'];
      storeApiChained.forEach(function (fcName) {
        _this2[fcName] = function () {
          var _this2$store2;

          (_this2$store2 = _this2.store)[fcName].apply(_this2$store2, arguments);

          return _this2;
        };
      });
      var deferred = defer();

      var load = function load() {
        var finish = function finish(err, t) {
          if (_this2.isInitialized && !_this2.initializedStoreOnce) _this2.logger.warn('init: i18next is already initialized. You should call init just once!');
          _this2.isInitialized = true;
          if (!_this2.options.isClone) _this2.logger.log('initialized', _this2.options);

          _this2.emit('initialized', _this2.options);

          deferred.resolve(t);
          callback(err, t);
        };

        if (_this2.languages && _this2.options.compatibilityAPI !== 'v1' && !_this2.isInitialized) return finish(null, _this2.t.bind(_this2));

        _this2.changeLanguage(_this2.options.lng, finish);
      };

      if (this.options.resources || !this.options.initImmediate) {
        load();
      } else {
        setTimeout(load, 0);
      }

      return deferred;
    }
  }, {
    key: "loadResources",
    value: function loadResources(language) {
      var _this3 = this;

      var callback = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : noop;
      var usedCallback = callback;
      var usedLng = typeof language === 'string' ? language : this.language;
      if (typeof language === 'function') usedCallback = language;

      if (!this.options.resources || this.options.partialBundledLanguages) {
        if (usedLng && usedLng.toLowerCase() === 'cimode') return usedCallback();
        var toLoad = [];

        var append = function append(lng) {
          if (!lng) return;

          var lngs = _this3.services.languageUtils.toResolveHierarchy(lng);

          lngs.forEach(function (l) {
            if (toLoad.indexOf(l) < 0) toLoad.push(l);
          });
        };

        if (!usedLng) {
          var fallbacks = this.services.languageUtils.getFallbackCodes(this.options.fallbackLng);
          fallbacks.forEach(function (l) {
            return append(l);
          });
        } else {
          append(usedLng);
        }

        if (this.options.preload) {
          this.options.preload.forEach(function (l) {
            return append(l);
          });
        }

        this.services.backendConnector.load(toLoad, this.options.ns, usedCallback);
      } else {
        usedCallback(null);
      }
    }
  }, {
    key: "reloadResources",
    value: function reloadResources(lngs, ns, callback) {
      var deferred = defer();
      if (!lngs) lngs = this.languages;
      if (!ns) ns = this.options.ns;
      if (!callback) callback = noop;
      this.services.backendConnector.reload(lngs, ns, function (err) {
        deferred.resolve();
        callback(err);
      });
      return deferred;
    }
  }, {
    key: "use",
    value: function use(module) {
      if (!module) throw new Error('You are passing an undefined module! Please check the object you are passing to i18next.use()');
      if (!module.type) throw new Error('You are passing a wrong module! Please check the object you are passing to i18next.use()');

      if (module.type === 'backend') {
        this.modules.backend = module;
      }

      if (module.type === 'logger' || module.log && module.warn && module.error) {
        this.modules.logger = module;
      }

      if (module.type === 'languageDetector') {
        this.modules.languageDetector = module;
      }

      if (module.type === 'i18nFormat') {
        this.modules.i18nFormat = module;
      }

      if (module.type === 'postProcessor') {
        postProcessor.addPostProcessor(module);
      }

      if (module.type === '3rdParty') {
        this.modules.external.push(module);
      }

      return this;
    }
  }, {
    key: "changeLanguage",
    value: function changeLanguage(lng, callback) {
      var _this4 = this;

      this.isLanguageChangingTo = lng;
      var deferred = defer();
      this.emit('languageChanging', lng);

      var done = function done(err, l) {
        if (l) {
          _this4.language = l;
          _this4.languages = _this4.services.languageUtils.toResolveHierarchy(l);

          _this4.translator.changeLanguage(l);

          _this4.isLanguageChangingTo = undefined;

          _this4.emit('languageChanged', l);

          _this4.logger.log('languageChanged', l);
        } else {
          _this4.isLanguageChangingTo = undefined;
        }

        deferred.resolve(function () {
          return _this4.t.apply(_this4, arguments);
        });
        if (callback) callback(err, function () {
          return _this4.t.apply(_this4, arguments);
        });
      };

      var setLng = function setLng(lngs) {
        if (!lng && !lngs && _this4.services.languageDetector) lngs = [];
        var l = typeof lngs === 'string' ? lngs : _this4.services.languageUtils.getBestMatchFromCodes(lngs);

        if (l) {
          if (!_this4.language) {
            _this4.language = l;
            _this4.languages = _this4.services.languageUtils.toResolveHierarchy(l);
          }

          if (!_this4.translator.language) _this4.translator.changeLanguage(l);
          if (_this4.services.languageDetector) _this4.services.languageDetector.cacheUserLanguage(l);
        }

        _this4.loadResources(l, function (err) {
          done(err, l);
        });
      };

      if (!lng && this.services.languageDetector && !this.services.languageDetector.async) {
        setLng(this.services.languageDetector.detect());
      } else if (!lng && this.services.languageDetector && this.services.languageDetector.async) {
        this.services.languageDetector.detect(setLng);
      } else {
        setLng(lng);
      }

      return deferred;
    }
  }, {
    key: "getFixedT",
    value: function getFixedT(lng, ns, keyPrefix) {
      var _this5 = this;

      var fixedT = function fixedT(key, opts) {
        var options;

        if (esm_typeof_typeof(opts) !== 'object') {
          for (var _len3 = arguments.length, rest = new Array(_len3 > 2 ? _len3 - 2 : 0), _key3 = 2; _key3 < _len3; _key3++) {
            rest[_key3 - 2] = arguments[_key3];
          }

          options = _this5.options.overloadTranslationOptionHandler([key, opts].concat(rest));
        } else {
          options = objectSpread_objectSpread({}, opts);
        }

        options.lng = options.lng || fixedT.lng;
        options.lngs = options.lngs || fixedT.lngs;
        options.ns = options.ns || fixedT.ns;
        var keySeparator = _this5.options.keySeparator || '.';
        var resultKey = keyPrefix ? "".concat(keyPrefix).concat(keySeparator).concat(key) : key;
        return _this5.t(resultKey, options);
      };

      if (typeof lng === 'string') {
        fixedT.lng = lng;
      } else {
        fixedT.lngs = lng;
      }

      fixedT.ns = ns;
      fixedT.keyPrefix = keyPrefix;
      return fixedT;
    }
  }, {
    key: "t",
    value: function t() {
      var _this$translator;

      return this.translator && (_this$translator = this.translator).translate.apply(_this$translator, arguments);
    }
  }, {
    key: "exists",
    value: function exists() {
      var _this$translator2;

      return this.translator && (_this$translator2 = this.translator).exists.apply(_this$translator2, arguments);
    }
  }, {
    key: "setDefaultNamespace",
    value: function setDefaultNamespace(ns) {
      this.options.defaultNS = ns;
    }
  }, {
    key: "hasLoadedNamespace",
    value: function hasLoadedNamespace(ns) {
      var _this6 = this;

      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      if (!this.isInitialized) {
        this.logger.warn('hasLoadedNamespace: i18next was not initialized', this.languages);
        return false;
      }

      if (!this.languages || !this.languages.length) {
        this.logger.warn('hasLoadedNamespace: i18n.languages were undefined or empty', this.languages);
        return false;
      }

      var lng = this.languages[0];
      var fallbackLng = this.options ? this.options.fallbackLng : false;
      var lastLng = this.languages[this.languages.length - 1];
      if (lng.toLowerCase() === 'cimode') return true;

      var loadNotPending = function loadNotPending(l, n) {
        var loadState = _this6.services.backendConnector.state["".concat(l, "|").concat(n)];

        return loadState === -1 || loadState === 2;
      };

      if (options.precheck) {
        var preResult = options.precheck(this, loadNotPending);
        if (preResult !== undefined) return preResult;
      }

      if (this.hasResourceBundle(lng, ns)) return true;
      if (!this.services.backendConnector.backend) return true;
      if (loadNotPending(lng, ns) && (!fallbackLng || loadNotPending(lastLng, ns))) return true;
      return false;
    }
  }, {
    key: "loadNamespaces",
    value: function loadNamespaces(ns, callback) {
      var _this7 = this;

      var deferred = defer();

      if (!this.options.ns) {
        callback && callback();
        return Promise.resolve();
      }

      if (typeof ns === 'string') ns = [ns];
      ns.forEach(function (n) {
        if (_this7.options.ns.indexOf(n) < 0) _this7.options.ns.push(n);
      });
      this.loadResources(function (err) {
        deferred.resolve();
        if (callback) callback(err);
      });
      return deferred;
    }
  }, {
    key: "loadLanguages",
    value: function loadLanguages(lngs, callback) {
      var deferred = defer();
      if (typeof lngs === 'string') lngs = [lngs];
      var preloaded = this.options.preload || [];
      var newLngs = lngs.filter(function (lng) {
        return preloaded.indexOf(lng) < 0;
      });

      if (!newLngs.length) {
        if (callback) callback();
        return Promise.resolve();
      }

      this.options.preload = preloaded.concat(newLngs);
      this.loadResources(function (err) {
        deferred.resolve();
        if (callback) callback(err);
      });
      return deferred;
    }
  }, {
    key: "dir",
    value: function dir(lng) {
      if (!lng) lng = this.languages && this.languages.length > 0 ? this.languages[0] : this.language;
      if (!lng) return 'rtl';
      var rtlLngs = ['ar', 'shu', 'sqr', 'ssh', 'xaa', 'yhd', 'yud', 'aao', 'abh', 'abv', 'acm', 'acq', 'acw', 'acx', 'acy', 'adf', 'ads', 'aeb', 'aec', 'afb', 'ajp', 'apc', 'apd', 'arb', 'arq', 'ars', 'ary', 'arz', 'auz', 'avl', 'ayh', 'ayl', 'ayn', 'ayp', 'bbz', 'pga', 'he', 'iw', 'ps', 'pbt', 'pbu', 'pst', 'prp', 'prd', 'ug', 'ur', 'ydd', 'yds', 'yih', 'ji', 'yi', 'hbo', 'men', 'xmn', 'fa', 'jpr', 'peo', 'pes', 'prs', 'dv', 'sam'];
      return rtlLngs.indexOf(this.services.languageUtils.getLanguagePartFromCode(lng)) >= 0 ? 'rtl' : 'ltr';
    }
  }, {
    key: "createInstance",
    value: function createInstance() {
      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var callback = arguments.length > 1 ? arguments[1] : undefined;
      return new I18n(options, callback);
    }
  }, {
    key: "cloneInstance",
    value: function cloneInstance() {
      var _this8 = this;

      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var callback = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : noop;

      var mergedOptions = objectSpread_objectSpread({}, this.options, options, {
        isClone: true
      });

      var clone = new I18n(mergedOptions);
      var membersToCopy = ['store', 'services', 'language'];
      membersToCopy.forEach(function (m) {
        clone[m] = _this8[m];
      });
      clone.services = objectSpread_objectSpread({}, this.services);
      clone.services.utils = {
        hasLoadedNamespace: clone.hasLoadedNamespace.bind(clone)
      };
      clone.translator = new Translator(clone.services, clone.options);
      clone.translator.on('*', function (event) {
        for (var _len4 = arguments.length, args = new Array(_len4 > 1 ? _len4 - 1 : 0), _key4 = 1; _key4 < _len4; _key4++) {
          args[_key4 - 1] = arguments[_key4];
        }

        clone.emit.apply(clone, [event].concat(args));
      });
      clone.init(mergedOptions, callback);
      clone.translator.options = clone.options;
      clone.translator.backendConnector.services.utils = {
        hasLoadedNamespace: clone.hasLoadedNamespace.bind(clone)
      };
      return clone;
    }
  }, {
    key: "toJSON",
    value: function toJSON() {
      return {
        options: this.options,
        store: this.store,
        language: this.language,
        languages: this.languages
      };
    }
  }]);

  return I18n;
}(EventEmitter);

var i18next = new I18n();

/* harmony default export */ var esm_i18next = (i18next);

;// CONCATENATED MODULE: ./node_modules/next-i18next/dist/esm/createClient/browser.js

/* harmony default export */ var browser = (function (config) {
  var instance = esm_i18next.createInstance(config);
  var initPromise;

  if (!instance.isInitialized) {
    var _config$use;

    config === null || config === void 0 ? void 0 : (_config$use = config.use) === null || _config$use === void 0 ? void 0 : _config$use.forEach(function (x) {
      return instance.use(x);
    });
    initPromise = instance.init(config);
  } else {
    initPromise = Promise.resolve(esm_i18next.t);
  }

  return {
    i18n: instance,
    initPromise: initPromise
  };
});
;// CONCATENATED MODULE: ./node_modules/next-i18next/dist/esm/appWithTranslation.js


var __jsx = react.createElement;

function appWithTranslation_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function appWithTranslation_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { appWithTranslation_ownKeys(Object(source), true).forEach(function (key) { defineProperty_defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { appWithTranslation_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }







var globalI18n = null;
var appWithTranslation = function appWithTranslation(WrappedComponent) {
  var configOverride = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

  var AppWithTranslation = function AppWithTranslation(props) {
    var _props$pageProps;

    var i18n = null;
    var locale = null;

    if (props === null || props === void 0 ? void 0 : (_props$pageProps = props.pageProps) === null || _props$pageProps === void 0 ? void 0 : _props$pageProps._nextI18Next) {
      var _userConfig;

      var userConfig = props.pageProps._nextI18Next.userConfig;
      var _props$pageProps$_nex = props.pageProps._nextI18Next,
          initialI18nStore = _props$pageProps$_nex.initialI18nStore,
          initialLocale = _props$pageProps$_nex.initialLocale;

      if (userConfig === null && configOverride === null) {
        throw new Error('appWithTranslation was called without a next-i18next config');
      }

      if (configOverride !== null) {
        userConfig = configOverride;
      }

      if (!((_userConfig = userConfig) === null || _userConfig === void 0 ? void 0 : _userConfig.i18n)) {
        throw new Error('appWithTranslation was called without config.i18n');
      }

      locale = initialLocale;

      var _createClient = browser(appWithTranslation_objectSpread(appWithTranslation_objectSpread({}, createConfig(appWithTranslation_objectSpread(appWithTranslation_objectSpread({}, userConfig), {}, {
        lng: initialLocale
      }))), {}, {
        lng: initialLocale,
        resources: initialI18nStore
      }));

      i18n = _createClient.i18n;
      (0,react.useMemo)(function () {
        globalI18n = i18n;
      }, [i18n]);
    }

    return i18n !== null ? __jsx(I18nextProvider, {
      i18n: i18n
    }, __jsx(WrappedComponent, (0,esm_extends/* default */.Z)({
      key: locale
    }, props))) : __jsx(WrappedComponent, (0,esm_extends/* default */.Z)({
      key: locale
    }, props));
  };

  return hoist_non_react_statics_cjs_default()(AppWithTranslation, WrappedComponent);
};
;// CONCATENATED MODULE: ./node_modules/next-i18next/dist/esm/index.js



/***/ }),

/***/ 82010:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "F": function() { return /* binding */ y; },
/* harmony export */   "f": function() { return /* binding */ $; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(55784);
const c=["light","dark"],i="(prefers-color-scheme: dark)",d="undefined"==typeof window,u=/*#__PURE__*/(0,react__WEBPACK_IMPORTED_MODULE_0__.createContext)(void 0),h={setTheme:e=>{},themes:[]},y=()=>{var e;return null!==(e=(0,react__WEBPACK_IMPORTED_MODULE_0__.useContext)(u))&&void 0!==e?e:h},$=r=>(0,react__WEBPACK_IMPORTED_MODULE_0__.useContext)(u)?/*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(react__WEBPACK_IMPORTED_MODULE_0__.Fragment,null,r.children):/*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(f,r),v=["light","dark"],f=({forcedTheme:t,disableTransitionOnChange:n=!1,enableSystem:l=!0,enableColorScheme:m=!0,storageKey:d="theme",themes:h=v,defaultTheme:y=(l?"system":"light"),attribute:$="data-theme",value:f,children:w,nonce:T})=>{const[E,k]=(0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(()=>S(d,y)),[C,L]=(0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(()=>S(d)),x=f?Object.values(f):h,I=(0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(e=>{let t=e;if(!t)return;"system"===e&&l&&(t=p());const r=f?f[t]:t,o=n?b():null,a=document.documentElement;if("class"===$?(a.classList.remove(...x),r&&a.classList.add(r)):r?a.setAttribute($,r):a.removeAttribute($),m){const e=c.includes(y)?y:null,n=c.includes(t)?t:e;a.style.colorScheme=n}null==o||o()},[]),O=(0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(e=>{k(e);try{localStorage.setItem(d,e)}catch(e){}},[t]),M=(0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(e=>{const n=p(e);L(n),"system"===E&&l&&!t&&I("system")},[E,t]);(0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(()=>{const e=window.matchMedia(i);return e.addListener(M),M(e),()=>e.removeListener(M)},[M]),(0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(()=>{const e=e=>{e.key===d&&O(e.newValue||y)};return window.addEventListener("storage",e),()=>window.removeEventListener("storage",e)},[O]),(0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(()=>{I(null!=t?t:E)},[t,E]);const A=(0,react__WEBPACK_IMPORTED_MODULE_0__.useMemo)(()=>({theme:E,setTheme:O,forcedTheme:t,resolvedTheme:"system"===E?C:E,themes:l?[...h,"system"]:h,systemTheme:l?C:void 0}),[E,O,t,C,l,h]);/*#__PURE__*/return react__WEBPACK_IMPORTED_MODULE_0__.createElement(u.Provider,{value:A},/*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(g,{forcedTheme:t,disableTransitionOnChange:n,enableSystem:l,enableColorScheme:m,storageKey:d,themes:h,defaultTheme:y,attribute:$,value:f,children:w,attrs:x,nonce:T}),w)},g=/*#__PURE__*/(0,react__WEBPACK_IMPORTED_MODULE_0__.memo)(({forcedTheme:t,storageKey:n,attribute:r,enableSystem:o,enableColorScheme:a,defaultTheme:s,value:l,attrs:m,nonce:d})=>{const u="system"===s,h="class"===r?`var d=document.documentElement,c=d.classList;c.remove(${m.map(e=>`'${e}'`).join(",")});`:`var d=document.documentElement,n='${r}',s='setAttribute';`,y=a?c.includes(s)&&s?`if(e==='light'||e==='dark'||!e)d.style.colorScheme=e||'${s}'`:"if(e==='light'||e==='dark')d.style.colorScheme=e":"",$=(e,t=!1,n=!0)=>{const o=l?l[e]:e,s=t?e+"|| ''":`'${o}'`;let m="";return a&&n&&!t&&c.includes(e)&&(m+=`d.style.colorScheme = '${e}';`),"class"===r?m+=t||o?`c.add(${s})`:"null":o&&(m+=`d[s](n,${s})`),m},v=t?`!function(){${h}${$(t)}}()`:o?`!function(){try{${h}var e=localStorage.getItem('${n}');if('system'===e||(!e&&${u})){var t='${i}',m=window.matchMedia(t);if(m.media!==t||m.matches){${$("dark")}}else{${$("light")}}}else if(e){${l?`var x=${JSON.stringify(l)};`:""}${$(l?"x[e]":"e",!0)}}${u?"":"else{"+$(s,!1,!1)+"}"}${y}}catch(e){}}()`:`!function(){try{${h}var e=localStorage.getItem('${n}');if(e){${l?`var x=${JSON.stringify(l)};`:""}${$(l?"x[e]":"e",!0)}}else{${$(s,!1,!1)};}${y}}catch(t){}}();`;/*#__PURE__*/return react__WEBPACK_IMPORTED_MODULE_0__.createElement("script",{nonce:d,dangerouslySetInnerHTML:{__html:v}})},()=>!0),S=(e,t)=>{if(d)return;let n;try{n=localStorage.getItem(e)||void 0}catch(e){}return n||t},b=()=>{const e=document.createElement("style");return e.appendChild(document.createTextNode("*{-webkit-transition:none!important;-moz-transition:none!important;-o-transition:none!important;-ms-transition:none!important;transition:none!important}")),document.head.appendChild(e),()=>{window.getComputedStyle(document.body),setTimeout(()=>{document.head.removeChild(e)},1)}},p=e=>(e||(e=window.matchMedia(i)),e.matches?"dark":"light");


/***/ }),

/***/ 83454:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var ref, ref1;
module.exports = ((ref = __webpack_require__.g.process) == null ? void 0 : ref.env) && typeof ((ref1 = __webpack_require__.g.process) == null ? void 0 : ref1.env) === "object" ? __webpack_require__.g.process : __webpack_require__(77663);

//# sourceMappingURL=process.js.map

/***/ }),

/***/ 6840:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/_app",
      function () {
        return __webpack_require__(89418);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 89038:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
/* harmony default export */ __webpack_exports__["Z"] = ({"src":"/_next/static/media/playee_full_text.3ea705a2.png","height":520,"width":1500,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAADCAYAAACuyE5IAAAAbUlEQVR4nGNkEMzm5BcSS5TgFfklwS9yTIxX6Ikkn6iQJL8oGx8Hz1NGBokiaT4u/vkSfCK3JfhE/0ryi3CJ8QgxyghK/OVh55rEyMDQx6Sq98ZYR+ne/W+/v/wRZE53Y2Z5f+Y/8/b3rIx63wDxrBpt0Wyj0wAAAABJRU5ErkJggg==","blurWidth":8,"blurHeight":3});

/***/ }),

/***/ 74050:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
/* harmony default export */ __webpack_exports__["Z"] = ({"src":"/_next/static/media/playee_full_text_dark.e167fca6.png","height":520,"width":1500,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAADCAQAAAAEwYbDAAAAPUlEQVR42mP4x/kv+1/qP+1/fP8U/qn/42b4J/1v578p/yb9mwuEs/7pMPxj+mf6T/ifwL/Qf4r/BP6xAQAS4B4Vf6r0rQAAAABJRU5ErkJggg==","blurWidth":8,"blurHeight":3});

/***/ }),

/***/ 8313:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
/* harmony default export */ __webpack_exports__["Z"] = ({"src":"/_next/static/media/playee_logo.23037ee0.png","height":1024,"width":1024,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAICAYAAADED76LAAABBklEQVR42g3JTUpCQQAH8P9MQ34FpoJWai0l6AhBEC2iVXSJoq1doDZ1gwjaBEkQdIAuEBRBVvhy1SqtFHzj+5iZ5zQzuf39yMVRdGiNO+NcsVx1YtWfJJ02h5mVNnHqmJw3w0iqSW5tCyhUHCwMvvshri4/IbS0bDRUbHXTYaWRQm05CxCH+RLF9m7e7R/0KYt17DL5FKr1LJ4ev6C1xfpGDYUiIzMLCsyPYvi+AaEOi0s5FEsZcC4QTt38BKB0LiF3rR6E0NNMIwgEPK+H69uOQ0WDSSPsx9sY3e6vU4kkrZt3vHpDvLQ5Kde1I3s7981IydMBjyhLKzw/jFBuGMBKNxjLk3+c6ocI8ffcpgAAAABJRU5ErkJggg==","blurWidth":8,"blurHeight":8});

/***/ }),

/***/ 34224:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "d": function() { return /* binding */ http; }
/* harmony export */ });
/* harmony import */ var axios__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(70594);

const BASE_API_URL = "https://api.playee.net";
const AUTH_PAGE = "/";
const http = axios__WEBPACK_IMPORTED_MODULE_0__/* ["default"].create */ .Z.create({
    baseURL: "".concat(BASE_API_URL),
    headers: {
        "Content-Type": "application/json"
    }
});


/***/ }),

/***/ 76711:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var app_configs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(54254);
/* harmony import */ var next_i18next__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(93378);


const interceptor = ($http)=>{
    $http.interceptors.request.use((config)=>{
        config.params = config.params || {};
        config.params["lang"] = next_i18next__WEBPACK_IMPORTED_MODULE_1__/* .i18n */ .ag === null || next_i18next__WEBPACK_IMPORTED_MODULE_1__/* .i18n */ .ag === void 0 ? void 0 : next_i18next__WEBPACK_IMPORTED_MODULE_1__/* .i18n.language */ .ag.language;
        if (app_configs__WEBPACK_IMPORTED_MODULE_0__/* .isClient */ .C5 && config.headers) {
            const token = localStorage.getItem("token");
            if (!!token) {
                config.headers["Game-Portal-Auth"] = "Bear ".concat(token);
            }
        }
        return config;
    });
    $http.interceptors.response.use((response)=>{
        if (response && response.request && response.request.responseURL && !response.request.responseURL.endsWith("/api/users/login") && response.data.errorCode === 1) {
            // store.dispatch(setVerifyModal(true))
            if (app_configs__WEBPACK_IMPORTED_MODULE_0__/* .isClient */ .C5) {
                const newUrl = new URL(window.location.href);
                newUrl.searchParams.set("global-modal", "verify");
                window.history.replaceState({}, "", newUrl);
            }
            return Promise.reject(response);
        } else if (response.data && response.data.errorCode !== 0) {
            if (response.request.responseURL.includes("/api/users/login")) {
            // store.dispatch(setDataError(response.data))
            }
            return Promise.reject(response);
        }
        return response;
    }, (error)=>{
        if (app_configs__WEBPACK_IMPORTED_MODULE_0__/* .isClient */ .C5) {
            if (error.response && error.response.status === 401) {
                localStorage.removeItem("token");
            // store.dispatch(setModal(true))
            } else if (error.data && error.data.errorCode === 1) {
            // store.dispatch(setVerifyModal(true))
            } else {
                return Promise.reject(error);
            }
            return Promise.reject();
        }
        return Promise.reject(error);
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (interceptor);


/***/ }),

/***/ 4547:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "y": function() { return /* binding */ PostCard; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(41844);
/* harmony import */ var _app_helpers_function__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(4203);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(55784);
/* harmony import */ var _app_configs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(54254);
/* harmony import */ var next_i18next__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(93378);
/* harmony import */ var moment__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(30381);
/* harmony import */ var moment__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(moment__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(41664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var _app_avatar_OnlyShowAvatar__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(30897);
/* harmony import */ var _connect_action_GroupFollowAction__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(10727);
/* harmony import */ var _app_context__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(17986);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(25675);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_11___default = /*#__PURE__*/__webpack_require__.n(next_image__WEBPACK_IMPORTED_MODULE_11__);












const PostCard = (param)=>{
    let { postcard , imgClassName , isInPage =false , isCheckHashtag =false  } = param;
    var _postcard_post, _postcard_author, _postcard_author1, _postcard_post1, _postcard_post2, _postcard_post3, _postcard_post4, _postcard_post5, _postcard_author2, _postcard_post6, _postcard_post7, _postcard_post8, _convertHashtag, _postcard_post9, _postcard_post10, _postcard_post11, _postcard_post12, _postcard_post13, _postcard_post14, _convertHashtag1, _convertHashtag2, _convertHashtag3;
    const router = (0,next_router__WEBPACK_IMPORTED_MODULE_2__.useRouter)();
    const { t  } = (0,next_i18next__WEBPACK_IMPORTED_MODULE_5__/* .useTranslation */ .$G)();
    const { userInfo  } = (0,react__WEBPACK_IMPORTED_MODULE_3__.useContext)(_app_context__WEBPACK_IMPORTED_MODULE_10__/* .AppContext */ .Il);
    const convertHashtag = (0,react__WEBPACK_IMPORTED_MODULE_3__.useCallback)(()=>{
        var _postcard_post;
        const result = [];
        for(let tag in postcard === null || postcard === void 0 ? void 0 : (_postcard_post = postcard.post) === null || _postcard_post === void 0 ? void 0 : _postcard_post.hashtag){
            var _postcard_post1;
            result.push(postcard === null || postcard === void 0 ? void 0 : (_postcard_post1 = postcard.post) === null || _postcard_post1 === void 0 ? void 0 : _postcard_post1.hashtag[tag]);
        }
        return result;
    }, [
        postcard
    ]);
    const renderContent = (0,react__WEBPACK_IMPORTED_MODULE_3__.useMemo)(()=>{
        var _postcard_post;
        return typeof document === "undefined" ? null : postcard === null || postcard === void 0 ? void 0 : (_postcard_post = postcard.post) === null || _postcard_post === void 0 ? void 0 : _postcard_post.content;
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        postcard === null || postcard === void 0 ? void 0 : (_postcard_post = postcard.post) === null || _postcard_post === void 0 ? void 0 : _postcard_post.content
    ]);
    const navigateUrl = (0,react__WEBPACK_IMPORTED_MODULE_3__.useCallback)(()=>{
        var _postcard_post, _postcard_post1, _postcard_post2, _postcard_post3;
        const isNotPublish = (postcard === null || postcard === void 0 ? void 0 : (_postcard_post = postcard.post) === null || _postcard_post === void 0 ? void 0 : _postcard_post.public_at) * 1000 > Number(new Date().getTime());
        const id = isNotPublish ? postcard === null || postcard === void 0 ? void 0 : (_postcard_post1 = postcard.post) === null || _postcard_post1 === void 0 ? void 0 : _postcard_post1.id : (0,_app_helpers_function__WEBPACK_IMPORTED_MODULE_1__/* .createSlugNameDetail */ .ti)(postcard === null || postcard === void 0 ? void 0 : (_postcard_post2 = postcard.post) === null || _postcard_post2 === void 0 ? void 0 : _postcard_post2.title, postcard === null || postcard === void 0 ? void 0 : (_postcard_post3 = postcard.post) === null || _postcard_post3 === void 0 ? void 0 : _postcard_post3.id);
        const type = "news";
        return isNotPublish ? "/preview/".concat(type, "/").concat(id) : "/detail/".concat(type, "/").concat(id);
    }, [
        postcard
    ]);
    const onNavigateToProfile = ()=>{
        var _postcard_author, _postcard_author1, _postcard_author2;
        router.push("/user/".concat(!!(postcard === null || postcard === void 0 ? void 0 : (_postcard_author = postcard.author) === null || _postcard_author === void 0 ? void 0 : _postcard_author.alias) ? postcard === null || postcard === void 0 ? void 0 : (_postcard_author1 = postcard.author) === null || _postcard_author1 === void 0 ? void 0 : _postcard_author1.alias : postcard === null || postcard === void 0 ? void 0 : (_postcard_author2 = postcard.author) === null || _postcard_author2 === void 0 ? void 0 : _postcard_author2.id));
    };
    var _postcard_post_public_at, _postcard_post_thumbnail, _postcard_post_public_at1, _extractText;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: "w-full border-b-[1px] border-black/10 dark:border-neutral-03 md:border-0 pb-4 md:pb-0",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
            className: "relative grid grid-cols-12 gap-0 md:gap-[24px] w-full rounded-[16px]",
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: "flex md:hidden items-center justify-between gap-3 pb-[10px] w-full col-span-12 md:col-span-0",
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                            className: "cursor-pointer relative gap-[12px] items-center flex max-w-[60%]",
                            onClick: onNavigateToProfile,
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_app_avatar_OnlyShowAvatar__WEBPACK_IMPORTED_MODULE_8__/* .OnlyShowAvatar */ .T, {
                                    size: 40,
                                    avatarUser: postcard === null || postcard === void 0 ? void 0 : postcard.author
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                    className: "flex flex-col",
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                            className: "flex items-center gap-[12px] ",
                                            children: [
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                                    className: "text-sm text-bg-01 Nunito-700 dark:text-white line-clamp-1",
                                                    children: postcard === null || postcard === void 0 ? void 0 : (_postcard_author = postcard.author) === null || _postcard_author === void 0 ? void 0 : _postcard_author.fullname
                                                }),
                                                !!(postcard === null || postcard === void 0 ? void 0 : (_postcard_author1 = postcard.author) === null || _postcard_author1 === void 0 ? void 0 : _postcard_author1.authentic) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
                                                        width: "16",
                                                        height: "16",
                                                        viewBox: "0 0 16 16",
                                                        fill: "none",
                                                        xmlns: "http://www.w3.org/2000/svg",
                                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                                            fillRule: "evenodd",
                                                            clipRule: "evenodd",
                                                            d: "M7.9987 14.6663C11.6806 14.6663 14.6654 11.6816 14.6654 7.99967C14.6654 4.31778 11.6806 1.33301 7.9987 1.33301C4.3168 1.33301 1.33203 4.31778 1.33203 7.99967C1.33203 11.6816 4.3168 14.6663 7.9987 14.6663ZM11.06 6.30667C11.2296 6.08869 11.1903 5.77456 10.9723 5.60502C10.7544 5.43549 10.4402 5.47475 10.2707 5.69273L7.59936 9.1273C7.53996 9.20367 7.42822 9.21358 7.35631 9.14886L5.66652 7.62805C5.46126 7.44332 5.14512 7.45996 4.96039 7.66522C4.77566 7.87047 4.7923 8.18661 4.99755 8.37134L6.68734 9.89215C7.19076 10.3452 7.9729 10.2759 8.38871 9.74124L11.06 6.30667Z",
                                                            fill: "#7673E6"
                                                        })
                                                    })
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                                            children: !!(postcard === null || postcard === void 0 ? void 0 : (_postcard_post1 = postcard.post) === null || _postcard_post1 === void 0 ? void 0 : _postcard_post1.public_at) && (postcard === null || postcard === void 0 ? void 0 : (_postcard_post2 = postcard.post) === null || _postcard_post2 === void 0 ? void 0 : _postcard_post2.public_at) * 1000 > Number(new Date().getTime()) ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("p", {
                                                className: "text-xs text-neutral-04 Nunito-400 dark:text-neutral-08",
                                                children: [
                                                    t("news.public_time"),
                                                    "\xa0\xa0",
                                                    moment__WEBPACK_IMPORTED_MODULE_6___default()(Number(postcard === null || postcard === void 0 ? void 0 : (_postcard_post3 = postcard.post) === null || _postcard_post3 === void 0 ? void 0 : _postcard_post3.public_at) * 1000).format(_app_configs__WEBPACK_IMPORTED_MODULE_4__/* .DATE_FORMAT_3 */ .Ly)
                                                ]
                                            }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                                className: "text-xs text-neutral-04 Nunito-400 dark:text-neutral-08",
                                                children: (0,_app_helpers_function__WEBPACK_IMPORTED_MODULE_1__/* .timeFormatter */ .g6)(Number((_postcard_post_public_at = postcard === null || postcard === void 0 ? void 0 : (_postcard_post4 = postcard.post) === null || _postcard_post4 === void 0 ? void 0 : _postcard_post4.public_at) !== null && _postcard_post_public_at !== void 0 ? _postcard_post_public_at : postcard === null || postcard === void 0 ? void 0 : (_postcard_post5 = postcard.post) === null || _postcard_post5 === void 0 ? void 0 : _postcard_post5.created_at) * 1000)
                                            })
                                        })
                                    ]
                                })
                            ]
                        }),
                        !isCheckHashtag && !!(userInfo === null || userInfo === void 0 ? void 0 : userInfo.userid) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_connect_action_GroupFollowAction__WEBPACK_IMPORTED_MODULE_9__/* .GroupFollowAction */ .o, {
                            id: postcard === null || postcard === void 0 ? void 0 : (_postcard_author2 = postcard.author) === null || _postcard_author2 === void 0 ? void 0 : _postcard_author2.id
                        })
                    ]
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: "col-span-12 md:col-span-4",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_7___default()), {
                        href: navigateUrl(),
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_11___default()), {
                            src: (0,_app_helpers_function__WEBPACK_IMPORTED_MODULE_1__/* .getCdnImage */ .ZZ)((_postcard_post_thumbnail = postcard === null || postcard === void 0 ? void 0 : (_postcard_post6 = postcard.post) === null || _postcard_post6 === void 0 ? void 0 : _postcard_post6.thumbnail) !== null && _postcard_post_thumbnail !== void 0 ? _postcard_post_thumbnail : "", 100),
                            width: 410,
                            height: 230,
                            loading: "lazy",
                            alt: postcard === null || postcard === void 0 ? void 0 : (_postcard_post7 = postcard.post) === null || _postcard_post7 === void 0 ? void 0 : _postcard_post7.title,
                            title: postcard === null || postcard === void 0 ? void 0 : (_postcard_post8 = postcard.post) === null || _postcard_post8 === void 0 ? void 0 : _postcard_post8.title,
                            className: "w-full min-w-full h-auto rounded-[16px] object-cover aspect-[16/9] cursor-pointer ".concat(imgClassName)
                        })
                    })
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: "col-span-12 md:col-span-8 flex flex-col my-0 lg:my-6 ".concat(!!isCheckHashtag && !!((_convertHashtag = convertHashtag()) === null || _convertHashtag === void 0 ? void 0 : _convertHashtag.length) && "lg:!my-0", "  ").concat(isInPage && "my-0 lg:!my-0"),
                    children: [
                        !!(postcard === null || postcard === void 0 ? void 0 : (_postcard_post9 = postcard.post) === null || _postcard_post9 === void 0 ? void 0 : _postcard_post9.public_at) && (postcard === null || postcard === void 0 ? void 0 : (_postcard_post10 = postcard.post) === null || _postcard_post10 === void 0 ? void 0 : _postcard_post10.public_at) * 1000 > Number(new Date().getTime()) ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("p", {
                            className: "text-[14px] Nunito-400 text-main-01 hidden md:block ".concat(isInPage && "md:text-[8px] ld:text-[14px]"),
                            children: [
                                t("news.public_time"),
                                "\xa0\xa0",
                                moment__WEBPACK_IMPORTED_MODULE_6___default()(Number(postcard === null || postcard === void 0 ? void 0 : (_postcard_post11 = postcard.post) === null || _postcard_post11 === void 0 ? void 0 : _postcard_post11.public_at) * 1000).format(_app_configs__WEBPACK_IMPORTED_MODULE_4__/* .DATE_FORMAT_3 */ .Ly)
                            ]
                        }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                            className: "text-[14px] Nunito-400 hidden text-neutral-04 dark:text-neutral-08 md:block ".concat(isInPage && "md:text-[8px] ld:text-[14px]"),
                            children: (0,_app_helpers_function__WEBPACK_IMPORTED_MODULE_1__/* .timeFormatter */ .g6)(Number((_postcard_post_public_at1 = postcard === null || postcard === void 0 ? void 0 : (_postcard_post12 = postcard.post) === null || _postcard_post12 === void 0 ? void 0 : _postcard_post12.public_at) !== null && _postcard_post_public_at1 !== void 0 ? _postcard_post_public_at1 : postcard === null || postcard === void 0 ? void 0 : (_postcard_post13 = postcard.post) === null || _postcard_post13 === void 0 ? void 0 : _postcard_post13.created_at) * 1000)
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_7___default()), {
                                    href: navigateUrl(),
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h3", {
                                        className: "text-[16px] md:text-[18px] Nunito-700 leading-normal mt-[10px] md:mt-[8px] mb-[8px] cursor-pointer line-clamp-1 ".concat(isInPage && "md:text-[12px] ld:text-[18px]"),
                                        children: postcard === null || postcard === void 0 ? void 0 : (_postcard_post14 = postcard.post) === null || _postcard_post14 === void 0 ? void 0 : _postcard_post14.title
                                    })
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                    className: "inline-block w-full md:w-[70%] ".concat(isInPage && "md:hidden ld:inline-block"),
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                            className: "text-[14px] Nunito-400 ".concat(!!((_convertHashtag1 = convertHashtag()) === null || _convertHashtag1 === void 0 ? void 0 : _convertHashtag1.length) ? "line-clamp-1 lg:line-clamp-1" : "line-clamp-2 lg:line-clamp-3", " ").concat(!isCheckHashtag ? "line-clamp-2 lg:line-clamp-3" : "line-clamp-1 lg:line-clamp-1", " text-neutral-04 dark:text-neutral-08 break-words"),
                                            dangerouslySetInnerHTML: {
                                                __html: (_extractText = (0,_app_helpers_function__WEBPACK_IMPORTED_MODULE_1__/* .extractText */ .oc)(renderContent || "")) !== null && _extractText !== void 0 ? _extractText : ""
                                            }
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_7___default()), {
                                            href: navigateUrl(),
                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                                className: "text-main-01 text-[14px] h-[28px] Nunito-400 cursor-pointer ".concat(isInPage && "md:hidden ld:block"),
                                                children: t("common.view_more")
                                            })
                                        })
                                    ]
                                })
                            ]
                        }),
                        !!((_convertHashtag2 = convertHashtag()) === null || _convertHashtag2 === void 0 ? void 0 : _convertHashtag2.length) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: "flex md:hidden gap-[8px] mb-0 pt-2",
                            children: convertHashtag().map((hashtag, index)=>{
                                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                    className: "px-[8px] py-[2px] rounded-[8px] bg-button dark:bg-[#EFEFFF]/[.1] text-main-01 text-[14px]",
                                    children: [
                                        "#",
                                        hashtag === null || hashtag === void 0 ? void 0 : hashtag.replaceAll("#", "")
                                    ]
                                }, index);
                            })
                        }),
                        !!((_convertHashtag3 = convertHashtag()) === null || _convertHashtag3 === void 0 ? void 0 : _convertHashtag3.length) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: "hidden lg:flex gap-[8px] mt-auto mb-0 pt-4 ".concat(isInPage && "md:pt-0 ld:pt-4"),
                            children: convertHashtag().map((hashtag, index)=>{
                                if (!hashtag) return null;
                                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_7___default()), {
                                    href: "/hashtag/".concat(hashtag === null || hashtag === void 0 ? void 0 : hashtag.replaceAll("#", "")),
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                        className: "px-[8px] py-[2px] rounded-[8px] bg-button dark:bg-[#EFEFFF]/[.1] text-main-01 text-[14px]",
                                        children: [
                                            "#",
                                            hashtag === null || hashtag === void 0 ? void 0 : hashtag.replaceAll("#", "")
                                        ]
                                    })
                                }, index);
                            })
                        })
                    ]
                })
            ]
        })
    });
};


/***/ }),

/***/ 82904:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "u": function() { return /* binding */ ModalAddressMerchandise; }
});

// EXTERNAL MODULE: ./node_modules/next/dist/compiled/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(41844);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/react/index.js
var react = __webpack_require__(55784);
// EXTERNAL MODULE: ./node_modules/next-i18next/dist/esm/index.js + 41 modules
var esm = __webpack_require__(93378);
// EXTERNAL MODULE: ./app/components/ui/dialog.tsx
var dialog = __webpack_require__(76500);
// EXTERNAL MODULE: ./app/components/icon-tsx/IconClose.tsx
var IconClose = __webpack_require__(51337);
// EXTERNAL MODULE: ./app/components/ui/button.tsx
var ui_button = __webpack_require__(34428);
// EXTERNAL MODULE: ./app/components/ui/input.tsx
var input = __webpack_require__(78634);
;// CONCATENATED MODULE: ./app/dummy/tinh_tp.json
var tinh_tp_namespaceObject = JSON.parse('{"10":{"name":"Lào Cai","type":"tinh","slug":"lao-cai","name_with_type":"Tỉnh Lào Cai","code":"10"},"11":{"name":"Điện Biên","type":"tinh","slug":"đien-bien","name_with_type":"Tỉnh Điện Biên","code":"11"},"12":{"name":"Lai Châu","type":"tinh","slug":"lai-chau","name_with_type":"Tỉnh Lai Châu","code":"12"},"14":{"name":"Sơn La","type":"tinh","slug":"son-la","name_with_type":"Tỉnh Sơn La","code":"14"},"15":{"name":"Yên Bái","type":"tinh","slug":"yen-bai","name_with_type":"Tỉnh Yên Bái","code":"15"},"17":{"name":"Hoà Bình","type":"tinh","slug":"hoa-binh","name_with_type":"Tỉnh Hoà Bình","code":"17"},"19":{"name":"Thái Nguyên","type":"tinh","slug":"thai-nguyen","name_with_type":"Tỉnh Thái Nguyên","code":"19"},"20":{"name":"Lạng Sơn","type":"tinh","slug":"lang-son","name_with_type":"Tỉnh Lạng Sơn","code":"20"},"22":{"name":"Quảng Ninh","type":"tinh","slug":"quang-ninh","name_with_type":"Tỉnh Quảng Ninh","code":"22"},"24":{"name":"Bắc Giang","type":"tinh","slug":"bac-giang","name_with_type":"Tỉnh Bắc Giang","code":"24"},"25":{"name":"Phú Thọ","type":"tinh","slug":"phu-tho","name_with_type":"Tỉnh Phú Thọ","code":"25"},"26":{"name":"Vĩnh Phúc","type":"tinh","slug":"vinh-phuc","name_with_type":"Tỉnh Vĩnh Phúc","code":"26"},"27":{"name":"Bắc Ninh","type":"tinh","slug":"bac-ninh","name_with_type":"Tỉnh Bắc Ninh","code":"27"},"30":{"name":"Hải Dương","type":"tinh","slug":"hai-duong","name_with_type":"Tỉnh Hải Dương","code":"30"},"31":{"name":"Hải Phòng","type":"thanh-pho-trung-uong","slug":"hai-phong","name_with_type":"Thành phố Hải Phòng","code":"31"},"33":{"name":"Hưng Yên","type":"tinh","slug":"hung-yen","name_with_type":"Tỉnh Hưng Yên","code":"33"},"34":{"name":"Thái Bình","type":"tinh","slug":"thai-binh","name_with_type":"Tỉnh Thái Bình","code":"34"},"35":{"name":"Hà Nam","type":"tinh","slug":"ha-nam","name_with_type":"Tỉnh Hà Nam","code":"35"},"36":{"name":"Nam Định","type":"tinh","slug":"nam-đinh","name_with_type":"Tỉnh Nam Định","code":"36"},"37":{"name":"Ninh Bình","type":"tinh","slug":"ninh-binh","name_with_type":"Tỉnh Ninh Bình","code":"37"},"38":{"name":"Thanh Hóa","type":"tinh","slug":"thanh-hoa","name_with_type":"Tỉnh Thanh Hóa","code":"38"},"40":{"name":"Nghệ An","type":"tinh","slug":"nghe-an","name_with_type":"Tỉnh Nghệ An","code":"40"},"42":{"name":"Hà Tĩnh","type":"tinh","slug":"ha-tinh","name_with_type":"Tỉnh Hà Tĩnh","code":"42"},"44":{"name":"Quảng Bình","type":"tinh","slug":"quang-binh","name_with_type":"Tỉnh Quảng Bình","code":"44"},"45":{"name":"Quảng Trị","type":"tinh","slug":"quang-tri","name_with_type":"Tỉnh Quảng Trị","code":"45"},"46":{"name":"Huế","type":"thanh-pho-trung-uong","slug":"hue","name_with_type":"Thành phố Huế","code":"46"},"48":{"name":"Đà Nẵng","type":"thanh-pho-trung-uong","slug":"đa-nang","name_with_type":"Thành phố Đà Nẵng","code":"48"},"49":{"name":"Quảng Nam","type":"tinh","slug":"quang-nam","name_with_type":"Tỉnh Quảng Nam","code":"49"},"51":{"name":"Quảng Ngãi","type":"tinh","slug":"quang-ngai","name_with_type":"Tỉnh Quảng Ngãi","code":"51"},"52":{"name":"Bình Định","type":"tinh","slug":"binh-đinh","name_with_type":"Tỉnh Bình Định","code":"52"},"54":{"name":"Phú Yên","type":"tinh","slug":"phu-yen","name_with_type":"Tỉnh Phú Yên","code":"54"},"56":{"name":"Khánh Hòa","type":"tinh","slug":"khanh-hoa","name_with_type":"Tỉnh Khánh Hòa","code":"56"},"58":{"name":"Ninh Thuận","type":"tinh","slug":"ninh-thuan","name_with_type":"Tỉnh Ninh Thuận","code":"58"},"60":{"name":"Bình Thuận","type":"tinh","slug":"binh-thuan","name_with_type":"Tỉnh Bình Thuận","code":"60"},"62":{"name":"Kon Tum","type":"tinh","slug":"kon-tum","name_with_type":"Tỉnh Kon Tum","code":"62"},"64":{"name":"Gia Lai","type":"tinh","slug":"gia-lai","name_with_type":"Tỉnh Gia Lai","code":"64"},"66":{"name":"Đắk Lắk","type":"tinh","slug":"đak-lak","name_with_type":"Tỉnh Đắk Lắk","code":"66"},"67":{"name":"Đắk Nông","type":"tinh","slug":"đak-nong","name_with_type":"Tỉnh Đắk Nông","code":"67"},"68":{"name":"Lâm Đồng","type":"tinh","slug":"lam-đong","name_with_type":"Tỉnh Lâm Đồng","code":"68"},"70":{"name":"Bình Phước","type":"tinh","slug":"binh-phuoc","name_with_type":"Tỉnh Bình Phước","code":"70"},"72":{"name":"Tây Ninh","type":"tinh","slug":"tay-ninh","name_with_type":"Tỉnh Tây Ninh","code":"72"},"74":{"name":"Bình Dương","type":"tinh","slug":"binh-duong","name_with_type":"Tỉnh Bình Dương","code":"74"},"75":{"name":"Đồng Nai","type":"tinh","slug":"đong-nai","name_with_type":"Tỉnh Đồng Nai","code":"75"},"77":{"name":"Bà Rịa - Vũng Tàu","type":"tinh","slug":"ba-ria---vung-tau","name_with_type":"Tỉnh Bà Rịa - Vũng Tàu","code":"77"},"79":{"name":"Hồ Chí Minh","type":"thanh-pho-trung-uong","slug":"ho-chi-minh","name_with_type":"Thành phố Hồ Chí Minh","code":"79"},"80":{"name":"Long An","type":"tinh","slug":"long-an","name_with_type":"Tỉnh Long An","code":"80"},"82":{"name":"Tiền Giang","type":"tinh","slug":"tien-giang","name_with_type":"Tỉnh Tiền Giang","code":"82"},"83":{"name":"Bến Tre","type":"tinh","slug":"ben-tre","name_with_type":"Tỉnh Bến Tre","code":"83"},"84":{"name":"Trà Vinh","type":"tinh","slug":"tra-vinh","name_with_type":"Tỉnh Trà Vinh","code":"84"},"86":{"name":"Vĩnh Long","type":"tinh","slug":"vinh-long","name_with_type":"Tỉnh Vĩnh Long","code":"86"},"87":{"name":"Đồng Tháp","type":"tinh","slug":"đong-thap","name_with_type":"Tỉnh Đồng Tháp","code":"87"},"89":{"name":"An Giang","type":"tinh","slug":"an-giang","name_with_type":"Tỉnh An Giang","code":"89"},"91":{"name":"Kiên Giang","type":"tinh","slug":"kien-giang","name_with_type":"Tỉnh Kiên Giang","code":"91"},"92":{"name":"Cần Thơ","type":"thanh-pho-trung-uong","slug":"can-tho","name_with_type":"Thành phố Cần Thơ","code":"92"},"93":{"name":"Hậu Giang","type":"tinh","slug":"hau-giang","name_with_type":"Tỉnh Hậu Giang","code":"93"},"94":{"name":"Sóc Trăng","type":"tinh","slug":"soc-trang","name_with_type":"Tỉnh Sóc Trăng","code":"94"},"95":{"name":"Bạc Liêu","type":"tinh","slug":"bac-lieu","name_with_type":"Tỉnh Bạc Liêu","code":"95"},"96":{"name":"Cà Mau","type":"tinh","slug":"ca-mau","name_with_type":"Tỉnh Cà Mau","code":"96"},"01":{"name":"Hà Nội","type":"thanh-pho-trung-uong","slug":"ha-noi","name_with_type":"Thành phố Hà Nội","code":"01"},"02":{"name":"Hà Giang","type":"tinh","slug":"ha-giang","name_with_type":"Tỉnh Hà Giang","code":"02"},"04":{"name":"Cao Bằng","type":"tinh","slug":"cao-bang","name_with_type":"Tỉnh Cao Bằng","code":"04"},"06":{"name":"Bắc Kạn","type":"tinh","slug":"bac-kan","name_with_type":"Tỉnh Bắc Kạn","code":"06"},"08":{"name":"Tuyên Quang","type":"tinh","slug":"tuyen-quang","name_with_type":"Tỉnh Tuyên Quang","code":"08"}}');
;// CONCATENATED MODULE: ./app/dummy/quan_huyen.json
var quan_huyen_namespaceObject = JSON.parse('{"100":{"name":"Điện Biên","type":"huyen","slug":"dien-bien","name_with_type":"Huyện Điện Biên","path":"Huyện Điện Biên, Tỉnh Điện Biên","path_with_type":"Huyện Điện Biên, Tỉnh Điện Biên","code":"100","parent_code":"11"},"101":{"name":"Điện Biên Đông","type":"huyen","slug":"dien-bien-dong","name_with_type":"Huyện Điện Biên Đông","path":"Huyện Điện Biên Đông, Tỉnh Điện Biên","path_with_type":"Huyện Điện Biên Đông, Tỉnh Điện Biên","code":"101","parent_code":"11"},"102":{"name":"Mường Ảng","type":"huyen","slug":"muong-ang","name_with_type":"Huyện Mường Ảng","path":"Huyện Mường Ảng, Tỉnh Điện Biên","path_with_type":"Huyện Mường Ảng, Tỉnh Điện Biên","code":"102","parent_code":"11"},"103":{"name":"Nậm Pồ","type":"huyen","slug":"nam-po","name_with_type":"Huyện Nậm Pồ","path":"Huyện Nậm Pồ, Tỉnh Điện Biên","path_with_type":"Huyện Nậm Pồ, Tỉnh Điện Biên","code":"103","parent_code":"11"},"105":{"name":"Thành phố Lai Châu","type":"thanh-pho","slug":"thanh-pho-lai-chau","name_with_type":"Thành phố Lai Châu","path":"Thành phố Lai Châu, Tỉnh Lai Châu","path_with_type":"Thành phố Lai Châu, Tỉnh Lai Châu","code":"105","parent_code":"12"},"106":{"name":"Tam Đường","type":"huyen","slug":"tam-duong","name_with_type":"Huyện Tam Đường","path":"Huyện Tam Đường, Tỉnh Lai Châu","path_with_type":"Huyện Tam Đường, Tỉnh Lai Châu","code":"106","parent_code":"12"},"107":{"name":"Mường Tè","type":"huyen","slug":"muong-te","name_with_type":"Huyện Mường Tè","path":"Huyện Mường Tè, Tỉnh Lai Châu","path_with_type":"Huyện Mường Tè, Tỉnh Lai Châu","code":"107","parent_code":"12"},"108":{"name":"Sìn Hồ","type":"huyen","slug":"sin-ho","name_with_type":"Huyện Sìn Hồ","path":"Huyện Sìn Hồ, Tỉnh Lai Châu","path_with_type":"Huyện Sìn Hồ, Tỉnh Lai Châu","code":"108","parent_code":"12"},"109":{"name":"Phong Thổ","type":"huyen","slug":"phong-tho","name_with_type":"Huyện Phong Thổ","path":"Huyện Phong Thổ, Tỉnh Lai Châu","path_with_type":"Huyện Phong Thổ, Tỉnh Lai Châu","code":"109","parent_code":"12"},"110":{"name":"Than Uyên","type":"huyen","slug":"than-uyen","name_with_type":"Huyện Than Uyên","path":"Huyện Than Uyên, Tỉnh Lai Châu","path_with_type":"Huyện Than Uyên, Tỉnh Lai Châu","code":"110","parent_code":"12"},"111":{"name":"Tân Uyên","type":"huyen","slug":"tan-uyen","name_with_type":"Huyện Tân Uyên","path":"Huyện Tân Uyên, Tỉnh Lai Châu","path_with_type":"Huyện Tân Uyên, Tỉnh Lai Châu","code":"111","parent_code":"12"},"112":{"name":"Nậm Nhùn","type":"huyen","slug":"nam-nhun","name_with_type":"Huyện Nậm Nhùn","path":"Huyện Nậm Nhùn, Tỉnh Lai Châu","path_with_type":"Huyện Nậm Nhùn, Tỉnh Lai Châu","code":"112","parent_code":"12"},"116":{"name":"Thành phố Sơn La","type":"thanh-pho","slug":"thanh-pho-son-la","name_with_type":"Thành phố Sơn La","path":"Thành phố Sơn La, Tỉnh Sơn La","path_with_type":"Thành phố Sơn La, Tỉnh Sơn La","code":"116","parent_code":"14"},"118":{"name":"Quỳnh Nhai","type":"huyen","slug":"quynh-nhai","name_with_type":"Huyện Quỳnh Nhai","path":"Huyện Quỳnh Nhai, Tỉnh Sơn La","path_with_type":"Huyện Quỳnh Nhai, Tỉnh Sơn La","code":"118","parent_code":"14"},"119":{"name":"Thuận Châu","type":"huyen","slug":"thuan-chau","name_with_type":"Huyện Thuận Châu","path":"Huyện Thuận Châu, Tỉnh Sơn La","path_with_type":"Huyện Thuận Châu, Tỉnh Sơn La","code":"119","parent_code":"14"},"120":{"name":"Mường La","type":"huyen","slug":"muong-la","name_with_type":"Huyện Mường La","path":"Huyện Mường La, Tỉnh Sơn La","path_with_type":"Huyện Mường La, Tỉnh Sơn La","code":"120","parent_code":"14"},"121":{"name":"Bắc Yên","type":"huyen","slug":"bac-yen","name_with_type":"Huyện Bắc Yên","path":"Huyện Bắc Yên, Tỉnh Sơn La","path_with_type":"Huyện Bắc Yên, Tỉnh Sơn La","code":"121","parent_code":"14"},"122":{"name":"Phù Yên","type":"huyen","slug":"phu-yen","name_with_type":"Huyện Phù Yên","path":"Huyện Phù Yên, Tỉnh Sơn La","path_with_type":"Huyện Phù Yên, Tỉnh Sơn La","code":"122","parent_code":"14"},"123":{"name":"Mộc Châu","type":"huyen","slug":"moc-chau","name_with_type":"Huyện Mộc Châu","path":"Huyện Mộc Châu, Tỉnh Sơn La","path_with_type":"Huyện Mộc Châu, Tỉnh Sơn La","code":"123","parent_code":"14"},"124":{"name":"Yên Châu","type":"huyen","slug":"yen-chau","name_with_type":"Huyện Yên Châu","path":"Huyện Yên Châu, Tỉnh Sơn La","path_with_type":"Huyện Yên Châu, Tỉnh Sơn La","code":"124","parent_code":"14"},"125":{"name":"Mai Sơn","type":"huyen","slug":"mai-son","name_with_type":"Huyện Mai Sơn","path":"Huyện Mai Sơn, Tỉnh Sơn La","path_with_type":"Huyện Mai Sơn, Tỉnh Sơn La","code":"125","parent_code":"14"},"126":{"name":"Sông Mã","type":"huyen","slug":"song-ma","name_with_type":"Huyện Sông Mã","path":"Huyện Sông Mã, Tỉnh Sơn La","path_with_type":"Huyện Sông Mã, Tỉnh Sơn La","code":"126","parent_code":"14"},"127":{"name":"Sốp Cộp","type":"huyen","slug":"sop-cop","name_with_type":"Huyện Sốp Cộp","path":"Huyện Sốp Cộp, Tỉnh Sơn La","path_with_type":"Huyện Sốp Cộp, Tỉnh Sơn La","code":"127","parent_code":"14"},"128":{"name":"Vân Hồ","type":"huyen","slug":"van-ho","name_with_type":"Huyện Vân Hồ","path":"Huyện Vân Hồ, Tỉnh Sơn La","path_with_type":"Huyện Vân Hồ, Tỉnh Sơn La","code":"128","parent_code":"14"},"132":{"name":"Thành phố Yên Bái","type":"thanh-pho","slug":"thanh-pho-yen-bai","name_with_type":"Thành phố Yên Bái","path":"Thành phố Yên Bái, Tỉnh Yên Bái","path_with_type":"Thành phố Yên Bái, Tỉnh Yên Bái","code":"132","parent_code":"15"},"133":{"name":"Thị xã Nghĩa Lộ","type":"thi-xa","slug":"thi-xa-nghia-lo","name_with_type":"Thị xã Nghĩa Lộ","path":"Thị xã Nghĩa Lộ, Tỉnh Yên Bái","path_with_type":"Thị xã Nghĩa Lộ, Tỉnh Yên Bái","code":"133","parent_code":"15"},"135":{"name":"Lục Yên","type":"huyen","slug":"luc-yen","name_with_type":"Huyện Lục Yên","path":"Huyện Lục Yên, Tỉnh Yên Bái","path_with_type":"Huyện Lục Yên, Tỉnh Yên Bái","code":"135","parent_code":"15"},"136":{"name":"Văn Yên","type":"huyen","slug":"van-yen","name_with_type":"Huyện Văn Yên","path":"Huyện Văn Yên, Tỉnh Yên Bái","path_with_type":"Huyện Văn Yên, Tỉnh Yên Bái","code":"136","parent_code":"15"},"137":{"name":"Mù Căng Chải","type":"huyen","slug":"mu-cang-chai","name_with_type":"Huyện Mù Căng Chải","path":"Huyện Mù Căng Chải, Tỉnh Yên Bái","path_with_type":"Huyện Mù Căng Chải, Tỉnh Yên Bái","code":"137","parent_code":"15"},"138":{"name":"Trấn Yên","type":"huyen","slug":"tran-yen","name_with_type":"Huyện Trấn Yên","path":"Huyện Trấn Yên, Tỉnh Yên Bái","path_with_type":"Huyện Trấn Yên, Tỉnh Yên Bái","code":"138","parent_code":"15"},"139":{"name":"Trạm Tấu","type":"huyen","slug":"tram-tau","name_with_type":"Huyện Trạm Tấu","path":"Huyện Trạm Tấu, Tỉnh Yên Bái","path_with_type":"Huyện Trạm Tấu, Tỉnh Yên Bái","code":"139","parent_code":"15"},"140":{"name":"Văn Chấn","type":"huyen","slug":"van-chan","name_with_type":"Huyện Văn Chấn","path":"Huyện Văn Chấn, Tỉnh Yên Bái","path_with_type":"Huyện Văn Chấn, Tỉnh Yên Bái","code":"140","parent_code":"15"},"141":{"name":"Yên Bình","type":"huyen","slug":"yen-binh","name_with_type":"Huyện Yên Bình","path":"Huyện Yên Bình, Tỉnh Yên Bái","path_with_type":"Huyện Yên Bình, Tỉnh Yên Bái","code":"141","parent_code":"15"},"148":{"name":"Thành phố Hòa Bình","type":"thanh-pho","slug":"thanh-pho-hoa-binh","name_with_type":"Thành phố Hòa Bình","path":"Thành phố Hòa Bình, Tỉnh Hoà Bình","path_with_type":"Thành phố Hòa Bình, Tỉnh Hoà Bình","code":"148","parent_code":"17"},"150":{"name":"Đà Bắc","type":"huyen","slug":"da-bac","name_with_type":"Huyện Đà Bắc","path":"Huyện Đà Bắc, Tỉnh Hoà Bình","path_with_type":"Huyện Đà Bắc, Tỉnh Hoà Bình","code":"150","parent_code":"17"},"152":{"name":"Lương Sơn","type":"huyen","slug":"luong-son","name_with_type":"Huyện Lương Sơn","path":"Huyện Lương Sơn, Tỉnh Hoà Bình","path_with_type":"Huyện Lương Sơn, Tỉnh Hoà Bình","code":"152","parent_code":"17"},"153":{"name":"Kim Bôi","type":"huyen","slug":"kim-boi","name_with_type":"Huyện Kim Bôi","path":"Huyện Kim Bôi, Tỉnh Hoà Bình","path_with_type":"Huyện Kim Bôi, Tỉnh Hoà Bình","code":"153","parent_code":"17"},"154":{"name":"Cao Phong","type":"huyen","slug":"cao-phong","name_with_type":"Huyện Cao Phong","path":"Huyện Cao Phong, Tỉnh Hoà Bình","path_with_type":"Huyện Cao Phong, Tỉnh Hoà Bình","code":"154","parent_code":"17"},"155":{"name":"Tân Lạc","type":"huyen","slug":"tan-lac","name_with_type":"Huyện Tân Lạc","path":"Huyện Tân Lạc, Tỉnh Hoà Bình","path_with_type":"Huyện Tân Lạc, Tỉnh Hoà Bình","code":"155","parent_code":"17"},"156":{"name":"Mai Châu","type":"huyen","slug":"mai-chau","name_with_type":"Huyện Mai Châu","path":"Huyện Mai Châu, Tỉnh Hoà Bình","path_with_type":"Huyện Mai Châu, Tỉnh Hoà Bình","code":"156","parent_code":"17"},"157":{"name":"Lạc Sơn","type":"huyen","slug":"lac-son","name_with_type":"Huyện Lạc Sơn","path":"Huyện Lạc Sơn, Tỉnh Hoà Bình","path_with_type":"Huyện Lạc Sơn, Tỉnh Hoà Bình","code":"157","parent_code":"17"},"158":{"name":"Yên Thủy","type":"huyen","slug":"yen-thuy","name_with_type":"Huyện Yên Thủy","path":"Huyện Yên Thủy, Tỉnh Hoà Bình","path_with_type":"Huyện Yên Thủy, Tỉnh Hoà Bình","code":"158","parent_code":"17"},"159":{"name":"Lạc Thủy","type":"huyen","slug":"lac-thuy","name_with_type":"Huyện Lạc Thủy","path":"Huyện Lạc Thủy, Tỉnh Hoà Bình","path_with_type":"Huyện Lạc Thủy, Tỉnh Hoà Bình","code":"159","parent_code":"17"},"164":{"name":"Thành phố Thái Nguyên","type":"thanh-pho","slug":"thanh-pho-thai-nguyen","name_with_type":"Thành phố Thái Nguyên","path":"Thành phố Thái Nguyên, Tỉnh Thái Nguyên","path_with_type":"Thành phố Thái Nguyên, Tỉnh Thái Nguyên","code":"164","parent_code":"19"},"165":{"name":"Thành phố Sông Công","type":"thanh-pho","slug":"thanh-pho-song-cong","name_with_type":"Thành phố Sông Công","path":"Thành phố Sông Công, Tỉnh Thái Nguyên","path_with_type":"Thành phố Sông Công, Tỉnh Thái Nguyên","code":"165","parent_code":"19"},"167":{"name":"Định Hóa","type":"huyen","slug":"dinh-hoa","name_with_type":"Huyện Định Hóa","path":"Huyện Định Hóa, Tỉnh Thái Nguyên","path_with_type":"Huyện Định Hóa, Tỉnh Thái Nguyên","code":"167","parent_code":"19"},"168":{"name":"Phú Lương","type":"huyen","slug":"phu-luong","name_with_type":"Huyện Phú Lương","path":"Huyện Phú Lương, Tỉnh Thái Nguyên","path_with_type":"Huyện Phú Lương, Tỉnh Thái Nguyên","code":"168","parent_code":"19"},"169":{"name":"Đồng Hỷ","type":"huyen","slug":"dong-hy","name_with_type":"Huyện Đồng Hỷ","path":"Huyện Đồng Hỷ, Tỉnh Thái Nguyên","path_with_type":"Huyện Đồng Hỷ, Tỉnh Thái Nguyên","code":"169","parent_code":"19"},"170":{"name":"Võ Nhai","type":"huyen","slug":"vo-nhai","name_with_type":"Huyện Võ Nhai","path":"Huyện Võ Nhai, Tỉnh Thái Nguyên","path_with_type":"Huyện Võ Nhai, Tỉnh Thái Nguyên","code":"170","parent_code":"19"},"171":{"name":"Đại Từ","type":"huyen","slug":"dai-tu","name_with_type":"Huyện Đại Từ","path":"Huyện Đại Từ, Tỉnh Thái Nguyên","path_with_type":"Huyện Đại Từ, Tỉnh Thái Nguyên","code":"171","parent_code":"19"},"172":{"name":"Thành phố Phổ Yên","type":"thanh-pho","slug":"thanh-pho-pho-yen","name_with_type":"Thành phố Phổ Yên","path":"Thành phố Phổ Yên, Tỉnh Thái Nguyên","path_with_type":"Thành phố Phổ Yên, Tỉnh Thái Nguyên","code":"172","parent_code":"19"},"173":{"name":"Phú Bình","type":"huyen","slug":"phu-binh","name_with_type":"Huyện Phú Bình","path":"Huyện Phú Bình, Tỉnh Thái Nguyên","path_with_type":"Huyện Phú Bình, Tỉnh Thái Nguyên","code":"173","parent_code":"19"},"178":{"name":"Thành phố Lạng Sơn","type":"thanh-pho","slug":"thanh-pho-lang-son","name_with_type":"Thành phố Lạng Sơn","path":"Thành phố Lạng Sơn, Tỉnh Lạng Sơn","path_with_type":"Thành phố Lạng Sơn, Tỉnh Lạng Sơn","code":"178","parent_code":"20"},"180":{"name":"Tràng Định","type":"huyen","slug":"trang-dinh","name_with_type":"Huyện Tràng Định","path":"Huyện Tràng Định, Tỉnh Lạng Sơn","path_with_type":"Huyện Tràng Định, Tỉnh Lạng Sơn","code":"180","parent_code":"20"},"181":{"name":"Bình Gia","type":"huyen","slug":"binh-gia","name_with_type":"Huyện Bình Gia","path":"Huyện Bình Gia, Tỉnh Lạng Sơn","path_with_type":"Huyện Bình Gia, Tỉnh Lạng Sơn","code":"181","parent_code":"20"},"182":{"name":"Văn Lãng","type":"huyen","slug":"van-lang","name_with_type":"Huyện Văn Lãng","path":"Huyện Văn Lãng, Tỉnh Lạng Sơn","path_with_type":"Huyện Văn Lãng, Tỉnh Lạng Sơn","code":"182","parent_code":"20"},"183":{"name":"Cao Lộc","type":"huyen","slug":"cao-loc","name_with_type":"Huyện Cao Lộc","path":"Huyện Cao Lộc, Tỉnh Lạng Sơn","path_with_type":"Huyện Cao Lộc, Tỉnh Lạng Sơn","code":"183","parent_code":"20"},"184":{"name":"Văn Quan","type":"huyen","slug":"van-quan","name_with_type":"Huyện Văn Quan","path":"Huyện Văn Quan, Tỉnh Lạng Sơn","path_with_type":"Huyện Văn Quan, Tỉnh Lạng Sơn","code":"184","parent_code":"20"},"185":{"name":"Bắc Sơn","type":"huyen","slug":"bac-son","name_with_type":"Huyện Bắc Sơn","path":"Huyện Bắc Sơn, Tỉnh Lạng Sơn","path_with_type":"Huyện Bắc Sơn, Tỉnh Lạng Sơn","code":"185","parent_code":"20"},"186":{"name":"Hữu Lũng","type":"huyen","slug":"huu-lung","name_with_type":"Huyện Hữu Lũng","path":"Huyện Hữu Lũng, Tỉnh Lạng Sơn","path_with_type":"Huyện Hữu Lũng, Tỉnh Lạng Sơn","code":"186","parent_code":"20"},"187":{"name":"Chi Lăng","type":"huyen","slug":"chi-lang","name_with_type":"Huyện Chi Lăng","path":"Huyện Chi Lăng, Tỉnh Lạng Sơn","path_with_type":"Huyện Chi Lăng, Tỉnh Lạng Sơn","code":"187","parent_code":"20"},"188":{"name":"Lộc Bình","type":"huyen","slug":"loc-binh","name_with_type":"Huyện Lộc Bình","path":"Huyện Lộc Bình, Tỉnh Lạng Sơn","path_with_type":"Huyện Lộc Bình, Tỉnh Lạng Sơn","code":"188","parent_code":"20"},"189":{"name":"Đình Lập","type":"huyen","slug":"dinh-lap","name_with_type":"Huyện Đình Lập","path":"Huyện Đình Lập, Tỉnh Lạng Sơn","path_with_type":"Huyện Đình Lập, Tỉnh Lạng Sơn","code":"189","parent_code":"20"},"193":{"name":"Thành phố Hạ Long","type":"thanh-pho","slug":"thanh-pho-ha-long","name_with_type":"Thành phố Hạ Long","path":"Thành phố Hạ Long, Tỉnh Quảng Ninh","path_with_type":"Thành phố Hạ Long, Tỉnh Quảng Ninh","code":"193","parent_code":"22"},"194":{"name":"Thành phố Móng Cái","type":"thanh-pho","slug":"thanh-pho-mong-cai","name_with_type":"Thành phố Móng Cái","path":"Thành phố Móng Cái, Tỉnh Quảng Ninh","path_with_type":"Thành phố Móng Cái, Tỉnh Quảng Ninh","code":"194","parent_code":"22"},"195":{"name":"Thành phố Cẩm Phả","type":"thanh-pho","slug":"thanh-pho-cam-pha","name_with_type":"Thành phố Cẩm Phả","path":"Thành phố Cẩm Phả, Tỉnh Quảng Ninh","path_with_type":"Thành phố Cẩm Phả, Tỉnh Quảng Ninh","code":"195","parent_code":"22"},"196":{"name":"Thành phố Uông Bí","type":"thanh-pho","slug":"thanh-pho-uong-bi","name_with_type":"Thành phố Uông Bí","path":"Thành phố Uông Bí, Tỉnh Quảng Ninh","path_with_type":"Thành phố Uông Bí, Tỉnh Quảng Ninh","code":"196","parent_code":"22"},"198":{"name":"Bình Liêu","type":"huyen","slug":"binh-lieu","name_with_type":"Huyện Bình Liêu","path":"Huyện Bình Liêu, Tỉnh Quảng Ninh","path_with_type":"Huyện Bình Liêu, Tỉnh Quảng Ninh","code":"198","parent_code":"22"},"199":{"name":"Tiên Yên","type":"huyen","slug":"tien-yen","name_with_type":"Huyện Tiên Yên","path":"Huyện Tiên Yên, Tỉnh Quảng Ninh","path_with_type":"Huyện Tiên Yên, Tỉnh Quảng Ninh","code":"199","parent_code":"22"},"200":{"name":"Đầm Hà","type":"huyen","slug":"dam-ha","name_with_type":"Huyện Đầm Hà","path":"Huyện Đầm Hà, Tỉnh Quảng Ninh","path_with_type":"Huyện Đầm Hà, Tỉnh Quảng Ninh","code":"200","parent_code":"22"},"201":{"name":"Hải Hà","type":"huyen","slug":"hai-ha","name_with_type":"Huyện Hải Hà","path":"Huyện Hải Hà, Tỉnh Quảng Ninh","path_with_type":"Huyện Hải Hà, Tỉnh Quảng Ninh","code":"201","parent_code":"22"},"202":{"name":"Ba Chẽ","type":"huyen","slug":"ba-che","name_with_type":"Huyện Ba Chẽ","path":"Huyện Ba Chẽ, Tỉnh Quảng Ninh","path_with_type":"Huyện Ba Chẽ, Tỉnh Quảng Ninh","code":"202","parent_code":"22"},"203":{"name":"Vân Đồn","type":"huyen","slug":"van-don","name_with_type":"Huyện Vân Đồn","path":"Huyện Vân Đồn, Tỉnh Quảng Ninh","path_with_type":"Huyện Vân Đồn, Tỉnh Quảng Ninh","code":"203","parent_code":"22"},"205":{"name":"Thành phố Đông Triều","type":"thanh-pho","slug":"thanh-pho-dong-trieu","name_with_type":"Thành phố Đông Triều","path":"Thành phố Đông Triều, Tỉnh Quảng Ninh","path_with_type":"Thành phố Đông Triều, Tỉnh Quảng Ninh","code":"205","parent_code":"22"},"206":{"name":"Thị xã Quảng Yên","type":"thi-xa","slug":"thi-xa-quang-yen","name_with_type":"Thị xã Quảng Yên","path":"Thị xã Quảng Yên, Tỉnh Quảng Ninh","path_with_type":"Thị xã Quảng Yên, Tỉnh Quảng Ninh","code":"206","parent_code":"22"},"207":{"name":"Cô Tô","type":"huyen","slug":"co-to","name_with_type":"Huyện Cô Tô","path":"Huyện Cô Tô, Tỉnh Quảng Ninh","path_with_type":"Huyện Cô Tô, Tỉnh Quảng Ninh","code":"207","parent_code":"22"},"213":{"name":"Thành phố Bắc Giang","type":"thanh-pho","slug":"thanh-pho-bac-giang","name_with_type":"Thành phố Bắc Giang","path":"Thành phố Bắc Giang, Tỉnh Bắc Giang","path_with_type":"Thành phố Bắc Giang, Tỉnh Bắc Giang","code":"213","parent_code":"24"},"215":{"name":"Yên Thế","type":"huyen","slug":"yen-the","name_with_type":"Huyện Yên Thế","path":"Huyện Yên Thế, Tỉnh Bắc Giang","path_with_type":"Huyện Yên Thế, Tỉnh Bắc Giang","code":"215","parent_code":"24"},"216":{"name":"Tân Yên","type":"huyen","slug":"tan-yen","name_with_type":"Huyện Tân Yên","path":"Huyện Tân Yên, Tỉnh Bắc Giang","path_with_type":"Huyện Tân Yên, Tỉnh Bắc Giang","code":"216","parent_code":"24"},"217":{"name":"Lạng Giang","type":"huyen","slug":"lang-giang","name_with_type":"Huyện Lạng Giang","path":"Huyện Lạng Giang, Tỉnh Bắc Giang","path_with_type":"Huyện Lạng Giang, Tỉnh Bắc Giang","code":"217","parent_code":"24"},"218":{"name":"Lục Nam","type":"huyen","slug":"luc-nam","name_with_type":"Huyện Lục Nam","path":"Huyện Lục Nam, Tỉnh Bắc Giang","path_with_type":"Huyện Lục Nam, Tỉnh Bắc Giang","code":"218","parent_code":"24"},"219":{"name":"Lục Ngạn","type":"huyen","slug":"luc-ngan","name_with_type":"Huyện Lục Ngạn","path":"Huyện Lục Ngạn, Tỉnh Bắc Giang","path_with_type":"Huyện Lục Ngạn, Tỉnh Bắc Giang","code":"219","parent_code":"24"},"220":{"name":"Sơn Động","type":"huyen","slug":"son-dong","name_with_type":"Huyện Sơn Động","path":"Huyện Sơn Động, Tỉnh Bắc Giang","path_with_type":"Huyện Sơn Động, Tỉnh Bắc Giang","code":"220","parent_code":"24"},"222":{"name":"Thị Xã Việt Yên","type":"thi-xa","slug":"thi-xa-viet-yen","name_with_type":"Thị Xã Việt Yên","path":"Thị Xã Việt Yên, Tỉnh Bắc Giang","path_with_type":"Thị Xã Việt Yên, Tỉnh Bắc Giang","code":"222","parent_code":"24"},"223":{"name":"Hiệp Hòa","type":"huyen","slug":"hiep-hoa","name_with_type":"Huyện Hiệp Hòa","path":"Huyện Hiệp Hòa, Tỉnh Bắc Giang","path_with_type":"Huyện Hiệp Hòa, Tỉnh Bắc Giang","code":"223","parent_code":"24"},"224":{"name":"Thị xã Chũ","type":"thi-xa","slug":"thi-xa-chu","name_with_type":"Thị xã Chũ","path":"Thị xã Chũ, Tỉnh Bắc Giang","path_with_type":"Thị xã Chũ, Tỉnh Bắc Giang","code":"224","parent_code":"24"},"227":{"name":"Thành phố Việt Trì","type":"thanh-pho","slug":"thanh-pho-viet-tri","name_with_type":"Thành phố Việt Trì","path":"Thành phố Việt Trì, Tỉnh Phú Thọ","path_with_type":"Thành phố Việt Trì, Tỉnh Phú Thọ","code":"227","parent_code":"25"},"228":{"name":"Thị xã Phú Thọ","type":"thi-xa","slug":"thi-xa-phu-tho","name_with_type":"Thị xã Phú Thọ","path":"Thị xã Phú Thọ, Tỉnh Phú Thọ","path_with_type":"Thị xã Phú Thọ, Tỉnh Phú Thọ","code":"228","parent_code":"25"},"230":{"name":"Đoan Hùng","type":"huyen","slug":"doan-hung","name_with_type":"Huyện Đoan Hùng","path":"Huyện Đoan Hùng, Tỉnh Phú Thọ","path_with_type":"Huyện Đoan Hùng, Tỉnh Phú Thọ","code":"230","parent_code":"25"},"231":{"name":"Hạ Hoà","type":"huyen","slug":"ha-hoa","name_with_type":"Huyện Hạ Hoà","path":"Huyện Hạ Hoà, Tỉnh Phú Thọ","path_with_type":"Huyện Hạ Hoà, Tỉnh Phú Thọ","code":"231","parent_code":"25"},"232":{"name":"Thanh Ba","type":"huyen","slug":"thanh-ba","name_with_type":"Huyện Thanh Ba","path":"Huyện Thanh Ba, Tỉnh Phú Thọ","path_with_type":"Huyện Thanh Ba, Tỉnh Phú Thọ","code":"232","parent_code":"25"},"233":{"name":"Phù Ninh","type":"huyen","slug":"phu-ninh","name_with_type":"Huyện Phù Ninh","path":"Huyện Phù Ninh, Tỉnh Phú Thọ","path_with_type":"Huyện Phù Ninh, Tỉnh Phú Thọ","code":"233","parent_code":"25"},"234":{"name":"Yên Lập","type":"huyen","slug":"yen-lap","name_with_type":"Huyện Yên Lập","path":"Huyện Yên Lập, Tỉnh Phú Thọ","path_with_type":"Huyện Yên Lập, Tỉnh Phú Thọ","code":"234","parent_code":"25"},"235":{"name":"Cẩm Khê","type":"huyen","slug":"cam-khe","name_with_type":"Huyện Cẩm Khê","path":"Huyện Cẩm Khê, Tỉnh Phú Thọ","path_with_type":"Huyện Cẩm Khê, Tỉnh Phú Thọ","code":"235","parent_code":"25"},"236":{"name":"Tam Nông","type":"huyen","slug":"tam-nong","name_with_type":"Huyện Tam Nông","path":"Huyện Tam Nông, Tỉnh Phú Thọ","path_with_type":"Huyện Tam Nông, Tỉnh Phú Thọ","code":"236","parent_code":"25"},"237":{"name":"Lâm Thao","type":"huyen","slug":"lam-thao","name_with_type":"Huyện Lâm Thao","path":"Huyện Lâm Thao, Tỉnh Phú Thọ","path_with_type":"Huyện Lâm Thao, Tỉnh Phú Thọ","code":"237","parent_code":"25"},"238":{"name":"Thanh Sơn","type":"huyen","slug":"thanh-son","name_with_type":"Huyện Thanh Sơn","path":"Huyện Thanh Sơn, Tỉnh Phú Thọ","path_with_type":"Huyện Thanh Sơn, Tỉnh Phú Thọ","code":"238","parent_code":"25"},"239":{"name":"Thanh Thuỷ","type":"huyen","slug":"thanh-thuy","name_with_type":"Huyện Thanh Thuỷ","path":"Huyện Thanh Thuỷ, Tỉnh Phú Thọ","path_with_type":"Huyện Thanh Thuỷ, Tỉnh Phú Thọ","code":"239","parent_code":"25"},"240":{"name":"Tân Sơn","type":"huyen","slug":"tan-son","name_with_type":"Huyện Tân Sơn","path":"Huyện Tân Sơn, Tỉnh Phú Thọ","path_with_type":"Huyện Tân Sơn, Tỉnh Phú Thọ","code":"240","parent_code":"25"},"243":{"name":"Thành phố Vĩnh Yên","type":"thanh-pho","slug":"thanh-pho-vinh-yen","name_with_type":"Thành phố Vĩnh Yên","path":"Thành phố Vĩnh Yên, Tỉnh Vĩnh Phúc","path_with_type":"Thành phố Vĩnh Yên, Tỉnh Vĩnh Phúc","code":"243","parent_code":"26"},"244":{"name":"Thành phố Phúc Yên","type":"thanh-pho","slug":"thanh-pho-phuc-yen","name_with_type":"Thành phố Phúc Yên","path":"Thành phố Phúc Yên, Tỉnh Vĩnh Phúc","path_with_type":"Thành phố Phúc Yên, Tỉnh Vĩnh Phúc","code":"244","parent_code":"26"},"246":{"name":"Lập Thạch","type":"huyen","slug":"lap-thach","name_with_type":"Huyện Lập Thạch","path":"Huyện Lập Thạch, Tỉnh Vĩnh Phúc","path_with_type":"Huyện Lập Thạch, Tỉnh Vĩnh Phúc","code":"246","parent_code":"26"},"247":{"name":"Tam Dương","type":"huyen","slug":"tam-duong","name_with_type":"Huyện Tam Dương","path":"Huyện Tam Dương, Tỉnh Vĩnh Phúc","path_with_type":"Huyện Tam Dương, Tỉnh Vĩnh Phúc","code":"247","parent_code":"26"},"248":{"name":"Tam Đảo","type":"huyen","slug":"tam-dao","name_with_type":"Huyện Tam Đảo","path":"Huyện Tam Đảo, Tỉnh Vĩnh Phúc","path_with_type":"Huyện Tam Đảo, Tỉnh Vĩnh Phúc","code":"248","parent_code":"26"},"249":{"name":"Bình Xuyên","type":"huyen","slug":"binh-xuyen","name_with_type":"Huyện Bình Xuyên","path":"Huyện Bình Xuyên, Tỉnh Vĩnh Phúc","path_with_type":"Huyện Bình Xuyên, Tỉnh Vĩnh Phúc","code":"249","parent_code":"26"},"250":{"name":"Mê Linh","type":"huyen","slug":"me-linh","name_with_type":"Huyện Mê Linh","path":"Huyện Mê Linh, Thành phố Hà Nội","path_with_type":"Huyện Mê Linh, Thành phố Hà Nội","code":"250","parent_code":"01"},"251":{"name":"Yên Lạc","type":"huyen","slug":"yen-lac","name_with_type":"Huyện Yên Lạc","path":"Huyện Yên Lạc, Tỉnh Vĩnh Phúc","path_with_type":"Huyện Yên Lạc, Tỉnh Vĩnh Phúc","code":"251","parent_code":"26"},"252":{"name":"Vĩnh Tường","type":"huyen","slug":"vinh-tuong","name_with_type":"Huyện Vĩnh Tường","path":"Huyện Vĩnh Tường, Tỉnh Vĩnh Phúc","path_with_type":"Huyện Vĩnh Tường, Tỉnh Vĩnh Phúc","code":"252","parent_code":"26"},"253":{"name":"Sông Lô","type":"huyen","slug":"song-lo","name_with_type":"Huyện Sông Lô","path":"Huyện Sông Lô, Tỉnh Vĩnh Phúc","path_with_type":"Huyện Sông Lô, Tỉnh Vĩnh Phúc","code":"253","parent_code":"26"},"256":{"name":"Thành phố Bắc Ninh","type":"thanh-pho","slug":"thanh-pho-bac-ninh","name_with_type":"Thành phố Bắc Ninh","path":"Thành phố Bắc Ninh, Tỉnh Bắc Ninh","path_with_type":"Thành phố Bắc Ninh, Tỉnh Bắc Ninh","code":"256","parent_code":"27"},"258":{"name":"Yên Phong","type":"huyen","slug":"yen-phong","name_with_type":"Huyện Yên Phong","path":"Huyện Yên Phong, Tỉnh Bắc Ninh","path_with_type":"Huyện Yên Phong, Tỉnh Bắc Ninh","code":"258","parent_code":"27"},"259":{"name":"Thị xã Quế Võ","type":"thi-xa","slug":"thi-xa-que-vo","name_with_type":"Thị xã Quế Võ","path":"Thị xã Quế Võ, Tỉnh Bắc Ninh","path_with_type":"Thị xã Quế Võ, Tỉnh Bắc Ninh","code":"259","parent_code":"27"},"260":{"name":"Tiên Du","type":"huyen","slug":"tien-du","name_with_type":"Huyện Tiên Du","path":"Huyện Tiên Du, Tỉnh Bắc Ninh","path_with_type":"Huyện Tiên Du, Tỉnh Bắc Ninh","code":"260","parent_code":"27"},"261":{"name":"Thành phố Từ Sơn","type":"thanh-pho","slug":"thanh-pho-tu-son","name_with_type":"Thành phố Từ Sơn","path":"Thành phố Từ Sơn, Tỉnh Bắc Ninh","path_with_type":"Thành phố Từ Sơn, Tỉnh Bắc Ninh","code":"261","parent_code":"27"},"262":{"name":"Thị xã Thuận Thành","type":"thi-xa","slug":"thi-xa-thuan-thanh","name_with_type":"Thị xã Thuận Thành","path":"Thị xã Thuận Thành, Tỉnh Bắc Ninh","path_with_type":"Thị xã Thuận Thành, Tỉnh Bắc Ninh","code":"262","parent_code":"27"},"263":{"name":"Gia Bình","type":"huyen","slug":"gia-binh","name_with_type":"Huyện Gia Bình","path":"Huyện Gia Bình, Tỉnh Bắc Ninh","path_with_type":"Huyện Gia Bình, Tỉnh Bắc Ninh","code":"263","parent_code":"27"},"264":{"name":"Lương Tài","type":"huyen","slug":"luong-tai","name_with_type":"Huyện Lương Tài","path":"Huyện Lương Tài, Tỉnh Bắc Ninh","path_with_type":"Huyện Lương Tài, Tỉnh Bắc Ninh","code":"264","parent_code":"27"},"268":{"name":"Quận Hà Đông","type":"quan","slug":"quan-ha-dong","name_with_type":"Quận Hà Đông","path":"Quận Hà Đông, Thành phố Hà Nội","path_with_type":"Quận Hà Đông, Thành phố Hà Nội","code":"268","parent_code":"01"},"269":{"name":"Thị xã Sơn Tây","type":"thi-xa","slug":"thi-xa-son-tay","name_with_type":"Thị xã Sơn Tây","path":"Thị xã Sơn Tây, Thành phố Hà Nội","path_with_type":"Thị xã Sơn Tây, Thành phố Hà Nội","code":"269","parent_code":"01"},"271":{"name":"Ba Vì","type":"huyen","slug":"ba-vi","name_with_type":"Huyện Ba Vì","path":"Huyện Ba Vì, Thành phố Hà Nội","path_with_type":"Huyện Ba Vì, Thành phố Hà Nội","code":"271","parent_code":"01"},"272":{"name":"Phúc Thọ","type":"huyen","slug":"phuc-tho","name_with_type":"Huyện Phúc Thọ","path":"Huyện Phúc Thọ, Thành phố Hà Nội","path_with_type":"Huyện Phúc Thọ, Thành phố Hà Nội","code":"272","parent_code":"01"},"273":{"name":"Đan Phượng","type":"huyen","slug":"dan-phuong","name_with_type":"Huyện Đan Phượng","path":"Huyện Đan Phượng, Thành phố Hà Nội","path_with_type":"Huyện Đan Phượng, Thành phố Hà Nội","code":"273","parent_code":"01"},"274":{"name":"Hoài Đức","type":"huyen","slug":"hoai-duc","name_with_type":"Huyện Hoài Đức","path":"Huyện Hoài Đức, Thành phố Hà Nội","path_with_type":"Huyện Hoài Đức, Thành phố Hà Nội","code":"274","parent_code":"01"},"275":{"name":"Quốc Oai","type":"huyen","slug":"quoc-oai","name_with_type":"Huyện Quốc Oai","path":"Huyện Quốc Oai, Thành phố Hà Nội","path_with_type":"Huyện Quốc Oai, Thành phố Hà Nội","code":"275","parent_code":"01"},"276":{"name":"Thạch Thất","type":"huyen","slug":"thach-that","name_with_type":"Huyện Thạch Thất","path":"Huyện Thạch Thất, Thành phố Hà Nội","path_with_type":"Huyện Thạch Thất, Thành phố Hà Nội","code":"276","parent_code":"01"},"277":{"name":"Chương Mỹ","type":"huyen","slug":"chuong-my","name_with_type":"Huyện Chương Mỹ","path":"Huyện Chương Mỹ, Thành phố Hà Nội","path_with_type":"Huyện Chương Mỹ, Thành phố Hà Nội","code":"277","parent_code":"01"},"278":{"name":"Thanh Oai","type":"huyen","slug":"thanh-oai","name_with_type":"Huyện Thanh Oai","path":"Huyện Thanh Oai, Thành phố Hà Nội","path_with_type":"Huyện Thanh Oai, Thành phố Hà Nội","code":"278","parent_code":"01"},"279":{"name":"Thường Tín","type":"huyen","slug":"thuong-tin","name_with_type":"Huyện Thường Tín","path":"Huyện Thường Tín, Thành phố Hà Nội","path_with_type":"Huyện Thường Tín, Thành phố Hà Nội","code":"279","parent_code":"01"},"280":{"name":"Phú Xuyên","type":"huyen","slug":"phu-xuyen","name_with_type":"Huyện Phú Xuyên","path":"Huyện Phú Xuyên, Thành phố Hà Nội","path_with_type":"Huyện Phú Xuyên, Thành phố Hà Nội","code":"280","parent_code":"01"},"281":{"name":"Ứng Hòa","type":"huyen","slug":"ung-hoa","name_with_type":"Huyện Ứng Hòa","path":"Huyện Ứng Hòa, Thành phố Hà Nội","path_with_type":"Huyện Ứng Hòa, Thành phố Hà Nội","code":"281","parent_code":"01"},"282":{"name":"Mỹ Đức","type":"huyen","slug":"my-duc","name_with_type":"Huyện Mỹ Đức","path":"Huyện Mỹ Đức, Thành phố Hà Nội","path_with_type":"Huyện Mỹ Đức, Thành phố Hà Nội","code":"282","parent_code":"01"},"288":{"name":"Thành phố Hải Dương","type":"thanh-pho","slug":"thanh-pho-hai-duong","name_with_type":"Thành phố Hải Dương","path":"Thành phố Hải Dương, Tỉnh Hải Dương","path_with_type":"Thành phố Hải Dương, Tỉnh Hải Dương","code":"288","parent_code":"30"},"290":{"name":"Thành phố Chí Linh","type":"thanh-pho","slug":"thanh-pho-chi-linh","name_with_type":"Thành phố Chí Linh","path":"Thành phố Chí Linh, Tỉnh Hải Dương","path_with_type":"Thành phố Chí Linh, Tỉnh Hải Dương","code":"290","parent_code":"30"},"291":{"name":"Nam Sách","type":"huyen","slug":"nam-sach","name_with_type":"Huyện Nam Sách","path":"Huyện Nam Sách, Tỉnh Hải Dương","path_with_type":"Huyện Nam Sách, Tỉnh Hải Dương","code":"291","parent_code":"30"},"292":{"name":"Thị xã Kinh Môn","type":"thi-xa","slug":"thi-xa-kinh-mon","name_with_type":"Thị xã Kinh Môn","path":"Thị xã Kinh Môn, Tỉnh Hải Dương","path_with_type":"Thị xã Kinh Môn, Tỉnh Hải Dương","code":"292","parent_code":"30"},"293":{"name":"Kim Thành","type":"huyen","slug":"kim-thanh","name_with_type":"Huyện Kim Thành","path":"Huyện Kim Thành, Tỉnh Hải Dương","path_with_type":"Huyện Kim Thành, Tỉnh Hải Dương","code":"293","parent_code":"30"},"294":{"name":"Thanh Hà","type":"huyen","slug":"thanh-ha","name_with_type":"Huyện Thanh Hà","path":"Huyện Thanh Hà, Tỉnh Hải Dương","path_with_type":"Huyện Thanh Hà, Tỉnh Hải Dương","code":"294","parent_code":"30"},"295":{"name":"Cẩm Giàng","type":"huyen","slug":"cam-giang","name_with_type":"Huyện Cẩm Giàng","path":"Huyện Cẩm Giàng, Tỉnh Hải Dương","path_with_type":"Huyện Cẩm Giàng, Tỉnh Hải Dương","code":"295","parent_code":"30"},"296":{"name":"Bình Giang","type":"huyen","slug":"binh-giang","name_with_type":"Huyện Bình Giang","path":"Huyện Bình Giang, Tỉnh Hải Dương","path_with_type":"Huyện Bình Giang, Tỉnh Hải Dương","code":"296","parent_code":"30"},"297":{"name":"Gia Lộc","type":"huyen","slug":"gia-loc","name_with_type":"Huyện Gia Lộc","path":"Huyện Gia Lộc, Tỉnh Hải Dương","path_with_type":"Huyện Gia Lộc, Tỉnh Hải Dương","code":"297","parent_code":"30"},"298":{"name":"Tứ Kỳ","type":"huyen","slug":"tu-ky","name_with_type":"Huyện Tứ Kỳ","path":"Huyện Tứ Kỳ, Tỉnh Hải Dương","path_with_type":"Huyện Tứ Kỳ, Tỉnh Hải Dương","code":"298","parent_code":"30"},"299":{"name":"Ninh Giang","type":"huyen","slug":"ninh-giang","name_with_type":"Huyện Ninh Giang","path":"Huyện Ninh Giang, Tỉnh Hải Dương","path_with_type":"Huyện Ninh Giang, Tỉnh Hải Dương","code":"299","parent_code":"30"},"300":{"name":"Thanh Miện","type":"huyen","slug":"thanh-mien","name_with_type":"Huyện Thanh Miện","path":"Huyện Thanh Miện, Tỉnh Hải Dương","path_with_type":"Huyện Thanh Miện, Tỉnh Hải Dương","code":"300","parent_code":"30"},"303":{"name":"Quận Hồng Bàng","type":"quan","slug":"quan-hong-bang","name_with_type":"Quận Hồng Bàng","path":"Quận Hồng Bàng, Thành phố Hải Phòng","path_with_type":"Quận Hồng Bàng, Thành phố Hải Phòng","code":"303","parent_code":"31"},"304":{"name":"Quận Ngô Quyền","type":"quan","slug":"quan-ngo-quyen","name_with_type":"Quận Ngô Quyền","path":"Quận Ngô Quyền, Thành phố Hải Phòng","path_with_type":"Quận Ngô Quyền, Thành phố Hải Phòng","code":"304","parent_code":"31"},"305":{"name":"Quận Lê Chân","type":"quan","slug":"quan-le-chan","name_with_type":"Quận Lê Chân","path":"Quận Lê Chân, Thành phố Hải Phòng","path_with_type":"Quận Lê Chân, Thành phố Hải Phòng","code":"305","parent_code":"31"},"306":{"name":"Quận Hải An","type":"quan","slug":"quan-hai-an","name_with_type":"Quận Hải An","path":"Quận Hải An, Thành phố Hải Phòng","path_with_type":"Quận Hải An, Thành phố Hải Phòng","code":"306","parent_code":"31"},"307":{"name":"Quận Kiến An","type":"quan","slug":"quan-kien-an","name_with_type":"Quận Kiến An","path":"Quận Kiến An, Thành phố Hải Phòng","path_with_type":"Quận Kiến An, Thành phố Hải Phòng","code":"307","parent_code":"31"},"308":{"name":"Quận Đồ Sơn","type":"quan","slug":"quan-do-son","name_with_type":"Quận Đồ Sơn","path":"Quận Đồ Sơn, Thành phố Hải Phòng","path_with_type":"Quận Đồ Sơn, Thành phố Hải Phòng","code":"308","parent_code":"31"},"309":{"name":"Quận Dương Kinh","type":"quan","slug":"quan-duong-kinh","name_with_type":"Quận Dương Kinh","path":"Quận Dương Kinh, Thành phố Hải Phòng","path_with_type":"Quận Dương Kinh, Thành phố Hải Phòng","code":"309","parent_code":"31"},"311":{"name":"Thành phố Thuỷ Nguyên","type":"thanh-pho","slug":"thanh-pho-thuy-nguyen","name_with_type":"Thành phố Thuỷ Nguyên","path":"Thành phố Thuỷ Nguyên, Thành phố Hải Phòng","path_with_type":"Thành phố Thuỷ Nguyên, Thành phố Hải Phòng","code":"311","parent_code":"31"},"312":{"name":"Quận An Dương","type":"quan","slug":"quan-an-duong","name_with_type":"Quận An Dương","path":"Quận An Dương, Thành phố Hải Phòng","path_with_type":"Quận An Dương, Thành phố Hải Phòng","code":"312","parent_code":"31"},"313":{"name":"An Lão","type":"huyen","slug":"an-lao","name_with_type":"Huyện An Lão","path":"Huyện An Lão, Thành phố Hải Phòng","path_with_type":"Huyện An Lão, Thành phố Hải Phòng","code":"313","parent_code":"31"},"314":{"name":"Kiến Thuỵ","type":"huyen","slug":"kien-thuy","name_with_type":"Huyện Kiến Thuỵ","path":"Huyện Kiến Thuỵ, Thành phố Hải Phòng","path_with_type":"Huyện Kiến Thuỵ, Thành phố Hải Phòng","code":"314","parent_code":"31"},"315":{"name":"Tiên Lãng","type":"huyen","slug":"tien-lang","name_with_type":"Huyện Tiên Lãng","path":"Huyện Tiên Lãng, Thành phố Hải Phòng","path_with_type":"Huyện Tiên Lãng, Thành phố Hải Phòng","code":"315","parent_code":"31"},"316":{"name":"Vĩnh Bảo","type":"huyen","slug":"vinh-bao","name_with_type":"Huyện Vĩnh Bảo","path":"Huyện Vĩnh Bảo, Thành phố Hải Phòng","path_with_type":"Huyện Vĩnh Bảo, Thành phố Hải Phòng","code":"316","parent_code":"31"},"317":{"name":"Cát Hải","type":"huyen","slug":"cat-hai","name_with_type":"Huyện Cát Hải","path":"Huyện Cát Hải, Thành phố Hải Phòng","path_with_type":"Huyện Cát Hải, Thành phố Hải Phòng","code":"317","parent_code":"31"},"318":{"name":"Bạch Long Vĩ","type":"huyen","slug":"bach-long-vi","name_with_type":"Huyện Bạch Long Vĩ","path":"Huyện Bạch Long Vĩ, Thành phố Hải Phòng","path_with_type":"Huyện Bạch Long Vĩ, Thành phố Hải Phòng","code":"318","parent_code":"31"},"323":{"name":"Thành phố Hưng Yên","type":"thanh-pho","slug":"thanh-pho-hung-yen","name_with_type":"Thành phố Hưng Yên","path":"Thành phố Hưng Yên, Tỉnh Hưng Yên","path_with_type":"Thành phố Hưng Yên, Tỉnh Hưng Yên","code":"323","parent_code":"33"},"325":{"name":"Văn Lâm","type":"huyen","slug":"van-lam","name_with_type":"Huyện Văn Lâm","path":"Huyện Văn Lâm, Tỉnh Hưng Yên","path_with_type":"Huyện Văn Lâm, Tỉnh Hưng Yên","code":"325","parent_code":"33"},"326":{"name":"Văn Giang","type":"huyen","slug":"van-giang","name_with_type":"Huyện Văn Giang","path":"Huyện Văn Giang, Tỉnh Hưng Yên","path_with_type":"Huyện Văn Giang, Tỉnh Hưng Yên","code":"326","parent_code":"33"},"327":{"name":"Yên Mỹ","type":"huyen","slug":"yen-my","name_with_type":"Huyện Yên Mỹ","path":"Huyện Yên Mỹ, Tỉnh Hưng Yên","path_with_type":"Huyện Yên Mỹ, Tỉnh Hưng Yên","code":"327","parent_code":"33"},"328":{"name":"Thị xã Mỹ Hào","type":"thi-xa","slug":"thi-xa-my-hao","name_with_type":"Thị xã Mỹ Hào","path":"Thị xã Mỹ Hào, Tỉnh Hưng Yên","path_with_type":"Thị xã Mỹ Hào, Tỉnh Hưng Yên","code":"328","parent_code":"33"},"329":{"name":"Ân Thi","type":"huyen","slug":"an-thi","name_with_type":"Huyện Ân Thi","path":"Huyện Ân Thi, Tỉnh Hưng Yên","path_with_type":"Huyện Ân Thi, Tỉnh Hưng Yên","code":"329","parent_code":"33"},"330":{"name":"Khoái Châu","type":"huyen","slug":"khoai-chau","name_with_type":"Huyện Khoái Châu","path":"Huyện Khoái Châu, Tỉnh Hưng Yên","path_with_type":"Huyện Khoái Châu, Tỉnh Hưng Yên","code":"330","parent_code":"33"},"331":{"name":"Kim Động","type":"huyen","slug":"kim-dong","name_with_type":"Huyện Kim Động","path":"Huyện Kim Động, Tỉnh Hưng Yên","path_with_type":"Huyện Kim Động, Tỉnh Hưng Yên","code":"331","parent_code":"33"},"332":{"name":"Tiên Lữ","type":"huyen","slug":"tien-lu","name_with_type":"Huyện Tiên Lữ","path":"Huyện Tiên Lữ, Tỉnh Hưng Yên","path_with_type":"Huyện Tiên Lữ, Tỉnh Hưng Yên","code":"332","parent_code":"33"},"333":{"name":"Phù Cừ","type":"huyen","slug":"phu-cu","name_with_type":"Huyện Phù Cừ","path":"Huyện Phù Cừ, Tỉnh Hưng Yên","path_with_type":"Huyện Phù Cừ, Tỉnh Hưng Yên","code":"333","parent_code":"33"},"336":{"name":"Thành phố Thái Bình","type":"thanh-pho","slug":"thanh-pho-thai-binh","name_with_type":"Thành phố Thái Bình","path":"Thành phố Thái Bình, Tỉnh Thái Bình","path_with_type":"Thành phố Thái Bình, Tỉnh Thái Bình","code":"336","parent_code":"34"},"338":{"name":"Quỳnh Phụ","type":"huyen","slug":"quynh-phu","name_with_type":"Huyện Quỳnh Phụ","path":"Huyện Quỳnh Phụ, Tỉnh Thái Bình","path_with_type":"Huyện Quỳnh Phụ, Tỉnh Thái Bình","code":"338","parent_code":"34"},"339":{"name":"Hưng Hà","type":"huyen","slug":"hung-ha","name_with_type":"Huyện Hưng Hà","path":"Huyện Hưng Hà, Tỉnh Thái Bình","path_with_type":"Huyện Hưng Hà, Tỉnh Thái Bình","code":"339","parent_code":"34"},"340":{"name":"Đông Hưng","type":"huyen","slug":"dong-hung","name_with_type":"Huyện Đông Hưng","path":"Huyện Đông Hưng, Tỉnh Thái Bình","path_with_type":"Huyện Đông Hưng, Tỉnh Thái Bình","code":"340","parent_code":"34"},"341":{"name":"Thái Thụy","type":"huyen","slug":"thai-thuy","name_with_type":"Huyện Thái Thụy","path":"Huyện Thái Thụy, Tỉnh Thái Bình","path_with_type":"Huyện Thái Thụy, Tỉnh Thái Bình","code":"341","parent_code":"34"},"342":{"name":"Tiền Hải","type":"huyen","slug":"tien-hai","name_with_type":"Huyện Tiền Hải","path":"Huyện Tiền Hải, Tỉnh Thái Bình","path_with_type":"Huyện Tiền Hải, Tỉnh Thái Bình","code":"342","parent_code":"34"},"343":{"name":"Kiến Xương","type":"huyen","slug":"kien-xuong","name_with_type":"Huyện Kiến Xương","path":"Huyện Kiến Xương, Tỉnh Thái Bình","path_with_type":"Huyện Kiến Xương, Tỉnh Thái Bình","code":"343","parent_code":"34"},"344":{"name":"Vũ Thư","type":"huyen","slug":"vu-thu","name_with_type":"Huyện Vũ Thư","path":"Huyện Vũ Thư, Tỉnh Thái Bình","path_with_type":"Huyện Vũ Thư, Tỉnh Thái Bình","code":"344","parent_code":"34"},"347":{"name":"Thành phố Phủ Lý","type":"thanh-pho","slug":"thanh-pho-phu-ly","name_with_type":"Thành phố Phủ Lý","path":"Thành phố Phủ Lý, Tỉnh Hà Nam","path_with_type":"Thành phố Phủ Lý, Tỉnh Hà Nam","code":"347","parent_code":"35"},"349":{"name":"Thị xã Duy Tiên","type":"thi-xa","slug":"thi-xa-duy-tien","name_with_type":"Thị xã Duy Tiên","path":"Thị xã Duy Tiên, Tỉnh Hà Nam","path_with_type":"Thị xã Duy Tiên, Tỉnh Hà Nam","code":"349","parent_code":"35"},"350":{"name":"Thị xã Kim Bảng","type":"thi-xa","slug":"thi-xa-kim-bang","name_with_type":"Thị xã Kim Bảng","path":"Thị xã Kim Bảng, Tỉnh Hà Nam","path_with_type":"Thị xã Kim Bảng, Tỉnh Hà Nam","code":"350","parent_code":"35"},"351":{"name":"Thanh Liêm","type":"huyen","slug":"thanh-liem","name_with_type":"Huyện Thanh Liêm","path":"Huyện Thanh Liêm, Tỉnh Hà Nam","path_with_type":"Huyện Thanh Liêm, Tỉnh Hà Nam","code":"351","parent_code":"35"},"352":{"name":"Bình Lục","type":"huyen","slug":"binh-luc","name_with_type":"Huyện Bình Lục","path":"Huyện Bình Lục, Tỉnh Hà Nam","path_with_type":"Huyện Bình Lục, Tỉnh Hà Nam","code":"352","parent_code":"35"},"353":{"name":"Lý Nhân","type":"huyen","slug":"ly-nhan","name_with_type":"Huyện Lý Nhân","path":"Huyện Lý Nhân, Tỉnh Hà Nam","path_with_type":"Huyện Lý Nhân, Tỉnh Hà Nam","code":"353","parent_code":"35"},"356":{"name":"Thành phố Nam Định","type":"thanh-pho","slug":"thanh-pho-nam-dinh","name_with_type":"Thành phố Nam Định","path":"Thành phố Nam Định, Tỉnh Nam Định","path_with_type":"Thành phố Nam Định, Tỉnh Nam Định","code":"356","parent_code":"36"},"359":{"name":"Vụ Bản","type":"huyen","slug":"vu-ban","name_with_type":"Huyện Vụ Bản","path":"Huyện Vụ Bản, Tỉnh Nam Định","path_with_type":"Huyện Vụ Bản, Tỉnh Nam Định","code":"359","parent_code":"36"},"360":{"name":"Ý Yên","type":"huyen","slug":"y-yen","name_with_type":"Huyện Ý Yên","path":"Huyện Ý Yên, Tỉnh Nam Định","path_with_type":"Huyện Ý Yên, Tỉnh Nam Định","code":"360","parent_code":"36"},"361":{"name":"Nghĩa Hưng","type":"huyen","slug":"nghia-hung","name_with_type":"Huyện Nghĩa Hưng","path":"Huyện Nghĩa Hưng, Tỉnh Nam Định","path_with_type":"Huyện Nghĩa Hưng, Tỉnh Nam Định","code":"361","parent_code":"36"},"362":{"name":"Nam Trực","type":"huyen","slug":"nam-truc","name_with_type":"Huyện Nam Trực","path":"Huyện Nam Trực, Tỉnh Nam Định","path_with_type":"Huyện Nam Trực, Tỉnh Nam Định","code":"362","parent_code":"36"},"363":{"name":"Trực Ninh","type":"huyen","slug":"truc-ninh","name_with_type":"Huyện Trực Ninh","path":"Huyện Trực Ninh, Tỉnh Nam Định","path_with_type":"Huyện Trực Ninh, Tỉnh Nam Định","code":"363","parent_code":"36"},"364":{"name":"Xuân Trường","type":"huyen","slug":"xuan-truong","name_with_type":"Huyện Xuân Trường","path":"Huyện Xuân Trường, Tỉnh Nam Định","path_with_type":"Huyện Xuân Trường, Tỉnh Nam Định","code":"364","parent_code":"36"},"365":{"name":"Giao Thủy","type":"huyen","slug":"giao-thuy","name_with_type":"Huyện Giao Thủy","path":"Huyện Giao Thủy, Tỉnh Nam Định","path_with_type":"Huyện Giao Thủy, Tỉnh Nam Định","code":"365","parent_code":"36"},"366":{"name":"Hải Hậu","type":"huyen","slug":"hai-hau","name_with_type":"Huyện Hải Hậu","path":"Huyện Hải Hậu, Tỉnh Nam Định","path_with_type":"Huyện Hải Hậu, Tỉnh Nam Định","code":"366","parent_code":"36"},"370":{"name":"Thành phố Tam Điệp","type":"thanh-pho","slug":"thanh-pho-tam-diep","name_with_type":"Thành phố Tam Điệp","path":"Thành phố Tam Điệp, Tỉnh Ninh Bình","path_with_type":"Thành phố Tam Điệp, Tỉnh Ninh Bình","code":"370","parent_code":"37"},"372":{"name":"Nho Quan","type":"huyen","slug":"nho-quan","name_with_type":"Huyện Nho Quan","path":"Huyện Nho Quan, Tỉnh Ninh Bình","path_with_type":"Huyện Nho Quan, Tỉnh Ninh Bình","code":"372","parent_code":"37"},"373":{"name":"Gia Viễn","type":"huyen","slug":"gia-vien","name_with_type":"Huyện Gia Viễn","path":"Huyện Gia Viễn, Tỉnh Ninh Bình","path_with_type":"Huyện Gia Viễn, Tỉnh Ninh Bình","code":"373","parent_code":"37"},"374":{"name":"Thành phố Hoa Lư","type":"thanh-pho","slug":"thanh-pho-hoa-lu","name_with_type":"Thành phố Hoa Lư","path":"Thành phố Hoa Lư, Tỉnh Ninh Bình","path_with_type":"Thành phố Hoa Lư, Tỉnh Ninh Bình","code":"374","parent_code":"37"},"375":{"name":"Yên Khánh","type":"huyen","slug":"yen-khanh","name_with_type":"Huyện Yên Khánh","path":"Huyện Yên Khánh, Tỉnh Ninh Bình","path_with_type":"Huyện Yên Khánh, Tỉnh Ninh Bình","code":"375","parent_code":"37"},"376":{"name":"Kim Sơn","type":"huyen","slug":"kim-son","name_with_type":"Huyện Kim Sơn","path":"Huyện Kim Sơn, Tỉnh Ninh Bình","path_with_type":"Huyện Kim Sơn, Tỉnh Ninh Bình","code":"376","parent_code":"37"},"377":{"name":"Yên Mô","type":"huyen","slug":"yen-mo","name_with_type":"Huyện Yên Mô","path":"Huyện Yên Mô, Tỉnh Ninh Bình","path_with_type":"Huyện Yên Mô, Tỉnh Ninh Bình","code":"377","parent_code":"37"},"380":{"name":"Thành phố Thanh Hóa","type":"thanh-pho","slug":"thanh-pho-thanh-hoa","name_with_type":"Thành phố Thanh Hóa","path":"Thành phố Thanh Hóa, Tỉnh Thanh Hóa","path_with_type":"Thành phố Thanh Hóa, Tỉnh Thanh Hóa","code":"380","parent_code":"38"},"381":{"name":"Thị xã Bỉm Sơn","type":"thi-xa","slug":"thi-xa-bim-son","name_with_type":"Thị xã Bỉm Sơn","path":"Thị xã Bỉm Sơn, Tỉnh Thanh Hóa","path_with_type":"Thị xã Bỉm Sơn, Tỉnh Thanh Hóa","code":"381","parent_code":"38"},"382":{"name":"Thành phố Sầm Sơn","type":"thanh-pho","slug":"thanh-pho-sam-son","name_with_type":"Thành phố Sầm Sơn","path":"Thành phố Sầm Sơn, Tỉnh Thanh Hóa","path_with_type":"Thành phố Sầm Sơn, Tỉnh Thanh Hóa","code":"382","parent_code":"38"},"384":{"name":"Mường Lát","type":"huyen","slug":"muong-lat","name_with_type":"Huyện Mường Lát","path":"Huyện Mường Lát, Tỉnh Thanh Hóa","path_with_type":"Huyện Mường Lát, Tỉnh Thanh Hóa","code":"384","parent_code":"38"},"385":{"name":"Quan Hóa","type":"huyen","slug":"quan-hoa","name_with_type":"Huyện Quan Hóa","path":"Huyện Quan Hóa, Tỉnh Thanh Hóa","path_with_type":"Huyện Quan Hóa, Tỉnh Thanh Hóa","code":"385","parent_code":"38"},"386":{"name":"Bá Thước","type":"huyen","slug":"ba-thuoc","name_with_type":"Huyện Bá Thước","path":"Huyện Bá Thước, Tỉnh Thanh Hóa","path_with_type":"Huyện Bá Thước, Tỉnh Thanh Hóa","code":"386","parent_code":"38"},"387":{"name":"Quan Sơn","type":"huyen","slug":"quan-son","name_with_type":"Huyện Quan Sơn","path":"Huyện Quan Sơn, Tỉnh Thanh Hóa","path_with_type":"Huyện Quan Sơn, Tỉnh Thanh Hóa","code":"387","parent_code":"38"},"388":{"name":"Lang Chánh","type":"huyen","slug":"lang-chanh","name_with_type":"Huyện Lang Chánh","path":"Huyện Lang Chánh, Tỉnh Thanh Hóa","path_with_type":"Huyện Lang Chánh, Tỉnh Thanh Hóa","code":"388","parent_code":"38"},"389":{"name":"Ngọc Lặc","type":"huyen","slug":"ngoc-lac","name_with_type":"Huyện Ngọc Lặc","path":"Huyện Ngọc Lặc, Tỉnh Thanh Hóa","path_with_type":"Huyện Ngọc Lặc, Tỉnh Thanh Hóa","code":"389","parent_code":"38"},"390":{"name":"Cẩm Thủy","type":"huyen","slug":"cam-thuy","name_with_type":"Huyện Cẩm Thủy","path":"Huyện Cẩm Thủy, Tỉnh Thanh Hóa","path_with_type":"Huyện Cẩm Thủy, Tỉnh Thanh Hóa","code":"390","parent_code":"38"},"391":{"name":"Thạch Thành","type":"huyen","slug":"thach-thanh","name_with_type":"Huyện Thạch Thành","path":"Huyện Thạch Thành, Tỉnh Thanh Hóa","path_with_type":"Huyện Thạch Thành, Tỉnh Thanh Hóa","code":"391","parent_code":"38"},"392":{"name":"Hà Trung","type":"huyen","slug":"ha-trung","name_with_type":"Huyện Hà Trung","path":"Huyện Hà Trung, Tỉnh Thanh Hóa","path_with_type":"Huyện Hà Trung, Tỉnh Thanh Hóa","code":"392","parent_code":"38"},"393":{"name":"Vĩnh Lộc","type":"huyen","slug":"vinh-loc","name_with_type":"Huyện Vĩnh Lộc","path":"Huyện Vĩnh Lộc, Tỉnh Thanh Hóa","path_with_type":"Huyện Vĩnh Lộc, Tỉnh Thanh Hóa","code":"393","parent_code":"38"},"394":{"name":"Yên Định","type":"huyen","slug":"yen-dinh","name_with_type":"Huyện Yên Định","path":"Huyện Yên Định, Tỉnh Thanh Hóa","path_with_type":"Huyện Yên Định, Tỉnh Thanh Hóa","code":"394","parent_code":"38"},"395":{"name":"Thọ Xuân","type":"huyen","slug":"tho-xuan","name_with_type":"Huyện Thọ Xuân","path":"Huyện Thọ Xuân, Tỉnh Thanh Hóa","path_with_type":"Huyện Thọ Xuân, Tỉnh Thanh Hóa","code":"395","parent_code":"38"},"396":{"name":"Thường Xuân","type":"huyen","slug":"thuong-xuan","name_with_type":"Huyện Thường Xuân","path":"Huyện Thường Xuân, Tỉnh Thanh Hóa","path_with_type":"Huyện Thường Xuân, Tỉnh Thanh Hóa","code":"396","parent_code":"38"},"397":{"name":"Triệu Sơn","type":"huyen","slug":"trieu-son","name_with_type":"Huyện Triệu Sơn","path":"Huyện Triệu Sơn, Tỉnh Thanh Hóa","path_with_type":"Huyện Triệu Sơn, Tỉnh Thanh Hóa","code":"397","parent_code":"38"},"398":{"name":"Thiệu Hóa","type":"huyen","slug":"thieu-hoa","name_with_type":"Huyện Thiệu Hóa","path":"Huyện Thiệu Hóa, Tỉnh Thanh Hóa","path_with_type":"Huyện Thiệu Hóa, Tỉnh Thanh Hóa","code":"398","parent_code":"38"},"399":{"name":"Hoằng Hóa","type":"huyen","slug":"hoang-hoa","name_with_type":"Huyện Hoằng Hóa","path":"Huyện Hoằng Hóa, Tỉnh Thanh Hóa","path_with_type":"Huyện Hoằng Hóa, Tỉnh Thanh Hóa","code":"399","parent_code":"38"},"400":{"name":"Hậu Lộc","type":"huyen","slug":"hau-loc","name_with_type":"Huyện Hậu Lộc","path":"Huyện Hậu Lộc, Tỉnh Thanh Hóa","path_with_type":"Huyện Hậu Lộc, Tỉnh Thanh Hóa","code":"400","parent_code":"38"},"401":{"name":"Nga Sơn","type":"huyen","slug":"nga-son","name_with_type":"Huyện Nga Sơn","path":"Huyện Nga Sơn, Tỉnh Thanh Hóa","path_with_type":"Huyện Nga Sơn, Tỉnh Thanh Hóa","code":"401","parent_code":"38"},"402":{"name":"Như Xuân","type":"huyen","slug":"nhu-xuan","name_with_type":"Huyện Như Xuân","path":"Huyện Như Xuân, Tỉnh Thanh Hóa","path_with_type":"Huyện Như Xuân, Tỉnh Thanh Hóa","code":"402","parent_code":"38"},"403":{"name":"Như Thanh","type":"huyen","slug":"nhu-thanh","name_with_type":"Huyện Như Thanh","path":"Huyện Như Thanh, Tỉnh Thanh Hóa","path_with_type":"Huyện Như Thanh, Tỉnh Thanh Hóa","code":"403","parent_code":"38"},"404":{"name":"Nông Cống","type":"huyen","slug":"nong-cong","name_with_type":"Huyện Nông Cống","path":"Huyện Nông Cống, Tỉnh Thanh Hóa","path_with_type":"Huyện Nông Cống, Tỉnh Thanh Hóa","code":"404","parent_code":"38"},"406":{"name":"Quảng Xương","type":"huyen","slug":"quang-xuong","name_with_type":"Huyện Quảng Xương","path":"Huyện Quảng Xương, Tỉnh Thanh Hóa","path_with_type":"Huyện Quảng Xương, Tỉnh Thanh Hóa","code":"406","parent_code":"38"},"407":{"name":"Thị xã Nghi Sơn","type":"thi-xa","slug":"thi-xa-nghi-son","name_with_type":"Thị xã Nghi Sơn","path":"Thị xã Nghi Sơn, Tỉnh Thanh Hóa","path_with_type":"Thị xã Nghi Sơn, Tỉnh Thanh Hóa","code":"407","parent_code":"38"},"412":{"name":"Thành phố Vinh","type":"thanh-pho","slug":"thanh-pho-vinh","name_with_type":"Thành phố Vinh","path":"Thành phố Vinh, Tỉnh Nghệ An","path_with_type":"Thành phố Vinh, Tỉnh Nghệ An","code":"412","parent_code":"40"},"414":{"name":"Thị xã Thái Hoà","type":"thi-xa","slug":"thi-xa-thai-hoa","name_with_type":"Thị xã Thái Hoà","path":"Thị xã Thái Hoà, Tỉnh Nghệ An","path_with_type":"Thị xã Thái Hoà, Tỉnh Nghệ An","code":"414","parent_code":"40"},"415":{"name":"Quế Phong","type":"huyen","slug":"que-phong","name_with_type":"Huyện Quế Phong","path":"Huyện Quế Phong, Tỉnh Nghệ An","path_with_type":"Huyện Quế Phong, Tỉnh Nghệ An","code":"415","parent_code":"40"},"416":{"name":"Quỳ Châu","type":"huyen","slug":"quy-chau","name_with_type":"Huyện Quỳ Châu","path":"Huyện Quỳ Châu, Tỉnh Nghệ An","path_with_type":"Huyện Quỳ Châu, Tỉnh Nghệ An","code":"416","parent_code":"40"},"417":{"name":"Kỳ Sơn","type":"huyen","slug":"ky-son","name_with_type":"Huyện Kỳ Sơn","path":"Huyện Kỳ Sơn, Tỉnh Nghệ An","path_with_type":"Huyện Kỳ Sơn, Tỉnh Nghệ An","code":"417","parent_code":"40"},"418":{"name":"Tương Dương","type":"huyen","slug":"tuong-duong","name_with_type":"Huyện Tương Dương","path":"Huyện Tương Dương, Tỉnh Nghệ An","path_with_type":"Huyện Tương Dương, Tỉnh Nghệ An","code":"418","parent_code":"40"},"419":{"name":"Nghĩa Đàn","type":"huyen","slug":"nghia-dan","name_with_type":"Huyện Nghĩa Đàn","path":"Huyện Nghĩa Đàn, Tỉnh Nghệ An","path_with_type":"Huyện Nghĩa Đàn, Tỉnh Nghệ An","code":"419","parent_code":"40"},"420":{"name":"Quỳ Hợp","type":"huyen","slug":"quy-hop","name_with_type":"Huyện Quỳ Hợp","path":"Huyện Quỳ Hợp, Tỉnh Nghệ An","path_with_type":"Huyện Quỳ Hợp, Tỉnh Nghệ An","code":"420","parent_code":"40"},"421":{"name":"Quỳnh Lưu","type":"huyen","slug":"quynh-luu","name_with_type":"Huyện Quỳnh Lưu","path":"Huyện Quỳnh Lưu, Tỉnh Nghệ An","path_with_type":"Huyện Quỳnh Lưu, Tỉnh Nghệ An","code":"421","parent_code":"40"},"422":{"name":"Con Cuông","type":"huyen","slug":"con-cuong","name_with_type":"Huyện Con Cuông","path":"Huyện Con Cuông, Tỉnh Nghệ An","path_with_type":"Huyện Con Cuông, Tỉnh Nghệ An","code":"422","parent_code":"40"},"423":{"name":"Tân Kỳ","type":"huyen","slug":"tan-ky","name_with_type":"Huyện Tân Kỳ","path":"Huyện Tân Kỳ, Tỉnh Nghệ An","path_with_type":"Huyện Tân Kỳ, Tỉnh Nghệ An","code":"423","parent_code":"40"},"424":{"name":"Anh Sơn","type":"huyen","slug":"anh-son","name_with_type":"Huyện Anh Sơn","path":"Huyện Anh Sơn, Tỉnh Nghệ An","path_with_type":"Huyện Anh Sơn, Tỉnh Nghệ An","code":"424","parent_code":"40"},"425":{"name":"Diễn Châu","type":"huyen","slug":"dien-chau","name_with_type":"Huyện Diễn Châu","path":"Huyện Diễn Châu, Tỉnh Nghệ An","path_with_type":"Huyện Diễn Châu, Tỉnh Nghệ An","code":"425","parent_code":"40"},"426":{"name":"Yên Thành","type":"huyen","slug":"yen-thanh","name_with_type":"Huyện Yên Thành","path":"Huyện Yên Thành, Tỉnh Nghệ An","path_with_type":"Huyện Yên Thành, Tỉnh Nghệ An","code":"426","parent_code":"40"},"427":{"name":"Đô Lương","type":"huyen","slug":"do-luong","name_with_type":"Huyện Đô Lương","path":"Huyện Đô Lương, Tỉnh Nghệ An","path_with_type":"Huyện Đô Lương, Tỉnh Nghệ An","code":"427","parent_code":"40"},"428":{"name":"Thanh Chương","type":"huyen","slug":"thanh-chuong","name_with_type":"Huyện Thanh Chương","path":"Huyện Thanh Chương, Tỉnh Nghệ An","path_with_type":"Huyện Thanh Chương, Tỉnh Nghệ An","code":"428","parent_code":"40"},"429":{"name":"Nghi Lộc","type":"huyen","slug":"nghi-loc","name_with_type":"Huyện Nghi Lộc","path":"Huyện Nghi Lộc, Tỉnh Nghệ An","path_with_type":"Huyện Nghi Lộc, Tỉnh Nghệ An","code":"429","parent_code":"40"},"430":{"name":"Nam Đàn","type":"huyen","slug":"nam-dan","name_with_type":"Huyện Nam Đàn","path":"Huyện Nam Đàn, Tỉnh Nghệ An","path_with_type":"Huyện Nam Đàn, Tỉnh Nghệ An","code":"430","parent_code":"40"},"431":{"name":"Hưng Nguyên","type":"huyen","slug":"hung-nguyen","name_with_type":"Huyện Hưng Nguyên","path":"Huyện Hưng Nguyên, Tỉnh Nghệ An","path_with_type":"Huyện Hưng Nguyên, Tỉnh Nghệ An","code":"431","parent_code":"40"},"432":{"name":"Thị xã Hoàng Mai","type":"thi-xa","slug":"thi-xa-hoang-mai","name_with_type":"Thị xã Hoàng Mai","path":"Thị xã Hoàng Mai, Tỉnh Nghệ An","path_with_type":"Thị xã Hoàng Mai, Tỉnh Nghệ An","code":"432","parent_code":"40"},"436":{"name":"Thành phố Hà Tĩnh","type":"thanh-pho","slug":"thanh-pho-ha-tinh","name_with_type":"Thành phố Hà Tĩnh","path":"Thành phố Hà Tĩnh, Tỉnh Hà Tĩnh","path_with_type":"Thành phố Hà Tĩnh, Tỉnh Hà Tĩnh","code":"436","parent_code":"42"},"437":{"name":"Thị xã Hồng Lĩnh","type":"thi-xa","slug":"thi-xa-hong-linh","name_with_type":"Thị xã Hồng Lĩnh","path":"Thị xã Hồng Lĩnh, Tỉnh Hà Tĩnh","path_with_type":"Thị xã Hồng Lĩnh, Tỉnh Hà Tĩnh","code":"437","parent_code":"42"},"439":{"name":"Hương Sơn","type":"huyen","slug":"huong-son","name_with_type":"Huyện Hương Sơn","path":"Huyện Hương Sơn, Tỉnh Hà Tĩnh","path_with_type":"Huyện Hương Sơn, Tỉnh Hà Tĩnh","code":"439","parent_code":"42"},"440":{"name":"Đức Thọ","type":"huyen","slug":"duc-tho","name_with_type":"Huyện Đức Thọ","path":"Huyện Đức Thọ, Tỉnh Hà Tĩnh","path_with_type":"Huyện Đức Thọ, Tỉnh Hà Tĩnh","code":"440","parent_code":"42"},"441":{"name":"Vũ Quang","type":"huyen","slug":"vu-quang","name_with_type":"Huyện Vũ Quang","path":"Huyện Vũ Quang, Tỉnh Hà Tĩnh","path_with_type":"Huyện Vũ Quang, Tỉnh Hà Tĩnh","code":"441","parent_code":"42"},"442":{"name":"Nghi Xuân","type":"huyen","slug":"nghi-xuan","name_with_type":"Huyện Nghi Xuân","path":"Huyện Nghi Xuân, Tỉnh Hà Tĩnh","path_with_type":"Huyện Nghi Xuân, Tỉnh Hà Tĩnh","code":"442","parent_code":"42"},"443":{"name":"Can Lộc","type":"huyen","slug":"can-loc","name_with_type":"Huyện Can Lộc","path":"Huyện Can Lộc, Tỉnh Hà Tĩnh","path_with_type":"Huyện Can Lộc, Tỉnh Hà Tĩnh","code":"443","parent_code":"42"},"444":{"name":"Hương Khê","type":"huyen","slug":"huong-khe","name_with_type":"Huyện Hương Khê","path":"Huyện Hương Khê, Tỉnh Hà Tĩnh","path_with_type":"Huyện Hương Khê, Tỉnh Hà Tĩnh","code":"444","parent_code":"42"},"445":{"name":"Thạch Hà","type":"huyen","slug":"thach-ha","name_with_type":"Huyện Thạch Hà","path":"Huyện Thạch Hà, Tỉnh Hà Tĩnh","path_with_type":"Huyện Thạch Hà, Tỉnh Hà Tĩnh","code":"445","parent_code":"42"},"446":{"name":"Cẩm Xuyên","type":"huyen","slug":"cam-xuyen","name_with_type":"Huyện Cẩm Xuyên","path":"Huyện Cẩm Xuyên, Tỉnh Hà Tĩnh","path_with_type":"Huyện Cẩm Xuyên, Tỉnh Hà Tĩnh","code":"446","parent_code":"42"},"447":{"name":"Kỳ Anh","type":"huyen","slug":"ky-anh","name_with_type":"Huyện Kỳ Anh","path":"Huyện Kỳ Anh, Tỉnh Hà Tĩnh","path_with_type":"Huyện Kỳ Anh, Tỉnh Hà Tĩnh","code":"447","parent_code":"42"},"449":{"name":"Thị xã Kỳ Anh","type":"thi-xa","slug":"thi-xa-ky-anh","name_with_type":"Thị xã Kỳ Anh","path":"Thị xã Kỳ Anh, Tỉnh Hà Tĩnh","path_with_type":"Thị xã Kỳ Anh, Tỉnh Hà Tĩnh","code":"449","parent_code":"42"},"450":{"name":"Thành Phố Đồng Hới","type":"thanh-pho","slug":"thanh-pho-dong-hoi","name_with_type":"Thành Phố Đồng Hới","path":"Thành Phố Đồng Hới, Tỉnh Quảng Bình","path_with_type":"Thành Phố Đồng Hới, Tỉnh Quảng Bình","code":"450","parent_code":"44"},"452":{"name":"Minh Hóa","type":"huyen","slug":"minh-hoa","name_with_type":"Huyện Minh Hóa","path":"Huyện Minh Hóa, Tỉnh Quảng Bình","path_with_type":"Huyện Minh Hóa, Tỉnh Quảng Bình","code":"452","parent_code":"44"},"453":{"name":"Tuyên Hóa","type":"huyen","slug":"tuyen-hoa","name_with_type":"Huyện Tuyên Hóa","path":"Huyện Tuyên Hóa, Tỉnh Quảng Bình","path_with_type":"Huyện Tuyên Hóa, Tỉnh Quảng Bình","code":"453","parent_code":"44"},"454":{"name":"Quảng Trạch","type":"huyen","slug":"quang-trach","name_with_type":"Huyện Quảng Trạch","path":"Huyện Quảng Trạch, Tỉnh Quảng Bình","path_with_type":"Huyện Quảng Trạch, Tỉnh Quảng Bình","code":"454","parent_code":"44"},"455":{"name":"Bố Trạch","type":"huyen","slug":"bo-trach","name_with_type":"Huyện Bố Trạch","path":"Huyện Bố Trạch, Tỉnh Quảng Bình","path_with_type":"Huyện Bố Trạch, Tỉnh Quảng Bình","code":"455","parent_code":"44"},"456":{"name":"Quảng Ninh","type":"huyen","slug":"quang-ninh","name_with_type":"Huyện Quảng Ninh","path":"Huyện Quảng Ninh, Tỉnh Quảng Bình","path_with_type":"Huyện Quảng Ninh, Tỉnh Quảng Bình","code":"456","parent_code":"44"},"457":{"name":"Lệ Thủy","type":"huyen","slug":"le-thuy","name_with_type":"Huyện Lệ Thủy","path":"Huyện Lệ Thủy, Tỉnh Quảng Bình","path_with_type":"Huyện Lệ Thủy, Tỉnh Quảng Bình","code":"457","parent_code":"44"},"458":{"name":"Thị xã Ba Đồn","type":"thi-xa","slug":"thi-xa-ba-don","name_with_type":"Thị xã Ba Đồn","path":"Thị xã Ba Đồn, Tỉnh Quảng Bình","path_with_type":"Thị xã Ba Đồn, Tỉnh Quảng Bình","code":"458","parent_code":"44"},"461":{"name":"Thành phố Đông Hà","type":"thanh-pho","slug":"thanh-pho-dong-ha","name_with_type":"Thành phố Đông Hà","path":"Thành phố Đông Hà, Tỉnh Quảng Trị","path_with_type":"Thành phố Đông Hà, Tỉnh Quảng Trị","code":"461","parent_code":"45"},"462":{"name":"Thị xã Quảng Trị","type":"thi-xa","slug":"thi-xa-quang-tri","name_with_type":"Thị xã Quảng Trị","path":"Thị xã Quảng Trị, Tỉnh Quảng Trị","path_with_type":"Thị xã Quảng Trị, Tỉnh Quảng Trị","code":"462","parent_code":"45"},"464":{"name":"Vĩnh Linh","type":"huyen","slug":"vinh-linh","name_with_type":"Huyện Vĩnh Linh","path":"Huyện Vĩnh Linh, Tỉnh Quảng Trị","path_with_type":"Huyện Vĩnh Linh, Tỉnh Quảng Trị","code":"464","parent_code":"45"},"465":{"name":"Hướng Hóa","type":"huyen","slug":"huong-hoa","name_with_type":"Huyện Hướng Hóa","path":"Huyện Hướng Hóa, Tỉnh Quảng Trị","path_with_type":"Huyện Hướng Hóa, Tỉnh Quảng Trị","code":"465","parent_code":"45"},"466":{"name":"Gio Linh","type":"huyen","slug":"gio-linh","name_with_type":"Huyện Gio Linh","path":"Huyện Gio Linh, Tỉnh Quảng Trị","path_with_type":"Huyện Gio Linh, Tỉnh Quảng Trị","code":"466","parent_code":"45"},"467":{"name":"Đa Krông","type":"huyen","slug":"da-krong","name_with_type":"Huyện Đa Krông","path":"Huyện Đa Krông, Tỉnh Quảng Trị","path_with_type":"Huyện Đa Krông, Tỉnh Quảng Trị","code":"467","parent_code":"45"},"468":{"name":"Cam Lộ","type":"huyen","slug":"cam-lo","name_with_type":"Huyện Cam Lộ","path":"Huyện Cam Lộ, Tỉnh Quảng Trị","path_with_type":"Huyện Cam Lộ, Tỉnh Quảng Trị","code":"468","parent_code":"45"},"469":{"name":"Triệu Phong","type":"huyen","slug":"trieu-phong","name_with_type":"Huyện Triệu Phong","path":"Huyện Triệu Phong, Tỉnh Quảng Trị","path_with_type":"Huyện Triệu Phong, Tỉnh Quảng Trị","code":"469","parent_code":"45"},"470":{"name":"Hải Lăng","type":"huyen","slug":"hai-lang","name_with_type":"Huyện Hải Lăng","path":"Huyện Hải Lăng, Tỉnh Quảng Trị","path_with_type":"Huyện Hải Lăng, Tỉnh Quảng Trị","code":"470","parent_code":"45"},"471":{"name":"Cồn Cỏ","type":"huyen","slug":"con-co","name_with_type":"Huyện Cồn Cỏ","path":"Huyện Cồn Cỏ, Tỉnh Quảng Trị","path_with_type":"Huyện Cồn Cỏ, Tỉnh Quảng Trị","code":"471","parent_code":"45"},"474":{"name":"Quận Thuận Hóa","type":"quan","slug":"quan-thuan-hoa","name_with_type":"Quận Thuận Hóa","path":"Quận Thuận Hóa, Thành phố Huế","path_with_type":"Quận Thuận Hóa, Thành phố Huế","code":"474","parent_code":"46"},"475":{"name":"Quận Phú Xuân","type":"quan","slug":"quan-phu-xuan","name_with_type":"Quận Phú Xuân","path":"Quận Phú Xuân, Thành phố Huế","path_with_type":"Quận Phú Xuân, Thành phố Huế","code":"475","parent_code":"46"},"476":{"name":"Thị xã Phong Điền","type":"thi-xa","slug":"thi-xa-phong-dien","name_with_type":"Thị xã Phong Điền","path":"Thị xã Phong Điền, Thành phố Huế","path_with_type":"Thị xã Phong Điền, Thành phố Huế","code":"476","parent_code":"46"},"477":{"name":"Quảng Điền","type":"huyen","slug":"quang-dien","name_with_type":"Huyện Quảng Điền","path":"Huyện Quảng Điền, Thành phố Huế","path_with_type":"Huyện Quảng Điền, Thành phố Huế","code":"477","parent_code":"46"},"478":{"name":"Phú Vang","type":"huyen","slug":"phu-vang","name_with_type":"Huyện Phú Vang","path":"Huyện Phú Vang, Thành phố Huế","path_with_type":"Huyện Phú Vang, Thành phố Huế","code":"478","parent_code":"46"},"479":{"name":"Thị xã Hương Thủy","type":"thi-xa","slug":"thi-xa-huong-thuy","name_with_type":"Thị xã Hương Thủy","path":"Thị xã Hương Thủy, Thành phố Huế","path_with_type":"Thị xã Hương Thủy, Thành phố Huế","code":"479","parent_code":"46"},"480":{"name":"Thị xã Hương Trà","type":"thi-xa","slug":"thi-xa-huong-tra","name_with_type":"Thị xã Hương Trà","path":"Thị xã Hương Trà, Thành phố Huế","path_with_type":"Thị xã Hương Trà, Thành phố Huế","code":"480","parent_code":"46"},"481":{"name":"A Lưới","type":"huyen","slug":"a-luoi","name_with_type":"Huyện A Lưới","path":"Huyện A Lưới, Thành phố Huế","path_with_type":"Huyện A Lưới, Thành phố Huế","code":"481","parent_code":"46"},"482":{"name":"Phú Lộc","type":"huyen","slug":"phu-loc","name_with_type":"Huyện Phú Lộc","path":"Huyện Phú Lộc, Thành phố Huế","path_with_type":"Huyện Phú Lộc, Thành phố Huế","code":"482","parent_code":"46"},"490":{"name":"Quận Liên Chiểu","type":"quan","slug":"quan-lien-chieu","name_with_type":"Quận Liên Chiểu","path":"Quận Liên Chiểu, Thành phố Đà Nẵng","path_with_type":"Quận Liên Chiểu, Thành phố Đà Nẵng","code":"490","parent_code":"48"},"491":{"name":"Quận Thanh Khê","type":"quan","slug":"quan-thanh-khe","name_with_type":"Quận Thanh Khê","path":"Quận Thanh Khê, Thành phố Đà Nẵng","path_with_type":"Quận Thanh Khê, Thành phố Đà Nẵng","code":"491","parent_code":"48"},"492":{"name":"Quận Hải Châu","type":"quan","slug":"quan-hai-chau","name_with_type":"Quận Hải Châu","path":"Quận Hải Châu, Thành phố Đà Nẵng","path_with_type":"Quận Hải Châu, Thành phố Đà Nẵng","code":"492","parent_code":"48"},"493":{"name":"Quận Sơn Trà","type":"quan","slug":"quan-son-tra","name_with_type":"Quận Sơn Trà","path":"Quận Sơn Trà, Thành phố Đà Nẵng","path_with_type":"Quận Sơn Trà, Thành phố Đà Nẵng","code":"493","parent_code":"48"},"494":{"name":"Quận Ngũ Hành Sơn","type":"quan","slug":"quan-ngu-hanh-son","name_with_type":"Quận Ngũ Hành Sơn","path":"Quận Ngũ Hành Sơn, Thành phố Đà Nẵng","path_with_type":"Quận Ngũ Hành Sơn, Thành phố Đà Nẵng","code":"494","parent_code":"48"},"495":{"name":"Quận Cẩm Lệ","type":"quan","slug":"quan-cam-le","name_with_type":"Quận Cẩm Lệ","path":"Quận Cẩm Lệ, Thành phố Đà Nẵng","path_with_type":"Quận Cẩm Lệ, Thành phố Đà Nẵng","code":"495","parent_code":"48"},"497":{"name":"Hòa Vang","type":"huyen","slug":"hoa-vang","name_with_type":"Huyện Hòa Vang","path":"Huyện Hòa Vang, Thành phố Đà Nẵng","path_with_type":"Huyện Hòa Vang, Thành phố Đà Nẵng","code":"497","parent_code":"48"},"498":{"name":"Hoàng Sa","type":"huyen","slug":"hoang-sa","name_with_type":"Huyện Hoàng Sa","path":"Huyện Hoàng Sa, Thành phố Đà Nẵng","path_with_type":"Huyện Hoàng Sa, Thành phố Đà Nẵng","code":"498","parent_code":"48"},"502":{"name":"Thành phố Tam Kỳ","type":"thanh-pho","slug":"thanh-pho-tam-ky","name_with_type":"Thành phố Tam Kỳ","path":"Thành phố Tam Kỳ, Tỉnh Quảng Nam","path_with_type":"Thành phố Tam Kỳ, Tỉnh Quảng Nam","code":"502","parent_code":"49"},"503":{"name":"Thành phố Hội An","type":"thanh-pho","slug":"thanh-pho-hoi-an","name_with_type":"Thành phố Hội An","path":"Thành phố Hội An, Tỉnh Quảng Nam","path_with_type":"Thành phố Hội An, Tỉnh Quảng Nam","code":"503","parent_code":"49"},"504":{"name":"Tây Giang","type":"huyen","slug":"tay-giang","name_with_type":"Huyện Tây Giang","path":"Huyện Tây Giang, Tỉnh Quảng Nam","path_with_type":"Huyện Tây Giang, Tỉnh Quảng Nam","code":"504","parent_code":"49"},"505":{"name":"Đông Giang","type":"huyen","slug":"dong-giang","name_with_type":"Huyện Đông Giang","path":"Huyện Đông Giang, Tỉnh Quảng Nam","path_with_type":"Huyện Đông Giang, Tỉnh Quảng Nam","code":"505","parent_code":"49"},"506":{"name":"Đại Lộc","type":"huyen","slug":"dai-loc","name_with_type":"Huyện Đại Lộc","path":"Huyện Đại Lộc, Tỉnh Quảng Nam","path_with_type":"Huyện Đại Lộc, Tỉnh Quảng Nam","code":"506","parent_code":"49"},"507":{"name":"Thị xã Điện Bàn","type":"thi-xa","slug":"thi-xa-dien-ban","name_with_type":"Thị xã Điện Bàn","path":"Thị xã Điện Bàn, Tỉnh Quảng Nam","path_with_type":"Thị xã Điện Bàn, Tỉnh Quảng Nam","code":"507","parent_code":"49"},"508":{"name":"Duy Xuyên","type":"huyen","slug":"duy-xuyen","name_with_type":"Huyện Duy Xuyên","path":"Huyện Duy Xuyên, Tỉnh Quảng Nam","path_with_type":"Huyện Duy Xuyên, Tỉnh Quảng Nam","code":"508","parent_code":"49"},"509":{"name":"Quế Sơn","type":"huyen","slug":"que-son","name_with_type":"Huyện Quế Sơn","path":"Huyện Quế Sơn, Tỉnh Quảng Nam","path_with_type":"Huyện Quế Sơn, Tỉnh Quảng Nam","code":"509","parent_code":"49"},"510":{"name":"Nam Giang","type":"huyen","slug":"nam-giang","name_with_type":"Huyện Nam Giang","path":"Huyện Nam Giang, Tỉnh Quảng Nam","path_with_type":"Huyện Nam Giang, Tỉnh Quảng Nam","code":"510","parent_code":"49"},"511":{"name":"Phước Sơn","type":"huyen","slug":"phuoc-son","name_with_type":"Huyện Phước Sơn","path":"Huyện Phước Sơn, Tỉnh Quảng Nam","path_with_type":"Huyện Phước Sơn, Tỉnh Quảng Nam","code":"511","parent_code":"49"},"512":{"name":"Hiệp Đức","type":"huyen","slug":"hiep-duc","name_with_type":"Huyện Hiệp Đức","path":"Huyện Hiệp Đức, Tỉnh Quảng Nam","path_with_type":"Huyện Hiệp Đức, Tỉnh Quảng Nam","code":"512","parent_code":"49"},"513":{"name":"Thăng Bình","type":"huyen","slug":"thang-binh","name_with_type":"Huyện Thăng Bình","path":"Huyện Thăng Bình, Tỉnh Quảng Nam","path_with_type":"Huyện Thăng Bình, Tỉnh Quảng Nam","code":"513","parent_code":"49"},"514":{"name":"Tiên Phước","type":"huyen","slug":"tien-phuoc","name_with_type":"Huyện Tiên Phước","path":"Huyện Tiên Phước, Tỉnh Quảng Nam","path_with_type":"Huyện Tiên Phước, Tỉnh Quảng Nam","code":"514","parent_code":"49"},"515":{"name":"Bắc Trà My","type":"huyen","slug":"bac-tra-my","name_with_type":"Huyện Bắc Trà My","path":"Huyện Bắc Trà My, Tỉnh Quảng Nam","path_with_type":"Huyện Bắc Trà My, Tỉnh Quảng Nam","code":"515","parent_code":"49"},"516":{"name":"Nam Trà My","type":"huyen","slug":"nam-tra-my","name_with_type":"Huyện Nam Trà My","path":"Huyện Nam Trà My, Tỉnh Quảng Nam","path_with_type":"Huyện Nam Trà My, Tỉnh Quảng Nam","code":"516","parent_code":"49"},"517":{"name":"Núi Thành","type":"huyen","slug":"nui-thanh","name_with_type":"Huyện Núi Thành","path":"Huyện Núi Thành, Tỉnh Quảng Nam","path_with_type":"Huyện Núi Thành, Tỉnh Quảng Nam","code":"517","parent_code":"49"},"518":{"name":"Phú Ninh","type":"huyen","slug":"phu-ninh","name_with_type":"Huyện Phú Ninh","path":"Huyện Phú Ninh, Tỉnh Quảng Nam","path_with_type":"Huyện Phú Ninh, Tỉnh Quảng Nam","code":"518","parent_code":"49"},"522":{"name":"Thành phố Quảng Ngãi","type":"thanh-pho","slug":"thanh-pho-quang-ngai","name_with_type":"Thành phố Quảng Ngãi","path":"Thành phố Quảng Ngãi, Tỉnh Quảng Ngãi","path_with_type":"Thành phố Quảng Ngãi, Tỉnh Quảng Ngãi","code":"522","parent_code":"51"},"524":{"name":"Bình Sơn","type":"huyen","slug":"binh-son","name_with_type":"Huyện Bình Sơn","path":"Huyện Bình Sơn, Tỉnh Quảng Ngãi","path_with_type":"Huyện Bình Sơn, Tỉnh Quảng Ngãi","code":"524","parent_code":"51"},"525":{"name":"Trà Bồng","type":"huyen","slug":"tra-bong","name_with_type":"Huyện Trà Bồng","path":"Huyện Trà Bồng, Tỉnh Quảng Ngãi","path_with_type":"Huyện Trà Bồng, Tỉnh Quảng Ngãi","code":"525","parent_code":"51"},"527":{"name":"Sơn Tịnh","type":"huyen","slug":"son-tinh","name_with_type":"Huyện Sơn Tịnh","path":"Huyện Sơn Tịnh, Tỉnh Quảng Ngãi","path_with_type":"Huyện Sơn Tịnh, Tỉnh Quảng Ngãi","code":"527","parent_code":"51"},"528":{"name":"Tư Nghĩa","type":"huyen","slug":"tu-nghia","name_with_type":"Huyện Tư Nghĩa","path":"Huyện Tư Nghĩa, Tỉnh Quảng Ngãi","path_with_type":"Huyện Tư Nghĩa, Tỉnh Quảng Ngãi","code":"528","parent_code":"51"},"529":{"name":"Sơn Hà","type":"huyen","slug":"son-ha","name_with_type":"Huyện Sơn Hà","path":"Huyện Sơn Hà, Tỉnh Quảng Ngãi","path_with_type":"Huyện Sơn Hà, Tỉnh Quảng Ngãi","code":"529","parent_code":"51"},"530":{"name":"Sơn Tây","type":"huyen","slug":"son-tay","name_with_type":"Huyện Sơn Tây","path":"Huyện Sơn Tây, Tỉnh Quảng Ngãi","path_with_type":"Huyện Sơn Tây, Tỉnh Quảng Ngãi","code":"530","parent_code":"51"},"531":{"name":"Minh Long","type":"huyen","slug":"minh-long","name_with_type":"Huyện Minh Long","path":"Huyện Minh Long, Tỉnh Quảng Ngãi","path_with_type":"Huyện Minh Long, Tỉnh Quảng Ngãi","code":"531","parent_code":"51"},"532":{"name":"Nghĩa Hành","type":"huyen","slug":"nghia-hanh","name_with_type":"Huyện Nghĩa Hành","path":"Huyện Nghĩa Hành, Tỉnh Quảng Ngãi","path_with_type":"Huyện Nghĩa Hành, Tỉnh Quảng Ngãi","code":"532","parent_code":"51"},"533":{"name":"Mộ Đức","type":"huyen","slug":"mo-duc","name_with_type":"Huyện Mộ Đức","path":"Huyện Mộ Đức, Tỉnh Quảng Ngãi","path_with_type":"Huyện Mộ Đức, Tỉnh Quảng Ngãi","code":"533","parent_code":"51"},"534":{"name":"Thị xã Đức Phổ","type":"thi-xa","slug":"thi-xa-duc-pho","name_with_type":"Thị xã Đức Phổ","path":"Thị xã Đức Phổ, Tỉnh Quảng Ngãi","path_with_type":"Thị xã Đức Phổ, Tỉnh Quảng Ngãi","code":"534","parent_code":"51"},"535":{"name":"Ba Tơ","type":"huyen","slug":"ba-to","name_with_type":"Huyện Ba Tơ","path":"Huyện Ba Tơ, Tỉnh Quảng Ngãi","path_with_type":"Huyện Ba Tơ, Tỉnh Quảng Ngãi","code":"535","parent_code":"51"},"536":{"name":"Lý Sơn","type":"huyen","slug":"ly-son","name_with_type":"Huyện Lý Sơn","path":"Huyện Lý Sơn, Tỉnh Quảng Ngãi","path_with_type":"Huyện Lý Sơn, Tỉnh Quảng Ngãi","code":"536","parent_code":"51"},"540":{"name":"Thành phố Quy Nhơn","type":"thanh-pho","slug":"thanh-pho-quy-nhon","name_with_type":"Thành phố Quy Nhơn","path":"Thành phố Quy Nhơn, Tỉnh Bình Định","path_with_type":"Thành phố Quy Nhơn, Tỉnh Bình Định","code":"540","parent_code":"52"},"542":{"name":"An Lão","type":"huyen","slug":"an-lao","name_with_type":"Huyện An Lão","path":"Huyện An Lão, Tỉnh Bình Định","path_with_type":"Huyện An Lão, Tỉnh Bình Định","code":"542","parent_code":"52"},"543":{"name":"Thị xã Hoài Nhơn","type":"thi-xa","slug":"thi-xa-hoai-nhon","name_with_type":"Thị xã Hoài Nhơn","path":"Thị xã Hoài Nhơn, Tỉnh Bình Định","path_with_type":"Thị xã Hoài Nhơn, Tỉnh Bình Định","code":"543","parent_code":"52"},"544":{"name":"Hoài Ân","type":"huyen","slug":"hoai-an","name_with_type":"Huyện Hoài Ân","path":"Huyện Hoài Ân, Tỉnh Bình Định","path_with_type":"Huyện Hoài Ân, Tỉnh Bình Định","code":"544","parent_code":"52"},"545":{"name":"Phù Mỹ","type":"huyen","slug":"phu-my","name_with_type":"Huyện Phù Mỹ","path":"Huyện Phù Mỹ, Tỉnh Bình Định","path_with_type":"Huyện Phù Mỹ, Tỉnh Bình Định","code":"545","parent_code":"52"},"546":{"name":"Vĩnh Thạnh","type":"huyen","slug":"vinh-thanh","name_with_type":"Huyện Vĩnh Thạnh","path":"Huyện Vĩnh Thạnh, Tỉnh Bình Định","path_with_type":"Huyện Vĩnh Thạnh, Tỉnh Bình Định","code":"546","parent_code":"52"},"547":{"name":"Tây Sơn","type":"huyen","slug":"tay-son","name_with_type":"Huyện Tây Sơn","path":"Huyện Tây Sơn, Tỉnh Bình Định","path_with_type":"Huyện Tây Sơn, Tỉnh Bình Định","code":"547","parent_code":"52"},"548":{"name":"Phù Cát","type":"huyen","slug":"phu-cat","name_with_type":"Huyện Phù Cát","path":"Huyện Phù Cát, Tỉnh Bình Định","path_with_type":"Huyện Phù Cát, Tỉnh Bình Định","code":"548","parent_code":"52"},"549":{"name":"Thị xã An Nhơn","type":"thi-xa","slug":"thi-xa-an-nhon","name_with_type":"Thị xã An Nhơn","path":"Thị xã An Nhơn, Tỉnh Bình Định","path_with_type":"Thị xã An Nhơn, Tỉnh Bình Định","code":"549","parent_code":"52"},"550":{"name":"Tuy Phước","type":"huyen","slug":"tuy-phuoc","name_with_type":"Huyện Tuy Phước","path":"Huyện Tuy Phước, Tỉnh Bình Định","path_with_type":"Huyện Tuy Phước, Tỉnh Bình Định","code":"550","parent_code":"52"},"551":{"name":"Vân Canh","type":"huyen","slug":"van-canh","name_with_type":"Huyện Vân Canh","path":"Huyện Vân Canh, Tỉnh Bình Định","path_with_type":"Huyện Vân Canh, Tỉnh Bình Định","code":"551","parent_code":"52"},"555":{"name":"Thành phố Tuy Hoà","type":"thanh-pho","slug":"thanh-pho-tuy-hoa","name_with_type":"Thành phố Tuy Hoà","path":"Thành phố Tuy Hoà, Tỉnh Phú Yên","path_with_type":"Thành phố Tuy Hoà, Tỉnh Phú Yên","code":"555","parent_code":"54"},"557":{"name":"Thị xã Sông Cầu","type":"thi-xa","slug":"thi-xa-song-cau","name_with_type":"Thị xã Sông Cầu","path":"Thị xã Sông Cầu, Tỉnh Phú Yên","path_with_type":"Thị xã Sông Cầu, Tỉnh Phú Yên","code":"557","parent_code":"54"},"558":{"name":"Đồng Xuân","type":"huyen","slug":"dong-xuan","name_with_type":"Huyện Đồng Xuân","path":"Huyện Đồng Xuân, Tỉnh Phú Yên","path_with_type":"Huyện Đồng Xuân, Tỉnh Phú Yên","code":"558","parent_code":"54"},"559":{"name":"Tuy An","type":"huyen","slug":"tuy-an","name_with_type":"Huyện Tuy An","path":"Huyện Tuy An, Tỉnh Phú Yên","path_with_type":"Huyện Tuy An, Tỉnh Phú Yên","code":"559","parent_code":"54"},"560":{"name":"Sơn Hòa","type":"huyen","slug":"son-hoa","name_with_type":"Huyện Sơn Hòa","path":"Huyện Sơn Hòa, Tỉnh Phú Yên","path_with_type":"Huyện Sơn Hòa, Tỉnh Phú Yên","code":"560","parent_code":"54"},"561":{"name":"Sông Hinh","type":"huyen","slug":"song-hinh","name_with_type":"Huyện Sông Hinh","path":"Huyện Sông Hinh, Tỉnh Phú Yên","path_with_type":"Huyện Sông Hinh, Tỉnh Phú Yên","code":"561","parent_code":"54"},"562":{"name":"Tây Hoà","type":"huyen","slug":"tay-hoa","name_with_type":"Huyện Tây Hoà","path":"Huyện Tây Hoà, Tỉnh Phú Yên","path_with_type":"Huyện Tây Hoà, Tỉnh Phú Yên","code":"562","parent_code":"54"},"563":{"name":"Phú Hoà","type":"huyen","slug":"phu-hoa","name_with_type":"Huyện Phú Hoà","path":"Huyện Phú Hoà, Tỉnh Phú Yên","path_with_type":"Huyện Phú Hoà, Tỉnh Phú Yên","code":"563","parent_code":"54"},"564":{"name":"Thị xã Đông Hòa","type":"thi-xa","slug":"thi-xa-dong-hoa","name_with_type":"Thị xã Đông Hòa","path":"Thị xã Đông Hòa, Tỉnh Phú Yên","path_with_type":"Thị xã Đông Hòa, Tỉnh Phú Yên","code":"564","parent_code":"54"},"568":{"name":"Thành phố Nha Trang","type":"thanh-pho","slug":"thanh-pho-nha-trang","name_with_type":"Thành phố Nha Trang","path":"Thành phố Nha Trang, Tỉnh Khánh Hòa","path_with_type":"Thành phố Nha Trang, Tỉnh Khánh Hòa","code":"568","parent_code":"56"},"569":{"name":"Thành phố Cam Ranh","type":"thanh-pho","slug":"thanh-pho-cam-ranh","name_with_type":"Thành phố Cam Ranh","path":"Thành phố Cam Ranh, Tỉnh Khánh Hòa","path_with_type":"Thành phố Cam Ranh, Tỉnh Khánh Hòa","code":"569","parent_code":"56"},"570":{"name":"Cam Lâm","type":"huyen","slug":"cam-lam","name_with_type":"Huyện Cam Lâm","path":"Huyện Cam Lâm, Tỉnh Khánh Hòa","path_with_type":"Huyện Cam Lâm, Tỉnh Khánh Hòa","code":"570","parent_code":"56"},"571":{"name":"Vạn Ninh","type":"huyen","slug":"van-ninh","name_with_type":"Huyện Vạn Ninh","path":"Huyện Vạn Ninh, Tỉnh Khánh Hòa","path_with_type":"Huyện Vạn Ninh, Tỉnh Khánh Hòa","code":"571","parent_code":"56"},"572":{"name":"Thị xã Ninh Hòa","type":"thi-xa","slug":"thi-xa-ninh-hoa","name_with_type":"Thị xã Ninh Hòa","path":"Thị xã Ninh Hòa, Tỉnh Khánh Hòa","path_with_type":"Thị xã Ninh Hòa, Tỉnh Khánh Hòa","code":"572","parent_code":"56"},"573":{"name":"Khánh Vĩnh","type":"huyen","slug":"khanh-vinh","name_with_type":"Huyện Khánh Vĩnh","path":"Huyện Khánh Vĩnh, Tỉnh Khánh Hòa","path_with_type":"Huyện Khánh Vĩnh, Tỉnh Khánh Hòa","code":"573","parent_code":"56"},"574":{"name":"Diên Khánh","type":"huyen","slug":"dien-khanh","name_with_type":"Huyện Diên Khánh","path":"Huyện Diên Khánh, Tỉnh Khánh Hòa","path_with_type":"Huyện Diên Khánh, Tỉnh Khánh Hòa","code":"574","parent_code":"56"},"575":{"name":"Khánh Sơn","type":"huyen","slug":"khanh-son","name_with_type":"Huyện Khánh Sơn","path":"Huyện Khánh Sơn, Tỉnh Khánh Hòa","path_with_type":"Huyện Khánh Sơn, Tỉnh Khánh Hòa","code":"575","parent_code":"56"},"576":{"name":"Trường Sa","type":"huyen","slug":"truong-sa","name_with_type":"Huyện Trường Sa","path":"Huyện Trường Sa, Tỉnh Khánh Hòa","path_with_type":"Huyện Trường Sa, Tỉnh Khánh Hòa","code":"576","parent_code":"56"},"582":{"name":"Thành phố Phan Rang-Tháp Chàm","type":"thanh-pho","slug":"thanh-pho-phan-rang-thap-cham","name_with_type":"Thành phố Phan Rang-Tháp Chàm","path":"Thành phố Phan Rang-Tháp Chàm, Tỉnh Ninh Thuận","path_with_type":"Thành phố Phan Rang-Tháp Chàm, Tỉnh Ninh Thuận","code":"582","parent_code":"58"},"584":{"name":"Bác Ái","type":"huyen","slug":"bac-ai","name_with_type":"Huyện Bác Ái","path":"Huyện Bác Ái, Tỉnh Ninh Thuận","path_with_type":"Huyện Bác Ái, Tỉnh Ninh Thuận","code":"584","parent_code":"58"},"585":{"name":"Ninh Sơn","type":"huyen","slug":"ninh-son","name_with_type":"Huyện Ninh Sơn","path":"Huyện Ninh Sơn, Tỉnh Ninh Thuận","path_with_type":"Huyện Ninh Sơn, Tỉnh Ninh Thuận","code":"585","parent_code":"58"},"586":{"name":"Ninh Hải","type":"huyen","slug":"ninh-hai","name_with_type":"Huyện Ninh Hải","path":"Huyện Ninh Hải, Tỉnh Ninh Thuận","path_with_type":"Huyện Ninh Hải, Tỉnh Ninh Thuận","code":"586","parent_code":"58"},"587":{"name":"Ninh Phước","type":"huyen","slug":"ninh-phuoc","name_with_type":"Huyện Ninh Phước","path":"Huyện Ninh Phước, Tỉnh Ninh Thuận","path_with_type":"Huyện Ninh Phước, Tỉnh Ninh Thuận","code":"587","parent_code":"58"},"588":{"name":"Thuận Bắc","type":"huyen","slug":"thuan-bac","name_with_type":"Huyện Thuận Bắc","path":"Huyện Thuận Bắc, Tỉnh Ninh Thuận","path_with_type":"Huyện Thuận Bắc, Tỉnh Ninh Thuận","code":"588","parent_code":"58"},"589":{"name":"Thuận Nam","type":"huyen","slug":"thuan-nam","name_with_type":"Huyện Thuận Nam","path":"Huyện Thuận Nam, Tỉnh Ninh Thuận","path_with_type":"Huyện Thuận Nam, Tỉnh Ninh Thuận","code":"589","parent_code":"58"},"593":{"name":"Thành phố Phan Thiết","type":"thanh-pho","slug":"thanh-pho-phan-thiet","name_with_type":"Thành phố Phan Thiết","path":"Thành phố Phan Thiết, Tỉnh Bình Thuận","path_with_type":"Thành phố Phan Thiết, Tỉnh Bình Thuận","code":"593","parent_code":"60"},"594":{"name":"Thị xã La Gi","type":"thi-xa","slug":"thi-xa-la-gi","name_with_type":"Thị xã La Gi","path":"Thị xã La Gi, Tỉnh Bình Thuận","path_with_type":"Thị xã La Gi, Tỉnh Bình Thuận","code":"594","parent_code":"60"},"595":{"name":"Tuy Phong","type":"huyen","slug":"tuy-phong","name_with_type":"Huyện Tuy Phong","path":"Huyện Tuy Phong, Tỉnh Bình Thuận","path_with_type":"Huyện Tuy Phong, Tỉnh Bình Thuận","code":"595","parent_code":"60"},"596":{"name":"Bắc Bình","type":"huyen","slug":"bac-binh","name_with_type":"Huyện Bắc Bình","path":"Huyện Bắc Bình, Tỉnh Bình Thuận","path_with_type":"Huyện Bắc Bình, Tỉnh Bình Thuận","code":"596","parent_code":"60"},"597":{"name":"Hàm Thuận Bắc","type":"huyen","slug":"ham-thuan-bac","name_with_type":"Huyện Hàm Thuận Bắc","path":"Huyện Hàm Thuận Bắc, Tỉnh Bình Thuận","path_with_type":"Huyện Hàm Thuận Bắc, Tỉnh Bình Thuận","code":"597","parent_code":"60"},"598":{"name":"Hàm Thuận Nam","type":"huyen","slug":"ham-thuan-nam","name_with_type":"Huyện Hàm Thuận Nam","path":"Huyện Hàm Thuận Nam, Tỉnh Bình Thuận","path_with_type":"Huyện Hàm Thuận Nam, Tỉnh Bình Thuận","code":"598","parent_code":"60"},"599":{"name":"Tánh Linh","type":"huyen","slug":"tanh-linh","name_with_type":"Huyện Tánh Linh","path":"Huyện Tánh Linh, Tỉnh Bình Thuận","path_with_type":"Huyện Tánh Linh, Tỉnh Bình Thuận","code":"599","parent_code":"60"},"600":{"name":"Đức Linh","type":"huyen","slug":"duc-linh","name_with_type":"Huyện Đức Linh","path":"Huyện Đức Linh, Tỉnh Bình Thuận","path_with_type":"Huyện Đức Linh, Tỉnh Bình Thuận","code":"600","parent_code":"60"},"601":{"name":"Hàm Tân","type":"huyen","slug":"ham-tan","name_with_type":"Huyện Hàm Tân","path":"Huyện Hàm Tân, Tỉnh Bình Thuận","path_with_type":"Huyện Hàm Tân, Tỉnh Bình Thuận","code":"601","parent_code":"60"},"602":{"name":"Phú Quí","type":"huyen","slug":"phu-qui","name_with_type":"Huyện Phú Quí","path":"Huyện Phú Quí, Tỉnh Bình Thuận","path_with_type":"Huyện Phú Quí, Tỉnh Bình Thuận","code":"602","parent_code":"60"},"608":{"name":"Thành phố Kon Tum","type":"thanh-pho","slug":"thanh-pho-kon-tum","name_with_type":"Thành phố Kon Tum","path":"Thành phố Kon Tum, Tỉnh Kon Tum","path_with_type":"Thành phố Kon Tum, Tỉnh Kon Tum","code":"608","parent_code":"62"},"610":{"name":"Đắk Glei","type":"huyen","slug":"dak-glei","name_with_type":"Huyện Đắk Glei","path":"Huyện Đắk Glei, Tỉnh Kon Tum","path_with_type":"Huyện Đắk Glei, Tỉnh Kon Tum","code":"610","parent_code":"62"},"611":{"name":"Ngọc Hồi","type":"huyen","slug":"ngoc-hoi","name_with_type":"Huyện Ngọc Hồi","path":"Huyện Ngọc Hồi, Tỉnh Kon Tum","path_with_type":"Huyện Ngọc Hồi, Tỉnh Kon Tum","code":"611","parent_code":"62"},"612":{"name":"Đắk Tô","type":"huyen","slug":"dak-to","name_with_type":"Huyện Đắk Tô","path":"Huyện Đắk Tô, Tỉnh Kon Tum","path_with_type":"Huyện Đắk Tô, Tỉnh Kon Tum","code":"612","parent_code":"62"},"613":{"name":"Kon Plông","type":"huyen","slug":"kon-plong","name_with_type":"Huyện Kon Plông","path":"Huyện Kon Plông, Tỉnh Kon Tum","path_with_type":"Huyện Kon Plông, Tỉnh Kon Tum","code":"613","parent_code":"62"},"614":{"name":"Kon Rẫy","type":"huyen","slug":"kon-ray","name_with_type":"Huyện Kon Rẫy","path":"Huyện Kon Rẫy, Tỉnh Kon Tum","path_with_type":"Huyện Kon Rẫy, Tỉnh Kon Tum","code":"614","parent_code":"62"},"615":{"name":"Đắk Hà","type":"huyen","slug":"dak-ha","name_with_type":"Huyện Đắk Hà","path":"Huyện Đắk Hà, Tỉnh Kon Tum","path_with_type":"Huyện Đắk Hà, Tỉnh Kon Tum","code":"615","parent_code":"62"},"616":{"name":"Sa Thầy","type":"huyen","slug":"sa-thay","name_with_type":"Huyện Sa Thầy","path":"Huyện Sa Thầy, Tỉnh Kon Tum","path_with_type":"Huyện Sa Thầy, Tỉnh Kon Tum","code":"616","parent_code":"62"},"617":{"name":"Tu Mơ Rông","type":"huyen","slug":"tu-mo-rong","name_with_type":"Huyện Tu Mơ Rông","path":"Huyện Tu Mơ Rông, Tỉnh Kon Tum","path_with_type":"Huyện Tu Mơ Rông, Tỉnh Kon Tum","code":"617","parent_code":"62"},"618":{"name":"Ia H\' Drai","type":"huyen","slug":"ia-h\'-drai","name_with_type":"Huyện Ia H\' Drai","path":"Huyện Ia H\' Drai, Tỉnh Kon Tum","path_with_type":"Huyện Ia H\' Drai, Tỉnh Kon Tum","code":"618","parent_code":"62"},"622":{"name":"Thành phố Pleiku","type":"thanh-pho","slug":"thanh-pho-pleiku","name_with_type":"Thành phố Pleiku","path":"Thành phố Pleiku, Tỉnh Gia Lai","path_with_type":"Thành phố Pleiku, Tỉnh Gia Lai","code":"622","parent_code":"64"},"623":{"name":"Thị xã An Khê","type":"thi-xa","slug":"thi-xa-an-khe","name_with_type":"Thị xã An Khê","path":"Thị xã An Khê, Tỉnh Gia Lai","path_with_type":"Thị xã An Khê, Tỉnh Gia Lai","code":"623","parent_code":"64"},"624":{"name":"Thị xã Ayun Pa","type":"thi-xa","slug":"thi-xa-ayun-pa","name_with_type":"Thị xã Ayun Pa","path":"Thị xã Ayun Pa, Tỉnh Gia Lai","path_with_type":"Thị xã Ayun Pa, Tỉnh Gia Lai","code":"624","parent_code":"64"},"625":{"name":"KBang","type":"huyen","slug":"kbang","name_with_type":"Huyện KBang","path":"Huyện KBang, Tỉnh Gia Lai","path_with_type":"Huyện KBang, Tỉnh Gia Lai","code":"625","parent_code":"64"},"626":{"name":"Đăk Đoa","type":"huyen","slug":"dak-doa","name_with_type":"Huyện Đăk Đoa","path":"Huyện Đăk Đoa, Tỉnh Gia Lai","path_with_type":"Huyện Đăk Đoa, Tỉnh Gia Lai","code":"626","parent_code":"64"},"627":{"name":"Chư Păh","type":"huyen","slug":"chu-pah","name_with_type":"Huyện Chư Păh","path":"Huyện Chư Păh, Tỉnh Gia Lai","path_with_type":"Huyện Chư Păh, Tỉnh Gia Lai","code":"627","parent_code":"64"},"628":{"name":"Ia Grai","type":"huyen","slug":"ia-grai","name_with_type":"Huyện Ia Grai","path":"Huyện Ia Grai, Tỉnh Gia Lai","path_with_type":"Huyện Ia Grai, Tỉnh Gia Lai","code":"628","parent_code":"64"},"629":{"name":"Mang Yang","type":"huyen","slug":"mang-yang","name_with_type":"Huyện Mang Yang","path":"Huyện Mang Yang, Tỉnh Gia Lai","path_with_type":"Huyện Mang Yang, Tỉnh Gia Lai","code":"629","parent_code":"64"},"630":{"name":"Kông Chro","type":"huyen","slug":"kong-chro","name_with_type":"Huyện Kông Chro","path":"Huyện Kông Chro, Tỉnh Gia Lai","path_with_type":"Huyện Kông Chro, Tỉnh Gia Lai","code":"630","parent_code":"64"},"631":{"name":"Đức Cơ","type":"huyen","slug":"duc-co","name_with_type":"Huyện Đức Cơ","path":"Huyện Đức Cơ, Tỉnh Gia Lai","path_with_type":"Huyện Đức Cơ, Tỉnh Gia Lai","code":"631","parent_code":"64"},"632":{"name":"Chư Prông","type":"huyen","slug":"chu-prong","name_with_type":"Huyện Chư Prông","path":"Huyện Chư Prông, Tỉnh Gia Lai","path_with_type":"Huyện Chư Prông, Tỉnh Gia Lai","code":"632","parent_code":"64"},"633":{"name":"Chư Sê","type":"huyen","slug":"chu-se","name_with_type":"Huyện Chư Sê","path":"Huyện Chư Sê, Tỉnh Gia Lai","path_with_type":"Huyện Chư Sê, Tỉnh Gia Lai","code":"633","parent_code":"64"},"634":{"name":"Đăk Pơ","type":"huyen","slug":"dak-po","name_with_type":"Huyện Đăk Pơ","path":"Huyện Đăk Pơ, Tỉnh Gia Lai","path_with_type":"Huyện Đăk Pơ, Tỉnh Gia Lai","code":"634","parent_code":"64"},"635":{"name":"Ia Pa","type":"huyen","slug":"ia-pa","name_with_type":"Huyện Ia Pa","path":"Huyện Ia Pa, Tỉnh Gia Lai","path_with_type":"Huyện Ia Pa, Tỉnh Gia Lai","code":"635","parent_code":"64"},"637":{"name":"Krông Pa","type":"huyen","slug":"krong-pa","name_with_type":"Huyện Krông Pa","path":"Huyện Krông Pa, Tỉnh Gia Lai","path_with_type":"Huyện Krông Pa, Tỉnh Gia Lai","code":"637","parent_code":"64"},"638":{"name":"Phú Thiện","type":"huyen","slug":"phu-thien","name_with_type":"Huyện Phú Thiện","path":"Huyện Phú Thiện, Tỉnh Gia Lai","path_with_type":"Huyện Phú Thiện, Tỉnh Gia Lai","code":"638","parent_code":"64"},"639":{"name":"Chư Pưh","type":"huyen","slug":"chu-puh","name_with_type":"Huyện Chư Pưh","path":"Huyện Chư Pưh, Tỉnh Gia Lai","path_with_type":"Huyện Chư Pưh, Tỉnh Gia Lai","code":"639","parent_code":"64"},"643":{"name":"Thành phố Buôn Ma Thuột","type":"thanh-pho","slug":"thanh-pho-buon-ma-thuot","name_with_type":"Thành phố Buôn Ma Thuột","path":"Thành phố Buôn Ma Thuột, Tỉnh Đắk Lắk","path_with_type":"Thành phố Buôn Ma Thuột, Tỉnh Đắk Lắk","code":"643","parent_code":"66"},"644":{"name":"Thị Xã Buôn Hồ","type":"thi-xa","slug":"thi-xa-buon-ho","name_with_type":"Thị Xã Buôn Hồ","path":"Thị Xã Buôn Hồ, Tỉnh Đắk Lắk","path_with_type":"Thị Xã Buôn Hồ, Tỉnh Đắk Lắk","code":"644","parent_code":"66"},"645":{"name":"Ea H\'leo","type":"huyen","slug":"ea-h\'leo","name_with_type":"Huyện Ea H\'leo","path":"Huyện Ea H\'leo, Tỉnh Đắk Lắk","path_with_type":"Huyện Ea H\'leo, Tỉnh Đắk Lắk","code":"645","parent_code":"66"},"646":{"name":"Ea Súp","type":"huyen","slug":"ea-sup","name_with_type":"Huyện Ea Súp","path":"Huyện Ea Súp, Tỉnh Đắk Lắk","path_with_type":"Huyện Ea Súp, Tỉnh Đắk Lắk","code":"646","parent_code":"66"},"647":{"name":"Buôn Đôn","type":"huyen","slug":"buon-don","name_with_type":"Huyện Buôn Đôn","path":"Huyện Buôn Đôn, Tỉnh Đắk Lắk","path_with_type":"Huyện Buôn Đôn, Tỉnh Đắk Lắk","code":"647","parent_code":"66"},"648":{"name":"Cư M\'gar","type":"huyen","slug":"cu-m\'gar","name_with_type":"Huyện Cư M\'gar","path":"Huyện Cư M\'gar, Tỉnh Đắk Lắk","path_with_type":"Huyện Cư M\'gar, Tỉnh Đắk Lắk","code":"648","parent_code":"66"},"649":{"name":"Krông Búk","type":"huyen","slug":"krong-buk","name_with_type":"Huyện Krông Búk","path":"Huyện Krông Búk, Tỉnh Đắk Lắk","path_with_type":"Huyện Krông Búk, Tỉnh Đắk Lắk","code":"649","parent_code":"66"},"650":{"name":"Krông Năng","type":"huyen","slug":"krong-nang","name_with_type":"Huyện Krông Năng","path":"Huyện Krông Năng, Tỉnh Đắk Lắk","path_with_type":"Huyện Krông Năng, Tỉnh Đắk Lắk","code":"650","parent_code":"66"},"651":{"name":"Ea Kar","type":"huyen","slug":"ea-kar","name_with_type":"Huyện Ea Kar","path":"Huyện Ea Kar, Tỉnh Đắk Lắk","path_with_type":"Huyện Ea Kar, Tỉnh Đắk Lắk","code":"651","parent_code":"66"},"652":{"name":"M\'Đrắk","type":"huyen","slug":"m\'drak","name_with_type":"Huyện M\'Đrắk","path":"Huyện M\'Đrắk, Tỉnh Đắk Lắk","path_with_type":"Huyện M\'Đrắk, Tỉnh Đắk Lắk","code":"652","parent_code":"66"},"653":{"name":"Krông Bông","type":"huyen","slug":"krong-bong","name_with_type":"Huyện Krông Bông","path":"Huyện Krông Bông, Tỉnh Đắk Lắk","path_with_type":"Huyện Krông Bông, Tỉnh Đắk Lắk","code":"653","parent_code":"66"},"654":{"name":"Krông Pắc","type":"huyen","slug":"krong-pac","name_with_type":"Huyện Krông Pắc","path":"Huyện Krông Pắc, Tỉnh Đắk Lắk","path_with_type":"Huyện Krông Pắc, Tỉnh Đắk Lắk","code":"654","parent_code":"66"},"655":{"name":"Krông A Na","type":"huyen","slug":"krong-a-na","name_with_type":"Huyện Krông A Na","path":"Huyện Krông A Na, Tỉnh Đắk Lắk","path_with_type":"Huyện Krông A Na, Tỉnh Đắk Lắk","code":"655","parent_code":"66"},"656":{"name":"Lắk","type":"huyen","slug":"lak","name_with_type":"Huyện Lắk","path":"Huyện Lắk, Tỉnh Đắk Lắk","path_with_type":"Huyện Lắk, Tỉnh Đắk Lắk","code":"656","parent_code":"66"},"657":{"name":"Cư Kuin","type":"huyen","slug":"cu-kuin","name_with_type":"Huyện Cư Kuin","path":"Huyện Cư Kuin, Tỉnh Đắk Lắk","path_with_type":"Huyện Cư Kuin, Tỉnh Đắk Lắk","code":"657","parent_code":"66"},"660":{"name":"Thành phố Gia Nghĩa","type":"thanh-pho","slug":"thanh-pho-gia-nghia","name_with_type":"Thành phố Gia Nghĩa","path":"Thành phố Gia Nghĩa, Tỉnh Đắk Nông","path_with_type":"Thành phố Gia Nghĩa, Tỉnh Đắk Nông","code":"660","parent_code":"67"},"661":{"name":"Đăk Glong","type":"huyen","slug":"dak-glong","name_with_type":"Huyện Đăk Glong","path":"Huyện Đăk Glong, Tỉnh Đắk Nông","path_with_type":"Huyện Đăk Glong, Tỉnh Đắk Nông","code":"661","parent_code":"67"},"662":{"name":"Cư Jút","type":"huyen","slug":"cu-jut","name_with_type":"Huyện Cư Jút","path":"Huyện Cư Jút, Tỉnh Đắk Nông","path_with_type":"Huyện Cư Jút, Tỉnh Đắk Nông","code":"662","parent_code":"67"},"663":{"name":"Đắk Mil","type":"huyen","slug":"dak-mil","name_with_type":"Huyện Đắk Mil","path":"Huyện Đắk Mil, Tỉnh Đắk Nông","path_with_type":"Huyện Đắk Mil, Tỉnh Đắk Nông","code":"663","parent_code":"67"},"664":{"name":"Krông Nô","type":"huyen","slug":"krong-no","name_with_type":"Huyện Krông Nô","path":"Huyện Krông Nô, Tỉnh Đắk Nông","path_with_type":"Huyện Krông Nô, Tỉnh Đắk Nông","code":"664","parent_code":"67"},"665":{"name":"Đắk Song","type":"huyen","slug":"dak-song","name_with_type":"Huyện Đắk Song","path":"Huyện Đắk Song, Tỉnh Đắk Nông","path_with_type":"Huyện Đắk Song, Tỉnh Đắk Nông","code":"665","parent_code":"67"},"666":{"name":"Đắk R\'Lấp","type":"huyen","slug":"dak-r\'lap","name_with_type":"Huyện Đắk R\'Lấp","path":"Huyện Đắk R\'Lấp, Tỉnh Đắk Nông","path_with_type":"Huyện Đắk R\'Lấp, Tỉnh Đắk Nông","code":"666","parent_code":"67"},"667":{"name":"Tuy Đức","type":"huyen","slug":"tuy-duc","name_with_type":"Huyện Tuy Đức","path":"Huyện Tuy Đức, Tỉnh Đắk Nông","path_with_type":"Huyện Tuy Đức, Tỉnh Đắk Nông","code":"667","parent_code":"67"},"672":{"name":"Thành phố Đà Lạt","type":"thanh-pho","slug":"thanh-pho-da-lat","name_with_type":"Thành phố Đà Lạt","path":"Thành phố Đà Lạt, Tỉnh Lâm Đồng","path_with_type":"Thành phố Đà Lạt, Tỉnh Lâm Đồng","code":"672","parent_code":"68"},"673":{"name":"Thành phố Bảo Lộc","type":"thanh-pho","slug":"thanh-pho-bao-loc","name_with_type":"Thành phố Bảo Lộc","path":"Thành phố Bảo Lộc, Tỉnh Lâm Đồng","path_with_type":"Thành phố Bảo Lộc, Tỉnh Lâm Đồng","code":"673","parent_code":"68"},"674":{"name":"Đam Rông","type":"huyen","slug":"dam-rong","name_with_type":"Huyện Đam Rông","path":"Huyện Đam Rông, Tỉnh Lâm Đồng","path_with_type":"Huyện Đam Rông, Tỉnh Lâm Đồng","code":"674","parent_code":"68"},"675":{"name":"Lạc Dương","type":"huyen","slug":"lac-duong","name_with_type":"Huyện Lạc Dương","path":"Huyện Lạc Dương, Tỉnh Lâm Đồng","path_with_type":"Huyện Lạc Dương, Tỉnh Lâm Đồng","code":"675","parent_code":"68"},"676":{"name":"Lâm Hà","type":"huyen","slug":"lam-ha","name_with_type":"Huyện Lâm Hà","path":"Huyện Lâm Hà, Tỉnh Lâm Đồng","path_with_type":"Huyện Lâm Hà, Tỉnh Lâm Đồng","code":"676","parent_code":"68"},"677":{"name":"Đơn Dương","type":"huyen","slug":"don-duong","name_with_type":"Huyện Đơn Dương","path":"Huyện Đơn Dương, Tỉnh Lâm Đồng","path_with_type":"Huyện Đơn Dương, Tỉnh Lâm Đồng","code":"677","parent_code":"68"},"678":{"name":"Đức Trọng","type":"huyen","slug":"duc-trong","name_with_type":"Huyện Đức Trọng","path":"Huyện Đức Trọng, Tỉnh Lâm Đồng","path_with_type":"Huyện Đức Trọng, Tỉnh Lâm Đồng","code":"678","parent_code":"68"},"679":{"name":"Di Linh","type":"huyen","slug":"di-linh","name_with_type":"Huyện Di Linh","path":"Huyện Di Linh, Tỉnh Lâm Đồng","path_with_type":"Huyện Di Linh, Tỉnh Lâm Đồng","code":"679","parent_code":"68"},"680":{"name":"Bảo Lâm","type":"huyen","slug":"bao-lam","name_with_type":"Huyện Bảo Lâm","path":"Huyện Bảo Lâm, Tỉnh Lâm Đồng","path_with_type":"Huyện Bảo Lâm, Tỉnh Lâm Đồng","code":"680","parent_code":"68"},"682":{"name":"Đạ Huoai","type":"huyen","slug":"da-huoai","name_with_type":"Huyện Đạ Huoai","path":"Huyện Đạ Huoai, Tỉnh Lâm Đồng","path_with_type":"Huyện Đạ Huoai, Tỉnh Lâm Đồng","code":"682","parent_code":"68"},"688":{"name":"Thị xã Phước Long","type":"thi-xa","slug":"thi-xa-phuoc-long","name_with_type":"Thị xã Phước Long","path":"Thị xã Phước Long, Tỉnh Bình Phước","path_with_type":"Thị xã Phước Long, Tỉnh Bình Phước","code":"688","parent_code":"70"},"689":{"name":"Thành phố Đồng Xoài","type":"thanh-pho","slug":"thanh-pho-dong-xoai","name_with_type":"Thành phố Đồng Xoài","path":"Thành phố Đồng Xoài, Tỉnh Bình Phước","path_with_type":"Thành phố Đồng Xoài, Tỉnh Bình Phước","code":"689","parent_code":"70"},"690":{"name":"Thị xã Bình Long","type":"thi-xa","slug":"thi-xa-binh-long","name_with_type":"Thị xã Bình Long","path":"Thị xã Bình Long, Tỉnh Bình Phước","path_with_type":"Thị xã Bình Long, Tỉnh Bình Phước","code":"690","parent_code":"70"},"691":{"name":"Bù Gia Mập","type":"huyen","slug":"bu-gia-map","name_with_type":"Huyện Bù Gia Mập","path":"Huyện Bù Gia Mập, Tỉnh Bình Phước","path_with_type":"Huyện Bù Gia Mập, Tỉnh Bình Phước","code":"691","parent_code":"70"},"692":{"name":"Lộc Ninh","type":"huyen","slug":"loc-ninh","name_with_type":"Huyện Lộc Ninh","path":"Huyện Lộc Ninh, Tỉnh Bình Phước","path_with_type":"Huyện Lộc Ninh, Tỉnh Bình Phước","code":"692","parent_code":"70"},"693":{"name":"Bù Đốp","type":"huyen","slug":"bu-dop","name_with_type":"Huyện Bù Đốp","path":"Huyện Bù Đốp, Tỉnh Bình Phước","path_with_type":"Huyện Bù Đốp, Tỉnh Bình Phước","code":"693","parent_code":"70"},"694":{"name":"Hớn Quản","type":"huyen","slug":"hon-quan","name_with_type":"Huyện Hớn Quản","path":"Huyện Hớn Quản, Tỉnh Bình Phước","path_with_type":"Huyện Hớn Quản, Tỉnh Bình Phước","code":"694","parent_code":"70"},"695":{"name":"Đồng Phú","type":"huyen","slug":"dong-phu","name_with_type":"Huyện Đồng Phú","path":"Huyện Đồng Phú, Tỉnh Bình Phước","path_with_type":"Huyện Đồng Phú, Tỉnh Bình Phước","code":"695","parent_code":"70"},"696":{"name":"Bù Đăng","type":"huyen","slug":"bu-dang","name_with_type":"Huyện Bù Đăng","path":"Huyện Bù Đăng, Tỉnh Bình Phước","path_with_type":"Huyện Bù Đăng, Tỉnh Bình Phước","code":"696","parent_code":"70"},"697":{"name":"Thị xã Chơn Thành","type":"thi-xa","slug":"thi-xa-chon-thanh","name_with_type":"Thị xã Chơn Thành","path":"Thị xã Chơn Thành, Tỉnh Bình Phước","path_with_type":"Thị xã Chơn Thành, Tỉnh Bình Phước","code":"697","parent_code":"70"},"698":{"name":"Phú Riềng","type":"huyen","slug":"phu-rieng","name_with_type":"Huyện Phú Riềng","path":"Huyện Phú Riềng, Tỉnh Bình Phước","path_with_type":"Huyện Phú Riềng, Tỉnh Bình Phước","code":"698","parent_code":"70"},"703":{"name":"Thành phố Tây Ninh","type":"thanh-pho","slug":"thanh-pho-tay-ninh","name_with_type":"Thành phố Tây Ninh","path":"Thành phố Tây Ninh, Tỉnh Tây Ninh","path_with_type":"Thành phố Tây Ninh, Tỉnh Tây Ninh","code":"703","parent_code":"72"},"705":{"name":"Tân Biên","type":"huyen","slug":"tan-bien","name_with_type":"Huyện Tân Biên","path":"Huyện Tân Biên, Tỉnh Tây Ninh","path_with_type":"Huyện Tân Biên, Tỉnh Tây Ninh","code":"705","parent_code":"72"},"706":{"name":"Tân Châu","type":"huyen","slug":"tan-chau","name_with_type":"Huyện Tân Châu","path":"Huyện Tân Châu, Tỉnh Tây Ninh","path_with_type":"Huyện Tân Châu, Tỉnh Tây Ninh","code":"706","parent_code":"72"},"707":{"name":"Dương Minh Châu","type":"huyen","slug":"duong-minh-chau","name_with_type":"Huyện Dương Minh Châu","path":"Huyện Dương Minh Châu, Tỉnh Tây Ninh","path_with_type":"Huyện Dương Minh Châu, Tỉnh Tây Ninh","code":"707","parent_code":"72"},"708":{"name":"Châu Thành","type":"huyen","slug":"chau-thanh","name_with_type":"Huyện Châu Thành","path":"Huyện Châu Thành, Tỉnh Tây Ninh","path_with_type":"Huyện Châu Thành, Tỉnh Tây Ninh","code":"708","parent_code":"72"},"709":{"name":"Thị xã Hòa Thành","type":"thi-xa","slug":"thi-xa-hoa-thanh","name_with_type":"Thị xã Hòa Thành","path":"Thị xã Hòa Thành, Tỉnh Tây Ninh","path_with_type":"Thị xã Hòa Thành, Tỉnh Tây Ninh","code":"709","parent_code":"72"},"710":{"name":"Gò Dầu","type":"huyen","slug":"go-dau","name_with_type":"Huyện Gò Dầu","path":"Huyện Gò Dầu, Tỉnh Tây Ninh","path_with_type":"Huyện Gò Dầu, Tỉnh Tây Ninh","code":"710","parent_code":"72"},"711":{"name":"Bến Cầu","type":"huyen","slug":"ben-cau","name_with_type":"Huyện Bến Cầu","path":"Huyện Bến Cầu, Tỉnh Tây Ninh","path_with_type":"Huyện Bến Cầu, Tỉnh Tây Ninh","code":"711","parent_code":"72"},"712":{"name":"Thị xã Trảng Bàng","type":"thi-xa","slug":"thi-xa-trang-bang","name_with_type":"Thị xã Trảng Bàng","path":"Thị xã Trảng Bàng, Tỉnh Tây Ninh","path_with_type":"Thị xã Trảng Bàng, Tỉnh Tây Ninh","code":"712","parent_code":"72"},"718":{"name":"Thành phố Thủ Dầu Một","type":"thanh-pho","slug":"thanh-pho-thu-dau-mot","name_with_type":"Thành phố Thủ Dầu Một","path":"Thành phố Thủ Dầu Một, Tỉnh Bình Dương","path_with_type":"Thành phố Thủ Dầu Một, Tỉnh Bình Dương","code":"718","parent_code":"74"},"719":{"name":"Bàu Bàng","type":"huyen","slug":"bau-bang","name_with_type":"Huyện Bàu Bàng","path":"Huyện Bàu Bàng, Tỉnh Bình Dương","path_with_type":"Huyện Bàu Bàng, Tỉnh Bình Dương","code":"719","parent_code":"74"},"720":{"name":"Dầu Tiếng","type":"huyen","slug":"dau-tieng","name_with_type":"Huyện Dầu Tiếng","path":"Huyện Dầu Tiếng, Tỉnh Bình Dương","path_with_type":"Huyện Dầu Tiếng, Tỉnh Bình Dương","code":"720","parent_code":"74"},"721":{"name":"Thành phố Bến Cát","type":"thanh-pho","slug":"thanh-pho-ben-cat","name_with_type":"Thành phố Bến Cát","path":"Thành phố Bến Cát, Tỉnh Bình Dương","path_with_type":"Thành phố Bến Cát, Tỉnh Bình Dương","code":"721","parent_code":"74"},"722":{"name":"Phú Giáo","type":"huyen","slug":"phu-giao","name_with_type":"Huyện Phú Giáo","path":"Huyện Phú Giáo, Tỉnh Bình Dương","path_with_type":"Huyện Phú Giáo, Tỉnh Bình Dương","code":"722","parent_code":"74"},"723":{"name":"Thành phố Tân Uyên","type":"thanh-pho","slug":"thanh-pho-tan-uyen","name_with_type":"Thành phố Tân Uyên","path":"Thành phố Tân Uyên, Tỉnh Bình Dương","path_with_type":"Thành phố Tân Uyên, Tỉnh Bình Dương","code":"723","parent_code":"74"},"724":{"name":"Thành phố Dĩ An","type":"thanh-pho","slug":"thanh-pho-di-an","name_with_type":"Thành phố Dĩ An","path":"Thành phố Dĩ An, Tỉnh Bình Dương","path_with_type":"Thành phố Dĩ An, Tỉnh Bình Dương","code":"724","parent_code":"74"},"725":{"name":"Thành phố Thuận An","type":"thanh-pho","slug":"thanh-pho-thuan-an","name_with_type":"Thành phố Thuận An","path":"Thành phố Thuận An, Tỉnh Bình Dương","path_with_type":"Thành phố Thuận An, Tỉnh Bình Dương","code":"725","parent_code":"74"},"726":{"name":"Bắc Tân Uyên","type":"huyen","slug":"bac-tan-uyen","name_with_type":"Huyện Bắc Tân Uyên","path":"Huyện Bắc Tân Uyên, Tỉnh Bình Dương","path_with_type":"Huyện Bắc Tân Uyên, Tỉnh Bình Dương","code":"726","parent_code":"74"},"731":{"name":"Thành phố Biên Hòa","type":"thanh-pho","slug":"thanh-pho-bien-hoa","name_with_type":"Thành phố Biên Hòa","path":"Thành phố Biên Hòa, Tỉnh Đồng Nai","path_with_type":"Thành phố Biên Hòa, Tỉnh Đồng Nai","code":"731","parent_code":"75"},"732":{"name":"Thành phố Long Khánh","type":"thanh-pho","slug":"thanh-pho-long-khanh","name_with_type":"Thành phố Long Khánh","path":"Thành phố Long Khánh, Tỉnh Đồng Nai","path_with_type":"Thành phố Long Khánh, Tỉnh Đồng Nai","code":"732","parent_code":"75"},"734":{"name":"Tân Phú","type":"huyen","slug":"tan-phu","name_with_type":"Huyện Tân Phú","path":"Huyện Tân Phú, Tỉnh Đồng Nai","path_with_type":"Huyện Tân Phú, Tỉnh Đồng Nai","code":"734","parent_code":"75"},"735":{"name":"Vĩnh Cửu","type":"huyen","slug":"vinh-cuu","name_with_type":"Huyện Vĩnh Cửu","path":"Huyện Vĩnh Cửu, Tỉnh Đồng Nai","path_with_type":"Huyện Vĩnh Cửu, Tỉnh Đồng Nai","code":"735","parent_code":"75"},"736":{"name":"Định Quán","type":"huyen","slug":"dinh-quan","name_with_type":"Huyện Định Quán","path":"Huyện Định Quán, Tỉnh Đồng Nai","path_with_type":"Huyện Định Quán, Tỉnh Đồng Nai","code":"736","parent_code":"75"},"737":{"name":"Trảng Bom","type":"huyen","slug":"trang-bom","name_with_type":"Huyện Trảng Bom","path":"Huyện Trảng Bom, Tỉnh Đồng Nai","path_with_type":"Huyện Trảng Bom, Tỉnh Đồng Nai","code":"737","parent_code":"75"},"738":{"name":"Thống Nhất","type":"huyen","slug":"thong-nhat","name_with_type":"Huyện Thống Nhất","path":"Huyện Thống Nhất, Tỉnh Đồng Nai","path_with_type":"Huyện Thống Nhất, Tỉnh Đồng Nai","code":"738","parent_code":"75"},"739":{"name":"Cẩm Mỹ","type":"huyen","slug":"cam-my","name_with_type":"Huyện Cẩm Mỹ","path":"Huyện Cẩm Mỹ, Tỉnh Đồng Nai","path_with_type":"Huyện Cẩm Mỹ, Tỉnh Đồng Nai","code":"739","parent_code":"75"},"740":{"name":"Long Thành","type":"huyen","slug":"long-thanh","name_with_type":"Huyện Long Thành","path":"Huyện Long Thành, Tỉnh Đồng Nai","path_with_type":"Huyện Long Thành, Tỉnh Đồng Nai","code":"740","parent_code":"75"},"741":{"name":"Xuân Lộc","type":"huyen","slug":"xuan-loc","name_with_type":"Huyện Xuân Lộc","path":"Huyện Xuân Lộc, Tỉnh Đồng Nai","path_with_type":"Huyện Xuân Lộc, Tỉnh Đồng Nai","code":"741","parent_code":"75"},"742":{"name":"Nhơn Trạch","type":"huyen","slug":"nhon-trach","name_with_type":"Huyện Nhơn Trạch","path":"Huyện Nhơn Trạch, Tỉnh Đồng Nai","path_with_type":"Huyện Nhơn Trạch, Tỉnh Đồng Nai","code":"742","parent_code":"75"},"747":{"name":"Thành phố Vũng Tàu","type":"thanh-pho","slug":"thanh-pho-vung-tau","name_with_type":"Thành phố Vũng Tàu","path":"Thành phố Vũng Tàu, Tỉnh Bà Rịa - Vũng Tàu","path_with_type":"Thành phố Vũng Tàu, Tỉnh Bà Rịa - Vũng Tàu","code":"747","parent_code":"77"},"748":{"name":"Thành phố Bà Rịa","type":"thanh-pho","slug":"thanh-pho-ba-ria","name_with_type":"Thành phố Bà Rịa","path":"Thành phố Bà Rịa, Tỉnh Bà Rịa - Vũng Tàu","path_with_type":"Thành phố Bà Rịa, Tỉnh Bà Rịa - Vũng Tàu","code":"748","parent_code":"77"},"750":{"name":"Châu Đức","type":"huyen","slug":"chau-duc","name_with_type":"Huyện Châu Đức","path":"Huyện Châu Đức, Tỉnh Bà Rịa - Vũng Tàu","path_with_type":"Huyện Châu Đức, Tỉnh Bà Rịa - Vũng Tàu","code":"750","parent_code":"77"},"751":{"name":"Xuyên Mộc","type":"huyen","slug":"xuyen-moc","name_with_type":"Huyện Xuyên Mộc","path":"Huyện Xuyên Mộc, Tỉnh Bà Rịa - Vũng Tàu","path_with_type":"Huyện Xuyên Mộc, Tỉnh Bà Rịa - Vũng Tàu","code":"751","parent_code":"77"},"753":{"name":"Long Đất","type":"huyen","slug":"long-dat","name_with_type":"Huyện Long Đất","path":"Huyện Long Đất, Tỉnh Bà Rịa - Vũng Tàu","path_with_type":"Huyện Long Đất, Tỉnh Bà Rịa - Vũng Tàu","code":"753","parent_code":"77"},"754":{"name":"Thị xã Phú Mỹ","type":"thi-xa","slug":"thi-xa-phu-my","name_with_type":"Thị xã Phú Mỹ","path":"Thị xã Phú Mỹ, Tỉnh Bà Rịa - Vũng Tàu","path_with_type":"Thị xã Phú Mỹ, Tỉnh Bà Rịa - Vũng Tàu","code":"754","parent_code":"77"},"755":{"name":"Côn Đảo","type":"huyen","slug":"con-dao","name_with_type":"Huyện Côn Đảo","path":"Huyện Côn Đảo, Tỉnh Bà Rịa - Vũng Tàu","path_with_type":"Huyện Côn Đảo, Tỉnh Bà Rịa - Vũng Tàu","code":"755","parent_code":"77"},"760":{"name":"Quận 1","type":"quan","slug":"quan-1","name_with_type":"Quận 1","path":"Quận 1, Thành phố Hồ Chí Minh","path_with_type":"Quận 1, Thành phố Hồ Chí Minh","code":"760","parent_code":"79"},"761":{"name":"Quận 12","type":"quan","slug":"quan-12","name_with_type":"Quận 12","path":"Quận 12, Thành phố Hồ Chí Minh","path_with_type":"Quận 12, Thành phố Hồ Chí Minh","code":"761","parent_code":"79"},"764":{"name":"Quận Gò Vấp","type":"quan","slug":"quan-go-vap","name_with_type":"Quận Gò Vấp","path":"Quận Gò Vấp, Thành phố Hồ Chí Minh","path_with_type":"Quận Gò Vấp, Thành phố Hồ Chí Minh","code":"764","parent_code":"79"},"765":{"name":"Quận Bình Thạnh","type":"quan","slug":"quan-binh-thanh","name_with_type":"Quận Bình Thạnh","path":"Quận Bình Thạnh, Thành phố Hồ Chí Minh","path_with_type":"Quận Bình Thạnh, Thành phố Hồ Chí Minh","code":"765","parent_code":"79"},"766":{"name":"Quận Tân Bình","type":"quan","slug":"quan-tan-binh","name_with_type":"Quận Tân Bình","path":"Quận Tân Bình, Thành phố Hồ Chí Minh","path_with_type":"Quận Tân Bình, Thành phố Hồ Chí Minh","code":"766","parent_code":"79"},"767":{"name":"Quận Tân Phú","type":"quan","slug":"quan-tan-phu","name_with_type":"Quận Tân Phú","path":"Quận Tân Phú, Thành phố Hồ Chí Minh","path_with_type":"Quận Tân Phú, Thành phố Hồ Chí Minh","code":"767","parent_code":"79"},"768":{"name":"Quận Phú Nhuận","type":"quan","slug":"quan-phu-nhuan","name_with_type":"Quận Phú Nhuận","path":"Quận Phú Nhuận, Thành phố Hồ Chí Minh","path_with_type":"Quận Phú Nhuận, Thành phố Hồ Chí Minh","code":"768","parent_code":"79"},"769":{"name":"Thành phố Thủ Đức","type":"thanh-pho","slug":"thanh-pho-thu-duc","name_with_type":"Thành phố Thủ Đức","path":"Thành phố Thủ Đức, Thành phố Hồ Chí Minh","path_with_type":"Thành phố Thủ Đức, Thành phố Hồ Chí Minh","code":"769","parent_code":"79"},"770":{"name":"Quận 3","type":"quan","slug":"quan-3","name_with_type":"Quận 3","path":"Quận 3, Thành phố Hồ Chí Minh","path_with_type":"Quận 3, Thành phố Hồ Chí Minh","code":"770","parent_code":"79"},"771":{"name":"Quận 10","type":"quan","slug":"quan-10","name_with_type":"Quận 10","path":"Quận 10, Thành phố Hồ Chí Minh","path_with_type":"Quận 10, Thành phố Hồ Chí Minh","code":"771","parent_code":"79"},"772":{"name":"Quận 11","type":"quan","slug":"quan-11","name_with_type":"Quận 11","path":"Quận 11, Thành phố Hồ Chí Minh","path_with_type":"Quận 11, Thành phố Hồ Chí Minh","code":"772","parent_code":"79"},"773":{"name":"Quận 4","type":"quan","slug":"quan-4","name_with_type":"Quận 4","path":"Quận 4, Thành phố Hồ Chí Minh","path_with_type":"Quận 4, Thành phố Hồ Chí Minh","code":"773","parent_code":"79"},"774":{"name":"Quận 5","type":"quan","slug":"quan-5","name_with_type":"Quận 5","path":"Quận 5, Thành phố Hồ Chí Minh","path_with_type":"Quận 5, Thành phố Hồ Chí Minh","code":"774","parent_code":"79"},"775":{"name":"Quận 6","type":"quan","slug":"quan-6","name_with_type":"Quận 6","path":"Quận 6, Thành phố Hồ Chí Minh","path_with_type":"Quận 6, Thành phố Hồ Chí Minh","code":"775","parent_code":"79"},"776":{"name":"Quận 8","type":"quan","slug":"quan-8","name_with_type":"Quận 8","path":"Quận 8, Thành phố Hồ Chí Minh","path_with_type":"Quận 8, Thành phố Hồ Chí Minh","code":"776","parent_code":"79"},"777":{"name":"Quận Bình Tân","type":"quan","slug":"quan-binh-tan","name_with_type":"Quận Bình Tân","path":"Quận Bình Tân, Thành phố Hồ Chí Minh","path_with_type":"Quận Bình Tân, Thành phố Hồ Chí Minh","code":"777","parent_code":"79"},"778":{"name":"Quận 7","type":"quan","slug":"quan-7","name_with_type":"Quận 7","path":"Quận 7, Thành phố Hồ Chí Minh","path_with_type":"Quận 7, Thành phố Hồ Chí Minh","code":"778","parent_code":"79"},"783":{"name":"Củ Chi","type":"huyen","slug":"cu-chi","name_with_type":"Huyện Củ Chi","path":"Huyện Củ Chi, Thành phố Hồ Chí Minh","path_with_type":"Huyện Củ Chi, Thành phố Hồ Chí Minh","code":"783","parent_code":"79"},"784":{"name":"Hóc Môn","type":"huyen","slug":"hoc-mon","name_with_type":"Huyện Hóc Môn","path":"Huyện Hóc Môn, Thành phố Hồ Chí Minh","path_with_type":"Huyện Hóc Môn, Thành phố Hồ Chí Minh","code":"784","parent_code":"79"},"785":{"name":"Bình Chánh","type":"huyen","slug":"binh-chanh","name_with_type":"Huyện Bình Chánh","path":"Huyện Bình Chánh, Thành phố Hồ Chí Minh","path_with_type":"Huyện Bình Chánh, Thành phố Hồ Chí Minh","code":"785","parent_code":"79"},"786":{"name":"Nhà Bè","type":"huyen","slug":"nha-be","name_with_type":"Huyện Nhà Bè","path":"Huyện Nhà Bè, Thành phố Hồ Chí Minh","path_with_type":"Huyện Nhà Bè, Thành phố Hồ Chí Minh","code":"786","parent_code":"79"},"787":{"name":"Cần Giờ","type":"huyen","slug":"can-gio","name_with_type":"Huyện Cần Giờ","path":"Huyện Cần Giờ, Thành phố Hồ Chí Minh","path_with_type":"Huyện Cần Giờ, Thành phố Hồ Chí Minh","code":"787","parent_code":"79"},"794":{"name":"Thành phố Tân An","type":"thanh-pho","slug":"thanh-pho-tan-an","name_with_type":"Thành phố Tân An","path":"Thành phố Tân An, Tỉnh Long An","path_with_type":"Thành phố Tân An, Tỉnh Long An","code":"794","parent_code":"80"},"795":{"name":"Thị xã Kiến Tường","type":"thi-xa","slug":"thi-xa-kien-tuong","name_with_type":"Thị xã Kiến Tường","path":"Thị xã Kiến Tường, Tỉnh Long An","path_with_type":"Thị xã Kiến Tường, Tỉnh Long An","code":"795","parent_code":"80"},"796":{"name":"Tân Hưng","type":"huyen","slug":"tan-hung","name_with_type":"Huyện Tân Hưng","path":"Huyện Tân Hưng, Tỉnh Long An","path_with_type":"Huyện Tân Hưng, Tỉnh Long An","code":"796","parent_code":"80"},"797":{"name":"Vĩnh Hưng","type":"huyen","slug":"vinh-hung","name_with_type":"Huyện Vĩnh Hưng","path":"Huyện Vĩnh Hưng, Tỉnh Long An","path_with_type":"Huyện Vĩnh Hưng, Tỉnh Long An","code":"797","parent_code":"80"},"798":{"name":"Mộc Hóa","type":"huyen","slug":"moc-hoa","name_with_type":"Huyện Mộc Hóa","path":"Huyện Mộc Hóa, Tỉnh Long An","path_with_type":"Huyện Mộc Hóa, Tỉnh Long An","code":"798","parent_code":"80"},"799":{"name":"Tân Thạnh","type":"huyen","slug":"tan-thanh","name_with_type":"Huyện Tân Thạnh","path":"Huyện Tân Thạnh, Tỉnh Long An","path_with_type":"Huyện Tân Thạnh, Tỉnh Long An","code":"799","parent_code":"80"},"800":{"name":"Thạnh Hóa","type":"huyen","slug":"thanh-hoa","name_with_type":"Huyện Thạnh Hóa","path":"Huyện Thạnh Hóa, Tỉnh Long An","path_with_type":"Huyện Thạnh Hóa, Tỉnh Long An","code":"800","parent_code":"80"},"801":{"name":"Đức Huệ","type":"huyen","slug":"duc-hue","name_with_type":"Huyện Đức Huệ","path":"Huyện Đức Huệ, Tỉnh Long An","path_with_type":"Huyện Đức Huệ, Tỉnh Long An","code":"801","parent_code":"80"},"802":{"name":"Đức Hòa","type":"huyen","slug":"duc-hoa","name_with_type":"Huyện Đức Hòa","path":"Huyện Đức Hòa, Tỉnh Long An","path_with_type":"Huyện Đức Hòa, Tỉnh Long An","code":"802","parent_code":"80"},"803":{"name":"Bến Lức","type":"huyen","slug":"ben-luc","name_with_type":"Huyện Bến Lức","path":"Huyện Bến Lức, Tỉnh Long An","path_with_type":"Huyện Bến Lức, Tỉnh Long An","code":"803","parent_code":"80"},"804":{"name":"Thủ Thừa","type":"huyen","slug":"thu-thua","name_with_type":"Huyện Thủ Thừa","path":"Huyện Thủ Thừa, Tỉnh Long An","path_with_type":"Huyện Thủ Thừa, Tỉnh Long An","code":"804","parent_code":"80"},"805":{"name":"Tân Trụ","type":"huyen","slug":"tan-tru","name_with_type":"Huyện Tân Trụ","path":"Huyện Tân Trụ, Tỉnh Long An","path_with_type":"Huyện Tân Trụ, Tỉnh Long An","code":"805","parent_code":"80"},"806":{"name":"Cần Đước","type":"huyen","slug":"can-duoc","name_with_type":"Huyện Cần Đước","path":"Huyện Cần Đước, Tỉnh Long An","path_with_type":"Huyện Cần Đước, Tỉnh Long An","code":"806","parent_code":"80"},"807":{"name":"Cần Giuộc","type":"huyen","slug":"can-giuoc","name_with_type":"Huyện Cần Giuộc","path":"Huyện Cần Giuộc, Tỉnh Long An","path_with_type":"Huyện Cần Giuộc, Tỉnh Long An","code":"807","parent_code":"80"},"808":{"name":"Châu Thành","type":"huyen","slug":"chau-thanh","name_with_type":"Huyện Châu Thành","path":"Huyện Châu Thành, Tỉnh Long An","path_with_type":"Huyện Châu Thành, Tỉnh Long An","code":"808","parent_code":"80"},"815":{"name":"Thành phố Mỹ Tho","type":"thanh-pho","slug":"thanh-pho-my-tho","name_with_type":"Thành phố Mỹ Tho","path":"Thành phố Mỹ Tho, Tỉnh Tiền Giang","path_with_type":"Thành phố Mỹ Tho, Tỉnh Tiền Giang","code":"815","parent_code":"82"},"816":{"name":"Thành phố Gò Công","type":"thanh-pho","slug":"thanh-pho-go-cong","name_with_type":"Thành phố Gò Công","path":"Thành phố Gò Công, Tỉnh Tiền Giang","path_with_type":"Thành phố Gò Công, Tỉnh Tiền Giang","code":"816","parent_code":"82"},"817":{"name":"Thị xã Cai Lậy","type":"thi-xa","slug":"thi-xa-cai-lay","name_with_type":"Thị xã Cai Lậy","path":"Thị xã Cai Lậy, Tỉnh Tiền Giang","path_with_type":"Thị xã Cai Lậy, Tỉnh Tiền Giang","code":"817","parent_code":"82"},"818":{"name":"Tân Phước","type":"huyen","slug":"tan-phuoc","name_with_type":"Huyện Tân Phước","path":"Huyện Tân Phước, Tỉnh Tiền Giang","path_with_type":"Huyện Tân Phước, Tỉnh Tiền Giang","code":"818","parent_code":"82"},"819":{"name":"Cái Bè","type":"huyen","slug":"cai-be","name_with_type":"Huyện Cái Bè","path":"Huyện Cái Bè, Tỉnh Tiền Giang","path_with_type":"Huyện Cái Bè, Tỉnh Tiền Giang","code":"819","parent_code":"82"},"820":{"name":"Cai Lậy","type":"huyen","slug":"cai-lay","name_with_type":"Huyện Cai Lậy","path":"Huyện Cai Lậy, Tỉnh Tiền Giang","path_with_type":"Huyện Cai Lậy, Tỉnh Tiền Giang","code":"820","parent_code":"82"},"821":{"name":"Châu Thành","type":"huyen","slug":"chau-thanh","name_with_type":"Huyện Châu Thành","path":"Huyện Châu Thành, Tỉnh Tiền Giang","path_with_type":"Huyện Châu Thành, Tỉnh Tiền Giang","code":"821","parent_code":"82"},"822":{"name":"Chợ Gạo","type":"huyen","slug":"cho-gao","name_with_type":"Huyện Chợ Gạo","path":"Huyện Chợ Gạo, Tỉnh Tiền Giang","path_with_type":"Huyện Chợ Gạo, Tỉnh Tiền Giang","code":"822","parent_code":"82"},"823":{"name":"Gò Công Tây","type":"huyen","slug":"go-cong-tay","name_with_type":"Huyện Gò Công Tây","path":"Huyện Gò Công Tây, Tỉnh Tiền Giang","path_with_type":"Huyện Gò Công Tây, Tỉnh Tiền Giang","code":"823","parent_code":"82"},"824":{"name":"Gò Công Đông","type":"huyen","slug":"go-cong-dong","name_with_type":"Huyện Gò Công Đông","path":"Huyện Gò Công Đông, Tỉnh Tiền Giang","path_with_type":"Huyện Gò Công Đông, Tỉnh Tiền Giang","code":"824","parent_code":"82"},"825":{"name":"Tân Phú Đông","type":"huyen","slug":"tan-phu-dong","name_with_type":"Huyện Tân Phú Đông","path":"Huyện Tân Phú Đông, Tỉnh Tiền Giang","path_with_type":"Huyện Tân Phú Đông, Tỉnh Tiền Giang","code":"825","parent_code":"82"},"829":{"name":"Thành phố Bến Tre","type":"thanh-pho","slug":"thanh-pho-ben-tre","name_with_type":"Thành phố Bến Tre","path":"Thành phố Bến Tre, Tỉnh Bến Tre","path_with_type":"Thành phố Bến Tre, Tỉnh Bến Tre","code":"829","parent_code":"83"},"831":{"name":"Châu Thành","type":"huyen","slug":"chau-thanh","name_with_type":"Huyện Châu Thành","path":"Huyện Châu Thành, Tỉnh Bến Tre","path_with_type":"Huyện Châu Thành, Tỉnh Bến Tre","code":"831","parent_code":"83"},"832":{"name":"Chợ Lách","type":"huyen","slug":"cho-lach","name_with_type":"Huyện Chợ Lách","path":"Huyện Chợ Lách, Tỉnh Bến Tre","path_with_type":"Huyện Chợ Lách, Tỉnh Bến Tre","code":"832","parent_code":"83"},"833":{"name":"Mỏ Cày Nam","type":"huyen","slug":"mo-cay-nam","name_with_type":"Huyện Mỏ Cày Nam","path":"Huyện Mỏ Cày Nam, Tỉnh Bến Tre","path_with_type":"Huyện Mỏ Cày Nam, Tỉnh Bến Tre","code":"833","parent_code":"83"},"834":{"name":"Giồng Trôm","type":"huyen","slug":"giong-trom","name_with_type":"Huyện Giồng Trôm","path":"Huyện Giồng Trôm, Tỉnh Bến Tre","path_with_type":"Huyện Giồng Trôm, Tỉnh Bến Tre","code":"834","parent_code":"83"},"835":{"name":"Bình Đại","type":"huyen","slug":"binh-dai","name_with_type":"Huyện Bình Đại","path":"Huyện Bình Đại, Tỉnh Bến Tre","path_with_type":"Huyện Bình Đại, Tỉnh Bến Tre","code":"835","parent_code":"83"},"836":{"name":"Ba Tri","type":"huyen","slug":"ba-tri","name_with_type":"Huyện Ba Tri","path":"Huyện Ba Tri, Tỉnh Bến Tre","path_with_type":"Huyện Ba Tri, Tỉnh Bến Tre","code":"836","parent_code":"83"},"837":{"name":"Thạnh Phú","type":"huyen","slug":"thanh-phu","name_with_type":"Huyện Thạnh Phú","path":"Huyện Thạnh Phú, Tỉnh Bến Tre","path_with_type":"Huyện Thạnh Phú, Tỉnh Bến Tre","code":"837","parent_code":"83"},"838":{"name":"Mỏ Cày Bắc","type":"huyen","slug":"mo-cay-bac","name_with_type":"Huyện Mỏ Cày Bắc","path":"Huyện Mỏ Cày Bắc, Tỉnh Bến Tre","path_with_type":"Huyện Mỏ Cày Bắc, Tỉnh Bến Tre","code":"838","parent_code":"83"},"842":{"name":"Thành phố Trà Vinh","type":"thanh-pho","slug":"thanh-pho-tra-vinh","name_with_type":"Thành phố Trà Vinh","path":"Thành phố Trà Vinh, Tỉnh Trà Vinh","path_with_type":"Thành phố Trà Vinh, Tỉnh Trà Vinh","code":"842","parent_code":"84"},"844":{"name":"Càng Long","type":"huyen","slug":"cang-long","name_with_type":"Huyện Càng Long","path":"Huyện Càng Long, Tỉnh Trà Vinh","path_with_type":"Huyện Càng Long, Tỉnh Trà Vinh","code":"844","parent_code":"84"},"845":{"name":"Cầu Kè","type":"huyen","slug":"cau-ke","name_with_type":"Huyện Cầu Kè","path":"Huyện Cầu Kè, Tỉnh Trà Vinh","path_with_type":"Huyện Cầu Kè, Tỉnh Trà Vinh","code":"845","parent_code":"84"},"846":{"name":"Tiểu Cần","type":"huyen","slug":"tieu-can","name_with_type":"Huyện Tiểu Cần","path":"Huyện Tiểu Cần, Tỉnh Trà Vinh","path_with_type":"Huyện Tiểu Cần, Tỉnh Trà Vinh","code":"846","parent_code":"84"},"847":{"name":"Châu Thành","type":"huyen","slug":"chau-thanh","name_with_type":"Huyện Châu Thành","path":"Huyện Châu Thành, Tỉnh Trà Vinh","path_with_type":"Huyện Châu Thành, Tỉnh Trà Vinh","code":"847","parent_code":"84"},"848":{"name":"Cầu Ngang","type":"huyen","slug":"cau-ngang","name_with_type":"Huyện Cầu Ngang","path":"Huyện Cầu Ngang, Tỉnh Trà Vinh","path_with_type":"Huyện Cầu Ngang, Tỉnh Trà Vinh","code":"848","parent_code":"84"},"849":{"name":"Trà Cú","type":"huyen","slug":"tra-cu","name_with_type":"Huyện Trà Cú","path":"Huyện Trà Cú, Tỉnh Trà Vinh","path_with_type":"Huyện Trà Cú, Tỉnh Trà Vinh","code":"849","parent_code":"84"},"850":{"name":"Duyên Hải","type":"huyen","slug":"duyen-hai","name_with_type":"Huyện Duyên Hải","path":"Huyện Duyên Hải, Tỉnh Trà Vinh","path_with_type":"Huyện Duyên Hải, Tỉnh Trà Vinh","code":"850","parent_code":"84"},"851":{"name":"Thị xã Duyên Hải","type":"thi-xa","slug":"thi-xa-duyen-hai","name_with_type":"Thị xã Duyên Hải","path":"Thị xã Duyên Hải, Tỉnh Trà Vinh","path_with_type":"Thị xã Duyên Hải, Tỉnh Trà Vinh","code":"851","parent_code":"84"},"855":{"name":"Thành phố Vĩnh Long","type":"thanh-pho","slug":"thanh-pho-vinh-long","name_with_type":"Thành phố Vĩnh Long","path":"Thành phố Vĩnh Long, Tỉnh Vĩnh Long","path_with_type":"Thành phố Vĩnh Long, Tỉnh Vĩnh Long","code":"855","parent_code":"86"},"857":{"name":"Long Hồ","type":"huyen","slug":"long-ho","name_with_type":"Huyện Long Hồ","path":"Huyện Long Hồ, Tỉnh Vĩnh Long","path_with_type":"Huyện Long Hồ, Tỉnh Vĩnh Long","code":"857","parent_code":"86"},"858":{"name":"Mang Thít","type":"huyen","slug":"mang-thit","name_with_type":"Huyện Mang Thít","path":"Huyện Mang Thít, Tỉnh Vĩnh Long","path_with_type":"Huyện Mang Thít, Tỉnh Vĩnh Long","code":"858","parent_code":"86"},"859":{"name":" Vũng Liêm","type":"huyen","slug":"vung-liem","name_with_type":"Huyện  Vũng Liêm","path":"Huyện  Vũng Liêm, Tỉnh Vĩnh Long","path_with_type":"Huyện  Vũng Liêm, Tỉnh Vĩnh Long","code":"859","parent_code":"86"},"860":{"name":"Tam Bình","type":"huyen","slug":"tam-binh","name_with_type":"Huyện Tam Bình","path":"Huyện Tam Bình, Tỉnh Vĩnh Long","path_with_type":"Huyện Tam Bình, Tỉnh Vĩnh Long","code":"860","parent_code":"86"},"861":{"name":"Thị xã Bình Minh","type":"thi-xa","slug":"thi-xa-binh-minh","name_with_type":"Thị xã Bình Minh","path":"Thị xã Bình Minh, Tỉnh Vĩnh Long","path_with_type":"Thị xã Bình Minh, Tỉnh Vĩnh Long","code":"861","parent_code":"86"},"862":{"name":"Trà Ôn","type":"huyen","slug":"tra-on","name_with_type":"Huyện Trà Ôn","path":"Huyện Trà Ôn, Tỉnh Vĩnh Long","path_with_type":"Huyện Trà Ôn, Tỉnh Vĩnh Long","code":"862","parent_code":"86"},"863":{"name":"Bình Tân","type":"huyen","slug":"binh-tan","name_with_type":"Huyện Bình Tân","path":"Huyện Bình Tân, Tỉnh Vĩnh Long","path_with_type":"Huyện Bình Tân, Tỉnh Vĩnh Long","code":"863","parent_code":"86"},"866":{"name":"Thành phố Cao Lãnh","type":"thanh-pho","slug":"thanh-pho-cao-lanh","name_with_type":"Thành phố Cao Lãnh","path":"Thành phố Cao Lãnh, Tỉnh Đồng Tháp","path_with_type":"Thành phố Cao Lãnh, Tỉnh Đồng Tháp","code":"866","parent_code":"87"},"867":{"name":"Thành phố Sa Đéc","type":"thanh-pho","slug":"thanh-pho-sa-dec","name_with_type":"Thành phố Sa Đéc","path":"Thành phố Sa Đéc, Tỉnh Đồng Tháp","path_with_type":"Thành phố Sa Đéc, Tỉnh Đồng Tháp","code":"867","parent_code":"87"},"868":{"name":"Thành phố Hồng Ngự","type":"thanh-pho","slug":"thanh-pho-hong-ngu","name_with_type":"Thành phố Hồng Ngự","path":"Thành phố Hồng Ngự, Tỉnh Đồng Tháp","path_with_type":"Thành phố Hồng Ngự, Tỉnh Đồng Tháp","code":"868","parent_code":"87"},"869":{"name":"Tân Hồng","type":"huyen","slug":"tan-hong","name_with_type":"Huyện Tân Hồng","path":"Huyện Tân Hồng, Tỉnh Đồng Tháp","path_with_type":"Huyện Tân Hồng, Tỉnh Đồng Tháp","code":"869","parent_code":"87"},"870":{"name":"Hồng Ngự","type":"huyen","slug":"hong-ngu","name_with_type":"Huyện Hồng Ngự","path":"Huyện Hồng Ngự, Tỉnh Đồng Tháp","path_with_type":"Huyện Hồng Ngự, Tỉnh Đồng Tháp","code":"870","parent_code":"87"},"871":{"name":"Tam Nông","type":"huyen","slug":"tam-nong","name_with_type":"Huyện Tam Nông","path":"Huyện Tam Nông, Tỉnh Đồng Tháp","path_with_type":"Huyện Tam Nông, Tỉnh Đồng Tháp","code":"871","parent_code":"87"},"872":{"name":"Tháp Mười","type":"huyen","slug":"thap-muoi","name_with_type":"Huyện Tháp Mười","path":"Huyện Tháp Mười, Tỉnh Đồng Tháp","path_with_type":"Huyện Tháp Mười, Tỉnh Đồng Tháp","code":"872","parent_code":"87"},"873":{"name":"Cao Lãnh","type":"huyen","slug":"cao-lanh","name_with_type":"Huyện Cao Lãnh","path":"Huyện Cao Lãnh, Tỉnh Đồng Tháp","path_with_type":"Huyện Cao Lãnh, Tỉnh Đồng Tháp","code":"873","parent_code":"87"},"874":{"name":"Thanh Bình","type":"huyen","slug":"thanh-binh","name_with_type":"Huyện Thanh Bình","path":"Huyện Thanh Bình, Tỉnh Đồng Tháp","path_with_type":"Huyện Thanh Bình, Tỉnh Đồng Tháp","code":"874","parent_code":"87"},"875":{"name":"Lấp Vò","type":"huyen","slug":"lap-vo","name_with_type":"Huyện Lấp Vò","path":"Huyện Lấp Vò, Tỉnh Đồng Tháp","path_with_type":"Huyện Lấp Vò, Tỉnh Đồng Tháp","code":"875","parent_code":"87"},"876":{"name":"Lai Vung","type":"huyen","slug":"lai-vung","name_with_type":"Huyện Lai Vung","path":"Huyện Lai Vung, Tỉnh Đồng Tháp","path_with_type":"Huyện Lai Vung, Tỉnh Đồng Tháp","code":"876","parent_code":"87"},"877":{"name":"Châu Thành","type":"huyen","slug":"chau-thanh","name_with_type":"Huyện Châu Thành","path":"Huyện Châu Thành, Tỉnh Đồng Tháp","path_with_type":"Huyện Châu Thành, Tỉnh Đồng Tháp","code":"877","parent_code":"87"},"883":{"name":"Thành phố Long Xuyên","type":"thanh-pho","slug":"thanh-pho-long-xuyen","name_with_type":"Thành phố Long Xuyên","path":"Thành phố Long Xuyên, Tỉnh An Giang","path_with_type":"Thành phố Long Xuyên, Tỉnh An Giang","code":"883","parent_code":"89"},"884":{"name":"Thành phố Châu Đốc","type":"thanh-pho","slug":"thanh-pho-chau-doc","name_with_type":"Thành phố Châu Đốc","path":"Thành phố Châu Đốc, Tỉnh An Giang","path_with_type":"Thành phố Châu Đốc, Tỉnh An Giang","code":"884","parent_code":"89"},"886":{"name":"An Phú","type":"huyen","slug":"an-phu","name_with_type":"Huyện An Phú","path":"Huyện An Phú, Tỉnh An Giang","path_with_type":"Huyện An Phú, Tỉnh An Giang","code":"886","parent_code":"89"},"887":{"name":"Thị xã Tân Châu","type":"thi-xa","slug":"thi-xa-tan-chau","name_with_type":"Thị xã Tân Châu","path":"Thị xã Tân Châu, Tỉnh An Giang","path_with_type":"Thị xã Tân Châu, Tỉnh An Giang","code":"887","parent_code":"89"},"888":{"name":"Phú Tân","type":"huyen","slug":"phu-tan","name_with_type":"Huyện Phú Tân","path":"Huyện Phú Tân, Tỉnh An Giang","path_with_type":"Huyện Phú Tân, Tỉnh An Giang","code":"888","parent_code":"89"},"889":{"name":"Châu Phú","type":"huyen","slug":"chau-phu","name_with_type":"Huyện Châu Phú","path":"Huyện Châu Phú, Tỉnh An Giang","path_with_type":"Huyện Châu Phú, Tỉnh An Giang","code":"889","parent_code":"89"},"890":{"name":"Thị xã Tịnh Biên","type":"thi-xa","slug":"thi-xa-tinh-bien","name_with_type":"Thị xã Tịnh Biên","path":"Thị xã Tịnh Biên, Tỉnh An Giang","path_with_type":"Thị xã Tịnh Biên, Tỉnh An Giang","code":"890","parent_code":"89"},"891":{"name":"Tri Tôn","type":"huyen","slug":"tri-ton","name_with_type":"Huyện Tri Tôn","path":"Huyện Tri Tôn, Tỉnh An Giang","path_with_type":"Huyện Tri Tôn, Tỉnh An Giang","code":"891","parent_code":"89"},"892":{"name":"Châu Thành","type":"huyen","slug":"chau-thanh","name_with_type":"Huyện Châu Thành","path":"Huyện Châu Thành, Tỉnh An Giang","path_with_type":"Huyện Châu Thành, Tỉnh An Giang","code":"892","parent_code":"89"},"893":{"name":"Chợ Mới","type":"huyen","slug":"cho-moi","name_with_type":"Huyện Chợ Mới","path":"Huyện Chợ Mới, Tỉnh An Giang","path_with_type":"Huyện Chợ Mới, Tỉnh An Giang","code":"893","parent_code":"89"},"894":{"name":"Thoại Sơn","type":"huyen","slug":"thoai-son","name_with_type":"Huyện Thoại Sơn","path":"Huyện Thoại Sơn, Tỉnh An Giang","path_with_type":"Huyện Thoại Sơn, Tỉnh An Giang","code":"894","parent_code":"89"},"899":{"name":"Thành phố Rạch Giá","type":"thanh-pho","slug":"thanh-pho-rach-gia","name_with_type":"Thành phố Rạch Giá","path":"Thành phố Rạch Giá, Tỉnh Kiên Giang","path_with_type":"Thành phố Rạch Giá, Tỉnh Kiên Giang","code":"899","parent_code":"91"},"900":{"name":"Thành phố Hà Tiên","type":"thanh-pho","slug":"thanh-pho-ha-tien","name_with_type":"Thành phố Hà Tiên","path":"Thành phố Hà Tiên, Tỉnh Kiên Giang","path_with_type":"Thành phố Hà Tiên, Tỉnh Kiên Giang","code":"900","parent_code":"91"},"902":{"name":"Kiên Lương","type":"huyen","slug":"kien-luong","name_with_type":"Huyện Kiên Lương","path":"Huyện Kiên Lương, Tỉnh Kiên Giang","path_with_type":"Huyện Kiên Lương, Tỉnh Kiên Giang","code":"902","parent_code":"91"},"903":{"name":"Hòn Đất","type":"huyen","slug":"hon-dat","name_with_type":"Huyện Hòn Đất","path":"Huyện Hòn Đất, Tỉnh Kiên Giang","path_with_type":"Huyện Hòn Đất, Tỉnh Kiên Giang","code":"903","parent_code":"91"},"904":{"name":"Tân Hiệp","type":"huyen","slug":"tan-hiep","name_with_type":"Huyện Tân Hiệp","path":"Huyện Tân Hiệp, Tỉnh Kiên Giang","path_with_type":"Huyện Tân Hiệp, Tỉnh Kiên Giang","code":"904","parent_code":"91"},"905":{"name":"Châu Thành","type":"huyen","slug":"chau-thanh","name_with_type":"Huyện Châu Thành","path":"Huyện Châu Thành, Tỉnh Kiên Giang","path_with_type":"Huyện Châu Thành, Tỉnh Kiên Giang","code":"905","parent_code":"91"},"906":{"name":"Giồng Riềng","type":"huyen","slug":"giong-rieng","name_with_type":"Huyện Giồng Riềng","path":"Huyện Giồng Riềng, Tỉnh Kiên Giang","path_with_type":"Huyện Giồng Riềng, Tỉnh Kiên Giang","code":"906","parent_code":"91"},"907":{"name":"Gò Quao","type":"huyen","slug":"go-quao","name_with_type":"Huyện Gò Quao","path":"Huyện Gò Quao, Tỉnh Kiên Giang","path_with_type":"Huyện Gò Quao, Tỉnh Kiên Giang","code":"907","parent_code":"91"},"908":{"name":"An Biên","type":"huyen","slug":"an-bien","name_with_type":"Huyện An Biên","path":"Huyện An Biên, Tỉnh Kiên Giang","path_with_type":"Huyện An Biên, Tỉnh Kiên Giang","code":"908","parent_code":"91"},"909":{"name":"An Minh","type":"huyen","slug":"an-minh","name_with_type":"Huyện An Minh","path":"Huyện An Minh, Tỉnh Kiên Giang","path_with_type":"Huyện An Minh, Tỉnh Kiên Giang","code":"909","parent_code":"91"},"910":{"name":"Vĩnh Thuận","type":"huyen","slug":"vinh-thuan","name_with_type":"Huyện Vĩnh Thuận","path":"Huyện Vĩnh Thuận, Tỉnh Kiên Giang","path_with_type":"Huyện Vĩnh Thuận, Tỉnh Kiên Giang","code":"910","parent_code":"91"},"911":{"name":"Thành phố Phú Quốc","type":"thanh-pho","slug":"thanh-pho-phu-quoc","name_with_type":"Thành phố Phú Quốc","path":"Thành phố Phú Quốc, Tỉnh Kiên Giang","path_with_type":"Thành phố Phú Quốc, Tỉnh Kiên Giang","code":"911","parent_code":"91"},"912":{"name":"Kiên Hải","type":"huyen","slug":"kien-hai","name_with_type":"Huyện Kiên Hải","path":"Huyện Kiên Hải, Tỉnh Kiên Giang","path_with_type":"Huyện Kiên Hải, Tỉnh Kiên Giang","code":"912","parent_code":"91"},"913":{"name":"U Minh Thượng","type":"huyen","slug":"u-minh-thuong","name_with_type":"Huyện U Minh Thượng","path":"Huyện U Minh Thượng, Tỉnh Kiên Giang","path_with_type":"Huyện U Minh Thượng, Tỉnh Kiên Giang","code":"913","parent_code":"91"},"914":{"name":"Giang Thành","type":"huyen","slug":"giang-thanh","name_with_type":"Huyện Giang Thành","path":"Huyện Giang Thành, Tỉnh Kiên Giang","path_with_type":"Huyện Giang Thành, Tỉnh Kiên Giang","code":"914","parent_code":"91"},"916":{"name":"Quận Ninh Kiều","type":"quan","slug":"quan-ninh-kieu","name_with_type":"Quận Ninh Kiều","path":"Quận Ninh Kiều, Thành phố Cần Thơ","path_with_type":"Quận Ninh Kiều, Thành phố Cần Thơ","code":"916","parent_code":"92"},"917":{"name":"Quận Ô Môn","type":"quan","slug":"quan-o-mon","name_with_type":"Quận Ô Môn","path":"Quận Ô Môn, Thành phố Cần Thơ","path_with_type":"Quận Ô Môn, Thành phố Cần Thơ","code":"917","parent_code":"92"},"918":{"name":"Quận Bình Thuỷ","type":"quan","slug":"quan-binh-thuy","name_with_type":"Quận Bình Thuỷ","path":"Quận Bình Thuỷ, Thành phố Cần Thơ","path_with_type":"Quận Bình Thuỷ, Thành phố Cần Thơ","code":"918","parent_code":"92"},"919":{"name":"Quận Cái Răng","type":"quan","slug":"quan-cai-rang","name_with_type":"Quận Cái Răng","path":"Quận Cái Răng, Thành phố Cần Thơ","path_with_type":"Quận Cái Răng, Thành phố Cần Thơ","code":"919","parent_code":"92"},"923":{"name":"Quận Thốt Nốt","type":"quan","slug":"quan-thot-not","name_with_type":"Quận Thốt Nốt","path":"Quận Thốt Nốt, Thành phố Cần Thơ","path_with_type":"Quận Thốt Nốt, Thành phố Cần Thơ","code":"923","parent_code":"92"},"924":{"name":"Vĩnh Thạnh","type":"huyen","slug":"vinh-thanh","name_with_type":"Huyện Vĩnh Thạnh","path":"Huyện Vĩnh Thạnh, Thành phố Cần Thơ","path_with_type":"Huyện Vĩnh Thạnh, Thành phố Cần Thơ","code":"924","parent_code":"92"},"925":{"name":"Cờ Đỏ","type":"huyen","slug":"co-do","name_with_type":"Huyện Cờ Đỏ","path":"Huyện Cờ Đỏ, Thành phố Cần Thơ","path_with_type":"Huyện Cờ Đỏ, Thành phố Cần Thơ","code":"925","parent_code":"92"},"926":{"name":"Phong Điền","type":"huyen","slug":"phong-dien","name_with_type":"Huyện Phong Điền","path":"Huyện Phong Điền, Thành phố Cần Thơ","path_with_type":"Huyện Phong Điền, Thành phố Cần Thơ","code":"926","parent_code":"92"},"927":{"name":"Thới Lai","type":"huyen","slug":"thoi-lai","name_with_type":"Huyện Thới Lai","path":"Huyện Thới Lai, Thành phố Cần Thơ","path_with_type":"Huyện Thới Lai, Thành phố Cần Thơ","code":"927","parent_code":"92"},"930":{"name":"Thành phố Vị Thanh","type":"thanh-pho","slug":"thanh-pho-vi-thanh","name_with_type":"Thành phố Vị Thanh","path":"Thành phố Vị Thanh, Tỉnh Hậu Giang","path_with_type":"Thành phố Vị Thanh, Tỉnh Hậu Giang","code":"930","parent_code":"93"},"931":{"name":"Thành phố Ngã Bảy","type":"thanh-pho","slug":"thanh-pho-nga-bay","name_with_type":"Thành phố Ngã Bảy","path":"Thành phố Ngã Bảy, Tỉnh Hậu Giang","path_with_type":"Thành phố Ngã Bảy, Tỉnh Hậu Giang","code":"931","parent_code":"93"},"932":{"name":"Châu Thành A","type":"huyen","slug":"chau-thanh-a","name_with_type":"Huyện Châu Thành A","path":"Huyện Châu Thành A, Tỉnh Hậu Giang","path_with_type":"Huyện Châu Thành A, Tỉnh Hậu Giang","code":"932","parent_code":"93"},"933":{"name":"Châu Thành","type":"huyen","slug":"chau-thanh","name_with_type":"Huyện Châu Thành","path":"Huyện Châu Thành, Tỉnh Hậu Giang","path_with_type":"Huyện Châu Thành, Tỉnh Hậu Giang","code":"933","parent_code":"93"},"934":{"name":"Phụng Hiệp","type":"huyen","slug":"phung-hiep","name_with_type":"Huyện Phụng Hiệp","path":"Huyện Phụng Hiệp, Tỉnh Hậu Giang","path_with_type":"Huyện Phụng Hiệp, Tỉnh Hậu Giang","code":"934","parent_code":"93"},"935":{"name":"Vị Thuỷ","type":"huyen","slug":"vi-thuy","name_with_type":"Huyện Vị Thuỷ","path":"Huyện Vị Thuỷ, Tỉnh Hậu Giang","path_with_type":"Huyện Vị Thuỷ, Tỉnh Hậu Giang","code":"935","parent_code":"93"},"936":{"name":"Long Mỹ","type":"huyen","slug":"long-my","name_with_type":"Huyện Long Mỹ","path":"Huyện Long Mỹ, Tỉnh Hậu Giang","path_with_type":"Huyện Long Mỹ, Tỉnh Hậu Giang","code":"936","parent_code":"93"},"937":{"name":"Thị xã Long Mỹ","type":"thi-xa","slug":"thi-xa-long-my","name_with_type":"Thị xã Long Mỹ","path":"Thị xã Long Mỹ, Tỉnh Hậu Giang","path_with_type":"Thị xã Long Mỹ, Tỉnh Hậu Giang","code":"937","parent_code":"93"},"941":{"name":"Thành phố Sóc Trăng","type":"thanh-pho","slug":"thanh-pho-soc-trang","name_with_type":"Thành phố Sóc Trăng","path":"Thành phố Sóc Trăng, Tỉnh Sóc Trăng","path_with_type":"Thành phố Sóc Trăng, Tỉnh Sóc Trăng","code":"941","parent_code":"94"},"942":{"name":"Châu Thành","type":"huyen","slug":"chau-thanh","name_with_type":"Huyện Châu Thành","path":"Huyện Châu Thành, Tỉnh Sóc Trăng","path_with_type":"Huyện Châu Thành, Tỉnh Sóc Trăng","code":"942","parent_code":"94"},"943":{"name":"Kế Sách","type":"huyen","slug":"ke-sach","name_with_type":"Huyện Kế Sách","path":"Huyện Kế Sách, Tỉnh Sóc Trăng","path_with_type":"Huyện Kế Sách, Tỉnh Sóc Trăng","code":"943","parent_code":"94"},"944":{"name":"Mỹ Tú","type":"huyen","slug":"my-tu","name_with_type":"Huyện Mỹ Tú","path":"Huyện Mỹ Tú, Tỉnh Sóc Trăng","path_with_type":"Huyện Mỹ Tú, Tỉnh Sóc Trăng","code":"944","parent_code":"94"},"945":{"name":"Cù Lao Dung","type":"huyen","slug":"cu-lao-dung","name_with_type":"Huyện Cù Lao Dung","path":"Huyện Cù Lao Dung, Tỉnh Sóc Trăng","path_with_type":"Huyện Cù Lao Dung, Tỉnh Sóc Trăng","code":"945","parent_code":"94"},"946":{"name":"Long Phú","type":"huyen","slug":"long-phu","name_with_type":"Huyện Long Phú","path":"Huyện Long Phú, Tỉnh Sóc Trăng","path_with_type":"Huyện Long Phú, Tỉnh Sóc Trăng","code":"946","parent_code":"94"},"947":{"name":"Mỹ Xuyên","type":"huyen","slug":"my-xuyen","name_with_type":"Huyện Mỹ Xuyên","path":"Huyện Mỹ Xuyên, Tỉnh Sóc Trăng","path_with_type":"Huyện Mỹ Xuyên, Tỉnh Sóc Trăng","code":"947","parent_code":"94"},"948":{"name":"Thị xã Ngã Năm","type":"thi-xa","slug":"thi-xa-nga-nam","name_with_type":"Thị xã Ngã Năm","path":"Thị xã Ngã Năm, Tỉnh Sóc Trăng","path_with_type":"Thị xã Ngã Năm, Tỉnh Sóc Trăng","code":"948","parent_code":"94"},"949":{"name":"Thạnh Trị","type":"huyen","slug":"thanh-tri","name_with_type":"Huyện Thạnh Trị","path":"Huyện Thạnh Trị, Tỉnh Sóc Trăng","path_with_type":"Huyện Thạnh Trị, Tỉnh Sóc Trăng","code":"949","parent_code":"94"},"950":{"name":"Thị xã Vĩnh Châu","type":"thi-xa","slug":"thi-xa-vinh-chau","name_with_type":"Thị xã Vĩnh Châu","path":"Thị xã Vĩnh Châu, Tỉnh Sóc Trăng","path_with_type":"Thị xã Vĩnh Châu, Tỉnh Sóc Trăng","code":"950","parent_code":"94"},"951":{"name":"Trần Đề","type":"huyen","slug":"tran-de","name_with_type":"Huyện Trần Đề","path":"Huyện Trần Đề, Tỉnh Sóc Trăng","path_with_type":"Huyện Trần Đề, Tỉnh Sóc Trăng","code":"951","parent_code":"94"},"954":{"name":"Thành phố Bạc Liêu","type":"thanh-pho","slug":"thanh-pho-bac-lieu","name_with_type":"Thành phố Bạc Liêu","path":"Thành phố Bạc Liêu, Tỉnh Bạc Liêu","path_with_type":"Thành phố Bạc Liêu, Tỉnh Bạc Liêu","code":"954","parent_code":"95"},"956":{"name":"Hồng Dân","type":"huyen","slug":"hong-dan","name_with_type":"Huyện Hồng Dân","path":"Huyện Hồng Dân, Tỉnh Bạc Liêu","path_with_type":"Huyện Hồng Dân, Tỉnh Bạc Liêu","code":"956","parent_code":"95"},"957":{"name":"Phước Long","type":"huyen","slug":"phuoc-long","name_with_type":"Huyện Phước Long","path":"Huyện Phước Long, Tỉnh Bạc Liêu","path_with_type":"Huyện Phước Long, Tỉnh Bạc Liêu","code":"957","parent_code":"95"},"958":{"name":"Vĩnh Lợi","type":"huyen","slug":"vinh-loi","name_with_type":"Huyện Vĩnh Lợi","path":"Huyện Vĩnh Lợi, Tỉnh Bạc Liêu","path_with_type":"Huyện Vĩnh Lợi, Tỉnh Bạc Liêu","code":"958","parent_code":"95"},"959":{"name":"Thị xã Giá Rai","type":"thi-xa","slug":"thi-xa-gia-rai","name_with_type":"Thị xã Giá Rai","path":"Thị xã Giá Rai, Tỉnh Bạc Liêu","path_with_type":"Thị xã Giá Rai, Tỉnh Bạc Liêu","code":"959","parent_code":"95"},"960":{"name":"Đông Hải","type":"huyen","slug":"dong-hai","name_with_type":"Huyện Đông Hải","path":"Huyện Đông Hải, Tỉnh Bạc Liêu","path_with_type":"Huyện Đông Hải, Tỉnh Bạc Liêu","code":"960","parent_code":"95"},"961":{"name":"Hoà Bình","type":"huyen","slug":"hoa-binh","name_with_type":"Huyện Hoà Bình","path":"Huyện Hoà Bình, Tỉnh Bạc Liêu","path_with_type":"Huyện Hoà Bình, Tỉnh Bạc Liêu","code":"961","parent_code":"95"},"964":{"name":"Thành phố Cà Mau","type":"thanh-pho","slug":"thanh-pho-ca-mau","name_with_type":"Thành phố Cà Mau","path":"Thành phố Cà Mau, Tỉnh Cà Mau","path_with_type":"Thành phố Cà Mau, Tỉnh Cà Mau","code":"964","parent_code":"96"},"966":{"name":"U Minh","type":"huyen","slug":"u-minh","name_with_type":"Huyện U Minh","path":"Huyện U Minh, Tỉnh Cà Mau","path_with_type":"Huyện U Minh, Tỉnh Cà Mau","code":"966","parent_code":"96"},"967":{"name":"Thới Bình","type":"huyen","slug":"thoi-binh","name_with_type":"Huyện Thới Bình","path":"Huyện Thới Bình, Tỉnh Cà Mau","path_with_type":"Huyện Thới Bình, Tỉnh Cà Mau","code":"967","parent_code":"96"},"968":{"name":"Trần Văn Thời","type":"huyen","slug":"tran-van-thoi","name_with_type":"Huyện Trần Văn Thời","path":"Huyện Trần Văn Thời, Tỉnh Cà Mau","path_with_type":"Huyện Trần Văn Thời, Tỉnh Cà Mau","code":"968","parent_code":"96"},"969":{"name":"Cái Nước","type":"huyen","slug":"cai-nuoc","name_with_type":"Huyện Cái Nước","path":"Huyện Cái Nước, Tỉnh Cà Mau","path_with_type":"Huyện Cái Nước, Tỉnh Cà Mau","code":"969","parent_code":"96"},"970":{"name":"Đầm Dơi","type":"huyen","slug":"dam-doi","name_with_type":"Huyện Đầm Dơi","path":"Huyện Đầm Dơi, Tỉnh Cà Mau","path_with_type":"Huyện Đầm Dơi, Tỉnh Cà Mau","code":"970","parent_code":"96"},"971":{"name":"Năm Căn","type":"huyen","slug":"nam-can","name_with_type":"Huyện Năm Căn","path":"Huyện Năm Căn, Tỉnh Cà Mau","path_with_type":"Huyện Năm Căn, Tỉnh Cà Mau","code":"971","parent_code":"96"},"972":{"name":"Phú Tân","type":"huyen","slug":"phu-tan","name_with_type":"Huyện Phú Tân","path":"Huyện Phú Tân, Tỉnh Cà Mau","path_with_type":"Huyện Phú Tân, Tỉnh Cà Mau","code":"972","parent_code":"96"},"973":{"name":"Ngọc Hiển","type":"huyen","slug":"ngoc-hien","name_with_type":"Huyện Ngọc Hiển","path":"Huyện Ngọc Hiển, Tỉnh Cà Mau","path_with_type":"Huyện Ngọc Hiển, Tỉnh Cà Mau","code":"973","parent_code":"96"},"001":{"name":"Quận Ba Đình","type":"quan","slug":"quan-ba-dinh","name_with_type":"Quận Ba Đình","path":"Quận Ba Đình, Thành phố Hà Nội","path_with_type":"Quận Ba Đình, Thành phố Hà Nội","code":"001","parent_code":"01"},"002":{"name":"Quận Hoàn Kiếm","type":"quan","slug":"quan-hoan-kiem","name_with_type":"Quận Hoàn Kiếm","path":"Quận Hoàn Kiếm, Thành phố Hà Nội","path_with_type":"Quận Hoàn Kiếm, Thành phố Hà Nội","code":"002","parent_code":"01"},"003":{"name":"Quận Tây Hồ","type":"quan","slug":"quan-tay-ho","name_with_type":"Quận Tây Hồ","path":"Quận Tây Hồ, Thành phố Hà Nội","path_with_type":"Quận Tây Hồ, Thành phố Hà Nội","code":"003","parent_code":"01"},"004":{"name":"Quận Long Biên","type":"quan","slug":"quan-long-bien","name_with_type":"Quận Long Biên","path":"Quận Long Biên, Thành phố Hà Nội","path_with_type":"Quận Long Biên, Thành phố Hà Nội","code":"004","parent_code":"01"},"005":{"name":"Quận Cầu Giấy","type":"quan","slug":"quan-cau-giay","name_with_type":"Quận Cầu Giấy","path":"Quận Cầu Giấy, Thành phố Hà Nội","path_with_type":"Quận Cầu Giấy, Thành phố Hà Nội","code":"005","parent_code":"01"},"006":{"name":"Quận Đống Đa","type":"quan","slug":"quan-dong-da","name_with_type":"Quận Đống Đa","path":"Quận Đống Đa, Thành phố Hà Nội","path_with_type":"Quận Đống Đa, Thành phố Hà Nội","code":"006","parent_code":"01"},"007":{"name":"Quận Hai Bà Trưng","type":"quan","slug":"quan-hai-ba-trung","name_with_type":"Quận Hai Bà Trưng","path":"Quận Hai Bà Trưng, Thành phố Hà Nội","path_with_type":"Quận Hai Bà Trưng, Thành phố Hà Nội","code":"007","parent_code":"01"},"008":{"name":"Quận Hoàng Mai","type":"quan","slug":"quan-hoang-mai","name_with_type":"Quận Hoàng Mai","path":"Quận Hoàng Mai, Thành phố Hà Nội","path_with_type":"Quận Hoàng Mai, Thành phố Hà Nội","code":"008","parent_code":"01"},"009":{"name":"Quận Thanh Xuân","type":"quan","slug":"quan-thanh-xuan","name_with_type":"Quận Thanh Xuân","path":"Quận Thanh Xuân, Thành phố Hà Nội","path_with_type":"Quận Thanh Xuân, Thành phố Hà Nội","code":"009","parent_code":"01"},"016":{"name":"Sóc Sơn","type":"huyen","slug":"soc-son","name_with_type":"Huyện Sóc Sơn","path":"Huyện Sóc Sơn, Thành phố Hà Nội","path_with_type":"Huyện Sóc Sơn, Thành phố Hà Nội","code":"016","parent_code":"01"},"017":{"name":"Đông Anh","type":"huyen","slug":"dong-anh","name_with_type":"Huyện Đông Anh","path":"Huyện Đông Anh, Thành phố Hà Nội","path_with_type":"Huyện Đông Anh, Thành phố Hà Nội","code":"017","parent_code":"01"},"018":{"name":"Gia Lâm","type":"huyen","slug":"gia-lam","name_with_type":"Huyện Gia Lâm","path":"Huyện Gia Lâm, Thành phố Hà Nội","path_with_type":"Huyện Gia Lâm, Thành phố Hà Nội","code":"018","parent_code":"01"},"019":{"name":"Quận Nam Từ Liêm","type":"quan","slug":"quan-nam-tu-liem","name_with_type":"Quận Nam Từ Liêm","path":"Quận Nam Từ Liêm, Thành phố Hà Nội","path_with_type":"Quận Nam Từ Liêm, Thành phố Hà Nội","code":"019","parent_code":"01"},"020":{"name":"Thanh Trì","type":"huyen","slug":"thanh-tri","name_with_type":"Huyện Thanh Trì","path":"Huyện Thanh Trì, Thành phố Hà Nội","path_with_type":"Huyện Thanh Trì, Thành phố Hà Nội","code":"020","parent_code":"01"},"021":{"name":"Quận Bắc Từ Liêm","type":"quan","slug":"quan-bac-tu-liem","name_with_type":"Quận Bắc Từ Liêm","path":"Quận Bắc Từ Liêm, Thành phố Hà Nội","path_with_type":"Quận Bắc Từ Liêm, Thành phố Hà Nội","code":"021","parent_code":"01"},"024":{"name":"Thành phố Hà Giang","type":"thanh-pho","slug":"thanh-pho-ha-giang","name_with_type":"Thành phố Hà Giang","path":"Thành phố Hà Giang, Tỉnh Hà Giang","path_with_type":"Thành phố Hà Giang, Tỉnh Hà Giang","code":"024","parent_code":"02"},"026":{"name":"Đồng Văn","type":"huyen","slug":"dong-van","name_with_type":"Huyện Đồng Văn","path":"Huyện Đồng Văn, Tỉnh Hà Giang","path_with_type":"Huyện Đồng Văn, Tỉnh Hà Giang","code":"026","parent_code":"02"},"027":{"name":"Mèo Vạc","type":"huyen","slug":"meo-vac","name_with_type":"Huyện Mèo Vạc","path":"Huyện Mèo Vạc, Tỉnh Hà Giang","path_with_type":"Huyện Mèo Vạc, Tỉnh Hà Giang","code":"027","parent_code":"02"},"028":{"name":"Yên Minh","type":"huyen","slug":"yen-minh","name_with_type":"Huyện Yên Minh","path":"Huyện Yên Minh, Tỉnh Hà Giang","path_with_type":"Huyện Yên Minh, Tỉnh Hà Giang","code":"028","parent_code":"02"},"029":{"name":"Quản Bạ","type":"huyen","slug":"quan-ba","name_with_type":"Huyện Quản Bạ","path":"Huyện Quản Bạ, Tỉnh Hà Giang","path_with_type":"Huyện Quản Bạ, Tỉnh Hà Giang","code":"029","parent_code":"02"},"030":{"name":"Vị Xuyên","type":"huyen","slug":"vi-xuyen","name_with_type":"Huyện Vị Xuyên","path":"Huyện Vị Xuyên, Tỉnh Hà Giang","path_with_type":"Huyện Vị Xuyên, Tỉnh Hà Giang","code":"030","parent_code":"02"},"031":{"name":"Bắc Mê","type":"huyen","slug":"bac-me","name_with_type":"Huyện Bắc Mê","path":"Huyện Bắc Mê, Tỉnh Hà Giang","path_with_type":"Huyện Bắc Mê, Tỉnh Hà Giang","code":"031","parent_code":"02"},"032":{"name":"Hoàng Su Phì","type":"huyen","slug":"hoang-su-phi","name_with_type":"Huyện Hoàng Su Phì","path":"Huyện Hoàng Su Phì, Tỉnh Hà Giang","path_with_type":"Huyện Hoàng Su Phì, Tỉnh Hà Giang","code":"032","parent_code":"02"},"033":{"name":"Xín Mần","type":"huyen","slug":"xin-man","name_with_type":"Huyện Xín Mần","path":"Huyện Xín Mần, Tỉnh Hà Giang","path_with_type":"Huyện Xín Mần, Tỉnh Hà Giang","code":"033","parent_code":"02"},"034":{"name":"Bắc Quang","type":"huyen","slug":"bac-quang","name_with_type":"Huyện Bắc Quang","path":"Huyện Bắc Quang, Tỉnh Hà Giang","path_with_type":"Huyện Bắc Quang, Tỉnh Hà Giang","code":"034","parent_code":"02"},"035":{"name":"Quang Bình","type":"huyen","slug":"quang-binh","name_with_type":"Huyện Quang Bình","path":"Huyện Quang Bình, Tỉnh Hà Giang","path_with_type":"Huyện Quang Bình, Tỉnh Hà Giang","code":"035","parent_code":"02"},"040":{"name":"Thành phố Cao Bằng","type":"thanh-pho","slug":"thanh-pho-cao-bang","name_with_type":"Thành phố Cao Bằng","path":"Thành phố Cao Bằng, Tỉnh Cao Bằng","path_with_type":"Thành phố Cao Bằng, Tỉnh Cao Bằng","code":"040","parent_code":"04"},"042":{"name":"Bảo Lâm","type":"huyen","slug":"bao-lam","name_with_type":"Huyện Bảo Lâm","path":"Huyện Bảo Lâm, Tỉnh Cao Bằng","path_with_type":"Huyện Bảo Lâm, Tỉnh Cao Bằng","code":"042","parent_code":"04"},"043":{"name":"Bảo Lạc","type":"huyen","slug":"bao-lac","name_with_type":"Huyện Bảo Lạc","path":"Huyện Bảo Lạc, Tỉnh Cao Bằng","path_with_type":"Huyện Bảo Lạc, Tỉnh Cao Bằng","code":"043","parent_code":"04"},"045":{"name":"Hà Quảng","type":"huyen","slug":"ha-quang","name_with_type":"Huyện Hà Quảng","path":"Huyện Hà Quảng, Tỉnh Cao Bằng","path_with_type":"Huyện Hà Quảng, Tỉnh Cao Bằng","code":"045","parent_code":"04"},"047":{"name":"Trùng Khánh","type":"huyen","slug":"trung-khanh","name_with_type":"Huyện Trùng Khánh","path":"Huyện Trùng Khánh, Tỉnh Cao Bằng","path_with_type":"Huyện Trùng Khánh, Tỉnh Cao Bằng","code":"047","parent_code":"04"},"048":{"name":"Hạ Lang","type":"huyen","slug":"ha-lang","name_with_type":"Huyện Hạ Lang","path":"Huyện Hạ Lang, Tỉnh Cao Bằng","path_with_type":"Huyện Hạ Lang, Tỉnh Cao Bằng","code":"048","parent_code":"04"},"049":{"name":"Quảng Hòa","type":"huyen","slug":"quang-hoa","name_with_type":"Huyện Quảng Hòa","path":"Huyện Quảng Hòa, Tỉnh Cao Bằng","path_with_type":"Huyện Quảng Hòa, Tỉnh Cao Bằng","code":"049","parent_code":"04"},"051":{"name":"Hoà An","type":"huyen","slug":"hoa-an","name_with_type":"Huyện Hoà An","path":"Huyện Hoà An, Tỉnh Cao Bằng","path_with_type":"Huyện Hoà An, Tỉnh Cao Bằng","code":"051","parent_code":"04"},"052":{"name":"Nguyên Bình","type":"huyen","slug":"nguyen-binh","name_with_type":"Huyện Nguyên Bình","path":"Huyện Nguyên Bình, Tỉnh Cao Bằng","path_with_type":"Huyện Nguyên Bình, Tỉnh Cao Bằng","code":"052","parent_code":"04"},"053":{"name":"Thạch An","type":"huyen","slug":"thach-an","name_with_type":"Huyện Thạch An","path":"Huyện Thạch An, Tỉnh Cao Bằng","path_with_type":"Huyện Thạch An, Tỉnh Cao Bằng","code":"053","parent_code":"04"},"058":{"name":"Thành Phố Bắc Kạn","type":"thanh-pho","slug":"thanh-pho-bac-kan","name_with_type":"Thành Phố Bắc Kạn","path":"Thành Phố Bắc Kạn, Tỉnh Bắc Kạn","path_with_type":"Thành Phố Bắc Kạn, Tỉnh Bắc Kạn","code":"058","parent_code":"06"},"060":{"name":"Pác Nặm","type":"huyen","slug":"pac-nam","name_with_type":"Huyện Pác Nặm","path":"Huyện Pác Nặm, Tỉnh Bắc Kạn","path_with_type":"Huyện Pác Nặm, Tỉnh Bắc Kạn","code":"060","parent_code":"06"},"061":{"name":"Ba Bể","type":"huyen","slug":"ba-be","name_with_type":"Huyện Ba Bể","path":"Huyện Ba Bể, Tỉnh Bắc Kạn","path_with_type":"Huyện Ba Bể, Tỉnh Bắc Kạn","code":"061","parent_code":"06"},"062":{"name":"Ngân Sơn","type":"huyen","slug":"ngan-son","name_with_type":"Huyện Ngân Sơn","path":"Huyện Ngân Sơn, Tỉnh Bắc Kạn","path_with_type":"Huyện Ngân Sơn, Tỉnh Bắc Kạn","code":"062","parent_code":"06"},"063":{"name":"Bạch Thông","type":"huyen","slug":"bach-thong","name_with_type":"Huyện Bạch Thông","path":"Huyện Bạch Thông, Tỉnh Bắc Kạn","path_with_type":"Huyện Bạch Thông, Tỉnh Bắc Kạn","code":"063","parent_code":"06"},"064":{"name":"Chợ Đồn","type":"huyen","slug":"cho-don","name_with_type":"Huyện Chợ Đồn","path":"Huyện Chợ Đồn, Tỉnh Bắc Kạn","path_with_type":"Huyện Chợ Đồn, Tỉnh Bắc Kạn","code":"064","parent_code":"06"},"065":{"name":"Chợ Mới","type":"huyen","slug":"cho-moi","name_with_type":"Huyện Chợ Mới","path":"Huyện Chợ Mới, Tỉnh Bắc Kạn","path_with_type":"Huyện Chợ Mới, Tỉnh Bắc Kạn","code":"065","parent_code":"06"},"066":{"name":"Na Rì","type":"huyen","slug":"na-ri","name_with_type":"Huyện Na Rì","path":"Huyện Na Rì, Tỉnh Bắc Kạn","path_with_type":"Huyện Na Rì, Tỉnh Bắc Kạn","code":"066","parent_code":"06"},"070":{"name":"Thành phố Tuyên Quang","type":"thanh-pho","slug":"thanh-pho-tuyen-quang","name_with_type":"Thành phố Tuyên Quang","path":"Thành phố Tuyên Quang, Tỉnh Tuyên Quang","path_with_type":"Thành phố Tuyên Quang, Tỉnh Tuyên Quang","code":"070","parent_code":"08"},"071":{"name":"Lâm Bình","type":"huyen","slug":"lam-binh","name_with_type":"Huyện Lâm Bình","path":"Huyện Lâm Bình, Tỉnh Tuyên Quang","path_with_type":"Huyện Lâm Bình, Tỉnh Tuyên Quang","code":"071","parent_code":"08"},"072":{"name":"Na Hang","type":"huyen","slug":"na-hang","name_with_type":"Huyện Na Hang","path":"Huyện Na Hang, Tỉnh Tuyên Quang","path_with_type":"Huyện Na Hang, Tỉnh Tuyên Quang","code":"072","parent_code":"08"},"073":{"name":"Chiêm Hóa","type":"huyen","slug":"chiem-hoa","name_with_type":"Huyện Chiêm Hóa","path":"Huyện Chiêm Hóa, Tỉnh Tuyên Quang","path_with_type":"Huyện Chiêm Hóa, Tỉnh Tuyên Quang","code":"073","parent_code":"08"},"074":{"name":"Hàm Yên","type":"huyen","slug":"ham-yen","name_with_type":"Huyện Hàm Yên","path":"Huyện Hàm Yên, Tỉnh Tuyên Quang","path_with_type":"Huyện Hàm Yên, Tỉnh Tuyên Quang","code":"074","parent_code":"08"},"075":{"name":"Yên Sơn","type":"huyen","slug":"yen-son","name_with_type":"Huyện Yên Sơn","path":"Huyện Yên Sơn, Tỉnh Tuyên Quang","path_with_type":"Huyện Yên Sơn, Tỉnh Tuyên Quang","code":"075","parent_code":"08"},"076":{"name":"Sơn Dương","type":"huyen","slug":"son-duong","name_with_type":"Huyện Sơn Dương","path":"Huyện Sơn Dương, Tỉnh Tuyên Quang","path_with_type":"Huyện Sơn Dương, Tỉnh Tuyên Quang","code":"076","parent_code":"08"},"080":{"name":"Thành phố Lào Cai","type":"thanh-pho","slug":"thanh-pho-lao-cai","name_with_type":"Thành phố Lào Cai","path":"Thành phố Lào Cai, Tỉnh Lào Cai","path_with_type":"Thành phố Lào Cai, Tỉnh Lào Cai","code":"080","parent_code":"10"},"082":{"name":"Bát Xát","type":"huyen","slug":"bat-xat","name_with_type":"Huyện Bát Xát","path":"Huyện Bát Xát, Tỉnh Lào Cai","path_with_type":"Huyện Bát Xát, Tỉnh Lào Cai","code":"082","parent_code":"10"},"083":{"name":"Mường Khương","type":"huyen","slug":"muong-khuong","name_with_type":"Huyện Mường Khương","path":"Huyện Mường Khương, Tỉnh Lào Cai","path_with_type":"Huyện Mường Khương, Tỉnh Lào Cai","code":"083","parent_code":"10"},"084":{"name":"Si Ma Cai","type":"huyen","slug":"si-ma-cai","name_with_type":"Huyện Si Ma Cai","path":"Huyện Si Ma Cai, Tỉnh Lào Cai","path_with_type":"Huyện Si Ma Cai, Tỉnh Lào Cai","code":"084","parent_code":"10"},"085":{"name":"Bắc Hà","type":"huyen","slug":"bac-ha","name_with_type":"Huyện Bắc Hà","path":"Huyện Bắc Hà, Tỉnh Lào Cai","path_with_type":"Huyện Bắc Hà, Tỉnh Lào Cai","code":"085","parent_code":"10"},"086":{"name":"Bảo Thắng","type":"huyen","slug":"bao-thang","name_with_type":"Huyện Bảo Thắng","path":"Huyện Bảo Thắng, Tỉnh Lào Cai","path_with_type":"Huyện Bảo Thắng, Tỉnh Lào Cai","code":"086","parent_code":"10"},"087":{"name":"Bảo Yên","type":"huyen","slug":"bao-yen","name_with_type":"Huyện Bảo Yên","path":"Huyện Bảo Yên, Tỉnh Lào Cai","path_with_type":"Huyện Bảo Yên, Tỉnh Lào Cai","code":"087","parent_code":"10"},"088":{"name":"Thị xã Sa Pa","type":"thi-xa","slug":"thi-xa-sa-pa","name_with_type":"Thị xã Sa Pa","path":"Thị xã Sa Pa, Tỉnh Lào Cai","path_with_type":"Thị xã Sa Pa, Tỉnh Lào Cai","code":"088","parent_code":"10"},"089":{"name":"Văn Bàn","type":"huyen","slug":"van-ban","name_with_type":"Huyện Văn Bàn","path":"Huyện Văn Bàn, Tỉnh Lào Cai","path_with_type":"Huyện Văn Bàn, Tỉnh Lào Cai","code":"089","parent_code":"10"},"094":{"name":"Thành phố Điện Biên Phủ","type":"thanh-pho","slug":"thanh-pho-dien-bien-phu","name_with_type":"Thành phố Điện Biên Phủ","path":"Thành phố Điện Biên Phủ, Tỉnh Điện Biên","path_with_type":"Thành phố Điện Biên Phủ, Tỉnh Điện Biên","code":"094","parent_code":"11"},"095":{"name":"Thị Xã Mường Lay","type":"thi-xa","slug":"thi-xa-muong-lay","name_with_type":"Thị Xã Mường Lay","path":"Thị Xã Mường Lay, Tỉnh Điện Biên","path_with_type":"Thị Xã Mường Lay, Tỉnh Điện Biên","code":"095","parent_code":"11"},"096":{"name":"Mường Nhé","type":"huyen","slug":"muong-nhe","name_with_type":"Huyện Mường Nhé","path":"Huyện Mường Nhé, Tỉnh Điện Biên","path_with_type":"Huyện Mường Nhé, Tỉnh Điện Biên","code":"096","parent_code":"11"},"097":{"name":"Mường Chà","type":"huyen","slug":"muong-cha","name_with_type":"Huyện Mường Chà","path":"Huyện Mường Chà, Tỉnh Điện Biên","path_with_type":"Huyện Mường Chà, Tỉnh Điện Biên","code":"097","parent_code":"11"},"098":{"name":"Tủa Chùa","type":"huyen","slug":"tua-chua","name_with_type":"Huyện Tủa Chùa","path":"Huyện Tủa Chùa, Tỉnh Điện Biên","path_with_type":"Huyện Tủa Chùa, Tỉnh Điện Biên","code":"098","parent_code":"11"},"099":{"name":"Tuần Giáo","type":"huyen","slug":"tuan-giao","name_with_type":"Huyện Tuần Giáo","path":"Huyện Tuần Giáo, Tỉnh Điện Biên","path_with_type":"Huyện Tuần Giáo, Tỉnh Điện Biên","code":"099","parent_code":"11"}}');
;// CONCATENATED MODULE: ./app/dummy/xa_phuong.json
var xa_phuong_namespaceObject = JSON.parse('{"10000":{"name":"Xã Tân Xã","type":"xa","slug":"xa-tan-xa","name_with_type":"Xã Tân Xã","path":"Xã Tân Xã, Huyện Thạch Thất, Thành phố Hà Nội","path_with_type":"Xã Tân Xã, Huyện Thạch Thất, Thành phố Hà Nội","code":"10000","parent_code":"276"},"10003":{"name":"Xã Thạch Xá","type":"xa","slug":"xa-thach-xa","name_with_type":"Xã Thạch Xá","path":"Xã Thạch Xá, Huyện Thạch Thất, Thành phố Hà Nội","path_with_type":"Xã Thạch Xá, Huyện Thạch Thất, Thành phố Hà Nội","code":"10003","parent_code":"276"},"10006":{"name":"Xã Quang Trung","type":"xa","slug":"xa-quang-trung","name_with_type":"Xã Quang Trung","path":"Xã Quang Trung, Huyện Thạch Thất, Thành phố Hà Nội","path_with_type":"Xã Quang Trung, Huyện Thạch Thất, Thành phố Hà Nội","code":"10006","parent_code":"276"},"10009":{"name":"Xã Hạ Bằng","type":"xa","slug":"xa-ha-bang","name_with_type":"Xã Hạ Bằng","path":"Xã Hạ Bằng, Huyện Thạch Thất, Thành phố Hà Nội","path_with_type":"Xã Hạ Bằng, Huyện Thạch Thất, Thành phố Hà Nội","code":"10009","parent_code":"276"},"10012":{"name":"Xã Đồng Trúc","type":"xa","slug":"xa-dong-truc","name_with_type":"Xã Đồng Trúc","path":"Xã Đồng Trúc, Huyện Thạch Thất, Thành phố Hà Nội","path_with_type":"Xã Đồng Trúc, Huyện Thạch Thất, Thành phố Hà Nội","code":"10012","parent_code":"276"},"10015":{"name":"Thị trấn Chúc Sơn","type":"thi-tran","slug":"thi-tran-chuc-son","name_with_type":"Thị trấn Chúc Sơn","path":"Thị trấn Chúc Sơn, Huyện Chương Mỹ, Thành phố Hà Nội","path_with_type":"Thị trấn Chúc Sơn, Huyện Chương Mỹ, Thành phố Hà Nội","code":"10015","parent_code":"277"},"10018":{"name":"Thị trấn Xuân Mai","type":"thi-tran","slug":"thi-tran-xuan-mai","name_with_type":"Thị trấn Xuân Mai","path":"Thị trấn Xuân Mai, Huyện Chương Mỹ, Thành phố Hà Nội","path_with_type":"Thị trấn Xuân Mai, Huyện Chương Mỹ, Thành phố Hà Nội","code":"10018","parent_code":"277"},"10021":{"name":"Xã Phụng Châu","type":"xa","slug":"xa-phung-chau","name_with_type":"Xã Phụng Châu","path":"Xã Phụng Châu, Huyện Chương Mỹ, Thành phố Hà Nội","path_with_type":"Xã Phụng Châu, Huyện Chương Mỹ, Thành phố Hà Nội","code":"10021","parent_code":"277"},"10024":{"name":"Xã Tiên Phương","type":"xa","slug":"xa-tien-phuong","name_with_type":"Xã Tiên Phương","path":"Xã Tiên Phương, Huyện Chương Mỹ, Thành phố Hà Nội","path_with_type":"Xã Tiên Phương, Huyện Chương Mỹ, Thành phố Hà Nội","code":"10024","parent_code":"277"},"10027":{"name":"Xã Đông Sơn","type":"xa","slug":"xa-dong-son","name_with_type":"Xã Đông Sơn","path":"Xã Đông Sơn, Huyện Chương Mỹ, Thành phố Hà Nội","path_with_type":"Xã Đông Sơn, Huyện Chương Mỹ, Thành phố Hà Nội","code":"10027","parent_code":"277"},"10030":{"name":"Xã Đông Phương Yên","type":"xa","slug":"xa-dong-phuong-yen","name_with_type":"Xã Đông Phương Yên","path":"Xã Đông Phương Yên, Huyện Chương Mỹ, Thành phố Hà Nội","path_with_type":"Xã Đông Phương Yên, Huyện Chương Mỹ, Thành phố Hà Nội","code":"10030","parent_code":"277"},"10033":{"name":"Xã Phú Nghĩa","type":"xa","slug":"xa-phu-nghia","name_with_type":"Xã Phú Nghĩa","path":"Xã Phú Nghĩa, Huyện Chương Mỹ, Thành phố Hà Nội","path_with_type":"Xã Phú Nghĩa, Huyện Chương Mỹ, Thành phố Hà Nội","code":"10033","parent_code":"277"},"10039":{"name":"Xã Trường Yên","type":"xa","slug":"xa-truong-yen","name_with_type":"Xã Trường Yên","path":"Xã Trường Yên, Huyện Chương Mỹ, Thành phố Hà Nội","path_with_type":"Xã Trường Yên, Huyện Chương Mỹ, Thành phố Hà Nội","code":"10039","parent_code":"277"},"10042":{"name":"Xã Ngọc Hòa","type":"xa","slug":"xa-ngoc-hoa","name_with_type":"Xã Ngọc Hòa","path":"Xã Ngọc Hòa, Huyện Chương Mỹ, Thành phố Hà Nội","path_with_type":"Xã Ngọc Hòa, Huyện Chương Mỹ, Thành phố Hà Nội","code":"10042","parent_code":"277"},"10045":{"name":"Xã Thủy Xuân Tiên","type":"xa","slug":"xa-thuy-xuan-tien","name_with_type":"Xã Thủy Xuân Tiên","path":"Xã Thủy Xuân Tiên, Huyện Chương Mỹ, Thành phố Hà Nội","path_with_type":"Xã Thủy Xuân Tiên, Huyện Chương Mỹ, Thành phố Hà Nội","code":"10045","parent_code":"277"},"10048":{"name":"Xã Thanh Bình","type":"xa","slug":"xa-thanh-binh","name_with_type":"Xã Thanh Bình","path":"Xã Thanh Bình, Huyện Chương Mỹ, Thành phố Hà Nội","path_with_type":"Xã Thanh Bình, Huyện Chương Mỹ, Thành phố Hà Nội","code":"10048","parent_code":"277"},"10051":{"name":"Xã Trung Hòa","type":"xa","slug":"xa-trung-hoa","name_with_type":"Xã Trung Hòa","path":"Xã Trung Hòa, Huyện Chương Mỹ, Thành phố Hà Nội","path_with_type":"Xã Trung Hòa, Huyện Chương Mỹ, Thành phố Hà Nội","code":"10051","parent_code":"277"},"10054":{"name":"Xã Đại Yên","type":"xa","slug":"xa-dai-yen","name_with_type":"Xã Đại Yên","path":"Xã Đại Yên, Huyện Chương Mỹ, Thành phố Hà Nội","path_with_type":"Xã Đại Yên, Huyện Chương Mỹ, Thành phố Hà Nội","code":"10054","parent_code":"277"},"10057":{"name":"Xã Thụy Hương","type":"xa","slug":"xa-thuy-huong","name_with_type":"Xã Thụy Hương","path":"Xã Thụy Hương, Huyện Chương Mỹ, Thành phố Hà Nội","path_with_type":"Xã Thụy Hương, Huyện Chương Mỹ, Thành phố Hà Nội","code":"10057","parent_code":"277"},"10060":{"name":"Xã Tốt Động","type":"xa","slug":"xa-tot-dong","name_with_type":"Xã Tốt Động","path":"Xã Tốt Động, Huyện Chương Mỹ, Thành phố Hà Nội","path_with_type":"Xã Tốt Động, Huyện Chương Mỹ, Thành phố Hà Nội","code":"10060","parent_code":"277"},"10063":{"name":"Xã Lam Điền","type":"xa","slug":"xa-lam-dien","name_with_type":"Xã Lam Điền","path":"Xã Lam Điền, Huyện Chương Mỹ, Thành phố Hà Nội","path_with_type":"Xã Lam Điền, Huyện Chương Mỹ, Thành phố Hà Nội","code":"10063","parent_code":"277"},"10066":{"name":"Xã Tân Tiến","type":"xa","slug":"xa-tan-tien","name_with_type":"Xã Tân Tiến","path":"Xã Tân Tiến, Huyện Chương Mỹ, Thành phố Hà Nội","path_with_type":"Xã Tân Tiến, Huyện Chương Mỹ, Thành phố Hà Nội","code":"10066","parent_code":"277"},"10069":{"name":"Xã Nam Phương Tiến","type":"xa","slug":"xa-nam-phuong-tien","name_with_type":"Xã Nam Phương Tiến","path":"Xã Nam Phương Tiến, Huyện Chương Mỹ, Thành phố Hà Nội","path_with_type":"Xã Nam Phương Tiến, Huyện Chương Mỹ, Thành phố Hà Nội","code":"10069","parent_code":"277"},"10072":{"name":"Xã Hợp Đồng","type":"xa","slug":"xa-hop-dong","name_with_type":"Xã Hợp Đồng","path":"Xã Hợp Đồng, Huyện Chương Mỹ, Thành phố Hà Nội","path_with_type":"Xã Hợp Đồng, Huyện Chương Mỹ, Thành phố Hà Nội","code":"10072","parent_code":"277"},"10075":{"name":"Xã Hoàng Văn Thụ","type":"xa","slug":"xa-hoang-van-thu","name_with_type":"Xã Hoàng Văn Thụ","path":"Xã Hoàng Văn Thụ, Huyện Chương Mỹ, Thành phố Hà Nội","path_with_type":"Xã Hoàng Văn Thụ, Huyện Chương Mỹ, Thành phố Hà Nội","code":"10075","parent_code":"277"},"10078":{"name":"Xã Hoàng Diệu","type":"xa","slug":"xa-hoang-dieu","name_with_type":"Xã Hoàng Diệu","path":"Xã Hoàng Diệu, Huyện Chương Mỹ, Thành phố Hà Nội","path_with_type":"Xã Hoàng Diệu, Huyện Chương Mỹ, Thành phố Hà Nội","code":"10078","parent_code":"277"},"10081":{"name":"Xã Hữu Văn","type":"xa","slug":"xa-huu-van","name_with_type":"Xã Hữu Văn","path":"Xã Hữu Văn, Huyện Chương Mỹ, Thành phố Hà Nội","path_with_type":"Xã Hữu Văn, Huyện Chương Mỹ, Thành phố Hà Nội","code":"10081","parent_code":"277"},"10084":{"name":"Xã Quảng Bị","type":"xa","slug":"xa-quang-bi","name_with_type":"Xã Quảng Bị","path":"Xã Quảng Bị, Huyện Chương Mỹ, Thành phố Hà Nội","path_with_type":"Xã Quảng Bị, Huyện Chương Mỹ, Thành phố Hà Nội","code":"10084","parent_code":"277"},"10087":{"name":"Xã Mỹ Lương","type":"xa","slug":"xa-my-luong","name_with_type":"Xã Mỹ Lương","path":"Xã Mỹ Lương, Huyện Chương Mỹ, Thành phố Hà Nội","path_with_type":"Xã Mỹ Lương, Huyện Chương Mỹ, Thành phố Hà Nội","code":"10087","parent_code":"277"},"10090":{"name":"Xã Thượng Vực","type":"xa","slug":"xa-thuong-vuc","name_with_type":"Xã Thượng Vực","path":"Xã Thượng Vực, Huyện Chương Mỹ, Thành phố Hà Nội","path_with_type":"Xã Thượng Vực, Huyện Chương Mỹ, Thành phố Hà Nội","code":"10090","parent_code":"277"},"10096":{"name":"Xã Hồng Phú","type":"xa","slug":"xa-hong-phu","name_with_type":"Xã Hồng Phú","path":"Xã Hồng Phú, Huyện Chương Mỹ, Thành phố Hà Nội","path_with_type":"Xã Hồng Phú, Huyện Chương Mỹ, Thành phố Hà Nội","code":"10096","parent_code":"277"},"10099":{"name":"Xã Trần Phú","type":"xa","slug":"xa-tran-phu","name_with_type":"Xã Trần Phú","path":"Xã Trần Phú, Huyện Chương Mỹ, Thành phố Hà Nội","path_with_type":"Xã Trần Phú, Huyện Chương Mỹ, Thành phố Hà Nội","code":"10099","parent_code":"277"},"10102":{"name":"Xã Văn Võ","type":"xa","slug":"xa-van-vo","name_with_type":"Xã Văn Võ","path":"Xã Văn Võ, Huyện Chương Mỹ, Thành phố Hà Nội","path_with_type":"Xã Văn Võ, Huyện Chương Mỹ, Thành phố Hà Nội","code":"10102","parent_code":"277"},"10105":{"name":"Xã Đồng Lạc","type":"xa","slug":"xa-dong-lac","name_with_type":"Xã Đồng Lạc","path":"Xã Đồng Lạc, Huyện Chương Mỹ, Thành phố Hà Nội","path_with_type":"Xã Đồng Lạc, Huyện Chương Mỹ, Thành phố Hà Nội","code":"10105","parent_code":"277"},"10108":{"name":"Xã Hòa Phú","type":"xa","slug":"xa-hoa-phu","name_with_type":"Xã Hòa Phú","path":"Xã Hòa Phú, Huyện Chương Mỹ, Thành phố Hà Nội","path_with_type":"Xã Hòa Phú, Huyện Chương Mỹ, Thành phố Hà Nội","code":"10108","parent_code":"277"},"10114":{"name":"Thị trấn Kim Bài","type":"thi-tran","slug":"thi-tran-kim-bai","name_with_type":"Thị trấn Kim Bài","path":"Thị trấn Kim Bài, Huyện Thanh Oai, Thành phố Hà Nội","path_with_type":"Thị trấn Kim Bài, Huyện Thanh Oai, Thành phố Hà Nội","code":"10114","parent_code":"278"},"10117":{"name":"Phường Đồng Mai","type":"phuong","slug":"phuong-dong-mai","name_with_type":"Phường Đồng Mai","path":"Phường Đồng Mai, Quận Hà Đông, Thành phố Hà Nội","path_with_type":"Phường Đồng Mai, Quận Hà Đông, Thành phố Hà Nội","code":"10117","parent_code":"268"},"10120":{"name":"Xã Cự Khê","type":"xa","slug":"xa-cu-khe","name_with_type":"Xã Cự Khê","path":"Xã Cự Khê, Huyện Thanh Oai, Thành phố Hà Nội","path_with_type":"Xã Cự Khê, Huyện Thanh Oai, Thành phố Hà Nội","code":"10120","parent_code":"278"},"10123":{"name":"Phường Biên Giang","type":"phuong","slug":"phuong-bien-giang","name_with_type":"Phường Biên Giang","path":"Phường Biên Giang, Quận Hà Đông, Thành phố Hà Nội","path_with_type":"Phường Biên Giang, Quận Hà Đông, Thành phố Hà Nội","code":"10123","parent_code":"268"},"10126":{"name":"Xã Bích Hòa","type":"xa","slug":"xa-bich-hoa","name_with_type":"Xã Bích Hòa","path":"Xã Bích Hòa, Huyện Thanh Oai, Thành phố Hà Nội","path_with_type":"Xã Bích Hòa, Huyện Thanh Oai, Thành phố Hà Nội","code":"10126","parent_code":"278"},"10129":{"name":"Xã Mỹ Hưng","type":"xa","slug":"xa-my-hung","name_with_type":"Xã Mỹ Hưng","path":"Xã Mỹ Hưng, Huyện Thanh Oai, Thành phố Hà Nội","path_with_type":"Xã Mỹ Hưng, Huyện Thanh Oai, Thành phố Hà Nội","code":"10129","parent_code":"278"},"10132":{"name":"Xã Cao Viên","type":"xa","slug":"xa-cao-vien","name_with_type":"Xã Cao Viên","path":"Xã Cao Viên, Huyện Thanh Oai, Thành phố Hà Nội","path_with_type":"Xã Cao Viên, Huyện Thanh Oai, Thành phố Hà Nội","code":"10132","parent_code":"278"},"10135":{"name":"Xã Bình Minh","type":"xa","slug":"xa-binh-minh","name_with_type":"Xã Bình Minh","path":"Xã Bình Minh, Huyện Thanh Oai, Thành phố Hà Nội","path_with_type":"Xã Bình Minh, Huyện Thanh Oai, Thành phố Hà Nội","code":"10135","parent_code":"278"},"10138":{"name":"Xã Tam Hưng","type":"xa","slug":"xa-tam-hung","name_with_type":"Xã Tam Hưng","path":"Xã Tam Hưng, Huyện Thanh Oai, Thành phố Hà Nội","path_with_type":"Xã Tam Hưng, Huyện Thanh Oai, Thành phố Hà Nội","code":"10138","parent_code":"278"},"10141":{"name":"Xã Thanh Cao","type":"xa","slug":"xa-thanh-cao","name_with_type":"Xã Thanh Cao","path":"Xã Thanh Cao, Huyện Thanh Oai, Thành phố Hà Nội","path_with_type":"Xã Thanh Cao, Huyện Thanh Oai, Thành phố Hà Nội","code":"10141","parent_code":"278"},"10144":{"name":"Xã Thanh Thùy","type":"xa","slug":"xa-thanh-thuy","name_with_type":"Xã Thanh Thùy","path":"Xã Thanh Thùy, Huyện Thanh Oai, Thành phố Hà Nội","path_with_type":"Xã Thanh Thùy, Huyện Thanh Oai, Thành phố Hà Nội","code":"10144","parent_code":"278"},"10147":{"name":"Xã Thanh Mai","type":"xa","slug":"xa-thanh-mai","name_with_type":"Xã Thanh Mai","path":"Xã Thanh Mai, Huyện Thanh Oai, Thành phố Hà Nội","path_with_type":"Xã Thanh Mai, Huyện Thanh Oai, Thành phố Hà Nội","code":"10147","parent_code":"278"},"10150":{"name":"Xã Thanh Văn","type":"xa","slug":"xa-thanh-van","name_with_type":"Xã Thanh Văn","path":"Xã Thanh Văn, Huyện Thanh Oai, Thành phố Hà Nội","path_with_type":"Xã Thanh Văn, Huyện Thanh Oai, Thành phố Hà Nội","code":"10150","parent_code":"278"},"10153":{"name":"Xã Đỗ Động","type":"xa","slug":"xa-do-dong","name_with_type":"Xã Đỗ Động","path":"Xã Đỗ Động, Huyện Thanh Oai, Thành phố Hà Nội","path_with_type":"Xã Đỗ Động, Huyện Thanh Oai, Thành phố Hà Nội","code":"10153","parent_code":"278"},"10156":{"name":"Xã Kim An","type":"xa","slug":"xa-kim-an","name_with_type":"Xã Kim An","path":"Xã Kim An, Huyện Thanh Oai, Thành phố Hà Nội","path_with_type":"Xã Kim An, Huyện Thanh Oai, Thành phố Hà Nội","code":"10156","parent_code":"278"},"10159":{"name":"Xã Kim Thư","type":"xa","slug":"xa-kim-thu","name_with_type":"Xã Kim Thư","path":"Xã Kim Thư, Huyện Thanh Oai, Thành phố Hà Nội","path_with_type":"Xã Kim Thư, Huyện Thanh Oai, Thành phố Hà Nội","code":"10159","parent_code":"278"},"10162":{"name":"Xã Phương Trung","type":"xa","slug":"xa-phuong-trung","name_with_type":"Xã Phương Trung","path":"Xã Phương Trung, Huyện Thanh Oai, Thành phố Hà Nội","path_with_type":"Xã Phương Trung, Huyện Thanh Oai, Thành phố Hà Nội","code":"10162","parent_code":"278"},"10165":{"name":"Xã Tân Ước","type":"xa","slug":"xa-tan-uoc","name_with_type":"Xã Tân Ước","path":"Xã Tân Ước, Huyện Thanh Oai, Thành phố Hà Nội","path_with_type":"Xã Tân Ước, Huyện Thanh Oai, Thành phố Hà Nội","code":"10165","parent_code":"278"},"10168":{"name":"Xã Dân Hòa","type":"xa","slug":"xa-dan-hoa","name_with_type":"Xã Dân Hòa","path":"Xã Dân Hòa, Huyện Thanh Oai, Thành phố Hà Nội","path_with_type":"Xã Dân Hòa, Huyện Thanh Oai, Thành phố Hà Nội","code":"10168","parent_code":"278"},"10171":{"name":"Xã Liên Châu","type":"xa","slug":"xa-lien-chau","name_with_type":"Xã Liên Châu","path":"Xã Liên Châu, Huyện Thanh Oai, Thành phố Hà Nội","path_with_type":"Xã Liên Châu, Huyện Thanh Oai, Thành phố Hà Nội","code":"10171","parent_code":"278"},"10174":{"name":"Xã Cao Xuân Dương","type":"xa","slug":"xa-cao-xuan-duong","name_with_type":"Xã Cao Xuân Dương","path":"Xã Cao Xuân Dương, Huyện Thanh Oai, Thành phố Hà Nội","path_with_type":"Xã Cao Xuân Dương, Huyện Thanh Oai, Thành phố Hà Nội","code":"10174","parent_code":"278"},"10180":{"name":"Xã Hồng Dương","type":"xa","slug":"xa-hong-duong","name_with_type":"Xã Hồng Dương","path":"Xã Hồng Dương, Huyện Thanh Oai, Thành phố Hà Nội","path_with_type":"Xã Hồng Dương, Huyện Thanh Oai, Thành phố Hà Nội","code":"10180","parent_code":"278"},"10183":{"name":"Thị trấn Thường Tín","type":"thi-tran","slug":"thi-tran-thuong-tin","name_with_type":"Thị trấn Thường Tín","path":"Thị trấn Thường Tín, Huyện Thường Tín, Thành phố Hà Nội","path_with_type":"Thị trấn Thường Tín, Huyện Thường Tín, Thành phố Hà Nội","code":"10183","parent_code":"279"},"10186":{"name":"Xã Ninh Sở","type":"xa","slug":"xa-ninh-so","name_with_type":"Xã Ninh Sở","path":"Xã Ninh Sở, Huyện Thường Tín, Thành phố Hà Nội","path_with_type":"Xã Ninh Sở, Huyện Thường Tín, Thành phố Hà Nội","code":"10186","parent_code":"279"},"10189":{"name":"Xã Nhị Khê","type":"xa","slug":"xa-nhi-khe","name_with_type":"Xã Nhị Khê","path":"Xã Nhị Khê, Huyện Thường Tín, Thành phố Hà Nội","path_with_type":"Xã Nhị Khê, Huyện Thường Tín, Thành phố Hà Nội","code":"10189","parent_code":"279"},"10192":{"name":"Xã Duyên Thái","type":"xa","slug":"xa-duyen-thai","name_with_type":"Xã Duyên Thái","path":"Xã Duyên Thái, Huyện Thường Tín, Thành phố Hà Nội","path_with_type":"Xã Duyên Thái, Huyện Thường Tín, Thành phố Hà Nội","code":"10192","parent_code":"279"},"10195":{"name":"Xã Khánh Hà","type":"xa","slug":"xa-khanh-ha","name_with_type":"Xã Khánh Hà","path":"Xã Khánh Hà, Huyện Thường Tín, Thành phố Hà Nội","path_with_type":"Xã Khánh Hà, Huyện Thường Tín, Thành phố Hà Nội","code":"10195","parent_code":"279"},"10198":{"name":"Xã Hòa Bình","type":"xa","slug":"xa-hoa-binh","name_with_type":"Xã Hòa Bình","path":"Xã Hòa Bình, Huyện Thường Tín, Thành phố Hà Nội","path_with_type":"Xã Hòa Bình, Huyện Thường Tín, Thành phố Hà Nội","code":"10198","parent_code":"279"},"10201":{"name":"Xã Văn Bình","type":"xa","slug":"xa-van-binh","name_with_type":"Xã Văn Bình","path":"Xã Văn Bình, Huyện Thường Tín, Thành phố Hà Nội","path_with_type":"Xã Văn Bình, Huyện Thường Tín, Thành phố Hà Nội","code":"10201","parent_code":"279"},"10204":{"name":"Xã Hiền Giang","type":"xa","slug":"xa-hien-giang","name_with_type":"Xã Hiền Giang","path":"Xã Hiền Giang, Huyện Thường Tín, Thành phố Hà Nội","path_with_type":"Xã Hiền Giang, Huyện Thường Tín, Thành phố Hà Nội","code":"10204","parent_code":"279"},"10207":{"name":"Xã Hồng Vân","type":"xa","slug":"xa-hong-van","name_with_type":"Xã Hồng Vân","path":"Xã Hồng Vân, Huyện Thường Tín, Thành phố Hà Nội","path_with_type":"Xã Hồng Vân, Huyện Thường Tín, Thành phố Hà Nội","code":"10207","parent_code":"279"},"10210":{"name":"Xã Vân Tảo","type":"xa","slug":"xa-van-tao","name_with_type":"Xã Vân Tảo","path":"Xã Vân Tảo, Huyện Thường Tín, Thành phố Hà Nội","path_with_type":"Xã Vân Tảo, Huyện Thường Tín, Thành phố Hà Nội","code":"10210","parent_code":"279"},"10213":{"name":"Xã Liên Phương","type":"xa","slug":"xa-lien-phuong","name_with_type":"Xã Liên Phương","path":"Xã Liên Phương, Huyện Thường Tín, Thành phố Hà Nội","path_with_type":"Xã Liên Phương, Huyện Thường Tín, Thành phố Hà Nội","code":"10213","parent_code":"279"},"10216":{"name":"Xã Văn Phú","type":"xa","slug":"xa-van-phu","name_with_type":"Xã Văn Phú","path":"Xã Văn Phú, Huyện Thường Tín, Thành phố Hà Nội","path_with_type":"Xã Văn Phú, Huyện Thường Tín, Thành phố Hà Nội","code":"10216","parent_code":"279"},"10219":{"name":"Xã Tự Nhiên","type":"xa","slug":"xa-tu-nhien","name_with_type":"Xã Tự Nhiên","path":"Xã Tự Nhiên, Huyện Thường Tín, Thành phố Hà Nội","path_with_type":"Xã Tự Nhiên, Huyện Thường Tín, Thành phố Hà Nội","code":"10219","parent_code":"279"},"10222":{"name":"Xã Tiền Phong","type":"xa","slug":"xa-tien-phong","name_with_type":"Xã Tiền Phong","path":"Xã Tiền Phong, Huyện Thường Tín, Thành phố Hà Nội","path_with_type":"Xã Tiền Phong, Huyện Thường Tín, Thành phố Hà Nội","code":"10222","parent_code":"279"},"10225":{"name":"Xã Hà Hồi","type":"xa","slug":"xa-ha-hoi","name_with_type":"Xã Hà Hồi","path":"Xã Hà Hồi, Huyện Thường Tín, Thành phố Hà Nội","path_with_type":"Xã Hà Hồi, Huyện Thường Tín, Thành phố Hà Nội","code":"10225","parent_code":"279"},"10231":{"name":"Xã Nguyễn Trãi","type":"xa","slug":"xa-nguyen-trai","name_with_type":"Xã Nguyễn Trãi","path":"Xã Nguyễn Trãi, Huyện Thường Tín, Thành phố Hà Nội","path_with_type":"Xã Nguyễn Trãi, Huyện Thường Tín, Thành phố Hà Nội","code":"10231","parent_code":"279"},"10234":{"name":"Xã Quất Động","type":"xa","slug":"xa-quat-dong","name_with_type":"Xã Quất Động","path":"Xã Quất Động, Huyện Thường Tín, Thành phố Hà Nội","path_with_type":"Xã Quất Động, Huyện Thường Tín, Thành phố Hà Nội","code":"10234","parent_code":"279"},"10237":{"name":"Xã Chương Dương","type":"xa","slug":"xa-chuong-duong","name_with_type":"Xã Chương Dương","path":"Xã Chương Dương, Huyện Thường Tín, Thành phố Hà Nội","path_with_type":"Xã Chương Dương, Huyện Thường Tín, Thành phố Hà Nội","code":"10237","parent_code":"279"},"10240":{"name":"Xã Tân Minh","type":"xa","slug":"xa-tan-minh","name_with_type":"Xã Tân Minh","path":"Xã Tân Minh, Huyện Thường Tín, Thành phố Hà Nội","path_with_type":"Xã Tân Minh, Huyện Thường Tín, Thành phố Hà Nội","code":"10240","parent_code":"279"},"10243":{"name":"Xã Lê Lợi","type":"xa","slug":"xa-le-loi","name_with_type":"Xã Lê Lợi","path":"Xã Lê Lợi, Huyện Thường Tín, Thành phố Hà Nội","path_with_type":"Xã Lê Lợi, Huyện Thường Tín, Thành phố Hà Nội","code":"10243","parent_code":"279"},"10246":{"name":"Xã Thắng Lợi","type":"xa","slug":"xa-thang-loi","name_with_type":"Xã Thắng Lợi","path":"Xã Thắng Lợi, Huyện Thường Tín, Thành phố Hà Nội","path_with_type":"Xã Thắng Lợi, Huyện Thường Tín, Thành phố Hà Nội","code":"10246","parent_code":"279"},"10249":{"name":"Xã Dũng Tiến","type":"xa","slug":"xa-dung-tien","name_with_type":"Xã Dũng Tiến","path":"Xã Dũng Tiến, Huyện Thường Tín, Thành phố Hà Nội","path_with_type":"Xã Dũng Tiến, Huyện Thường Tín, Thành phố Hà Nội","code":"10249","parent_code":"279"},"10255":{"name":"Xã Nghiêm Xuyên","type":"xa","slug":"xa-nghiem-xuyen","name_with_type":"Xã Nghiêm Xuyên","path":"Xã Nghiêm Xuyên, Huyện Thường Tín, Thành phố Hà Nội","path_with_type":"Xã Nghiêm Xuyên, Huyện Thường Tín, Thành phố Hà Nội","code":"10255","parent_code":"279"},"10258":{"name":"Xã Tô Hiệu","type":"xa","slug":"xa-to-hieu","name_with_type":"Xã Tô Hiệu","path":"Xã Tô Hiệu, Huyện Thường Tín, Thành phố Hà Nội","path_with_type":"Xã Tô Hiệu, Huyện Thường Tín, Thành phố Hà Nội","code":"10258","parent_code":"279"},"10261":{"name":"Xã Văn Tự","type":"xa","slug":"xa-van-tu","name_with_type":"Xã Văn Tự","path":"Xã Văn Tự, Huyện Thường Tín, Thành phố Hà Nội","path_with_type":"Xã Văn Tự, Huyện Thường Tín, Thành phố Hà Nội","code":"10261","parent_code":"279"},"10264":{"name":"Xã Vạn Nhất","type":"xa","slug":"xa-van-nhat","name_with_type":"Xã Vạn Nhất","path":"Xã Vạn Nhất, Huyện Thường Tín, Thành phố Hà Nội","path_with_type":"Xã Vạn Nhất, Huyện Thường Tín, Thành phố Hà Nội","code":"10264","parent_code":"279"},"10267":{"name":"Xã Minh Cường","type":"xa","slug":"xa-minh-cuong","name_with_type":"Xã Minh Cường","path":"Xã Minh Cường, Huyện Thường Tín, Thành phố Hà Nội","path_with_type":"Xã Minh Cường, Huyện Thường Tín, Thành phố Hà Nội","code":"10267","parent_code":"279"},"10270":{"name":"Thị trấn Phú Minh","type":"thi-tran","slug":"thi-tran-phu-minh","name_with_type":"Thị trấn Phú Minh","path":"Thị trấn Phú Minh, Huyện Phú Xuyên, Thành phố Hà Nội","path_with_type":"Thị trấn Phú Minh, Huyện Phú Xuyên, Thành phố Hà Nội","code":"10270","parent_code":"280"},"10273":{"name":"Thị trấn Phú Xuyên","type":"thi-tran","slug":"thi-tran-phu-xuyen","name_with_type":"Thị trấn Phú Xuyên","path":"Thị trấn Phú Xuyên, Huyện Phú Xuyên, Thành phố Hà Nội","path_with_type":"Thị trấn Phú Xuyên, Huyện Phú Xuyên, Thành phố Hà Nội","code":"10273","parent_code":"280"},"10276":{"name":"Xã Hồng Minh","type":"xa","slug":"xa-hong-minh","name_with_type":"Xã Hồng Minh","path":"Xã Hồng Minh, Huyện Phú Xuyên, Thành phố Hà Nội","path_with_type":"Xã Hồng Minh, Huyện Phú Xuyên, Thành phố Hà Nội","code":"10276","parent_code":"280"},"10279":{"name":"Xã Phượng Dực","type":"xa","slug":"xa-phuong-duc","name_with_type":"Xã Phượng Dực","path":"Xã Phượng Dực, Huyện Phú Xuyên, Thành phố Hà Nội","path_with_type":"Xã Phượng Dực, Huyện Phú Xuyên, Thành phố Hà Nội","code":"10279","parent_code":"280"},"10282":{"name":"Xã Nam Tiến","type":"xa","slug":"xa-nam-tien","name_with_type":"Xã Nam Tiến","path":"Xã Nam Tiến, Huyện Phú Xuyên, Thành phố Hà Nội","path_with_type":"Xã Nam Tiến, Huyện Phú Xuyên, Thành phố Hà Nội","code":"10282","parent_code":"280"},"10291":{"name":"Xã Văn Hoàng","type":"xa","slug":"xa-van-hoang","name_with_type":"Xã Văn Hoàng","path":"Xã Văn Hoàng, Huyện Phú Xuyên, Thành phố Hà Nội","path_with_type":"Xã Văn Hoàng, Huyện Phú Xuyên, Thành phố Hà Nội","code":"10291","parent_code":"280"},"10294":{"name":"Xã Phú Túc","type":"xa","slug":"xa-phu-tuc","name_with_type":"Xã Phú Túc","path":"Xã Phú Túc, Huyện Phú Xuyên, Thành phố Hà Nội","path_with_type":"Xã Phú Túc, Huyện Phú Xuyên, Thành phố Hà Nội","code":"10294","parent_code":"280"},"10300":{"name":"Xã Hồng Thái","type":"xa","slug":"xa-hong-thai","name_with_type":"Xã Hồng Thái","path":"Xã Hồng Thái, Huyện Phú Xuyên, Thành phố Hà Nội","path_with_type":"Xã Hồng Thái, Huyện Phú Xuyên, Thành phố Hà Nội","code":"10300","parent_code":"280"},"10303":{"name":"Xã Hoàng Long","type":"xa","slug":"xa-hoang-long","name_with_type":"Xã Hoàng Long","path":"Xã Hoàng Long, Huyện Phú Xuyên, Thành phố Hà Nội","path_with_type":"Xã Hoàng Long, Huyện Phú Xuyên, Thành phố Hà Nội","code":"10303","parent_code":"280"},"10312":{"name":"Xã Nam Phong","type":"xa","slug":"xa-nam-phong","name_with_type":"Xã Nam Phong","path":"Xã Nam Phong, Huyện Phú Xuyên, Thành phố Hà Nội","path_with_type":"Xã Nam Phong, Huyện Phú Xuyên, Thành phố Hà Nội","code":"10312","parent_code":"280"},"10315":{"name":"Xã Tân Dân","type":"xa","slug":"xa-tan-dan","name_with_type":"Xã Tân Dân","path":"Xã Tân Dân, Huyện Phú Xuyên, Thành phố Hà Nội","path_with_type":"Xã Tân Dân, Huyện Phú Xuyên, Thành phố Hà Nội","code":"10315","parent_code":"280"},"10318":{"name":"Xã Quang Hà","type":"xa","slug":"xa-quang-ha","name_with_type":"Xã Quang Hà","path":"Xã Quang Hà, Huyện Phú Xuyên, Thành phố Hà Nội","path_with_type":"Xã Quang Hà, Huyện Phú Xuyên, Thành phố Hà Nội","code":"10318","parent_code":"280"},"10321":{"name":"Xã Chuyên Mỹ","type":"xa","slug":"xa-chuyen-my","name_with_type":"Xã Chuyên Mỹ","path":"Xã Chuyên Mỹ, Huyện Phú Xuyên, Thành phố Hà Nội","path_with_type":"Xã Chuyên Mỹ, Huyện Phú Xuyên, Thành phố Hà Nội","code":"10321","parent_code":"280"},"10324":{"name":"Xã Khai Thái","type":"xa","slug":"xa-khai-thai","name_with_type":"Xã Khai Thái","path":"Xã Khai Thái, Huyện Phú Xuyên, Thành phố Hà Nội","path_with_type":"Xã Khai Thái, Huyện Phú Xuyên, Thành phố Hà Nội","code":"10324","parent_code":"280"},"10327":{"name":"Xã Phúc Tiến","type":"xa","slug":"xa-phuc-tien","name_with_type":"Xã Phúc Tiến","path":"Xã Phúc Tiến, Huyện Phú Xuyên, Thành phố Hà Nội","path_with_type":"Xã Phúc Tiến, Huyện Phú Xuyên, Thành phố Hà Nội","code":"10327","parent_code":"280"},"10330":{"name":"Xã Vân Từ","type":"xa","slug":"xa-van-tu","name_with_type":"Xã Vân Từ","path":"Xã Vân Từ, Huyện Phú Xuyên, Thành phố Hà Nội","path_with_type":"Xã Vân Từ, Huyện Phú Xuyên, Thành phố Hà Nội","code":"10330","parent_code":"280"},"10333":{"name":"Xã Tri Thủy","type":"xa","slug":"xa-tri-thuy","name_with_type":"Xã Tri Thủy","path":"Xã Tri Thủy, Huyện Phú Xuyên, Thành phố Hà Nội","path_with_type":"Xã Tri Thủy, Huyện Phú Xuyên, Thành phố Hà Nội","code":"10333","parent_code":"280"},"10336":{"name":"Xã Đại Xuyên","type":"xa","slug":"xa-dai-xuyen","name_with_type":"Xã Đại Xuyên","path":"Xã Đại Xuyên, Huyện Phú Xuyên, Thành phố Hà Nội","path_with_type":"Xã Đại Xuyên, Huyện Phú Xuyên, Thành phố Hà Nội","code":"10336","parent_code":"280"},"10339":{"name":"Xã Phú Yên","type":"xa","slug":"xa-phu-yen","name_with_type":"Xã Phú Yên","path":"Xã Phú Yên, Huyện Phú Xuyên, Thành phố Hà Nội","path_with_type":"Xã Phú Yên, Huyện Phú Xuyên, Thành phố Hà Nội","code":"10339","parent_code":"280"},"10342":{"name":"Xã Bạch Hạ","type":"xa","slug":"xa-bach-ha","name_with_type":"Xã Bạch Hạ","path":"Xã Bạch Hạ, Huyện Phú Xuyên, Thành phố Hà Nội","path_with_type":"Xã Bạch Hạ, Huyện Phú Xuyên, Thành phố Hà Nội","code":"10342","parent_code":"280"},"10345":{"name":"Xã Quang Lãng","type":"xa","slug":"xa-quang-lang","name_with_type":"Xã Quang Lãng","path":"Xã Quang Lãng, Huyện Phú Xuyên, Thành phố Hà Nội","path_with_type":"Xã Quang Lãng, Huyện Phú Xuyên, Thành phố Hà Nội","code":"10345","parent_code":"280"},"10348":{"name":"Xã Châu Can","type":"xa","slug":"xa-chau-can","name_with_type":"Xã Châu Can","path":"Xã Châu Can, Huyện Phú Xuyên, Thành phố Hà Nội","path_with_type":"Xã Châu Can, Huyện Phú Xuyên, Thành phố Hà Nội","code":"10348","parent_code":"280"},"10351":{"name":"Xã Minh Tân","type":"xa","slug":"xa-minh-tan","name_with_type":"Xã Minh Tân","path":"Xã Minh Tân, Huyện Phú Xuyên, Thành phố Hà Nội","path_with_type":"Xã Minh Tân, Huyện Phú Xuyên, Thành phố Hà Nội","code":"10351","parent_code":"280"},"10354":{"name":"Thị trấn Vân Đình","type":"thi-tran","slug":"thi-tran-van-dinh","name_with_type":"Thị trấn Vân Đình","path":"Thị trấn Vân Đình, Huyện Ứng Hòa, Thành phố Hà Nội","path_with_type":"Thị trấn Vân Đình, Huyện Ứng Hòa, Thành phố Hà Nội","code":"10354","parent_code":"281"},"10363":{"name":"Xã Hoa Viên","type":"xa","slug":"xa-hoa-vien","name_with_type":"Xã Hoa Viên","path":"Xã Hoa Viên, Huyện Ứng Hòa, Thành phố Hà Nội","path_with_type":"Xã Hoa Viên, Huyện Ứng Hòa, Thành phố Hà Nội","code":"10363","parent_code":"281"},"10366":{"name":"Xã Quảng Phú Cầu","type":"xa","slug":"xa-quang-phu-cau","name_with_type":"Xã Quảng Phú Cầu","path":"Xã Quảng Phú Cầu, Huyện Ứng Hòa, Thành phố Hà Nội","path_with_type":"Xã Quảng Phú Cầu, Huyện Ứng Hòa, Thành phố Hà Nội","code":"10366","parent_code":"281"},"10369":{"name":"Xã Trường Thịnh","type":"xa","slug":"xa-truong-thinh","name_with_type":"Xã Trường Thịnh","path":"Xã Trường Thịnh, Huyện Ứng Hòa, Thành phố Hà Nội","path_with_type":"Xã Trường Thịnh, Huyện Ứng Hòa, Thành phố Hà Nội","code":"10369","parent_code":"281"},"10375":{"name":"Xã Liên Bạt","type":"xa","slug":"xa-lien-bat","name_with_type":"Xã Liên Bạt","path":"Xã Liên Bạt, Huyện Ứng Hòa, Thành phố Hà Nội","path_with_type":"Xã Liên Bạt, Huyện Ứng Hòa, Thành phố Hà Nội","code":"10375","parent_code":"281"},"10378":{"name":"Xã Cao Sơn Tiến","type":"xa","slug":"xa-cao-son-tien","name_with_type":"Xã Cao Sơn Tiến","path":"Xã Cao Sơn Tiến, Huyện Ứng Hòa, Thành phố Hà Nội","path_with_type":"Xã Cao Sơn Tiến, Huyện Ứng Hòa, Thành phố Hà Nội","code":"10378","parent_code":"281"},"10384":{"name":"Xã Phương Tú","type":"xa","slug":"xa-phuong-tu","name_with_type":"Xã Phương Tú","path":"Xã Phương Tú, Huyện Ứng Hòa, Thành phố Hà Nội","path_with_type":"Xã Phương Tú, Huyện Ứng Hòa, Thành phố Hà Nội","code":"10384","parent_code":"281"},"10387":{"name":"Xã Trung Tú","type":"xa","slug":"xa-trung-tu","name_with_type":"Xã Trung Tú","path":"Xã Trung Tú, Huyện Ứng Hòa, Thành phố Hà Nội","path_with_type":"Xã Trung Tú, Huyện Ứng Hòa, Thành phố Hà Nội","code":"10387","parent_code":"281"},"10390":{"name":"Xã Đồng Tân","type":"xa","slug":"xa-dong-tan","name_with_type":"Xã Đồng Tân","path":"Xã Đồng Tân, Huyện Ứng Hòa, Thành phố Hà Nội","path_with_type":"Xã Đồng Tân, Huyện Ứng Hòa, Thành phố Hà Nội","code":"10390","parent_code":"281"},"10393":{"name":"Xã Tảo Dương Văn","type":"xa","slug":"xa-tao-duong-van","name_with_type":"Xã Tảo Dương Văn","path":"Xã Tảo Dương Văn, Huyện Ứng Hòa, Thành phố Hà Nội","path_with_type":"Xã Tảo Dương Văn, Huyện Ứng Hòa, Thành phố Hà Nội","code":"10393","parent_code":"281"},"10396":{"name":"Xã Thái Hòa","type":"xa","slug":"xa-thai-hoa","name_with_type":"Xã Thái Hòa","path":"Xã Thái Hòa, Huyện Ứng Hòa, Thành phố Hà Nội","path_with_type":"Xã Thái Hòa, Huyện Ứng Hòa, Thành phố Hà Nội","code":"10396","parent_code":"281"},"10399":{"name":"Xã Minh Đức","type":"xa","slug":"xa-minh-duc","name_with_type":"Xã Minh Đức","path":"Xã Minh Đức, Huyện Ứng Hòa, Thành phố Hà Nội","path_with_type":"Xã Minh Đức, Huyện Ứng Hòa, Thành phố Hà Nội","code":"10399","parent_code":"281"},"10402":{"name":"Xã Trầm Lộng","type":"xa","slug":"xa-tram-long","name_with_type":"Xã Trầm Lộng","path":"Xã Trầm Lộng, Huyện Ứng Hòa, Thành phố Hà Nội","path_with_type":"Xã Trầm Lộng, Huyện Ứng Hòa, Thành phố Hà Nội","code":"10402","parent_code":"281"},"10411":{"name":"Xã Kim Đường","type":"xa","slug":"xa-kim-duong","name_with_type":"Xã Kim Đường","path":"Xã Kim Đường, Huyện Ứng Hòa, Thành phố Hà Nội","path_with_type":"Xã Kim Đường, Huyện Ứng Hòa, Thành phố Hà Nội","code":"10411","parent_code":"281"},"10417":{"name":"Xã Hòa Phú","type":"xa","slug":"xa-hoa-phu","name_with_type":"Xã Hòa Phú","path":"Xã Hòa Phú, Huyện Ứng Hòa, Thành phố Hà Nội","path_with_type":"Xã Hòa Phú, Huyện Ứng Hòa, Thành phố Hà Nội","code":"10417","parent_code":"281"},"10423":{"name":"Xã Đại Hùng","type":"xa","slug":"xa-dai-hung","name_with_type":"Xã Đại Hùng","path":"Xã Đại Hùng, Huyện Ứng Hòa, Thành phố Hà Nội","path_with_type":"Xã Đại Hùng, Huyện Ứng Hòa, Thành phố Hà Nội","code":"10423","parent_code":"281"},"10426":{"name":"Xã Đông Lỗ","type":"xa","slug":"xa-dong-lo","name_with_type":"Xã Đông Lỗ","path":"Xã Đông Lỗ, Huyện Ứng Hòa, Thành phố Hà Nội","path_with_type":"Xã Đông Lỗ, Huyện Ứng Hòa, Thành phố Hà Nội","code":"10426","parent_code":"281"},"10429":{"name":"Xã Phù Lưu","type":"xa","slug":"xa-phu-luu","name_with_type":"Xã Phù Lưu","path":"Xã Phù Lưu, Huyện Ứng Hòa, Thành phố Hà Nội","path_with_type":"Xã Phù Lưu, Huyện Ứng Hòa, Thành phố Hà Nội","code":"10429","parent_code":"281"},"10432":{"name":"Xã Đại Cường","type":"xa","slug":"xa-dai-cuong","name_with_type":"Xã Đại Cường","path":"Xã Đại Cường, Huyện Ứng Hòa, Thành phố Hà Nội","path_with_type":"Xã Đại Cường, Huyện Ứng Hòa, Thành phố Hà Nội","code":"10432","parent_code":"281"},"10435":{"name":"Xã Bình Lưu Quang","type":"xa","slug":"xa-binh-luu-quang","name_with_type":"Xã Bình Lưu Quang","path":"Xã Bình Lưu Quang, Huyện Ứng Hòa, Thành phố Hà Nội","path_with_type":"Xã Bình Lưu Quang, Huyện Ứng Hòa, Thành phố Hà Nội","code":"10435","parent_code":"281"},"10441":{"name":"Thị trấn Đại Nghĩa","type":"thi-tran","slug":"thi-tran-dai-nghia","name_with_type":"Thị trấn Đại Nghĩa","path":"Thị trấn Đại Nghĩa, Huyện Mỹ Đức, Thành phố Hà Nội","path_with_type":"Thị trấn Đại Nghĩa, Huyện Mỹ Đức, Thành phố Hà Nội","code":"10441","parent_code":"282"},"10444":{"name":"Xã Đồng Tâm","type":"xa","slug":"xa-dong-tam","name_with_type":"Xã Đồng Tâm","path":"Xã Đồng Tâm, Huyện Mỹ Đức, Thành phố Hà Nội","path_with_type":"Xã Đồng Tâm, Huyện Mỹ Đức, Thành phố Hà Nội","code":"10444","parent_code":"282"},"10447":{"name":"Xã Thượng Lâm","type":"xa","slug":"xa-thuong-lam","name_with_type":"Xã Thượng Lâm","path":"Xã Thượng Lâm, Huyện Mỹ Đức, Thành phố Hà Nội","path_with_type":"Xã Thượng Lâm, Huyện Mỹ Đức, Thành phố Hà Nội","code":"10447","parent_code":"282"},"10450":{"name":"Xã Tuy Lai","type":"xa","slug":"xa-tuy-lai","name_with_type":"Xã Tuy Lai","path":"Xã Tuy Lai, Huyện Mỹ Đức, Thành phố Hà Nội","path_with_type":"Xã Tuy Lai, Huyện Mỹ Đức, Thành phố Hà Nội","code":"10450","parent_code":"282"},"10453":{"name":"Xã Phúc Lâm","type":"xa","slug":"xa-phuc-lam","name_with_type":"Xã Phúc Lâm","path":"Xã Phúc Lâm, Huyện Mỹ Đức, Thành phố Hà Nội","path_with_type":"Xã Phúc Lâm, Huyện Mỹ Đức, Thành phố Hà Nội","code":"10453","parent_code":"282"},"10459":{"name":"Xã Mỹ Xuyên","type":"xa","slug":"xa-my-xuyen","name_with_type":"Xã Mỹ Xuyên","path":"Xã Mỹ Xuyên, Huyện Mỹ Đức, Thành phố Hà Nội","path_with_type":"Xã Mỹ Xuyên, Huyện Mỹ Đức, Thành phố Hà Nội","code":"10459","parent_code":"282"},"10462":{"name":"Xã An Mỹ","type":"xa","slug":"xa-an-my","name_with_type":"Xã An Mỹ","path":"Xã An Mỹ, Huyện Mỹ Đức, Thành phố Hà Nội","path_with_type":"Xã An Mỹ, Huyện Mỹ Đức, Thành phố Hà Nội","code":"10462","parent_code":"282"},"10465":{"name":"Xã Hồng Sơn","type":"xa","slug":"xa-hong-son","name_with_type":"Xã Hồng Sơn","path":"Xã Hồng Sơn, Huyện Mỹ Đức, Thành phố Hà Nội","path_with_type":"Xã Hồng Sơn, Huyện Mỹ Đức, Thành phố Hà Nội","code":"10465","parent_code":"282"},"10468":{"name":"Xã Lê Thanh","type":"xa","slug":"xa-le-thanh","name_with_type":"Xã Lê Thanh","path":"Xã Lê Thanh, Huyện Mỹ Đức, Thành phố Hà Nội","path_with_type":"Xã Lê Thanh, Huyện Mỹ Đức, Thành phố Hà Nội","code":"10468","parent_code":"282"},"10471":{"name":"Xã Xuy Xá","type":"xa","slug":"xa-xuy-xa","name_with_type":"Xã Xuy Xá","path":"Xã Xuy Xá, Huyện Mỹ Đức, Thành phố Hà Nội","path_with_type":"Xã Xuy Xá, Huyện Mỹ Đức, Thành phố Hà Nội","code":"10471","parent_code":"282"},"10474":{"name":"Xã Phùng Xá","type":"xa","slug":"xa-phung-xa","name_with_type":"Xã Phùng Xá","path":"Xã Phùng Xá, Huyện Mỹ Đức, Thành phố Hà Nội","path_with_type":"Xã Phùng Xá, Huyện Mỹ Đức, Thành phố Hà Nội","code":"10474","parent_code":"282"},"10477":{"name":"Xã Phù Lưu Tế","type":"xa","slug":"xa-phu-luu-te","name_with_type":"Xã Phù Lưu Tế","path":"Xã Phù Lưu Tế, Huyện Mỹ Đức, Thành phố Hà Nội","path_with_type":"Xã Phù Lưu Tế, Huyện Mỹ Đức, Thành phố Hà Nội","code":"10477","parent_code":"282"},"10480":{"name":"Xã Đại Hưng","type":"xa","slug":"xa-dai-hung","name_with_type":"Xã Đại Hưng","path":"Xã Đại Hưng, Huyện Mỹ Đức, Thành phố Hà Nội","path_with_type":"Xã Đại Hưng, Huyện Mỹ Đức, Thành phố Hà Nội","code":"10480","parent_code":"282"},"10483":{"name":"Xã Vạn Tín","type":"xa","slug":"xa-van-tin","name_with_type":"Xã Vạn Tín","path":"Xã Vạn Tín, Huyện Mỹ Đức, Thành phố Hà Nội","path_with_type":"Xã Vạn Tín, Huyện Mỹ Đức, Thành phố Hà Nội","code":"10483","parent_code":"282"},"10489":{"name":"Xã Hương Sơn","type":"xa","slug":"xa-huong-son","name_with_type":"Xã Hương Sơn","path":"Xã Hương Sơn, Huyện Mỹ Đức, Thành phố Hà Nội","path_with_type":"Xã Hương Sơn, Huyện Mỹ Đức, Thành phố Hà Nội","code":"10489","parent_code":"282"},"10492":{"name":"Xã Hùng Tiến","type":"xa","slug":"xa-hung-tien","name_with_type":"Xã Hùng Tiến","path":"Xã Hùng Tiến, Huyện Mỹ Đức, Thành phố Hà Nội","path_with_type":"Xã Hùng Tiến, Huyện Mỹ Đức, Thành phố Hà Nội","code":"10492","parent_code":"282"},"10495":{"name":"Xã An Tiến","type":"xa","slug":"xa-an-tien","name_with_type":"Xã An Tiến","path":"Xã An Tiến, Huyện Mỹ Đức, Thành phố Hà Nội","path_with_type":"Xã An Tiến, Huyện Mỹ Đức, Thành phố Hà Nội","code":"10495","parent_code":"282"},"10498":{"name":"Xã Hợp Tiến","type":"xa","slug":"xa-hop-tien","name_with_type":"Xã Hợp Tiến","path":"Xã Hợp Tiến, Huyện Mỹ Đức, Thành phố Hà Nội","path_with_type":"Xã Hợp Tiến, Huyện Mỹ Đức, Thành phố Hà Nội","code":"10498","parent_code":"282"},"10501":{"name":"Xã Hợp Thanh","type":"xa","slug":"xa-hop-thanh","name_with_type":"Xã Hợp Thanh","path":"Xã Hợp Thanh, Huyện Mỹ Đức, Thành phố Hà Nội","path_with_type":"Xã Hợp Thanh, Huyện Mỹ Đức, Thành phố Hà Nội","code":"10501","parent_code":"282"},"10504":{"name":"Xã An Phú","type":"xa","slug":"xa-an-phu","name_with_type":"Xã An Phú","path":"Xã An Phú, Huyện Mỹ Đức, Thành phố Hà Nội","path_with_type":"Xã An Phú, Huyện Mỹ Đức, Thành phố Hà Nội","code":"10504","parent_code":"282"},"10507":{"name":"Phường Cẩm Thượng","type":"phuong","slug":"phuong-cam-thuong","name_with_type":"Phường Cẩm Thượng","path":"Phường Cẩm Thượng, Thành phố Hải Dương, Tỉnh Hải Dương","path_with_type":"Phường Cẩm Thượng, Thành phố Hải Dương, Tỉnh Hải Dương","code":"10507","parent_code":"288"},"10510":{"name":"Phường Bình Hàn","type":"phuong","slug":"phuong-binh-han","name_with_type":"Phường Bình Hàn","path":"Phường Bình Hàn, Thành phố Hải Dương, Tỉnh Hải Dương","path_with_type":"Phường Bình Hàn, Thành phố Hải Dương, Tỉnh Hải Dương","code":"10510","parent_code":"288"},"10513":{"name":"Phường Ngọc Châu","type":"phuong","slug":"phuong-ngoc-chau","name_with_type":"Phường Ngọc Châu","path":"Phường Ngọc Châu, Thành phố Hải Dương, Tỉnh Hải Dương","path_with_type":"Phường Ngọc Châu, Thành phố Hải Dương, Tỉnh Hải Dương","code":"10513","parent_code":"288"},"10514":{"name":"Phường Nhị Châu","type":"phuong","slug":"phuong-nhi-chau","name_with_type":"Phường Nhị Châu","path":"Phường Nhị Châu, Thành phố Hải Dương, Tỉnh Hải Dương","path_with_type":"Phường Nhị Châu, Thành phố Hải Dương, Tỉnh Hải Dương","code":"10514","parent_code":"288"},"10516":{"name":"Phường Quang Trung","type":"phuong","slug":"phuong-quang-trung","name_with_type":"Phường Quang Trung","path":"Phường Quang Trung, Thành phố Hải Dương, Tỉnh Hải Dương","path_with_type":"Phường Quang Trung, Thành phố Hải Dương, Tỉnh Hải Dương","code":"10516","parent_code":"288"},"10519":{"name":"Phường Nguyễn Trãi","type":"phuong","slug":"phuong-nguyen-trai","name_with_type":"Phường Nguyễn Trãi","path":"Phường Nguyễn Trãi, Thành phố Hải Dương, Tỉnh Hải Dương","path_with_type":"Phường Nguyễn Trãi, Thành phố Hải Dương, Tỉnh Hải Dương","code":"10519","parent_code":"288"},"10525":{"name":"Phường Trần Hưng Đạo","type":"phuong","slug":"phuong-tran-hung-dao","name_with_type":"Phường Trần Hưng Đạo","path":"Phường Trần Hưng Đạo, Thành phố Hải Dương, Tỉnh Hải Dương","path_with_type":"Phường Trần Hưng Đạo, Thành phố Hải Dương, Tỉnh Hải Dương","code":"10525","parent_code":"288"},"10528":{"name":"Phường Trần Phú","type":"phuong","slug":"phuong-tran-phu","name_with_type":"Phường Trần Phú","path":"Phường Trần Phú, Thành phố Hải Dương, Tỉnh Hải Dương","path_with_type":"Phường Trần Phú, Thành phố Hải Dương, Tỉnh Hải Dương","code":"10528","parent_code":"288"},"10531":{"name":"Phường Thanh Bình","type":"phuong","slug":"phuong-thanh-binh","name_with_type":"Phường Thanh Bình","path":"Phường Thanh Bình, Thành phố Hải Dương, Tỉnh Hải Dương","path_with_type":"Phường Thanh Bình, Thành phố Hải Dương, Tỉnh Hải Dương","code":"10531","parent_code":"288"},"10532":{"name":"Phường Tân Bình","type":"phuong","slug":"phuong-tan-binh","name_with_type":"Phường Tân Bình","path":"Phường Tân Bình, Thành phố Hải Dương, Tỉnh Hải Dương","path_with_type":"Phường Tân Bình, Thành phố Hải Dương, Tỉnh Hải Dương","code":"10532","parent_code":"288"},"10534":{"name":"Phường Lê Thanh Nghị","type":"phuong","slug":"phuong-le-thanh-nghi","name_with_type":"Phường Lê Thanh Nghị","path":"Phường Lê Thanh Nghị, Thành phố Hải Dương, Tỉnh Hải Dương","path_with_type":"Phường Lê Thanh Nghị, Thành phố Hải Dương, Tỉnh Hải Dương","code":"10534","parent_code":"288"},"10537":{"name":"Phường Hải Tân","type":"phuong","slug":"phuong-hai-tan","name_with_type":"Phường Hải Tân","path":"Phường Hải Tân, Thành phố Hải Dương, Tỉnh Hải Dương","path_with_type":"Phường Hải Tân, Thành phố Hải Dương, Tỉnh Hải Dương","code":"10537","parent_code":"288"},"10540":{"name":"Phường Tứ Minh","type":"phuong","slug":"phuong-tu-minh","name_with_type":"Phường Tứ Minh","path":"Phường Tứ Minh, Thành phố Hải Dương, Tỉnh Hải Dương","path_with_type":"Phường Tứ Minh, Thành phố Hải Dương, Tỉnh Hải Dương","code":"10540","parent_code":"288"},"10543":{"name":"Phường Việt Hoà","type":"phuong","slug":"phuong-viet-hoa","name_with_type":"Phường Việt Hoà","path":"Phường Việt Hoà, Thành phố Hải Dương, Tỉnh Hải Dương","path_with_type":"Phường Việt Hoà, Thành phố Hải Dương, Tỉnh Hải Dương","code":"10543","parent_code":"288"},"10546":{"name":"Phường Phả Lại","type":"phuong","slug":"phuong-pha-lai","name_with_type":"Phường Phả Lại","path":"Phường Phả Lại, Thành phố Chí Linh, Tỉnh Hải Dương","path_with_type":"Phường Phả Lại, Thành phố Chí Linh, Tỉnh Hải Dương","code":"10546","parent_code":"290"},"10549":{"name":"Phường Sao Đỏ","type":"phuong","slug":"phuong-sao-do","name_with_type":"Phường Sao Đỏ","path":"Phường Sao Đỏ, Thành phố Chí Linh, Tỉnh Hải Dương","path_with_type":"Phường Sao Đỏ, Thành phố Chí Linh, Tỉnh Hải Dương","code":"10549","parent_code":"290"},"10552":{"name":"Phường Bến Tắm","type":"phuong","slug":"phuong-ben-tam","name_with_type":"Phường Bến Tắm","path":"Phường Bến Tắm, Thành phố Chí Linh, Tỉnh Hải Dương","path_with_type":"Phường Bến Tắm, Thành phố Chí Linh, Tỉnh Hải Dương","code":"10552","parent_code":"290"},"10555":{"name":"Xã Hoàng Hoa Thám","type":"xa","slug":"xa-hoang-hoa-tham","name_with_type":"Xã Hoàng Hoa Thám","path":"Xã Hoàng Hoa Thám, Thành phố Chí Linh, Tỉnh Hải Dương","path_with_type":"Xã Hoàng Hoa Thám, Thành phố Chí Linh, Tỉnh Hải Dương","code":"10555","parent_code":"290"},"10558":{"name":"Xã Bắc An","type":"xa","slug":"xa-bac-an","name_with_type":"Xã Bắc An","path":"Xã Bắc An, Thành phố Chí Linh, Tỉnh Hải Dương","path_with_type":"Xã Bắc An, Thành phố Chí Linh, Tỉnh Hải Dương","code":"10558","parent_code":"290"},"10561":{"name":"Xã Hưng Đạo","type":"xa","slug":"xa-hung-dao","name_with_type":"Xã Hưng Đạo","path":"Xã Hưng Đạo, Thành phố Chí Linh, Tỉnh Hải Dương","path_with_type":"Xã Hưng Đạo, Thành phố Chí Linh, Tỉnh Hải Dương","code":"10561","parent_code":"290"},"10564":{"name":"Xã Lê Lợi","type":"xa","slug":"xa-le-loi","name_with_type":"Xã Lê Lợi","path":"Xã Lê Lợi, Thành phố Chí Linh, Tỉnh Hải Dương","path_with_type":"Xã Lê Lợi, Thành phố Chí Linh, Tỉnh Hải Dương","code":"10564","parent_code":"290"},"10567":{"name":"Phường Hoàng Tiến","type":"phuong","slug":"phuong-hoang-tien","name_with_type":"Phường Hoàng Tiến","path":"Phường Hoàng Tiến, Thành phố Chí Linh, Tỉnh Hải Dương","path_with_type":"Phường Hoàng Tiến, Thành phố Chí Linh, Tỉnh Hải Dương","code":"10567","parent_code":"290"},"10570":{"name":"Phường Cộng Hoà","type":"phuong","slug":"phuong-cong-hoa","name_with_type":"Phường Cộng Hoà","path":"Phường Cộng Hoà, Thành phố Chí Linh, Tỉnh Hải Dương","path_with_type":"Phường Cộng Hoà, Thành phố Chí Linh, Tỉnh Hải Dương","code":"10570","parent_code":"290"},"10573":{"name":"Phường Hoàng Tân","type":"phuong","slug":"phuong-hoang-tan","name_with_type":"Phường Hoàng Tân","path":"Phường Hoàng Tân, Thành phố Chí Linh, Tỉnh Hải Dương","path_with_type":"Phường Hoàng Tân, Thành phố Chí Linh, Tỉnh Hải Dương","code":"10573","parent_code":"290"},"10576":{"name":"Phường Cổ Thành","type":"phuong","slug":"phuong-co-thanh","name_with_type":"Phường Cổ Thành","path":"Phường Cổ Thành, Thành phố Chí Linh, Tỉnh Hải Dương","path_with_type":"Phường Cổ Thành, Thành phố Chí Linh, Tỉnh Hải Dương","code":"10576","parent_code":"290"},"10579":{"name":"Phường Văn An","type":"phuong","slug":"phuong-van-an","name_with_type":"Phường Văn An","path":"Phường Văn An, Thành phố Chí Linh, Tỉnh Hải Dương","path_with_type":"Phường Văn An, Thành phố Chí Linh, Tỉnh Hải Dương","code":"10579","parent_code":"290"},"10582":{"name":"Phường Chí Minh","type":"phuong","slug":"phuong-chi-minh","name_with_type":"Phường Chí Minh","path":"Phường Chí Minh, Thành phố Chí Linh, Tỉnh Hải Dương","path_with_type":"Phường Chí Minh, Thành phố Chí Linh, Tỉnh Hải Dương","code":"10582","parent_code":"290"},"10585":{"name":"Phường Văn Đức","type":"phuong","slug":"phuong-van-duc","name_with_type":"Phường Văn Đức","path":"Phường Văn Đức, Thành phố Chí Linh, Tỉnh Hải Dương","path_with_type":"Phường Văn Đức, Thành phố Chí Linh, Tỉnh Hải Dương","code":"10585","parent_code":"290"},"10588":{"name":"Phường Thái Học","type":"phuong","slug":"phuong-thai-hoc","name_with_type":"Phường Thái Học","path":"Phường Thái Học, Thành phố Chí Linh, Tỉnh Hải Dương","path_with_type":"Phường Thái Học, Thành phố Chí Linh, Tỉnh Hải Dương","code":"10588","parent_code":"290"},"10591":{"name":"Xã Nhân Huệ","type":"xa","slug":"xa-nhan-hue","name_with_type":"Xã Nhân Huệ","path":"Xã Nhân Huệ, Thành phố Chí Linh, Tỉnh Hải Dương","path_with_type":"Xã Nhân Huệ, Thành phố Chí Linh, Tỉnh Hải Dương","code":"10591","parent_code":"290"},"10594":{"name":"Phường An Lạc","type":"phuong","slug":"phuong-an-lac","name_with_type":"Phường An Lạc","path":"Phường An Lạc, Thành phố Chí Linh, Tỉnh Hải Dương","path_with_type":"Phường An Lạc, Thành phố Chí Linh, Tỉnh Hải Dương","code":"10594","parent_code":"290"},"10600":{"name":"Phường Đồng Lạc","type":"phuong","slug":"phuong-dong-lac","name_with_type":"Phường Đồng Lạc","path":"Phường Đồng Lạc, Thành phố Chí Linh, Tỉnh Hải Dương","path_with_type":"Phường Đồng Lạc, Thành phố Chí Linh, Tỉnh Hải Dương","code":"10600","parent_code":"290"},"10603":{"name":"Phường Tân Dân","type":"phuong","slug":"phuong-tan-dan","name_with_type":"Phường Tân Dân","path":"Phường Tân Dân, Thành phố Chí Linh, Tỉnh Hải Dương","path_with_type":"Phường Tân Dân, Thành phố Chí Linh, Tỉnh Hải Dương","code":"10603","parent_code":"290"},"10606":{"name":"Thị trấn Nam Sách","type":"thi-tran","slug":"thi-tran-nam-sach","name_with_type":"Thị trấn Nam Sách","path":"Thị trấn Nam Sách, Huyện Nam Sách, Tỉnh Hải Dương","path_with_type":"Thị trấn Nam Sách, Huyện Nam Sách, Tỉnh Hải Dương","code":"10606","parent_code":"291"},"10609":{"name":"Xã Nam Hưng","type":"xa","slug":"xa-nam-hung","name_with_type":"Xã Nam Hưng","path":"Xã Nam Hưng, Huyện Nam Sách, Tỉnh Hải Dương","path_with_type":"Xã Nam Hưng, Huyện Nam Sách, Tỉnh Hải Dương","code":"10609","parent_code":"291"},"10612":{"name":"Xã Nam Tân","type":"xa","slug":"xa-nam-tan","name_with_type":"Xã Nam Tân","path":"Xã Nam Tân, Huyện Nam Sách, Tỉnh Hải Dương","path_with_type":"Xã Nam Tân, Huyện Nam Sách, Tỉnh Hải Dương","code":"10612","parent_code":"291"},"10615":{"name":"Xã Hợp Tiến","type":"xa","slug":"xa-hop-tien","name_with_type":"Xã Hợp Tiến","path":"Xã Hợp Tiến, Huyện Nam Sách, Tỉnh Hải Dương","path_with_type":"Xã Hợp Tiến, Huyện Nam Sách, Tỉnh Hải Dương","code":"10615","parent_code":"291"},"10618":{"name":"Xã Hiệp Cát","type":"xa","slug":"xa-hiep-cat","name_with_type":"Xã Hiệp Cát","path":"Xã Hiệp Cát, Huyện Nam Sách, Tỉnh Hải Dương","path_with_type":"Xã Hiệp Cát, Huyện Nam Sách, Tỉnh Hải Dương","code":"10618","parent_code":"291"},"10621":{"name":"Xã Quốc Tuấn","type":"xa","slug":"xa-quoc-tuan","name_with_type":"Xã Quốc Tuấn","path":"Xã Quốc Tuấn, Huyện Nam Sách, Tỉnh Hải Dương","path_with_type":"Xã Quốc Tuấn, Huyện Nam Sách, Tỉnh Hải Dương","code":"10621","parent_code":"291"},"10630":{"name":"Xã An Bình","type":"xa","slug":"xa-an-binh","name_with_type":"Xã An Bình","path":"Xã An Bình, Huyện Nam Sách, Tỉnh Hải Dương","path_with_type":"Xã An Bình, Huyện Nam Sách, Tỉnh Hải Dương","code":"10630","parent_code":"291"},"10633":{"name":"Xã Trần Phú","type":"xa","slug":"xa-tran-phu","name_with_type":"Xã Trần Phú","path":"Xã Trần Phú, Huyện Nam Sách, Tỉnh Hải Dương","path_with_type":"Xã Trần Phú, Huyện Nam Sách, Tỉnh Hải Dương","code":"10633","parent_code":"291"},"10636":{"name":"Xã An Sơn","type":"xa","slug":"xa-an-son","name_with_type":"Xã An Sơn","path":"Xã An Sơn, Huyện Nam Sách, Tỉnh Hải Dương","path_with_type":"Xã An Sơn, Huyện Nam Sách, Tỉnh Hải Dương","code":"10636","parent_code":"291"},"10639":{"name":"Xã Cộng Hòa","type":"xa","slug":"xa-cong-hoa","name_with_type":"Xã Cộng Hòa","path":"Xã Cộng Hòa, Huyện Nam Sách, Tỉnh Hải Dương","path_with_type":"Xã Cộng Hòa, Huyện Nam Sách, Tỉnh Hải Dương","code":"10639","parent_code":"291"},"10642":{"name":"Xã Thái Tân","type":"xa","slug":"xa-thai-tan","name_with_type":"Xã Thái Tân","path":"Xã Thái Tân, Huyện Nam Sách, Tỉnh Hải Dương","path_with_type":"Xã Thái Tân, Huyện Nam Sách, Tỉnh Hải Dương","code":"10642","parent_code":"291"},"10645":{"name":"Xã An Phú","type":"xa","slug":"xa-an-phu","name_with_type":"Xã An Phú","path":"Xã An Phú, Huyện Nam Sách, Tỉnh Hải Dương","path_with_type":"Xã An Phú, Huyện Nam Sách, Tỉnh Hải Dương","code":"10645","parent_code":"291"},"10654":{"name":"Xã Hồng Phong","type":"xa","slug":"xa-hong-phong","name_with_type":"Xã Hồng Phong","path":"Xã Hồng Phong, Huyện Nam Sách, Tỉnh Hải Dương","path_with_type":"Xã Hồng Phong, Huyện Nam Sách, Tỉnh Hải Dương","code":"10654","parent_code":"291"},"10657":{"name":"Xã Đồng Lạc","type":"xa","slug":"xa-dong-lac","name_with_type":"Xã Đồng Lạc","path":"Xã Đồng Lạc, Huyện Nam Sách, Tỉnh Hải Dương","path_with_type":"Xã Đồng Lạc, Huyện Nam Sách, Tỉnh Hải Dương","code":"10657","parent_code":"291"},"10660":{"name":"Phường Ái Quốc","type":"phuong","slug":"phuong-ai-quoc","name_with_type":"Phường Ái Quốc","path":"Phường Ái Quốc, Thành phố Hải Dương, Tỉnh Hải Dương","path_with_type":"Phường Ái Quốc, Thành phố Hải Dương, Tỉnh Hải Dương","code":"10660","parent_code":"288"},"10663":{"name":"Xã An Thượng","type":"xa","slug":"xa-an-thuong","name_with_type":"Xã An Thượng","path":"Xã An Thượng, Thành phố Hải Dương, Tỉnh Hải Dương","path_with_type":"Xã An Thượng, Thành phố Hải Dương, Tỉnh Hải Dương","code":"10663","parent_code":"288"},"10666":{"name":"Xã Minh Tân","type":"xa","slug":"xa-minh-tan","name_with_type":"Xã Minh Tân","path":"Xã Minh Tân, Huyện Nam Sách, Tỉnh Hải Dương","path_with_type":"Xã Minh Tân, Huyện Nam Sách, Tỉnh Hải Dương","code":"10666","parent_code":"291"},"10672":{"name":"Phường Nam Đồng","type":"phuong","slug":"phuong-nam-dong","name_with_type":"Phường Nam Đồng","path":"Phường Nam Đồng, Thành phố Hải Dương, Tỉnh Hải Dương","path_with_type":"Phường Nam Đồng, Thành phố Hải Dương, Tỉnh Hải Dương","code":"10672","parent_code":"288"},"10675":{"name":"Phường An Lưu","type":"phuong","slug":"phuong-an-luu","name_with_type":"Phường An Lưu","path":"Phường An Lưu, Thị xã Kinh Môn, Tỉnh Hải Dương","path_with_type":"Phường An Lưu, Thị xã Kinh Môn, Tỉnh Hải Dương","code":"10675","parent_code":"292"},"10678":{"name":"Xã Bạch Đằng","type":"xa","slug":"xa-bach-dang","name_with_type":"Xã Bạch Đằng","path":"Xã Bạch Đằng, Thị xã Kinh Môn, Tỉnh Hải Dương","path_with_type":"Xã Bạch Đằng, Thị xã Kinh Môn, Tỉnh Hải Dương","code":"10678","parent_code":"292"},"10681":{"name":"Phường Thất Hùng","type":"phuong","slug":"phuong-that-hung","name_with_type":"Phường Thất Hùng","path":"Phường Thất Hùng, Thị xã Kinh Môn, Tỉnh Hải Dương","path_with_type":"Phường Thất Hùng, Thị xã Kinh Môn, Tỉnh Hải Dương","code":"10681","parent_code":"292"},"10684":{"name":"Xã Lê Ninh","type":"xa","slug":"xa-le-ninh","name_with_type":"Xã Lê Ninh","path":"Xã Lê Ninh, Thị xã Kinh Môn, Tỉnh Hải Dương","path_with_type":"Xã Lê Ninh, Thị xã Kinh Môn, Tỉnh Hải Dương","code":"10684","parent_code":"292"},"10693":{"name":"Phường Phạm Thái","type":"phuong","slug":"phuong-pham-thai","name_with_type":"Phường Phạm Thái","path":"Phường Phạm Thái, Thị xã Kinh Môn, Tỉnh Hải Dương","path_with_type":"Phường Phạm Thái, Thị xã Kinh Môn, Tỉnh Hải Dương","code":"10693","parent_code":"292"},"10696":{"name":"Phường Duy Tân","type":"phuong","slug":"phuong-duy-tan","name_with_type":"Phường Duy Tân","path":"Phường Duy Tân, Thị xã Kinh Môn, Tỉnh Hải Dương","path_with_type":"Phường Duy Tân, Thị xã Kinh Môn, Tỉnh Hải Dương","code":"10696","parent_code":"292"},"10699":{"name":"Phường Tân Dân","type":"phuong","slug":"phuong-tan-dan","name_with_type":"Phường Tân Dân","path":"Phường Tân Dân, Thị xã Kinh Môn, Tỉnh Hải Dương","path_with_type":"Phường Tân Dân, Thị xã Kinh Môn, Tỉnh Hải Dương","code":"10699","parent_code":"292"},"10702":{"name":"Phường Minh Tân","type":"phuong","slug":"phuong-minh-tan","name_with_type":"Phường Minh Tân","path":"Phường Minh Tân, Thị xã Kinh Môn, Tỉnh Hải Dương","path_with_type":"Phường Minh Tân, Thị xã Kinh Môn, Tỉnh Hải Dương","code":"10702","parent_code":"292"},"10705":{"name":"Xã Quang Thành","type":"xa","slug":"xa-quang-thanh","name_with_type":"Xã Quang Thành","path":"Xã Quang Thành, Thị xã Kinh Môn, Tỉnh Hải Dương","path_with_type":"Xã Quang Thành, Thị xã Kinh Môn, Tỉnh Hải Dương","code":"10705","parent_code":"292"},"10708":{"name":"Xã Hiệp Hòa","type":"xa","slug":"xa-hiep-hoa","name_with_type":"Xã Hiệp Hòa","path":"Xã Hiệp Hòa, Thị xã Kinh Môn, Tỉnh Hải Dương","path_with_type":"Xã Hiệp Hòa, Thị xã Kinh Môn, Tỉnh Hải Dương","code":"10708","parent_code":"292"},"10714":{"name":"Phường Phú Thứ","type":"phuong","slug":"phuong-phu-thu","name_with_type":"Phường Phú Thứ","path":"Phường Phú Thứ, Thị xã Kinh Môn, Tỉnh Hải Dương","path_with_type":"Phường Phú Thứ, Thị xã Kinh Môn, Tỉnh Hải Dương","code":"10714","parent_code":"292"},"10717":{"name":"Xã Thăng Long","type":"xa","slug":"xa-thang-long","name_with_type":"Xã Thăng Long","path":"Xã Thăng Long, Thị xã Kinh Môn, Tỉnh Hải Dương","path_with_type":"Xã Thăng Long, Thị xã Kinh Môn, Tỉnh Hải Dương","code":"10717","parent_code":"292"},"10720":{"name":"Xã Lạc Long","type":"xa","slug":"xa-lac-long","name_with_type":"Xã Lạc Long","path":"Xã Lạc Long, Thị xã Kinh Môn, Tỉnh Hải Dương","path_with_type":"Xã Lạc Long, Thị xã Kinh Môn, Tỉnh Hải Dương","code":"10720","parent_code":"292"},"10723":{"name":"Phường An Sinh","type":"phuong","slug":"phuong-an-sinh","name_with_type":"Phường An Sinh","path":"Phường An Sinh, Thị xã Kinh Môn, Tỉnh Hải Dương","path_with_type":"Phường An Sinh, Thị xã Kinh Môn, Tỉnh Hải Dương","code":"10723","parent_code":"292"},"10726":{"name":"Phường Hiệp Sơn","type":"phuong","slug":"phuong-hiep-son","name_with_type":"Phường Hiệp Sơn","path":"Phường Hiệp Sơn, Thị xã Kinh Môn, Tỉnh Hải Dương","path_with_type":"Phường Hiệp Sơn, Thị xã Kinh Môn, Tỉnh Hải Dương","code":"10726","parent_code":"292"},"10729":{"name":"Xã Thượng Quận","type":"xa","slug":"xa-thuong-quan","name_with_type":"Xã Thượng Quận","path":"Xã Thượng Quận, Thị xã Kinh Môn, Tỉnh Hải Dương","path_with_type":"Xã Thượng Quận, Thị xã Kinh Môn, Tỉnh Hải Dương","code":"10729","parent_code":"292"},"10732":{"name":"Phường An Phụ","type":"phuong","slug":"phuong-an-phu","name_with_type":"Phường An Phụ","path":"Phường An Phụ, Thị xã Kinh Môn, Tỉnh Hải Dương","path_with_type":"Phường An Phụ, Thị xã Kinh Môn, Tỉnh Hải Dương","code":"10732","parent_code":"292"},"10735":{"name":"Phường Hiệp An","type":"phuong","slug":"phuong-hiep-an","name_with_type":"Phường Hiệp An","path":"Phường Hiệp An, Thị xã Kinh Môn, Tỉnh Hải Dương","path_with_type":"Phường Hiệp An, Thị xã Kinh Môn, Tỉnh Hải Dương","code":"10735","parent_code":"292"},"10738":{"name":"Phường Long Xuyên","type":"phuong","slug":"phuong-long-xuyen","name_with_type":"Phường Long Xuyên","path":"Phường Long Xuyên, Thị xã Kinh Môn, Tỉnh Hải Dương","path_with_type":"Phường Long Xuyên, Thị xã Kinh Môn, Tỉnh Hải Dương","code":"10738","parent_code":"292"},"10741":{"name":"Phường Thái Thịnh","type":"phuong","slug":"phuong-thai-thinh","name_with_type":"Phường Thái Thịnh","path":"Phường Thái Thịnh, Thị xã Kinh Môn, Tỉnh Hải Dương","path_with_type":"Phường Thái Thịnh, Thị xã Kinh Môn, Tỉnh Hải Dương","code":"10741","parent_code":"292"},"10744":{"name":"Phường Hiến Thành","type":"phuong","slug":"phuong-hien-thanh","name_with_type":"Phường Hiến Thành","path":"Phường Hiến Thành, Thị xã Kinh Môn, Tỉnh Hải Dương","path_with_type":"Phường Hiến Thành, Thị xã Kinh Môn, Tỉnh Hải Dương","code":"10744","parent_code":"292"},"10747":{"name":"Xã Minh Hòa","type":"xa","slug":"xa-minh-hoa","name_with_type":"Xã Minh Hòa","path":"Xã Minh Hòa, Thị xã Kinh Môn, Tỉnh Hải Dương","path_with_type":"Xã Minh Hòa, Thị xã Kinh Môn, Tỉnh Hải Dương","code":"10747","parent_code":"292"},"10750":{"name":"Thị trấn Phú Thái","type":"thi-tran","slug":"thi-tran-phu-thai","name_with_type":"Thị trấn Phú Thái","path":"Thị trấn Phú Thái, Huyện Kim Thành, Tỉnh Hải Dương","path_with_type":"Thị trấn Phú Thái, Huyện Kim Thành, Tỉnh Hải Dương","code":"10750","parent_code":"293"},"10756":{"name":"Xã Lai Khê","type":"xa","slug":"xa-lai-khe","name_with_type":"Xã Lai Khê","path":"Xã Lai Khê, Huyện Kim Thành, Tỉnh Hải Dương","path_with_type":"Xã Lai Khê, Huyện Kim Thành, Tỉnh Hải Dương","code":"10756","parent_code":"293"},"10762":{"name":"Xã Vũ Dũng","type":"xa","slug":"xa-vu-dung","name_with_type":"Xã Vũ Dũng","path":"Xã Vũ Dũng, Huyện Kim Thành, Tỉnh Hải Dương","path_with_type":"Xã Vũ Dũng, Huyện Kim Thành, Tỉnh Hải Dương","code":"10762","parent_code":"293"},"10768":{"name":"Xã Tuấn Việt","type":"xa","slug":"xa-tuan-viet","name_with_type":"Xã Tuấn Việt","path":"Xã Tuấn Việt, Huyện Kim Thành, Tỉnh Hải Dương","path_with_type":"Xã Tuấn Việt, Huyện Kim Thành, Tỉnh Hải Dương","code":"10768","parent_code":"293"},"10771":{"name":"Xã Kim Xuyên","type":"xa","slug":"xa-kim-xuyen","name_with_type":"Xã Kim Xuyên","path":"Xã Kim Xuyên, Huyện Kim Thành, Tỉnh Hải Dương","path_with_type":"Xã Kim Xuyên, Huyện Kim Thành, Tỉnh Hải Dương","code":"10771","parent_code":"293"},"10777":{"name":"Xã Ngũ Phúc","type":"xa","slug":"xa-ngu-phuc","name_with_type":"Xã Ngũ Phúc","path":"Xã Ngũ Phúc, Huyện Kim Thành, Tỉnh Hải Dương","path_with_type":"Xã Ngũ Phúc, Huyện Kim Thành, Tỉnh Hải Dương","code":"10777","parent_code":"293"},"10780":{"name":"Xã Kim Anh","type":"xa","slug":"xa-kim-anh","name_with_type":"Xã Kim Anh","path":"Xã Kim Anh, Huyện Kim Thành, Tỉnh Hải Dương","path_with_type":"Xã Kim Anh, Huyện Kim Thành, Tỉnh Hải Dương","code":"10780","parent_code":"293"},"10783":{"name":"Xã Kim Liên","type":"xa","slug":"xa-kim-lien","name_with_type":"Xã Kim Liên","path":"Xã Kim Liên, Huyện Kim Thành, Tỉnh Hải Dương","path_with_type":"Xã Kim Liên, Huyện Kim Thành, Tỉnh Hải Dương","code":"10783","parent_code":"293"},"10786":{"name":"Xã Kim Tân","type":"xa","slug":"xa-kim-tan","name_with_type":"Xã Kim Tân","path":"Xã Kim Tân, Huyện Kim Thành, Tỉnh Hải Dương","path_with_type":"Xã Kim Tân, Huyện Kim Thành, Tỉnh Hải Dương","code":"10786","parent_code":"293"},"10792":{"name":"Xã Kim Đính","type":"xa","slug":"xa-kim-dinh","name_with_type":"Xã Kim Đính","path":"Xã Kim Đính, Huyện Kim Thành, Tỉnh Hải Dương","path_with_type":"Xã Kim Đính, Huyện Kim Thành, Tỉnh Hải Dương","code":"10792","parent_code":"293"},"10798":{"name":"Xã Hòa Bình","type":"xa","slug":"xa-hoa-binh","name_with_type":"Xã Hòa Bình","path":"Xã Hòa Bình, Huyện Kim Thành, Tỉnh Hải Dương","path_with_type":"Xã Hòa Bình, Huyện Kim Thành, Tỉnh Hải Dương","code":"10798","parent_code":"293"},"10801":{"name":"Xã Tam Kỳ","type":"xa","slug":"xa-tam-ky","name_with_type":"Xã Tam Kỳ","path":"Xã Tam Kỳ, Huyện Kim Thành, Tỉnh Hải Dương","path_with_type":"Xã Tam Kỳ, Huyện Kim Thành, Tỉnh Hải Dương","code":"10801","parent_code":"293"},"10804":{"name":"Xã Đồng Cẩm","type":"xa","slug":"xa-dong-cam","name_with_type":"Xã Đồng Cẩm","path":"Xã Đồng Cẩm, Huyện Kim Thành, Tỉnh Hải Dương","path_with_type":"Xã Đồng Cẩm, Huyện Kim Thành, Tỉnh Hải Dương","code":"10804","parent_code":"293"},"10810":{"name":"Xã Đại Đức","type":"xa","slug":"xa-dai-duc","name_with_type":"Xã Đại Đức","path":"Xã Đại Đức, Huyện Kim Thành, Tỉnh Hải Dương","path_with_type":"Xã Đại Đức, Huyện Kim Thành, Tỉnh Hải Dương","code":"10810","parent_code":"293"},"10813":{"name":"Thị trấn Thanh Hà","type":"thi-tran","slug":"thi-tran-thanh-ha","name_with_type":"Thị trấn Thanh Hà","path":"Thị trấn Thanh Hà, Huyện Thanh Hà, Tỉnh Hải Dương","path_with_type":"Thị trấn Thanh Hà, Huyện Thanh Hà, Tỉnh Hải Dương","code":"10813","parent_code":"294"},"10816":{"name":"Xã Hồng Lạc","type":"xa","slug":"xa-hong-lac","name_with_type":"Xã Hồng Lạc","path":"Xã Hồng Lạc, Huyện Thanh Hà, Tỉnh Hải Dương","path_with_type":"Xã Hồng Lạc, Huyện Thanh Hà, Tỉnh Hải Dương","code":"10816","parent_code":"294"},"10822":{"name":"Xã Quyết Thắng","type":"xa","slug":"xa-quyet-thang","name_with_type":"Xã Quyết Thắng","path":"Xã Quyết Thắng, Thành phố Hải Dương, Tỉnh Hải Dương","path_with_type":"Xã Quyết Thắng, Thành phố Hải Dương, Tỉnh Hải Dương","code":"10822","parent_code":"288"},"10825":{"name":"Xã Tân Việt","type":"xa","slug":"xa-tan-viet","name_with_type":"Xã Tân Việt","path":"Xã Tân Việt, Huyện Thanh Hà, Tỉnh Hải Dương","path_with_type":"Xã Tân Việt, Huyện Thanh Hà, Tỉnh Hải Dương","code":"10825","parent_code":"294"},"10828":{"name":"Xã Cẩm Việt","type":"xa","slug":"xa-cam-viet","name_with_type":"Xã Cẩm Việt","path":"Xã Cẩm Việt, Huyện Thanh Hà, Tỉnh Hải Dương","path_with_type":"Xã Cẩm Việt, Huyện Thanh Hà, Tỉnh Hải Dương","code":"10828","parent_code":"294"},"10831":{"name":"Xã Thanh An","type":"xa","slug":"xa-thanh-an","name_with_type":"Xã Thanh An","path":"Xã Thanh An, Huyện Thanh Hà, Tỉnh Hải Dương","path_with_type":"Xã Thanh An, Huyện Thanh Hà, Tỉnh Hải Dương","code":"10831","parent_code":"294"},"10834":{"name":"Xã Thanh Lang","type":"xa","slug":"xa-thanh-lang","name_with_type":"Xã Thanh Lang","path":"Xã Thanh Lang, Huyện Thanh Hà, Tỉnh Hải Dương","path_with_type":"Xã Thanh Lang, Huyện Thanh Hà, Tỉnh Hải Dương","code":"10834","parent_code":"294"},"10837":{"name":"Xã Tiền Tiến","type":"xa","slug":"xa-tien-tien","name_with_type":"Xã Tiền Tiến","path":"Xã Tiền Tiến, Thành phố Hải Dương, Tỉnh Hải Dương","path_with_type":"Xã Tiền Tiến, Thành phố Hải Dương, Tỉnh Hải Dương","code":"10837","parent_code":"288"},"10840":{"name":"Xã Tân An","type":"xa","slug":"xa-tan-an","name_with_type":"Xã Tân An","path":"Xã Tân An, Huyện Thanh Hà, Tỉnh Hải Dương","path_with_type":"Xã Tân An, Huyện Thanh Hà, Tỉnh Hải Dương","code":"10840","parent_code":"294"},"10843":{"name":"Xã Liên Mạc","type":"xa","slug":"xa-lien-mac","name_with_type":"Xã Liên Mạc","path":"Xã Liên Mạc, Huyện Thanh Hà, Tỉnh Hải Dương","path_with_type":"Xã Liên Mạc, Huyện Thanh Hà, Tỉnh Hải Dương","code":"10843","parent_code":"294"},"10846":{"name":"Xã Thanh Hải","type":"xa","slug":"xa-thanh-hai","name_with_type":"Xã Thanh Hải","path":"Xã Thanh Hải, Huyện Thanh Hà, Tỉnh Hải Dương","path_with_type":"Xã Thanh Hải, Huyện Thanh Hà, Tỉnh Hải Dương","code":"10846","parent_code":"294"},"10855":{"name":"Xã Thanh Xuân","type":"xa","slug":"xa-thanh-xuan","name_with_type":"Xã Thanh Xuân","path":"Xã Thanh Xuân, Huyện Thanh Hà, Tỉnh Hải Dương","path_with_type":"Xã Thanh Xuân, Huyện Thanh Hà, Tỉnh Hải Dương","code":"10855","parent_code":"294"},"10861":{"name":"Xã Thanh Tân","type":"xa","slug":"xa-thanh-tan","name_with_type":"Xã Thanh Tân","path":"Xã Thanh Tân, Huyện Thanh Hà, Tỉnh Hải Dương","path_with_type":"Xã Thanh Tân, Huyện Thanh Hà, Tỉnh Hải Dương","code":"10861","parent_code":"294"},"10864":{"name":"Xã An Phượng","type":"xa","slug":"xa-an-phuong","name_with_type":"Xã An Phượng","path":"Xã An Phượng, Huyện Thanh Hà, Tỉnh Hải Dương","path_with_type":"Xã An Phượng, Huyện Thanh Hà, Tỉnh Hải Dương","code":"10864","parent_code":"294"},"10867":{"name":"Xã Thanh Sơn","type":"xa","slug":"xa-thanh-son","name_with_type":"Xã Thanh Sơn","path":"Xã Thanh Sơn, Huyện Thanh Hà, Tỉnh Hải Dương","path_with_type":"Xã Thanh Sơn, Huyện Thanh Hà, Tỉnh Hải Dương","code":"10867","parent_code":"294"},"10876":{"name":"Xã Thanh Quang","type":"xa","slug":"xa-thanh-quang","name_with_type":"Xã Thanh Quang","path":"Xã Thanh Quang, Huyện Thanh Hà, Tỉnh Hải Dương","path_with_type":"Xã Thanh Quang, Huyện Thanh Hà, Tỉnh Hải Dương","code":"10876","parent_code":"294"},"10879":{"name":"Xã Thanh Hồng","type":"xa","slug":"xa-thanh-hong","name_with_type":"Xã Thanh Hồng","path":"Xã Thanh Hồng, Huyện Thanh Hà, Tỉnh Hải Dương","path_with_type":"Xã Thanh Hồng, Huyện Thanh Hà, Tỉnh Hải Dương","code":"10879","parent_code":"294"},"10882":{"name":"Xã Vĩnh Cường","type":"xa","slug":"xa-vinh-cuong","name_with_type":"Xã Vĩnh Cường","path":"Xã Vĩnh Cường, Huyện Thanh Hà, Tỉnh Hải Dương","path_with_type":"Xã Vĩnh Cường, Huyện Thanh Hà, Tỉnh Hải Dương","code":"10882","parent_code":"294"},"10888":{"name":"Thị trấn Cẩm Giang","type":"thi-tran","slug":"thi-tran-cam-giang","name_with_type":"Thị trấn Cẩm Giang","path":"Thị trấn Cẩm Giang, Huyện Cẩm Giàng, Tỉnh Hải Dương","path_with_type":"Thị trấn Cẩm Giang, Huyện Cẩm Giàng, Tỉnh Hải Dương","code":"10888","parent_code":"295"},"10891":{"name":"Thị trấn Lai Cách","type":"thi-tran","slug":"thi-tran-lai-cach","name_with_type":"Thị trấn Lai Cách","path":"Thị trấn Lai Cách, Huyện Cẩm Giàng, Tỉnh Hải Dương","path_with_type":"Thị trấn Lai Cách, Huyện Cẩm Giàng, Tỉnh Hải Dương","code":"10891","parent_code":"295"},"10894":{"name":"Xã Cẩm Hưng","type":"xa","slug":"xa-cam-hung","name_with_type":"Xã Cẩm Hưng","path":"Xã Cẩm Hưng, Huyện Cẩm Giàng, Tỉnh Hải Dương","path_with_type":"Xã Cẩm Hưng, Huyện Cẩm Giàng, Tỉnh Hải Dương","code":"10894","parent_code":"295"},"10897":{"name":"Xã Cẩm Hoàng","type":"xa","slug":"xa-cam-hoang","name_with_type":"Xã Cẩm Hoàng","path":"Xã Cẩm Hoàng, Huyện Cẩm Giàng, Tỉnh Hải Dương","path_with_type":"Xã Cẩm Hoàng, Huyện Cẩm Giàng, Tỉnh Hải Dương","code":"10897","parent_code":"295"},"10900":{"name":"Xã Cẩm Văn","type":"xa","slug":"xa-cam-van","name_with_type":"Xã Cẩm Văn","path":"Xã Cẩm Văn, Huyện Cẩm Giàng, Tỉnh Hải Dương","path_with_type":"Xã Cẩm Văn, Huyện Cẩm Giàng, Tỉnh Hải Dương","code":"10900","parent_code":"295"},"10903":{"name":"Xã Ngọc Liên","type":"xa","slug":"xa-ngoc-lien","name_with_type":"Xã Ngọc Liên","path":"Xã Ngọc Liên, Huyện Cẩm Giàng, Tỉnh Hải Dương","path_with_type":"Xã Ngọc Liên, Huyện Cẩm Giàng, Tỉnh Hải Dương","code":"10903","parent_code":"295"},"10909":{"name":"Xã Cẩm Vũ","type":"xa","slug":"xa-cam-vu","name_with_type":"Xã Cẩm Vũ","path":"Xã Cẩm Vũ, Huyện Cẩm Giàng, Tỉnh Hải Dương","path_with_type":"Xã Cẩm Vũ, Huyện Cẩm Giàng, Tỉnh Hải Dương","code":"10909","parent_code":"295"},"10912":{"name":"Xã Đức Chính","type":"xa","slug":"xa-duc-chinh","name_with_type":"Xã Đức Chính","path":"Xã Đức Chính, Huyện Cẩm Giàng, Tỉnh Hải Dương","path_with_type":"Xã Đức Chính, Huyện Cẩm Giàng, Tỉnh Hải Dương","code":"10912","parent_code":"295"},"10918":{"name":"Xã Định Sơn","type":"xa","slug":"xa-dinh-son","name_with_type":"Xã Định Sơn","path":"Xã Định Sơn, Huyện Cẩm Giàng, Tỉnh Hải Dương","path_with_type":"Xã Định Sơn, Huyện Cẩm Giàng, Tỉnh Hải Dương","code":"10918","parent_code":"295"},"10924":{"name":"Xã Lương Điền","type":"xa","slug":"xa-luong-dien","name_with_type":"Xã Lương Điền","path":"Xã Lương Điền, Huyện Cẩm Giàng, Tỉnh Hải Dương","path_with_type":"Xã Lương Điền, Huyện Cẩm Giàng, Tỉnh Hải Dương","code":"10924","parent_code":"295"},"10927":{"name":"Xã Cao An","type":"xa","slug":"xa-cao-an","name_with_type":"Xã Cao An","path":"Xã Cao An, Huyện Cẩm Giàng, Tỉnh Hải Dương","path_with_type":"Xã Cao An, Huyện Cẩm Giàng, Tỉnh Hải Dương","code":"10927","parent_code":"295"},"10930":{"name":"Xã Tân Trường","type":"xa","slug":"xa-tan-truong","name_with_type":"Xã Tân Trường","path":"Xã Tân Trường, Huyện Cẩm Giàng, Tỉnh Hải Dương","path_with_type":"Xã Tân Trường, Huyện Cẩm Giàng, Tỉnh Hải Dương","code":"10930","parent_code":"295"},"10933":{"name":"Xã Phúc Điền","type":"xa","slug":"xa-phuc-dien","name_with_type":"Xã Phúc Điền","path":"Xã Phúc Điền, Huyện Cẩm Giàng, Tỉnh Hải Dương","path_with_type":"Xã Phúc Điền, Huyện Cẩm Giàng, Tỉnh Hải Dương","code":"10933","parent_code":"295"},"10939":{"name":"Xã Cẩm Đông","type":"xa","slug":"xa-cam-dong","name_with_type":"Xã Cẩm Đông","path":"Xã Cẩm Đông, Huyện Cẩm Giàng, Tỉnh Hải Dương","path_with_type":"Xã Cẩm Đông, Huyện Cẩm Giàng, Tỉnh Hải Dương","code":"10939","parent_code":"295"},"10942":{"name":"Xã Cẩm Đoài","type":"xa","slug":"xa-cam-doai","name_with_type":"Xã Cẩm Đoài","path":"Xã Cẩm Đoài, Huyện Cẩm Giàng, Tỉnh Hải Dương","path_with_type":"Xã Cẩm Đoài, Huyện Cẩm Giàng, Tỉnh Hải Dương","code":"10942","parent_code":"295"},"10945":{"name":"Thị trấn Kẻ Sặt","type":"thi-tran","slug":"thi-tran-ke-sat","name_with_type":"Thị trấn Kẻ Sặt","path":"Thị trấn Kẻ Sặt, Huyện Bình Giang, Tỉnh Hải Dương","path_with_type":"Thị trấn Kẻ Sặt, Huyện Bình Giang, Tỉnh Hải Dương","code":"10945","parent_code":"296"},"10951":{"name":"Xã Vĩnh Hưng","type":"xa","slug":"xa-vinh-hung","name_with_type":"Xã Vĩnh Hưng","path":"Xã Vĩnh Hưng, Huyện Bình Giang, Tỉnh Hải Dương","path_with_type":"Xã Vĩnh Hưng, Huyện Bình Giang, Tỉnh Hải Dương","code":"10951","parent_code":"296"},"10954":{"name":"Xã Hùng Thắng","type":"xa","slug":"xa-hung-thang","name_with_type":"Xã Hùng Thắng","path":"Xã Hùng Thắng, Huyện Bình Giang, Tỉnh Hải Dương","path_with_type":"Xã Hùng Thắng, Huyện Bình Giang, Tỉnh Hải Dương","code":"10954","parent_code":"296"},"10960":{"name":"Xã Vĩnh Hồng","type":"xa","slug":"xa-vinh-hong","name_with_type":"Xã Vĩnh Hồng","path":"Xã Vĩnh Hồng, Huyện Bình Giang, Tỉnh Hải Dương","path_with_type":"Xã Vĩnh Hồng, Huyện Bình Giang, Tỉnh Hải Dương","code":"10960","parent_code":"296"},"10963":{"name":"Xã Long Xuyên","type":"xa","slug":"xa-long-xuyen","name_with_type":"Xã Long Xuyên","path":"Xã Long Xuyên, Huyện Bình Giang, Tỉnh Hải Dương","path_with_type":"Xã Long Xuyên, Huyện Bình Giang, Tỉnh Hải Dương","code":"10963","parent_code":"296"},"10966":{"name":"Xã Tân Việt","type":"xa","slug":"xa-tan-viet","name_with_type":"Xã Tân Việt","path":"Xã Tân Việt, Huyện Bình Giang, Tỉnh Hải Dương","path_with_type":"Xã Tân Việt, Huyện Bình Giang, Tỉnh Hải Dương","code":"10966","parent_code":"296"},"10969":{"name":"Xã Thúc Kháng","type":"xa","slug":"xa-thuc-khang","name_with_type":"Xã Thúc Kháng","path":"Xã Thúc Kháng, Huyện Bình Giang, Tỉnh Hải Dương","path_with_type":"Xã Thúc Kháng, Huyện Bình Giang, Tỉnh Hải Dương","code":"10969","parent_code":"296"},"10972":{"name":"Xã Tân Hồng","type":"xa","slug":"xa-tan-hong","name_with_type":"Xã Tân Hồng","path":"Xã Tân Hồng, Huyện Bình Giang, Tỉnh Hải Dương","path_with_type":"Xã Tân Hồng, Huyện Bình Giang, Tỉnh Hải Dương","code":"10972","parent_code":"296"},"10978":{"name":"Xã Hồng Khê","type":"xa","slug":"xa-hong-khe","name_with_type":"Xã Hồng Khê","path":"Xã Hồng Khê, Huyện Bình Giang, Tỉnh Hải Dương","path_with_type":"Xã Hồng Khê, Huyện Bình Giang, Tỉnh Hải Dương","code":"10978","parent_code":"296"},"10981":{"name":"Xã Thái Minh","type":"xa","slug":"xa-thai-minh","name_with_type":"Xã Thái Minh","path":"Xã Thái Minh, Huyện Bình Giang, Tỉnh Hải Dương","path_with_type":"Xã Thái Minh, Huyện Bình Giang, Tỉnh Hải Dương","code":"10981","parent_code":"296"},"10984":{"name":"Xã Cổ Bì","type":"xa","slug":"xa-co-bi","name_with_type":"Xã Cổ Bì","path":"Xã Cổ Bì, Huyện Bình Giang, Tỉnh Hải Dương","path_with_type":"Xã Cổ Bì, Huyện Bình Giang, Tỉnh Hải Dương","code":"10984","parent_code":"296"},"10987":{"name":"Xã Nhân Quyền","type":"xa","slug":"xa-nhan-quyen","name_with_type":"Xã Nhân Quyền","path":"Xã Nhân Quyền, Huyện Bình Giang, Tỉnh Hải Dương","path_with_type":"Xã Nhân Quyền, Huyện Bình Giang, Tỉnh Hải Dương","code":"10987","parent_code":"296"},"10990":{"name":"Xã Thái Dương","type":"xa","slug":"xa-thai-duong","name_with_type":"Xã Thái Dương","path":"Xã Thái Dương, Huyện Bình Giang, Tỉnh Hải Dương","path_with_type":"Xã Thái Dương, Huyện Bình Giang, Tỉnh Hải Dương","code":"10990","parent_code":"296"},"10993":{"name":"Xã Thái Hòa","type":"xa","slug":"xa-thai-hoa","name_with_type":"Xã Thái Hòa","path":"Xã Thái Hòa, Huyện Bình Giang, Tỉnh Hải Dương","path_with_type":"Xã Thái Hòa, Huyện Bình Giang, Tỉnh Hải Dương","code":"10993","parent_code":"296"},"10996":{"name":"Xã Bình Xuyên","type":"xa","slug":"xa-binh-xuyen","name_with_type":"Xã Bình Xuyên","path":"Xã Bình Xuyên, Huyện Bình Giang, Tỉnh Hải Dương","path_with_type":"Xã Bình Xuyên, Huyện Bình Giang, Tỉnh Hải Dương","code":"10996","parent_code":"296"},"10999":{"name":"Thị trấn Gia Lộc","type":"thi-tran","slug":"thi-tran-gia-loc","name_with_type":"Thị trấn Gia Lộc","path":"Thị trấn Gia Lộc, Huyện Gia Lộc, Tỉnh Hải Dương","path_with_type":"Thị trấn Gia Lộc, Huyện Gia Lộc, Tỉnh Hải Dương","code":"10999","parent_code":"297"},"11002":{"name":"Phường Thạch Khôi","type":"phuong","slug":"phuong-thach-khoi","name_with_type":"Phường Thạch Khôi","path":"Phường Thạch Khôi, Thành phố Hải Dương, Tỉnh Hải Dương","path_with_type":"Phường Thạch Khôi, Thành phố Hải Dương, Tỉnh Hải Dương","code":"11002","parent_code":"288"},"11005":{"name":"Xã Liên Hồng","type":"xa","slug":"xa-lien-hong","name_with_type":"Xã Liên Hồng","path":"Xã Liên Hồng, Thành phố Hải Dương, Tỉnh Hải Dương","path_with_type":"Xã Liên Hồng, Thành phố Hải Dương, Tỉnh Hải Dương","code":"11005","parent_code":"288"},"11008":{"name":"Xã Thống Nhất","type":"xa","slug":"xa-thong-nhat","name_with_type":"Xã Thống Nhất","path":"Xã Thống Nhất, Huyện Gia Lộc, Tỉnh Hải Dương","path_with_type":"Xã Thống Nhất, Huyện Gia Lộc, Tỉnh Hải Dương","code":"11008","parent_code":"297"},"11011":{"name":"Phường Tân Hưng","type":"phuong","slug":"phuong-tan-hung","name_with_type":"Phường Tân Hưng","path":"Phường Tân Hưng, Thành phố Hải Dương, Tỉnh Hải Dương","path_with_type":"Phường Tân Hưng, Thành phố Hải Dương, Tỉnh Hải Dương","code":"11011","parent_code":"288"},"11017":{"name":"Xã Gia Xuyên","type":"xa","slug":"xa-gia-xuyen","name_with_type":"Xã Gia Xuyên","path":"Xã Gia Xuyên, Thành phố Hải Dương, Tỉnh Hải Dương","path_with_type":"Xã Gia Xuyên, Thành phố Hải Dương, Tỉnh Hải Dương","code":"11017","parent_code":"288"},"11020":{"name":"Xã Yết Kiêu","type":"xa","slug":"xa-yet-kieu","name_with_type":"Xã Yết Kiêu","path":"Xã Yết Kiêu, Huyện Gia Lộc, Tỉnh Hải Dương","path_with_type":"Xã Yết Kiêu, Huyện Gia Lộc, Tỉnh Hải Dương","code":"11020","parent_code":"297"},"11035":{"name":"Xã Gia Phúc","type":"xa","slug":"xa-gia-phuc","name_with_type":"Xã Gia Phúc","path":"Xã Gia Phúc, Huyện Gia Lộc, Tỉnh Hải Dương","path_with_type":"Xã Gia Phúc, Huyện Gia Lộc, Tỉnh Hải Dương","code":"11035","parent_code":"297"},"11038":{"name":"Xã Gia Tiến","type":"xa","slug":"xa-gia-tien","name_with_type":"Xã Gia Tiến","path":"Xã Gia Tiến, Huyện Gia Lộc, Tỉnh Hải Dương","path_with_type":"Xã Gia Tiến, Huyện Gia Lộc, Tỉnh Hải Dương","code":"11038","parent_code":"297"},"11041":{"name":"Xã Lê Lợi","type":"xa","slug":"xa-le-loi","name_with_type":"Xã Lê Lợi","path":"Xã Lê Lợi, Huyện Gia Lộc, Tỉnh Hải Dương","path_with_type":"Xã Lê Lợi, Huyện Gia Lộc, Tỉnh Hải Dương","code":"11041","parent_code":"297"},"11044":{"name":"Xã Toàn Thắng","type":"xa","slug":"xa-toan-thang","name_with_type":"Xã Toàn Thắng","path":"Xã Toàn Thắng, Huyện Gia Lộc, Tỉnh Hải Dương","path_with_type":"Xã Toàn Thắng, Huyện Gia Lộc, Tỉnh Hải Dương","code":"11044","parent_code":"297"},"11047":{"name":"Xã Hoàng Diệu","type":"xa","slug":"xa-hoang-dieu","name_with_type":"Xã Hoàng Diệu","path":"Xã Hoàng Diệu, Huyện Gia Lộc, Tỉnh Hải Dương","path_with_type":"Xã Hoàng Diệu, Huyện Gia Lộc, Tỉnh Hải Dương","code":"11047","parent_code":"297"},"11050":{"name":"Xã Hồng Hưng","type":"xa","slug":"xa-hong-hung","name_with_type":"Xã Hồng Hưng","path":"Xã Hồng Hưng, Huyện Gia Lộc, Tỉnh Hải Dương","path_with_type":"Xã Hồng Hưng, Huyện Gia Lộc, Tỉnh Hải Dương","code":"11050","parent_code":"297"},"11053":{"name":"Xã Phạm Trấn","type":"xa","slug":"xa-pham-tran","name_with_type":"Xã Phạm Trấn","path":"Xã Phạm Trấn, Huyện Gia Lộc, Tỉnh Hải Dương","path_with_type":"Xã Phạm Trấn, Huyện Gia Lộc, Tỉnh Hải Dương","code":"11053","parent_code":"297"},"11056":{"name":"Xã Đoàn Thượng","type":"xa","slug":"xa-doan-thuong","name_with_type":"Xã Đoàn Thượng","path":"Xã Đoàn Thượng, Huyện Gia Lộc, Tỉnh Hải Dương","path_with_type":"Xã Đoàn Thượng, Huyện Gia Lộc, Tỉnh Hải Dương","code":"11056","parent_code":"297"},"11059":{"name":"Xã Thống Kênh","type":"xa","slug":"xa-thong-kenh","name_with_type":"Xã Thống Kênh","path":"Xã Thống Kênh, Huyện Gia Lộc, Tỉnh Hải Dương","path_with_type":"Xã Thống Kênh, Huyện Gia Lộc, Tỉnh Hải Dương","code":"11059","parent_code":"297"},"11065":{"name":"Xã Nhật Quang","type":"xa","slug":"xa-nhat-quang","name_with_type":"Xã Nhật Quang","path":"Xã Nhật Quang, Huyện Gia Lộc, Tỉnh Hải Dương","path_with_type":"Xã Nhật Quang, Huyện Gia Lộc, Tỉnh Hải Dương","code":"11065","parent_code":"297"},"11071":{"name":"Xã Quang Đức","type":"xa","slug":"xa-quang-duc","name_with_type":"Xã Quang Đức","path":"Xã Quang Đức, Huyện Gia Lộc, Tỉnh Hải Dương","path_with_type":"Xã Quang Đức, Huyện Gia Lộc, Tỉnh Hải Dương","code":"11071","parent_code":"297"},"11074":{"name":"Thị trấn Tứ Kỳ","type":"thi-tran","slug":"thi-tran-tu-ky","name_with_type":"Thị trấn Tứ Kỳ","path":"Thị trấn Tứ Kỳ, Huyện Tứ Kỳ, Tỉnh Hải Dương","path_with_type":"Thị trấn Tứ Kỳ, Huyện Tứ Kỳ, Tỉnh Hải Dương","code":"11074","parent_code":"298"},"11077":{"name":"Xã Ngọc Sơn","type":"xa","slug":"xa-ngoc-son","name_with_type":"Xã Ngọc Sơn","path":"Xã Ngọc Sơn, Thành phố Hải Dương, Tỉnh Hải Dương","path_with_type":"Xã Ngọc Sơn, Thành phố Hải Dương, Tỉnh Hải Dương","code":"11077","parent_code":"288"},"11083":{"name":"Xã Đại Sơn","type":"xa","slug":"xa-dai-son","name_with_type":"Xã Đại Sơn","path":"Xã Đại Sơn, Huyện Tứ Kỳ, Tỉnh Hải Dương","path_with_type":"Xã Đại Sơn, Huyện Tứ Kỳ, Tỉnh Hải Dương","code":"11083","parent_code":"298"},"11086":{"name":"Xã Hưng Đạo","type":"xa","slug":"xa-hung-dao","name_with_type":"Xã Hưng Đạo","path":"Xã Hưng Đạo, Huyện Tứ Kỳ, Tỉnh Hải Dương","path_with_type":"Xã Hưng Đạo, Huyện Tứ Kỳ, Tỉnh Hải Dương","code":"11086","parent_code":"298"},"11092":{"name":"Xã Bình Lăng","type":"xa","slug":"xa-binh-lang","name_with_type":"Xã Bình Lăng","path":"Xã Bình Lăng, Huyện Tứ Kỳ, Tỉnh Hải Dương","path_with_type":"Xã Bình Lăng, Huyện Tứ Kỳ, Tỉnh Hải Dương","code":"11092","parent_code":"298"},"11095":{"name":"Xã Chí Minh","type":"xa","slug":"xa-chi-minh","name_with_type":"Xã Chí Minh","path":"Xã Chí Minh, Huyện Tứ Kỳ, Tỉnh Hải Dương","path_with_type":"Xã Chí Minh, Huyện Tứ Kỳ, Tỉnh Hải Dương","code":"11095","parent_code":"298"},"11098":{"name":"Xã Kỳ Sơn","type":"xa","slug":"xa-ky-son","name_with_type":"Xã Kỳ Sơn","path":"Xã Kỳ Sơn, Huyện Tứ Kỳ, Tỉnh Hải Dương","path_with_type":"Xã Kỳ Sơn, Huyện Tứ Kỳ, Tỉnh Hải Dương","code":"11098","parent_code":"298"},"11101":{"name":"Xã Quang Phục","type":"xa","slug":"xa-quang-phuc","name_with_type":"Xã Quang Phục","path":"Xã Quang Phục, Huyện Tứ Kỳ, Tỉnh Hải Dương","path_with_type":"Xã Quang Phục, Huyện Tứ Kỳ, Tỉnh Hải Dương","code":"11101","parent_code":"298"},"11113":{"name":"Xã Tân Kỳ","type":"xa","slug":"xa-tan-ky","name_with_type":"Xã Tân Kỳ","path":"Xã Tân Kỳ, Huyện Tứ Kỳ, Tỉnh Hải Dương","path_with_type":"Xã Tân Kỳ, Huyện Tứ Kỳ, Tỉnh Hải Dương","code":"11113","parent_code":"298"},"11116":{"name":"Xã Quang Khải","type":"xa","slug":"xa-quang-khai","name_with_type":"Xã Quang Khải","path":"Xã Quang Khải, Huyện Tứ Kỳ, Tỉnh Hải Dương","path_with_type":"Xã Quang Khải, Huyện Tứ Kỳ, Tỉnh Hải Dương","code":"11116","parent_code":"298"},"11119":{"name":"Xã Đại Hợp","type":"xa","slug":"xa-dai-hop","name_with_type":"Xã Đại Hợp","path":"Xã Đại Hợp, Huyện Tứ Kỳ, Tỉnh Hải Dương","path_with_type":"Xã Đại Hợp, Huyện Tứ Kỳ, Tỉnh Hải Dương","code":"11119","parent_code":"298"},"11122":{"name":"Xã Dân An","type":"xa","slug":"xa-dan-an","name_with_type":"Xã Dân An","path":"Xã Dân An, Huyện Tứ Kỳ, Tỉnh Hải Dương","path_with_type":"Xã Dân An, Huyện Tứ Kỳ, Tỉnh Hải Dương","code":"11122","parent_code":"298"},"11125":{"name":"Xã An Thanh","type":"xa","slug":"xa-an-thanh","name_with_type":"Xã An Thanh","path":"Xã An Thanh, Huyện Tứ Kỳ, Tỉnh Hải Dương","path_with_type":"Xã An Thanh, Huyện Tứ Kỳ, Tỉnh Hải Dương","code":"11125","parent_code":"298"},"11128":{"name":"Xã Minh Đức","type":"xa","slug":"xa-minh-duc","name_with_type":"Xã Minh Đức","path":"Xã Minh Đức, Huyện Tứ Kỳ, Tỉnh Hải Dương","path_with_type":"Xã Minh Đức, Huyện Tứ Kỳ, Tỉnh Hải Dương","code":"11128","parent_code":"298"},"11131":{"name":"Xã Văn Tố","type":"xa","slug":"xa-van-to","name_with_type":"Xã Văn Tố","path":"Xã Văn Tố, Huyện Tứ Kỳ, Tỉnh Hải Dương","path_with_type":"Xã Văn Tố, Huyện Tứ Kỳ, Tỉnh Hải Dương","code":"11131","parent_code":"298"},"11134":{"name":"Xã Quang Trung","type":"xa","slug":"xa-quang-trung","name_with_type":"Xã Quang Trung","path":"Xã Quang Trung, Huyện Tứ Kỳ, Tỉnh Hải Dương","path_with_type":"Xã Quang Trung, Huyện Tứ Kỳ, Tỉnh Hải Dương","code":"11134","parent_code":"298"},"11140":{"name":"Xã Lạc Phượng","type":"xa","slug":"xa-lac-phuong","name_with_type":"Xã Lạc Phượng","path":"Xã Lạc Phượng, Huyện Tứ Kỳ, Tỉnh Hải Dương","path_with_type":"Xã Lạc Phượng, Huyện Tứ Kỳ, Tỉnh Hải Dương","code":"11140","parent_code":"298"},"11143":{"name":"Xã Tiên Động","type":"xa","slug":"xa-tien-dong","name_with_type":"Xã Tiên Động","path":"Xã Tiên Động, Huyện Tứ Kỳ, Tỉnh Hải Dương","path_with_type":"Xã Tiên Động, Huyện Tứ Kỳ, Tỉnh Hải Dương","code":"11143","parent_code":"298"},"11146":{"name":"Xã Nguyên Giáp","type":"xa","slug":"xa-nguyen-giap","name_with_type":"Xã Nguyên Giáp","path":"Xã Nguyên Giáp, Huyện Tứ Kỳ, Tỉnh Hải Dương","path_with_type":"Xã Nguyên Giáp, Huyện Tứ Kỳ, Tỉnh Hải Dương","code":"11146","parent_code":"298"},"11149":{"name":"Xã Hà Kỳ","type":"xa","slug":"xa-ha-ky","name_with_type":"Xã Hà Kỳ","path":"Xã Hà Kỳ, Huyện Tứ Kỳ, Tỉnh Hải Dương","path_with_type":"Xã Hà Kỳ, Huyện Tứ Kỳ, Tỉnh Hải Dương","code":"11149","parent_code":"298"},"11152":{"name":"Xã Hà Thanh","type":"xa","slug":"xa-ha-thanh","name_with_type":"Xã Hà Thanh","path":"Xã Hà Thanh, Huyện Tứ Kỳ, Tỉnh Hải Dương","path_with_type":"Xã Hà Thanh, Huyện Tứ Kỳ, Tỉnh Hải Dương","code":"11152","parent_code":"298"},"11161":{"name":"Xã Ứng Hoè","type":"xa","slug":"xa-ung-hoe","name_with_type":"Xã Ứng Hoè","path":"Xã Ứng Hoè, Huyện Ninh Giang, Tỉnh Hải Dương","path_with_type":"Xã Ứng Hoè, Huyện Ninh Giang, Tỉnh Hải Dương","code":"11161","parent_code":"299"},"11164":{"name":"Xã Nghĩa An","type":"xa","slug":"xa-nghia-an","name_with_type":"Xã Nghĩa An","path":"Xã Nghĩa An, Huyện Ninh Giang, Tỉnh Hải Dương","path_with_type":"Xã Nghĩa An, Huyện Ninh Giang, Tỉnh Hải Dương","code":"11164","parent_code":"299"},"11167":{"name":"Xã Đức Phúc","type":"xa","slug":"xa-duc-phuc","name_with_type":"Xã Đức Phúc","path":"Xã Đức Phúc, Huyện Ninh Giang, Tỉnh Hải Dương","path_with_type":"Xã Đức Phúc, Huyện Ninh Giang, Tỉnh Hải Dương","code":"11167","parent_code":"299"},"11173":{"name":"Xã An Đức","type":"xa","slug":"xa-an-duc","name_with_type":"Xã An Đức","path":"Xã An Đức, Huyện Ninh Giang, Tỉnh Hải Dương","path_with_type":"Xã An Đức, Huyện Ninh Giang, Tỉnh Hải Dương","code":"11173","parent_code":"299"},"11179":{"name":"Xã Tân Hương","type":"xa","slug":"xa-tan-huong","name_with_type":"Xã Tân Hương","path":"Xã Tân Hương, Huyện Ninh Giang, Tỉnh Hải Dương","path_with_type":"Xã Tân Hương, Huyện Ninh Giang, Tỉnh Hải Dương","code":"11179","parent_code":"299"},"11185":{"name":"Xã Vĩnh Hòa","type":"xa","slug":"xa-vinh-hoa","name_with_type":"Xã Vĩnh Hòa","path":"Xã Vĩnh Hòa, Huyện Ninh Giang, Tỉnh Hải Dương","path_with_type":"Xã Vĩnh Hòa, Huyện Ninh Giang, Tỉnh Hải Dương","code":"11185","parent_code":"299"},"11188":{"name":"Xã Bình Xuyên","type":"xa","slug":"xa-binh-xuyen","name_with_type":"Xã Bình Xuyên","path":"Xã Bình Xuyên, Huyện Ninh Giang, Tỉnh Hải Dương","path_with_type":"Xã Bình Xuyên, Huyện Ninh Giang, Tỉnh Hải Dương","code":"11188","parent_code":"299"},"11197":{"name":"Xã Tân Phong","type":"xa","slug":"xa-tan-phong","name_with_type":"Xã Tân Phong","path":"Xã Tân Phong, Huyện Ninh Giang, Tỉnh Hải Dương","path_with_type":"Xã Tân Phong, Huyện Ninh Giang, Tỉnh Hải Dương","code":"11197","parent_code":"299"},"11203":{"name":"Thị trấn Ninh Giang","type":"thi-tran","slug":"thi-tran-ninh-giang","name_with_type":"Thị trấn Ninh Giang","path":"Thị trấn Ninh Giang, Huyện Ninh Giang, Tỉnh Hải Dương","path_with_type":"Thị trấn Ninh Giang, Huyện Ninh Giang, Tỉnh Hải Dương","code":"11203","parent_code":"299"},"11206":{"name":"Xã Tân Quang","type":"xa","slug":"xa-tan-quang","name_with_type":"Xã Tân Quang","path":"Xã Tân Quang, Huyện Ninh Giang, Tỉnh Hải Dương","path_with_type":"Xã Tân Quang, Huyện Ninh Giang, Tỉnh Hải Dương","code":"11206","parent_code":"299"},"11215":{"name":"Xã Hồng Dụ","type":"xa","slug":"xa-hong-du","name_with_type":"Xã Hồng Dụ","path":"Xã Hồng Dụ, Huyện Ninh Giang, Tỉnh Hải Dương","path_with_type":"Xã Hồng Dụ, Huyện Ninh Giang, Tỉnh Hải Dương","code":"11215","parent_code":"299"},"11218":{"name":"Xã Văn Hội","type":"xa","slug":"xa-van-hoi","name_with_type":"Xã Văn Hội","path":"Xã Văn Hội, Huyện Ninh Giang, Tỉnh Hải Dương","path_with_type":"Xã Văn Hội, Huyện Ninh Giang, Tỉnh Hải Dương","code":"11218","parent_code":"299"},"11224":{"name":"Xã Hồng Phong","type":"xa","slug":"xa-hong-phong","name_with_type":"Xã Hồng Phong","path":"Xã Hồng Phong, Huyện Ninh Giang, Tỉnh Hải Dương","path_with_type":"Xã Hồng Phong, Huyện Ninh Giang, Tỉnh Hải Dương","code":"11224","parent_code":"299"},"11227":{"name":"Xã Hiệp Lực","type":"xa","slug":"xa-hiep-luc","name_with_type":"Xã Hiệp Lực","path":"Xã Hiệp Lực, Huyện Ninh Giang, Tỉnh Hải Dương","path_with_type":"Xã Hiệp Lực, Huyện Ninh Giang, Tỉnh Hải Dương","code":"11227","parent_code":"299"},"11230":{"name":"Xã Kiến Phúc","type":"xa","slug":"xa-kien-phuc","name_with_type":"Xã Kiến Phúc","path":"Xã Kiến Phúc, Huyện Ninh Giang, Tỉnh Hải Dương","path_with_type":"Xã Kiến Phúc, Huyện Ninh Giang, Tỉnh Hải Dương","code":"11230","parent_code":"299"},"11233":{"name":"Xã Hưng Long","type":"xa","slug":"xa-hung-long","name_with_type":"Xã Hưng Long","path":"Xã Hưng Long, Huyện Ninh Giang, Tỉnh Hải Dương","path_with_type":"Xã Hưng Long, Huyện Ninh Giang, Tỉnh Hải Dương","code":"11233","parent_code":"299"},"11239":{"name":"Thị trấn Thanh Miện","type":"thi-tran","slug":"thi-tran-thanh-mien","name_with_type":"Thị trấn Thanh Miện","path":"Thị trấn Thanh Miện, Huyện Thanh Miện, Tỉnh Hải Dương","path_with_type":"Thị trấn Thanh Miện, Huyện Thanh Miện, Tỉnh Hải Dương","code":"11239","parent_code":"300"},"11242":{"name":"Xã Thanh Tùng","type":"xa","slug":"xa-thanh-tung","name_with_type":"Xã Thanh Tùng","path":"Xã Thanh Tùng, Huyện Thanh Miện, Tỉnh Hải Dương","path_with_type":"Xã Thanh Tùng, Huyện Thanh Miện, Tỉnh Hải Dương","code":"11242","parent_code":"300"},"11245":{"name":"Xã Phạm Kha","type":"xa","slug":"xa-pham-kha","name_with_type":"Xã Phạm Kha","path":"Xã Phạm Kha, Huyện Thanh Miện, Tỉnh Hải Dương","path_with_type":"Xã Phạm Kha, Huyện Thanh Miện, Tỉnh Hải Dương","code":"11245","parent_code":"300"},"11248":{"name":"Xã Ngô Quyền","type":"xa","slug":"xa-ngo-quyen","name_with_type":"Xã Ngô Quyền","path":"Xã Ngô Quyền, Huyện Thanh Miện, Tỉnh Hải Dương","path_with_type":"Xã Ngô Quyền, Huyện Thanh Miện, Tỉnh Hải Dương","code":"11248","parent_code":"300"},"11251":{"name":"Xã Đoàn Tùng","type":"xa","slug":"xa-doan-tung","name_with_type":"Xã Đoàn Tùng","path":"Xã Đoàn Tùng, Huyện Thanh Miện, Tỉnh Hải Dương","path_with_type":"Xã Đoàn Tùng, Huyện Thanh Miện, Tỉnh Hải Dương","code":"11251","parent_code":"300"},"11254":{"name":"Xã Hồng Quang","type":"xa","slug":"xa-hong-quang","name_with_type":"Xã Hồng Quang","path":"Xã Hồng Quang, Huyện Thanh Miện, Tỉnh Hải Dương","path_with_type":"Xã Hồng Quang, Huyện Thanh Miện, Tỉnh Hải Dương","code":"11254","parent_code":"300"},"11257":{"name":"Xã Tân Trào","type":"xa","slug":"xa-tan-trao","name_with_type":"Xã Tân Trào","path":"Xã Tân Trào, Huyện Thanh Miện, Tỉnh Hải Dương","path_with_type":"Xã Tân Trào, Huyện Thanh Miện, Tỉnh Hải Dương","code":"11257","parent_code":"300"},"11260":{"name":"Xã Lam Sơn","type":"xa","slug":"xa-lam-son","name_with_type":"Xã Lam Sơn","path":"Xã Lam Sơn, Huyện Thanh Miện, Tỉnh Hải Dương","path_with_type":"Xã Lam Sơn, Huyện Thanh Miện, Tỉnh Hải Dương","code":"11260","parent_code":"300"},"11263":{"name":"Xã Đoàn Kết","type":"xa","slug":"xa-doan-ket","name_with_type":"Xã Đoàn Kết","path":"Xã Đoàn Kết, Huyện Thanh Miện, Tỉnh Hải Dương","path_with_type":"Xã Đoàn Kết, Huyện Thanh Miện, Tỉnh Hải Dương","code":"11263","parent_code":"300"},"11266":{"name":"Xã Lê Hồng","type":"xa","slug":"xa-le-hong","name_with_type":"Xã Lê Hồng","path":"Xã Lê Hồng, Huyện Thanh Miện, Tỉnh Hải Dương","path_with_type":"Xã Lê Hồng, Huyện Thanh Miện, Tỉnh Hải Dương","code":"11266","parent_code":"300"},"11269":{"name":"Xã Tứ Cường","type":"xa","slug":"xa-tu-cuong","name_with_type":"Xã Tứ Cường","path":"Xã Tứ Cường, Huyện Thanh Miện, Tỉnh Hải Dương","path_with_type":"Xã Tứ Cường, Huyện Thanh Miện, Tỉnh Hải Dương","code":"11269","parent_code":"300"},"11275":{"name":"Xã Ngũ Hùng","type":"xa","slug":"xa-ngu-hung","name_with_type":"Xã Ngũ Hùng","path":"Xã Ngũ Hùng, Huyện Thanh Miện, Tỉnh Hải Dương","path_with_type":"Xã Ngũ Hùng, Huyện Thanh Miện, Tỉnh Hải Dương","code":"11275","parent_code":"300"},"11278":{"name":"Xã Cao Thắng","type":"xa","slug":"xa-cao-thang","name_with_type":"Xã Cao Thắng","path":"Xã Cao Thắng, Huyện Thanh Miện, Tỉnh Hải Dương","path_with_type":"Xã Cao Thắng, Huyện Thanh Miện, Tỉnh Hải Dương","code":"11278","parent_code":"300"},"11281":{"name":"Xã Chi Lăng Bắc","type":"xa","slug":"xa-chi-lang-bac","name_with_type":"Xã Chi Lăng Bắc","path":"Xã Chi Lăng Bắc, Huyện Thanh Miện, Tỉnh Hải Dương","path_with_type":"Xã Chi Lăng Bắc, Huyện Thanh Miện, Tỉnh Hải Dương","code":"11281","parent_code":"300"},"11284":{"name":"Xã Chi Lăng Nam","type":"xa","slug":"xa-chi-lang-nam","name_with_type":"Xã Chi Lăng Nam","path":"Xã Chi Lăng Nam, Huyện Thanh Miện, Tỉnh Hải Dương","path_with_type":"Xã Chi Lăng Nam, Huyện Thanh Miện, Tỉnh Hải Dương","code":"11284","parent_code":"300"},"11287":{"name":"Xã Thanh Giang","type":"xa","slug":"xa-thanh-giang","name_with_type":"Xã Thanh Giang","path":"Xã Thanh Giang, Huyện Thanh Miện, Tỉnh Hải Dương","path_with_type":"Xã Thanh Giang, Huyện Thanh Miện, Tỉnh Hải Dương","code":"11287","parent_code":"300"},"11293":{"name":"Xã Hồng Phong","type":"xa","slug":"xa-hong-phong","name_with_type":"Xã Hồng Phong","path":"Xã Hồng Phong, Huyện Thanh Miện, Tỉnh Hải Dương","path_with_type":"Xã Hồng Phong, Huyện Thanh Miện, Tỉnh Hải Dương","code":"11293","parent_code":"300"},"11296":{"name":"Phường Quán Toan","type":"phuong","slug":"phuong-quan-toan","name_with_type":"Phường Quán Toan","path":"Phường Quán Toan, Quận Hồng Bàng, Thành phố Hải Phòng","path_with_type":"Phường Quán Toan, Quận Hồng Bàng, Thành phố Hải Phòng","code":"11296","parent_code":"303"},"11299":{"name":"Phường Hùng Vương","type":"phuong","slug":"phuong-hung-vuong","name_with_type":"Phường Hùng Vương","path":"Phường Hùng Vương, Quận Hồng Bàng, Thành phố Hải Phòng","path_with_type":"Phường Hùng Vương, Quận Hồng Bàng, Thành phố Hải Phòng","code":"11299","parent_code":"303"},"11302":{"name":"Phường Sở Dầu","type":"phuong","slug":"phuong-so-dau","name_with_type":"Phường Sở Dầu","path":"Phường Sở Dầu, Quận Hồng Bàng, Thành phố Hải Phòng","path_with_type":"Phường Sở Dầu, Quận Hồng Bàng, Thành phố Hải Phòng","code":"11302","parent_code":"303"},"11305":{"name":"Phường Thượng Lý","type":"phuong","slug":"phuong-thuong-ly","name_with_type":"Phường Thượng Lý","path":"Phường Thượng Lý, Quận Hồng Bàng, Thành phố Hải Phòng","path_with_type":"Phường Thượng Lý, Quận Hồng Bàng, Thành phố Hải Phòng","code":"11305","parent_code":"303"},"11311":{"name":"Phường Minh Khai","type":"phuong","slug":"phuong-minh-khai","name_with_type":"Phường Minh Khai","path":"Phường Minh Khai, Quận Hồng Bàng, Thành phố Hải Phòng","path_with_type":"Phường Minh Khai, Quận Hồng Bàng, Thành phố Hải Phòng","code":"11311","parent_code":"303"},"11320":{"name":"Phường Hoàng Văn Thụ","type":"phuong","slug":"phuong-hoang-van-thu","name_with_type":"Phường Hoàng Văn Thụ","path":"Phường Hoàng Văn Thụ, Quận Hồng Bàng, Thành phố Hải Phòng","path_with_type":"Phường Hoàng Văn Thụ, Quận Hồng Bàng, Thành phố Hải Phòng","code":"11320","parent_code":"303"},"11323":{"name":"Phường Phan Bội Châu","type":"phuong","slug":"phuong-phan-boi-chau","name_with_type":"Phường Phan Bội Châu","path":"Phường Phan Bội Châu, Quận Hồng Bàng, Thành phố Hải Phòng","path_with_type":"Phường Phan Bội Châu, Quận Hồng Bàng, Thành phố Hải Phòng","code":"11323","parent_code":"303"},"11329":{"name":"Phường Máy Chai","type":"phuong","slug":"phuong-may-chai","name_with_type":"Phường Máy Chai","path":"Phường Máy Chai, Quận Ngô Quyền, Thành phố Hải Phòng","path_with_type":"Phường Máy Chai, Quận Ngô Quyền, Thành phố Hải Phòng","code":"11329","parent_code":"304"},"11335":{"name":"Phường Vạn Mỹ","type":"phuong","slug":"phuong-van-my","name_with_type":"Phường Vạn Mỹ","path":"Phường Vạn Mỹ, Quận Ngô Quyền, Thành phố Hải Phòng","path_with_type":"Phường Vạn Mỹ, Quận Ngô Quyền, Thành phố Hải Phòng","code":"11335","parent_code":"304"},"11338":{"name":"Phường Cầu Tre","type":"phuong","slug":"phuong-cau-tre","name_with_type":"Phường Cầu Tre","path":"Phường Cầu Tre, Quận Ngô Quyền, Thành phố Hải Phòng","path_with_type":"Phường Cầu Tre, Quận Ngô Quyền, Thành phố Hải Phòng","code":"11338","parent_code":"304"},"11341":{"name":"Phường Gia Viên","type":"phuong","slug":"phuong-gia-vien","name_with_type":"Phường Gia Viên","path":"Phường Gia Viên, Quận Ngô Quyền, Thành phố Hải Phòng","path_with_type":"Phường Gia Viên, Quận Ngô Quyền, Thành phố Hải Phòng","code":"11341","parent_code":"304"},"11344":{"name":"Phường Cầu Đất","type":"phuong","slug":"phuong-cau-dat","name_with_type":"Phường Cầu Đất","path":"Phường Cầu Đất, Quận Ngô Quyền, Thành phố Hải Phòng","path_with_type":"Phường Cầu Đất, Quận Ngô Quyền, Thành phố Hải Phòng","code":"11344","parent_code":"304"},"11350":{"name":"Phường Đông Khê","type":"phuong","slug":"phuong-dong-khe","name_with_type":"Phường Đông Khê","path":"Phường Đông Khê, Quận Ngô Quyền, Thành phố Hải Phòng","path_with_type":"Phường Đông Khê, Quận Ngô Quyền, Thành phố Hải Phòng","code":"11350","parent_code":"304"},"11359":{"name":"Phường Đằng Giang","type":"phuong","slug":"phuong-dang-giang","name_with_type":"Phường Đằng Giang","path":"Phường Đằng Giang, Quận Ngô Quyền, Thành phố Hải Phòng","path_with_type":"Phường Đằng Giang, Quận Ngô Quyền, Thành phố Hải Phòng","code":"11359","parent_code":"304"},"11365":{"name":"Phường Lạch Tray","type":"phuong","slug":"phuong-lach-tray","name_with_type":"Phường Lạch Tray","path":"Phường Lạch Tray, Quận Ngô Quyền, Thành phố Hải Phòng","path_with_type":"Phường Lạch Tray, Quận Ngô Quyền, Thành phố Hải Phòng","code":"11365","parent_code":"304"},"11371":{"name":"Phường An Biên","type":"phuong","slug":"phuong-an-bien","name_with_type":"Phường An Biên","path":"Phường An Biên, Quận Lê Chân, Thành phố Hải Phòng","path_with_type":"Phường An Biên, Quận Lê Chân, Thành phố Hải Phòng","code":"11371","parent_code":"305"},"11383":{"name":"Phường Trần Nguyên Hãn","type":"phuong","slug":"phuong-tran-nguyen-han","name_with_type":"Phường Trần Nguyên Hãn","path":"Phường Trần Nguyên Hãn, Quận Lê Chân, Thành phố Hải Phòng","path_with_type":"Phường Trần Nguyên Hãn, Quận Lê Chân, Thành phố Hải Phòng","code":"11383","parent_code":"305"},"11395":{"name":"Phường Hàng Kênh","type":"phuong","slug":"phuong-hang-kenh","name_with_type":"Phường Hàng Kênh","path":"Phường Hàng Kênh, Quận Lê Chân, Thành phố Hải Phòng","path_with_type":"Phường Hàng Kênh, Quận Lê Chân, Thành phố Hải Phòng","code":"11395","parent_code":"305"},"11401":{"name":"Phường An Dương","type":"phuong","slug":"phuong-an-duong","name_with_type":"Phường An Dương","path":"Phường An Dương, Quận Lê Chân, Thành phố Hải Phòng","path_with_type":"Phường An Dương, Quận Lê Chân, Thành phố Hải Phòng","code":"11401","parent_code":"305"},"11404":{"name":"Phường Dư Hàng Kênh","type":"phuong","slug":"phuong-du-hang-kenh","name_with_type":"Phường Dư Hàng Kênh","path":"Phường Dư Hàng Kênh, Quận Lê Chân, Thành phố Hải Phòng","path_with_type":"Phường Dư Hàng Kênh, Quận Lê Chân, Thành phố Hải Phòng","code":"11404","parent_code":"305"},"11405":{"name":"Phường Kênh Dương","type":"phuong","slug":"phuong-kenh-duong","name_with_type":"Phường Kênh Dương","path":"Phường Kênh Dương, Quận Lê Chân, Thành phố Hải Phòng","path_with_type":"Phường Kênh Dương, Quận Lê Chân, Thành phố Hải Phòng","code":"11405","parent_code":"305"},"11407":{"name":"Phường Vĩnh Niệm","type":"phuong","slug":"phuong-vinh-niem","name_with_type":"Phường Vĩnh Niệm","path":"Phường Vĩnh Niệm, Quận Lê Chân, Thành phố Hải Phòng","path_with_type":"Phường Vĩnh Niệm, Quận Lê Chân, Thành phố Hải Phòng","code":"11407","parent_code":"305"},"11410":{"name":"Phường Đông Hải 1","type":"phuong","slug":"phuong-dong-hai-1","name_with_type":"Phường Đông Hải 1","path":"Phường Đông Hải 1, Quận Hải An, Thành phố Hải Phòng","path_with_type":"Phường Đông Hải 1, Quận Hải An, Thành phố Hải Phòng","code":"11410","parent_code":"306"},"11411":{"name":"Phường Đông Hải 2","type":"phuong","slug":"phuong-dong-hai-2","name_with_type":"Phường Đông Hải 2","path":"Phường Đông Hải 2, Quận Hải An, Thành phố Hải Phòng","path_with_type":"Phường Đông Hải 2, Quận Hải An, Thành phố Hải Phòng","code":"11411","parent_code":"306"},"11413":{"name":"Phường Đằng Lâm","type":"phuong","slug":"phuong-dang-lam","name_with_type":"Phường Đằng Lâm","path":"Phường Đằng Lâm, Quận Hải An, Thành phố Hải Phòng","path_with_type":"Phường Đằng Lâm, Quận Hải An, Thành phố Hải Phòng","code":"11413","parent_code":"306"},"11414":{"name":"Phường Thành Tô","type":"phuong","slug":"phuong-thanh-to","name_with_type":"Phường Thành Tô","path":"Phường Thành Tô, Quận Hải An, Thành phố Hải Phòng","path_with_type":"Phường Thành Tô, Quận Hải An, Thành phố Hải Phòng","code":"11414","parent_code":"306"},"11416":{"name":"Phường Đằng Hải","type":"phuong","slug":"phuong-dang-hai","name_with_type":"Phường Đằng Hải","path":"Phường Đằng Hải, Quận Hải An, Thành phố Hải Phòng","path_with_type":"Phường Đằng Hải, Quận Hải An, Thành phố Hải Phòng","code":"11416","parent_code":"306"},"11419":{"name":"Phường Nam Hải","type":"phuong","slug":"phuong-nam-hai","name_with_type":"Phường Nam Hải","path":"Phường Nam Hải, Quận Hải An, Thành phố Hải Phòng","path_with_type":"Phường Nam Hải, Quận Hải An, Thành phố Hải Phòng","code":"11419","parent_code":"306"},"11422":{"name":"Phường Cát Bi","type":"phuong","slug":"phuong-cat-bi","name_with_type":"Phường Cát Bi","path":"Phường Cát Bi, Quận Hải An, Thành phố Hải Phòng","path_with_type":"Phường Cát Bi, Quận Hải An, Thành phố Hải Phòng","code":"11422","parent_code":"306"},"11425":{"name":"Phường Tràng Cát","type":"phuong","slug":"phuong-trang-cat","name_with_type":"Phường Tràng Cát","path":"Phường Tràng Cát, Quận Hải An, Thành phố Hải Phòng","path_with_type":"Phường Tràng Cát, Quận Hải An, Thành phố Hải Phòng","code":"11425","parent_code":"306"},"11431":{"name":"Phường Đồng Hoà","type":"phuong","slug":"phuong-dong-hoa","name_with_type":"Phường Đồng Hoà","path":"Phường Đồng Hoà, Quận Kiến An, Thành phố Hải Phòng","path_with_type":"Phường Đồng Hoà, Quận Kiến An, Thành phố Hải Phòng","code":"11431","parent_code":"307"},"11434":{"name":"Phường Bắc Sơn","type":"phuong","slug":"phuong-bac-son","name_with_type":"Phường Bắc Sơn","path":"Phường Bắc Sơn, Quận Kiến An, Thành phố Hải Phòng","path_with_type":"Phường Bắc Sơn, Quận Kiến An, Thành phố Hải Phòng","code":"11434","parent_code":"307"},"11437":{"name":"Phường Nam Sơn","type":"phuong","slug":"phuong-nam-son","name_with_type":"Phường Nam Sơn","path":"Phường Nam Sơn, Quận Kiến An, Thành phố Hải Phòng","path_with_type":"Phường Nam Sơn, Quận Kiến An, Thành phố Hải Phòng","code":"11437","parent_code":"307"},"11440":{"name":"Phường Ngọc Sơn","type":"phuong","slug":"phuong-ngoc-son","name_with_type":"Phường Ngọc Sơn","path":"Phường Ngọc Sơn, Quận Kiến An, Thành phố Hải Phòng","path_with_type":"Phường Ngọc Sơn, Quận Kiến An, Thành phố Hải Phòng","code":"11440","parent_code":"307"},"11443":{"name":"Phường Trần Thành Ngọ","type":"phuong","slug":"phuong-tran-thanh-ngo","name_with_type":"Phường Trần Thành Ngọ","path":"Phường Trần Thành Ngọ, Quận Kiến An, Thành phố Hải Phòng","path_with_type":"Phường Trần Thành Ngọ, Quận Kiến An, Thành phố Hải Phòng","code":"11443","parent_code":"307"},"11446":{"name":"Phường Văn Đẩu","type":"phuong","slug":"phuong-van-dau","name_with_type":"Phường Văn Đẩu","path":"Phường Văn Đẩu, Quận Kiến An, Thành phố Hải Phòng","path_with_type":"Phường Văn Đẩu, Quận Kiến An, Thành phố Hải Phòng","code":"11446","parent_code":"307"},"11449":{"name":"Phường Bắc Hà","type":"phuong","slug":"phuong-bac-ha","name_with_type":"Phường Bắc Hà","path":"Phường Bắc Hà, Quận Kiến An, Thành phố Hải Phòng","path_with_type":"Phường Bắc Hà, Quận Kiến An, Thành phố Hải Phòng","code":"11449","parent_code":"307"},"11455":{"name":"Phường Ngọc Xuyên","type":"phuong","slug":"phuong-ngoc-xuyen","name_with_type":"Phường Ngọc Xuyên","path":"Phường Ngọc Xuyên, Quận Đồ Sơn, Thành phố Hải Phòng","path_with_type":"Phường Ngọc Xuyên, Quận Đồ Sơn, Thành phố Hải Phòng","code":"11455","parent_code":"308"},"11458":{"name":"Phường Hải Sơn","type":"phuong","slug":"phuong-hai-son","name_with_type":"Phường Hải Sơn","path":"Phường Hải Sơn, Quận Đồ Sơn, Thành phố Hải Phòng","path_with_type":"Phường Hải Sơn, Quận Đồ Sơn, Thành phố Hải Phòng","code":"11458","parent_code":"308"},"11461":{"name":"Phường Vạn Hương","type":"phuong","slug":"phuong-van-huong","name_with_type":"Phường Vạn Hương","path":"Phường Vạn Hương, Quận Đồ Sơn, Thành phố Hải Phòng","path_with_type":"Phường Vạn Hương, Quận Đồ Sơn, Thành phố Hải Phòng","code":"11461","parent_code":"308"},"11465":{"name":"Phường Minh Đức","type":"phuong","slug":"phuong-minh-duc","name_with_type":"Phường Minh Đức","path":"Phường Minh Đức, Quận Đồ Sơn, Thành phố Hải Phòng","path_with_type":"Phường Minh Đức, Quận Đồ Sơn, Thành phố Hải Phòng","code":"11465","parent_code":"308"},"11467":{"name":"Phường Bàng La","type":"phuong","slug":"phuong-bang-la","name_with_type":"Phường Bàng La","path":"Phường Bàng La, Quận Đồ Sơn, Thành phố Hải Phòng","path_with_type":"Phường Bàng La, Quận Đồ Sơn, Thành phố Hải Phòng","code":"11467","parent_code":"308"},"11473":{"name":"Phường Minh Đức","type":"phuong","slug":"phuong-minh-duc","name_with_type":"Phường Minh Đức","path":"Phường Minh Đức, Thành phố Thuỷ Nguyên, Thành phố Hải Phòng","path_with_type":"Phường Minh Đức, Thành phố Thuỷ Nguyên, Thành phố Hải Phòng","code":"11473","parent_code":"311"},"11485":{"name":"Xã Liên Xuân","type":"xa","slug":"xa-lien-xuan","name_with_type":"Xã Liên Xuân","path":"Xã Liên Xuân, Thành phố Thuỷ Nguyên, Thành phố Hải Phòng","path_with_type":"Xã Liên Xuân, Thành phố Thuỷ Nguyên, Thành phố Hải Phòng","code":"11485","parent_code":"311"},"11488":{"name":"Phường Lưu Kiếm","type":"phuong","slug":"phuong-luu-kiem","name_with_type":"Phường Lưu Kiếm","path":"Phường Lưu Kiếm, Thành phố Thuỷ Nguyên, Thành phố Hải Phòng","path_with_type":"Phường Lưu Kiếm, Thành phố Thuỷ Nguyên, Thành phố Hải Phòng","code":"11488","parent_code":"311"},"11500":{"name":"Xã Bạch Đằng","type":"xa","slug":"xa-bach-dang","name_with_type":"Xã Bạch Đằng","path":"Xã Bạch Đằng, Thành phố Thuỷ Nguyên, Thành phố Hải Phòng","path_with_type":"Xã Bạch Đằng, Thành phố Thuỷ Nguyên, Thành phố Hải Phòng","code":"11500","parent_code":"311"},"11503":{"name":"Xã Ninh Sơn","type":"xa","slug":"xa-ninh-son","name_with_type":"Xã Ninh Sơn","path":"Xã Ninh Sơn, Thành phố Thuỷ Nguyên, Thành phố Hải Phòng","path_with_type":"Xã Ninh Sơn, Thành phố Thuỷ Nguyên, Thành phố Hải Phòng","code":"11503","parent_code":"311"},"11506":{"name":"Phường Quảng Thanh","type":"phuong","slug":"phuong-quang-thanh","name_with_type":"Phường Quảng Thanh","path":"Phường Quảng Thanh, Thành phố Thuỷ Nguyên, Thành phố Hải Phòng","path_with_type":"Phường Quảng Thanh, Thành phố Thuỷ Nguyên, Thành phố Hải Phòng","code":"11506","parent_code":"311"},"11512":{"name":"Phường Trần Hưng Đạo","type":"phuong","slug":"phuong-tran-hung-dao","name_with_type":"Phường Trần Hưng Đạo","path":"Phường Trần Hưng Đạo, Thành phố Thuỷ Nguyên, Thành phố Hải Phòng","path_with_type":"Phường Trần Hưng Đạo, Thành phố Thuỷ Nguyên, Thành phố Hải Phòng","code":"11512","parent_code":"311"},"11518":{"name":"Xã Quang Trung","type":"xa","slug":"xa-quang-trung","name_with_type":"Xã Quang Trung","path":"Xã Quang Trung, Thành phố Thuỷ Nguyên, Thành phố Hải Phòng","path_with_type":"Xã Quang Trung, Thành phố Thuỷ Nguyên, Thành phố Hải Phòng","code":"11518","parent_code":"311"},"11521":{"name":"Phường Lê Hồng Phong","type":"phuong","slug":"phuong-le-hong-phong","name_with_type":"Phường Lê Hồng Phong","path":"Phường Lê Hồng Phong, Thành phố Thuỷ Nguyên, Thành phố Hải Phòng","path_with_type":"Phường Lê Hồng Phong, Thành phố Thuỷ Nguyên, Thành phố Hải Phòng","code":"11521","parent_code":"311"},"11527":{"name":"Phường Hoà Bình","type":"phuong","slug":"phuong-hoa-binh","name_with_type":"Phường Hoà Bình","path":"Phường Hoà Bình, Thành phố Thuỷ Nguyên, Thành phố Hải Phòng","path_with_type":"Phường Hoà Bình, Thành phố Thuỷ Nguyên, Thành phố Hải Phòng","code":"11527","parent_code":"311"},"11530":{"name":"Phường Thủy Hà","type":"phuong","slug":"phuong-thuy-ha","name_with_type":"Phường Thủy Hà","path":"Phường Thủy Hà, Thành phố Thuỷ Nguyên, Thành phố Hải Phòng","path_with_type":"Phường Thủy Hà, Thành phố Thuỷ Nguyên, Thành phố Hải Phòng","code":"11530","parent_code":"311"},"11533":{"name":"Phường An Lư","type":"phuong","slug":"phuong-an-lu","name_with_type":"Phường An Lư","path":"Phường An Lư, Thành phố Thuỷ Nguyên, Thành phố Hải Phòng","path_with_type":"Phường An Lư, Thành phố Thuỷ Nguyên, Thành phố Hải Phòng","code":"11533","parent_code":"311"},"11539":{"name":"Phường Phạm Ngũ Lão","type":"phuong","slug":"phuong-pham-ngu-lao","name_with_type":"Phường Phạm Ngũ Lão","path":"Phường Phạm Ngũ Lão, Thành phố Thuỷ Nguyên, Thành phố Hải Phòng","path_with_type":"Phường Phạm Ngũ Lão, Thành phố Thuỷ Nguyên, Thành phố Hải Phòng","code":"11539","parent_code":"311"},"11542":{"name":"Phường Nam Triệu Giang","type":"phuong","slug":"phuong-nam-trieu-giang","name_with_type":"Phường Nam Triệu Giang","path":"Phường Nam Triệu Giang, Thành phố Thuỷ Nguyên, Thành phố Hải Phòng","path_with_type":"Phường Nam Triệu Giang, Thành phố Thuỷ Nguyên, Thành phố Hải Phòng","code":"11542","parent_code":"311"},"11545":{"name":"Phường Tam Hưng","type":"phuong","slug":"phuong-tam-hung","name_with_type":"Phường Tam Hưng","path":"Phường Tam Hưng, Thành phố Thuỷ Nguyên, Thành phố Hải Phòng","path_with_type":"Phường Tam Hưng, Thành phố Thuỷ Nguyên, Thành phố Hải Phòng","code":"11545","parent_code":"311"},"11551":{"name":"Phường Lập Lễ","type":"phuong","slug":"phuong-lap-le","name_with_type":"Phường Lập Lễ","path":"Phường Lập Lễ, Thành phố Thuỷ Nguyên, Thành phố Hải Phòng","path_with_type":"Phường Lập Lễ, Thành phố Thuỷ Nguyên, Thành phố Hải Phòng","code":"11551","parent_code":"311"},"11557":{"name":"Phường Thiên Hương","type":"phuong","slug":"phuong-thien-huong","name_with_type":"Phường Thiên Hương","path":"Phường Thiên Hương, Thành phố Thuỷ Nguyên, Thành phố Hải Phòng","path_with_type":"Phường Thiên Hương, Thành phố Thuỷ Nguyên, Thành phố Hải Phòng","code":"11557","parent_code":"311"},"11560":{"name":"Phường Thuỷ Đường","type":"phuong","slug":"phuong-thuy-duong","name_with_type":"Phường Thuỷ Đường","path":"Phường Thuỷ Đường, Thành phố Thuỷ Nguyên, Thành phố Hải Phòng","path_with_type":"Phường Thuỷ Đường, Thành phố Thuỷ Nguyên, Thành phố Hải Phòng","code":"11560","parent_code":"311"},"11569":{"name":"Phường Hoàng Lâm","type":"phuong","slug":"phuong-hoang-lam","name_with_type":"Phường Hoàng Lâm","path":"Phường Hoàng Lâm, Thành phố Thuỷ Nguyên, Thành phố Hải Phòng","path_with_type":"Phường Hoàng Lâm, Thành phố Thuỷ Nguyên, Thành phố Hải Phòng","code":"11569","parent_code":"311"},"11572":{"name":"Phường Hoa Động","type":"phuong","slug":"phuong-hoa-dong","name_with_type":"Phường Hoa Động","path":"Phường Hoa Động, Thành phố Thuỷ Nguyên, Thành phố Hải Phòng","path_with_type":"Phường Hoa Động, Thành phố Thuỷ Nguyên, Thành phố Hải Phòng","code":"11572","parent_code":"311"},"11578":{"name":"Phường Dương Quan","type":"phuong","slug":"phuong-duong-quan","name_with_type":"Phường Dương Quan","path":"Phường Dương Quan, Thành phố Thuỷ Nguyên, Thành phố Hải Phòng","path_with_type":"Phường Dương Quan, Thành phố Thuỷ Nguyên, Thành phố Hải Phòng","code":"11578","parent_code":"311"},"11581":{"name":"Phường Lê Lợi","type":"phuong","slug":"phuong-le-loi","name_with_type":"Phường Lê Lợi","path":"Phường Lê Lợi, Quận An Dương, Thành phố Hải Phòng","path_with_type":"Phường Lê Lợi, Quận An Dương, Thành phố Hải Phòng","code":"11581","parent_code":"312"},"11584":{"name":"Phường Lê Thiện","type":"phuong","slug":"phuong-le-thien","name_with_type":"Phường Lê Thiện","path":"Phường Lê Thiện, Quận An Dương, Thành phố Hải Phòng","path_with_type":"Phường Lê Thiện, Quận An Dương, Thành phố Hải Phòng","code":"11584","parent_code":"312"},"11587":{"name":"Phường Đại Bản","type":"phuong","slug":"phuong-dai-ban","name_with_type":"Phường Đại Bản","path":"Phường Đại Bản, Quận Hồng Bàng, Thành phố Hải Phòng","path_with_type":"Phường Đại Bản, Quận Hồng Bàng, Thành phố Hải Phòng","code":"11587","parent_code":"303"},"11590":{"name":"Phường An Hoà","type":"phuong","slug":"phuong-an-hoa","name_with_type":"Phường An Hoà","path":"Phường An Hoà, Quận An Dương, Thành phố Hải Phòng","path_with_type":"Phường An Hoà, Quận An Dương, Thành phố Hải Phòng","code":"11590","parent_code":"312"},"11593":{"name":"Phường Hồng Phong","type":"phuong","slug":"phuong-hong-phong","name_with_type":"Phường Hồng Phong","path":"Phường Hồng Phong, Quận An Dương, Thành phố Hải Phòng","path_with_type":"Phường Hồng Phong, Quận An Dương, Thành phố Hải Phòng","code":"11593","parent_code":"312"},"11596":{"name":"Phường Tân Tiến","type":"phuong","slug":"phuong-tan-tien","name_with_type":"Phường Tân Tiến","path":"Phường Tân Tiến, Quận An Dương, Thành phố Hải Phòng","path_with_type":"Phường Tân Tiến, Quận An Dương, Thành phố Hải Phòng","code":"11596","parent_code":"312"},"11599":{"name":"Phường An Hưng","type":"phuong","slug":"phuong-an-hung","name_with_type":"Phường An Hưng","path":"Phường An Hưng, Quận Hồng Bàng, Thành phố Hải Phòng","path_with_type":"Phường An Hưng, Quận Hồng Bàng, Thành phố Hải Phòng","code":"11599","parent_code":"303"},"11602":{"name":"Phường An Hồng","type":"phuong","slug":"phuong-an-hong","name_with_type":"Phường An Hồng","path":"Phường An Hồng, Quận Hồng Bàng, Thành phố Hải Phòng","path_with_type":"Phường An Hồng, Quận Hồng Bàng, Thành phố Hải Phòng","code":"11602","parent_code":"303"},"11608":{"name":"Phường Nam Sơn","type":"phuong","slug":"phuong-nam-son","name_with_type":"Phường Nam Sơn","path":"Phường Nam Sơn, Quận An Dương, Thành phố Hải Phòng","path_with_type":"Phường Nam Sơn, Quận An Dương, Thành phố Hải Phòng","code":"11608","parent_code":"312"},"11614":{"name":"Phường An Hải","type":"phuong","slug":"phuong-an-hai","name_with_type":"Phường An Hải","path":"Phường An Hải, Quận An Dương, Thành phố Hải Phòng","path_with_type":"Phường An Hải, Quận An Dương, Thành phố Hải Phòng","code":"11614","parent_code":"312"},"11617":{"name":"Phường Đồng Thái","type":"phuong","slug":"phuong-dong-thai","name_with_type":"Phường Đồng Thái","path":"Phường Đồng Thái, Quận An Dương, Thành phố Hải Phòng","path_with_type":"Phường Đồng Thái, Quận An Dương, Thành phố Hải Phòng","code":"11617","parent_code":"312"},"11623":{"name":"Phường An Đồng","type":"phuong","slug":"phuong-an-dong","name_with_type":"Phường An Đồng","path":"Phường An Đồng, Quận An Dương, Thành phố Hải Phòng","path_with_type":"Phường An Đồng, Quận An Dương, Thành phố Hải Phòng","code":"11623","parent_code":"312"},"11626":{"name":"Phường Hồng Thái","type":"phuong","slug":"phuong-hong-thai","name_with_type":"Phường Hồng Thái","path":"Phường Hồng Thái, Quận An Dương, Thành phố Hải Phòng","path_with_type":"Phường Hồng Thái, Quận An Dương, Thành phố Hải Phòng","code":"11626","parent_code":"312"},"11629":{"name":"Thị trấn An Lão","type":"thi-tran","slug":"thi-tran-an-lao","name_with_type":"Thị trấn An Lão","path":"Thị trấn An Lão, Huyện An Lão, Thành phố Hải Phòng","path_with_type":"Thị trấn An Lão, Huyện An Lão, Thành phố Hải Phòng","code":"11629","parent_code":"313"},"11632":{"name":"Xã Bát Trang","type":"xa","slug":"xa-bat-trang","name_with_type":"Xã Bát Trang","path":"Xã Bát Trang, Huyện An Lão, Thành phố Hải Phòng","path_with_type":"Xã Bát Trang, Huyện An Lão, Thành phố Hải Phòng","code":"11632","parent_code":"313"},"11635":{"name":"Xã Trường Thọ","type":"xa","slug":"xa-truong-tho","name_with_type":"Xã Trường Thọ","path":"Xã Trường Thọ, Huyện An Lão, Thành phố Hải Phòng","path_with_type":"Xã Trường Thọ, Huyện An Lão, Thành phố Hải Phòng","code":"11635","parent_code":"313"},"11638":{"name":"Xã Trường Thành","type":"xa","slug":"xa-truong-thanh","name_with_type":"Xã Trường Thành","path":"Xã Trường Thành, Huyện An Lão, Thành phố Hải Phòng","path_with_type":"Xã Trường Thành, Huyện An Lão, Thành phố Hải Phòng","code":"11638","parent_code":"313"},"11641":{"name":"Xã An Tiến","type":"xa","slug":"xa-an-tien","name_with_type":"Xã An Tiến","path":"Xã An Tiến, Huyện An Lão, Thành phố Hải Phòng","path_with_type":"Xã An Tiến, Huyện An Lão, Thành phố Hải Phòng","code":"11641","parent_code":"313"},"11644":{"name":"Xã Quang Hưng","type":"xa","slug":"xa-quang-hung","name_with_type":"Xã Quang Hưng","path":"Xã Quang Hưng, Huyện An Lão, Thành phố Hải Phòng","path_with_type":"Xã Quang Hưng, Huyện An Lão, Thành phố Hải Phòng","code":"11644","parent_code":"313"},"11647":{"name":"Xã Quang Trung","type":"xa","slug":"xa-quang-trung","name_with_type":"Xã Quang Trung","path":"Xã Quang Trung, Huyện An Lão, Thành phố Hải Phòng","path_with_type":"Xã Quang Trung, Huyện An Lão, Thành phố Hải Phòng","code":"11647","parent_code":"313"},"11650":{"name":"Xã Quốc Tuấn","type":"xa","slug":"xa-quoc-tuan","name_with_type":"Xã Quốc Tuấn","path":"Xã Quốc Tuấn, Huyện An Lão, Thành phố Hải Phòng","path_with_type":"Xã Quốc Tuấn, Huyện An Lão, Thành phố Hải Phòng","code":"11650","parent_code":"313"},"11653":{"name":"Xã An Thắng","type":"xa","slug":"xa-an-thang","name_with_type":"Xã An Thắng","path":"Xã An Thắng, Huyện An Lão, Thành phố Hải Phòng","path_with_type":"Xã An Thắng, Huyện An Lão, Thành phố Hải Phòng","code":"11653","parent_code":"313"},"11656":{"name":"Thị trấn Trường Sơn","type":"thi-tran","slug":"thi-tran-truong-son","name_with_type":"Thị trấn Trường Sơn","path":"Thị trấn Trường Sơn, Huyện An Lão, Thành phố Hải Phòng","path_with_type":"Thị trấn Trường Sơn, Huyện An Lão, Thành phố Hải Phòng","code":"11656","parent_code":"313"},"11659":{"name":"Xã Tân Dân","type":"xa","slug":"xa-tan-dan","name_with_type":"Xã Tân Dân","path":"Xã Tân Dân, Huyện An Lão, Thành phố Hải Phòng","path_with_type":"Xã Tân Dân, Huyện An Lão, Thành phố Hải Phòng","code":"11659","parent_code":"313"},"11662":{"name":"Xã Thái Sơn","type":"xa","slug":"xa-thai-son","name_with_type":"Xã Thái Sơn","path":"Xã Thái Sơn, Huyện An Lão, Thành phố Hải Phòng","path_with_type":"Xã Thái Sơn, Huyện An Lão, Thành phố Hải Phòng","code":"11662","parent_code":"313"},"11665":{"name":"Xã Tân Viên","type":"xa","slug":"xa-tan-vien","name_with_type":"Xã Tân Viên","path":"Xã Tân Viên, Huyện An Lão, Thành phố Hải Phòng","path_with_type":"Xã Tân Viên, Huyện An Lão, Thành phố Hải Phòng","code":"11665","parent_code":"313"},"11668":{"name":"Xã Mỹ Đức","type":"xa","slug":"xa-my-duc","name_with_type":"Xã Mỹ Đức","path":"Xã Mỹ Đức, Huyện An Lão, Thành phố Hải Phòng","path_with_type":"Xã Mỹ Đức, Huyện An Lão, Thành phố Hải Phòng","code":"11668","parent_code":"313"},"11671":{"name":"Xã Chiến Thắng","type":"xa","slug":"xa-chien-thang","name_with_type":"Xã Chiến Thắng","path":"Xã Chiến Thắng, Huyện An Lão, Thành phố Hải Phòng","path_with_type":"Xã Chiến Thắng, Huyện An Lão, Thành phố Hải Phòng","code":"11671","parent_code":"313"},"11674":{"name":"Xã An Thọ","type":"xa","slug":"xa-an-tho","name_with_type":"Xã An Thọ","path":"Xã An Thọ, Huyện An Lão, Thành phố Hải Phòng","path_with_type":"Xã An Thọ, Huyện An Lão, Thành phố Hải Phòng","code":"11674","parent_code":"313"},"11677":{"name":"Xã An Thái","type":"xa","slug":"xa-an-thai","name_with_type":"Xã An Thái","path":"Xã An Thái, Huyện An Lão, Thành phố Hải Phòng","path_with_type":"Xã An Thái, Huyện An Lão, Thành phố Hải Phòng","code":"11677","parent_code":"313"},"11680":{"name":"Thị trấn Núi Đối","type":"thi-tran","slug":"thi-tran-nui-doi","name_with_type":"Thị trấn Núi Đối","path":"Thị trấn Núi Đối, Huyện Kiến Thuỵ, Thành phố Hải Phòng","path_with_type":"Thị trấn Núi Đối, Huyện Kiến Thuỵ, Thành phố Hải Phòng","code":"11680","parent_code":"314"},"11683":{"name":"Phường Đa Phúc","type":"phuong","slug":"phuong-da-phuc","name_with_type":"Phường Đa Phúc","path":"Phường Đa Phúc, Quận Dương Kinh, Thành phố Hải Phòng","path_with_type":"Phường Đa Phúc, Quận Dương Kinh, Thành phố Hải Phòng","code":"11683","parent_code":"309"},"11686":{"name":"Phường Hưng Đạo","type":"phuong","slug":"phuong-hung-dao","name_with_type":"Phường Hưng Đạo","path":"Phường Hưng Đạo, Quận Dương Kinh, Thành phố Hải Phòng","path_with_type":"Phường Hưng Đạo, Quận Dương Kinh, Thành phố Hải Phòng","code":"11686","parent_code":"309"},"11689":{"name":"Phường Anh Dũng","type":"phuong","slug":"phuong-anh-dung","name_with_type":"Phường Anh Dũng","path":"Phường Anh Dũng, Quận Dương Kinh, Thành phố Hải Phòng","path_with_type":"Phường Anh Dũng, Quận Dương Kinh, Thành phố Hải Phòng","code":"11689","parent_code":"309"},"11692":{"name":"Phường Hải Thành","type":"phuong","slug":"phuong-hai-thanh","name_with_type":"Phường Hải Thành","path":"Phường Hải Thành, Quận Dương Kinh, Thành phố Hải Phòng","path_with_type":"Phường Hải Thành, Quận Dương Kinh, Thành phố Hải Phòng","code":"11692","parent_code":"309"},"11695":{"name":"Xã Đông Phương","type":"xa","slug":"xa-dong-phuong","name_with_type":"Xã Đông Phương","path":"Xã Đông Phương, Huyện Kiến Thuỵ, Thành phố Hải Phòng","path_with_type":"Xã Đông Phương, Huyện Kiến Thuỵ, Thành phố Hải Phòng","code":"11695","parent_code":"314"},"11698":{"name":"Xã Thuận Thiên","type":"xa","slug":"xa-thuan-thien","name_with_type":"Xã Thuận Thiên","path":"Xã Thuận Thiên, Huyện Kiến Thuỵ, Thành phố Hải Phòng","path_with_type":"Xã Thuận Thiên, Huyện Kiến Thuỵ, Thành phố Hải Phòng","code":"11698","parent_code":"314"},"11701":{"name":"Xã Hữu Bằng","type":"xa","slug":"xa-huu-bang","name_with_type":"Xã Hữu Bằng","path":"Xã Hữu Bằng, Huyện Kiến Thuỵ, Thành phố Hải Phòng","path_with_type":"Xã Hữu Bằng, Huyện Kiến Thuỵ, Thành phố Hải Phòng","code":"11701","parent_code":"314"},"11704":{"name":"Xã Đại Đồng","type":"xa","slug":"xa-dai-dong","name_with_type":"Xã Đại Đồng","path":"Xã Đại Đồng, Huyện Kiến Thuỵ, Thành phố Hải Phòng","path_with_type":"Xã Đại Đồng, Huyện Kiến Thuỵ, Thành phố Hải Phòng","code":"11704","parent_code":"314"},"11707":{"name":"Phường Hoà Nghĩa","type":"phuong","slug":"phuong-hoa-nghia","name_with_type":"Phường Hoà Nghĩa","path":"Phường Hoà Nghĩa, Quận Dương Kinh, Thành phố Hải Phòng","path_with_type":"Phường Hoà Nghĩa, Quận Dương Kinh, Thành phố Hải Phòng","code":"11707","parent_code":"309"},"11710":{"name":"Xã Ngũ Phúc","type":"xa","slug":"xa-ngu-phuc","name_with_type":"Xã Ngũ Phúc","path":"Xã Ngũ Phúc, Huyện Kiến Thuỵ, Thành phố Hải Phòng","path_with_type":"Xã Ngũ Phúc, Huyện Kiến Thuỵ, Thành phố Hải Phòng","code":"11710","parent_code":"314"},"11713":{"name":"Xã Kiến Quốc","type":"xa","slug":"xa-kien-quoc","name_with_type":"Xã Kiến Quốc","path":"Xã Kiến Quốc, Huyện Kiến Thuỵ, Thành phố Hải Phòng","path_with_type":"Xã Kiến Quốc, Huyện Kiến Thuỵ, Thành phố Hải Phòng","code":"11713","parent_code":"314"},"11716":{"name":"Xã Du Lễ","type":"xa","slug":"xa-du-le","name_with_type":"Xã Du Lễ","path":"Xã Du Lễ, Huyện Kiến Thuỵ, Thành phố Hải Phòng","path_with_type":"Xã Du Lễ, Huyện Kiến Thuỵ, Thành phố Hải Phòng","code":"11716","parent_code":"314"},"11722":{"name":"Xã Thanh Sơn","type":"xa","slug":"xa-thanh-son","name_with_type":"Xã Thanh Sơn","path":"Xã Thanh Sơn, Huyện Kiến Thuỵ, Thành phố Hải Phòng","path_with_type":"Xã Thanh Sơn, Huyện Kiến Thuỵ, Thành phố Hải Phòng","code":"11722","parent_code":"314"},"11725":{"name":"Xã Minh Tân","type":"xa","slug":"xa-minh-tan","name_with_type":"Xã Minh Tân","path":"Xã Minh Tân, Huyện Kiến Thuỵ, Thành phố Hải Phòng","path_with_type":"Xã Minh Tân, Huyện Kiến Thuỵ, Thành phố Hải Phòng","code":"11725","parent_code":"314"},"11728":{"name":"Xã Kiến Hưng","type":"xa","slug":"xa-kien-hung","name_with_type":"Xã Kiến Hưng","path":"Xã Kiến Hưng, Huyện Kiến Thuỵ, Thành phố Hải Phòng","path_with_type":"Xã Kiến Hưng, Huyện Kiến Thuỵ, Thành phố Hải Phòng","code":"11728","parent_code":"314"},"11734":{"name":"Xã Tân Phong","type":"xa","slug":"xa-tan-phong","name_with_type":"Xã Tân Phong","path":"Xã Tân Phong, Huyện Kiến Thuỵ, Thành phố Hải Phòng","path_with_type":"Xã Tân Phong, Huyện Kiến Thuỵ, Thành phố Hải Phòng","code":"11734","parent_code":"314"},"11737":{"name":"Phường Hợp Đức","type":"phuong","slug":"phuong-hop-duc","name_with_type":"Phường Hợp Đức","path":"Phường Hợp Đức, Quận Đồ Sơn, Thành phố Hải Phòng","path_with_type":"Phường Hợp Đức, Quận Đồ Sơn, Thành phố Hải Phòng","code":"11737","parent_code":"308"},"11740":{"name":"Phường Tân Thành","type":"phuong","slug":"phuong-tan-thanh","name_with_type":"Phường Tân Thành","path":"Phường Tân Thành, Quận Dương Kinh, Thành phố Hải Phòng","path_with_type":"Phường Tân Thành, Quận Dương Kinh, Thành phố Hải Phòng","code":"11740","parent_code":"309"},"11743":{"name":"Xã Tân Trào","type":"xa","slug":"xa-tan-trao","name_with_type":"Xã Tân Trào","path":"Xã Tân Trào, Huyện Kiến Thuỵ, Thành phố Hải Phòng","path_with_type":"Xã Tân Trào, Huyện Kiến Thuỵ, Thành phố Hải Phòng","code":"11743","parent_code":"314"},"11746":{"name":"Xã Đoàn Xá","type":"xa","slug":"xa-doan-xa","name_with_type":"Xã Đoàn Xá","path":"Xã Đoàn Xá, Huyện Kiến Thuỵ, Thành phố Hải Phòng","path_with_type":"Xã Đoàn Xá, Huyện Kiến Thuỵ, Thành phố Hải Phòng","code":"11746","parent_code":"314"},"11749":{"name":"Xã Tú Sơn","type":"xa","slug":"xa-tu-son","name_with_type":"Xã Tú Sơn","path":"Xã Tú Sơn, Huyện Kiến Thuỵ, Thành phố Hải Phòng","path_with_type":"Xã Tú Sơn, Huyện Kiến Thuỵ, Thành phố Hải Phòng","code":"11749","parent_code":"314"},"11752":{"name":"Xã Đại Hợp","type":"xa","slug":"xa-dai-hop","name_with_type":"Xã Đại Hợp","path":"Xã Đại Hợp, Huyện Kiến Thuỵ, Thành phố Hải Phòng","path_with_type":"Xã Đại Hợp, Huyện Kiến Thuỵ, Thành phố Hải Phòng","code":"11752","parent_code":"314"},"11755":{"name":"Thị trấn Tiên Lãng","type":"thi-tran","slug":"thi-tran-tien-lang","name_with_type":"Thị trấn Tiên Lãng","path":"Thị trấn Tiên Lãng, Huyện Tiên Lãng, Thành phố Hải Phòng","path_with_type":"Thị trấn Tiên Lãng, Huyện Tiên Lãng, Thành phố Hải Phòng","code":"11755","parent_code":"315"},"11758":{"name":"Xã Đại Thắng","type":"xa","slug":"xa-dai-thang","name_with_type":"Xã Đại Thắng","path":"Xã Đại Thắng, Huyện Tiên Lãng, Thành phố Hải Phòng","path_with_type":"Xã Đại Thắng, Huyện Tiên Lãng, Thành phố Hải Phòng","code":"11758","parent_code":"315"},"11761":{"name":"Xã Tiên Cường","type":"xa","slug":"xa-tien-cuong","name_with_type":"Xã Tiên Cường","path":"Xã Tiên Cường, Huyện Tiên Lãng, Thành phố Hải Phòng","path_with_type":"Xã Tiên Cường, Huyện Tiên Lãng, Thành phố Hải Phòng","code":"11761","parent_code":"315"},"11764":{"name":"Xã Tự Cường","type":"xa","slug":"xa-tu-cuong","name_with_type":"Xã Tự Cường","path":"Xã Tự Cường, Huyện Tiên Lãng, Thành phố Hải Phòng","path_with_type":"Xã Tự Cường, Huyện Tiên Lãng, Thành phố Hải Phòng","code":"11764","parent_code":"315"},"11770":{"name":"Xã Quyết Tiến","type":"xa","slug":"xa-quyet-tien","name_with_type":"Xã Quyết Tiến","path":"Xã Quyết Tiến, Huyện Tiên Lãng, Thành phố Hải Phòng","path_with_type":"Xã Quyết Tiến, Huyện Tiên Lãng, Thành phố Hải Phòng","code":"11770","parent_code":"315"},"11773":{"name":"Xã Khởi Nghĩa","type":"xa","slug":"xa-khoi-nghia","name_with_type":"Xã Khởi Nghĩa","path":"Xã Khởi Nghĩa, Huyện Tiên Lãng, Thành phố Hải Phòng","path_with_type":"Xã Khởi Nghĩa, Huyện Tiên Lãng, Thành phố Hải Phòng","code":"11773","parent_code":"315"},"11776":{"name":"Xã Tiên Thanh","type":"xa","slug":"xa-tien-thanh","name_with_type":"Xã Tiên Thanh","path":"Xã Tiên Thanh, Huyện Tiên Lãng, Thành phố Hải Phòng","path_with_type":"Xã Tiên Thanh, Huyện Tiên Lãng, Thành phố Hải Phòng","code":"11776","parent_code":"315"},"11779":{"name":"Xã Cấp Tiến","type":"xa","slug":"xa-cap-tien","name_with_type":"Xã Cấp Tiến","path":"Xã Cấp Tiến, Huyện Tiên Lãng, Thành phố Hải Phòng","path_with_type":"Xã Cấp Tiến, Huyện Tiên Lãng, Thành phố Hải Phòng","code":"11779","parent_code":"315"},"11782":{"name":"Xã Kiến Thiết","type":"xa","slug":"xa-kien-thiet","name_with_type":"Xã Kiến Thiết","path":"Xã Kiến Thiết, Huyện Tiên Lãng, Thành phố Hải Phòng","path_with_type":"Xã Kiến Thiết, Huyện Tiên Lãng, Thành phố Hải Phòng","code":"11782","parent_code":"315"},"11785":{"name":"Xã Đoàn Lập","type":"xa","slug":"xa-doan-lap","name_with_type":"Xã Đoàn Lập","path":"Xã Đoàn Lập, Huyện Tiên Lãng, Thành phố Hải Phòng","path_with_type":"Xã Đoàn Lập, Huyện Tiên Lãng, Thành phố Hải Phòng","code":"11785","parent_code":"315"},"11791":{"name":"Xã Tân Minh","type":"xa","slug":"xa-tan-minh","name_with_type":"Xã Tân Minh","path":"Xã Tân Minh, Huyện Tiên Lãng, Thành phố Hải Phòng","path_with_type":"Xã Tân Minh, Huyện Tiên Lãng, Thành phố Hải Phòng","code":"11791","parent_code":"315"},"11797":{"name":"Xã Tiên Thắng","type":"xa","slug":"xa-tien-thang","name_with_type":"Xã Tiên Thắng","path":"Xã Tiên Thắng, Huyện Tiên Lãng, Thành phố Hải Phòng","path_with_type":"Xã Tiên Thắng, Huyện Tiên Lãng, Thành phố Hải Phòng","code":"11797","parent_code":"315"},"11800":{"name":"Xã Tiên Minh","type":"xa","slug":"xa-tien-minh","name_with_type":"Xã Tiên Minh","path":"Xã Tiên Minh, Huyện Tiên Lãng, Thành phố Hải Phòng","path_with_type":"Xã Tiên Minh, Huyện Tiên Lãng, Thành phố Hải Phòng","code":"11800","parent_code":"315"},"11803":{"name":"Xã Bắc Hưng","type":"xa","slug":"xa-bac-hung","name_with_type":"Xã Bắc Hưng","path":"Xã Bắc Hưng, Huyện Tiên Lãng, Thành phố Hải Phòng","path_with_type":"Xã Bắc Hưng, Huyện Tiên Lãng, Thành phố Hải Phòng","code":"11803","parent_code":"315"},"11806":{"name":"Xã Nam Hưng","type":"xa","slug":"xa-nam-hung","name_with_type":"Xã Nam Hưng","path":"Xã Nam Hưng, Huyện Tiên Lãng, Thành phố Hải Phòng","path_with_type":"Xã Nam Hưng, Huyện Tiên Lãng, Thành phố Hải Phòng","code":"11806","parent_code":"315"},"11809":{"name":"Xã Hùng Thắng","type":"xa","slug":"xa-hung-thang","name_with_type":"Xã Hùng Thắng","path":"Xã Hùng Thắng, Huyện Tiên Lãng, Thành phố Hải Phòng","path_with_type":"Xã Hùng Thắng, Huyện Tiên Lãng, Thành phố Hải Phòng","code":"11809","parent_code":"315"},"11812":{"name":"Xã Tây Hưng","type":"xa","slug":"xa-tay-hung","name_with_type":"Xã Tây Hưng","path":"Xã Tây Hưng, Huyện Tiên Lãng, Thành phố Hải Phòng","path_with_type":"Xã Tây Hưng, Huyện Tiên Lãng, Thành phố Hải Phòng","code":"11812","parent_code":"315"},"11815":{"name":"Xã Đông Hưng","type":"xa","slug":"xa-dong-hung","name_with_type":"Xã Đông Hưng","path":"Xã Đông Hưng, Huyện Tiên Lãng, Thành phố Hải Phòng","path_with_type":"Xã Đông Hưng, Huyện Tiên Lãng, Thành phố Hải Phòng","code":"11815","parent_code":"315"},"11821":{"name":"Xã Vinh Quang","type":"xa","slug":"xa-vinh-quang","name_with_type":"Xã Vinh Quang","path":"Xã Vinh Quang, Huyện Tiên Lãng, Thành phố Hải Phòng","path_with_type":"Xã Vinh Quang, Huyện Tiên Lãng, Thành phố Hải Phòng","code":"11821","parent_code":"315"},"11824":{"name":"Thị trấn Vĩnh Bảo","type":"thi-tran","slug":"thi-tran-vinh-bao","name_with_type":"Thị trấn Vĩnh Bảo","path":"Thị trấn Vĩnh Bảo, Huyện Vĩnh Bảo, Thành phố Hải Phòng","path_with_type":"Thị trấn Vĩnh Bảo, Huyện Vĩnh Bảo, Thành phố Hải Phòng","code":"11824","parent_code":"316"},"11827":{"name":"Xã Dũng Tiến","type":"xa","slug":"xa-dung-tien","name_with_type":"Xã Dũng Tiến","path":"Xã Dũng Tiến, Huyện Vĩnh Bảo, Thành phố Hải Phòng","path_with_type":"Xã Dũng Tiến, Huyện Vĩnh Bảo, Thành phố Hải Phòng","code":"11827","parent_code":"316"},"11830":{"name":"Xã Giang Biên","type":"xa","slug":"xa-giang-bien","name_with_type":"Xã Giang Biên","path":"Xã Giang Biên, Huyện Vĩnh Bảo, Thành phố Hải Phòng","path_with_type":"Xã Giang Biên, Huyện Vĩnh Bảo, Thành phố Hải Phòng","code":"11830","parent_code":"316"},"11833":{"name":"Xã Thắng Thuỷ","type":"xa","slug":"xa-thang-thuy","name_with_type":"Xã Thắng Thuỷ","path":"Xã Thắng Thuỷ, Huyện Vĩnh Bảo, Thành phố Hải Phòng","path_with_type":"Xã Thắng Thuỷ, Huyện Vĩnh Bảo, Thành phố Hải Phòng","code":"11833","parent_code":"316"},"11836":{"name":"Xã Trung Lập","type":"xa","slug":"xa-trung-lap","name_with_type":"Xã Trung Lập","path":"Xã Trung Lập, Huyện Vĩnh Bảo, Thành phố Hải Phòng","path_with_type":"Xã Trung Lập, Huyện Vĩnh Bảo, Thành phố Hải Phòng","code":"11836","parent_code":"316"},"11839":{"name":"Xã Việt Tiến","type":"xa","slug":"xa-viet-tien","name_with_type":"Xã Việt Tiến","path":"Xã Việt Tiến, Huyện Vĩnh Bảo, Thành phố Hải Phòng","path_with_type":"Xã Việt Tiến, Huyện Vĩnh Bảo, Thành phố Hải Phòng","code":"11839","parent_code":"316"},"11842":{"name":"Xã Vĩnh An","type":"xa","slug":"xa-vinh-an","name_with_type":"Xã Vĩnh An","path":"Xã Vĩnh An, Huyện Vĩnh Bảo, Thành phố Hải Phòng","path_with_type":"Xã Vĩnh An, Huyện Vĩnh Bảo, Thành phố Hải Phòng","code":"11842","parent_code":"316"},"11848":{"name":"Xã Vĩnh Hoà","type":"xa","slug":"xa-vinh-hoa","name_with_type":"Xã Vĩnh Hoà","path":"Xã Vĩnh Hoà, Huyện Vĩnh Bảo, Thành phố Hải Phòng","path_with_type":"Xã Vĩnh Hoà, Huyện Vĩnh Bảo, Thành phố Hải Phòng","code":"11848","parent_code":"316"},"11851":{"name":"Xã Hùng Tiến","type":"xa","slug":"xa-hung-tien","name_with_type":"Xã Hùng Tiến","path":"Xã Hùng Tiến, Huyện Vĩnh Bảo, Thành phố Hải Phòng","path_with_type":"Xã Hùng Tiến, Huyện Vĩnh Bảo, Thành phố Hải Phòng","code":"11851","parent_code":"316"},"11857":{"name":"Xã Tân Hưng","type":"xa","slug":"xa-tan-hung","name_with_type":"Xã Tân Hưng","path":"Xã Tân Hưng, Huyện Vĩnh Bảo, Thành phố Hải Phòng","path_with_type":"Xã Tân Hưng, Huyện Vĩnh Bảo, Thành phố Hải Phòng","code":"11857","parent_code":"316"},"11860":{"name":"Xã Tân Liên","type":"xa","slug":"xa-tan-lien","name_with_type":"Xã Tân Liên","path":"Xã Tân Liên, Huyện Vĩnh Bảo, Thành phố Hải Phòng","path_with_type":"Xã Tân Liên, Huyện Vĩnh Bảo, Thành phố Hải Phòng","code":"11860","parent_code":"316"},"11866":{"name":"Xã Vĩnh Hưng","type":"xa","slug":"xa-vinh-hung","name_with_type":"Xã Vĩnh Hưng","path":"Xã Vĩnh Hưng, Huyện Vĩnh Bảo, Thành phố Hải Phòng","path_with_type":"Xã Vĩnh Hưng, Huyện Vĩnh Bảo, Thành phố Hải Phòng","code":"11866","parent_code":"316"},"11875":{"name":"Xã Vĩnh Hải","type":"xa","slug":"xa-vinh-hai","name_with_type":"Xã Vĩnh Hải","path":"Xã Vĩnh Hải, Huyện Vĩnh Bảo, Thành phố Hải Phòng","path_with_type":"Xã Vĩnh Hải, Huyện Vĩnh Bảo, Thành phố Hải Phòng","code":"11875","parent_code":"316"},"11881":{"name":"Xã Liên Am","type":"xa","slug":"xa-lien-am","name_with_type":"Xã Liên Am","path":"Xã Liên Am, Huyện Vĩnh Bảo, Thành phố Hải Phòng","path_with_type":"Xã Liên Am, Huyện Vĩnh Bảo, Thành phố Hải Phòng","code":"11881","parent_code":"316"},"11884":{"name":"Xã Lý Học","type":"xa","slug":"xa-ly-hoc","name_with_type":"Xã Lý Học","path":"Xã Lý Học, Huyện Vĩnh Bảo, Thành phố Hải Phòng","path_with_type":"Xã Lý Học, Huyện Vĩnh Bảo, Thành phố Hải Phòng","code":"11884","parent_code":"316"},"11887":{"name":"Xã Tam Cường","type":"xa","slug":"xa-tam-cuong","name_with_type":"Xã Tam Cường","path":"Xã Tam Cường, Huyện Vĩnh Bảo, Thành phố Hải Phòng","path_with_type":"Xã Tam Cường, Huyện Vĩnh Bảo, Thành phố Hải Phòng","code":"11887","parent_code":"316"},"11890":{"name":"Xã Hoà Bình","type":"xa","slug":"xa-hoa-binh","name_with_type":"Xã Hoà Bình","path":"Xã Hoà Bình, Huyện Vĩnh Bảo, Thành phố Hải Phòng","path_with_type":"Xã Hoà Bình, Huyện Vĩnh Bảo, Thành phố Hải Phòng","code":"11890","parent_code":"316"},"11893":{"name":"Xã Tiền Phong","type":"xa","slug":"xa-tien-phong","name_with_type":"Xã Tiền Phong","path":"Xã Tiền Phong, Huyện Vĩnh Bảo, Thành phố Hải Phòng","path_with_type":"Xã Tiền Phong, Huyện Vĩnh Bảo, Thành phố Hải Phòng","code":"11893","parent_code":"316"},"11902":{"name":"Xã Cao Minh","type":"xa","slug":"xa-cao-minh","name_with_type":"Xã Cao Minh","path":"Xã Cao Minh, Huyện Vĩnh Bảo, Thành phố Hải Phòng","path_with_type":"Xã Cao Minh, Huyện Vĩnh Bảo, Thành phố Hải Phòng","code":"11902","parent_code":"316"},"11911":{"name":"Xã Trấn Dương","type":"xa","slug":"xa-tran-duong","name_with_type":"Xã Trấn Dương","path":"Xã Trấn Dương, Huyện Vĩnh Bảo, Thành phố Hải Phòng","path_with_type":"Xã Trấn Dương, Huyện Vĩnh Bảo, Thành phố Hải Phòng","code":"11911","parent_code":"316"},"11914":{"name":"Thị trấn Cát Bà","type":"thi-tran","slug":"thi-tran-cat-ba","name_with_type":"Thị trấn Cát Bà","path":"Thị trấn Cát Bà, Huyện Cát Hải, Thành phố Hải Phòng","path_with_type":"Thị trấn Cát Bà, Huyện Cát Hải, Thành phố Hải Phòng","code":"11914","parent_code":"317"},"11917":{"name":"Thị trấn Cát Hải","type":"thi-tran","slug":"thi-tran-cat-hai","name_with_type":"Thị trấn Cát Hải","path":"Thị trấn Cát Hải, Huyện Cát Hải, Thành phố Hải Phòng","path_with_type":"Thị trấn Cát Hải, Huyện Cát Hải, Thành phố Hải Phòng","code":"11917","parent_code":"317"},"11920":{"name":"Xã Nghĩa Lộ","type":"xa","slug":"xa-nghia-lo","name_with_type":"Xã Nghĩa Lộ","path":"Xã Nghĩa Lộ, Huyện Cát Hải, Thành phố Hải Phòng","path_with_type":"Xã Nghĩa Lộ, Huyện Cát Hải, Thành phố Hải Phòng","code":"11920","parent_code":"317"},"11923":{"name":"Xã Đồng Bài","type":"xa","slug":"xa-dong-bai","name_with_type":"Xã Đồng Bài","path":"Xã Đồng Bài, Huyện Cát Hải, Thành phố Hải Phòng","path_with_type":"Xã Đồng Bài, Huyện Cát Hải, Thành phố Hải Phòng","code":"11923","parent_code":"317"},"11926":{"name":"Xã Hoàng Châu","type":"xa","slug":"xa-hoang-chau","name_with_type":"Xã Hoàng Châu","path":"Xã Hoàng Châu, Huyện Cát Hải, Thành phố Hải Phòng","path_with_type":"Xã Hoàng Châu, Huyện Cát Hải, Thành phố Hải Phòng","code":"11926","parent_code":"317"},"11929":{"name":"Xã Văn Phong","type":"xa","slug":"xa-van-phong","name_with_type":"Xã Văn Phong","path":"Xã Văn Phong, Huyện Cát Hải, Thành phố Hải Phòng","path_with_type":"Xã Văn Phong, Huyện Cát Hải, Thành phố Hải Phòng","code":"11929","parent_code":"317"},"11932":{"name":"Xã Phù Long","type":"xa","slug":"xa-phu-long","name_with_type":"Xã Phù Long","path":"Xã Phù Long, Huyện Cát Hải, Thành phố Hải Phòng","path_with_type":"Xã Phù Long, Huyện Cát Hải, Thành phố Hải Phòng","code":"11932","parent_code":"317"},"11935":{"name":"Xã Gia Luận","type":"xa","slug":"xa-gia-luan","name_with_type":"Xã Gia Luận","path":"Xã Gia Luận, Huyện Cát Hải, Thành phố Hải Phòng","path_with_type":"Xã Gia Luận, Huyện Cát Hải, Thành phố Hải Phòng","code":"11935","parent_code":"317"},"11938":{"name":"Xã Hiền Hào","type":"xa","slug":"xa-hien-hao","name_with_type":"Xã Hiền Hào","path":"Xã Hiền Hào, Huyện Cát Hải, Thành phố Hải Phòng","path_with_type":"Xã Hiền Hào, Huyện Cát Hải, Thành phố Hải Phòng","code":"11938","parent_code":"317"},"11941":{"name":"Xã Trân Châu","type":"xa","slug":"xa-tran-chau","name_with_type":"Xã Trân Châu","path":"Xã Trân Châu, Huyện Cát Hải, Thành phố Hải Phòng","path_with_type":"Xã Trân Châu, Huyện Cát Hải, Thành phố Hải Phòng","code":"11941","parent_code":"317"},"11944":{"name":"Xã Việt Hải","type":"xa","slug":"xa-viet-hai","name_with_type":"Xã Việt Hải","path":"Xã Việt Hải, Huyện Cát Hải, Thành phố Hải Phòng","path_with_type":"Xã Việt Hải, Huyện Cát Hải, Thành phố Hải Phòng","code":"11944","parent_code":"317"},"11947":{"name":"Xã Xuân Đám","type":"xa","slug":"xa-xuan-dam","name_with_type":"Xã Xuân Đám","path":"Xã Xuân Đám, Huyện Cát Hải, Thành phố Hải Phòng","path_with_type":"Xã Xuân Đám, Huyện Cát Hải, Thành phố Hải Phòng","code":"11947","parent_code":"317"},"11950":{"name":"Phường Lam Sơn","type":"phuong","slug":"phuong-lam-son","name_with_type":"Phường Lam Sơn","path":"Phường Lam Sơn, Thành phố Hưng Yên, Tỉnh Hưng Yên","path_with_type":"Phường Lam Sơn, Thành phố Hưng Yên, Tỉnh Hưng Yên","code":"11950","parent_code":"323"},"11953":{"name":"Phường Hiến Nam","type":"phuong","slug":"phuong-hien-nam","name_with_type":"Phường Hiến Nam","path":"Phường Hiến Nam, Thành phố Hưng Yên, Tỉnh Hưng Yên","path_with_type":"Phường Hiến Nam, Thành phố Hưng Yên, Tỉnh Hưng Yên","code":"11953","parent_code":"323"},"11956":{"name":"Phường An Tảo","type":"phuong","slug":"phuong-an-tao","name_with_type":"Phường An Tảo","path":"Phường An Tảo, Thành phố Hưng Yên, Tỉnh Hưng Yên","path_with_type":"Phường An Tảo, Thành phố Hưng Yên, Tỉnh Hưng Yên","code":"11956","parent_code":"323"},"11959":{"name":"Phường Lê Lợi","type":"phuong","slug":"phuong-le-loi","name_with_type":"Phường Lê Lợi","path":"Phường Lê Lợi, Thành phố Hưng Yên, Tỉnh Hưng Yên","path_with_type":"Phường Lê Lợi, Thành phố Hưng Yên, Tỉnh Hưng Yên","code":"11959","parent_code":"323"},"11962":{"name":"Phường Minh Khai","type":"phuong","slug":"phuong-minh-khai","name_with_type":"Phường Minh Khai","path":"Phường Minh Khai, Thành phố Hưng Yên, Tỉnh Hưng Yên","path_with_type":"Phường Minh Khai, Thành phố Hưng Yên, Tỉnh Hưng Yên","code":"11962","parent_code":"323"},"11968":{"name":"Phường Hồng Châu","type":"phuong","slug":"phuong-hong-chau","name_with_type":"Phường Hồng Châu","path":"Phường Hồng Châu, Thành phố Hưng Yên, Tỉnh Hưng Yên","path_with_type":"Phường Hồng Châu, Thành phố Hưng Yên, Tỉnh Hưng Yên","code":"11968","parent_code":"323"},"11971":{"name":"Xã Trung Nghĩa","type":"xa","slug":"xa-trung-nghia","name_with_type":"Xã Trung Nghĩa","path":"Xã Trung Nghĩa, Thành phố Hưng Yên, Tỉnh Hưng Yên","path_with_type":"Xã Trung Nghĩa, Thành phố Hưng Yên, Tỉnh Hưng Yên","code":"11971","parent_code":"323"},"11974":{"name":"Xã Liên Phương","type":"xa","slug":"xa-lien-phuong","name_with_type":"Xã Liên Phương","path":"Xã Liên Phương, Thành phố Hưng Yên, Tỉnh Hưng Yên","path_with_type":"Xã Liên Phương, Thành phố Hưng Yên, Tỉnh Hưng Yên","code":"11974","parent_code":"323"},"11977":{"name":"Xã Phương Nam","type":"xa","slug":"xa-phuong-nam","name_with_type":"Xã Phương Nam","path":"Xã Phương Nam, Thành phố Hưng Yên, Tỉnh Hưng Yên","path_with_type":"Xã Phương Nam, Thành phố Hưng Yên, Tỉnh Hưng Yên","code":"11977","parent_code":"323"},"11980":{"name":"Xã Quảng Châu","type":"xa","slug":"xa-quang-chau","name_with_type":"Xã Quảng Châu","path":"Xã Quảng Châu, Thành phố Hưng Yên, Tỉnh Hưng Yên","path_with_type":"Xã Quảng Châu, Thành phố Hưng Yên, Tỉnh Hưng Yên","code":"11980","parent_code":"323"},"11983":{"name":"Xã Bảo Khê","type":"xa","slug":"xa-bao-khe","name_with_type":"Xã Bảo Khê","path":"Xã Bảo Khê, Thành phố Hưng Yên, Tỉnh Hưng Yên","path_with_type":"Xã Bảo Khê, Thành phố Hưng Yên, Tỉnh Hưng Yên","code":"11983","parent_code":"323"},"11986":{"name":"Thị trấn Như Quỳnh","type":"thi-tran","slug":"thi-tran-nhu-quynh","name_with_type":"Thị trấn Như Quỳnh","path":"Thị trấn Như Quỳnh, Huyện Văn Lâm, Tỉnh Hưng Yên","path_with_type":"Thị trấn Như Quỳnh, Huyện Văn Lâm, Tỉnh Hưng Yên","code":"11986","parent_code":"325"},"11989":{"name":"Xã Lạc Đạo","type":"xa","slug":"xa-lac-dao","name_with_type":"Xã Lạc Đạo","path":"Xã Lạc Đạo, Huyện Văn Lâm, Tỉnh Hưng Yên","path_with_type":"Xã Lạc Đạo, Huyện Văn Lâm, Tỉnh Hưng Yên","code":"11989","parent_code":"325"},"11992":{"name":"Xã Chỉ Đạo","type":"xa","slug":"xa-chi-dao","name_with_type":"Xã Chỉ Đạo","path":"Xã Chỉ Đạo, Huyện Văn Lâm, Tỉnh Hưng Yên","path_with_type":"Xã Chỉ Đạo, Huyện Văn Lâm, Tỉnh Hưng Yên","code":"11992","parent_code":"325"},"11995":{"name":"Xã Đại Đồng","type":"xa","slug":"xa-dai-dong","name_with_type":"Xã Đại Đồng","path":"Xã Đại Đồng, Huyện Văn Lâm, Tỉnh Hưng Yên","path_with_type":"Xã Đại Đồng, Huyện Văn Lâm, Tỉnh Hưng Yên","code":"11995","parent_code":"325"},"11998":{"name":"Xã Việt Hưng","type":"xa","slug":"xa-viet-hung","name_with_type":"Xã Việt Hưng","path":"Xã Việt Hưng, Huyện Văn Lâm, Tỉnh Hưng Yên","path_with_type":"Xã Việt Hưng, Huyện Văn Lâm, Tỉnh Hưng Yên","code":"11998","parent_code":"325"},"12001":{"name":"Xã Tân Quang","type":"xa","slug":"xa-tan-quang","name_with_type":"Xã Tân Quang","path":"Xã Tân Quang, Huyện Văn Lâm, Tỉnh Hưng Yên","path_with_type":"Xã Tân Quang, Huyện Văn Lâm, Tỉnh Hưng Yên","code":"12001","parent_code":"325"},"12004":{"name":"Xã Đình Dù","type":"xa","slug":"xa-dinh-du","name_with_type":"Xã Đình Dù","path":"Xã Đình Dù, Huyện Văn Lâm, Tỉnh Hưng Yên","path_with_type":"Xã Đình Dù, Huyện Văn Lâm, Tỉnh Hưng Yên","code":"12004","parent_code":"325"},"12007":{"name":"Xã Minh Hải","type":"xa","slug":"xa-minh-hai","name_with_type":"Xã Minh Hải","path":"Xã Minh Hải, Huyện Văn Lâm, Tỉnh Hưng Yên","path_with_type":"Xã Minh Hải, Huyện Văn Lâm, Tỉnh Hưng Yên","code":"12007","parent_code":"325"},"12010":{"name":"Xã Lương Tài","type":"xa","slug":"xa-luong-tai","name_with_type":"Xã Lương Tài","path":"Xã Lương Tài, Huyện Văn Lâm, Tỉnh Hưng Yên","path_with_type":"Xã Lương Tài, Huyện Văn Lâm, Tỉnh Hưng Yên","code":"12010","parent_code":"325"},"12013":{"name":"Xã Trưng Trắc","type":"xa","slug":"xa-trung-trac","name_with_type":"Xã Trưng Trắc","path":"Xã Trưng Trắc, Huyện Văn Lâm, Tỉnh Hưng Yên","path_with_type":"Xã Trưng Trắc, Huyện Văn Lâm, Tỉnh Hưng Yên","code":"12013","parent_code":"325"},"12016":{"name":"Xã Lạc Hồng","type":"xa","slug":"xa-lac-hong","name_with_type":"Xã Lạc Hồng","path":"Xã Lạc Hồng, Huyện Văn Lâm, Tỉnh Hưng Yên","path_with_type":"Xã Lạc Hồng, Huyện Văn Lâm, Tỉnh Hưng Yên","code":"12016","parent_code":"325"},"12019":{"name":"Thị trấn Văn Giang","type":"thi-tran","slug":"thi-tran-van-giang","name_with_type":"Thị trấn Văn Giang","path":"Thị trấn Văn Giang, Huyện Văn Giang, Tỉnh Hưng Yên","path_with_type":"Thị trấn Văn Giang, Huyện Văn Giang, Tỉnh Hưng Yên","code":"12019","parent_code":"326"},"12022":{"name":"Xã Xuân Quan","type":"xa","slug":"xa-xuan-quan","name_with_type":"Xã Xuân Quan","path":"Xã Xuân Quan, Huyện Văn Giang, Tỉnh Hưng Yên","path_with_type":"Xã Xuân Quan, Huyện Văn Giang, Tỉnh Hưng Yên","code":"12022","parent_code":"326"},"12025":{"name":"Xã Cửu Cao","type":"xa","slug":"xa-cuu-cao","name_with_type":"Xã Cửu Cao","path":"Xã Cửu Cao, Huyện Văn Giang, Tỉnh Hưng Yên","path_with_type":"Xã Cửu Cao, Huyện Văn Giang, Tỉnh Hưng Yên","code":"12025","parent_code":"326"},"12028":{"name":"Xã Phụng Công","type":"xa","slug":"xa-phung-cong","name_with_type":"Xã Phụng Công","path":"Xã Phụng Công, Huyện Văn Giang, Tỉnh Hưng Yên","path_with_type":"Xã Phụng Công, Huyện Văn Giang, Tỉnh Hưng Yên","code":"12028","parent_code":"326"},"12031":{"name":"Xã Nghĩa Trụ","type":"xa","slug":"xa-nghia-tru","name_with_type":"Xã Nghĩa Trụ","path":"Xã Nghĩa Trụ, Huyện Văn Giang, Tỉnh Hưng Yên","path_with_type":"Xã Nghĩa Trụ, Huyện Văn Giang, Tỉnh Hưng Yên","code":"12031","parent_code":"326"},"12034":{"name":"Xã Long Hưng","type":"xa","slug":"xa-long-hung","name_with_type":"Xã Long Hưng","path":"Xã Long Hưng, Huyện Văn Giang, Tỉnh Hưng Yên","path_with_type":"Xã Long Hưng, Huyện Văn Giang, Tỉnh Hưng Yên","code":"12034","parent_code":"326"},"12037":{"name":"Xã Vĩnh Khúc","type":"xa","slug":"xa-vinh-khuc","name_with_type":"Xã Vĩnh Khúc","path":"Xã Vĩnh Khúc, Huyện Văn Giang, Tỉnh Hưng Yên","path_with_type":"Xã Vĩnh Khúc, Huyện Văn Giang, Tỉnh Hưng Yên","code":"12037","parent_code":"326"},"12040":{"name":"Xã Liên Nghĩa","type":"xa","slug":"xa-lien-nghia","name_with_type":"Xã Liên Nghĩa","path":"Xã Liên Nghĩa, Huyện Văn Giang, Tỉnh Hưng Yên","path_with_type":"Xã Liên Nghĩa, Huyện Văn Giang, Tỉnh Hưng Yên","code":"12040","parent_code":"326"},"12043":{"name":"Xã Tân Tiến","type":"xa","slug":"xa-tan-tien","name_with_type":"Xã Tân Tiến","path":"Xã Tân Tiến, Huyện Văn Giang, Tỉnh Hưng Yên","path_with_type":"Xã Tân Tiến, Huyện Văn Giang, Tỉnh Hưng Yên","code":"12043","parent_code":"326"},"12046":{"name":"Xã Thắng Lợi","type":"xa","slug":"xa-thang-loi","name_with_type":"Xã Thắng Lợi","path":"Xã Thắng Lợi, Huyện Văn Giang, Tỉnh Hưng Yên","path_with_type":"Xã Thắng Lợi, Huyện Văn Giang, Tỉnh Hưng Yên","code":"12046","parent_code":"326"},"12049":{"name":"Xã Mễ Sở","type":"xa","slug":"xa-me-so","name_with_type":"Xã Mễ Sở","path":"Xã Mễ Sở, Huyện Văn Giang, Tỉnh Hưng Yên","path_with_type":"Xã Mễ Sở, Huyện Văn Giang, Tỉnh Hưng Yên","code":"12049","parent_code":"326"},"12052":{"name":"Thị trấn Yên Mỹ","type":"thi-tran","slug":"thi-tran-yen-my","name_with_type":"Thị trấn Yên Mỹ","path":"Thị trấn Yên Mỹ, Huyện Yên Mỹ, Tỉnh Hưng Yên","path_with_type":"Thị trấn Yên Mỹ, Huyện Yên Mỹ, Tỉnh Hưng Yên","code":"12052","parent_code":"327"},"12055":{"name":"Xã Nguyễn Văn Linh","type":"xa","slug":"xa-nguyen-van-linh","name_with_type":"Xã Nguyễn Văn Linh","path":"Xã Nguyễn Văn Linh, Huyện Yên Mỹ, Tỉnh Hưng Yên","path_with_type":"Xã Nguyễn Văn Linh, Huyện Yên Mỹ, Tỉnh Hưng Yên","code":"12055","parent_code":"327"},"12061":{"name":"Xã Đồng Than","type":"xa","slug":"xa-dong-than","name_with_type":"Xã Đồng Than","path":"Xã Đồng Than, Huyện Yên Mỹ, Tỉnh Hưng Yên","path_with_type":"Xã Đồng Than, Huyện Yên Mỹ, Tỉnh Hưng Yên","code":"12061","parent_code":"327"},"12064":{"name":"Xã Ngọc Long","type":"xa","slug":"xa-ngoc-long","name_with_type":"Xã Ngọc Long","path":"Xã Ngọc Long, Huyện Yên Mỹ, Tỉnh Hưng Yên","path_with_type":"Xã Ngọc Long, Huyện Yên Mỹ, Tỉnh Hưng Yên","code":"12064","parent_code":"327"},"12067":{"name":"Xã Liêu Xá","type":"xa","slug":"xa-lieu-xa","name_with_type":"Xã Liêu Xá","path":"Xã Liêu Xá, Huyện Yên Mỹ, Tỉnh Hưng Yên","path_with_type":"Xã Liêu Xá, Huyện Yên Mỹ, Tỉnh Hưng Yên","code":"12067","parent_code":"327"},"12070":{"name":"Xã Hoàn Long","type":"xa","slug":"xa-hoan-long","name_with_type":"Xã Hoàn Long","path":"Xã Hoàn Long, Huyện Yên Mỹ, Tỉnh Hưng Yên","path_with_type":"Xã Hoàn Long, Huyện Yên Mỹ, Tỉnh Hưng Yên","code":"12070","parent_code":"327"},"12073":{"name":"Xã Tân Lập","type":"xa","slug":"xa-tan-lap","name_with_type":"Xã Tân Lập","path":"Xã Tân Lập, Huyện Yên Mỹ, Tỉnh Hưng Yên","path_with_type":"Xã Tân Lập, Huyện Yên Mỹ, Tỉnh Hưng Yên","code":"12073","parent_code":"327"},"12076":{"name":"Xã Thanh Long","type":"xa","slug":"xa-thanh-long","name_with_type":"Xã Thanh Long","path":"Xã Thanh Long, Huyện Yên Mỹ, Tỉnh Hưng Yên","path_with_type":"Xã Thanh Long, Huyện Yên Mỹ, Tỉnh Hưng Yên","code":"12076","parent_code":"327"},"12079":{"name":"Xã Yên Phú","type":"xa","slug":"xa-yen-phu","name_with_type":"Xã Yên Phú","path":"Xã Yên Phú, Huyện Yên Mỹ, Tỉnh Hưng Yên","path_with_type":"Xã Yên Phú, Huyện Yên Mỹ, Tỉnh Hưng Yên","code":"12079","parent_code":"327"},"12085":{"name":"Xã Trung Hòa","type":"xa","slug":"xa-trung-hoa","name_with_type":"Xã Trung Hòa","path":"Xã Trung Hòa, Huyện Yên Mỹ, Tỉnh Hưng Yên","path_with_type":"Xã Trung Hòa, Huyện Yên Mỹ, Tỉnh Hưng Yên","code":"12085","parent_code":"327"},"12091":{"name":"Xã Việt Yên","type":"xa","slug":"xa-viet-yen","name_with_type":"Xã Việt Yên","path":"Xã Việt Yên, Huyện Yên Mỹ, Tỉnh Hưng Yên","path_with_type":"Xã Việt Yên, Huyện Yên Mỹ, Tỉnh Hưng Yên","code":"12091","parent_code":"327"},"12100":{"name":"Xã Tân Minh","type":"xa","slug":"xa-tan-minh","name_with_type":"Xã Tân Minh","path":"Xã Tân Minh, Huyện Yên Mỹ, Tỉnh Hưng Yên","path_with_type":"Xã Tân Minh, Huyện Yên Mỹ, Tỉnh Hưng Yên","code":"12100","parent_code":"327"},"12103":{"name":"Phường Bần Yên Nhân","type":"phuong","slug":"phuong-ban-yen-nhan","name_with_type":"Phường Bần Yên Nhân","path":"Phường Bần Yên Nhân, Thị xã Mỹ Hào, Tỉnh Hưng Yên","path_with_type":"Phường Bần Yên Nhân, Thị xã Mỹ Hào, Tỉnh Hưng Yên","code":"12103","parent_code":"328"},"12106":{"name":"Phường Phan Đình Phùng","type":"phuong","slug":"phuong-phan-dinh-phung","name_with_type":"Phường Phan Đình Phùng","path":"Phường Phan Đình Phùng, Thị xã Mỹ Hào, Tỉnh Hưng Yên","path_with_type":"Phường Phan Đình Phùng, Thị xã Mỹ Hào, Tỉnh Hưng Yên","code":"12106","parent_code":"328"},"12109":{"name":"Xã Cẩm Xá","type":"xa","slug":"xa-cam-xa","name_with_type":"Xã Cẩm Xá","path":"Xã Cẩm Xá, Thị xã Mỹ Hào, Tỉnh Hưng Yên","path_with_type":"Xã Cẩm Xá, Thị xã Mỹ Hào, Tỉnh Hưng Yên","code":"12109","parent_code":"328"},"12112":{"name":"Xã Dương Quang","type":"xa","slug":"xa-duong-quang","name_with_type":"Xã Dương Quang","path":"Xã Dương Quang, Thị xã Mỹ Hào, Tỉnh Hưng Yên","path_with_type":"Xã Dương Quang, Thị xã Mỹ Hào, Tỉnh Hưng Yên","code":"12112","parent_code":"328"},"12115":{"name":"Xã Hòa Phong","type":"xa","slug":"xa-hoa-phong","name_with_type":"Xã Hòa Phong","path":"Xã Hòa Phong, Thị xã Mỹ Hào, Tỉnh Hưng Yên","path_with_type":"Xã Hòa Phong, Thị xã Mỹ Hào, Tỉnh Hưng Yên","code":"12115","parent_code":"328"},"12118":{"name":"Phường Nhân Hòa","type":"phuong","slug":"phuong-nhan-hoa","name_with_type":"Phường Nhân Hòa","path":"Phường Nhân Hòa, Thị xã Mỹ Hào, Tỉnh Hưng Yên","path_with_type":"Phường Nhân Hòa, Thị xã Mỹ Hào, Tỉnh Hưng Yên","code":"12118","parent_code":"328"},"12121":{"name":"Phường Dị Sử","type":"phuong","slug":"phuong-di-su","name_with_type":"Phường Dị Sử","path":"Phường Dị Sử, Thị xã Mỹ Hào, Tỉnh Hưng Yên","path_with_type":"Phường Dị Sử, Thị xã Mỹ Hào, Tỉnh Hưng Yên","code":"12121","parent_code":"328"},"12124":{"name":"Phường Bạch Sam","type":"phuong","slug":"phuong-bach-sam","name_with_type":"Phường Bạch Sam","path":"Phường Bạch Sam, Thị xã Mỹ Hào, Tỉnh Hưng Yên","path_with_type":"Phường Bạch Sam, Thị xã Mỹ Hào, Tỉnh Hưng Yên","code":"12124","parent_code":"328"},"12127":{"name":"Phường Minh Đức","type":"phuong","slug":"phuong-minh-duc","name_with_type":"Phường Minh Đức","path":"Phường Minh Đức, Thị xã Mỹ Hào, Tỉnh Hưng Yên","path_with_type":"Phường Minh Đức, Thị xã Mỹ Hào, Tỉnh Hưng Yên","code":"12127","parent_code":"328"},"12130":{"name":"Phường Phùng Chí Kiên","type":"phuong","slug":"phuong-phung-chi-kien","name_with_type":"Phường Phùng Chí Kiên","path":"Phường Phùng Chí Kiên, Thị xã Mỹ Hào, Tỉnh Hưng Yên","path_with_type":"Phường Phùng Chí Kiên, Thị xã Mỹ Hào, Tỉnh Hưng Yên","code":"12130","parent_code":"328"},"12133":{"name":"Xã Xuân Dục","type":"xa","slug":"xa-xuan-duc","name_with_type":"Xã Xuân Dục","path":"Xã Xuân Dục, Thị xã Mỹ Hào, Tỉnh Hưng Yên","path_with_type":"Xã Xuân Dục, Thị xã Mỹ Hào, Tỉnh Hưng Yên","code":"12133","parent_code":"328"},"12136":{"name":"Xã Ngọc Lâm","type":"xa","slug":"xa-ngoc-lam","name_with_type":"Xã Ngọc Lâm","path":"Xã Ngọc Lâm, Thị xã Mỹ Hào, Tỉnh Hưng Yên","path_with_type":"Xã Ngọc Lâm, Thị xã Mỹ Hào, Tỉnh Hưng Yên","code":"12136","parent_code":"328"},"12139":{"name":"Xã Hưng Long","type":"xa","slug":"xa-hung-long","name_with_type":"Xã Hưng Long","path":"Xã Hưng Long, Thị xã Mỹ Hào, Tỉnh Hưng Yên","path_with_type":"Xã Hưng Long, Thị xã Mỹ Hào, Tỉnh Hưng Yên","code":"12139","parent_code":"328"},"12142":{"name":"Thị trấn Ân Thi","type":"thi-tran","slug":"thi-tran-an-thi","name_with_type":"Thị trấn Ân Thi","path":"Thị trấn Ân Thi, Huyện Ân Thi, Tỉnh Hưng Yên","path_with_type":"Thị trấn Ân Thi, Huyện Ân Thi, Tỉnh Hưng Yên","code":"12142","parent_code":"329"},"12145":{"name":"Xã Phù Ủng","type":"xa","slug":"xa-phu-ung","name_with_type":"Xã Phù Ủng","path":"Xã Phù Ủng, Huyện Ân Thi, Tỉnh Hưng Yên","path_with_type":"Xã Phù Ủng, Huyện Ân Thi, Tỉnh Hưng Yên","code":"12145","parent_code":"329"},"12148":{"name":"Xã Bắc Sơn","type":"xa","slug":"xa-bac-son","name_with_type":"Xã Bắc Sơn","path":"Xã Bắc Sơn, Huyện Ân Thi, Tỉnh Hưng Yên","path_with_type":"Xã Bắc Sơn, Huyện Ân Thi, Tỉnh Hưng Yên","code":"12148","parent_code":"329"},"12151":{"name":"Xã Bãi Sậy","type":"xa","slug":"xa-bai-say","name_with_type":"Xã Bãi Sậy","path":"Xã Bãi Sậy, Huyện Ân Thi, Tỉnh Hưng Yên","path_with_type":"Xã Bãi Sậy, Huyện Ân Thi, Tỉnh Hưng Yên","code":"12151","parent_code":"329"},"12154":{"name":"Xã Đào Dương","type":"xa","slug":"xa-dao-duong","name_with_type":"Xã Đào Dương","path":"Xã Đào Dương, Huyện Ân Thi, Tỉnh Hưng Yên","path_with_type":"Xã Đào Dương, Huyện Ân Thi, Tỉnh Hưng Yên","code":"12154","parent_code":"329"},"12157":{"name":"Xã Quang Vinh","type":"xa","slug":"xa-quang-vinh","name_with_type":"Xã Quang Vinh","path":"Xã Quang Vinh, Huyện Ân Thi, Tỉnh Hưng Yên","path_with_type":"Xã Quang Vinh, Huyện Ân Thi, Tỉnh Hưng Yên","code":"12157","parent_code":"329"},"12160":{"name":"Xã Vân Du","type":"xa","slug":"xa-van-du","name_with_type":"Xã Vân Du","path":"Xã Vân Du, Huyện Ân Thi, Tỉnh Hưng Yên","path_with_type":"Xã Vân Du, Huyện Ân Thi, Tỉnh Hưng Yên","code":"12160","parent_code":"329"},"12166":{"name":"Xã Xuân Trúc","type":"xa","slug":"xa-xuan-truc","name_with_type":"Xã Xuân Trúc","path":"Xã Xuân Trúc, Huyện Ân Thi, Tỉnh Hưng Yên","path_with_type":"Xã Xuân Trúc, Huyện Ân Thi, Tỉnh Hưng Yên","code":"12166","parent_code":"329"},"12169":{"name":"Xã Hoàng Hoa Thám","type":"xa","slug":"xa-hoang-hoa-tham","name_with_type":"Xã Hoàng Hoa Thám","path":"Xã Hoàng Hoa Thám, Huyện Ân Thi, Tỉnh Hưng Yên","path_with_type":"Xã Hoàng Hoa Thám, Huyện Ân Thi, Tỉnh Hưng Yên","code":"12169","parent_code":"329"},"12172":{"name":"Xã Quảng Lãng","type":"xa","slug":"xa-quang-lang","name_with_type":"Xã Quảng Lãng","path":"Xã Quảng Lãng, Huyện Ân Thi, Tỉnh Hưng Yên","path_with_type":"Xã Quảng Lãng, Huyện Ân Thi, Tỉnh Hưng Yên","code":"12172","parent_code":"329"},"12175":{"name":"Xã Đa Lộc","type":"xa","slug":"xa-da-loc","name_with_type":"Xã Đa Lộc","path":"Xã Đa Lộc, Huyện Ân Thi, Tỉnh Hưng Yên","path_with_type":"Xã Đa Lộc, Huyện Ân Thi, Tỉnh Hưng Yên","code":"12175","parent_code":"329"},"12178":{"name":"Xã Đặng Lễ","type":"xa","slug":"xa-dang-le","name_with_type":"Xã Đặng Lễ","path":"Xã Đặng Lễ, Huyện Ân Thi, Tỉnh Hưng Yên","path_with_type":"Xã Đặng Lễ, Huyện Ân Thi, Tỉnh Hưng Yên","code":"12178","parent_code":"329"},"12181":{"name":"Xã Cẩm Ninh","type":"xa","slug":"xa-cam-ninh","name_with_type":"Xã Cẩm Ninh","path":"Xã Cẩm Ninh, Huyện Ân Thi, Tỉnh Hưng Yên","path_with_type":"Xã Cẩm Ninh, Huyện Ân Thi, Tỉnh Hưng Yên","code":"12181","parent_code":"329"},"12184":{"name":"Xã Nguyễn Trãi","type":"xa","slug":"xa-nguyen-trai","name_with_type":"Xã Nguyễn Trãi","path":"Xã Nguyễn Trãi, Huyện Ân Thi, Tỉnh Hưng Yên","path_with_type":"Xã Nguyễn Trãi, Huyện Ân Thi, Tỉnh Hưng Yên","code":"12184","parent_code":"329"},"12190":{"name":"Xã Hồ Tùng Mậu","type":"xa","slug":"xa-ho-tung-mau","name_with_type":"Xã Hồ Tùng Mậu","path":"Xã Hồ Tùng Mậu, Huyện Ân Thi, Tỉnh Hưng Yên","path_with_type":"Xã Hồ Tùng Mậu, Huyện Ân Thi, Tỉnh Hưng Yên","code":"12190","parent_code":"329"},"12193":{"name":"Xã Tiền Phong","type":"xa","slug":"xa-tien-phong","name_with_type":"Xã Tiền Phong","path":"Xã Tiền Phong, Huyện Ân Thi, Tỉnh Hưng Yên","path_with_type":"Xã Tiền Phong, Huyện Ân Thi, Tỉnh Hưng Yên","code":"12193","parent_code":"329"},"12196":{"name":"Xã Hồng Quang","type":"xa","slug":"xa-hong-quang","name_with_type":"Xã Hồng Quang","path":"Xã Hồng Quang, Huyện Ân Thi, Tỉnh Hưng Yên","path_with_type":"Xã Hồng Quang, Huyện Ân Thi, Tỉnh Hưng Yên","code":"12196","parent_code":"329"},"12202":{"name":"Xã Hạ Lễ","type":"xa","slug":"xa-ha-le","name_with_type":"Xã Hạ Lễ","path":"Xã Hạ Lễ, Huyện Ân Thi, Tỉnh Hưng Yên","path_with_type":"Xã Hạ Lễ, Huyện Ân Thi, Tỉnh Hưng Yên","code":"12202","parent_code":"329"},"12205":{"name":"Thị trấn Khoái Châu","type":"thi-tran","slug":"thi-tran-khoai-chau","name_with_type":"Thị trấn Khoái Châu","path":"Thị trấn Khoái Châu, Huyện Khoái Châu, Tỉnh Hưng Yên","path_with_type":"Thị trấn Khoái Châu, Huyện Khoái Châu, Tỉnh Hưng Yên","code":"12205","parent_code":"330"},"12208":{"name":"Xã Đông Tảo","type":"xa","slug":"xa-dong-tao","name_with_type":"Xã Đông Tảo","path":"Xã Đông Tảo, Huyện Khoái Châu, Tỉnh Hưng Yên","path_with_type":"Xã Đông Tảo, Huyện Khoái Châu, Tỉnh Hưng Yên","code":"12208","parent_code":"330"},"12211":{"name":"Xã Bình Minh","type":"xa","slug":"xa-binh-minh","name_with_type":"Xã Bình Minh","path":"Xã Bình Minh, Huyện Khoái Châu, Tỉnh Hưng Yên","path_with_type":"Xã Bình Minh, Huyện Khoái Châu, Tỉnh Hưng Yên","code":"12211","parent_code":"330"},"12214":{"name":"Xã Phạm Hồng Thái","type":"xa","slug":"xa-pham-hong-thai","name_with_type":"Xã Phạm Hồng Thái","path":"Xã Phạm Hồng Thái, Huyện Khoái Châu, Tỉnh Hưng Yên","path_with_type":"Xã Phạm Hồng Thái, Huyện Khoái Châu, Tỉnh Hưng Yên","code":"12214","parent_code":"330"},"12220":{"name":"Xã Ông Đình","type":"xa","slug":"xa-ong-dinh","name_with_type":"Xã Ông Đình","path":"Xã Ông Đình, Huyện Khoái Châu, Tỉnh Hưng Yên","path_with_type":"Xã Ông Đình, Huyện Khoái Châu, Tỉnh Hưng Yên","code":"12220","parent_code":"330"},"12223":{"name":"Xã Tân Dân","type":"xa","slug":"xa-tan-dan","name_with_type":"Xã Tân Dân","path":"Xã Tân Dân, Huyện Khoái Châu, Tỉnh Hưng Yên","path_with_type":"Xã Tân Dân, Huyện Khoái Châu, Tỉnh Hưng Yên","code":"12223","parent_code":"330"},"12226":{"name":"Xã Tứ Dân","type":"xa","slug":"xa-tu-dan","name_with_type":"Xã Tứ Dân","path":"Xã Tứ Dân, Huyện Khoái Châu, Tỉnh Hưng Yên","path_with_type":"Xã Tứ Dân, Huyện Khoái Châu, Tỉnh Hưng Yên","code":"12226","parent_code":"330"},"12229":{"name":"Xã An Vĩ","type":"xa","slug":"xa-an-vi","name_with_type":"Xã An Vĩ","path":"Xã An Vĩ, Huyện Khoái Châu, Tỉnh Hưng Yên","path_with_type":"Xã An Vĩ, Huyện Khoái Châu, Tỉnh Hưng Yên","code":"12229","parent_code":"330"},"12232":{"name":"Xã Đông Kết","type":"xa","slug":"xa-dong-ket","name_with_type":"Xã Đông Kết","path":"Xã Đông Kết, Huyện Khoái Châu, Tỉnh Hưng Yên","path_with_type":"Xã Đông Kết, Huyện Khoái Châu, Tỉnh Hưng Yên","code":"12232","parent_code":"330"},"12238":{"name":"Xã Dân Tiến","type":"xa","slug":"xa-dan-tien","name_with_type":"Xã Dân Tiến","path":"Xã Dân Tiến, Huyện Khoái Châu, Tỉnh Hưng Yên","path_with_type":"Xã Dân Tiến, Huyện Khoái Châu, Tỉnh Hưng Yên","code":"12238","parent_code":"330"},"12244":{"name":"Xã Đồng Tiến","type":"xa","slug":"xa-dong-tien","name_with_type":"Xã Đồng Tiến","path":"Xã Đồng Tiến, Huyện Khoái Châu, Tỉnh Hưng Yên","path_with_type":"Xã Đồng Tiến, Huyện Khoái Châu, Tỉnh Hưng Yên","code":"12244","parent_code":"330"},"12247":{"name":"Xã Tân Châu","type":"xa","slug":"xa-tan-chau","name_with_type":"Xã Tân Châu","path":"Xã Tân Châu, Huyện Khoái Châu, Tỉnh Hưng Yên","path_with_type":"Xã Tân Châu, Huyện Khoái Châu, Tỉnh Hưng Yên","code":"12247","parent_code":"330"},"12250":{"name":"Xã Liên Khê","type":"xa","slug":"xa-lien-khe","name_with_type":"Xã Liên Khê","path":"Xã Liên Khê, Huyện Khoái Châu, Tỉnh Hưng Yên","path_with_type":"Xã Liên Khê, Huyện Khoái Châu, Tỉnh Hưng Yên","code":"12250","parent_code":"330"},"12253":{"name":"Xã Phùng Hưng","type":"xa","slug":"xa-phung-hung","name_with_type":"Xã Phùng Hưng","path":"Xã Phùng Hưng, Huyện Khoái Châu, Tỉnh Hưng Yên","path_with_type":"Xã Phùng Hưng, Huyện Khoái Châu, Tỉnh Hưng Yên","code":"12253","parent_code":"330"},"12256":{"name":"Xã Việt Hòa","type":"xa","slug":"xa-viet-hoa","name_with_type":"Xã Việt Hòa","path":"Xã Việt Hòa, Huyện Khoái Châu, Tỉnh Hưng Yên","path_with_type":"Xã Việt Hòa, Huyện Khoái Châu, Tỉnh Hưng Yên","code":"12256","parent_code":"330"},"12259":{"name":"Xã Đông Ninh","type":"xa","slug":"xa-dong-ninh","name_with_type":"Xã Đông Ninh","path":"Xã Đông Ninh, Huyện Khoái Châu, Tỉnh Hưng Yên","path_with_type":"Xã Đông Ninh, Huyện Khoái Châu, Tỉnh Hưng Yên","code":"12259","parent_code":"330"},"12262":{"name":"Xã Đại Tập","type":"xa","slug":"xa-dai-tap","name_with_type":"Xã Đại Tập","path":"Xã Đại Tập, Huyện Khoái Châu, Tỉnh Hưng Yên","path_with_type":"Xã Đại Tập, Huyện Khoái Châu, Tỉnh Hưng Yên","code":"12262","parent_code":"330"},"12265":{"name":"Xã Chí Minh","type":"xa","slug":"xa-chi-minh","name_with_type":"Xã Chí Minh","path":"Xã Chí Minh, Huyện Khoái Châu, Tỉnh Hưng Yên","path_with_type":"Xã Chí Minh, Huyện Khoái Châu, Tỉnh Hưng Yên","code":"12265","parent_code":"330"},"12271":{"name":"Xã Thuần Hưng","type":"xa","slug":"xa-thuan-hung","name_with_type":"Xã Thuần Hưng","path":"Xã Thuần Hưng, Huyện Khoái Châu, Tỉnh Hưng Yên","path_with_type":"Xã Thuần Hưng, Huyện Khoái Châu, Tỉnh Hưng Yên","code":"12271","parent_code":"330"},"12274":{"name":"Xã Nguyễn Huệ","type":"xa","slug":"xa-nguyen-hue","name_with_type":"Xã Nguyễn Huệ","path":"Xã Nguyễn Huệ, Huyện Khoái Châu, Tỉnh Hưng Yên","path_with_type":"Xã Nguyễn Huệ, Huyện Khoái Châu, Tỉnh Hưng Yên","code":"12274","parent_code":"330"},"12280":{"name":"Thị trấn Lương Bằng","type":"thi-tran","slug":"thi-tran-luong-bang","name_with_type":"Thị trấn Lương Bằng","path":"Thị trấn Lương Bằng, Huyện Kim Động, Tỉnh Hưng Yên","path_with_type":"Thị trấn Lương Bằng, Huyện Kim Động, Tỉnh Hưng Yên","code":"12280","parent_code":"331"},"12283":{"name":"Xã Nghĩa Dân","type":"xa","slug":"xa-nghia-dan","name_with_type":"Xã Nghĩa Dân","path":"Xã Nghĩa Dân, Huyện Kim Động, Tỉnh Hưng Yên","path_with_type":"Xã Nghĩa Dân, Huyện Kim Động, Tỉnh Hưng Yên","code":"12283","parent_code":"331"},"12286":{"name":"Xã Toàn Thắng","type":"xa","slug":"xa-toan-thang","name_with_type":"Xã Toàn Thắng","path":"Xã Toàn Thắng, Huyện Kim Động, Tỉnh Hưng Yên","path_with_type":"Xã Toàn Thắng, Huyện Kim Động, Tỉnh Hưng Yên","code":"12286","parent_code":"331"},"12289":{"name":"Xã Vĩnh Xá","type":"xa","slug":"xa-vinh-xa","name_with_type":"Xã Vĩnh Xá","path":"Xã Vĩnh Xá, Huyện Kim Động, Tỉnh Hưng Yên","path_with_type":"Xã Vĩnh Xá, Huyện Kim Động, Tỉnh Hưng Yên","code":"12289","parent_code":"331"},"12292":{"name":"Xã Phạm Ngũ Lão","type":"xa","slug":"xa-pham-ngu-lao","name_with_type":"Xã Phạm Ngũ Lão","path":"Xã Phạm Ngũ Lão, Huyện Kim Động, Tỉnh Hưng Yên","path_with_type":"Xã Phạm Ngũ Lão, Huyện Kim Động, Tỉnh Hưng Yên","code":"12292","parent_code":"331"},"12295":{"name":"Xã Phú Thọ","type":"xa","slug":"xa-phu-tho","name_with_type":"Xã Phú Thọ","path":"Xã Phú Thọ, Huyện Kim Động, Tỉnh Hưng Yên","path_with_type":"Xã Phú Thọ, Huyện Kim Động, Tỉnh Hưng Yên","code":"12295","parent_code":"331"},"12298":{"name":"Xã Đồng Thanh","type":"xa","slug":"xa-dong-thanh","name_with_type":"Xã Đồng Thanh","path":"Xã Đồng Thanh, Huyện Kim Động, Tỉnh Hưng Yên","path_with_type":"Xã Đồng Thanh, Huyện Kim Động, Tỉnh Hưng Yên","code":"12298","parent_code":"331"},"12301":{"name":"Xã Song Mai","type":"xa","slug":"xa-song-mai","name_with_type":"Xã Song Mai","path":"Xã Song Mai, Huyện Kim Động, Tỉnh Hưng Yên","path_with_type":"Xã Song Mai, Huyện Kim Động, Tỉnh Hưng Yên","code":"12301","parent_code":"331"},"12304":{"name":"Xã Chính Nghĩa","type":"xa","slug":"xa-chinh-nghia","name_with_type":"Xã Chính Nghĩa","path":"Xã Chính Nghĩa, Huyện Kim Động, Tỉnh Hưng Yên","path_with_type":"Xã Chính Nghĩa, Huyện Kim Động, Tỉnh Hưng Yên","code":"12304","parent_code":"331"},"12313":{"name":"Xã Mai Động","type":"xa","slug":"xa-mai-dong","name_with_type":"Xã Mai Động","path":"Xã Mai Động, Huyện Kim Động, Tỉnh Hưng Yên","path_with_type":"Xã Mai Động, Huyện Kim Động, Tỉnh Hưng Yên","code":"12313","parent_code":"331"},"12316":{"name":"Xã Đức Hợp","type":"xa","slug":"xa-duc-hop","name_with_type":"Xã Đức Hợp","path":"Xã Đức Hợp, Huyện Kim Động, Tỉnh Hưng Yên","path_with_type":"Xã Đức Hợp, Huyện Kim Động, Tỉnh Hưng Yên","code":"12316","parent_code":"331"},"12319":{"name":"Xã Hùng An","type":"xa","slug":"xa-hung-an","name_with_type":"Xã Hùng An","path":"Xã Hùng An, Huyện Kim Động, Tỉnh Hưng Yên","path_with_type":"Xã Hùng An, Huyện Kim Động, Tỉnh Hưng Yên","code":"12319","parent_code":"331"},"12322":{"name":"Xã Ngọc Thanh","type":"xa","slug":"xa-ngoc-thanh","name_with_type":"Xã Ngọc Thanh","path":"Xã Ngọc Thanh, Huyện Kim Động, Tỉnh Hưng Yên","path_with_type":"Xã Ngọc Thanh, Huyện Kim Động, Tỉnh Hưng Yên","code":"12322","parent_code":"331"},"12325":{"name":"Xã Diên Hồng","type":"xa","slug":"xa-dien-hong","name_with_type":"Xã Diên Hồng","path":"Xã Diên Hồng, Huyện Kim Động, Tỉnh Hưng Yên","path_with_type":"Xã Diên Hồng, Huyện Kim Động, Tỉnh Hưng Yên","code":"12325","parent_code":"331"},"12328":{"name":"Xã Hiệp Cường","type":"xa","slug":"xa-hiep-cuong","name_with_type":"Xã Hiệp Cường","path":"Xã Hiệp Cường, Huyện Kim Động, Tỉnh Hưng Yên","path_with_type":"Xã Hiệp Cường, Huyện Kim Động, Tỉnh Hưng Yên","code":"12328","parent_code":"331"},"12331":{"name":"Xã Phú Cường","type":"xa","slug":"xa-phu-cuong","name_with_type":"Xã Phú Cường","path":"Xã Phú Cường, Thành phố Hưng Yên, Tỉnh Hưng Yên","path_with_type":"Xã Phú Cường, Thành phố Hưng Yên, Tỉnh Hưng Yên","code":"12331","parent_code":"323"},"12334":{"name":"Xã Hùng Cường","type":"xa","slug":"xa-hung-cuong","name_with_type":"Xã Hùng Cường","path":"Xã Hùng Cường, Thành phố Hưng Yên, Tỉnh Hưng Yên","path_with_type":"Xã Hùng Cường, Thành phố Hưng Yên, Tỉnh Hưng Yên","code":"12334","parent_code":"323"},"12337":{"name":"Thị trấn Vương","type":"thi-tran","slug":"thi-tran-vuong","name_with_type":"Thị trấn Vương","path":"Thị trấn Vương, Huyện Tiên Lữ, Tỉnh Hưng Yên","path_with_type":"Thị trấn Vương, Huyện Tiên Lữ, Tỉnh Hưng Yên","code":"12337","parent_code":"332"},"12340":{"name":"Xã Hưng Đạo","type":"xa","slug":"xa-hung-dao","name_with_type":"Xã Hưng Đạo","path":"Xã Hưng Đạo, Huyện Tiên Lữ, Tỉnh Hưng Yên","path_with_type":"Xã Hưng Đạo, Huyện Tiên Lữ, Tỉnh Hưng Yên","code":"12340","parent_code":"332"},"12346":{"name":"Xã Nhật Tân","type":"xa","slug":"xa-nhat-tan","name_with_type":"Xã Nhật Tân","path":"Xã Nhật Tân, Huyện Tiên Lữ, Tỉnh Hưng Yên","path_with_type":"Xã Nhật Tân, Huyện Tiên Lữ, Tỉnh Hưng Yên","code":"12346","parent_code":"332"},"12352":{"name":"Xã Lệ Xá","type":"xa","slug":"xa-le-xa","name_with_type":"Xã Lệ Xá","path":"Xã Lệ Xá, Huyện Tiên Lữ, Tỉnh Hưng Yên","path_with_type":"Xã Lệ Xá, Huyện Tiên Lữ, Tỉnh Hưng Yên","code":"12352","parent_code":"332"},"12355":{"name":"Xã An Viên","type":"xa","slug":"xa-an-vien","name_with_type":"Xã An Viên","path":"Xã An Viên, Huyện Tiên Lữ, Tỉnh Hưng Yên","path_with_type":"Xã An Viên, Huyện Tiên Lữ, Tỉnh Hưng Yên","code":"12355","parent_code":"332"},"12361":{"name":"Xã Trung Dũng","type":"xa","slug":"xa-trung-dung","name_with_type":"Xã Trung Dũng","path":"Xã Trung Dũng, Huyện Tiên Lữ, Tỉnh Hưng Yên","path_with_type":"Xã Trung Dũng, Huyện Tiên Lữ, Tỉnh Hưng Yên","code":"12361","parent_code":"332"},"12364":{"name":"Xã Hải Thắng","type":"xa","slug":"xa-hai-thang","name_with_type":"Xã Hải Thắng","path":"Xã Hải Thắng, Huyện Tiên Lữ, Tỉnh Hưng Yên","path_with_type":"Xã Hải Thắng, Huyện Tiên Lữ, Tỉnh Hưng Yên","code":"12364","parent_code":"332"},"12367":{"name":"Xã Thủ Sỹ","type":"xa","slug":"xa-thu-sy","name_with_type":"Xã Thủ Sỹ","path":"Xã Thủ Sỹ, Huyện Tiên Lữ, Tỉnh Hưng Yên","path_with_type":"Xã Thủ Sỹ, Huyện Tiên Lữ, Tỉnh Hưng Yên","code":"12367","parent_code":"332"},"12370":{"name":"Xã Thiện Phiến","type":"xa","slug":"xa-thien-phien","name_with_type":"Xã Thiện Phiến","path":"Xã Thiện Phiến, Huyện Tiên Lữ, Tỉnh Hưng Yên","path_with_type":"Xã Thiện Phiến, Huyện Tiên Lữ, Tỉnh Hưng Yên","code":"12370","parent_code":"332"},"12373":{"name":"Xã Thụy Lôi","type":"xa","slug":"xa-thuy-loi","name_with_type":"Xã Thụy Lôi","path":"Xã Thụy Lôi, Huyện Tiên Lữ, Tỉnh Hưng Yên","path_with_type":"Xã Thụy Lôi, Huyện Tiên Lữ, Tỉnh Hưng Yên","code":"12373","parent_code":"332"},"12376":{"name":"Xã Cương Chính","type":"xa","slug":"xa-cuong-chinh","name_with_type":"Xã Cương Chính","path":"Xã Cương Chính, Huyện Tiên Lữ, Tỉnh Hưng Yên","path_with_type":"Xã Cương Chính, Huyện Tiên Lữ, Tỉnh Hưng Yên","code":"12376","parent_code":"332"},"12385":{"name":"Xã Tân Hưng","type":"xa","slug":"xa-tan-hung","name_with_type":"Xã Tân Hưng","path":"Xã Tân Hưng, Thành phố Hưng Yên, Tỉnh Hưng Yên","path_with_type":"Xã Tân Hưng, Thành phố Hưng Yên, Tỉnh Hưng Yên","code":"12385","parent_code":"323"},"12388":{"name":"Xã Hoàng Hanh","type":"xa","slug":"xa-hoang-hanh","name_with_type":"Xã Hoàng Hanh","path":"Xã Hoàng Hanh, Thành phố Hưng Yên, Tỉnh Hưng Yên","path_with_type":"Xã Hoàng Hanh, Thành phố Hưng Yên, Tỉnh Hưng Yên","code":"12388","parent_code":"323"},"12391":{"name":"Thị trấn Trần Cao","type":"thi-tran","slug":"thi-tran-tran-cao","name_with_type":"Thị trấn Trần Cao","path":"Thị trấn Trần Cao, Huyện Phù Cừ, Tỉnh Hưng Yên","path_with_type":"Thị trấn Trần Cao, Huyện Phù Cừ, Tỉnh Hưng Yên","code":"12391","parent_code":"333"},"12394":{"name":"Xã Minh Tân","type":"xa","slug":"xa-minh-tan","name_with_type":"Xã Minh Tân","path":"Xã Minh Tân, Huyện Phù Cừ, Tỉnh Hưng Yên","path_with_type":"Xã Minh Tân, Huyện Phù Cừ, Tỉnh Hưng Yên","code":"12394","parent_code":"333"},"12397":{"name":"Xã Phan Sào Nam","type":"xa","slug":"xa-phan-sao-nam","name_with_type":"Xã Phan Sào Nam","path":"Xã Phan Sào Nam, Huyện Phù Cừ, Tỉnh Hưng Yên","path_with_type":"Xã Phan Sào Nam, Huyện Phù Cừ, Tỉnh Hưng Yên","code":"12397","parent_code":"333"},"12400":{"name":"Xã Quang Hưng","type":"xa","slug":"xa-quang-hung","name_with_type":"Xã Quang Hưng","path":"Xã Quang Hưng, Huyện Phù Cừ, Tỉnh Hưng Yên","path_with_type":"Xã Quang Hưng, Huyện Phù Cừ, Tỉnh Hưng Yên","code":"12400","parent_code":"333"},"12403":{"name":"Xã Minh Hoàng","type":"xa","slug":"xa-minh-hoang","name_with_type":"Xã Minh Hoàng","path":"Xã Minh Hoàng, Huyện Phù Cừ, Tỉnh Hưng Yên","path_with_type":"Xã Minh Hoàng, Huyện Phù Cừ, Tỉnh Hưng Yên","code":"12403","parent_code":"333"},"12406":{"name":"Xã Đoàn Đào","type":"xa","slug":"xa-doan-dao","name_with_type":"Xã Đoàn Đào","path":"Xã Đoàn Đào, Huyện Phù Cừ, Tỉnh Hưng Yên","path_with_type":"Xã Đoàn Đào, Huyện Phù Cừ, Tỉnh Hưng Yên","code":"12406","parent_code":"333"},"12409":{"name":"Xã Tống Phan","type":"xa","slug":"xa-tong-phan","name_with_type":"Xã Tống Phan","path":"Xã Tống Phan, Huyện Phù Cừ, Tỉnh Hưng Yên","path_with_type":"Xã Tống Phan, Huyện Phù Cừ, Tỉnh Hưng Yên","code":"12409","parent_code":"333"},"12412":{"name":"Xã Đình Cao","type":"xa","slug":"xa-dinh-cao","name_with_type":"Xã Đình Cao","path":"Xã Đình Cao, Huyện Phù Cừ, Tỉnh Hưng Yên","path_with_type":"Xã Đình Cao, Huyện Phù Cừ, Tỉnh Hưng Yên","code":"12412","parent_code":"333"},"12415":{"name":"Xã Nhật Quang","type":"xa","slug":"xa-nhat-quang","name_with_type":"Xã Nhật Quang","path":"Xã Nhật Quang, Huyện Phù Cừ, Tỉnh Hưng Yên","path_with_type":"Xã Nhật Quang, Huyện Phù Cừ, Tỉnh Hưng Yên","code":"12415","parent_code":"333"},"12421":{"name":"Xã Tam Đa","type":"xa","slug":"xa-tam-da","name_with_type":"Xã Tam Đa","path":"Xã Tam Đa, Huyện Phù Cừ, Tỉnh Hưng Yên","path_with_type":"Xã Tam Đa, Huyện Phù Cừ, Tỉnh Hưng Yên","code":"12421","parent_code":"333"},"12424":{"name":"Xã Tiên Tiến","type":"xa","slug":"xa-tien-tien","name_with_type":"Xã Tiên Tiến","path":"Xã Tiên Tiến, Huyện Phù Cừ, Tỉnh Hưng Yên","path_with_type":"Xã Tiên Tiến, Huyện Phù Cừ, Tỉnh Hưng Yên","code":"12424","parent_code":"333"},"12427":{"name":"Xã Nguyên Hòa","type":"xa","slug":"xa-nguyen-hoa","name_with_type":"Xã Nguyên Hòa","path":"Xã Nguyên Hòa, Huyện Phù Cừ, Tỉnh Hưng Yên","path_with_type":"Xã Nguyên Hòa, Huyện Phù Cừ, Tỉnh Hưng Yên","code":"12427","parent_code":"333"},"12430":{"name":"Xã Tống Trân","type":"xa","slug":"xa-tong-tran","name_with_type":"Xã Tống Trân","path":"Xã Tống Trân, Huyện Phù Cừ, Tỉnh Hưng Yên","path_with_type":"Xã Tống Trân, Huyện Phù Cừ, Tỉnh Hưng Yên","code":"12430","parent_code":"333"},"12433":{"name":"Phường Lê Hồng Phong","type":"phuong","slug":"phuong-le-hong-phong","name_with_type":"Phường Lê Hồng Phong","path":"Phường Lê Hồng Phong, Thành phố Thái Bình, Tỉnh Thái Bình","path_with_type":"Phường Lê Hồng Phong, Thành phố Thái Bình, Tỉnh Thái Bình","code":"12433","parent_code":"336"},"12436":{"name":"Phường Bồ Xuyên","type":"phuong","slug":"phuong-bo-xuyen","name_with_type":"Phường Bồ Xuyên","path":"Phường Bồ Xuyên, Thành phố Thái Bình, Tỉnh Thái Bình","path_with_type":"Phường Bồ Xuyên, Thành phố Thái Bình, Tỉnh Thái Bình","code":"12436","parent_code":"336"},"12439":{"name":"Phường Đề Thám","type":"phuong","slug":"phuong-de-tham","name_with_type":"Phường Đề Thám","path":"Phường Đề Thám, Thành phố Thái Bình, Tỉnh Thái Bình","path_with_type":"Phường Đề Thám, Thành phố Thái Bình, Tỉnh Thái Bình","code":"12439","parent_code":"336"},"12442":{"name":"Phường Kỳ Bá","type":"phuong","slug":"phuong-ky-ba","name_with_type":"Phường Kỳ Bá","path":"Phường Kỳ Bá, Thành phố Thái Bình, Tỉnh Thái Bình","path_with_type":"Phường Kỳ Bá, Thành phố Thái Bình, Tỉnh Thái Bình","code":"12442","parent_code":"336"},"12445":{"name":"Phường Quang Trung","type":"phuong","slug":"phuong-quang-trung","name_with_type":"Phường Quang Trung","path":"Phường Quang Trung, Thành phố Thái Bình, Tỉnh Thái Bình","path_with_type":"Phường Quang Trung, Thành phố Thái Bình, Tỉnh Thái Bình","code":"12445","parent_code":"336"},"12448":{"name":"Phường Phú Khánh","type":"phuong","slug":"phuong-phu-khanh","name_with_type":"Phường Phú Khánh","path":"Phường Phú Khánh, Thành phố Thái Bình, Tỉnh Thái Bình","path_with_type":"Phường Phú Khánh, Thành phố Thái Bình, Tỉnh Thái Bình","code":"12448","parent_code":"336"},"12451":{"name":"Phường Tiền Phong","type":"phuong","slug":"phuong-tien-phong","name_with_type":"Phường Tiền Phong","path":"Phường Tiền Phong, Thành phố Thái Bình, Tỉnh Thái Bình","path_with_type":"Phường Tiền Phong, Thành phố Thái Bình, Tỉnh Thái Bình","code":"12451","parent_code":"336"},"12452":{"name":"Phường Trần Hưng Đạo","type":"phuong","slug":"phuong-tran-hung-dao","name_with_type":"Phường Trần Hưng Đạo","path":"Phường Trần Hưng Đạo, Thành phố Thái Bình, Tỉnh Thái Bình","path_with_type":"Phường Trần Hưng Đạo, Thành phố Thái Bình, Tỉnh Thái Bình","code":"12452","parent_code":"336"},"12454":{"name":"Phường Trần Lãm","type":"phuong","slug":"phuong-tran-lam","name_with_type":"Phường Trần Lãm","path":"Phường Trần Lãm, Thành phố Thái Bình, Tỉnh Thái Bình","path_with_type":"Phường Trần Lãm, Thành phố Thái Bình, Tỉnh Thái Bình","code":"12454","parent_code":"336"},"12457":{"name":"Xã Đông Hòa","type":"xa","slug":"xa-dong-hoa","name_with_type":"Xã Đông Hòa","path":"Xã Đông Hòa, Thành phố Thái Bình, Tỉnh Thái Bình","path_with_type":"Xã Đông Hòa, Thành phố Thái Bình, Tỉnh Thái Bình","code":"12457","parent_code":"336"},"12460":{"name":"Phường Hoàng Diệu","type":"phuong","slug":"phuong-hoang-dieu","name_with_type":"Phường Hoàng Diệu","path":"Phường Hoàng Diệu, Thành phố Thái Bình, Tỉnh Thái Bình","path_with_type":"Phường Hoàng Diệu, Thành phố Thái Bình, Tỉnh Thái Bình","code":"12460","parent_code":"336"},"12463":{"name":"Xã Phú Xuân","type":"xa","slug":"xa-phu-xuan","name_with_type":"Xã Phú Xuân","path":"Xã Phú Xuân, Thành phố Thái Bình, Tỉnh Thái Bình","path_with_type":"Xã Phú Xuân, Thành phố Thái Bình, Tỉnh Thái Bình","code":"12463","parent_code":"336"},"12466":{"name":"Xã Vũ Phúc","type":"xa","slug":"xa-vu-phuc","name_with_type":"Xã Vũ Phúc","path":"Xã Vũ Phúc, Thành phố Thái Bình, Tỉnh Thái Bình","path_with_type":"Xã Vũ Phúc, Thành phố Thái Bình, Tỉnh Thái Bình","code":"12466","parent_code":"336"},"12469":{"name":"Xã Vũ Chính","type":"xa","slug":"xa-vu-chinh","name_with_type":"Xã Vũ Chính","path":"Xã Vũ Chính, Thành phố Thái Bình, Tỉnh Thái Bình","path_with_type":"Xã Vũ Chính, Thành phố Thái Bình, Tỉnh Thái Bình","code":"12469","parent_code":"336"},"12472":{"name":"Thị trấn Quỳnh Côi","type":"thi-tran","slug":"thi-tran-quynh-coi","name_with_type":"Thị trấn Quỳnh Côi","path":"Thị trấn Quỳnh Côi, Huyện Quỳnh Phụ, Tỉnh Thái Bình","path_with_type":"Thị trấn Quỳnh Côi, Huyện Quỳnh Phụ, Tỉnh Thái Bình","code":"12472","parent_code":"338"},"12475":{"name":"Xã An Khê","type":"xa","slug":"xa-an-khe","name_with_type":"Xã An Khê","path":"Xã An Khê, Huyện Quỳnh Phụ, Tỉnh Thái Bình","path_with_type":"Xã An Khê, Huyện Quỳnh Phụ, Tỉnh Thái Bình","code":"12475","parent_code":"338"},"12478":{"name":"Xã An Đồng","type":"xa","slug":"xa-an-dong","name_with_type":"Xã An Đồng","path":"Xã An Đồng, Huyện Quỳnh Phụ, Tỉnh Thái Bình","path_with_type":"Xã An Đồng, Huyện Quỳnh Phụ, Tỉnh Thái Bình","code":"12478","parent_code":"338"},"12481":{"name":"Xã Quỳnh Hoa","type":"xa","slug":"xa-quynh-hoa","name_with_type":"Xã Quỳnh Hoa","path":"Xã Quỳnh Hoa, Huyện Quỳnh Phụ, Tỉnh Thái Bình","path_with_type":"Xã Quỳnh Hoa, Huyện Quỳnh Phụ, Tỉnh Thái Bình","code":"12481","parent_code":"338"},"12484":{"name":"Xã Quỳnh Lâm","type":"xa","slug":"xa-quynh-lam","name_with_type":"Xã Quỳnh Lâm","path":"Xã Quỳnh Lâm, Huyện Quỳnh Phụ, Tỉnh Thái Bình","path_with_type":"Xã Quỳnh Lâm, Huyện Quỳnh Phụ, Tỉnh Thái Bình","code":"12484","parent_code":"338"},"12487":{"name":"Xã Quỳnh Thọ","type":"xa","slug":"xa-quynh-tho","name_with_type":"Xã Quỳnh Thọ","path":"Xã Quỳnh Thọ, Huyện Quỳnh Phụ, Tỉnh Thái Bình","path_with_type":"Xã Quỳnh Thọ, Huyện Quỳnh Phụ, Tỉnh Thái Bình","code":"12487","parent_code":"338"},"12490":{"name":"Xã An Hiệp","type":"xa","slug":"xa-an-hiep","name_with_type":"Xã An Hiệp","path":"Xã An Hiệp, Huyện Quỳnh Phụ, Tỉnh Thái Bình","path_with_type":"Xã An Hiệp, Huyện Quỳnh Phụ, Tỉnh Thái Bình","code":"12490","parent_code":"338"},"12493":{"name":"Xã Quỳnh Hoàng","type":"xa","slug":"xa-quynh-hoang","name_with_type":"Xã Quỳnh Hoàng","path":"Xã Quỳnh Hoàng, Huyện Quỳnh Phụ, Tỉnh Thái Bình","path_with_type":"Xã Quỳnh Hoàng, Huyện Quỳnh Phụ, Tỉnh Thái Bình","code":"12493","parent_code":"338"},"12496":{"name":"Xã Quỳnh Giao","type":"xa","slug":"xa-quynh-giao","name_with_type":"Xã Quỳnh Giao","path":"Xã Quỳnh Giao, Huyện Quỳnh Phụ, Tỉnh Thái Bình","path_with_type":"Xã Quỳnh Giao, Huyện Quỳnh Phụ, Tỉnh Thái Bình","code":"12496","parent_code":"338"},"12499":{"name":"Xã An Thái","type":"xa","slug":"xa-an-thai","name_with_type":"Xã An Thái","path":"Xã An Thái, Huyện Quỳnh Phụ, Tỉnh Thái Bình","path_with_type":"Xã An Thái, Huyện Quỳnh Phụ, Tỉnh Thái Bình","code":"12499","parent_code":"338"},"12502":{"name":"Xã An Cầu","type":"xa","slug":"xa-an-cau","name_with_type":"Xã An Cầu","path":"Xã An Cầu, Huyện Quỳnh Phụ, Tỉnh Thái Bình","path_with_type":"Xã An Cầu, Huyện Quỳnh Phụ, Tỉnh Thái Bình","code":"12502","parent_code":"338"},"12505":{"name":"Xã Quỳnh Hồng","type":"xa","slug":"xa-quynh-hong","name_with_type":"Xã Quỳnh Hồng","path":"Xã Quỳnh Hồng, Huyện Quỳnh Phụ, Tỉnh Thái Bình","path_with_type":"Xã Quỳnh Hồng, Huyện Quỳnh Phụ, Tỉnh Thái Bình","code":"12505","parent_code":"338"},"12508":{"name":"Xã Quỳnh Khê","type":"xa","slug":"xa-quynh-khe","name_with_type":"Xã Quỳnh Khê","path":"Xã Quỳnh Khê, Huyện Quỳnh Phụ, Tỉnh Thái Bình","path_with_type":"Xã Quỳnh Khê, Huyện Quỳnh Phụ, Tỉnh Thái Bình","code":"12508","parent_code":"338"},"12511":{"name":"Xã Quỳnh Minh","type":"xa","slug":"xa-quynh-minh","name_with_type":"Xã Quỳnh Minh","path":"Xã Quỳnh Minh, Huyện Quỳnh Phụ, Tỉnh Thái Bình","path_with_type":"Xã Quỳnh Minh, Huyện Quỳnh Phụ, Tỉnh Thái Bình","code":"12511","parent_code":"338"},"12514":{"name":"Xã An Ninh","type":"xa","slug":"xa-an-ninh","name_with_type":"Xã An Ninh","path":"Xã An Ninh, Huyện Quỳnh Phụ, Tỉnh Thái Bình","path_with_type":"Xã An Ninh, Huyện Quỳnh Phụ, Tỉnh Thái Bình","code":"12514","parent_code":"338"},"12517":{"name":"Xã Quỳnh Ngọc","type":"xa","slug":"xa-quynh-ngoc","name_with_type":"Xã Quỳnh Ngọc","path":"Xã Quỳnh Ngọc, Huyện Quỳnh Phụ, Tỉnh Thái Bình","path_with_type":"Xã Quỳnh Ngọc, Huyện Quỳnh Phụ, Tỉnh Thái Bình","code":"12517","parent_code":"338"},"12520":{"name":"Xã Quỳnh Hải","type":"xa","slug":"xa-quynh-hai","name_with_type":"Xã Quỳnh Hải","path":"Xã Quỳnh Hải, Huyện Quỳnh Phụ, Tỉnh Thái Bình","path_with_type":"Xã Quỳnh Hải, Huyện Quỳnh Phụ, Tỉnh Thái Bình","code":"12520","parent_code":"338"},"12523":{"name":"Thị trấn An Bài","type":"thi-tran","slug":"thi-tran-an-bai","name_with_type":"Thị trấn An Bài","path":"Thị trấn An Bài, Huyện Quỳnh Phụ, Tỉnh Thái Bình","path_with_type":"Thị trấn An Bài, Huyện Quỳnh Phụ, Tỉnh Thái Bình","code":"12523","parent_code":"338"},"12526":{"name":"Xã An Ấp","type":"xa","slug":"xa-an-ap","name_with_type":"Xã An Ấp","path":"Xã An Ấp, Huyện Quỳnh Phụ, Tỉnh Thái Bình","path_with_type":"Xã An Ấp, Huyện Quỳnh Phụ, Tỉnh Thái Bình","code":"12526","parent_code":"338"},"12529":{"name":"Xã Quỳnh Hội","type":"xa","slug":"xa-quynh-hoi","name_with_type":"Xã Quỳnh Hội","path":"Xã Quỳnh Hội, Huyện Quỳnh Phụ, Tỉnh Thái Bình","path_with_type":"Xã Quỳnh Hội, Huyện Quỳnh Phụ, Tỉnh Thái Bình","code":"12529","parent_code":"338"},"12532":{"name":"Xã Châu Sơn","type":"xa","slug":"xa-chau-son","name_with_type":"Xã Châu Sơn","path":"Xã Châu Sơn, Huyện Quỳnh Phụ, Tỉnh Thái Bình","path_with_type":"Xã Châu Sơn, Huyện Quỳnh Phụ, Tỉnh Thái Bình","code":"12532","parent_code":"338"},"12535":{"name":"Xã Quỳnh Mỹ","type":"xa","slug":"xa-quynh-my","name_with_type":"Xã Quỳnh Mỹ","path":"Xã Quỳnh Mỹ, Huyện Quỳnh Phụ, Tỉnh Thái Bình","path_with_type":"Xã Quỳnh Mỹ, Huyện Quỳnh Phụ, Tỉnh Thái Bình","code":"12535","parent_code":"338"},"12538":{"name":"Xã An Quí","type":"xa","slug":"xa-an-qui","name_with_type":"Xã An Quí","path":"Xã An Quí, Huyện Quỳnh Phụ, Tỉnh Thái Bình","path_with_type":"Xã An Quí, Huyện Quỳnh Phụ, Tỉnh Thái Bình","code":"12538","parent_code":"338"},"12541":{"name":"Xã An Thanh","type":"xa","slug":"xa-an-thanh","name_with_type":"Xã An Thanh","path":"Xã An Thanh, Huyện Quỳnh Phụ, Tỉnh Thái Bình","path_with_type":"Xã An Thanh, Huyện Quỳnh Phụ, Tỉnh Thái Bình","code":"12541","parent_code":"338"},"12547":{"name":"Xã An Vũ","type":"xa","slug":"xa-an-vu","name_with_type":"Xã An Vũ","path":"Xã An Vũ, Huyện Quỳnh Phụ, Tỉnh Thái Bình","path_with_type":"Xã An Vũ, Huyện Quỳnh Phụ, Tỉnh Thái Bình","code":"12547","parent_code":"338"},"12550":{"name":"Xã An Lễ","type":"xa","slug":"xa-an-le","name_with_type":"Xã An Lễ","path":"Xã An Lễ, Huyện Quỳnh Phụ, Tỉnh Thái Bình","path_with_type":"Xã An Lễ, Huyện Quỳnh Phụ, Tỉnh Thái Bình","code":"12550","parent_code":"338"},"12553":{"name":"Xã Quỳnh Hưng","type":"xa","slug":"xa-quynh-hung","name_with_type":"Xã Quỳnh Hưng","path":"Xã Quỳnh Hưng, Huyện Quỳnh Phụ, Tỉnh Thái Bình","path_with_type":"Xã Quỳnh Hưng, Huyện Quỳnh Phụ, Tỉnh Thái Bình","code":"12553","parent_code":"338"},"12559":{"name":"Xã An Mỹ","type":"xa","slug":"xa-an-my","name_with_type":"Xã An Mỹ","path":"Xã An Mỹ, Huyện Quỳnh Phụ, Tỉnh Thái Bình","path_with_type":"Xã An Mỹ, Huyện Quỳnh Phụ, Tỉnh Thái Bình","code":"12559","parent_code":"338"},"12562":{"name":"Xã Quỳnh Nguyên","type":"xa","slug":"xa-quynh-nguyen","name_with_type":"Xã Quỳnh Nguyên","path":"Xã Quỳnh Nguyên, Huyện Quỳnh Phụ, Tỉnh Thái Bình","path_with_type":"Xã Quỳnh Nguyên, Huyện Quỳnh Phụ, Tỉnh Thái Bình","code":"12562","parent_code":"338"},"12565":{"name":"Xã An Vinh","type":"xa","slug":"xa-an-vinh","name_with_type":"Xã An Vinh","path":"Xã An Vinh, Huyện Quỳnh Phụ, Tỉnh Thái Bình","path_with_type":"Xã An Vinh, Huyện Quỳnh Phụ, Tỉnh Thái Bình","code":"12565","parent_code":"338"},"12571":{"name":"Xã An Dục","type":"xa","slug":"xa-an-duc","name_with_type":"Xã An Dục","path":"Xã An Dục, Huyện Quỳnh Phụ, Tỉnh Thái Bình","path_with_type":"Xã An Dục, Huyện Quỳnh Phụ, Tỉnh Thái Bình","code":"12571","parent_code":"338"},"12574":{"name":"Xã Đông Hải","type":"xa","slug":"xa-dong-hai","name_with_type":"Xã Đông Hải","path":"Xã Đông Hải, Huyện Quỳnh Phụ, Tỉnh Thái Bình","path_with_type":"Xã Đông Hải, Huyện Quỳnh Phụ, Tỉnh Thái Bình","code":"12574","parent_code":"338"},"12577":{"name":"Xã Trang Bảo Xá","type":"xa","slug":"xa-trang-bao-xa","name_with_type":"Xã Trang Bảo Xá","path":"Xã Trang Bảo Xá, Huyện Quỳnh Phụ, Tỉnh Thái Bình","path_with_type":"Xã Trang Bảo Xá, Huyện Quỳnh Phụ, Tỉnh Thái Bình","code":"12577","parent_code":"338"},"12580":{"name":"Xã An Tràng","type":"xa","slug":"xa-an-trang","name_with_type":"Xã An Tràng","path":"Xã An Tràng, Huyện Quỳnh Phụ, Tỉnh Thái Bình","path_with_type":"Xã An Tràng, Huyện Quỳnh Phụ, Tỉnh Thái Bình","code":"12580","parent_code":"338"},"12583":{"name":"Xã Đồng Tiến","type":"xa","slug":"xa-dong-tien","name_with_type":"Xã Đồng Tiến","path":"Xã Đồng Tiến, Huyện Quỳnh Phụ, Tỉnh Thái Bình","path_with_type":"Xã Đồng Tiến, Huyện Quỳnh Phụ, Tỉnh Thái Bình","code":"12583","parent_code":"338"},"12586":{"name":"Thị trấn Hưng Hà","type":"thi-tran","slug":"thi-tran-hung-ha","name_with_type":"Thị trấn Hưng Hà","path":"Thị trấn Hưng Hà, Huyện Hưng Hà, Tỉnh Thái Bình","path_with_type":"Thị trấn Hưng Hà, Huyện Hưng Hà, Tỉnh Thái Bình","code":"12586","parent_code":"339"},"12589":{"name":"Xã Quang Trung","type":"xa","slug":"xa-quang-trung","name_with_type":"Xã Quang Trung","path":"Xã Quang Trung, Huyện Hưng Hà, Tỉnh Thái Bình","path_with_type":"Xã Quang Trung, Huyện Hưng Hà, Tỉnh Thái Bình","code":"12589","parent_code":"339"},"12592":{"name":"Xã Tân Lễ","type":"xa","slug":"xa-tan-le","name_with_type":"Xã Tân Lễ","path":"Xã Tân Lễ, Huyện Hưng Hà, Tỉnh Thái Bình","path_with_type":"Xã Tân Lễ, Huyện Hưng Hà, Tỉnh Thái Bình","code":"12592","parent_code":"339"},"12595":{"name":"Xã Cộng Hòa","type":"xa","slug":"xa-cong-hoa","name_with_type":"Xã Cộng Hòa","path":"Xã Cộng Hòa, Huyện Hưng Hà, Tỉnh Thái Bình","path_with_type":"Xã Cộng Hòa, Huyện Hưng Hà, Tỉnh Thái Bình","code":"12595","parent_code":"339"},"12601":{"name":"Xã Canh Tân","type":"xa","slug":"xa-canh-tan","name_with_type":"Xã Canh Tân","path":"Xã Canh Tân, Huyện Hưng Hà, Tỉnh Thái Bình","path_with_type":"Xã Canh Tân, Huyện Hưng Hà, Tỉnh Thái Bình","code":"12601","parent_code":"339"},"12604":{"name":"Xã Hòa Tiến","type":"xa","slug":"xa-hoa-tien","name_with_type":"Xã Hòa Tiến","path":"Xã Hòa Tiến, Huyện Hưng Hà, Tỉnh Thái Bình","path_with_type":"Xã Hòa Tiến, Huyện Hưng Hà, Tỉnh Thái Bình","code":"12604","parent_code":"339"},"12610":{"name":"Xã Tân Tiến","type":"xa","slug":"xa-tan-tien","name_with_type":"Xã Tân Tiến","path":"Xã Tân Tiến, Huyện Hưng Hà, Tỉnh Thái Bình","path_with_type":"Xã Tân Tiến, Huyện Hưng Hà, Tỉnh Thái Bình","code":"12610","parent_code":"339"},"12613":{"name":"Thị trấn Hưng Nhân","type":"thi-tran","slug":"thi-tran-hung-nhan","name_with_type":"Thị trấn Hưng Nhân","path":"Thị trấn Hưng Nhân, Huyện Hưng Hà, Tỉnh Thái Bình","path_with_type":"Thị trấn Hưng Nhân, Huyện Hưng Hà, Tỉnh Thái Bình","code":"12613","parent_code":"339"},"12616":{"name":"Xã Đoan Hùng","type":"xa","slug":"xa-doan-hung","name_with_type":"Xã Đoan Hùng","path":"Xã Đoan Hùng, Huyện Hưng Hà, Tỉnh Thái Bình","path_with_type":"Xã Đoan Hùng, Huyện Hưng Hà, Tỉnh Thái Bình","code":"12616","parent_code":"339"},"12619":{"name":"Xã Duyên Hải","type":"xa","slug":"xa-duyen-hai","name_with_type":"Xã Duyên Hải","path":"Xã Duyên Hải, Huyện Hưng Hà, Tỉnh Thái Bình","path_with_type":"Xã Duyên Hải, Huyện Hưng Hà, Tỉnh Thái Bình","code":"12619","parent_code":"339"},"12622":{"name":"Xã Tân Hòa","type":"xa","slug":"xa-tan-hoa","name_with_type":"Xã Tân Hòa","path":"Xã Tân Hòa, Huyện Hưng Hà, Tỉnh Thái Bình","path_with_type":"Xã Tân Hòa, Huyện Hưng Hà, Tỉnh Thái Bình","code":"12622","parent_code":"339"},"12625":{"name":"Xã Văn Cẩm","type":"xa","slug":"xa-van-cam","name_with_type":"Xã Văn Cẩm","path":"Xã Văn Cẩm, Huyện Hưng Hà, Tỉnh Thái Bình","path_with_type":"Xã Văn Cẩm, Huyện Hưng Hà, Tỉnh Thái Bình","code":"12625","parent_code":"339"},"12628":{"name":"Xã Bắc Sơn","type":"xa","slug":"xa-bac-son","name_with_type":"Xã Bắc Sơn","path":"Xã Bắc Sơn, Huyện Hưng Hà, Tỉnh Thái Bình","path_with_type":"Xã Bắc Sơn, Huyện Hưng Hà, Tỉnh Thái Bình","code":"12628","parent_code":"339"},"12631":{"name":"Xã Đông Đô","type":"xa","slug":"xa-dong-do","name_with_type":"Xã Đông Đô","path":"Xã Đông Đô, Huyện Hưng Hà, Tỉnh Thái Bình","path_with_type":"Xã Đông Đô, Huyện Hưng Hà, Tỉnh Thái Bình","code":"12631","parent_code":"339"},"12634":{"name":"Xã Phúc Khánh","type":"xa","slug":"xa-phuc-khanh","name_with_type":"Xã Phúc Khánh","path":"Xã Phúc Khánh, Huyện Hưng Hà, Tỉnh Thái Bình","path_with_type":"Xã Phúc Khánh, Huyện Hưng Hà, Tỉnh Thái Bình","code":"12634","parent_code":"339"},"12637":{"name":"Xã Liên Hiệp","type":"xa","slug":"xa-lien-hiep","name_with_type":"Xã Liên Hiệp","path":"Xã Liên Hiệp, Huyện Hưng Hà, Tỉnh Thái Bình","path_with_type":"Xã Liên Hiệp, Huyện Hưng Hà, Tỉnh Thái Bình","code":"12637","parent_code":"339"},"12640":{"name":"Xã Tây Đô","type":"xa","slug":"xa-tay-do","name_with_type":"Xã Tây Đô","path":"Xã Tây Đô, Huyện Hưng Hà, Tỉnh Thái Bình","path_with_type":"Xã Tây Đô, Huyện Hưng Hà, Tỉnh Thái Bình","code":"12640","parent_code":"339"},"12643":{"name":"Xã Thống Nhất","type":"xa","slug":"xa-thong-nhat","name_with_type":"Xã Thống Nhất","path":"Xã Thống Nhất, Huyện Hưng Hà, Tỉnh Thái Bình","path_with_type":"Xã Thống Nhất, Huyện Hưng Hà, Tỉnh Thái Bình","code":"12643","parent_code":"339"},"12646":{"name":"Xã Tiến Đức","type":"xa","slug":"xa-tien-duc","name_with_type":"Xã Tiến Đức","path":"Xã Tiến Đức, Huyện Hưng Hà, Tỉnh Thái Bình","path_with_type":"Xã Tiến Đức, Huyện Hưng Hà, Tỉnh Thái Bình","code":"12646","parent_code":"339"},"12649":{"name":"Xã Thái Hưng","type":"xa","slug":"xa-thai-hung","name_with_type":"Xã Thái Hưng","path":"Xã Thái Hưng, Huyện Hưng Hà, Tỉnh Thái Bình","path_with_type":"Xã Thái Hưng, Huyện Hưng Hà, Tỉnh Thái Bình","code":"12649","parent_code":"339"},"12652":{"name":"Xã Thái Phương","type":"xa","slug":"xa-thai-phuong","name_with_type":"Xã Thái Phương","path":"Xã Thái Phương, Huyện Hưng Hà, Tỉnh Thái Bình","path_with_type":"Xã Thái Phương, Huyện Hưng Hà, Tỉnh Thái Bình","code":"12652","parent_code":"339"},"12655":{"name":"Xã Hòa Bình","type":"xa","slug":"xa-hoa-binh","name_with_type":"Xã Hòa Bình","path":"Xã Hòa Bình, Huyện Hưng Hà, Tỉnh Thái Bình","path_with_type":"Xã Hòa Bình, Huyện Hưng Hà, Tỉnh Thái Bình","code":"12655","parent_code":"339"},"12656":{"name":"Xã Chi Lăng","type":"xa","slug":"xa-chi-lang","name_with_type":"Xã Chi Lăng","path":"Xã Chi Lăng, Huyện Hưng Hà, Tỉnh Thái Bình","path_with_type":"Xã Chi Lăng, Huyện Hưng Hà, Tỉnh Thái Bình","code":"12656","parent_code":"339"},"12658":{"name":"Xã Minh Khai","type":"xa","slug":"xa-minh-khai","name_with_type":"Xã Minh Khai","path":"Xã Minh Khai, Huyện Hưng Hà, Tỉnh Thái Bình","path_with_type":"Xã Minh Khai, Huyện Hưng Hà, Tỉnh Thái Bình","code":"12658","parent_code":"339"},"12661":{"name":"Xã Hồng An","type":"xa","slug":"xa-hong-an","name_with_type":"Xã Hồng An","path":"Xã Hồng An, Huyện Hưng Hà, Tỉnh Thái Bình","path_with_type":"Xã Hồng An, Huyện Hưng Hà, Tỉnh Thái Bình","code":"12661","parent_code":"339"},"12664":{"name":"Xã Kim Chung","type":"xa","slug":"xa-kim-chung","name_with_type":"Xã Kim Chung","path":"Xã Kim Chung, Huyện Hưng Hà, Tỉnh Thái Bình","path_with_type":"Xã Kim Chung, Huyện Hưng Hà, Tỉnh Thái Bình","code":"12664","parent_code":"339"},"12667":{"name":"Xã Hồng Lĩnh","type":"xa","slug":"xa-hong-linh","name_with_type":"Xã Hồng Lĩnh","path":"Xã Hồng Lĩnh, Huyện Hưng Hà, Tỉnh Thái Bình","path_with_type":"Xã Hồng Lĩnh, Huyện Hưng Hà, Tỉnh Thái Bình","code":"12667","parent_code":"339"},"12670":{"name":"Xã Minh Tân","type":"xa","slug":"xa-minh-tan","name_with_type":"Xã Minh Tân","path":"Xã Minh Tân, Huyện Hưng Hà, Tỉnh Thái Bình","path_with_type":"Xã Minh Tân, Huyện Hưng Hà, Tỉnh Thái Bình","code":"12670","parent_code":"339"},"12673":{"name":"Xã Văn Lang","type":"xa","slug":"xa-van-lang","name_with_type":"Xã Văn Lang","path":"Xã Văn Lang, Huyện Hưng Hà, Tỉnh Thái Bình","path_with_type":"Xã Văn Lang, Huyện Hưng Hà, Tỉnh Thái Bình","code":"12673","parent_code":"339"},"12676":{"name":"Xã Độc Lập","type":"xa","slug":"xa-doc-lap","name_with_type":"Xã Độc Lập","path":"Xã Độc Lập, Huyện Hưng Hà, Tỉnh Thái Bình","path_with_type":"Xã Độc Lập, Huyện Hưng Hà, Tỉnh Thái Bình","code":"12676","parent_code":"339"},"12679":{"name":"Xã Chí Hòa","type":"xa","slug":"xa-chi-hoa","name_with_type":"Xã Chí Hòa","path":"Xã Chí Hòa, Huyện Hưng Hà, Tỉnh Thái Bình","path_with_type":"Xã Chí Hòa, Huyện Hưng Hà, Tỉnh Thái Bình","code":"12679","parent_code":"339"},"12682":{"name":"Xã Minh Hòa","type":"xa","slug":"xa-minh-hoa","name_with_type":"Xã Minh Hòa","path":"Xã Minh Hòa, Huyện Hưng Hà, Tỉnh Thái Bình","path_with_type":"Xã Minh Hòa, Huyện Hưng Hà, Tỉnh Thái Bình","code":"12682","parent_code":"339"},"12685":{"name":"Xã Hồng Minh","type":"xa","slug":"xa-hong-minh","name_with_type":"Xã Hồng Minh","path":"Xã Hồng Minh, Huyện Hưng Hà, Tỉnh Thái Bình","path_with_type":"Xã Hồng Minh, Huyện Hưng Hà, Tỉnh Thái Bình","code":"12685","parent_code":"339"},"12688":{"name":"Thị trấn Đông Hưng","type":"thi-tran","slug":"thi-tran-dong-hung","name_with_type":"Thị trấn Đông Hưng","path":"Thị trấn Đông Hưng, Huyện Đông Hưng, Tỉnh Thái Bình","path_with_type":"Thị trấn Đông Hưng, Huyện Đông Hưng, Tỉnh Thái Bình","code":"12688","parent_code":"340"},"12694":{"name":"Xã Đông Phương","type":"xa","slug":"xa-dong-phuong","name_with_type":"Xã Đông Phương","path":"Xã Đông Phương, Huyện Đông Hưng, Tỉnh Thái Bình","path_with_type":"Xã Đông Phương, Huyện Đông Hưng, Tỉnh Thái Bình","code":"12694","parent_code":"340"},"12700":{"name":"Xã Liên An Đô","type":"xa","slug":"xa-lien-an-do","name_with_type":"Xã Liên An Đô","path":"Xã Liên An Đô, Huyện Đông Hưng, Tỉnh Thái Bình","path_with_type":"Xã Liên An Đô, Huyện Đông Hưng, Tỉnh Thái Bình","code":"12700","parent_code":"340"},"12703":{"name":"Xã Đông Sơn","type":"xa","slug":"xa-dong-son","name_with_type":"Xã Đông Sơn","path":"Xã Đông Sơn, Huyện Đông Hưng, Tỉnh Thái Bình","path_with_type":"Xã Đông Sơn, Huyện Đông Hưng, Tỉnh Thái Bình","code":"12703","parent_code":"340"},"12706":{"name":"Xã Đông Cường","type":"xa","slug":"xa-dong-cuong","name_with_type":"Xã Đông Cường","path":"Xã Đông Cường, Huyện Đông Hưng, Tỉnh Thái Bình","path_with_type":"Xã Đông Cường, Huyện Đông Hưng, Tỉnh Thái Bình","code":"12706","parent_code":"340"},"12709":{"name":"Xã Phú Lương","type":"xa","slug":"xa-phu-luong","name_with_type":"Xã Phú Lương","path":"Xã Phú Lương, Huyện Đông Hưng, Tỉnh Thái Bình","path_with_type":"Xã Phú Lương, Huyện Đông Hưng, Tỉnh Thái Bình","code":"12709","parent_code":"340"},"12712":{"name":"Xã Mê Linh","type":"xa","slug":"xa-me-linh","name_with_type":"Xã Mê Linh","path":"Xã Mê Linh, Huyện Đông Hưng, Tỉnh Thái Bình","path_with_type":"Xã Mê Linh, Huyện Đông Hưng, Tỉnh Thái Bình","code":"12712","parent_code":"340"},"12715":{"name":"Xã Lô Giang","type":"xa","slug":"xa-lo-giang","name_with_type":"Xã Lô Giang","path":"Xã Lô Giang, Huyện Đông Hưng, Tỉnh Thái Bình","path_with_type":"Xã Lô Giang, Huyện Đông Hưng, Tỉnh Thái Bình","code":"12715","parent_code":"340"},"12718":{"name":"Xã Đông La","type":"xa","slug":"xa-dong-la","name_with_type":"Xã Đông La","path":"Xã Đông La, Huyện Đông Hưng, Tỉnh Thái Bình","path_with_type":"Xã Đông La, Huyện Đông Hưng, Tỉnh Thái Bình","code":"12718","parent_code":"340"},"12721":{"name":"Xã Minh Tân","type":"xa","slug":"xa-minh-tan","name_with_type":"Xã Minh Tân","path":"Xã Minh Tân, Huyện Đông Hưng, Tỉnh Thái Bình","path_with_type":"Xã Minh Tân, Huyện Đông Hưng, Tỉnh Thái Bình","code":"12721","parent_code":"340"},"12724":{"name":"Xã Đông Xá","type":"xa","slug":"xa-dong-xa","name_with_type":"Xã Đông Xá","path":"Xã Đông Xá, Huyện Đông Hưng, Tỉnh Thái Bình","path_with_type":"Xã Đông Xá, Huyện Đông Hưng, Tỉnh Thái Bình","code":"12724","parent_code":"340"},"12730":{"name":"Xã Nguyên Xá","type":"xa","slug":"xa-nguyen-xa","name_with_type":"Xã Nguyên Xá","path":"Xã Nguyên Xá, Huyện Đông Hưng, Tỉnh Thái Bình","path_with_type":"Xã Nguyên Xá, Huyện Đông Hưng, Tỉnh Thái Bình","code":"12730","parent_code":"340"},"12736":{"name":"Xã Phong Dương Tiến","type":"xa","slug":"xa-phong-duong-tien","name_with_type":"Xã Phong Dương Tiến","path":"Xã Phong Dương Tiến, Huyện Đông Hưng, Tỉnh Thái Bình","path_with_type":"Xã Phong Dương Tiến, Huyện Đông Hưng, Tỉnh Thái Bình","code":"12736","parent_code":"340"},"12739":{"name":"Xã Hồng Việt","type":"xa","slug":"xa-hong-viet","name_with_type":"Xã Hồng Việt","path":"Xã Hồng Việt, Huyện Đông Hưng, Tỉnh Thái Bình","path_with_type":"Xã Hồng Việt, Huyện Đông Hưng, Tỉnh Thái Bình","code":"12739","parent_code":"340"},"12745":{"name":"Xã Hà Giang","type":"xa","slug":"xa-ha-giang","name_with_type":"Xã Hà Giang","path":"Xã Hà Giang, Huyện Đông Hưng, Tỉnh Thái Bình","path_with_type":"Xã Hà Giang, Huyện Đông Hưng, Tỉnh Thái Bình","code":"12745","parent_code":"340"},"12748":{"name":"Xã Đông Kinh","type":"xa","slug":"xa-dong-kinh","name_with_type":"Xã Đông Kinh","path":"Xã Đông Kinh, Huyện Đông Hưng, Tỉnh Thái Bình","path_with_type":"Xã Đông Kinh, Huyện Đông Hưng, Tỉnh Thái Bình","code":"12748","parent_code":"340"},"12751":{"name":"Xã Đông Hợp","type":"xa","slug":"xa-dong-hop","name_with_type":"Xã Đông Hợp","path":"Xã Đông Hợp, Huyện Đông Hưng, Tỉnh Thái Bình","path_with_type":"Xã Đông Hợp, Huyện Đông Hưng, Tỉnh Thái Bình","code":"12751","parent_code":"340"},"12754":{"name":"Xã Thăng Long","type":"xa","slug":"xa-thang-long","name_with_type":"Xã Thăng Long","path":"Xã Thăng Long, Huyện Đông Hưng, Tỉnh Thái Bình","path_with_type":"Xã Thăng Long, Huyện Đông Hưng, Tỉnh Thái Bình","code":"12754","parent_code":"340"},"12757":{"name":"Xã Đông Các","type":"xa","slug":"xa-dong-cac","name_with_type":"Xã Đông Các","path":"Xã Đông Các, Huyện Đông Hưng, Tỉnh Thái Bình","path_with_type":"Xã Đông Các, Huyện Đông Hưng, Tỉnh Thái Bình","code":"12757","parent_code":"340"},"12760":{"name":"Xã Phú Châu","type":"xa","slug":"xa-phu-chau","name_with_type":"Xã Phú Châu","path":"Xã Phú Châu, Huyện Đông Hưng, Tỉnh Thái Bình","path_with_type":"Xã Phú Châu, Huyện Đông Hưng, Tỉnh Thái Bình","code":"12760","parent_code":"340"},"12763":{"name":"Xã Liên Hoa","type":"xa","slug":"xa-lien-hoa","name_with_type":"Xã Liên Hoa","path":"Xã Liên Hoa, Huyện Đông Hưng, Tỉnh Thái Bình","path_with_type":"Xã Liên Hoa, Huyện Đông Hưng, Tỉnh Thái Bình","code":"12763","parent_code":"340"},"12769":{"name":"Xã Đông Tân","type":"xa","slug":"xa-dong-tan","name_with_type":"Xã Đông Tân","path":"Xã Đông Tân, Huyện Đông Hưng, Tỉnh Thái Bình","path_with_type":"Xã Đông Tân, Huyện Đông Hưng, Tỉnh Thái Bình","code":"12769","parent_code":"340"},"12772":{"name":"Xã Đông Vinh","type":"xa","slug":"xa-dong-vinh","name_with_type":"Xã Đông Vinh","path":"Xã Đông Vinh, Huyện Đông Hưng, Tỉnh Thái Bình","path_with_type":"Xã Đông Vinh, Huyện Đông Hưng, Tỉnh Thái Bình","code":"12772","parent_code":"340"},"12775":{"name":"Xã Xuân Quang Động","type":"xa","slug":"xa-xuan-quang-dong","name_with_type":"Xã Xuân Quang Động","path":"Xã Xuân Quang Động, Huyện Đông Hưng, Tỉnh Thái Bình","path_with_type":"Xã Xuân Quang Động, Huyện Đông Hưng, Tỉnh Thái Bình","code":"12775","parent_code":"340"},"12778":{"name":"Xã Hồng Bạch","type":"xa","slug":"xa-hong-bach","name_with_type":"Xã Hồng Bạch","path":"Xã Hồng Bạch, Huyện Đông Hưng, Tỉnh Thái Bình","path_with_type":"Xã Hồng Bạch, Huyện Đông Hưng, Tỉnh Thái Bình","code":"12778","parent_code":"340"},"12784":{"name":"Xã Trọng Quan","type":"xa","slug":"xa-trong-quan","name_with_type":"Xã Trọng Quan","path":"Xã Trọng Quan, Huyện Đông Hưng, Tỉnh Thái Bình","path_with_type":"Xã Trọng Quan, Huyện Đông Hưng, Tỉnh Thái Bình","code":"12784","parent_code":"340"},"12790":{"name":"Xã Hồng Giang","type":"xa","slug":"xa-hong-giang","name_with_type":"Xã Hồng Giang","path":"Xã Hồng Giang, Huyện Đông Hưng, Tỉnh Thái Bình","path_with_type":"Xã Hồng Giang, Huyện Đông Hưng, Tỉnh Thái Bình","code":"12790","parent_code":"340"},"12793":{"name":"Xã Đông Quan","type":"xa","slug":"xa-dong-quan","name_with_type":"Xã Đông Quan","path":"Xã Đông Quan, Huyện Đông Hưng, Tỉnh Thái Bình","path_with_type":"Xã Đông Quan, Huyện Đông Hưng, Tỉnh Thái Bình","code":"12793","parent_code":"340"},"12802":{"name":"Xã Đông Á","type":"xa","slug":"xa-dong-a","name_with_type":"Xã Đông Á","path":"Xã Đông Á, Huyện Đông Hưng, Tỉnh Thái Bình","path_with_type":"Xã Đông Á, Huyện Đông Hưng, Tỉnh Thái Bình","code":"12802","parent_code":"340"},"12808":{"name":"Xã Đông Hoàng","type":"xa","slug":"xa-dong-hoang","name_with_type":"Xã Đông Hoàng","path":"Xã Đông Hoàng, Huyện Đông Hưng, Tỉnh Thái Bình","path_with_type":"Xã Đông Hoàng, Huyện Đông Hưng, Tỉnh Thái Bình","code":"12808","parent_code":"340"},"12811":{"name":"Xã Đông Dương","type":"xa","slug":"xa-dong-duong","name_with_type":"Xã Đông Dương","path":"Xã Đông Dương, Huyện Đông Hưng, Tỉnh Thái Bình","path_with_type":"Xã Đông Dương, Huyện Đông Hưng, Tỉnh Thái Bình","code":"12811","parent_code":"340"},"12817":{"name":"Xã Đông Mỹ","type":"xa","slug":"xa-dong-my","name_with_type":"Xã Đông Mỹ","path":"Xã Đông Mỹ, Thành phố Thái Bình, Tỉnh Thái Bình","path_with_type":"Xã Đông Mỹ, Thành phố Thái Bình, Tỉnh Thái Bình","code":"12817","parent_code":"336"},"12820":{"name":"Xã Đông Thọ","type":"xa","slug":"xa-dong-tho","name_with_type":"Xã Đông Thọ","path":"Xã Đông Thọ, Thành phố Thái Bình, Tỉnh Thái Bình","path_with_type":"Xã Đông Thọ, Thành phố Thái Bình, Tỉnh Thái Bình","code":"12820","parent_code":"336"},"12823":{"name":"Xã Minh Phú","type":"xa","slug":"xa-minh-phu","name_with_type":"Xã Minh Phú","path":"Xã Minh Phú, Huyện Đông Hưng, Tỉnh Thái Bình","path_with_type":"Xã Minh Phú, Huyện Đông Hưng, Tỉnh Thái Bình","code":"12823","parent_code":"340"},"12826":{"name":"Thị trấn Diêm Điền","type":"thi-tran","slug":"thi-tran-diem-dien","name_with_type":"Thị trấn Diêm Điền","path":"Thị trấn Diêm Điền, Huyện Thái Thụy, Tỉnh Thái Bình","path_with_type":"Thị trấn Diêm Điền, Huyện Thái Thụy, Tỉnh Thái Bình","code":"12826","parent_code":"341"},"12832":{"name":"Xã Thụy Trường","type":"xa","slug":"xa-thuy-truong","name_with_type":"Xã Thụy Trường","path":"Xã Thụy Trường, Huyện Thái Thụy, Tỉnh Thái Bình","path_with_type":"Xã Thụy Trường, Huyện Thái Thụy, Tỉnh Thái Bình","code":"12832","parent_code":"341"},"12841":{"name":"Xã Hồng Dũng","type":"xa","slug":"xa-hong-dung","name_with_type":"Xã Hồng Dũng","path":"Xã Hồng Dũng, Huyện Thái Thụy, Tỉnh Thái Bình","path_with_type":"Xã Hồng Dũng, Huyện Thái Thụy, Tỉnh Thái Bình","code":"12841","parent_code":"341"},"12844":{"name":"Xã Thụy Quỳnh","type":"xa","slug":"xa-thuy-quynh","name_with_type":"Xã Thụy Quỳnh","path":"Xã Thụy Quỳnh, Huyện Thái Thụy, Tỉnh Thái Bình","path_with_type":"Xã Thụy Quỳnh, Huyện Thái Thụy, Tỉnh Thái Bình","code":"12844","parent_code":"341"},"12847":{"name":"Xã An Tân","type":"xa","slug":"xa-an-tan","name_with_type":"Xã An Tân","path":"Xã An Tân, Huyện Thái Thụy, Tỉnh Thái Bình","path_with_type":"Xã An Tân, Huyện Thái Thụy, Tỉnh Thái Bình","code":"12847","parent_code":"341"},"12850":{"name":"Xã Thụy Ninh","type":"xa","slug":"xa-thuy-ninh","name_with_type":"Xã Thụy Ninh","path":"Xã Thụy Ninh, Huyện Thái Thụy, Tỉnh Thái Bình","path_with_type":"Xã Thụy Ninh, Huyện Thái Thụy, Tỉnh Thái Bình","code":"12850","parent_code":"341"},"12853":{"name":"Xã Thụy Hưng","type":"xa","slug":"xa-thuy-hung","name_with_type":"Xã Thụy Hưng","path":"Xã Thụy Hưng, Huyện Thái Thụy, Tỉnh Thái Bình","path_with_type":"Xã Thụy Hưng, Huyện Thái Thụy, Tỉnh Thái Bình","code":"12853","parent_code":"341"},"12856":{"name":"Xã Thụy Việt","type":"xa","slug":"xa-thuy-viet","name_with_type":"Xã Thụy Việt","path":"Xã Thụy Việt, Huyện Thái Thụy, Tỉnh Thái Bình","path_with_type":"Xã Thụy Việt, Huyện Thái Thụy, Tỉnh Thái Bình","code":"12856","parent_code":"341"},"12859":{"name":"Xã Thụy Văn","type":"xa","slug":"xa-thuy-van","name_with_type":"Xã Thụy Văn","path":"Xã Thụy Văn, Huyện Thái Thụy, Tỉnh Thái Bình","path_with_type":"Xã Thụy Văn, Huyện Thái Thụy, Tỉnh Thái Bình","code":"12859","parent_code":"341"},"12862":{"name":"Xã Thụy Xuân","type":"xa","slug":"xa-thuy-xuan","name_with_type":"Xã Thụy Xuân","path":"Xã Thụy Xuân, Huyện Thái Thụy, Tỉnh Thái Bình","path_with_type":"Xã Thụy Xuân, Huyện Thái Thụy, Tỉnh Thái Bình","code":"12862","parent_code":"341"},"12865":{"name":"Xã Dương Phúc","type":"xa","slug":"xa-duong-phuc","name_with_type":"Xã Dương Phúc","path":"Xã Dương Phúc, Huyện Thái Thụy, Tỉnh Thái Bình","path_with_type":"Xã Dương Phúc, Huyện Thái Thụy, Tỉnh Thái Bình","code":"12865","parent_code":"341"},"12868":{"name":"Xã Thụy Trình","type":"xa","slug":"xa-thuy-trinh","name_with_type":"Xã Thụy Trình","path":"Xã Thụy Trình, Huyện Thái Thụy, Tỉnh Thái Bình","path_with_type":"Xã Thụy Trình, Huyện Thái Thụy, Tỉnh Thái Bình","code":"12868","parent_code":"341"},"12871":{"name":"Xã Thụy Bình","type":"xa","slug":"xa-thuy-binh","name_with_type":"Xã Thụy Bình","path":"Xã Thụy Bình, Huyện Thái Thụy, Tỉnh Thái Bình","path_with_type":"Xã Thụy Bình, Huyện Thái Thụy, Tỉnh Thái Bình","code":"12871","parent_code":"341"},"12874":{"name":"Xã Thụy Chính","type":"xa","slug":"xa-thuy-chinh","name_with_type":"Xã Thụy Chính","path":"Xã Thụy Chính, Huyện Thái Thụy, Tỉnh Thái Bình","path_with_type":"Xã Thụy Chính, Huyện Thái Thụy, Tỉnh Thái Bình","code":"12874","parent_code":"341"},"12877":{"name":"Xã Thụy Dân","type":"xa","slug":"xa-thuy-dan","name_with_type":"Xã Thụy Dân","path":"Xã Thụy Dân, Huyện Thái Thụy, Tỉnh Thái Bình","path_with_type":"Xã Thụy Dân, Huyện Thái Thụy, Tỉnh Thái Bình","code":"12877","parent_code":"341"},"12880":{"name":"Xã Thụy Hải","type":"xa","slug":"xa-thuy-hai","name_with_type":"Xã Thụy Hải","path":"Xã Thụy Hải, Huyện Thái Thụy, Tỉnh Thái Bình","path_with_type":"Xã Thụy Hải, Huyện Thái Thụy, Tỉnh Thái Bình","code":"12880","parent_code":"341"},"12889":{"name":"Xã Thụy Liên","type":"xa","slug":"xa-thuy-lien","name_with_type":"Xã Thụy Liên","path":"Xã Thụy Liên, Huyện Thái Thụy, Tỉnh Thái Bình","path_with_type":"Xã Thụy Liên, Huyện Thái Thụy, Tỉnh Thái Bình","code":"12889","parent_code":"341"},"12892":{"name":"Xã Thụy Duyên","type":"xa","slug":"xa-thuy-duyen","name_with_type":"Xã Thụy Duyên","path":"Xã Thụy Duyên, Huyện Thái Thụy, Tỉnh Thái Bình","path_with_type":"Xã Thụy Duyên, Huyện Thái Thụy, Tỉnh Thái Bình","code":"12892","parent_code":"341"},"12898":{"name":"Xã Thụy Thanh","type":"xa","slug":"xa-thuy-thanh","name_with_type":"Xã Thụy Thanh","path":"Xã Thụy Thanh, Huyện Thái Thụy, Tỉnh Thái Bình","path_with_type":"Xã Thụy Thanh, Huyện Thái Thụy, Tỉnh Thái Bình","code":"12898","parent_code":"341"},"12901":{"name":"Xã Thụy Sơn","type":"xa","slug":"xa-thuy-son","name_with_type":"Xã Thụy Sơn","path":"Xã Thụy Sơn, Huyện Thái Thụy, Tỉnh Thái Bình","path_with_type":"Xã Thụy Sơn, Huyện Thái Thụy, Tỉnh Thái Bình","code":"12901","parent_code":"341"},"12904":{"name":"Xã Thụy Phong","type":"xa","slug":"xa-thuy-phong","name_with_type":"Xã Thụy Phong","path":"Xã Thụy Phong, Huyện Thái Thụy, Tỉnh Thái Bình","path_with_type":"Xã Thụy Phong, Huyện Thái Thụy, Tỉnh Thái Bình","code":"12904","parent_code":"341"},"12907":{"name":"Xã Thái Thượng","type":"xa","slug":"xa-thai-thuong","name_with_type":"Xã Thái Thượng","path":"Xã Thái Thượng, Huyện Thái Thụy, Tỉnh Thái Bình","path_with_type":"Xã Thái Thượng, Huyện Thái Thụy, Tỉnh Thái Bình","code":"12907","parent_code":"341"},"12910":{"name":"Xã Thái Nguyên","type":"xa","slug":"xa-thai-nguyen","name_with_type":"Xã Thái Nguyên","path":"Xã Thái Nguyên, Huyện Thái Thụy, Tỉnh Thái Bình","path_with_type":"Xã Thái Nguyên, Huyện Thái Thụy, Tỉnh Thái Bình","code":"12910","parent_code":"341"},"12916":{"name":"Xã Dương Hồng  Thủy","type":"xa","slug":"xa-duong-hong-thuy","name_with_type":"Xã Dương Hồng  Thủy","path":"Xã Dương Hồng  Thủy, Huyện Thái Thụy, Tỉnh Thái Bình","path_with_type":"Xã Dương Hồng  Thủy, Huyện Thái Thụy, Tỉnh Thái Bình","code":"12916","parent_code":"341"},"12919":{"name":"Xã Thái Giang","type":"xa","slug":"xa-thai-giang","name_with_type":"Xã Thái Giang","path":"Xã Thái Giang, Huyện Thái Thụy, Tỉnh Thái Bình","path_with_type":"Xã Thái Giang, Huyện Thái Thụy, Tỉnh Thái Bình","code":"12919","parent_code":"341"},"12922":{"name":"Xã Hòa An","type":"xa","slug":"xa-hoa-an","name_with_type":"Xã Hòa An","path":"Xã Hòa An, Huyện Thái Thụy, Tỉnh Thái Bình","path_with_type":"Xã Hòa An, Huyện Thái Thụy, Tỉnh Thái Bình","code":"12922","parent_code":"341"},"12925":{"name":"Xã Sơn Hà","type":"xa","slug":"xa-son-ha","name_with_type":"Xã Sơn Hà","path":"Xã Sơn Hà, Huyện Thái Thụy, Tỉnh Thái Bình","path_with_type":"Xã Sơn Hà, Huyện Thái Thụy, Tỉnh Thái Bình","code":"12925","parent_code":"341"},"12934":{"name":"Xã Thái Phúc","type":"xa","slug":"xa-thai-phuc","name_with_type":"Xã Thái Phúc","path":"Xã Thái Phúc, Huyện Thái Thụy, Tỉnh Thái Bình","path_with_type":"Xã Thái Phúc, Huyện Thái Thụy, Tỉnh Thái Bình","code":"12934","parent_code":"341"},"12937":{"name":"Xã Thái Hưng","type":"xa","slug":"xa-thai-hung","name_with_type":"Xã Thái Hưng","path":"Xã Thái Hưng, Huyện Thái Thụy, Tỉnh Thái Bình","path_with_type":"Xã Thái Hưng, Huyện Thái Thụy, Tỉnh Thái Bình","code":"12937","parent_code":"341"},"12940":{"name":"Xã Thái Đô","type":"xa","slug":"xa-thai-do","name_with_type":"Xã Thái Đô","path":"Xã Thái Đô, Huyện Thái Thụy, Tỉnh Thái Bình","path_with_type":"Xã Thái Đô, Huyện Thái Thụy, Tỉnh Thái Bình","code":"12940","parent_code":"341"},"12943":{"name":"Xã Thái Xuyên","type":"xa","slug":"xa-thai-xuyen","name_with_type":"Xã Thái Xuyên","path":"Xã Thái Xuyên, Huyện Thái Thụy, Tỉnh Thái Bình","path_with_type":"Xã Thái Xuyên, Huyện Thái Thụy, Tỉnh Thái Bình","code":"12943","parent_code":"341"},"12949":{"name":"Xã  Mỹ Lộc","type":"xa","slug":"xa-my-loc","name_with_type":"Xã  Mỹ Lộc","path":"Xã  Mỹ Lộc, Huyện Thái Thụy, Tỉnh Thái Bình","path_with_type":"Xã  Mỹ Lộc, Huyện Thái Thụy, Tỉnh Thái Bình","code":"12949","parent_code":"341"},"12958":{"name":"Xã Tân Học","type":"xa","slug":"xa-tan-hoc","name_with_type":"Xã Tân Học","path":"Xã Tân Học, Huyện Thái Thụy, Tỉnh Thái Bình","path_with_type":"Xã Tân Học, Huyện Thái Thụy, Tỉnh Thái Bình","code":"12958","parent_code":"341"},"12961":{"name":"Xã Thái Thịnh","type":"xa","slug":"xa-thai-thinh","name_with_type":"Xã Thái Thịnh","path":"Xã Thái Thịnh, Huyện Thái Thụy, Tỉnh Thái Bình","path_with_type":"Xã Thái Thịnh, Huyện Thái Thụy, Tỉnh Thái Bình","code":"12961","parent_code":"341"},"12964":{"name":"Xã Thuần Thành","type":"xa","slug":"xa-thuan-thanh","name_with_type":"Xã Thuần Thành","path":"Xã Thuần Thành, Huyện Thái Thụy, Tỉnh Thái Bình","path_with_type":"Xã Thuần Thành, Huyện Thái Thụy, Tỉnh Thái Bình","code":"12964","parent_code":"341"},"12967":{"name":"Xã Thái Thọ","type":"xa","slug":"xa-thai-tho","name_with_type":"Xã Thái Thọ","path":"Xã Thái Thọ, Huyện Thái Thụy, Tỉnh Thái Bình","path_with_type":"Xã Thái Thọ, Huyện Thái Thụy, Tỉnh Thái Bình","code":"12967","parent_code":"341"},"12970":{"name":"Thị trấn Tiền Hải","type":"thi-tran","slug":"thi-tran-tien-hai","name_with_type":"Thị trấn Tiền Hải","path":"Thị trấn Tiền Hải, Huyện Tiền Hải, Tỉnh Thái Bình","path_with_type":"Thị trấn Tiền Hải, Huyện Tiền Hải, Tỉnh Thái Bình","code":"12970","parent_code":"342"},"12976":{"name":"Xã Đông Trà","type":"xa","slug":"xa-dong-tra","name_with_type":"Xã Đông Trà","path":"Xã Đông Trà, Huyện Tiền Hải, Tỉnh Thái Bình","path_with_type":"Xã Đông Trà, Huyện Tiền Hải, Tỉnh Thái Bình","code":"12976","parent_code":"342"},"12979":{"name":"Xã Đông Long","type":"xa","slug":"xa-dong-long","name_with_type":"Xã Đông Long","path":"Xã Đông Long, Huyện Tiền Hải, Tỉnh Thái Bình","path_with_type":"Xã Đông Long, Huyện Tiền Hải, Tỉnh Thái Bình","code":"12979","parent_code":"342"},"12985":{"name":"Xã Vũ Lăng","type":"xa","slug":"xa-vu-lang","name_with_type":"Xã Vũ Lăng","path":"Xã Vũ Lăng, Huyện Tiền Hải, Tỉnh Thái Bình","path_with_type":"Xã Vũ Lăng, Huyện Tiền Hải, Tỉnh Thái Bình","code":"12985","parent_code":"342"},"12988":{"name":"Xã Đông Xuyên","type":"xa","slug":"xa-dong-xuyen","name_with_type":"Xã Đông Xuyên","path":"Xã Đông Xuyên, Huyện Tiền Hải, Tỉnh Thái Bình","path_with_type":"Xã Đông Xuyên, Huyện Tiền Hải, Tỉnh Thái Bình","code":"12988","parent_code":"342"},"12991":{"name":"Xã Tây Lương","type":"xa","slug":"xa-tay-luong","name_with_type":"Xã Tây Lương","path":"Xã Tây Lương, Huyện Tiền Hải, Tỉnh Thái Bình","path_with_type":"Xã Tây Lương, Huyện Tiền Hải, Tỉnh Thái Bình","code":"12991","parent_code":"342"},"12994":{"name":"Xã Tây Ninh","type":"xa","slug":"xa-tay-ninh","name_with_type":"Xã Tây Ninh","path":"Xã Tây Ninh, Huyện Tiền Hải, Tỉnh Thái Bình","path_with_type":"Xã Tây Ninh, Huyện Tiền Hải, Tỉnh Thái Bình","code":"12994","parent_code":"342"},"12997":{"name":"Xã Đông Quang","type":"xa","slug":"xa-dong-quang","name_with_type":"Xã Đông Quang","path":"Xã Đông Quang, Huyện Tiền Hải, Tỉnh Thái Bình","path_with_type":"Xã Đông Quang, Huyện Tiền Hải, Tỉnh Thái Bình","code":"12997","parent_code":"342"},"13000":{"name":"Xã Đông Hoàng","type":"xa","slug":"xa-dong-hoang","name_with_type":"Xã Đông Hoàng","path":"Xã Đông Hoàng, Huyện Tiền Hải, Tỉnh Thái Bình","path_with_type":"Xã Đông Hoàng, Huyện Tiền Hải, Tỉnh Thái Bình","code":"13000","parent_code":"342"},"13003":{"name":"Xã Đông Minh","type":"xa","slug":"xa-dong-minh","name_with_type":"Xã Đông Minh","path":"Xã Đông Minh, Huyện Tiền Hải, Tỉnh Thái Bình","path_with_type":"Xã Đông Minh, Huyện Tiền Hải, Tỉnh Thái Bình","code":"13003","parent_code":"342"},"13012":{"name":"Xã An Ninh","type":"xa","slug":"xa-an-ninh","name_with_type":"Xã An Ninh","path":"Xã An Ninh, Huyện Tiền Hải, Tỉnh Thái Bình","path_with_type":"Xã An Ninh, Huyện Tiền Hải, Tỉnh Thái Bình","code":"13012","parent_code":"342"},"13018":{"name":"Xã Đông Cơ","type":"xa","slug":"xa-dong-co","name_with_type":"Xã Đông Cơ","path":"Xã Đông Cơ, Huyện Tiền Hải, Tỉnh Thái Bình","path_with_type":"Xã Đông Cơ, Huyện Tiền Hải, Tỉnh Thái Bình","code":"13018","parent_code":"342"},"13021":{"name":"Xã Tây Giang","type":"xa","slug":"xa-tay-giang","name_with_type":"Xã Tây Giang","path":"Xã Tây Giang, Huyện Tiền Hải, Tỉnh Thái Bình","path_with_type":"Xã Tây Giang, Huyện Tiền Hải, Tỉnh Thái Bình","code":"13021","parent_code":"342"},"13024":{"name":"Xã Đông Lâm","type":"xa","slug":"xa-dong-lam","name_with_type":"Xã Đông Lâm","path":"Xã Đông Lâm, Huyện Tiền Hải, Tỉnh Thái Bình","path_with_type":"Xã Đông Lâm, Huyện Tiền Hải, Tỉnh Thái Bình","code":"13024","parent_code":"342"},"13027":{"name":"Xã Phương Công","type":"xa","slug":"xa-phuong-cong","name_with_type":"Xã Phương Công","path":"Xã Phương Công, Huyện Tiền Hải, Tỉnh Thái Bình","path_with_type":"Xã Phương Công, Huyện Tiền Hải, Tỉnh Thái Bình","code":"13027","parent_code":"342"},"13030":{"name":"Xã Ái Quốc","type":"xa","slug":"xa-ai-quoc","name_with_type":"Xã Ái Quốc","path":"Xã Ái Quốc, Huyện Tiền Hải, Tỉnh Thái Bình","path_with_type":"Xã Ái Quốc, Huyện Tiền Hải, Tỉnh Thái Bình","code":"13030","parent_code":"342"},"13036":{"name":"Xã Nam Cường","type":"xa","slug":"xa-nam-cuong","name_with_type":"Xã Nam Cường","path":"Xã Nam Cường, Huyện Tiền Hải, Tỉnh Thái Bình","path_with_type":"Xã Nam Cường, Huyện Tiền Hải, Tỉnh Thái Bình","code":"13036","parent_code":"342"},"13039":{"name":"Xã Vân Trường","type":"xa","slug":"xa-van-truong","name_with_type":"Xã Vân Trường","path":"Xã Vân Trường, Huyện Tiền Hải, Tỉnh Thái Bình","path_with_type":"Xã Vân Trường, Huyện Tiền Hải, Tỉnh Thái Bình","code":"13039","parent_code":"342"},"13045":{"name":"Xã Nam Chính","type":"xa","slug":"xa-nam-chinh","name_with_type":"Xã Nam Chính","path":"Xã Nam Chính, Huyện Tiền Hải, Tỉnh Thái Bình","path_with_type":"Xã Nam Chính, Huyện Tiền Hải, Tỉnh Thái Bình","code":"13045","parent_code":"342"},"13048":{"name":"Xã Bắc Hải","type":"xa","slug":"xa-bac-hai","name_with_type":"Xã Bắc Hải","path":"Xã Bắc Hải, Huyện Tiền Hải, Tỉnh Thái Bình","path_with_type":"Xã Bắc Hải, Huyện Tiền Hải, Tỉnh Thái Bình","code":"13048","parent_code":"342"},"13051":{"name":"Xã Nam Thịnh","type":"xa","slug":"xa-nam-thinh","name_with_type":"Xã Nam Thịnh","path":"Xã Nam Thịnh, Huyện Tiền Hải, Tỉnh Thái Bình","path_with_type":"Xã Nam Thịnh, Huyện Tiền Hải, Tỉnh Thái Bình","code":"13051","parent_code":"342"},"13054":{"name":"Xã Nam Hà","type":"xa","slug":"xa-nam-ha","name_with_type":"Xã Nam Hà","path":"Xã Nam Hà, Huyện Tiền Hải, Tỉnh Thái Bình","path_with_type":"Xã Nam Hà, Huyện Tiền Hải, Tỉnh Thái Bình","code":"13054","parent_code":"342"},"13057":{"name":"Xã Nam Tiến","type":"xa","slug":"xa-nam-tien","name_with_type":"Xã Nam Tiến","path":"Xã Nam Tiến, Huyện Tiền Hải, Tỉnh Thái Bình","path_with_type":"Xã Nam Tiến, Huyện Tiền Hải, Tỉnh Thái Bình","code":"13057","parent_code":"342"},"13060":{"name":"Xã Nam Trung","type":"xa","slug":"xa-nam-trung","name_with_type":"Xã Nam Trung","path":"Xã Nam Trung, Huyện Tiền Hải, Tỉnh Thái Bình","path_with_type":"Xã Nam Trung, Huyện Tiền Hải, Tỉnh Thái Bình","code":"13060","parent_code":"342"},"13063":{"name":"Xã Nam Hồng","type":"xa","slug":"xa-nam-hong","name_with_type":"Xã Nam Hồng","path":"Xã Nam Hồng, Huyện Tiền Hải, Tỉnh Thái Bình","path_with_type":"Xã Nam Hồng, Huyện Tiền Hải, Tỉnh Thái Bình","code":"13063","parent_code":"342"},"13066":{"name":"Xã Nam Hưng","type":"xa","slug":"xa-nam-hung","name_with_type":"Xã Nam Hưng","path":"Xã Nam Hưng, Huyện Tiền Hải, Tỉnh Thái Bình","path_with_type":"Xã Nam Hưng, Huyện Tiền Hải, Tỉnh Thái Bình","code":"13066","parent_code":"342"},"13069":{"name":"Xã Nam Hải","type":"xa","slug":"xa-nam-hai","name_with_type":"Xã Nam Hải","path":"Xã Nam Hải, Huyện Tiền Hải, Tỉnh Thái Bình","path_with_type":"Xã Nam Hải, Huyện Tiền Hải, Tỉnh Thái Bình","code":"13069","parent_code":"342"},"13072":{"name":"Xã Nam Phú","type":"xa","slug":"xa-nam-phu","name_with_type":"Xã Nam Phú","path":"Xã Nam Phú, Huyện Tiền Hải, Tỉnh Thái Bình","path_with_type":"Xã Nam Phú, Huyện Tiền Hải, Tỉnh Thái Bình","code":"13072","parent_code":"342"},"13075":{"name":"Thị trấn Kiến Xương","type":"thi-tran","slug":"thi-tran-kien-xuong","name_with_type":"Thị trấn Kiến Xương","path":"Thị trấn Kiến Xương, Huyện Kiến Xương, Tỉnh Thái Bình","path_with_type":"Thị trấn Kiến Xương, Huyện Kiến Xương, Tỉnh Thái Bình","code":"13075","parent_code":"343"},"13078":{"name":"Xã Trà Giang","type":"xa","slug":"xa-tra-giang","name_with_type":"Xã Trà Giang","path":"Xã Trà Giang, Huyện Kiến Xương, Tỉnh Thái Bình","path_with_type":"Xã Trà Giang, Huyện Kiến Xương, Tỉnh Thái Bình","code":"13078","parent_code":"343"},"13081":{"name":"Xã Quốc Tuấn","type":"xa","slug":"xa-quoc-tuan","name_with_type":"Xã Quốc Tuấn","path":"Xã Quốc Tuấn, Huyện Kiến Xương, Tỉnh Thái Bình","path_with_type":"Xã Quốc Tuấn, Huyện Kiến Xương, Tỉnh Thái Bình","code":"13081","parent_code":"343"},"13084":{"name":"Xã Vũ Đông","type":"xa","slug":"xa-vu-dong","name_with_type":"Xã Vũ Đông","path":"Xã Vũ Đông, Thành phố Thái Bình, Tỉnh Thái Bình","path_with_type":"Xã Vũ Đông, Thành phố Thái Bình, Tỉnh Thái Bình","code":"13084","parent_code":"336"},"13087":{"name":"Xã An Bình","type":"xa","slug":"xa-an-binh","name_with_type":"Xã An Bình","path":"Xã An Bình, Huyện Kiến Xương, Tỉnh Thái Bình","path_with_type":"Xã An Bình, Huyện Kiến Xương, Tỉnh Thái Bình","code":"13087","parent_code":"343"},"13090":{"name":"Xã Tây Sơn","type":"xa","slug":"xa-tay-son","name_with_type":"Xã Tây Sơn","path":"Xã Tây Sơn, Huyện Kiến Xương, Tỉnh Thái Bình","path_with_type":"Xã Tây Sơn, Huyện Kiến Xương, Tỉnh Thái Bình","code":"13090","parent_code":"343"},"13093":{"name":"Xã Hồng Thái","type":"xa","slug":"xa-hong-thai","name_with_type":"Xã Hồng Thái","path":"Xã Hồng Thái, Huyện Kiến Xương, Tỉnh Thái Bình","path_with_type":"Xã Hồng Thái, Huyện Kiến Xương, Tỉnh Thái Bình","code":"13093","parent_code":"343"},"13096":{"name":"Xã Bình Nguyên","type":"xa","slug":"xa-binh-nguyen","name_with_type":"Xã Bình Nguyên","path":"Xã Bình Nguyên, Huyện Kiến Xương, Tỉnh Thái Bình","path_with_type":"Xã Bình Nguyên, Huyện Kiến Xương, Tỉnh Thái Bình","code":"13096","parent_code":"343"},"13102":{"name":"Xã Lê Lợi","type":"xa","slug":"xa-le-loi","name_with_type":"Xã Lê Lợi","path":"Xã Lê Lợi, Huyện Kiến Xương, Tỉnh Thái Bình","path_with_type":"Xã Lê Lợi, Huyện Kiến Xương, Tỉnh Thái Bình","code":"13102","parent_code":"343"},"13108":{"name":"Xã Vũ Lạc","type":"xa","slug":"xa-vu-lac","name_with_type":"Xã Vũ Lạc","path":"Xã Vũ Lạc, Thành phố Thái Bình, Tỉnh Thái Bình","path_with_type":"Xã Vũ Lạc, Thành phố Thái Bình, Tỉnh Thái Bình","code":"13108","parent_code":"336"},"13111":{"name":"Xã Vũ Lễ","type":"xa","slug":"xa-vu-le","name_with_type":"Xã Vũ Lễ","path":"Xã Vũ Lễ, Huyện Kiến Xương, Tỉnh Thái Bình","path_with_type":"Xã Vũ Lễ, Huyện Kiến Xương, Tỉnh Thái Bình","code":"13111","parent_code":"343"},"13114":{"name":"Xã Thanh Tân","type":"xa","slug":"xa-thanh-tan","name_with_type":"Xã Thanh Tân","path":"Xã Thanh Tân, Huyện Kiến Xương, Tỉnh Thái Bình","path_with_type":"Xã Thanh Tân, Huyện Kiến Xương, Tỉnh Thái Bình","code":"13114","parent_code":"343"},"13120":{"name":"Xã Thống Nhất","type":"xa","slug":"xa-thong-nhat","name_with_type":"Xã Thống Nhất","path":"Xã Thống Nhất, Huyện Kiến Xương, Tỉnh Thái Bình","path_with_type":"Xã Thống Nhất, Huyện Kiến Xương, Tỉnh Thái Bình","code":"13120","parent_code":"343"},"13126":{"name":"Xã Vũ Ninh","type":"xa","slug":"xa-vu-ninh","name_with_type":"Xã Vũ Ninh","path":"Xã Vũ Ninh, Huyện Kiến Xương, Tỉnh Thái Bình","path_with_type":"Xã Vũ Ninh, Huyện Kiến Xương, Tỉnh Thái Bình","code":"13126","parent_code":"343"},"13129":{"name":"Xã Vũ An","type":"xa","slug":"xa-vu-an","name_with_type":"Xã Vũ An","path":"Xã Vũ An, Huyện Kiến Xương, Tỉnh Thái Bình","path_with_type":"Xã Vũ An, Huyện Kiến Xương, Tỉnh Thái Bình","code":"13129","parent_code":"343"},"13132":{"name":"Xã Quang Lịch","type":"xa","slug":"xa-quang-lich","name_with_type":"Xã Quang Lịch","path":"Xã Quang Lịch, Huyện Kiến Xương, Tỉnh Thái Bình","path_with_type":"Xã Quang Lịch, Huyện Kiến Xương, Tỉnh Thái Bình","code":"13132","parent_code":"343"},"13135":{"name":"Xã Hòa Bình","type":"xa","slug":"xa-hoa-binh","name_with_type":"Xã Hòa Bình","path":"Xã Hòa Bình, Huyện Kiến Xương, Tỉnh Thái Bình","path_with_type":"Xã Hòa Bình, Huyện Kiến Xương, Tỉnh Thái Bình","code":"13135","parent_code":"343"},"13138":{"name":"Xã Bình Minh","type":"xa","slug":"xa-binh-minh","name_with_type":"Xã Bình Minh","path":"Xã Bình Minh, Huyện Kiến Xương, Tỉnh Thái Bình","path_with_type":"Xã Bình Minh, Huyện Kiến Xương, Tỉnh Thái Bình","code":"13138","parent_code":"343"},"13141":{"name":"Xã Vũ Quí","type":"xa","slug":"xa-vu-qui","name_with_type":"Xã Vũ Quí","path":"Xã Vũ Quí, Huyện Kiến Xương, Tỉnh Thái Bình","path_with_type":"Xã Vũ Quí, Huyện Kiến Xương, Tỉnh Thái Bình","code":"13141","parent_code":"343"},"13144":{"name":"Xã Quang Bình","type":"xa","slug":"xa-quang-binh","name_with_type":"Xã Quang Bình","path":"Xã Quang Bình, Huyện Kiến Xương, Tỉnh Thái Bình","path_with_type":"Xã Quang Bình, Huyện Kiến Xương, Tỉnh Thái Bình","code":"13144","parent_code":"343"},"13150":{"name":"Xã Vũ Trung","type":"xa","slug":"xa-vu-trung","name_with_type":"Xã Vũ Trung","path":"Xã Vũ Trung, Huyện Kiến Xương, Tỉnh Thái Bình","path_with_type":"Xã Vũ Trung, Huyện Kiến Xương, Tỉnh Thái Bình","code":"13150","parent_code":"343"},"13156":{"name":"Xã Vũ Công","type":"xa","slug":"xa-vu-cong","name_with_type":"Xã Vũ Công","path":"Xã Vũ Công, Huyện Kiến Xương, Tỉnh Thái Bình","path_with_type":"Xã Vũ Công, Huyện Kiến Xương, Tỉnh Thái Bình","code":"13156","parent_code":"343"},"13159":{"name":"Xã Hồng Vũ","type":"xa","slug":"xa-hong-vu","name_with_type":"Xã Hồng Vũ","path":"Xã Hồng Vũ, Huyện Kiến Xương, Tỉnh Thái Bình","path_with_type":"Xã Hồng Vũ, Huyện Kiến Xương, Tỉnh Thái Bình","code":"13159","parent_code":"343"},"13162":{"name":"Xã Quang Minh","type":"xa","slug":"xa-quang-minh","name_with_type":"Xã Quang Minh","path":"Xã Quang Minh, Huyện Kiến Xương, Tỉnh Thái Bình","path_with_type":"Xã Quang Minh, Huyện Kiến Xương, Tỉnh Thái Bình","code":"13162","parent_code":"343"},"13165":{"name":"Xã Quang Trung","type":"xa","slug":"xa-quang-trung","name_with_type":"Xã Quang Trung","path":"Xã Quang Trung, Huyện Kiến Xương, Tỉnh Thái Bình","path_with_type":"Xã Quang Trung, Huyện Kiến Xương, Tỉnh Thái Bình","code":"13165","parent_code":"343"},"13171":{"name":"Xã Minh Quang","type":"xa","slug":"xa-minh-quang","name_with_type":"Xã Minh Quang","path":"Xã Minh Quang, Huyện Kiến Xương, Tỉnh Thái Bình","path_with_type":"Xã Minh Quang, Huyện Kiến Xương, Tỉnh Thái Bình","code":"13171","parent_code":"343"},"13177":{"name":"Xã Minh Tân","type":"xa","slug":"xa-minh-tan","name_with_type":"Xã Minh Tân","path":"Xã Minh Tân, Huyện Kiến Xương, Tỉnh Thái Bình","path_with_type":"Xã Minh Tân, Huyện Kiến Xương, Tỉnh Thái Bình","code":"13177","parent_code":"343"},"13180":{"name":"Xã Nam Bình","type":"xa","slug":"xa-nam-binh","name_with_type":"Xã Nam Bình","path":"Xã Nam Bình, Huyện Kiến Xương, Tỉnh Thái Bình","path_with_type":"Xã Nam Bình, Huyện Kiến Xương, Tỉnh Thái Bình","code":"13180","parent_code":"343"},"13183":{"name":"Xã Bình Thanh","type":"xa","slug":"xa-binh-thanh","name_with_type":"Xã Bình Thanh","path":"Xã Bình Thanh, Huyện Kiến Xương, Tỉnh Thái Bình","path_with_type":"Xã Bình Thanh, Huyện Kiến Xương, Tỉnh Thái Bình","code":"13183","parent_code":"343"},"13186":{"name":"Xã Bình Định","type":"xa","slug":"xa-binh-dinh","name_with_type":"Xã Bình Định","path":"Xã Bình Định, Huyện Kiến Xương, Tỉnh Thái Bình","path_with_type":"Xã Bình Định, Huyện Kiến Xương, Tỉnh Thái Bình","code":"13186","parent_code":"343"},"13189":{"name":"Xã Hồng Tiến","type":"xa","slug":"xa-hong-tien","name_with_type":"Xã Hồng Tiến","path":"Xã Hồng Tiến, Huyện Kiến Xương, Tỉnh Thái Bình","path_with_type":"Xã Hồng Tiến, Huyện Kiến Xương, Tỉnh Thái Bình","code":"13189","parent_code":"343"},"13192":{"name":"Thị trấn Vũ Thư","type":"thi-tran","slug":"thi-tran-vu-thu","name_with_type":"Thị trấn Vũ Thư","path":"Thị trấn Vũ Thư, Huyện Vũ Thư, Tỉnh Thái Bình","path_with_type":"Thị trấn Vũ Thư, Huyện Vũ Thư, Tỉnh Thái Bình","code":"13192","parent_code":"344"},"13195":{"name":"Xã Hồng Lý","type":"xa","slug":"xa-hong-ly","name_with_type":"Xã Hồng Lý","path":"Xã Hồng Lý, Huyện Vũ Thư, Tỉnh Thái Bình","path_with_type":"Xã Hồng Lý, Huyện Vũ Thư, Tỉnh Thái Bình","code":"13195","parent_code":"344"},"13198":{"name":"Xã Đồng Thanh","type":"xa","slug":"xa-dong-thanh","name_with_type":"Xã Đồng Thanh","path":"Xã Đồng Thanh, Huyện Vũ Thư, Tỉnh Thái Bình","path_with_type":"Xã Đồng Thanh, Huyện Vũ Thư, Tỉnh Thái Bình","code":"13198","parent_code":"344"},"13201":{"name":"Xã Xuân Hòa","type":"xa","slug":"xa-xuan-hoa","name_with_type":"Xã Xuân Hòa","path":"Xã Xuân Hòa, Huyện Vũ Thư, Tỉnh Thái Bình","path_with_type":"Xã Xuân Hòa, Huyện Vũ Thư, Tỉnh Thái Bình","code":"13201","parent_code":"344"},"13204":{"name":"Xã Hiệp Hòa","type":"xa","slug":"xa-hiep-hoa","name_with_type":"Xã Hiệp Hòa","path":"Xã Hiệp Hòa, Huyện Vũ Thư, Tỉnh Thái Bình","path_with_type":"Xã Hiệp Hòa, Huyện Vũ Thư, Tỉnh Thái Bình","code":"13204","parent_code":"344"},"13207":{"name":"Xã Phúc Thành","type":"xa","slug":"xa-phuc-thanh","name_with_type":"Xã Phúc Thành","path":"Xã Phúc Thành, Huyện Vũ Thư, Tỉnh Thái Bình","path_with_type":"Xã Phúc Thành, Huyện Vũ Thư, Tỉnh Thái Bình","code":"13207","parent_code":"344"},"13210":{"name":"Xã Tân Phong","type":"xa","slug":"xa-tan-phong","name_with_type":"Xã Tân Phong","path":"Xã Tân Phong, Huyện Vũ Thư, Tỉnh Thái Bình","path_with_type":"Xã Tân Phong, Huyện Vũ Thư, Tỉnh Thái Bình","code":"13210","parent_code":"344"},"13213":{"name":"Xã Song Lãng","type":"xa","slug":"xa-song-lang","name_with_type":"Xã Song Lãng","path":"Xã Song Lãng, Huyện Vũ Thư, Tỉnh Thái Bình","path_with_type":"Xã Song Lãng, Huyện Vũ Thư, Tỉnh Thái Bình","code":"13213","parent_code":"344"},"13216":{"name":"Xã Tân Hòa","type":"xa","slug":"xa-tan-hoa","name_with_type":"Xã Tân Hòa","path":"Xã Tân Hòa, Huyện Vũ Thư, Tỉnh Thái Bình","path_with_type":"Xã Tân Hòa, Huyện Vũ Thư, Tỉnh Thái Bình","code":"13216","parent_code":"344"},"13219":{"name":"Xã Việt Hùng","type":"xa","slug":"xa-viet-hung","name_with_type":"Xã Việt Hùng","path":"Xã Việt Hùng, Huyện Vũ Thư, Tỉnh Thái Bình","path_with_type":"Xã Việt Hùng, Huyện Vũ Thư, Tỉnh Thái Bình","code":"13219","parent_code":"344"},"13222":{"name":"Xã Minh Lãng","type":"xa","slug":"xa-minh-lang","name_with_type":"Xã Minh Lãng","path":"Xã Minh Lãng, Huyện Vũ Thư, Tỉnh Thái Bình","path_with_type":"Xã Minh Lãng, Huyện Vũ Thư, Tỉnh Thái Bình","code":"13222","parent_code":"344"},"13225":{"name":"Xã Tân Bình","type":"xa","slug":"xa-tan-binh","name_with_type":"Xã Tân Bình","path":"Xã Tân Bình, Thành phố Thái Bình, Tỉnh Thái Bình","path_with_type":"Xã Tân Bình, Thành phố Thái Bình, Tỉnh Thái Bình","code":"13225","parent_code":"336"},"13228":{"name":"Xã Minh Khai","type":"xa","slug":"xa-minh-khai","name_with_type":"Xã Minh Khai","path":"Xã Minh Khai, Huyện Vũ Thư, Tỉnh Thái Bình","path_with_type":"Xã Minh Khai, Huyện Vũ Thư, Tỉnh Thái Bình","code":"13228","parent_code":"344"},"13231":{"name":"Xã Dũng Nghĩa","type":"xa","slug":"xa-dung-nghia","name_with_type":"Xã Dũng Nghĩa","path":"Xã Dũng Nghĩa, Huyện Vũ Thư, Tỉnh Thái Bình","path_with_type":"Xã Dũng Nghĩa, Huyện Vũ Thư, Tỉnh Thái Bình","code":"13231","parent_code":"344"},"13234":{"name":"Xã Minh Quang","type":"xa","slug":"xa-minh-quang","name_with_type":"Xã Minh Quang","path":"Xã Minh Quang, Huyện Vũ Thư, Tỉnh Thái Bình","path_with_type":"Xã Minh Quang, Huyện Vũ Thư, Tỉnh Thái Bình","code":"13234","parent_code":"344"},"13237":{"name":"Xã Tam Quang","type":"xa","slug":"xa-tam-quang","name_with_type":"Xã Tam Quang","path":"Xã Tam Quang, Huyện Vũ Thư, Tỉnh Thái Bình","path_with_type":"Xã Tam Quang, Huyện Vũ Thư, Tỉnh Thái Bình","code":"13237","parent_code":"344"},"13240":{"name":"Xã Tân Lập","type":"xa","slug":"xa-tan-lap","name_with_type":"Xã Tân Lập","path":"Xã Tân Lập, Huyện Vũ Thư, Tỉnh Thái Bình","path_with_type":"Xã Tân Lập, Huyện Vũ Thư, Tỉnh Thái Bình","code":"13240","parent_code":"344"},"13243":{"name":"Xã Bách Thuận","type":"xa","slug":"xa-bach-thuan","name_with_type":"Xã Bách Thuận","path":"Xã Bách Thuận, Huyện Vũ Thư, Tỉnh Thái Bình","path_with_type":"Xã Bách Thuận, Huyện Vũ Thư, Tỉnh Thái Bình","code":"13243","parent_code":"344"},"13246":{"name":"Xã Tự Tân","type":"xa","slug":"xa-tu-tan","name_with_type":"Xã Tự Tân","path":"Xã Tự Tân, Huyện Vũ Thư, Tỉnh Thái Bình","path_with_type":"Xã Tự Tân, Huyện Vũ Thư, Tỉnh Thái Bình","code":"13246","parent_code":"344"},"13249":{"name":"Xã Song An","type":"xa","slug":"xa-song-an","name_with_type":"Xã Song An","path":"Xã Song An, Huyện Vũ Thư, Tỉnh Thái Bình","path_with_type":"Xã Song An, Huyện Vũ Thư, Tỉnh Thái Bình","code":"13249","parent_code":"344"},"13252":{"name":"Xã Trung An","type":"xa","slug":"xa-trung-an","name_with_type":"Xã Trung An","path":"Xã Trung An, Huyện Vũ Thư, Tỉnh Thái Bình","path_with_type":"Xã Trung An, Huyện Vũ Thư, Tỉnh Thái Bình","code":"13252","parent_code":"344"},"13255":{"name":"Xã Vũ Hội","type":"xa","slug":"xa-vu-hoi","name_with_type":"Xã Vũ Hội","path":"Xã Vũ Hội, Huyện Vũ Thư, Tỉnh Thái Bình","path_with_type":"Xã Vũ Hội, Huyện Vũ Thư, Tỉnh Thái Bình","code":"13255","parent_code":"344"},"13258":{"name":"Xã Hòa Bình","type":"xa","slug":"xa-hoa-binh","name_with_type":"Xã Hòa Bình","path":"Xã Hòa Bình, Huyện Vũ Thư, Tỉnh Thái Bình","path_with_type":"Xã Hòa Bình, Huyện Vũ Thư, Tỉnh Thái Bình","code":"13258","parent_code":"344"},"13261":{"name":"Xã Nguyên Xá","type":"xa","slug":"xa-nguyen-xa","name_with_type":"Xã Nguyên Xá","path":"Xã Nguyên Xá, Huyện Vũ Thư, Tỉnh Thái Bình","path_with_type":"Xã Nguyên Xá, Huyện Vũ Thư, Tỉnh Thái Bình","code":"13261","parent_code":"344"},"13264":{"name":"Xã Việt Thuận","type":"xa","slug":"xa-viet-thuan","name_with_type":"Xã Việt Thuận","path":"Xã Việt Thuận, Huyện Vũ Thư, Tỉnh Thái Bình","path_with_type":"Xã Việt Thuận, Huyện Vũ Thư, Tỉnh Thái Bình","code":"13264","parent_code":"344"},"13267":{"name":"Xã Vũ Vinh","type":"xa","slug":"xa-vu-vinh","name_with_type":"Xã Vũ Vinh","path":"Xã Vũ Vinh, Huyện Vũ Thư, Tỉnh Thái Bình","path_with_type":"Xã Vũ Vinh, Huyện Vũ Thư, Tỉnh Thái Bình","code":"13267","parent_code":"344"},"13270":{"name":"Xã Vũ Đoài","type":"xa","slug":"xa-vu-doai","name_with_type":"Xã Vũ Đoài","path":"Xã Vũ Đoài, Huyện Vũ Thư, Tỉnh Thái Bình","path_with_type":"Xã Vũ Đoài, Huyện Vũ Thư, Tỉnh Thái Bình","code":"13270","parent_code":"344"},"13273":{"name":"Xã Vũ Tiến","type":"xa","slug":"xa-vu-tien","name_with_type":"Xã Vũ Tiến","path":"Xã Vũ Tiến, Huyện Vũ Thư, Tỉnh Thái Bình","path_with_type":"Xã Vũ Tiến, Huyện Vũ Thư, Tỉnh Thái Bình","code":"13273","parent_code":"344"},"13276":{"name":"Xã Vũ Vân","type":"xa","slug":"xa-vu-van","name_with_type":"Xã Vũ Vân","path":"Xã Vũ Vân, Huyện Vũ Thư, Tỉnh Thái Bình","path_with_type":"Xã Vũ Vân, Huyện Vũ Thư, Tỉnh Thái Bình","code":"13276","parent_code":"344"},"13279":{"name":"Xã Duy Nhất","type":"xa","slug":"xa-duy-nhat","name_with_type":"Xã Duy Nhất","path":"Xã Duy Nhất, Huyện Vũ Thư, Tỉnh Thái Bình","path_with_type":"Xã Duy Nhất, Huyện Vũ Thư, Tỉnh Thái Bình","code":"13279","parent_code":"344"},"13282":{"name":"Xã Hồng Phong","type":"xa","slug":"xa-hong-phong","name_with_type":"Xã Hồng Phong","path":"Xã Hồng Phong, Huyện Vũ Thư, Tỉnh Thái Bình","path_with_type":"Xã Hồng Phong, Huyện Vũ Thư, Tỉnh Thái Bình","code":"13282","parent_code":"344"},"13285":{"name":"Phường Quang Trung","type":"phuong","slug":"phuong-quang-trung","name_with_type":"Phường Quang Trung","path":"Phường Quang Trung, Thành phố Phủ Lý, Tỉnh Hà Nam","path_with_type":"Phường Quang Trung, Thành phố Phủ Lý, Tỉnh Hà Nam","code":"13285","parent_code":"347"},"13291":{"name":"Phường Lê Hồng Phong","type":"phuong","slug":"phuong-le-hong-phong","name_with_type":"Phường Lê Hồng Phong","path":"Phường Lê Hồng Phong, Thành phố Phủ Lý, Tỉnh Hà Nam","path_with_type":"Phường Lê Hồng Phong, Thành phố Phủ Lý, Tỉnh Hà Nam","code":"13291","parent_code":"347"},"13294":{"name":"Phường Châu Cầu","type":"phuong","slug":"phuong-chau-cau","name_with_type":"Phường Châu Cầu","path":"Phường Châu Cầu, Thành phố Phủ Lý, Tỉnh Hà Nam","path_with_type":"Phường Châu Cầu, Thành phố Phủ Lý, Tỉnh Hà Nam","code":"13294","parent_code":"347"},"13303":{"name":"Phường Lam Hạ","type":"phuong","slug":"phuong-lam-ha","name_with_type":"Phường Lam Hạ","path":"Phường Lam Hạ, Thành phố Phủ Lý, Tỉnh Hà Nam","path_with_type":"Phường Lam Hạ, Thành phố Phủ Lý, Tỉnh Hà Nam","code":"13303","parent_code":"347"},"13306":{"name":"Xã Phù Vân","type":"xa","slug":"xa-phu-van","name_with_type":"Xã Phù Vân","path":"Xã Phù Vân, Thành phố Phủ Lý, Tỉnh Hà Nam","path_with_type":"Xã Phù Vân, Thành phố Phủ Lý, Tỉnh Hà Nam","code":"13306","parent_code":"347"},"13309":{"name":"Phường Liêm Chính","type":"phuong","slug":"phuong-liem-chinh","name_with_type":"Phường Liêm Chính","path":"Phường Liêm Chính, Thành phố Phủ Lý, Tỉnh Hà Nam","path_with_type":"Phường Liêm Chính, Thành phố Phủ Lý, Tỉnh Hà Nam","code":"13309","parent_code":"347"},"13315":{"name":"Phường Thanh Châu","type":"phuong","slug":"phuong-thanh-chau","name_with_type":"Phường Thanh Châu","path":"Phường Thanh Châu, Thành phố Phủ Lý, Tỉnh Hà Nam","path_with_type":"Phường Thanh Châu, Thành phố Phủ Lý, Tỉnh Hà Nam","code":"13315","parent_code":"347"},"13318":{"name":"Phường Châu Sơn","type":"phuong","slug":"phuong-chau-son","name_with_type":"Phường Châu Sơn","path":"Phường Châu Sơn, Thành phố Phủ Lý, Tỉnh Hà Nam","path_with_type":"Phường Châu Sơn, Thành phố Phủ Lý, Tỉnh Hà Nam","code":"13318","parent_code":"347"},"13321":{"name":"Phường Đồng Văn","type":"phuong","slug":"phuong-dong-van","name_with_type":"Phường Đồng Văn","path":"Phường Đồng Văn, Thị xã Duy Tiên, Tỉnh Hà Nam","path_with_type":"Phường Đồng Văn, Thị xã Duy Tiên, Tỉnh Hà Nam","code":"13321","parent_code":"349"},"13324":{"name":"Phường Hòa Mạc","type":"phuong","slug":"phuong-hoa-mac","name_with_type":"Phường Hòa Mạc","path":"Phường Hòa Mạc, Thị xã Duy Tiên, Tỉnh Hà Nam","path_with_type":"Phường Hòa Mạc, Thị xã Duy Tiên, Tỉnh Hà Nam","code":"13324","parent_code":"349"},"13327":{"name":"Xã Mộc Hoàn","type":"xa","slug":"xa-moc-hoan","name_with_type":"Xã Mộc Hoàn","path":"Xã Mộc Hoàn, Thị xã Duy Tiên, Tỉnh Hà Nam","path_with_type":"Xã Mộc Hoàn, Thị xã Duy Tiên, Tỉnh Hà Nam","code":"13327","parent_code":"349"},"13330":{"name":"Phường Châu Giang","type":"phuong","slug":"phuong-chau-giang","name_with_type":"Phường Châu Giang","path":"Phường Châu Giang, Thị xã Duy Tiên, Tỉnh Hà Nam","path_with_type":"Phường Châu Giang, Thị xã Duy Tiên, Tỉnh Hà Nam","code":"13330","parent_code":"349"},"13333":{"name":"Phường Bạch Thượng","type":"phuong","slug":"phuong-bach-thuong","name_with_type":"Phường Bạch Thượng","path":"Phường Bạch Thượng, Thị xã Duy Tiên, Tỉnh Hà Nam","path_with_type":"Phường Bạch Thượng, Thị xã Duy Tiên, Tỉnh Hà Nam","code":"13333","parent_code":"349"},"13336":{"name":"Phường Duy Minh","type":"phuong","slug":"phuong-duy-minh","name_with_type":"Phường Duy Minh","path":"Phường Duy Minh, Thị xã Duy Tiên, Tỉnh Hà Nam","path_with_type":"Phường Duy Minh, Thị xã Duy Tiên, Tỉnh Hà Nam","code":"13336","parent_code":"349"},"13342":{"name":"Phường Duy Hải","type":"phuong","slug":"phuong-duy-hai","name_with_type":"Phường Duy Hải","path":"Phường Duy Hải, Thị xã Duy Tiên, Tỉnh Hà Nam","path_with_type":"Phường Duy Hải, Thị xã Duy Tiên, Tỉnh Hà Nam","code":"13342","parent_code":"349"},"13345":{"name":"Xã Chuyên Ngoại","type":"xa","slug":"xa-chuyen-ngoai","name_with_type":"Xã Chuyên Ngoại","path":"Xã Chuyên Ngoại, Thị xã Duy Tiên, Tỉnh Hà Nam","path_with_type":"Xã Chuyên Ngoại, Thị xã Duy Tiên, Tỉnh Hà Nam","code":"13345","parent_code":"349"},"13348":{"name":"Phường Yên Bắc","type":"phuong","slug":"phuong-yen-bac","name_with_type":"Phường Yên Bắc","path":"Phường Yên Bắc, Thị xã Duy Tiên, Tỉnh Hà Nam","path_with_type":"Phường Yên Bắc, Thị xã Duy Tiên, Tỉnh Hà Nam","code":"13348","parent_code":"349"},"13351":{"name":"Xã Trác Văn","type":"xa","slug":"xa-trac-van","name_with_type":"Xã Trác Văn","path":"Xã Trác Văn, Thị xã Duy Tiên, Tỉnh Hà Nam","path_with_type":"Xã Trác Văn, Thị xã Duy Tiên, Tỉnh Hà Nam","code":"13351","parent_code":"349"},"13354":{"name":"Phường Tiên Nội","type":"phuong","slug":"phuong-tien-noi","name_with_type":"Phường Tiên Nội","path":"Phường Tiên Nội, Thị xã Duy Tiên, Tỉnh Hà Nam","path_with_type":"Phường Tiên Nội, Thị xã Duy Tiên, Tỉnh Hà Nam","code":"13354","parent_code":"349"},"13357":{"name":"Phường Hoàng Đông","type":"phuong","slug":"phuong-hoang-dong","name_with_type":"Phường Hoàng Đông","path":"Phường Hoàng Đông, Thị xã Duy Tiên, Tỉnh Hà Nam","path_with_type":"Phường Hoàng Đông, Thị xã Duy Tiên, Tỉnh Hà Nam","code":"13357","parent_code":"349"},"13360":{"name":"Xã Yên Nam","type":"xa","slug":"xa-yen-nam","name_with_type":"Xã Yên Nam","path":"Xã Yên Nam, Thị xã Duy Tiên, Tỉnh Hà Nam","path_with_type":"Xã Yên Nam, Thị xã Duy Tiên, Tỉnh Hà Nam","code":"13360","parent_code":"349"},"13363":{"name":"Xã Tiên Ngoại","type":"xa","slug":"xa-tien-ngoai","name_with_type":"Xã Tiên Ngoại","path":"Xã Tiên Ngoại, Thị xã Duy Tiên, Tỉnh Hà Nam","path_with_type":"Xã Tiên Ngoại, Thị xã Duy Tiên, Tỉnh Hà Nam","code":"13363","parent_code":"349"},"13366":{"name":"Phường Tân Hiệp","type":"phuong","slug":"phuong-tan-hiep","name_with_type":"Phường Tân Hiệp","path":"Phường Tân Hiệp, Thành phố Phủ Lý, Tỉnh Hà Nam","path_with_type":"Phường Tân Hiệp, Thành phố Phủ Lý, Tỉnh Hà Nam","code":"13366","parent_code":"347"},"13369":{"name":"Xã Tiên Sơn","type":"xa","slug":"xa-tien-son","name_with_type":"Xã Tiên Sơn","path":"Xã Tiên Sơn, Thị xã Duy Tiên, Tỉnh Hà Nam","path_with_type":"Xã Tiên Sơn, Thị xã Duy Tiên, Tỉnh Hà Nam","code":"13369","parent_code":"349"},"13384":{"name":"Phường Quế","type":"phuong","slug":"phuong-que","name_with_type":"Phường Quế","path":"Phường Quế, Thị xã Kim Bảng, Tỉnh Hà Nam","path_with_type":"Phường Quế, Thị xã Kim Bảng, Tỉnh Hà Nam","code":"13384","parent_code":"350"},"13387":{"name":"Xã Nguyễn Úy","type":"xa","slug":"xa-nguyen-uy","name_with_type":"Xã Nguyễn Úy","path":"Xã Nguyễn Úy, Thị xã Kim Bảng, Tỉnh Hà Nam","path_with_type":"Xã Nguyễn Úy, Thị xã Kim Bảng, Tỉnh Hà Nam","code":"13387","parent_code":"350"},"13390":{"name":"Phường Đại Cương","type":"phuong","slug":"phuong-dai-cuong","name_with_type":"Phường Đại Cương","path":"Phường Đại Cương, Thị xã Kim Bảng, Tỉnh Hà Nam","path_with_type":"Phường Đại Cương, Thị xã Kim Bảng, Tỉnh Hà Nam","code":"13390","parent_code":"350"},"13393":{"name":"Phường Lê Hồ","type":"phuong","slug":"phuong-le-ho","name_with_type":"Phường Lê Hồ","path":"Phường Lê Hồ, Thị xã Kim Bảng, Tỉnh Hà Nam","path_with_type":"Phường Lê Hồ, Thị xã Kim Bảng, Tỉnh Hà Nam","code":"13393","parent_code":"350"},"13396":{"name":"Phường Tượng Lĩnh","type":"phuong","slug":"phuong-tuong-linh","name_with_type":"Phường Tượng Lĩnh","path":"Phường Tượng Lĩnh, Thị xã Kim Bảng, Tỉnh Hà Nam","path_with_type":"Phường Tượng Lĩnh, Thị xã Kim Bảng, Tỉnh Hà Nam","code":"13396","parent_code":"350"},"13402":{"name":"Phường Tân Tựu","type":"phuong","slug":"phuong-tan-tuu","name_with_type":"Phường Tân Tựu","path":"Phường Tân Tựu, Thị xã Kim Bảng, Tỉnh Hà Nam","path_with_type":"Phường Tân Tựu, Thị xã Kim Bảng, Tỉnh Hà Nam","code":"13402","parent_code":"350"},"13405":{"name":"Phường Đồng Hóa","type":"phuong","slug":"phuong-dong-hoa","name_with_type":"Phường Đồng Hóa","path":"Phường Đồng Hóa, Thị xã Kim Bảng, Tỉnh Hà Nam","path_with_type":"Phường Đồng Hóa, Thị xã Kim Bảng, Tỉnh Hà Nam","code":"13405","parent_code":"350"},"13408":{"name":"Xã Hoàng Tây","type":"xa","slug":"xa-hoang-tay","name_with_type":"Xã Hoàng Tây","path":"Xã Hoàng Tây, Thị xã Kim Bảng, Tỉnh Hà Nam","path_with_type":"Xã Hoàng Tây, Thị xã Kim Bảng, Tỉnh Hà Nam","code":"13408","parent_code":"350"},"13411":{"name":"Phường Tân Sơn","type":"phuong","slug":"phuong-tan-son","name_with_type":"Phường Tân Sơn","path":"Phường Tân Sơn, Thị xã Kim Bảng, Tỉnh Hà Nam","path_with_type":"Phường Tân Sơn, Thị xã Kim Bảng, Tỉnh Hà Nam","code":"13411","parent_code":"350"},"13414":{"name":"Xã Thụy Lôi","type":"xa","slug":"xa-thuy-loi","name_with_type":"Xã Thụy Lôi","path":"Xã Thụy Lôi, Thị xã Kim Bảng, Tỉnh Hà Nam","path_with_type":"Xã Thụy Lôi, Thị xã Kim Bảng, Tỉnh Hà Nam","code":"13414","parent_code":"350"},"13417":{"name":"Xã Văn Xá","type":"xa","slug":"xa-van-xa","name_with_type":"Xã Văn Xá","path":"Xã Văn Xá, Thị xã Kim Bảng, Tỉnh Hà Nam","path_with_type":"Xã Văn Xá, Thị xã Kim Bảng, Tỉnh Hà Nam","code":"13417","parent_code":"350"},"13420":{"name":"Xã Khả Phong","type":"xa","slug":"xa-kha-phong","name_with_type":"Xã Khả Phong","path":"Xã Khả Phong, Thị xã Kim Bảng, Tỉnh Hà Nam","path_with_type":"Xã Khả Phong, Thị xã Kim Bảng, Tỉnh Hà Nam","code":"13420","parent_code":"350"},"13423":{"name":"Phường Ngọc Sơn","type":"phuong","slug":"phuong-ngoc-son","name_with_type":"Phường Ngọc Sơn","path":"Phường Ngọc Sơn, Thị xã Kim Bảng, Tỉnh Hà Nam","path_with_type":"Phường Ngọc Sơn, Thị xã Kim Bảng, Tỉnh Hà Nam","code":"13423","parent_code":"350"},"13426":{"name":"Xã Kim Bình","type":"xa","slug":"xa-kim-binh","name_with_type":"Xã Kim Bình","path":"Xã Kim Bình, Thành phố Phủ Lý, Tỉnh Hà Nam","path_with_type":"Xã Kim Bình, Thành phố Phủ Lý, Tỉnh Hà Nam","code":"13426","parent_code":"347"},"13429":{"name":"Phường Ba Sao","type":"phuong","slug":"phuong-ba-sao","name_with_type":"Phường Ba Sao","path":"Phường Ba Sao, Thị xã Kim Bảng, Tỉnh Hà Nam","path_with_type":"Phường Ba Sao, Thị xã Kim Bảng, Tỉnh Hà Nam","code":"13429","parent_code":"350"},"13432":{"name":"Xã Liên Sơn","type":"xa","slug":"xa-lien-son","name_with_type":"Xã Liên Sơn","path":"Xã Liên Sơn, Thị xã Kim Bảng, Tỉnh Hà Nam","path_with_type":"Xã Liên Sơn, Thị xã Kim Bảng, Tỉnh Hà Nam","code":"13432","parent_code":"350"},"13435":{"name":"Phường Thi Sơn","type":"phuong","slug":"phuong-thi-son","name_with_type":"Phường Thi Sơn","path":"Phường Thi Sơn, Thị xã Kim Bảng, Tỉnh Hà Nam","path_with_type":"Phường Thi Sơn, Thị xã Kim Bảng, Tỉnh Hà Nam","code":"13435","parent_code":"350"},"13438":{"name":"Xã Thanh Sơn","type":"xa","slug":"xa-thanh-son","name_with_type":"Xã Thanh Sơn","path":"Xã Thanh Sơn, Thị xã Kim Bảng, Tỉnh Hà Nam","path_with_type":"Xã Thanh Sơn, Thị xã Kim Bảng, Tỉnh Hà Nam","code":"13438","parent_code":"350"},"13441":{"name":"Thị trấn Kiện Khê","type":"thi-tran","slug":"thi-tran-kien-khe","name_with_type":"Thị trấn Kiện Khê","path":"Thị trấn Kiện Khê, Huyện Thanh Liêm, Tỉnh Hà Nam","path_with_type":"Thị trấn Kiện Khê, Huyện Thanh Liêm, Tỉnh Hà Nam","code":"13441","parent_code":"351"},"13444":{"name":"Phường Tân Liêm","type":"phuong","slug":"phuong-tan-liem","name_with_type":"Phường Tân Liêm","path":"Phường Tân Liêm, Thành phố Phủ Lý, Tỉnh Hà Nam","path_with_type":"Phường Tân Liêm, Thành phố Phủ Lý, Tỉnh Hà Nam","code":"13444","parent_code":"347"},"13450":{"name":"Xã Liêm Phong","type":"xa","slug":"xa-liem-phong","name_with_type":"Xã Liêm Phong","path":"Xã Liêm Phong, Huyện Thanh Liêm, Tỉnh Hà Nam","path_with_type":"Xã Liêm Phong, Huyện Thanh Liêm, Tỉnh Hà Nam","code":"13450","parent_code":"351"},"13453":{"name":"Xã Thanh Hà","type":"xa","slug":"xa-thanh-ha","name_with_type":"Xã Thanh Hà","path":"Xã Thanh Hà, Huyện Thanh Liêm, Tỉnh Hà Nam","path_with_type":"Xã Thanh Hà, Huyện Thanh Liêm, Tỉnh Hà Nam","code":"13453","parent_code":"351"},"13456":{"name":"Xã Liêm Cần","type":"xa","slug":"xa-liem-can","name_with_type":"Xã Liêm Cần","path":"Xã Liêm Cần, Huyện Thanh Liêm, Tỉnh Hà Nam","path_with_type":"Xã Liêm Cần, Huyện Thanh Liêm, Tỉnh Hà Nam","code":"13456","parent_code":"351"},"13459":{"name":"Phường Thanh Tuyền","type":"phuong","slug":"phuong-thanh-tuyen","name_with_type":"Phường Thanh Tuyền","path":"Phường Thanh Tuyền, Thành phố Phủ Lý, Tỉnh Hà Nam","path_with_type":"Phường Thanh Tuyền, Thành phố Phủ Lý, Tỉnh Hà Nam","code":"13459","parent_code":"347"},"13465":{"name":"Xã Liêm Thuận","type":"xa","slug":"xa-liem-thuan","name_with_type":"Xã Liêm Thuận","path":"Xã Liêm Thuận, Huyện Thanh Liêm, Tỉnh Hà Nam","path_with_type":"Xã Liêm Thuận, Huyện Thanh Liêm, Tỉnh Hà Nam","code":"13465","parent_code":"351"},"13468":{"name":"Xã Thanh Thủy","type":"xa","slug":"xa-thanh-thuy","name_with_type":"Xã Thanh Thủy","path":"Xã Thanh Thủy, Huyện Thanh Liêm, Tỉnh Hà Nam","path_with_type":"Xã Thanh Thủy, Huyện Thanh Liêm, Tỉnh Hà Nam","code":"13468","parent_code":"351"},"13471":{"name":"Xã Thanh Phong","type":"xa","slug":"xa-thanh-phong","name_with_type":"Xã Thanh Phong","path":"Xã Thanh Phong, Huyện Thanh Liêm, Tỉnh Hà Nam","path_with_type":"Xã Thanh Phong, Huyện Thanh Liêm, Tỉnh Hà Nam","code":"13471","parent_code":"351"},"13474":{"name":"Thị trấn Tân Thanh","type":"thi-tran","slug":"thi-tran-tan-thanh","name_with_type":"Thị trấn Tân Thanh","path":"Thị trấn Tân Thanh, Huyện Thanh Liêm, Tỉnh Hà Nam","path_with_type":"Thị trấn Tân Thanh, Huyện Thanh Liêm, Tỉnh Hà Nam","code":"13474","parent_code":"351"},"13477":{"name":"Xã Thanh Tân","type":"xa","slug":"xa-thanh-tan","name_with_type":"Xã Thanh Tân","path":"Xã Thanh Tân, Huyện Thanh Liêm, Tỉnh Hà Nam","path_with_type":"Xã Thanh Tân, Huyện Thanh Liêm, Tỉnh Hà Nam","code":"13477","parent_code":"351"},"13480":{"name":"Xã Liêm Túc","type":"xa","slug":"xa-liem-tuc","name_with_type":"Xã Liêm Túc","path":"Xã Liêm Túc, Huyện Thanh Liêm, Tỉnh Hà Nam","path_with_type":"Xã Liêm Túc, Huyện Thanh Liêm, Tỉnh Hà Nam","code":"13480","parent_code":"351"},"13483":{"name":"Xã Liêm Sơn","type":"xa","slug":"xa-liem-son","name_with_type":"Xã Liêm Sơn","path":"Xã Liêm Sơn, Huyện Thanh Liêm, Tỉnh Hà Nam","path_with_type":"Xã Liêm Sơn, Huyện Thanh Liêm, Tỉnh Hà Nam","code":"13483","parent_code":"351"},"13486":{"name":"Xã Thanh Hương","type":"xa","slug":"xa-thanh-huong","name_with_type":"Xã Thanh Hương","path":"Xã Thanh Hương, Huyện Thanh Liêm, Tỉnh Hà Nam","path_with_type":"Xã Thanh Hương, Huyện Thanh Liêm, Tỉnh Hà Nam","code":"13486","parent_code":"351"},"13489":{"name":"Xã Thanh Nghị","type":"xa","slug":"xa-thanh-nghi","name_with_type":"Xã Thanh Nghị","path":"Xã Thanh Nghị, Huyện Thanh Liêm, Tỉnh Hà Nam","path_with_type":"Xã Thanh Nghị, Huyện Thanh Liêm, Tỉnh Hà Nam","code":"13489","parent_code":"351"},"13492":{"name":"Xã Thanh Tâm","type":"xa","slug":"xa-thanh-tam","name_with_type":"Xã Thanh Tâm","path":"Xã Thanh Tâm, Huyện Thanh Liêm, Tỉnh Hà Nam","path_with_type":"Xã Thanh Tâm, Huyện Thanh Liêm, Tỉnh Hà Nam","code":"13492","parent_code":"351"},"13495":{"name":"Xã Thanh Nguyên","type":"xa","slug":"xa-thanh-nguyen","name_with_type":"Xã Thanh Nguyên","path":"Xã Thanh Nguyên, Huyện Thanh Liêm, Tỉnh Hà Nam","path_with_type":"Xã Thanh Nguyên, Huyện Thanh Liêm, Tỉnh Hà Nam","code":"13495","parent_code":"351"},"13498":{"name":"Xã Thanh Hải","type":"xa","slug":"xa-thanh-hai","name_with_type":"Xã Thanh Hải","path":"Xã Thanh Hải, Huyện Thanh Liêm, Tỉnh Hà Nam","path_with_type":"Xã Thanh Hải, Huyện Thanh Liêm, Tỉnh Hà Nam","code":"13498","parent_code":"351"},"13501":{"name":"Thị trấn Bình Mỹ","type":"thi-tran","slug":"thi-tran-binh-my","name_with_type":"Thị trấn Bình Mỹ","path":"Thị trấn Bình Mỹ, Huyện Bình Lục, Tỉnh Hà Nam","path_with_type":"Thị trấn Bình Mỹ, Huyện Bình Lục, Tỉnh Hà Nam","code":"13501","parent_code":"352"},"13504":{"name":"Xã Bình Nghĩa","type":"xa","slug":"xa-binh-nghia","name_with_type":"Xã Bình Nghĩa","path":"Xã Bình Nghĩa, Huyện Bình Lục, Tỉnh Hà Nam","path_with_type":"Xã Bình Nghĩa, Huyện Bình Lục, Tỉnh Hà Nam","code":"13504","parent_code":"352"},"13507":{"name":"Xã Đinh Xá","type":"xa","slug":"xa-dinh-xa","name_with_type":"Xã Đinh Xá","path":"Xã Đinh Xá, Thành phố Phủ Lý, Tỉnh Hà Nam","path_with_type":"Xã Đinh Xá, Thành phố Phủ Lý, Tỉnh Hà Nam","code":"13507","parent_code":"347"},"13510":{"name":"Xã Tràng An","type":"xa","slug":"xa-trang-an","name_with_type":"Xã Tràng An","path":"Xã Tràng An, Huyện Bình Lục, Tỉnh Hà Nam","path_with_type":"Xã Tràng An, Huyện Bình Lục, Tỉnh Hà Nam","code":"13510","parent_code":"352"},"13513":{"name":"Xã Trịnh Xá","type":"xa","slug":"xa-trinh-xa","name_with_type":"Xã Trịnh Xá","path":"Xã Trịnh Xá, Thành phố Phủ Lý, Tỉnh Hà Nam","path_with_type":"Xã Trịnh Xá, Thành phố Phủ Lý, Tỉnh Hà Nam","code":"13513","parent_code":"347"},"13516":{"name":"Xã Đồng Du","type":"xa","slug":"xa-dong-du","name_with_type":"Xã Đồng Du","path":"Xã Đồng Du, Huyện Bình Lục, Tỉnh Hà Nam","path_with_type":"Xã Đồng Du, Huyện Bình Lục, Tỉnh Hà Nam","code":"13516","parent_code":"352"},"13519":{"name":"Xã Ngọc Lũ","type":"xa","slug":"xa-ngoc-lu","name_with_type":"Xã Ngọc Lũ","path":"Xã Ngọc Lũ, Huyện Bình Lục, Tỉnh Hà Nam","path_with_type":"Xã Ngọc Lũ, Huyện Bình Lục, Tỉnh Hà Nam","code":"13519","parent_code":"352"},"13525":{"name":"Xã Đồn Xá","type":"xa","slug":"xa-don-xa","name_with_type":"Xã Đồn Xá","path":"Xã Đồn Xá, Huyện Bình Lục, Tỉnh Hà Nam","path_with_type":"Xã Đồn Xá, Huyện Bình Lục, Tỉnh Hà Nam","code":"13525","parent_code":"352"},"13528":{"name":"Xã An Ninh","type":"xa","slug":"xa-an-ninh","name_with_type":"Xã An Ninh","path":"Xã An Ninh, Huyện Bình Lục, Tỉnh Hà Nam","path_with_type":"Xã An Ninh, Huyện Bình Lục, Tỉnh Hà Nam","code":"13528","parent_code":"352"},"13531":{"name":"Xã Bồ Đề","type":"xa","slug":"xa-bo-de","name_with_type":"Xã Bồ Đề","path":"Xã Bồ Đề, Huyện Bình Lục, Tỉnh Hà Nam","path_with_type":"Xã Bồ Đề, Huyện Bình Lục, Tỉnh Hà Nam","code":"13531","parent_code":"352"},"13540":{"name":"Xã Bình An","type":"xa","slug":"xa-binh-an","name_with_type":"Xã Bình An","path":"Xã Bình An, Huyện Bình Lục, Tỉnh Hà Nam","path_with_type":"Xã Bình An, Huyện Bình Lục, Tỉnh Hà Nam","code":"13540","parent_code":"352"},"13543":{"name":"Xã Vũ Bản","type":"xa","slug":"xa-vu-ban","name_with_type":"Xã Vũ Bản","path":"Xã Vũ Bản, Huyện Bình Lục, Tỉnh Hà Nam","path_with_type":"Xã Vũ Bản, Huyện Bình Lục, Tỉnh Hà Nam","code":"13543","parent_code":"352"},"13546":{"name":"Xã Trung Lương","type":"xa","slug":"xa-trung-luong","name_with_type":"Xã Trung Lương","path":"Xã Trung Lương, Huyện Bình Lục, Tỉnh Hà Nam","path_with_type":"Xã Trung Lương, Huyện Bình Lục, Tỉnh Hà Nam","code":"13546","parent_code":"352"},"13552":{"name":"Xã An Đổ","type":"xa","slug":"xa-an-do","name_with_type":"Xã An Đổ","path":"Xã An Đổ, Huyện Bình Lục, Tỉnh Hà Nam","path_with_type":"Xã An Đổ, Huyện Bình Lục, Tỉnh Hà Nam","code":"13552","parent_code":"352"},"13555":{"name":"Xã La Sơn","type":"xa","slug":"xa-la-son","name_with_type":"Xã La Sơn","path":"Xã La Sơn, Huyện Bình Lục, Tỉnh Hà Nam","path_with_type":"Xã La Sơn, Huyện Bình Lục, Tỉnh Hà Nam","code":"13555","parent_code":"352"},"13558":{"name":"Xã Tiêu Động","type":"xa","slug":"xa-tieu-dong","name_with_type":"Xã Tiêu Động","path":"Xã Tiêu Động, Huyện Bình Lục, Tỉnh Hà Nam","path_with_type":"Xã Tiêu Động, Huyện Bình Lục, Tỉnh Hà Nam","code":"13558","parent_code":"352"},"13561":{"name":"Xã An Lão","type":"xa","slug":"xa-an-lao","name_with_type":"Xã An Lão","path":"Xã An Lão, Huyện Bình Lục, Tỉnh Hà Nam","path_with_type":"Xã An Lão, Huyện Bình Lục, Tỉnh Hà Nam","code":"13561","parent_code":"352"},"13567":{"name":"Xã Hợp Lý","type":"xa","slug":"xa-hop-ly","name_with_type":"Xã Hợp Lý","path":"Xã Hợp Lý, Huyện Lý Nhân, Tỉnh Hà Nam","path_with_type":"Xã Hợp Lý, Huyện Lý Nhân, Tỉnh Hà Nam","code":"13567","parent_code":"353"},"13570":{"name":"Xã Nguyên Lý","type":"xa","slug":"xa-nguyen-ly","name_with_type":"Xã Nguyên Lý","path":"Xã Nguyên Lý, Huyện Lý Nhân, Tỉnh Hà Nam","path_with_type":"Xã Nguyên Lý, Huyện Lý Nhân, Tỉnh Hà Nam","code":"13570","parent_code":"353"},"13573":{"name":"Xã Chính Lý","type":"xa","slug":"xa-chinh-ly","name_with_type":"Xã Chính Lý","path":"Xã Chính Lý, Huyện Lý Nhân, Tỉnh Hà Nam","path_with_type":"Xã Chính Lý, Huyện Lý Nhân, Tỉnh Hà Nam","code":"13573","parent_code":"353"},"13576":{"name":"Xã Chân Lý","type":"xa","slug":"xa-chan-ly","name_with_type":"Xã Chân Lý","path":"Xã Chân Lý, Huyện Lý Nhân, Tỉnh Hà Nam","path_with_type":"Xã Chân Lý, Huyện Lý Nhân, Tỉnh Hà Nam","code":"13576","parent_code":"353"},"13579":{"name":"Xã Đạo Lý","type":"xa","slug":"xa-dao-ly","name_with_type":"Xã Đạo Lý","path":"Xã Đạo Lý, Huyện Lý Nhân, Tỉnh Hà Nam","path_with_type":"Xã Đạo Lý, Huyện Lý Nhân, Tỉnh Hà Nam","code":"13579","parent_code":"353"},"13582":{"name":"Xã Công Lý","type":"xa","slug":"xa-cong-ly","name_with_type":"Xã Công Lý","path":"Xã Công Lý, Huyện Lý Nhân, Tỉnh Hà Nam","path_with_type":"Xã Công Lý, Huyện Lý Nhân, Tỉnh Hà Nam","code":"13582","parent_code":"353"},"13585":{"name":"Xã Văn Lý","type":"xa","slug":"xa-van-ly","name_with_type":"Xã Văn Lý","path":"Xã Văn Lý, Huyện Lý Nhân, Tỉnh Hà Nam","path_with_type":"Xã Văn Lý, Huyện Lý Nhân, Tỉnh Hà Nam","code":"13585","parent_code":"353"},"13588":{"name":"Xã Bắc Lý","type":"xa","slug":"xa-bac-ly","name_with_type":"Xã Bắc Lý","path":"Xã Bắc Lý, Huyện Lý Nhân, Tỉnh Hà Nam","path_with_type":"Xã Bắc Lý, Huyện Lý Nhân, Tỉnh Hà Nam","code":"13588","parent_code":"353"},"13591":{"name":"Xã Đức Lý","type":"xa","slug":"xa-duc-ly","name_with_type":"Xã Đức Lý","path":"Xã Đức Lý, Huyện Lý Nhân, Tỉnh Hà Nam","path_with_type":"Xã Đức Lý, Huyện Lý Nhân, Tỉnh Hà Nam","code":"13591","parent_code":"353"},"13594":{"name":"Xã Trần Hưng Đạo","type":"xa","slug":"xa-tran-hung-dao","name_with_type":"Xã Trần Hưng Đạo","path":"Xã Trần Hưng Đạo, Huyện Lý Nhân, Tỉnh Hà Nam","path_with_type":"Xã Trần Hưng Đạo, Huyện Lý Nhân, Tỉnh Hà Nam","code":"13594","parent_code":"353"},"13597":{"name":"Thị trấn Vĩnh Trụ","type":"thi-tran","slug":"thi-tran-vinh-tru","name_with_type":"Thị trấn Vĩnh Trụ","path":"Thị trấn Vĩnh Trụ, Huyện Lý Nhân, Tỉnh Hà Nam","path_with_type":"Thị trấn Vĩnh Trụ, Huyện Lý Nhân, Tỉnh Hà Nam","code":"13597","parent_code":"353"},"13600":{"name":"Xã Nhân Thịnh","type":"xa","slug":"xa-nhan-thinh","name_with_type":"Xã Nhân Thịnh","path":"Xã Nhân Thịnh, Huyện Lý Nhân, Tỉnh Hà Nam","path_with_type":"Xã Nhân Thịnh, Huyện Lý Nhân, Tỉnh Hà Nam","code":"13600","parent_code":"353"},"13606":{"name":"Xã Nhân Khang","type":"xa","slug":"xa-nhan-khang","name_with_type":"Xã Nhân Khang","path":"Xã Nhân Khang, Huyện Lý Nhân, Tỉnh Hà Nam","path_with_type":"Xã Nhân Khang, Huyện Lý Nhân, Tỉnh Hà Nam","code":"13606","parent_code":"353"},"13609":{"name":"Xã Nhân Mỹ","type":"xa","slug":"xa-nhan-my","name_with_type":"Xã Nhân Mỹ","path":"Xã Nhân Mỹ, Huyện Lý Nhân, Tỉnh Hà Nam","path_with_type":"Xã Nhân Mỹ, Huyện Lý Nhân, Tỉnh Hà Nam","code":"13609","parent_code":"353"},"13612":{"name":"Xã Nhân Nghĩa","type":"xa","slug":"xa-nhan-nghia","name_with_type":"Xã Nhân Nghĩa","path":"Xã Nhân Nghĩa, Huyện Lý Nhân, Tỉnh Hà Nam","path_with_type":"Xã Nhân Nghĩa, Huyện Lý Nhân, Tỉnh Hà Nam","code":"13612","parent_code":"353"},"13615":{"name":"Xã Nhân Chính","type":"xa","slug":"xa-nhan-chinh","name_with_type":"Xã Nhân Chính","path":"Xã Nhân Chính, Huyện Lý Nhân, Tỉnh Hà Nam","path_with_type":"Xã Nhân Chính, Huyện Lý Nhân, Tỉnh Hà Nam","code":"13615","parent_code":"353"},"13618":{"name":"Xã Nhân Bình","type":"xa","slug":"xa-nhan-binh","name_with_type":"Xã Nhân Bình","path":"Xã Nhân Bình, Huyện Lý Nhân, Tỉnh Hà Nam","path_with_type":"Xã Nhân Bình, Huyện Lý Nhân, Tỉnh Hà Nam","code":"13618","parent_code":"353"},"13621":{"name":"Xã Phú Phúc","type":"xa","slug":"xa-phu-phuc","name_with_type":"Xã Phú Phúc","path":"Xã Phú Phúc, Huyện Lý Nhân, Tỉnh Hà Nam","path_with_type":"Xã Phú Phúc, Huyện Lý Nhân, Tỉnh Hà Nam","code":"13621","parent_code":"353"},"13624":{"name":"Xã Xuân Khê","type":"xa","slug":"xa-xuan-khe","name_with_type":"Xã Xuân Khê","path":"Xã Xuân Khê, Huyện Lý Nhân, Tỉnh Hà Nam","path_with_type":"Xã Xuân Khê, Huyện Lý Nhân, Tỉnh Hà Nam","code":"13624","parent_code":"353"},"13627":{"name":"Xã Tiến Thắng","type":"xa","slug":"xa-tien-thang","name_with_type":"Xã Tiến Thắng","path":"Xã Tiến Thắng, Huyện Lý Nhân, Tỉnh Hà Nam","path_with_type":"Xã Tiến Thắng, Huyện Lý Nhân, Tỉnh Hà Nam","code":"13627","parent_code":"353"},"13630":{"name":"Xã Hòa Hậu","type":"xa","slug":"xa-hoa-hau","name_with_type":"Xã Hòa Hậu","path":"Xã Hòa Hậu, Huyện Lý Nhân, Tỉnh Hà Nam","path_with_type":"Xã Hòa Hậu, Huyện Lý Nhân, Tỉnh Hà Nam","code":"13630","parent_code":"353"},"13636":{"name":"Phường Vị Xuyên","type":"phuong","slug":"phuong-vi-xuyen","name_with_type":"Phường Vị Xuyên","path":"Phường Vị Xuyên, Thành phố Nam Định, Tỉnh Nam Định","path_with_type":"Phường Vị Xuyên, Thành phố Nam Định, Tỉnh Nam Định","code":"13636","parent_code":"356"},"13657":{"name":"Phường Trường Thi","type":"phuong","slug":"phuong-truong-thi","name_with_type":"Phường Trường Thi","path":"Phường Trường Thi, Thành phố Nam Định, Tỉnh Nam Định","path_with_type":"Phường Trường Thi, Thành phố Nam Định, Tỉnh Nam Định","code":"13657","parent_code":"356"},"13666":{"name":"Phường Trần Hưng Đạo","type":"phuong","slug":"phuong-tran-hung-dao","name_with_type":"Phường Trần Hưng Đạo","path":"Phường Trần Hưng Đạo, Thành phố Nam Định, Tỉnh Nam Định","path_with_type":"Phường Trần Hưng Đạo, Thành phố Nam Định, Tỉnh Nam Định","code":"13666","parent_code":"356"},"13669":{"name":"Phường Cửa Bắc","type":"phuong","slug":"phuong-cua-bac","name_with_type":"Phường Cửa Bắc","path":"Phường Cửa Bắc, Thành phố Nam Định, Tỉnh Nam Định","path_with_type":"Phường Cửa Bắc, Thành phố Nam Định, Tỉnh Nam Định","code":"13669","parent_code":"356"},"13678":{"name":"Phường Năng Tĩnh","type":"phuong","slug":"phuong-nang-tinh","name_with_type":"Phường Năng Tĩnh","path":"Phường Năng Tĩnh, Thành phố Nam Định, Tỉnh Nam Định","path_with_type":"Phường Năng Tĩnh, Thành phố Nam Định, Tỉnh Nam Định","code":"13678","parent_code":"356"},"13681":{"name":"Phường Quang Trung","type":"phuong","slug":"phuong-quang-trung","name_with_type":"Phường Quang Trung","path":"Phường Quang Trung, Thành phố Nam Định, Tỉnh Nam Định","path_with_type":"Phường Quang Trung, Thành phố Nam Định, Tỉnh Nam Định","code":"13681","parent_code":"356"},"13684":{"name":"Phường Lộc Hạ","type":"phuong","slug":"phuong-loc-ha","name_with_type":"Phường Lộc Hạ","path":"Phường Lộc Hạ, Thành phố Nam Định, Tỉnh Nam Định","path_with_type":"Phường Lộc Hạ, Thành phố Nam Định, Tỉnh Nam Định","code":"13684","parent_code":"356"},"13687":{"name":"Phường Lộc Vượng","type":"phuong","slug":"phuong-loc-vuong","name_with_type":"Phường Lộc Vượng","path":"Phường Lộc Vượng, Thành phố Nam Định, Tỉnh Nam Định","path_with_type":"Phường Lộc Vượng, Thành phố Nam Định, Tỉnh Nam Định","code":"13687","parent_code":"356"},"13690":{"name":"Phường Cửa Nam","type":"phuong","slug":"phuong-cua-nam","name_with_type":"Phường Cửa Nam","path":"Phường Cửa Nam, Thành phố Nam Định, Tỉnh Nam Định","path_with_type":"Phường Cửa Nam, Thành phố Nam Định, Tỉnh Nam Định","code":"13690","parent_code":"356"},"13693":{"name":"Phường Lộc Hòa","type":"phuong","slug":"phuong-loc-hoa","name_with_type":"Phường Lộc Hòa","path":"Phường Lộc Hòa, Thành phố Nam Định, Tỉnh Nam Định","path_with_type":"Phường Lộc Hòa, Thành phố Nam Định, Tỉnh Nam Định","code":"13693","parent_code":"356"},"13696":{"name":"Phường Nam Phong","type":"phuong","slug":"phuong-nam-phong","name_with_type":"Phường Nam Phong","path":"Phường Nam Phong, Thành phố Nam Định, Tỉnh Nam Định","path_with_type":"Phường Nam Phong, Thành phố Nam Định, Tỉnh Nam Định","code":"13696","parent_code":"356"},"13699":{"name":"Phường Mỹ Xá","type":"phuong","slug":"phuong-my-xa","name_with_type":"Phường Mỹ Xá","path":"Phường Mỹ Xá, Thành phố Nam Định, Tỉnh Nam Định","path_with_type":"Phường Mỹ Xá, Thành phố Nam Định, Tỉnh Nam Định","code":"13699","parent_code":"356"},"13705":{"name":"Phường Nam Vân","type":"phuong","slug":"phuong-nam-van","name_with_type":"Phường Nam Vân","path":"Phường Nam Vân, Thành phố Nam Định, Tỉnh Nam Định","path_with_type":"Phường Nam Vân, Thành phố Nam Định, Tỉnh Nam Định","code":"13705","parent_code":"356"},"13708":{"name":"Phường Hưng Lộc","type":"phuong","slug":"phuong-hung-loc","name_with_type":"Phường Hưng Lộc","path":"Phường Hưng Lộc, Thành phố Nam Định, Tỉnh Nam Định","path_with_type":"Phường Hưng Lộc, Thành phố Nam Định, Tỉnh Nam Định","code":"13708","parent_code":"356"},"13711":{"name":"Xã Mỹ Hà","type":"xa","slug":"xa-my-ha","name_with_type":"Xã Mỹ Hà","path":"Xã Mỹ Hà, Thành phố Nam Định, Tỉnh Nam Định","path_with_type":"Xã Mỹ Hà, Thành phố Nam Định, Tỉnh Nam Định","code":"13711","parent_code":"356"},"13717":{"name":"Xã Mỹ Thắng","type":"xa","slug":"xa-my-thang","name_with_type":"Xã Mỹ Thắng","path":"Xã Mỹ Thắng, Thành phố Nam Định, Tỉnh Nam Định","path_with_type":"Xã Mỹ Thắng, Thành phố Nam Định, Tỉnh Nam Định","code":"13717","parent_code":"356"},"13720":{"name":"Xã Mỹ Trung","type":"xa","slug":"xa-my-trung","name_with_type":"Xã Mỹ Trung","path":"Xã Mỹ Trung, Thành phố Nam Định, Tỉnh Nam Định","path_with_type":"Xã Mỹ Trung, Thành phố Nam Định, Tỉnh Nam Định","code":"13720","parent_code":"356"},"13723":{"name":"Xã Mỹ Tân","type":"xa","slug":"xa-my-tan","name_with_type":"Xã Mỹ Tân","path":"Xã Mỹ Tân, Thành phố Nam Định, Tỉnh Nam Định","path_with_type":"Xã Mỹ Tân, Thành phố Nam Định, Tỉnh Nam Định","code":"13723","parent_code":"356"},"13726":{"name":"Xã Mỹ Phúc","type":"xa","slug":"xa-my-phuc","name_with_type":"Xã Mỹ Phúc","path":"Xã Mỹ Phúc, Thành phố Nam Định, Tỉnh Nam Định","path_with_type":"Xã Mỹ Phúc, Thành phố Nam Định, Tỉnh Nam Định","code":"13726","parent_code":"356"},"13732":{"name":"Xã Mỹ Thuận","type":"xa","slug":"xa-my-thuan","name_with_type":"Xã Mỹ Thuận","path":"Xã Mỹ Thuận, Thành phố Nam Định, Tỉnh Nam Định","path_with_type":"Xã Mỹ Thuận, Thành phố Nam Định, Tỉnh Nam Định","code":"13732","parent_code":"356"},"13735":{"name":"Xã Mỹ Lộc","type":"xa","slug":"xa-my-loc","name_with_type":"Xã Mỹ Lộc","path":"Xã Mỹ Lộc, Thành phố Nam Định, Tỉnh Nam Định","path_with_type":"Xã Mỹ Lộc, Thành phố Nam Định, Tỉnh Nam Định","code":"13735","parent_code":"356"},"13741":{"name":"Thị trấn Gôi","type":"thi-tran","slug":"thi-tran-goi","name_with_type":"Thị trấn Gôi","path":"Thị trấn Gôi, Huyện Vụ Bản, Tỉnh Nam Định","path_with_type":"Thị trấn Gôi, Huyện Vụ Bản, Tỉnh Nam Định","code":"13741","parent_code":"359"},"13747":{"name":"Xã Hiển Khánh","type":"xa","slug":"xa-hien-khanh","name_with_type":"Xã Hiển Khánh","path":"Xã Hiển Khánh, Huyện Vụ Bản, Tỉnh Nam Định","path_with_type":"Xã Hiển Khánh, Huyện Vụ Bản, Tỉnh Nam Định","code":"13747","parent_code":"359"},"13750":{"name":"Xã Minh Tân","type":"xa","slug":"xa-minh-tan","name_with_type":"Xã Minh Tân","path":"Xã Minh Tân, Huyện Vụ Bản, Tỉnh Nam Định","path_with_type":"Xã Minh Tân, Huyện Vụ Bản, Tỉnh Nam Định","code":"13750","parent_code":"359"},"13753":{"name":"Xã Hợp Hưng","type":"xa","slug":"xa-hop-hung","name_with_type":"Xã Hợp Hưng","path":"Xã Hợp Hưng, Huyện Vụ Bản, Tỉnh Nam Định","path_with_type":"Xã Hợp Hưng, Huyện Vụ Bản, Tỉnh Nam Định","code":"13753","parent_code":"359"},"13756":{"name":"Xã Đại An","type":"xa","slug":"xa-dai-an","name_with_type":"Xã Đại An","path":"Xã Đại An, Huyện Vụ Bản, Tỉnh Nam Định","path_with_type":"Xã Đại An, Huyện Vụ Bản, Tỉnh Nam Định","code":"13756","parent_code":"359"},"13762":{"name":"Xã Cộng Hòa","type":"xa","slug":"xa-cong-hoa","name_with_type":"Xã Cộng Hòa","path":"Xã Cộng Hòa, Huyện Vụ Bản, Tỉnh Nam Định","path_with_type":"Xã Cộng Hòa, Huyện Vụ Bản, Tỉnh Nam Định","code":"13762","parent_code":"359"},"13765":{"name":"Xã Trung Thành","type":"xa","slug":"xa-trung-thanh","name_with_type":"Xã Trung Thành","path":"Xã Trung Thành, Huyện Vụ Bản, Tỉnh Nam Định","path_with_type":"Xã Trung Thành, Huyện Vụ Bản, Tỉnh Nam Định","code":"13765","parent_code":"359"},"13768":{"name":"Xã Quang Trung","type":"xa","slug":"xa-quang-trung","name_with_type":"Xã Quang Trung","path":"Xã Quang Trung, Huyện Vụ Bản, Tỉnh Nam Định","path_with_type":"Xã Quang Trung, Huyện Vụ Bản, Tỉnh Nam Định","code":"13768","parent_code":"359"},"13777":{"name":"Xã Thành Lợi","type":"xa","slug":"xa-thanh-loi","name_with_type":"Xã Thành Lợi","path":"Xã Thành Lợi, Huyện Vụ Bản, Tỉnh Nam Định","path_with_type":"Xã Thành Lợi, Huyện Vụ Bản, Tỉnh Nam Định","code":"13777","parent_code":"359"},"13780":{"name":"Xã Kim Thái","type":"xa","slug":"xa-kim-thai","name_with_type":"Xã Kim Thái","path":"Xã Kim Thái, Huyện Vụ Bản, Tỉnh Nam Định","path_with_type":"Xã Kim Thái, Huyện Vụ Bản, Tỉnh Nam Định","code":"13780","parent_code":"359"},"13783":{"name":"Xã Liên Minh","type":"xa","slug":"xa-lien-minh","name_with_type":"Xã Liên Minh","path":"Xã Liên Minh, Huyện Vụ Bản, Tỉnh Nam Định","path_with_type":"Xã Liên Minh, Huyện Vụ Bản, Tỉnh Nam Định","code":"13783","parent_code":"359"},"13786":{"name":"Xã Đại Thắng","type":"xa","slug":"xa-dai-thang","name_with_type":"Xã Đại Thắng","path":"Xã Đại Thắng, Huyện Vụ Bản, Tỉnh Nam Định","path_with_type":"Xã Đại Thắng, Huyện Vụ Bản, Tỉnh Nam Định","code":"13786","parent_code":"359"},"13789":{"name":"Xã Tam Thanh","type":"xa","slug":"xa-tam-thanh","name_with_type":"Xã Tam Thanh","path":"Xã Tam Thanh, Huyện Vụ Bản, Tỉnh Nam Định","path_with_type":"Xã Tam Thanh, Huyện Vụ Bản, Tỉnh Nam Định","code":"13789","parent_code":"359"},"13792":{"name":"Xã Vĩnh Hào","type":"xa","slug":"xa-vinh-hao","name_with_type":"Xã Vĩnh Hào","path":"Xã Vĩnh Hào, Huyện Vụ Bản, Tỉnh Nam Định","path_with_type":"Xã Vĩnh Hào, Huyện Vụ Bản, Tỉnh Nam Định","code":"13792","parent_code":"359"},"13795":{"name":"Thị trấn Lâm","type":"thi-tran","slug":"thi-tran-lam","name_with_type":"Thị trấn Lâm","path":"Thị trấn Lâm, Huyện Ý Yên, Tỉnh Nam Định","path_with_type":"Thị trấn Lâm, Huyện Ý Yên, Tỉnh Nam Định","code":"13795","parent_code":"360"},"13801":{"name":"Xã Trung Nghĩa","type":"xa","slug":"xa-trung-nghia","name_with_type":"Xã Trung Nghĩa","path":"Xã Trung Nghĩa, Huyện Ý Yên, Tỉnh Nam Định","path_with_type":"Xã Trung Nghĩa, Huyện Ý Yên, Tỉnh Nam Định","code":"13801","parent_code":"360"},"13807":{"name":"Xã Tân Minh","type":"xa","slug":"xa-tan-minh","name_with_type":"Xã Tân Minh","path":"Xã Tân Minh, Huyện Ý Yên, Tỉnh Nam Định","path_with_type":"Xã Tân Minh, Huyện Ý Yên, Tỉnh Nam Định","code":"13807","parent_code":"360"},"13810":{"name":"Xã Yên Thọ","type":"xa","slug":"xa-yen-tho","name_with_type":"Xã Yên Thọ","path":"Xã Yên Thọ, Huyện Ý Yên, Tỉnh Nam Định","path_with_type":"Xã Yên Thọ, Huyện Ý Yên, Tỉnh Nam Định","code":"13810","parent_code":"360"},"13819":{"name":"Xã Phú Hưng","type":"xa","slug":"xa-phu-hung","name_with_type":"Xã Phú Hưng","path":"Xã Phú Hưng, Huyện Ý Yên, Tỉnh Nam Định","path_with_type":"Xã Phú Hưng, Huyện Ý Yên, Tỉnh Nam Định","code":"13819","parent_code":"360"},"13822":{"name":"Xã Yên Chính","type":"xa","slug":"xa-yen-chinh","name_with_type":"Xã Yên Chính","path":"Xã Yên Chính, Huyện Ý Yên, Tỉnh Nam Định","path_with_type":"Xã Yên Chính, Huyện Ý Yên, Tỉnh Nam Định","code":"13822","parent_code":"360"},"13825":{"name":"Xã Yên Bình","type":"xa","slug":"xa-yen-binh","name_with_type":"Xã Yên Bình","path":"Xã Yên Bình, Huyện Ý Yên, Tỉnh Nam Định","path_with_type":"Xã Yên Bình, Huyện Ý Yên, Tỉnh Nam Định","code":"13825","parent_code":"360"},"13831":{"name":"Xã Yên Mỹ","type":"xa","slug":"xa-yen-my","name_with_type":"Xã Yên Mỹ","path":"Xã Yên Mỹ, Huyện Ý Yên, Tỉnh Nam Định","path_with_type":"Xã Yên Mỹ, Huyện Ý Yên, Tỉnh Nam Định","code":"13831","parent_code":"360"},"13834":{"name":"Xã Yên Dương","type":"xa","slug":"xa-yen-duong","name_with_type":"Xã Yên Dương","path":"Xã Yên Dương, Huyện Ý Yên, Tỉnh Nam Định","path_with_type":"Xã Yên Dương, Huyện Ý Yên, Tỉnh Nam Định","code":"13834","parent_code":"360"},"13843":{"name":"Xã Yên Khánh","type":"xa","slug":"xa-yen-khanh","name_with_type":"Xã Yên Khánh","path":"Xã Yên Khánh, Huyện Ý Yên, Tỉnh Nam Định","path_with_type":"Xã Yên Khánh, Huyện Ý Yên, Tỉnh Nam Định","code":"13843","parent_code":"360"},"13846":{"name":"Xã Yên Phong","type":"xa","slug":"xa-yen-phong","name_with_type":"Xã Yên Phong","path":"Xã Yên Phong, Huyện Ý Yên, Tỉnh Nam Định","path_with_type":"Xã Yên Phong, Huyện Ý Yên, Tỉnh Nam Định","code":"13846","parent_code":"360"},"13849":{"name":"Xã Yên Ninh","type":"xa","slug":"xa-yen-ninh","name_with_type":"Xã Yên Ninh","path":"Xã Yên Ninh, Huyện Ý Yên, Tỉnh Nam Định","path_with_type":"Xã Yên Ninh, Huyện Ý Yên, Tỉnh Nam Định","code":"13849","parent_code":"360"},"13852":{"name":"Xã Yên Lương","type":"xa","slug":"xa-yen-luong","name_with_type":"Xã Yên Lương","path":"Xã Yên Lương, Huyện Ý Yên, Tỉnh Nam Định","path_with_type":"Xã Yên Lương, Huyện Ý Yên, Tỉnh Nam Định","code":"13852","parent_code":"360"},"13861":{"name":"Xã Yên Tiến","type":"xa","slug":"xa-yen-tien","name_with_type":"Xã Yên Tiến","path":"Xã Yên Tiến, Huyện Ý Yên, Tỉnh Nam Định","path_with_type":"Xã Yên Tiến, Huyện Ý Yên, Tỉnh Nam Định","code":"13861","parent_code":"360"},"13864":{"name":"Xã Yên Thắng","type":"xa","slug":"xa-yen-thang","name_with_type":"Xã Yên Thắng","path":"Xã Yên Thắng, Huyện Ý Yên, Tỉnh Nam Định","path_with_type":"Xã Yên Thắng, Huyện Ý Yên, Tỉnh Nam Định","code":"13864","parent_code":"360"},"13867":{"name":"Xã Yên Phúc","type":"xa","slug":"xa-yen-phuc","name_with_type":"Xã Yên Phúc","path":"Xã Yên Phúc, Huyện Ý Yên, Tỉnh Nam Định","path_with_type":"Xã Yên Phúc, Huyện Ý Yên, Tỉnh Nam Định","code":"13867","parent_code":"360"},"13870":{"name":"Xã Yên Cường","type":"xa","slug":"xa-yen-cuong","name_with_type":"Xã Yên Cường","path":"Xã Yên Cường, Huyện Ý Yên, Tỉnh Nam Định","path_with_type":"Xã Yên Cường, Huyện Ý Yên, Tỉnh Nam Định","code":"13870","parent_code":"360"},"13873":{"name":"Xã Yên Lộc","type":"xa","slug":"xa-yen-loc","name_with_type":"Xã Yên Lộc","path":"Xã Yên Lộc, Huyện Ý Yên, Tỉnh Nam Định","path_with_type":"Xã Yên Lộc, Huyện Ý Yên, Tỉnh Nam Định","code":"13873","parent_code":"360"},"13876":{"name":"Xã Hồng Quang","type":"xa","slug":"xa-hong-quang","name_with_type":"Xã Hồng Quang","path":"Xã Hồng Quang, Huyện Ý Yên, Tỉnh Nam Định","path_with_type":"Xã Hồng Quang, Huyện Ý Yên, Tỉnh Nam Định","code":"13876","parent_code":"360"},"13879":{"name":"Xã Yên Đồng","type":"xa","slug":"xa-yen-dong","name_with_type":"Xã Yên Đồng","path":"Xã Yên Đồng, Huyện Ý Yên, Tỉnh Nam Định","path_with_type":"Xã Yên Đồng, Huyện Ý Yên, Tỉnh Nam Định","code":"13879","parent_code":"360"},"13882":{"name":"Xã Yên Khang","type":"xa","slug":"xa-yen-khang","name_with_type":"Xã Yên Khang","path":"Xã Yên Khang, Huyện Ý Yên, Tỉnh Nam Định","path_with_type":"Xã Yên Khang, Huyện Ý Yên, Tỉnh Nam Định","code":"13882","parent_code":"360"},"13885":{"name":"Xã Yên Nhân","type":"xa","slug":"xa-yen-nhan","name_with_type":"Xã Yên Nhân","path":"Xã Yên Nhân, Huyện Ý Yên, Tỉnh Nam Định","path_with_type":"Xã Yên Nhân, Huyện Ý Yên, Tỉnh Nam Định","code":"13885","parent_code":"360"},"13888":{"name":"Xã Yên Trị","type":"xa","slug":"xa-yen-tri","name_with_type":"Xã Yên Trị","path":"Xã Yên Trị, Huyện Ý Yên, Tỉnh Nam Định","path_with_type":"Xã Yên Trị, Huyện Ý Yên, Tỉnh Nam Định","code":"13888","parent_code":"360"},"13891":{"name":"Thị trấn Liễu Đề","type":"thi-tran","slug":"thi-tran-lieu-de","name_with_type":"Thị trấn Liễu Đề","path":"Thị trấn Liễu Đề, Huyện Nghĩa Hưng, Tỉnh Nam Định","path_with_type":"Thị trấn Liễu Đề, Huyện Nghĩa Hưng, Tỉnh Nam Định","code":"13891","parent_code":"361"},"13894":{"name":"Thị trấn Rạng Đông","type":"thi-tran","slug":"thi-tran-rang-dong","name_with_type":"Thị trấn Rạng Đông","path":"Thị trấn Rạng Đông, Huyện Nghĩa Hưng, Tỉnh Nam Định","path_with_type":"Thị trấn Rạng Đông, Huyện Nghĩa Hưng, Tỉnh Nam Định","code":"13894","parent_code":"361"},"13900":{"name":"Xã Đồng Thịnh","type":"xa","slug":"xa-dong-thinh","name_with_type":"Xã Đồng Thịnh","path":"Xã Đồng Thịnh, Huyện Nghĩa Hưng, Tỉnh Nam Định","path_with_type":"Xã Đồng Thịnh, Huyện Nghĩa Hưng, Tỉnh Nam Định","code":"13900","parent_code":"361"},"13906":{"name":"Xã Nghĩa Thái","type":"xa","slug":"xa-nghia-thai","name_with_type":"Xã Nghĩa Thái","path":"Xã Nghĩa Thái, Huyện Nghĩa Hưng, Tỉnh Nam Định","path_with_type":"Xã Nghĩa Thái, Huyện Nghĩa Hưng, Tỉnh Nam Định","code":"13906","parent_code":"361"},"13909":{"name":"Xã Hoàng Nam","type":"xa","slug":"xa-hoang-nam","name_with_type":"Xã Hoàng Nam","path":"Xã Hoàng Nam, Huyện Nghĩa Hưng, Tỉnh Nam Định","path_with_type":"Xã Hoàng Nam, Huyện Nghĩa Hưng, Tỉnh Nam Định","code":"13909","parent_code":"361"},"13912":{"name":"Xã Nghĩa Châu","type":"xa","slug":"xa-nghia-chau","name_with_type":"Xã Nghĩa Châu","path":"Xã Nghĩa Châu, Huyện Nghĩa Hưng, Tỉnh Nam Định","path_with_type":"Xã Nghĩa Châu, Huyện Nghĩa Hưng, Tỉnh Nam Định","code":"13912","parent_code":"361"},"13915":{"name":"Xã Nghĩa Trung","type":"xa","slug":"xa-nghia-trung","name_with_type":"Xã Nghĩa Trung","path":"Xã Nghĩa Trung, Huyện Nghĩa Hưng, Tỉnh Nam Định","path_with_type":"Xã Nghĩa Trung, Huyện Nghĩa Hưng, Tỉnh Nam Định","code":"13915","parent_code":"361"},"13918":{"name":"Xã Nghĩa Sơn","type":"xa","slug":"xa-nghia-son","name_with_type":"Xã Nghĩa Sơn","path":"Xã Nghĩa Sơn, Huyện Nghĩa Hưng, Tỉnh Nam Định","path_with_type":"Xã Nghĩa Sơn, Huyện Nghĩa Hưng, Tỉnh Nam Định","code":"13918","parent_code":"361"},"13921":{"name":"Xã Nghĩa Lạc","type":"xa","slug":"xa-nghia-lac","name_with_type":"Xã Nghĩa Lạc","path":"Xã Nghĩa Lạc, Huyện Nghĩa Hưng, Tỉnh Nam Định","path_with_type":"Xã Nghĩa Lạc, Huyện Nghĩa Hưng, Tỉnh Nam Định","code":"13921","parent_code":"361"},"13924":{"name":"Xã Nghĩa Hồng","type":"xa","slug":"xa-nghia-hong","name_with_type":"Xã Nghĩa Hồng","path":"Xã Nghĩa Hồng, Huyện Nghĩa Hưng, Tỉnh Nam Định","path_with_type":"Xã Nghĩa Hồng, Huyện Nghĩa Hưng, Tỉnh Nam Định","code":"13924","parent_code":"361"},"13927":{"name":"Xã Nghĩa Phong","type":"xa","slug":"xa-nghia-phong","name_with_type":"Xã Nghĩa Phong","path":"Xã Nghĩa Phong, Huyện Nghĩa Hưng, Tỉnh Nam Định","path_with_type":"Xã Nghĩa Phong, Huyện Nghĩa Hưng, Tỉnh Nam Định","code":"13927","parent_code":"361"},"13930":{"name":"Xã Nghĩa Phú","type":"xa","slug":"xa-nghia-phu","name_with_type":"Xã Nghĩa Phú","path":"Xã Nghĩa Phú, Huyện Nghĩa Hưng, Tỉnh Nam Định","path_with_type":"Xã Nghĩa Phú, Huyện Nghĩa Hưng, Tỉnh Nam Định","code":"13930","parent_code":"361"},"13939":{"name":"Thị trấn Quỹ Nhất","type":"thi-tran","slug":"thi-tran-quy-nhat","name_with_type":"Thị trấn Quỹ Nhất","path":"Thị trấn Quỹ Nhất, Huyện Nghĩa Hưng, Tỉnh Nam Định","path_with_type":"Thị trấn Quỹ Nhất, Huyện Nghĩa Hưng, Tỉnh Nam Định","code":"13939","parent_code":"361"},"13942":{"name":"Xã Nghĩa Hùng","type":"xa","slug":"xa-nghia-hung","name_with_type":"Xã Nghĩa Hùng","path":"Xã Nghĩa Hùng, Huyện Nghĩa Hưng, Tỉnh Nam Định","path_with_type":"Xã Nghĩa Hùng, Huyện Nghĩa Hưng, Tỉnh Nam Định","code":"13942","parent_code":"361"},"13945":{"name":"Xã Nghĩa Lâm","type":"xa","slug":"xa-nghia-lam","name_with_type":"Xã Nghĩa Lâm","path":"Xã Nghĩa Lâm, Huyện Nghĩa Hưng, Tỉnh Nam Định","path_with_type":"Xã Nghĩa Lâm, Huyện Nghĩa Hưng, Tỉnh Nam Định","code":"13945","parent_code":"361"},"13948":{"name":"Xã Nghĩa Thành","type":"xa","slug":"xa-nghia-thanh","name_with_type":"Xã Nghĩa Thành","path":"Xã Nghĩa Thành, Huyện Nghĩa Hưng, Tỉnh Nam Định","path_with_type":"Xã Nghĩa Thành, Huyện Nghĩa Hưng, Tỉnh Nam Định","code":"13948","parent_code":"361"},"13951":{"name":"Xã Phúc Thắng","type":"xa","slug":"xa-phuc-thang","name_with_type":"Xã Phúc Thắng","path":"Xã Phúc Thắng, Huyện Nghĩa Hưng, Tỉnh Nam Định","path_with_type":"Xã Phúc Thắng, Huyện Nghĩa Hưng, Tỉnh Nam Định","code":"13951","parent_code":"361"},"13954":{"name":"Xã Nghĩa Lợi","type":"xa","slug":"xa-nghia-loi","name_with_type":"Xã Nghĩa Lợi","path":"Xã Nghĩa Lợi, Huyện Nghĩa Hưng, Tỉnh Nam Định","path_with_type":"Xã Nghĩa Lợi, Huyện Nghĩa Hưng, Tỉnh Nam Định","code":"13954","parent_code":"361"},"13957":{"name":"Xã Nghĩa Hải","type":"xa","slug":"xa-nghia-hai","name_with_type":"Xã Nghĩa Hải","path":"Xã Nghĩa Hải, Huyện Nghĩa Hưng, Tỉnh Nam Định","path_with_type":"Xã Nghĩa Hải, Huyện Nghĩa Hưng, Tỉnh Nam Định","code":"13957","parent_code":"361"},"13963":{"name":"Xã Nam Điền","type":"xa","slug":"xa-nam-dien","name_with_type":"Xã Nam Điền","path":"Xã Nam Điền, Huyện Nghĩa Hưng, Tỉnh Nam Định","path_with_type":"Xã Nam Điền, Huyện Nghĩa Hưng, Tỉnh Nam Định","code":"13963","parent_code":"361"},"13966":{"name":"Thị trấn Nam Giang","type":"thi-tran","slug":"thi-tran-nam-giang","name_with_type":"Thị trấn Nam Giang","path":"Thị trấn Nam Giang, Huyện Nam Trực, Tỉnh Nam Định","path_with_type":"Thị trấn Nam Giang, Huyện Nam Trực, Tỉnh Nam Định","code":"13966","parent_code":"362"},"13972":{"name":"Xã Nam Điền","type":"xa","slug":"xa-nam-dien","name_with_type":"Xã Nam Điền","path":"Xã Nam Điền, Huyện Nam Trực, Tỉnh Nam Định","path_with_type":"Xã Nam Điền, Huyện Nam Trực, Tỉnh Nam Định","code":"13972","parent_code":"362"},"13975":{"name":"Xã Nghĩa An","type":"xa","slug":"xa-nghia-an","name_with_type":"Xã Nghĩa An","path":"Xã Nghĩa An, Huyện Nam Trực, Tỉnh Nam Định","path_with_type":"Xã Nghĩa An, Huyện Nam Trực, Tỉnh Nam Định","code":"13975","parent_code":"362"},"13978":{"name":"Xã Nam Thắng","type":"xa","slug":"xa-nam-thang","name_with_type":"Xã Nam Thắng","path":"Xã Nam Thắng, Huyện Nam Trực, Tỉnh Nam Định","path_with_type":"Xã Nam Thắng, Huyện Nam Trực, Tỉnh Nam Định","code":"13978","parent_code":"362"},"13984":{"name":"Xã Hồng Quang","type":"xa","slug":"xa-hong-quang","name_with_type":"Xã Hồng Quang","path":"Xã Hồng Quang, Huyện Nam Trực, Tỉnh Nam Định","path_with_type":"Xã Hồng Quang, Huyện Nam Trực, Tỉnh Nam Định","code":"13984","parent_code":"362"},"13987":{"name":"Xã Tân Thịnh","type":"xa","slug":"xa-tan-thinh","name_with_type":"Xã Tân Thịnh","path":"Xã Tân Thịnh, Huyện Nam Trực, Tỉnh Nam Định","path_with_type":"Xã Tân Thịnh, Huyện Nam Trực, Tỉnh Nam Định","code":"13987","parent_code":"362"},"13990":{"name":"Xã Nam Cường","type":"xa","slug":"xa-nam-cuong","name_with_type":"Xã Nam Cường","path":"Xã Nam Cường, Huyện Nam Trực, Tỉnh Nam Định","path_with_type":"Xã Nam Cường, Huyện Nam Trực, Tỉnh Nam Định","code":"13990","parent_code":"362"},"13993":{"name":"Xã Nam Hồng","type":"xa","slug":"xa-nam-hong","name_with_type":"Xã Nam Hồng","path":"Xã Nam Hồng, Huyện Nam Trực, Tỉnh Nam Định","path_with_type":"Xã Nam Hồng, Huyện Nam Trực, Tỉnh Nam Định","code":"13993","parent_code":"362"},"13996":{"name":"Xã Nam Hùng","type":"xa","slug":"xa-nam-hung","name_with_type":"Xã Nam Hùng","path":"Xã Nam Hùng, Huyện Nam Trực, Tỉnh Nam Định","path_with_type":"Xã Nam Hùng, Huyện Nam Trực, Tỉnh Nam Định","code":"13996","parent_code":"362"},"13999":{"name":"Xã Nam Hoa","type":"xa","slug":"xa-nam-hoa","name_with_type":"Xã Nam Hoa","path":"Xã Nam Hoa, Huyện Nam Trực, Tỉnh Nam Định","path_with_type":"Xã Nam Hoa, Huyện Nam Trực, Tỉnh Nam Định","code":"13999","parent_code":"362"},"14002":{"name":"Xã Nam Dương","type":"xa","slug":"xa-nam-duong","name_with_type":"Xã Nam Dương","path":"Xã Nam Dương, Huyện Nam Trực, Tỉnh Nam Định","path_with_type":"Xã Nam Dương, Huyện Nam Trực, Tỉnh Nam Định","code":"14002","parent_code":"362"},"14005":{"name":"Xã Nam Thanh","type":"xa","slug":"xa-nam-thanh","name_with_type":"Xã Nam Thanh","path":"Xã Nam Thanh, Huyện Nam Trực, Tỉnh Nam Định","path_with_type":"Xã Nam Thanh, Huyện Nam Trực, Tỉnh Nam Định","code":"14005","parent_code":"362"},"14008":{"name":"Xã Nam Lợi","type":"xa","slug":"xa-nam-loi","name_with_type":"Xã Nam Lợi","path":"Xã Nam Lợi, Huyện Nam Trực, Tỉnh Nam Định","path_with_type":"Xã Nam Lợi, Huyện Nam Trực, Tỉnh Nam Định","code":"14008","parent_code":"362"},"14011":{"name":"Xã Bình Minh","type":"xa","slug":"xa-binh-minh","name_with_type":"Xã Bình Minh","path":"Xã Bình Minh, Huyện Nam Trực, Tỉnh Nam Định","path_with_type":"Xã Bình Minh, Huyện Nam Trực, Tỉnh Nam Định","code":"14011","parent_code":"362"},"14014":{"name":"Xã Đồng Sơn","type":"xa","slug":"xa-dong-son","name_with_type":"Xã Đồng Sơn","path":"Xã Đồng Sơn, Huyện Nam Trực, Tỉnh Nam Định","path_with_type":"Xã Đồng Sơn, Huyện Nam Trực, Tỉnh Nam Định","code":"14014","parent_code":"362"},"14017":{"name":"Xã Nam Tiến","type":"xa","slug":"xa-nam-tien","name_with_type":"Xã Nam Tiến","path":"Xã Nam Tiến, Huyện Nam Trực, Tỉnh Nam Định","path_with_type":"Xã Nam Tiến, Huyện Nam Trực, Tỉnh Nam Định","code":"14017","parent_code":"362"},"14020":{"name":"Xã Nam Hải","type":"xa","slug":"xa-nam-hai","name_with_type":"Xã Nam Hải","path":"Xã Nam Hải, Huyện Nam Trực, Tỉnh Nam Định","path_with_type":"Xã Nam Hải, Huyện Nam Trực, Tỉnh Nam Định","code":"14020","parent_code":"362"},"14023":{"name":"Xã Nam Thái","type":"xa","slug":"xa-nam-thai","name_with_type":"Xã Nam Thái","path":"Xã Nam Thái, Huyện Nam Trực, Tỉnh Nam Định","path_with_type":"Xã Nam Thái, Huyện Nam Trực, Tỉnh Nam Định","code":"14023","parent_code":"362"},"14026":{"name":"Thị trấn Cổ Lễ","type":"thi-tran","slug":"thi-tran-co-le","name_with_type":"Thị trấn Cổ Lễ","path":"Thị trấn Cổ Lễ, Huyện Trực Ninh, Tỉnh Nam Định","path_with_type":"Thị trấn Cổ Lễ, Huyện Trực Ninh, Tỉnh Nam Định","code":"14026","parent_code":"363"},"14029":{"name":"Xã Phương Định","type":"xa","slug":"xa-phuong-dinh","name_with_type":"Xã Phương Định","path":"Xã Phương Định, Huyện Trực Ninh, Tỉnh Nam Định","path_with_type":"Xã Phương Định, Huyện Trực Ninh, Tỉnh Nam Định","code":"14029","parent_code":"363"},"14032":{"name":"Xã Trực Chính","type":"xa","slug":"xa-truc-chinh","name_with_type":"Xã Trực Chính","path":"Xã Trực Chính, Huyện Trực Ninh, Tỉnh Nam Định","path_with_type":"Xã Trực Chính, Huyện Trực Ninh, Tỉnh Nam Định","code":"14032","parent_code":"363"},"14035":{"name":"Xã Trung Đông","type":"xa","slug":"xa-trung-dong","name_with_type":"Xã Trung Đông","path":"Xã Trung Đông, Huyện Trực Ninh, Tỉnh Nam Định","path_with_type":"Xã Trung Đông, Huyện Trực Ninh, Tỉnh Nam Định","code":"14035","parent_code":"363"},"14038":{"name":"Xã Liêm Hải","type":"xa","slug":"xa-liem-hai","name_with_type":"Xã Liêm Hải","path":"Xã Liêm Hải, Huyện Trực Ninh, Tỉnh Nam Định","path_with_type":"Xã Liêm Hải, Huyện Trực Ninh, Tỉnh Nam Định","code":"14038","parent_code":"363"},"14041":{"name":"Xã Trực Tuấn","type":"xa","slug":"xa-truc-tuan","name_with_type":"Xã Trực Tuấn","path":"Xã Trực Tuấn, Huyện Trực Ninh, Tỉnh Nam Định","path_with_type":"Xã Trực Tuấn, Huyện Trực Ninh, Tỉnh Nam Định","code":"14041","parent_code":"363"},"14044":{"name":"Xã Việt Hùng","type":"xa","slug":"xa-viet-hung","name_with_type":"Xã Việt Hùng","path":"Xã Việt Hùng, Huyện Trực Ninh, Tỉnh Nam Định","path_with_type":"Xã Việt Hùng, Huyện Trực Ninh, Tỉnh Nam Định","code":"14044","parent_code":"363"},"14047":{"name":"Xã Trực Đạo","type":"xa","slug":"xa-truc-dao","name_with_type":"Xã Trực Đạo","path":"Xã Trực Đạo, Huyện Trực Ninh, Tỉnh Nam Định","path_with_type":"Xã Trực Đạo, Huyện Trực Ninh, Tỉnh Nam Định","code":"14047","parent_code":"363"},"14050":{"name":"Xã Trực Hưng","type":"xa","slug":"xa-truc-hung","name_with_type":"Xã Trực Hưng","path":"Xã Trực Hưng, Huyện Trực Ninh, Tỉnh Nam Định","path_with_type":"Xã Trực Hưng, Huyện Trực Ninh, Tỉnh Nam Định","code":"14050","parent_code":"363"},"14053":{"name":"Xã Trực Nội","type":"xa","slug":"xa-truc-noi","name_with_type":"Xã Trực Nội","path":"Xã Trực Nội, Huyện Trực Ninh, Tỉnh Nam Định","path_with_type":"Xã Trực Nội, Huyện Trực Ninh, Tỉnh Nam Định","code":"14053","parent_code":"363"},"14056":{"name":"Thị trấn Cát Thành","type":"thi-tran","slug":"thi-tran-cat-thanh","name_with_type":"Thị trấn Cát Thành","path":"Thị trấn Cát Thành, Huyện Trực Ninh, Tỉnh Nam Định","path_with_type":"Thị trấn Cát Thành, Huyện Trực Ninh, Tỉnh Nam Định","code":"14056","parent_code":"363"},"14059":{"name":"Xã Trực Thanh","type":"xa","slug":"xa-truc-thanh","name_with_type":"Xã Trực Thanh","path":"Xã Trực Thanh, Huyện Trực Ninh, Tỉnh Nam Định","path_with_type":"Xã Trực Thanh, Huyện Trực Ninh, Tỉnh Nam Định","code":"14059","parent_code":"363"},"14062":{"name":"Xã Trực Khang","type":"xa","slug":"xa-truc-khang","name_with_type":"Xã Trực Khang","path":"Xã Trực Khang, Huyện Trực Ninh, Tỉnh Nam Định","path_with_type":"Xã Trực Khang, Huyện Trực Ninh, Tỉnh Nam Định","code":"14062","parent_code":"363"},"14065":{"name":"Xã Trực Thuận","type":"xa","slug":"xa-truc-thuan","name_with_type":"Xã Trực Thuận","path":"Xã Trực Thuận, Huyện Trực Ninh, Tỉnh Nam Định","path_with_type":"Xã Trực Thuận, Huyện Trực Ninh, Tỉnh Nam Định","code":"14065","parent_code":"363"},"14068":{"name":"Xã Trực Mỹ","type":"xa","slug":"xa-truc-my","name_with_type":"Xã Trực Mỹ","path":"Xã Trực Mỹ, Huyện Trực Ninh, Tỉnh Nam Định","path_with_type":"Xã Trực Mỹ, Huyện Trực Ninh, Tỉnh Nam Định","code":"14068","parent_code":"363"},"14071":{"name":"Xã Trực Đại","type":"xa","slug":"xa-truc-dai","name_with_type":"Xã Trực Đại","path":"Xã Trực Đại, Huyện Trực Ninh, Tỉnh Nam Định","path_with_type":"Xã Trực Đại, Huyện Trực Ninh, Tỉnh Nam Định","code":"14071","parent_code":"363"},"14074":{"name":"Xã Trực Cường","type":"xa","slug":"xa-truc-cuong","name_with_type":"Xã Trực Cường","path":"Xã Trực Cường, Huyện Trực Ninh, Tỉnh Nam Định","path_with_type":"Xã Trực Cường, Huyện Trực Ninh, Tỉnh Nam Định","code":"14074","parent_code":"363"},"14077":{"name":"Thị trấn Ninh Cường","type":"thi-tran","slug":"thi-tran-ninh-cuong","name_with_type":"Thị trấn Ninh Cường","path":"Thị trấn Ninh Cường, Huyện Trực Ninh, Tỉnh Nam Định","path_with_type":"Thị trấn Ninh Cường, Huyện Trực Ninh, Tỉnh Nam Định","code":"14077","parent_code":"363"},"14080":{"name":"Xã Trực Thái","type":"xa","slug":"xa-truc-thai","name_with_type":"Xã Trực Thái","path":"Xã Trực Thái, Huyện Trực Ninh, Tỉnh Nam Định","path_with_type":"Xã Trực Thái, Huyện Trực Ninh, Tỉnh Nam Định","code":"14080","parent_code":"363"},"14083":{"name":"Xã Trực Hùng","type":"xa","slug":"xa-truc-hung","name_with_type":"Xã Trực Hùng","path":"Xã Trực Hùng, Huyện Trực Ninh, Tỉnh Nam Định","path_with_type":"Xã Trực Hùng, Huyện Trực Ninh, Tỉnh Nam Định","code":"14083","parent_code":"363"},"14086":{"name":"Xã Trực Thắng","type":"xa","slug":"xa-truc-thang","name_with_type":"Xã Trực Thắng","path":"Xã Trực Thắng, Huyện Trực Ninh, Tỉnh Nam Định","path_with_type":"Xã Trực Thắng, Huyện Trực Ninh, Tỉnh Nam Định","code":"14086","parent_code":"363"},"14089":{"name":"Thị trấn Xuân Trường","type":"thi-tran","slug":"thi-tran-xuan-truong","name_with_type":"Thị trấn Xuân Trường","path":"Thị trấn Xuân Trường, Huyện Xuân Trường, Tỉnh Nam Định","path_with_type":"Thị trấn Xuân Trường, Huyện Xuân Trường, Tỉnh Nam Định","code":"14089","parent_code":"364"},"14092":{"name":"Xã Xuân Châu","type":"xa","slug":"xa-xuan-chau","name_with_type":"Xã Xuân Châu","path":"Xã Xuân Châu, Huyện Xuân Trường, Tỉnh Nam Định","path_with_type":"Xã Xuân Châu, Huyện Xuân Trường, Tỉnh Nam Định","code":"14092","parent_code":"364"},"14095":{"name":"Xã Xuân Hồng","type":"xa","slug":"xa-xuan-hong","name_with_type":"Xã Xuân Hồng","path":"Xã Xuân Hồng, Huyện Xuân Trường, Tỉnh Nam Định","path_with_type":"Xã Xuân Hồng, Huyện Xuân Trường, Tỉnh Nam Định","code":"14095","parent_code":"364"},"14098":{"name":"Xã Xuân Thành","type":"xa","slug":"xa-xuan-thanh","name_with_type":"Xã Xuân Thành","path":"Xã Xuân Thành, Huyện Xuân Trường, Tỉnh Nam Định","path_with_type":"Xã Xuân Thành, Huyện Xuân Trường, Tỉnh Nam Định","code":"14098","parent_code":"364"},"14101":{"name":"Xã Xuân Thượng","type":"xa","slug":"xa-xuan-thuong","name_with_type":"Xã Xuân Thượng","path":"Xã Xuân Thượng, Huyện Xuân Trường, Tỉnh Nam Định","path_with_type":"Xã Xuân Thượng, Huyện Xuân Trường, Tỉnh Nam Định","code":"14101","parent_code":"364"},"14104":{"name":"Xã Xuân Giang","type":"xa","slug":"xa-xuan-giang","name_with_type":"Xã Xuân Giang","path":"Xã Xuân Giang, Huyện Xuân Trường, Tỉnh Nam Định","path_with_type":"Xã Xuân Giang, Huyện Xuân Trường, Tỉnh Nam Định","code":"14104","parent_code":"364"},"14110":{"name":"Xã Xuân Tân","type":"xa","slug":"xa-xuan-tan","name_with_type":"Xã Xuân Tân","path":"Xã Xuân Tân, Huyện Xuân Trường, Tỉnh Nam Định","path_with_type":"Xã Xuân Tân, Huyện Xuân Trường, Tỉnh Nam Định","code":"14110","parent_code":"364"},"14116":{"name":"Xã Xuân Ngọc","type":"xa","slug":"xa-xuan-ngoc","name_with_type":"Xã Xuân Ngọc","path":"Xã Xuân Ngọc, Huyện Xuân Trường, Tỉnh Nam Định","path_with_type":"Xã Xuân Ngọc, Huyện Xuân Trường, Tỉnh Nam Định","code":"14116","parent_code":"364"},"14122":{"name":"Xã Trà Lũ","type":"xa","slug":"xa-tra-lu","name_with_type":"Xã Trà Lũ","path":"Xã Trà Lũ, Huyện Xuân Trường, Tỉnh Nam Định","path_with_type":"Xã Trà Lũ, Huyện Xuân Trường, Tỉnh Nam Định","code":"14122","parent_code":"364"},"14125":{"name":"Xã Thọ Nghiệp","type":"xa","slug":"xa-tho-nghiep","name_with_type":"Xã Thọ Nghiệp","path":"Xã Thọ Nghiệp, Huyện Xuân Trường, Tỉnh Nam Định","path_with_type":"Xã Thọ Nghiệp, Huyện Xuân Trường, Tỉnh Nam Định","code":"14125","parent_code":"364"},"14128":{"name":"Xã Xuân Phú","type":"xa","slug":"xa-xuan-phu","name_with_type":"Xã Xuân Phú","path":"Xã Xuân Phú, Huyện Xuân Trường, Tỉnh Nam Định","path_with_type":"Xã Xuân Phú, Huyện Xuân Trường, Tỉnh Nam Định","code":"14128","parent_code":"364"},"14134":{"name":"Xã Xuân Vinh","type":"xa","slug":"xa-xuan-vinh","name_with_type":"Xã Xuân Vinh","path":"Xã Xuân Vinh, Huyện Xuân Trường, Tỉnh Nam Định","path_with_type":"Xã Xuân Vinh, Huyện Xuân Trường, Tỉnh Nam Định","code":"14134","parent_code":"364"},"14143":{"name":"Xã Xuân Ninh","type":"xa","slug":"xa-xuan-ninh","name_with_type":"Xã Xuân Ninh","path":"Xã Xuân Ninh, Huyện Xuân Trường, Tỉnh Nam Định","path_with_type":"Xã Xuân Ninh, Huyện Xuân Trường, Tỉnh Nam Định","code":"14143","parent_code":"364"},"14146":{"name":"Xã Xuân Phúc","type":"xa","slug":"xa-xuan-phuc","name_with_type":"Xã Xuân Phúc","path":"Xã Xuân Phúc, Huyện Xuân Trường, Tỉnh Nam Định","path_with_type":"Xã Xuân Phúc, Huyện Xuân Trường, Tỉnh Nam Định","code":"14146","parent_code":"364"},"14152":{"name":"Thị trấn Quất Lâm","type":"thi-tran","slug":"thi-tran-quat-lam","name_with_type":"Thị trấn Quất Lâm","path":"Thị trấn Quất Lâm, Huyện Giao Thủy, Tỉnh Nam Định","path_with_type":"Thị trấn Quất Lâm, Huyện Giao Thủy, Tỉnh Nam Định","code":"14152","parent_code":"365"},"14155":{"name":"Xã Giao Hương","type":"xa","slug":"xa-giao-huong","name_with_type":"Xã Giao Hương","path":"Xã Giao Hương, Huyện Giao Thủy, Tỉnh Nam Định","path_with_type":"Xã Giao Hương, Huyện Giao Thủy, Tỉnh Nam Định","code":"14155","parent_code":"365"},"14158":{"name":"Xã Hồng Thuận","type":"xa","slug":"xa-hong-thuan","name_with_type":"Xã Hồng Thuận","path":"Xã Hồng Thuận, Huyện Giao Thủy, Tỉnh Nam Định","path_with_type":"Xã Hồng Thuận, Huyện Giao Thủy, Tỉnh Nam Định","code":"14158","parent_code":"365"},"14161":{"name":"Xã Giao Thiện","type":"xa","slug":"xa-giao-thien","name_with_type":"Xã Giao Thiện","path":"Xã Giao Thiện, Huyện Giao Thủy, Tỉnh Nam Định","path_with_type":"Xã Giao Thiện, Huyện Giao Thủy, Tỉnh Nam Định","code":"14161","parent_code":"365"},"14164":{"name":"Xã Giao Thanh","type":"xa","slug":"xa-giao-thanh","name_with_type":"Xã Giao Thanh","path":"Xã Giao Thanh, Huyện Giao Thủy, Tỉnh Nam Định","path_with_type":"Xã Giao Thanh, Huyện Giao Thủy, Tỉnh Nam Định","code":"14164","parent_code":"365"},"14167":{"name":"Thị trấn Giao Thủy","type":"thi-tran","slug":"thi-tran-giao-thuy","name_with_type":"Thị trấn Giao Thủy","path":"Thị trấn Giao Thủy, Huyện Giao Thủy, Tỉnh Nam Định","path_with_type":"Thị trấn Giao Thủy, Huyện Giao Thủy, Tỉnh Nam Định","code":"14167","parent_code":"365"},"14170":{"name":"Xã Bình Hòa","type":"xa","slug":"xa-binh-hoa","name_with_type":"Xã Bình Hòa","path":"Xã Bình Hòa, Huyện Giao Thủy, Tỉnh Nam Định","path_with_type":"Xã Bình Hòa, Huyện Giao Thủy, Tỉnh Nam Định","code":"14170","parent_code":"365"},"14176":{"name":"Xã Giao Hà","type":"xa","slug":"xa-giao-ha","name_with_type":"Xã Giao Hà","path":"Xã Giao Hà, Huyện Giao Thủy, Tỉnh Nam Định","path_with_type":"Xã Giao Hà, Huyện Giao Thủy, Tỉnh Nam Định","code":"14176","parent_code":"365"},"14179":{"name":"Xã Giao Nhân","type":"xa","slug":"xa-giao-nhan","name_with_type":"Xã Giao Nhân","path":"Xã Giao Nhân, Huyện Giao Thủy, Tỉnh Nam Định","path_with_type":"Xã Giao Nhân, Huyện Giao Thủy, Tỉnh Nam Định","code":"14179","parent_code":"365"},"14182":{"name":"Xã Giao An","type":"xa","slug":"xa-giao-an","name_with_type":"Xã Giao An","path":"Xã Giao An, Huyện Giao Thủy, Tỉnh Nam Định","path_with_type":"Xã Giao An, Huyện Giao Thủy, Tỉnh Nam Định","code":"14182","parent_code":"365"},"14185":{"name":"Xã Giao Lạc","type":"xa","slug":"xa-giao-lac","name_with_type":"Xã Giao Lạc","path":"Xã Giao Lạc, Huyện Giao Thủy, Tỉnh Nam Định","path_with_type":"Xã Giao Lạc, Huyện Giao Thủy, Tỉnh Nam Định","code":"14185","parent_code":"365"},"14188":{"name":"Xã Giao Châu","type":"xa","slug":"xa-giao-chau","name_with_type":"Xã Giao Châu","path":"Xã Giao Châu, Huyện Giao Thủy, Tỉnh Nam Định","path_with_type":"Xã Giao Châu, Huyện Giao Thủy, Tỉnh Nam Định","code":"14188","parent_code":"365"},"14191":{"name":"Xã Giao Tân","type":"xa","slug":"xa-giao-tan","name_with_type":"Xã Giao Tân","path":"Xã Giao Tân, Huyện Giao Thủy, Tỉnh Nam Định","path_with_type":"Xã Giao Tân, Huyện Giao Thủy, Tỉnh Nam Định","code":"14191","parent_code":"365"},"14194":{"name":"Xã Giao Yến","type":"xa","slug":"xa-giao-yen","name_with_type":"Xã Giao Yến","path":"Xã Giao Yến, Huyện Giao Thủy, Tỉnh Nam Định","path_with_type":"Xã Giao Yến, Huyện Giao Thủy, Tỉnh Nam Định","code":"14194","parent_code":"365"},"14197":{"name":"Xã Giao Xuân","type":"xa","slug":"xa-giao-xuan","name_with_type":"Xã Giao Xuân","path":"Xã Giao Xuân, Huyện Giao Thủy, Tỉnh Nam Định","path_with_type":"Xã Giao Xuân, Huyện Giao Thủy, Tỉnh Nam Định","code":"14197","parent_code":"365"},"14200":{"name":"Xã Giao Thịnh","type":"xa","slug":"xa-giao-thinh","name_with_type":"Xã Giao Thịnh","path":"Xã Giao Thịnh, Huyện Giao Thủy, Tỉnh Nam Định","path_with_type":"Xã Giao Thịnh, Huyện Giao Thủy, Tỉnh Nam Định","code":"14200","parent_code":"365"},"14203":{"name":"Xã Giao Hải","type":"xa","slug":"xa-giao-hai","name_with_type":"Xã Giao Hải","path":"Xã Giao Hải, Huyện Giao Thủy, Tỉnh Nam Định","path_with_type":"Xã Giao Hải, Huyện Giao Thủy, Tỉnh Nam Định","code":"14203","parent_code":"365"},"14206":{"name":"Xã Bạch Long","type":"xa","slug":"xa-bach-long","name_with_type":"Xã Bạch Long","path":"Xã Bạch Long, Huyện Giao Thủy, Tỉnh Nam Định","path_with_type":"Xã Bạch Long, Huyện Giao Thủy, Tỉnh Nam Định","code":"14206","parent_code":"365"},"14209":{"name":"Xã Giao Long","type":"xa","slug":"xa-giao-long","name_with_type":"Xã Giao Long","path":"Xã Giao Long, Huyện Giao Thủy, Tỉnh Nam Định","path_with_type":"Xã Giao Long, Huyện Giao Thủy, Tỉnh Nam Định","code":"14209","parent_code":"365"},"14212":{"name":"Xã Giao Phong","type":"xa","slug":"xa-giao-phong","name_with_type":"Xã Giao Phong","path":"Xã Giao Phong, Huyện Giao Thủy, Tỉnh Nam Định","path_with_type":"Xã Giao Phong, Huyện Giao Thủy, Tỉnh Nam Định","code":"14212","parent_code":"365"},"14215":{"name":"Thị trấn Yên Định","type":"thi-tran","slug":"thi-tran-yen-dinh","name_with_type":"Thị trấn Yên Định","path":"Thị trấn Yên Định, Huyện Hải Hậu, Tỉnh Nam Định","path_with_type":"Thị trấn Yên Định, Huyện Hải Hậu, Tỉnh Nam Định","code":"14215","parent_code":"366"},"14218":{"name":"Thị trấn Cồn","type":"thi-tran","slug":"thi-tran-con","name_with_type":"Thị trấn Cồn","path":"Thị trấn Cồn, Huyện Hải Hậu, Tỉnh Nam Định","path_with_type":"Thị trấn Cồn, Huyện Hải Hậu, Tỉnh Nam Định","code":"14218","parent_code":"366"},"14221":{"name":"Thị trấn Thịnh Long","type":"thi-tran","slug":"thi-tran-thinh-long","name_with_type":"Thị trấn Thịnh Long","path":"Thị trấn Thịnh Long, Huyện Hải Hậu, Tỉnh Nam Định","path_with_type":"Thị trấn Thịnh Long, Huyện Hải Hậu, Tỉnh Nam Định","code":"14221","parent_code":"366"},"14224":{"name":"Xã Hải Nam","type":"xa","slug":"xa-hai-nam","name_with_type":"Xã Hải Nam","path":"Xã Hải Nam, Huyện Hải Hậu, Tỉnh Nam Định","path_with_type":"Xã Hải Nam, Huyện Hải Hậu, Tỉnh Nam Định","code":"14224","parent_code":"366"},"14227":{"name":"Xã Hải Trung","type":"xa","slug":"xa-hai-trung","name_with_type":"Xã Hải Trung","path":"Xã Hải Trung, Huyện Hải Hậu, Tỉnh Nam Định","path_with_type":"Xã Hải Trung, Huyện Hải Hậu, Tỉnh Nam Định","code":"14227","parent_code":"366"},"14233":{"name":"Xã Hải Minh","type":"xa","slug":"xa-hai-minh","name_with_type":"Xã Hải Minh","path":"Xã Hải Minh, Huyện Hải Hậu, Tỉnh Nam Định","path_with_type":"Xã Hải Minh, Huyện Hải Hậu, Tỉnh Nam Định","code":"14233","parent_code":"366"},"14236":{"name":"Xã Hải Anh","type":"xa","slug":"xa-hai-anh","name_with_type":"Xã Hải Anh","path":"Xã Hải Anh, Huyện Hải Hậu, Tỉnh Nam Định","path_with_type":"Xã Hải Anh, Huyện Hải Hậu, Tỉnh Nam Định","code":"14236","parent_code":"366"},"14248":{"name":"Xã Hải Hưng","type":"xa","slug":"xa-hai-hung","name_with_type":"Xã Hải Hưng","path":"Xã Hải Hưng, Huyện Hải Hậu, Tỉnh Nam Định","path_with_type":"Xã Hải Hưng, Huyện Hải Hậu, Tỉnh Nam Định","code":"14248","parent_code":"366"},"14254":{"name":"Xã Hải Long","type":"xa","slug":"xa-hai-long","name_with_type":"Xã Hải Long","path":"Xã Hải Long, Huyện Hải Hậu, Tỉnh Nam Định","path_with_type":"Xã Hải Long, Huyện Hải Hậu, Tỉnh Nam Định","code":"14254","parent_code":"366"},"14260":{"name":"Xã Hải Đường","type":"xa","slug":"xa-hai-duong","name_with_type":"Xã Hải Đường","path":"Xã Hải Đường, Huyện Hải Hậu, Tỉnh Nam Định","path_with_type":"Xã Hải Đường, Huyện Hải Hậu, Tỉnh Nam Định","code":"14260","parent_code":"366"},"14263":{"name":"Xã Hải Lộc","type":"xa","slug":"xa-hai-loc","name_with_type":"Xã Hải Lộc","path":"Xã Hải Lộc, Huyện Hải Hậu, Tỉnh Nam Định","path_with_type":"Xã Hải Lộc, Huyện Hải Hậu, Tỉnh Nam Định","code":"14263","parent_code":"366"},"14266":{"name":"Xã Hải Quang","type":"xa","slug":"xa-hai-quang","name_with_type":"Xã Hải Quang","path":"Xã Hải Quang, Huyện Hải Hậu, Tỉnh Nam Định","path_with_type":"Xã Hải Quang, Huyện Hải Hậu, Tỉnh Nam Định","code":"14266","parent_code":"366"},"14269":{"name":"Xã Hải Đông","type":"xa","slug":"xa-hai-dong","name_with_type":"Xã Hải Đông","path":"Xã Hải Đông, Huyện Hải Hậu, Tỉnh Nam Định","path_with_type":"Xã Hải Đông, Huyện Hải Hậu, Tỉnh Nam Định","code":"14269","parent_code":"366"},"14272":{"name":"Xã Hải Sơn","type":"xa","slug":"xa-hai-son","name_with_type":"Xã Hải Sơn","path":"Xã Hải Sơn, Huyện Hải Hậu, Tỉnh Nam Định","path_with_type":"Xã Hải Sơn, Huyện Hải Hậu, Tỉnh Nam Định","code":"14272","parent_code":"366"},"14275":{"name":"Xã Hải Tân","type":"xa","slug":"xa-hai-tan","name_with_type":"Xã Hải Tân","path":"Xã Hải Tân, Huyện Hải Hậu, Tỉnh Nam Định","path_with_type":"Xã Hải Tân, Huyện Hải Hậu, Tỉnh Nam Định","code":"14275","parent_code":"366"},"14281":{"name":"Xã Hải Phong","type":"xa","slug":"xa-hai-phong","name_with_type":"Xã Hải Phong","path":"Xã Hải Phong, Huyện Hải Hậu, Tỉnh Nam Định","path_with_type":"Xã Hải Phong, Huyện Hải Hậu, Tỉnh Nam Định","code":"14281","parent_code":"366"},"14284":{"name":"Xã Hải An","type":"xa","slug":"xa-hai-an","name_with_type":"Xã Hải An","path":"Xã Hải An, Huyện Hải Hậu, Tỉnh Nam Định","path_with_type":"Xã Hải An, Huyện Hải Hậu, Tỉnh Nam Định","code":"14284","parent_code":"366"},"14287":{"name":"Xã Hải Tây","type":"xa","slug":"xa-hai-tay","name_with_type":"Xã Hải Tây","path":"Xã Hải Tây, Huyện Hải Hậu, Tỉnh Nam Định","path_with_type":"Xã Hải Tây, Huyện Hải Hậu, Tỉnh Nam Định","code":"14287","parent_code":"366"},"14293":{"name":"Xã Hải Phú","type":"xa","slug":"xa-hai-phu","name_with_type":"Xã Hải Phú","path":"Xã Hải Phú, Huyện Hải Hậu, Tỉnh Nam Định","path_with_type":"Xã Hải Phú, Huyện Hải Hậu, Tỉnh Nam Định","code":"14293","parent_code":"366"},"14296":{"name":"Xã Hải Giang","type":"xa","slug":"xa-hai-giang","name_with_type":"Xã Hải Giang","path":"Xã Hải Giang, Huyện Hải Hậu, Tỉnh Nam Định","path_with_type":"Xã Hải Giang, Huyện Hải Hậu, Tỉnh Nam Định","code":"14296","parent_code":"366"},"14302":{"name":"Xã Hải Ninh","type":"xa","slug":"xa-hai-ninh","name_with_type":"Xã Hải Ninh","path":"Xã Hải Ninh, Huyện Hải Hậu, Tỉnh Nam Định","path_with_type":"Xã Hải Ninh, Huyện Hải Hậu, Tỉnh Nam Định","code":"14302","parent_code":"366"},"14308":{"name":"Xã Hải Xuân","type":"xa","slug":"xa-hai-xuan","name_with_type":"Xã Hải Xuân","path":"Xã Hải Xuân, Huyện Hải Hậu, Tỉnh Nam Định","path_with_type":"Xã Hải Xuân, Huyện Hải Hậu, Tỉnh Nam Định","code":"14308","parent_code":"366"},"14311":{"name":"Xã Hải Châu","type":"xa","slug":"xa-hai-chau","name_with_type":"Xã Hải Châu","path":"Xã Hải Châu, Huyện Hải Hậu, Tỉnh Nam Định","path_with_type":"Xã Hải Châu, Huyện Hải Hậu, Tỉnh Nam Định","code":"14311","parent_code":"366"},"14317":{"name":"Xã Hải Hòa","type":"xa","slug":"xa-hai-hoa","name_with_type":"Xã Hải Hòa","path":"Xã Hải Hòa, Huyện Hải Hậu, Tỉnh Nam Định","path_with_type":"Xã Hải Hòa, Huyện Hải Hậu, Tỉnh Nam Định","code":"14317","parent_code":"366"},"14320":{"name":"Phường Đông Thành","type":"phuong","slug":"phuong-dong-thanh","name_with_type":"Phường Đông Thành","path":"Phường Đông Thành, Thành phố Hoa Lư, Tỉnh Ninh Bình","path_with_type":"Phường Đông Thành, Thành phố Hoa Lư, Tỉnh Ninh Bình","code":"14320","parent_code":"374"},"14323":{"name":"Phường Tân Thành","type":"phuong","slug":"phuong-tan-thanh","name_with_type":"Phường Tân Thành","path":"Phường Tân Thành, Thành phố Hoa Lư, Tỉnh Ninh Bình","path_with_type":"Phường Tân Thành, Thành phố Hoa Lư, Tỉnh Ninh Bình","code":"14323","parent_code":"374"},"14329":{"name":"Phường Vân Giang","type":"phuong","slug":"phuong-van-giang","name_with_type":"Phường Vân Giang","path":"Phường Vân Giang, Thành phố Hoa Lư, Tỉnh Ninh Bình","path_with_type":"Phường Vân Giang, Thành phố Hoa Lư, Tỉnh Ninh Bình","code":"14329","parent_code":"374"},"14332":{"name":"Phường Bích Đào","type":"phuong","slug":"phuong-bich-dao","name_with_type":"Phường Bích Đào","path":"Phường Bích Đào, Thành phố Hoa Lư, Tỉnh Ninh Bình","path_with_type":"Phường Bích Đào, Thành phố Hoa Lư, Tỉnh Ninh Bình","code":"14332","parent_code":"374"},"14338":{"name":"Phường Nam Bình","type":"phuong","slug":"phuong-nam-binh","name_with_type":"Phường Nam Bình","path":"Phường Nam Bình, Thành phố Hoa Lư, Tỉnh Ninh Bình","path_with_type":"Phường Nam Bình, Thành phố Hoa Lư, Tỉnh Ninh Bình","code":"14338","parent_code":"374"},"14341":{"name":"Phường Nam Thành","type":"phuong","slug":"phuong-nam-thanh","name_with_type":"Phường Nam Thành","path":"Phường Nam Thành, Thành phố Hoa Lư, Tỉnh Ninh Bình","path_with_type":"Phường Nam Thành, Thành phố Hoa Lư, Tỉnh Ninh Bình","code":"14341","parent_code":"374"},"14344":{"name":"Phường Ninh Khánh","type":"phuong","slug":"phuong-ninh-khanh","name_with_type":"Phường Ninh Khánh","path":"Phường Ninh Khánh, Thành phố Hoa Lư, Tỉnh Ninh Bình","path_with_type":"Phường Ninh Khánh, Thành phố Hoa Lư, Tỉnh Ninh Bình","code":"14344","parent_code":"374"},"14347":{"name":"Xã Ninh Nhất","type":"xa","slug":"xa-ninh-nhat","name_with_type":"Xã Ninh Nhất","path":"Xã Ninh Nhất, Thành phố Hoa Lư, Tỉnh Ninh Bình","path_with_type":"Xã Ninh Nhất, Thành phố Hoa Lư, Tỉnh Ninh Bình","code":"14347","parent_code":"374"},"14350":{"name":"Xã Ninh Tiến","type":"xa","slug":"xa-ninh-tien","name_with_type":"Xã Ninh Tiến","path":"Xã Ninh Tiến, Thành phố Hoa Lư, Tỉnh Ninh Bình","path_with_type":"Xã Ninh Tiến, Thành phố Hoa Lư, Tỉnh Ninh Bình","code":"14350","parent_code":"374"},"14353":{"name":"Phường Ninh Phúc","type":"phuong","slug":"phuong-ninh-phuc","name_with_type":"Phường Ninh Phúc","path":"Phường Ninh Phúc, Thành phố Hoa Lư, Tỉnh Ninh Bình","path_with_type":"Phường Ninh Phúc, Thành phố Hoa Lư, Tỉnh Ninh Bình","code":"14353","parent_code":"374"},"14356":{"name":"Phường Ninh Sơn","type":"phuong","slug":"phuong-ninh-son","name_with_type":"Phường Ninh Sơn","path":"Phường Ninh Sơn, Thành phố Hoa Lư, Tỉnh Ninh Bình","path_with_type":"Phường Ninh Sơn, Thành phố Hoa Lư, Tỉnh Ninh Bình","code":"14356","parent_code":"374"},"14359":{"name":"Phường Ninh Phong","type":"phuong","slug":"phuong-ninh-phong","name_with_type":"Phường Ninh Phong","path":"Phường Ninh Phong, Thành phố Hoa Lư, Tỉnh Ninh Bình","path_with_type":"Phường Ninh Phong, Thành phố Hoa Lư, Tỉnh Ninh Bình","code":"14359","parent_code":"374"},"14362":{"name":"Phường Bắc Sơn","type":"phuong","slug":"phuong-bac-son","name_with_type":"Phường Bắc Sơn","path":"Phường Bắc Sơn, Thành phố Tam Điệp, Tỉnh Ninh Bình","path_with_type":"Phường Bắc Sơn, Thành phố Tam Điệp, Tỉnh Ninh Bình","code":"14362","parent_code":"370"},"14365":{"name":"Phường Trung Sơn","type":"phuong","slug":"phuong-trung-son","name_with_type":"Phường Trung Sơn","path":"Phường Trung Sơn, Thành phố Tam Điệp, Tỉnh Ninh Bình","path_with_type":"Phường Trung Sơn, Thành phố Tam Điệp, Tỉnh Ninh Bình","code":"14365","parent_code":"370"},"14368":{"name":"Phường Nam Sơn","type":"phuong","slug":"phuong-nam-son","name_with_type":"Phường Nam Sơn","path":"Phường Nam Sơn, Thành phố Tam Điệp, Tỉnh Ninh Bình","path_with_type":"Phường Nam Sơn, Thành phố Tam Điệp, Tỉnh Ninh Bình","code":"14368","parent_code":"370"},"14369":{"name":"Phường Tây Sơn","type":"phuong","slug":"phuong-tay-son","name_with_type":"Phường Tây Sơn","path":"Phường Tây Sơn, Thành phố Tam Điệp, Tỉnh Ninh Bình","path_with_type":"Phường Tây Sơn, Thành phố Tam Điệp, Tỉnh Ninh Bình","code":"14369","parent_code":"370"},"14371":{"name":"Xã Yên Sơn","type":"xa","slug":"xa-yen-son","name_with_type":"Xã Yên Sơn","path":"Xã Yên Sơn, Thành phố Tam Điệp, Tỉnh Ninh Bình","path_with_type":"Xã Yên Sơn, Thành phố Tam Điệp, Tỉnh Ninh Bình","code":"14371","parent_code":"370"},"14374":{"name":"Phường Yên Bình","type":"phuong","slug":"phuong-yen-binh","name_with_type":"Phường Yên Bình","path":"Phường Yên Bình, Thành phố Tam Điệp, Tỉnh Ninh Bình","path_with_type":"Phường Yên Bình, Thành phố Tam Điệp, Tỉnh Ninh Bình","code":"14374","parent_code":"370"},"14375":{"name":"Phường Tân Bình","type":"phuong","slug":"phuong-tan-binh","name_with_type":"Phường Tân Bình","path":"Phường Tân Bình, Thành phố Tam Điệp, Tỉnh Ninh Bình","path_with_type":"Phường Tân Bình, Thành phố Tam Điệp, Tỉnh Ninh Bình","code":"14375","parent_code":"370"},"14377":{"name":"Xã Quang Sơn","type":"xa","slug":"xa-quang-son","name_with_type":"Xã Quang Sơn","path":"Xã Quang Sơn, Thành phố Tam Điệp, Tỉnh Ninh Bình","path_with_type":"Xã Quang Sơn, Thành phố Tam Điệp, Tỉnh Ninh Bình","code":"14377","parent_code":"370"},"14380":{"name":"Xã Đông Sơn","type":"xa","slug":"xa-dong-son","name_with_type":"Xã Đông Sơn","path":"Xã Đông Sơn, Thành phố Tam Điệp, Tỉnh Ninh Bình","path_with_type":"Xã Đông Sơn, Thành phố Tam Điệp, Tỉnh Ninh Bình","code":"14380","parent_code":"370"},"14386":{"name":"Xã Xích Thổ","type":"xa","slug":"xa-xich-tho","name_with_type":"Xã Xích Thổ","path":"Xã Xích Thổ, Huyện Nho Quan, Tỉnh Ninh Bình","path_with_type":"Xã Xích Thổ, Huyện Nho Quan, Tỉnh Ninh Bình","code":"14386","parent_code":"372"},"14389":{"name":"Xã Gia Lâm","type":"xa","slug":"xa-gia-lam","name_with_type":"Xã Gia Lâm","path":"Xã Gia Lâm, Huyện Nho Quan, Tỉnh Ninh Bình","path_with_type":"Xã Gia Lâm, Huyện Nho Quan, Tỉnh Ninh Bình","code":"14389","parent_code":"372"},"14392":{"name":"Xã Gia Sơn","type":"xa","slug":"xa-gia-son","name_with_type":"Xã Gia Sơn","path":"Xã Gia Sơn, Huyện Nho Quan, Tỉnh Ninh Bình","path_with_type":"Xã Gia Sơn, Huyện Nho Quan, Tỉnh Ninh Bình","code":"14392","parent_code":"372"},"14395":{"name":"Xã Thạch Bình","type":"xa","slug":"xa-thach-binh","name_with_type":"Xã Thạch Bình","path":"Xã Thạch Bình, Huyện Nho Quan, Tỉnh Ninh Bình","path_with_type":"Xã Thạch Bình, Huyện Nho Quan, Tỉnh Ninh Bình","code":"14395","parent_code":"372"},"14398":{"name":"Xã Gia Thủy","type":"xa","slug":"xa-gia-thuy","name_with_type":"Xã Gia Thủy","path":"Xã Gia Thủy, Huyện Nho Quan, Tỉnh Ninh Bình","path_with_type":"Xã Gia Thủy, Huyện Nho Quan, Tỉnh Ninh Bình","code":"14398","parent_code":"372"},"14401":{"name":"Xã Gia Tường","type":"xa","slug":"xa-gia-tuong","name_with_type":"Xã Gia Tường","path":"Xã Gia Tường, Huyện Nho Quan, Tỉnh Ninh Bình","path_with_type":"Xã Gia Tường, Huyện Nho Quan, Tỉnh Ninh Bình","code":"14401","parent_code":"372"},"14404":{"name":"Xã Cúc Phương","type":"xa","slug":"xa-cuc-phuong","name_with_type":"Xã Cúc Phương","path":"Xã Cúc Phương, Huyện Nho Quan, Tỉnh Ninh Bình","path_with_type":"Xã Cúc Phương, Huyện Nho Quan, Tỉnh Ninh Bình","code":"14404","parent_code":"372"},"14407":{"name":"Xã Phú Sơn","type":"xa","slug":"xa-phu-son","name_with_type":"Xã Phú Sơn","path":"Xã Phú Sơn, Huyện Nho Quan, Tỉnh Ninh Bình","path_with_type":"Xã Phú Sơn, Huyện Nho Quan, Tỉnh Ninh Bình","code":"14407","parent_code":"372"},"14410":{"name":"Xã Đức Long","type":"xa","slug":"xa-duc-long","name_with_type":"Xã Đức Long","path":"Xã Đức Long, Huyện Nho Quan, Tỉnh Ninh Bình","path_with_type":"Xã Đức Long, Huyện Nho Quan, Tỉnh Ninh Bình","code":"14410","parent_code":"372"},"14413":{"name":"Xã Lạc Vân","type":"xa","slug":"xa-lac-van","name_with_type":"Xã Lạc Vân","path":"Xã Lạc Vân, Huyện Nho Quan, Tỉnh Ninh Bình","path_with_type":"Xã Lạc Vân, Huyện Nho Quan, Tỉnh Ninh Bình","code":"14413","parent_code":"372"},"14416":{"name":"Xã Đồng Phong","type":"xa","slug":"xa-dong-phong","name_with_type":"Xã Đồng Phong","path":"Xã Đồng Phong, Huyện Nho Quan, Tỉnh Ninh Bình","path_with_type":"Xã Đồng Phong, Huyện Nho Quan, Tỉnh Ninh Bình","code":"14416","parent_code":"372"},"14419":{"name":"Xã Yên Quang","type":"xa","slug":"xa-yen-quang","name_with_type":"Xã Yên Quang","path":"Xã Yên Quang, Huyện Nho Quan, Tỉnh Ninh Bình","path_with_type":"Xã Yên Quang, Huyện Nho Quan, Tỉnh Ninh Bình","code":"14419","parent_code":"372"},"14425":{"name":"Xã Thượng Hòa","type":"xa","slug":"xa-thuong-hoa","name_with_type":"Xã Thượng Hòa","path":"Xã Thượng Hòa, Huyện Nho Quan, Tỉnh Ninh Bình","path_with_type":"Xã Thượng Hòa, Huyện Nho Quan, Tỉnh Ninh Bình","code":"14425","parent_code":"372"},"14428":{"name":"Thị trấn Nho Quan","type":"thi-tran","slug":"thi-tran-nho-quan","name_with_type":"Thị trấn Nho Quan","path":"Thị trấn Nho Quan, Huyện Nho Quan, Tỉnh Ninh Bình","path_with_type":"Thị trấn Nho Quan, Huyện Nho Quan, Tỉnh Ninh Bình","code":"14428","parent_code":"372"},"14431":{"name":"Xã Văn Phương","type":"xa","slug":"xa-van-phuong","name_with_type":"Xã Văn Phương","path":"Xã Văn Phương, Huyện Nho Quan, Tỉnh Ninh Bình","path_with_type":"Xã Văn Phương, Huyện Nho Quan, Tỉnh Ninh Bình","code":"14431","parent_code":"372"},"14434":{"name":"Xã Thanh Sơn","type":"xa","slug":"xa-thanh-son","name_with_type":"Xã Thanh Sơn","path":"Xã Thanh Sơn, Huyện Nho Quan, Tỉnh Ninh Bình","path_with_type":"Xã Thanh Sơn, Huyện Nho Quan, Tỉnh Ninh Bình","code":"14434","parent_code":"372"},"14437":{"name":"Xã Phúc Sơn","type":"xa","slug":"xa-phuc-son","name_with_type":"Xã Phúc Sơn","path":"Xã Phúc Sơn, Huyện Nho Quan, Tỉnh Ninh Bình","path_with_type":"Xã Phúc Sơn, Huyện Nho Quan, Tỉnh Ninh Bình","code":"14437","parent_code":"372"},"14443":{"name":"Xã Văn Phú","type":"xa","slug":"xa-van-phu","name_with_type":"Xã Văn Phú","path":"Xã Văn Phú, Huyện Nho Quan, Tỉnh Ninh Bình","path_with_type":"Xã Văn Phú, Huyện Nho Quan, Tỉnh Ninh Bình","code":"14443","parent_code":"372"},"14446":{"name":"Xã Phú Lộc","type":"xa","slug":"xa-phu-loc","name_with_type":"Xã Phú Lộc","path":"Xã Phú Lộc, Huyện Nho Quan, Tỉnh Ninh Bình","path_with_type":"Xã Phú Lộc, Huyện Nho Quan, Tỉnh Ninh Bình","code":"14446","parent_code":"372"},"14449":{"name":"Xã Kỳ Phú","type":"xa","slug":"xa-ky-phu","name_with_type":"Xã Kỳ Phú","path":"Xã Kỳ Phú, Huyện Nho Quan, Tỉnh Ninh Bình","path_with_type":"Xã Kỳ Phú, Huyện Nho Quan, Tỉnh Ninh Bình","code":"14449","parent_code":"372"},"14452":{"name":"Xã Quỳnh Lưu","type":"xa","slug":"xa-quynh-luu","name_with_type":"Xã Quỳnh Lưu","path":"Xã Quỳnh Lưu, Huyện Nho Quan, Tỉnh Ninh Bình","path_with_type":"Xã Quỳnh Lưu, Huyện Nho Quan, Tỉnh Ninh Bình","code":"14452","parent_code":"372"},"14458":{"name":"Xã Phú Long","type":"xa","slug":"xa-phu-long","name_with_type":"Xã Phú Long","path":"Xã Phú Long, Huyện Nho Quan, Tỉnh Ninh Bình","path_with_type":"Xã Phú Long, Huyện Nho Quan, Tỉnh Ninh Bình","code":"14458","parent_code":"372"},"14461":{"name":"Xã Quảng Lạc","type":"xa","slug":"xa-quang-lac","name_with_type":"Xã Quảng Lạc","path":"Xã Quảng Lạc, Huyện Nho Quan, Tỉnh Ninh Bình","path_with_type":"Xã Quảng Lạc, Huyện Nho Quan, Tỉnh Ninh Bình","code":"14461","parent_code":"372"},"14464":{"name":"Thị trấn Thịnh Vượng","type":"thi-tran","slug":"thi-tran-thinh-vuong","name_with_type":"Thị trấn Thịnh Vượng","path":"Thị trấn Thịnh Vượng, Huyện Gia Viễn, Tỉnh Ninh Bình","path_with_type":"Thị trấn Thịnh Vượng, Huyện Gia Viễn, Tỉnh Ninh Bình","code":"14464","parent_code":"373"},"14467":{"name":"Xã Gia Hòa","type":"xa","slug":"xa-gia-hoa","name_with_type":"Xã Gia Hòa","path":"Xã Gia Hòa, Huyện Gia Viễn, Tỉnh Ninh Bình","path_with_type":"Xã Gia Hòa, Huyện Gia Viễn, Tỉnh Ninh Bình","code":"14467","parent_code":"373"},"14470":{"name":"Xã Gia Hưng","type":"xa","slug":"xa-gia-hung","name_with_type":"Xã Gia Hưng","path":"Xã Gia Hưng, Huyện Gia Viễn, Tỉnh Ninh Bình","path_with_type":"Xã Gia Hưng, Huyện Gia Viễn, Tỉnh Ninh Bình","code":"14470","parent_code":"373"},"14473":{"name":"Xã Liên Sơn","type":"xa","slug":"xa-lien-son","name_with_type":"Xã Liên Sơn","path":"Xã Liên Sơn, Huyện Gia Viễn, Tỉnh Ninh Bình","path_with_type":"Xã Liên Sơn, Huyện Gia Viễn, Tỉnh Ninh Bình","code":"14473","parent_code":"373"},"14476":{"name":"Xã Gia Thanh","type":"xa","slug":"xa-gia-thanh","name_with_type":"Xã Gia Thanh","path":"Xã Gia Thanh, Huyện Gia Viễn, Tỉnh Ninh Bình","path_with_type":"Xã Gia Thanh, Huyện Gia Viễn, Tỉnh Ninh Bình","code":"14476","parent_code":"373"},"14479":{"name":"Xã Gia Vân","type":"xa","slug":"xa-gia-van","name_with_type":"Xã Gia Vân","path":"Xã Gia Vân, Huyện Gia Viễn, Tỉnh Ninh Bình","path_with_type":"Xã Gia Vân, Huyện Gia Viễn, Tỉnh Ninh Bình","code":"14479","parent_code":"373"},"14482":{"name":"Xã Gia Phú","type":"xa","slug":"xa-gia-phu","name_with_type":"Xã Gia Phú","path":"Xã Gia Phú, Huyện Gia Viễn, Tỉnh Ninh Bình","path_with_type":"Xã Gia Phú, Huyện Gia Viễn, Tỉnh Ninh Bình","code":"14482","parent_code":"373"},"14485":{"name":"Xã Gia Xuân","type":"xa","slug":"xa-gia-xuan","name_with_type":"Xã Gia Xuân","path":"Xã Gia Xuân, Huyện Gia Viễn, Tỉnh Ninh Bình","path_with_type":"Xã Gia Xuân, Huyện Gia Viễn, Tỉnh Ninh Bình","code":"14485","parent_code":"373"},"14488":{"name":"Xã Gia Lập","type":"xa","slug":"xa-gia-lap","name_with_type":"Xã Gia Lập","path":"Xã Gia Lập, Huyện Gia Viễn, Tỉnh Ninh Bình","path_with_type":"Xã Gia Lập, Huyện Gia Viễn, Tỉnh Ninh Bình","code":"14488","parent_code":"373"},"14494":{"name":"Xã Gia Trấn","type":"xa","slug":"xa-gia-tran","name_with_type":"Xã Gia Trấn","path":"Xã Gia Trấn, Huyện Gia Viễn, Tỉnh Ninh Bình","path_with_type":"Xã Gia Trấn, Huyện Gia Viễn, Tỉnh Ninh Bình","code":"14494","parent_code":"373"},"14500":{"name":"Xã Gia Phương","type":"xa","slug":"xa-gia-phuong","name_with_type":"Xã Gia Phương","path":"Xã Gia Phương, Huyện Gia Viễn, Tỉnh Ninh Bình","path_with_type":"Xã Gia Phương, Huyện Gia Viễn, Tỉnh Ninh Bình","code":"14500","parent_code":"373"},"14503":{"name":"Xã Gia Tân","type":"xa","slug":"xa-gia-tan","name_with_type":"Xã Gia Tân","path":"Xã Gia Tân, Huyện Gia Viễn, Tỉnh Ninh Bình","path_with_type":"Xã Gia Tân, Huyện Gia Viễn, Tỉnh Ninh Bình","code":"14503","parent_code":"373"},"14506":{"name":"Xã Tiến Thắng","type":"xa","slug":"xa-tien-thang","name_with_type":"Xã Tiến Thắng","path":"Xã Tiến Thắng, Huyện Gia Viễn, Tỉnh Ninh Bình","path_with_type":"Xã Tiến Thắng, Huyện Gia Viễn, Tỉnh Ninh Bình","code":"14506","parent_code":"373"},"14509":{"name":"Xã Gia Trung","type":"xa","slug":"xa-gia-trung","name_with_type":"Xã Gia Trung","path":"Xã Gia Trung, Huyện Gia Viễn, Tỉnh Ninh Bình","path_with_type":"Xã Gia Trung, Huyện Gia Viễn, Tỉnh Ninh Bình","code":"14509","parent_code":"373"},"14512":{"name":"Xã Gia Minh","type":"xa","slug":"xa-gia-minh","name_with_type":"Xã Gia Minh","path":"Xã Gia Minh, Huyện Gia Viễn, Tỉnh Ninh Bình","path_with_type":"Xã Gia Minh, Huyện Gia Viễn, Tỉnh Ninh Bình","code":"14512","parent_code":"373"},"14515":{"name":"Xã Gia Lạc","type":"xa","slug":"xa-gia-lac","name_with_type":"Xã Gia Lạc","path":"Xã Gia Lạc, Huyện Gia Viễn, Tỉnh Ninh Bình","path_with_type":"Xã Gia Lạc, Huyện Gia Viễn, Tỉnh Ninh Bình","code":"14515","parent_code":"373"},"14521":{"name":"Xã Gia Sinh","type":"xa","slug":"xa-gia-sinh","name_with_type":"Xã Gia Sinh","path":"Xã Gia Sinh, Huyện Gia Viễn, Tỉnh Ninh Bình","path_with_type":"Xã Gia Sinh, Huyện Gia Viễn, Tỉnh Ninh Bình","code":"14521","parent_code":"373"},"14524":{"name":"Xã Gia Phong","type":"xa","slug":"xa-gia-phong","name_with_type":"Xã Gia Phong","path":"Xã Gia Phong, Huyện Gia Viễn, Tỉnh Ninh Bình","path_with_type":"Xã Gia Phong, Huyện Gia Viễn, Tỉnh Ninh Bình","code":"14524","parent_code":"373"},"14527":{"name":"Phường Ninh Mỹ","type":"phuong","slug":"phuong-ninh-my","name_with_type":"Phường Ninh Mỹ","path":"Phường Ninh Mỹ, Thành phố Hoa Lư, Tỉnh Ninh Bình","path_with_type":"Phường Ninh Mỹ, Thành phố Hoa Lư, Tỉnh Ninh Bình","code":"14527","parent_code":"374"},"14530":{"name":"Phường Ninh Giang","type":"phuong","slug":"phuong-ninh-giang","name_with_type":"Phường Ninh Giang","path":"Phường Ninh Giang, Thành phố Hoa Lư, Tỉnh Ninh Bình","path_with_type":"Phường Ninh Giang, Thành phố Hoa Lư, Tỉnh Ninh Bình","code":"14530","parent_code":"374"},"14533":{"name":"Xã Trường Yên","type":"xa","slug":"xa-truong-yen","name_with_type":"Xã Trường Yên","path":"Xã Trường Yên, Thành phố Hoa Lư, Tỉnh Ninh Bình","path_with_type":"Xã Trường Yên, Thành phố Hoa Lư, Tỉnh Ninh Bình","code":"14533","parent_code":"374"},"14536":{"name":"Xã Ninh Khang","type":"xa","slug":"xa-ninh-khang","name_with_type":"Xã Ninh Khang","path":"Xã Ninh Khang, Thành phố Hoa Lư, Tỉnh Ninh Bình","path_with_type":"Xã Ninh Khang, Thành phố Hoa Lư, Tỉnh Ninh Bình","code":"14536","parent_code":"374"},"14542":{"name":"Xã Ninh Hòa","type":"xa","slug":"xa-ninh-hoa","name_with_type":"Xã Ninh Hòa","path":"Xã Ninh Hòa, Thành phố Hoa Lư, Tỉnh Ninh Bình","path_with_type":"Xã Ninh Hòa, Thành phố Hoa Lư, Tỉnh Ninh Bình","code":"14542","parent_code":"374"},"14551":{"name":"Xã Ninh Hải","type":"xa","slug":"xa-ninh-hai","name_with_type":"Xã Ninh Hải","path":"Xã Ninh Hải, Thành phố Hoa Lư, Tỉnh Ninh Bình","path_with_type":"Xã Ninh Hải, Thành phố Hoa Lư, Tỉnh Ninh Bình","code":"14551","parent_code":"374"},"14554":{"name":"Xã Ninh Vân","type":"xa","slug":"xa-ninh-van","name_with_type":"Xã Ninh Vân","path":"Xã Ninh Vân, Thành phố Hoa Lư, Tỉnh Ninh Bình","path_with_type":"Xã Ninh Vân, Thành phố Hoa Lư, Tỉnh Ninh Bình","code":"14554","parent_code":"374"},"14557":{"name":"Xã Ninh An","type":"xa","slug":"xa-ninh-an","name_with_type":"Xã Ninh An","path":"Xã Ninh An, Thành phố Hoa Lư, Tỉnh Ninh Bình","path_with_type":"Xã Ninh An, Thành phố Hoa Lư, Tỉnh Ninh Bình","code":"14557","parent_code":"374"},"14560":{"name":"Thị trấn Yên Ninh","type":"thi-tran","slug":"thi-tran-yen-ninh","name_with_type":"Thị trấn Yên Ninh","path":"Thị trấn Yên Ninh, Huyện Yên Khánh, Tỉnh Ninh Bình","path_with_type":"Thị trấn Yên Ninh, Huyện Yên Khánh, Tỉnh Ninh Bình","code":"14560","parent_code":"375"},"14563":{"name":"Xã Khánh Thiện","type":"xa","slug":"xa-khanh-thien","name_with_type":"Xã Khánh Thiện","path":"Xã Khánh Thiện, Huyện Yên Khánh, Tỉnh Ninh Bình","path_with_type":"Xã Khánh Thiện, Huyện Yên Khánh, Tỉnh Ninh Bình","code":"14563","parent_code":"375"},"14566":{"name":"Xã Khánh Phú","type":"xa","slug":"xa-khanh-phu","name_with_type":"Xã Khánh Phú","path":"Xã Khánh Phú, Huyện Yên Khánh, Tỉnh Ninh Bình","path_with_type":"Xã Khánh Phú, Huyện Yên Khánh, Tỉnh Ninh Bình","code":"14566","parent_code":"375"},"14569":{"name":"Xã Khánh Hòa","type":"xa","slug":"xa-khanh-hoa","name_with_type":"Xã Khánh Hòa","path":"Xã Khánh Hòa, Huyện Yên Khánh, Tỉnh Ninh Bình","path_with_type":"Xã Khánh Hòa, Huyện Yên Khánh, Tỉnh Ninh Bình","code":"14569","parent_code":"375"},"14572":{"name":"Xã Khánh Lợi","type":"xa","slug":"xa-khanh-loi","name_with_type":"Xã Khánh Lợi","path":"Xã Khánh Lợi, Huyện Yên Khánh, Tỉnh Ninh Bình","path_with_type":"Xã Khánh Lợi, Huyện Yên Khánh, Tỉnh Ninh Bình","code":"14572","parent_code":"375"},"14575":{"name":"Xã Khánh An","type":"xa","slug":"xa-khanh-an","name_with_type":"Xã Khánh An","path":"Xã Khánh An, Huyện Yên Khánh, Tỉnh Ninh Bình","path_with_type":"Xã Khánh An, Huyện Yên Khánh, Tỉnh Ninh Bình","code":"14575","parent_code":"375"},"14578":{"name":"Xã Khánh Cường","type":"xa","slug":"xa-khanh-cuong","name_with_type":"Xã Khánh Cường","path":"Xã Khánh Cường, Huyện Yên Khánh, Tỉnh Ninh Bình","path_with_type":"Xã Khánh Cường, Huyện Yên Khánh, Tỉnh Ninh Bình","code":"14578","parent_code":"375"},"14581":{"name":"Xã Khánh Cư","type":"xa","slug":"xa-khanh-cu","name_with_type":"Xã Khánh Cư","path":"Xã Khánh Cư, Huyện Yên Khánh, Tỉnh Ninh Bình","path_with_type":"Xã Khánh Cư, Huyện Yên Khánh, Tỉnh Ninh Bình","code":"14581","parent_code":"375"},"14587":{"name":"Xã Khánh Hải","type":"xa","slug":"xa-khanh-hai","name_with_type":"Xã Khánh Hải","path":"Xã Khánh Hải, Huyện Yên Khánh, Tỉnh Ninh Bình","path_with_type":"Xã Khánh Hải, Huyện Yên Khánh, Tỉnh Ninh Bình","code":"14587","parent_code":"375"},"14590":{"name":"Xã Khánh Trung","type":"xa","slug":"xa-khanh-trung","name_with_type":"Xã Khánh Trung","path":"Xã Khánh Trung, Huyện Yên Khánh, Tỉnh Ninh Bình","path_with_type":"Xã Khánh Trung, Huyện Yên Khánh, Tỉnh Ninh Bình","code":"14590","parent_code":"375"},"14593":{"name":"Xã Khánh Mậu","type":"xa","slug":"xa-khanh-mau","name_with_type":"Xã Khánh Mậu","path":"Xã Khánh Mậu, Huyện Yên Khánh, Tỉnh Ninh Bình","path_with_type":"Xã Khánh Mậu, Huyện Yên Khánh, Tỉnh Ninh Bình","code":"14593","parent_code":"375"},"14596":{"name":"Xã Khánh Vân","type":"xa","slug":"xa-khanh-van","name_with_type":"Xã Khánh Vân","path":"Xã Khánh Vân, Huyện Yên Khánh, Tỉnh Ninh Bình","path_with_type":"Xã Khánh Vân, Huyện Yên Khánh, Tỉnh Ninh Bình","code":"14596","parent_code":"375"},"14599":{"name":"Xã Khánh Hội","type":"xa","slug":"xa-khanh-hoi","name_with_type":"Xã Khánh Hội","path":"Xã Khánh Hội, Huyện Yên Khánh, Tỉnh Ninh Bình","path_with_type":"Xã Khánh Hội, Huyện Yên Khánh, Tỉnh Ninh Bình","code":"14599","parent_code":"375"},"14602":{"name":"Xã Khánh Công","type":"xa","slug":"xa-khanh-cong","name_with_type":"Xã Khánh Công","path":"Xã Khánh Công, Huyện Yên Khánh, Tỉnh Ninh Bình","path_with_type":"Xã Khánh Công, Huyện Yên Khánh, Tỉnh Ninh Bình","code":"14602","parent_code":"375"},"14608":{"name":"Xã Khánh Thành","type":"xa","slug":"xa-khanh-thanh","name_with_type":"Xã Khánh Thành","path":"Xã Khánh Thành, Huyện Yên Khánh, Tỉnh Ninh Bình","path_with_type":"Xã Khánh Thành, Huyện Yên Khánh, Tỉnh Ninh Bình","code":"14608","parent_code":"375"},"14611":{"name":"Xã Khánh Nhạc","type":"xa","slug":"xa-khanh-nhac","name_with_type":"Xã Khánh Nhạc","path":"Xã Khánh Nhạc, Huyện Yên Khánh, Tỉnh Ninh Bình","path_with_type":"Xã Khánh Nhạc, Huyện Yên Khánh, Tỉnh Ninh Bình","code":"14611","parent_code":"375"},"14614":{"name":"Xã Khánh Thủy","type":"xa","slug":"xa-khanh-thuy","name_with_type":"Xã Khánh Thủy","path":"Xã Khánh Thủy, Huyện Yên Khánh, Tỉnh Ninh Bình","path_with_type":"Xã Khánh Thủy, Huyện Yên Khánh, Tỉnh Ninh Bình","code":"14614","parent_code":"375"},"14617":{"name":"Xã Khánh Hồng","type":"xa","slug":"xa-khanh-hong","name_with_type":"Xã Khánh Hồng","path":"Xã Khánh Hồng, Huyện Yên Khánh, Tỉnh Ninh Bình","path_with_type":"Xã Khánh Hồng, Huyện Yên Khánh, Tỉnh Ninh Bình","code":"14617","parent_code":"375"},"14620":{"name":"Thị trấn Phát Diệm","type":"thi-tran","slug":"thi-tran-phat-diem","name_with_type":"Thị trấn Phát Diệm","path":"Thị trấn Phát Diệm, Huyện Kim Sơn, Tỉnh Ninh Bình","path_with_type":"Thị trấn Phát Diệm, Huyện Kim Sơn, Tỉnh Ninh Bình","code":"14620","parent_code":"376"},"14623":{"name":"Thị trấn Bình Minh","type":"thi-tran","slug":"thi-tran-binh-minh","name_with_type":"Thị trấn Bình Minh","path":"Thị trấn Bình Minh, Huyện Kim Sơn, Tỉnh Ninh Bình","path_with_type":"Thị trấn Bình Minh, Huyện Kim Sơn, Tỉnh Ninh Bình","code":"14623","parent_code":"376"},"14629":{"name":"Xã Hồi Ninh","type":"xa","slug":"xa-hoi-ninh","name_with_type":"Xã Hồi Ninh","path":"Xã Hồi Ninh, Huyện Kim Sơn, Tỉnh Ninh Bình","path_with_type":"Xã Hồi Ninh, Huyện Kim Sơn, Tỉnh Ninh Bình","code":"14629","parent_code":"376"},"14632":{"name":"Xã Xuân Chính","type":"xa","slug":"xa-xuan-chinh","name_with_type":"Xã Xuân Chính","path":"Xã Xuân Chính, Huyện Kim Sơn, Tỉnh Ninh Bình","path_with_type":"Xã Xuân Chính, Huyện Kim Sơn, Tỉnh Ninh Bình","code":"14632","parent_code":"376"},"14635":{"name":"Xã Kim Định","type":"xa","slug":"xa-kim-dinh","name_with_type":"Xã Kim Định","path":"Xã Kim Định, Huyện Kim Sơn, Tỉnh Ninh Bình","path_with_type":"Xã Kim Định, Huyện Kim Sơn, Tỉnh Ninh Bình","code":"14635","parent_code":"376"},"14638":{"name":"Xã Ân Hòa","type":"xa","slug":"xa-an-hoa","name_with_type":"Xã Ân Hòa","path":"Xã Ân Hòa, Huyện Kim Sơn, Tỉnh Ninh Bình","path_with_type":"Xã Ân Hòa, Huyện Kim Sơn, Tỉnh Ninh Bình","code":"14638","parent_code":"376"},"14641":{"name":"Xã Hùng Tiến","type":"xa","slug":"xa-hung-tien","name_with_type":"Xã Hùng Tiến","path":"Xã Hùng Tiến, Huyện Kim Sơn, Tỉnh Ninh Bình","path_with_type":"Xã Hùng Tiến, Huyện Kim Sơn, Tỉnh Ninh Bình","code":"14641","parent_code":"376"},"14647":{"name":"Xã Quang Thiện","type":"xa","slug":"xa-quang-thien","name_with_type":"Xã Quang Thiện","path":"Xã Quang Thiện, Huyện Kim Sơn, Tỉnh Ninh Bình","path_with_type":"Xã Quang Thiện, Huyện Kim Sơn, Tỉnh Ninh Bình","code":"14647","parent_code":"376"},"14650":{"name":"Xã Như Hòa","type":"xa","slug":"xa-nhu-hoa","name_with_type":"Xã Như Hòa","path":"Xã Như Hòa, Huyện Kim Sơn, Tỉnh Ninh Bình","path_with_type":"Xã Như Hòa, Huyện Kim Sơn, Tỉnh Ninh Bình","code":"14650","parent_code":"376"},"14653":{"name":"Xã Chất Bình","type":"xa","slug":"xa-chat-binh","name_with_type":"Xã Chất Bình","path":"Xã Chất Bình, Huyện Kim Sơn, Tỉnh Ninh Bình","path_with_type":"Xã Chất Bình, Huyện Kim Sơn, Tỉnh Ninh Bình","code":"14653","parent_code":"376"},"14656":{"name":"Xã Đồng Hướng","type":"xa","slug":"xa-dong-huong","name_with_type":"Xã Đồng Hướng","path":"Xã Đồng Hướng, Huyện Kim Sơn, Tỉnh Ninh Bình","path_with_type":"Xã Đồng Hướng, Huyện Kim Sơn, Tỉnh Ninh Bình","code":"14656","parent_code":"376"},"14659":{"name":"Xã Kim Chính","type":"xa","slug":"xa-kim-chinh","name_with_type":"Xã Kim Chính","path":"Xã Kim Chính, Huyện Kim Sơn, Tỉnh Ninh Bình","path_with_type":"Xã Kim Chính, Huyện Kim Sơn, Tỉnh Ninh Bình","code":"14659","parent_code":"376"},"14662":{"name":"Xã Thượng Kiệm","type":"xa","slug":"xa-thuong-kiem","name_with_type":"Xã Thượng Kiệm","path":"Xã Thượng Kiệm, Huyện Kim Sơn, Tỉnh Ninh Bình","path_with_type":"Xã Thượng Kiệm, Huyện Kim Sơn, Tỉnh Ninh Bình","code":"14662","parent_code":"376"},"14668":{"name":"Xã Tân Thành","type":"xa","slug":"xa-tan-thanh","name_with_type":"Xã Tân Thành","path":"Xã Tân Thành, Huyện Kim Sơn, Tỉnh Ninh Bình","path_with_type":"Xã Tân Thành, Huyện Kim Sơn, Tỉnh Ninh Bình","code":"14668","parent_code":"376"},"14671":{"name":"Xã Yên Lộc","type":"xa","slug":"xa-yen-loc","name_with_type":"Xã Yên Lộc","path":"Xã Yên Lộc, Huyện Kim Sơn, Tỉnh Ninh Bình","path_with_type":"Xã Yên Lộc, Huyện Kim Sơn, Tỉnh Ninh Bình","code":"14671","parent_code":"376"},"14674":{"name":"Xã Lai Thành","type":"xa","slug":"xa-lai-thanh","name_with_type":"Xã Lai Thành","path":"Xã Lai Thành, Huyện Kim Sơn, Tỉnh Ninh Bình","path_with_type":"Xã Lai Thành, Huyện Kim Sơn, Tỉnh Ninh Bình","code":"14674","parent_code":"376"},"14677":{"name":"Xã Định Hóa","type":"xa","slug":"xa-dinh-hoa","name_with_type":"Xã Định Hóa","path":"Xã Định Hóa, Huyện Kim Sơn, Tỉnh Ninh Bình","path_with_type":"Xã Định Hóa, Huyện Kim Sơn, Tỉnh Ninh Bình","code":"14677","parent_code":"376"},"14680":{"name":"Xã Văn Hải","type":"xa","slug":"xa-van-hai","name_with_type":"Xã Văn Hải","path":"Xã Văn Hải, Huyện Kim Sơn, Tỉnh Ninh Bình","path_with_type":"Xã Văn Hải, Huyện Kim Sơn, Tỉnh Ninh Bình","code":"14680","parent_code":"376"},"14683":{"name":"Xã Kim Tân","type":"xa","slug":"xa-kim-tan","name_with_type":"Xã Kim Tân","path":"Xã Kim Tân, Huyện Kim Sơn, Tỉnh Ninh Bình","path_with_type":"Xã Kim Tân, Huyện Kim Sơn, Tỉnh Ninh Bình","code":"14683","parent_code":"376"},"14686":{"name":"Xã Kim Mỹ","type":"xa","slug":"xa-kim-my","name_with_type":"Xã Kim Mỹ","path":"Xã Kim Mỹ, Huyện Kim Sơn, Tỉnh Ninh Bình","path_with_type":"Xã Kim Mỹ, Huyện Kim Sơn, Tỉnh Ninh Bình","code":"14686","parent_code":"376"},"14689":{"name":"Xã Cồn Thoi","type":"xa","slug":"xa-con-thoi","name_with_type":"Xã Cồn Thoi","path":"Xã Cồn Thoi, Huyện Kim Sơn, Tỉnh Ninh Bình","path_with_type":"Xã Cồn Thoi, Huyện Kim Sơn, Tỉnh Ninh Bình","code":"14689","parent_code":"376"},"14695":{"name":"Xã Kim Trung","type":"xa","slug":"xa-kim-trung","name_with_type":"Xã Kim Trung","path":"Xã Kim Trung, Huyện Kim Sơn, Tỉnh Ninh Bình","path_with_type":"Xã Kim Trung, Huyện Kim Sơn, Tỉnh Ninh Bình","code":"14695","parent_code":"376"},"14698":{"name":"Xã Kim Đông","type":"xa","slug":"xa-kim-dong","name_with_type":"Xã Kim Đông","path":"Xã Kim Đông, Huyện Kim Sơn, Tỉnh Ninh Bình","path_with_type":"Xã Kim Đông, Huyện Kim Sơn, Tỉnh Ninh Bình","code":"14698","parent_code":"376"},"14701":{"name":"Thị trấn Yên Thịnh","type":"thi-tran","slug":"thi-tran-yen-thinh","name_with_type":"Thị trấn Yên Thịnh","path":"Thị trấn Yên Thịnh, Huyện Yên Mô, Tỉnh Ninh Bình","path_with_type":"Thị trấn Yên Thịnh, Huyện Yên Mô, Tỉnh Ninh Bình","code":"14701","parent_code":"377"},"14704":{"name":"Xã Khánh Thượng","type":"xa","slug":"xa-khanh-thuong","name_with_type":"Xã Khánh Thượng","path":"Xã Khánh Thượng, Huyện Yên Mô, Tỉnh Ninh Bình","path_with_type":"Xã Khánh Thượng, Huyện Yên Mô, Tỉnh Ninh Bình","code":"14704","parent_code":"377"},"14707":{"name":"Xã Khánh Dương","type":"xa","slug":"xa-khanh-duong","name_with_type":"Xã Khánh Dương","path":"Xã Khánh Dương, Huyện Yên Mô, Tỉnh Ninh Bình","path_with_type":"Xã Khánh Dương, Huyện Yên Mô, Tỉnh Ninh Bình","code":"14707","parent_code":"377"},"14719":{"name":"Xã Yên Phong","type":"xa","slug":"xa-yen-phong","name_with_type":"Xã Yên Phong","path":"Xã Yên Phong, Huyện Yên Mô, Tỉnh Ninh Bình","path_with_type":"Xã Yên Phong, Huyện Yên Mô, Tỉnh Ninh Bình","code":"14719","parent_code":"377"},"14722":{"name":"Xã Yên Hòa","type":"xa","slug":"xa-yen-hoa","name_with_type":"Xã Yên Hòa","path":"Xã Yên Hòa, Huyện Yên Mô, Tỉnh Ninh Bình","path_with_type":"Xã Yên Hòa, Huyện Yên Mô, Tỉnh Ninh Bình","code":"14722","parent_code":"377"},"14725":{"name":"Xã Yên Thắng","type":"xa","slug":"xa-yen-thang","name_with_type":"Xã Yên Thắng","path":"Xã Yên Thắng, Huyện Yên Mô, Tỉnh Ninh Bình","path_with_type":"Xã Yên Thắng, Huyện Yên Mô, Tỉnh Ninh Bình","code":"14725","parent_code":"377"},"14728":{"name":"Xã Yên Từ","type":"xa","slug":"xa-yen-tu","name_with_type":"Xã Yên Từ","path":"Xã Yên Từ, Huyện Yên Mô, Tỉnh Ninh Bình","path_with_type":"Xã Yên Từ, Huyện Yên Mô, Tỉnh Ninh Bình","code":"14728","parent_code":"377"},"14734":{"name":"Xã Yên Thành","type":"xa","slug":"xa-yen-thanh","name_with_type":"Xã Yên Thành","path":"Xã Yên Thành, Huyện Yên Mô, Tỉnh Ninh Bình","path_with_type":"Xã Yên Thành, Huyện Yên Mô, Tỉnh Ninh Bình","code":"14734","parent_code":"377"},"14737":{"name":"Xã Yên Nhân","type":"xa","slug":"xa-yen-nhan","name_with_type":"Xã Yên Nhân","path":"Xã Yên Nhân, Huyện Yên Mô, Tỉnh Ninh Bình","path_with_type":"Xã Yên Nhân, Huyện Yên Mô, Tỉnh Ninh Bình","code":"14737","parent_code":"377"},"14740":{"name":"Xã Yên Mỹ","type":"xa","slug":"xa-yen-my","name_with_type":"Xã Yên Mỹ","path":"Xã Yên Mỹ, Huyện Yên Mô, Tỉnh Ninh Bình","path_with_type":"Xã Yên Mỹ, Huyện Yên Mô, Tỉnh Ninh Bình","code":"14740","parent_code":"377"},"14743":{"name":"Xã Yên Mạc","type":"xa","slug":"xa-yen-mac","name_with_type":"Xã Yên Mạc","path":"Xã Yên Mạc, Huyện Yên Mô, Tỉnh Ninh Bình","path_with_type":"Xã Yên Mạc, Huyện Yên Mô, Tỉnh Ninh Bình","code":"14743","parent_code":"377"},"14746":{"name":"Xã Yên Đồng","type":"xa","slug":"xa-yen-dong","name_with_type":"Xã Yên Đồng","path":"Xã Yên Đồng, Huyện Yên Mô, Tỉnh Ninh Bình","path_with_type":"Xã Yên Đồng, Huyện Yên Mô, Tỉnh Ninh Bình","code":"14746","parent_code":"377"},"14749":{"name":"Xã Yên Thái","type":"xa","slug":"xa-yen-thai","name_with_type":"Xã Yên Thái","path":"Xã Yên Thái, Huyện Yên Mô, Tỉnh Ninh Bình","path_with_type":"Xã Yên Thái, Huyện Yên Mô, Tỉnh Ninh Bình","code":"14749","parent_code":"377"},"14752":{"name":"Xã Yên Lâm","type":"xa","slug":"xa-yen-lam","name_with_type":"Xã Yên Lâm","path":"Xã Yên Lâm, Huyện Yên Mô, Tỉnh Ninh Bình","path_with_type":"Xã Yên Lâm, Huyện Yên Mô, Tỉnh Ninh Bình","code":"14752","parent_code":"377"},"14755":{"name":"Phường Hàm Rồng","type":"phuong","slug":"phuong-ham-rong","name_with_type":"Phường Hàm Rồng","path":"Phường Hàm Rồng, Thành phố Thanh Hóa, Tỉnh Thanh Hóa","path_with_type":"Phường Hàm Rồng, Thành phố Thanh Hóa, Tỉnh Thanh Hóa","code":"14755","parent_code":"380"},"14758":{"name":"Phường Đông Thọ","type":"phuong","slug":"phuong-dong-tho","name_with_type":"Phường Đông Thọ","path":"Phường Đông Thọ, Thành phố Thanh Hóa, Tỉnh Thanh Hóa","path_with_type":"Phường Đông Thọ, Thành phố Thanh Hóa, Tỉnh Thanh Hóa","code":"14758","parent_code":"380"},"14761":{"name":"Phường Nam Ngạn","type":"phuong","slug":"phuong-nam-ngan","name_with_type":"Phường Nam Ngạn","path":"Phường Nam Ngạn, Thành phố Thanh Hóa, Tỉnh Thanh Hóa","path_with_type":"Phường Nam Ngạn, Thành phố Thanh Hóa, Tỉnh Thanh Hóa","code":"14761","parent_code":"380"},"14764":{"name":"Phường Trường Thi","type":"phuong","slug":"phuong-truong-thi","name_with_type":"Phường Trường Thi","path":"Phường Trường Thi, Thành phố Thanh Hóa, Tỉnh Thanh Hóa","path_with_type":"Phường Trường Thi, Thành phố Thanh Hóa, Tỉnh Thanh Hóa","code":"14764","parent_code":"380"},"14767":{"name":"Phường Điện Biên","type":"phuong","slug":"phuong-dien-bien","name_with_type":"Phường Điện Biên","path":"Phường Điện Biên, Thành phố Thanh Hóa, Tỉnh Thanh Hóa","path_with_type":"Phường Điện Biên, Thành phố Thanh Hóa, Tỉnh Thanh Hóa","code":"14767","parent_code":"380"},"14770":{"name":"Phường Phú Sơn","type":"phuong","slug":"phuong-phu-son","name_with_type":"Phường Phú Sơn","path":"Phường Phú Sơn, Thành phố Thanh Hóa, Tỉnh Thanh Hóa","path_with_type":"Phường Phú Sơn, Thành phố Thanh Hóa, Tỉnh Thanh Hóa","code":"14770","parent_code":"380"},"14773":{"name":"Phường Lam Sơn","type":"phuong","slug":"phuong-lam-son","name_with_type":"Phường Lam Sơn","path":"Phường Lam Sơn, Thành phố Thanh Hóa, Tỉnh Thanh Hóa","path_with_type":"Phường Lam Sơn, Thành phố Thanh Hóa, Tỉnh Thanh Hóa","code":"14773","parent_code":"380"},"14776":{"name":"Phường Ba Đình","type":"phuong","slug":"phuong-ba-dinh","name_with_type":"Phường Ba Đình","path":"Phường Ba Đình, Thành phố Thanh Hóa, Tỉnh Thanh Hóa","path_with_type":"Phường Ba Đình, Thành phố Thanh Hóa, Tỉnh Thanh Hóa","code":"14776","parent_code":"380"},"14779":{"name":"Phường Ngọc Trạo","type":"phuong","slug":"phuong-ngoc-trao","name_with_type":"Phường Ngọc Trạo","path":"Phường Ngọc Trạo, Thành phố Thanh Hóa, Tỉnh Thanh Hóa","path_with_type":"Phường Ngọc Trạo, Thành phố Thanh Hóa, Tỉnh Thanh Hóa","code":"14779","parent_code":"380"},"14782":{"name":"Phường Đông Vệ","type":"phuong","slug":"phuong-dong-ve","name_with_type":"Phường Đông Vệ","path":"Phường Đông Vệ, Thành phố Thanh Hóa, Tỉnh Thanh Hóa","path_with_type":"Phường Đông Vệ, Thành phố Thanh Hóa, Tỉnh Thanh Hóa","code":"14782","parent_code":"380"},"14785":{"name":"Phường Đông Sơn","type":"phuong","slug":"phuong-dong-son","name_with_type":"Phường Đông Sơn","path":"Phường Đông Sơn, Thành phố Thanh Hóa, Tỉnh Thanh Hóa","path_with_type":"Phường Đông Sơn, Thành phố Thanh Hóa, Tỉnh Thanh Hóa","code":"14785","parent_code":"380"},"14791":{"name":"Phường Đông Cương","type":"phuong","slug":"phuong-dong-cuong","name_with_type":"Phường Đông Cương","path":"Phường Đông Cương, Thành phố Thanh Hóa, Tỉnh Thanh Hóa","path_with_type":"Phường Đông Cương, Thành phố Thanh Hóa, Tỉnh Thanh Hóa","code":"14791","parent_code":"380"},"14794":{"name":"Phường Đông Hương","type":"phuong","slug":"phuong-dong-huong","name_with_type":"Phường Đông Hương","path":"Phường Đông Hương, Thành phố Thanh Hóa, Tỉnh Thanh Hóa","path_with_type":"Phường Đông Hương, Thành phố Thanh Hóa, Tỉnh Thanh Hóa","code":"14794","parent_code":"380"},"14797":{"name":"Phường Đông Hải","type":"phuong","slug":"phuong-dong-hai","name_with_type":"Phường Đông Hải","path":"Phường Đông Hải, Thành phố Thanh Hóa, Tỉnh Thanh Hóa","path_with_type":"Phường Đông Hải, Thành phố Thanh Hóa, Tỉnh Thanh Hóa","code":"14797","parent_code":"380"},"14800":{"name":"Phường Quảng Hưng","type":"phuong","slug":"phuong-quang-hung","name_with_type":"Phường Quảng Hưng","path":"Phường Quảng Hưng, Thành phố Thanh Hóa, Tỉnh Thanh Hóa","path_with_type":"Phường Quảng Hưng, Thành phố Thanh Hóa, Tỉnh Thanh Hóa","code":"14800","parent_code":"380"},"14803":{"name":"Phường Quảng Thắng","type":"phuong","slug":"phuong-quang-thang","name_with_type":"Phường Quảng Thắng","path":"Phường Quảng Thắng, Thành phố Thanh Hóa, Tỉnh Thanh Hóa","path_with_type":"Phường Quảng Thắng, Thành phố Thanh Hóa, Tỉnh Thanh Hóa","code":"14803","parent_code":"380"},"14806":{"name":"Phường Quảng Thành","type":"phuong","slug":"phuong-quang-thanh","name_with_type":"Phường Quảng Thành","path":"Phường Quảng Thành, Thành phố Thanh Hóa, Tỉnh Thanh Hóa","path_with_type":"Phường Quảng Thành, Thành phố Thanh Hóa, Tỉnh Thanh Hóa","code":"14806","parent_code":"380"},"14809":{"name":"Phường Bắc Sơn","type":"phuong","slug":"phuong-bac-son","name_with_type":"Phường Bắc Sơn","path":"Phường Bắc Sơn, Thị xã Bỉm Sơn, Tỉnh Thanh Hóa","path_with_type":"Phường Bắc Sơn, Thị xã Bỉm Sơn, Tỉnh Thanh Hóa","code":"14809","parent_code":"381"},"14812":{"name":"Phường Ba Đình","type":"phuong","slug":"phuong-ba-dinh","name_with_type":"Phường Ba Đình","path":"Phường Ba Đình, Thị xã Bỉm Sơn, Tỉnh Thanh Hóa","path_with_type":"Phường Ba Đình, Thị xã Bỉm Sơn, Tỉnh Thanh Hóa","code":"14812","parent_code":"381"},"14815":{"name":"Phường Lam Sơn","type":"phuong","slug":"phuong-lam-son","name_with_type":"Phường Lam Sơn","path":"Phường Lam Sơn, Thị xã Bỉm Sơn, Tỉnh Thanh Hóa","path_with_type":"Phường Lam Sơn, Thị xã Bỉm Sơn, Tỉnh Thanh Hóa","code":"14815","parent_code":"381"},"14818":{"name":"Phường Ngọc Trạo","type":"phuong","slug":"phuong-ngoc-trao","name_with_type":"Phường Ngọc Trạo","path":"Phường Ngọc Trạo, Thị xã Bỉm Sơn, Tỉnh Thanh Hóa","path_with_type":"Phường Ngọc Trạo, Thị xã Bỉm Sơn, Tỉnh Thanh Hóa","code":"14818","parent_code":"381"},"14821":{"name":"Phường Đông Sơn","type":"phuong","slug":"phuong-dong-son","name_with_type":"Phường Đông Sơn","path":"Phường Đông Sơn, Thị xã Bỉm Sơn, Tỉnh Thanh Hóa","path_with_type":"Phường Đông Sơn, Thị xã Bỉm Sơn, Tỉnh Thanh Hóa","code":"14821","parent_code":"381"},"14823":{"name":"Phường Phú Sơn","type":"phuong","slug":"phuong-phu-son","name_with_type":"Phường Phú Sơn","path":"Phường Phú Sơn, Thị xã Bỉm Sơn, Tỉnh Thanh Hóa","path_with_type":"Phường Phú Sơn, Thị xã Bỉm Sơn, Tỉnh Thanh Hóa","code":"14823","parent_code":"381"},"14824":{"name":"Xã Quang Trung","type":"xa","slug":"xa-quang-trung","name_with_type":"Xã Quang Trung","path":"Xã Quang Trung, Thị xã Bỉm Sơn, Tỉnh Thanh Hóa","path_with_type":"Xã Quang Trung, Thị xã Bỉm Sơn, Tỉnh Thanh Hóa","code":"14824","parent_code":"381"},"14830":{"name":"Phường Trung Sơn","type":"phuong","slug":"phuong-trung-son","name_with_type":"Phường Trung Sơn","path":"Phường Trung Sơn, Thành phố Sầm Sơn, Tỉnh Thanh Hóa","path_with_type":"Phường Trung Sơn, Thành phố Sầm Sơn, Tỉnh Thanh Hóa","code":"14830","parent_code":"382"},"14833":{"name":"Phường Bắc Sơn","type":"phuong","slug":"phuong-bac-son","name_with_type":"Phường Bắc Sơn","path":"Phường Bắc Sơn, Thành phố Sầm Sơn, Tỉnh Thanh Hóa","path_with_type":"Phường Bắc Sơn, Thành phố Sầm Sơn, Tỉnh Thanh Hóa","code":"14833","parent_code":"382"},"14836":{"name":"Phường Trường Sơn","type":"phuong","slug":"phuong-truong-son","name_with_type":"Phường Trường Sơn","path":"Phường Trường Sơn, Thành phố Sầm Sơn, Tỉnh Thanh Hóa","path_with_type":"Phường Trường Sơn, Thành phố Sầm Sơn, Tỉnh Thanh Hóa","code":"14836","parent_code":"382"},"14839":{"name":"Phường Quảng Cư","type":"phuong","slug":"phuong-quang-cu","name_with_type":"Phường Quảng Cư","path":"Phường Quảng Cư, Thành phố Sầm Sơn, Tỉnh Thanh Hóa","path_with_type":"Phường Quảng Cư, Thành phố Sầm Sơn, Tỉnh Thanh Hóa","code":"14839","parent_code":"382"},"14842":{"name":"Phường Quảng Tiến","type":"phuong","slug":"phuong-quang-tien","name_with_type":"Phường Quảng Tiến","path":"Phường Quảng Tiến, Thành phố Sầm Sơn, Tỉnh Thanh Hóa","path_with_type":"Phường Quảng Tiến, Thành phố Sầm Sơn, Tỉnh Thanh Hóa","code":"14842","parent_code":"382"},"14845":{"name":"Thị trấn Mường Lát","type":"thi-tran","slug":"thi-tran-muong-lat","name_with_type":"Thị trấn Mường Lát","path":"Thị trấn Mường Lát, Huyện Mường Lát, Tỉnh Thanh Hóa","path_with_type":"Thị trấn Mường Lát, Huyện Mường Lát, Tỉnh Thanh Hóa","code":"14845","parent_code":"384"},"14848":{"name":"Xã Tam Chung","type":"xa","slug":"xa-tam-chung","name_with_type":"Xã Tam Chung","path":"Xã Tam Chung, Huyện Mường Lát, Tỉnh Thanh Hóa","path_with_type":"Xã Tam Chung, Huyện Mường Lát, Tỉnh Thanh Hóa","code":"14848","parent_code":"384"},"14854":{"name":"Xã Mường Lý","type":"xa","slug":"xa-muong-ly","name_with_type":"Xã Mường Lý","path":"Xã Mường Lý, Huyện Mường Lát, Tỉnh Thanh Hóa","path_with_type":"Xã Mường Lý, Huyện Mường Lát, Tỉnh Thanh Hóa","code":"14854","parent_code":"384"},"14857":{"name":"Xã Trung Lý","type":"xa","slug":"xa-trung-ly","name_with_type":"Xã Trung Lý","path":"Xã Trung Lý, Huyện Mường Lát, Tỉnh Thanh Hóa","path_with_type":"Xã Trung Lý, Huyện Mường Lát, Tỉnh Thanh Hóa","code":"14857","parent_code":"384"},"14860":{"name":"Xã Quang Chiểu","type":"xa","slug":"xa-quang-chieu","name_with_type":"Xã Quang Chiểu","path":"Xã Quang Chiểu, Huyện Mường Lát, Tỉnh Thanh Hóa","path_with_type":"Xã Quang Chiểu, Huyện Mường Lát, Tỉnh Thanh Hóa","code":"14860","parent_code":"384"},"14863":{"name":"Xã Pù Nhi","type":"xa","slug":"xa-pu-nhi","name_with_type":"Xã Pù Nhi","path":"Xã Pù Nhi, Huyện Mường Lát, Tỉnh Thanh Hóa","path_with_type":"Xã Pù Nhi, Huyện Mường Lát, Tỉnh Thanh Hóa","code":"14863","parent_code":"384"},"14864":{"name":"Xã Nhi Sơn","type":"xa","slug":"xa-nhi-son","name_with_type":"Xã Nhi Sơn","path":"Xã Nhi Sơn, Huyện Mường Lát, Tỉnh Thanh Hóa","path_with_type":"Xã Nhi Sơn, Huyện Mường Lát, Tỉnh Thanh Hóa","code":"14864","parent_code":"384"},"14866":{"name":"Xã Mường Chanh","type":"xa","slug":"xa-muong-chanh","name_with_type":"Xã Mường Chanh","path":"Xã Mường Chanh, Huyện Mường Lát, Tỉnh Thanh Hóa","path_with_type":"Xã Mường Chanh, Huyện Mường Lát, Tỉnh Thanh Hóa","code":"14866","parent_code":"384"},"14869":{"name":"Thị trấn Hồi Xuân","type":"thi-tran","slug":"thi-tran-hoi-xuan","name_with_type":"Thị trấn Hồi Xuân","path":"Thị trấn Hồi Xuân, Huyện Quan Hóa, Tỉnh Thanh Hóa","path_with_type":"Thị trấn Hồi Xuân, Huyện Quan Hóa, Tỉnh Thanh Hóa","code":"14869","parent_code":"385"},"14872":{"name":"Xã Thành Sơn","type":"xa","slug":"xa-thanh-son","name_with_type":"Xã Thành Sơn","path":"Xã Thành Sơn, Huyện Quan Hóa, Tỉnh Thanh Hóa","path_with_type":"Xã Thành Sơn, Huyện Quan Hóa, Tỉnh Thanh Hóa","code":"14872","parent_code":"385"},"14875":{"name":"Xã Trung Sơn","type":"xa","slug":"xa-trung-son","name_with_type":"Xã Trung Sơn","path":"Xã Trung Sơn, Huyện Quan Hóa, Tỉnh Thanh Hóa","path_with_type":"Xã Trung Sơn, Huyện Quan Hóa, Tỉnh Thanh Hóa","code":"14875","parent_code":"385"},"14878":{"name":"Xã Phú Thanh","type":"xa","slug":"xa-phu-thanh","name_with_type":"Xã Phú Thanh","path":"Xã Phú Thanh, Huyện Quan Hóa, Tỉnh Thanh Hóa","path_with_type":"Xã Phú Thanh, Huyện Quan Hóa, Tỉnh Thanh Hóa","code":"14878","parent_code":"385"},"14881":{"name":"Xã Trung Thành","type":"xa","slug":"xa-trung-thanh","name_with_type":"Xã Trung Thành","path":"Xã Trung Thành, Huyện Quan Hóa, Tỉnh Thanh Hóa","path_with_type":"Xã Trung Thành, Huyện Quan Hóa, Tỉnh Thanh Hóa","code":"14881","parent_code":"385"},"14884":{"name":"Xã Phú Lệ","type":"xa","slug":"xa-phu-le","name_with_type":"Xã Phú Lệ","path":"Xã Phú Lệ, Huyện Quan Hóa, Tỉnh Thanh Hóa","path_with_type":"Xã Phú Lệ, Huyện Quan Hóa, Tỉnh Thanh Hóa","code":"14884","parent_code":"385"},"14887":{"name":"Xã Phú Sơn","type":"xa","slug":"xa-phu-son","name_with_type":"Xã Phú Sơn","path":"Xã Phú Sơn, Huyện Quan Hóa, Tỉnh Thanh Hóa","path_with_type":"Xã Phú Sơn, Huyện Quan Hóa, Tỉnh Thanh Hóa","code":"14887","parent_code":"385"},"14890":{"name":"Xã Phú Xuân","type":"xa","slug":"xa-phu-xuan","name_with_type":"Xã Phú Xuân","path":"Xã Phú Xuân, Huyện Quan Hóa, Tỉnh Thanh Hóa","path_with_type":"Xã Phú Xuân, Huyện Quan Hóa, Tỉnh Thanh Hóa","code":"14890","parent_code":"385"},"14896":{"name":"Xã Hiền Chung","type":"xa","slug":"xa-hien-chung","name_with_type":"Xã Hiền Chung","path":"Xã Hiền Chung, Huyện Quan Hóa, Tỉnh Thanh Hóa","path_with_type":"Xã Hiền Chung, Huyện Quan Hóa, Tỉnh Thanh Hóa","code":"14896","parent_code":"385"},"14899":{"name":"Xã Hiền Kiệt","type":"xa","slug":"xa-hien-kiet","name_with_type":"Xã Hiền Kiệt","path":"Xã Hiền Kiệt, Huyện Quan Hóa, Tỉnh Thanh Hóa","path_with_type":"Xã Hiền Kiệt, Huyện Quan Hóa, Tỉnh Thanh Hóa","code":"14899","parent_code":"385"},"14902":{"name":"Xã Nam Tiến","type":"xa","slug":"xa-nam-tien","name_with_type":"Xã Nam Tiến","path":"Xã Nam Tiến, Huyện Quan Hóa, Tỉnh Thanh Hóa","path_with_type":"Xã Nam Tiến, Huyện Quan Hóa, Tỉnh Thanh Hóa","code":"14902","parent_code":"385"},"14908":{"name":"Xã Thiên Phủ","type":"xa","slug":"xa-thien-phu","name_with_type":"Xã Thiên Phủ","path":"Xã Thiên Phủ, Huyện Quan Hóa, Tỉnh Thanh Hóa","path_with_type":"Xã Thiên Phủ, Huyện Quan Hóa, Tỉnh Thanh Hóa","code":"14908","parent_code":"385"},"14911":{"name":"Xã Phú Nghiêm","type":"xa","slug":"xa-phu-nghiem","name_with_type":"Xã Phú Nghiêm","path":"Xã Phú Nghiêm, Huyện Quan Hóa, Tỉnh Thanh Hóa","path_with_type":"Xã Phú Nghiêm, Huyện Quan Hóa, Tỉnh Thanh Hóa","code":"14911","parent_code":"385"},"14914":{"name":"Xã Nam Xuân","type":"xa","slug":"xa-nam-xuan","name_with_type":"Xã Nam Xuân","path":"Xã Nam Xuân, Huyện Quan Hóa, Tỉnh Thanh Hóa","path_with_type":"Xã Nam Xuân, Huyện Quan Hóa, Tỉnh Thanh Hóa","code":"14914","parent_code":"385"},"14917":{"name":"Xã Nam Động","type":"xa","slug":"xa-nam-dong","name_with_type":"Xã Nam Động","path":"Xã Nam Động, Huyện Quan Hóa, Tỉnh Thanh Hóa","path_with_type":"Xã Nam Động, Huyện Quan Hóa, Tỉnh Thanh Hóa","code":"14917","parent_code":"385"},"14923":{"name":"Thị trấn Cành Nàng","type":"thi-tran","slug":"thi-tran-canh-nang","name_with_type":"Thị trấn Cành Nàng","path":"Thị trấn Cành Nàng, Huyện Bá Thước, Tỉnh Thanh Hóa","path_with_type":"Thị trấn Cành Nàng, Huyện Bá Thước, Tỉnh Thanh Hóa","code":"14923","parent_code":"386"},"14926":{"name":"Xã Điền Thượng","type":"xa","slug":"xa-dien-thuong","name_with_type":"Xã Điền Thượng","path":"Xã Điền Thượng, Huyện Bá Thước, Tỉnh Thanh Hóa","path_with_type":"Xã Điền Thượng, Huyện Bá Thước, Tỉnh Thanh Hóa","code":"14926","parent_code":"386"},"14929":{"name":"Xã Điền Hạ","type":"xa","slug":"xa-dien-ha","name_with_type":"Xã Điền Hạ","path":"Xã Điền Hạ, Huyện Bá Thước, Tỉnh Thanh Hóa","path_with_type":"Xã Điền Hạ, Huyện Bá Thước, Tỉnh Thanh Hóa","code":"14929","parent_code":"386"},"14932":{"name":"Xã Điền Quang","type":"xa","slug":"xa-dien-quang","name_with_type":"Xã Điền Quang","path":"Xã Điền Quang, Huyện Bá Thước, Tỉnh Thanh Hóa","path_with_type":"Xã Điền Quang, Huyện Bá Thước, Tỉnh Thanh Hóa","code":"14932","parent_code":"386"},"14935":{"name":"Xã Điền Trung","type":"xa","slug":"xa-dien-trung","name_with_type":"Xã Điền Trung","path":"Xã Điền Trung, Huyện Bá Thước, Tỉnh Thanh Hóa","path_with_type":"Xã Điền Trung, Huyện Bá Thước, Tỉnh Thanh Hóa","code":"14935","parent_code":"386"},"14938":{"name":"Xã Thành Sơn","type":"xa","slug":"xa-thanh-son","name_with_type":"Xã Thành Sơn","path":"Xã Thành Sơn, Huyện Bá Thước, Tỉnh Thanh Hóa","path_with_type":"Xã Thành Sơn, Huyện Bá Thước, Tỉnh Thanh Hóa","code":"14938","parent_code":"386"},"14941":{"name":"Xã Lương Ngoại","type":"xa","slug":"xa-luong-ngoai","name_with_type":"Xã Lương Ngoại","path":"Xã Lương Ngoại, Huyện Bá Thước, Tỉnh Thanh Hóa","path_with_type":"Xã Lương Ngoại, Huyện Bá Thước, Tỉnh Thanh Hóa","code":"14941","parent_code":"386"},"14944":{"name":"Xã Ái Thượng","type":"xa","slug":"xa-ai-thuong","name_with_type":"Xã Ái Thượng","path":"Xã Ái Thượng, Huyện Bá Thước, Tỉnh Thanh Hóa","path_with_type":"Xã Ái Thượng, Huyện Bá Thước, Tỉnh Thanh Hóa","code":"14944","parent_code":"386"},"14947":{"name":"Xã Lương Nội","type":"xa","slug":"xa-luong-noi","name_with_type":"Xã Lương Nội","path":"Xã Lương Nội, Huyện Bá Thước, Tỉnh Thanh Hóa","path_with_type":"Xã Lương Nội, Huyện Bá Thước, Tỉnh Thanh Hóa","code":"14947","parent_code":"386"},"14950":{"name":"Xã Điền Lư","type":"xa","slug":"xa-dien-lu","name_with_type":"Xã Điền Lư","path":"Xã Điền Lư, Huyện Bá Thước, Tỉnh Thanh Hóa","path_with_type":"Xã Điền Lư, Huyện Bá Thước, Tỉnh Thanh Hóa","code":"14950","parent_code":"386"},"14953":{"name":"Xã Lương Trung","type":"xa","slug":"xa-luong-trung","name_with_type":"Xã Lương Trung","path":"Xã Lương Trung, Huyện Bá Thước, Tỉnh Thanh Hóa","path_with_type":"Xã Lương Trung, Huyện Bá Thước, Tỉnh Thanh Hóa","code":"14953","parent_code":"386"},"14956":{"name":"Xã Lũng Niêm","type":"xa","slug":"xa-lung-niem","name_with_type":"Xã Lũng Niêm","path":"Xã Lũng Niêm, Huyện Bá Thước, Tỉnh Thanh Hóa","path_with_type":"Xã Lũng Niêm, Huyện Bá Thước, Tỉnh Thanh Hóa","code":"14956","parent_code":"386"},"14959":{"name":"Xã Lũng Cao","type":"xa","slug":"xa-lung-cao","name_with_type":"Xã Lũng Cao","path":"Xã Lũng Cao, Huyện Bá Thước, Tỉnh Thanh Hóa","path_with_type":"Xã Lũng Cao, Huyện Bá Thước, Tỉnh Thanh Hóa","code":"14959","parent_code":"386"},"14962":{"name":"Xã Hạ Trung","type":"xa","slug":"xa-ha-trung","name_with_type":"Xã Hạ Trung","path":"Xã Hạ Trung, Huyện Bá Thước, Tỉnh Thanh Hóa","path_with_type":"Xã Hạ Trung, Huyện Bá Thước, Tỉnh Thanh Hóa","code":"14962","parent_code":"386"},"14965":{"name":"Xã Cổ Lũng","type":"xa","slug":"xa-co-lung","name_with_type":"Xã Cổ Lũng","path":"Xã Cổ Lũng, Huyện Bá Thước, Tỉnh Thanh Hóa","path_with_type":"Xã Cổ Lũng, Huyện Bá Thước, Tỉnh Thanh Hóa","code":"14965","parent_code":"386"},"14968":{"name":"Xã Thành Lâm","type":"xa","slug":"xa-thanh-lam","name_with_type":"Xã Thành Lâm","path":"Xã Thành Lâm, Huyện Bá Thước, Tỉnh Thanh Hóa","path_with_type":"Xã Thành Lâm, Huyện Bá Thước, Tỉnh Thanh Hóa","code":"14968","parent_code":"386"},"14971":{"name":"Xã Ban Công","type":"xa","slug":"xa-ban-cong","name_with_type":"Xã Ban Công","path":"Xã Ban Công, Huyện Bá Thước, Tỉnh Thanh Hóa","path_with_type":"Xã Ban Công, Huyện Bá Thước, Tỉnh Thanh Hóa","code":"14971","parent_code":"386"},"14974":{"name":"Xã Kỳ Tân","type":"xa","slug":"xa-ky-tan","name_with_type":"Xã Kỳ Tân","path":"Xã Kỳ Tân, Huyện Bá Thước, Tỉnh Thanh Hóa","path_with_type":"Xã Kỳ Tân, Huyện Bá Thước, Tỉnh Thanh Hóa","code":"14974","parent_code":"386"},"14977":{"name":"Xã Văn Nho","type":"xa","slug":"xa-van-nho","name_with_type":"Xã Văn Nho","path":"Xã Văn Nho, Huyện Bá Thước, Tỉnh Thanh Hóa","path_with_type":"Xã Văn Nho, Huyện Bá Thước, Tỉnh Thanh Hóa","code":"14977","parent_code":"386"},"14980":{"name":"Xã Thiết Ống","type":"xa","slug":"xa-thiet-ong","name_with_type":"Xã Thiết Ống","path":"Xã Thiết Ống, Huyện Bá Thước, Tỉnh Thanh Hóa","path_with_type":"Xã Thiết Ống, Huyện Bá Thước, Tỉnh Thanh Hóa","code":"14980","parent_code":"386"},"14986":{"name":"Xã Thiết Kế","type":"xa","slug":"xa-thiet-ke","name_with_type":"Xã Thiết Kế","path":"Xã Thiết Kế, Huyện Bá Thước, Tỉnh Thanh Hóa","path_with_type":"Xã Thiết Kế, Huyện Bá Thước, Tỉnh Thanh Hóa","code":"14986","parent_code":"386"},"14995":{"name":"Xã Trung Xuân","type":"xa","slug":"xa-trung-xuan","name_with_type":"Xã Trung Xuân","path":"Xã Trung Xuân, Huyện Quan Sơn, Tỉnh Thanh Hóa","path_with_type":"Xã Trung Xuân, Huyện Quan Sơn, Tỉnh Thanh Hóa","code":"14995","parent_code":"387"},"14998":{"name":"Xã Trung Thượng","type":"xa","slug":"xa-trung-thuong","name_with_type":"Xã Trung Thượng","path":"Xã Trung Thượng, Huyện Quan Sơn, Tỉnh Thanh Hóa","path_with_type":"Xã Trung Thượng, Huyện Quan Sơn, Tỉnh Thanh Hóa","code":"14998","parent_code":"387"},"14999":{"name":"Xã Trung Tiến","type":"xa","slug":"xa-trung-tien","name_with_type":"Xã Trung Tiến","path":"Xã Trung Tiến, Huyện Quan Sơn, Tỉnh Thanh Hóa","path_with_type":"Xã Trung Tiến, Huyện Quan Sơn, Tỉnh Thanh Hóa","code":"14999","parent_code":"387"},"15001":{"name":"Xã Trung Hạ","type":"xa","slug":"xa-trung-ha","name_with_type":"Xã Trung Hạ","path":"Xã Trung Hạ, Huyện Quan Sơn, Tỉnh Thanh Hóa","path_with_type":"Xã Trung Hạ, Huyện Quan Sơn, Tỉnh Thanh Hóa","code":"15001","parent_code":"387"},"15004":{"name":"Xã Sơn Hà","type":"xa","slug":"xa-son-ha","name_with_type":"Xã Sơn Hà","path":"Xã Sơn Hà, Huyện Quan Sơn, Tỉnh Thanh Hóa","path_with_type":"Xã Sơn Hà, Huyện Quan Sơn, Tỉnh Thanh Hóa","code":"15004","parent_code":"387"},"15007":{"name":"Xã Tam Thanh","type":"xa","slug":"xa-tam-thanh","name_with_type":"Xã Tam Thanh","path":"Xã Tam Thanh, Huyện Quan Sơn, Tỉnh Thanh Hóa","path_with_type":"Xã Tam Thanh, Huyện Quan Sơn, Tỉnh Thanh Hóa","code":"15007","parent_code":"387"},"15010":{"name":"Xã Sơn Thủy","type":"xa","slug":"xa-son-thuy","name_with_type":"Xã Sơn Thủy","path":"Xã Sơn Thủy, Huyện Quan Sơn, Tỉnh Thanh Hóa","path_with_type":"Xã Sơn Thủy, Huyện Quan Sơn, Tỉnh Thanh Hóa","code":"15010","parent_code":"387"},"15013":{"name":"Xã Na Mèo","type":"xa","slug":"xa-na-meo","name_with_type":"Xã Na Mèo","path":"Xã Na Mèo, Huyện Quan Sơn, Tỉnh Thanh Hóa","path_with_type":"Xã Na Mèo, Huyện Quan Sơn, Tỉnh Thanh Hóa","code":"15013","parent_code":"387"},"15016":{"name":"Thị trấn Sơn Lư","type":"thi-tran","slug":"thi-tran-son-lu","name_with_type":"Thị trấn Sơn Lư","path":"Thị trấn Sơn Lư, Huyện Quan Sơn, Tỉnh Thanh Hóa","path_with_type":"Thị trấn Sơn Lư, Huyện Quan Sơn, Tỉnh Thanh Hóa","code":"15016","parent_code":"387"},"15019":{"name":"Xã Tam Lư","type":"xa","slug":"xa-tam-lu","name_with_type":"Xã Tam Lư","path":"Xã Tam Lư, Huyện Quan Sơn, Tỉnh Thanh Hóa","path_with_type":"Xã Tam Lư, Huyện Quan Sơn, Tỉnh Thanh Hóa","code":"15019","parent_code":"387"},"15022":{"name":"Xã Sơn Điện","type":"xa","slug":"xa-son-dien","name_with_type":"Xã Sơn Điện","path":"Xã Sơn Điện, Huyện Quan Sơn, Tỉnh Thanh Hóa","path_with_type":"Xã Sơn Điện, Huyện Quan Sơn, Tỉnh Thanh Hóa","code":"15022","parent_code":"387"},"15025":{"name":"Xã Mường Mìn","type":"xa","slug":"xa-muong-min","name_with_type":"Xã Mường Mìn","path":"Xã Mường Mìn, Huyện Quan Sơn, Tỉnh Thanh Hóa","path_with_type":"Xã Mường Mìn, Huyện Quan Sơn, Tỉnh Thanh Hóa","code":"15025","parent_code":"387"},"15031":{"name":"Xã Yên Khương","type":"xa","slug":"xa-yen-khuong","name_with_type":"Xã Yên Khương","path":"Xã Yên Khương, Huyện Lang Chánh, Tỉnh Thanh Hóa","path_with_type":"Xã Yên Khương, Huyện Lang Chánh, Tỉnh Thanh Hóa","code":"15031","parent_code":"388"},"15034":{"name":"Xã Yên Thắng","type":"xa","slug":"xa-yen-thang","name_with_type":"Xã Yên Thắng","path":"Xã Yên Thắng, Huyện Lang Chánh, Tỉnh Thanh Hóa","path_with_type":"Xã Yên Thắng, Huyện Lang Chánh, Tỉnh Thanh Hóa","code":"15034","parent_code":"388"},"15037":{"name":"Xã Trí Nang","type":"xa","slug":"xa-tri-nang","name_with_type":"Xã Trí Nang","path":"Xã Trí Nang, Huyện Lang Chánh, Tỉnh Thanh Hóa","path_with_type":"Xã Trí Nang, Huyện Lang Chánh, Tỉnh Thanh Hóa","code":"15037","parent_code":"388"},"15040":{"name":"Xã Giao An","type":"xa","slug":"xa-giao-an","name_with_type":"Xã Giao An","path":"Xã Giao An, Huyện Lang Chánh, Tỉnh Thanh Hóa","path_with_type":"Xã Giao An, Huyện Lang Chánh, Tỉnh Thanh Hóa","code":"15040","parent_code":"388"},"15043":{"name":"Xã Giao Thiện","type":"xa","slug":"xa-giao-thien","name_with_type":"Xã Giao Thiện","path":"Xã Giao Thiện, Huyện Lang Chánh, Tỉnh Thanh Hóa","path_with_type":"Xã Giao Thiện, Huyện Lang Chánh, Tỉnh Thanh Hóa","code":"15043","parent_code":"388"},"15046":{"name":"Xã Tân Phúc","type":"xa","slug":"xa-tan-phuc","name_with_type":"Xã Tân Phúc","path":"Xã Tân Phúc, Huyện Lang Chánh, Tỉnh Thanh Hóa","path_with_type":"Xã Tân Phúc, Huyện Lang Chánh, Tỉnh Thanh Hóa","code":"15046","parent_code":"388"},"15049":{"name":"Xã Tam Văn","type":"xa","slug":"xa-tam-van","name_with_type":"Xã Tam Văn","path":"Xã Tam Văn, Huyện Lang Chánh, Tỉnh Thanh Hóa","path_with_type":"Xã Tam Văn, Huyện Lang Chánh, Tỉnh Thanh Hóa","code":"15049","parent_code":"388"},"15052":{"name":"Xã Lâm Phú","type":"xa","slug":"xa-lam-phu","name_with_type":"Xã Lâm Phú","path":"Xã Lâm Phú, Huyện Lang Chánh, Tỉnh Thanh Hóa","path_with_type":"Xã Lâm Phú, Huyện Lang Chánh, Tỉnh Thanh Hóa","code":"15052","parent_code":"388"},"15055":{"name":"Thị trấn Lang Chánh","type":"thi-tran","slug":"thi-tran-lang-chanh","name_with_type":"Thị trấn Lang Chánh","path":"Thị trấn Lang Chánh, Huyện Lang Chánh, Tỉnh Thanh Hóa","path_with_type":"Thị trấn Lang Chánh, Huyện Lang Chánh, Tỉnh Thanh Hóa","code":"15055","parent_code":"388"},"15058":{"name":"Xã Đồng Lương","type":"xa","slug":"xa-dong-luong","name_with_type":"Xã Đồng Lương","path":"Xã Đồng Lương, Huyện Lang Chánh, Tỉnh Thanh Hóa","path_with_type":"Xã Đồng Lương, Huyện Lang Chánh, Tỉnh Thanh Hóa","code":"15058","parent_code":"388"},"15061":{"name":"Thị Trấn Ngọc Lặc","type":"thi-tran","slug":"thi-tran-ngoc-lac","name_with_type":"Thị Trấn Ngọc Lặc","path":"Thị Trấn Ngọc Lặc, Huyện Ngọc Lặc, Tỉnh Thanh Hóa","path_with_type":"Thị Trấn Ngọc Lặc, Huyện Ngọc Lặc, Tỉnh Thanh Hóa","code":"15061","parent_code":"389"},"15064":{"name":"Xã Lam Sơn","type":"xa","slug":"xa-lam-son","name_with_type":"Xã Lam Sơn","path":"Xã Lam Sơn, Huyện Ngọc Lặc, Tỉnh Thanh Hóa","path_with_type":"Xã Lam Sơn, Huyện Ngọc Lặc, Tỉnh Thanh Hóa","code":"15064","parent_code":"389"},"15067":{"name":"Xã Mỹ Tân","type":"xa","slug":"xa-my-tan","name_with_type":"Xã Mỹ Tân","path":"Xã Mỹ Tân, Huyện Ngọc Lặc, Tỉnh Thanh Hóa","path_with_type":"Xã Mỹ Tân, Huyện Ngọc Lặc, Tỉnh Thanh Hóa","code":"15067","parent_code":"389"},"15070":{"name":"Xã Thúy Sơn","type":"xa","slug":"xa-thuy-son","name_with_type":"Xã Thúy Sơn","path":"Xã Thúy Sơn, Huyện Ngọc Lặc, Tỉnh Thanh Hóa","path_with_type":"Xã Thúy Sơn, Huyện Ngọc Lặc, Tỉnh Thanh Hóa","code":"15070","parent_code":"389"},"15073":{"name":"Xã Thạch Lập","type":"xa","slug":"xa-thach-lap","name_with_type":"Xã Thạch Lập","path":"Xã Thạch Lập, Huyện Ngọc Lặc, Tỉnh Thanh Hóa","path_with_type":"Xã Thạch Lập, Huyện Ngọc Lặc, Tỉnh Thanh Hóa","code":"15073","parent_code":"389"},"15076":{"name":"Xã Vân Âm","type":"xa","slug":"xa-van-am","name_with_type":"Xã Vân Âm","path":"Xã Vân Âm, Huyện Ngọc Lặc, Tỉnh Thanh Hóa","path_with_type":"Xã Vân Âm, Huyện Ngọc Lặc, Tỉnh Thanh Hóa","code":"15076","parent_code":"389"},"15079":{"name":"Xã Cao Ngọc","type":"xa","slug":"xa-cao-ngoc","name_with_type":"Xã Cao Ngọc","path":"Xã Cao Ngọc, Huyện Ngọc Lặc, Tỉnh Thanh Hóa","path_with_type":"Xã Cao Ngọc, Huyện Ngọc Lặc, Tỉnh Thanh Hóa","code":"15079","parent_code":"389"},"15085":{"name":"Xã Quang Trung","type":"xa","slug":"xa-quang-trung","name_with_type":"Xã Quang Trung","path":"Xã Quang Trung, Huyện Ngọc Lặc, Tỉnh Thanh Hóa","path_with_type":"Xã Quang Trung, Huyện Ngọc Lặc, Tỉnh Thanh Hóa","code":"15085","parent_code":"389"},"15088":{"name":"Xã Đồng Thịnh","type":"xa","slug":"xa-dong-thinh","name_with_type":"Xã Đồng Thịnh","path":"Xã Đồng Thịnh, Huyện Ngọc Lặc, Tỉnh Thanh Hóa","path_with_type":"Xã Đồng Thịnh, Huyện Ngọc Lặc, Tỉnh Thanh Hóa","code":"15088","parent_code":"389"},"15091":{"name":"Xã Ngọc Liên","type":"xa","slug":"xa-ngoc-lien","name_with_type":"Xã Ngọc Liên","path":"Xã Ngọc Liên, Huyện Ngọc Lặc, Tỉnh Thanh Hóa","path_with_type":"Xã Ngọc Liên, Huyện Ngọc Lặc, Tỉnh Thanh Hóa","code":"15091","parent_code":"389"},"15094":{"name":"Xã Ngọc Sơn","type":"xa","slug":"xa-ngoc-son","name_with_type":"Xã Ngọc Sơn","path":"Xã Ngọc Sơn, Huyện Ngọc Lặc, Tỉnh Thanh Hóa","path_with_type":"Xã Ngọc Sơn, Huyện Ngọc Lặc, Tỉnh Thanh Hóa","code":"15094","parent_code":"389"},"15097":{"name":"Xã Lộc Thịnh","type":"xa","slug":"xa-loc-thinh","name_with_type":"Xã Lộc Thịnh","path":"Xã Lộc Thịnh, Huyện Ngọc Lặc, Tỉnh Thanh Hóa","path_with_type":"Xã Lộc Thịnh, Huyện Ngọc Lặc, Tỉnh Thanh Hóa","code":"15097","parent_code":"389"},"15100":{"name":"Xã Cao Thịnh","type":"xa","slug":"xa-cao-thinh","name_with_type":"Xã Cao Thịnh","path":"Xã Cao Thịnh, Huyện Ngọc Lặc, Tỉnh Thanh Hóa","path_with_type":"Xã Cao Thịnh, Huyện Ngọc Lặc, Tỉnh Thanh Hóa","code":"15100","parent_code":"389"},"15103":{"name":"Xã Ngọc Trung","type":"xa","slug":"xa-ngoc-trung","name_with_type":"Xã Ngọc Trung","path":"Xã Ngọc Trung, Huyện Ngọc Lặc, Tỉnh Thanh Hóa","path_with_type":"Xã Ngọc Trung, Huyện Ngọc Lặc, Tỉnh Thanh Hóa","code":"15103","parent_code":"389"},"15106":{"name":"Xã Phùng Giáo","type":"xa","slug":"xa-phung-giao","name_with_type":"Xã Phùng Giáo","path":"Xã Phùng Giáo, Huyện Ngọc Lặc, Tỉnh Thanh Hóa","path_with_type":"Xã Phùng Giáo, Huyện Ngọc Lặc, Tỉnh Thanh Hóa","code":"15106","parent_code":"389"},"15109":{"name":"Xã Phùng Minh","type":"xa","slug":"xa-phung-minh","name_with_type":"Xã Phùng Minh","path":"Xã Phùng Minh, Huyện Ngọc Lặc, Tỉnh Thanh Hóa","path_with_type":"Xã Phùng Minh, Huyện Ngọc Lặc, Tỉnh Thanh Hóa","code":"15109","parent_code":"389"},"15112":{"name":"Xã Phúc Thịnh","type":"xa","slug":"xa-phuc-thinh","name_with_type":"Xã Phúc Thịnh","path":"Xã Phúc Thịnh, Huyện Ngọc Lặc, Tỉnh Thanh Hóa","path_with_type":"Xã Phúc Thịnh, Huyện Ngọc Lặc, Tỉnh Thanh Hóa","code":"15112","parent_code":"389"},"15115":{"name":"Xã Nguyệt Ấn","type":"xa","slug":"xa-nguyet-an","name_with_type":"Xã Nguyệt Ấn","path":"Xã Nguyệt Ấn, Huyện Ngọc Lặc, Tỉnh Thanh Hóa","path_with_type":"Xã Nguyệt Ấn, Huyện Ngọc Lặc, Tỉnh Thanh Hóa","code":"15115","parent_code":"389"},"15118":{"name":"Xã Kiên Thọ","type":"xa","slug":"xa-kien-tho","name_with_type":"Xã Kiên Thọ","path":"Xã Kiên Thọ, Huyện Ngọc Lặc, Tỉnh Thanh Hóa","path_with_type":"Xã Kiên Thọ, Huyện Ngọc Lặc, Tỉnh Thanh Hóa","code":"15118","parent_code":"389"},"15121":{"name":"Xã Minh Tiến","type":"xa","slug":"xa-minh-tien","name_with_type":"Xã Minh Tiến","path":"Xã Minh Tiến, Huyện Ngọc Lặc, Tỉnh Thanh Hóa","path_with_type":"Xã Minh Tiến, Huyện Ngọc Lặc, Tỉnh Thanh Hóa","code":"15121","parent_code":"389"},"15124":{"name":"Xã Minh Sơn","type":"xa","slug":"xa-minh-son","name_with_type":"Xã Minh Sơn","path":"Xã Minh Sơn, Huyện Ngọc Lặc, Tỉnh Thanh Hóa","path_with_type":"Xã Minh Sơn, Huyện Ngọc Lặc, Tỉnh Thanh Hóa","code":"15124","parent_code":"389"},"15127":{"name":"Thị trấn Phong Sơn","type":"thi-tran","slug":"thi-tran-phong-son","name_with_type":"Thị trấn Phong Sơn","path":"Thị trấn Phong Sơn, Huyện Cẩm Thủy, Tỉnh Thanh Hóa","path_with_type":"Thị trấn Phong Sơn, Huyện Cẩm Thủy, Tỉnh Thanh Hóa","code":"15127","parent_code":"390"},"15133":{"name":"Xã Cẩm Thành","type":"xa","slug":"xa-cam-thanh","name_with_type":"Xã Cẩm Thành","path":"Xã Cẩm Thành, Huyện Cẩm Thủy, Tỉnh Thanh Hóa","path_with_type":"Xã Cẩm Thành, Huyện Cẩm Thủy, Tỉnh Thanh Hóa","code":"15133","parent_code":"390"},"15136":{"name":"Xã Cẩm Quý","type":"xa","slug":"xa-cam-quy","name_with_type":"Xã Cẩm Quý","path":"Xã Cẩm Quý, Huyện Cẩm Thủy, Tỉnh Thanh Hóa","path_with_type":"Xã Cẩm Quý, Huyện Cẩm Thủy, Tỉnh Thanh Hóa","code":"15136","parent_code":"390"},"15139":{"name":"Xã Cẩm Lương","type":"xa","slug":"xa-cam-luong","name_with_type":"Xã Cẩm Lương","path":"Xã Cẩm Lương, Huyện Cẩm Thủy, Tỉnh Thanh Hóa","path_with_type":"Xã Cẩm Lương, Huyện Cẩm Thủy, Tỉnh Thanh Hóa","code":"15139","parent_code":"390"},"15142":{"name":"Xã Cẩm Thạch","type":"xa","slug":"xa-cam-thach","name_with_type":"Xã Cẩm Thạch","path":"Xã Cẩm Thạch, Huyện Cẩm Thủy, Tỉnh Thanh Hóa","path_with_type":"Xã Cẩm Thạch, Huyện Cẩm Thủy, Tỉnh Thanh Hóa","code":"15142","parent_code":"390"},"15145":{"name":"Xã Cẩm Liên","type":"xa","slug":"xa-cam-lien","name_with_type":"Xã Cẩm Liên","path":"Xã Cẩm Liên, Huyện Cẩm Thủy, Tỉnh Thanh Hóa","path_with_type":"Xã Cẩm Liên, Huyện Cẩm Thủy, Tỉnh Thanh Hóa","code":"15145","parent_code":"390"},"15148":{"name":"Xã Cẩm Giang","type":"xa","slug":"xa-cam-giang","name_with_type":"Xã Cẩm Giang","path":"Xã Cẩm Giang, Huyện Cẩm Thủy, Tỉnh Thanh Hóa","path_with_type":"Xã Cẩm Giang, Huyện Cẩm Thủy, Tỉnh Thanh Hóa","code":"15148","parent_code":"390"},"15151":{"name":"Xã Cẩm Bình","type":"xa","slug":"xa-cam-binh","name_with_type":"Xã Cẩm Bình","path":"Xã Cẩm Bình, Huyện Cẩm Thủy, Tỉnh Thanh Hóa","path_with_type":"Xã Cẩm Bình, Huyện Cẩm Thủy, Tỉnh Thanh Hóa","code":"15151","parent_code":"390"},"15154":{"name":"Xã Cẩm Tú","type":"xa","slug":"xa-cam-tu","name_with_type":"Xã Cẩm Tú","path":"Xã Cẩm Tú, Huyện Cẩm Thủy, Tỉnh Thanh Hóa","path_with_type":"Xã Cẩm Tú, Huyện Cẩm Thủy, Tỉnh Thanh Hóa","code":"15154","parent_code":"390"},"15160":{"name":"Xã Cẩm Châu","type":"xa","slug":"xa-cam-chau","name_with_type":"Xã Cẩm Châu","path":"Xã Cẩm Châu, Huyện Cẩm Thủy, Tỉnh Thanh Hóa","path_with_type":"Xã Cẩm Châu, Huyện Cẩm Thủy, Tỉnh Thanh Hóa","code":"15160","parent_code":"390"},"15163":{"name":"Xã Cẩm Tâm","type":"xa","slug":"xa-cam-tam","name_with_type":"Xã Cẩm Tâm","path":"Xã Cẩm Tâm, Huyện Cẩm Thủy, Tỉnh Thanh Hóa","path_with_type":"Xã Cẩm Tâm, Huyện Cẩm Thủy, Tỉnh Thanh Hóa","code":"15163","parent_code":"390"},"15169":{"name":"Xã Cẩm Ngọc","type":"xa","slug":"xa-cam-ngoc","name_with_type":"Xã Cẩm Ngọc","path":"Xã Cẩm Ngọc, Huyện Cẩm Thủy, Tỉnh Thanh Hóa","path_with_type":"Xã Cẩm Ngọc, Huyện Cẩm Thủy, Tỉnh Thanh Hóa","code":"15169","parent_code":"390"},"15172":{"name":"Xã Cẩm Long","type":"xa","slug":"xa-cam-long","name_with_type":"Xã Cẩm Long","path":"Xã Cẩm Long, Huyện Cẩm Thủy, Tỉnh Thanh Hóa","path_with_type":"Xã Cẩm Long, Huyện Cẩm Thủy, Tỉnh Thanh Hóa","code":"15172","parent_code":"390"},"15175":{"name":"Xã Cẩm Yên","type":"xa","slug":"xa-cam-yen","name_with_type":"Xã Cẩm Yên","path":"Xã Cẩm Yên, Huyện Cẩm Thủy, Tỉnh Thanh Hóa","path_with_type":"Xã Cẩm Yên, Huyện Cẩm Thủy, Tỉnh Thanh Hóa","code":"15175","parent_code":"390"},"15178":{"name":"Xã Cẩm Tân","type":"xa","slug":"xa-cam-tan","name_with_type":"Xã Cẩm Tân","path":"Xã Cẩm Tân, Huyện Cẩm Thủy, Tỉnh Thanh Hóa","path_with_type":"Xã Cẩm Tân, Huyện Cẩm Thủy, Tỉnh Thanh Hóa","code":"15178","parent_code":"390"},"15181":{"name":"Xã Cẩm Phú","type":"xa","slug":"xa-cam-phu","name_with_type":"Xã Cẩm Phú","path":"Xã Cẩm Phú, Huyện Cẩm Thủy, Tỉnh Thanh Hóa","path_with_type":"Xã Cẩm Phú, Huyện Cẩm Thủy, Tỉnh Thanh Hóa","code":"15181","parent_code":"390"},"15184":{"name":"Xã Cẩm Vân","type":"xa","slug":"xa-cam-van","name_with_type":"Xã Cẩm Vân","path":"Xã Cẩm Vân, Huyện Cẩm Thủy, Tỉnh Thanh Hóa","path_with_type":"Xã Cẩm Vân, Huyện Cẩm Thủy, Tỉnh Thanh Hóa","code":"15184","parent_code":"390"},"15187":{"name":"Thị trấn Kim Tân","type":"thi-tran","slug":"thi-tran-kim-tan","name_with_type":"Thị trấn Kim Tân","path":"Thị trấn Kim Tân, Huyện Thạch Thành, Tỉnh Thanh Hóa","path_with_type":"Thị trấn Kim Tân, Huyện Thạch Thành, Tỉnh Thanh Hóa","code":"15187","parent_code":"391"},"15190":{"name":"Thị trấn Vân Du","type":"thi-tran","slug":"thi-tran-van-du","name_with_type":"Thị trấn Vân Du","path":"Thị trấn Vân Du, Huyện Thạch Thành, Tỉnh Thanh Hóa","path_with_type":"Thị trấn Vân Du, Huyện Thạch Thành, Tỉnh Thanh Hóa","code":"15190","parent_code":"391"},"15196":{"name":"Xã Thạch Lâm","type":"xa","slug":"xa-thach-lam","name_with_type":"Xã Thạch Lâm","path":"Xã Thạch Lâm, Huyện Thạch Thành, Tỉnh Thanh Hóa","path_with_type":"Xã Thạch Lâm, Huyện Thạch Thành, Tỉnh Thanh Hóa","code":"15196","parent_code":"391"},"15199":{"name":"Xã Thạch Quảng","type":"xa","slug":"xa-thach-quang","name_with_type":"Xã Thạch Quảng","path":"Xã Thạch Quảng, Huyện Thạch Thành, Tỉnh Thanh Hóa","path_with_type":"Xã Thạch Quảng, Huyện Thạch Thành, Tỉnh Thanh Hóa","code":"15199","parent_code":"391"},"15202":{"name":"Xã Thạch Tượng","type":"xa","slug":"xa-thach-tuong","name_with_type":"Xã Thạch Tượng","path":"Xã Thạch Tượng, Huyện Thạch Thành, Tỉnh Thanh Hóa","path_with_type":"Xã Thạch Tượng, Huyện Thạch Thành, Tỉnh Thanh Hóa","code":"15202","parent_code":"391"},"15205":{"name":"Xã Thạch Cẩm","type":"xa","slug":"xa-thach-cam","name_with_type":"Xã Thạch Cẩm","path":"Xã Thạch Cẩm, Huyện Thạch Thành, Tỉnh Thanh Hóa","path_with_type":"Xã Thạch Cẩm, Huyện Thạch Thành, Tỉnh Thanh Hóa","code":"15205","parent_code":"391"},"15208":{"name":"Xã Thạch Sơn","type":"xa","slug":"xa-thach-son","name_with_type":"Xã Thạch Sơn","path":"Xã Thạch Sơn, Huyện Thạch Thành, Tỉnh Thanh Hóa","path_with_type":"Xã Thạch Sơn, Huyện Thạch Thành, Tỉnh Thanh Hóa","code":"15208","parent_code":"391"},"15211":{"name":"Xã Thạch Bình","type":"xa","slug":"xa-thach-binh","name_with_type":"Xã Thạch Bình","path":"Xã Thạch Bình, Huyện Thạch Thành, Tỉnh Thanh Hóa","path_with_type":"Xã Thạch Bình, Huyện Thạch Thành, Tỉnh Thanh Hóa","code":"15211","parent_code":"391"},"15214":{"name":"Xã Thạch Định","type":"xa","slug":"xa-thach-dinh","name_with_type":"Xã Thạch Định","path":"Xã Thạch Định, Huyện Thạch Thành, Tỉnh Thanh Hóa","path_with_type":"Xã Thạch Định, Huyện Thạch Thành, Tỉnh Thanh Hóa","code":"15214","parent_code":"391"},"15220":{"name":"Xã Thạch Long","type":"xa","slug":"xa-thach-long","name_with_type":"Xã Thạch Long","path":"Xã Thạch Long, Huyện Thạch Thành, Tỉnh Thanh Hóa","path_with_type":"Xã Thạch Long, Huyện Thạch Thành, Tỉnh Thanh Hóa","code":"15220","parent_code":"391"},"15223":{"name":"Xã Thành Mỹ","type":"xa","slug":"xa-thanh-my","name_with_type":"Xã Thành Mỹ","path":"Xã Thành Mỹ, Huyện Thạch Thành, Tỉnh Thanh Hóa","path_with_type":"Xã Thành Mỹ, Huyện Thạch Thành, Tỉnh Thanh Hóa","code":"15223","parent_code":"391"},"15226":{"name":"Xã Thành Yên","type":"xa","slug":"xa-thanh-yen","name_with_type":"Xã Thành Yên","path":"Xã Thành Yên, Huyện Thạch Thành, Tỉnh Thanh Hóa","path_with_type":"Xã Thành Yên, Huyện Thạch Thành, Tỉnh Thanh Hóa","code":"15226","parent_code":"391"},"15229":{"name":"Xã Thành Vinh","type":"xa","slug":"xa-thanh-vinh","name_with_type":"Xã Thành Vinh","path":"Xã Thành Vinh, Huyện Thạch Thành, Tỉnh Thanh Hóa","path_with_type":"Xã Thành Vinh, Huyện Thạch Thành, Tỉnh Thanh Hóa","code":"15229","parent_code":"391"},"15232":{"name":"Xã Thành Minh","type":"xa","slug":"xa-thanh-minh","name_with_type":"Xã Thành Minh","path":"Xã Thành Minh, Huyện Thạch Thành, Tỉnh Thanh Hóa","path_with_type":"Xã Thành Minh, Huyện Thạch Thành, Tỉnh Thanh Hóa","code":"15232","parent_code":"391"},"15235":{"name":"Xã Thành Công","type":"xa","slug":"xa-thanh-cong","name_with_type":"Xã Thành Công","path":"Xã Thành Công, Huyện Thạch Thành, Tỉnh Thanh Hóa","path_with_type":"Xã Thành Công, Huyện Thạch Thành, Tỉnh Thanh Hóa","code":"15235","parent_code":"391"},"15238":{"name":"Xã Thành Tân","type":"xa","slug":"xa-thanh-tan","name_with_type":"Xã Thành Tân","path":"Xã Thành Tân, Huyện Thạch Thành, Tỉnh Thanh Hóa","path_with_type":"Xã Thành Tân, Huyện Thạch Thành, Tỉnh Thanh Hóa","code":"15238","parent_code":"391"},"15241":{"name":"Xã Thành Trực","type":"xa","slug":"xa-thanh-truc","name_with_type":"Xã Thành Trực","path":"Xã Thành Trực, Huyện Thạch Thành, Tỉnh Thanh Hóa","path_with_type":"Xã Thành Trực, Huyện Thạch Thành, Tỉnh Thanh Hóa","code":"15241","parent_code":"391"},"15247":{"name":"Xã Thành Tâm","type":"xa","slug":"xa-thanh-tam","name_with_type":"Xã Thành Tâm","path":"Xã Thành Tâm, Huyện Thạch Thành, Tỉnh Thanh Hóa","path_with_type":"Xã Thành Tâm, Huyện Thạch Thành, Tỉnh Thanh Hóa","code":"15247","parent_code":"391"},"15250":{"name":"Xã Thành An","type":"xa","slug":"xa-thanh-an","name_with_type":"Xã Thành An","path":"Xã Thành An, Huyện Thạch Thành, Tỉnh Thanh Hóa","path_with_type":"Xã Thành An, Huyện Thạch Thành, Tỉnh Thanh Hóa","code":"15250","parent_code":"391"},"15253":{"name":"Xã Thành Thọ","type":"xa","slug":"xa-thanh-tho","name_with_type":"Xã Thành Thọ","path":"Xã Thành Thọ, Huyện Thạch Thành, Tỉnh Thanh Hóa","path_with_type":"Xã Thành Thọ, Huyện Thạch Thành, Tỉnh Thanh Hóa","code":"15253","parent_code":"391"},"15256":{"name":"Xã Thành Tiến","type":"xa","slug":"xa-thanh-tien","name_with_type":"Xã Thành Tiến","path":"Xã Thành Tiến, Huyện Thạch Thành, Tỉnh Thanh Hóa","path_with_type":"Xã Thành Tiến, Huyện Thạch Thành, Tỉnh Thanh Hóa","code":"15256","parent_code":"391"},"15259":{"name":"Xã Thành Long","type":"xa","slug":"xa-thanh-long","name_with_type":"Xã Thành Long","path":"Xã Thành Long, Huyện Thạch Thành, Tỉnh Thanh Hóa","path_with_type":"Xã Thành Long, Huyện Thạch Thành, Tỉnh Thanh Hóa","code":"15259","parent_code":"391"},"15265":{"name":"Xã Thành Hưng","type":"xa","slug":"xa-thanh-hung","name_with_type":"Xã Thành Hưng","path":"Xã Thành Hưng, Huyện Thạch Thành, Tỉnh Thanh Hóa","path_with_type":"Xã Thành Hưng, Huyện Thạch Thành, Tỉnh Thanh Hóa","code":"15265","parent_code":"391"},"15268":{"name":"Xã Ngọc Trạo","type":"xa","slug":"xa-ngoc-trao","name_with_type":"Xã Ngọc Trạo","path":"Xã Ngọc Trạo, Huyện Thạch Thành, Tỉnh Thanh Hóa","path_with_type":"Xã Ngọc Trạo, Huyện Thạch Thành, Tỉnh Thanh Hóa","code":"15268","parent_code":"391"},"15271":{"name":"Thị trấn Hà Trung","type":"thi-tran","slug":"thi-tran-ha-trung","name_with_type":"Thị trấn Hà Trung","path":"Thị trấn Hà Trung, Huyện Hà Trung, Tỉnh Thanh Hóa","path_with_type":"Thị trấn Hà Trung, Huyện Hà Trung, Tỉnh Thanh Hóa","code":"15271","parent_code":"392"},"15274":{"name":"Thị trấn Hà Long","type":"thi-tran","slug":"thi-tran-ha-long","name_with_type":"Thị trấn Hà Long","path":"Thị trấn Hà Long, Huyện Hà Trung, Tỉnh Thanh Hóa","path_with_type":"Thị trấn Hà Long, Huyện Hà Trung, Tỉnh Thanh Hóa","code":"15274","parent_code":"392"},"15277":{"name":"Xã Hà Vinh","type":"xa","slug":"xa-ha-vinh","name_with_type":"Xã Hà Vinh","path":"Xã Hà Vinh, Huyện Hà Trung, Tỉnh Thanh Hóa","path_with_type":"Xã Hà Vinh, Huyện Hà Trung, Tỉnh Thanh Hóa","code":"15277","parent_code":"392"},"15280":{"name":"Xã Hà Bắc","type":"xa","slug":"xa-ha-bac","name_with_type":"Xã Hà Bắc","path":"Xã Hà Bắc, Huyện Hà Trung, Tỉnh Thanh Hóa","path_with_type":"Xã Hà Bắc, Huyện Hà Trung, Tỉnh Thanh Hóa","code":"15280","parent_code":"392"},"15283":{"name":"Xã Hoạt Giang","type":"xa","slug":"xa-hoat-giang","name_with_type":"Xã Hoạt Giang","path":"Xã Hoạt Giang, Huyện Hà Trung, Tỉnh Thanh Hóa","path_with_type":"Xã Hoạt Giang, Huyện Hà Trung, Tỉnh Thanh Hóa","code":"15283","parent_code":"392"},"15286":{"name":"Xã Yên Dương","type":"xa","slug":"xa-yen-duong","name_with_type":"Xã Yên Dương","path":"Xã Yên Dương, Huyện Hà Trung, Tỉnh Thanh Hóa","path_with_type":"Xã Yên Dương, Huyện Hà Trung, Tỉnh Thanh Hóa","code":"15286","parent_code":"392"},"15292":{"name":"Xã Hà Giang","type":"xa","slug":"xa-ha-giang","name_with_type":"Xã Hà Giang","path":"Xã Hà Giang, Huyện Hà Trung, Tỉnh Thanh Hóa","path_with_type":"Xã Hà Giang, Huyện Hà Trung, Tỉnh Thanh Hóa","code":"15292","parent_code":"392"},"15298":{"name":"Xã Lĩnh Toại","type":"xa","slug":"xa-linh-toai","name_with_type":"Xã Lĩnh Toại","path":"Xã Lĩnh Toại, Huyện Hà Trung, Tỉnh Thanh Hóa","path_with_type":"Xã Lĩnh Toại, Huyện Hà Trung, Tỉnh Thanh Hóa","code":"15298","parent_code":"392"},"15304":{"name":"Xã Hà Ngọc","type":"xa","slug":"xa-ha-ngoc","name_with_type":"Xã Hà Ngọc","path":"Xã Hà Ngọc, Huyện Hà Trung, Tỉnh Thanh Hóa","path_with_type":"Xã Hà Ngọc, Huyện Hà Trung, Tỉnh Thanh Hóa","code":"15304","parent_code":"392"},"15307":{"name":"Xã Yến Sơn","type":"xa","slug":"xa-yen-son","name_with_type":"Xã Yến Sơn","path":"Xã Yến Sơn, Huyện Hà Trung, Tỉnh Thanh Hóa","path_with_type":"Xã Yến Sơn, Huyện Hà Trung, Tỉnh Thanh Hóa","code":"15307","parent_code":"392"},"15313":{"name":"Xã Hà Sơn","type":"xa","slug":"xa-ha-son","name_with_type":"Xã Hà Sơn","path":"Xã Hà Sơn, Huyện Hà Trung, Tỉnh Thanh Hóa","path_with_type":"Xã Hà Sơn, Huyện Hà Trung, Tỉnh Thanh Hóa","code":"15313","parent_code":"392"},"15316":{"name":"Thị trấn Hà Lĩnh","type":"thi-tran","slug":"thi-tran-ha-linh","name_with_type":"Thị trấn Hà Lĩnh","path":"Thị trấn Hà Lĩnh, Huyện Hà Trung, Tỉnh Thanh Hóa","path_with_type":"Thị trấn Hà Lĩnh, Huyện Hà Trung, Tỉnh Thanh Hóa","code":"15316","parent_code":"392"},"15319":{"name":"Xã Hà Đông","type":"xa","slug":"xa-ha-dong","name_with_type":"Xã Hà Đông","path":"Xã Hà Đông, Huyện Hà Trung, Tỉnh Thanh Hóa","path_with_type":"Xã Hà Đông, Huyện Hà Trung, Tỉnh Thanh Hóa","code":"15319","parent_code":"392"},"15322":{"name":"Xã Hà Tân","type":"xa","slug":"xa-ha-tan","name_with_type":"Xã Hà Tân","path":"Xã Hà Tân, Huyện Hà Trung, Tỉnh Thanh Hóa","path_with_type":"Xã Hà Tân, Huyện Hà Trung, Tỉnh Thanh Hóa","code":"15322","parent_code":"392"},"15325":{"name":"Xã Hà Tiến","type":"xa","slug":"xa-ha-tien","name_with_type":"Xã Hà Tiến","path":"Xã Hà Tiến, Huyện Hà Trung, Tỉnh Thanh Hóa","path_with_type":"Xã Hà Tiến, Huyện Hà Trung, Tỉnh Thanh Hóa","code":"15325","parent_code":"392"},"15328":{"name":"Xã Hà Bình","type":"xa","slug":"xa-ha-binh","name_with_type":"Xã Hà Bình","path":"Xã Hà Bình, Huyện Hà Trung, Tỉnh Thanh Hóa","path_with_type":"Xã Hà Bình, Huyện Hà Trung, Tỉnh Thanh Hóa","code":"15328","parent_code":"392"},"15331":{"name":"Xã Thái Lai","type":"xa","slug":"xa-thai-lai","name_with_type":"Xã Thái Lai","path":"Xã Thái Lai, Huyện Hà Trung, Tỉnh Thanh Hóa","path_with_type":"Xã Thái Lai, Huyện Hà Trung, Tỉnh Thanh Hóa","code":"15331","parent_code":"392"},"15334":{"name":"Xã Hà Châu","type":"xa","slug":"xa-ha-chau","name_with_type":"Xã Hà Châu","path":"Xã Hà Châu, Huyện Hà Trung, Tỉnh Thanh Hóa","path_with_type":"Xã Hà Châu, Huyện Hà Trung, Tỉnh Thanh Hóa","code":"15334","parent_code":"392"},"15343":{"name":"Xã Hà Hải","type":"xa","slug":"xa-ha-hai","name_with_type":"Xã Hà Hải","path":"Xã Hà Hải, Huyện Hà Trung, Tỉnh Thanh Hóa","path_with_type":"Xã Hà Hải, Huyện Hà Trung, Tỉnh Thanh Hóa","code":"15343","parent_code":"392"},"15349":{"name":"Thị trấn Vĩnh Lộc","type":"thi-tran","slug":"thi-tran-vinh-loc","name_with_type":"Thị trấn Vĩnh Lộc","path":"Thị trấn Vĩnh Lộc, Huyện Vĩnh Lộc, Tỉnh Thanh Hóa","path_with_type":"Thị trấn Vĩnh Lộc, Huyện Vĩnh Lộc, Tỉnh Thanh Hóa","code":"15349","parent_code":"393"},"15352":{"name":"Xã Vĩnh Quang","type":"xa","slug":"xa-vinh-quang","name_with_type":"Xã Vĩnh Quang","path":"Xã Vĩnh Quang, Huyện Vĩnh Lộc, Tỉnh Thanh Hóa","path_with_type":"Xã Vĩnh Quang, Huyện Vĩnh Lộc, Tỉnh Thanh Hóa","code":"15352","parent_code":"393"},"15355":{"name":"Xã Vĩnh Yên","type":"xa","slug":"xa-vinh-yen","name_with_type":"Xã Vĩnh Yên","path":"Xã Vĩnh Yên, Huyện Vĩnh Lộc, Tỉnh Thanh Hóa","path_with_type":"Xã Vĩnh Yên, Huyện Vĩnh Lộc, Tỉnh Thanh Hóa","code":"15355","parent_code":"393"},"15358":{"name":"Xã Vĩnh Tiến","type":"xa","slug":"xa-vinh-tien","name_with_type":"Xã Vĩnh Tiến","path":"Xã Vĩnh Tiến, Huyện Vĩnh Lộc, Tỉnh Thanh Hóa","path_with_type":"Xã Vĩnh Tiến, Huyện Vĩnh Lộc, Tỉnh Thanh Hóa","code":"15358","parent_code":"393"},"15361":{"name":"Xã Vĩnh Long","type":"xa","slug":"xa-vinh-long","name_with_type":"Xã Vĩnh Long","path":"Xã Vĩnh Long, Huyện Vĩnh Lộc, Tỉnh Thanh Hóa","path_with_type":"Xã Vĩnh Long, Huyện Vĩnh Lộc, Tỉnh Thanh Hóa","code":"15361","parent_code":"393"},"15364":{"name":"Xã Vĩnh Phúc","type":"xa","slug":"xa-vinh-phuc","name_with_type":"Xã Vĩnh Phúc","path":"Xã Vĩnh Phúc, Huyện Vĩnh Lộc, Tỉnh Thanh Hóa","path_with_type":"Xã Vĩnh Phúc, Huyện Vĩnh Lộc, Tỉnh Thanh Hóa","code":"15364","parent_code":"393"},"15367":{"name":"Xã Vĩnh Hưng","type":"xa","slug":"xa-vinh-hung","name_with_type":"Xã Vĩnh Hưng","path":"Xã Vĩnh Hưng, Huyện Vĩnh Lộc, Tỉnh Thanh Hóa","path_with_type":"Xã Vĩnh Hưng, Huyện Vĩnh Lộc, Tỉnh Thanh Hóa","code":"15367","parent_code":"393"},"15376":{"name":"Xã Vĩnh Hòa","type":"xa","slug":"xa-vinh-hoa","name_with_type":"Xã Vĩnh Hòa","path":"Xã Vĩnh Hòa, Huyện Vĩnh Lộc, Tỉnh Thanh Hóa","path_with_type":"Xã Vĩnh Hòa, Huyện Vĩnh Lộc, Tỉnh Thanh Hóa","code":"15376","parent_code":"393"},"15379":{"name":"Xã Vĩnh Hùng","type":"xa","slug":"xa-vinh-hung","name_with_type":"Xã Vĩnh Hùng","path":"Xã Vĩnh Hùng, Huyện Vĩnh Lộc, Tỉnh Thanh Hóa","path_with_type":"Xã Vĩnh Hùng, Huyện Vĩnh Lộc, Tỉnh Thanh Hóa","code":"15379","parent_code":"393"},"15382":{"name":"Xã Minh Tân","type":"xa","slug":"xa-minh-tan","name_with_type":"Xã Minh Tân","path":"Xã Minh Tân, Huyện Vĩnh Lộc, Tỉnh Thanh Hóa","path_with_type":"Xã Minh Tân, Huyện Vĩnh Lộc, Tỉnh Thanh Hóa","code":"15382","parent_code":"393"},"15385":{"name":"Xã Ninh Khang","type":"xa","slug":"xa-ninh-khang","name_with_type":"Xã Ninh Khang","path":"Xã Ninh Khang, Huyện Vĩnh Lộc, Tỉnh Thanh Hóa","path_with_type":"Xã Ninh Khang, Huyện Vĩnh Lộc, Tỉnh Thanh Hóa","code":"15385","parent_code":"393"},"15388":{"name":"Xã Vĩnh Thịnh","type":"xa","slug":"xa-vinh-thinh","name_with_type":"Xã Vĩnh Thịnh","path":"Xã Vĩnh Thịnh, Huyện Vĩnh Lộc, Tỉnh Thanh Hóa","path_with_type":"Xã Vĩnh Thịnh, Huyện Vĩnh Lộc, Tỉnh Thanh Hóa","code":"15388","parent_code":"393"},"15391":{"name":"Xã Vĩnh An","type":"xa","slug":"xa-vinh-an","name_with_type":"Xã Vĩnh An","path":"Xã Vĩnh An, Huyện Vĩnh Lộc, Tỉnh Thanh Hóa","path_with_type":"Xã Vĩnh An, Huyện Vĩnh Lộc, Tỉnh Thanh Hóa","code":"15391","parent_code":"393"},"15397":{"name":"Thị trấn Thống Nhất","type":"thi-tran","slug":"thi-tran-thong-nhat","name_with_type":"Thị trấn Thống Nhất","path":"Thị trấn Thống Nhất, Huyện Yên Định, Tỉnh Thanh Hóa","path_with_type":"Thị trấn Thống Nhất, Huyện Yên Định, Tỉnh Thanh Hóa","code":"15397","parent_code":"394"},"15403":{"name":"Thị trấn Yên Lâm","type":"thi-tran","slug":"thi-tran-yen-lam","name_with_type":"Thị trấn Yên Lâm","path":"Thị trấn Yên Lâm, Huyện Yên Định, Tỉnh Thanh Hóa","path_with_type":"Thị trấn Yên Lâm, Huyện Yên Định, Tỉnh Thanh Hóa","code":"15403","parent_code":"394"},"15406":{"name":"Xã Yên Tâm","type":"xa","slug":"xa-yen-tam","name_with_type":"Xã Yên Tâm","path":"Xã Yên Tâm, Huyện Yên Định, Tỉnh Thanh Hóa","path_with_type":"Xã Yên Tâm, Huyện Yên Định, Tỉnh Thanh Hóa","code":"15406","parent_code":"394"},"15409":{"name":"Xã Yên Phú","type":"xa","slug":"xa-yen-phu","name_with_type":"Xã Yên Phú","path":"Xã Yên Phú, Huyện Yên Định, Tỉnh Thanh Hóa","path_with_type":"Xã Yên Phú, Huyện Yên Định, Tỉnh Thanh Hóa","code":"15409","parent_code":"394"},"15412":{"name":"Thị trấn Quý Lộc","type":"thi-tran","slug":"thi-tran-quy-loc","name_with_type":"Thị trấn Quý Lộc","path":"Thị trấn Quý Lộc, Huyện Yên Định, Tỉnh Thanh Hóa","path_with_type":"Thị trấn Quý Lộc, Huyện Yên Định, Tỉnh Thanh Hóa","code":"15412","parent_code":"394"},"15415":{"name":"Xã Yên Thọ","type":"xa","slug":"xa-yen-tho","name_with_type":"Xã Yên Thọ","path":"Xã Yên Thọ, Huyện Yên Định, Tỉnh Thanh Hóa","path_with_type":"Xã Yên Thọ, Huyện Yên Định, Tỉnh Thanh Hóa","code":"15415","parent_code":"394"},"15418":{"name":"Xã Yên Trung","type":"xa","slug":"xa-yen-trung","name_with_type":"Xã Yên Trung","path":"Xã Yên Trung, Huyện Yên Định, Tỉnh Thanh Hóa","path_with_type":"Xã Yên Trung, Huyện Yên Định, Tỉnh Thanh Hóa","code":"15418","parent_code":"394"},"15421":{"name":"Xã Yên Trường","type":"xa","slug":"xa-yen-truong","name_with_type":"Xã Yên Trường","path":"Xã Yên Trường, Huyện Yên Định, Tỉnh Thanh Hóa","path_with_type":"Xã Yên Trường, Huyện Yên Định, Tỉnh Thanh Hóa","code":"15421","parent_code":"394"},"15427":{"name":"Xã Yên Phong","type":"xa","slug":"xa-yen-phong","name_with_type":"Xã Yên Phong","path":"Xã Yên Phong, Huyện Yên Định, Tỉnh Thanh Hóa","path_with_type":"Xã Yên Phong, Huyện Yên Định, Tỉnh Thanh Hóa","code":"15427","parent_code":"394"},"15430":{"name":"Xã Yên Thái","type":"xa","slug":"xa-yen-thai","name_with_type":"Xã Yên Thái","path":"Xã Yên Thái, Huyện Yên Định, Tỉnh Thanh Hóa","path_with_type":"Xã Yên Thái, Huyện Yên Định, Tỉnh Thanh Hóa","code":"15430","parent_code":"394"},"15433":{"name":"Xã Yên Hùng","type":"xa","slug":"xa-yen-hung","name_with_type":"Xã Yên Hùng","path":"Xã Yên Hùng, Huyện Yên Định, Tỉnh Thanh Hóa","path_with_type":"Xã Yên Hùng, Huyện Yên Định, Tỉnh Thanh Hóa","code":"15433","parent_code":"394"},"15436":{"name":"Xã Yên Thịnh","type":"xa","slug":"xa-yen-thinh","name_with_type":"Xã Yên Thịnh","path":"Xã Yên Thịnh, Huyện Yên Định, Tỉnh Thanh Hóa","path_with_type":"Xã Yên Thịnh, Huyện Yên Định, Tỉnh Thanh Hóa","code":"15436","parent_code":"394"},"15442":{"name":"Xã Yên Ninh","type":"xa","slug":"xa-yen-ninh","name_with_type":"Xã Yên Ninh","path":"Xã Yên Ninh, Huyện Yên Định, Tỉnh Thanh Hóa","path_with_type":"Xã Yên Ninh, Huyện Yên Định, Tỉnh Thanh Hóa","code":"15442","parent_code":"394"},"15445":{"name":"Xã Định Tăng","type":"xa","slug":"xa-dinh-tang","name_with_type":"Xã Định Tăng","path":"Xã Định Tăng, Huyện Yên Định, Tỉnh Thanh Hóa","path_with_type":"Xã Định Tăng, Huyện Yên Định, Tỉnh Thanh Hóa","code":"15445","parent_code":"394"},"15448":{"name":"Xã Định Hòa","type":"xa","slug":"xa-dinh-hoa","name_with_type":"Xã Định Hòa","path":"Xã Định Hòa, Huyện Yên Định, Tỉnh Thanh Hóa","path_with_type":"Xã Định Hòa, Huyện Yên Định, Tỉnh Thanh Hóa","code":"15448","parent_code":"394"},"15451":{"name":"Xã Định Thành","type":"xa","slug":"xa-dinh-thanh","name_with_type":"Xã Định Thành","path":"Xã Định Thành, Huyện Yên Định, Tỉnh Thanh Hóa","path_with_type":"Xã Định Thành, Huyện Yên Định, Tỉnh Thanh Hóa","code":"15451","parent_code":"394"},"15454":{"name":"Xã Định Công","type":"xa","slug":"xa-dinh-cong","name_with_type":"Xã Định Công","path":"Xã Định Công, Huyện Yên Định, Tỉnh Thanh Hóa","path_with_type":"Xã Định Công, Huyện Yên Định, Tỉnh Thanh Hóa","code":"15454","parent_code":"394"},"15457":{"name":"Xã Định Tân","type":"xa","slug":"xa-dinh-tan","name_with_type":"Xã Định Tân","path":"Xã Định Tân, Huyện Yên Định, Tỉnh Thanh Hóa","path_with_type":"Xã Định Tân, Huyện Yên Định, Tỉnh Thanh Hóa","code":"15457","parent_code":"394"},"15460":{"name":"Xã Định Tiến","type":"xa","slug":"xa-dinh-tien","name_with_type":"Xã Định Tiến","path":"Xã Định Tiến, Huyện Yên Định, Tỉnh Thanh Hóa","path_with_type":"Xã Định Tiến, Huyện Yên Định, Tỉnh Thanh Hóa","code":"15460","parent_code":"394"},"15463":{"name":"Xã Định Long","type":"xa","slug":"xa-dinh-long","name_with_type":"Xã Định Long","path":"Xã Định Long, Huyện Yên Định, Tỉnh Thanh Hóa","path_with_type":"Xã Định Long, Huyện Yên Định, Tỉnh Thanh Hóa","code":"15463","parent_code":"394"},"15466":{"name":"Xã Định Liên","type":"xa","slug":"xa-dinh-lien","name_with_type":"Xã Định Liên","path":"Xã Định Liên, Huyện Yên Định, Tỉnh Thanh Hóa","path_with_type":"Xã Định Liên, Huyện Yên Định, Tỉnh Thanh Hóa","code":"15466","parent_code":"394"},"15469":{"name":"Thị trấn Quán Lào","type":"thi-tran","slug":"thi-tran-quan-lao","name_with_type":"Thị trấn Quán Lào","path":"Thị trấn Quán Lào, Huyện Yên Định, Tỉnh Thanh Hóa","path_with_type":"Thị trấn Quán Lào, Huyện Yên Định, Tỉnh Thanh Hóa","code":"15469","parent_code":"394"},"15472":{"name":"Xã Định Hưng","type":"xa","slug":"xa-dinh-hung","name_with_type":"Xã Định Hưng","path":"Xã Định Hưng, Huyện Yên Định, Tỉnh Thanh Hóa","path_with_type":"Xã Định Hưng, Huyện Yên Định, Tỉnh Thanh Hóa","code":"15472","parent_code":"394"},"15475":{"name":"Xã Định Hải","type":"xa","slug":"xa-dinh-hai","name_with_type":"Xã Định Hải","path":"Xã Định Hải, Huyện Yên Định, Tỉnh Thanh Hóa","path_with_type":"Xã Định Hải, Huyện Yên Định, Tỉnh Thanh Hóa","code":"15475","parent_code":"394"},"15478":{"name":"Xã Định Bình","type":"xa","slug":"xa-dinh-binh","name_with_type":"Xã Định Bình","path":"Xã Định Bình, Huyện Yên Định, Tỉnh Thanh Hóa","path_with_type":"Xã Định Bình, Huyện Yên Định, Tỉnh Thanh Hóa","code":"15478","parent_code":"394"},"15493":{"name":"Xã Xuân Hồng","type":"xa","slug":"xa-xuan-hong","name_with_type":"Xã Xuân Hồng","path":"Xã Xuân Hồng, Huyện Thọ Xuân, Tỉnh Thanh Hóa","path_with_type":"Xã Xuân Hồng, Huyện Thọ Xuân, Tỉnh Thanh Hóa","code":"15493","parent_code":"395"},"15499":{"name":"Thị trấn Thọ Xuân","type":"thi-tran","slug":"thi-tran-tho-xuan","name_with_type":"Thị trấn Thọ Xuân","path":"Thị trấn Thọ Xuân, Huyện Thọ Xuân, Tỉnh Thanh Hóa","path_with_type":"Thị trấn Thọ Xuân, Huyện Thọ Xuân, Tỉnh Thanh Hóa","code":"15499","parent_code":"395"},"15502":{"name":"Xã Bắc Lương","type":"xa","slug":"xa-bac-luong","name_with_type":"Xã Bắc Lương","path":"Xã Bắc Lương, Huyện Thọ Xuân, Tỉnh Thanh Hóa","path_with_type":"Xã Bắc Lương, Huyện Thọ Xuân, Tỉnh Thanh Hóa","code":"15502","parent_code":"395"},"15505":{"name":"Xã Nam Giang","type":"xa","slug":"xa-nam-giang","name_with_type":"Xã Nam Giang","path":"Xã Nam Giang, Huyện Thọ Xuân, Tỉnh Thanh Hóa","path_with_type":"Xã Nam Giang, Huyện Thọ Xuân, Tỉnh Thanh Hóa","code":"15505","parent_code":"395"},"15508":{"name":"Xã Xuân Phong","type":"xa","slug":"xa-xuan-phong","name_with_type":"Xã Xuân Phong","path":"Xã Xuân Phong, Huyện Thọ Xuân, Tỉnh Thanh Hóa","path_with_type":"Xã Xuân Phong, Huyện Thọ Xuân, Tỉnh Thanh Hóa","code":"15508","parent_code":"395"},"15511":{"name":"Xã Thọ Lộc","type":"xa","slug":"xa-tho-loc","name_with_type":"Xã Thọ Lộc","path":"Xã Thọ Lộc, Huyện Thọ Xuân, Tỉnh Thanh Hóa","path_with_type":"Xã Thọ Lộc, Huyện Thọ Xuân, Tỉnh Thanh Hóa","code":"15511","parent_code":"395"},"15514":{"name":"Xã Xuân Trường","type":"xa","slug":"xa-xuan-truong","name_with_type":"Xã Xuân Trường","path":"Xã Xuân Trường, Huyện Thọ Xuân, Tỉnh Thanh Hóa","path_with_type":"Xã Xuân Trường, Huyện Thọ Xuân, Tỉnh Thanh Hóa","code":"15514","parent_code":"395"},"15517":{"name":"Xã Xuân Hòa","type":"xa","slug":"xa-xuan-hoa","name_with_type":"Xã Xuân Hòa","path":"Xã Xuân Hòa, Huyện Thọ Xuân, Tỉnh Thanh Hóa","path_with_type":"Xã Xuân Hòa, Huyện Thọ Xuân, Tỉnh Thanh Hóa","code":"15517","parent_code":"395"},"15520":{"name":"Xã Thọ Hải","type":"xa","slug":"xa-tho-hai","name_with_type":"Xã Thọ Hải","path":"Xã Thọ Hải, Huyện Thọ Xuân, Tỉnh Thanh Hóa","path_with_type":"Xã Thọ Hải, Huyện Thọ Xuân, Tỉnh Thanh Hóa","code":"15520","parent_code":"395"},"15523":{"name":"Xã Tây Hồ","type":"xa","slug":"xa-tay-ho","name_with_type":"Xã Tây Hồ","path":"Xã Tây Hồ, Huyện Thọ Xuân, Tỉnh Thanh Hóa","path_with_type":"Xã Tây Hồ, Huyện Thọ Xuân, Tỉnh Thanh Hóa","code":"15523","parent_code":"395"},"15526":{"name":"Xã Xuân Giang","type":"xa","slug":"xa-xuan-giang","name_with_type":"Xã Xuân Giang","path":"Xã Xuân Giang, Huyện Thọ Xuân, Tỉnh Thanh Hóa","path_with_type":"Xã Xuân Giang, Huyện Thọ Xuân, Tỉnh Thanh Hóa","code":"15526","parent_code":"395"},"15532":{"name":"Xã Xuân Sinh","type":"xa","slug":"xa-xuan-sinh","name_with_type":"Xã Xuân Sinh","path":"Xã Xuân Sinh, Huyện Thọ Xuân, Tỉnh Thanh Hóa","path_with_type":"Xã Xuân Sinh, Huyện Thọ Xuân, Tỉnh Thanh Hóa","code":"15532","parent_code":"395"},"15535":{"name":"Xã Xuân Hưng","type":"xa","slug":"xa-xuan-hung","name_with_type":"Xã Xuân Hưng","path":"Xã Xuân Hưng, Huyện Thọ Xuân, Tỉnh Thanh Hóa","path_with_type":"Xã Xuân Hưng, Huyện Thọ Xuân, Tỉnh Thanh Hóa","code":"15535","parent_code":"395"},"15538":{"name":"Xã Thọ Diên","type":"xa","slug":"xa-tho-dien","name_with_type":"Xã Thọ Diên","path":"Xã Thọ Diên, Huyện Thọ Xuân, Tỉnh Thanh Hóa","path_with_type":"Xã Thọ Diên, Huyện Thọ Xuân, Tỉnh Thanh Hóa","code":"15538","parent_code":"395"},"15541":{"name":"Xã Thọ Lâm","type":"xa","slug":"xa-tho-lam","name_with_type":"Xã Thọ Lâm","path":"Xã Thọ Lâm, Huyện Thọ Xuân, Tỉnh Thanh Hóa","path_with_type":"Xã Thọ Lâm, Huyện Thọ Xuân, Tỉnh Thanh Hóa","code":"15541","parent_code":"395"},"15544":{"name":"Xã Thọ Xương","type":"xa","slug":"xa-tho-xuong","name_with_type":"Xã Thọ Xương","path":"Xã Thọ Xương, Huyện Thọ Xuân, Tỉnh Thanh Hóa","path_with_type":"Xã Thọ Xương, Huyện Thọ Xuân, Tỉnh Thanh Hóa","code":"15544","parent_code":"395"},"15547":{"name":"Xã Xuân Bái","type":"xa","slug":"xa-xuan-bai","name_with_type":"Xã Xuân Bái","path":"Xã Xuân Bái, Huyện Thọ Xuân, Tỉnh Thanh Hóa","path_with_type":"Xã Xuân Bái, Huyện Thọ Xuân, Tỉnh Thanh Hóa","code":"15547","parent_code":"395"},"15550":{"name":"Xã Xuân Phú","type":"xa","slug":"xa-xuan-phu","name_with_type":"Xã Xuân Phú","path":"Xã Xuân Phú, Huyện Thọ Xuân, Tỉnh Thanh Hóa","path_with_type":"Xã Xuân Phú, Huyện Thọ Xuân, Tỉnh Thanh Hóa","code":"15550","parent_code":"395"},"15553":{"name":"Thị trấn Sao Vàng","type":"thi-tran","slug":"thi-tran-sao-vang","name_with_type":"Thị trấn Sao Vàng","path":"Thị trấn Sao Vàng, Huyện Thọ Xuân, Tỉnh Thanh Hóa","path_with_type":"Thị trấn Sao Vàng, Huyện Thọ Xuân, Tỉnh Thanh Hóa","code":"15553","parent_code":"395"},"15556":{"name":"Thị trấn Lam Sơn","type":"thi-tran","slug":"thi-tran-lam-son","name_with_type":"Thị trấn Lam Sơn","path":"Thị trấn Lam Sơn, Huyện Thọ Xuân, Tỉnh Thanh Hóa","path_with_type":"Thị trấn Lam Sơn, Huyện Thọ Xuân, Tỉnh Thanh Hóa","code":"15556","parent_code":"395"},"15559":{"name":"Xã Xuân Thiên","type":"xa","slug":"xa-xuan-thien","name_with_type":"Xã Xuân Thiên","path":"Xã Xuân Thiên, Huyện Thọ Xuân, Tỉnh Thanh Hóa","path_with_type":"Xã Xuân Thiên, Huyện Thọ Xuân, Tỉnh Thanh Hóa","code":"15559","parent_code":"395"},"15565":{"name":"Xã Thuận Minh","type":"xa","slug":"xa-thuan-minh","name_with_type":"Xã Thuận Minh","path":"Xã Thuận Minh, Huyện Thọ Xuân, Tỉnh Thanh Hóa","path_with_type":"Xã Thuận Minh, Huyện Thọ Xuân, Tỉnh Thanh Hóa","code":"15565","parent_code":"395"},"15568":{"name":"Xã Thọ Lập","type":"xa","slug":"xa-tho-lap","name_with_type":"Xã Thọ Lập","path":"Xã Thọ Lập, Huyện Thọ Xuân, Tỉnh Thanh Hóa","path_with_type":"Xã Thọ Lập, Huyện Thọ Xuân, Tỉnh Thanh Hóa","code":"15568","parent_code":"395"},"15571":{"name":"Xã Quảng Phú","type":"xa","slug":"xa-quang-phu","name_with_type":"Xã Quảng Phú","path":"Xã Quảng Phú, Huyện Thọ Xuân, Tỉnh Thanh Hóa","path_with_type":"Xã Quảng Phú, Huyện Thọ Xuân, Tỉnh Thanh Hóa","code":"15571","parent_code":"395"},"15574":{"name":"Xã Xuân Tín","type":"xa","slug":"xa-xuan-tin","name_with_type":"Xã Xuân Tín","path":"Xã Xuân Tín, Huyện Thọ Xuân, Tỉnh Thanh Hóa","path_with_type":"Xã Xuân Tín, Huyện Thọ Xuân, Tỉnh Thanh Hóa","code":"15574","parent_code":"395"},"15577":{"name":"Xã Phú Xuân","type":"xa","slug":"xa-phu-xuan","name_with_type":"Xã Phú Xuân","path":"Xã Phú Xuân, Huyện Thọ Xuân, Tỉnh Thanh Hóa","path_with_type":"Xã Phú Xuân, Huyện Thọ Xuân, Tỉnh Thanh Hóa","code":"15577","parent_code":"395"},"15583":{"name":"Xã Xuân Lai","type":"xa","slug":"xa-xuan-lai","name_with_type":"Xã Xuân Lai","path":"Xã Xuân Lai, Huyện Thọ Xuân, Tỉnh Thanh Hóa","path_with_type":"Xã Xuân Lai, Huyện Thọ Xuân, Tỉnh Thanh Hóa","code":"15583","parent_code":"395"},"15586":{"name":"Xã Xuân Lập","type":"xa","slug":"xa-xuan-lap","name_with_type":"Xã Xuân Lập","path":"Xã Xuân Lập, Huyện Thọ Xuân, Tỉnh Thanh Hóa","path_with_type":"Xã Xuân Lập, Huyện Thọ Xuân, Tỉnh Thanh Hóa","code":"15586","parent_code":"395"},"15592":{"name":"Xã Xuân Minh","type":"xa","slug":"xa-xuan-minh","name_with_type":"Xã Xuân Minh","path":"Xã Xuân Minh, Huyện Thọ Xuân, Tỉnh Thanh Hóa","path_with_type":"Xã Xuân Minh, Huyện Thọ Xuân, Tỉnh Thanh Hóa","code":"15592","parent_code":"395"},"15598":{"name":"Xã Trường Xuân","type":"xa","slug":"xa-truong-xuan","name_with_type":"Xã Trường Xuân","path":"Xã Trường Xuân, Huyện Thọ Xuân, Tỉnh Thanh Hóa","path_with_type":"Xã Trường Xuân, Huyện Thọ Xuân, Tỉnh Thanh Hóa","code":"15598","parent_code":"395"},"15607":{"name":"Xã Bát Mọt","type":"xa","slug":"xa-bat-mot","name_with_type":"Xã Bát Mọt","path":"Xã Bát Mọt, Huyện Thường Xuân, Tỉnh Thanh Hóa","path_with_type":"Xã Bát Mọt, Huyện Thường Xuân, Tỉnh Thanh Hóa","code":"15607","parent_code":"396"},"15610":{"name":"Xã Yên Nhân","type":"xa","slug":"xa-yen-nhan","name_with_type":"Xã Yên Nhân","path":"Xã Yên Nhân, Huyện Thường Xuân, Tỉnh Thanh Hóa","path_with_type":"Xã Yên Nhân, Huyện Thường Xuân, Tỉnh Thanh Hóa","code":"15610","parent_code":"396"},"15619":{"name":"Xã Xuân Lẹ","type":"xa","slug":"xa-xuan-le","name_with_type":"Xã Xuân Lẹ","path":"Xã Xuân Lẹ, Huyện Thường Xuân, Tỉnh Thanh Hóa","path_with_type":"Xã Xuân Lẹ, Huyện Thường Xuân, Tỉnh Thanh Hóa","code":"15619","parent_code":"396"},"15622":{"name":"Xã Vạn Xuân","type":"xa","slug":"xa-van-xuan","name_with_type":"Xã Vạn Xuân","path":"Xã Vạn Xuân, Huyện Thường Xuân, Tỉnh Thanh Hóa","path_with_type":"Xã Vạn Xuân, Huyện Thường Xuân, Tỉnh Thanh Hóa","code":"15622","parent_code":"396"},"15628":{"name":"Xã Lương Sơn","type":"xa","slug":"xa-luong-son","name_with_type":"Xã Lương Sơn","path":"Xã Lương Sơn, Huyện Thường Xuân, Tỉnh Thanh Hóa","path_with_type":"Xã Lương Sơn, Huyện Thường Xuân, Tỉnh Thanh Hóa","code":"15628","parent_code":"396"},"15631":{"name":"Xã Xuân Cao","type":"xa","slug":"xa-xuan-cao","name_with_type":"Xã Xuân Cao","path":"Xã Xuân Cao, Huyện Thường Xuân, Tỉnh Thanh Hóa","path_with_type":"Xã Xuân Cao, Huyện Thường Xuân, Tỉnh Thanh Hóa","code":"15631","parent_code":"396"},"15634":{"name":"Xã Luận Thành","type":"xa","slug":"xa-luan-thanh","name_with_type":"Xã Luận Thành","path":"Xã Luận Thành, Huyện Thường Xuân, Tỉnh Thanh Hóa","path_with_type":"Xã Luận Thành, Huyện Thường Xuân, Tỉnh Thanh Hóa","code":"15634","parent_code":"396"},"15637":{"name":"Xã Luận Khê","type":"xa","slug":"xa-luan-khe","name_with_type":"Xã Luận Khê","path":"Xã Luận Khê, Huyện Thường Xuân, Tỉnh Thanh Hóa","path_with_type":"Xã Luận Khê, Huyện Thường Xuân, Tỉnh Thanh Hóa","code":"15637","parent_code":"396"},"15640":{"name":"Xã Xuân Thắng","type":"xa","slug":"xa-xuan-thang","name_with_type":"Xã Xuân Thắng","path":"Xã Xuân Thắng, Huyện Thường Xuân, Tỉnh Thanh Hóa","path_with_type":"Xã Xuân Thắng, Huyện Thường Xuân, Tỉnh Thanh Hóa","code":"15640","parent_code":"396"},"15643":{"name":"Xã Xuân Lộc","type":"xa","slug":"xa-xuan-loc","name_with_type":"Xã Xuân Lộc","path":"Xã Xuân Lộc, Huyện Thường Xuân, Tỉnh Thanh Hóa","path_with_type":"Xã Xuân Lộc, Huyện Thường Xuân, Tỉnh Thanh Hóa","code":"15643","parent_code":"396"},"15646":{"name":"Thị trấn Thường Xuân","type":"thi-tran","slug":"thi-tran-thuong-xuan","name_with_type":"Thị trấn Thường Xuân","path":"Thị trấn Thường Xuân, Huyện Thường Xuân, Tỉnh Thanh Hóa","path_with_type":"Thị trấn Thường Xuân, Huyện Thường Xuân, Tỉnh Thanh Hóa","code":"15646","parent_code":"396"},"15649":{"name":"Xã Xuân Dương","type":"xa","slug":"xa-xuan-duong","name_with_type":"Xã Xuân Dương","path":"Xã Xuân Dương, Huyện Thường Xuân, Tỉnh Thanh Hóa","path_with_type":"Xã Xuân Dương, Huyện Thường Xuân, Tỉnh Thanh Hóa","code":"15649","parent_code":"396"},"15652":{"name":"Xã Thọ Thanh","type":"xa","slug":"xa-tho-thanh","name_with_type":"Xã Thọ Thanh","path":"Xã Thọ Thanh, Huyện Thường Xuân, Tỉnh Thanh Hóa","path_with_type":"Xã Thọ Thanh, Huyện Thường Xuân, Tỉnh Thanh Hóa","code":"15652","parent_code":"396"},"15655":{"name":"Xã Ngọc Phụng","type":"xa","slug":"xa-ngoc-phung","name_with_type":"Xã Ngọc Phụng","path":"Xã Ngọc Phụng, Huyện Thường Xuân, Tỉnh Thanh Hóa","path_with_type":"Xã Ngọc Phụng, Huyện Thường Xuân, Tỉnh Thanh Hóa","code":"15655","parent_code":"396"},"15658":{"name":"Xã Xuân Chinh","type":"xa","slug":"xa-xuan-chinh","name_with_type":"Xã Xuân Chinh","path":"Xã Xuân Chinh, Huyện Thường Xuân, Tỉnh Thanh Hóa","path_with_type":"Xã Xuân Chinh, Huyện Thường Xuân, Tỉnh Thanh Hóa","code":"15658","parent_code":"396"},"15661":{"name":"Xã Tân Thành","type":"xa","slug":"xa-tan-thanh","name_with_type":"Xã Tân Thành","path":"Xã Tân Thành, Huyện Thường Xuân, Tỉnh Thanh Hóa","path_with_type":"Xã Tân Thành, Huyện Thường Xuân, Tỉnh Thanh Hóa","code":"15661","parent_code":"396"},"15664":{"name":"Thị trấn Triệu Sơn","type":"thi-tran","slug":"thi-tran-trieu-son","name_with_type":"Thị trấn Triệu Sơn","path":"Thị trấn Triệu Sơn, Huyện Triệu Sơn, Tỉnh Thanh Hóa","path_with_type":"Thị trấn Triệu Sơn, Huyện Triệu Sơn, Tỉnh Thanh Hóa","code":"15664","parent_code":"397"},"15667":{"name":"Xã Thọ Sơn","type":"xa","slug":"xa-tho-son","name_with_type":"Xã Thọ Sơn","path":"Xã Thọ Sơn, Huyện Triệu Sơn, Tỉnh Thanh Hóa","path_with_type":"Xã Thọ Sơn, Huyện Triệu Sơn, Tỉnh Thanh Hóa","code":"15667","parent_code":"397"},"15670":{"name":"Xã Thọ Bình","type":"xa","slug":"xa-tho-binh","name_with_type":"Xã Thọ Bình","path":"Xã Thọ Bình, Huyện Triệu Sơn, Tỉnh Thanh Hóa","path_with_type":"Xã Thọ Bình, Huyện Triệu Sơn, Tỉnh Thanh Hóa","code":"15670","parent_code":"397"},"15673":{"name":"Xã Thọ Tiến","type":"xa","slug":"xa-tho-tien","name_with_type":"Xã Thọ Tiến","path":"Xã Thọ Tiến, Huyện Triệu Sơn, Tỉnh Thanh Hóa","path_with_type":"Xã Thọ Tiến, Huyện Triệu Sơn, Tỉnh Thanh Hóa","code":"15673","parent_code":"397"},"15676":{"name":"Xã Hợp Lý","type":"xa","slug":"xa-hop-ly","name_with_type":"Xã Hợp Lý","path":"Xã Hợp Lý, Huyện Triệu Sơn, Tỉnh Thanh Hóa","path_with_type":"Xã Hợp Lý, Huyện Triệu Sơn, Tỉnh Thanh Hóa","code":"15676","parent_code":"397"},"15679":{"name":"Xã Hợp Tiến","type":"xa","slug":"xa-hop-tien","name_with_type":"Xã Hợp Tiến","path":"Xã Hợp Tiến, Huyện Triệu Sơn, Tỉnh Thanh Hóa","path_with_type":"Xã Hợp Tiến, Huyện Triệu Sơn, Tỉnh Thanh Hóa","code":"15679","parent_code":"397"},"15682":{"name":"Xã Hợp Thành","type":"xa","slug":"xa-hop-thanh","name_with_type":"Xã Hợp Thành","path":"Xã Hợp Thành, Huyện Triệu Sơn, Tỉnh Thanh Hóa","path_with_type":"Xã Hợp Thành, Huyện Triệu Sơn, Tỉnh Thanh Hóa","code":"15682","parent_code":"397"},"15685":{"name":"Xã Triệu Thành","type":"xa","slug":"xa-trieu-thanh","name_with_type":"Xã Triệu Thành","path":"Xã Triệu Thành, Huyện Triệu Sơn, Tỉnh Thanh Hóa","path_with_type":"Xã Triệu Thành, Huyện Triệu Sơn, Tỉnh Thanh Hóa","code":"15685","parent_code":"397"},"15688":{"name":"Xã Hợp Thắng","type":"xa","slug":"xa-hop-thang","name_with_type":"Xã Hợp Thắng","path":"Xã Hợp Thắng, Huyện Triệu Sơn, Tỉnh Thanh Hóa","path_with_type":"Xã Hợp Thắng, Huyện Triệu Sơn, Tỉnh Thanh Hóa","code":"15688","parent_code":"397"},"15691":{"name":"Xã Minh Sơn","type":"xa","slug":"xa-minh-son","name_with_type":"Xã Minh Sơn","path":"Xã Minh Sơn, Huyện Triệu Sơn, Tỉnh Thanh Hóa","path_with_type":"Xã Minh Sơn, Huyện Triệu Sơn, Tỉnh Thanh Hóa","code":"15691","parent_code":"397"},"15700":{"name":"Xã Dân Lực","type":"xa","slug":"xa-dan-luc","name_with_type":"Xã Dân Lực","path":"Xã Dân Lực, Huyện Triệu Sơn, Tỉnh Thanh Hóa","path_with_type":"Xã Dân Lực, Huyện Triệu Sơn, Tỉnh Thanh Hóa","code":"15700","parent_code":"397"},"15703":{"name":"Xã Dân Lý","type":"xa","slug":"xa-dan-ly","name_with_type":"Xã Dân Lý","path":"Xã Dân Lý, Huyện Triệu Sơn, Tỉnh Thanh Hóa","path_with_type":"Xã Dân Lý, Huyện Triệu Sơn, Tỉnh Thanh Hóa","code":"15703","parent_code":"397"},"15706":{"name":"Xã Dân Quyền","type":"xa","slug":"xa-dan-quyen","name_with_type":"Xã Dân Quyền","path":"Xã Dân Quyền, Huyện Triệu Sơn, Tỉnh Thanh Hóa","path_with_type":"Xã Dân Quyền, Huyện Triệu Sơn, Tỉnh Thanh Hóa","code":"15706","parent_code":"397"},"15709":{"name":"Xã An Nông","type":"xa","slug":"xa-an-nong","name_with_type":"Xã An Nông","path":"Xã An Nông, Huyện Triệu Sơn, Tỉnh Thanh Hóa","path_with_type":"Xã An Nông, Huyện Triệu Sơn, Tỉnh Thanh Hóa","code":"15709","parent_code":"397"},"15712":{"name":"Xã Văn Sơn","type":"xa","slug":"xa-van-son","name_with_type":"Xã Văn Sơn","path":"Xã Văn Sơn, Huyện Triệu Sơn, Tỉnh Thanh Hóa","path_with_type":"Xã Văn Sơn, Huyện Triệu Sơn, Tỉnh Thanh Hóa","code":"15712","parent_code":"397"},"15715":{"name":"Xã Thái Hòa","type":"xa","slug":"xa-thai-hoa","name_with_type":"Xã Thái Hòa","path":"Xã Thái Hòa, Huyện Triệu Sơn, Tỉnh Thanh Hóa","path_with_type":"Xã Thái Hòa, Huyện Triệu Sơn, Tỉnh Thanh Hóa","code":"15715","parent_code":"397"},"15718":{"name":"Thị trấn Nưa","type":"thi-tran","slug":"thi-tran-nua","name_with_type":"Thị trấn Nưa","path":"Thị trấn Nưa, Huyện Triệu Sơn, Tỉnh Thanh Hóa","path_with_type":"Thị trấn Nưa, Huyện Triệu Sơn, Tỉnh Thanh Hóa","code":"15718","parent_code":"397"},"15721":{"name":"Xã Đồng Lợi","type":"xa","slug":"xa-dong-loi","name_with_type":"Xã Đồng Lợi","path":"Xã Đồng Lợi, Huyện Triệu Sơn, Tỉnh Thanh Hóa","path_with_type":"Xã Đồng Lợi, Huyện Triệu Sơn, Tỉnh Thanh Hóa","code":"15721","parent_code":"397"},"15724":{"name":"Xã Đồng Tiến","type":"xa","slug":"xa-dong-tien","name_with_type":"Xã Đồng Tiến","path":"Xã Đồng Tiến, Huyện Triệu Sơn, Tỉnh Thanh Hóa","path_with_type":"Xã Đồng Tiến, Huyện Triệu Sơn, Tỉnh Thanh Hóa","code":"15724","parent_code":"397"},"15727":{"name":"Xã Đồng Thắng","type":"xa","slug":"xa-dong-thang","name_with_type":"Xã Đồng Thắng","path":"Xã Đồng Thắng, Huyện Triệu Sơn, Tỉnh Thanh Hóa","path_with_type":"Xã Đồng Thắng, Huyện Triệu Sơn, Tỉnh Thanh Hóa","code":"15727","parent_code":"397"},"15730":{"name":"Xã Tiến Nông","type":"xa","slug":"xa-tien-nong","name_with_type":"Xã Tiến Nông","path":"Xã Tiến Nông, Huyện Triệu Sơn, Tỉnh Thanh Hóa","path_with_type":"Xã Tiến Nông, Huyện Triệu Sơn, Tỉnh Thanh Hóa","code":"15730","parent_code":"397"},"15733":{"name":"Xã Khuyến Nông","type":"xa","slug":"xa-khuyen-nong","name_with_type":"Xã Khuyến Nông","path":"Xã Khuyến Nông, Huyện Triệu Sơn, Tỉnh Thanh Hóa","path_with_type":"Xã Khuyến Nông, Huyện Triệu Sơn, Tỉnh Thanh Hóa","code":"15733","parent_code":"397"},"15736":{"name":"Xã Xuân Lộc","type":"xa","slug":"xa-xuan-loc","name_with_type":"Xã Xuân Lộc","path":"Xã Xuân Lộc, Huyện Triệu Sơn, Tỉnh Thanh Hóa","path_with_type":"Xã Xuân Lộc, Huyện Triệu Sơn, Tỉnh Thanh Hóa","code":"15736","parent_code":"397"},"15742":{"name":"Xã Thọ Dân","type":"xa","slug":"xa-tho-dan","name_with_type":"Xã Thọ Dân","path":"Xã Thọ Dân, Huyện Triệu Sơn, Tỉnh Thanh Hóa","path_with_type":"Xã Thọ Dân, Huyện Triệu Sơn, Tỉnh Thanh Hóa","code":"15742","parent_code":"397"},"15745":{"name":"Xã Xuân Thọ","type":"xa","slug":"xa-xuan-tho","name_with_type":"Xã Xuân Thọ","path":"Xã Xuân Thọ, Huyện Triệu Sơn, Tỉnh Thanh Hóa","path_with_type":"Xã Xuân Thọ, Huyện Triệu Sơn, Tỉnh Thanh Hóa","code":"15745","parent_code":"397"},"15748":{"name":"Xã Thọ Tân","type":"xa","slug":"xa-tho-tan","name_with_type":"Xã Thọ Tân","path":"Xã Thọ Tân, Huyện Triệu Sơn, Tỉnh Thanh Hóa","path_with_type":"Xã Thọ Tân, Huyện Triệu Sơn, Tỉnh Thanh Hóa","code":"15748","parent_code":"397"},"15751":{"name":"Xã Thọ Ngọc","type":"xa","slug":"xa-tho-ngoc","name_with_type":"Xã Thọ Ngọc","path":"Xã Thọ Ngọc, Huyện Triệu Sơn, Tỉnh Thanh Hóa","path_with_type":"Xã Thọ Ngọc, Huyện Triệu Sơn, Tỉnh Thanh Hóa","code":"15751","parent_code":"397"},"15754":{"name":"Xã Thọ Cường","type":"xa","slug":"xa-tho-cuong","name_with_type":"Xã Thọ Cường","path":"Xã Thọ Cường, Huyện Triệu Sơn, Tỉnh Thanh Hóa","path_with_type":"Xã Thọ Cường, Huyện Triệu Sơn, Tỉnh Thanh Hóa","code":"15754","parent_code":"397"},"15760":{"name":"Xã Thọ Phú","type":"xa","slug":"xa-tho-phu","name_with_type":"Xã Thọ Phú","path":"Xã Thọ Phú, Huyện Triệu Sơn, Tỉnh Thanh Hóa","path_with_type":"Xã Thọ Phú, Huyện Triệu Sơn, Tỉnh Thanh Hóa","code":"15760","parent_code":"397"},"15763":{"name":"Xã Thọ Thế","type":"xa","slug":"xa-tho-the","name_with_type":"Xã Thọ Thế","path":"Xã Thọ Thế, Huyện Triệu Sơn, Tỉnh Thanh Hóa","path_with_type":"Xã Thọ Thế, Huyện Triệu Sơn, Tỉnh Thanh Hóa","code":"15763","parent_code":"397"},"15766":{"name":"Xã Nông Trường","type":"xa","slug":"xa-nong-truong","name_with_type":"Xã Nông Trường","path":"Xã Nông Trường, Huyện Triệu Sơn, Tỉnh Thanh Hóa","path_with_type":"Xã Nông Trường, Huyện Triệu Sơn, Tỉnh Thanh Hóa","code":"15766","parent_code":"397"},"15769":{"name":"Xã Bình Sơn","type":"xa","slug":"xa-binh-son","name_with_type":"Xã Bình Sơn","path":"Xã Bình Sơn, Huyện Triệu Sơn, Tỉnh Thanh Hóa","path_with_type":"Xã Bình Sơn, Huyện Triệu Sơn, Tỉnh Thanh Hóa","code":"15769","parent_code":"397"},"15772":{"name":"Thị trấn Thiệu Hóa","type":"thi-tran","slug":"thi-tran-thieu-hoa","name_with_type":"Thị trấn Thiệu Hóa","path":"Thị trấn Thiệu Hóa, Huyện Thiệu Hóa, Tỉnh Thanh Hóa","path_with_type":"Thị trấn Thiệu Hóa, Huyện Thiệu Hóa, Tỉnh Thanh Hóa","code":"15772","parent_code":"398"},"15775":{"name":"Xã Thiệu Ngọc","type":"xa","slug":"xa-thieu-ngoc","name_with_type":"Xã Thiệu Ngọc","path":"Xã Thiệu Ngọc, Huyện Thiệu Hóa, Tỉnh Thanh Hóa","path_with_type":"Xã Thiệu Ngọc, Huyện Thiệu Hóa, Tỉnh Thanh Hóa","code":"15775","parent_code":"398"},"15778":{"name":"Xã Thiệu Vũ","type":"xa","slug":"xa-thieu-vu","name_with_type":"Xã Thiệu Vũ","path":"Xã Thiệu Vũ, Huyện Thiệu Hóa, Tỉnh Thanh Hóa","path_with_type":"Xã Thiệu Vũ, Huyện Thiệu Hóa, Tỉnh Thanh Hóa","code":"15778","parent_code":"398"},"15781":{"name":"Xã Thiệu Phúc","type":"xa","slug":"xa-thieu-phuc","name_with_type":"Xã Thiệu Phúc","path":"Xã Thiệu Phúc, Huyện Thiệu Hóa, Tỉnh Thanh Hóa","path_with_type":"Xã Thiệu Phúc, Huyện Thiệu Hóa, Tỉnh Thanh Hóa","code":"15781","parent_code":"398"},"15784":{"name":"Xã Thiệu Tiến","type":"xa","slug":"xa-thieu-tien","name_with_type":"Xã Thiệu Tiến","path":"Xã Thiệu Tiến, Huyện Thiệu Hóa, Tỉnh Thanh Hóa","path_with_type":"Xã Thiệu Tiến, Huyện Thiệu Hóa, Tỉnh Thanh Hóa","code":"15784","parent_code":"398"},"15787":{"name":"Xã Thiệu Công","type":"xa","slug":"xa-thieu-cong","name_with_type":"Xã Thiệu Công","path":"Xã Thiệu Công, Huyện Thiệu Hóa, Tỉnh Thanh Hóa","path_with_type":"Xã Thiệu Công, Huyện Thiệu Hóa, Tỉnh Thanh Hóa","code":"15787","parent_code":"398"},"15793":{"name":"Xã Thiệu Long","type":"xa","slug":"xa-thieu-long","name_with_type":"Xã Thiệu Long","path":"Xã Thiệu Long, Huyện Thiệu Hóa, Tỉnh Thanh Hóa","path_with_type":"Xã Thiệu Long, Huyện Thiệu Hóa, Tỉnh Thanh Hóa","code":"15793","parent_code":"398"},"15796":{"name":"Xã Thiệu Giang","type":"xa","slug":"xa-thieu-giang","name_with_type":"Xã Thiệu Giang","path":"Xã Thiệu Giang, Huyện Thiệu Hóa, Tỉnh Thanh Hóa","path_with_type":"Xã Thiệu Giang, Huyện Thiệu Hóa, Tỉnh Thanh Hóa","code":"15796","parent_code":"398"},"15799":{"name":"Xã Thiệu Duy","type":"xa","slug":"xa-thieu-duy","name_with_type":"Xã Thiệu Duy","path":"Xã Thiệu Duy, Huyện Thiệu Hóa, Tỉnh Thanh Hóa","path_with_type":"Xã Thiệu Duy, Huyện Thiệu Hóa, Tỉnh Thanh Hóa","code":"15799","parent_code":"398"},"15802":{"name":"Xã Thiệu Nguyên","type":"xa","slug":"xa-thieu-nguyen","name_with_type":"Xã Thiệu Nguyên","path":"Xã Thiệu Nguyên, Huyện Thiệu Hóa, Tỉnh Thanh Hóa","path_with_type":"Xã Thiệu Nguyên, Huyện Thiệu Hóa, Tỉnh Thanh Hóa","code":"15802","parent_code":"398"},"15805":{"name":"Xã Thiệu Hợp","type":"xa","slug":"xa-thieu-hop","name_with_type":"Xã Thiệu Hợp","path":"Xã Thiệu Hợp, Huyện Thiệu Hóa, Tỉnh Thanh Hóa","path_with_type":"Xã Thiệu Hợp, Huyện Thiệu Hóa, Tỉnh Thanh Hóa","code":"15805","parent_code":"398"},"15808":{"name":"Xã Thiệu Thịnh","type":"xa","slug":"xa-thieu-thinh","name_with_type":"Xã Thiệu Thịnh","path":"Xã Thiệu Thịnh, Huyện Thiệu Hóa, Tỉnh Thanh Hóa","path_with_type":"Xã Thiệu Thịnh, Huyện Thiệu Hóa, Tỉnh Thanh Hóa","code":"15808","parent_code":"398"},"15811":{"name":"Xã Thiệu Quang","type":"xa","slug":"xa-thieu-quang","name_with_type":"Xã Thiệu Quang","path":"Xã Thiệu Quang, Huyện Thiệu Hóa, Tỉnh Thanh Hóa","path_with_type":"Xã Thiệu Quang, Huyện Thiệu Hóa, Tỉnh Thanh Hóa","code":"15811","parent_code":"398"},"15814":{"name":"Xã Thiệu Thành","type":"xa","slug":"xa-thieu-thanh","name_with_type":"Xã Thiệu Thành","path":"Xã Thiệu Thành, Huyện Thiệu Hóa, Tỉnh Thanh Hóa","path_with_type":"Xã Thiệu Thành, Huyện Thiệu Hóa, Tỉnh Thanh Hóa","code":"15814","parent_code":"398"},"15817":{"name":"Xã Thiệu Toán","type":"xa","slug":"xa-thieu-toan","name_with_type":"Xã Thiệu Toán","path":"Xã Thiệu Toán, Huyện Thiệu Hóa, Tỉnh Thanh Hóa","path_with_type":"Xã Thiệu Toán, Huyện Thiệu Hóa, Tỉnh Thanh Hóa","code":"15817","parent_code":"398"},"15820":{"name":"Xã Thiệu Chính","type":"xa","slug":"xa-thieu-chinh","name_with_type":"Xã Thiệu Chính","path":"Xã Thiệu Chính, Huyện Thiệu Hóa, Tỉnh Thanh Hóa","path_with_type":"Xã Thiệu Chính, Huyện Thiệu Hóa, Tỉnh Thanh Hóa","code":"15820","parent_code":"398"},"15823":{"name":"Xã Thiệu Hòa","type":"xa","slug":"xa-thieu-hoa","name_with_type":"Xã Thiệu Hòa","path":"Xã Thiệu Hòa, Huyện Thiệu Hóa, Tỉnh Thanh Hóa","path_with_type":"Xã Thiệu Hòa, Huyện Thiệu Hóa, Tỉnh Thanh Hóa","code":"15823","parent_code":"398"},"15829":{"name":"Thị trấn Hậu Hiền","type":"thi-tran","slug":"thi-tran-hau-hien","name_with_type":"Thị trấn Hậu Hiền","path":"Thị trấn Hậu Hiền, Huyện Thiệu Hóa, Tỉnh Thanh Hóa","path_with_type":"Thị trấn Hậu Hiền, Huyện Thiệu Hóa, Tỉnh Thanh Hóa","code":"15829","parent_code":"398"},"15832":{"name":"Xã Thiệu Viên","type":"xa","slug":"xa-thieu-vien","name_with_type":"Xã Thiệu Viên","path":"Xã Thiệu Viên, Huyện Thiệu Hóa, Tỉnh Thanh Hóa","path_with_type":"Xã Thiệu Viên, Huyện Thiệu Hóa, Tỉnh Thanh Hóa","code":"15832","parent_code":"398"},"15835":{"name":"Xã Thiệu Lý","type":"xa","slug":"xa-thieu-ly","name_with_type":"Xã Thiệu Lý","path":"Xã Thiệu Lý, Huyện Thiệu Hóa, Tỉnh Thanh Hóa","path_with_type":"Xã Thiệu Lý, Huyện Thiệu Hóa, Tỉnh Thanh Hóa","code":"15835","parent_code":"398"},"15838":{"name":"Xã Thiệu Vận","type":"xa","slug":"xa-thieu-van","name_with_type":"Xã Thiệu Vận","path":"Xã Thiệu Vận, Huyện Thiệu Hóa, Tỉnh Thanh Hóa","path_with_type":"Xã Thiệu Vận, Huyện Thiệu Hóa, Tỉnh Thanh Hóa","code":"15838","parent_code":"398"},"15841":{"name":"Xã Thiệu Trung","type":"xa","slug":"xa-thieu-trung","name_with_type":"Xã Thiệu Trung","path":"Xã Thiệu Trung, Huyện Thiệu Hóa, Tỉnh Thanh Hóa","path_with_type":"Xã Thiệu Trung, Huyện Thiệu Hóa, Tỉnh Thanh Hóa","code":"15841","parent_code":"398"},"15847":{"name":"Xã Tân Châu","type":"xa","slug":"xa-tan-chau","name_with_type":"Xã Tân Châu","path":"Xã Tân Châu, Huyện Thiệu Hóa, Tỉnh Thanh Hóa","path_with_type":"Xã Tân Châu, Huyện Thiệu Hóa, Tỉnh Thanh Hóa","code":"15847","parent_code":"398"},"15850":{"name":"Xã Thiệu Vân","type":"xa","slug":"xa-thieu-van","name_with_type":"Xã Thiệu Vân","path":"Xã Thiệu Vân, Thành phố Thanh Hóa, Tỉnh Thanh Hóa","path_with_type":"Xã Thiệu Vân, Thành phố Thanh Hóa, Tỉnh Thanh Hóa","code":"15850","parent_code":"380"},"15853":{"name":"Xã Thiệu Giao","type":"xa","slug":"xa-thieu-giao","name_with_type":"Xã Thiệu Giao","path":"Xã Thiệu Giao, Huyện Thiệu Hóa, Tỉnh Thanh Hóa","path_with_type":"Xã Thiệu Giao, Huyện Thiệu Hóa, Tỉnh Thanh Hóa","code":"15853","parent_code":"398"},"15856":{"name":"Phường Thiệu Khánh","type":"phuong","slug":"phuong-thieu-khanh","name_with_type":"Phường Thiệu Khánh","path":"Phường Thiệu Khánh, Thành phố Thanh Hóa, Tỉnh Thanh Hóa","path_with_type":"Phường Thiệu Khánh, Thành phố Thanh Hóa, Tỉnh Thanh Hóa","code":"15856","parent_code":"380"},"15859":{"name":"Phường Thiệu Dương","type":"phuong","slug":"phuong-thieu-duong","name_with_type":"Phường Thiệu Dương","path":"Phường Thiệu Dương, Thành phố Thanh Hóa, Tỉnh Thanh Hóa","path_with_type":"Phường Thiệu Dương, Thành phố Thanh Hóa, Tỉnh Thanh Hóa","code":"15859","parent_code":"380"},"15865":{"name":"Thị trấn Bút Sơn","type":"thi-tran","slug":"thi-tran-but-son","name_with_type":"Thị trấn Bút Sơn","path":"Thị trấn Bút Sơn, Huyện Hoằng Hóa, Tỉnh Thanh Hóa","path_with_type":"Thị trấn Bút Sơn, Huyện Hoằng Hóa, Tỉnh Thanh Hóa","code":"15865","parent_code":"399"},"15877":{"name":"Xã Hoằng Xuân","type":"xa","slug":"xa-hoang-xuan","name_with_type":"Xã Hoằng Xuân","path":"Xã Hoằng Xuân, Huyện Hoằng Hóa, Tỉnh Thanh Hóa","path_with_type":"Xã Hoằng Xuân, Huyện Hoằng Hóa, Tỉnh Thanh Hóa","code":"15877","parent_code":"399"},"15880":{"name":"Xã Hoằng Giang","type":"xa","slug":"xa-hoang-giang","name_with_type":"Xã Hoằng Giang","path":"Xã Hoằng Giang, Huyện Hoằng Hóa, Tỉnh Thanh Hóa","path_with_type":"Xã Hoằng Giang, Huyện Hoằng Hóa, Tỉnh Thanh Hóa","code":"15880","parent_code":"399"},"15883":{"name":"Xã Hoằng Phú","type":"xa","slug":"xa-hoang-phu","name_with_type":"Xã Hoằng Phú","path":"Xã Hoằng Phú, Huyện Hoằng Hóa, Tỉnh Thanh Hóa","path_with_type":"Xã Hoằng Phú, Huyện Hoằng Hóa, Tỉnh Thanh Hóa","code":"15883","parent_code":"399"},"15886":{"name":"Xã Hoằng Quỳ","type":"xa","slug":"xa-hoang-quy","name_with_type":"Xã Hoằng Quỳ","path":"Xã Hoằng Quỳ, Huyện Hoằng Hóa, Tỉnh Thanh Hóa","path_with_type":"Xã Hoằng Quỳ, Huyện Hoằng Hóa, Tỉnh Thanh Hóa","code":"15886","parent_code":"399"},"15889":{"name":"Xã Hoằng Kim","type":"xa","slug":"xa-hoang-kim","name_with_type":"Xã Hoằng Kim","path":"Xã Hoằng Kim, Huyện Hoằng Hóa, Tỉnh Thanh Hóa","path_with_type":"Xã Hoằng Kim, Huyện Hoằng Hóa, Tỉnh Thanh Hóa","code":"15889","parent_code":"399"},"15892":{"name":"Xã Hoằng Trung","type":"xa","slug":"xa-hoang-trung","name_with_type":"Xã Hoằng Trung","path":"Xã Hoằng Trung, Huyện Hoằng Hóa, Tỉnh Thanh Hóa","path_with_type":"Xã Hoằng Trung, Huyện Hoằng Hóa, Tỉnh Thanh Hóa","code":"15892","parent_code":"399"},"15895":{"name":"Xã Hoằng Trinh","type":"xa","slug":"xa-hoang-trinh","name_with_type":"Xã Hoằng Trinh","path":"Xã Hoằng Trinh, Huyện Hoằng Hóa, Tỉnh Thanh Hóa","path_with_type":"Xã Hoằng Trinh, Huyện Hoằng Hóa, Tỉnh Thanh Hóa","code":"15895","parent_code":"399"},"15901":{"name":"Xã Hoằng Sơn","type":"xa","slug":"xa-hoang-son","name_with_type":"Xã Hoằng Sơn","path":"Xã Hoằng Sơn, Huyện Hoằng Hóa, Tỉnh Thanh Hóa","path_with_type":"Xã Hoằng Sơn, Huyện Hoằng Hóa, Tỉnh Thanh Hóa","code":"15901","parent_code":"399"},"15907":{"name":"Xã Hoằng Cát","type":"xa","slug":"xa-hoang-cat","name_with_type":"Xã Hoằng Cát","path":"Xã Hoằng Cát, Huyện Hoằng Hóa, Tỉnh Thanh Hóa","path_with_type":"Xã Hoằng Cát, Huyện Hoằng Hóa, Tỉnh Thanh Hóa","code":"15907","parent_code":"399"},"15910":{"name":"Xã Hoằng Xuyên","type":"xa","slug":"xa-hoang-xuyen","name_with_type":"Xã Hoằng Xuyên","path":"Xã Hoằng Xuyên, Huyện Hoằng Hóa, Tỉnh Thanh Hóa","path_with_type":"Xã Hoằng Xuyên, Huyện Hoằng Hóa, Tỉnh Thanh Hóa","code":"15910","parent_code":"399"},"15913":{"name":"Phường Tào Xuyên","type":"phuong","slug":"phuong-tao-xuyen","name_with_type":"Phường Tào Xuyên","path":"Phường Tào Xuyên, Thành phố Thanh Hóa, Tỉnh Thanh Hóa","path_with_type":"Phường Tào Xuyên, Thành phố Thanh Hóa, Tỉnh Thanh Hóa","code":"15913","parent_code":"380"},"15916":{"name":"Xã Hoằng Quý","type":"xa","slug":"xa-hoang-quy","name_with_type":"Xã Hoằng Quý","path":"Xã Hoằng Quý, Huyện Hoằng Hóa, Tỉnh Thanh Hóa","path_with_type":"Xã Hoằng Quý, Huyện Hoằng Hóa, Tỉnh Thanh Hóa","code":"15916","parent_code":"399"},"15919":{"name":"Xã Hoằng Hợp","type":"xa","slug":"xa-hoang-hop","name_with_type":"Xã Hoằng Hợp","path":"Xã Hoằng Hợp, Huyện Hoằng Hóa, Tỉnh Thanh Hóa","path_with_type":"Xã Hoằng Hợp, Huyện Hoằng Hóa, Tỉnh Thanh Hóa","code":"15919","parent_code":"399"},"15922":{"name":"Phường Long Anh","type":"phuong","slug":"phuong-long-anh","name_with_type":"Phường Long Anh","path":"Phường Long Anh, Thành phố Thanh Hóa, Tỉnh Thanh Hóa","path_with_type":"Phường Long Anh, Thành phố Thanh Hóa, Tỉnh Thanh Hóa","code":"15922","parent_code":"380"},"15925":{"name":"Phường Hoằng Quang","type":"phuong","slug":"phuong-hoang-quang","name_with_type":"Phường Hoằng Quang","path":"Phường Hoằng Quang, Thành phố Thanh Hóa, Tỉnh Thanh Hóa","path_with_type":"Phường Hoằng Quang, Thành phố Thanh Hóa, Tỉnh Thanh Hóa","code":"15925","parent_code":"380"},"15928":{"name":"Xã Hoằng Đức","type":"xa","slug":"xa-hoang-duc","name_with_type":"Xã Hoằng Đức","path":"Xã Hoằng Đức, Huyện Hoằng Hóa, Tỉnh Thanh Hóa","path_with_type":"Xã Hoằng Đức, Huyện Hoằng Hóa, Tỉnh Thanh Hóa","code":"15928","parent_code":"399"},"15937":{"name":"Xã Hoằng Hà","type":"xa","slug":"xa-hoang-ha","name_with_type":"Xã Hoằng Hà","path":"Xã Hoằng Hà, Huyện Hoằng Hóa, Tỉnh Thanh Hóa","path_with_type":"Xã Hoằng Hà, Huyện Hoằng Hóa, Tỉnh Thanh Hóa","code":"15937","parent_code":"399"},"15940":{"name":"Xã Hoằng Đạt","type":"xa","slug":"xa-hoang-dat","name_with_type":"Xã Hoằng Đạt","path":"Xã Hoằng Đạt, Huyện Hoằng Hóa, Tỉnh Thanh Hóa","path_with_type":"Xã Hoằng Đạt, Huyện Hoằng Hóa, Tỉnh Thanh Hóa","code":"15940","parent_code":"399"},"15946":{"name":"Xã Hoằng Đạo","type":"xa","slug":"xa-hoang-dao","name_with_type":"Xã Hoằng Đạo","path":"Xã Hoằng Đạo, Huyện Hoằng Hóa, Tỉnh Thanh Hóa","path_with_type":"Xã Hoằng Đạo, Huyện Hoằng Hóa, Tỉnh Thanh Hóa","code":"15946","parent_code":"399"},"15949":{"name":"Xã Hoằng Thắng","type":"xa","slug":"xa-hoang-thang","name_with_type":"Xã Hoằng Thắng","path":"Xã Hoằng Thắng, Huyện Hoằng Hóa, Tỉnh Thanh Hóa","path_with_type":"Xã Hoằng Thắng, Huyện Hoằng Hóa, Tỉnh Thanh Hóa","code":"15949","parent_code":"399"},"15952":{"name":"Xã Hoằng Đồng","type":"xa","slug":"xa-hoang-dong","name_with_type":"Xã Hoằng Đồng","path":"Xã Hoằng Đồng, Huyện Hoằng Hóa, Tỉnh Thanh Hóa","path_with_type":"Xã Hoằng Đồng, Huyện Hoằng Hóa, Tỉnh Thanh Hóa","code":"15952","parent_code":"399"},"15955":{"name":"Xã Hoằng Thái","type":"xa","slug":"xa-hoang-thai","name_with_type":"Xã Hoằng Thái","path":"Xã Hoằng Thái, Huyện Hoằng Hóa, Tỉnh Thanh Hóa","path_with_type":"Xã Hoằng Thái, Huyện Hoằng Hóa, Tỉnh Thanh Hóa","code":"15955","parent_code":"399"},"15958":{"name":"Xã Hoằng Thịnh","type":"xa","slug":"xa-hoang-thinh","name_with_type":"Xã Hoằng Thịnh","path":"Xã Hoằng Thịnh, Huyện Hoằng Hóa, Tỉnh Thanh Hóa","path_with_type":"Xã Hoằng Thịnh, Huyện Hoằng Hóa, Tỉnh Thanh Hóa","code":"15958","parent_code":"399"},"15961":{"name":"Xã Hoằng Thành","type":"xa","slug":"xa-hoang-thanh","name_with_type":"Xã Hoằng Thành","path":"Xã Hoằng Thành, Huyện Hoằng Hóa, Tỉnh Thanh Hóa","path_with_type":"Xã Hoằng Thành, Huyện Hoằng Hóa, Tỉnh Thanh Hóa","code":"15961","parent_code":"399"},"15964":{"name":"Xã Hoằng Lộc","type":"xa","slug":"xa-hoang-loc","name_with_type":"Xã Hoằng Lộc","path":"Xã Hoằng Lộc, Huyện Hoằng Hóa, Tỉnh Thanh Hóa","path_with_type":"Xã Hoằng Lộc, Huyện Hoằng Hóa, Tỉnh Thanh Hóa","code":"15964","parent_code":"399"},"15967":{"name":"Xã Hoằng Trạch","type":"xa","slug":"xa-hoang-trach","name_with_type":"Xã Hoằng Trạch","path":"Xã Hoằng Trạch, Huyện Hoằng Hóa, Tỉnh Thanh Hóa","path_with_type":"Xã Hoằng Trạch, Huyện Hoằng Hóa, Tỉnh Thanh Hóa","code":"15967","parent_code":"399"},"15970":{"name":"Phường Hoằng Đại","type":"phuong","slug":"phuong-hoang-dai","name_with_type":"Phường Hoằng Đại","path":"Phường Hoằng Đại, Thành phố Thanh Hóa, Tỉnh Thanh Hóa","path_with_type":"Phường Hoằng Đại, Thành phố Thanh Hóa, Tỉnh Thanh Hóa","code":"15970","parent_code":"380"},"15973":{"name":"Xã Hoằng Phong","type":"xa","slug":"xa-hoang-phong","name_with_type":"Xã Hoằng Phong","path":"Xã Hoằng Phong, Huyện Hoằng Hóa, Tỉnh Thanh Hóa","path_with_type":"Xã Hoằng Phong, Huyện Hoằng Hóa, Tỉnh Thanh Hóa","code":"15973","parent_code":"399"},"15976":{"name":"Xã Hoằng Lưu","type":"xa","slug":"xa-hoang-luu","name_with_type":"Xã Hoằng Lưu","path":"Xã Hoằng Lưu, Huyện Hoằng Hóa, Tỉnh Thanh Hóa","path_with_type":"Xã Hoằng Lưu, Huyện Hoằng Hóa, Tỉnh Thanh Hóa","code":"15976","parent_code":"399"},"15979":{"name":"Xã Hoằng Châu","type":"xa","slug":"xa-hoang-chau","name_with_type":"Xã Hoằng Châu","path":"Xã Hoằng Châu, Huyện Hoằng Hóa, Tỉnh Thanh Hóa","path_with_type":"Xã Hoằng Châu, Huyện Hoằng Hóa, Tỉnh Thanh Hóa","code":"15979","parent_code":"399"},"15982":{"name":"Xã Hoằng Tân","type":"xa","slug":"xa-hoang-tan","name_with_type":"Xã Hoằng Tân","path":"Xã Hoằng Tân, Huyện Hoằng Hóa, Tỉnh Thanh Hóa","path_with_type":"Xã Hoằng Tân, Huyện Hoằng Hóa, Tỉnh Thanh Hóa","code":"15982","parent_code":"399"},"15985":{"name":"Xã Hoằng Yến","type":"xa","slug":"xa-hoang-yen","name_with_type":"Xã Hoằng Yến","path":"Xã Hoằng Yến, Huyện Hoằng Hóa, Tỉnh Thanh Hóa","path_with_type":"Xã Hoằng Yến, Huyện Hoằng Hóa, Tỉnh Thanh Hóa","code":"15985","parent_code":"399"},"15988":{"name":"Xã Hoằng Tiến","type":"xa","slug":"xa-hoang-tien","name_with_type":"Xã Hoằng Tiến","path":"Xã Hoằng Tiến, Huyện Hoằng Hóa, Tỉnh Thanh Hóa","path_with_type":"Xã Hoằng Tiến, Huyện Hoằng Hóa, Tỉnh Thanh Hóa","code":"15988","parent_code":"399"},"15991":{"name":"Xã Hoằng Hải","type":"xa","slug":"xa-hoang-hai","name_with_type":"Xã Hoằng Hải","path":"Xã Hoằng Hải, Huyện Hoằng Hóa, Tỉnh Thanh Hóa","path_with_type":"Xã Hoằng Hải, Huyện Hoằng Hóa, Tỉnh Thanh Hóa","code":"15991","parent_code":"399"},"15994":{"name":"Xã Hoằng Ngọc","type":"xa","slug":"xa-hoang-ngoc","name_with_type":"Xã Hoằng Ngọc","path":"Xã Hoằng Ngọc, Huyện Hoằng Hóa, Tỉnh Thanh Hóa","path_with_type":"Xã Hoằng Ngọc, Huyện Hoằng Hóa, Tỉnh Thanh Hóa","code":"15994","parent_code":"399"},"15997":{"name":"Xã Hoằng Đông","type":"xa","slug":"xa-hoang-dong","name_with_type":"Xã Hoằng Đông","path":"Xã Hoằng Đông, Huyện Hoằng Hóa, Tỉnh Thanh Hóa","path_with_type":"Xã Hoằng Đông, Huyện Hoằng Hóa, Tỉnh Thanh Hóa","code":"15997","parent_code":"399"},"16000":{"name":"Xã Hoằng Thanh","type":"xa","slug":"xa-hoang-thanh","name_with_type":"Xã Hoằng Thanh","path":"Xã Hoằng Thanh, Huyện Hoằng Hóa, Tỉnh Thanh Hóa","path_with_type":"Xã Hoằng Thanh, Huyện Hoằng Hóa, Tỉnh Thanh Hóa","code":"16000","parent_code":"399"},"16003":{"name":"Xã Hoằng Phụ","type":"xa","slug":"xa-hoang-phu","name_with_type":"Xã Hoằng Phụ","path":"Xã Hoằng Phụ, Huyện Hoằng Hóa, Tỉnh Thanh Hóa","path_with_type":"Xã Hoằng Phụ, Huyện Hoằng Hóa, Tỉnh Thanh Hóa","code":"16003","parent_code":"399"},"16006":{"name":"Xã Hoằng Trường","type":"xa","slug":"xa-hoang-truong","name_with_type":"Xã Hoằng Trường","path":"Xã Hoằng Trường, Huyện Hoằng Hóa, Tỉnh Thanh Hóa","path_with_type":"Xã Hoằng Trường, Huyện Hoằng Hóa, Tỉnh Thanh Hóa","code":"16006","parent_code":"399"},"16012":{"name":"Thị trấn Hậu Lộc","type":"thi-tran","slug":"thi-tran-hau-loc","name_with_type":"Thị trấn Hậu Lộc","path":"Thị trấn Hậu Lộc, Huyện Hậu Lộc, Tỉnh Thanh Hóa","path_with_type":"Thị trấn Hậu Lộc, Huyện Hậu Lộc, Tỉnh Thanh Hóa","code":"16012","parent_code":"400"},"16015":{"name":"Xã Đồng Lộc","type":"xa","slug":"xa-dong-loc","name_with_type":"Xã Đồng Lộc","path":"Xã Đồng Lộc, Huyện Hậu Lộc, Tỉnh Thanh Hóa","path_with_type":"Xã Đồng Lộc, Huyện Hậu Lộc, Tỉnh Thanh Hóa","code":"16015","parent_code":"400"},"16018":{"name":"Xã Đại Lộc","type":"xa","slug":"xa-dai-loc","name_with_type":"Xã Đại Lộc","path":"Xã Đại Lộc, Huyện Hậu Lộc, Tỉnh Thanh Hóa","path_with_type":"Xã Đại Lộc, Huyện Hậu Lộc, Tỉnh Thanh Hóa","code":"16018","parent_code":"400"},"16021":{"name":"Xã Triệu Lộc","type":"xa","slug":"xa-trieu-loc","name_with_type":"Xã Triệu Lộc","path":"Xã Triệu Lộc, Huyện Hậu Lộc, Tỉnh Thanh Hóa","path_with_type":"Xã Triệu Lộc, Huyện Hậu Lộc, Tỉnh Thanh Hóa","code":"16021","parent_code":"400"},"16027":{"name":"Xã Tiến Lộc","type":"xa","slug":"xa-tien-loc","name_with_type":"Xã Tiến Lộc","path":"Xã Tiến Lộc, Huyện Hậu Lộc, Tỉnh Thanh Hóa","path_with_type":"Xã Tiến Lộc, Huyện Hậu Lộc, Tỉnh Thanh Hóa","code":"16027","parent_code":"400"},"16030":{"name":"Xã Lộc Sơn","type":"xa","slug":"xa-loc-son","name_with_type":"Xã Lộc Sơn","path":"Xã Lộc Sơn, Huyện Hậu Lộc, Tỉnh Thanh Hóa","path_with_type":"Xã Lộc Sơn, Huyện Hậu Lộc, Tỉnh Thanh Hóa","code":"16030","parent_code":"400"},"16033":{"name":"Xã Cầu Lộc","type":"xa","slug":"xa-cau-loc","name_with_type":"Xã Cầu Lộc","path":"Xã Cầu Lộc, Huyện Hậu Lộc, Tỉnh Thanh Hóa","path_with_type":"Xã Cầu Lộc, Huyện Hậu Lộc, Tỉnh Thanh Hóa","code":"16033","parent_code":"400"},"16036":{"name":"Xã Thành Lộc","type":"xa","slug":"xa-thanh-loc","name_with_type":"Xã Thành Lộc","path":"Xã Thành Lộc, Huyện Hậu Lộc, Tỉnh Thanh Hóa","path_with_type":"Xã Thành Lộc, Huyện Hậu Lộc, Tỉnh Thanh Hóa","code":"16036","parent_code":"400"},"16042":{"name":"Xã Tuy Lộc","type":"xa","slug":"xa-tuy-loc","name_with_type":"Xã Tuy Lộc","path":"Xã Tuy Lộc, Huyện Hậu Lộc, Tỉnh Thanh Hóa","path_with_type":"Xã Tuy Lộc, Huyện Hậu Lộc, Tỉnh Thanh Hóa","code":"16042","parent_code":"400"},"16045":{"name":"Xã Mỹ Lộc","type":"xa","slug":"xa-my-loc","name_with_type":"Xã Mỹ Lộc","path":"Xã Mỹ Lộc, Huyện Hậu Lộc, Tỉnh Thanh Hóa","path_with_type":"Xã Mỹ Lộc, Huyện Hậu Lộc, Tỉnh Thanh Hóa","code":"16045","parent_code":"400"},"16048":{"name":"Xã Thuần Lộc","type":"xa","slug":"xa-thuan-loc","name_with_type":"Xã Thuần Lộc","path":"Xã Thuần Lộc, Huyện Hậu Lộc, Tỉnh Thanh Hóa","path_with_type":"Xã Thuần Lộc, Huyện Hậu Lộc, Tỉnh Thanh Hóa","code":"16048","parent_code":"400"},"16057":{"name":"Xã Xuân Lộc","type":"xa","slug":"xa-xuan-loc","name_with_type":"Xã Xuân Lộc","path":"Xã Xuân Lộc, Huyện Hậu Lộc, Tỉnh Thanh Hóa","path_with_type":"Xã Xuân Lộc, Huyện Hậu Lộc, Tỉnh Thanh Hóa","code":"16057","parent_code":"400"},"16063":{"name":"Xã Hoa Lộc","type":"xa","slug":"xa-hoa-loc","name_with_type":"Xã Hoa Lộc","path":"Xã Hoa Lộc, Huyện Hậu Lộc, Tỉnh Thanh Hóa","path_with_type":"Xã Hoa Lộc, Huyện Hậu Lộc, Tỉnh Thanh Hóa","code":"16063","parent_code":"400"},"16066":{"name":"Xã Liên Lộc","type":"xa","slug":"xa-lien-loc","name_with_type":"Xã Liên Lộc","path":"Xã Liên Lộc, Huyện Hậu Lộc, Tỉnh Thanh Hóa","path_with_type":"Xã Liên Lộc, Huyện Hậu Lộc, Tỉnh Thanh Hóa","code":"16066","parent_code":"400"},"16069":{"name":"Xã Quang Lộc","type":"xa","slug":"xa-quang-loc","name_with_type":"Xã Quang Lộc","path":"Xã Quang Lộc, Huyện Hậu Lộc, Tỉnh Thanh Hóa","path_with_type":"Xã Quang Lộc, Huyện Hậu Lộc, Tỉnh Thanh Hóa","code":"16069","parent_code":"400"},"16072":{"name":"Xã Phú Lộc","type":"xa","slug":"xa-phu-loc","name_with_type":"Xã Phú Lộc","path":"Xã Phú Lộc, Huyện Hậu Lộc, Tỉnh Thanh Hóa","path_with_type":"Xã Phú Lộc, Huyện Hậu Lộc, Tỉnh Thanh Hóa","code":"16072","parent_code":"400"},"16075":{"name":"Xã Hòa Lộc","type":"xa","slug":"xa-hoa-loc","name_with_type":"Xã Hòa Lộc","path":"Xã Hòa Lộc, Huyện Hậu Lộc, Tỉnh Thanh Hóa","path_with_type":"Xã Hòa Lộc, Huyện Hậu Lộc, Tỉnh Thanh Hóa","code":"16075","parent_code":"400"},"16078":{"name":"Xã Minh Lộc","type":"xa","slug":"xa-minh-loc","name_with_type":"Xã Minh Lộc","path":"Xã Minh Lộc, Huyện Hậu Lộc, Tỉnh Thanh Hóa","path_with_type":"Xã Minh Lộc, Huyện Hậu Lộc, Tỉnh Thanh Hóa","code":"16078","parent_code":"400"},"16081":{"name":"Xã Hưng Lộc","type":"xa","slug":"xa-hung-loc","name_with_type":"Xã Hưng Lộc","path":"Xã Hưng Lộc, Huyện Hậu Lộc, Tỉnh Thanh Hóa","path_with_type":"Xã Hưng Lộc, Huyện Hậu Lộc, Tỉnh Thanh Hóa","code":"16081","parent_code":"400"},"16084":{"name":"Xã Hải Lộc","type":"xa","slug":"xa-hai-loc","name_with_type":"Xã Hải Lộc","path":"Xã Hải Lộc, Huyện Hậu Lộc, Tỉnh Thanh Hóa","path_with_type":"Xã Hải Lộc, Huyện Hậu Lộc, Tỉnh Thanh Hóa","code":"16084","parent_code":"400"},"16087":{"name":"Xã Đa Lộc","type":"xa","slug":"xa-da-loc","name_with_type":"Xã Đa Lộc","path":"Xã Đa Lộc, Huyện Hậu Lộc, Tỉnh Thanh Hóa","path_with_type":"Xã Đa Lộc, Huyện Hậu Lộc, Tỉnh Thanh Hóa","code":"16087","parent_code":"400"},"16090":{"name":"Xã Ngư Lộc","type":"xa","slug":"xa-ngu-loc","name_with_type":"Xã Ngư Lộc","path":"Xã Ngư Lộc, Huyện Hậu Lộc, Tỉnh Thanh Hóa","path_with_type":"Xã Ngư Lộc, Huyện Hậu Lộc, Tỉnh Thanh Hóa","code":"16090","parent_code":"400"},"16093":{"name":"Thị trấn Nga Sơn","type":"thi-tran","slug":"thi-tran-nga-son","name_with_type":"Thị trấn Nga Sơn","path":"Thị trấn Nga Sơn, Huyện Nga Sơn, Tỉnh Thanh Hóa","path_with_type":"Thị trấn Nga Sơn, Huyện Nga Sơn, Tỉnh Thanh Hóa","code":"16093","parent_code":"401"},"16096":{"name":"Xã Ba Đình","type":"xa","slug":"xa-ba-dinh","name_with_type":"Xã Ba Đình","path":"Xã Ba Đình, Huyện Nga Sơn, Tỉnh Thanh Hóa","path_with_type":"Xã Ba Đình, Huyện Nga Sơn, Tỉnh Thanh Hóa","code":"16096","parent_code":"401"},"16099":{"name":"Xã Nga Vịnh","type":"xa","slug":"xa-nga-vinh","name_with_type":"Xã Nga Vịnh","path":"Xã Nga Vịnh, Huyện Nga Sơn, Tỉnh Thanh Hóa","path_with_type":"Xã Nga Vịnh, Huyện Nga Sơn, Tỉnh Thanh Hóa","code":"16099","parent_code":"401"},"16102":{"name":"Xã Nga Văn","type":"xa","slug":"xa-nga-van","name_with_type":"Xã Nga Văn","path":"Xã Nga Văn, Huyện Nga Sơn, Tỉnh Thanh Hóa","path_with_type":"Xã Nga Văn, Huyện Nga Sơn, Tỉnh Thanh Hóa","code":"16102","parent_code":"401"},"16105":{"name":"Xã Nga Thiện","type":"xa","slug":"xa-nga-thien","name_with_type":"Xã Nga Thiện","path":"Xã Nga Thiện, Huyện Nga Sơn, Tỉnh Thanh Hóa","path_with_type":"Xã Nga Thiện, Huyện Nga Sơn, Tỉnh Thanh Hóa","code":"16105","parent_code":"401"},"16108":{"name":"Xã Nga Tiến","type":"xa","slug":"xa-nga-tien","name_with_type":"Xã Nga Tiến","path":"Xã Nga Tiến, Huyện Nga Sơn, Tỉnh Thanh Hóa","path_with_type":"Xã Nga Tiến, Huyện Nga Sơn, Tỉnh Thanh Hóa","code":"16108","parent_code":"401"},"16114":{"name":"Xã Nga Phượng","type":"xa","slug":"xa-nga-phuong","name_with_type":"Xã Nga Phượng","path":"Xã Nga Phượng, Huyện Nga Sơn, Tỉnh Thanh Hóa","path_with_type":"Xã Nga Phượng, Huyện Nga Sơn, Tỉnh Thanh Hóa","code":"16114","parent_code":"401"},"16120":{"name":"Xã Nga Hiệp","type":"xa","slug":"xa-nga-hiep","name_with_type":"Xã Nga Hiệp","path":"Xã Nga Hiệp, Huyện Nga Sơn, Tỉnh Thanh Hóa","path_with_type":"Xã Nga Hiệp, Huyện Nga Sơn, Tỉnh Thanh Hóa","code":"16120","parent_code":"401"},"16123":{"name":"Xã Nga Thanh","type":"xa","slug":"xa-nga-thanh","name_with_type":"Xã Nga Thanh","path":"Xã Nga Thanh, Huyện Nga Sơn, Tỉnh Thanh Hóa","path_with_type":"Xã Nga Thanh, Huyện Nga Sơn, Tỉnh Thanh Hóa","code":"16123","parent_code":"401"},"16132":{"name":"Xã Nga Yên","type":"xa","slug":"xa-nga-yen","name_with_type":"Xã Nga Yên","path":"Xã Nga Yên, Huyện Nga Sơn, Tỉnh Thanh Hóa","path_with_type":"Xã Nga Yên, Huyện Nga Sơn, Tỉnh Thanh Hóa","code":"16132","parent_code":"401"},"16135":{"name":"Xã Nga Giáp","type":"xa","slug":"xa-nga-giap","name_with_type":"Xã Nga Giáp","path":"Xã Nga Giáp, Huyện Nga Sơn, Tỉnh Thanh Hóa","path_with_type":"Xã Nga Giáp, Huyện Nga Sơn, Tỉnh Thanh Hóa","code":"16135","parent_code":"401"},"16138":{"name":"Xã Nga Hải","type":"xa","slug":"xa-nga-hai","name_with_type":"Xã Nga Hải","path":"Xã Nga Hải, Huyện Nga Sơn, Tỉnh Thanh Hóa","path_with_type":"Xã Nga Hải, Huyện Nga Sơn, Tỉnh Thanh Hóa","code":"16138","parent_code":"401"},"16141":{"name":"Xã Nga Thành","type":"xa","slug":"xa-nga-thanh","name_with_type":"Xã Nga Thành","path":"Xã Nga Thành, Huyện Nga Sơn, Tỉnh Thanh Hóa","path_with_type":"Xã Nga Thành, Huyện Nga Sơn, Tỉnh Thanh Hóa","code":"16141","parent_code":"401"},"16144":{"name":"Xã Nga An","type":"xa","slug":"xa-nga-an","name_with_type":"Xã Nga An","path":"Xã Nga An, Huyện Nga Sơn, Tỉnh Thanh Hóa","path_with_type":"Xã Nga An, Huyện Nga Sơn, Tỉnh Thanh Hóa","code":"16144","parent_code":"401"},"16147":{"name":"Xã Nga Phú","type":"xa","slug":"xa-nga-phu","name_with_type":"Xã Nga Phú","path":"Xã Nga Phú, Huyện Nga Sơn, Tỉnh Thanh Hóa","path_with_type":"Xã Nga Phú, Huyện Nga Sơn, Tỉnh Thanh Hóa","code":"16147","parent_code":"401"},"16150":{"name":"Xã Nga Điền","type":"xa","slug":"xa-nga-dien","name_with_type":"Xã Nga Điền","path":"Xã Nga Điền, Huyện Nga Sơn, Tỉnh Thanh Hóa","path_with_type":"Xã Nga Điền, Huyện Nga Sơn, Tỉnh Thanh Hóa","code":"16150","parent_code":"401"},"16153":{"name":"Xã Nga Tân","type":"xa","slug":"xa-nga-tan","name_with_type":"Xã Nga Tân","path":"Xã Nga Tân, Huyện Nga Sơn, Tỉnh Thanh Hóa","path_with_type":"Xã Nga Tân, Huyện Nga Sơn, Tỉnh Thanh Hóa","code":"16153","parent_code":"401"},"16156":{"name":"Xã Nga Thủy","type":"xa","slug":"xa-nga-thuy","name_with_type":"Xã Nga Thủy","path":"Xã Nga Thủy, Huyện Nga Sơn, Tỉnh Thanh Hóa","path_with_type":"Xã Nga Thủy, Huyện Nga Sơn, Tỉnh Thanh Hóa","code":"16156","parent_code":"401"},"16159":{"name":"Xã Nga Liên","type":"xa","slug":"xa-nga-lien","name_with_type":"Xã Nga Liên","path":"Xã Nga Liên, Huyện Nga Sơn, Tỉnh Thanh Hóa","path_with_type":"Xã Nga Liên, Huyện Nga Sơn, Tỉnh Thanh Hóa","code":"16159","parent_code":"401"},"16162":{"name":"Xã Nga Thái","type":"xa","slug":"xa-nga-thai","name_with_type":"Xã Nga Thái","path":"Xã Nga Thái, Huyện Nga Sơn, Tỉnh Thanh Hóa","path_with_type":"Xã Nga Thái, Huyện Nga Sơn, Tỉnh Thanh Hóa","code":"16162","parent_code":"401"},"16165":{"name":"Xã Nga Thạch","type":"xa","slug":"xa-nga-thach","name_with_type":"Xã Nga Thạch","path":"Xã Nga Thạch, Huyện Nga Sơn, Tỉnh Thanh Hóa","path_with_type":"Xã Nga Thạch, Huyện Nga Sơn, Tỉnh Thanh Hóa","code":"16165","parent_code":"401"},"16168":{"name":"Xã Nga Thắng","type":"xa","slug":"xa-nga-thang","name_with_type":"Xã Nga Thắng","path":"Xã Nga Thắng, Huyện Nga Sơn, Tỉnh Thanh Hóa","path_with_type":"Xã Nga Thắng, Huyện Nga Sơn, Tỉnh Thanh Hóa","code":"16168","parent_code":"401"},"16171":{"name":"Xã Nga Trường","type":"xa","slug":"xa-nga-truong","name_with_type":"Xã Nga Trường","path":"Xã Nga Trường, Huyện Nga Sơn, Tỉnh Thanh Hóa","path_with_type":"Xã Nga Trường, Huyện Nga Sơn, Tỉnh Thanh Hóa","code":"16171","parent_code":"401"},"16174":{"name":"Thị trấn Yên Cát","type":"thi-tran","slug":"thi-tran-yen-cat","name_with_type":"Thị trấn Yên Cát","path":"Thị trấn Yên Cát, Huyện Như Xuân, Tỉnh Thanh Hóa","path_with_type":"Thị trấn Yên Cát, Huyện Như Xuân, Tỉnh Thanh Hóa","code":"16174","parent_code":"402"},"16177":{"name":"Xã Bãi Trành","type":"xa","slug":"xa-bai-tranh","name_with_type":"Xã Bãi Trành","path":"Xã Bãi Trành, Huyện Như Xuân, Tỉnh Thanh Hóa","path_with_type":"Xã Bãi Trành, Huyện Như Xuân, Tỉnh Thanh Hóa","code":"16177","parent_code":"402"},"16180":{"name":"Xã Xuân Hòa","type":"xa","slug":"xa-xuan-hoa","name_with_type":"Xã Xuân Hòa","path":"Xã Xuân Hòa, Huyện Như Xuân, Tỉnh Thanh Hóa","path_with_type":"Xã Xuân Hòa, Huyện Như Xuân, Tỉnh Thanh Hóa","code":"16180","parent_code":"402"},"16183":{"name":"Xã Xuân Bình","type":"xa","slug":"xa-xuan-binh","name_with_type":"Xã Xuân Bình","path":"Xã Xuân Bình, Huyện Như Xuân, Tỉnh Thanh Hóa","path_with_type":"Xã Xuân Bình, Huyện Như Xuân, Tỉnh Thanh Hóa","code":"16183","parent_code":"402"},"16186":{"name":"Xã Hóa Quỳ","type":"xa","slug":"xa-hoa-quy","name_with_type":"Xã Hóa Quỳ","path":"Xã Hóa Quỳ, Huyện Như Xuân, Tỉnh Thanh Hóa","path_with_type":"Xã Hóa Quỳ, Huyện Như Xuân, Tỉnh Thanh Hóa","code":"16186","parent_code":"402"},"16195":{"name":"Xã Cát Vân","type":"xa","slug":"xa-cat-van","name_with_type":"Xã Cát Vân","path":"Xã Cát Vân, Huyện Như Xuân, Tỉnh Thanh Hóa","path_with_type":"Xã Cát Vân, Huyện Như Xuân, Tỉnh Thanh Hóa","code":"16195","parent_code":"402"},"16198":{"name":"Xã Cát Tân","type":"xa","slug":"xa-cat-tan","name_with_type":"Xã Cát Tân","path":"Xã Cát Tân, Huyện Như Xuân, Tỉnh Thanh Hóa","path_with_type":"Xã Cát Tân, Huyện Như Xuân, Tỉnh Thanh Hóa","code":"16198","parent_code":"402"},"16201":{"name":"Xã Tân Bình","type":"xa","slug":"xa-tan-binh","name_with_type":"Xã Tân Bình","path":"Xã Tân Bình, Huyện Như Xuân, Tỉnh Thanh Hóa","path_with_type":"Xã Tân Bình, Huyện Như Xuân, Tỉnh Thanh Hóa","code":"16201","parent_code":"402"},"16204":{"name":"Xã Bình Lương","type":"xa","slug":"xa-binh-luong","name_with_type":"Xã Bình Lương","path":"Xã Bình Lương, Huyện Như Xuân, Tỉnh Thanh Hóa","path_with_type":"Xã Bình Lương, Huyện Như Xuân, Tỉnh Thanh Hóa","code":"16204","parent_code":"402"},"16207":{"name":"Xã Thanh Quân","type":"xa","slug":"xa-thanh-quan","name_with_type":"Xã Thanh Quân","path":"Xã Thanh Quân, Huyện Như Xuân, Tỉnh Thanh Hóa","path_with_type":"Xã Thanh Quân, Huyện Như Xuân, Tỉnh Thanh Hóa","code":"16207","parent_code":"402"},"16210":{"name":"Xã Thanh Xuân","type":"xa","slug":"xa-thanh-xuan","name_with_type":"Xã Thanh Xuân","path":"Xã Thanh Xuân, Huyện Như Xuân, Tỉnh Thanh Hóa","path_with_type":"Xã Thanh Xuân, Huyện Như Xuân, Tỉnh Thanh Hóa","code":"16210","parent_code":"402"},"16213":{"name":"Xã Thanh Hòa","type":"xa","slug":"xa-thanh-hoa","name_with_type":"Xã Thanh Hòa","path":"Xã Thanh Hòa, Huyện Như Xuân, Tỉnh Thanh Hóa","path_with_type":"Xã Thanh Hòa, Huyện Như Xuân, Tỉnh Thanh Hóa","code":"16213","parent_code":"402"},"16216":{"name":"Xã Thanh Phong","type":"xa","slug":"xa-thanh-phong","name_with_type":"Xã Thanh Phong","path":"Xã Thanh Phong, Huyện Như Xuân, Tỉnh Thanh Hóa","path_with_type":"Xã Thanh Phong, Huyện Như Xuân, Tỉnh Thanh Hóa","code":"16216","parent_code":"402"},"16219":{"name":"Xã Thanh Lâm","type":"xa","slug":"xa-thanh-lam","name_with_type":"Xã Thanh Lâm","path":"Xã Thanh Lâm, Huyện Như Xuân, Tỉnh Thanh Hóa","path_with_type":"Xã Thanh Lâm, Huyện Như Xuân, Tỉnh Thanh Hóa","code":"16219","parent_code":"402"},"16222":{"name":"Xã Thanh Sơn","type":"xa","slug":"xa-thanh-son","name_with_type":"Xã Thanh Sơn","path":"Xã Thanh Sơn, Huyện Như Xuân, Tỉnh Thanh Hóa","path_with_type":"Xã Thanh Sơn, Huyện Như Xuân, Tỉnh Thanh Hóa","code":"16222","parent_code":"402"},"16225":{"name":"Xã Thượng Ninh","type":"xa","slug":"xa-thuong-ninh","name_with_type":"Xã Thượng Ninh","path":"Xã Thượng Ninh, Huyện Như Xuân, Tỉnh Thanh Hóa","path_with_type":"Xã Thượng Ninh, Huyện Như Xuân, Tỉnh Thanh Hóa","code":"16225","parent_code":"402"},"16228":{"name":"Thị trấn Bến Sung","type":"thi-tran","slug":"thi-tran-ben-sung","name_with_type":"Thị trấn Bến Sung","path":"Thị trấn Bến Sung, Huyện Như Thanh, Tỉnh Thanh Hóa","path_with_type":"Thị trấn Bến Sung, Huyện Như Thanh, Tỉnh Thanh Hóa","code":"16228","parent_code":"403"},"16231":{"name":"Xã Cán Khê","type":"xa","slug":"xa-can-khe","name_with_type":"Xã Cán Khê","path":"Xã Cán Khê, Huyện Như Thanh, Tỉnh Thanh Hóa","path_with_type":"Xã Cán Khê, Huyện Như Thanh, Tỉnh Thanh Hóa","code":"16231","parent_code":"403"},"16234":{"name":"Xã Xuân Du","type":"xa","slug":"xa-xuan-du","name_with_type":"Xã Xuân Du","path":"Xã Xuân Du, Huyện Như Thanh, Tỉnh Thanh Hóa","path_with_type":"Xã Xuân Du, Huyện Như Thanh, Tỉnh Thanh Hóa","code":"16234","parent_code":"403"},"16240":{"name":"Xã Phượng Nghi","type":"xa","slug":"xa-phuong-nghi","name_with_type":"Xã Phượng Nghi","path":"Xã Phượng Nghi, Huyện Như Thanh, Tỉnh Thanh Hóa","path_with_type":"Xã Phượng Nghi, Huyện Như Thanh, Tỉnh Thanh Hóa","code":"16240","parent_code":"403"},"16243":{"name":"Xã Mậu Lâm","type":"xa","slug":"xa-mau-lam","name_with_type":"Xã Mậu Lâm","path":"Xã Mậu Lâm, Huyện Như Thanh, Tỉnh Thanh Hóa","path_with_type":"Xã Mậu Lâm, Huyện Như Thanh, Tỉnh Thanh Hóa","code":"16243","parent_code":"403"},"16246":{"name":"Xã Xuân Khang","type":"xa","slug":"xa-xuan-khang","name_with_type":"Xã Xuân Khang","path":"Xã Xuân Khang, Huyện Như Thanh, Tỉnh Thanh Hóa","path_with_type":"Xã Xuân Khang, Huyện Như Thanh, Tỉnh Thanh Hóa","code":"16246","parent_code":"403"},"16249":{"name":"Xã Phú Nhuận","type":"xa","slug":"xa-phu-nhuan","name_with_type":"Xã Phú Nhuận","path":"Xã Phú Nhuận, Huyện Như Thanh, Tỉnh Thanh Hóa","path_with_type":"Xã Phú Nhuận, Huyện Như Thanh, Tỉnh Thanh Hóa","code":"16249","parent_code":"403"},"16252":{"name":"Xã Hải Long","type":"xa","slug":"xa-hai-long","name_with_type":"Xã Hải Long","path":"Xã Hải Long, Huyện Như Thanh, Tỉnh Thanh Hóa","path_with_type":"Xã Hải Long, Huyện Như Thanh, Tỉnh Thanh Hóa","code":"16252","parent_code":"403"},"16258":{"name":"Xã Xuân Thái","type":"xa","slug":"xa-xuan-thai","name_with_type":"Xã Xuân Thái","path":"Xã Xuân Thái, Huyện Như Thanh, Tỉnh Thanh Hóa","path_with_type":"Xã Xuân Thái, Huyện Như Thanh, Tỉnh Thanh Hóa","code":"16258","parent_code":"403"},"16261":{"name":"Xã Xuân Phúc","type":"xa","slug":"xa-xuan-phuc","name_with_type":"Xã Xuân Phúc","path":"Xã Xuân Phúc, Huyện Như Thanh, Tỉnh Thanh Hóa","path_with_type":"Xã Xuân Phúc, Huyện Như Thanh, Tỉnh Thanh Hóa","code":"16261","parent_code":"403"},"16264":{"name":"Xã Yên Thọ","type":"xa","slug":"xa-yen-tho","name_with_type":"Xã Yên Thọ","path":"Xã Yên Thọ, Huyện Như Thanh, Tỉnh Thanh Hóa","path_with_type":"Xã Yên Thọ, Huyện Như Thanh, Tỉnh Thanh Hóa","code":"16264","parent_code":"403"},"16267":{"name":"Xã Yên Lạc","type":"xa","slug":"xa-yen-lac","name_with_type":"Xã Yên Lạc","path":"Xã Yên Lạc, Huyện Như Thanh, Tỉnh Thanh Hóa","path_with_type":"Xã Yên Lạc, Huyện Như Thanh, Tỉnh Thanh Hóa","code":"16267","parent_code":"403"},"16273":{"name":"Xã Thanh Tân","type":"xa","slug":"xa-thanh-tan","name_with_type":"Xã Thanh Tân","path":"Xã Thanh Tân, Huyện Như Thanh, Tỉnh Thanh Hóa","path_with_type":"Xã Thanh Tân, Huyện Như Thanh, Tỉnh Thanh Hóa","code":"16273","parent_code":"403"},"16276":{"name":"Xã Thanh Kỳ","type":"xa","slug":"xa-thanh-ky","name_with_type":"Xã Thanh Kỳ","path":"Xã Thanh Kỳ, Huyện Như Thanh, Tỉnh Thanh Hóa","path_with_type":"Xã Thanh Kỳ, Huyện Như Thanh, Tỉnh Thanh Hóa","code":"16276","parent_code":"403"},"16279":{"name":"Thị trấn Nông Cống","type":"thi-tran","slug":"thi-tran-nong-cong","name_with_type":"Thị trấn Nông Cống","path":"Thị trấn Nông Cống, Huyện Nông Cống, Tỉnh Thanh Hóa","path_with_type":"Thị trấn Nông Cống, Huyện Nông Cống, Tỉnh Thanh Hóa","code":"16279","parent_code":"404"},"16282":{"name":"Xã Tân Phúc","type":"xa","slug":"xa-tan-phuc","name_with_type":"Xã Tân Phúc","path":"Xã Tân Phúc, Huyện Nông Cống, Tỉnh Thanh Hóa","path_with_type":"Xã Tân Phúc, Huyện Nông Cống, Tỉnh Thanh Hóa","code":"16282","parent_code":"404"},"16285":{"name":"Xã Tân Thọ","type":"xa","slug":"xa-tan-tho","name_with_type":"Xã Tân Thọ","path":"Xã Tân Thọ, Huyện Nông Cống, Tỉnh Thanh Hóa","path_with_type":"Xã Tân Thọ, Huyện Nông Cống, Tỉnh Thanh Hóa","code":"16285","parent_code":"404"},"16288":{"name":"Xã Hoàng Sơn","type":"xa","slug":"xa-hoang-son","name_with_type":"Xã Hoàng Sơn","path":"Xã Hoàng Sơn, Huyện Nông Cống, Tỉnh Thanh Hóa","path_with_type":"Xã Hoàng Sơn, Huyện Nông Cống, Tỉnh Thanh Hóa","code":"16288","parent_code":"404"},"16291":{"name":"Xã Tân Khang","type":"xa","slug":"xa-tan-khang","name_with_type":"Xã Tân Khang","path":"Xã Tân Khang, Huyện Nông Cống, Tỉnh Thanh Hóa","path_with_type":"Xã Tân Khang, Huyện Nông Cống, Tỉnh Thanh Hóa","code":"16291","parent_code":"404"},"16294":{"name":"Xã Hoàng Giang","type":"xa","slug":"xa-hoang-giang","name_with_type":"Xã Hoàng Giang","path":"Xã Hoàng Giang, Huyện Nông Cống, Tỉnh Thanh Hóa","path_with_type":"Xã Hoàng Giang, Huyện Nông Cống, Tỉnh Thanh Hóa","code":"16294","parent_code":"404"},"16297":{"name":"Xã Trung Chính","type":"xa","slug":"xa-trung-chinh","name_with_type":"Xã Trung Chính","path":"Xã Trung Chính, Huyện Nông Cống, Tỉnh Thanh Hóa","path_with_type":"Xã Trung Chính, Huyện Nông Cống, Tỉnh Thanh Hóa","code":"16297","parent_code":"404"},"16303":{"name":"Xã Trung Thành","type":"xa","slug":"xa-trung-thanh","name_with_type":"Xã Trung Thành","path":"Xã Trung Thành, Huyện Nông Cống, Tỉnh Thanh Hóa","path_with_type":"Xã Trung Thành, Huyện Nông Cống, Tỉnh Thanh Hóa","code":"16303","parent_code":"404"},"16309":{"name":"Xã Tế Thắng","type":"xa","slug":"xa-te-thang","name_with_type":"Xã Tế Thắng","path":"Xã Tế Thắng, Huyện Nông Cống, Tỉnh Thanh Hóa","path_with_type":"Xã Tế Thắng, Huyện Nông Cống, Tỉnh Thanh Hóa","code":"16309","parent_code":"404"},"16315":{"name":"Xã Tế Lợi","type":"xa","slug":"xa-te-loi","name_with_type":"Xã Tế Lợi","path":"Xã Tế Lợi, Huyện Nông Cống, Tỉnh Thanh Hóa","path_with_type":"Xã Tế Lợi, Huyện Nông Cống, Tỉnh Thanh Hóa","code":"16315","parent_code":"404"},"16318":{"name":"Xã Tế Nông","type":"xa","slug":"xa-te-nong","name_with_type":"Xã Tế Nông","path":"Xã Tế Nông, Huyện Nông Cống, Tỉnh Thanh Hóa","path_with_type":"Xã Tế Nông, Huyện Nông Cống, Tỉnh Thanh Hóa","code":"16318","parent_code":"404"},"16321":{"name":"Xã Minh Nghĩa","type":"xa","slug":"xa-minh-nghia","name_with_type":"Xã Minh Nghĩa","path":"Xã Minh Nghĩa, Huyện Nông Cống, Tỉnh Thanh Hóa","path_with_type":"Xã Minh Nghĩa, Huyện Nông Cống, Tỉnh Thanh Hóa","code":"16321","parent_code":"404"},"16324":{"name":"Xã Minh Khôi","type":"xa","slug":"xa-minh-khoi","name_with_type":"Xã Minh Khôi","path":"Xã Minh Khôi, Huyện Nông Cống, Tỉnh Thanh Hóa","path_with_type":"Xã Minh Khôi, Huyện Nông Cống, Tỉnh Thanh Hóa","code":"16324","parent_code":"404"},"16327":{"name":"Xã Vạn Hòa","type":"xa","slug":"xa-van-hoa","name_with_type":"Xã Vạn Hòa","path":"Xã Vạn Hòa, Huyện Nông Cống, Tỉnh Thanh Hóa","path_with_type":"Xã Vạn Hòa, Huyện Nông Cống, Tỉnh Thanh Hóa","code":"16327","parent_code":"404"},"16330":{"name":"Xã Trường Trung","type":"xa","slug":"xa-truong-trung","name_with_type":"Xã Trường Trung","path":"Xã Trường Trung, Huyện Nông Cống, Tỉnh Thanh Hóa","path_with_type":"Xã Trường Trung, Huyện Nông Cống, Tỉnh Thanh Hóa","code":"16330","parent_code":"404"},"16333":{"name":"Xã Vạn Thắng","type":"xa","slug":"xa-van-thang","name_with_type":"Xã Vạn Thắng","path":"Xã Vạn Thắng, Huyện Nông Cống, Tỉnh Thanh Hóa","path_with_type":"Xã Vạn Thắng, Huyện Nông Cống, Tỉnh Thanh Hóa","code":"16333","parent_code":"404"},"16336":{"name":"Xã Trường Giang","type":"xa","slug":"xa-truong-giang","name_with_type":"Xã Trường Giang","path":"Xã Trường Giang, Huyện Nông Cống, Tỉnh Thanh Hóa","path_with_type":"Xã Trường Giang, Huyện Nông Cống, Tỉnh Thanh Hóa","code":"16336","parent_code":"404"},"16339":{"name":"Xã Vạn Thiện","type":"xa","slug":"xa-van-thien","name_with_type":"Xã Vạn Thiện","path":"Xã Vạn Thiện, Huyện Nông Cống, Tỉnh Thanh Hóa","path_with_type":"Xã Vạn Thiện, Huyện Nông Cống, Tỉnh Thanh Hóa","code":"16339","parent_code":"404"},"16342":{"name":"Xã Thăng Long","type":"xa","slug":"xa-thang-long","name_with_type":"Xã Thăng Long","path":"Xã Thăng Long, Huyện Nông Cống, Tỉnh Thanh Hóa","path_with_type":"Xã Thăng Long, Huyện Nông Cống, Tỉnh Thanh Hóa","code":"16342","parent_code":"404"},"16345":{"name":"Xã Trường Minh","type":"xa","slug":"xa-truong-minh","name_with_type":"Xã Trường Minh","path":"Xã Trường Minh, Huyện Nông Cống, Tỉnh Thanh Hóa","path_with_type":"Xã Trường Minh, Huyện Nông Cống, Tỉnh Thanh Hóa","code":"16345","parent_code":"404"},"16348":{"name":"Xã Trường Sơn","type":"xa","slug":"xa-truong-son","name_with_type":"Xã Trường Sơn","path":"Xã Trường Sơn, Huyện Nông Cống, Tỉnh Thanh Hóa","path_with_type":"Xã Trường Sơn, Huyện Nông Cống, Tỉnh Thanh Hóa","code":"16348","parent_code":"404"},"16351":{"name":"Xã Thăng Bình","type":"xa","slug":"xa-thang-binh","name_with_type":"Xã Thăng Bình","path":"Xã Thăng Bình, Huyện Nông Cống, Tỉnh Thanh Hóa","path_with_type":"Xã Thăng Bình, Huyện Nông Cống, Tỉnh Thanh Hóa","code":"16351","parent_code":"404"},"16354":{"name":"Xã Công Liêm","type":"xa","slug":"xa-cong-liem","name_with_type":"Xã Công Liêm","path":"Xã Công Liêm, Huyện Nông Cống, Tỉnh Thanh Hóa","path_with_type":"Xã Công Liêm, Huyện Nông Cống, Tỉnh Thanh Hóa","code":"16354","parent_code":"404"},"16357":{"name":"Xã Tượng Văn","type":"xa","slug":"xa-tuong-van","name_with_type":"Xã Tượng Văn","path":"Xã Tượng Văn, Huyện Nông Cống, Tỉnh Thanh Hóa","path_with_type":"Xã Tượng Văn, Huyện Nông Cống, Tỉnh Thanh Hóa","code":"16357","parent_code":"404"},"16360":{"name":"Xã Thăng Thọ","type":"xa","slug":"xa-thang-tho","name_with_type":"Xã Thăng Thọ","path":"Xã Thăng Thọ, Huyện Nông Cống, Tỉnh Thanh Hóa","path_with_type":"Xã Thăng Thọ, Huyện Nông Cống, Tỉnh Thanh Hóa","code":"16360","parent_code":"404"},"16363":{"name":"Xã Tượng Lĩnh","type":"xa","slug":"xa-tuong-linh","name_with_type":"Xã Tượng Lĩnh","path":"Xã Tượng Lĩnh, Huyện Nông Cống, Tỉnh Thanh Hóa","path_with_type":"Xã Tượng Lĩnh, Huyện Nông Cống, Tỉnh Thanh Hóa","code":"16363","parent_code":"404"},"16366":{"name":"Xã Tượng Sơn","type":"xa","slug":"xa-tuong-son","name_with_type":"Xã Tượng Sơn","path":"Xã Tượng Sơn, Huyện Nông Cống, Tỉnh Thanh Hóa","path_with_type":"Xã Tượng Sơn, Huyện Nông Cống, Tỉnh Thanh Hóa","code":"16366","parent_code":"404"},"16369":{"name":"Xã Công Chính","type":"xa","slug":"xa-cong-chinh","name_with_type":"Xã Công Chính","path":"Xã Công Chính, Huyện Nông Cống, Tỉnh Thanh Hóa","path_with_type":"Xã Công Chính, Huyện Nông Cống, Tỉnh Thanh Hóa","code":"16369","parent_code":"404"},"16375":{"name":"Xã Yên Mỹ","type":"xa","slug":"xa-yen-my","name_with_type":"Xã Yên Mỹ","path":"Xã Yên Mỹ, Huyện Nông Cống, Tỉnh Thanh Hóa","path_with_type":"Xã Yên Mỹ, Huyện Nông Cống, Tỉnh Thanh Hóa","code":"16375","parent_code":"404"},"16378":{"name":"Phường Rừng Thông","type":"phuong","slug":"phuong-rung-thong","name_with_type":"Phường Rừng Thông","path":"Phường Rừng Thông, Thành phố Thanh Hóa, Tỉnh Thanh Hóa","path_with_type":"Phường Rừng Thông, Thành phố Thanh Hóa, Tỉnh Thanh Hóa","code":"16378","parent_code":"380"},"16381":{"name":"Xã Đông Hoàng","type":"xa","slug":"xa-dong-hoang","name_with_type":"Xã Đông Hoàng","path":"Xã Đông Hoàng, Thành phố Thanh Hóa, Tỉnh Thanh Hóa","path_with_type":"Xã Đông Hoàng, Thành phố Thanh Hóa, Tỉnh Thanh Hóa","code":"16381","parent_code":"380"},"16384":{"name":"Xã Đông Ninh","type":"xa","slug":"xa-dong-ninh","name_with_type":"Xã Đông Ninh","path":"Xã Đông Ninh, Thành phố Thanh Hóa, Tỉnh Thanh Hóa","path_with_type":"Xã Đông Ninh, Thành phố Thanh Hóa, Tỉnh Thanh Hóa","code":"16384","parent_code":"380"},"16387":{"name":"Xã Đông Khê","type":"xa","slug":"xa-dong-khe","name_with_type":"Xã Đông Khê","path":"Xã Đông Khê, Thành phố Thanh Hóa, Tỉnh Thanh Hóa","path_with_type":"Xã Đông Khê, Thành phố Thanh Hóa, Tỉnh Thanh Hóa","code":"16387","parent_code":"380"},"16390":{"name":"Xã Đông Hòa","type":"xa","slug":"xa-dong-hoa","name_with_type":"Xã Đông Hòa","path":"Xã Đông Hòa, Thành phố Thanh Hóa, Tỉnh Thanh Hóa","path_with_type":"Xã Đông Hòa, Thành phố Thanh Hóa, Tỉnh Thanh Hóa","code":"16390","parent_code":"380"},"16393":{"name":"Xã Đông Yên","type":"xa","slug":"xa-dong-yen","name_with_type":"Xã Đông Yên","path":"Xã Đông Yên, Thành phố Thanh Hóa, Tỉnh Thanh Hóa","path_with_type":"Xã Đông Yên, Thành phố Thanh Hóa, Tỉnh Thanh Hóa","code":"16393","parent_code":"380"},"16396":{"name":"Phường Đông Lĩnh","type":"phuong","slug":"phuong-dong-linh","name_with_type":"Phường Đông Lĩnh","path":"Phường Đông Lĩnh, Thành phố Thanh Hóa, Tỉnh Thanh Hóa","path_with_type":"Phường Đông Lĩnh, Thành phố Thanh Hóa, Tỉnh Thanh Hóa","code":"16396","parent_code":"380"},"16399":{"name":"Xã Đông Minh","type":"xa","slug":"xa-dong-minh","name_with_type":"Xã Đông Minh","path":"Xã Đông Minh, Thành phố Thanh Hóa, Tỉnh Thanh Hóa","path_with_type":"Xã Đông Minh, Thành phố Thanh Hóa, Tỉnh Thanh Hóa","code":"16399","parent_code":"380"},"16402":{"name":"Xã Đông Thanh","type":"xa","slug":"xa-dong-thanh","name_with_type":"Xã Đông Thanh","path":"Xã Đông Thanh, Thành phố Thanh Hóa, Tỉnh Thanh Hóa","path_with_type":"Xã Đông Thanh, Thành phố Thanh Hóa, Tỉnh Thanh Hóa","code":"16402","parent_code":"380"},"16405":{"name":"Xã Đông Tiến","type":"xa","slug":"xa-dong-tien","name_with_type":"Xã Đông Tiến","path":"Xã Đông Tiến, Thành phố Thanh Hóa, Tỉnh Thanh Hóa","path_with_type":"Xã Đông Tiến, Thành phố Thanh Hóa, Tỉnh Thanh Hóa","code":"16405","parent_code":"380"},"16408":{"name":"Xã Đông Khê","type":"xa","slug":"xa-dong-khe","name_with_type":"Xã Đông Khê","path":"Xã Đông Khê, Thành phố Thanh Hóa, Tỉnh Thanh Hóa","path_with_type":"Xã Đông Khê, Thành phố Thanh Hóa, Tỉnh Thanh Hóa","code":"16408","parent_code":"380"},"16411":{"name":"Xã Đông Xuân","type":"xa","slug":"xa-dong-xuan","name_with_type":"Xã Đông Xuân","path":"Xã Đông Xuân, Thành phố Thanh Hóa, Tỉnh Thanh Hóa","path_with_type":"Xã Đông Xuân, Thành phố Thanh Hóa, Tỉnh Thanh Hóa","code":"16411","parent_code":"380"},"16414":{"name":"Phường Đông Thịnh","type":"phuong","slug":"phuong-dong-thinh","name_with_type":"Phường Đông Thịnh","path":"Phường Đông Thịnh, Thành phố Thanh Hóa, Tỉnh Thanh Hóa","path_with_type":"Phường Đông Thịnh, Thành phố Thanh Hóa, Tỉnh Thanh Hóa","code":"16414","parent_code":"380"},"16417":{"name":"Xã Đông Văn","type":"xa","slug":"xa-dong-van","name_with_type":"Xã Đông Văn","path":"Xã Đông Văn, Thành phố Thanh Hóa, Tỉnh Thanh Hóa","path_with_type":"Xã Đông Văn, Thành phố Thanh Hóa, Tỉnh Thanh Hóa","code":"16417","parent_code":"380"},"16420":{"name":"Xã Đông Phú","type":"xa","slug":"xa-dong-phu","name_with_type":"Xã Đông Phú","path":"Xã Đông Phú, Thành phố Thanh Hóa, Tỉnh Thanh Hóa","path_with_type":"Xã Đông Phú, Thành phố Thanh Hóa, Tỉnh Thanh Hóa","code":"16420","parent_code":"380"},"16423":{"name":"Xã Đông Nam","type":"xa","slug":"xa-dong-nam","name_with_type":"Xã Đông Nam","path":"Xã Đông Nam, Thành phố Thanh Hóa, Tỉnh Thanh Hóa","path_with_type":"Xã Đông Nam, Thành phố Thanh Hóa, Tỉnh Thanh Hóa","code":"16423","parent_code":"380"},"16426":{"name":"Xã Đông Quang","type":"xa","slug":"xa-dong-quang","name_with_type":"Xã Đông Quang","path":"Xã Đông Quang, Thành phố Thanh Hóa, Tỉnh Thanh Hóa","path_with_type":"Xã Đông Quang, Thành phố Thanh Hóa, Tỉnh Thanh Hóa","code":"16426","parent_code":"380"},"16429":{"name":"Xã Đông Vinh","type":"xa","slug":"xa-dong-vinh","name_with_type":"Xã Đông Vinh","path":"Xã Đông Vinh, Thành phố Thanh Hóa, Tỉnh Thanh Hóa","path_with_type":"Xã Đông Vinh, Thành phố Thanh Hóa, Tỉnh Thanh Hóa","code":"16429","parent_code":"380"},"16432":{"name":"Phường Đông Tân","type":"phuong","slug":"phuong-dong-tan","name_with_type":"Phường Đông Tân","path":"Phường Đông Tân, Thành phố Thanh Hóa, Tỉnh Thanh Hóa","path_with_type":"Phường Đông Tân, Thành phố Thanh Hóa, Tỉnh Thanh Hóa","code":"16432","parent_code":"380"},"16435":{"name":"Phường An Hưng","type":"phuong","slug":"phuong-an-hung","name_with_type":"Phường An Hưng","path":"Phường An Hưng, Thành phố Thanh Hóa, Tỉnh Thanh Hóa","path_with_type":"Phường An Hưng, Thành phố Thanh Hóa, Tỉnh Thanh Hóa","code":"16435","parent_code":"380"},"16438":{"name":"Thị trấn Tân Phong","type":"thi-tran","slug":"thi-tran-tan-phong","name_with_type":"Thị trấn Tân Phong","path":"Thị trấn Tân Phong, Huyện Quảng Xương, Tỉnh Thanh Hóa","path_with_type":"Thị trấn Tân Phong, Huyện Quảng Xương, Tỉnh Thanh Hóa","code":"16438","parent_code":"406"},"16441":{"name":"Phường Quảng Thịnh","type":"phuong","slug":"phuong-quang-thinh","name_with_type":"Phường Quảng Thịnh","path":"Phường Quảng Thịnh, Thành phố Thanh Hóa, Tỉnh Thanh Hóa","path_with_type":"Phường Quảng Thịnh, Thành phố Thanh Hóa, Tỉnh Thanh Hóa","code":"16441","parent_code":"380"},"16447":{"name":"Xã Quảng Trạch","type":"xa","slug":"xa-quang-trach","name_with_type":"Xã Quảng Trạch","path":"Xã Quảng Trạch, Huyện Quảng Xương, Tỉnh Thanh Hóa","path_with_type":"Xã Quảng Trạch, Huyện Quảng Xương, Tỉnh Thanh Hóa","code":"16447","parent_code":"406"},"16453":{"name":"Xã Quảng Đức","type":"xa","slug":"xa-quang-duc","name_with_type":"Xã Quảng Đức","path":"Xã Quảng Đức, Huyện Quảng Xương, Tỉnh Thanh Hóa","path_with_type":"Xã Quảng Đức, Huyện Quảng Xương, Tỉnh Thanh Hóa","code":"16453","parent_code":"406"},"16456":{"name":"Xã Quảng Định","type":"xa","slug":"xa-quang-dinh","name_with_type":"Xã Quảng Định","path":"Xã Quảng Định, Huyện Quảng Xương, Tỉnh Thanh Hóa","path_with_type":"Xã Quảng Định, Huyện Quảng Xương, Tỉnh Thanh Hóa","code":"16456","parent_code":"406"},"16459":{"name":"Phường Quảng Đông","type":"phuong","slug":"phuong-quang-dong","name_with_type":"Phường Quảng Đông","path":"Phường Quảng Đông, Thành phố Thanh Hóa, Tỉnh Thanh Hóa","path_with_type":"Phường Quảng Đông, Thành phố Thanh Hóa, Tỉnh Thanh Hóa","code":"16459","parent_code":"380"},"16462":{"name":"Xã Quảng Nhân","type":"xa","slug":"xa-quang-nhan","name_with_type":"Xã Quảng Nhân","path":"Xã Quảng Nhân, Huyện Quảng Xương, Tỉnh Thanh Hóa","path_with_type":"Xã Quảng Nhân, Huyện Quảng Xương, Tỉnh Thanh Hóa","code":"16462","parent_code":"406"},"16465":{"name":"Xã Quảng Ninh","type":"xa","slug":"xa-quang-ninh","name_with_type":"Xã Quảng Ninh","path":"Xã Quảng Ninh, Huyện Quảng Xương, Tỉnh Thanh Hóa","path_with_type":"Xã Quảng Ninh, Huyện Quảng Xương, Tỉnh Thanh Hóa","code":"16465","parent_code":"406"},"16468":{"name":"Xã Quảng Bình","type":"xa","slug":"xa-quang-binh","name_with_type":"Xã Quảng Bình","path":"Xã Quảng Bình, Huyện Quảng Xương, Tỉnh Thanh Hóa","path_with_type":"Xã Quảng Bình, Huyện Quảng Xương, Tỉnh Thanh Hóa","code":"16468","parent_code":"406"},"16471":{"name":"Xã Quảng Hợp","type":"xa","slug":"xa-quang-hop","name_with_type":"Xã Quảng Hợp","path":"Xã Quảng Hợp, Huyện Quảng Xương, Tỉnh Thanh Hóa","path_with_type":"Xã Quảng Hợp, Huyện Quảng Xương, Tỉnh Thanh Hóa","code":"16471","parent_code":"406"},"16474":{"name":"Xã Quảng Văn","type":"xa","slug":"xa-quang-van","name_with_type":"Xã Quảng Văn","path":"Xã Quảng Văn, Huyện Quảng Xương, Tỉnh Thanh Hóa","path_with_type":"Xã Quảng Văn, Huyện Quảng Xương, Tỉnh Thanh Hóa","code":"16474","parent_code":"406"},"16477":{"name":"Xã Quảng Long","type":"xa","slug":"xa-quang-long","name_with_type":"Xã Quảng Long","path":"Xã Quảng Long, Huyện Quảng Xương, Tỉnh Thanh Hóa","path_with_type":"Xã Quảng Long, Huyện Quảng Xương, Tỉnh Thanh Hóa","code":"16477","parent_code":"406"},"16480":{"name":"Xã Quảng Yên","type":"xa","slug":"xa-quang-yen","name_with_type":"Xã Quảng Yên","path":"Xã Quảng Yên, Huyện Quảng Xương, Tỉnh Thanh Hóa","path_with_type":"Xã Quảng Yên, Huyện Quảng Xương, Tỉnh Thanh Hóa","code":"16480","parent_code":"406"},"16483":{"name":"Xã Quảng Hòa","type":"xa","slug":"xa-quang-hoa","name_with_type":"Xã Quảng Hòa","path":"Xã Quảng Hòa, Huyện Quảng Xương, Tỉnh Thanh Hóa","path_with_type":"Xã Quảng Hòa, Huyện Quảng Xương, Tỉnh Thanh Hóa","code":"16483","parent_code":"406"},"16489":{"name":"Xã Quảng Khê","type":"xa","slug":"xa-quang-khe","name_with_type":"Xã Quảng Khê","path":"Xã Quảng Khê, Huyện Quảng Xương, Tỉnh Thanh Hóa","path_with_type":"Xã Quảng Khê, Huyện Quảng Xương, Tỉnh Thanh Hóa","code":"16489","parent_code":"406"},"16492":{"name":"Xã Quảng Trung","type":"xa","slug":"xa-quang-trung","name_with_type":"Xã Quảng Trung","path":"Xã Quảng Trung, Huyện Quảng Xương, Tỉnh Thanh Hóa","path_with_type":"Xã Quảng Trung, Huyện Quảng Xương, Tỉnh Thanh Hóa","code":"16492","parent_code":"406"},"16495":{"name":"Xã Quảng Chính","type":"xa","slug":"xa-quang-chinh","name_with_type":"Xã Quảng Chính","path":"Xã Quảng Chính, Huyện Quảng Xương, Tỉnh Thanh Hóa","path_with_type":"Xã Quảng Chính, Huyện Quảng Xương, Tỉnh Thanh Hóa","code":"16495","parent_code":"406"},"16498":{"name":"Xã Quảng Ngọc","type":"xa","slug":"xa-quang-ngoc","name_with_type":"Xã Quảng Ngọc","path":"Xã Quảng Ngọc, Huyện Quảng Xương, Tỉnh Thanh Hóa","path_with_type":"Xã Quảng Ngọc, Huyện Quảng Xương, Tỉnh Thanh Hóa","code":"16498","parent_code":"406"},"16501":{"name":"Xã Quảng Trường","type":"xa","slug":"xa-quang-truong","name_with_type":"Xã Quảng Trường","path":"Xã Quảng Trường, Huyện Quảng Xương, Tỉnh Thanh Hóa","path_with_type":"Xã Quảng Trường, Huyện Quảng Xương, Tỉnh Thanh Hóa","code":"16501","parent_code":"406"},"16507":{"name":"Phường Quảng Cát","type":"phuong","slug":"phuong-quang-cat","name_with_type":"Phường Quảng Cát","path":"Phường Quảng Cát, Thành phố Thanh Hóa, Tỉnh Thanh Hóa","path_with_type":"Phường Quảng Cát, Thành phố Thanh Hóa, Tỉnh Thanh Hóa","code":"16507","parent_code":"380"},"16510":{"name":"Xã Quảng Phúc","type":"xa","slug":"xa-quang-phuc","name_with_type":"Xã Quảng Phúc","path":"Xã Quảng Phúc, Huyện Quảng Xương, Tỉnh Thanh Hóa","path_with_type":"Xã Quảng Phúc, Huyện Quảng Xương, Tỉnh Thanh Hóa","code":"16510","parent_code":"406"},"16513":{"name":"Xã Quảng Minh","type":"xa","slug":"xa-quang-minh","name_with_type":"Xã Quảng Minh","path":"Xã Quảng Minh, Thành phố Sầm Sơn, Tỉnh Thanh Hóa","path_with_type":"Xã Quảng Minh, Thành phố Sầm Sơn, Tỉnh Thanh Hóa","code":"16513","parent_code":"382"},"16516":{"name":"Xã Đại Hùng","type":"xa","slug":"xa-dai-hung","name_with_type":"Xã Đại Hùng","path":"Xã Đại Hùng, Thành phố Sầm Sơn, Tỉnh Thanh Hóa","path_with_type":"Xã Đại Hùng, Thành phố Sầm Sơn, Tỉnh Thanh Hóa","code":"16516","parent_code":"382"},"16519":{"name":"Xã Quảng Giao","type":"xa","slug":"xa-quang-giao","name_with_type":"Xã Quảng Giao","path":"Xã Quảng Giao, Huyện Quảng Xương, Tỉnh Thanh Hóa","path_with_type":"Xã Quảng Giao, Huyện Quảng Xương, Tỉnh Thanh Hóa","code":"16519","parent_code":"406"},"16522":{"name":"Phường Quảng Phú","type":"phuong","slug":"phuong-quang-phu","name_with_type":"Phường Quảng Phú","path":"Phường Quảng Phú, Thành phố Thanh Hóa, Tỉnh Thanh Hóa","path_with_type":"Phường Quảng Phú, Thành phố Thanh Hóa, Tỉnh Thanh Hóa","code":"16522","parent_code":"380"},"16525":{"name":"Phường Quảng Tâm","type":"phuong","slug":"phuong-quang-tam","name_with_type":"Phường Quảng Tâm","path":"Phường Quảng Tâm, Thành phố Thanh Hóa, Tỉnh Thanh Hóa","path_with_type":"Phường Quảng Tâm, Thành phố Thanh Hóa, Tỉnh Thanh Hóa","code":"16525","parent_code":"380"},"16528":{"name":"Phường Quảng Thọ","type":"phuong","slug":"phuong-quang-tho","name_with_type":"Phường Quảng Thọ","path":"Phường Quảng Thọ, Thành phố Sầm Sơn, Tỉnh Thanh Hóa","path_with_type":"Phường Quảng Thọ, Thành phố Sầm Sơn, Tỉnh Thanh Hóa","code":"16528","parent_code":"382"},"16531":{"name":"Phường Quảng Châu","type":"phuong","slug":"phuong-quang-chau","name_with_type":"Phường Quảng Châu","path":"Phường Quảng Châu, Thành phố Sầm Sơn, Tỉnh Thanh Hóa","path_with_type":"Phường Quảng Châu, Thành phố Sầm Sơn, Tỉnh Thanh Hóa","code":"16531","parent_code":"382"},"16534":{"name":"Phường Quảng Vinh","type":"phuong","slug":"phuong-quang-vinh","name_with_type":"Phường Quảng Vinh","path":"Phường Quảng Vinh, Thành phố Sầm Sơn, Tỉnh Thanh Hóa","path_with_type":"Phường Quảng Vinh, Thành phố Sầm Sơn, Tỉnh Thanh Hóa","code":"16534","parent_code":"382"},"16540":{"name":"Xã Quảng Hải","type":"xa","slug":"xa-quang-hai","name_with_type":"Xã Quảng Hải","path":"Xã Quảng Hải, Huyện Quảng Xương, Tỉnh Thanh Hóa","path_with_type":"Xã Quảng Hải, Huyện Quảng Xương, Tỉnh Thanh Hóa","code":"16540","parent_code":"406"},"16543":{"name":"Xã Quảng Lưu","type":"xa","slug":"xa-quang-luu","name_with_type":"Xã Quảng Lưu","path":"Xã Quảng Lưu, Huyện Quảng Xương, Tỉnh Thanh Hóa","path_with_type":"Xã Quảng Lưu, Huyện Quảng Xương, Tỉnh Thanh Hóa","code":"16543","parent_code":"406"},"16546":{"name":"Xã Quảng Lộc","type":"xa","slug":"xa-quang-loc","name_with_type":"Xã Quảng Lộc","path":"Xã Quảng Lộc, Huyện Quảng Xương, Tỉnh Thanh Hóa","path_with_type":"Xã Quảng Lộc, Huyện Quảng Xương, Tỉnh Thanh Hóa","code":"16546","parent_code":"406"},"16549":{"name":"Xã Tiên Trang","type":"xa","slug":"xa-tien-trang","name_with_type":"Xã Tiên Trang","path":"Xã Tiên Trang, Huyện Quảng Xương, Tỉnh Thanh Hóa","path_with_type":"Xã Tiên Trang, Huyện Quảng Xương, Tỉnh Thanh Hóa","code":"16549","parent_code":"406"},"16552":{"name":"Xã Quảng Nham","type":"xa","slug":"xa-quang-nham","name_with_type":"Xã Quảng Nham","path":"Xã Quảng Nham, Huyện Quảng Xương, Tỉnh Thanh Hóa","path_with_type":"Xã Quảng Nham, Huyện Quảng Xương, Tỉnh Thanh Hóa","code":"16552","parent_code":"406"},"16555":{"name":"Xã Quảng Thạch","type":"xa","slug":"xa-quang-thach","name_with_type":"Xã Quảng Thạch","path":"Xã Quảng Thạch, Huyện Quảng Xương, Tỉnh Thanh Hóa","path_with_type":"Xã Quảng Thạch, Huyện Quảng Xương, Tỉnh Thanh Hóa","code":"16555","parent_code":"406"},"16558":{"name":"Xã Quảng Thái","type":"xa","slug":"xa-quang-thai","name_with_type":"Xã Quảng Thái","path":"Xã Quảng Thái, Huyện Quảng Xương, Tỉnh Thanh Hóa","path_with_type":"Xã Quảng Thái, Huyện Quảng Xương, Tỉnh Thanh Hóa","code":"16558","parent_code":"406"},"16561":{"name":"Phường Hải Hòa","type":"phuong","slug":"phuong-hai-hoa","name_with_type":"Phường Hải Hòa","path":"Phường Hải Hòa, Thị xã Nghi Sơn, Tỉnh Thanh Hóa","path_with_type":"Phường Hải Hòa, Thị xã Nghi Sơn, Tỉnh Thanh Hóa","code":"16561","parent_code":"407"},"16564":{"name":"Phường Hải Châu","type":"phuong","slug":"phuong-hai-chau","name_with_type":"Phường Hải Châu","path":"Phường Hải Châu, Thị xã Nghi Sơn, Tỉnh Thanh Hóa","path_with_type":"Phường Hải Châu, Thị xã Nghi Sơn, Tỉnh Thanh Hóa","code":"16564","parent_code":"407"},"16567":{"name":"Xã Thanh Thủy","type":"xa","slug":"xa-thanh-thuy","name_with_type":"Xã Thanh Thủy","path":"Xã Thanh Thủy, Thị xã Nghi Sơn, Tỉnh Thanh Hóa","path_with_type":"Xã Thanh Thủy, Thị xã Nghi Sơn, Tỉnh Thanh Hóa","code":"16567","parent_code":"407"},"16570":{"name":"Xã Thanh Sơn","type":"xa","slug":"xa-thanh-son","name_with_type":"Xã Thanh Sơn","path":"Xã Thanh Sơn, Thị xã Nghi Sơn, Tỉnh Thanh Hóa","path_with_type":"Xã Thanh Sơn, Thị xã Nghi Sơn, Tỉnh Thanh Hóa","code":"16570","parent_code":"407"},"16576":{"name":"Phường Hải Ninh","type":"phuong","slug":"phuong-hai-ninh","name_with_type":"Phường Hải Ninh","path":"Phường Hải Ninh, Thị xã Nghi Sơn, Tỉnh Thanh Hóa","path_with_type":"Phường Hải Ninh, Thị xã Nghi Sơn, Tỉnh Thanh Hóa","code":"16576","parent_code":"407"},"16579":{"name":"Xã Anh Sơn","type":"xa","slug":"xa-anh-son","name_with_type":"Xã Anh Sơn","path":"Xã Anh Sơn, Thị xã Nghi Sơn, Tỉnh Thanh Hóa","path_with_type":"Xã Anh Sơn, Thị xã Nghi Sơn, Tỉnh Thanh Hóa","code":"16579","parent_code":"407"},"16582":{"name":"Xã Ngọc Lĩnh","type":"xa","slug":"xa-ngoc-linh","name_with_type":"Xã Ngọc Lĩnh","path":"Xã Ngọc Lĩnh, Thị xã Nghi Sơn, Tỉnh Thanh Hóa","path_with_type":"Xã Ngọc Lĩnh, Thị xã Nghi Sơn, Tỉnh Thanh Hóa","code":"16582","parent_code":"407"},"16585":{"name":"Phường Hải An","type":"phuong","slug":"phuong-hai-an","name_with_type":"Phường Hải An","path":"Phường Hải An, Thị xã Nghi Sơn, Tỉnh Thanh Hóa","path_with_type":"Phường Hải An, Thị xã Nghi Sơn, Tỉnh Thanh Hóa","code":"16585","parent_code":"407"},"16591":{"name":"Xã Các Sơn","type":"xa","slug":"xa-cac-son","name_with_type":"Xã Các Sơn","path":"Xã Các Sơn, Thị xã Nghi Sơn, Tỉnh Thanh Hóa","path_with_type":"Xã Các Sơn, Thị xã Nghi Sơn, Tỉnh Thanh Hóa","code":"16591","parent_code":"407"},"16594":{"name":"Phường Tân Dân","type":"phuong","slug":"phuong-tan-dan","name_with_type":"Phường Tân Dân","path":"Phường Tân Dân, Thị xã Nghi Sơn, Tỉnh Thanh Hóa","path_with_type":"Phường Tân Dân, Thị xã Nghi Sơn, Tỉnh Thanh Hóa","code":"16594","parent_code":"407"},"16597":{"name":"Phường Hải Lĩnh","type":"phuong","slug":"phuong-hai-linh","name_with_type":"Phường Hải Lĩnh","path":"Phường Hải Lĩnh, Thị xã Nghi Sơn, Tỉnh Thanh Hóa","path_with_type":"Phường Hải Lĩnh, Thị xã Nghi Sơn, Tỉnh Thanh Hóa","code":"16597","parent_code":"407"},"16600":{"name":"Xã Định Hải","type":"xa","slug":"xa-dinh-hai","name_with_type":"Xã Định Hải","path":"Xã Định Hải, Thị xã Nghi Sơn, Tỉnh Thanh Hóa","path_with_type":"Xã Định Hải, Thị xã Nghi Sơn, Tỉnh Thanh Hóa","code":"16600","parent_code":"407"},"16603":{"name":"Xã Phú Sơn","type":"xa","slug":"xa-phu-son","name_with_type":"Xã Phú Sơn","path":"Xã Phú Sơn, Thị xã Nghi Sơn, Tỉnh Thanh Hóa","path_with_type":"Xã Phú Sơn, Thị xã Nghi Sơn, Tỉnh Thanh Hóa","code":"16603","parent_code":"407"},"16606":{"name":"Phường Ninh Hải","type":"phuong","slug":"phuong-ninh-hai","name_with_type":"Phường Ninh Hải","path":"Phường Ninh Hải, Thị xã Nghi Sơn, Tỉnh Thanh Hóa","path_with_type":"Phường Ninh Hải, Thị xã Nghi Sơn, Tỉnh Thanh Hóa","code":"16606","parent_code":"407"},"16609":{"name":"Phường Nguyên Bình","type":"phuong","slug":"phuong-nguyen-binh","name_with_type":"Phường Nguyên Bình","path":"Phường Nguyên Bình, Thị xã Nghi Sơn, Tỉnh Thanh Hóa","path_with_type":"Phường Nguyên Bình, Thị xã Nghi Sơn, Tỉnh Thanh Hóa","code":"16609","parent_code":"407"},"16612":{"name":"Xã Hải Nhân","type":"xa","slug":"xa-hai-nhan","name_with_type":"Xã Hải Nhân","path":"Xã Hải Nhân, Thị xã Nghi Sơn, Tỉnh Thanh Hóa","path_with_type":"Xã Hải Nhân, Thị xã Nghi Sơn, Tỉnh Thanh Hóa","code":"16612","parent_code":"407"},"16618":{"name":"Phường Bình Minh","type":"phuong","slug":"phuong-binh-minh","name_with_type":"Phường Bình Minh","path":"Phường Bình Minh, Thị xã Nghi Sơn, Tỉnh Thanh Hóa","path_with_type":"Phường Bình Minh, Thị xã Nghi Sơn, Tỉnh Thanh Hóa","code":"16618","parent_code":"407"},"16621":{"name":"Phường Hải Thanh","type":"phuong","slug":"phuong-hai-thanh","name_with_type":"Phường Hải Thanh","path":"Phường Hải Thanh, Thị xã Nghi Sơn, Tỉnh Thanh Hóa","path_with_type":"Phường Hải Thanh, Thị xã Nghi Sơn, Tỉnh Thanh Hóa","code":"16621","parent_code":"407"},"16624":{"name":"Xã Phú Lâm","type":"xa","slug":"xa-phu-lam","name_with_type":"Xã Phú Lâm","path":"Xã Phú Lâm, Thị xã Nghi Sơn, Tỉnh Thanh Hóa","path_with_type":"Xã Phú Lâm, Thị xã Nghi Sơn, Tỉnh Thanh Hóa","code":"16624","parent_code":"407"},"16627":{"name":"Phường Xuân Lâm","type":"phuong","slug":"phuong-xuan-lam","name_with_type":"Phường Xuân Lâm","path":"Phường Xuân Lâm, Thị xã Nghi Sơn, Tỉnh Thanh Hóa","path_with_type":"Phường Xuân Lâm, Thị xã Nghi Sơn, Tỉnh Thanh Hóa","code":"16627","parent_code":"407"},"16630":{"name":"Phường Trúc Lâm","type":"phuong","slug":"phuong-truc-lam","name_with_type":"Phường Trúc Lâm","path":"Phường Trúc Lâm, Thị xã Nghi Sơn, Tỉnh Thanh Hóa","path_with_type":"Phường Trúc Lâm, Thị xã Nghi Sơn, Tỉnh Thanh Hóa","code":"16630","parent_code":"407"},"16633":{"name":"Phường Hải Bình","type":"phuong","slug":"phuong-hai-binh","name_with_type":"Phường Hải Bình","path":"Phường Hải Bình, Thị xã Nghi Sơn, Tỉnh Thanh Hóa","path_with_type":"Phường Hải Bình, Thị xã Nghi Sơn, Tỉnh Thanh Hóa","code":"16633","parent_code":"407"},"16636":{"name":"Xã Tân Trường","type":"xa","slug":"xa-tan-truong","name_with_type":"Xã Tân Trường","path":"Xã Tân Trường, Thị xã Nghi Sơn, Tỉnh Thanh Hóa","path_with_type":"Xã Tân Trường, Thị xã Nghi Sơn, Tỉnh Thanh Hóa","code":"16636","parent_code":"407"},"16639":{"name":"Xã Tùng Lâm","type":"xa","slug":"xa-tung-lam","name_with_type":"Xã Tùng Lâm","path":"Xã Tùng Lâm, Thị xã Nghi Sơn, Tỉnh Thanh Hóa","path_with_type":"Xã Tùng Lâm, Thị xã Nghi Sơn, Tỉnh Thanh Hóa","code":"16639","parent_code":"407"},"16642":{"name":"Phường Tĩnh Hải","type":"phuong","slug":"phuong-tinh-hai","name_with_type":"Phường Tĩnh Hải","path":"Phường Tĩnh Hải, Thị xã Nghi Sơn, Tỉnh Thanh Hóa","path_with_type":"Phường Tĩnh Hải, Thị xã Nghi Sơn, Tỉnh Thanh Hóa","code":"16642","parent_code":"407"},"16645":{"name":"Phường Mai Lâm","type":"phuong","slug":"phuong-mai-lam","name_with_type":"Phường Mai Lâm","path":"Phường Mai Lâm, Thị xã Nghi Sơn, Tỉnh Thanh Hóa","path_with_type":"Phường Mai Lâm, Thị xã Nghi Sơn, Tỉnh Thanh Hóa","code":"16645","parent_code":"407"},"16648":{"name":"Xã Trường Lâm","type":"xa","slug":"xa-truong-lam","name_with_type":"Xã Trường Lâm","path":"Xã Trường Lâm, Thị xã Nghi Sơn, Tỉnh Thanh Hóa","path_with_type":"Xã Trường Lâm, Thị xã Nghi Sơn, Tỉnh Thanh Hóa","code":"16648","parent_code":"407"},"16654":{"name":"Phường Hải Thượng","type":"phuong","slug":"phuong-hai-thuong","name_with_type":"Phường Hải Thượng","path":"Phường Hải Thượng, Thị xã Nghi Sơn, Tỉnh Thanh Hóa","path_with_type":"Phường Hải Thượng, Thị xã Nghi Sơn, Tỉnh Thanh Hóa","code":"16654","parent_code":"407"},"16657":{"name":"Xã Nghi Sơn","type":"xa","slug":"xa-nghi-son","name_with_type":"Xã Nghi Sơn","path":"Xã Nghi Sơn, Thị xã Nghi Sơn, Tỉnh Thanh Hóa","path_with_type":"Xã Nghi Sơn, Thị xã Nghi Sơn, Tỉnh Thanh Hóa","code":"16657","parent_code":"407"},"16660":{"name":"Xã Hải Hà","type":"xa","slug":"xa-hai-ha","name_with_type":"Xã Hải Hà","path":"Xã Hải Hà, Thị xã Nghi Sơn, Tỉnh Thanh Hóa","path_with_type":"Xã Hải Hà, Thị xã Nghi Sơn, Tỉnh Thanh Hóa","code":"16660","parent_code":"407"},"16663":{"name":"Phường Đông Vĩnh","type":"phuong","slug":"phuong-dong-vinh","name_with_type":"Phường Đông Vĩnh","path":"Phường Đông Vĩnh, Thành phố Vinh, Tỉnh Nghệ An","path_with_type":"Phường Đông Vĩnh, Thành phố Vinh, Tỉnh Nghệ An","code":"16663","parent_code":"412"},"16666":{"name":"Phường Hà Huy Tập","type":"phuong","slug":"phuong-ha-huy-tap","name_with_type":"Phường Hà Huy Tập","path":"Phường Hà Huy Tập, Thành phố Vinh, Tỉnh Nghệ An","path_with_type":"Phường Hà Huy Tập, Thành phố Vinh, Tỉnh Nghệ An","code":"16666","parent_code":"412"},"16669":{"name":"Phường Lê Lợi","type":"phuong","slug":"phuong-le-loi","name_with_type":"Phường Lê Lợi","path":"Phường Lê Lợi, Thành phố Vinh, Tỉnh Nghệ An","path_with_type":"Phường Lê Lợi, Thành phố Vinh, Tỉnh Nghệ An","code":"16669","parent_code":"412"},"16670":{"name":"Phường Quán Bàu","type":"phuong","slug":"phuong-quan-bau","name_with_type":"Phường Quán Bàu","path":"Phường Quán Bàu, Thành phố Vinh, Tỉnh Nghệ An","path_with_type":"Phường Quán Bàu, Thành phố Vinh, Tỉnh Nghệ An","code":"16670","parent_code":"412"},"16672":{"name":"Phường Hưng Bình","type":"phuong","slug":"phuong-hung-binh","name_with_type":"Phường Hưng Bình","path":"Phường Hưng Bình, Thành phố Vinh, Tỉnh Nghệ An","path_with_type":"Phường Hưng Bình, Thành phố Vinh, Tỉnh Nghệ An","code":"16672","parent_code":"412"},"16673":{"name":"Phường Hưng Phúc","type":"phuong","slug":"phuong-hung-phuc","name_with_type":"Phường Hưng Phúc","path":"Phường Hưng Phúc, Thành phố Vinh, Tỉnh Nghệ An","path_with_type":"Phường Hưng Phúc, Thành phố Vinh, Tỉnh Nghệ An","code":"16673","parent_code":"412"},"16675":{"name":"Phường Hưng Dũng","type":"phuong","slug":"phuong-hung-dung","name_with_type":"Phường Hưng Dũng","path":"Phường Hưng Dũng, Thành phố Vinh, Tỉnh Nghệ An","path_with_type":"Phường Hưng Dũng, Thành phố Vinh, Tỉnh Nghệ An","code":"16675","parent_code":"412"},"16678":{"name":"Phường Cửa Nam","type":"phuong","slug":"phuong-cua-nam","name_with_type":"Phường Cửa Nam","path":"Phường Cửa Nam, Thành phố Vinh, Tỉnh Nghệ An","path_with_type":"Phường Cửa Nam, Thành phố Vinh, Tỉnh Nghệ An","code":"16678","parent_code":"412"},"16681":{"name":"Phường Quang Trung","type":"phuong","slug":"phuong-quang-trung","name_with_type":"Phường Quang Trung","path":"Phường Quang Trung, Thành phố Vinh, Tỉnh Nghệ An","path_with_type":"Phường Quang Trung, Thành phố Vinh, Tỉnh Nghệ An","code":"16681","parent_code":"412"},"16690":{"name":"Phường Trường Thi","type":"phuong","slug":"phuong-truong-thi","name_with_type":"Phường Trường Thi","path":"Phường Trường Thi, Thành phố Vinh, Tỉnh Nghệ An","path_with_type":"Phường Trường Thi, Thành phố Vinh, Tỉnh Nghệ An","code":"16690","parent_code":"412"},"16693":{"name":"Phường Bến Thủy","type":"phuong","slug":"phuong-ben-thuy","name_with_type":"Phường Bến Thủy","path":"Phường Bến Thủy, Thành phố Vinh, Tỉnh Nghệ An","path_with_type":"Phường Bến Thủy, Thành phố Vinh, Tỉnh Nghệ An","code":"16693","parent_code":"412"},"16699":{"name":"Phường Trung Đô","type":"phuong","slug":"phuong-trung-do","name_with_type":"Phường Trung Đô","path":"Phường Trung Đô, Thành phố Vinh, Tỉnh Nghệ An","path_with_type":"Phường Trung Đô, Thành phố Vinh, Tỉnh Nghệ An","code":"16699","parent_code":"412"},"16702":{"name":"Phường Nghi Phú","type":"phuong","slug":"phuong-nghi-phu","name_with_type":"Phường Nghi Phú","path":"Phường Nghi Phú, Thành phố Vinh, Tỉnh Nghệ An","path_with_type":"Phường Nghi Phú, Thành phố Vinh, Tỉnh Nghệ An","code":"16702","parent_code":"412"},"16705":{"name":"Phường Hưng Đông","type":"phuong","slug":"phuong-hung-dong","name_with_type":"Phường Hưng Đông","path":"Phường Hưng Đông, Thành phố Vinh, Tỉnh Nghệ An","path_with_type":"Phường Hưng Đông, Thành phố Vinh, Tỉnh Nghệ An","code":"16705","parent_code":"412"},"16708":{"name":"Phường Hưng Lộc","type":"phuong","slug":"phuong-hung-loc","name_with_type":"Phường Hưng Lộc","path":"Phường Hưng Lộc, Thành phố Vinh, Tỉnh Nghệ An","path_with_type":"Phường Hưng Lộc, Thành phố Vinh, Tỉnh Nghệ An","code":"16708","parent_code":"412"},"16711":{"name":"Xã Hưng Hòa","type":"xa","slug":"xa-hung-hoa","name_with_type":"Xã Hưng Hòa","path":"Xã Hưng Hòa, Thành phố Vinh, Tỉnh Nghệ An","path_with_type":"Xã Hưng Hòa, Thành phố Vinh, Tỉnh Nghệ An","code":"16711","parent_code":"412"},"16714":{"name":"Phường Vinh Tân","type":"phuong","slug":"phuong-vinh-tan","name_with_type":"Phường Vinh Tân","path":"Phường Vinh Tân, Thành phố Vinh, Tỉnh Nghệ An","path_with_type":"Phường Vinh Tân, Thành phố Vinh, Tỉnh Nghệ An","code":"16714","parent_code":"412"},"16717":{"name":"Phường Nghi Thuỷ","type":"phuong","slug":"phuong-nghi-thuy","name_with_type":"Phường Nghi Thuỷ","path":"Phường Nghi Thuỷ, Thành phố Vinh, Tỉnh Nghệ An","path_with_type":"Phường Nghi Thuỷ, Thành phố Vinh, Tỉnh Nghệ An","code":"16717","parent_code":"412"},"16720":{"name":"Phường Nghi Tân","type":"phuong","slug":"phuong-nghi-tan","name_with_type":"Phường Nghi Tân","path":"Phường Nghi Tân, Thành phố Vinh, Tỉnh Nghệ An","path_with_type":"Phường Nghi Tân, Thành phố Vinh, Tỉnh Nghệ An","code":"16720","parent_code":"412"},"16723":{"name":"Phường Thu Thuỷ","type":"phuong","slug":"phuong-thu-thuy","name_with_type":"Phường Thu Thuỷ","path":"Phường Thu Thuỷ, Thành phố Vinh, Tỉnh Nghệ An","path_with_type":"Phường Thu Thuỷ, Thành phố Vinh, Tỉnh Nghệ An","code":"16723","parent_code":"412"},"16726":{"name":"Phường Nghi Hòa","type":"phuong","slug":"phuong-nghi-hoa","name_with_type":"Phường Nghi Hòa","path":"Phường Nghi Hòa, Thành phố Vinh, Tỉnh Nghệ An","path_with_type":"Phường Nghi Hòa, Thành phố Vinh, Tỉnh Nghệ An","code":"16726","parent_code":"412"},"16729":{"name":"Phường Nghi Hải","type":"phuong","slug":"phuong-nghi-hai","name_with_type":"Phường Nghi Hải","path":"Phường Nghi Hải, Thành phố Vinh, Tỉnh Nghệ An","path_with_type":"Phường Nghi Hải, Thành phố Vinh, Tỉnh Nghệ An","code":"16729","parent_code":"412"},"16732":{"name":"Phường Nghi Hương","type":"phuong","slug":"phuong-nghi-huong","name_with_type":"Phường Nghi Hương","path":"Phường Nghi Hương, Thành phố Vinh, Tỉnh Nghệ An","path_with_type":"Phường Nghi Hương, Thành phố Vinh, Tỉnh Nghệ An","code":"16732","parent_code":"412"},"16735":{"name":"Phường Nghi Thu","type":"phuong","slug":"phuong-nghi-thu","name_with_type":"Phường Nghi Thu","path":"Phường Nghi Thu, Thành phố Vinh, Tỉnh Nghệ An","path_with_type":"Phường Nghi Thu, Thành phố Vinh, Tỉnh Nghệ An","code":"16735","parent_code":"412"},"16738":{"name":"Thị trấn Kim Sơn","type":"thi-tran","slug":"thi-tran-kim-son","name_with_type":"Thị trấn Kim Sơn","path":"Thị trấn Kim Sơn, Huyện Quế Phong, Tỉnh Nghệ An","path_with_type":"Thị trấn Kim Sơn, Huyện Quế Phong, Tỉnh Nghệ An","code":"16738","parent_code":"415"},"16741":{"name":"Xã Thông Thụ","type":"xa","slug":"xa-thong-thu","name_with_type":"Xã Thông Thụ","path":"Xã Thông Thụ, Huyện Quế Phong, Tỉnh Nghệ An","path_with_type":"Xã Thông Thụ, Huyện Quế Phong, Tỉnh Nghệ An","code":"16741","parent_code":"415"},"16744":{"name":"Xã Đồng Văn","type":"xa","slug":"xa-dong-van","name_with_type":"Xã Đồng Văn","path":"Xã Đồng Văn, Huyện Quế Phong, Tỉnh Nghệ An","path_with_type":"Xã Đồng Văn, Huyện Quế Phong, Tỉnh Nghệ An","code":"16744","parent_code":"415"},"16747":{"name":"Xã Hạnh Dịch","type":"xa","slug":"xa-hanh-dich","name_with_type":"Xã Hạnh Dịch","path":"Xã Hạnh Dịch, Huyện Quế Phong, Tỉnh Nghệ An","path_with_type":"Xã Hạnh Dịch, Huyện Quế Phong, Tỉnh Nghệ An","code":"16747","parent_code":"415"},"16750":{"name":"Xã Tiền Phong","type":"xa","slug":"xa-tien-phong","name_with_type":"Xã Tiền Phong","path":"Xã Tiền Phong, Huyện Quế Phong, Tỉnh Nghệ An","path_with_type":"Xã Tiền Phong, Huyện Quế Phong, Tỉnh Nghệ An","code":"16750","parent_code":"415"},"16753":{"name":"Xã Nậm Giải","type":"xa","slug":"xa-nam-giai","name_with_type":"Xã Nậm Giải","path":"Xã Nậm Giải, Huyện Quế Phong, Tỉnh Nghệ An","path_with_type":"Xã Nậm Giải, Huyện Quế Phong, Tỉnh Nghệ An","code":"16753","parent_code":"415"},"16756":{"name":"Xã Tri Lễ","type":"xa","slug":"xa-tri-le","name_with_type":"Xã Tri Lễ","path":"Xã Tri Lễ, Huyện Quế Phong, Tỉnh Nghệ An","path_with_type":"Xã Tri Lễ, Huyện Quế Phong, Tỉnh Nghệ An","code":"16756","parent_code":"415"},"16759":{"name":"Xã Châu Kim","type":"xa","slug":"xa-chau-kim","name_with_type":"Xã Châu Kim","path":"Xã Châu Kim, Huyện Quế Phong, Tỉnh Nghệ An","path_with_type":"Xã Châu Kim, Huyện Quế Phong, Tỉnh Nghệ An","code":"16759","parent_code":"415"},"16763":{"name":"Xã Mường Nọc","type":"xa","slug":"xa-muong-noc","name_with_type":"Xã Mường Nọc","path":"Xã Mường Nọc, Huyện Quế Phong, Tỉnh Nghệ An","path_with_type":"Xã Mường Nọc, Huyện Quế Phong, Tỉnh Nghệ An","code":"16763","parent_code":"415"},"16765":{"name":"Xã Châu Thôn","type":"xa","slug":"xa-chau-thon","name_with_type":"Xã Châu Thôn","path":"Xã Châu Thôn, Huyện Quế Phong, Tỉnh Nghệ An","path_with_type":"Xã Châu Thôn, Huyện Quế Phong, Tỉnh Nghệ An","code":"16765","parent_code":"415"},"16768":{"name":"Xã Nậm Nhoóng","type":"xa","slug":"xa-nam-nhoong","name_with_type":"Xã Nậm Nhoóng","path":"Xã Nậm Nhoóng, Huyện Quế Phong, Tỉnh Nghệ An","path_with_type":"Xã Nậm Nhoóng, Huyện Quế Phong, Tỉnh Nghệ An","code":"16768","parent_code":"415"},"16771":{"name":"Xã Quang Phong","type":"xa","slug":"xa-quang-phong","name_with_type":"Xã Quang Phong","path":"Xã Quang Phong, Huyện Quế Phong, Tỉnh Nghệ An","path_with_type":"Xã Quang Phong, Huyện Quế Phong, Tỉnh Nghệ An","code":"16771","parent_code":"415"},"16774":{"name":"Xã Căm Muộn","type":"xa","slug":"xa-cam-muon","name_with_type":"Xã Căm Muộn","path":"Xã Căm Muộn, Huyện Quế Phong, Tỉnh Nghệ An","path_with_type":"Xã Căm Muộn, Huyện Quế Phong, Tỉnh Nghệ An","code":"16774","parent_code":"415"},"16777":{"name":"Thị trấn Tân Lạc","type":"thi-tran","slug":"thi-tran-tan-lac","name_with_type":"Thị trấn Tân Lạc","path":"Thị trấn Tân Lạc, Huyện Quỳ Châu, Tỉnh Nghệ An","path_with_type":"Thị trấn Tân Lạc, Huyện Quỳ Châu, Tỉnh Nghệ An","code":"16777","parent_code":"416"},"16780":{"name":"Xã Châu Bính","type":"xa","slug":"xa-chau-binh","name_with_type":"Xã Châu Bính","path":"Xã Châu Bính, Huyện Quỳ Châu, Tỉnh Nghệ An","path_with_type":"Xã Châu Bính, Huyện Quỳ Châu, Tỉnh Nghệ An","code":"16780","parent_code":"416"},"16783":{"name":"Xã Châu Thuận","type":"xa","slug":"xa-chau-thuan","name_with_type":"Xã Châu Thuận","path":"Xã Châu Thuận, Huyện Quỳ Châu, Tỉnh Nghệ An","path_with_type":"Xã Châu Thuận, Huyện Quỳ Châu, Tỉnh Nghệ An","code":"16783","parent_code":"416"},"16786":{"name":"Xã Châu Hội","type":"xa","slug":"xa-chau-hoi","name_with_type":"Xã Châu Hội","path":"Xã Châu Hội, Huyện Quỳ Châu, Tỉnh Nghệ An","path_with_type":"Xã Châu Hội, Huyện Quỳ Châu, Tỉnh Nghệ An","code":"16786","parent_code":"416"},"16789":{"name":"Xã Châu Nga","type":"xa","slug":"xa-chau-nga","name_with_type":"Xã Châu Nga","path":"Xã Châu Nga, Huyện Quỳ Châu, Tỉnh Nghệ An","path_with_type":"Xã Châu Nga, Huyện Quỳ Châu, Tỉnh Nghệ An","code":"16789","parent_code":"416"},"16792":{"name":"Xã Châu Tiến","type":"xa","slug":"xa-chau-tien","name_with_type":"Xã Châu Tiến","path":"Xã Châu Tiến, Huyện Quỳ Châu, Tỉnh Nghệ An","path_with_type":"Xã Châu Tiến, Huyện Quỳ Châu, Tỉnh Nghệ An","code":"16792","parent_code":"416"},"16795":{"name":"Xã Châu Hạnh","type":"xa","slug":"xa-chau-hanh","name_with_type":"Xã Châu Hạnh","path":"Xã Châu Hạnh, Huyện Quỳ Châu, Tỉnh Nghệ An","path_with_type":"Xã Châu Hạnh, Huyện Quỳ Châu, Tỉnh Nghệ An","code":"16795","parent_code":"416"},"16798":{"name":"Xã Châu Thắng","type":"xa","slug":"xa-chau-thang","name_with_type":"Xã Châu Thắng","path":"Xã Châu Thắng, Huyện Quỳ Châu, Tỉnh Nghệ An","path_with_type":"Xã Châu Thắng, Huyện Quỳ Châu, Tỉnh Nghệ An","code":"16798","parent_code":"416"},"16801":{"name":"Xã Châu Phong","type":"xa","slug":"xa-chau-phong","name_with_type":"Xã Châu Phong","path":"Xã Châu Phong, Huyện Quỳ Châu, Tỉnh Nghệ An","path_with_type":"Xã Châu Phong, Huyện Quỳ Châu, Tỉnh Nghệ An","code":"16801","parent_code":"416"},"16804":{"name":"Xã Châu Bình","type":"xa","slug":"xa-chau-binh","name_with_type":"Xã Châu Bình","path":"Xã Châu Bình, Huyện Quỳ Châu, Tỉnh Nghệ An","path_with_type":"Xã Châu Bình, Huyện Quỳ Châu, Tỉnh Nghệ An","code":"16804","parent_code":"416"},"16807":{"name":"Xã Châu Hoàn","type":"xa","slug":"xa-chau-hoan","name_with_type":"Xã Châu Hoàn","path":"Xã Châu Hoàn, Huyện Quỳ Châu, Tỉnh Nghệ An","path_with_type":"Xã Châu Hoàn, Huyện Quỳ Châu, Tỉnh Nghệ An","code":"16807","parent_code":"416"},"16810":{"name":"Xã Diên Lãm","type":"xa","slug":"xa-dien-lam","name_with_type":"Xã Diên Lãm","path":"Xã Diên Lãm, Huyện Quỳ Châu, Tỉnh Nghệ An","path_with_type":"Xã Diên Lãm, Huyện Quỳ Châu, Tỉnh Nghệ An","code":"16810","parent_code":"416"},"16813":{"name":"Thị trấn Mường Xén","type":"thi-tran","slug":"thi-tran-muong-xen","name_with_type":"Thị trấn Mường Xén","path":"Thị trấn Mường Xén, Huyện Kỳ Sơn, Tỉnh Nghệ An","path_with_type":"Thị trấn Mường Xén, Huyện Kỳ Sơn, Tỉnh Nghệ An","code":"16813","parent_code":"417"},"16816":{"name":"Xã Mỹ Lý","type":"xa","slug":"xa-my-ly","name_with_type":"Xã Mỹ Lý","path":"Xã Mỹ Lý, Huyện Kỳ Sơn, Tỉnh Nghệ An","path_with_type":"Xã Mỹ Lý, Huyện Kỳ Sơn, Tỉnh Nghệ An","code":"16816","parent_code":"417"},"16819":{"name":"Xã Bắc Lý","type":"xa","slug":"xa-bac-ly","name_with_type":"Xã Bắc Lý","path":"Xã Bắc Lý, Huyện Kỳ Sơn, Tỉnh Nghệ An","path_with_type":"Xã Bắc Lý, Huyện Kỳ Sơn, Tỉnh Nghệ An","code":"16819","parent_code":"417"},"16822":{"name":"Xã Keng Đu","type":"xa","slug":"xa-keng-du","name_with_type":"Xã Keng Đu","path":"Xã Keng Đu, Huyện Kỳ Sơn, Tỉnh Nghệ An","path_with_type":"Xã Keng Đu, Huyện Kỳ Sơn, Tỉnh Nghệ An","code":"16822","parent_code":"417"},"16825":{"name":"Xã Đoọc Mạy","type":"xa","slug":"xa-dooc-may","name_with_type":"Xã Đoọc Mạy","path":"Xã Đoọc Mạy, Huyện Kỳ Sơn, Tỉnh Nghệ An","path_with_type":"Xã Đoọc Mạy, Huyện Kỳ Sơn, Tỉnh Nghệ An","code":"16825","parent_code":"417"},"16828":{"name":"Xã Huồi Tụ","type":"xa","slug":"xa-huoi-tu","name_with_type":"Xã Huồi Tụ","path":"Xã Huồi Tụ, Huyện Kỳ Sơn, Tỉnh Nghệ An","path_with_type":"Xã Huồi Tụ, Huyện Kỳ Sơn, Tỉnh Nghệ An","code":"16828","parent_code":"417"},"16831":{"name":"Xã Mường Lống","type":"xa","slug":"xa-muong-long","name_with_type":"Xã Mường Lống","path":"Xã Mường Lống, Huyện Kỳ Sơn, Tỉnh Nghệ An","path_with_type":"Xã Mường Lống, Huyện Kỳ Sơn, Tỉnh Nghệ An","code":"16831","parent_code":"417"},"16834":{"name":"Xã Na Loi","type":"xa","slug":"xa-na-loi","name_with_type":"Xã Na Loi","path":"Xã Na Loi, Huyện Kỳ Sơn, Tỉnh Nghệ An","path_with_type":"Xã Na Loi, Huyện Kỳ Sơn, Tỉnh Nghệ An","code":"16834","parent_code":"417"},"16837":{"name":"Xã Nậm Cắn","type":"xa","slug":"xa-nam-can","name_with_type":"Xã Nậm Cắn","path":"Xã Nậm Cắn, Huyện Kỳ Sơn, Tỉnh Nghệ An","path_with_type":"Xã Nậm Cắn, Huyện Kỳ Sơn, Tỉnh Nghệ An","code":"16837","parent_code":"417"},"16840":{"name":"Xã Bảo Nam","type":"xa","slug":"xa-bao-nam","name_with_type":"Xã Bảo Nam","path":"Xã Bảo Nam, Huyện Kỳ Sơn, Tỉnh Nghệ An","path_with_type":"Xã Bảo Nam, Huyện Kỳ Sơn, Tỉnh Nghệ An","code":"16840","parent_code":"417"},"16843":{"name":"Xã Phà Đánh","type":"xa","slug":"xa-pha-danh","name_with_type":"Xã Phà Đánh","path":"Xã Phà Đánh, Huyện Kỳ Sơn, Tỉnh Nghệ An","path_with_type":"Xã Phà Đánh, Huyện Kỳ Sơn, Tỉnh Nghệ An","code":"16843","parent_code":"417"},"16846":{"name":"Xã Bảo Thắng","type":"xa","slug":"xa-bao-thang","name_with_type":"Xã Bảo Thắng","path":"Xã Bảo Thắng, Huyện Kỳ Sơn, Tỉnh Nghệ An","path_with_type":"Xã Bảo Thắng, Huyện Kỳ Sơn, Tỉnh Nghệ An","code":"16846","parent_code":"417"},"16849":{"name":"Xã Hữu Lập","type":"xa","slug":"xa-huu-lap","name_with_type":"Xã Hữu Lập","path":"Xã Hữu Lập, Huyện Kỳ Sơn, Tỉnh Nghệ An","path_with_type":"Xã Hữu Lập, Huyện Kỳ Sơn, Tỉnh Nghệ An","code":"16849","parent_code":"417"},"16852":{"name":"Xã Tà Cạ","type":"xa","slug":"xa-ta-ca","name_with_type":"Xã Tà Cạ","path":"Xã Tà Cạ, Huyện Kỳ Sơn, Tỉnh Nghệ An","path_with_type":"Xã Tà Cạ, Huyện Kỳ Sơn, Tỉnh Nghệ An","code":"16852","parent_code":"417"},"16855":{"name":"Xã Chiêu Lưu","type":"xa","slug":"xa-chieu-luu","name_with_type":"Xã Chiêu Lưu","path":"Xã Chiêu Lưu, Huyện Kỳ Sơn, Tỉnh Nghệ An","path_with_type":"Xã Chiêu Lưu, Huyện Kỳ Sơn, Tỉnh Nghệ An","code":"16855","parent_code":"417"},"16858":{"name":"Xã Mường Típ","type":"xa","slug":"xa-muong-tip","name_with_type":"Xã Mường Típ","path":"Xã Mường Típ, Huyện Kỳ Sơn, Tỉnh Nghệ An","path_with_type":"Xã Mường Típ, Huyện Kỳ Sơn, Tỉnh Nghệ An","code":"16858","parent_code":"417"},"16861":{"name":"Xã Hữu Kiệm","type":"xa","slug":"xa-huu-kiem","name_with_type":"Xã Hữu Kiệm","path":"Xã Hữu Kiệm, Huyện Kỳ Sơn, Tỉnh Nghệ An","path_with_type":"Xã Hữu Kiệm, Huyện Kỳ Sơn, Tỉnh Nghệ An","code":"16861","parent_code":"417"},"16864":{"name":"Xã Tây Sơn","type":"xa","slug":"xa-tay-son","name_with_type":"Xã Tây Sơn","path":"Xã Tây Sơn, Huyện Kỳ Sơn, Tỉnh Nghệ An","path_with_type":"Xã Tây Sơn, Huyện Kỳ Sơn, Tỉnh Nghệ An","code":"16864","parent_code":"417"},"16867":{"name":"Xã Mường Ải","type":"xa","slug":"xa-muong-ai","name_with_type":"Xã Mường Ải","path":"Xã Mường Ải, Huyện Kỳ Sơn, Tỉnh Nghệ An","path_with_type":"Xã Mường Ải, Huyện Kỳ Sơn, Tỉnh Nghệ An","code":"16867","parent_code":"417"},"16870":{"name":"Xã Na Ngoi","type":"xa","slug":"xa-na-ngoi","name_with_type":"Xã Na Ngoi","path":"Xã Na Ngoi, Huyện Kỳ Sơn, Tỉnh Nghệ An","path_with_type":"Xã Na Ngoi, Huyện Kỳ Sơn, Tỉnh Nghệ An","code":"16870","parent_code":"417"},"16873":{"name":"Xã Nậm Càn","type":"xa","slug":"xa-nam-can","name_with_type":"Xã Nậm Càn","path":"Xã Nậm Càn, Huyện Kỳ Sơn, Tỉnh Nghệ An","path_with_type":"Xã Nậm Càn, Huyện Kỳ Sơn, Tỉnh Nghệ An","code":"16873","parent_code":"417"},"16876":{"name":"Thị trấn Thạch Giám","type":"thi-tran","slug":"thi-tran-thach-giam","name_with_type":"Thị trấn Thạch Giám","path":"Thị trấn Thạch Giám, Huyện Tương Dương, Tỉnh Nghệ An","path_with_type":"Thị trấn Thạch Giám, Huyện Tương Dương, Tỉnh Nghệ An","code":"16876","parent_code":"418"},"16879":{"name":"Xã Mai Sơn","type":"xa","slug":"xa-mai-son","name_with_type":"Xã Mai Sơn","path":"Xã Mai Sơn, Huyện Tương Dương, Tỉnh Nghệ An","path_with_type":"Xã Mai Sơn, Huyện Tương Dương, Tỉnh Nghệ An","code":"16879","parent_code":"418"},"16882":{"name":"Xã Nhôn Mai","type":"xa","slug":"xa-nhon-mai","name_with_type":"Xã Nhôn Mai","path":"Xã Nhôn Mai, Huyện Tương Dương, Tỉnh Nghệ An","path_with_type":"Xã Nhôn Mai, Huyện Tương Dương, Tỉnh Nghệ An","code":"16882","parent_code":"418"},"16885":{"name":"Xã Hữu Khuông","type":"xa","slug":"xa-huu-khuong","name_with_type":"Xã Hữu Khuông","path":"Xã Hữu Khuông, Huyện Tương Dương, Tỉnh Nghệ An","path_with_type":"Xã Hữu Khuông, Huyện Tương Dương, Tỉnh Nghệ An","code":"16885","parent_code":"418"},"16900":{"name":"Xã Yên Tĩnh","type":"xa","slug":"xa-yen-tinh","name_with_type":"Xã Yên Tĩnh","path":"Xã Yên Tĩnh, Huyện Tương Dương, Tỉnh Nghệ An","path_with_type":"Xã Yên Tĩnh, Huyện Tương Dương, Tỉnh Nghệ An","code":"16900","parent_code":"418"},"16903":{"name":"Xã Nga My","type":"xa","slug":"xa-nga-my","name_with_type":"Xã Nga My","path":"Xã Nga My, Huyện Tương Dương, Tỉnh Nghệ An","path_with_type":"Xã Nga My, Huyện Tương Dương, Tỉnh Nghệ An","code":"16903","parent_code":"418"},"16904":{"name":"Xã Xiêng My","type":"xa","slug":"xa-xieng-my","name_with_type":"Xã Xiêng My","path":"Xã Xiêng My, Huyện Tương Dương, Tỉnh Nghệ An","path_with_type":"Xã Xiêng My, Huyện Tương Dương, Tỉnh Nghệ An","code":"16904","parent_code":"418"},"16906":{"name":"Xã Lưỡng Minh","type":"xa","slug":"xa-luong-minh","name_with_type":"Xã Lưỡng Minh","path":"Xã Lưỡng Minh, Huyện Tương Dương, Tỉnh Nghệ An","path_with_type":"Xã Lưỡng Minh, Huyện Tương Dương, Tỉnh Nghệ An","code":"16906","parent_code":"418"},"16909":{"name":"Xã Yên Hòa","type":"xa","slug":"xa-yen-hoa","name_with_type":"Xã Yên Hòa","path":"Xã Yên Hòa, Huyện Tương Dương, Tỉnh Nghệ An","path_with_type":"Xã Yên Hòa, Huyện Tương Dương, Tỉnh Nghệ An","code":"16909","parent_code":"418"},"16912":{"name":"Xã Yên Na","type":"xa","slug":"xa-yen-na","name_with_type":"Xã Yên Na","path":"Xã Yên Na, Huyện Tương Dương, Tỉnh Nghệ An","path_with_type":"Xã Yên Na, Huyện Tương Dương, Tỉnh Nghệ An","code":"16912","parent_code":"418"},"16915":{"name":"Xã Lưu Kiền","type":"xa","slug":"xa-luu-kien","name_with_type":"Xã Lưu Kiền","path":"Xã Lưu Kiền, Huyện Tương Dương, Tỉnh Nghệ An","path_with_type":"Xã Lưu Kiền, Huyện Tương Dương, Tỉnh Nghệ An","code":"16915","parent_code":"418"},"16921":{"name":"Xã Xá Lượng","type":"xa","slug":"xa-xa-luong","name_with_type":"Xã Xá Lượng","path":"Xã Xá Lượng, Huyện Tương Dương, Tỉnh Nghệ An","path_with_type":"Xã Xá Lượng, Huyện Tương Dương, Tỉnh Nghệ An","code":"16921","parent_code":"418"},"16924":{"name":"Xã Tam Thái","type":"xa","slug":"xa-tam-thai","name_with_type":"Xã Tam Thái","path":"Xã Tam Thái, Huyện Tương Dương, Tỉnh Nghệ An","path_with_type":"Xã Tam Thái, Huyện Tương Dương, Tỉnh Nghệ An","code":"16924","parent_code":"418"},"16927":{"name":"Xã Tam Đình","type":"xa","slug":"xa-tam-dinh","name_with_type":"Xã Tam Đình","path":"Xã Tam Đình, Huyện Tương Dương, Tỉnh Nghệ An","path_with_type":"Xã Tam Đình, Huyện Tương Dương, Tỉnh Nghệ An","code":"16927","parent_code":"418"},"16930":{"name":"Xã Yên Thắng","type":"xa","slug":"xa-yen-thang","name_with_type":"Xã Yên Thắng","path":"Xã Yên Thắng, Huyện Tương Dương, Tỉnh Nghệ An","path_with_type":"Xã Yên Thắng, Huyện Tương Dương, Tỉnh Nghệ An","code":"16930","parent_code":"418"},"16933":{"name":"Xã Tam Quang","type":"xa","slug":"xa-tam-quang","name_with_type":"Xã Tam Quang","path":"Xã Tam Quang, Huyện Tương Dương, Tỉnh Nghệ An","path_with_type":"Xã Tam Quang, Huyện Tương Dương, Tỉnh Nghệ An","code":"16933","parent_code":"418"},"16936":{"name":"Xã Tam Hợp","type":"xa","slug":"xa-tam-hop","name_with_type":"Xã Tam Hợp","path":"Xã Tam Hợp, Huyện Tương Dương, Tỉnh Nghệ An","path_with_type":"Xã Tam Hợp, Huyện Tương Dương, Tỉnh Nghệ An","code":"16936","parent_code":"418"},"16939":{"name":"Phường Hoà Hiếu","type":"phuong","slug":"phuong-hoa-hieu","name_with_type":"Phường Hoà Hiếu","path":"Phường Hoà Hiếu, Thị xã Thái Hoà, Tỉnh Nghệ An","path_with_type":"Phường Hoà Hiếu, Thị xã Thái Hoà, Tỉnh Nghệ An","code":"16939","parent_code":"414"},"16941":{"name":"Thị trấn Nghĩa Đàn","type":"thi-tran","slug":"thi-tran-nghia-dan","name_with_type":"Thị trấn Nghĩa Đàn","path":"Thị trấn Nghĩa Đàn, Huyện Nghĩa Đàn, Tỉnh Nghệ An","path_with_type":"Thị trấn Nghĩa Đàn, Huyện Nghĩa Đàn, Tỉnh Nghệ An","code":"16941","parent_code":"419"},"16942":{"name":"Xã Nghĩa Mai","type":"xa","slug":"xa-nghia-mai","name_with_type":"Xã Nghĩa Mai","path":"Xã Nghĩa Mai, Huyện Nghĩa Đàn, Tỉnh Nghệ An","path_with_type":"Xã Nghĩa Mai, Huyện Nghĩa Đàn, Tỉnh Nghệ An","code":"16942","parent_code":"419"},"16945":{"name":"Xã Nghĩa Yên","type":"xa","slug":"xa-nghia-yen","name_with_type":"Xã Nghĩa Yên","path":"Xã Nghĩa Yên, Huyện Nghĩa Đàn, Tỉnh Nghệ An","path_with_type":"Xã Nghĩa Yên, Huyện Nghĩa Đàn, Tỉnh Nghệ An","code":"16945","parent_code":"419"},"16948":{"name":"Xã Nghĩa Lạc","type":"xa","slug":"xa-nghia-lac","name_with_type":"Xã Nghĩa Lạc","path":"Xã Nghĩa Lạc, Huyện Nghĩa Đàn, Tỉnh Nghệ An","path_with_type":"Xã Nghĩa Lạc, Huyện Nghĩa Đàn, Tỉnh Nghệ An","code":"16948","parent_code":"419"},"16951":{"name":"Xã Nghĩa Lâm","type":"xa","slug":"xa-nghia-lam","name_with_type":"Xã Nghĩa Lâm","path":"Xã Nghĩa Lâm, Huyện Nghĩa Đàn, Tỉnh Nghệ An","path_with_type":"Xã Nghĩa Lâm, Huyện Nghĩa Đàn, Tỉnh Nghệ An","code":"16951","parent_code":"419"},"16954":{"name":"Xã Nghĩa Sơn","type":"xa","slug":"xa-nghia-son","name_with_type":"Xã Nghĩa Sơn","path":"Xã Nghĩa Sơn, Huyện Nghĩa Đàn, Tỉnh Nghệ An","path_with_type":"Xã Nghĩa Sơn, Huyện Nghĩa Đàn, Tỉnh Nghệ An","code":"16954","parent_code":"419"},"16957":{"name":"Xã Nghĩa Lợi","type":"xa","slug":"xa-nghia-loi","name_with_type":"Xã Nghĩa Lợi","path":"Xã Nghĩa Lợi, Huyện Nghĩa Đàn, Tỉnh Nghệ An","path_with_type":"Xã Nghĩa Lợi, Huyện Nghĩa Đàn, Tỉnh Nghệ An","code":"16957","parent_code":"419"},"16960":{"name":"Xã Nghĩa Bình","type":"xa","slug":"xa-nghia-binh","name_with_type":"Xã Nghĩa Bình","path":"Xã Nghĩa Bình, Huyện Nghĩa Đàn, Tỉnh Nghệ An","path_with_type":"Xã Nghĩa Bình, Huyện Nghĩa Đàn, Tỉnh Nghệ An","code":"16960","parent_code":"419"},"16966":{"name":"Xã Nghĩa Minh","type":"xa","slug":"xa-nghia-minh","name_with_type":"Xã Nghĩa Minh","path":"Xã Nghĩa Minh, Huyện Nghĩa Đàn, Tỉnh Nghệ An","path_with_type":"Xã Nghĩa Minh, Huyện Nghĩa Đàn, Tỉnh Nghệ An","code":"16966","parent_code":"419"},"16969":{"name":"Xã Nghĩa Thọ","type":"xa","slug":"xa-nghia-tho","name_with_type":"Xã Nghĩa Thọ","path":"Xã Nghĩa Thọ, Huyện Nghĩa Đàn, Tỉnh Nghệ An","path_with_type":"Xã Nghĩa Thọ, Huyện Nghĩa Đàn, Tỉnh Nghệ An","code":"16969","parent_code":"419"},"16972":{"name":"Xã Nghĩa Hưng","type":"xa","slug":"xa-nghia-hung","name_with_type":"Xã Nghĩa Hưng","path":"Xã Nghĩa Hưng, Huyện Nghĩa Đàn, Tỉnh Nghệ An","path_with_type":"Xã Nghĩa Hưng, Huyện Nghĩa Đàn, Tỉnh Nghệ An","code":"16972","parent_code":"419"},"16975":{"name":"Xã Nghĩa Hồng","type":"xa","slug":"xa-nghia-hong","name_with_type":"Xã Nghĩa Hồng","path":"Xã Nghĩa Hồng, Huyện Nghĩa Đàn, Tỉnh Nghệ An","path_with_type":"Xã Nghĩa Hồng, Huyện Nghĩa Đàn, Tỉnh Nghệ An","code":"16975","parent_code":"419"},"16981":{"name":"Xã Nghĩa Trung","type":"xa","slug":"xa-nghia-trung","name_with_type":"Xã Nghĩa Trung","path":"Xã Nghĩa Trung, Huyện Nghĩa Đàn, Tỉnh Nghệ An","path_with_type":"Xã Nghĩa Trung, Huyện Nghĩa Đàn, Tỉnh Nghệ An","code":"16981","parent_code":"419"},"16984":{"name":"Xã Nghĩa Hội","type":"xa","slug":"xa-nghia-hoi","name_with_type":"Xã Nghĩa Hội","path":"Xã Nghĩa Hội, Huyện Nghĩa Đàn, Tỉnh Nghệ An","path_with_type":"Xã Nghĩa Hội, Huyện Nghĩa Đàn, Tỉnh Nghệ An","code":"16984","parent_code":"419"},"16987":{"name":"Xã Nghĩa Thành","type":"xa","slug":"xa-nghia-thanh","name_with_type":"Xã Nghĩa Thành","path":"Xã Nghĩa Thành, Huyện Nghĩa Đàn, Tỉnh Nghệ An","path_with_type":"Xã Nghĩa Thành, Huyện Nghĩa Đàn, Tỉnh Nghệ An","code":"16987","parent_code":"419"},"16993":{"name":"Phường Quang Phong","type":"phuong","slug":"phuong-quang-phong","name_with_type":"Phường Quang Phong","path":"Phường Quang Phong, Thị xã Thái Hoà, Tỉnh Nghệ An","path_with_type":"Phường Quang Phong, Thị xã Thái Hoà, Tỉnh Nghệ An","code":"16993","parent_code":"414"},"16994":{"name":"Phường Quang Tiến","type":"phuong","slug":"phuong-quang-tien","name_with_type":"Phường Quang Tiến","path":"Phường Quang Tiến, Thị xã Thái Hoà, Tỉnh Nghệ An","path_with_type":"Phường Quang Tiến, Thị xã Thái Hoà, Tỉnh Nghệ An","code":"16994","parent_code":"414"},"17003":{"name":"Phường Long Sơn","type":"phuong","slug":"phuong-long-son","name_with_type":"Phường Long Sơn","path":"Phường Long Sơn, Thị xã Thái Hoà, Tỉnh Nghệ An","path_with_type":"Phường Long Sơn, Thị xã Thái Hoà, Tỉnh Nghệ An","code":"17003","parent_code":"414"},"17005":{"name":"Xã Nghĩa Tiến","type":"xa","slug":"xa-nghia-tien","name_with_type":"Xã Nghĩa Tiến","path":"Xã Nghĩa Tiến, Thị xã Thái Hoà, Tỉnh Nghệ An","path_with_type":"Xã Nghĩa Tiến, Thị xã Thái Hoà, Tỉnh Nghệ An","code":"17005","parent_code":"414"},"17008":{"name":"Xã Nghĩa Mỹ","type":"xa","slug":"xa-nghia-my","name_with_type":"Xã Nghĩa Mỹ","path":"Xã Nghĩa Mỹ, Thị xã Thái Hoà, Tỉnh Nghệ An","path_with_type":"Xã Nghĩa Mỹ, Thị xã Thái Hoà, Tỉnh Nghệ An","code":"17008","parent_code":"414"},"17011":{"name":"Xã Tây Hiếu","type":"xa","slug":"xa-tay-hieu","name_with_type":"Xã Tây Hiếu","path":"Xã Tây Hiếu, Thị xã Thái Hoà, Tỉnh Nghệ An","path_with_type":"Xã Tây Hiếu, Thị xã Thái Hoà, Tỉnh Nghệ An","code":"17011","parent_code":"414"},"17014":{"name":"Xã Nghĩa Thuận","type":"xa","slug":"xa-nghia-thuan","name_with_type":"Xã Nghĩa Thuận","path":"Xã Nghĩa Thuận, Thị xã Thái Hoà, Tỉnh Nghệ An","path_with_type":"Xã Nghĩa Thuận, Thị xã Thái Hoà, Tỉnh Nghệ An","code":"17014","parent_code":"414"},"17017":{"name":"Xã Đông Hiếu","type":"xa","slug":"xa-dong-hieu","name_with_type":"Xã Đông Hiếu","path":"Xã Đông Hiếu, Thị xã Thái Hoà, Tỉnh Nghệ An","path_with_type":"Xã Đông Hiếu, Thị xã Thái Hoà, Tỉnh Nghệ An","code":"17017","parent_code":"414"},"17020":{"name":"Xã Nghĩa Đức","type":"xa","slug":"xa-nghia-duc","name_with_type":"Xã Nghĩa Đức","path":"Xã Nghĩa Đức, Huyện Nghĩa Đàn, Tỉnh Nghệ An","path_with_type":"Xã Nghĩa Đức, Huyện Nghĩa Đàn, Tỉnh Nghệ An","code":"17020","parent_code":"419"},"17023":{"name":"Xã Nghĩa An","type":"xa","slug":"xa-nghia-an","name_with_type":"Xã Nghĩa An","path":"Xã Nghĩa An, Huyện Nghĩa Đàn, Tỉnh Nghệ An","path_with_type":"Xã Nghĩa An, Huyện Nghĩa Đàn, Tỉnh Nghệ An","code":"17023","parent_code":"419"},"17026":{"name":"Xã Nghĩa Long","type":"xa","slug":"xa-nghia-long","name_with_type":"Xã Nghĩa Long","path":"Xã Nghĩa Long, Huyện Nghĩa Đàn, Tỉnh Nghệ An","path_with_type":"Xã Nghĩa Long, Huyện Nghĩa Đàn, Tỉnh Nghệ An","code":"17026","parent_code":"419"},"17029":{"name":"Xã Nghĩa Lộc","type":"xa","slug":"xa-nghia-loc","name_with_type":"Xã Nghĩa Lộc","path":"Xã Nghĩa Lộc, Huyện Nghĩa Đàn, Tỉnh Nghệ An","path_with_type":"Xã Nghĩa Lộc, Huyện Nghĩa Đàn, Tỉnh Nghệ An","code":"17029","parent_code":"419"},"17032":{"name":"Xã Nghĩa Khánh","type":"xa","slug":"xa-nghia-khanh","name_with_type":"Xã Nghĩa Khánh","path":"Xã Nghĩa Khánh, Huyện Nghĩa Đàn, Tỉnh Nghệ An","path_with_type":"Xã Nghĩa Khánh, Huyện Nghĩa Đàn, Tỉnh Nghệ An","code":"17032","parent_code":"419"},"17035":{"name":"Thị trấn Quỳ Hợp","type":"thi-tran","slug":"thi-tran-quy-hop","name_with_type":"Thị trấn Quỳ Hợp","path":"Thị trấn Quỳ Hợp, Huyện Quỳ Hợp, Tỉnh Nghệ An","path_with_type":"Thị trấn Quỳ Hợp, Huyện Quỳ Hợp, Tỉnh Nghệ An","code":"17035","parent_code":"420"},"17038":{"name":"Xã Yên Hợp","type":"xa","slug":"xa-yen-hop","name_with_type":"Xã Yên Hợp","path":"Xã Yên Hợp, Huyện Quỳ Hợp, Tỉnh Nghệ An","path_with_type":"Xã Yên Hợp, Huyện Quỳ Hợp, Tỉnh Nghệ An","code":"17038","parent_code":"420"},"17041":{"name":"Xã Châu Tiến","type":"xa","slug":"xa-chau-tien","name_with_type":"Xã Châu Tiến","path":"Xã Châu Tiến, Huyện Quỳ Hợp, Tỉnh Nghệ An","path_with_type":"Xã Châu Tiến, Huyện Quỳ Hợp, Tỉnh Nghệ An","code":"17041","parent_code":"420"},"17044":{"name":"Xã Châu Hồng","type":"xa","slug":"xa-chau-hong","name_with_type":"Xã Châu Hồng","path":"Xã Châu Hồng, Huyện Quỳ Hợp, Tỉnh Nghệ An","path_with_type":"Xã Châu Hồng, Huyện Quỳ Hợp, Tỉnh Nghệ An","code":"17044","parent_code":"420"},"17047":{"name":"Xã Đồng Hợp","type":"xa","slug":"xa-dong-hop","name_with_type":"Xã Đồng Hợp","path":"Xã Đồng Hợp, Huyện Quỳ Hợp, Tỉnh Nghệ An","path_with_type":"Xã Đồng Hợp, Huyện Quỳ Hợp, Tỉnh Nghệ An","code":"17047","parent_code":"420"},"17050":{"name":"Xã Châu Thành","type":"xa","slug":"xa-chau-thanh","name_with_type":"Xã Châu Thành","path":"Xã Châu Thành, Huyện Quỳ Hợp, Tỉnh Nghệ An","path_with_type":"Xã Châu Thành, Huyện Quỳ Hợp, Tỉnh Nghệ An","code":"17050","parent_code":"420"},"17053":{"name":"Xã Liên Hợp","type":"xa","slug":"xa-lien-hop","name_with_type":"Xã Liên Hợp","path":"Xã Liên Hợp, Huyện Quỳ Hợp, Tỉnh Nghệ An","path_with_type":"Xã Liên Hợp, Huyện Quỳ Hợp, Tỉnh Nghệ An","code":"17053","parent_code":"420"},"17056":{"name":"Xã Châu Lộc","type":"xa","slug":"xa-chau-loc","name_with_type":"Xã Châu Lộc","path":"Xã Châu Lộc, Huyện Quỳ Hợp, Tỉnh Nghệ An","path_with_type":"Xã Châu Lộc, Huyện Quỳ Hợp, Tỉnh Nghệ An","code":"17056","parent_code":"420"},"17059":{"name":"Xã Tam Hợp","type":"xa","slug":"xa-tam-hop","name_with_type":"Xã Tam Hợp","path":"Xã Tam Hợp, Huyện Quỳ Hợp, Tỉnh Nghệ An","path_with_type":"Xã Tam Hợp, Huyện Quỳ Hợp, Tỉnh Nghệ An","code":"17059","parent_code":"420"},"17062":{"name":"Xã Châu Cường","type":"xa","slug":"xa-chau-cuong","name_with_type":"Xã Châu Cường","path":"Xã Châu Cường, Huyện Quỳ Hợp, Tỉnh Nghệ An","path_with_type":"Xã Châu Cường, Huyện Quỳ Hợp, Tỉnh Nghệ An","code":"17062","parent_code":"420"},"17065":{"name":"Xã Châu Quang","type":"xa","slug":"xa-chau-quang","name_with_type":"Xã Châu Quang","path":"Xã Châu Quang, Huyện Quỳ Hợp, Tỉnh Nghệ An","path_with_type":"Xã Châu Quang, Huyện Quỳ Hợp, Tỉnh Nghệ An","code":"17065","parent_code":"420"},"17068":{"name":"Xã Thọ Hợp","type":"xa","slug":"xa-tho-hop","name_with_type":"Xã Thọ Hợp","path":"Xã Thọ Hợp, Huyện Quỳ Hợp, Tỉnh Nghệ An","path_with_type":"Xã Thọ Hợp, Huyện Quỳ Hợp, Tỉnh Nghệ An","code":"17068","parent_code":"420"},"17071":{"name":"Xã Minh Hợp","type":"xa","slug":"xa-minh-hop","name_with_type":"Xã Minh Hợp","path":"Xã Minh Hợp, Huyện Quỳ Hợp, Tỉnh Nghệ An","path_with_type":"Xã Minh Hợp, Huyện Quỳ Hợp, Tỉnh Nghệ An","code":"17071","parent_code":"420"},"17074":{"name":"Xã Nghĩa Xuân","type":"xa","slug":"xa-nghia-xuan","name_with_type":"Xã Nghĩa Xuân","path":"Xã Nghĩa Xuân, Huyện Quỳ Hợp, Tỉnh Nghệ An","path_with_type":"Xã Nghĩa Xuân, Huyện Quỳ Hợp, Tỉnh Nghệ An","code":"17074","parent_code":"420"},"17077":{"name":"Xã Châu Thái","type":"xa","slug":"xa-chau-thai","name_with_type":"Xã Châu Thái","path":"Xã Châu Thái, Huyện Quỳ Hợp, Tỉnh Nghệ An","path_with_type":"Xã Châu Thái, Huyện Quỳ Hợp, Tỉnh Nghệ An","code":"17077","parent_code":"420"},"17080":{"name":"Xã Châu Đình","type":"xa","slug":"xa-chau-dinh","name_with_type":"Xã Châu Đình","path":"Xã Châu Đình, Huyện Quỳ Hợp, Tỉnh Nghệ An","path_with_type":"Xã Châu Đình, Huyện Quỳ Hợp, Tỉnh Nghệ An","code":"17080","parent_code":"420"},"17083":{"name":"Xã Văn Lợi","type":"xa","slug":"xa-van-loi","name_with_type":"Xã Văn Lợi","path":"Xã Văn Lợi, Huyện Quỳ Hợp, Tỉnh Nghệ An","path_with_type":"Xã Văn Lợi, Huyện Quỳ Hợp, Tỉnh Nghệ An","code":"17083","parent_code":"420"},"17086":{"name":"Xã Nam Sơn","type":"xa","slug":"xa-nam-son","name_with_type":"Xã Nam Sơn","path":"Xã Nam Sơn, Huyện Quỳ Hợp, Tỉnh Nghệ An","path_with_type":"Xã Nam Sơn, Huyện Quỳ Hợp, Tỉnh Nghệ An","code":"17086","parent_code":"420"},"17089":{"name":"Xã Châu Lý","type":"xa","slug":"xa-chau-ly","name_with_type":"Xã Châu Lý","path":"Xã Châu Lý, Huyện Quỳ Hợp, Tỉnh Nghệ An","path_with_type":"Xã Châu Lý, Huyện Quỳ Hợp, Tỉnh Nghệ An","code":"17089","parent_code":"420"},"17092":{"name":"Xã Hạ Sơn","type":"xa","slug":"xa-ha-son","name_with_type":"Xã Hạ Sơn","path":"Xã Hạ Sơn, Huyện Quỳ Hợp, Tỉnh Nghệ An","path_with_type":"Xã Hạ Sơn, Huyện Quỳ Hợp, Tỉnh Nghệ An","code":"17092","parent_code":"420"},"17095":{"name":"Xã Bắc Sơn","type":"xa","slug":"xa-bac-son","name_with_type":"Xã Bắc Sơn","path":"Xã Bắc Sơn, Huyện Quỳ Hợp, Tỉnh Nghệ An","path_with_type":"Xã Bắc Sơn, Huyện Quỳ Hợp, Tỉnh Nghệ An","code":"17095","parent_code":"420"},"17101":{"name":"Xã Quỳnh Thắng","type":"xa","slug":"xa-quynh-thang","name_with_type":"Xã Quỳnh Thắng","path":"Xã Quỳnh Thắng, Huyện Quỳnh Lưu, Tỉnh Nghệ An","path_with_type":"Xã Quỳnh Thắng, Huyện Quỳnh Lưu, Tỉnh Nghệ An","code":"17101","parent_code":"421"},"17104":{"name":"Xã Quỳnh Vinh","type":"xa","slug":"xa-quynh-vinh","name_with_type":"Xã Quỳnh Vinh","path":"Xã Quỳnh Vinh, Thị xã Hoàng Mai, Tỉnh Nghệ An","path_with_type":"Xã Quỳnh Vinh, Thị xã Hoàng Mai, Tỉnh Nghệ An","code":"17104","parent_code":"432"},"17107":{"name":"Xã Quỳnh Lộc","type":"xa","slug":"xa-quynh-loc","name_with_type":"Xã Quỳnh Lộc","path":"Xã Quỳnh Lộc, Thị xã Hoàng Mai, Tỉnh Nghệ An","path_with_type":"Xã Quỳnh Lộc, Thị xã Hoàng Mai, Tỉnh Nghệ An","code":"17107","parent_code":"432"},"17110":{"name":"Phường Quỳnh Thiện","type":"phuong","slug":"phuong-quynh-thien","name_with_type":"Phường Quỳnh Thiện","path":"Phường Quỳnh Thiện, Thị xã Hoàng Mai, Tỉnh Nghệ An","path_with_type":"Phường Quỳnh Thiện, Thị xã Hoàng Mai, Tỉnh Nghệ An","code":"17110","parent_code":"432"},"17113":{"name":"Xã Quỳnh Lập","type":"xa","slug":"xa-quynh-lap","name_with_type":"Xã Quỳnh Lập","path":"Xã Quỳnh Lập, Thị xã Hoàng Mai, Tỉnh Nghệ An","path_with_type":"Xã Quỳnh Lập, Thị xã Hoàng Mai, Tỉnh Nghệ An","code":"17113","parent_code":"432"},"17116":{"name":"Xã Quỳnh Trang","type":"xa","slug":"xa-quynh-trang","name_with_type":"Xã Quỳnh Trang","path":"Xã Quỳnh Trang, Thị xã Hoàng Mai, Tỉnh Nghệ An","path_with_type":"Xã Quỳnh Trang, Thị xã Hoàng Mai, Tỉnh Nghệ An","code":"17116","parent_code":"432"},"17119":{"name":"Xã Quỳnh Tân","type":"xa","slug":"xa-quynh-tan","name_with_type":"Xã Quỳnh Tân","path":"Xã Quỳnh Tân, Huyện Quỳnh Lưu, Tỉnh Nghệ An","path_with_type":"Xã Quỳnh Tân, Huyện Quỳnh Lưu, Tỉnh Nghệ An","code":"17119","parent_code":"421"},"17122":{"name":"Xã Quỳnh Châu","type":"xa","slug":"xa-quynh-chau","name_with_type":"Xã Quỳnh Châu","path":"Xã Quỳnh Châu, Huyện Quỳnh Lưu, Tỉnh Nghệ An","path_with_type":"Xã Quỳnh Châu, Huyện Quỳnh Lưu, Tỉnh Nghệ An","code":"17122","parent_code":"421"},"17125":{"name":"Phường Mai Hùng","type":"phuong","slug":"phuong-mai-hung","name_with_type":"Phường Mai Hùng","path":"Phường Mai Hùng, Thị xã Hoàng Mai, Tỉnh Nghệ An","path_with_type":"Phường Mai Hùng, Thị xã Hoàng Mai, Tỉnh Nghệ An","code":"17125","parent_code":"432"},"17128":{"name":"Phường Quỳnh Dị","type":"phuong","slug":"phuong-quynh-di","name_with_type":"Phường Quỳnh Dị","path":"Phường Quỳnh Dị, Thị xã Hoàng Mai, Tỉnh Nghệ An","path_with_type":"Phường Quỳnh Dị, Thị xã Hoàng Mai, Tỉnh Nghệ An","code":"17128","parent_code":"432"},"17131":{"name":"Phường Quỳnh Xuân","type":"phuong","slug":"phuong-quynh-xuan","name_with_type":"Phường Quỳnh Xuân","path":"Phường Quỳnh Xuân, Thị xã Hoàng Mai, Tỉnh Nghệ An","path_with_type":"Phường Quỳnh Xuân, Thị xã Hoàng Mai, Tỉnh Nghệ An","code":"17131","parent_code":"432"},"17134":{"name":"Phường Quỳnh Phương","type":"phuong","slug":"phuong-quynh-phuong","name_with_type":"Phường Quỳnh Phương","path":"Phường Quỳnh Phương, Thị xã Hoàng Mai, Tỉnh Nghệ An","path_with_type":"Phường Quỳnh Phương, Thị xã Hoàng Mai, Tỉnh Nghệ An","code":"17134","parent_code":"432"},"17137":{"name":"Xã Quỳnh Liên","type":"xa","slug":"xa-quynh-lien","name_with_type":"Xã Quỳnh Liên","path":"Xã Quỳnh Liên, Thị xã Hoàng Mai, Tỉnh Nghệ An","path_with_type":"Xã Quỳnh Liên, Thị xã Hoàng Mai, Tỉnh Nghệ An","code":"17137","parent_code":"432"},"17140":{"name":"Xã Tân Sơn","type":"xa","slug":"xa-tan-son","name_with_type":"Xã Tân Sơn","path":"Xã Tân Sơn, Huyện Quỳnh Lưu, Tỉnh Nghệ An","path_with_type":"Xã Tân Sơn, Huyện Quỳnh Lưu, Tỉnh Nghệ An","code":"17140","parent_code":"421"},"17143":{"name":"Xã Quỳnh Văn","type":"xa","slug":"xa-quynh-van","name_with_type":"Xã Quỳnh Văn","path":"Xã Quỳnh Văn, Huyện Quỳnh Lưu, Tỉnh Nghệ An","path_with_type":"Xã Quỳnh Văn, Huyện Quỳnh Lưu, Tỉnh Nghệ An","code":"17143","parent_code":"421"},"17146":{"name":"Xã Ngọc Sơn","type":"xa","slug":"xa-ngoc-son","name_with_type":"Xã Ngọc Sơn","path":"Xã Ngọc Sơn, Huyện Quỳnh Lưu, Tỉnh Nghệ An","path_with_type":"Xã Ngọc Sơn, Huyện Quỳnh Lưu, Tỉnh Nghệ An","code":"17146","parent_code":"421"},"17149":{"name":"Xã Quỳnh Tam","type":"xa","slug":"xa-quynh-tam","name_with_type":"Xã Quỳnh Tam","path":"Xã Quỳnh Tam, Huyện Quỳnh Lưu, Tỉnh Nghệ An","path_with_type":"Xã Quỳnh Tam, Huyện Quỳnh Lưu, Tỉnh Nghệ An","code":"17149","parent_code":"421"},"17152":{"name":"Xã Quỳnh Sơn","type":"xa","slug":"xa-quynh-son","name_with_type":"Xã Quỳnh Sơn","path":"Xã Quỳnh Sơn, Huyện Quỳnh Lưu, Tỉnh Nghệ An","path_with_type":"Xã Quỳnh Sơn, Huyện Quỳnh Lưu, Tỉnh Nghệ An","code":"17152","parent_code":"421"},"17155":{"name":"Xã Quỳnh Thạch","type":"xa","slug":"xa-quynh-thach","name_with_type":"Xã Quỳnh Thạch","path":"Xã Quỳnh Thạch, Huyện Quỳnh Lưu, Tỉnh Nghệ An","path_with_type":"Xã Quỳnh Thạch, Huyện Quỳnh Lưu, Tỉnh Nghệ An","code":"17155","parent_code":"421"},"17158":{"name":"Xã Quỳnh Bảng","type":"xa","slug":"xa-quynh-bang","name_with_type":"Xã Quỳnh Bảng","path":"Xã Quỳnh Bảng, Huyện Quỳnh Lưu, Tỉnh Nghệ An","path_with_type":"Xã Quỳnh Bảng, Huyện Quỳnh Lưu, Tỉnh Nghệ An","code":"17158","parent_code":"421"},"17164":{"name":"Xã Quỳnh Thanh","type":"xa","slug":"xa-quynh-thanh","name_with_type":"Xã Quỳnh Thanh","path":"Xã Quỳnh Thanh, Huyện Quỳnh Lưu, Tỉnh Nghệ An","path_with_type":"Xã Quỳnh Thanh, Huyện Quỳnh Lưu, Tỉnh Nghệ An","code":"17164","parent_code":"421"},"17167":{"name":"Xã Quỳnh Hậu","type":"xa","slug":"xa-quynh-hau","name_with_type":"Xã Quỳnh Hậu","path":"Xã Quỳnh Hậu, Huyện Quỳnh Lưu, Tỉnh Nghệ An","path_with_type":"Xã Quỳnh Hậu, Huyện Quỳnh Lưu, Tỉnh Nghệ An","code":"17167","parent_code":"421"},"17170":{"name":"Xã Quỳnh Lâm","type":"xa","slug":"xa-quynh-lam","name_with_type":"Xã Quỳnh Lâm","path":"Xã Quỳnh Lâm, Huyện Quỳnh Lưu, Tỉnh Nghệ An","path_with_type":"Xã Quỳnh Lâm, Huyện Quỳnh Lưu, Tỉnh Nghệ An","code":"17170","parent_code":"421"},"17173":{"name":"Xã Quỳnh Đôi","type":"xa","slug":"xa-quynh-doi","name_with_type":"Xã Quỳnh Đôi","path":"Xã Quỳnh Đôi, Huyện Quỳnh Lưu, Tỉnh Nghệ An","path_with_type":"Xã Quỳnh Đôi, Huyện Quỳnh Lưu, Tỉnh Nghệ An","code":"17173","parent_code":"421"},"17176":{"name":"Xã Minh Lương","type":"xa","slug":"xa-minh-luong","name_with_type":"Xã Minh Lương","path":"Xã Minh Lương, Huyện Quỳnh Lưu, Tỉnh Nghệ An","path_with_type":"Xã Minh Lương, Huyện Quỳnh Lưu, Tỉnh Nghệ An","code":"17176","parent_code":"421"},"17179":{"name":"Thị trấn Cầu Giát","type":"thi-tran","slug":"thi-tran-cau-giat","name_with_type":"Thị trấn Cầu Giát","path":"Thị trấn Cầu Giát, Huyện Quỳnh Lưu, Tỉnh Nghệ An","path_with_type":"Thị trấn Cầu Giát, Huyện Quỳnh Lưu, Tỉnh Nghệ An","code":"17179","parent_code":"421"},"17182":{"name":"Xã Quỳnh Yên","type":"xa","slug":"xa-quynh-yen","name_with_type":"Xã Quỳnh Yên","path":"Xã Quỳnh Yên, Huyện Quỳnh Lưu, Tỉnh Nghệ An","path_with_type":"Xã Quỳnh Yên, Huyện Quỳnh Lưu, Tỉnh Nghệ An","code":"17182","parent_code":"421"},"17185":{"name":"Xã Bình Sơn","type":"xa","slug":"xa-binh-son","name_with_type":"Xã Bình Sơn","path":"Xã Bình Sơn, Huyện Quỳnh Lưu, Tỉnh Nghệ An","path_with_type":"Xã Bình Sơn, Huyện Quỳnh Lưu, Tỉnh Nghệ An","code":"17185","parent_code":"421"},"17191":{"name":"Xã Quỳnh Diễn","type":"xa","slug":"xa-quynh-dien","name_with_type":"Xã Quỳnh Diễn","path":"Xã Quỳnh Diễn, Huyện Quỳnh Lưu, Tỉnh Nghệ An","path_with_type":"Xã Quỳnh Diễn, Huyện Quỳnh Lưu, Tỉnh Nghệ An","code":"17191","parent_code":"421"},"17197":{"name":"Xã Quỳnh Giang","type":"xa","slug":"xa-quynh-giang","name_with_type":"Xã Quỳnh Giang","path":"Xã Quỳnh Giang, Huyện Quỳnh Lưu, Tỉnh Nghệ An","path_with_type":"Xã Quỳnh Giang, Huyện Quỳnh Lưu, Tỉnh Nghệ An","code":"17197","parent_code":"421"},"17206":{"name":"Xã An Hòa","type":"xa","slug":"xa-an-hoa","name_with_type":"Xã An Hòa","path":"Xã An Hòa, Huyện Quỳnh Lưu, Tỉnh Nghệ An","path_with_type":"Xã An Hòa, Huyện Quỳnh Lưu, Tỉnh Nghệ An","code":"17206","parent_code":"421"},"17209":{"name":"Xã Phú Nghĩa","type":"xa","slug":"xa-phu-nghia","name_with_type":"Xã Phú Nghĩa","path":"Xã Phú Nghĩa, Huyện Quỳnh Lưu, Tỉnh Nghệ An","path_with_type":"Xã Phú Nghĩa, Huyện Quỳnh Lưu, Tỉnh Nghệ An","code":"17209","parent_code":"421"},"17212":{"name":"Xã Văn Hải","type":"xa","slug":"xa-van-hai","name_with_type":"Xã Văn Hải","path":"Xã Văn Hải, Huyện Quỳnh Lưu, Tỉnh Nghệ An","path_with_type":"Xã Văn Hải, Huyện Quỳnh Lưu, Tỉnh Nghệ An","code":"17212","parent_code":"421"},"17218":{"name":"Xã Thuận Long","type":"xa","slug":"xa-thuan-long","name_with_type":"Xã Thuận Long","path":"Xã Thuận Long, Huyện Quỳnh Lưu, Tỉnh Nghệ An","path_with_type":"Xã Thuận Long, Huyện Quỳnh Lưu, Tỉnh Nghệ An","code":"17218","parent_code":"421"},"17224":{"name":"Xã Tân Thắng","type":"xa","slug":"xa-tan-thang","name_with_type":"Xã Tân Thắng","path":"Xã Tân Thắng, Huyện Quỳnh Lưu, Tỉnh Nghệ An","path_with_type":"Xã Tân Thắng, Huyện Quỳnh Lưu, Tỉnh Nghệ An","code":"17224","parent_code":"421"},"17230":{"name":"Xã Bình Chuẩn","type":"xa","slug":"xa-binh-chuan","name_with_type":"Xã Bình Chuẩn","path":"Xã Bình Chuẩn, Huyện Con Cuông, Tỉnh Nghệ An","path_with_type":"Xã Bình Chuẩn, Huyện Con Cuông, Tỉnh Nghệ An","code":"17230","parent_code":"422"},"17233":{"name":"Xã Lạng Khê","type":"xa","slug":"xa-lang-khe","name_with_type":"Xã Lạng Khê","path":"Xã Lạng Khê, Huyện Con Cuông, Tỉnh Nghệ An","path_with_type":"Xã Lạng Khê, Huyện Con Cuông, Tỉnh Nghệ An","code":"17233","parent_code":"422"},"17236":{"name":"Xã Cam Lâm","type":"xa","slug":"xa-cam-lam","name_with_type":"Xã Cam Lâm","path":"Xã Cam Lâm, Huyện Con Cuông, Tỉnh Nghệ An","path_with_type":"Xã Cam Lâm, Huyện Con Cuông, Tỉnh Nghệ An","code":"17236","parent_code":"422"},"17239":{"name":"Xã Thạch Ngàn","type":"xa","slug":"xa-thach-ngan","name_with_type":"Xã Thạch Ngàn","path":"Xã Thạch Ngàn, Huyện Con Cuông, Tỉnh Nghệ An","path_with_type":"Xã Thạch Ngàn, Huyện Con Cuông, Tỉnh Nghệ An","code":"17239","parent_code":"422"},"17242":{"name":"Xã Đôn Phục","type":"xa","slug":"xa-don-phuc","name_with_type":"Xã Đôn Phục","path":"Xã Đôn Phục, Huyện Con Cuông, Tỉnh Nghệ An","path_with_type":"Xã Đôn Phục, Huyện Con Cuông, Tỉnh Nghệ An","code":"17242","parent_code":"422"},"17245":{"name":"Xã Mậu Đức","type":"xa","slug":"xa-mau-duc","name_with_type":"Xã Mậu Đức","path":"Xã Mậu Đức, Huyện Con Cuông, Tỉnh Nghệ An","path_with_type":"Xã Mậu Đức, Huyện Con Cuông, Tỉnh Nghệ An","code":"17245","parent_code":"422"},"17248":{"name":"Xã Châu Khê","type":"xa","slug":"xa-chau-khe","name_with_type":"Xã Châu Khê","path":"Xã Châu Khê, Huyện Con Cuông, Tỉnh Nghệ An","path_with_type":"Xã Châu Khê, Huyện Con Cuông, Tỉnh Nghệ An","code":"17248","parent_code":"422"},"17251":{"name":"Xã Chi Khê","type":"xa","slug":"xa-chi-khe","name_with_type":"Xã Chi Khê","path":"Xã Chi Khê, Huyện Con Cuông, Tỉnh Nghệ An","path_with_type":"Xã Chi Khê, Huyện Con Cuông, Tỉnh Nghệ An","code":"17251","parent_code":"422"},"17254":{"name":"Thị trấn Trà Lân","type":"thi-tran","slug":"thi-tran-tra-lan","name_with_type":"Thị trấn Trà Lân","path":"Thị trấn Trà Lân, Huyện Con Cuông, Tỉnh Nghệ An","path_with_type":"Thị trấn Trà Lân, Huyện Con Cuông, Tỉnh Nghệ An","code":"17254","parent_code":"422"},"17257":{"name":"Xã Yên Khê","type":"xa","slug":"xa-yen-khe","name_with_type":"Xã Yên Khê","path":"Xã Yên Khê, Huyện Con Cuông, Tỉnh Nghệ An","path_with_type":"Xã Yên Khê, Huyện Con Cuông, Tỉnh Nghệ An","code":"17257","parent_code":"422"},"17260":{"name":"Xã Lục Dạ","type":"xa","slug":"xa-luc-da","name_with_type":"Xã Lục Dạ","path":"Xã Lục Dạ, Huyện Con Cuông, Tỉnh Nghệ An","path_with_type":"Xã Lục Dạ, Huyện Con Cuông, Tỉnh Nghệ An","code":"17260","parent_code":"422"},"17263":{"name":"Xã Môn Sơn","type":"xa","slug":"xa-mon-son","name_with_type":"Xã Môn Sơn","path":"Xã Môn Sơn, Huyện Con Cuông, Tỉnh Nghệ An","path_with_type":"Xã Môn Sơn, Huyện Con Cuông, Tỉnh Nghệ An","code":"17263","parent_code":"422"},"17266":{"name":"Thị trấn Tân Kỳ","type":"thi-tran","slug":"thi-tran-tan-ky","name_with_type":"Thị trấn Tân Kỳ","path":"Thị trấn Tân Kỳ, Huyện Tân Kỳ, Tỉnh Nghệ An","path_with_type":"Thị trấn Tân Kỳ, Huyện Tân Kỳ, Tỉnh Nghệ An","code":"17266","parent_code":"423"},"17269":{"name":"Xã Tân Hợp","type":"xa","slug":"xa-tan-hop","name_with_type":"Xã Tân Hợp","path":"Xã Tân Hợp, Huyện Tân Kỳ, Tỉnh Nghệ An","path_with_type":"Xã Tân Hợp, Huyện Tân Kỳ, Tỉnh Nghệ An","code":"17269","parent_code":"423"},"17272":{"name":"Xã Tân Phú","type":"xa","slug":"xa-tan-phu","name_with_type":"Xã Tân Phú","path":"Xã Tân Phú, Huyện Tân Kỳ, Tỉnh Nghệ An","path_with_type":"Xã Tân Phú, Huyện Tân Kỳ, Tỉnh Nghệ An","code":"17272","parent_code":"423"},"17275":{"name":"Xã Tân Xuân","type":"xa","slug":"xa-tan-xuan","name_with_type":"Xã Tân Xuân","path":"Xã Tân Xuân, Huyện Tân Kỳ, Tỉnh Nghệ An","path_with_type":"Xã Tân Xuân, Huyện Tân Kỳ, Tỉnh Nghệ An","code":"17275","parent_code":"423"},"17278":{"name":"Xã Giai Xuân","type":"xa","slug":"xa-giai-xuan","name_with_type":"Xã Giai Xuân","path":"Xã Giai Xuân, Huyện Tân Kỳ, Tỉnh Nghệ An","path_with_type":"Xã Giai Xuân, Huyện Tân Kỳ, Tỉnh Nghệ An","code":"17278","parent_code":"423"},"17281":{"name":"Xã Bình Hợp","type":"xa","slug":"xa-binh-hop","name_with_type":"Xã Bình Hợp","path":"Xã Bình Hợp, Huyện Tân Kỳ, Tỉnh Nghệ An","path_with_type":"Xã Bình Hợp, Huyện Tân Kỳ, Tỉnh Nghệ An","code":"17281","parent_code":"423"},"17284":{"name":"Xã Nghĩa Đồng","type":"xa","slug":"xa-nghia-dong","name_with_type":"Xã Nghĩa Đồng","path":"Xã Nghĩa Đồng, Huyện Tân Kỳ, Tỉnh Nghệ An","path_with_type":"Xã Nghĩa Đồng, Huyện Tân Kỳ, Tỉnh Nghệ An","code":"17284","parent_code":"423"},"17287":{"name":"Xã Đồng Văn","type":"xa","slug":"xa-dong-van","name_with_type":"Xã Đồng Văn","path":"Xã Đồng Văn, Huyện Tân Kỳ, Tỉnh Nghệ An","path_with_type":"Xã Đồng Văn, Huyện Tân Kỳ, Tỉnh Nghệ An","code":"17287","parent_code":"423"},"17290":{"name":"Xã Nghĩa Thái","type":"xa","slug":"xa-nghia-thai","name_with_type":"Xã Nghĩa Thái","path":"Xã Nghĩa Thái, Huyện Tân Kỳ, Tỉnh Nghệ An","path_with_type":"Xã Nghĩa Thái, Huyện Tân Kỳ, Tỉnh Nghệ An","code":"17290","parent_code":"423"},"17296":{"name":"Xã Hoàn Long","type":"xa","slug":"xa-hoan-long","name_with_type":"Xã Hoàn Long","path":"Xã Hoàn Long, Huyện Tân Kỳ, Tỉnh Nghệ An","path_with_type":"Xã Hoàn Long, Huyện Tân Kỳ, Tỉnh Nghệ An","code":"17296","parent_code":"423"},"17299":{"name":"Xã Nghĩa Phúc","type":"xa","slug":"xa-nghia-phuc","name_with_type":"Xã Nghĩa Phúc","path":"Xã Nghĩa Phúc, Huyện Tân Kỳ, Tỉnh Nghệ An","path_with_type":"Xã Nghĩa Phúc, Huyện Tân Kỳ, Tỉnh Nghệ An","code":"17299","parent_code":"423"},"17302":{"name":"Xã Tiên Kỳ","type":"xa","slug":"xa-tien-ky","name_with_type":"Xã Tiên Kỳ","path":"Xã Tiên Kỳ, Huyện Tân Kỳ, Tỉnh Nghệ An","path_with_type":"Xã Tiên Kỳ, Huyện Tân Kỳ, Tỉnh Nghệ An","code":"17302","parent_code":"423"},"17305":{"name":"Xã Tân An","type":"xa","slug":"xa-tan-an","name_with_type":"Xã Tân An","path":"Xã Tân An, Huyện Tân Kỳ, Tỉnh Nghệ An","path_with_type":"Xã Tân An, Huyện Tân Kỳ, Tỉnh Nghệ An","code":"17305","parent_code":"423"},"17308":{"name":"Xã Nghĩa Dũng","type":"xa","slug":"xa-nghia-dung","name_with_type":"Xã Nghĩa Dũng","path":"Xã Nghĩa Dũng, Huyện Tân Kỳ, Tỉnh Nghệ An","path_with_type":"Xã Nghĩa Dũng, Huyện Tân Kỳ, Tỉnh Nghệ An","code":"17308","parent_code":"423"},"17314":{"name":"Xã Kỳ Sơn","type":"xa","slug":"xa-ky-son","name_with_type":"Xã Kỳ Sơn","path":"Xã Kỳ Sơn, Huyện Tân Kỳ, Tỉnh Nghệ An","path_with_type":"Xã Kỳ Sơn, Huyện Tân Kỳ, Tỉnh Nghệ An","code":"17314","parent_code":"423"},"17317":{"name":"Xã Hương Sơn","type":"xa","slug":"xa-huong-son","name_with_type":"Xã Hương Sơn","path":"Xã Hương Sơn, Huyện Tân Kỳ, Tỉnh Nghệ An","path_with_type":"Xã Hương Sơn, Huyện Tân Kỳ, Tỉnh Nghệ An","code":"17317","parent_code":"423"},"17320":{"name":"Xã Kỳ Tân","type":"xa","slug":"xa-ky-tan","name_with_type":"Xã Kỳ Tân","path":"Xã Kỳ Tân, Huyện Tân Kỳ, Tỉnh Nghệ An","path_with_type":"Xã Kỳ Tân, Huyện Tân Kỳ, Tỉnh Nghệ An","code":"17320","parent_code":"423"},"17323":{"name":"Xã Phú Sơn","type":"xa","slug":"xa-phu-son","name_with_type":"Xã Phú Sơn","path":"Xã Phú Sơn, Huyện Tân Kỳ, Tỉnh Nghệ An","path_with_type":"Xã Phú Sơn, Huyện Tân Kỳ, Tỉnh Nghệ An","code":"17323","parent_code":"423"},"17325":{"name":"Xã Tân Hương","type":"xa","slug":"xa-tan-huong","name_with_type":"Xã Tân Hương","path":"Xã Tân Hương, Huyện Tân Kỳ, Tỉnh Nghệ An","path_with_type":"Xã Tân Hương, Huyện Tân Kỳ, Tỉnh Nghệ An","code":"17325","parent_code":"423"},"17326":{"name":"Xã Nghĩa Hành","type":"xa","slug":"xa-nghia-hanh","name_with_type":"Xã Nghĩa Hành","path":"Xã Nghĩa Hành, Huyện Tân Kỳ, Tỉnh Nghệ An","path_with_type":"Xã Nghĩa Hành, Huyện Tân Kỳ, Tỉnh Nghệ An","code":"17326","parent_code":"423"},"17329":{"name":"Thị trấn Kim Nhan","type":"thi-tran","slug":"thi-tran-kim-nhan","name_with_type":"Thị trấn Kim Nhan","path":"Thị trấn Kim Nhan, Huyện Anh Sơn, Tỉnh Nghệ An","path_with_type":"Thị trấn Kim Nhan, Huyện Anh Sơn, Tỉnh Nghệ An","code":"17329","parent_code":"424"},"17332":{"name":"Xã Thọ Sơn","type":"xa","slug":"xa-tho-son","name_with_type":"Xã Thọ Sơn","path":"Xã Thọ Sơn, Huyện Anh Sơn, Tỉnh Nghệ An","path_with_type":"Xã Thọ Sơn, Huyện Anh Sơn, Tỉnh Nghệ An","code":"17332","parent_code":"424"},"17335":{"name":"Xã Thành Sơn","type":"xa","slug":"xa-thanh-son","name_with_type":"Xã Thành Sơn","path":"Xã Thành Sơn, Huyện Anh Sơn, Tỉnh Nghệ An","path_with_type":"Xã Thành Sơn, Huyện Anh Sơn, Tỉnh Nghệ An","code":"17335","parent_code":"424"},"17338":{"name":"Xã Bình Sơn","type":"xa","slug":"xa-binh-son","name_with_type":"Xã Bình Sơn","path":"Xã Bình Sơn, Huyện Anh Sơn, Tỉnh Nghệ An","path_with_type":"Xã Bình Sơn, Huyện Anh Sơn, Tỉnh Nghệ An","code":"17338","parent_code":"424"},"17344":{"name":"Xã Tam Đỉnh","type":"xa","slug":"xa-tam-dinh","name_with_type":"Xã Tam Đỉnh","path":"Xã Tam Đỉnh, Huyện Anh Sơn, Tỉnh Nghệ An","path_with_type":"Xã Tam Đỉnh, Huyện Anh Sơn, Tỉnh Nghệ An","code":"17344","parent_code":"424"},"17347":{"name":"Xã Hùng Sơn","type":"xa","slug":"xa-hung-son","name_with_type":"Xã Hùng Sơn","path":"Xã Hùng Sơn, Huyện Anh Sơn, Tỉnh Nghệ An","path_with_type":"Xã Hùng Sơn, Huyện Anh Sơn, Tỉnh Nghệ An","code":"17347","parent_code":"424"},"17350":{"name":"Xã Cẩm Sơn","type":"xa","slug":"xa-cam-son","name_with_type":"Xã Cẩm Sơn","path":"Xã Cẩm Sơn, Huyện Anh Sơn, Tỉnh Nghệ An","path_with_type":"Xã Cẩm Sơn, Huyện Anh Sơn, Tỉnh Nghệ An","code":"17350","parent_code":"424"},"17353":{"name":"Xã Đức Sơn","type":"xa","slug":"xa-duc-son","name_with_type":"Xã Đức Sơn","path":"Xã Đức Sơn, Huyện Anh Sơn, Tỉnh Nghệ An","path_with_type":"Xã Đức Sơn, Huyện Anh Sơn, Tỉnh Nghệ An","code":"17353","parent_code":"424"},"17356":{"name":"Xã Tường Sơn","type":"xa","slug":"xa-tuong-son","name_with_type":"Xã Tường Sơn","path":"Xã Tường Sơn, Huyện Anh Sơn, Tỉnh Nghệ An","path_with_type":"Xã Tường Sơn, Huyện Anh Sơn, Tỉnh Nghệ An","code":"17356","parent_code":"424"},"17357":{"name":"Xã Hoa Sơn","type":"xa","slug":"xa-hoa-son","name_with_type":"Xã Hoa Sơn","path":"Xã Hoa Sơn, Huyện Anh Sơn, Tỉnh Nghệ An","path_with_type":"Xã Hoa Sơn, Huyện Anh Sơn, Tỉnh Nghệ An","code":"17357","parent_code":"424"},"17359":{"name":"Xã Tào Sơn","type":"xa","slug":"xa-tao-son","name_with_type":"Xã Tào Sơn","path":"Xã Tào Sơn, Huyện Anh Sơn, Tỉnh Nghệ An","path_with_type":"Xã Tào Sơn, Huyện Anh Sơn, Tỉnh Nghệ An","code":"17359","parent_code":"424"},"17362":{"name":"Xã Vĩnh Sơn","type":"xa","slug":"xa-vinh-son","name_with_type":"Xã Vĩnh Sơn","path":"Xã Vĩnh Sơn, Huyện Anh Sơn, Tỉnh Nghệ An","path_with_type":"Xã Vĩnh Sơn, Huyện Anh Sơn, Tỉnh Nghệ An","code":"17362","parent_code":"424"},"17365":{"name":"Xã Lạng Sơn","type":"xa","slug":"xa-lang-son","name_with_type":"Xã Lạng Sơn","path":"Xã Lạng Sơn, Huyện Anh Sơn, Tỉnh Nghệ An","path_with_type":"Xã Lạng Sơn, Huyện Anh Sơn, Tỉnh Nghệ An","code":"17365","parent_code":"424"},"17368":{"name":"Xã Hội Sơn","type":"xa","slug":"xa-hoi-son","name_with_type":"Xã Hội Sơn","path":"Xã Hội Sơn, Huyện Anh Sơn, Tỉnh Nghệ An","path_with_type":"Xã Hội Sơn, Huyện Anh Sơn, Tỉnh Nghệ An","code":"17368","parent_code":"424"},"17374":{"name":"Xã Phúc Sơn","type":"xa","slug":"xa-phuc-son","name_with_type":"Xã Phúc Sơn","path":"Xã Phúc Sơn, Huyện Anh Sơn, Tỉnh Nghệ An","path_with_type":"Xã Phúc Sơn, Huyện Anh Sơn, Tỉnh Nghệ An","code":"17374","parent_code":"424"},"17377":{"name":"Xã Long Sơn","type":"xa","slug":"xa-long-son","name_with_type":"Xã Long Sơn","path":"Xã Long Sơn, Huyện Anh Sơn, Tỉnh Nghệ An","path_with_type":"Xã Long Sơn, Huyện Anh Sơn, Tỉnh Nghệ An","code":"17377","parent_code":"424"},"17380":{"name":"Xã Khai Sơn","type":"xa","slug":"xa-khai-son","name_with_type":"Xã Khai Sơn","path":"Xã Khai Sơn, Huyện Anh Sơn, Tỉnh Nghệ An","path_with_type":"Xã Khai Sơn, Huyện Anh Sơn, Tỉnh Nghệ An","code":"17380","parent_code":"424"},"17383":{"name":"Xã Lĩnh Sơn","type":"xa","slug":"xa-linh-son","name_with_type":"Xã Lĩnh Sơn","path":"Xã Lĩnh Sơn, Huyện Anh Sơn, Tỉnh Nghệ An","path_with_type":"Xã Lĩnh Sơn, Huyện Anh Sơn, Tỉnh Nghệ An","code":"17383","parent_code":"424"},"17386":{"name":"Xã Cao Sơn","type":"xa","slug":"xa-cao-son","name_with_type":"Xã Cao Sơn","path":"Xã Cao Sơn, Huyện Anh Sơn, Tỉnh Nghệ An","path_with_type":"Xã Cao Sơn, Huyện Anh Sơn, Tỉnh Nghệ An","code":"17386","parent_code":"424"},"17392":{"name":"Xã Diễn Lâm","type":"xa","slug":"xa-dien-lam","name_with_type":"Xã Diễn Lâm","path":"Xã Diễn Lâm, Huyện Diễn Châu, Tỉnh Nghệ An","path_with_type":"Xã Diễn Lâm, Huyện Diễn Châu, Tỉnh Nghệ An","code":"17392","parent_code":"425"},"17395":{"name":"Xã Diễn Đoài","type":"xa","slug":"xa-dien-doai","name_with_type":"Xã Diễn Đoài","path":"Xã Diễn Đoài, Huyện Diễn Châu, Tỉnh Nghệ An","path_with_type":"Xã Diễn Đoài, Huyện Diễn Châu, Tỉnh Nghệ An","code":"17395","parent_code":"425"},"17398":{"name":"Xã Diễn Trường","type":"xa","slug":"xa-dien-truong","name_with_type":"Xã Diễn Trường","path":"Xã Diễn Trường, Huyện Diễn Châu, Tỉnh Nghệ An","path_with_type":"Xã Diễn Trường, Huyện Diễn Châu, Tỉnh Nghệ An","code":"17398","parent_code":"425"},"17401":{"name":"Xã Diễn Yên","type":"xa","slug":"xa-dien-yen","name_with_type":"Xã Diễn Yên","path":"Xã Diễn Yên, Huyện Diễn Châu, Tỉnh Nghệ An","path_with_type":"Xã Diễn Yên, Huyện Diễn Châu, Tỉnh Nghệ An","code":"17401","parent_code":"425"},"17404":{"name":"Xã Diễn Hoàng","type":"xa","slug":"xa-dien-hoang","name_with_type":"Xã Diễn Hoàng","path":"Xã Diễn Hoàng, Huyện Diễn Châu, Tỉnh Nghệ An","path_with_type":"Xã Diễn Hoàng, Huyện Diễn Châu, Tỉnh Nghệ An","code":"17404","parent_code":"425"},"17410":{"name":"Xã Diễn Mỹ","type":"xa","slug":"xa-dien-my","name_with_type":"Xã Diễn Mỹ","path":"Xã Diễn Mỹ, Huyện Diễn Châu, Tỉnh Nghệ An","path_with_type":"Xã Diễn Mỹ, Huyện Diễn Châu, Tỉnh Nghệ An","code":"17410","parent_code":"425"},"17413":{"name":"Xã Diễn Hồng","type":"xa","slug":"xa-dien-hong","name_with_type":"Xã Diễn Hồng","path":"Xã Diễn Hồng, Huyện Diễn Châu, Tỉnh Nghệ An","path_with_type":"Xã Diễn Hồng, Huyện Diễn Châu, Tỉnh Nghệ An","code":"17413","parent_code":"425"},"17416":{"name":"Xã Diễn Phong","type":"xa","slug":"xa-dien-phong","name_with_type":"Xã Diễn Phong","path":"Xã Diễn Phong, Huyện Diễn Châu, Tỉnh Nghệ An","path_with_type":"Xã Diễn Phong, Huyện Diễn Châu, Tỉnh Nghệ An","code":"17416","parent_code":"425"},"17419":{"name":"Xã Hùng Hải","type":"xa","slug":"xa-hung-hai","name_with_type":"Xã Hùng Hải","path":"Xã Hùng Hải, Huyện Diễn Châu, Tỉnh Nghệ An","path_with_type":"Xã Hùng Hải, Huyện Diễn Châu, Tỉnh Nghệ An","code":"17419","parent_code":"425"},"17425":{"name":"Xã Diễn Liên","type":"xa","slug":"xa-dien-lien","name_with_type":"Xã Diễn Liên","path":"Xã Diễn Liên, Huyện Diễn Châu, Tỉnh Nghệ An","path_with_type":"Xã Diễn Liên, Huyện Diễn Châu, Tỉnh Nghệ An","code":"17425","parent_code":"425"},"17428":{"name":"Xã Diễn Vạn","type":"xa","slug":"xa-dien-van","name_with_type":"Xã Diễn Vạn","path":"Xã Diễn Vạn, Huyện Diễn Châu, Tỉnh Nghệ An","path_with_type":"Xã Diễn Vạn, Huyện Diễn Châu, Tỉnh Nghệ An","code":"17428","parent_code":"425"},"17431":{"name":"Xã Diễn Kim","type":"xa","slug":"xa-dien-kim","name_with_type":"Xã Diễn Kim","path":"Xã Diễn Kim, Huyện Diễn Châu, Tỉnh Nghệ An","path_with_type":"Xã Diễn Kim, Huyện Diễn Châu, Tỉnh Nghệ An","code":"17431","parent_code":"425"},"17434":{"name":"Xã Diễn Kỷ","type":"xa","slug":"xa-dien-ky","name_with_type":"Xã Diễn Kỷ","path":"Xã Diễn Kỷ, Huyện Diễn Châu, Tỉnh Nghệ An","path_with_type":"Xã Diễn Kỷ, Huyện Diễn Châu, Tỉnh Nghệ An","code":"17434","parent_code":"425"},"17437":{"name":"Xã Xuân Tháp","type":"xa","slug":"xa-xuan-thap","name_with_type":"Xã Xuân Tháp","path":"Xã Xuân Tháp, Huyện Diễn Châu, Tỉnh Nghệ An","path_with_type":"Xã Xuân Tháp, Huyện Diễn Châu, Tỉnh Nghệ An","code":"17437","parent_code":"425"},"17440":{"name":"Xã Diễn Thái","type":"xa","slug":"xa-dien-thai","name_with_type":"Xã Diễn Thái","path":"Xã Diễn Thái, Huyện Diễn Châu, Tỉnh Nghệ An","path_with_type":"Xã Diễn Thái, Huyện Diễn Châu, Tỉnh Nghệ An","code":"17440","parent_code":"425"},"17443":{"name":"Xã Diễn Đồng","type":"xa","slug":"xa-dien-dong","name_with_type":"Xã Diễn Đồng","path":"Xã Diễn Đồng, Huyện Diễn Châu, Tỉnh Nghệ An","path_with_type":"Xã Diễn Đồng, Huyện Diễn Châu, Tỉnh Nghệ An","code":"17443","parent_code":"425"},"17449":{"name":"Xã Hạnh Quảng","type":"xa","slug":"xa-hanh-quang","name_with_type":"Xã Hạnh Quảng","path":"Xã Hạnh Quảng, Huyện Diễn Châu, Tỉnh Nghệ An","path_with_type":"Xã Hạnh Quảng, Huyện Diễn Châu, Tỉnh Nghệ An","code":"17449","parent_code":"425"},"17452":{"name":"Xã Ngọc Bích","type":"xa","slug":"xa-ngoc-bich","name_with_type":"Xã Ngọc Bích","path":"Xã Ngọc Bích, Huyện Diễn Châu, Tỉnh Nghệ An","path_with_type":"Xã Ngọc Bích, Huyện Diễn Châu, Tỉnh Nghệ An","code":"17452","parent_code":"425"},"17458":{"name":"Xã Diễn Nguyên","type":"xa","slug":"xa-dien-nguyen","name_with_type":"Xã Diễn Nguyên","path":"Xã Diễn Nguyên, Huyện Diễn Châu, Tỉnh Nghệ An","path_with_type":"Xã Diễn Nguyên, Huyện Diễn Châu, Tỉnh Nghệ An","code":"17458","parent_code":"425"},"17461":{"name":"Xã Diễn Hoa","type":"xa","slug":"xa-dien-hoa","name_with_type":"Xã Diễn Hoa","path":"Xã Diễn Hoa, Huyện Diễn Châu, Tỉnh Nghệ An","path_with_type":"Xã Diễn Hoa, Huyện Diễn Châu, Tỉnh Nghệ An","code":"17461","parent_code":"425"},"17464":{"name":"Thị trấn Diễn Thành","type":"thi-tran","slug":"thi-tran-dien-thanh","name_with_type":"Thị trấn Diễn Thành","path":"Thị trấn Diễn Thành, Huyện Diễn Châu, Tỉnh Nghệ An","path_with_type":"Thị trấn Diễn Thành, Huyện Diễn Châu, Tỉnh Nghệ An","code":"17464","parent_code":"425"},"17467":{"name":"Xã Diễn Phúc","type":"xa","slug":"xa-dien-phuc","name_with_type":"Xã Diễn Phúc","path":"Xã Diễn Phúc, Huyện Diễn Châu, Tỉnh Nghệ An","path_with_type":"Xã Diễn Phúc, Huyện Diễn Châu, Tỉnh Nghệ An","code":"17467","parent_code":"425"},"17476":{"name":"Xã Diễn Cát","type":"xa","slug":"xa-dien-cat","name_with_type":"Xã Diễn Cát","path":"Xã Diễn Cát, Huyện Diễn Châu, Tỉnh Nghệ An","path_with_type":"Xã Diễn Cát, Huyện Diễn Châu, Tỉnh Nghệ An","code":"17476","parent_code":"425"},"17479":{"name":"Xã Diễn Thịnh","type":"xa","slug":"xa-dien-thinh","name_with_type":"Xã Diễn Thịnh","path":"Xã Diễn Thịnh, Huyện Diễn Châu, Tỉnh Nghệ An","path_with_type":"Xã Diễn Thịnh, Huyện Diễn Châu, Tỉnh Nghệ An","code":"17479","parent_code":"425"},"17482":{"name":"Xã Diễn Tân","type":"xa","slug":"xa-dien-tan","name_with_type":"Xã Diễn Tân","path":"Xã Diễn Tân, Huyện Diễn Châu, Tỉnh Nghệ An","path_with_type":"Xã Diễn Tân, Huyện Diễn Châu, Tỉnh Nghệ An","code":"17482","parent_code":"425"},"17485":{"name":"Xã Minh Châu","type":"xa","slug":"xa-minh-chau","name_with_type":"Xã Minh Châu","path":"Xã Minh Châu, Huyện Diễn Châu, Tỉnh Nghệ An","path_with_type":"Xã Minh Châu, Huyện Diễn Châu, Tỉnh Nghệ An","code":"17485","parent_code":"425"},"17488":{"name":"Xã Diễn Thọ","type":"xa","slug":"xa-dien-tho","name_with_type":"Xã Diễn Thọ","path":"Xã Diễn Thọ, Huyện Diễn Châu, Tỉnh Nghệ An","path_with_type":"Xã Diễn Thọ, Huyện Diễn Châu, Tỉnh Nghệ An","code":"17488","parent_code":"425"},"17491":{"name":"Xã Diễn Lợi","type":"xa","slug":"xa-dien-loi","name_with_type":"Xã Diễn Lợi","path":"Xã Diễn Lợi, Huyện Diễn Châu, Tỉnh Nghệ An","path_with_type":"Xã Diễn Lợi, Huyện Diễn Châu, Tỉnh Nghệ An","code":"17491","parent_code":"425"},"17494":{"name":"Xã Diễn Lộc","type":"xa","slug":"xa-dien-loc","name_with_type":"Xã Diễn Lộc","path":"Xã Diễn Lộc, Huyện Diễn Châu, Tỉnh Nghệ An","path_with_type":"Xã Diễn Lộc, Huyện Diễn Châu, Tỉnh Nghệ An","code":"17494","parent_code":"425"},"17497":{"name":"Xã Diễn Trung","type":"xa","slug":"xa-dien-trung","name_with_type":"Xã Diễn Trung","path":"Xã Diễn Trung, Huyện Diễn Châu, Tỉnh Nghệ An","path_with_type":"Xã Diễn Trung, Huyện Diễn Châu, Tỉnh Nghệ An","code":"17497","parent_code":"425"},"17500":{"name":"Xã Diễn An","type":"xa","slug":"xa-dien-an","name_with_type":"Xã Diễn An","path":"Xã Diễn An, Huyện Diễn Châu, Tỉnh Nghệ An","path_with_type":"Xã Diễn An, Huyện Diễn Châu, Tỉnh Nghệ An","code":"17500","parent_code":"425"},"17503":{"name":"Xã Diễn Phú","type":"xa","slug":"xa-dien-phu","name_with_type":"Xã Diễn Phú","path":"Xã Diễn Phú, Huyện Diễn Châu, Tỉnh Nghệ An","path_with_type":"Xã Diễn Phú, Huyện Diễn Châu, Tỉnh Nghệ An","code":"17503","parent_code":"425"},"17506":{"name":"Thị trấn Hoa Thành","type":"thi-tran","slug":"thi-tran-hoa-thanh","name_with_type":"Thị trấn Hoa Thành","path":"Thị trấn Hoa Thành, Huyện Yên Thành, Tỉnh Nghệ An","path_with_type":"Thị trấn Hoa Thành, Huyện Yên Thành, Tỉnh Nghệ An","code":"17506","parent_code":"426"},"17509":{"name":"Xã Mã Thành","type":"xa","slug":"xa-ma-thanh","name_with_type":"Xã Mã Thành","path":"Xã Mã Thành, Huyện Yên Thành, Tỉnh Nghệ An","path_with_type":"Xã Mã Thành, Huyện Yên Thành, Tỉnh Nghệ An","code":"17509","parent_code":"426"},"17510":{"name":"Xã Tiến Thành","type":"xa","slug":"xa-tien-thanh","name_with_type":"Xã Tiến Thành","path":"Xã Tiến Thành, Huyện Yên Thành, Tỉnh Nghệ An","path_with_type":"Xã Tiến Thành, Huyện Yên Thành, Tỉnh Nghệ An","code":"17510","parent_code":"426"},"17512":{"name":"Xã Lăng Thành","type":"xa","slug":"xa-lang-thanh","name_with_type":"Xã Lăng Thành","path":"Xã Lăng Thành, Huyện Yên Thành, Tỉnh Nghệ An","path_with_type":"Xã Lăng Thành, Huyện Yên Thành, Tỉnh Nghệ An","code":"17512","parent_code":"426"},"17515":{"name":"Xã Tân Thành","type":"xa","slug":"xa-tan-thanh","name_with_type":"Xã Tân Thành","path":"Xã Tân Thành, Huyện Yên Thành, Tỉnh Nghệ An","path_with_type":"Xã Tân Thành, Huyện Yên Thành, Tỉnh Nghệ An","code":"17515","parent_code":"426"},"17518":{"name":"Xã Đức Thành","type":"xa","slug":"xa-duc-thanh","name_with_type":"Xã Đức Thành","path":"Xã Đức Thành, Huyện Yên Thành, Tỉnh Nghệ An","path_with_type":"Xã Đức Thành, Huyện Yên Thành, Tỉnh Nghệ An","code":"17518","parent_code":"426"},"17521":{"name":"Xã Kim Thành","type":"xa","slug":"xa-kim-thanh","name_with_type":"Xã Kim Thành","path":"Xã Kim Thành, Huyện Yên Thành, Tỉnh Nghệ An","path_with_type":"Xã Kim Thành, Huyện Yên Thành, Tỉnh Nghệ An","code":"17521","parent_code":"426"},"17524":{"name":"Xã Hậu Thành","type":"xa","slug":"xa-hau-thanh","name_with_type":"Xã Hậu Thành","path":"Xã Hậu Thành, Huyện Yên Thành, Tỉnh Nghệ An","path_with_type":"Xã Hậu Thành, Huyện Yên Thành, Tỉnh Nghệ An","code":"17524","parent_code":"426"},"17527":{"name":"Xã Đô Thành","type":"xa","slug":"xa-do-thanh","name_with_type":"Xã Đô Thành","path":"Xã Đô Thành, Huyện Yên Thành, Tỉnh Nghệ An","path_with_type":"Xã Đô Thành, Huyện Yên Thành, Tỉnh Nghệ An","code":"17527","parent_code":"426"},"17530":{"name":"Xã Thọ Thành","type":"xa","slug":"xa-tho-thanh","name_with_type":"Xã Thọ Thành","path":"Xã Thọ Thành, Huyện Yên Thành, Tỉnh Nghệ An","path_with_type":"Xã Thọ Thành, Huyện Yên Thành, Tỉnh Nghệ An","code":"17530","parent_code":"426"},"17533":{"name":"Xã Quang Thành","type":"xa","slug":"xa-quang-thanh","name_with_type":"Xã Quang Thành","path":"Xã Quang Thành, Huyện Yên Thành, Tỉnh Nghệ An","path_with_type":"Xã Quang Thành, Huyện Yên Thành, Tỉnh Nghệ An","code":"17533","parent_code":"426"},"17536":{"name":"Xã Tây Thành","type":"xa","slug":"xa-tay-thanh","name_with_type":"Xã Tây Thành","path":"Xã Tây Thành, Huyện Yên Thành, Tỉnh Nghệ An","path_with_type":"Xã Tây Thành, Huyện Yên Thành, Tỉnh Nghệ An","code":"17536","parent_code":"426"},"17539":{"name":"Xã Phúc Thành","type":"xa","slug":"xa-phuc-thanh","name_with_type":"Xã Phúc Thành","path":"Xã Phúc Thành, Huyện Yên Thành, Tỉnh Nghệ An","path_with_type":"Xã Phúc Thành, Huyện Yên Thành, Tỉnh Nghệ An","code":"17539","parent_code":"426"},"17542":{"name":"Xã Phú Thành","type":"xa","slug":"xa-phu-thanh","name_with_type":"Xã Phú Thành","path":"Xã Phú Thành, Huyện Yên Thành, Tỉnh Nghệ An","path_with_type":"Xã Phú Thành, Huyện Yên Thành, Tỉnh Nghệ An","code":"17542","parent_code":"426"},"17545":{"name":"Xã Đồng Thành","type":"xa","slug":"xa-dong-thanh","name_with_type":"Xã Đồng Thành","path":"Xã Đồng Thành, Huyện Yên Thành, Tỉnh Nghệ An","path_with_type":"Xã Đồng Thành, Huyện Yên Thành, Tỉnh Nghệ An","code":"17545","parent_code":"426"},"17554":{"name":"Xã Tăng Thành","type":"xa","slug":"xa-tang-thanh","name_with_type":"Xã Tăng Thành","path":"Xã Tăng Thành, Huyện Yên Thành, Tỉnh Nghệ An","path_with_type":"Xã Tăng Thành, Huyện Yên Thành, Tỉnh Nghệ An","code":"17554","parent_code":"426"},"17557":{"name":"Xã Văn Thành","type":"xa","slug":"xa-van-thanh","name_with_type":"Xã Văn Thành","path":"Xã Văn Thành, Huyện Yên Thành, Tỉnh Nghệ An","path_with_type":"Xã Văn Thành, Huyện Yên Thành, Tỉnh Nghệ An","code":"17557","parent_code":"426"},"17560":{"name":"Xã Thịnh Thành","type":"xa","slug":"xa-thinh-thanh","name_with_type":"Xã Thịnh Thành","path":"Xã Thịnh Thành, Huyện Yên Thành, Tỉnh Nghệ An","path_with_type":"Xã Thịnh Thành, Huyện Yên Thành, Tỉnh Nghệ An","code":"17560","parent_code":"426"},"17566":{"name":"Xã Xuân Thành","type":"xa","slug":"xa-xuan-thanh","name_with_type":"Xã Xuân Thành","path":"Xã Xuân Thành, Huyện Yên Thành, Tỉnh Nghệ An","path_with_type":"Xã Xuân Thành, Huyện Yên Thành, Tỉnh Nghệ An","code":"17566","parent_code":"426"},"17569":{"name":"Xã Bắc Thành","type":"xa","slug":"xa-bac-thanh","name_with_type":"Xã Bắc Thành","path":"Xã Bắc Thành, Huyện Yên Thành, Tỉnh Nghệ An","path_with_type":"Xã Bắc Thành, Huyện Yên Thành, Tỉnh Nghệ An","code":"17569","parent_code":"426"},"17572":{"name":"Xã Đông Thành","type":"xa","slug":"xa-dong-thanh","name_with_type":"Xã Đông Thành","path":"Xã Đông Thành, Huyện Yên Thành, Tỉnh Nghệ An","path_with_type":"Xã Đông Thành, Huyện Yên Thành, Tỉnh Nghệ An","code":"17572","parent_code":"426"},"17575":{"name":"Xã Trung Thành","type":"xa","slug":"xa-trung-thanh","name_with_type":"Xã Trung Thành","path":"Xã Trung Thành, Huyện Yên Thành, Tỉnh Nghệ An","path_with_type":"Xã Trung Thành, Huyện Yên Thành, Tỉnh Nghệ An","code":"17575","parent_code":"426"},"17578":{"name":"Xã Long Thành","type":"xa","slug":"xa-long-thanh","name_with_type":"Xã Long Thành","path":"Xã Long Thành, Huyện Yên Thành, Tỉnh Nghệ An","path_with_type":"Xã Long Thành, Huyện Yên Thành, Tỉnh Nghệ An","code":"17578","parent_code":"426"},"17581":{"name":"Xã Minh Thành","type":"xa","slug":"xa-minh-thanh","name_with_type":"Xã Minh Thành","path":"Xã Minh Thành, Huyện Yên Thành, Tỉnh Nghệ An","path_with_type":"Xã Minh Thành, Huyện Yên Thành, Tỉnh Nghệ An","code":"17581","parent_code":"426"},"17584":{"name":"Xã Nam Thành","type":"xa","slug":"xa-nam-thanh","name_with_type":"Xã Nam Thành","path":"Xã Nam Thành, Huyện Yên Thành, Tỉnh Nghệ An","path_with_type":"Xã Nam Thành, Huyện Yên Thành, Tỉnh Nghệ An","code":"17584","parent_code":"426"},"17587":{"name":"Xã Vĩnh Thành","type":"xa","slug":"xa-vinh-thanh","name_with_type":"Xã Vĩnh Thành","path":"Xã Vĩnh Thành, Huyện Yên Thành, Tỉnh Nghệ An","path_with_type":"Xã Vĩnh Thành, Huyện Yên Thành, Tỉnh Nghệ An","code":"17587","parent_code":"426"},"17596":{"name":"Xã Viên Thành","type":"xa","slug":"xa-vien-thanh","name_with_type":"Xã Viên Thành","path":"Xã Viên Thành, Huyện Yên Thành, Tỉnh Nghệ An","path_with_type":"Xã Viên Thành, Huyện Yên Thành, Tỉnh Nghệ An","code":"17596","parent_code":"426"},"17602":{"name":"Xã Liên Thành","type":"xa","slug":"xa-lien-thanh","name_with_type":"Xã Liên Thành","path":"Xã Liên Thành, Huyện Yên Thành, Tỉnh Nghệ An","path_with_type":"Xã Liên Thành, Huyện Yên Thành, Tỉnh Nghệ An","code":"17602","parent_code":"426"},"17605":{"name":"Xã Bảo Thành","type":"xa","slug":"xa-bao-thanh","name_with_type":"Xã Bảo Thành","path":"Xã Bảo Thành, Huyện Yên Thành, Tỉnh Nghệ An","path_with_type":"Xã Bảo Thành, Huyện Yên Thành, Tỉnh Nghệ An","code":"17605","parent_code":"426"},"17608":{"name":"Xã Mỹ Thành","type":"xa","slug":"xa-my-thanh","name_with_type":"Xã Mỹ Thành","path":"Xã Mỹ Thành, Huyện Yên Thành, Tỉnh Nghệ An","path_with_type":"Xã Mỹ Thành, Huyện Yên Thành, Tỉnh Nghệ An","code":"17608","parent_code":"426"},"17611":{"name":"Xã Vân Tụ","type":"xa","slug":"xa-van-tu","name_with_type":"Xã Vân Tụ","path":"Xã Vân Tụ, Huyện Yên Thành, Tỉnh Nghệ An","path_with_type":"Xã Vân Tụ, Huyện Yên Thành, Tỉnh Nghệ An","code":"17611","parent_code":"426"},"17614":{"name":"Xã Sơn Thành","type":"xa","slug":"xa-son-thanh","name_with_type":"Xã Sơn Thành","path":"Xã Sơn Thành, Huyện Yên Thành, Tỉnh Nghệ An","path_with_type":"Xã Sơn Thành, Huyện Yên Thành, Tỉnh Nghệ An","code":"17614","parent_code":"426"},"17617":{"name":"Thị trấn Đô Lương","type":"thi-tran","slug":"thi-tran-do-luong","name_with_type":"Thị trấn Đô Lương","path":"Thị trấn Đô Lương, Huyện Đô Lương, Tỉnh Nghệ An","path_with_type":"Thị trấn Đô Lương, Huyện Đô Lương, Tỉnh Nghệ An","code":"17617","parent_code":"427"},"17619":{"name":"Xã Giang Sơn Đông","type":"xa","slug":"xa-giang-son-dong","name_with_type":"Xã Giang Sơn Đông","path":"Xã Giang Sơn Đông, Huyện Đô Lương, Tỉnh Nghệ An","path_with_type":"Xã Giang Sơn Đông, Huyện Đô Lương, Tỉnh Nghệ An","code":"17619","parent_code":"427"},"17620":{"name":"Xã Giang Sơn Tây","type":"xa","slug":"xa-giang-son-tay","name_with_type":"Xã Giang Sơn Tây","path":"Xã Giang Sơn Tây, Huyện Đô Lương, Tỉnh Nghệ An","path_with_type":"Xã Giang Sơn Tây, Huyện Đô Lương, Tỉnh Nghệ An","code":"17620","parent_code":"427"},"17623":{"name":"Xã Bạch Ngọc","type":"xa","slug":"xa-bach-ngoc","name_with_type":"Xã Bạch Ngọc","path":"Xã Bạch Ngọc, Huyện Đô Lương, Tỉnh Nghệ An","path_with_type":"Xã Bạch Ngọc, Huyện Đô Lương, Tỉnh Nghệ An","code":"17623","parent_code":"427"},"17626":{"name":"Xã Bồi Sơn","type":"xa","slug":"xa-boi-son","name_with_type":"Xã Bồi Sơn","path":"Xã Bồi Sơn, Huyện Đô Lương, Tỉnh Nghệ An","path_with_type":"Xã Bồi Sơn, Huyện Đô Lương, Tỉnh Nghệ An","code":"17626","parent_code":"427"},"17629":{"name":"Xã Hồng Sơn","type":"xa","slug":"xa-hong-son","name_with_type":"Xã Hồng Sơn","path":"Xã Hồng Sơn, Huyện Đô Lương, Tỉnh Nghệ An","path_with_type":"Xã Hồng Sơn, Huyện Đô Lương, Tỉnh Nghệ An","code":"17629","parent_code":"427"},"17632":{"name":"Xã Bài Sơn","type":"xa","slug":"xa-bai-son","name_with_type":"Xã Bài Sơn","path":"Xã Bài Sơn, Huyện Đô Lương, Tỉnh Nghệ An","path_with_type":"Xã Bài Sơn, Huyện Đô Lương, Tỉnh Nghệ An","code":"17632","parent_code":"427"},"17638":{"name":"Xã Bắc Sơn","type":"xa","slug":"xa-bac-son","name_with_type":"Xã Bắc Sơn","path":"Xã Bắc Sơn, Huyện Đô Lương, Tỉnh Nghệ An","path_with_type":"Xã Bắc Sơn, Huyện Đô Lương, Tỉnh Nghệ An","code":"17638","parent_code":"427"},"17641":{"name":"Xã Tràng Sơn","type":"xa","slug":"xa-trang-son","name_with_type":"Xã Tràng Sơn","path":"Xã Tràng Sơn, Huyện Đô Lương, Tỉnh Nghệ An","path_with_type":"Xã Tràng Sơn, Huyện Đô Lương, Tỉnh Nghệ An","code":"17641","parent_code":"427"},"17644":{"name":"Xã Thượng Sơn","type":"xa","slug":"xa-thuong-son","name_with_type":"Xã Thượng Sơn","path":"Xã Thượng Sơn, Huyện Đô Lương, Tỉnh Nghệ An","path_with_type":"Xã Thượng Sơn, Huyện Đô Lương, Tỉnh Nghệ An","code":"17644","parent_code":"427"},"17647":{"name":"Xã Hòa Sơn","type":"xa","slug":"xa-hoa-son","name_with_type":"Xã Hòa Sơn","path":"Xã Hòa Sơn, Huyện Đô Lương, Tỉnh Nghệ An","path_with_type":"Xã Hòa Sơn, Huyện Đô Lương, Tỉnh Nghệ An","code":"17647","parent_code":"427"},"17650":{"name":"Xã Đặng Sơn","type":"xa","slug":"xa-dang-son","name_with_type":"Xã Đặng Sơn","path":"Xã Đặng Sơn, Huyện Đô Lương, Tỉnh Nghệ An","path_with_type":"Xã Đặng Sơn, Huyện Đô Lương, Tỉnh Nghệ An","code":"17650","parent_code":"427"},"17653":{"name":"Xã Đông Sơn","type":"xa","slug":"xa-dong-son","name_with_type":"Xã Đông Sơn","path":"Xã Đông Sơn, Huyện Đô Lương, Tỉnh Nghệ An","path_with_type":"Xã Đông Sơn, Huyện Đô Lương, Tỉnh Nghệ An","code":"17653","parent_code":"427"},"17656":{"name":"Xã Nam Sơn","type":"xa","slug":"xa-nam-son","name_with_type":"Xã Nam Sơn","path":"Xã Nam Sơn, Huyện Đô Lương, Tỉnh Nghệ An","path_with_type":"Xã Nam Sơn, Huyện Đô Lương, Tỉnh Nghệ An","code":"17656","parent_code":"427"},"17659":{"name":"Xã Lưu Sơn","type":"xa","slug":"xa-luu-son","name_with_type":"Xã Lưu Sơn","path":"Xã Lưu Sơn, Huyện Đô Lương, Tỉnh Nghệ An","path_with_type":"Xã Lưu Sơn, Huyện Đô Lương, Tỉnh Nghệ An","code":"17659","parent_code":"427"},"17662":{"name":"Xã Yên Sơn","type":"xa","slug":"xa-yen-son","name_with_type":"Xã Yên Sơn","path":"Xã Yên Sơn, Huyện Đô Lương, Tỉnh Nghệ An","path_with_type":"Xã Yên Sơn, Huyện Đô Lương, Tỉnh Nghệ An","code":"17662","parent_code":"427"},"17665":{"name":"Xã Văn Sơn","type":"xa","slug":"xa-van-son","name_with_type":"Xã Văn Sơn","path":"Xã Văn Sơn, Huyện Đô Lương, Tỉnh Nghệ An","path_with_type":"Xã Văn Sơn, Huyện Đô Lương, Tỉnh Nghệ An","code":"17665","parent_code":"427"},"17668":{"name":"Xã Đà Sơn","type":"xa","slug":"xa-da-son","name_with_type":"Xã Đà Sơn","path":"Xã Đà Sơn, Huyện Đô Lương, Tỉnh Nghệ An","path_with_type":"Xã Đà Sơn, Huyện Đô Lương, Tỉnh Nghệ An","code":"17668","parent_code":"427"},"17671":{"name":"Xã Lạc Sơn","type":"xa","slug":"xa-lac-son","name_with_type":"Xã Lạc Sơn","path":"Xã Lạc Sơn, Huyện Đô Lương, Tỉnh Nghệ An","path_with_type":"Xã Lạc Sơn, Huyện Đô Lương, Tỉnh Nghệ An","code":"17671","parent_code":"427"},"17674":{"name":"Xã Tân Sơn","type":"xa","slug":"xa-tan-son","name_with_type":"Xã Tân Sơn","path":"Xã Tân Sơn, Huyện Đô Lương, Tỉnh Nghệ An","path_with_type":"Xã Tân Sơn, Huyện Đô Lương, Tỉnh Nghệ An","code":"17674","parent_code":"427"},"17677":{"name":"Xã Thái Sơn","type":"xa","slug":"xa-thai-son","name_with_type":"Xã Thái Sơn","path":"Xã Thái Sơn, Huyện Đô Lương, Tỉnh Nghệ An","path_with_type":"Xã Thái Sơn, Huyện Đô Lương, Tỉnh Nghệ An","code":"17677","parent_code":"427"},"17680":{"name":"Xã Quang Sơn","type":"xa","slug":"xa-quang-son","name_with_type":"Xã Quang Sơn","path":"Xã Quang Sơn, Huyện Đô Lương, Tỉnh Nghệ An","path_with_type":"Xã Quang Sơn, Huyện Đô Lương, Tỉnh Nghệ An","code":"17680","parent_code":"427"},"17683":{"name":"Xã Thịnh Sơn","type":"xa","slug":"xa-thinh-son","name_with_type":"Xã Thịnh Sơn","path":"Xã Thịnh Sơn, Huyện Đô Lương, Tỉnh Nghệ An","path_with_type":"Xã Thịnh Sơn, Huyện Đô Lương, Tỉnh Nghệ An","code":"17683","parent_code":"427"},"17686":{"name":"Xã Trung Sơn","type":"xa","slug":"xa-trung-son","name_with_type":"Xã Trung Sơn","path":"Xã Trung Sơn, Huyện Đô Lương, Tỉnh Nghệ An","path_with_type":"Xã Trung Sơn, Huyện Đô Lương, Tỉnh Nghệ An","code":"17686","parent_code":"427"},"17689":{"name":"Xã Xuân Sơn","type":"xa","slug":"xa-xuan-son","name_with_type":"Xã Xuân Sơn","path":"Xã Xuân Sơn, Huyện Đô Lương, Tỉnh Nghệ An","path_with_type":"Xã Xuân Sơn, Huyện Đô Lương, Tỉnh Nghệ An","code":"17689","parent_code":"427"},"17692":{"name":"Xã Minh Sơn","type":"xa","slug":"xa-minh-son","name_with_type":"Xã Minh Sơn","path":"Xã Minh Sơn, Huyện Đô Lương, Tỉnh Nghệ An","path_with_type":"Xã Minh Sơn, Huyện Đô Lương, Tỉnh Nghệ An","code":"17692","parent_code":"427"},"17695":{"name":"Xã Thuận Sơn","type":"xa","slug":"xa-thuan-son","name_with_type":"Xã Thuận Sơn","path":"Xã Thuận Sơn, Huyện Đô Lương, Tỉnh Nghệ An","path_with_type":"Xã Thuận Sơn, Huyện Đô Lương, Tỉnh Nghệ An","code":"17695","parent_code":"427"},"17698":{"name":"Xã Nhân Sơn","type":"xa","slug":"xa-nhan-son","name_with_type":"Xã Nhân Sơn","path":"Xã Nhân Sơn, Huyện Đô Lương, Tỉnh Nghệ An","path_with_type":"Xã Nhân Sơn, Huyện Đô Lương, Tỉnh Nghệ An","code":"17698","parent_code":"427"},"17701":{"name":"Xã Hiến Sơn","type":"xa","slug":"xa-hien-son","name_with_type":"Xã Hiến Sơn","path":"Xã Hiến Sơn, Huyện Đô Lương, Tỉnh Nghệ An","path_with_type":"Xã Hiến Sơn, Huyện Đô Lương, Tỉnh Nghệ An","code":"17701","parent_code":"427"},"17704":{"name":"Xã Mỹ Sơn","type":"xa","slug":"xa-my-son","name_with_type":"Xã Mỹ Sơn","path":"Xã Mỹ Sơn, Huyện Đô Lương, Tỉnh Nghệ An","path_with_type":"Xã Mỹ Sơn, Huyện Đô Lương, Tỉnh Nghệ An","code":"17704","parent_code":"427"},"17707":{"name":"Xã Trù Sơn","type":"xa","slug":"xa-tru-son","name_with_type":"Xã Trù Sơn","path":"Xã Trù Sơn, Huyện Đô Lương, Tỉnh Nghệ An","path_with_type":"Xã Trù Sơn, Huyện Đô Lương, Tỉnh Nghệ An","code":"17707","parent_code":"427"},"17710":{"name":"Xã Đại Sơn","type":"xa","slug":"xa-dai-son","name_with_type":"Xã Đại Sơn","path":"Xã Đại Sơn, Huyện Đô Lương, Tỉnh Nghệ An","path_with_type":"Xã Đại Sơn, Huyện Đô Lương, Tỉnh Nghệ An","code":"17710","parent_code":"427"},"17713":{"name":"Thị trấn Dùng","type":"thi-tran","slug":"thi-tran-dung","name_with_type":"Thị trấn Dùng","path":"Thị trấn Dùng, Huyện Thanh Chương, Tỉnh Nghệ An","path_with_type":"Thị trấn Dùng, Huyện Thanh Chương, Tỉnh Nghệ An","code":"17713","parent_code":"428"},"17716":{"name":"Xã Cát Văn","type":"xa","slug":"xa-cat-van","name_with_type":"Xã Cát Văn","path":"Xã Cát Văn, Huyện Thanh Chương, Tỉnh Nghệ An","path_with_type":"Xã Cát Văn, Huyện Thanh Chương, Tỉnh Nghệ An","code":"17716","parent_code":"428"},"17719":{"name":"Xã Minh Sơn","type":"xa","slug":"xa-minh-son","name_with_type":"Xã Minh Sơn","path":"Xã Minh Sơn, Huyện Thanh Chương, Tỉnh Nghệ An","path_with_type":"Xã Minh Sơn, Huyện Thanh Chương, Tỉnh Nghệ An","code":"17719","parent_code":"428"},"17722":{"name":"Xã Hạnh Lâm","type":"xa","slug":"xa-hanh-lam","name_with_type":"Xã Hạnh Lâm","path":"Xã Hạnh Lâm, Huyện Thanh Chương, Tỉnh Nghệ An","path_with_type":"Xã Hạnh Lâm, Huyện Thanh Chương, Tỉnh Nghệ An","code":"17722","parent_code":"428"},"17723":{"name":"Xã Thanh Sơn","type":"xa","slug":"xa-thanh-son","name_with_type":"Xã Thanh Sơn","path":"Xã Thanh Sơn, Huyện Thanh Chương, Tỉnh Nghệ An","path_with_type":"Xã Thanh Sơn, Huyện Thanh Chương, Tỉnh Nghệ An","code":"17723","parent_code":"428"},"17728":{"name":"Xã Phong Thịnh","type":"xa","slug":"xa-phong-thinh","name_with_type":"Xã Phong Thịnh","path":"Xã Phong Thịnh, Huyện Thanh Chương, Tỉnh Nghệ An","path_with_type":"Xã Phong Thịnh, Huyện Thanh Chương, Tỉnh Nghệ An","code":"17728","parent_code":"428"},"17731":{"name":"Xã Thanh Phong","type":"xa","slug":"xa-thanh-phong","name_with_type":"Xã Thanh Phong","path":"Xã Thanh Phong, Huyện Thanh Chương, Tỉnh Nghệ An","path_with_type":"Xã Thanh Phong, Huyện Thanh Chương, Tỉnh Nghệ An","code":"17731","parent_code":"428"},"17734":{"name":"Xã Thanh Mỹ","type":"xa","slug":"xa-thanh-my","name_with_type":"Xã Thanh Mỹ","path":"Xã Thanh Mỹ, Huyện Thanh Chương, Tỉnh Nghệ An","path_with_type":"Xã Thanh Mỹ, Huyện Thanh Chương, Tỉnh Nghệ An","code":"17734","parent_code":"428"},"17737":{"name":"Xã Thanh Tiên","type":"xa","slug":"xa-thanh-tien","name_with_type":"Xã Thanh Tiên","path":"Xã Thanh Tiên, Huyện Thanh Chương, Tỉnh Nghệ An","path_with_type":"Xã Thanh Tiên, Huyện Thanh Chương, Tỉnh Nghệ An","code":"17737","parent_code":"428"},"17743":{"name":"Xã Thanh Liên","type":"xa","slug":"xa-thanh-lien","name_with_type":"Xã Thanh Liên","path":"Xã Thanh Liên, Huyện Thanh Chương, Tỉnh Nghệ An","path_with_type":"Xã Thanh Liên, Huyện Thanh Chương, Tỉnh Nghệ An","code":"17743","parent_code":"428"},"17749":{"name":"Xã Đại Đồng","type":"xa","slug":"xa-dai-dong","name_with_type":"Xã Đại Đồng","path":"Xã Đại Đồng, Huyện Thanh Chương, Tỉnh Nghệ An","path_with_type":"Xã Đại Đồng, Huyện Thanh Chương, Tỉnh Nghệ An","code":"17749","parent_code":"428"},"17755":{"name":"Xã Thanh Ngọc","type":"xa","slug":"xa-thanh-ngoc","name_with_type":"Xã Thanh Ngọc","path":"Xã Thanh Ngọc, Huyện Thanh Chương, Tỉnh Nghệ An","path_with_type":"Xã Thanh Ngọc, Huyện Thanh Chương, Tỉnh Nghệ An","code":"17755","parent_code":"428"},"17758":{"name":"Xã Thanh Hương","type":"xa","slug":"xa-thanh-huong","name_with_type":"Xã Thanh Hương","path":"Xã Thanh Hương, Huyện Thanh Chương, Tỉnh Nghệ An","path_with_type":"Xã Thanh Hương, Huyện Thanh Chương, Tỉnh Nghệ An","code":"17758","parent_code":"428"},"17759":{"name":"Xã Ngọc Lâm","type":"xa","slug":"xa-ngoc-lam","name_with_type":"Xã Ngọc Lâm","path":"Xã Ngọc Lâm, Huyện Thanh Chương, Tỉnh Nghệ An","path_with_type":"Xã Ngọc Lâm, Huyện Thanh Chương, Tỉnh Nghệ An","code":"17759","parent_code":"428"},"17764":{"name":"Xã Đồng Văn","type":"xa","slug":"xa-dong-van","name_with_type":"Xã Đồng Văn","path":"Xã Đồng Văn, Huyện Thanh Chương, Tỉnh Nghệ An","path_with_type":"Xã Đồng Văn, Huyện Thanh Chương, Tỉnh Nghệ An","code":"17764","parent_code":"428"},"17767":{"name":"Xã Ngọc Sơn","type":"xa","slug":"xa-ngoc-son","name_with_type":"Xã Ngọc Sơn","path":"Xã Ngọc Sơn, Huyện Thanh Chương, Tỉnh Nghệ An","path_with_type":"Xã Ngọc Sơn, Huyện Thanh Chương, Tỉnh Nghệ An","code":"17767","parent_code":"428"},"17770":{"name":"Xã Thanh Thịnh","type":"xa","slug":"xa-thanh-thinh","name_with_type":"Xã Thanh Thịnh","path":"Xã Thanh Thịnh, Huyện Thanh Chương, Tỉnh Nghệ An","path_with_type":"Xã Thanh Thịnh, Huyện Thanh Chương, Tỉnh Nghệ An","code":"17770","parent_code":"428"},"17773":{"name":"Xã Thanh An","type":"xa","slug":"xa-thanh-an","name_with_type":"Xã Thanh An","path":"Xã Thanh An, Huyện Thanh Chương, Tỉnh Nghệ An","path_with_type":"Xã Thanh An, Huyện Thanh Chương, Tỉnh Nghệ An","code":"17773","parent_code":"428"},"17776":{"name":"Xã Thanh Quả","type":"xa","slug":"xa-thanh-qua","name_with_type":"Xã Thanh Quả","path":"Xã Thanh Quả, Huyện Thanh Chương, Tỉnh Nghệ An","path_with_type":"Xã Thanh Quả, Huyện Thanh Chương, Tỉnh Nghệ An","code":"17776","parent_code":"428"},"17779":{"name":"Xã Xuân Dương","type":"xa","slug":"xa-xuan-duong","name_with_type":"Xã Xuân Dương","path":"Xã Xuân Dương, Huyện Thanh Chương, Tỉnh Nghệ An","path_with_type":"Xã Xuân Dương, Huyện Thanh Chương, Tỉnh Nghệ An","code":"17779","parent_code":"428"},"17785":{"name":"Xã Minh Tiến","type":"xa","slug":"xa-minh-tien","name_with_type":"Xã Minh Tiến","path":"Xã Minh Tiến, Huyện Thanh Chương, Tỉnh Nghệ An","path_with_type":"Xã Minh Tiến, Huyện Thanh Chương, Tỉnh Nghệ An","code":"17785","parent_code":"428"},"17791":{"name":"Xã Kim Bảng","type":"xa","slug":"xa-kim-bang","name_with_type":"Xã Kim Bảng","path":"Xã Kim Bảng, Huyện Thanh Chương, Tỉnh Nghệ An","path_with_type":"Xã Kim Bảng, Huyện Thanh Chương, Tỉnh Nghệ An","code":"17791","parent_code":"428"},"17797":{"name":"Xã Thanh Thủy","type":"xa","slug":"xa-thanh-thuy","name_with_type":"Xã Thanh Thủy","path":"Xã Thanh Thủy, Huyện Thanh Chương, Tỉnh Nghệ An","path_with_type":"Xã Thanh Thủy, Huyện Thanh Chương, Tỉnh Nghệ An","code":"17797","parent_code":"428"},"17806":{"name":"Xã Thanh Hà","type":"xa","slug":"xa-thanh-ha","name_with_type":"Xã Thanh Hà","path":"Xã Thanh Hà, Huyện Thanh Chương, Tỉnh Nghệ An","path_with_type":"Xã Thanh Hà, Huyện Thanh Chương, Tỉnh Nghệ An","code":"17806","parent_code":"428"},"17812":{"name":"Xã Thanh Tùng","type":"xa","slug":"xa-thanh-tung","name_with_type":"Xã Thanh Tùng","path":"Xã Thanh Tùng, Huyện Thanh Chương, Tỉnh Nghệ An","path_with_type":"Xã Thanh Tùng, Huyện Thanh Chương, Tỉnh Nghệ An","code":"17812","parent_code":"428"},"17815":{"name":"Xã Thanh Lâm","type":"xa","slug":"xa-thanh-lam","name_with_type":"Xã Thanh Lâm","path":"Xã Thanh Lâm, Huyện Thanh Chương, Tỉnh Nghệ An","path_with_type":"Xã Thanh Lâm, Huyện Thanh Chương, Tỉnh Nghệ An","code":"17815","parent_code":"428"},"17818":{"name":"Xã Mai Giang","type":"xa","slug":"xa-mai-giang","name_with_type":"Xã Mai Giang","path":"Xã Mai Giang, Huyện Thanh Chương, Tỉnh Nghệ An","path_with_type":"Xã Mai Giang, Huyện Thanh Chương, Tỉnh Nghệ An","code":"17818","parent_code":"428"},"17821":{"name":"Xã Thanh Xuân","type":"xa","slug":"xa-thanh-xuan","name_with_type":"Xã Thanh Xuân","path":"Xã Thanh Xuân, Huyện Thanh Chương, Tỉnh Nghệ An","path_with_type":"Xã Thanh Xuân, Huyện Thanh Chương, Tỉnh Nghệ An","code":"17821","parent_code":"428"},"17824":{"name":"Xã Thanh Đức","type":"xa","slug":"xa-thanh-duc","name_with_type":"Xã Thanh Đức","path":"Xã Thanh Đức, Huyện Thanh Chương, Tỉnh Nghệ An","path_with_type":"Xã Thanh Đức, Huyện Thanh Chương, Tỉnh Nghệ An","code":"17824","parent_code":"428"},"17827":{"name":"Thị trấn Quán Hành","type":"thi-tran","slug":"thi-tran-quan-hanh","name_with_type":"Thị trấn Quán Hành","path":"Thị trấn Quán Hành, Huyện Nghi Lộc, Tỉnh Nghệ An","path_with_type":"Thị trấn Quán Hành, Huyện Nghi Lộc, Tỉnh Nghệ An","code":"17827","parent_code":"429"},"17830":{"name":"Xã Nghi Văn","type":"xa","slug":"xa-nghi-van","name_with_type":"Xã Nghi Văn","path":"Xã Nghi Văn, Huyện Nghi Lộc, Tỉnh Nghệ An","path_with_type":"Xã Nghi Văn, Huyện Nghi Lộc, Tỉnh Nghệ An","code":"17830","parent_code":"429"},"17833":{"name":"Xã Nghi Yên","type":"xa","slug":"xa-nghi-yen","name_with_type":"Xã Nghi Yên","path":"Xã Nghi Yên, Huyện Nghi Lộc, Tỉnh Nghệ An","path_with_type":"Xã Nghi Yên, Huyện Nghi Lộc, Tỉnh Nghệ An","code":"17833","parent_code":"429"},"17836":{"name":"Xã Nghi Tiến","type":"xa","slug":"xa-nghi-tien","name_with_type":"Xã Nghi Tiến","path":"Xã Nghi Tiến, Huyện Nghi Lộc, Tỉnh Nghệ An","path_with_type":"Xã Nghi Tiến, Huyện Nghi Lộc, Tỉnh Nghệ An","code":"17836","parent_code":"429"},"17839":{"name":"Xã Nghi Hưng","type":"xa","slug":"xa-nghi-hung","name_with_type":"Xã Nghi Hưng","path":"Xã Nghi Hưng, Huyện Nghi Lộc, Tỉnh Nghệ An","path_with_type":"Xã Nghi Hưng, Huyện Nghi Lộc, Tỉnh Nghệ An","code":"17839","parent_code":"429"},"17842":{"name":"Xã Nghi Đồng","type":"xa","slug":"xa-nghi-dong","name_with_type":"Xã Nghi Đồng","path":"Xã Nghi Đồng, Huyện Nghi Lộc, Tỉnh Nghệ An","path_with_type":"Xã Nghi Đồng, Huyện Nghi Lộc, Tỉnh Nghệ An","code":"17842","parent_code":"429"},"17845":{"name":"Xã Nghi Thiết","type":"xa","slug":"xa-nghi-thiet","name_with_type":"Xã Nghi Thiết","path":"Xã Nghi Thiết, Huyện Nghi Lộc, Tỉnh Nghệ An","path_with_type":"Xã Nghi Thiết, Huyện Nghi Lộc, Tỉnh Nghệ An","code":"17845","parent_code":"429"},"17848":{"name":"Xã Nghi Lâm","type":"xa","slug":"xa-nghi-lam","name_with_type":"Xã Nghi Lâm","path":"Xã Nghi Lâm, Huyện Nghi Lộc, Tỉnh Nghệ An","path_with_type":"Xã Nghi Lâm, Huyện Nghi Lộc, Tỉnh Nghệ An","code":"17848","parent_code":"429"},"17851":{"name":"Xã Nghi Quang","type":"xa","slug":"xa-nghi-quang","name_with_type":"Xã Nghi Quang","path":"Xã Nghi Quang, Huyện Nghi Lộc, Tỉnh Nghệ An","path_with_type":"Xã Nghi Quang, Huyện Nghi Lộc, Tỉnh Nghệ An","code":"17851","parent_code":"429"},"17854":{"name":"Xã Nghi Kiều","type":"xa","slug":"xa-nghi-kieu","name_with_type":"Xã Nghi Kiều","path":"Xã Nghi Kiều, Huyện Nghi Lộc, Tỉnh Nghệ An","path_with_type":"Xã Nghi Kiều, Huyện Nghi Lộc, Tỉnh Nghệ An","code":"17854","parent_code":"429"},"17857":{"name":"Xã Nghi Mỹ","type":"xa","slug":"xa-nghi-my","name_with_type":"Xã Nghi Mỹ","path":"Xã Nghi Mỹ, Huyện Nghi Lộc, Tỉnh Nghệ An","path_with_type":"Xã Nghi Mỹ, Huyện Nghi Lộc, Tỉnh Nghệ An","code":"17857","parent_code":"429"},"17860":{"name":"Xã Nghi Phương","type":"xa","slug":"xa-nghi-phuong","name_with_type":"Xã Nghi Phương","path":"Xã Nghi Phương, Huyện Nghi Lộc, Tỉnh Nghệ An","path_with_type":"Xã Nghi Phương, Huyện Nghi Lộc, Tỉnh Nghệ An","code":"17860","parent_code":"429"},"17863":{"name":"Xã Nghi Thuận","type":"xa","slug":"xa-nghi-thuan","name_with_type":"Xã Nghi Thuận","path":"Xã Nghi Thuận, Huyện Nghi Lộc, Tỉnh Nghệ An","path_with_type":"Xã Nghi Thuận, Huyện Nghi Lộc, Tỉnh Nghệ An","code":"17863","parent_code":"429"},"17866":{"name":"Xã Nghi Long","type":"xa","slug":"xa-nghi-long","name_with_type":"Xã Nghi Long","path":"Xã Nghi Long, Huyện Nghi Lộc, Tỉnh Nghệ An","path_with_type":"Xã Nghi Long, Huyện Nghi Lộc, Tỉnh Nghệ An","code":"17866","parent_code":"429"},"17869":{"name":"Xã Nghi Xá","type":"xa","slug":"xa-nghi-xa","name_with_type":"Xã Nghi Xá","path":"Xã Nghi Xá, Huyện Nghi Lộc, Tỉnh Nghệ An","path_with_type":"Xã Nghi Xá, Huyện Nghi Lộc, Tỉnh Nghệ An","code":"17869","parent_code":"429"},"17878":{"name":"Xã Khánh Hợp","type":"xa","slug":"xa-khanh-hop","name_with_type":"Xã Khánh Hợp","path":"Xã Khánh Hợp, Huyện Nghi Lộc, Tỉnh Nghệ An","path_with_type":"Xã Khánh Hợp, Huyện Nghi Lộc, Tỉnh Nghệ An","code":"17878","parent_code":"429"},"17884":{"name":"Xã Nghi Công Bắc","type":"xa","slug":"xa-nghi-cong-bac","name_with_type":"Xã Nghi Công Bắc","path":"Xã Nghi Công Bắc, Huyện Nghi Lộc, Tỉnh Nghệ An","path_with_type":"Xã Nghi Công Bắc, Huyện Nghi Lộc, Tỉnh Nghệ An","code":"17884","parent_code":"429"},"17887":{"name":"Xã Nghi Công Nam","type":"xa","slug":"xa-nghi-cong-nam","name_with_type":"Xã Nghi Công Nam","path":"Xã Nghi Công Nam, Huyện Nghi Lộc, Tỉnh Nghệ An","path_with_type":"Xã Nghi Công Nam, Huyện Nghi Lộc, Tỉnh Nghệ An","code":"17887","parent_code":"429"},"17890":{"name":"Xã Nghi Thạch","type":"xa","slug":"xa-nghi-thach","name_with_type":"Xã Nghi Thạch","path":"Xã Nghi Thạch, Huyện Nghi Lộc, Tỉnh Nghệ An","path_with_type":"Xã Nghi Thạch, Huyện Nghi Lộc, Tỉnh Nghệ An","code":"17890","parent_code":"429"},"17893":{"name":"Xã Nghi Trung","type":"xa","slug":"xa-nghi-trung","name_with_type":"Xã Nghi Trung","path":"Xã Nghi Trung, Huyện Nghi Lộc, Tỉnh Nghệ An","path_with_type":"Xã Nghi Trung, Huyện Nghi Lộc, Tỉnh Nghệ An","code":"17893","parent_code":"429"},"17896":{"name":"Xã Thịnh Trường","type":"xa","slug":"xa-thinh-truong","name_with_type":"Xã Thịnh Trường","path":"Xã Thịnh Trường, Huyện Nghi Lộc, Tỉnh Nghệ An","path_with_type":"Xã Thịnh Trường, Huyện Nghi Lộc, Tỉnh Nghệ An","code":"17896","parent_code":"429"},"17899":{"name":"Xã Diên Hoa","type":"xa","slug":"xa-dien-hoa","name_with_type":"Xã Diên Hoa","path":"Xã Diên Hoa, Huyện Nghi Lộc, Tỉnh Nghệ An","path_with_type":"Xã Diên Hoa, Huyện Nghi Lộc, Tỉnh Nghệ An","code":"17899","parent_code":"429"},"17902":{"name":"Xã Nghi Phong","type":"xa","slug":"xa-nghi-phong","name_with_type":"Xã Nghi Phong","path":"Xã Nghi Phong, Thành phố Vinh, Tỉnh Nghệ An","path_with_type":"Xã Nghi Phong, Thành phố Vinh, Tỉnh Nghệ An","code":"17902","parent_code":"412"},"17905":{"name":"Xã Nghi Xuân","type":"xa","slug":"xa-nghi-xuan","name_with_type":"Xã Nghi Xuân","path":"Xã Nghi Xuân, Thành phố Vinh, Tỉnh Nghệ An","path_with_type":"Xã Nghi Xuân, Thành phố Vinh, Tỉnh Nghệ An","code":"17905","parent_code":"412"},"17908":{"name":"Xã Nghi Liên","type":"xa","slug":"xa-nghi-lien","name_with_type":"Xã Nghi Liên","path":"Xã Nghi Liên, Thành phố Vinh, Tỉnh Nghệ An","path_with_type":"Xã Nghi Liên, Thành phố Vinh, Tỉnh Nghệ An","code":"17908","parent_code":"412"},"17911":{"name":"Xã Nghi Vạn","type":"xa","slug":"xa-nghi-van","name_with_type":"Xã Nghi Vạn","path":"Xã Nghi Vạn, Huyện Nghi Lộc, Tỉnh Nghệ An","path_with_type":"Xã Nghi Vạn, Huyện Nghi Lộc, Tỉnh Nghệ An","code":"17911","parent_code":"429"},"17914":{"name":"Xã Nghi Ân","type":"xa","slug":"xa-nghi-an","name_with_type":"Xã Nghi Ân","path":"Xã Nghi Ân, Thành phố Vinh, Tỉnh Nghệ An","path_with_type":"Xã Nghi Ân, Thành phố Vinh, Tỉnh Nghệ An","code":"17914","parent_code":"412"},"17917":{"name":"Xã Phúc Thọ","type":"xa","slug":"xa-phuc-tho","name_with_type":"Xã Phúc Thọ","path":"Xã Phúc Thọ, Thành phố Vinh, Tỉnh Nghệ An","path_with_type":"Xã Phúc Thọ, Thành phố Vinh, Tỉnh Nghệ An","code":"17917","parent_code":"412"},"17920":{"name":"Xã Nghi Kim","type":"xa","slug":"xa-nghi-kim","name_with_type":"Xã Nghi Kim","path":"Xã Nghi Kim, Thành phố Vinh, Tỉnh Nghệ An","path_with_type":"Xã Nghi Kim, Thành phố Vinh, Tỉnh Nghệ An","code":"17920","parent_code":"412"},"17923":{"name":"Phường Nghi Đức","type":"phuong","slug":"phuong-nghi-duc","name_with_type":"Phường Nghi Đức","path":"Phường Nghi Đức, Thành phố Vinh, Tỉnh Nghệ An","path_with_type":"Phường Nghi Đức, Thành phố Vinh, Tỉnh Nghệ An","code":"17923","parent_code":"412"},"17926":{"name":"Xã Nghi Thái","type":"xa","slug":"xa-nghi-thai","name_with_type":"Xã Nghi Thái","path":"Xã Nghi Thái, Thành phố Vinh, Tỉnh Nghệ An","path_with_type":"Xã Nghi Thái, Thành phố Vinh, Tỉnh Nghệ An","code":"17926","parent_code":"412"},"17932":{"name":"Xã Nam Hưng","type":"xa","slug":"xa-nam-hung","name_with_type":"Xã Nam Hưng","path":"Xã Nam Hưng, Huyện Nam Đàn, Tỉnh Nghệ An","path_with_type":"Xã Nam Hưng, Huyện Nam Đàn, Tỉnh Nghệ An","code":"17932","parent_code":"430"},"17935":{"name":"Xã Nghĩa Thái","type":"xa","slug":"xa-nghia-thai","name_with_type":"Xã Nghĩa Thái","path":"Xã Nghĩa Thái, Huyện Nam Đàn, Tỉnh Nghệ An","path_with_type":"Xã Nghĩa Thái, Huyện Nam Đàn, Tỉnh Nghệ An","code":"17935","parent_code":"430"},"17938":{"name":"Xã Nam Thanh","type":"xa","slug":"xa-nam-thanh","name_with_type":"Xã Nam Thanh","path":"Xã Nam Thanh, Huyện Nam Đàn, Tỉnh Nghệ An","path_with_type":"Xã Nam Thanh, Huyện Nam Đàn, Tỉnh Nghệ An","code":"17938","parent_code":"430"},"17941":{"name":"Xã Nam Anh","type":"xa","slug":"xa-nam-anh","name_with_type":"Xã Nam Anh","path":"Xã Nam Anh, Huyện Nam Đàn, Tỉnh Nghệ An","path_with_type":"Xã Nam Anh, Huyện Nam Đàn, Tỉnh Nghệ An","code":"17941","parent_code":"430"},"17944":{"name":"Xã Nam Xuân","type":"xa","slug":"xa-nam-xuan","name_with_type":"Xã Nam Xuân","path":"Xã Nam Xuân, Huyện Nam Đàn, Tỉnh Nghệ An","path_with_type":"Xã Nam Xuân, Huyện Nam Đàn, Tỉnh Nghệ An","code":"17944","parent_code":"430"},"17950":{"name":"Thị trấn Nam Đàn","type":"thi-tran","slug":"thi-tran-nam-dan","name_with_type":"Thị trấn Nam Đàn","path":"Thị trấn Nam Đàn, Huyện Nam Đàn, Tỉnh Nghệ An","path_with_type":"Thị trấn Nam Đàn, Huyện Nam Đàn, Tỉnh Nghệ An","code":"17950","parent_code":"430"},"17953":{"name":"Xã Nam Lĩnh","type":"xa","slug":"xa-nam-linh","name_with_type":"Xã Nam Lĩnh","path":"Xã Nam Lĩnh, Huyện Nam Đàn, Tỉnh Nghệ An","path_with_type":"Xã Nam Lĩnh, Huyện Nam Đàn, Tỉnh Nghệ An","code":"17953","parent_code":"430"},"17956":{"name":"Xã Nam Giang","type":"xa","slug":"xa-nam-giang","name_with_type":"Xã Nam Giang","path":"Xã Nam Giang, Huyện Nam Đàn, Tỉnh Nghệ An","path_with_type":"Xã Nam Giang, Huyện Nam Đàn, Tỉnh Nghệ An","code":"17956","parent_code":"430"},"17959":{"name":"Xã Xuân Hòa","type":"xa","slug":"xa-xuan-hoa","name_with_type":"Xã Xuân Hòa","path":"Xã Xuân Hòa, Huyện Nam Đàn, Tỉnh Nghệ An","path_with_type":"Xã Xuân Hòa, Huyện Nam Đàn, Tỉnh Nghệ An","code":"17959","parent_code":"430"},"17962":{"name":"Xã Hùng Tiến","type":"xa","slug":"xa-hung-tien","name_with_type":"Xã Hùng Tiến","path":"Xã Hùng Tiến, Huyện Nam Đàn, Tỉnh Nghệ An","path_with_type":"Xã Hùng Tiến, Huyện Nam Đàn, Tỉnh Nghệ An","code":"17962","parent_code":"430"},"17968":{"name":"Xã Thượng Tân Lộc","type":"xa","slug":"xa-thuong-tan-loc","name_with_type":"Xã Thượng Tân Lộc","path":"Xã Thượng Tân Lộc, Huyện Nam Đàn, Tỉnh Nghệ An","path_with_type":"Xã Thượng Tân Lộc, Huyện Nam Đàn, Tỉnh Nghệ An","code":"17968","parent_code":"430"},"17971":{"name":"Xã Kim Liên","type":"xa","slug":"xa-kim-lien","name_with_type":"Xã Kim Liên","path":"Xã Kim Liên, Huyện Nam Đàn, Tỉnh Nghệ An","path_with_type":"Xã Kim Liên, Huyện Nam Đàn, Tỉnh Nghệ An","code":"17971","parent_code":"430"},"17980":{"name":"Xã Xuân Hồng","type":"xa","slug":"xa-xuan-hong","name_with_type":"Xã Xuân Hồng","path":"Xã Xuân Hồng, Huyện Nam Đàn, Tỉnh Nghệ An","path_with_type":"Xã Xuân Hồng, Huyện Nam Đàn, Tỉnh Nghệ An","code":"17980","parent_code":"430"},"17983":{"name":"Xã Nam Cát","type":"xa","slug":"xa-nam-cat","name_with_type":"Xã Nam Cát","path":"Xã Nam Cát, Huyện Nam Đàn, Tỉnh Nghệ An","path_with_type":"Xã Nam Cát, Huyện Nam Đàn, Tỉnh Nghệ An","code":"17983","parent_code":"430"},"17986":{"name":"Xã Khánh Sơn","type":"xa","slug":"xa-khanh-son","name_with_type":"Xã Khánh Sơn","path":"Xã Khánh Sơn, Huyện Nam Đàn, Tỉnh Nghệ An","path_with_type":"Xã Khánh Sơn, Huyện Nam Đàn, Tỉnh Nghệ An","code":"17986","parent_code":"430"},"17989":{"name":"Xã Trung Phúc Cường","type":"xa","slug":"xa-trung-phuc-cuong","name_with_type":"Xã Trung Phúc Cường","path":"Xã Trung Phúc Cường, Huyện Nam Đàn, Tỉnh Nghệ An","path_with_type":"Xã Trung Phúc Cường, Huyện Nam Đàn, Tỉnh Nghệ An","code":"17989","parent_code":"430"},"17998":{"name":"Xã Nam Kim","type":"xa","slug":"xa-nam-kim","name_with_type":"Xã Nam Kim","path":"Xã Nam Kim, Huyện Nam Đàn, Tỉnh Nghệ An","path_with_type":"Xã Nam Kim, Huyện Nam Đàn, Tỉnh Nghệ An","code":"17998","parent_code":"430"},"18001":{"name":"Thị trấn Hưng Nguyên","type":"thi-tran","slug":"thi-tran-hung-nguyen","name_with_type":"Thị trấn Hưng Nguyên","path":"Thị trấn Hưng Nguyên, Huyện Hưng Nguyên, Tỉnh Nghệ An","path_with_type":"Thị trấn Hưng Nguyên, Huyện Hưng Nguyên, Tỉnh Nghệ An","code":"18001","parent_code":"431"},"18004":{"name":"Xã Hưng Trung","type":"xa","slug":"xa-hung-trung","name_with_type":"Xã Hưng Trung","path":"Xã Hưng Trung, Huyện Hưng Nguyên, Tỉnh Nghệ An","path_with_type":"Xã Hưng Trung, Huyện Hưng Nguyên, Tỉnh Nghệ An","code":"18004","parent_code":"431"},"18007":{"name":"Xã Hưng Yên","type":"xa","slug":"xa-hung-yen","name_with_type":"Xã Hưng Yên","path":"Xã Hưng Yên, Huyện Hưng Nguyên, Tỉnh Nghệ An","path_with_type":"Xã Hưng Yên, Huyện Hưng Nguyên, Tỉnh Nghệ An","code":"18007","parent_code":"431"},"18008":{"name":"Xã Hưng Yên Bắc","type":"xa","slug":"xa-hung-yen-bac","name_with_type":"Xã Hưng Yên Bắc","path":"Xã Hưng Yên Bắc, Huyện Hưng Nguyên, Tỉnh Nghệ An","path_with_type":"Xã Hưng Yên Bắc, Huyện Hưng Nguyên, Tỉnh Nghệ An","code":"18008","parent_code":"431"},"18010":{"name":"Xã Hưng Tây","type":"xa","slug":"xa-hung-tay","name_with_type":"Xã Hưng Tây","path":"Xã Hưng Tây, Huyện Hưng Nguyên, Tỉnh Nghệ An","path_with_type":"Xã Hưng Tây, Huyện Hưng Nguyên, Tỉnh Nghệ An","code":"18010","parent_code":"431"},"18013":{"name":"Xã Hưng Chính","type":"xa","slug":"xa-hung-chinh","name_with_type":"Xã Hưng Chính","path":"Xã Hưng Chính, Thành phố Vinh, Tỉnh Nghệ An","path_with_type":"Xã Hưng Chính, Thành phố Vinh, Tỉnh Nghệ An","code":"18013","parent_code":"412"},"18016":{"name":"Xã Hưng Đạo","type":"xa","slug":"xa-hung-dao","name_with_type":"Xã Hưng Đạo","path":"Xã Hưng Đạo, Huyện Hưng Nguyên, Tỉnh Nghệ An","path_with_type":"Xã Hưng Đạo, Huyện Hưng Nguyên, Tỉnh Nghệ An","code":"18016","parent_code":"431"},"18022":{"name":"Xã Thịnh Mỹ","type":"xa","slug":"xa-thinh-my","name_with_type":"Xã Thịnh Mỹ","path":"Xã Thịnh Mỹ, Huyện Hưng Nguyên, Tỉnh Nghệ An","path_with_type":"Xã Thịnh Mỹ, Huyện Hưng Nguyên, Tỉnh Nghệ An","code":"18022","parent_code":"431"},"18025":{"name":"Xã Hưng Lĩnh","type":"xa","slug":"xa-hung-linh","name_with_type":"Xã Hưng Lĩnh","path":"Xã Hưng Lĩnh, Huyện Hưng Nguyên, Tỉnh Nghệ An","path_with_type":"Xã Hưng Lĩnh, Huyện Hưng Nguyên, Tỉnh Nghệ An","code":"18025","parent_code":"431"},"18028":{"name":"Xã Thông Tân","type":"xa","slug":"xa-thong-tan","name_with_type":"Xã Thông Tân","path":"Xã Thông Tân, Huyện Hưng Nguyên, Tỉnh Nghệ An","path_with_type":"Xã Thông Tân, Huyện Hưng Nguyên, Tỉnh Nghệ An","code":"18028","parent_code":"431"},"18037":{"name":"Xã Hưng Nghĩa","type":"xa","slug":"xa-hung-nghia","name_with_type":"Xã Hưng Nghĩa","path":"Xã Hưng Nghĩa, Huyện Hưng Nguyên, Tỉnh Nghệ An","path_with_type":"Xã Hưng Nghĩa, Huyện Hưng Nguyên, Tỉnh Nghệ An","code":"18037","parent_code":"431"},"18040":{"name":"Xã Phúc Lợi","type":"xa","slug":"xa-phuc-loi","name_with_type":"Xã Phúc Lợi","path":"Xã Phúc Lợi, Huyện Hưng Nguyên, Tỉnh Nghệ An","path_with_type":"Xã Phúc Lợi, Huyện Hưng Nguyên, Tỉnh Nghệ An","code":"18040","parent_code":"431"},"18043":{"name":"Xã Long Xá","type":"xa","slug":"xa-long-xa","name_with_type":"Xã Long Xá","path":"Xã Long Xá, Huyện Hưng Nguyên, Tỉnh Nghệ An","path_with_type":"Xã Long Xá, Huyện Hưng Nguyên, Tỉnh Nghệ An","code":"18043","parent_code":"431"},"18052":{"name":"Xã Châu Nhân","type":"xa","slug":"xa-chau-nhan","name_with_type":"Xã Châu Nhân","path":"Xã Châu Nhân, Huyện Hưng Nguyên, Tỉnh Nghệ An","path_with_type":"Xã Châu Nhân, Huyện Hưng Nguyên, Tỉnh Nghệ An","code":"18052","parent_code":"431"},"18055":{"name":"Xã Xuân Lam","type":"xa","slug":"xa-xuan-lam","name_with_type":"Xã Xuân Lam","path":"Xã Xuân Lam, Huyện Hưng Nguyên, Tỉnh Nghệ An","path_with_type":"Xã Xuân Lam, Huyện Hưng Nguyên, Tỉnh Nghệ An","code":"18055","parent_code":"431"},"18064":{"name":"Xã Hưng Thành","type":"xa","slug":"xa-hung-thanh","name_with_type":"Xã Hưng Thành","path":"Xã Hưng Thành, Huyện Hưng Nguyên, Tỉnh Nghệ An","path_with_type":"Xã Hưng Thành, Huyện Hưng Nguyên, Tỉnh Nghệ An","code":"18064","parent_code":"431"},"18073":{"name":"Phường Nam Hà","type":"phuong","slug":"phuong-nam-ha","name_with_type":"Phường Nam Hà","path":"Phường Nam Hà, Thành phố Hà Tĩnh, Tỉnh Hà Tĩnh","path_with_type":"Phường Nam Hà, Thành phố Hà Tĩnh, Tỉnh Hà Tĩnh","code":"18073","parent_code":"436"},"18077":{"name":"Phường Bắc Hà","type":"phuong","slug":"phuong-bac-ha","name_with_type":"Phường Bắc Hà","path":"Phường Bắc Hà, Thành phố Hà Tĩnh, Tỉnh Hà Tĩnh","path_with_type":"Phường Bắc Hà, Thành phố Hà Tĩnh, Tỉnh Hà Tĩnh","code":"18077","parent_code":"436"},"18079":{"name":"Phường Tân Giang","type":"phuong","slug":"phuong-tan-giang","name_with_type":"Phường Tân Giang","path":"Phường Tân Giang, Thành phố Hà Tĩnh, Tỉnh Hà Tĩnh","path_with_type":"Phường Tân Giang, Thành phố Hà Tĩnh, Tỉnh Hà Tĩnh","code":"18079","parent_code":"436"},"18082":{"name":"Phường Đại Nài","type":"phuong","slug":"phuong-dai-nai","name_with_type":"Phường Đại Nài","path":"Phường Đại Nài, Thành phố Hà Tĩnh, Tỉnh Hà Tĩnh","path_with_type":"Phường Đại Nài, Thành phố Hà Tĩnh, Tỉnh Hà Tĩnh","code":"18082","parent_code":"436"},"18085":{"name":"Phường Hà Huy Tập","type":"phuong","slug":"phuong-ha-huy-tap","name_with_type":"Phường Hà Huy Tập","path":"Phường Hà Huy Tập, Thành phố Hà Tĩnh, Tỉnh Hà Tĩnh","path_with_type":"Phường Hà Huy Tập, Thành phố Hà Tĩnh, Tỉnh Hà Tĩnh","code":"18085","parent_code":"436"},"18088":{"name":"Phường Thạch Trung","type":"phuong","slug":"phuong-thach-trung","name_with_type":"Phường Thạch Trung","path":"Phường Thạch Trung, Thành phố Hà Tĩnh, Tỉnh Hà Tĩnh","path_with_type":"Phường Thạch Trung, Thành phố Hà Tĩnh, Tỉnh Hà Tĩnh","code":"18088","parent_code":"436"},"18091":{"name":"Phường Thạch Quý","type":"phuong","slug":"phuong-thach-quy","name_with_type":"Phường Thạch Quý","path":"Phường Thạch Quý, Thành phố Hà Tĩnh, Tỉnh Hà Tĩnh","path_with_type":"Phường Thạch Quý, Thành phố Hà Tĩnh, Tỉnh Hà Tĩnh","code":"18091","parent_code":"436"},"18094":{"name":"Phường Trần Phú","type":"phuong","slug":"phuong-tran-phu","name_with_type":"Phường Trần Phú","path":"Phường Trần Phú, Thành phố Hà Tĩnh, Tỉnh Hà Tĩnh","path_with_type":"Phường Trần Phú, Thành phố Hà Tĩnh, Tỉnh Hà Tĩnh","code":"18094","parent_code":"436"},"18097":{"name":"Phường Văn Yên","type":"phuong","slug":"phuong-van-yen","name_with_type":"Phường Văn Yên","path":"Phường Văn Yên, Thành phố Hà Tĩnh, Tỉnh Hà Tĩnh","path_with_type":"Phường Văn Yên, Thành phố Hà Tĩnh, Tỉnh Hà Tĩnh","code":"18097","parent_code":"436"},"18100":{"name":"Phường Thạch Hạ","type":"phuong","slug":"phuong-thach-ha","name_with_type":"Phường Thạch Hạ","path":"Phường Thạch Hạ, Thành phố Hà Tĩnh, Tỉnh Hà Tĩnh","path_with_type":"Phường Thạch Hạ, Thành phố Hà Tĩnh, Tỉnh Hà Tĩnh","code":"18100","parent_code":"436"},"18103":{"name":"Phường Đồng Môn","type":"phuong","slug":"phuong-dong-mon","name_with_type":"Phường Đồng Môn","path":"Phường Đồng Môn, Thành phố Hà Tĩnh, Tỉnh Hà Tĩnh","path_with_type":"Phường Đồng Môn, Thành phố Hà Tĩnh, Tỉnh Hà Tĩnh","code":"18103","parent_code":"436"},"18109":{"name":"Phường Thạch Hưng","type":"phuong","slug":"phuong-thach-hung","name_with_type":"Phường Thạch Hưng","path":"Phường Thạch Hưng, Thành phố Hà Tĩnh, Tỉnh Hà Tĩnh","path_with_type":"Phường Thạch Hưng, Thành phố Hà Tĩnh, Tỉnh Hà Tĩnh","code":"18109","parent_code":"436"},"18112":{"name":"Xã Thạch Bình","type":"xa","slug":"xa-thach-binh","name_with_type":"Xã Thạch Bình","path":"Xã Thạch Bình, Thành phố Hà Tĩnh, Tỉnh Hà Tĩnh","path_with_type":"Xã Thạch Bình, Thành phố Hà Tĩnh, Tỉnh Hà Tĩnh","code":"18112","parent_code":"436"},"18115":{"name":"Phường Bắc Hồng","type":"phuong","slug":"phuong-bac-hong","name_with_type":"Phường Bắc Hồng","path":"Phường Bắc Hồng, Thị xã Hồng Lĩnh, Tỉnh Hà Tĩnh","path_with_type":"Phường Bắc Hồng, Thị xã Hồng Lĩnh, Tỉnh Hà Tĩnh","code":"18115","parent_code":"437"},"18118":{"name":"Phường Nam Hồng","type":"phuong","slug":"phuong-nam-hong","name_with_type":"Phường Nam Hồng","path":"Phường Nam Hồng, Thị xã Hồng Lĩnh, Tỉnh Hà Tĩnh","path_with_type":"Phường Nam Hồng, Thị xã Hồng Lĩnh, Tỉnh Hà Tĩnh","code":"18118","parent_code":"437"},"18121":{"name":"Phường Trung Lương","type":"phuong","slug":"phuong-trung-luong","name_with_type":"Phường Trung Lương","path":"Phường Trung Lương, Thị xã Hồng Lĩnh, Tỉnh Hà Tĩnh","path_with_type":"Phường Trung Lương, Thị xã Hồng Lĩnh, Tỉnh Hà Tĩnh","code":"18121","parent_code":"437"},"18124":{"name":"Phường Đức Thuận","type":"phuong","slug":"phuong-duc-thuan","name_with_type":"Phường Đức Thuận","path":"Phường Đức Thuận, Thị xã Hồng Lĩnh, Tỉnh Hà Tĩnh","path_with_type":"Phường Đức Thuận, Thị xã Hồng Lĩnh, Tỉnh Hà Tĩnh","code":"18124","parent_code":"437"},"18127":{"name":"Phường Đậu Liêu","type":"phuong","slug":"phuong-dau-lieu","name_with_type":"Phường Đậu Liêu","path":"Phường Đậu Liêu, Thị xã Hồng Lĩnh, Tỉnh Hà Tĩnh","path_with_type":"Phường Đậu Liêu, Thị xã Hồng Lĩnh, Tỉnh Hà Tĩnh","code":"18127","parent_code":"437"},"18130":{"name":"Xã Thuận Lộc","type":"xa","slug":"xa-thuan-loc","name_with_type":"Xã Thuận Lộc","path":"Xã Thuận Lộc, Thị xã Hồng Lĩnh, Tỉnh Hà Tĩnh","path_with_type":"Xã Thuận Lộc, Thị xã Hồng Lĩnh, Tỉnh Hà Tĩnh","code":"18130","parent_code":"437"},"18133":{"name":"Thị trấn Phố Châu","type":"thi-tran","slug":"thi-tran-pho-chau","name_with_type":"Thị trấn Phố Châu","path":"Thị trấn Phố Châu, Huyện Hương Sơn, Tỉnh Hà Tĩnh","path_with_type":"Thị trấn Phố Châu, Huyện Hương Sơn, Tỉnh Hà Tĩnh","code":"18133","parent_code":"439"},"18136":{"name":"Thị trấn  Tây Sơn","type":"thi-tran","slug":"thi-tran-tay-son","name_with_type":"Thị trấn  Tây Sơn","path":"Thị trấn  Tây Sơn, Huyện Hương Sơn, Tỉnh Hà Tĩnh","path_with_type":"Thị trấn  Tây Sơn, Huyện Hương Sơn, Tỉnh Hà Tĩnh","code":"18136","parent_code":"439"},"18139":{"name":"Xã Sơn Hồng","type":"xa","slug":"xa-son-hong","name_with_type":"Xã Sơn Hồng","path":"Xã Sơn Hồng, Huyện Hương Sơn, Tỉnh Hà Tĩnh","path_with_type":"Xã Sơn Hồng, Huyện Hương Sơn, Tỉnh Hà Tĩnh","code":"18139","parent_code":"439"},"18142":{"name":"Xã Sơn Tiến","type":"xa","slug":"xa-son-tien","name_with_type":"Xã Sơn Tiến","path":"Xã Sơn Tiến, Huyện Hương Sơn, Tỉnh Hà Tĩnh","path_with_type":"Xã Sơn Tiến, Huyện Hương Sơn, Tỉnh Hà Tĩnh","code":"18142","parent_code":"439"},"18145":{"name":"Xã Sơn Lâm","type":"xa","slug":"xa-son-lam","name_with_type":"Xã Sơn Lâm","path":"Xã Sơn Lâm, Huyện Hương Sơn, Tỉnh Hà Tĩnh","path_with_type":"Xã Sơn Lâm, Huyện Hương Sơn, Tỉnh Hà Tĩnh","code":"18145","parent_code":"439"},"18148":{"name":"Xã Sơn Lễ","type":"xa","slug":"xa-son-le","name_with_type":"Xã Sơn Lễ","path":"Xã Sơn Lễ, Huyện Hương Sơn, Tỉnh Hà Tĩnh","path_with_type":"Xã Sơn Lễ, Huyện Hương Sơn, Tỉnh Hà Tĩnh","code":"18148","parent_code":"439"},"18157":{"name":"Xã Sơn Giang","type":"xa","slug":"xa-son-giang","name_with_type":"Xã Sơn Giang","path":"Xã Sơn Giang, Huyện Hương Sơn, Tỉnh Hà Tĩnh","path_with_type":"Xã Sơn Giang, Huyện Hương Sơn, Tỉnh Hà Tĩnh","code":"18157","parent_code":"439"},"18160":{"name":"Xã Sơn Lĩnh","type":"xa","slug":"xa-son-linh","name_with_type":"Xã Sơn Lĩnh","path":"Xã Sơn Lĩnh, Huyện Hương Sơn, Tỉnh Hà Tĩnh","path_with_type":"Xã Sơn Lĩnh, Huyện Hương Sơn, Tỉnh Hà Tĩnh","code":"18160","parent_code":"439"},"18163":{"name":"Xã An Hòa Thịnh","type":"xa","slug":"xa-an-hoa-thinh","name_with_type":"Xã An Hòa Thịnh","path":"Xã An Hòa Thịnh, Huyện Hương Sơn, Tỉnh Hà Tĩnh","path_with_type":"Xã An Hòa Thịnh, Huyện Hương Sơn, Tỉnh Hà Tĩnh","code":"18163","parent_code":"439"},"18172":{"name":"Xã Sơn Tây","type":"xa","slug":"xa-son-tay","name_with_type":"Xã Sơn Tây","path":"Xã Sơn Tây, Huyện Hương Sơn, Tỉnh Hà Tĩnh","path_with_type":"Xã Sơn Tây, Huyện Hương Sơn, Tỉnh Hà Tĩnh","code":"18172","parent_code":"439"},"18175":{"name":"Xã Sơn Ninh","type":"xa","slug":"xa-son-ninh","name_with_type":"Xã Sơn Ninh","path":"Xã Sơn Ninh, Huyện Hương Sơn, Tỉnh Hà Tĩnh","path_with_type":"Xã Sơn Ninh, Huyện Hương Sơn, Tỉnh Hà Tĩnh","code":"18175","parent_code":"439"},"18178":{"name":"Xã Châu Bình","type":"xa","slug":"xa-chau-binh","name_with_type":"Xã Châu Bình","path":"Xã Châu Bình, Huyện Hương Sơn, Tỉnh Hà Tĩnh","path_with_type":"Xã Châu Bình, Huyện Hương Sơn, Tỉnh Hà Tĩnh","code":"18178","parent_code":"439"},"18181":{"name":"Xã Tân Mỹ Hà","type":"xa","slug":"xa-tan-my-ha","name_with_type":"Xã Tân Mỹ Hà","path":"Xã Tân Mỹ Hà, Huyện Hương Sơn, Tỉnh Hà Tĩnh","path_with_type":"Xã Tân Mỹ Hà, Huyện Hương Sơn, Tỉnh Hà Tĩnh","code":"18181","parent_code":"439"},"18184":{"name":"Xã Quang Diệm","type":"xa","slug":"xa-quang-diem","name_with_type":"Xã Quang Diệm","path":"Xã Quang Diệm, Huyện Hương Sơn, Tỉnh Hà Tĩnh","path_with_type":"Xã Quang Diệm, Huyện Hương Sơn, Tỉnh Hà Tĩnh","code":"18184","parent_code":"439"},"18187":{"name":"Xã Sơn Trung","type":"xa","slug":"xa-son-trung","name_with_type":"Xã Sơn Trung","path":"Xã Sơn Trung, Huyện Hương Sơn, Tỉnh Hà Tĩnh","path_with_type":"Xã Sơn Trung, Huyện Hương Sơn, Tỉnh Hà Tĩnh","code":"18187","parent_code":"439"},"18190":{"name":"Xã Sơn Bằng","type":"xa","slug":"xa-son-bang","name_with_type":"Xã Sơn Bằng","path":"Xã Sơn Bằng, Huyện Hương Sơn, Tỉnh Hà Tĩnh","path_with_type":"Xã Sơn Bằng, Huyện Hương Sơn, Tỉnh Hà Tĩnh","code":"18190","parent_code":"439"},"18196":{"name":"Xã Sơn Kim 1","type":"xa","slug":"xa-son-kim-1","name_with_type":"Xã Sơn Kim 1","path":"Xã Sơn Kim 1, Huyện Hương Sơn, Tỉnh Hà Tĩnh","path_with_type":"Xã Sơn Kim 1, Huyện Hương Sơn, Tỉnh Hà Tĩnh","code":"18196","parent_code":"439"},"18199":{"name":"Xã Sơn Kim 2","type":"xa","slug":"xa-son-kim-2","name_with_type":"Xã Sơn Kim 2","path":"Xã Sơn Kim 2, Huyện Hương Sơn, Tỉnh Hà Tĩnh","path_with_type":"Xã Sơn Kim 2, Huyện Hương Sơn, Tỉnh Hà Tĩnh","code":"18199","parent_code":"439"},"18202":{"name":"Xã Mỹ Long","type":"xa","slug":"xa-my-long","name_with_type":"Xã Mỹ Long","path":"Xã Mỹ Long, Huyện Hương Sơn, Tỉnh Hà Tĩnh","path_with_type":"Xã Mỹ Long, Huyện Hương Sơn, Tỉnh Hà Tĩnh","code":"18202","parent_code":"439"},"18211":{"name":"Xã Kim Hoa","type":"xa","slug":"xa-kim-hoa","name_with_type":"Xã Kim Hoa","path":"Xã Kim Hoa, Huyện Hương Sơn, Tỉnh Hà Tĩnh","path_with_type":"Xã Kim Hoa, Huyện Hương Sơn, Tỉnh Hà Tĩnh","code":"18211","parent_code":"439"},"18217":{"name":"Xã Sơn Phú","type":"xa","slug":"xa-son-phu","name_with_type":"Xã Sơn Phú","path":"Xã Sơn Phú, Huyện Hương Sơn, Tỉnh Hà Tĩnh","path_with_type":"Xã Sơn Phú, Huyện Hương Sơn, Tỉnh Hà Tĩnh","code":"18217","parent_code":"439"},"18223":{"name":"Xã Hàm Trường","type":"xa","slug":"xa-ham-truong","name_with_type":"Xã Hàm Trường","path":"Xã Hàm Trường, Huyện Hương Sơn, Tỉnh Hà Tĩnh","path_with_type":"Xã Hàm Trường, Huyện Hương Sơn, Tỉnh Hà Tĩnh","code":"18223","parent_code":"439"},"18229":{"name":"Thị trấn Đức Thọ","type":"thi-tran","slug":"thi-tran-duc-tho","name_with_type":"Thị trấn Đức Thọ","path":"Thị trấn Đức Thọ, Huyện Đức Thọ, Tỉnh Hà Tĩnh","path_with_type":"Thị trấn Đức Thọ, Huyện Đức Thọ, Tỉnh Hà Tĩnh","code":"18229","parent_code":"440"},"18235":{"name":"Xã Quang Vĩnh","type":"xa","slug":"xa-quang-vinh","name_with_type":"Xã Quang Vĩnh","path":"Xã Quang Vĩnh, Huyện Đức Thọ, Tỉnh Hà Tĩnh","path_with_type":"Xã Quang Vĩnh, Huyện Đức Thọ, Tỉnh Hà Tĩnh","code":"18235","parent_code":"440"},"18241":{"name":"Xã Tùng Châu","type":"xa","slug":"xa-tung-chau","name_with_type":"Xã Tùng Châu","path":"Xã Tùng Châu, Huyện Đức Thọ, Tỉnh Hà Tĩnh","path_with_type":"Xã Tùng Châu, Huyện Đức Thọ, Tỉnh Hà Tĩnh","code":"18241","parent_code":"440"},"18244":{"name":"Xã Trường Sơn","type":"xa","slug":"xa-truong-son","name_with_type":"Xã Trường Sơn","path":"Xã Trường Sơn, Huyện Đức Thọ, Tỉnh Hà Tĩnh","path_with_type":"Xã Trường Sơn, Huyện Đức Thọ, Tỉnh Hà Tĩnh","code":"18244","parent_code":"440"},"18247":{"name":"Xã Liên Minh","type":"xa","slug":"xa-lien-minh","name_with_type":"Xã Liên Minh","path":"Xã Liên Minh, Huyện Đức Thọ, Tỉnh Hà Tĩnh","path_with_type":"Xã Liên Minh, Huyện Đức Thọ, Tỉnh Hà Tĩnh","code":"18247","parent_code":"440"},"18253":{"name":"Xã Yên Hồ","type":"xa","slug":"xa-yen-ho","name_with_type":"Xã Yên Hồ","path":"Xã Yên Hồ, Huyện Đức Thọ, Tỉnh Hà Tĩnh","path_with_type":"Xã Yên Hồ, Huyện Đức Thọ, Tỉnh Hà Tĩnh","code":"18253","parent_code":"440"},"18259":{"name":"Xã Tùng Ảnh","type":"xa","slug":"xa-tung-anh","name_with_type":"Xã Tùng Ảnh","path":"Xã Tùng Ảnh, Huyện Đức Thọ, Tỉnh Hà Tĩnh","path_with_type":"Xã Tùng Ảnh, Huyện Đức Thọ, Tỉnh Hà Tĩnh","code":"18259","parent_code":"440"},"18262":{"name":"Xã Bùi La Nhân","type":"xa","slug":"xa-bui-la-nhan","name_with_type":"Xã Bùi La Nhân","path":"Xã Bùi La Nhân, Huyện Đức Thọ, Tỉnh Hà Tĩnh","path_with_type":"Xã Bùi La Nhân, Huyện Đức Thọ, Tỉnh Hà Tĩnh","code":"18262","parent_code":"440"},"18274":{"name":"Xã Thanh Bình Thịnh","type":"xa","slug":"xa-thanh-binh-thinh","name_with_type":"Xã Thanh Bình Thịnh","path":"Xã Thanh Bình Thịnh, Huyện Đức Thọ, Tỉnh Hà Tĩnh","path_with_type":"Xã Thanh Bình Thịnh, Huyện Đức Thọ, Tỉnh Hà Tĩnh","code":"18274","parent_code":"440"},"18277":{"name":"Xã Lâm Trung Thủy","type":"xa","slug":"xa-lam-trung-thuy","name_with_type":"Xã Lâm Trung Thủy","path":"Xã Lâm Trung Thủy, Huyện Đức Thọ, Tỉnh Hà Tĩnh","path_with_type":"Xã Lâm Trung Thủy, Huyện Đức Thọ, Tỉnh Hà Tĩnh","code":"18277","parent_code":"440"},"18280":{"name":"Xã Hòa Lạc","type":"xa","slug":"xa-hoa-lac","name_with_type":"Xã Hòa Lạc","path":"Xã Hòa Lạc, Huyện Đức Thọ, Tỉnh Hà Tĩnh","path_with_type":"Xã Hòa Lạc, Huyện Đức Thọ, Tỉnh Hà Tĩnh","code":"18280","parent_code":"440"},"18283":{"name":"Xã Tân Dân","type":"xa","slug":"xa-tan-dan","name_with_type":"Xã Tân Dân","path":"Xã Tân Dân, Huyện Đức Thọ, Tỉnh Hà Tĩnh","path_with_type":"Xã Tân Dân, Huyện Đức Thọ, Tỉnh Hà Tĩnh","code":"18283","parent_code":"440"},"18298":{"name":"Xã An Dũng","type":"xa","slug":"xa-an-dung","name_with_type":"Xã An Dũng","path":"Xã An Dũng, Huyện Đức Thọ, Tỉnh Hà Tĩnh","path_with_type":"Xã An Dũng, Huyện Đức Thọ, Tỉnh Hà Tĩnh","code":"18298","parent_code":"440"},"18304":{"name":"Xã Đức Đồng","type":"xa","slug":"xa-duc-dong","name_with_type":"Xã Đức Đồng","path":"Xã Đức Đồng, Huyện Đức Thọ, Tỉnh Hà Tĩnh","path_with_type":"Xã Đức Đồng, Huyện Đức Thọ, Tỉnh Hà Tĩnh","code":"18304","parent_code":"440"},"18307":{"name":"Xã Đức Lạng","type":"xa","slug":"xa-duc-lang","name_with_type":"Xã Đức Lạng","path":"Xã Đức Lạng, Huyện Đức Thọ, Tỉnh Hà Tĩnh","path_with_type":"Xã Đức Lạng, Huyện Đức Thọ, Tỉnh Hà Tĩnh","code":"18307","parent_code":"440"},"18310":{"name":"Xã Tân Hương","type":"xa","slug":"xa-tan-huong","name_with_type":"Xã Tân Hương","path":"Xã Tân Hương, Huyện Đức Thọ, Tỉnh Hà Tĩnh","path_with_type":"Xã Tân Hương, Huyện Đức Thọ, Tỉnh Hà Tĩnh","code":"18310","parent_code":"440"},"18313":{"name":"Thị trấn Vũ Quang","type":"thi-tran","slug":"thi-tran-vu-quang","name_with_type":"Thị trấn Vũ Quang","path":"Thị trấn Vũ Quang, Huyện Vũ Quang, Tỉnh Hà Tĩnh","path_with_type":"Thị trấn Vũ Quang, Huyện Vũ Quang, Tỉnh Hà Tĩnh","code":"18313","parent_code":"441"},"18316":{"name":"Xã Ân Phú","type":"xa","slug":"xa-an-phu","name_with_type":"Xã Ân Phú","path":"Xã Ân Phú, Huyện Vũ Quang, Tỉnh Hà Tĩnh","path_with_type":"Xã Ân Phú, Huyện Vũ Quang, Tỉnh Hà Tĩnh","code":"18316","parent_code":"441"},"18319":{"name":"Xã Đức Giang","type":"xa","slug":"xa-duc-giang","name_with_type":"Xã Đức Giang","path":"Xã Đức Giang, Huyện Vũ Quang, Tỉnh Hà Tĩnh","path_with_type":"Xã Đức Giang, Huyện Vũ Quang, Tỉnh Hà Tĩnh","code":"18319","parent_code":"441"},"18322":{"name":"Xã Đức Lĩnh","type":"xa","slug":"xa-duc-linh","name_with_type":"Xã Đức Lĩnh","path":"Xã Đức Lĩnh, Huyện Vũ Quang, Tỉnh Hà Tĩnh","path_with_type":"Xã Đức Lĩnh, Huyện Vũ Quang, Tỉnh Hà Tĩnh","code":"18322","parent_code":"441"},"18325":{"name":"Xã Thọ Điền","type":"xa","slug":"xa-tho-dien","name_with_type":"Xã Thọ Điền","path":"Xã Thọ Điền, Huyện Vũ Quang, Tỉnh Hà Tĩnh","path_with_type":"Xã Thọ Điền, Huyện Vũ Quang, Tỉnh Hà Tĩnh","code":"18325","parent_code":"441"},"18328":{"name":"Xã Đức Hương","type":"xa","slug":"xa-duc-huong","name_with_type":"Xã Đức Hương","path":"Xã Đức Hương, Huyện Vũ Quang, Tỉnh Hà Tĩnh","path_with_type":"Xã Đức Hương, Huyện Vũ Quang, Tỉnh Hà Tĩnh","code":"18328","parent_code":"441"},"18331":{"name":"Xã Đức Bồng","type":"xa","slug":"xa-duc-bong","name_with_type":"Xã Đức Bồng","path":"Xã Đức Bồng, Huyện Vũ Quang, Tỉnh Hà Tĩnh","path_with_type":"Xã Đức Bồng, Huyện Vũ Quang, Tỉnh Hà Tĩnh","code":"18331","parent_code":"441"},"18334":{"name":"Xã Đức Liên","type":"xa","slug":"xa-duc-lien","name_with_type":"Xã Đức Liên","path":"Xã Đức Liên, Huyện Vũ Quang, Tỉnh Hà Tĩnh","path_with_type":"Xã Đức Liên, Huyện Vũ Quang, Tỉnh Hà Tĩnh","code":"18334","parent_code":"441"},"18340":{"name":"Xã Hương Minh","type":"xa","slug":"xa-huong-minh","name_with_type":"Xã Hương Minh","path":"Xã Hương Minh, Huyện Vũ Quang, Tỉnh Hà Tĩnh","path_with_type":"Xã Hương Minh, Huyện Vũ Quang, Tỉnh Hà Tĩnh","code":"18340","parent_code":"441"},"18343":{"name":"Xã Quang Thọ","type":"xa","slug":"xa-quang-tho","name_with_type":"Xã Quang Thọ","path":"Xã Quang Thọ, Huyện Vũ Quang, Tỉnh Hà Tĩnh","path_with_type":"Xã Quang Thọ, Huyện Vũ Quang, Tỉnh Hà Tĩnh","code":"18343","parent_code":"441"},"18352":{"name":"Thị trấn Xuân An","type":"thi-tran","slug":"thi-tran-xuan-an","name_with_type":"Thị trấn Xuân An","path":"Thị trấn Xuân An, Huyện Nghi Xuân, Tỉnh Hà Tĩnh","path_with_type":"Thị trấn Xuân An, Huyện Nghi Xuân, Tỉnh Hà Tĩnh","code":"18352","parent_code":"442"},"18355":{"name":"Xã Xuân Hội","type":"xa","slug":"xa-xuan-hoi","name_with_type":"Xã Xuân Hội","path":"Xã Xuân Hội, Huyện Nghi Xuân, Tỉnh Hà Tĩnh","path_with_type":"Xã Xuân Hội, Huyện Nghi Xuân, Tỉnh Hà Tĩnh","code":"18355","parent_code":"442"},"18358":{"name":"Xã Đan Trường","type":"xa","slug":"xa-dan-truong","name_with_type":"Xã Đan Trường","path":"Xã Đan Trường, Huyện Nghi Xuân, Tỉnh Hà Tĩnh","path_with_type":"Xã Đan Trường, Huyện Nghi Xuân, Tỉnh Hà Tĩnh","code":"18358","parent_code":"442"},"18364":{"name":"Xã Xuân Phổ","type":"xa","slug":"xa-xuan-pho","name_with_type":"Xã Xuân Phổ","path":"Xã Xuân Phổ, Huyện Nghi Xuân, Tỉnh Hà Tĩnh","path_with_type":"Xã Xuân Phổ, Huyện Nghi Xuân, Tỉnh Hà Tĩnh","code":"18364","parent_code":"442"},"18367":{"name":"Xã Xuân Hải","type":"xa","slug":"xa-xuan-hai","name_with_type":"Xã Xuân Hải","path":"Xã Xuân Hải, Huyện Nghi Xuân, Tỉnh Hà Tĩnh","path_with_type":"Xã Xuân Hải, Huyện Nghi Xuân, Tỉnh Hà Tĩnh","code":"18367","parent_code":"442"},"18370":{"name":"Xã Xuân Giang","type":"xa","slug":"xa-xuan-giang","name_with_type":"Xã Xuân Giang","path":"Xã Xuân Giang, Huyện Nghi Xuân, Tỉnh Hà Tĩnh","path_with_type":"Xã Xuân Giang, Huyện Nghi Xuân, Tỉnh Hà Tĩnh","code":"18370","parent_code":"442"},"18373":{"name":"Thị trấn Tiên Điền","type":"thi-tran","slug":"thi-tran-tien-dien","name_with_type":"Thị trấn Tiên Điền","path":"Thị trấn Tiên Điền, Huyện Nghi Xuân, Tỉnh Hà Tĩnh","path_with_type":"Thị trấn Tiên Điền, Huyện Nghi Xuân, Tỉnh Hà Tĩnh","code":"18373","parent_code":"442"},"18376":{"name":"Xã Xuân Yên","type":"xa","slug":"xa-xuan-yen","name_with_type":"Xã Xuân Yên","path":"Xã Xuân Yên, Huyện Nghi Xuân, Tỉnh Hà Tĩnh","path_with_type":"Xã Xuân Yên, Huyện Nghi Xuân, Tỉnh Hà Tĩnh","code":"18376","parent_code":"442"},"18379":{"name":"Xã Xuân Mỹ","type":"xa","slug":"xa-xuan-my","name_with_type":"Xã Xuân Mỹ","path":"Xã Xuân Mỹ, Huyện Nghi Xuân, Tỉnh Hà Tĩnh","path_with_type":"Xã Xuân Mỹ, Huyện Nghi Xuân, Tỉnh Hà Tĩnh","code":"18379","parent_code":"442"},"18382":{"name":"Xã Xuân Thành","type":"xa","slug":"xa-xuan-thanh","name_with_type":"Xã Xuân Thành","path":"Xã Xuân Thành, Huyện Nghi Xuân, Tỉnh Hà Tĩnh","path_with_type":"Xã Xuân Thành, Huyện Nghi Xuân, Tỉnh Hà Tĩnh","code":"18382","parent_code":"442"},"18385":{"name":"Xã Xuân Viên","type":"xa","slug":"xa-xuan-vien","name_with_type":"Xã Xuân Viên","path":"Xã Xuân Viên, Huyện Nghi Xuân, Tỉnh Hà Tĩnh","path_with_type":"Xã Xuân Viên, Huyện Nghi Xuân, Tỉnh Hà Tĩnh","code":"18385","parent_code":"442"},"18388":{"name":"Xã Xuân Hồng","type":"xa","slug":"xa-xuan-hong","name_with_type":"Xã Xuân Hồng","path":"Xã Xuân Hồng, Huyện Nghi Xuân, Tỉnh Hà Tĩnh","path_with_type":"Xã Xuân Hồng, Huyện Nghi Xuân, Tỉnh Hà Tĩnh","code":"18388","parent_code":"442"},"18391":{"name":"Xã Cỗ Đạm","type":"xa","slug":"xa-co-dam","name_with_type":"Xã Cỗ Đạm","path":"Xã Cỗ Đạm, Huyện Nghi Xuân, Tỉnh Hà Tĩnh","path_with_type":"Xã Cỗ Đạm, Huyện Nghi Xuân, Tỉnh Hà Tĩnh","code":"18391","parent_code":"442"},"18394":{"name":"Xã Xuân Liên","type":"xa","slug":"xa-xuan-lien","name_with_type":"Xã Xuân Liên","path":"Xã Xuân Liên, Huyện Nghi Xuân, Tỉnh Hà Tĩnh","path_with_type":"Xã Xuân Liên, Huyện Nghi Xuân, Tỉnh Hà Tĩnh","code":"18394","parent_code":"442"},"18397":{"name":"Xã Xuân Lĩnh","type":"xa","slug":"xa-xuan-linh","name_with_type":"Xã Xuân Lĩnh","path":"Xã Xuân Lĩnh, Huyện Nghi Xuân, Tỉnh Hà Tĩnh","path_with_type":"Xã Xuân Lĩnh, Huyện Nghi Xuân, Tỉnh Hà Tĩnh","code":"18397","parent_code":"442"},"18400":{"name":"Xã Xuân Lam","type":"xa","slug":"xa-xuan-lam","name_with_type":"Xã Xuân Lam","path":"Xã Xuân Lam, Huyện Nghi Xuân, Tỉnh Hà Tĩnh","path_with_type":"Xã Xuân Lam, Huyện Nghi Xuân, Tỉnh Hà Tĩnh","code":"18400","parent_code":"442"},"18403":{"name":"Xã Cương Gián","type":"xa","slug":"xa-cuong-gian","name_with_type":"Xã Cương Gián","path":"Xã Cương Gián, Huyện Nghi Xuân, Tỉnh Hà Tĩnh","path_with_type":"Xã Cương Gián, Huyện Nghi Xuân, Tỉnh Hà Tĩnh","code":"18403","parent_code":"442"},"18406":{"name":"Thị trấn Nghèn","type":"thi-tran","slug":"thi-tran-nghen","name_with_type":"Thị trấn Nghèn","path":"Thị trấn Nghèn, Huyện Can Lộc, Tỉnh Hà Tĩnh","path_with_type":"Thị trấn Nghèn, Huyện Can Lộc, Tỉnh Hà Tĩnh","code":"18406","parent_code":"443"},"18409":{"name":"Xã Tân Lộc","type":"xa","slug":"xa-tan-loc","name_with_type":"Xã Tân Lộc","path":"Xã Tân Lộc, Huyện Thạch Hà, Tỉnh Hà Tĩnh","path_with_type":"Xã Tân Lộc, Huyện Thạch Hà, Tỉnh Hà Tĩnh","code":"18409","parent_code":"445"},"18412":{"name":"Xã Hồng Lộc","type":"xa","slug":"xa-hong-loc","name_with_type":"Xã Hồng Lộc","path":"Xã Hồng Lộc, Huyện Thạch Hà, Tỉnh Hà Tĩnh","path_with_type":"Xã Hồng Lộc, Huyện Thạch Hà, Tỉnh Hà Tĩnh","code":"18412","parent_code":"445"},"18415":{"name":"Xã Thiên Lộc","type":"xa","slug":"xa-thien-loc","name_with_type":"Xã Thiên Lộc","path":"Xã Thiên Lộc, Huyện Can Lộc, Tỉnh Hà Tĩnh","path_with_type":"Xã Thiên Lộc, Huyện Can Lộc, Tỉnh Hà Tĩnh","code":"18415","parent_code":"443"},"18418":{"name":"Xã Thuần Thiện","type":"xa","slug":"xa-thuan-thien","name_with_type":"Xã Thuần Thiện","path":"Xã Thuần Thiện, Huyện Can Lộc, Tỉnh Hà Tĩnh","path_with_type":"Xã Thuần Thiện, Huyện Can Lộc, Tỉnh Hà Tĩnh","code":"18418","parent_code":"443"},"18421":{"name":"Xã Thịnh Lộc","type":"xa","slug":"xa-thinh-loc","name_with_type":"Xã Thịnh Lộc","path":"Xã Thịnh Lộc, Huyện Thạch Hà, Tỉnh Hà Tĩnh","path_with_type":"Xã Thịnh Lộc, Huyện Thạch Hà, Tỉnh Hà Tĩnh","code":"18421","parent_code":"445"},"18427":{"name":"Xã Vượng Lộc","type":"xa","slug":"xa-vuong-loc","name_with_type":"Xã Vượng Lộc","path":"Xã Vượng Lộc, Huyện Can Lộc, Tỉnh Hà Tĩnh","path_with_type":"Xã Vượng Lộc, Huyện Can Lộc, Tỉnh Hà Tĩnh","code":"18427","parent_code":"443"},"18430":{"name":"Xã Bình An","type":"xa","slug":"xa-binh-an","name_with_type":"Xã Bình An","path":"Xã Bình An, Huyện Thạch Hà, Tỉnh Hà Tĩnh","path_with_type":"Xã Bình An, Huyện Thạch Hà, Tỉnh Hà Tĩnh","code":"18430","parent_code":"445"},"18433":{"name":"Xã Thanh Lộc","type":"xa","slug":"xa-thanh-loc","name_with_type":"Xã Thanh Lộc","path":"Xã Thanh Lộc, Huyện Can Lộc, Tỉnh Hà Tĩnh","path_with_type":"Xã Thanh Lộc, Huyện Can Lộc, Tỉnh Hà Tĩnh","code":"18433","parent_code":"443"},"18436":{"name":"Xã Kim Song Trường","type":"xa","slug":"xa-kim-song-truong","name_with_type":"Xã Kim Song Trường","path":"Xã Kim Song Trường, Huyện Can Lộc, Tỉnh Hà Tĩnh","path_with_type":"Xã Kim Song Trường, Huyện Can Lộc, Tỉnh Hà Tĩnh","code":"18436","parent_code":"443"},"18439":{"name":"Xã Thường Nga","type":"xa","slug":"xa-thuong-nga","name_with_type":"Xã Thường Nga","path":"Xã Thường Nga, Huyện Can Lộc, Tỉnh Hà Tĩnh","path_with_type":"Xã Thường Nga, Huyện Can Lộc, Tỉnh Hà Tĩnh","code":"18439","parent_code":"443"},"18445":{"name":"Xã Tùng Lộc","type":"xa","slug":"xa-tung-loc","name_with_type":"Xã Tùng Lộc","path":"Xã Tùng Lộc, Huyện Can Lộc, Tỉnh Hà Tĩnh","path_with_type":"Xã Tùng Lộc, Huyện Can Lộc, Tỉnh Hà Tĩnh","code":"18445","parent_code":"443"},"18448":{"name":"Xã Bình Lộc","type":"xa","slug":"xa-binh-loc","name_with_type":"Xã Bình Lộc","path":"Xã Bình Lộc, Huyện Thạch Hà, Tỉnh Hà Tĩnh","path_with_type":"Xã Bình Lộc, Huyện Thạch Hà, Tỉnh Hà Tĩnh","code":"18448","parent_code":"445"},"18454":{"name":"Xã Phú Lộc","type":"xa","slug":"xa-phu-loc","name_with_type":"Xã Phú Lộc","path":"Xã Phú Lộc, Huyện Can Lộc, Tỉnh Hà Tĩnh","path_with_type":"Xã Phú Lộc, Huyện Can Lộc, Tỉnh Hà Tĩnh","code":"18454","parent_code":"443"},"18457":{"name":"Xã Ích Hậu","type":"xa","slug":"xa-ich-hau","name_with_type":"Xã Ích Hậu","path":"Xã Ích Hậu, Huyện Thạch Hà, Tỉnh Hà Tĩnh","path_with_type":"Xã Ích Hậu, Huyện Thạch Hà, Tỉnh Hà Tĩnh","code":"18457","parent_code":"445"},"18463":{"name":"Xã Gia Hanh","type":"xa","slug":"xa-gia-hanh","name_with_type":"Xã Gia Hanh","path":"Xã Gia Hanh, Huyện Can Lộc, Tỉnh Hà Tĩnh","path_with_type":"Xã Gia Hanh, Huyện Can Lộc, Tỉnh Hà Tĩnh","code":"18463","parent_code":"443"},"18466":{"name":"Xã Khánh Vĩnh Yên","type":"xa","slug":"xa-khanh-vinh-yen","name_with_type":"Xã Khánh Vĩnh Yên","path":"Xã Khánh Vĩnh Yên, Huyện Can Lộc, Tỉnh Hà Tĩnh","path_with_type":"Xã Khánh Vĩnh Yên, Huyện Can Lộc, Tỉnh Hà Tĩnh","code":"18466","parent_code":"443"},"18475":{"name":"Xã Xuân Lộc","type":"xa","slug":"xa-xuan-loc","name_with_type":"Xã Xuân Lộc","path":"Xã Xuân Lộc, Huyện Can Lộc, Tỉnh Hà Tĩnh","path_with_type":"Xã Xuân Lộc, Huyện Can Lộc, Tỉnh Hà Tĩnh","code":"18475","parent_code":"443"},"18478":{"name":"Xã Thượng Lộc","type":"xa","slug":"xa-thuong-loc","name_with_type":"Xã Thượng Lộc","path":"Xã Thượng Lộc, Huyện Can Lộc, Tỉnh Hà Tĩnh","path_with_type":"Xã Thượng Lộc, Huyện Can Lộc, Tỉnh Hà Tĩnh","code":"18478","parent_code":"443"},"18481":{"name":"Xã Quang Lộc","type":"xa","slug":"xa-quang-loc","name_with_type":"Xã Quang Lộc","path":"Xã Quang Lộc, Huyện Can Lộc, Tỉnh Hà Tĩnh","path_with_type":"Xã Quang Lộc, Huyện Can Lộc, Tỉnh Hà Tĩnh","code":"18481","parent_code":"443"},"18484":{"name":"Thị trấn Đồng Lộc","type":"thi-tran","slug":"thi-tran-dong-loc","name_with_type":"Thị trấn Đồng Lộc","path":"Thị trấn Đồng Lộc, Huyện Can Lộc, Tỉnh Hà Tĩnh","path_with_type":"Thị trấn Đồng Lộc, Huyện Can Lộc, Tỉnh Hà Tĩnh","code":"18484","parent_code":"443"},"18487":{"name":"Xã Mỹ Lộc","type":"xa","slug":"xa-my-loc","name_with_type":"Xã Mỹ Lộc","path":"Xã Mỹ Lộc, Huyện Can Lộc, Tỉnh Hà Tĩnh","path_with_type":"Xã Mỹ Lộc, Huyện Can Lộc, Tỉnh Hà Tĩnh","code":"18487","parent_code":"443"},"18490":{"name":"Xã Sơn Lộc","type":"xa","slug":"xa-son-loc","name_with_type":"Xã Sơn Lộc","path":"Xã Sơn Lộc, Huyện Can Lộc, Tỉnh Hà Tĩnh","path_with_type":"Xã Sơn Lộc, Huyện Can Lộc, Tỉnh Hà Tĩnh","code":"18490","parent_code":"443"},"18493":{"name":"Xã Phù Lưu","type":"xa","slug":"xa-phu-luu","name_with_type":"Xã Phù Lưu","path":"Xã Phù Lưu, Huyện Thạch Hà, Tỉnh Hà Tĩnh","path_with_type":"Xã Phù Lưu, Huyện Thạch Hà, Tỉnh Hà Tĩnh","code":"18493","parent_code":"445"},"18496":{"name":"Thị trấn Hương Khê","type":"thi-tran","slug":"thi-tran-huong-khe","name_with_type":"Thị trấn Hương Khê","path":"Thị trấn Hương Khê, Huyện Hương Khê, Tỉnh Hà Tĩnh","path_with_type":"Thị trấn Hương Khê, Huyện Hương Khê, Tỉnh Hà Tĩnh","code":"18496","parent_code":"444"},"18499":{"name":"Xã Điền Mỹ","type":"xa","slug":"xa-dien-my","name_with_type":"Xã Điền Mỹ","path":"Xã Điền Mỹ, Huyện Hương Khê, Tỉnh Hà Tĩnh","path_with_type":"Xã Điền Mỹ, Huyện Hương Khê, Tỉnh Hà Tĩnh","code":"18499","parent_code":"444"},"18502":{"name":"Xã Hà Linh","type":"xa","slug":"xa-ha-linh","name_with_type":"Xã Hà Linh","path":"Xã Hà Linh, Huyện Hương Khê, Tỉnh Hà Tĩnh","path_with_type":"Xã Hà Linh, Huyện Hương Khê, Tỉnh Hà Tĩnh","code":"18502","parent_code":"444"},"18505":{"name":"Xã Hương Thủy","type":"xa","slug":"xa-huong-thuy","name_with_type":"Xã Hương Thủy","path":"Xã Hương Thủy, Huyện Hương Khê, Tỉnh Hà Tĩnh","path_with_type":"Xã Hương Thủy, Huyện Hương Khê, Tỉnh Hà Tĩnh","code":"18505","parent_code":"444"},"18508":{"name":"Xã Hòa Hải","type":"xa","slug":"xa-hoa-hai","name_with_type":"Xã Hòa Hải","path":"Xã Hòa Hải, Huyện Hương Khê, Tỉnh Hà Tĩnh","path_with_type":"Xã Hòa Hải, Huyện Hương Khê, Tỉnh Hà Tĩnh","code":"18508","parent_code":"444"},"18514":{"name":"Xã Phúc Đồng","type":"xa","slug":"xa-phuc-dong","name_with_type":"Xã Phúc Đồng","path":"Xã Phúc Đồng, Huyện Hương Khê, Tỉnh Hà Tĩnh","path_with_type":"Xã Phúc Đồng, Huyện Hương Khê, Tỉnh Hà Tĩnh","code":"18514","parent_code":"444"},"18517":{"name":"Xã Hương Giang","type":"xa","slug":"xa-huong-giang","name_with_type":"Xã Hương Giang","path":"Xã Hương Giang, Huyện Hương Khê, Tỉnh Hà Tĩnh","path_with_type":"Xã Hương Giang, Huyện Hương Khê, Tỉnh Hà Tĩnh","code":"18517","parent_code":"444"},"18520":{"name":"Xã Lộc Yên","type":"xa","slug":"xa-loc-yen","name_with_type":"Xã Lộc Yên","path":"Xã Lộc Yên, Huyện Hương Khê, Tỉnh Hà Tĩnh","path_with_type":"Xã Lộc Yên, Huyện Hương Khê, Tỉnh Hà Tĩnh","code":"18520","parent_code":"444"},"18523":{"name":"Xã Hương Bình","type":"xa","slug":"xa-huong-binh","name_with_type":"Xã Hương Bình","path":"Xã Hương Bình, Huyện Hương Khê, Tỉnh Hà Tĩnh","path_with_type":"Xã Hương Bình, Huyện Hương Khê, Tỉnh Hà Tĩnh","code":"18523","parent_code":"444"},"18526":{"name":"Xã Hương Long","type":"xa","slug":"xa-huong-long","name_with_type":"Xã Hương Long","path":"Xã Hương Long, Huyện Hương Khê, Tỉnh Hà Tĩnh","path_with_type":"Xã Hương Long, Huyện Hương Khê, Tỉnh Hà Tĩnh","code":"18526","parent_code":"444"},"18529":{"name":"Xã Phú Gia","type":"xa","slug":"xa-phu-gia","name_with_type":"Xã Phú Gia","path":"Xã Phú Gia, Huyện Hương Khê, Tỉnh Hà Tĩnh","path_with_type":"Xã Phú Gia, Huyện Hương Khê, Tỉnh Hà Tĩnh","code":"18529","parent_code":"444"},"18532":{"name":"Xã Gia Phố","type":"xa","slug":"xa-gia-pho","name_with_type":"Xã Gia Phố","path":"Xã Gia Phố, Huyện Hương Khê, Tỉnh Hà Tĩnh","path_with_type":"Xã Gia Phố, Huyện Hương Khê, Tỉnh Hà Tĩnh","code":"18532","parent_code":"444"},"18538":{"name":"Xã Hương Đô","type":"xa","slug":"xa-huong-do","name_with_type":"Xã Hương Đô","path":"Xã Hương Đô, Huyện Hương Khê, Tỉnh Hà Tĩnh","path_with_type":"Xã Hương Đô, Huyện Hương Khê, Tỉnh Hà Tĩnh","code":"18538","parent_code":"444"},"18541":{"name":"Xã Hương Vĩnh","type":"xa","slug":"xa-huong-vinh","name_with_type":"Xã Hương Vĩnh","path":"Xã Hương Vĩnh, Huyện Hương Khê, Tỉnh Hà Tĩnh","path_with_type":"Xã Hương Vĩnh, Huyện Hương Khê, Tỉnh Hà Tĩnh","code":"18541","parent_code":"444"},"18544":{"name":"Xã Hương Xuân","type":"xa","slug":"xa-huong-xuan","name_with_type":"Xã Hương Xuân","path":"Xã Hương Xuân, Huyện Hương Khê, Tỉnh Hà Tĩnh","path_with_type":"Xã Hương Xuân, Huyện Hương Khê, Tỉnh Hà Tĩnh","code":"18544","parent_code":"444"},"18547":{"name":"Xã Phúc Trạch","type":"xa","slug":"xa-phuc-trach","name_with_type":"Xã Phúc Trạch","path":"Xã Phúc Trạch, Huyện Hương Khê, Tỉnh Hà Tĩnh","path_with_type":"Xã Phúc Trạch, Huyện Hương Khê, Tỉnh Hà Tĩnh","code":"18547","parent_code":"444"},"18550":{"name":"Xã Hương Trà","type":"xa","slug":"xa-huong-tra","name_with_type":"Xã Hương Trà","path":"Xã Hương Trà, Huyện Hương Khê, Tỉnh Hà Tĩnh","path_with_type":"Xã Hương Trà, Huyện Hương Khê, Tỉnh Hà Tĩnh","code":"18550","parent_code":"444"},"18553":{"name":"Xã Hương Trạch","type":"xa","slug":"xa-huong-trach","name_with_type":"Xã Hương Trạch","path":"Xã Hương Trạch, Huyện Hương Khê, Tỉnh Hà Tĩnh","path_with_type":"Xã Hương Trạch, Huyện Hương Khê, Tỉnh Hà Tĩnh","code":"18553","parent_code":"444"},"18556":{"name":"Xã Hương Lâm","type":"xa","slug":"xa-huong-lam","name_with_type":"Xã Hương Lâm","path":"Xã Hương Lâm, Huyện Hương Khê, Tỉnh Hà Tĩnh","path_with_type":"Xã Hương Lâm, Huyện Hương Khê, Tỉnh Hà Tĩnh","code":"18556","parent_code":"444"},"18559":{"name":"Xã Hương Liên","type":"xa","slug":"xa-huong-lien","name_with_type":"Xã Hương Liên","path":"Xã Hương Liên, Huyện Hương Khê, Tỉnh Hà Tĩnh","path_with_type":"Xã Hương Liên, Huyện Hương Khê, Tỉnh Hà Tĩnh","code":"18559","parent_code":"444"},"18562":{"name":"Thị trấn Thạch Hà","type":"thi-tran","slug":"thi-tran-thach-ha","name_with_type":"Thị trấn Thạch Hà","path":"Thị trấn Thạch Hà, Huyện Thạch Hà, Tỉnh Hà Tĩnh","path_with_type":"Thị trấn Thạch Hà, Huyện Thạch Hà, Tỉnh Hà Tĩnh","code":"18562","parent_code":"445"},"18565":{"name":"Xã Ngọc Sơn","type":"xa","slug":"xa-ngoc-son","name_with_type":"Xã Ngọc Sơn","path":"Xã Ngọc Sơn, Huyện Thạch Hà, Tỉnh Hà Tĩnh","path_with_type":"Xã Ngọc Sơn, Huyện Thạch Hà, Tỉnh Hà Tĩnh","code":"18565","parent_code":"445"},"18568":{"name":"Thị trấn Lộc Hà","type":"thi-tran","slug":"thi-tran-loc-ha","name_with_type":"Thị trấn Lộc Hà","path":"Thị trấn Lộc Hà, Huyện Thạch Hà, Tỉnh Hà Tĩnh","path_with_type":"Thị trấn Lộc Hà, Huyện Thạch Hà, Tỉnh Hà Tĩnh","code":"18568","parent_code":"445"},"18571":{"name":"Xã Thạch Hải","type":"xa","slug":"xa-thach-hai","name_with_type":"Xã Thạch Hải","path":"Xã Thạch Hải, Thành phố Hà Tĩnh, Tỉnh Hà Tĩnh","path_with_type":"Xã Thạch Hải, Thành phố Hà Tĩnh, Tỉnh Hà Tĩnh","code":"18571","parent_code":"436"},"18577":{"name":"Xã Thạch Mỹ","type":"xa","slug":"xa-thach-my","name_with_type":"Xã Thạch Mỹ","path":"Xã Thạch Mỹ, Huyện Thạch Hà, Tỉnh Hà Tĩnh","path_with_type":"Xã Thạch Mỹ, Huyện Thạch Hà, Tỉnh Hà Tĩnh","code":"18577","parent_code":"445"},"18580":{"name":"Xã Thạch Kim","type":"xa","slug":"xa-thach-kim","name_with_type":"Xã Thạch Kim","path":"Xã Thạch Kim, Huyện Thạch Hà, Tỉnh Hà Tĩnh","path_with_type":"Xã Thạch Kim, Huyện Thạch Hà, Tỉnh Hà Tĩnh","code":"18580","parent_code":"445"},"18583":{"name":"Xã Thạch Châu","type":"xa","slug":"xa-thach-chau","name_with_type":"Xã Thạch Châu","path":"Xã Thạch Châu, Huyện Thạch Hà, Tỉnh Hà Tĩnh","path_with_type":"Xã Thạch Châu, Huyện Thạch Hà, Tỉnh Hà Tĩnh","code":"18583","parent_code":"445"},"18586":{"name":"Xã Thạch Kênh","type":"xa","slug":"xa-thach-kenh","name_with_type":"Xã Thạch Kênh","path":"Xã Thạch Kênh, Huyện Thạch Hà, Tỉnh Hà Tĩnh","path_with_type":"Xã Thạch Kênh, Huyện Thạch Hà, Tỉnh Hà Tĩnh","code":"18586","parent_code":"445"},"18589":{"name":"Xã Thạch Sơn","type":"xa","slug":"xa-thach-son","name_with_type":"Xã Thạch Sơn","path":"Xã Thạch Sơn, Huyện Thạch Hà, Tỉnh Hà Tĩnh","path_with_type":"Xã Thạch Sơn, Huyện Thạch Hà, Tỉnh Hà Tĩnh","code":"18589","parent_code":"445"},"18592":{"name":"Xã Thạch Liên","type":"xa","slug":"xa-thach-lien","name_with_type":"Xã Thạch Liên","path":"Xã Thạch Liên, Huyện Thạch Hà, Tỉnh Hà Tĩnh","path_with_type":"Xã Thạch Liên, Huyện Thạch Hà, Tỉnh Hà Tĩnh","code":"18592","parent_code":"445"},"18595":{"name":"Xã Đỉnh Bàn","type":"xa","slug":"xa-dinh-ban","name_with_type":"Xã Đỉnh Bàn","path":"Xã Đỉnh Bàn, Thành phố Hà Tĩnh, Tỉnh Hà Tĩnh","path_with_type":"Xã Đỉnh Bàn, Thành phố Hà Tĩnh, Tỉnh Hà Tĩnh","code":"18595","parent_code":"436"},"18598":{"name":"Xã Hộ Độ","type":"xa","slug":"xa-ho-do","name_with_type":"Xã Hộ Độ","path":"Xã Hộ Độ, Thành phố Hà Tĩnh, Tỉnh Hà Tĩnh","path_with_type":"Xã Hộ Độ, Thành phố Hà Tĩnh, Tỉnh Hà Tĩnh","code":"18598","parent_code":"436"},"18601":{"name":"Xã Việt Tiến","type":"xa","slug":"xa-viet-tien","name_with_type":"Xã Việt Tiến","path":"Xã Việt Tiến, Huyện Thạch Hà, Tỉnh Hà Tĩnh","path_with_type":"Xã Việt Tiến, Huyện Thạch Hà, Tỉnh Hà Tĩnh","code":"18601","parent_code":"445"},"18604":{"name":"Xã Thạch Khê","type":"xa","slug":"xa-thach-khe","name_with_type":"Xã Thạch Khê","path":"Xã Thạch Khê, Thành phố Hà Tĩnh, Tỉnh Hà Tĩnh","path_with_type":"Xã Thạch Khê, Thành phố Hà Tĩnh, Tỉnh Hà Tĩnh","code":"18604","parent_code":"436"},"18607":{"name":"Xã Thạch Long","type":"xa","slug":"xa-thach-long","name_with_type":"Xã Thạch Long","path":"Xã Thạch Long, Huyện Thạch Hà, Tỉnh Hà Tĩnh","path_with_type":"Xã Thạch Long, Huyện Thạch Hà, Tỉnh Hà Tĩnh","code":"18607","parent_code":"445"},"18619":{"name":"Xã Thạch Trị","type":"xa","slug":"xa-thach-tri","name_with_type":"Xã Thạch Trị","path":"Xã Thạch Trị, Thành phố Hà Tĩnh, Tỉnh Hà Tĩnh","path_with_type":"Xã Thạch Trị, Thành phố Hà Tĩnh, Tỉnh Hà Tĩnh","code":"18619","parent_code":"436"},"18622":{"name":"Xã Thạch Lạc","type":"xa","slug":"xa-thach-lac","name_with_type":"Xã Thạch Lạc","path":"Xã Thạch Lạc, Thành phố Hà Tĩnh, Tỉnh Hà Tĩnh","path_with_type":"Xã Thạch Lạc, Thành phố Hà Tĩnh, Tỉnh Hà Tĩnh","code":"18622","parent_code":"436"},"18625":{"name":"Xã Thạch Ngọc","type":"xa","slug":"xa-thach-ngoc","name_with_type":"Xã Thạch Ngọc","path":"Xã Thạch Ngọc, Huyện Thạch Hà, Tỉnh Hà Tĩnh","path_with_type":"Xã Thạch Ngọc, Huyện Thạch Hà, Tỉnh Hà Tĩnh","code":"18625","parent_code":"445"},"18628":{"name":"Xã Tượng Sơn","type":"xa","slug":"xa-tuong-son","name_with_type":"Xã Tượng Sơn","path":"Xã Tượng Sơn, Thành phố Hà Tĩnh, Tỉnh Hà Tĩnh","path_with_type":"Xã Tượng Sơn, Thành phố Hà Tĩnh, Tỉnh Hà Tĩnh","code":"18628","parent_code":"436"},"18631":{"name":"Xã Thạch Văn","type":"xa","slug":"xa-thach-van","name_with_type":"Xã Thạch Văn","path":"Xã Thạch Văn, Thành phố Hà Tĩnh, Tỉnh Hà Tĩnh","path_with_type":"Xã Thạch Văn, Thành phố Hà Tĩnh, Tỉnh Hà Tĩnh","code":"18631","parent_code":"436"},"18634":{"name":"Xã Lưu Vĩnh Sơn","type":"xa","slug":"xa-luu-vinh-son","name_with_type":"Xã Lưu Vĩnh Sơn","path":"Xã Lưu Vĩnh Sơn, Huyện Thạch Hà, Tỉnh Hà Tĩnh","path_with_type":"Xã Lưu Vĩnh Sơn, Huyện Thạch Hà, Tỉnh Hà Tĩnh","code":"18634","parent_code":"445"},"18637":{"name":"Xã Thạch Thắng","type":"xa","slug":"xa-thach-thang","name_with_type":"Xã Thạch Thắng","path":"Xã Thạch Thắng, Thành phố Hà Tĩnh, Tỉnh Hà Tĩnh","path_with_type":"Xã Thạch Thắng, Thành phố Hà Tĩnh, Tỉnh Hà Tĩnh","code":"18637","parent_code":"436"},"18643":{"name":"Xã Thạch Đài","type":"xa","slug":"xa-thach-dai","name_with_type":"Xã Thạch Đài","path":"Xã Thạch Đài, Thành phố Hà Tĩnh, Tỉnh Hà Tĩnh","path_with_type":"Xã Thạch Đài, Thành phố Hà Tĩnh, Tỉnh Hà Tĩnh","code":"18643","parent_code":"436"},"18649":{"name":"Xã Thạch Hội","type":"xa","slug":"xa-thach-hoi","name_with_type":"Xã Thạch Hội","path":"Xã Thạch Hội, Thành phố Hà Tĩnh, Tỉnh Hà Tĩnh","path_with_type":"Xã Thạch Hội, Thành phố Hà Tĩnh, Tỉnh Hà Tĩnh","code":"18649","parent_code":"436"},"18652":{"name":"Xã Tân Lâm Hương","type":"xa","slug":"xa-tan-lam-huong","name_with_type":"Xã Tân Lâm Hương","path":"Xã Tân Lâm Hương, Thành phố Hà Tĩnh, Tỉnh Hà Tĩnh","path_with_type":"Xã Tân Lâm Hương, Thành phố Hà Tĩnh, Tỉnh Hà Tĩnh","code":"18652","parent_code":"436"},"18658":{"name":"Xã Thạch Xuân","type":"xa","slug":"xa-thach-xuan","name_with_type":"Xã Thạch Xuân","path":"Xã Thạch Xuân, Huyện Thạch Hà, Tỉnh Hà Tĩnh","path_with_type":"Xã Thạch Xuân, Huyện Thạch Hà, Tỉnh Hà Tĩnh","code":"18658","parent_code":"445"},"18667":{"name":"Xã Nam Điền","type":"xa","slug":"xa-nam-dien","name_with_type":"Xã Nam Điền","path":"Xã Nam Điền, Huyện Thạch Hà, Tỉnh Hà Tĩnh","path_with_type":"Xã Nam Điền, Huyện Thạch Hà, Tỉnh Hà Tĩnh","code":"18667","parent_code":"445"},"18670":{"name":"Xã Mai Phụ","type":"xa","slug":"xa-mai-phu","name_with_type":"Xã Mai Phụ","path":"Xã Mai Phụ, Huyện Thạch Hà, Tỉnh Hà Tĩnh","path_with_type":"Xã Mai Phụ, Huyện Thạch Hà, Tỉnh Hà Tĩnh","code":"18670","parent_code":"445"},"18673":{"name":"Thị trấn Cẩm Xuyên","type":"thi-tran","slug":"thi-tran-cam-xuyen","name_with_type":"Thị trấn Cẩm Xuyên","path":"Thị trấn Cẩm Xuyên, Huyện Cẩm Xuyên, Tỉnh Hà Tĩnh","path_with_type":"Thị trấn Cẩm Xuyên, Huyện Cẩm Xuyên, Tỉnh Hà Tĩnh","code":"18673","parent_code":"446"},"18676":{"name":"Thị trấn Thiên Cầm","type":"thi-tran","slug":"thi-tran-thien-cam","name_with_type":"Thị trấn Thiên Cầm","path":"Thị trấn Thiên Cầm, Huyện Cẩm Xuyên, Tỉnh Hà Tĩnh","path_with_type":"Thị trấn Thiên Cầm, Huyện Cẩm Xuyên, Tỉnh Hà Tĩnh","code":"18676","parent_code":"446"},"18679":{"name":"Xã Yên Hòa","type":"xa","slug":"xa-yen-hoa","name_with_type":"Xã Yên Hòa","path":"Xã Yên Hòa, Huyện Cẩm Xuyên, Tỉnh Hà Tĩnh","path_with_type":"Xã Yên Hòa, Huyện Cẩm Xuyên, Tỉnh Hà Tĩnh","code":"18679","parent_code":"446"},"18682":{"name":"Xã Cẩm Dương","type":"xa","slug":"xa-cam-duong","name_with_type":"Xã Cẩm Dương","path":"Xã Cẩm Dương, Huyện Cẩm Xuyên, Tỉnh Hà Tĩnh","path_with_type":"Xã Cẩm Dương, Huyện Cẩm Xuyên, Tỉnh Hà Tĩnh","code":"18682","parent_code":"446"},"18685":{"name":"Xã Cẩm Bình","type":"xa","slug":"xa-cam-binh","name_with_type":"Xã Cẩm Bình","path":"Xã Cẩm Bình, Thành phố Hà Tĩnh, Tỉnh Hà Tĩnh","path_with_type":"Xã Cẩm Bình, Thành phố Hà Tĩnh, Tỉnh Hà Tĩnh","code":"18685","parent_code":"436"},"18691":{"name":"Xã Cẩm Vịnh","type":"xa","slug":"xa-cam-vinh","name_with_type":"Xã Cẩm Vịnh","path":"Xã Cẩm Vịnh, Thành phố Hà Tĩnh, Tỉnh Hà Tĩnh","path_with_type":"Xã Cẩm Vịnh, Thành phố Hà Tĩnh, Tỉnh Hà Tĩnh","code":"18691","parent_code":"436"},"18694":{"name":"Xã Cẩm Thành","type":"xa","slug":"xa-cam-thanh","name_with_type":"Xã Cẩm Thành","path":"Xã Cẩm Thành, Huyện Cẩm Xuyên, Tỉnh Hà Tĩnh","path_with_type":"Xã Cẩm Thành, Huyện Cẩm Xuyên, Tỉnh Hà Tĩnh","code":"18694","parent_code":"446"},"18697":{"name":"Xã Cẩm Quang","type":"xa","slug":"xa-cam-quang","name_with_type":"Xã Cẩm Quang","path":"Xã Cẩm Quang, Huyện Cẩm Xuyên, Tỉnh Hà Tĩnh","path_with_type":"Xã Cẩm Quang, Huyện Cẩm Xuyên, Tỉnh Hà Tĩnh","code":"18697","parent_code":"446"},"18706":{"name":"Xã Cẩm Thạch","type":"xa","slug":"xa-cam-thach","name_with_type":"Xã Cẩm Thạch","path":"Xã Cẩm Thạch, Huyện Cẩm Xuyên, Tỉnh Hà Tĩnh","path_with_type":"Xã Cẩm Thạch, Huyện Cẩm Xuyên, Tỉnh Hà Tĩnh","code":"18706","parent_code":"446"},"18709":{"name":"Xã Cẩm Nhượng","type":"xa","slug":"xa-cam-nhuong","name_with_type":"Xã Cẩm Nhượng","path":"Xã Cẩm Nhượng, Huyện Cẩm Xuyên, Tỉnh Hà Tĩnh","path_with_type":"Xã Cẩm Nhượng, Huyện Cẩm Xuyên, Tỉnh Hà Tĩnh","code":"18709","parent_code":"446"},"18712":{"name":"Xã Nam Phúc Thăng","type":"xa","slug":"xa-nam-phuc-thang","name_with_type":"Xã Nam Phúc Thăng","path":"Xã Nam Phúc Thăng, Huyện Cẩm Xuyên, Tỉnh Hà Tĩnh","path_with_type":"Xã Nam Phúc Thăng, Huyện Cẩm Xuyên, Tỉnh Hà Tĩnh","code":"18712","parent_code":"446"},"18715":{"name":"Xã Cẩm Duệ","type":"xa","slug":"xa-cam-due","name_with_type":"Xã Cẩm Duệ","path":"Xã Cẩm Duệ, Huyện Cẩm Xuyên, Tỉnh Hà Tĩnh","path_with_type":"Xã Cẩm Duệ, Huyện Cẩm Xuyên, Tỉnh Hà Tĩnh","code":"18715","parent_code":"446"},"18721":{"name":"Xã Cẩm Lĩnh","type":"xa","slug":"xa-cam-linh","name_with_type":"Xã Cẩm Lĩnh","path":"Xã Cẩm Lĩnh, Huyện Cẩm Xuyên, Tỉnh Hà Tĩnh","path_with_type":"Xã Cẩm Lĩnh, Huyện Cẩm Xuyên, Tỉnh Hà Tĩnh","code":"18721","parent_code":"446"},"18724":{"name":"Xã Cẩm Quan","type":"xa","slug":"xa-cam-quan","name_with_type":"Xã Cẩm Quan","path":"Xã Cẩm Quan, Huyện Cẩm Xuyên, Tỉnh Hà Tĩnh","path_with_type":"Xã Cẩm Quan, Huyện Cẩm Xuyên, Tỉnh Hà Tĩnh","code":"18724","parent_code":"446"},"18727":{"name":"Xã Cẩm Hà","type":"xa","slug":"xa-cam-ha","name_with_type":"Xã Cẩm Hà","path":"Xã Cẩm Hà, Huyện Cẩm Xuyên, Tỉnh Hà Tĩnh","path_with_type":"Xã Cẩm Hà, Huyện Cẩm Xuyên, Tỉnh Hà Tĩnh","code":"18727","parent_code":"446"},"18730":{"name":"Xã Cẩm Lộc","type":"xa","slug":"xa-cam-loc","name_with_type":"Xã Cẩm Lộc","path":"Xã Cẩm Lộc, Huyện Cẩm Xuyên, Tỉnh Hà Tĩnh","path_with_type":"Xã Cẩm Lộc, Huyện Cẩm Xuyên, Tỉnh Hà Tĩnh","code":"18730","parent_code":"446"},"18733":{"name":"Xã Cẩm Hưng","type":"xa","slug":"xa-cam-hung","name_with_type":"Xã Cẩm Hưng","path":"Xã Cẩm Hưng, Huyện Cẩm Xuyên, Tỉnh Hà Tĩnh","path_with_type":"Xã Cẩm Hưng, Huyện Cẩm Xuyên, Tỉnh Hà Tĩnh","code":"18733","parent_code":"446"},"18736":{"name":"Xã Cẩm Thịnh","type":"xa","slug":"xa-cam-thinh","name_with_type":"Xã Cẩm Thịnh","path":"Xã Cẩm Thịnh, Huyện Cẩm Xuyên, Tỉnh Hà Tĩnh","path_with_type":"Xã Cẩm Thịnh, Huyện Cẩm Xuyên, Tỉnh Hà Tĩnh","code":"18736","parent_code":"446"},"18739":{"name":"Xã Cẩm Mỹ","type":"xa","slug":"xa-cam-my","name_with_type":"Xã Cẩm Mỹ","path":"Xã Cẩm Mỹ, Huyện Cẩm Xuyên, Tỉnh Hà Tĩnh","path_with_type":"Xã Cẩm Mỹ, Huyện Cẩm Xuyên, Tỉnh Hà Tĩnh","code":"18739","parent_code":"446"},"18742":{"name":"Xã Cẩm Trung","type":"xa","slug":"xa-cam-trung","name_with_type":"Xã Cẩm Trung","path":"Xã Cẩm Trung, Huyện Cẩm Xuyên, Tỉnh Hà Tĩnh","path_with_type":"Xã Cẩm Trung, Huyện Cẩm Xuyên, Tỉnh Hà Tĩnh","code":"18742","parent_code":"446"},"18745":{"name":"Xã Cẩm Sơn","type":"xa","slug":"xa-cam-son","name_with_type":"Xã Cẩm Sơn","path":"Xã Cẩm Sơn, Huyện Cẩm Xuyên, Tỉnh Hà Tĩnh","path_with_type":"Xã Cẩm Sơn, Huyện Cẩm Xuyên, Tỉnh Hà Tĩnh","code":"18745","parent_code":"446"},"18748":{"name":"Xã Cẩm Lạc","type":"xa","slug":"xa-cam-lac","name_with_type":"Xã Cẩm Lạc","path":"Xã Cẩm Lạc, Huyện Cẩm Xuyên, Tỉnh Hà Tĩnh","path_with_type":"Xã Cẩm Lạc, Huyện Cẩm Xuyên, Tỉnh Hà Tĩnh","code":"18748","parent_code":"446"},"18751":{"name":"Xã Cẩm Minh","type":"xa","slug":"xa-cam-minh","name_with_type":"Xã Cẩm Minh","path":"Xã Cẩm Minh, Huyện Cẩm Xuyên, Tỉnh Hà Tĩnh","path_with_type":"Xã Cẩm Minh, Huyện Cẩm Xuyên, Tỉnh Hà Tĩnh","code":"18751","parent_code":"446"},"18754":{"name":"Phường Hưng Trí","type":"phuong","slug":"phuong-hung-tri","name_with_type":"Phường Hưng Trí","path":"Phường Hưng Trí, Thị xã Kỳ Anh, Tỉnh Hà Tĩnh","path_with_type":"Phường Hưng Trí, Thị xã Kỳ Anh, Tỉnh Hà Tĩnh","code":"18754","parent_code":"449"},"18757":{"name":"Xã Kỳ Xuân","type":"xa","slug":"xa-ky-xuan","name_with_type":"Xã Kỳ Xuân","path":"Xã Kỳ Xuân, Huyện Kỳ Anh, Tỉnh Hà Tĩnh","path_with_type":"Xã Kỳ Xuân, Huyện Kỳ Anh, Tỉnh Hà Tĩnh","code":"18757","parent_code":"447"},"18760":{"name":"Xã Kỳ Bắc","type":"xa","slug":"xa-ky-bac","name_with_type":"Xã Kỳ Bắc","path":"Xã Kỳ Bắc, Huyện Kỳ Anh, Tỉnh Hà Tĩnh","path_with_type":"Xã Kỳ Bắc, Huyện Kỳ Anh, Tỉnh Hà Tĩnh","code":"18760","parent_code":"447"},"18763":{"name":"Xã Kỳ Phú","type":"xa","slug":"xa-ky-phu","name_with_type":"Xã Kỳ Phú","path":"Xã Kỳ Phú, Huyện Kỳ Anh, Tỉnh Hà Tĩnh","path_with_type":"Xã Kỳ Phú, Huyện Kỳ Anh, Tỉnh Hà Tĩnh","code":"18763","parent_code":"447"},"18766":{"name":"Xã Kỳ Phong","type":"xa","slug":"xa-ky-phong","name_with_type":"Xã Kỳ Phong","path":"Xã Kỳ Phong, Huyện Kỳ Anh, Tỉnh Hà Tĩnh","path_with_type":"Xã Kỳ Phong, Huyện Kỳ Anh, Tỉnh Hà Tĩnh","code":"18766","parent_code":"447"},"18769":{"name":"Xã Kỳ Tiến","type":"xa","slug":"xa-ky-tien","name_with_type":"Xã Kỳ Tiến","path":"Xã Kỳ Tiến, Huyện Kỳ Anh, Tỉnh Hà Tĩnh","path_with_type":"Xã Kỳ Tiến, Huyện Kỳ Anh, Tỉnh Hà Tĩnh","code":"18769","parent_code":"447"},"18772":{"name":"Xã Kỳ Giang","type":"xa","slug":"xa-ky-giang","name_with_type":"Xã Kỳ Giang","path":"Xã Kỳ Giang, Huyện Kỳ Anh, Tỉnh Hà Tĩnh","path_with_type":"Xã Kỳ Giang, Huyện Kỳ Anh, Tỉnh Hà Tĩnh","code":"18772","parent_code":"447"},"18775":{"name":"Thị trấn Kỳ Đồng","type":"thi-tran","slug":"thi-tran-ky-dong","name_with_type":"Thị trấn Kỳ Đồng","path":"Thị trấn Kỳ Đồng, Huyện Kỳ Anh, Tỉnh Hà Tĩnh","path_with_type":"Thị trấn Kỳ Đồng, Huyện Kỳ Anh, Tỉnh Hà Tĩnh","code":"18775","parent_code":"447"},"18778":{"name":"Xã Kỳ Khang","type":"xa","slug":"xa-ky-khang","name_with_type":"Xã Kỳ Khang","path":"Xã Kỳ Khang, Huyện Kỳ Anh, Tỉnh Hà Tĩnh","path_with_type":"Xã Kỳ Khang, Huyện Kỳ Anh, Tỉnh Hà Tĩnh","code":"18778","parent_code":"447"},"18781":{"name":"Phường Kỳ Ninh","type":"phuong","slug":"phuong-ky-ninh","name_with_type":"Phường Kỳ Ninh","path":"Phường Kỳ Ninh, Thị xã Kỳ Anh, Tỉnh Hà Tĩnh","path_with_type":"Phường Kỳ Ninh, Thị xã Kỳ Anh, Tỉnh Hà Tĩnh","code":"18781","parent_code":"449"},"18784":{"name":"Xã Kỳ Văn","type":"xa","slug":"xa-ky-van","name_with_type":"Xã Kỳ Văn","path":"Xã Kỳ Văn, Huyện Kỳ Anh, Tỉnh Hà Tĩnh","path_with_type":"Xã Kỳ Văn, Huyện Kỳ Anh, Tỉnh Hà Tĩnh","code":"18784","parent_code":"447"},"18787":{"name":"Xã Kỳ Trung","type":"xa","slug":"xa-ky-trung","name_with_type":"Xã Kỳ Trung","path":"Xã Kỳ Trung, Huyện Kỳ Anh, Tỉnh Hà Tĩnh","path_with_type":"Xã Kỳ Trung, Huyện Kỳ Anh, Tỉnh Hà Tĩnh","code":"18787","parent_code":"447"},"18790":{"name":"Xã Kỳ Thọ","type":"xa","slug":"xa-ky-tho","name_with_type":"Xã Kỳ Thọ","path":"Xã Kỳ Thọ, Huyện Kỳ Anh, Tỉnh Hà Tĩnh","path_with_type":"Xã Kỳ Thọ, Huyện Kỳ Anh, Tỉnh Hà Tĩnh","code":"18790","parent_code":"447"},"18793":{"name":"Xã Kỳ Tây","type":"xa","slug":"xa-ky-tay","name_with_type":"Xã Kỳ Tây","path":"Xã Kỳ Tây, Huyện Kỳ Anh, Tỉnh Hà Tĩnh","path_with_type":"Xã Kỳ Tây, Huyện Kỳ Anh, Tỉnh Hà Tĩnh","code":"18793","parent_code":"447"},"18796":{"name":"Xã Kỳ Lợi","type":"xa","slug":"xa-ky-loi","name_with_type":"Xã Kỳ Lợi","path":"Xã Kỳ Lợi, Thị xã Kỳ Anh, Tỉnh Hà Tĩnh","path_with_type":"Xã Kỳ Lợi, Thị xã Kỳ Anh, Tỉnh Hà Tĩnh","code":"18796","parent_code":"449"},"18799":{"name":"Xã Kỳ Thượng","type":"xa","slug":"xa-ky-thuong","name_with_type":"Xã Kỳ Thượng","path":"Xã Kỳ Thượng, Huyện Kỳ Anh, Tỉnh Hà Tĩnh","path_with_type":"Xã Kỳ Thượng, Huyện Kỳ Anh, Tỉnh Hà Tĩnh","code":"18799","parent_code":"447"},"18802":{"name":"Xã Kỳ Hải","type":"xa","slug":"xa-ky-hai","name_with_type":"Xã Kỳ Hải","path":"Xã Kỳ Hải, Huyện Kỳ Anh, Tỉnh Hà Tĩnh","path_with_type":"Xã Kỳ Hải, Huyện Kỳ Anh, Tỉnh Hà Tĩnh","code":"18802","parent_code":"447"},"18805":{"name":"Xã Kỳ Thư","type":"xa","slug":"xa-ky-thu","name_with_type":"Xã Kỳ Thư","path":"Xã Kỳ Thư, Huyện Kỳ Anh, Tỉnh Hà Tĩnh","path_with_type":"Xã Kỳ Thư, Huyện Kỳ Anh, Tỉnh Hà Tĩnh","code":"18805","parent_code":"447"},"18808":{"name":"Xã Kỳ Hà","type":"xa","slug":"xa-ky-ha","name_with_type":"Xã Kỳ Hà","path":"Xã Kỳ Hà, Thị xã Kỳ Anh, Tỉnh Hà Tĩnh","path_with_type":"Xã Kỳ Hà, Thị xã Kỳ Anh, Tỉnh Hà Tĩnh","code":"18808","parent_code":"449"},"18811":{"name":"Xã Kỳ Châu","type":"xa","slug":"xa-ky-chau","name_with_type":"Xã Kỳ Châu","path":"Xã Kỳ Châu, Huyện Kỳ Anh, Tỉnh Hà Tĩnh","path_with_type":"Xã Kỳ Châu, Huyện Kỳ Anh, Tỉnh Hà Tĩnh","code":"18811","parent_code":"447"},"18814":{"name":"Xã Kỳ Tân","type":"xa","slug":"xa-ky-tan","name_with_type":"Xã Kỳ Tân","path":"Xã Kỳ Tân, Huyện Kỳ Anh, Tỉnh Hà Tĩnh","path_with_type":"Xã Kỳ Tân, Huyện Kỳ Anh, Tỉnh Hà Tĩnh","code":"18814","parent_code":"447"},"18820":{"name":"Phường Kỳ Trinh","type":"phuong","slug":"phuong-ky-trinh","name_with_type":"Phường Kỳ Trinh","path":"Phường Kỳ Trinh, Thị xã Kỳ Anh, Tỉnh Hà Tĩnh","path_with_type":"Phường Kỳ Trinh, Thị xã Kỳ Anh, Tỉnh Hà Tĩnh","code":"18820","parent_code":"449"},"18823":{"name":"Phường Kỳ Thịnh","type":"phuong","slug":"phuong-ky-thinh","name_with_type":"Phường Kỳ Thịnh","path":"Phường Kỳ Thịnh, Thị xã Kỳ Anh, Tỉnh Hà Tĩnh","path_with_type":"Phường Kỳ Thịnh, Thị xã Kỳ Anh, Tỉnh Hà Tĩnh","code":"18823","parent_code":"449"},"18829":{"name":"Xã Kỳ Hoa","type":"xa","slug":"xa-ky-hoa","name_with_type":"Xã Kỳ Hoa","path":"Xã Kỳ Hoa, Thị xã Kỳ Anh, Tỉnh Hà Tĩnh","path_with_type":"Xã Kỳ Hoa, Thị xã Kỳ Anh, Tỉnh Hà Tĩnh","code":"18829","parent_code":"449"},"18832":{"name":"Phường Kỳ Phương","type":"phuong","slug":"phuong-ky-phuong","name_with_type":"Phường Kỳ Phương","path":"Phường Kỳ Phương, Thị xã Kỳ Anh, Tỉnh Hà Tĩnh","path_with_type":"Phường Kỳ Phương, Thị xã Kỳ Anh, Tỉnh Hà Tĩnh","code":"18832","parent_code":"449"},"18835":{"name":"Phường Kỳ Long","type":"phuong","slug":"phuong-ky-long","name_with_type":"Phường Kỳ Long","path":"Phường Kỳ Long, Thị xã Kỳ Anh, Tỉnh Hà Tĩnh","path_with_type":"Phường Kỳ Long, Thị xã Kỳ Anh, Tỉnh Hà Tĩnh","code":"18835","parent_code":"449"},"18838":{"name":"Xã Lâm Hợp","type":"xa","slug":"xa-lam-hop","name_with_type":"Xã Lâm Hợp","path":"Xã Lâm Hợp, Huyện Kỳ Anh, Tỉnh Hà Tĩnh","path_with_type":"Xã Lâm Hợp, Huyện Kỳ Anh, Tỉnh Hà Tĩnh","code":"18838","parent_code":"447"},"18841":{"name":"Phường Kỳ Liên","type":"phuong","slug":"phuong-ky-lien","name_with_type":"Phường Kỳ Liên","path":"Phường Kỳ Liên, Thị xã Kỳ Anh, Tỉnh Hà Tĩnh","path_with_type":"Phường Kỳ Liên, Thị xã Kỳ Anh, Tỉnh Hà Tĩnh","code":"18841","parent_code":"449"},"18844":{"name":"Xã Kỳ Sơn","type":"xa","slug":"xa-ky-son","name_with_type":"Xã Kỳ Sơn","path":"Xã Kỳ Sơn, Huyện Kỳ Anh, Tỉnh Hà Tĩnh","path_with_type":"Xã Kỳ Sơn, Huyện Kỳ Anh, Tỉnh Hà Tĩnh","code":"18844","parent_code":"447"},"18847":{"name":"Phường Kỳ Nam","type":"phuong","slug":"phuong-ky-nam","name_with_type":"Phường Kỳ Nam","path":"Phường Kỳ Nam, Thị xã Kỳ Anh, Tỉnh Hà Tĩnh","path_with_type":"Phường Kỳ Nam, Thị xã Kỳ Anh, Tỉnh Hà Tĩnh","code":"18847","parent_code":"449"},"18850":{"name":"Xã Kỳ Lạc","type":"xa","slug":"xa-ky-lac","name_with_type":"Xã Kỳ Lạc","path":"Xã Kỳ Lạc, Huyện Kỳ Anh, Tỉnh Hà Tĩnh","path_with_type":"Xã Kỳ Lạc, Huyện Kỳ Anh, Tỉnh Hà Tĩnh","code":"18850","parent_code":"447"},"18853":{"name":"Phường Hải Thành","type":"phuong","slug":"phuong-hai-thanh","name_with_type":"Phường Hải Thành","path":"Phường Hải Thành, Thành Phố Đồng Hới, Tỉnh Quảng Bình","path_with_type":"Phường Hải Thành, Thành Phố Đồng Hới, Tỉnh Quảng Bình","code":"18853","parent_code":"450"},"18856":{"name":"Phường Đồng Phú","type":"phuong","slug":"phuong-dong-phu","name_with_type":"Phường Đồng Phú","path":"Phường Đồng Phú, Thành Phố Đồng Hới, Tỉnh Quảng Bình","path_with_type":"Phường Đồng Phú, Thành Phố Đồng Hới, Tỉnh Quảng Bình","code":"18856","parent_code":"450"},"18859":{"name":"Phường Bắc Lý","type":"phuong","slug":"phuong-bac-ly","name_with_type":"Phường Bắc Lý","path":"Phường Bắc Lý, Thành Phố Đồng Hới, Tỉnh Quảng Bình","path_with_type":"Phường Bắc Lý, Thành Phố Đồng Hới, Tỉnh Quảng Bình","code":"18859","parent_code":"450"},"18865":{"name":"Phường Nam Lý","type":"phuong","slug":"phuong-nam-ly","name_with_type":"Phường Nam Lý","path":"Phường Nam Lý, Thành Phố Đồng Hới, Tỉnh Quảng Bình","path_with_type":"Phường Nam Lý, Thành Phố Đồng Hới, Tỉnh Quảng Bình","code":"18865","parent_code":"450"},"18868":{"name":"Phường Đồng Hải","type":"phuong","slug":"phuong-dong-hai","name_with_type":"Phường Đồng Hải","path":"Phường Đồng Hải, Thành Phố Đồng Hới, Tỉnh Quảng Bình","path_with_type":"Phường Đồng Hải, Thành Phố Đồng Hới, Tỉnh Quảng Bình","code":"18868","parent_code":"450"},"18871":{"name":"Phường Đồng Sơn","type":"phuong","slug":"phuong-dong-son","name_with_type":"Phường Đồng Sơn","path":"Phường Đồng Sơn, Thành Phố Đồng Hới, Tỉnh Quảng Bình","path_with_type":"Phường Đồng Sơn, Thành Phố Đồng Hới, Tỉnh Quảng Bình","code":"18871","parent_code":"450"},"18874":{"name":"Phường Phú Hải","type":"phuong","slug":"phuong-phu-hai","name_with_type":"Phường Phú Hải","path":"Phường Phú Hải, Thành Phố Đồng Hới, Tỉnh Quảng Bình","path_with_type":"Phường Phú Hải, Thành Phố Đồng Hới, Tỉnh Quảng Bình","code":"18874","parent_code":"450"},"18877":{"name":"Phường Bắc Nghĩa","type":"phuong","slug":"phuong-bac-nghia","name_with_type":"Phường Bắc Nghĩa","path":"Phường Bắc Nghĩa, Thành Phố Đồng Hới, Tỉnh Quảng Bình","path_with_type":"Phường Bắc Nghĩa, Thành Phố Đồng Hới, Tỉnh Quảng Bình","code":"18877","parent_code":"450"},"18880":{"name":"Phường Đức Ninh Đông","type":"phuong","slug":"phuong-duc-ninh-dong","name_with_type":"Phường Đức Ninh Đông","path":"Phường Đức Ninh Đông, Thành Phố Đồng Hới, Tỉnh Quảng Bình","path_with_type":"Phường Đức Ninh Đông, Thành Phố Đồng Hới, Tỉnh Quảng Bình","code":"18880","parent_code":"450"},"18883":{"name":"Xã Quang Phú","type":"xa","slug":"xa-quang-phu","name_with_type":"Xã Quang Phú","path":"Xã Quang Phú, Thành Phố Đồng Hới, Tỉnh Quảng Bình","path_with_type":"Xã Quang Phú, Thành Phố Đồng Hới, Tỉnh Quảng Bình","code":"18883","parent_code":"450"},"18886":{"name":"Xã Lộc Ninh","type":"xa","slug":"xa-loc-ninh","name_with_type":"Xã Lộc Ninh","path":"Xã Lộc Ninh, Thành Phố Đồng Hới, Tỉnh Quảng Bình","path_with_type":"Xã Lộc Ninh, Thành Phố Đồng Hới, Tỉnh Quảng Bình","code":"18886","parent_code":"450"},"18889":{"name":"Xã Bảo Ninh","type":"xa","slug":"xa-bao-ninh","name_with_type":"Xã Bảo Ninh","path":"Xã Bảo Ninh, Thành Phố Đồng Hới, Tỉnh Quảng Bình","path_with_type":"Xã Bảo Ninh, Thành Phố Đồng Hới, Tỉnh Quảng Bình","code":"18889","parent_code":"450"},"18892":{"name":"Xã Nghĩa Ninh","type":"xa","slug":"xa-nghia-ninh","name_with_type":"Xã Nghĩa Ninh","path":"Xã Nghĩa Ninh, Thành Phố Đồng Hới, Tỉnh Quảng Bình","path_with_type":"Xã Nghĩa Ninh, Thành Phố Đồng Hới, Tỉnh Quảng Bình","code":"18892","parent_code":"450"},"18895":{"name":"Xã Thuận Đức","type":"xa","slug":"xa-thuan-duc","name_with_type":"Xã Thuận Đức","path":"Xã Thuận Đức, Thành Phố Đồng Hới, Tỉnh Quảng Bình","path_with_type":"Xã Thuận Đức, Thành Phố Đồng Hới, Tỉnh Quảng Bình","code":"18895","parent_code":"450"},"18898":{"name":"Xã Đức Ninh","type":"xa","slug":"xa-duc-ninh","name_with_type":"Xã Đức Ninh","path":"Xã Đức Ninh, Thành Phố Đồng Hới, Tỉnh Quảng Bình","path_with_type":"Xã Đức Ninh, Thành Phố Đồng Hới, Tỉnh Quảng Bình","code":"18898","parent_code":"450"},"18901":{"name":"Thị trấn Quy Đạt","type":"thi-tran","slug":"thi-tran-quy-dat","name_with_type":"Thị trấn Quy Đạt","path":"Thị trấn Quy Đạt, Huyện Minh Hóa, Tỉnh Quảng Bình","path_with_type":"Thị trấn Quy Đạt, Huyện Minh Hóa, Tỉnh Quảng Bình","code":"18901","parent_code":"452"},"18904":{"name":"Xã Dân Hóa","type":"xa","slug":"xa-dan-hoa","name_with_type":"Xã Dân Hóa","path":"Xã Dân Hóa, Huyện Minh Hóa, Tỉnh Quảng Bình","path_with_type":"Xã Dân Hóa, Huyện Minh Hóa, Tỉnh Quảng Bình","code":"18904","parent_code":"452"},"18907":{"name":"Xã Trọng Hóa","type":"xa","slug":"xa-trong-hoa","name_with_type":"Xã Trọng Hóa","path":"Xã Trọng Hóa, Huyện Minh Hóa, Tỉnh Quảng Bình","path_with_type":"Xã Trọng Hóa, Huyện Minh Hóa, Tỉnh Quảng Bình","code":"18907","parent_code":"452"},"18913":{"name":"Xã Hồng Hóa","type":"xa","slug":"xa-hong-hoa","name_with_type":"Xã Hồng Hóa","path":"Xã Hồng Hóa, Huyện Minh Hóa, Tỉnh Quảng Bình","path_with_type":"Xã Hồng Hóa, Huyện Minh Hóa, Tỉnh Quảng Bình","code":"18913","parent_code":"452"},"18919":{"name":"Xã Tân Thành","type":"xa","slug":"xa-tan-thanh","name_with_type":"Xã Tân Thành","path":"Xã Tân Thành, Huyện Minh Hóa, Tỉnh Quảng Bình","path_with_type":"Xã Tân Thành, Huyện Minh Hóa, Tỉnh Quảng Bình","code":"18919","parent_code":"452"},"18922":{"name":"Xã Hóa Hợp","type":"xa","slug":"xa-hoa-hop","name_with_type":"Xã Hóa Hợp","path":"Xã Hóa Hợp, Huyện Minh Hóa, Tỉnh Quảng Bình","path_with_type":"Xã Hóa Hợp, Huyện Minh Hóa, Tỉnh Quảng Bình","code":"18922","parent_code":"452"},"18925":{"name":"Xã Xuân Hóa","type":"xa","slug":"xa-xuan-hoa","name_with_type":"Xã Xuân Hóa","path":"Xã Xuân Hóa, Huyện Minh Hóa, Tỉnh Quảng Bình","path_with_type":"Xã Xuân Hóa, Huyện Minh Hóa, Tỉnh Quảng Bình","code":"18925","parent_code":"452"},"18928":{"name":"Xã Yên Hóa","type":"xa","slug":"xa-yen-hoa","name_with_type":"Xã Yên Hóa","path":"Xã Yên Hóa, Huyện Minh Hóa, Tỉnh Quảng Bình","path_with_type":"Xã Yên Hóa, Huyện Minh Hóa, Tỉnh Quảng Bình","code":"18928","parent_code":"452"},"18931":{"name":"Xã Minh Hóa","type":"xa","slug":"xa-minh-hoa","name_with_type":"Xã Minh Hóa","path":"Xã Minh Hóa, Huyện Minh Hóa, Tỉnh Quảng Bình","path_with_type":"Xã Minh Hóa, Huyện Minh Hóa, Tỉnh Quảng Bình","code":"18931","parent_code":"452"},"18934":{"name":"Xã Tân Hóa","type":"xa","slug":"xa-tan-hoa","name_with_type":"Xã Tân Hóa","path":"Xã Tân Hóa, Huyện Minh Hóa, Tỉnh Quảng Bình","path_with_type":"Xã Tân Hóa, Huyện Minh Hóa, Tỉnh Quảng Bình","code":"18934","parent_code":"452"},"18937":{"name":"Xã Hóa Sơn","type":"xa","slug":"xa-hoa-son","name_with_type":"Xã Hóa Sơn","path":"Xã Hóa Sơn, Huyện Minh Hóa, Tỉnh Quảng Bình","path_with_type":"Xã Hóa Sơn, Huyện Minh Hóa, Tỉnh Quảng Bình","code":"18937","parent_code":"452"},"18943":{"name":"Xã Trung Hóa","type":"xa","slug":"xa-trung-hoa","name_with_type":"Xã Trung Hóa","path":"Xã Trung Hóa, Huyện Minh Hóa, Tỉnh Quảng Bình","path_with_type":"Xã Trung Hóa, Huyện Minh Hóa, Tỉnh Quảng Bình","code":"18943","parent_code":"452"},"18946":{"name":"Xã Thượng Hóa","type":"xa","slug":"xa-thuong-hoa","name_with_type":"Xã Thượng Hóa","path":"Xã Thượng Hóa, Huyện Minh Hóa, Tỉnh Quảng Bình","path_with_type":"Xã Thượng Hóa, Huyện Minh Hóa, Tỉnh Quảng Bình","code":"18946","parent_code":"452"},"18949":{"name":"Thị trấn Đồng Lê","type":"thi-tran","slug":"thi-tran-dong-le","name_with_type":"Thị trấn Đồng Lê","path":"Thị trấn Đồng Lê, Huyện Tuyên Hóa, Tỉnh Quảng Bình","path_with_type":"Thị trấn Đồng Lê, Huyện Tuyên Hóa, Tỉnh Quảng Bình","code":"18949","parent_code":"453"},"18952":{"name":"Xã Hương Hóa","type":"xa","slug":"xa-huong-hoa","name_with_type":"Xã Hương Hóa","path":"Xã Hương Hóa, Huyện Tuyên Hóa, Tỉnh Quảng Bình","path_with_type":"Xã Hương Hóa, Huyện Tuyên Hóa, Tỉnh Quảng Bình","code":"18952","parent_code":"453"},"18955":{"name":"Xã Kim Hóa","type":"xa","slug":"xa-kim-hoa","name_with_type":"Xã Kim Hóa","path":"Xã Kim Hóa, Huyện Tuyên Hóa, Tỉnh Quảng Bình","path_with_type":"Xã Kim Hóa, Huyện Tuyên Hóa, Tỉnh Quảng Bình","code":"18955","parent_code":"453"},"18958":{"name":"Xã Thanh Hóa","type":"xa","slug":"xa-thanh-hoa","name_with_type":"Xã Thanh Hóa","path":"Xã Thanh Hóa, Huyện Tuyên Hóa, Tỉnh Quảng Bình","path_with_type":"Xã Thanh Hóa, Huyện Tuyên Hóa, Tỉnh Quảng Bình","code":"18958","parent_code":"453"},"18961":{"name":"Xã Thanh Thạch","type":"xa","slug":"xa-thanh-thach","name_with_type":"Xã Thanh Thạch","path":"Xã Thanh Thạch, Huyện Tuyên Hóa, Tỉnh Quảng Bình","path_with_type":"Xã Thanh Thạch, Huyện Tuyên Hóa, Tỉnh Quảng Bình","code":"18961","parent_code":"453"},"18964":{"name":"Xã Thuận Hóa","type":"xa","slug":"xa-thuan-hoa","name_with_type":"Xã Thuận Hóa","path":"Xã Thuận Hóa, Huyện Tuyên Hóa, Tỉnh Quảng Bình","path_with_type":"Xã Thuận Hóa, Huyện Tuyên Hóa, Tỉnh Quảng Bình","code":"18964","parent_code":"453"},"18967":{"name":"Xã Lâm Hóa","type":"xa","slug":"xa-lam-hoa","name_with_type":"Xã Lâm Hóa","path":"Xã Lâm Hóa, Huyện Tuyên Hóa, Tỉnh Quảng Bình","path_with_type":"Xã Lâm Hóa, Huyện Tuyên Hóa, Tỉnh Quảng Bình","code":"18967","parent_code":"453"},"18970":{"name":"Xã Lê Hóa","type":"xa","slug":"xa-le-hoa","name_with_type":"Xã Lê Hóa","path":"Xã Lê Hóa, Huyện Tuyên Hóa, Tỉnh Quảng Bình","path_with_type":"Xã Lê Hóa, Huyện Tuyên Hóa, Tỉnh Quảng Bình","code":"18970","parent_code":"453"},"18973":{"name":"Xã Sơn Hóa","type":"xa","slug":"xa-son-hoa","name_with_type":"Xã Sơn Hóa","path":"Xã Sơn Hóa, Huyện Tuyên Hóa, Tỉnh Quảng Bình","path_with_type":"Xã Sơn Hóa, Huyện Tuyên Hóa, Tỉnh Quảng Bình","code":"18973","parent_code":"453"},"18976":{"name":"Xã Đồng Hóa","type":"xa","slug":"xa-dong-hoa","name_with_type":"Xã Đồng Hóa","path":"Xã Đồng Hóa, Huyện Tuyên Hóa, Tỉnh Quảng Bình","path_with_type":"Xã Đồng Hóa, Huyện Tuyên Hóa, Tỉnh Quảng Bình","code":"18976","parent_code":"453"},"18979":{"name":"Xã Ngư Hóa","type":"xa","slug":"xa-ngu-hoa","name_with_type":"Xã Ngư Hóa","path":"Xã Ngư Hóa, Huyện Tuyên Hóa, Tỉnh Quảng Bình","path_with_type":"Xã Ngư Hóa, Huyện Tuyên Hóa, Tỉnh Quảng Bình","code":"18979","parent_code":"453"},"18985":{"name":"Xã Thạch Hóa","type":"xa","slug":"xa-thach-hoa","name_with_type":"Xã Thạch Hóa","path":"Xã Thạch Hóa, Huyện Tuyên Hóa, Tỉnh Quảng Bình","path_with_type":"Xã Thạch Hóa, Huyện Tuyên Hóa, Tỉnh Quảng Bình","code":"18985","parent_code":"453"},"18988":{"name":"Xã Đức Hóa","type":"xa","slug":"xa-duc-hoa","name_with_type":"Xã Đức Hóa","path":"Xã Đức Hóa, Huyện Tuyên Hóa, Tỉnh Quảng Bình","path_with_type":"Xã Đức Hóa, Huyện Tuyên Hóa, Tỉnh Quảng Bình","code":"18988","parent_code":"453"},"18991":{"name":"Xã Phong Hóa","type":"xa","slug":"xa-phong-hoa","name_with_type":"Xã Phong Hóa","path":"Xã Phong Hóa, Huyện Tuyên Hóa, Tỉnh Quảng Bình","path_with_type":"Xã Phong Hóa, Huyện Tuyên Hóa, Tỉnh Quảng Bình","code":"18991","parent_code":"453"},"18994":{"name":"Xã Mai Hóa","type":"xa","slug":"xa-mai-hoa","name_with_type":"Xã Mai Hóa","path":"Xã Mai Hóa, Huyện Tuyên Hóa, Tỉnh Quảng Bình","path_with_type":"Xã Mai Hóa, Huyện Tuyên Hóa, Tỉnh Quảng Bình","code":"18994","parent_code":"453"},"18997":{"name":"Xã Tiến Hóa","type":"xa","slug":"xa-tien-hoa","name_with_type":"Xã Tiến Hóa","path":"Xã Tiến Hóa, Huyện Tuyên Hóa, Tỉnh Quảng Bình","path_with_type":"Xã Tiến Hóa, Huyện Tuyên Hóa, Tỉnh Quảng Bình","code":"18997","parent_code":"453"},"19000":{"name":"Xã Châu Hóa","type":"xa","slug":"xa-chau-hoa","name_with_type":"Xã Châu Hóa","path":"Xã Châu Hóa, Huyện Tuyên Hóa, Tỉnh Quảng Bình","path_with_type":"Xã Châu Hóa, Huyện Tuyên Hóa, Tỉnh Quảng Bình","code":"19000","parent_code":"453"},"19003":{"name":"Xã Cao Quảng","type":"xa","slug":"xa-cao-quang","name_with_type":"Xã Cao Quảng","path":"Xã Cao Quảng, Huyện Tuyên Hóa, Tỉnh Quảng Bình","path_with_type":"Xã Cao Quảng, Huyện Tuyên Hóa, Tỉnh Quảng Bình","code":"19003","parent_code":"453"},"19006":{"name":"Xã Văn Hóa","type":"xa","slug":"xa-van-hoa","name_with_type":"Xã Văn Hóa","path":"Xã Văn Hóa, Huyện Tuyên Hóa, Tỉnh Quảng Bình","path_with_type":"Xã Văn Hóa, Huyện Tuyên Hóa, Tỉnh Quảng Bình","code":"19006","parent_code":"453"},"19009":{"name":"Phường Ba Đồn","type":"phuong","slug":"phuong-ba-don","name_with_type":"Phường Ba Đồn","path":"Phường Ba Đồn, Thị xã Ba Đồn, Tỉnh Quảng Bình","path_with_type":"Phường Ba Đồn, Thị xã Ba Đồn, Tỉnh Quảng Bình","code":"19009","parent_code":"458"},"19012":{"name":"Xã Quảng Hợp","type":"xa","slug":"xa-quang-hop","name_with_type":"Xã Quảng Hợp","path":"Xã Quảng Hợp, Huyện Quảng Trạch, Tỉnh Quảng Bình","path_with_type":"Xã Quảng Hợp, Huyện Quảng Trạch, Tỉnh Quảng Bình","code":"19012","parent_code":"454"},"19015":{"name":"Xã Quảng Kim","type":"xa","slug":"xa-quang-kim","name_with_type":"Xã Quảng Kim","path":"Xã Quảng Kim, Huyện Quảng Trạch, Tỉnh Quảng Bình","path_with_type":"Xã Quảng Kim, Huyện Quảng Trạch, Tỉnh Quảng Bình","code":"19015","parent_code":"454"},"19018":{"name":"Xã Quảng Đông","type":"xa","slug":"xa-quang-dong","name_with_type":"Xã Quảng Đông","path":"Xã Quảng Đông, Huyện Quảng Trạch, Tỉnh Quảng Bình","path_with_type":"Xã Quảng Đông, Huyện Quảng Trạch, Tỉnh Quảng Bình","code":"19018","parent_code":"454"},"19021":{"name":"Xã Quảng Phú","type":"xa","slug":"xa-quang-phu","name_with_type":"Xã Quảng Phú","path":"Xã Quảng Phú, Huyện Quảng Trạch, Tỉnh Quảng Bình","path_with_type":"Xã Quảng Phú, Huyện Quảng Trạch, Tỉnh Quảng Bình","code":"19021","parent_code":"454"},"19024":{"name":"Xã Quảng Châu","type":"xa","slug":"xa-quang-chau","name_with_type":"Xã Quảng Châu","path":"Xã Quảng Châu, Huyện Quảng Trạch, Tỉnh Quảng Bình","path_with_type":"Xã Quảng Châu, Huyện Quảng Trạch, Tỉnh Quảng Bình","code":"19024","parent_code":"454"},"19027":{"name":"Xã Quảng Thạch","type":"xa","slug":"xa-quang-thach","name_with_type":"Xã Quảng Thạch","path":"Xã Quảng Thạch, Huyện Quảng Trạch, Tỉnh Quảng Bình","path_with_type":"Xã Quảng Thạch, Huyện Quảng Trạch, Tỉnh Quảng Bình","code":"19027","parent_code":"454"},"19030":{"name":"Xã Quảng Lưu","type":"xa","slug":"xa-quang-luu","name_with_type":"Xã Quảng Lưu","path":"Xã Quảng Lưu, Huyện Quảng Trạch, Tỉnh Quảng Bình","path_with_type":"Xã Quảng Lưu, Huyện Quảng Trạch, Tỉnh Quảng Bình","code":"19030","parent_code":"454"},"19033":{"name":"Xã Quảng Tùng","type":"xa","slug":"xa-quang-tung","name_with_type":"Xã Quảng Tùng","path":"Xã Quảng Tùng, Huyện Quảng Trạch, Tỉnh Quảng Bình","path_with_type":"Xã Quảng Tùng, Huyện Quảng Trạch, Tỉnh Quảng Bình","code":"19033","parent_code":"454"},"19036":{"name":"Xã Cảnh Dương","type":"xa","slug":"xa-canh-duong","name_with_type":"Xã Cảnh Dương","path":"Xã Cảnh Dương, Huyện Quảng Trạch, Tỉnh Quảng Bình","path_with_type":"Xã Cảnh Dương, Huyện Quảng Trạch, Tỉnh Quảng Bình","code":"19036","parent_code":"454"},"19039":{"name":"Xã Quảng Tiến","type":"xa","slug":"xa-quang-tien","name_with_type":"Xã Quảng Tiến","path":"Xã Quảng Tiến, Huyện Quảng Trạch, Tỉnh Quảng Bình","path_with_type":"Xã Quảng Tiến, Huyện Quảng Trạch, Tỉnh Quảng Bình","code":"19039","parent_code":"454"},"19042":{"name":"Xã Quảng Hưng","type":"xa","slug":"xa-quang-hung","name_with_type":"Xã Quảng Hưng","path":"Xã Quảng Hưng, Huyện Quảng Trạch, Tỉnh Quảng Bình","path_with_type":"Xã Quảng Hưng, Huyện Quảng Trạch, Tỉnh Quảng Bình","code":"19042","parent_code":"454"},"19045":{"name":"Xã Quảng Xuân","type":"xa","slug":"xa-quang-xuan","name_with_type":"Xã Quảng Xuân","path":"Xã Quảng Xuân, Huyện Quảng Trạch, Tỉnh Quảng Bình","path_with_type":"Xã Quảng Xuân, Huyện Quảng Trạch, Tỉnh Quảng Bình","code":"19045","parent_code":"454"},"19051":{"name":"Xã Liên Trường","type":"xa","slug":"xa-lien-truong","name_with_type":"Xã Liên Trường","path":"Xã Liên Trường, Huyện Quảng Trạch, Tỉnh Quảng Bình","path_with_type":"Xã Liên Trường, Huyện Quảng Trạch, Tỉnh Quảng Bình","code":"19051","parent_code":"454"},"19057":{"name":"Xã Quảng Phương","type":"xa","slug":"xa-quang-phuong","name_with_type":"Xã Quảng Phương","path":"Xã Quảng Phương, Huyện Quảng Trạch, Tỉnh Quảng Bình","path_with_type":"Xã Quảng Phương, Huyện Quảng Trạch, Tỉnh Quảng Bình","code":"19057","parent_code":"454"},"19060":{"name":"Phường Quảng Long","type":"phuong","slug":"phuong-quang-long","name_with_type":"Phường Quảng Long","path":"Phường Quảng Long, Thị xã Ba Đồn, Tỉnh Quảng Bình","path_with_type":"Phường Quảng Long, Thị xã Ba Đồn, Tỉnh Quảng Bình","code":"19060","parent_code":"458"},"19063":{"name":"Xã Phù Cảnh","type":"xa","slug":"xa-phu-canh","name_with_type":"Xã Phù Cảnh","path":"Xã Phù Cảnh, Huyện Quảng Trạch, Tỉnh Quảng Bình","path_with_type":"Xã Phù Cảnh, Huyện Quảng Trạch, Tỉnh Quảng Bình","code":"19063","parent_code":"454"},"19066":{"name":"Phường Quảng Thọ","type":"phuong","slug":"phuong-quang-tho","name_with_type":"Phường Quảng Thọ","path":"Phường Quảng Thọ, Thị xã Ba Đồn, Tỉnh Quảng Bình","path_with_type":"Phường Quảng Thọ, Thị xã Ba Đồn, Tỉnh Quảng Bình","code":"19066","parent_code":"458"},"19069":{"name":"Xã Quảng Tiên","type":"xa","slug":"xa-quang-tien","name_with_type":"Xã Quảng Tiên","path":"Xã Quảng Tiên, Thị xã Ba Đồn, Tỉnh Quảng Bình","path_with_type":"Xã Quảng Tiên, Thị xã Ba Đồn, Tỉnh Quảng Bình","code":"19069","parent_code":"458"},"19072":{"name":"Xã Quảng Thanh","type":"xa","slug":"xa-quang-thanh","name_with_type":"Xã Quảng Thanh","path":"Xã Quảng Thanh, Huyện Quảng Trạch, Tỉnh Quảng Bình","path_with_type":"Xã Quảng Thanh, Huyện Quảng Trạch, Tỉnh Quảng Bình","code":"19072","parent_code":"454"},"19075":{"name":"Xã Quảng Trung","type":"xa","slug":"xa-quang-trung","name_with_type":"Xã Quảng Trung","path":"Xã Quảng Trung, Thị xã Ba Đồn, Tỉnh Quảng Bình","path_with_type":"Xã Quảng Trung, Thị xã Ba Đồn, Tỉnh Quảng Bình","code":"19075","parent_code":"458"},"19078":{"name":"Phường Quảng Phong","type":"phuong","slug":"phuong-quang-phong","name_with_type":"Phường Quảng Phong","path":"Phường Quảng Phong, Thị xã Ba Đồn, Tỉnh Quảng Bình","path_with_type":"Phường Quảng Phong, Thị xã Ba Đồn, Tỉnh Quảng Bình","code":"19078","parent_code":"458"},"19081":{"name":"Phường Quảng Thuận","type":"phuong","slug":"phuong-quang-thuan","name_with_type":"Phường Quảng Thuận","path":"Phường Quảng Thuận, Thị xã Ba Đồn, Tỉnh Quảng Bình","path_with_type":"Phường Quảng Thuận, Thị xã Ba Đồn, Tỉnh Quảng Bình","code":"19081","parent_code":"458"},"19084":{"name":"Xã Quảng Tân","type":"xa","slug":"xa-quang-tan","name_with_type":"Xã Quảng Tân","path":"Xã Quảng Tân, Thị xã Ba Đồn, Tỉnh Quảng Bình","path_with_type":"Xã Quảng Tân, Thị xã Ba Đồn, Tỉnh Quảng Bình","code":"19084","parent_code":"458"},"19087":{"name":"Xã Quảng Hải","type":"xa","slug":"xa-quang-hai","name_with_type":"Xã Quảng Hải","path":"Xã Quảng Hải, Thị xã Ba Đồn, Tỉnh Quảng Bình","path_with_type":"Xã Quảng Hải, Thị xã Ba Đồn, Tỉnh Quảng Bình","code":"19087","parent_code":"458"},"19090":{"name":"Xã Quảng Sơn","type":"xa","slug":"xa-quang-son","name_with_type":"Xã Quảng Sơn","path":"Xã Quảng Sơn, Thị xã Ba Đồn, Tỉnh Quảng Bình","path_with_type":"Xã Quảng Sơn, Thị xã Ba Đồn, Tỉnh Quảng Bình","code":"19090","parent_code":"458"},"19093":{"name":"Xã Quảng Lộc","type":"xa","slug":"xa-quang-loc","name_with_type":"Xã Quảng Lộc","path":"Xã Quảng Lộc, Thị xã Ba Đồn, Tỉnh Quảng Bình","path_with_type":"Xã Quảng Lộc, Thị xã Ba Đồn, Tỉnh Quảng Bình","code":"19093","parent_code":"458"},"19096":{"name":"Xã Quảng Thủy","type":"xa","slug":"xa-quang-thuy","name_with_type":"Xã Quảng Thủy","path":"Xã Quảng Thủy, Thị xã Ba Đồn, Tỉnh Quảng Bình","path_with_type":"Xã Quảng Thủy, Thị xã Ba Đồn, Tỉnh Quảng Bình","code":"19096","parent_code":"458"},"19099":{"name":"Xã Quảng Văn","type":"xa","slug":"xa-quang-van","name_with_type":"Xã Quảng Văn","path":"Xã Quảng Văn, Thị xã Ba Đồn, Tỉnh Quảng Bình","path_with_type":"Xã Quảng Văn, Thị xã Ba Đồn, Tỉnh Quảng Bình","code":"19099","parent_code":"458"},"19102":{"name":"Phường Quảng Phúc","type":"phuong","slug":"phuong-quang-phuc","name_with_type":"Phường Quảng Phúc","path":"Phường Quảng Phúc, Thị xã Ba Đồn, Tỉnh Quảng Bình","path_with_type":"Phường Quảng Phúc, Thị xã Ba Đồn, Tỉnh Quảng Bình","code":"19102","parent_code":"458"},"19105":{"name":"Xã Quảng Hòa","type":"xa","slug":"xa-quang-hoa","name_with_type":"Xã Quảng Hòa","path":"Xã Quảng Hòa, Thị xã Ba Đồn, Tỉnh Quảng Bình","path_with_type":"Xã Quảng Hòa, Thị xã Ba Đồn, Tỉnh Quảng Bình","code":"19105","parent_code":"458"},"19108":{"name":"Xã Quảng Minh","type":"xa","slug":"xa-quang-minh","name_with_type":"Xã Quảng Minh","path":"Xã Quảng Minh, Thị xã Ba Đồn, Tỉnh Quảng Bình","path_with_type":"Xã Quảng Minh, Thị xã Ba Đồn, Tỉnh Quảng Bình","code":"19108","parent_code":"458"},"19111":{"name":"Thị trấn Hoàn Lão","type":"thi-tran","slug":"thi-tran-hoan-lao","name_with_type":"Thị trấn Hoàn Lão","path":"Thị trấn Hoàn Lão, Huyện Bố Trạch, Tỉnh Quảng Bình","path_with_type":"Thị trấn Hoàn Lão, Huyện Bố Trạch, Tỉnh Quảng Bình","code":"19111","parent_code":"455"},"19114":{"name":"Thị trấn NT Việt Trung","type":"thi-tran","slug":"thi-tran-nt-viet-trung","name_with_type":"Thị trấn NT Việt Trung","path":"Thị trấn NT Việt Trung, Huyện Bố Trạch, Tỉnh Quảng Bình","path_with_type":"Thị trấn NT Việt Trung, Huyện Bố Trạch, Tỉnh Quảng Bình","code":"19114","parent_code":"455"},"19117":{"name":"Xã Xuân Trạch","type":"xa","slug":"xa-xuan-trach","name_with_type":"Xã Xuân Trạch","path":"Xã Xuân Trạch, Huyện Bố Trạch, Tỉnh Quảng Bình","path_with_type":"Xã Xuân Trạch, Huyện Bố Trạch, Tỉnh Quảng Bình","code":"19117","parent_code":"455"},"19123":{"name":"Xã Hạ Mỹ","type":"xa","slug":"xa-ha-my","name_with_type":"Xã Hạ Mỹ","path":"Xã Hạ Mỹ, Huyện Bố Trạch, Tỉnh Quảng Bình","path_with_type":"Xã Hạ Mỹ, Huyện Bố Trạch, Tỉnh Quảng Bình","code":"19123","parent_code":"455"},"19126":{"name":"Xã Bắc Trạch","type":"xa","slug":"xa-bac-trach","name_with_type":"Xã Bắc Trạch","path":"Xã Bắc Trạch, Huyện Bố Trạch, Tỉnh Quảng Bình","path_with_type":"Xã Bắc Trạch, Huyện Bố Trạch, Tỉnh Quảng Bình","code":"19126","parent_code":"455"},"19129":{"name":"Xã Lâm Trạch","type":"xa","slug":"xa-lam-trach","name_with_type":"Xã Lâm Trạch","path":"Xã Lâm Trạch, Huyện Bố Trạch, Tỉnh Quảng Bình","path_with_type":"Xã Lâm Trạch, Huyện Bố Trạch, Tỉnh Quảng Bình","code":"19129","parent_code":"455"},"19132":{"name":"Xã Thanh Trạch","type":"xa","slug":"xa-thanh-trach","name_with_type":"Xã Thanh Trạch","path":"Xã Thanh Trạch, Huyện Bố Trạch, Tỉnh Quảng Bình","path_with_type":"Xã Thanh Trạch, Huyện Bố Trạch, Tỉnh Quảng Bình","code":"19132","parent_code":"455"},"19135":{"name":"Xã Liên Trạch","type":"xa","slug":"xa-lien-trach","name_with_type":"Xã Liên Trạch","path":"Xã Liên Trạch, Huyện Bố Trạch, Tỉnh Quảng Bình","path_with_type":"Xã Liên Trạch, Huyện Bố Trạch, Tỉnh Quảng Bình","code":"19135","parent_code":"455"},"19138":{"name":"Xã Phúc Trạch","type":"xa","slug":"xa-phuc-trach","name_with_type":"Xã Phúc Trạch","path":"Xã Phúc Trạch, Huyện Bố Trạch, Tỉnh Quảng Bình","path_with_type":"Xã Phúc Trạch, Huyện Bố Trạch, Tỉnh Quảng Bình","code":"19138","parent_code":"455"},"19141":{"name":"Xã Cự Nẫm","type":"xa","slug":"xa-cu-nam","name_with_type":"Xã Cự Nẫm","path":"Xã Cự Nẫm, Huyện Bố Trạch, Tỉnh Quảng Bình","path_with_type":"Xã Cự Nẫm, Huyện Bố Trạch, Tỉnh Quảng Bình","code":"19141","parent_code":"455"},"19144":{"name":"Xã Hải Phú","type":"xa","slug":"xa-hai-phu","name_with_type":"Xã Hải Phú","path":"Xã Hải Phú, Huyện Bố Trạch, Tỉnh Quảng Bình","path_with_type":"Xã Hải Phú, Huyện Bố Trạch, Tỉnh Quảng Bình","code":"19144","parent_code":"455"},"19147":{"name":"Xã Thượng Trạch","type":"xa","slug":"xa-thuong-trach","name_with_type":"Xã Thượng Trạch","path":"Xã Thượng Trạch, Huyện Bố Trạch, Tỉnh Quảng Bình","path_with_type":"Xã Thượng Trạch, Huyện Bố Trạch, Tỉnh Quảng Bình","code":"19147","parent_code":"455"},"19150":{"name":"Xã Sơn Lộc","type":"xa","slug":"xa-son-loc","name_with_type":"Xã Sơn Lộc","path":"Xã Sơn Lộc, Huyện Bố Trạch, Tỉnh Quảng Bình","path_with_type":"Xã Sơn Lộc, Huyện Bố Trạch, Tỉnh Quảng Bình","code":"19150","parent_code":"455"},"19156":{"name":"Xã Hưng Trạch","type":"xa","slug":"xa-hung-trach","name_with_type":"Xã Hưng Trạch","path":"Xã Hưng Trạch, Huyện Bố Trạch, Tỉnh Quảng Bình","path_with_type":"Xã Hưng Trạch, Huyện Bố Trạch, Tỉnh Quảng Bình","code":"19156","parent_code":"455"},"19159":{"name":"Xã Đồng Trạch","type":"xa","slug":"xa-dong-trach","name_with_type":"Xã Đồng Trạch","path":"Xã Đồng Trạch, Huyện Bố Trạch, Tỉnh Quảng Bình","path_with_type":"Xã Đồng Trạch, Huyện Bố Trạch, Tỉnh Quảng Bình","code":"19159","parent_code":"455"},"19162":{"name":"Xã Đức Trạch","type":"xa","slug":"xa-duc-trach","name_with_type":"Xã Đức Trạch","path":"Xã Đức Trạch, Huyện Bố Trạch, Tỉnh Quảng Bình","path_with_type":"Xã Đức Trạch, Huyện Bố Trạch, Tỉnh Quảng Bình","code":"19162","parent_code":"455"},"19165":{"name":"Thị trấn Phong Nha","type":"thi-tran","slug":"thi-tran-phong-nha","name_with_type":"Thị trấn Phong Nha","path":"Thị trấn Phong Nha, Huyện Bố Trạch, Tỉnh Quảng Bình","path_with_type":"Thị trấn Phong Nha, Huyện Bố Trạch, Tỉnh Quảng Bình","code":"19165","parent_code":"455"},"19168":{"name":"Xã Vạn Trạch","type":"xa","slug":"xa-van-trach","name_with_type":"Xã Vạn Trạch","path":"Xã Vạn Trạch, Huyện Bố Trạch, Tỉnh Quảng Bình","path_with_type":"Xã Vạn Trạch, Huyện Bố Trạch, Tỉnh Quảng Bình","code":"19168","parent_code":"455"},"19174":{"name":"Xã Phú Định","type":"xa","slug":"xa-phu-dinh","name_with_type":"Xã Phú Định","path":"Xã Phú Định, Huyện Bố Trạch, Tỉnh Quảng Bình","path_with_type":"Xã Phú Định, Huyện Bố Trạch, Tỉnh Quảng Bình","code":"19174","parent_code":"455"},"19177":{"name":"Xã Trung Trạch","type":"xa","slug":"xa-trung-trach","name_with_type":"Xã Trung Trạch","path":"Xã Trung Trạch, Huyện Bố Trạch, Tỉnh Quảng Bình","path_with_type":"Xã Trung Trạch, Huyện Bố Trạch, Tỉnh Quảng Bình","code":"19177","parent_code":"455"},"19180":{"name":"Xã Tây Trạch","type":"xa","slug":"xa-tay-trach","name_with_type":"Xã Tây Trạch","path":"Xã Tây Trạch, Huyện Bố Trạch, Tỉnh Quảng Bình","path_with_type":"Xã Tây Trạch, Huyện Bố Trạch, Tỉnh Quảng Bình","code":"19180","parent_code":"455"},"19183":{"name":"Xã Hòa Trạch","type":"xa","slug":"xa-hoa-trach","name_with_type":"Xã Hòa Trạch","path":"Xã Hòa Trạch, Huyện Bố Trạch, Tỉnh Quảng Bình","path_with_type":"Xã Hòa Trạch, Huyện Bố Trạch, Tỉnh Quảng Bình","code":"19183","parent_code":"455"},"19186":{"name":"Xã Đại Trạch","type":"xa","slug":"xa-dai-trach","name_with_type":"Xã Đại Trạch","path":"Xã Đại Trạch, Huyện Bố Trạch, Tỉnh Quảng Bình","path_with_type":"Xã Đại Trạch, Huyện Bố Trạch, Tỉnh Quảng Bình","code":"19186","parent_code":"455"},"19189":{"name":"Xã Nhân Trạch","type":"xa","slug":"xa-nhan-trach","name_with_type":"Xã Nhân Trạch","path":"Xã Nhân Trạch, Huyện Bố Trạch, Tỉnh Quảng Bình","path_with_type":"Xã Nhân Trạch, Huyện Bố Trạch, Tỉnh Quảng Bình","code":"19189","parent_code":"455"},"19192":{"name":"Xã Tân Trạch","type":"xa","slug":"xa-tan-trach","name_with_type":"Xã Tân Trạch","path":"Xã Tân Trạch, Huyện Bố Trạch, Tỉnh Quảng Bình","path_with_type":"Xã Tân Trạch, Huyện Bố Trạch, Tỉnh Quảng Bình","code":"19192","parent_code":"455"},"19198":{"name":"Xã Lý Nam","type":"xa","slug":"xa-ly-nam","name_with_type":"Xã Lý Nam","path":"Xã Lý Nam, Huyện Bố Trạch, Tỉnh Quảng Bình","path_with_type":"Xã Lý Nam, Huyện Bố Trạch, Tỉnh Quảng Bình","code":"19198","parent_code":"455"},"19204":{"name":"Xã Trường Sơn","type":"xa","slug":"xa-truong-son","name_with_type":"Xã Trường Sơn","path":"Xã Trường Sơn, Huyện Quảng Ninh, Tỉnh Quảng Bình","path_with_type":"Xã Trường Sơn, Huyện Quảng Ninh, Tỉnh Quảng Bình","code":"19204","parent_code":"456"},"19207":{"name":"Thị trấn Quán Hàu","type":"thi-tran","slug":"thi-tran-quan-hau","name_with_type":"Thị trấn Quán Hàu","path":"Thị trấn Quán Hàu, Huyện Quảng Ninh, Tỉnh Quảng Bình","path_with_type":"Thị trấn Quán Hàu, Huyện Quảng Ninh, Tỉnh Quảng Bình","code":"19207","parent_code":"456"},"19210":{"name":"Xã Vĩnh Ninh","type":"xa","slug":"xa-vinh-ninh","name_with_type":"Xã Vĩnh Ninh","path":"Xã Vĩnh Ninh, Huyện Quảng Ninh, Tỉnh Quảng Bình","path_with_type":"Xã Vĩnh Ninh, Huyện Quảng Ninh, Tỉnh Quảng Bình","code":"19210","parent_code":"456"},"19213":{"name":"Xã Võ Ninh","type":"xa","slug":"xa-vo-ninh","name_with_type":"Xã Võ Ninh","path":"Xã Võ Ninh, Huyện Quảng Ninh, Tỉnh Quảng Bình","path_with_type":"Xã Võ Ninh, Huyện Quảng Ninh, Tỉnh Quảng Bình","code":"19213","parent_code":"456"},"19216":{"name":"Xã Hải Ninh","type":"xa","slug":"xa-hai-ninh","name_with_type":"Xã Hải Ninh","path":"Xã Hải Ninh, Huyện Quảng Ninh, Tỉnh Quảng Bình","path_with_type":"Xã Hải Ninh, Huyện Quảng Ninh, Tỉnh Quảng Bình","code":"19216","parent_code":"456"},"19219":{"name":"Xã Hàm Ninh","type":"xa","slug":"xa-ham-ninh","name_with_type":"Xã Hàm Ninh","path":"Xã Hàm Ninh, Huyện Quảng Ninh, Tỉnh Quảng Bình","path_with_type":"Xã Hàm Ninh, Huyện Quảng Ninh, Tỉnh Quảng Bình","code":"19219","parent_code":"456"},"19222":{"name":"Xã Duy Ninh","type":"xa","slug":"xa-duy-ninh","name_with_type":"Xã Duy Ninh","path":"Xã Duy Ninh, Huyện Quảng Ninh, Tỉnh Quảng Bình","path_with_type":"Xã Duy Ninh, Huyện Quảng Ninh, Tỉnh Quảng Bình","code":"19222","parent_code":"456"},"19225":{"name":"Xã Gia Ninh","type":"xa","slug":"xa-gia-ninh","name_with_type":"Xã Gia Ninh","path":"Xã Gia Ninh, Huyện Quảng Ninh, Tỉnh Quảng Bình","path_with_type":"Xã Gia Ninh, Huyện Quảng Ninh, Tỉnh Quảng Bình","code":"19225","parent_code":"456"},"19228":{"name":"Xã Trường Xuân","type":"xa","slug":"xa-truong-xuan","name_with_type":"Xã Trường Xuân","path":"Xã Trường Xuân, Huyện Quảng Ninh, Tỉnh Quảng Bình","path_with_type":"Xã Trường Xuân, Huyện Quảng Ninh, Tỉnh Quảng Bình","code":"19228","parent_code":"456"},"19231":{"name":"Xã Hiền Ninh","type":"xa","slug":"xa-hien-ninh","name_with_type":"Xã Hiền Ninh","path":"Xã Hiền Ninh, Huyện Quảng Ninh, Tỉnh Quảng Bình","path_with_type":"Xã Hiền Ninh, Huyện Quảng Ninh, Tỉnh Quảng Bình","code":"19231","parent_code":"456"},"19234":{"name":"Xã Tân Ninh","type":"xa","slug":"xa-tan-ninh","name_with_type":"Xã Tân Ninh","path":"Xã Tân Ninh, Huyện Quảng Ninh, Tỉnh Quảng Bình","path_with_type":"Xã Tân Ninh, Huyện Quảng Ninh, Tỉnh Quảng Bình","code":"19234","parent_code":"456"},"19237":{"name":"Xã Xuân Ninh","type":"xa","slug":"xa-xuan-ninh","name_with_type":"Xã Xuân Ninh","path":"Xã Xuân Ninh, Huyện Quảng Ninh, Tỉnh Quảng Bình","path_with_type":"Xã Xuân Ninh, Huyện Quảng Ninh, Tỉnh Quảng Bình","code":"19237","parent_code":"456"},"19240":{"name":"Xã An Ninh","type":"xa","slug":"xa-an-ninh","name_with_type":"Xã An Ninh","path":"Xã An Ninh, Huyện Quảng Ninh, Tỉnh Quảng Bình","path_with_type":"Xã An Ninh, Huyện Quảng Ninh, Tỉnh Quảng Bình","code":"19240","parent_code":"456"},"19243":{"name":"Xã Vạn Ninh","type":"xa","slug":"xa-van-ninh","name_with_type":"Xã Vạn Ninh","path":"Xã Vạn Ninh, Huyện Quảng Ninh, Tỉnh Quảng Bình","path_with_type":"Xã Vạn Ninh, Huyện Quảng Ninh, Tỉnh Quảng Bình","code":"19243","parent_code":"456"},"19246":{"name":"Thị trấn NT Lệ Ninh","type":"thi-tran","slug":"thi-tran-nt-le-ninh","name_with_type":"Thị trấn NT Lệ Ninh","path":"Thị trấn NT Lệ Ninh, Huyện Lệ Thủy, Tỉnh Quảng Bình","path_with_type":"Thị trấn NT Lệ Ninh, Huyện Lệ Thủy, Tỉnh Quảng Bình","code":"19246","parent_code":"457"},"19249":{"name":"Thị trấn Kiến Giang","type":"thi-tran","slug":"thi-tran-kien-giang","name_with_type":"Thị trấn Kiến Giang","path":"Thị trấn Kiến Giang, Huyện Lệ Thủy, Tỉnh Quảng Bình","path_with_type":"Thị trấn Kiến Giang, Huyện Lệ Thủy, Tỉnh Quảng Bình","code":"19249","parent_code":"457"},"19252":{"name":"Xã Hồng Thủy","type":"xa","slug":"xa-hong-thuy","name_with_type":"Xã Hồng Thủy","path":"Xã Hồng Thủy, Huyện Lệ Thủy, Tỉnh Quảng Bình","path_with_type":"Xã Hồng Thủy, Huyện Lệ Thủy, Tỉnh Quảng Bình","code":"19252","parent_code":"457"},"19255":{"name":"Xã Ngư Thủy Bắc","type":"xa","slug":"xa-ngu-thuy-bac","name_with_type":"Xã Ngư Thủy Bắc","path":"Xã Ngư Thủy Bắc, Huyện Lệ Thủy, Tỉnh Quảng Bình","path_with_type":"Xã Ngư Thủy Bắc, Huyện Lệ Thủy, Tỉnh Quảng Bình","code":"19255","parent_code":"457"},"19258":{"name":"Xã Hoa Thủy","type":"xa","slug":"xa-hoa-thuy","name_with_type":"Xã Hoa Thủy","path":"Xã Hoa Thủy, Huyện Lệ Thủy, Tỉnh Quảng Bình","path_with_type":"Xã Hoa Thủy, Huyện Lệ Thủy, Tỉnh Quảng Bình","code":"19258","parent_code":"457"},"19261":{"name":"Xã Thanh Thủy","type":"xa","slug":"xa-thanh-thuy","name_with_type":"Xã Thanh Thủy","path":"Xã Thanh Thủy, Huyện Lệ Thủy, Tỉnh Quảng Bình","path_with_type":"Xã Thanh Thủy, Huyện Lệ Thủy, Tỉnh Quảng Bình","code":"19261","parent_code":"457"},"19264":{"name":"Xã An Thủy","type":"xa","slug":"xa-an-thuy","name_with_type":"Xã An Thủy","path":"Xã An Thủy, Huyện Lệ Thủy, Tỉnh Quảng Bình","path_with_type":"Xã An Thủy, Huyện Lệ Thủy, Tỉnh Quảng Bình","code":"19264","parent_code":"457"},"19267":{"name":"Xã Phong Thủy","type":"xa","slug":"xa-phong-thuy","name_with_type":"Xã Phong Thủy","path":"Xã Phong Thủy, Huyện Lệ Thủy, Tỉnh Quảng Bình","path_with_type":"Xã Phong Thủy, Huyện Lệ Thủy, Tỉnh Quảng Bình","code":"19267","parent_code":"457"},"19270":{"name":"Xã Cam Thủy","type":"xa","slug":"xa-cam-thuy","name_with_type":"Xã Cam Thủy","path":"Xã Cam Thủy, Huyện Lệ Thủy, Tỉnh Quảng Bình","path_with_type":"Xã Cam Thủy, Huyện Lệ Thủy, Tỉnh Quảng Bình","code":"19270","parent_code":"457"},"19273":{"name":"Xã Ngân Thủy","type":"xa","slug":"xa-ngan-thuy","name_with_type":"Xã Ngân Thủy","path":"Xã Ngân Thủy, Huyện Lệ Thủy, Tỉnh Quảng Bình","path_with_type":"Xã Ngân Thủy, Huyện Lệ Thủy, Tỉnh Quảng Bình","code":"19273","parent_code":"457"},"19276":{"name":"Xã Sơn Thủy","type":"xa","slug":"xa-son-thuy","name_with_type":"Xã Sơn Thủy","path":"Xã Sơn Thủy, Huyện Lệ Thủy, Tỉnh Quảng Bình","path_with_type":"Xã Sơn Thủy, Huyện Lệ Thủy, Tỉnh Quảng Bình","code":"19276","parent_code":"457"},"19279":{"name":"Xã Lộc Thủy","type":"xa","slug":"xa-loc-thuy","name_with_type":"Xã Lộc Thủy","path":"Xã Lộc Thủy, Huyện Lệ Thủy, Tỉnh Quảng Bình","path_with_type":"Xã Lộc Thủy, Huyện Lệ Thủy, Tỉnh Quảng Bình","code":"19279","parent_code":"457"},"19285":{"name":"Xã Liên Thủy","type":"xa","slug":"xa-lien-thuy","name_with_type":"Xã Liên Thủy","path":"Xã Liên Thủy, Huyện Lệ Thủy, Tỉnh Quảng Bình","path_with_type":"Xã Liên Thủy, Huyện Lệ Thủy, Tỉnh Quảng Bình","code":"19285","parent_code":"457"},"19288":{"name":"Xã Hưng Thủy","type":"xa","slug":"xa-hung-thuy","name_with_type":"Xã Hưng Thủy","path":"Xã Hưng Thủy, Huyện Lệ Thủy, Tỉnh Quảng Bình","path_with_type":"Xã Hưng Thủy, Huyện Lệ Thủy, Tỉnh Quảng Bình","code":"19288","parent_code":"457"},"19291":{"name":"Xã Dương Thủy","type":"xa","slug":"xa-duong-thuy","name_with_type":"Xã Dương Thủy","path":"Xã Dương Thủy, Huyện Lệ Thủy, Tỉnh Quảng Bình","path_with_type":"Xã Dương Thủy, Huyện Lệ Thủy, Tỉnh Quảng Bình","code":"19291","parent_code":"457"},"19294":{"name":"Xã Tân Thủy","type":"xa","slug":"xa-tan-thuy","name_with_type":"Xã Tân Thủy","path":"Xã Tân Thủy, Huyện Lệ Thủy, Tỉnh Quảng Bình","path_with_type":"Xã Tân Thủy, Huyện Lệ Thủy, Tỉnh Quảng Bình","code":"19294","parent_code":"457"},"19297":{"name":"Xã Phú Thủy","type":"xa","slug":"xa-phu-thuy","name_with_type":"Xã Phú Thủy","path":"Xã Phú Thủy, Huyện Lệ Thủy, Tỉnh Quảng Bình","path_with_type":"Xã Phú Thủy, Huyện Lệ Thủy, Tỉnh Quảng Bình","code":"19297","parent_code":"457"},"19300":{"name":"Xã Xuân Thủy","type":"xa","slug":"xa-xuan-thuy","name_with_type":"Xã Xuân Thủy","path":"Xã Xuân Thủy, Huyện Lệ Thủy, Tỉnh Quảng Bình","path_with_type":"Xã Xuân Thủy, Huyện Lệ Thủy, Tỉnh Quảng Bình","code":"19300","parent_code":"457"},"19303":{"name":"Xã Mỹ Thủy","type":"xa","slug":"xa-my-thuy","name_with_type":"Xã Mỹ Thủy","path":"Xã Mỹ Thủy, Huyện Lệ Thủy, Tỉnh Quảng Bình","path_with_type":"Xã Mỹ Thủy, Huyện Lệ Thủy, Tỉnh Quảng Bình","code":"19303","parent_code":"457"},"19306":{"name":"Xã Ngư Thủy ","type":"xa","slug":"xa-ngu-thuy-","name_with_type":"Xã Ngư Thủy ","path":"Xã Ngư Thủy , Huyện Lệ Thủy, Tỉnh Quảng Bình","path_with_type":"Xã Ngư Thủy , Huyện Lệ Thủy, Tỉnh Quảng Bình","code":"19306","parent_code":"457"},"19309":{"name":"Xã Mai Thủy","type":"xa","slug":"xa-mai-thuy","name_with_type":"Xã Mai Thủy","path":"Xã Mai Thủy, Huyện Lệ Thủy, Tỉnh Quảng Bình","path_with_type":"Xã Mai Thủy, Huyện Lệ Thủy, Tỉnh Quảng Bình","code":"19309","parent_code":"457"},"19312":{"name":"Xã Sen Thủy","type":"xa","slug":"xa-sen-thuy","name_with_type":"Xã Sen Thủy","path":"Xã Sen Thủy, Huyện Lệ Thủy, Tỉnh Quảng Bình","path_with_type":"Xã Sen Thủy, Huyện Lệ Thủy, Tỉnh Quảng Bình","code":"19312","parent_code":"457"},"19315":{"name":"Xã Thái Thủy","type":"xa","slug":"xa-thai-thuy","name_with_type":"Xã Thái Thủy","path":"Xã Thái Thủy, Huyện Lệ Thủy, Tỉnh Quảng Bình","path_with_type":"Xã Thái Thủy, Huyện Lệ Thủy, Tỉnh Quảng Bình","code":"19315","parent_code":"457"},"19318":{"name":"Xã Kim Thủy","type":"xa","slug":"xa-kim-thuy","name_with_type":"Xã Kim Thủy","path":"Xã Kim Thủy, Huyện Lệ Thủy, Tỉnh Quảng Bình","path_with_type":"Xã Kim Thủy, Huyện Lệ Thủy, Tỉnh Quảng Bình","code":"19318","parent_code":"457"},"19321":{"name":"Xã Trường Thủy","type":"xa","slug":"xa-truong-thuy","name_with_type":"Xã Trường Thủy","path":"Xã Trường Thủy, Huyện Lệ Thủy, Tỉnh Quảng Bình","path_with_type":"Xã Trường Thủy, Huyện Lệ Thủy, Tỉnh Quảng Bình","code":"19321","parent_code":"457"},"19327":{"name":"Xã Lâm Thủy","type":"xa","slug":"xa-lam-thuy","name_with_type":"Xã Lâm Thủy","path":"Xã Lâm Thủy, Huyện Lệ Thủy, Tỉnh Quảng Bình","path_with_type":"Xã Lâm Thủy, Huyện Lệ Thủy, Tỉnh Quảng Bình","code":"19327","parent_code":"457"},"19330":{"name":"Phường Đông Giang","type":"phuong","slug":"phuong-dong-giang","name_with_type":"Phường Đông Giang","path":"Phường Đông Giang, Thành phố Đông Hà, Tỉnh Quảng Trị","path_with_type":"Phường Đông Giang, Thành phố Đông Hà, Tỉnh Quảng Trị","code":"19330","parent_code":"461"},"19333":{"name":"Phường 1","type":"phuong","slug":"phuong-1","name_with_type":"Phường 1","path":"Phường 1, Thành phố Đông Hà, Tỉnh Quảng Trị","path_with_type":"Phường 1, Thành phố Đông Hà, Tỉnh Quảng Trị","code":"19333","parent_code":"461"},"19336":{"name":"Phường Đông Lễ","type":"phuong","slug":"phuong-dong-le","name_with_type":"Phường Đông Lễ","path":"Phường Đông Lễ, Thành phố Đông Hà, Tỉnh Quảng Trị","path_with_type":"Phường Đông Lễ, Thành phố Đông Hà, Tỉnh Quảng Trị","code":"19336","parent_code":"461"},"19339":{"name":"Phường Đông Thanh","type":"phuong","slug":"phuong-dong-thanh","name_with_type":"Phường Đông Thanh","path":"Phường Đông Thanh, Thành phố Đông Hà, Tỉnh Quảng Trị","path_with_type":"Phường Đông Thanh, Thành phố Đông Hà, Tỉnh Quảng Trị","code":"19339","parent_code":"461"},"19342":{"name":"Phường 2","type":"phuong","slug":"phuong-2","name_with_type":"Phường 2","path":"Phường 2, Thành phố Đông Hà, Tỉnh Quảng Trị","path_with_type":"Phường 2, Thành phố Đông Hà, Tỉnh Quảng Trị","code":"19342","parent_code":"461"},"19345":{"name":"Phường 4","type":"phuong","slug":"phuong-4","name_with_type":"Phường 4","path":"Phường 4, Thành phố Đông Hà, Tỉnh Quảng Trị","path_with_type":"Phường 4, Thành phố Đông Hà, Tỉnh Quảng Trị","code":"19345","parent_code":"461"},"19348":{"name":"Phường 5","type":"phuong","slug":"phuong-5","name_with_type":"Phường 5","path":"Phường 5, Thành phố Đông Hà, Tỉnh Quảng Trị","path_with_type":"Phường 5, Thành phố Đông Hà, Tỉnh Quảng Trị","code":"19348","parent_code":"461"},"19351":{"name":"Phường Đông Lương","type":"phuong","slug":"phuong-dong-luong","name_with_type":"Phường Đông Lương","path":"Phường Đông Lương, Thành phố Đông Hà, Tỉnh Quảng Trị","path_with_type":"Phường Đông Lương, Thành phố Đông Hà, Tỉnh Quảng Trị","code":"19351","parent_code":"461"},"19354":{"name":"Phường 3","type":"phuong","slug":"phuong-3","name_with_type":"Phường 3","path":"Phường 3, Thành phố Đông Hà, Tỉnh Quảng Trị","path_with_type":"Phường 3, Thành phố Đông Hà, Tỉnh Quảng Trị","code":"19354","parent_code":"461"},"19357":{"name":"Phường 1","type":"phuong","slug":"phuong-1","name_with_type":"Phường 1","path":"Phường 1, Thị xã Quảng Trị, Tỉnh Quảng Trị","path_with_type":"Phường 1, Thị xã Quảng Trị, Tỉnh Quảng Trị","code":"19357","parent_code":"462"},"19358":{"name":"Phường An Đôn","type":"phuong","slug":"phuong-an-don","name_with_type":"Phường An Đôn","path":"Phường An Đôn, Thị xã Quảng Trị, Tỉnh Quảng Trị","path_with_type":"Phường An Đôn, Thị xã Quảng Trị, Tỉnh Quảng Trị","code":"19358","parent_code":"462"},"19360":{"name":"Phường 2","type":"phuong","slug":"phuong-2","name_with_type":"Phường 2","path":"Phường 2, Thị xã Quảng Trị, Tỉnh Quảng Trị","path_with_type":"Phường 2, Thị xã Quảng Trị, Tỉnh Quảng Trị","code":"19360","parent_code":"462"},"19361":{"name":"Phường 3","type":"phuong","slug":"phuong-3","name_with_type":"Phường 3","path":"Phường 3, Thị xã Quảng Trị, Tỉnh Quảng Trị","path_with_type":"Phường 3, Thị xã Quảng Trị, Tỉnh Quảng Trị","code":"19361","parent_code":"462"},"19363":{"name":"Thị trấn Hồ Xá","type":"thi-tran","slug":"thi-tran-ho-xa","name_with_type":"Thị trấn Hồ Xá","path":"Thị trấn Hồ Xá, Huyện Vĩnh Linh, Tỉnh Quảng Trị","path_with_type":"Thị trấn Hồ Xá, Huyện Vĩnh Linh, Tỉnh Quảng Trị","code":"19363","parent_code":"464"},"19366":{"name":"Thị trấn Bến Quan","type":"thi-tran","slug":"thi-tran-ben-quan","name_with_type":"Thị trấn Bến Quan","path":"Thị trấn Bến Quan, Huyện Vĩnh Linh, Tỉnh Quảng Trị","path_with_type":"Thị trấn Bến Quan, Huyện Vĩnh Linh, Tỉnh Quảng Trị","code":"19366","parent_code":"464"},"19369":{"name":"Xã Vĩnh Thái","type":"xa","slug":"xa-vinh-thai","name_with_type":"Xã Vĩnh Thái","path":"Xã Vĩnh Thái, Huyện Vĩnh Linh, Tỉnh Quảng Trị","path_with_type":"Xã Vĩnh Thái, Huyện Vĩnh Linh, Tỉnh Quảng Trị","code":"19369","parent_code":"464"},"19372":{"name":"Xã Vĩnh Tú","type":"xa","slug":"xa-vinh-tu","name_with_type":"Xã Vĩnh Tú","path":"Xã Vĩnh Tú, Huyện Vĩnh Linh, Tỉnh Quảng Trị","path_with_type":"Xã Vĩnh Tú, Huyện Vĩnh Linh, Tỉnh Quảng Trị","code":"19372","parent_code":"464"},"19375":{"name":"Xã Vĩnh Chấp","type":"xa","slug":"xa-vinh-chap","name_with_type":"Xã Vĩnh Chấp","path":"Xã Vĩnh Chấp, Huyện Vĩnh Linh, Tỉnh Quảng Trị","path_with_type":"Xã Vĩnh Chấp, Huyện Vĩnh Linh, Tỉnh Quảng Trị","code":"19375","parent_code":"464"},"19378":{"name":"Xã Trung Nam","type":"xa","slug":"xa-trung-nam","name_with_type":"Xã Trung Nam","path":"Xã Trung Nam, Huyện Vĩnh Linh, Tỉnh Quảng Trị","path_with_type":"Xã Trung Nam, Huyện Vĩnh Linh, Tỉnh Quảng Trị","code":"19378","parent_code":"464"},"19384":{"name":"Xã Kim Thạch","type":"xa","slug":"xa-kim-thach","name_with_type":"Xã Kim Thạch","path":"Xã Kim Thạch, Huyện Vĩnh Linh, Tỉnh Quảng Trị","path_with_type":"Xã Kim Thạch, Huyện Vĩnh Linh, Tỉnh Quảng Trị","code":"19384","parent_code":"464"},"19387":{"name":"Xã Vĩnh Long","type":"xa","slug":"xa-vinh-long","name_with_type":"Xã Vĩnh Long","path":"Xã Vĩnh Long, Huyện Vĩnh Linh, Tỉnh Quảng Trị","path_with_type":"Xã Vĩnh Long, Huyện Vĩnh Linh, Tỉnh Quảng Trị","code":"19387","parent_code":"464"},"19393":{"name":"Xã Vĩnh Khê","type":"xa","slug":"xa-vinh-khe","name_with_type":"Xã Vĩnh Khê","path":"Xã Vĩnh Khê, Huyện Vĩnh Linh, Tỉnh Quảng Trị","path_with_type":"Xã Vĩnh Khê, Huyện Vĩnh Linh, Tỉnh Quảng Trị","code":"19393","parent_code":"464"},"19396":{"name":"Xã Vĩnh Hòa","type":"xa","slug":"xa-vinh-hoa","name_with_type":"Xã Vĩnh Hòa","path":"Xã Vĩnh Hòa, Huyện Vĩnh Linh, Tỉnh Quảng Trị","path_with_type":"Xã Vĩnh Hòa, Huyện Vĩnh Linh, Tỉnh Quảng Trị","code":"19396","parent_code":"464"},"19402":{"name":"Xã Vĩnh Thủy","type":"xa","slug":"xa-vinh-thuy","name_with_type":"Xã Vĩnh Thủy","path":"Xã Vĩnh Thủy, Huyện Vĩnh Linh, Tỉnh Quảng Trị","path_with_type":"Xã Vĩnh Thủy, Huyện Vĩnh Linh, Tỉnh Quảng Trị","code":"19402","parent_code":"464"},"19405":{"name":"Xã Vĩnh Lâm","type":"xa","slug":"xa-vinh-lam","name_with_type":"Xã Vĩnh Lâm","path":"Xã Vĩnh Lâm, Huyện Vĩnh Linh, Tỉnh Quảng Trị","path_with_type":"Xã Vĩnh Lâm, Huyện Vĩnh Linh, Tỉnh Quảng Trị","code":"19405","parent_code":"464"},"19408":{"name":"Xã Hiền Thành","type":"xa","slug":"xa-hien-thanh","name_with_type":"Xã Hiền Thành","path":"Xã Hiền Thành, Huyện Vĩnh Linh, Tỉnh Quảng Trị","path_with_type":"Xã Hiền Thành, Huyện Vĩnh Linh, Tỉnh Quảng Trị","code":"19408","parent_code":"464"},"19414":{"name":"Thị trấn Cửa Tùng","type":"thi-tran","slug":"thi-tran-cua-tung","name_with_type":"Thị trấn Cửa Tùng","path":"Thị trấn Cửa Tùng, Huyện Vĩnh Linh, Tỉnh Quảng Trị","path_with_type":"Thị trấn Cửa Tùng, Huyện Vĩnh Linh, Tỉnh Quảng Trị","code":"19414","parent_code":"464"},"19417":{"name":"Xã Vĩnh Hà","type":"xa","slug":"xa-vinh-ha","name_with_type":"Xã Vĩnh Hà","path":"Xã Vĩnh Hà, Huyện Vĩnh Linh, Tỉnh Quảng Trị","path_with_type":"Xã Vĩnh Hà, Huyện Vĩnh Linh, Tỉnh Quảng Trị","code":"19417","parent_code":"464"},"19420":{"name":"Xã Vĩnh Sơn","type":"xa","slug":"xa-vinh-son","name_with_type":"Xã Vĩnh Sơn","path":"Xã Vĩnh Sơn, Huyện Vĩnh Linh, Tỉnh Quảng Trị","path_with_type":"Xã Vĩnh Sơn, Huyện Vĩnh Linh, Tỉnh Quảng Trị","code":"19420","parent_code":"464"},"19423":{"name":"Xã Vĩnh Giang","type":"xa","slug":"xa-vinh-giang","name_with_type":"Xã Vĩnh Giang","path":"Xã Vĩnh Giang, Huyện Vĩnh Linh, Tỉnh Quảng Trị","path_with_type":"Xã Vĩnh Giang, Huyện Vĩnh Linh, Tỉnh Quảng Trị","code":"19423","parent_code":"464"},"19426":{"name":"Xã Vĩnh Ô","type":"xa","slug":"xa-vinh-o","name_with_type":"Xã Vĩnh Ô","path":"Xã Vĩnh Ô, Huyện Vĩnh Linh, Tỉnh Quảng Trị","path_with_type":"Xã Vĩnh Ô, Huyện Vĩnh Linh, Tỉnh Quảng Trị","code":"19426","parent_code":"464"},"19429":{"name":"Thị trấn Khe Sanh","type":"thi-tran","slug":"thi-tran-khe-sanh","name_with_type":"Thị trấn Khe Sanh","path":"Thị trấn Khe Sanh, Huyện Hướng Hóa, Tỉnh Quảng Trị","path_with_type":"Thị trấn Khe Sanh, Huyện Hướng Hóa, Tỉnh Quảng Trị","code":"19429","parent_code":"465"},"19432":{"name":"Thị trấn Lao Bảo","type":"thi-tran","slug":"thi-tran-lao-bao","name_with_type":"Thị trấn Lao Bảo","path":"Thị trấn Lao Bảo, Huyện Hướng Hóa, Tỉnh Quảng Trị","path_with_type":"Thị trấn Lao Bảo, Huyện Hướng Hóa, Tỉnh Quảng Trị","code":"19432","parent_code":"465"},"19435":{"name":"Xã Hướng Lập","type":"xa","slug":"xa-huong-lap","name_with_type":"Xã Hướng Lập","path":"Xã Hướng Lập, Huyện Hướng Hóa, Tỉnh Quảng Trị","path_with_type":"Xã Hướng Lập, Huyện Hướng Hóa, Tỉnh Quảng Trị","code":"19435","parent_code":"465"},"19438":{"name":"Xã Hướng Việt","type":"xa","slug":"xa-huong-viet","name_with_type":"Xã Hướng Việt","path":"Xã Hướng Việt, Huyện Hướng Hóa, Tỉnh Quảng Trị","path_with_type":"Xã Hướng Việt, Huyện Hướng Hóa, Tỉnh Quảng Trị","code":"19438","parent_code":"465"},"19441":{"name":"Xã Hướng Phùng","type":"xa","slug":"xa-huong-phung","name_with_type":"Xã Hướng Phùng","path":"Xã Hướng Phùng, Huyện Hướng Hóa, Tỉnh Quảng Trị","path_with_type":"Xã Hướng Phùng, Huyện Hướng Hóa, Tỉnh Quảng Trị","code":"19441","parent_code":"465"},"19444":{"name":"Xã Hướng Sơn","type":"xa","slug":"xa-huong-son","name_with_type":"Xã Hướng Sơn","path":"Xã Hướng Sơn, Huyện Hướng Hóa, Tỉnh Quảng Trị","path_with_type":"Xã Hướng Sơn, Huyện Hướng Hóa, Tỉnh Quảng Trị","code":"19444","parent_code":"465"},"19447":{"name":"Xã Hướng Linh","type":"xa","slug":"xa-huong-linh","name_with_type":"Xã Hướng Linh","path":"Xã Hướng Linh, Huyện Hướng Hóa, Tỉnh Quảng Trị","path_with_type":"Xã Hướng Linh, Huyện Hướng Hóa, Tỉnh Quảng Trị","code":"19447","parent_code":"465"},"19450":{"name":"Xã Tân Hợp","type":"xa","slug":"xa-tan-hop","name_with_type":"Xã Tân Hợp","path":"Xã Tân Hợp, Huyện Hướng Hóa, Tỉnh Quảng Trị","path_with_type":"Xã Tân Hợp, Huyện Hướng Hóa, Tỉnh Quảng Trị","code":"19450","parent_code":"465"},"19453":{"name":"Xã Hướng Tân","type":"xa","slug":"xa-huong-tan","name_with_type":"Xã Hướng Tân","path":"Xã Hướng Tân, Huyện Hướng Hóa, Tỉnh Quảng Trị","path_with_type":"Xã Hướng Tân, Huyện Hướng Hóa, Tỉnh Quảng Trị","code":"19453","parent_code":"465"},"19456":{"name":"Xã Tân Thành","type":"xa","slug":"xa-tan-thanh","name_with_type":"Xã Tân Thành","path":"Xã Tân Thành, Huyện Hướng Hóa, Tỉnh Quảng Trị","path_with_type":"Xã Tân Thành, Huyện Hướng Hóa, Tỉnh Quảng Trị","code":"19456","parent_code":"465"},"19459":{"name":"Xã Tân Long","type":"xa","slug":"xa-tan-long","name_with_type":"Xã Tân Long","path":"Xã Tân Long, Huyện Hướng Hóa, Tỉnh Quảng Trị","path_with_type":"Xã Tân Long, Huyện Hướng Hóa, Tỉnh Quảng Trị","code":"19459","parent_code":"465"},"19462":{"name":"Xã Tân Lập","type":"xa","slug":"xa-tan-lap","name_with_type":"Xã Tân Lập","path":"Xã Tân Lập, Huyện Hướng Hóa, Tỉnh Quảng Trị","path_with_type":"Xã Tân Lập, Huyện Hướng Hóa, Tỉnh Quảng Trị","code":"19462","parent_code":"465"},"19465":{"name":"Xã Tân Liên","type":"xa","slug":"xa-tan-lien","name_with_type":"Xã Tân Liên","path":"Xã Tân Liên, Huyện Hướng Hóa, Tỉnh Quảng Trị","path_with_type":"Xã Tân Liên, Huyện Hướng Hóa, Tỉnh Quảng Trị","code":"19465","parent_code":"465"},"19468":{"name":"Xã Húc","type":"xa","slug":"xa-huc","name_with_type":"Xã Húc","path":"Xã Húc, Huyện Hướng Hóa, Tỉnh Quảng Trị","path_with_type":"Xã Húc, Huyện Hướng Hóa, Tỉnh Quảng Trị","code":"19468","parent_code":"465"},"19471":{"name":"Xã Thuận","type":"xa","slug":"xa-thuan","name_with_type":"Xã Thuận","path":"Xã Thuận, Huyện Hướng Hóa, Tỉnh Quảng Trị","path_with_type":"Xã Thuận, Huyện Hướng Hóa, Tỉnh Quảng Trị","code":"19471","parent_code":"465"},"19474":{"name":"Xã Hướng Lộc","type":"xa","slug":"xa-huong-loc","name_with_type":"Xã Hướng Lộc","path":"Xã Hướng Lộc, Huyện Hướng Hóa, Tỉnh Quảng Trị","path_with_type":"Xã Hướng Lộc, Huyện Hướng Hóa, Tỉnh Quảng Trị","code":"19474","parent_code":"465"},"19477":{"name":"Xã Ba Tầng","type":"xa","slug":"xa-ba-tang","name_with_type":"Xã Ba Tầng","path":"Xã Ba Tầng, Huyện Hướng Hóa, Tỉnh Quảng Trị","path_with_type":"Xã Ba Tầng, Huyện Hướng Hóa, Tỉnh Quảng Trị","code":"19477","parent_code":"465"},"19480":{"name":"Xã Thanh","type":"xa","slug":"xa-thanh","name_with_type":"Xã Thanh","path":"Xã Thanh, Huyện Hướng Hóa, Tỉnh Quảng Trị","path_with_type":"Xã Thanh, Huyện Hướng Hóa, Tỉnh Quảng Trị","code":"19480","parent_code":"465"},"19483":{"name":"Xã  A Dơi","type":"xa","slug":"xa-a-doi","name_with_type":"Xã  A Dơi","path":"Xã  A Dơi, Huyện Hướng Hóa, Tỉnh Quảng Trị","path_with_type":"Xã  A Dơi, Huyện Hướng Hóa, Tỉnh Quảng Trị","code":"19483","parent_code":"465"},"19489":{"name":"Xã Lìa","type":"xa","slug":"xa-lia","name_with_type":"Xã Lìa","path":"Xã Lìa, Huyện Hướng Hóa, Tỉnh Quảng Trị","path_with_type":"Xã Lìa, Huyện Hướng Hóa, Tỉnh Quảng Trị","code":"19489","parent_code":"465"},"19492":{"name":"Xã Xy","type":"xa","slug":"xa-xy","name_with_type":"Xã Xy","path":"Xã Xy, Huyện Hướng Hóa, Tỉnh Quảng Trị","path_with_type":"Xã Xy, Huyện Hướng Hóa, Tỉnh Quảng Trị","code":"19492","parent_code":"465"},"19495":{"name":"Thị trấn Gio Linh","type":"thi-tran","slug":"thi-tran-gio-linh","name_with_type":"Thị trấn Gio Linh","path":"Thị trấn Gio Linh, Huyện Gio Linh, Tỉnh Quảng Trị","path_with_type":"Thị trấn Gio Linh, Huyện Gio Linh, Tỉnh Quảng Trị","code":"19495","parent_code":"466"},"19496":{"name":"Thị trấn Cửa Việt","type":"thi-tran","slug":"thi-tran-cua-viet","name_with_type":"Thị trấn Cửa Việt","path":"Thị trấn Cửa Việt, Huyện Gio Linh, Tỉnh Quảng Trị","path_with_type":"Thị trấn Cửa Việt, Huyện Gio Linh, Tỉnh Quảng Trị","code":"19496","parent_code":"466"},"19498":{"name":"Xã Trung Giang","type":"xa","slug":"xa-trung-giang","name_with_type":"Xã Trung Giang","path":"Xã Trung Giang, Huyện Gio Linh, Tỉnh Quảng Trị","path_with_type":"Xã Trung Giang, Huyện Gio Linh, Tỉnh Quảng Trị","code":"19498","parent_code":"466"},"19501":{"name":"Xã Trung Hải","type":"xa","slug":"xa-trung-hai","name_with_type":"Xã Trung Hải","path":"Xã Trung Hải, Huyện Gio Linh, Tỉnh Quảng Trị","path_with_type":"Xã Trung Hải, Huyện Gio Linh, Tỉnh Quảng Trị","code":"19501","parent_code":"466"},"19504":{"name":"Xã Trung Sơn","type":"xa","slug":"xa-trung-son","name_with_type":"Xã Trung Sơn","path":"Xã Trung Sơn, Huyện Gio Linh, Tỉnh Quảng Trị","path_with_type":"Xã Trung Sơn, Huyện Gio Linh, Tỉnh Quảng Trị","code":"19504","parent_code":"466"},"19507":{"name":"Xã Phong Bình","type":"xa","slug":"xa-phong-binh","name_with_type":"Xã Phong Bình","path":"Xã Phong Bình, Huyện Gio Linh, Tỉnh Quảng Trị","path_with_type":"Xã Phong Bình, Huyện Gio Linh, Tỉnh Quảng Trị","code":"19507","parent_code":"466"},"19510":{"name":"Xã Gio Mỹ","type":"xa","slug":"xa-gio-my","name_with_type":"Xã Gio Mỹ","path":"Xã Gio Mỹ, Huyện Gio Linh, Tỉnh Quảng Trị","path_with_type":"Xã Gio Mỹ, Huyện Gio Linh, Tỉnh Quảng Trị","code":"19510","parent_code":"466"},"19519":{"name":"Xã Gio Hải","type":"xa","slug":"xa-gio-hai","name_with_type":"Xã Gio Hải","path":"Xã Gio Hải, Huyện Gio Linh, Tỉnh Quảng Trị","path_with_type":"Xã Gio Hải, Huyện Gio Linh, Tỉnh Quảng Trị","code":"19519","parent_code":"466"},"19522":{"name":"Xã Gio An","type":"xa","slug":"xa-gio-an","name_with_type":"Xã Gio An","path":"Xã Gio An, Huyện Gio Linh, Tỉnh Quảng Trị","path_with_type":"Xã Gio An, Huyện Gio Linh, Tỉnh Quảng Trị","code":"19522","parent_code":"466"},"19525":{"name":"Xã Gio Châu","type":"xa","slug":"xa-gio-chau","name_with_type":"Xã Gio Châu","path":"Xã Gio Châu, Huyện Gio Linh, Tỉnh Quảng Trị","path_with_type":"Xã Gio Châu, Huyện Gio Linh, Tỉnh Quảng Trị","code":"19525","parent_code":"466"},"19531":{"name":"Xã Gio Việt","type":"xa","slug":"xa-gio-viet","name_with_type":"Xã Gio Việt","path":"Xã Gio Việt, Huyện Gio Linh, Tỉnh Quảng Trị","path_with_type":"Xã Gio Việt, Huyện Gio Linh, Tỉnh Quảng Trị","code":"19531","parent_code":"466"},"19534":{"name":"Xã Linh Trường","type":"xa","slug":"xa-linh-truong","name_with_type":"Xã Linh Trường","path":"Xã Linh Trường, Huyện Gio Linh, Tỉnh Quảng Trị","path_with_type":"Xã Linh Trường, Huyện Gio Linh, Tỉnh Quảng Trị","code":"19534","parent_code":"466"},"19537":{"name":"Xã Gio Sơn","type":"xa","slug":"xa-gio-son","name_with_type":"Xã Gio Sơn","path":"Xã Gio Sơn, Huyện Gio Linh, Tỉnh Quảng Trị","path_with_type":"Xã Gio Sơn, Huyện Gio Linh, Tỉnh Quảng Trị","code":"19537","parent_code":"466"},"19543":{"name":"Xã Gio Mai","type":"xa","slug":"xa-gio-mai","name_with_type":"Xã Gio Mai","path":"Xã Gio Mai, Huyện Gio Linh, Tỉnh Quảng Trị","path_with_type":"Xã Gio Mai, Huyện Gio Linh, Tỉnh Quảng Trị","code":"19543","parent_code":"466"},"19546":{"name":"Xã Hải Thái","type":"xa","slug":"xa-hai-thai","name_with_type":"Xã Hải Thái","path":"Xã Hải Thái, Huyện Gio Linh, Tỉnh Quảng Trị","path_with_type":"Xã Hải Thái, Huyện Gio Linh, Tỉnh Quảng Trị","code":"19546","parent_code":"466"},"19549":{"name":"Xã Linh Hải","type":"xa","slug":"xa-linh-hai","name_with_type":"Xã Linh Hải","path":"Xã Linh Hải, Huyện Gio Linh, Tỉnh Quảng Trị","path_with_type":"Xã Linh Hải, Huyện Gio Linh, Tỉnh Quảng Trị","code":"19549","parent_code":"466"},"19552":{"name":"Xã Gio Quang","type":"xa","slug":"xa-gio-quang","name_with_type":"Xã Gio Quang","path":"Xã Gio Quang, Huyện Gio Linh, Tỉnh Quảng Trị","path_with_type":"Xã Gio Quang, Huyện Gio Linh, Tỉnh Quảng Trị","code":"19552","parent_code":"466"},"19555":{"name":"Thị trấn Krông Klang","type":"thi-tran","slug":"thi-tran-krong-klang","name_with_type":"Thị trấn Krông Klang","path":"Thị trấn Krông Klang, Huyện Đa Krông, Tỉnh Quảng Trị","path_with_type":"Thị trấn Krông Klang, Huyện Đa Krông, Tỉnh Quảng Trị","code":"19555","parent_code":"467"},"19558":{"name":"Xã Mò Ó","type":"xa","slug":"xa-mo-o","name_with_type":"Xã Mò Ó","path":"Xã Mò Ó, Huyện Đa Krông, Tỉnh Quảng Trị","path_with_type":"Xã Mò Ó, Huyện Đa Krông, Tỉnh Quảng Trị","code":"19558","parent_code":"467"},"19561":{"name":"Xã Hướng Hiệp","type":"xa","slug":"xa-huong-hiep","name_with_type":"Xã Hướng Hiệp","path":"Xã Hướng Hiệp, Huyện Đa Krông, Tỉnh Quảng Trị","path_with_type":"Xã Hướng Hiệp, Huyện Đa Krông, Tỉnh Quảng Trị","code":"19561","parent_code":"467"},"19564":{"name":"Xã Đa Krông","type":"xa","slug":"xa-da-krong","name_with_type":"Xã Đa Krông","path":"Xã Đa Krông, Huyện Đa Krông, Tỉnh Quảng Trị","path_with_type":"Xã Đa Krông, Huyện Đa Krông, Tỉnh Quảng Trị","code":"19564","parent_code":"467"},"19567":{"name":"Xã Triệu Nguyên","type":"xa","slug":"xa-trieu-nguyen","name_with_type":"Xã Triệu Nguyên","path":"Xã Triệu Nguyên, Huyện Đa Krông, Tỉnh Quảng Trị","path_with_type":"Xã Triệu Nguyên, Huyện Đa Krông, Tỉnh Quảng Trị","code":"19567","parent_code":"467"},"19570":{"name":"Xã Ba Lòng","type":"xa","slug":"xa-ba-long","name_with_type":"Xã Ba Lòng","path":"Xã Ba Lòng, Huyện Đa Krông, Tỉnh Quảng Trị","path_with_type":"Xã Ba Lòng, Huyện Đa Krông, Tỉnh Quảng Trị","code":"19570","parent_code":"467"},"19576":{"name":"Xã Ba Nang","type":"xa","slug":"xa-ba-nang","name_with_type":"Xã Ba Nang","path":"Xã Ba Nang, Huyện Đa Krông, Tỉnh Quảng Trị","path_with_type":"Xã Ba Nang, Huyện Đa Krông, Tỉnh Quảng Trị","code":"19576","parent_code":"467"},"19579":{"name":"Xã Tà Long","type":"xa","slug":"xa-ta-long","name_with_type":"Xã Tà Long","path":"Xã Tà Long, Huyện Đa Krông, Tỉnh Quảng Trị","path_with_type":"Xã Tà Long, Huyện Đa Krông, Tỉnh Quảng Trị","code":"19579","parent_code":"467"},"19582":{"name":"Xã Húc Nghì","type":"xa","slug":"xa-huc-nghi","name_with_type":"Xã Húc Nghì","path":"Xã Húc Nghì, Huyện Đa Krông, Tỉnh Quảng Trị","path_with_type":"Xã Húc Nghì, Huyện Đa Krông, Tỉnh Quảng Trị","code":"19582","parent_code":"467"},"19585":{"name":"Xã A Vao","type":"xa","slug":"xa-a-vao","name_with_type":"Xã A Vao","path":"Xã A Vao, Huyện Đa Krông, Tỉnh Quảng Trị","path_with_type":"Xã A Vao, Huyện Đa Krông, Tỉnh Quảng Trị","code":"19585","parent_code":"467"},"19588":{"name":"Xã Tà Rụt","type":"xa","slug":"xa-ta-rut","name_with_type":"Xã Tà Rụt","path":"Xã Tà Rụt, Huyện Đa Krông, Tỉnh Quảng Trị","path_with_type":"Xã Tà Rụt, Huyện Đa Krông, Tỉnh Quảng Trị","code":"19588","parent_code":"467"},"19591":{"name":"Xã A Bung","type":"xa","slug":"xa-a-bung","name_with_type":"Xã A Bung","path":"Xã A Bung, Huyện Đa Krông, Tỉnh Quảng Trị","path_with_type":"Xã A Bung, Huyện Đa Krông, Tỉnh Quảng Trị","code":"19591","parent_code":"467"},"19594":{"name":"Xã A Ngo","type":"xa","slug":"xa-a-ngo","name_with_type":"Xã A Ngo","path":"Xã A Ngo, Huyện Đa Krông, Tỉnh Quảng Trị","path_with_type":"Xã A Ngo, Huyện Đa Krông, Tỉnh Quảng Trị","code":"19594","parent_code":"467"},"19597":{"name":"Thị trấn Cam Lộ","type":"thi-tran","slug":"thi-tran-cam-lo","name_with_type":"Thị trấn Cam Lộ","path":"Thị trấn Cam Lộ, Huyện Cam Lộ, Tỉnh Quảng Trị","path_with_type":"Thị trấn Cam Lộ, Huyện Cam Lộ, Tỉnh Quảng Trị","code":"19597","parent_code":"468"},"19600":{"name":"Xã Cam Tuyền","type":"xa","slug":"xa-cam-tuyen","name_with_type":"Xã Cam Tuyền","path":"Xã Cam Tuyền, Huyện Cam Lộ, Tỉnh Quảng Trị","path_with_type":"Xã Cam Tuyền, Huyện Cam Lộ, Tỉnh Quảng Trị","code":"19600","parent_code":"468"},"19603":{"name":"Xã Thanh An","type":"xa","slug":"xa-thanh-an","name_with_type":"Xã Thanh An","path":"Xã Thanh An, Huyện Cam Lộ, Tỉnh Quảng Trị","path_with_type":"Xã Thanh An, Huyện Cam Lộ, Tỉnh Quảng Trị","code":"19603","parent_code":"468"},"19606":{"name":"Xã Cam Thủy","type":"xa","slug":"xa-cam-thuy","name_with_type":"Xã Cam Thủy","path":"Xã Cam Thủy, Huyện Cam Lộ, Tỉnh Quảng Trị","path_with_type":"Xã Cam Thủy, Huyện Cam Lộ, Tỉnh Quảng Trị","code":"19606","parent_code":"468"},"19612":{"name":"Xã Cam Thành","type":"xa","slug":"xa-cam-thanh","name_with_type":"Xã Cam Thành","path":"Xã Cam Thành, Huyện Cam Lộ, Tỉnh Quảng Trị","path_with_type":"Xã Cam Thành, Huyện Cam Lộ, Tỉnh Quảng Trị","code":"19612","parent_code":"468"},"19615":{"name":"Xã Cam Hiếu","type":"xa","slug":"xa-cam-hieu","name_with_type":"Xã Cam Hiếu","path":"Xã Cam Hiếu, Huyện Cam Lộ, Tỉnh Quảng Trị","path_with_type":"Xã Cam Hiếu, Huyện Cam Lộ, Tỉnh Quảng Trị","code":"19615","parent_code":"468"},"19618":{"name":"Xã Cam Chính","type":"xa","slug":"xa-cam-chinh","name_with_type":"Xã Cam Chính","path":"Xã Cam Chính, Huyện Cam Lộ, Tỉnh Quảng Trị","path_with_type":"Xã Cam Chính, Huyện Cam Lộ, Tỉnh Quảng Trị","code":"19618","parent_code":"468"},"19621":{"name":"Xã Cam Nghĩa","type":"xa","slug":"xa-cam-nghia","name_with_type":"Xã Cam Nghĩa","path":"Xã Cam Nghĩa, Huyện Cam Lộ, Tỉnh Quảng Trị","path_with_type":"Xã Cam Nghĩa, Huyện Cam Lộ, Tỉnh Quảng Trị","code":"19621","parent_code":"468"},"19624":{"name":"Thị Trấn Ái Tử","type":"thi-tran","slug":"thi-tran-ai-tu","name_with_type":"Thị Trấn Ái Tử","path":"Thị Trấn Ái Tử, Huyện Triệu Phong, Tỉnh Quảng Trị","path_with_type":"Thị Trấn Ái Tử, Huyện Triệu Phong, Tỉnh Quảng Trị","code":"19624","parent_code":"469"},"19627":{"name":"Xã Triệu An","type":"xa","slug":"xa-trieu-an","name_with_type":"Xã Triệu An","path":"Xã Triệu An, Huyện Triệu Phong, Tỉnh Quảng Trị","path_with_type":"Xã Triệu An, Huyện Triệu Phong, Tỉnh Quảng Trị","code":"19627","parent_code":"469"},"19630":{"name":"Xã Triệu Vân","type":"xa","slug":"xa-trieu-van","name_with_type":"Xã Triệu Vân","path":"Xã Triệu Vân, Huyện Triệu Phong, Tỉnh Quảng Trị","path_with_type":"Xã Triệu Vân, Huyện Triệu Phong, Tỉnh Quảng Trị","code":"19630","parent_code":"469"},"19633":{"name":"Xã Triệu Phước","type":"xa","slug":"xa-trieu-phuoc","name_with_type":"Xã Triệu Phước","path":"Xã Triệu Phước, Huyện Triệu Phong, Tỉnh Quảng Trị","path_with_type":"Xã Triệu Phước, Huyện Triệu Phong, Tỉnh Quảng Trị","code":"19633","parent_code":"469"},"19636":{"name":"Xã Triệu Độ","type":"xa","slug":"xa-trieu-do","name_with_type":"Xã Triệu Độ","path":"Xã Triệu Độ, Huyện Triệu Phong, Tỉnh Quảng Trị","path_with_type":"Xã Triệu Độ, Huyện Triệu Phong, Tỉnh Quảng Trị","code":"19636","parent_code":"469"},"19639":{"name":"Xã Triệu Trạch","type":"xa","slug":"xa-trieu-trach","name_with_type":"Xã Triệu Trạch","path":"Xã Triệu Trạch, Huyện Triệu Phong, Tỉnh Quảng Trị","path_with_type":"Xã Triệu Trạch, Huyện Triệu Phong, Tỉnh Quảng Trị","code":"19639","parent_code":"469"},"19642":{"name":"Xã Triệu Thuận","type":"xa","slug":"xa-trieu-thuan","name_with_type":"Xã Triệu Thuận","path":"Xã Triệu Thuận, Huyện Triệu Phong, Tỉnh Quảng Trị","path_with_type":"Xã Triệu Thuận, Huyện Triệu Phong, Tỉnh Quảng Trị","code":"19642","parent_code":"469"},"19645":{"name":"Xã Triệu Đại","type":"xa","slug":"xa-trieu-dai","name_with_type":"Xã Triệu Đại","path":"Xã Triệu Đại, Huyện Triệu Phong, Tỉnh Quảng Trị","path_with_type":"Xã Triệu Đại, Huyện Triệu Phong, Tỉnh Quảng Trị","code":"19645","parent_code":"469"},"19648":{"name":"Xã Triệu Hòa","type":"xa","slug":"xa-trieu-hoa","name_with_type":"Xã Triệu Hòa","path":"Xã Triệu Hòa, Huyện Triệu Phong, Tỉnh Quảng Trị","path_with_type":"Xã Triệu Hòa, Huyện Triệu Phong, Tỉnh Quảng Trị","code":"19648","parent_code":"469"},"19651":{"name":"Xã Triệu Lăng","type":"xa","slug":"xa-trieu-lang","name_with_type":"Xã Triệu Lăng","path":"Xã Triệu Lăng, Huyện Triệu Phong, Tỉnh Quảng Trị","path_with_type":"Xã Triệu Lăng, Huyện Triệu Phong, Tỉnh Quảng Trị","code":"19651","parent_code":"469"},"19654":{"name":"Xã Triệu Sơn","type":"xa","slug":"xa-trieu-son","name_with_type":"Xã Triệu Sơn","path":"Xã Triệu Sơn, Huyện Triệu Phong, Tỉnh Quảng Trị","path_with_type":"Xã Triệu Sơn, Huyện Triệu Phong, Tỉnh Quảng Trị","code":"19654","parent_code":"469"},"19657":{"name":"Xã Triệu Long","type":"xa","slug":"xa-trieu-long","name_with_type":"Xã Triệu Long","path":"Xã Triệu Long, Huyện Triệu Phong, Tỉnh Quảng Trị","path_with_type":"Xã Triệu Long, Huyện Triệu Phong, Tỉnh Quảng Trị","code":"19657","parent_code":"469"},"19660":{"name":"Xã Triệu Tài","type":"xa","slug":"xa-trieu-tai","name_with_type":"Xã Triệu Tài","path":"Xã Triệu Tài, Huyện Triệu Phong, Tỉnh Quảng Trị","path_with_type":"Xã Triệu Tài, Huyện Triệu Phong, Tỉnh Quảng Trị","code":"19660","parent_code":"469"},"19666":{"name":"Xã Triệu Trung","type":"xa","slug":"xa-trieu-trung","name_with_type":"Xã Triệu Trung","path":"Xã Triệu Trung, Huyện Triệu Phong, Tỉnh Quảng Trị","path_with_type":"Xã Triệu Trung, Huyện Triệu Phong, Tỉnh Quảng Trị","code":"19666","parent_code":"469"},"19669":{"name":"Xã Triệu Ái","type":"xa","slug":"xa-trieu-ai","name_with_type":"Xã Triệu Ái","path":"Xã Triệu Ái, Huyện Triệu Phong, Tỉnh Quảng Trị","path_with_type":"Xã Triệu Ái, Huyện Triệu Phong, Tỉnh Quảng Trị","code":"19669","parent_code":"469"},"19672":{"name":"Xã Triệu Thượng","type":"xa","slug":"xa-trieu-thuong","name_with_type":"Xã Triệu Thượng","path":"Xã Triệu Thượng, Huyện Triệu Phong, Tỉnh Quảng Trị","path_with_type":"Xã Triệu Thượng, Huyện Triệu Phong, Tỉnh Quảng Trị","code":"19672","parent_code":"469"},"19675":{"name":"Xã Triệu Giang","type":"xa","slug":"xa-trieu-giang","name_with_type":"Xã Triệu Giang","path":"Xã Triệu Giang, Huyện Triệu Phong, Tỉnh Quảng Trị","path_with_type":"Xã Triệu Giang, Huyện Triệu Phong, Tỉnh Quảng Trị","code":"19675","parent_code":"469"},"19678":{"name":"Xã Triệu Thành","type":"xa","slug":"xa-trieu-thanh","name_with_type":"Xã Triệu Thành","path":"Xã Triệu Thành, Huyện Triệu Phong, Tỉnh Quảng Trị","path_with_type":"Xã Triệu Thành, Huyện Triệu Phong, Tỉnh Quảng Trị","code":"19678","parent_code":"469"},"19681":{"name":"Thị trấn Diên Sanh","type":"thi-tran","slug":"thi-tran-dien-sanh","name_with_type":"Thị trấn Diên Sanh","path":"Thị trấn Diên Sanh, Huyện Hải Lăng, Tỉnh Quảng Trị","path_with_type":"Thị trấn Diên Sanh, Huyện Hải Lăng, Tỉnh Quảng Trị","code":"19681","parent_code":"470"},"19684":{"name":"Xã Hải An","type":"xa","slug":"xa-hai-an","name_with_type":"Xã Hải An","path":"Xã Hải An, Huyện Hải Lăng, Tỉnh Quảng Trị","path_with_type":"Xã Hải An, Huyện Hải Lăng, Tỉnh Quảng Trị","code":"19684","parent_code":"470"},"19687":{"name":"Xã Hải Ba","type":"xa","slug":"xa-hai-ba","name_with_type":"Xã Hải Ba","path":"Xã Hải Ba, Huyện Hải Lăng, Tỉnh Quảng Trị","path_with_type":"Xã Hải Ba, Huyện Hải Lăng, Tỉnh Quảng Trị","code":"19687","parent_code":"470"},"19693":{"name":"Xã Hải Quy","type":"xa","slug":"xa-hai-quy","name_with_type":"Xã Hải Quy","path":"Xã Hải Quy, Huyện Hải Lăng, Tỉnh Quảng Trị","path_with_type":"Xã Hải Quy, Huyện Hải Lăng, Tỉnh Quảng Trị","code":"19693","parent_code":"470"},"19696":{"name":"Xã Hải Quế","type":"xa","slug":"xa-hai-que","name_with_type":"Xã Hải Quế","path":"Xã Hải Quế, Huyện Hải Lăng, Tỉnh Quảng Trị","path_with_type":"Xã Hải Quế, Huyện Hải Lăng, Tỉnh Quảng Trị","code":"19696","parent_code":"470"},"19699":{"name":"Xã Hải Hưng","type":"xa","slug":"xa-hai-hung","name_with_type":"Xã Hải Hưng","path":"Xã Hải Hưng, Huyện Hải Lăng, Tỉnh Quảng Trị","path_with_type":"Xã Hải Hưng, Huyện Hải Lăng, Tỉnh Quảng Trị","code":"19699","parent_code":"470"},"19702":{"name":"Xã Hải Phú","type":"xa","slug":"xa-hai-phu","name_with_type":"Xã Hải Phú","path":"Xã Hải Phú, Huyện Hải Lăng, Tỉnh Quảng Trị","path_with_type":"Xã Hải Phú, Huyện Hải Lăng, Tỉnh Quảng Trị","code":"19702","parent_code":"470"},"19705":{"name":"Xã Hải Lệ","type":"xa","slug":"xa-hai-le","name_with_type":"Xã Hải Lệ","path":"Xã Hải Lệ, Thị xã Quảng Trị, Tỉnh Quảng Trị","path_with_type":"Xã Hải Lệ, Thị xã Quảng Trị, Tỉnh Quảng Trị","code":"19705","parent_code":"462"},"19708":{"name":"Xã Hải Thượng","type":"xa","slug":"xa-hai-thuong","name_with_type":"Xã Hải Thượng","path":"Xã Hải Thượng, Huyện Hải Lăng, Tỉnh Quảng Trị","path_with_type":"Xã Hải Thượng, Huyện Hải Lăng, Tỉnh Quảng Trị","code":"19708","parent_code":"470"},"19711":{"name":"Xã Hải Dương","type":"xa","slug":"xa-hai-duong","name_with_type":"Xã Hải Dương","path":"Xã Hải Dương, Huyện Hải Lăng, Tỉnh Quảng Trị","path_with_type":"Xã Hải Dương, Huyện Hải Lăng, Tỉnh Quảng Trị","code":"19711","parent_code":"470"},"19714":{"name":"Xã Hải Định","type":"xa","slug":"xa-hai-dinh","name_with_type":"Xã Hải Định","path":"Xã Hải Định, Huyện Hải Lăng, Tỉnh Quảng Trị","path_with_type":"Xã Hải Định, Huyện Hải Lăng, Tỉnh Quảng Trị","code":"19714","parent_code":"470"},"19717":{"name":"Xã Hải Lâm","type":"xa","slug":"xa-hai-lam","name_with_type":"Xã Hải Lâm","path":"Xã Hải Lâm, Huyện Hải Lăng, Tỉnh Quảng Trị","path_with_type":"Xã Hải Lâm, Huyện Hải Lăng, Tỉnh Quảng Trị","code":"19717","parent_code":"470"},"19726":{"name":"Xã Hải Phong","type":"xa","slug":"xa-hai-phong","name_with_type":"Xã Hải Phong","path":"Xã Hải Phong, Huyện Hải Lăng, Tỉnh Quảng Trị","path_with_type":"Xã Hải Phong, Huyện Hải Lăng, Tỉnh Quảng Trị","code":"19726","parent_code":"470"},"19729":{"name":"Xã Hải Trường","type":"xa","slug":"xa-hai-truong","name_with_type":"Xã Hải Trường","path":"Xã Hải Trường, Huyện Hải Lăng, Tỉnh Quảng Trị","path_with_type":"Xã Hải Trường, Huyện Hải Lăng, Tỉnh Quảng Trị","code":"19729","parent_code":"470"},"19735":{"name":"Xã Hải Sơn","type":"xa","slug":"xa-hai-son","name_with_type":"Xã Hải Sơn","path":"Xã Hải Sơn, Huyện Hải Lăng, Tỉnh Quảng Trị","path_with_type":"Xã Hải Sơn, Huyện Hải Lăng, Tỉnh Quảng Trị","code":"19735","parent_code":"470"},"19738":{"name":"Xã Hải Chánh","type":"xa","slug":"xa-hai-chanh","name_with_type":"Xã Hải Chánh","path":"Xã Hải Chánh, Huyện Hải Lăng, Tỉnh Quảng Trị","path_with_type":"Xã Hải Chánh, Huyện Hải Lăng, Tỉnh Quảng Trị","code":"19738","parent_code":"470"},"19741":{"name":"Xã Hải Khê","type":"xa","slug":"xa-hai-khe","name_with_type":"Xã Hải Khê","path":"Xã Hải Khê, Huyện Hải Lăng, Tỉnh Quảng Trị","path_with_type":"Xã Hải Khê, Huyện Hải Lăng, Tỉnh Quảng Trị","code":"19741","parent_code":"470"},"19750":{"name":"Phường Tây Lộc","type":"phuong","slug":"phuong-tay-loc","name_with_type":"Phường Tây Lộc","path":"Phường Tây Lộc, Quận Phú Xuân, Thành phố Huế","path_with_type":"Phường Tây Lộc, Quận Phú Xuân, Thành phố Huế","code":"19750","parent_code":"475"},"19753":{"name":"Phường Thuận Lộc","type":"phuong","slug":"phuong-thuan-loc","name_with_type":"Phường Thuận Lộc","path":"Phường Thuận Lộc, Quận Phú Xuân, Thành phố Huế","path_with_type":"Phường Thuận Lộc, Quận Phú Xuân, Thành phố Huế","code":"19753","parent_code":"475"},"19756":{"name":"Phường Gia Hội","type":"phuong","slug":"phuong-gia-hoi","name_with_type":"Phường Gia Hội","path":"Phường Gia Hội, Quận Phú Xuân, Thành phố Huế","path_with_type":"Phường Gia Hội, Quận Phú Xuân, Thành phố Huế","code":"19756","parent_code":"475"},"19759":{"name":"Phường Phú Hậu","type":"phuong","slug":"phuong-phu-hau","name_with_type":"Phường Phú Hậu","path":"Phường Phú Hậu, Quận Phú Xuân, Thành phố Huế","path_with_type":"Phường Phú Hậu, Quận Phú Xuân, Thành phố Huế","code":"19759","parent_code":"475"},"19762":{"name":"Phường Thuận Hòa","type":"phuong","slug":"phuong-thuan-hoa","name_with_type":"Phường Thuận Hòa","path":"Phường Thuận Hòa, Quận Phú Xuân, Thành phố Huế","path_with_type":"Phường Thuận Hòa, Quận Phú Xuân, Thành phố Huế","code":"19762","parent_code":"475"},"19768":{"name":"Phường Đông Ba","type":"phuong","slug":"phuong-dong-ba","name_with_type":"Phường Đông Ba","path":"Phường Đông Ba, Quận Phú Xuân, Thành phố Huế","path_with_type":"Phường Đông Ba, Quận Phú Xuân, Thành phố Huế","code":"19768","parent_code":"475"},"19774":{"name":"Phường Kim Long","type":"phuong","slug":"phuong-kim-long","name_with_type":"Phường Kim Long","path":"Phường Kim Long, Quận Phú Xuân, Thành phố Huế","path_with_type":"Phường Kim Long, Quận Phú Xuân, Thành phố Huế","code":"19774","parent_code":"475"},"19777":{"name":"Phường Vỹ Dạ","type":"phuong","slug":"phuong-vy-da","name_with_type":"Phường Vỹ Dạ","path":"Phường Vỹ Dạ, Quận Thuận Hóa, Thành phố Huế","path_with_type":"Phường Vỹ Dạ, Quận Thuận Hóa, Thành phố Huế","code":"19777","parent_code":"474"},"19780":{"name":"Phường Phường Đúc","type":"phuong","slug":"phuong-phuong-duc","name_with_type":"Phường Phường Đúc","path":"Phường Phường Đúc, Quận Thuận Hóa, Thành phố Huế","path_with_type":"Phường Phường Đúc, Quận Thuận Hóa, Thành phố Huế","code":"19780","parent_code":"474"},"19783":{"name":"Phường Vĩnh Ninh","type":"phuong","slug":"phuong-vinh-ninh","name_with_type":"Phường Vĩnh Ninh","path":"Phường Vĩnh Ninh, Quận Thuận Hóa, Thành phố Huế","path_with_type":"Phường Vĩnh Ninh, Quận Thuận Hóa, Thành phố Huế","code":"19783","parent_code":"474"},"19786":{"name":"Phường Phú Hội","type":"phuong","slug":"phuong-phu-hoi","name_with_type":"Phường Phú Hội","path":"Phường Phú Hội, Quận Thuận Hóa, Thành phố Huế","path_with_type":"Phường Phú Hội, Quận Thuận Hóa, Thành phố Huế","code":"19786","parent_code":"474"},"19789":{"name":"Phường Phú Nhuận","type":"phuong","slug":"phuong-phu-nhuan","name_with_type":"Phường Phú Nhuận","path":"Phường Phú Nhuận, Quận Thuận Hóa, Thành phố Huế","path_with_type":"Phường Phú Nhuận, Quận Thuận Hóa, Thành phố Huế","code":"19789","parent_code":"474"},"19792":{"name":"Phường Xuân Phú","type":"phuong","slug":"phuong-xuan-phu","name_with_type":"Phường Xuân Phú","path":"Phường Xuân Phú, Quận Thuận Hóa, Thành phố Huế","path_with_type":"Phường Xuân Phú, Quận Thuận Hóa, Thành phố Huế","code":"19792","parent_code":"474"},"19795":{"name":"Phường Trường An","type":"phuong","slug":"phuong-truong-an","name_with_type":"Phường Trường An","path":"Phường Trường An, Quận Thuận Hóa, Thành phố Huế","path_with_type":"Phường Trường An, Quận Thuận Hóa, Thành phố Huế","code":"19795","parent_code":"474"},"19798":{"name":"Phường Phước Vĩnh","type":"phuong","slug":"phuong-phuoc-vinh","name_with_type":"Phường Phước Vĩnh","path":"Phường Phước Vĩnh, Quận Thuận Hóa, Thành phố Huế","path_with_type":"Phường Phước Vĩnh, Quận Thuận Hóa, Thành phố Huế","code":"19798","parent_code":"474"},"19801":{"name":"Phường An Cựu","type":"phuong","slug":"phuong-an-cuu","name_with_type":"Phường An Cựu","path":"Phường An Cựu, Quận Thuận Hóa, Thành phố Huế","path_with_type":"Phường An Cựu, Quận Thuận Hóa, Thành phố Huế","code":"19801","parent_code":"474"},"19803":{"name":"Phường An Hòa","type":"phuong","slug":"phuong-an-hoa","name_with_type":"Phường An Hòa","path":"Phường An Hòa, Quận Phú Xuân, Thành phố Huế","path_with_type":"Phường An Hòa, Quận Phú Xuân, Thành phố Huế","code":"19803","parent_code":"475"},"19804":{"name":"Phường Hương Sơ","type":"phuong","slug":"phuong-huong-so","name_with_type":"Phường Hương Sơ","path":"Phường Hương Sơ, Quận Phú Xuân, Thành phố Huế","path_with_type":"Phường Hương Sơ, Quận Phú Xuân, Thành phố Huế","code":"19804","parent_code":"475"},"19807":{"name":"Phường Thuỷ Biều","type":"phuong","slug":"phuong-thuy-bieu","name_with_type":"Phường Thuỷ Biều","path":"Phường Thuỷ Biều, Quận Thuận Hóa, Thành phố Huế","path_with_type":"Phường Thuỷ Biều, Quận Thuận Hóa, Thành phố Huế","code":"19807","parent_code":"474"},"19810":{"name":"Phường Hương Long","type":"phuong","slug":"phuong-huong-long","name_with_type":"Phường Hương Long","path":"Phường Hương Long, Quận Phú Xuân, Thành phố Huế","path_with_type":"Phường Hương Long, Quận Phú Xuân, Thành phố Huế","code":"19810","parent_code":"475"},"19813":{"name":"Phường Thuỷ Xuân","type":"phuong","slug":"phuong-thuy-xuan","name_with_type":"Phường Thuỷ Xuân","path":"Phường Thuỷ Xuân, Quận Thuận Hóa, Thành phố Huế","path_with_type":"Phường Thuỷ Xuân, Quận Thuận Hóa, Thành phố Huế","code":"19813","parent_code":"474"},"19815":{"name":"Phường An Đông","type":"phuong","slug":"phuong-an-dong","name_with_type":"Phường An Đông","path":"Phường An Đông, Quận Thuận Hóa, Thành phố Huế","path_with_type":"Phường An Đông, Quận Thuận Hóa, Thành phố Huế","code":"19815","parent_code":"474"},"19816":{"name":"Phường An Tây","type":"phuong","slug":"phuong-an-tay","name_with_type":"Phường An Tây","path":"Phường An Tây, Quận Thuận Hóa, Thành phố Huế","path_with_type":"Phường An Tây, Quận Thuận Hóa, Thành phố Huế","code":"19816","parent_code":"474"},"19819":{"name":"Phường Phong Thu","type":"phuong","slug":"phuong-phong-thu","name_with_type":"Phường Phong Thu","path":"Phường Phong Thu, Thị xã Phong Điền, Thành phố Huế","path_with_type":"Phường Phong Thu, Thị xã Phong Điền, Thành phố Huế","code":"19819","parent_code":"476"},"19825":{"name":"Xã Phong Thạnh","type":"xa","slug":"xa-phong-thanh","name_with_type":"Xã Phong Thạnh","path":"Xã Phong Thạnh, Thị xã Phong Điền, Thành phố Huế","path_with_type":"Xã Phong Thạnh, Thị xã Phong Điền, Thành phố Huế","code":"19825","parent_code":"476"},"19828":{"name":"Phường Phong Phú","type":"phuong","slug":"phuong-phong-phu","name_with_type":"Phường Phong Phú","path":"Phường Phong Phú, Thị xã Phong Điền, Thành phố Huế","path_with_type":"Phường Phong Phú, Thị xã Phong Điền, Thành phố Huế","code":"19828","parent_code":"476"},"19831":{"name":"Xã Phong Bình","type":"xa","slug":"xa-phong-binh","name_with_type":"Xã Phong Bình","path":"Xã Phong Bình, Thị xã Phong Điền, Thành phố Huế","path_with_type":"Xã Phong Bình, Thị xã Phong Điền, Thành phố Huế","code":"19831","parent_code":"476"},"19837":{"name":"Xã Phong Chương","type":"xa","slug":"xa-phong-chuong","name_with_type":"Xã Phong Chương","path":"Xã Phong Chương, Thị xã Phong Điền, Thành phố Huế","path_with_type":"Xã Phong Chương, Thị xã Phong Điền, Thành phố Huế","code":"19837","parent_code":"476"},"19843":{"name":"Phường Phong Hải","type":"phuong","slug":"phuong-phong-hai","name_with_type":"Phường Phong Hải","path":"Phường Phong Hải, Thị xã Phong Điền, Thành phố Huế","path_with_type":"Phường Phong Hải, Thị xã Phong Điền, Thành phố Huế","code":"19843","parent_code":"476"},"19846":{"name":"Phường Phong Hòa","type":"phuong","slug":"phuong-phong-hoa","name_with_type":"Phường Phong Hòa","path":"Phường Phong Hòa, Thị xã Phong Điền, Thành phố Huế","path_with_type":"Phường Phong Hòa, Thị xã Phong Điền, Thành phố Huế","code":"19846","parent_code":"476"},"19852":{"name":"Phường Phong Hiền","type":"phuong","slug":"phuong-phong-hien","name_with_type":"Phường Phong Hiền","path":"Phường Phong Hiền, Thị xã Phong Điền, Thành phố Huế","path_with_type":"Phường Phong Hiền, Thị xã Phong Điền, Thành phố Huế","code":"19852","parent_code":"476"},"19855":{"name":"Xã Phong Mỹ","type":"xa","slug":"xa-phong-my","name_with_type":"Xã Phong Mỹ","path":"Xã Phong Mỹ, Thị xã Phong Điền, Thành phố Huế","path_with_type":"Xã Phong Mỹ, Thị xã Phong Điền, Thành phố Huế","code":"19855","parent_code":"476"},"19858":{"name":"Phường Phong An","type":"phuong","slug":"phuong-phong-an","name_with_type":"Phường Phong An","path":"Phường Phong An, Thị xã Phong Điền, Thành phố Huế","path_with_type":"Phường Phong An, Thị xã Phong Điền, Thành phố Huế","code":"19858","parent_code":"476"},"19861":{"name":"Xã Phong Xuân","type":"xa","slug":"xa-phong-xuan","name_with_type":"Xã Phong Xuân","path":"Xã Phong Xuân, Thị xã Phong Điền, Thành phố Huế","path_with_type":"Xã Phong Xuân, Thị xã Phong Điền, Thành phố Huế","code":"19861","parent_code":"476"},"19864":{"name":"Xã Phong Sơn","type":"xa","slug":"xa-phong-son","name_with_type":"Xã Phong Sơn","path":"Xã Phong Sơn, Thị xã Phong Điền, Thành phố Huế","path_with_type":"Xã Phong Sơn, Thị xã Phong Điền, Thành phố Huế","code":"19864","parent_code":"476"},"19867":{"name":"Thị trấn Sịa","type":"thi-tran","slug":"thi-tran-sia","name_with_type":"Thị trấn Sịa","path":"Thị trấn Sịa, Huyện Quảng Điền, Thành phố Huế","path_with_type":"Thị trấn Sịa, Huyện Quảng Điền, Thành phố Huế","code":"19867","parent_code":"477"},"19870":{"name":"Xã Quảng Thái","type":"xa","slug":"xa-quang-thai","name_with_type":"Xã Quảng Thái","path":"Xã Quảng Thái, Huyện Quảng Điền, Thành phố Huế","path_with_type":"Xã Quảng Thái, Huyện Quảng Điền, Thành phố Huế","code":"19870","parent_code":"477"},"19873":{"name":"Xã Quảng Ngạn","type":"xa","slug":"xa-quang-ngan","name_with_type":"Xã Quảng Ngạn","path":"Xã Quảng Ngạn, Huyện Quảng Điền, Thành phố Huế","path_with_type":"Xã Quảng Ngạn, Huyện Quảng Điền, Thành phố Huế","code":"19873","parent_code":"477"},"19876":{"name":"Xã Quảng Lợi","type":"xa","slug":"xa-quang-loi","name_with_type":"Xã Quảng Lợi","path":"Xã Quảng Lợi, Huyện Quảng Điền, Thành phố Huế","path_with_type":"Xã Quảng Lợi, Huyện Quảng Điền, Thành phố Huế","code":"19876","parent_code":"477"},"19879":{"name":"Xã Quảng Công","type":"xa","slug":"xa-quang-cong","name_with_type":"Xã Quảng Công","path":"Xã Quảng Công, Huyện Quảng Điền, Thành phố Huế","path_with_type":"Xã Quảng Công, Huyện Quảng Điền, Thành phố Huế","code":"19879","parent_code":"477"},"19882":{"name":"Xã Quảng Phước","type":"xa","slug":"xa-quang-phuoc","name_with_type":"Xã Quảng Phước","path":"Xã Quảng Phước, Huyện Quảng Điền, Thành phố Huế","path_with_type":"Xã Quảng Phước, Huyện Quảng Điền, Thành phố Huế","code":"19882","parent_code":"477"},"19885":{"name":"Xã Quảng Vinh","type":"xa","slug":"xa-quang-vinh","name_with_type":"Xã Quảng Vinh","path":"Xã Quảng Vinh, Huyện Quảng Điền, Thành phố Huế","path_with_type":"Xã Quảng Vinh, Huyện Quảng Điền, Thành phố Huế","code":"19885","parent_code":"477"},"19888":{"name":"Xã Quảng An","type":"xa","slug":"xa-quang-an","name_with_type":"Xã Quảng An","path":"Xã Quảng An, Huyện Quảng Điền, Thành phố Huế","path_with_type":"Xã Quảng An, Huyện Quảng Điền, Thành phố Huế","code":"19888","parent_code":"477"},"19891":{"name":"Xã Quảng Thành","type":"xa","slug":"xa-quang-thanh","name_with_type":"Xã Quảng Thành","path":"Xã Quảng Thành, Huyện Quảng Điền, Thành phố Huế","path_with_type":"Xã Quảng Thành, Huyện Quảng Điền, Thành phố Huế","code":"19891","parent_code":"477"},"19894":{"name":"Xã Quảng Thọ","type":"xa","slug":"xa-quang-tho","name_with_type":"Xã Quảng Thọ","path":"Xã Quảng Thọ, Huyện Quảng Điền, Thành phố Huế","path_with_type":"Xã Quảng Thọ, Huyện Quảng Điền, Thành phố Huế","code":"19894","parent_code":"477"},"19897":{"name":"Xã Quảng Phú","type":"xa","slug":"xa-quang-phu","name_with_type":"Xã Quảng Phú","path":"Xã Quảng Phú, Huyện Quảng Điền, Thành phố Huế","path_with_type":"Xã Quảng Phú, Huyện Quảng Điền, Thành phố Huế","code":"19897","parent_code":"477"},"19900":{"name":"Phường Thuận An","type":"phuong","slug":"phuong-thuan-an","name_with_type":"Phường Thuận An","path":"Phường Thuận An, Quận Thuận Hóa, Thành phố Huế","path_with_type":"Phường Thuận An, Quận Thuận Hóa, Thành phố Huế","code":"19900","parent_code":"474"},"19903":{"name":"Xã Phú Thuận","type":"xa","slug":"xa-phu-thuan","name_with_type":"Xã Phú Thuận","path":"Xã Phú Thuận, Huyện Phú Vang, Thành phố Huế","path_with_type":"Xã Phú Thuận, Huyện Phú Vang, Thành phố Huế","code":"19903","parent_code":"478"},"19909":{"name":"Phường Dương Nỗ","type":"phuong","slug":"phuong-duong-no","name_with_type":"Phường Dương Nỗ","path":"Phường Dương Nỗ, Quận Thuận Hóa, Thành phố Huế","path_with_type":"Phường Dương Nỗ, Quận Thuận Hóa, Thành phố Huế","code":"19909","parent_code":"474"},"19912":{"name":"Xã Phú An","type":"xa","slug":"xa-phu-an","name_with_type":"Xã Phú An","path":"Xã Phú An, Huyện Phú Vang, Thành phố Huế","path_with_type":"Xã Phú An, Huyện Phú Vang, Thành phố Huế","code":"19912","parent_code":"478"},"19915":{"name":"Xã Phú Hải","type":"xa","slug":"xa-phu-hai","name_with_type":"Xã Phú Hải","path":"Xã Phú Hải, Huyện Phú Vang, Thành phố Huế","path_with_type":"Xã Phú Hải, Huyện Phú Vang, Thành phố Huế","code":"19915","parent_code":"478"},"19918":{"name":"Xã Phú Xuân","type":"xa","slug":"xa-phu-xuan","name_with_type":"Xã Phú Xuân","path":"Xã Phú Xuân, Huyện Phú Vang, Thành phố Huế","path_with_type":"Xã Phú Xuân, Huyện Phú Vang, Thành phố Huế","code":"19918","parent_code":"478"},"19921":{"name":"Xã Phú Diên","type":"xa","slug":"xa-phu-dien","name_with_type":"Xã Phú Diên","path":"Xã Phú Diên, Huyện Phú Vang, Thành phố Huế","path_with_type":"Xã Phú Diên, Huyện Phú Vang, Thành phố Huế","code":"19921","parent_code":"478"},"19927":{"name":"Xã Phú Mỹ","type":"xa","slug":"xa-phu-my","name_with_type":"Xã Phú Mỹ","path":"Xã Phú Mỹ, Huyện Phú Vang, Thành phố Huế","path_with_type":"Xã Phú Mỹ, Huyện Phú Vang, Thành phố Huế","code":"19927","parent_code":"478"},"19930":{"name":"Phường Phú Thượng","type":"phuong","slug":"phuong-phu-thuong","name_with_type":"Phường Phú Thượng","path":"Phường Phú Thượng, Quận Thuận Hóa, Thành phố Huế","path_with_type":"Phường Phú Thượng, Quận Thuận Hóa, Thành phố Huế","code":"19930","parent_code":"474"},"19933":{"name":"Xã Phú Hồ","type":"xa","slug":"xa-phu-ho","name_with_type":"Xã Phú Hồ","path":"Xã Phú Hồ, Huyện Phú Vang, Thành phố Huế","path_with_type":"Xã Phú Hồ, Huyện Phú Vang, Thành phố Huế","code":"19933","parent_code":"478"},"19936":{"name":"Xã Vinh Xuân","type":"xa","slug":"xa-vinh-xuan","name_with_type":"Xã Vinh Xuân","path":"Xã Vinh Xuân, Huyện Phú Vang, Thành phố Huế","path_with_type":"Xã Vinh Xuân, Huyện Phú Vang, Thành phố Huế","code":"19936","parent_code":"478"},"19939":{"name":"Xã Phú Lương","type":"xa","slug":"xa-phu-luong","name_with_type":"Xã Phú Lương","path":"Xã Phú Lương, Huyện Phú Vang, Thành phố Huế","path_with_type":"Xã Phú Lương, Huyện Phú Vang, Thành phố Huế","code":"19939","parent_code":"478"},"19942":{"name":"Thị trấn Phú Đa","type":"thi-tran","slug":"thi-tran-phu-da","name_with_type":"Thị trấn Phú Đa","path":"Thị trấn Phú Đa, Huyện Phú Vang, Thành phố Huế","path_with_type":"Thị trấn Phú Đa, Huyện Phú Vang, Thành phố Huế","code":"19942","parent_code":"478"},"19945":{"name":"Xã Vinh Thanh","type":"xa","slug":"xa-vinh-thanh","name_with_type":"Xã Vinh Thanh","path":"Xã Vinh Thanh, Huyện Phú Vang, Thành phố Huế","path_with_type":"Xã Vinh Thanh, Huyện Phú Vang, Thành phố Huế","code":"19945","parent_code":"478"},"19948":{"name":"Xã Vinh An","type":"xa","slug":"xa-vinh-an","name_with_type":"Xã Vinh An","path":"Xã Vinh An, Huyện Phú Vang, Thành phố Huế","path_with_type":"Xã Vinh An, Huyện Phú Vang, Thành phố Huế","code":"19948","parent_code":"478"},"19954":{"name":"Xã Phú Gia","type":"xa","slug":"xa-phu-gia","name_with_type":"Xã Phú Gia","path":"Xã Phú Gia, Huyện Phú Vang, Thành phố Huế","path_with_type":"Xã Phú Gia, Huyện Phú Vang, Thành phố Huế","code":"19954","parent_code":"478"},"19957":{"name":"Xã Vinh Hà","type":"xa","slug":"xa-vinh-ha","name_with_type":"Xã Vinh Hà","path":"Xã Vinh Hà, Huyện Phú Vang, Thành phố Huế","path_with_type":"Xã Vinh Hà, Huyện Phú Vang, Thành phố Huế","code":"19957","parent_code":"478"},"19960":{"name":"Phường Phú Bài","type":"phuong","slug":"phuong-phu-bai","name_with_type":"Phường Phú Bài","path":"Phường Phú Bài, Thị xã Hương Thủy, Thành phố Huế","path_with_type":"Phường Phú Bài, Thị xã Hương Thủy, Thành phố Huế","code":"19960","parent_code":"479"},"19963":{"name":"Phường Thủy Vân","type":"phuong","slug":"phuong-thuy-van","name_with_type":"Phường Thủy Vân","path":"Phường Thủy Vân, Quận Thuận Hóa, Thành phố Huế","path_with_type":"Phường Thủy Vân, Quận Thuận Hóa, Thành phố Huế","code":"19963","parent_code":"474"},"19966":{"name":"Xã Thủy Thanh","type":"xa","slug":"xa-thuy-thanh","name_with_type":"Xã Thủy Thanh","path":"Xã Thủy Thanh, Thị xã Hương Thủy, Thành phố Huế","path_with_type":"Xã Thủy Thanh, Thị xã Hương Thủy, Thành phố Huế","code":"19966","parent_code":"479"},"19969":{"name":"Phường Thủy Dương","type":"phuong","slug":"phuong-thuy-duong","name_with_type":"Phường Thủy Dương","path":"Phường Thủy Dương, Thị xã Hương Thủy, Thành phố Huế","path_with_type":"Phường Thủy Dương, Thị xã Hương Thủy, Thành phố Huế","code":"19969","parent_code":"479"},"19972":{"name":"Phường Thủy Phương","type":"phuong","slug":"phuong-thuy-phuong","name_with_type":"Phường Thủy Phương","path":"Phường Thủy Phương, Thị xã Hương Thủy, Thành phố Huế","path_with_type":"Phường Thủy Phương, Thị xã Hương Thủy, Thành phố Huế","code":"19972","parent_code":"479"},"19975":{"name":"Phường Thủy Châu","type":"phuong","slug":"phuong-thuy-chau","name_with_type":"Phường Thủy Châu","path":"Phường Thủy Châu, Thị xã Hương Thủy, Thành phố Huế","path_with_type":"Phường Thủy Châu, Thị xã Hương Thủy, Thành phố Huế","code":"19975","parent_code":"479"},"19978":{"name":"Phường Thủy Lương","type":"phuong","slug":"phuong-thuy-luong","name_with_type":"Phường Thủy Lương","path":"Phường Thủy Lương, Thị xã Hương Thủy, Thành phố Huế","path_with_type":"Phường Thủy Lương, Thị xã Hương Thủy, Thành phố Huế","code":"19978","parent_code":"479"},"19981":{"name":"Phường Thủy Bằng","type":"phuong","slug":"phuong-thuy-bang","name_with_type":"Phường Thủy Bằng","path":"Phường Thủy Bằng, Quận Thuận Hóa, Thành phố Huế","path_with_type":"Phường Thủy Bằng, Quận Thuận Hóa, Thành phố Huế","code":"19981","parent_code":"474"},"19984":{"name":"Xã Thủy Tân","type":"xa","slug":"xa-thuy-tan","name_with_type":"Xã Thủy Tân","path":"Xã Thủy Tân, Thị xã Hương Thủy, Thành phố Huế","path_with_type":"Xã Thủy Tân, Thị xã Hương Thủy, Thành phố Huế","code":"19984","parent_code":"479"},"19987":{"name":"Xã Thủy Phù","type":"xa","slug":"xa-thuy-phu","name_with_type":"Xã Thủy Phù","path":"Xã Thủy Phù, Thị xã Hương Thủy, Thành phố Huế","path_with_type":"Xã Thủy Phù, Thị xã Hương Thủy, Thành phố Huế","code":"19987","parent_code":"479"},"19990":{"name":"Xã Phú Sơn","type":"xa","slug":"xa-phu-son","name_with_type":"Xã Phú Sơn","path":"Xã Phú Sơn, Thị xã Hương Thủy, Thành phố Huế","path_with_type":"Xã Phú Sơn, Thị xã Hương Thủy, Thành phố Huế","code":"19990","parent_code":"479"},"19993":{"name":"Xã Dương Hòa","type":"xa","slug":"xa-duong-hoa","name_with_type":"Xã Dương Hòa","path":"Xã Dương Hòa, Thị xã Hương Thủy, Thành phố Huế","path_with_type":"Xã Dương Hòa, Thị xã Hương Thủy, Thành phố Huế","code":"19993","parent_code":"479"},"19996":{"name":"Phường Tứ Hạ","type":"phuong","slug":"phuong-tu-ha","name_with_type":"Phường Tứ Hạ","path":"Phường Tứ Hạ, Thị xã Hương Trà, Thành phố Huế","path_with_type":"Phường Tứ Hạ, Thị xã Hương Trà, Thành phố Huế","code":"19996","parent_code":"480"},"20002":{"name":"Phường Hương Phong","type":"phuong","slug":"phuong-huong-phong","name_with_type":"Phường Hương Phong","path":"Phường Hương Phong, Quận Thuận Hóa, Thành phố Huế","path_with_type":"Phường Hương Phong, Quận Thuận Hóa, Thành phố Huế","code":"20002","parent_code":"474"},"20005":{"name":"Xã Hương Toàn","type":"xa","slug":"xa-huong-toan","name_with_type":"Xã Hương Toàn","path":"Xã Hương Toàn, Thị xã Hương Trà, Thành phố Huế","path_with_type":"Xã Hương Toàn, Thị xã Hương Trà, Thành phố Huế","code":"20005","parent_code":"480"},"20008":{"name":"Phường Hương Vân","type":"phuong","slug":"phuong-huong-van","name_with_type":"Phường Hương Vân","path":"Phường Hương Vân, Thị xã Hương Trà, Thành phố Huế","path_with_type":"Phường Hương Vân, Thị xã Hương Trà, Thành phố Huế","code":"20008","parent_code":"480"},"20011":{"name":"Phường Hương Văn","type":"phuong","slug":"phuong-huong-van","name_with_type":"Phường Hương Văn","path":"Phường Hương Văn, Thị xã Hương Trà, Thành phố Huế","path_with_type":"Phường Hương Văn, Thị xã Hương Trà, Thành phố Huế","code":"20011","parent_code":"480"},"20014":{"name":"Phường Hương Vinh","type":"phuong","slug":"phuong-huong-vinh","name_with_type":"Phường Hương Vinh","path":"Phường Hương Vinh, Quận Phú Xuân, Thành phố Huế","path_with_type":"Phường Hương Vinh, Quận Phú Xuân, Thành phố Huế","code":"20014","parent_code":"475"},"20017":{"name":"Phường Hương Xuân","type":"phuong","slug":"phuong-huong-xuan","name_with_type":"Phường Hương Xuân","path":"Phường Hương Xuân, Thị xã Hương Trà, Thành phố Huế","path_with_type":"Phường Hương Xuân, Thị xã Hương Trà, Thành phố Huế","code":"20017","parent_code":"480"},"20020":{"name":"Phường Hương Chữ","type":"phuong","slug":"phuong-huong-chu","name_with_type":"Phường Hương Chữ","path":"Phường Hương Chữ, Thị xã Hương Trà, Thành phố Huế","path_with_type":"Phường Hương Chữ, Thị xã Hương Trà, Thành phố Huế","code":"20020","parent_code":"480"},"20023":{"name":"Phường Hương An","type":"phuong","slug":"phuong-huong-an","name_with_type":"Phường Hương An","path":"Phường Hương An, Quận Phú Xuân, Thành phố Huế","path_with_type":"Phường Hương An, Quận Phú Xuân, Thành phố Huế","code":"20023","parent_code":"475"},"20026":{"name":"Xã Hương Bình","type":"xa","slug":"xa-huong-binh","name_with_type":"Xã Hương Bình","path":"Xã Hương Bình, Thị xã Hương Trà, Thành phố Huế","path_with_type":"Xã Hương Bình, Thị xã Hương Trà, Thành phố Huế","code":"20026","parent_code":"480"},"20029":{"name":"Phường Long Hồ","type":"phuong","slug":"phuong-long-ho","name_with_type":"Phường Long Hồ","path":"Phường Long Hồ, Quận Phú Xuân, Thành phố Huế","path_with_type":"Phường Long Hồ, Quận Phú Xuân, Thành phố Huế","code":"20029","parent_code":"475"},"20035":{"name":"Xã Bình Tiến","type":"xa","slug":"xa-binh-tien","name_with_type":"Xã Bình Tiến","path":"Xã Bình Tiến, Thị xã Hương Trà, Thành phố Huế","path_with_type":"Xã Bình Tiến, Thị xã Hương Trà, Thành phố Huế","code":"20035","parent_code":"480"},"20041":{"name":"Xã Bình Thành","type":"xa","slug":"xa-binh-thanh","name_with_type":"Xã Bình Thành","path":"Xã Bình Thành, Thị xã Hương Trà, Thành phố Huế","path_with_type":"Xã Bình Thành, Thị xã Hương Trà, Thành phố Huế","code":"20041","parent_code":"480"},"20044":{"name":"Thị trấn A Lưới","type":"thi-tran","slug":"thi-tran-a-luoi","name_with_type":"Thị trấn A Lưới","path":"Thị trấn A Lưới, Huyện A Lưới, Thành phố Huế","path_with_type":"Thị trấn A Lưới, Huyện A Lưới, Thành phố Huế","code":"20044","parent_code":"481"},"20047":{"name":"Xã Hồng Vân","type":"xa","slug":"xa-hong-van","name_with_type":"Xã Hồng Vân","path":"Xã Hồng Vân, Huyện A Lưới, Thành phố Huế","path_with_type":"Xã Hồng Vân, Huyện A Lưới, Thành phố Huế","code":"20047","parent_code":"481"},"20050":{"name":"Xã Hồng Hạ","type":"xa","slug":"xa-hong-ha","name_with_type":"Xã Hồng Hạ","path":"Xã Hồng Hạ, Huyện A Lưới, Thành phố Huế","path_with_type":"Xã Hồng Hạ, Huyện A Lưới, Thành phố Huế","code":"20050","parent_code":"481"},"20053":{"name":"Xã Hồng Kim","type":"xa","slug":"xa-hong-kim","name_with_type":"Xã Hồng Kim","path":"Xã Hồng Kim, Huyện A Lưới, Thành phố Huế","path_with_type":"Xã Hồng Kim, Huyện A Lưới, Thành phố Huế","code":"20053","parent_code":"481"},"20056":{"name":"Xã Trung Sơn","type":"xa","slug":"xa-trung-son","name_with_type":"Xã Trung Sơn","path":"Xã Trung Sơn, Huyện A Lưới, Thành phố Huế","path_with_type":"Xã Trung Sơn, Huyện A Lưới, Thành phố Huế","code":"20056","parent_code":"481"},"20059":{"name":"Xã Hương Nguyên","type":"xa","slug":"xa-huong-nguyen","name_with_type":"Xã Hương Nguyên","path":"Xã Hương Nguyên, Huyện A Lưới, Thành phố Huế","path_with_type":"Xã Hương Nguyên, Huyện A Lưới, Thành phố Huế","code":"20059","parent_code":"481"},"20065":{"name":"Xã Hồng Bắc","type":"xa","slug":"xa-hong-bac","name_with_type":"Xã Hồng Bắc","path":"Xã Hồng Bắc, Huyện A Lưới, Thành phố Huế","path_with_type":"Xã Hồng Bắc, Huyện A Lưới, Thành phố Huế","code":"20065","parent_code":"481"},"20068":{"name":"Xã A Ngo","type":"xa","slug":"xa-a-ngo","name_with_type":"Xã A Ngo","path":"Xã A Ngo, Huyện A Lưới, Thành phố Huế","path_with_type":"Xã A Ngo, Huyện A Lưới, Thành phố Huế","code":"20068","parent_code":"481"},"20071":{"name":"Xã Sơn Thủy","type":"xa","slug":"xa-son-thuy","name_with_type":"Xã Sơn Thủy","path":"Xã Sơn Thủy, Huyện A Lưới, Thành phố Huế","path_with_type":"Xã Sơn Thủy, Huyện A Lưới, Thành phố Huế","code":"20071","parent_code":"481"},"20074":{"name":"Xã Phú Vinh","type":"xa","slug":"xa-phu-vinh","name_with_type":"Xã Phú Vinh","path":"Xã Phú Vinh, Huyện A Lưới, Thành phố Huế","path_with_type":"Xã Phú Vinh, Huyện A Lưới, Thành phố Huế","code":"20074","parent_code":"481"},"20080":{"name":"Xã Hương Phong","type":"xa","slug":"xa-huong-phong","name_with_type":"Xã Hương Phong","path":"Xã Hương Phong, Huyện A Lưới, Thành phố Huế","path_with_type":"Xã Hương Phong, Huyện A Lưới, Thành phố Huế","code":"20080","parent_code":"481"},"20083":{"name":"Xã Quảng Nhâm","type":"xa","slug":"xa-quang-nham","name_with_type":"Xã Quảng Nhâm","path":"Xã Quảng Nhâm, Huyện A Lưới, Thành phố Huế","path_with_type":"Xã Quảng Nhâm, Huyện A Lưới, Thành phố Huế","code":"20083","parent_code":"481"},"20086":{"name":"Xã Hồng Thượng","type":"xa","slug":"xa-hong-thuong","name_with_type":"Xã Hồng Thượng","path":"Xã Hồng Thượng, Huyện A Lưới, Thành phố Huế","path_with_type":"Xã Hồng Thượng, Huyện A Lưới, Thành phố Huế","code":"20086","parent_code":"481"},"20089":{"name":"Xã Hồng Thái","type":"xa","slug":"xa-hong-thai","name_with_type":"Xã Hồng Thái","path":"Xã Hồng Thái, Huyện A Lưới, Thành phố Huế","path_with_type":"Xã Hồng Thái, Huyện A Lưới, Thành phố Huế","code":"20089","parent_code":"481"},"20095":{"name":"Xã A Roàng","type":"xa","slug":"xa-a-roang","name_with_type":"Xã A Roàng","path":"Xã A Roàng, Huyện A Lưới, Thành phố Huế","path_with_type":"Xã A Roàng, Huyện A Lưới, Thành phố Huế","code":"20095","parent_code":"481"},"20098":{"name":"Xã Đông Sơn","type":"xa","slug":"xa-dong-son","name_with_type":"Xã Đông Sơn","path":"Xã Đông Sơn, Huyện A Lưới, Thành phố Huế","path_with_type":"Xã Đông Sơn, Huyện A Lưới, Thành phố Huế","code":"20098","parent_code":"481"},"20101":{"name":"Xã Lâm Đớt","type":"xa","slug":"xa-lam-dot","name_with_type":"Xã Lâm Đớt","path":"Xã Lâm Đớt, Huyện A Lưới, Thành phố Huế","path_with_type":"Xã Lâm Đớt, Huyện A Lưới, Thành phố Huế","code":"20101","parent_code":"481"},"20104":{"name":"Xã Hồng Thủy","type":"xa","slug":"xa-hong-thuy","name_with_type":"Xã Hồng Thủy","path":"Xã Hồng Thủy, Huyện A Lưới, Thành phố Huế","path_with_type":"Xã Hồng Thủy, Huyện A Lưới, Thành phố Huế","code":"20104","parent_code":"481"},"20107":{"name":"Thị trấn Phú Lộc","type":"thi-tran","slug":"thi-tran-phu-loc","name_with_type":"Thị trấn Phú Lộc","path":"Thị trấn Phú Lộc, Huyện Phú Lộc, Thành phố Huế","path_with_type":"Thị trấn Phú Lộc, Huyện Phú Lộc, Thành phố Huế","code":"20107","parent_code":"482"},"20110":{"name":"Thị trấn Lăng Cô","type":"thi-tran","slug":"thi-tran-lang-co","name_with_type":"Thị trấn Lăng Cô","path":"Thị trấn Lăng Cô, Huyện Phú Lộc, Thành phố Huế","path_with_type":"Thị trấn Lăng Cô, Huyện Phú Lộc, Thành phố Huế","code":"20110","parent_code":"482"},"20113":{"name":"Xã Vinh Mỹ","type":"xa","slug":"xa-vinh-my","name_with_type":"Xã Vinh Mỹ","path":"Xã Vinh Mỹ, Huyện Phú Lộc, Thành phố Huế","path_with_type":"Xã Vinh Mỹ, Huyện Phú Lộc, Thành phố Huế","code":"20113","parent_code":"482"},"20116":{"name":"Xã Vinh Hưng","type":"xa","slug":"xa-vinh-hung","name_with_type":"Xã Vinh Hưng","path":"Xã Vinh Hưng, Huyện Phú Lộc, Thành phố Huế","path_with_type":"Xã Vinh Hưng, Huyện Phú Lộc, Thành phố Huế","code":"20116","parent_code":"482"},"20122":{"name":"Xã Giang Hải","type":"xa","slug":"xa-giang-hai","name_with_type":"Xã Giang Hải","path":"Xã Giang Hải, Huyện Phú Lộc, Thành phố Huế","path_with_type":"Xã Giang Hải, Huyện Phú Lộc, Thành phố Huế","code":"20122","parent_code":"482"},"20125":{"name":"Xã Vinh Hiền","type":"xa","slug":"xa-vinh-hien","name_with_type":"Xã Vinh Hiền","path":"Xã Vinh Hiền, Huyện Phú Lộc, Thành phố Huế","path_with_type":"Xã Vinh Hiền, Huyện Phú Lộc, Thành phố Huế","code":"20125","parent_code":"482"},"20128":{"name":"Xã Lộc Bổn","type":"xa","slug":"xa-loc-bon","name_with_type":"Xã Lộc Bổn","path":"Xã Lộc Bổn, Huyện Phú Lộc, Thành phố Huế","path_with_type":"Xã Lộc Bổn, Huyện Phú Lộc, Thành phố Huế","code":"20128","parent_code":"482"},"20131":{"name":"Thị trấn Lộc Sơn","type":"thi-tran","slug":"thi-tran-loc-son","name_with_type":"Thị trấn Lộc Sơn","path":"Thị trấn Lộc Sơn, Huyện Phú Lộc, Thành phố Huế","path_with_type":"Thị trấn Lộc Sơn, Huyện Phú Lộc, Thành phố Huế","code":"20131","parent_code":"482"},"20134":{"name":"Xã Lộc Bình","type":"xa","slug":"xa-loc-binh","name_with_type":"Xã Lộc Bình","path":"Xã Lộc Bình, Huyện Phú Lộc, Thành phố Huế","path_with_type":"Xã Lộc Bình, Huyện Phú Lộc, Thành phố Huế","code":"20134","parent_code":"482"},"20137":{"name":"Xã Lộc Vĩnh","type":"xa","slug":"xa-loc-vinh","name_with_type":"Xã Lộc Vĩnh","path":"Xã Lộc Vĩnh, Huyện Phú Lộc, Thành phố Huế","path_with_type":"Xã Lộc Vĩnh, Huyện Phú Lộc, Thành phố Huế","code":"20137","parent_code":"482"},"20140":{"name":"Xã Lộc An","type":"xa","slug":"xa-loc-an","name_with_type":"Xã Lộc An","path":"Xã Lộc An, Huyện Phú Lộc, Thành phố Huế","path_with_type":"Xã Lộc An, Huyện Phú Lộc, Thành phố Huế","code":"20140","parent_code":"482"},"20143":{"name":"Xã Lộc Điền","type":"xa","slug":"xa-loc-dien","name_with_type":"Xã Lộc Điền","path":"Xã Lộc Điền, Huyện Phú Lộc, Thành phố Huế","path_with_type":"Xã Lộc Điền, Huyện Phú Lộc, Thành phố Huế","code":"20143","parent_code":"482"},"20146":{"name":"Xã Lộc Thủy","type":"xa","slug":"xa-loc-thuy","name_with_type":"Xã Lộc Thủy","path":"Xã Lộc Thủy, Huyện Phú Lộc, Thành phố Huế","path_with_type":"Xã Lộc Thủy, Huyện Phú Lộc, Thành phố Huế","code":"20146","parent_code":"482"},"20149":{"name":"Xã Lộc Trì","type":"xa","slug":"xa-loc-tri","name_with_type":"Xã Lộc Trì","path":"Xã Lộc Trì, Huyện Phú Lộc, Thành phố Huế","path_with_type":"Xã Lộc Trì, Huyện Phú Lộc, Thành phố Huế","code":"20149","parent_code":"482"},"20152":{"name":"Xã Lộc Tiến","type":"xa","slug":"xa-loc-tien","name_with_type":"Xã Lộc Tiến","path":"Xã Lộc Tiến, Huyện Phú Lộc, Thành phố Huế","path_with_type":"Xã Lộc Tiến, Huyện Phú Lộc, Thành phố Huế","code":"20152","parent_code":"482"},"20155":{"name":"Xã Lộc Hòa","type":"xa","slug":"xa-loc-hoa","name_with_type":"Xã Lộc Hòa","path":"Xã Lộc Hòa, Huyện Phú Lộc, Thành phố Huế","path_with_type":"Xã Lộc Hòa, Huyện Phú Lộc, Thành phố Huế","code":"20155","parent_code":"482"},"20158":{"name":"Xã Xuân Lộc","type":"xa","slug":"xa-xuan-loc","name_with_type":"Xã Xuân Lộc","path":"Xã Xuân Lộc, Huyện Phú Lộc, Thành phố Huế","path_with_type":"Xã Xuân Lộc, Huyện Phú Lộc, Thành phố Huế","code":"20158","parent_code":"482"},"20161":{"name":"Thị trấn Khe Tre","type":"thi-tran","slug":"thi-tran-khe-tre","name_with_type":"Thị trấn Khe Tre","path":"Thị trấn Khe Tre, Huyện Phú Lộc, Thành phố Huế","path_with_type":"Thị trấn Khe Tre, Huyện Phú Lộc, Thành phố Huế","code":"20161","parent_code":"482"},"20164":{"name":"Xã Hương Phú","type":"xa","slug":"xa-huong-phu","name_with_type":"Xã Hương Phú","path":"Xã Hương Phú, Huyện Phú Lộc, Thành phố Huế","path_with_type":"Xã Hương Phú, Huyện Phú Lộc, Thành phố Huế","code":"20164","parent_code":"482"},"20167":{"name":"Xã Hương Sơn","type":"xa","slug":"xa-huong-son","name_with_type":"Xã Hương Sơn","path":"Xã Hương Sơn, Huyện Phú Lộc, Thành phố Huế","path_with_type":"Xã Hương Sơn, Huyện Phú Lộc, Thành phố Huế","code":"20167","parent_code":"482"},"20170":{"name":"Xã Hương Lộc","type":"xa","slug":"xa-huong-loc","name_with_type":"Xã Hương Lộc","path":"Xã Hương Lộc, Huyện Phú Lộc, Thành phố Huế","path_with_type":"Xã Hương Lộc, Huyện Phú Lộc, Thành phố Huế","code":"20170","parent_code":"482"},"20173":{"name":"Xã Thượng Quảng","type":"xa","slug":"xa-thuong-quang","name_with_type":"Xã Thượng Quảng","path":"Xã Thượng Quảng, Huyện Phú Lộc, Thành phố Huế","path_with_type":"Xã Thượng Quảng, Huyện Phú Lộc, Thành phố Huế","code":"20173","parent_code":"482"},"20176":{"name":"Xã Hương Hòa","type":"xa","slug":"xa-huong-hoa","name_with_type":"Xã Hương Hòa","path":"Xã Hương Hòa, Huyện Phú Lộc, Thành phố Huế","path_with_type":"Xã Hương Hòa, Huyện Phú Lộc, Thành phố Huế","code":"20176","parent_code":"482"},"20179":{"name":"Xã Hương Xuân","type":"xa","slug":"xa-huong-xuan","name_with_type":"Xã Hương Xuân","path":"Xã Hương Xuân, Huyện Phú Lộc, Thành phố Huế","path_with_type":"Xã Hương Xuân, Huyện Phú Lộc, Thành phố Huế","code":"20179","parent_code":"482"},"20182":{"name":"Xã Hương Hữu","type":"xa","slug":"xa-huong-huu","name_with_type":"Xã Hương Hữu","path":"Xã Hương Hữu, Huyện Phú Lộc, Thành phố Huế","path_with_type":"Xã Hương Hữu, Huyện Phú Lộc, Thành phố Huế","code":"20182","parent_code":"482"},"20185":{"name":"Xã Thượng Lộ","type":"xa","slug":"xa-thuong-lo","name_with_type":"Xã Thượng Lộ","path":"Xã Thượng Lộ, Huyện Phú Lộc, Thành phố Huế","path_with_type":"Xã Thượng Lộ, Huyện Phú Lộc, Thành phố Huế","code":"20185","parent_code":"482"},"20188":{"name":"Xã Thượng Long","type":"xa","slug":"xa-thuong-long","name_with_type":"Xã Thượng Long","path":"Xã Thượng Long, Huyện Phú Lộc, Thành phố Huế","path_with_type":"Xã Thượng Long, Huyện Phú Lộc, Thành phố Huế","code":"20188","parent_code":"482"},"20191":{"name":"Xã Thượng Nhật","type":"xa","slug":"xa-thuong-nhat","name_with_type":"Xã Thượng Nhật","path":"Xã Thượng Nhật, Huyện Phú Lộc, Thành phố Huế","path_with_type":"Xã Thượng Nhật, Huyện Phú Lộc, Thành phố Huế","code":"20191","parent_code":"482"},"20194":{"name":"Phường Hòa Hiệp Bắc","type":"phuong","slug":"phuong-hoa-hiep-bac","name_with_type":"Phường Hòa Hiệp Bắc","path":"Phường Hòa Hiệp Bắc, Quận Liên Chiểu, Thành phố Đà Nẵng","path_with_type":"Phường Hòa Hiệp Bắc, Quận Liên Chiểu, Thành phố Đà Nẵng","code":"20194","parent_code":"490"},"20195":{"name":"Phường Hòa Hiệp Nam","type":"phuong","slug":"phuong-hoa-hiep-nam","name_with_type":"Phường Hòa Hiệp Nam","path":"Phường Hòa Hiệp Nam, Quận Liên Chiểu, Thành phố Đà Nẵng","path_with_type":"Phường Hòa Hiệp Nam, Quận Liên Chiểu, Thành phố Đà Nẵng","code":"20195","parent_code":"490"},"20197":{"name":"Phường Hòa Khánh Bắc","type":"phuong","slug":"phuong-hoa-khanh-bac","name_with_type":"Phường Hòa Khánh Bắc","path":"Phường Hòa Khánh Bắc, Quận Liên Chiểu, Thành phố Đà Nẵng","path_with_type":"Phường Hòa Khánh Bắc, Quận Liên Chiểu, Thành phố Đà Nẵng","code":"20197","parent_code":"490"},"20198":{"name":"Phường Hòa Khánh Nam","type":"phuong","slug":"phuong-hoa-khanh-nam","name_with_type":"Phường Hòa Khánh Nam","path":"Phường Hòa Khánh Nam, Quận Liên Chiểu, Thành phố Đà Nẵng","path_with_type":"Phường Hòa Khánh Nam, Quận Liên Chiểu, Thành phố Đà Nẵng","code":"20198","parent_code":"490"},"20200":{"name":"Phường Hòa Minh","type":"phuong","slug":"phuong-hoa-minh","name_with_type":"Phường Hòa Minh","path":"Phường Hòa Minh, Quận Liên Chiểu, Thành phố Đà Nẵng","path_with_type":"Phường Hòa Minh, Quận Liên Chiểu, Thành phố Đà Nẵng","code":"20200","parent_code":"490"},"20206":{"name":"Phường Thanh Khê Tây","type":"phuong","slug":"phuong-thanh-khe-tay","name_with_type":"Phường Thanh Khê Tây","path":"Phường Thanh Khê Tây, Quận Thanh Khê, Thành phố Đà Nẵng","path_with_type":"Phường Thanh Khê Tây, Quận Thanh Khê, Thành phố Đà Nẵng","code":"20206","parent_code":"491"},"20207":{"name":"Phường Thanh Khê Đông","type":"phuong","slug":"phuong-thanh-khe-dong","name_with_type":"Phường Thanh Khê Đông","path":"Phường Thanh Khê Đông, Quận Thanh Khê, Thành phố Đà Nẵng","path_with_type":"Phường Thanh Khê Đông, Quận Thanh Khê, Thành phố Đà Nẵng","code":"20207","parent_code":"491"},"20209":{"name":"Phường Xuân Hà","type":"phuong","slug":"phuong-xuan-ha","name_with_type":"Phường Xuân Hà","path":"Phường Xuân Hà, Quận Thanh Khê, Thành phố Đà Nẵng","path_with_type":"Phường Xuân Hà, Quận Thanh Khê, Thành phố Đà Nẵng","code":"20209","parent_code":"491"},"20215":{"name":"Phường Chính Gián","type":"phuong","slug":"phuong-chinh-gian","name_with_type":"Phường Chính Gián","path":"Phường Chính Gián, Quận Thanh Khê, Thành phố Đà Nẵng","path_with_type":"Phường Chính Gián, Quận Thanh Khê, Thành phố Đà Nẵng","code":"20215","parent_code":"491"},"20218":{"name":"Phường Thạc Gián","type":"phuong","slug":"phuong-thac-gian","name_with_type":"Phường Thạc Gián","path":"Phường Thạc Gián, Quận Thanh Khê, Thành phố Đà Nẵng","path_with_type":"Phường Thạc Gián, Quận Thanh Khê, Thành phố Đà Nẵng","code":"20218","parent_code":"491"},"20224":{"name":"Phường An Khê","type":"phuong","slug":"phuong-an-khe","name_with_type":"Phường An Khê","path":"Phường An Khê, Quận Thanh Khê, Thành phố Đà Nẵng","path_with_type":"Phường An Khê, Quận Thanh Khê, Thành phố Đà Nẵng","code":"20224","parent_code":"491"},"20227":{"name":"Phường Thanh Bình","type":"phuong","slug":"phuong-thanh-binh","name_with_type":"Phường Thanh Bình","path":"Phường Thanh Bình, Quận Hải Châu, Thành phố Đà Nẵng","path_with_type":"Phường Thanh Bình, Quận Hải Châu, Thành phố Đà Nẵng","code":"20227","parent_code":"492"},"20230":{"name":"Phường Thuận Phước","type":"phuong","slug":"phuong-thuan-phuoc","name_with_type":"Phường Thuận Phước","path":"Phường Thuận Phước, Quận Hải Châu, Thành phố Đà Nẵng","path_with_type":"Phường Thuận Phước, Quận Hải Châu, Thành phố Đà Nẵng","code":"20230","parent_code":"492"},"20233":{"name":"Phường Thạch Thang","type":"phuong","slug":"phuong-thach-thang","name_with_type":"Phường Thạch Thang","path":"Phường Thạch Thang, Quận Hải Châu, Thành phố Đà Nẵng","path_with_type":"Phường Thạch Thang, Quận Hải Châu, Thành phố Đà Nẵng","code":"20233","parent_code":"492"},"20236":{"name":"Phường Hải Châu","type":"phuong","slug":"phuong-hai-chau","name_with_type":"Phường Hải Châu","path":"Phường Hải Châu, Quận Hải Châu, Thành phố Đà Nẵng","path_with_type":"Phường Hải Châu, Quận Hải Châu, Thành phố Đà Nẵng","code":"20236","parent_code":"492"},"20242":{"name":"Phường Phước Ninh","type":"phuong","slug":"phuong-phuoc-ninh","name_with_type":"Phường Phước Ninh","path":"Phường Phước Ninh, Quận Hải Châu, Thành phố Đà Nẵng","path_with_type":"Phường Phước Ninh, Quận Hải Châu, Thành phố Đà Nẵng","code":"20242","parent_code":"492"},"20245":{"name":"Phường Hòa Thuận Tây","type":"phuong","slug":"phuong-hoa-thuan-tay","name_with_type":"Phường Hòa Thuận Tây","path":"Phường Hòa Thuận Tây, Quận Hải Châu, Thành phố Đà Nẵng","path_with_type":"Phường Hòa Thuận Tây, Quận Hải Châu, Thành phố Đà Nẵng","code":"20245","parent_code":"492"},"20254":{"name":"Phường Bình Thuận","type":"phuong","slug":"phuong-binh-thuan","name_with_type":"Phường Bình Thuận","path":"Phường Bình Thuận, Quận Hải Châu, Thành phố Đà Nẵng","path_with_type":"Phường Bình Thuận, Quận Hải Châu, Thành phố Đà Nẵng","code":"20254","parent_code":"492"},"20257":{"name":"Phường Hòa Cường Bắc","type":"phuong","slug":"phuong-hoa-cuong-bac","name_with_type":"Phường Hòa Cường Bắc","path":"Phường Hòa Cường Bắc, Quận Hải Châu, Thành phố Đà Nẵng","path_with_type":"Phường Hòa Cường Bắc, Quận Hải Châu, Thành phố Đà Nẵng","code":"20257","parent_code":"492"},"20258":{"name":"Phường Hòa Cường Nam","type":"phuong","slug":"phuong-hoa-cuong-nam","name_with_type":"Phường Hòa Cường Nam","path":"Phường Hòa Cường Nam, Quận Hải Châu, Thành phố Đà Nẵng","path_with_type":"Phường Hòa Cường Nam, Quận Hải Châu, Thành phố Đà Nẵng","code":"20258","parent_code":"492"},"20260":{"name":"Phường Khuê Trung","type":"phuong","slug":"phuong-khue-trung","name_with_type":"Phường Khuê Trung","path":"Phường Khuê Trung, Quận Cẩm Lệ, Thành phố Đà Nẵng","path_with_type":"Phường Khuê Trung, Quận Cẩm Lệ, Thành phố Đà Nẵng","code":"20260","parent_code":"495"},"20263":{"name":"Phường Thọ Quang","type":"phuong","slug":"phuong-tho-quang","name_with_type":"Phường Thọ Quang","path":"Phường Thọ Quang, Quận Sơn Trà, Thành phố Đà Nẵng","path_with_type":"Phường Thọ Quang, Quận Sơn Trà, Thành phố Đà Nẵng","code":"20263","parent_code":"493"},"20266":{"name":"Phường Nại Hiên Đông","type":"phuong","slug":"phuong-nai-hien-dong","name_with_type":"Phường Nại Hiên Đông","path":"Phường Nại Hiên Đông, Quận Sơn Trà, Thành phố Đà Nẵng","path_with_type":"Phường Nại Hiên Đông, Quận Sơn Trà, Thành phố Đà Nẵng","code":"20266","parent_code":"493"},"20269":{"name":"Phường Mân Thái","type":"phuong","slug":"phuong-man-thai","name_with_type":"Phường Mân Thái","path":"Phường Mân Thái, Quận Sơn Trà, Thành phố Đà Nẵng","path_with_type":"Phường Mân Thái, Quận Sơn Trà, Thành phố Đà Nẵng","code":"20269","parent_code":"493"},"20272":{"name":"Phường An Hải Bắc","type":"phuong","slug":"phuong-an-hai-bac","name_with_type":"Phường An Hải Bắc","path":"Phường An Hải Bắc, Quận Sơn Trà, Thành phố Đà Nẵng","path_with_type":"Phường An Hải Bắc, Quận Sơn Trà, Thành phố Đà Nẵng","code":"20272","parent_code":"493"},"20275":{"name":"Phường Phước Mỹ","type":"phuong","slug":"phuong-phuoc-my","name_with_type":"Phường Phước Mỹ","path":"Phường Phước Mỹ, Quận Sơn Trà, Thành phố Đà Nẵng","path_with_type":"Phường Phước Mỹ, Quận Sơn Trà, Thành phố Đà Nẵng","code":"20275","parent_code":"493"},"20278":{"name":"Phường An Hải Nam","type":"phuong","slug":"phuong-an-hai-nam","name_with_type":"Phường An Hải Nam","path":"Phường An Hải Nam, Quận Sơn Trà, Thành phố Đà Nẵng","path_with_type":"Phường An Hải Nam, Quận Sơn Trà, Thành phố Đà Nẵng","code":"20278","parent_code":"493"},"20284":{"name":"Phường Mỹ An","type":"phuong","slug":"phuong-my-an","name_with_type":"Phường Mỹ An","path":"Phường Mỹ An, Quận Ngũ Hành Sơn, Thành phố Đà Nẵng","path_with_type":"Phường Mỹ An, Quận Ngũ Hành Sơn, Thành phố Đà Nẵng","code":"20284","parent_code":"494"},"20285":{"name":"Phường Khuê Mỹ","type":"phuong","slug":"phuong-khue-my","name_with_type":"Phường Khuê Mỹ","path":"Phường Khuê Mỹ, Quận Ngũ Hành Sơn, Thành phố Đà Nẵng","path_with_type":"Phường Khuê Mỹ, Quận Ngũ Hành Sơn, Thành phố Đà Nẵng","code":"20285","parent_code":"494"},"20287":{"name":"Phường Hoà Quý","type":"phuong","slug":"phuong-hoa-quy","name_with_type":"Phường Hoà Quý","path":"Phường Hoà Quý, Quận Ngũ Hành Sơn, Thành phố Đà Nẵng","path_with_type":"Phường Hoà Quý, Quận Ngũ Hành Sơn, Thành phố Đà Nẵng","code":"20287","parent_code":"494"},"20290":{"name":"Phường Hoà Hải","type":"phuong","slug":"phuong-hoa-hai","name_with_type":"Phường Hoà Hải","path":"Phường Hoà Hải, Quận Ngũ Hành Sơn, Thành phố Đà Nẵng","path_with_type":"Phường Hoà Hải, Quận Ngũ Hành Sơn, Thành phố Đà Nẵng","code":"20290","parent_code":"494"},"20293":{"name":"Xã Hòa Bắc","type":"xa","slug":"xa-hoa-bac","name_with_type":"Xã Hòa Bắc","path":"Xã Hòa Bắc, Huyện Hòa Vang, Thành phố Đà Nẵng","path_with_type":"Xã Hòa Bắc, Huyện Hòa Vang, Thành phố Đà Nẵng","code":"20293","parent_code":"497"},"20296":{"name":"Xã Hòa Liên","type":"xa","slug":"xa-hoa-lien","name_with_type":"Xã Hòa Liên","path":"Xã Hòa Liên, Huyện Hòa Vang, Thành phố Đà Nẵng","path_with_type":"Xã Hòa Liên, Huyện Hòa Vang, Thành phố Đà Nẵng","code":"20296","parent_code":"497"},"20299":{"name":"Xã Hòa Ninh","type":"xa","slug":"xa-hoa-ninh","name_with_type":"Xã Hòa Ninh","path":"Xã Hòa Ninh, Huyện Hòa Vang, Thành phố Đà Nẵng","path_with_type":"Xã Hòa Ninh, Huyện Hòa Vang, Thành phố Đà Nẵng","code":"20299","parent_code":"497"},"20302":{"name":"Xã Hòa Sơn","type":"xa","slug":"xa-hoa-son","name_with_type":"Xã Hòa Sơn","path":"Xã Hòa Sơn, Huyện Hòa Vang, Thành phố Đà Nẵng","path_with_type":"Xã Hòa Sơn, Huyện Hòa Vang, Thành phố Đà Nẵng","code":"20302","parent_code":"497"},"20305":{"name":"Phường Hòa Phát","type":"phuong","slug":"phuong-hoa-phat","name_with_type":"Phường Hòa Phát","path":"Phường Hòa Phát, Quận Cẩm Lệ, Thành phố Đà Nẵng","path_with_type":"Phường Hòa Phát, Quận Cẩm Lệ, Thành phố Đà Nẵng","code":"20305","parent_code":"495"},"20306":{"name":"Phường Hòa An","type":"phuong","slug":"phuong-hoa-an","name_with_type":"Phường Hòa An","path":"Phường Hòa An, Quận Cẩm Lệ, Thành phố Đà Nẵng","path_with_type":"Phường Hòa An, Quận Cẩm Lệ, Thành phố Đà Nẵng","code":"20306","parent_code":"495"},"20308":{"name":"Xã Hòa Nhơn","type":"xa","slug":"xa-hoa-nhon","name_with_type":"Xã Hòa Nhơn","path":"Xã Hòa Nhơn, Huyện Hòa Vang, Thành phố Đà Nẵng","path_with_type":"Xã Hòa Nhơn, Huyện Hòa Vang, Thành phố Đà Nẵng","code":"20308","parent_code":"497"},"20311":{"name":"Phường Hòa Thọ Tây","type":"phuong","slug":"phuong-hoa-tho-tay","name_with_type":"Phường Hòa Thọ Tây","path":"Phường Hòa Thọ Tây, Quận Cẩm Lệ, Thành phố Đà Nẵng","path_with_type":"Phường Hòa Thọ Tây, Quận Cẩm Lệ, Thành phố Đà Nẵng","code":"20311","parent_code":"495"},"20312":{"name":"Phường Hòa Thọ Đông","type":"phuong","slug":"phuong-hoa-tho-dong","name_with_type":"Phường Hòa Thọ Đông","path":"Phường Hòa Thọ Đông, Quận Cẩm Lệ, Thành phố Đà Nẵng","path_with_type":"Phường Hòa Thọ Đông, Quận Cẩm Lệ, Thành phố Đà Nẵng","code":"20312","parent_code":"495"},"20314":{"name":"Phường Hòa Xuân","type":"phuong","slug":"phuong-hoa-xuan","name_with_type":"Phường Hòa Xuân","path":"Phường Hòa Xuân, Quận Cẩm Lệ, Thành phố Đà Nẵng","path_with_type":"Phường Hòa Xuân, Quận Cẩm Lệ, Thành phố Đà Nẵng","code":"20314","parent_code":"495"},"20317":{"name":"Xã Hòa Phú","type":"xa","slug":"xa-hoa-phu","name_with_type":"Xã Hòa Phú","path":"Xã Hòa Phú, Huyện Hòa Vang, Thành phố Đà Nẵng","path_with_type":"Xã Hòa Phú, Huyện Hòa Vang, Thành phố Đà Nẵng","code":"20317","parent_code":"497"},"20320":{"name":"Xã Hòa Phong","type":"xa","slug":"xa-hoa-phong","name_with_type":"Xã Hòa Phong","path":"Xã Hòa Phong, Huyện Hòa Vang, Thành phố Đà Nẵng","path_with_type":"Xã Hòa Phong, Huyện Hòa Vang, Thành phố Đà Nẵng","code":"20320","parent_code":"497"},"20323":{"name":"Xã Hòa Châu","type":"xa","slug":"xa-hoa-chau","name_with_type":"Xã Hòa Châu","path":"Xã Hòa Châu, Huyện Hòa Vang, Thành phố Đà Nẵng","path_with_type":"Xã Hòa Châu, Huyện Hòa Vang, Thành phố Đà Nẵng","code":"20323","parent_code":"497"},"20326":{"name":"Xã Hòa Tiến","type":"xa","slug":"xa-hoa-tien","name_with_type":"Xã Hòa Tiến","path":"Xã Hòa Tiến, Huyện Hòa Vang, Thành phố Đà Nẵng","path_with_type":"Xã Hòa Tiến, Huyện Hòa Vang, Thành phố Đà Nẵng","code":"20326","parent_code":"497"},"20329":{"name":"Xã Hòa Phước","type":"xa","slug":"xa-hoa-phuoc","name_with_type":"Xã Hòa Phước","path":"Xã Hòa Phước, Huyện Hòa Vang, Thành phố Đà Nẵng","path_with_type":"Xã Hòa Phước, Huyện Hòa Vang, Thành phố Đà Nẵng","code":"20329","parent_code":"497"},"20332":{"name":"Xã Hòa Khương","type":"xa","slug":"xa-hoa-khuong","name_with_type":"Xã Hòa Khương","path":"Xã Hòa Khương, Huyện Hòa Vang, Thành phố Đà Nẵng","path_with_type":"Xã Hòa Khương, Huyện Hòa Vang, Thành phố Đà Nẵng","code":"20332","parent_code":"497"},"20335":{"name":"Phường Tân Thạnh","type":"phuong","slug":"phuong-tan-thanh","name_with_type":"Phường Tân Thạnh","path":"Phường Tân Thạnh, Thành phố Tam Kỳ, Tỉnh Quảng Nam","path_with_type":"Phường Tân Thạnh, Thành phố Tam Kỳ, Tỉnh Quảng Nam","code":"20335","parent_code":"502"},"20341":{"name":"Phường An Mỹ","type":"phuong","slug":"phuong-an-my","name_with_type":"Phường An Mỹ","path":"Phường An Mỹ, Thành phố Tam Kỳ, Tỉnh Quảng Nam","path_with_type":"Phường An Mỹ, Thành phố Tam Kỳ, Tỉnh Quảng Nam","code":"20341","parent_code":"502"},"20344":{"name":"Phường Hòa Hương","type":"phuong","slug":"phuong-hoa-huong","name_with_type":"Phường Hòa Hương","path":"Phường Hòa Hương, Thành phố Tam Kỳ, Tỉnh Quảng Nam","path_with_type":"Phường Hòa Hương, Thành phố Tam Kỳ, Tỉnh Quảng Nam","code":"20344","parent_code":"502"},"20347":{"name":"Phường An Xuân","type":"phuong","slug":"phuong-an-xuan","name_with_type":"Phường An Xuân","path":"Phường An Xuân, Thành phố Tam Kỳ, Tỉnh Quảng Nam","path_with_type":"Phường An Xuân, Thành phố Tam Kỳ, Tỉnh Quảng Nam","code":"20347","parent_code":"502"},"20350":{"name":"Phường An Sơn","type":"phuong","slug":"phuong-an-son","name_with_type":"Phường An Sơn","path":"Phường An Sơn, Thành phố Tam Kỳ, Tỉnh Quảng Nam","path_with_type":"Phường An Sơn, Thành phố Tam Kỳ, Tỉnh Quảng Nam","code":"20350","parent_code":"502"},"20353":{"name":"Phường Trường Xuân","type":"phuong","slug":"phuong-truong-xuan","name_with_type":"Phường Trường Xuân","path":"Phường Trường Xuân, Thành phố Tam Kỳ, Tỉnh Quảng Nam","path_with_type":"Phường Trường Xuân, Thành phố Tam Kỳ, Tỉnh Quảng Nam","code":"20353","parent_code":"502"},"20356":{"name":"Phường An Phú","type":"phuong","slug":"phuong-an-phu","name_with_type":"Phường An Phú","path":"Phường An Phú, Thành phố Tam Kỳ, Tỉnh Quảng Nam","path_with_type":"Phường An Phú, Thành phố Tam Kỳ, Tỉnh Quảng Nam","code":"20356","parent_code":"502"},"20359":{"name":"Xã Tam Thanh","type":"xa","slug":"xa-tam-thanh","name_with_type":"Xã Tam Thanh","path":"Xã Tam Thanh, Thành phố Tam Kỳ, Tỉnh Quảng Nam","path_with_type":"Xã Tam Thanh, Thành phố Tam Kỳ, Tỉnh Quảng Nam","code":"20359","parent_code":"502"},"20362":{"name":"Xã Tam Thăng","type":"xa","slug":"xa-tam-thang","name_with_type":"Xã Tam Thăng","path":"Xã Tam Thăng, Thành phố Tam Kỳ, Tỉnh Quảng Nam","path_with_type":"Xã Tam Thăng, Thành phố Tam Kỳ, Tỉnh Quảng Nam","code":"20362","parent_code":"502"},"20364":{"name":"Thị trấn Phú Thịnh","type":"thi-tran","slug":"thi-tran-phu-thinh","name_with_type":"Thị trấn Phú Thịnh","path":"Thị trấn Phú Thịnh, Huyện Phú Ninh, Tỉnh Quảng Nam","path_with_type":"Thị trấn Phú Thịnh, Huyện Phú Ninh, Tỉnh Quảng Nam","code":"20364","parent_code":"518"},"20365":{"name":"Xã Tam Thành","type":"xa","slug":"xa-tam-thanh","name_with_type":"Xã Tam Thành","path":"Xã Tam Thành, Huyện Phú Ninh, Tỉnh Quảng Nam","path_with_type":"Xã Tam Thành, Huyện Phú Ninh, Tỉnh Quảng Nam","code":"20365","parent_code":"518"},"20368":{"name":"Xã Tam An","type":"xa","slug":"xa-tam-an","name_with_type":"Xã Tam An","path":"Xã Tam An, Huyện Phú Ninh, Tỉnh Quảng Nam","path_with_type":"Xã Tam An, Huyện Phú Ninh, Tỉnh Quảng Nam","code":"20368","parent_code":"518"},"20371":{"name":"Xã Tam Phú","type":"xa","slug":"xa-tam-phu","name_with_type":"Xã Tam Phú","path":"Xã Tam Phú, Thành phố Tam Kỳ, Tỉnh Quảng Nam","path_with_type":"Xã Tam Phú, Thành phố Tam Kỳ, Tỉnh Quảng Nam","code":"20371","parent_code":"502"},"20374":{"name":"Xã Tam Đàn","type":"xa","slug":"xa-tam-dan","name_with_type":"Xã Tam Đàn","path":"Xã Tam Đàn, Huyện Phú Ninh, Tỉnh Quảng Nam","path_with_type":"Xã Tam Đàn, Huyện Phú Ninh, Tỉnh Quảng Nam","code":"20374","parent_code":"518"},"20375":{"name":"Phường Hoà Thuận","type":"phuong","slug":"phuong-hoa-thuan","name_with_type":"Phường Hoà Thuận","path":"Phường Hoà Thuận, Thành phố Tam Kỳ, Tỉnh Quảng Nam","path_with_type":"Phường Hoà Thuận, Thành phố Tam Kỳ, Tỉnh Quảng Nam","code":"20375","parent_code":"502"},"20377":{"name":"Xã Tam Lộc","type":"xa","slug":"xa-tam-loc","name_with_type":"Xã Tam Lộc","path":"Xã Tam Lộc, Huyện Phú Ninh, Tỉnh Quảng Nam","path_with_type":"Xã Tam Lộc, Huyện Phú Ninh, Tỉnh Quảng Nam","code":"20377","parent_code":"518"},"20380":{"name":"Xã Tam Phước","type":"xa","slug":"xa-tam-phuoc","name_with_type":"Xã Tam Phước","path":"Xã Tam Phước, Huyện Phú Ninh, Tỉnh Quảng Nam","path_with_type":"Xã Tam Phước, Huyện Phú Ninh, Tỉnh Quảng Nam","code":"20380","parent_code":"518"},"20386":{"name":"Xã Tam Thái","type":"xa","slug":"xa-tam-thai","name_with_type":"Xã Tam Thái","path":"Xã Tam Thái, Huyện Phú Ninh, Tỉnh Quảng Nam","path_with_type":"Xã Tam Thái, Huyện Phú Ninh, Tỉnh Quảng Nam","code":"20386","parent_code":"518"},"20387":{"name":"Xã Tam Đại","type":"xa","slug":"xa-tam-dai","name_with_type":"Xã Tam Đại","path":"Xã Tam Đại, Huyện Phú Ninh, Tỉnh Quảng Nam","path_with_type":"Xã Tam Đại, Huyện Phú Ninh, Tỉnh Quảng Nam","code":"20387","parent_code":"518"},"20389":{"name":"Xã Tam Ngọc","type":"xa","slug":"xa-tam-ngoc","name_with_type":"Xã Tam Ngọc","path":"Xã Tam Ngọc, Thành phố Tam Kỳ, Tỉnh Quảng Nam","path_with_type":"Xã Tam Ngọc, Thành phố Tam Kỳ, Tỉnh Quảng Nam","code":"20389","parent_code":"502"},"20392":{"name":"Xã Tam Dân","type":"xa","slug":"xa-tam-dan","name_with_type":"Xã Tam Dân","path":"Xã Tam Dân, Huyện Phú Ninh, Tỉnh Quảng Nam","path_with_type":"Xã Tam Dân, Huyện Phú Ninh, Tỉnh Quảng Nam","code":"20392","parent_code":"518"},"20395":{"name":"Xã Tam Lãnh","type":"xa","slug":"xa-tam-lanh","name_with_type":"Xã Tam Lãnh","path":"Xã Tam Lãnh, Huyện Phú Ninh, Tỉnh Quảng Nam","path_with_type":"Xã Tam Lãnh, Huyện Phú Ninh, Tỉnh Quảng Nam","code":"20395","parent_code":"518"},"20398":{"name":"Phường Minh An","type":"phuong","slug":"phuong-minh-an","name_with_type":"Phường Minh An","path":"Phường Minh An, Thành phố Hội An, Tỉnh Quảng Nam","path_with_type":"Phường Minh An, Thành phố Hội An, Tỉnh Quảng Nam","code":"20398","parent_code":"503"},"20401":{"name":"Phường Tân An","type":"phuong","slug":"phuong-tan-an","name_with_type":"Phường Tân An","path":"Phường Tân An, Thành phố Hội An, Tỉnh Quảng Nam","path_with_type":"Phường Tân An, Thành phố Hội An, Tỉnh Quảng Nam","code":"20401","parent_code":"503"},"20404":{"name":"Phường Cẩm Phô","type":"phuong","slug":"phuong-cam-pho","name_with_type":"Phường Cẩm Phô","path":"Phường Cẩm Phô, Thành phố Hội An, Tỉnh Quảng Nam","path_with_type":"Phường Cẩm Phô, Thành phố Hội An, Tỉnh Quảng Nam","code":"20404","parent_code":"503"},"20407":{"name":"Phường Thanh Hà","type":"phuong","slug":"phuong-thanh-ha","name_with_type":"Phường Thanh Hà","path":"Phường Thanh Hà, Thành phố Hội An, Tỉnh Quảng Nam","path_with_type":"Phường Thanh Hà, Thành phố Hội An, Tỉnh Quảng Nam","code":"20407","parent_code":"503"},"20410":{"name":"Phường Sơn Phong","type":"phuong","slug":"phuong-son-phong","name_with_type":"Phường Sơn Phong","path":"Phường Sơn Phong, Thành phố Hội An, Tỉnh Quảng Nam","path_with_type":"Phường Sơn Phong, Thành phố Hội An, Tỉnh Quảng Nam","code":"20410","parent_code":"503"},"20413":{"name":"Phường Cẩm Châu","type":"phuong","slug":"phuong-cam-chau","name_with_type":"Phường Cẩm Châu","path":"Phường Cẩm Châu, Thành phố Hội An, Tỉnh Quảng Nam","path_with_type":"Phường Cẩm Châu, Thành phố Hội An, Tỉnh Quảng Nam","code":"20413","parent_code":"503"},"20416":{"name":"Phường Cửa Đại","type":"phuong","slug":"phuong-cua-dai","name_with_type":"Phường Cửa Đại","path":"Phường Cửa Đại, Thành phố Hội An, Tỉnh Quảng Nam","path_with_type":"Phường Cửa Đại, Thành phố Hội An, Tỉnh Quảng Nam","code":"20416","parent_code":"503"},"20419":{"name":"Phường Cẩm An","type":"phuong","slug":"phuong-cam-an","name_with_type":"Phường Cẩm An","path":"Phường Cẩm An, Thành phố Hội An, Tỉnh Quảng Nam","path_with_type":"Phường Cẩm An, Thành phố Hội An, Tỉnh Quảng Nam","code":"20419","parent_code":"503"},"20422":{"name":"Xã Cẩm Hà","type":"xa","slug":"xa-cam-ha","name_with_type":"Xã Cẩm Hà","path":"Xã Cẩm Hà, Thành phố Hội An, Tỉnh Quảng Nam","path_with_type":"Xã Cẩm Hà, Thành phố Hội An, Tỉnh Quảng Nam","code":"20422","parent_code":"503"},"20425":{"name":"Xã Cẩm Kim","type":"xa","slug":"xa-cam-kim","name_with_type":"Xã Cẩm Kim","path":"Xã Cẩm Kim, Thành phố Hội An, Tỉnh Quảng Nam","path_with_type":"Xã Cẩm Kim, Thành phố Hội An, Tỉnh Quảng Nam","code":"20425","parent_code":"503"},"20428":{"name":"Phường Cẩm Nam","type":"phuong","slug":"phuong-cam-nam","name_with_type":"Phường Cẩm Nam","path":"Phường Cẩm Nam, Thành phố Hội An, Tỉnh Quảng Nam","path_with_type":"Phường Cẩm Nam, Thành phố Hội An, Tỉnh Quảng Nam","code":"20428","parent_code":"503"},"20431":{"name":"Xã Cẩm Thanh","type":"xa","slug":"xa-cam-thanh","name_with_type":"Xã Cẩm Thanh","path":"Xã Cẩm Thanh, Thành phố Hội An, Tỉnh Quảng Nam","path_with_type":"Xã Cẩm Thanh, Thành phố Hội An, Tỉnh Quảng Nam","code":"20431","parent_code":"503"},"20434":{"name":"Xã Tân Hiệp","type":"xa","slug":"xa-tan-hiep","name_with_type":"Xã Tân Hiệp","path":"Xã Tân Hiệp, Thành phố Hội An, Tỉnh Quảng Nam","path_with_type":"Xã Tân Hiệp, Thành phố Hội An, Tỉnh Quảng Nam","code":"20434","parent_code":"503"},"20437":{"name":"Xã Ch\'ơm","type":"xa","slug":"xa-ch\'om","name_with_type":"Xã Ch\'ơm","path":"Xã Ch\'ơm, Huyện Tây Giang, Tỉnh Quảng Nam","path_with_type":"Xã Ch\'ơm, Huyện Tây Giang, Tỉnh Quảng Nam","code":"20437","parent_code":"504"},"20440":{"name":"Xã Ga Ri","type":"xa","slug":"xa-ga-ri","name_with_type":"Xã Ga Ri","path":"Xã Ga Ri, Huyện Tây Giang, Tỉnh Quảng Nam","path_with_type":"Xã Ga Ri, Huyện Tây Giang, Tỉnh Quảng Nam","code":"20440","parent_code":"504"},"20443":{"name":"Xã A Xan","type":"xa","slug":"xa-a-xan","name_with_type":"Xã A Xan","path":"Xã A Xan, Huyện Tây Giang, Tỉnh Quảng Nam","path_with_type":"Xã A Xan, Huyện Tây Giang, Tỉnh Quảng Nam","code":"20443","parent_code":"504"},"20446":{"name":"Xã Tr\'Hy","type":"xa","slug":"xa-tr\'hy","name_with_type":"Xã Tr\'Hy","path":"Xã Tr\'Hy, Huyện Tây Giang, Tỉnh Quảng Nam","path_with_type":"Xã Tr\'Hy, Huyện Tây Giang, Tỉnh Quảng Nam","code":"20446","parent_code":"504"},"20449":{"name":"Xã Lăng","type":"xa","slug":"xa-lang","name_with_type":"Xã Lăng","path":"Xã Lăng, Huyện Tây Giang, Tỉnh Quảng Nam","path_with_type":"Xã Lăng, Huyện Tây Giang, Tỉnh Quảng Nam","code":"20449","parent_code":"504"},"20452":{"name":"Xã A Nông","type":"xa","slug":"xa-a-nong","name_with_type":"Xã A Nông","path":"Xã A Nông, Huyện Tây Giang, Tỉnh Quảng Nam","path_with_type":"Xã A Nông, Huyện Tây Giang, Tỉnh Quảng Nam","code":"20452","parent_code":"504"},"20455":{"name":"Xã A Tiêng","type":"xa","slug":"xa-a-tieng","name_with_type":"Xã A Tiêng","path":"Xã A Tiêng, Huyện Tây Giang, Tỉnh Quảng Nam","path_with_type":"Xã A Tiêng, Huyện Tây Giang, Tỉnh Quảng Nam","code":"20455","parent_code":"504"},"20458":{"name":"Xã Bha Lê","type":"xa","slug":"xa-bha-le","name_with_type":"Xã Bha Lê","path":"Xã Bha Lê, Huyện Tây Giang, Tỉnh Quảng Nam","path_with_type":"Xã Bha Lê, Huyện Tây Giang, Tỉnh Quảng Nam","code":"20458","parent_code":"504"},"20461":{"name":"Xã A Vương","type":"xa","slug":"xa-a-vuong","name_with_type":"Xã A Vương","path":"Xã A Vương, Huyện Tây Giang, Tỉnh Quảng Nam","path_with_type":"Xã A Vương, Huyện Tây Giang, Tỉnh Quảng Nam","code":"20461","parent_code":"504"},"20464":{"name":"Xã Dang","type":"xa","slug":"xa-dang","name_with_type":"Xã Dang","path":"Xã Dang, Huyện Tây Giang, Tỉnh Quảng Nam","path_with_type":"Xã Dang, Huyện Tây Giang, Tỉnh Quảng Nam","code":"20464","parent_code":"504"},"20467":{"name":"Thị trấn P Rao","type":"thi-tran","slug":"thi-tran-p-rao","name_with_type":"Thị trấn P Rao","path":"Thị trấn P Rao, Huyện Đông Giang, Tỉnh Quảng Nam","path_with_type":"Thị trấn P Rao, Huyện Đông Giang, Tỉnh Quảng Nam","code":"20467","parent_code":"505"},"20470":{"name":"Xã Tà Lu","type":"xa","slug":"xa-ta-lu","name_with_type":"Xã Tà Lu","path":"Xã Tà Lu, Huyện Đông Giang, Tỉnh Quảng Nam","path_with_type":"Xã Tà Lu, Huyện Đông Giang, Tỉnh Quảng Nam","code":"20470","parent_code":"505"},"20473":{"name":"Xã Sông Kôn","type":"xa","slug":"xa-song-kon","name_with_type":"Xã Sông Kôn","path":"Xã Sông Kôn, Huyện Đông Giang, Tỉnh Quảng Nam","path_with_type":"Xã Sông Kôn, Huyện Đông Giang, Tỉnh Quảng Nam","code":"20473","parent_code":"505"},"20476":{"name":"Xã Jơ Ngây","type":"xa","slug":"xa-jo-ngay","name_with_type":"Xã Jơ Ngây","path":"Xã Jơ Ngây, Huyện Đông Giang, Tỉnh Quảng Nam","path_with_type":"Xã Jơ Ngây, Huyện Đông Giang, Tỉnh Quảng Nam","code":"20476","parent_code":"505"},"20479":{"name":"Xã A Ting","type":"xa","slug":"xa-a-ting","name_with_type":"Xã A Ting","path":"Xã A Ting, Huyện Đông Giang, Tỉnh Quảng Nam","path_with_type":"Xã A Ting, Huyện Đông Giang, Tỉnh Quảng Nam","code":"20479","parent_code":"505"},"20482":{"name":"Xã  Tư","type":"xa","slug":"xa-tu","name_with_type":"Xã  Tư","path":"Xã  Tư, Huyện Đông Giang, Tỉnh Quảng Nam","path_with_type":"Xã  Tư, Huyện Đông Giang, Tỉnh Quảng Nam","code":"20482","parent_code":"505"},"20485":{"name":"Xã Ba","type":"xa","slug":"xa-ba","name_with_type":"Xã Ba","path":"Xã Ba, Huyện Đông Giang, Tỉnh Quảng Nam","path_with_type":"Xã Ba, Huyện Đông Giang, Tỉnh Quảng Nam","code":"20485","parent_code":"505"},"20488":{"name":"Xã A Rooi","type":"xa","slug":"xa-a-rooi","name_with_type":"Xã A Rooi","path":"Xã A Rooi, Huyện Đông Giang, Tỉnh Quảng Nam","path_with_type":"Xã A Rooi, Huyện Đông Giang, Tỉnh Quảng Nam","code":"20488","parent_code":"505"},"20491":{"name":"Xã Za Hung","type":"xa","slug":"xa-za-hung","name_with_type":"Xã Za Hung","path":"Xã Za Hung, Huyện Đông Giang, Tỉnh Quảng Nam","path_with_type":"Xã Za Hung, Huyện Đông Giang, Tỉnh Quảng Nam","code":"20491","parent_code":"505"},"20494":{"name":"Xã Mà Cooi","type":"xa","slug":"xa-ma-cooi","name_with_type":"Xã Mà Cooi","path":"Xã Mà Cooi, Huyện Đông Giang, Tỉnh Quảng Nam","path_with_type":"Xã Mà Cooi, Huyện Đông Giang, Tỉnh Quảng Nam","code":"20494","parent_code":"505"},"20497":{"name":"Xã Ka Dăng","type":"xa","slug":"xa-ka-dang","name_with_type":"Xã Ka Dăng","path":"Xã Ka Dăng, Huyện Đông Giang, Tỉnh Quảng Nam","path_with_type":"Xã Ka Dăng, Huyện Đông Giang, Tỉnh Quảng Nam","code":"20497","parent_code":"505"},"20500":{"name":"Thị Trấn Ái Nghĩa","type":"thi-tran","slug":"thi-tran-ai-nghia","name_with_type":"Thị Trấn Ái Nghĩa","path":"Thị Trấn Ái Nghĩa, Huyện Đại Lộc, Tỉnh Quảng Nam","path_with_type":"Thị Trấn Ái Nghĩa, Huyện Đại Lộc, Tỉnh Quảng Nam","code":"20500","parent_code":"506"},"20503":{"name":"Xã Đại Sơn","type":"xa","slug":"xa-dai-son","name_with_type":"Xã Đại Sơn","path":"Xã Đại Sơn, Huyện Đại Lộc, Tỉnh Quảng Nam","path_with_type":"Xã Đại Sơn, Huyện Đại Lộc, Tỉnh Quảng Nam","code":"20503","parent_code":"506"},"20506":{"name":"Xã Đại Lãnh","type":"xa","slug":"xa-dai-lanh","name_with_type":"Xã Đại Lãnh","path":"Xã Đại Lãnh, Huyện Đại Lộc, Tỉnh Quảng Nam","path_with_type":"Xã Đại Lãnh, Huyện Đại Lộc, Tỉnh Quảng Nam","code":"20506","parent_code":"506"},"20509":{"name":"Xã Đại Hưng","type":"xa","slug":"xa-dai-hung","name_with_type":"Xã Đại Hưng","path":"Xã Đại Hưng, Huyện Đại Lộc, Tỉnh Quảng Nam","path_with_type":"Xã Đại Hưng, Huyện Đại Lộc, Tỉnh Quảng Nam","code":"20509","parent_code":"506"},"20512":{"name":"Xã Đại Hồng","type":"xa","slug":"xa-dai-hong","name_with_type":"Xã Đại Hồng","path":"Xã Đại Hồng, Huyện Đại Lộc, Tỉnh Quảng Nam","path_with_type":"Xã Đại Hồng, Huyện Đại Lộc, Tỉnh Quảng Nam","code":"20512","parent_code":"506"},"20515":{"name":"Xã Đại Đồng","type":"xa","slug":"xa-dai-dong","name_with_type":"Xã Đại Đồng","path":"Xã Đại Đồng, Huyện Đại Lộc, Tỉnh Quảng Nam","path_with_type":"Xã Đại Đồng, Huyện Đại Lộc, Tỉnh Quảng Nam","code":"20515","parent_code":"506"},"20518":{"name":"Xã Đại Quang","type":"xa","slug":"xa-dai-quang","name_with_type":"Xã Đại Quang","path":"Xã Đại Quang, Huyện Đại Lộc, Tỉnh Quảng Nam","path_with_type":"Xã Đại Quang, Huyện Đại Lộc, Tỉnh Quảng Nam","code":"20518","parent_code":"506"},"20521":{"name":"Xã Đại Nghĩa","type":"xa","slug":"xa-dai-nghia","name_with_type":"Xã Đại Nghĩa","path":"Xã Đại Nghĩa, Huyện Đại Lộc, Tỉnh Quảng Nam","path_with_type":"Xã Đại Nghĩa, Huyện Đại Lộc, Tỉnh Quảng Nam","code":"20521","parent_code":"506"},"20524":{"name":"Xã Đại Hiệp","type":"xa","slug":"xa-dai-hiep","name_with_type":"Xã Đại Hiệp","path":"Xã Đại Hiệp, Huyện Đại Lộc, Tỉnh Quảng Nam","path_with_type":"Xã Đại Hiệp, Huyện Đại Lộc, Tỉnh Quảng Nam","code":"20524","parent_code":"506"},"20527":{"name":"Xã Đại Thạnh","type":"xa","slug":"xa-dai-thanh","name_with_type":"Xã Đại Thạnh","path":"Xã Đại Thạnh, Huyện Đại Lộc, Tỉnh Quảng Nam","path_with_type":"Xã Đại Thạnh, Huyện Đại Lộc, Tỉnh Quảng Nam","code":"20527","parent_code":"506"},"20530":{"name":"Xã Đại Chánh","type":"xa","slug":"xa-dai-chanh","name_with_type":"Xã Đại Chánh","path":"Xã Đại Chánh, Huyện Đại Lộc, Tỉnh Quảng Nam","path_with_type":"Xã Đại Chánh, Huyện Đại Lộc, Tỉnh Quảng Nam","code":"20530","parent_code":"506"},"20533":{"name":"Xã Đại Tân","type":"xa","slug":"xa-dai-tan","name_with_type":"Xã Đại Tân","path":"Xã Đại Tân, Huyện Đại Lộc, Tỉnh Quảng Nam","path_with_type":"Xã Đại Tân, Huyện Đại Lộc, Tỉnh Quảng Nam","code":"20533","parent_code":"506"},"20536":{"name":"Xã Đại Phong","type":"xa","slug":"xa-dai-phong","name_with_type":"Xã Đại Phong","path":"Xã Đại Phong, Huyện Đại Lộc, Tỉnh Quảng Nam","path_with_type":"Xã Đại Phong, Huyện Đại Lộc, Tỉnh Quảng Nam","code":"20536","parent_code":"506"},"20539":{"name":"Xã Đại Minh","type":"xa","slug":"xa-dai-minh","name_with_type":"Xã Đại Minh","path":"Xã Đại Minh, Huyện Đại Lộc, Tỉnh Quảng Nam","path_with_type":"Xã Đại Minh, Huyện Đại Lộc, Tỉnh Quảng Nam","code":"20539","parent_code":"506"},"20542":{"name":"Xã Đại Thắng","type":"xa","slug":"xa-dai-thang","name_with_type":"Xã Đại Thắng","path":"Xã Đại Thắng, Huyện Đại Lộc, Tỉnh Quảng Nam","path_with_type":"Xã Đại Thắng, Huyện Đại Lộc, Tỉnh Quảng Nam","code":"20542","parent_code":"506"},"20545":{"name":"Xã Đại Cường","type":"xa","slug":"xa-dai-cuong","name_with_type":"Xã Đại Cường","path":"Xã Đại Cường, Huyện Đại Lộc, Tỉnh Quảng Nam","path_with_type":"Xã Đại Cường, Huyện Đại Lộc, Tỉnh Quảng Nam","code":"20545","parent_code":"506"},"20547":{"name":"Xã Đại An","type":"xa","slug":"xa-dai-an","name_with_type":"Xã Đại An","path":"Xã Đại An, Huyện Đại Lộc, Tỉnh Quảng Nam","path_with_type":"Xã Đại An, Huyện Đại Lộc, Tỉnh Quảng Nam","code":"20547","parent_code":"506"},"20548":{"name":"Xã Đại Hòa","type":"xa","slug":"xa-dai-hoa","name_with_type":"Xã Đại Hòa","path":"Xã Đại Hòa, Huyện Đại Lộc, Tỉnh Quảng Nam","path_with_type":"Xã Đại Hòa, Huyện Đại Lộc, Tỉnh Quảng Nam","code":"20548","parent_code":"506"},"20551":{"name":"Phường Vĩnh Điện","type":"phuong","slug":"phuong-vinh-dien","name_with_type":"Phường Vĩnh Điện","path":"Phường Vĩnh Điện, Thị xã Điện Bàn, Tỉnh Quảng Nam","path_with_type":"Phường Vĩnh Điện, Thị xã Điện Bàn, Tỉnh Quảng Nam","code":"20551","parent_code":"507"},"20554":{"name":"Xã Điện Tiến","type":"xa","slug":"xa-dien-tien","name_with_type":"Xã Điện Tiến","path":"Xã Điện Tiến, Thị xã Điện Bàn, Tỉnh Quảng Nam","path_with_type":"Xã Điện Tiến, Thị xã Điện Bàn, Tỉnh Quảng Nam","code":"20554","parent_code":"507"},"20557":{"name":"Xã Điện Hòa","type":"xa","slug":"xa-dien-hoa","name_with_type":"Xã Điện Hòa","path":"Xã Điện Hòa, Thị xã Điện Bàn, Tỉnh Quảng Nam","path_with_type":"Xã Điện Hòa, Thị xã Điện Bàn, Tỉnh Quảng Nam","code":"20557","parent_code":"507"},"20560":{"name":"Phường Điện Thắng Bắc","type":"phuong","slug":"phuong-dien-thang-bac","name_with_type":"Phường Điện Thắng Bắc","path":"Phường Điện Thắng Bắc, Thị xã Điện Bàn, Tỉnh Quảng Nam","path_with_type":"Phường Điện Thắng Bắc, Thị xã Điện Bàn, Tỉnh Quảng Nam","code":"20560","parent_code":"507"},"20561":{"name":"Phường Điện Thắng Trung","type":"phuong","slug":"phuong-dien-thang-trung","name_with_type":"Phường Điện Thắng Trung","path":"Phường Điện Thắng Trung, Thị xã Điện Bàn, Tỉnh Quảng Nam","path_with_type":"Phường Điện Thắng Trung, Thị xã Điện Bàn, Tỉnh Quảng Nam","code":"20561","parent_code":"507"},"20562":{"name":"Phường Điện Thắng Nam","type":"phuong","slug":"phuong-dien-thang-nam","name_with_type":"Phường Điện Thắng Nam","path":"Phường Điện Thắng Nam, Thị xã Điện Bàn, Tỉnh Quảng Nam","path_with_type":"Phường Điện Thắng Nam, Thị xã Điện Bàn, Tỉnh Quảng Nam","code":"20562","parent_code":"507"},"20563":{"name":"Phường Điện Ngọc","type":"phuong","slug":"phuong-dien-ngoc","name_with_type":"Phường Điện Ngọc","path":"Phường Điện Ngọc, Thị xã Điện Bàn, Tỉnh Quảng Nam","path_with_type":"Phường Điện Ngọc, Thị xã Điện Bàn, Tỉnh Quảng Nam","code":"20563","parent_code":"507"},"20566":{"name":"Xã Điện Hồng","type":"xa","slug":"xa-dien-hong","name_with_type":"Xã Điện Hồng","path":"Xã Điện Hồng, Thị xã Điện Bàn, Tỉnh Quảng Nam","path_with_type":"Xã Điện Hồng, Thị xã Điện Bàn, Tỉnh Quảng Nam","code":"20566","parent_code":"507"},"20569":{"name":"Xã Điện Thọ","type":"xa","slug":"xa-dien-tho","name_with_type":"Xã Điện Thọ","path":"Xã Điện Thọ, Thị xã Điện Bàn, Tỉnh Quảng Nam","path_with_type":"Xã Điện Thọ, Thị xã Điện Bàn, Tỉnh Quảng Nam","code":"20569","parent_code":"507"},"20572":{"name":"Xã Điện Phước","type":"xa","slug":"xa-dien-phuoc","name_with_type":"Xã Điện Phước","path":"Xã Điện Phước, Thị xã Điện Bàn, Tỉnh Quảng Nam","path_with_type":"Xã Điện Phước, Thị xã Điện Bàn, Tỉnh Quảng Nam","code":"20572","parent_code":"507"},"20575":{"name":"Phường Điện An","type":"phuong","slug":"phuong-dien-an","name_with_type":"Phường Điện An","path":"Phường Điện An, Thị xã Điện Bàn, Tỉnh Quảng Nam","path_with_type":"Phường Điện An, Thị xã Điện Bàn, Tỉnh Quảng Nam","code":"20575","parent_code":"507"},"20578":{"name":"Phường Điện Nam Bắc","type":"phuong","slug":"phuong-dien-nam-bac","name_with_type":"Phường Điện Nam Bắc","path":"Phường Điện Nam Bắc, Thị xã Điện Bàn, Tỉnh Quảng Nam","path_with_type":"Phường Điện Nam Bắc, Thị xã Điện Bàn, Tỉnh Quảng Nam","code":"20578","parent_code":"507"},"20579":{"name":"Phường Điện Nam Trung","type":"phuong","slug":"phuong-dien-nam-trung","name_with_type":"Phường Điện Nam Trung","path":"Phường Điện Nam Trung, Thị xã Điện Bàn, Tỉnh Quảng Nam","path_with_type":"Phường Điện Nam Trung, Thị xã Điện Bàn, Tỉnh Quảng Nam","code":"20579","parent_code":"507"},"20580":{"name":"Phường Điện Nam Đông","type":"phuong","slug":"phuong-dien-nam-dong","name_with_type":"Phường Điện Nam Đông","path":"Phường Điện Nam Đông, Thị xã Điện Bàn, Tỉnh Quảng Nam","path_with_type":"Phường Điện Nam Đông, Thị xã Điện Bàn, Tỉnh Quảng Nam","code":"20580","parent_code":"507"},"20581":{"name":"Phường Điện Dương","type":"phuong","slug":"phuong-dien-duong","name_with_type":"Phường Điện Dương","path":"Phường Điện Dương, Thị xã Điện Bàn, Tỉnh Quảng Nam","path_with_type":"Phường Điện Dương, Thị xã Điện Bàn, Tỉnh Quảng Nam","code":"20581","parent_code":"507"},"20584":{"name":"Xã Điện Quang","type":"xa","slug":"xa-dien-quang","name_with_type":"Xã Điện Quang","path":"Xã Điện Quang, Thị xã Điện Bàn, Tỉnh Quảng Nam","path_with_type":"Xã Điện Quang, Thị xã Điện Bàn, Tỉnh Quảng Nam","code":"20584","parent_code":"507"},"20587":{"name":"Xã Điện Trung","type":"xa","slug":"xa-dien-trung","name_with_type":"Xã Điện Trung","path":"Xã Điện Trung, Thị xã Điện Bàn, Tỉnh Quảng Nam","path_with_type":"Xã Điện Trung, Thị xã Điện Bàn, Tỉnh Quảng Nam","code":"20587","parent_code":"507"},"20590":{"name":"Xã Điện Phong","type":"xa","slug":"xa-dien-phong","name_with_type":"Xã Điện Phong","path":"Xã Điện Phong, Thị xã Điện Bàn, Tỉnh Quảng Nam","path_with_type":"Xã Điện Phong, Thị xã Điện Bàn, Tỉnh Quảng Nam","code":"20590","parent_code":"507"},"20593":{"name":"Phường Điện Minh","type":"phuong","slug":"phuong-dien-minh","name_with_type":"Phường Điện Minh","path":"Phường Điện Minh, Thị xã Điện Bàn, Tỉnh Quảng Nam","path_with_type":"Phường Điện Minh, Thị xã Điện Bàn, Tỉnh Quảng Nam","code":"20593","parent_code":"507"},"20596":{"name":"Phường Điện Phương","type":"phuong","slug":"phuong-dien-phuong","name_with_type":"Phường Điện Phương","path":"Phường Điện Phương, Thị xã Điện Bàn, Tỉnh Quảng Nam","path_with_type":"Phường Điện Phương, Thị xã Điện Bàn, Tỉnh Quảng Nam","code":"20596","parent_code":"507"},"20599":{"name":"Thị trấn Nam Phước","type":"thi-tran","slug":"thi-tran-nam-phuoc","name_with_type":"Thị trấn Nam Phước","path":"Thị trấn Nam Phước, Huyện Duy Xuyên, Tỉnh Quảng Nam","path_with_type":"Thị trấn Nam Phước, Huyện Duy Xuyên, Tỉnh Quảng Nam","code":"20599","parent_code":"508"},"20605":{"name":"Xã Duy Phú","type":"xa","slug":"xa-duy-phu","name_with_type":"Xã Duy Phú","path":"Xã Duy Phú, Huyện Duy Xuyên, Tỉnh Quảng Nam","path_with_type":"Xã Duy Phú, Huyện Duy Xuyên, Tỉnh Quảng Nam","code":"20605","parent_code":"508"},"20608":{"name":"Xã Duy Tân","type":"xa","slug":"xa-duy-tan","name_with_type":"Xã Duy Tân","path":"Xã Duy Tân, Huyện Duy Xuyên, Tỉnh Quảng Nam","path_with_type":"Xã Duy Tân, Huyện Duy Xuyên, Tỉnh Quảng Nam","code":"20608","parent_code":"508"},"20611":{"name":"Xã Duy Hòa","type":"xa","slug":"xa-duy-hoa","name_with_type":"Xã Duy Hòa","path":"Xã Duy Hòa, Huyện Duy Xuyên, Tỉnh Quảng Nam","path_with_type":"Xã Duy Hòa, Huyện Duy Xuyên, Tỉnh Quảng Nam","code":"20611","parent_code":"508"},"20614":{"name":"Xã Duy Châu","type":"xa","slug":"xa-duy-chau","name_with_type":"Xã Duy Châu","path":"Xã Duy Châu, Huyện Duy Xuyên, Tỉnh Quảng Nam","path_with_type":"Xã Duy Châu, Huyện Duy Xuyên, Tỉnh Quảng Nam","code":"20614","parent_code":"508"},"20617":{"name":"Xã Duy Trinh","type":"xa","slug":"xa-duy-trinh","name_with_type":"Xã Duy Trinh","path":"Xã Duy Trinh, Huyện Duy Xuyên, Tỉnh Quảng Nam","path_with_type":"Xã Duy Trinh, Huyện Duy Xuyên, Tỉnh Quảng Nam","code":"20617","parent_code":"508"},"20620":{"name":"Xã Duy Sơn","type":"xa","slug":"xa-duy-son","name_with_type":"Xã Duy Sơn","path":"Xã Duy Sơn, Huyện Duy Xuyên, Tỉnh Quảng Nam","path_with_type":"Xã Duy Sơn, Huyện Duy Xuyên, Tỉnh Quảng Nam","code":"20620","parent_code":"508"},"20623":{"name":"Xã Duy Trung","type":"xa","slug":"xa-duy-trung","name_with_type":"Xã Duy Trung","path":"Xã Duy Trung, Huyện Duy Xuyên, Tỉnh Quảng Nam","path_with_type":"Xã Duy Trung, Huyện Duy Xuyên, Tỉnh Quảng Nam","code":"20623","parent_code":"508"},"20626":{"name":"Xã Duy Phước","type":"xa","slug":"xa-duy-phuoc","name_with_type":"Xã Duy Phước","path":"Xã Duy Phước, Huyện Duy Xuyên, Tỉnh Quảng Nam","path_with_type":"Xã Duy Phước, Huyện Duy Xuyên, Tỉnh Quảng Nam","code":"20626","parent_code":"508"},"20629":{"name":"Xã Duy Thành","type":"xa","slug":"xa-duy-thanh","name_with_type":"Xã Duy Thành","path":"Xã Duy Thành, Huyện Duy Xuyên, Tỉnh Quảng Nam","path_with_type":"Xã Duy Thành, Huyện Duy Xuyên, Tỉnh Quảng Nam","code":"20629","parent_code":"508"},"20632":{"name":"Xã Duy Vinh","type":"xa","slug":"xa-duy-vinh","name_with_type":"Xã Duy Vinh","path":"Xã Duy Vinh, Huyện Duy Xuyên, Tỉnh Quảng Nam","path_with_type":"Xã Duy Vinh, Huyện Duy Xuyên, Tỉnh Quảng Nam","code":"20632","parent_code":"508"},"20635":{"name":"Xã Duy Nghĩa","type":"xa","slug":"xa-duy-nghia","name_with_type":"Xã Duy Nghĩa","path":"Xã Duy Nghĩa, Huyện Duy Xuyên, Tỉnh Quảng Nam","path_with_type":"Xã Duy Nghĩa, Huyện Duy Xuyên, Tỉnh Quảng Nam","code":"20635","parent_code":"508"},"20638":{"name":"Xã Duy Hải","type":"xa","slug":"xa-duy-hai","name_with_type":"Xã Duy Hải","path":"Xã Duy Hải, Huyện Duy Xuyên, Tỉnh Quảng Nam","path_with_type":"Xã Duy Hải, Huyện Duy Xuyên, Tỉnh Quảng Nam","code":"20638","parent_code":"508"},"20641":{"name":"Thị trấn Đông Phú","type":"thi-tran","slug":"thi-tran-dong-phu","name_with_type":"Thị trấn Đông Phú","path":"Thị trấn Đông Phú, Huyện Quế Sơn, Tỉnh Quảng Nam","path_with_type":"Thị trấn Đông Phú, Huyện Quế Sơn, Tỉnh Quảng Nam","code":"20641","parent_code":"509"},"20644":{"name":"Xã Quế Xuân 1","type":"xa","slug":"xa-que-xuan-1","name_with_type":"Xã Quế Xuân 1","path":"Xã Quế Xuân 1, Huyện Quế Sơn, Tỉnh Quảng Nam","path_with_type":"Xã Quế Xuân 1, Huyện Quế Sơn, Tỉnh Quảng Nam","code":"20644","parent_code":"509"},"20647":{"name":"Xã Quế Xuân 2","type":"xa","slug":"xa-que-xuan-2","name_with_type":"Xã Quế Xuân 2","path":"Xã Quế Xuân 2, Huyện Quế Sơn, Tỉnh Quảng Nam","path_with_type":"Xã Quế Xuân 2, Huyện Quế Sơn, Tỉnh Quảng Nam","code":"20647","parent_code":"509"},"20650":{"name":"Xã Quế Phú","type":"xa","slug":"xa-que-phu","name_with_type":"Xã Quế Phú","path":"Xã Quế Phú, Huyện Quế Sơn, Tỉnh Quảng Nam","path_with_type":"Xã Quế Phú, Huyện Quế Sơn, Tỉnh Quảng Nam","code":"20650","parent_code":"509"},"20651":{"name":"Thị trấn Hương An","type":"thi-tran","slug":"thi-tran-huong-an","name_with_type":"Thị trấn Hương An","path":"Thị trấn Hương An, Huyện Quế Sơn, Tỉnh Quảng Nam","path_with_type":"Thị trấn Hương An, Huyện Quế Sơn, Tỉnh Quảng Nam","code":"20651","parent_code":"509"},"20656":{"name":"Thị trấn Trung Phước","type":"thi-tran","slug":"thi-tran-trung-phuoc","name_with_type":"Thị trấn Trung Phước","path":"Thị trấn Trung Phước, Huyện Quế Sơn, Tỉnh Quảng Nam","path_with_type":"Thị trấn Trung Phước, Huyện Quế Sơn, Tỉnh Quảng Nam","code":"20656","parent_code":"509"},"20659":{"name":"Xã Quế Hiệp","type":"xa","slug":"xa-que-hiep","name_with_type":"Xã Quế Hiệp","path":"Xã Quế Hiệp, Huyện Quế Sơn, Tỉnh Quảng Nam","path_with_type":"Xã Quế Hiệp, Huyện Quế Sơn, Tỉnh Quảng Nam","code":"20659","parent_code":"509"},"20662":{"name":"Xã Quế Thuận","type":"xa","slug":"xa-que-thuan","name_with_type":"Xã Quế Thuận","path":"Xã Quế Thuận, Huyện Quế Sơn, Tỉnh Quảng Nam","path_with_type":"Xã Quế Thuận, Huyện Quế Sơn, Tỉnh Quảng Nam","code":"20662","parent_code":"509"},"20665":{"name":"Xã Quế Mỹ","type":"xa","slug":"xa-que-my","name_with_type":"Xã Quế Mỹ","path":"Xã Quế Mỹ, Huyện Quế Sơn, Tỉnh Quảng Nam","path_with_type":"Xã Quế Mỹ, Huyện Quế Sơn, Tỉnh Quảng Nam","code":"20665","parent_code":"509"},"20668":{"name":"Xã Ninh Phước","type":"xa","slug":"xa-ninh-phuoc","name_with_type":"Xã Ninh Phước","path":"Xã Ninh Phước, Huyện Quế Sơn, Tỉnh Quảng Nam","path_with_type":"Xã Ninh Phước, Huyện Quế Sơn, Tỉnh Quảng Nam","code":"20668","parent_code":"509"},"20669":{"name":"Xã Phước Ninh","type":"xa","slug":"xa-phuoc-ninh","name_with_type":"Xã Phước Ninh","path":"Xã Phước Ninh, Huyện Quế Sơn, Tỉnh Quảng Nam","path_with_type":"Xã Phước Ninh, Huyện Quế Sơn, Tỉnh Quảng Nam","code":"20669","parent_code":"509"},"20671":{"name":"Xã Quế Lộc","type":"xa","slug":"xa-que-loc","name_with_type":"Xã Quế Lộc","path":"Xã Quế Lộc, Huyện Quế Sơn, Tỉnh Quảng Nam","path_with_type":"Xã Quế Lộc, Huyện Quế Sơn, Tỉnh Quảng Nam","code":"20671","parent_code":"509"},"20674":{"name":"Xã Quế Phước","type":"xa","slug":"xa-que-phuoc","name_with_type":"Xã Quế Phước","path":"Xã Quế Phước, Huyện Quế Sơn, Tỉnh Quảng Nam","path_with_type":"Xã Quế Phước, Huyện Quế Sơn, Tỉnh Quảng Nam","code":"20674","parent_code":"509"},"20677":{"name":"Xã Quế Long","type":"xa","slug":"xa-que-long","name_with_type":"Xã Quế Long","path":"Xã Quế Long, Huyện Quế Sơn, Tỉnh Quảng Nam","path_with_type":"Xã Quế Long, Huyện Quế Sơn, Tỉnh Quảng Nam","code":"20677","parent_code":"509"},"20680":{"name":"Xã Quế Châu","type":"xa","slug":"xa-que-chau","name_with_type":"Xã Quế Châu","path":"Xã Quế Châu, Huyện Quế Sơn, Tỉnh Quảng Nam","path_with_type":"Xã Quế Châu, Huyện Quế Sơn, Tỉnh Quảng Nam","code":"20680","parent_code":"509"},"20683":{"name":"Xã Quế Phong","type":"xa","slug":"xa-que-phong","name_with_type":"Xã Quế Phong","path":"Xã Quế Phong, Huyện Quế Sơn, Tỉnh Quảng Nam","path_with_type":"Xã Quế Phong, Huyện Quế Sơn, Tỉnh Quảng Nam","code":"20683","parent_code":"509"},"20686":{"name":"Xã Quế An","type":"xa","slug":"xa-que-an","name_with_type":"Xã Quế An","path":"Xã Quế An, Huyện Quế Sơn, Tỉnh Quảng Nam","path_with_type":"Xã Quế An, Huyện Quế Sơn, Tỉnh Quảng Nam","code":"20686","parent_code":"509"},"20689":{"name":"Xã Quế Minh","type":"xa","slug":"xa-que-minh","name_with_type":"Xã Quế Minh","path":"Xã Quế Minh, Huyện Quế Sơn, Tỉnh Quảng Nam","path_with_type":"Xã Quế Minh, Huyện Quế Sơn, Tỉnh Quảng Nam","code":"20689","parent_code":"509"},"20692":{"name":"Xã Quế Lâm","type":"xa","slug":"xa-que-lam","name_with_type":"Xã Quế Lâm","path":"Xã Quế Lâm, Huyện Quế Sơn, Tỉnh Quảng Nam","path_with_type":"Xã Quế Lâm, Huyện Quế Sơn, Tỉnh Quảng Nam","code":"20692","parent_code":"509"},"20695":{"name":"Thị trấn Thạnh Mỹ","type":"thi-tran","slug":"thi-tran-thanh-my","name_with_type":"Thị trấn Thạnh Mỹ","path":"Thị trấn Thạnh Mỹ, Huyện Nam Giang, Tỉnh Quảng Nam","path_with_type":"Thị trấn Thạnh Mỹ, Huyện Nam Giang, Tỉnh Quảng Nam","code":"20695","parent_code":"510"},"20698":{"name":"Xã Laêê","type":"xa","slug":"xa-laee","name_with_type":"Xã Laêê","path":"Xã Laêê, Huyện Nam Giang, Tỉnh Quảng Nam","path_with_type":"Xã Laêê, Huyện Nam Giang, Tỉnh Quảng Nam","code":"20698","parent_code":"510"},"20699":{"name":"Xã Chơ Chun","type":"xa","slug":"xa-cho-chun","name_with_type":"Xã Chơ Chun","path":"Xã Chơ Chun, Huyện Nam Giang, Tỉnh Quảng Nam","path_with_type":"Xã Chơ Chun, Huyện Nam Giang, Tỉnh Quảng Nam","code":"20699","parent_code":"510"},"20701":{"name":"Xã Zuôich","type":"xa","slug":"xa-zuoich","name_with_type":"Xã Zuôich","path":"Xã Zuôich, Huyện Nam Giang, Tỉnh Quảng Nam","path_with_type":"Xã Zuôich, Huyện Nam Giang, Tỉnh Quảng Nam","code":"20701","parent_code":"510"},"20702":{"name":"Xã Tà Pơơ","type":"xa","slug":"xa-ta-poo","name_with_type":"Xã Tà Pơơ","path":"Xã Tà Pơơ, Huyện Nam Giang, Tỉnh Quảng Nam","path_with_type":"Xã Tà Pơơ, Huyện Nam Giang, Tỉnh Quảng Nam","code":"20702","parent_code":"510"},"20704":{"name":"Xã La Dêê","type":"xa","slug":"xa-la-dee","name_with_type":"Xã La Dêê","path":"Xã La Dêê, Huyện Nam Giang, Tỉnh Quảng Nam","path_with_type":"Xã La Dêê, Huyện Nam Giang, Tỉnh Quảng Nam","code":"20704","parent_code":"510"},"20705":{"name":"Xã Đắc Tôi","type":"xa","slug":"xa-dac-toi","name_with_type":"Xã Đắc Tôi","path":"Xã Đắc Tôi, Huyện Nam Giang, Tỉnh Quảng Nam","path_with_type":"Xã Đắc Tôi, Huyện Nam Giang, Tỉnh Quảng Nam","code":"20705","parent_code":"510"},"20707":{"name":"Xã Chà Vàl","type":"xa","slug":"xa-cha-val","name_with_type":"Xã Chà Vàl","path":"Xã Chà Vàl, Huyện Nam Giang, Tỉnh Quảng Nam","path_with_type":"Xã Chà Vàl, Huyện Nam Giang, Tỉnh Quảng Nam","code":"20707","parent_code":"510"},"20710":{"name":"Xã Tà Bhinh","type":"xa","slug":"xa-ta-bhinh","name_with_type":"Xã Tà Bhinh","path":"Xã Tà Bhinh, Huyện Nam Giang, Tỉnh Quảng Nam","path_with_type":"Xã Tà Bhinh, Huyện Nam Giang, Tỉnh Quảng Nam","code":"20710","parent_code":"510"},"20713":{"name":"Xã Cà Dy","type":"xa","slug":"xa-ca-dy","name_with_type":"Xã Cà Dy","path":"Xã Cà Dy, Huyện Nam Giang, Tỉnh Quảng Nam","path_with_type":"Xã Cà Dy, Huyện Nam Giang, Tỉnh Quảng Nam","code":"20713","parent_code":"510"},"20716":{"name":"Xã Đắc Pre","type":"xa","slug":"xa-dac-pre","name_with_type":"Xã Đắc Pre","path":"Xã Đắc Pre, Huyện Nam Giang, Tỉnh Quảng Nam","path_with_type":"Xã Đắc Pre, Huyện Nam Giang, Tỉnh Quảng Nam","code":"20716","parent_code":"510"},"20719":{"name":"Xã Đắc Pring","type":"xa","slug":"xa-dac-pring","name_with_type":"Xã Đắc Pring","path":"Xã Đắc Pring, Huyện Nam Giang, Tỉnh Quảng Nam","path_with_type":"Xã Đắc Pring, Huyện Nam Giang, Tỉnh Quảng Nam","code":"20719","parent_code":"510"},"20722":{"name":"Thị trấn Khâm Đức","type":"thi-tran","slug":"thi-tran-kham-duc","name_with_type":"Thị trấn Khâm Đức","path":"Thị trấn Khâm Đức, Huyện Phước Sơn, Tỉnh Quảng Nam","path_with_type":"Thị trấn Khâm Đức, Huyện Phước Sơn, Tỉnh Quảng Nam","code":"20722","parent_code":"511"},"20725":{"name":"Xã Phước Xuân","type":"xa","slug":"xa-phuoc-xuan","name_with_type":"Xã Phước Xuân","path":"Xã Phước Xuân, Huyện Phước Sơn, Tỉnh Quảng Nam","path_with_type":"Xã Phước Xuân, Huyện Phước Sơn, Tỉnh Quảng Nam","code":"20725","parent_code":"511"},"20728":{"name":"Xã Phước Hiệp","type":"xa","slug":"xa-phuoc-hiep","name_with_type":"Xã Phước Hiệp","path":"Xã Phước Hiệp, Huyện Phước Sơn, Tỉnh Quảng Nam","path_with_type":"Xã Phước Hiệp, Huyện Phước Sơn, Tỉnh Quảng Nam","code":"20728","parent_code":"511"},"20729":{"name":"Xã Phước Hoà","type":"xa","slug":"xa-phuoc-hoa","name_with_type":"Xã Phước Hoà","path":"Xã Phước Hoà, Huyện Phước Sơn, Tỉnh Quảng Nam","path_with_type":"Xã Phước Hoà, Huyện Phước Sơn, Tỉnh Quảng Nam","code":"20729","parent_code":"511"},"20731":{"name":"Xã Phước Đức","type":"xa","slug":"xa-phuoc-duc","name_with_type":"Xã Phước Đức","path":"Xã Phước Đức, Huyện Phước Sơn, Tỉnh Quảng Nam","path_with_type":"Xã Phước Đức, Huyện Phước Sơn, Tỉnh Quảng Nam","code":"20731","parent_code":"511"},"20734":{"name":"Xã Phước Năng","type":"xa","slug":"xa-phuoc-nang","name_with_type":"Xã Phước Năng","path":"Xã Phước Năng, Huyện Phước Sơn, Tỉnh Quảng Nam","path_with_type":"Xã Phước Năng, Huyện Phước Sơn, Tỉnh Quảng Nam","code":"20734","parent_code":"511"},"20737":{"name":"Xã Phước Mỹ","type":"xa","slug":"xa-phuoc-my","name_with_type":"Xã Phước Mỹ","path":"Xã Phước Mỹ, Huyện Phước Sơn, Tỉnh Quảng Nam","path_with_type":"Xã Phước Mỹ, Huyện Phước Sơn, Tỉnh Quảng Nam","code":"20737","parent_code":"511"},"20740":{"name":"Xã Phước Chánh","type":"xa","slug":"xa-phuoc-chanh","name_with_type":"Xã Phước Chánh","path":"Xã Phước Chánh, Huyện Phước Sơn, Tỉnh Quảng Nam","path_with_type":"Xã Phước Chánh, Huyện Phước Sơn, Tỉnh Quảng Nam","code":"20740","parent_code":"511"},"20743":{"name":"Xã Phước Công","type":"xa","slug":"xa-phuoc-cong","name_with_type":"Xã Phước Công","path":"Xã Phước Công, Huyện Phước Sơn, Tỉnh Quảng Nam","path_with_type":"Xã Phước Công, Huyện Phước Sơn, Tỉnh Quảng Nam","code":"20743","parent_code":"511"},"20746":{"name":"Xã Phước Kim","type":"xa","slug":"xa-phuoc-kim","name_with_type":"Xã Phước Kim","path":"Xã Phước Kim, Huyện Phước Sơn, Tỉnh Quảng Nam","path_with_type":"Xã Phước Kim, Huyện Phước Sơn, Tỉnh Quảng Nam","code":"20746","parent_code":"511"},"20749":{"name":"Xã Phước Lộc","type":"xa","slug":"xa-phuoc-loc","name_with_type":"Xã Phước Lộc","path":"Xã Phước Lộc, Huyện Phước Sơn, Tỉnh Quảng Nam","path_with_type":"Xã Phước Lộc, Huyện Phước Sơn, Tỉnh Quảng Nam","code":"20749","parent_code":"511"},"20752":{"name":"Xã Phước Thành","type":"xa","slug":"xa-phuoc-thanh","name_with_type":"Xã Phước Thành","path":"Xã Phước Thành, Huyện Phước Sơn, Tỉnh Quảng Nam","path_with_type":"Xã Phước Thành, Huyện Phước Sơn, Tỉnh Quảng Nam","code":"20752","parent_code":"511"},"20758":{"name":"Xã Quế Tân","type":"xa","slug":"xa-que-tan","name_with_type":"Xã Quế Tân","path":"Xã Quế Tân, Huyện Hiệp Đức, Tỉnh Quảng Nam","path_with_type":"Xã Quế Tân, Huyện Hiệp Đức, Tỉnh Quảng Nam","code":"20758","parent_code":"512"},"20764":{"name":"Xã Quế Thọ","type":"xa","slug":"xa-que-tho","name_with_type":"Xã Quế Thọ","path":"Xã Quế Thọ, Huyện Hiệp Đức, Tỉnh Quảng Nam","path_with_type":"Xã Quế Thọ, Huyện Hiệp Đức, Tỉnh Quảng Nam","code":"20764","parent_code":"512"},"20767":{"name":"Xã Bình Lâm","type":"xa","slug":"xa-binh-lam","name_with_type":"Xã Bình Lâm","path":"Xã Bình Lâm, Huyện Hiệp Đức, Tỉnh Quảng Nam","path_with_type":"Xã Bình Lâm, Huyện Hiệp Đức, Tỉnh Quảng Nam","code":"20767","parent_code":"512"},"20770":{"name":"Xã Sông Trà","type":"xa","slug":"xa-song-tra","name_with_type":"Xã Sông Trà","path":"Xã Sông Trà, Huyện Hiệp Đức, Tỉnh Quảng Nam","path_with_type":"Xã Sông Trà, Huyện Hiệp Đức, Tỉnh Quảng Nam","code":"20770","parent_code":"512"},"20773":{"name":"Xã Phước Trà","type":"xa","slug":"xa-phuoc-tra","name_with_type":"Xã Phước Trà","path":"Xã Phước Trà, Huyện Hiệp Đức, Tỉnh Quảng Nam","path_with_type":"Xã Phước Trà, Huyện Hiệp Đức, Tỉnh Quảng Nam","code":"20773","parent_code":"512"},"20776":{"name":"Xã Phước Gia","type":"xa","slug":"xa-phuoc-gia","name_with_type":"Xã Phước Gia","path":"Xã Phước Gia, Huyện Hiệp Đức, Tỉnh Quảng Nam","path_with_type":"Xã Phước Gia, Huyện Hiệp Đức, Tỉnh Quảng Nam","code":"20776","parent_code":"512"},"20779":{"name":"Thị trấn Tân Bình","type":"thi-tran","slug":"thi-tran-tan-binh","name_with_type":"Thị trấn Tân Bình","path":"Thị trấn Tân Bình, Huyện Hiệp Đức, Tỉnh Quảng Nam","path_with_type":"Thị trấn Tân Bình, Huyện Hiệp Đức, Tỉnh Quảng Nam","code":"20779","parent_code":"512"},"20782":{"name":"Xã Quế Lưu","type":"xa","slug":"xa-que-luu","name_with_type":"Xã Quế Lưu","path":"Xã Quế Lưu, Huyện Hiệp Đức, Tỉnh Quảng Nam","path_with_type":"Xã Quế Lưu, Huyện Hiệp Đức, Tỉnh Quảng Nam","code":"20782","parent_code":"512"},"20785":{"name":"Xã Thăng Phước","type":"xa","slug":"xa-thang-phuoc","name_with_type":"Xã Thăng Phước","path":"Xã Thăng Phước, Huyện Hiệp Đức, Tỉnh Quảng Nam","path_with_type":"Xã Thăng Phước, Huyện Hiệp Đức, Tỉnh Quảng Nam","code":"20785","parent_code":"512"},"20788":{"name":"Xã Bình Sơn","type":"xa","slug":"xa-binh-son","name_with_type":"Xã Bình Sơn","path":"Xã Bình Sơn, Huyện Hiệp Đức, Tỉnh Quảng Nam","path_with_type":"Xã Bình Sơn, Huyện Hiệp Đức, Tỉnh Quảng Nam","code":"20788","parent_code":"512"},"20791":{"name":"Thị trấn Hà Lam","type":"thi-tran","slug":"thi-tran-ha-lam","name_with_type":"Thị trấn Hà Lam","path":"Thị trấn Hà Lam, Huyện Thăng Bình, Tỉnh Quảng Nam","path_with_type":"Thị trấn Hà Lam, Huyện Thăng Bình, Tỉnh Quảng Nam","code":"20791","parent_code":"513"},"20794":{"name":"Xã Bình Dương","type":"xa","slug":"xa-binh-duong","name_with_type":"Xã Bình Dương","path":"Xã Bình Dương, Huyện Thăng Bình, Tỉnh Quảng Nam","path_with_type":"Xã Bình Dương, Huyện Thăng Bình, Tỉnh Quảng Nam","code":"20794","parent_code":"513"},"20797":{"name":"Xã Bình Giang","type":"xa","slug":"xa-binh-giang","name_with_type":"Xã Bình Giang","path":"Xã Bình Giang, Huyện Thăng Bình, Tỉnh Quảng Nam","path_with_type":"Xã Bình Giang, Huyện Thăng Bình, Tỉnh Quảng Nam","code":"20797","parent_code":"513"},"20800":{"name":"Xã Bình Nguyên","type":"xa","slug":"xa-binh-nguyen","name_with_type":"Xã Bình Nguyên","path":"Xã Bình Nguyên, Huyện Thăng Bình, Tỉnh Quảng Nam","path_with_type":"Xã Bình Nguyên, Huyện Thăng Bình, Tỉnh Quảng Nam","code":"20800","parent_code":"513"},"20803":{"name":"Xã Bình Phục","type":"xa","slug":"xa-binh-phuc","name_with_type":"Xã Bình Phục","path":"Xã Bình Phục, Huyện Thăng Bình, Tỉnh Quảng Nam","path_with_type":"Xã Bình Phục, Huyện Thăng Bình, Tỉnh Quảng Nam","code":"20803","parent_code":"513"},"20806":{"name":"Xã Bình Triều","type":"xa","slug":"xa-binh-trieu","name_with_type":"Xã Bình Triều","path":"Xã Bình Triều, Huyện Thăng Bình, Tỉnh Quảng Nam","path_with_type":"Xã Bình Triều, Huyện Thăng Bình, Tỉnh Quảng Nam","code":"20806","parent_code":"513"},"20809":{"name":"Xã Bình Đào","type":"xa","slug":"xa-binh-dao","name_with_type":"Xã Bình Đào","path":"Xã Bình Đào, Huyện Thăng Bình, Tỉnh Quảng Nam","path_with_type":"Xã Bình Đào, Huyện Thăng Bình, Tỉnh Quảng Nam","code":"20809","parent_code":"513"},"20812":{"name":"Xã Bình Minh","type":"xa","slug":"xa-binh-minh","name_with_type":"Xã Bình Minh","path":"Xã Bình Minh, Huyện Thăng Bình, Tỉnh Quảng Nam","path_with_type":"Xã Bình Minh, Huyện Thăng Bình, Tỉnh Quảng Nam","code":"20812","parent_code":"513"},"20815":{"name":"Xã Bình Lãnh","type":"xa","slug":"xa-binh-lanh","name_with_type":"Xã Bình Lãnh","path":"Xã Bình Lãnh, Huyện Thăng Bình, Tỉnh Quảng Nam","path_with_type":"Xã Bình Lãnh, Huyện Thăng Bình, Tỉnh Quảng Nam","code":"20815","parent_code":"513"},"20818":{"name":"Xã Bình Trị","type":"xa","slug":"xa-binh-tri","name_with_type":"Xã Bình Trị","path":"Xã Bình Trị, Huyện Thăng Bình, Tỉnh Quảng Nam","path_with_type":"Xã Bình Trị, Huyện Thăng Bình, Tỉnh Quảng Nam","code":"20818","parent_code":"513"},"20821":{"name":"Xã Bình Định","type":"xa","slug":"xa-binh-dinh","name_with_type":"Xã Bình Định","path":"Xã Bình Định, Huyện Thăng Bình, Tỉnh Quảng Nam","path_with_type":"Xã Bình Định, Huyện Thăng Bình, Tỉnh Quảng Nam","code":"20821","parent_code":"513"},"20824":{"name":"Xã Bình Quý","type":"xa","slug":"xa-binh-quy","name_with_type":"Xã Bình Quý","path":"Xã Bình Quý, Huyện Thăng Bình, Tỉnh Quảng Nam","path_with_type":"Xã Bình Quý, Huyện Thăng Bình, Tỉnh Quảng Nam","code":"20824","parent_code":"513"},"20827":{"name":"Xã Bình Phú","type":"xa","slug":"xa-binh-phu","name_with_type":"Xã Bình Phú","path":"Xã Bình Phú, Huyện Thăng Bình, Tỉnh Quảng Nam","path_with_type":"Xã Bình Phú, Huyện Thăng Bình, Tỉnh Quảng Nam","code":"20827","parent_code":"513"},"20833":{"name":"Xã Bình Tú","type":"xa","slug":"xa-binh-tu","name_with_type":"Xã Bình Tú","path":"Xã Bình Tú, Huyện Thăng Bình, Tỉnh Quảng Nam","path_with_type":"Xã Bình Tú, Huyện Thăng Bình, Tỉnh Quảng Nam","code":"20833","parent_code":"513"},"20836":{"name":"Xã Bình Sa","type":"xa","slug":"xa-binh-sa","name_with_type":"Xã Bình Sa","path":"Xã Bình Sa, Huyện Thăng Bình, Tỉnh Quảng Nam","path_with_type":"Xã Bình Sa, Huyện Thăng Bình, Tỉnh Quảng Nam","code":"20836","parent_code":"513"},"20839":{"name":"Xã Bình Hải","type":"xa","slug":"xa-binh-hai","name_with_type":"Xã Bình Hải","path":"Xã Bình Hải, Huyện Thăng Bình, Tỉnh Quảng Nam","path_with_type":"Xã Bình Hải, Huyện Thăng Bình, Tỉnh Quảng Nam","code":"20839","parent_code":"513"},"20842":{"name":"Xã Bình Quế","type":"xa","slug":"xa-binh-que","name_with_type":"Xã Bình Quế","path":"Xã Bình Quế, Huyện Thăng Bình, Tỉnh Quảng Nam","path_with_type":"Xã Bình Quế, Huyện Thăng Bình, Tỉnh Quảng Nam","code":"20842","parent_code":"513"},"20845":{"name":"Xã Bình An","type":"xa","slug":"xa-binh-an","name_with_type":"Xã Bình An","path":"Xã Bình An, Huyện Thăng Bình, Tỉnh Quảng Nam","path_with_type":"Xã Bình An, Huyện Thăng Bình, Tỉnh Quảng Nam","code":"20845","parent_code":"513"},"20848":{"name":"Xã Bình Trung","type":"xa","slug":"xa-binh-trung","name_with_type":"Xã Bình Trung","path":"Xã Bình Trung, Huyện Thăng Bình, Tỉnh Quảng Nam","path_with_type":"Xã Bình Trung, Huyện Thăng Bình, Tỉnh Quảng Nam","code":"20848","parent_code":"513"},"20851":{"name":"Xã Bình Nam","type":"xa","slug":"xa-binh-nam","name_with_type":"Xã Bình Nam","path":"Xã Bình Nam, Huyện Thăng Bình, Tỉnh Quảng Nam","path_with_type":"Xã Bình Nam, Huyện Thăng Bình, Tỉnh Quảng Nam","code":"20851","parent_code":"513"},"20854":{"name":"Thị trấn Tiên Kỳ","type":"thi-tran","slug":"thi-tran-tien-ky","name_with_type":"Thị trấn Tiên Kỳ","path":"Thị trấn Tiên Kỳ, Huyện Tiên Phước, Tỉnh Quảng Nam","path_with_type":"Thị trấn Tiên Kỳ, Huyện Tiên Phước, Tỉnh Quảng Nam","code":"20854","parent_code":"514"},"20857":{"name":"Xã Tiên Sơn","type":"xa","slug":"xa-tien-son","name_with_type":"Xã Tiên Sơn","path":"Xã Tiên Sơn, Huyện Tiên Phước, Tỉnh Quảng Nam","path_with_type":"Xã Tiên Sơn, Huyện Tiên Phước, Tỉnh Quảng Nam","code":"20857","parent_code":"514"},"20860":{"name":"Xã Tiên Hà","type":"xa","slug":"xa-tien-ha","name_with_type":"Xã Tiên Hà","path":"Xã Tiên Hà, Huyện Tiên Phước, Tỉnh Quảng Nam","path_with_type":"Xã Tiên Hà, Huyện Tiên Phước, Tỉnh Quảng Nam","code":"20860","parent_code":"514"},"20866":{"name":"Xã Tiên Châu","type":"xa","slug":"xa-tien-chau","name_with_type":"Xã Tiên Châu","path":"Xã Tiên Châu, Huyện Tiên Phước, Tỉnh Quảng Nam","path_with_type":"Xã Tiên Châu, Huyện Tiên Phước, Tỉnh Quảng Nam","code":"20866","parent_code":"514"},"20869":{"name":"Xã Tiên Lãnh","type":"xa","slug":"xa-tien-lanh","name_with_type":"Xã Tiên Lãnh","path":"Xã Tiên Lãnh, Huyện Tiên Phước, Tỉnh Quảng Nam","path_with_type":"Xã Tiên Lãnh, Huyện Tiên Phước, Tỉnh Quảng Nam","code":"20869","parent_code":"514"},"20872":{"name":"Xã Tiên Ngọc","type":"xa","slug":"xa-tien-ngoc","name_with_type":"Xã Tiên Ngọc","path":"Xã Tiên Ngọc, Huyện Tiên Phước, Tỉnh Quảng Nam","path_with_type":"Xã Tiên Ngọc, Huyện Tiên Phước, Tỉnh Quảng Nam","code":"20872","parent_code":"514"},"20875":{"name":"Xã Tiên Hiệp","type":"xa","slug":"xa-tien-hiep","name_with_type":"Xã Tiên Hiệp","path":"Xã Tiên Hiệp, Huyện Tiên Phước, Tỉnh Quảng Nam","path_with_type":"Xã Tiên Hiệp, Huyện Tiên Phước, Tỉnh Quảng Nam","code":"20875","parent_code":"514"},"20878":{"name":"Xã Tiên Cảnh","type":"xa","slug":"xa-tien-canh","name_with_type":"Xã Tiên Cảnh","path":"Xã Tiên Cảnh, Huyện Tiên Phước, Tỉnh Quảng Nam","path_with_type":"Xã Tiên Cảnh, Huyện Tiên Phước, Tỉnh Quảng Nam","code":"20878","parent_code":"514"},"20881":{"name":"Xã Tiên Mỹ","type":"xa","slug":"xa-tien-my","name_with_type":"Xã Tiên Mỹ","path":"Xã Tiên Mỹ, Huyện Tiên Phước, Tỉnh Quảng Nam","path_with_type":"Xã Tiên Mỹ, Huyện Tiên Phước, Tỉnh Quảng Nam","code":"20881","parent_code":"514"},"20884":{"name":"Xã Tiên Phong","type":"xa","slug":"xa-tien-phong","name_with_type":"Xã Tiên Phong","path":"Xã Tiên Phong, Huyện Tiên Phước, Tỉnh Quảng Nam","path_with_type":"Xã Tiên Phong, Huyện Tiên Phước, Tỉnh Quảng Nam","code":"20884","parent_code":"514"},"20887":{"name":"Xã Tiên Thọ","type":"xa","slug":"xa-tien-tho","name_with_type":"Xã Tiên Thọ","path":"Xã Tiên Thọ, Huyện Tiên Phước, Tỉnh Quảng Nam","path_with_type":"Xã Tiên Thọ, Huyện Tiên Phước, Tỉnh Quảng Nam","code":"20887","parent_code":"514"},"20890":{"name":"Xã Tiên An","type":"xa","slug":"xa-tien-an","name_with_type":"Xã Tiên An","path":"Xã Tiên An, Huyện Tiên Phước, Tỉnh Quảng Nam","path_with_type":"Xã Tiên An, Huyện Tiên Phước, Tỉnh Quảng Nam","code":"20890","parent_code":"514"},"20893":{"name":"Xã Tiên Lộc","type":"xa","slug":"xa-tien-loc","name_with_type":"Xã Tiên Lộc","path":"Xã Tiên Lộc, Huyện Tiên Phước, Tỉnh Quảng Nam","path_with_type":"Xã Tiên Lộc, Huyện Tiên Phước, Tỉnh Quảng Nam","code":"20893","parent_code":"514"},"20896":{"name":"Xã Tiên Lập","type":"xa","slug":"xa-tien-lap","name_with_type":"Xã Tiên Lập","path":"Xã Tiên Lập, Huyện Tiên Phước, Tỉnh Quảng Nam","path_with_type":"Xã Tiên Lập, Huyện Tiên Phước, Tỉnh Quảng Nam","code":"20896","parent_code":"514"},"20899":{"name":"Thị trấn Trà My","type":"thi-tran","slug":"thi-tran-tra-my","name_with_type":"Thị trấn Trà My","path":"Thị trấn Trà My, Huyện Bắc Trà My, Tỉnh Quảng Nam","path_with_type":"Thị trấn Trà My, Huyện Bắc Trà My, Tỉnh Quảng Nam","code":"20899","parent_code":"515"},"20900":{"name":"Xã Trà Sơn","type":"xa","slug":"xa-tra-son","name_with_type":"Xã Trà Sơn","path":"Xã Trà Sơn, Huyện Bắc Trà My, Tỉnh Quảng Nam","path_with_type":"Xã Trà Sơn, Huyện Bắc Trà My, Tỉnh Quảng Nam","code":"20900","parent_code":"515"},"20902":{"name":"Xã Trà Kót","type":"xa","slug":"xa-tra-kot","name_with_type":"Xã Trà Kót","path":"Xã Trà Kót, Huyện Bắc Trà My, Tỉnh Quảng Nam","path_with_type":"Xã Trà Kót, Huyện Bắc Trà My, Tỉnh Quảng Nam","code":"20902","parent_code":"515"},"20905":{"name":"Xã Trà Nú","type":"xa","slug":"xa-tra-nu","name_with_type":"Xã Trà Nú","path":"Xã Trà Nú, Huyện Bắc Trà My, Tỉnh Quảng Nam","path_with_type":"Xã Trà Nú, Huyện Bắc Trà My, Tỉnh Quảng Nam","code":"20905","parent_code":"515"},"20908":{"name":"Xã Trà Đông","type":"xa","slug":"xa-tra-dong","name_with_type":"Xã Trà Đông","path":"Xã Trà Đông, Huyện Bắc Trà My, Tỉnh Quảng Nam","path_with_type":"Xã Trà Đông, Huyện Bắc Trà My, Tỉnh Quảng Nam","code":"20908","parent_code":"515"},"20911":{"name":"Xã Trà Dương","type":"xa","slug":"xa-tra-duong","name_with_type":"Xã Trà Dương","path":"Xã Trà Dương, Huyện Bắc Trà My, Tỉnh Quảng Nam","path_with_type":"Xã Trà Dương, Huyện Bắc Trà My, Tỉnh Quảng Nam","code":"20911","parent_code":"515"},"20914":{"name":"Xã Trà Giang","type":"xa","slug":"xa-tra-giang","name_with_type":"Xã Trà Giang","path":"Xã Trà Giang, Huyện Bắc Trà My, Tỉnh Quảng Nam","path_with_type":"Xã Trà Giang, Huyện Bắc Trà My, Tỉnh Quảng Nam","code":"20914","parent_code":"515"},"20917":{"name":"Xã Trà Bui","type":"xa","slug":"xa-tra-bui","name_with_type":"Xã Trà Bui","path":"Xã Trà Bui, Huyện Bắc Trà My, Tỉnh Quảng Nam","path_with_type":"Xã Trà Bui, Huyện Bắc Trà My, Tỉnh Quảng Nam","code":"20917","parent_code":"515"},"20920":{"name":"Xã Trà Đốc","type":"xa","slug":"xa-tra-doc","name_with_type":"Xã Trà Đốc","path":"Xã Trà Đốc, Huyện Bắc Trà My, Tỉnh Quảng Nam","path_with_type":"Xã Trà Đốc, Huyện Bắc Trà My, Tỉnh Quảng Nam","code":"20920","parent_code":"515"},"20923":{"name":"Xã Trà Tân","type":"xa","slug":"xa-tra-tan","name_with_type":"Xã Trà Tân","path":"Xã Trà Tân, Huyện Bắc Trà My, Tỉnh Quảng Nam","path_with_type":"Xã Trà Tân, Huyện Bắc Trà My, Tỉnh Quảng Nam","code":"20923","parent_code":"515"},"20926":{"name":"Xã Trà Giác","type":"xa","slug":"xa-tra-giac","name_with_type":"Xã Trà Giác","path":"Xã Trà Giác, Huyện Bắc Trà My, Tỉnh Quảng Nam","path_with_type":"Xã Trà Giác, Huyện Bắc Trà My, Tỉnh Quảng Nam","code":"20926","parent_code":"515"},"20929":{"name":"Xã Trà Giáp","type":"xa","slug":"xa-tra-giap","name_with_type":"Xã Trà Giáp","path":"Xã Trà Giáp, Huyện Bắc Trà My, Tỉnh Quảng Nam","path_with_type":"Xã Trà Giáp, Huyện Bắc Trà My, Tỉnh Quảng Nam","code":"20929","parent_code":"515"},"20932":{"name":"Xã Trà Ka","type":"xa","slug":"xa-tra-ka","name_with_type":"Xã Trà Ka","path":"Xã Trà Ka, Huyện Bắc Trà My, Tỉnh Quảng Nam","path_with_type":"Xã Trà Ka, Huyện Bắc Trà My, Tỉnh Quảng Nam","code":"20932","parent_code":"515"},"20935":{"name":"Xã Trà Leng","type":"xa","slug":"xa-tra-leng","name_with_type":"Xã Trà Leng","path":"Xã Trà Leng, Huyện Nam Trà My, Tỉnh Quảng Nam","path_with_type":"Xã Trà Leng, Huyện Nam Trà My, Tỉnh Quảng Nam","code":"20935","parent_code":"516"},"20938":{"name":"Xã Trà Dơn","type":"xa","slug":"xa-tra-don","name_with_type":"Xã Trà Dơn","path":"Xã Trà Dơn, Huyện Nam Trà My, Tỉnh Quảng Nam","path_with_type":"Xã Trà Dơn, Huyện Nam Trà My, Tỉnh Quảng Nam","code":"20938","parent_code":"516"},"20941":{"name":"Xã Trà Tập","type":"xa","slug":"xa-tra-tap","name_with_type":"Xã Trà Tập","path":"Xã Trà Tập, Huyện Nam Trà My, Tỉnh Quảng Nam","path_with_type":"Xã Trà Tập, Huyện Nam Trà My, Tỉnh Quảng Nam","code":"20941","parent_code":"516"},"20944":{"name":"Xã Trà Mai","type":"xa","slug":"xa-tra-mai","name_with_type":"Xã Trà Mai","path":"Xã Trà Mai, Huyện Nam Trà My, Tỉnh Quảng Nam","path_with_type":"Xã Trà Mai, Huyện Nam Trà My, Tỉnh Quảng Nam","code":"20944","parent_code":"516"},"20947":{"name":"Xã Trà Cang","type":"xa","slug":"xa-tra-cang","name_with_type":"Xã Trà Cang","path":"Xã Trà Cang, Huyện Nam Trà My, Tỉnh Quảng Nam","path_with_type":"Xã Trà Cang, Huyện Nam Trà My, Tỉnh Quảng Nam","code":"20947","parent_code":"516"},"20950":{"name":"Xã Trà Linh","type":"xa","slug":"xa-tra-linh","name_with_type":"Xã Trà Linh","path":"Xã Trà Linh, Huyện Nam Trà My, Tỉnh Quảng Nam","path_with_type":"Xã Trà Linh, Huyện Nam Trà My, Tỉnh Quảng Nam","code":"20950","parent_code":"516"},"20953":{"name":"Xã Trà Nam","type":"xa","slug":"xa-tra-nam","name_with_type":"Xã Trà Nam","path":"Xã Trà Nam, Huyện Nam Trà My, Tỉnh Quảng Nam","path_with_type":"Xã Trà Nam, Huyện Nam Trà My, Tỉnh Quảng Nam","code":"20953","parent_code":"516"},"20956":{"name":"Xã Trà Don","type":"xa","slug":"xa-tra-don","name_with_type":"Xã Trà Don","path":"Xã Trà Don, Huyện Nam Trà My, Tỉnh Quảng Nam","path_with_type":"Xã Trà Don, Huyện Nam Trà My, Tỉnh Quảng Nam","code":"20956","parent_code":"516"},"20959":{"name":"Xã Trà Vân","type":"xa","slug":"xa-tra-van","name_with_type":"Xã Trà Vân","path":"Xã Trà Vân, Huyện Nam Trà My, Tỉnh Quảng Nam","path_with_type":"Xã Trà Vân, Huyện Nam Trà My, Tỉnh Quảng Nam","code":"20959","parent_code":"516"},"20962":{"name":"Xã Trà Vinh","type":"xa","slug":"xa-tra-vinh","name_with_type":"Xã Trà Vinh","path":"Xã Trà Vinh, Huyện Nam Trà My, Tỉnh Quảng Nam","path_with_type":"Xã Trà Vinh, Huyện Nam Trà My, Tỉnh Quảng Nam","code":"20962","parent_code":"516"},"20965":{"name":"Thị trấn Núi Thành","type":"thi-tran","slug":"thi-tran-nui-thanh","name_with_type":"Thị trấn Núi Thành","path":"Thị trấn Núi Thành, Huyện Núi Thành, Tỉnh Quảng Nam","path_with_type":"Thị trấn Núi Thành, Huyện Núi Thành, Tỉnh Quảng Nam","code":"20965","parent_code":"517"},"20968":{"name":"Xã Tam Xuân I","type":"xa","slug":"xa-tam-xuan-i","name_with_type":"Xã Tam Xuân I","path":"Xã Tam Xuân I, Huyện Núi Thành, Tỉnh Quảng Nam","path_with_type":"Xã Tam Xuân I, Huyện Núi Thành, Tỉnh Quảng Nam","code":"20968","parent_code":"517"},"20971":{"name":"Xã Tam Xuân II","type":"xa","slug":"xa-tam-xuan-ii","name_with_type":"Xã Tam Xuân II","path":"Xã Tam Xuân II, Huyện Núi Thành, Tỉnh Quảng Nam","path_with_type":"Xã Tam Xuân II, Huyện Núi Thành, Tỉnh Quảng Nam","code":"20971","parent_code":"517"},"20974":{"name":"Xã Tam Tiến","type":"xa","slug":"xa-tam-tien","name_with_type":"Xã Tam Tiến","path":"Xã Tam Tiến, Huyện Núi Thành, Tỉnh Quảng Nam","path_with_type":"Xã Tam Tiến, Huyện Núi Thành, Tỉnh Quảng Nam","code":"20974","parent_code":"517"},"20977":{"name":"Xã Tam Sơn","type":"xa","slug":"xa-tam-son","name_with_type":"Xã Tam Sơn","path":"Xã Tam Sơn, Huyện Núi Thành, Tỉnh Quảng Nam","path_with_type":"Xã Tam Sơn, Huyện Núi Thành, Tỉnh Quảng Nam","code":"20977","parent_code":"517"},"20980":{"name":"Xã Tam Thạnh","type":"xa","slug":"xa-tam-thanh","name_with_type":"Xã Tam Thạnh","path":"Xã Tam Thạnh, Huyện Núi Thành, Tỉnh Quảng Nam","path_with_type":"Xã Tam Thạnh, Huyện Núi Thành, Tỉnh Quảng Nam","code":"20980","parent_code":"517"},"20983":{"name":"Xã Tam Anh Bắc","type":"xa","slug":"xa-tam-anh-bac","name_with_type":"Xã Tam Anh Bắc","path":"Xã Tam Anh Bắc, Huyện Núi Thành, Tỉnh Quảng Nam","path_with_type":"Xã Tam Anh Bắc, Huyện Núi Thành, Tỉnh Quảng Nam","code":"20983","parent_code":"517"},"20984":{"name":"Xã Tam Anh Nam","type":"xa","slug":"xa-tam-anh-nam","name_with_type":"Xã Tam Anh Nam","path":"Xã Tam Anh Nam, Huyện Núi Thành, Tỉnh Quảng Nam","path_with_type":"Xã Tam Anh Nam, Huyện Núi Thành, Tỉnh Quảng Nam","code":"20984","parent_code":"517"},"20986":{"name":"Xã Tam Hòa","type":"xa","slug":"xa-tam-hoa","name_with_type":"Xã Tam Hòa","path":"Xã Tam Hòa, Huyện Núi Thành, Tỉnh Quảng Nam","path_with_type":"Xã Tam Hòa, Huyện Núi Thành, Tỉnh Quảng Nam","code":"20986","parent_code":"517"},"20989":{"name":"Xã Tam Hiệp","type":"xa","slug":"xa-tam-hiep","name_with_type":"Xã Tam Hiệp","path":"Xã Tam Hiệp, Huyện Núi Thành, Tỉnh Quảng Nam","path_with_type":"Xã Tam Hiệp, Huyện Núi Thành, Tỉnh Quảng Nam","code":"20989","parent_code":"517"},"20992":{"name":"Xã Tam Hải","type":"xa","slug":"xa-tam-hai","name_with_type":"Xã Tam Hải","path":"Xã Tam Hải, Huyện Núi Thành, Tỉnh Quảng Nam","path_with_type":"Xã Tam Hải, Huyện Núi Thành, Tỉnh Quảng Nam","code":"20992","parent_code":"517"},"20995":{"name":"Xã Tam Giang","type":"xa","slug":"xa-tam-giang","name_with_type":"Xã Tam Giang","path":"Xã Tam Giang, Huyện Núi Thành, Tỉnh Quảng Nam","path_with_type":"Xã Tam Giang, Huyện Núi Thành, Tỉnh Quảng Nam","code":"20995","parent_code":"517"},"20998":{"name":"Xã Tam Quang","type":"xa","slug":"xa-tam-quang","name_with_type":"Xã Tam Quang","path":"Xã Tam Quang, Huyện Núi Thành, Tỉnh Quảng Nam","path_with_type":"Xã Tam Quang, Huyện Núi Thành, Tỉnh Quảng Nam","code":"20998","parent_code":"517"},"21001":{"name":"Xã Tam Nghĩa","type":"xa","slug":"xa-tam-nghia","name_with_type":"Xã Tam Nghĩa","path":"Xã Tam Nghĩa, Huyện Núi Thành, Tỉnh Quảng Nam","path_with_type":"Xã Tam Nghĩa, Huyện Núi Thành, Tỉnh Quảng Nam","code":"21001","parent_code":"517"},"21004":{"name":"Xã Tam Mỹ Tây","type":"xa","slug":"xa-tam-my-tay","name_with_type":"Xã Tam Mỹ Tây","path":"Xã Tam Mỹ Tây, Huyện Núi Thành, Tỉnh Quảng Nam","path_with_type":"Xã Tam Mỹ Tây, Huyện Núi Thành, Tỉnh Quảng Nam","code":"21004","parent_code":"517"},"21005":{"name":"Xã Tam Mỹ Đông","type":"xa","slug":"xa-tam-my-dong","name_with_type":"Xã Tam Mỹ Đông","path":"Xã Tam Mỹ Đông, Huyện Núi Thành, Tỉnh Quảng Nam","path_with_type":"Xã Tam Mỹ Đông, Huyện Núi Thành, Tỉnh Quảng Nam","code":"21005","parent_code":"517"},"21007":{"name":"Xã Tam Trà","type":"xa","slug":"xa-tam-tra","name_with_type":"Xã Tam Trà","path":"Xã Tam Trà, Huyện Núi Thành, Tỉnh Quảng Nam","path_with_type":"Xã Tam Trà, Huyện Núi Thành, Tỉnh Quảng Nam","code":"21007","parent_code":"517"},"21010":{"name":"Phường Lê Hồng Phong","type":"phuong","slug":"phuong-le-hong-phong","name_with_type":"Phường Lê Hồng Phong","path":"Phường Lê Hồng Phong, Thành phố Quảng Ngãi, Tỉnh Quảng Ngãi","path_with_type":"Phường Lê Hồng Phong, Thành phố Quảng Ngãi, Tỉnh Quảng Ngãi","code":"21010","parent_code":"522"},"21013":{"name":"Phường Trần Phú","type":"phuong","slug":"phuong-tran-phu","name_with_type":"Phường Trần Phú","path":"Phường Trần Phú, Thành phố Quảng Ngãi, Tỉnh Quảng Ngãi","path_with_type":"Phường Trần Phú, Thành phố Quảng Ngãi, Tỉnh Quảng Ngãi","code":"21013","parent_code":"522"},"21016":{"name":"Phường Quảng Phú","type":"phuong","slug":"phuong-quang-phu","name_with_type":"Phường Quảng Phú","path":"Phường Quảng Phú, Thành phố Quảng Ngãi, Tỉnh Quảng Ngãi","path_with_type":"Phường Quảng Phú, Thành phố Quảng Ngãi, Tỉnh Quảng Ngãi","code":"21016","parent_code":"522"},"21019":{"name":"Phường Nghĩa Chánh","type":"phuong","slug":"phuong-nghia-chanh","name_with_type":"Phường Nghĩa Chánh","path":"Phường Nghĩa Chánh, Thành phố Quảng Ngãi, Tỉnh Quảng Ngãi","path_with_type":"Phường Nghĩa Chánh, Thành phố Quảng Ngãi, Tỉnh Quảng Ngãi","code":"21019","parent_code":"522"},"21022":{"name":"Phường Trần Hưng Đạo","type":"phuong","slug":"phuong-tran-hung-dao","name_with_type":"Phường Trần Hưng Đạo","path":"Phường Trần Hưng Đạo, Thành phố Quảng Ngãi, Tỉnh Quảng Ngãi","path_with_type":"Phường Trần Hưng Đạo, Thành phố Quảng Ngãi, Tỉnh Quảng Ngãi","code":"21022","parent_code":"522"},"21025":{"name":"Phường Nguyễn Nghiêm","type":"phuong","slug":"phuong-nguyen-nghiem","name_with_type":"Phường Nguyễn Nghiêm","path":"Phường Nguyễn Nghiêm, Thành phố Quảng Ngãi, Tỉnh Quảng Ngãi","path_with_type":"Phường Nguyễn Nghiêm, Thành phố Quảng Ngãi, Tỉnh Quảng Ngãi","code":"21025","parent_code":"522"},"21028":{"name":"Phường Nghĩa Lộ","type":"phuong","slug":"phuong-nghia-lo","name_with_type":"Phường Nghĩa Lộ","path":"Phường Nghĩa Lộ, Thành phố Quảng Ngãi, Tỉnh Quảng Ngãi","path_with_type":"Phường Nghĩa Lộ, Thành phố Quảng Ngãi, Tỉnh Quảng Ngãi","code":"21028","parent_code":"522"},"21031":{"name":"Phường Chánh Lộ","type":"phuong","slug":"phuong-chanh-lo","name_with_type":"Phường Chánh Lộ","path":"Phường Chánh Lộ, Thành phố Quảng Ngãi, Tỉnh Quảng Ngãi","path_with_type":"Phường Chánh Lộ, Thành phố Quảng Ngãi, Tỉnh Quảng Ngãi","code":"21031","parent_code":"522"},"21034":{"name":"Xã Nghĩa Dũng","type":"xa","slug":"xa-nghia-dung","name_with_type":"Xã Nghĩa Dũng","path":"Xã Nghĩa Dũng, Thành phố Quảng Ngãi, Tỉnh Quảng Ngãi","path_with_type":"Xã Nghĩa Dũng, Thành phố Quảng Ngãi, Tỉnh Quảng Ngãi","code":"21034","parent_code":"522"},"21037":{"name":"Xã Nghĩa Dõng","type":"xa","slug":"xa-nghia-dong","name_with_type":"Xã Nghĩa Dõng","path":"Xã Nghĩa Dõng, Thành phố Quảng Ngãi, Tỉnh Quảng Ngãi","path_with_type":"Xã Nghĩa Dõng, Thành phố Quảng Ngãi, Tỉnh Quảng Ngãi","code":"21037","parent_code":"522"},"21040":{"name":"Thị Trấn Châu Ổ","type":"thi-tran","slug":"thi-tran-chau-o","name_with_type":"Thị Trấn Châu Ổ","path":"Thị Trấn Châu Ổ, Huyện Bình Sơn, Tỉnh Quảng Ngãi","path_with_type":"Thị Trấn Châu Ổ, Huyện Bình Sơn, Tỉnh Quảng Ngãi","code":"21040","parent_code":"524"},"21043":{"name":"Xã Bình Thuận","type":"xa","slug":"xa-binh-thuan","name_with_type":"Xã Bình Thuận","path":"Xã Bình Thuận, Huyện Bình Sơn, Tỉnh Quảng Ngãi","path_with_type":"Xã Bình Thuận, Huyện Bình Sơn, Tỉnh Quảng Ngãi","code":"21043","parent_code":"524"},"21046":{"name":"Xã Bình Thạnh","type":"xa","slug":"xa-binh-thanh","name_with_type":"Xã Bình Thạnh","path":"Xã Bình Thạnh, Huyện Bình Sơn, Tỉnh Quảng Ngãi","path_with_type":"Xã Bình Thạnh, Huyện Bình Sơn, Tỉnh Quảng Ngãi","code":"21046","parent_code":"524"},"21049":{"name":"Xã Bình Đông","type":"xa","slug":"xa-binh-dong","name_with_type":"Xã Bình Đông","path":"Xã Bình Đông, Huyện Bình Sơn, Tỉnh Quảng Ngãi","path_with_type":"Xã Bình Đông, Huyện Bình Sơn, Tỉnh Quảng Ngãi","code":"21049","parent_code":"524"},"21052":{"name":"Xã Bình Chánh","type":"xa","slug":"xa-binh-chanh","name_with_type":"Xã Bình Chánh","path":"Xã Bình Chánh, Huyện Bình Sơn, Tỉnh Quảng Ngãi","path_with_type":"Xã Bình Chánh, Huyện Bình Sơn, Tỉnh Quảng Ngãi","code":"21052","parent_code":"524"},"21055":{"name":"Xã Bình Nguyên","type":"xa","slug":"xa-binh-nguyen","name_with_type":"Xã Bình Nguyên","path":"Xã Bình Nguyên, Huyện Bình Sơn, Tỉnh Quảng Ngãi","path_with_type":"Xã Bình Nguyên, Huyện Bình Sơn, Tỉnh Quảng Ngãi","code":"21055","parent_code":"524"},"21058":{"name":"Xã Bình Khương","type":"xa","slug":"xa-binh-khuong","name_with_type":"Xã Bình Khương","path":"Xã Bình Khương, Huyện Bình Sơn, Tỉnh Quảng Ngãi","path_with_type":"Xã Bình Khương, Huyện Bình Sơn, Tỉnh Quảng Ngãi","code":"21058","parent_code":"524"},"21061":{"name":"Xã Bình Trị","type":"xa","slug":"xa-binh-tri","name_with_type":"Xã Bình Trị","path":"Xã Bình Trị, Huyện Bình Sơn, Tỉnh Quảng Ngãi","path_with_type":"Xã Bình Trị, Huyện Bình Sơn, Tỉnh Quảng Ngãi","code":"21061","parent_code":"524"},"21064":{"name":"Xã Bình An","type":"xa","slug":"xa-binh-an","name_with_type":"Xã Bình An","path":"Xã Bình An, Huyện Bình Sơn, Tỉnh Quảng Ngãi","path_with_type":"Xã Bình An, Huyện Bình Sơn, Tỉnh Quảng Ngãi","code":"21064","parent_code":"524"},"21067":{"name":"Xã Bình Hải","type":"xa","slug":"xa-binh-hai","name_with_type":"Xã Bình Hải","path":"Xã Bình Hải, Huyện Bình Sơn, Tỉnh Quảng Ngãi","path_with_type":"Xã Bình Hải, Huyện Bình Sơn, Tỉnh Quảng Ngãi","code":"21067","parent_code":"524"},"21070":{"name":"Xã Bình Dương","type":"xa","slug":"xa-binh-duong","name_with_type":"Xã Bình Dương","path":"Xã Bình Dương, Huyện Bình Sơn, Tỉnh Quảng Ngãi","path_with_type":"Xã Bình Dương, Huyện Bình Sơn, Tỉnh Quảng Ngãi","code":"21070","parent_code":"524"},"21073":{"name":"Xã Bình Phước","type":"xa","slug":"xa-binh-phuoc","name_with_type":"Xã Bình Phước","path":"Xã Bình Phước, Huyện Bình Sơn, Tỉnh Quảng Ngãi","path_with_type":"Xã Bình Phước, Huyện Bình Sơn, Tỉnh Quảng Ngãi","code":"21073","parent_code":"524"},"21079":{"name":"Xã Bình Hòa","type":"xa","slug":"xa-binh-hoa","name_with_type":"Xã Bình Hòa","path":"Xã Bình Hòa, Huyện Bình Sơn, Tỉnh Quảng Ngãi","path_with_type":"Xã Bình Hòa, Huyện Bình Sơn, Tỉnh Quảng Ngãi","code":"21079","parent_code":"524"},"21082":{"name":"Xã Bình Trung","type":"xa","slug":"xa-binh-trung","name_with_type":"Xã Bình Trung","path":"Xã Bình Trung, Huyện Bình Sơn, Tỉnh Quảng Ngãi","path_with_type":"Xã Bình Trung, Huyện Bình Sơn, Tỉnh Quảng Ngãi","code":"21082","parent_code":"524"},"21085":{"name":"Xã Bình Minh","type":"xa","slug":"xa-binh-minh","name_with_type":"Xã Bình Minh","path":"Xã Bình Minh, Huyện Bình Sơn, Tỉnh Quảng Ngãi","path_with_type":"Xã Bình Minh, Huyện Bình Sơn, Tỉnh Quảng Ngãi","code":"21085","parent_code":"524"},"21088":{"name":"Xã Bình Long","type":"xa","slug":"xa-binh-long","name_with_type":"Xã Bình Long","path":"Xã Bình Long, Huyện Bình Sơn, Tỉnh Quảng Ngãi","path_with_type":"Xã Bình Long, Huyện Bình Sơn, Tỉnh Quảng Ngãi","code":"21088","parent_code":"524"},"21091":{"name":"Xã Bình Thanh ","type":"xa","slug":"xa-binh-thanh-","name_with_type":"Xã Bình Thanh ","path":"Xã Bình Thanh , Huyện Bình Sơn, Tỉnh Quảng Ngãi","path_with_type":"Xã Bình Thanh , Huyện Bình Sơn, Tỉnh Quảng Ngãi","code":"21091","parent_code":"524"},"21100":{"name":"Xã Bình Chương","type":"xa","slug":"xa-binh-chuong","name_with_type":"Xã Bình Chương","path":"Xã Bình Chương, Huyện Bình Sơn, Tỉnh Quảng Ngãi","path_with_type":"Xã Bình Chương, Huyện Bình Sơn, Tỉnh Quảng Ngãi","code":"21100","parent_code":"524"},"21103":{"name":"Xã Bình Hiệp","type":"xa","slug":"xa-binh-hiep","name_with_type":"Xã Bình Hiệp","path":"Xã Bình Hiệp, Huyện Bình Sơn, Tỉnh Quảng Ngãi","path_with_type":"Xã Bình Hiệp, Huyện Bình Sơn, Tỉnh Quảng Ngãi","code":"21103","parent_code":"524"},"21106":{"name":"Xã Bình Mỹ","type":"xa","slug":"xa-binh-my","name_with_type":"Xã Bình Mỹ","path":"Xã Bình Mỹ, Huyện Bình Sơn, Tỉnh Quảng Ngãi","path_with_type":"Xã Bình Mỹ, Huyện Bình Sơn, Tỉnh Quảng Ngãi","code":"21106","parent_code":"524"},"21109":{"name":"Xã Bình Tân Phú","type":"xa","slug":"xa-binh-tan-phu","name_with_type":"Xã Bình Tân Phú","path":"Xã Bình Tân Phú, Huyện Bình Sơn, Tỉnh Quảng Ngãi","path_with_type":"Xã Bình Tân Phú, Huyện Bình Sơn, Tỉnh Quảng Ngãi","code":"21109","parent_code":"524"},"21112":{"name":"Xã Bình Châu","type":"xa","slug":"xa-binh-chau","name_with_type":"Xã Bình Châu","path":"Xã Bình Châu, Huyện Bình Sơn, Tỉnh Quảng Ngãi","path_with_type":"Xã Bình Châu, Huyện Bình Sơn, Tỉnh Quảng Ngãi","code":"21112","parent_code":"524"},"21115":{"name":"Thị trấn Trà Xuân","type":"thi-tran","slug":"thi-tran-tra-xuan","name_with_type":"Thị trấn Trà Xuân","path":"Thị trấn Trà Xuân, Huyện Trà Bồng, Tỉnh Quảng Ngãi","path_with_type":"Thị trấn Trà Xuân, Huyện Trà Bồng, Tỉnh Quảng Ngãi","code":"21115","parent_code":"525"},"21118":{"name":"Xã Trà Giang","type":"xa","slug":"xa-tra-giang","name_with_type":"Xã Trà Giang","path":"Xã Trà Giang, Huyện Trà Bồng, Tỉnh Quảng Ngãi","path_with_type":"Xã Trà Giang, Huyện Trà Bồng, Tỉnh Quảng Ngãi","code":"21118","parent_code":"525"},"21121":{"name":"Xã Trà Thủy","type":"xa","slug":"xa-tra-thuy","name_with_type":"Xã Trà Thủy","path":"Xã Trà Thủy, Huyện Trà Bồng, Tỉnh Quảng Ngãi","path_with_type":"Xã Trà Thủy, Huyện Trà Bồng, Tỉnh Quảng Ngãi","code":"21121","parent_code":"525"},"21124":{"name":"Xã Trà Hiệp","type":"xa","slug":"xa-tra-hiep","name_with_type":"Xã Trà Hiệp","path":"Xã Trà Hiệp, Huyện Trà Bồng, Tỉnh Quảng Ngãi","path_with_type":"Xã Trà Hiệp, Huyện Trà Bồng, Tỉnh Quảng Ngãi","code":"21124","parent_code":"525"},"21127":{"name":"Xã Trà Bình","type":"xa","slug":"xa-tra-binh","name_with_type":"Xã Trà Bình","path":"Xã Trà Bình, Huyện Trà Bồng, Tỉnh Quảng Ngãi","path_with_type":"Xã Trà Bình, Huyện Trà Bồng, Tỉnh Quảng Ngãi","code":"21127","parent_code":"525"},"21130":{"name":"Xã Trà Phú","type":"xa","slug":"xa-tra-phu","name_with_type":"Xã Trà Phú","path":"Xã Trà Phú, Huyện Trà Bồng, Tỉnh Quảng Ngãi","path_with_type":"Xã Trà Phú, Huyện Trà Bồng, Tỉnh Quảng Ngãi","code":"21130","parent_code":"525"},"21133":{"name":"Xã Trà Lâm","type":"xa","slug":"xa-tra-lam","name_with_type":"Xã Trà Lâm","path":"Xã Trà Lâm, Huyện Trà Bồng, Tỉnh Quảng Ngãi","path_with_type":"Xã Trà Lâm, Huyện Trà Bồng, Tỉnh Quảng Ngãi","code":"21133","parent_code":"525"},"21136":{"name":"Xã Trà Tân","type":"xa","slug":"xa-tra-tan","name_with_type":"Xã Trà Tân","path":"Xã Trà Tân, Huyện Trà Bồng, Tỉnh Quảng Ngãi","path_with_type":"Xã Trà Tân, Huyện Trà Bồng, Tỉnh Quảng Ngãi","code":"21136","parent_code":"525"},"21139":{"name":"Xã Trà Sơn","type":"xa","slug":"xa-tra-son","name_with_type":"Xã Trà Sơn","path":"Xã Trà Sơn, Huyện Trà Bồng, Tỉnh Quảng Ngãi","path_with_type":"Xã Trà Sơn, Huyện Trà Bồng, Tỉnh Quảng Ngãi","code":"21139","parent_code":"525"},"21142":{"name":"Xã Trà Bùi","type":"xa","slug":"xa-tra-bui","name_with_type":"Xã Trà Bùi","path":"Xã Trà Bùi, Huyện Trà Bồng, Tỉnh Quảng Ngãi","path_with_type":"Xã Trà Bùi, Huyện Trà Bồng, Tỉnh Quảng Ngãi","code":"21142","parent_code":"525"},"21145":{"name":"Xã Trà Thanh","type":"xa","slug":"xa-tra-thanh","name_with_type":"Xã Trà Thanh","path":"Xã Trà Thanh, Huyện Trà Bồng, Tỉnh Quảng Ngãi","path_with_type":"Xã Trà Thanh, Huyện Trà Bồng, Tỉnh Quảng Ngãi","code":"21145","parent_code":"525"},"21148":{"name":"Xã Sơn Trà","type":"xa","slug":"xa-son-tra","name_with_type":"Xã Sơn Trà","path":"Xã Sơn Trà, Huyện Trà Bồng, Tỉnh Quảng Ngãi","path_with_type":"Xã Sơn Trà, Huyện Trà Bồng, Tỉnh Quảng Ngãi","code":"21148","parent_code":"525"},"21154":{"name":"Xã Trà Phong","type":"xa","slug":"xa-tra-phong","name_with_type":"Xã Trà Phong","path":"Xã Trà Phong, Huyện Trà Bồng, Tỉnh Quảng Ngãi","path_with_type":"Xã Trà Phong, Huyện Trà Bồng, Tỉnh Quảng Ngãi","code":"21154","parent_code":"525"},"21157":{"name":"Xã Hương Trà","type":"xa","slug":"xa-huong-tra","name_with_type":"Xã Hương Trà","path":"Xã Hương Trà, Huyện Trà Bồng, Tỉnh Quảng Ngãi","path_with_type":"Xã Hương Trà, Huyện Trà Bồng, Tỉnh Quảng Ngãi","code":"21157","parent_code":"525"},"21163":{"name":"Xã Trà Xinh","type":"xa","slug":"xa-tra-xinh","name_with_type":"Xã Trà Xinh","path":"Xã Trà Xinh, Huyện Trà Bồng, Tỉnh Quảng Ngãi","path_with_type":"Xã Trà Xinh, Huyện Trà Bồng, Tỉnh Quảng Ngãi","code":"21163","parent_code":"525"},"21166":{"name":"Xã Trà Tây","type":"xa","slug":"xa-tra-tay","name_with_type":"Xã Trà Tây","path":"Xã Trà Tây, Huyện Trà Bồng, Tỉnh Quảng Ngãi","path_with_type":"Xã Trà Tây, Huyện Trà Bồng, Tỉnh Quảng Ngãi","code":"21166","parent_code":"525"},"21172":{"name":"Phường Trương Quang Trọng","type":"phuong","slug":"phuong-truong-quang-trong","name_with_type":"Phường Trương Quang Trọng","path":"Phường Trương Quang Trọng, Thành phố Quảng Ngãi, Tỉnh Quảng Ngãi","path_with_type":"Phường Trương Quang Trọng, Thành phố Quảng Ngãi, Tỉnh Quảng Ngãi","code":"21172","parent_code":"522"},"21175":{"name":"Xã Tịnh Thọ","type":"xa","slug":"xa-tinh-tho","name_with_type":"Xã Tịnh Thọ","path":"Xã Tịnh Thọ, Huyện Sơn Tịnh, Tỉnh Quảng Ngãi","path_with_type":"Xã Tịnh Thọ, Huyện Sơn Tịnh, Tỉnh Quảng Ngãi","code":"21175","parent_code":"527"},"21178":{"name":"Xã Tịnh Trà","type":"xa","slug":"xa-tinh-tra","name_with_type":"Xã Tịnh Trà","path":"Xã Tịnh Trà, Huyện Sơn Tịnh, Tỉnh Quảng Ngãi","path_with_type":"Xã Tịnh Trà, Huyện Sơn Tịnh, Tỉnh Quảng Ngãi","code":"21178","parent_code":"527"},"21181":{"name":"Xã Tịnh Phong","type":"xa","slug":"xa-tinh-phong","name_with_type":"Xã Tịnh Phong","path":"Xã Tịnh Phong, Huyện Sơn Tịnh, Tỉnh Quảng Ngãi","path_with_type":"Xã Tịnh Phong, Huyện Sơn Tịnh, Tỉnh Quảng Ngãi","code":"21181","parent_code":"527"},"21184":{"name":"Xã Tịnh Hiệp","type":"xa","slug":"xa-tinh-hiep","name_with_type":"Xã Tịnh Hiệp","path":"Xã Tịnh Hiệp, Huyện Sơn Tịnh, Tỉnh Quảng Ngãi","path_with_type":"Xã Tịnh Hiệp, Huyện Sơn Tịnh, Tỉnh Quảng Ngãi","code":"21184","parent_code":"527"},"21187":{"name":"Xã Tịnh Hòa","type":"xa","slug":"xa-tinh-hoa","name_with_type":"Xã Tịnh Hòa","path":"Xã Tịnh Hòa, Thành phố Quảng Ngãi, Tỉnh Quảng Ngãi","path_with_type":"Xã Tịnh Hòa, Thành phố Quảng Ngãi, Tỉnh Quảng Ngãi","code":"21187","parent_code":"522"},"21190":{"name":"Xã Tịnh Kỳ","type":"xa","slug":"xa-tinh-ky","name_with_type":"Xã Tịnh Kỳ","path":"Xã Tịnh Kỳ, Thành phố Quảng Ngãi, Tỉnh Quảng Ngãi","path_with_type":"Xã Tịnh Kỳ, Thành phố Quảng Ngãi, Tỉnh Quảng Ngãi","code":"21190","parent_code":"522"},"21193":{"name":"Xã Tịnh Bình","type":"xa","slug":"xa-tinh-binh","name_with_type":"Xã Tịnh Bình","path":"Xã Tịnh Bình, Huyện Sơn Tịnh, Tỉnh Quảng Ngãi","path_with_type":"Xã Tịnh Bình, Huyện Sơn Tịnh, Tỉnh Quảng Ngãi","code":"21193","parent_code":"527"},"21196":{"name":"Xã Tịnh Đông","type":"xa","slug":"xa-tinh-dong","name_with_type":"Xã Tịnh Đông","path":"Xã Tịnh Đông, Huyện Sơn Tịnh, Tỉnh Quảng Ngãi","path_with_type":"Xã Tịnh Đông, Huyện Sơn Tịnh, Tỉnh Quảng Ngãi","code":"21196","parent_code":"527"},"21199":{"name":"Xã Tịnh Thiện","type":"xa","slug":"xa-tinh-thien","name_with_type":"Xã Tịnh Thiện","path":"Xã Tịnh Thiện, Thành phố Quảng Ngãi, Tỉnh Quảng Ngãi","path_with_type":"Xã Tịnh Thiện, Thành phố Quảng Ngãi, Tỉnh Quảng Ngãi","code":"21199","parent_code":"522"},"21202":{"name":"Xã Tịnh Ấn Đông","type":"xa","slug":"xa-tinh-an-dong","name_with_type":"Xã Tịnh Ấn Đông","path":"Xã Tịnh Ấn Đông, Thành phố Quảng Ngãi, Tỉnh Quảng Ngãi","path_with_type":"Xã Tịnh Ấn Đông, Thành phố Quảng Ngãi, Tỉnh Quảng Ngãi","code":"21202","parent_code":"522"},"21205":{"name":"Xã Tịnh Bắc","type":"xa","slug":"xa-tinh-bac","name_with_type":"Xã Tịnh Bắc","path":"Xã Tịnh Bắc, Huyện Sơn Tịnh, Tỉnh Quảng Ngãi","path_with_type":"Xã Tịnh Bắc, Huyện Sơn Tịnh, Tỉnh Quảng Ngãi","code":"21205","parent_code":"527"},"21208":{"name":"Xã Tịnh Châu","type":"xa","slug":"xa-tinh-chau","name_with_type":"Xã Tịnh Châu","path":"Xã Tịnh Châu, Thành phố Quảng Ngãi, Tỉnh Quảng Ngãi","path_with_type":"Xã Tịnh Châu, Thành phố Quảng Ngãi, Tỉnh Quảng Ngãi","code":"21208","parent_code":"522"},"21211":{"name":"Xã Tịnh Khê","type":"xa","slug":"xa-tinh-khe","name_with_type":"Xã Tịnh Khê","path":"Xã Tịnh Khê, Thành phố Quảng Ngãi, Tỉnh Quảng Ngãi","path_with_type":"Xã Tịnh Khê, Thành phố Quảng Ngãi, Tỉnh Quảng Ngãi","code":"21211","parent_code":"522"},"21214":{"name":"Xã Tịnh Long","type":"xa","slug":"xa-tinh-long","name_with_type":"Xã Tịnh Long","path":"Xã Tịnh Long, Thành phố Quảng Ngãi, Tỉnh Quảng Ngãi","path_with_type":"Xã Tịnh Long, Thành phố Quảng Ngãi, Tỉnh Quảng Ngãi","code":"21214","parent_code":"522"},"21217":{"name":"Xã Tịnh Sơn","type":"xa","slug":"xa-tinh-son","name_with_type":"Xã Tịnh Sơn","path":"Xã Tịnh Sơn, Huyện Sơn Tịnh, Tỉnh Quảng Ngãi","path_with_type":"Xã Tịnh Sơn, Huyện Sơn Tịnh, Tỉnh Quảng Ngãi","code":"21217","parent_code":"527"},"21220":{"name":"Thị trấn Tịnh Hà","type":"thi-tran","slug":"thi-tran-tinh-ha","name_with_type":"Thị trấn Tịnh Hà","path":"Thị trấn Tịnh Hà, Huyện Sơn Tịnh, Tỉnh Quảng Ngãi","path_with_type":"Thị trấn Tịnh Hà, Huyện Sơn Tịnh, Tỉnh Quảng Ngãi","code":"21220","parent_code":"527"},"21223":{"name":"Xã Tịnh Ấn Tây","type":"xa","slug":"xa-tinh-an-tay","name_with_type":"Xã Tịnh Ấn Tây","path":"Xã Tịnh Ấn Tây, Thành phố Quảng Ngãi, Tỉnh Quảng Ngãi","path_with_type":"Xã Tịnh Ấn Tây, Thành phố Quảng Ngãi, Tỉnh Quảng Ngãi","code":"21223","parent_code":"522"},"21226":{"name":"Xã Tịnh Giang","type":"xa","slug":"xa-tinh-giang","name_with_type":"Xã Tịnh Giang","path":"Xã Tịnh Giang, Huyện Sơn Tịnh, Tỉnh Quảng Ngãi","path_with_type":"Xã Tịnh Giang, Huyện Sơn Tịnh, Tỉnh Quảng Ngãi","code":"21226","parent_code":"527"},"21229":{"name":"Xã Tịnh Minh","type":"xa","slug":"xa-tinh-minh","name_with_type":"Xã Tịnh Minh","path":"Xã Tịnh Minh, Huyện Sơn Tịnh, Tỉnh Quảng Ngãi","path_with_type":"Xã Tịnh Minh, Huyện Sơn Tịnh, Tỉnh Quảng Ngãi","code":"21229","parent_code":"527"},"21232":{"name":"Xã Tịnh An","type":"xa","slug":"xa-tinh-an","name_with_type":"Xã Tịnh An","path":"Xã Tịnh An, Thành phố Quảng Ngãi, Tỉnh Quảng Ngãi","path_with_type":"Xã Tịnh An, Thành phố Quảng Ngãi, Tỉnh Quảng Ngãi","code":"21232","parent_code":"522"},"21235":{"name":"Thị trấn La Hà","type":"thi-tran","slug":"thi-tran-la-ha","name_with_type":"Thị trấn La Hà","path":"Thị trấn La Hà, Huyện Tư Nghĩa, Tỉnh Quảng Ngãi","path_with_type":"Thị trấn La Hà, Huyện Tư Nghĩa, Tỉnh Quảng Ngãi","code":"21235","parent_code":"528"},"21238":{"name":"Thị trấn Sông Vệ","type":"thi-tran","slug":"thi-tran-song-ve","name_with_type":"Thị trấn Sông Vệ","path":"Thị trấn Sông Vệ, Huyện Tư Nghĩa, Tỉnh Quảng Ngãi","path_with_type":"Thị trấn Sông Vệ, Huyện Tư Nghĩa, Tỉnh Quảng Ngãi","code":"21238","parent_code":"528"},"21241":{"name":"Xã Nghĩa Lâm","type":"xa","slug":"xa-nghia-lam","name_with_type":"Xã Nghĩa Lâm","path":"Xã Nghĩa Lâm, Huyện Tư Nghĩa, Tỉnh Quảng Ngãi","path_with_type":"Xã Nghĩa Lâm, Huyện Tư Nghĩa, Tỉnh Quảng Ngãi","code":"21241","parent_code":"528"},"21244":{"name":"Xã Nghĩa Thắng","type":"xa","slug":"xa-nghia-thang","name_with_type":"Xã Nghĩa Thắng","path":"Xã Nghĩa Thắng, Huyện Tư Nghĩa, Tỉnh Quảng Ngãi","path_with_type":"Xã Nghĩa Thắng, Huyện Tư Nghĩa, Tỉnh Quảng Ngãi","code":"21244","parent_code":"528"},"21247":{"name":"Xã Nghĩa Thuận","type":"xa","slug":"xa-nghia-thuan","name_with_type":"Xã Nghĩa Thuận","path":"Xã Nghĩa Thuận, Huyện Tư Nghĩa, Tỉnh Quảng Ngãi","path_with_type":"Xã Nghĩa Thuận, Huyện Tư Nghĩa, Tỉnh Quảng Ngãi","code":"21247","parent_code":"528"},"21250":{"name":"Xã Nghĩa Kỳ","type":"xa","slug":"xa-nghia-ky","name_with_type":"Xã Nghĩa Kỳ","path":"Xã Nghĩa Kỳ, Huyện Tư Nghĩa, Tỉnh Quảng Ngãi","path_with_type":"Xã Nghĩa Kỳ, Huyện Tư Nghĩa, Tỉnh Quảng Ngãi","code":"21250","parent_code":"528"},"21256":{"name":"Xã Nghĩa Hà","type":"xa","slug":"xa-nghia-ha","name_with_type":"Xã Nghĩa Hà","path":"Xã Nghĩa Hà, Thành phố Quảng Ngãi, Tỉnh Quảng Ngãi","path_with_type":"Xã Nghĩa Hà, Thành phố Quảng Ngãi, Tỉnh Quảng Ngãi","code":"21256","parent_code":"522"},"21259":{"name":"Xã Nghĩa Sơn","type":"xa","slug":"xa-nghia-son","name_with_type":"Xã Nghĩa Sơn","path":"Xã Nghĩa Sơn, Huyện Tư Nghĩa, Tỉnh Quảng Ngãi","path_with_type":"Xã Nghĩa Sơn, Huyện Tư Nghĩa, Tỉnh Quảng Ngãi","code":"21259","parent_code":"528"},"21262":{"name":"Xã An Phú","type":"xa","slug":"xa-an-phu","name_with_type":"Xã An Phú","path":"Xã An Phú, Thành phố Quảng Ngãi, Tỉnh Quảng Ngãi","path_with_type":"Xã An Phú, Thành phố Quảng Ngãi, Tỉnh Quảng Ngãi","code":"21262","parent_code":"522"},"21268":{"name":"Xã Nghĩa Hòa","type":"xa","slug":"xa-nghia-hoa","name_with_type":"Xã Nghĩa Hòa","path":"Xã Nghĩa Hòa, Huyện Tư Nghĩa, Tỉnh Quảng Ngãi","path_with_type":"Xã Nghĩa Hòa, Huyện Tư Nghĩa, Tỉnh Quảng Ngãi","code":"21268","parent_code":"528"},"21271":{"name":"Xã Nghĩa Điền","type":"xa","slug":"xa-nghia-dien","name_with_type":"Xã Nghĩa Điền","path":"Xã Nghĩa Điền, Huyện Tư Nghĩa, Tỉnh Quảng Ngãi","path_with_type":"Xã Nghĩa Điền, Huyện Tư Nghĩa, Tỉnh Quảng Ngãi","code":"21271","parent_code":"528"},"21274":{"name":"Xã Nghĩa Thương","type":"xa","slug":"xa-nghia-thuong","name_with_type":"Xã Nghĩa Thương","path":"Xã Nghĩa Thương, Huyện Tư Nghĩa, Tỉnh Quảng Ngãi","path_with_type":"Xã Nghĩa Thương, Huyện Tư Nghĩa, Tỉnh Quảng Ngãi","code":"21274","parent_code":"528"},"21277":{"name":"Xã Nghĩa Trung","type":"xa","slug":"xa-nghia-trung","name_with_type":"Xã Nghĩa Trung","path":"Xã Nghĩa Trung, Huyện Tư Nghĩa, Tỉnh Quảng Ngãi","path_with_type":"Xã Nghĩa Trung, Huyện Tư Nghĩa, Tỉnh Quảng Ngãi","code":"21277","parent_code":"528"},"21280":{"name":"Xã Nghĩa Hiệp","type":"xa","slug":"xa-nghia-hiep","name_with_type":"Xã Nghĩa Hiệp","path":"Xã Nghĩa Hiệp, Huyện Tư Nghĩa, Tỉnh Quảng Ngãi","path_with_type":"Xã Nghĩa Hiệp, Huyện Tư Nghĩa, Tỉnh Quảng Ngãi","code":"21280","parent_code":"528"},"21283":{"name":"Xã Nghĩa Phương","type":"xa","slug":"xa-nghia-phuong","name_with_type":"Xã Nghĩa Phương","path":"Xã Nghĩa Phương, Huyện Tư Nghĩa, Tỉnh Quảng Ngãi","path_with_type":"Xã Nghĩa Phương, Huyện Tư Nghĩa, Tỉnh Quảng Ngãi","code":"21283","parent_code":"528"},"21289":{"name":"Thị trấn Di Lăng","type":"thi-tran","slug":"thi-tran-di-lang","name_with_type":"Thị trấn Di Lăng","path":"Thị trấn Di Lăng, Huyện Sơn Hà, Tỉnh Quảng Ngãi","path_with_type":"Thị trấn Di Lăng, Huyện Sơn Hà, Tỉnh Quảng Ngãi","code":"21289","parent_code":"529"},"21292":{"name":"Xã Sơn Hạ","type":"xa","slug":"xa-son-ha","name_with_type":"Xã Sơn Hạ","path":"Xã Sơn Hạ, Huyện Sơn Hà, Tỉnh Quảng Ngãi","path_with_type":"Xã Sơn Hạ, Huyện Sơn Hà, Tỉnh Quảng Ngãi","code":"21292","parent_code":"529"},"21295":{"name":"Xã Sơn Thành","type":"xa","slug":"xa-son-thanh","name_with_type":"Xã Sơn Thành","path":"Xã Sơn Thành, Huyện Sơn Hà, Tỉnh Quảng Ngãi","path_with_type":"Xã Sơn Thành, Huyện Sơn Hà, Tỉnh Quảng Ngãi","code":"21295","parent_code":"529"},"21298":{"name":"Xã Sơn Nham","type":"xa","slug":"xa-son-nham","name_with_type":"Xã Sơn Nham","path":"Xã Sơn Nham, Huyện Sơn Hà, Tỉnh Quảng Ngãi","path_with_type":"Xã Sơn Nham, Huyện Sơn Hà, Tỉnh Quảng Ngãi","code":"21298","parent_code":"529"},"21301":{"name":"Xã Sơn Bao","type":"xa","slug":"xa-son-bao","name_with_type":"Xã Sơn Bao","path":"Xã Sơn Bao, Huyện Sơn Hà, Tỉnh Quảng Ngãi","path_with_type":"Xã Sơn Bao, Huyện Sơn Hà, Tỉnh Quảng Ngãi","code":"21301","parent_code":"529"},"21304":{"name":"Xã Sơn Linh","type":"xa","slug":"xa-son-linh","name_with_type":"Xã Sơn Linh","path":"Xã Sơn Linh, Huyện Sơn Hà, Tỉnh Quảng Ngãi","path_with_type":"Xã Sơn Linh, Huyện Sơn Hà, Tỉnh Quảng Ngãi","code":"21304","parent_code":"529"},"21307":{"name":"Xã Sơn Giang","type":"xa","slug":"xa-son-giang","name_with_type":"Xã Sơn Giang","path":"Xã Sơn Giang, Huyện Sơn Hà, Tỉnh Quảng Ngãi","path_with_type":"Xã Sơn Giang, Huyện Sơn Hà, Tỉnh Quảng Ngãi","code":"21307","parent_code":"529"},"21310":{"name":"Xã Sơn Trung","type":"xa","slug":"xa-son-trung","name_with_type":"Xã Sơn Trung","path":"Xã Sơn Trung, Huyện Sơn Hà, Tỉnh Quảng Ngãi","path_with_type":"Xã Sơn Trung, Huyện Sơn Hà, Tỉnh Quảng Ngãi","code":"21310","parent_code":"529"},"21313":{"name":"Xã Sơn Thượng","type":"xa","slug":"xa-son-thuong","name_with_type":"Xã Sơn Thượng","path":"Xã Sơn Thượng, Huyện Sơn Hà, Tỉnh Quảng Ngãi","path_with_type":"Xã Sơn Thượng, Huyện Sơn Hà, Tỉnh Quảng Ngãi","code":"21313","parent_code":"529"},"21316":{"name":"Xã Sơn Cao","type":"xa","slug":"xa-son-cao","name_with_type":"Xã Sơn Cao","path":"Xã Sơn Cao, Huyện Sơn Hà, Tỉnh Quảng Ngãi","path_with_type":"Xã Sơn Cao, Huyện Sơn Hà, Tỉnh Quảng Ngãi","code":"21316","parent_code":"529"},"21319":{"name":"Xã Sơn Hải","type":"xa","slug":"xa-son-hai","name_with_type":"Xã Sơn Hải","path":"Xã Sơn Hải, Huyện Sơn Hà, Tỉnh Quảng Ngãi","path_with_type":"Xã Sơn Hải, Huyện Sơn Hà, Tỉnh Quảng Ngãi","code":"21319","parent_code":"529"},"21322":{"name":"Xã Sơn Thủy","type":"xa","slug":"xa-son-thuy","name_with_type":"Xã Sơn Thủy","path":"Xã Sơn Thủy, Huyện Sơn Hà, Tỉnh Quảng Ngãi","path_with_type":"Xã Sơn Thủy, Huyện Sơn Hà, Tỉnh Quảng Ngãi","code":"21322","parent_code":"529"},"21325":{"name":"Xã Sơn Kỳ","type":"xa","slug":"xa-son-ky","name_with_type":"Xã Sơn Kỳ","path":"Xã Sơn Kỳ, Huyện Sơn Hà, Tỉnh Quảng Ngãi","path_with_type":"Xã Sơn Kỳ, Huyện Sơn Hà, Tỉnh Quảng Ngãi","code":"21325","parent_code":"529"},"21328":{"name":"Xã Sơn Ba","type":"xa","slug":"xa-son-ba","name_with_type":"Xã Sơn Ba","path":"Xã Sơn Ba, Huyện Sơn Hà, Tỉnh Quảng Ngãi","path_with_type":"Xã Sơn Ba, Huyện Sơn Hà, Tỉnh Quảng Ngãi","code":"21328","parent_code":"529"},"21331":{"name":"Xã Sơn Bua","type":"xa","slug":"xa-son-bua","name_with_type":"Xã Sơn Bua","path":"Xã Sơn Bua, Huyện Sơn Tây, Tỉnh Quảng Ngãi","path_with_type":"Xã Sơn Bua, Huyện Sơn Tây, Tỉnh Quảng Ngãi","code":"21331","parent_code":"530"},"21334":{"name":"Xã Sơn Mùa","type":"xa","slug":"xa-son-mua","name_with_type":"Xã Sơn Mùa","path":"Xã Sơn Mùa, Huyện Sơn Tây, Tỉnh Quảng Ngãi","path_with_type":"Xã Sơn Mùa, Huyện Sơn Tây, Tỉnh Quảng Ngãi","code":"21334","parent_code":"530"},"21335":{"name":"Xã Sơn Liên","type":"xa","slug":"xa-son-lien","name_with_type":"Xã Sơn Liên","path":"Xã Sơn Liên, Huyện Sơn Tây, Tỉnh Quảng Ngãi","path_with_type":"Xã Sơn Liên, Huyện Sơn Tây, Tỉnh Quảng Ngãi","code":"21335","parent_code":"530"},"21337":{"name":"Xã Sơn Tân","type":"xa","slug":"xa-son-tan","name_with_type":"Xã Sơn Tân","path":"Xã Sơn Tân, Huyện Sơn Tây, Tỉnh Quảng Ngãi","path_with_type":"Xã Sơn Tân, Huyện Sơn Tây, Tỉnh Quảng Ngãi","code":"21337","parent_code":"530"},"21338":{"name":"Xã Sơn Màu","type":"xa","slug":"xa-son-mau","name_with_type":"Xã Sơn Màu","path":"Xã Sơn Màu, Huyện Sơn Tây, Tỉnh Quảng Ngãi","path_with_type":"Xã Sơn Màu, Huyện Sơn Tây, Tỉnh Quảng Ngãi","code":"21338","parent_code":"530"},"21340":{"name":"Xã Sơn Dung","type":"xa","slug":"xa-son-dung","name_with_type":"Xã Sơn Dung","path":"Xã Sơn Dung, Huyện Sơn Tây, Tỉnh Quảng Ngãi","path_with_type":"Xã Sơn Dung, Huyện Sơn Tây, Tỉnh Quảng Ngãi","code":"21340","parent_code":"530"},"21341":{"name":"Xã Sơn Long","type":"xa","slug":"xa-son-long","name_with_type":"Xã Sơn Long","path":"Xã Sơn Long, Huyện Sơn Tây, Tỉnh Quảng Ngãi","path_with_type":"Xã Sơn Long, Huyện Sơn Tây, Tỉnh Quảng Ngãi","code":"21341","parent_code":"530"},"21343":{"name":"Xã Sơn Tinh","type":"xa","slug":"xa-son-tinh","name_with_type":"Xã Sơn Tinh","path":"Xã Sơn Tinh, Huyện Sơn Tây, Tỉnh Quảng Ngãi","path_with_type":"Xã Sơn Tinh, Huyện Sơn Tây, Tỉnh Quảng Ngãi","code":"21343","parent_code":"530"},"21346":{"name":"Xã Sơn Lập","type":"xa","slug":"xa-son-lap","name_with_type":"Xã Sơn Lập","path":"Xã Sơn Lập, Huyện Sơn Tây, Tỉnh Quảng Ngãi","path_with_type":"Xã Sơn Lập, Huyện Sơn Tây, Tỉnh Quảng Ngãi","code":"21346","parent_code":"530"},"21349":{"name":"Xã Long Sơn","type":"xa","slug":"xa-long-son","name_with_type":"Xã Long Sơn","path":"Xã Long Sơn, Huyện Minh Long, Tỉnh Quảng Ngãi","path_with_type":"Xã Long Sơn, Huyện Minh Long, Tỉnh Quảng Ngãi","code":"21349","parent_code":"531"},"21352":{"name":"Xã Long Mai","type":"xa","slug":"xa-long-mai","name_with_type":"Xã Long Mai","path":"Xã Long Mai, Huyện Minh Long, Tỉnh Quảng Ngãi","path_with_type":"Xã Long Mai, Huyện Minh Long, Tỉnh Quảng Ngãi","code":"21352","parent_code":"531"},"21355":{"name":"Xã Thanh An","type":"xa","slug":"xa-thanh-an","name_with_type":"Xã Thanh An","path":"Xã Thanh An, Huyện Minh Long, Tỉnh Quảng Ngãi","path_with_type":"Xã Thanh An, Huyện Minh Long, Tỉnh Quảng Ngãi","code":"21355","parent_code":"531"},"21358":{"name":"Xã Long Môn","type":"xa","slug":"xa-long-mon","name_with_type":"Xã Long Môn","path":"Xã Long Môn, Huyện Minh Long, Tỉnh Quảng Ngãi","path_with_type":"Xã Long Môn, Huyện Minh Long, Tỉnh Quảng Ngãi","code":"21358","parent_code":"531"},"21361":{"name":"Xã Long Hiệp","type":"xa","slug":"xa-long-hiep","name_with_type":"Xã Long Hiệp","path":"Xã Long Hiệp, Huyện Minh Long, Tỉnh Quảng Ngãi","path_with_type":"Xã Long Hiệp, Huyện Minh Long, Tỉnh Quảng Ngãi","code":"21361","parent_code":"531"},"21364":{"name":"Thị trấn Chợ Chùa","type":"thi-tran","slug":"thi-tran-cho-chua","name_with_type":"Thị trấn Chợ Chùa","path":"Thị trấn Chợ Chùa, Huyện Nghĩa Hành, Tỉnh Quảng Ngãi","path_with_type":"Thị trấn Chợ Chùa, Huyện Nghĩa Hành, Tỉnh Quảng Ngãi","code":"21364","parent_code":"532"},"21367":{"name":"Xã Hành Thuận","type":"xa","slug":"xa-hanh-thuan","name_with_type":"Xã Hành Thuận","path":"Xã Hành Thuận, Huyện Nghĩa Hành, Tỉnh Quảng Ngãi","path_with_type":"Xã Hành Thuận, Huyện Nghĩa Hành, Tỉnh Quảng Ngãi","code":"21367","parent_code":"532"},"21370":{"name":"Xã Hành Dũng","type":"xa","slug":"xa-hanh-dung","name_with_type":"Xã Hành Dũng","path":"Xã Hành Dũng, Huyện Nghĩa Hành, Tỉnh Quảng Ngãi","path_with_type":"Xã Hành Dũng, Huyện Nghĩa Hành, Tỉnh Quảng Ngãi","code":"21370","parent_code":"532"},"21373":{"name":"Xã Hành Trung","type":"xa","slug":"xa-hanh-trung","name_with_type":"Xã Hành Trung","path":"Xã Hành Trung, Huyện Nghĩa Hành, Tỉnh Quảng Ngãi","path_with_type":"Xã Hành Trung, Huyện Nghĩa Hành, Tỉnh Quảng Ngãi","code":"21373","parent_code":"532"},"21376":{"name":"Xã Hành Nhân","type":"xa","slug":"xa-hanh-nhan","name_with_type":"Xã Hành Nhân","path":"Xã Hành Nhân, Huyện Nghĩa Hành, Tỉnh Quảng Ngãi","path_with_type":"Xã Hành Nhân, Huyện Nghĩa Hành, Tỉnh Quảng Ngãi","code":"21376","parent_code":"532"},"21379":{"name":"Xã Hành Đức","type":"xa","slug":"xa-hanh-duc","name_with_type":"Xã Hành Đức","path":"Xã Hành Đức, Huyện Nghĩa Hành, Tỉnh Quảng Ngãi","path_with_type":"Xã Hành Đức, Huyện Nghĩa Hành, Tỉnh Quảng Ngãi","code":"21379","parent_code":"532"},"21382":{"name":"Xã Hành Minh","type":"xa","slug":"xa-hanh-minh","name_with_type":"Xã Hành Minh","path":"Xã Hành Minh, Huyện Nghĩa Hành, Tỉnh Quảng Ngãi","path_with_type":"Xã Hành Minh, Huyện Nghĩa Hành, Tỉnh Quảng Ngãi","code":"21382","parent_code":"532"},"21385":{"name":"Xã Hành Phước","type":"xa","slug":"xa-hanh-phuoc","name_with_type":"Xã Hành Phước","path":"Xã Hành Phước, Huyện Nghĩa Hành, Tỉnh Quảng Ngãi","path_with_type":"Xã Hành Phước, Huyện Nghĩa Hành, Tỉnh Quảng Ngãi","code":"21385","parent_code":"532"},"21388":{"name":"Xã Hành Thiện","type":"xa","slug":"xa-hanh-thien","name_with_type":"Xã Hành Thiện","path":"Xã Hành Thiện, Huyện Nghĩa Hành, Tỉnh Quảng Ngãi","path_with_type":"Xã Hành Thiện, Huyện Nghĩa Hành, Tỉnh Quảng Ngãi","code":"21388","parent_code":"532"},"21391":{"name":"Xã Hành Thịnh","type":"xa","slug":"xa-hanh-thinh","name_with_type":"Xã Hành Thịnh","path":"Xã Hành Thịnh, Huyện Nghĩa Hành, Tỉnh Quảng Ngãi","path_with_type":"Xã Hành Thịnh, Huyện Nghĩa Hành, Tỉnh Quảng Ngãi","code":"21391","parent_code":"532"},"21394":{"name":"Xã Hành Tín Tây","type":"xa","slug":"xa-hanh-tin-tay","name_with_type":"Xã Hành Tín Tây","path":"Xã Hành Tín Tây, Huyện Nghĩa Hành, Tỉnh Quảng Ngãi","path_with_type":"Xã Hành Tín Tây, Huyện Nghĩa Hành, Tỉnh Quảng Ngãi","code":"21394","parent_code":"532"},"21397":{"name":"Xã Hành Tín  Đông","type":"xa","slug":"xa-hanh-tin-dong","name_with_type":"Xã Hành Tín  Đông","path":"Xã Hành Tín  Đông, Huyện Nghĩa Hành, Tỉnh Quảng Ngãi","path_with_type":"Xã Hành Tín  Đông, Huyện Nghĩa Hành, Tỉnh Quảng Ngãi","code":"21397","parent_code":"532"},"21400":{"name":"Thị trấn Mộ Đức","type":"thi-tran","slug":"thi-tran-mo-duc","name_with_type":"Thị trấn Mộ Đức","path":"Thị trấn Mộ Đức, Huyện Mộ Đức, Tỉnh Quảng Ngãi","path_with_type":"Thị trấn Mộ Đức, Huyện Mộ Đức, Tỉnh Quảng Ngãi","code":"21400","parent_code":"533"},"21406":{"name":"Xã Thắng Lợi","type":"xa","slug":"xa-thang-loi","name_with_type":"Xã Thắng Lợi","path":"Xã Thắng Lợi, Huyện Mộ Đức, Tỉnh Quảng Ngãi","path_with_type":"Xã Thắng Lợi, Huyện Mộ Đức, Tỉnh Quảng Ngãi","code":"21406","parent_code":"533"},"21409":{"name":"Xã Đức Nhuận","type":"xa","slug":"xa-duc-nhuan","name_with_type":"Xã Đức Nhuận","path":"Xã Đức Nhuận, Huyện Mộ Đức, Tỉnh Quảng Ngãi","path_with_type":"Xã Đức Nhuận, Huyện Mộ Đức, Tỉnh Quảng Ngãi","code":"21409","parent_code":"533"},"21412":{"name":"Xã Đức Chánh","type":"xa","slug":"xa-duc-chanh","name_with_type":"Xã Đức Chánh","path":"Xã Đức Chánh, Huyện Mộ Đức, Tỉnh Quảng Ngãi","path_with_type":"Xã Đức Chánh, Huyện Mộ Đức, Tỉnh Quảng Ngãi","code":"21412","parent_code":"533"},"21415":{"name":"Xã Đức Hiệp","type":"xa","slug":"xa-duc-hiep","name_with_type":"Xã Đức Hiệp","path":"Xã Đức Hiệp, Huyện Mộ Đức, Tỉnh Quảng Ngãi","path_with_type":"Xã Đức Hiệp, Huyện Mộ Đức, Tỉnh Quảng Ngãi","code":"21415","parent_code":"533"},"21418":{"name":"Xã Đức Minh","type":"xa","slug":"xa-duc-minh","name_with_type":"Xã Đức Minh","path":"Xã Đức Minh, Huyện Mộ Đức, Tỉnh Quảng Ngãi","path_with_type":"Xã Đức Minh, Huyện Mộ Đức, Tỉnh Quảng Ngãi","code":"21418","parent_code":"533"},"21421":{"name":"Xã Đức Thạnh","type":"xa","slug":"xa-duc-thanh","name_with_type":"Xã Đức Thạnh","path":"Xã Đức Thạnh, Huyện Mộ Đức, Tỉnh Quảng Ngãi","path_with_type":"Xã Đức Thạnh, Huyện Mộ Đức, Tỉnh Quảng Ngãi","code":"21421","parent_code":"533"},"21424":{"name":"Xã Đức Hòa","type":"xa","slug":"xa-duc-hoa","name_with_type":"Xã Đức Hòa","path":"Xã Đức Hòa, Huyện Mộ Đức, Tỉnh Quảng Ngãi","path_with_type":"Xã Đức Hòa, Huyện Mộ Đức, Tỉnh Quảng Ngãi","code":"21424","parent_code":"533"},"21427":{"name":"Xã Đức Tân","type":"xa","slug":"xa-duc-tan","name_with_type":"Xã Đức Tân","path":"Xã Đức Tân, Huyện Mộ Đức, Tỉnh Quảng Ngãi","path_with_type":"Xã Đức Tân, Huyện Mộ Đức, Tỉnh Quảng Ngãi","code":"21427","parent_code":"533"},"21430":{"name":"Xã Đức Phú","type":"xa","slug":"xa-duc-phu","name_with_type":"Xã Đức Phú","path":"Xã Đức Phú, Huyện Mộ Đức, Tỉnh Quảng Ngãi","path_with_type":"Xã Đức Phú, Huyện Mộ Đức, Tỉnh Quảng Ngãi","code":"21430","parent_code":"533"},"21433":{"name":"Xã Đức Phong","type":"xa","slug":"xa-duc-phong","name_with_type":"Xã Đức Phong","path":"Xã Đức Phong, Huyện Mộ Đức, Tỉnh Quảng Ngãi","path_with_type":"Xã Đức Phong, Huyện Mộ Đức, Tỉnh Quảng Ngãi","code":"21433","parent_code":"533"},"21436":{"name":"Xã Đức Lân","type":"xa","slug":"xa-duc-lan","name_with_type":"Xã Đức Lân","path":"Xã Đức Lân, Huyện Mộ Đức, Tỉnh Quảng Ngãi","path_with_type":"Xã Đức Lân, Huyện Mộ Đức, Tỉnh Quảng Ngãi","code":"21436","parent_code":"533"},"21439":{"name":"Phường Nguyễn Nghiêm","type":"phuong","slug":"phuong-nguyen-nghiem","name_with_type":"Phường Nguyễn Nghiêm","path":"Phường Nguyễn Nghiêm, Thị xã Đức Phổ, Tỉnh Quảng Ngãi","path_with_type":"Phường Nguyễn Nghiêm, Thị xã Đức Phổ, Tỉnh Quảng Ngãi","code":"21439","parent_code":"534"},"21442":{"name":"Xã Phổ An","type":"xa","slug":"xa-pho-an","name_with_type":"Xã Phổ An","path":"Xã Phổ An, Thị xã Đức Phổ, Tỉnh Quảng Ngãi","path_with_type":"Xã Phổ An, Thị xã Đức Phổ, Tỉnh Quảng Ngãi","code":"21442","parent_code":"534"},"21445":{"name":"Xã Phổ Phong","type":"xa","slug":"xa-pho-phong","name_with_type":"Xã Phổ Phong","path":"Xã Phổ Phong, Thị xã Đức Phổ, Tỉnh Quảng Ngãi","path_with_type":"Xã Phổ Phong, Thị xã Đức Phổ, Tỉnh Quảng Ngãi","code":"21445","parent_code":"534"},"21448":{"name":"Xã Phổ Thuận","type":"xa","slug":"xa-pho-thuan","name_with_type":"Xã Phổ Thuận","path":"Xã Phổ Thuận, Thị xã Đức Phổ, Tỉnh Quảng Ngãi","path_with_type":"Xã Phổ Thuận, Thị xã Đức Phổ, Tỉnh Quảng Ngãi","code":"21448","parent_code":"534"},"21451":{"name":"Phường Phổ Văn","type":"phuong","slug":"phuong-pho-van","name_with_type":"Phường Phổ Văn","path":"Phường Phổ Văn, Thị xã Đức Phổ, Tỉnh Quảng Ngãi","path_with_type":"Phường Phổ Văn, Thị xã Đức Phổ, Tỉnh Quảng Ngãi","code":"21451","parent_code":"534"},"21454":{"name":"Phường Phổ Quang","type":"phuong","slug":"phuong-pho-quang","name_with_type":"Phường Phổ Quang","path":"Phường Phổ Quang, Thị xã Đức Phổ, Tỉnh Quảng Ngãi","path_with_type":"Phường Phổ Quang, Thị xã Đức Phổ, Tỉnh Quảng Ngãi","code":"21454","parent_code":"534"},"21457":{"name":"Xã Phổ Nhơn","type":"xa","slug":"xa-pho-nhon","name_with_type":"Xã Phổ Nhơn","path":"Xã Phổ Nhơn, Thị xã Đức Phổ, Tỉnh Quảng Ngãi","path_with_type":"Xã Phổ Nhơn, Thị xã Đức Phổ, Tỉnh Quảng Ngãi","code":"21457","parent_code":"534"},"21460":{"name":"Phường Phổ Ninh","type":"phuong","slug":"phuong-pho-ninh","name_with_type":"Phường Phổ Ninh","path":"Phường Phổ Ninh, Thị xã Đức Phổ, Tỉnh Quảng Ngãi","path_with_type":"Phường Phổ Ninh, Thị xã Đức Phổ, Tỉnh Quảng Ngãi","code":"21460","parent_code":"534"},"21463":{"name":"Phường Phổ Minh","type":"phuong","slug":"phuong-pho-minh","name_with_type":"Phường Phổ Minh","path":"Phường Phổ Minh, Thị xã Đức Phổ, Tỉnh Quảng Ngãi","path_with_type":"Phường Phổ Minh, Thị xã Đức Phổ, Tỉnh Quảng Ngãi","code":"21463","parent_code":"534"},"21466":{"name":"Phường Phổ Vinh","type":"phuong","slug":"phuong-pho-vinh","name_with_type":"Phường Phổ Vinh","path":"Phường Phổ Vinh, Thị xã Đức Phổ, Tỉnh Quảng Ngãi","path_with_type":"Phường Phổ Vinh, Thị xã Đức Phổ, Tỉnh Quảng Ngãi","code":"21466","parent_code":"534"},"21469":{"name":"Phường Phổ Hòa","type":"phuong","slug":"phuong-pho-hoa","name_with_type":"Phường Phổ Hòa","path":"Phường Phổ Hòa, Thị xã Đức Phổ, Tỉnh Quảng Ngãi","path_with_type":"Phường Phổ Hòa, Thị xã Đức Phổ, Tỉnh Quảng Ngãi","code":"21469","parent_code":"534"},"21472":{"name":"Xã Phổ Cường","type":"xa","slug":"xa-pho-cuong","name_with_type":"Xã Phổ Cường","path":"Xã Phổ Cường, Thị xã Đức Phổ, Tỉnh Quảng Ngãi","path_with_type":"Xã Phổ Cường, Thị xã Đức Phổ, Tỉnh Quảng Ngãi","code":"21472","parent_code":"534"},"21475":{"name":"Xã Phổ Khánh","type":"xa","slug":"xa-pho-khanh","name_with_type":"Xã Phổ Khánh","path":"Xã Phổ Khánh, Thị xã Đức Phổ, Tỉnh Quảng Ngãi","path_with_type":"Xã Phổ Khánh, Thị xã Đức Phổ, Tỉnh Quảng Ngãi","code":"21475","parent_code":"534"},"21478":{"name":"Phường Phổ Thạnh","type":"phuong","slug":"phuong-pho-thanh","name_with_type":"Phường Phổ Thạnh","path":"Phường Phổ Thạnh, Thị xã Đức Phổ, Tỉnh Quảng Ngãi","path_with_type":"Phường Phổ Thạnh, Thị xã Đức Phổ, Tỉnh Quảng Ngãi","code":"21478","parent_code":"534"},"21481":{"name":"Xã Phổ Châu","type":"xa","slug":"xa-pho-chau","name_with_type":"Xã Phổ Châu","path":"Xã Phổ Châu, Thị xã Đức Phổ, Tỉnh Quảng Ngãi","path_with_type":"Xã Phổ Châu, Thị xã Đức Phổ, Tỉnh Quảng Ngãi","code":"21481","parent_code":"534"},"21484":{"name":"Thị trấn Ba Tơ","type":"thi-tran","slug":"thi-tran-ba-to","name_with_type":"Thị trấn Ba Tơ","path":"Thị trấn Ba Tơ, Huyện Ba Tơ, Tỉnh Quảng Ngãi","path_with_type":"Thị trấn Ba Tơ, Huyện Ba Tơ, Tỉnh Quảng Ngãi","code":"21484","parent_code":"535"},"21487":{"name":"Xã Ba Điền","type":"xa","slug":"xa-ba-dien","name_with_type":"Xã Ba Điền","path":"Xã Ba Điền, Huyện Ba Tơ, Tỉnh Quảng Ngãi","path_with_type":"Xã Ba Điền, Huyện Ba Tơ, Tỉnh Quảng Ngãi","code":"21487","parent_code":"535"},"21490":{"name":"Xã Ba Vinh","type":"xa","slug":"xa-ba-vinh","name_with_type":"Xã Ba Vinh","path":"Xã Ba Vinh, Huyện Ba Tơ, Tỉnh Quảng Ngãi","path_with_type":"Xã Ba Vinh, Huyện Ba Tơ, Tỉnh Quảng Ngãi","code":"21490","parent_code":"535"},"21493":{"name":"Xã Ba Thành","type":"xa","slug":"xa-ba-thanh","name_with_type":"Xã Ba Thành","path":"Xã Ba Thành, Huyện Ba Tơ, Tỉnh Quảng Ngãi","path_with_type":"Xã Ba Thành, Huyện Ba Tơ, Tỉnh Quảng Ngãi","code":"21493","parent_code":"535"},"21496":{"name":"Xã Ba Động","type":"xa","slug":"xa-ba-dong","name_with_type":"Xã Ba Động","path":"Xã Ba Động, Huyện Ba Tơ, Tỉnh Quảng Ngãi","path_with_type":"Xã Ba Động, Huyện Ba Tơ, Tỉnh Quảng Ngãi","code":"21496","parent_code":"535"},"21499":{"name":"Xã Ba Dinh","type":"xa","slug":"xa-ba-dinh","name_with_type":"Xã Ba Dinh","path":"Xã Ba Dinh, Huyện Ba Tơ, Tỉnh Quảng Ngãi","path_with_type":"Xã Ba Dinh, Huyện Ba Tơ, Tỉnh Quảng Ngãi","code":"21499","parent_code":"535"},"21500":{"name":"Xã Ba Giang","type":"xa","slug":"xa-ba-giang","name_with_type":"Xã Ba Giang","path":"Xã Ba Giang, Huyện Ba Tơ, Tỉnh Quảng Ngãi","path_with_type":"Xã Ba Giang, Huyện Ba Tơ, Tỉnh Quảng Ngãi","code":"21500","parent_code":"535"},"21502":{"name":"Xã Ba Liên","type":"xa","slug":"xa-ba-lien","name_with_type":"Xã Ba Liên","path":"Xã Ba Liên, Huyện Ba Tơ, Tỉnh Quảng Ngãi","path_with_type":"Xã Ba Liên, Huyện Ba Tơ, Tỉnh Quảng Ngãi","code":"21502","parent_code":"535"},"21505":{"name":"Xã Ba Ngạc","type":"xa","slug":"xa-ba-ngac","name_with_type":"Xã Ba Ngạc","path":"Xã Ba Ngạc, Huyện Ba Tơ, Tỉnh Quảng Ngãi","path_with_type":"Xã Ba Ngạc, Huyện Ba Tơ, Tỉnh Quảng Ngãi","code":"21505","parent_code":"535"},"21508":{"name":"Xã Ba Khâm","type":"xa","slug":"xa-ba-kham","name_with_type":"Xã Ba Khâm","path":"Xã Ba Khâm, Huyện Ba Tơ, Tỉnh Quảng Ngãi","path_with_type":"Xã Ba Khâm, Huyện Ba Tơ, Tỉnh Quảng Ngãi","code":"21508","parent_code":"535"},"21511":{"name":"Xã Ba Cung","type":"xa","slug":"xa-ba-cung","name_with_type":"Xã Ba Cung","path":"Xã Ba Cung, Huyện Ba Tơ, Tỉnh Quảng Ngãi","path_with_type":"Xã Ba Cung, Huyện Ba Tơ, Tỉnh Quảng Ngãi","code":"21511","parent_code":"535"},"21517":{"name":"Xã Ba Tiêu","type":"xa","slug":"xa-ba-tieu","name_with_type":"Xã Ba Tiêu","path":"Xã Ba Tiêu, Huyện Ba Tơ, Tỉnh Quảng Ngãi","path_with_type":"Xã Ba Tiêu, Huyện Ba Tơ, Tỉnh Quảng Ngãi","code":"21517","parent_code":"535"},"21520":{"name":"Xã Ba Trang","type":"xa","slug":"xa-ba-trang","name_with_type":"Xã Ba Trang","path":"Xã Ba Trang, Huyện Ba Tơ, Tỉnh Quảng Ngãi","path_with_type":"Xã Ba Trang, Huyện Ba Tơ, Tỉnh Quảng Ngãi","code":"21520","parent_code":"535"},"21523":{"name":"Xã Ba Tô","type":"xa","slug":"xa-ba-to","name_with_type":"Xã Ba Tô","path":"Xã Ba Tô, Huyện Ba Tơ, Tỉnh Quảng Ngãi","path_with_type":"Xã Ba Tô, Huyện Ba Tơ, Tỉnh Quảng Ngãi","code":"21523","parent_code":"535"},"21526":{"name":"Xã Ba Bích","type":"xa","slug":"xa-ba-bich","name_with_type":"Xã Ba Bích","path":"Xã Ba Bích, Huyện Ba Tơ, Tỉnh Quảng Ngãi","path_with_type":"Xã Ba Bích, Huyện Ba Tơ, Tỉnh Quảng Ngãi","code":"21526","parent_code":"535"},"21529":{"name":"Xã Ba Vì","type":"xa","slug":"xa-ba-vi","name_with_type":"Xã Ba Vì","path":"Xã Ba Vì, Huyện Ba Tơ, Tỉnh Quảng Ngãi","path_with_type":"Xã Ba Vì, Huyện Ba Tơ, Tỉnh Quảng Ngãi","code":"21529","parent_code":"535"},"21532":{"name":"Xã Ba Lế","type":"xa","slug":"xa-ba-le","name_with_type":"Xã Ba Lế","path":"Xã Ba Lế, Huyện Ba Tơ, Tỉnh Quảng Ngãi","path_with_type":"Xã Ba Lế, Huyện Ba Tơ, Tỉnh Quảng Ngãi","code":"21532","parent_code":"535"},"21535":{"name":"Xã Ba Nam","type":"xa","slug":"xa-ba-nam","name_with_type":"Xã Ba Nam","path":"Xã Ba Nam, Huyện Ba Tơ, Tỉnh Quảng Ngãi","path_with_type":"Xã Ba Nam, Huyện Ba Tơ, Tỉnh Quảng Ngãi","code":"21535","parent_code":"535"},"21538":{"name":"Xã Ba Xa","type":"xa","slug":"xa-ba-xa","name_with_type":"Xã Ba Xa","path":"Xã Ba Xa, Huyện Ba Tơ, Tỉnh Quảng Ngãi","path_with_type":"Xã Ba Xa, Huyện Ba Tơ, Tỉnh Quảng Ngãi","code":"21538","parent_code":"535"},"21550":{"name":"Phường Nhơn Bình","type":"phuong","slug":"phuong-nhon-binh","name_with_type":"Phường Nhơn Bình","path":"Phường Nhơn Bình, Thành phố Quy Nhơn, Tỉnh Bình Định","path_with_type":"Phường Nhơn Bình, Thành phố Quy Nhơn, Tỉnh Bình Định","code":"21550","parent_code":"540"},"21553":{"name":"Phường Nhơn Phú","type":"phuong","slug":"phuong-nhon-phu","name_with_type":"Phường Nhơn Phú","path":"Phường Nhơn Phú, Thành phố Quy Nhơn, Tỉnh Bình Định","path_with_type":"Phường Nhơn Phú, Thành phố Quy Nhơn, Tỉnh Bình Định","code":"21553","parent_code":"540"},"21556":{"name":"Phường Đống Đa","type":"phuong","slug":"phuong-dong-da","name_with_type":"Phường Đống Đa","path":"Phường Đống Đa, Thành phố Quy Nhơn, Tỉnh Bình Định","path_with_type":"Phường Đống Đa, Thành phố Quy Nhơn, Tỉnh Bình Định","code":"21556","parent_code":"540"},"21559":{"name":"Phường Trần Quang Diệu","type":"phuong","slug":"phuong-tran-quang-dieu","name_with_type":"Phường Trần Quang Diệu","path":"Phường Trần Quang Diệu, Thành phố Quy Nhơn, Tỉnh Bình Định","path_with_type":"Phường Trần Quang Diệu, Thành phố Quy Nhơn, Tỉnh Bình Định","code":"21559","parent_code":"540"},"21562":{"name":"Phường Hải Cảng","type":"phuong","slug":"phuong-hai-cang","name_with_type":"Phường Hải Cảng","path":"Phường Hải Cảng, Thành phố Quy Nhơn, Tỉnh Bình Định","path_with_type":"Phường Hải Cảng, Thành phố Quy Nhơn, Tỉnh Bình Định","code":"21562","parent_code":"540"},"21565":{"name":"Phường Quang Trung","type":"phuong","slug":"phuong-quang-trung","name_with_type":"Phường Quang Trung","path":"Phường Quang Trung, Thành phố Quy Nhơn, Tỉnh Bình Định","path_with_type":"Phường Quang Trung, Thành phố Quy Nhơn, Tỉnh Bình Định","code":"21565","parent_code":"540"},"21577":{"name":"Phường Ngô Mây","type":"phuong","slug":"phuong-ngo-may","name_with_type":"Phường Ngô Mây","path":"Phường Ngô Mây, Thành phố Quy Nhơn, Tỉnh Bình Định","path_with_type":"Phường Ngô Mây, Thành phố Quy Nhơn, Tỉnh Bình Định","code":"21577","parent_code":"540"},"21580":{"name":"Phường Trần Phú","type":"phuong","slug":"phuong-tran-phu","name_with_type":"Phường Trần Phú","path":"Phường Trần Phú, Thành phố Quy Nhơn, Tỉnh Bình Định","path_with_type":"Phường Trần Phú, Thành phố Quy Nhơn, Tỉnh Bình Định","code":"21580","parent_code":"540"},"21583":{"name":"Phường Thị Nại","type":"phuong","slug":"phuong-thi-nai","name_with_type":"Phường Thị Nại","path":"Phường Thị Nại, Thành phố Quy Nhơn, Tỉnh Bình Định","path_with_type":"Phường Thị Nại, Thành phố Quy Nhơn, Tỉnh Bình Định","code":"21583","parent_code":"540"},"21589":{"name":"Phường Bùi Thị Xuân","type":"phuong","slug":"phuong-bui-thi-xuan","name_with_type":"Phường Bùi Thị Xuân","path":"Phường Bùi Thị Xuân, Thành phố Quy Nhơn, Tỉnh Bình Định","path_with_type":"Phường Bùi Thị Xuân, Thành phố Quy Nhơn, Tỉnh Bình Định","code":"21589","parent_code":"540"},"21592":{"name":"Phường Nguyễn Văn Cừ","type":"phuong","slug":"phuong-nguyen-van-cu","name_with_type":"Phường Nguyễn Văn Cừ","path":"Phường Nguyễn Văn Cừ, Thành phố Quy Nhơn, Tỉnh Bình Định","path_with_type":"Phường Nguyễn Văn Cừ, Thành phố Quy Nhơn, Tỉnh Bình Định","code":"21592","parent_code":"540"},"21595":{"name":"Phường Ghềnh Ráng","type":"phuong","slug":"phuong-ghenh-rang","name_with_type":"Phường Ghềnh Ráng","path":"Phường Ghềnh Ráng, Thành phố Quy Nhơn, Tỉnh Bình Định","path_with_type":"Phường Ghềnh Ráng, Thành phố Quy Nhơn, Tỉnh Bình Định","code":"21595","parent_code":"540"},"21598":{"name":"Xã Nhơn Lý","type":"xa","slug":"xa-nhon-ly","name_with_type":"Xã Nhơn Lý","path":"Xã Nhơn Lý, Thành phố Quy Nhơn, Tỉnh Bình Định","path_with_type":"Xã Nhơn Lý, Thành phố Quy Nhơn, Tỉnh Bình Định","code":"21598","parent_code":"540"},"21601":{"name":"Xã Nhơn Hội","type":"xa","slug":"xa-nhon-hoi","name_with_type":"Xã Nhơn Hội","path":"Xã Nhơn Hội, Thành phố Quy Nhơn, Tỉnh Bình Định","path_with_type":"Xã Nhơn Hội, Thành phố Quy Nhơn, Tỉnh Bình Định","code":"21601","parent_code":"540"},"21604":{"name":"Xã Nhơn Hải","type":"xa","slug":"xa-nhon-hai","name_with_type":"Xã Nhơn Hải","path":"Xã Nhơn Hải, Thành phố Quy Nhơn, Tỉnh Bình Định","path_with_type":"Xã Nhơn Hải, Thành phố Quy Nhơn, Tỉnh Bình Định","code":"21604","parent_code":"540"},"21607":{"name":"Xã Nhơn Châu","type":"xa","slug":"xa-nhon-chau","name_with_type":"Xã Nhơn Châu","path":"Xã Nhơn Châu, Thành phố Quy Nhơn, Tỉnh Bình Định","path_with_type":"Xã Nhơn Châu, Thành phố Quy Nhơn, Tỉnh Bình Định","code":"21607","parent_code":"540"},"21609":{"name":"Thị trấn An Lão","type":"thi-tran","slug":"thi-tran-an-lao","name_with_type":"Thị trấn An Lão","path":"Thị trấn An Lão, Huyện An Lão, Tỉnh Bình Định","path_with_type":"Thị trấn An Lão, Huyện An Lão, Tỉnh Bình Định","code":"21609","parent_code":"542"},"21610":{"name":"Xã An Hưng","type":"xa","slug":"xa-an-hung","name_with_type":"Xã An Hưng","path":"Xã An Hưng, Huyện An Lão, Tỉnh Bình Định","path_with_type":"Xã An Hưng, Huyện An Lão, Tỉnh Bình Định","code":"21610","parent_code":"542"},"21613":{"name":"Xã An Trung","type":"xa","slug":"xa-an-trung","name_with_type":"Xã An Trung","path":"Xã An Trung, Huyện An Lão, Tỉnh Bình Định","path_with_type":"Xã An Trung, Huyện An Lão, Tỉnh Bình Định","code":"21613","parent_code":"542"},"21616":{"name":"Xã An Dũng","type":"xa","slug":"xa-an-dung","name_with_type":"Xã An Dũng","path":"Xã An Dũng, Huyện An Lão, Tỉnh Bình Định","path_with_type":"Xã An Dũng, Huyện An Lão, Tỉnh Bình Định","code":"21616","parent_code":"542"},"21619":{"name":"Xã An Vinh","type":"xa","slug":"xa-an-vinh","name_with_type":"Xã An Vinh","path":"Xã An Vinh, Huyện An Lão, Tỉnh Bình Định","path_with_type":"Xã An Vinh, Huyện An Lão, Tỉnh Bình Định","code":"21619","parent_code":"542"},"21622":{"name":"Xã An Toàn","type":"xa","slug":"xa-an-toan","name_with_type":"Xã An Toàn","path":"Xã An Toàn, Huyện An Lão, Tỉnh Bình Định","path_with_type":"Xã An Toàn, Huyện An Lão, Tỉnh Bình Định","code":"21622","parent_code":"542"},"21625":{"name":"Xã An Tân","type":"xa","slug":"xa-an-tan","name_with_type":"Xã An Tân","path":"Xã An Tân, Huyện An Lão, Tỉnh Bình Định","path_with_type":"Xã An Tân, Huyện An Lão, Tỉnh Bình Định","code":"21625","parent_code":"542"},"21628":{"name":"Xã An Hòa","type":"xa","slug":"xa-an-hoa","name_with_type":"Xã An Hòa","path":"Xã An Hòa, Huyện An Lão, Tỉnh Bình Định","path_with_type":"Xã An Hòa, Huyện An Lão, Tỉnh Bình Định","code":"21628","parent_code":"542"},"21631":{"name":"Xã An Quang","type":"xa","slug":"xa-an-quang","name_with_type":"Xã An Quang","path":"Xã An Quang, Huyện An Lão, Tỉnh Bình Định","path_with_type":"Xã An Quang, Huyện An Lão, Tỉnh Bình Định","code":"21631","parent_code":"542"},"21634":{"name":"Xã An Nghĩa","type":"xa","slug":"xa-an-nghia","name_with_type":"Xã An Nghĩa","path":"Xã An Nghĩa, Huyện An Lão, Tỉnh Bình Định","path_with_type":"Xã An Nghĩa, Huyện An Lão, Tỉnh Bình Định","code":"21634","parent_code":"542"},"21637":{"name":"Phường Tam Quan","type":"phuong","slug":"phuong-tam-quan","name_with_type":"Phường Tam Quan","path":"Phường Tam Quan, Thị xã Hoài Nhơn, Tỉnh Bình Định","path_with_type":"Phường Tam Quan, Thị xã Hoài Nhơn, Tỉnh Bình Định","code":"21637","parent_code":"543"},"21640":{"name":"Phường Bồng Sơn","type":"phuong","slug":"phuong-bong-son","name_with_type":"Phường Bồng Sơn","path":"Phường Bồng Sơn, Thị xã Hoài Nhơn, Tỉnh Bình Định","path_with_type":"Phường Bồng Sơn, Thị xã Hoài Nhơn, Tỉnh Bình Định","code":"21640","parent_code":"543"},"21643":{"name":"Xã Hoài Sơn","type":"xa","slug":"xa-hoai-son","name_with_type":"Xã Hoài Sơn","path":"Xã Hoài Sơn, Thị xã Hoài Nhơn, Tỉnh Bình Định","path_with_type":"Xã Hoài Sơn, Thị xã Hoài Nhơn, Tỉnh Bình Định","code":"21643","parent_code":"543"},"21646":{"name":"Xã Hoài Châu Bắc","type":"xa","slug":"xa-hoai-chau-bac","name_with_type":"Xã Hoài Châu Bắc","path":"Xã Hoài Châu Bắc, Thị xã Hoài Nhơn, Tỉnh Bình Định","path_with_type":"Xã Hoài Châu Bắc, Thị xã Hoài Nhơn, Tỉnh Bình Định","code":"21646","parent_code":"543"},"21649":{"name":"Xã Hoài Châu","type":"xa","slug":"xa-hoai-chau","name_with_type":"Xã Hoài Châu","path":"Xã Hoài Châu, Thị xã Hoài Nhơn, Tỉnh Bình Định","path_with_type":"Xã Hoài Châu, Thị xã Hoài Nhơn, Tỉnh Bình Định","code":"21649","parent_code":"543"},"21652":{"name":"Xã Hoài Phú","type":"xa","slug":"xa-hoai-phu","name_with_type":"Xã Hoài Phú","path":"Xã Hoài Phú, Thị xã Hoài Nhơn, Tỉnh Bình Định","path_with_type":"Xã Hoài Phú, Thị xã Hoài Nhơn, Tỉnh Bình Định","code":"21652","parent_code":"543"},"21655":{"name":"Phường Tam Quan Bắc","type":"phuong","slug":"phuong-tam-quan-bac","name_with_type":"Phường Tam Quan Bắc","path":"Phường Tam Quan Bắc, Thị xã Hoài Nhơn, Tỉnh Bình Định","path_with_type":"Phường Tam Quan Bắc, Thị xã Hoài Nhơn, Tỉnh Bình Định","code":"21655","parent_code":"543"},"21658":{"name":"Phường Tam Quan Nam","type":"phuong","slug":"phuong-tam-quan-nam","name_with_type":"Phường Tam Quan Nam","path":"Phường Tam Quan Nam, Thị xã Hoài Nhơn, Tỉnh Bình Định","path_with_type":"Phường Tam Quan Nam, Thị xã Hoài Nhơn, Tỉnh Bình Định","code":"21658","parent_code":"543"},"21661":{"name":"Phường Hoài Hảo","type":"phuong","slug":"phuong-hoai-hao","name_with_type":"Phường Hoài Hảo","path":"Phường Hoài Hảo, Thị xã Hoài Nhơn, Tỉnh Bình Định","path_with_type":"Phường Hoài Hảo, Thị xã Hoài Nhơn, Tỉnh Bình Định","code":"21661","parent_code":"543"},"21664":{"name":"Phường Hoài Thanh Tây","type":"phuong","slug":"phuong-hoai-thanh-tay","name_with_type":"Phường Hoài Thanh Tây","path":"Phường Hoài Thanh Tây, Thị xã Hoài Nhơn, Tỉnh Bình Định","path_with_type":"Phường Hoài Thanh Tây, Thị xã Hoài Nhơn, Tỉnh Bình Định","code":"21664","parent_code":"543"},"21667":{"name":"Phường Hoài Thanh","type":"phuong","slug":"phuong-hoai-thanh","name_with_type":"Phường Hoài Thanh","path":"Phường Hoài Thanh, Thị xã Hoài Nhơn, Tỉnh Bình Định","path_with_type":"Phường Hoài Thanh, Thị xã Hoài Nhơn, Tỉnh Bình Định","code":"21667","parent_code":"543"},"21670":{"name":"Phường Hoài Hương","type":"phuong","slug":"phuong-hoai-huong","name_with_type":"Phường Hoài Hương","path":"Phường Hoài Hương, Thị xã Hoài Nhơn, Tỉnh Bình Định","path_with_type":"Phường Hoài Hương, Thị xã Hoài Nhơn, Tỉnh Bình Định","code":"21670","parent_code":"543"},"21673":{"name":"Phường Hoài Tân","type":"phuong","slug":"phuong-hoai-tan","name_with_type":"Phường Hoài Tân","path":"Phường Hoài Tân, Thị xã Hoài Nhơn, Tỉnh Bình Định","path_with_type":"Phường Hoài Tân, Thị xã Hoài Nhơn, Tỉnh Bình Định","code":"21673","parent_code":"543"},"21676":{"name":"Xã Hoài Hải","type":"xa","slug":"xa-hoai-hai","name_with_type":"Xã Hoài Hải","path":"Xã Hoài Hải, Thị xã Hoài Nhơn, Tỉnh Bình Định","path_with_type":"Xã Hoài Hải, Thị xã Hoài Nhơn, Tỉnh Bình Định","code":"21676","parent_code":"543"},"21679":{"name":"Phường Hoài Xuân","type":"phuong","slug":"phuong-hoai-xuan","name_with_type":"Phường Hoài Xuân","path":"Phường Hoài Xuân, Thị xã Hoài Nhơn, Tỉnh Bình Định","path_with_type":"Phường Hoài Xuân, Thị xã Hoài Nhơn, Tỉnh Bình Định","code":"21679","parent_code":"543"},"21682":{"name":"Xã Hoài Mỹ","type":"xa","slug":"xa-hoai-my","name_with_type":"Xã Hoài Mỹ","path":"Xã Hoài Mỹ, Thị xã Hoài Nhơn, Tỉnh Bình Định","path_with_type":"Xã Hoài Mỹ, Thị xã Hoài Nhơn, Tỉnh Bình Định","code":"21682","parent_code":"543"},"21685":{"name":"Phường Hoài Đức","type":"phuong","slug":"phuong-hoai-duc","name_with_type":"Phường Hoài Đức","path":"Phường Hoài Đức, Thị xã Hoài Nhơn, Tỉnh Bình Định","path_with_type":"Phường Hoài Đức, Thị xã Hoài Nhơn, Tỉnh Bình Định","code":"21685","parent_code":"543"},"21688":{"name":"Thị trấn Tăng Bạt Hổ","type":"thi-tran","slug":"thi-tran-tang-bat-ho","name_with_type":"Thị trấn Tăng Bạt Hổ","path":"Thị trấn Tăng Bạt Hổ, Huyện Hoài Ân, Tỉnh Bình Định","path_with_type":"Thị trấn Tăng Bạt Hổ, Huyện Hoài Ân, Tỉnh Bình Định","code":"21688","parent_code":"544"},"21690":{"name":"Xã Ân Hảo Tây","type":"xa","slug":"xa-an-hao-tay","name_with_type":"Xã Ân Hảo Tây","path":"Xã Ân Hảo Tây, Huyện Hoài Ân, Tỉnh Bình Định","path_with_type":"Xã Ân Hảo Tây, Huyện Hoài Ân, Tỉnh Bình Định","code":"21690","parent_code":"544"},"21691":{"name":"Xã Ân Hảo Đông","type":"xa","slug":"xa-an-hao-dong","name_with_type":"Xã Ân Hảo Đông","path":"Xã Ân Hảo Đông, Huyện Hoài Ân, Tỉnh Bình Định","path_with_type":"Xã Ân Hảo Đông, Huyện Hoài Ân, Tỉnh Bình Định","code":"21691","parent_code":"544"},"21694":{"name":"Xã Ân Sơn","type":"xa","slug":"xa-an-son","name_with_type":"Xã Ân Sơn","path":"Xã Ân Sơn, Huyện Hoài Ân, Tỉnh Bình Định","path_with_type":"Xã Ân Sơn, Huyện Hoài Ân, Tỉnh Bình Định","code":"21694","parent_code":"544"},"21697":{"name":"Xã Ân Mỹ","type":"xa","slug":"xa-an-my","name_with_type":"Xã Ân Mỹ","path":"Xã Ân Mỹ, Huyện Hoài Ân, Tỉnh Bình Định","path_with_type":"Xã Ân Mỹ, Huyện Hoài Ân, Tỉnh Bình Định","code":"21697","parent_code":"544"},"21700":{"name":"Xã Đak Mang","type":"xa","slug":"xa-dak-mang","name_with_type":"Xã Đak Mang","path":"Xã Đak Mang, Huyện Hoài Ân, Tỉnh Bình Định","path_with_type":"Xã Đak Mang, Huyện Hoài Ân, Tỉnh Bình Định","code":"21700","parent_code":"544"},"21703":{"name":"Xã Ân Tín","type":"xa","slug":"xa-an-tin","name_with_type":"Xã Ân Tín","path":"Xã Ân Tín, Huyện Hoài Ân, Tỉnh Bình Định","path_with_type":"Xã Ân Tín, Huyện Hoài Ân, Tỉnh Bình Định","code":"21703","parent_code":"544"},"21706":{"name":"Xã Ân Thạnh","type":"xa","slug":"xa-an-thanh","name_with_type":"Xã Ân Thạnh","path":"Xã Ân Thạnh, Huyện Hoài Ân, Tỉnh Bình Định","path_with_type":"Xã Ân Thạnh, Huyện Hoài Ân, Tỉnh Bình Định","code":"21706","parent_code":"544"},"21709":{"name":"Xã Ân Phong","type":"xa","slug":"xa-an-phong","name_with_type":"Xã Ân Phong","path":"Xã Ân Phong, Huyện Hoài Ân, Tỉnh Bình Định","path_with_type":"Xã Ân Phong, Huyện Hoài Ân, Tỉnh Bình Định","code":"21709","parent_code":"544"},"21712":{"name":"Xã Ân Đức","type":"xa","slug":"xa-an-duc","name_with_type":"Xã Ân Đức","path":"Xã Ân Đức, Huyện Hoài Ân, Tỉnh Bình Định","path_with_type":"Xã Ân Đức, Huyện Hoài Ân, Tỉnh Bình Định","code":"21712","parent_code":"544"},"21715":{"name":"Xã Ân Hữu","type":"xa","slug":"xa-an-huu","name_with_type":"Xã Ân Hữu","path":"Xã Ân Hữu, Huyện Hoài Ân, Tỉnh Bình Định","path_with_type":"Xã Ân Hữu, Huyện Hoài Ân, Tỉnh Bình Định","code":"21715","parent_code":"544"},"21718":{"name":"Xã Bok Tới","type":"xa","slug":"xa-bok-toi","name_with_type":"Xã Bok Tới","path":"Xã Bok Tới, Huyện Hoài Ân, Tỉnh Bình Định","path_with_type":"Xã Bok Tới, Huyện Hoài Ân, Tỉnh Bình Định","code":"21718","parent_code":"544"},"21721":{"name":"Xã Ân Tường Tây","type":"xa","slug":"xa-an-tuong-tay","name_with_type":"Xã Ân Tường Tây","path":"Xã Ân Tường Tây, Huyện Hoài Ân, Tỉnh Bình Định","path_with_type":"Xã Ân Tường Tây, Huyện Hoài Ân, Tỉnh Bình Định","code":"21721","parent_code":"544"},"21724":{"name":"Xã Ân Tường Đông","type":"xa","slug":"xa-an-tuong-dong","name_with_type":"Xã Ân Tường Đông","path":"Xã Ân Tường Đông, Huyện Hoài Ân, Tỉnh Bình Định","path_with_type":"Xã Ân Tường Đông, Huyện Hoài Ân, Tỉnh Bình Định","code":"21724","parent_code":"544"},"21727":{"name":"Xã Ân Nghĩa","type":"xa","slug":"xa-an-nghia","name_with_type":"Xã Ân Nghĩa","path":"Xã Ân Nghĩa, Huyện Hoài Ân, Tỉnh Bình Định","path_with_type":"Xã Ân Nghĩa, Huyện Hoài Ân, Tỉnh Bình Định","code":"21727","parent_code":"544"},"21730":{"name":"Thị trấn Phù Mỹ","type":"thi-tran","slug":"thi-tran-phu-my","name_with_type":"Thị trấn Phù Mỹ","path":"Thị trấn Phù Mỹ, Huyện Phù Mỹ, Tỉnh Bình Định","path_with_type":"Thị trấn Phù Mỹ, Huyện Phù Mỹ, Tỉnh Bình Định","code":"21730","parent_code":"545"},"21733":{"name":"Thị trấn Bình Dương","type":"thi-tran","slug":"thi-tran-binh-duong","name_with_type":"Thị trấn Bình Dương","path":"Thị trấn Bình Dương, Huyện Phù Mỹ, Tỉnh Bình Định","path_with_type":"Thị trấn Bình Dương, Huyện Phù Mỹ, Tỉnh Bình Định","code":"21733","parent_code":"545"},"21736":{"name":"Xã Mỹ Đức","type":"xa","slug":"xa-my-duc","name_with_type":"Xã Mỹ Đức","path":"Xã Mỹ Đức, Huyện Phù Mỹ, Tỉnh Bình Định","path_with_type":"Xã Mỹ Đức, Huyện Phù Mỹ, Tỉnh Bình Định","code":"21736","parent_code":"545"},"21739":{"name":"Xã Mỹ Châu","type":"xa","slug":"xa-my-chau","name_with_type":"Xã Mỹ Châu","path":"Xã Mỹ Châu, Huyện Phù Mỹ, Tỉnh Bình Định","path_with_type":"Xã Mỹ Châu, Huyện Phù Mỹ, Tỉnh Bình Định","code":"21739","parent_code":"545"},"21742":{"name":"Xã Mỹ Thắng","type":"xa","slug":"xa-my-thang","name_with_type":"Xã Mỹ Thắng","path":"Xã Mỹ Thắng, Huyện Phù Mỹ, Tỉnh Bình Định","path_with_type":"Xã Mỹ Thắng, Huyện Phù Mỹ, Tỉnh Bình Định","code":"21742","parent_code":"545"},"21745":{"name":"Xã Mỹ Lộc","type":"xa","slug":"xa-my-loc","name_with_type":"Xã Mỹ Lộc","path":"Xã Mỹ Lộc, Huyện Phù Mỹ, Tỉnh Bình Định","path_with_type":"Xã Mỹ Lộc, Huyện Phù Mỹ, Tỉnh Bình Định","code":"21745","parent_code":"545"},"21748":{"name":"Xã Mỹ Lợi","type":"xa","slug":"xa-my-loi","name_with_type":"Xã Mỹ Lợi","path":"Xã Mỹ Lợi, Huyện Phù Mỹ, Tỉnh Bình Định","path_with_type":"Xã Mỹ Lợi, Huyện Phù Mỹ, Tỉnh Bình Định","code":"21748","parent_code":"545"},"21751":{"name":"Xã Mỹ An","type":"xa","slug":"xa-my-an","name_with_type":"Xã Mỹ An","path":"Xã Mỹ An, Huyện Phù Mỹ, Tỉnh Bình Định","path_with_type":"Xã Mỹ An, Huyện Phù Mỹ, Tỉnh Bình Định","code":"21751","parent_code":"545"},"21754":{"name":"Xã Mỹ Phong","type":"xa","slug":"xa-my-phong","name_with_type":"Xã Mỹ Phong","path":"Xã Mỹ Phong, Huyện Phù Mỹ, Tỉnh Bình Định","path_with_type":"Xã Mỹ Phong, Huyện Phù Mỹ, Tỉnh Bình Định","code":"21754","parent_code":"545"},"21757":{"name":"Xã Mỹ Trinh","type":"xa","slug":"xa-my-trinh","name_with_type":"Xã Mỹ Trinh","path":"Xã Mỹ Trinh, Huyện Phù Mỹ, Tỉnh Bình Định","path_with_type":"Xã Mỹ Trinh, Huyện Phù Mỹ, Tỉnh Bình Định","code":"21757","parent_code":"545"},"21760":{"name":"Xã Mỹ Thọ","type":"xa","slug":"xa-my-tho","name_with_type":"Xã Mỹ Thọ","path":"Xã Mỹ Thọ, Huyện Phù Mỹ, Tỉnh Bình Định","path_with_type":"Xã Mỹ Thọ, Huyện Phù Mỹ, Tỉnh Bình Định","code":"21760","parent_code":"545"},"21763":{"name":"Xã Mỹ Hòa","type":"xa","slug":"xa-my-hoa","name_with_type":"Xã Mỹ Hòa","path":"Xã Mỹ Hòa, Huyện Phù Mỹ, Tỉnh Bình Định","path_with_type":"Xã Mỹ Hòa, Huyện Phù Mỹ, Tỉnh Bình Định","code":"21763","parent_code":"545"},"21766":{"name":"Xã Mỹ Thành","type":"xa","slug":"xa-my-thanh","name_with_type":"Xã Mỹ Thành","path":"Xã Mỹ Thành, Huyện Phù Mỹ, Tỉnh Bình Định","path_with_type":"Xã Mỹ Thành, Huyện Phù Mỹ, Tỉnh Bình Định","code":"21766","parent_code":"545"},"21769":{"name":"Xã Mỹ Chánh","type":"xa","slug":"xa-my-chanh","name_with_type":"Xã Mỹ Chánh","path":"Xã Mỹ Chánh, Huyện Phù Mỹ, Tỉnh Bình Định","path_with_type":"Xã Mỹ Chánh, Huyện Phù Mỹ, Tỉnh Bình Định","code":"21769","parent_code":"545"},"21772":{"name":"Xã Mỹ Quang","type":"xa","slug":"xa-my-quang","name_with_type":"Xã Mỹ Quang","path":"Xã Mỹ Quang, Huyện Phù Mỹ, Tỉnh Bình Định","path_with_type":"Xã Mỹ Quang, Huyện Phù Mỹ, Tỉnh Bình Định","code":"21772","parent_code":"545"},"21775":{"name":"Xã Mỹ Hiệp","type":"xa","slug":"xa-my-hiep","name_with_type":"Xã Mỹ Hiệp","path":"Xã Mỹ Hiệp, Huyện Phù Mỹ, Tỉnh Bình Định","path_with_type":"Xã Mỹ Hiệp, Huyện Phù Mỹ, Tỉnh Bình Định","code":"21775","parent_code":"545"},"21778":{"name":"Xã Mỹ Tài","type":"xa","slug":"xa-my-tai","name_with_type":"Xã Mỹ Tài","path":"Xã Mỹ Tài, Huyện Phù Mỹ, Tỉnh Bình Định","path_with_type":"Xã Mỹ Tài, Huyện Phù Mỹ, Tỉnh Bình Định","code":"21778","parent_code":"545"},"21781":{"name":"Xã Mỹ Cát","type":"xa","slug":"xa-my-cat","name_with_type":"Xã Mỹ Cát","path":"Xã Mỹ Cát, Huyện Phù Mỹ, Tỉnh Bình Định","path_with_type":"Xã Mỹ Cát, Huyện Phù Mỹ, Tỉnh Bình Định","code":"21781","parent_code":"545"},"21784":{"name":"Xã Mỹ Chánh Tây","type":"xa","slug":"xa-my-chanh-tay","name_with_type":"Xã Mỹ Chánh Tây","path":"Xã Mỹ Chánh Tây, Huyện Phù Mỹ, Tỉnh Bình Định","path_with_type":"Xã Mỹ Chánh Tây, Huyện Phù Mỹ, Tỉnh Bình Định","code":"21784","parent_code":"545"},"21786":{"name":"Thị trấn Vĩnh Thạnh","type":"thi-tran","slug":"thi-tran-vinh-thanh","name_with_type":"Thị trấn Vĩnh Thạnh","path":"Thị trấn Vĩnh Thạnh, Huyện Vĩnh Thạnh, Tỉnh Bình Định","path_with_type":"Thị trấn Vĩnh Thạnh, Huyện Vĩnh Thạnh, Tỉnh Bình Định","code":"21786","parent_code":"546"},"21787":{"name":"Xã Vĩnh Sơn","type":"xa","slug":"xa-vinh-son","name_with_type":"Xã Vĩnh Sơn","path":"Xã Vĩnh Sơn, Huyện Vĩnh Thạnh, Tỉnh Bình Định","path_with_type":"Xã Vĩnh Sơn, Huyện Vĩnh Thạnh, Tỉnh Bình Định","code":"21787","parent_code":"546"},"21790":{"name":"Xã Vĩnh Kim","type":"xa","slug":"xa-vinh-kim","name_with_type":"Xã Vĩnh Kim","path":"Xã Vĩnh Kim, Huyện Vĩnh Thạnh, Tỉnh Bình Định","path_with_type":"Xã Vĩnh Kim, Huyện Vĩnh Thạnh, Tỉnh Bình Định","code":"21790","parent_code":"546"},"21796":{"name":"Xã Vĩnh Hiệp","type":"xa","slug":"xa-vinh-hiep","name_with_type":"Xã Vĩnh Hiệp","path":"Xã Vĩnh Hiệp, Huyện Vĩnh Thạnh, Tỉnh Bình Định","path_with_type":"Xã Vĩnh Hiệp, Huyện Vĩnh Thạnh, Tỉnh Bình Định","code":"21796","parent_code":"546"},"21799":{"name":"Xã Vĩnh Hảo","type":"xa","slug":"xa-vinh-hao","name_with_type":"Xã Vĩnh Hảo","path":"Xã Vĩnh Hảo, Huyện Vĩnh Thạnh, Tỉnh Bình Định","path_with_type":"Xã Vĩnh Hảo, Huyện Vĩnh Thạnh, Tỉnh Bình Định","code":"21799","parent_code":"546"},"21801":{"name":"Xã Vĩnh Hòa","type":"xa","slug":"xa-vinh-hoa","name_with_type":"Xã Vĩnh Hòa","path":"Xã Vĩnh Hòa, Huyện Vĩnh Thạnh, Tỉnh Bình Định","path_with_type":"Xã Vĩnh Hòa, Huyện Vĩnh Thạnh, Tỉnh Bình Định","code":"21801","parent_code":"546"},"21802":{"name":"Xã Vĩnh Thịnh","type":"xa","slug":"xa-vinh-thinh","name_with_type":"Xã Vĩnh Thịnh","path":"Xã Vĩnh Thịnh, Huyện Vĩnh Thạnh, Tỉnh Bình Định","path_with_type":"Xã Vĩnh Thịnh, Huyện Vĩnh Thạnh, Tỉnh Bình Định","code":"21802","parent_code":"546"},"21804":{"name":"Xã Vĩnh Thuận","type":"xa","slug":"xa-vinh-thuan","name_with_type":"Xã Vĩnh Thuận","path":"Xã Vĩnh Thuận, Huyện Vĩnh Thạnh, Tỉnh Bình Định","path_with_type":"Xã Vĩnh Thuận, Huyện Vĩnh Thạnh, Tỉnh Bình Định","code":"21804","parent_code":"546"},"21805":{"name":"Xã Vĩnh Quang","type":"xa","slug":"xa-vinh-quang","name_with_type":"Xã Vĩnh Quang","path":"Xã Vĩnh Quang, Huyện Vĩnh Thạnh, Tỉnh Bình Định","path_with_type":"Xã Vĩnh Quang, Huyện Vĩnh Thạnh, Tỉnh Bình Định","code":"21805","parent_code":"546"},"21808":{"name":"Thị trấn Phú Phong","type":"thi-tran","slug":"thi-tran-phu-phong","name_with_type":"Thị trấn Phú Phong","path":"Thị trấn Phú Phong, Huyện Tây Sơn, Tỉnh Bình Định","path_with_type":"Thị trấn Phú Phong, Huyện Tây Sơn, Tỉnh Bình Định","code":"21808","parent_code":"547"},"21811":{"name":"Xã Bình Tân","type":"xa","slug":"xa-binh-tan","name_with_type":"Xã Bình Tân","path":"Xã Bình Tân, Huyện Tây Sơn, Tỉnh Bình Định","path_with_type":"Xã Bình Tân, Huyện Tây Sơn, Tỉnh Bình Định","code":"21811","parent_code":"547"},"21814":{"name":"Xã Tây Thuận","type":"xa","slug":"xa-tay-thuan","name_with_type":"Xã Tây Thuận","path":"Xã Tây Thuận, Huyện Tây Sơn, Tỉnh Bình Định","path_with_type":"Xã Tây Thuận, Huyện Tây Sơn, Tỉnh Bình Định","code":"21814","parent_code":"547"},"21817":{"name":"Xã Bình Thuận","type":"xa","slug":"xa-binh-thuan","name_with_type":"Xã Bình Thuận","path":"Xã Bình Thuận, Huyện Tây Sơn, Tỉnh Bình Định","path_with_type":"Xã Bình Thuận, Huyện Tây Sơn, Tỉnh Bình Định","code":"21817","parent_code":"547"},"21820":{"name":"Xã Tây Giang","type":"xa","slug":"xa-tay-giang","name_with_type":"Xã Tây Giang","path":"Xã Tây Giang, Huyện Tây Sơn, Tỉnh Bình Định","path_with_type":"Xã Tây Giang, Huyện Tây Sơn, Tỉnh Bình Định","code":"21820","parent_code":"547"},"21823":{"name":"Xã Bình Thành","type":"xa","slug":"xa-binh-thanh","name_with_type":"Xã Bình Thành","path":"Xã Bình Thành, Huyện Tây Sơn, Tỉnh Bình Định","path_with_type":"Xã Bình Thành, Huyện Tây Sơn, Tỉnh Bình Định","code":"21823","parent_code":"547"},"21826":{"name":"Xã Tây An","type":"xa","slug":"xa-tay-an","name_with_type":"Xã Tây An","path":"Xã Tây An, Huyện Tây Sơn, Tỉnh Bình Định","path_with_type":"Xã Tây An, Huyện Tây Sơn, Tỉnh Bình Định","code":"21826","parent_code":"547"},"21829":{"name":"Xã Bình Hòa","type":"xa","slug":"xa-binh-hoa","name_with_type":"Xã Bình Hòa","path":"Xã Bình Hòa, Huyện Tây Sơn, Tỉnh Bình Định","path_with_type":"Xã Bình Hòa, Huyện Tây Sơn, Tỉnh Bình Định","code":"21829","parent_code":"547"},"21832":{"name":"Xã Tây Bình","type":"xa","slug":"xa-tay-binh","name_with_type":"Xã Tây Bình","path":"Xã Tây Bình, Huyện Tây Sơn, Tỉnh Bình Định","path_with_type":"Xã Tây Bình, Huyện Tây Sơn, Tỉnh Bình Định","code":"21832","parent_code":"547"},"21835":{"name":"Xã Bình Tường","type":"xa","slug":"xa-binh-tuong","name_with_type":"Xã Bình Tường","path":"Xã Bình Tường, Huyện Tây Sơn, Tỉnh Bình Định","path_with_type":"Xã Bình Tường, Huyện Tây Sơn, Tỉnh Bình Định","code":"21835","parent_code":"547"},"21838":{"name":"Xã Tây Vinh","type":"xa","slug":"xa-tay-vinh","name_with_type":"Xã Tây Vinh","path":"Xã Tây Vinh, Huyện Tây Sơn, Tỉnh Bình Định","path_with_type":"Xã Tây Vinh, Huyện Tây Sơn, Tỉnh Bình Định","code":"21838","parent_code":"547"},"21841":{"name":"Xã Vĩnh An","type":"xa","slug":"xa-vinh-an","name_with_type":"Xã Vĩnh An","path":"Xã Vĩnh An, Huyện Tây Sơn, Tỉnh Bình Định","path_with_type":"Xã Vĩnh An, Huyện Tây Sơn, Tỉnh Bình Định","code":"21841","parent_code":"547"},"21844":{"name":"Xã Tây Xuân","type":"xa","slug":"xa-tay-xuan","name_with_type":"Xã Tây Xuân","path":"Xã Tây Xuân, Huyện Tây Sơn, Tỉnh Bình Định","path_with_type":"Xã Tây Xuân, Huyện Tây Sơn, Tỉnh Bình Định","code":"21844","parent_code":"547"},"21847":{"name":"Xã Bình Nghi","type":"xa","slug":"xa-binh-nghi","name_with_type":"Xã Bình Nghi","path":"Xã Bình Nghi, Huyện Tây Sơn, Tỉnh Bình Định","path_with_type":"Xã Bình Nghi, Huyện Tây Sơn, Tỉnh Bình Định","code":"21847","parent_code":"547"},"21850":{"name":"Xã Tây Phú","type":"xa","slug":"xa-tay-phu","name_with_type":"Xã Tây Phú","path":"Xã Tây Phú, Huyện Tây Sơn, Tỉnh Bình Định","path_with_type":"Xã Tây Phú, Huyện Tây Sơn, Tỉnh Bình Định","code":"21850","parent_code":"547"},"21853":{"name":"Thị trấn Ngô Mây","type":"thi-tran","slug":"thi-tran-ngo-may","name_with_type":"Thị trấn Ngô Mây","path":"Thị trấn Ngô Mây, Huyện Phù Cát, Tỉnh Bình Định","path_with_type":"Thị trấn Ngô Mây, Huyện Phù Cát, Tỉnh Bình Định","code":"21853","parent_code":"548"},"21856":{"name":"Xã Cát Sơn","type":"xa","slug":"xa-cat-son","name_with_type":"Xã Cát Sơn","path":"Xã Cát Sơn, Huyện Phù Cát, Tỉnh Bình Định","path_with_type":"Xã Cát Sơn, Huyện Phù Cát, Tỉnh Bình Định","code":"21856","parent_code":"548"},"21859":{"name":"Xã Cát Minh","type":"xa","slug":"xa-cat-minh","name_with_type":"Xã Cát Minh","path":"Xã Cát Minh, Huyện Phù Cát, Tỉnh Bình Định","path_with_type":"Xã Cát Minh, Huyện Phù Cát, Tỉnh Bình Định","code":"21859","parent_code":"548"},"21862":{"name":"Thị trấn Cát Khánh","type":"thi-tran","slug":"thi-tran-cat-khanh","name_with_type":"Thị trấn Cát Khánh","path":"Thị trấn Cát Khánh, Huyện Phù Cát, Tỉnh Bình Định","path_with_type":"Thị trấn Cát Khánh, Huyện Phù Cát, Tỉnh Bình Định","code":"21862","parent_code":"548"},"21865":{"name":"Xã Cát Tài","type":"xa","slug":"xa-cat-tai","name_with_type":"Xã Cát Tài","path":"Xã Cát Tài, Huyện Phù Cát, Tỉnh Bình Định","path_with_type":"Xã Cát Tài, Huyện Phù Cát, Tỉnh Bình Định","code":"21865","parent_code":"548"},"21868":{"name":"Xã Cát Lâm","type":"xa","slug":"xa-cat-lam","name_with_type":"Xã Cát Lâm","path":"Xã Cát Lâm, Huyện Phù Cát, Tỉnh Bình Định","path_with_type":"Xã Cát Lâm, Huyện Phù Cát, Tỉnh Bình Định","code":"21868","parent_code":"548"},"21871":{"name":"Xã Cát Hanh","type":"xa","slug":"xa-cat-hanh","name_with_type":"Xã Cát Hanh","path":"Xã Cát Hanh, Huyện Phù Cát, Tỉnh Bình Định","path_with_type":"Xã Cát Hanh, Huyện Phù Cát, Tỉnh Bình Định","code":"21871","parent_code":"548"},"21874":{"name":"Xã Cát Thành","type":"xa","slug":"xa-cat-thanh","name_with_type":"Xã Cát Thành","path":"Xã Cát Thành, Huyện Phù Cát, Tỉnh Bình Định","path_with_type":"Xã Cát Thành, Huyện Phù Cát, Tỉnh Bình Định","code":"21874","parent_code":"548"},"21877":{"name":"Xã Cát Trinh","type":"xa","slug":"xa-cat-trinh","name_with_type":"Xã Cát Trinh","path":"Xã Cát Trinh, Huyện Phù Cát, Tỉnh Bình Định","path_with_type":"Xã Cát Trinh, Huyện Phù Cát, Tỉnh Bình Định","code":"21877","parent_code":"548"},"21880":{"name":"Xã Cát Hải","type":"xa","slug":"xa-cat-hai","name_with_type":"Xã Cát Hải","path":"Xã Cát Hải, Huyện Phù Cát, Tỉnh Bình Định","path_with_type":"Xã Cát Hải, Huyện Phù Cát, Tỉnh Bình Định","code":"21880","parent_code":"548"},"21883":{"name":"Xã Cát Hiệp","type":"xa","slug":"xa-cat-hiep","name_with_type":"Xã Cát Hiệp","path":"Xã Cát Hiệp, Huyện Phù Cát, Tỉnh Bình Định","path_with_type":"Xã Cát Hiệp, Huyện Phù Cát, Tỉnh Bình Định","code":"21883","parent_code":"548"},"21886":{"name":"Xã Cát Nhơn","type":"xa","slug":"xa-cat-nhon","name_with_type":"Xã Cát Nhơn","path":"Xã Cát Nhơn, Huyện Phù Cát, Tỉnh Bình Định","path_with_type":"Xã Cát Nhơn, Huyện Phù Cát, Tỉnh Bình Định","code":"21886","parent_code":"548"},"21889":{"name":"Xã Cát Hưng","type":"xa","slug":"xa-cat-hung","name_with_type":"Xã Cát Hưng","path":"Xã Cát Hưng, Huyện Phù Cát, Tỉnh Bình Định","path_with_type":"Xã Cát Hưng, Huyện Phù Cát, Tỉnh Bình Định","code":"21889","parent_code":"548"},"21892":{"name":"Xã Cát Tường","type":"xa","slug":"xa-cat-tuong","name_with_type":"Xã Cát Tường","path":"Xã Cát Tường, Huyện Phù Cát, Tỉnh Bình Định","path_with_type":"Xã Cát Tường, Huyện Phù Cát, Tỉnh Bình Định","code":"21892","parent_code":"548"},"21895":{"name":"Xã Cát Tân","type":"xa","slug":"xa-cat-tan","name_with_type":"Xã Cát Tân","path":"Xã Cát Tân, Huyện Phù Cát, Tỉnh Bình Định","path_with_type":"Xã Cát Tân, Huyện Phù Cát, Tỉnh Bình Định","code":"21895","parent_code":"548"},"21898":{"name":"Thị trấn Cát Tiến","type":"thi-tran","slug":"thi-tran-cat-tien","name_with_type":"Thị trấn Cát Tiến","path":"Thị trấn Cát Tiến, Huyện Phù Cát, Tỉnh Bình Định","path_with_type":"Thị trấn Cát Tiến, Huyện Phù Cát, Tỉnh Bình Định","code":"21898","parent_code":"548"},"21901":{"name":"Xã Cát Thắng","type":"xa","slug":"xa-cat-thang","name_with_type":"Xã Cát Thắng","path":"Xã Cát Thắng, Huyện Phù Cát, Tỉnh Bình Định","path_with_type":"Xã Cát Thắng, Huyện Phù Cát, Tỉnh Bình Định","code":"21901","parent_code":"548"},"21904":{"name":"Xã Cát Chánh","type":"xa","slug":"xa-cat-chanh","name_with_type":"Xã Cát Chánh","path":"Xã Cát Chánh, Huyện Phù Cát, Tỉnh Bình Định","path_with_type":"Xã Cát Chánh, Huyện Phù Cát, Tỉnh Bình Định","code":"21904","parent_code":"548"},"21907":{"name":"Phường Bình Định","type":"phuong","slug":"phuong-binh-dinh","name_with_type":"Phường Bình Định","path":"Phường Bình Định, Thị xã An Nhơn, Tỉnh Bình Định","path_with_type":"Phường Bình Định, Thị xã An Nhơn, Tỉnh Bình Định","code":"21907","parent_code":"549"},"21910":{"name":"Phường Đập Đá","type":"phuong","slug":"phuong-dap-da","name_with_type":"Phường Đập Đá","path":"Phường Đập Đá, Thị xã An Nhơn, Tỉnh Bình Định","path_with_type":"Phường Đập Đá, Thị xã An Nhơn, Tỉnh Bình Định","code":"21910","parent_code":"549"},"21913":{"name":"Xã Nhơn Mỹ","type":"xa","slug":"xa-nhon-my","name_with_type":"Xã Nhơn Mỹ","path":"Xã Nhơn Mỹ, Thị xã An Nhơn, Tỉnh Bình Định","path_with_type":"Xã Nhơn Mỹ, Thị xã An Nhơn, Tỉnh Bình Định","code":"21913","parent_code":"549"},"21916":{"name":"Phường Nhơn Thành","type":"phuong","slug":"phuong-nhon-thanh","name_with_type":"Phường Nhơn Thành","path":"Phường Nhơn Thành, Thị xã An Nhơn, Tỉnh Bình Định","path_with_type":"Phường Nhơn Thành, Thị xã An Nhơn, Tỉnh Bình Định","code":"21916","parent_code":"549"},"21919":{"name":"Xã Nhơn Hạnh","type":"xa","slug":"xa-nhon-hanh","name_with_type":"Xã Nhơn Hạnh","path":"Xã Nhơn Hạnh, Thị xã An Nhơn, Tỉnh Bình Định","path_with_type":"Xã Nhơn Hạnh, Thị xã An Nhơn, Tỉnh Bình Định","code":"21919","parent_code":"549"},"21922":{"name":"Xã Nhơn Hậu","type":"xa","slug":"xa-nhon-hau","name_with_type":"Xã Nhơn Hậu","path":"Xã Nhơn Hậu, Thị xã An Nhơn, Tỉnh Bình Định","path_with_type":"Xã Nhơn Hậu, Thị xã An Nhơn, Tỉnh Bình Định","code":"21922","parent_code":"549"},"21925":{"name":"Xã Nhơn Phong","type":"xa","slug":"xa-nhon-phong","name_with_type":"Xã Nhơn Phong","path":"Xã Nhơn Phong, Thị xã An Nhơn, Tỉnh Bình Định","path_with_type":"Xã Nhơn Phong, Thị xã An Nhơn, Tỉnh Bình Định","code":"21925","parent_code":"549"},"21928":{"name":"Xã Nhơn An","type":"xa","slug":"xa-nhon-an","name_with_type":"Xã Nhơn An","path":"Xã Nhơn An, Thị xã An Nhơn, Tỉnh Bình Định","path_with_type":"Xã Nhơn An, Thị xã An Nhơn, Tỉnh Bình Định","code":"21928","parent_code":"549"},"21931":{"name":"Xã Nhơn Phúc","type":"xa","slug":"xa-nhon-phuc","name_with_type":"Xã Nhơn Phúc","path":"Xã Nhơn Phúc, Thị xã An Nhơn, Tỉnh Bình Định","path_with_type":"Xã Nhơn Phúc, Thị xã An Nhơn, Tỉnh Bình Định","code":"21931","parent_code":"549"},"21934":{"name":"Phường Nhơn Hưng","type":"phuong","slug":"phuong-nhon-hung","name_with_type":"Phường Nhơn Hưng","path":"Phường Nhơn Hưng, Thị xã An Nhơn, Tỉnh Bình Định","path_with_type":"Phường Nhơn Hưng, Thị xã An Nhơn, Tỉnh Bình Định","code":"21934","parent_code":"549"},"21937":{"name":"Xã Nhơn Khánh","type":"xa","slug":"xa-nhon-khanh","name_with_type":"Xã Nhơn Khánh","path":"Xã Nhơn Khánh, Thị xã An Nhơn, Tỉnh Bình Định","path_with_type":"Xã Nhơn Khánh, Thị xã An Nhơn, Tỉnh Bình Định","code":"21937","parent_code":"549"},"21940":{"name":"Xã Nhơn Lộc","type":"xa","slug":"xa-nhon-loc","name_with_type":"Xã Nhơn Lộc","path":"Xã Nhơn Lộc, Thị xã An Nhơn, Tỉnh Bình Định","path_with_type":"Xã Nhơn Lộc, Thị xã An Nhơn, Tỉnh Bình Định","code":"21940","parent_code":"549"},"21943":{"name":"Phường Nhơn Hoà","type":"phuong","slug":"phuong-nhon-hoa","name_with_type":"Phường Nhơn Hoà","path":"Phường Nhơn Hoà, Thị xã An Nhơn, Tỉnh Bình Định","path_with_type":"Phường Nhơn Hoà, Thị xã An Nhơn, Tỉnh Bình Định","code":"21943","parent_code":"549"},"21946":{"name":"Xã Nhơn Tân","type":"xa","slug":"xa-nhon-tan","name_with_type":"Xã Nhơn Tân","path":"Xã Nhơn Tân, Thị xã An Nhơn, Tỉnh Bình Định","path_with_type":"Xã Nhơn Tân, Thị xã An Nhơn, Tỉnh Bình Định","code":"21946","parent_code":"549"},"21949":{"name":"Xã Nhơn Thọ","type":"xa","slug":"xa-nhon-tho","name_with_type":"Xã Nhơn Thọ","path":"Xã Nhơn Thọ, Thị xã An Nhơn, Tỉnh Bình Định","path_with_type":"Xã Nhơn Thọ, Thị xã An Nhơn, Tỉnh Bình Định","code":"21949","parent_code":"549"},"21952":{"name":"Thị trấn Tuy Phước","type":"thi-tran","slug":"thi-tran-tuy-phuoc","name_with_type":"Thị trấn Tuy Phước","path":"Thị trấn Tuy Phước, Huyện Tuy Phước, Tỉnh Bình Định","path_with_type":"Thị trấn Tuy Phước, Huyện Tuy Phước, Tỉnh Bình Định","code":"21952","parent_code":"550"},"21955":{"name":"Thị trấn Diêu Trì","type":"thi-tran","slug":"thi-tran-dieu-tri","name_with_type":"Thị trấn Diêu Trì","path":"Thị trấn Diêu Trì, Huyện Tuy Phước, Tỉnh Bình Định","path_with_type":"Thị trấn Diêu Trì, Huyện Tuy Phước, Tỉnh Bình Định","code":"21955","parent_code":"550"},"21958":{"name":"Xã Phước Thắng","type":"xa","slug":"xa-phuoc-thang","name_with_type":"Xã Phước Thắng","path":"Xã Phước Thắng, Huyện Tuy Phước, Tỉnh Bình Định","path_with_type":"Xã Phước Thắng, Huyện Tuy Phước, Tỉnh Bình Định","code":"21958","parent_code":"550"},"21961":{"name":"Xã Phước Hưng","type":"xa","slug":"xa-phuoc-hung","name_with_type":"Xã Phước Hưng","path":"Xã Phước Hưng, Huyện Tuy Phước, Tỉnh Bình Định","path_with_type":"Xã Phước Hưng, Huyện Tuy Phước, Tỉnh Bình Định","code":"21961","parent_code":"550"},"21964":{"name":"Xã Phước Quang","type":"xa","slug":"xa-phuoc-quang","name_with_type":"Xã Phước Quang","path":"Xã Phước Quang, Huyện Tuy Phước, Tỉnh Bình Định","path_with_type":"Xã Phước Quang, Huyện Tuy Phước, Tỉnh Bình Định","code":"21964","parent_code":"550"},"21967":{"name":"Xã Phước Hòa","type":"xa","slug":"xa-phuoc-hoa","name_with_type":"Xã Phước Hòa","path":"Xã Phước Hòa, Huyện Tuy Phước, Tỉnh Bình Định","path_with_type":"Xã Phước Hòa, Huyện Tuy Phước, Tỉnh Bình Định","code":"21967","parent_code":"550"},"21970":{"name":"Xã Phước Sơn","type":"xa","slug":"xa-phuoc-son","name_with_type":"Xã Phước Sơn","path":"Xã Phước Sơn, Huyện Tuy Phước, Tỉnh Bình Định","path_with_type":"Xã Phước Sơn, Huyện Tuy Phước, Tỉnh Bình Định","code":"21970","parent_code":"550"},"21973":{"name":"Xã Phước Hiệp","type":"xa","slug":"xa-phuoc-hiep","name_with_type":"Xã Phước Hiệp","path":"Xã Phước Hiệp, Huyện Tuy Phước, Tỉnh Bình Định","path_with_type":"Xã Phước Hiệp, Huyện Tuy Phước, Tỉnh Bình Định","code":"21973","parent_code":"550"},"21976":{"name":"Xã Phước Lộc","type":"xa","slug":"xa-phuoc-loc","name_with_type":"Xã Phước Lộc","path":"Xã Phước Lộc, Huyện Tuy Phước, Tỉnh Bình Định","path_with_type":"Xã Phước Lộc, Huyện Tuy Phước, Tỉnh Bình Định","code":"21976","parent_code":"550"},"21979":{"name":"Xã Phước Nghĩa","type":"xa","slug":"xa-phuoc-nghia","name_with_type":"Xã Phước Nghĩa","path":"Xã Phước Nghĩa, Huyện Tuy Phước, Tỉnh Bình Định","path_with_type":"Xã Phước Nghĩa, Huyện Tuy Phước, Tỉnh Bình Định","code":"21979","parent_code":"550"},"21982":{"name":"Xã Phước Thuận","type":"xa","slug":"xa-phuoc-thuan","name_with_type":"Xã Phước Thuận","path":"Xã Phước Thuận, Huyện Tuy Phước, Tỉnh Bình Định","path_with_type":"Xã Phước Thuận, Huyện Tuy Phước, Tỉnh Bình Định","code":"21982","parent_code":"550"},"21985":{"name":"Xã Phước An","type":"xa","slug":"xa-phuoc-an","name_with_type":"Xã Phước An","path":"Xã Phước An, Huyện Tuy Phước, Tỉnh Bình Định","path_with_type":"Xã Phước An, Huyện Tuy Phước, Tỉnh Bình Định","code":"21985","parent_code":"550"},"21988":{"name":"Xã Phước Thành","type":"xa","slug":"xa-phuoc-thanh","name_with_type":"Xã Phước Thành","path":"Xã Phước Thành, Huyện Tuy Phước, Tỉnh Bình Định","path_with_type":"Xã Phước Thành, Huyện Tuy Phước, Tỉnh Bình Định","code":"21988","parent_code":"550"},"21991":{"name":"Xã Phước Mỹ","type":"xa","slug":"xa-phuoc-my","name_with_type":"Xã Phước Mỹ","path":"Xã Phước Mỹ, Thành phố Quy Nhơn, Tỉnh Bình Định","path_with_type":"Xã Phước Mỹ, Thành phố Quy Nhơn, Tỉnh Bình Định","code":"21991","parent_code":"540"},"21994":{"name":"Thị trấn Vân Canh","type":"thi-tran","slug":"thi-tran-van-canh","name_with_type":"Thị trấn Vân Canh","path":"Thị trấn Vân Canh, Huyện Vân Canh, Tỉnh Bình Định","path_with_type":"Thị trấn Vân Canh, Huyện Vân Canh, Tỉnh Bình Định","code":"21994","parent_code":"551"},"21997":{"name":"Xã Canh Liên","type":"xa","slug":"xa-canh-lien","name_with_type":"Xã Canh Liên","path":"Xã Canh Liên, Huyện Vân Canh, Tỉnh Bình Định","path_with_type":"Xã Canh Liên, Huyện Vân Canh, Tỉnh Bình Định","code":"21997","parent_code":"551"},"22000":{"name":"Xã Canh Hiệp","type":"xa","slug":"xa-canh-hiep","name_with_type":"Xã Canh Hiệp","path":"Xã Canh Hiệp, Huyện Vân Canh, Tỉnh Bình Định","path_with_type":"Xã Canh Hiệp, Huyện Vân Canh, Tỉnh Bình Định","code":"22000","parent_code":"551"},"22003":{"name":"Xã Canh Vinh","type":"xa","slug":"xa-canh-vinh","name_with_type":"Xã Canh Vinh","path":"Xã Canh Vinh, Huyện Vân Canh, Tỉnh Bình Định","path_with_type":"Xã Canh Vinh, Huyện Vân Canh, Tỉnh Bình Định","code":"22003","parent_code":"551"},"22006":{"name":"Xã Canh Hiển","type":"xa","slug":"xa-canh-hien","name_with_type":"Xã Canh Hiển","path":"Xã Canh Hiển, Huyện Vân Canh, Tỉnh Bình Định","path_with_type":"Xã Canh Hiển, Huyện Vân Canh, Tỉnh Bình Định","code":"22006","parent_code":"551"},"22009":{"name":"Xã Canh Thuận","type":"xa","slug":"xa-canh-thuan","name_with_type":"Xã Canh Thuận","path":"Xã Canh Thuận, Huyện Vân Canh, Tỉnh Bình Định","path_with_type":"Xã Canh Thuận, Huyện Vân Canh, Tỉnh Bình Định","code":"22009","parent_code":"551"},"22012":{"name":"Xã Canh Hòa","type":"xa","slug":"xa-canh-hoa","name_with_type":"Xã Canh Hòa","path":"Xã Canh Hòa, Huyện Vân Canh, Tỉnh Bình Định","path_with_type":"Xã Canh Hòa, Huyện Vân Canh, Tỉnh Bình Định","code":"22012","parent_code":"551"},"22015":{"name":"Phường 1","type":"phuong","slug":"phuong-1","name_with_type":"Phường 1","path":"Phường 1, Thành phố Tuy Hoà, Tỉnh Phú Yên","path_with_type":"Phường 1, Thành phố Tuy Hoà, Tỉnh Phú Yên","code":"22015","parent_code":"555"},"22018":{"name":"Phường 2","type":"phuong","slug":"phuong-2","name_with_type":"Phường 2","path":"Phường 2, Thành phố Tuy Hoà, Tỉnh Phú Yên","path_with_type":"Phường 2, Thành phố Tuy Hoà, Tỉnh Phú Yên","code":"22018","parent_code":"555"},"22024":{"name":"Phường 9","type":"phuong","slug":"phuong-9","name_with_type":"Phường 9","path":"Phường 9, Thành phố Tuy Hoà, Tỉnh Phú Yên","path_with_type":"Phường 9, Thành phố Tuy Hoà, Tỉnh Phú Yên","code":"22024","parent_code":"555"},"22030":{"name":"Phường 4","type":"phuong","slug":"phuong-4","name_with_type":"Phường 4","path":"Phường 4, Thành phố Tuy Hoà, Tỉnh Phú Yên","path_with_type":"Phường 4, Thành phố Tuy Hoà, Tỉnh Phú Yên","code":"22030","parent_code":"555"},"22033":{"name":"Phường 5","type":"phuong","slug":"phuong-5","name_with_type":"Phường 5","path":"Phường 5, Thành phố Tuy Hoà, Tỉnh Phú Yên","path_with_type":"Phường 5, Thành phố Tuy Hoà, Tỉnh Phú Yên","code":"22033","parent_code":"555"},"22036":{"name":"Phường 7","type":"phuong","slug":"phuong-7","name_with_type":"Phường 7","path":"Phường 7, Thành phố Tuy Hoà, Tỉnh Phú Yên","path_with_type":"Phường 7, Thành phố Tuy Hoà, Tỉnh Phú Yên","code":"22036","parent_code":"555"},"22040":{"name":"Phường Phú Thạnh","type":"phuong","slug":"phuong-phu-thanh","name_with_type":"Phường Phú Thạnh","path":"Phường Phú Thạnh, Thành phố Tuy Hoà, Tỉnh Phú Yên","path_with_type":"Phường Phú Thạnh, Thành phố Tuy Hoà, Tỉnh Phú Yên","code":"22040","parent_code":"555"},"22041":{"name":"Phường Phú Đông","type":"phuong","slug":"phuong-phu-dong","name_with_type":"Phường Phú Đông","path":"Phường Phú Đông, Thành phố Tuy Hoà, Tỉnh Phú Yên","path_with_type":"Phường Phú Đông, Thành phố Tuy Hoà, Tỉnh Phú Yên","code":"22041","parent_code":"555"},"22042":{"name":"Xã Hòa Kiến","type":"xa","slug":"xa-hoa-kien","name_with_type":"Xã Hòa Kiến","path":"Xã Hòa Kiến, Thành phố Tuy Hoà, Tỉnh Phú Yên","path_with_type":"Xã Hòa Kiến, Thành phố Tuy Hoà, Tỉnh Phú Yên","code":"22042","parent_code":"555"},"22045":{"name":"Xã Bình Kiến","type":"xa","slug":"xa-binh-kien","name_with_type":"Xã Bình Kiến","path":"Xã Bình Kiến, Thành phố Tuy Hoà, Tỉnh Phú Yên","path_with_type":"Xã Bình Kiến, Thành phố Tuy Hoà, Tỉnh Phú Yên","code":"22045","parent_code":"555"},"22051":{"name":"Phường Xuân Phú","type":"phuong","slug":"phuong-xuan-phu","name_with_type":"Phường Xuân Phú","path":"Phường Xuân Phú, Thị xã Sông Cầu, Tỉnh Phú Yên","path_with_type":"Phường Xuân Phú, Thị xã Sông Cầu, Tỉnh Phú Yên","code":"22051","parent_code":"557"},"22052":{"name":"Xã Xuân Lâm","type":"xa","slug":"xa-xuan-lam","name_with_type":"Xã Xuân Lâm","path":"Xã Xuân Lâm, Thị xã Sông Cầu, Tỉnh Phú Yên","path_with_type":"Xã Xuân Lâm, Thị xã Sông Cầu, Tỉnh Phú Yên","code":"22052","parent_code":"557"},"22053":{"name":"Phường Xuân Thành","type":"phuong","slug":"phuong-xuan-thanh","name_with_type":"Phường Xuân Thành","path":"Phường Xuân Thành, Thị xã Sông Cầu, Tỉnh Phú Yên","path_with_type":"Phường Xuân Thành, Thị xã Sông Cầu, Tỉnh Phú Yên","code":"22053","parent_code":"557"},"22054":{"name":"Xã Xuân Hải","type":"xa","slug":"xa-xuan-hai","name_with_type":"Xã Xuân Hải","path":"Xã Xuân Hải, Thị xã Sông Cầu, Tỉnh Phú Yên","path_with_type":"Xã Xuân Hải, Thị xã Sông Cầu, Tỉnh Phú Yên","code":"22054","parent_code":"557"},"22057":{"name":"Xã Xuân Lộc","type":"xa","slug":"xa-xuan-loc","name_with_type":"Xã Xuân Lộc","path":"Xã Xuân Lộc, Thị xã Sông Cầu, Tỉnh Phú Yên","path_with_type":"Xã Xuân Lộc, Thị xã Sông Cầu, Tỉnh Phú Yên","code":"22057","parent_code":"557"},"22060":{"name":"Xã Xuân Bình","type":"xa","slug":"xa-xuan-binh","name_with_type":"Xã Xuân Bình","path":"Xã Xuân Bình, Thị xã Sông Cầu, Tỉnh Phú Yên","path_with_type":"Xã Xuân Bình, Thị xã Sông Cầu, Tỉnh Phú Yên","code":"22060","parent_code":"557"},"22066":{"name":"Xã Xuân Cảnh","type":"xa","slug":"xa-xuan-canh","name_with_type":"Xã Xuân Cảnh","path":"Xã Xuân Cảnh, Thị xã Sông Cầu, Tỉnh Phú Yên","path_with_type":"Xã Xuân Cảnh, Thị xã Sông Cầu, Tỉnh Phú Yên","code":"22066","parent_code":"557"},"22069":{"name":"Xã Xuân Thịnh","type":"xa","slug":"xa-xuan-thinh","name_with_type":"Xã Xuân Thịnh","path":"Xã Xuân Thịnh, Thị xã Sông Cầu, Tỉnh Phú Yên","path_with_type":"Xã Xuân Thịnh, Thị xã Sông Cầu, Tỉnh Phú Yên","code":"22069","parent_code":"557"},"22072":{"name":"Xã Xuân Phương","type":"xa","slug":"xa-xuan-phuong","name_with_type":"Xã Xuân Phương","path":"Xã Xuân Phương, Thị xã Sông Cầu, Tỉnh Phú Yên","path_with_type":"Xã Xuân Phương, Thị xã Sông Cầu, Tỉnh Phú Yên","code":"22072","parent_code":"557"},"22073":{"name":"Phường Xuân Yên","type":"phuong","slug":"phuong-xuan-yen","name_with_type":"Phường Xuân Yên","path":"Phường Xuân Yên, Thị xã Sông Cầu, Tỉnh Phú Yên","path_with_type":"Phường Xuân Yên, Thị xã Sông Cầu, Tỉnh Phú Yên","code":"22073","parent_code":"557"},"22075":{"name":"Xã Xuân Thọ 1","type":"xa","slug":"xa-xuan-tho-1","name_with_type":"Xã Xuân Thọ 1","path":"Xã Xuân Thọ 1, Thị xã Sông Cầu, Tỉnh Phú Yên","path_with_type":"Xã Xuân Thọ 1, Thị xã Sông Cầu, Tỉnh Phú Yên","code":"22075","parent_code":"557"},"22076":{"name":"Phường Xuân Đài","type":"phuong","slug":"phuong-xuan-dai","name_with_type":"Phường Xuân Đài","path":"Phường Xuân Đài, Thị xã Sông Cầu, Tỉnh Phú Yên","path_with_type":"Phường Xuân Đài, Thị xã Sông Cầu, Tỉnh Phú Yên","code":"22076","parent_code":"557"},"22078":{"name":"Xã Xuân Thọ 2","type":"xa","slug":"xa-xuan-tho-2","name_with_type":"Xã Xuân Thọ 2","path":"Xã Xuân Thọ 2, Thị xã Sông Cầu, Tỉnh Phú Yên","path_with_type":"Xã Xuân Thọ 2, Thị xã Sông Cầu, Tỉnh Phú Yên","code":"22078","parent_code":"557"},"22081":{"name":"Thị trấn La Hai","type":"thi-tran","slug":"thi-tran-la-hai","name_with_type":"Thị trấn La Hai","path":"Thị trấn La Hai, Huyện Đồng Xuân, Tỉnh Phú Yên","path_with_type":"Thị trấn La Hai, Huyện Đồng Xuân, Tỉnh Phú Yên","code":"22081","parent_code":"558"},"22084":{"name":"Xã Đa Lộc","type":"xa","slug":"xa-da-loc","name_with_type":"Xã Đa Lộc","path":"Xã Đa Lộc, Huyện Đồng Xuân, Tỉnh Phú Yên","path_with_type":"Xã Đa Lộc, Huyện Đồng Xuân, Tỉnh Phú Yên","code":"22084","parent_code":"558"},"22087":{"name":"Xã Phú Mỡ","type":"xa","slug":"xa-phu-mo","name_with_type":"Xã Phú Mỡ","path":"Xã Phú Mỡ, Huyện Đồng Xuân, Tỉnh Phú Yên","path_with_type":"Xã Phú Mỡ, Huyện Đồng Xuân, Tỉnh Phú Yên","code":"22087","parent_code":"558"},"22090":{"name":"Xã Xuân Lãnh","type":"xa","slug":"xa-xuan-lanh","name_with_type":"Xã Xuân Lãnh","path":"Xã Xuân Lãnh, Huyện Đồng Xuân, Tỉnh Phú Yên","path_with_type":"Xã Xuân Lãnh, Huyện Đồng Xuân, Tỉnh Phú Yên","code":"22090","parent_code":"558"},"22093":{"name":"Xã Xuân Long","type":"xa","slug":"xa-xuan-long","name_with_type":"Xã Xuân Long","path":"Xã Xuân Long, Huyện Đồng Xuân, Tỉnh Phú Yên","path_with_type":"Xã Xuân Long, Huyện Đồng Xuân, Tỉnh Phú Yên","code":"22093","parent_code":"558"},"22096":{"name":"Xã Xuân Quang 1","type":"xa","slug":"xa-xuan-quang-1","name_with_type":"Xã Xuân Quang 1","path":"Xã Xuân Quang 1, Huyện Đồng Xuân, Tỉnh Phú Yên","path_with_type":"Xã Xuân Quang 1, Huyện Đồng Xuân, Tỉnh Phú Yên","code":"22096","parent_code":"558"},"22099":{"name":"Xã Xuân Sơn Bắc","type":"xa","slug":"xa-xuan-son-bac","name_with_type":"Xã Xuân Sơn Bắc","path":"Xã Xuân Sơn Bắc, Huyện Đồng Xuân, Tỉnh Phú Yên","path_with_type":"Xã Xuân Sơn Bắc, Huyện Đồng Xuân, Tỉnh Phú Yên","code":"22099","parent_code":"558"},"22102":{"name":"Xã Xuân Quang 2","type":"xa","slug":"xa-xuan-quang-2","name_with_type":"Xã Xuân Quang 2","path":"Xã Xuân Quang 2, Huyện Đồng Xuân, Tỉnh Phú Yên","path_with_type":"Xã Xuân Quang 2, Huyện Đồng Xuân, Tỉnh Phú Yên","code":"22102","parent_code":"558"},"22105":{"name":"Xã Xuân Sơn Nam","type":"xa","slug":"xa-xuan-son-nam","name_with_type":"Xã Xuân Sơn Nam","path":"Xã Xuân Sơn Nam, Huyện Đồng Xuân, Tỉnh Phú Yên","path_with_type":"Xã Xuân Sơn Nam, Huyện Đồng Xuân, Tỉnh Phú Yên","code":"22105","parent_code":"558"},"22108":{"name":"Xã Xuân Quang 3","type":"xa","slug":"xa-xuan-quang-3","name_with_type":"Xã Xuân Quang 3","path":"Xã Xuân Quang 3, Huyện Đồng Xuân, Tỉnh Phú Yên","path_with_type":"Xã Xuân Quang 3, Huyện Đồng Xuân, Tỉnh Phú Yên","code":"22108","parent_code":"558"},"22111":{"name":"Xã Xuân Phước","type":"xa","slug":"xa-xuan-phuoc","name_with_type":"Xã Xuân Phước","path":"Xã Xuân Phước, Huyện Đồng Xuân, Tỉnh Phú Yên","path_with_type":"Xã Xuân Phước, Huyện Đồng Xuân, Tỉnh Phú Yên","code":"22111","parent_code":"558"},"22114":{"name":"Thị trấn Chí Thạnh","type":"thi-tran","slug":"thi-tran-chi-thanh","name_with_type":"Thị trấn Chí Thạnh","path":"Thị trấn Chí Thạnh, Huyện Tuy An, Tỉnh Phú Yên","path_with_type":"Thị trấn Chí Thạnh, Huyện Tuy An, Tỉnh Phú Yên","code":"22114","parent_code":"559"},"22117":{"name":"Xã An Dân","type":"xa","slug":"xa-an-dan","name_with_type":"Xã An Dân","path":"Xã An Dân, Huyện Tuy An, Tỉnh Phú Yên","path_with_type":"Xã An Dân, Huyện Tuy An, Tỉnh Phú Yên","code":"22117","parent_code":"559"},"22120":{"name":"Xã An Ninh Tây","type":"xa","slug":"xa-an-ninh-tay","name_with_type":"Xã An Ninh Tây","path":"Xã An Ninh Tây, Huyện Tuy An, Tỉnh Phú Yên","path_with_type":"Xã An Ninh Tây, Huyện Tuy An, Tỉnh Phú Yên","code":"22120","parent_code":"559"},"22123":{"name":"Xã An Ninh Đông","type":"xa","slug":"xa-an-ninh-dong","name_with_type":"Xã An Ninh Đông","path":"Xã An Ninh Đông, Huyện Tuy An, Tỉnh Phú Yên","path_with_type":"Xã An Ninh Đông, Huyện Tuy An, Tỉnh Phú Yên","code":"22123","parent_code":"559"},"22126":{"name":"Xã An Thạch","type":"xa","slug":"xa-an-thach","name_with_type":"Xã An Thạch","path":"Xã An Thạch, Huyện Tuy An, Tỉnh Phú Yên","path_with_type":"Xã An Thạch, Huyện Tuy An, Tỉnh Phú Yên","code":"22126","parent_code":"559"},"22129":{"name":"Xã An Định","type":"xa","slug":"xa-an-dinh","name_with_type":"Xã An Định","path":"Xã An Định, Huyện Tuy An, Tỉnh Phú Yên","path_with_type":"Xã An Định, Huyện Tuy An, Tỉnh Phú Yên","code":"22129","parent_code":"559"},"22132":{"name":"Xã An Nghiệp","type":"xa","slug":"xa-an-nghiep","name_with_type":"Xã An Nghiệp","path":"Xã An Nghiệp, Huyện Tuy An, Tỉnh Phú Yên","path_with_type":"Xã An Nghiệp, Huyện Tuy An, Tỉnh Phú Yên","code":"22132","parent_code":"559"},"22138":{"name":"Xã An Cư","type":"xa","slug":"xa-an-cu","name_with_type":"Xã An Cư","path":"Xã An Cư, Huyện Tuy An, Tỉnh Phú Yên","path_with_type":"Xã An Cư, Huyện Tuy An, Tỉnh Phú Yên","code":"22138","parent_code":"559"},"22141":{"name":"Xã An Xuân","type":"xa","slug":"xa-an-xuan","name_with_type":"Xã An Xuân","path":"Xã An Xuân, Huyện Tuy An, Tỉnh Phú Yên","path_with_type":"Xã An Xuân, Huyện Tuy An, Tỉnh Phú Yên","code":"22141","parent_code":"559"},"22144":{"name":"Xã An Lĩnh","type":"xa","slug":"xa-an-linh","name_with_type":"Xã An Lĩnh","path":"Xã An Lĩnh, Huyện Tuy An, Tỉnh Phú Yên","path_with_type":"Xã An Lĩnh, Huyện Tuy An, Tỉnh Phú Yên","code":"22144","parent_code":"559"},"22147":{"name":"Xã An Hòa Hải","type":"xa","slug":"xa-an-hoa-hai","name_with_type":"Xã An Hòa Hải","path":"Xã An Hòa Hải, Huyện Tuy An, Tỉnh Phú Yên","path_with_type":"Xã An Hòa Hải, Huyện Tuy An, Tỉnh Phú Yên","code":"22147","parent_code":"559"},"22150":{"name":"Xã An Hiệp","type":"xa","slug":"xa-an-hiep","name_with_type":"Xã An Hiệp","path":"Xã An Hiệp, Huyện Tuy An, Tỉnh Phú Yên","path_with_type":"Xã An Hiệp, Huyện Tuy An, Tỉnh Phú Yên","code":"22150","parent_code":"559"},"22153":{"name":"Xã An Mỹ","type":"xa","slug":"xa-an-my","name_with_type":"Xã An Mỹ","path":"Xã An Mỹ, Huyện Tuy An, Tỉnh Phú Yên","path_with_type":"Xã An Mỹ, Huyện Tuy An, Tỉnh Phú Yên","code":"22153","parent_code":"559"},"22156":{"name":"Xã An Chấn","type":"xa","slug":"xa-an-chan","name_with_type":"Xã An Chấn","path":"Xã An Chấn, Huyện Tuy An, Tỉnh Phú Yên","path_with_type":"Xã An Chấn, Huyện Tuy An, Tỉnh Phú Yên","code":"22156","parent_code":"559"},"22159":{"name":"Xã An Thọ","type":"xa","slug":"xa-an-tho","name_with_type":"Xã An Thọ","path":"Xã An Thọ, Huyện Tuy An, Tỉnh Phú Yên","path_with_type":"Xã An Thọ, Huyện Tuy An, Tỉnh Phú Yên","code":"22159","parent_code":"559"},"22162":{"name":"Xã An Phú","type":"xa","slug":"xa-an-phu","name_with_type":"Xã An Phú","path":"Xã An Phú, Thành phố Tuy Hoà, Tỉnh Phú Yên","path_with_type":"Xã An Phú, Thành phố Tuy Hoà, Tỉnh Phú Yên","code":"22162","parent_code":"555"},"22165":{"name":"Thị trấn Củng Sơn","type":"thi-tran","slug":"thi-tran-cung-son","name_with_type":"Thị trấn Củng Sơn","path":"Thị trấn Củng Sơn, Huyện Sơn Hòa, Tỉnh Phú Yên","path_with_type":"Thị trấn Củng Sơn, Huyện Sơn Hòa, Tỉnh Phú Yên","code":"22165","parent_code":"560"},"22168":{"name":"Xã Phước Tân","type":"xa","slug":"xa-phuoc-tan","name_with_type":"Xã Phước Tân","path":"Xã Phước Tân, Huyện Sơn Hòa, Tỉnh Phú Yên","path_with_type":"Xã Phước Tân, Huyện Sơn Hòa, Tỉnh Phú Yên","code":"22168","parent_code":"560"},"22171":{"name":"Xã Sơn Hội","type":"xa","slug":"xa-son-hoi","name_with_type":"Xã Sơn Hội","path":"Xã Sơn Hội, Huyện Sơn Hòa, Tỉnh Phú Yên","path_with_type":"Xã Sơn Hội, Huyện Sơn Hòa, Tỉnh Phú Yên","code":"22171","parent_code":"560"},"22174":{"name":"Xã Sơn Định","type":"xa","slug":"xa-son-dinh","name_with_type":"Xã Sơn Định","path":"Xã Sơn Định, Huyện Sơn Hòa, Tỉnh Phú Yên","path_with_type":"Xã Sơn Định, Huyện Sơn Hòa, Tỉnh Phú Yên","code":"22174","parent_code":"560"},"22177":{"name":"Xã Sơn Long","type":"xa","slug":"xa-son-long","name_with_type":"Xã Sơn Long","path":"Xã Sơn Long, Huyện Sơn Hòa, Tỉnh Phú Yên","path_with_type":"Xã Sơn Long, Huyện Sơn Hòa, Tỉnh Phú Yên","code":"22177","parent_code":"560"},"22180":{"name":"Xã Cà Lúi","type":"xa","slug":"xa-ca-lui","name_with_type":"Xã Cà Lúi","path":"Xã Cà Lúi, Huyện Sơn Hòa, Tỉnh Phú Yên","path_with_type":"Xã Cà Lúi, Huyện Sơn Hòa, Tỉnh Phú Yên","code":"22180","parent_code":"560"},"22183":{"name":"Xã Sơn Phước","type":"xa","slug":"xa-son-phuoc","name_with_type":"Xã Sơn Phước","path":"Xã Sơn Phước, Huyện Sơn Hòa, Tỉnh Phú Yên","path_with_type":"Xã Sơn Phước, Huyện Sơn Hòa, Tỉnh Phú Yên","code":"22183","parent_code":"560"},"22186":{"name":"Xã Sơn Xuân","type":"xa","slug":"xa-son-xuan","name_with_type":"Xã Sơn Xuân","path":"Xã Sơn Xuân, Huyện Sơn Hòa, Tỉnh Phú Yên","path_with_type":"Xã Sơn Xuân, Huyện Sơn Hòa, Tỉnh Phú Yên","code":"22186","parent_code":"560"},"22189":{"name":"Xã Sơn Nguyên","type":"xa","slug":"xa-son-nguyen","name_with_type":"Xã Sơn Nguyên","path":"Xã Sơn Nguyên, Huyện Sơn Hòa, Tỉnh Phú Yên","path_with_type":"Xã Sơn Nguyên, Huyện Sơn Hòa, Tỉnh Phú Yên","code":"22189","parent_code":"560"},"22192":{"name":"Xã Eachà Rang","type":"xa","slug":"xa-eacha-rang","name_with_type":"Xã Eachà Rang","path":"Xã Eachà Rang, Huyện Sơn Hòa, Tỉnh Phú Yên","path_with_type":"Xã Eachà Rang, Huyện Sơn Hòa, Tỉnh Phú Yên","code":"22192","parent_code":"560"},"22195":{"name":"Xã Krông Pa","type":"xa","slug":"xa-krong-pa","name_with_type":"Xã Krông Pa","path":"Xã Krông Pa, Huyện Sơn Hòa, Tỉnh Phú Yên","path_with_type":"Xã Krông Pa, Huyện Sơn Hòa, Tỉnh Phú Yên","code":"22195","parent_code":"560"},"22198":{"name":"Xã Suối Bạc","type":"xa","slug":"xa-suoi-bac","name_with_type":"Xã Suối Bạc","path":"Xã Suối Bạc, Huyện Sơn Hòa, Tỉnh Phú Yên","path_with_type":"Xã Suối Bạc, Huyện Sơn Hòa, Tỉnh Phú Yên","code":"22198","parent_code":"560"},"22201":{"name":"Xã Sơn Hà","type":"xa","slug":"xa-son-ha","name_with_type":"Xã Sơn Hà","path":"Xã Sơn Hà, Huyện Sơn Hòa, Tỉnh Phú Yên","path_with_type":"Xã Sơn Hà, Huyện Sơn Hòa, Tỉnh Phú Yên","code":"22201","parent_code":"560"},"22204":{"name":"Xã Suối Trai","type":"xa","slug":"xa-suoi-trai","name_with_type":"Xã Suối Trai","path":"Xã Suối Trai, Huyện Sơn Hòa, Tỉnh Phú Yên","path_with_type":"Xã Suối Trai, Huyện Sơn Hòa, Tỉnh Phú Yên","code":"22204","parent_code":"560"},"22207":{"name":"Thị trấn Hai Riêng","type":"thi-tran","slug":"thi-tran-hai-rieng","name_with_type":"Thị trấn Hai Riêng","path":"Thị trấn Hai Riêng, Huyện Sông Hinh, Tỉnh Phú Yên","path_with_type":"Thị trấn Hai Riêng, Huyện Sông Hinh, Tỉnh Phú Yên","code":"22207","parent_code":"561"},"22210":{"name":"Xã Ea Lâm","type":"xa","slug":"xa-ea-lam","name_with_type":"Xã Ea Lâm","path":"Xã Ea Lâm, Huyện Sông Hinh, Tỉnh Phú Yên","path_with_type":"Xã Ea Lâm, Huyện Sông Hinh, Tỉnh Phú Yên","code":"22210","parent_code":"561"},"22213":{"name":"Xã Đức Bình Tây","type":"xa","slug":"xa-duc-binh-tay","name_with_type":"Xã Đức Bình Tây","path":"Xã Đức Bình Tây, Huyện Sông Hinh, Tỉnh Phú Yên","path_with_type":"Xã Đức Bình Tây, Huyện Sông Hinh, Tỉnh Phú Yên","code":"22213","parent_code":"561"},"22216":{"name":"Xã Ea Bá","type":"xa","slug":"xa-ea-ba","name_with_type":"Xã Ea Bá","path":"Xã Ea Bá, Huyện Sông Hinh, Tỉnh Phú Yên","path_with_type":"Xã Ea Bá, Huyện Sông Hinh, Tỉnh Phú Yên","code":"22216","parent_code":"561"},"22219":{"name":"Xã Sơn Giang","type":"xa","slug":"xa-son-giang","name_with_type":"Xã Sơn Giang","path":"Xã Sơn Giang, Huyện Sông Hinh, Tỉnh Phú Yên","path_with_type":"Xã Sơn Giang, Huyện Sông Hinh, Tỉnh Phú Yên","code":"22219","parent_code":"561"},"22222":{"name":"Xã Đức Bình Đông","type":"xa","slug":"xa-duc-binh-dong","name_with_type":"Xã Đức Bình Đông","path":"Xã Đức Bình Đông, Huyện Sông Hinh, Tỉnh Phú Yên","path_with_type":"Xã Đức Bình Đông, Huyện Sông Hinh, Tỉnh Phú Yên","code":"22222","parent_code":"561"},"22225":{"name":"Xã EaBar","type":"xa","slug":"xa-eabar","name_with_type":"Xã EaBar","path":"Xã EaBar, Huyện Sông Hinh, Tỉnh Phú Yên","path_with_type":"Xã EaBar, Huyện Sông Hinh, Tỉnh Phú Yên","code":"22225","parent_code":"561"},"22228":{"name":"Xã EaBia","type":"xa","slug":"xa-eabia","name_with_type":"Xã EaBia","path":"Xã EaBia, Huyện Sông Hinh, Tỉnh Phú Yên","path_with_type":"Xã EaBia, Huyện Sông Hinh, Tỉnh Phú Yên","code":"22228","parent_code":"561"},"22231":{"name":"Xã EaTrol","type":"xa","slug":"xa-eatrol","name_with_type":"Xã EaTrol","path":"Xã EaTrol, Huyện Sông Hinh, Tỉnh Phú Yên","path_with_type":"Xã EaTrol, Huyện Sông Hinh, Tỉnh Phú Yên","code":"22231","parent_code":"561"},"22234":{"name":"Xã Sông Hinh","type":"xa","slug":"xa-song-hinh","name_with_type":"Xã Sông Hinh","path":"Xã Sông Hinh, Huyện Sông Hinh, Tỉnh Phú Yên","path_with_type":"Xã Sông Hinh, Huyện Sông Hinh, Tỉnh Phú Yên","code":"22234","parent_code":"561"},"22237":{"name":"Xã Ealy","type":"xa","slug":"xa-ealy","name_with_type":"Xã Ealy","path":"Xã Ealy, Huyện Sông Hinh, Tỉnh Phú Yên","path_with_type":"Xã Ealy, Huyện Sông Hinh, Tỉnh Phú Yên","code":"22237","parent_code":"561"},"22240":{"name":"Phường Phú Lâm","type":"phuong","slug":"phuong-phu-lam","name_with_type":"Phường Phú Lâm","path":"Phường Phú Lâm, Thành phố Tuy Hoà, Tỉnh Phú Yên","path_with_type":"Phường Phú Lâm, Thành phố Tuy Hoà, Tỉnh Phú Yên","code":"22240","parent_code":"555"},"22243":{"name":"Xã Hòa Thành","type":"xa","slug":"xa-hoa-thanh","name_with_type":"Xã Hòa Thành","path":"Xã Hòa Thành, Thị xã Đông Hòa, Tỉnh Phú Yên","path_with_type":"Xã Hòa Thành, Thị xã Đông Hòa, Tỉnh Phú Yên","code":"22243","parent_code":"564"},"22246":{"name":"Phường Hòa Hiệp Bắc","type":"phuong","slug":"phuong-hoa-hiep-bac","name_with_type":"Phường Hòa Hiệp Bắc","path":"Phường Hòa Hiệp Bắc, Thị xã Đông Hòa, Tỉnh Phú Yên","path_with_type":"Phường Hòa Hiệp Bắc, Thị xã Đông Hòa, Tỉnh Phú Yên","code":"22246","parent_code":"564"},"22249":{"name":"Xã Sơn Thành Tây","type":"xa","slug":"xa-son-thanh-tay","name_with_type":"Xã Sơn Thành Tây","path":"Xã Sơn Thành Tây, Huyện Tây Hoà, Tỉnh Phú Yên","path_with_type":"Xã Sơn Thành Tây, Huyện Tây Hoà, Tỉnh Phú Yên","code":"22249","parent_code":"562"},"22250":{"name":"Xã Sơn Thành Đông","type":"xa","slug":"xa-son-thanh-dong","name_with_type":"Xã Sơn Thành Đông","path":"Xã Sơn Thành Đông, Huyện Tây Hoà, Tỉnh Phú Yên","path_with_type":"Xã Sơn Thành Đông, Huyện Tây Hoà, Tỉnh Phú Yên","code":"22250","parent_code":"562"},"22252":{"name":"Xã Hòa Bình 1","type":"xa","slug":"xa-hoa-binh-1","name_with_type":"Xã Hòa Bình 1","path":"Xã Hòa Bình 1, Huyện Tây Hoà, Tỉnh Phú Yên","path_with_type":"Xã Hòa Bình 1, Huyện Tây Hoà, Tỉnh Phú Yên","code":"22252","parent_code":"562"},"22255":{"name":"Thị trấn Phú Thứ","type":"thi-tran","slug":"thi-tran-phu-thu","name_with_type":"Thị trấn Phú Thứ","path":"Thị trấn Phú Thứ, Huyện Tây Hoà, Tỉnh Phú Yên","path_with_type":"Thị trấn Phú Thứ, Huyện Tây Hoà, Tỉnh Phú Yên","code":"22255","parent_code":"562"},"22258":{"name":"Phường Hoà Vinh","type":"phuong","slug":"phuong-hoa-vinh","name_with_type":"Phường Hoà Vinh","path":"Phường Hoà Vinh, Thị xã Đông Hòa, Tỉnh Phú Yên","path_with_type":"Phường Hoà Vinh, Thị xã Đông Hòa, Tỉnh Phú Yên","code":"22258","parent_code":"564"},"22261":{"name":"Phường Hoà Hiệp Trung","type":"phuong","slug":"phuong-hoa-hiep-trung","name_with_type":"Phường Hoà Hiệp Trung","path":"Phường Hoà Hiệp Trung, Thị xã Đông Hòa, Tỉnh Phú Yên","path_with_type":"Phường Hoà Hiệp Trung, Thị xã Đông Hòa, Tỉnh Phú Yên","code":"22261","parent_code":"564"},"22264":{"name":"Xã Hòa Phong","type":"xa","slug":"xa-hoa-phong","name_with_type":"Xã Hòa Phong","path":"Xã Hòa Phong, Huyện Tây Hoà, Tỉnh Phú Yên","path_with_type":"Xã Hòa Phong, Huyện Tây Hoà, Tỉnh Phú Yên","code":"22264","parent_code":"562"},"22267":{"name":"Xã Hòa Tân Đông","type":"xa","slug":"xa-hoa-tan-dong","name_with_type":"Xã Hòa Tân Đông","path":"Xã Hòa Tân Đông, Thị xã Đông Hòa, Tỉnh Phú Yên","path_with_type":"Xã Hòa Tân Đông, Thị xã Đông Hòa, Tỉnh Phú Yên","code":"22267","parent_code":"564"},"22270":{"name":"Xã Hòa Phú","type":"xa","slug":"xa-hoa-phu","name_with_type":"Xã Hòa Phú","path":"Xã Hòa Phú, Huyện Tây Hoà, Tỉnh Phú Yên","path_with_type":"Xã Hòa Phú, Huyện Tây Hoà, Tỉnh Phú Yên","code":"22270","parent_code":"562"},"22273":{"name":"Xã Hòa Tân Tây","type":"xa","slug":"xa-hoa-tan-tay","name_with_type":"Xã Hòa Tân Tây","path":"Xã Hòa Tân Tây, Huyện Tây Hoà, Tỉnh Phú Yên","path_with_type":"Xã Hòa Tân Tây, Huyện Tây Hoà, Tỉnh Phú Yên","code":"22273","parent_code":"562"},"22276":{"name":"Xã Hòa Đồng","type":"xa","slug":"xa-hoa-dong","name_with_type":"Xã Hòa Đồng","path":"Xã Hòa Đồng, Huyện Tây Hoà, Tỉnh Phú Yên","path_with_type":"Xã Hòa Đồng, Huyện Tây Hoà, Tỉnh Phú Yên","code":"22276","parent_code":"562"},"22279":{"name":"Phường Hòa Xuân Tây","type":"phuong","slug":"phuong-hoa-xuan-tay","name_with_type":"Phường Hòa Xuân Tây","path":"Phường Hòa Xuân Tây, Thị xã Đông Hòa, Tỉnh Phú Yên","path_with_type":"Phường Hòa Xuân Tây, Thị xã Đông Hòa, Tỉnh Phú Yên","code":"22279","parent_code":"564"},"22282":{"name":"Phường Hòa Hiệp Nam","type":"phuong","slug":"phuong-hoa-hiep-nam","name_with_type":"Phường Hòa Hiệp Nam","path":"Phường Hòa Hiệp Nam, Thị xã Đông Hòa, Tỉnh Phú Yên","path_with_type":"Phường Hòa Hiệp Nam, Thị xã Đông Hòa, Tỉnh Phú Yên","code":"22282","parent_code":"564"},"22285":{"name":"Xã Hòa Mỹ Đông","type":"xa","slug":"xa-hoa-my-dong","name_with_type":"Xã Hòa Mỹ Đông","path":"Xã Hòa Mỹ Đông, Huyện Tây Hoà, Tỉnh Phú Yên","path_with_type":"Xã Hòa Mỹ Đông, Huyện Tây Hoà, Tỉnh Phú Yên","code":"22285","parent_code":"562"},"22288":{"name":"Xã Hòa Mỹ Tây","type":"xa","slug":"xa-hoa-my-tay","name_with_type":"Xã Hòa Mỹ Tây","path":"Xã Hòa Mỹ Tây, Huyện Tây Hoà, Tỉnh Phú Yên","path_with_type":"Xã Hòa Mỹ Tây, Huyện Tây Hoà, Tỉnh Phú Yên","code":"22288","parent_code":"562"},"22291":{"name":"Xã Hòa Xuân Đông","type":"xa","slug":"xa-hoa-xuan-dong","name_with_type":"Xã Hòa Xuân Đông","path":"Xã Hòa Xuân Đông, Thị xã Đông Hòa, Tỉnh Phú Yên","path_with_type":"Xã Hòa Xuân Đông, Thị xã Đông Hòa, Tỉnh Phú Yên","code":"22291","parent_code":"564"},"22294":{"name":"Xã Hòa Thịnh","type":"xa","slug":"xa-hoa-thinh","name_with_type":"Xã Hòa Thịnh","path":"Xã Hòa Thịnh, Huyện Tây Hoà, Tỉnh Phú Yên","path_with_type":"Xã Hòa Thịnh, Huyện Tây Hoà, Tỉnh Phú Yên","code":"22294","parent_code":"562"},"22297":{"name":"Xã Hòa Tâm","type":"xa","slug":"xa-hoa-tam","name_with_type":"Xã Hòa Tâm","path":"Xã Hòa Tâm, Thị xã Đông Hòa, Tỉnh Phú Yên","path_with_type":"Xã Hòa Tâm, Thị xã Đông Hòa, Tỉnh Phú Yên","code":"22297","parent_code":"564"},"22300":{"name":"Xã Hòa Xuân Nam","type":"xa","slug":"xa-hoa-xuan-nam","name_with_type":"Xã Hòa Xuân Nam","path":"Xã Hòa Xuân Nam, Thị xã Đông Hòa, Tỉnh Phú Yên","path_with_type":"Xã Hòa Xuân Nam, Thị xã Đông Hòa, Tỉnh Phú Yên","code":"22300","parent_code":"564"},"22303":{"name":"Xã Hòa Quang Bắc","type":"xa","slug":"xa-hoa-quang-bac","name_with_type":"Xã Hòa Quang Bắc","path":"Xã Hòa Quang Bắc, Huyện Phú Hoà, Tỉnh Phú Yên","path_with_type":"Xã Hòa Quang Bắc, Huyện Phú Hoà, Tỉnh Phú Yên","code":"22303","parent_code":"563"},"22306":{"name":"Xã Hòa Quang Nam","type":"xa","slug":"xa-hoa-quang-nam","name_with_type":"Xã Hòa Quang Nam","path":"Xã Hòa Quang Nam, Huyện Phú Hoà, Tỉnh Phú Yên","path_with_type":"Xã Hòa Quang Nam, Huyện Phú Hoà, Tỉnh Phú Yên","code":"22306","parent_code":"563"},"22309":{"name":"Xã Hòa Hội","type":"xa","slug":"xa-hoa-hoi","name_with_type":"Xã Hòa Hội","path":"Xã Hòa Hội, Huyện Phú Hoà, Tỉnh Phú Yên","path_with_type":"Xã Hòa Hội, Huyện Phú Hoà, Tỉnh Phú Yên","code":"22309","parent_code":"563"},"22312":{"name":"Xã Hòa Trị","type":"xa","slug":"xa-hoa-tri","name_with_type":"Xã Hòa Trị","path":"Xã Hòa Trị, Huyện Phú Hoà, Tỉnh Phú Yên","path_with_type":"Xã Hòa Trị, Huyện Phú Hoà, Tỉnh Phú Yên","code":"22312","parent_code":"563"},"22315":{"name":"Xã Hòa An","type":"xa","slug":"xa-hoa-an","name_with_type":"Xã Hòa An","path":"Xã Hòa An, Huyện Phú Hoà, Tỉnh Phú Yên","path_with_type":"Xã Hòa An, Huyện Phú Hoà, Tỉnh Phú Yên","code":"22315","parent_code":"563"},"22318":{"name":"Xã Hòa Định Đông","type":"xa","slug":"xa-hoa-dinh-dong","name_with_type":"Xã Hòa Định Đông","path":"Xã Hòa Định Đông, Huyện Phú Hoà, Tỉnh Phú Yên","path_with_type":"Xã Hòa Định Đông, Huyện Phú Hoà, Tỉnh Phú Yên","code":"22318","parent_code":"563"},"22319":{"name":"Thị Trấn Phú Hoà","type":"thi-tran","slug":"thi-tran-phu-hoa","name_with_type":"Thị Trấn Phú Hoà","path":"Thị Trấn Phú Hoà, Huyện Phú Hoà, Tỉnh Phú Yên","path_with_type":"Thị Trấn Phú Hoà, Huyện Phú Hoà, Tỉnh Phú Yên","code":"22319","parent_code":"563"},"22321":{"name":"Xã Hòa Định Tây","type":"xa","slug":"xa-hoa-dinh-tay","name_with_type":"Xã Hòa Định Tây","path":"Xã Hòa Định Tây, Huyện Phú Hoà, Tỉnh Phú Yên","path_with_type":"Xã Hòa Định Tây, Huyện Phú Hoà, Tỉnh Phú Yên","code":"22321","parent_code":"563"},"22324":{"name":"Xã Hòa Thắng","type":"xa","slug":"xa-hoa-thang","name_with_type":"Xã Hòa Thắng","path":"Xã Hòa Thắng, Huyện Phú Hoà, Tỉnh Phú Yên","path_with_type":"Xã Hòa Thắng, Huyện Phú Hoà, Tỉnh Phú Yên","code":"22324","parent_code":"563"},"22327":{"name":"Phường Vĩnh Hòa","type":"phuong","slug":"phuong-vinh-hoa","name_with_type":"Phường Vĩnh Hòa","path":"Phường Vĩnh Hòa, Thành phố Nha Trang, Tỉnh Khánh Hòa","path_with_type":"Phường Vĩnh Hòa, Thành phố Nha Trang, Tỉnh Khánh Hòa","code":"22327","parent_code":"568"},"22330":{"name":"Phường Vĩnh Hải","type":"phuong","slug":"phuong-vinh-hai","name_with_type":"Phường Vĩnh Hải","path":"Phường Vĩnh Hải, Thành phố Nha Trang, Tỉnh Khánh Hòa","path_with_type":"Phường Vĩnh Hải, Thành phố Nha Trang, Tỉnh Khánh Hòa","code":"22330","parent_code":"568"},"22333":{"name":"Phường Vĩnh Phước","type":"phuong","slug":"phuong-vinh-phuoc","name_with_type":"Phường Vĩnh Phước","path":"Phường Vĩnh Phước, Thành phố Nha Trang, Tỉnh Khánh Hòa","path_with_type":"Phường Vĩnh Phước, Thành phố Nha Trang, Tỉnh Khánh Hòa","code":"22333","parent_code":"568"},"22336":{"name":"Phường Ngọc Hiệp","type":"phuong","slug":"phuong-ngoc-hiep","name_with_type":"Phường Ngọc Hiệp","path":"Phường Ngọc Hiệp, Thành phố Nha Trang, Tỉnh Khánh Hòa","path_with_type":"Phường Ngọc Hiệp, Thành phố Nha Trang, Tỉnh Khánh Hòa","code":"22336","parent_code":"568"},"22339":{"name":"Phường Vĩnh Thọ","type":"phuong","slug":"phuong-vinh-tho","name_with_type":"Phường Vĩnh Thọ","path":"Phường Vĩnh Thọ, Thành phố Nha Trang, Tỉnh Khánh Hòa","path_with_type":"Phường Vĩnh Thọ, Thành phố Nha Trang, Tỉnh Khánh Hòa","code":"22339","parent_code":"568"},"22348":{"name":"Phường Vạn Thạnh","type":"phuong","slug":"phuong-van-thanh","name_with_type":"Phường Vạn Thạnh","path":"Phường Vạn Thạnh, Thành phố Nha Trang, Tỉnh Khánh Hòa","path_with_type":"Phường Vạn Thạnh, Thành phố Nha Trang, Tỉnh Khánh Hòa","code":"22348","parent_code":"568"},"22351":{"name":"Phường Phương Sài","type":"phuong","slug":"phuong-phuong-sai","name_with_type":"Phường Phương Sài","path":"Phường Phương Sài, Thành phố Nha Trang, Tỉnh Khánh Hòa","path_with_type":"Phường Phương Sài, Thành phố Nha Trang, Tỉnh Khánh Hòa","code":"22351","parent_code":"568"},"22357":{"name":"Phường Phước Hải","type":"phuong","slug":"phuong-phuoc-hai","name_with_type":"Phường Phước Hải","path":"Phường Phước Hải, Thành phố Nha Trang, Tỉnh Khánh Hòa","path_with_type":"Phường Phước Hải, Thành phố Nha Trang, Tỉnh Khánh Hòa","code":"22357","parent_code":"568"},"22363":{"name":"Phường Lộc Thọ","type":"phuong","slug":"phuong-loc-tho","name_with_type":"Phường Lộc Thọ","path":"Phường Lộc Thọ, Thành phố Nha Trang, Tỉnh Khánh Hòa","path_with_type":"Phường Lộc Thọ, Thành phố Nha Trang, Tỉnh Khánh Hòa","code":"22363","parent_code":"568"},"22366":{"name":"Phường Tân Tiến","type":"phuong","slug":"phuong-tan-tien","name_with_type":"Phường Tân Tiến","path":"Phường Tân Tiến, Thành phố Nha Trang, Tỉnh Khánh Hòa","path_with_type":"Phường Tân Tiến, Thành phố Nha Trang, Tỉnh Khánh Hòa","code":"22366","parent_code":"568"},"22372":{"name":"Phường Phước Hòa","type":"phuong","slug":"phuong-phuoc-hoa","name_with_type":"Phường Phước Hòa","path":"Phường Phước Hòa, Thành phố Nha Trang, Tỉnh Khánh Hòa","path_with_type":"Phường Phước Hòa, Thành phố Nha Trang, Tỉnh Khánh Hòa","code":"22372","parent_code":"568"},"22375":{"name":"Phường Vĩnh Nguyên","type":"phuong","slug":"phuong-vinh-nguyen","name_with_type":"Phường Vĩnh Nguyên","path":"Phường Vĩnh Nguyên, Thành phố Nha Trang, Tỉnh Khánh Hòa","path_with_type":"Phường Vĩnh Nguyên, Thành phố Nha Trang, Tỉnh Khánh Hòa","code":"22375","parent_code":"568"},"22378":{"name":"Phường Phước Long","type":"phuong","slug":"phuong-phuoc-long","name_with_type":"Phường Phước Long","path":"Phường Phước Long, Thành phố Nha Trang, Tỉnh Khánh Hòa","path_with_type":"Phường Phước Long, Thành phố Nha Trang, Tỉnh Khánh Hòa","code":"22378","parent_code":"568"},"22381":{"name":"Phường Vĩnh Trường","type":"phuong","slug":"phuong-vinh-truong","name_with_type":"Phường Vĩnh Trường","path":"Phường Vĩnh Trường, Thành phố Nha Trang, Tỉnh Khánh Hòa","path_with_type":"Phường Vĩnh Trường, Thành phố Nha Trang, Tỉnh Khánh Hòa","code":"22381","parent_code":"568"},"22384":{"name":"Xã Vĩnh Lương","type":"xa","slug":"xa-vinh-luong","name_with_type":"Xã Vĩnh Lương","path":"Xã Vĩnh Lương, Thành phố Nha Trang, Tỉnh Khánh Hòa","path_with_type":"Xã Vĩnh Lương, Thành phố Nha Trang, Tỉnh Khánh Hòa","code":"22384","parent_code":"568"},"22387":{"name":"Xã Vĩnh Phương","type":"xa","slug":"xa-vinh-phuong","name_with_type":"Xã Vĩnh Phương","path":"Xã Vĩnh Phương, Thành phố Nha Trang, Tỉnh Khánh Hòa","path_with_type":"Xã Vĩnh Phương, Thành phố Nha Trang, Tỉnh Khánh Hòa","code":"22387","parent_code":"568"},"22390":{"name":"Xã Vĩnh Ngọc","type":"xa","slug":"xa-vinh-ngoc","name_with_type":"Xã Vĩnh Ngọc","path":"Xã Vĩnh Ngọc, Thành phố Nha Trang, Tỉnh Khánh Hòa","path_with_type":"Xã Vĩnh Ngọc, Thành phố Nha Trang, Tỉnh Khánh Hòa","code":"22390","parent_code":"568"},"22393":{"name":"Xã Vĩnh Thạnh","type":"xa","slug":"xa-vinh-thanh","name_with_type":"Xã Vĩnh Thạnh","path":"Xã Vĩnh Thạnh, Thành phố Nha Trang, Tỉnh Khánh Hòa","path_with_type":"Xã Vĩnh Thạnh, Thành phố Nha Trang, Tỉnh Khánh Hòa","code":"22393","parent_code":"568"},"22396":{"name":"Xã Vĩnh Trung","type":"xa","slug":"xa-vinh-trung","name_with_type":"Xã Vĩnh Trung","path":"Xã Vĩnh Trung, Thành phố Nha Trang, Tỉnh Khánh Hòa","path_with_type":"Xã Vĩnh Trung, Thành phố Nha Trang, Tỉnh Khánh Hòa","code":"22396","parent_code":"568"},"22399":{"name":"Xã Vĩnh Hiệp","type":"xa","slug":"xa-vinh-hiep","name_with_type":"Xã Vĩnh Hiệp","path":"Xã Vĩnh Hiệp, Thành phố Nha Trang, Tỉnh Khánh Hòa","path_with_type":"Xã Vĩnh Hiệp, Thành phố Nha Trang, Tỉnh Khánh Hòa","code":"22399","parent_code":"568"},"22402":{"name":"Xã Vĩnh Thái","type":"xa","slug":"xa-vinh-thai","name_with_type":"Xã Vĩnh Thái","path":"Xã Vĩnh Thái, Thành phố Nha Trang, Tỉnh Khánh Hòa","path_with_type":"Xã Vĩnh Thái, Thành phố Nha Trang, Tỉnh Khánh Hòa","code":"22402","parent_code":"568"},"22405":{"name":"Xã Phước Đồng","type":"xa","slug":"xa-phuoc-dong","name_with_type":"Xã Phước Đồng","path":"Xã Phước Đồng, Thành phố Nha Trang, Tỉnh Khánh Hòa","path_with_type":"Xã Phước Đồng, Thành phố Nha Trang, Tỉnh Khánh Hòa","code":"22405","parent_code":"568"},"22408":{"name":"Phường Cam Nghĩa","type":"phuong","slug":"phuong-cam-nghia","name_with_type":"Phường Cam Nghĩa","path":"Phường Cam Nghĩa, Thành phố Cam Ranh, Tỉnh Khánh Hòa","path_with_type":"Phường Cam Nghĩa, Thành phố Cam Ranh, Tỉnh Khánh Hòa","code":"22408","parent_code":"569"},"22411":{"name":"Phường Cam Phúc Bắc","type":"phuong","slug":"phuong-cam-phuc-bac","name_with_type":"Phường Cam Phúc Bắc","path":"Phường Cam Phúc Bắc, Thành phố Cam Ranh, Tỉnh Khánh Hòa","path_with_type":"Phường Cam Phúc Bắc, Thành phố Cam Ranh, Tỉnh Khánh Hòa","code":"22411","parent_code":"569"},"22414":{"name":"Phường Cam Phúc Nam","type":"phuong","slug":"phuong-cam-phuc-nam","name_with_type":"Phường Cam Phúc Nam","path":"Phường Cam Phúc Nam, Thành phố Cam Ranh, Tỉnh Khánh Hòa","path_with_type":"Phường Cam Phúc Nam, Thành phố Cam Ranh, Tỉnh Khánh Hòa","code":"22414","parent_code":"569"},"22417":{"name":"Phường Cam Lộc","type":"phuong","slug":"phuong-cam-loc","name_with_type":"Phường Cam Lộc","path":"Phường Cam Lộc, Thành phố Cam Ranh, Tỉnh Khánh Hòa","path_with_type":"Phường Cam Lộc, Thành phố Cam Ranh, Tỉnh Khánh Hòa","code":"22417","parent_code":"569"},"22420":{"name":"Phường Cam Phú","type":"phuong","slug":"phuong-cam-phu","name_with_type":"Phường Cam Phú","path":"Phường Cam Phú, Thành phố Cam Ranh, Tỉnh Khánh Hòa","path_with_type":"Phường Cam Phú, Thành phố Cam Ranh, Tỉnh Khánh Hòa","code":"22420","parent_code":"569"},"22423":{"name":"Phường Ba Ngòi","type":"phuong","slug":"phuong-ba-ngoi","name_with_type":"Phường Ba Ngòi","path":"Phường Ba Ngòi, Thành phố Cam Ranh, Tỉnh Khánh Hòa","path_with_type":"Phường Ba Ngòi, Thành phố Cam Ranh, Tỉnh Khánh Hòa","code":"22423","parent_code":"569"},"22426":{"name":"Phường Cam Thuận","type":"phuong","slug":"phuong-cam-thuan","name_with_type":"Phường Cam Thuận","path":"Phường Cam Thuận, Thành phố Cam Ranh, Tỉnh Khánh Hòa","path_with_type":"Phường Cam Thuận, Thành phố Cam Ranh, Tỉnh Khánh Hòa","code":"22426","parent_code":"569"},"22429":{"name":"Phường Cam Lợi","type":"phuong","slug":"phuong-cam-loi","name_with_type":"Phường Cam Lợi","path":"Phường Cam Lợi, Thành phố Cam Ranh, Tỉnh Khánh Hòa","path_with_type":"Phường Cam Lợi, Thành phố Cam Ranh, Tỉnh Khánh Hòa","code":"22429","parent_code":"569"},"22432":{"name":"Phường Cam Linh","type":"phuong","slug":"phuong-cam-linh","name_with_type":"Phường Cam Linh","path":"Phường Cam Linh, Thành phố Cam Ranh, Tỉnh Khánh Hòa","path_with_type":"Phường Cam Linh, Thành phố Cam Ranh, Tỉnh Khánh Hòa","code":"22432","parent_code":"569"},"22435":{"name":"Xã Cam Tân","type":"xa","slug":"xa-cam-tan","name_with_type":"Xã Cam Tân","path":"Xã Cam Tân, Huyện Cam Lâm, Tỉnh Khánh Hòa","path_with_type":"Xã Cam Tân, Huyện Cam Lâm, Tỉnh Khánh Hòa","code":"22435","parent_code":"570"},"22438":{"name":"Xã Cam Hòa","type":"xa","slug":"xa-cam-hoa","name_with_type":"Xã Cam Hòa","path":"Xã Cam Hòa, Huyện Cam Lâm, Tỉnh Khánh Hòa","path_with_type":"Xã Cam Hòa, Huyện Cam Lâm, Tỉnh Khánh Hòa","code":"22438","parent_code":"570"},"22441":{"name":"Xã Cam Hải Đông","type":"xa","slug":"xa-cam-hai-dong","name_with_type":"Xã Cam Hải Đông","path":"Xã Cam Hải Đông, Huyện Cam Lâm, Tỉnh Khánh Hòa","path_with_type":"Xã Cam Hải Đông, Huyện Cam Lâm, Tỉnh Khánh Hòa","code":"22441","parent_code":"570"},"22444":{"name":"Xã Cam Hải Tây","type":"xa","slug":"xa-cam-hai-tay","name_with_type":"Xã Cam Hải Tây","path":"Xã Cam Hải Tây, Huyện Cam Lâm, Tỉnh Khánh Hòa","path_with_type":"Xã Cam Hải Tây, Huyện Cam Lâm, Tỉnh Khánh Hòa","code":"22444","parent_code":"570"},"22447":{"name":"Xã Sơn Tân","type":"xa","slug":"xa-son-tan","name_with_type":"Xã Sơn Tân","path":"Xã Sơn Tân, Huyện Cam Lâm, Tỉnh Khánh Hòa","path_with_type":"Xã Sơn Tân, Huyện Cam Lâm, Tỉnh Khánh Hòa","code":"22447","parent_code":"570"},"22450":{"name":"Xã Cam Hiệp Bắc","type":"xa","slug":"xa-cam-hiep-bac","name_with_type":"Xã Cam Hiệp Bắc","path":"Xã Cam Hiệp Bắc, Huyện Cam Lâm, Tỉnh Khánh Hòa","path_with_type":"Xã Cam Hiệp Bắc, Huyện Cam Lâm, Tỉnh Khánh Hòa","code":"22450","parent_code":"570"},"22453":{"name":"Thị trấn Cam Đức","type":"thi-tran","slug":"thi-tran-cam-duc","name_with_type":"Thị trấn Cam Đức","path":"Thị trấn Cam Đức, Huyện Cam Lâm, Tỉnh Khánh Hòa","path_with_type":"Thị trấn Cam Đức, Huyện Cam Lâm, Tỉnh Khánh Hòa","code":"22453","parent_code":"570"},"22456":{"name":"Xã Cam Hiệp Nam","type":"xa","slug":"xa-cam-hiep-nam","name_with_type":"Xã Cam Hiệp Nam","path":"Xã Cam Hiệp Nam, Huyện Cam Lâm, Tỉnh Khánh Hòa","path_with_type":"Xã Cam Hiệp Nam, Huyện Cam Lâm, Tỉnh Khánh Hòa","code":"22456","parent_code":"570"},"22459":{"name":"Xã Cam Phước Tây","type":"xa","slug":"xa-cam-phuoc-tay","name_with_type":"Xã Cam Phước Tây","path":"Xã Cam Phước Tây, Huyện Cam Lâm, Tỉnh Khánh Hòa","path_with_type":"Xã Cam Phước Tây, Huyện Cam Lâm, Tỉnh Khánh Hòa","code":"22459","parent_code":"570"},"22462":{"name":"Xã Cam Thành Bắc","type":"xa","slug":"xa-cam-thanh-bac","name_with_type":"Xã Cam Thành Bắc","path":"Xã Cam Thành Bắc, Huyện Cam Lâm, Tỉnh Khánh Hòa","path_with_type":"Xã Cam Thành Bắc, Huyện Cam Lâm, Tỉnh Khánh Hòa","code":"22462","parent_code":"570"},"22465":{"name":"Xã Cam An Bắc","type":"xa","slug":"xa-cam-an-bac","name_with_type":"Xã Cam An Bắc","path":"Xã Cam An Bắc, Huyện Cam Lâm, Tỉnh Khánh Hòa","path_with_type":"Xã Cam An Bắc, Huyện Cam Lâm, Tỉnh Khánh Hòa","code":"22465","parent_code":"570"},"22468":{"name":"Xã Cam Thành Nam","type":"xa","slug":"xa-cam-thanh-nam","name_with_type":"Xã Cam Thành Nam","path":"Xã Cam Thành Nam, Thành phố Cam Ranh, Tỉnh Khánh Hòa","path_with_type":"Xã Cam Thành Nam, Thành phố Cam Ranh, Tỉnh Khánh Hòa","code":"22468","parent_code":"569"},"22471":{"name":"Xã Cam An Nam","type":"xa","slug":"xa-cam-an-nam","name_with_type":"Xã Cam An Nam","path":"Xã Cam An Nam, Huyện Cam Lâm, Tỉnh Khánh Hòa","path_with_type":"Xã Cam An Nam, Huyện Cam Lâm, Tỉnh Khánh Hòa","code":"22471","parent_code":"570"},"22474":{"name":"Xã Cam Phước Đông","type":"xa","slug":"xa-cam-phuoc-dong","name_with_type":"Xã Cam Phước Đông","path":"Xã Cam Phước Đông, Thành phố Cam Ranh, Tỉnh Khánh Hòa","path_with_type":"Xã Cam Phước Đông, Thành phố Cam Ranh, Tỉnh Khánh Hòa","code":"22474","parent_code":"569"},"22477":{"name":"Xã Cam Thịnh Tây","type":"xa","slug":"xa-cam-thinh-tay","name_with_type":"Xã Cam Thịnh Tây","path":"Xã Cam Thịnh Tây, Thành phố Cam Ranh, Tỉnh Khánh Hòa","path_with_type":"Xã Cam Thịnh Tây, Thành phố Cam Ranh, Tỉnh Khánh Hòa","code":"22477","parent_code":"569"},"22480":{"name":"Xã Cam Thịnh Đông","type":"xa","slug":"xa-cam-thinh-dong","name_with_type":"Xã Cam Thịnh Đông","path":"Xã Cam Thịnh Đông, Thành phố Cam Ranh, Tỉnh Khánh Hòa","path_with_type":"Xã Cam Thịnh Đông, Thành phố Cam Ranh, Tỉnh Khánh Hòa","code":"22480","parent_code":"569"},"22483":{"name":"Xã Cam Lập","type":"xa","slug":"xa-cam-lap","name_with_type":"Xã Cam Lập","path":"Xã Cam Lập, Thành phố Cam Ranh, Tỉnh Khánh Hòa","path_with_type":"Xã Cam Lập, Thành phố Cam Ranh, Tỉnh Khánh Hòa","code":"22483","parent_code":"569"},"22486":{"name":"Xã Cam Bình","type":"xa","slug":"xa-cam-binh","name_with_type":"Xã Cam Bình","path":"Xã Cam Bình, Thành phố Cam Ranh, Tỉnh Khánh Hòa","path_with_type":"Xã Cam Bình, Thành phố Cam Ranh, Tỉnh Khánh Hòa","code":"22486","parent_code":"569"},"22489":{"name":"Thị trấn Vạn Giã","type":"thi-tran","slug":"thi-tran-van-gia","name_with_type":"Thị trấn Vạn Giã","path":"Thị trấn Vạn Giã, Huyện Vạn Ninh, Tỉnh Khánh Hòa","path_with_type":"Thị trấn Vạn Giã, Huyện Vạn Ninh, Tỉnh Khánh Hòa","code":"22489","parent_code":"571"},"22492":{"name":"Xã Đại Lãnh","type":"xa","slug":"xa-dai-lanh","name_with_type":"Xã Đại Lãnh","path":"Xã Đại Lãnh, Huyện Vạn Ninh, Tỉnh Khánh Hòa","path_with_type":"Xã Đại Lãnh, Huyện Vạn Ninh, Tỉnh Khánh Hòa","code":"22492","parent_code":"571"},"22495":{"name":"Xã Vạn Phước","type":"xa","slug":"xa-van-phuoc","name_with_type":"Xã Vạn Phước","path":"Xã Vạn Phước, Huyện Vạn Ninh, Tỉnh Khánh Hòa","path_with_type":"Xã Vạn Phước, Huyện Vạn Ninh, Tỉnh Khánh Hòa","code":"22495","parent_code":"571"},"22498":{"name":"Xã Vạn Long","type":"xa","slug":"xa-van-long","name_with_type":"Xã Vạn Long","path":"Xã Vạn Long, Huyện Vạn Ninh, Tỉnh Khánh Hòa","path_with_type":"Xã Vạn Long, Huyện Vạn Ninh, Tỉnh Khánh Hòa","code":"22498","parent_code":"571"},"22501":{"name":"Xã Vạn Bình","type":"xa","slug":"xa-van-binh","name_with_type":"Xã Vạn Bình","path":"Xã Vạn Bình, Huyện Vạn Ninh, Tỉnh Khánh Hòa","path_with_type":"Xã Vạn Bình, Huyện Vạn Ninh, Tỉnh Khánh Hòa","code":"22501","parent_code":"571"},"22504":{"name":"Xã Vạn Thọ","type":"xa","slug":"xa-van-tho","name_with_type":"Xã Vạn Thọ","path":"Xã Vạn Thọ, Huyện Vạn Ninh, Tỉnh Khánh Hòa","path_with_type":"Xã Vạn Thọ, Huyện Vạn Ninh, Tỉnh Khánh Hòa","code":"22504","parent_code":"571"},"22507":{"name":"Xã Vạn Khánh","type":"xa","slug":"xa-van-khanh","name_with_type":"Xã Vạn Khánh","path":"Xã Vạn Khánh, Huyện Vạn Ninh, Tỉnh Khánh Hòa","path_with_type":"Xã Vạn Khánh, Huyện Vạn Ninh, Tỉnh Khánh Hòa","code":"22507","parent_code":"571"},"22510":{"name":"Xã Vạn Phú","type":"xa","slug":"xa-van-phu","name_with_type":"Xã Vạn Phú","path":"Xã Vạn Phú, Huyện Vạn Ninh, Tỉnh Khánh Hòa","path_with_type":"Xã Vạn Phú, Huyện Vạn Ninh, Tỉnh Khánh Hòa","code":"22510","parent_code":"571"},"22513":{"name":"Xã Vạn Lương","type":"xa","slug":"xa-van-luong","name_with_type":"Xã Vạn Lương","path":"Xã Vạn Lương, Huyện Vạn Ninh, Tỉnh Khánh Hòa","path_with_type":"Xã Vạn Lương, Huyện Vạn Ninh, Tỉnh Khánh Hòa","code":"22513","parent_code":"571"},"22516":{"name":"Xã Vạn Thắng","type":"xa","slug":"xa-van-thang","name_with_type":"Xã Vạn Thắng","path":"Xã Vạn Thắng, Huyện Vạn Ninh, Tỉnh Khánh Hòa","path_with_type":"Xã Vạn Thắng, Huyện Vạn Ninh, Tỉnh Khánh Hòa","code":"22516","parent_code":"571"},"22519":{"name":"Xã Vạn Thạnh","type":"xa","slug":"xa-van-thanh","name_with_type":"Xã Vạn Thạnh","path":"Xã Vạn Thạnh, Huyện Vạn Ninh, Tỉnh Khánh Hòa","path_with_type":"Xã Vạn Thạnh, Huyện Vạn Ninh, Tỉnh Khánh Hòa","code":"22519","parent_code":"571"},"22522":{"name":"Xã Xuân Sơn","type":"xa","slug":"xa-xuan-son","name_with_type":"Xã Xuân Sơn","path":"Xã Xuân Sơn, Huyện Vạn Ninh, Tỉnh Khánh Hòa","path_with_type":"Xã Xuân Sơn, Huyện Vạn Ninh, Tỉnh Khánh Hòa","code":"22522","parent_code":"571"},"22525":{"name":"Xã Vạn Hưng","type":"xa","slug":"xa-van-hung","name_with_type":"Xã Vạn Hưng","path":"Xã Vạn Hưng, Huyện Vạn Ninh, Tỉnh Khánh Hòa","path_with_type":"Xã Vạn Hưng, Huyện Vạn Ninh, Tỉnh Khánh Hòa","code":"22525","parent_code":"571"},"22528":{"name":"Phường Ninh Hiệp","type":"phuong","slug":"phuong-ninh-hiep","name_with_type":"Phường Ninh Hiệp","path":"Phường Ninh Hiệp, Thị xã Ninh Hòa, Tỉnh Khánh Hòa","path_with_type":"Phường Ninh Hiệp, Thị xã Ninh Hòa, Tỉnh Khánh Hòa","code":"22528","parent_code":"572"},"22531":{"name":"Xã Ninh Sơn","type":"xa","slug":"xa-ninh-son","name_with_type":"Xã Ninh Sơn","path":"Xã Ninh Sơn, Thị xã Ninh Hòa, Tỉnh Khánh Hòa","path_with_type":"Xã Ninh Sơn, Thị xã Ninh Hòa, Tỉnh Khánh Hòa","code":"22531","parent_code":"572"},"22534":{"name":"Xã Ninh Tây","type":"xa","slug":"xa-ninh-tay","name_with_type":"Xã Ninh Tây","path":"Xã Ninh Tây, Thị xã Ninh Hòa, Tỉnh Khánh Hòa","path_with_type":"Xã Ninh Tây, Thị xã Ninh Hòa, Tỉnh Khánh Hòa","code":"22534","parent_code":"572"},"22537":{"name":"Xã Ninh Thượng","type":"xa","slug":"xa-ninh-thuong","name_with_type":"Xã Ninh Thượng","path":"Xã Ninh Thượng, Thị xã Ninh Hòa, Tỉnh Khánh Hòa","path_with_type":"Xã Ninh Thượng, Thị xã Ninh Hòa, Tỉnh Khánh Hòa","code":"22537","parent_code":"572"},"22540":{"name":"Xã Ninh An","type":"xa","slug":"xa-ninh-an","name_with_type":"Xã Ninh An","path":"Xã Ninh An, Thị xã Ninh Hòa, Tỉnh Khánh Hòa","path_with_type":"Xã Ninh An, Thị xã Ninh Hòa, Tỉnh Khánh Hòa","code":"22540","parent_code":"572"},"22543":{"name":"Phường Ninh Hải","type":"phuong","slug":"phuong-ninh-hai","name_with_type":"Phường Ninh Hải","path":"Phường Ninh Hải, Thị xã Ninh Hòa, Tỉnh Khánh Hòa","path_with_type":"Phường Ninh Hải, Thị xã Ninh Hòa, Tỉnh Khánh Hòa","code":"22543","parent_code":"572"},"22546":{"name":"Xã Ninh Thọ","type":"xa","slug":"xa-ninh-tho","name_with_type":"Xã Ninh Thọ","path":"Xã Ninh Thọ, Thị xã Ninh Hòa, Tỉnh Khánh Hòa","path_with_type":"Xã Ninh Thọ, Thị xã Ninh Hòa, Tỉnh Khánh Hòa","code":"22546","parent_code":"572"},"22549":{"name":"Xã Ninh Trung","type":"xa","slug":"xa-ninh-trung","name_with_type":"Xã Ninh Trung","path":"Xã Ninh Trung, Thị xã Ninh Hòa, Tỉnh Khánh Hòa","path_with_type":"Xã Ninh Trung, Thị xã Ninh Hòa, Tỉnh Khánh Hòa","code":"22549","parent_code":"572"},"22552":{"name":"Xã Ninh Sim","type":"xa","slug":"xa-ninh-sim","name_with_type":"Xã Ninh Sim","path":"Xã Ninh Sim, Thị xã Ninh Hòa, Tỉnh Khánh Hòa","path_with_type":"Xã Ninh Sim, Thị xã Ninh Hòa, Tỉnh Khánh Hòa","code":"22552","parent_code":"572"},"22555":{"name":"Xã Ninh Xuân","type":"xa","slug":"xa-ninh-xuan","name_with_type":"Xã Ninh Xuân","path":"Xã Ninh Xuân, Thị xã Ninh Hòa, Tỉnh Khánh Hòa","path_with_type":"Xã Ninh Xuân, Thị xã Ninh Hòa, Tỉnh Khánh Hòa","code":"22555","parent_code":"572"},"22558":{"name":"Xã Ninh Thân","type":"xa","slug":"xa-ninh-than","name_with_type":"Xã Ninh Thân","path":"Xã Ninh Thân, Thị xã Ninh Hòa, Tỉnh Khánh Hòa","path_with_type":"Xã Ninh Thân, Thị xã Ninh Hòa, Tỉnh Khánh Hòa","code":"22558","parent_code":"572"},"22561":{"name":"Phường Ninh Diêm","type":"phuong","slug":"phuong-ninh-diem","name_with_type":"Phường Ninh Diêm","path":"Phường Ninh Diêm, Thị xã Ninh Hòa, Tỉnh Khánh Hòa","path_with_type":"Phường Ninh Diêm, Thị xã Ninh Hòa, Tỉnh Khánh Hòa","code":"22561","parent_code":"572"},"22564":{"name":"Xã Ninh Đông","type":"xa","slug":"xa-ninh-dong","name_with_type":"Xã Ninh Đông","path":"Xã Ninh Đông, Thị xã Ninh Hòa, Tỉnh Khánh Hòa","path_with_type":"Xã Ninh Đông, Thị xã Ninh Hòa, Tỉnh Khánh Hòa","code":"22564","parent_code":"572"},"22567":{"name":"Phường Ninh Thủy","type":"phuong","slug":"phuong-ninh-thuy","name_with_type":"Phường Ninh Thủy","path":"Phường Ninh Thủy, Thị xã Ninh Hòa, Tỉnh Khánh Hòa","path_with_type":"Phường Ninh Thủy, Thị xã Ninh Hòa, Tỉnh Khánh Hòa","code":"22567","parent_code":"572"},"22570":{"name":"Phường Ninh Đa","type":"phuong","slug":"phuong-ninh-da","name_with_type":"Phường Ninh Đa","path":"Phường Ninh Đa, Thị xã Ninh Hòa, Tỉnh Khánh Hòa","path_with_type":"Phường Ninh Đa, Thị xã Ninh Hòa, Tỉnh Khánh Hòa","code":"22570","parent_code":"572"},"22573":{"name":"Xã Ninh Phụng","type":"xa","slug":"xa-ninh-phung","name_with_type":"Xã Ninh Phụng","path":"Xã Ninh Phụng, Thị xã Ninh Hòa, Tỉnh Khánh Hòa","path_with_type":"Xã Ninh Phụng, Thị xã Ninh Hòa, Tỉnh Khánh Hòa","code":"22573","parent_code":"572"},"22576":{"name":"Xã Ninh Bình","type":"xa","slug":"xa-ninh-binh","name_with_type":"Xã Ninh Bình","path":"Xã Ninh Bình, Thị xã Ninh Hòa, Tỉnh Khánh Hòa","path_with_type":"Xã Ninh Bình, Thị xã Ninh Hòa, Tỉnh Khánh Hòa","code":"22576","parent_code":"572"},"22582":{"name":"Xã Ninh Phú","type":"xa","slug":"xa-ninh-phu","name_with_type":"Xã Ninh Phú","path":"Xã Ninh Phú, Thị xã Ninh Hòa, Tỉnh Khánh Hòa","path_with_type":"Xã Ninh Phú, Thị xã Ninh Hòa, Tỉnh Khánh Hòa","code":"22582","parent_code":"572"},"22585":{"name":"Xã Ninh Tân","type":"xa","slug":"xa-ninh-tan","name_with_type":"Xã Ninh Tân","path":"Xã Ninh Tân, Thị xã Ninh Hòa, Tỉnh Khánh Hòa","path_with_type":"Xã Ninh Tân, Thị xã Ninh Hòa, Tỉnh Khánh Hòa","code":"22585","parent_code":"572"},"22588":{"name":"Xã Ninh Quang","type":"xa","slug":"xa-ninh-quang","name_with_type":"Xã Ninh Quang","path":"Xã Ninh Quang, Thị xã Ninh Hòa, Tỉnh Khánh Hòa","path_with_type":"Xã Ninh Quang, Thị xã Ninh Hòa, Tỉnh Khánh Hòa","code":"22588","parent_code":"572"},"22591":{"name":"Phường Ninh Giang","type":"phuong","slug":"phuong-ninh-giang","name_with_type":"Phường Ninh Giang","path":"Phường Ninh Giang, Thị xã Ninh Hòa, Tỉnh Khánh Hòa","path_with_type":"Phường Ninh Giang, Thị xã Ninh Hòa, Tỉnh Khánh Hòa","code":"22591","parent_code":"572"},"22594":{"name":"Phường Ninh Hà","type":"phuong","slug":"phuong-ninh-ha","name_with_type":"Phường Ninh Hà","path":"Phường Ninh Hà, Thị xã Ninh Hòa, Tỉnh Khánh Hòa","path_with_type":"Phường Ninh Hà, Thị xã Ninh Hòa, Tỉnh Khánh Hòa","code":"22594","parent_code":"572"},"22597":{"name":"Xã Ninh Hưng","type":"xa","slug":"xa-ninh-hung","name_with_type":"Xã Ninh Hưng","path":"Xã Ninh Hưng, Thị xã Ninh Hòa, Tỉnh Khánh Hòa","path_with_type":"Xã Ninh Hưng, Thị xã Ninh Hòa, Tỉnh Khánh Hòa","code":"22597","parent_code":"572"},"22600":{"name":"Xã Ninh Lộc","type":"xa","slug":"xa-ninh-loc","name_with_type":"Xã Ninh Lộc","path":"Xã Ninh Lộc, Thị xã Ninh Hòa, Tỉnh Khánh Hòa","path_with_type":"Xã Ninh Lộc, Thị xã Ninh Hòa, Tỉnh Khánh Hòa","code":"22600","parent_code":"572"},"22603":{"name":"Xã Ninh Ích","type":"xa","slug":"xa-ninh-ich","name_with_type":"Xã Ninh Ích","path":"Xã Ninh Ích, Thị xã Ninh Hòa, Tỉnh Khánh Hòa","path_with_type":"Xã Ninh Ích, Thị xã Ninh Hòa, Tỉnh Khánh Hòa","code":"22603","parent_code":"572"},"22606":{"name":"Xã Ninh Phước","type":"xa","slug":"xa-ninh-phuoc","name_with_type":"Xã Ninh Phước","path":"Xã Ninh Phước, Thị xã Ninh Hòa, Tỉnh Khánh Hòa","path_with_type":"Xã Ninh Phước, Thị xã Ninh Hòa, Tỉnh Khánh Hòa","code":"22606","parent_code":"572"},"22609":{"name":"Thị trấn Khánh Vĩnh","type":"thi-tran","slug":"thi-tran-khanh-vinh","name_with_type":"Thị trấn Khánh Vĩnh","path":"Thị trấn Khánh Vĩnh, Huyện Khánh Vĩnh, Tỉnh Khánh Hòa","path_with_type":"Thị trấn Khánh Vĩnh, Huyện Khánh Vĩnh, Tỉnh Khánh Hòa","code":"22609","parent_code":"573"},"22612":{"name":"Xã Khánh Hiệp","type":"xa","slug":"xa-khanh-hiep","name_with_type":"Xã Khánh Hiệp","path":"Xã Khánh Hiệp, Huyện Khánh Vĩnh, Tỉnh Khánh Hòa","path_with_type":"Xã Khánh Hiệp, Huyện Khánh Vĩnh, Tỉnh Khánh Hòa","code":"22612","parent_code":"573"},"22615":{"name":"Xã Khánh Bình","type":"xa","slug":"xa-khanh-binh","name_with_type":"Xã Khánh Bình","path":"Xã Khánh Bình, Huyện Khánh Vĩnh, Tỉnh Khánh Hòa","path_with_type":"Xã Khánh Bình, Huyện Khánh Vĩnh, Tỉnh Khánh Hòa","code":"22615","parent_code":"573"},"22618":{"name":"Xã Khánh Trung","type":"xa","slug":"xa-khanh-trung","name_with_type":"Xã Khánh Trung","path":"Xã Khánh Trung, Huyện Khánh Vĩnh, Tỉnh Khánh Hòa","path_with_type":"Xã Khánh Trung, Huyện Khánh Vĩnh, Tỉnh Khánh Hòa","code":"22618","parent_code":"573"},"22621":{"name":"Xã Khánh Đông","type":"xa","slug":"xa-khanh-dong","name_with_type":"Xã Khánh Đông","path":"Xã Khánh Đông, Huyện Khánh Vĩnh, Tỉnh Khánh Hòa","path_with_type":"Xã Khánh Đông, Huyện Khánh Vĩnh, Tỉnh Khánh Hòa","code":"22621","parent_code":"573"},"22624":{"name":"Xã Khánh Thượng","type":"xa","slug":"xa-khanh-thuong","name_with_type":"Xã Khánh Thượng","path":"Xã Khánh Thượng, Huyện Khánh Vĩnh, Tỉnh Khánh Hòa","path_with_type":"Xã Khánh Thượng, Huyện Khánh Vĩnh, Tỉnh Khánh Hòa","code":"22624","parent_code":"573"},"22627":{"name":"Xã Khánh Nam","type":"xa","slug":"xa-khanh-nam","name_with_type":"Xã Khánh Nam","path":"Xã Khánh Nam, Huyện Khánh Vĩnh, Tỉnh Khánh Hòa","path_with_type":"Xã Khánh Nam, Huyện Khánh Vĩnh, Tỉnh Khánh Hòa","code":"22627","parent_code":"573"},"22630":{"name":"Xã Sông Cầu","type":"xa","slug":"xa-song-cau","name_with_type":"Xã Sông Cầu","path":"Xã Sông Cầu, Huyện Khánh Vĩnh, Tỉnh Khánh Hòa","path_with_type":"Xã Sông Cầu, Huyện Khánh Vĩnh, Tỉnh Khánh Hòa","code":"22630","parent_code":"573"},"22633":{"name":"Xã Giang Ly","type":"xa","slug":"xa-giang-ly","name_with_type":"Xã Giang Ly","path":"Xã Giang Ly, Huyện Khánh Vĩnh, Tỉnh Khánh Hòa","path_with_type":"Xã Giang Ly, Huyện Khánh Vĩnh, Tỉnh Khánh Hòa","code":"22633","parent_code":"573"},"22636":{"name":"Xã Cầu Bà","type":"xa","slug":"xa-cau-ba","name_with_type":"Xã Cầu Bà","path":"Xã Cầu Bà, Huyện Khánh Vĩnh, Tỉnh Khánh Hòa","path_with_type":"Xã Cầu Bà, Huyện Khánh Vĩnh, Tỉnh Khánh Hòa","code":"22636","parent_code":"573"},"22639":{"name":"Xã Liên Sang","type":"xa","slug":"xa-lien-sang","name_with_type":"Xã Liên Sang","path":"Xã Liên Sang, Huyện Khánh Vĩnh, Tỉnh Khánh Hòa","path_with_type":"Xã Liên Sang, Huyện Khánh Vĩnh, Tỉnh Khánh Hòa","code":"22639","parent_code":"573"},"22642":{"name":"Xã Khánh Thành","type":"xa","slug":"xa-khanh-thanh","name_with_type":"Xã Khánh Thành","path":"Xã Khánh Thành, Huyện Khánh Vĩnh, Tỉnh Khánh Hòa","path_with_type":"Xã Khánh Thành, Huyện Khánh Vĩnh, Tỉnh Khánh Hòa","code":"22642","parent_code":"573"},"22645":{"name":"Xã Khánh Phú","type":"xa","slug":"xa-khanh-phu","name_with_type":"Xã Khánh Phú","path":"Xã Khánh Phú, Huyện Khánh Vĩnh, Tỉnh Khánh Hòa","path_with_type":"Xã Khánh Phú, Huyện Khánh Vĩnh, Tỉnh Khánh Hòa","code":"22645","parent_code":"573"},"22648":{"name":"Xã Sơn Thái","type":"xa","slug":"xa-son-thai","name_with_type":"Xã Sơn Thái","path":"Xã Sơn Thái, Huyện Khánh Vĩnh, Tỉnh Khánh Hòa","path_with_type":"Xã Sơn Thái, Huyện Khánh Vĩnh, Tỉnh Khánh Hòa","code":"22648","parent_code":"573"},"22651":{"name":"Thị trấn Diên Khánh","type":"thi-tran","slug":"thi-tran-dien-khanh","name_with_type":"Thị trấn Diên Khánh","path":"Thị trấn Diên Khánh, Huyện Diên Khánh, Tỉnh Khánh Hòa","path_with_type":"Thị trấn Diên Khánh, Huyện Diên Khánh, Tỉnh Khánh Hòa","code":"22651","parent_code":"574"},"22654":{"name":"Xã Diên Lâm","type":"xa","slug":"xa-dien-lam","name_with_type":"Xã Diên Lâm","path":"Xã Diên Lâm, Huyện Diên Khánh, Tỉnh Khánh Hòa","path_with_type":"Xã Diên Lâm, Huyện Diên Khánh, Tỉnh Khánh Hòa","code":"22654","parent_code":"574"},"22657":{"name":"Xã Diên Điền","type":"xa","slug":"xa-dien-dien","name_with_type":"Xã Diên Điền","path":"Xã Diên Điền, Huyện Diên Khánh, Tỉnh Khánh Hòa","path_with_type":"Xã Diên Điền, Huyện Diên Khánh, Tỉnh Khánh Hòa","code":"22657","parent_code":"574"},"22660":{"name":"Xã Xuân Đồng","type":"xa","slug":"xa-xuan-dong","name_with_type":"Xã Xuân Đồng","path":"Xã Xuân Đồng, Huyện Diên Khánh, Tỉnh Khánh Hòa","path_with_type":"Xã Xuân Đồng, Huyện Diên Khánh, Tỉnh Khánh Hòa","code":"22660","parent_code":"574"},"22663":{"name":"Xã Diên Sơn","type":"xa","slug":"xa-dien-son","name_with_type":"Xã Diên Sơn","path":"Xã Diên Sơn, Huyện Diên Khánh, Tỉnh Khánh Hòa","path_with_type":"Xã Diên Sơn, Huyện Diên Khánh, Tỉnh Khánh Hòa","code":"22663","parent_code":"574"},"22669":{"name":"Xã Diên Phú","type":"xa","slug":"xa-dien-phu","name_with_type":"Xã Diên Phú","path":"Xã Diên Phú, Huyện Diên Khánh, Tỉnh Khánh Hòa","path_with_type":"Xã Diên Phú, Huyện Diên Khánh, Tỉnh Khánh Hòa","code":"22669","parent_code":"574"},"22672":{"name":"Xã Diên Thọ","type":"xa","slug":"xa-dien-tho","name_with_type":"Xã Diên Thọ","path":"Xã Diên Thọ, Huyện Diên Khánh, Tỉnh Khánh Hòa","path_with_type":"Xã Diên Thọ, Huyện Diên Khánh, Tỉnh Khánh Hòa","code":"22672","parent_code":"574"},"22675":{"name":"Xã Diên Phước","type":"xa","slug":"xa-dien-phuoc","name_with_type":"Xã Diên Phước","path":"Xã Diên Phước, Huyện Diên Khánh, Tỉnh Khánh Hòa","path_with_type":"Xã Diên Phước, Huyện Diên Khánh, Tỉnh Khánh Hòa","code":"22675","parent_code":"574"},"22678":{"name":"Xã Diên Lạc","type":"xa","slug":"xa-dien-lac","name_with_type":"Xã Diên Lạc","path":"Xã Diên Lạc, Huyện Diên Khánh, Tỉnh Khánh Hòa","path_with_type":"Xã Diên Lạc, Huyện Diên Khánh, Tỉnh Khánh Hòa","code":"22678","parent_code":"574"},"22681":{"name":"Xã Diên Tân","type":"xa","slug":"xa-dien-tan","name_with_type":"Xã Diên Tân","path":"Xã Diên Tân, Huyện Diên Khánh, Tỉnh Khánh Hòa","path_with_type":"Xã Diên Tân, Huyện Diên Khánh, Tỉnh Khánh Hòa","code":"22681","parent_code":"574"},"22684":{"name":"Xã Diên Hòa","type":"xa","slug":"xa-dien-hoa","name_with_type":"Xã Diên Hòa","path":"Xã Diên Hòa, Huyện Diên Khánh, Tỉnh Khánh Hòa","path_with_type":"Xã Diên Hòa, Huyện Diên Khánh, Tỉnh Khánh Hòa","code":"22684","parent_code":"574"},"22687":{"name":"Xã Diên Thạnh","type":"xa","slug":"xa-dien-thanh","name_with_type":"Xã Diên Thạnh","path":"Xã Diên Thạnh, Huyện Diên Khánh, Tỉnh Khánh Hòa","path_with_type":"Xã Diên Thạnh, Huyện Diên Khánh, Tỉnh Khánh Hòa","code":"22687","parent_code":"574"},"22690":{"name":"Xã Diên Toàn","type":"xa","slug":"xa-dien-toan","name_with_type":"Xã Diên Toàn","path":"Xã Diên Toàn, Huyện Diên Khánh, Tỉnh Khánh Hòa","path_with_type":"Xã Diên Toàn, Huyện Diên Khánh, Tỉnh Khánh Hòa","code":"22690","parent_code":"574"},"22693":{"name":"Xã Diên An","type":"xa","slug":"xa-dien-an","name_with_type":"Xã Diên An","path":"Xã Diên An, Huyện Diên Khánh, Tỉnh Khánh Hòa","path_with_type":"Xã Diên An, Huyện Diên Khánh, Tỉnh Khánh Hòa","code":"22693","parent_code":"574"},"22696":{"name":"Xã Bình Lộc","type":"xa","slug":"xa-binh-loc","name_with_type":"Xã Bình Lộc","path":"Xã Bình Lộc, Huyện Diên Khánh, Tỉnh Khánh Hòa","path_with_type":"Xã Bình Lộc, Huyện Diên Khánh, Tỉnh Khánh Hòa","code":"22696","parent_code":"574"},"22702":{"name":"Xã Suối Hiệp","type":"xa","slug":"xa-suoi-hiep","name_with_type":"Xã Suối Hiệp","path":"Xã Suối Hiệp, Huyện Diên Khánh, Tỉnh Khánh Hòa","path_with_type":"Xã Suối Hiệp, Huyện Diên Khánh, Tỉnh Khánh Hòa","code":"22702","parent_code":"574"},"22705":{"name":"Xã Suối Tiên","type":"xa","slug":"xa-suoi-tien","name_with_type":"Xã Suối Tiên","path":"Xã Suối Tiên, Huyện Diên Khánh, Tỉnh Khánh Hòa","path_with_type":"Xã Suối Tiên, Huyện Diên Khánh, Tỉnh Khánh Hòa","code":"22705","parent_code":"574"},"22708":{"name":"Xã Suối Cát","type":"xa","slug":"xa-suoi-cat","name_with_type":"Xã Suối Cát","path":"Xã Suối Cát, Huyện Cam Lâm, Tỉnh Khánh Hòa","path_with_type":"Xã Suối Cát, Huyện Cam Lâm, Tỉnh Khánh Hòa","code":"22708","parent_code":"570"},"22711":{"name":"Xã Suối Tân","type":"xa","slug":"xa-suoi-tan","name_with_type":"Xã Suối Tân","path":"Xã Suối Tân, Huyện Cam Lâm, Tỉnh Khánh Hòa","path_with_type":"Xã Suối Tân, Huyện Cam Lâm, Tỉnh Khánh Hòa","code":"22711","parent_code":"570"},"22714":{"name":"Thị trấn Tô Hạp","type":"thi-tran","slug":"thi-tran-to-hap","name_with_type":"Thị trấn Tô Hạp","path":"Thị trấn Tô Hạp, Huyện Khánh Sơn, Tỉnh Khánh Hòa","path_with_type":"Thị trấn Tô Hạp, Huyện Khánh Sơn, Tỉnh Khánh Hòa","code":"22714","parent_code":"575"},"22717":{"name":"Xã Thành Sơn","type":"xa","slug":"xa-thanh-son","name_with_type":"Xã Thành Sơn","path":"Xã Thành Sơn, Huyện Khánh Sơn, Tỉnh Khánh Hòa","path_with_type":"Xã Thành Sơn, Huyện Khánh Sơn, Tỉnh Khánh Hòa","code":"22717","parent_code":"575"},"22720":{"name":"Xã Sơn Lâm","type":"xa","slug":"xa-son-lam","name_with_type":"Xã Sơn Lâm","path":"Xã Sơn Lâm, Huyện Khánh Sơn, Tỉnh Khánh Hòa","path_with_type":"Xã Sơn Lâm, Huyện Khánh Sơn, Tỉnh Khánh Hòa","code":"22720","parent_code":"575"},"22723":{"name":"Xã Sơn Hiệp","type":"xa","slug":"xa-son-hiep","name_with_type":"Xã Sơn Hiệp","path":"Xã Sơn Hiệp, Huyện Khánh Sơn, Tỉnh Khánh Hòa","path_with_type":"Xã Sơn Hiệp, Huyện Khánh Sơn, Tỉnh Khánh Hòa","code":"22723","parent_code":"575"},"22726":{"name":"Xã Sơn Bình","type":"xa","slug":"xa-son-binh","name_with_type":"Xã Sơn Bình","path":"Xã Sơn Bình, Huyện Khánh Sơn, Tỉnh Khánh Hòa","path_with_type":"Xã Sơn Bình, Huyện Khánh Sơn, Tỉnh Khánh Hòa","code":"22726","parent_code":"575"},"22729":{"name":"Xã Sơn Trung","type":"xa","slug":"xa-son-trung","name_with_type":"Xã Sơn Trung","path":"Xã Sơn Trung, Huyện Khánh Sơn, Tỉnh Khánh Hòa","path_with_type":"Xã Sơn Trung, Huyện Khánh Sơn, Tỉnh Khánh Hòa","code":"22729","parent_code":"575"},"22732":{"name":"Xã Ba Cụm Bắc","type":"xa","slug":"xa-ba-cum-bac","name_with_type":"Xã Ba Cụm Bắc","path":"Xã Ba Cụm Bắc, Huyện Khánh Sơn, Tỉnh Khánh Hòa","path_with_type":"Xã Ba Cụm Bắc, Huyện Khánh Sơn, Tỉnh Khánh Hòa","code":"22732","parent_code":"575"},"22735":{"name":"Xã Ba Cụm Nam","type":"xa","slug":"xa-ba-cum-nam","name_with_type":"Xã Ba Cụm Nam","path":"Xã Ba Cụm Nam, Huyện Khánh Sơn, Tỉnh Khánh Hòa","path_with_type":"Xã Ba Cụm Nam, Huyện Khánh Sơn, Tỉnh Khánh Hòa","code":"22735","parent_code":"575"},"22736":{"name":"Thị trấn Trường Sa","type":"thi-tran","slug":"thi-tran-truong-sa","name_with_type":"Thị trấn Trường Sa","path":"Thị trấn Trường Sa, Huyện Trường Sa, Tỉnh Khánh Hòa","path_with_type":"Thị trấn Trường Sa, Huyện Trường Sa, Tỉnh Khánh Hòa","code":"22736","parent_code":"576"},"22737":{"name":"Xã Song Tử Tây","type":"xa","slug":"xa-song-tu-tay","name_with_type":"Xã Song Tử Tây","path":"Xã Song Tử Tây, Huyện Trường Sa, Tỉnh Khánh Hòa","path_with_type":"Xã Song Tử Tây, Huyện Trường Sa, Tỉnh Khánh Hòa","code":"22737","parent_code":"576"},"22738":{"name":"Phường Đô Vinh","type":"phuong","slug":"phuong-do-vinh","name_with_type":"Phường Đô Vinh","path":"Phường Đô Vinh, Thành phố Phan Rang-Tháp Chàm, Tỉnh Ninh Thuận","path_with_type":"Phường Đô Vinh, Thành phố Phan Rang-Tháp Chàm, Tỉnh Ninh Thuận","code":"22738","parent_code":"582"},"22739":{"name":"Xã Sinh Tồn","type":"xa","slug":"xa-sinh-ton","name_with_type":"Xã Sinh Tồn","path":"Xã Sinh Tồn, Huyện Trường Sa, Tỉnh Khánh Hòa","path_with_type":"Xã Sinh Tồn, Huyện Trường Sa, Tỉnh Khánh Hòa","code":"22739","parent_code":"576"},"22741":{"name":"Phường Phước Mỹ","type":"phuong","slug":"phuong-phuoc-my","name_with_type":"Phường Phước Mỹ","path":"Phường Phước Mỹ, Thành phố Phan Rang-Tháp Chàm, Tỉnh Ninh Thuận","path_with_type":"Phường Phước Mỹ, Thành phố Phan Rang-Tháp Chàm, Tỉnh Ninh Thuận","code":"22741","parent_code":"582"},"22744":{"name":"Phường Bảo An","type":"phuong","slug":"phuong-bao-an","name_with_type":"Phường Bảo An","path":"Phường Bảo An, Thành phố Phan Rang-Tháp Chàm, Tỉnh Ninh Thuận","path_with_type":"Phường Bảo An, Thành phố Phan Rang-Tháp Chàm, Tỉnh Ninh Thuận","code":"22744","parent_code":"582"},"22750":{"name":"Phường Phủ Hà","type":"phuong","slug":"phuong-phu-ha","name_with_type":"Phường Phủ Hà","path":"Phường Phủ Hà, Thành phố Phan Rang-Tháp Chàm, Tỉnh Ninh Thuận","path_with_type":"Phường Phủ Hà, Thành phố Phan Rang-Tháp Chàm, Tỉnh Ninh Thuận","code":"22750","parent_code":"582"},"22759":{"name":"Phường Kinh Dinh","type":"phuong","slug":"phuong-kinh-dinh","name_with_type":"Phường Kinh Dinh","path":"Phường Kinh Dinh, Thành phố Phan Rang-Tháp Chàm, Tỉnh Ninh Thuận","path_with_type":"Phường Kinh Dinh, Thành phố Phan Rang-Tháp Chàm, Tỉnh Ninh Thuận","code":"22759","parent_code":"582"},"22762":{"name":"Phường Đạo Long","type":"phuong","slug":"phuong-dao-long","name_with_type":"Phường Đạo Long","path":"Phường Đạo Long, Thành phố Phan Rang-Tháp Chàm, Tỉnh Ninh Thuận","path_with_type":"Phường Đạo Long, Thành phố Phan Rang-Tháp Chàm, Tỉnh Ninh Thuận","code":"22762","parent_code":"582"},"22765":{"name":"Phường Đài Sơn","type":"phuong","slug":"phuong-dai-son","name_with_type":"Phường Đài Sơn","path":"Phường Đài Sơn, Thành phố Phan Rang-Tháp Chàm, Tỉnh Ninh Thuận","path_with_type":"Phường Đài Sơn, Thành phố Phan Rang-Tháp Chàm, Tỉnh Ninh Thuận","code":"22765","parent_code":"582"},"22768":{"name":"Phường Đông Hải","type":"phuong","slug":"phuong-dong-hai","name_with_type":"Phường Đông Hải","path":"Phường Đông Hải, Thành phố Phan Rang-Tháp Chàm, Tỉnh Ninh Thuận","path_with_type":"Phường Đông Hải, Thành phố Phan Rang-Tháp Chàm, Tỉnh Ninh Thuận","code":"22768","parent_code":"582"},"22771":{"name":"Phường Mỹ Đông","type":"phuong","slug":"phuong-my-dong","name_with_type":"Phường Mỹ Đông","path":"Phường Mỹ Đông, Thành phố Phan Rang-Tháp Chàm, Tỉnh Ninh Thuận","path_with_type":"Phường Mỹ Đông, Thành phố Phan Rang-Tháp Chàm, Tỉnh Ninh Thuận","code":"22771","parent_code":"582"},"22774":{"name":"Xã Thành Hải","type":"xa","slug":"xa-thanh-hai","name_with_type":"Xã Thành Hải","path":"Xã Thành Hải, Thành phố Phan Rang-Tháp Chàm, Tỉnh Ninh Thuận","path_with_type":"Xã Thành Hải, Thành phố Phan Rang-Tháp Chàm, Tỉnh Ninh Thuận","code":"22774","parent_code":"582"},"22777":{"name":"Phường Văn Hải","type":"phuong","slug":"phuong-van-hai","name_with_type":"Phường Văn Hải","path":"Phường Văn Hải, Thành phố Phan Rang-Tháp Chàm, Tỉnh Ninh Thuận","path_with_type":"Phường Văn Hải, Thành phố Phan Rang-Tháp Chàm, Tỉnh Ninh Thuận","code":"22777","parent_code":"582"},"22779":{"name":"Phường Mỹ Bình","type":"phuong","slug":"phuong-my-binh","name_with_type":"Phường Mỹ Bình","path":"Phường Mỹ Bình, Thành phố Phan Rang-Tháp Chàm, Tỉnh Ninh Thuận","path_with_type":"Phường Mỹ Bình, Thành phố Phan Rang-Tháp Chàm, Tỉnh Ninh Thuận","code":"22779","parent_code":"582"},"22780":{"name":"Phường Mỹ Hải","type":"phuong","slug":"phuong-my-hai","name_with_type":"Phường Mỹ Hải","path":"Phường Mỹ Hải, Thành phố Phan Rang-Tháp Chàm, Tỉnh Ninh Thuận","path_with_type":"Phường Mỹ Hải, Thành phố Phan Rang-Tháp Chàm, Tỉnh Ninh Thuận","code":"22780","parent_code":"582"},"22783":{"name":"Xã Phước Bình","type":"xa","slug":"xa-phuoc-binh","name_with_type":"Xã Phước Bình","path":"Xã Phước Bình, Huyện Bác Ái, Tỉnh Ninh Thuận","path_with_type":"Xã Phước Bình, Huyện Bác Ái, Tỉnh Ninh Thuận","code":"22783","parent_code":"584"},"22786":{"name":"Xã Phước Hòa","type":"xa","slug":"xa-phuoc-hoa","name_with_type":"Xã Phước Hòa","path":"Xã Phước Hòa, Huyện Bác Ái, Tỉnh Ninh Thuận","path_with_type":"Xã Phước Hòa, Huyện Bác Ái, Tỉnh Ninh Thuận","code":"22786","parent_code":"584"},"22789":{"name":"Xã Phước Tân","type":"xa","slug":"xa-phuoc-tan","name_with_type":"Xã Phước Tân","path":"Xã Phước Tân, Huyện Bác Ái, Tỉnh Ninh Thuận","path_with_type":"Xã Phước Tân, Huyện Bác Ái, Tỉnh Ninh Thuận","code":"22789","parent_code":"584"},"22792":{"name":"Xã Phước Tiến","type":"xa","slug":"xa-phuoc-tien","name_with_type":"Xã Phước Tiến","path":"Xã Phước Tiến, Huyện Bác Ái, Tỉnh Ninh Thuận","path_with_type":"Xã Phước Tiến, Huyện Bác Ái, Tỉnh Ninh Thuận","code":"22792","parent_code":"584"},"22795":{"name":"Xã Phước Thắng","type":"xa","slug":"xa-phuoc-thang","name_with_type":"Xã Phước Thắng","path":"Xã Phước Thắng, Huyện Bác Ái, Tỉnh Ninh Thuận","path_with_type":"Xã Phước Thắng, Huyện Bác Ái, Tỉnh Ninh Thuận","code":"22795","parent_code":"584"},"22798":{"name":"Xã Phước Thành","type":"xa","slug":"xa-phuoc-thanh","name_with_type":"Xã Phước Thành","path":"Xã Phước Thành, Huyện Bác Ái, Tỉnh Ninh Thuận","path_with_type":"Xã Phước Thành, Huyện Bác Ái, Tỉnh Ninh Thuận","code":"22798","parent_code":"584"},"22801":{"name":"Xã Phước Đại","type":"xa","slug":"xa-phuoc-dai","name_with_type":"Xã Phước Đại","path":"Xã Phước Đại, Huyện Bác Ái, Tỉnh Ninh Thuận","path_with_type":"Xã Phước Đại, Huyện Bác Ái, Tỉnh Ninh Thuận","code":"22801","parent_code":"584"},"22804":{"name":"Xã Phước Chính","type":"xa","slug":"xa-phuoc-chinh","name_with_type":"Xã Phước Chính","path":"Xã Phước Chính, Huyện Bác Ái, Tỉnh Ninh Thuận","path_with_type":"Xã Phước Chính, Huyện Bác Ái, Tỉnh Ninh Thuận","code":"22804","parent_code":"584"},"22807":{"name":"Xã Phước Trung","type":"xa","slug":"xa-phuoc-trung","name_with_type":"Xã Phước Trung","path":"Xã Phước Trung, Huyện Bác Ái, Tỉnh Ninh Thuận","path_with_type":"Xã Phước Trung, Huyện Bác Ái, Tỉnh Ninh Thuận","code":"22807","parent_code":"584"},"22810":{"name":"Thị trấn Tân Sơn","type":"thi-tran","slug":"thi-tran-tan-son","name_with_type":"Thị trấn Tân Sơn","path":"Thị trấn Tân Sơn, Huyện Ninh Sơn, Tỉnh Ninh Thuận","path_with_type":"Thị trấn Tân Sơn, Huyện Ninh Sơn, Tỉnh Ninh Thuận","code":"22810","parent_code":"585"},"22813":{"name":"Xã Lâm Sơn","type":"xa","slug":"xa-lam-son","name_with_type":"Xã Lâm Sơn","path":"Xã Lâm Sơn, Huyện Ninh Sơn, Tỉnh Ninh Thuận","path_with_type":"Xã Lâm Sơn, Huyện Ninh Sơn, Tỉnh Ninh Thuận","code":"22813","parent_code":"585"},"22816":{"name":"Xã Lương Sơn","type":"xa","slug":"xa-luong-son","name_with_type":"Xã Lương Sơn","path":"Xã Lương Sơn, Huyện Ninh Sơn, Tỉnh Ninh Thuận","path_with_type":"Xã Lương Sơn, Huyện Ninh Sơn, Tỉnh Ninh Thuận","code":"22816","parent_code":"585"},"22819":{"name":"Xã Quảng Sơn","type":"xa","slug":"xa-quang-son","name_with_type":"Xã Quảng Sơn","path":"Xã Quảng Sơn, Huyện Ninh Sơn, Tỉnh Ninh Thuận","path_with_type":"Xã Quảng Sơn, Huyện Ninh Sơn, Tỉnh Ninh Thuận","code":"22819","parent_code":"585"},"22822":{"name":"Xã Mỹ Sơn","type":"xa","slug":"xa-my-son","name_with_type":"Xã Mỹ Sơn","path":"Xã Mỹ Sơn, Huyện Ninh Sơn, Tỉnh Ninh Thuận","path_with_type":"Xã Mỹ Sơn, Huyện Ninh Sơn, Tỉnh Ninh Thuận","code":"22822","parent_code":"585"},"22825":{"name":"Xã Hòa Sơn","type":"xa","slug":"xa-hoa-son","name_with_type":"Xã Hòa Sơn","path":"Xã Hòa Sơn, Huyện Ninh Sơn, Tỉnh Ninh Thuận","path_with_type":"Xã Hòa Sơn, Huyện Ninh Sơn, Tỉnh Ninh Thuận","code":"22825","parent_code":"585"},"22828":{"name":"Xã Ma Nới","type":"xa","slug":"xa-ma-noi","name_with_type":"Xã Ma Nới","path":"Xã Ma Nới, Huyện Ninh Sơn, Tỉnh Ninh Thuận","path_with_type":"Xã Ma Nới, Huyện Ninh Sơn, Tỉnh Ninh Thuận","code":"22828","parent_code":"585"},"22831":{"name":"Xã Nhơn Sơn","type":"xa","slug":"xa-nhon-son","name_with_type":"Xã Nhơn Sơn","path":"Xã Nhơn Sơn, Huyện Ninh Sơn, Tỉnh Ninh Thuận","path_with_type":"Xã Nhơn Sơn, Huyện Ninh Sơn, Tỉnh Ninh Thuận","code":"22831","parent_code":"585"},"22834":{"name":"Thị trấn Khánh Hải","type":"thi-tran","slug":"thi-tran-khanh-hai","name_with_type":"Thị trấn Khánh Hải","path":"Thị trấn Khánh Hải, Huyện Ninh Hải, Tỉnh Ninh Thuận","path_with_type":"Thị trấn Khánh Hải, Huyện Ninh Hải, Tỉnh Ninh Thuận","code":"22834","parent_code":"586"},"22837":{"name":"Xã Phước Chiến","type":"xa","slug":"xa-phuoc-chien","name_with_type":"Xã Phước Chiến","path":"Xã Phước Chiến, Huyện Thuận Bắc, Tỉnh Ninh Thuận","path_with_type":"Xã Phước Chiến, Huyện Thuận Bắc, Tỉnh Ninh Thuận","code":"22837","parent_code":"588"},"22840":{"name":"Xã Công Hải","type":"xa","slug":"xa-cong-hai","name_with_type":"Xã Công Hải","path":"Xã Công Hải, Huyện Thuận Bắc, Tỉnh Ninh Thuận","path_with_type":"Xã Công Hải, Huyện Thuận Bắc, Tỉnh Ninh Thuận","code":"22840","parent_code":"588"},"22843":{"name":"Xã Phước Kháng","type":"xa","slug":"xa-phuoc-khang","name_with_type":"Xã Phước Kháng","path":"Xã Phước Kháng, Huyện Thuận Bắc, Tỉnh Ninh Thuận","path_with_type":"Xã Phước Kháng, Huyện Thuận Bắc, Tỉnh Ninh Thuận","code":"22843","parent_code":"588"},"22846":{"name":"Xã Vĩnh Hải","type":"xa","slug":"xa-vinh-hai","name_with_type":"Xã Vĩnh Hải","path":"Xã Vĩnh Hải, Huyện Ninh Hải, Tỉnh Ninh Thuận","path_with_type":"Xã Vĩnh Hải, Huyện Ninh Hải, Tỉnh Ninh Thuận","code":"22846","parent_code":"586"},"22849":{"name":"Xã Lợi Hải","type":"xa","slug":"xa-loi-hai","name_with_type":"Xã Lợi Hải","path":"Xã Lợi Hải, Huyện Thuận Bắc, Tỉnh Ninh Thuận","path_with_type":"Xã Lợi Hải, Huyện Thuận Bắc, Tỉnh Ninh Thuận","code":"22849","parent_code":"588"},"22852":{"name":"Xã Phương Hải","type":"xa","slug":"xa-phuong-hai","name_with_type":"Xã Phương Hải","path":"Xã Phương Hải, Huyện Ninh Hải, Tỉnh Ninh Thuận","path_with_type":"Xã Phương Hải, Huyện Ninh Hải, Tỉnh Ninh Thuận","code":"22852","parent_code":"586"},"22853":{"name":"Xã Bắc Sơn","type":"xa","slug":"xa-bac-son","name_with_type":"Xã Bắc Sơn","path":"Xã Bắc Sơn, Huyện Thuận Bắc, Tỉnh Ninh Thuận","path_with_type":"Xã Bắc Sơn, Huyện Thuận Bắc, Tỉnh Ninh Thuận","code":"22853","parent_code":"588"},"22855":{"name":"Xã Tân Hải","type":"xa","slug":"xa-tan-hai","name_with_type":"Xã Tân Hải","path":"Xã Tân Hải, Huyện Ninh Hải, Tỉnh Ninh Thuận","path_with_type":"Xã Tân Hải, Huyện Ninh Hải, Tỉnh Ninh Thuận","code":"22855","parent_code":"586"},"22856":{"name":"Xã Bắc Phong","type":"xa","slug":"xa-bac-phong","name_with_type":"Xã Bắc Phong","path":"Xã Bắc Phong, Huyện Thuận Bắc, Tỉnh Ninh Thuận","path_with_type":"Xã Bắc Phong, Huyện Thuận Bắc, Tỉnh Ninh Thuận","code":"22856","parent_code":"588"},"22858":{"name":"Xã Xuân Hải","type":"xa","slug":"xa-xuan-hai","name_with_type":"Xã Xuân Hải","path":"Xã Xuân Hải, Huyện Ninh Hải, Tỉnh Ninh Thuận","path_with_type":"Xã Xuân Hải, Huyện Ninh Hải, Tỉnh Ninh Thuận","code":"22858","parent_code":"586"},"22861":{"name":"Xã Hộ Hải","type":"xa","slug":"xa-ho-hai","name_with_type":"Xã Hộ Hải","path":"Xã Hộ Hải, Huyện Ninh Hải, Tỉnh Ninh Thuận","path_with_type":"Xã Hộ Hải, Huyện Ninh Hải, Tỉnh Ninh Thuận","code":"22861","parent_code":"586"},"22864":{"name":"Xã Tri Hải","type":"xa","slug":"xa-tri-hai","name_with_type":"Xã Tri Hải","path":"Xã Tri Hải, Huyện Ninh Hải, Tỉnh Ninh Thuận","path_with_type":"Xã Tri Hải, Huyện Ninh Hải, Tỉnh Ninh Thuận","code":"22864","parent_code":"586"},"22867":{"name":"Xã Nhơn Hải","type":"xa","slug":"xa-nhon-hai","name_with_type":"Xã Nhơn Hải","path":"Xã Nhơn Hải, Huyện Ninh Hải, Tỉnh Ninh Thuận","path_with_type":"Xã Nhơn Hải, Huyện Ninh Hải, Tỉnh Ninh Thuận","code":"22867","parent_code":"586"},"22868":{"name":"Xã Thanh Hải","type":"xa","slug":"xa-thanh-hai","name_with_type":"Xã Thanh Hải","path":"Xã Thanh Hải, Huyện Ninh Hải, Tỉnh Ninh Thuận","path_with_type":"Xã Thanh Hải, Huyện Ninh Hải, Tỉnh Ninh Thuận","code":"22868","parent_code":"586"},"22870":{"name":"Thị trấn Phước Dân","type":"thi-tran","slug":"thi-tran-phuoc-dan","name_with_type":"Thị trấn Phước Dân","path":"Thị trấn Phước Dân, Huyện Ninh Phước, Tỉnh Ninh Thuận","path_with_type":"Thị trấn Phước Dân, Huyện Ninh Phước, Tỉnh Ninh Thuận","code":"22870","parent_code":"587"},"22873":{"name":"Xã Phước Sơn","type":"xa","slug":"xa-phuoc-son","name_with_type":"Xã Phước Sơn","path":"Xã Phước Sơn, Huyện Ninh Phước, Tỉnh Ninh Thuận","path_with_type":"Xã Phước Sơn, Huyện Ninh Phước, Tỉnh Ninh Thuận","code":"22873","parent_code":"587"},"22876":{"name":"Xã Phước Thái","type":"xa","slug":"xa-phuoc-thai","name_with_type":"Xã Phước Thái","path":"Xã Phước Thái, Huyện Ninh Phước, Tỉnh Ninh Thuận","path_with_type":"Xã Phước Thái, Huyện Ninh Phước, Tỉnh Ninh Thuận","code":"22876","parent_code":"587"},"22879":{"name":"Xã Phước Hậu","type":"xa","slug":"xa-phuoc-hau","name_with_type":"Xã Phước Hậu","path":"Xã Phước Hậu, Huyện Ninh Phước, Tỉnh Ninh Thuận","path_with_type":"Xã Phước Hậu, Huyện Ninh Phước, Tỉnh Ninh Thuận","code":"22879","parent_code":"587"},"22882":{"name":"Xã Phước Thuận","type":"xa","slug":"xa-phuoc-thuan","name_with_type":"Xã Phước Thuận","path":"Xã Phước Thuận, Huyện Ninh Phước, Tỉnh Ninh Thuận","path_with_type":"Xã Phước Thuận, Huyện Ninh Phước, Tỉnh Ninh Thuận","code":"22882","parent_code":"587"},"22885":{"name":"Xã Phước Hà","type":"xa","slug":"xa-phuoc-ha","name_with_type":"Xã Phước Hà","path":"Xã Phước Hà, Huyện Thuận Nam, Tỉnh Ninh Thuận","path_with_type":"Xã Phước Hà, Huyện Thuận Nam, Tỉnh Ninh Thuận","code":"22885","parent_code":"589"},"22888":{"name":"Xã An Hải","type":"xa","slug":"xa-an-hai","name_with_type":"Xã An Hải","path":"Xã An Hải, Huyện Ninh Phước, Tỉnh Ninh Thuận","path_with_type":"Xã An Hải, Huyện Ninh Phước, Tỉnh Ninh Thuận","code":"22888","parent_code":"587"},"22891":{"name":"Xã Phước Hữu","type":"xa","slug":"xa-phuoc-huu","name_with_type":"Xã Phước Hữu","path":"Xã Phước Hữu, Huyện Ninh Phước, Tỉnh Ninh Thuận","path_with_type":"Xã Phước Hữu, Huyện Ninh Phước, Tỉnh Ninh Thuận","code":"22891","parent_code":"587"},"22894":{"name":"Xã Phước Hải","type":"xa","slug":"xa-phuoc-hai","name_with_type":"Xã Phước Hải","path":"Xã Phước Hải, Huyện Ninh Phước, Tỉnh Ninh Thuận","path_with_type":"Xã Phước Hải, Huyện Ninh Phước, Tỉnh Ninh Thuận","code":"22894","parent_code":"587"},"22897":{"name":"Xã Phước Nam","type":"xa","slug":"xa-phuoc-nam","name_with_type":"Xã Phước Nam","path":"Xã Phước Nam, Huyện Thuận Nam, Tỉnh Ninh Thuận","path_with_type":"Xã Phước Nam, Huyện Thuận Nam, Tỉnh Ninh Thuận","code":"22897","parent_code":"589"},"22898":{"name":"Xã Phước Ninh","type":"xa","slug":"xa-phuoc-ninh","name_with_type":"Xã Phước Ninh","path":"Xã Phước Ninh, Huyện Thuận Nam, Tỉnh Ninh Thuận","path_with_type":"Xã Phước Ninh, Huyện Thuận Nam, Tỉnh Ninh Thuận","code":"22898","parent_code":"589"},"22900":{"name":"Xã Nhị Hà","type":"xa","slug":"xa-nhi-ha","name_with_type":"Xã Nhị Hà","path":"Xã Nhị Hà, Huyện Thuận Nam, Tỉnh Ninh Thuận","path_with_type":"Xã Nhị Hà, Huyện Thuận Nam, Tỉnh Ninh Thuận","code":"22900","parent_code":"589"},"22903":{"name":"Xã Phước Dinh","type":"xa","slug":"xa-phuoc-dinh","name_with_type":"Xã Phước Dinh","path":"Xã Phước Dinh, Huyện Thuận Nam, Tỉnh Ninh Thuận","path_with_type":"Xã Phước Dinh, Huyện Thuận Nam, Tỉnh Ninh Thuận","code":"22903","parent_code":"589"},"22906":{"name":"Xã Phước Minh","type":"xa","slug":"xa-phuoc-minh","name_with_type":"Xã Phước Minh","path":"Xã Phước Minh, Huyện Thuận Nam, Tỉnh Ninh Thuận","path_with_type":"Xã Phước Minh, Huyện Thuận Nam, Tỉnh Ninh Thuận","code":"22906","parent_code":"589"},"22909":{"name":"Xã Phước Diêm","type":"xa","slug":"xa-phuoc-diem","name_with_type":"Xã Phước Diêm","path":"Xã Phước Diêm, Huyện Thuận Nam, Tỉnh Ninh Thuận","path_with_type":"Xã Phước Diêm, Huyện Thuận Nam, Tỉnh Ninh Thuận","code":"22909","parent_code":"589"},"22910":{"name":"Xã Cà Ná","type":"xa","slug":"xa-ca-na","name_with_type":"Xã Cà Ná","path":"Xã Cà Ná, Huyện Thuận Nam, Tỉnh Ninh Thuận","path_with_type":"Xã Cà Ná, Huyện Thuận Nam, Tỉnh Ninh Thuận","code":"22910","parent_code":"589"},"22912":{"name":"Xã Phước Vinh","type":"xa","slug":"xa-phuoc-vinh","name_with_type":"Xã Phước Vinh","path":"Xã Phước Vinh, Huyện Ninh Phước, Tỉnh Ninh Thuận","path_with_type":"Xã Phước Vinh, Huyện Ninh Phước, Tỉnh Ninh Thuận","code":"22912","parent_code":"587"},"22915":{"name":"Phường Mũi Né","type":"phuong","slug":"phuong-mui-ne","name_with_type":"Phường Mũi Né","path":"Phường Mũi Né, Thành phố Phan Thiết, Tỉnh Bình Thuận","path_with_type":"Phường Mũi Né, Thành phố Phan Thiết, Tỉnh Bình Thuận","code":"22915","parent_code":"593"},"22918":{"name":"Phường Hàm Tiến","type":"phuong","slug":"phuong-ham-tien","name_with_type":"Phường Hàm Tiến","path":"Phường Hàm Tiến, Thành phố Phan Thiết, Tỉnh Bình Thuận","path_with_type":"Phường Hàm Tiến, Thành phố Phan Thiết, Tỉnh Bình Thuận","code":"22918","parent_code":"593"},"22921":{"name":"Phường Phú Hài","type":"phuong","slug":"phuong-phu-hai","name_with_type":"Phường Phú Hài","path":"Phường Phú Hài, Thành phố Phan Thiết, Tỉnh Bình Thuận","path_with_type":"Phường Phú Hài, Thành phố Phan Thiết, Tỉnh Bình Thuận","code":"22921","parent_code":"593"},"22924":{"name":"Phường Phú Thủy","type":"phuong","slug":"phuong-phu-thuy","name_with_type":"Phường Phú Thủy","path":"Phường Phú Thủy, Thành phố Phan Thiết, Tỉnh Bình Thuận","path_with_type":"Phường Phú Thủy, Thành phố Phan Thiết, Tỉnh Bình Thuận","code":"22924","parent_code":"593"},"22927":{"name":"Phường Phú Tài","type":"phuong","slug":"phuong-phu-tai","name_with_type":"Phường Phú Tài","path":"Phường Phú Tài, Thành phố Phan Thiết, Tỉnh Bình Thuận","path_with_type":"Phường Phú Tài, Thành phố Phan Thiết, Tỉnh Bình Thuận","code":"22927","parent_code":"593"},"22930":{"name":"Phường Phú Trinh","type":"phuong","slug":"phuong-phu-trinh","name_with_type":"Phường Phú Trinh","path":"Phường Phú Trinh, Thành phố Phan Thiết, Tỉnh Bình Thuận","path_with_type":"Phường Phú Trinh, Thành phố Phan Thiết, Tỉnh Bình Thuận","code":"22930","parent_code":"593"},"22933":{"name":"Phường Xuân An","type":"phuong","slug":"phuong-xuan-an","name_with_type":"Phường Xuân An","path":"Phường Xuân An, Thành phố Phan Thiết, Tỉnh Bình Thuận","path_with_type":"Phường Xuân An, Thành phố Phan Thiết, Tỉnh Bình Thuận","code":"22933","parent_code":"593"},"22936":{"name":"Phường Thanh Hải","type":"phuong","slug":"phuong-thanh-hai","name_with_type":"Phường Thanh Hải","path":"Phường Thanh Hải, Thành phố Phan Thiết, Tỉnh Bình Thuận","path_with_type":"Phường Thanh Hải, Thành phố Phan Thiết, Tỉnh Bình Thuận","code":"22936","parent_code":"593"},"22945":{"name":"Phường Lạc Đạo","type":"phuong","slug":"phuong-lac-dao","name_with_type":"Phường Lạc Đạo","path":"Phường Lạc Đạo, Thành phố Phan Thiết, Tỉnh Bình Thuận","path_with_type":"Phường Lạc Đạo, Thành phố Phan Thiết, Tỉnh Bình Thuận","code":"22945","parent_code":"593"},"22951":{"name":"Phường Bình Hưng","type":"phuong","slug":"phuong-binh-hung","name_with_type":"Phường Bình Hưng","path":"Phường Bình Hưng, Thành phố Phan Thiết, Tỉnh Bình Thuận","path_with_type":"Phường Bình Hưng, Thành phố Phan Thiết, Tỉnh Bình Thuận","code":"22951","parent_code":"593"},"22954":{"name":"Phường Đức Long","type":"phuong","slug":"phuong-duc-long","name_with_type":"Phường Đức Long","path":"Phường Đức Long, Thành phố Phan Thiết, Tỉnh Bình Thuận","path_with_type":"Phường Đức Long, Thành phố Phan Thiết, Tỉnh Bình Thuận","code":"22954","parent_code":"593"},"22957":{"name":"Xã Thiện Nghiệp","type":"xa","slug":"xa-thien-nghiep","name_with_type":"Xã Thiện Nghiệp","path":"Xã Thiện Nghiệp, Thành phố Phan Thiết, Tỉnh Bình Thuận","path_with_type":"Xã Thiện Nghiệp, Thành phố Phan Thiết, Tỉnh Bình Thuận","code":"22957","parent_code":"593"},"22960":{"name":"Xã Phong Nẫm","type":"xa","slug":"xa-phong-nam","name_with_type":"Xã Phong Nẫm","path":"Xã Phong Nẫm, Thành phố Phan Thiết, Tỉnh Bình Thuận","path_with_type":"Xã Phong Nẫm, Thành phố Phan Thiết, Tỉnh Bình Thuận","code":"22960","parent_code":"593"},"22963":{"name":"Xã Tiến Lợi","type":"xa","slug":"xa-tien-loi","name_with_type":"Xã Tiến Lợi","path":"Xã Tiến Lợi, Thành phố Phan Thiết, Tỉnh Bình Thuận","path_with_type":"Xã Tiến Lợi, Thành phố Phan Thiết, Tỉnh Bình Thuận","code":"22963","parent_code":"593"},"22966":{"name":"Xã Tiến Thành","type":"xa","slug":"xa-tien-thanh","name_with_type":"Xã Tiến Thành","path":"Xã Tiến Thành, Thành phố Phan Thiết, Tỉnh Bình Thuận","path_with_type":"Xã Tiến Thành, Thành phố Phan Thiết, Tỉnh Bình Thuận","code":"22966","parent_code":"593"},"22969":{"name":"Thị trấn Liên Hương","type":"thi-tran","slug":"thi-tran-lien-huong","name_with_type":"Thị trấn Liên Hương","path":"Thị trấn Liên Hương, Huyện Tuy Phong, Tỉnh Bình Thuận","path_with_type":"Thị trấn Liên Hương, Huyện Tuy Phong, Tỉnh Bình Thuận","code":"22969","parent_code":"595"},"22972":{"name":"Thị trấn Phan Rí Cửa","type":"thi-tran","slug":"thi-tran-phan-ri-cua","name_with_type":"Thị trấn Phan Rí Cửa","path":"Thị trấn Phan Rí Cửa, Huyện Tuy Phong, Tỉnh Bình Thuận","path_with_type":"Thị trấn Phan Rí Cửa, Huyện Tuy Phong, Tỉnh Bình Thuận","code":"22972","parent_code":"595"},"22975":{"name":"Xã Phan Dũng","type":"xa","slug":"xa-phan-dung","name_with_type":"Xã Phan Dũng","path":"Xã Phan Dũng, Huyện Tuy Phong, Tỉnh Bình Thuận","path_with_type":"Xã Phan Dũng, Huyện Tuy Phong, Tỉnh Bình Thuận","code":"22975","parent_code":"595"},"22978":{"name":"Xã Phong Phú","type":"xa","slug":"xa-phong-phu","name_with_type":"Xã Phong Phú","path":"Xã Phong Phú, Huyện Tuy Phong, Tỉnh Bình Thuận","path_with_type":"Xã Phong Phú, Huyện Tuy Phong, Tỉnh Bình Thuận","code":"22978","parent_code":"595"},"22981":{"name":"Xã Vĩnh Hảo","type":"xa","slug":"xa-vinh-hao","name_with_type":"Xã Vĩnh Hảo","path":"Xã Vĩnh Hảo, Huyện Tuy Phong, Tỉnh Bình Thuận","path_with_type":"Xã Vĩnh Hảo, Huyện Tuy Phong, Tỉnh Bình Thuận","code":"22981","parent_code":"595"},"22984":{"name":"Xã Vĩnh Tân","type":"xa","slug":"xa-vinh-tan","name_with_type":"Xã Vĩnh Tân","path":"Xã Vĩnh Tân, Huyện Tuy Phong, Tỉnh Bình Thuận","path_with_type":"Xã Vĩnh Tân, Huyện Tuy Phong, Tỉnh Bình Thuận","code":"22984","parent_code":"595"},"22987":{"name":"Xã Phú Lạc","type":"xa","slug":"xa-phu-lac","name_with_type":"Xã Phú Lạc","path":"Xã Phú Lạc, Huyện Tuy Phong, Tỉnh Bình Thuận","path_with_type":"Xã Phú Lạc, Huyện Tuy Phong, Tỉnh Bình Thuận","code":"22987","parent_code":"595"},"22990":{"name":"Xã Phước Thể","type":"xa","slug":"xa-phuoc-the","name_with_type":"Xã Phước Thể","path":"Xã Phước Thể, Huyện Tuy Phong, Tỉnh Bình Thuận","path_with_type":"Xã Phước Thể, Huyện Tuy Phong, Tỉnh Bình Thuận","code":"22990","parent_code":"595"},"22993":{"name":"Xã Hòa Minh","type":"xa","slug":"xa-hoa-minh","name_with_type":"Xã Hòa Minh","path":"Xã Hòa Minh, Huyện Tuy Phong, Tỉnh Bình Thuận","path_with_type":"Xã Hòa Minh, Huyện Tuy Phong, Tỉnh Bình Thuận","code":"22993","parent_code":"595"},"22996":{"name":"Xã Chí Công","type":"xa","slug":"xa-chi-cong","name_with_type":"Xã Chí Công","path":"Xã Chí Công, Huyện Tuy Phong, Tỉnh Bình Thuận","path_with_type":"Xã Chí Công, Huyện Tuy Phong, Tỉnh Bình Thuận","code":"22996","parent_code":"595"},"22999":{"name":"Xã Bình Thạnh","type":"xa","slug":"xa-binh-thanh","name_with_type":"Xã Bình Thạnh","path":"Xã Bình Thạnh, Huyện Tuy Phong, Tỉnh Bình Thuận","path_with_type":"Xã Bình Thạnh, Huyện Tuy Phong, Tỉnh Bình Thuận","code":"22999","parent_code":"595"},"23005":{"name":"Thị trấn Chợ Lầu","type":"thi-tran","slug":"thi-tran-cho-lau","name_with_type":"Thị trấn Chợ Lầu","path":"Thị trấn Chợ Lầu, Huyện Bắc Bình, Tỉnh Bình Thuận","path_with_type":"Thị trấn Chợ Lầu, Huyện Bắc Bình, Tỉnh Bình Thuận","code":"23005","parent_code":"596"},"23008":{"name":"Xã Phan Sơn","type":"xa","slug":"xa-phan-son","name_with_type":"Xã Phan Sơn","path":"Xã Phan Sơn, Huyện Bắc Bình, Tỉnh Bình Thuận","path_with_type":"Xã Phan Sơn, Huyện Bắc Bình, Tỉnh Bình Thuận","code":"23008","parent_code":"596"},"23011":{"name":"Xã Phan Lâm","type":"xa","slug":"xa-phan-lam","name_with_type":"Xã Phan Lâm","path":"Xã Phan Lâm, Huyện Bắc Bình, Tỉnh Bình Thuận","path_with_type":"Xã Phan Lâm, Huyện Bắc Bình, Tỉnh Bình Thuận","code":"23011","parent_code":"596"},"23014":{"name":"Xã Bình An","type":"xa","slug":"xa-binh-an","name_with_type":"Xã Bình An","path":"Xã Bình An, Huyện Bắc Bình, Tỉnh Bình Thuận","path_with_type":"Xã Bình An, Huyện Bắc Bình, Tỉnh Bình Thuận","code":"23014","parent_code":"596"},"23017":{"name":"Xã Phan Điền","type":"xa","slug":"xa-phan-dien","name_with_type":"Xã Phan Điền","path":"Xã Phan Điền, Huyện Bắc Bình, Tỉnh Bình Thuận","path_with_type":"Xã Phan Điền, Huyện Bắc Bình, Tỉnh Bình Thuận","code":"23017","parent_code":"596"},"23020":{"name":"Xã Hải Ninh","type":"xa","slug":"xa-hai-ninh","name_with_type":"Xã Hải Ninh","path":"Xã Hải Ninh, Huyện Bắc Bình, Tỉnh Bình Thuận","path_with_type":"Xã Hải Ninh, Huyện Bắc Bình, Tỉnh Bình Thuận","code":"23020","parent_code":"596"},"23023":{"name":"Xã Sông Lũy","type":"xa","slug":"xa-song-luy","name_with_type":"Xã Sông Lũy","path":"Xã Sông Lũy, Huyện Bắc Bình, Tỉnh Bình Thuận","path_with_type":"Xã Sông Lũy, Huyện Bắc Bình, Tỉnh Bình Thuận","code":"23023","parent_code":"596"},"23026":{"name":"Xã Phan Tiến","type":"xa","slug":"xa-phan-tien","name_with_type":"Xã Phan Tiến","path":"Xã Phan Tiến, Huyện Bắc Bình, Tỉnh Bình Thuận","path_with_type":"Xã Phan Tiến, Huyện Bắc Bình, Tỉnh Bình Thuận","code":"23026","parent_code":"596"},"23029":{"name":"Xã Sông Bình","type":"xa","slug":"xa-song-binh","name_with_type":"Xã Sông Bình","path":"Xã Sông Bình, Huyện Bắc Bình, Tỉnh Bình Thuận","path_with_type":"Xã Sông Bình, Huyện Bắc Bình, Tỉnh Bình Thuận","code":"23029","parent_code":"596"},"23032":{"name":"Thị trấn Lương Sơn","type":"thi-tran","slug":"thi-tran-luong-son","name_with_type":"Thị trấn Lương Sơn","path":"Thị trấn Lương Sơn, Huyện Bắc Bình, Tỉnh Bình Thuận","path_with_type":"Thị trấn Lương Sơn, Huyện Bắc Bình, Tỉnh Bình Thuận","code":"23032","parent_code":"596"},"23035":{"name":"Xã Phan Hòa","type":"xa","slug":"xa-phan-hoa","name_with_type":"Xã Phan Hòa","path":"Xã Phan Hòa, Huyện Bắc Bình, Tỉnh Bình Thuận","path_with_type":"Xã Phan Hòa, Huyện Bắc Bình, Tỉnh Bình Thuận","code":"23035","parent_code":"596"},"23038":{"name":"Xã Phan Thanh","type":"xa","slug":"xa-phan-thanh","name_with_type":"Xã Phan Thanh","path":"Xã Phan Thanh, Huyện Bắc Bình, Tỉnh Bình Thuận","path_with_type":"Xã Phan Thanh, Huyện Bắc Bình, Tỉnh Bình Thuận","code":"23038","parent_code":"596"},"23041":{"name":"Xã Hồng Thái","type":"xa","slug":"xa-hong-thai","name_with_type":"Xã Hồng Thái","path":"Xã Hồng Thái, Huyện Bắc Bình, Tỉnh Bình Thuận","path_with_type":"Xã Hồng Thái, Huyện Bắc Bình, Tỉnh Bình Thuận","code":"23041","parent_code":"596"},"23044":{"name":"Xã Phan Hiệp","type":"xa","slug":"xa-phan-hiep","name_with_type":"Xã Phan Hiệp","path":"Xã Phan Hiệp, Huyện Bắc Bình, Tỉnh Bình Thuận","path_with_type":"Xã Phan Hiệp, Huyện Bắc Bình, Tỉnh Bình Thuận","code":"23044","parent_code":"596"},"23047":{"name":"Xã Bình Tân","type":"xa","slug":"xa-binh-tan","name_with_type":"Xã Bình Tân","path":"Xã Bình Tân, Huyện Bắc Bình, Tỉnh Bình Thuận","path_with_type":"Xã Bình Tân, Huyện Bắc Bình, Tỉnh Bình Thuận","code":"23047","parent_code":"596"},"23050":{"name":"Xã Phan Rí Thành","type":"xa","slug":"xa-phan-ri-thanh","name_with_type":"Xã Phan Rí Thành","path":"Xã Phan Rí Thành, Huyện Bắc Bình, Tỉnh Bình Thuận","path_with_type":"Xã Phan Rí Thành, Huyện Bắc Bình, Tỉnh Bình Thuận","code":"23050","parent_code":"596"},"23053":{"name":"Xã Hòa Thắng","type":"xa","slug":"xa-hoa-thang","name_with_type":"Xã Hòa Thắng","path":"Xã Hòa Thắng, Huyện Bắc Bình, Tỉnh Bình Thuận","path_with_type":"Xã Hòa Thắng, Huyện Bắc Bình, Tỉnh Bình Thuận","code":"23053","parent_code":"596"},"23056":{"name":"Xã Hồng Phong","type":"xa","slug":"xa-hong-phong","name_with_type":"Xã Hồng Phong","path":"Xã Hồng Phong, Huyện Bắc Bình, Tỉnh Bình Thuận","path_with_type":"Xã Hồng Phong, Huyện Bắc Bình, Tỉnh Bình Thuận","code":"23056","parent_code":"596"},"23059":{"name":"Thị trấn Ma Lâm","type":"thi-tran","slug":"thi-tran-ma-lam","name_with_type":"Thị trấn Ma Lâm","path":"Thị trấn Ma Lâm, Huyện Hàm Thuận Bắc, Tỉnh Bình Thuận","path_with_type":"Thị trấn Ma Lâm, Huyện Hàm Thuận Bắc, Tỉnh Bình Thuận","code":"23059","parent_code":"597"},"23062":{"name":"Thị trấn Phú Long","type":"thi-tran","slug":"thi-tran-phu-long","name_with_type":"Thị trấn Phú Long","path":"Thị trấn Phú Long, Huyện Hàm Thuận Bắc, Tỉnh Bình Thuận","path_with_type":"Thị trấn Phú Long, Huyện Hàm Thuận Bắc, Tỉnh Bình Thuận","code":"23062","parent_code":"597"},"23065":{"name":"Xã La Dạ","type":"xa","slug":"xa-la-da","name_with_type":"Xã La Dạ","path":"Xã La Dạ, Huyện Hàm Thuận Bắc, Tỉnh Bình Thuận","path_with_type":"Xã La Dạ, Huyện Hàm Thuận Bắc, Tỉnh Bình Thuận","code":"23065","parent_code":"597"},"23068":{"name":"Xã Đông Tiến","type":"xa","slug":"xa-dong-tien","name_with_type":"Xã Đông Tiến","path":"Xã Đông Tiến, Huyện Hàm Thuận Bắc, Tỉnh Bình Thuận","path_with_type":"Xã Đông Tiến, Huyện Hàm Thuận Bắc, Tỉnh Bình Thuận","code":"23068","parent_code":"597"},"23071":{"name":"Xã Thuận Hòa","type":"xa","slug":"xa-thuan-hoa","name_with_type":"Xã Thuận Hòa","path":"Xã Thuận Hòa, Huyện Hàm Thuận Bắc, Tỉnh Bình Thuận","path_with_type":"Xã Thuận Hòa, Huyện Hàm Thuận Bắc, Tỉnh Bình Thuận","code":"23071","parent_code":"597"},"23074":{"name":"Xã Đông Giang","type":"xa","slug":"xa-dong-giang","name_with_type":"Xã Đông Giang","path":"Xã Đông Giang, Huyện Hàm Thuận Bắc, Tỉnh Bình Thuận","path_with_type":"Xã Đông Giang, Huyện Hàm Thuận Bắc, Tỉnh Bình Thuận","code":"23074","parent_code":"597"},"23077":{"name":"Xã Hàm Phú","type":"xa","slug":"xa-ham-phu","name_with_type":"Xã Hàm Phú","path":"Xã Hàm Phú, Huyện Hàm Thuận Bắc, Tỉnh Bình Thuận","path_with_type":"Xã Hàm Phú, Huyện Hàm Thuận Bắc, Tỉnh Bình Thuận","code":"23077","parent_code":"597"},"23080":{"name":"Xã Hồng Liêm","type":"xa","slug":"xa-hong-liem","name_with_type":"Xã Hồng Liêm","path":"Xã Hồng Liêm, Huyện Hàm Thuận Bắc, Tỉnh Bình Thuận","path_with_type":"Xã Hồng Liêm, Huyện Hàm Thuận Bắc, Tỉnh Bình Thuận","code":"23080","parent_code":"597"},"23083":{"name":"Xã Thuận Minh","type":"xa","slug":"xa-thuan-minh","name_with_type":"Xã Thuận Minh","path":"Xã Thuận Minh, Huyện Hàm Thuận Bắc, Tỉnh Bình Thuận","path_with_type":"Xã Thuận Minh, Huyện Hàm Thuận Bắc, Tỉnh Bình Thuận","code":"23083","parent_code":"597"},"23086":{"name":"Xã Hồng Sơn","type":"xa","slug":"xa-hong-son","name_with_type":"Xã Hồng Sơn","path":"Xã Hồng Sơn, Huyện Hàm Thuận Bắc, Tỉnh Bình Thuận","path_with_type":"Xã Hồng Sơn, Huyện Hàm Thuận Bắc, Tỉnh Bình Thuận","code":"23086","parent_code":"597"},"23089":{"name":"Xã Hàm Trí","type":"xa","slug":"xa-ham-tri","name_with_type":"Xã Hàm Trí","path":"Xã Hàm Trí, Huyện Hàm Thuận Bắc, Tỉnh Bình Thuận","path_with_type":"Xã Hàm Trí, Huyện Hàm Thuận Bắc, Tỉnh Bình Thuận","code":"23089","parent_code":"597"},"23092":{"name":"Xã Hàm Đức","type":"xa","slug":"xa-ham-duc","name_with_type":"Xã Hàm Đức","path":"Xã Hàm Đức, Huyện Hàm Thuận Bắc, Tỉnh Bình Thuận","path_with_type":"Xã Hàm Đức, Huyện Hàm Thuận Bắc, Tỉnh Bình Thuận","code":"23092","parent_code":"597"},"23095":{"name":"Xã Hàm Liêm","type":"xa","slug":"xa-ham-liem","name_with_type":"Xã Hàm Liêm","path":"Xã Hàm Liêm, Huyện Hàm Thuận Bắc, Tỉnh Bình Thuận","path_with_type":"Xã Hàm Liêm, Huyện Hàm Thuận Bắc, Tỉnh Bình Thuận","code":"23095","parent_code":"597"},"23098":{"name":"Xã Hàm Chính","type":"xa","slug":"xa-ham-chinh","name_with_type":"Xã Hàm Chính","path":"Xã Hàm Chính, Huyện Hàm Thuận Bắc, Tỉnh Bình Thuận","path_with_type":"Xã Hàm Chính, Huyện Hàm Thuận Bắc, Tỉnh Bình Thuận","code":"23098","parent_code":"597"},"23101":{"name":"Xã Hàm Hiệp","type":"xa","slug":"xa-ham-hiep","name_with_type":"Xã Hàm Hiệp","path":"Xã Hàm Hiệp, Huyện Hàm Thuận Bắc, Tỉnh Bình Thuận","path_with_type":"Xã Hàm Hiệp, Huyện Hàm Thuận Bắc, Tỉnh Bình Thuận","code":"23101","parent_code":"597"},"23104":{"name":"Xã Hàm Thắng","type":"xa","slug":"xa-ham-thang","name_with_type":"Xã Hàm Thắng","path":"Xã Hàm Thắng, Huyện Hàm Thuận Bắc, Tỉnh Bình Thuận","path_with_type":"Xã Hàm Thắng, Huyện Hàm Thuận Bắc, Tỉnh Bình Thuận","code":"23104","parent_code":"597"},"23107":{"name":"Xã Đa Mi","type":"xa","slug":"xa-da-mi","name_with_type":"Xã Đa Mi","path":"Xã Đa Mi, Huyện Hàm Thuận Bắc, Tỉnh Bình Thuận","path_with_type":"Xã Đa Mi, Huyện Hàm Thuận Bắc, Tỉnh Bình Thuận","code":"23107","parent_code":"597"},"23110":{"name":"Thị trấn Thuận Nam","type":"thi-tran","slug":"thi-tran-thuan-nam","name_with_type":"Thị trấn Thuận Nam","path":"Thị trấn Thuận Nam, Huyện Hàm Thuận Nam, Tỉnh Bình Thuận","path_with_type":"Thị trấn Thuận Nam, Huyện Hàm Thuận Nam, Tỉnh Bình Thuận","code":"23110","parent_code":"598"},"23113":{"name":"Xã Mỹ Thạnh","type":"xa","slug":"xa-my-thanh","name_with_type":"Xã Mỹ Thạnh","path":"Xã Mỹ Thạnh, Huyện Hàm Thuận Nam, Tỉnh Bình Thuận","path_with_type":"Xã Mỹ Thạnh, Huyện Hàm Thuận Nam, Tỉnh Bình Thuận","code":"23113","parent_code":"598"},"23116":{"name":"Xã Hàm Cần","type":"xa","slug":"xa-ham-can","name_with_type":"Xã Hàm Cần","path":"Xã Hàm Cần, Huyện Hàm Thuận Nam, Tỉnh Bình Thuận","path_with_type":"Xã Hàm Cần, Huyện Hàm Thuận Nam, Tỉnh Bình Thuận","code":"23116","parent_code":"598"},"23119":{"name":"Xã Mương Mán","type":"xa","slug":"xa-muong-man","name_with_type":"Xã Mương Mán","path":"Xã Mương Mán, Huyện Hàm Thuận Nam, Tỉnh Bình Thuận","path_with_type":"Xã Mương Mán, Huyện Hàm Thuận Nam, Tỉnh Bình Thuận","code":"23119","parent_code":"598"},"23122":{"name":"Xã Hàm Thạnh","type":"xa","slug":"xa-ham-thanh","name_with_type":"Xã Hàm Thạnh","path":"Xã Hàm Thạnh, Huyện Hàm Thuận Nam, Tỉnh Bình Thuận","path_with_type":"Xã Hàm Thạnh, Huyện Hàm Thuận Nam, Tỉnh Bình Thuận","code":"23122","parent_code":"598"},"23125":{"name":"Xã Hàm Kiệm","type":"xa","slug":"xa-ham-kiem","name_with_type":"Xã Hàm Kiệm","path":"Xã Hàm Kiệm, Huyện Hàm Thuận Nam, Tỉnh Bình Thuận","path_with_type":"Xã Hàm Kiệm, Huyện Hàm Thuận Nam, Tỉnh Bình Thuận","code":"23125","parent_code":"598"},"23128":{"name":"Xã Hàm Cường","type":"xa","slug":"xa-ham-cuong","name_with_type":"Xã Hàm Cường","path":"Xã Hàm Cường, Huyện Hàm Thuận Nam, Tỉnh Bình Thuận","path_with_type":"Xã Hàm Cường, Huyện Hàm Thuận Nam, Tỉnh Bình Thuận","code":"23128","parent_code":"598"},"23131":{"name":"Xã Hàm Mỹ","type":"xa","slug":"xa-ham-my","name_with_type":"Xã Hàm Mỹ","path":"Xã Hàm Mỹ, Huyện Hàm Thuận Nam, Tỉnh Bình Thuận","path_with_type":"Xã Hàm Mỹ, Huyện Hàm Thuận Nam, Tỉnh Bình Thuận","code":"23131","parent_code":"598"},"23134":{"name":"Xã Tân Lập","type":"xa","slug":"xa-tan-lap","name_with_type":"Xã Tân Lập","path":"Xã Tân Lập, Huyện Hàm Thuận Nam, Tỉnh Bình Thuận","path_with_type":"Xã Tân Lập, Huyện Hàm Thuận Nam, Tỉnh Bình Thuận","code":"23134","parent_code":"598"},"23137":{"name":"Xã Hàm Minh","type":"xa","slug":"xa-ham-minh","name_with_type":"Xã Hàm Minh","path":"Xã Hàm Minh, Huyện Hàm Thuận Nam, Tỉnh Bình Thuận","path_with_type":"Xã Hàm Minh, Huyện Hàm Thuận Nam, Tỉnh Bình Thuận","code":"23137","parent_code":"598"},"23140":{"name":"Xã Thuận Quí","type":"xa","slug":"xa-thuan-qui","name_with_type":"Xã Thuận Quí","path":"Xã Thuận Quí, Huyện Hàm Thuận Nam, Tỉnh Bình Thuận","path_with_type":"Xã Thuận Quí, Huyện Hàm Thuận Nam, Tỉnh Bình Thuận","code":"23140","parent_code":"598"},"23143":{"name":"Xã Tân Thuận","type":"xa","slug":"xa-tan-thuan","name_with_type":"Xã Tân Thuận","path":"Xã Tân Thuận, Huyện Hàm Thuận Nam, Tỉnh Bình Thuận","path_with_type":"Xã Tân Thuận, Huyện Hàm Thuận Nam, Tỉnh Bình Thuận","code":"23143","parent_code":"598"},"23146":{"name":"Xã Tân Thành","type":"xa","slug":"xa-tan-thanh","name_with_type":"Xã Tân Thành","path":"Xã Tân Thành, Huyện Hàm Thuận Nam, Tỉnh Bình Thuận","path_with_type":"Xã Tân Thành, Huyện Hàm Thuận Nam, Tỉnh Bình Thuận","code":"23146","parent_code":"598"},"23149":{"name":"Thị trấn Lạc Tánh","type":"thi-tran","slug":"thi-tran-lac-tanh","name_with_type":"Thị trấn Lạc Tánh","path":"Thị trấn Lạc Tánh, Huyện Tánh Linh, Tỉnh Bình Thuận","path_with_type":"Thị trấn Lạc Tánh, Huyện Tánh Linh, Tỉnh Bình Thuận","code":"23149","parent_code":"599"},"23152":{"name":"Xã Bắc Ruộng","type":"xa","slug":"xa-bac-ruong","name_with_type":"Xã Bắc Ruộng","path":"Xã Bắc Ruộng, Huyện Tánh Linh, Tỉnh Bình Thuận","path_with_type":"Xã Bắc Ruộng, Huyện Tánh Linh, Tỉnh Bình Thuận","code":"23152","parent_code":"599"},"23158":{"name":"Xã Nghị Đức","type":"xa","slug":"xa-nghi-duc","name_with_type":"Xã Nghị Đức","path":"Xã Nghị Đức, Huyện Tánh Linh, Tỉnh Bình Thuận","path_with_type":"Xã Nghị Đức, Huyện Tánh Linh, Tỉnh Bình Thuận","code":"23158","parent_code":"599"},"23161":{"name":"Xã La Ngâu","type":"xa","slug":"xa-la-ngau","name_with_type":"Xã La Ngâu","path":"Xã La Ngâu, Huyện Tánh Linh, Tỉnh Bình Thuận","path_with_type":"Xã La Ngâu, Huyện Tánh Linh, Tỉnh Bình Thuận","code":"23161","parent_code":"599"},"23164":{"name":"Xã Huy Khiêm","type":"xa","slug":"xa-huy-khiem","name_with_type":"Xã Huy Khiêm","path":"Xã Huy Khiêm, Huyện Tánh Linh, Tỉnh Bình Thuận","path_with_type":"Xã Huy Khiêm, Huyện Tánh Linh, Tỉnh Bình Thuận","code":"23164","parent_code":"599"},"23167":{"name":"Xã Măng Tố","type":"xa","slug":"xa-mang-to","name_with_type":"Xã Măng Tố","path":"Xã Măng Tố, Huyện Tánh Linh, Tỉnh Bình Thuận","path_with_type":"Xã Măng Tố, Huyện Tánh Linh, Tỉnh Bình Thuận","code":"23167","parent_code":"599"},"23170":{"name":"Xã Đức Phú","type":"xa","slug":"xa-duc-phu","name_with_type":"Xã Đức Phú","path":"Xã Đức Phú, Huyện Tánh Linh, Tỉnh Bình Thuận","path_with_type":"Xã Đức Phú, Huyện Tánh Linh, Tỉnh Bình Thuận","code":"23170","parent_code":"599"},"23173":{"name":"Xã Đồng Kho","type":"xa","slug":"xa-dong-kho","name_with_type":"Xã Đồng Kho","path":"Xã Đồng Kho, Huyện Tánh Linh, Tỉnh Bình Thuận","path_with_type":"Xã Đồng Kho, Huyện Tánh Linh, Tỉnh Bình Thuận","code":"23173","parent_code":"599"},"23176":{"name":"Xã Gia An","type":"xa","slug":"xa-gia-an","name_with_type":"Xã Gia An","path":"Xã Gia An, Huyện Tánh Linh, Tỉnh Bình Thuận","path_with_type":"Xã Gia An, Huyện Tánh Linh, Tỉnh Bình Thuận","code":"23176","parent_code":"599"},"23179":{"name":"Xã Đức Bình","type":"xa","slug":"xa-duc-binh","name_with_type":"Xã Đức Bình","path":"Xã Đức Bình, Huyện Tánh Linh, Tỉnh Bình Thuận","path_with_type":"Xã Đức Bình, Huyện Tánh Linh, Tỉnh Bình Thuận","code":"23179","parent_code":"599"},"23182":{"name":"Xã Gia Huynh","type":"xa","slug":"xa-gia-huynh","name_with_type":"Xã Gia Huynh","path":"Xã Gia Huynh, Huyện Tánh Linh, Tỉnh Bình Thuận","path_with_type":"Xã Gia Huynh, Huyện Tánh Linh, Tỉnh Bình Thuận","code":"23182","parent_code":"599"},"23185":{"name":"Xã Đức Thuận","type":"xa","slug":"xa-duc-thuan","name_with_type":"Xã Đức Thuận","path":"Xã Đức Thuận, Huyện Tánh Linh, Tỉnh Bình Thuận","path_with_type":"Xã Đức Thuận, Huyện Tánh Linh, Tỉnh Bình Thuận","code":"23185","parent_code":"599"},"23188":{"name":"Xã Suối Kiết","type":"xa","slug":"xa-suoi-kiet","name_with_type":"Xã Suối Kiết","path":"Xã Suối Kiết, Huyện Tánh Linh, Tỉnh Bình Thuận","path_with_type":"Xã Suối Kiết, Huyện Tánh Linh, Tỉnh Bình Thuận","code":"23188","parent_code":"599"},"23191":{"name":"Thị trấn Võ Xu","type":"thi-tran","slug":"thi-tran-vo-xu","name_with_type":"Thị trấn Võ Xu","path":"Thị trấn Võ Xu, Huyện Đức Linh, Tỉnh Bình Thuận","path_with_type":"Thị trấn Võ Xu, Huyện Đức Linh, Tỉnh Bình Thuận","code":"23191","parent_code":"600"},"23194":{"name":"Thị trấn Đức Tài","type":"thi-tran","slug":"thi-tran-duc-tai","name_with_type":"Thị trấn Đức Tài","path":"Thị trấn Đức Tài, Huyện Đức Linh, Tỉnh Bình Thuận","path_with_type":"Thị trấn Đức Tài, Huyện Đức Linh, Tỉnh Bình Thuận","code":"23194","parent_code":"600"},"23197":{"name":"Xã Đa Kai","type":"xa","slug":"xa-da-kai","name_with_type":"Xã Đa Kai","path":"Xã Đa Kai, Huyện Đức Linh, Tỉnh Bình Thuận","path_with_type":"Xã Đa Kai, Huyện Đức Linh, Tỉnh Bình Thuận","code":"23197","parent_code":"600"},"23200":{"name":"Xã Sùng Nhơn","type":"xa","slug":"xa-sung-nhon","name_with_type":"Xã Sùng Nhơn","path":"Xã Sùng Nhơn, Huyện Đức Linh, Tỉnh Bình Thuận","path_with_type":"Xã Sùng Nhơn, Huyện Đức Linh, Tỉnh Bình Thuận","code":"23200","parent_code":"600"},"23203":{"name":"Xã Mê Pu","type":"xa","slug":"xa-me-pu","name_with_type":"Xã Mê Pu","path":"Xã Mê Pu, Huyện Đức Linh, Tỉnh Bình Thuận","path_with_type":"Xã Mê Pu, Huyện Đức Linh, Tỉnh Bình Thuận","code":"23203","parent_code":"600"},"23206":{"name":"Xã Nam Chính","type":"xa","slug":"xa-nam-chinh","name_with_type":"Xã Nam Chính","path":"Xã Nam Chính, Huyện Đức Linh, Tỉnh Bình Thuận","path_with_type":"Xã Nam Chính, Huyện Đức Linh, Tỉnh Bình Thuận","code":"23206","parent_code":"600"},"23212":{"name":"Xã Đức Hạnh","type":"xa","slug":"xa-duc-hanh","name_with_type":"Xã Đức Hạnh","path":"Xã Đức Hạnh, Huyện Đức Linh, Tỉnh Bình Thuận","path_with_type":"Xã Đức Hạnh, Huyện Đức Linh, Tỉnh Bình Thuận","code":"23212","parent_code":"600"},"23215":{"name":"Xã Đức Tín","type":"xa","slug":"xa-duc-tin","name_with_type":"Xã Đức Tín","path":"Xã Đức Tín, Huyện Đức Linh, Tỉnh Bình Thuận","path_with_type":"Xã Đức Tín, Huyện Đức Linh, Tỉnh Bình Thuận","code":"23215","parent_code":"600"},"23218":{"name":"Xã Vũ Hoà","type":"xa","slug":"xa-vu-hoa","name_with_type":"Xã Vũ Hoà","path":"Xã Vũ Hoà, Huyện Đức Linh, Tỉnh Bình Thuận","path_with_type":"Xã Vũ Hoà, Huyện Đức Linh, Tỉnh Bình Thuận","code":"23218","parent_code":"600"},"23221":{"name":"Xã Tân Hà","type":"xa","slug":"xa-tan-ha","name_with_type":"Xã Tân Hà","path":"Xã Tân Hà, Huyện Đức Linh, Tỉnh Bình Thuận","path_with_type":"Xã Tân Hà, Huyện Đức Linh, Tỉnh Bình Thuận","code":"23221","parent_code":"600"},"23224":{"name":"Xã Đông Hà","type":"xa","slug":"xa-dong-ha","name_with_type":"Xã Đông Hà","path":"Xã Đông Hà, Huyện Đức Linh, Tỉnh Bình Thuận","path_with_type":"Xã Đông Hà, Huyện Đức Linh, Tỉnh Bình Thuận","code":"23224","parent_code":"600"},"23227":{"name":"Xã Trà Tân","type":"xa","slug":"xa-tra-tan","name_with_type":"Xã Trà Tân","path":"Xã Trà Tân, Huyện Đức Linh, Tỉnh Bình Thuận","path_with_type":"Xã Trà Tân, Huyện Đức Linh, Tỉnh Bình Thuận","code":"23227","parent_code":"600"},"23230":{"name":"Thị trấn Tân Minh","type":"thi-tran","slug":"thi-tran-tan-minh","name_with_type":"Thị trấn Tân Minh","path":"Thị trấn Tân Minh, Huyện Hàm Tân, Tỉnh Bình Thuận","path_with_type":"Thị trấn Tân Minh, Huyện Hàm Tân, Tỉnh Bình Thuận","code":"23230","parent_code":"601"},"23231":{"name":"Phường Phước Hội","type":"phuong","slug":"phuong-phuoc-hoi","name_with_type":"Phường Phước Hội","path":"Phường Phước Hội, Thị xã La Gi, Tỉnh Bình Thuận","path_with_type":"Phường Phước Hội, Thị xã La Gi, Tỉnh Bình Thuận","code":"23231","parent_code":"594"},"23232":{"name":"Phường Phước Lộc","type":"phuong","slug":"phuong-phuoc-loc","name_with_type":"Phường Phước Lộc","path":"Phường Phước Lộc, Thị xã La Gi, Tỉnh Bình Thuận","path_with_type":"Phường Phước Lộc, Thị xã La Gi, Tỉnh Bình Thuận","code":"23232","parent_code":"594"},"23234":{"name":"Phường Tân Thiện","type":"phuong","slug":"phuong-tan-thien","name_with_type":"Phường Tân Thiện","path":"Phường Tân Thiện, Thị xã La Gi, Tỉnh Bình Thuận","path_with_type":"Phường Tân Thiện, Thị xã La Gi, Tỉnh Bình Thuận","code":"23234","parent_code":"594"},"23235":{"name":"Phường Tân An","type":"phuong","slug":"phuong-tan-an","name_with_type":"Phường Tân An","path":"Phường Tân An, Thị xã La Gi, Tỉnh Bình Thuận","path_with_type":"Phường Tân An, Thị xã La Gi, Tỉnh Bình Thuận","code":"23235","parent_code":"594"},"23236":{"name":"Thị trấn Tân Nghĩa","type":"thi-tran","slug":"thi-tran-tan-nghia","name_with_type":"Thị trấn Tân Nghĩa","path":"Thị trấn Tân Nghĩa, Huyện Hàm Tân, Tỉnh Bình Thuận","path_with_type":"Thị trấn Tân Nghĩa, Huyện Hàm Tân, Tỉnh Bình Thuận","code":"23236","parent_code":"601"},"23237":{"name":"Phường Bình Tân","type":"phuong","slug":"phuong-binh-tan","name_with_type":"Phường Bình Tân","path":"Phường Bình Tân, Thị xã La Gi, Tỉnh Bình Thuận","path_with_type":"Phường Bình Tân, Thị xã La Gi, Tỉnh Bình Thuận","code":"23237","parent_code":"594"},"23239":{"name":"Xã Sông Phan","type":"xa","slug":"xa-song-phan","name_with_type":"Xã Sông Phan","path":"Xã Sông Phan, Huyện Hàm Tân, Tỉnh Bình Thuận","path_with_type":"Xã Sông Phan, Huyện Hàm Tân, Tỉnh Bình Thuận","code":"23239","parent_code":"601"},"23242":{"name":"Xã Tân Phúc","type":"xa","slug":"xa-tan-phuc","name_with_type":"Xã Tân Phúc","path":"Xã Tân Phúc, Huyện Hàm Tân, Tỉnh Bình Thuận","path_with_type":"Xã Tân Phúc, Huyện Hàm Tân, Tỉnh Bình Thuận","code":"23242","parent_code":"601"},"23245":{"name":"Xã Tân Hải","type":"xa","slug":"xa-tan-hai","name_with_type":"Xã Tân Hải","path":"Xã Tân Hải, Thị xã La Gi, Tỉnh Bình Thuận","path_with_type":"Xã Tân Hải, Thị xã La Gi, Tỉnh Bình Thuận","code":"23245","parent_code":"594"},"23246":{"name":"Xã Tân Tiến","type":"xa","slug":"xa-tan-tien","name_with_type":"Xã Tân Tiến","path":"Xã Tân Tiến, Thị xã La Gi, Tỉnh Bình Thuận","path_with_type":"Xã Tân Tiến, Thị xã La Gi, Tỉnh Bình Thuận","code":"23246","parent_code":"594"},"23248":{"name":"Xã Tân Bình","type":"xa","slug":"xa-tan-binh","name_with_type":"Xã Tân Bình","path":"Xã Tân Bình, Thị xã La Gi, Tỉnh Bình Thuận","path_with_type":"Xã Tân Bình, Thị xã La Gi, Tỉnh Bình Thuận","code":"23248","parent_code":"594"},"23251":{"name":"Xã Tân Đức","type":"xa","slug":"xa-tan-duc","name_with_type":"Xã Tân Đức","path":"Xã Tân Đức, Huyện Hàm Tân, Tỉnh Bình Thuận","path_with_type":"Xã Tân Đức, Huyện Hàm Tân, Tỉnh Bình Thuận","code":"23251","parent_code":"601"},"23254":{"name":"Xã Tân Thắng","type":"xa","slug":"xa-tan-thang","name_with_type":"Xã Tân Thắng","path":"Xã Tân Thắng, Huyện Hàm Tân, Tỉnh Bình Thuận","path_with_type":"Xã Tân Thắng, Huyện Hàm Tân, Tỉnh Bình Thuận","code":"23254","parent_code":"601"},"23255":{"name":"Xã Thắng Hải","type":"xa","slug":"xa-thang-hai","name_with_type":"Xã Thắng Hải","path":"Xã Thắng Hải, Huyện Hàm Tân, Tỉnh Bình Thuận","path_with_type":"Xã Thắng Hải, Huyện Hàm Tân, Tỉnh Bình Thuận","code":"23255","parent_code":"601"},"23257":{"name":"Xã Tân Hà","type":"xa","slug":"xa-tan-ha","name_with_type":"Xã Tân Hà","path":"Xã Tân Hà, Huyện Hàm Tân, Tỉnh Bình Thuận","path_with_type":"Xã Tân Hà, Huyện Hàm Tân, Tỉnh Bình Thuận","code":"23257","parent_code":"601"},"23260":{"name":"Xã Tân Xuân","type":"xa","slug":"xa-tan-xuan","name_with_type":"Xã Tân Xuân","path":"Xã Tân Xuân, Huyện Hàm Tân, Tỉnh Bình Thuận","path_with_type":"Xã Tân Xuân, Huyện Hàm Tân, Tỉnh Bình Thuận","code":"23260","parent_code":"601"},"23266":{"name":"Xã Sơn Mỹ","type":"xa","slug":"xa-son-my","name_with_type":"Xã Sơn Mỹ","path":"Xã Sơn Mỹ, Huyện Hàm Tân, Tỉnh Bình Thuận","path_with_type":"Xã Sơn Mỹ, Huyện Hàm Tân, Tỉnh Bình Thuận","code":"23266","parent_code":"601"},"23268":{"name":"Xã Tân Phước","type":"xa","slug":"xa-tan-phuoc","name_with_type":"Xã Tân Phước","path":"Xã Tân Phước, Thị xã La Gi, Tỉnh Bình Thuận","path_with_type":"Xã Tân Phước, Thị xã La Gi, Tỉnh Bình Thuận","code":"23268","parent_code":"594"},"23272":{"name":"Xã Ngũ Phụng","type":"xa","slug":"xa-ngu-phung","name_with_type":"Xã Ngũ Phụng","path":"Xã Ngũ Phụng, Huyện Phú Quí, Tỉnh Bình Thuận","path_with_type":"Xã Ngũ Phụng, Huyện Phú Quí, Tỉnh Bình Thuận","code":"23272","parent_code":"602"},"23275":{"name":"Xã Long Hải","type":"xa","slug":"xa-long-hai","name_with_type":"Xã Long Hải","path":"Xã Long Hải, Huyện Phú Quí, Tỉnh Bình Thuận","path_with_type":"Xã Long Hải, Huyện Phú Quí, Tỉnh Bình Thuận","code":"23275","parent_code":"602"},"23278":{"name":"Xã Tam Thanh","type":"xa","slug":"xa-tam-thanh","name_with_type":"Xã Tam Thanh","path":"Xã Tam Thanh, Huyện Phú Quí, Tỉnh Bình Thuận","path_with_type":"Xã Tam Thanh, Huyện Phú Quí, Tỉnh Bình Thuận","code":"23278","parent_code":"602"},"23281":{"name":"Phường Quang Trung","type":"phuong","slug":"phuong-quang-trung","name_with_type":"Phường Quang Trung","path":"Phường Quang Trung, Thành phố Kon Tum, Tỉnh Kon Tum","path_with_type":"Phường Quang Trung, Thành phố Kon Tum, Tỉnh Kon Tum","code":"23281","parent_code":"608"},"23284":{"name":"Phường Duy Tân","type":"phuong","slug":"phuong-duy-tan","name_with_type":"Phường Duy Tân","path":"Phường Duy Tân, Thành phố Kon Tum, Tỉnh Kon Tum","path_with_type":"Phường Duy Tân, Thành phố Kon Tum, Tỉnh Kon Tum","code":"23284","parent_code":"608"},"23287":{"name":"Phường Quyết Thắng","type":"phuong","slug":"phuong-quyet-thang","name_with_type":"Phường Quyết Thắng","path":"Phường Quyết Thắng, Thành phố Kon Tum, Tỉnh Kon Tum","path_with_type":"Phường Quyết Thắng, Thành phố Kon Tum, Tỉnh Kon Tum","code":"23287","parent_code":"608"},"23290":{"name":"Phường Trường Chinh","type":"phuong","slug":"phuong-truong-chinh","name_with_type":"Phường Trường Chinh","path":"Phường Trường Chinh, Thành phố Kon Tum, Tỉnh Kon Tum","path_with_type":"Phường Trường Chinh, Thành phố Kon Tum, Tỉnh Kon Tum","code":"23290","parent_code":"608"},"23293":{"name":"Phường Thắng Lợi","type":"phuong","slug":"phuong-thang-loi","name_with_type":"Phường Thắng Lợi","path":"Phường Thắng Lợi, Thành phố Kon Tum, Tỉnh Kon Tum","path_with_type":"Phường Thắng Lợi, Thành phố Kon Tum, Tỉnh Kon Tum","code":"23293","parent_code":"608"},"23296":{"name":"Phường Ngô Mây","type":"phuong","slug":"phuong-ngo-may","name_with_type":"Phường Ngô Mây","path":"Phường Ngô Mây, Thành phố Kon Tum, Tỉnh Kon Tum","path_with_type":"Phường Ngô Mây, Thành phố Kon Tum, Tỉnh Kon Tum","code":"23296","parent_code":"608"},"23299":{"name":"Phường Thống Nhất","type":"phuong","slug":"phuong-thong-nhat","name_with_type":"Phường Thống Nhất","path":"Phường Thống Nhất, Thành phố Kon Tum, Tỉnh Kon Tum","path_with_type":"Phường Thống Nhất, Thành phố Kon Tum, Tỉnh Kon Tum","code":"23299","parent_code":"608"},"23302":{"name":"Phường Lê Lợi","type":"phuong","slug":"phuong-le-loi","name_with_type":"Phường Lê Lợi","path":"Phường Lê Lợi, Thành phố Kon Tum, Tỉnh Kon Tum","path_with_type":"Phường Lê Lợi, Thành phố Kon Tum, Tỉnh Kon Tum","code":"23302","parent_code":"608"},"23305":{"name":"Phường Nguyễn Trãi","type":"phuong","slug":"phuong-nguyen-trai","name_with_type":"Phường Nguyễn Trãi","path":"Phường Nguyễn Trãi, Thành phố Kon Tum, Tỉnh Kon Tum","path_with_type":"Phường Nguyễn Trãi, Thành phố Kon Tum, Tỉnh Kon Tum","code":"23305","parent_code":"608"},"23308":{"name":"Phường Trần Hưng Đạo","type":"phuong","slug":"phuong-tran-hung-dao","name_with_type":"Phường Trần Hưng Đạo","path":"Phường Trần Hưng Đạo, Thành phố Kon Tum, Tỉnh Kon Tum","path_with_type":"Phường Trần Hưng Đạo, Thành phố Kon Tum, Tỉnh Kon Tum","code":"23308","parent_code":"608"},"23311":{"name":"Xã Đắk Cấm","type":"xa","slug":"xa-dak-cam","name_with_type":"Xã Đắk Cấm","path":"Xã Đắk Cấm, Thành phố Kon Tum, Tỉnh Kon Tum","path_with_type":"Xã Đắk Cấm, Thành phố Kon Tum, Tỉnh Kon Tum","code":"23311","parent_code":"608"},"23314":{"name":"Xã Kroong","type":"xa","slug":"xa-kroong","name_with_type":"Xã Kroong","path":"Xã Kroong, Thành phố Kon Tum, Tỉnh Kon Tum","path_with_type":"Xã Kroong, Thành phố Kon Tum, Tỉnh Kon Tum","code":"23314","parent_code":"608"},"23317":{"name":"Xã Ngọk Bay","type":"xa","slug":"xa-ngok-bay","name_with_type":"Xã Ngọk Bay","path":"Xã Ngọk Bay, Thành phố Kon Tum, Tỉnh Kon Tum","path_with_type":"Xã Ngọk Bay, Thành phố Kon Tum, Tỉnh Kon Tum","code":"23317","parent_code":"608"},"23320":{"name":"Xã Vinh Quang","type":"xa","slug":"xa-vinh-quang","name_with_type":"Xã Vinh Quang","path":"Xã Vinh Quang, Thành phố Kon Tum, Tỉnh Kon Tum","path_with_type":"Xã Vinh Quang, Thành phố Kon Tum, Tỉnh Kon Tum","code":"23320","parent_code":"608"},"23323":{"name":"Xã Đắk Blà","type":"xa","slug":"xa-dak-bla","name_with_type":"Xã Đắk Blà","path":"Xã Đắk Blà, Thành phố Kon Tum, Tỉnh Kon Tum","path_with_type":"Xã Đắk Blà, Thành phố Kon Tum, Tỉnh Kon Tum","code":"23323","parent_code":"608"},"23326":{"name":"Xã Ia Chim","type":"xa","slug":"xa-ia-chim","name_with_type":"Xã Ia Chim","path":"Xã Ia Chim, Thành phố Kon Tum, Tỉnh Kon Tum","path_with_type":"Xã Ia Chim, Thành phố Kon Tum, Tỉnh Kon Tum","code":"23326","parent_code":"608"},"23327":{"name":"Xã Đăk Năng","type":"xa","slug":"xa-dak-nang","name_with_type":"Xã Đăk Năng","path":"Xã Đăk Năng, Thành phố Kon Tum, Tỉnh Kon Tum","path_with_type":"Xã Đăk Năng, Thành phố Kon Tum, Tỉnh Kon Tum","code":"23327","parent_code":"608"},"23329":{"name":"Xã Đoàn Kết","type":"xa","slug":"xa-doan-ket","name_with_type":"Xã Đoàn Kết","path":"Xã Đoàn Kết, Thành phố Kon Tum, Tỉnh Kon Tum","path_with_type":"Xã Đoàn Kết, Thành phố Kon Tum, Tỉnh Kon Tum","code":"23329","parent_code":"608"},"23332":{"name":"Xã Chư Hreng","type":"xa","slug":"xa-chu-hreng","name_with_type":"Xã Chư Hreng","path":"Xã Chư Hreng, Thành phố Kon Tum, Tỉnh Kon Tum","path_with_type":"Xã Chư Hreng, Thành phố Kon Tum, Tỉnh Kon Tum","code":"23332","parent_code":"608"},"23335":{"name":"Xã Đắk Rơ Wa","type":"xa","slug":"xa-dak-ro-wa","name_with_type":"Xã Đắk Rơ Wa","path":"Xã Đắk Rơ Wa, Thành phố Kon Tum, Tỉnh Kon Tum","path_with_type":"Xã Đắk Rơ Wa, Thành phố Kon Tum, Tỉnh Kon Tum","code":"23335","parent_code":"608"},"23338":{"name":"Xã Hòa Bình","type":"xa","slug":"xa-hoa-binh","name_with_type":"Xã Hòa Bình","path":"Xã Hòa Bình, Thành phố Kon Tum, Tỉnh Kon Tum","path_with_type":"Xã Hòa Bình, Thành phố Kon Tum, Tỉnh Kon Tum","code":"23338","parent_code":"608"},"23341":{"name":"Thị trấn Đắk Glei","type":"thi-tran","slug":"thi-tran-dak-glei","name_with_type":"Thị trấn Đắk Glei","path":"Thị trấn Đắk Glei, Huyện Đắk Glei, Tỉnh Kon Tum","path_with_type":"Thị trấn Đắk Glei, Huyện Đắk Glei, Tỉnh Kon Tum","code":"23341","parent_code":"610"},"23344":{"name":"Xã Đắk Blô","type":"xa","slug":"xa-dak-blo","name_with_type":"Xã Đắk Blô","path":"Xã Đắk Blô, Huyện Đắk Glei, Tỉnh Kon Tum","path_with_type":"Xã Đắk Blô, Huyện Đắk Glei, Tỉnh Kon Tum","code":"23344","parent_code":"610"},"23347":{"name":"Xã Đắk Man","type":"xa","slug":"xa-dak-man","name_with_type":"Xã Đắk Man","path":"Xã Đắk Man, Huyện Đắk Glei, Tỉnh Kon Tum","path_with_type":"Xã Đắk Man, Huyện Đắk Glei, Tỉnh Kon Tum","code":"23347","parent_code":"610"},"23350":{"name":"Xã Đắk Nhoong","type":"xa","slug":"xa-dak-nhoong","name_with_type":"Xã Đắk Nhoong","path":"Xã Đắk Nhoong, Huyện Đắk Glei, Tỉnh Kon Tum","path_with_type":"Xã Đắk Nhoong, Huyện Đắk Glei, Tỉnh Kon Tum","code":"23350","parent_code":"610"},"23353":{"name":"Xã Đắk Pék","type":"xa","slug":"xa-dak-pek","name_with_type":"Xã Đắk Pék","path":"Xã Đắk Pék, Huyện Đắk Glei, Tỉnh Kon Tum","path_with_type":"Xã Đắk Pék, Huyện Đắk Glei, Tỉnh Kon Tum","code":"23353","parent_code":"610"},"23356":{"name":"Xã Đắk Choong","type":"xa","slug":"xa-dak-choong","name_with_type":"Xã Đắk Choong","path":"Xã Đắk Choong, Huyện Đắk Glei, Tỉnh Kon Tum","path_with_type":"Xã Đắk Choong, Huyện Đắk Glei, Tỉnh Kon Tum","code":"23356","parent_code":"610"},"23359":{"name":"Xã Xốp","type":"xa","slug":"xa-xop","name_with_type":"Xã Xốp","path":"Xã Xốp, Huyện Đắk Glei, Tỉnh Kon Tum","path_with_type":"Xã Xốp, Huyện Đắk Glei, Tỉnh Kon Tum","code":"23359","parent_code":"610"},"23362":{"name":"Xã Mường Hoong","type":"xa","slug":"xa-muong-hoong","name_with_type":"Xã Mường Hoong","path":"Xã Mường Hoong, Huyện Đắk Glei, Tỉnh Kon Tum","path_with_type":"Xã Mường Hoong, Huyện Đắk Glei, Tỉnh Kon Tum","code":"23362","parent_code":"610"},"23365":{"name":"Xã Ngọc Linh","type":"xa","slug":"xa-ngoc-linh","name_with_type":"Xã Ngọc Linh","path":"Xã Ngọc Linh, Huyện Đắk Glei, Tỉnh Kon Tum","path_with_type":"Xã Ngọc Linh, Huyện Đắk Glei, Tỉnh Kon Tum","code":"23365","parent_code":"610"},"23368":{"name":"Xã Đắk Long","type":"xa","slug":"xa-dak-long","name_with_type":"Xã Đắk Long","path":"Xã Đắk Long, Huyện Đắk Glei, Tỉnh Kon Tum","path_with_type":"Xã Đắk Long, Huyện Đắk Glei, Tỉnh Kon Tum","code":"23368","parent_code":"610"},"23371":{"name":"Xã Đắk KRoong","type":"xa","slug":"xa-dak-kroong","name_with_type":"Xã Đắk KRoong","path":"Xã Đắk KRoong, Huyện Đắk Glei, Tỉnh Kon Tum","path_with_type":"Xã Đắk KRoong, Huyện Đắk Glei, Tỉnh Kon Tum","code":"23371","parent_code":"610"},"23374":{"name":"Xã Đắk Môn","type":"xa","slug":"xa-dak-mon","name_with_type":"Xã Đắk Môn","path":"Xã Đắk Môn, Huyện Đắk Glei, Tỉnh Kon Tum","path_with_type":"Xã Đắk Môn, Huyện Đắk Glei, Tỉnh Kon Tum","code":"23374","parent_code":"610"},"23377":{"name":"Thị trấn Plei Kần","type":"thi-tran","slug":"thi-tran-plei-kan","name_with_type":"Thị trấn Plei Kần","path":"Thị trấn Plei Kần, Huyện Ngọc Hồi, Tỉnh Kon Tum","path_with_type":"Thị trấn Plei Kần, Huyện Ngọc Hồi, Tỉnh Kon Tum","code":"23377","parent_code":"611"},"23380":{"name":"Xã Đắk Ang","type":"xa","slug":"xa-dak-ang","name_with_type":"Xã Đắk Ang","path":"Xã Đắk Ang, Huyện Ngọc Hồi, Tỉnh Kon Tum","path_with_type":"Xã Đắk Ang, Huyện Ngọc Hồi, Tỉnh Kon Tum","code":"23380","parent_code":"611"},"23383":{"name":"Xã Đắk Dục","type":"xa","slug":"xa-dak-duc","name_with_type":"Xã Đắk Dục","path":"Xã Đắk Dục, Huyện Ngọc Hồi, Tỉnh Kon Tum","path_with_type":"Xã Đắk Dục, Huyện Ngọc Hồi, Tỉnh Kon Tum","code":"23383","parent_code":"611"},"23386":{"name":"Xã Đắk Nông","type":"xa","slug":"xa-dak-nong","name_with_type":"Xã Đắk Nông","path":"Xã Đắk Nông, Huyện Ngọc Hồi, Tỉnh Kon Tum","path_with_type":"Xã Đắk Nông, Huyện Ngọc Hồi, Tỉnh Kon Tum","code":"23386","parent_code":"611"},"23389":{"name":"Xã Đắk Xú","type":"xa","slug":"xa-dak-xu","name_with_type":"Xã Đắk Xú","path":"Xã Đắk Xú, Huyện Ngọc Hồi, Tỉnh Kon Tum","path_with_type":"Xã Đắk Xú, Huyện Ngọc Hồi, Tỉnh Kon Tum","code":"23389","parent_code":"611"},"23392":{"name":"Xã Đắk Kan","type":"xa","slug":"xa-dak-kan","name_with_type":"Xã Đắk Kan","path":"Xã Đắk Kan, Huyện Ngọc Hồi, Tỉnh Kon Tum","path_with_type":"Xã Đắk Kan, Huyện Ngọc Hồi, Tỉnh Kon Tum","code":"23392","parent_code":"611"},"23395":{"name":"Xã Bờ Y","type":"xa","slug":"xa-bo-y","name_with_type":"Xã Bờ Y","path":"Xã Bờ Y, Huyện Ngọc Hồi, Tỉnh Kon Tum","path_with_type":"Xã Bờ Y, Huyện Ngọc Hồi, Tỉnh Kon Tum","code":"23395","parent_code":"611"},"23398":{"name":"Xã Sa Loong","type":"xa","slug":"xa-sa-loong","name_with_type":"Xã Sa Loong","path":"Xã Sa Loong, Huyện Ngọc Hồi, Tỉnh Kon Tum","path_with_type":"Xã Sa Loong, Huyện Ngọc Hồi, Tỉnh Kon Tum","code":"23398","parent_code":"611"},"23401":{"name":"Thị trấn Đắk Tô","type":"thi-tran","slug":"thi-tran-dak-to","name_with_type":"Thị trấn Đắk Tô","path":"Thị trấn Đắk Tô, Huyện Đắk Tô, Tỉnh Kon Tum","path_with_type":"Thị trấn Đắk Tô, Huyện Đắk Tô, Tỉnh Kon Tum","code":"23401","parent_code":"612"},"23404":{"name":"Xã Ngọc Lây","type":"xa","slug":"xa-ngoc-lay","name_with_type":"Xã Ngọc Lây","path":"Xã Ngọc Lây, Huyện Tu Mơ Rông, Tỉnh Kon Tum","path_with_type":"Xã Ngọc Lây, Huyện Tu Mơ Rông, Tỉnh Kon Tum","code":"23404","parent_code":"617"},"23407":{"name":"Xã Đắk Na","type":"xa","slug":"xa-dak-na","name_with_type":"Xã Đắk Na","path":"Xã Đắk Na, Huyện Tu Mơ Rông, Tỉnh Kon Tum","path_with_type":"Xã Đắk Na, Huyện Tu Mơ Rông, Tỉnh Kon Tum","code":"23407","parent_code":"617"},"23410":{"name":"Xã Măng Ri","type":"xa","slug":"xa-mang-ri","name_with_type":"Xã Măng Ri","path":"Xã Măng Ri, Huyện Tu Mơ Rông, Tỉnh Kon Tum","path_with_type":"Xã Măng Ri, Huyện Tu Mơ Rông, Tỉnh Kon Tum","code":"23410","parent_code":"617"},"23413":{"name":"Xã Ngọc Yêu","type":"xa","slug":"xa-ngoc-yeu","name_with_type":"Xã Ngọc Yêu","path":"Xã Ngọc Yêu, Huyện Tu Mơ Rông, Tỉnh Kon Tum","path_with_type":"Xã Ngọc Yêu, Huyện Tu Mơ Rông, Tỉnh Kon Tum","code":"23413","parent_code":"617"},"23416":{"name":"Xã Đắk Sao","type":"xa","slug":"xa-dak-sao","name_with_type":"Xã Đắk Sao","path":"Xã Đắk Sao, Huyện Tu Mơ Rông, Tỉnh Kon Tum","path_with_type":"Xã Đắk Sao, Huyện Tu Mơ Rông, Tỉnh Kon Tum","code":"23416","parent_code":"617"},"23417":{"name":"Xã Đắk Rơ Ông","type":"xa","slug":"xa-dak-ro-ong","name_with_type":"Xã Đắk Rơ Ông","path":"Xã Đắk Rơ Ông, Huyện Tu Mơ Rông, Tỉnh Kon Tum","path_with_type":"Xã Đắk Rơ Ông, Huyện Tu Mơ Rông, Tỉnh Kon Tum","code":"23417","parent_code":"617"},"23419":{"name":"Xã Đắk Tờ Kan","type":"xa","slug":"xa-dak-to-kan","name_with_type":"Xã Đắk Tờ Kan","path":"Xã Đắk Tờ Kan, Huyện Tu Mơ Rông, Tỉnh Kon Tum","path_with_type":"Xã Đắk Tờ Kan, Huyện Tu Mơ Rông, Tỉnh Kon Tum","code":"23419","parent_code":"617"},"23422":{"name":"Xã Tu Mơ Rông","type":"xa","slug":"xa-tu-mo-rong","name_with_type":"Xã Tu Mơ Rông","path":"Xã Tu Mơ Rông, Huyện Tu Mơ Rông, Tỉnh Kon Tum","path_with_type":"Xã Tu Mơ Rông, Huyện Tu Mơ Rông, Tỉnh Kon Tum","code":"23422","parent_code":"617"},"23425":{"name":"Xã Đắk Hà","type":"xa","slug":"xa-dak-ha","name_with_type":"Xã Đắk Hà","path":"Xã Đắk Hà, Huyện Tu Mơ Rông, Tỉnh Kon Tum","path_with_type":"Xã Đắk Hà, Huyện Tu Mơ Rông, Tỉnh Kon Tum","code":"23425","parent_code":"617"},"23427":{"name":"Xã Đắk Rơ Nga","type":"xa","slug":"xa-dak-ro-nga","name_with_type":"Xã Đắk Rơ Nga","path":"Xã Đắk Rơ Nga, Huyện Đắk Tô, Tỉnh Kon Tum","path_with_type":"Xã Đắk Rơ Nga, Huyện Đắk Tô, Tỉnh Kon Tum","code":"23427","parent_code":"612"},"23428":{"name":"Xã Ngọk Tụ","type":"xa","slug":"xa-ngok-tu","name_with_type":"Xã Ngọk Tụ","path":"Xã Ngọk Tụ, Huyện Đắk Tô, Tỉnh Kon Tum","path_with_type":"Xã Ngọk Tụ, Huyện Đắk Tô, Tỉnh Kon Tum","code":"23428","parent_code":"612"},"23430":{"name":"Xã Đắk Trăm","type":"xa","slug":"xa-dak-tram","name_with_type":"Xã Đắk Trăm","path":"Xã Đắk Trăm, Huyện Đắk Tô, Tỉnh Kon Tum","path_with_type":"Xã Đắk Trăm, Huyện Đắk Tô, Tỉnh Kon Tum","code":"23430","parent_code":"612"},"23431":{"name":"Xã Văn Lem","type":"xa","slug":"xa-van-lem","name_with_type":"Xã Văn Lem","path":"Xã Văn Lem, Huyện Đắk Tô, Tỉnh Kon Tum","path_with_type":"Xã Văn Lem, Huyện Đắk Tô, Tỉnh Kon Tum","code":"23431","parent_code":"612"},"23434":{"name":"Xã Kon Đào","type":"xa","slug":"xa-kon-dao","name_with_type":"Xã Kon Đào","path":"Xã Kon Đào, Huyện Đắk Tô, Tỉnh Kon Tum","path_with_type":"Xã Kon Đào, Huyện Đắk Tô, Tỉnh Kon Tum","code":"23434","parent_code":"612"},"23437":{"name":"Xã Tân Cảnh","type":"xa","slug":"xa-tan-canh","name_with_type":"Xã Tân Cảnh","path":"Xã Tân Cảnh, Huyện Đắk Tô, Tỉnh Kon Tum","path_with_type":"Xã Tân Cảnh, Huyện Đắk Tô, Tỉnh Kon Tum","code":"23437","parent_code":"612"},"23440":{"name":"Xã Diên Bình","type":"xa","slug":"xa-dien-binh","name_with_type":"Xã Diên Bình","path":"Xã Diên Bình, Huyện Đắk Tô, Tỉnh Kon Tum","path_with_type":"Xã Diên Bình, Huyện Đắk Tô, Tỉnh Kon Tum","code":"23440","parent_code":"612"},"23443":{"name":"Xã Pô Kô","type":"xa","slug":"xa-po-ko","name_with_type":"Xã Pô Kô","path":"Xã Pô Kô, Huyện Đắk Tô, Tỉnh Kon Tum","path_with_type":"Xã Pô Kô, Huyện Đắk Tô, Tỉnh Kon Tum","code":"23443","parent_code":"612"},"23446":{"name":"Xã Tê Xăng","type":"xa","slug":"xa-te-xang","name_with_type":"Xã Tê Xăng","path":"Xã Tê Xăng, Huyện Tu Mơ Rông, Tỉnh Kon Tum","path_with_type":"Xã Tê Xăng, Huyện Tu Mơ Rông, Tỉnh Kon Tum","code":"23446","parent_code":"617"},"23449":{"name":"Xã Văn Xuôi","type":"xa","slug":"xa-van-xuoi","name_with_type":"Xã Văn Xuôi","path":"Xã Văn Xuôi, Huyện Tu Mơ Rông, Tỉnh Kon Tum","path_with_type":"Xã Văn Xuôi, Huyện Tu Mơ Rông, Tỉnh Kon Tum","code":"23449","parent_code":"617"},"23452":{"name":"Xã Đắk Nên","type":"xa","slug":"xa-dak-nen","name_with_type":"Xã Đắk Nên","path":"Xã Đắk Nên, Huyện Kon Plông, Tỉnh Kon Tum","path_with_type":"Xã Đắk Nên, Huyện Kon Plông, Tỉnh Kon Tum","code":"23452","parent_code":"613"},"23455":{"name":"Xã Đắk Ring","type":"xa","slug":"xa-dak-ring","name_with_type":"Xã Đắk Ring","path":"Xã Đắk Ring, Huyện Kon Plông, Tỉnh Kon Tum","path_with_type":"Xã Đắk Ring, Huyện Kon Plông, Tỉnh Kon Tum","code":"23455","parent_code":"613"},"23458":{"name":"Xã Măng Buk","type":"xa","slug":"xa-mang-buk","name_with_type":"Xã Măng Buk","path":"Xã Măng Buk, Huyện Kon Plông, Tỉnh Kon Tum","path_with_type":"Xã Măng Buk, Huyện Kon Plông, Tỉnh Kon Tum","code":"23458","parent_code":"613"},"23461":{"name":"Xã Đắk Tăng","type":"xa","slug":"xa-dak-tang","name_with_type":"Xã Đắk Tăng","path":"Xã Đắk Tăng, Huyện Kon Plông, Tỉnh Kon Tum","path_with_type":"Xã Đắk Tăng, Huyện Kon Plông, Tỉnh Kon Tum","code":"23461","parent_code":"613"},"23464":{"name":"Xã Ngok Tem","type":"xa","slug":"xa-ngok-tem","name_with_type":"Xã Ngok Tem","path":"Xã Ngok Tem, Huyện Kon Plông, Tỉnh Kon Tum","path_with_type":"Xã Ngok Tem, Huyện Kon Plông, Tỉnh Kon Tum","code":"23464","parent_code":"613"},"23467":{"name":"Xã Pờ Ê","type":"xa","slug":"xa-po-e","name_with_type":"Xã Pờ Ê","path":"Xã Pờ Ê, Huyện Kon Plông, Tỉnh Kon Tum","path_with_type":"Xã Pờ Ê, Huyện Kon Plông, Tỉnh Kon Tum","code":"23467","parent_code":"613"},"23470":{"name":"Xã Măng Cành","type":"xa","slug":"xa-mang-canh","name_with_type":"Xã Măng Cành","path":"Xã Măng Cành, Huyện Kon Plông, Tỉnh Kon Tum","path_with_type":"Xã Măng Cành, Huyện Kon Plông, Tỉnh Kon Tum","code":"23470","parent_code":"613"},"23473":{"name":"Thị trấn Măng Đen","type":"thi-tran","slug":"thi-tran-mang-den","name_with_type":"Thị trấn Măng Đen","path":"Thị trấn Măng Đen, Huyện Kon Plông, Tỉnh Kon Tum","path_with_type":"Thị trấn Măng Đen, Huyện Kon Plông, Tỉnh Kon Tum","code":"23473","parent_code":"613"},"23476":{"name":"Xã Hiếu","type":"xa","slug":"xa-hieu","name_with_type":"Xã Hiếu","path":"Xã Hiếu, Huyện Kon Plông, Tỉnh Kon Tum","path_with_type":"Xã Hiếu, Huyện Kon Plông, Tỉnh Kon Tum","code":"23476","parent_code":"613"},"23479":{"name":"Thị trấn Đắk Rve","type":"thi-tran","slug":"thi-tran-dak-rve","name_with_type":"Thị trấn Đắk Rve","path":"Thị trấn Đắk Rve, Huyện Kon Rẫy, Tỉnh Kon Tum","path_with_type":"Thị trấn Đắk Rve, Huyện Kon Rẫy, Tỉnh Kon Tum","code":"23479","parent_code":"614"},"23482":{"name":"Xã Đắk Kôi","type":"xa","slug":"xa-dak-koi","name_with_type":"Xã Đắk Kôi","path":"Xã Đắk Kôi, Huyện Kon Rẫy, Tỉnh Kon Tum","path_with_type":"Xã Đắk Kôi, Huyện Kon Rẫy, Tỉnh Kon Tum","code":"23482","parent_code":"614"},"23485":{"name":"Xã Đắk Tơ Lung","type":"xa","slug":"xa-dak-to-lung","name_with_type":"Xã Đắk Tơ Lung","path":"Xã Đắk Tơ Lung, Huyện Kon Rẫy, Tỉnh Kon Tum","path_with_type":"Xã Đắk Tơ Lung, Huyện Kon Rẫy, Tỉnh Kon Tum","code":"23485","parent_code":"614"},"23488":{"name":"Xã Đắk Ruồng","type":"xa","slug":"xa-dak-ruong","name_with_type":"Xã Đắk Ruồng","path":"Xã Đắk Ruồng, Huyện Kon Rẫy, Tỉnh Kon Tum","path_with_type":"Xã Đắk Ruồng, Huyện Kon Rẫy, Tỉnh Kon Tum","code":"23488","parent_code":"614"},"23491":{"name":"Xã Đắk Pne","type":"xa","slug":"xa-dak-pne","name_with_type":"Xã Đắk Pne","path":"Xã Đắk Pne, Huyện Kon Rẫy, Tỉnh Kon Tum","path_with_type":"Xã Đắk Pne, Huyện Kon Rẫy, Tỉnh Kon Tum","code":"23491","parent_code":"614"},"23494":{"name":"Xã Đắk Tờ Re","type":"xa","slug":"xa-dak-to-re","name_with_type":"Xã Đắk Tờ Re","path":"Xã Đắk Tờ Re, Huyện Kon Rẫy, Tỉnh Kon Tum","path_with_type":"Xã Đắk Tờ Re, Huyện Kon Rẫy, Tỉnh Kon Tum","code":"23494","parent_code":"614"},"23497":{"name":"Xã Tân Lập","type":"xa","slug":"xa-tan-lap","name_with_type":"Xã Tân Lập","path":"Xã Tân Lập, Huyện Kon Rẫy, Tỉnh Kon Tum","path_with_type":"Xã Tân Lập, Huyện Kon Rẫy, Tỉnh Kon Tum","code":"23497","parent_code":"614"},"23500":{"name":"Thị trấn Đắk Hà","type":"thi-tran","slug":"thi-tran-dak-ha","name_with_type":"Thị trấn Đắk Hà","path":"Thị trấn Đắk Hà, Huyện Đắk Hà, Tỉnh Kon Tum","path_with_type":"Thị trấn Đắk Hà, Huyện Đắk Hà, Tỉnh Kon Tum","code":"23500","parent_code":"615"},"23503":{"name":"Xã Đắk PXi","type":"xa","slug":"xa-dak-pxi","name_with_type":"Xã Đắk PXi","path":"Xã Đắk PXi, Huyện Đắk Hà, Tỉnh Kon Tum","path_with_type":"Xã Đắk PXi, Huyện Đắk Hà, Tỉnh Kon Tum","code":"23503","parent_code":"615"},"23504":{"name":"Xã Đăk Long","type":"xa","slug":"xa-dak-long","name_with_type":"Xã Đăk Long","path":"Xã Đăk Long, Huyện Đắk Hà, Tỉnh Kon Tum","path_with_type":"Xã Đăk Long, Huyện Đắk Hà, Tỉnh Kon Tum","code":"23504","parent_code":"615"},"23506":{"name":"Xã Đắk HRing","type":"xa","slug":"xa-dak-hring","name_with_type":"Xã Đắk HRing","path":"Xã Đắk HRing, Huyện Đắk Hà, Tỉnh Kon Tum","path_with_type":"Xã Đắk HRing, Huyện Đắk Hà, Tỉnh Kon Tum","code":"23506","parent_code":"615"},"23509":{"name":"Xã Đắk Ui","type":"xa","slug":"xa-dak-ui","name_with_type":"Xã Đắk Ui","path":"Xã Đắk Ui, Huyện Đắk Hà, Tỉnh Kon Tum","path_with_type":"Xã Đắk Ui, Huyện Đắk Hà, Tỉnh Kon Tum","code":"23509","parent_code":"615"},"23510":{"name":"Xã Đăk Ngọk","type":"xa","slug":"xa-dak-ngok","name_with_type":"Xã Đăk Ngọk","path":"Xã Đăk Ngọk, Huyện Đắk Hà, Tỉnh Kon Tum","path_with_type":"Xã Đăk Ngọk, Huyện Đắk Hà, Tỉnh Kon Tum","code":"23510","parent_code":"615"},"23512":{"name":"Xã Đắk Mar","type":"xa","slug":"xa-dak-mar","name_with_type":"Xã Đắk Mar","path":"Xã Đắk Mar, Huyện Đắk Hà, Tỉnh Kon Tum","path_with_type":"Xã Đắk Mar, Huyện Đắk Hà, Tỉnh Kon Tum","code":"23512","parent_code":"615"},"23515":{"name":"Xã Ngok Wang","type":"xa","slug":"xa-ngok-wang","name_with_type":"Xã Ngok Wang","path":"Xã Ngok Wang, Huyện Đắk Hà, Tỉnh Kon Tum","path_with_type":"Xã Ngok Wang, Huyện Đắk Hà, Tỉnh Kon Tum","code":"23515","parent_code":"615"},"23518":{"name":"Xã Ngok Réo","type":"xa","slug":"xa-ngok-reo","name_with_type":"Xã Ngok Réo","path":"Xã Ngok Réo, Huyện Đắk Hà, Tỉnh Kon Tum","path_with_type":"Xã Ngok Réo, Huyện Đắk Hà, Tỉnh Kon Tum","code":"23518","parent_code":"615"},"23521":{"name":"Xã Hà Mòn","type":"xa","slug":"xa-ha-mon","name_with_type":"Xã Hà Mòn","path":"Xã Hà Mòn, Huyện Đắk Hà, Tỉnh Kon Tum","path_with_type":"Xã Hà Mòn, Huyện Đắk Hà, Tỉnh Kon Tum","code":"23521","parent_code":"615"},"23524":{"name":"Xã Đắk La","type":"xa","slug":"xa-dak-la","name_with_type":"Xã Đắk La","path":"Xã Đắk La, Huyện Đắk Hà, Tỉnh Kon Tum","path_with_type":"Xã Đắk La, Huyện Đắk Hà, Tỉnh Kon Tum","code":"23524","parent_code":"615"},"23527":{"name":"Thị trấn Sa Thầy","type":"thi-tran","slug":"thi-tran-sa-thay","name_with_type":"Thị trấn Sa Thầy","path":"Thị trấn Sa Thầy, Huyện Sa Thầy, Tỉnh Kon Tum","path_with_type":"Thị trấn Sa Thầy, Huyện Sa Thầy, Tỉnh Kon Tum","code":"23527","parent_code":"616"},"23530":{"name":"Xã Rơ Kơi","type":"xa","slug":"xa-ro-koi","name_with_type":"Xã Rơ Kơi","path":"Xã Rơ Kơi, Huyện Sa Thầy, Tỉnh Kon Tum","path_with_type":"Xã Rơ Kơi, Huyện Sa Thầy, Tỉnh Kon Tum","code":"23530","parent_code":"616"},"23533":{"name":"Xã Sa Nhơn","type":"xa","slug":"xa-sa-nhon","name_with_type":"Xã Sa Nhơn","path":"Xã Sa Nhơn, Huyện Sa Thầy, Tỉnh Kon Tum","path_with_type":"Xã Sa Nhơn, Huyện Sa Thầy, Tỉnh Kon Tum","code":"23533","parent_code":"616"},"23534":{"name":"Xã Hơ Moong","type":"xa","slug":"xa-ho-moong","name_with_type":"Xã Hơ Moong","path":"Xã Hơ Moong, Huyện Sa Thầy, Tỉnh Kon Tum","path_with_type":"Xã Hơ Moong, Huyện Sa Thầy, Tỉnh Kon Tum","code":"23534","parent_code":"616"},"23535":{"name":"Xã Ia Đal","type":"xa","slug":"xa-ia-dal","name_with_type":"Xã Ia Đal","path":"Xã Ia Đal, Huyện Ia H\' Drai, Tỉnh Kon Tum","path_with_type":"Xã Ia Đal, Huyện Ia H\' Drai, Tỉnh Kon Tum","code":"23535","parent_code":"618"},"23536":{"name":"Xã Mô Rai","type":"xa","slug":"xa-mo-rai","name_with_type":"Xã Mô Rai","path":"Xã Mô Rai, Huyện Sa Thầy, Tỉnh Kon Tum","path_with_type":"Xã Mô Rai, Huyện Sa Thầy, Tỉnh Kon Tum","code":"23536","parent_code":"616"},"23537":{"name":"Xã Ia Dom","type":"xa","slug":"xa-ia-dom","name_with_type":"Xã Ia Dom","path":"Xã Ia Dom, Huyện Ia H\' Drai, Tỉnh Kon Tum","path_with_type":"Xã Ia Dom, Huyện Ia H\' Drai, Tỉnh Kon Tum","code":"23537","parent_code":"618"},"23538":{"name":"Xã Ia Tơi","type":"xa","slug":"xa-ia-toi","name_with_type":"Xã Ia Tơi","path":"Xã Ia Tơi, Huyện Ia H\' Drai, Tỉnh Kon Tum","path_with_type":"Xã Ia Tơi, Huyện Ia H\' Drai, Tỉnh Kon Tum","code":"23538","parent_code":"618"},"23539":{"name":"Xã Sa Sơn","type":"xa","slug":"xa-sa-son","name_with_type":"Xã Sa Sơn","path":"Xã Sa Sơn, Huyện Sa Thầy, Tỉnh Kon Tum","path_with_type":"Xã Sa Sơn, Huyện Sa Thầy, Tỉnh Kon Tum","code":"23539","parent_code":"616"},"23542":{"name":"Xã Sa Nghĩa","type":"xa","slug":"xa-sa-nghia","name_with_type":"Xã Sa Nghĩa","path":"Xã Sa Nghĩa, Huyện Sa Thầy, Tỉnh Kon Tum","path_with_type":"Xã Sa Nghĩa, Huyện Sa Thầy, Tỉnh Kon Tum","code":"23542","parent_code":"616"},"23545":{"name":"Xã Sa Bình","type":"xa","slug":"xa-sa-binh","name_with_type":"Xã Sa Bình","path":"Xã Sa Bình, Huyện Sa Thầy, Tỉnh Kon Tum","path_with_type":"Xã Sa Bình, Huyện Sa Thầy, Tỉnh Kon Tum","code":"23545","parent_code":"616"},"23548":{"name":"Xã Ya Xiêr","type":"xa","slug":"xa-ya-xier","name_with_type":"Xã Ya Xiêr","path":"Xã Ya Xiêr, Huyện Sa Thầy, Tỉnh Kon Tum","path_with_type":"Xã Ya Xiêr, Huyện Sa Thầy, Tỉnh Kon Tum","code":"23548","parent_code":"616"},"23551":{"name":"Xã Ya Tăng","type":"xa","slug":"xa-ya-tang","name_with_type":"Xã Ya Tăng","path":"Xã Ya Tăng, Huyện Sa Thầy, Tỉnh Kon Tum","path_with_type":"Xã Ya Tăng, Huyện Sa Thầy, Tỉnh Kon Tum","code":"23551","parent_code":"616"},"23554":{"name":"Xã Ya ly","type":"xa","slug":"xa-ya-ly","name_with_type":"Xã Ya ly","path":"Xã Ya ly, Huyện Sa Thầy, Tỉnh Kon Tum","path_with_type":"Xã Ya ly, Huyện Sa Thầy, Tỉnh Kon Tum","code":"23554","parent_code":"616"},"23557":{"name":"Phường Yên Đỗ","type":"phuong","slug":"phuong-yen-do","name_with_type":"Phường Yên Đỗ","path":"Phường Yên Đỗ, Thành phố Pleiku, Tỉnh Gia Lai","path_with_type":"Phường Yên Đỗ, Thành phố Pleiku, Tỉnh Gia Lai","code":"23557","parent_code":"622"},"23560":{"name":"Phường Diên Hồng","type":"phuong","slug":"phuong-dien-hong","name_with_type":"Phường Diên Hồng","path":"Phường Diên Hồng, Thành phố Pleiku, Tỉnh Gia Lai","path_with_type":"Phường Diên Hồng, Thành phố Pleiku, Tỉnh Gia Lai","code":"23560","parent_code":"622"},"23563":{"name":"Phường Ia Kring","type":"phuong","slug":"phuong-ia-kring","name_with_type":"Phường Ia Kring","path":"Phường Ia Kring, Thành phố Pleiku, Tỉnh Gia Lai","path_with_type":"Phường Ia Kring, Thành phố Pleiku, Tỉnh Gia Lai","code":"23563","parent_code":"622"},"23566":{"name":"Phường Hội Thương","type":"phuong","slug":"phuong-hoi-thuong","name_with_type":"Phường Hội Thương","path":"Phường Hội Thương, Thành phố Pleiku, Tỉnh Gia Lai","path_with_type":"Phường Hội Thương, Thành phố Pleiku, Tỉnh Gia Lai","code":"23566","parent_code":"622"},"23569":{"name":"Phường Hội Phú","type":"phuong","slug":"phuong-hoi-phu","name_with_type":"Phường Hội Phú","path":"Phường Hội Phú, Thành phố Pleiku, Tỉnh Gia Lai","path_with_type":"Phường Hội Phú, Thành phố Pleiku, Tỉnh Gia Lai","code":"23569","parent_code":"622"},"23570":{"name":"Phường Phù Đổng","type":"phuong","slug":"phuong-phu-dong","name_with_type":"Phường Phù Đổng","path":"Phường Phù Đổng, Thành phố Pleiku, Tỉnh Gia Lai","path_with_type":"Phường Phù Đổng, Thành phố Pleiku, Tỉnh Gia Lai","code":"23570","parent_code":"622"},"23572":{"name":"Phường Hoa Lư","type":"phuong","slug":"phuong-hoa-lu","name_with_type":"Phường Hoa Lư","path":"Phường Hoa Lư, Thành phố Pleiku, Tỉnh Gia Lai","path_with_type":"Phường Hoa Lư, Thành phố Pleiku, Tỉnh Gia Lai","code":"23572","parent_code":"622"},"23575":{"name":"Phường Tây Sơn","type":"phuong","slug":"phuong-tay-son","name_with_type":"Phường Tây Sơn","path":"Phường Tây Sơn, Thành phố Pleiku, Tỉnh Gia Lai","path_with_type":"Phường Tây Sơn, Thành phố Pleiku, Tỉnh Gia Lai","code":"23575","parent_code":"622"},"23578":{"name":"Phường Thống Nhất","type":"phuong","slug":"phuong-thong-nhat","name_with_type":"Phường Thống Nhất","path":"Phường Thống Nhất, Thành phố Pleiku, Tỉnh Gia Lai","path_with_type":"Phường Thống Nhất, Thành phố Pleiku, Tỉnh Gia Lai","code":"23578","parent_code":"622"},"23579":{"name":"Phường Đống Đa","type":"phuong","slug":"phuong-dong-da","name_with_type":"Phường Đống Đa","path":"Phường Đống Đa, Thành phố Pleiku, Tỉnh Gia Lai","path_with_type":"Phường Đống Đa, Thành phố Pleiku, Tỉnh Gia Lai","code":"23579","parent_code":"622"},"23581":{"name":"Phường Trà Bá","type":"phuong","slug":"phuong-tra-ba","name_with_type":"Phường Trà Bá","path":"Phường Trà Bá, Thành phố Pleiku, Tỉnh Gia Lai","path_with_type":"Phường Trà Bá, Thành phố Pleiku, Tỉnh Gia Lai","code":"23581","parent_code":"622"},"23582":{"name":"Phường Thắng Lợi","type":"phuong","slug":"phuong-thang-loi","name_with_type":"Phường Thắng Lợi","path":"Phường Thắng Lợi, Thành phố Pleiku, Tỉnh Gia Lai","path_with_type":"Phường Thắng Lợi, Thành phố Pleiku, Tỉnh Gia Lai","code":"23582","parent_code":"622"},"23584":{"name":"Phường Yên Thế","type":"phuong","slug":"phuong-yen-the","name_with_type":"Phường Yên Thế","path":"Phường Yên Thế, Thành phố Pleiku, Tỉnh Gia Lai","path_with_type":"Phường Yên Thế, Thành phố Pleiku, Tỉnh Gia Lai","code":"23584","parent_code":"622"},"23586":{"name":"Phường Chi Lăng","type":"phuong","slug":"phuong-chi-lang","name_with_type":"Phường Chi Lăng","path":"Phường Chi Lăng, Thành phố Pleiku, Tỉnh Gia Lai","path_with_type":"Phường Chi Lăng, Thành phố Pleiku, Tỉnh Gia Lai","code":"23586","parent_code":"622"},"23590":{"name":"Xã Biển Hồ","type":"xa","slug":"xa-bien-ho","name_with_type":"Xã Biển Hồ","path":"Xã Biển Hồ, Thành phố Pleiku, Tỉnh Gia Lai","path_with_type":"Xã Biển Hồ, Thành phố Pleiku, Tỉnh Gia Lai","code":"23590","parent_code":"622"},"23596":{"name":"Xã Trà Đa","type":"xa","slug":"xa-tra-da","name_with_type":"Xã Trà Đa","path":"Xã Trà Đa, Thành phố Pleiku, Tỉnh Gia Lai","path_with_type":"Xã Trà Đa, Thành phố Pleiku, Tỉnh Gia Lai","code":"23596","parent_code":"622"},"23599":{"name":"Xã Chư Á","type":"xa","slug":"xa-chu-a","name_with_type":"Xã Chư Á","path":"Xã Chư Á, Thành phố Pleiku, Tỉnh Gia Lai","path_with_type":"Xã Chư Á, Thành phố Pleiku, Tỉnh Gia Lai","code":"23599","parent_code":"622"},"23602":{"name":"Xã An Phú","type":"xa","slug":"xa-an-phu","name_with_type":"Xã An Phú","path":"Xã An Phú, Thành phố Pleiku, Tỉnh Gia Lai","path_with_type":"Xã An Phú, Thành phố Pleiku, Tỉnh Gia Lai","code":"23602","parent_code":"622"},"23605":{"name":"Xã Diên Phú","type":"xa","slug":"xa-dien-phu","name_with_type":"Xã Diên Phú","path":"Xã Diên Phú, Thành phố Pleiku, Tỉnh Gia Lai","path_with_type":"Xã Diên Phú, Thành phố Pleiku, Tỉnh Gia Lai","code":"23605","parent_code":"622"},"23608":{"name":"Xã Ia Kênh","type":"xa","slug":"xa-ia-kenh","name_with_type":"Xã Ia Kênh","path":"Xã Ia Kênh, Thành phố Pleiku, Tỉnh Gia Lai","path_with_type":"Xã Ia Kênh, Thành phố Pleiku, Tỉnh Gia Lai","code":"23608","parent_code":"622"},"23611":{"name":"Xã Gào","type":"xa","slug":"xa-gao","name_with_type":"Xã Gào","path":"Xã Gào, Thành phố Pleiku, Tỉnh Gia Lai","path_with_type":"Xã Gào, Thành phố Pleiku, Tỉnh Gia Lai","code":"23611","parent_code":"622"},"23614":{"name":"Phường An Bình","type":"phuong","slug":"phuong-an-binh","name_with_type":"Phường An Bình","path":"Phường An Bình, Thị xã An Khê, Tỉnh Gia Lai","path_with_type":"Phường An Bình, Thị xã An Khê, Tỉnh Gia Lai","code":"23614","parent_code":"623"},"23617":{"name":"Phường Tây Sơn","type":"phuong","slug":"phuong-tay-son","name_with_type":"Phường Tây Sơn","path":"Phường Tây Sơn, Thị xã An Khê, Tỉnh Gia Lai","path_with_type":"Phường Tây Sơn, Thị xã An Khê, Tỉnh Gia Lai","code":"23617","parent_code":"623"},"23620":{"name":"Phường An Phú","type":"phuong","slug":"phuong-an-phu","name_with_type":"Phường An Phú","path":"Phường An Phú, Thị xã An Khê, Tỉnh Gia Lai","path_with_type":"Phường An Phú, Thị xã An Khê, Tỉnh Gia Lai","code":"23620","parent_code":"623"},"23623":{"name":"Phường An Tân","type":"phuong","slug":"phuong-an-tan","name_with_type":"Phường An Tân","path":"Phường An Tân, Thị xã An Khê, Tỉnh Gia Lai","path_with_type":"Phường An Tân, Thị xã An Khê, Tỉnh Gia Lai","code":"23623","parent_code":"623"},"23626":{"name":"Xã Tú An","type":"xa","slug":"xa-tu-an","name_with_type":"Xã Tú An","path":"Xã Tú An, Thị xã An Khê, Tỉnh Gia Lai","path_with_type":"Xã Tú An, Thị xã An Khê, Tỉnh Gia Lai","code":"23626","parent_code":"623"},"23627":{"name":"Xã Xuân An","type":"xa","slug":"xa-xuan-an","name_with_type":"Xã Xuân An","path":"Xã Xuân An, Thị xã An Khê, Tỉnh Gia Lai","path_with_type":"Xã Xuân An, Thị xã An Khê, Tỉnh Gia Lai","code":"23627","parent_code":"623"},"23629":{"name":"Xã Cửu An","type":"xa","slug":"xa-cuu-an","name_with_type":"Xã Cửu An","path":"Xã Cửu An, Thị xã An Khê, Tỉnh Gia Lai","path_with_type":"Xã Cửu An, Thị xã An Khê, Tỉnh Gia Lai","code":"23629","parent_code":"623"},"23630":{"name":"Phường An Phước","type":"phuong","slug":"phuong-an-phuoc","name_with_type":"Phường An Phước","path":"Phường An Phước, Thị xã An Khê, Tỉnh Gia Lai","path_with_type":"Phường An Phước, Thị xã An Khê, Tỉnh Gia Lai","code":"23630","parent_code":"623"},"23632":{"name":"Xã Song An","type":"xa","slug":"xa-song-an","name_with_type":"Xã Song An","path":"Xã Song An, Thị xã An Khê, Tỉnh Gia Lai","path_with_type":"Xã Song An, Thị xã An Khê, Tỉnh Gia Lai","code":"23632","parent_code":"623"},"23633":{"name":"Phường Ngô Mây","type":"phuong","slug":"phuong-ngo-may","name_with_type":"Phường Ngô Mây","path":"Phường Ngô Mây, Thị xã An Khê, Tỉnh Gia Lai","path_with_type":"Phường Ngô Mây, Thị xã An Khê, Tỉnh Gia Lai","code":"23633","parent_code":"623"},"23635":{"name":"Xã Thành An","type":"xa","slug":"xa-thanh-an","name_with_type":"Xã Thành An","path":"Xã Thành An, Thị xã An Khê, Tỉnh Gia Lai","path_with_type":"Xã Thành An, Thị xã An Khê, Tỉnh Gia Lai","code":"23635","parent_code":"623"},"23638":{"name":"Thị trấn KBang","type":"thi-tran","slug":"thi-tran-kbang","name_with_type":"Thị trấn KBang","path":"Thị trấn KBang, Huyện KBang, Tỉnh Gia Lai","path_with_type":"Thị trấn KBang, Huyện KBang, Tỉnh Gia Lai","code":"23638","parent_code":"625"},"23641":{"name":"Xã Kon Pne","type":"xa","slug":"xa-kon-pne","name_with_type":"Xã Kon Pne","path":"Xã Kon Pne, Huyện KBang, Tỉnh Gia Lai","path_with_type":"Xã Kon Pne, Huyện KBang, Tỉnh Gia Lai","code":"23641","parent_code":"625"},"23644":{"name":"Xã Đăk Roong","type":"xa","slug":"xa-dak-roong","name_with_type":"Xã Đăk Roong","path":"Xã Đăk Roong, Huyện KBang, Tỉnh Gia Lai","path_with_type":"Xã Đăk Roong, Huyện KBang, Tỉnh Gia Lai","code":"23644","parent_code":"625"},"23647":{"name":"Xã Sơn Lang","type":"xa","slug":"xa-son-lang","name_with_type":"Xã Sơn Lang","path":"Xã Sơn Lang, Huyện KBang, Tỉnh Gia Lai","path_with_type":"Xã Sơn Lang, Huyện KBang, Tỉnh Gia Lai","code":"23647","parent_code":"625"},"23650":{"name":"Xã KRong","type":"xa","slug":"xa-krong","name_with_type":"Xã KRong","path":"Xã KRong, Huyện KBang, Tỉnh Gia Lai","path_with_type":"Xã KRong, Huyện KBang, Tỉnh Gia Lai","code":"23650","parent_code":"625"},"23653":{"name":"Xã Sơ Pai","type":"xa","slug":"xa-so-pai","name_with_type":"Xã Sơ Pai","path":"Xã Sơ Pai, Huyện KBang, Tỉnh Gia Lai","path_with_type":"Xã Sơ Pai, Huyện KBang, Tỉnh Gia Lai","code":"23653","parent_code":"625"},"23656":{"name":"Xã Lơ Ku","type":"xa","slug":"xa-lo-ku","name_with_type":"Xã Lơ Ku","path":"Xã Lơ Ku, Huyện KBang, Tỉnh Gia Lai","path_with_type":"Xã Lơ Ku, Huyện KBang, Tỉnh Gia Lai","code":"23656","parent_code":"625"},"23659":{"name":"Xã Đông","type":"xa","slug":"xa-dong","name_with_type":"Xã Đông","path":"Xã Đông, Huyện KBang, Tỉnh Gia Lai","path_with_type":"Xã Đông, Huyện KBang, Tỉnh Gia Lai","code":"23659","parent_code":"625"},"23660":{"name":"Xã Đak SMar","type":"xa","slug":"xa-dak-smar","name_with_type":"Xã Đak SMar","path":"Xã Đak SMar, Huyện KBang, Tỉnh Gia Lai","path_with_type":"Xã Đak SMar, Huyện KBang, Tỉnh Gia Lai","code":"23660","parent_code":"625"},"23662":{"name":"Xã Nghĩa An","type":"xa","slug":"xa-nghia-an","name_with_type":"Xã Nghĩa An","path":"Xã Nghĩa An, Huyện KBang, Tỉnh Gia Lai","path_with_type":"Xã Nghĩa An, Huyện KBang, Tỉnh Gia Lai","code":"23662","parent_code":"625"},"23665":{"name":"Xã Tơ Tung","type":"xa","slug":"xa-to-tung","name_with_type":"Xã Tơ Tung","path":"Xã Tơ Tung, Huyện KBang, Tỉnh Gia Lai","path_with_type":"Xã Tơ Tung, Huyện KBang, Tỉnh Gia Lai","code":"23665","parent_code":"625"},"23668":{"name":"Xã Kông Lơng Khơng","type":"xa","slug":"xa-kong-long-khong","name_with_type":"Xã Kông Lơng Khơng","path":"Xã Kông Lơng Khơng, Huyện KBang, Tỉnh Gia Lai","path_with_type":"Xã Kông Lơng Khơng, Huyện KBang, Tỉnh Gia Lai","code":"23668","parent_code":"625"},"23674":{"name":"Xã Kông Bơ La","type":"xa","slug":"xa-kong-bo-la","name_with_type":"Xã Kông Bơ La","path":"Xã Kông Bơ La, Huyện KBang, Tỉnh Gia Lai","path_with_type":"Xã Kông Bơ La, Huyện KBang, Tỉnh Gia Lai","code":"23674","parent_code":"625"},"23677":{"name":"Thị trấn Đăk Đoa","type":"thi-tran","slug":"thi-tran-dak-doa","name_with_type":"Thị trấn Đăk Đoa","path":"Thị trấn Đăk Đoa, Huyện Đăk Đoa, Tỉnh Gia Lai","path_with_type":"Thị trấn Đăk Đoa, Huyện Đăk Đoa, Tỉnh Gia Lai","code":"23677","parent_code":"626"},"23680":{"name":"Xã Hà Đông","type":"xa","slug":"xa-ha-dong","name_with_type":"Xã Hà Đông","path":"Xã Hà Đông, Huyện Đăk Đoa, Tỉnh Gia Lai","path_with_type":"Xã Hà Đông, Huyện Đăk Đoa, Tỉnh Gia Lai","code":"23680","parent_code":"626"},"23683":{"name":"Xã Đăk Sơmei","type":"xa","slug":"xa-dak-somei","name_with_type":"Xã Đăk Sơmei","path":"Xã Đăk Sơmei, Huyện Đăk Đoa, Tỉnh Gia Lai","path_with_type":"Xã Đăk Sơmei, Huyện Đăk Đoa, Tỉnh Gia Lai","code":"23683","parent_code":"626"},"23684":{"name":"Xã Đăk Krong","type":"xa","slug":"xa-dak-krong","name_with_type":"Xã Đăk Krong","path":"Xã Đăk Krong, Huyện Đăk Đoa, Tỉnh Gia Lai","path_with_type":"Xã Đăk Krong, Huyện Đăk Đoa, Tỉnh Gia Lai","code":"23684","parent_code":"626"},"23686":{"name":"Xã Hải Yang","type":"xa","slug":"xa-hai-yang","name_with_type":"Xã Hải Yang","path":"Xã Hải Yang, Huyện Đăk Đoa, Tỉnh Gia Lai","path_with_type":"Xã Hải Yang, Huyện Đăk Đoa, Tỉnh Gia Lai","code":"23686","parent_code":"626"},"23689":{"name":"Xã Kon Gang","type":"xa","slug":"xa-kon-gang","name_with_type":"Xã Kon Gang","path":"Xã Kon Gang, Huyện Đăk Đoa, Tỉnh Gia Lai","path_with_type":"Xã Kon Gang, Huyện Đăk Đoa, Tỉnh Gia Lai","code":"23689","parent_code":"626"},"23692":{"name":"Xã Hà Bầu","type":"xa","slug":"xa-ha-bau","name_with_type":"Xã Hà Bầu","path":"Xã Hà Bầu, Huyện Đăk Đoa, Tỉnh Gia Lai","path_with_type":"Xã Hà Bầu, Huyện Đăk Đoa, Tỉnh Gia Lai","code":"23692","parent_code":"626"},"23695":{"name":"Xã Nam Yang","type":"xa","slug":"xa-nam-yang","name_with_type":"Xã Nam Yang","path":"Xã Nam Yang, Huyện Đăk Đoa, Tỉnh Gia Lai","path_with_type":"Xã Nam Yang, Huyện Đăk Đoa, Tỉnh Gia Lai","code":"23695","parent_code":"626"},"23698":{"name":"Xã K\' Dang","type":"xa","slug":"xa-k\'-dang","name_with_type":"Xã K\' Dang","path":"Xã K\' Dang, Huyện Đăk Đoa, Tỉnh Gia Lai","path_with_type":"Xã K\' Dang, Huyện Đăk Đoa, Tỉnh Gia Lai","code":"23698","parent_code":"626"},"23701":{"name":"Xã H\' Neng","type":"xa","slug":"xa-h\'-neng","name_with_type":"Xã H\' Neng","path":"Xã H\' Neng, Huyện Đăk Đoa, Tỉnh Gia Lai","path_with_type":"Xã H\' Neng, Huyện Đăk Đoa, Tỉnh Gia Lai","code":"23701","parent_code":"626"},"23704":{"name":"Xã Tân Bình","type":"xa","slug":"xa-tan-binh","name_with_type":"Xã Tân Bình","path":"Xã Tân Bình, Huyện Đăk Đoa, Tỉnh Gia Lai","path_with_type":"Xã Tân Bình, Huyện Đăk Đoa, Tỉnh Gia Lai","code":"23704","parent_code":"626"},"23707":{"name":"Xã Glar","type":"xa","slug":"xa-glar","name_with_type":"Xã Glar","path":"Xã Glar, Huyện Đăk Đoa, Tỉnh Gia Lai","path_with_type":"Xã Glar, Huyện Đăk Đoa, Tỉnh Gia Lai","code":"23707","parent_code":"626"},"23710":{"name":"Xã A Dơk","type":"xa","slug":"xa-a-dok","name_with_type":"Xã A Dơk","path":"Xã A Dơk, Huyện Đăk Đoa, Tỉnh Gia Lai","path_with_type":"Xã A Dơk, Huyện Đăk Đoa, Tỉnh Gia Lai","code":"23710","parent_code":"626"},"23713":{"name":"Xã Trang","type":"xa","slug":"xa-trang","name_with_type":"Xã Trang","path":"Xã Trang, Huyện Đăk Đoa, Tỉnh Gia Lai","path_with_type":"Xã Trang, Huyện Đăk Đoa, Tỉnh Gia Lai","code":"23713","parent_code":"626"},"23714":{"name":"Xã HNol","type":"xa","slug":"xa-hnol","name_with_type":"Xã HNol","path":"Xã HNol, Huyện Đăk Đoa, Tỉnh Gia Lai","path_with_type":"Xã HNol, Huyện Đăk Đoa, Tỉnh Gia Lai","code":"23714","parent_code":"626"},"23716":{"name":"Xã Ia Pết","type":"xa","slug":"xa-ia-pet","name_with_type":"Xã Ia Pết","path":"Xã Ia Pết, Huyện Đăk Đoa, Tỉnh Gia Lai","path_with_type":"Xã Ia Pết, Huyện Đăk Đoa, Tỉnh Gia Lai","code":"23716","parent_code":"626"},"23719":{"name":"Xã Ia Băng","type":"xa","slug":"xa-ia-bang","name_with_type":"Xã Ia Băng","path":"Xã Ia Băng, Huyện Đăk Đoa, Tỉnh Gia Lai","path_with_type":"Xã Ia Băng, Huyện Đăk Đoa, Tỉnh Gia Lai","code":"23719","parent_code":"626"},"23722":{"name":"Thị trấn Phú Hòa","type":"thi-tran","slug":"thi-tran-phu-hoa","name_with_type":"Thị trấn Phú Hòa","path":"Thị trấn Phú Hòa, Huyện Chư Păh, Tỉnh Gia Lai","path_with_type":"Thị trấn Phú Hòa, Huyện Chư Păh, Tỉnh Gia Lai","code":"23722","parent_code":"627"},"23725":{"name":"Xã Hà Tây","type":"xa","slug":"xa-ha-tay","name_with_type":"Xã Hà Tây","path":"Xã Hà Tây, Huyện Chư Păh, Tỉnh Gia Lai","path_with_type":"Xã Hà Tây, Huyện Chư Păh, Tỉnh Gia Lai","code":"23725","parent_code":"627"},"23728":{"name":"Xã Ia Khươl","type":"xa","slug":"xa-ia-khuol","name_with_type":"Xã Ia Khươl","path":"Xã Ia Khươl, Huyện Chư Păh, Tỉnh Gia Lai","path_with_type":"Xã Ia Khươl, Huyện Chư Păh, Tỉnh Gia Lai","code":"23728","parent_code":"627"},"23731":{"name":"Xã Ia Phí","type":"xa","slug":"xa-ia-phi","name_with_type":"Xã Ia Phí","path":"Xã Ia Phí, Huyện Chư Păh, Tỉnh Gia Lai","path_with_type":"Xã Ia Phí, Huyện Chư Păh, Tỉnh Gia Lai","code":"23731","parent_code":"627"},"23734":{"name":"Thị trấn Ia Ly","type":"thi-tran","slug":"thi-tran-ia-ly","name_with_type":"Thị trấn Ia Ly","path":"Thị trấn Ia Ly, Huyện Chư Păh, Tỉnh Gia Lai","path_with_type":"Thị trấn Ia Ly, Huyện Chư Păh, Tỉnh Gia Lai","code":"23734","parent_code":"627"},"23737":{"name":"Xã Ia Mơ Nông","type":"xa","slug":"xa-ia-mo-nong","name_with_type":"Xã Ia Mơ Nông","path":"Xã Ia Mơ Nông, Huyện Chư Păh, Tỉnh Gia Lai","path_with_type":"Xã Ia Mơ Nông, Huyện Chư Păh, Tỉnh Gia Lai","code":"23737","parent_code":"627"},"23738":{"name":"Xã Ia Kreng","type":"xa","slug":"xa-ia-kreng","name_with_type":"Xã Ia Kreng","path":"Xã Ia Kreng, Huyện Chư Păh, Tỉnh Gia Lai","path_with_type":"Xã Ia Kreng, Huyện Chư Păh, Tỉnh Gia Lai","code":"23738","parent_code":"627"},"23740":{"name":"Xã Đăk Tơ Ver","type":"xa","slug":"xa-dak-to-ver","name_with_type":"Xã Đăk Tơ Ver","path":"Xã Đăk Tơ Ver, Huyện Chư Păh, Tỉnh Gia Lai","path_with_type":"Xã Đăk Tơ Ver, Huyện Chư Păh, Tỉnh Gia Lai","code":"23740","parent_code":"627"},"23743":{"name":"Xã Hòa Phú","type":"xa","slug":"xa-hoa-phu","name_with_type":"Xã Hòa Phú","path":"Xã Hòa Phú, Huyện Chư Păh, Tỉnh Gia Lai","path_with_type":"Xã Hòa Phú, Huyện Chư Păh, Tỉnh Gia Lai","code":"23743","parent_code":"627"},"23746":{"name":"Xã Chư Đăng Ya","type":"xa","slug":"xa-chu-dang-ya","name_with_type":"Xã Chư Đăng Ya","path":"Xã Chư Đăng Ya, Huyện Chư Păh, Tỉnh Gia Lai","path_with_type":"Xã Chư Đăng Ya, Huyện Chư Păh, Tỉnh Gia Lai","code":"23746","parent_code":"627"},"23749":{"name":"Xã Ia Ka","type":"xa","slug":"xa-ia-ka","name_with_type":"Xã Ia Ka","path":"Xã Ia Ka, Huyện Chư Păh, Tỉnh Gia Lai","path_with_type":"Xã Ia Ka, Huyện Chư Păh, Tỉnh Gia Lai","code":"23749","parent_code":"627"},"23752":{"name":"Xã Ia Nhin","type":"xa","slug":"xa-ia-nhin","name_with_type":"Xã Ia Nhin","path":"Xã Ia Nhin, Huyện Chư Păh, Tỉnh Gia Lai","path_with_type":"Xã Ia Nhin, Huyện Chư Păh, Tỉnh Gia Lai","code":"23752","parent_code":"627"},"23755":{"name":"Xã Nghĩa Hòa","type":"xa","slug":"xa-nghia-hoa","name_with_type":"Xã Nghĩa Hòa","path":"Xã Nghĩa Hòa, Huyện Chư Păh, Tỉnh Gia Lai","path_with_type":"Xã Nghĩa Hòa, Huyện Chư Păh, Tỉnh Gia Lai","code":"23755","parent_code":"627"},"23761":{"name":"Xã Nghĩa Hưng","type":"xa","slug":"xa-nghia-hung","name_with_type":"Xã Nghĩa Hưng","path":"Xã Nghĩa Hưng, Huyện Chư Păh, Tỉnh Gia Lai","path_with_type":"Xã Nghĩa Hưng, Huyện Chư Păh, Tỉnh Gia Lai","code":"23761","parent_code":"627"},"23764":{"name":"Thị trấn Ia Kha","type":"thi-tran","slug":"thi-tran-ia-kha","name_with_type":"Thị trấn Ia Kha","path":"Thị trấn Ia Kha, Huyện Ia Grai, Tỉnh Gia Lai","path_with_type":"Thị trấn Ia Kha, Huyện Ia Grai, Tỉnh Gia Lai","code":"23764","parent_code":"628"},"23767":{"name":"Xã Ia Sao","type":"xa","slug":"xa-ia-sao","name_with_type":"Xã Ia Sao","path":"Xã Ia Sao, Huyện Ia Grai, Tỉnh Gia Lai","path_with_type":"Xã Ia Sao, Huyện Ia Grai, Tỉnh Gia Lai","code":"23767","parent_code":"628"},"23768":{"name":"Xã Ia Yok","type":"xa","slug":"xa-ia-yok","name_with_type":"Xã Ia Yok","path":"Xã Ia Yok, Huyện Ia Grai, Tỉnh Gia Lai","path_with_type":"Xã Ia Yok, Huyện Ia Grai, Tỉnh Gia Lai","code":"23768","parent_code":"628"},"23770":{"name":"Xã Ia Hrung","type":"xa","slug":"xa-ia-hrung","name_with_type":"Xã Ia Hrung","path":"Xã Ia Hrung, Huyện Ia Grai, Tỉnh Gia Lai","path_with_type":"Xã Ia Hrung, Huyện Ia Grai, Tỉnh Gia Lai","code":"23770","parent_code":"628"},"23771":{"name":"Xã Ia Bă","type":"xa","slug":"xa-ia-ba","name_with_type":"Xã Ia Bă","path":"Xã Ia Bă, Huyện Ia Grai, Tỉnh Gia Lai","path_with_type":"Xã Ia Bă, Huyện Ia Grai, Tỉnh Gia Lai","code":"23771","parent_code":"628"},"23773":{"name":"Xã Ia Khai","type":"xa","slug":"xa-ia-khai","name_with_type":"Xã Ia Khai","path":"Xã Ia Khai, Huyện Ia Grai, Tỉnh Gia Lai","path_with_type":"Xã Ia Khai, Huyện Ia Grai, Tỉnh Gia Lai","code":"23773","parent_code":"628"},"23776":{"name":"Xã Ia KRai","type":"xa","slug":"xa-ia-krai","name_with_type":"Xã Ia KRai","path":"Xã Ia KRai, Huyện Ia Grai, Tỉnh Gia Lai","path_with_type":"Xã Ia KRai, Huyện Ia Grai, Tỉnh Gia Lai","code":"23776","parent_code":"628"},"23778":{"name":"Xã Ia Grăng","type":"xa","slug":"xa-ia-grang","name_with_type":"Xã Ia Grăng","path":"Xã Ia Grăng, Huyện Ia Grai, Tỉnh Gia Lai","path_with_type":"Xã Ia Grăng, Huyện Ia Grai, Tỉnh Gia Lai","code":"23778","parent_code":"628"},"23779":{"name":"Xã Ia Tô","type":"xa","slug":"xa-ia-to","name_with_type":"Xã Ia Tô","path":"Xã Ia Tô, Huyện Ia Grai, Tỉnh Gia Lai","path_with_type":"Xã Ia Tô, Huyện Ia Grai, Tỉnh Gia Lai","code":"23779","parent_code":"628"},"23782":{"name":"Xã Ia O","type":"xa","slug":"xa-ia-o","name_with_type":"Xã Ia O","path":"Xã Ia O, Huyện Ia Grai, Tỉnh Gia Lai","path_with_type":"Xã Ia O, Huyện Ia Grai, Tỉnh Gia Lai","code":"23782","parent_code":"628"},"23785":{"name":"Xã Ia Dêr","type":"xa","slug":"xa-ia-der","name_with_type":"Xã Ia Dêr","path":"Xã Ia Dêr, Huyện Ia Grai, Tỉnh Gia Lai","path_with_type":"Xã Ia Dêr, Huyện Ia Grai, Tỉnh Gia Lai","code":"23785","parent_code":"628"},"23788":{"name":"Xã Ia Chia","type":"xa","slug":"xa-ia-chia","name_with_type":"Xã Ia Chia","path":"Xã Ia Chia, Huyện Ia Grai, Tỉnh Gia Lai","path_with_type":"Xã Ia Chia, Huyện Ia Grai, Tỉnh Gia Lai","code":"23788","parent_code":"628"},"23791":{"name":"Xã Ia Pếch","type":"xa","slug":"xa-ia-pech","name_with_type":"Xã Ia Pếch","path":"Xã Ia Pếch, Huyện Ia Grai, Tỉnh Gia Lai","path_with_type":"Xã Ia Pếch, Huyện Ia Grai, Tỉnh Gia Lai","code":"23791","parent_code":"628"},"23794":{"name":"Thị trấn Kon Dơng","type":"thi-tran","slug":"thi-tran-kon-dong","name_with_type":"Thị trấn Kon Dơng","path":"Thị trấn Kon Dơng, Huyện Mang Yang, Tỉnh Gia Lai","path_with_type":"Thị trấn Kon Dơng, Huyện Mang Yang, Tỉnh Gia Lai","code":"23794","parent_code":"629"},"23797":{"name":"Xã Ayun","type":"xa","slug":"xa-ayun","name_with_type":"Xã Ayun","path":"Xã Ayun, Huyện Mang Yang, Tỉnh Gia Lai","path_with_type":"Xã Ayun, Huyện Mang Yang, Tỉnh Gia Lai","code":"23797","parent_code":"629"},"23798":{"name":"Xã Đak Jơ Ta","type":"xa","slug":"xa-dak-jo-ta","name_with_type":"Xã Đak Jơ Ta","path":"Xã Đak Jơ Ta, Huyện Mang Yang, Tỉnh Gia Lai","path_with_type":"Xã Đak Jơ Ta, Huyện Mang Yang, Tỉnh Gia Lai","code":"23798","parent_code":"629"},"23799":{"name":"Xã Đak Ta Ley","type":"xa","slug":"xa-dak-ta-ley","name_with_type":"Xã Đak Ta Ley","path":"Xã Đak Ta Ley, Huyện Mang Yang, Tỉnh Gia Lai","path_with_type":"Xã Đak Ta Ley, Huyện Mang Yang, Tỉnh Gia Lai","code":"23799","parent_code":"629"},"23800":{"name":"Xã Hra","type":"xa","slug":"xa-hra","name_with_type":"Xã Hra","path":"Xã Hra, Huyện Mang Yang, Tỉnh Gia Lai","path_with_type":"Xã Hra, Huyện Mang Yang, Tỉnh Gia Lai","code":"23800","parent_code":"629"},"23803":{"name":"Xã Đăk Yă","type":"xa","slug":"xa-dak-ya","name_with_type":"Xã Đăk Yă","path":"Xã Đăk Yă, Huyện Mang Yang, Tỉnh Gia Lai","path_with_type":"Xã Đăk Yă, Huyện Mang Yang, Tỉnh Gia Lai","code":"23803","parent_code":"629"},"23806":{"name":"Xã Đăk Djrăng","type":"xa","slug":"xa-dak-djrang","name_with_type":"Xã Đăk Djrăng","path":"Xã Đăk Djrăng, Huyện Mang Yang, Tỉnh Gia Lai","path_with_type":"Xã Đăk Djrăng, Huyện Mang Yang, Tỉnh Gia Lai","code":"23806","parent_code":"629"},"23809":{"name":"Xã Lơ Pang","type":"xa","slug":"xa-lo-pang","name_with_type":"Xã Lơ Pang","path":"Xã Lơ Pang, Huyện Mang Yang, Tỉnh Gia Lai","path_with_type":"Xã Lơ Pang, Huyện Mang Yang, Tỉnh Gia Lai","code":"23809","parent_code":"629"},"23812":{"name":"Xã Kon Thụp","type":"xa","slug":"xa-kon-thup","name_with_type":"Xã Kon Thụp","path":"Xã Kon Thụp, Huyện Mang Yang, Tỉnh Gia Lai","path_with_type":"Xã Kon Thụp, Huyện Mang Yang, Tỉnh Gia Lai","code":"23812","parent_code":"629"},"23815":{"name":"Xã Đê Ar","type":"xa","slug":"xa-de-ar","name_with_type":"Xã Đê Ar","path":"Xã Đê Ar, Huyện Mang Yang, Tỉnh Gia Lai","path_with_type":"Xã Đê Ar, Huyện Mang Yang, Tỉnh Gia Lai","code":"23815","parent_code":"629"},"23818":{"name":"Xã Kon Chiêng","type":"xa","slug":"xa-kon-chieng","name_with_type":"Xã Kon Chiêng","path":"Xã Kon Chiêng, Huyện Mang Yang, Tỉnh Gia Lai","path_with_type":"Xã Kon Chiêng, Huyện Mang Yang, Tỉnh Gia Lai","code":"23818","parent_code":"629"},"23821":{"name":"Xã Đăk Trôi","type":"xa","slug":"xa-dak-troi","name_with_type":"Xã Đăk Trôi","path":"Xã Đăk Trôi, Huyện Mang Yang, Tỉnh Gia Lai","path_with_type":"Xã Đăk Trôi, Huyện Mang Yang, Tỉnh Gia Lai","code":"23821","parent_code":"629"},"23824":{"name":"Thị trấn Kông Chro","type":"thi-tran","slug":"thi-tran-kong-chro","name_with_type":"Thị trấn Kông Chro","path":"Thị trấn Kông Chro, Huyện Kông Chro, Tỉnh Gia Lai","path_with_type":"Thị trấn Kông Chro, Huyện Kông Chro, Tỉnh Gia Lai","code":"23824","parent_code":"630"},"23827":{"name":"Xã Chư Krêy","type":"xa","slug":"xa-chu-krey","name_with_type":"Xã Chư Krêy","path":"Xã Chư Krêy, Huyện Kông Chro, Tỉnh Gia Lai","path_with_type":"Xã Chư Krêy, Huyện Kông Chro, Tỉnh Gia Lai","code":"23827","parent_code":"630"},"23830":{"name":"Xã An Trung","type":"xa","slug":"xa-an-trung","name_with_type":"Xã An Trung","path":"Xã An Trung, Huyện Kông Chro, Tỉnh Gia Lai","path_with_type":"Xã An Trung, Huyện Kông Chro, Tỉnh Gia Lai","code":"23830","parent_code":"630"},"23833":{"name":"Xã Kông Yang","type":"xa","slug":"xa-kong-yang","name_with_type":"Xã Kông Yang","path":"Xã Kông Yang, Huyện Kông Chro, Tỉnh Gia Lai","path_with_type":"Xã Kông Yang, Huyện Kông Chro, Tỉnh Gia Lai","code":"23833","parent_code":"630"},"23836":{"name":"Xã Đăk Tơ Pang","type":"xa","slug":"xa-dak-to-pang","name_with_type":"Xã Đăk Tơ Pang","path":"Xã Đăk Tơ Pang, Huyện Kông Chro, Tỉnh Gia Lai","path_with_type":"Xã Đăk Tơ Pang, Huyện Kông Chro, Tỉnh Gia Lai","code":"23836","parent_code":"630"},"23839":{"name":"Xã SRó","type":"xa","slug":"xa-sro","name_with_type":"Xã SRó","path":"Xã SRó, Huyện Kông Chro, Tỉnh Gia Lai","path_with_type":"Xã SRó, Huyện Kông Chro, Tỉnh Gia Lai","code":"23839","parent_code":"630"},"23840":{"name":"Xã Đắk Kơ Ning","type":"xa","slug":"xa-dak-ko-ning","name_with_type":"Xã Đắk Kơ Ning","path":"Xã Đắk Kơ Ning, Huyện Kông Chro, Tỉnh Gia Lai","path_with_type":"Xã Đắk Kơ Ning, Huyện Kông Chro, Tỉnh Gia Lai","code":"23840","parent_code":"630"},"23842":{"name":"Xã Đăk Song","type":"xa","slug":"xa-dak-song","name_with_type":"Xã Đăk Song","path":"Xã Đăk Song, Huyện Kông Chro, Tỉnh Gia Lai","path_with_type":"Xã Đăk Song, Huyện Kông Chro, Tỉnh Gia Lai","code":"23842","parent_code":"630"},"23843":{"name":"Xã Đăk Pling","type":"xa","slug":"xa-dak-pling","name_with_type":"Xã Đăk Pling","path":"Xã Đăk Pling, Huyện Kông Chro, Tỉnh Gia Lai","path_with_type":"Xã Đăk Pling, Huyện Kông Chro, Tỉnh Gia Lai","code":"23843","parent_code":"630"},"23845":{"name":"Xã Yang Trung","type":"xa","slug":"xa-yang-trung","name_with_type":"Xã Yang Trung","path":"Xã Yang Trung, Huyện Kông Chro, Tỉnh Gia Lai","path_with_type":"Xã Yang Trung, Huyện Kông Chro, Tỉnh Gia Lai","code":"23845","parent_code":"630"},"23846":{"name":"Xã Đăk Pơ Pho","type":"xa","slug":"xa-dak-po-pho","name_with_type":"Xã Đăk Pơ Pho","path":"Xã Đăk Pơ Pho, Huyện Kông Chro, Tỉnh Gia Lai","path_with_type":"Xã Đăk Pơ Pho, Huyện Kông Chro, Tỉnh Gia Lai","code":"23846","parent_code":"630"},"23848":{"name":"Xã Ya Ma","type":"xa","slug":"xa-ya-ma","name_with_type":"Xã Ya Ma","path":"Xã Ya Ma, Huyện Kông Chro, Tỉnh Gia Lai","path_with_type":"Xã Ya Ma, Huyện Kông Chro, Tỉnh Gia Lai","code":"23848","parent_code":"630"},"23851":{"name":"Xã Chơ Long","type":"xa","slug":"xa-cho-long","name_with_type":"Xã Chơ Long","path":"Xã Chơ Long, Huyện Kông Chro, Tỉnh Gia Lai","path_with_type":"Xã Chơ Long, Huyện Kông Chro, Tỉnh Gia Lai","code":"23851","parent_code":"630"},"23854":{"name":"Xã Yang Nam","type":"xa","slug":"xa-yang-nam","name_with_type":"Xã Yang Nam","path":"Xã Yang Nam, Huyện Kông Chro, Tỉnh Gia Lai","path_with_type":"Xã Yang Nam, Huyện Kông Chro, Tỉnh Gia Lai","code":"23854","parent_code":"630"},"23857":{"name":"Thị trấn Chư Ty","type":"thi-tran","slug":"thi-tran-chu-ty","name_with_type":"Thị trấn Chư Ty","path":"Thị trấn Chư Ty, Huyện Đức Cơ, Tỉnh Gia Lai","path_with_type":"Thị trấn Chư Ty, Huyện Đức Cơ, Tỉnh Gia Lai","code":"23857","parent_code":"631"},"23860":{"name":"Xã Ia Dơk","type":"xa","slug":"xa-ia-dok","name_with_type":"Xã Ia Dơk","path":"Xã Ia Dơk, Huyện Đức Cơ, Tỉnh Gia Lai","path_with_type":"Xã Ia Dơk, Huyện Đức Cơ, Tỉnh Gia Lai","code":"23860","parent_code":"631"},"23863":{"name":"Xã Ia Krêl","type":"xa","slug":"xa-ia-krel","name_with_type":"Xã Ia Krêl","path":"Xã Ia Krêl, Huyện Đức Cơ, Tỉnh Gia Lai","path_with_type":"Xã Ia Krêl, Huyện Đức Cơ, Tỉnh Gia Lai","code":"23863","parent_code":"631"},"23866":{"name":"Xã Ia Din","type":"xa","slug":"xa-ia-din","name_with_type":"Xã Ia Din","path":"Xã Ia Din, Huyện Đức Cơ, Tỉnh Gia Lai","path_with_type":"Xã Ia Din, Huyện Đức Cơ, Tỉnh Gia Lai","code":"23866","parent_code":"631"},"23869":{"name":"Xã Ia Kla","type":"xa","slug":"xa-ia-kla","name_with_type":"Xã Ia Kla","path":"Xã Ia Kla, Huyện Đức Cơ, Tỉnh Gia Lai","path_with_type":"Xã Ia Kla, Huyện Đức Cơ, Tỉnh Gia Lai","code":"23869","parent_code":"631"},"23872":{"name":"Xã Ia Dom","type":"xa","slug":"xa-ia-dom","name_with_type":"Xã Ia Dom","path":"Xã Ia Dom, Huyện Đức Cơ, Tỉnh Gia Lai","path_with_type":"Xã Ia Dom, Huyện Đức Cơ, Tỉnh Gia Lai","code":"23872","parent_code":"631"},"23875":{"name":"Xã Ia Lang","type":"xa","slug":"xa-ia-lang","name_with_type":"Xã Ia Lang","path":"Xã Ia Lang, Huyện Đức Cơ, Tỉnh Gia Lai","path_with_type":"Xã Ia Lang, Huyện Đức Cơ, Tỉnh Gia Lai","code":"23875","parent_code":"631"},"23878":{"name":"Xã Ia Kriêng","type":"xa","slug":"xa-ia-krieng","name_with_type":"Xã Ia Kriêng","path":"Xã Ia Kriêng, Huyện Đức Cơ, Tỉnh Gia Lai","path_with_type":"Xã Ia Kriêng, Huyện Đức Cơ, Tỉnh Gia Lai","code":"23878","parent_code":"631"},"23881":{"name":"Xã Ia Pnôn","type":"xa","slug":"xa-ia-pnon","name_with_type":"Xã Ia Pnôn","path":"Xã Ia Pnôn, Huyện Đức Cơ, Tỉnh Gia Lai","path_with_type":"Xã Ia Pnôn, Huyện Đức Cơ, Tỉnh Gia Lai","code":"23881","parent_code":"631"},"23884":{"name":"Xã Ia Nan","type":"xa","slug":"xa-ia-nan","name_with_type":"Xã Ia Nan","path":"Xã Ia Nan, Huyện Đức Cơ, Tỉnh Gia Lai","path_with_type":"Xã Ia Nan, Huyện Đức Cơ, Tỉnh Gia Lai","code":"23884","parent_code":"631"},"23887":{"name":"Thị trấn Chư Prông","type":"thi-tran","slug":"thi-tran-chu-prong","name_with_type":"Thị trấn Chư Prông","path":"Thị trấn Chư Prông, Huyện Chư Prông, Tỉnh Gia Lai","path_with_type":"Thị trấn Chư Prông, Huyện Chư Prông, Tỉnh Gia Lai","code":"23887","parent_code":"632"},"23888":{"name":"Xã Ia Kly","type":"xa","slug":"xa-ia-kly","name_with_type":"Xã Ia Kly","path":"Xã Ia Kly, Huyện Chư Prông, Tỉnh Gia Lai","path_with_type":"Xã Ia Kly, Huyện Chư Prông, Tỉnh Gia Lai","code":"23888","parent_code":"632"},"23890":{"name":"Xã Bình Giáo","type":"xa","slug":"xa-binh-giao","name_with_type":"Xã Bình Giáo","path":"Xã Bình Giáo, Huyện Chư Prông, Tỉnh Gia Lai","path_with_type":"Xã Bình Giáo, Huyện Chư Prông, Tỉnh Gia Lai","code":"23890","parent_code":"632"},"23893":{"name":"Xã Ia Drăng","type":"xa","slug":"xa-ia-drang","name_with_type":"Xã Ia Drăng","path":"Xã Ia Drăng, Huyện Chư Prông, Tỉnh Gia Lai","path_with_type":"Xã Ia Drăng, Huyện Chư Prông, Tỉnh Gia Lai","code":"23893","parent_code":"632"},"23896":{"name":"Xã Thăng Hưng","type":"xa","slug":"xa-thang-hung","name_with_type":"Xã Thăng Hưng","path":"Xã Thăng Hưng, Huyện Chư Prông, Tỉnh Gia Lai","path_with_type":"Xã Thăng Hưng, Huyện Chư Prông, Tỉnh Gia Lai","code":"23896","parent_code":"632"},"23899":{"name":"Xã Bàu Cạn","type":"xa","slug":"xa-bau-can","name_with_type":"Xã Bàu Cạn","path":"Xã Bàu Cạn, Huyện Chư Prông, Tỉnh Gia Lai","path_with_type":"Xã Bàu Cạn, Huyện Chư Prông, Tỉnh Gia Lai","code":"23899","parent_code":"632"},"23902":{"name":"Xã Ia Phìn","type":"xa","slug":"xa-ia-phin","name_with_type":"Xã Ia Phìn","path":"Xã Ia Phìn, Huyện Chư Prông, Tỉnh Gia Lai","path_with_type":"Xã Ia Phìn, Huyện Chư Prông, Tỉnh Gia Lai","code":"23902","parent_code":"632"},"23905":{"name":"Xã Ia Băng","type":"xa","slug":"xa-ia-bang","name_with_type":"Xã Ia Băng","path":"Xã Ia Băng, Huyện Chư Prông, Tỉnh Gia Lai","path_with_type":"Xã Ia Băng, Huyện Chư Prông, Tỉnh Gia Lai","code":"23905","parent_code":"632"},"23908":{"name":"Xã Ia Tôr","type":"xa","slug":"xa-ia-tor","name_with_type":"Xã Ia Tôr","path":"Xã Ia Tôr, Huyện Chư Prông, Tỉnh Gia Lai","path_with_type":"Xã Ia Tôr, Huyện Chư Prông, Tỉnh Gia Lai","code":"23908","parent_code":"632"},"23911":{"name":"Xã Ia Boòng","type":"xa","slug":"xa-ia-boong","name_with_type":"Xã Ia Boòng","path":"Xã Ia Boòng, Huyện Chư Prông, Tỉnh Gia Lai","path_with_type":"Xã Ia Boòng, Huyện Chư Prông, Tỉnh Gia Lai","code":"23911","parent_code":"632"},"23914":{"name":"Xã Ia O","type":"xa","slug":"xa-ia-o","name_with_type":"Xã Ia O","path":"Xã Ia O, Huyện Chư Prông, Tỉnh Gia Lai","path_with_type":"Xã Ia O, Huyện Chư Prông, Tỉnh Gia Lai","code":"23914","parent_code":"632"},"23917":{"name":"Xã Ia Púch","type":"xa","slug":"xa-ia-puch","name_with_type":"Xã Ia Púch","path":"Xã Ia Púch, Huyện Chư Prông, Tỉnh Gia Lai","path_with_type":"Xã Ia Púch, Huyện Chư Prông, Tỉnh Gia Lai","code":"23917","parent_code":"632"},"23920":{"name":"Xã Ia Me","type":"xa","slug":"xa-ia-me","name_with_type":"Xã Ia Me","path":"Xã Ia Me, Huyện Chư Prông, Tỉnh Gia Lai","path_with_type":"Xã Ia Me, Huyện Chư Prông, Tỉnh Gia Lai","code":"23920","parent_code":"632"},"23923":{"name":"Xã Ia Vê","type":"xa","slug":"xa-ia-ve","name_with_type":"Xã Ia Vê","path":"Xã Ia Vê, Huyện Chư Prông, Tỉnh Gia Lai","path_with_type":"Xã Ia Vê, Huyện Chư Prông, Tỉnh Gia Lai","code":"23923","parent_code":"632"},"23924":{"name":"Xã Ia Bang","type":"xa","slug":"xa-ia-bang","name_with_type":"Xã Ia Bang","path":"Xã Ia Bang, Huyện Chư Prông, Tỉnh Gia Lai","path_with_type":"Xã Ia Bang, Huyện Chư Prông, Tỉnh Gia Lai","code":"23924","parent_code":"632"},"23926":{"name":"Xã Ia Pia","type":"xa","slug":"xa-ia-pia","name_with_type":"Xã Ia Pia","path":"Xã Ia Pia, Huyện Chư Prông, Tỉnh Gia Lai","path_with_type":"Xã Ia Pia, Huyện Chư Prông, Tỉnh Gia Lai","code":"23926","parent_code":"632"},"23929":{"name":"Xã Ia Ga","type":"xa","slug":"xa-ia-ga","name_with_type":"Xã Ia Ga","path":"Xã Ia Ga, Huyện Chư Prông, Tỉnh Gia Lai","path_with_type":"Xã Ia Ga, Huyện Chư Prông, Tỉnh Gia Lai","code":"23929","parent_code":"632"},"23932":{"name":"Xã Ia Lâu","type":"xa","slug":"xa-ia-lau","name_with_type":"Xã Ia Lâu","path":"Xã Ia Lâu, Huyện Chư Prông, Tỉnh Gia Lai","path_with_type":"Xã Ia Lâu, Huyện Chư Prông, Tỉnh Gia Lai","code":"23932","parent_code":"632"},"23935":{"name":"Xã Ia Piơr","type":"xa","slug":"xa-ia-pior","name_with_type":"Xã Ia Piơr","path":"Xã Ia Piơr, Huyện Chư Prông, Tỉnh Gia Lai","path_with_type":"Xã Ia Piơr, Huyện Chư Prông, Tỉnh Gia Lai","code":"23935","parent_code":"632"},"23938":{"name":"Xã Ia Mơ","type":"xa","slug":"xa-ia-mo","name_with_type":"Xã Ia Mơ","path":"Xã Ia Mơ, Huyện Chư Prông, Tỉnh Gia Lai","path_with_type":"Xã Ia Mơ, Huyện Chư Prông, Tỉnh Gia Lai","code":"23938","parent_code":"632"},"23941":{"name":"Thị trấn Chư Sê","type":"thi-tran","slug":"thi-tran-chu-se","name_with_type":"Thị trấn Chư Sê","path":"Thị trấn Chư Sê, Huyện Chư Sê, Tỉnh Gia Lai","path_with_type":"Thị trấn Chư Sê, Huyện Chư Sê, Tỉnh Gia Lai","code":"23941","parent_code":"633"},"23942":{"name":"Thị trấn Nhơn Hoà","type":"thi-tran","slug":"thi-tran-nhon-hoa","name_with_type":"Thị trấn Nhơn Hoà","path":"Thị trấn Nhơn Hoà, Huyện Chư Pưh, Tỉnh Gia Lai","path_with_type":"Thị trấn Nhơn Hoà, Huyện Chư Pưh, Tỉnh Gia Lai","code":"23942","parent_code":"639"},"23944":{"name":"Xã Ia Tiêm","type":"xa","slug":"xa-ia-tiem","name_with_type":"Xã Ia Tiêm","path":"Xã Ia Tiêm, Huyện Chư Sê, Tỉnh Gia Lai","path_with_type":"Xã Ia Tiêm, Huyện Chư Sê, Tỉnh Gia Lai","code":"23944","parent_code":"633"},"23945":{"name":"Xã Chư Pơng","type":"xa","slug":"xa-chu-pong","name_with_type":"Xã Chư Pơng","path":"Xã Chư Pơng, Huyện Chư Sê, Tỉnh Gia Lai","path_with_type":"Xã Chư Pơng, Huyện Chư Sê, Tỉnh Gia Lai","code":"23945","parent_code":"633"},"23946":{"name":"Xã Bar Măih","type":"xa","slug":"xa-bar-maih","name_with_type":"Xã Bar Măih","path":"Xã Bar Măih, Huyện Chư Sê, Tỉnh Gia Lai","path_with_type":"Xã Bar Măih, Huyện Chư Sê, Tỉnh Gia Lai","code":"23946","parent_code":"633"},"23947":{"name":"Xã Bờ Ngoong","type":"xa","slug":"xa-bo-ngoong","name_with_type":"Xã Bờ Ngoong","path":"Xã Bờ Ngoong, Huyện Chư Sê, Tỉnh Gia Lai","path_with_type":"Xã Bờ Ngoong, Huyện Chư Sê, Tỉnh Gia Lai","code":"23947","parent_code":"633"},"23950":{"name":"Xã Ia Glai","type":"xa","slug":"xa-ia-glai","name_with_type":"Xã Ia Glai","path":"Xã Ia Glai, Huyện Chư Sê, Tỉnh Gia Lai","path_with_type":"Xã Ia Glai, Huyện Chư Sê, Tỉnh Gia Lai","code":"23950","parent_code":"633"},"23953":{"name":"Xã AL Bá","type":"xa","slug":"xa-al-ba","name_with_type":"Xã AL Bá","path":"Xã AL Bá, Huyện Chư Sê, Tỉnh Gia Lai","path_with_type":"Xã AL Bá, Huyện Chư Sê, Tỉnh Gia Lai","code":"23953","parent_code":"633"},"23954":{"name":"Xã Kông HTok","type":"xa","slug":"xa-kong-htok","name_with_type":"Xã Kông HTok","path":"Xã Kông HTok, Huyện Chư Sê, Tỉnh Gia Lai","path_with_type":"Xã Kông HTok, Huyện Chư Sê, Tỉnh Gia Lai","code":"23954","parent_code":"633"},"23956":{"name":"Xã AYun","type":"xa","slug":"xa-ayun","name_with_type":"Xã AYun","path":"Xã AYun, Huyện Chư Sê, Tỉnh Gia Lai","path_with_type":"Xã AYun, Huyện Chư Sê, Tỉnh Gia Lai","code":"23956","parent_code":"633"},"23959":{"name":"Xã Ia HLốp","type":"xa","slug":"xa-ia-hlop","name_with_type":"Xã Ia HLốp","path":"Xã Ia HLốp, Huyện Chư Sê, Tỉnh Gia Lai","path_with_type":"Xã Ia HLốp, Huyện Chư Sê, Tỉnh Gia Lai","code":"23959","parent_code":"633"},"23962":{"name":"Xã Ia Blang","type":"xa","slug":"xa-ia-blang","name_with_type":"Xã Ia Blang","path":"Xã Ia Blang, Huyện Chư Sê, Tỉnh Gia Lai","path_with_type":"Xã Ia Blang, Huyện Chư Sê, Tỉnh Gia Lai","code":"23962","parent_code":"633"},"23965":{"name":"Xã Dun","type":"xa","slug":"xa-dun","name_with_type":"Xã Dun","path":"Xã Dun, Huyện Chư Sê, Tỉnh Gia Lai","path_with_type":"Xã Dun, Huyện Chư Sê, Tỉnh Gia Lai","code":"23965","parent_code":"633"},"23966":{"name":"Xã Ia Pal","type":"xa","slug":"xa-ia-pal","name_with_type":"Xã Ia Pal","path":"Xã Ia Pal, Huyện Chư Sê, Tỉnh Gia Lai","path_with_type":"Xã Ia Pal, Huyện Chư Sê, Tỉnh Gia Lai","code":"23966","parent_code":"633"},"23968":{"name":"Xã H Bông","type":"xa","slug":"xa-h-bong","name_with_type":"Xã H Bông","path":"Xã H Bông, Huyện Chư Sê, Tỉnh Gia Lai","path_with_type":"Xã H Bông, Huyện Chư Sê, Tỉnh Gia Lai","code":"23968","parent_code":"633"},"23971":{"name":"Xã Ia Hrú","type":"xa","slug":"xa-ia-hru","name_with_type":"Xã Ia Hrú","path":"Xã Ia Hrú, Huyện Chư Pưh, Tỉnh Gia Lai","path_with_type":"Xã Ia Hrú, Huyện Chư Pưh, Tỉnh Gia Lai","code":"23971","parent_code":"639"},"23972":{"name":"Xã Ia Rong","type":"xa","slug":"xa-ia-rong","name_with_type":"Xã Ia Rong","path":"Xã Ia Rong, Huyện Chư Pưh, Tỉnh Gia Lai","path_with_type":"Xã Ia Rong, Huyện Chư Pưh, Tỉnh Gia Lai","code":"23972","parent_code":"639"},"23974":{"name":"Xã Ia Dreng","type":"xa","slug":"xa-ia-dreng","name_with_type":"Xã Ia Dreng","path":"Xã Ia Dreng, Huyện Chư Pưh, Tỉnh Gia Lai","path_with_type":"Xã Ia Dreng, Huyện Chư Pưh, Tỉnh Gia Lai","code":"23974","parent_code":"639"},"23977":{"name":"Xã Ia Ko","type":"xa","slug":"xa-ia-ko","name_with_type":"Xã Ia Ko","path":"Xã Ia Ko, Huyện Chư Sê, Tỉnh Gia Lai","path_with_type":"Xã Ia Ko, Huyện Chư Sê, Tỉnh Gia Lai","code":"23977","parent_code":"633"},"23978":{"name":"Xã Ia Hla","type":"xa","slug":"xa-ia-hla","name_with_type":"Xã Ia Hla","path":"Xã Ia Hla, Huyện Chư Pưh, Tỉnh Gia Lai","path_with_type":"Xã Ia Hla, Huyện Chư Pưh, Tỉnh Gia Lai","code":"23978","parent_code":"639"},"23980":{"name":"Xã Chư Don","type":"xa","slug":"xa-chu-don","name_with_type":"Xã Chư Don","path":"Xã Chư Don, Huyện Chư Pưh, Tỉnh Gia Lai","path_with_type":"Xã Chư Don, Huyện Chư Pưh, Tỉnh Gia Lai","code":"23980","parent_code":"639"},"23983":{"name":"Xã Ia Phang","type":"xa","slug":"xa-ia-phang","name_with_type":"Xã Ia Phang","path":"Xã Ia Phang, Huyện Chư Pưh, Tỉnh Gia Lai","path_with_type":"Xã Ia Phang, Huyện Chư Pưh, Tỉnh Gia Lai","code":"23983","parent_code":"639"},"23986":{"name":"Xã Ia Le","type":"xa","slug":"xa-ia-le","name_with_type":"Xã Ia Le","path":"Xã Ia Le, Huyện Chư Pưh, Tỉnh Gia Lai","path_with_type":"Xã Ia Le, Huyện Chư Pưh, Tỉnh Gia Lai","code":"23986","parent_code":"639"},"23987":{"name":"Xã Ia BLứ","type":"xa","slug":"xa-ia-blu","name_with_type":"Xã Ia BLứ","path":"Xã Ia BLứ, Huyện Chư Pưh, Tỉnh Gia Lai","path_with_type":"Xã Ia BLứ, Huyện Chư Pưh, Tỉnh Gia Lai","code":"23987","parent_code":"639"},"23989":{"name":"Xã Hà Tam","type":"xa","slug":"xa-ha-tam","name_with_type":"Xã Hà Tam","path":"Xã Hà Tam, Huyện Đăk Pơ, Tỉnh Gia Lai","path_with_type":"Xã Hà Tam, Huyện Đăk Pơ, Tỉnh Gia Lai","code":"23989","parent_code":"634"},"23992":{"name":"Xã An Thành","type":"xa","slug":"xa-an-thanh","name_with_type":"Xã An Thành","path":"Xã An Thành, Huyện Đăk Pơ, Tỉnh Gia Lai","path_with_type":"Xã An Thành, Huyện Đăk Pơ, Tỉnh Gia Lai","code":"23992","parent_code":"634"},"23995":{"name":"Thị trấn Đak Pơ","type":"thi-tran","slug":"thi-tran-dak-po","name_with_type":"Thị trấn Đak Pơ","path":"Thị trấn Đak Pơ, Huyện Đăk Pơ, Tỉnh Gia Lai","path_with_type":"Thị trấn Đak Pơ, Huyện Đăk Pơ, Tỉnh Gia Lai","code":"23995","parent_code":"634"},"23998":{"name":"Xã Yang Bắc","type":"xa","slug":"xa-yang-bac","name_with_type":"Xã Yang Bắc","path":"Xã Yang Bắc, Huyện Đăk Pơ, Tỉnh Gia Lai","path_with_type":"Xã Yang Bắc, Huyện Đăk Pơ, Tỉnh Gia Lai","code":"23998","parent_code":"634"},"24001":{"name":"Xã Cư An","type":"xa","slug":"xa-cu-an","name_with_type":"Xã Cư An","path":"Xã Cư An, Huyện Đăk Pơ, Tỉnh Gia Lai","path_with_type":"Xã Cư An, Huyện Đăk Pơ, Tỉnh Gia Lai","code":"24001","parent_code":"634"},"24004":{"name":"Xã Tân An","type":"xa","slug":"xa-tan-an","name_with_type":"Xã Tân An","path":"Xã Tân An, Huyện Đăk Pơ, Tỉnh Gia Lai","path_with_type":"Xã Tân An, Huyện Đăk Pơ, Tỉnh Gia Lai","code":"24004","parent_code":"634"},"24007":{"name":"Xã Phú An","type":"xa","slug":"xa-phu-an","name_with_type":"Xã Phú An","path":"Xã Phú An, Huyện Đăk Pơ, Tỉnh Gia Lai","path_with_type":"Xã Phú An, Huyện Đăk Pơ, Tỉnh Gia Lai","code":"24007","parent_code":"634"},"24010":{"name":"Xã Ya Hội","type":"xa","slug":"xa-ya-hoi","name_with_type":"Xã Ya Hội","path":"Xã Ya Hội, Huyện Đăk Pơ, Tỉnh Gia Lai","path_with_type":"Xã Ya Hội, Huyện Đăk Pơ, Tỉnh Gia Lai","code":"24010","parent_code":"634"},"24013":{"name":"Xã Pờ Tó","type":"xa","slug":"xa-po-to","name_with_type":"Xã Pờ Tó","path":"Xã Pờ Tó, Huyện Ia Pa, Tỉnh Gia Lai","path_with_type":"Xã Pờ Tó, Huyện Ia Pa, Tỉnh Gia Lai","code":"24013","parent_code":"635"},"24016":{"name":"Xã Chư Răng","type":"xa","slug":"xa-chu-rang","name_with_type":"Xã Chư Răng","path":"Xã Chư Răng, Huyện Ia Pa, Tỉnh Gia Lai","path_with_type":"Xã Chư Răng, Huyện Ia Pa, Tỉnh Gia Lai","code":"24016","parent_code":"635"},"24019":{"name":"Xã Ia KDăm","type":"xa","slug":"xa-ia-kdam","name_with_type":"Xã Ia KDăm","path":"Xã Ia KDăm, Huyện Ia Pa, Tỉnh Gia Lai","path_with_type":"Xã Ia KDăm, Huyện Ia Pa, Tỉnh Gia Lai","code":"24019","parent_code":"635"},"24022":{"name":"Xã Kim Tân","type":"xa","slug":"xa-kim-tan","name_with_type":"Xã Kim Tân","path":"Xã Kim Tân, Huyện Ia Pa, Tỉnh Gia Lai","path_with_type":"Xã Kim Tân, Huyện Ia Pa, Tỉnh Gia Lai","code":"24022","parent_code":"635"},"24025":{"name":"Xã Chư Mố","type":"xa","slug":"xa-chu-mo","name_with_type":"Xã Chư Mố","path":"Xã Chư Mố, Huyện Ia Pa, Tỉnh Gia Lai","path_with_type":"Xã Chư Mố, Huyện Ia Pa, Tỉnh Gia Lai","code":"24025","parent_code":"635"},"24028":{"name":"Xã Ia Tul","type":"xa","slug":"xa-ia-tul","name_with_type":"Xã Ia Tul","path":"Xã Ia Tul, Huyện Ia Pa, Tỉnh Gia Lai","path_with_type":"Xã Ia Tul, Huyện Ia Pa, Tỉnh Gia Lai","code":"24028","parent_code":"635"},"24031":{"name":"Xã Ia Ma Rơn","type":"xa","slug":"xa-ia-ma-ron","name_with_type":"Xã Ia Ma Rơn","path":"Xã Ia Ma Rơn, Huyện Ia Pa, Tỉnh Gia Lai","path_with_type":"Xã Ia Ma Rơn, Huyện Ia Pa, Tỉnh Gia Lai","code":"24031","parent_code":"635"},"24034":{"name":"Xã Ia Broăi","type":"xa","slug":"xa-ia-broai","name_with_type":"Xã Ia Broăi","path":"Xã Ia Broăi, Huyện Ia Pa, Tỉnh Gia Lai","path_with_type":"Xã Ia Broăi, Huyện Ia Pa, Tỉnh Gia Lai","code":"24034","parent_code":"635"},"24037":{"name":"Xã Ia Trok","type":"xa","slug":"xa-ia-trok","name_with_type":"Xã Ia Trok","path":"Xã Ia Trok, Huyện Ia Pa, Tỉnh Gia Lai","path_with_type":"Xã Ia Trok, Huyện Ia Pa, Tỉnh Gia Lai","code":"24037","parent_code":"635"},"24041":{"name":"Phường Cheo Reo","type":"phuong","slug":"phuong-cheo-reo","name_with_type":"Phường Cheo Reo","path":"Phường Cheo Reo, Thị xã Ayun Pa, Tỉnh Gia Lai","path_with_type":"Phường Cheo Reo, Thị xã Ayun Pa, Tỉnh Gia Lai","code":"24041","parent_code":"624"},"24042":{"name":"Phường Hòa Bình","type":"phuong","slug":"phuong-hoa-binh","name_with_type":"Phường Hòa Bình","path":"Phường Hòa Bình, Thị xã Ayun Pa, Tỉnh Gia Lai","path_with_type":"Phường Hòa Bình, Thị xã Ayun Pa, Tỉnh Gia Lai","code":"24042","parent_code":"624"},"24043":{"name":"Thị trấn Phú Thiện","type":"thi-tran","slug":"thi-tran-phu-thien","name_with_type":"Thị trấn Phú Thiện","path":"Thị trấn Phú Thiện, Huyện Phú Thiện, Tỉnh Gia Lai","path_with_type":"Thị trấn Phú Thiện, Huyện Phú Thiện, Tỉnh Gia Lai","code":"24043","parent_code":"638"},"24044":{"name":"Phường Đoàn Kết","type":"phuong","slug":"phuong-doan-ket","name_with_type":"Phường Đoàn Kết","path":"Phường Đoàn Kết, Thị xã Ayun Pa, Tỉnh Gia Lai","path_with_type":"Phường Đoàn Kết, Thị xã Ayun Pa, Tỉnh Gia Lai","code":"24044","parent_code":"624"},"24045":{"name":"Phường Sông Bờ","type":"phuong","slug":"phuong-song-bo","name_with_type":"Phường Sông Bờ","path":"Phường Sông Bờ, Thị xã Ayun Pa, Tỉnh Gia Lai","path_with_type":"Phường Sông Bờ, Thị xã Ayun Pa, Tỉnh Gia Lai","code":"24045","parent_code":"624"},"24046":{"name":"Xã Chư A Thai","type":"xa","slug":"xa-chu-a-thai","name_with_type":"Xã Chư A Thai","path":"Xã Chư A Thai, Huyện Phú Thiện, Tỉnh Gia Lai","path_with_type":"Xã Chư A Thai, Huyện Phú Thiện, Tỉnh Gia Lai","code":"24046","parent_code":"638"},"24048":{"name":"Xã Ayun Hạ","type":"xa","slug":"xa-ayun-ha","name_with_type":"Xã Ayun Hạ","path":"Xã Ayun Hạ, Huyện Phú Thiện, Tỉnh Gia Lai","path_with_type":"Xã Ayun Hạ, Huyện Phú Thiện, Tỉnh Gia Lai","code":"24048","parent_code":"638"},"24049":{"name":"Xã Ia Ake","type":"xa","slug":"xa-ia-ake","name_with_type":"Xã Ia Ake","path":"Xã Ia Ake, Huyện Phú Thiện, Tỉnh Gia Lai","path_with_type":"Xã Ia Ake, Huyện Phú Thiện, Tỉnh Gia Lai","code":"24049","parent_code":"638"},"24052":{"name":"Xã Ia Sol","type":"xa","slug":"xa-ia-sol","name_with_type":"Xã Ia Sol","path":"Xã Ia Sol, Huyện Phú Thiện, Tỉnh Gia Lai","path_with_type":"Xã Ia Sol, Huyện Phú Thiện, Tỉnh Gia Lai","code":"24052","parent_code":"638"},"24055":{"name":"Xã Ia Piar","type":"xa","slug":"xa-ia-piar","name_with_type":"Xã Ia Piar","path":"Xã Ia Piar, Huyện Phú Thiện, Tỉnh Gia Lai","path_with_type":"Xã Ia Piar, Huyện Phú Thiện, Tỉnh Gia Lai","code":"24055","parent_code":"638"},"24058":{"name":"Xã Ia Peng","type":"xa","slug":"xa-ia-peng","name_with_type":"Xã Ia Peng","path":"Xã Ia Peng, Huyện Phú Thiện, Tỉnh Gia Lai","path_with_type":"Xã Ia Peng, Huyện Phú Thiện, Tỉnh Gia Lai","code":"24058","parent_code":"638"},"24060":{"name":"Xã Chrôh Pơnan","type":"xa","slug":"xa-chroh-ponan","name_with_type":"Xã Chrôh Pơnan","path":"Xã Chrôh Pơnan, Huyện Phú Thiện, Tỉnh Gia Lai","path_with_type":"Xã Chrôh Pơnan, Huyện Phú Thiện, Tỉnh Gia Lai","code":"24060","parent_code":"638"},"24061":{"name":"Xã Ia Hiao","type":"xa","slug":"xa-ia-hiao","name_with_type":"Xã Ia Hiao","path":"Xã Ia Hiao, Huyện Phú Thiện, Tỉnh Gia Lai","path_with_type":"Xã Ia Hiao, Huyện Phú Thiện, Tỉnh Gia Lai","code":"24061","parent_code":"638"},"24064":{"name":"Xã Ia RBol","type":"xa","slug":"xa-ia-rbol","name_with_type":"Xã Ia RBol","path":"Xã Ia RBol, Thị xã Ayun Pa, Tỉnh Gia Lai","path_with_type":"Xã Ia RBol, Thị xã Ayun Pa, Tỉnh Gia Lai","code":"24064","parent_code":"624"},"24065":{"name":"Xã Chư Băh","type":"xa","slug":"xa-chu-bah","name_with_type":"Xã Chư Băh","path":"Xã Chư Băh, Thị xã Ayun Pa, Tỉnh Gia Lai","path_with_type":"Xã Chư Băh, Thị xã Ayun Pa, Tỉnh Gia Lai","code":"24065","parent_code":"624"},"24067":{"name":"Xã Ia Yeng","type":"xa","slug":"xa-ia-yeng","name_with_type":"Xã Ia Yeng","path":"Xã Ia Yeng, Huyện Phú Thiện, Tỉnh Gia Lai","path_with_type":"Xã Ia Yeng, Huyện Phú Thiện, Tỉnh Gia Lai","code":"24067","parent_code":"638"},"24070":{"name":"Xã Ia RTô","type":"xa","slug":"xa-ia-rto","name_with_type":"Xã Ia RTô","path":"Xã Ia RTô, Thị xã Ayun Pa, Tỉnh Gia Lai","path_with_type":"Xã Ia RTô, Thị xã Ayun Pa, Tỉnh Gia Lai","code":"24070","parent_code":"624"},"24073":{"name":"Xã Ia Sao","type":"xa","slug":"xa-ia-sao","name_with_type":"Xã Ia Sao","path":"Xã Ia Sao, Thị xã Ayun Pa, Tỉnh Gia Lai","path_with_type":"Xã Ia Sao, Thị xã Ayun Pa, Tỉnh Gia Lai","code":"24073","parent_code":"624"},"24076":{"name":"Thị trấn Phú Túc","type":"thi-tran","slug":"thi-tran-phu-tuc","name_with_type":"Thị trấn Phú Túc","path":"Thị trấn Phú Túc, Huyện Krông Pa, Tỉnh Gia Lai","path_with_type":"Thị trấn Phú Túc, Huyện Krông Pa, Tỉnh Gia Lai","code":"24076","parent_code":"637"},"24079":{"name":"Xã Ia RSai","type":"xa","slug":"xa-ia-rsai","name_with_type":"Xã Ia RSai","path":"Xã Ia RSai, Huyện Krông Pa, Tỉnh Gia Lai","path_with_type":"Xã Ia RSai, Huyện Krông Pa, Tỉnh Gia Lai","code":"24079","parent_code":"637"},"24082":{"name":"Xã Ia RSươm","type":"xa","slug":"xa-ia-rsuom","name_with_type":"Xã Ia RSươm","path":"Xã Ia RSươm, Huyện Krông Pa, Tỉnh Gia Lai","path_with_type":"Xã Ia RSươm, Huyện Krông Pa, Tỉnh Gia Lai","code":"24082","parent_code":"637"},"24085":{"name":"Xã Chư Gu","type":"xa","slug":"xa-chu-gu","name_with_type":"Xã Chư Gu","path":"Xã Chư Gu, Huyện Krông Pa, Tỉnh Gia Lai","path_with_type":"Xã Chư Gu, Huyện Krông Pa, Tỉnh Gia Lai","code":"24085","parent_code":"637"},"24088":{"name":"Xã Đất Bằng","type":"xa","slug":"xa-dat-bang","name_with_type":"Xã Đất Bằng","path":"Xã Đất Bằng, Huyện Krông Pa, Tỉnh Gia Lai","path_with_type":"Xã Đất Bằng, Huyện Krông Pa, Tỉnh Gia Lai","code":"24088","parent_code":"637"},"24091":{"name":"Xã Ia Mláh","type":"xa","slug":"xa-ia-mlah","name_with_type":"Xã Ia Mláh","path":"Xã Ia Mláh, Huyện Krông Pa, Tỉnh Gia Lai","path_with_type":"Xã Ia Mláh, Huyện Krông Pa, Tỉnh Gia Lai","code":"24091","parent_code":"637"},"24094":{"name":"Xã Chư Drăng","type":"xa","slug":"xa-chu-drang","name_with_type":"Xã Chư Drăng","path":"Xã Chư Drăng, Huyện Krông Pa, Tỉnh Gia Lai","path_with_type":"Xã Chư Drăng, Huyện Krông Pa, Tỉnh Gia Lai","code":"24094","parent_code":"637"},"24097":{"name":"Xã Phú Cần","type":"xa","slug":"xa-phu-can","name_with_type":"Xã Phú Cần","path":"Xã Phú Cần, Huyện Krông Pa, Tỉnh Gia Lai","path_with_type":"Xã Phú Cần, Huyện Krông Pa, Tỉnh Gia Lai","code":"24097","parent_code":"637"},"24100":{"name":"Xã Ia HDreh","type":"xa","slug":"xa-ia-hdreh","name_with_type":"Xã Ia HDreh","path":"Xã Ia HDreh, Huyện Krông Pa, Tỉnh Gia Lai","path_with_type":"Xã Ia HDreh, Huyện Krông Pa, Tỉnh Gia Lai","code":"24100","parent_code":"637"},"24103":{"name":"Xã Ia RMok","type":"xa","slug":"xa-ia-rmok","name_with_type":"Xã Ia RMok","path":"Xã Ia RMok, Huyện Krông Pa, Tỉnh Gia Lai","path_with_type":"Xã Ia RMok, Huyện Krông Pa, Tỉnh Gia Lai","code":"24103","parent_code":"637"},"24106":{"name":"Xã Chư Ngọc","type":"xa","slug":"xa-chu-ngoc","name_with_type":"Xã Chư Ngọc","path":"Xã Chư Ngọc, Huyện Krông Pa, Tỉnh Gia Lai","path_with_type":"Xã Chư Ngọc, Huyện Krông Pa, Tỉnh Gia Lai","code":"24106","parent_code":"637"},"24109":{"name":"Xã Uar","type":"xa","slug":"xa-uar","name_with_type":"Xã Uar","path":"Xã Uar, Huyện Krông Pa, Tỉnh Gia Lai","path_with_type":"Xã Uar, Huyện Krông Pa, Tỉnh Gia Lai","code":"24109","parent_code":"637"},"24112":{"name":"Xã Chư Rcăm","type":"xa","slug":"xa-chu-rcam","name_with_type":"Xã Chư Rcăm","path":"Xã Chư Rcăm, Huyện Krông Pa, Tỉnh Gia Lai","path_with_type":"Xã Chư Rcăm, Huyện Krông Pa, Tỉnh Gia Lai","code":"24112","parent_code":"637"},"24115":{"name":"Xã Krông Năng","type":"xa","slug":"xa-krong-nang","name_with_type":"Xã Krông Năng","path":"Xã Krông Năng, Huyện Krông Pa, Tỉnh Gia Lai","path_with_type":"Xã Krông Năng, Huyện Krông Pa, Tỉnh Gia Lai","code":"24115","parent_code":"637"},"24118":{"name":"Phường Tân Lập","type":"phuong","slug":"phuong-tan-lap","name_with_type":"Phường Tân Lập","path":"Phường Tân Lập, Thành phố Buôn Ma Thuột, Tỉnh Đắk Lắk","path_with_type":"Phường Tân Lập, Thành phố Buôn Ma Thuột, Tỉnh Đắk Lắk","code":"24118","parent_code":"643"},"24121":{"name":"Phường Tân Hòa","type":"phuong","slug":"phuong-tan-hoa","name_with_type":"Phường Tân Hòa","path":"Phường Tân Hòa, Thành phố Buôn Ma Thuột, Tỉnh Đắk Lắk","path_with_type":"Phường Tân Hòa, Thành phố Buôn Ma Thuột, Tỉnh Đắk Lắk","code":"24121","parent_code":"643"},"24124":{"name":"Phường Tân An","type":"phuong","slug":"phuong-tan-an","name_with_type":"Phường Tân An","path":"Phường Tân An, Thành phố Buôn Ma Thuột, Tỉnh Đắk Lắk","path_with_type":"Phường Tân An, Thành phố Buôn Ma Thuột, Tỉnh Đắk Lắk","code":"24124","parent_code":"643"},"24130":{"name":"Phường Thành Nhất","type":"phuong","slug":"phuong-thanh-nhat","name_with_type":"Phường Thành Nhất","path":"Phường Thành Nhất, Thành phố Buôn Ma Thuột, Tỉnh Đắk Lắk","path_with_type":"Phường Thành Nhất, Thành phố Buôn Ma Thuột, Tỉnh Đắk Lắk","code":"24130","parent_code":"643"},"24133":{"name":"Phường Thành Công","type":"phuong","slug":"phuong-thanh-cong","name_with_type":"Phường Thành Công","path":"Phường Thành Công, Thành phố Buôn Ma Thuột, Tỉnh Đắk Lắk","path_with_type":"Phường Thành Công, Thành phố Buôn Ma Thuột, Tỉnh Đắk Lắk","code":"24133","parent_code":"643"},"24136":{"name":"Phường Tân Lợi","type":"phuong","slug":"phuong-tan-loi","name_with_type":"Phường Tân Lợi","path":"Phường Tân Lợi, Thành phố Buôn Ma Thuột, Tỉnh Đắk Lắk","path_with_type":"Phường Tân Lợi, Thành phố Buôn Ma Thuột, Tỉnh Đắk Lắk","code":"24136","parent_code":"643"},"24142":{"name":"Phường Tân Thành","type":"phuong","slug":"phuong-tan-thanh","name_with_type":"Phường Tân Thành","path":"Phường Tân Thành, Thành phố Buôn Ma Thuột, Tỉnh Đắk Lắk","path_with_type":"Phường Tân Thành, Thành phố Buôn Ma Thuột, Tỉnh Đắk Lắk","code":"24142","parent_code":"643"},"24145":{"name":"Phường Tân Tiến","type":"phuong","slug":"phuong-tan-tien","name_with_type":"Phường Tân Tiến","path":"Phường Tân Tiến, Thành phố Buôn Ma Thuột, Tỉnh Đắk Lắk","path_with_type":"Phường Tân Tiến, Thành phố Buôn Ma Thuột, Tỉnh Đắk Lắk","code":"24145","parent_code":"643"},"24148":{"name":"Phường Tự An","type":"phuong","slug":"phuong-tu-an","name_with_type":"Phường Tự An","path":"Phường Tự An, Thành phố Buôn Ma Thuột, Tỉnh Đắk Lắk","path_with_type":"Phường Tự An, Thành phố Buôn Ma Thuột, Tỉnh Đắk Lắk","code":"24148","parent_code":"643"},"24151":{"name":"Phường Ea Tam","type":"phuong","slug":"phuong-ea-tam","name_with_type":"Phường Ea Tam","path":"Phường Ea Tam, Thành phố Buôn Ma Thuột, Tỉnh Đắk Lắk","path_with_type":"Phường Ea Tam, Thành phố Buôn Ma Thuột, Tỉnh Đắk Lắk","code":"24151","parent_code":"643"},"24154":{"name":"Phường Khánh Xuân","type":"phuong","slug":"phuong-khanh-xuan","name_with_type":"Phường Khánh Xuân","path":"Phường Khánh Xuân, Thành phố Buôn Ma Thuột, Tỉnh Đắk Lắk","path_with_type":"Phường Khánh Xuân, Thành phố Buôn Ma Thuột, Tỉnh Đắk Lắk","code":"24154","parent_code":"643"},"24157":{"name":"Xã Hòa Thuận","type":"xa","slug":"xa-hoa-thuan","name_with_type":"Xã Hòa Thuận","path":"Xã Hòa Thuận, Thành phố Buôn Ma Thuột, Tỉnh Đắk Lắk","path_with_type":"Xã Hòa Thuận, Thành phố Buôn Ma Thuột, Tỉnh Đắk Lắk","code":"24157","parent_code":"643"},"24160":{"name":"Xã Cư ÊBur","type":"xa","slug":"xa-cu-ebur","name_with_type":"Xã Cư ÊBur","path":"Xã Cư ÊBur, Thành phố Buôn Ma Thuột, Tỉnh Đắk Lắk","path_with_type":"Xã Cư ÊBur, Thành phố Buôn Ma Thuột, Tỉnh Đắk Lắk","code":"24160","parent_code":"643"},"24163":{"name":"Xã Ea Tu","type":"xa","slug":"xa-ea-tu","name_with_type":"Xã Ea Tu","path":"Xã Ea Tu, Thành phố Buôn Ma Thuột, Tỉnh Đắk Lắk","path_with_type":"Xã Ea Tu, Thành phố Buôn Ma Thuột, Tỉnh Đắk Lắk","code":"24163","parent_code":"643"},"24166":{"name":"Xã Hòa Thắng","type":"xa","slug":"xa-hoa-thang","name_with_type":"Xã Hòa Thắng","path":"Xã Hòa Thắng, Thành phố Buôn Ma Thuột, Tỉnh Đắk Lắk","path_with_type":"Xã Hòa Thắng, Thành phố Buôn Ma Thuột, Tỉnh Đắk Lắk","code":"24166","parent_code":"643"},"24169":{"name":"Xã Ea Kao","type":"xa","slug":"xa-ea-kao","name_with_type":"Xã Ea Kao","path":"Xã Ea Kao, Thành phố Buôn Ma Thuột, Tỉnh Đắk Lắk","path_with_type":"Xã Ea Kao, Thành phố Buôn Ma Thuột, Tỉnh Đắk Lắk","code":"24169","parent_code":"643"},"24172":{"name":"Xã Hòa Phú","type":"xa","slug":"xa-hoa-phu","name_with_type":"Xã Hòa Phú","path":"Xã Hòa Phú, Thành phố Buôn Ma Thuột, Tỉnh Đắk Lắk","path_with_type":"Xã Hòa Phú, Thành phố Buôn Ma Thuột, Tỉnh Đắk Lắk","code":"24172","parent_code":"643"},"24175":{"name":"Xã Hòa Khánh","type":"xa","slug":"xa-hoa-khanh","name_with_type":"Xã Hòa Khánh","path":"Xã Hòa Khánh, Thành phố Buôn Ma Thuột, Tỉnh Đắk Lắk","path_with_type":"Xã Hòa Khánh, Thành phố Buôn Ma Thuột, Tỉnh Đắk Lắk","code":"24175","parent_code":"643"},"24178":{"name":"Xã Hòa Xuân","type":"xa","slug":"xa-hoa-xuan","name_with_type":"Xã Hòa Xuân","path":"Xã Hòa Xuân, Thành phố Buôn Ma Thuột, Tỉnh Đắk Lắk","path_with_type":"Xã Hòa Xuân, Thành phố Buôn Ma Thuột, Tỉnh Đắk Lắk","code":"24178","parent_code":"643"},"24181":{"name":"Thị trấn Ea Drăng","type":"thi-tran","slug":"thi-tran-ea-drang","name_with_type":"Thị trấn Ea Drăng","path":"Thị trấn Ea Drăng, Huyện Ea H\'leo, Tỉnh Đắk Lắk","path_with_type":"Thị trấn Ea Drăng, Huyện Ea H\'leo, Tỉnh Đắk Lắk","code":"24181","parent_code":"645"},"24184":{"name":"Xã Ea H\'leo","type":"xa","slug":"xa-ea-h\'leo","name_with_type":"Xã Ea H\'leo","path":"Xã Ea H\'leo, Huyện Ea H\'leo, Tỉnh Đắk Lắk","path_with_type":"Xã Ea H\'leo, Huyện Ea H\'leo, Tỉnh Đắk Lắk","code":"24184","parent_code":"645"},"24187":{"name":"Xã Ea Sol","type":"xa","slug":"xa-ea-sol","name_with_type":"Xã Ea Sol","path":"Xã Ea Sol, Huyện Ea H\'leo, Tỉnh Đắk Lắk","path_with_type":"Xã Ea Sol, Huyện Ea H\'leo, Tỉnh Đắk Lắk","code":"24187","parent_code":"645"},"24190":{"name":"Xã Ea Ral","type":"xa","slug":"xa-ea-ral","name_with_type":"Xã Ea Ral","path":"Xã Ea Ral, Huyện Ea H\'leo, Tỉnh Đắk Lắk","path_with_type":"Xã Ea Ral, Huyện Ea H\'leo, Tỉnh Đắk Lắk","code":"24190","parent_code":"645"},"24193":{"name":"Xã Ea Wy","type":"xa","slug":"xa-ea-wy","name_with_type":"Xã Ea Wy","path":"Xã Ea Wy, Huyện Ea H\'leo, Tỉnh Đắk Lắk","path_with_type":"Xã Ea Wy, Huyện Ea H\'leo, Tỉnh Đắk Lắk","code":"24193","parent_code":"645"},"24194":{"name":"Xã Cư A Mung","type":"xa","slug":"xa-cu-a-mung","name_with_type":"Xã Cư A Mung","path":"Xã Cư A Mung, Huyện Ea H\'leo, Tỉnh Đắk Lắk","path_with_type":"Xã Cư A Mung, Huyện Ea H\'leo, Tỉnh Đắk Lắk","code":"24194","parent_code":"645"},"24196":{"name":"Xã Cư Mốt","type":"xa","slug":"xa-cu-mot","name_with_type":"Xã Cư Mốt","path":"Xã Cư Mốt, Huyện Ea H\'leo, Tỉnh Đắk Lắk","path_with_type":"Xã Cư Mốt, Huyện Ea H\'leo, Tỉnh Đắk Lắk","code":"24196","parent_code":"645"},"24199":{"name":"Xã Ea Hiao","type":"xa","slug":"xa-ea-hiao","name_with_type":"Xã Ea Hiao","path":"Xã Ea Hiao, Huyện Ea H\'leo, Tỉnh Đắk Lắk","path_with_type":"Xã Ea Hiao, Huyện Ea H\'leo, Tỉnh Đắk Lắk","code":"24199","parent_code":"645"},"24202":{"name":"Xã Ea Khal","type":"xa","slug":"xa-ea-khal","name_with_type":"Xã Ea Khal","path":"Xã Ea Khal, Huyện Ea H\'leo, Tỉnh Đắk Lắk","path_with_type":"Xã Ea Khal, Huyện Ea H\'leo, Tỉnh Đắk Lắk","code":"24202","parent_code":"645"},"24205":{"name":"Xã Dliê Yang","type":"xa","slug":"xa-dlie-yang","name_with_type":"Xã Dliê Yang","path":"Xã Dliê Yang, Huyện Ea H\'leo, Tỉnh Đắk Lắk","path_with_type":"Xã Dliê Yang, Huyện Ea H\'leo, Tỉnh Đắk Lắk","code":"24205","parent_code":"645"},"24207":{"name":"Xã Ea Tir","type":"xa","slug":"xa-ea-tir","name_with_type":"Xã Ea Tir","path":"Xã Ea Tir, Huyện Ea H\'leo, Tỉnh Đắk Lắk","path_with_type":"Xã Ea Tir, Huyện Ea H\'leo, Tỉnh Đắk Lắk","code":"24207","parent_code":"645"},"24208":{"name":"Xã Ea Nam","type":"xa","slug":"xa-ea-nam","name_with_type":"Xã Ea Nam","path":"Xã Ea Nam, Huyện Ea H\'leo, Tỉnh Đắk Lắk","path_with_type":"Xã Ea Nam, Huyện Ea H\'leo, Tỉnh Đắk Lắk","code":"24208","parent_code":"645"},"24211":{"name":"Thị trấn Ea Súp","type":"thi-tran","slug":"thi-tran-ea-sup","name_with_type":"Thị trấn Ea Súp","path":"Thị trấn Ea Súp, Huyện Ea Súp, Tỉnh Đắk Lắk","path_with_type":"Thị trấn Ea Súp, Huyện Ea Súp, Tỉnh Đắk Lắk","code":"24211","parent_code":"646"},"24214":{"name":"Xã Ia Lốp","type":"xa","slug":"xa-ia-lop","name_with_type":"Xã Ia Lốp","path":"Xã Ia Lốp, Huyện Ea Súp, Tỉnh Đắk Lắk","path_with_type":"Xã Ia Lốp, Huyện Ea Súp, Tỉnh Đắk Lắk","code":"24214","parent_code":"646"},"24215":{"name":"Xã Ia JLơi","type":"xa","slug":"xa-ia-jloi","name_with_type":"Xã Ia JLơi","path":"Xã Ia JLơi, Huyện Ea Súp, Tỉnh Đắk Lắk","path_with_type":"Xã Ia JLơi, Huyện Ea Súp, Tỉnh Đắk Lắk","code":"24215","parent_code":"646"},"24217":{"name":"Xã Ea Rốk","type":"xa","slug":"xa-ea-rok","name_with_type":"Xã Ea Rốk","path":"Xã Ea Rốk, Huyện Ea Súp, Tỉnh Đắk Lắk","path_with_type":"Xã Ea Rốk, Huyện Ea Súp, Tỉnh Đắk Lắk","code":"24217","parent_code":"646"},"24220":{"name":"Xã Ya Tờ Mốt","type":"xa","slug":"xa-ya-to-mot","name_with_type":"Xã Ya Tờ Mốt","path":"Xã Ya Tờ Mốt, Huyện Ea Súp, Tỉnh Đắk Lắk","path_with_type":"Xã Ya Tờ Mốt, Huyện Ea Súp, Tỉnh Đắk Lắk","code":"24220","parent_code":"646"},"24221":{"name":"Xã Ia RVê","type":"xa","slug":"xa-ia-rve","name_with_type":"Xã Ia RVê","path":"Xã Ia RVê, Huyện Ea Súp, Tỉnh Đắk Lắk","path_with_type":"Xã Ia RVê, Huyện Ea Súp, Tỉnh Đắk Lắk","code":"24221","parent_code":"646"},"24223":{"name":"Xã Ea Lê","type":"xa","slug":"xa-ea-le","name_with_type":"Xã Ea Lê","path":"Xã Ea Lê, Huyện Ea Súp, Tỉnh Đắk Lắk","path_with_type":"Xã Ea Lê, Huyện Ea Súp, Tỉnh Đắk Lắk","code":"24223","parent_code":"646"},"24226":{"name":"Xã Cư KBang","type":"xa","slug":"xa-cu-kbang","name_with_type":"Xã Cư KBang","path":"Xã Cư KBang, Huyện Ea Súp, Tỉnh Đắk Lắk","path_with_type":"Xã Cư KBang, Huyện Ea Súp, Tỉnh Đắk Lắk","code":"24226","parent_code":"646"},"24229":{"name":"Xã Ea Bung","type":"xa","slug":"xa-ea-bung","name_with_type":"Xã Ea Bung","path":"Xã Ea Bung, Huyện Ea Súp, Tỉnh Đắk Lắk","path_with_type":"Xã Ea Bung, Huyện Ea Súp, Tỉnh Đắk Lắk","code":"24229","parent_code":"646"},"24232":{"name":"Xã Cư M\'Lan","type":"xa","slug":"xa-cu-m\'lan","name_with_type":"Xã Cư M\'Lan","path":"Xã Cư M\'Lan, Huyện Ea Súp, Tỉnh Đắk Lắk","path_with_type":"Xã Cư M\'Lan, Huyện Ea Súp, Tỉnh Đắk Lắk","code":"24232","parent_code":"646"},"24235":{"name":"Xã Krông Na","type":"xa","slug":"xa-krong-na","name_with_type":"Xã Krông Na","path":"Xã Krông Na, Huyện Buôn Đôn, Tỉnh Đắk Lắk","path_with_type":"Xã Krông Na, Huyện Buôn Đôn, Tỉnh Đắk Lắk","code":"24235","parent_code":"647"},"24238":{"name":"Xã Ea Huar","type":"xa","slug":"xa-ea-huar","name_with_type":"Xã Ea Huar","path":"Xã Ea Huar, Huyện Buôn Đôn, Tỉnh Đắk Lắk","path_with_type":"Xã Ea Huar, Huyện Buôn Đôn, Tỉnh Đắk Lắk","code":"24238","parent_code":"647"},"24241":{"name":"Xã Ea Wer","type":"xa","slug":"xa-ea-wer","name_with_type":"Xã Ea Wer","path":"Xã Ea Wer, Huyện Buôn Đôn, Tỉnh Đắk Lắk","path_with_type":"Xã Ea Wer, Huyện Buôn Đôn, Tỉnh Đắk Lắk","code":"24241","parent_code":"647"},"24244":{"name":"Xã Tân Hoà","type":"xa","slug":"xa-tan-hoa","name_with_type":"Xã Tân Hoà","path":"Xã Tân Hoà, Huyện Buôn Đôn, Tỉnh Đắk Lắk","path_with_type":"Xã Tân Hoà, Huyện Buôn Đôn, Tỉnh Đắk Lắk","code":"24244","parent_code":"647"},"24247":{"name":"Xã Cuôr KNia","type":"xa","slug":"xa-cuor-knia","name_with_type":"Xã Cuôr KNia","path":"Xã Cuôr KNia, Huyện Buôn Đôn, Tỉnh Đắk Lắk","path_with_type":"Xã Cuôr KNia, Huyện Buôn Đôn, Tỉnh Đắk Lắk","code":"24247","parent_code":"647"},"24250":{"name":"Xã Ea Bar","type":"xa","slug":"xa-ea-bar","name_with_type":"Xã Ea Bar","path":"Xã Ea Bar, Huyện Buôn Đôn, Tỉnh Đắk Lắk","path_with_type":"Xã Ea Bar, Huyện Buôn Đôn, Tỉnh Đắk Lắk","code":"24250","parent_code":"647"},"24253":{"name":"Xã Ea Nuôl","type":"xa","slug":"xa-ea-nuol","name_with_type":"Xã Ea Nuôl","path":"Xã Ea Nuôl, Huyện Buôn Đôn, Tỉnh Đắk Lắk","path_with_type":"Xã Ea Nuôl, Huyện Buôn Đôn, Tỉnh Đắk Lắk","code":"24253","parent_code":"647"},"24256":{"name":"Thị trấn Ea Pốk","type":"thi-tran","slug":"thi-tran-ea-pok","name_with_type":"Thị trấn Ea Pốk","path":"Thị trấn Ea Pốk, Huyện Cư M\'gar, Tỉnh Đắk Lắk","path_with_type":"Thị trấn Ea Pốk, Huyện Cư M\'gar, Tỉnh Đắk Lắk","code":"24256","parent_code":"648"},"24259":{"name":"Thị trấn Quảng Phú","type":"thi-tran","slug":"thi-tran-quang-phu","name_with_type":"Thị trấn Quảng Phú","path":"Thị trấn Quảng Phú, Huyện Cư M\'gar, Tỉnh Đắk Lắk","path_with_type":"Thị trấn Quảng Phú, Huyện Cư M\'gar, Tỉnh Đắk Lắk","code":"24259","parent_code":"648"},"24262":{"name":"Xã Quảng Tiến","type":"xa","slug":"xa-quang-tien","name_with_type":"Xã Quảng Tiến","path":"Xã Quảng Tiến, Huyện Cư M\'gar, Tỉnh Đắk Lắk","path_with_type":"Xã Quảng Tiến, Huyện Cư M\'gar, Tỉnh Đắk Lắk","code":"24262","parent_code":"648"},"24264":{"name":"Xã Ea Kuêh","type":"xa","slug":"xa-ea-kueh","name_with_type":"Xã Ea Kuêh","path":"Xã Ea Kuêh, Huyện Cư M\'gar, Tỉnh Đắk Lắk","path_with_type":"Xã Ea Kuêh, Huyện Cư M\'gar, Tỉnh Đắk Lắk","code":"24264","parent_code":"648"},"24265":{"name":"Xã Ea Kiết","type":"xa","slug":"xa-ea-kiet","name_with_type":"Xã Ea Kiết","path":"Xã Ea Kiết, Huyện Cư M\'gar, Tỉnh Đắk Lắk","path_with_type":"Xã Ea Kiết, Huyện Cư M\'gar, Tỉnh Đắk Lắk","code":"24265","parent_code":"648"},"24268":{"name":"Xã Ea Tar","type":"xa","slug":"xa-ea-tar","name_with_type":"Xã Ea Tar","path":"Xã Ea Tar, Huyện Cư M\'gar, Tỉnh Đắk Lắk","path_with_type":"Xã Ea Tar, Huyện Cư M\'gar, Tỉnh Đắk Lắk","code":"24268","parent_code":"648"},"24271":{"name":"Xã Cư Dliê M\'nông","type":"xa","slug":"xa-cu-dlie-m\'nong","name_with_type":"Xã Cư Dliê M\'nông","path":"Xã Cư Dliê M\'nông, Huyện Cư M\'gar, Tỉnh Đắk Lắk","path_with_type":"Xã Cư Dliê M\'nông, Huyện Cư M\'gar, Tỉnh Đắk Lắk","code":"24271","parent_code":"648"},"24274":{"name":"Xã Ea H\'đinh","type":"xa","slug":"xa-ea-h\'dinh","name_with_type":"Xã Ea H\'đinh","path":"Xã Ea H\'đinh, Huyện Cư M\'gar, Tỉnh Đắk Lắk","path_with_type":"Xã Ea H\'đinh, Huyện Cư M\'gar, Tỉnh Đắk Lắk","code":"24274","parent_code":"648"},"24277":{"name":"Xã Ea Tul","type":"xa","slug":"xa-ea-tul","name_with_type":"Xã Ea Tul","path":"Xã Ea Tul, Huyện Cư M\'gar, Tỉnh Đắk Lắk","path_with_type":"Xã Ea Tul, Huyện Cư M\'gar, Tỉnh Đắk Lắk","code":"24277","parent_code":"648"},"24280":{"name":"Xã Ea KPam","type":"xa","slug":"xa-ea-kpam","name_with_type":"Xã Ea KPam","path":"Xã Ea KPam, Huyện Cư M\'gar, Tỉnh Đắk Lắk","path_with_type":"Xã Ea KPam, Huyện Cư M\'gar, Tỉnh Đắk Lắk","code":"24280","parent_code":"648"},"24283":{"name":"Xã Ea M\'DRóh","type":"xa","slug":"xa-ea-m\'droh","name_with_type":"Xã Ea M\'DRóh","path":"Xã Ea M\'DRóh, Huyện Cư M\'gar, Tỉnh Đắk Lắk","path_with_type":"Xã Ea M\'DRóh, Huyện Cư M\'gar, Tỉnh Đắk Lắk","code":"24283","parent_code":"648"},"24286":{"name":"Xã Quảng Hiệp","type":"xa","slug":"xa-quang-hiep","name_with_type":"Xã Quảng Hiệp","path":"Xã Quảng Hiệp, Huyện Cư M\'gar, Tỉnh Đắk Lắk","path_with_type":"Xã Quảng Hiệp, Huyện Cư M\'gar, Tỉnh Đắk Lắk","code":"24286","parent_code":"648"},"24289":{"name":"Xã Cư M\'gar","type":"xa","slug":"xa-cu-m\'gar","name_with_type":"Xã Cư M\'gar","path":"Xã Cư M\'gar, Huyện Cư M\'gar, Tỉnh Đắk Lắk","path_with_type":"Xã Cư M\'gar, Huyện Cư M\'gar, Tỉnh Đắk Lắk","code":"24289","parent_code":"648"},"24292":{"name":"Xã Ea D\'Rơng","type":"xa","slug":"xa-ea-d\'rong","name_with_type":"Xã Ea D\'Rơng","path":"Xã Ea D\'Rơng, Huyện Cư M\'gar, Tỉnh Đắk Lắk","path_with_type":"Xã Ea D\'Rơng, Huyện Cư M\'gar, Tỉnh Đắk Lắk","code":"24292","parent_code":"648"},"24295":{"name":"Xã Ea M\'nang","type":"xa","slug":"xa-ea-m\'nang","name_with_type":"Xã Ea M\'nang","path":"Xã Ea M\'nang, Huyện Cư M\'gar, Tỉnh Đắk Lắk","path_with_type":"Xã Ea M\'nang, Huyện Cư M\'gar, Tỉnh Đắk Lắk","code":"24295","parent_code":"648"},"24298":{"name":"Xã Cư Suê","type":"xa","slug":"xa-cu-sue","name_with_type":"Xã Cư Suê","path":"Xã Cư Suê, Huyện Cư M\'gar, Tỉnh Đắk Lắk","path_with_type":"Xã Cư Suê, Huyện Cư M\'gar, Tỉnh Đắk Lắk","code":"24298","parent_code":"648"},"24301":{"name":"Xã Cuor Đăng","type":"xa","slug":"xa-cuor-dang","name_with_type":"Xã Cuor Đăng","path":"Xã Cuor Đăng, Huyện Cư M\'gar, Tỉnh Đắk Lắk","path_with_type":"Xã Cuor Đăng, Huyện Cư M\'gar, Tỉnh Đắk Lắk","code":"24301","parent_code":"648"},"24305":{"name":"Phường An Lạc","type":"phuong","slug":"phuong-an-lac","name_with_type":"Phường An Lạc","path":"Phường An Lạc, Thị Xã Buôn Hồ, Tỉnh Đắk Lắk","path_with_type":"Phường An Lạc, Thị Xã Buôn Hồ, Tỉnh Đắk Lắk","code":"24305","parent_code":"644"},"24307":{"name":"Xã Cư Né","type":"xa","slug":"xa-cu-ne","name_with_type":"Xã Cư Né","path":"Xã Cư Né, Huyện Krông Búk, Tỉnh Đắk Lắk","path_with_type":"Xã Cư Né, Huyện Krông Búk, Tỉnh Đắk Lắk","code":"24307","parent_code":"649"},"24308":{"name":"Phường An Bình","type":"phuong","slug":"phuong-an-binh","name_with_type":"Phường An Bình","path":"Phường An Bình, Thị Xã Buôn Hồ, Tỉnh Đắk Lắk","path_with_type":"Phường An Bình, Thị Xã Buôn Hồ, Tỉnh Đắk Lắk","code":"24308","parent_code":"644"},"24310":{"name":"Xã Chư KBô","type":"xa","slug":"xa-chu-kbo","name_with_type":"Xã Chư KBô","path":"Xã Chư KBô, Huyện Krông Búk, Tỉnh Đắk Lắk","path_with_type":"Xã Chư KBô, Huyện Krông Búk, Tỉnh Đắk Lắk","code":"24310","parent_code":"649"},"24311":{"name":"Phường Thiện An","type":"phuong","slug":"phuong-thien-an","name_with_type":"Phường Thiện An","path":"Phường Thiện An, Thị Xã Buôn Hồ, Tỉnh Đắk Lắk","path_with_type":"Phường Thiện An, Thị Xã Buôn Hồ, Tỉnh Đắk Lắk","code":"24311","parent_code":"644"},"24313":{"name":"Xã Cư Pơng","type":"xa","slug":"xa-cu-pong","name_with_type":"Xã Cư Pơng","path":"Xã Cư Pơng, Huyện Krông Búk, Tỉnh Đắk Lắk","path_with_type":"Xã Cư Pơng, Huyện Krông Búk, Tỉnh Đắk Lắk","code":"24313","parent_code":"649"},"24314":{"name":"Xã Ea Sin","type":"xa","slug":"xa-ea-sin","name_with_type":"Xã Ea Sin","path":"Xã Ea Sin, Huyện Krông Búk, Tỉnh Đắk Lắk","path_with_type":"Xã Ea Sin, Huyện Krông Búk, Tỉnh Đắk Lắk","code":"24314","parent_code":"649"},"24316":{"name":"Thị trấn Pơng Drang","type":"thi-tran","slug":"thi-tran-pong-drang","name_with_type":"Thị trấn Pơng Drang","path":"Thị trấn Pơng Drang, Huyện Krông Búk, Tỉnh Đắk Lắk","path_with_type":"Thị trấn Pơng Drang, Huyện Krông Búk, Tỉnh Đắk Lắk","code":"24316","parent_code":"649"},"24317":{"name":"Xã Tân Lập","type":"xa","slug":"xa-tan-lap","name_with_type":"Xã Tân Lập","path":"Xã Tân Lập, Huyện Krông Búk, Tỉnh Đắk Lắk","path_with_type":"Xã Tân Lập, Huyện Krông Búk, Tỉnh Đắk Lắk","code":"24317","parent_code":"649"},"24318":{"name":"Phường Đạt Hiếu","type":"phuong","slug":"phuong-dat-hieu","name_with_type":"Phường Đạt Hiếu","path":"Phường Đạt Hiếu, Thị Xã Buôn Hồ, Tỉnh Đắk Lắk","path_with_type":"Phường Đạt Hiếu, Thị Xã Buôn Hồ, Tỉnh Đắk Lắk","code":"24318","parent_code":"644"},"24319":{"name":"Xã Ea Ngai","type":"xa","slug":"xa-ea-ngai","name_with_type":"Xã Ea Ngai","path":"Xã Ea Ngai, Huyện Krông Búk, Tỉnh Đắk Lắk","path_with_type":"Xã Ea Ngai, Huyện Krông Búk, Tỉnh Đắk Lắk","code":"24319","parent_code":"649"},"24322":{"name":"Phường Đoàn Kết","type":"phuong","slug":"phuong-doan-ket","name_with_type":"Phường Đoàn Kết","path":"Phường Đoàn Kết, Thị Xã Buôn Hồ, Tỉnh Đắk Lắk","path_with_type":"Phường Đoàn Kết, Thị Xã Buôn Hồ, Tỉnh Đắk Lắk","code":"24322","parent_code":"644"},"24328":{"name":"Xã Ea Drông","type":"xa","slug":"xa-ea-drong","name_with_type":"Xã Ea Drông","path":"Xã Ea Drông, Thị Xã Buôn Hồ, Tỉnh Đắk Lắk","path_with_type":"Xã Ea Drông, Thị Xã Buôn Hồ, Tỉnh Đắk Lắk","code":"24328","parent_code":"644"},"24331":{"name":"Phường Thống Nhất","type":"phuong","slug":"phuong-thong-nhat","name_with_type":"Phường Thống Nhất","path":"Phường Thống Nhất, Thị Xã Buôn Hồ, Tỉnh Đắk Lắk","path_with_type":"Phường Thống Nhất, Thị Xã Buôn Hồ, Tỉnh Đắk Lắk","code":"24331","parent_code":"644"},"24332":{"name":"Phường Bình Tân","type":"phuong","slug":"phuong-binh-tan","name_with_type":"Phường Bình Tân","path":"Phường Bình Tân, Thị Xã Buôn Hồ, Tỉnh Đắk Lắk","path_with_type":"Phường Bình Tân, Thị Xã Buôn Hồ, Tỉnh Đắk Lắk","code":"24332","parent_code":"644"},"24334":{"name":"Xã Ea Siên","type":"xa","slug":"xa-ea-sien","name_with_type":"Xã Ea Siên","path":"Xã Ea Siên, Thị Xã Buôn Hồ, Tỉnh Đắk Lắk","path_with_type":"Xã Ea Siên, Thị Xã Buôn Hồ, Tỉnh Đắk Lắk","code":"24334","parent_code":"644"},"24337":{"name":"Xã Bình Thuận","type":"xa","slug":"xa-binh-thuan","name_with_type":"Xã Bình Thuận","path":"Xã Bình Thuận, Thị Xã Buôn Hồ, Tỉnh Đắk Lắk","path_with_type":"Xã Bình Thuận, Thị Xã Buôn Hồ, Tỉnh Đắk Lắk","code":"24337","parent_code":"644"},"24340":{"name":"Xã Cư Bao","type":"xa","slug":"xa-cu-bao","name_with_type":"Xã Cư Bao","path":"Xã Cư Bao, Thị Xã Buôn Hồ, Tỉnh Đắk Lắk","path_with_type":"Xã Cư Bao, Thị Xã Buôn Hồ, Tỉnh Đắk Lắk","code":"24340","parent_code":"644"},"24343":{"name":"Thị trấn Krông Năng","type":"thi-tran","slug":"thi-tran-krong-nang","name_with_type":"Thị trấn Krông Năng","path":"Thị trấn Krông Năng, Huyện Krông Năng, Tỉnh Đắk Lắk","path_with_type":"Thị trấn Krông Năng, Huyện Krông Năng, Tỉnh Đắk Lắk","code":"24343","parent_code":"650"},"24346":{"name":"Xã ĐLiê Ya","type":"xa","slug":"xa-dlie-ya","name_with_type":"Xã ĐLiê Ya","path":"Xã ĐLiê Ya, Huyện Krông Năng, Tỉnh Đắk Lắk","path_with_type":"Xã ĐLiê Ya, Huyện Krông Năng, Tỉnh Đắk Lắk","code":"24346","parent_code":"650"},"24349":{"name":"Xã Ea Tóh","type":"xa","slug":"xa-ea-toh","name_with_type":"Xã Ea Tóh","path":"Xã Ea Tóh, Huyện Krông Năng, Tỉnh Đắk Lắk","path_with_type":"Xã Ea Tóh, Huyện Krông Năng, Tỉnh Đắk Lắk","code":"24349","parent_code":"650"},"24352":{"name":"Xã Ea Tam","type":"xa","slug":"xa-ea-tam","name_with_type":"Xã Ea Tam","path":"Xã Ea Tam, Huyện Krông Năng, Tỉnh Đắk Lắk","path_with_type":"Xã Ea Tam, Huyện Krông Năng, Tỉnh Đắk Lắk","code":"24352","parent_code":"650"},"24355":{"name":"Xã Phú Lộc","type":"xa","slug":"xa-phu-loc","name_with_type":"Xã Phú Lộc","path":"Xã Phú Lộc, Huyện Krông Năng, Tỉnh Đắk Lắk","path_with_type":"Xã Phú Lộc, Huyện Krông Năng, Tỉnh Đắk Lắk","code":"24355","parent_code":"650"},"24358":{"name":"Xã Tam Giang","type":"xa","slug":"xa-tam-giang","name_with_type":"Xã Tam Giang","path":"Xã Tam Giang, Huyện Krông Năng, Tỉnh Đắk Lắk","path_with_type":"Xã Tam Giang, Huyện Krông Năng, Tỉnh Đắk Lắk","code":"24358","parent_code":"650"},"24359":{"name":"Xã Ea Puk","type":"xa","slug":"xa-ea-puk","name_with_type":"Xã Ea Puk","path":"Xã Ea Puk, Huyện Krông Năng, Tỉnh Đắk Lắk","path_with_type":"Xã Ea Puk, Huyện Krông Năng, Tỉnh Đắk Lắk","code":"24359","parent_code":"650"},"24360":{"name":"Xã Ea Dăh","type":"xa","slug":"xa-ea-dah","name_with_type":"Xã Ea Dăh","path":"Xã Ea Dăh, Huyện Krông Năng, Tỉnh Đắk Lắk","path_with_type":"Xã Ea Dăh, Huyện Krông Năng, Tỉnh Đắk Lắk","code":"24360","parent_code":"650"},"24361":{"name":"Xã Ea Hồ","type":"xa","slug":"xa-ea-ho","name_with_type":"Xã Ea Hồ","path":"Xã Ea Hồ, Huyện Krông Năng, Tỉnh Đắk Lắk","path_with_type":"Xã Ea Hồ, Huyện Krông Năng, Tỉnh Đắk Lắk","code":"24361","parent_code":"650"},"24364":{"name":"Xã Phú Xuân","type":"xa","slug":"xa-phu-xuan","name_with_type":"Xã Phú Xuân","path":"Xã Phú Xuân, Huyện Krông Năng, Tỉnh Đắk Lắk","path_with_type":"Xã Phú Xuân, Huyện Krông Năng, Tỉnh Đắk Lắk","code":"24364","parent_code":"650"},"24367":{"name":"Xã Cư Klông","type":"xa","slug":"xa-cu-klong","name_with_type":"Xã Cư Klông","path":"Xã Cư Klông, Huyện Krông Năng, Tỉnh Đắk Lắk","path_with_type":"Xã Cư Klông, Huyện Krông Năng, Tỉnh Đắk Lắk","code":"24367","parent_code":"650"},"24370":{"name":"Xã Ea Tân","type":"xa","slug":"xa-ea-tan","name_with_type":"Xã Ea Tân","path":"Xã Ea Tân, Huyện Krông Năng, Tỉnh Đắk Lắk","path_with_type":"Xã Ea Tân, Huyện Krông Năng, Tỉnh Đắk Lắk","code":"24370","parent_code":"650"},"24373":{"name":"Thị trấn Ea Kar","type":"thi-tran","slug":"thi-tran-ea-kar","name_with_type":"Thị trấn Ea Kar","path":"Thị trấn Ea Kar, Huyện Ea Kar, Tỉnh Đắk Lắk","path_with_type":"Thị trấn Ea Kar, Huyện Ea Kar, Tỉnh Đắk Lắk","code":"24373","parent_code":"651"},"24376":{"name":"Thị trấn Ea Knốp","type":"thi-tran","slug":"thi-tran-ea-knop","name_with_type":"Thị trấn Ea Knốp","path":"Thị trấn Ea Knốp, Huyện Ea Kar, Tỉnh Đắk Lắk","path_with_type":"Thị trấn Ea Knốp, Huyện Ea Kar, Tỉnh Đắk Lắk","code":"24376","parent_code":"651"},"24379":{"name":"Xã Ea Sô","type":"xa","slug":"xa-ea-so","name_with_type":"Xã Ea Sô","path":"Xã Ea Sô, Huyện Ea Kar, Tỉnh Đắk Lắk","path_with_type":"Xã Ea Sô, Huyện Ea Kar, Tỉnh Đắk Lắk","code":"24379","parent_code":"651"},"24380":{"name":"Xã Ea Sar","type":"xa","slug":"xa-ea-sar","name_with_type":"Xã Ea Sar","path":"Xã Ea Sar, Huyện Ea Kar, Tỉnh Đắk Lắk","path_with_type":"Xã Ea Sar, Huyện Ea Kar, Tỉnh Đắk Lắk","code":"24380","parent_code":"651"},"24382":{"name":"Xã Xuân Phú","type":"xa","slug":"xa-xuan-phu","name_with_type":"Xã Xuân Phú","path":"Xã Xuân Phú, Huyện Ea Kar, Tỉnh Đắk Lắk","path_with_type":"Xã Xuân Phú, Huyện Ea Kar, Tỉnh Đắk Lắk","code":"24382","parent_code":"651"},"24385":{"name":"Xã Cư Huê","type":"xa","slug":"xa-cu-hue","name_with_type":"Xã Cư Huê","path":"Xã Cư Huê, Huyện Ea Kar, Tỉnh Đắk Lắk","path_with_type":"Xã Cư Huê, Huyện Ea Kar, Tỉnh Đắk Lắk","code":"24385","parent_code":"651"},"24388":{"name":"Xã Ea Tih","type":"xa","slug":"xa-ea-tih","name_with_type":"Xã Ea Tih","path":"Xã Ea Tih, Huyện Ea Kar, Tỉnh Đắk Lắk","path_with_type":"Xã Ea Tih, Huyện Ea Kar, Tỉnh Đắk Lắk","code":"24388","parent_code":"651"},"24391":{"name":"Xã Ea Đar","type":"xa","slug":"xa-ea-dar","name_with_type":"Xã Ea Đar","path":"Xã Ea Đar, Huyện Ea Kar, Tỉnh Đắk Lắk","path_with_type":"Xã Ea Đar, Huyện Ea Kar, Tỉnh Đắk Lắk","code":"24391","parent_code":"651"},"24394":{"name":"Xã Ea Kmút","type":"xa","slug":"xa-ea-kmut","name_with_type":"Xã Ea Kmút","path":"Xã Ea Kmút, Huyện Ea Kar, Tỉnh Đắk Lắk","path_with_type":"Xã Ea Kmút, Huyện Ea Kar, Tỉnh Đắk Lắk","code":"24394","parent_code":"651"},"24397":{"name":"Xã Cư Ni","type":"xa","slug":"xa-cu-ni","name_with_type":"Xã Cư Ni","path":"Xã Cư Ni, Huyện Ea Kar, Tỉnh Đắk Lắk","path_with_type":"Xã Cư Ni, Huyện Ea Kar, Tỉnh Đắk Lắk","code":"24397","parent_code":"651"},"24400":{"name":"Xã Ea Păl","type":"xa","slug":"xa-ea-pal","name_with_type":"Xã Ea Păl","path":"Xã Ea Păl, Huyện Ea Kar, Tỉnh Đắk Lắk","path_with_type":"Xã Ea Păl, Huyện Ea Kar, Tỉnh Đắk Lắk","code":"24400","parent_code":"651"},"24401":{"name":"Xã Cư Prông","type":"xa","slug":"xa-cu-prong","name_with_type":"Xã Cư Prông","path":"Xã Cư Prông, Huyện Ea Kar, Tỉnh Đắk Lắk","path_with_type":"Xã Cư Prông, Huyện Ea Kar, Tỉnh Đắk Lắk","code":"24401","parent_code":"651"},"24403":{"name":"Xã Ea Ô","type":"xa","slug":"xa-ea-o","name_with_type":"Xã Ea Ô","path":"Xã Ea Ô, Huyện Ea Kar, Tỉnh Đắk Lắk","path_with_type":"Xã Ea Ô, Huyện Ea Kar, Tỉnh Đắk Lắk","code":"24403","parent_code":"651"},"24404":{"name":"Xã Cư ELang","type":"xa","slug":"xa-cu-elang","name_with_type":"Xã Cư ELang","path":"Xã Cư ELang, Huyện Ea Kar, Tỉnh Đắk Lắk","path_with_type":"Xã Cư ELang, Huyện Ea Kar, Tỉnh Đắk Lắk","code":"24404","parent_code":"651"},"24406":{"name":"Xã Cư Bông","type":"xa","slug":"xa-cu-bong","name_with_type":"Xã Cư Bông","path":"Xã Cư Bông, Huyện Ea Kar, Tỉnh Đắk Lắk","path_with_type":"Xã Cư Bông, Huyện Ea Kar, Tỉnh Đắk Lắk","code":"24406","parent_code":"651"},"24409":{"name":"Xã Cư Jang","type":"xa","slug":"xa-cu-jang","name_with_type":"Xã Cư Jang","path":"Xã Cư Jang, Huyện Ea Kar, Tỉnh Đắk Lắk","path_with_type":"Xã Cư Jang, Huyện Ea Kar, Tỉnh Đắk Lắk","code":"24409","parent_code":"651"},"24412":{"name":"Thị trấn M\'Đrắk","type":"thi-tran","slug":"thi-tran-m\'drak","name_with_type":"Thị trấn M\'Đrắk","path":"Thị trấn M\'Đrắk, Huyện M\'Đrắk, Tỉnh Đắk Lắk","path_with_type":"Thị trấn M\'Đrắk, Huyện M\'Đrắk, Tỉnh Đắk Lắk","code":"24412","parent_code":"652"},"24415":{"name":"Xã Cư Prao","type":"xa","slug":"xa-cu-prao","name_with_type":"Xã Cư Prao","path":"Xã Cư Prao, Huyện M\'Đrắk, Tỉnh Đắk Lắk","path_with_type":"Xã Cư Prao, Huyện M\'Đrắk, Tỉnh Đắk Lắk","code":"24415","parent_code":"652"},"24418":{"name":"Xã Ea Pil","type":"xa","slug":"xa-ea-pil","name_with_type":"Xã Ea Pil","path":"Xã Ea Pil, Huyện M\'Đrắk, Tỉnh Đắk Lắk","path_with_type":"Xã Ea Pil, Huyện M\'Đrắk, Tỉnh Đắk Lắk","code":"24418","parent_code":"652"},"24421":{"name":"Xã Ea Lai","type":"xa","slug":"xa-ea-lai","name_with_type":"Xã Ea Lai","path":"Xã Ea Lai, Huyện M\'Đrắk, Tỉnh Đắk Lắk","path_with_type":"Xã Ea Lai, Huyện M\'Đrắk, Tỉnh Đắk Lắk","code":"24421","parent_code":"652"},"24424":{"name":"Xã Ea H\'MLay","type":"xa","slug":"xa-ea-h\'mlay","name_with_type":"Xã Ea H\'MLay","path":"Xã Ea H\'MLay, Huyện M\'Đrắk, Tỉnh Đắk Lắk","path_with_type":"Xã Ea H\'MLay, Huyện M\'Đrắk, Tỉnh Đắk Lắk","code":"24424","parent_code":"652"},"24427":{"name":"Xã Krông Jing","type":"xa","slug":"xa-krong-jing","name_with_type":"Xã Krông Jing","path":"Xã Krông Jing, Huyện M\'Đrắk, Tỉnh Đắk Lắk","path_with_type":"Xã Krông Jing, Huyện M\'Đrắk, Tỉnh Đắk Lắk","code":"24427","parent_code":"652"},"24430":{"name":"Xã Ea M\' Doal","type":"xa","slug":"xa-ea-m\'-doal","name_with_type":"Xã Ea M\' Doal","path":"Xã Ea M\' Doal, Huyện M\'Đrắk, Tỉnh Đắk Lắk","path_with_type":"Xã Ea M\' Doal, Huyện M\'Đrắk, Tỉnh Đắk Lắk","code":"24430","parent_code":"652"},"24433":{"name":"Xã Ea Riêng","type":"xa","slug":"xa-ea-rieng","name_with_type":"Xã Ea Riêng","path":"Xã Ea Riêng, Huyện M\'Đrắk, Tỉnh Đắk Lắk","path_with_type":"Xã Ea Riêng, Huyện M\'Đrắk, Tỉnh Đắk Lắk","code":"24433","parent_code":"652"},"24436":{"name":"Xã Cư M\'ta","type":"xa","slug":"xa-cu-m\'ta","name_with_type":"Xã Cư M\'ta","path":"Xã Cư M\'ta, Huyện M\'Đrắk, Tỉnh Đắk Lắk","path_with_type":"Xã Cư M\'ta, Huyện M\'Đrắk, Tỉnh Đắk Lắk","code":"24436","parent_code":"652"},"24439":{"name":"Xã Cư K Róa","type":"xa","slug":"xa-cu-k-roa","name_with_type":"Xã Cư K Róa","path":"Xã Cư K Róa, Huyện M\'Đrắk, Tỉnh Đắk Lắk","path_with_type":"Xã Cư K Róa, Huyện M\'Đrắk, Tỉnh Đắk Lắk","code":"24439","parent_code":"652"},"24442":{"name":"Xã Krông Á","type":"xa","slug":"xa-krong-a","name_with_type":"Xã Krông Á","path":"Xã Krông Á, Huyện M\'Đrắk, Tỉnh Đắk Lắk","path_with_type":"Xã Krông Á, Huyện M\'Đrắk, Tỉnh Đắk Lắk","code":"24442","parent_code":"652"},"24444":{"name":"Xã Cư San","type":"xa","slug":"xa-cu-san","name_with_type":"Xã Cư San","path":"Xã Cư San, Huyện M\'Đrắk, Tỉnh Đắk Lắk","path_with_type":"Xã Cư San, Huyện M\'Đrắk, Tỉnh Đắk Lắk","code":"24444","parent_code":"652"},"24445":{"name":"Xã Ea Trang","type":"xa","slug":"xa-ea-trang","name_with_type":"Xã Ea Trang","path":"Xã Ea Trang, Huyện M\'Đrắk, Tỉnh Đắk Lắk","path_with_type":"Xã Ea Trang, Huyện M\'Đrắk, Tỉnh Đắk Lắk","code":"24445","parent_code":"652"},"24448":{"name":"Thị trấn Krông Kmar","type":"thi-tran","slug":"thi-tran-krong-kmar","name_with_type":"Thị trấn Krông Kmar","path":"Thị trấn Krông Kmar, Huyện Krông Bông, Tỉnh Đắk Lắk","path_with_type":"Thị trấn Krông Kmar, Huyện Krông Bông, Tỉnh Đắk Lắk","code":"24448","parent_code":"653"},"24451":{"name":"Xã Dang Kang","type":"xa","slug":"xa-dang-kang","name_with_type":"Xã Dang Kang","path":"Xã Dang Kang, Huyện Krông Bông, Tỉnh Đắk Lắk","path_with_type":"Xã Dang Kang, Huyện Krông Bông, Tỉnh Đắk Lắk","code":"24451","parent_code":"653"},"24454":{"name":"Xã Cư KTy","type":"xa","slug":"xa-cu-kty","name_with_type":"Xã Cư KTy","path":"Xã Cư KTy, Huyện Krông Bông, Tỉnh Đắk Lắk","path_with_type":"Xã Cư KTy, Huyện Krông Bông, Tỉnh Đắk Lắk","code":"24454","parent_code":"653"},"24457":{"name":"Xã Hòa Thành","type":"xa","slug":"xa-hoa-thanh","name_with_type":"Xã Hòa Thành","path":"Xã Hòa Thành, Huyện Krông Bông, Tỉnh Đắk Lắk","path_with_type":"Xã Hòa Thành, Huyện Krông Bông, Tỉnh Đắk Lắk","code":"24457","parent_code":"653"},"24463":{"name":"Xã Hòa Phong","type":"xa","slug":"xa-hoa-phong","name_with_type":"Xã Hòa Phong","path":"Xã Hòa Phong, Huyện Krông Bông, Tỉnh Đắk Lắk","path_with_type":"Xã Hòa Phong, Huyện Krông Bông, Tỉnh Đắk Lắk","code":"24463","parent_code":"653"},"24466":{"name":"Xã Hòa Lễ","type":"xa","slug":"xa-hoa-le","name_with_type":"Xã Hòa Lễ","path":"Xã Hòa Lễ, Huyện Krông Bông, Tỉnh Đắk Lắk","path_with_type":"Xã Hòa Lễ, Huyện Krông Bông, Tỉnh Đắk Lắk","code":"24466","parent_code":"653"},"24469":{"name":"Xã Yang Reh","type":"xa","slug":"xa-yang-reh","name_with_type":"Xã Yang Reh","path":"Xã Yang Reh, Huyện Krông Bông, Tỉnh Đắk Lắk","path_with_type":"Xã Yang Reh, Huyện Krông Bông, Tỉnh Đắk Lắk","code":"24469","parent_code":"653"},"24472":{"name":"Xã Ea Trul","type":"xa","slug":"xa-ea-trul","name_with_type":"Xã Ea Trul","path":"Xã Ea Trul, Huyện Krông Bông, Tỉnh Đắk Lắk","path_with_type":"Xã Ea Trul, Huyện Krông Bông, Tỉnh Đắk Lắk","code":"24472","parent_code":"653"},"24475":{"name":"Xã Khuê Ngọc Điền","type":"xa","slug":"xa-khue-ngoc-dien","name_with_type":"Xã Khuê Ngọc Điền","path":"Xã Khuê Ngọc Điền, Huyện Krông Bông, Tỉnh Đắk Lắk","path_with_type":"Xã Khuê Ngọc Điền, Huyện Krông Bông, Tỉnh Đắk Lắk","code":"24475","parent_code":"653"},"24478":{"name":"Xã Cư Pui","type":"xa","slug":"xa-cu-pui","name_with_type":"Xã Cư Pui","path":"Xã Cư Pui, Huyện Krông Bông, Tỉnh Đắk Lắk","path_with_type":"Xã Cư Pui, Huyện Krông Bông, Tỉnh Đắk Lắk","code":"24478","parent_code":"653"},"24481":{"name":"Xã Hòa Sơn","type":"xa","slug":"xa-hoa-son","name_with_type":"Xã Hòa Sơn","path":"Xã Hòa Sơn, Huyện Krông Bông, Tỉnh Đắk Lắk","path_with_type":"Xã Hòa Sơn, Huyện Krông Bông, Tỉnh Đắk Lắk","code":"24481","parent_code":"653"},"24484":{"name":"Xã Cư Drăm","type":"xa","slug":"xa-cu-dram","name_with_type":"Xã Cư Drăm","path":"Xã Cư Drăm, Huyện Krông Bông, Tỉnh Đắk Lắk","path_with_type":"Xã Cư Drăm, Huyện Krông Bông, Tỉnh Đắk Lắk","code":"24484","parent_code":"653"},"24487":{"name":"Xã Yang Mao","type":"xa","slug":"xa-yang-mao","name_with_type":"Xã Yang Mao","path":"Xã Yang Mao, Huyện Krông Bông, Tỉnh Đắk Lắk","path_with_type":"Xã Yang Mao, Huyện Krông Bông, Tỉnh Đắk Lắk","code":"24487","parent_code":"653"},"24490":{"name":"Thị trấn Phước An","type":"thi-tran","slug":"thi-tran-phuoc-an","name_with_type":"Thị trấn Phước An","path":"Thị trấn Phước An, Huyện Krông Pắc, Tỉnh Đắk Lắk","path_with_type":"Thị trấn Phước An, Huyện Krông Pắc, Tỉnh Đắk Lắk","code":"24490","parent_code":"654"},"24493":{"name":"Xã KRông Búk","type":"xa","slug":"xa-krong-buk","name_with_type":"Xã KRông Búk","path":"Xã KRông Búk, Huyện Krông Pắc, Tỉnh Đắk Lắk","path_with_type":"Xã KRông Búk, Huyện Krông Pắc, Tỉnh Đắk Lắk","code":"24493","parent_code":"654"},"24496":{"name":"Xã Ea Kly","type":"xa","slug":"xa-ea-kly","name_with_type":"Xã Ea Kly","path":"Xã Ea Kly, Huyện Krông Pắc, Tỉnh Đắk Lắk","path_with_type":"Xã Ea Kly, Huyện Krông Pắc, Tỉnh Đắk Lắk","code":"24496","parent_code":"654"},"24499":{"name":"Xã Ea Kênh","type":"xa","slug":"xa-ea-kenh","name_with_type":"Xã Ea Kênh","path":"Xã Ea Kênh, Huyện Krông Pắc, Tỉnh Đắk Lắk","path_with_type":"Xã Ea Kênh, Huyện Krông Pắc, Tỉnh Đắk Lắk","code":"24499","parent_code":"654"},"24502":{"name":"Xã Ea Phê","type":"xa","slug":"xa-ea-phe","name_with_type":"Xã Ea Phê","path":"Xã Ea Phê, Huyện Krông Pắc, Tỉnh Đắk Lắk","path_with_type":"Xã Ea Phê, Huyện Krông Pắc, Tỉnh Đắk Lắk","code":"24502","parent_code":"654"},"24505":{"name":"Xã Ea KNuec","type":"xa","slug":"xa-ea-knuec","name_with_type":"Xã Ea KNuec","path":"Xã Ea KNuec, Huyện Krông Pắc, Tỉnh Đắk Lắk","path_with_type":"Xã Ea KNuec, Huyện Krông Pắc, Tỉnh Đắk Lắk","code":"24505","parent_code":"654"},"24508":{"name":"Xã Ea Yông","type":"xa","slug":"xa-ea-yong","name_with_type":"Xã Ea Yông","path":"Xã Ea Yông, Huyện Krông Pắc, Tỉnh Đắk Lắk","path_with_type":"Xã Ea Yông, Huyện Krông Pắc, Tỉnh Đắk Lắk","code":"24508","parent_code":"654"},"24511":{"name":"Xã Hòa An","type":"xa","slug":"xa-hoa-an","name_with_type":"Xã Hòa An","path":"Xã Hòa An, Huyện Krông Pắc, Tỉnh Đắk Lắk","path_with_type":"Xã Hòa An, Huyện Krông Pắc, Tỉnh Đắk Lắk","code":"24511","parent_code":"654"},"24514":{"name":"Xã Ea Kuăng","type":"xa","slug":"xa-ea-kuang","name_with_type":"Xã Ea Kuăng","path":"Xã Ea Kuăng, Huyện Krông Pắc, Tỉnh Đắk Lắk","path_with_type":"Xã Ea Kuăng, Huyện Krông Pắc, Tỉnh Đắk Lắk","code":"24514","parent_code":"654"},"24517":{"name":"Xã Hòa Đông","type":"xa","slug":"xa-hoa-dong","name_with_type":"Xã Hòa Đông","path":"Xã Hòa Đông, Huyện Krông Pắc, Tỉnh Đắk Lắk","path_with_type":"Xã Hòa Đông, Huyện Krông Pắc, Tỉnh Đắk Lắk","code":"24517","parent_code":"654"},"24520":{"name":"Xã Ea Hiu","type":"xa","slug":"xa-ea-hiu","name_with_type":"Xã Ea Hiu","path":"Xã Ea Hiu, Huyện Krông Pắc, Tỉnh Đắk Lắk","path_with_type":"Xã Ea Hiu, Huyện Krông Pắc, Tỉnh Đắk Lắk","code":"24520","parent_code":"654"},"24523":{"name":"Xã Hòa Tiến","type":"xa","slug":"xa-hoa-tien","name_with_type":"Xã Hòa Tiến","path":"Xã Hòa Tiến, Huyện Krông Pắc, Tỉnh Đắk Lắk","path_with_type":"Xã Hòa Tiến, Huyện Krông Pắc, Tỉnh Đắk Lắk","code":"24523","parent_code":"654"},"24526":{"name":"Xã Tân Tiến","type":"xa","slug":"xa-tan-tien","name_with_type":"Xã Tân Tiến","path":"Xã Tân Tiến, Huyện Krông Pắc, Tỉnh Đắk Lắk","path_with_type":"Xã Tân Tiến, Huyện Krông Pắc, Tỉnh Đắk Lắk","code":"24526","parent_code":"654"},"24529":{"name":"Xã Vụ Bổn","type":"xa","slug":"xa-vu-bon","name_with_type":"Xã Vụ Bổn","path":"Xã Vụ Bổn, Huyện Krông Pắc, Tỉnh Đắk Lắk","path_with_type":"Xã Vụ Bổn, Huyện Krông Pắc, Tỉnh Đắk Lắk","code":"24529","parent_code":"654"},"24532":{"name":"Xã Ea Uy","type":"xa","slug":"xa-ea-uy","name_with_type":"Xã Ea Uy","path":"Xã Ea Uy, Huyện Krông Pắc, Tỉnh Đắk Lắk","path_with_type":"Xã Ea Uy, Huyện Krông Pắc, Tỉnh Đắk Lắk","code":"24532","parent_code":"654"},"24535":{"name":"Xã Ea Yiêng","type":"xa","slug":"xa-ea-yieng","name_with_type":"Xã Ea Yiêng","path":"Xã Ea Yiêng, Huyện Krông Pắc, Tỉnh Đắk Lắk","path_with_type":"Xã Ea Yiêng, Huyện Krông Pắc, Tỉnh Đắk Lắk","code":"24535","parent_code":"654"},"24538":{"name":"Thị trấn Buôn Trấp","type":"thi-tran","slug":"thi-tran-buon-trap","name_with_type":"Thị trấn Buôn Trấp","path":"Thị trấn Buôn Trấp, Huyện Krông A Na, Tỉnh Đắk Lắk","path_with_type":"Thị trấn Buôn Trấp, Huyện Krông A Na, Tỉnh Đắk Lắk","code":"24538","parent_code":"655"},"24540":{"name":"Xã Ea Ning","type":"xa","slug":"xa-ea-ning","name_with_type":"Xã Ea Ning","path":"Xã Ea Ning, Huyện Cư Kuin, Tỉnh Đắk Lắk","path_with_type":"Xã Ea Ning, Huyện Cư Kuin, Tỉnh Đắk Lắk","code":"24540","parent_code":"657"},"24541":{"name":"Xã Cư Ê Wi","type":"xa","slug":"xa-cu-e-wi","name_with_type":"Xã Cư Ê Wi","path":"Xã Cư Ê Wi, Huyện Cư Kuin, Tỉnh Đắk Lắk","path_with_type":"Xã Cư Ê Wi, Huyện Cư Kuin, Tỉnh Đắk Lắk","code":"24541","parent_code":"657"},"24544":{"name":"Xã Ea Ktur","type":"xa","slug":"xa-ea-ktur","name_with_type":"Xã Ea Ktur","path":"Xã Ea Ktur, Huyện Cư Kuin, Tỉnh Đắk Lắk","path_with_type":"Xã Ea Ktur, Huyện Cư Kuin, Tỉnh Đắk Lắk","code":"24544","parent_code":"657"},"24547":{"name":"Xã Ea Tiêu","type":"xa","slug":"xa-ea-tieu","name_with_type":"Xã Ea Tiêu","path":"Xã Ea Tiêu, Huyện Cư Kuin, Tỉnh Đắk Lắk","path_with_type":"Xã Ea Tiêu, Huyện Cư Kuin, Tỉnh Đắk Lắk","code":"24547","parent_code":"657"},"24550":{"name":"Xã Ea BHốk","type":"xa","slug":"xa-ea-bhok","name_with_type":"Xã Ea BHốk","path":"Xã Ea BHốk, Huyện Cư Kuin, Tỉnh Đắk Lắk","path_with_type":"Xã Ea BHốk, Huyện Cư Kuin, Tỉnh Đắk Lắk","code":"24550","parent_code":"657"},"24553":{"name":"Xã Ea Hu","type":"xa","slug":"xa-ea-hu","name_with_type":"Xã Ea Hu","path":"Xã Ea Hu, Huyện Cư Kuin, Tỉnh Đắk Lắk","path_with_type":"Xã Ea Hu, Huyện Cư Kuin, Tỉnh Đắk Lắk","code":"24553","parent_code":"657"},"24556":{"name":"Xã Dray Sáp","type":"xa","slug":"xa-dray-sap","name_with_type":"Xã Dray Sáp","path":"Xã Dray Sáp, Huyện Krông A Na, Tỉnh Đắk Lắk","path_with_type":"Xã Dray Sáp, Huyện Krông A Na, Tỉnh Đắk Lắk","code":"24556","parent_code":"655"},"24559":{"name":"Xã Ea Na","type":"xa","slug":"xa-ea-na","name_with_type":"Xã Ea Na","path":"Xã Ea Na, Huyện Krông A Na, Tỉnh Đắk Lắk","path_with_type":"Xã Ea Na, Huyện Krông A Na, Tỉnh Đắk Lắk","code":"24559","parent_code":"655"},"24561":{"name":"Xã Dray Bhăng","type":"xa","slug":"xa-dray-bhang","name_with_type":"Xã Dray Bhăng","path":"Xã Dray Bhăng, Huyện Cư Kuin, Tỉnh Đắk Lắk","path_with_type":"Xã Dray Bhăng, Huyện Cư Kuin, Tỉnh Đắk Lắk","code":"24561","parent_code":"657"},"24562":{"name":"Xã Hòa Hiệp","type":"xa","slug":"xa-hoa-hiep","name_with_type":"Xã Hòa Hiệp","path":"Xã Hòa Hiệp, Huyện Cư Kuin, Tỉnh Đắk Lắk","path_with_type":"Xã Hòa Hiệp, Huyện Cư Kuin, Tỉnh Đắk Lắk","code":"24562","parent_code":"657"},"24565":{"name":"Xã Ea Bông","type":"xa","slug":"xa-ea-bong","name_with_type":"Xã Ea Bông","path":"Xã Ea Bông, Huyện Krông A Na, Tỉnh Đắk Lắk","path_with_type":"Xã Ea Bông, Huyện Krông A Na, Tỉnh Đắk Lắk","code":"24565","parent_code":"655"},"24568":{"name":"Xã Băng A Drênh","type":"xa","slug":"xa-bang-a-drenh","name_with_type":"Xã Băng A Drênh","path":"Xã Băng A Drênh, Huyện Krông A Na, Tỉnh Đắk Lắk","path_with_type":"Xã Băng A Drênh, Huyện Krông A Na, Tỉnh Đắk Lắk","code":"24568","parent_code":"655"},"24571":{"name":"Xã Dur KMăl","type":"xa","slug":"xa-dur-kmal","name_with_type":"Xã Dur KMăl","path":"Xã Dur KMăl, Huyện Krông A Na, Tỉnh Đắk Lắk","path_with_type":"Xã Dur KMăl, Huyện Krông A Na, Tỉnh Đắk Lắk","code":"24571","parent_code":"655"},"24574":{"name":"Xã Bình Hòa","type":"xa","slug":"xa-binh-hoa","name_with_type":"Xã Bình Hòa","path":"Xã Bình Hòa, Huyện Krông A Na, Tỉnh Đắk Lắk","path_with_type":"Xã Bình Hòa, Huyện Krông A Na, Tỉnh Đắk Lắk","code":"24574","parent_code":"655"},"24577":{"name":"Xã Quảng Điền","type":"xa","slug":"xa-quang-dien","name_with_type":"Xã Quảng Điền","path":"Xã Quảng Điền, Huyện Krông A Na, Tỉnh Đắk Lắk","path_with_type":"Xã Quảng Điền, Huyện Krông A Na, Tỉnh Đắk Lắk","code":"24577","parent_code":"655"},"24580":{"name":"Thị trấn Liên Sơn","type":"thi-tran","slug":"thi-tran-lien-son","name_with_type":"Thị trấn Liên Sơn","path":"Thị trấn Liên Sơn, Huyện Lắk, Tỉnh Đắk Lắk","path_with_type":"Thị trấn Liên Sơn, Huyện Lắk, Tỉnh Đắk Lắk","code":"24580","parent_code":"656"},"24583":{"name":"Xã Yang Tao","type":"xa","slug":"xa-yang-tao","name_with_type":"Xã Yang Tao","path":"Xã Yang Tao, Huyện Lắk, Tỉnh Đắk Lắk","path_with_type":"Xã Yang Tao, Huyện Lắk, Tỉnh Đắk Lắk","code":"24583","parent_code":"656"},"24586":{"name":"Xã Bông Krang","type":"xa","slug":"xa-bong-krang","name_with_type":"Xã Bông Krang","path":"Xã Bông Krang, Huyện Lắk, Tỉnh Đắk Lắk","path_with_type":"Xã Bông Krang, Huyện Lắk, Tỉnh Đắk Lắk","code":"24586","parent_code":"656"},"24589":{"name":"Xã Đắk Liêng","type":"xa","slug":"xa-dak-lieng","name_with_type":"Xã Đắk Liêng","path":"Xã Đắk Liêng, Huyện Lắk, Tỉnh Đắk Lắk","path_with_type":"Xã Đắk Liêng, Huyện Lắk, Tỉnh Đắk Lắk","code":"24589","parent_code":"656"},"24592":{"name":"Xã Buôn Triết","type":"xa","slug":"xa-buon-triet","name_with_type":"Xã Buôn Triết","path":"Xã Buôn Triết, Huyện Lắk, Tỉnh Đắk Lắk","path_with_type":"Xã Buôn Triết, Huyện Lắk, Tỉnh Đắk Lắk","code":"24592","parent_code":"656"},"24595":{"name":"Xã Buôn Tría","type":"xa","slug":"xa-buon-tria","name_with_type":"Xã Buôn Tría","path":"Xã Buôn Tría, Huyện Lắk, Tỉnh Đắk Lắk","path_with_type":"Xã Buôn Tría, Huyện Lắk, Tỉnh Đắk Lắk","code":"24595","parent_code":"656"},"24598":{"name":"Xã Đắk Phơi","type":"xa","slug":"xa-dak-phoi","name_with_type":"Xã Đắk Phơi","path":"Xã Đắk Phơi, Huyện Lắk, Tỉnh Đắk Lắk","path_with_type":"Xã Đắk Phơi, Huyện Lắk, Tỉnh Đắk Lắk","code":"24598","parent_code":"656"},"24601":{"name":"Xã Đắk Nuê","type":"xa","slug":"xa-dak-nue","name_with_type":"Xã Đắk Nuê","path":"Xã Đắk Nuê, Huyện Lắk, Tỉnh Đắk Lắk","path_with_type":"Xã Đắk Nuê, Huyện Lắk, Tỉnh Đắk Lắk","code":"24601","parent_code":"656"},"24604":{"name":"Xã Krông Nô","type":"xa","slug":"xa-krong-no","name_with_type":"Xã Krông Nô","path":"Xã Krông Nô, Huyện Lắk, Tỉnh Đắk Lắk","path_with_type":"Xã Krông Nô, Huyện Lắk, Tỉnh Đắk Lắk","code":"24604","parent_code":"656"},"24607":{"name":"Xã Nam Ka","type":"xa","slug":"xa-nam-ka","name_with_type":"Xã Nam Ka","path":"Xã Nam Ka, Huyện Lắk, Tỉnh Đắk Lắk","path_with_type":"Xã Nam Ka, Huyện Lắk, Tỉnh Đắk Lắk","code":"24607","parent_code":"656"},"24610":{"name":"Xã Ea R\'Bin","type":"xa","slug":"xa-ea-r\'bin","name_with_type":"Xã Ea R\'Bin","path":"Xã Ea R\'Bin, Huyện Lắk, Tỉnh Đắk Lắk","path_with_type":"Xã Ea R\'Bin, Huyện Lắk, Tỉnh Đắk Lắk","code":"24610","parent_code":"656"},"24611":{"name":"Phường Nghĩa Đức","type":"phuong","slug":"phuong-nghia-duc","name_with_type":"Phường Nghĩa Đức","path":"Phường Nghĩa Đức, Thành phố Gia Nghĩa, Tỉnh Đắk Nông","path_with_type":"Phường Nghĩa Đức, Thành phố Gia Nghĩa, Tỉnh Đắk Nông","code":"24611","parent_code":"660"},"24612":{"name":"Phường Nghĩa Thành","type":"phuong","slug":"phuong-nghia-thanh","name_with_type":"Phường Nghĩa Thành","path":"Phường Nghĩa Thành, Thành phố Gia Nghĩa, Tỉnh Đắk Nông","path_with_type":"Phường Nghĩa Thành, Thành phố Gia Nghĩa, Tỉnh Đắk Nông","code":"24612","parent_code":"660"},"24614":{"name":"Phường Nghĩa Phú","type":"phuong","slug":"phuong-nghia-phu","name_with_type":"Phường Nghĩa Phú","path":"Phường Nghĩa Phú, Thành phố Gia Nghĩa, Tỉnh Đắk Nông","path_with_type":"Phường Nghĩa Phú, Thành phố Gia Nghĩa, Tỉnh Đắk Nông","code":"24614","parent_code":"660"},"24615":{"name":"Phường Nghĩa Tân","type":"phuong","slug":"phuong-nghia-tan","name_with_type":"Phường Nghĩa Tân","path":"Phường Nghĩa Tân, Thành phố Gia Nghĩa, Tỉnh Đắk Nông","path_with_type":"Phường Nghĩa Tân, Thành phố Gia Nghĩa, Tỉnh Đắk Nông","code":"24615","parent_code":"660"},"24616":{"name":"Xã Quảng Sơn","type":"xa","slug":"xa-quang-son","name_with_type":"Xã Quảng Sơn","path":"Xã Quảng Sơn, Huyện Đăk Glong, Tỉnh Đắk Nông","path_with_type":"Xã Quảng Sơn, Huyện Đăk Glong, Tỉnh Đắk Nông","code":"24616","parent_code":"661"},"24617":{"name":"Phường Nghĩa Trung","type":"phuong","slug":"phuong-nghia-trung","name_with_type":"Phường Nghĩa Trung","path":"Phường Nghĩa Trung, Thành phố Gia Nghĩa, Tỉnh Đắk Nông","path_with_type":"Phường Nghĩa Trung, Thành phố Gia Nghĩa, Tỉnh Đắk Nông","code":"24617","parent_code":"660"},"24618":{"name":"Xã Đăk R\'Moan","type":"xa","slug":"xa-dak-r\'moan","name_with_type":"Xã Đăk R\'Moan","path":"Xã Đăk R\'Moan, Thành phố Gia Nghĩa, Tỉnh Đắk Nông","path_with_type":"Xã Đăk R\'Moan, Thành phố Gia Nghĩa, Tỉnh Đắk Nông","code":"24618","parent_code":"660"},"24619":{"name":"Phường Quảng Thành","type":"phuong","slug":"phuong-quang-thanh","name_with_type":"Phường Quảng Thành","path":"Phường Quảng Thành, Thành phố Gia Nghĩa, Tỉnh Đắk Nông","path_with_type":"Phường Quảng Thành, Thành phố Gia Nghĩa, Tỉnh Đắk Nông","code":"24619","parent_code":"660"},"24620":{"name":"Xã Quảng Hoà","type":"xa","slug":"xa-quang-hoa","name_with_type":"Xã Quảng Hoà","path":"Xã Quảng Hoà, Huyện Đăk Glong, Tỉnh Đắk Nông","path_with_type":"Xã Quảng Hoà, Huyện Đăk Glong, Tỉnh Đắk Nông","code":"24620","parent_code":"661"},"24622":{"name":"Xã Đắk Ha","type":"xa","slug":"xa-dak-ha","name_with_type":"Xã Đắk Ha","path":"Xã Đắk Ha, Huyện Đăk Glong, Tỉnh Đắk Nông","path_with_type":"Xã Đắk Ha, Huyện Đăk Glong, Tỉnh Đắk Nông","code":"24622","parent_code":"661"},"24625":{"name":"Xã Đắk R\'Măng","type":"xa","slug":"xa-dak-r\'mang","name_with_type":"Xã Đắk R\'Măng","path":"Xã Đắk R\'Măng, Huyện Đăk Glong, Tỉnh Đắk Nông","path_with_type":"Xã Đắk R\'Măng, Huyện Đăk Glong, Tỉnh Đắk Nông","code":"24625","parent_code":"661"},"24628":{"name":"Xã Đắk Nia","type":"xa","slug":"xa-dak-nia","name_with_type":"Xã Đắk Nia","path":"Xã Đắk Nia, Thành phố Gia Nghĩa, Tỉnh Đắk Nông","path_with_type":"Xã Đắk Nia, Thành phố Gia Nghĩa, Tỉnh Đắk Nông","code":"24628","parent_code":"660"},"24631":{"name":"Xã Quảng Khê","type":"xa","slug":"xa-quang-khe","name_with_type":"Xã Quảng Khê","path":"Xã Quảng Khê, Huyện Đăk Glong, Tỉnh Đắk Nông","path_with_type":"Xã Quảng Khê, Huyện Đăk Glong, Tỉnh Đắk Nông","code":"24631","parent_code":"661"},"24634":{"name":"Xã Đắk Plao","type":"xa","slug":"xa-dak-plao","name_with_type":"Xã Đắk Plao","path":"Xã Đắk Plao, Huyện Đăk Glong, Tỉnh Đắk Nông","path_with_type":"Xã Đắk Plao, Huyện Đăk Glong, Tỉnh Đắk Nông","code":"24634","parent_code":"661"},"24637":{"name":"Xã Đắk Som","type":"xa","slug":"xa-dak-som","name_with_type":"Xã Đắk Som","path":"Xã Đắk Som, Huyện Đăk Glong, Tỉnh Đắk Nông","path_with_type":"Xã Đắk Som, Huyện Đăk Glong, Tỉnh Đắk Nông","code":"24637","parent_code":"661"},"24640":{"name":"Thị trấn Ea T\'Ling","type":"thi-tran","slug":"thi-tran-ea-t\'ling","name_with_type":"Thị trấn Ea T\'Ling","path":"Thị trấn Ea T\'Ling, Huyện Cư Jút, Tỉnh Đắk Nông","path_with_type":"Thị trấn Ea T\'Ling, Huyện Cư Jút, Tỉnh Đắk Nông","code":"24640","parent_code":"662"},"24643":{"name":"Xã Đắk Wil","type":"xa","slug":"xa-dak-wil","name_with_type":"Xã Đắk Wil","path":"Xã Đắk Wil, Huyện Cư Jút, Tỉnh Đắk Nông","path_with_type":"Xã Đắk Wil, Huyện Cư Jút, Tỉnh Đắk Nông","code":"24643","parent_code":"662"},"24646":{"name":"Xã Ea Pô","type":"xa","slug":"xa-ea-po","name_with_type":"Xã Ea Pô","path":"Xã Ea Pô, Huyện Cư Jút, Tỉnh Đắk Nông","path_with_type":"Xã Ea Pô, Huyện Cư Jút, Tỉnh Đắk Nông","code":"24646","parent_code":"662"},"24649":{"name":"Xã Nam Dong","type":"xa","slug":"xa-nam-dong","name_with_type":"Xã Nam Dong","path":"Xã Nam Dong, Huyện Cư Jút, Tỉnh Đắk Nông","path_with_type":"Xã Nam Dong, Huyện Cư Jút, Tỉnh Đắk Nông","code":"24649","parent_code":"662"},"24652":{"name":"Xã Đắk DRông","type":"xa","slug":"xa-dak-drong","name_with_type":"Xã Đắk DRông","path":"Xã Đắk DRông, Huyện Cư Jút, Tỉnh Đắk Nông","path_with_type":"Xã Đắk DRông, Huyện Cư Jút, Tỉnh Đắk Nông","code":"24652","parent_code":"662"},"24655":{"name":"Xã Tâm Thắng","type":"xa","slug":"xa-tam-thang","name_with_type":"Xã Tâm Thắng","path":"Xã Tâm Thắng, Huyện Cư Jút, Tỉnh Đắk Nông","path_with_type":"Xã Tâm Thắng, Huyện Cư Jút, Tỉnh Đắk Nông","code":"24655","parent_code":"662"},"24658":{"name":"Xã Cư Knia","type":"xa","slug":"xa-cu-knia","name_with_type":"Xã Cư Knia","path":"Xã Cư Knia, Huyện Cư Jút, Tỉnh Đắk Nông","path_with_type":"Xã Cư Knia, Huyện Cư Jút, Tỉnh Đắk Nông","code":"24658","parent_code":"662"},"24661":{"name":"Xã Trúc Sơn","type":"xa","slug":"xa-truc-son","name_with_type":"Xã Trúc Sơn","path":"Xã Trúc Sơn, Huyện Cư Jút, Tỉnh Đắk Nông","path_with_type":"Xã Trúc Sơn, Huyện Cư Jút, Tỉnh Đắk Nông","code":"24661","parent_code":"662"},"24664":{"name":"Thị trấn Đắk Mil","type":"thi-tran","slug":"thi-tran-dak-mil","name_with_type":"Thị trấn Đắk Mil","path":"Thị trấn Đắk Mil, Huyện Đắk Mil, Tỉnh Đắk Nông","path_with_type":"Thị trấn Đắk Mil, Huyện Đắk Mil, Tỉnh Đắk Nông","code":"24664","parent_code":"663"},"24667":{"name":"Xã  Đắk Lao","type":"xa","slug":"xa-dak-lao","name_with_type":"Xã  Đắk Lao","path":"Xã  Đắk Lao, Huyện Đắk Mil, Tỉnh Đắk Nông","path_with_type":"Xã  Đắk Lao, Huyện Đắk Mil, Tỉnh Đắk Nông","code":"24667","parent_code":"663"},"24670":{"name":"Xã Đắk R\'La","type":"xa","slug":"xa-dak-r\'la","name_with_type":"Xã Đắk R\'La","path":"Xã Đắk R\'La, Huyện Đắk Mil, Tỉnh Đắk Nông","path_with_type":"Xã Đắk R\'La, Huyện Đắk Mil, Tỉnh Đắk Nông","code":"24670","parent_code":"663"},"24673":{"name":"Xã Đắk Gằn","type":"xa","slug":"xa-dak-gan","name_with_type":"Xã Đắk Gằn","path":"Xã Đắk Gằn, Huyện Đắk Mil, Tỉnh Đắk Nông","path_with_type":"Xã Đắk Gằn, Huyện Đắk Mil, Tỉnh Đắk Nông","code":"24673","parent_code":"663"},"24676":{"name":"Xã Đức Mạnh","type":"xa","slug":"xa-duc-manh","name_with_type":"Xã Đức Mạnh","path":"Xã Đức Mạnh, Huyện Đắk Mil, Tỉnh Đắk Nông","path_with_type":"Xã Đức Mạnh, Huyện Đắk Mil, Tỉnh Đắk Nông","code":"24676","parent_code":"663"},"24677":{"name":"Xã Đắk N\'Drót","type":"xa","slug":"xa-dak-n\'drot","name_with_type":"Xã Đắk N\'Drót","path":"Xã Đắk N\'Drót, Huyện Đắk Mil, Tỉnh Đắk Nông","path_with_type":"Xã Đắk N\'Drót, Huyện Đắk Mil, Tỉnh Đắk Nông","code":"24677","parent_code":"663"},"24678":{"name":"Xã Long Sơn","type":"xa","slug":"xa-long-son","name_with_type":"Xã Long Sơn","path":"Xã Long Sơn, Huyện Đắk Mil, Tỉnh Đắk Nông","path_with_type":"Xã Long Sơn, Huyện Đắk Mil, Tỉnh Đắk Nông","code":"24678","parent_code":"663"},"24679":{"name":"Xã Đắk Sắk","type":"xa","slug":"xa-dak-sak","name_with_type":"Xã Đắk Sắk","path":"Xã Đắk Sắk, Huyện Đắk Mil, Tỉnh Đắk Nông","path_with_type":"Xã Đắk Sắk, Huyện Đắk Mil, Tỉnh Đắk Nông","code":"24679","parent_code":"663"},"24682":{"name":"Xã Thuận An","type":"xa","slug":"xa-thuan-an","name_with_type":"Xã Thuận An","path":"Xã Thuận An, Huyện Đắk Mil, Tỉnh Đắk Nông","path_with_type":"Xã Thuận An, Huyện Đắk Mil, Tỉnh Đắk Nông","code":"24682","parent_code":"663"},"24685":{"name":"Xã Đức Minh","type":"xa","slug":"xa-duc-minh","name_with_type":"Xã Đức Minh","path":"Xã Đức Minh, Huyện Đắk Mil, Tỉnh Đắk Nông","path_with_type":"Xã Đức Minh, Huyện Đắk Mil, Tỉnh Đắk Nông","code":"24685","parent_code":"663"},"24688":{"name":"Thị trấn Đắk Mâm","type":"thi-tran","slug":"thi-tran-dak-mam","name_with_type":"Thị trấn Đắk Mâm","path":"Thị trấn Đắk Mâm, Huyện Krông Nô, Tỉnh Đắk Nông","path_with_type":"Thị trấn Đắk Mâm, Huyện Krông Nô, Tỉnh Đắk Nông","code":"24688","parent_code":"664"},"24691":{"name":"Xã Đắk Sôr","type":"xa","slug":"xa-dak-sor","name_with_type":"Xã Đắk Sôr","path":"Xã Đắk Sôr, Huyện Krông Nô, Tỉnh Đắk Nông","path_with_type":"Xã Đắk Sôr, Huyện Krông Nô, Tỉnh Đắk Nông","code":"24691","parent_code":"664"},"24692":{"name":"Xã Nam Xuân","type":"xa","slug":"xa-nam-xuan","name_with_type":"Xã Nam Xuân","path":"Xã Nam Xuân, Huyện Krông Nô, Tỉnh Đắk Nông","path_with_type":"Xã Nam Xuân, Huyện Krông Nô, Tỉnh Đắk Nông","code":"24692","parent_code":"664"},"24694":{"name":"Xã Buôn Choah","type":"xa","slug":"xa-buon-choah","name_with_type":"Xã Buôn Choah","path":"Xã Buôn Choah, Huyện Krông Nô, Tỉnh Đắk Nông","path_with_type":"Xã Buôn Choah, Huyện Krông Nô, Tỉnh Đắk Nông","code":"24694","parent_code":"664"},"24697":{"name":"Xã Nam Đà","type":"xa","slug":"xa-nam-da","name_with_type":"Xã Nam Đà","path":"Xã Nam Đà, Huyện Krông Nô, Tỉnh Đắk Nông","path_with_type":"Xã Nam Đà, Huyện Krông Nô, Tỉnh Đắk Nông","code":"24697","parent_code":"664"},"24699":{"name":"Xã Tân Thành","type":"xa","slug":"xa-tan-thanh","name_with_type":"Xã Tân Thành","path":"Xã Tân Thành, Huyện Krông Nô, Tỉnh Đắk Nông","path_with_type":"Xã Tân Thành, Huyện Krông Nô, Tỉnh Đắk Nông","code":"24699","parent_code":"664"},"24700":{"name":"Xã Đắk Drô","type":"xa","slug":"xa-dak-dro","name_with_type":"Xã Đắk Drô","path":"Xã Đắk Drô, Huyện Krông Nô, Tỉnh Đắk Nông","path_with_type":"Xã Đắk Drô, Huyện Krông Nô, Tỉnh Đắk Nông","code":"24700","parent_code":"664"},"24703":{"name":"Xã Nâm Nung","type":"xa","slug":"xa-nam-nung","name_with_type":"Xã Nâm Nung","path":"Xã Nâm Nung, Huyện Krông Nô, Tỉnh Đắk Nông","path_with_type":"Xã Nâm Nung, Huyện Krông Nô, Tỉnh Đắk Nông","code":"24703","parent_code":"664"},"24706":{"name":"Xã Đức Xuyên","type":"xa","slug":"xa-duc-xuyen","name_with_type":"Xã Đức Xuyên","path":"Xã Đức Xuyên, Huyện Krông Nô, Tỉnh Đắk Nông","path_with_type":"Xã Đức Xuyên, Huyện Krông Nô, Tỉnh Đắk Nông","code":"24706","parent_code":"664"},"24709":{"name":"Xã Đắk Nang","type":"xa","slug":"xa-dak-nang","name_with_type":"Xã Đắk Nang","path":"Xã Đắk Nang, Huyện Krông Nô, Tỉnh Đắk Nông","path_with_type":"Xã Đắk Nang, Huyện Krông Nô, Tỉnh Đắk Nông","code":"24709","parent_code":"664"},"24712":{"name":"Xã Quảng Phú","type":"xa","slug":"xa-quang-phu","name_with_type":"Xã Quảng Phú","path":"Xã Quảng Phú, Huyện Krông Nô, Tỉnh Đắk Nông","path_with_type":"Xã Quảng Phú, Huyện Krông Nô, Tỉnh Đắk Nông","code":"24712","parent_code":"664"},"24715":{"name":"Xã Nâm N\'Đir","type":"xa","slug":"xa-nam-n\'dir","name_with_type":"Xã Nâm N\'Đir","path":"Xã Nâm N\'Đir, Huyện Krông Nô, Tỉnh Đắk Nông","path_with_type":"Xã Nâm N\'Đir, Huyện Krông Nô, Tỉnh Đắk Nông","code":"24715","parent_code":"664"},"24717":{"name":"Thị trấn Đức An","type":"thi-tran","slug":"thi-tran-duc-an","name_with_type":"Thị trấn Đức An","path":"Thị trấn Đức An, Huyện Đắk Song, Tỉnh Đắk Nông","path_with_type":"Thị trấn Đức An, Huyện Đắk Song, Tỉnh Đắk Nông","code":"24717","parent_code":"665"},"24718":{"name":"Xã Đắk Môl","type":"xa","slug":"xa-dak-mol","name_with_type":"Xã Đắk Môl","path":"Xã Đắk Môl, Huyện Đắk Song, Tỉnh Đắk Nông","path_with_type":"Xã Đắk Môl, Huyện Đắk Song, Tỉnh Đắk Nông","code":"24718","parent_code":"665"},"24719":{"name":"Xã Đắk Hòa","type":"xa","slug":"xa-dak-hoa","name_with_type":"Xã Đắk Hòa","path":"Xã Đắk Hòa, Huyện Đắk Song, Tỉnh Đắk Nông","path_with_type":"Xã Đắk Hòa, Huyện Đắk Song, Tỉnh Đắk Nông","code":"24719","parent_code":"665"},"24721":{"name":"Xã Nam Bình","type":"xa","slug":"xa-nam-binh","name_with_type":"Xã Nam Bình","path":"Xã Nam Bình, Huyện Đắk Song, Tỉnh Đắk Nông","path_with_type":"Xã Nam Bình, Huyện Đắk Song, Tỉnh Đắk Nông","code":"24721","parent_code":"665"},"24722":{"name":"Xã Thuận Hà","type":"xa","slug":"xa-thuan-ha","name_with_type":"Xã Thuận Hà","path":"Xã Thuận Hà, Huyện Đắk Song, Tỉnh Đắk Nông","path_with_type":"Xã Thuận Hà, Huyện Đắk Song, Tỉnh Đắk Nông","code":"24722","parent_code":"665"},"24724":{"name":"Xã Thuận Hạnh","type":"xa","slug":"xa-thuan-hanh","name_with_type":"Xã Thuận Hạnh","path":"Xã Thuận Hạnh, Huyện Đắk Song, Tỉnh Đắk Nông","path_with_type":"Xã Thuận Hạnh, Huyện Đắk Song, Tỉnh Đắk Nông","code":"24724","parent_code":"665"},"24727":{"name":"Xã Đắk N\'Dung","type":"xa","slug":"xa-dak-n\'dung","name_with_type":"Xã Đắk N\'Dung","path":"Xã Đắk N\'Dung, Huyện Đắk Song, Tỉnh Đắk Nông","path_with_type":"Xã Đắk N\'Dung, Huyện Đắk Song, Tỉnh Đắk Nông","code":"24727","parent_code":"665"},"24728":{"name":"Xã Nâm N\'Jang","type":"xa","slug":"xa-nam-n\'jang","name_with_type":"Xã Nâm N\'Jang","path":"Xã Nâm N\'Jang, Huyện Đắk Song, Tỉnh Đắk Nông","path_with_type":"Xã Nâm N\'Jang, Huyện Đắk Song, Tỉnh Đắk Nông","code":"24728","parent_code":"665"},"24730":{"name":"Xã Trường Xuân","type":"xa","slug":"xa-truong-xuan","name_with_type":"Xã Trường Xuân","path":"Xã Trường Xuân, Huyện Đắk Song, Tỉnh Đắk Nông","path_with_type":"Xã Trường Xuân, Huyện Đắk Song, Tỉnh Đắk Nông","code":"24730","parent_code":"665"},"24733":{"name":"Thị trấn Kiến Đức","type":"thi-tran","slug":"thi-tran-kien-duc","name_with_type":"Thị trấn Kiến Đức","path":"Thị trấn Kiến Đức, Huyện Đắk R\'Lấp, Tỉnh Đắk Nông","path_with_type":"Thị trấn Kiến Đức, Huyện Đắk R\'Lấp, Tỉnh Đắk Nông","code":"24733","parent_code":"666"},"24736":{"name":"Xã Quảng Trực","type":"xa","slug":"xa-quang-truc","name_with_type":"Xã Quảng Trực","path":"Xã Quảng Trực, Huyện Tuy Đức, Tỉnh Đắk Nông","path_with_type":"Xã Quảng Trực, Huyện Tuy Đức, Tỉnh Đắk Nông","code":"24736","parent_code":"667"},"24739":{"name":"Xã Đắk Búk So","type":"xa","slug":"xa-dak-buk-so","name_with_type":"Xã Đắk Búk So","path":"Xã Đắk Búk So, Huyện Tuy Đức, Tỉnh Đắk Nông","path_with_type":"Xã Đắk Búk So, Huyện Tuy Đức, Tỉnh Đắk Nông","code":"24739","parent_code":"667"},"24740":{"name":"Xã Quảng Tâm","type":"xa","slug":"xa-quang-tam","name_with_type":"Xã Quảng Tâm","path":"Xã Quảng Tâm, Huyện Tuy Đức, Tỉnh Đắk Nông","path_with_type":"Xã Quảng Tâm, Huyện Tuy Đức, Tỉnh Đắk Nông","code":"24740","parent_code":"667"},"24742":{"name":"Xã Đắk R\'Tíh","type":"xa","slug":"xa-dak-r\'tih","name_with_type":"Xã Đắk R\'Tíh","path":"Xã Đắk R\'Tíh, Huyện Tuy Đức, Tỉnh Đắk Nông","path_with_type":"Xã Đắk R\'Tíh, Huyện Tuy Đức, Tỉnh Đắk Nông","code":"24742","parent_code":"667"},"24745":{"name":"Xã Quảng Tín","type":"xa","slug":"xa-quang-tin","name_with_type":"Xã Quảng Tín","path":"Xã Quảng Tín, Huyện Đắk R\'Lấp, Tỉnh Đắk Nông","path_with_type":"Xã Quảng Tín, Huyện Đắk R\'Lấp, Tỉnh Đắk Nông","code":"24745","parent_code":"666"},"24746":{"name":"Xã Đắk Ngo","type":"xa","slug":"xa-dak-ngo","name_with_type":"Xã Đắk Ngo","path":"Xã Đắk Ngo, Huyện Tuy Đức, Tỉnh Đắk Nông","path_with_type":"Xã Đắk Ngo, Huyện Tuy Đức, Tỉnh Đắk Nông","code":"24746","parent_code":"667"},"24748":{"name":"Xã Quảng Tân","type":"xa","slug":"xa-quang-tan","name_with_type":"Xã Quảng Tân","path":"Xã Quảng Tân, Huyện Tuy Đức, Tỉnh Đắk Nông","path_with_type":"Xã Quảng Tân, Huyện Tuy Đức, Tỉnh Đắk Nông","code":"24748","parent_code":"667"},"24750":{"name":"Xã Đắk Wer","type":"xa","slug":"xa-dak-wer","name_with_type":"Xã Đắk Wer","path":"Xã Đắk Wer, Huyện Đắk R\'Lấp, Tỉnh Đắk Nông","path_with_type":"Xã Đắk Wer, Huyện Đắk R\'Lấp, Tỉnh Đắk Nông","code":"24750","parent_code":"666"},"24751":{"name":"Xã Nhân Cơ","type":"xa","slug":"xa-nhan-co","name_with_type":"Xã Nhân Cơ","path":"Xã Nhân Cơ, Huyện Đắk R\'Lấp, Tỉnh Đắk Nông","path_with_type":"Xã Nhân Cơ, Huyện Đắk R\'Lấp, Tỉnh Đắk Nông","code":"24751","parent_code":"666"},"24754":{"name":"Xã Kiến Thành","type":"xa","slug":"xa-kien-thanh","name_with_type":"Xã Kiến Thành","path":"Xã Kiến Thành, Huyện Đắk R\'Lấp, Tỉnh Đắk Nông","path_with_type":"Xã Kiến Thành, Huyện Đắk R\'Lấp, Tỉnh Đắk Nông","code":"24754","parent_code":"666"},"24756":{"name":"Xã Nghĩa Thắng","type":"xa","slug":"xa-nghia-thang","name_with_type":"Xã Nghĩa Thắng","path":"Xã Nghĩa Thắng, Huyện Đắk R\'Lấp, Tỉnh Đắk Nông","path_with_type":"Xã Nghĩa Thắng, Huyện Đắk R\'Lấp, Tỉnh Đắk Nông","code":"24756","parent_code":"666"},"24757":{"name":"Xã Đạo Nghĩa","type":"xa","slug":"xa-dao-nghia","name_with_type":"Xã Đạo Nghĩa","path":"Xã Đạo Nghĩa, Huyện Đắk R\'Lấp, Tỉnh Đắk Nông","path_with_type":"Xã Đạo Nghĩa, Huyện Đắk R\'Lấp, Tỉnh Đắk Nông","code":"24757","parent_code":"666"},"24760":{"name":"Xã Đắk Sin","type":"xa","slug":"xa-dak-sin","name_with_type":"Xã Đắk Sin","path":"Xã Đắk Sin, Huyện Đắk R\'Lấp, Tỉnh Đắk Nông","path_with_type":"Xã Đắk Sin, Huyện Đắk R\'Lấp, Tỉnh Đắk Nông","code":"24760","parent_code":"666"},"24761":{"name":"Xã Hưng Bình","type":"xa","slug":"xa-hung-binh","name_with_type":"Xã Hưng Bình","path":"Xã Hưng Bình, Huyện Đắk R\'Lấp, Tỉnh Đắk Nông","path_with_type":"Xã Hưng Bình, Huyện Đắk R\'Lấp, Tỉnh Đắk Nông","code":"24761","parent_code":"666"},"24763":{"name":"Xã Đắk Ru","type":"xa","slug":"xa-dak-ru","name_with_type":"Xã Đắk Ru","path":"Xã Đắk Ru, Huyện Đắk R\'Lấp, Tỉnh Đắk Nông","path_with_type":"Xã Đắk Ru, Huyện Đắk R\'Lấp, Tỉnh Đắk Nông","code":"24763","parent_code":"666"},"24766":{"name":"Xã Nhân Đạo","type":"xa","slug":"xa-nhan-dao","name_with_type":"Xã Nhân Đạo","path":"Xã Nhân Đạo, Huyện Đắk R\'Lấp, Tỉnh Đắk Nông","path_with_type":"Xã Nhân Đạo, Huyện Đắk R\'Lấp, Tỉnh Đắk Nông","code":"24766","parent_code":"666"},"24769":{"name":"Phường 7","type":"phuong","slug":"phuong-7","name_with_type":"Phường 7","path":"Phường 7, Thành phố Đà Lạt, Tỉnh Lâm Đồng","path_with_type":"Phường 7, Thành phố Đà Lạt, Tỉnh Lâm Đồng","code":"24769","parent_code":"672"},"24772":{"name":"Phường 8","type":"phuong","slug":"phuong-8","name_with_type":"Phường 8","path":"Phường 8, Thành phố Đà Lạt, Tỉnh Lâm Đồng","path_with_type":"Phường 8, Thành phố Đà Lạt, Tỉnh Lâm Đồng","code":"24772","parent_code":"672"},"24775":{"name":"Phường 12","type":"phuong","slug":"phuong-12","name_with_type":"Phường 12","path":"Phường 12, Thành phố Đà Lạt, Tỉnh Lâm Đồng","path_with_type":"Phường 12, Thành phố Đà Lạt, Tỉnh Lâm Đồng","code":"24775","parent_code":"672"},"24778":{"name":"Phường 9","type":"phuong","slug":"phuong-9","name_with_type":"Phường 9","path":"Phường 9, Thành phố Đà Lạt, Tỉnh Lâm Đồng","path_with_type":"Phường 9, Thành phố Đà Lạt, Tỉnh Lâm Đồng","code":"24778","parent_code":"672"},"24781":{"name":"Phường 2","type":"phuong","slug":"phuong-2","name_with_type":"Phường 2","path":"Phường 2, Thành phố Đà Lạt, Tỉnh Lâm Đồng","path_with_type":"Phường 2, Thành phố Đà Lạt, Tỉnh Lâm Đồng","code":"24781","parent_code":"672"},"24784":{"name":"Phường 1","type":"phuong","slug":"phuong-1","name_with_type":"Phường 1","path":"Phường 1, Thành phố Đà Lạt, Tỉnh Lâm Đồng","path_with_type":"Phường 1, Thành phố Đà Lạt, Tỉnh Lâm Đồng","code":"24784","parent_code":"672"},"24787":{"name":"Phường 6","type":"phuong","slug":"phuong-6","name_with_type":"Phường 6","path":"Phường 6, Thành phố Đà Lạt, Tỉnh Lâm Đồng","path_with_type":"Phường 6, Thành phố Đà Lạt, Tỉnh Lâm Đồng","code":"24787","parent_code":"672"},"24790":{"name":"Phường 5","type":"phuong","slug":"phuong-5","name_with_type":"Phường 5","path":"Phường 5, Thành phố Đà Lạt, Tỉnh Lâm Đồng","path_with_type":"Phường 5, Thành phố Đà Lạt, Tỉnh Lâm Đồng","code":"24790","parent_code":"672"},"24793":{"name":"Phường 4","type":"phuong","slug":"phuong-4","name_with_type":"Phường 4","path":"Phường 4, Thành phố Đà Lạt, Tỉnh Lâm Đồng","path_with_type":"Phường 4, Thành phố Đà Lạt, Tỉnh Lâm Đồng","code":"24793","parent_code":"672"},"24796":{"name":"Phường 10","type":"phuong","slug":"phuong-10","name_with_type":"Phường 10","path":"Phường 10, Thành phố Đà Lạt, Tỉnh Lâm Đồng","path_with_type":"Phường 10, Thành phố Đà Lạt, Tỉnh Lâm Đồng","code":"24796","parent_code":"672"},"24799":{"name":"Phường 11","type":"phuong","slug":"phuong-11","name_with_type":"Phường 11","path":"Phường 11, Thành phố Đà Lạt, Tỉnh Lâm Đồng","path_with_type":"Phường 11, Thành phố Đà Lạt, Tỉnh Lâm Đồng","code":"24799","parent_code":"672"},"24802":{"name":"Phường 3","type":"phuong","slug":"phuong-3","name_with_type":"Phường 3","path":"Phường 3, Thành phố Đà Lạt, Tỉnh Lâm Đồng","path_with_type":"Phường 3, Thành phố Đà Lạt, Tỉnh Lâm Đồng","code":"24802","parent_code":"672"},"24805":{"name":"Xã Xuân Thọ","type":"xa","slug":"xa-xuan-tho","name_with_type":"Xã Xuân Thọ","path":"Xã Xuân Thọ, Thành phố Đà Lạt, Tỉnh Lâm Đồng","path_with_type":"Xã Xuân Thọ, Thành phố Đà Lạt, Tỉnh Lâm Đồng","code":"24805","parent_code":"672"},"24808":{"name":"Xã Tà Nung","type":"xa","slug":"xa-ta-nung","name_with_type":"Xã Tà Nung","path":"Xã Tà Nung, Thành phố Đà Lạt, Tỉnh Lâm Đồng","path_with_type":"Xã Tà Nung, Thành phố Đà Lạt, Tỉnh Lâm Đồng","code":"24808","parent_code":"672"},"24810":{"name":"Xã Trạm Hành","type":"xa","slug":"xa-tram-hanh","name_with_type":"Xã Trạm Hành","path":"Xã Trạm Hành, Thành phố Đà Lạt, Tỉnh Lâm Đồng","path_with_type":"Xã Trạm Hành, Thành phố Đà Lạt, Tỉnh Lâm Đồng","code":"24810","parent_code":"672"},"24811":{"name":"Xã Xuân Trường","type":"xa","slug":"xa-xuan-truong","name_with_type":"Xã Xuân Trường","path":"Xã Xuân Trường, Thành phố Đà Lạt, Tỉnh Lâm Đồng","path_with_type":"Xã Xuân Trường, Thành phố Đà Lạt, Tỉnh Lâm Đồng","code":"24811","parent_code":"672"},"24814":{"name":"Phường Lộc Phát","type":"phuong","slug":"phuong-loc-phat","name_with_type":"Phường Lộc Phát","path":"Phường Lộc Phát, Thành phố Bảo Lộc, Tỉnh Lâm Đồng","path_with_type":"Phường Lộc Phát, Thành phố Bảo Lộc, Tỉnh Lâm Đồng","code":"24814","parent_code":"673"},"24817":{"name":"Phường Lộc Tiến","type":"phuong","slug":"phuong-loc-tien","name_with_type":"Phường Lộc Tiến","path":"Phường Lộc Tiến, Thành phố Bảo Lộc, Tỉnh Lâm Đồng","path_with_type":"Phường Lộc Tiến, Thành phố Bảo Lộc, Tỉnh Lâm Đồng","code":"24817","parent_code":"673"},"24820":{"name":"Phường 2","type":"phuong","slug":"phuong-2","name_with_type":"Phường 2","path":"Phường 2, Thành phố Bảo Lộc, Tỉnh Lâm Đồng","path_with_type":"Phường 2, Thành phố Bảo Lộc, Tỉnh Lâm Đồng","code":"24820","parent_code":"673"},"24823":{"name":"Phường 1","type":"phuong","slug":"phuong-1","name_with_type":"Phường 1","path":"Phường 1, Thành phố Bảo Lộc, Tỉnh Lâm Đồng","path_with_type":"Phường 1, Thành phố Bảo Lộc, Tỉnh Lâm Đồng","code":"24823","parent_code":"673"},"24826":{"name":"Phường B\'lao","type":"phuong","slug":"phuong-b\'lao","name_with_type":"Phường B\'lao","path":"Phường B\'lao, Thành phố Bảo Lộc, Tỉnh Lâm Đồng","path_with_type":"Phường B\'lao, Thành phố Bảo Lộc, Tỉnh Lâm Đồng","code":"24826","parent_code":"673"},"24829":{"name":"Phường Lộc Sơn","type":"phuong","slug":"phuong-loc-son","name_with_type":"Phường Lộc Sơn","path":"Phường Lộc Sơn, Thành phố Bảo Lộc, Tỉnh Lâm Đồng","path_with_type":"Phường Lộc Sơn, Thành phố Bảo Lộc, Tỉnh Lâm Đồng","code":"24829","parent_code":"673"},"24832":{"name":"Xã Đạm Bri","type":"xa","slug":"xa-dam-bri","name_with_type":"Xã Đạm Bri","path":"Xã Đạm Bri, Thành phố Bảo Lộc, Tỉnh Lâm Đồng","path_with_type":"Xã Đạm Bri, Thành phố Bảo Lộc, Tỉnh Lâm Đồng","code":"24832","parent_code":"673"},"24835":{"name":"Xã Lộc Thanh","type":"xa","slug":"xa-loc-thanh","name_with_type":"Xã Lộc Thanh","path":"Xã Lộc Thanh, Thành phố Bảo Lộc, Tỉnh Lâm Đồng","path_with_type":"Xã Lộc Thanh, Thành phố Bảo Lộc, Tỉnh Lâm Đồng","code":"24835","parent_code":"673"},"24838":{"name":"Xã Lộc Nga","type":"xa","slug":"xa-loc-nga","name_with_type":"Xã Lộc Nga","path":"Xã Lộc Nga, Thành phố Bảo Lộc, Tỉnh Lâm Đồng","path_with_type":"Xã Lộc Nga, Thành phố Bảo Lộc, Tỉnh Lâm Đồng","code":"24838","parent_code":"673"},"24841":{"name":"Xã Lộc Châu","type":"xa","slug":"xa-loc-chau","name_with_type":"Xã Lộc Châu","path":"Xã Lộc Châu, Thành phố Bảo Lộc, Tỉnh Lâm Đồng","path_with_type":"Xã Lộc Châu, Thành phố Bảo Lộc, Tỉnh Lâm Đồng","code":"24841","parent_code":"673"},"24844":{"name":"Xã Đại Lào","type":"xa","slug":"xa-dai-lao","name_with_type":"Xã Đại Lào","path":"Xã Đại Lào, Thành phố Bảo Lộc, Tỉnh Lâm Đồng","path_with_type":"Xã Đại Lào, Thành phố Bảo Lộc, Tỉnh Lâm Đồng","code":"24844","parent_code":"673"},"24846":{"name":"Thị trấn Lạc Dương","type":"thi-tran","slug":"thi-tran-lac-duong","name_with_type":"Thị trấn Lạc Dương","path":"Thị trấn Lạc Dương, Huyện Lạc Dương, Tỉnh Lâm Đồng","path_with_type":"Thị trấn Lạc Dương, Huyện Lạc Dương, Tỉnh Lâm Đồng","code":"24846","parent_code":"675"},"24847":{"name":"Xã Đạ Chais","type":"xa","slug":"xa-da-chais","name_with_type":"Xã Đạ Chais","path":"Xã Đạ Chais, Huyện Lạc Dương, Tỉnh Lâm Đồng","path_with_type":"Xã Đạ Chais, Huyện Lạc Dương, Tỉnh Lâm Đồng","code":"24847","parent_code":"675"},"24848":{"name":"Xã Đạ Nhim","type":"xa","slug":"xa-da-nhim","name_with_type":"Xã Đạ Nhim","path":"Xã Đạ Nhim, Huyện Lạc Dương, Tỉnh Lâm Đồng","path_with_type":"Xã Đạ Nhim, Huyện Lạc Dương, Tỉnh Lâm Đồng","code":"24848","parent_code":"675"},"24850":{"name":"Xã Đưng KNớ","type":"xa","slug":"xa-dung-kno","name_with_type":"Xã Đưng KNớ","path":"Xã Đưng KNớ, Huyện Lạc Dương, Tỉnh Lâm Đồng","path_with_type":"Xã Đưng KNớ, Huyện Lạc Dương, Tỉnh Lâm Đồng","code":"24850","parent_code":"675"},"24853":{"name":"Xã Đạ Tông","type":"xa","slug":"xa-da-tong","name_with_type":"Xã Đạ Tông","path":"Xã Đạ Tông, Huyện Đam Rông, Tỉnh Lâm Đồng","path_with_type":"Xã Đạ Tông, Huyện Đam Rông, Tỉnh Lâm Đồng","code":"24853","parent_code":"674"},"24856":{"name":"Xã Đạ Long","type":"xa","slug":"xa-da-long","name_with_type":"Xã Đạ Long","path":"Xã Đạ Long, Huyện Đam Rông, Tỉnh Lâm Đồng","path_with_type":"Xã Đạ Long, Huyện Đam Rông, Tỉnh Lâm Đồng","code":"24856","parent_code":"674"},"24859":{"name":"Xã Đạ M\' Rong","type":"xa","slug":"xa-da-m\'-rong","name_with_type":"Xã Đạ M\' Rong","path":"Xã Đạ M\' Rong, Huyện Đam Rông, Tỉnh Lâm Đồng","path_with_type":"Xã Đạ M\' Rong, Huyện Đam Rông, Tỉnh Lâm Đồng","code":"24859","parent_code":"674"},"24862":{"name":"Xã Lát","type":"xa","slug":"xa-lat","name_with_type":"Xã Lát","path":"Xã Lát, Huyện Lạc Dương, Tỉnh Lâm Đồng","path_with_type":"Xã Lát, Huyện Lạc Dương, Tỉnh Lâm Đồng","code":"24862","parent_code":"675"},"24865":{"name":"Xã Đạ Sar","type":"xa","slug":"xa-da-sar","name_with_type":"Xã Đạ Sar","path":"Xã Đạ Sar, Huyện Lạc Dương, Tỉnh Lâm Đồng","path_with_type":"Xã Đạ Sar, Huyện Lạc Dương, Tỉnh Lâm Đồng","code":"24865","parent_code":"675"},"24868":{"name":"Thị trấn Nam Ban","type":"thi-tran","slug":"thi-tran-nam-ban","name_with_type":"Thị trấn Nam Ban","path":"Thị trấn Nam Ban, Huyện Lâm Hà, Tỉnh Lâm Đồng","path_with_type":"Thị trấn Nam Ban, Huyện Lâm Hà, Tỉnh Lâm Đồng","code":"24868","parent_code":"676"},"24871":{"name":"Thị trấn Đinh Văn","type":"thi-tran","slug":"thi-tran-dinh-van","name_with_type":"Thị trấn Đinh Văn","path":"Thị trấn Đinh Văn, Huyện Lâm Hà, Tỉnh Lâm Đồng","path_with_type":"Thị trấn Đinh Văn, Huyện Lâm Hà, Tỉnh Lâm Đồng","code":"24871","parent_code":"676"},"24874":{"name":"Xã Liêng Srônh","type":"xa","slug":"xa-lieng-sronh","name_with_type":"Xã Liêng Srônh","path":"Xã Liêng Srônh, Huyện Đam Rông, Tỉnh Lâm Đồng","path_with_type":"Xã Liêng Srônh, Huyện Đam Rông, Tỉnh Lâm Đồng","code":"24874","parent_code":"674"},"24875":{"name":"Xã Đạ Rsal","type":"xa","slug":"xa-da-rsal","name_with_type":"Xã Đạ Rsal","path":"Xã Đạ Rsal, Huyện Đam Rông, Tỉnh Lâm Đồng","path_with_type":"Xã Đạ Rsal, Huyện Đam Rông, Tỉnh Lâm Đồng","code":"24875","parent_code":"674"},"24877":{"name":"Xã Rô Men","type":"xa","slug":"xa-ro-men","name_with_type":"Xã Rô Men","path":"Xã Rô Men, Huyện Đam Rông, Tỉnh Lâm Đồng","path_with_type":"Xã Rô Men, Huyện Đam Rông, Tỉnh Lâm Đồng","code":"24877","parent_code":"674"},"24880":{"name":"Xã Phú Sơn","type":"xa","slug":"xa-phu-son","name_with_type":"Xã Phú Sơn","path":"Xã Phú Sơn, Huyện Lâm Hà, Tỉnh Lâm Đồng","path_with_type":"Xã Phú Sơn, Huyện Lâm Hà, Tỉnh Lâm Đồng","code":"24880","parent_code":"676"},"24883":{"name":"Xã Phi Tô","type":"xa","slug":"xa-phi-to","name_with_type":"Xã Phi Tô","path":"Xã Phi Tô, Huyện Lâm Hà, Tỉnh Lâm Đồng","path_with_type":"Xã Phi Tô, Huyện Lâm Hà, Tỉnh Lâm Đồng","code":"24883","parent_code":"676"},"24886":{"name":"Xã Phi Liêng","type":"xa","slug":"xa-phi-lieng","name_with_type":"Xã Phi Liêng","path":"Xã Phi Liêng, Huyện Đam Rông, Tỉnh Lâm Đồng","path_with_type":"Xã Phi Liêng, Huyện Đam Rông, Tỉnh Lâm Đồng","code":"24886","parent_code":"674"},"24889":{"name":"Xã Đạ K\' Nàng","type":"xa","slug":"xa-da-k\'-nang","name_with_type":"Xã Đạ K\' Nàng","path":"Xã Đạ K\' Nàng, Huyện Đam Rông, Tỉnh Lâm Đồng","path_with_type":"Xã Đạ K\' Nàng, Huyện Đam Rông, Tỉnh Lâm Đồng","code":"24889","parent_code":"674"},"24892":{"name":"Xã Mê Linh","type":"xa","slug":"xa-me-linh","name_with_type":"Xã Mê Linh","path":"Xã Mê Linh, Huyện Lâm Hà, Tỉnh Lâm Đồng","path_with_type":"Xã Mê Linh, Huyện Lâm Hà, Tỉnh Lâm Đồng","code":"24892","parent_code":"676"},"24895":{"name":"Xã Đạ Đờn","type":"xa","slug":"xa-da-don","name_with_type":"Xã Đạ Đờn","path":"Xã Đạ Đờn, Huyện Lâm Hà, Tỉnh Lâm Đồng","path_with_type":"Xã Đạ Đờn, Huyện Lâm Hà, Tỉnh Lâm Đồng","code":"24895","parent_code":"676"},"24898":{"name":"Xã Phúc Thọ","type":"xa","slug":"xa-phuc-tho","name_with_type":"Xã Phúc Thọ","path":"Xã Phúc Thọ, Huyện Lâm Hà, Tỉnh Lâm Đồng","path_with_type":"Xã Phúc Thọ, Huyện Lâm Hà, Tỉnh Lâm Đồng","code":"24898","parent_code":"676"},"24901":{"name":"Xã Đông Thanh","type":"xa","slug":"xa-dong-thanh","name_with_type":"Xã Đông Thanh","path":"Xã Đông Thanh, Huyện Lâm Hà, Tỉnh Lâm Đồng","path_with_type":"Xã Đông Thanh, Huyện Lâm Hà, Tỉnh Lâm Đồng","code":"24901","parent_code":"676"},"24904":{"name":"Xã Gia Lâm","type":"xa","slug":"xa-gia-lam","name_with_type":"Xã Gia Lâm","path":"Xã Gia Lâm, Huyện Lâm Hà, Tỉnh Lâm Đồng","path_with_type":"Xã Gia Lâm, Huyện Lâm Hà, Tỉnh Lâm Đồng","code":"24904","parent_code":"676"},"24907":{"name":"Xã Tân Thanh","type":"xa","slug":"xa-tan-thanh","name_with_type":"Xã Tân Thanh","path":"Xã Tân Thanh, Huyện Lâm Hà, Tỉnh Lâm Đồng","path_with_type":"Xã Tân Thanh, Huyện Lâm Hà, Tỉnh Lâm Đồng","code":"24907","parent_code":"676"},"24910":{"name":"Xã Tân Văn","type":"xa","slug":"xa-tan-van","name_with_type":"Xã Tân Văn","path":"Xã Tân Văn, Huyện Lâm Hà, Tỉnh Lâm Đồng","path_with_type":"Xã Tân Văn, Huyện Lâm Hà, Tỉnh Lâm Đồng","code":"24910","parent_code":"676"},"24913":{"name":"Xã Hoài Đức","type":"xa","slug":"xa-hoai-duc","name_with_type":"Xã Hoài Đức","path":"Xã Hoài Đức, Huyện Lâm Hà, Tỉnh Lâm Đồng","path_with_type":"Xã Hoài Đức, Huyện Lâm Hà, Tỉnh Lâm Đồng","code":"24913","parent_code":"676"},"24916":{"name":"Xã Tân Hà","type":"xa","slug":"xa-tan-ha","name_with_type":"Xã Tân Hà","path":"Xã Tân Hà, Huyện Lâm Hà, Tỉnh Lâm Đồng","path_with_type":"Xã Tân Hà, Huyện Lâm Hà, Tỉnh Lâm Đồng","code":"24916","parent_code":"676"},"24919":{"name":"Xã Liên Hà","type":"xa","slug":"xa-lien-ha","name_with_type":"Xã Liên Hà","path":"Xã Liên Hà, Huyện Lâm Hà, Tỉnh Lâm Đồng","path_with_type":"Xã Liên Hà, Huyện Lâm Hà, Tỉnh Lâm Đồng","code":"24919","parent_code":"676"},"24922":{"name":"Xã Đan Phượng","type":"xa","slug":"xa-dan-phuong","name_with_type":"Xã Đan Phượng","path":"Xã Đan Phượng, Huyện Lâm Hà, Tỉnh Lâm Đồng","path_with_type":"Xã Đan Phượng, Huyện Lâm Hà, Tỉnh Lâm Đồng","code":"24922","parent_code":"676"},"24925":{"name":"Xã Nam Hà","type":"xa","slug":"xa-nam-ha","name_with_type":"Xã Nam Hà","path":"Xã Nam Hà, Huyện Lâm Hà, Tỉnh Lâm Đồng","path_with_type":"Xã Nam Hà, Huyện Lâm Hà, Tỉnh Lâm Đồng","code":"24925","parent_code":"676"},"24928":{"name":"Thị trấn D\'Ran","type":"thi-tran","slug":"thi-tran-d\'ran","name_with_type":"Thị trấn D\'Ran","path":"Thị trấn D\'Ran, Huyện Đơn Dương, Tỉnh Lâm Đồng","path_with_type":"Thị trấn D\'Ran, Huyện Đơn Dương, Tỉnh Lâm Đồng","code":"24928","parent_code":"677"},"24931":{"name":"Thị trấn Thạnh Mỹ","type":"thi-tran","slug":"thi-tran-thanh-my","name_with_type":"Thị trấn Thạnh Mỹ","path":"Thị trấn Thạnh Mỹ, Huyện Đơn Dương, Tỉnh Lâm Đồng","path_with_type":"Thị trấn Thạnh Mỹ, Huyện Đơn Dương, Tỉnh Lâm Đồng","code":"24931","parent_code":"677"},"24934":{"name":"Xã Lạc Xuân","type":"xa","slug":"xa-lac-xuan","name_with_type":"Xã Lạc Xuân","path":"Xã Lạc Xuân, Huyện Đơn Dương, Tỉnh Lâm Đồng","path_with_type":"Xã Lạc Xuân, Huyện Đơn Dương, Tỉnh Lâm Đồng","code":"24934","parent_code":"677"},"24937":{"name":"Xã Đạ Ròn","type":"xa","slug":"xa-da-ron","name_with_type":"Xã Đạ Ròn","path":"Xã Đạ Ròn, Huyện Đơn Dương, Tỉnh Lâm Đồng","path_with_type":"Xã Đạ Ròn, Huyện Đơn Dương, Tỉnh Lâm Đồng","code":"24937","parent_code":"677"},"24940":{"name":"Xã Lạc Lâm","type":"xa","slug":"xa-lac-lam","name_with_type":"Xã Lạc Lâm","path":"Xã Lạc Lâm, Huyện Đơn Dương, Tỉnh Lâm Đồng","path_with_type":"Xã Lạc Lâm, Huyện Đơn Dương, Tỉnh Lâm Đồng","code":"24940","parent_code":"677"},"24943":{"name":"Xã Ka Đô","type":"xa","slug":"xa-ka-do","name_with_type":"Xã Ka Đô","path":"Xã Ka Đô, Huyện Đơn Dương, Tỉnh Lâm Đồng","path_with_type":"Xã Ka Đô, Huyện Đơn Dương, Tỉnh Lâm Đồng","code":"24943","parent_code":"677"},"24949":{"name":"Xã Ka Đơn","type":"xa","slug":"xa-ka-don","name_with_type":"Xã Ka Đơn","path":"Xã Ka Đơn, Huyện Đơn Dương, Tỉnh Lâm Đồng","path_with_type":"Xã Ka Đơn, Huyện Đơn Dương, Tỉnh Lâm Đồng","code":"24949","parent_code":"677"},"24952":{"name":"Xã Tu Tra","type":"xa","slug":"xa-tu-tra","name_with_type":"Xã Tu Tra","path":"Xã Tu Tra, Huyện Đơn Dương, Tỉnh Lâm Đồng","path_with_type":"Xã Tu Tra, Huyện Đơn Dương, Tỉnh Lâm Đồng","code":"24952","parent_code":"677"},"24955":{"name":"Xã Quảng Lập","type":"xa","slug":"xa-quang-lap","name_with_type":"Xã Quảng Lập","path":"Xã Quảng Lập, Huyện Đơn Dương, Tỉnh Lâm Đồng","path_with_type":"Xã Quảng Lập, Huyện Đơn Dương, Tỉnh Lâm Đồng","code":"24955","parent_code":"677"},"24958":{"name":"Thị trấn Liên Nghĩa","type":"thi-tran","slug":"thi-tran-lien-nghia","name_with_type":"Thị trấn Liên Nghĩa","path":"Thị trấn Liên Nghĩa, Huyện Đức Trọng, Tỉnh Lâm Đồng","path_with_type":"Thị trấn Liên Nghĩa, Huyện Đức Trọng, Tỉnh Lâm Đồng","code":"24958","parent_code":"678"},"24961":{"name":"Xã Hiệp An","type":"xa","slug":"xa-hiep-an","name_with_type":"Xã Hiệp An","path":"Xã Hiệp An, Huyện Đức Trọng, Tỉnh Lâm Đồng","path_with_type":"Xã Hiệp An, Huyện Đức Trọng, Tỉnh Lâm Đồng","code":"24961","parent_code":"678"},"24964":{"name":"Xã Liên Hiệp","type":"xa","slug":"xa-lien-hiep","name_with_type":"Xã Liên Hiệp","path":"Xã Liên Hiệp, Huyện Đức Trọng, Tỉnh Lâm Đồng","path_with_type":"Xã Liên Hiệp, Huyện Đức Trọng, Tỉnh Lâm Đồng","code":"24964","parent_code":"678"},"24967":{"name":"Xã Hiệp Thạnh","type":"xa","slug":"xa-hiep-thanh","name_with_type":"Xã Hiệp Thạnh","path":"Xã Hiệp Thạnh, Huyện Đức Trọng, Tỉnh Lâm Đồng","path_with_type":"Xã Hiệp Thạnh, Huyện Đức Trọng, Tỉnh Lâm Đồng","code":"24967","parent_code":"678"},"24970":{"name":"Xã Bình Thạnh","type":"xa","slug":"xa-binh-thanh","name_with_type":"Xã Bình Thạnh","path":"Xã Bình Thạnh, Huyện Đức Trọng, Tỉnh Lâm Đồng","path_with_type":"Xã Bình Thạnh, Huyện Đức Trọng, Tỉnh Lâm Đồng","code":"24970","parent_code":"678"},"24973":{"name":"Xã N\'Thol Hạ","type":"xa","slug":"xa-n\'thol-ha","name_with_type":"Xã N\'Thol Hạ","path":"Xã N\'Thol Hạ, Huyện Đức Trọng, Tỉnh Lâm Đồng","path_with_type":"Xã N\'Thol Hạ, Huyện Đức Trọng, Tỉnh Lâm Đồng","code":"24973","parent_code":"678"},"24976":{"name":"Xã Tân Hội","type":"xa","slug":"xa-tan-hoi","name_with_type":"Xã Tân Hội","path":"Xã Tân Hội, Huyện Đức Trọng, Tỉnh Lâm Đồng","path_with_type":"Xã Tân Hội, Huyện Đức Trọng, Tỉnh Lâm Đồng","code":"24976","parent_code":"678"},"24979":{"name":"Xã Tân Thành","type":"xa","slug":"xa-tan-thanh","name_with_type":"Xã Tân Thành","path":"Xã Tân Thành, Huyện Đức Trọng, Tỉnh Lâm Đồng","path_with_type":"Xã Tân Thành, Huyện Đức Trọng, Tỉnh Lâm Đồng","code":"24979","parent_code":"678"},"24982":{"name":"Xã Phú Hội","type":"xa","slug":"xa-phu-hoi","name_with_type":"Xã Phú Hội","path":"Xã Phú Hội, Huyện Đức Trọng, Tỉnh Lâm Đồng","path_with_type":"Xã Phú Hội, Huyện Đức Trọng, Tỉnh Lâm Đồng","code":"24982","parent_code":"678"},"24985":{"name":"Xã Ninh Gia","type":"xa","slug":"xa-ninh-gia","name_with_type":"Xã Ninh Gia","path":"Xã Ninh Gia, Huyện Đức Trọng, Tỉnh Lâm Đồng","path_with_type":"Xã Ninh Gia, Huyện Đức Trọng, Tỉnh Lâm Đồng","code":"24985","parent_code":"678"},"24988":{"name":"Xã Tà Năng","type":"xa","slug":"xa-ta-nang","name_with_type":"Xã Tà Năng","path":"Xã Tà Năng, Huyện Đức Trọng, Tỉnh Lâm Đồng","path_with_type":"Xã Tà Năng, Huyện Đức Trọng, Tỉnh Lâm Đồng","code":"24988","parent_code":"678"},"24989":{"name":"Xã Đa Quyn","type":"xa","slug":"xa-da-quyn","name_with_type":"Xã Đa Quyn","path":"Xã Đa Quyn, Huyện Đức Trọng, Tỉnh Lâm Đồng","path_with_type":"Xã Đa Quyn, Huyện Đức Trọng, Tỉnh Lâm Đồng","code":"24989","parent_code":"678"},"24991":{"name":"Xã Tà Hine","type":"xa","slug":"xa-ta-hine","name_with_type":"Xã Tà Hine","path":"Xã Tà Hine, Huyện Đức Trọng, Tỉnh Lâm Đồng","path_with_type":"Xã Tà Hine, Huyện Đức Trọng, Tỉnh Lâm Đồng","code":"24991","parent_code":"678"},"24994":{"name":"Xã Đà Loan","type":"xa","slug":"xa-da-loan","name_with_type":"Xã Đà Loan","path":"Xã Đà Loan, Huyện Đức Trọng, Tỉnh Lâm Đồng","path_with_type":"Xã Đà Loan, Huyện Đức Trọng, Tỉnh Lâm Đồng","code":"24994","parent_code":"678"},"24997":{"name":"Xã Ninh Loan","type":"xa","slug":"xa-ninh-loan","name_with_type":"Xã Ninh Loan","path":"Xã Ninh Loan, Huyện Đức Trọng, Tỉnh Lâm Đồng","path_with_type":"Xã Ninh Loan, Huyện Đức Trọng, Tỉnh Lâm Đồng","code":"24997","parent_code":"678"},"25000":{"name":"Thị trấn Di Linh","type":"thi-tran","slug":"thi-tran-di-linh","name_with_type":"Thị trấn Di Linh","path":"Thị trấn Di Linh, Huyện Di Linh, Tỉnh Lâm Đồng","path_with_type":"Thị trấn Di Linh, Huyện Di Linh, Tỉnh Lâm Đồng","code":"25000","parent_code":"679"},"25003":{"name":"Xã Đinh Trang Thượng","type":"xa","slug":"xa-dinh-trang-thuong","name_with_type":"Xã Đinh Trang Thượng","path":"Xã Đinh Trang Thượng, Huyện Di Linh, Tỉnh Lâm Đồng","path_with_type":"Xã Đinh Trang Thượng, Huyện Di Linh, Tỉnh Lâm Đồng","code":"25003","parent_code":"679"},"25006":{"name":"Xã Tân Thượng","type":"xa","slug":"xa-tan-thuong","name_with_type":"Xã Tân Thượng","path":"Xã Tân Thượng, Huyện Di Linh, Tỉnh Lâm Đồng","path_with_type":"Xã Tân Thượng, Huyện Di Linh, Tỉnh Lâm Đồng","code":"25006","parent_code":"679"},"25007":{"name":"Xã Tân Lâm","type":"xa","slug":"xa-tan-lam","name_with_type":"Xã Tân Lâm","path":"Xã Tân Lâm, Huyện Di Linh, Tỉnh Lâm Đồng","path_with_type":"Xã Tân Lâm, Huyện Di Linh, Tỉnh Lâm Đồng","code":"25007","parent_code":"679"},"25009":{"name":"Xã Tân Châu","type":"xa","slug":"xa-tan-chau","name_with_type":"Xã Tân Châu","path":"Xã Tân Châu, Huyện Di Linh, Tỉnh Lâm Đồng","path_with_type":"Xã Tân Châu, Huyện Di Linh, Tỉnh Lâm Đồng","code":"25009","parent_code":"679"},"25012":{"name":"Xã Tân Nghĩa","type":"xa","slug":"xa-tan-nghia","name_with_type":"Xã Tân Nghĩa","path":"Xã Tân Nghĩa, Huyện Di Linh, Tỉnh Lâm Đồng","path_with_type":"Xã Tân Nghĩa, Huyện Di Linh, Tỉnh Lâm Đồng","code":"25012","parent_code":"679"},"25015":{"name":"Xã Gia Hiệp","type":"xa","slug":"xa-gia-hiep","name_with_type":"Xã Gia Hiệp","path":"Xã Gia Hiệp, Huyện Di Linh, Tỉnh Lâm Đồng","path_with_type":"Xã Gia Hiệp, Huyện Di Linh, Tỉnh Lâm Đồng","code":"25015","parent_code":"679"},"25018":{"name":"Xã Đinh Lạc","type":"xa","slug":"xa-dinh-lac","name_with_type":"Xã Đinh Lạc","path":"Xã Đinh Lạc, Huyện Di Linh, Tỉnh Lâm Đồng","path_with_type":"Xã Đinh Lạc, Huyện Di Linh, Tỉnh Lâm Đồng","code":"25018","parent_code":"679"},"25021":{"name":"Xã Tam Bố","type":"xa","slug":"xa-tam-bo","name_with_type":"Xã Tam Bố","path":"Xã Tam Bố, Huyện Di Linh, Tỉnh Lâm Đồng","path_with_type":"Xã Tam Bố, Huyện Di Linh, Tỉnh Lâm Đồng","code":"25021","parent_code":"679"},"25024":{"name":"Xã Đinh Trang Hòa","type":"xa","slug":"xa-dinh-trang-hoa","name_with_type":"Xã Đinh Trang Hòa","path":"Xã Đinh Trang Hòa, Huyện Di Linh, Tỉnh Lâm Đồng","path_with_type":"Xã Đinh Trang Hòa, Huyện Di Linh, Tỉnh Lâm Đồng","code":"25024","parent_code":"679"},"25027":{"name":"Xã Liên Đầm","type":"xa","slug":"xa-lien-dam","name_with_type":"Xã Liên Đầm","path":"Xã Liên Đầm, Huyện Di Linh, Tỉnh Lâm Đồng","path_with_type":"Xã Liên Đầm, Huyện Di Linh, Tỉnh Lâm Đồng","code":"25027","parent_code":"679"},"25030":{"name":"Xã Gung Ré","type":"xa","slug":"xa-gung-re","name_with_type":"Xã Gung Ré","path":"Xã Gung Ré, Huyện Di Linh, Tỉnh Lâm Đồng","path_with_type":"Xã Gung Ré, Huyện Di Linh, Tỉnh Lâm Đồng","code":"25030","parent_code":"679"},"25033":{"name":"Xã Bảo Thuận","type":"xa","slug":"xa-bao-thuan","name_with_type":"Xã Bảo Thuận","path":"Xã Bảo Thuận, Huyện Di Linh, Tỉnh Lâm Đồng","path_with_type":"Xã Bảo Thuận, Huyện Di Linh, Tỉnh Lâm Đồng","code":"25033","parent_code":"679"},"25036":{"name":"Xã Hòa Ninh","type":"xa","slug":"xa-hoa-ninh","name_with_type":"Xã Hòa Ninh","path":"Xã Hòa Ninh, Huyện Di Linh, Tỉnh Lâm Đồng","path_with_type":"Xã Hòa Ninh, Huyện Di Linh, Tỉnh Lâm Đồng","code":"25036","parent_code":"679"},"25039":{"name":"Xã Hòa Trung","type":"xa","slug":"xa-hoa-trung","name_with_type":"Xã Hòa Trung","path":"Xã Hòa Trung, Huyện Di Linh, Tỉnh Lâm Đồng","path_with_type":"Xã Hòa Trung, Huyện Di Linh, Tỉnh Lâm Đồng","code":"25039","parent_code":"679"},"25042":{"name":"Xã Hòa Nam","type":"xa","slug":"xa-hoa-nam","name_with_type":"Xã Hòa Nam","path":"Xã Hòa Nam, Huyện Di Linh, Tỉnh Lâm Đồng","path_with_type":"Xã Hòa Nam, Huyện Di Linh, Tỉnh Lâm Đồng","code":"25042","parent_code":"679"},"25045":{"name":"Xã Hòa Bắc","type":"xa","slug":"xa-hoa-bac","name_with_type":"Xã Hòa Bắc","path":"Xã Hòa Bắc, Huyện Di Linh, Tỉnh Lâm Đồng","path_with_type":"Xã Hòa Bắc, Huyện Di Linh, Tỉnh Lâm Đồng","code":"25045","parent_code":"679"},"25048":{"name":"Xã Sơn Điền","type":"xa","slug":"xa-son-dien","name_with_type":"Xã Sơn Điền","path":"Xã Sơn Điền, Huyện Di Linh, Tỉnh Lâm Đồng","path_with_type":"Xã Sơn Điền, Huyện Di Linh, Tỉnh Lâm Đồng","code":"25048","parent_code":"679"},"25051":{"name":"Xã Gia Bắc","type":"xa","slug":"xa-gia-bac","name_with_type":"Xã Gia Bắc","path":"Xã Gia Bắc, Huyện Di Linh, Tỉnh Lâm Đồng","path_with_type":"Xã Gia Bắc, Huyện Di Linh, Tỉnh Lâm Đồng","code":"25051","parent_code":"679"},"25054":{"name":"Thị trấn Lộc Thắng","type":"thi-tran","slug":"thi-tran-loc-thang","name_with_type":"Thị trấn Lộc Thắng","path":"Thị trấn Lộc Thắng, Huyện Bảo Lâm, Tỉnh Lâm Đồng","path_with_type":"Thị trấn Lộc Thắng, Huyện Bảo Lâm, Tỉnh Lâm Đồng","code":"25054","parent_code":"680"},"25057":{"name":"Xã Lộc Bảo","type":"xa","slug":"xa-loc-bao","name_with_type":"Xã Lộc Bảo","path":"Xã Lộc Bảo, Huyện Bảo Lâm, Tỉnh Lâm Đồng","path_with_type":"Xã Lộc Bảo, Huyện Bảo Lâm, Tỉnh Lâm Đồng","code":"25057","parent_code":"680"},"25060":{"name":"Xã Lộc Lâm","type":"xa","slug":"xa-loc-lam","name_with_type":"Xã Lộc Lâm","path":"Xã Lộc Lâm, Huyện Bảo Lâm, Tỉnh Lâm Đồng","path_with_type":"Xã Lộc Lâm, Huyện Bảo Lâm, Tỉnh Lâm Đồng","code":"25060","parent_code":"680"},"25063":{"name":"Xã Lộc Phú","type":"xa","slug":"xa-loc-phu","name_with_type":"Xã Lộc Phú","path":"Xã Lộc Phú, Huyện Bảo Lâm, Tỉnh Lâm Đồng","path_with_type":"Xã Lộc Phú, Huyện Bảo Lâm, Tỉnh Lâm Đồng","code":"25063","parent_code":"680"},"25066":{"name":"Xã Lộc Bắc","type":"xa","slug":"xa-loc-bac","name_with_type":"Xã Lộc Bắc","path":"Xã Lộc Bắc, Huyện Bảo Lâm, Tỉnh Lâm Đồng","path_with_type":"Xã Lộc Bắc, Huyện Bảo Lâm, Tỉnh Lâm Đồng","code":"25066","parent_code":"680"},"25069":{"name":"Xã B\' Lá","type":"xa","slug":"xa-b\'-la","name_with_type":"Xã B\' Lá","path":"Xã B\' Lá, Huyện Bảo Lâm, Tỉnh Lâm Đồng","path_with_type":"Xã B\' Lá, Huyện Bảo Lâm, Tỉnh Lâm Đồng","code":"25069","parent_code":"680"},"25072":{"name":"Xã Lộc Ngãi","type":"xa","slug":"xa-loc-ngai","name_with_type":"Xã Lộc Ngãi","path":"Xã Lộc Ngãi, Huyện Bảo Lâm, Tỉnh Lâm Đồng","path_with_type":"Xã Lộc Ngãi, Huyện Bảo Lâm, Tỉnh Lâm Đồng","code":"25072","parent_code":"680"},"25075":{"name":"Xã Lộc Quảng","type":"xa","slug":"xa-loc-quang","name_with_type":"Xã Lộc Quảng","path":"Xã Lộc Quảng, Huyện Bảo Lâm, Tỉnh Lâm Đồng","path_with_type":"Xã Lộc Quảng, Huyện Bảo Lâm, Tỉnh Lâm Đồng","code":"25075","parent_code":"680"},"25078":{"name":"Xã Lộc Tân","type":"xa","slug":"xa-loc-tan","name_with_type":"Xã Lộc Tân","path":"Xã Lộc Tân, Huyện Bảo Lâm, Tỉnh Lâm Đồng","path_with_type":"Xã Lộc Tân, Huyện Bảo Lâm, Tỉnh Lâm Đồng","code":"25078","parent_code":"680"},"25081":{"name":"Xã Lộc Đức","type":"xa","slug":"xa-loc-duc","name_with_type":"Xã Lộc Đức","path":"Xã Lộc Đức, Huyện Bảo Lâm, Tỉnh Lâm Đồng","path_with_type":"Xã Lộc Đức, Huyện Bảo Lâm, Tỉnh Lâm Đồng","code":"25081","parent_code":"680"},"25084":{"name":"Xã Lộc An","type":"xa","slug":"xa-loc-an","name_with_type":"Xã Lộc An","path":"Xã Lộc An, Huyện Bảo Lâm, Tỉnh Lâm Đồng","path_with_type":"Xã Lộc An, Huyện Bảo Lâm, Tỉnh Lâm Đồng","code":"25084","parent_code":"680"},"25087":{"name":"Xã Tân Lạc","type":"xa","slug":"xa-tan-lac","name_with_type":"Xã Tân Lạc","path":"Xã Tân Lạc, Huyện Bảo Lâm, Tỉnh Lâm Đồng","path_with_type":"Xã Tân Lạc, Huyện Bảo Lâm, Tỉnh Lâm Đồng","code":"25087","parent_code":"680"},"25090":{"name":"Xã Lộc Thành","type":"xa","slug":"xa-loc-thanh","name_with_type":"Xã Lộc Thành","path":"Xã Lộc Thành, Huyện Bảo Lâm, Tỉnh Lâm Đồng","path_with_type":"Xã Lộc Thành, Huyện Bảo Lâm, Tỉnh Lâm Đồng","code":"25090","parent_code":"680"},"25093":{"name":"Xã Lộc Nam","type":"xa","slug":"xa-loc-nam","name_with_type":"Xã Lộc Nam","path":"Xã Lộc Nam, Huyện Bảo Lâm, Tỉnh Lâm Đồng","path_with_type":"Xã Lộc Nam, Huyện Bảo Lâm, Tỉnh Lâm Đồng","code":"25093","parent_code":"680"},"25096":{"name":"Thị trấn Đạ M\'ri","type":"thi-tran","slug":"thi-tran-da-m\'ri","name_with_type":"Thị trấn Đạ M\'ri","path":"Thị trấn Đạ M\'ri, Huyện Đạ Huoai, Tỉnh Lâm Đồng","path_with_type":"Thị trấn Đạ M\'ri, Huyện Đạ Huoai, Tỉnh Lâm Đồng","code":"25096","parent_code":"682"},"25099":{"name":"Thị trấn Ma Đa Guôi","type":"thi-tran","slug":"thi-tran-ma-da-guoi","name_with_type":"Thị trấn Ma Đa Guôi","path":"Thị trấn Ma Đa Guôi, Huyện Đạ Huoai, Tỉnh Lâm Đồng","path_with_type":"Thị trấn Ma Đa Guôi, Huyện Đạ Huoai, Tỉnh Lâm Đồng","code":"25099","parent_code":"682"},"25102":{"name":"Xã Đạ M\'ri","type":"xa","slug":"xa-da-m\'ri","name_with_type":"Xã Đạ M\'ri","path":"Xã Đạ M\'ri, Huyện Đạ Huoai, Tỉnh Lâm Đồng","path_with_type":"Xã Đạ M\'ri, Huyện Đạ Huoai, Tỉnh Lâm Đồng","code":"25102","parent_code":"682"},"25105":{"name":"Xã Hà Lâm","type":"xa","slug":"xa-ha-lam","name_with_type":"Xã Hà Lâm","path":"Xã Hà Lâm, Huyện Đạ Huoai, Tỉnh Lâm Đồng","path_with_type":"Xã Hà Lâm, Huyện Đạ Huoai, Tỉnh Lâm Đồng","code":"25105","parent_code":"682"},"25111":{"name":"Xã Đạ Oai","type":"xa","slug":"xa-da-oai","name_with_type":"Xã Đạ Oai","path":"Xã Đạ Oai, Huyện Đạ Huoai, Tỉnh Lâm Đồng","path_with_type":"Xã Đạ Oai, Huyện Đạ Huoai, Tỉnh Lâm Đồng","code":"25111","parent_code":"682"},"25114":{"name":"Xã Bà Gia","type":"xa","slug":"xa-ba-gia","name_with_type":"Xã Bà Gia","path":"Xã Bà Gia, Huyện Đạ Huoai, Tỉnh Lâm Đồng","path_with_type":"Xã Bà Gia, Huyện Đạ Huoai, Tỉnh Lâm Đồng","code":"25114","parent_code":"682"},"25117":{"name":"Xã Ma Đa Guôi","type":"xa","slug":"xa-ma-da-guoi","name_with_type":"Xã Ma Đa Guôi","path":"Xã Ma Đa Guôi, Huyện Đạ Huoai, Tỉnh Lâm Đồng","path_with_type":"Xã Ma Đa Guôi, Huyện Đạ Huoai, Tỉnh Lâm Đồng","code":"25117","parent_code":"682"},"25126":{"name":"Thị trấn Đạ Tẻh","type":"thi-tran","slug":"thi-tran-da-teh","name_with_type":"Thị trấn Đạ Tẻh","path":"Thị trấn Đạ Tẻh, Huyện Đạ Huoai, Tỉnh Lâm Đồng","path_with_type":"Thị trấn Đạ Tẻh, Huyện Đạ Huoai, Tỉnh Lâm Đồng","code":"25126","parent_code":"682"},"25129":{"name":"Xã An Nhơn","type":"xa","slug":"xa-an-nhon","name_with_type":"Xã An Nhơn","path":"Xã An Nhơn, Huyện Đạ Huoai, Tỉnh Lâm Đồng","path_with_type":"Xã An Nhơn, Huyện Đạ Huoai, Tỉnh Lâm Đồng","code":"25129","parent_code":"682"},"25132":{"name":"Xã Quốc Oai","type":"xa","slug":"xa-quoc-oai","name_with_type":"Xã Quốc Oai","path":"Xã Quốc Oai, Huyện Đạ Huoai, Tỉnh Lâm Đồng","path_with_type":"Xã Quốc Oai, Huyện Đạ Huoai, Tỉnh Lâm Đồng","code":"25132","parent_code":"682"},"25135":{"name":"Xã Mỹ Đức","type":"xa","slug":"xa-my-duc","name_with_type":"Xã Mỹ Đức","path":"Xã Mỹ Đức, Huyện Đạ Huoai, Tỉnh Lâm Đồng","path_with_type":"Xã Mỹ Đức, Huyện Đạ Huoai, Tỉnh Lâm Đồng","code":"25135","parent_code":"682"},"25138":{"name":"Xã Quảng Trị","type":"xa","slug":"xa-quang-tri","name_with_type":"Xã Quảng Trị","path":"Xã Quảng Trị, Huyện Đạ Huoai, Tỉnh Lâm Đồng","path_with_type":"Xã Quảng Trị, Huyện Đạ Huoai, Tỉnh Lâm Đồng","code":"25138","parent_code":"682"},"25141":{"name":"Xã Đạ Lây","type":"xa","slug":"xa-da-lay","name_with_type":"Xã Đạ Lây","path":"Xã Đạ Lây, Huyện Đạ Huoai, Tỉnh Lâm Đồng","path_with_type":"Xã Đạ Lây, Huyện Đạ Huoai, Tỉnh Lâm Đồng","code":"25141","parent_code":"682"},"25153":{"name":"Xã Đạ Kho","type":"xa","slug":"xa-da-kho","name_with_type":"Xã Đạ Kho","path":"Xã Đạ Kho, Huyện Đạ Huoai, Tỉnh Lâm Đồng","path_with_type":"Xã Đạ Kho, Huyện Đạ Huoai, Tỉnh Lâm Đồng","code":"25153","parent_code":"682"},"25156":{"name":"Xã Đạ Pal","type":"xa","slug":"xa-da-pal","name_with_type":"Xã Đạ Pal","path":"Xã Đạ Pal, Huyện Đạ Huoai, Tỉnh Lâm Đồng","path_with_type":"Xã Đạ Pal, Huyện Đạ Huoai, Tỉnh Lâm Đồng","code":"25156","parent_code":"682"},"25159":{"name":"Thị trấn Cát Tiên","type":"thi-tran","slug":"thi-tran-cat-tien","name_with_type":"Thị trấn Cát Tiên","path":"Thị trấn Cát Tiên, Huyện Đạ Huoai, Tỉnh Lâm Đồng","path_with_type":"Thị trấn Cát Tiên, Huyện Đạ Huoai, Tỉnh Lâm Đồng","code":"25159","parent_code":"682"},"25162":{"name":"Xã Tiên Hoàng","type":"xa","slug":"xa-tien-hoang","name_with_type":"Xã Tiên Hoàng","path":"Xã Tiên Hoàng, Huyện Đạ Huoai, Tỉnh Lâm Đồng","path_with_type":"Xã Tiên Hoàng, Huyện Đạ Huoai, Tỉnh Lâm Đồng","code":"25162","parent_code":"682"},"25165":{"name":"Xã Phước Cát 2","type":"xa","slug":"xa-phuoc-cat-2","name_with_type":"Xã Phước Cát 2","path":"Xã Phước Cát 2, Huyện Đạ Huoai, Tỉnh Lâm Đồng","path_with_type":"Xã Phước Cát 2, Huyện Đạ Huoai, Tỉnh Lâm Đồng","code":"25165","parent_code":"682"},"25168":{"name":"Xã Gia Viễn","type":"xa","slug":"xa-gia-vien","name_with_type":"Xã Gia Viễn","path":"Xã Gia Viễn, Huyện Đạ Huoai, Tỉnh Lâm Đồng","path_with_type":"Xã Gia Viễn, Huyện Đạ Huoai, Tỉnh Lâm Đồng","code":"25168","parent_code":"682"},"25171":{"name":"Xã Nam Ninh","type":"xa","slug":"xa-nam-ninh","name_with_type":"Xã Nam Ninh","path":"Xã Nam Ninh, Huyện Đạ Huoai, Tỉnh Lâm Đồng","path_with_type":"Xã Nam Ninh, Huyện Đạ Huoai, Tỉnh Lâm Đồng","code":"25171","parent_code":"682"},"25174":{"name":"Xã Mỹ Lâm","type":"xa","slug":"xa-my-lam","name_with_type":"Xã Mỹ Lâm","path":"Xã Mỹ Lâm, Huyện Đạ Huoai, Tỉnh Lâm Đồng","path_with_type":"Xã Mỹ Lâm, Huyện Đạ Huoai, Tỉnh Lâm Đồng","code":"25174","parent_code":"682"},"25177":{"name":"Xã Tư Nghĩa","type":"xa","slug":"xa-tu-nghia","name_with_type":"Xã Tư Nghĩa","path":"Xã Tư Nghĩa, Huyện Đạ Huoai, Tỉnh Lâm Đồng","path_with_type":"Xã Tư Nghĩa, Huyện Đạ Huoai, Tỉnh Lâm Đồng","code":"25177","parent_code":"682"},"25180":{"name":"Thị trấn Phước Cát ","type":"thi-tran","slug":"thi-tran-phuoc-cat-","name_with_type":"Thị trấn Phước Cát ","path":"Thị trấn Phước Cát , Huyện Đạ Huoai, Tỉnh Lâm Đồng","path_with_type":"Thị trấn Phước Cát , Huyện Đạ Huoai, Tỉnh Lâm Đồng","code":"25180","parent_code":"682"},"25183":{"name":"Xã Đức Phổ","type":"xa","slug":"xa-duc-pho","name_with_type":"Xã Đức Phổ","path":"Xã Đức Phổ, Huyện Đạ Huoai, Tỉnh Lâm Đồng","path_with_type":"Xã Đức Phổ, Huyện Đạ Huoai, Tỉnh Lâm Đồng","code":"25183","parent_code":"682"},"25186":{"name":"Xã Phù Mỹ","type":"xa","slug":"xa-phu-my","name_with_type":"Xã Phù Mỹ","path":"Xã Phù Mỹ, Huyện Đạ Huoai, Tỉnh Lâm Đồng","path_with_type":"Xã Phù Mỹ, Huyện Đạ Huoai, Tỉnh Lâm Đồng","code":"25186","parent_code":"682"},"25189":{"name":"Xã Quảng Ngãi","type":"xa","slug":"xa-quang-ngai","name_with_type":"Xã Quảng Ngãi","path":"Xã Quảng Ngãi, Huyện Đạ Huoai, Tỉnh Lâm Đồng","path_with_type":"Xã Quảng Ngãi, Huyện Đạ Huoai, Tỉnh Lâm Đồng","code":"25189","parent_code":"682"},"25192":{"name":"Xã Đồng Nai Thượng","type":"xa","slug":"xa-dong-nai-thuong","name_with_type":"Xã Đồng Nai Thượng","path":"Xã Đồng Nai Thượng, Huyện Đạ Huoai, Tỉnh Lâm Đồng","path_with_type":"Xã Đồng Nai Thượng, Huyện Đạ Huoai, Tỉnh Lâm Đồng","code":"25192","parent_code":"682"},"25195":{"name":"Phường Tân Phú","type":"phuong","slug":"phuong-tan-phu","name_with_type":"Phường Tân Phú","path":"Phường Tân Phú, Thành phố Đồng Xoài, Tỉnh Bình Phước","path_with_type":"Phường Tân Phú, Thành phố Đồng Xoài, Tỉnh Bình Phước","code":"25195","parent_code":"689"},"25198":{"name":"Phường Tân Đồng","type":"phuong","slug":"phuong-tan-dong","name_with_type":"Phường Tân Đồng","path":"Phường Tân Đồng, Thành phố Đồng Xoài, Tỉnh Bình Phước","path_with_type":"Phường Tân Đồng, Thành phố Đồng Xoài, Tỉnh Bình Phước","code":"25198","parent_code":"689"},"25201":{"name":"Phường Tân Bình","type":"phuong","slug":"phuong-tan-binh","name_with_type":"Phường Tân Bình","path":"Phường Tân Bình, Thành phố Đồng Xoài, Tỉnh Bình Phước","path_with_type":"Phường Tân Bình, Thành phố Đồng Xoài, Tỉnh Bình Phước","code":"25201","parent_code":"689"},"25204":{"name":"Phường Tân Xuân","type":"phuong","slug":"phuong-tan-xuan","name_with_type":"Phường Tân Xuân","path":"Phường Tân Xuân, Thành phố Đồng Xoài, Tỉnh Bình Phước","path_with_type":"Phường Tân Xuân, Thành phố Đồng Xoài, Tỉnh Bình Phước","code":"25204","parent_code":"689"},"25205":{"name":"Phường Tân Thiện","type":"phuong","slug":"phuong-tan-thien","name_with_type":"Phường Tân Thiện","path":"Phường Tân Thiện, Thành phố Đồng Xoài, Tỉnh Bình Phước","path_with_type":"Phường Tân Thiện, Thành phố Đồng Xoài, Tỉnh Bình Phước","code":"25205","parent_code":"689"},"25207":{"name":"Xã Tân Thành","type":"xa","slug":"xa-tan-thanh","name_with_type":"Xã Tân Thành","path":"Xã Tân Thành, Thành phố Đồng Xoài, Tỉnh Bình Phước","path_with_type":"Xã Tân Thành, Thành phố Đồng Xoài, Tỉnh Bình Phước","code":"25207","parent_code":"689"},"25210":{"name":"Phường Tiến Thành","type":"phuong","slug":"phuong-tien-thanh","name_with_type":"Phường Tiến Thành","path":"Phường Tiến Thành, Thành phố Đồng Xoài, Tỉnh Bình Phước","path_with_type":"Phường Tiến Thành, Thành phố Đồng Xoài, Tỉnh Bình Phước","code":"25210","parent_code":"689"},"25213":{"name":"Xã Tiến Hưng","type":"xa","slug":"xa-tien-hung","name_with_type":"Xã Tiến Hưng","path":"Xã Tiến Hưng, Thành phố Đồng Xoài, Tỉnh Bình Phước","path_with_type":"Xã Tiến Hưng, Thành phố Đồng Xoài, Tỉnh Bình Phước","code":"25213","parent_code":"689"},"25216":{"name":"Phường Thác Mơ","type":"phuong","slug":"phuong-thac-mo","name_with_type":"Phường Thác Mơ","path":"Phường Thác Mơ, Thị xã Phước Long, Tỉnh Bình Phước","path_with_type":"Phường Thác Mơ, Thị xã Phước Long, Tỉnh Bình Phước","code":"25216","parent_code":"688"},"25217":{"name":"Phường Long Thủy","type":"phuong","slug":"phuong-long-thuy","name_with_type":"Phường Long Thủy","path":"Phường Long Thủy, Thị xã Phước Long, Tỉnh Bình Phước","path_with_type":"Phường Long Thủy, Thị xã Phước Long, Tỉnh Bình Phước","code":"25217","parent_code":"688"},"25219":{"name":"Phường Phước Bình","type":"phuong","slug":"phuong-phuoc-binh","name_with_type":"Phường Phước Bình","path":"Phường Phước Bình, Thị xã Phước Long, Tỉnh Bình Phước","path_with_type":"Phường Phước Bình, Thị xã Phước Long, Tỉnh Bình Phước","code":"25219","parent_code":"688"},"25220":{"name":"Phường Long Phước","type":"phuong","slug":"phuong-long-phuoc","name_with_type":"Phường Long Phước","path":"Phường Long Phước, Thị xã Phước Long, Tỉnh Bình Phước","path_with_type":"Phường Long Phước, Thị xã Phước Long, Tỉnh Bình Phước","code":"25220","parent_code":"688"},"25222":{"name":"Xã Bù Gia Mập","type":"xa","slug":"xa-bu-gia-map","name_with_type":"Xã Bù Gia Mập","path":"Xã Bù Gia Mập, Huyện Bù Gia Mập, Tỉnh Bình Phước","path_with_type":"Xã Bù Gia Mập, Huyện Bù Gia Mập, Tỉnh Bình Phước","code":"25222","parent_code":"691"},"25225":{"name":"Xã Đak Ơ","type":"xa","slug":"xa-dak-o","name_with_type":"Xã Đak Ơ","path":"Xã Đak Ơ, Huyện Bù Gia Mập, Tỉnh Bình Phước","path_with_type":"Xã Đak Ơ, Huyện Bù Gia Mập, Tỉnh Bình Phước","code":"25225","parent_code":"691"},"25228":{"name":"Xã Đức Hạnh","type":"xa","slug":"xa-duc-hanh","name_with_type":"Xã Đức Hạnh","path":"Xã Đức Hạnh, Huyện Bù Gia Mập, Tỉnh Bình Phước","path_with_type":"Xã Đức Hạnh, Huyện Bù Gia Mập, Tỉnh Bình Phước","code":"25228","parent_code":"691"},"25229":{"name":"Xã Phú Văn","type":"xa","slug":"xa-phu-van","name_with_type":"Xã Phú Văn","path":"Xã Phú Văn, Huyện Bù Gia Mập, Tỉnh Bình Phước","path_with_type":"Xã Phú Văn, Huyện Bù Gia Mập, Tỉnh Bình Phước","code":"25229","parent_code":"691"},"25231":{"name":"Xã Đa Kia","type":"xa","slug":"xa-da-kia","name_with_type":"Xã Đa Kia","path":"Xã Đa Kia, Huyện Bù Gia Mập, Tỉnh Bình Phước","path_with_type":"Xã Đa Kia, Huyện Bù Gia Mập, Tỉnh Bình Phước","code":"25231","parent_code":"691"},"25232":{"name":"Xã Phước Minh","type":"xa","slug":"xa-phuoc-minh","name_with_type":"Xã Phước Minh","path":"Xã Phước Minh, Huyện Bù Gia Mập, Tỉnh Bình Phước","path_with_type":"Xã Phước Minh, Huyện Bù Gia Mập, Tỉnh Bình Phước","code":"25232","parent_code":"691"},"25234":{"name":"Xã Bình Thắng","type":"xa","slug":"xa-binh-thang","name_with_type":"Xã Bình Thắng","path":"Xã Bình Thắng, Huyện Bù Gia Mập, Tỉnh Bình Phước","path_with_type":"Xã Bình Thắng, Huyện Bù Gia Mập, Tỉnh Bình Phước","code":"25234","parent_code":"691"},"25237":{"name":"Phường Sơn Giang","type":"phuong","slug":"phuong-son-giang","name_with_type":"Phường Sơn Giang","path":"Phường Sơn Giang, Thị xã Phước Long, Tỉnh Bình Phước","path_with_type":"Phường Sơn Giang, Thị xã Phước Long, Tỉnh Bình Phước","code":"25237","parent_code":"688"},"25240":{"name":"Xã Long Bình","type":"xa","slug":"xa-long-binh","name_with_type":"Xã Long Bình","path":"Xã Long Bình, Huyện Phú Riềng, Tỉnh Bình Phước","path_with_type":"Xã Long Bình, Huyện Phú Riềng, Tỉnh Bình Phước","code":"25240","parent_code":"698"},"25243":{"name":"Xã Bình Tân","type":"xa","slug":"xa-binh-tan","name_with_type":"Xã Bình Tân","path":"Xã Bình Tân, Huyện Phú Riềng, Tỉnh Bình Phước","path_with_type":"Xã Bình Tân, Huyện Phú Riềng, Tỉnh Bình Phước","code":"25243","parent_code":"698"},"25244":{"name":"Xã Bình Sơn","type":"xa","slug":"xa-binh-son","name_with_type":"Xã Bình Sơn","path":"Xã Bình Sơn, Huyện Phú Riềng, Tỉnh Bình Phước","path_with_type":"Xã Bình Sơn, Huyện Phú Riềng, Tỉnh Bình Phước","code":"25244","parent_code":"698"},"25245":{"name":"Xã Long Giang","type":"xa","slug":"xa-long-giang","name_with_type":"Xã Long Giang","path":"Xã Long Giang, Thị xã Phước Long, Tỉnh Bình Phước","path_with_type":"Xã Long Giang, Thị xã Phước Long, Tỉnh Bình Phước","code":"25245","parent_code":"688"},"25246":{"name":"Xã Long Hưng","type":"xa","slug":"xa-long-hung","name_with_type":"Xã Long Hưng","path":"Xã Long Hưng, Huyện Phú Riềng, Tỉnh Bình Phước","path_with_type":"Xã Long Hưng, Huyện Phú Riềng, Tỉnh Bình Phước","code":"25246","parent_code":"698"},"25249":{"name":"Xã Phước Tín","type":"xa","slug":"xa-phuoc-tin","name_with_type":"Xã Phước Tín","path":"Xã Phước Tín, Thị xã Phước Long, Tỉnh Bình Phước","path_with_type":"Xã Phước Tín, Thị xã Phước Long, Tỉnh Bình Phước","code":"25249","parent_code":"688"},"25250":{"name":"Xã Phước Tân","type":"xa","slug":"xa-phuoc-tan","name_with_type":"Xã Phước Tân","path":"Xã Phước Tân, Huyện Phú Riềng, Tỉnh Bình Phước","path_with_type":"Xã Phước Tân, Huyện Phú Riềng, Tỉnh Bình Phước","code":"25250","parent_code":"698"},"25252":{"name":"Xã Bù Nho","type":"xa","slug":"xa-bu-nho","name_with_type":"Xã Bù Nho","path":"Xã Bù Nho, Huyện Phú Riềng, Tỉnh Bình Phước","path_with_type":"Xã Bù Nho, Huyện Phú Riềng, Tỉnh Bình Phước","code":"25252","parent_code":"698"},"25255":{"name":"Xã Long Hà","type":"xa","slug":"xa-long-ha","name_with_type":"Xã Long Hà","path":"Xã Long Hà, Huyện Phú Riềng, Tỉnh Bình Phước","path_with_type":"Xã Long Hà, Huyện Phú Riềng, Tỉnh Bình Phước","code":"25255","parent_code":"698"},"25258":{"name":"Xã Long Tân","type":"xa","slug":"xa-long-tan","name_with_type":"Xã Long Tân","path":"Xã Long Tân, Huyện Phú Riềng, Tỉnh Bình Phước","path_with_type":"Xã Long Tân, Huyện Phú Riềng, Tỉnh Bình Phước","code":"25258","parent_code":"698"},"25261":{"name":"Xã Phú Trung","type":"xa","slug":"xa-phu-trung","name_with_type":"Xã Phú Trung","path":"Xã Phú Trung, Huyện Phú Riềng, Tỉnh Bình Phước","path_with_type":"Xã Phú Trung, Huyện Phú Riềng, Tỉnh Bình Phước","code":"25261","parent_code":"698"},"25264":{"name":"Xã Phú Riềng","type":"xa","slug":"xa-phu-rieng","name_with_type":"Xã Phú Riềng","path":"Xã Phú Riềng, Huyện Phú Riềng, Tỉnh Bình Phước","path_with_type":"Xã Phú Riềng, Huyện Phú Riềng, Tỉnh Bình Phước","code":"25264","parent_code":"698"},"25267":{"name":"Xã Phú Nghĩa","type":"xa","slug":"xa-phu-nghia","name_with_type":"Xã Phú Nghĩa","path":"Xã Phú Nghĩa, Huyện Bù Gia Mập, Tỉnh Bình Phước","path_with_type":"Xã Phú Nghĩa, Huyện Bù Gia Mập, Tỉnh Bình Phước","code":"25267","parent_code":"691"},"25270":{"name":"Thị trấn Lộc Ninh","type":"thi-tran","slug":"thi-tran-loc-ninh","name_with_type":"Thị trấn Lộc Ninh","path":"Thị trấn Lộc Ninh, Huyện Lộc Ninh, Tỉnh Bình Phước","path_with_type":"Thị trấn Lộc Ninh, Huyện Lộc Ninh, Tỉnh Bình Phước","code":"25270","parent_code":"692"},"25273":{"name":"Xã Lộc Hòa","type":"xa","slug":"xa-loc-hoa","name_with_type":"Xã Lộc Hòa","path":"Xã Lộc Hòa, Huyện Lộc Ninh, Tỉnh Bình Phước","path_with_type":"Xã Lộc Hòa, Huyện Lộc Ninh, Tỉnh Bình Phước","code":"25273","parent_code":"692"},"25276":{"name":"Xã Lộc An","type":"xa","slug":"xa-loc-an","name_with_type":"Xã Lộc An","path":"Xã Lộc An, Huyện Lộc Ninh, Tỉnh Bình Phước","path_with_type":"Xã Lộc An, Huyện Lộc Ninh, Tỉnh Bình Phước","code":"25276","parent_code":"692"},"25279":{"name":"Xã Lộc Tấn","type":"xa","slug":"xa-loc-tan","name_with_type":"Xã Lộc Tấn","path":"Xã Lộc Tấn, Huyện Lộc Ninh, Tỉnh Bình Phước","path_with_type":"Xã Lộc Tấn, Huyện Lộc Ninh, Tỉnh Bình Phước","code":"25279","parent_code":"692"},"25280":{"name":"Xã Lộc Thạnh","type":"xa","slug":"xa-loc-thanh","name_with_type":"Xã Lộc Thạnh","path":"Xã Lộc Thạnh, Huyện Lộc Ninh, Tỉnh Bình Phước","path_with_type":"Xã Lộc Thạnh, Huyện Lộc Ninh, Tỉnh Bình Phước","code":"25280","parent_code":"692"},"25282":{"name":"Xã Lộc Hiệp","type":"xa","slug":"xa-loc-hiep","name_with_type":"Xã Lộc Hiệp","path":"Xã Lộc Hiệp, Huyện Lộc Ninh, Tỉnh Bình Phước","path_with_type":"Xã Lộc Hiệp, Huyện Lộc Ninh, Tỉnh Bình Phước","code":"25282","parent_code":"692"},"25285":{"name":"Xã Lộc Thiện","type":"xa","slug":"xa-loc-thien","name_with_type":"Xã Lộc Thiện","path":"Xã Lộc Thiện, Huyện Lộc Ninh, Tỉnh Bình Phước","path_with_type":"Xã Lộc Thiện, Huyện Lộc Ninh, Tỉnh Bình Phước","code":"25285","parent_code":"692"},"25288":{"name":"Xã Lộc Thuận","type":"xa","slug":"xa-loc-thuan","name_with_type":"Xã Lộc Thuận","path":"Xã Lộc Thuận, Huyện Lộc Ninh, Tỉnh Bình Phước","path_with_type":"Xã Lộc Thuận, Huyện Lộc Ninh, Tỉnh Bình Phước","code":"25288","parent_code":"692"},"25291":{"name":"Xã Lộc Quang","type":"xa","slug":"xa-loc-quang","name_with_type":"Xã Lộc Quang","path":"Xã Lộc Quang, Huyện Lộc Ninh, Tỉnh Bình Phước","path_with_type":"Xã Lộc Quang, Huyện Lộc Ninh, Tỉnh Bình Phước","code":"25291","parent_code":"692"},"25292":{"name":"Xã Lộc Phú","type":"xa","slug":"xa-loc-phu","name_with_type":"Xã Lộc Phú","path":"Xã Lộc Phú, Huyện Lộc Ninh, Tỉnh Bình Phước","path_with_type":"Xã Lộc Phú, Huyện Lộc Ninh, Tỉnh Bình Phước","code":"25292","parent_code":"692"},"25294":{"name":"Xã Lộc Thành","type":"xa","slug":"xa-loc-thanh","name_with_type":"Xã Lộc Thành","path":"Xã Lộc Thành, Huyện Lộc Ninh, Tỉnh Bình Phước","path_with_type":"Xã Lộc Thành, Huyện Lộc Ninh, Tỉnh Bình Phước","code":"25294","parent_code":"692"},"25297":{"name":"Xã Lộc Thái","type":"xa","slug":"xa-loc-thai","name_with_type":"Xã Lộc Thái","path":"Xã Lộc Thái, Huyện Lộc Ninh, Tỉnh Bình Phước","path_with_type":"Xã Lộc Thái, Huyện Lộc Ninh, Tỉnh Bình Phước","code":"25297","parent_code":"692"},"25300":{"name":"Xã Lộc Điền","type":"xa","slug":"xa-loc-dien","name_with_type":"Xã Lộc Điền","path":"Xã Lộc Điền, Huyện Lộc Ninh, Tỉnh Bình Phước","path_with_type":"Xã Lộc Điền, Huyện Lộc Ninh, Tỉnh Bình Phước","code":"25300","parent_code":"692"},"25303":{"name":"Xã Lộc Hưng","type":"xa","slug":"xa-loc-hung","name_with_type":"Xã Lộc Hưng","path":"Xã Lộc Hưng, Huyện Lộc Ninh, Tỉnh Bình Phước","path_with_type":"Xã Lộc Hưng, Huyện Lộc Ninh, Tỉnh Bình Phước","code":"25303","parent_code":"692"},"25305":{"name":"Xã Lộc Thịnh","type":"xa","slug":"xa-loc-thinh","name_with_type":"Xã Lộc Thịnh","path":"Xã Lộc Thịnh, Huyện Lộc Ninh, Tỉnh Bình Phước","path_with_type":"Xã Lộc Thịnh, Huyện Lộc Ninh, Tỉnh Bình Phước","code":"25305","parent_code":"692"},"25306":{"name":"Xã Lộc Khánh","type":"xa","slug":"xa-loc-khanh","name_with_type":"Xã Lộc Khánh","path":"Xã Lộc Khánh, Huyện Lộc Ninh, Tỉnh Bình Phước","path_with_type":"Xã Lộc Khánh, Huyện Lộc Ninh, Tỉnh Bình Phước","code":"25306","parent_code":"692"},"25308":{"name":"Thị trấn Thanh Bình","type":"thi-tran","slug":"thi-tran-thanh-binh","name_with_type":"Thị trấn Thanh Bình","path":"Thị trấn Thanh Bình, Huyện Bù Đốp, Tỉnh Bình Phước","path_with_type":"Thị trấn Thanh Bình, Huyện Bù Đốp, Tỉnh Bình Phước","code":"25308","parent_code":"693"},"25309":{"name":"Xã Hưng Phước","type":"xa","slug":"xa-hung-phuoc","name_with_type":"Xã Hưng Phước","path":"Xã Hưng Phước, Huyện Bù Đốp, Tỉnh Bình Phước","path_with_type":"Xã Hưng Phước, Huyện Bù Đốp, Tỉnh Bình Phước","code":"25309","parent_code":"693"},"25310":{"name":"Xã Phước Thiện","type":"xa","slug":"xa-phuoc-thien","name_with_type":"Xã Phước Thiện","path":"Xã Phước Thiện, Huyện Bù Đốp, Tỉnh Bình Phước","path_with_type":"Xã Phước Thiện, Huyện Bù Đốp, Tỉnh Bình Phước","code":"25310","parent_code":"693"},"25312":{"name":"Xã Thiện Hưng","type":"xa","slug":"xa-thien-hung","name_with_type":"Xã Thiện Hưng","path":"Xã Thiện Hưng, Huyện Bù Đốp, Tỉnh Bình Phước","path_with_type":"Xã Thiện Hưng, Huyện Bù Đốp, Tỉnh Bình Phước","code":"25312","parent_code":"693"},"25315":{"name":"Xã Thanh Hòa","type":"xa","slug":"xa-thanh-hoa","name_with_type":"Xã Thanh Hòa","path":"Xã Thanh Hòa, Huyện Bù Đốp, Tỉnh Bình Phước","path_with_type":"Xã Thanh Hòa, Huyện Bù Đốp, Tỉnh Bình Phước","code":"25315","parent_code":"693"},"25318":{"name":"Xã Tân Thành","type":"xa","slug":"xa-tan-thanh","name_with_type":"Xã Tân Thành","path":"Xã Tân Thành, Huyện Bù Đốp, Tỉnh Bình Phước","path_with_type":"Xã Tân Thành, Huyện Bù Đốp, Tỉnh Bình Phước","code":"25318","parent_code":"693"},"25320":{"name":"Phường Hưng Chiến","type":"phuong","slug":"phuong-hung-chien","name_with_type":"Phường Hưng Chiến","path":"Phường Hưng Chiến, Thị xã Bình Long, Tỉnh Bình Phước","path_with_type":"Phường Hưng Chiến, Thị xã Bình Long, Tỉnh Bình Phước","code":"25320","parent_code":"690"},"25321":{"name":"Xã Tân Tiến","type":"xa","slug":"xa-tan-tien","name_with_type":"Xã Tân Tiến","path":"Xã Tân Tiến, Huyện Bù Đốp, Tỉnh Bình Phước","path_with_type":"Xã Tân Tiến, Huyện Bù Đốp, Tỉnh Bình Phước","code":"25321","parent_code":"693"},"25324":{"name":"Phường An Lộc","type":"phuong","slug":"phuong-an-loc","name_with_type":"Phường An Lộc","path":"Phường An Lộc, Thị xã Bình Long, Tỉnh Bình Phước","path_with_type":"Phường An Lộc, Thị xã Bình Long, Tỉnh Bình Phước","code":"25324","parent_code":"690"},"25325":{"name":"Phường Phú Thịnh","type":"phuong","slug":"phuong-phu-thinh","name_with_type":"Phường Phú Thịnh","path":"Phường Phú Thịnh, Thị xã Bình Long, Tỉnh Bình Phước","path_with_type":"Phường Phú Thịnh, Thị xã Bình Long, Tỉnh Bình Phước","code":"25325","parent_code":"690"},"25326":{"name":"Phường Phú Đức","type":"phuong","slug":"phuong-phu-duc","name_with_type":"Phường Phú Đức","path":"Phường Phú Đức, Thị xã Bình Long, Tỉnh Bình Phước","path_with_type":"Phường Phú Đức, Thị xã Bình Long, Tỉnh Bình Phước","code":"25326","parent_code":"690"},"25327":{"name":"Xã Thanh An","type":"xa","slug":"xa-thanh-an","name_with_type":"Xã Thanh An","path":"Xã Thanh An, Huyện Hớn Quản, Tỉnh Bình Phước","path_with_type":"Xã Thanh An, Huyện Hớn Quản, Tỉnh Bình Phước","code":"25327","parent_code":"694"},"25330":{"name":"Xã An Khương","type":"xa","slug":"xa-an-khuong","name_with_type":"Xã An Khương","path":"Xã An Khương, Huyện Hớn Quản, Tỉnh Bình Phước","path_with_type":"Xã An Khương, Huyện Hớn Quản, Tỉnh Bình Phước","code":"25330","parent_code":"694"},"25333":{"name":"Xã Thanh Lương","type":"xa","slug":"xa-thanh-luong","name_with_type":"Xã Thanh Lương","path":"Xã Thanh Lương, Thị xã Bình Long, Tỉnh Bình Phước","path_with_type":"Xã Thanh Lương, Thị xã Bình Long, Tỉnh Bình Phước","code":"25333","parent_code":"690"},"25336":{"name":"Xã Thanh Phú","type":"xa","slug":"xa-thanh-phu","name_with_type":"Xã Thanh Phú","path":"Xã Thanh Phú, Thị xã Bình Long, Tỉnh Bình Phước","path_with_type":"Xã Thanh Phú, Thị xã Bình Long, Tỉnh Bình Phước","code":"25336","parent_code":"690"},"25339":{"name":"Xã An Phú","type":"xa","slug":"xa-an-phu","name_with_type":"Xã An Phú","path":"Xã An Phú, Huyện Hớn Quản, Tỉnh Bình Phước","path_with_type":"Xã An Phú, Huyện Hớn Quản, Tỉnh Bình Phước","code":"25339","parent_code":"694"},"25342":{"name":"Xã Tân Lợi","type":"xa","slug":"xa-tan-loi","name_with_type":"Xã Tân Lợi","path":"Xã Tân Lợi, Huyện Hớn Quản, Tỉnh Bình Phước","path_with_type":"Xã Tân Lợi, Huyện Hớn Quản, Tỉnh Bình Phước","code":"25342","parent_code":"694"},"25345":{"name":"Xã Tân Hưng","type":"xa","slug":"xa-tan-hung","name_with_type":"Xã Tân Hưng","path":"Xã Tân Hưng, Huyện Hớn Quản, Tỉnh Bình Phước","path_with_type":"Xã Tân Hưng, Huyện Hớn Quản, Tỉnh Bình Phước","code":"25345","parent_code":"694"},"25348":{"name":"Xã Minh Đức","type":"xa","slug":"xa-minh-duc","name_with_type":"Xã Minh Đức","path":"Xã Minh Đức, Huyện Hớn Quản, Tỉnh Bình Phước","path_with_type":"Xã Minh Đức, Huyện Hớn Quản, Tỉnh Bình Phước","code":"25348","parent_code":"694"},"25349":{"name":"Xã Minh Tâm","type":"xa","slug":"xa-minh-tam","name_with_type":"Xã Minh Tâm","path":"Xã Minh Tâm, Huyện Hớn Quản, Tỉnh Bình Phước","path_with_type":"Xã Minh Tâm, Huyện Hớn Quản, Tỉnh Bình Phước","code":"25349","parent_code":"694"},"25351":{"name":"Xã Phước An","type":"xa","slug":"xa-phuoc-an","name_with_type":"Xã Phước An","path":"Xã Phước An, Huyện Hớn Quản, Tỉnh Bình Phước","path_with_type":"Xã Phước An, Huyện Hớn Quản, Tỉnh Bình Phước","code":"25351","parent_code":"694"},"25354":{"name":"Xã Thanh Bình","type":"xa","slug":"xa-thanh-binh","name_with_type":"Xã Thanh Bình","path":"Xã Thanh Bình, Huyện Hớn Quản, Tỉnh Bình Phước","path_with_type":"Xã Thanh Bình, Huyện Hớn Quản, Tỉnh Bình Phước","code":"25354","parent_code":"694"},"25357":{"name":"Thị trấn Tân Khai","type":"thi-tran","slug":"thi-tran-tan-khai","name_with_type":"Thị trấn Tân Khai","path":"Thị trấn Tân Khai, Huyện Hớn Quản, Tỉnh Bình Phước","path_with_type":"Thị trấn Tân Khai, Huyện Hớn Quản, Tỉnh Bình Phước","code":"25357","parent_code":"694"},"25360":{"name":"Xã Đồng Nơ","type":"xa","slug":"xa-dong-no","name_with_type":"Xã Đồng Nơ","path":"Xã Đồng Nơ, Huyện Hớn Quản, Tỉnh Bình Phước","path_with_type":"Xã Đồng Nơ, Huyện Hớn Quản, Tỉnh Bình Phước","code":"25360","parent_code":"694"},"25361":{"name":"Xã Tân Hiệp","type":"xa","slug":"xa-tan-hiep","name_with_type":"Xã Tân Hiệp","path":"Xã Tân Hiệp, Huyện Hớn Quản, Tỉnh Bình Phước","path_with_type":"Xã Tân Hiệp, Huyện Hớn Quản, Tỉnh Bình Phước","code":"25361","parent_code":"694"},"25363":{"name":"Thị trấn Tân Phú","type":"thi-tran","slug":"thi-tran-tan-phu","name_with_type":"Thị trấn Tân Phú","path":"Thị trấn Tân Phú, Huyện Đồng Phú, Tỉnh Bình Phước","path_with_type":"Thị trấn Tân Phú, Huyện Đồng Phú, Tỉnh Bình Phước","code":"25363","parent_code":"695"},"25366":{"name":"Xã Thuận Lợi","type":"xa","slug":"xa-thuan-loi","name_with_type":"Xã Thuận Lợi","path":"Xã Thuận Lợi, Huyện Đồng Phú, Tỉnh Bình Phước","path_with_type":"Xã Thuận Lợi, Huyện Đồng Phú, Tỉnh Bình Phước","code":"25366","parent_code":"695"},"25369":{"name":"Xã Đồng Tâm","type":"xa","slug":"xa-dong-tam","name_with_type":"Xã Đồng Tâm","path":"Xã Đồng Tâm, Huyện Đồng Phú, Tỉnh Bình Phước","path_with_type":"Xã Đồng Tâm, Huyện Đồng Phú, Tỉnh Bình Phước","code":"25369","parent_code":"695"},"25372":{"name":"Xã Tân Phước","type":"xa","slug":"xa-tan-phuoc","name_with_type":"Xã Tân Phước","path":"Xã Tân Phước, Huyện Đồng Phú, Tỉnh Bình Phước","path_with_type":"Xã Tân Phước, Huyện Đồng Phú, Tỉnh Bình Phước","code":"25372","parent_code":"695"},"25375":{"name":"Xã Tân Hưng","type":"xa","slug":"xa-tan-hung","name_with_type":"Xã Tân Hưng","path":"Xã Tân Hưng, Huyện Đồng Phú, Tỉnh Bình Phước","path_with_type":"Xã Tân Hưng, Huyện Đồng Phú, Tỉnh Bình Phước","code":"25375","parent_code":"695"},"25378":{"name":"Xã Tân Lợi","type":"xa","slug":"xa-tan-loi","name_with_type":"Xã Tân Lợi","path":"Xã Tân Lợi, Huyện Đồng Phú, Tỉnh Bình Phước","path_with_type":"Xã Tân Lợi, Huyện Đồng Phú, Tỉnh Bình Phước","code":"25378","parent_code":"695"},"25381":{"name":"Xã Tân Lập","type":"xa","slug":"xa-tan-lap","name_with_type":"Xã Tân Lập","path":"Xã Tân Lập, Huyện Đồng Phú, Tỉnh Bình Phước","path_with_type":"Xã Tân Lập, Huyện Đồng Phú, Tỉnh Bình Phước","code":"25381","parent_code":"695"},"25384":{"name":"Xã Tân Hòa","type":"xa","slug":"xa-tan-hoa","name_with_type":"Xã Tân Hòa","path":"Xã Tân Hòa, Huyện Đồng Phú, Tỉnh Bình Phước","path_with_type":"Xã Tân Hòa, Huyện Đồng Phú, Tỉnh Bình Phước","code":"25384","parent_code":"695"},"25387":{"name":"Xã Thuận Phú","type":"xa","slug":"xa-thuan-phu","name_with_type":"Xã Thuận Phú","path":"Xã Thuận Phú, Huyện Đồng Phú, Tỉnh Bình Phước","path_with_type":"Xã Thuận Phú, Huyện Đồng Phú, Tỉnh Bình Phước","code":"25387","parent_code":"695"},"25390":{"name":"Xã Đồng Tiến","type":"xa","slug":"xa-dong-tien","name_with_type":"Xã Đồng Tiến","path":"Xã Đồng Tiến, Huyện Đồng Phú, Tỉnh Bình Phước","path_with_type":"Xã Đồng Tiến, Huyện Đồng Phú, Tỉnh Bình Phước","code":"25390","parent_code":"695"},"25393":{"name":"Xã Tân Tiến","type":"xa","slug":"xa-tan-tien","name_with_type":"Xã Tân Tiến","path":"Xã Tân Tiến, Huyện Đồng Phú, Tỉnh Bình Phước","path_with_type":"Xã Tân Tiến, Huyện Đồng Phú, Tỉnh Bình Phước","code":"25393","parent_code":"695"},"25396":{"name":"Thị trấn Đức Phong","type":"thi-tran","slug":"thi-tran-duc-phong","name_with_type":"Thị trấn Đức Phong","path":"Thị trấn Đức Phong, Huyện Bù Đăng, Tỉnh Bình Phước","path_with_type":"Thị trấn Đức Phong, Huyện Bù Đăng, Tỉnh Bình Phước","code":"25396","parent_code":"696"},"25398":{"name":"Xã Đường 10","type":"xa","slug":"xa-duong-10","name_with_type":"Xã Đường 10","path":"Xã Đường 10, Huyện Bù Đăng, Tỉnh Bình Phước","path_with_type":"Xã Đường 10, Huyện Bù Đăng, Tỉnh Bình Phước","code":"25398","parent_code":"696"},"25399":{"name":"Xã Đak Nhau","type":"xa","slug":"xa-dak-nhau","name_with_type":"Xã Đak Nhau","path":"Xã Đak Nhau, Huyện Bù Đăng, Tỉnh Bình Phước","path_with_type":"Xã Đak Nhau, Huyện Bù Đăng, Tỉnh Bình Phước","code":"25399","parent_code":"696"},"25400":{"name":"Xã Phú Sơn","type":"xa","slug":"xa-phu-son","name_with_type":"Xã Phú Sơn","path":"Xã Phú Sơn, Huyện Bù Đăng, Tỉnh Bình Phước","path_with_type":"Xã Phú Sơn, Huyện Bù Đăng, Tỉnh Bình Phước","code":"25400","parent_code":"696"},"25402":{"name":"Xã Thọ Sơn","type":"xa","slug":"xa-tho-son","name_with_type":"Xã Thọ Sơn","path":"Xã Thọ Sơn, Huyện Bù Đăng, Tỉnh Bình Phước","path_with_type":"Xã Thọ Sơn, Huyện Bù Đăng, Tỉnh Bình Phước","code":"25402","parent_code":"696"},"25404":{"name":"Xã Bình Minh","type":"xa","slug":"xa-binh-minh","name_with_type":"Xã Bình Minh","path":"Xã Bình Minh, Huyện Bù Đăng, Tỉnh Bình Phước","path_with_type":"Xã Bình Minh, Huyện Bù Đăng, Tỉnh Bình Phước","code":"25404","parent_code":"696"},"25405":{"name":"Xã Bom Bo","type":"xa","slug":"xa-bom-bo","name_with_type":"Xã Bom Bo","path":"Xã Bom Bo, Huyện Bù Đăng, Tỉnh Bình Phước","path_with_type":"Xã Bom Bo, Huyện Bù Đăng, Tỉnh Bình Phước","code":"25405","parent_code":"696"},"25408":{"name":"Xã Minh Hưng","type":"xa","slug":"xa-minh-hung","name_with_type":"Xã Minh Hưng","path":"Xã Minh Hưng, Huyện Bù Đăng, Tỉnh Bình Phước","path_with_type":"Xã Minh Hưng, Huyện Bù Đăng, Tỉnh Bình Phước","code":"25408","parent_code":"696"},"25411":{"name":"Xã Đoàn Kết","type":"xa","slug":"xa-doan-ket","name_with_type":"Xã Đoàn Kết","path":"Xã Đoàn Kết, Huyện Bù Đăng, Tỉnh Bình Phước","path_with_type":"Xã Đoàn Kết, Huyện Bù Đăng, Tỉnh Bình Phước","code":"25411","parent_code":"696"},"25414":{"name":"Xã Đồng Nai","type":"xa","slug":"xa-dong-nai","name_with_type":"Xã Đồng Nai","path":"Xã Đồng Nai, Huyện Bù Đăng, Tỉnh Bình Phước","path_with_type":"Xã Đồng Nai, Huyện Bù Đăng, Tỉnh Bình Phước","code":"25414","parent_code":"696"},"25417":{"name":"Xã Đức Liễu","type":"xa","slug":"xa-duc-lieu","name_with_type":"Xã Đức Liễu","path":"Xã Đức Liễu, Huyện Bù Đăng, Tỉnh Bình Phước","path_with_type":"Xã Đức Liễu, Huyện Bù Đăng, Tỉnh Bình Phước","code":"25417","parent_code":"696"},"25420":{"name":"Xã Thống Nhất","type":"xa","slug":"xa-thong-nhat","name_with_type":"Xã Thống Nhất","path":"Xã Thống Nhất, Huyện Bù Đăng, Tỉnh Bình Phước","path_with_type":"Xã Thống Nhất, Huyện Bù Đăng, Tỉnh Bình Phước","code":"25420","parent_code":"696"},"25423":{"name":"Xã Nghĩa Trung","type":"xa","slug":"xa-nghia-trung","name_with_type":"Xã Nghĩa Trung","path":"Xã Nghĩa Trung, Huyện Bù Đăng, Tỉnh Bình Phước","path_with_type":"Xã Nghĩa Trung, Huyện Bù Đăng, Tỉnh Bình Phước","code":"25423","parent_code":"696"},"25424":{"name":"Xã Nghĩa Bình","type":"xa","slug":"xa-nghia-binh","name_with_type":"Xã Nghĩa Bình","path":"Xã Nghĩa Bình, Huyện Bù Đăng, Tỉnh Bình Phước","path_with_type":"Xã Nghĩa Bình, Huyện Bù Đăng, Tỉnh Bình Phước","code":"25424","parent_code":"696"},"25426":{"name":"Xã Đăng Hà","type":"xa","slug":"xa-dang-ha","name_with_type":"Xã Đăng Hà","path":"Xã Đăng Hà, Huyện Bù Đăng, Tỉnh Bình Phước","path_with_type":"Xã Đăng Hà, Huyện Bù Đăng, Tỉnh Bình Phước","code":"25426","parent_code":"696"},"25429":{"name":"Xã Phước Sơn","type":"xa","slug":"xa-phuoc-son","name_with_type":"Xã Phước Sơn","path":"Xã Phước Sơn, Huyện Bù Đăng, Tỉnh Bình Phước","path_with_type":"Xã Phước Sơn, Huyện Bù Đăng, Tỉnh Bình Phước","code":"25429","parent_code":"696"},"25432":{"name":"Phường Hưng Long","type":"phuong","slug":"phuong-hung-long","name_with_type":"Phường Hưng Long","path":"Phường Hưng Long, Thị xã Chơn Thành, Tỉnh Bình Phước","path_with_type":"Phường Hưng Long, Thị xã Chơn Thành, Tỉnh Bình Phước","code":"25432","parent_code":"697"},"25433":{"name":"Phường Thành Tâm","type":"phuong","slug":"phuong-thanh-tam","name_with_type":"Phường Thành Tâm","path":"Phường Thành Tâm, Thị xã Chơn Thành, Tỉnh Bình Phước","path_with_type":"Phường Thành Tâm, Thị xã Chơn Thành, Tỉnh Bình Phước","code":"25433","parent_code":"697"},"25435":{"name":"Xã Minh Lập","type":"xa","slug":"xa-minh-lap","name_with_type":"Xã Minh Lập","path":"Xã Minh Lập, Thị xã Chơn Thành, Tỉnh Bình Phước","path_with_type":"Xã Minh Lập, Thị xã Chơn Thành, Tỉnh Bình Phước","code":"25435","parent_code":"697"},"25438":{"name":"Xã Tân Quan","type":"xa","slug":"xa-tan-quan","name_with_type":"Xã Tân Quan","path":"Xã Tân Quan, Huyện Hớn Quản, Tỉnh Bình Phước","path_with_type":"Xã Tân Quan, Huyện Hớn Quản, Tỉnh Bình Phước","code":"25438","parent_code":"694"},"25439":{"name":"Xã Quang Minh","type":"xa","slug":"xa-quang-minh","name_with_type":"Xã Quang Minh","path":"Xã Quang Minh, Thị xã Chơn Thành, Tỉnh Bình Phước","path_with_type":"Xã Quang Minh, Thị xã Chơn Thành, Tỉnh Bình Phước","code":"25439","parent_code":"697"},"25441":{"name":"Phường Minh Hưng","type":"phuong","slug":"phuong-minh-hung","name_with_type":"Phường Minh Hưng","path":"Phường Minh Hưng, Thị xã Chơn Thành, Tỉnh Bình Phước","path_with_type":"Phường Minh Hưng, Thị xã Chơn Thành, Tỉnh Bình Phước","code":"25441","parent_code":"697"},"25444":{"name":"Phường Minh Long","type":"phuong","slug":"phuong-minh-long","name_with_type":"Phường Minh Long","path":"Phường Minh Long, Thị xã Chơn Thành, Tỉnh Bình Phước","path_with_type":"Phường Minh Long, Thị xã Chơn Thành, Tỉnh Bình Phước","code":"25444","parent_code":"697"},"25447":{"name":"Phường Minh Thành","type":"phuong","slug":"phuong-minh-thanh","name_with_type":"Phường Minh Thành","path":"Phường Minh Thành, Thị xã Chơn Thành, Tỉnh Bình Phước","path_with_type":"Phường Minh Thành, Thị xã Chơn Thành, Tỉnh Bình Phước","code":"25447","parent_code":"697"},"25450":{"name":"Xã Nha Bích","type":"xa","slug":"xa-nha-bich","name_with_type":"Xã Nha Bích","path":"Xã Nha Bích, Thị xã Chơn Thành, Tỉnh Bình Phước","path_with_type":"Xã Nha Bích, Thị xã Chơn Thành, Tỉnh Bình Phước","code":"25450","parent_code":"697"},"25453":{"name":"Xã Minh Thắng","type":"xa","slug":"xa-minh-thang","name_with_type":"Xã Minh Thắng","path":"Xã Minh Thắng, Thị xã Chơn Thành, Tỉnh Bình Phước","path_with_type":"Xã Minh Thắng, Thị xã Chơn Thành, Tỉnh Bình Phước","code":"25453","parent_code":"697"},"25456":{"name":"Phường 1","type":"phuong","slug":"phuong-1","name_with_type":"Phường 1","path":"Phường 1, Thành phố Tây Ninh, Tỉnh Tây Ninh","path_with_type":"Phường 1, Thành phố Tây Ninh, Tỉnh Tây Ninh","code":"25456","parent_code":"703"},"25459":{"name":"Phường 3","type":"phuong","slug":"phuong-3","name_with_type":"Phường 3","path":"Phường 3, Thành phố Tây Ninh, Tỉnh Tây Ninh","path_with_type":"Phường 3, Thành phố Tây Ninh, Tỉnh Tây Ninh","code":"25459","parent_code":"703"},"25462":{"name":"Phường 4","type":"phuong","slug":"phuong-4","name_with_type":"Phường 4","path":"Phường 4, Thành phố Tây Ninh, Tỉnh Tây Ninh","path_with_type":"Phường 4, Thành phố Tây Ninh, Tỉnh Tây Ninh","code":"25462","parent_code":"703"},"25465":{"name":"Phường Hiệp Ninh","type":"phuong","slug":"phuong-hiep-ninh","name_with_type":"Phường Hiệp Ninh","path":"Phường Hiệp Ninh, Thành phố Tây Ninh, Tỉnh Tây Ninh","path_with_type":"Phường Hiệp Ninh, Thành phố Tây Ninh, Tỉnh Tây Ninh","code":"25465","parent_code":"703"},"25468":{"name":"Phường 2","type":"phuong","slug":"phuong-2","name_with_type":"Phường 2","path":"Phường 2, Thành phố Tây Ninh, Tỉnh Tây Ninh","path_with_type":"Phường 2, Thành phố Tây Ninh, Tỉnh Tây Ninh","code":"25468","parent_code":"703"},"25471":{"name":"Xã Thạnh Tân","type":"xa","slug":"xa-thanh-tan","name_with_type":"Xã Thạnh Tân","path":"Xã Thạnh Tân, Thành phố Tây Ninh, Tỉnh Tây Ninh","path_with_type":"Xã Thạnh Tân, Thành phố Tây Ninh, Tỉnh Tây Ninh","code":"25471","parent_code":"703"},"25474":{"name":"Xã Tân Bình","type":"xa","slug":"xa-tan-binh","name_with_type":"Xã Tân Bình","path":"Xã Tân Bình, Thành phố Tây Ninh, Tỉnh Tây Ninh","path_with_type":"Xã Tân Bình, Thành phố Tây Ninh, Tỉnh Tây Ninh","code":"25474","parent_code":"703"},"25477":{"name":"Xã Bình Minh","type":"xa","slug":"xa-binh-minh","name_with_type":"Xã Bình Minh","path":"Xã Bình Minh, Thành phố Tây Ninh, Tỉnh Tây Ninh","path_with_type":"Xã Bình Minh, Thành phố Tây Ninh, Tỉnh Tây Ninh","code":"25477","parent_code":"703"},"25480":{"name":"Phường Ninh Sơn","type":"phuong","slug":"phuong-ninh-son","name_with_type":"Phường Ninh Sơn","path":"Phường Ninh Sơn, Thành phố Tây Ninh, Tỉnh Tây Ninh","path_with_type":"Phường Ninh Sơn, Thành phố Tây Ninh, Tỉnh Tây Ninh","code":"25480","parent_code":"703"},"25483":{"name":"Phường Ninh Thạnh","type":"phuong","slug":"phuong-ninh-thanh","name_with_type":"Phường Ninh Thạnh","path":"Phường Ninh Thạnh, Thành phố Tây Ninh, Tỉnh Tây Ninh","path_with_type":"Phường Ninh Thạnh, Thành phố Tây Ninh, Tỉnh Tây Ninh","code":"25483","parent_code":"703"},"25486":{"name":"Thị trấn Tân Biên","type":"thi-tran","slug":"thi-tran-tan-bien","name_with_type":"Thị trấn Tân Biên","path":"Thị trấn Tân Biên, Huyện Tân Biên, Tỉnh Tây Ninh","path_with_type":"Thị trấn Tân Biên, Huyện Tân Biên, Tỉnh Tây Ninh","code":"25486","parent_code":"705"},"25489":{"name":"Xã Tân Lập","type":"xa","slug":"xa-tan-lap","name_with_type":"Xã Tân Lập","path":"Xã Tân Lập, Huyện Tân Biên, Tỉnh Tây Ninh","path_with_type":"Xã Tân Lập, Huyện Tân Biên, Tỉnh Tây Ninh","code":"25489","parent_code":"705"},"25492":{"name":"Xã Thạnh Bắc","type":"xa","slug":"xa-thanh-bac","name_with_type":"Xã Thạnh Bắc","path":"Xã Thạnh Bắc, Huyện Tân Biên, Tỉnh Tây Ninh","path_with_type":"Xã Thạnh Bắc, Huyện Tân Biên, Tỉnh Tây Ninh","code":"25492","parent_code":"705"},"25495":{"name":"Xã Tân Bình","type":"xa","slug":"xa-tan-binh","name_with_type":"Xã Tân Bình","path":"Xã Tân Bình, Huyện Tân Biên, Tỉnh Tây Ninh","path_with_type":"Xã Tân Bình, Huyện Tân Biên, Tỉnh Tây Ninh","code":"25495","parent_code":"705"},"25498":{"name":"Xã Thạnh Bình","type":"xa","slug":"xa-thanh-binh","name_with_type":"Xã Thạnh Bình","path":"Xã Thạnh Bình, Huyện Tân Biên, Tỉnh Tây Ninh","path_with_type":"Xã Thạnh Bình, Huyện Tân Biên, Tỉnh Tây Ninh","code":"25498","parent_code":"705"},"25501":{"name":"Xã Thạnh Tây","type":"xa","slug":"xa-thanh-tay","name_with_type":"Xã Thạnh Tây","path":"Xã Thạnh Tây, Huyện Tân Biên, Tỉnh Tây Ninh","path_with_type":"Xã Thạnh Tây, Huyện Tân Biên, Tỉnh Tây Ninh","code":"25501","parent_code":"705"},"25504":{"name":"Xã Hòa Hiệp","type":"xa","slug":"xa-hoa-hiep","name_with_type":"Xã Hòa Hiệp","path":"Xã Hòa Hiệp, Huyện Tân Biên, Tỉnh Tây Ninh","path_with_type":"Xã Hòa Hiệp, Huyện Tân Biên, Tỉnh Tây Ninh","code":"25504","parent_code":"705"},"25507":{"name":"Xã Tân Phong","type":"xa","slug":"xa-tan-phong","name_with_type":"Xã Tân Phong","path":"Xã Tân Phong, Huyện Tân Biên, Tỉnh Tây Ninh","path_with_type":"Xã Tân Phong, Huyện Tân Biên, Tỉnh Tây Ninh","code":"25507","parent_code":"705"},"25510":{"name":"Xã Mỏ Công","type":"xa","slug":"xa-mo-cong","name_with_type":"Xã Mỏ Công","path":"Xã Mỏ Công, Huyện Tân Biên, Tỉnh Tây Ninh","path_with_type":"Xã Mỏ Công, Huyện Tân Biên, Tỉnh Tây Ninh","code":"25510","parent_code":"705"},"25513":{"name":"Xã Trà Vong","type":"xa","slug":"xa-tra-vong","name_with_type":"Xã Trà Vong","path":"Xã Trà Vong, Huyện Tân Biên, Tỉnh Tây Ninh","path_with_type":"Xã Trà Vong, Huyện Tân Biên, Tỉnh Tây Ninh","code":"25513","parent_code":"705"},"25516":{"name":"Thị trấn Tân Châu","type":"thi-tran","slug":"thi-tran-tan-chau","name_with_type":"Thị trấn Tân Châu","path":"Thị trấn Tân Châu, Huyện Tân Châu, Tỉnh Tây Ninh","path_with_type":"Thị trấn Tân Châu, Huyện Tân Châu, Tỉnh Tây Ninh","code":"25516","parent_code":"706"},"25519":{"name":"Xã Tân Hà","type":"xa","slug":"xa-tan-ha","name_with_type":"Xã Tân Hà","path":"Xã Tân Hà, Huyện Tân Châu, Tỉnh Tây Ninh","path_with_type":"Xã Tân Hà, Huyện Tân Châu, Tỉnh Tây Ninh","code":"25519","parent_code":"706"},"25522":{"name":"Xã Tân Đông","type":"xa","slug":"xa-tan-dong","name_with_type":"Xã Tân Đông","path":"Xã Tân Đông, Huyện Tân Châu, Tỉnh Tây Ninh","path_with_type":"Xã Tân Đông, Huyện Tân Châu, Tỉnh Tây Ninh","code":"25522","parent_code":"706"},"25525":{"name":"Xã Tân Hội","type":"xa","slug":"xa-tan-hoi","name_with_type":"Xã Tân Hội","path":"Xã Tân Hội, Huyện Tân Châu, Tỉnh Tây Ninh","path_with_type":"Xã Tân Hội, Huyện Tân Châu, Tỉnh Tây Ninh","code":"25525","parent_code":"706"},"25528":{"name":"Xã Tân Hòa","type":"xa","slug":"xa-tan-hoa","name_with_type":"Xã Tân Hòa","path":"Xã Tân Hòa, Huyện Tân Châu, Tỉnh Tây Ninh","path_with_type":"Xã Tân Hòa, Huyện Tân Châu, Tỉnh Tây Ninh","code":"25528","parent_code":"706"},"25531":{"name":"Xã Suối Ngô","type":"xa","slug":"xa-suoi-ngo","name_with_type":"Xã Suối Ngô","path":"Xã Suối Ngô, Huyện Tân Châu, Tỉnh Tây Ninh","path_with_type":"Xã Suối Ngô, Huyện Tân Châu, Tỉnh Tây Ninh","code":"25531","parent_code":"706"},"25534":{"name":"Xã Suối Dây","type":"xa","slug":"xa-suoi-day","name_with_type":"Xã Suối Dây","path":"Xã Suối Dây, Huyện Tân Châu, Tỉnh Tây Ninh","path_with_type":"Xã Suối Dây, Huyện Tân Châu, Tỉnh Tây Ninh","code":"25534","parent_code":"706"},"25537":{"name":"Xã Tân Hiệp","type":"xa","slug":"xa-tan-hiep","name_with_type":"Xã Tân Hiệp","path":"Xã Tân Hiệp, Huyện Tân Châu, Tỉnh Tây Ninh","path_with_type":"Xã Tân Hiệp, Huyện Tân Châu, Tỉnh Tây Ninh","code":"25537","parent_code":"706"},"25540":{"name":"Xã Thạnh Đông","type":"xa","slug":"xa-thanh-dong","name_with_type":"Xã Thạnh Đông","path":"Xã Thạnh Đông, Huyện Tân Châu, Tỉnh Tây Ninh","path_with_type":"Xã Thạnh Đông, Huyện Tân Châu, Tỉnh Tây Ninh","code":"25540","parent_code":"706"},"25543":{"name":"Xã Tân Thành","type":"xa","slug":"xa-tan-thanh","name_with_type":"Xã Tân Thành","path":"Xã Tân Thành, Huyện Tân Châu, Tỉnh Tây Ninh","path_with_type":"Xã Tân Thành, Huyện Tân Châu, Tỉnh Tây Ninh","code":"25543","parent_code":"706"},"25546":{"name":"Xã Tân Phú","type":"xa","slug":"xa-tan-phu","name_with_type":"Xã Tân Phú","path":"Xã Tân Phú, Huyện Tân Châu, Tỉnh Tây Ninh","path_with_type":"Xã Tân Phú, Huyện Tân Châu, Tỉnh Tây Ninh","code":"25546","parent_code":"706"},"25549":{"name":"Xã Tân Hưng","type":"xa","slug":"xa-tan-hung","name_with_type":"Xã Tân Hưng","path":"Xã Tân Hưng, Huyện Tân Châu, Tỉnh Tây Ninh","path_with_type":"Xã Tân Hưng, Huyện Tân Châu, Tỉnh Tây Ninh","code":"25549","parent_code":"706"},"25552":{"name":"Thị trấn Dương Minh Châu","type":"thi-tran","slug":"thi-tran-duong-minh-chau","name_with_type":"Thị trấn Dương Minh Châu","path":"Thị trấn Dương Minh Châu, Huyện Dương Minh Châu, Tỉnh Tây Ninh","path_with_type":"Thị trấn Dương Minh Châu, Huyện Dương Minh Châu, Tỉnh Tây Ninh","code":"25552","parent_code":"707"},"25555":{"name":"Xã Suối Đá","type":"xa","slug":"xa-suoi-da","name_with_type":"Xã Suối Đá","path":"Xã Suối Đá, Huyện Dương Minh Châu, Tỉnh Tây Ninh","path_with_type":"Xã Suối Đá, Huyện Dương Minh Châu, Tỉnh Tây Ninh","code":"25555","parent_code":"707"},"25558":{"name":"Xã Phan","type":"xa","slug":"xa-phan","name_with_type":"Xã Phan","path":"Xã Phan, Huyện Dương Minh Châu, Tỉnh Tây Ninh","path_with_type":"Xã Phan, Huyện Dương Minh Châu, Tỉnh Tây Ninh","code":"25558","parent_code":"707"},"25561":{"name":"Xã Phước Ninh","type":"xa","slug":"xa-phuoc-ninh","name_with_type":"Xã Phước Ninh","path":"Xã Phước Ninh, Huyện Dương Minh Châu, Tỉnh Tây Ninh","path_with_type":"Xã Phước Ninh, Huyện Dương Minh Châu, Tỉnh Tây Ninh","code":"25561","parent_code":"707"},"25564":{"name":"Xã Phước Minh","type":"xa","slug":"xa-phuoc-minh","name_with_type":"Xã Phước Minh","path":"Xã Phước Minh, Huyện Dương Minh Châu, Tỉnh Tây Ninh","path_with_type":"Xã Phước Minh, Huyện Dương Minh Châu, Tỉnh Tây Ninh","code":"25564","parent_code":"707"},"25567":{"name":"Xã Bàu Năng","type":"xa","slug":"xa-bau-nang","name_with_type":"Xã Bàu Năng","path":"Xã Bàu Năng, Huyện Dương Minh Châu, Tỉnh Tây Ninh","path_with_type":"Xã Bàu Năng, Huyện Dương Minh Châu, Tỉnh Tây Ninh","code":"25567","parent_code":"707"},"25570":{"name":"Xã Chà Là","type":"xa","slug":"xa-cha-la","name_with_type":"Xã Chà Là","path":"Xã Chà Là, Huyện Dương Minh Châu, Tỉnh Tây Ninh","path_with_type":"Xã Chà Là, Huyện Dương Minh Châu, Tỉnh Tây Ninh","code":"25570","parent_code":"707"},"25573":{"name":"Xã Cầu Khởi","type":"xa","slug":"xa-cau-khoi","name_with_type":"Xã Cầu Khởi","path":"Xã Cầu Khởi, Huyện Dương Minh Châu, Tỉnh Tây Ninh","path_with_type":"Xã Cầu Khởi, Huyện Dương Minh Châu, Tỉnh Tây Ninh","code":"25573","parent_code":"707"},"25576":{"name":"Xã Bến Củi","type":"xa","slug":"xa-ben-cui","name_with_type":"Xã Bến Củi","path":"Xã Bến Củi, Huyện Dương Minh Châu, Tỉnh Tây Ninh","path_with_type":"Xã Bến Củi, Huyện Dương Minh Châu, Tỉnh Tây Ninh","code":"25576","parent_code":"707"},"25579":{"name":"Xã Lộc Ninh","type":"xa","slug":"xa-loc-ninh","name_with_type":"Xã Lộc Ninh","path":"Xã Lộc Ninh, Huyện Dương Minh Châu, Tỉnh Tây Ninh","path_with_type":"Xã Lộc Ninh, Huyện Dương Minh Châu, Tỉnh Tây Ninh","code":"25579","parent_code":"707"},"25582":{"name":"Xã Truông Mít","type":"xa","slug":"xa-truong-mit","name_with_type":"Xã Truông Mít","path":"Xã Truông Mít, Huyện Dương Minh Châu, Tỉnh Tây Ninh","path_with_type":"Xã Truông Mít, Huyện Dương Minh Châu, Tỉnh Tây Ninh","code":"25582","parent_code":"707"},"25585":{"name":"Thị trấn Châu Thành","type":"thi-tran","slug":"thi-tran-chau-thanh","name_with_type":"Thị trấn Châu Thành","path":"Thị trấn Châu Thành, Huyện Châu Thành, Tỉnh Tây Ninh","path_with_type":"Thị trấn Châu Thành, Huyện Châu Thành, Tỉnh Tây Ninh","code":"25585","parent_code":"708"},"25588":{"name":"Xã Hảo Đước","type":"xa","slug":"xa-hao-duoc","name_with_type":"Xã Hảo Đước","path":"Xã Hảo Đước, Huyện Châu Thành, Tỉnh Tây Ninh","path_with_type":"Xã Hảo Đước, Huyện Châu Thành, Tỉnh Tây Ninh","code":"25588","parent_code":"708"},"25591":{"name":"Xã Phước Vinh","type":"xa","slug":"xa-phuoc-vinh","name_with_type":"Xã Phước Vinh","path":"Xã Phước Vinh, Huyện Châu Thành, Tỉnh Tây Ninh","path_with_type":"Xã Phước Vinh, Huyện Châu Thành, Tỉnh Tây Ninh","code":"25591","parent_code":"708"},"25594":{"name":"Xã Đồng Khởi","type":"xa","slug":"xa-dong-khoi","name_with_type":"Xã Đồng Khởi","path":"Xã Đồng Khởi, Huyện Châu Thành, Tỉnh Tây Ninh","path_with_type":"Xã Đồng Khởi, Huyện Châu Thành, Tỉnh Tây Ninh","code":"25594","parent_code":"708"},"25597":{"name":"Xã Thái Bình","type":"xa","slug":"xa-thai-binh","name_with_type":"Xã Thái Bình","path":"Xã Thái Bình, Huyện Châu Thành, Tỉnh Tây Ninh","path_with_type":"Xã Thái Bình, Huyện Châu Thành, Tỉnh Tây Ninh","code":"25597","parent_code":"708"},"25600":{"name":"Xã An Cơ","type":"xa","slug":"xa-an-co","name_with_type":"Xã An Cơ","path":"Xã An Cơ, Huyện Châu Thành, Tỉnh Tây Ninh","path_with_type":"Xã An Cơ, Huyện Châu Thành, Tỉnh Tây Ninh","code":"25600","parent_code":"708"},"25603":{"name":"Xã Biên Giới","type":"xa","slug":"xa-bien-gioi","name_with_type":"Xã Biên Giới","path":"Xã Biên Giới, Huyện Châu Thành, Tỉnh Tây Ninh","path_with_type":"Xã Biên Giới, Huyện Châu Thành, Tỉnh Tây Ninh","code":"25603","parent_code":"708"},"25606":{"name":"Xã Hòa Thạnh","type":"xa","slug":"xa-hoa-thanh","name_with_type":"Xã Hòa Thạnh","path":"Xã Hòa Thạnh, Huyện Châu Thành, Tỉnh Tây Ninh","path_with_type":"Xã Hòa Thạnh, Huyện Châu Thành, Tỉnh Tây Ninh","code":"25606","parent_code":"708"},"25609":{"name":"Xã Trí Bình","type":"xa","slug":"xa-tri-binh","name_with_type":"Xã Trí Bình","path":"Xã Trí Bình, Huyện Châu Thành, Tỉnh Tây Ninh","path_with_type":"Xã Trí Bình, Huyện Châu Thành, Tỉnh Tây Ninh","code":"25609","parent_code":"708"},"25612":{"name":"Xã Hòa Hội","type":"xa","slug":"xa-hoa-hoi","name_with_type":"Xã Hòa Hội","path":"Xã Hòa Hội, Huyện Châu Thành, Tỉnh Tây Ninh","path_with_type":"Xã Hòa Hội, Huyện Châu Thành, Tỉnh Tây Ninh","code":"25612","parent_code":"708"},"25615":{"name":"Xã An Bình","type":"xa","slug":"xa-an-binh","name_with_type":"Xã An Bình","path":"Xã An Bình, Huyện Châu Thành, Tỉnh Tây Ninh","path_with_type":"Xã An Bình, Huyện Châu Thành, Tỉnh Tây Ninh","code":"25615","parent_code":"708"},"25618":{"name":"Xã Thanh Điền","type":"xa","slug":"xa-thanh-dien","name_with_type":"Xã Thanh Điền","path":"Xã Thanh Điền, Huyện Châu Thành, Tỉnh Tây Ninh","path_with_type":"Xã Thanh Điền, Huyện Châu Thành, Tỉnh Tây Ninh","code":"25618","parent_code":"708"},"25621":{"name":"Xã Thành Long","type":"xa","slug":"xa-thanh-long","name_with_type":"Xã Thành Long","path":"Xã Thành Long, Huyện Châu Thành, Tỉnh Tây Ninh","path_with_type":"Xã Thành Long, Huyện Châu Thành, Tỉnh Tây Ninh","code":"25621","parent_code":"708"},"25624":{"name":"Xã Ninh Điền","type":"xa","slug":"xa-ninh-dien","name_with_type":"Xã Ninh Điền","path":"Xã Ninh Điền, Huyện Châu Thành, Tỉnh Tây Ninh","path_with_type":"Xã Ninh Điền, Huyện Châu Thành, Tỉnh Tây Ninh","code":"25624","parent_code":"708"},"25627":{"name":"Xã Long Vĩnh","type":"xa","slug":"xa-long-vinh","name_with_type":"Xã Long Vĩnh","path":"Xã Long Vĩnh, Huyện Châu Thành, Tỉnh Tây Ninh","path_with_type":"Xã Long Vĩnh, Huyện Châu Thành, Tỉnh Tây Ninh","code":"25627","parent_code":"708"},"25630":{"name":"Phường Long Hoa","type":"phuong","slug":"phuong-long-hoa","name_with_type":"Phường Long Hoa","path":"Phường Long Hoa, Thị xã Hòa Thành, Tỉnh Tây Ninh","path_with_type":"Phường Long Hoa, Thị xã Hòa Thành, Tỉnh Tây Ninh","code":"25630","parent_code":"709"},"25633":{"name":"Phường Hiệp Tân","type":"phuong","slug":"phuong-hiep-tan","name_with_type":"Phường Hiệp Tân","path":"Phường Hiệp Tân, Thị xã Hòa Thành, Tỉnh Tây Ninh","path_with_type":"Phường Hiệp Tân, Thị xã Hòa Thành, Tỉnh Tây Ninh","code":"25633","parent_code":"709"},"25636":{"name":"Phường Long Thành Bắc","type":"phuong","slug":"phuong-long-thanh-bac","name_with_type":"Phường Long Thành Bắc","path":"Phường Long Thành Bắc, Thị xã Hòa Thành, Tỉnh Tây Ninh","path_with_type":"Phường Long Thành Bắc, Thị xã Hòa Thành, Tỉnh Tây Ninh","code":"25636","parent_code":"709"},"25639":{"name":"Xã Trường Hòa","type":"xa","slug":"xa-truong-hoa","name_with_type":"Xã Trường Hòa","path":"Xã Trường Hòa, Thị xã Hòa Thành, Tỉnh Tây Ninh","path_with_type":"Xã Trường Hòa, Thị xã Hòa Thành, Tỉnh Tây Ninh","code":"25639","parent_code":"709"},"25642":{"name":"Xã Trường Đông","type":"xa","slug":"xa-truong-dong","name_with_type":"Xã Trường Đông","path":"Xã Trường Đông, Thị xã Hòa Thành, Tỉnh Tây Ninh","path_with_type":"Xã Trường Đông, Thị xã Hòa Thành, Tỉnh Tây Ninh","code":"25642","parent_code":"709"},"25645":{"name":"Phường Long Thành Trung","type":"phuong","slug":"phuong-long-thanh-trung","name_with_type":"Phường Long Thành Trung","path":"Phường Long Thành Trung, Thị xã Hòa Thành, Tỉnh Tây Ninh","path_with_type":"Phường Long Thành Trung, Thị xã Hòa Thành, Tỉnh Tây Ninh","code":"25645","parent_code":"709"},"25648":{"name":"Xã Trường Tây","type":"xa","slug":"xa-truong-tay","name_with_type":"Xã Trường Tây","path":"Xã Trường Tây, Thị xã Hòa Thành, Tỉnh Tây Ninh","path_with_type":"Xã Trường Tây, Thị xã Hòa Thành, Tỉnh Tây Ninh","code":"25648","parent_code":"709"},"25651":{"name":"Xã Long Thành Nam","type":"xa","slug":"xa-long-thanh-nam","name_with_type":"Xã Long Thành Nam","path":"Xã Long Thành Nam, Thị xã Hòa Thành, Tỉnh Tây Ninh","path_with_type":"Xã Long Thành Nam, Thị xã Hòa Thành, Tỉnh Tây Ninh","code":"25651","parent_code":"709"},"25654":{"name":"Thị trấn Gò Dầu","type":"thi-tran","slug":"thi-tran-go-dau","name_with_type":"Thị trấn Gò Dầu","path":"Thị trấn Gò Dầu, Huyện Gò Dầu, Tỉnh Tây Ninh","path_with_type":"Thị trấn Gò Dầu, Huyện Gò Dầu, Tỉnh Tây Ninh","code":"25654","parent_code":"710"},"25657":{"name":"Xã Thạnh Đức","type":"xa","slug":"xa-thanh-duc","name_with_type":"Xã Thạnh Đức","path":"Xã Thạnh Đức, Huyện Gò Dầu, Tỉnh Tây Ninh","path_with_type":"Xã Thạnh Đức, Huyện Gò Dầu, Tỉnh Tây Ninh","code":"25657","parent_code":"710"},"25660":{"name":"Xã Cẩm Giang","type":"xa","slug":"xa-cam-giang","name_with_type":"Xã Cẩm Giang","path":"Xã Cẩm Giang, Huyện Gò Dầu, Tỉnh Tây Ninh","path_with_type":"Xã Cẩm Giang, Huyện Gò Dầu, Tỉnh Tây Ninh","code":"25660","parent_code":"710"},"25663":{"name":"Xã Hiệp Thạnh","type":"xa","slug":"xa-hiep-thanh","name_with_type":"Xã Hiệp Thạnh","path":"Xã Hiệp Thạnh, Huyện Gò Dầu, Tỉnh Tây Ninh","path_with_type":"Xã Hiệp Thạnh, Huyện Gò Dầu, Tỉnh Tây Ninh","code":"25663","parent_code":"710"},"25666":{"name":"Xã Bàu Đồn","type":"xa","slug":"xa-bau-don","name_with_type":"Xã Bàu Đồn","path":"Xã Bàu Đồn, Huyện Gò Dầu, Tỉnh Tây Ninh","path_with_type":"Xã Bàu Đồn, Huyện Gò Dầu, Tỉnh Tây Ninh","code":"25666","parent_code":"710"},"25669":{"name":"Xã Phước Thạnh","type":"xa","slug":"xa-phuoc-thanh","name_with_type":"Xã Phước Thạnh","path":"Xã Phước Thạnh, Huyện Gò Dầu, Tỉnh Tây Ninh","path_with_type":"Xã Phước Thạnh, Huyện Gò Dầu, Tỉnh Tây Ninh","code":"25669","parent_code":"710"},"25672":{"name":"Xã Phước Đông","type":"xa","slug":"xa-phuoc-dong","name_with_type":"Xã Phước Đông","path":"Xã Phước Đông, Huyện Gò Dầu, Tỉnh Tây Ninh","path_with_type":"Xã Phước Đông, Huyện Gò Dầu, Tỉnh Tây Ninh","code":"25672","parent_code":"710"},"25675":{"name":"Xã Phước Trạch","type":"xa","slug":"xa-phuoc-trach","name_with_type":"Xã Phước Trạch","path":"Xã Phước Trạch, Huyện Gò Dầu, Tỉnh Tây Ninh","path_with_type":"Xã Phước Trạch, Huyện Gò Dầu, Tỉnh Tây Ninh","code":"25675","parent_code":"710"},"25678":{"name":"Xã Thanh Phước","type":"xa","slug":"xa-thanh-phuoc","name_with_type":"Xã Thanh Phước","path":"Xã Thanh Phước, Huyện Gò Dầu, Tỉnh Tây Ninh","path_with_type":"Xã Thanh Phước, Huyện Gò Dầu, Tỉnh Tây Ninh","code":"25678","parent_code":"710"},"25681":{"name":"Thị trấn Bến Cầu","type":"thi-tran","slug":"thi-tran-ben-cau","name_with_type":"Thị trấn Bến Cầu","path":"Thị trấn Bến Cầu, Huyện Bến Cầu, Tỉnh Tây Ninh","path_with_type":"Thị trấn Bến Cầu, Huyện Bến Cầu, Tỉnh Tây Ninh","code":"25681","parent_code":"711"},"25684":{"name":"Xã Long Chữ","type":"xa","slug":"xa-long-chu","name_with_type":"Xã Long Chữ","path":"Xã Long Chữ, Huyện Bến Cầu, Tỉnh Tây Ninh","path_with_type":"Xã Long Chữ, Huyện Bến Cầu, Tỉnh Tây Ninh","code":"25684","parent_code":"711"},"25687":{"name":"Xã Long Phước","type":"xa","slug":"xa-long-phuoc","name_with_type":"Xã Long Phước","path":"Xã Long Phước, Huyện Bến Cầu, Tỉnh Tây Ninh","path_with_type":"Xã Long Phước, Huyện Bến Cầu, Tỉnh Tây Ninh","code":"25687","parent_code":"711"},"25690":{"name":"Xã Long Giang","type":"xa","slug":"xa-long-giang","name_with_type":"Xã Long Giang","path":"Xã Long Giang, Huyện Bến Cầu, Tỉnh Tây Ninh","path_with_type":"Xã Long Giang, Huyện Bến Cầu, Tỉnh Tây Ninh","code":"25690","parent_code":"711"},"25693":{"name":"Xã Tiên Thuận","type":"xa","slug":"xa-tien-thuan","name_with_type":"Xã Tiên Thuận","path":"Xã Tiên Thuận, Huyện Bến Cầu, Tỉnh Tây Ninh","path_with_type":"Xã Tiên Thuận, Huyện Bến Cầu, Tỉnh Tây Ninh","code":"25693","parent_code":"711"},"25696":{"name":"Xã Long Khánh","type":"xa","slug":"xa-long-khanh","name_with_type":"Xã Long Khánh","path":"Xã Long Khánh, Huyện Bến Cầu, Tỉnh Tây Ninh","path_with_type":"Xã Long Khánh, Huyện Bến Cầu, Tỉnh Tây Ninh","code":"25696","parent_code":"711"},"25699":{"name":"Xã Lợi Thuận","type":"xa","slug":"xa-loi-thuan","name_with_type":"Xã Lợi Thuận","path":"Xã Lợi Thuận, Huyện Bến Cầu, Tỉnh Tây Ninh","path_with_type":"Xã Lợi Thuận, Huyện Bến Cầu, Tỉnh Tây Ninh","code":"25699","parent_code":"711"},"25702":{"name":"Xã Long Thuận","type":"xa","slug":"xa-long-thuan","name_with_type":"Xã Long Thuận","path":"Xã Long Thuận, Huyện Bến Cầu, Tỉnh Tây Ninh","path_with_type":"Xã Long Thuận, Huyện Bến Cầu, Tỉnh Tây Ninh","code":"25702","parent_code":"711"},"25705":{"name":"Xã An Thạnh","type":"xa","slug":"xa-an-thanh","name_with_type":"Xã An Thạnh","path":"Xã An Thạnh, Huyện Bến Cầu, Tỉnh Tây Ninh","path_with_type":"Xã An Thạnh, Huyện Bến Cầu, Tỉnh Tây Ninh","code":"25705","parent_code":"711"},"25708":{"name":"Phường Trảng Bàng","type":"phuong","slug":"phuong-trang-bang","name_with_type":"Phường Trảng Bàng","path":"Phường Trảng Bàng, Thị xã Trảng Bàng, Tỉnh Tây Ninh","path_with_type":"Phường Trảng Bàng, Thị xã Trảng Bàng, Tỉnh Tây Ninh","code":"25708","parent_code":"712"},"25711":{"name":"Xã Đôn Thuận","type":"xa","slug":"xa-don-thuan","name_with_type":"Xã Đôn Thuận","path":"Xã Đôn Thuận, Thị xã Trảng Bàng, Tỉnh Tây Ninh","path_with_type":"Xã Đôn Thuận, Thị xã Trảng Bàng, Tỉnh Tây Ninh","code":"25711","parent_code":"712"},"25714":{"name":"Xã Hưng Thuận","type":"xa","slug":"xa-hung-thuan","name_with_type":"Xã Hưng Thuận","path":"Xã Hưng Thuận, Thị xã Trảng Bàng, Tỉnh Tây Ninh","path_with_type":"Xã Hưng Thuận, Thị xã Trảng Bàng, Tỉnh Tây Ninh","code":"25714","parent_code":"712"},"25717":{"name":"Phường Lộc Hưng","type":"phuong","slug":"phuong-loc-hung","name_with_type":"Phường Lộc Hưng","path":"Phường Lộc Hưng, Thị xã Trảng Bàng, Tỉnh Tây Ninh","path_with_type":"Phường Lộc Hưng, Thị xã Trảng Bàng, Tỉnh Tây Ninh","code":"25717","parent_code":"712"},"25720":{"name":"Phường Gia Lộc","type":"phuong","slug":"phuong-gia-loc","name_with_type":"Phường Gia Lộc","path":"Phường Gia Lộc, Thị xã Trảng Bàng, Tỉnh Tây Ninh","path_with_type":"Phường Gia Lộc, Thị xã Trảng Bàng, Tỉnh Tây Ninh","code":"25720","parent_code":"712"},"25723":{"name":"Phường Gia Bình","type":"phuong","slug":"phuong-gia-binh","name_with_type":"Phường Gia Bình","path":"Phường Gia Bình, Thị xã Trảng Bàng, Tỉnh Tây Ninh","path_with_type":"Phường Gia Bình, Thị xã Trảng Bàng, Tỉnh Tây Ninh","code":"25723","parent_code":"712"},"25729":{"name":"Xã Phước Bình","type":"xa","slug":"xa-phuoc-binh","name_with_type":"Xã Phước Bình","path":"Xã Phước Bình, Thị xã Trảng Bàng, Tỉnh Tây Ninh","path_with_type":"Xã Phước Bình, Thị xã Trảng Bàng, Tỉnh Tây Ninh","code":"25729","parent_code":"712"},"25732":{"name":"Phường An Tịnh","type":"phuong","slug":"phuong-an-tinh","name_with_type":"Phường An Tịnh","path":"Phường An Tịnh, Thị xã Trảng Bàng, Tỉnh Tây Ninh","path_with_type":"Phường An Tịnh, Thị xã Trảng Bàng, Tỉnh Tây Ninh","code":"25732","parent_code":"712"},"25735":{"name":"Phường An Hòa","type":"phuong","slug":"phuong-an-hoa","name_with_type":"Phường An Hòa","path":"Phường An Hòa, Thị xã Trảng Bàng, Tỉnh Tây Ninh","path_with_type":"Phường An Hòa, Thị xã Trảng Bàng, Tỉnh Tây Ninh","code":"25735","parent_code":"712"},"25738":{"name":"Xã Phước Chỉ","type":"xa","slug":"xa-phuoc-chi","name_with_type":"Xã Phước Chỉ","path":"Xã Phước Chỉ, Thị xã Trảng Bàng, Tỉnh Tây Ninh","path_with_type":"Xã Phước Chỉ, Thị xã Trảng Bàng, Tỉnh Tây Ninh","code":"25738","parent_code":"712"},"25741":{"name":"Phường Hiệp Thành","type":"phuong","slug":"phuong-hiep-thanh","name_with_type":"Phường Hiệp Thành","path":"Phường Hiệp Thành, Thành phố Thủ Dầu Một, Tỉnh Bình Dương","path_with_type":"Phường Hiệp Thành, Thành phố Thủ Dầu Một, Tỉnh Bình Dương","code":"25741","parent_code":"718"},"25744":{"name":"Phường Phú Lợi","type":"phuong","slug":"phuong-phu-loi","name_with_type":"Phường Phú Lợi","path":"Phường Phú Lợi, Thành phố Thủ Dầu Một, Tỉnh Bình Dương","path_with_type":"Phường Phú Lợi, Thành phố Thủ Dầu Một, Tỉnh Bình Dương","code":"25744","parent_code":"718"},"25747":{"name":"Phường Phú Cường","type":"phuong","slug":"phuong-phu-cuong","name_with_type":"Phường Phú Cường","path":"Phường Phú Cường, Thành phố Thủ Dầu Một, Tỉnh Bình Dương","path_with_type":"Phường Phú Cường, Thành phố Thủ Dầu Một, Tỉnh Bình Dương","code":"25747","parent_code":"718"},"25750":{"name":"Phường Phú Hòa","type":"phuong","slug":"phuong-phu-hoa","name_with_type":"Phường Phú Hòa","path":"Phường Phú Hòa, Thành phố Thủ Dầu Một, Tỉnh Bình Dương","path_with_type":"Phường Phú Hòa, Thành phố Thủ Dầu Một, Tỉnh Bình Dương","code":"25750","parent_code":"718"},"25753":{"name":"Phường Phú Thọ","type":"phuong","slug":"phuong-phu-tho","name_with_type":"Phường Phú Thọ","path":"Phường Phú Thọ, Thành phố Thủ Dầu Một, Tỉnh Bình Dương","path_with_type":"Phường Phú Thọ, Thành phố Thủ Dầu Một, Tỉnh Bình Dương","code":"25753","parent_code":"718"},"25756":{"name":"Phường Chánh Nghĩa","type":"phuong","slug":"phuong-chanh-nghia","name_with_type":"Phường Chánh Nghĩa","path":"Phường Chánh Nghĩa, Thành phố Thủ Dầu Một, Tỉnh Bình Dương","path_with_type":"Phường Chánh Nghĩa, Thành phố Thủ Dầu Một, Tỉnh Bình Dương","code":"25756","parent_code":"718"},"25759":{"name":"Phường Định Hoà","type":"phuong","slug":"phuong-dinh-hoa","name_with_type":"Phường Định Hoà","path":"Phường Định Hoà, Thành phố Thủ Dầu Một, Tỉnh Bình Dương","path_with_type":"Phường Định Hoà, Thành phố Thủ Dầu Một, Tỉnh Bình Dương","code":"25759","parent_code":"718"},"25760":{"name":"Phường Hoà Phú","type":"phuong","slug":"phuong-hoa-phu","name_with_type":"Phường Hoà Phú","path":"Phường Hoà Phú, Thành phố Thủ Dầu Một, Tỉnh Bình Dương","path_with_type":"Phường Hoà Phú, Thành phố Thủ Dầu Một, Tỉnh Bình Dương","code":"25760","parent_code":"718"},"25762":{"name":"Phường Phú Mỹ","type":"phuong","slug":"phuong-phu-my","name_with_type":"Phường Phú Mỹ","path":"Phường Phú Mỹ, Thành phố Thủ Dầu Một, Tỉnh Bình Dương","path_with_type":"Phường Phú Mỹ, Thành phố Thủ Dầu Một, Tỉnh Bình Dương","code":"25762","parent_code":"718"},"25763":{"name":"Phường Phú Tân","type":"phuong","slug":"phuong-phu-tan","name_with_type":"Phường Phú Tân","path":"Phường Phú Tân, Thành phố Thủ Dầu Một, Tỉnh Bình Dương","path_with_type":"Phường Phú Tân, Thành phố Thủ Dầu Một, Tỉnh Bình Dương","code":"25763","parent_code":"718"},"25765":{"name":"Phường Tân An","type":"phuong","slug":"phuong-tan-an","name_with_type":"Phường Tân An","path":"Phường Tân An, Thành phố Thủ Dầu Một, Tỉnh Bình Dương","path_with_type":"Phường Tân An, Thành phố Thủ Dầu Một, Tỉnh Bình Dương","code":"25765","parent_code":"718"},"25768":{"name":"Phường Hiệp An","type":"phuong","slug":"phuong-hiep-an","name_with_type":"Phường Hiệp An","path":"Phường Hiệp An, Thành phố Thủ Dầu Một, Tỉnh Bình Dương","path_with_type":"Phường Hiệp An, Thành phố Thủ Dầu Một, Tỉnh Bình Dương","code":"25768","parent_code":"718"},"25771":{"name":"Phường Tương Bình Hiệp","type":"phuong","slug":"phuong-tuong-binh-hiep","name_with_type":"Phường Tương Bình Hiệp","path":"Phường Tương Bình Hiệp, Thành phố Thủ Dầu Một, Tỉnh Bình Dương","path_with_type":"Phường Tương Bình Hiệp, Thành phố Thủ Dầu Một, Tỉnh Bình Dương","code":"25771","parent_code":"718"},"25774":{"name":"Phường Chánh Mỹ","type":"phuong","slug":"phuong-chanh-my","name_with_type":"Phường Chánh Mỹ","path":"Phường Chánh Mỹ, Thành phố Thủ Dầu Một, Tỉnh Bình Dương","path_with_type":"Phường Chánh Mỹ, Thành phố Thủ Dầu Một, Tỉnh Bình Dương","code":"25774","parent_code":"718"},"25777":{"name":"Thị trấn Dầu Tiếng","type":"thi-tran","slug":"thi-tran-dau-tieng","name_with_type":"Thị trấn Dầu Tiếng","path":"Thị trấn Dầu Tiếng, Huyện Dầu Tiếng, Tỉnh Bình Dương","path_with_type":"Thị trấn Dầu Tiếng, Huyện Dầu Tiếng, Tỉnh Bình Dương","code":"25777","parent_code":"720"},"25780":{"name":"Xã Minh Hoà","type":"xa","slug":"xa-minh-hoa","name_with_type":"Xã Minh Hoà","path":"Xã Minh Hoà, Huyện Dầu Tiếng, Tỉnh Bình Dương","path_with_type":"Xã Minh Hoà, Huyện Dầu Tiếng, Tỉnh Bình Dương","code":"25780","parent_code":"720"},"25783":{"name":"Xã Minh Thạnh","type":"xa","slug":"xa-minh-thanh","name_with_type":"Xã Minh Thạnh","path":"Xã Minh Thạnh, Huyện Dầu Tiếng, Tỉnh Bình Dương","path_with_type":"Xã Minh Thạnh, Huyện Dầu Tiếng, Tỉnh Bình Dương","code":"25783","parent_code":"720"},"25786":{"name":"Xã Minh Tân","type":"xa","slug":"xa-minh-tan","name_with_type":"Xã Minh Tân","path":"Xã Minh Tân, Huyện Dầu Tiếng, Tỉnh Bình Dương","path_with_type":"Xã Minh Tân, Huyện Dầu Tiếng, Tỉnh Bình Dương","code":"25786","parent_code":"720"},"25789":{"name":"Xã Định An","type":"xa","slug":"xa-dinh-an","name_with_type":"Xã Định An","path":"Xã Định An, Huyện Dầu Tiếng, Tỉnh Bình Dương","path_with_type":"Xã Định An, Huyện Dầu Tiếng, Tỉnh Bình Dương","code":"25789","parent_code":"720"},"25792":{"name":"Xã Long Hoà","type":"xa","slug":"xa-long-hoa","name_with_type":"Xã Long Hoà","path":"Xã Long Hoà, Huyện Dầu Tiếng, Tỉnh Bình Dương","path_with_type":"Xã Long Hoà, Huyện Dầu Tiếng, Tỉnh Bình Dương","code":"25792","parent_code":"720"},"25795":{"name":"Xã Định Thành","type":"xa","slug":"xa-dinh-thanh","name_with_type":"Xã Định Thành","path":"Xã Định Thành, Huyện Dầu Tiếng, Tỉnh Bình Dương","path_with_type":"Xã Định Thành, Huyện Dầu Tiếng, Tỉnh Bình Dương","code":"25795","parent_code":"720"},"25798":{"name":"Xã Định Hiệp","type":"xa","slug":"xa-dinh-hiep","name_with_type":"Xã Định Hiệp","path":"Xã Định Hiệp, Huyện Dầu Tiếng, Tỉnh Bình Dương","path_with_type":"Xã Định Hiệp, Huyện Dầu Tiếng, Tỉnh Bình Dương","code":"25798","parent_code":"720"},"25801":{"name":"Xã An Lập","type":"xa","slug":"xa-an-lap","name_with_type":"Xã An Lập","path":"Xã An Lập, Huyện Dầu Tiếng, Tỉnh Bình Dương","path_with_type":"Xã An Lập, Huyện Dầu Tiếng, Tỉnh Bình Dương","code":"25801","parent_code":"720"},"25804":{"name":"Xã Long Tân","type":"xa","slug":"xa-long-tan","name_with_type":"Xã Long Tân","path":"Xã Long Tân, Huyện Dầu Tiếng, Tỉnh Bình Dương","path_with_type":"Xã Long Tân, Huyện Dầu Tiếng, Tỉnh Bình Dương","code":"25804","parent_code":"720"},"25807":{"name":"Xã Thanh An","type":"xa","slug":"xa-thanh-an","name_with_type":"Xã Thanh An","path":"Xã Thanh An, Huyện Dầu Tiếng, Tỉnh Bình Dương","path_with_type":"Xã Thanh An, Huyện Dầu Tiếng, Tỉnh Bình Dương","code":"25807","parent_code":"720"},"25810":{"name":"Xã Thanh Tuyền","type":"xa","slug":"xa-thanh-tuyen","name_with_type":"Xã Thanh Tuyền","path":"Xã Thanh Tuyền, Huyện Dầu Tiếng, Tỉnh Bình Dương","path_with_type":"Xã Thanh Tuyền, Huyện Dầu Tiếng, Tỉnh Bình Dương","code":"25810","parent_code":"720"},"25813":{"name":"Phường Mỹ Phước","type":"phuong","slug":"phuong-my-phuoc","name_with_type":"Phường Mỹ Phước","path":"Phường Mỹ Phước, Thành phố Bến Cát, Tỉnh Bình Dương","path_with_type":"Phường Mỹ Phước, Thành phố Bến Cát, Tỉnh Bình Dương","code":"25813","parent_code":"721"},"25816":{"name":"Xã Trừ Văn Thố","type":"xa","slug":"xa-tru-van-tho","name_with_type":"Xã Trừ Văn Thố","path":"Xã Trừ Văn Thố, Huyện Bàu Bàng, Tỉnh Bình Dương","path_with_type":"Xã Trừ Văn Thố, Huyện Bàu Bàng, Tỉnh Bình Dương","code":"25816","parent_code":"719"},"25819":{"name":"Xã Cây Trường II","type":"xa","slug":"xa-cay-truong-ii","name_with_type":"Xã Cây Trường II","path":"Xã Cây Trường II, Huyện Bàu Bàng, Tỉnh Bình Dương","path_with_type":"Xã Cây Trường II, Huyện Bàu Bàng, Tỉnh Bình Dương","code":"25819","parent_code":"719"},"25822":{"name":"Thị trấn Lai Uyên","type":"thi-tran","slug":"thi-tran-lai-uyen","name_with_type":"Thị trấn Lai Uyên","path":"Thị trấn Lai Uyên, Huyện Bàu Bàng, Tỉnh Bình Dương","path_with_type":"Thị trấn Lai Uyên, Huyện Bàu Bàng, Tỉnh Bình Dương","code":"25822","parent_code":"719"},"25825":{"name":"Xã Tân Hưng","type":"xa","slug":"xa-tan-hung","name_with_type":"Xã Tân Hưng","path":"Xã Tân Hưng, Huyện Bàu Bàng, Tỉnh Bình Dương","path_with_type":"Xã Tân Hưng, Huyện Bàu Bàng, Tỉnh Bình Dương","code":"25825","parent_code":"719"},"25828":{"name":"Xã Long Nguyên","type":"xa","slug":"xa-long-nguyen","name_with_type":"Xã Long Nguyên","path":"Xã Long Nguyên, Huyện Bàu Bàng, Tỉnh Bình Dương","path_with_type":"Xã Long Nguyên, Huyện Bàu Bàng, Tỉnh Bình Dương","code":"25828","parent_code":"719"},"25831":{"name":"Xã Hưng Hòa","type":"xa","slug":"xa-hung-hoa","name_with_type":"Xã Hưng Hòa","path":"Xã Hưng Hòa, Huyện Bàu Bàng, Tỉnh Bình Dương","path_with_type":"Xã Hưng Hòa, Huyện Bàu Bàng, Tỉnh Bình Dương","code":"25831","parent_code":"719"},"25834":{"name":"Xã Lai Hưng","type":"xa","slug":"xa-lai-hung","name_with_type":"Xã Lai Hưng","path":"Xã Lai Hưng, Huyện Bàu Bàng, Tỉnh Bình Dương","path_with_type":"Xã Lai Hưng, Huyện Bàu Bàng, Tỉnh Bình Dương","code":"25834","parent_code":"719"},"25837":{"name":"Phường Chánh Phú Hòa","type":"phuong","slug":"phuong-chanh-phu-hoa","name_with_type":"Phường Chánh Phú Hòa","path":"Phường Chánh Phú Hòa, Thành phố Bến Cát, Tỉnh Bình Dương","path_with_type":"Phường Chánh Phú Hòa, Thành phố Bến Cát, Tỉnh Bình Dương","code":"25837","parent_code":"721"},"25840":{"name":"Phường An Điền","type":"phuong","slug":"phuong-an-dien","name_with_type":"Phường An Điền","path":"Phường An Điền, Thành phố Bến Cát, Tỉnh Bình Dương","path_with_type":"Phường An Điền, Thành phố Bến Cát, Tỉnh Bình Dương","code":"25840","parent_code":"721"},"25843":{"name":"Phường An Tây","type":"phuong","slug":"phuong-an-tay","name_with_type":"Phường An Tây","path":"Phường An Tây, Thành phố Bến Cát, Tỉnh Bình Dương","path_with_type":"Phường An Tây, Thành phố Bến Cát, Tỉnh Bình Dương","code":"25843","parent_code":"721"},"25846":{"name":"Phường Thới Hòa","type":"phuong","slug":"phuong-thoi-hoa","name_with_type":"Phường Thới Hòa","path":"Phường Thới Hòa, Thành phố Bến Cát, Tỉnh Bình Dương","path_with_type":"Phường Thới Hòa, Thành phố Bến Cát, Tỉnh Bình Dương","code":"25846","parent_code":"721"},"25849":{"name":"Phường Hòa Lợi","type":"phuong","slug":"phuong-hoa-loi","name_with_type":"Phường Hòa Lợi","path":"Phường Hòa Lợi, Thành phố Bến Cát, Tỉnh Bình Dương","path_with_type":"Phường Hòa Lợi, Thành phố Bến Cát, Tỉnh Bình Dương","code":"25849","parent_code":"721"},"25852":{"name":"Phường Tân Định","type":"phuong","slug":"phuong-tan-dinh","name_with_type":"Phường Tân Định","path":"Phường Tân Định, Thành phố Bến Cát, Tỉnh Bình Dương","path_with_type":"Phường Tân Định, Thành phố Bến Cát, Tỉnh Bình Dương","code":"25852","parent_code":"721"},"25855":{"name":"Xã Phú An","type":"xa","slug":"xa-phu-an","name_with_type":"Xã Phú An","path":"Xã Phú An, Thành phố Bến Cát, Tỉnh Bình Dương","path_with_type":"Xã Phú An, Thành phố Bến Cát, Tỉnh Bình Dương","code":"25855","parent_code":"721"},"25858":{"name":"Thị trấn Phước Vĩnh","type":"thi-tran","slug":"thi-tran-phuoc-vinh","name_with_type":"Thị trấn Phước Vĩnh","path":"Thị trấn Phước Vĩnh, Huyện Phú Giáo, Tỉnh Bình Dương","path_with_type":"Thị trấn Phước Vĩnh, Huyện Phú Giáo, Tỉnh Bình Dương","code":"25858","parent_code":"722"},"25861":{"name":"Xã An Linh","type":"xa","slug":"xa-an-linh","name_with_type":"Xã An Linh","path":"Xã An Linh, Huyện Phú Giáo, Tỉnh Bình Dương","path_with_type":"Xã An Linh, Huyện Phú Giáo, Tỉnh Bình Dương","code":"25861","parent_code":"722"},"25864":{"name":"Xã Phước Sang","type":"xa","slug":"xa-phuoc-sang","name_with_type":"Xã Phước Sang","path":"Xã Phước Sang, Huyện Phú Giáo, Tỉnh Bình Dương","path_with_type":"Xã Phước Sang, Huyện Phú Giáo, Tỉnh Bình Dương","code":"25864","parent_code":"722"},"25865":{"name":"Xã An Thái","type":"xa","slug":"xa-an-thai","name_with_type":"Xã An Thái","path":"Xã An Thái, Huyện Phú Giáo, Tỉnh Bình Dương","path_with_type":"Xã An Thái, Huyện Phú Giáo, Tỉnh Bình Dương","code":"25865","parent_code":"722"},"25867":{"name":"Xã An Long","type":"xa","slug":"xa-an-long","name_with_type":"Xã An Long","path":"Xã An Long, Huyện Phú Giáo, Tỉnh Bình Dương","path_with_type":"Xã An Long, Huyện Phú Giáo, Tỉnh Bình Dương","code":"25867","parent_code":"722"},"25870":{"name":"Xã An Bình","type":"xa","slug":"xa-an-binh","name_with_type":"Xã An Bình","path":"Xã An Bình, Huyện Phú Giáo, Tỉnh Bình Dương","path_with_type":"Xã An Bình, Huyện Phú Giáo, Tỉnh Bình Dương","code":"25870","parent_code":"722"},"25873":{"name":"Xã Tân Hiệp","type":"xa","slug":"xa-tan-hiep","name_with_type":"Xã Tân Hiệp","path":"Xã Tân Hiệp, Huyện Phú Giáo, Tỉnh Bình Dương","path_with_type":"Xã Tân Hiệp, Huyện Phú Giáo, Tỉnh Bình Dương","code":"25873","parent_code":"722"},"25876":{"name":"Xã Tam Lập","type":"xa","slug":"xa-tam-lap","name_with_type":"Xã Tam Lập","path":"Xã Tam Lập, Huyện Phú Giáo, Tỉnh Bình Dương","path_with_type":"Xã Tam Lập, Huyện Phú Giáo, Tỉnh Bình Dương","code":"25876","parent_code":"722"},"25879":{"name":"Xã Tân Long","type":"xa","slug":"xa-tan-long","name_with_type":"Xã Tân Long","path":"Xã Tân Long, Huyện Phú Giáo, Tỉnh Bình Dương","path_with_type":"Xã Tân Long, Huyện Phú Giáo, Tỉnh Bình Dương","code":"25879","parent_code":"722"},"25882":{"name":"Xã Vĩnh Hoà","type":"xa","slug":"xa-vinh-hoa","name_with_type":"Xã Vĩnh Hoà","path":"Xã Vĩnh Hoà, Huyện Phú Giáo, Tỉnh Bình Dương","path_with_type":"Xã Vĩnh Hoà, Huyện Phú Giáo, Tỉnh Bình Dương","code":"25882","parent_code":"722"},"25885":{"name":"Xã Phước Hoà","type":"xa","slug":"xa-phuoc-hoa","name_with_type":"Xã Phước Hoà","path":"Xã Phước Hoà, Huyện Phú Giáo, Tỉnh Bình Dương","path_with_type":"Xã Phước Hoà, Huyện Phú Giáo, Tỉnh Bình Dương","code":"25885","parent_code":"722"},"25888":{"name":"Phường Uyên Hưng","type":"phuong","slug":"phuong-uyen-hung","name_with_type":"Phường Uyên Hưng","path":"Phường Uyên Hưng, Thành phố Tân Uyên, Tỉnh Bình Dương","path_with_type":"Phường Uyên Hưng, Thành phố Tân Uyên, Tỉnh Bình Dương","code":"25888","parent_code":"723"},"25891":{"name":"Phường Tân Phước Khánh","type":"phuong","slug":"phuong-tan-phuoc-khanh","name_with_type":"Phường Tân Phước Khánh","path":"Phường Tân Phước Khánh, Thành phố Tân Uyên, Tỉnh Bình Dương","path_with_type":"Phường Tân Phước Khánh, Thành phố Tân Uyên, Tỉnh Bình Dương","code":"25891","parent_code":"723"},"25894":{"name":"Xã Tân Định","type":"xa","slug":"xa-tan-dinh","name_with_type":"Xã Tân Định","path":"Xã Tân Định, Huyện Bắc Tân Uyên, Tỉnh Bình Dương","path_with_type":"Xã Tân Định, Huyện Bắc Tân Uyên, Tỉnh Bình Dương","code":"25894","parent_code":"726"},"25897":{"name":"Xã Bình Mỹ","type":"xa","slug":"xa-binh-my","name_with_type":"Xã Bình Mỹ","path":"Xã Bình Mỹ, Huyện Bắc Tân Uyên, Tỉnh Bình Dương","path_with_type":"Xã Bình Mỹ, Huyện Bắc Tân Uyên, Tỉnh Bình Dương","code":"25897","parent_code":"726"},"25900":{"name":"Thị trấn Tân Bình","type":"thi-tran","slug":"thi-tran-tan-binh","name_with_type":"Thị trấn Tân Bình","path":"Thị trấn Tân Bình, Huyện Bắc Tân Uyên, Tỉnh Bình Dương","path_with_type":"Thị trấn Tân Bình, Huyện Bắc Tân Uyên, Tỉnh Bình Dương","code":"25900","parent_code":"726"},"25903":{"name":"Xã Tân Lập","type":"xa","slug":"xa-tan-lap","name_with_type":"Xã Tân Lập","path":"Xã Tân Lập, Huyện Bắc Tân Uyên, Tỉnh Bình Dương","path_with_type":"Xã Tân Lập, Huyện Bắc Tân Uyên, Tỉnh Bình Dương","code":"25903","parent_code":"726"},"25906":{"name":"Thị trấn Tân Thành","type":"thi-tran","slug":"thi-tran-tan-thanh","name_with_type":"Thị trấn Tân Thành","path":"Thị trấn Tân Thành, Huyện Bắc Tân Uyên, Tỉnh Bình Dương","path_with_type":"Thị trấn Tân Thành, Huyện Bắc Tân Uyên, Tỉnh Bình Dương","code":"25906","parent_code":"726"},"25907":{"name":"Xã Đất Cuốc","type":"xa","slug":"xa-dat-cuoc","name_with_type":"Xã Đất Cuốc","path":"Xã Đất Cuốc, Huyện Bắc Tân Uyên, Tỉnh Bình Dương","path_with_type":"Xã Đất Cuốc, Huyện Bắc Tân Uyên, Tỉnh Bình Dương","code":"25907","parent_code":"726"},"25908":{"name":"Xã Hiếu Liêm","type":"xa","slug":"xa-hieu-liem","name_with_type":"Xã Hiếu Liêm","path":"Xã Hiếu Liêm, Huyện Bắc Tân Uyên, Tỉnh Bình Dương","path_with_type":"Xã Hiếu Liêm, Huyện Bắc Tân Uyên, Tỉnh Bình Dương","code":"25908","parent_code":"726"},"25909":{"name":"Xã Lạc An","type":"xa","slug":"xa-lac-an","name_with_type":"Xã Lạc An","path":"Xã Lạc An, Huyện Bắc Tân Uyên, Tỉnh Bình Dương","path_with_type":"Xã Lạc An, Huyện Bắc Tân Uyên, Tỉnh Bình Dương","code":"25909","parent_code":"726"},"25912":{"name":"Phường Vĩnh Tân","type":"phuong","slug":"phuong-vinh-tan","name_with_type":"Phường Vĩnh Tân","path":"Phường Vĩnh Tân, Thành phố Tân Uyên, Tỉnh Bình Dương","path_with_type":"Phường Vĩnh Tân, Thành phố Tân Uyên, Tỉnh Bình Dương","code":"25912","parent_code":"723"},"25915":{"name":"Phường Hội Nghĩa","type":"phuong","slug":"phuong-hoi-nghia","name_with_type":"Phường Hội Nghĩa","path":"Phường Hội Nghĩa, Thành phố Tân Uyên, Tỉnh Bình Dương","path_with_type":"Phường Hội Nghĩa, Thành phố Tân Uyên, Tỉnh Bình Dương","code":"25915","parent_code":"723"},"25918":{"name":"Xã Tân Mỹ","type":"xa","slug":"xa-tan-my","name_with_type":"Xã Tân Mỹ","path":"Xã Tân Mỹ, Huyện Bắc Tân Uyên, Tỉnh Bình Dương","path_with_type":"Xã Tân Mỹ, Huyện Bắc Tân Uyên, Tỉnh Bình Dương","code":"25918","parent_code":"726"},"25920":{"name":"Phường Tân Hiệp","type":"phuong","slug":"phuong-tan-hiep","name_with_type":"Phường Tân Hiệp","path":"Phường Tân Hiệp, Thành phố Tân Uyên, Tỉnh Bình Dương","path_with_type":"Phường Tân Hiệp, Thành phố Tân Uyên, Tỉnh Bình Dương","code":"25920","parent_code":"723"},"25921":{"name":"Phường Khánh Bình","type":"phuong","slug":"phuong-khanh-binh","name_with_type":"Phường Khánh Bình","path":"Phường Khánh Bình, Thành phố Tân Uyên, Tỉnh Bình Dương","path_with_type":"Phường Khánh Bình, Thành phố Tân Uyên, Tỉnh Bình Dương","code":"25921","parent_code":"723"},"25924":{"name":"Phường Phú Chánh","type":"phuong","slug":"phuong-phu-chanh","name_with_type":"Phường Phú Chánh","path":"Phường Phú Chánh, Thành phố Tân Uyên, Tỉnh Bình Dương","path_with_type":"Phường Phú Chánh, Thành phố Tân Uyên, Tỉnh Bình Dương","code":"25924","parent_code":"723"},"25927":{"name":"Xã Thường Tân","type":"xa","slug":"xa-thuong-tan","name_with_type":"Xã Thường Tân","path":"Xã Thường Tân, Huyện Bắc Tân Uyên, Tỉnh Bình Dương","path_with_type":"Xã Thường Tân, Huyện Bắc Tân Uyên, Tỉnh Bình Dương","code":"25927","parent_code":"726"},"25930":{"name":"Xã Bạch Đằng","type":"xa","slug":"xa-bach-dang","name_with_type":"Xã Bạch Đằng","path":"Xã Bạch Đằng, Thành phố Tân Uyên, Tỉnh Bình Dương","path_with_type":"Xã Bạch Đằng, Thành phố Tân Uyên, Tỉnh Bình Dương","code":"25930","parent_code":"723"},"25933":{"name":"Phường Tân Vĩnh Hiệp","type":"phuong","slug":"phuong-tan-vinh-hiep","name_with_type":"Phường Tân Vĩnh Hiệp","path":"Phường Tân Vĩnh Hiệp, Thành phố Tân Uyên, Tỉnh Bình Dương","path_with_type":"Phường Tân Vĩnh Hiệp, Thành phố Tân Uyên, Tỉnh Bình Dương","code":"25933","parent_code":"723"},"25936":{"name":"Phường Thạnh Phước","type":"phuong","slug":"phuong-thanh-phuoc","name_with_type":"Phường Thạnh Phước","path":"Phường Thạnh Phước, Thành phố Tân Uyên, Tỉnh Bình Dương","path_with_type":"Phường Thạnh Phước, Thành phố Tân Uyên, Tỉnh Bình Dương","code":"25936","parent_code":"723"},"25937":{"name":"Xã Thạnh Hội","type":"xa","slug":"xa-thanh-hoi","name_with_type":"Xã Thạnh Hội","path":"Xã Thạnh Hội, Thành phố Tân Uyên, Tỉnh Bình Dương","path_with_type":"Xã Thạnh Hội, Thành phố Tân Uyên, Tỉnh Bình Dương","code":"25937","parent_code":"723"},"25939":{"name":"Phường Thái Hòa","type":"phuong","slug":"phuong-thai-hoa","name_with_type":"Phường Thái Hòa","path":"Phường Thái Hòa, Thành phố Tân Uyên, Tỉnh Bình Dương","path_with_type":"Phường Thái Hòa, Thành phố Tân Uyên, Tỉnh Bình Dương","code":"25939","parent_code":"723"},"25942":{"name":"Phường Dĩ An","type":"phuong","slug":"phuong-di-an","name_with_type":"Phường Dĩ An","path":"Phường Dĩ An, Thành phố Dĩ An, Tỉnh Bình Dương","path_with_type":"Phường Dĩ An, Thành phố Dĩ An, Tỉnh Bình Dương","code":"25942","parent_code":"724"},"25945":{"name":"Phường Tân Bình","type":"phuong","slug":"phuong-tan-binh","name_with_type":"Phường Tân Bình","path":"Phường Tân Bình, Thành phố Dĩ An, Tỉnh Bình Dương","path_with_type":"Phường Tân Bình, Thành phố Dĩ An, Tỉnh Bình Dương","code":"25945","parent_code":"724"},"25948":{"name":"Phường Tân Đông Hiệp","type":"phuong","slug":"phuong-tan-dong-hiep","name_with_type":"Phường Tân Đông Hiệp","path":"Phường Tân Đông Hiệp, Thành phố Dĩ An, Tỉnh Bình Dương","path_with_type":"Phường Tân Đông Hiệp, Thành phố Dĩ An, Tỉnh Bình Dương","code":"25948","parent_code":"724"},"25951":{"name":"Phường Bình An","type":"phuong","slug":"phuong-binh-an","name_with_type":"Phường Bình An","path":"Phường Bình An, Thành phố Dĩ An, Tỉnh Bình Dương","path_with_type":"Phường Bình An, Thành phố Dĩ An, Tỉnh Bình Dương","code":"25951","parent_code":"724"},"25954":{"name":"Phường Bình Thắng","type":"phuong","slug":"phuong-binh-thang","name_with_type":"Phường Bình Thắng","path":"Phường Bình Thắng, Thành phố Dĩ An, Tỉnh Bình Dương","path_with_type":"Phường Bình Thắng, Thành phố Dĩ An, Tỉnh Bình Dương","code":"25954","parent_code":"724"},"25957":{"name":"Phường Đông Hòa","type":"phuong","slug":"phuong-dong-hoa","name_with_type":"Phường Đông Hòa","path":"Phường Đông Hòa, Thành phố Dĩ An, Tỉnh Bình Dương","path_with_type":"Phường Đông Hòa, Thành phố Dĩ An, Tỉnh Bình Dương","code":"25957","parent_code":"724"},"25960":{"name":"Phường An Bình","type":"phuong","slug":"phuong-an-binh","name_with_type":"Phường An Bình","path":"Phường An Bình, Thành phố Dĩ An, Tỉnh Bình Dương","path_with_type":"Phường An Bình, Thành phố Dĩ An, Tỉnh Bình Dương","code":"25960","parent_code":"724"},"25963":{"name":"Phường An Thạnh","type":"phuong","slug":"phuong-an-thanh","name_with_type":"Phường An Thạnh","path":"Phường An Thạnh, Thành phố Thuận An, Tỉnh Bình Dương","path_with_type":"Phường An Thạnh, Thành phố Thuận An, Tỉnh Bình Dương","code":"25963","parent_code":"725"},"25966":{"name":"Phường Lái Thiêu","type":"phuong","slug":"phuong-lai-thieu","name_with_type":"Phường Lái Thiêu","path":"Phường Lái Thiêu, Thành phố Thuận An, Tỉnh Bình Dương","path_with_type":"Phường Lái Thiêu, Thành phố Thuận An, Tỉnh Bình Dương","code":"25966","parent_code":"725"},"25969":{"name":"Phường Bình Chuẩn","type":"phuong","slug":"phuong-binh-chuan","name_with_type":"Phường Bình Chuẩn","path":"Phường Bình Chuẩn, Thành phố Thuận An, Tỉnh Bình Dương","path_with_type":"Phường Bình Chuẩn, Thành phố Thuận An, Tỉnh Bình Dương","code":"25969","parent_code":"725"},"25972":{"name":"Phường Thuận Giao","type":"phuong","slug":"phuong-thuan-giao","name_with_type":"Phường Thuận Giao","path":"Phường Thuận Giao, Thành phố Thuận An, Tỉnh Bình Dương","path_with_type":"Phường Thuận Giao, Thành phố Thuận An, Tỉnh Bình Dương","code":"25972","parent_code":"725"},"25975":{"name":"Phường An Phú","type":"phuong","slug":"phuong-an-phu","name_with_type":"Phường An Phú","path":"Phường An Phú, Thành phố Thuận An, Tỉnh Bình Dương","path_with_type":"Phường An Phú, Thành phố Thuận An, Tỉnh Bình Dương","code":"25975","parent_code":"725"},"25978":{"name":"Phường Hưng Định","type":"phuong","slug":"phuong-hung-dinh","name_with_type":"Phường Hưng Định","path":"Phường Hưng Định, Thành phố Thuận An, Tỉnh Bình Dương","path_with_type":"Phường Hưng Định, Thành phố Thuận An, Tỉnh Bình Dương","code":"25978","parent_code":"725"},"25981":{"name":"Xã An Sơn","type":"xa","slug":"xa-an-son","name_with_type":"Xã An Sơn","path":"Xã An Sơn, Thành phố Thuận An, Tỉnh Bình Dương","path_with_type":"Xã An Sơn, Thành phố Thuận An, Tỉnh Bình Dương","code":"25981","parent_code":"725"},"25984":{"name":"Phường Bình Nhâm","type":"phuong","slug":"phuong-binh-nham","name_with_type":"Phường Bình Nhâm","path":"Phường Bình Nhâm, Thành phố Thuận An, Tỉnh Bình Dương","path_with_type":"Phường Bình Nhâm, Thành phố Thuận An, Tỉnh Bình Dương","code":"25984","parent_code":"725"},"25987":{"name":"Phường Bình Hòa","type":"phuong","slug":"phuong-binh-hoa","name_with_type":"Phường Bình Hòa","path":"Phường Bình Hòa, Thành phố Thuận An, Tỉnh Bình Dương","path_with_type":"Phường Bình Hòa, Thành phố Thuận An, Tỉnh Bình Dương","code":"25987","parent_code":"725"},"25990":{"name":"Phường Vĩnh Phú","type":"phuong","slug":"phuong-vinh-phu","name_with_type":"Phường Vĩnh Phú","path":"Phường Vĩnh Phú, Thành phố Thuận An, Tỉnh Bình Dương","path_with_type":"Phường Vĩnh Phú, Thành phố Thuận An, Tỉnh Bình Dương","code":"25990","parent_code":"725"},"25993":{"name":"Phường Trảng Dài","type":"phuong","slug":"phuong-trang-dai","name_with_type":"Phường Trảng Dài","path":"Phường Trảng Dài, Thành phố Biên Hòa, Tỉnh Đồng Nai","path_with_type":"Phường Trảng Dài, Thành phố Biên Hòa, Tỉnh Đồng Nai","code":"25993","parent_code":"731"},"25996":{"name":"Phường Tân Phong","type":"phuong","slug":"phuong-tan-phong","name_with_type":"Phường Tân Phong","path":"Phường Tân Phong, Thành phố Biên Hòa, Tỉnh Đồng Nai","path_with_type":"Phường Tân Phong, Thành phố Biên Hòa, Tỉnh Đồng Nai","code":"25996","parent_code":"731"},"25999":{"name":"Phường Tân Biên","type":"phuong","slug":"phuong-tan-bien","name_with_type":"Phường Tân Biên","path":"Phường Tân Biên, Thành phố Biên Hòa, Tỉnh Đồng Nai","path_with_type":"Phường Tân Biên, Thành phố Biên Hòa, Tỉnh Đồng Nai","code":"25999","parent_code":"731"},"26002":{"name":"Phường Hố Nai","type":"phuong","slug":"phuong-ho-nai","name_with_type":"Phường Hố Nai","path":"Phường Hố Nai, Thành phố Biên Hòa, Tỉnh Đồng Nai","path_with_type":"Phường Hố Nai, Thành phố Biên Hòa, Tỉnh Đồng Nai","code":"26002","parent_code":"731"},"26005":{"name":"Phường Tân Hòa","type":"phuong","slug":"phuong-tan-hoa","name_with_type":"Phường Tân Hòa","path":"Phường Tân Hòa, Thành phố Biên Hòa, Tỉnh Đồng Nai","path_with_type":"Phường Tân Hòa, Thành phố Biên Hòa, Tỉnh Đồng Nai","code":"26005","parent_code":"731"},"26008":{"name":"Phường Tân Hiệp","type":"phuong","slug":"phuong-tan-hiep","name_with_type":"Phường Tân Hiệp","path":"Phường Tân Hiệp, Thành phố Biên Hòa, Tỉnh Đồng Nai","path_with_type":"Phường Tân Hiệp, Thành phố Biên Hòa, Tỉnh Đồng Nai","code":"26008","parent_code":"731"},"26011":{"name":"Phường Bửu Long","type":"phuong","slug":"phuong-buu-long","name_with_type":"Phường Bửu Long","path":"Phường Bửu Long, Thành phố Biên Hòa, Tỉnh Đồng Nai","path_with_type":"Phường Bửu Long, Thành phố Biên Hòa, Tỉnh Đồng Nai","code":"26011","parent_code":"731"},"26014":{"name":"Phường Tân Mai","type":"phuong","slug":"phuong-tan-mai","name_with_type":"Phường Tân Mai","path":"Phường Tân Mai, Thành phố Biên Hòa, Tỉnh Đồng Nai","path_with_type":"Phường Tân Mai, Thành phố Biên Hòa, Tỉnh Đồng Nai","code":"26014","parent_code":"731"},"26017":{"name":"Phường Tam Hiệp","type":"phuong","slug":"phuong-tam-hiep","name_with_type":"Phường Tam Hiệp","path":"Phường Tam Hiệp, Thành phố Biên Hòa, Tỉnh Đồng Nai","path_with_type":"Phường Tam Hiệp, Thành phố Biên Hòa, Tỉnh Đồng Nai","code":"26017","parent_code":"731"},"26020":{"name":"Phường Long Bình","type":"phuong","slug":"phuong-long-binh","name_with_type":"Phường Long Bình","path":"Phường Long Bình, Thành phố Biên Hòa, Tỉnh Đồng Nai","path_with_type":"Phường Long Bình, Thành phố Biên Hòa, Tỉnh Đồng Nai","code":"26020","parent_code":"731"},"26023":{"name":"Phường Quang Vinh","type":"phuong","slug":"phuong-quang-vinh","name_with_type":"Phường Quang Vinh","path":"Phường Quang Vinh, Thành phố Biên Hòa, Tỉnh Đồng Nai","path_with_type":"Phường Quang Vinh, Thành phố Biên Hòa, Tỉnh Đồng Nai","code":"26023","parent_code":"731"},"26029":{"name":"Phường Thống Nhất","type":"phuong","slug":"phuong-thong-nhat","name_with_type":"Phường Thống Nhất","path":"Phường Thống Nhất, Thành phố Biên Hòa, Tỉnh Đồng Nai","path_with_type":"Phường Thống Nhất, Thành phố Biên Hòa, Tỉnh Đồng Nai","code":"26029","parent_code":"731"},"26041":{"name":"Phường Trung Dũng","type":"phuong","slug":"phuong-trung-dung","name_with_type":"Phường Trung Dũng","path":"Phường Trung Dũng, Thành phố Biên Hòa, Tỉnh Đồng Nai","path_with_type":"Phường Trung Dũng, Thành phố Biên Hòa, Tỉnh Đồng Nai","code":"26041","parent_code":"731"},"26047":{"name":"Phường Bình Đa","type":"phuong","slug":"phuong-binh-da","name_with_type":"Phường Bình Đa","path":"Phường Bình Đa, Thành phố Biên Hòa, Tỉnh Đồng Nai","path_with_type":"Phường Bình Đa, Thành phố Biên Hòa, Tỉnh Đồng Nai","code":"26047","parent_code":"731"},"26050":{"name":"Phường An Bình","type":"phuong","slug":"phuong-an-binh","name_with_type":"Phường An Bình","path":"Phường An Bình, Thành phố Biên Hòa, Tỉnh Đồng Nai","path_with_type":"Phường An Bình, Thành phố Biên Hòa, Tỉnh Đồng Nai","code":"26050","parent_code":"731"},"26053":{"name":"Phường Bửu Hòa","type":"phuong","slug":"phuong-buu-hoa","name_with_type":"Phường Bửu Hòa","path":"Phường Bửu Hòa, Thành phố Biên Hòa, Tỉnh Đồng Nai","path_with_type":"Phường Bửu Hòa, Thành phố Biên Hòa, Tỉnh Đồng Nai","code":"26053","parent_code":"731"},"26056":{"name":"Phường Long Bình Tân","type":"phuong","slug":"phuong-long-binh-tan","name_with_type":"Phường Long Bình Tân","path":"Phường Long Bình Tân, Thành phố Biên Hòa, Tỉnh Đồng Nai","path_with_type":"Phường Long Bình Tân, Thành phố Biên Hòa, Tỉnh Đồng Nai","code":"26056","parent_code":"731"},"26059":{"name":"Phường Tân Vạn","type":"phuong","slug":"phuong-tan-van","name_with_type":"Phường Tân Vạn","path":"Phường Tân Vạn, Thành phố Biên Hòa, Tỉnh Đồng Nai","path_with_type":"Phường Tân Vạn, Thành phố Biên Hòa, Tỉnh Đồng Nai","code":"26059","parent_code":"731"},"26062":{"name":"Phường Tân Hạnh","type":"phuong","slug":"phuong-tan-hanh","name_with_type":"Phường Tân Hạnh","path":"Phường Tân Hạnh, Thành phố Biên Hòa, Tỉnh Đồng Nai","path_with_type":"Phường Tân Hạnh, Thành phố Biên Hòa, Tỉnh Đồng Nai","code":"26062","parent_code":"731"},"26065":{"name":"Phường Hiệp Hòa","type":"phuong","slug":"phuong-hiep-hoa","name_with_type":"Phường Hiệp Hòa","path":"Phường Hiệp Hòa, Thành phố Biên Hòa, Tỉnh Đồng Nai","path_with_type":"Phường Hiệp Hòa, Thành phố Biên Hòa, Tỉnh Đồng Nai","code":"26065","parent_code":"731"},"26068":{"name":"Phường Hóa An","type":"phuong","slug":"phuong-hoa-an","name_with_type":"Phường Hóa An","path":"Phường Hóa An, Thành phố Biên Hòa, Tỉnh Đồng Nai","path_with_type":"Phường Hóa An, Thành phố Biên Hòa, Tỉnh Đồng Nai","code":"26068","parent_code":"731"},"26077":{"name":"Phường Xuân Bình","type":"phuong","slug":"phuong-xuan-binh","name_with_type":"Phường Xuân Bình","path":"Phường Xuân Bình, Thành phố Long Khánh, Tỉnh Đồng Nai","path_with_type":"Phường Xuân Bình, Thành phố Long Khánh, Tỉnh Đồng Nai","code":"26077","parent_code":"732"},"26080":{"name":"Phường Xuân An","type":"phuong","slug":"phuong-xuan-an","name_with_type":"Phường Xuân An","path":"Phường Xuân An, Thành phố Long Khánh, Tỉnh Đồng Nai","path_with_type":"Phường Xuân An, Thành phố Long Khánh, Tỉnh Đồng Nai","code":"26080","parent_code":"732"},"26083":{"name":"Phường Xuân Hoà","type":"phuong","slug":"phuong-xuan-hoa","name_with_type":"Phường Xuân Hoà","path":"Phường Xuân Hoà, Thành phố Long Khánh, Tỉnh Đồng Nai","path_with_type":"Phường Xuân Hoà, Thành phố Long Khánh, Tỉnh Đồng Nai","code":"26083","parent_code":"732"},"26086":{"name":"Phường Phú Bình","type":"phuong","slug":"phuong-phu-binh","name_with_type":"Phường Phú Bình","path":"Phường Phú Bình, Thành phố Long Khánh, Tỉnh Đồng Nai","path_with_type":"Phường Phú Bình, Thành phố Long Khánh, Tỉnh Đồng Nai","code":"26086","parent_code":"732"},"26089":{"name":"Xã Bình Lộc","type":"xa","slug":"xa-binh-loc","name_with_type":"Xã Bình Lộc","path":"Xã Bình Lộc, Thành phố Long Khánh, Tỉnh Đồng Nai","path_with_type":"Xã Bình Lộc, Thành phố Long Khánh, Tỉnh Đồng Nai","code":"26089","parent_code":"732"},"26092":{"name":"Xã Bảo Quang","type":"xa","slug":"xa-bao-quang","name_with_type":"Xã Bảo Quang","path":"Xã Bảo Quang, Thành phố Long Khánh, Tỉnh Đồng Nai","path_with_type":"Xã Bảo Quang, Thành phố Long Khánh, Tỉnh Đồng Nai","code":"26092","parent_code":"732"},"26095":{"name":"Phường Suối Tre","type":"phuong","slug":"phuong-suoi-tre","name_with_type":"Phường Suối Tre","path":"Phường Suối Tre, Thành phố Long Khánh, Tỉnh Đồng Nai","path_with_type":"Phường Suối Tre, Thành phố Long Khánh, Tỉnh Đồng Nai","code":"26095","parent_code":"732"},"26098":{"name":"Phường Bảo Vinh","type":"phuong","slug":"phuong-bao-vinh","name_with_type":"Phường Bảo Vinh","path":"Phường Bảo Vinh, Thành phố Long Khánh, Tỉnh Đồng Nai","path_with_type":"Phường Bảo Vinh, Thành phố Long Khánh, Tỉnh Đồng Nai","code":"26098","parent_code":"732"},"26101":{"name":"Phường Xuân Lập","type":"phuong","slug":"phuong-xuan-lap","name_with_type":"Phường Xuân Lập","path":"Phường Xuân Lập, Thành phố Long Khánh, Tỉnh Đồng Nai","path_with_type":"Phường Xuân Lập, Thành phố Long Khánh, Tỉnh Đồng Nai","code":"26101","parent_code":"732"},"26104":{"name":"Phường Bàu Sen","type":"phuong","slug":"phuong-bau-sen","name_with_type":"Phường Bàu Sen","path":"Phường Bàu Sen, Thành phố Long Khánh, Tỉnh Đồng Nai","path_with_type":"Phường Bàu Sen, Thành phố Long Khánh, Tỉnh Đồng Nai","code":"26104","parent_code":"732"},"26107":{"name":"Xã Bàu Trâm","type":"xa","slug":"xa-bau-tram","name_with_type":"Xã Bàu Trâm","path":"Xã Bàu Trâm, Thành phố Long Khánh, Tỉnh Đồng Nai","path_with_type":"Xã Bàu Trâm, Thành phố Long Khánh, Tỉnh Đồng Nai","code":"26107","parent_code":"732"},"26110":{"name":"Phường Xuân Tân","type":"phuong","slug":"phuong-xuan-tan","name_with_type":"Phường Xuân Tân","path":"Phường Xuân Tân, Thành phố Long Khánh, Tỉnh Đồng Nai","path_with_type":"Phường Xuân Tân, Thành phố Long Khánh, Tỉnh Đồng Nai","code":"26110","parent_code":"732"},"26113":{"name":"Xã Hàng Gòn","type":"xa","slug":"xa-hang-gon","name_with_type":"Xã Hàng Gòn","path":"Xã Hàng Gòn, Thành phố Long Khánh, Tỉnh Đồng Nai","path_with_type":"Xã Hàng Gòn, Thành phố Long Khánh, Tỉnh Đồng Nai","code":"26113","parent_code":"732"},"26116":{"name":"Thị trấn Tân Phú","type":"thi-tran","slug":"thi-tran-tan-phu","name_with_type":"Thị trấn Tân Phú","path":"Thị trấn Tân Phú, Huyện Tân Phú, Tỉnh Đồng Nai","path_with_type":"Thị trấn Tân Phú, Huyện Tân Phú, Tỉnh Đồng Nai","code":"26116","parent_code":"734"},"26119":{"name":"Xã Dak Lua","type":"xa","slug":"xa-dak-lua","name_with_type":"Xã Dak Lua","path":"Xã Dak Lua, Huyện Tân Phú, Tỉnh Đồng Nai","path_with_type":"Xã Dak Lua, Huyện Tân Phú, Tỉnh Đồng Nai","code":"26119","parent_code":"734"},"26122":{"name":"Xã Nam Cát Tiên","type":"xa","slug":"xa-nam-cat-tien","name_with_type":"Xã Nam Cát Tiên","path":"Xã Nam Cát Tiên, Huyện Tân Phú, Tỉnh Đồng Nai","path_with_type":"Xã Nam Cát Tiên, Huyện Tân Phú, Tỉnh Đồng Nai","code":"26122","parent_code":"734"},"26125":{"name":"Xã Phú An","type":"xa","slug":"xa-phu-an","name_with_type":"Xã Phú An","path":"Xã Phú An, Huyện Tân Phú, Tỉnh Đồng Nai","path_with_type":"Xã Phú An, Huyện Tân Phú, Tỉnh Đồng Nai","code":"26125","parent_code":"734"},"26131":{"name":"Xã Tà Lài","type":"xa","slug":"xa-ta-lai","name_with_type":"Xã Tà Lài","path":"Xã Tà Lài, Huyện Tân Phú, Tỉnh Đồng Nai","path_with_type":"Xã Tà Lài, Huyện Tân Phú, Tỉnh Đồng Nai","code":"26131","parent_code":"734"},"26134":{"name":"Xã Phú Lập","type":"xa","slug":"xa-phu-lap","name_with_type":"Xã Phú Lập","path":"Xã Phú Lập, Huyện Tân Phú, Tỉnh Đồng Nai","path_with_type":"Xã Phú Lập, Huyện Tân Phú, Tỉnh Đồng Nai","code":"26134","parent_code":"734"},"26140":{"name":"Xã Phú Thịnh","type":"xa","slug":"xa-phu-thinh","name_with_type":"Xã Phú Thịnh","path":"Xã Phú Thịnh, Huyện Tân Phú, Tỉnh Đồng Nai","path_with_type":"Xã Phú Thịnh, Huyện Tân Phú, Tỉnh Đồng Nai","code":"26140","parent_code":"734"},"26143":{"name":"Xã Thanh Sơn","type":"xa","slug":"xa-thanh-son","name_with_type":"Xã Thanh Sơn","path":"Xã Thanh Sơn, Huyện Tân Phú, Tỉnh Đồng Nai","path_with_type":"Xã Thanh Sơn, Huyện Tân Phú, Tỉnh Đồng Nai","code":"26143","parent_code":"734"},"26146":{"name":"Xã Phú Sơn","type":"xa","slug":"xa-phu-son","name_with_type":"Xã Phú Sơn","path":"Xã Phú Sơn, Huyện Tân Phú, Tỉnh Đồng Nai","path_with_type":"Xã Phú Sơn, Huyện Tân Phú, Tỉnh Đồng Nai","code":"26146","parent_code":"734"},"26149":{"name":"Xã Phú Xuân","type":"xa","slug":"xa-phu-xuan","name_with_type":"Xã Phú Xuân","path":"Xã Phú Xuân, Huyện Tân Phú, Tỉnh Đồng Nai","path_with_type":"Xã Phú Xuân, Huyện Tân Phú, Tỉnh Đồng Nai","code":"26149","parent_code":"734"},"26152":{"name":"Xã Phú Lộc","type":"xa","slug":"xa-phu-loc","name_with_type":"Xã Phú Lộc","path":"Xã Phú Lộc, Huyện Tân Phú, Tỉnh Đồng Nai","path_with_type":"Xã Phú Lộc, Huyện Tân Phú, Tỉnh Đồng Nai","code":"26152","parent_code":"734"},"26155":{"name":"Xã Phú Lâm","type":"xa","slug":"xa-phu-lam","name_with_type":"Xã Phú Lâm","path":"Xã Phú Lâm, Huyện Tân Phú, Tỉnh Đồng Nai","path_with_type":"Xã Phú Lâm, Huyện Tân Phú, Tỉnh Đồng Nai","code":"26155","parent_code":"734"},"26158":{"name":"Xã Phú Bình","type":"xa","slug":"xa-phu-binh","name_with_type":"Xã Phú Bình","path":"Xã Phú Bình, Huyện Tân Phú, Tỉnh Đồng Nai","path_with_type":"Xã Phú Bình, Huyện Tân Phú, Tỉnh Đồng Nai","code":"26158","parent_code":"734"},"26161":{"name":"Xã Phú Thanh","type":"xa","slug":"xa-phu-thanh","name_with_type":"Xã Phú Thanh","path":"Xã Phú Thanh, Huyện Tân Phú, Tỉnh Đồng Nai","path_with_type":"Xã Phú Thanh, Huyện Tân Phú, Tỉnh Đồng Nai","code":"26161","parent_code":"734"},"26164":{"name":"Xã Trà Cổ","type":"xa","slug":"xa-tra-co","name_with_type":"Xã Trà Cổ","path":"Xã Trà Cổ, Huyện Tân Phú, Tỉnh Đồng Nai","path_with_type":"Xã Trà Cổ, Huyện Tân Phú, Tỉnh Đồng Nai","code":"26164","parent_code":"734"},"26167":{"name":"Xã Phú Điền","type":"xa","slug":"xa-phu-dien","name_with_type":"Xã Phú Điền","path":"Xã Phú Điền, Huyện Tân Phú, Tỉnh Đồng Nai","path_with_type":"Xã Phú Điền, Huyện Tân Phú, Tỉnh Đồng Nai","code":"26167","parent_code":"734"},"26170":{"name":"Thị trấn Vĩnh An","type":"thi-tran","slug":"thi-tran-vinh-an","name_with_type":"Thị trấn Vĩnh An","path":"Thị trấn Vĩnh An, Huyện Vĩnh Cửu, Tỉnh Đồng Nai","path_with_type":"Thị trấn Vĩnh An, Huyện Vĩnh Cửu, Tỉnh Đồng Nai","code":"26170","parent_code":"735"},"26173":{"name":"Xã Phú Lý","type":"xa","slug":"xa-phu-ly","name_with_type":"Xã Phú Lý","path":"Xã Phú Lý, Huyện Vĩnh Cửu, Tỉnh Đồng Nai","path_with_type":"Xã Phú Lý, Huyện Vĩnh Cửu, Tỉnh Đồng Nai","code":"26173","parent_code":"735"},"26176":{"name":"Xã Trị An","type":"xa","slug":"xa-tri-an","name_with_type":"Xã Trị An","path":"Xã Trị An, Huyện Vĩnh Cửu, Tỉnh Đồng Nai","path_with_type":"Xã Trị An, Huyện Vĩnh Cửu, Tỉnh Đồng Nai","code":"26176","parent_code":"735"},"26179":{"name":"Xã Tân An","type":"xa","slug":"xa-tan-an","name_with_type":"Xã Tân An","path":"Xã Tân An, Huyện Vĩnh Cửu, Tỉnh Đồng Nai","path_with_type":"Xã Tân An, Huyện Vĩnh Cửu, Tỉnh Đồng Nai","code":"26179","parent_code":"735"},"26182":{"name":"Xã Vĩnh Tân","type":"xa","slug":"xa-vinh-tan","name_with_type":"Xã Vĩnh Tân","path":"Xã Vĩnh Tân, Huyện Vĩnh Cửu, Tỉnh Đồng Nai","path_with_type":"Xã Vĩnh Tân, Huyện Vĩnh Cửu, Tỉnh Đồng Nai","code":"26182","parent_code":"735"},"26185":{"name":"Xã Bình Lợi","type":"xa","slug":"xa-binh-loi","name_with_type":"Xã Bình Lợi","path":"Xã Bình Lợi, Huyện Vĩnh Cửu, Tỉnh Đồng Nai","path_with_type":"Xã Bình Lợi, Huyện Vĩnh Cửu, Tỉnh Đồng Nai","code":"26185","parent_code":"735"},"26188":{"name":"Xã Thạnh Phú","type":"xa","slug":"xa-thanh-phu","name_with_type":"Xã Thạnh Phú","path":"Xã Thạnh Phú, Huyện Vĩnh Cửu, Tỉnh Đồng Nai","path_with_type":"Xã Thạnh Phú, Huyện Vĩnh Cửu, Tỉnh Đồng Nai","code":"26188","parent_code":"735"},"26191":{"name":"Xã Thiện Tân","type":"xa","slug":"xa-thien-tan","name_with_type":"Xã Thiện Tân","path":"Xã Thiện Tân, Huyện Vĩnh Cửu, Tỉnh Đồng Nai","path_with_type":"Xã Thiện Tân, Huyện Vĩnh Cửu, Tỉnh Đồng Nai","code":"26191","parent_code":"735"},"26194":{"name":"Xã Tân Bình","type":"xa","slug":"xa-tan-binh","name_with_type":"Xã Tân Bình","path":"Xã Tân Bình, Huyện Vĩnh Cửu, Tỉnh Đồng Nai","path_with_type":"Xã Tân Bình, Huyện Vĩnh Cửu, Tỉnh Đồng Nai","code":"26194","parent_code":"735"},"26200":{"name":"Xã Mã Đà","type":"xa","slug":"xa-ma-da","name_with_type":"Xã Mã Đà","path":"Xã Mã Đà, Huyện Vĩnh Cửu, Tỉnh Đồng Nai","path_with_type":"Xã Mã Đà, Huyện Vĩnh Cửu, Tỉnh Đồng Nai","code":"26200","parent_code":"735"},"26206":{"name":"Thị trấn Định Quán","type":"thi-tran","slug":"thi-tran-dinh-quan","name_with_type":"Thị trấn Định Quán","path":"Thị trấn Định Quán, Huyện Định Quán, Tỉnh Đồng Nai","path_with_type":"Thị trấn Định Quán, Huyện Định Quán, Tỉnh Đồng Nai","code":"26206","parent_code":"736"},"26209":{"name":"Xã Thanh Sơn","type":"xa","slug":"xa-thanh-son","name_with_type":"Xã Thanh Sơn","path":"Xã Thanh Sơn, Huyện Định Quán, Tỉnh Đồng Nai","path_with_type":"Xã Thanh Sơn, Huyện Định Quán, Tỉnh Đồng Nai","code":"26209","parent_code":"736"},"26212":{"name":"Xã Phú Tân","type":"xa","slug":"xa-phu-tan","name_with_type":"Xã Phú Tân","path":"Xã Phú Tân, Huyện Định Quán, Tỉnh Đồng Nai","path_with_type":"Xã Phú Tân, Huyện Định Quán, Tỉnh Đồng Nai","code":"26212","parent_code":"736"},"26215":{"name":"Xã Phú Vinh","type":"xa","slug":"xa-phu-vinh","name_with_type":"Xã Phú Vinh","path":"Xã Phú Vinh, Huyện Định Quán, Tỉnh Đồng Nai","path_with_type":"Xã Phú Vinh, Huyện Định Quán, Tỉnh Đồng Nai","code":"26215","parent_code":"736"},"26218":{"name":"Xã Phú Lợi","type":"xa","slug":"xa-phu-loi","name_with_type":"Xã Phú Lợi","path":"Xã Phú Lợi, Huyện Định Quán, Tỉnh Đồng Nai","path_with_type":"Xã Phú Lợi, Huyện Định Quán, Tỉnh Đồng Nai","code":"26218","parent_code":"736"},"26221":{"name":"Xã Phú Hòa","type":"xa","slug":"xa-phu-hoa","name_with_type":"Xã Phú Hòa","path":"Xã Phú Hòa, Huyện Định Quán, Tỉnh Đồng Nai","path_with_type":"Xã Phú Hòa, Huyện Định Quán, Tỉnh Đồng Nai","code":"26221","parent_code":"736"},"26224":{"name":"Xã Ngọc Định","type":"xa","slug":"xa-ngoc-dinh","name_with_type":"Xã Ngọc Định","path":"Xã Ngọc Định, Huyện Định Quán, Tỉnh Đồng Nai","path_with_type":"Xã Ngọc Định, Huyện Định Quán, Tỉnh Đồng Nai","code":"26224","parent_code":"736"},"26227":{"name":"Xã La Ngà","type":"xa","slug":"xa-la-nga","name_with_type":"Xã La Ngà","path":"Xã La Ngà, Huyện Định Quán, Tỉnh Đồng Nai","path_with_type":"Xã La Ngà, Huyện Định Quán, Tỉnh Đồng Nai","code":"26227","parent_code":"736"},"26230":{"name":"Xã Gia Canh","type":"xa","slug":"xa-gia-canh","name_with_type":"Xã Gia Canh","path":"Xã Gia Canh, Huyện Định Quán, Tỉnh Đồng Nai","path_with_type":"Xã Gia Canh, Huyện Định Quán, Tỉnh Đồng Nai","code":"26230","parent_code":"736"},"26233":{"name":"Xã Phú Ngọc","type":"xa","slug":"xa-phu-ngoc","name_with_type":"Xã Phú Ngọc","path":"Xã Phú Ngọc, Huyện Định Quán, Tỉnh Đồng Nai","path_with_type":"Xã Phú Ngọc, Huyện Định Quán, Tỉnh Đồng Nai","code":"26233","parent_code":"736"},"26236":{"name":"Xã Phú Cường","type":"xa","slug":"xa-phu-cuong","name_with_type":"Xã Phú Cường","path":"Xã Phú Cường, Huyện Định Quán, Tỉnh Đồng Nai","path_with_type":"Xã Phú Cường, Huyện Định Quán, Tỉnh Đồng Nai","code":"26236","parent_code":"736"},"26239":{"name":"Xã Túc Trưng","type":"xa","slug":"xa-tuc-trung","name_with_type":"Xã Túc Trưng","path":"Xã Túc Trưng, Huyện Định Quán, Tỉnh Đồng Nai","path_with_type":"Xã Túc Trưng, Huyện Định Quán, Tỉnh Đồng Nai","code":"26239","parent_code":"736"},"26242":{"name":"Xã Phú Túc","type":"xa","slug":"xa-phu-tuc","name_with_type":"Xã Phú Túc","path":"Xã Phú Túc, Huyện Định Quán, Tỉnh Đồng Nai","path_with_type":"Xã Phú Túc, Huyện Định Quán, Tỉnh Đồng Nai","code":"26242","parent_code":"736"},"26245":{"name":"Xã Suối Nho","type":"xa","slug":"xa-suoi-nho","name_with_type":"Xã Suối Nho","path":"Xã Suối Nho, Huyện Định Quán, Tỉnh Đồng Nai","path_with_type":"Xã Suối Nho, Huyện Định Quán, Tỉnh Đồng Nai","code":"26245","parent_code":"736"},"26248":{"name":"Thị trấn Trảng Bom","type":"thi-tran","slug":"thi-tran-trang-bom","name_with_type":"Thị trấn Trảng Bom","path":"Thị trấn Trảng Bom, Huyện Trảng Bom, Tỉnh Đồng Nai","path_with_type":"Thị trấn Trảng Bom, Huyện Trảng Bom, Tỉnh Đồng Nai","code":"26248","parent_code":"737"},"26251":{"name":"Xã Thanh Bình","type":"xa","slug":"xa-thanh-binh","name_with_type":"Xã Thanh Bình","path":"Xã Thanh Bình, Huyện Trảng Bom, Tỉnh Đồng Nai","path_with_type":"Xã Thanh Bình, Huyện Trảng Bom, Tỉnh Đồng Nai","code":"26251","parent_code":"737"},"26254":{"name":"Xã Cây Gáo","type":"xa","slug":"xa-cay-gao","name_with_type":"Xã Cây Gáo","path":"Xã Cây Gáo, Huyện Trảng Bom, Tỉnh Đồng Nai","path_with_type":"Xã Cây Gáo, Huyện Trảng Bom, Tỉnh Đồng Nai","code":"26254","parent_code":"737"},"26257":{"name":"Xã Bàu Hàm","type":"xa","slug":"xa-bau-ham","name_with_type":"Xã Bàu Hàm","path":"Xã Bàu Hàm, Huyện Trảng Bom, Tỉnh Đồng Nai","path_with_type":"Xã Bàu Hàm, Huyện Trảng Bom, Tỉnh Đồng Nai","code":"26257","parent_code":"737"},"26260":{"name":"Xã Sông Thao","type":"xa","slug":"xa-song-thao","name_with_type":"Xã Sông Thao","path":"Xã Sông Thao, Huyện Trảng Bom, Tỉnh Đồng Nai","path_with_type":"Xã Sông Thao, Huyện Trảng Bom, Tỉnh Đồng Nai","code":"26260","parent_code":"737"},"26263":{"name":"Xã Sông Trầu","type":"xa","slug":"xa-song-trau","name_with_type":"Xã Sông Trầu","path":"Xã Sông Trầu, Huyện Trảng Bom, Tỉnh Đồng Nai","path_with_type":"Xã Sông Trầu, Huyện Trảng Bom, Tỉnh Đồng Nai","code":"26263","parent_code":"737"},"26266":{"name":"Xã Đông Hoà","type":"xa","slug":"xa-dong-hoa","name_with_type":"Xã Đông Hoà","path":"Xã Đông Hoà, Huyện Trảng Bom, Tỉnh Đồng Nai","path_with_type":"Xã Đông Hoà, Huyện Trảng Bom, Tỉnh Đồng Nai","code":"26266","parent_code":"737"},"26269":{"name":"Xã Bắc Sơn","type":"xa","slug":"xa-bac-son","name_with_type":"Xã Bắc Sơn","path":"Xã Bắc Sơn, Huyện Trảng Bom, Tỉnh Đồng Nai","path_with_type":"Xã Bắc Sơn, Huyện Trảng Bom, Tỉnh Đồng Nai","code":"26269","parent_code":"737"},"26272":{"name":"Xã Hố Nai 3","type":"xa","slug":"xa-ho-nai-3","name_with_type":"Xã Hố Nai 3","path":"Xã Hố Nai 3, Huyện Trảng Bom, Tỉnh Đồng Nai","path_with_type":"Xã Hố Nai 3, Huyện Trảng Bom, Tỉnh Đồng Nai","code":"26272","parent_code":"737"},"26275":{"name":"Xã Tây Hoà","type":"xa","slug":"xa-tay-hoa","name_with_type":"Xã Tây Hoà","path":"Xã Tây Hoà, Huyện Trảng Bom, Tỉnh Đồng Nai","path_with_type":"Xã Tây Hoà, Huyện Trảng Bom, Tỉnh Đồng Nai","code":"26275","parent_code":"737"},"26278":{"name":"Xã Bình Minh","type":"xa","slug":"xa-binh-minh","name_with_type":"Xã Bình Minh","path":"Xã Bình Minh, Huyện Trảng Bom, Tỉnh Đồng Nai","path_with_type":"Xã Bình Minh, Huyện Trảng Bom, Tỉnh Đồng Nai","code":"26278","parent_code":"737"},"26281":{"name":"Xã Trung Hoà","type":"xa","slug":"xa-trung-hoa","name_with_type":"Xã Trung Hoà","path":"Xã Trung Hoà, Huyện Trảng Bom, Tỉnh Đồng Nai","path_with_type":"Xã Trung Hoà, Huyện Trảng Bom, Tỉnh Đồng Nai","code":"26281","parent_code":"737"},"26284":{"name":"Xã Đồi 61","type":"xa","slug":"xa-doi-61","name_with_type":"Xã Đồi 61","path":"Xã Đồi 61, Huyện Trảng Bom, Tỉnh Đồng Nai","path_with_type":"Xã Đồi 61, Huyện Trảng Bom, Tỉnh Đồng Nai","code":"26284","parent_code":"737"},"26287":{"name":"Xã Hưng Thịnh","type":"xa","slug":"xa-hung-thinh","name_with_type":"Xã Hưng Thịnh","path":"Xã Hưng Thịnh, Huyện Trảng Bom, Tỉnh Đồng Nai","path_with_type":"Xã Hưng Thịnh, Huyện Trảng Bom, Tỉnh Đồng Nai","code":"26287","parent_code":"737"},"26290":{"name":"Xã Quảng Tiến","type":"xa","slug":"xa-quang-tien","name_with_type":"Xã Quảng Tiến","path":"Xã Quảng Tiến, Huyện Trảng Bom, Tỉnh Đồng Nai","path_with_type":"Xã Quảng Tiến, Huyện Trảng Bom, Tỉnh Đồng Nai","code":"26290","parent_code":"737"},"26293":{"name":"Xã Giang Điền","type":"xa","slug":"xa-giang-dien","name_with_type":"Xã Giang Điền","path":"Xã Giang Điền, Huyện Trảng Bom, Tỉnh Đồng Nai","path_with_type":"Xã Giang Điền, Huyện Trảng Bom, Tỉnh Đồng Nai","code":"26293","parent_code":"737"},"26296":{"name":"Xã An Viễn","type":"xa","slug":"xa-an-vien","name_with_type":"Xã An Viễn","path":"Xã An Viễn, Huyện Trảng Bom, Tỉnh Đồng Nai","path_with_type":"Xã An Viễn, Huyện Trảng Bom, Tỉnh Đồng Nai","code":"26296","parent_code":"737"},"26299":{"name":"Xã Gia Tân 1","type":"xa","slug":"xa-gia-tan-1","name_with_type":"Xã Gia Tân 1","path":"Xã Gia Tân 1, Huyện Thống Nhất, Tỉnh Đồng Nai","path_with_type":"Xã Gia Tân 1, Huyện Thống Nhất, Tỉnh Đồng Nai","code":"26299","parent_code":"738"},"26302":{"name":"Xã Gia Tân 2","type":"xa","slug":"xa-gia-tan-2","name_with_type":"Xã Gia Tân 2","path":"Xã Gia Tân 2, Huyện Thống Nhất, Tỉnh Đồng Nai","path_with_type":"Xã Gia Tân 2, Huyện Thống Nhất, Tỉnh Đồng Nai","code":"26302","parent_code":"738"},"26305":{"name":"Xã Gia Tân 3","type":"xa","slug":"xa-gia-tan-3","name_with_type":"Xã Gia Tân 3","path":"Xã Gia Tân 3, Huyện Thống Nhất, Tỉnh Đồng Nai","path_with_type":"Xã Gia Tân 3, Huyện Thống Nhất, Tỉnh Đồng Nai","code":"26305","parent_code":"738"},"26308":{"name":"Xã Gia Kiệm","type":"xa","slug":"xa-gia-kiem","name_with_type":"Xã Gia Kiệm","path":"Xã Gia Kiệm, Huyện Thống Nhất, Tỉnh Đồng Nai","path_with_type":"Xã Gia Kiệm, Huyện Thống Nhất, Tỉnh Đồng Nai","code":"26308","parent_code":"738"},"26311":{"name":"Xã Quang Trung","type":"xa","slug":"xa-quang-trung","name_with_type":"Xã Quang Trung","path":"Xã Quang Trung, Huyện Thống Nhất, Tỉnh Đồng Nai","path_with_type":"Xã Quang Trung, Huyện Thống Nhất, Tỉnh Đồng Nai","code":"26311","parent_code":"738"},"26314":{"name":"Xã Bàu Hàm 2","type":"xa","slug":"xa-bau-ham-2","name_with_type":"Xã Bàu Hàm 2","path":"Xã Bàu Hàm 2, Huyện Thống Nhất, Tỉnh Đồng Nai","path_with_type":"Xã Bàu Hàm 2, Huyện Thống Nhất, Tỉnh Đồng Nai","code":"26314","parent_code":"738"},"26317":{"name":"Xã Hưng Lộc","type":"xa","slug":"xa-hung-loc","name_with_type":"Xã Hưng Lộc","path":"Xã Hưng Lộc, Huyện Thống Nhất, Tỉnh Đồng Nai","path_with_type":"Xã Hưng Lộc, Huyện Thống Nhất, Tỉnh Đồng Nai","code":"26317","parent_code":"738"},"26320":{"name":"Xã Lộ 25","type":"xa","slug":"xa-lo-25","name_with_type":"Xã Lộ 25","path":"Xã Lộ 25, Huyện Thống Nhất, Tỉnh Đồng Nai","path_with_type":"Xã Lộ 25, Huyện Thống Nhất, Tỉnh Đồng Nai","code":"26320","parent_code":"738"},"26323":{"name":"Xã Xuân Thiện","type":"xa","slug":"xa-xuan-thien","name_with_type":"Xã Xuân Thiện","path":"Xã Xuân Thiện, Huyện Thống Nhất, Tỉnh Đồng Nai","path_with_type":"Xã Xuân Thiện, Huyện Thống Nhất, Tỉnh Đồng Nai","code":"26323","parent_code":"738"},"26326":{"name":"Thị trấn Dầu Giây","type":"thi-tran","slug":"thi-tran-dau-giay","name_with_type":"Thị trấn Dầu Giây","path":"Thị trấn Dầu Giây, Huyện Thống Nhất, Tỉnh Đồng Nai","path_with_type":"Thị trấn Dầu Giây, Huyện Thống Nhất, Tỉnh Đồng Nai","code":"26326","parent_code":"738"},"26329":{"name":"Xã Sông Nhạn","type":"xa","slug":"xa-song-nhan","name_with_type":"Xã Sông Nhạn","path":"Xã Sông Nhạn, Huyện Cẩm Mỹ, Tỉnh Đồng Nai","path_with_type":"Xã Sông Nhạn, Huyện Cẩm Mỹ, Tỉnh Đồng Nai","code":"26329","parent_code":"739"},"26332":{"name":"Xã Xuân Quế","type":"xa","slug":"xa-xuan-que","name_with_type":"Xã Xuân Quế","path":"Xã Xuân Quế, Huyện Cẩm Mỹ, Tỉnh Đồng Nai","path_with_type":"Xã Xuân Quế, Huyện Cẩm Mỹ, Tỉnh Đồng Nai","code":"26332","parent_code":"739"},"26335":{"name":"Xã Nhân Nghĩa","type":"xa","slug":"xa-nhan-nghia","name_with_type":"Xã Nhân Nghĩa","path":"Xã Nhân Nghĩa, Huyện Cẩm Mỹ, Tỉnh Đồng Nai","path_with_type":"Xã Nhân Nghĩa, Huyện Cẩm Mỹ, Tỉnh Đồng Nai","code":"26335","parent_code":"739"},"26338":{"name":"Xã Xuân Đường","type":"xa","slug":"xa-xuan-duong","name_with_type":"Xã Xuân Đường","path":"Xã Xuân Đường, Huyện Cẩm Mỹ, Tỉnh Đồng Nai","path_with_type":"Xã Xuân Đường, Huyện Cẩm Mỹ, Tỉnh Đồng Nai","code":"26338","parent_code":"739"},"26341":{"name":"Thị trấn Long Giao","type":"thi-tran","slug":"thi-tran-long-giao","name_with_type":"Thị trấn Long Giao","path":"Thị trấn Long Giao, Huyện Cẩm Mỹ, Tỉnh Đồng Nai","path_with_type":"Thị trấn Long Giao, Huyện Cẩm Mỹ, Tỉnh Đồng Nai","code":"26341","parent_code":"739"},"26344":{"name":"Xã Xuân Mỹ","type":"xa","slug":"xa-xuan-my","name_with_type":"Xã Xuân Mỹ","path":"Xã Xuân Mỹ, Huyện Cẩm Mỹ, Tỉnh Đồng Nai","path_with_type":"Xã Xuân Mỹ, Huyện Cẩm Mỹ, Tỉnh Đồng Nai","code":"26344","parent_code":"739"},"26347":{"name":"Xã Thừa Đức","type":"xa","slug":"xa-thua-duc","name_with_type":"Xã Thừa Đức","path":"Xã Thừa Đức, Huyện Cẩm Mỹ, Tỉnh Đồng Nai","path_with_type":"Xã Thừa Đức, Huyện Cẩm Mỹ, Tỉnh Đồng Nai","code":"26347","parent_code":"739"},"26350":{"name":"Xã Bảo Bình","type":"xa","slug":"xa-bao-binh","name_with_type":"Xã Bảo Bình","path":"Xã Bảo Bình, Huyện Cẩm Mỹ, Tỉnh Đồng Nai","path_with_type":"Xã Bảo Bình, Huyện Cẩm Mỹ, Tỉnh Đồng Nai","code":"26350","parent_code":"739"},"26353":{"name":"Xã Xuân Bảo","type":"xa","slug":"xa-xuan-bao","name_with_type":"Xã Xuân Bảo","path":"Xã Xuân Bảo, Huyện Cẩm Mỹ, Tỉnh Đồng Nai","path_with_type":"Xã Xuân Bảo, Huyện Cẩm Mỹ, Tỉnh Đồng Nai","code":"26353","parent_code":"739"},"26356":{"name":"Xã Xuân Tây","type":"xa","slug":"xa-xuan-tay","name_with_type":"Xã Xuân Tây","path":"Xã Xuân Tây, Huyện Cẩm Mỹ, Tỉnh Đồng Nai","path_with_type":"Xã Xuân Tây, Huyện Cẩm Mỹ, Tỉnh Đồng Nai","code":"26356","parent_code":"739"},"26359":{"name":"Xã Xuân Đông","type":"xa","slug":"xa-xuan-dong","name_with_type":"Xã Xuân Đông","path":"Xã Xuân Đông, Huyện Cẩm Mỹ, Tỉnh Đồng Nai","path_with_type":"Xã Xuân Đông, Huyện Cẩm Mỹ, Tỉnh Đồng Nai","code":"26359","parent_code":"739"},"26362":{"name":"Xã Sông Ray","type":"xa","slug":"xa-song-ray","name_with_type":"Xã Sông Ray","path":"Xã Sông Ray, Huyện Cẩm Mỹ, Tỉnh Đồng Nai","path_with_type":"Xã Sông Ray, Huyện Cẩm Mỹ, Tỉnh Đồng Nai","code":"26362","parent_code":"739"},"26365":{"name":"Xã Lâm San","type":"xa","slug":"xa-lam-san","name_with_type":"Xã Lâm San","path":"Xã Lâm San, Huyện Cẩm Mỹ, Tỉnh Đồng Nai","path_with_type":"Xã Lâm San, Huyện Cẩm Mỹ, Tỉnh Đồng Nai","code":"26365","parent_code":"739"},"26368":{"name":"Thị trấn Long Thành","type":"thi-tran","slug":"thi-tran-long-thanh","name_with_type":"Thị trấn Long Thành","path":"Thị trấn Long Thành, Huyện Long Thành, Tỉnh Đồng Nai","path_with_type":"Thị trấn Long Thành, Huyện Long Thành, Tỉnh Đồng Nai","code":"26368","parent_code":"740"},"26371":{"name":"Phường An Hòa","type":"phuong","slug":"phuong-an-hoa","name_with_type":"Phường An Hòa","path":"Phường An Hòa, Thành phố Biên Hòa, Tỉnh Đồng Nai","path_with_type":"Phường An Hòa, Thành phố Biên Hòa, Tỉnh Đồng Nai","code":"26371","parent_code":"731"},"26374":{"name":"Phường Tam Phước","type":"phuong","slug":"phuong-tam-phuoc","name_with_type":"Phường Tam Phước","path":"Phường Tam Phước, Thành phố Biên Hòa, Tỉnh Đồng Nai","path_with_type":"Phường Tam Phước, Thành phố Biên Hòa, Tỉnh Đồng Nai","code":"26374","parent_code":"731"},"26377":{"name":"Phường Phước Tân","type":"phuong","slug":"phuong-phuoc-tan","name_with_type":"Phường Phước Tân","path":"Phường Phước Tân, Thành phố Biên Hòa, Tỉnh Đồng Nai","path_with_type":"Phường Phước Tân, Thành phố Biên Hòa, Tỉnh Đồng Nai","code":"26377","parent_code":"731"},"26380":{"name":"Xã Long Hưng","type":"xa","slug":"xa-long-hung","name_with_type":"Xã Long Hưng","path":"Xã Long Hưng, Thành phố Biên Hòa, Tỉnh Đồng Nai","path_with_type":"Xã Long Hưng, Thành phố Biên Hòa, Tỉnh Đồng Nai","code":"26380","parent_code":"731"},"26383":{"name":"Xã An Phước","type":"xa","slug":"xa-an-phuoc","name_with_type":"Xã An Phước","path":"Xã An Phước, Huyện Long Thành, Tỉnh Đồng Nai","path_with_type":"Xã An Phước, Huyện Long Thành, Tỉnh Đồng Nai","code":"26383","parent_code":"740"},"26386":{"name":"Xã Bình An","type":"xa","slug":"xa-binh-an","name_with_type":"Xã Bình An","path":"Xã Bình An, Huyện Long Thành, Tỉnh Đồng Nai","path_with_type":"Xã Bình An, Huyện Long Thành, Tỉnh Đồng Nai","code":"26386","parent_code":"740"},"26389":{"name":"Xã Long Đức","type":"xa","slug":"xa-long-duc","name_with_type":"Xã Long Đức","path":"Xã Long Đức, Huyện Long Thành, Tỉnh Đồng Nai","path_with_type":"Xã Long Đức, Huyện Long Thành, Tỉnh Đồng Nai","code":"26389","parent_code":"740"},"26392":{"name":"Xã Lộc An","type":"xa","slug":"xa-loc-an","name_with_type":"Xã Lộc An","path":"Xã Lộc An, Huyện Long Thành, Tỉnh Đồng Nai","path_with_type":"Xã Lộc An, Huyện Long Thành, Tỉnh Đồng Nai","code":"26392","parent_code":"740"},"26395":{"name":"Xã Bình Sơn","type":"xa","slug":"xa-binh-son","name_with_type":"Xã Bình Sơn","path":"Xã Bình Sơn, Huyện Long Thành, Tỉnh Đồng Nai","path_with_type":"Xã Bình Sơn, Huyện Long Thành, Tỉnh Đồng Nai","code":"26395","parent_code":"740"},"26398":{"name":"Xã Tam An","type":"xa","slug":"xa-tam-an","name_with_type":"Xã Tam An","path":"Xã Tam An, Huyện Long Thành, Tỉnh Đồng Nai","path_with_type":"Xã Tam An, Huyện Long Thành, Tỉnh Đồng Nai","code":"26398","parent_code":"740"},"26401":{"name":"Xã Cẩm Đường","type":"xa","slug":"xa-cam-duong","name_with_type":"Xã Cẩm Đường","path":"Xã Cẩm Đường, Huyện Long Thành, Tỉnh Đồng Nai","path_with_type":"Xã Cẩm Đường, Huyện Long Thành, Tỉnh Đồng Nai","code":"26401","parent_code":"740"},"26404":{"name":"Xã Long An","type":"xa","slug":"xa-long-an","name_with_type":"Xã Long An","path":"Xã Long An, Huyện Long Thành, Tỉnh Đồng Nai","path_with_type":"Xã Long An, Huyện Long Thành, Tỉnh Đồng Nai","code":"26404","parent_code":"740"},"26410":{"name":"Xã Bàu Cạn","type":"xa","slug":"xa-bau-can","name_with_type":"Xã Bàu Cạn","path":"Xã Bàu Cạn, Huyện Long Thành, Tỉnh Đồng Nai","path_with_type":"Xã Bàu Cạn, Huyện Long Thành, Tỉnh Đồng Nai","code":"26410","parent_code":"740"},"26413":{"name":"Xã Long Phước","type":"xa","slug":"xa-long-phuoc","name_with_type":"Xã Long Phước","path":"Xã Long Phước, Huyện Long Thành, Tỉnh Đồng Nai","path_with_type":"Xã Long Phước, Huyện Long Thành, Tỉnh Đồng Nai","code":"26413","parent_code":"740"},"26416":{"name":"Xã Phước Bình","type":"xa","slug":"xa-phuoc-binh","name_with_type":"Xã Phước Bình","path":"Xã Phước Bình, Huyện Long Thành, Tỉnh Đồng Nai","path_with_type":"Xã Phước Bình, Huyện Long Thành, Tỉnh Đồng Nai","code":"26416","parent_code":"740"},"26419":{"name":"Xã Tân Hiệp","type":"xa","slug":"xa-tan-hiep","name_with_type":"Xã Tân Hiệp","path":"Xã Tân Hiệp, Huyện Long Thành, Tỉnh Đồng Nai","path_with_type":"Xã Tân Hiệp, Huyện Long Thành, Tỉnh Đồng Nai","code":"26419","parent_code":"740"},"26422":{"name":"Xã Phước Thái","type":"xa","slug":"xa-phuoc-thai","name_with_type":"Xã Phước Thái","path":"Xã Phước Thái, Huyện Long Thành, Tỉnh Đồng Nai","path_with_type":"Xã Phước Thái, Huyện Long Thành, Tỉnh Đồng Nai","code":"26422","parent_code":"740"},"26425":{"name":"Thị trấn Gia Ray","type":"thi-tran","slug":"thi-tran-gia-ray","name_with_type":"Thị trấn Gia Ray","path":"Thị trấn Gia Ray, Huyện Xuân Lộc, Tỉnh Đồng Nai","path_with_type":"Thị trấn Gia Ray, Huyện Xuân Lộc, Tỉnh Đồng Nai","code":"26425","parent_code":"741"},"26428":{"name":"Xã Xuân Bắc","type":"xa","slug":"xa-xuan-bac","name_with_type":"Xã Xuân Bắc","path":"Xã Xuân Bắc, Huyện Xuân Lộc, Tỉnh Đồng Nai","path_with_type":"Xã Xuân Bắc, Huyện Xuân Lộc, Tỉnh Đồng Nai","code":"26428","parent_code":"741"},"26431":{"name":"Xã Suối Cao","type":"xa","slug":"xa-suoi-cao","name_with_type":"Xã Suối Cao","path":"Xã Suối Cao, Huyện Xuân Lộc, Tỉnh Đồng Nai","path_with_type":"Xã Suối Cao, Huyện Xuân Lộc, Tỉnh Đồng Nai","code":"26431","parent_code":"741"},"26434":{"name":"Xã Xuân Thành","type":"xa","slug":"xa-xuan-thanh","name_with_type":"Xã Xuân Thành","path":"Xã Xuân Thành, Huyện Xuân Lộc, Tỉnh Đồng Nai","path_with_type":"Xã Xuân Thành, Huyện Xuân Lộc, Tỉnh Đồng Nai","code":"26434","parent_code":"741"},"26437":{"name":"Xã Xuân Thọ","type":"xa","slug":"xa-xuan-tho","name_with_type":"Xã Xuân Thọ","path":"Xã Xuân Thọ, Huyện Xuân Lộc, Tỉnh Đồng Nai","path_with_type":"Xã Xuân Thọ, Huyện Xuân Lộc, Tỉnh Đồng Nai","code":"26437","parent_code":"741"},"26440":{"name":"Xã Xuân Trường","type":"xa","slug":"xa-xuan-truong","name_with_type":"Xã Xuân Trường","path":"Xã Xuân Trường, Huyện Xuân Lộc, Tỉnh Đồng Nai","path_with_type":"Xã Xuân Trường, Huyện Xuân Lộc, Tỉnh Đồng Nai","code":"26440","parent_code":"741"},"26443":{"name":"Xã Xuân Hòa","type":"xa","slug":"xa-xuan-hoa","name_with_type":"Xã Xuân Hòa","path":"Xã Xuân Hòa, Huyện Xuân Lộc, Tỉnh Đồng Nai","path_with_type":"Xã Xuân Hòa, Huyện Xuân Lộc, Tỉnh Đồng Nai","code":"26443","parent_code":"741"},"26446":{"name":"Xã Xuân Hưng","type":"xa","slug":"xa-xuan-hung","name_with_type":"Xã Xuân Hưng","path":"Xã Xuân Hưng, Huyện Xuân Lộc, Tỉnh Đồng Nai","path_with_type":"Xã Xuân Hưng, Huyện Xuân Lộc, Tỉnh Đồng Nai","code":"26446","parent_code":"741"},"26449":{"name":"Xã Xuân Tâm","type":"xa","slug":"xa-xuan-tam","name_with_type":"Xã Xuân Tâm","path":"Xã Xuân Tâm, Huyện Xuân Lộc, Tỉnh Đồng Nai","path_with_type":"Xã Xuân Tâm, Huyện Xuân Lộc, Tỉnh Đồng Nai","code":"26449","parent_code":"741"},"26452":{"name":"Xã Suối Cát","type":"xa","slug":"xa-suoi-cat","name_with_type":"Xã Suối Cát","path":"Xã Suối Cát, Huyện Xuân Lộc, Tỉnh Đồng Nai","path_with_type":"Xã Suối Cát, Huyện Xuân Lộc, Tỉnh Đồng Nai","code":"26452","parent_code":"741"},"26455":{"name":"Xã Xuân Hiệp","type":"xa","slug":"xa-xuan-hiep","name_with_type":"Xã Xuân Hiệp","path":"Xã Xuân Hiệp, Huyện Xuân Lộc, Tỉnh Đồng Nai","path_with_type":"Xã Xuân Hiệp, Huyện Xuân Lộc, Tỉnh Đồng Nai","code":"26455","parent_code":"741"},"26458":{"name":"Xã Xuân Phú","type":"xa","slug":"xa-xuan-phu","name_with_type":"Xã Xuân Phú","path":"Xã Xuân Phú, Huyện Xuân Lộc, Tỉnh Đồng Nai","path_with_type":"Xã Xuân Phú, Huyện Xuân Lộc, Tỉnh Đồng Nai","code":"26458","parent_code":"741"},"26461":{"name":"Xã Xuân Định","type":"xa","slug":"xa-xuan-dinh","name_with_type":"Xã Xuân Định","path":"Xã Xuân Định, Huyện Xuân Lộc, Tỉnh Đồng Nai","path_with_type":"Xã Xuân Định, Huyện Xuân Lộc, Tỉnh Đồng Nai","code":"26461","parent_code":"741"},"26464":{"name":"Xã Bảo Hoà","type":"xa","slug":"xa-bao-hoa","name_with_type":"Xã Bảo Hoà","path":"Xã Bảo Hoà, Huyện Xuân Lộc, Tỉnh Đồng Nai","path_with_type":"Xã Bảo Hoà, Huyện Xuân Lộc, Tỉnh Đồng Nai","code":"26464","parent_code":"741"},"26467":{"name":"Xã Lang Minh","type":"xa","slug":"xa-lang-minh","name_with_type":"Xã Lang Minh","path":"Xã Lang Minh, Huyện Xuân Lộc, Tỉnh Đồng Nai","path_with_type":"Xã Lang Minh, Huyện Xuân Lộc, Tỉnh Đồng Nai","code":"26467","parent_code":"741"},"26470":{"name":"Xã Phước Thiền","type":"xa","slug":"xa-phuoc-thien","name_with_type":"Xã Phước Thiền","path":"Xã Phước Thiền, Huyện Nhơn Trạch, Tỉnh Đồng Nai","path_with_type":"Xã Phước Thiền, Huyện Nhơn Trạch, Tỉnh Đồng Nai","code":"26470","parent_code":"742"},"26473":{"name":"Xã Long Tân","type":"xa","slug":"xa-long-tan","name_with_type":"Xã Long Tân","path":"Xã Long Tân, Huyện Nhơn Trạch, Tỉnh Đồng Nai","path_with_type":"Xã Long Tân, Huyện Nhơn Trạch, Tỉnh Đồng Nai","code":"26473","parent_code":"742"},"26476":{"name":"Xã Đại Phước","type":"xa","slug":"xa-dai-phuoc","name_with_type":"Xã Đại Phước","path":"Xã Đại Phước, Huyện Nhơn Trạch, Tỉnh Đồng Nai","path_with_type":"Xã Đại Phước, Huyện Nhơn Trạch, Tỉnh Đồng Nai","code":"26476","parent_code":"742"},"26479":{"name":"Thị trấn Hiệp Phước","type":"thi-tran","slug":"thi-tran-hiep-phuoc","name_with_type":"Thị trấn Hiệp Phước","path":"Thị trấn Hiệp Phước, Huyện Nhơn Trạch, Tỉnh Đồng Nai","path_with_type":"Thị trấn Hiệp Phước, Huyện Nhơn Trạch, Tỉnh Đồng Nai","code":"26479","parent_code":"742"},"26482":{"name":"Xã Phú Hữu","type":"xa","slug":"xa-phu-huu","name_with_type":"Xã Phú Hữu","path":"Xã Phú Hữu, Huyện Nhơn Trạch, Tỉnh Đồng Nai","path_with_type":"Xã Phú Hữu, Huyện Nhơn Trạch, Tỉnh Đồng Nai","code":"26482","parent_code":"742"},"26485":{"name":"Xã Phú Hội","type":"xa","slug":"xa-phu-hoi","name_with_type":"Xã Phú Hội","path":"Xã Phú Hội, Huyện Nhơn Trạch, Tỉnh Đồng Nai","path_with_type":"Xã Phú Hội, Huyện Nhơn Trạch, Tỉnh Đồng Nai","code":"26485","parent_code":"742"},"26488":{"name":"Xã Phú Thạnh","type":"xa","slug":"xa-phu-thanh","name_with_type":"Xã Phú Thạnh","path":"Xã Phú Thạnh, Huyện Nhơn Trạch, Tỉnh Đồng Nai","path_with_type":"Xã Phú Thạnh, Huyện Nhơn Trạch, Tỉnh Đồng Nai","code":"26488","parent_code":"742"},"26491":{"name":"Xã Phú Đông","type":"xa","slug":"xa-phu-dong","name_with_type":"Xã Phú Đông","path":"Xã Phú Đông, Huyện Nhơn Trạch, Tỉnh Đồng Nai","path_with_type":"Xã Phú Đông, Huyện Nhơn Trạch, Tỉnh Đồng Nai","code":"26491","parent_code":"742"},"26494":{"name":"Xã Long Thọ","type":"xa","slug":"xa-long-tho","name_with_type":"Xã Long Thọ","path":"Xã Long Thọ, Huyện Nhơn Trạch, Tỉnh Đồng Nai","path_with_type":"Xã Long Thọ, Huyện Nhơn Trạch, Tỉnh Đồng Nai","code":"26494","parent_code":"742"},"26497":{"name":"Xã Vĩnh Thanh","type":"xa","slug":"xa-vinh-thanh","name_with_type":"Xã Vĩnh Thanh","path":"Xã Vĩnh Thanh, Huyện Nhơn Trạch, Tỉnh Đồng Nai","path_with_type":"Xã Vĩnh Thanh, Huyện Nhơn Trạch, Tỉnh Đồng Nai","code":"26497","parent_code":"742"},"26500":{"name":"Xã Phước Khánh","type":"xa","slug":"xa-phuoc-khanh","name_with_type":"Xã Phước Khánh","path":"Xã Phước Khánh, Huyện Nhơn Trạch, Tỉnh Đồng Nai","path_with_type":"Xã Phước Khánh, Huyện Nhơn Trạch, Tỉnh Đồng Nai","code":"26500","parent_code":"742"},"26503":{"name":"Xã Phước An","type":"xa","slug":"xa-phuoc-an","name_with_type":"Xã Phước An","path":"Xã Phước An, Huyện Nhơn Trạch, Tỉnh Đồng Nai","path_with_type":"Xã Phước An, Huyện Nhơn Trạch, Tỉnh Đồng Nai","code":"26503","parent_code":"742"},"26506":{"name":"Phường 1","type":"phuong","slug":"phuong-1","name_with_type":"Phường 1","path":"Phường 1, Thành phố Vũng Tàu, Tỉnh Bà Rịa - Vũng Tàu","path_with_type":"Phường 1, Thành phố Vũng Tàu, Tỉnh Bà Rịa - Vũng Tàu","code":"26506","parent_code":"747"},"26508":{"name":"Phường Thắng Tam","type":"phuong","slug":"phuong-thang-tam","name_with_type":"Phường Thắng Tam","path":"Phường Thắng Tam, Thành phố Vũng Tàu, Tỉnh Bà Rịa - Vũng Tàu","path_with_type":"Phường Thắng Tam, Thành phố Vũng Tàu, Tỉnh Bà Rịa - Vũng Tàu","code":"26508","parent_code":"747"},"26509":{"name":"Phường 2","type":"phuong","slug":"phuong-2","name_with_type":"Phường 2","path":"Phường 2, Thành phố Vũng Tàu, Tỉnh Bà Rịa - Vũng Tàu","path_with_type":"Phường 2, Thành phố Vũng Tàu, Tỉnh Bà Rịa - Vũng Tàu","code":"26509","parent_code":"747"},"26512":{"name":"Phường 3","type":"phuong","slug":"phuong-3","name_with_type":"Phường 3","path":"Phường 3, Thành phố Vũng Tàu, Tỉnh Bà Rịa - Vũng Tàu","path_with_type":"Phường 3, Thành phố Vũng Tàu, Tỉnh Bà Rịa - Vũng Tàu","code":"26512","parent_code":"747"},"26515":{"name":"Phường 4","type":"phuong","slug":"phuong-4","name_with_type":"Phường 4","path":"Phường 4, Thành phố Vũng Tàu, Tỉnh Bà Rịa - Vũng Tàu","path_with_type":"Phường 4, Thành phố Vũng Tàu, Tỉnh Bà Rịa - Vũng Tàu","code":"26515","parent_code":"747"},"26518":{"name":"Phường 5","type":"phuong","slug":"phuong-5","name_with_type":"Phường 5","path":"Phường 5, Thành phố Vũng Tàu, Tỉnh Bà Rịa - Vũng Tàu","path_with_type":"Phường 5, Thành phố Vũng Tàu, Tỉnh Bà Rịa - Vũng Tàu","code":"26518","parent_code":"747"},"26521":{"name":"Phường Thắng Nhì","type":"phuong","slug":"phuong-thang-nhi","name_with_type":"Phường Thắng Nhì","path":"Phường Thắng Nhì, Thành phố Vũng Tàu, Tỉnh Bà Rịa - Vũng Tàu","path_with_type":"Phường Thắng Nhì, Thành phố Vũng Tàu, Tỉnh Bà Rịa - Vũng Tàu","code":"26521","parent_code":"747"},"26524":{"name":"Phường 7","type":"phuong","slug":"phuong-7","name_with_type":"Phường 7","path":"Phường 7, Thành phố Vũng Tàu, Tỉnh Bà Rịa - Vũng Tàu","path_with_type":"Phường 7, Thành phố Vũng Tàu, Tỉnh Bà Rịa - Vũng Tàu","code":"26524","parent_code":"747"},"26526":{"name":"Phường Nguyễn An Ninh","type":"phuong","slug":"phuong-nguyen-an-ninh","name_with_type":"Phường Nguyễn An Ninh","path":"Phường Nguyễn An Ninh, Thành phố Vũng Tàu, Tỉnh Bà Rịa - Vũng Tàu","path_with_type":"Phường Nguyễn An Ninh, Thành phố Vũng Tàu, Tỉnh Bà Rịa - Vũng Tàu","code":"26526","parent_code":"747"},"26527":{"name":"Phường 8","type":"phuong","slug":"phuong-8","name_with_type":"Phường 8","path":"Phường 8, Thành phố Vũng Tàu, Tỉnh Bà Rịa - Vũng Tàu","path_with_type":"Phường 8, Thành phố Vũng Tàu, Tỉnh Bà Rịa - Vũng Tàu","code":"26527","parent_code":"747"},"26530":{"name":"Phường 9","type":"phuong","slug":"phuong-9","name_with_type":"Phường 9","path":"Phường 9, Thành phố Vũng Tàu, Tỉnh Bà Rịa - Vũng Tàu","path_with_type":"Phường 9, Thành phố Vũng Tàu, Tỉnh Bà Rịa - Vũng Tàu","code":"26530","parent_code":"747"},"26533":{"name":"Phường Thắng Nhất","type":"phuong","slug":"phuong-thang-nhat","name_with_type":"Phường Thắng Nhất","path":"Phường Thắng Nhất, Thành phố Vũng Tàu, Tỉnh Bà Rịa - Vũng Tàu","path_with_type":"Phường Thắng Nhất, Thành phố Vũng Tàu, Tỉnh Bà Rịa - Vũng Tàu","code":"26533","parent_code":"747"},"26535":{"name":"Phường Rạch Dừa","type":"phuong","slug":"phuong-rach-dua","name_with_type":"Phường Rạch Dừa","path":"Phường Rạch Dừa, Thành phố Vũng Tàu, Tỉnh Bà Rịa - Vũng Tàu","path_with_type":"Phường Rạch Dừa, Thành phố Vũng Tàu, Tỉnh Bà Rịa - Vũng Tàu","code":"26535","parent_code":"747"},"26536":{"name":"Phường 10","type":"phuong","slug":"phuong-10","name_with_type":"Phường 10","path":"Phường 10, Thành phố Vũng Tàu, Tỉnh Bà Rịa - Vũng Tàu","path_with_type":"Phường 10, Thành phố Vũng Tàu, Tỉnh Bà Rịa - Vũng Tàu","code":"26536","parent_code":"747"},"26539":{"name":"Phường 11","type":"phuong","slug":"phuong-11","name_with_type":"Phường 11","path":"Phường 11, Thành phố Vũng Tàu, Tỉnh Bà Rịa - Vũng Tàu","path_with_type":"Phường 11, Thành phố Vũng Tàu, Tỉnh Bà Rịa - Vũng Tàu","code":"26539","parent_code":"747"},"26542":{"name":"Phường 12","type":"phuong","slug":"phuong-12","name_with_type":"Phường 12","path":"Phường 12, Thành phố Vũng Tàu, Tỉnh Bà Rịa - Vũng Tàu","path_with_type":"Phường 12, Thành phố Vũng Tàu, Tỉnh Bà Rịa - Vũng Tàu","code":"26542","parent_code":"747"},"26545":{"name":"Xã Long Sơn","type":"xa","slug":"xa-long-son","name_with_type":"Xã Long Sơn","path":"Xã Long Sơn, Thành phố Vũng Tàu, Tỉnh Bà Rịa - Vũng Tàu","path_with_type":"Xã Long Sơn, Thành phố Vũng Tàu, Tỉnh Bà Rịa - Vũng Tàu","code":"26545","parent_code":"747"},"26548":{"name":"Phường Phước Hưng","type":"phuong","slug":"phuong-phuoc-hung","name_with_type":"Phường Phước Hưng","path":"Phường Phước Hưng, Thành phố Bà Rịa, Tỉnh Bà Rịa - Vũng Tàu","path_with_type":"Phường Phước Hưng, Thành phố Bà Rịa, Tỉnh Bà Rịa - Vũng Tàu","code":"26548","parent_code":"748"},"26554":{"name":"Phường Phước Nguyên","type":"phuong","slug":"phuong-phuoc-nguyen","name_with_type":"Phường Phước Nguyên","path":"Phường Phước Nguyên, Thành phố Bà Rịa, Tỉnh Bà Rịa - Vũng Tàu","path_with_type":"Phường Phước Nguyên, Thành phố Bà Rịa, Tỉnh Bà Rịa - Vũng Tàu","code":"26554","parent_code":"748"},"26557":{"name":"Phường Long Toàn","type":"phuong","slug":"phuong-long-toan","name_with_type":"Phường Long Toàn","path":"Phường Long Toàn, Thành phố Bà Rịa, Tỉnh Bà Rịa - Vũng Tàu","path_with_type":"Phường Long Toàn, Thành phố Bà Rịa, Tỉnh Bà Rịa - Vũng Tàu","code":"26557","parent_code":"748"},"26558":{"name":"Phường Long Tâm","type":"phuong","slug":"phuong-long-tam","name_with_type":"Phường Long Tâm","path":"Phường Long Tâm, Thành phố Bà Rịa, Tỉnh Bà Rịa - Vũng Tàu","path_with_type":"Phường Long Tâm, Thành phố Bà Rịa, Tỉnh Bà Rịa - Vũng Tàu","code":"26558","parent_code":"748"},"26560":{"name":"Phường Phước Trung","type":"phuong","slug":"phuong-phuoc-trung","name_with_type":"Phường Phước Trung","path":"Phường Phước Trung, Thành phố Bà Rịa, Tỉnh Bà Rịa - Vũng Tàu","path_with_type":"Phường Phước Trung, Thành phố Bà Rịa, Tỉnh Bà Rịa - Vũng Tàu","code":"26560","parent_code":"748"},"26563":{"name":"Phường Long Hương","type":"phuong","slug":"phuong-long-huong","name_with_type":"Phường Long Hương","path":"Phường Long Hương, Thành phố Bà Rịa, Tỉnh Bà Rịa - Vũng Tàu","path_with_type":"Phường Long Hương, Thành phố Bà Rịa, Tỉnh Bà Rịa - Vũng Tàu","code":"26563","parent_code":"748"},"26566":{"name":"Phường Kim Dinh","type":"phuong","slug":"phuong-kim-dinh","name_with_type":"Phường Kim Dinh","path":"Phường Kim Dinh, Thành phố Bà Rịa, Tỉnh Bà Rịa - Vũng Tàu","path_with_type":"Phường Kim Dinh, Thành phố Bà Rịa, Tỉnh Bà Rịa - Vũng Tàu","code":"26566","parent_code":"748"},"26567":{"name":"Xã Tân Hưng","type":"xa","slug":"xa-tan-hung","name_with_type":"Xã Tân Hưng","path":"Xã Tân Hưng, Thành phố Bà Rịa, Tỉnh Bà Rịa - Vũng Tàu","path_with_type":"Xã Tân Hưng, Thành phố Bà Rịa, Tỉnh Bà Rịa - Vũng Tàu","code":"26567","parent_code":"748"},"26569":{"name":"Xã Long Phước","type":"xa","slug":"xa-long-phuoc","name_with_type":"Xã Long Phước","path":"Xã Long Phước, Thành phố Bà Rịa, Tỉnh Bà Rịa - Vũng Tàu","path_with_type":"Xã Long Phước, Thành phố Bà Rịa, Tỉnh Bà Rịa - Vũng Tàu","code":"26569","parent_code":"748"},"26572":{"name":"Xã Hoà Long","type":"xa","slug":"xa-hoa-long","name_with_type":"Xã Hoà Long","path":"Xã Hoà Long, Thành phố Bà Rịa, Tỉnh Bà Rịa - Vũng Tàu","path_with_type":"Xã Hoà Long, Thành phố Bà Rịa, Tỉnh Bà Rịa - Vũng Tàu","code":"26572","parent_code":"748"},"26574":{"name":"Xã Bàu Chinh","type":"xa","slug":"xa-bau-chinh","name_with_type":"Xã Bàu Chinh","path":"Xã Bàu Chinh, Huyện Châu Đức, Tỉnh Bà Rịa - Vũng Tàu","path_with_type":"Xã Bàu Chinh, Huyện Châu Đức, Tỉnh Bà Rịa - Vũng Tàu","code":"26574","parent_code":"750"},"26575":{"name":"Thị trấn Ngãi Giao","type":"thi-tran","slug":"thi-tran-ngai-giao","name_with_type":"Thị trấn Ngãi Giao","path":"Thị trấn Ngãi Giao, Huyện Châu Đức, Tỉnh Bà Rịa - Vũng Tàu","path_with_type":"Thị trấn Ngãi Giao, Huyện Châu Đức, Tỉnh Bà Rịa - Vũng Tàu","code":"26575","parent_code":"750"},"26578":{"name":"Xã Bình Ba","type":"xa","slug":"xa-binh-ba","name_with_type":"Xã Bình Ba","path":"Xã Bình Ba, Huyện Châu Đức, Tỉnh Bà Rịa - Vũng Tàu","path_with_type":"Xã Bình Ba, Huyện Châu Đức, Tỉnh Bà Rịa - Vũng Tàu","code":"26578","parent_code":"750"},"26581":{"name":"Xã Suối Nghệ","type":"xa","slug":"xa-suoi-nghe","name_with_type":"Xã Suối Nghệ","path":"Xã Suối Nghệ, Huyện Châu Đức, Tỉnh Bà Rịa - Vũng Tàu","path_with_type":"Xã Suối Nghệ, Huyện Châu Đức, Tỉnh Bà Rịa - Vũng Tàu","code":"26581","parent_code":"750"},"26584":{"name":"Xã Xuân Sơn","type":"xa","slug":"xa-xuan-son","name_with_type":"Xã Xuân Sơn","path":"Xã Xuân Sơn, Huyện Châu Đức, Tỉnh Bà Rịa - Vũng Tàu","path_with_type":"Xã Xuân Sơn, Huyện Châu Đức, Tỉnh Bà Rịa - Vũng Tàu","code":"26584","parent_code":"750"},"26587":{"name":"Xã Sơn Bình","type":"xa","slug":"xa-son-binh","name_with_type":"Xã Sơn Bình","path":"Xã Sơn Bình, Huyện Châu Đức, Tỉnh Bà Rịa - Vũng Tàu","path_with_type":"Xã Sơn Bình, Huyện Châu Đức, Tỉnh Bà Rịa - Vũng Tàu","code":"26587","parent_code":"750"},"26590":{"name":"Xã Bình Giã","type":"xa","slug":"xa-binh-gia","name_with_type":"Xã Bình Giã","path":"Xã Bình Giã, Huyện Châu Đức, Tỉnh Bà Rịa - Vũng Tàu","path_with_type":"Xã Bình Giã, Huyện Châu Đức, Tỉnh Bà Rịa - Vũng Tàu","code":"26590","parent_code":"750"},"26593":{"name":"Xã Bình Trung","type":"xa","slug":"xa-binh-trung","name_with_type":"Xã Bình Trung","path":"Xã Bình Trung, Huyện Châu Đức, Tỉnh Bà Rịa - Vũng Tàu","path_with_type":"Xã Bình Trung, Huyện Châu Đức, Tỉnh Bà Rịa - Vũng Tàu","code":"26593","parent_code":"750"},"26596":{"name":"Xã Xà Bang","type":"xa","slug":"xa-xa-bang","name_with_type":"Xã Xà Bang","path":"Xã Xà Bang, Huyện Châu Đức, Tỉnh Bà Rịa - Vũng Tàu","path_with_type":"Xã Xà Bang, Huyện Châu Đức, Tỉnh Bà Rịa - Vũng Tàu","code":"26596","parent_code":"750"},"26599":{"name":"Xã Cù Bị","type":"xa","slug":"xa-cu-bi","name_with_type":"Xã Cù Bị","path":"Xã Cù Bị, Huyện Châu Đức, Tỉnh Bà Rịa - Vũng Tàu","path_with_type":"Xã Cù Bị, Huyện Châu Đức, Tỉnh Bà Rịa - Vũng Tàu","code":"26599","parent_code":"750"},"26602":{"name":"Xã Láng Lớn","type":"xa","slug":"xa-lang-lon","name_with_type":"Xã Láng Lớn","path":"Xã Láng Lớn, Huyện Châu Đức, Tỉnh Bà Rịa - Vũng Tàu","path_with_type":"Xã Láng Lớn, Huyện Châu Đức, Tỉnh Bà Rịa - Vũng Tàu","code":"26602","parent_code":"750"},"26605":{"name":"Xã Quảng Thành","type":"xa","slug":"xa-quang-thanh","name_with_type":"Xã Quảng Thành","path":"Xã Quảng Thành, Huyện Châu Đức, Tỉnh Bà Rịa - Vũng Tàu","path_with_type":"Xã Quảng Thành, Huyện Châu Đức, Tỉnh Bà Rịa - Vũng Tàu","code":"26605","parent_code":"750"},"26608":{"name":"Thị trấn Kim Long","type":"thi-tran","slug":"thi-tran-kim-long","name_with_type":"Thị trấn Kim Long","path":"Thị trấn Kim Long, Huyện Châu Đức, Tỉnh Bà Rịa - Vũng Tàu","path_with_type":"Thị trấn Kim Long, Huyện Châu Đức, Tỉnh Bà Rịa - Vũng Tàu","code":"26608","parent_code":"750"},"26611":{"name":"Xã Suối Rao","type":"xa","slug":"xa-suoi-rao","name_with_type":"Xã Suối Rao","path":"Xã Suối Rao, Huyện Châu Đức, Tỉnh Bà Rịa - Vũng Tàu","path_with_type":"Xã Suối Rao, Huyện Châu Đức, Tỉnh Bà Rịa - Vũng Tàu","code":"26611","parent_code":"750"},"26614":{"name":"Xã Đá Bạc","type":"xa","slug":"xa-da-bac","name_with_type":"Xã Đá Bạc","path":"Xã Đá Bạc, Huyện Châu Đức, Tỉnh Bà Rịa - Vũng Tàu","path_with_type":"Xã Đá Bạc, Huyện Châu Đức, Tỉnh Bà Rịa - Vũng Tàu","code":"26614","parent_code":"750"},"26617":{"name":"Xã Nghĩa Thành","type":"xa","slug":"xa-nghia-thanh","name_with_type":"Xã Nghĩa Thành","path":"Xã Nghĩa Thành, Huyện Châu Đức, Tỉnh Bà Rịa - Vũng Tàu","path_with_type":"Xã Nghĩa Thành, Huyện Châu Đức, Tỉnh Bà Rịa - Vũng Tàu","code":"26617","parent_code":"750"},"26620":{"name":"Thị trấn Phước Bửu","type":"thi-tran","slug":"thi-tran-phuoc-buu","name_with_type":"Thị trấn Phước Bửu","path":"Thị trấn Phước Bửu, Huyện Xuyên Mộc, Tỉnh Bà Rịa - Vũng Tàu","path_with_type":"Thị trấn Phước Bửu, Huyện Xuyên Mộc, Tỉnh Bà Rịa - Vũng Tàu","code":"26620","parent_code":"751"},"26623":{"name":"Xã Phước Thuận","type":"xa","slug":"xa-phuoc-thuan","name_with_type":"Xã Phước Thuận","path":"Xã Phước Thuận, Huyện Xuyên Mộc, Tỉnh Bà Rịa - Vũng Tàu","path_with_type":"Xã Phước Thuận, Huyện Xuyên Mộc, Tỉnh Bà Rịa - Vũng Tàu","code":"26623","parent_code":"751"},"26626":{"name":"Xã Phước Tân","type":"xa","slug":"xa-phuoc-tan","name_with_type":"Xã Phước Tân","path":"Xã Phước Tân, Huyện Xuyên Mộc, Tỉnh Bà Rịa - Vũng Tàu","path_with_type":"Xã Phước Tân, Huyện Xuyên Mộc, Tỉnh Bà Rịa - Vũng Tàu","code":"26626","parent_code":"751"},"26629":{"name":"Xã Xuyên Mộc","type":"xa","slug":"xa-xuyen-moc","name_with_type":"Xã Xuyên Mộc","path":"Xã Xuyên Mộc, Huyện Xuyên Mộc, Tỉnh Bà Rịa - Vũng Tàu","path_with_type":"Xã Xuyên Mộc, Huyện Xuyên Mộc, Tỉnh Bà Rịa - Vũng Tàu","code":"26629","parent_code":"751"},"26632":{"name":"Xã Bông Trang","type":"xa","slug":"xa-bong-trang","name_with_type":"Xã Bông Trang","path":"Xã Bông Trang, Huyện Xuyên Mộc, Tỉnh Bà Rịa - Vũng Tàu","path_with_type":"Xã Bông Trang, Huyện Xuyên Mộc, Tỉnh Bà Rịa - Vũng Tàu","code":"26632","parent_code":"751"},"26635":{"name":"Xã Tân Lâm","type":"xa","slug":"xa-tan-lam","name_with_type":"Xã Tân Lâm","path":"Xã Tân Lâm, Huyện Xuyên Mộc, Tỉnh Bà Rịa - Vũng Tàu","path_with_type":"Xã Tân Lâm, Huyện Xuyên Mộc, Tỉnh Bà Rịa - Vũng Tàu","code":"26635","parent_code":"751"},"26638":{"name":"Xã Bàu Lâm","type":"xa","slug":"xa-bau-lam","name_with_type":"Xã Bàu Lâm","path":"Xã Bàu Lâm, Huyện Xuyên Mộc, Tỉnh Bà Rịa - Vũng Tàu","path_with_type":"Xã Bàu Lâm, Huyện Xuyên Mộc, Tỉnh Bà Rịa - Vũng Tàu","code":"26638","parent_code":"751"},"26641":{"name":"Xã Hòa Bình","type":"xa","slug":"xa-hoa-binh","name_with_type":"Xã Hòa Bình","path":"Xã Hòa Bình, Huyện Xuyên Mộc, Tỉnh Bà Rịa - Vũng Tàu","path_with_type":"Xã Hòa Bình, Huyện Xuyên Mộc, Tỉnh Bà Rịa - Vũng Tàu","code":"26641","parent_code":"751"},"26644":{"name":"Xã Hòa Hưng","type":"xa","slug":"xa-hoa-hung","name_with_type":"Xã Hòa Hưng","path":"Xã Hòa Hưng, Huyện Xuyên Mộc, Tỉnh Bà Rịa - Vũng Tàu","path_with_type":"Xã Hòa Hưng, Huyện Xuyên Mộc, Tỉnh Bà Rịa - Vũng Tàu","code":"26644","parent_code":"751"},"26647":{"name":"Xã Hòa Hiệp","type":"xa","slug":"xa-hoa-hiep","name_with_type":"Xã Hòa Hiệp","path":"Xã Hòa Hiệp, Huyện Xuyên Mộc, Tỉnh Bà Rịa - Vũng Tàu","path_with_type":"Xã Hòa Hiệp, Huyện Xuyên Mộc, Tỉnh Bà Rịa - Vũng Tàu","code":"26647","parent_code":"751"},"26650":{"name":"Xã Hòa Hội","type":"xa","slug":"xa-hoa-hoi","name_with_type":"Xã Hòa Hội","path":"Xã Hòa Hội, Huyện Xuyên Mộc, Tỉnh Bà Rịa - Vũng Tàu","path_with_type":"Xã Hòa Hội, Huyện Xuyên Mộc, Tỉnh Bà Rịa - Vũng Tàu","code":"26650","parent_code":"751"},"26653":{"name":"Xã Bưng Riềng","type":"xa","slug":"xa-bung-rieng","name_with_type":"Xã Bưng Riềng","path":"Xã Bưng Riềng, Huyện Xuyên Mộc, Tỉnh Bà Rịa - Vũng Tàu","path_with_type":"Xã Bưng Riềng, Huyện Xuyên Mộc, Tỉnh Bà Rịa - Vũng Tàu","code":"26653","parent_code":"751"},"26656":{"name":"Xã Bình Châu","type":"xa","slug":"xa-binh-chau","name_with_type":"Xã Bình Châu","path":"Xã Bình Châu, Huyện Xuyên Mộc, Tỉnh Bà Rịa - Vũng Tàu","path_with_type":"Xã Bình Châu, Huyện Xuyên Mộc, Tỉnh Bà Rịa - Vũng Tàu","code":"26656","parent_code":"751"},"26659":{"name":"Thị trấn Long Điền","type":"thi-tran","slug":"thi-tran-long-dien","name_with_type":"Thị trấn Long Điền","path":"Thị trấn Long Điền, Huyện Long Đất, Tỉnh Bà Rịa - Vũng Tàu","path_with_type":"Thị trấn Long Điền, Huyện Long Đất, Tỉnh Bà Rịa - Vũng Tàu","code":"26659","parent_code":"753"},"26662":{"name":"Thị trấn Long Hải","type":"thi-tran","slug":"thi-tran-long-hai","name_with_type":"Thị trấn Long Hải","path":"Thị trấn Long Hải, Huyện Long Đất, Tỉnh Bà Rịa - Vũng Tàu","path_with_type":"Thị trấn Long Hải, Huyện Long Đất, Tỉnh Bà Rịa - Vũng Tàu","code":"26662","parent_code":"753"},"26668":{"name":"Xã Tam An","type":"xa","slug":"xa-tam-an","name_with_type":"Xã Tam An","path":"Xã Tam An, Huyện Long Đất, Tỉnh Bà Rịa - Vũng Tàu","path_with_type":"Xã Tam An, Huyện Long Đất, Tỉnh Bà Rịa - Vũng Tàu","code":"26668","parent_code":"753"},"26674":{"name":"Xã Phước Tỉnh","type":"xa","slug":"xa-phuoc-tinh","name_with_type":"Xã Phước Tỉnh","path":"Xã Phước Tỉnh, Huyện Long Đất, Tỉnh Bà Rịa - Vũng Tàu","path_with_type":"Xã Phước Tỉnh, Huyện Long Đất, Tỉnh Bà Rịa - Vũng Tàu","code":"26674","parent_code":"753"},"26677":{"name":"Xã Phước Hưng","type":"xa","slug":"xa-phuoc-hung","name_with_type":"Xã Phước Hưng","path":"Xã Phước Hưng, Huyện Long Đất, Tỉnh Bà Rịa - Vũng Tàu","path_with_type":"Xã Phước Hưng, Huyện Long Đất, Tỉnh Bà Rịa - Vũng Tàu","code":"26677","parent_code":"753"},"26680":{"name":"Thị trấn Đất Đỏ","type":"thi-tran","slug":"thi-tran-dat-do","name_with_type":"Thị trấn Đất Đỏ","path":"Thị trấn Đất Đỏ, Huyện Long Đất, Tỉnh Bà Rịa - Vũng Tàu","path_with_type":"Thị trấn Đất Đỏ, Huyện Long Đất, Tỉnh Bà Rịa - Vũng Tàu","code":"26680","parent_code":"753"},"26683":{"name":"Xã Phước Long Thọ","type":"xa","slug":"xa-phuoc-long-tho","name_with_type":"Xã Phước Long Thọ","path":"Xã Phước Long Thọ, Huyện Long Đất, Tỉnh Bà Rịa - Vũng Tàu","path_with_type":"Xã Phước Long Thọ, Huyện Long Đất, Tỉnh Bà Rịa - Vũng Tàu","code":"26683","parent_code":"753"},"26686":{"name":"Xã Phước Hội","type":"xa","slug":"xa-phuoc-hoi","name_with_type":"Xã Phước Hội","path":"Xã Phước Hội, Huyện Long Đất, Tỉnh Bà Rịa - Vũng Tàu","path_with_type":"Xã Phước Hội, Huyện Long Đất, Tỉnh Bà Rịa - Vũng Tàu","code":"26686","parent_code":"753"},"26689":{"name":"Thị trấn Phước Hải","type":"thi-tran","slug":"thi-tran-phuoc-hai","name_with_type":"Thị trấn Phước Hải","path":"Thị trấn Phước Hải, Huyện Long Đất, Tỉnh Bà Rịa - Vũng Tàu","path_with_type":"Thị trấn Phước Hải, Huyện Long Đất, Tỉnh Bà Rịa - Vũng Tàu","code":"26689","parent_code":"753"},"26695":{"name":"Xã Long Tân","type":"xa","slug":"xa-long-tan","name_with_type":"Xã Long Tân","path":"Xã Long Tân, Huyện Long Đất, Tỉnh Bà Rịa - Vũng Tàu","path_with_type":"Xã Long Tân, Huyện Long Đất, Tỉnh Bà Rịa - Vũng Tàu","code":"26695","parent_code":"753"},"26698":{"name":"Xã Láng Dài","type":"xa","slug":"xa-lang-dai","name_with_type":"Xã Láng Dài","path":"Xã Láng Dài, Huyện Long Đất, Tỉnh Bà Rịa - Vũng Tàu","path_with_type":"Xã Láng Dài, Huyện Long Đất, Tỉnh Bà Rịa - Vũng Tàu","code":"26698","parent_code":"753"},"26704":{"name":"Phường Phú Mỹ","type":"phuong","slug":"phuong-phu-my","name_with_type":"Phường Phú Mỹ","path":"Phường Phú Mỹ, Thị xã Phú Mỹ, Tỉnh Bà Rịa - Vũng Tàu","path_with_type":"Phường Phú Mỹ, Thị xã Phú Mỹ, Tỉnh Bà Rịa - Vũng Tàu","code":"26704","parent_code":"754"},"26707":{"name":"Xã Tân Hoà","type":"xa","slug":"xa-tan-hoa","name_with_type":"Xã Tân Hoà","path":"Xã Tân Hoà, Thị xã Phú Mỹ, Tỉnh Bà Rịa - Vũng Tàu","path_with_type":"Xã Tân Hoà, Thị xã Phú Mỹ, Tỉnh Bà Rịa - Vũng Tàu","code":"26707","parent_code":"754"},"26710":{"name":"Xã Tân Hải","type":"xa","slug":"xa-tan-hai","name_with_type":"Xã Tân Hải","path":"Xã Tân Hải, Thị xã Phú Mỹ, Tỉnh Bà Rịa - Vũng Tàu","path_with_type":"Xã Tân Hải, Thị xã Phú Mỹ, Tỉnh Bà Rịa - Vũng Tàu","code":"26710","parent_code":"754"},"26713":{"name":"Phường Phước Hoà","type":"phuong","slug":"phuong-phuoc-hoa","name_with_type":"Phường Phước Hoà","path":"Phường Phước Hoà, Thị xã Phú Mỹ, Tỉnh Bà Rịa - Vũng Tàu","path_with_type":"Phường Phước Hoà, Thị xã Phú Mỹ, Tỉnh Bà Rịa - Vũng Tàu","code":"26713","parent_code":"754"},"26716":{"name":"Phường Tân Phước","type":"phuong","slug":"phuong-tan-phuoc","name_with_type":"Phường Tân Phước","path":"Phường Tân Phước, Thị xã Phú Mỹ, Tỉnh Bà Rịa - Vũng Tàu","path_with_type":"Phường Tân Phước, Thị xã Phú Mỹ, Tỉnh Bà Rịa - Vũng Tàu","code":"26716","parent_code":"754"},"26719":{"name":"Phường Mỹ Xuân","type":"phuong","slug":"phuong-my-xuan","name_with_type":"Phường Mỹ Xuân","path":"Phường Mỹ Xuân, Thị xã Phú Mỹ, Tỉnh Bà Rịa - Vũng Tàu","path_with_type":"Phường Mỹ Xuân, Thị xã Phú Mỹ, Tỉnh Bà Rịa - Vũng Tàu","code":"26719","parent_code":"754"},"26722":{"name":"Xã Sông Xoài","type":"xa","slug":"xa-song-xoai","name_with_type":"Xã Sông Xoài","path":"Xã Sông Xoài, Thị xã Phú Mỹ, Tỉnh Bà Rịa - Vũng Tàu","path_with_type":"Xã Sông Xoài, Thị xã Phú Mỹ, Tỉnh Bà Rịa - Vũng Tàu","code":"26722","parent_code":"754"},"26725":{"name":"Phường Hắc Dịch","type":"phuong","slug":"phuong-hac-dich","name_with_type":"Phường Hắc Dịch","path":"Phường Hắc Dịch, Thị xã Phú Mỹ, Tỉnh Bà Rịa - Vũng Tàu","path_with_type":"Phường Hắc Dịch, Thị xã Phú Mỹ, Tỉnh Bà Rịa - Vũng Tàu","code":"26725","parent_code":"754"},"26728":{"name":"Xã Châu Pha","type":"xa","slug":"xa-chau-pha","name_with_type":"Xã Châu Pha","path":"Xã Châu Pha, Thị xã Phú Mỹ, Tỉnh Bà Rịa - Vũng Tàu","path_with_type":"Xã Châu Pha, Thị xã Phú Mỹ, Tỉnh Bà Rịa - Vũng Tàu","code":"26728","parent_code":"754"},"26731":{"name":"Xã Tóc Tiên","type":"xa","slug":"xa-toc-tien","name_with_type":"Xã Tóc Tiên","path":"Xã Tóc Tiên, Thị xã Phú Mỹ, Tỉnh Bà Rịa - Vũng Tàu","path_with_type":"Xã Tóc Tiên, Thị xã Phú Mỹ, Tỉnh Bà Rịa - Vũng Tàu","code":"26731","parent_code":"754"},"26734":{"name":"Phường Tân Định","type":"phuong","slug":"phuong-tan-dinh","name_with_type":"Phường Tân Định","path":"Phường Tân Định, Quận 1, Thành phố Hồ Chí Minh","path_with_type":"Phường Tân Định, Quận 1, Thành phố Hồ Chí Minh","code":"26734","parent_code":"760"},"26737":{"name":"Phường Đa Kao","type":"phuong","slug":"phuong-da-kao","name_with_type":"Phường Đa Kao","path":"Phường Đa Kao, Quận 1, Thành phố Hồ Chí Minh","path_with_type":"Phường Đa Kao, Quận 1, Thành phố Hồ Chí Minh","code":"26737","parent_code":"760"},"26740":{"name":"Phường Bến Nghé","type":"phuong","slug":"phuong-ben-nghe","name_with_type":"Phường Bến Nghé","path":"Phường Bến Nghé, Quận 1, Thành phố Hồ Chí Minh","path_with_type":"Phường Bến Nghé, Quận 1, Thành phố Hồ Chí Minh","code":"26740","parent_code":"760"},"26743":{"name":"Phường Bến Thành","type":"phuong","slug":"phuong-ben-thanh","name_with_type":"Phường Bến Thành","path":"Phường Bến Thành, Quận 1, Thành phố Hồ Chí Minh","path_with_type":"Phường Bến Thành, Quận 1, Thành phố Hồ Chí Minh","code":"26743","parent_code":"760"},"26746":{"name":"Phường Nguyễn Thái Bình","type":"phuong","slug":"phuong-nguyen-thai-binh","name_with_type":"Phường Nguyễn Thái Bình","path":"Phường Nguyễn Thái Bình, Quận 1, Thành phố Hồ Chí Minh","path_with_type":"Phường Nguyễn Thái Bình, Quận 1, Thành phố Hồ Chí Minh","code":"26746","parent_code":"760"},"26749":{"name":"Phường Phạm Ngũ Lão","type":"phuong","slug":"phuong-pham-ngu-lao","name_with_type":"Phường Phạm Ngũ Lão","path":"Phường Phạm Ngũ Lão, Quận 1, Thành phố Hồ Chí Minh","path_with_type":"Phường Phạm Ngũ Lão, Quận 1, Thành phố Hồ Chí Minh","code":"26749","parent_code":"760"},"26752":{"name":"Phường Cầu Ông Lãnh","type":"phuong","slug":"phuong-cau-ong-lanh","name_with_type":"Phường Cầu Ông Lãnh","path":"Phường Cầu Ông Lãnh, Quận 1, Thành phố Hồ Chí Minh","path_with_type":"Phường Cầu Ông Lãnh, Quận 1, Thành phố Hồ Chí Minh","code":"26752","parent_code":"760"},"26755":{"name":"Phường Cô Giang","type":"phuong","slug":"phuong-co-giang","name_with_type":"Phường Cô Giang","path":"Phường Cô Giang, Quận 1, Thành phố Hồ Chí Minh","path_with_type":"Phường Cô Giang, Quận 1, Thành phố Hồ Chí Minh","code":"26755","parent_code":"760"},"26758":{"name":"Phường Nguyễn Cư Trinh","type":"phuong","slug":"phuong-nguyen-cu-trinh","name_with_type":"Phường Nguyễn Cư Trinh","path":"Phường Nguyễn Cư Trinh, Quận 1, Thành phố Hồ Chí Minh","path_with_type":"Phường Nguyễn Cư Trinh, Quận 1, Thành phố Hồ Chí Minh","code":"26758","parent_code":"760"},"26761":{"name":"Phường Cầu Kho","type":"phuong","slug":"phuong-cau-kho","name_with_type":"Phường Cầu Kho","path":"Phường Cầu Kho, Quận 1, Thành phố Hồ Chí Minh","path_with_type":"Phường Cầu Kho, Quận 1, Thành phố Hồ Chí Minh","code":"26761","parent_code":"760"},"26764":{"name":"Phường Thạnh Xuân","type":"phuong","slug":"phuong-thanh-xuan","name_with_type":"Phường Thạnh Xuân","path":"Phường Thạnh Xuân, Quận 12, Thành phố Hồ Chí Minh","path_with_type":"Phường Thạnh Xuân, Quận 12, Thành phố Hồ Chí Minh","code":"26764","parent_code":"761"},"26767":{"name":"Phường Thạnh Lộc","type":"phuong","slug":"phuong-thanh-loc","name_with_type":"Phường Thạnh Lộc","path":"Phường Thạnh Lộc, Quận 12, Thành phố Hồ Chí Minh","path_with_type":"Phường Thạnh Lộc, Quận 12, Thành phố Hồ Chí Minh","code":"26767","parent_code":"761"},"26770":{"name":"Phường Hiệp Thành","type":"phuong","slug":"phuong-hiep-thanh","name_with_type":"Phường Hiệp Thành","path":"Phường Hiệp Thành, Quận 12, Thành phố Hồ Chí Minh","path_with_type":"Phường Hiệp Thành, Quận 12, Thành phố Hồ Chí Minh","code":"26770","parent_code":"761"},"26773":{"name":"Phường Thới An","type":"phuong","slug":"phuong-thoi-an","name_with_type":"Phường Thới An","path":"Phường Thới An, Quận 12, Thành phố Hồ Chí Minh","path_with_type":"Phường Thới An, Quận 12, Thành phố Hồ Chí Minh","code":"26773","parent_code":"761"},"26776":{"name":"Phường Tân Chánh Hiệp","type":"phuong","slug":"phuong-tan-chanh-hiep","name_with_type":"Phường Tân Chánh Hiệp","path":"Phường Tân Chánh Hiệp, Quận 12, Thành phố Hồ Chí Minh","path_with_type":"Phường Tân Chánh Hiệp, Quận 12, Thành phố Hồ Chí Minh","code":"26776","parent_code":"761"},"26779":{"name":"Phường An Phú Đông","type":"phuong","slug":"phuong-an-phu-dong","name_with_type":"Phường An Phú Đông","path":"Phường An Phú Đông, Quận 12, Thành phố Hồ Chí Minh","path_with_type":"Phường An Phú Đông, Quận 12, Thành phố Hồ Chí Minh","code":"26779","parent_code":"761"},"26782":{"name":"Phường Tân Thới Hiệp","type":"phuong","slug":"phuong-tan-thoi-hiep","name_with_type":"Phường Tân Thới Hiệp","path":"Phường Tân Thới Hiệp, Quận 12, Thành phố Hồ Chí Minh","path_with_type":"Phường Tân Thới Hiệp, Quận 12, Thành phố Hồ Chí Minh","code":"26782","parent_code":"761"},"26785":{"name":"Phường Trung Mỹ Tây","type":"phuong","slug":"phuong-trung-my-tay","name_with_type":"Phường Trung Mỹ Tây","path":"Phường Trung Mỹ Tây, Quận 12, Thành phố Hồ Chí Minh","path_with_type":"Phường Trung Mỹ Tây, Quận 12, Thành phố Hồ Chí Minh","code":"26785","parent_code":"761"},"26787":{"name":"Phường Tân Hưng Thuận","type":"phuong","slug":"phuong-tan-hung-thuan","name_with_type":"Phường Tân Hưng Thuận","path":"Phường Tân Hưng Thuận, Quận 12, Thành phố Hồ Chí Minh","path_with_type":"Phường Tân Hưng Thuận, Quận 12, Thành phố Hồ Chí Minh","code":"26787","parent_code":"761"},"26788":{"name":"Phường Đông Hưng Thuận","type":"phuong","slug":"phuong-dong-hung-thuan","name_with_type":"Phường Đông Hưng Thuận","path":"Phường Đông Hưng Thuận, Quận 12, Thành phố Hồ Chí Minh","path_with_type":"Phường Đông Hưng Thuận, Quận 12, Thành phố Hồ Chí Minh","code":"26788","parent_code":"761"},"26791":{"name":"Phường Tân Thới Nhất","type":"phuong","slug":"phuong-tan-thoi-nhat","name_with_type":"Phường Tân Thới Nhất","path":"Phường Tân Thới Nhất, Quận 12, Thành phố Hồ Chí Minh","path_with_type":"Phường Tân Thới Nhất, Quận 12, Thành phố Hồ Chí Minh","code":"26791","parent_code":"761"},"26794":{"name":"Phường Linh Xuân","type":"phuong","slug":"phuong-linh-xuan","name_with_type":"Phường Linh Xuân","path":"Phường Linh Xuân, Thành phố Thủ Đức, Thành phố Hồ Chí Minh","path_with_type":"Phường Linh Xuân, Thành phố Thủ Đức, Thành phố Hồ Chí Minh","code":"26794","parent_code":"769"},"26797":{"name":"Phường Bình Chiểu","type":"phuong","slug":"phuong-binh-chieu","name_with_type":"Phường Bình Chiểu","path":"Phường Bình Chiểu, Thành phố Thủ Đức, Thành phố Hồ Chí Minh","path_with_type":"Phường Bình Chiểu, Thành phố Thủ Đức, Thành phố Hồ Chí Minh","code":"26797","parent_code":"769"},"26800":{"name":"Phường Linh Trung","type":"phuong","slug":"phuong-linh-trung","name_with_type":"Phường Linh Trung","path":"Phường Linh Trung, Thành phố Thủ Đức, Thành phố Hồ Chí Minh","path_with_type":"Phường Linh Trung, Thành phố Thủ Đức, Thành phố Hồ Chí Minh","code":"26800","parent_code":"769"},"26803":{"name":"Phường Tam Bình","type":"phuong","slug":"phuong-tam-binh","name_with_type":"Phường Tam Bình","path":"Phường Tam Bình, Thành phố Thủ Đức, Thành phố Hồ Chí Minh","path_with_type":"Phường Tam Bình, Thành phố Thủ Đức, Thành phố Hồ Chí Minh","code":"26803","parent_code":"769"},"26806":{"name":"Phường Tam Phú","type":"phuong","slug":"phuong-tam-phu","name_with_type":"Phường Tam Phú","path":"Phường Tam Phú, Thành phố Thủ Đức, Thành phố Hồ Chí Minh","path_with_type":"Phường Tam Phú, Thành phố Thủ Đức, Thành phố Hồ Chí Minh","code":"26806","parent_code":"769"},"26809":{"name":"Phường Hiệp Bình Phước","type":"phuong","slug":"phuong-hiep-binh-phuoc","name_with_type":"Phường Hiệp Bình Phước","path":"Phường Hiệp Bình Phước, Thành phố Thủ Đức, Thành phố Hồ Chí Minh","path_with_type":"Phường Hiệp Bình Phước, Thành phố Thủ Đức, Thành phố Hồ Chí Minh","code":"26809","parent_code":"769"},"26812":{"name":"Phường Hiệp Bình Chánh","type":"phuong","slug":"phuong-hiep-binh-chanh","name_with_type":"Phường Hiệp Bình Chánh","path":"Phường Hiệp Bình Chánh, Thành phố Thủ Đức, Thành phố Hồ Chí Minh","path_with_type":"Phường Hiệp Bình Chánh, Thành phố Thủ Đức, Thành phố Hồ Chí Minh","code":"26812","parent_code":"769"},"26815":{"name":"Phường Linh Chiểu","type":"phuong","slug":"phuong-linh-chieu","name_with_type":"Phường Linh Chiểu","path":"Phường Linh Chiểu, Thành phố Thủ Đức, Thành phố Hồ Chí Minh","path_with_type":"Phường Linh Chiểu, Thành phố Thủ Đức, Thành phố Hồ Chí Minh","code":"26815","parent_code":"769"},"26818":{"name":"Phường Linh Tây","type":"phuong","slug":"phuong-linh-tay","name_with_type":"Phường Linh Tây","path":"Phường Linh Tây, Thành phố Thủ Đức, Thành phố Hồ Chí Minh","path_with_type":"Phường Linh Tây, Thành phố Thủ Đức, Thành phố Hồ Chí Minh","code":"26818","parent_code":"769"},"26821":{"name":"Phường Linh Đông","type":"phuong","slug":"phuong-linh-dong","name_with_type":"Phường Linh Đông","path":"Phường Linh Đông, Thành phố Thủ Đức, Thành phố Hồ Chí Minh","path_with_type":"Phường Linh Đông, Thành phố Thủ Đức, Thành phố Hồ Chí Minh","code":"26821","parent_code":"769"},"26824":{"name":"Phường Bình Thọ","type":"phuong","slug":"phuong-binh-tho","name_with_type":"Phường Bình Thọ","path":"Phường Bình Thọ, Thành phố Thủ Đức, Thành phố Hồ Chí Minh","path_with_type":"Phường Bình Thọ, Thành phố Thủ Đức, Thành phố Hồ Chí Minh","code":"26824","parent_code":"769"},"26827":{"name":"Phường Trường Thọ","type":"phuong","slug":"phuong-truong-tho","name_with_type":"Phường Trường Thọ","path":"Phường Trường Thọ, Thành phố Thủ Đức, Thành phố Hồ Chí Minh","path_with_type":"Phường Trường Thọ, Thành phố Thủ Đức, Thành phố Hồ Chí Minh","code":"26827","parent_code":"769"},"26830":{"name":"Phường Long Bình","type":"phuong","slug":"phuong-long-binh","name_with_type":"Phường Long Bình","path":"Phường Long Bình, Thành phố Thủ Đức, Thành phố Hồ Chí Minh","path_with_type":"Phường Long Bình, Thành phố Thủ Đức, Thành phố Hồ Chí Minh","code":"26830","parent_code":"769"},"26833":{"name":"Phường Long Thạnh Mỹ","type":"phuong","slug":"phuong-long-thanh-my","name_with_type":"Phường Long Thạnh Mỹ","path":"Phường Long Thạnh Mỹ, Thành phố Thủ Đức, Thành phố Hồ Chí Minh","path_with_type":"Phường Long Thạnh Mỹ, Thành phố Thủ Đức, Thành phố Hồ Chí Minh","code":"26833","parent_code":"769"},"26836":{"name":"Phường Tân Phú","type":"phuong","slug":"phuong-tan-phu","name_with_type":"Phường Tân Phú","path":"Phường Tân Phú, Thành phố Thủ Đức, Thành phố Hồ Chí Minh","path_with_type":"Phường Tân Phú, Thành phố Thủ Đức, Thành phố Hồ Chí Minh","code":"26836","parent_code":"769"},"26839":{"name":"Phường Hiệp Phú","type":"phuong","slug":"phuong-hiep-phu","name_with_type":"Phường Hiệp Phú","path":"Phường Hiệp Phú, Thành phố Thủ Đức, Thành phố Hồ Chí Minh","path_with_type":"Phường Hiệp Phú, Thành phố Thủ Đức, Thành phố Hồ Chí Minh","code":"26839","parent_code":"769"},"26842":{"name":"Phường Tăng Nhơn Phú A","type":"phuong","slug":"phuong-tang-nhon-phu-a","name_with_type":"Phường Tăng Nhơn Phú A","path":"Phường Tăng Nhơn Phú A, Thành phố Thủ Đức, Thành phố Hồ Chí Minh","path_with_type":"Phường Tăng Nhơn Phú A, Thành phố Thủ Đức, Thành phố Hồ Chí Minh","code":"26842","parent_code":"769"},"26845":{"name":"Phường Tăng Nhơn Phú B","type":"phuong","slug":"phuong-tang-nhon-phu-b","name_with_type":"Phường Tăng Nhơn Phú B","path":"Phường Tăng Nhơn Phú B, Thành phố Thủ Đức, Thành phố Hồ Chí Minh","path_with_type":"Phường Tăng Nhơn Phú B, Thành phố Thủ Đức, Thành phố Hồ Chí Minh","code":"26845","parent_code":"769"},"26848":{"name":"Phường Phước Long B","type":"phuong","slug":"phuong-phuoc-long-b","name_with_type":"Phường Phước Long B","path":"Phường Phước Long B, Thành phố Thủ Đức, Thành phố Hồ Chí Minh","path_with_type":"Phường Phước Long B, Thành phố Thủ Đức, Thành phố Hồ Chí Minh","code":"26848","parent_code":"769"},"26851":{"name":"Phường Phước Long A","type":"phuong","slug":"phuong-phuoc-long-a","name_with_type":"Phường Phước Long A","path":"Phường Phước Long A, Thành phố Thủ Đức, Thành phố Hồ Chí Minh","path_with_type":"Phường Phước Long A, Thành phố Thủ Đức, Thành phố Hồ Chí Minh","code":"26851","parent_code":"769"},"26854":{"name":"Phường Trường Thạnh","type":"phuong","slug":"phuong-truong-thanh","name_with_type":"Phường Trường Thạnh","path":"Phường Trường Thạnh, Thành phố Thủ Đức, Thành phố Hồ Chí Minh","path_with_type":"Phường Trường Thạnh, Thành phố Thủ Đức, Thành phố Hồ Chí Minh","code":"26854","parent_code":"769"},"26857":{"name":"Phường Long Phước","type":"phuong","slug":"phuong-long-phuoc","name_with_type":"Phường Long Phước","path":"Phường Long Phước, Thành phố Thủ Đức, Thành phố Hồ Chí Minh","path_with_type":"Phường Long Phước, Thành phố Thủ Đức, Thành phố Hồ Chí Minh","code":"26857","parent_code":"769"},"26860":{"name":"Phường Long Trường","type":"phuong","slug":"phuong-long-truong","name_with_type":"Phường Long Trường","path":"Phường Long Trường, Thành phố Thủ Đức, Thành phố Hồ Chí Minh","path_with_type":"Phường Long Trường, Thành phố Thủ Đức, Thành phố Hồ Chí Minh","code":"26860","parent_code":"769"},"26863":{"name":"Phường Phước Bình","type":"phuong","slug":"phuong-phuoc-binh","name_with_type":"Phường Phước Bình","path":"Phường Phước Bình, Thành phố Thủ Đức, Thành phố Hồ Chí Minh","path_with_type":"Phường Phước Bình, Thành phố Thủ Đức, Thành phố Hồ Chí Minh","code":"26863","parent_code":"769"},"26866":{"name":"Phường Phú Hữu","type":"phuong","slug":"phuong-phu-huu","name_with_type":"Phường Phú Hữu","path":"Phường Phú Hữu, Thành phố Thủ Đức, Thành phố Hồ Chí Minh","path_with_type":"Phường Phú Hữu, Thành phố Thủ Đức, Thành phố Hồ Chí Minh","code":"26866","parent_code":"769"},"26872":{"name":"Phường 15","type":"phuong","slug":"phuong-15","name_with_type":"Phường 15","path":"Phường 15, Quận Gò Vấp, Thành phố Hồ Chí Minh","path_with_type":"Phường 15, Quận Gò Vấp, Thành phố Hồ Chí Minh","code":"26872","parent_code":"764"},"26875":{"name":"Phường 17","type":"phuong","slug":"phuong-17","name_with_type":"Phường 17","path":"Phường 17, Quận Gò Vấp, Thành phố Hồ Chí Minh","path_with_type":"Phường 17, Quận Gò Vấp, Thành phố Hồ Chí Minh","code":"26875","parent_code":"764"},"26876":{"name":"Phường 6","type":"phuong","slug":"phuong-6","name_with_type":"Phường 6","path":"Phường 6, Quận Gò Vấp, Thành phố Hồ Chí Minh","path_with_type":"Phường 6, Quận Gò Vấp, Thành phố Hồ Chí Minh","code":"26876","parent_code":"764"},"26878":{"name":"Phường 16","type":"phuong","slug":"phuong-16","name_with_type":"Phường 16","path":"Phường 16, Quận Gò Vấp, Thành phố Hồ Chí Minh","path_with_type":"Phường 16, Quận Gò Vấp, Thành phố Hồ Chí Minh","code":"26878","parent_code":"764"},"26881":{"name":"Phường 12","type":"phuong","slug":"phuong-12","name_with_type":"Phường 12","path":"Phường 12, Quận Gò Vấp, Thành phố Hồ Chí Minh","path_with_type":"Phường 12, Quận Gò Vấp, Thành phố Hồ Chí Minh","code":"26881","parent_code":"764"},"26882":{"name":"Phường 14","type":"phuong","slug":"phuong-14","name_with_type":"Phường 14","path":"Phường 14, Quận Gò Vấp, Thành phố Hồ Chí Minh","path_with_type":"Phường 14, Quận Gò Vấp, Thành phố Hồ Chí Minh","code":"26882","parent_code":"764"},"26884":{"name":"Phường 10","type":"phuong","slug":"phuong-10","name_with_type":"Phường 10","path":"Phường 10, Quận Gò Vấp, Thành phố Hồ Chí Minh","path_with_type":"Phường 10, Quận Gò Vấp, Thành phố Hồ Chí Minh","code":"26884","parent_code":"764"},"26887":{"name":"Phường 5","type":"phuong","slug":"phuong-5","name_with_type":"Phường 5","path":"Phường 5, Quận Gò Vấp, Thành phố Hồ Chí Minh","path_with_type":"Phường 5, Quận Gò Vấp, Thành phố Hồ Chí Minh","code":"26887","parent_code":"764"},"26890":{"name":"Phường 1","type":"phuong","slug":"phuong-1","name_with_type":"Phường 1","path":"Phường 1, Quận Gò Vấp, Thành phố Hồ Chí Minh","path_with_type":"Phường 1, Quận Gò Vấp, Thành phố Hồ Chí Minh","code":"26890","parent_code":"764"},"26898":{"name":"Phường 8","type":"phuong","slug":"phuong-8","name_with_type":"Phường 8","path":"Phường 8, Quận Gò Vấp, Thành phố Hồ Chí Minh","path_with_type":"Phường 8, Quận Gò Vấp, Thành phố Hồ Chí Minh","code":"26898","parent_code":"764"},"26899":{"name":"Phường 11","type":"phuong","slug":"phuong-11","name_with_type":"Phường 11","path":"Phường 11, Quận Gò Vấp, Thành phố Hồ Chí Minh","path_with_type":"Phường 11, Quận Gò Vấp, Thành phố Hồ Chí Minh","code":"26899","parent_code":"764"},"26902":{"name":"Phường 3","type":"phuong","slug":"phuong-3","name_with_type":"Phường 3","path":"Phường 3, Quận Gò Vấp, Thành phố Hồ Chí Minh","path_with_type":"Phường 3, Quận Gò Vấp, Thành phố Hồ Chí Minh","code":"26902","parent_code":"764"},"26905":{"name":"Phường 13","type":"phuong","slug":"phuong-13","name_with_type":"Phường 13","path":"Phường 13, Quận Bình Thạnh, Thành phố Hồ Chí Minh","path_with_type":"Phường 13, Quận Bình Thạnh, Thành phố Hồ Chí Minh","code":"26905","parent_code":"765"},"26908":{"name":"Phường 11","type":"phuong","slug":"phuong-11","name_with_type":"Phường 11","path":"Phường 11, Quận Bình Thạnh, Thành phố Hồ Chí Minh","path_with_type":"Phường 11, Quận Bình Thạnh, Thành phố Hồ Chí Minh","code":"26908","parent_code":"765"},"26911":{"name":"Phường 27","type":"phuong","slug":"phuong-27","name_with_type":"Phường 27","path":"Phường 27, Quận Bình Thạnh, Thành phố Hồ Chí Minh","path_with_type":"Phường 27, Quận Bình Thạnh, Thành phố Hồ Chí Minh","code":"26911","parent_code":"765"},"26914":{"name":"Phường 26","type":"phuong","slug":"phuong-26","name_with_type":"Phường 26","path":"Phường 26, Quận Bình Thạnh, Thành phố Hồ Chí Minh","path_with_type":"Phường 26, Quận Bình Thạnh, Thành phố Hồ Chí Minh","code":"26914","parent_code":"765"},"26917":{"name":"Phường 12","type":"phuong","slug":"phuong-12","name_with_type":"Phường 12","path":"Phường 12, Quận Bình Thạnh, Thành phố Hồ Chí Minh","path_with_type":"Phường 12, Quận Bình Thạnh, Thành phố Hồ Chí Minh","code":"26917","parent_code":"765"},"26920":{"name":"Phường 25","type":"phuong","slug":"phuong-25","name_with_type":"Phường 25","path":"Phường 25, Quận Bình Thạnh, Thành phố Hồ Chí Minh","path_with_type":"Phường 25, Quận Bình Thạnh, Thành phố Hồ Chí Minh","code":"26920","parent_code":"765"},"26923":{"name":"Phường 5","type":"phuong","slug":"phuong-5","name_with_type":"Phường 5","path":"Phường 5, Quận Bình Thạnh, Thành phố Hồ Chí Minh","path_with_type":"Phường 5, Quận Bình Thạnh, Thành phố Hồ Chí Minh","code":"26923","parent_code":"765"},"26926":{"name":"Phường 7","type":"phuong","slug":"phuong-7","name_with_type":"Phường 7","path":"Phường 7, Quận Bình Thạnh, Thành phố Hồ Chí Minh","path_with_type":"Phường 7, Quận Bình Thạnh, Thành phố Hồ Chí Minh","code":"26926","parent_code":"765"},"26935":{"name":"Phường 14","type":"phuong","slug":"phuong-14","name_with_type":"Phường 14","path":"Phường 14, Quận Bình Thạnh, Thành phố Hồ Chí Minh","path_with_type":"Phường 14, Quận Bình Thạnh, Thành phố Hồ Chí Minh","code":"26935","parent_code":"765"},"26941":{"name":"Phường 2","type":"phuong","slug":"phuong-2","name_with_type":"Phường 2","path":"Phường 2, Quận Bình Thạnh, Thành phố Hồ Chí Minh","path_with_type":"Phường 2, Quận Bình Thạnh, Thành phố Hồ Chí Minh","code":"26941","parent_code":"765"},"26944":{"name":"Phường 1","type":"phuong","slug":"phuong-1","name_with_type":"Phường 1","path":"Phường 1, Quận Bình Thạnh, Thành phố Hồ Chí Minh","path_with_type":"Phường 1, Quận Bình Thạnh, Thành phố Hồ Chí Minh","code":"26944","parent_code":"765"},"26950":{"name":"Phường 17","type":"phuong","slug":"phuong-17","name_with_type":"Phường 17","path":"Phường 17, Quận Bình Thạnh, Thành phố Hồ Chí Minh","path_with_type":"Phường 17, Quận Bình Thạnh, Thành phố Hồ Chí Minh","code":"26950","parent_code":"765"},"26956":{"name":"Phường 22","type":"phuong","slug":"phuong-22","name_with_type":"Phường 22","path":"Phường 22, Quận Bình Thạnh, Thành phố Hồ Chí Minh","path_with_type":"Phường 22, Quận Bình Thạnh, Thành phố Hồ Chí Minh","code":"26956","parent_code":"765"},"26959":{"name":"Phường 19","type":"phuong","slug":"phuong-19","name_with_type":"Phường 19","path":"Phường 19, Quận Bình Thạnh, Thành phố Hồ Chí Minh","path_with_type":"Phường 19, Quận Bình Thạnh, Thành phố Hồ Chí Minh","code":"26959","parent_code":"765"},"26962":{"name":"Phường 28","type":"phuong","slug":"phuong-28","name_with_type":"Phường 28","path":"Phường 28, Quận Bình Thạnh, Thành phố Hồ Chí Minh","path_with_type":"Phường 28, Quận Bình Thạnh, Thành phố Hồ Chí Minh","code":"26962","parent_code":"765"},"26965":{"name":"Phường 2","type":"phuong","slug":"phuong-2","name_with_type":"Phường 2","path":"Phường 2, Quận Tân Bình, Thành phố Hồ Chí Minh","path_with_type":"Phường 2, Quận Tân Bình, Thành phố Hồ Chí Minh","code":"26965","parent_code":"766"},"26968":{"name":"Phường 4","type":"phuong","slug":"phuong-4","name_with_type":"Phường 4","path":"Phường 4, Quận Tân Bình, Thành phố Hồ Chí Minh","path_with_type":"Phường 4, Quận Tân Bình, Thành phố Hồ Chí Minh","code":"26968","parent_code":"766"},"26971":{"name":"Phường 12","type":"phuong","slug":"phuong-12","name_with_type":"Phường 12","path":"Phường 12, Quận Tân Bình, Thành phố Hồ Chí Minh","path_with_type":"Phường 12, Quận Tân Bình, Thành phố Hồ Chí Minh","code":"26971","parent_code":"766"},"26974":{"name":"Phường 13","type":"phuong","slug":"phuong-13","name_with_type":"Phường 13","path":"Phường 13, Quận Tân Bình, Thành phố Hồ Chí Minh","path_with_type":"Phường 13, Quận Tân Bình, Thành phố Hồ Chí Minh","code":"26974","parent_code":"766"},"26977":{"name":"Phường 1","type":"phuong","slug":"phuong-1","name_with_type":"Phường 1","path":"Phường 1, Quận Tân Bình, Thành phố Hồ Chí Minh","path_with_type":"Phường 1, Quận Tân Bình, Thành phố Hồ Chí Minh","code":"26977","parent_code":"766"},"26980":{"name":"Phường 3","type":"phuong","slug":"phuong-3","name_with_type":"Phường 3","path":"Phường 3, Quận Tân Bình, Thành phố Hồ Chí Minh","path_with_type":"Phường 3, Quận Tân Bình, Thành phố Hồ Chí Minh","code":"26980","parent_code":"766"},"26983":{"name":"Phường 11","type":"phuong","slug":"phuong-11","name_with_type":"Phường 11","path":"Phường 11, Quận Tân Bình, Thành phố Hồ Chí Minh","path_with_type":"Phường 11, Quận Tân Bình, Thành phố Hồ Chí Minh","code":"26983","parent_code":"766"},"26986":{"name":"Phường 7","type":"phuong","slug":"phuong-7","name_with_type":"Phường 7","path":"Phường 7, Quận Tân Bình, Thành phố Hồ Chí Minh","path_with_type":"Phường 7, Quận Tân Bình, Thành phố Hồ Chí Minh","code":"26986","parent_code":"766"},"26989":{"name":"Phường 5","type":"phuong","slug":"phuong-5","name_with_type":"Phường 5","path":"Phường 5, Quận Tân Bình, Thành phố Hồ Chí Minh","path_with_type":"Phường 5, Quận Tân Bình, Thành phố Hồ Chí Minh","code":"26989","parent_code":"766"},"26992":{"name":"Phường 10","type":"phuong","slug":"phuong-10","name_with_type":"Phường 10","path":"Phường 10, Quận Tân Bình, Thành phố Hồ Chí Minh","path_with_type":"Phường 10, Quận Tân Bình, Thành phố Hồ Chí Minh","code":"26992","parent_code":"766"},"26995":{"name":"Phường 6","type":"phuong","slug":"phuong-6","name_with_type":"Phường 6","path":"Phường 6, Quận Tân Bình, Thành phố Hồ Chí Minh","path_with_type":"Phường 6, Quận Tân Bình, Thành phố Hồ Chí Minh","code":"26995","parent_code":"766"},"26998":{"name":"Phường 8","type":"phuong","slug":"phuong-8","name_with_type":"Phường 8","path":"Phường 8, Quận Tân Bình, Thành phố Hồ Chí Minh","path_with_type":"Phường 8, Quận Tân Bình, Thành phố Hồ Chí Minh","code":"26998","parent_code":"766"},"27001":{"name":"Phường 9","type":"phuong","slug":"phuong-9","name_with_type":"Phường 9","path":"Phường 9, Quận Tân Bình, Thành phố Hồ Chí Minh","path_with_type":"Phường 9, Quận Tân Bình, Thành phố Hồ Chí Minh","code":"27001","parent_code":"766"},"27004":{"name":"Phường 14","type":"phuong","slug":"phuong-14","name_with_type":"Phường 14","path":"Phường 14, Quận Tân Bình, Thành phố Hồ Chí Minh","path_with_type":"Phường 14, Quận Tân Bình, Thành phố Hồ Chí Minh","code":"27004","parent_code":"766"},"27007":{"name":"Phường 15","type":"phuong","slug":"phuong-15","name_with_type":"Phường 15","path":"Phường 15, Quận Tân Bình, Thành phố Hồ Chí Minh","path_with_type":"Phường 15, Quận Tân Bình, Thành phố Hồ Chí Minh","code":"27007","parent_code":"766"},"27010":{"name":"Phường Tân Sơn Nhì","type":"phuong","slug":"phuong-tan-son-nhi","name_with_type":"Phường Tân Sơn Nhì","path":"Phường Tân Sơn Nhì, Quận Tân Phú, Thành phố Hồ Chí Minh","path_with_type":"Phường Tân Sơn Nhì, Quận Tân Phú, Thành phố Hồ Chí Minh","code":"27010","parent_code":"767"},"27013":{"name":"Phường Tây Thạnh","type":"phuong","slug":"phuong-tay-thanh","name_with_type":"Phường Tây Thạnh","path":"Phường Tây Thạnh, Quận Tân Phú, Thành phố Hồ Chí Minh","path_with_type":"Phường Tây Thạnh, Quận Tân Phú, Thành phố Hồ Chí Minh","code":"27013","parent_code":"767"},"27016":{"name":"Phường Sơn Kỳ","type":"phuong","slug":"phuong-son-ky","name_with_type":"Phường Sơn Kỳ","path":"Phường Sơn Kỳ, Quận Tân Phú, Thành phố Hồ Chí Minh","path_with_type":"Phường Sơn Kỳ, Quận Tân Phú, Thành phố Hồ Chí Minh","code":"27016","parent_code":"767"},"27019":{"name":"Phường Tân Quý","type":"phuong","slug":"phuong-tan-quy","name_with_type":"Phường Tân Quý","path":"Phường Tân Quý, Quận Tân Phú, Thành phố Hồ Chí Minh","path_with_type":"Phường Tân Quý, Quận Tân Phú, Thành phố Hồ Chí Minh","code":"27019","parent_code":"767"},"27022":{"name":"Phường Tân Thành","type":"phuong","slug":"phuong-tan-thanh","name_with_type":"Phường Tân Thành","path":"Phường Tân Thành, Quận Tân Phú, Thành phố Hồ Chí Minh","path_with_type":"Phường Tân Thành, Quận Tân Phú, Thành phố Hồ Chí Minh","code":"27022","parent_code":"767"},"27025":{"name":"Phường Phú Thọ Hòa","type":"phuong","slug":"phuong-phu-tho-hoa","name_with_type":"Phường Phú Thọ Hòa","path":"Phường Phú Thọ Hòa, Quận Tân Phú, Thành phố Hồ Chí Minh","path_with_type":"Phường Phú Thọ Hòa, Quận Tân Phú, Thành phố Hồ Chí Minh","code":"27025","parent_code":"767"},"27028":{"name":"Phường Phú Thạnh","type":"phuong","slug":"phuong-phu-thanh","name_with_type":"Phường Phú Thạnh","path":"Phường Phú Thạnh, Quận Tân Phú, Thành phố Hồ Chí Minh","path_with_type":"Phường Phú Thạnh, Quận Tân Phú, Thành phố Hồ Chí Minh","code":"27028","parent_code":"767"},"27031":{"name":"Phường Phú Trung","type":"phuong","slug":"phuong-phu-trung","name_with_type":"Phường Phú Trung","path":"Phường Phú Trung, Quận Tân Phú, Thành phố Hồ Chí Minh","path_with_type":"Phường Phú Trung, Quận Tân Phú, Thành phố Hồ Chí Minh","code":"27031","parent_code":"767"},"27034":{"name":"Phường Hòa Thạnh","type":"phuong","slug":"phuong-hoa-thanh","name_with_type":"Phường Hòa Thạnh","path":"Phường Hòa Thạnh, Quận Tân Phú, Thành phố Hồ Chí Minh","path_with_type":"Phường Hòa Thạnh, Quận Tân Phú, Thành phố Hồ Chí Minh","code":"27034","parent_code":"767"},"27037":{"name":"Phường Hiệp Tân","type":"phuong","slug":"phuong-hiep-tan","name_with_type":"Phường Hiệp Tân","path":"Phường Hiệp Tân, Quận Tân Phú, Thành phố Hồ Chí Minh","path_with_type":"Phường Hiệp Tân, Quận Tân Phú, Thành phố Hồ Chí Minh","code":"27037","parent_code":"767"},"27040":{"name":"Phường Tân Thới Hòa","type":"phuong","slug":"phuong-tan-thoi-hoa","name_with_type":"Phường Tân Thới Hòa","path":"Phường Tân Thới Hòa, Quận Tân Phú, Thành phố Hồ Chí Minh","path_with_type":"Phường Tân Thới Hòa, Quận Tân Phú, Thành phố Hồ Chí Minh","code":"27040","parent_code":"767"},"27043":{"name":"Phường 4","type":"phuong","slug":"phuong-4","name_with_type":"Phường 4","path":"Phường 4, Quận Phú Nhuận, Thành phố Hồ Chí Minh","path_with_type":"Phường 4, Quận Phú Nhuận, Thành phố Hồ Chí Minh","code":"27043","parent_code":"768"},"27046":{"name":"Phường 5","type":"xa","slug":"phuong-5","name_with_type":"Phường 5","path":"Phường 5, Quận Phú Nhuận, Thành phố Hồ Chí Minh","path_with_type":"Phường 5, Quận Phú Nhuận, Thành phố Hồ Chí Minh","code":"27046","parent_code":"768"},"27049":{"name":"Phường 9","type":"phuong","slug":"phuong-9","name_with_type":"Phường 9","path":"Phường 9, Quận Phú Nhuận, Thành phố Hồ Chí Minh","path_with_type":"Phường 9, Quận Phú Nhuận, Thành phố Hồ Chí Minh","code":"27049","parent_code":"768"},"27052":{"name":"Phường 7","type":"phuong","slug":"phuong-7","name_with_type":"Phường 7","path":"Phường 7, Quận Phú Nhuận, Thành phố Hồ Chí Minh","path_with_type":"Phường 7, Quận Phú Nhuận, Thành phố Hồ Chí Minh","code":"27052","parent_code":"768"},"27058":{"name":"Phường 1","type":"phuong","slug":"phuong-1","name_with_type":"Phường 1","path":"Phường 1, Quận Phú Nhuận, Thành phố Hồ Chí Minh","path_with_type":"Phường 1, Quận Phú Nhuận, Thành phố Hồ Chí Minh","code":"27058","parent_code":"768"},"27061":{"name":"Phường 2","type":"phuong","slug":"phuong-2","name_with_type":"Phường 2","path":"Phường 2, Quận Phú Nhuận, Thành phố Hồ Chí Minh","path_with_type":"Phường 2, Quận Phú Nhuận, Thành phố Hồ Chí Minh","code":"27061","parent_code":"768"},"27064":{"name":"Phường 8","type":"phuong","slug":"phuong-8","name_with_type":"Phường 8","path":"Phường 8, Quận Phú Nhuận, Thành phố Hồ Chí Minh","path_with_type":"Phường 8, Quận Phú Nhuận, Thành phố Hồ Chí Minh","code":"27064","parent_code":"768"},"27067":{"name":"Phường 15","type":"phuong","slug":"phuong-15","name_with_type":"Phường 15","path":"Phường 15, Quận Phú Nhuận, Thành phố Hồ Chí Minh","path_with_type":"Phường 15, Quận Phú Nhuận, Thành phố Hồ Chí Minh","code":"27067","parent_code":"768"},"27070":{"name":"Phường 10","type":"phuong","slug":"phuong-10","name_with_type":"Phường 10","path":"Phường 10, Quận Phú Nhuận, Thành phố Hồ Chí Minh","path_with_type":"Phường 10, Quận Phú Nhuận, Thành phố Hồ Chí Minh","code":"27070","parent_code":"768"},"27073":{"name":"Phường 11","type":"phuong","slug":"phuong-11","name_with_type":"Phường 11","path":"Phường 11, Quận Phú Nhuận, Thành phố Hồ Chí Minh","path_with_type":"Phường 11, Quận Phú Nhuận, Thành phố Hồ Chí Minh","code":"27073","parent_code":"768"},"27085":{"name":"Phường 13","type":"phuong","slug":"phuong-13","name_with_type":"Phường 13","path":"Phường 13, Quận Phú Nhuận, Thành phố Hồ Chí Minh","path_with_type":"Phường 13, Quận Phú Nhuận, Thành phố Hồ Chí Minh","code":"27085","parent_code":"768"},"27088":{"name":"Phường Thảo Điền","type":"phuong","slug":"phuong-thao-dien","name_with_type":"Phường Thảo Điền","path":"Phường Thảo Điền, Thành phố Thủ Đức, Thành phố Hồ Chí Minh","path_with_type":"Phường Thảo Điền, Thành phố Thủ Đức, Thành phố Hồ Chí Minh","code":"27088","parent_code":"769"},"27091":{"name":"Phường An Phú","type":"phuong","slug":"phuong-an-phu","name_with_type":"Phường An Phú","path":"Phường An Phú, Thành phố Thủ Đức, Thành phố Hồ Chí Minh","path_with_type":"Phường An Phú, Thành phố Thủ Đức, Thành phố Hồ Chí Minh","code":"27091","parent_code":"769"},"27094":{"name":"Phường An Khánh","type":"phuong","slug":"phuong-an-khanh","name_with_type":"Phường An Khánh","path":"Phường An Khánh, Thành phố Thủ Đức, Thành phố Hồ Chí Minh","path_with_type":"Phường An Khánh, Thành phố Thủ Đức, Thành phố Hồ Chí Minh","code":"27094","parent_code":"769"},"27097":{"name":"Phường Bình Trưng Đông","type":"phuong","slug":"phuong-binh-trung-dong","name_with_type":"Phường Bình Trưng Đông","path":"Phường Bình Trưng Đông, Thành phố Thủ Đức, Thành phố Hồ Chí Minh","path_with_type":"Phường Bình Trưng Đông, Thành phố Thủ Đức, Thành phố Hồ Chí Minh","code":"27097","parent_code":"769"},"27100":{"name":"Phường Bình Trưng Tây","type":"phuong","slug":"phuong-binh-trung-tay","name_with_type":"Phường Bình Trưng Tây","path":"Phường Bình Trưng Tây, Thành phố Thủ Đức, Thành phố Hồ Chí Minh","path_with_type":"Phường Bình Trưng Tây, Thành phố Thủ Đức, Thành phố Hồ Chí Minh","code":"27100","parent_code":"769"},"27109":{"name":"Phường Cát Lái","type":"phuong","slug":"phuong-cat-lai","name_with_type":"Phường Cát Lái","path":"Phường Cát Lái, Thành phố Thủ Đức, Thành phố Hồ Chí Minh","path_with_type":"Phường Cát Lái, Thành phố Thủ Đức, Thành phố Hồ Chí Minh","code":"27109","parent_code":"769"},"27112":{"name":"Phường Thạnh Mỹ Lợi","type":"phuong","slug":"phuong-thanh-my-loi","name_with_type":"Phường Thạnh Mỹ Lợi","path":"Phường Thạnh Mỹ Lợi, Thành phố Thủ Đức, Thành phố Hồ Chí Minh","path_with_type":"Phường Thạnh Mỹ Lợi, Thành phố Thủ Đức, Thành phố Hồ Chí Minh","code":"27112","parent_code":"769"},"27115":{"name":"Phường An Lợi Đông","type":"phuong","slug":"phuong-an-loi-dong","name_with_type":"Phường An Lợi Đông","path":"Phường An Lợi Đông, Thành phố Thủ Đức, Thành phố Hồ Chí Minh","path_with_type":"Phường An Lợi Đông, Thành phố Thủ Đức, Thành phố Hồ Chí Minh","code":"27115","parent_code":"769"},"27118":{"name":"Phường Thủ Thiêm","type":"phuong","slug":"phuong-thu-thiem","name_with_type":"Phường Thủ Thiêm","path":"Phường Thủ Thiêm, Thành phố Thủ Đức, Thành phố Hồ Chí Minh","path_with_type":"Phường Thủ Thiêm, Thành phố Thủ Đức, Thành phố Hồ Chí Minh","code":"27118","parent_code":"769"},"27127":{"name":"Phường 14","type":"phuong","slug":"phuong-14","name_with_type":"Phường 14","path":"Phường 14, Quận 3, Thành phố Hồ Chí Minh","path_with_type":"Phường 14, Quận 3, Thành phố Hồ Chí Minh","code":"27127","parent_code":"770"},"27130":{"name":"Phường 12","type":"phuong","slug":"phuong-12","name_with_type":"Phường 12","path":"Phường 12, Quận 3, Thành phố Hồ Chí Minh","path_with_type":"Phường 12, Quận 3, Thành phố Hồ Chí Minh","code":"27130","parent_code":"770"},"27133":{"name":"Phường 11","type":"phuong","slug":"phuong-11","name_with_type":"Phường 11","path":"Phường 11, Quận 3, Thành phố Hồ Chí Minh","path_with_type":"Phường 11, Quận 3, Thành phố Hồ Chí Minh","code":"27133","parent_code":"770"},"27139":{"name":"Phường Võ Thị Sáu","type":"phuong","slug":"phuong-vo-thi-sau","name_with_type":"Phường Võ Thị Sáu","path":"Phường Võ Thị Sáu, Quận 3, Thành phố Hồ Chí Minh","path_with_type":"Phường Võ Thị Sáu, Quận 3, Thành phố Hồ Chí Minh","code":"27139","parent_code":"770"},"27142":{"name":"Phường 9","type":"phuong","slug":"phuong-9","name_with_type":"Phường 9","path":"Phường 9, Quận 3, Thành phố Hồ Chí Minh","path_with_type":"Phường 9, Quận 3, Thành phố Hồ Chí Minh","code":"27142","parent_code":"770"},"27148":{"name":"Phường 4","type":"phuong","slug":"phuong-4","name_with_type":"Phường 4","path":"Phường 4, Quận 3, Thành phố Hồ Chí Minh","path_with_type":"Phường 4, Quận 3, Thành phố Hồ Chí Minh","code":"27148","parent_code":"770"},"27151":{"name":"Phường 5","type":"phuong","slug":"phuong-5","name_with_type":"Phường 5","path":"Phường 5, Quận 3, Thành phố Hồ Chí Minh","path_with_type":"Phường 5, Quận 3, Thành phố Hồ Chí Minh","code":"27151","parent_code":"770"},"27154":{"name":"Phường 3","type":"phuong","slug":"phuong-3","name_with_type":"Phường 3","path":"Phường 3, Quận 3, Thành phố Hồ Chí Minh","path_with_type":"Phường 3, Quận 3, Thành phố Hồ Chí Minh","code":"27154","parent_code":"770"},"27157":{"name":"Phường 2","type":"phuong","slug":"phuong-2","name_with_type":"Phường 2","path":"Phường 2, Quận 3, Thành phố Hồ Chí Minh","path_with_type":"Phường 2, Quận 3, Thành phố Hồ Chí Minh","code":"27157","parent_code":"770"},"27160":{"name":"Phường 1","type":"phuong","slug":"phuong-1","name_with_type":"Phường 1","path":"Phường 1, Quận 3, Thành phố Hồ Chí Minh","path_with_type":"Phường 1, Quận 3, Thành phố Hồ Chí Minh","code":"27160","parent_code":"770"},"27163":{"name":"Phường 15","type":"phuong","slug":"phuong-15","name_with_type":"Phường 15","path":"Phường 15, Quận 10, Thành phố Hồ Chí Minh","path_with_type":"Phường 15, Quận 10, Thành phố Hồ Chí Minh","code":"27163","parent_code":"771"},"27166":{"name":"Phường 13","type":"phuong","slug":"phuong-13","name_with_type":"Phường 13","path":"Phường 13, Quận 10, Thành phố Hồ Chí Minh","path_with_type":"Phường 13, Quận 10, Thành phố Hồ Chí Minh","code":"27166","parent_code":"771"},"27169":{"name":"Phường 14","type":"phuong","slug":"phuong-14","name_with_type":"Phường 14","path":"Phường 14, Quận 10, Thành phố Hồ Chí Minh","path_with_type":"Phường 14, Quận 10, Thành phố Hồ Chí Minh","code":"27169","parent_code":"771"},"27172":{"name":"Phường 12","type":"phuong","slug":"phuong-12","name_with_type":"Phường 12","path":"Phường 12, Quận 10, Thành phố Hồ Chí Minh","path_with_type":"Phường 12, Quận 10, Thành phố Hồ Chí Minh","code":"27172","parent_code":"771"},"27178":{"name":"Phường 10","type":"phuong","slug":"phuong-10","name_with_type":"Phường 10","path":"Phường 10, Quận 10, Thành phố Hồ Chí Minh","path_with_type":"Phường 10, Quận 10, Thành phố Hồ Chí Minh","code":"27178","parent_code":"771"},"27181":{"name":"Phường 9","type":"phuong","slug":"phuong-9","name_with_type":"Phường 9","path":"Phường 9, Quận 10, Thành phố Hồ Chí Minh","path_with_type":"Phường 9, Quận 10, Thành phố Hồ Chí Minh","code":"27181","parent_code":"771"},"27184":{"name":"Phường 1","type":"phuong","slug":"phuong-1","name_with_type":"Phường 1","path":"Phường 1, Quận 10, Thành phố Hồ Chí Minh","path_with_type":"Phường 1, Quận 10, Thành phố Hồ Chí Minh","code":"27184","parent_code":"771"},"27187":{"name":"Phường 8","type":"phuong","slug":"phuong-8","name_with_type":"Phường 8","path":"Phường 8, Quận 10, Thành phố Hồ Chí Minh","path_with_type":"Phường 8, Quận 10, Thành phố Hồ Chí Minh","code":"27187","parent_code":"771"},"27190":{"name":"Phường 2","type":"phuong","slug":"phuong-2","name_with_type":"Phường 2","path":"Phường 2, Quận 10, Thành phố Hồ Chí Minh","path_with_type":"Phường 2, Quận 10, Thành phố Hồ Chí Minh","code":"27190","parent_code":"771"},"27193":{"name":"Phường 4","type":"phuong","slug":"phuong-4","name_with_type":"Phường 4","path":"Phường 4, Quận 10, Thành phố Hồ Chí Minh","path_with_type":"Phường 4, Quận 10, Thành phố Hồ Chí Minh","code":"27193","parent_code":"771"},"27202":{"name":"Phường 6","type":"phuong","slug":"phuong-6","name_with_type":"Phường 6","path":"Phường 6, Quận 10, Thành phố Hồ Chí Minh","path_with_type":"Phường 6, Quận 10, Thành phố Hồ Chí Minh","code":"27202","parent_code":"771"},"27208":{"name":"Phường 15","type":"phuong","slug":"phuong-15","name_with_type":"Phường 15","path":"Phường 15, Quận 11, Thành phố Hồ Chí Minh","path_with_type":"Phường 15, Quận 11, Thành phố Hồ Chí Minh","code":"27208","parent_code":"772"},"27211":{"name":"Phường 5","type":"phuong","slug":"phuong-5","name_with_type":"Phường 5","path":"Phường 5, Quận 11, Thành phố Hồ Chí Minh","path_with_type":"Phường 5, Quận 11, Thành phố Hồ Chí Minh","code":"27211","parent_code":"772"},"27214":{"name":"Phường 14","type":"phuong","slug":"phuong-14","name_with_type":"Phường 14","path":"Phường 14, Quận 11, Thành phố Hồ Chí Minh","path_with_type":"Phường 14, Quận 11, Thành phố Hồ Chí Minh","code":"27214","parent_code":"772"},"27217":{"name":"Phường 11","type":"phuong","slug":"phuong-11","name_with_type":"Phường 11","path":"Phường 11, Quận 11, Thành phố Hồ Chí Minh","path_with_type":"Phường 11, Quận 11, Thành phố Hồ Chí Minh","code":"27217","parent_code":"772"},"27220":{"name":"Phường 3","type":"phuong","slug":"phuong-3","name_with_type":"Phường 3","path":"Phường 3, Quận 11, Thành phố Hồ Chí Minh","path_with_type":"Phường 3, Quận 11, Thành phố Hồ Chí Minh","code":"27220","parent_code":"772"},"27223":{"name":"Phường 10","type":"phuong","slug":"phuong-10","name_with_type":"Phường 10","path":"Phường 10, Quận 11, Thành phố Hồ Chí Minh","path_with_type":"Phường 10, Quận 11, Thành phố Hồ Chí Minh","code":"27223","parent_code":"772"},"27229":{"name":"Phường 8","type":"phuong","slug":"phuong-8","name_with_type":"Phường 8","path":"Phường 8, Quận 11, Thành phố Hồ Chí Minh","path_with_type":"Phường 8, Quận 11, Thành phố Hồ Chí Minh","code":"27229","parent_code":"772"},"27238":{"name":"Phường 7","type":"phuong","slug":"phuong-7","name_with_type":"Phường 7","path":"Phường 7, Quận 11, Thành phố Hồ Chí Minh","path_with_type":"Phường 7, Quận 11, Thành phố Hồ Chí Minh","code":"27238","parent_code":"772"},"27247":{"name":"Phường 1","type":"phuong","slug":"phuong-1","name_with_type":"Phường 1","path":"Phường 1, Quận 11, Thành phố Hồ Chí Minh","path_with_type":"Phường 1, Quận 11, Thành phố Hồ Chí Minh","code":"27247","parent_code":"772"},"27253":{"name":"Phường 16","type":"phuong","slug":"phuong-16","name_with_type":"Phường 16","path":"Phường 16, Quận 11, Thành phố Hồ Chí Minh","path_with_type":"Phường 16, Quận 11, Thành phố Hồ Chí Minh","code":"27253","parent_code":"772"},"27259":{"name":"Phường 13","type":"phuong","slug":"phuong-13","name_with_type":"Phường 13","path":"Phường 13, Quận 4, Thành phố Hồ Chí Minh","path_with_type":"Phường 13, Quận 4, Thành phố Hồ Chí Minh","code":"27259","parent_code":"773"},"27265":{"name":"Phường 9","type":"phuong","slug":"phuong-9","name_with_type":"Phường 9","path":"Phường 9, Quận 4, Thành phố Hồ Chí Minh","path_with_type":"Phường 9, Quận 4, Thành phố Hồ Chí Minh","code":"27265","parent_code":"773"},"27271":{"name":"Phường 8","type":"phuong","slug":"phuong-8","name_with_type":"Phường 8","path":"Phường 8, Quận 4, Thành phố Hồ Chí Minh","path_with_type":"Phường 8, Quận 4, Thành phố Hồ Chí Minh","code":"27271","parent_code":"773"},"27277":{"name":"Phường 18","type":"phuong","slug":"phuong-18","name_with_type":"Phường 18","path":"Phường 18, Quận 4, Thành phố Hồ Chí Minh","path_with_type":"Phường 18, Quận 4, Thành phố Hồ Chí Minh","code":"27277","parent_code":"773"},"27283":{"name":"Phường 4","type":"phuong","slug":"phuong-4","name_with_type":"Phường 4","path":"Phường 4, Quận 4, Thành phố Hồ Chí Minh","path_with_type":"Phường 4, Quận 4, Thành phố Hồ Chí Minh","code":"27283","parent_code":"773"},"27286":{"name":"Phường 3","type":"phuong","slug":"phuong-3","name_with_type":"Phường 3","path":"Phường 3, Quận 4, Thành phố Hồ Chí Minh","path_with_type":"Phường 3, Quận 4, Thành phố Hồ Chí Minh","code":"27286","parent_code":"773"},"27289":{"name":"Phường 16","type":"phuong","slug":"phuong-16","name_with_type":"Phường 16","path":"Phường 16, Quận 4, Thành phố Hồ Chí Minh","path_with_type":"Phường 16, Quận 4, Thành phố Hồ Chí Minh","code":"27289","parent_code":"773"},"27292":{"name":"Phường 2","type":"phuong","slug":"phuong-2","name_with_type":"Phường 2","path":"Phường 2, Quận 4, Thành phố Hồ Chí Minh","path_with_type":"Phường 2, Quận 4, Thành phố Hồ Chí Minh","code":"27292","parent_code":"773"},"27295":{"name":"Phường 15","type":"phuong","slug":"phuong-15","name_with_type":"Phường 15","path":"Phường 15, Quận 4, Thành phố Hồ Chí Minh","path_with_type":"Phường 15, Quận 4, Thành phố Hồ Chí Minh","code":"27295","parent_code":"773"},"27298":{"name":"Phường 1","type":"phuong","slug":"phuong-1","name_with_type":"Phường 1","path":"Phường 1, Quận 4, Thành phố Hồ Chí Minh","path_with_type":"Phường 1, Quận 4, Thành phố Hồ Chí Minh","code":"27298","parent_code":"773"},"27301":{"name":"Phường 4","type":"phuong","slug":"phuong-4","name_with_type":"Phường 4","path":"Phường 4, Quận 5, Thành phố Hồ Chí Minh","path_with_type":"Phường 4, Quận 5, Thành phố Hồ Chí Minh","code":"27301","parent_code":"774"},"27304":{"name":"Phường 9","type":"phuong","slug":"phuong-9","name_with_type":"Phường 9","path":"Phường 9, Quận 5, Thành phố Hồ Chí Minh","path_with_type":"Phường 9, Quận 5, Thành phố Hồ Chí Minh","code":"27304","parent_code":"774"},"27307":{"name":"Phường 2","type":"phuong","slug":"phuong-2","name_with_type":"Phường 2","path":"Phường 2, Quận 5, Thành phố Hồ Chí Minh","path_with_type":"Phường 2, Quận 5, Thành phố Hồ Chí Minh","code":"27307","parent_code":"774"},"27310":{"name":"Phường 12","type":"phuong","slug":"phuong-12","name_with_type":"Phường 12","path":"Phường 12, Quận 5, Thành phố Hồ Chí Minh","path_with_type":"Phường 12, Quận 5, Thành phố Hồ Chí Minh","code":"27310","parent_code":"774"},"27316":{"name":"Phường 7","type":"phuong","slug":"phuong-7","name_with_type":"Phường 7","path":"Phường 7, Quận 5, Thành phố Hồ Chí Minh","path_with_type":"Phường 7, Quận 5, Thành phố Hồ Chí Minh","code":"27316","parent_code":"774"},"27325":{"name":"Phường 1","type":"phuong","slug":"phuong-1","name_with_type":"Phường 1","path":"Phường 1, Quận 5, Thành phố Hồ Chí Minh","path_with_type":"Phường 1, Quận 5, Thành phố Hồ Chí Minh","code":"27325","parent_code":"774"},"27328":{"name":"Phường 11","type":"phuong","slug":"phuong-11","name_with_type":"Phường 11","path":"Phường 11, Quận 5, Thành phố Hồ Chí Minh","path_with_type":"Phường 11, Quận 5, Thành phố Hồ Chí Minh","code":"27328","parent_code":"774"},"27331":{"name":"Phường 14","type":"phuong","slug":"phuong-14","name_with_type":"Phường 14","path":"Phường 14, Quận 5, Thành phố Hồ Chí Minh","path_with_type":"Phường 14, Quận 5, Thành phố Hồ Chí Minh","code":"27331","parent_code":"774"},"27334":{"name":"Phường 5","type":"phuong","slug":"phuong-5","name_with_type":"Phường 5","path":"Phường 5, Quận 5, Thành phố Hồ Chí Minh","path_with_type":"Phường 5, Quận 5, Thành phố Hồ Chí Minh","code":"27334","parent_code":"774"},"27343":{"name":"Phường 13","type":"phuong","slug":"phuong-13","name_with_type":"Phường 13","path":"Phường 13, Quận 5, Thành phố Hồ Chí Minh","path_with_type":"Phường 13, Quận 5, Thành phố Hồ Chí Minh","code":"27343","parent_code":"774"},"27346":{"name":"Phường 14","type":"phuong","slug":"phuong-14","name_with_type":"Phường 14","path":"Phường 14, Quận 6, Thành phố Hồ Chí Minh","path_with_type":"Phường 14, Quận 6, Thành phố Hồ Chí Minh","code":"27346","parent_code":"775"},"27349":{"name":"Phường 13","type":"phuong","slug":"phuong-13","name_with_type":"Phường 13","path":"Phường 13, Quận 6, Thành phố Hồ Chí Minh","path_with_type":"Phường 13, Quận 6, Thành phố Hồ Chí Minh","code":"27349","parent_code":"775"},"27352":{"name":"Phường 9","type":"phuong","slug":"phuong-9","name_with_type":"Phường 9","path":"Phường 9, Quận 6, Thành phố Hồ Chí Minh","path_with_type":"Phường 9, Quận 6, Thành phố Hồ Chí Minh","code":"27352","parent_code":"775"},"27358":{"name":"Phường 12","type":"phuong","slug":"phuong-12","name_with_type":"Phường 12","path":"Phường 12, Quận 6, Thành phố Hồ Chí Minh","path_with_type":"Phường 12, Quận 6, Thành phố Hồ Chí Minh","code":"27358","parent_code":"775"},"27361":{"name":"Phường 2","type":"phuong","slug":"phuong-2","name_with_type":"Phường 2","path":"Phường 2, Quận 6, Thành phố Hồ Chí Minh","path_with_type":"Phường 2, Quận 6, Thành phố Hồ Chí Minh","code":"27361","parent_code":"775"},"27364":{"name":"Phường 11","type":"phuong","slug":"phuong-11","name_with_type":"Phường 11","path":"Phường 11, Quận 6, Thành phố Hồ Chí Minh","path_with_type":"Phường 11, Quận 6, Thành phố Hồ Chí Minh","code":"27364","parent_code":"775"},"27376":{"name":"Phường 8","type":"phuong","slug":"phuong-8","name_with_type":"Phường 8","path":"Phường 8, Quận 6, Thành phố Hồ Chí Minh","path_with_type":"Phường 8, Quận 6, Thành phố Hồ Chí Minh","code":"27376","parent_code":"775"},"27379":{"name":"Phường 1","type":"phuong","slug":"phuong-1","name_with_type":"Phường 1","path":"Phường 1, Quận 6, Thành phố Hồ Chí Minh","path_with_type":"Phường 1, Quận 6, Thành phố Hồ Chí Minh","code":"27379","parent_code":"775"},"27382":{"name":"Phường 7","type":"phuong","slug":"phuong-7","name_with_type":"Phường 7","path":"Phường 7, Quận 6, Thành phố Hồ Chí Minh","path_with_type":"Phường 7, Quận 6, Thành phố Hồ Chí Minh","code":"27382","parent_code":"775"},"27385":{"name":"Phường 10","type":"phuong","slug":"phuong-10","name_with_type":"Phường 10","path":"Phường 10, Quận 6, Thành phố Hồ Chí Minh","path_with_type":"Phường 10, Quận 6, Thành phố Hồ Chí Minh","code":"27385","parent_code":"775"},"27397":{"name":"Phường Rạch Ông","type":"phuong","slug":"phuong-rach-ong","name_with_type":"Phường Rạch Ông","path":"Phường Rạch Ông, Quận 8, Thành phố Hồ Chí Minh","path_with_type":"Phường Rạch Ông, Quận 8, Thành phố Hồ Chí Minh","code":"27397","parent_code":"776"},"27403":{"name":"Phường Hưng Phú","type":"phuong","slug":"phuong-hung-phu","name_with_type":"Phường Hưng Phú","path":"Phường Hưng Phú, Quận 8, Thành phố Hồ Chí Minh","path_with_type":"Phường Hưng Phú, Quận 8, Thành phố Hồ Chí Minh","code":"27403","parent_code":"776"},"27409":{"name":"Phường 4","type":"phuong","slug":"phuong-4","name_with_type":"Phường 4","path":"Phường 4, Quận 8, Thành phố Hồ Chí Minh","path_with_type":"Phường 4, Quận 8, Thành phố Hồ Chí Minh","code":"27409","parent_code":"776"},"27415":{"name":"Phường Xóm Củi","type":"phuong","slug":"phuong-xom-cui","name_with_type":"Phường Xóm Củi","path":"Phường Xóm Củi, Quận 8, Thành phố Hồ Chí Minh","path_with_type":"Phường Xóm Củi, Quận 8, Thành phố Hồ Chí Minh","code":"27415","parent_code":"776"},"27418":{"name":"Phường 5","type":"phuong","slug":"phuong-5","name_with_type":"Phường 5","path":"Phường 5, Quận 8, Thành phố Hồ Chí Minh","path_with_type":"Phường 5, Quận 8, Thành phố Hồ Chí Minh","code":"27418","parent_code":"776"},"27421":{"name":"Phường 14","type":"phuong","slug":"phuong-14","name_with_type":"Phường 14","path":"Phường 14, Quận 8, Thành phố Hồ Chí Minh","path_with_type":"Phường 14, Quận 8, Thành phố Hồ Chí Minh","code":"27421","parent_code":"776"},"27424":{"name":"Phường 6","type":"phuong","slug":"phuong-6","name_with_type":"Phường 6","path":"Phường 6, Quận 8, Thành phố Hồ Chí Minh","path_with_type":"Phường 6, Quận 8, Thành phố Hồ Chí Minh","code":"27424","parent_code":"776"},"27427":{"name":"Phường 15","type":"phuong","slug":"phuong-15","name_with_type":"Phường 15","path":"Phường 15, Quận 8, Thành phố Hồ Chí Minh","path_with_type":"Phường 15, Quận 8, Thành phố Hồ Chí Minh","code":"27427","parent_code":"776"},"27430":{"name":"Phường 16","type":"phuong","slug":"phuong-16","name_with_type":"Phường 16","path":"Phường 16, Quận 8, Thành phố Hồ Chí Minh","path_with_type":"Phường 16, Quận 8, Thành phố Hồ Chí Minh","code":"27430","parent_code":"776"},"27433":{"name":"Phường 7","type":"phuong","slug":"phuong-7","name_with_type":"Phường 7","path":"Phường 7, Quận 8, Thành phố Hồ Chí Minh","path_with_type":"Phường 7, Quận 8, Thành phố Hồ Chí Minh","code":"27433","parent_code":"776"},"27436":{"name":"Phường Bình Hưng Hòa","type":"phuong","slug":"phuong-binh-hung-hoa","name_with_type":"Phường Bình Hưng Hòa","path":"Phường Bình Hưng Hòa, Quận Bình Tân, Thành phố Hồ Chí Minh","path_with_type":"Phường Bình Hưng Hòa, Quận Bình Tân, Thành phố Hồ Chí Minh","code":"27436","parent_code":"777"},"27439":{"name":"Phường Bình Hưng Hoà A","type":"phuong","slug":"phuong-binh-hung-hoa-a","name_with_type":"Phường Bình Hưng Hoà A","path":"Phường Bình Hưng Hoà A, Quận Bình Tân, Thành phố Hồ Chí Minh","path_with_type":"Phường Bình Hưng Hoà A, Quận Bình Tân, Thành phố Hồ Chí Minh","code":"27439","parent_code":"777"},"27442":{"name":"Phường Bình Hưng Hoà B","type":"phuong","slug":"phuong-binh-hung-hoa-b","name_with_type":"Phường Bình Hưng Hoà B","path":"Phường Bình Hưng Hoà B, Quận Bình Tân, Thành phố Hồ Chí Minh","path_with_type":"Phường Bình Hưng Hoà B, Quận Bình Tân, Thành phố Hồ Chí Minh","code":"27442","parent_code":"777"},"27445":{"name":"Phường Bình Trị Đông","type":"phuong","slug":"phuong-binh-tri-dong","name_with_type":"Phường Bình Trị Đông","path":"Phường Bình Trị Đông, Quận Bình Tân, Thành phố Hồ Chí Minh","path_with_type":"Phường Bình Trị Đông, Quận Bình Tân, Thành phố Hồ Chí Minh","code":"27445","parent_code":"777"},"27448":{"name":"Phường Bình Trị Đông A","type":"phuong","slug":"phuong-binh-tri-dong-a","name_with_type":"Phường Bình Trị Đông A","path":"Phường Bình Trị Đông A, Quận Bình Tân, Thành phố Hồ Chí Minh","path_with_type":"Phường Bình Trị Đông A, Quận Bình Tân, Thành phố Hồ Chí Minh","code":"27448","parent_code":"777"},"27451":{"name":"Phường Bình Trị Đông B","type":"phuong","slug":"phuong-binh-tri-dong-b","name_with_type":"Phường Bình Trị Đông B","path":"Phường Bình Trị Đông B, Quận Bình Tân, Thành phố Hồ Chí Minh","path_with_type":"Phường Bình Trị Đông B, Quận Bình Tân, Thành phố Hồ Chí Minh","code":"27451","parent_code":"777"},"27454":{"name":"Phường Tân Tạo","type":"phuong","slug":"phuong-tan-tao","name_with_type":"Phường Tân Tạo","path":"Phường Tân Tạo, Quận Bình Tân, Thành phố Hồ Chí Minh","path_with_type":"Phường Tân Tạo, Quận Bình Tân, Thành phố Hồ Chí Minh","code":"27454","parent_code":"777"},"27457":{"name":"Phường Tân Tạo A","type":"phuong","slug":"phuong-tan-tao-a","name_with_type":"Phường Tân Tạo A","path":"Phường Tân Tạo A, Quận Bình Tân, Thành phố Hồ Chí Minh","path_with_type":"Phường Tân Tạo A, Quận Bình Tân, Thành phố Hồ Chí Minh","code":"27457","parent_code":"777"},"27460":{"name":"Phường An Lạc","type":"phuong","slug":"phuong-an-lac","name_with_type":"Phường An Lạc","path":"Phường An Lạc, Quận Bình Tân, Thành phố Hồ Chí Minh","path_with_type":"Phường An Lạc, Quận Bình Tân, Thành phố Hồ Chí Minh","code":"27460","parent_code":"777"},"27463":{"name":"Phường An Lạc A","type":"phuong","slug":"phuong-an-lac-a","name_with_type":"Phường An Lạc A","path":"Phường An Lạc A, Quận Bình Tân, Thành phố Hồ Chí Minh","path_with_type":"Phường An Lạc A, Quận Bình Tân, Thành phố Hồ Chí Minh","code":"27463","parent_code":"777"},"27466":{"name":"Phường Tân Thuận Đông","type":"phuong","slug":"phuong-tan-thuan-dong","name_with_type":"Phường Tân Thuận Đông","path":"Phường Tân Thuận Đông, Quận 7, Thành phố Hồ Chí Minh","path_with_type":"Phường Tân Thuận Đông, Quận 7, Thành phố Hồ Chí Minh","code":"27466","parent_code":"778"},"27469":{"name":"Phường Tân Thuận Tây","type":"phuong","slug":"phuong-tan-thuan-tay","name_with_type":"Phường Tân Thuận Tây","path":"Phường Tân Thuận Tây, Quận 7, Thành phố Hồ Chí Minh","path_with_type":"Phường Tân Thuận Tây, Quận 7, Thành phố Hồ Chí Minh","code":"27469","parent_code":"778"},"27472":{"name":"Phường Tân Kiểng","type":"phuong","slug":"phuong-tan-kieng","name_with_type":"Phường Tân Kiểng","path":"Phường Tân Kiểng, Quận 7, Thành phố Hồ Chí Minh","path_with_type":"Phường Tân Kiểng, Quận 7, Thành phố Hồ Chí Minh","code":"27472","parent_code":"778"},"27475":{"name":"Phường Tân Hưng","type":"phuong","slug":"phuong-tan-hung","name_with_type":"Phường Tân Hưng","path":"Phường Tân Hưng, Quận 7, Thành phố Hồ Chí Minh","path_with_type":"Phường Tân Hưng, Quận 7, Thành phố Hồ Chí Minh","code":"27475","parent_code":"778"},"27478":{"name":"Phường Bình Thuận","type":"phuong","slug":"phuong-binh-thuan","name_with_type":"Phường Bình Thuận","path":"Phường Bình Thuận, Quận 7, Thành phố Hồ Chí Minh","path_with_type":"Phường Bình Thuận, Quận 7, Thành phố Hồ Chí Minh","code":"27478","parent_code":"778"},"27481":{"name":"Phường Tân Quy","type":"phuong","slug":"phuong-tan-quy","name_with_type":"Phường Tân Quy","path":"Phường Tân Quy, Quận 7, Thành phố Hồ Chí Minh","path_with_type":"Phường Tân Quy, Quận 7, Thành phố Hồ Chí Minh","code":"27481","parent_code":"778"},"27484":{"name":"Phường Phú Thuận","type":"phuong","slug":"phuong-phu-thuan","name_with_type":"Phường Phú Thuận","path":"Phường Phú Thuận, Quận 7, Thành phố Hồ Chí Minh","path_with_type":"Phường Phú Thuận, Quận 7, Thành phố Hồ Chí Minh","code":"27484","parent_code":"778"},"27487":{"name":"Phường Tân Phú","type":"phuong","slug":"phuong-tan-phu","name_with_type":"Phường Tân Phú","path":"Phường Tân Phú, Quận 7, Thành phố Hồ Chí Minh","path_with_type":"Phường Tân Phú, Quận 7, Thành phố Hồ Chí Minh","code":"27487","parent_code":"778"},"27490":{"name":"Phường Tân Phong","type":"phuong","slug":"phuong-tan-phong","name_with_type":"Phường Tân Phong","path":"Phường Tân Phong, Quận 7, Thành phố Hồ Chí Minh","path_with_type":"Phường Tân Phong, Quận 7, Thành phố Hồ Chí Minh","code":"27490","parent_code":"778"},"27493":{"name":"Phường Phú Mỹ","type":"phuong","slug":"phuong-phu-my","name_with_type":"Phường Phú Mỹ","path":"Phường Phú Mỹ, Quận 7, Thành phố Hồ Chí Minh","path_with_type":"Phường Phú Mỹ, Quận 7, Thành phố Hồ Chí Minh","code":"27493","parent_code":"778"},"27496":{"name":"Thị trấn Củ Chi","type":"thi-tran","slug":"thi-tran-cu-chi","name_with_type":"Thị trấn Củ Chi","path":"Thị trấn Củ Chi, Huyện Củ Chi, Thành phố Hồ Chí Minh","path_with_type":"Thị trấn Củ Chi, Huyện Củ Chi, Thành phố Hồ Chí Minh","code":"27496","parent_code":"783"},"27499":{"name":"Xã Phú Mỹ Hưng","type":"xa","slug":"xa-phu-my-hung","name_with_type":"Xã Phú Mỹ Hưng","path":"Xã Phú Mỹ Hưng, Huyện Củ Chi, Thành phố Hồ Chí Minh","path_with_type":"Xã Phú Mỹ Hưng, Huyện Củ Chi, Thành phố Hồ Chí Minh","code":"27499","parent_code":"783"},"27502":{"name":"Xã An Phú","type":"xa","slug":"xa-an-phu","name_with_type":"Xã An Phú","path":"Xã An Phú, Huyện Củ Chi, Thành phố Hồ Chí Minh","path_with_type":"Xã An Phú, Huyện Củ Chi, Thành phố Hồ Chí Minh","code":"27502","parent_code":"783"},"27505":{"name":"Xã Trung Lập Thượng","type":"xa","slug":"xa-trung-lap-thuong","name_with_type":"Xã Trung Lập Thượng","path":"Xã Trung Lập Thượng, Huyện Củ Chi, Thành phố Hồ Chí Minh","path_with_type":"Xã Trung Lập Thượng, Huyện Củ Chi, Thành phố Hồ Chí Minh","code":"27505","parent_code":"783"},"27508":{"name":"Xã An Nhơn Tây","type":"xa","slug":"xa-an-nhon-tay","name_with_type":"Xã An Nhơn Tây","path":"Xã An Nhơn Tây, Huyện Củ Chi, Thành phố Hồ Chí Minh","path_with_type":"Xã An Nhơn Tây, Huyện Củ Chi, Thành phố Hồ Chí Minh","code":"27508","parent_code":"783"},"27511":{"name":"Xã Nhuận Đức","type":"xa","slug":"xa-nhuan-duc","name_with_type":"Xã Nhuận Đức","path":"Xã Nhuận Đức, Huyện Củ Chi, Thành phố Hồ Chí Minh","path_with_type":"Xã Nhuận Đức, Huyện Củ Chi, Thành phố Hồ Chí Minh","code":"27511","parent_code":"783"},"27514":{"name":"Xã Phạm Văn Cội","type":"xa","slug":"xa-pham-van-coi","name_with_type":"Xã Phạm Văn Cội","path":"Xã Phạm Văn Cội, Huyện Củ Chi, Thành phố Hồ Chí Minh","path_with_type":"Xã Phạm Văn Cội, Huyện Củ Chi, Thành phố Hồ Chí Minh","code":"27514","parent_code":"783"},"27517":{"name":"Xã Phú Hòa Đông","type":"xa","slug":"xa-phu-hoa-dong","name_with_type":"Xã Phú Hòa Đông","path":"Xã Phú Hòa Đông, Huyện Củ Chi, Thành phố Hồ Chí Minh","path_with_type":"Xã Phú Hòa Đông, Huyện Củ Chi, Thành phố Hồ Chí Minh","code":"27517","parent_code":"783"},"27520":{"name":"Xã Trung Lập Hạ","type":"xa","slug":"xa-trung-lap-ha","name_with_type":"Xã Trung Lập Hạ","path":"Xã Trung Lập Hạ, Huyện Củ Chi, Thành phố Hồ Chí Minh","path_with_type":"Xã Trung Lập Hạ, Huyện Củ Chi, Thành phố Hồ Chí Minh","code":"27520","parent_code":"783"},"27523":{"name":"Xã Trung An","type":"xa","slug":"xa-trung-an","name_with_type":"Xã Trung An","path":"Xã Trung An, Huyện Củ Chi, Thành phố Hồ Chí Minh","path_with_type":"Xã Trung An, Huyện Củ Chi, Thành phố Hồ Chí Minh","code":"27523","parent_code":"783"},"27526":{"name":"Xã Phước Thạnh","type":"xa","slug":"xa-phuoc-thanh","name_with_type":"Xã Phước Thạnh","path":"Xã Phước Thạnh, Huyện Củ Chi, Thành phố Hồ Chí Minh","path_with_type":"Xã Phước Thạnh, Huyện Củ Chi, Thành phố Hồ Chí Minh","code":"27526","parent_code":"783"},"27529":{"name":"Xã Phước Hiệp","type":"xa","slug":"xa-phuoc-hiep","name_with_type":"Xã Phước Hiệp","path":"Xã Phước Hiệp, Huyện Củ Chi, Thành phố Hồ Chí Minh","path_with_type":"Xã Phước Hiệp, Huyện Củ Chi, Thành phố Hồ Chí Minh","code":"27529","parent_code":"783"},"27532":{"name":"Xã Tân An Hội","type":"xa","slug":"xa-tan-an-hoi","name_with_type":"Xã Tân An Hội","path":"Xã Tân An Hội, Huyện Củ Chi, Thành phố Hồ Chí Minh","path_with_type":"Xã Tân An Hội, Huyện Củ Chi, Thành phố Hồ Chí Minh","code":"27532","parent_code":"783"},"27535":{"name":"Xã Phước Vĩnh An","type":"xa","slug":"xa-phuoc-vinh-an","name_with_type":"Xã Phước Vĩnh An","path":"Xã Phước Vĩnh An, Huyện Củ Chi, Thành phố Hồ Chí Minh","path_with_type":"Xã Phước Vĩnh An, Huyện Củ Chi, Thành phố Hồ Chí Minh","code":"27535","parent_code":"783"},"27538":{"name":"Xã Thái Mỹ","type":"xa","slug":"xa-thai-my","name_with_type":"Xã Thái Mỹ","path":"Xã Thái Mỹ, Huyện Củ Chi, Thành phố Hồ Chí Minh","path_with_type":"Xã Thái Mỹ, Huyện Củ Chi, Thành phố Hồ Chí Minh","code":"27538","parent_code":"783"},"27541":{"name":"Xã Tân Thạnh Tây","type":"xa","slug":"xa-tan-thanh-tay","name_with_type":"Xã Tân Thạnh Tây","path":"Xã Tân Thạnh Tây, Huyện Củ Chi, Thành phố Hồ Chí Minh","path_with_type":"Xã Tân Thạnh Tây, Huyện Củ Chi, Thành phố Hồ Chí Minh","code":"27541","parent_code":"783"},"27544":{"name":"Xã Hòa Phú","type":"xa","slug":"xa-hoa-phu","name_with_type":"Xã Hòa Phú","path":"Xã Hòa Phú, Huyện Củ Chi, Thành phố Hồ Chí Minh","path_with_type":"Xã Hòa Phú, Huyện Củ Chi, Thành phố Hồ Chí Minh","code":"27544","parent_code":"783"},"27547":{"name":"Xã Tân Thạnh Đông","type":"xa","slug":"xa-tan-thanh-dong","name_with_type":"Xã Tân Thạnh Đông","path":"Xã Tân Thạnh Đông, Huyện Củ Chi, Thành phố Hồ Chí Minh","path_with_type":"Xã Tân Thạnh Đông, Huyện Củ Chi, Thành phố Hồ Chí Minh","code":"27547","parent_code":"783"},"27550":{"name":"Xã Bình Mỹ","type":"xa","slug":"xa-binh-my","name_with_type":"Xã Bình Mỹ","path":"Xã Bình Mỹ, Huyện Củ Chi, Thành phố Hồ Chí Minh","path_with_type":"Xã Bình Mỹ, Huyện Củ Chi, Thành phố Hồ Chí Minh","code":"27550","parent_code":"783"},"27553":{"name":"Xã Tân Phú Trung","type":"xa","slug":"xa-tan-phu-trung","name_with_type":"Xã Tân Phú Trung","path":"Xã Tân Phú Trung, Huyện Củ Chi, Thành phố Hồ Chí Minh","path_with_type":"Xã Tân Phú Trung, Huyện Củ Chi, Thành phố Hồ Chí Minh","code":"27553","parent_code":"783"},"27556":{"name":"Xã Tân Thông Hội","type":"xa","slug":"xa-tan-thong-hoi","name_with_type":"Xã Tân Thông Hội","path":"Xã Tân Thông Hội, Huyện Củ Chi, Thành phố Hồ Chí Minh","path_with_type":"Xã Tân Thông Hội, Huyện Củ Chi, Thành phố Hồ Chí Minh","code":"27556","parent_code":"783"},"27559":{"name":"Thị trấn Hóc Môn","type":"thi-tran","slug":"thi-tran-hoc-mon","name_with_type":"Thị trấn Hóc Môn","path":"Thị trấn Hóc Môn, Huyện Hóc Môn, Thành phố Hồ Chí Minh","path_with_type":"Thị trấn Hóc Môn, Huyện Hóc Môn, Thành phố Hồ Chí Minh","code":"27559","parent_code":"784"},"27562":{"name":"Xã Tân Hiệp","type":"xa","slug":"xa-tan-hiep","name_with_type":"Xã Tân Hiệp","path":"Xã Tân Hiệp, Huyện Hóc Môn, Thành phố Hồ Chí Minh","path_with_type":"Xã Tân Hiệp, Huyện Hóc Môn, Thành phố Hồ Chí Minh","code":"27562","parent_code":"784"},"27565":{"name":"Xã Nhị Bình","type":"xa","slug":"xa-nhi-binh","name_with_type":"Xã Nhị Bình","path":"Xã Nhị Bình, Huyện Hóc Môn, Thành phố Hồ Chí Minh","path_with_type":"Xã Nhị Bình, Huyện Hóc Môn, Thành phố Hồ Chí Minh","code":"27565","parent_code":"784"},"27568":{"name":"Xã Đông Thạnh","type":"xa","slug":"xa-dong-thanh","name_with_type":"Xã Đông Thạnh","path":"Xã Đông Thạnh, Huyện Hóc Môn, Thành phố Hồ Chí Minh","path_with_type":"Xã Đông Thạnh, Huyện Hóc Môn, Thành phố Hồ Chí Minh","code":"27568","parent_code":"784"},"27571":{"name":"Xã Tân Thới Nhì","type":"xa","slug":"xa-tan-thoi-nhi","name_with_type":"Xã Tân Thới Nhì","path":"Xã Tân Thới Nhì, Huyện Hóc Môn, Thành phố Hồ Chí Minh","path_with_type":"Xã Tân Thới Nhì, Huyện Hóc Môn, Thành phố Hồ Chí Minh","code":"27571","parent_code":"784"},"27574":{"name":"Xã Thới Tam Thôn","type":"xa","slug":"xa-thoi-tam-thon","name_with_type":"Xã Thới Tam Thôn","path":"Xã Thới Tam Thôn, Huyện Hóc Môn, Thành phố Hồ Chí Minh","path_with_type":"Xã Thới Tam Thôn, Huyện Hóc Môn, Thành phố Hồ Chí Minh","code":"27574","parent_code":"784"},"27577":{"name":"Xã Xuân Thới Sơn","type":"xa","slug":"xa-xuan-thoi-son","name_with_type":"Xã Xuân Thới Sơn","path":"Xã Xuân Thới Sơn, Huyện Hóc Môn, Thành phố Hồ Chí Minh","path_with_type":"Xã Xuân Thới Sơn, Huyện Hóc Môn, Thành phố Hồ Chí Minh","code":"27577","parent_code":"784"},"27580":{"name":"Xã Tân Xuân","type":"xa","slug":"xa-tan-xuan","name_with_type":"Xã Tân Xuân","path":"Xã Tân Xuân, Huyện Hóc Môn, Thành phố Hồ Chí Minh","path_with_type":"Xã Tân Xuân, Huyện Hóc Môn, Thành phố Hồ Chí Minh","code":"27580","parent_code":"784"},"27583":{"name":"Xã Xuân Thới Đông","type":"xa","slug":"xa-xuan-thoi-dong","name_with_type":"Xã Xuân Thới Đông","path":"Xã Xuân Thới Đông, Huyện Hóc Môn, Thành phố Hồ Chí Minh","path_with_type":"Xã Xuân Thới Đông, Huyện Hóc Môn, Thành phố Hồ Chí Minh","code":"27583","parent_code":"784"},"27586":{"name":"Xã Trung Chánh","type":"xa","slug":"xa-trung-chanh","name_with_type":"Xã Trung Chánh","path":"Xã Trung Chánh, Huyện Hóc Môn, Thành phố Hồ Chí Minh","path_with_type":"Xã Trung Chánh, Huyện Hóc Môn, Thành phố Hồ Chí Minh","code":"27586","parent_code":"784"},"27589":{"name":"Xã Xuân Thới Thượng","type":"xa","slug":"xa-xuan-thoi-thuong","name_with_type":"Xã Xuân Thới Thượng","path":"Xã Xuân Thới Thượng, Huyện Hóc Môn, Thành phố Hồ Chí Minh","path_with_type":"Xã Xuân Thới Thượng, Huyện Hóc Môn, Thành phố Hồ Chí Minh","code":"27589","parent_code":"784"},"27592":{"name":"Xã Bà Điểm","type":"xa","slug":"xa-ba-diem","name_with_type":"Xã Bà Điểm","path":"Xã Bà Điểm, Huyện Hóc Môn, Thành phố Hồ Chí Minh","path_with_type":"Xã Bà Điểm, Huyện Hóc Môn, Thành phố Hồ Chí Minh","code":"27592","parent_code":"784"},"27595":{"name":"Thị trấn Tân Túc","type":"thi-tran","slug":"thi-tran-tan-tuc","name_with_type":"Thị trấn Tân Túc","path":"Thị trấn Tân Túc, Huyện Bình Chánh, Thành phố Hồ Chí Minh","path_with_type":"Thị trấn Tân Túc, Huyện Bình Chánh, Thành phố Hồ Chí Minh","code":"27595","parent_code":"785"},"27598":{"name":"Xã Phạm Văn Hai","type":"xa","slug":"xa-pham-van-hai","name_with_type":"Xã Phạm Văn Hai","path":"Xã Phạm Văn Hai, Huyện Bình Chánh, Thành phố Hồ Chí Minh","path_with_type":"Xã Phạm Văn Hai, Huyện Bình Chánh, Thành phố Hồ Chí Minh","code":"27598","parent_code":"785"},"27601":{"name":"Xã Vĩnh Lộc A","type":"xa","slug":"xa-vinh-loc-a","name_with_type":"Xã Vĩnh Lộc A","path":"Xã Vĩnh Lộc A, Huyện Bình Chánh, Thành phố Hồ Chí Minh","path_with_type":"Xã Vĩnh Lộc A, Huyện Bình Chánh, Thành phố Hồ Chí Minh","code":"27601","parent_code":"785"},"27604":{"name":"Xã Vĩnh Lộc B","type":"xa","slug":"xa-vinh-loc-b","name_with_type":"Xã Vĩnh Lộc B","path":"Xã Vĩnh Lộc B, Huyện Bình Chánh, Thành phố Hồ Chí Minh","path_with_type":"Xã Vĩnh Lộc B, Huyện Bình Chánh, Thành phố Hồ Chí Minh","code":"27604","parent_code":"785"},"27607":{"name":"Xã Bình Lợi","type":"xa","slug":"xa-binh-loi","name_with_type":"Xã Bình Lợi","path":"Xã Bình Lợi, Huyện Bình Chánh, Thành phố Hồ Chí Minh","path_with_type":"Xã Bình Lợi, Huyện Bình Chánh, Thành phố Hồ Chí Minh","code":"27607","parent_code":"785"},"27610":{"name":"Xã Lê Minh Xuân","type":"xa","slug":"xa-le-minh-xuan","name_with_type":"Xã Lê Minh Xuân","path":"Xã Lê Minh Xuân, Huyện Bình Chánh, Thành phố Hồ Chí Minh","path_with_type":"Xã Lê Minh Xuân, Huyện Bình Chánh, Thành phố Hồ Chí Minh","code":"27610","parent_code":"785"},"27613":{"name":"Xã Tân Nhựt","type":"xa","slug":"xa-tan-nhut","name_with_type":"Xã Tân Nhựt","path":"Xã Tân Nhựt, Huyện Bình Chánh, Thành phố Hồ Chí Minh","path_with_type":"Xã Tân Nhựt, Huyện Bình Chánh, Thành phố Hồ Chí Minh","code":"27613","parent_code":"785"},"27616":{"name":"Xã Tân Kiên","type":"xa","slug":"xa-tan-kien","name_with_type":"Xã Tân Kiên","path":"Xã Tân Kiên, Huyện Bình Chánh, Thành phố Hồ Chí Minh","path_with_type":"Xã Tân Kiên, Huyện Bình Chánh, Thành phố Hồ Chí Minh","code":"27616","parent_code":"785"},"27619":{"name":"Xã Bình Hưng","type":"xa","slug":"xa-binh-hung","name_with_type":"Xã Bình Hưng","path":"Xã Bình Hưng, Huyện Bình Chánh, Thành phố Hồ Chí Minh","path_with_type":"Xã Bình Hưng, Huyện Bình Chánh, Thành phố Hồ Chí Minh","code":"27619","parent_code":"785"},"27622":{"name":"Xã Phong Phú","type":"xa","slug":"xa-phong-phu","name_with_type":"Xã Phong Phú","path":"Xã Phong Phú, Huyện Bình Chánh, Thành phố Hồ Chí Minh","path_with_type":"Xã Phong Phú, Huyện Bình Chánh, Thành phố Hồ Chí Minh","code":"27622","parent_code":"785"},"27625":{"name":"Xã An Phú Tây","type":"xa","slug":"xa-an-phu-tay","name_with_type":"Xã An Phú Tây","path":"Xã An Phú Tây, Huyện Bình Chánh, Thành phố Hồ Chí Minh","path_with_type":"Xã An Phú Tây, Huyện Bình Chánh, Thành phố Hồ Chí Minh","code":"27625","parent_code":"785"},"27628":{"name":"Xã Hưng Long","type":"xa","slug":"xa-hung-long","name_with_type":"Xã Hưng Long","path":"Xã Hưng Long, Huyện Bình Chánh, Thành phố Hồ Chí Minh","path_with_type":"Xã Hưng Long, Huyện Bình Chánh, Thành phố Hồ Chí Minh","code":"27628","parent_code":"785"},"27631":{"name":"Xã Đa Phước","type":"xa","slug":"xa-da-phuoc","name_with_type":"Xã Đa Phước","path":"Xã Đa Phước, Huyện Bình Chánh, Thành phố Hồ Chí Minh","path_with_type":"Xã Đa Phước, Huyện Bình Chánh, Thành phố Hồ Chí Minh","code":"27631","parent_code":"785"},"27634":{"name":"Xã Tân Quý Tây","type":"xa","slug":"xa-tan-quy-tay","name_with_type":"Xã Tân Quý Tây","path":"Xã Tân Quý Tây, Huyện Bình Chánh, Thành phố Hồ Chí Minh","path_with_type":"Xã Tân Quý Tây, Huyện Bình Chánh, Thành phố Hồ Chí Minh","code":"27634","parent_code":"785"},"27637":{"name":"Xã Bình Chánh","type":"xa","slug":"xa-binh-chanh","name_with_type":"Xã Bình Chánh","path":"Xã Bình Chánh, Huyện Bình Chánh, Thành phố Hồ Chí Minh","path_with_type":"Xã Bình Chánh, Huyện Bình Chánh, Thành phố Hồ Chí Minh","code":"27637","parent_code":"785"},"27640":{"name":"Xã Quy Đức","type":"xa","slug":"xa-quy-duc","name_with_type":"Xã Quy Đức","path":"Xã Quy Đức, Huyện Bình Chánh, Thành phố Hồ Chí Minh","path_with_type":"Xã Quy Đức, Huyện Bình Chánh, Thành phố Hồ Chí Minh","code":"27640","parent_code":"785"},"27643":{"name":"Thị trấn Nhà Bè","type":"thi-tran","slug":"thi-tran-nha-be","name_with_type":"Thị trấn Nhà Bè","path":"Thị trấn Nhà Bè, Huyện Nhà Bè, Thành phố Hồ Chí Minh","path_with_type":"Thị trấn Nhà Bè, Huyện Nhà Bè, Thành phố Hồ Chí Minh","code":"27643","parent_code":"786"},"27646":{"name":"Xã Phước Kiển","type":"xa","slug":"xa-phuoc-kien","name_with_type":"Xã Phước Kiển","path":"Xã Phước Kiển, Huyện Nhà Bè, Thành phố Hồ Chí Minh","path_with_type":"Xã Phước Kiển, Huyện Nhà Bè, Thành phố Hồ Chí Minh","code":"27646","parent_code":"786"},"27649":{"name":"Xã Phước Lộc","type":"xa","slug":"xa-phuoc-loc","name_with_type":"Xã Phước Lộc","path":"Xã Phước Lộc, Huyện Nhà Bè, Thành phố Hồ Chí Minh","path_with_type":"Xã Phước Lộc, Huyện Nhà Bè, Thành phố Hồ Chí Minh","code":"27649","parent_code":"786"},"27652":{"name":"Xã Nhơn Đức","type":"xa","slug":"xa-nhon-duc","name_with_type":"Xã Nhơn Đức","path":"Xã Nhơn Đức, Huyện Nhà Bè, Thành phố Hồ Chí Minh","path_with_type":"Xã Nhơn Đức, Huyện Nhà Bè, Thành phố Hồ Chí Minh","code":"27652","parent_code":"786"},"27655":{"name":"Xã Phú Xuân","type":"xa","slug":"xa-phu-xuan","name_with_type":"Xã Phú Xuân","path":"Xã Phú Xuân, Huyện Nhà Bè, Thành phố Hồ Chí Minh","path_with_type":"Xã Phú Xuân, Huyện Nhà Bè, Thành phố Hồ Chí Minh","code":"27655","parent_code":"786"},"27658":{"name":"Xã Long Thới","type":"xa","slug":"xa-long-thoi","name_with_type":"Xã Long Thới","path":"Xã Long Thới, Huyện Nhà Bè, Thành phố Hồ Chí Minh","path_with_type":"Xã Long Thới, Huyện Nhà Bè, Thành phố Hồ Chí Minh","code":"27658","parent_code":"786"},"27661":{"name":"Xã Hiệp Phước","type":"xa","slug":"xa-hiep-phuoc","name_with_type":"Xã Hiệp Phước","path":"Xã Hiệp Phước, Huyện Nhà Bè, Thành phố Hồ Chí Minh","path_with_type":"Xã Hiệp Phước, Huyện Nhà Bè, Thành phố Hồ Chí Minh","code":"27661","parent_code":"786"},"27664":{"name":"Thị trấn Cần Thạnh","type":"thi-tran","slug":"thi-tran-can-thanh","name_with_type":"Thị trấn Cần Thạnh","path":"Thị trấn Cần Thạnh, Huyện Cần Giờ, Thành phố Hồ Chí Minh","path_with_type":"Thị trấn Cần Thạnh, Huyện Cần Giờ, Thành phố Hồ Chí Minh","code":"27664","parent_code":"787"},"27667":{"name":"Xã Bình Khánh","type":"xa","slug":"xa-binh-khanh","name_with_type":"Xã Bình Khánh","path":"Xã Bình Khánh, Huyện Cần Giờ, Thành phố Hồ Chí Minh","path_with_type":"Xã Bình Khánh, Huyện Cần Giờ, Thành phố Hồ Chí Minh","code":"27667","parent_code":"787"},"27670":{"name":"Xã Tam Thôn Hiệp","type":"xa","slug":"xa-tam-thon-hiep","name_with_type":"Xã Tam Thôn Hiệp","path":"Xã Tam Thôn Hiệp, Huyện Cần Giờ, Thành phố Hồ Chí Minh","path_with_type":"Xã Tam Thôn Hiệp, Huyện Cần Giờ, Thành phố Hồ Chí Minh","code":"27670","parent_code":"787"},"27673":{"name":"Xã An Thới Đông","type":"xa","slug":"xa-an-thoi-dong","name_with_type":"Xã An Thới Đông","path":"Xã An Thới Đông, Huyện Cần Giờ, Thành phố Hồ Chí Minh","path_with_type":"Xã An Thới Đông, Huyện Cần Giờ, Thành phố Hồ Chí Minh","code":"27673","parent_code":"787"},"27676":{"name":"Xã Thạnh An","type":"xa","slug":"xa-thanh-an","name_with_type":"Xã Thạnh An","path":"Xã Thạnh An, Huyện Cần Giờ, Thành phố Hồ Chí Minh","path_with_type":"Xã Thạnh An, Huyện Cần Giờ, Thành phố Hồ Chí Minh","code":"27676","parent_code":"787"},"27679":{"name":"Xã Long Hòa","type":"xa","slug":"xa-long-hoa","name_with_type":"Xã Long Hòa","path":"Xã Long Hòa, Huyện Cần Giờ, Thành phố Hồ Chí Minh","path_with_type":"Xã Long Hòa, Huyện Cần Giờ, Thành phố Hồ Chí Minh","code":"27679","parent_code":"787"},"27682":{"name":"Xã Lý Nhơn","type":"xa","slug":"xa-ly-nhon","name_with_type":"Xã Lý Nhơn","path":"Xã Lý Nhơn, Huyện Cần Giờ, Thành phố Hồ Chí Minh","path_with_type":"Xã Lý Nhơn, Huyện Cần Giờ, Thành phố Hồ Chí Minh","code":"27682","parent_code":"787"},"27685":{"name":"Phường 5","type":"phuong","slug":"phuong-5","name_with_type":"Phường 5","path":"Phường 5, Thành phố Tân An, Tỉnh Long An","path_with_type":"Phường 5, Thành phố Tân An, Tỉnh Long An","code":"27685","parent_code":"794"},"27691":{"name":"Phường 4","type":"phuong","slug":"phuong-4","name_with_type":"Phường 4","path":"Phường 4, Thành phố Tân An, Tỉnh Long An","path_with_type":"Phường 4, Thành phố Tân An, Tỉnh Long An","code":"27691","parent_code":"794"},"27692":{"name":"Phường Tân Khánh","type":"phuong","slug":"phuong-tan-khanh","name_with_type":"Phường Tân Khánh","path":"Phường Tân Khánh, Thành phố Tân An, Tỉnh Long An","path_with_type":"Phường Tân Khánh, Thành phố Tân An, Tỉnh Long An","code":"27692","parent_code":"794"},"27694":{"name":"Phường 1","type":"phuong","slug":"phuong-1","name_with_type":"Phường 1","path":"Phường 1, Thành phố Tân An, Tỉnh Long An","path_with_type":"Phường 1, Thành phố Tân An, Tỉnh Long An","code":"27694","parent_code":"794"},"27697":{"name":"Phường 3","type":"phuong","slug":"phuong-3","name_with_type":"Phường 3","path":"Phường 3, Thành phố Tân An, Tỉnh Long An","path_with_type":"Phường 3, Thành phố Tân An, Tỉnh Long An","code":"27697","parent_code":"794"},"27698":{"name":"Phường 7","type":"phuong","slug":"phuong-7","name_with_type":"Phường 7","path":"Phường 7, Thành phố Tân An, Tỉnh Long An","path_with_type":"Phường 7, Thành phố Tân An, Tỉnh Long An","code":"27698","parent_code":"794"},"27700":{"name":"Phường 6","type":"phuong","slug":"phuong-6","name_with_type":"Phường 6","path":"Phường 6, Thành phố Tân An, Tỉnh Long An","path_with_type":"Phường 6, Thành phố Tân An, Tỉnh Long An","code":"27700","parent_code":"794"},"27703":{"name":"Xã Hướng Thọ Phú","type":"xa","slug":"xa-huong-tho-phu","name_with_type":"Xã Hướng Thọ Phú","path":"Xã Hướng Thọ Phú, Thành phố Tân An, Tỉnh Long An","path_with_type":"Xã Hướng Thọ Phú, Thành phố Tân An, Tỉnh Long An","code":"27703","parent_code":"794"},"27706":{"name":"Xã Nhơn Thạnh Trung","type":"xa","slug":"xa-nhon-thanh-trung","name_with_type":"Xã Nhơn Thạnh Trung","path":"Xã Nhơn Thạnh Trung, Thành phố Tân An, Tỉnh Long An","path_with_type":"Xã Nhơn Thạnh Trung, Thành phố Tân An, Tỉnh Long An","code":"27706","parent_code":"794"},"27709":{"name":"Xã Lợi Bình Nhơn","type":"xa","slug":"xa-loi-binh-nhon","name_with_type":"Xã Lợi Bình Nhơn","path":"Xã Lợi Bình Nhơn, Thành phố Tân An, Tỉnh Long An","path_with_type":"Xã Lợi Bình Nhơn, Thành phố Tân An, Tỉnh Long An","code":"27709","parent_code":"794"},"27712":{"name":"Xã Bình Tâm","type":"xa","slug":"xa-binh-tam","name_with_type":"Xã Bình Tâm","path":"Xã Bình Tâm, Thành phố Tân An, Tỉnh Long An","path_with_type":"Xã Bình Tâm, Thành phố Tân An, Tỉnh Long An","code":"27712","parent_code":"794"},"27715":{"name":"Phường Khánh Hậu","type":"phuong","slug":"phuong-khanh-hau","name_with_type":"Phường Khánh Hậu","path":"Phường Khánh Hậu, Thành phố Tân An, Tỉnh Long An","path_with_type":"Phường Khánh Hậu, Thành phố Tân An, Tỉnh Long An","code":"27715","parent_code":"794"},"27718":{"name":"Xã An Vĩnh Ngãi","type":"xa","slug":"xa-an-vinh-ngai","name_with_type":"Xã An Vĩnh Ngãi","path":"Xã An Vĩnh Ngãi, Thành phố Tân An, Tỉnh Long An","path_with_type":"Xã An Vĩnh Ngãi, Thành phố Tân An, Tỉnh Long An","code":"27718","parent_code":"794"},"27721":{"name":"Thị trấn Tân Hưng","type":"thi-tran","slug":"thi-tran-tan-hung","name_with_type":"Thị trấn Tân Hưng","path":"Thị trấn Tân Hưng, Huyện Tân Hưng, Tỉnh Long An","path_with_type":"Thị trấn Tân Hưng, Huyện Tân Hưng, Tỉnh Long An","code":"27721","parent_code":"796"},"27724":{"name":"Xã Hưng Hà","type":"xa","slug":"xa-hung-ha","name_with_type":"Xã Hưng Hà","path":"Xã Hưng Hà, Huyện Tân Hưng, Tỉnh Long An","path_with_type":"Xã Hưng Hà, Huyện Tân Hưng, Tỉnh Long An","code":"27724","parent_code":"796"},"27727":{"name":"Xã Hưng Điền B","type":"xa","slug":"xa-hung-dien-b","name_with_type":"Xã Hưng Điền B","path":"Xã Hưng Điền B, Huyện Tân Hưng, Tỉnh Long An","path_with_type":"Xã Hưng Điền B, Huyện Tân Hưng, Tỉnh Long An","code":"27727","parent_code":"796"},"27730":{"name":"Xã Hưng Điền","type":"xa","slug":"xa-hung-dien","name_with_type":"Xã Hưng Điền","path":"Xã Hưng Điền, Huyện Tân Hưng, Tỉnh Long An","path_with_type":"Xã Hưng Điền, Huyện Tân Hưng, Tỉnh Long An","code":"27730","parent_code":"796"},"27733":{"name":"Xã Thạnh Hưng","type":"xa","slug":"xa-thanh-hung","name_with_type":"Xã Thạnh Hưng","path":"Xã Thạnh Hưng, Huyện Tân Hưng, Tỉnh Long An","path_with_type":"Xã Thạnh Hưng, Huyện Tân Hưng, Tỉnh Long An","code":"27733","parent_code":"796"},"27736":{"name":"Xã Hưng Thạnh","type":"xa","slug":"xa-hung-thanh","name_with_type":"Xã Hưng Thạnh","path":"Xã Hưng Thạnh, Huyện Tân Hưng, Tỉnh Long An","path_with_type":"Xã Hưng Thạnh, Huyện Tân Hưng, Tỉnh Long An","code":"27736","parent_code":"796"},"27739":{"name":"Xã Vĩnh Thạnh","type":"xa","slug":"xa-vinh-thanh","name_with_type":"Xã Vĩnh Thạnh","path":"Xã Vĩnh Thạnh, Huyện Tân Hưng, Tỉnh Long An","path_with_type":"Xã Vĩnh Thạnh, Huyện Tân Hưng, Tỉnh Long An","code":"27739","parent_code":"796"},"27742":{"name":"Xã Vĩnh Châu B","type":"xa","slug":"xa-vinh-chau-b","name_with_type":"Xã Vĩnh Châu B","path":"Xã Vĩnh Châu B, Huyện Tân Hưng, Tỉnh Long An","path_with_type":"Xã Vĩnh Châu B, Huyện Tân Hưng, Tỉnh Long An","code":"27742","parent_code":"796"},"27745":{"name":"Xã Vĩnh Lợi","type":"xa","slug":"xa-vinh-loi","name_with_type":"Xã Vĩnh Lợi","path":"Xã Vĩnh Lợi, Huyện Tân Hưng, Tỉnh Long An","path_with_type":"Xã Vĩnh Lợi, Huyện Tân Hưng, Tỉnh Long An","code":"27745","parent_code":"796"},"27748":{"name":"Xã Vĩnh Đại","type":"xa","slug":"xa-vinh-dai","name_with_type":"Xã Vĩnh Đại","path":"Xã Vĩnh Đại, Huyện Tân Hưng, Tỉnh Long An","path_with_type":"Xã Vĩnh Đại, Huyện Tân Hưng, Tỉnh Long An","code":"27748","parent_code":"796"},"27751":{"name":"Xã Vĩnh Châu A","type":"xa","slug":"xa-vinh-chau-a","name_with_type":"Xã Vĩnh Châu A","path":"Xã Vĩnh Châu A, Huyện Tân Hưng, Tỉnh Long An","path_with_type":"Xã Vĩnh Châu A, Huyện Tân Hưng, Tỉnh Long An","code":"27751","parent_code":"796"},"27754":{"name":"Xã Vĩnh Bửu","type":"xa","slug":"xa-vinh-buu","name_with_type":"Xã Vĩnh Bửu","path":"Xã Vĩnh Bửu, Huyện Tân Hưng, Tỉnh Long An","path_with_type":"Xã Vĩnh Bửu, Huyện Tân Hưng, Tỉnh Long An","code":"27754","parent_code":"796"},"27757":{"name":"Thị trấn Vĩnh Hưng","type":"thi-tran","slug":"thi-tran-vinh-hung","name_with_type":"Thị trấn Vĩnh Hưng","path":"Thị trấn Vĩnh Hưng, Huyện Vĩnh Hưng, Tỉnh Long An","path_with_type":"Thị trấn Vĩnh Hưng, Huyện Vĩnh Hưng, Tỉnh Long An","code":"27757","parent_code":"797"},"27760":{"name":"Xã Hưng Điền A","type":"xa","slug":"xa-hung-dien-a","name_with_type":"Xã Hưng Điền A","path":"Xã Hưng Điền A, Huyện Vĩnh Hưng, Tỉnh Long An","path_with_type":"Xã Hưng Điền A, Huyện Vĩnh Hưng, Tỉnh Long An","code":"27760","parent_code":"797"},"27763":{"name":"Xã Khánh Hưng","type":"xa","slug":"xa-khanh-hung","name_with_type":"Xã Khánh Hưng","path":"Xã Khánh Hưng, Huyện Vĩnh Hưng, Tỉnh Long An","path_with_type":"Xã Khánh Hưng, Huyện Vĩnh Hưng, Tỉnh Long An","code":"27763","parent_code":"797"},"27766":{"name":"Xã Thái Trị","type":"xa","slug":"xa-thai-tri","name_with_type":"Xã Thái Trị","path":"Xã Thái Trị, Huyện Vĩnh Hưng, Tỉnh Long An","path_with_type":"Xã Thái Trị, Huyện Vĩnh Hưng, Tỉnh Long An","code":"27766","parent_code":"797"},"27769":{"name":"Xã Vĩnh Trị","type":"xa","slug":"xa-vinh-tri","name_with_type":"Xã Vĩnh Trị","path":"Xã Vĩnh Trị, Huyện Vĩnh Hưng, Tỉnh Long An","path_with_type":"Xã Vĩnh Trị, Huyện Vĩnh Hưng, Tỉnh Long An","code":"27769","parent_code":"797"},"27772":{"name":"Xã Thái Bình Trung","type":"xa","slug":"xa-thai-binh-trung","name_with_type":"Xã Thái Bình Trung","path":"Xã Thái Bình Trung, Huyện Vĩnh Hưng, Tỉnh Long An","path_with_type":"Xã Thái Bình Trung, Huyện Vĩnh Hưng, Tỉnh Long An","code":"27772","parent_code":"797"},"27775":{"name":"Xã Vĩnh Bình","type":"xa","slug":"xa-vinh-binh","name_with_type":"Xã Vĩnh Bình","path":"Xã Vĩnh Bình, Huyện Vĩnh Hưng, Tỉnh Long An","path_with_type":"Xã Vĩnh Bình, Huyện Vĩnh Hưng, Tỉnh Long An","code":"27775","parent_code":"797"},"27778":{"name":"Xã Vĩnh Thuận","type":"xa","slug":"xa-vinh-thuan","name_with_type":"Xã Vĩnh Thuận","path":"Xã Vĩnh Thuận, Huyện Vĩnh Hưng, Tỉnh Long An","path_with_type":"Xã Vĩnh Thuận, Huyện Vĩnh Hưng, Tỉnh Long An","code":"27778","parent_code":"797"},"27781":{"name":"Xã Tuyên Bình","type":"xa","slug":"xa-tuyen-binh","name_with_type":"Xã Tuyên Bình","path":"Xã Tuyên Bình, Huyện Vĩnh Hưng, Tỉnh Long An","path_with_type":"Xã Tuyên Bình, Huyện Vĩnh Hưng, Tỉnh Long An","code":"27781","parent_code":"797"},"27784":{"name":"Xã Tuyên Bình Tây","type":"xa","slug":"xa-tuyen-binh-tay","name_with_type":"Xã Tuyên Bình Tây","path":"Xã Tuyên Bình Tây, Huyện Vĩnh Hưng, Tỉnh Long An","path_with_type":"Xã Tuyên Bình Tây, Huyện Vĩnh Hưng, Tỉnh Long An","code":"27784","parent_code":"797"},"27787":{"name":"Phường 1","type":"phuong","slug":"phuong-1","name_with_type":"Phường 1","path":"Phường 1, Thị xã Kiến Tường, Tỉnh Long An","path_with_type":"Phường 1, Thị xã Kiến Tường, Tỉnh Long An","code":"27787","parent_code":"795"},"27788":{"name":"Phường 2","type":"phuong","slug":"phuong-2","name_with_type":"Phường 2","path":"Phường 2, Thị xã Kiến Tường, Tỉnh Long An","path_with_type":"Phường 2, Thị xã Kiến Tường, Tỉnh Long An","code":"27788","parent_code":"795"},"27790":{"name":"Xã Thạnh Trị","type":"xa","slug":"xa-thanh-tri","name_with_type":"Xã Thạnh Trị","path":"Xã Thạnh Trị, Thị xã Kiến Tường, Tỉnh Long An","path_with_type":"Xã Thạnh Trị, Thị xã Kiến Tường, Tỉnh Long An","code":"27790","parent_code":"795"},"27793":{"name":"Xã Bình Hiệp","type":"xa","slug":"xa-binh-hiep","name_with_type":"Xã Bình Hiệp","path":"Xã Bình Hiệp, Thị xã Kiến Tường, Tỉnh Long An","path_with_type":"Xã Bình Hiệp, Thị xã Kiến Tường, Tỉnh Long An","code":"27793","parent_code":"795"},"27796":{"name":"Xã Bình Hòa Tây","type":"xa","slug":"xa-binh-hoa-tay","name_with_type":"Xã Bình Hòa Tây","path":"Xã Bình Hòa Tây, Huyện Mộc Hóa, Tỉnh Long An","path_with_type":"Xã Bình Hòa Tây, Huyện Mộc Hóa, Tỉnh Long An","code":"27796","parent_code":"798"},"27799":{"name":"Xã Bình Tân","type":"xa","slug":"xa-binh-tan","name_with_type":"Xã Bình Tân","path":"Xã Bình Tân, Thị xã Kiến Tường, Tỉnh Long An","path_with_type":"Xã Bình Tân, Thị xã Kiến Tường, Tỉnh Long An","code":"27799","parent_code":"795"},"27802":{"name":"Xã Bình Thạnh","type":"xa","slug":"xa-binh-thanh","name_with_type":"Xã Bình Thạnh","path":"Xã Bình Thạnh, Huyện Mộc Hóa, Tỉnh Long An","path_with_type":"Xã Bình Thạnh, Huyện Mộc Hóa, Tỉnh Long An","code":"27802","parent_code":"798"},"27805":{"name":"Xã Tuyên Thạnh","type":"xa","slug":"xa-tuyen-thanh","name_with_type":"Xã Tuyên Thạnh","path":"Xã Tuyên Thạnh, Thị xã Kiến Tường, Tỉnh Long An","path_with_type":"Xã Tuyên Thạnh, Thị xã Kiến Tường, Tỉnh Long An","code":"27805","parent_code":"795"},"27806":{"name":"Phường 3","type":"phuong","slug":"phuong-3","name_with_type":"Phường 3","path":"Phường 3, Thị xã Kiến Tường, Tỉnh Long An","path_with_type":"Phường 3, Thị xã Kiến Tường, Tỉnh Long An","code":"27806","parent_code":"795"},"27808":{"name":"Xã Bình Hòa Trung","type":"xa","slug":"xa-binh-hoa-trung","name_with_type":"Xã Bình Hòa Trung","path":"Xã Bình Hòa Trung, Huyện Mộc Hóa, Tỉnh Long An","path_with_type":"Xã Bình Hòa Trung, Huyện Mộc Hóa, Tỉnh Long An","code":"27808","parent_code":"798"},"27811":{"name":"Xã Bình Hòa Đông","type":"xa","slug":"xa-binh-hoa-dong","name_with_type":"Xã Bình Hòa Đông","path":"Xã Bình Hòa Đông, Huyện Mộc Hóa, Tỉnh Long An","path_with_type":"Xã Bình Hòa Đông, Huyện Mộc Hóa, Tỉnh Long An","code":"27811","parent_code":"798"},"27814":{"name":"Thị trấn Bình Phong Thạnh","type":"thi-tran","slug":"thi-tran-binh-phong-thanh","name_with_type":"Thị trấn Bình Phong Thạnh","path":"Thị trấn Bình Phong Thạnh, Huyện Mộc Hóa, Tỉnh Long An","path_with_type":"Thị trấn Bình Phong Thạnh, Huyện Mộc Hóa, Tỉnh Long An","code":"27814","parent_code":"798"},"27817":{"name":"Xã Thạnh Hưng","type":"xa","slug":"xa-thanh-hung","name_with_type":"Xã Thạnh Hưng","path":"Xã Thạnh Hưng, Thị xã Kiến Tường, Tỉnh Long An","path_with_type":"Xã Thạnh Hưng, Thị xã Kiến Tường, Tỉnh Long An","code":"27817","parent_code":"795"},"27820":{"name":"Xã Tân Lập","type":"xa","slug":"xa-tan-lap","name_with_type":"Xã Tân Lập","path":"Xã Tân Lập, Huyện Mộc Hóa, Tỉnh Long An","path_with_type":"Xã Tân Lập, Huyện Mộc Hóa, Tỉnh Long An","code":"27820","parent_code":"798"},"27823":{"name":"Xã Tân Thành","type":"xa","slug":"xa-tan-thanh","name_with_type":"Xã Tân Thành","path":"Xã Tân Thành, Huyện Mộc Hóa, Tỉnh Long An","path_with_type":"Xã Tân Thành, Huyện Mộc Hóa, Tỉnh Long An","code":"27823","parent_code":"798"},"27826":{"name":"Thị trấn Tân Thạnh","type":"thi-tran","slug":"thi-tran-tan-thanh","name_with_type":"Thị trấn Tân Thạnh","path":"Thị trấn Tân Thạnh, Huyện Tân Thạnh, Tỉnh Long An","path_with_type":"Thị trấn Tân Thạnh, Huyện Tân Thạnh, Tỉnh Long An","code":"27826","parent_code":"799"},"27829":{"name":"Xã Bắc Hòa","type":"xa","slug":"xa-bac-hoa","name_with_type":"Xã Bắc Hòa","path":"Xã Bắc Hòa, Huyện Tân Thạnh, Tỉnh Long An","path_with_type":"Xã Bắc Hòa, Huyện Tân Thạnh, Tỉnh Long An","code":"27829","parent_code":"799"},"27832":{"name":"Xã Hậu Thạnh Tây","type":"xa","slug":"xa-hau-thanh-tay","name_with_type":"Xã Hậu Thạnh Tây","path":"Xã Hậu Thạnh Tây, Huyện Tân Thạnh, Tỉnh Long An","path_with_type":"Xã Hậu Thạnh Tây, Huyện Tân Thạnh, Tỉnh Long An","code":"27832","parent_code":"799"},"27835":{"name":"Xã Nhơn Hòa Lập","type":"xa","slug":"xa-nhon-hoa-lap","name_with_type":"Xã Nhơn Hòa Lập","path":"Xã Nhơn Hòa Lập, Huyện Tân Thạnh, Tỉnh Long An","path_with_type":"Xã Nhơn Hòa Lập, Huyện Tân Thạnh, Tỉnh Long An","code":"27835","parent_code":"799"},"27838":{"name":"Xã Tân Lập","type":"xa","slug":"xa-tan-lap","name_with_type":"Xã Tân Lập","path":"Xã Tân Lập, Huyện Tân Thạnh, Tỉnh Long An","path_with_type":"Xã Tân Lập, Huyện Tân Thạnh, Tỉnh Long An","code":"27838","parent_code":"799"},"27841":{"name":"Xã Hậu Thạnh Đông","type":"xa","slug":"xa-hau-thanh-dong","name_with_type":"Xã Hậu Thạnh Đông","path":"Xã Hậu Thạnh Đông, Huyện Tân Thạnh, Tỉnh Long An","path_with_type":"Xã Hậu Thạnh Đông, Huyện Tân Thạnh, Tỉnh Long An","code":"27841","parent_code":"799"},"27844":{"name":"Xã Nhơn Hoà","type":"xa","slug":"xa-nhon-hoa","name_with_type":"Xã Nhơn Hoà","path":"Xã Nhơn Hoà, Huyện Tân Thạnh, Tỉnh Long An","path_with_type":"Xã Nhơn Hoà, Huyện Tân Thạnh, Tỉnh Long An","code":"27844","parent_code":"799"},"27847":{"name":"Xã Kiến Bình","type":"xa","slug":"xa-kien-binh","name_with_type":"Xã Kiến Bình","path":"Xã Kiến Bình, Huyện Tân Thạnh, Tỉnh Long An","path_with_type":"Xã Kiến Bình, Huyện Tân Thạnh, Tỉnh Long An","code":"27847","parent_code":"799"},"27850":{"name":"Xã Tân Thành","type":"xa","slug":"xa-tan-thanh","name_with_type":"Xã Tân Thành","path":"Xã Tân Thành, Huyện Tân Thạnh, Tỉnh Long An","path_with_type":"Xã Tân Thành, Huyện Tân Thạnh, Tỉnh Long An","code":"27850","parent_code":"799"},"27853":{"name":"Xã Tân Bình","type":"xa","slug":"xa-tan-binh","name_with_type":"Xã Tân Bình","path":"Xã Tân Bình, Huyện Tân Thạnh, Tỉnh Long An","path_with_type":"Xã Tân Bình, Huyện Tân Thạnh, Tỉnh Long An","code":"27853","parent_code":"799"},"27856":{"name":"Xã Tân Ninh","type":"xa","slug":"xa-tan-ninh","name_with_type":"Xã Tân Ninh","path":"Xã Tân Ninh, Huyện Tân Thạnh, Tỉnh Long An","path_with_type":"Xã Tân Ninh, Huyện Tân Thạnh, Tỉnh Long An","code":"27856","parent_code":"799"},"27859":{"name":"Xã Nhơn Ninh","type":"xa","slug":"xa-nhon-ninh","name_with_type":"Xã Nhơn Ninh","path":"Xã Nhơn Ninh, Huyện Tân Thạnh, Tỉnh Long An","path_with_type":"Xã Nhơn Ninh, Huyện Tân Thạnh, Tỉnh Long An","code":"27859","parent_code":"799"},"27862":{"name":"Xã Tân Hòa","type":"xa","slug":"xa-tan-hoa","name_with_type":"Xã Tân Hòa","path":"Xã Tân Hòa, Huyện Tân Thạnh, Tỉnh Long An","path_with_type":"Xã Tân Hòa, Huyện Tân Thạnh, Tỉnh Long An","code":"27862","parent_code":"799"},"27865":{"name":"Thị trấn Thạnh Hóa","type":"thi-tran","slug":"thi-tran-thanh-hoa","name_with_type":"Thị trấn Thạnh Hóa","path":"Thị trấn Thạnh Hóa, Huyện Thạnh Hóa, Tỉnh Long An","path_with_type":"Thị trấn Thạnh Hóa, Huyện Thạnh Hóa, Tỉnh Long An","code":"27865","parent_code":"800"},"27868":{"name":"Xã Tân Hiệp","type":"xa","slug":"xa-tan-hiep","name_with_type":"Xã Tân Hiệp","path":"Xã Tân Hiệp, Huyện Thạnh Hóa, Tỉnh Long An","path_with_type":"Xã Tân Hiệp, Huyện Thạnh Hóa, Tỉnh Long An","code":"27868","parent_code":"800"},"27871":{"name":"Xã Thuận Bình","type":"xa","slug":"xa-thuan-binh","name_with_type":"Xã Thuận Bình","path":"Xã Thuận Bình, Huyện Thạnh Hóa, Tỉnh Long An","path_with_type":"Xã Thuận Bình, Huyện Thạnh Hóa, Tỉnh Long An","code":"27871","parent_code":"800"},"27874":{"name":"Xã Thạnh Phước","type":"xa","slug":"xa-thanh-phuoc","name_with_type":"Xã Thạnh Phước","path":"Xã Thạnh Phước, Huyện Thạnh Hóa, Tỉnh Long An","path_with_type":"Xã Thạnh Phước, Huyện Thạnh Hóa, Tỉnh Long An","code":"27874","parent_code":"800"},"27877":{"name":"Xã Thạnh Phú","type":"xa","slug":"xa-thanh-phu","name_with_type":"Xã Thạnh Phú","path":"Xã Thạnh Phú, Huyện Thạnh Hóa, Tỉnh Long An","path_with_type":"Xã Thạnh Phú, Huyện Thạnh Hóa, Tỉnh Long An","code":"27877","parent_code":"800"},"27880":{"name":"Xã Thuận Nghĩa Hòa","type":"xa","slug":"xa-thuan-nghia-hoa","name_with_type":"Xã Thuận Nghĩa Hòa","path":"Xã Thuận Nghĩa Hòa, Huyện Thạnh Hóa, Tỉnh Long An","path_with_type":"Xã Thuận Nghĩa Hòa, Huyện Thạnh Hóa, Tỉnh Long An","code":"27880","parent_code":"800"},"27883":{"name":"Xã Thủy Đông","type":"xa","slug":"xa-thuy-dong","name_with_type":"Xã Thủy Đông","path":"Xã Thủy Đông, Huyện Thạnh Hóa, Tỉnh Long An","path_with_type":"Xã Thủy Đông, Huyện Thạnh Hóa, Tỉnh Long An","code":"27883","parent_code":"800"},"27886":{"name":"Xã Thủy Tây","type":"xa","slug":"xa-thuy-tay","name_with_type":"Xã Thủy Tây","path":"Xã Thủy Tây, Huyện Thạnh Hóa, Tỉnh Long An","path_with_type":"Xã Thủy Tây, Huyện Thạnh Hóa, Tỉnh Long An","code":"27886","parent_code":"800"},"27889":{"name":"Xã Tân Tây","type":"xa","slug":"xa-tan-tay","name_with_type":"Xã Tân Tây","path":"Xã Tân Tây, Huyện Thạnh Hóa, Tỉnh Long An","path_with_type":"Xã Tân Tây, Huyện Thạnh Hóa, Tỉnh Long An","code":"27889","parent_code":"800"},"27892":{"name":"Xã Tân Đông","type":"xa","slug":"xa-tan-dong","name_with_type":"Xã Tân Đông","path":"Xã Tân Đông, Huyện Thạnh Hóa, Tỉnh Long An","path_with_type":"Xã Tân Đông, Huyện Thạnh Hóa, Tỉnh Long An","code":"27892","parent_code":"800"},"27895":{"name":"Xã Thạnh An","type":"xa","slug":"xa-thanh-an","name_with_type":"Xã Thạnh An","path":"Xã Thạnh An, Huyện Thạnh Hóa, Tỉnh Long An","path_with_type":"Xã Thạnh An, Huyện Thạnh Hóa, Tỉnh Long An","code":"27895","parent_code":"800"},"27898":{"name":"Thị trấn Đông Thành","type":"thi-tran","slug":"thi-tran-dong-thanh","name_with_type":"Thị trấn Đông Thành","path":"Thị trấn Đông Thành, Huyện Đức Huệ, Tỉnh Long An","path_with_type":"Thị trấn Đông Thành, Huyện Đức Huệ, Tỉnh Long An","code":"27898","parent_code":"801"},"27901":{"name":"Xã Mỹ Quý Đông","type":"xa","slug":"xa-my-quy-dong","name_with_type":"Xã Mỹ Quý Đông","path":"Xã Mỹ Quý Đông, Huyện Đức Huệ, Tỉnh Long An","path_with_type":"Xã Mỹ Quý Đông, Huyện Đức Huệ, Tỉnh Long An","code":"27901","parent_code":"801"},"27904":{"name":"Xã Mỹ Thạnh Bắc","type":"xa","slug":"xa-my-thanh-bac","name_with_type":"Xã Mỹ Thạnh Bắc","path":"Xã Mỹ Thạnh Bắc, Huyện Đức Huệ, Tỉnh Long An","path_with_type":"Xã Mỹ Thạnh Bắc, Huyện Đức Huệ, Tỉnh Long An","code":"27904","parent_code":"801"},"27907":{"name":"Xã Mỹ Quý Tây","type":"xa","slug":"xa-my-quy-tay","name_with_type":"Xã Mỹ Quý Tây","path":"Xã Mỹ Quý Tây, Huyện Đức Huệ, Tỉnh Long An","path_with_type":"Xã Mỹ Quý Tây, Huyện Đức Huệ, Tỉnh Long An","code":"27907","parent_code":"801"},"27910":{"name":"Xã Mỹ Thạnh Tây","type":"xa","slug":"xa-my-thanh-tay","name_with_type":"Xã Mỹ Thạnh Tây","path":"Xã Mỹ Thạnh Tây, Huyện Đức Huệ, Tỉnh Long An","path_with_type":"Xã Mỹ Thạnh Tây, Huyện Đức Huệ, Tỉnh Long An","code":"27910","parent_code":"801"},"27913":{"name":"Xã Mỹ Thạnh Đông","type":"xa","slug":"xa-my-thanh-dong","name_with_type":"Xã Mỹ Thạnh Đông","path":"Xã Mỹ Thạnh Đông, Huyện Đức Huệ, Tỉnh Long An","path_with_type":"Xã Mỹ Thạnh Đông, Huyện Đức Huệ, Tỉnh Long An","code":"27913","parent_code":"801"},"27916":{"name":"Xã Bình Thành","type":"xa","slug":"xa-binh-thanh","name_with_type":"Xã Bình Thành","path":"Xã Bình Thành, Huyện Đức Huệ, Tỉnh Long An","path_with_type":"Xã Bình Thành, Huyện Đức Huệ, Tỉnh Long An","code":"27916","parent_code":"801"},"27919":{"name":"Xã Bình Hòa Bắc","type":"xa","slug":"xa-binh-hoa-bac","name_with_type":"Xã Bình Hòa Bắc","path":"Xã Bình Hòa Bắc, Huyện Đức Huệ, Tỉnh Long An","path_with_type":"Xã Bình Hòa Bắc, Huyện Đức Huệ, Tỉnh Long An","code":"27919","parent_code":"801"},"27922":{"name":"Xã Bình Hòa Hưng","type":"xa","slug":"xa-binh-hoa-hung","name_with_type":"Xã Bình Hòa Hưng","path":"Xã Bình Hòa Hưng, Huyện Đức Huệ, Tỉnh Long An","path_with_type":"Xã Bình Hòa Hưng, Huyện Đức Huệ, Tỉnh Long An","code":"27922","parent_code":"801"},"27925":{"name":"Xã Bình Hòa Nam","type":"xa","slug":"xa-binh-hoa-nam","name_with_type":"Xã Bình Hòa Nam","path":"Xã Bình Hòa Nam, Huyện Đức Huệ, Tỉnh Long An","path_with_type":"Xã Bình Hòa Nam, Huyện Đức Huệ, Tỉnh Long An","code":"27925","parent_code":"801"},"27928":{"name":"Xã Mỹ Bình","type":"xa","slug":"xa-my-binh","name_with_type":"Xã Mỹ Bình","path":"Xã Mỹ Bình, Huyện Đức Huệ, Tỉnh Long An","path_with_type":"Xã Mỹ Bình, Huyện Đức Huệ, Tỉnh Long An","code":"27928","parent_code":"801"},"27931":{"name":"Thị trấn Hậu Nghĩa","type":"thi-tran","slug":"thi-tran-hau-nghia","name_with_type":"Thị trấn Hậu Nghĩa","path":"Thị trấn Hậu Nghĩa, Huyện Đức Hòa, Tỉnh Long An","path_with_type":"Thị trấn Hậu Nghĩa, Huyện Đức Hòa, Tỉnh Long An","code":"27931","parent_code":"802"},"27934":{"name":"Thị trấn Hiệp Hòa","type":"thi-tran","slug":"thi-tran-hiep-hoa","name_with_type":"Thị trấn Hiệp Hòa","path":"Thị trấn Hiệp Hòa, Huyện Đức Hòa, Tỉnh Long An","path_with_type":"Thị trấn Hiệp Hòa, Huyện Đức Hòa, Tỉnh Long An","code":"27934","parent_code":"802"},"27937":{"name":"Thị trấn Đức Hòa","type":"thi-tran","slug":"thi-tran-duc-hoa","name_with_type":"Thị trấn Đức Hòa","path":"Thị trấn Đức Hòa, Huyện Đức Hòa, Tỉnh Long An","path_with_type":"Thị trấn Đức Hòa, Huyện Đức Hòa, Tỉnh Long An","code":"27937","parent_code":"802"},"27940":{"name":"Xã Lộc Giang","type":"xa","slug":"xa-loc-giang","name_with_type":"Xã Lộc Giang","path":"Xã Lộc Giang, Huyện Đức Hòa, Tỉnh Long An","path_with_type":"Xã Lộc Giang, Huyện Đức Hòa, Tỉnh Long An","code":"27940","parent_code":"802"},"27943":{"name":"Xã An Ninh Đông","type":"xa","slug":"xa-an-ninh-dong","name_with_type":"Xã An Ninh Đông","path":"Xã An Ninh Đông, Huyện Đức Hòa, Tỉnh Long An","path_with_type":"Xã An Ninh Đông, Huyện Đức Hòa, Tỉnh Long An","code":"27943","parent_code":"802"},"27946":{"name":"Xã An Ninh Tây","type":"xa","slug":"xa-an-ninh-tay","name_with_type":"Xã An Ninh Tây","path":"Xã An Ninh Tây, Huyện Đức Hòa, Tỉnh Long An","path_with_type":"Xã An Ninh Tây, Huyện Đức Hòa, Tỉnh Long An","code":"27946","parent_code":"802"},"27949":{"name":"Xã Tân Mỹ","type":"xa","slug":"xa-tan-my","name_with_type":"Xã Tân Mỹ","path":"Xã Tân Mỹ, Huyện Đức Hòa, Tỉnh Long An","path_with_type":"Xã Tân Mỹ, Huyện Đức Hòa, Tỉnh Long An","code":"27949","parent_code":"802"},"27952":{"name":"Xã Hiệp Hòa","type":"xa","slug":"xa-hiep-hoa","name_with_type":"Xã Hiệp Hòa","path":"Xã Hiệp Hòa, Huyện Đức Hòa, Tỉnh Long An","path_with_type":"Xã Hiệp Hòa, Huyện Đức Hòa, Tỉnh Long An","code":"27952","parent_code":"802"},"27955":{"name":"Xã Đức Lập Thượng","type":"xa","slug":"xa-duc-lap-thuong","name_with_type":"Xã Đức Lập Thượng","path":"Xã Đức Lập Thượng, Huyện Đức Hòa, Tỉnh Long An","path_with_type":"Xã Đức Lập Thượng, Huyện Đức Hòa, Tỉnh Long An","code":"27955","parent_code":"802"},"27958":{"name":"Xã Đức Lập Hạ","type":"xa","slug":"xa-duc-lap-ha","name_with_type":"Xã Đức Lập Hạ","path":"Xã Đức Lập Hạ, Huyện Đức Hòa, Tỉnh Long An","path_with_type":"Xã Đức Lập Hạ, Huyện Đức Hòa, Tỉnh Long An","code":"27958","parent_code":"802"},"27961":{"name":"Xã Tân Phú","type":"xa","slug":"xa-tan-phu","name_with_type":"Xã Tân Phú","path":"Xã Tân Phú, Huyện Đức Hòa, Tỉnh Long An","path_with_type":"Xã Tân Phú, Huyện Đức Hòa, Tỉnh Long An","code":"27961","parent_code":"802"},"27964":{"name":"Xã Mỹ Hạnh Bắc","type":"xa","slug":"xa-my-hanh-bac","name_with_type":"Xã Mỹ Hạnh Bắc","path":"Xã Mỹ Hạnh Bắc, Huyện Đức Hòa, Tỉnh Long An","path_with_type":"Xã Mỹ Hạnh Bắc, Huyện Đức Hòa, Tỉnh Long An","code":"27964","parent_code":"802"},"27967":{"name":"Xã Đức Hòa Thượng","type":"xa","slug":"xa-duc-hoa-thuong","name_with_type":"Xã Đức Hòa Thượng","path":"Xã Đức Hòa Thượng, Huyện Đức Hòa, Tỉnh Long An","path_with_type":"Xã Đức Hòa Thượng, Huyện Đức Hòa, Tỉnh Long An","code":"27967","parent_code":"802"},"27970":{"name":"Xã Hòa Khánh Tây","type":"xa","slug":"xa-hoa-khanh-tay","name_with_type":"Xã Hòa Khánh Tây","path":"Xã Hòa Khánh Tây, Huyện Đức Hòa, Tỉnh Long An","path_with_type":"Xã Hòa Khánh Tây, Huyện Đức Hòa, Tỉnh Long An","code":"27970","parent_code":"802"},"27973":{"name":"Xã Hòa Khánh Đông","type":"xa","slug":"xa-hoa-khanh-dong","name_with_type":"Xã Hòa Khánh Đông","path":"Xã Hòa Khánh Đông, Huyện Đức Hòa, Tỉnh Long An","path_with_type":"Xã Hòa Khánh Đông, Huyện Đức Hòa, Tỉnh Long An","code":"27973","parent_code":"802"},"27976":{"name":"Xã Mỹ Hạnh Nam","type":"xa","slug":"xa-my-hanh-nam","name_with_type":"Xã Mỹ Hạnh Nam","path":"Xã Mỹ Hạnh Nam, Huyện Đức Hòa, Tỉnh Long An","path_with_type":"Xã Mỹ Hạnh Nam, Huyện Đức Hòa, Tỉnh Long An","code":"27976","parent_code":"802"},"27979":{"name":"Xã Hòa Khánh Nam","type":"xa","slug":"xa-hoa-khanh-nam","name_with_type":"Xã Hòa Khánh Nam","path":"Xã Hòa Khánh Nam, Huyện Đức Hòa, Tỉnh Long An","path_with_type":"Xã Hòa Khánh Nam, Huyện Đức Hòa, Tỉnh Long An","code":"27979","parent_code":"802"},"27982":{"name":"Xã Đức Hòa Đông","type":"xa","slug":"xa-duc-hoa-dong","name_with_type":"Xã Đức Hòa Đông","path":"Xã Đức Hòa Đông, Huyện Đức Hòa, Tỉnh Long An","path_with_type":"Xã Đức Hòa Đông, Huyện Đức Hòa, Tỉnh Long An","code":"27982","parent_code":"802"},"27985":{"name":"Xã Đức Hòa Hạ","type":"xa","slug":"xa-duc-hoa-ha","name_with_type":"Xã Đức Hòa Hạ","path":"Xã Đức Hòa Hạ, Huyện Đức Hòa, Tỉnh Long An","path_with_type":"Xã Đức Hòa Hạ, Huyện Đức Hòa, Tỉnh Long An","code":"27985","parent_code":"802"},"27988":{"name":"Xã Hựu Thạnh","type":"xa","slug":"xa-huu-thanh","name_with_type":"Xã Hựu Thạnh","path":"Xã Hựu Thạnh, Huyện Đức Hòa, Tỉnh Long An","path_with_type":"Xã Hựu Thạnh, Huyện Đức Hòa, Tỉnh Long An","code":"27988","parent_code":"802"},"27991":{"name":"Thị trấn Bến Lức","type":"thi-tran","slug":"thi-tran-ben-luc","name_with_type":"Thị trấn Bến Lức","path":"Thị trấn Bến Lức, Huyện Bến Lức, Tỉnh Long An","path_with_type":"Thị trấn Bến Lức, Huyện Bến Lức, Tỉnh Long An","code":"27991","parent_code":"803"},"27994":{"name":"Xã Thạnh Lợi","type":"xa","slug":"xa-thanh-loi","name_with_type":"Xã Thạnh Lợi","path":"Xã Thạnh Lợi, Huyện Bến Lức, Tỉnh Long An","path_with_type":"Xã Thạnh Lợi, Huyện Bến Lức, Tỉnh Long An","code":"27994","parent_code":"803"},"27997":{"name":"Xã Lương Bình","type":"xa","slug":"xa-luong-binh","name_with_type":"Xã Lương Bình","path":"Xã Lương Bình, Huyện Bến Lức, Tỉnh Long An","path_with_type":"Xã Lương Bình, Huyện Bến Lức, Tỉnh Long An","code":"27997","parent_code":"803"},"28000":{"name":"Xã Thạnh Hòa","type":"xa","slug":"xa-thanh-hoa","name_with_type":"Xã Thạnh Hòa","path":"Xã Thạnh Hòa, Huyện Bến Lức, Tỉnh Long An","path_with_type":"Xã Thạnh Hòa, Huyện Bến Lức, Tỉnh Long An","code":"28000","parent_code":"803"},"28003":{"name":"Xã Lương Hòa","type":"xa","slug":"xa-luong-hoa","name_with_type":"Xã Lương Hòa","path":"Xã Lương Hòa, Huyện Bến Lức, Tỉnh Long An","path_with_type":"Xã Lương Hòa, Huyện Bến Lức, Tỉnh Long An","code":"28003","parent_code":"803"},"28009":{"name":"Xã Tân Bửu","type":"xa","slug":"xa-tan-buu","name_with_type":"Xã Tân Bửu","path":"Xã Tân Bửu, Huyện Bến Lức, Tỉnh Long An","path_with_type":"Xã Tân Bửu, Huyện Bến Lức, Tỉnh Long An","code":"28009","parent_code":"803"},"28012":{"name":"Xã An Thạnh","type":"xa","slug":"xa-an-thanh","name_with_type":"Xã An Thạnh","path":"Xã An Thạnh, Huyện Bến Lức, Tỉnh Long An","path_with_type":"Xã An Thạnh, Huyện Bến Lức, Tỉnh Long An","code":"28012","parent_code":"803"},"28015":{"name":"Xã Bình Đức","type":"xa","slug":"xa-binh-duc","name_with_type":"Xã Bình Đức","path":"Xã Bình Đức, Huyện Bến Lức, Tỉnh Long An","path_with_type":"Xã Bình Đức, Huyện Bến Lức, Tỉnh Long An","code":"28015","parent_code":"803"},"28018":{"name":"Xã Mỹ Yên","type":"xa","slug":"xa-my-yen","name_with_type":"Xã Mỹ Yên","path":"Xã Mỹ Yên, Huyện Bến Lức, Tỉnh Long An","path_with_type":"Xã Mỹ Yên, Huyện Bến Lức, Tỉnh Long An","code":"28018","parent_code":"803"},"28021":{"name":"Xã Thanh Phú","type":"xa","slug":"xa-thanh-phu","name_with_type":"Xã Thanh Phú","path":"Xã Thanh Phú, Huyện Bến Lức, Tỉnh Long An","path_with_type":"Xã Thanh Phú, Huyện Bến Lức, Tỉnh Long An","code":"28021","parent_code":"803"},"28024":{"name":"Xã Long Hiệp","type":"xa","slug":"xa-long-hiep","name_with_type":"Xã Long Hiệp","path":"Xã Long Hiệp, Huyện Bến Lức, Tỉnh Long An","path_with_type":"Xã Long Hiệp, Huyện Bến Lức, Tỉnh Long An","code":"28024","parent_code":"803"},"28027":{"name":"Xã Thạnh Đức","type":"xa","slug":"xa-thanh-duc","name_with_type":"Xã Thạnh Đức","path":"Xã Thạnh Đức, Huyện Bến Lức, Tỉnh Long An","path_with_type":"Xã Thạnh Đức, Huyện Bến Lức, Tỉnh Long An","code":"28027","parent_code":"803"},"28030":{"name":"Xã Phước Lợi","type":"xa","slug":"xa-phuoc-loi","name_with_type":"Xã Phước Lợi","path":"Xã Phước Lợi, Huyện Bến Lức, Tỉnh Long An","path_with_type":"Xã Phước Lợi, Huyện Bến Lức, Tỉnh Long An","code":"28030","parent_code":"803"},"28033":{"name":"Xã Nhựt Chánh","type":"xa","slug":"xa-nhut-chanh","name_with_type":"Xã Nhựt Chánh","path":"Xã Nhựt Chánh, Huyện Bến Lức, Tỉnh Long An","path_with_type":"Xã Nhựt Chánh, Huyện Bến Lức, Tỉnh Long An","code":"28033","parent_code":"803"},"28036":{"name":"Thị trấn Thủ Thừa","type":"thi-tran","slug":"thi-tran-thu-thua","name_with_type":"Thị trấn Thủ Thừa","path":"Thị trấn Thủ Thừa, Huyện Thủ Thừa, Tỉnh Long An","path_with_type":"Thị trấn Thủ Thừa, Huyện Thủ Thừa, Tỉnh Long An","code":"28036","parent_code":"804"},"28039":{"name":"Xã Long Thạnh","type":"xa","slug":"xa-long-thanh","name_with_type":"Xã Long Thạnh","path":"Xã Long Thạnh, Huyện Thủ Thừa, Tỉnh Long An","path_with_type":"Xã Long Thạnh, Huyện Thủ Thừa, Tỉnh Long An","code":"28039","parent_code":"804"},"28042":{"name":"Xã Tân Thành","type":"xa","slug":"xa-tan-thanh","name_with_type":"Xã Tân Thành","path":"Xã Tân Thành, Huyện Thủ Thừa, Tỉnh Long An","path_with_type":"Xã Tân Thành, Huyện Thủ Thừa, Tỉnh Long An","code":"28042","parent_code":"804"},"28045":{"name":"Xã Long Thuận","type":"xa","slug":"xa-long-thuan","name_with_type":"Xã Long Thuận","path":"Xã Long Thuận, Huyện Thủ Thừa, Tỉnh Long An","path_with_type":"Xã Long Thuận, Huyện Thủ Thừa, Tỉnh Long An","code":"28045","parent_code":"804"},"28048":{"name":"Xã Mỹ Lạc","type":"xa","slug":"xa-my-lac","name_with_type":"Xã Mỹ Lạc","path":"Xã Mỹ Lạc, Huyện Thủ Thừa, Tỉnh Long An","path_with_type":"Xã Mỹ Lạc, Huyện Thủ Thừa, Tỉnh Long An","code":"28048","parent_code":"804"},"28051":{"name":"Xã Mỹ Thạnh","type":"xa","slug":"xa-my-thanh","name_with_type":"Xã Mỹ Thạnh","path":"Xã Mỹ Thạnh, Huyện Thủ Thừa, Tỉnh Long An","path_with_type":"Xã Mỹ Thạnh, Huyện Thủ Thừa, Tỉnh Long An","code":"28051","parent_code":"804"},"28054":{"name":"Xã Bình An","type":"xa","slug":"xa-binh-an","name_with_type":"Xã Bình An","path":"Xã Bình An, Huyện Thủ Thừa, Tỉnh Long An","path_with_type":"Xã Bình An, Huyện Thủ Thừa, Tỉnh Long An","code":"28054","parent_code":"804"},"28057":{"name":"Xã Nhị Thành","type":"xa","slug":"xa-nhi-thanh","name_with_type":"Xã Nhị Thành","path":"Xã Nhị Thành, Huyện Thủ Thừa, Tỉnh Long An","path_with_type":"Xã Nhị Thành, Huyện Thủ Thừa, Tỉnh Long An","code":"28057","parent_code":"804"},"28060":{"name":"Xã Mỹ An","type":"xa","slug":"xa-my-an","name_with_type":"Xã Mỹ An","path":"Xã Mỹ An, Huyện Thủ Thừa, Tỉnh Long An","path_with_type":"Xã Mỹ An, Huyện Thủ Thừa, Tỉnh Long An","code":"28060","parent_code":"804"},"28063":{"name":"Xã Bình Thạnh","type":"xa","slug":"xa-binh-thanh","name_with_type":"Xã Bình Thạnh","path":"Xã Bình Thạnh, Huyện Thủ Thừa, Tỉnh Long An","path_with_type":"Xã Bình Thạnh, Huyện Thủ Thừa, Tỉnh Long An","code":"28063","parent_code":"804"},"28066":{"name":"Xã Mỹ Phú","type":"xa","slug":"xa-my-phu","name_with_type":"Xã Mỹ Phú","path":"Xã Mỹ Phú, Huyện Thủ Thừa, Tỉnh Long An","path_with_type":"Xã Mỹ Phú, Huyện Thủ Thừa, Tỉnh Long An","code":"28066","parent_code":"804"},"28072":{"name":"Xã Tân Long","type":"xa","slug":"xa-tan-long","name_with_type":"Xã Tân Long","path":"Xã Tân Long, Huyện Thủ Thừa, Tỉnh Long An","path_with_type":"Xã Tân Long, Huyện Thủ Thừa, Tỉnh Long An","code":"28072","parent_code":"804"},"28075":{"name":"Thị trấn Tân Trụ","type":"thi-tran","slug":"thi-tran-tan-tru","name_with_type":"Thị trấn Tân Trụ","path":"Thị trấn Tân Trụ, Huyện Tân Trụ, Tỉnh Long An","path_with_type":"Thị trấn Tân Trụ, Huyện Tân Trụ, Tỉnh Long An","code":"28075","parent_code":"805"},"28078":{"name":"Xã Tân Bình","type":"xa","slug":"xa-tan-binh","name_with_type":"Xã Tân Bình","path":"Xã Tân Bình, Huyện Tân Trụ, Tỉnh Long An","path_with_type":"Xã Tân Bình, Huyện Tân Trụ, Tỉnh Long An","code":"28078","parent_code":"805"},"28084":{"name":"Xã Quê Mỹ Thạnh","type":"xa","slug":"xa-que-my-thanh","name_with_type":"Xã Quê Mỹ Thạnh","path":"Xã Quê Mỹ Thạnh, Huyện Tân Trụ, Tỉnh Long An","path_with_type":"Xã Quê Mỹ Thạnh, Huyện Tân Trụ, Tỉnh Long An","code":"28084","parent_code":"805"},"28087":{"name":"Xã Lạc Tấn","type":"xa","slug":"xa-lac-tan","name_with_type":"Xã Lạc Tấn","path":"Xã Lạc Tấn, Huyện Tân Trụ, Tỉnh Long An","path_with_type":"Xã Lạc Tấn, Huyện Tân Trụ, Tỉnh Long An","code":"28087","parent_code":"805"},"28090":{"name":"Xã Bình Trinh Đông","type":"xa","slug":"xa-binh-trinh-dong","name_with_type":"Xã Bình Trinh Đông","path":"Xã Bình Trinh Đông, Huyện Tân Trụ, Tỉnh Long An","path_with_type":"Xã Bình Trinh Đông, Huyện Tân Trụ, Tỉnh Long An","code":"28090","parent_code":"805"},"28093":{"name":"Xã Tân Phước Tây","type":"xa","slug":"xa-tan-phuoc-tay","name_with_type":"Xã Tân Phước Tây","path":"Xã Tân Phước Tây, Huyện Tân Trụ, Tỉnh Long An","path_with_type":"Xã Tân Phước Tây, Huyện Tân Trụ, Tỉnh Long An","code":"28093","parent_code":"805"},"28096":{"name":"Xã Bình Lãng","type":"xa","slug":"xa-binh-lang","name_with_type":"Xã Bình Lãng","path":"Xã Bình Lãng, Huyện Tân Trụ, Tỉnh Long An","path_with_type":"Xã Bình Lãng, Huyện Tân Trụ, Tỉnh Long An","code":"28096","parent_code":"805"},"28099":{"name":"Xã Bình Tịnh","type":"xa","slug":"xa-binh-tinh","name_with_type":"Xã Bình Tịnh","path":"Xã Bình Tịnh, Huyện Tân Trụ, Tỉnh Long An","path_with_type":"Xã Bình Tịnh, Huyện Tân Trụ, Tỉnh Long An","code":"28099","parent_code":"805"},"28102":{"name":"Xã Đức Tân","type":"xa","slug":"xa-duc-tan","name_with_type":"Xã Đức Tân","path":"Xã Đức Tân, Huyện Tân Trụ, Tỉnh Long An","path_with_type":"Xã Đức Tân, Huyện Tân Trụ, Tỉnh Long An","code":"28102","parent_code":"805"},"28105":{"name":"Xã Nhựt Ninh","type":"xa","slug":"xa-nhut-ninh","name_with_type":"Xã Nhựt Ninh","path":"Xã Nhựt Ninh, Huyện Tân Trụ, Tỉnh Long An","path_with_type":"Xã Nhựt Ninh, Huyện Tân Trụ, Tỉnh Long An","code":"28105","parent_code":"805"},"28108":{"name":"Thị trấn Cần Đước","type":"thi-tran","slug":"thi-tran-can-duoc","name_with_type":"Thị trấn Cần Đước","path":"Thị trấn Cần Đước, Huyện Cần Đước, Tỉnh Long An","path_with_type":"Thị trấn Cần Đước, Huyện Cần Đước, Tỉnh Long An","code":"28108","parent_code":"806"},"28111":{"name":"Xã Long Trạch","type":"xa","slug":"xa-long-trach","name_with_type":"Xã Long Trạch","path":"Xã Long Trạch, Huyện Cần Đước, Tỉnh Long An","path_with_type":"Xã Long Trạch, Huyện Cần Đước, Tỉnh Long An","code":"28111","parent_code":"806"},"28114":{"name":"Xã Long Khê","type":"xa","slug":"xa-long-khe","name_with_type":"Xã Long Khê","path":"Xã Long Khê, Huyện Cần Đước, Tỉnh Long An","path_with_type":"Xã Long Khê, Huyện Cần Đước, Tỉnh Long An","code":"28114","parent_code":"806"},"28117":{"name":"Xã Long Định","type":"xa","slug":"xa-long-dinh","name_with_type":"Xã Long Định","path":"Xã Long Định, Huyện Cần Đước, Tỉnh Long An","path_with_type":"Xã Long Định, Huyện Cần Đước, Tỉnh Long An","code":"28117","parent_code":"806"},"28120":{"name":"Xã Phước Vân","type":"xa","slug":"xa-phuoc-van","name_with_type":"Xã Phước Vân","path":"Xã Phước Vân, Huyện Cần Đước, Tỉnh Long An","path_with_type":"Xã Phước Vân, Huyện Cần Đước, Tỉnh Long An","code":"28120","parent_code":"806"},"28123":{"name":"Xã Long Hòa","type":"xa","slug":"xa-long-hoa","name_with_type":"Xã Long Hòa","path":"Xã Long Hòa, Huyện Cần Đước, Tỉnh Long An","path_with_type":"Xã Long Hòa, Huyện Cần Đước, Tỉnh Long An","code":"28123","parent_code":"806"},"28126":{"name":"Xã Long Cang","type":"xa","slug":"xa-long-cang","name_with_type":"Xã Long Cang","path":"Xã Long Cang, Huyện Cần Đước, Tỉnh Long An","path_with_type":"Xã Long Cang, Huyện Cần Đước, Tỉnh Long An","code":"28126","parent_code":"806"},"28129":{"name":"Xã Long Sơn","type":"xa","slug":"xa-long-son","name_with_type":"Xã Long Sơn","path":"Xã Long Sơn, Huyện Cần Đước, Tỉnh Long An","path_with_type":"Xã Long Sơn, Huyện Cần Đước, Tỉnh Long An","code":"28129","parent_code":"806"},"28132":{"name":"Xã Tân Trạch","type":"xa","slug":"xa-tan-trach","name_with_type":"Xã Tân Trạch","path":"Xã Tân Trạch, Huyện Cần Đước, Tỉnh Long An","path_with_type":"Xã Tân Trạch, Huyện Cần Đước, Tỉnh Long An","code":"28132","parent_code":"806"},"28135":{"name":"Xã Mỹ Lệ","type":"xa","slug":"xa-my-le","name_with_type":"Xã Mỹ Lệ","path":"Xã Mỹ Lệ, Huyện Cần Đước, Tỉnh Long An","path_with_type":"Xã Mỹ Lệ, Huyện Cần Đước, Tỉnh Long An","code":"28135","parent_code":"806"},"28138":{"name":"Xã Tân Lân","type":"xa","slug":"xa-tan-lan","name_with_type":"Xã Tân Lân","path":"Xã Tân Lân, Huyện Cần Đước, Tỉnh Long An","path_with_type":"Xã Tân Lân, Huyện Cần Đước, Tỉnh Long An","code":"28138","parent_code":"806"},"28141":{"name":"Xã Phước Tuy","type":"xa","slug":"xa-phuoc-tuy","name_with_type":"Xã Phước Tuy","path":"Xã Phước Tuy, Huyện Cần Đước, Tỉnh Long An","path_with_type":"Xã Phước Tuy, Huyện Cần Đước, Tỉnh Long An","code":"28141","parent_code":"806"},"28144":{"name":"Xã Long Hựu Đông","type":"xa","slug":"xa-long-huu-dong","name_with_type":"Xã Long Hựu Đông","path":"Xã Long Hựu Đông, Huyện Cần Đước, Tỉnh Long An","path_with_type":"Xã Long Hựu Đông, Huyện Cần Đước, Tỉnh Long An","code":"28144","parent_code":"806"},"28147":{"name":"Xã Tân Ân","type":"xa","slug":"xa-tan-an","name_with_type":"Xã Tân Ân","path":"Xã Tân Ân, Huyện Cần Đước, Tỉnh Long An","path_with_type":"Xã Tân Ân, Huyện Cần Đước, Tỉnh Long An","code":"28147","parent_code":"806"},"28150":{"name":"Xã Phước Đông","type":"xa","slug":"xa-phuoc-dong","name_with_type":"Xã Phước Đông","path":"Xã Phước Đông, Huyện Cần Đước, Tỉnh Long An","path_with_type":"Xã Phước Đông, Huyện Cần Đước, Tỉnh Long An","code":"28150","parent_code":"806"},"28153":{"name":"Xã Long Hựu Tây","type":"xa","slug":"xa-long-huu-tay","name_with_type":"Xã Long Hựu Tây","path":"Xã Long Hựu Tây, Huyện Cần Đước, Tỉnh Long An","path_with_type":"Xã Long Hựu Tây, Huyện Cần Đước, Tỉnh Long An","code":"28153","parent_code":"806"},"28156":{"name":"Xã Tân Chánh","type":"xa","slug":"xa-tan-chanh","name_with_type":"Xã Tân Chánh","path":"Xã Tân Chánh, Huyện Cần Đước, Tỉnh Long An","path_with_type":"Xã Tân Chánh, Huyện Cần Đước, Tỉnh Long An","code":"28156","parent_code":"806"},"28159":{"name":"Thị trấn Cần Giuộc","type":"thi-tran","slug":"thi-tran-can-giuoc","name_with_type":"Thị trấn Cần Giuộc","path":"Thị trấn Cần Giuộc, Huyện Cần Giuộc, Tỉnh Long An","path_with_type":"Thị trấn Cần Giuộc, Huyện Cần Giuộc, Tỉnh Long An","code":"28159","parent_code":"807"},"28162":{"name":"Xã Phước Lý","type":"xa","slug":"xa-phuoc-ly","name_with_type":"Xã Phước Lý","path":"Xã Phước Lý, Huyện Cần Giuộc, Tỉnh Long An","path_with_type":"Xã Phước Lý, Huyện Cần Giuộc, Tỉnh Long An","code":"28162","parent_code":"807"},"28165":{"name":"Xã Long Thượng","type":"xa","slug":"xa-long-thuong","name_with_type":"Xã Long Thượng","path":"Xã Long Thượng, Huyện Cần Giuộc, Tỉnh Long An","path_with_type":"Xã Long Thượng, Huyện Cần Giuộc, Tỉnh Long An","code":"28165","parent_code":"807"},"28168":{"name":"Xã Long Hậu","type":"xa","slug":"xa-long-hau","name_with_type":"Xã Long Hậu","path":"Xã Long Hậu, Huyện Cần Giuộc, Tỉnh Long An","path_with_type":"Xã Long Hậu, Huyện Cần Giuộc, Tỉnh Long An","code":"28168","parent_code":"807"},"28174":{"name":"Xã Phước Hậu","type":"xa","slug":"xa-phuoc-hau","name_with_type":"Xã Phước Hậu","path":"Xã Phước Hậu, Huyện Cần Giuộc, Tỉnh Long An","path_with_type":"Xã Phước Hậu, Huyện Cần Giuộc, Tỉnh Long An","code":"28174","parent_code":"807"},"28177":{"name":"Xã Mỹ Lộc","type":"xa","slug":"xa-my-loc","name_with_type":"Xã Mỹ Lộc","path":"Xã Mỹ Lộc, Huyện Cần Giuộc, Tỉnh Long An","path_with_type":"Xã Mỹ Lộc, Huyện Cần Giuộc, Tỉnh Long An","code":"28177","parent_code":"807"},"28180":{"name":"Xã Phước Lại","type":"xa","slug":"xa-phuoc-lai","name_with_type":"Xã Phước Lại","path":"Xã Phước Lại, Huyện Cần Giuộc, Tỉnh Long An","path_with_type":"Xã Phước Lại, Huyện Cần Giuộc, Tỉnh Long An","code":"28180","parent_code":"807"},"28183":{"name":"Xã Phước Lâm","type":"xa","slug":"xa-phuoc-lam","name_with_type":"Xã Phước Lâm","path":"Xã Phước Lâm, Huyện Cần Giuộc, Tỉnh Long An","path_with_type":"Xã Phước Lâm, Huyện Cần Giuộc, Tỉnh Long An","code":"28183","parent_code":"807"},"28189":{"name":"Xã Thuận Thành","type":"xa","slug":"xa-thuan-thanh","name_with_type":"Xã Thuận Thành","path":"Xã Thuận Thành, Huyện Cần Giuộc, Tỉnh Long An","path_with_type":"Xã Thuận Thành, Huyện Cần Giuộc, Tỉnh Long An","code":"28189","parent_code":"807"},"28192":{"name":"Xã Phước Vĩnh Tây","type":"xa","slug":"xa-phuoc-vinh-tay","name_with_type":"Xã Phước Vĩnh Tây","path":"Xã Phước Vĩnh Tây, Huyện Cần Giuộc, Tỉnh Long An","path_with_type":"Xã Phước Vĩnh Tây, Huyện Cần Giuộc, Tỉnh Long An","code":"28192","parent_code":"807"},"28195":{"name":"Xã Phước Vĩnh Đông","type":"xa","slug":"xa-phuoc-vinh-dong","name_with_type":"Xã Phước Vĩnh Đông","path":"Xã Phước Vĩnh Đông, Huyện Cần Giuộc, Tỉnh Long An","path_with_type":"Xã Phước Vĩnh Đông, Huyện Cần Giuộc, Tỉnh Long An","code":"28195","parent_code":"807"},"28198":{"name":"Xã Long An","type":"xa","slug":"xa-long-an","name_with_type":"Xã Long An","path":"Xã Long An, Huyện Cần Giuộc, Tỉnh Long An","path_with_type":"Xã Long An, Huyện Cần Giuộc, Tỉnh Long An","code":"28198","parent_code":"807"},"28201":{"name":"Xã Long Phụng","type":"xa","slug":"xa-long-phung","name_with_type":"Xã Long Phụng","path":"Xã Long Phụng, Huyện Cần Giuộc, Tỉnh Long An","path_with_type":"Xã Long Phụng, Huyện Cần Giuộc, Tỉnh Long An","code":"28201","parent_code":"807"},"28204":{"name":"Xã Đông Thạnh","type":"xa","slug":"xa-dong-thanh","name_with_type":"Xã Đông Thạnh","path":"Xã Đông Thạnh, Huyện Cần Giuộc, Tỉnh Long An","path_with_type":"Xã Đông Thạnh, Huyện Cần Giuộc, Tỉnh Long An","code":"28204","parent_code":"807"},"28207":{"name":"Xã Tân Tập","type":"xa","slug":"xa-tan-tap","name_with_type":"Xã Tân Tập","path":"Xã Tân Tập, Huyện Cần Giuộc, Tỉnh Long An","path_with_type":"Xã Tân Tập, Huyện Cần Giuộc, Tỉnh Long An","code":"28207","parent_code":"807"},"28210":{"name":"Thị trấn Tầm Vu","type":"thi-tran","slug":"thi-tran-tam-vu","name_with_type":"Thị trấn Tầm Vu","path":"Thị trấn Tầm Vu, Huyện Châu Thành, Tỉnh Long An","path_with_type":"Thị trấn Tầm Vu, Huyện Châu Thành, Tỉnh Long An","code":"28210","parent_code":"808"},"28213":{"name":"Xã Bình Quới","type":"xa","slug":"xa-binh-quoi","name_with_type":"Xã Bình Quới","path":"Xã Bình Quới, Huyện Châu Thành, Tỉnh Long An","path_with_type":"Xã Bình Quới, Huyện Châu Thành, Tỉnh Long An","code":"28213","parent_code":"808"},"28216":{"name":"Xã Hòa Phú","type":"xa","slug":"xa-hoa-phu","name_with_type":"Xã Hòa Phú","path":"Xã Hòa Phú, Huyện Châu Thành, Tỉnh Long An","path_with_type":"Xã Hòa Phú, Huyện Châu Thành, Tỉnh Long An","code":"28216","parent_code":"808"},"28219":{"name":"Xã Phú Ngãi Trị","type":"xa","slug":"xa-phu-ngai-tri","name_with_type":"Xã Phú Ngãi Trị","path":"Xã Phú Ngãi Trị, Huyện Châu Thành, Tỉnh Long An","path_with_type":"Xã Phú Ngãi Trị, Huyện Châu Thành, Tỉnh Long An","code":"28219","parent_code":"808"},"28222":{"name":"Xã Vĩnh Công","type":"xa","slug":"xa-vinh-cong","name_with_type":"Xã Vĩnh Công","path":"Xã Vĩnh Công, Huyện Châu Thành, Tỉnh Long An","path_with_type":"Xã Vĩnh Công, Huyện Châu Thành, Tỉnh Long An","code":"28222","parent_code":"808"},"28225":{"name":"Xã Thuận Mỹ","type":"xa","slug":"xa-thuan-my","name_with_type":"Xã Thuận Mỹ","path":"Xã Thuận Mỹ, Huyện Châu Thành, Tỉnh Long An","path_with_type":"Xã Thuận Mỹ, Huyện Châu Thành, Tỉnh Long An","code":"28225","parent_code":"808"},"28228":{"name":"Xã Hiệp Thạnh","type":"xa","slug":"xa-hiep-thanh","name_with_type":"Xã Hiệp Thạnh","path":"Xã Hiệp Thạnh, Huyện Châu Thành, Tỉnh Long An","path_with_type":"Xã Hiệp Thạnh, Huyện Châu Thành, Tỉnh Long An","code":"28228","parent_code":"808"},"28231":{"name":"Xã Phước Tân Hưng","type":"xa","slug":"xa-phuoc-tan-hung","name_with_type":"Xã Phước Tân Hưng","path":"Xã Phước Tân Hưng, Huyện Châu Thành, Tỉnh Long An","path_with_type":"Xã Phước Tân Hưng, Huyện Châu Thành, Tỉnh Long An","code":"28231","parent_code":"808"},"28234":{"name":"Xã Thanh Phú Long","type":"xa","slug":"xa-thanh-phu-long","name_with_type":"Xã Thanh Phú Long","path":"Xã Thanh Phú Long, Huyện Châu Thành, Tỉnh Long An","path_with_type":"Xã Thanh Phú Long, Huyện Châu Thành, Tỉnh Long An","code":"28234","parent_code":"808"},"28237":{"name":"Xã Dương Xuân Hội","type":"xa","slug":"xa-duong-xuan-hoi","name_with_type":"Xã Dương Xuân Hội","path":"Xã Dương Xuân Hội, Huyện Châu Thành, Tỉnh Long An","path_with_type":"Xã Dương Xuân Hội, Huyện Châu Thành, Tỉnh Long An","code":"28237","parent_code":"808"},"28240":{"name":"Xã An Lục Long","type":"xa","slug":"xa-an-luc-long","name_with_type":"Xã An Lục Long","path":"Xã An Lục Long, Huyện Châu Thành, Tỉnh Long An","path_with_type":"Xã An Lục Long, Huyện Châu Thành, Tỉnh Long An","code":"28240","parent_code":"808"},"28243":{"name":"Xã Long Trì","type":"xa","slug":"xa-long-tri","name_with_type":"Xã Long Trì","path":"Xã Long Trì, Huyện Châu Thành, Tỉnh Long An","path_with_type":"Xã Long Trì, Huyện Châu Thành, Tỉnh Long An","code":"28243","parent_code":"808"},"28246":{"name":"Xã Thanh Vĩnh Đông","type":"xa","slug":"xa-thanh-vinh-dong","name_with_type":"Xã Thanh Vĩnh Đông","path":"Xã Thanh Vĩnh Đông, Huyện Châu Thành, Tỉnh Long An","path_with_type":"Xã Thanh Vĩnh Đông, Huyện Châu Thành, Tỉnh Long An","code":"28246","parent_code":"808"},"28249":{"name":"Phường 5","type":"phuong","slug":"phuong-5","name_with_type":"Phường 5","path":"Phường 5, Thành phố Mỹ Tho, Tỉnh Tiền Giang","path_with_type":"Phường 5, Thành phố Mỹ Tho, Tỉnh Tiền Giang","code":"28249","parent_code":"815"},"28252":{"name":"Phường 4","type":"phuong","slug":"phuong-4","name_with_type":"Phường 4","path":"Phường 4, Thành phố Mỹ Tho, Tỉnh Tiền Giang","path_with_type":"Phường 4, Thành phố Mỹ Tho, Tỉnh Tiền Giang","code":"28252","parent_code":"815"},"28261":{"name":"Phường 1","type":"phuong","slug":"phuong-1","name_with_type":"Phường 1","path":"Phường 1, Thành phố Mỹ Tho, Tỉnh Tiền Giang","path_with_type":"Phường 1, Thành phố Mỹ Tho, Tỉnh Tiền Giang","code":"28261","parent_code":"815"},"28264":{"name":"Phường 2","type":"phuong","slug":"phuong-2","name_with_type":"Phường 2","path":"Phường 2, Thành phố Mỹ Tho, Tỉnh Tiền Giang","path_with_type":"Phường 2, Thành phố Mỹ Tho, Tỉnh Tiền Giang","code":"28264","parent_code":"815"},"28270":{"name":"Phường 6","type":"phuong","slug":"phuong-6","name_with_type":"Phường 6","path":"Phường 6, Thành phố Mỹ Tho, Tỉnh Tiền Giang","path_with_type":"Phường 6, Thành phố Mỹ Tho, Tỉnh Tiền Giang","code":"28270","parent_code":"815"},"28273":{"name":"Phường 9","type":"phuong","slug":"phuong-9","name_with_type":"Phường 9","path":"Phường 9, Thành phố Mỹ Tho, Tỉnh Tiền Giang","path_with_type":"Phường 9, Thành phố Mỹ Tho, Tỉnh Tiền Giang","code":"28273","parent_code":"815"},"28276":{"name":"Phường 10","type":"phuong","slug":"phuong-10","name_with_type":"Phường 10","path":"Phường 10, Thành phố Mỹ Tho, Tỉnh Tiền Giang","path_with_type":"Phường 10, Thành phố Mỹ Tho, Tỉnh Tiền Giang","code":"28276","parent_code":"815"},"28279":{"name":"Phường Tân Long","type":"phuong","slug":"phuong-tan-long","name_with_type":"Phường Tân Long","path":"Phường Tân Long, Thành phố Mỹ Tho, Tỉnh Tiền Giang","path_with_type":"Phường Tân Long, Thành phố Mỹ Tho, Tỉnh Tiền Giang","code":"28279","parent_code":"815"},"28282":{"name":"Xã Đạo Thạnh","type":"xa","slug":"xa-dao-thanh","name_with_type":"Xã Đạo Thạnh","path":"Xã Đạo Thạnh, Thành phố Mỹ Tho, Tỉnh Tiền Giang","path_with_type":"Xã Đạo Thạnh, Thành phố Mỹ Tho, Tỉnh Tiền Giang","code":"28282","parent_code":"815"},"28285":{"name":"Xã Trung An","type":"xa","slug":"xa-trung-an","name_with_type":"Xã Trung An","path":"Xã Trung An, Thành phố Mỹ Tho, Tỉnh Tiền Giang","path_with_type":"Xã Trung An, Thành phố Mỹ Tho, Tỉnh Tiền Giang","code":"28285","parent_code":"815"},"28288":{"name":"Xã Mỹ Phong","type":"xa","slug":"xa-my-phong","name_with_type":"Xã Mỹ Phong","path":"Xã Mỹ Phong, Thành phố Mỹ Tho, Tỉnh Tiền Giang","path_with_type":"Xã Mỹ Phong, Thành phố Mỹ Tho, Tỉnh Tiền Giang","code":"28288","parent_code":"815"},"28291":{"name":"Xã Tân Mỹ Chánh","type":"xa","slug":"xa-tan-my-chanh","name_with_type":"Xã Tân Mỹ Chánh","path":"Xã Tân Mỹ Chánh, Thành phố Mỹ Tho, Tỉnh Tiền Giang","path_with_type":"Xã Tân Mỹ Chánh, Thành phố Mỹ Tho, Tỉnh Tiền Giang","code":"28291","parent_code":"815"},"28297":{"name":"Phường 2","type":"phuong","slug":"phuong-2","name_with_type":"Phường 2","path":"Phường 2, Thành phố Gò Công, Tỉnh Tiền Giang","path_with_type":"Phường 2, Thành phố Gò Công, Tỉnh Tiền Giang","code":"28297","parent_code":"816"},"28300":{"name":"Phường 1","type":"phuong","slug":"phuong-1","name_with_type":"Phường 1","path":"Phường 1, Thành phố Gò Công, Tỉnh Tiền Giang","path_with_type":"Phường 1, Thành phố Gò Công, Tỉnh Tiền Giang","code":"28300","parent_code":"816"},"28306":{"name":"Phường 5","type":"phuong","slug":"phuong-5","name_with_type":"Phường 5","path":"Phường 5, Thành phố Gò Công, Tỉnh Tiền Giang","path_with_type":"Phường 5, Thành phố Gò Công, Tỉnh Tiền Giang","code":"28306","parent_code":"816"},"28309":{"name":"Phường Long Hưng","type":"phuong","slug":"phuong-long-hung","name_with_type":"Phường Long Hưng","path":"Phường Long Hưng, Thành phố Gò Công, Tỉnh Tiền Giang","path_with_type":"Phường Long Hưng, Thành phố Gò Công, Tỉnh Tiền Giang","code":"28309","parent_code":"816"},"28312":{"name":"Phường Long Thuận","type":"phuong","slug":"phuong-long-thuan","name_with_type":"Phường Long Thuận","path":"Phường Long Thuận, Thành phố Gò Công, Tỉnh Tiền Giang","path_with_type":"Phường Long Thuận, Thành phố Gò Công, Tỉnh Tiền Giang","code":"28312","parent_code":"816"},"28315":{"name":"Phường Long Chánh","type":"phuong","slug":"phuong-long-chanh","name_with_type":"Phường Long Chánh","path":"Phường Long Chánh, Thành phố Gò Công, Tỉnh Tiền Giang","path_with_type":"Phường Long Chánh, Thành phố Gò Công, Tỉnh Tiền Giang","code":"28315","parent_code":"816"},"28318":{"name":"Phường Long Hòa","type":"phuong","slug":"phuong-long-hoa","name_with_type":"Phường Long Hòa","path":"Phường Long Hòa, Thành phố Gò Công, Tỉnh Tiền Giang","path_with_type":"Phường Long Hòa, Thành phố Gò Công, Tỉnh Tiền Giang","code":"28318","parent_code":"816"},"28321":{"name":"Thị trấn Mỹ Phước","type":"thi-tran","slug":"thi-tran-my-phuoc","name_with_type":"Thị trấn Mỹ Phước","path":"Thị trấn Mỹ Phước, Huyện Tân Phước, Tỉnh Tiền Giang","path_with_type":"Thị trấn Mỹ Phước, Huyện Tân Phước, Tỉnh Tiền Giang","code":"28321","parent_code":"818"},"28324":{"name":"Xã Tân Hòa Đông","type":"xa","slug":"xa-tan-hoa-dong","name_with_type":"Xã Tân Hòa Đông","path":"Xã Tân Hòa Đông, Huyện Tân Phước, Tỉnh Tiền Giang","path_with_type":"Xã Tân Hòa Đông, Huyện Tân Phước, Tỉnh Tiền Giang","code":"28324","parent_code":"818"},"28327":{"name":"Xã Thạnh Tân","type":"xa","slug":"xa-thanh-tan","name_with_type":"Xã Thạnh Tân","path":"Xã Thạnh Tân, Huyện Tân Phước, Tỉnh Tiền Giang","path_with_type":"Xã Thạnh Tân, Huyện Tân Phước, Tỉnh Tiền Giang","code":"28327","parent_code":"818"},"28330":{"name":"Xã Thạnh Mỹ","type":"xa","slug":"xa-thanh-my","name_with_type":"Xã Thạnh Mỹ","path":"Xã Thạnh Mỹ, Huyện Tân Phước, Tỉnh Tiền Giang","path_with_type":"Xã Thạnh Mỹ, Huyện Tân Phước, Tỉnh Tiền Giang","code":"28330","parent_code":"818"},"28333":{"name":"Xã Thạnh Hoà","type":"xa","slug":"xa-thanh-hoa","name_with_type":"Xã Thạnh Hoà","path":"Xã Thạnh Hoà, Huyện Tân Phước, Tỉnh Tiền Giang","path_with_type":"Xã Thạnh Hoà, Huyện Tân Phước, Tỉnh Tiền Giang","code":"28333","parent_code":"818"},"28336":{"name":"Xã Phú Mỹ","type":"xa","slug":"xa-phu-my","name_with_type":"Xã Phú Mỹ","path":"Xã Phú Mỹ, Huyện Tân Phước, Tỉnh Tiền Giang","path_with_type":"Xã Phú Mỹ, Huyện Tân Phước, Tỉnh Tiền Giang","code":"28336","parent_code":"818"},"28339":{"name":"Xã Tân Hòa Thành","type":"xa","slug":"xa-tan-hoa-thanh","name_with_type":"Xã Tân Hòa Thành","path":"Xã Tân Hòa Thành, Huyện Tân Phước, Tỉnh Tiền Giang","path_with_type":"Xã Tân Hòa Thành, Huyện Tân Phước, Tỉnh Tiền Giang","code":"28339","parent_code":"818"},"28342":{"name":"Xã Hưng Thạnh","type":"xa","slug":"xa-hung-thanh","name_with_type":"Xã Hưng Thạnh","path":"Xã Hưng Thạnh, Huyện Tân Phước, Tỉnh Tiền Giang","path_with_type":"Xã Hưng Thạnh, Huyện Tân Phước, Tỉnh Tiền Giang","code":"28342","parent_code":"818"},"28345":{"name":"Xã Tân Lập 1","type":"xa","slug":"xa-tan-lap-1","name_with_type":"Xã Tân Lập 1","path":"Xã Tân Lập 1, Huyện Tân Phước, Tỉnh Tiền Giang","path_with_type":"Xã Tân Lập 1, Huyện Tân Phước, Tỉnh Tiền Giang","code":"28345","parent_code":"818"},"28348":{"name":"Xã Tân Hòa Tây","type":"xa","slug":"xa-tan-hoa-tay","name_with_type":"Xã Tân Hòa Tây","path":"Xã Tân Hòa Tây, Huyện Tân Phước, Tỉnh Tiền Giang","path_with_type":"Xã Tân Hòa Tây, Huyện Tân Phước, Tỉnh Tiền Giang","code":"28348","parent_code":"818"},"28354":{"name":"Xã Tân Lập 2","type":"xa","slug":"xa-tan-lap-2","name_with_type":"Xã Tân Lập 2","path":"Xã Tân Lập 2, Huyện Tân Phước, Tỉnh Tiền Giang","path_with_type":"Xã Tân Lập 2, Huyện Tân Phước, Tỉnh Tiền Giang","code":"28354","parent_code":"818"},"28357":{"name":"Xã Phước Lập","type":"xa","slug":"xa-phuoc-lap","name_with_type":"Xã Phước Lập","path":"Xã Phước Lập, Huyện Tân Phước, Tỉnh Tiền Giang","path_with_type":"Xã Phước Lập, Huyện Tân Phước, Tỉnh Tiền Giang","code":"28357","parent_code":"818"},"28360":{"name":"Thị trấn Cái Bè","type":"thi-tran","slug":"thi-tran-cai-be","name_with_type":"Thị trấn Cái Bè","path":"Thị trấn Cái Bè, Huyện Cái Bè, Tỉnh Tiền Giang","path_with_type":"Thị trấn Cái Bè, Huyện Cái Bè, Tỉnh Tiền Giang","code":"28360","parent_code":"819"},"28363":{"name":"Xã Hậu Mỹ Bắc B","type":"xa","slug":"xa-hau-my-bac-b","name_with_type":"Xã Hậu Mỹ Bắc B","path":"Xã Hậu Mỹ Bắc B, Huyện Cái Bè, Tỉnh Tiền Giang","path_with_type":"Xã Hậu Mỹ Bắc B, Huyện Cái Bè, Tỉnh Tiền Giang","code":"28363","parent_code":"819"},"28366":{"name":"Xã Hậu Mỹ Bắc A","type":"xa","slug":"xa-hau-my-bac-a","name_with_type":"Xã Hậu Mỹ Bắc A","path":"Xã Hậu Mỹ Bắc A, Huyện Cái Bè, Tỉnh Tiền Giang","path_with_type":"Xã Hậu Mỹ Bắc A, Huyện Cái Bè, Tỉnh Tiền Giang","code":"28366","parent_code":"819"},"28369":{"name":"Xã Mỹ Trung","type":"xa","slug":"xa-my-trung","name_with_type":"Xã Mỹ Trung","path":"Xã Mỹ Trung, Huyện Cái Bè, Tỉnh Tiền Giang","path_with_type":"Xã Mỹ Trung, Huyện Cái Bè, Tỉnh Tiền Giang","code":"28369","parent_code":"819"},"28372":{"name":"Xã Hậu Mỹ Trinh","type":"xa","slug":"xa-hau-my-trinh","name_with_type":"Xã Hậu Mỹ Trinh","path":"Xã Hậu Mỹ Trinh, Huyện Cái Bè, Tỉnh Tiền Giang","path_with_type":"Xã Hậu Mỹ Trinh, Huyện Cái Bè, Tỉnh Tiền Giang","code":"28372","parent_code":"819"},"28375":{"name":"Xã Hậu Mỹ Phú","type":"xa","slug":"xa-hau-my-phu","name_with_type":"Xã Hậu Mỹ Phú","path":"Xã Hậu Mỹ Phú, Huyện Cái Bè, Tỉnh Tiền Giang","path_with_type":"Xã Hậu Mỹ Phú, Huyện Cái Bè, Tỉnh Tiền Giang","code":"28375","parent_code":"819"},"28378":{"name":"Xã Mỹ Tân","type":"xa","slug":"xa-my-tan","name_with_type":"Xã Mỹ Tân","path":"Xã Mỹ Tân, Huyện Cái Bè, Tỉnh Tiền Giang","path_with_type":"Xã Mỹ Tân, Huyện Cái Bè, Tỉnh Tiền Giang","code":"28378","parent_code":"819"},"28381":{"name":"Xã Mỹ Lợi B","type":"xa","slug":"xa-my-loi-b","name_with_type":"Xã Mỹ Lợi B","path":"Xã Mỹ Lợi B, Huyện Cái Bè, Tỉnh Tiền Giang","path_with_type":"Xã Mỹ Lợi B, Huyện Cái Bè, Tỉnh Tiền Giang","code":"28381","parent_code":"819"},"28384":{"name":"Xã Thiện Trung","type":"xa","slug":"xa-thien-trung","name_with_type":"Xã Thiện Trung","path":"Xã Thiện Trung, Huyện Cái Bè, Tỉnh Tiền Giang","path_with_type":"Xã Thiện Trung, Huyện Cái Bè, Tỉnh Tiền Giang","code":"28384","parent_code":"819"},"28387":{"name":"Xã Mỹ Hội","type":"xa","slug":"xa-my-hoi","name_with_type":"Xã Mỹ Hội","path":"Xã Mỹ Hội, Huyện Cái Bè, Tỉnh Tiền Giang","path_with_type":"Xã Mỹ Hội, Huyện Cái Bè, Tỉnh Tiền Giang","code":"28387","parent_code":"819"},"28390":{"name":"Xã An Cư","type":"xa","slug":"xa-an-cu","name_with_type":"Xã An Cư","path":"Xã An Cư, Huyện Cái Bè, Tỉnh Tiền Giang","path_with_type":"Xã An Cư, Huyện Cái Bè, Tỉnh Tiền Giang","code":"28390","parent_code":"819"},"28393":{"name":"Xã Hậu Thành","type":"xa","slug":"xa-hau-thanh","name_with_type":"Xã Hậu Thành","path":"Xã Hậu Thành, Huyện Cái Bè, Tỉnh Tiền Giang","path_with_type":"Xã Hậu Thành, Huyện Cái Bè, Tỉnh Tiền Giang","code":"28393","parent_code":"819"},"28396":{"name":"Xã Mỹ Lợi A","type":"xa","slug":"xa-my-loi-a","name_with_type":"Xã Mỹ Lợi A","path":"Xã Mỹ Lợi A, Huyện Cái Bè, Tỉnh Tiền Giang","path_with_type":"Xã Mỹ Lợi A, Huyện Cái Bè, Tỉnh Tiền Giang","code":"28396","parent_code":"819"},"28399":{"name":"Xã Hòa Khánh","type":"xa","slug":"xa-hoa-khanh","name_with_type":"Xã Hòa Khánh","path":"Xã Hòa Khánh, Huyện Cái Bè, Tỉnh Tiền Giang","path_with_type":"Xã Hòa Khánh, Huyện Cái Bè, Tỉnh Tiền Giang","code":"28399","parent_code":"819"},"28402":{"name":"Xã Thiện Trí","type":"xa","slug":"xa-thien-tri","name_with_type":"Xã Thiện Trí","path":"Xã Thiện Trí, Huyện Cái Bè, Tỉnh Tiền Giang","path_with_type":"Xã Thiện Trí, Huyện Cái Bè, Tỉnh Tiền Giang","code":"28402","parent_code":"819"},"28405":{"name":"Xã Mỹ Đức Đông","type":"xa","slug":"xa-my-duc-dong","name_with_type":"Xã Mỹ Đức Đông","path":"Xã Mỹ Đức Đông, Huyện Cái Bè, Tỉnh Tiền Giang","path_with_type":"Xã Mỹ Đức Đông, Huyện Cái Bè, Tỉnh Tiền Giang","code":"28405","parent_code":"819"},"28408":{"name":"Xã Mỹ Đức Tây","type":"xa","slug":"xa-my-duc-tay","name_with_type":"Xã Mỹ Đức Tây","path":"Xã Mỹ Đức Tây, Huyện Cái Bè, Tỉnh Tiền Giang","path_with_type":"Xã Mỹ Đức Tây, Huyện Cái Bè, Tỉnh Tiền Giang","code":"28408","parent_code":"819"},"28411":{"name":"Xã Đông Hòa Hiệp","type":"xa","slug":"xa-dong-hoa-hiep","name_with_type":"Xã Đông Hòa Hiệp","path":"Xã Đông Hòa Hiệp, Huyện Cái Bè, Tỉnh Tiền Giang","path_with_type":"Xã Đông Hòa Hiệp, Huyện Cái Bè, Tỉnh Tiền Giang","code":"28411","parent_code":"819"},"28414":{"name":"Xã An Thái Đông","type":"xa","slug":"xa-an-thai-dong","name_with_type":"Xã An Thái Đông","path":"Xã An Thái Đông, Huyện Cái Bè, Tỉnh Tiền Giang","path_with_type":"Xã An Thái Đông, Huyện Cái Bè, Tỉnh Tiền Giang","code":"28414","parent_code":"819"},"28417":{"name":"Xã Tân Hưng","type":"xa","slug":"xa-tan-hung","name_with_type":"Xã Tân Hưng","path":"Xã Tân Hưng, Huyện Cái Bè, Tỉnh Tiền Giang","path_with_type":"Xã Tân Hưng, Huyện Cái Bè, Tỉnh Tiền Giang","code":"28417","parent_code":"819"},"28420":{"name":"Xã Mỹ Lương","type":"xa","slug":"xa-my-luong","name_with_type":"Xã Mỹ Lương","path":"Xã Mỹ Lương, Huyện Cái Bè, Tỉnh Tiền Giang","path_with_type":"Xã Mỹ Lương, Huyện Cái Bè, Tỉnh Tiền Giang","code":"28420","parent_code":"819"},"28423":{"name":"Xã Tân Thanh","type":"xa","slug":"xa-tan-thanh","name_with_type":"Xã Tân Thanh","path":"Xã Tân Thanh, Huyện Cái Bè, Tỉnh Tiền Giang","path_with_type":"Xã Tân Thanh, Huyện Cái Bè, Tỉnh Tiền Giang","code":"28423","parent_code":"819"},"28426":{"name":"Xã An Thái Trung","type":"xa","slug":"xa-an-thai-trung","name_with_type":"Xã An Thái Trung","path":"Xã An Thái Trung, Huyện Cái Bè, Tỉnh Tiền Giang","path_with_type":"Xã An Thái Trung, Huyện Cái Bè, Tỉnh Tiền Giang","code":"28426","parent_code":"819"},"28429":{"name":"Xã An Hữu","type":"xa","slug":"xa-an-huu","name_with_type":"Xã An Hữu","path":"Xã An Hữu, Huyện Cái Bè, Tỉnh Tiền Giang","path_with_type":"Xã An Hữu, Huyện Cái Bè, Tỉnh Tiền Giang","code":"28429","parent_code":"819"},"28432":{"name":"Xã Hòa Hưng","type":"xa","slug":"xa-hoa-hung","name_with_type":"Xã Hòa Hưng","path":"Xã Hòa Hưng, Huyện Cái Bè, Tỉnh Tiền Giang","path_with_type":"Xã Hòa Hưng, Huyện Cái Bè, Tỉnh Tiền Giang","code":"28432","parent_code":"819"},"28435":{"name":"Phường 1","type":"phuong","slug":"phuong-1","name_with_type":"Phường 1","path":"Phường 1, Thị xã Cai Lậy, Tỉnh Tiền Giang","path_with_type":"Phường 1, Thị xã Cai Lậy, Tỉnh Tiền Giang","code":"28435","parent_code":"817"},"28436":{"name":"Phường 2","type":"phuong","slug":"phuong-2","name_with_type":"Phường 2","path":"Phường 2, Thị xã Cai Lậy, Tỉnh Tiền Giang","path_with_type":"Phường 2, Thị xã Cai Lậy, Tỉnh Tiền Giang","code":"28436","parent_code":"817"},"28437":{"name":"Phường 3","type":"phuong","slug":"phuong-3","name_with_type":"Phường 3","path":"Phường 3, Thị xã Cai Lậy, Tỉnh Tiền Giang","path_with_type":"Phường 3, Thị xã Cai Lậy, Tỉnh Tiền Giang","code":"28437","parent_code":"817"},"28438":{"name":"Xã Thạnh Lộc","type":"xa","slug":"xa-thanh-loc","name_with_type":"Xã Thạnh Lộc","path":"Xã Thạnh Lộc, Huyện Cai Lậy, Tỉnh Tiền Giang","path_with_type":"Xã Thạnh Lộc, Huyện Cai Lậy, Tỉnh Tiền Giang","code":"28438","parent_code":"820"},"28439":{"name":"Phường 4","type":"phuong","slug":"phuong-4","name_with_type":"Phường 4","path":"Phường 4, Thị xã Cai Lậy, Tỉnh Tiền Giang","path_with_type":"Phường 4, Thị xã Cai Lậy, Tỉnh Tiền Giang","code":"28439","parent_code":"817"},"28440":{"name":"Phường 5","type":"phuong","slug":"phuong-5","name_with_type":"Phường 5","path":"Phường 5, Thị xã Cai Lậy, Tỉnh Tiền Giang","path_with_type":"Phường 5, Thị xã Cai Lậy, Tỉnh Tiền Giang","code":"28440","parent_code":"817"},"28441":{"name":"Xã Mỹ Thành Bắc","type":"xa","slug":"xa-my-thanh-bac","name_with_type":"Xã Mỹ Thành Bắc","path":"Xã Mỹ Thành Bắc, Huyện Cai Lậy, Tỉnh Tiền Giang","path_with_type":"Xã Mỹ Thành Bắc, Huyện Cai Lậy, Tỉnh Tiền Giang","code":"28441","parent_code":"820"},"28444":{"name":"Xã Phú Cường","type":"xa","slug":"xa-phu-cuong","name_with_type":"Xã Phú Cường","path":"Xã Phú Cường, Huyện Cai Lậy, Tỉnh Tiền Giang","path_with_type":"Xã Phú Cường, Huyện Cai Lậy, Tỉnh Tiền Giang","code":"28444","parent_code":"820"},"28447":{"name":"Xã Mỹ Phước Tây","type":"xa","slug":"xa-my-phuoc-tay","name_with_type":"Xã Mỹ Phước Tây","path":"Xã Mỹ Phước Tây, Thị xã Cai Lậy, Tỉnh Tiền Giang","path_with_type":"Xã Mỹ Phước Tây, Thị xã Cai Lậy, Tỉnh Tiền Giang","code":"28447","parent_code":"817"},"28450":{"name":"Xã Mỹ Hạnh Đông","type":"xa","slug":"xa-my-hanh-dong","name_with_type":"Xã Mỹ Hạnh Đông","path":"Xã Mỹ Hạnh Đông, Thị xã Cai Lậy, Tỉnh Tiền Giang","path_with_type":"Xã Mỹ Hạnh Đông, Thị xã Cai Lậy, Tỉnh Tiền Giang","code":"28450","parent_code":"817"},"28453":{"name":"Xã Mỹ Hạnh Trung","type":"xa","slug":"xa-my-hanh-trung","name_with_type":"Xã Mỹ Hạnh Trung","path":"Xã Mỹ Hạnh Trung, Thị xã Cai Lậy, Tỉnh Tiền Giang","path_with_type":"Xã Mỹ Hạnh Trung, Thị xã Cai Lậy, Tỉnh Tiền Giang","code":"28453","parent_code":"817"},"28456":{"name":"Xã Mỹ Thành Nam","type":"xa","slug":"xa-my-thanh-nam","name_with_type":"Xã Mỹ Thành Nam","path":"Xã Mỹ Thành Nam, Huyện Cai Lậy, Tỉnh Tiền Giang","path_with_type":"Xã Mỹ Thành Nam, Huyện Cai Lậy, Tỉnh Tiền Giang","code":"28456","parent_code":"820"},"28459":{"name":"Xã Tân Phú","type":"xa","slug":"xa-tan-phu","name_with_type":"Xã Tân Phú","path":"Xã Tân Phú, Thị xã Cai Lậy, Tỉnh Tiền Giang","path_with_type":"Xã Tân Phú, Thị xã Cai Lậy, Tỉnh Tiền Giang","code":"28459","parent_code":"817"},"28462":{"name":"Xã Tân Bình","type":"xa","slug":"xa-tan-binh","name_with_type":"Xã Tân Bình","path":"Xã Tân Bình, Thị xã Cai Lậy, Tỉnh Tiền Giang","path_with_type":"Xã Tân Bình, Thị xã Cai Lậy, Tỉnh Tiền Giang","code":"28462","parent_code":"817"},"28465":{"name":"Xã Phú Nhuận","type":"xa","slug":"xa-phu-nhuan","name_with_type":"Xã Phú Nhuận","path":"Xã Phú Nhuận, Huyện Cai Lậy, Tỉnh Tiền Giang","path_with_type":"Xã Phú Nhuận, Huyện Cai Lậy, Tỉnh Tiền Giang","code":"28465","parent_code":"820"},"28468":{"name":"Xã Tân Hội","type":"xa","slug":"xa-tan-hoi","name_with_type":"Xã Tân Hội","path":"Xã Tân Hội, Thị xã Cai Lậy, Tỉnh Tiền Giang","path_with_type":"Xã Tân Hội, Thị xã Cai Lậy, Tỉnh Tiền Giang","code":"28468","parent_code":"817"},"28471":{"name":"Thị trấn Bình Phú","type":"thi-tran","slug":"thi-tran-binh-phu","name_with_type":"Thị trấn Bình Phú","path":"Thị trấn Bình Phú, Huyện Cai Lậy, Tỉnh Tiền Giang","path_with_type":"Thị trấn Bình Phú, Huyện Cai Lậy, Tỉnh Tiền Giang","code":"28471","parent_code":"820"},"28474":{"name":"Phường Nhị Mỹ","type":"phuong","slug":"phuong-nhi-my","name_with_type":"Phường Nhị Mỹ","path":"Phường Nhị Mỹ, Thị xã Cai Lậy, Tỉnh Tiền Giang","path_with_type":"Phường Nhị Mỹ, Thị xã Cai Lậy, Tỉnh Tiền Giang","code":"28474","parent_code":"817"},"28477":{"name":"Xã Nhị Quý","type":"xa","slug":"xa-nhi-quy","name_with_type":"Xã Nhị Quý","path":"Xã Nhị Quý, Thị xã Cai Lậy, Tỉnh Tiền Giang","path_with_type":"Xã Nhị Quý, Thị xã Cai Lậy, Tỉnh Tiền Giang","code":"28477","parent_code":"817"},"28480":{"name":"Xã Thanh Hòa","type":"xa","slug":"xa-thanh-hoa","name_with_type":"Xã Thanh Hòa","path":"Xã Thanh Hòa, Thị xã Cai Lậy, Tỉnh Tiền Giang","path_with_type":"Xã Thanh Hòa, Thị xã Cai Lậy, Tỉnh Tiền Giang","code":"28480","parent_code":"817"},"28483":{"name":"Xã Phú Quý","type":"xa","slug":"xa-phu-quy","name_with_type":"Xã Phú Quý","path":"Xã Phú Quý, Thị xã Cai Lậy, Tỉnh Tiền Giang","path_with_type":"Xã Phú Quý, Thị xã Cai Lậy, Tỉnh Tiền Giang","code":"28483","parent_code":"817"},"28486":{"name":"Xã Long Khánh","type":"xa","slug":"xa-long-khanh","name_with_type":"Xã Long Khánh","path":"Xã Long Khánh, Thị xã Cai Lậy, Tỉnh Tiền Giang","path_with_type":"Xã Long Khánh, Thị xã Cai Lậy, Tỉnh Tiền Giang","code":"28486","parent_code":"817"},"28489":{"name":"Xã Cẩm Sơn","type":"xa","slug":"xa-cam-son","name_with_type":"Xã Cẩm Sơn","path":"Xã Cẩm Sơn, Huyện Cai Lậy, Tỉnh Tiền Giang","path_with_type":"Xã Cẩm Sơn, Huyện Cai Lậy, Tỉnh Tiền Giang","code":"28489","parent_code":"820"},"28492":{"name":"Xã Phú An","type":"xa","slug":"xa-phu-an","name_with_type":"Xã Phú An","path":"Xã Phú An, Huyện Cai Lậy, Tỉnh Tiền Giang","path_with_type":"Xã Phú An, Huyện Cai Lậy, Tỉnh Tiền Giang","code":"28492","parent_code":"820"},"28495":{"name":"Xã Mỹ Long","type":"xa","slug":"xa-my-long","name_with_type":"Xã Mỹ Long","path":"Xã Mỹ Long, Huyện Cai Lậy, Tỉnh Tiền Giang","path_with_type":"Xã Mỹ Long, Huyện Cai Lậy, Tỉnh Tiền Giang","code":"28495","parent_code":"820"},"28498":{"name":"Xã Long Tiên","type":"xa","slug":"xa-long-tien","name_with_type":"Xã Long Tiên","path":"Xã Long Tiên, Huyện Cai Lậy, Tỉnh Tiền Giang","path_with_type":"Xã Long Tiên, Huyện Cai Lậy, Tỉnh Tiền Giang","code":"28498","parent_code":"820"},"28501":{"name":"Xã Hiệp Đức","type":"xa","slug":"xa-hiep-duc","name_with_type":"Xã Hiệp Đức","path":"Xã Hiệp Đức, Huyện Cai Lậy, Tỉnh Tiền Giang","path_with_type":"Xã Hiệp Đức, Huyện Cai Lậy, Tỉnh Tiền Giang","code":"28501","parent_code":"820"},"28504":{"name":"Xã Long Trung","type":"xa","slug":"xa-long-trung","name_with_type":"Xã Long Trung","path":"Xã Long Trung, Huyện Cai Lậy, Tỉnh Tiền Giang","path_with_type":"Xã Long Trung, Huyện Cai Lậy, Tỉnh Tiền Giang","code":"28504","parent_code":"820"},"28507":{"name":"Xã Hội Xuân","type":"xa","slug":"xa-hoi-xuan","name_with_type":"Xã Hội Xuân","path":"Xã Hội Xuân, Huyện Cai Lậy, Tỉnh Tiền Giang","path_with_type":"Xã Hội Xuân, Huyện Cai Lậy, Tỉnh Tiền Giang","code":"28507","parent_code":"820"},"28510":{"name":"Xã Tân Phong","type":"xa","slug":"xa-tan-phong","name_with_type":"Xã Tân Phong","path":"Xã Tân Phong, Huyện Cai Lậy, Tỉnh Tiền Giang","path_with_type":"Xã Tân Phong, Huyện Cai Lậy, Tỉnh Tiền Giang","code":"28510","parent_code":"820"},"28513":{"name":"Xã Tam Bình","type":"xa","slug":"xa-tam-binh","name_with_type":"Xã Tam Bình","path":"Xã Tam Bình, Huyện Cai Lậy, Tỉnh Tiền Giang","path_with_type":"Xã Tam Bình, Huyện Cai Lậy, Tỉnh Tiền Giang","code":"28513","parent_code":"820"},"28516":{"name":"Xã Ngũ Hiệp","type":"xa","slug":"xa-ngu-hiep","name_with_type":"Xã Ngũ Hiệp","path":"Xã Ngũ Hiệp, Huyện Cai Lậy, Tỉnh Tiền Giang","path_with_type":"Xã Ngũ Hiệp, Huyện Cai Lậy, Tỉnh Tiền Giang","code":"28516","parent_code":"820"},"28519":{"name":"Thị trấn Tân Hiệp","type":"thi-tran","slug":"thi-tran-tan-hiep","name_with_type":"Thị trấn Tân Hiệp","path":"Thị trấn Tân Hiệp, Huyện Châu Thành, Tỉnh Tiền Giang","path_with_type":"Thị trấn Tân Hiệp, Huyện Châu Thành, Tỉnh Tiền Giang","code":"28519","parent_code":"821"},"28522":{"name":"Xã Tân Hội Đông","type":"xa","slug":"xa-tan-hoi-dong","name_with_type":"Xã Tân Hội Đông","path":"Xã Tân Hội Đông, Huyện Châu Thành, Tỉnh Tiền Giang","path_with_type":"Xã Tân Hội Đông, Huyện Châu Thành, Tỉnh Tiền Giang","code":"28522","parent_code":"821"},"28525":{"name":"Xã Tân Hương","type":"xa","slug":"xa-tan-huong","name_with_type":"Xã Tân Hương","path":"Xã Tân Hương, Huyện Châu Thành, Tỉnh Tiền Giang","path_with_type":"Xã Tân Hương, Huyện Châu Thành, Tỉnh Tiền Giang","code":"28525","parent_code":"821"},"28528":{"name":"Xã Tân Lý Đông","type":"xa","slug":"xa-tan-ly-dong","name_with_type":"Xã Tân Lý Đông","path":"Xã Tân Lý Đông, Huyện Châu Thành, Tỉnh Tiền Giang","path_with_type":"Xã Tân Lý Đông, Huyện Châu Thành, Tỉnh Tiền Giang","code":"28528","parent_code":"821"},"28534":{"name":"Xã Thân Cửu Nghĩa","type":"xa","slug":"xa-than-cuu-nghia","name_with_type":"Xã Thân Cửu Nghĩa","path":"Xã Thân Cửu Nghĩa, Huyện Châu Thành, Tỉnh Tiền Giang","path_with_type":"Xã Thân Cửu Nghĩa, Huyện Châu Thành, Tỉnh Tiền Giang","code":"28534","parent_code":"821"},"28537":{"name":"Xã Tam Hiệp","type":"xa","slug":"xa-tam-hiep","name_with_type":"Xã Tam Hiệp","path":"Xã Tam Hiệp, Huyện Châu Thành, Tỉnh Tiền Giang","path_with_type":"Xã Tam Hiệp, Huyện Châu Thành, Tỉnh Tiền Giang","code":"28537","parent_code":"821"},"28540":{"name":"Xã Điềm Hy","type":"xa","slug":"xa-diem-hy","name_with_type":"Xã Điềm Hy","path":"Xã Điềm Hy, Huyện Châu Thành, Tỉnh Tiền Giang","path_with_type":"Xã Điềm Hy, Huyện Châu Thành, Tỉnh Tiền Giang","code":"28540","parent_code":"821"},"28543":{"name":"Xã Nhị Bình","type":"xa","slug":"xa-nhi-binh","name_with_type":"Xã Nhị Bình","path":"Xã Nhị Bình, Huyện Châu Thành, Tỉnh Tiền Giang","path_with_type":"Xã Nhị Bình, Huyện Châu Thành, Tỉnh Tiền Giang","code":"28543","parent_code":"821"},"28549":{"name":"Xã Đông Hòa","type":"xa","slug":"xa-dong-hoa","name_with_type":"Xã Đông Hòa","path":"Xã Đông Hòa, Huyện Châu Thành, Tỉnh Tiền Giang","path_with_type":"Xã Đông Hòa, Huyện Châu Thành, Tỉnh Tiền Giang","code":"28549","parent_code":"821"},"28552":{"name":"Xã Long Định","type":"xa","slug":"xa-long-dinh","name_with_type":"Xã Long Định","path":"Xã Long Định, Huyện Châu Thành, Tỉnh Tiền Giang","path_with_type":"Xã Long Định, Huyện Châu Thành, Tỉnh Tiền Giang","code":"28552","parent_code":"821"},"28558":{"name":"Xã Long An","type":"xa","slug":"xa-long-an","name_with_type":"Xã Long An","path":"Xã Long An, Huyện Châu Thành, Tỉnh Tiền Giang","path_with_type":"Xã Long An, Huyện Châu Thành, Tỉnh Tiền Giang","code":"28558","parent_code":"821"},"28561":{"name":"Xã Long Hưng","type":"xa","slug":"xa-long-hung","name_with_type":"Xã Long Hưng","path":"Xã Long Hưng, Huyện Châu Thành, Tỉnh Tiền Giang","path_with_type":"Xã Long Hưng, Huyện Châu Thành, Tỉnh Tiền Giang","code":"28561","parent_code":"821"},"28564":{"name":"Xã Bình Trưng","type":"xa","slug":"xa-binh-trung","name_with_type":"Xã Bình Trưng","path":"Xã Bình Trưng, Huyện Châu Thành, Tỉnh Tiền Giang","path_with_type":"Xã Bình Trưng, Huyện Châu Thành, Tỉnh Tiền Giang","code":"28564","parent_code":"821"},"28567":{"name":"Xã Phước Thạnh","type":"xa","slug":"xa-phuoc-thanh","name_with_type":"Xã Phước Thạnh","path":"Xã Phước Thạnh, Thành phố Mỹ Tho, Tỉnh Tiền Giang","path_with_type":"Xã Phước Thạnh, Thành phố Mỹ Tho, Tỉnh Tiền Giang","code":"28567","parent_code":"815"},"28570":{"name":"Xã Thạnh Phú","type":"xa","slug":"xa-thanh-phu","name_with_type":"Xã Thạnh Phú","path":"Xã Thạnh Phú, Huyện Châu Thành, Tỉnh Tiền Giang","path_with_type":"Xã Thạnh Phú, Huyện Châu Thành, Tỉnh Tiền Giang","code":"28570","parent_code":"821"},"28573":{"name":"Xã Bàn Long","type":"xa","slug":"xa-ban-long","name_with_type":"Xã Bàn Long","path":"Xã Bàn Long, Huyện Châu Thành, Tỉnh Tiền Giang","path_with_type":"Xã Bàn Long, Huyện Châu Thành, Tỉnh Tiền Giang","code":"28573","parent_code":"821"},"28576":{"name":"Xã Vĩnh Kim","type":"xa","slug":"xa-vinh-kim","name_with_type":"Xã Vĩnh Kim","path":"Xã Vĩnh Kim, Huyện Châu Thành, Tỉnh Tiền Giang","path_with_type":"Xã Vĩnh Kim, Huyện Châu Thành, Tỉnh Tiền Giang","code":"28576","parent_code":"821"},"28579":{"name":"Xã Bình Đức","type":"xa","slug":"xa-binh-duc","name_with_type":"Xã Bình Đức","path":"Xã Bình Đức, Huyện Châu Thành, Tỉnh Tiền Giang","path_with_type":"Xã Bình Đức, Huyện Châu Thành, Tỉnh Tiền Giang","code":"28579","parent_code":"821"},"28582":{"name":"Xã Song Thuận","type":"xa","slug":"xa-song-thuan","name_with_type":"Xã Song Thuận","path":"Xã Song Thuận, Huyện Châu Thành, Tỉnh Tiền Giang","path_with_type":"Xã Song Thuận, Huyện Châu Thành, Tỉnh Tiền Giang","code":"28582","parent_code":"821"},"28585":{"name":"Xã Kim Sơn","type":"xa","slug":"xa-kim-son","name_with_type":"Xã Kim Sơn","path":"Xã Kim Sơn, Huyện Châu Thành, Tỉnh Tiền Giang","path_with_type":"Xã Kim Sơn, Huyện Châu Thành, Tỉnh Tiền Giang","code":"28585","parent_code":"821"},"28588":{"name":"Xã Phú Phong","type":"xa","slug":"xa-phu-phong","name_with_type":"Xã Phú Phong","path":"Xã Phú Phong, Huyện Châu Thành, Tỉnh Tiền Giang","path_with_type":"Xã Phú Phong, Huyện Châu Thành, Tỉnh Tiền Giang","code":"28588","parent_code":"821"},"28591":{"name":"Xã Thới Sơn","type":"xa","slug":"xa-thoi-son","name_with_type":"Xã Thới Sơn","path":"Xã Thới Sơn, Thành phố Mỹ Tho, Tỉnh Tiền Giang","path_with_type":"Xã Thới Sơn, Thành phố Mỹ Tho, Tỉnh Tiền Giang","code":"28591","parent_code":"815"},"28594":{"name":"Thị trấn Chợ Gạo","type":"thi-tran","slug":"thi-tran-cho-gao","name_with_type":"Thị trấn Chợ Gạo","path":"Thị trấn Chợ Gạo, Huyện Chợ Gạo, Tỉnh Tiền Giang","path_with_type":"Thị trấn Chợ Gạo, Huyện Chợ Gạo, Tỉnh Tiền Giang","code":"28594","parent_code":"822"},"28597":{"name":"Xã Trung Hòa","type":"xa","slug":"xa-trung-hoa","name_with_type":"Xã Trung Hòa","path":"Xã Trung Hòa, Huyện Chợ Gạo, Tỉnh Tiền Giang","path_with_type":"Xã Trung Hòa, Huyện Chợ Gạo, Tỉnh Tiền Giang","code":"28597","parent_code":"822"},"28600":{"name":"Xã Hòa Tịnh","type":"xa","slug":"xa-hoa-tinh","name_with_type":"Xã Hòa Tịnh","path":"Xã Hòa Tịnh, Huyện Chợ Gạo, Tỉnh Tiền Giang","path_with_type":"Xã Hòa Tịnh, Huyện Chợ Gạo, Tỉnh Tiền Giang","code":"28600","parent_code":"822"},"28603":{"name":"Xã Mỹ Tịnh An","type":"xa","slug":"xa-my-tinh-an","name_with_type":"Xã Mỹ Tịnh An","path":"Xã Mỹ Tịnh An, Huyện Chợ Gạo, Tỉnh Tiền Giang","path_with_type":"Xã Mỹ Tịnh An, Huyện Chợ Gạo, Tỉnh Tiền Giang","code":"28603","parent_code":"822"},"28606":{"name":"Xã Tân Bình Thạnh","type":"xa","slug":"xa-tan-binh-thanh","name_with_type":"Xã Tân Bình Thạnh","path":"Xã Tân Bình Thạnh, Huyện Chợ Gạo, Tỉnh Tiền Giang","path_with_type":"Xã Tân Bình Thạnh, Huyện Chợ Gạo, Tỉnh Tiền Giang","code":"28606","parent_code":"822"},"28609":{"name":"Xã Phú Kiết","type":"xa","slug":"xa-phu-kiet","name_with_type":"Xã Phú Kiết","path":"Xã Phú Kiết, Huyện Chợ Gạo, Tỉnh Tiền Giang","path_with_type":"Xã Phú Kiết, Huyện Chợ Gạo, Tỉnh Tiền Giang","code":"28609","parent_code":"822"},"28612":{"name":"Xã Lương Hòa Lạc","type":"xa","slug":"xa-luong-hoa-lac","name_with_type":"Xã Lương Hòa Lạc","path":"Xã Lương Hòa Lạc, Huyện Chợ Gạo, Tỉnh Tiền Giang","path_with_type":"Xã Lương Hòa Lạc, Huyện Chợ Gạo, Tỉnh Tiền Giang","code":"28612","parent_code":"822"},"28615":{"name":"Xã Thanh Bình","type":"xa","slug":"xa-thanh-binh","name_with_type":"Xã Thanh Bình","path":"Xã Thanh Bình, Huyện Chợ Gạo, Tỉnh Tiền Giang","path_with_type":"Xã Thanh Bình, Huyện Chợ Gạo, Tỉnh Tiền Giang","code":"28615","parent_code":"822"},"28618":{"name":"Xã Quơn Long","type":"xa","slug":"xa-quon-long","name_with_type":"Xã Quơn Long","path":"Xã Quơn Long, Huyện Chợ Gạo, Tỉnh Tiền Giang","path_with_type":"Xã Quơn Long, Huyện Chợ Gạo, Tỉnh Tiền Giang","code":"28618","parent_code":"822"},"28621":{"name":"Xã Bình Phục Nhứt","type":"xa","slug":"xa-binh-phuc-nhut","name_with_type":"Xã Bình Phục Nhứt","path":"Xã Bình Phục Nhứt, Huyện Chợ Gạo, Tỉnh Tiền Giang","path_with_type":"Xã Bình Phục Nhứt, Huyện Chợ Gạo, Tỉnh Tiền Giang","code":"28621","parent_code":"822"},"28624":{"name":"Xã Đăng Hưng Phước","type":"xa","slug":"xa-dang-hung-phuoc","name_with_type":"Xã Đăng Hưng Phước","path":"Xã Đăng Hưng Phước, Huyện Chợ Gạo, Tỉnh Tiền Giang","path_with_type":"Xã Đăng Hưng Phước, Huyện Chợ Gạo, Tỉnh Tiền Giang","code":"28624","parent_code":"822"},"28627":{"name":"Xã Tân Thuận Bình","type":"xa","slug":"xa-tan-thuan-binh","name_with_type":"Xã Tân Thuận Bình","path":"Xã Tân Thuận Bình, Huyện Chợ Gạo, Tỉnh Tiền Giang","path_with_type":"Xã Tân Thuận Bình, Huyện Chợ Gạo, Tỉnh Tiền Giang","code":"28627","parent_code":"822"},"28630":{"name":"Xã Song Bình","type":"xa","slug":"xa-song-binh","name_with_type":"Xã Song Bình","path":"Xã Song Bình, Huyện Chợ Gạo, Tỉnh Tiền Giang","path_with_type":"Xã Song Bình, Huyện Chợ Gạo, Tỉnh Tiền Giang","code":"28630","parent_code":"822"},"28633":{"name":"Xã Bình Phan","type":"xa","slug":"xa-binh-phan","name_with_type":"Xã Bình Phan","path":"Xã Bình Phan, Huyện Chợ Gạo, Tỉnh Tiền Giang","path_with_type":"Xã Bình Phan, Huyện Chợ Gạo, Tỉnh Tiền Giang","code":"28633","parent_code":"822"},"28636":{"name":"Xã Long Bình Điền","type":"xa","slug":"xa-long-binh-dien","name_with_type":"Xã Long Bình Điền","path":"Xã Long Bình Điền, Huyện Chợ Gạo, Tỉnh Tiền Giang","path_with_type":"Xã Long Bình Điền, Huyện Chợ Gạo, Tỉnh Tiền Giang","code":"28636","parent_code":"822"},"28639":{"name":"Xã An Thạnh Thủy","type":"xa","slug":"xa-an-thanh-thuy","name_with_type":"Xã An Thạnh Thủy","path":"Xã An Thạnh Thủy, Huyện Chợ Gạo, Tỉnh Tiền Giang","path_with_type":"Xã An Thạnh Thủy, Huyện Chợ Gạo, Tỉnh Tiền Giang","code":"28639","parent_code":"822"},"28642":{"name":"Xã Xuân Đông","type":"xa","slug":"xa-xuan-dong","name_with_type":"Xã Xuân Đông","path":"Xã Xuân Đông, Huyện Chợ Gạo, Tỉnh Tiền Giang","path_with_type":"Xã Xuân Đông, Huyện Chợ Gạo, Tỉnh Tiền Giang","code":"28642","parent_code":"822"},"28645":{"name":"Xã Hòa Định","type":"xa","slug":"xa-hoa-dinh","name_with_type":"Xã Hòa Định","path":"Xã Hòa Định, Huyện Chợ Gạo, Tỉnh Tiền Giang","path_with_type":"Xã Hòa Định, Huyện Chợ Gạo, Tỉnh Tiền Giang","code":"28645","parent_code":"822"},"28648":{"name":"Xã Bình Ninh","type":"xa","slug":"xa-binh-ninh","name_with_type":"Xã Bình Ninh","path":"Xã Bình Ninh, Huyện Chợ Gạo, Tỉnh Tiền Giang","path_with_type":"Xã Bình Ninh, Huyện Chợ Gạo, Tỉnh Tiền Giang","code":"28648","parent_code":"822"},"28651":{"name":"Thị trấn Vĩnh Bình","type":"thi-tran","slug":"thi-tran-vinh-binh","name_with_type":"Thị trấn Vĩnh Bình","path":"Thị trấn Vĩnh Bình, Huyện Gò Công Tây, Tỉnh Tiền Giang","path_with_type":"Thị trấn Vĩnh Bình, Huyện Gò Công Tây, Tỉnh Tiền Giang","code":"28651","parent_code":"823"},"28654":{"name":"Xã Đồng Sơn","type":"xa","slug":"xa-dong-son","name_with_type":"Xã Đồng Sơn","path":"Xã Đồng Sơn, Huyện Gò Công Tây, Tỉnh Tiền Giang","path_with_type":"Xã Đồng Sơn, Huyện Gò Công Tây, Tỉnh Tiền Giang","code":"28654","parent_code":"823"},"28657":{"name":"Xã Bình Phú","type":"xa","slug":"xa-binh-phu","name_with_type":"Xã Bình Phú","path":"Xã Bình Phú, Huyện Gò Công Tây, Tỉnh Tiền Giang","path_with_type":"Xã Bình Phú, Huyện Gò Công Tây, Tỉnh Tiền Giang","code":"28657","parent_code":"823"},"28660":{"name":"Xã Đồng Thạnh","type":"xa","slug":"xa-dong-thanh","name_with_type":"Xã Đồng Thạnh","path":"Xã Đồng Thạnh, Huyện Gò Công Tây, Tỉnh Tiền Giang","path_with_type":"Xã Đồng Thạnh, Huyện Gò Công Tây, Tỉnh Tiền Giang","code":"28660","parent_code":"823"},"28663":{"name":"Xã Thành Công","type":"xa","slug":"xa-thanh-cong","name_with_type":"Xã Thành Công","path":"Xã Thành Công, Huyện Gò Công Tây, Tỉnh Tiền Giang","path_with_type":"Xã Thành Công, Huyện Gò Công Tây, Tỉnh Tiền Giang","code":"28663","parent_code":"823"},"28666":{"name":"Xã Bình Nhì","type":"xa","slug":"xa-binh-nhi","name_with_type":"Xã Bình Nhì","path":"Xã Bình Nhì, Huyện Gò Công Tây, Tỉnh Tiền Giang","path_with_type":"Xã Bình Nhì, Huyện Gò Công Tây, Tỉnh Tiền Giang","code":"28666","parent_code":"823"},"28669":{"name":"Xã Yên Luông","type":"xa","slug":"xa-yen-luong","name_with_type":"Xã Yên Luông","path":"Xã Yên Luông, Huyện Gò Công Tây, Tỉnh Tiền Giang","path_with_type":"Xã Yên Luông, Huyện Gò Công Tây, Tỉnh Tiền Giang","code":"28669","parent_code":"823"},"28672":{"name":"Xã Thạnh Trị","type":"xa","slug":"xa-thanh-tri","name_with_type":"Xã Thạnh Trị","path":"Xã Thạnh Trị, Huyện Gò Công Tây, Tỉnh Tiền Giang","path_with_type":"Xã Thạnh Trị, Huyện Gò Công Tây, Tỉnh Tiền Giang","code":"28672","parent_code":"823"},"28675":{"name":"Xã Thạnh Nhựt","type":"xa","slug":"xa-thanh-nhut","name_with_type":"Xã Thạnh Nhựt","path":"Xã Thạnh Nhựt, Huyện Gò Công Tây, Tỉnh Tiền Giang","path_with_type":"Xã Thạnh Nhựt, Huyện Gò Công Tây, Tỉnh Tiền Giang","code":"28675","parent_code":"823"},"28678":{"name":"Xã Long Vĩnh","type":"xa","slug":"xa-long-vinh","name_with_type":"Xã Long Vĩnh","path":"Xã Long Vĩnh, Huyện Gò Công Tây, Tỉnh Tiền Giang","path_with_type":"Xã Long Vĩnh, Huyện Gò Công Tây, Tỉnh Tiền Giang","code":"28678","parent_code":"823"},"28681":{"name":"Xã Bình Tân","type":"xa","slug":"xa-binh-tan","name_with_type":"Xã Bình Tân","path":"Xã Bình Tân, Huyện Gò Công Tây, Tỉnh Tiền Giang","path_with_type":"Xã Bình Tân, Huyện Gò Công Tây, Tỉnh Tiền Giang","code":"28681","parent_code":"823"},"28684":{"name":"Xã Vĩnh Hựu","type":"xa","slug":"xa-vinh-huu","name_with_type":"Xã Vĩnh Hựu","path":"Xã Vĩnh Hựu, Huyện Gò Công Tây, Tỉnh Tiền Giang","path_with_type":"Xã Vĩnh Hựu, Huyện Gò Công Tây, Tỉnh Tiền Giang","code":"28684","parent_code":"823"},"28687":{"name":"Xã Long Bình","type":"xa","slug":"xa-long-binh","name_with_type":"Xã Long Bình","path":"Xã Long Bình, Huyện Gò Công Tây, Tỉnh Tiền Giang","path_with_type":"Xã Long Bình, Huyện Gò Công Tây, Tỉnh Tiền Giang","code":"28687","parent_code":"823"},"28690":{"name":"Xã Tân Thới","type":"xa","slug":"xa-tan-thoi","name_with_type":"Xã Tân Thới","path":"Xã Tân Thới, Huyện Tân Phú Đông, Tỉnh Tiền Giang","path_with_type":"Xã Tân Thới, Huyện Tân Phú Đông, Tỉnh Tiền Giang","code":"28690","parent_code":"825"},"28693":{"name":"Xã Tân Phú","type":"xa","slug":"xa-tan-phu","name_with_type":"Xã Tân Phú","path":"Xã Tân Phú, Huyện Tân Phú Đông, Tỉnh Tiền Giang","path_with_type":"Xã Tân Phú, Huyện Tân Phú Đông, Tỉnh Tiền Giang","code":"28693","parent_code":"825"},"28696":{"name":"Xã Phú Thạnh","type":"xa","slug":"xa-phu-thanh","name_with_type":"Xã Phú Thạnh","path":"Xã Phú Thạnh, Huyện Tân Phú Đông, Tỉnh Tiền Giang","path_with_type":"Xã Phú Thạnh, Huyện Tân Phú Đông, Tỉnh Tiền Giang","code":"28696","parent_code":"825"},"28699":{"name":"Xã Tân Thạnh","type":"xa","slug":"xa-tan-thanh","name_with_type":"Xã Tân Thạnh","path":"Xã Tân Thạnh, Huyện Tân Phú Đông, Tỉnh Tiền Giang","path_with_type":"Xã Tân Thạnh, Huyện Tân Phú Đông, Tỉnh Tiền Giang","code":"28699","parent_code":"825"},"28702":{"name":"Thị trấn Tân Hòa","type":"thi-tran","slug":"thi-tran-tan-hoa","name_with_type":"Thị trấn Tân Hòa","path":"Thị trấn Tân Hòa, Huyện Gò Công Đông, Tỉnh Tiền Giang","path_with_type":"Thị trấn Tân Hòa, Huyện Gò Công Đông, Tỉnh Tiền Giang","code":"28702","parent_code":"824"},"28705":{"name":"Xã Tăng Hoà","type":"xa","slug":"xa-tang-hoa","name_with_type":"Xã Tăng Hoà","path":"Xã Tăng Hoà, Huyện Gò Công Đông, Tỉnh Tiền Giang","path_with_type":"Xã Tăng Hoà, Huyện Gò Công Đông, Tỉnh Tiền Giang","code":"28705","parent_code":"824"},"28708":{"name":"Xã Bình Đông","type":"xa","slug":"xa-binh-dong","name_with_type":"Xã Bình Đông","path":"Xã Bình Đông, Thành phố Gò Công, Tỉnh Tiền Giang","path_with_type":"Xã Bình Đông, Thành phố Gò Công, Tỉnh Tiền Giang","code":"28708","parent_code":"816"},"28711":{"name":"Xã Tân Phước","type":"xa","slug":"xa-tan-phuoc","name_with_type":"Xã Tân Phước","path":"Xã Tân Phước, Huyện Gò Công Đông, Tỉnh Tiền Giang","path_with_type":"Xã Tân Phước, Huyện Gò Công Đông, Tỉnh Tiền Giang","code":"28711","parent_code":"824"},"28714":{"name":"Xã Gia Thuận","type":"xa","slug":"xa-gia-thuan","name_with_type":"Xã Gia Thuận","path":"Xã Gia Thuận, Huyện Gò Công Đông, Tỉnh Tiền Giang","path_with_type":"Xã Gia Thuận, Huyện Gò Công Đông, Tỉnh Tiền Giang","code":"28714","parent_code":"824"},"28717":{"name":"Xã Bình Xuân","type":"xa","slug":"xa-binh-xuan","name_with_type":"Xã Bình Xuân","path":"Xã Bình Xuân, Thành phố Gò Công, Tỉnh Tiền Giang","path_with_type":"Xã Bình Xuân, Thành phố Gò Công, Tỉnh Tiền Giang","code":"28717","parent_code":"816"},"28720":{"name":"Thị trấn Vàm Láng","type":"thi-tran","slug":"thi-tran-vam-lang","name_with_type":"Thị trấn Vàm Láng","path":"Thị trấn Vàm Láng, Huyện Gò Công Đông, Tỉnh Tiền Giang","path_with_type":"Thị trấn Vàm Láng, Huyện Gò Công Đông, Tỉnh Tiền Giang","code":"28720","parent_code":"824"},"28723":{"name":"Xã Tân Tây","type":"xa","slug":"xa-tan-tay","name_with_type":"Xã Tân Tây","path":"Xã Tân Tây, Huyện Gò Công Đông, Tỉnh Tiền Giang","path_with_type":"Xã Tân Tây, Huyện Gò Công Đông, Tỉnh Tiền Giang","code":"28723","parent_code":"824"},"28726":{"name":"Xã Kiểng Phước","type":"xa","slug":"xa-kieng-phuoc","name_with_type":"Xã Kiểng Phước","path":"Xã Kiểng Phước, Huyện Gò Công Đông, Tỉnh Tiền Giang","path_with_type":"Xã Kiểng Phước, Huyện Gò Công Đông, Tỉnh Tiền Giang","code":"28726","parent_code":"824"},"28729":{"name":"Xã Tân Trung","type":"xa","slug":"xa-tan-trung","name_with_type":"Xã Tân Trung","path":"Xã Tân Trung, Thành phố Gò Công, Tỉnh Tiền Giang","path_with_type":"Xã Tân Trung, Thành phố Gò Công, Tỉnh Tiền Giang","code":"28729","parent_code":"816"},"28732":{"name":"Xã Tân Đông","type":"xa","slug":"xa-tan-dong","name_with_type":"Xã Tân Đông","path":"Xã Tân Đông, Huyện Gò Công Đông, Tỉnh Tiền Giang","path_with_type":"Xã Tân Đông, Huyện Gò Công Đông, Tỉnh Tiền Giang","code":"28732","parent_code":"824"},"28735":{"name":"Xã Bình Ân","type":"xa","slug":"xa-binh-an","name_with_type":"Xã Bình Ân","path":"Xã Bình Ân, Huyện Gò Công Đông, Tỉnh Tiền Giang","path_with_type":"Xã Bình Ân, Huyện Gò Công Đông, Tỉnh Tiền Giang","code":"28735","parent_code":"824"},"28738":{"name":"Xã Tân Điền","type":"xa","slug":"xa-tan-dien","name_with_type":"Xã Tân Điền","path":"Xã Tân Điền, Huyện Gò Công Đông, Tỉnh Tiền Giang","path_with_type":"Xã Tân Điền, Huyện Gò Công Đông, Tỉnh Tiền Giang","code":"28738","parent_code":"824"},"28741":{"name":"Xã Bình Nghị","type":"xa","slug":"xa-binh-nghi","name_with_type":"Xã Bình Nghị","path":"Xã Bình Nghị, Huyện Gò Công Đông, Tỉnh Tiền Giang","path_with_type":"Xã Bình Nghị, Huyện Gò Công Đông, Tỉnh Tiền Giang","code":"28741","parent_code":"824"},"28744":{"name":"Xã Phước Trung","type":"xa","slug":"xa-phuoc-trung","name_with_type":"Xã Phước Trung","path":"Xã Phước Trung, Huyện Gò Công Đông, Tỉnh Tiền Giang","path_with_type":"Xã Phước Trung, Huyện Gò Công Đông, Tỉnh Tiền Giang","code":"28744","parent_code":"824"},"28747":{"name":"Xã Tân Thành","type":"xa","slug":"xa-tan-thanh","name_with_type":"Xã Tân Thành","path":"Xã Tân Thành, Huyện Gò Công Đông, Tỉnh Tiền Giang","path_with_type":"Xã Tân Thành, Huyện Gò Công Đông, Tỉnh Tiền Giang","code":"28747","parent_code":"824"},"28750":{"name":"Xã Phú Đông","type":"xa","slug":"xa-phu-dong","name_with_type":"Xã Phú Đông","path":"Xã Phú Đông, Huyện Tân Phú Đông, Tỉnh Tiền Giang","path_with_type":"Xã Phú Đông, Huyện Tân Phú Đông, Tỉnh Tiền Giang","code":"28750","parent_code":"825"},"28753":{"name":"Xã Phú Tân","type":"xa","slug":"xa-phu-tan","name_with_type":"Xã Phú Tân","path":"Xã Phú Tân, Huyện Tân Phú Đông, Tỉnh Tiền Giang","path_with_type":"Xã Phú Tân, Huyện Tân Phú Đông, Tỉnh Tiền Giang","code":"28753","parent_code":"825"},"28756":{"name":"Phường Phú Khương","type":"phuong","slug":"phuong-phu-khuong","name_with_type":"Phường Phú Khương","path":"Phường Phú Khương, Thành phố Bến Tre, Tỉnh Bến Tre","path_with_type":"Phường Phú Khương, Thành phố Bến Tre, Tỉnh Bến Tre","code":"28756","parent_code":"829"},"28757":{"name":"Phường Phú Tân","type":"phuong","slug":"phuong-phu-tan","name_with_type":"Phường Phú Tân","path":"Phường Phú Tân, Thành phố Bến Tre, Tỉnh Bến Tre","path_with_type":"Phường Phú Tân, Thành phố Bến Tre, Tỉnh Bến Tre","code":"28757","parent_code":"829"},"28759":{"name":"Phường 8","type":"phuong","slug":"phuong-8","name_with_type":"Phường 8","path":"Phường 8, Thành phố Bến Tre, Tỉnh Bến Tre","path_with_type":"Phường 8, Thành phố Bến Tre, Tỉnh Bến Tre","code":"28759","parent_code":"829"},"28762":{"name":"Phường 6","type":"phuong","slug":"phuong-6","name_with_type":"Phường 6","path":"Phường 6, Thành phố Bến Tre, Tỉnh Bến Tre","path_with_type":"Phường 6, Thành phố Bến Tre, Tỉnh Bến Tre","code":"28762","parent_code":"829"},"28777":{"name":"Phường An Hội","type":"phuong","slug":"phuong-an-hoi","name_with_type":"Phường An Hội","path":"Phường An Hội, Thành phố Bến Tre, Tỉnh Bến Tre","path_with_type":"Phường An Hội, Thành phố Bến Tre, Tỉnh Bến Tre","code":"28777","parent_code":"829"},"28780":{"name":"Phường 7","type":"phuong","slug":"phuong-7","name_with_type":"Phường 7","path":"Phường 7, Thành phố Bến Tre, Tỉnh Bến Tre","path_with_type":"Phường 7, Thành phố Bến Tre, Tỉnh Bến Tre","code":"28780","parent_code":"829"},"28783":{"name":"Xã Sơn Đông","type":"xa","slug":"xa-son-dong","name_with_type":"Xã Sơn Đông","path":"Xã Sơn Đông, Thành phố Bến Tre, Tỉnh Bến Tre","path_with_type":"Xã Sơn Đông, Thành phố Bến Tre, Tỉnh Bến Tre","code":"28783","parent_code":"829"},"28786":{"name":"Xã Phú Hưng","type":"xa","slug":"xa-phu-hung","name_with_type":"Xã Phú Hưng","path":"Xã Phú Hưng, Thành phố Bến Tre, Tỉnh Bến Tre","path_with_type":"Xã Phú Hưng, Thành phố Bến Tre, Tỉnh Bến Tre","code":"28786","parent_code":"829"},"28789":{"name":"Xã Bình Phú","type":"xa","slug":"xa-binh-phu","name_with_type":"Xã Bình Phú","path":"Xã Bình Phú, Thành phố Bến Tre, Tỉnh Bến Tre","path_with_type":"Xã Bình Phú, Thành phố Bến Tre, Tỉnh Bến Tre","code":"28789","parent_code":"829"},"28792":{"name":"Xã Mỹ Thạnh An","type":"xa","slug":"xa-my-thanh-an","name_with_type":"Xã Mỹ Thạnh An","path":"Xã Mỹ Thạnh An, Thành phố Bến Tre, Tỉnh Bến Tre","path_with_type":"Xã Mỹ Thạnh An, Thành phố Bến Tre, Tỉnh Bến Tre","code":"28792","parent_code":"829"},"28795":{"name":"Xã Nhơn Thạnh","type":"xa","slug":"xa-nhon-thanh","name_with_type":"Xã Nhơn Thạnh","path":"Xã Nhơn Thạnh, Thành phố Bến Tre, Tỉnh Bến Tre","path_with_type":"Xã Nhơn Thạnh, Thành phố Bến Tre, Tỉnh Bến Tre","code":"28795","parent_code":"829"},"28798":{"name":"Xã Phú Nhuận","type":"xa","slug":"xa-phu-nhuan","name_with_type":"Xã Phú Nhuận","path":"Xã Phú Nhuận, Thành phố Bến Tre, Tỉnh Bến Tre","path_with_type":"Xã Phú Nhuận, Thành phố Bến Tre, Tỉnh Bến Tre","code":"28798","parent_code":"829"},"28804":{"name":"Xã Tân Thạch","type":"xa","slug":"xa-tan-thach","name_with_type":"Xã Tân Thạch","path":"Xã Tân Thạch, Huyện Châu Thành, Tỉnh Bến Tre","path_with_type":"Xã Tân Thạch, Huyện Châu Thành, Tỉnh Bến Tre","code":"28804","parent_code":"831"},"28807":{"name":"Xã Qưới Sơn","type":"xa","slug":"xa-quoi-son","name_with_type":"Xã Qưới Sơn","path":"Xã Qưới Sơn, Huyện Châu Thành, Tỉnh Bến Tre","path_with_type":"Xã Qưới Sơn, Huyện Châu Thành, Tỉnh Bến Tre","code":"28807","parent_code":"831"},"28810":{"name":"Thị trấn Châu Thành","type":"thi-tran","slug":"thi-tran-chau-thanh","name_with_type":"Thị trấn Châu Thành","path":"Thị trấn Châu Thành, Huyện Châu Thành, Tỉnh Bến Tre","path_with_type":"Thị trấn Châu Thành, Huyện Châu Thành, Tỉnh Bến Tre","code":"28810","parent_code":"831"},"28813":{"name":"Xã Giao Long","type":"xa","slug":"xa-giao-long","name_with_type":"Xã Giao Long","path":"Xã Giao Long, Huyện Châu Thành, Tỉnh Bến Tre","path_with_type":"Xã Giao Long, Huyện Châu Thành, Tỉnh Bến Tre","code":"28813","parent_code":"831"},"28819":{"name":"Xã Phú Túc","type":"xa","slug":"xa-phu-tuc","name_with_type":"Xã Phú Túc","path":"Xã Phú Túc, Huyện Châu Thành, Tỉnh Bến Tre","path_with_type":"Xã Phú Túc, Huyện Châu Thành, Tỉnh Bến Tre","code":"28819","parent_code":"831"},"28822":{"name":"Xã Phú Đức","type":"xa","slug":"xa-phu-duc","name_with_type":"Xã Phú Đức","path":"Xã Phú Đức, Huyện Châu Thành, Tỉnh Bến Tre","path_with_type":"Xã Phú Đức, Huyện Châu Thành, Tỉnh Bến Tre","code":"28822","parent_code":"831"},"28828":{"name":"Xã An Phước","type":"xa","slug":"xa-an-phuoc","name_with_type":"Xã An Phước","path":"Xã An Phước, Huyện Châu Thành, Tỉnh Bến Tre","path_with_type":"Xã An Phước, Huyện Châu Thành, Tỉnh Bến Tre","code":"28828","parent_code":"831"},"28831":{"name":"Xã Tam Phước","type":"xa","slug":"xa-tam-phuoc","name_with_type":"Xã Tam Phước","path":"Xã Tam Phước, Huyện Châu Thành, Tỉnh Bến Tre","path_with_type":"Xã Tam Phước, Huyện Châu Thành, Tỉnh Bến Tre","code":"28831","parent_code":"831"},"28834":{"name":"Xã Thành Triệu","type":"xa","slug":"xa-thanh-trieu","name_with_type":"Xã Thành Triệu","path":"Xã Thành Triệu, Huyện Châu Thành, Tỉnh Bến Tre","path_with_type":"Xã Thành Triệu, Huyện Châu Thành, Tỉnh Bến Tre","code":"28834","parent_code":"831"},"28840":{"name":"Xã Tân Phú","type":"xa","slug":"xa-tan-phu","name_with_type":"Xã Tân Phú","path":"Xã Tân Phú, Huyện Châu Thành, Tỉnh Bến Tre","path_with_type":"Xã Tân Phú, Huyện Châu Thành, Tỉnh Bến Tre","code":"28840","parent_code":"831"},"28843":{"name":"Xã Quới Thành","type":"xa","slug":"xa-quoi-thanh","name_with_type":"Xã Quới Thành","path":"Xã Quới Thành, Huyện Châu Thành, Tỉnh Bến Tre","path_with_type":"Xã Quới Thành, Huyện Châu Thành, Tỉnh Bến Tre","code":"28843","parent_code":"831"},"28846":{"name":"Xã Phước Thạnh","type":"xa","slug":"xa-phuoc-thanh","name_with_type":"Xã Phước Thạnh","path":"Xã Phước Thạnh, Huyện Châu Thành, Tỉnh Bến Tre","path_with_type":"Xã Phước Thạnh, Huyện Châu Thành, Tỉnh Bến Tre","code":"28846","parent_code":"831"},"28852":{"name":"Xã Tiên Long","type":"xa","slug":"xa-tien-long","name_with_type":"Xã Tiên Long","path":"Xã Tiên Long, Huyện Châu Thành, Tỉnh Bến Tre","path_with_type":"Xã Tiên Long, Huyện Châu Thành, Tỉnh Bến Tre","code":"28852","parent_code":"831"},"28855":{"name":"Xã Tường Đa","type":"xa","slug":"xa-tuong-da","name_with_type":"Xã Tường Đa","path":"Xã Tường Đa, Huyện Châu Thành, Tỉnh Bến Tre","path_with_type":"Xã Tường Đa, Huyện Châu Thành, Tỉnh Bến Tre","code":"28855","parent_code":"831"},"28858":{"name":"Xã Hữu Định","type":"xa","slug":"xa-huu-dinh","name_with_type":"Xã Hữu Định","path":"Xã Hữu Định, Huyện Châu Thành, Tỉnh Bến Tre","path_with_type":"Xã Hữu Định, Huyện Châu Thành, Tỉnh Bến Tre","code":"28858","parent_code":"831"},"28861":{"name":"Thị trấn Tiên Thủy","type":"thi-tran","slug":"thi-tran-tien-thuy","name_with_type":"Thị trấn Tiên Thủy","path":"Thị trấn Tiên Thủy, Huyện Châu Thành, Tỉnh Bến Tre","path_with_type":"Thị trấn Tiên Thủy, Huyện Châu Thành, Tỉnh Bến Tre","code":"28861","parent_code":"831"},"28870":{"name":"Thị trấn Chợ Lách","type":"thi-tran","slug":"thi-tran-cho-lach","name_with_type":"Thị trấn Chợ Lách","path":"Thị trấn Chợ Lách, Huyện Chợ Lách, Tỉnh Bến Tre","path_with_type":"Thị trấn Chợ Lách, Huyện Chợ Lách, Tỉnh Bến Tre","code":"28870","parent_code":"832"},"28873":{"name":"Xã Phú Phụng","type":"xa","slug":"xa-phu-phung","name_with_type":"Xã Phú Phụng","path":"Xã Phú Phụng, Huyện Chợ Lách, Tỉnh Bến Tre","path_with_type":"Xã Phú Phụng, Huyện Chợ Lách, Tỉnh Bến Tre","code":"28873","parent_code":"832"},"28876":{"name":"Xã Sơn Định","type":"xa","slug":"xa-son-dinh","name_with_type":"Xã Sơn Định","path":"Xã Sơn Định, Huyện Chợ Lách, Tỉnh Bến Tre","path_with_type":"Xã Sơn Định, Huyện Chợ Lách, Tỉnh Bến Tre","code":"28876","parent_code":"832"},"28879":{"name":"Xã Vĩnh Bình","type":"xa","slug":"xa-vinh-binh","name_with_type":"Xã Vĩnh Bình","path":"Xã Vĩnh Bình, Huyện Chợ Lách, Tỉnh Bến Tre","path_with_type":"Xã Vĩnh Bình, Huyện Chợ Lách, Tỉnh Bến Tre","code":"28879","parent_code":"832"},"28882":{"name":"Xã Hòa Nghĩa","type":"xa","slug":"xa-hoa-nghia","name_with_type":"Xã Hòa Nghĩa","path":"Xã Hòa Nghĩa, Huyện Chợ Lách, Tỉnh Bến Tre","path_with_type":"Xã Hòa Nghĩa, Huyện Chợ Lách, Tỉnh Bến Tre","code":"28882","parent_code":"832"},"28885":{"name":"Xã Long Thới","type":"xa","slug":"xa-long-thoi","name_with_type":"Xã Long Thới","path":"Xã Long Thới, Huyện Chợ Lách, Tỉnh Bến Tre","path_with_type":"Xã Long Thới, Huyện Chợ Lách, Tỉnh Bến Tre","code":"28885","parent_code":"832"},"28888":{"name":"Xã Phú Sơn","type":"xa","slug":"xa-phu-son","name_with_type":"Xã Phú Sơn","path":"Xã Phú Sơn, Huyện Chợ Lách, Tỉnh Bến Tre","path_with_type":"Xã Phú Sơn, Huyện Chợ Lách, Tỉnh Bến Tre","code":"28888","parent_code":"832"},"28889":{"name":"Xã Phú Mỹ","type":"xa","slug":"xa-phu-my","name_with_type":"Xã Phú Mỹ","path":"Xã Phú Mỹ, Huyện Mỏ Cày Bắc, Tỉnh Bến Tre","path_with_type":"Xã Phú Mỹ, Huyện Mỏ Cày Bắc, Tỉnh Bến Tre","code":"28889","parent_code":"838"},"28891":{"name":"Xã Tân Thiềng","type":"xa","slug":"xa-tan-thieng","name_with_type":"Xã Tân Thiềng","path":"Xã Tân Thiềng, Huyện Chợ Lách, Tỉnh Bến Tre","path_with_type":"Xã Tân Thiềng, Huyện Chợ Lách, Tỉnh Bến Tre","code":"28891","parent_code":"832"},"28894":{"name":"Xã Vĩnh Thành","type":"xa","slug":"xa-vinh-thanh","name_with_type":"Xã Vĩnh Thành","path":"Xã Vĩnh Thành, Huyện Chợ Lách, Tỉnh Bến Tre","path_with_type":"Xã Vĩnh Thành, Huyện Chợ Lách, Tỉnh Bến Tre","code":"28894","parent_code":"832"},"28897":{"name":"Xã Vĩnh Hòa","type":"xa","slug":"xa-vinh-hoa","name_with_type":"Xã Vĩnh Hòa","path":"Xã Vĩnh Hòa, Huyện Chợ Lách, Tỉnh Bến Tre","path_with_type":"Xã Vĩnh Hòa, Huyện Chợ Lách, Tỉnh Bến Tre","code":"28897","parent_code":"832"},"28900":{"name":"Xã Hưng Khánh Trung B","type":"xa","slug":"xa-hung-khanh-trung-b","name_with_type":"Xã Hưng Khánh Trung B","path":"Xã Hưng Khánh Trung B, Huyện Chợ Lách, Tỉnh Bến Tre","path_with_type":"Xã Hưng Khánh Trung B, Huyện Chợ Lách, Tỉnh Bến Tre","code":"28900","parent_code":"832"},"28901":{"name":"Xã Hưng Khánh Trung A","type":"xa","slug":"xa-hung-khanh-trung-a","name_with_type":"Xã Hưng Khánh Trung A","path":"Xã Hưng Khánh Trung A, Huyện Mỏ Cày Bắc, Tỉnh Bến Tre","path_with_type":"Xã Hưng Khánh Trung A, Huyện Mỏ Cày Bắc, Tỉnh Bến Tre","code":"28901","parent_code":"838"},"28903":{"name":"Thị trấn Mỏ Cày","type":"thi-tran","slug":"thi-tran-mo-cay","name_with_type":"Thị trấn Mỏ Cày","path":"Thị trấn Mỏ Cày, Huyện Mỏ Cày Nam, Tỉnh Bến Tre","path_with_type":"Thị trấn Mỏ Cày, Huyện Mỏ Cày Nam, Tỉnh Bến Tre","code":"28903","parent_code":"833"},"28906":{"name":"Xã Thanh Tân","type":"xa","slug":"xa-thanh-tan","name_with_type":"Xã Thanh Tân","path":"Xã Thanh Tân, Huyện Mỏ Cày Bắc, Tỉnh Bến Tre","path_with_type":"Xã Thanh Tân, Huyện Mỏ Cày Bắc, Tỉnh Bến Tre","code":"28906","parent_code":"838"},"28909":{"name":"Xã Thạnh Ngãi","type":"xa","slug":"xa-thanh-ngai","name_with_type":"Xã Thạnh Ngãi","path":"Xã Thạnh Ngãi, Huyện Mỏ Cày Bắc, Tỉnh Bến Tre","path_with_type":"Xã Thạnh Ngãi, Huyện Mỏ Cày Bắc, Tỉnh Bến Tre","code":"28909","parent_code":"838"},"28912":{"name":"Xã Tân Phú Tây","type":"xa","slug":"xa-tan-phu-tay","name_with_type":"Xã Tân Phú Tây","path":"Xã Tân Phú Tây, Huyện Mỏ Cày Bắc, Tỉnh Bến Tre","path_with_type":"Xã Tân Phú Tây, Huyện Mỏ Cày Bắc, Tỉnh Bến Tre","code":"28912","parent_code":"838"},"28915":{"name":"Thị trấn Phước Mỹ Trung","type":"thi-tran","slug":"thi-tran-phuoc-my-trung","name_with_type":"Thị trấn Phước Mỹ Trung","path":"Thị trấn Phước Mỹ Trung, Huyện Mỏ Cày Bắc, Tỉnh Bến Tre","path_with_type":"Thị trấn Phước Mỹ Trung, Huyện Mỏ Cày Bắc, Tỉnh Bến Tre","code":"28915","parent_code":"838"},"28918":{"name":"Xã Tân Thành Bình","type":"xa","slug":"xa-tan-thanh-binh","name_with_type":"Xã Tân Thành Bình","path":"Xã Tân Thành Bình, Huyện Mỏ Cày Bắc, Tỉnh Bến Tre","path_with_type":"Xã Tân Thành Bình, Huyện Mỏ Cày Bắc, Tỉnh Bến Tre","code":"28918","parent_code":"838"},"28921":{"name":"Xã Thành An","type":"xa","slug":"xa-thanh-an","name_with_type":"Xã Thành An","path":"Xã Thành An, Huyện Mỏ Cày Bắc, Tỉnh Bến Tre","path_with_type":"Xã Thành An, Huyện Mỏ Cày Bắc, Tỉnh Bến Tre","code":"28921","parent_code":"838"},"28924":{"name":"Xã Hòa Lộc","type":"xa","slug":"xa-hoa-loc","name_with_type":"Xã Hòa Lộc","path":"Xã Hòa Lộc, Huyện Mỏ Cày Bắc, Tỉnh Bến Tre","path_with_type":"Xã Hòa Lộc, Huyện Mỏ Cày Bắc, Tỉnh Bến Tre","code":"28924","parent_code":"838"},"28927":{"name":"Xã Tân Thanh Tây","type":"xa","slug":"xa-tan-thanh-tay","name_with_type":"Xã Tân Thanh Tây","path":"Xã Tân Thanh Tây, Huyện Mỏ Cày Bắc, Tỉnh Bến Tre","path_with_type":"Xã Tân Thanh Tây, Huyện Mỏ Cày Bắc, Tỉnh Bến Tre","code":"28927","parent_code":"838"},"28930":{"name":"Xã Định Thủy","type":"xa","slug":"xa-dinh-thuy","name_with_type":"Xã Định Thủy","path":"Xã Định Thủy, Huyện Mỏ Cày Nam, Tỉnh Bến Tre","path_with_type":"Xã Định Thủy, Huyện Mỏ Cày Nam, Tỉnh Bến Tre","code":"28930","parent_code":"833"},"28933":{"name":"Xã Tân Bình","type":"xa","slug":"xa-tan-binh","name_with_type":"Xã Tân Bình","path":"Xã Tân Bình, Huyện Mỏ Cày Bắc, Tỉnh Bến Tre","path_with_type":"Xã Tân Bình, Huyện Mỏ Cày Bắc, Tỉnh Bến Tre","code":"28933","parent_code":"838"},"28936":{"name":"Xã Nhuận Phú Tân","type":"xa","slug":"xa-nhuan-phu-tan","name_with_type":"Xã Nhuận Phú Tân","path":"Xã Nhuận Phú Tân, Huyện Mỏ Cày Bắc, Tỉnh Bến Tre","path_with_type":"Xã Nhuận Phú Tân, Huyện Mỏ Cày Bắc, Tỉnh Bến Tre","code":"28936","parent_code":"838"},"28939":{"name":"Xã Đa Phước Hội","type":"xa","slug":"xa-da-phuoc-hoi","name_with_type":"Xã Đa Phước Hội","path":"Xã Đa Phước Hội, Huyện Mỏ Cày Nam, Tỉnh Bến Tre","path_with_type":"Xã Đa Phước Hội, Huyện Mỏ Cày Nam, Tỉnh Bến Tre","code":"28939","parent_code":"833"},"28940":{"name":"Xã Tân Hội","type":"xa","slug":"xa-tan-hoi","name_with_type":"Xã Tân Hội","path":"Xã Tân Hội, Huyện Mỏ Cày Nam, Tỉnh Bến Tre","path_with_type":"Xã Tân Hội, Huyện Mỏ Cày Nam, Tỉnh Bến Tre","code":"28940","parent_code":"833"},"28942":{"name":"Xã Phước Hiệp","type":"xa","slug":"xa-phuoc-hiep","name_with_type":"Xã Phước Hiệp","path":"Xã Phước Hiệp, Huyện Mỏ Cày Nam, Tỉnh Bến Tre","path_with_type":"Xã Phước Hiệp, Huyện Mỏ Cày Nam, Tỉnh Bến Tre","code":"28942","parent_code":"833"},"28945":{"name":"Xã Bình Khánh ","type":"xa","slug":"xa-binh-khanh-","name_with_type":"Xã Bình Khánh ","path":"Xã Bình Khánh , Huyện Mỏ Cày Nam, Tỉnh Bến Tre","path_with_type":"Xã Bình Khánh , Huyện Mỏ Cày Nam, Tỉnh Bến Tre","code":"28945","parent_code":"833"},"28948":{"name":"Xã Khánh Thạnh Tân","type":"xa","slug":"xa-khanh-thanh-tan","name_with_type":"Xã Khánh Thạnh Tân","path":"Xã Khánh Thạnh Tân, Huyện Mỏ Cày Bắc, Tỉnh Bến Tre","path_with_type":"Xã Khánh Thạnh Tân, Huyện Mỏ Cày Bắc, Tỉnh Bến Tre","code":"28948","parent_code":"838"},"28951":{"name":"Xã An Thạnh","type":"xa","slug":"xa-an-thanh","name_with_type":"Xã An Thạnh","path":"Xã An Thạnh, Huyện Mỏ Cày Nam, Tỉnh Bến Tre","path_with_type":"Xã An Thạnh, Huyện Mỏ Cày Nam, Tỉnh Bến Tre","code":"28951","parent_code":"833"},"28957":{"name":"Xã An Định","type":"xa","slug":"xa-an-dinh","name_with_type":"Xã An Định","path":"Xã An Định, Huyện Mỏ Cày Nam, Tỉnh Bến Tre","path_with_type":"Xã An Định, Huyện Mỏ Cày Nam, Tỉnh Bến Tre","code":"28957","parent_code":"833"},"28960":{"name":"Xã Thành Thới B","type":"xa","slug":"xa-thanh-thoi-b","name_with_type":"Xã Thành Thới B","path":"Xã Thành Thới B, Huyện Mỏ Cày Nam, Tỉnh Bến Tre","path_with_type":"Xã Thành Thới B, Huyện Mỏ Cày Nam, Tỉnh Bến Tre","code":"28960","parent_code":"833"},"28963":{"name":"Xã Tân Trung","type":"xa","slug":"xa-tan-trung","name_with_type":"Xã Tân Trung","path":"Xã Tân Trung, Huyện Mỏ Cày Nam, Tỉnh Bến Tre","path_with_type":"Xã Tân Trung, Huyện Mỏ Cày Nam, Tỉnh Bến Tre","code":"28963","parent_code":"833"},"28966":{"name":"Xã An Thới","type":"xa","slug":"xa-an-thoi","name_with_type":"Xã An Thới","path":"Xã An Thới, Huyện Mỏ Cày Nam, Tỉnh Bến Tre","path_with_type":"Xã An Thới, Huyện Mỏ Cày Nam, Tỉnh Bến Tre","code":"28966","parent_code":"833"},"28969":{"name":"Xã Thành Thới A","type":"xa","slug":"xa-thanh-thoi-a","name_with_type":"Xã Thành Thới A","path":"Xã Thành Thới A, Huyện Mỏ Cày Nam, Tỉnh Bến Tre","path_with_type":"Xã Thành Thới A, Huyện Mỏ Cày Nam, Tỉnh Bến Tre","code":"28969","parent_code":"833"},"28972":{"name":"Xã Minh Đức","type":"xa","slug":"xa-minh-duc","name_with_type":"Xã Minh Đức","path":"Xã Minh Đức, Huyện Mỏ Cày Nam, Tỉnh Bến Tre","path_with_type":"Xã Minh Đức, Huyện Mỏ Cày Nam, Tỉnh Bến Tre","code":"28972","parent_code":"833"},"28975":{"name":"Xã Ngãi Đăng","type":"xa","slug":"xa-ngai-dang","name_with_type":"Xã Ngãi Đăng","path":"Xã Ngãi Đăng, Huyện Mỏ Cày Nam, Tỉnh Bến Tre","path_with_type":"Xã Ngãi Đăng, Huyện Mỏ Cày Nam, Tỉnh Bến Tre","code":"28975","parent_code":"833"},"28978":{"name":"Xã Cẩm Sơn","type":"xa","slug":"xa-cam-son","name_with_type":"Xã Cẩm Sơn","path":"Xã Cẩm Sơn, Huyện Mỏ Cày Nam, Tỉnh Bến Tre","path_with_type":"Xã Cẩm Sơn, Huyện Mỏ Cày Nam, Tỉnh Bến Tre","code":"28978","parent_code":"833"},"28981":{"name":"Xã Hương Mỹ","type":"xa","slug":"xa-huong-my","name_with_type":"Xã Hương Mỹ","path":"Xã Hương Mỹ, Huyện Mỏ Cày Nam, Tỉnh Bến Tre","path_with_type":"Xã Hương Mỹ, Huyện Mỏ Cày Nam, Tỉnh Bến Tre","code":"28981","parent_code":"833"},"28984":{"name":"Thị trấn Giồng Trôm","type":"thi-tran","slug":"thi-tran-giong-trom","name_with_type":"Thị trấn Giồng Trôm","path":"Thị trấn Giồng Trôm, Huyện Giồng Trôm, Tỉnh Bến Tre","path_with_type":"Thị trấn Giồng Trôm, Huyện Giồng Trôm, Tỉnh Bến Tre","code":"28984","parent_code":"834"},"28987":{"name":"Xã Phong Nẫm","type":"xa","slug":"xa-phong-nam","name_with_type":"Xã Phong Nẫm","path":"Xã Phong Nẫm, Huyện Giồng Trôm, Tỉnh Bến Tre","path_with_type":"Xã Phong Nẫm, Huyện Giồng Trôm, Tỉnh Bến Tre","code":"28987","parent_code":"834"},"28993":{"name":"Xã Mỹ Thạnh","type":"xa","slug":"xa-my-thanh","name_with_type":"Xã Mỹ Thạnh","path":"Xã Mỹ Thạnh, Huyện Giồng Trôm, Tỉnh Bến Tre","path_with_type":"Xã Mỹ Thạnh, Huyện Giồng Trôm, Tỉnh Bến Tre","code":"28993","parent_code":"834"},"28996":{"name":"Xã Châu Hòa","type":"xa","slug":"xa-chau-hoa","name_with_type":"Xã Châu Hòa","path":"Xã Châu Hòa, Huyện Giồng Trôm, Tỉnh Bến Tre","path_with_type":"Xã Châu Hòa, Huyện Giồng Trôm, Tỉnh Bến Tre","code":"28996","parent_code":"834"},"28999":{"name":"Xã Lương Hòa","type":"xa","slug":"xa-luong-hoa","name_with_type":"Xã Lương Hòa","path":"Xã Lương Hòa, Huyện Giồng Trôm, Tỉnh Bến Tre","path_with_type":"Xã Lương Hòa, Huyện Giồng Trôm, Tỉnh Bến Tre","code":"28999","parent_code":"834"},"29002":{"name":"Xã Lương Quới","type":"xa","slug":"xa-luong-quoi","name_with_type":"Xã Lương Quới","path":"Xã Lương Quới, Huyện Giồng Trôm, Tỉnh Bến Tre","path_with_type":"Xã Lương Quới, Huyện Giồng Trôm, Tỉnh Bến Tre","code":"29002","parent_code":"834"},"29005":{"name":"Xã Lương Phú","type":"xa","slug":"xa-luong-phu","name_with_type":"Xã Lương Phú","path":"Xã Lương Phú, Huyện Giồng Trôm, Tỉnh Bến Tre","path_with_type":"Xã Lương Phú, Huyện Giồng Trôm, Tỉnh Bến Tre","code":"29005","parent_code":"834"},"29008":{"name":"Xã Châu Bình","type":"xa","slug":"xa-chau-binh","name_with_type":"Xã Châu Bình","path":"Xã Châu Bình, Huyện Giồng Trôm, Tỉnh Bến Tre","path_with_type":"Xã Châu Bình, Huyện Giồng Trôm, Tỉnh Bến Tre","code":"29008","parent_code":"834"},"29011":{"name":"Xã Thuận Điền","type":"xa","slug":"xa-thuan-dien","name_with_type":"Xã Thuận Điền","path":"Xã Thuận Điền, Huyện Giồng Trôm, Tỉnh Bến Tre","path_with_type":"Xã Thuận Điền, Huyện Giồng Trôm, Tỉnh Bến Tre","code":"29011","parent_code":"834"},"29014":{"name":"Xã Sơn Phú","type":"xa","slug":"xa-son-phu","name_with_type":"Xã Sơn Phú","path":"Xã Sơn Phú, Huyện Giồng Trôm, Tỉnh Bến Tre","path_with_type":"Xã Sơn Phú, Huyện Giồng Trôm, Tỉnh Bến Tre","code":"29014","parent_code":"834"},"29017":{"name":"Xã Bình Hoà","type":"xa","slug":"xa-binh-hoa","name_with_type":"Xã Bình Hoà","path":"Xã Bình Hoà, Huyện Giồng Trôm, Tỉnh Bến Tre","path_with_type":"Xã Bình Hoà, Huyện Giồng Trôm, Tỉnh Bến Tre","code":"29017","parent_code":"834"},"29020":{"name":"Xã Phước Long","type":"xa","slug":"xa-phuoc-long","name_with_type":"Xã Phước Long","path":"Xã Phước Long, Huyện Giồng Trôm, Tỉnh Bến Tre","path_with_type":"Xã Phước Long, Huyện Giồng Trôm, Tỉnh Bến Tre","code":"29020","parent_code":"834"},"29023":{"name":"Xã Hưng Phong","type":"xa","slug":"xa-hung-phong","name_with_type":"Xã Hưng Phong","path":"Xã Hưng Phong, Huyện Giồng Trôm, Tỉnh Bến Tre","path_with_type":"Xã Hưng Phong, Huyện Giồng Trôm, Tỉnh Bến Tre","code":"29023","parent_code":"834"},"29026":{"name":"Xã Long Mỹ","type":"xa","slug":"xa-long-my","name_with_type":"Xã Long Mỹ","path":"Xã Long Mỹ, Huyện Giồng Trôm, Tỉnh Bến Tre","path_with_type":"Xã Long Mỹ, Huyện Giồng Trôm, Tỉnh Bến Tre","code":"29026","parent_code":"834"},"29029":{"name":"Xã Tân Hào","type":"xa","slug":"xa-tan-hao","name_with_type":"Xã Tân Hào","path":"Xã Tân Hào, Huyện Giồng Trôm, Tỉnh Bến Tre","path_with_type":"Xã Tân Hào, Huyện Giồng Trôm, Tỉnh Bến Tre","code":"29029","parent_code":"834"},"29032":{"name":"Xã Bình Thành","type":"xa","slug":"xa-binh-thanh","name_with_type":"Xã Bình Thành","path":"Xã Bình Thành, Huyện Giồng Trôm, Tỉnh Bến Tre","path_with_type":"Xã Bình Thành, Huyện Giồng Trôm, Tỉnh Bến Tre","code":"29032","parent_code":"834"},"29035":{"name":"Xã Tân Thanh","type":"xa","slug":"xa-tan-thanh","name_with_type":"Xã Tân Thanh","path":"Xã Tân Thanh, Huyện Giồng Trôm, Tỉnh Bến Tre","path_with_type":"Xã Tân Thanh, Huyện Giồng Trôm, Tỉnh Bến Tre","code":"29035","parent_code":"834"},"29038":{"name":"Xã Tân Lợi Thạnh","type":"xa","slug":"xa-tan-loi-thanh","name_with_type":"Xã Tân Lợi Thạnh","path":"Xã Tân Lợi Thạnh, Huyện Giồng Trôm, Tỉnh Bến Tre","path_with_type":"Xã Tân Lợi Thạnh, Huyện Giồng Trôm, Tỉnh Bến Tre","code":"29038","parent_code":"834"},"29041":{"name":"Xã Thạnh Phú Đông","type":"xa","slug":"xa-thanh-phu-dong","name_with_type":"Xã Thạnh Phú Đông","path":"Xã Thạnh Phú Đông, Huyện Giồng Trôm, Tỉnh Bến Tre","path_with_type":"Xã Thạnh Phú Đông, Huyện Giồng Trôm, Tỉnh Bến Tre","code":"29041","parent_code":"834"},"29044":{"name":"Xã Hưng Nhượng","type":"xa","slug":"xa-hung-nhuong","name_with_type":"Xã Hưng Nhượng","path":"Xã Hưng Nhượng, Huyện Giồng Trôm, Tỉnh Bến Tre","path_with_type":"Xã Hưng Nhượng, Huyện Giồng Trôm, Tỉnh Bến Tre","code":"29044","parent_code":"834"},"29047":{"name":"Xã Hưng Lễ","type":"xa","slug":"xa-hung-le","name_with_type":"Xã Hưng Lễ","path":"Xã Hưng Lễ, Huyện Giồng Trôm, Tỉnh Bến Tre","path_with_type":"Xã Hưng Lễ, Huyện Giồng Trôm, Tỉnh Bến Tre","code":"29047","parent_code":"834"},"29050":{"name":"Thị trấn Bình Đại","type":"thi-tran","slug":"thi-tran-binh-dai","name_with_type":"Thị trấn Bình Đại","path":"Thị trấn Bình Đại, Huyện Bình Đại, Tỉnh Bến Tre","path_with_type":"Thị trấn Bình Đại, Huyện Bình Đại, Tỉnh Bến Tre","code":"29050","parent_code":"835"},"29053":{"name":"Xã Tam Hiệp","type":"xa","slug":"xa-tam-hiep","name_with_type":"Xã Tam Hiệp","path":"Xã Tam Hiệp, Huyện Bình Đại, Tỉnh Bến Tre","path_with_type":"Xã Tam Hiệp, Huyện Bình Đại, Tỉnh Bến Tre","code":"29053","parent_code":"835"},"29056":{"name":"Xã Long Định","type":"xa","slug":"xa-long-dinh","name_with_type":"Xã Long Định","path":"Xã Long Định, Huyện Bình Đại, Tỉnh Bến Tre","path_with_type":"Xã Long Định, Huyện Bình Đại, Tỉnh Bến Tre","code":"29056","parent_code":"835"},"29059":{"name":"Xã Long Hòa","type":"xa","slug":"xa-long-hoa","name_with_type":"Xã Long Hòa","path":"Xã Long Hòa, Huyện Bình Đại, Tỉnh Bến Tre","path_with_type":"Xã Long Hòa, Huyện Bình Đại, Tỉnh Bến Tre","code":"29059","parent_code":"835"},"29062":{"name":"Xã Phú Thuận","type":"xa","slug":"xa-phu-thuan","name_with_type":"Xã Phú Thuận","path":"Xã Phú Thuận, Huyện Bình Đại, Tỉnh Bến Tre","path_with_type":"Xã Phú Thuận, Huyện Bình Đại, Tỉnh Bến Tre","code":"29062","parent_code":"835"},"29065":{"name":"Xã Vang Quới Tây","type":"xa","slug":"xa-vang-quoi-tay","name_with_type":"Xã Vang Quới Tây","path":"Xã Vang Quới Tây, Huyện Bình Đại, Tỉnh Bến Tre","path_with_type":"Xã Vang Quới Tây, Huyện Bình Đại, Tỉnh Bến Tre","code":"29065","parent_code":"835"},"29068":{"name":"Xã Vang Quới Đông","type":"xa","slug":"xa-vang-quoi-dong","name_with_type":"Xã Vang Quới Đông","path":"Xã Vang Quới Đông, Huyện Bình Đại, Tỉnh Bến Tre","path_with_type":"Xã Vang Quới Đông, Huyện Bình Đại, Tỉnh Bến Tre","code":"29068","parent_code":"835"},"29071":{"name":"Xã Châu Hưng","type":"xa","slug":"xa-chau-hung","name_with_type":"Xã Châu Hưng","path":"Xã Châu Hưng, Huyện Bình Đại, Tỉnh Bến Tre","path_with_type":"Xã Châu Hưng, Huyện Bình Đại, Tỉnh Bến Tre","code":"29071","parent_code":"835"},"29077":{"name":"Xã Lộc Thuận","type":"xa","slug":"xa-loc-thuan","name_with_type":"Xã Lộc Thuận","path":"Xã Lộc Thuận, Huyện Bình Đại, Tỉnh Bến Tre","path_with_type":"Xã Lộc Thuận, Huyện Bình Đại, Tỉnh Bến Tre","code":"29077","parent_code":"835"},"29080":{"name":"Xã Định Trung","type":"xa","slug":"xa-dinh-trung","name_with_type":"Xã Định Trung","path":"Xã Định Trung, Huyện Bình Đại, Tỉnh Bến Tre","path_with_type":"Xã Định Trung, Huyện Bình Đại, Tỉnh Bến Tre","code":"29080","parent_code":"835"},"29083":{"name":"Xã Thới Lai","type":"xa","slug":"xa-thoi-lai","name_with_type":"Xã Thới Lai","path":"Xã Thới Lai, Huyện Bình Đại, Tỉnh Bến Tre","path_with_type":"Xã Thới Lai, Huyện Bình Đại, Tỉnh Bến Tre","code":"29083","parent_code":"835"},"29086":{"name":"Xã Bình Thới","type":"xa","slug":"xa-binh-thoi","name_with_type":"Xã Bình Thới","path":"Xã Bình Thới, Huyện Bình Đại, Tỉnh Bến Tre","path_with_type":"Xã Bình Thới, Huyện Bình Đại, Tỉnh Bến Tre","code":"29086","parent_code":"835"},"29089":{"name":"Xã Phú Long","type":"xa","slug":"xa-phu-long","name_with_type":"Xã Phú Long","path":"Xã Phú Long, Huyện Bình Đại, Tỉnh Bến Tre","path_with_type":"Xã Phú Long, Huyện Bình Đại, Tỉnh Bến Tre","code":"29089","parent_code":"835"},"29092":{"name":"Xã Bình Thắng","type":"xa","slug":"xa-binh-thang","name_with_type":"Xã Bình Thắng","path":"Xã Bình Thắng, Huyện Bình Đại, Tỉnh Bến Tre","path_with_type":"Xã Bình Thắng, Huyện Bình Đại, Tỉnh Bến Tre","code":"29092","parent_code":"835"},"29095":{"name":"Xã Thạnh Trị","type":"xa","slug":"xa-thanh-tri","name_with_type":"Xã Thạnh Trị","path":"Xã Thạnh Trị, Huyện Bình Đại, Tỉnh Bến Tre","path_with_type":"Xã Thạnh Trị, Huyện Bình Đại, Tỉnh Bến Tre","code":"29095","parent_code":"835"},"29098":{"name":"Xã Đại Hòa Lộc","type":"xa","slug":"xa-dai-hoa-loc","name_with_type":"Xã Đại Hòa Lộc","path":"Xã Đại Hòa Lộc, Huyện Bình Đại, Tỉnh Bến Tre","path_with_type":"Xã Đại Hòa Lộc, Huyện Bình Đại, Tỉnh Bến Tre","code":"29098","parent_code":"835"},"29101":{"name":"Xã Thừa Đức","type":"xa","slug":"xa-thua-duc","name_with_type":"Xã Thừa Đức","path":"Xã Thừa Đức, Huyện Bình Đại, Tỉnh Bến Tre","path_with_type":"Xã Thừa Đức, Huyện Bình Đại, Tỉnh Bến Tre","code":"29101","parent_code":"835"},"29104":{"name":"Xã Thạnh Phước","type":"xa","slug":"xa-thanh-phuoc","name_with_type":"Xã Thạnh Phước","path":"Xã Thạnh Phước, Huyện Bình Đại, Tỉnh Bến Tre","path_with_type":"Xã Thạnh Phước, Huyện Bình Đại, Tỉnh Bến Tre","code":"29104","parent_code":"835"},"29107":{"name":"Xã Thới Thuận","type":"xa","slug":"xa-thoi-thuan","name_with_type":"Xã Thới Thuận","path":"Xã Thới Thuận, Huyện Bình Đại, Tỉnh Bến Tre","path_with_type":"Xã Thới Thuận, Huyện Bình Đại, Tỉnh Bến Tre","code":"29107","parent_code":"835"},"29110":{"name":"Thị trấn Ba Tri","type":"thi-tran","slug":"thi-tran-ba-tri","name_with_type":"Thị trấn Ba Tri","path":"Thị trấn Ba Tri, Huyện Ba Tri, Tỉnh Bến Tre","path_with_type":"Thị trấn Ba Tri, Huyện Ba Tri, Tỉnh Bến Tre","code":"29110","parent_code":"836"},"29116":{"name":"Xã Mỹ Hòa","type":"xa","slug":"xa-my-hoa","name_with_type":"Xã Mỹ Hòa","path":"Xã Mỹ Hòa, Huyện Ba Tri, Tỉnh Bến Tre","path_with_type":"Xã Mỹ Hòa, Huyện Ba Tri, Tỉnh Bến Tre","code":"29116","parent_code":"836"},"29119":{"name":"Xã Tân Xuân","type":"xa","slug":"xa-tan-xuan","name_with_type":"Xã Tân Xuân","path":"Xã Tân Xuân, Huyện Ba Tri, Tỉnh Bến Tre","path_with_type":"Xã Tân Xuân, Huyện Ba Tri, Tỉnh Bến Tre","code":"29119","parent_code":"836"},"29122":{"name":"Xã Mỹ Chánh","type":"xa","slug":"xa-my-chanh","name_with_type":"Xã Mỹ Chánh","path":"Xã Mỹ Chánh, Huyện Ba Tri, Tỉnh Bến Tre","path_with_type":"Xã Mỹ Chánh, Huyện Ba Tri, Tỉnh Bến Tre","code":"29122","parent_code":"836"},"29125":{"name":"Xã Bảo Thạnh","type":"xa","slug":"xa-bao-thanh","name_with_type":"Xã Bảo Thạnh","path":"Xã Bảo Thạnh, Huyện Ba Tri, Tỉnh Bến Tre","path_with_type":"Xã Bảo Thạnh, Huyện Ba Tri, Tỉnh Bến Tre","code":"29125","parent_code":"836"},"29128":{"name":"Xã An Phú Trung","type":"xa","slug":"xa-an-phu-trung","name_with_type":"Xã An Phú Trung","path":"Xã An Phú Trung, Huyện Ba Tri, Tỉnh Bến Tre","path_with_type":"Xã An Phú Trung, Huyện Ba Tri, Tỉnh Bến Tre","code":"29128","parent_code":"836"},"29131":{"name":"Xã Mỹ Thạnh","type":"xa","slug":"xa-my-thanh","name_with_type":"Xã Mỹ Thạnh","path":"Xã Mỹ Thạnh, Huyện Ba Tri, Tỉnh Bến Tre","path_with_type":"Xã Mỹ Thạnh, Huyện Ba Tri, Tỉnh Bến Tre","code":"29131","parent_code":"836"},"29134":{"name":"Xã Mỹ Nhơn","type":"xa","slug":"xa-my-nhon","name_with_type":"Xã Mỹ Nhơn","path":"Xã Mỹ Nhơn, Huyện Ba Tri, Tỉnh Bến Tre","path_with_type":"Xã Mỹ Nhơn, Huyện Ba Tri, Tỉnh Bến Tre","code":"29134","parent_code":"836"},"29137":{"name":"Xã Phước Ngãi","type":"xa","slug":"xa-phuoc-ngai","name_with_type":"Xã Phước Ngãi","path":"Xã Phước Ngãi, Huyện Ba Tri, Tỉnh Bến Tre","path_with_type":"Xã Phước Ngãi, Huyện Ba Tri, Tỉnh Bến Tre","code":"29137","parent_code":"836"},"29143":{"name":"Xã An Ngãi Trung","type":"xa","slug":"xa-an-ngai-trung","name_with_type":"Xã An Ngãi Trung","path":"Xã An Ngãi Trung, Huyện Ba Tri, Tỉnh Bến Tre","path_with_type":"Xã An Ngãi Trung, Huyện Ba Tri, Tỉnh Bến Tre","code":"29143","parent_code":"836"},"29146":{"name":"Xã Phú Lễ","type":"xa","slug":"xa-phu-le","name_with_type":"Xã Phú Lễ","path":"Xã Phú Lễ, Huyện Ba Tri, Tỉnh Bến Tre","path_with_type":"Xã Phú Lễ, Huyện Ba Tri, Tỉnh Bến Tre","code":"29146","parent_code":"836"},"29149":{"name":"Xã An Bình Tây","type":"xa","slug":"xa-an-binh-tay","name_with_type":"Xã An Bình Tây","path":"Xã An Bình Tây, Huyện Ba Tri, Tỉnh Bến Tre","path_with_type":"Xã An Bình Tây, Huyện Ba Tri, Tỉnh Bến Tre","code":"29149","parent_code":"836"},"29152":{"name":"Xã Bảo Thuận","type":"xa","slug":"xa-bao-thuan","name_with_type":"Xã Bảo Thuận","path":"Xã Bảo Thuận, Huyện Ba Tri, Tỉnh Bến Tre","path_with_type":"Xã Bảo Thuận, Huyện Ba Tri, Tỉnh Bến Tre","code":"29152","parent_code":"836"},"29155":{"name":"Xã Tân Hưng","type":"xa","slug":"xa-tan-hung","name_with_type":"Xã Tân Hưng","path":"Xã Tân Hưng, Huyện Ba Tri, Tỉnh Bến Tre","path_with_type":"Xã Tân Hưng, Huyện Ba Tri, Tỉnh Bến Tre","code":"29155","parent_code":"836"},"29158":{"name":"Xã An Ngãi Tây","type":"xa","slug":"xa-an-ngai-tay","name_with_type":"Xã An Ngãi Tây","path":"Xã An Ngãi Tây, Huyện Ba Tri, Tỉnh Bến Tre","path_with_type":"Xã An Ngãi Tây, Huyện Ba Tri, Tỉnh Bến Tre","code":"29158","parent_code":"836"},"29161":{"name":"Xã An Hiệp","type":"xa","slug":"xa-an-hiep","name_with_type":"Xã An Hiệp","path":"Xã An Hiệp, Huyện Ba Tri, Tỉnh Bến Tre","path_with_type":"Xã An Hiệp, Huyện Ba Tri, Tỉnh Bến Tre","code":"29161","parent_code":"836"},"29164":{"name":"Xã Vĩnh Hòa","type":"xa","slug":"xa-vinh-hoa","name_with_type":"Xã Vĩnh Hòa","path":"Xã Vĩnh Hòa, Huyện Ba Tri, Tỉnh Bến Tre","path_with_type":"Xã Vĩnh Hòa, Huyện Ba Tri, Tỉnh Bến Tre","code":"29164","parent_code":"836"},"29167":{"name":"Xã Tân Thủy","type":"xa","slug":"xa-tan-thuy","name_with_type":"Xã Tân Thủy","path":"Xã Tân Thủy, Huyện Ba Tri, Tỉnh Bến Tre","path_with_type":"Xã Tân Thủy, Huyện Ba Tri, Tỉnh Bến Tre","code":"29167","parent_code":"836"},"29170":{"name":"Xã Vĩnh An","type":"xa","slug":"xa-vinh-an","name_with_type":"Xã Vĩnh An","path":"Xã Vĩnh An, Huyện Ba Tri, Tỉnh Bến Tre","path_with_type":"Xã Vĩnh An, Huyện Ba Tri, Tỉnh Bến Tre","code":"29170","parent_code":"836"},"29173":{"name":"Xã An Đức","type":"xa","slug":"xa-an-duc","name_with_type":"Xã An Đức","path":"Xã An Đức, Huyện Ba Tri, Tỉnh Bến Tre","path_with_type":"Xã An Đức, Huyện Ba Tri, Tỉnh Bến Tre","code":"29173","parent_code":"836"},"29176":{"name":"Xã An Hòa Tây","type":"xa","slug":"xa-an-hoa-tay","name_with_type":"Xã An Hòa Tây","path":"Xã An Hòa Tây, Huyện Ba Tri, Tỉnh Bến Tre","path_with_type":"Xã An Hòa Tây, Huyện Ba Tri, Tỉnh Bến Tre","code":"29176","parent_code":"836"},"29179":{"name":"Thị trấn Tiệm Tôm","type":"thi-tran","slug":"thi-tran-tiem-tom","name_with_type":"Thị trấn Tiệm Tôm","path":"Thị trấn Tiệm Tôm, Huyện Ba Tri, Tỉnh Bến Tre","path_with_type":"Thị trấn Tiệm Tôm, Huyện Ba Tri, Tỉnh Bến Tre","code":"29179","parent_code":"836"},"29182":{"name":"Thị trấn Thạnh Phú","type":"thi-tran","slug":"thi-tran-thanh-phu","name_with_type":"Thị trấn Thạnh Phú","path":"Thị trấn Thạnh Phú, Huyện Thạnh Phú, Tỉnh Bến Tre","path_with_type":"Thị trấn Thạnh Phú, Huyện Thạnh Phú, Tỉnh Bến Tre","code":"29182","parent_code":"837"},"29185":{"name":"Xã Phú Khánh","type":"xa","slug":"xa-phu-khanh","name_with_type":"Xã Phú Khánh","path":"Xã Phú Khánh, Huyện Thạnh Phú, Tỉnh Bến Tre","path_with_type":"Xã Phú Khánh, Huyện Thạnh Phú, Tỉnh Bến Tre","code":"29185","parent_code":"837"},"29188":{"name":"Xã Đại Điền","type":"xa","slug":"xa-dai-dien","name_with_type":"Xã Đại Điền","path":"Xã Đại Điền, Huyện Thạnh Phú, Tỉnh Bến Tre","path_with_type":"Xã Đại Điền, Huyện Thạnh Phú, Tỉnh Bến Tre","code":"29188","parent_code":"837"},"29191":{"name":"Xã Quới Điền","type":"xa","slug":"xa-quoi-dien","name_with_type":"Xã Quới Điền","path":"Xã Quới Điền, Huyện Thạnh Phú, Tỉnh Bến Tre","path_with_type":"Xã Quới Điền, Huyện Thạnh Phú, Tỉnh Bến Tre","code":"29191","parent_code":"837"},"29194":{"name":"Xã Tân Phong","type":"xa","slug":"xa-tan-phong","name_with_type":"Xã Tân Phong","path":"Xã Tân Phong, Huyện Thạnh Phú, Tỉnh Bến Tre","path_with_type":"Xã Tân Phong, Huyện Thạnh Phú, Tỉnh Bến Tre","code":"29194","parent_code":"837"},"29197":{"name":"Xã Mỹ Hưng","type":"xa","slug":"xa-my-hung","name_with_type":"Xã Mỹ Hưng","path":"Xã Mỹ Hưng, Huyện Thạnh Phú, Tỉnh Bến Tre","path_with_type":"Xã Mỹ Hưng, Huyện Thạnh Phú, Tỉnh Bến Tre","code":"29197","parent_code":"837"},"29200":{"name":"Xã An Thạnh","type":"xa","slug":"xa-an-thanh","name_with_type":"Xã An Thạnh","path":"Xã An Thạnh, Huyện Thạnh Phú, Tỉnh Bến Tre","path_with_type":"Xã An Thạnh, Huyện Thạnh Phú, Tỉnh Bến Tre","code":"29200","parent_code":"837"},"29203":{"name":"Xã Thới Thạnh","type":"xa","slug":"xa-thoi-thanh","name_with_type":"Xã Thới Thạnh","path":"Xã Thới Thạnh, Huyện Thạnh Phú, Tỉnh Bến Tre","path_with_type":"Xã Thới Thạnh, Huyện Thạnh Phú, Tỉnh Bến Tre","code":"29203","parent_code":"837"},"29206":{"name":"Xã Hòa Lợi","type":"xa","slug":"xa-hoa-loi","name_with_type":"Xã Hòa Lợi","path":"Xã Hòa Lợi, Huyện Thạnh Phú, Tỉnh Bến Tre","path_with_type":"Xã Hòa Lợi, Huyện Thạnh Phú, Tỉnh Bến Tre","code":"29206","parent_code":"837"},"29209":{"name":"Xã An Điền","type":"xa","slug":"xa-an-dien","name_with_type":"Xã An Điền","path":"Xã An Điền, Huyện Thạnh Phú, Tỉnh Bến Tre","path_with_type":"Xã An Điền, Huyện Thạnh Phú, Tỉnh Bến Tre","code":"29209","parent_code":"837"},"29212":{"name":"Xã Bình Thạnh","type":"xa","slug":"xa-binh-thanh","name_with_type":"Xã Bình Thạnh","path":"Xã Bình Thạnh, Huyện Thạnh Phú, Tỉnh Bến Tre","path_with_type":"Xã Bình Thạnh, Huyện Thạnh Phú, Tỉnh Bến Tre","code":"29212","parent_code":"837"},"29215":{"name":"Xã An Thuận","type":"xa","slug":"xa-an-thuan","name_with_type":"Xã An Thuận","path":"Xã An Thuận, Huyện Thạnh Phú, Tỉnh Bến Tre","path_with_type":"Xã An Thuận, Huyện Thạnh Phú, Tỉnh Bến Tre","code":"29215","parent_code":"837"},"29218":{"name":"Xã An Quy","type":"xa","slug":"xa-an-quy","name_with_type":"Xã An Quy","path":"Xã An Quy, Huyện Thạnh Phú, Tỉnh Bến Tre","path_with_type":"Xã An Quy, Huyện Thạnh Phú, Tỉnh Bến Tre","code":"29218","parent_code":"837"},"29221":{"name":"Xã Thạnh Hải","type":"xa","slug":"xa-thanh-hai","name_with_type":"Xã Thạnh Hải","path":"Xã Thạnh Hải, Huyện Thạnh Phú, Tỉnh Bến Tre","path_with_type":"Xã Thạnh Hải, Huyện Thạnh Phú, Tỉnh Bến Tre","code":"29221","parent_code":"837"},"29224":{"name":"Xã An Nhơn","type":"xa","slug":"xa-an-nhon","name_with_type":"Xã An Nhơn","path":"Xã An Nhơn, Huyện Thạnh Phú, Tỉnh Bến Tre","path_with_type":"Xã An Nhơn, Huyện Thạnh Phú, Tỉnh Bến Tre","code":"29224","parent_code":"837"},"29227":{"name":"Xã Giao Thạnh","type":"xa","slug":"xa-giao-thanh","name_with_type":"Xã Giao Thạnh","path":"Xã Giao Thạnh, Huyện Thạnh Phú, Tỉnh Bến Tre","path_with_type":"Xã Giao Thạnh, Huyện Thạnh Phú, Tỉnh Bến Tre","code":"29227","parent_code":"837"},"29230":{"name":"Xã Thạnh Phong","type":"xa","slug":"xa-thanh-phong","name_with_type":"Xã Thạnh Phong","path":"Xã Thạnh Phong, Huyện Thạnh Phú, Tỉnh Bến Tre","path_with_type":"Xã Thạnh Phong, Huyện Thạnh Phú, Tỉnh Bến Tre","code":"29230","parent_code":"837"},"29233":{"name":"Xã Mỹ An","type":"xa","slug":"xa-my-an","name_with_type":"Xã Mỹ An","path":"Xã Mỹ An, Huyện Thạnh Phú, Tỉnh Bến Tre","path_with_type":"Xã Mỹ An, Huyện Thạnh Phú, Tỉnh Bến Tre","code":"29233","parent_code":"837"},"29236":{"name":"Phường 4","type":"phuong","slug":"phuong-4","name_with_type":"Phường 4","path":"Phường 4, Thành phố Trà Vinh, Tỉnh Trà Vinh","path_with_type":"Phường 4, Thành phố Trà Vinh, Tỉnh Trà Vinh","code":"29236","parent_code":"842"},"29239":{"name":"Phường 1","type":"phuong","slug":"phuong-1","name_with_type":"Phường 1","path":"Phường 1, Thành phố Trà Vinh, Tỉnh Trà Vinh","path_with_type":"Phường 1, Thành phố Trà Vinh, Tỉnh Trà Vinh","code":"29239","parent_code":"842"},"29242":{"name":"Phường 3","type":"phuong","slug":"phuong-3","name_with_type":"Phường 3","path":"Phường 3, Thành phố Trà Vinh, Tỉnh Trà Vinh","path_with_type":"Phường 3, Thành phố Trà Vinh, Tỉnh Trà Vinh","code":"29242","parent_code":"842"},"29248":{"name":"Phường 5","type":"phuong","slug":"phuong-5","name_with_type":"Phường 5","path":"Phường 5, Thành phố Trà Vinh, Tỉnh Trà Vinh","path_with_type":"Phường 5, Thành phố Trà Vinh, Tỉnh Trà Vinh","code":"29248","parent_code":"842"},"29254":{"name":"Phường 7","type":"phuong","slug":"phuong-7","name_with_type":"Phường 7","path":"Phường 7, Thành phố Trà Vinh, Tỉnh Trà Vinh","path_with_type":"Phường 7, Thành phố Trà Vinh, Tỉnh Trà Vinh","code":"29254","parent_code":"842"},"29257":{"name":"Phường 8","type":"phuong","slug":"phuong-8","name_with_type":"Phường 8","path":"Phường 8, Thành phố Trà Vinh, Tỉnh Trà Vinh","path_with_type":"Phường 8, Thành phố Trà Vinh, Tỉnh Trà Vinh","code":"29257","parent_code":"842"},"29260":{"name":"Phường 9","type":"phuong","slug":"phuong-9","name_with_type":"Phường 9","path":"Phường 9, Thành phố Trà Vinh, Tỉnh Trà Vinh","path_with_type":"Phường 9, Thành phố Trà Vinh, Tỉnh Trà Vinh","code":"29260","parent_code":"842"},"29263":{"name":"Xã Long Đức","type":"xa","slug":"xa-long-duc","name_with_type":"Xã Long Đức","path":"Xã Long Đức, Thành phố Trà Vinh, Tỉnh Trà Vinh","path_with_type":"Xã Long Đức, Thành phố Trà Vinh, Tỉnh Trà Vinh","code":"29263","parent_code":"842"},"29266":{"name":"Thị trấn Càng Long","type":"thi-tran","slug":"thi-tran-cang-long","name_with_type":"Thị trấn Càng Long","path":"Thị trấn Càng Long, Huyện Càng Long, Tỉnh Trà Vinh","path_with_type":"Thị trấn Càng Long, Huyện Càng Long, Tỉnh Trà Vinh","code":"29266","parent_code":"844"},"29269":{"name":"Xã Mỹ Cẩm","type":"xa","slug":"xa-my-cam","name_with_type":"Xã Mỹ Cẩm","path":"Xã Mỹ Cẩm, Huyện Càng Long, Tỉnh Trà Vinh","path_with_type":"Xã Mỹ Cẩm, Huyện Càng Long, Tỉnh Trà Vinh","code":"29269","parent_code":"844"},"29272":{"name":"Xã An Trường A","type":"xa","slug":"xa-an-truong-a","name_with_type":"Xã An Trường A","path":"Xã An Trường A, Huyện Càng Long, Tỉnh Trà Vinh","path_with_type":"Xã An Trường A, Huyện Càng Long, Tỉnh Trà Vinh","code":"29272","parent_code":"844"},"29275":{"name":"Xã An Trường","type":"xa","slug":"xa-an-truong","name_with_type":"Xã An Trường","path":"Xã An Trường, Huyện Càng Long, Tỉnh Trà Vinh","path_with_type":"Xã An Trường, Huyện Càng Long, Tỉnh Trà Vinh","code":"29275","parent_code":"844"},"29278":{"name":"Xã Huyền Hội","type":"xa","slug":"xa-huyen-hoi","name_with_type":"Xã Huyền Hội","path":"Xã Huyền Hội, Huyện Càng Long, Tỉnh Trà Vinh","path_with_type":"Xã Huyền Hội, Huyện Càng Long, Tỉnh Trà Vinh","code":"29278","parent_code":"844"},"29281":{"name":"Xã Tân An","type":"xa","slug":"xa-tan-an","name_with_type":"Xã Tân An","path":"Xã Tân An, Huyện Càng Long, Tỉnh Trà Vinh","path_with_type":"Xã Tân An, Huyện Càng Long, Tỉnh Trà Vinh","code":"29281","parent_code":"844"},"29284":{"name":"Xã Tân Bình","type":"xa","slug":"xa-tan-binh","name_with_type":"Xã Tân Bình","path":"Xã Tân Bình, Huyện Càng Long, Tỉnh Trà Vinh","path_with_type":"Xã Tân Bình, Huyện Càng Long, Tỉnh Trà Vinh","code":"29284","parent_code":"844"},"29287":{"name":"Xã Bình Phú","type":"xa","slug":"xa-binh-phu","name_with_type":"Xã Bình Phú","path":"Xã Bình Phú, Huyện Càng Long, Tỉnh Trà Vinh","path_with_type":"Xã Bình Phú, Huyện Càng Long, Tỉnh Trà Vinh","code":"29287","parent_code":"844"},"29290":{"name":"Xã Phương Thạnh","type":"xa","slug":"xa-phuong-thanh","name_with_type":"Xã Phương Thạnh","path":"Xã Phương Thạnh, Huyện Càng Long, Tỉnh Trà Vinh","path_with_type":"Xã Phương Thạnh, Huyện Càng Long, Tỉnh Trà Vinh","code":"29290","parent_code":"844"},"29293":{"name":"Xã Đại Phúc","type":"xa","slug":"xa-dai-phuc","name_with_type":"Xã Đại Phúc","path":"Xã Đại Phúc, Huyện Càng Long, Tỉnh Trà Vinh","path_with_type":"Xã Đại Phúc, Huyện Càng Long, Tỉnh Trà Vinh","code":"29293","parent_code":"844"},"29296":{"name":"Xã Đại Phước","type":"xa","slug":"xa-dai-phuoc","name_with_type":"Xã Đại Phước","path":"Xã Đại Phước, Huyện Càng Long, Tỉnh Trà Vinh","path_with_type":"Xã Đại Phước, Huyện Càng Long, Tỉnh Trà Vinh","code":"29296","parent_code":"844"},"29299":{"name":"Xã Nhị Long Phú","type":"xa","slug":"xa-nhi-long-phu","name_with_type":"Xã Nhị Long Phú","path":"Xã Nhị Long Phú, Huyện Càng Long, Tỉnh Trà Vinh","path_with_type":"Xã Nhị Long Phú, Huyện Càng Long, Tỉnh Trà Vinh","code":"29299","parent_code":"844"},"29302":{"name":"Xã Nhị Long","type":"xa","slug":"xa-nhi-long","name_with_type":"Xã Nhị Long","path":"Xã Nhị Long, Huyện Càng Long, Tỉnh Trà Vinh","path_with_type":"Xã Nhị Long, Huyện Càng Long, Tỉnh Trà Vinh","code":"29302","parent_code":"844"},"29305":{"name":"Xã Đức Mỹ","type":"xa","slug":"xa-duc-my","name_with_type":"Xã Đức Mỹ","path":"Xã Đức Mỹ, Huyện Càng Long, Tỉnh Trà Vinh","path_with_type":"Xã Đức Mỹ, Huyện Càng Long, Tỉnh Trà Vinh","code":"29305","parent_code":"844"},"29308":{"name":"Thị trấn Cầu Kè","type":"thi-tran","slug":"thi-tran-cau-ke","name_with_type":"Thị trấn Cầu Kè","path":"Thị trấn Cầu Kè, Huyện Cầu Kè, Tỉnh Trà Vinh","path_with_type":"Thị trấn Cầu Kè, Huyện Cầu Kè, Tỉnh Trà Vinh","code":"29308","parent_code":"845"},"29311":{"name":"Xã Hòa Ân","type":"xa","slug":"xa-hoa-an","name_with_type":"Xã Hòa Ân","path":"Xã Hòa Ân, Huyện Cầu Kè, Tỉnh Trà Vinh","path_with_type":"Xã Hòa Ân, Huyện Cầu Kè, Tỉnh Trà Vinh","code":"29311","parent_code":"845"},"29314":{"name":"Xã Châu Điền","type":"xa","slug":"xa-chau-dien","name_with_type":"Xã Châu Điền","path":"Xã Châu Điền, Huyện Cầu Kè, Tỉnh Trà Vinh","path_with_type":"Xã Châu Điền, Huyện Cầu Kè, Tỉnh Trà Vinh","code":"29314","parent_code":"845"},"29317":{"name":"Xã An Phú Tân","type":"xa","slug":"xa-an-phu-tan","name_with_type":"Xã An Phú Tân","path":"Xã An Phú Tân, Huyện Cầu Kè, Tỉnh Trà Vinh","path_with_type":"Xã An Phú Tân, Huyện Cầu Kè, Tỉnh Trà Vinh","code":"29317","parent_code":"845"},"29320":{"name":"Xã Hoà Tân","type":"xa","slug":"xa-hoa-tan","name_with_type":"Xã Hoà Tân","path":"Xã Hoà Tân, Huyện Cầu Kè, Tỉnh Trà Vinh","path_with_type":"Xã Hoà Tân, Huyện Cầu Kè, Tỉnh Trà Vinh","code":"29320","parent_code":"845"},"29323":{"name":"Xã Ninh Thới","type":"xa","slug":"xa-ninh-thoi","name_with_type":"Xã Ninh Thới","path":"Xã Ninh Thới, Huyện Cầu Kè, Tỉnh Trà Vinh","path_with_type":"Xã Ninh Thới, Huyện Cầu Kè, Tỉnh Trà Vinh","code":"29323","parent_code":"845"},"29326":{"name":"Xã Phong Phú","type":"xa","slug":"xa-phong-phu","name_with_type":"Xã Phong Phú","path":"Xã Phong Phú, Huyện Cầu Kè, Tỉnh Trà Vinh","path_with_type":"Xã Phong Phú, Huyện Cầu Kè, Tỉnh Trà Vinh","code":"29326","parent_code":"845"},"29329":{"name":"Xã Phong Thạnh","type":"xa","slug":"xa-phong-thanh","name_with_type":"Xã Phong Thạnh","path":"Xã Phong Thạnh, Huyện Cầu Kè, Tỉnh Trà Vinh","path_with_type":"Xã Phong Thạnh, Huyện Cầu Kè, Tỉnh Trà Vinh","code":"29329","parent_code":"845"},"29332":{"name":"Xã Tam Ngãi","type":"xa","slug":"xa-tam-ngai","name_with_type":"Xã Tam Ngãi","path":"Xã Tam Ngãi, Huyện Cầu Kè, Tỉnh Trà Vinh","path_with_type":"Xã Tam Ngãi, Huyện Cầu Kè, Tỉnh Trà Vinh","code":"29332","parent_code":"845"},"29335":{"name":"Xã Thông Hòa","type":"xa","slug":"xa-thong-hoa","name_with_type":"Xã Thông Hòa","path":"Xã Thông Hòa, Huyện Cầu Kè, Tỉnh Trà Vinh","path_with_type":"Xã Thông Hòa, Huyện Cầu Kè, Tỉnh Trà Vinh","code":"29335","parent_code":"845"},"29338":{"name":"Xã Thạnh Phú","type":"xa","slug":"xa-thanh-phu","name_with_type":"Xã Thạnh Phú","path":"Xã Thạnh Phú, Huyện Cầu Kè, Tỉnh Trà Vinh","path_with_type":"Xã Thạnh Phú, Huyện Cầu Kè, Tỉnh Trà Vinh","code":"29338","parent_code":"845"},"29341":{"name":"Thị trấn Tiểu Cần","type":"thi-tran","slug":"thi-tran-tieu-can","name_with_type":"Thị trấn Tiểu Cần","path":"Thị trấn Tiểu Cần, Huyện Tiểu Cần, Tỉnh Trà Vinh","path_with_type":"Thị trấn Tiểu Cần, Huyện Tiểu Cần, Tỉnh Trà Vinh","code":"29341","parent_code":"846"},"29344":{"name":"Thị trấn Cầu Quan","type":"thi-tran","slug":"thi-tran-cau-quan","name_with_type":"Thị trấn Cầu Quan","path":"Thị trấn Cầu Quan, Huyện Tiểu Cần, Tỉnh Trà Vinh","path_with_type":"Thị trấn Cầu Quan, Huyện Tiểu Cần, Tỉnh Trà Vinh","code":"29344","parent_code":"846"},"29347":{"name":"Xã Phú Cần","type":"xa","slug":"xa-phu-can","name_with_type":"Xã Phú Cần","path":"Xã Phú Cần, Huyện Tiểu Cần, Tỉnh Trà Vinh","path_with_type":"Xã Phú Cần, Huyện Tiểu Cần, Tỉnh Trà Vinh","code":"29347","parent_code":"846"},"29350":{"name":"Xã Hiếu Tử","type":"xa","slug":"xa-hieu-tu","name_with_type":"Xã Hiếu Tử","path":"Xã Hiếu Tử, Huyện Tiểu Cần, Tỉnh Trà Vinh","path_with_type":"Xã Hiếu Tử, Huyện Tiểu Cần, Tỉnh Trà Vinh","code":"29350","parent_code":"846"},"29353":{"name":"Xã Hiếu Trung","type":"xa","slug":"xa-hieu-trung","name_with_type":"Xã Hiếu Trung","path":"Xã Hiếu Trung, Huyện Tiểu Cần, Tỉnh Trà Vinh","path_with_type":"Xã Hiếu Trung, Huyện Tiểu Cần, Tỉnh Trà Vinh","code":"29353","parent_code":"846"},"29356":{"name":"Xã Long Thới","type":"xa","slug":"xa-long-thoi","name_with_type":"Xã Long Thới","path":"Xã Long Thới, Huyện Tiểu Cần, Tỉnh Trà Vinh","path_with_type":"Xã Long Thới, Huyện Tiểu Cần, Tỉnh Trà Vinh","code":"29356","parent_code":"846"},"29359":{"name":"Xã Hùng Hòa","type":"xa","slug":"xa-hung-hoa","name_with_type":"Xã Hùng Hòa","path":"Xã Hùng Hòa, Huyện Tiểu Cần, Tỉnh Trà Vinh","path_with_type":"Xã Hùng Hòa, Huyện Tiểu Cần, Tỉnh Trà Vinh","code":"29359","parent_code":"846"},"29362":{"name":"Xã Tân Hùng","type":"xa","slug":"xa-tan-hung","name_with_type":"Xã Tân Hùng","path":"Xã Tân Hùng, Huyện Tiểu Cần, Tỉnh Trà Vinh","path_with_type":"Xã Tân Hùng, Huyện Tiểu Cần, Tỉnh Trà Vinh","code":"29362","parent_code":"846"},"29365":{"name":"Xã Tập Ngãi","type":"xa","slug":"xa-tap-ngai","name_with_type":"Xã Tập Ngãi","path":"Xã Tập Ngãi, Huyện Tiểu Cần, Tỉnh Trà Vinh","path_with_type":"Xã Tập Ngãi, Huyện Tiểu Cần, Tỉnh Trà Vinh","code":"29365","parent_code":"846"},"29368":{"name":"Xã Ngãi Hùng","type":"xa","slug":"xa-ngai-hung","name_with_type":"Xã Ngãi Hùng","path":"Xã Ngãi Hùng, Huyện Tiểu Cần, Tỉnh Trà Vinh","path_with_type":"Xã Ngãi Hùng, Huyện Tiểu Cần, Tỉnh Trà Vinh","code":"29368","parent_code":"846"},"29371":{"name":"Xã Tân Hòa","type":"xa","slug":"xa-tan-hoa","name_with_type":"Xã Tân Hòa","path":"Xã Tân Hòa, Huyện Tiểu Cần, Tỉnh Trà Vinh","path_with_type":"Xã Tân Hòa, Huyện Tiểu Cần, Tỉnh Trà Vinh","code":"29371","parent_code":"846"},"29374":{"name":"Thị trấn Châu Thành","type":"thi-tran","slug":"thi-tran-chau-thanh","name_with_type":"Thị trấn Châu Thành","path":"Thị trấn Châu Thành, Huyện Châu Thành, Tỉnh Trà Vinh","path_with_type":"Thị trấn Châu Thành, Huyện Châu Thành, Tỉnh Trà Vinh","code":"29374","parent_code":"847"},"29377":{"name":"Xã Đa Lộc","type":"xa","slug":"xa-da-loc","name_with_type":"Xã Đa Lộc","path":"Xã Đa Lộc, Huyện Châu Thành, Tỉnh Trà Vinh","path_with_type":"Xã Đa Lộc, Huyện Châu Thành, Tỉnh Trà Vinh","code":"29377","parent_code":"847"},"29380":{"name":"Xã Mỹ Chánh","type":"xa","slug":"xa-my-chanh","name_with_type":"Xã Mỹ Chánh","path":"Xã Mỹ Chánh, Huyện Châu Thành, Tỉnh Trà Vinh","path_with_type":"Xã Mỹ Chánh, Huyện Châu Thành, Tỉnh Trà Vinh","code":"29380","parent_code":"847"},"29383":{"name":"Xã Thanh Mỹ","type":"xa","slug":"xa-thanh-my","name_with_type":"Xã Thanh Mỹ","path":"Xã Thanh Mỹ, Huyện Châu Thành, Tỉnh Trà Vinh","path_with_type":"Xã Thanh Mỹ, Huyện Châu Thành, Tỉnh Trà Vinh","code":"29383","parent_code":"847"},"29386":{"name":"Xã Lương Hoà A","type":"xa","slug":"xa-luong-hoa-a","name_with_type":"Xã Lương Hoà A","path":"Xã Lương Hoà A, Huyện Châu Thành, Tỉnh Trà Vinh","path_with_type":"Xã Lương Hoà A, Huyện Châu Thành, Tỉnh Trà Vinh","code":"29386","parent_code":"847"},"29389":{"name":"Xã Lương Hòa","type":"xa","slug":"xa-luong-hoa","name_with_type":"Xã Lương Hòa","path":"Xã Lương Hòa, Huyện Châu Thành, Tỉnh Trà Vinh","path_with_type":"Xã Lương Hòa, Huyện Châu Thành, Tỉnh Trà Vinh","code":"29389","parent_code":"847"},"29392":{"name":"Xã Song Lộc","type":"xa","slug":"xa-song-loc","name_with_type":"Xã Song Lộc","path":"Xã Song Lộc, Huyện Châu Thành, Tỉnh Trà Vinh","path_with_type":"Xã Song Lộc, Huyện Châu Thành, Tỉnh Trà Vinh","code":"29392","parent_code":"847"},"29395":{"name":"Xã Nguyệt Hóa","type":"xa","slug":"xa-nguyet-hoa","name_with_type":"Xã Nguyệt Hóa","path":"Xã Nguyệt Hóa, Huyện Châu Thành, Tỉnh Trà Vinh","path_with_type":"Xã Nguyệt Hóa, Huyện Châu Thành, Tỉnh Trà Vinh","code":"29395","parent_code":"847"},"29398":{"name":"Xã Hòa Thuận","type":"xa","slug":"xa-hoa-thuan","name_with_type":"Xã Hòa Thuận","path":"Xã Hòa Thuận, Huyện Châu Thành, Tỉnh Trà Vinh","path_with_type":"Xã Hòa Thuận, Huyện Châu Thành, Tỉnh Trà Vinh","code":"29398","parent_code":"847"},"29401":{"name":"Xã Hòa Lợi","type":"xa","slug":"xa-hoa-loi","name_with_type":"Xã Hòa Lợi","path":"Xã Hòa Lợi, Huyện Châu Thành, Tỉnh Trà Vinh","path_with_type":"Xã Hòa Lợi, Huyện Châu Thành, Tỉnh Trà Vinh","code":"29401","parent_code":"847"},"29404":{"name":"Xã Phước Hảo","type":"xa","slug":"xa-phuoc-hao","name_with_type":"Xã Phước Hảo","path":"Xã Phước Hảo, Huyện Châu Thành, Tỉnh Trà Vinh","path_with_type":"Xã Phước Hảo, Huyện Châu Thành, Tỉnh Trà Vinh","code":"29404","parent_code":"847"},"29407":{"name":"Xã Hưng Mỹ","type":"xa","slug":"xa-hung-my","name_with_type":"Xã Hưng Mỹ","path":"Xã Hưng Mỹ, Huyện Châu Thành, Tỉnh Trà Vinh","path_with_type":"Xã Hưng Mỹ, Huyện Châu Thành, Tỉnh Trà Vinh","code":"29407","parent_code":"847"},"29410":{"name":"Xã Hòa Minh","type":"xa","slug":"xa-hoa-minh","name_with_type":"Xã Hòa Minh","path":"Xã Hòa Minh, Huyện Châu Thành, Tỉnh Trà Vinh","path_with_type":"Xã Hòa Minh, Huyện Châu Thành, Tỉnh Trà Vinh","code":"29410","parent_code":"847"},"29413":{"name":"Xã Long Hòa","type":"xa","slug":"xa-long-hoa","name_with_type":"Xã Long Hòa","path":"Xã Long Hòa, Huyện Châu Thành, Tỉnh Trà Vinh","path_with_type":"Xã Long Hòa, Huyện Châu Thành, Tỉnh Trà Vinh","code":"29413","parent_code":"847"},"29416":{"name":"Thị trấn Cầu Ngang","type":"thi-tran","slug":"thi-tran-cau-ngang","name_with_type":"Thị trấn Cầu Ngang","path":"Thị trấn Cầu Ngang, Huyện Cầu Ngang, Tỉnh Trà Vinh","path_with_type":"Thị trấn Cầu Ngang, Huyện Cầu Ngang, Tỉnh Trà Vinh","code":"29416","parent_code":"848"},"29419":{"name":"Thị trấn Mỹ Long","type":"thi-tran","slug":"thi-tran-my-long","name_with_type":"Thị trấn Mỹ Long","path":"Thị trấn Mỹ Long, Huyện Cầu Ngang, Tỉnh Trà Vinh","path_with_type":"Thị trấn Mỹ Long, Huyện Cầu Ngang, Tỉnh Trà Vinh","code":"29419","parent_code":"848"},"29422":{"name":"Xã Mỹ Long Bắc","type":"xa","slug":"xa-my-long-bac","name_with_type":"Xã Mỹ Long Bắc","path":"Xã Mỹ Long Bắc, Huyện Cầu Ngang, Tỉnh Trà Vinh","path_with_type":"Xã Mỹ Long Bắc, Huyện Cầu Ngang, Tỉnh Trà Vinh","code":"29422","parent_code":"848"},"29425":{"name":"Xã Mỹ Long Nam","type":"xa","slug":"xa-my-long-nam","name_with_type":"Xã Mỹ Long Nam","path":"Xã Mỹ Long Nam, Huyện Cầu Ngang, Tỉnh Trà Vinh","path_with_type":"Xã Mỹ Long Nam, Huyện Cầu Ngang, Tỉnh Trà Vinh","code":"29425","parent_code":"848"},"29428":{"name":"Xã Mỹ Hòa","type":"xa","slug":"xa-my-hoa","name_with_type":"Xã Mỹ Hòa","path":"Xã Mỹ Hòa, Huyện Cầu Ngang, Tỉnh Trà Vinh","path_with_type":"Xã Mỹ Hòa, Huyện Cầu Ngang, Tỉnh Trà Vinh","code":"29428","parent_code":"848"},"29431":{"name":"Xã Vĩnh Kim","type":"xa","slug":"xa-vinh-kim","name_with_type":"Xã Vĩnh Kim","path":"Xã Vĩnh Kim, Huyện Cầu Ngang, Tỉnh Trà Vinh","path_with_type":"Xã Vĩnh Kim, Huyện Cầu Ngang, Tỉnh Trà Vinh","code":"29431","parent_code":"848"},"29434":{"name":"Xã Kim Hòa","type":"xa","slug":"xa-kim-hoa","name_with_type":"Xã Kim Hòa","path":"Xã Kim Hòa, Huyện Cầu Ngang, Tỉnh Trà Vinh","path_with_type":"Xã Kim Hòa, Huyện Cầu Ngang, Tỉnh Trà Vinh","code":"29434","parent_code":"848"},"29437":{"name":"Xã Hiệp Hòa","type":"xa","slug":"xa-hiep-hoa","name_with_type":"Xã Hiệp Hòa","path":"Xã Hiệp Hòa, Huyện Cầu Ngang, Tỉnh Trà Vinh","path_with_type":"Xã Hiệp Hòa, Huyện Cầu Ngang, Tỉnh Trà Vinh","code":"29437","parent_code":"848"},"29440":{"name":"Xã Thuận Hòa","type":"xa","slug":"xa-thuan-hoa","name_with_type":"Xã Thuận Hòa","path":"Xã Thuận Hòa, Huyện Cầu Ngang, Tỉnh Trà Vinh","path_with_type":"Xã Thuận Hòa, Huyện Cầu Ngang, Tỉnh Trà Vinh","code":"29440","parent_code":"848"},"29443":{"name":"Xã Long Sơn","type":"xa","slug":"xa-long-son","name_with_type":"Xã Long Sơn","path":"Xã Long Sơn, Huyện Cầu Ngang, Tỉnh Trà Vinh","path_with_type":"Xã Long Sơn, Huyện Cầu Ngang, Tỉnh Trà Vinh","code":"29443","parent_code":"848"},"29446":{"name":"Xã Nhị Trường","type":"xa","slug":"xa-nhi-truong","name_with_type":"Xã Nhị Trường","path":"Xã Nhị Trường, Huyện Cầu Ngang, Tỉnh Trà Vinh","path_with_type":"Xã Nhị Trường, Huyện Cầu Ngang, Tỉnh Trà Vinh","code":"29446","parent_code":"848"},"29449":{"name":"Xã Trường Thọ","type":"xa","slug":"xa-truong-tho","name_with_type":"Xã Trường Thọ","path":"Xã Trường Thọ, Huyện Cầu Ngang, Tỉnh Trà Vinh","path_with_type":"Xã Trường Thọ, Huyện Cầu Ngang, Tỉnh Trà Vinh","code":"29449","parent_code":"848"},"29452":{"name":"Xã Hiệp Mỹ Đông","type":"xa","slug":"xa-hiep-my-dong","name_with_type":"Xã Hiệp Mỹ Đông","path":"Xã Hiệp Mỹ Đông, Huyện Cầu Ngang, Tỉnh Trà Vinh","path_with_type":"Xã Hiệp Mỹ Đông, Huyện Cầu Ngang, Tỉnh Trà Vinh","code":"29452","parent_code":"848"},"29455":{"name":"Xã Hiệp Mỹ Tây","type":"xa","slug":"xa-hiep-my-tay","name_with_type":"Xã Hiệp Mỹ Tây","path":"Xã Hiệp Mỹ Tây, Huyện Cầu Ngang, Tỉnh Trà Vinh","path_with_type":"Xã Hiệp Mỹ Tây, Huyện Cầu Ngang, Tỉnh Trà Vinh","code":"29455","parent_code":"848"},"29458":{"name":"Xã Thạnh Hòa Sơn","type":"xa","slug":"xa-thanh-hoa-son","name_with_type":"Xã Thạnh Hòa Sơn","path":"Xã Thạnh Hòa Sơn, Huyện Cầu Ngang, Tỉnh Trà Vinh","path_with_type":"Xã Thạnh Hòa Sơn, Huyện Cầu Ngang, Tỉnh Trà Vinh","code":"29458","parent_code":"848"},"29461":{"name":"Thị trấn Trà Cú","type":"thi-tran","slug":"thi-tran-tra-cu","name_with_type":"Thị trấn Trà Cú","path":"Thị trấn Trà Cú, Huyện Trà Cú, Tỉnh Trà Vinh","path_with_type":"Thị trấn Trà Cú, Huyện Trà Cú, Tỉnh Trà Vinh","code":"29461","parent_code":"849"},"29462":{"name":"Thị trấn Định An","type":"thi-tran","slug":"thi-tran-dinh-an","name_with_type":"Thị trấn Định An","path":"Thị trấn Định An, Huyện Trà Cú, Tỉnh Trà Vinh","path_with_type":"Thị trấn Định An, Huyện Trà Cú, Tỉnh Trà Vinh","code":"29462","parent_code":"849"},"29464":{"name":"Xã Phước Hưng","type":"xa","slug":"xa-phuoc-hung","name_with_type":"Xã Phước Hưng","path":"Xã Phước Hưng, Huyện Trà Cú, Tỉnh Trà Vinh","path_with_type":"Xã Phước Hưng, Huyện Trà Cú, Tỉnh Trà Vinh","code":"29464","parent_code":"849"},"29467":{"name":"Xã Tập Sơn","type":"xa","slug":"xa-tap-son","name_with_type":"Xã Tập Sơn","path":"Xã Tập Sơn, Huyện Trà Cú, Tỉnh Trà Vinh","path_with_type":"Xã Tập Sơn, Huyện Trà Cú, Tỉnh Trà Vinh","code":"29467","parent_code":"849"},"29470":{"name":"Xã Tân Sơn","type":"xa","slug":"xa-tan-son","name_with_type":"Xã Tân Sơn","path":"Xã Tân Sơn, Huyện Trà Cú, Tỉnh Trà Vinh","path_with_type":"Xã Tân Sơn, Huyện Trà Cú, Tỉnh Trà Vinh","code":"29470","parent_code":"849"},"29473":{"name":"Xã An Quảng Hữu","type":"xa","slug":"xa-an-quang-huu","name_with_type":"Xã An Quảng Hữu","path":"Xã An Quảng Hữu, Huyện Trà Cú, Tỉnh Trà Vinh","path_with_type":"Xã An Quảng Hữu, Huyện Trà Cú, Tỉnh Trà Vinh","code":"29473","parent_code":"849"},"29476":{"name":"Xã Lưu Nghiệp Anh","type":"xa","slug":"xa-luu-nghiep-anh","name_with_type":"Xã Lưu Nghiệp Anh","path":"Xã Lưu Nghiệp Anh, Huyện Trà Cú, Tỉnh Trà Vinh","path_with_type":"Xã Lưu Nghiệp Anh, Huyện Trà Cú, Tỉnh Trà Vinh","code":"29476","parent_code":"849"},"29479":{"name":"Xã Ngãi Xuyên","type":"xa","slug":"xa-ngai-xuyen","name_with_type":"Xã Ngãi Xuyên","path":"Xã Ngãi Xuyên, Huyện Trà Cú, Tỉnh Trà Vinh","path_with_type":"Xã Ngãi Xuyên, Huyện Trà Cú, Tỉnh Trà Vinh","code":"29479","parent_code":"849"},"29482":{"name":"Xã Kim Sơn","type":"xa","slug":"xa-kim-son","name_with_type":"Xã Kim Sơn","path":"Xã Kim Sơn, Huyện Trà Cú, Tỉnh Trà Vinh","path_with_type":"Xã Kim Sơn, Huyện Trà Cú, Tỉnh Trà Vinh","code":"29482","parent_code":"849"},"29485":{"name":"Xã Thanh Sơn","type":"xa","slug":"xa-thanh-son","name_with_type":"Xã Thanh Sơn","path":"Xã Thanh Sơn, Huyện Trà Cú, Tỉnh Trà Vinh","path_with_type":"Xã Thanh Sơn, Huyện Trà Cú, Tỉnh Trà Vinh","code":"29485","parent_code":"849"},"29488":{"name":"Xã Hàm Giang","type":"xa","slug":"xa-ham-giang","name_with_type":"Xã Hàm Giang","path":"Xã Hàm Giang, Huyện Trà Cú, Tỉnh Trà Vinh","path_with_type":"Xã Hàm Giang, Huyện Trà Cú, Tỉnh Trà Vinh","code":"29488","parent_code":"849"},"29489":{"name":"Xã Hàm Tân","type":"xa","slug":"xa-ham-tan","name_with_type":"Xã Hàm Tân","path":"Xã Hàm Tân, Huyện Trà Cú, Tỉnh Trà Vinh","path_with_type":"Xã Hàm Tân, Huyện Trà Cú, Tỉnh Trà Vinh","code":"29489","parent_code":"849"},"29491":{"name":"Xã Đại An","type":"xa","slug":"xa-dai-an","name_with_type":"Xã Đại An","path":"Xã Đại An, Huyện Trà Cú, Tỉnh Trà Vinh","path_with_type":"Xã Đại An, Huyện Trà Cú, Tỉnh Trà Vinh","code":"29491","parent_code":"849"},"29494":{"name":"Xã Định An","type":"xa","slug":"xa-dinh-an","name_with_type":"Xã Định An","path":"Xã Định An, Huyện Trà Cú, Tỉnh Trà Vinh","path_with_type":"Xã Định An, Huyện Trà Cú, Tỉnh Trà Vinh","code":"29494","parent_code":"849"},"29497":{"name":"Xã Đôn Xuân","type":"xa","slug":"xa-don-xuan","name_with_type":"Xã Đôn Xuân","path":"Xã Đôn Xuân, Huyện Duyên Hải, Tỉnh Trà Vinh","path_with_type":"Xã Đôn Xuân, Huyện Duyên Hải, Tỉnh Trà Vinh","code":"29497","parent_code":"850"},"29500":{"name":"Xã Đôn Châu","type":"xa","slug":"xa-don-chau","name_with_type":"Xã Đôn Châu","path":"Xã Đôn Châu, Huyện Duyên Hải, Tỉnh Trà Vinh","path_with_type":"Xã Đôn Châu, Huyện Duyên Hải, Tỉnh Trà Vinh","code":"29500","parent_code":"850"},"29503":{"name":"Xã Ngọc Biên","type":"xa","slug":"xa-ngoc-bien","name_with_type":"Xã Ngọc Biên","path":"Xã Ngọc Biên, Huyện Trà Cú, Tỉnh Trà Vinh","path_with_type":"Xã Ngọc Biên, Huyện Trà Cú, Tỉnh Trà Vinh","code":"29503","parent_code":"849"},"29506":{"name":"Xã Long Hiệp","type":"xa","slug":"xa-long-hiep","name_with_type":"Xã Long Hiệp","path":"Xã Long Hiệp, Huyện Trà Cú, Tỉnh Trà Vinh","path_with_type":"Xã Long Hiệp, Huyện Trà Cú, Tỉnh Trà Vinh","code":"29506","parent_code":"849"},"29509":{"name":"Xã Tân Hiệp","type":"xa","slug":"xa-tan-hiep","name_with_type":"Xã Tân Hiệp","path":"Xã Tân Hiệp, Huyện Trà Cú, Tỉnh Trà Vinh","path_with_type":"Xã Tân Hiệp, Huyện Trà Cú, Tỉnh Trà Vinh","code":"29509","parent_code":"849"},"29512":{"name":"Phường 1","type":"phuong","slug":"phuong-1","name_with_type":"Phường 1","path":"Phường 1, Thị xã Duyên Hải, Tỉnh Trà Vinh","path_with_type":"Phường 1, Thị xã Duyên Hải, Tỉnh Trà Vinh","code":"29512","parent_code":"851"},"29513":{"name":"Thị trấn Long Thành","type":"thi-tran","slug":"thi-tran-long-thanh","name_with_type":"Thị trấn Long Thành","path":"Thị trấn Long Thành, Huyện Duyên Hải, Tỉnh Trà Vinh","path_with_type":"Thị trấn Long Thành, Huyện Duyên Hải, Tỉnh Trà Vinh","code":"29513","parent_code":"850"},"29515":{"name":"Xã Long Toàn","type":"xa","slug":"xa-long-toan","name_with_type":"Xã Long Toàn","path":"Xã Long Toàn, Thị xã Duyên Hải, Tỉnh Trà Vinh","path_with_type":"Xã Long Toàn, Thị xã Duyên Hải, Tỉnh Trà Vinh","code":"29515","parent_code":"851"},"29516":{"name":"Phường 2","type":"phuong","slug":"phuong-2","name_with_type":"Phường 2","path":"Phường 2, Thị xã Duyên Hải, Tỉnh Trà Vinh","path_with_type":"Phường 2, Thị xã Duyên Hải, Tỉnh Trà Vinh","code":"29516","parent_code":"851"},"29518":{"name":"Xã Long Hữu","type":"xa","slug":"xa-long-huu","name_with_type":"Xã Long Hữu","path":"Xã Long Hữu, Thị xã Duyên Hải, Tỉnh Trà Vinh","path_with_type":"Xã Long Hữu, Thị xã Duyên Hải, Tỉnh Trà Vinh","code":"29518","parent_code":"851"},"29521":{"name":"Xã Long Khánh","type":"xa","slug":"xa-long-khanh","name_with_type":"Xã Long Khánh","path":"Xã Long Khánh, Huyện Duyên Hải, Tỉnh Trà Vinh","path_with_type":"Xã Long Khánh, Huyện Duyên Hải, Tỉnh Trà Vinh","code":"29521","parent_code":"850"},"29524":{"name":"Xã Dân Thành","type":"xa","slug":"xa-dan-thanh","name_with_type":"Xã Dân Thành","path":"Xã Dân Thành, Thị xã Duyên Hải, Tỉnh Trà Vinh","path_with_type":"Xã Dân Thành, Thị xã Duyên Hải, Tỉnh Trà Vinh","code":"29524","parent_code":"851"},"29527":{"name":"Xã Trường Long Hòa","type":"xa","slug":"xa-truong-long-hoa","name_with_type":"Xã Trường Long Hòa","path":"Xã Trường Long Hòa, Thị xã Duyên Hải, Tỉnh Trà Vinh","path_with_type":"Xã Trường Long Hòa, Thị xã Duyên Hải, Tỉnh Trà Vinh","code":"29527","parent_code":"851"},"29530":{"name":"Xã Ngũ Lạc","type":"xa","slug":"xa-ngu-lac","name_with_type":"Xã Ngũ Lạc","path":"Xã Ngũ Lạc, Huyện Duyên Hải, Tỉnh Trà Vinh","path_with_type":"Xã Ngũ Lạc, Huyện Duyên Hải, Tỉnh Trà Vinh","code":"29530","parent_code":"850"},"29533":{"name":"Xã Long Vĩnh","type":"xa","slug":"xa-long-vinh","name_with_type":"Xã Long Vĩnh","path":"Xã Long Vĩnh, Huyện Duyên Hải, Tỉnh Trà Vinh","path_with_type":"Xã Long Vĩnh, Huyện Duyên Hải, Tỉnh Trà Vinh","code":"29533","parent_code":"850"},"29536":{"name":"Xã Đông Hải","type":"xa","slug":"xa-dong-hai","name_with_type":"Xã Đông Hải","path":"Xã Đông Hải, Huyện Duyên Hải, Tỉnh Trà Vinh","path_with_type":"Xã Đông Hải, Huyện Duyên Hải, Tỉnh Trà Vinh","code":"29536","parent_code":"850"},"29539":{"name":"Xã Hiệp Thạnh","type":"xa","slug":"xa-hiep-thanh","name_with_type":"Xã Hiệp Thạnh","path":"Xã Hiệp Thạnh, Thị xã Duyên Hải, Tỉnh Trà Vinh","path_with_type":"Xã Hiệp Thạnh, Thị xã Duyên Hải, Tỉnh Trà Vinh","code":"29539","parent_code":"851"},"29542":{"name":"Phường 9","type":"phuong","slug":"phuong-9","name_with_type":"Phường 9","path":"Phường 9, Thành phố Vĩnh Long, Tỉnh Vĩnh Long","path_with_type":"Phường 9, Thành phố Vĩnh Long, Tỉnh Vĩnh Long","code":"29542","parent_code":"855"},"29545":{"name":"Phường 5","type":"phuong","slug":"phuong-5","name_with_type":"Phường 5","path":"Phường 5, Thành phố Vĩnh Long, Tỉnh Vĩnh Long","path_with_type":"Phường 5, Thành phố Vĩnh Long, Tỉnh Vĩnh Long","code":"29545","parent_code":"855"},"29551":{"name":"Phường 1","type":"phuong","slug":"phuong-1","name_with_type":"Phường 1","path":"Phường 1, Thành phố Vĩnh Long, Tỉnh Vĩnh Long","path_with_type":"Phường 1, Thành phố Vĩnh Long, Tỉnh Vĩnh Long","code":"29551","parent_code":"855"},"29554":{"name":"Phường 4","type":"phuong","slug":"phuong-4","name_with_type":"Phường 4","path":"Phường 4, Thành phố Vĩnh Long, Tỉnh Vĩnh Long","path_with_type":"Phường 4, Thành phố Vĩnh Long, Tỉnh Vĩnh Long","code":"29554","parent_code":"855"},"29557":{"name":"Phường 3","type":"phuong","slug":"phuong-3","name_with_type":"Phường 3","path":"Phường 3, Thành phố Vĩnh Long, Tỉnh Vĩnh Long","path_with_type":"Phường 3, Thành phố Vĩnh Long, Tỉnh Vĩnh Long","code":"29557","parent_code":"855"},"29560":{"name":"Phường 8","type":"phuong","slug":"phuong-8","name_with_type":"Phường 8","path":"Phường 8, Thành phố Vĩnh Long, Tỉnh Vĩnh Long","path_with_type":"Phường 8, Thành phố Vĩnh Long, Tỉnh Vĩnh Long","code":"29560","parent_code":"855"},"29563":{"name":"Phường Tân Ngãi","type":"phuong","slug":"phuong-tan-ngai","name_with_type":"Phường Tân Ngãi","path":"Phường Tân Ngãi, Thành phố Vĩnh Long, Tỉnh Vĩnh Long","path_with_type":"Phường Tân Ngãi, Thành phố Vĩnh Long, Tỉnh Vĩnh Long","code":"29563","parent_code":"855"},"29566":{"name":"Phường Tân Hòa","type":"phuong","slug":"phuong-tan-hoa","name_with_type":"Phường Tân Hòa","path":"Phường Tân Hòa, Thành phố Vĩnh Long, Tỉnh Vĩnh Long","path_with_type":"Phường Tân Hòa, Thành phố Vĩnh Long, Tỉnh Vĩnh Long","code":"29566","parent_code":"855"},"29569":{"name":"Phường Tân Hội","type":"phuong","slug":"phuong-tan-hoi","name_with_type":"Phường Tân Hội","path":"Phường Tân Hội, Thành phố Vĩnh Long, Tỉnh Vĩnh Long","path_with_type":"Phường Tân Hội, Thành phố Vĩnh Long, Tỉnh Vĩnh Long","code":"29569","parent_code":"855"},"29572":{"name":"Phường Trường An","type":"phuong","slug":"phuong-truong-an","name_with_type":"Phường Trường An","path":"Phường Trường An, Thành phố Vĩnh Long, Tỉnh Vĩnh Long","path_with_type":"Phường Trường An, Thành phố Vĩnh Long, Tỉnh Vĩnh Long","code":"29572","parent_code":"855"},"29578":{"name":"Xã Đồng Phú","type":"xa","slug":"xa-dong-phu","name_with_type":"Xã Đồng Phú","path":"Xã Đồng Phú, Huyện Long Hồ, Tỉnh Vĩnh Long","path_with_type":"Xã Đồng Phú, Huyện Long Hồ, Tỉnh Vĩnh Long","code":"29578","parent_code":"857"},"29581":{"name":"Xã Bình Hòa Phước","type":"xa","slug":"xa-binh-hoa-phuoc","name_with_type":"Xã Bình Hòa Phước","path":"Xã Bình Hòa Phước, Huyện Long Hồ, Tỉnh Vĩnh Long","path_with_type":"Xã Bình Hòa Phước, Huyện Long Hồ, Tỉnh Vĩnh Long","code":"29581","parent_code":"857"},"29584":{"name":"Xã Hòa Ninh","type":"xa","slug":"xa-hoa-ninh","name_with_type":"Xã Hòa Ninh","path":"Xã Hòa Ninh, Huyện Long Hồ, Tỉnh Vĩnh Long","path_with_type":"Xã Hòa Ninh, Huyện Long Hồ, Tỉnh Vĩnh Long","code":"29584","parent_code":"857"},"29587":{"name":"Xã An Bình","type":"xa","slug":"xa-an-binh","name_with_type":"Xã An Bình","path":"Xã An Bình, Huyện Long Hồ, Tỉnh Vĩnh Long","path_with_type":"Xã An Bình, Huyện Long Hồ, Tỉnh Vĩnh Long","code":"29587","parent_code":"857"},"29590":{"name":"Xã Thanh Đức","type":"xa","slug":"xa-thanh-duc","name_with_type":"Xã Thanh Đức","path":"Xã Thanh Đức, Huyện Long Hồ, Tỉnh Vĩnh Long","path_with_type":"Xã Thanh Đức, Huyện Long Hồ, Tỉnh Vĩnh Long","code":"29590","parent_code":"857"},"29593":{"name":"Xã Tân Hạnh","type":"xa","slug":"xa-tan-hanh","name_with_type":"Xã Tân Hạnh","path":"Xã Tân Hạnh, Huyện Long Hồ, Tỉnh Vĩnh Long","path_with_type":"Xã Tân Hạnh, Huyện Long Hồ, Tỉnh Vĩnh Long","code":"29593","parent_code":"857"},"29596":{"name":"Xã Phước Hậu","type":"xa","slug":"xa-phuoc-hau","name_with_type":"Xã Phước Hậu","path":"Xã Phước Hậu, Huyện Long Hồ, Tỉnh Vĩnh Long","path_with_type":"Xã Phước Hậu, Huyện Long Hồ, Tỉnh Vĩnh Long","code":"29596","parent_code":"857"},"29599":{"name":"Xã Long Phước","type":"xa","slug":"xa-long-phuoc","name_with_type":"Xã Long Phước","path":"Xã Long Phước, Huyện Long Hồ, Tỉnh Vĩnh Long","path_with_type":"Xã Long Phước, Huyện Long Hồ, Tỉnh Vĩnh Long","code":"29599","parent_code":"857"},"29602":{"name":"Thị trấn Long Hồ","type":"thi-tran","slug":"thi-tran-long-ho","name_with_type":"Thị trấn Long Hồ","path":"Thị trấn Long Hồ, Huyện Long Hồ, Tỉnh Vĩnh Long","path_with_type":"Thị trấn Long Hồ, Huyện Long Hồ, Tỉnh Vĩnh Long","code":"29602","parent_code":"857"},"29605":{"name":"Xã Lộc Hòa","type":"xa","slug":"xa-loc-hoa","name_with_type":"Xã Lộc Hòa","path":"Xã Lộc Hòa, Huyện Long Hồ, Tỉnh Vĩnh Long","path_with_type":"Xã Lộc Hòa, Huyện Long Hồ, Tỉnh Vĩnh Long","code":"29605","parent_code":"857"},"29608":{"name":"Xã Long An","type":"xa","slug":"xa-long-an","name_with_type":"Xã Long An","path":"Xã Long An, Huyện Long Hồ, Tỉnh Vĩnh Long","path_with_type":"Xã Long An, Huyện Long Hồ, Tỉnh Vĩnh Long","code":"29608","parent_code":"857"},"29611":{"name":"Xã Phú Quới","type":"xa","slug":"xa-phu-quoi","name_with_type":"Xã Phú Quới","path":"Xã Phú Quới, Huyện Long Hồ, Tỉnh Vĩnh Long","path_with_type":"Xã Phú Quới, Huyện Long Hồ, Tỉnh Vĩnh Long","code":"29611","parent_code":"857"},"29614":{"name":"Xã Thạnh Quới","type":"xa","slug":"xa-thanh-quoi","name_with_type":"Xã Thạnh Quới","path":"Xã Thạnh Quới, Huyện Long Hồ, Tỉnh Vĩnh Long","path_with_type":"Xã Thạnh Quới, Huyện Long Hồ, Tỉnh Vĩnh Long","code":"29614","parent_code":"857"},"29617":{"name":"Xã Hòa Phú","type":"xa","slug":"xa-hoa-phu","name_with_type":"Xã Hòa Phú","path":"Xã Hòa Phú, Huyện Long Hồ, Tỉnh Vĩnh Long","path_with_type":"Xã Hòa Phú, Huyện Long Hồ, Tỉnh Vĩnh Long","code":"29617","parent_code":"857"},"29623":{"name":"Xã Mỹ An","type":"xa","slug":"xa-my-an","name_with_type":"Xã Mỹ An","path":"Xã Mỹ An, Huyện Mang Thít, Tỉnh Vĩnh Long","path_with_type":"Xã Mỹ An, Huyện Mang Thít, Tỉnh Vĩnh Long","code":"29623","parent_code":"858"},"29626":{"name":"Xã Mỹ Phước","type":"xa","slug":"xa-my-phuoc","name_with_type":"Xã Mỹ Phước","path":"Xã Mỹ Phước, Huyện Mang Thít, Tỉnh Vĩnh Long","path_with_type":"Xã Mỹ Phước, Huyện Mang Thít, Tỉnh Vĩnh Long","code":"29626","parent_code":"858"},"29629":{"name":"Xã An Phước","type":"xa","slug":"xa-an-phuoc","name_with_type":"Xã An Phước","path":"Xã An Phước, Huyện Mang Thít, Tỉnh Vĩnh Long","path_with_type":"Xã An Phước, Huyện Mang Thít, Tỉnh Vĩnh Long","code":"29629","parent_code":"858"},"29632":{"name":"Xã Nhơn Phú","type":"xa","slug":"xa-nhon-phu","name_with_type":"Xã Nhơn Phú","path":"Xã Nhơn Phú, Huyện Mang Thít, Tỉnh Vĩnh Long","path_with_type":"Xã Nhơn Phú, Huyện Mang Thít, Tỉnh Vĩnh Long","code":"29632","parent_code":"858"},"29635":{"name":"Xã Long Mỹ","type":"xa","slug":"xa-long-my","name_with_type":"Xã Long Mỹ","path":"Xã Long Mỹ, Huyện Mang Thít, Tỉnh Vĩnh Long","path_with_type":"Xã Long Mỹ, Huyện Mang Thít, Tỉnh Vĩnh Long","code":"29635","parent_code":"858"},"29638":{"name":"Xã Hòa Tịnh","type":"xa","slug":"xa-hoa-tinh","name_with_type":"Xã Hòa Tịnh","path":"Xã Hòa Tịnh, Huyện Mang Thít, Tỉnh Vĩnh Long","path_with_type":"Xã Hòa Tịnh, Huyện Mang Thít, Tỉnh Vĩnh Long","code":"29638","parent_code":"858"},"29641":{"name":"Thị trấn Cái Nhum","type":"thi-tran","slug":"thi-tran-cai-nhum","name_with_type":"Thị trấn Cái Nhum","path":"Thị trấn Cái Nhum, Huyện Mang Thít, Tỉnh Vĩnh Long","path_with_type":"Thị trấn Cái Nhum, Huyện Mang Thít, Tỉnh Vĩnh Long","code":"29641","parent_code":"858"},"29644":{"name":"Xã Bình Phước","type":"xa","slug":"xa-binh-phuoc","name_with_type":"Xã Bình Phước","path":"Xã Bình Phước, Huyện Mang Thít, Tỉnh Vĩnh Long","path_with_type":"Xã Bình Phước, Huyện Mang Thít, Tỉnh Vĩnh Long","code":"29644","parent_code":"858"},"29647":{"name":"Xã Chánh An","type":"xa","slug":"xa-chanh-an","name_with_type":"Xã Chánh An","path":"Xã Chánh An, Huyện Mang Thít, Tỉnh Vĩnh Long","path_with_type":"Xã Chánh An, Huyện Mang Thít, Tỉnh Vĩnh Long","code":"29647","parent_code":"858"},"29650":{"name":"Xã Tân An Hội","type":"xa","slug":"xa-tan-an-hoi","name_with_type":"Xã Tân An Hội","path":"Xã Tân An Hội, Huyện Mang Thít, Tỉnh Vĩnh Long","path_with_type":"Xã Tân An Hội, Huyện Mang Thít, Tỉnh Vĩnh Long","code":"29650","parent_code":"858"},"29653":{"name":"Xã Tân Long","type":"xa","slug":"xa-tan-long","name_with_type":"Xã Tân Long","path":"Xã Tân Long, Huyện Mang Thít, Tỉnh Vĩnh Long","path_with_type":"Xã Tân Long, Huyện Mang Thít, Tỉnh Vĩnh Long","code":"29653","parent_code":"858"},"29656":{"name":"Xã Tân Long Hội","type":"xa","slug":"xa-tan-long-hoi","name_with_type":"Xã Tân Long Hội","path":"Xã Tân Long Hội, Huyện Mang Thít, Tỉnh Vĩnh Long","path_with_type":"Xã Tân Long Hội, Huyện Mang Thít, Tỉnh Vĩnh Long","code":"29656","parent_code":"858"},"29659":{"name":"Thị trấn Vũng Liêm","type":"thi-tran","slug":"thi-tran-vung-liem","name_with_type":"Thị trấn Vũng Liêm","path":"Thị trấn Vũng Liêm, Huyện  Vũng Liêm, Tỉnh Vĩnh Long","path_with_type":"Thị trấn Vũng Liêm, Huyện  Vũng Liêm, Tỉnh Vĩnh Long","code":"29659","parent_code":"859"},"29662":{"name":"Xã Tân Quới Trung","type":"xa","slug":"xa-tan-quoi-trung","name_with_type":"Xã Tân Quới Trung","path":"Xã Tân Quới Trung, Huyện  Vũng Liêm, Tỉnh Vĩnh Long","path_with_type":"Xã Tân Quới Trung, Huyện  Vũng Liêm, Tỉnh Vĩnh Long","code":"29662","parent_code":"859"},"29665":{"name":"Xã Quới Thiện","type":"xa","slug":"xa-quoi-thien","name_with_type":"Xã Quới Thiện","path":"Xã Quới Thiện, Huyện  Vũng Liêm, Tỉnh Vĩnh Long","path_with_type":"Xã Quới Thiện, Huyện  Vũng Liêm, Tỉnh Vĩnh Long","code":"29665","parent_code":"859"},"29668":{"name":"Xã Quới An","type":"xa","slug":"xa-quoi-an","name_with_type":"Xã Quới An","path":"Xã Quới An, Huyện  Vũng Liêm, Tỉnh Vĩnh Long","path_with_type":"Xã Quới An, Huyện  Vũng Liêm, Tỉnh Vĩnh Long","code":"29668","parent_code":"859"},"29671":{"name":"Xã Trung Chánh","type":"xa","slug":"xa-trung-chanh","name_with_type":"Xã Trung Chánh","path":"Xã Trung Chánh, Huyện  Vũng Liêm, Tỉnh Vĩnh Long","path_with_type":"Xã Trung Chánh, Huyện  Vũng Liêm, Tỉnh Vĩnh Long","code":"29671","parent_code":"859"},"29674":{"name":"Xã Tân An Luông","type":"xa","slug":"xa-tan-an-luong","name_with_type":"Xã Tân An Luông","path":"Xã Tân An Luông, Huyện  Vũng Liêm, Tỉnh Vĩnh Long","path_with_type":"Xã Tân An Luông, Huyện  Vũng Liêm, Tỉnh Vĩnh Long","code":"29674","parent_code":"859"},"29677":{"name":"Xã Thanh Bình","type":"xa","slug":"xa-thanh-binh","name_with_type":"Xã Thanh Bình","path":"Xã Thanh Bình, Huyện  Vũng Liêm, Tỉnh Vĩnh Long","path_with_type":"Xã Thanh Bình, Huyện  Vũng Liêm, Tỉnh Vĩnh Long","code":"29677","parent_code":"859"},"29680":{"name":"Xã Trung Thành Tây","type":"xa","slug":"xa-trung-thanh-tay","name_with_type":"Xã Trung Thành Tây","path":"Xã Trung Thành Tây, Huyện  Vũng Liêm, Tỉnh Vĩnh Long","path_with_type":"Xã Trung Thành Tây, Huyện  Vũng Liêm, Tỉnh Vĩnh Long","code":"29680","parent_code":"859"},"29683":{"name":"Xã Trung Hiệp","type":"xa","slug":"xa-trung-hiep","name_with_type":"Xã Trung Hiệp","path":"Xã Trung Hiệp, Huyện  Vũng Liêm, Tỉnh Vĩnh Long","path_with_type":"Xã Trung Hiệp, Huyện  Vũng Liêm, Tỉnh Vĩnh Long","code":"29683","parent_code":"859"},"29686":{"name":"Xã Hiếu Phụng","type":"xa","slug":"xa-hieu-phung","name_with_type":"Xã Hiếu Phụng","path":"Xã Hiếu Phụng, Huyện  Vũng Liêm, Tỉnh Vĩnh Long","path_with_type":"Xã Hiếu Phụng, Huyện  Vũng Liêm, Tỉnh Vĩnh Long","code":"29686","parent_code":"859"},"29689":{"name":"Xã Trung Thành Đông","type":"xa","slug":"xa-trung-thanh-dong","name_with_type":"Xã Trung Thành Đông","path":"Xã Trung Thành Đông, Huyện  Vũng Liêm, Tỉnh Vĩnh Long","path_with_type":"Xã Trung Thành Đông, Huyện  Vũng Liêm, Tỉnh Vĩnh Long","code":"29689","parent_code":"859"},"29692":{"name":"Xã Trung Thành","type":"xa","slug":"xa-trung-thanh","name_with_type":"Xã Trung Thành","path":"Xã Trung Thành, Huyện  Vũng Liêm, Tỉnh Vĩnh Long","path_with_type":"Xã Trung Thành, Huyện  Vũng Liêm, Tỉnh Vĩnh Long","code":"29692","parent_code":"859"},"29695":{"name":"Xã Trung Hiếu","type":"xa","slug":"xa-trung-hieu","name_with_type":"Xã Trung Hiếu","path":"Xã Trung Hiếu, Huyện  Vũng Liêm, Tỉnh Vĩnh Long","path_with_type":"Xã Trung Hiếu, Huyện  Vũng Liêm, Tỉnh Vĩnh Long","code":"29695","parent_code":"859"},"29698":{"name":"Xã Trung Ngãi","type":"xa","slug":"xa-trung-ngai","name_with_type":"Xã Trung Ngãi","path":"Xã Trung Ngãi, Huyện  Vũng Liêm, Tỉnh Vĩnh Long","path_with_type":"Xã Trung Ngãi, Huyện  Vũng Liêm, Tỉnh Vĩnh Long","code":"29698","parent_code":"859"},"29701":{"name":"Xã Hiếu Thuận","type":"xa","slug":"xa-hieu-thuan","name_with_type":"Xã Hiếu Thuận","path":"Xã Hiếu Thuận, Huyện  Vũng Liêm, Tỉnh Vĩnh Long","path_with_type":"Xã Hiếu Thuận, Huyện  Vũng Liêm, Tỉnh Vĩnh Long","code":"29701","parent_code":"859"},"29704":{"name":"Xã Trung Nghĩa","type":"xa","slug":"xa-trung-nghia","name_with_type":"Xã Trung Nghĩa","path":"Xã Trung Nghĩa, Huyện  Vũng Liêm, Tỉnh Vĩnh Long","path_with_type":"Xã Trung Nghĩa, Huyện  Vũng Liêm, Tỉnh Vĩnh Long","code":"29704","parent_code":"859"},"29707":{"name":"Xã Trung An","type":"xa","slug":"xa-trung-an","name_with_type":"Xã Trung An","path":"Xã Trung An, Huyện  Vũng Liêm, Tỉnh Vĩnh Long","path_with_type":"Xã Trung An, Huyện  Vũng Liêm, Tỉnh Vĩnh Long","code":"29707","parent_code":"859"},"29710":{"name":"Xã Hiếu Nhơn","type":"xa","slug":"xa-hieu-nhon","name_with_type":"Xã Hiếu Nhơn","path":"Xã Hiếu Nhơn, Huyện  Vũng Liêm, Tỉnh Vĩnh Long","path_with_type":"Xã Hiếu Nhơn, Huyện  Vũng Liêm, Tỉnh Vĩnh Long","code":"29710","parent_code":"859"},"29713":{"name":"Xã Hiếu Thành","type":"xa","slug":"xa-hieu-thanh","name_with_type":"Xã Hiếu Thành","path":"Xã Hiếu Thành, Huyện  Vũng Liêm, Tỉnh Vĩnh Long","path_with_type":"Xã Hiếu Thành, Huyện  Vũng Liêm, Tỉnh Vĩnh Long","code":"29713","parent_code":"859"},"29716":{"name":"Xã Hiếu Nghĩa","type":"xa","slug":"xa-hieu-nghia","name_with_type":"Xã Hiếu Nghĩa","path":"Xã Hiếu Nghĩa, Huyện  Vũng Liêm, Tỉnh Vĩnh Long","path_with_type":"Xã Hiếu Nghĩa, Huyện  Vũng Liêm, Tỉnh Vĩnh Long","code":"29716","parent_code":"859"},"29719":{"name":"Thị trấn Tam Bình","type":"thi-tran","slug":"thi-tran-tam-binh","name_with_type":"Thị trấn Tam Bình","path":"Thị trấn Tam Bình, Huyện Tam Bình, Tỉnh Vĩnh Long","path_with_type":"Thị trấn Tam Bình, Huyện Tam Bình, Tỉnh Vĩnh Long","code":"29719","parent_code":"860"},"29722":{"name":"Xã Tân Lộc","type":"xa","slug":"xa-tan-loc","name_with_type":"Xã Tân Lộc","path":"Xã Tân Lộc, Huyện Tam Bình, Tỉnh Vĩnh Long","path_with_type":"Xã Tân Lộc, Huyện Tam Bình, Tỉnh Vĩnh Long","code":"29722","parent_code":"860"},"29725":{"name":"Xã Phú Thịnh","type":"xa","slug":"xa-phu-thinh","name_with_type":"Xã Phú Thịnh","path":"Xã Phú Thịnh, Huyện Tam Bình, Tỉnh Vĩnh Long","path_with_type":"Xã Phú Thịnh, Huyện Tam Bình, Tỉnh Vĩnh Long","code":"29725","parent_code":"860"},"29728":{"name":"Xã Hậu Lộc","type":"xa","slug":"xa-hau-loc","name_with_type":"Xã Hậu Lộc","path":"Xã Hậu Lộc, Huyện Tam Bình, Tỉnh Vĩnh Long","path_with_type":"Xã Hậu Lộc, Huyện Tam Bình, Tỉnh Vĩnh Long","code":"29728","parent_code":"860"},"29731":{"name":"Xã Hòa Thạnh","type":"xa","slug":"xa-hoa-thanh","name_with_type":"Xã Hòa Thạnh","path":"Xã Hòa Thạnh, Huyện Tam Bình, Tỉnh Vĩnh Long","path_with_type":"Xã Hòa Thạnh, Huyện Tam Bình, Tỉnh Vĩnh Long","code":"29731","parent_code":"860"},"29734":{"name":"Xã Hoà Lộc","type":"xa","slug":"xa-hoa-loc","name_with_type":"Xã Hoà Lộc","path":"Xã Hoà Lộc, Huyện Tam Bình, Tỉnh Vĩnh Long","path_with_type":"Xã Hoà Lộc, Huyện Tam Bình, Tỉnh Vĩnh Long","code":"29734","parent_code":"860"},"29737":{"name":"Xã Phú Lộc","type":"xa","slug":"xa-phu-loc","name_with_type":"Xã Phú Lộc","path":"Xã Phú Lộc, Huyện Tam Bình, Tỉnh Vĩnh Long","path_with_type":"Xã Phú Lộc, Huyện Tam Bình, Tỉnh Vĩnh Long","code":"29737","parent_code":"860"},"29740":{"name":"Xã Song Phú","type":"xa","slug":"xa-song-phu","name_with_type":"Xã Song Phú","path":"Xã Song Phú, Huyện Tam Bình, Tỉnh Vĩnh Long","path_with_type":"Xã Song Phú, Huyện Tam Bình, Tỉnh Vĩnh Long","code":"29740","parent_code":"860"},"29743":{"name":"Xã Hòa Hiệp","type":"xa","slug":"xa-hoa-hiep","name_with_type":"Xã Hòa Hiệp","path":"Xã Hòa Hiệp, Huyện Tam Bình, Tỉnh Vĩnh Long","path_with_type":"Xã Hòa Hiệp, Huyện Tam Bình, Tỉnh Vĩnh Long","code":"29743","parent_code":"860"},"29746":{"name":"Xã Mỹ Lộc","type":"xa","slug":"xa-my-loc","name_with_type":"Xã Mỹ Lộc","path":"Xã Mỹ Lộc, Huyện Tam Bình, Tỉnh Vĩnh Long","path_with_type":"Xã Mỹ Lộc, Huyện Tam Bình, Tỉnh Vĩnh Long","code":"29746","parent_code":"860"},"29749":{"name":"Xã Tân Phú","type":"xa","slug":"xa-tan-phu","name_with_type":"Xã Tân Phú","path":"Xã Tân Phú, Huyện Tam Bình, Tỉnh Vĩnh Long","path_with_type":"Xã Tân Phú, Huyện Tam Bình, Tỉnh Vĩnh Long","code":"29749","parent_code":"860"},"29752":{"name":"Xã Long Phú","type":"xa","slug":"xa-long-phu","name_with_type":"Xã Long Phú","path":"Xã Long Phú, Huyện Tam Bình, Tỉnh Vĩnh Long","path_with_type":"Xã Long Phú, Huyện Tam Bình, Tỉnh Vĩnh Long","code":"29752","parent_code":"860"},"29755":{"name":"Xã Mỹ Thạnh Trung","type":"xa","slug":"xa-my-thanh-trung","name_with_type":"Xã Mỹ Thạnh Trung","path":"Xã Mỹ Thạnh Trung, Huyện Tam Bình, Tỉnh Vĩnh Long","path_with_type":"Xã Mỹ Thạnh Trung, Huyện Tam Bình, Tỉnh Vĩnh Long","code":"29755","parent_code":"860"},"29761":{"name":"Xã Loan Mỹ","type":"xa","slug":"xa-loan-my","name_with_type":"Xã Loan Mỹ","path":"Xã Loan Mỹ, Huyện Tam Bình, Tỉnh Vĩnh Long","path_with_type":"Xã Loan Mỹ, Huyện Tam Bình, Tỉnh Vĩnh Long","code":"29761","parent_code":"860"},"29764":{"name":"Xã Ngãi Tứ","type":"xa","slug":"xa-ngai-tu","name_with_type":"Xã Ngãi Tứ","path":"Xã Ngãi Tứ, Huyện Tam Bình, Tỉnh Vĩnh Long","path_with_type":"Xã Ngãi Tứ, Huyện Tam Bình, Tỉnh Vĩnh Long","code":"29764","parent_code":"860"},"29767":{"name":"Xã Bình Ninh","type":"xa","slug":"xa-binh-ninh","name_with_type":"Xã Bình Ninh","path":"Xã Bình Ninh, Huyện Tam Bình, Tỉnh Vĩnh Long","path_with_type":"Xã Bình Ninh, Huyện Tam Bình, Tỉnh Vĩnh Long","code":"29767","parent_code":"860"},"29770":{"name":"Phường Cái Vồn","type":"phuong","slug":"phuong-cai-von","name_with_type":"Phường Cái Vồn","path":"Phường Cái Vồn, Thị xã Bình Minh, Tỉnh Vĩnh Long","path_with_type":"Phường Cái Vồn, Thị xã Bình Minh, Tỉnh Vĩnh Long","code":"29770","parent_code":"861"},"29771":{"name":"Phường Thành Phước","type":"phuong","slug":"phuong-thanh-phuoc","name_with_type":"Phường Thành Phước","path":"Phường Thành Phước, Thị xã Bình Minh, Tỉnh Vĩnh Long","path_with_type":"Phường Thành Phước, Thị xã Bình Minh, Tỉnh Vĩnh Long","code":"29771","parent_code":"861"},"29776":{"name":"Xã Tân Thành","type":"xa","slug":"xa-tan-thanh","name_with_type":"Xã Tân Thành","path":"Xã Tân Thành, Huyện Bình Tân, Tỉnh Vĩnh Long","path_with_type":"Xã Tân Thành, Huyện Bình Tân, Tỉnh Vĩnh Long","code":"29776","parent_code":"863"},"29779":{"name":"Xã Thành Trung","type":"xa","slug":"xa-thanh-trung","name_with_type":"Xã Thành Trung","path":"Xã Thành Trung, Huyện Bình Tân, Tỉnh Vĩnh Long","path_with_type":"Xã Thành Trung, Huyện Bình Tân, Tỉnh Vĩnh Long","code":"29779","parent_code":"863"},"29782":{"name":"Xã Tân An Thạnh","type":"xa","slug":"xa-tan-an-thanh","name_with_type":"Xã Tân An Thạnh","path":"Xã Tân An Thạnh, Huyện Bình Tân, Tỉnh Vĩnh Long","path_with_type":"Xã Tân An Thạnh, Huyện Bình Tân, Tỉnh Vĩnh Long","code":"29782","parent_code":"863"},"29785":{"name":"Xã Tân Lược","type":"xa","slug":"xa-tan-luoc","name_with_type":"Xã Tân Lược","path":"Xã Tân Lược, Huyện Bình Tân, Tỉnh Vĩnh Long","path_with_type":"Xã Tân Lược, Huyện Bình Tân, Tỉnh Vĩnh Long","code":"29785","parent_code":"863"},"29788":{"name":"Xã Nguyễn Văn Thảnh","type":"xa","slug":"xa-nguyen-van-thanh","name_with_type":"Xã Nguyễn Văn Thảnh","path":"Xã Nguyễn Văn Thảnh, Huyện Bình Tân, Tỉnh Vĩnh Long","path_with_type":"Xã Nguyễn Văn Thảnh, Huyện Bình Tân, Tỉnh Vĩnh Long","code":"29788","parent_code":"863"},"29791":{"name":"Xã Thành Lợi","type":"xa","slug":"xa-thanh-loi","name_with_type":"Xã Thành Lợi","path":"Xã Thành Lợi, Huyện Bình Tân, Tỉnh Vĩnh Long","path_with_type":"Xã Thành Lợi, Huyện Bình Tân, Tỉnh Vĩnh Long","code":"29791","parent_code":"863"},"29794":{"name":"Xã Mỹ Thuận","type":"xa","slug":"xa-my-thuan","name_with_type":"Xã Mỹ Thuận","path":"Xã Mỹ Thuận, Huyện Bình Tân, Tỉnh Vĩnh Long","path_with_type":"Xã Mỹ Thuận, Huyện Bình Tân, Tỉnh Vĩnh Long","code":"29794","parent_code":"863"},"29797":{"name":"Xã Tân Bình","type":"xa","slug":"xa-tan-binh","name_with_type":"Xã Tân Bình","path":"Xã Tân Bình, Huyện Bình Tân, Tỉnh Vĩnh Long","path_with_type":"Xã Tân Bình, Huyện Bình Tân, Tỉnh Vĩnh Long","code":"29797","parent_code":"863"},"29800":{"name":"Thị trấn Tân Quới","type":"thi-tran","slug":"thi-tran-tan-quoi","name_with_type":"Thị trấn Tân Quới","path":"Thị trấn Tân Quới, Huyện Bình Tân, Tỉnh Vĩnh Long","path_with_type":"Thị trấn Tân Quới, Huyện Bình Tân, Tỉnh Vĩnh Long","code":"29800","parent_code":"863"},"29806":{"name":"Xã Thuận An","type":"xa","slug":"xa-thuan-an","name_with_type":"Xã Thuận An","path":"Xã Thuận An, Thị xã Bình Minh, Tỉnh Vĩnh Long","path_with_type":"Xã Thuận An, Thị xã Bình Minh, Tỉnh Vĩnh Long","code":"29806","parent_code":"861"},"29809":{"name":"Xã Đông Thạnh","type":"xa","slug":"xa-dong-thanh","name_with_type":"Xã Đông Thạnh","path":"Xã Đông Thạnh, Thị xã Bình Minh, Tỉnh Vĩnh Long","path_with_type":"Xã Đông Thạnh, Thị xã Bình Minh, Tỉnh Vĩnh Long","code":"29809","parent_code":"861"},"29812":{"name":"Xã Đông Bình","type":"xa","slug":"xa-dong-binh","name_with_type":"Xã Đông Bình","path":"Xã Đông Bình, Thị xã Bình Minh, Tỉnh Vĩnh Long","path_with_type":"Xã Đông Bình, Thị xã Bình Minh, Tỉnh Vĩnh Long","code":"29812","parent_code":"861"},"29813":{"name":"Phường Đông Thuận","type":"phuong","slug":"phuong-dong-thuan","name_with_type":"Phường Đông Thuận","path":"Phường Đông Thuận, Thị xã Bình Minh, Tỉnh Vĩnh Long","path_with_type":"Phường Đông Thuận, Thị xã Bình Minh, Tỉnh Vĩnh Long","code":"29813","parent_code":"861"},"29815":{"name":"Xã Mỹ Hòa","type":"xa","slug":"xa-my-hoa","name_with_type":"Xã Mỹ Hòa","path":"Xã Mỹ Hòa, Thị xã Bình Minh, Tỉnh Vĩnh Long","path_with_type":"Xã Mỹ Hòa, Thị xã Bình Minh, Tỉnh Vĩnh Long","code":"29815","parent_code":"861"},"29818":{"name":"Xã Đông Thành","type":"xa","slug":"xa-dong-thanh","name_with_type":"Xã Đông Thành","path":"Xã Đông Thành, Thị xã Bình Minh, Tỉnh Vĩnh Long","path_with_type":"Xã Đông Thành, Thị xã Bình Minh, Tỉnh Vĩnh Long","code":"29818","parent_code":"861"},"29821":{"name":"Thị trấn Trà Ôn","type":"thi-tran","slug":"thi-tran-tra-on","name_with_type":"Thị trấn Trà Ôn","path":"Thị trấn Trà Ôn, Huyện Trà Ôn, Tỉnh Vĩnh Long","path_with_type":"Thị trấn Trà Ôn, Huyện Trà Ôn, Tỉnh Vĩnh Long","code":"29821","parent_code":"862"},"29824":{"name":"Xã Xuân Hiệp","type":"xa","slug":"xa-xuan-hiep","name_with_type":"Xã Xuân Hiệp","path":"Xã Xuân Hiệp, Huyện Trà Ôn, Tỉnh Vĩnh Long","path_with_type":"Xã Xuân Hiệp, Huyện Trà Ôn, Tỉnh Vĩnh Long","code":"29824","parent_code":"862"},"29827":{"name":"Xã Nhơn Bình","type":"xa","slug":"xa-nhon-binh","name_with_type":"Xã Nhơn Bình","path":"Xã Nhơn Bình, Huyện Trà Ôn, Tỉnh Vĩnh Long","path_with_type":"Xã Nhơn Bình, Huyện Trà Ôn, Tỉnh Vĩnh Long","code":"29827","parent_code":"862"},"29830":{"name":"Xã Hòa Bình","type":"xa","slug":"xa-hoa-binh","name_with_type":"Xã Hòa Bình","path":"Xã Hòa Bình, Huyện Trà Ôn, Tỉnh Vĩnh Long","path_with_type":"Xã Hòa Bình, Huyện Trà Ôn, Tỉnh Vĩnh Long","code":"29830","parent_code":"862"},"29833":{"name":"Xã Thới Hòa","type":"xa","slug":"xa-thoi-hoa","name_with_type":"Xã Thới Hòa","path":"Xã Thới Hòa, Huyện Trà Ôn, Tỉnh Vĩnh Long","path_with_type":"Xã Thới Hòa, Huyện Trà Ôn, Tỉnh Vĩnh Long","code":"29833","parent_code":"862"},"29836":{"name":"Xã Trà Côn","type":"xa","slug":"xa-tra-con","name_with_type":"Xã Trà Côn","path":"Xã Trà Côn, Huyện Trà Ôn, Tỉnh Vĩnh Long","path_with_type":"Xã Trà Côn, Huyện Trà Ôn, Tỉnh Vĩnh Long","code":"29836","parent_code":"862"},"29839":{"name":"Xã Tân Mỹ","type":"xa","slug":"xa-tan-my","name_with_type":"Xã Tân Mỹ","path":"Xã Tân Mỹ, Huyện Trà Ôn, Tỉnh Vĩnh Long","path_with_type":"Xã Tân Mỹ, Huyện Trà Ôn, Tỉnh Vĩnh Long","code":"29839","parent_code":"862"},"29842":{"name":"Xã Hựu Thành","type":"xa","slug":"xa-huu-thanh","name_with_type":"Xã Hựu Thành","path":"Xã Hựu Thành, Huyện Trà Ôn, Tỉnh Vĩnh Long","path_with_type":"Xã Hựu Thành, Huyện Trà Ôn, Tỉnh Vĩnh Long","code":"29842","parent_code":"862"},"29845":{"name":"Xã Vĩnh Xuân","type":"xa","slug":"xa-vinh-xuan","name_with_type":"Xã Vĩnh Xuân","path":"Xã Vĩnh Xuân, Huyện Trà Ôn, Tỉnh Vĩnh Long","path_with_type":"Xã Vĩnh Xuân, Huyện Trà Ôn, Tỉnh Vĩnh Long","code":"29845","parent_code":"862"},"29848":{"name":"Xã Thuận Thới","type":"xa","slug":"xa-thuan-thoi","name_with_type":"Xã Thuận Thới","path":"Xã Thuận Thới, Huyện Trà Ôn, Tỉnh Vĩnh Long","path_with_type":"Xã Thuận Thới, Huyện Trà Ôn, Tỉnh Vĩnh Long","code":"29848","parent_code":"862"},"29851":{"name":"Xã Phú Thành","type":"xa","slug":"xa-phu-thanh","name_with_type":"Xã Phú Thành","path":"Xã Phú Thành, Huyện Trà Ôn, Tỉnh Vĩnh Long","path_with_type":"Xã Phú Thành, Huyện Trà Ôn, Tỉnh Vĩnh Long","code":"29851","parent_code":"862"},"29857":{"name":"Xã Lục Sỹ Thành","type":"xa","slug":"xa-luc-sy-thanh","name_with_type":"Xã Lục Sỹ Thành","path":"Xã Lục Sỹ Thành, Huyện Trà Ôn, Tỉnh Vĩnh Long","path_with_type":"Xã Lục Sỹ Thành, Huyện Trà Ôn, Tỉnh Vĩnh Long","code":"29857","parent_code":"862"},"29860":{"name":"Xã Tích Thiện","type":"xa","slug":"xa-tich-thien","name_with_type":"Xã Tích Thiện","path":"Xã Tích Thiện, Huyện Trà Ôn, Tỉnh Vĩnh Long","path_with_type":"Xã Tích Thiện, Huyện Trà Ôn, Tỉnh Vĩnh Long","code":"29860","parent_code":"862"},"29869":{"name":"Phường 1","type":"phuong","slug":"phuong-1","name_with_type":"Phường 1","path":"Phường 1, Thành phố Cao Lãnh, Tỉnh Đồng Tháp","path_with_type":"Phường 1, Thành phố Cao Lãnh, Tỉnh Đồng Tháp","code":"29869","parent_code":"866"},"29872":{"name":"Phường 4","type":"phuong","slug":"phuong-4","name_with_type":"Phường 4","path":"Phường 4, Thành phố Cao Lãnh, Tỉnh Đồng Tháp","path_with_type":"Phường 4, Thành phố Cao Lãnh, Tỉnh Đồng Tháp","code":"29872","parent_code":"866"},"29875":{"name":"Phường 3","type":"phuong","slug":"phuong-3","name_with_type":"Phường 3","path":"Phường 3, Thành phố Cao Lãnh, Tỉnh Đồng Tháp","path_with_type":"Phường 3, Thành phố Cao Lãnh, Tỉnh Đồng Tháp","code":"29875","parent_code":"866"},"29878":{"name":"Phường 6","type":"phuong","slug":"phuong-6","name_with_type":"Phường 6","path":"Phường 6, Thành phố Cao Lãnh, Tỉnh Đồng Tháp","path_with_type":"Phường 6, Thành phố Cao Lãnh, Tỉnh Đồng Tháp","code":"29878","parent_code":"866"},"29881":{"name":"Phường Mỹ Ngãi","type":"phuong","slug":"phuong-my-ngai","name_with_type":"Phường Mỹ Ngãi","path":"Phường Mỹ Ngãi, Thành phố Cao Lãnh, Tỉnh Đồng Tháp","path_with_type":"Phường Mỹ Ngãi, Thành phố Cao Lãnh, Tỉnh Đồng Tháp","code":"29881","parent_code":"866"},"29884":{"name":"Xã Mỹ Tân","type":"xa","slug":"xa-my-tan","name_with_type":"Xã Mỹ Tân","path":"Xã Mỹ Tân, Thành phố Cao Lãnh, Tỉnh Đồng Tháp","path_with_type":"Xã Mỹ Tân, Thành phố Cao Lãnh, Tỉnh Đồng Tháp","code":"29884","parent_code":"866"},"29887":{"name":"Xã Mỹ Trà","type":"xa","slug":"xa-my-tra","name_with_type":"Xã Mỹ Trà","path":"Xã Mỹ Trà, Thành phố Cao Lãnh, Tỉnh Đồng Tháp","path_with_type":"Xã Mỹ Trà, Thành phố Cao Lãnh, Tỉnh Đồng Tháp","code":"29887","parent_code":"866"},"29888":{"name":"Phường Mỹ Phú","type":"phuong","slug":"phuong-my-phu","name_with_type":"Phường Mỹ Phú","path":"Phường Mỹ Phú, Thành phố Cao Lãnh, Tỉnh Đồng Tháp","path_with_type":"Phường Mỹ Phú, Thành phố Cao Lãnh, Tỉnh Đồng Tháp","code":"29888","parent_code":"866"},"29890":{"name":"Xã Tân Thuận Tây","type":"xa","slug":"xa-tan-thuan-tay","name_with_type":"Xã Tân Thuận Tây","path":"Xã Tân Thuận Tây, Thành phố Cao Lãnh, Tỉnh Đồng Tháp","path_with_type":"Xã Tân Thuận Tây, Thành phố Cao Lãnh, Tỉnh Đồng Tháp","code":"29890","parent_code":"866"},"29892":{"name":"Phường Hoà Thuận","type":"phuong","slug":"phuong-hoa-thuan","name_with_type":"Phường Hoà Thuận","path":"Phường Hoà Thuận, Thành phố Cao Lãnh, Tỉnh Đồng Tháp","path_with_type":"Phường Hoà Thuận, Thành phố Cao Lãnh, Tỉnh Đồng Tháp","code":"29892","parent_code":"866"},"29893":{"name":"Xã Hòa An","type":"xa","slug":"xa-hoa-an","name_with_type":"Xã Hòa An","path":"Xã Hòa An, Thành phố Cao Lãnh, Tỉnh Đồng Tháp","path_with_type":"Xã Hòa An, Thành phố Cao Lãnh, Tỉnh Đồng Tháp","code":"29893","parent_code":"866"},"29896":{"name":"Xã Tân Thuận Đông","type":"xa","slug":"xa-tan-thuan-dong","name_with_type":"Xã Tân Thuận Đông","path":"Xã Tân Thuận Đông, Thành phố Cao Lãnh, Tỉnh Đồng Tháp","path_with_type":"Xã Tân Thuận Đông, Thành phố Cao Lãnh, Tỉnh Đồng Tháp","code":"29896","parent_code":"866"},"29899":{"name":"Xã Tịnh Thới","type":"xa","slug":"xa-tinh-thoi","name_with_type":"Xã Tịnh Thới","path":"Xã Tịnh Thới, Thành phố Cao Lãnh, Tỉnh Đồng Tháp","path_with_type":"Xã Tịnh Thới, Thành phố Cao Lãnh, Tỉnh Đồng Tháp","code":"29899","parent_code":"866"},"29902":{"name":"Phường 3","type":"phuong","slug":"phuong-3","name_with_type":"Phường 3","path":"Phường 3, Thành phố Sa Đéc, Tỉnh Đồng Tháp","path_with_type":"Phường 3, Thành phố Sa Đéc, Tỉnh Đồng Tháp","code":"29902","parent_code":"867"},"29905":{"name":"Phường 1","type":"phuong","slug":"phuong-1","name_with_type":"Phường 1","path":"Phường 1, Thành phố Sa Đéc, Tỉnh Đồng Tháp","path_with_type":"Phường 1, Thành phố Sa Đéc, Tỉnh Đồng Tháp","code":"29905","parent_code":"867"},"29908":{"name":"Phường 4","type":"phuong","slug":"phuong-4","name_with_type":"Phường 4","path":"Phường 4, Thành phố Sa Đéc, Tỉnh Đồng Tháp","path_with_type":"Phường 4, Thành phố Sa Đéc, Tỉnh Đồng Tháp","code":"29908","parent_code":"867"},"29911":{"name":"Phường 2","type":"phuong","slug":"phuong-2","name_with_type":"Phường 2","path":"Phường 2, Thành phố Sa Đéc, Tỉnh Đồng Tháp","path_with_type":"Phường 2, Thành phố Sa Đéc, Tỉnh Đồng Tháp","code":"29911","parent_code":"867"},"29914":{"name":"Xã Tân Khánh Đông","type":"xa","slug":"xa-tan-khanh-dong","name_with_type":"Xã Tân Khánh Đông","path":"Xã Tân Khánh Đông, Thành phố Sa Đéc, Tỉnh Đồng Tháp","path_with_type":"Xã Tân Khánh Đông, Thành phố Sa Đéc, Tỉnh Đồng Tháp","code":"29914","parent_code":"867"},"29917":{"name":"Phường Tân Quy Đông","type":"phuong","slug":"phuong-tan-quy-dong","name_with_type":"Phường Tân Quy Đông","path":"Phường Tân Quy Đông, Thành phố Sa Đéc, Tỉnh Đồng Tháp","path_with_type":"Phường Tân Quy Đông, Thành phố Sa Đéc, Tỉnh Đồng Tháp","code":"29917","parent_code":"867"},"29919":{"name":"Phường An Hoà","type":"phuong","slug":"phuong-an-hoa","name_with_type":"Phường An Hoà","path":"Phường An Hoà, Thành phố Sa Đéc, Tỉnh Đồng Tháp","path_with_type":"Phường An Hoà, Thành phố Sa Đéc, Tỉnh Đồng Tháp","code":"29919","parent_code":"867"},"29920":{"name":"Xã Tân Quy Tây","type":"xa","slug":"xa-tan-quy-tay","name_with_type":"Xã Tân Quy Tây","path":"Xã Tân Quy Tây, Thành phố Sa Đéc, Tỉnh Đồng Tháp","path_with_type":"Xã Tân Quy Tây, Thành phố Sa Đéc, Tỉnh Đồng Tháp","code":"29920","parent_code":"867"},"29923":{"name":"Xã Tân Phú Đông","type":"xa","slug":"xa-tan-phu-dong","name_with_type":"Xã Tân Phú Đông","path":"Xã Tân Phú Đông, Thành phố Sa Đéc, Tỉnh Đồng Tháp","path_with_type":"Xã Tân Phú Đông, Thành phố Sa Đéc, Tỉnh Đồng Tháp","code":"29923","parent_code":"867"},"29926":{"name":"Thị trấn Sa Rài","type":"thi-tran","slug":"thi-tran-sa-rai","name_with_type":"Thị trấn Sa Rài","path":"Thị trấn Sa Rài, Huyện Tân Hồng, Tỉnh Đồng Tháp","path_with_type":"Thị trấn Sa Rài, Huyện Tân Hồng, Tỉnh Đồng Tháp","code":"29926","parent_code":"869"},"29929":{"name":"Xã Tân Hộ Cơ","type":"xa","slug":"xa-tan-ho-co","name_with_type":"Xã Tân Hộ Cơ","path":"Xã Tân Hộ Cơ, Huyện Tân Hồng, Tỉnh Đồng Tháp","path_with_type":"Xã Tân Hộ Cơ, Huyện Tân Hồng, Tỉnh Đồng Tháp","code":"29929","parent_code":"869"},"29932":{"name":"Xã Thông Bình","type":"xa","slug":"xa-thong-binh","name_with_type":"Xã Thông Bình","path":"Xã Thông Bình, Huyện Tân Hồng, Tỉnh Đồng Tháp","path_with_type":"Xã Thông Bình, Huyện Tân Hồng, Tỉnh Đồng Tháp","code":"29932","parent_code":"869"},"29935":{"name":"Xã Bình Phú","type":"xa","slug":"xa-binh-phu","name_with_type":"Xã Bình Phú","path":"Xã Bình Phú, Huyện Tân Hồng, Tỉnh Đồng Tháp","path_with_type":"Xã Bình Phú, Huyện Tân Hồng, Tỉnh Đồng Tháp","code":"29935","parent_code":"869"},"29938":{"name":"Xã Tân Thành A","type":"xa","slug":"xa-tan-thanh-a","name_with_type":"Xã Tân Thành A","path":"Xã Tân Thành A, Huyện Tân Hồng, Tỉnh Đồng Tháp","path_with_type":"Xã Tân Thành A, Huyện Tân Hồng, Tỉnh Đồng Tháp","code":"29938","parent_code":"869"},"29941":{"name":"Xã Tân Thành B","type":"xa","slug":"xa-tan-thanh-b","name_with_type":"Xã Tân Thành B","path":"Xã Tân Thành B, Huyện Tân Hồng, Tỉnh Đồng Tháp","path_with_type":"Xã Tân Thành B, Huyện Tân Hồng, Tỉnh Đồng Tháp","code":"29941","parent_code":"869"},"29944":{"name":"Xã Tân Phước","type":"xa","slug":"xa-tan-phuoc","name_with_type":"Xã Tân Phước","path":"Xã Tân Phước, Huyện Tân Hồng, Tỉnh Đồng Tháp","path_with_type":"Xã Tân Phước, Huyện Tân Hồng, Tỉnh Đồng Tháp","code":"29944","parent_code":"869"},"29947":{"name":"Xã Tân Công Chí","type":"xa","slug":"xa-tan-cong-chi","name_with_type":"Xã Tân Công Chí","path":"Xã Tân Công Chí, Huyện Tân Hồng, Tỉnh Đồng Tháp","path_with_type":"Xã Tân Công Chí, Huyện Tân Hồng, Tỉnh Đồng Tháp","code":"29947","parent_code":"869"},"29950":{"name":"Xã An Phước","type":"xa","slug":"xa-an-phuoc","name_with_type":"Xã An Phước","path":"Xã An Phước, Huyện Tân Hồng, Tỉnh Đồng Tháp","path_with_type":"Xã An Phước, Huyện Tân Hồng, Tỉnh Đồng Tháp","code":"29950","parent_code":"869"},"29954":{"name":"Phường An Lộc","type":"phuong","slug":"phuong-an-loc","name_with_type":"Phường An Lộc","path":"Phường An Lộc, Thành phố Hồng Ngự, Tỉnh Đồng Tháp","path_with_type":"Phường An Lộc, Thành phố Hồng Ngự, Tỉnh Đồng Tháp","code":"29954","parent_code":"868"},"29955":{"name":"Phường An Thạnh","type":"phuong","slug":"phuong-an-thanh","name_with_type":"Phường An Thạnh","path":"Phường An Thạnh, Thành phố Hồng Ngự, Tỉnh Đồng Tháp","path_with_type":"Phường An Thạnh, Thành phố Hồng Ngự, Tỉnh Đồng Tháp","code":"29955","parent_code":"868"},"29956":{"name":"Xã Thường Phước 1","type":"xa","slug":"xa-thuong-phuoc-1","name_with_type":"Xã Thường Phước 1","path":"Xã Thường Phước 1, Huyện Hồng Ngự, Tỉnh Đồng Tháp","path_with_type":"Xã Thường Phước 1, Huyện Hồng Ngự, Tỉnh Đồng Tháp","code":"29956","parent_code":"870"},"29959":{"name":"Xã Bình Thạnh","type":"xa","slug":"xa-binh-thanh","name_with_type":"Xã Bình Thạnh","path":"Xã Bình Thạnh, Thành phố Hồng Ngự, Tỉnh Đồng Tháp","path_with_type":"Xã Bình Thạnh, Thành phố Hồng Ngự, Tỉnh Đồng Tháp","code":"29959","parent_code":"868"},"29962":{"name":"Xã Thường Thới Hậu A","type":"xa","slug":"xa-thuong-thoi-hau-a","name_with_type":"Xã Thường Thới Hậu A","path":"Xã Thường Thới Hậu A, Huyện Hồng Ngự, Tỉnh Đồng Tháp","path_with_type":"Xã Thường Thới Hậu A, Huyện Hồng Ngự, Tỉnh Đồng Tháp","code":"29962","parent_code":"870"},"29965":{"name":"Xã Tân Hội","type":"xa","slug":"xa-tan-hoi","name_with_type":"Xã Tân Hội","path":"Xã Tân Hội, Thành phố Hồng Ngự, Tỉnh Đồng Tháp","path_with_type":"Xã Tân Hội, Thành phố Hồng Ngự, Tỉnh Đồng Tháp","code":"29965","parent_code":"868"},"29971":{"name":"Thị trấn Thường Thới Tiền","type":"thi-tran","slug":"thi-tran-thuong-thoi-tien","name_with_type":"Thị trấn Thường Thới Tiền","path":"Thị trấn Thường Thới Tiền, Huyện Hồng Ngự, Tỉnh Đồng Tháp","path_with_type":"Thị trấn Thường Thới Tiền, Huyện Hồng Ngự, Tỉnh Đồng Tháp","code":"29971","parent_code":"870"},"29974":{"name":"Xã Thường Phước 2","type":"xa","slug":"xa-thuong-phuoc-2","name_with_type":"Xã Thường Phước 2","path":"Xã Thường Phước 2, Huyện Hồng Ngự, Tỉnh Đồng Tháp","path_with_type":"Xã Thường Phước 2, Huyện Hồng Ngự, Tỉnh Đồng Tháp","code":"29974","parent_code":"870"},"29977":{"name":"Xã Thường Lạc","type":"xa","slug":"xa-thuong-lac","name_with_type":"Xã Thường Lạc","path":"Xã Thường Lạc, Huyện Hồng Ngự, Tỉnh Đồng Tháp","path_with_type":"Xã Thường Lạc, Huyện Hồng Ngự, Tỉnh Đồng Tháp","code":"29977","parent_code":"870"},"29978":{"name":"Phường An Lạc","type":"phuong","slug":"phuong-an-lac","name_with_type":"Phường An Lạc","path":"Phường An Lạc, Thành phố Hồng Ngự, Tỉnh Đồng Tháp","path_with_type":"Phường An Lạc, Thành phố Hồng Ngự, Tỉnh Đồng Tháp","code":"29978","parent_code":"868"},"29980":{"name":"Xã Long Khánh A","type":"xa","slug":"xa-long-khanh-a","name_with_type":"Xã Long Khánh A","path":"Xã Long Khánh A, Huyện Hồng Ngự, Tỉnh Đồng Tháp","path_with_type":"Xã Long Khánh A, Huyện Hồng Ngự, Tỉnh Đồng Tháp","code":"29980","parent_code":"870"},"29983":{"name":"Xã Long Khánh B","type":"xa","slug":"xa-long-khanh-b","name_with_type":"Xã Long Khánh B","path":"Xã Long Khánh B, Huyện Hồng Ngự, Tỉnh Đồng Tháp","path_with_type":"Xã Long Khánh B, Huyện Hồng Ngự, Tỉnh Đồng Tháp","code":"29983","parent_code":"870"},"29986":{"name":"Phường An Bình B","type":"phuong","slug":"phuong-an-binh-b","name_with_type":"Phường An Bình B","path":"Phường An Bình B, Thành phố Hồng Ngự, Tỉnh Đồng Tháp","path_with_type":"Phường An Bình B, Thành phố Hồng Ngự, Tỉnh Đồng Tháp","code":"29986","parent_code":"868"},"29989":{"name":"Phường An Bình A","type":"phuong","slug":"phuong-an-binh-a","name_with_type":"Phường An Bình A","path":"Phường An Bình A, Thành phố Hồng Ngự, Tỉnh Đồng Tháp","path_with_type":"Phường An Bình A, Thành phố Hồng Ngự, Tỉnh Đồng Tháp","code":"29989","parent_code":"868"},"29992":{"name":"Xã Long Thuận","type":"xa","slug":"xa-long-thuan","name_with_type":"Xã Long Thuận","path":"Xã Long Thuận, Huyện Hồng Ngự, Tỉnh Đồng Tháp","path_with_type":"Xã Long Thuận, Huyện Hồng Ngự, Tỉnh Đồng Tháp","code":"29992","parent_code":"870"},"29995":{"name":"Xã Phú Thuận B","type":"xa","slug":"xa-phu-thuan-b","name_with_type":"Xã Phú Thuận B","path":"Xã Phú Thuận B, Huyện Hồng Ngự, Tỉnh Đồng Tháp","path_with_type":"Xã Phú Thuận B, Huyện Hồng Ngự, Tỉnh Đồng Tháp","code":"29995","parent_code":"870"},"29998":{"name":"Xã Phú Thuận A","type":"xa","slug":"xa-phu-thuan-a","name_with_type":"Xã Phú Thuận A","path":"Xã Phú Thuận A, Huyện Hồng Ngự, Tỉnh Đồng Tháp","path_with_type":"Xã Phú Thuận A, Huyện Hồng Ngự, Tỉnh Đồng Tháp","code":"29998","parent_code":"870"},"30001":{"name":"Thị trấn Tràm Chim","type":"thi-tran","slug":"thi-tran-tram-chim","name_with_type":"Thị trấn Tràm Chim","path":"Thị trấn Tràm Chim, Huyện Tam Nông, Tỉnh Đồng Tháp","path_with_type":"Thị trấn Tràm Chim, Huyện Tam Nông, Tỉnh Đồng Tháp","code":"30001","parent_code":"871"},"30004":{"name":"Xã Hoà Bình","type":"xa","slug":"xa-hoa-binh","name_with_type":"Xã Hoà Bình","path":"Xã Hoà Bình, Huyện Tam Nông, Tỉnh Đồng Tháp","path_with_type":"Xã Hoà Bình, Huyện Tam Nông, Tỉnh Đồng Tháp","code":"30004","parent_code":"871"},"30007":{"name":"Xã Tân Công Sính","type":"xa","slug":"xa-tan-cong-sinh","name_with_type":"Xã Tân Công Sính","path":"Xã Tân Công Sính, Huyện Tam Nông, Tỉnh Đồng Tháp","path_with_type":"Xã Tân Công Sính, Huyện Tam Nông, Tỉnh Đồng Tháp","code":"30007","parent_code":"871"},"30010":{"name":"Xã Phú Hiệp","type":"xa","slug":"xa-phu-hiep","name_with_type":"Xã Phú Hiệp","path":"Xã Phú Hiệp, Huyện Tam Nông, Tỉnh Đồng Tháp","path_with_type":"Xã Phú Hiệp, Huyện Tam Nông, Tỉnh Đồng Tháp","code":"30010","parent_code":"871"},"30013":{"name":"Xã Phú Đức","type":"xa","slug":"xa-phu-duc","name_with_type":"Xã Phú Đức","path":"Xã Phú Đức, Huyện Tam Nông, Tỉnh Đồng Tháp","path_with_type":"Xã Phú Đức, Huyện Tam Nông, Tỉnh Đồng Tháp","code":"30013","parent_code":"871"},"30016":{"name":"Xã Phú Thành B","type":"xa","slug":"xa-phu-thanh-b","name_with_type":"Xã Phú Thành B","path":"Xã Phú Thành B, Huyện Tam Nông, Tỉnh Đồng Tháp","path_with_type":"Xã Phú Thành B, Huyện Tam Nông, Tỉnh Đồng Tháp","code":"30016","parent_code":"871"},"30019":{"name":"Xã An Hòa","type":"xa","slug":"xa-an-hoa","name_with_type":"Xã An Hòa","path":"Xã An Hòa, Huyện Tam Nông, Tỉnh Đồng Tháp","path_with_type":"Xã An Hòa, Huyện Tam Nông, Tỉnh Đồng Tháp","code":"30019","parent_code":"871"},"30022":{"name":"Xã An Long","type":"xa","slug":"xa-an-long","name_with_type":"Xã An Long","path":"Xã An Long, Huyện Tam Nông, Tỉnh Đồng Tháp","path_with_type":"Xã An Long, Huyện Tam Nông, Tỉnh Đồng Tháp","code":"30022","parent_code":"871"},"30025":{"name":"Xã Phú Cường","type":"xa","slug":"xa-phu-cuong","name_with_type":"Xã Phú Cường","path":"Xã Phú Cường, Huyện Tam Nông, Tỉnh Đồng Tháp","path_with_type":"Xã Phú Cường, Huyện Tam Nông, Tỉnh Đồng Tháp","code":"30025","parent_code":"871"},"30028":{"name":"Xã Phú Ninh","type":"xa","slug":"xa-phu-ninh","name_with_type":"Xã Phú Ninh","path":"Xã Phú Ninh, Huyện Tam Nông, Tỉnh Đồng Tháp","path_with_type":"Xã Phú Ninh, Huyện Tam Nông, Tỉnh Đồng Tháp","code":"30028","parent_code":"871"},"30031":{"name":"Xã Phú Thọ","type":"xa","slug":"xa-phu-tho","name_with_type":"Xã Phú Thọ","path":"Xã Phú Thọ, Huyện Tam Nông, Tỉnh Đồng Tháp","path_with_type":"Xã Phú Thọ, Huyện Tam Nông, Tỉnh Đồng Tháp","code":"30031","parent_code":"871"},"30034":{"name":"Xã Phú Thành A","type":"xa","slug":"xa-phu-thanh-a","name_with_type":"Xã Phú Thành A","path":"Xã Phú Thành A, Huyện Tam Nông, Tỉnh Đồng Tháp","path_with_type":"Xã Phú Thành A, Huyện Tam Nông, Tỉnh Đồng Tháp","code":"30034","parent_code":"871"},"30037":{"name":"Thị trấn Mỹ An","type":"thi-tran","slug":"thi-tran-my-an","name_with_type":"Thị trấn Mỹ An","path":"Thị trấn Mỹ An, Huyện Tháp Mười, Tỉnh Đồng Tháp","path_with_type":"Thị trấn Mỹ An, Huyện Tháp Mười, Tỉnh Đồng Tháp","code":"30037","parent_code":"872"},"30040":{"name":"Xã Thạnh Lợi","type":"xa","slug":"xa-thanh-loi","name_with_type":"Xã Thạnh Lợi","path":"Xã Thạnh Lợi, Huyện Tháp Mười, Tỉnh Đồng Tháp","path_with_type":"Xã Thạnh Lợi, Huyện Tháp Mười, Tỉnh Đồng Tháp","code":"30040","parent_code":"872"},"30043":{"name":"Xã Hưng Thạnh","type":"xa","slug":"xa-hung-thanh","name_with_type":"Xã Hưng Thạnh","path":"Xã Hưng Thạnh, Huyện Tháp Mười, Tỉnh Đồng Tháp","path_with_type":"Xã Hưng Thạnh, Huyện Tháp Mười, Tỉnh Đồng Tháp","code":"30043","parent_code":"872"},"30046":{"name":"Xã Trường Xuân","type":"xa","slug":"xa-truong-xuan","name_with_type":"Xã Trường Xuân","path":"Xã Trường Xuân, Huyện Tháp Mười, Tỉnh Đồng Tháp","path_with_type":"Xã Trường Xuân, Huyện Tháp Mười, Tỉnh Đồng Tháp","code":"30046","parent_code":"872"},"30049":{"name":"Xã Tân Kiều","type":"xa","slug":"xa-tan-kieu","name_with_type":"Xã Tân Kiều","path":"Xã Tân Kiều, Huyện Tháp Mười, Tỉnh Đồng Tháp","path_with_type":"Xã Tân Kiều, Huyện Tháp Mười, Tỉnh Đồng Tháp","code":"30049","parent_code":"872"},"30052":{"name":"Xã Mỹ Hòa","type":"xa","slug":"xa-my-hoa","name_with_type":"Xã Mỹ Hòa","path":"Xã Mỹ Hòa, Huyện Tháp Mười, Tỉnh Đồng Tháp","path_with_type":"Xã Mỹ Hòa, Huyện Tháp Mười, Tỉnh Đồng Tháp","code":"30052","parent_code":"872"},"30055":{"name":"Xã Mỹ Quý","type":"xa","slug":"xa-my-quy","name_with_type":"Xã Mỹ Quý","path":"Xã Mỹ Quý, Huyện Tháp Mười, Tỉnh Đồng Tháp","path_with_type":"Xã Mỹ Quý, Huyện Tháp Mười, Tỉnh Đồng Tháp","code":"30055","parent_code":"872"},"30058":{"name":"Xã Mỹ Đông","type":"xa","slug":"xa-my-dong","name_with_type":"Xã Mỹ Đông","path":"Xã Mỹ Đông, Huyện Tháp Mười, Tỉnh Đồng Tháp","path_with_type":"Xã Mỹ Đông, Huyện Tháp Mười, Tỉnh Đồng Tháp","code":"30058","parent_code":"872"},"30061":{"name":"Xã Đốc Binh Kiều","type":"xa","slug":"xa-doc-binh-kieu","name_with_type":"Xã Đốc Binh Kiều","path":"Xã Đốc Binh Kiều, Huyện Tháp Mười, Tỉnh Đồng Tháp","path_with_type":"Xã Đốc Binh Kiều, Huyện Tháp Mười, Tỉnh Đồng Tháp","code":"30061","parent_code":"872"},"30064":{"name":"Xã Mỹ An","type":"xa","slug":"xa-my-an","name_with_type":"Xã Mỹ An","path":"Xã Mỹ An, Huyện Tháp Mười, Tỉnh Đồng Tháp","path_with_type":"Xã Mỹ An, Huyện Tháp Mười, Tỉnh Đồng Tháp","code":"30064","parent_code":"872"},"30067":{"name":"Xã Phú Điền","type":"xa","slug":"xa-phu-dien","name_with_type":"Xã Phú Điền","path":"Xã Phú Điền, Huyện Tháp Mười, Tỉnh Đồng Tháp","path_with_type":"Xã Phú Điền, Huyện Tháp Mười, Tỉnh Đồng Tháp","code":"30067","parent_code":"872"},"30070":{"name":"Xã Láng Biển","type":"xa","slug":"xa-lang-bien","name_with_type":"Xã Láng Biển","path":"Xã Láng Biển, Huyện Tháp Mười, Tỉnh Đồng Tháp","path_with_type":"Xã Láng Biển, Huyện Tháp Mười, Tỉnh Đồng Tháp","code":"30070","parent_code":"872"},"30073":{"name":"Xã Thanh Mỹ","type":"xa","slug":"xa-thanh-my","name_with_type":"Xã Thanh Mỹ","path":"Xã Thanh Mỹ, Huyện Tháp Mười, Tỉnh Đồng Tháp","path_with_type":"Xã Thanh Mỹ, Huyện Tháp Mười, Tỉnh Đồng Tháp","code":"30073","parent_code":"872"},"30076":{"name":"Thị trấn Mỹ Thọ","type":"thi-tran","slug":"thi-tran-my-tho","name_with_type":"Thị trấn Mỹ Thọ","path":"Thị trấn Mỹ Thọ, Huyện Cao Lãnh, Tỉnh Đồng Tháp","path_with_type":"Thị trấn Mỹ Thọ, Huyện Cao Lãnh, Tỉnh Đồng Tháp","code":"30076","parent_code":"873"},"30079":{"name":"Xã Gáo Giồng","type":"xa","slug":"xa-gao-giong","name_with_type":"Xã Gáo Giồng","path":"Xã Gáo Giồng, Huyện Cao Lãnh, Tỉnh Đồng Tháp","path_with_type":"Xã Gáo Giồng, Huyện Cao Lãnh, Tỉnh Đồng Tháp","code":"30079","parent_code":"873"},"30082":{"name":"Xã Phương Thịnh","type":"xa","slug":"xa-phuong-thinh","name_with_type":"Xã Phương Thịnh","path":"Xã Phương Thịnh, Huyện Cao Lãnh, Tỉnh Đồng Tháp","path_with_type":"Xã Phương Thịnh, Huyện Cao Lãnh, Tỉnh Đồng Tháp","code":"30082","parent_code":"873"},"30085":{"name":"Xã Ba Sao","type":"xa","slug":"xa-ba-sao","name_with_type":"Xã Ba Sao","path":"Xã Ba Sao, Huyện Cao Lãnh, Tỉnh Đồng Tháp","path_with_type":"Xã Ba Sao, Huyện Cao Lãnh, Tỉnh Đồng Tháp","code":"30085","parent_code":"873"},"30088":{"name":"Xã Phong Mỹ","type":"xa","slug":"xa-phong-my","name_with_type":"Xã Phong Mỹ","path":"Xã Phong Mỹ, Huyện Cao Lãnh, Tỉnh Đồng Tháp","path_with_type":"Xã Phong Mỹ, Huyện Cao Lãnh, Tỉnh Đồng Tháp","code":"30088","parent_code":"873"},"30091":{"name":"Xã Tân Nghĩa","type":"xa","slug":"xa-tan-nghia","name_with_type":"Xã Tân Nghĩa","path":"Xã Tân Nghĩa, Huyện Cao Lãnh, Tỉnh Đồng Tháp","path_with_type":"Xã Tân Nghĩa, Huyện Cao Lãnh, Tỉnh Đồng Tháp","code":"30091","parent_code":"873"},"30094":{"name":"Xã Phương Trà","type":"xa","slug":"xa-phuong-tra","name_with_type":"Xã Phương Trà","path":"Xã Phương Trà, Huyện Cao Lãnh, Tỉnh Đồng Tháp","path_with_type":"Xã Phương Trà, Huyện Cao Lãnh, Tỉnh Đồng Tháp","code":"30094","parent_code":"873"},"30097":{"name":"Xã Nhị Mỹ","type":"xa","slug":"xa-nhi-my","name_with_type":"Xã Nhị Mỹ","path":"Xã Nhị Mỹ, Huyện Cao Lãnh, Tỉnh Đồng Tháp","path_with_type":"Xã Nhị Mỹ, Huyện Cao Lãnh, Tỉnh Đồng Tháp","code":"30097","parent_code":"873"},"30100":{"name":"Xã Mỹ Thọ","type":"xa","slug":"xa-my-tho","name_with_type":"Xã Mỹ Thọ","path":"Xã Mỹ Thọ, Huyện Cao Lãnh, Tỉnh Đồng Tháp","path_with_type":"Xã Mỹ Thọ, Huyện Cao Lãnh, Tỉnh Đồng Tháp","code":"30100","parent_code":"873"},"30103":{"name":"Xã Tân Hội Trung","type":"xa","slug":"xa-tan-hoi-trung","name_with_type":"Xã Tân Hội Trung","path":"Xã Tân Hội Trung, Huyện Cao Lãnh, Tỉnh Đồng Tháp","path_with_type":"Xã Tân Hội Trung, Huyện Cao Lãnh, Tỉnh Đồng Tháp","code":"30103","parent_code":"873"},"30106":{"name":"Xã An Bình","type":"xa","slug":"xa-an-binh","name_with_type":"Xã An Bình","path":"Xã An Bình, Huyện Cao Lãnh, Tỉnh Đồng Tháp","path_with_type":"Xã An Bình, Huyện Cao Lãnh, Tỉnh Đồng Tháp","code":"30106","parent_code":"873"},"30109":{"name":"Xã Mỹ Hội","type":"xa","slug":"xa-my-hoi","name_with_type":"Xã Mỹ Hội","path":"Xã Mỹ Hội, Huyện Cao Lãnh, Tỉnh Đồng Tháp","path_with_type":"Xã Mỹ Hội, Huyện Cao Lãnh, Tỉnh Đồng Tháp","code":"30109","parent_code":"873"},"30112":{"name":"Xã Mỹ Hiệp","type":"xa","slug":"xa-my-hiep","name_with_type":"Xã Mỹ Hiệp","path":"Xã Mỹ Hiệp, Huyện Cao Lãnh, Tỉnh Đồng Tháp","path_with_type":"Xã Mỹ Hiệp, Huyện Cao Lãnh, Tỉnh Đồng Tháp","code":"30112","parent_code":"873"},"30115":{"name":"Xã Mỹ Long","type":"xa","slug":"xa-my-long","name_with_type":"Xã Mỹ Long","path":"Xã Mỹ Long, Huyện Cao Lãnh, Tỉnh Đồng Tháp","path_with_type":"Xã Mỹ Long, Huyện Cao Lãnh, Tỉnh Đồng Tháp","code":"30115","parent_code":"873"},"30118":{"name":"Xã Bình Hàng Trung","type":"xa","slug":"xa-binh-hang-trung","name_with_type":"Xã Bình Hàng Trung","path":"Xã Bình Hàng Trung, Huyện Cao Lãnh, Tỉnh Đồng Tháp","path_with_type":"Xã Bình Hàng Trung, Huyện Cao Lãnh, Tỉnh Đồng Tháp","code":"30118","parent_code":"873"},"30121":{"name":"Xã Mỹ Xương","type":"xa","slug":"xa-my-xuong","name_with_type":"Xã Mỹ Xương","path":"Xã Mỹ Xương, Huyện Cao Lãnh, Tỉnh Đồng Tháp","path_with_type":"Xã Mỹ Xương, Huyện Cao Lãnh, Tỉnh Đồng Tháp","code":"30121","parent_code":"873"},"30124":{"name":"Xã Bình Hàng Tây","type":"xa","slug":"xa-binh-hang-tay","name_with_type":"Xã Bình Hàng Tây","path":"Xã Bình Hàng Tây, Huyện Cao Lãnh, Tỉnh Đồng Tháp","path_with_type":"Xã Bình Hàng Tây, Huyện Cao Lãnh, Tỉnh Đồng Tháp","code":"30124","parent_code":"873"},"30127":{"name":"Xã Bình Thạnh","type":"xa","slug":"xa-binh-thanh","name_with_type":"Xã Bình Thạnh","path":"Xã Bình Thạnh, Huyện Cao Lãnh, Tỉnh Đồng Tháp","path_with_type":"Xã Bình Thạnh, Huyện Cao Lãnh, Tỉnh Đồng Tháp","code":"30127","parent_code":"873"},"30130":{"name":"Thị trấn Thanh Bình","type":"thi-tran","slug":"thi-tran-thanh-binh","name_with_type":"Thị trấn Thanh Bình","path":"Thị trấn Thanh Bình, Huyện Thanh Bình, Tỉnh Đồng Tháp","path_with_type":"Thị trấn Thanh Bình, Huyện Thanh Bình, Tỉnh Đồng Tháp","code":"30130","parent_code":"874"},"30133":{"name":"Xã Tân Quới","type":"xa","slug":"xa-tan-quoi","name_with_type":"Xã Tân Quới","path":"Xã Tân Quới, Huyện Thanh Bình, Tỉnh Đồng Tháp","path_with_type":"Xã Tân Quới, Huyện Thanh Bình, Tỉnh Đồng Tháp","code":"30133","parent_code":"874"},"30136":{"name":"Xã Tân Hòa","type":"xa","slug":"xa-tan-hoa","name_with_type":"Xã Tân Hòa","path":"Xã Tân Hòa, Huyện Thanh Bình, Tỉnh Đồng Tháp","path_with_type":"Xã Tân Hòa, Huyện Thanh Bình, Tỉnh Đồng Tháp","code":"30136","parent_code":"874"},"30139":{"name":"Xã An Phong","type":"xa","slug":"xa-an-phong","name_with_type":"Xã An Phong","path":"Xã An Phong, Huyện Thanh Bình, Tỉnh Đồng Tháp","path_with_type":"Xã An Phong, Huyện Thanh Bình, Tỉnh Đồng Tháp","code":"30139","parent_code":"874"},"30142":{"name":"Xã Phú Lợi","type":"xa","slug":"xa-phu-loi","name_with_type":"Xã Phú Lợi","path":"Xã Phú Lợi, Huyện Thanh Bình, Tỉnh Đồng Tháp","path_with_type":"Xã Phú Lợi, Huyện Thanh Bình, Tỉnh Đồng Tháp","code":"30142","parent_code":"874"},"30145":{"name":"Xã Tân Mỹ","type":"xa","slug":"xa-tan-my","name_with_type":"Xã Tân Mỹ","path":"Xã Tân Mỹ, Huyện Thanh Bình, Tỉnh Đồng Tháp","path_with_type":"Xã Tân Mỹ, Huyện Thanh Bình, Tỉnh Đồng Tháp","code":"30145","parent_code":"874"},"30148":{"name":"Xã Bình Tấn","type":"xa","slug":"xa-binh-tan","name_with_type":"Xã Bình Tấn","path":"Xã Bình Tấn, Huyện Thanh Bình, Tỉnh Đồng Tháp","path_with_type":"Xã Bình Tấn, Huyện Thanh Bình, Tỉnh Đồng Tháp","code":"30148","parent_code":"874"},"30151":{"name":"Xã Tân Huề","type":"xa","slug":"xa-tan-hue","name_with_type":"Xã Tân Huề","path":"Xã Tân Huề, Huyện Thanh Bình, Tỉnh Đồng Tháp","path_with_type":"Xã Tân Huề, Huyện Thanh Bình, Tỉnh Đồng Tháp","code":"30151","parent_code":"874"},"30154":{"name":"Xã Tân Bình","type":"xa","slug":"xa-tan-binh","name_with_type":"Xã Tân Bình","path":"Xã Tân Bình, Huyện Thanh Bình, Tỉnh Đồng Tháp","path_with_type":"Xã Tân Bình, Huyện Thanh Bình, Tỉnh Đồng Tháp","code":"30154","parent_code":"874"},"30157":{"name":"Xã Tân Thạnh","type":"xa","slug":"xa-tan-thanh","name_with_type":"Xã Tân Thạnh","path":"Xã Tân Thạnh, Huyện Thanh Bình, Tỉnh Đồng Tháp","path_with_type":"Xã Tân Thạnh, Huyện Thanh Bình, Tỉnh Đồng Tháp","code":"30157","parent_code":"874"},"30160":{"name":"Xã Tân Phú","type":"xa","slug":"xa-tan-phu","name_with_type":"Xã Tân Phú","path":"Xã Tân Phú, Huyện Thanh Bình, Tỉnh Đồng Tháp","path_with_type":"Xã Tân Phú, Huyện Thanh Bình, Tỉnh Đồng Tháp","code":"30160","parent_code":"874"},"30163":{"name":"Xã Bình Thành","type":"xa","slug":"xa-binh-thanh","name_with_type":"Xã Bình Thành","path":"Xã Bình Thành, Huyện Thanh Bình, Tỉnh Đồng Tháp","path_with_type":"Xã Bình Thành, Huyện Thanh Bình, Tỉnh Đồng Tháp","code":"30163","parent_code":"874"},"30166":{"name":"Xã Tân Long","type":"xa","slug":"xa-tan-long","name_with_type":"Xã Tân Long","path":"Xã Tân Long, Huyện Thanh Bình, Tỉnh Đồng Tháp","path_with_type":"Xã Tân Long, Huyện Thanh Bình, Tỉnh Đồng Tháp","code":"30166","parent_code":"874"},"30169":{"name":"Thị trấn Lấp Vò","type":"thi-tran","slug":"thi-tran-lap-vo","name_with_type":"Thị trấn Lấp Vò","path":"Thị trấn Lấp Vò, Huyện Lấp Vò, Tỉnh Đồng Tháp","path_with_type":"Thị trấn Lấp Vò, Huyện Lấp Vò, Tỉnh Đồng Tháp","code":"30169","parent_code":"875"},"30172":{"name":"Xã Mỹ An Hưng A","type":"xa","slug":"xa-my-an-hung-a","name_with_type":"Xã Mỹ An Hưng A","path":"Xã Mỹ An Hưng A, Huyện Lấp Vò, Tỉnh Đồng Tháp","path_with_type":"Xã Mỹ An Hưng A, Huyện Lấp Vò, Tỉnh Đồng Tháp","code":"30172","parent_code":"875"},"30175":{"name":"Xã Tân Mỹ","type":"xa","slug":"xa-tan-my","name_with_type":"Xã Tân Mỹ","path":"Xã Tân Mỹ, Huyện Lấp Vò, Tỉnh Đồng Tháp","path_with_type":"Xã Tân Mỹ, Huyện Lấp Vò, Tỉnh Đồng Tháp","code":"30175","parent_code":"875"},"30178":{"name":"Xã Mỹ An Hưng B","type":"xa","slug":"xa-my-an-hung-b","name_with_type":"Xã Mỹ An Hưng B","path":"Xã Mỹ An Hưng B, Huyện Lấp Vò, Tỉnh Đồng Tháp","path_with_type":"Xã Mỹ An Hưng B, Huyện Lấp Vò, Tỉnh Đồng Tháp","code":"30178","parent_code":"875"},"30181":{"name":"Xã Tân  Khánh Trung","type":"xa","slug":"xa-tan-khanh-trung","name_with_type":"Xã Tân  Khánh Trung","path":"Xã Tân  Khánh Trung, Huyện Lấp Vò, Tỉnh Đồng Tháp","path_with_type":"Xã Tân  Khánh Trung, Huyện Lấp Vò, Tỉnh Đồng Tháp","code":"30181","parent_code":"875"},"30184":{"name":"Xã Long Hưng A","type":"xa","slug":"xa-long-hung-a","name_with_type":"Xã Long Hưng A","path":"Xã Long Hưng A, Huyện Lấp Vò, Tỉnh Đồng Tháp","path_with_type":"Xã Long Hưng A, Huyện Lấp Vò, Tỉnh Đồng Tháp","code":"30184","parent_code":"875"},"30187":{"name":"Xã Vĩnh Thạnh","type":"xa","slug":"xa-vinh-thanh","name_with_type":"Xã Vĩnh Thạnh","path":"Xã Vĩnh Thạnh, Huyện Lấp Vò, Tỉnh Đồng Tháp","path_with_type":"Xã Vĩnh Thạnh, Huyện Lấp Vò, Tỉnh Đồng Tháp","code":"30187","parent_code":"875"},"30190":{"name":"Xã Long Hưng B","type":"xa","slug":"xa-long-hung-b","name_with_type":"Xã Long Hưng B","path":"Xã Long Hưng B, Huyện Lấp Vò, Tỉnh Đồng Tháp","path_with_type":"Xã Long Hưng B, Huyện Lấp Vò, Tỉnh Đồng Tháp","code":"30190","parent_code":"875"},"30193":{"name":"Xã Bình Thành","type":"xa","slug":"xa-binh-thanh","name_with_type":"Xã Bình Thành","path":"Xã Bình Thành, Huyện Lấp Vò, Tỉnh Đồng Tháp","path_with_type":"Xã Bình Thành, Huyện Lấp Vò, Tỉnh Đồng Tháp","code":"30193","parent_code":"875"},"30196":{"name":"Xã Định An","type":"xa","slug":"xa-dinh-an","name_with_type":"Xã Định An","path":"Xã Định An, Huyện Lấp Vò, Tỉnh Đồng Tháp","path_with_type":"Xã Định An, Huyện Lấp Vò, Tỉnh Đồng Tháp","code":"30196","parent_code":"875"},"30199":{"name":"Xã Định Yên","type":"xa","slug":"xa-dinh-yen","name_with_type":"Xã Định Yên","path":"Xã Định Yên, Huyện Lấp Vò, Tỉnh Đồng Tháp","path_with_type":"Xã Định Yên, Huyện Lấp Vò, Tỉnh Đồng Tháp","code":"30199","parent_code":"875"},"30202":{"name":"Xã Hội An Đông","type":"xa","slug":"xa-hoi-an-dong","name_with_type":"Xã Hội An Đông","path":"Xã Hội An Đông, Huyện Lấp Vò, Tỉnh Đồng Tháp","path_with_type":"Xã Hội An Đông, Huyện Lấp Vò, Tỉnh Đồng Tháp","code":"30202","parent_code":"875"},"30205":{"name":"Xã Bình Thạnh Trung","type":"xa","slug":"xa-binh-thanh-trung","name_with_type":"Xã Bình Thạnh Trung","path":"Xã Bình Thạnh Trung, Huyện Lấp Vò, Tỉnh Đồng Tháp","path_with_type":"Xã Bình Thạnh Trung, Huyện Lấp Vò, Tỉnh Đồng Tháp","code":"30205","parent_code":"875"},"30208":{"name":"Thị trấn Lai Vung","type":"thi-tran","slug":"thi-tran-lai-vung","name_with_type":"Thị trấn Lai Vung","path":"Thị trấn Lai Vung, Huyện Lai Vung, Tỉnh Đồng Tháp","path_with_type":"Thị trấn Lai Vung, Huyện Lai Vung, Tỉnh Đồng Tháp","code":"30208","parent_code":"876"},"30211":{"name":"Xã Tân Dương","type":"xa","slug":"xa-tan-duong","name_with_type":"Xã Tân Dương","path":"Xã Tân Dương, Huyện Lai Vung, Tỉnh Đồng Tháp","path_with_type":"Xã Tân Dương, Huyện Lai Vung, Tỉnh Đồng Tháp","code":"30211","parent_code":"876"},"30214":{"name":"Xã Hòa Thành","type":"xa","slug":"xa-hoa-thanh","name_with_type":"Xã Hòa Thành","path":"Xã Hòa Thành, Huyện Lai Vung, Tỉnh Đồng Tháp","path_with_type":"Xã Hòa Thành, Huyện Lai Vung, Tỉnh Đồng Tháp","code":"30214","parent_code":"876"},"30217":{"name":"Xã Long Hậu","type":"xa","slug":"xa-long-hau","name_with_type":"Xã Long Hậu","path":"Xã Long Hậu, Huyện Lai Vung, Tỉnh Đồng Tháp","path_with_type":"Xã Long Hậu, Huyện Lai Vung, Tỉnh Đồng Tháp","code":"30217","parent_code":"876"},"30220":{"name":"Xã Tân Phước","type":"xa","slug":"xa-tan-phuoc","name_with_type":"Xã Tân Phước","path":"Xã Tân Phước, Huyện Lai Vung, Tỉnh Đồng Tháp","path_with_type":"Xã Tân Phước, Huyện Lai Vung, Tỉnh Đồng Tháp","code":"30220","parent_code":"876"},"30223":{"name":"Xã Hòa Long","type":"xa","slug":"xa-hoa-long","name_with_type":"Xã Hòa Long","path":"Xã Hòa Long, Huyện Lai Vung, Tỉnh Đồng Tháp","path_with_type":"Xã Hòa Long, Huyện Lai Vung, Tỉnh Đồng Tháp","code":"30223","parent_code":"876"},"30226":{"name":"Xã Tân Thành","type":"xa","slug":"xa-tan-thanh","name_with_type":"Xã Tân Thành","path":"Xã Tân Thành, Huyện Lai Vung, Tỉnh Đồng Tháp","path_with_type":"Xã Tân Thành, Huyện Lai Vung, Tỉnh Đồng Tháp","code":"30226","parent_code":"876"},"30229":{"name":"Xã Long Thắng","type":"xa","slug":"xa-long-thang","name_with_type":"Xã Long Thắng","path":"Xã Long Thắng, Huyện Lai Vung, Tỉnh Đồng Tháp","path_with_type":"Xã Long Thắng, Huyện Lai Vung, Tỉnh Đồng Tháp","code":"30229","parent_code":"876"},"30232":{"name":"Xã Vĩnh Thới","type":"xa","slug":"xa-vinh-thoi","name_with_type":"Xã Vĩnh Thới","path":"Xã Vĩnh Thới, Huyện Lai Vung, Tỉnh Đồng Tháp","path_with_type":"Xã Vĩnh Thới, Huyện Lai Vung, Tỉnh Đồng Tháp","code":"30232","parent_code":"876"},"30235":{"name":"Xã Tân Hòa","type":"xa","slug":"xa-tan-hoa","name_with_type":"Xã Tân Hòa","path":"Xã Tân Hòa, Huyện Lai Vung, Tỉnh Đồng Tháp","path_with_type":"Xã Tân Hòa, Huyện Lai Vung, Tỉnh Đồng Tháp","code":"30235","parent_code":"876"},"30238":{"name":"Xã Định Hòa","type":"xa","slug":"xa-dinh-hoa","name_with_type":"Xã Định Hòa","path":"Xã Định Hòa, Huyện Lai Vung, Tỉnh Đồng Tháp","path_with_type":"Xã Định Hòa, Huyện Lai Vung, Tỉnh Đồng Tháp","code":"30238","parent_code":"876"},"30241":{"name":"Xã Phong Hòa","type":"xa","slug":"xa-phong-hoa","name_with_type":"Xã Phong Hòa","path":"Xã Phong Hòa, Huyện Lai Vung, Tỉnh Đồng Tháp","path_with_type":"Xã Phong Hòa, Huyện Lai Vung, Tỉnh Đồng Tháp","code":"30241","parent_code":"876"},"30244":{"name":"Thị trấn Cái Tàu Hạ","type":"thi-tran","slug":"thi-tran-cai-tau-ha","name_with_type":"Thị trấn Cái Tàu Hạ","path":"Thị trấn Cái Tàu Hạ, Huyện Châu Thành, Tỉnh Đồng Tháp","path_with_type":"Thị trấn Cái Tàu Hạ, Huyện Châu Thành, Tỉnh Đồng Tháp","code":"30244","parent_code":"877"},"30247":{"name":"Xã An Hiệp","type":"xa","slug":"xa-an-hiep","name_with_type":"Xã An Hiệp","path":"Xã An Hiệp, Huyện Châu Thành, Tỉnh Đồng Tháp","path_with_type":"Xã An Hiệp, Huyện Châu Thành, Tỉnh Đồng Tháp","code":"30247","parent_code":"877"},"30250":{"name":"Xã An Nhơn","type":"xa","slug":"xa-an-nhon","name_with_type":"Xã An Nhơn","path":"Xã An Nhơn, Huyện Châu Thành, Tỉnh Đồng Tháp","path_with_type":"Xã An Nhơn, Huyện Châu Thành, Tỉnh Đồng Tháp","code":"30250","parent_code":"877"},"30253":{"name":"Xã Tân Nhuận Đông","type":"xa","slug":"xa-tan-nhuan-dong","name_with_type":"Xã Tân Nhuận Đông","path":"Xã Tân Nhuận Đông, Huyện Châu Thành, Tỉnh Đồng Tháp","path_with_type":"Xã Tân Nhuận Đông, Huyện Châu Thành, Tỉnh Đồng Tháp","code":"30253","parent_code":"877"},"30256":{"name":"Xã Tân Bình","type":"xa","slug":"xa-tan-binh","name_with_type":"Xã Tân Bình","path":"Xã Tân Bình, Huyện Châu Thành, Tỉnh Đồng Tháp","path_with_type":"Xã Tân Bình, Huyện Châu Thành, Tỉnh Đồng Tháp","code":"30256","parent_code":"877"},"30259":{"name":"Xã Tân Phú Trung","type":"xa","slug":"xa-tan-phu-trung","name_with_type":"Xã Tân Phú Trung","path":"Xã Tân Phú Trung, Huyện Châu Thành, Tỉnh Đồng Tháp","path_with_type":"Xã Tân Phú Trung, Huyện Châu Thành, Tỉnh Đồng Tháp","code":"30259","parent_code":"877"},"30262":{"name":"Xã Phú Long","type":"xa","slug":"xa-phu-long","name_with_type":"Xã Phú Long","path":"Xã Phú Long, Huyện Châu Thành, Tỉnh Đồng Tháp","path_with_type":"Xã Phú Long, Huyện Châu Thành, Tỉnh Đồng Tháp","code":"30262","parent_code":"877"},"30265":{"name":"Xã An Phú Thuận","type":"xa","slug":"xa-an-phu-thuan","name_with_type":"Xã An Phú Thuận","path":"Xã An Phú Thuận, Huyện Châu Thành, Tỉnh Đồng Tháp","path_with_type":"Xã An Phú Thuận, Huyện Châu Thành, Tỉnh Đồng Tháp","code":"30265","parent_code":"877"},"30268":{"name":"Xã Phú Hựu","type":"xa","slug":"xa-phu-huu","name_with_type":"Xã Phú Hựu","path":"Xã Phú Hựu, Huyện Châu Thành, Tỉnh Đồng Tháp","path_with_type":"Xã Phú Hựu, Huyện Châu Thành, Tỉnh Đồng Tháp","code":"30268","parent_code":"877"},"30271":{"name":"Xã An Khánh","type":"xa","slug":"xa-an-khanh","name_with_type":"Xã An Khánh","path":"Xã An Khánh, Huyện Châu Thành, Tỉnh Đồng Tháp","path_with_type":"Xã An Khánh, Huyện Châu Thành, Tỉnh Đồng Tháp","code":"30271","parent_code":"877"},"30274":{"name":"Xã Tân Phú","type":"xa","slug":"xa-tan-phu","name_with_type":"Xã Tân Phú","path":"Xã Tân Phú, Huyện Châu Thành, Tỉnh Đồng Tháp","path_with_type":"Xã Tân Phú, Huyện Châu Thành, Tỉnh Đồng Tháp","code":"30274","parent_code":"877"},"30277":{"name":"Xã Hòa Tân","type":"xa","slug":"xa-hoa-tan","name_with_type":"Xã Hòa Tân","path":"Xã Hòa Tân, Huyện Châu Thành, Tỉnh Đồng Tháp","path_with_type":"Xã Hòa Tân, Huyện Châu Thành, Tỉnh Đồng Tháp","code":"30277","parent_code":"877"},"30280":{"name":"Phường Mỹ Bình","type":"phuong","slug":"phuong-my-binh","name_with_type":"Phường Mỹ Bình","path":"Phường Mỹ Bình, Thành phố Long Xuyên, Tỉnh An Giang","path_with_type":"Phường Mỹ Bình, Thành phố Long Xuyên, Tỉnh An Giang","code":"30280","parent_code":"883"},"30283":{"name":"Phường Mỹ Long","type":"phuong","slug":"phuong-my-long","name_with_type":"Phường Mỹ Long","path":"Phường Mỹ Long, Thành phố Long Xuyên, Tỉnh An Giang","path_with_type":"Phường Mỹ Long, Thành phố Long Xuyên, Tỉnh An Giang","code":"30283","parent_code":"883"},"30286":{"name":"Phường Mỹ Xuyên","type":"phuong","slug":"phuong-my-xuyen","name_with_type":"Phường Mỹ Xuyên","path":"Phường Mỹ Xuyên, Thành phố Long Xuyên, Tỉnh An Giang","path_with_type":"Phường Mỹ Xuyên, Thành phố Long Xuyên, Tỉnh An Giang","code":"30286","parent_code":"883"},"30289":{"name":"Phường Bình Đức","type":"phuong","slug":"phuong-binh-duc","name_with_type":"Phường Bình Đức","path":"Phường Bình Đức, Thành phố Long Xuyên, Tỉnh An Giang","path_with_type":"Phường Bình Đức, Thành phố Long Xuyên, Tỉnh An Giang","code":"30289","parent_code":"883"},"30292":{"name":"Phường Bình Khánh","type":"phuong","slug":"phuong-binh-khanh","name_with_type":"Phường Bình Khánh","path":"Phường Bình Khánh, Thành phố Long Xuyên, Tỉnh An Giang","path_with_type":"Phường Bình Khánh, Thành phố Long Xuyên, Tỉnh An Giang","code":"30292","parent_code":"883"},"30295":{"name":"Phường Mỹ Phước","type":"phuong","slug":"phuong-my-phuoc","name_with_type":"Phường Mỹ Phước","path":"Phường Mỹ Phước, Thành phố Long Xuyên, Tỉnh An Giang","path_with_type":"Phường Mỹ Phước, Thành phố Long Xuyên, Tỉnh An Giang","code":"30295","parent_code":"883"},"30298":{"name":"Phường Mỹ Quý","type":"phuong","slug":"phuong-my-quy","name_with_type":"Phường Mỹ Quý","path":"Phường Mỹ Quý, Thành phố Long Xuyên, Tỉnh An Giang","path_with_type":"Phường Mỹ Quý, Thành phố Long Xuyên, Tỉnh An Giang","code":"30298","parent_code":"883"},"30301":{"name":"Phường Mỹ Thới","type":"phuong","slug":"phuong-my-thoi","name_with_type":"Phường Mỹ Thới","path":"Phường Mỹ Thới, Thành phố Long Xuyên, Tỉnh An Giang","path_with_type":"Phường Mỹ Thới, Thành phố Long Xuyên, Tỉnh An Giang","code":"30301","parent_code":"883"},"30304":{"name":"Phường Mỹ Thạnh","type":"phuong","slug":"phuong-my-thanh","name_with_type":"Phường Mỹ Thạnh","path":"Phường Mỹ Thạnh, Thành phố Long Xuyên, Tỉnh An Giang","path_with_type":"Phường Mỹ Thạnh, Thành phố Long Xuyên, Tỉnh An Giang","code":"30304","parent_code":"883"},"30307":{"name":"Phường Mỹ Hòa","type":"phuong","slug":"phuong-my-hoa","name_with_type":"Phường Mỹ Hòa","path":"Phường Mỹ Hòa, Thành phố Long Xuyên, Tỉnh An Giang","path_with_type":"Phường Mỹ Hòa, Thành phố Long Xuyên, Tỉnh An Giang","code":"30307","parent_code":"883"},"30310":{"name":"Xã Mỹ Khánh","type":"xa","slug":"xa-my-khanh","name_with_type":"Xã Mỹ Khánh","path":"Xã Mỹ Khánh, Thành phố Long Xuyên, Tỉnh An Giang","path_with_type":"Xã Mỹ Khánh, Thành phố Long Xuyên, Tỉnh An Giang","code":"30310","parent_code":"883"},"30313":{"name":"Xã Mỹ Hoà Hưng","type":"xa","slug":"xa-my-hoa-hung","name_with_type":"Xã Mỹ Hoà Hưng","path":"Xã Mỹ Hoà Hưng, Thành phố Long Xuyên, Tỉnh An Giang","path_with_type":"Xã Mỹ Hoà Hưng, Thành phố Long Xuyên, Tỉnh An Giang","code":"30313","parent_code":"883"},"30316":{"name":"Phường Châu Phú B","type":"phuong","slug":"phuong-chau-phu-b","name_with_type":"Phường Châu Phú B","path":"Phường Châu Phú B, Thành phố Châu Đốc, Tỉnh An Giang","path_with_type":"Phường Châu Phú B, Thành phố Châu Đốc, Tỉnh An Giang","code":"30316","parent_code":"884"},"30319":{"name":"Phường Châu Phú A","type":"phuong","slug":"phuong-chau-phu-a","name_with_type":"Phường Châu Phú A","path":"Phường Châu Phú A, Thành phố Châu Đốc, Tỉnh An Giang","path_with_type":"Phường Châu Phú A, Thành phố Châu Đốc, Tỉnh An Giang","code":"30319","parent_code":"884"},"30322":{"name":"Phường Vĩnh Mỹ","type":"phuong","slug":"phuong-vinh-my","name_with_type":"Phường Vĩnh Mỹ","path":"Phường Vĩnh Mỹ, Thành phố Châu Đốc, Tỉnh An Giang","path_with_type":"Phường Vĩnh Mỹ, Thành phố Châu Đốc, Tỉnh An Giang","code":"30322","parent_code":"884"},"30325":{"name":"Phường Núi Sam","type":"phuong","slug":"phuong-nui-sam","name_with_type":"Phường Núi Sam","path":"Phường Núi Sam, Thành phố Châu Đốc, Tỉnh An Giang","path_with_type":"Phường Núi Sam, Thành phố Châu Đốc, Tỉnh An Giang","code":"30325","parent_code":"884"},"30328":{"name":"Phường Vĩnh Ngươn","type":"phuong","slug":"phuong-vinh-nguon","name_with_type":"Phường Vĩnh Ngươn","path":"Phường Vĩnh Ngươn, Thành phố Châu Đốc, Tỉnh An Giang","path_with_type":"Phường Vĩnh Ngươn, Thành phố Châu Đốc, Tỉnh An Giang","code":"30328","parent_code":"884"},"30331":{"name":"Xã Vĩnh Tế","type":"xa","slug":"xa-vinh-te","name_with_type":"Xã Vĩnh Tế","path":"Xã Vĩnh Tế, Thành phố Châu Đốc, Tỉnh An Giang","path_with_type":"Xã Vĩnh Tế, Thành phố Châu Đốc, Tỉnh An Giang","code":"30331","parent_code":"884"},"30334":{"name":"Xã Vĩnh Châu","type":"xa","slug":"xa-vinh-chau","name_with_type":"Xã Vĩnh Châu","path":"Xã Vĩnh Châu, Thành phố Châu Đốc, Tỉnh An Giang","path_with_type":"Xã Vĩnh Châu, Thành phố Châu Đốc, Tỉnh An Giang","code":"30334","parent_code":"884"},"30337":{"name":"Thị trấn An Phú","type":"thi-tran","slug":"thi-tran-an-phu","name_with_type":"Thị trấn An Phú","path":"Thị trấn An Phú, Huyện An Phú, Tỉnh An Giang","path_with_type":"Thị trấn An Phú, Huyện An Phú, Tỉnh An Giang","code":"30337","parent_code":"886"},"30340":{"name":"Xã Khánh An","type":"xa","slug":"xa-khanh-an","name_with_type":"Xã Khánh An","path":"Xã Khánh An, Huyện An Phú, Tỉnh An Giang","path_with_type":"Xã Khánh An, Huyện An Phú, Tỉnh An Giang","code":"30340","parent_code":"886"},"30341":{"name":"Thị Trấn Long Bình","type":"thi-tran","slug":"thi-tran-long-binh","name_with_type":"Thị Trấn Long Bình","path":"Thị Trấn Long Bình, Huyện An Phú, Tỉnh An Giang","path_with_type":"Thị Trấn Long Bình, Huyện An Phú, Tỉnh An Giang","code":"30341","parent_code":"886"},"30343":{"name":"Xã Khánh Bình","type":"xa","slug":"xa-khanh-binh","name_with_type":"Xã Khánh Bình","path":"Xã Khánh Bình, Huyện An Phú, Tỉnh An Giang","path_with_type":"Xã Khánh Bình, Huyện An Phú, Tỉnh An Giang","code":"30343","parent_code":"886"},"30346":{"name":"Xã Quốc Thái","type":"xa","slug":"xa-quoc-thai","name_with_type":"Xã Quốc Thái","path":"Xã Quốc Thái, Huyện An Phú, Tỉnh An Giang","path_with_type":"Xã Quốc Thái, Huyện An Phú, Tỉnh An Giang","code":"30346","parent_code":"886"},"30349":{"name":"Xã Nhơn Hội","type":"xa","slug":"xa-nhon-hoi","name_with_type":"Xã Nhơn Hội","path":"Xã Nhơn Hội, Huyện An Phú, Tỉnh An Giang","path_with_type":"Xã Nhơn Hội, Huyện An Phú, Tỉnh An Giang","code":"30349","parent_code":"886"},"30352":{"name":"Xã Phú Hữu","type":"xa","slug":"xa-phu-huu","name_with_type":"Xã Phú Hữu","path":"Xã Phú Hữu, Huyện An Phú, Tỉnh An Giang","path_with_type":"Xã Phú Hữu, Huyện An Phú, Tỉnh An Giang","code":"30352","parent_code":"886"},"30355":{"name":"Xã Phú Hội","type":"xa","slug":"xa-phu-hoi","name_with_type":"Xã Phú Hội","path":"Xã Phú Hội, Huyện An Phú, Tỉnh An Giang","path_with_type":"Xã Phú Hội, Huyện An Phú, Tỉnh An Giang","code":"30355","parent_code":"886"},"30358":{"name":"Xã Phước Hưng","type":"xa","slug":"xa-phuoc-hung","name_with_type":"Xã Phước Hưng","path":"Xã Phước Hưng, Huyện An Phú, Tỉnh An Giang","path_with_type":"Xã Phước Hưng, Huyện An Phú, Tỉnh An Giang","code":"30358","parent_code":"886"},"30361":{"name":"Xã Vĩnh Lộc","type":"xa","slug":"xa-vinh-loc","name_with_type":"Xã Vĩnh Lộc","path":"Xã Vĩnh Lộc, Huyện An Phú, Tỉnh An Giang","path_with_type":"Xã Vĩnh Lộc, Huyện An Phú, Tỉnh An Giang","code":"30361","parent_code":"886"},"30364":{"name":"Xã Vĩnh Hậu","type":"xa","slug":"xa-vinh-hau","name_with_type":"Xã Vĩnh Hậu","path":"Xã Vĩnh Hậu, Huyện An Phú, Tỉnh An Giang","path_with_type":"Xã Vĩnh Hậu, Huyện An Phú, Tỉnh An Giang","code":"30364","parent_code":"886"},"30367":{"name":"Xã Vĩnh Trường","type":"xa","slug":"xa-vinh-truong","name_with_type":"Xã Vĩnh Trường","path":"Xã Vĩnh Trường, Huyện An Phú, Tỉnh An Giang","path_with_type":"Xã Vĩnh Trường, Huyện An Phú, Tỉnh An Giang","code":"30367","parent_code":"886"},"30370":{"name":"Xã Vĩnh Hội Đông","type":"xa","slug":"xa-vinh-hoi-dong","name_with_type":"Xã Vĩnh Hội Đông","path":"Xã Vĩnh Hội Đông, Huyện An Phú, Tỉnh An Giang","path_with_type":"Xã Vĩnh Hội Đông, Huyện An Phú, Tỉnh An Giang","code":"30370","parent_code":"886"},"30373":{"name":"Thị trấn Đa Phước","type":"thi-tran","slug":"thi-tran-da-phuoc","name_with_type":"Thị trấn Đa Phước","path":"Thị trấn Đa Phước, Huyện An Phú, Tỉnh An Giang","path_with_type":"Thị trấn Đa Phước, Huyện An Phú, Tỉnh An Giang","code":"30373","parent_code":"886"},"30376":{"name":"Phường Long Thạnh","type":"phuong","slug":"phuong-long-thanh","name_with_type":"Phường Long Thạnh","path":"Phường Long Thạnh, Thị xã Tân Châu, Tỉnh An Giang","path_with_type":"Phường Long Thạnh, Thị xã Tân Châu, Tỉnh An Giang","code":"30376","parent_code":"887"},"30377":{"name":"Phường Long Hưng","type":"phuong","slug":"phuong-long-hung","name_with_type":"Phường Long Hưng","path":"Phường Long Hưng, Thị xã Tân Châu, Tỉnh An Giang","path_with_type":"Phường Long Hưng, Thị xã Tân Châu, Tỉnh An Giang","code":"30377","parent_code":"887"},"30378":{"name":"Phường Long Châu","type":"phuong","slug":"phuong-long-chau","name_with_type":"Phường Long Châu","path":"Phường Long Châu, Thị xã Tân Châu, Tỉnh An Giang","path_with_type":"Phường Long Châu, Thị xã Tân Châu, Tỉnh An Giang","code":"30378","parent_code":"887"},"30379":{"name":"Xã Phú Lộc","type":"xa","slug":"xa-phu-loc","name_with_type":"Xã Phú Lộc","path":"Xã Phú Lộc, Thị xã Tân Châu, Tỉnh An Giang","path_with_type":"Xã Phú Lộc, Thị xã Tân Châu, Tỉnh An Giang","code":"30379","parent_code":"887"},"30382":{"name":"Xã Vĩnh Xương","type":"xa","slug":"xa-vinh-xuong","name_with_type":"Xã Vĩnh Xương","path":"Xã Vĩnh Xương, Thị xã Tân Châu, Tỉnh An Giang","path_with_type":"Xã Vĩnh Xương, Thị xã Tân Châu, Tỉnh An Giang","code":"30382","parent_code":"887"},"30385":{"name":"Xã Vĩnh Hòa","type":"xa","slug":"xa-vinh-hoa","name_with_type":"Xã Vĩnh Hòa","path":"Xã Vĩnh Hòa, Thị xã Tân Châu, Tỉnh An Giang","path_with_type":"Xã Vĩnh Hòa, Thị xã Tân Châu, Tỉnh An Giang","code":"30385","parent_code":"887"},"30387":{"name":"Xã Tân Thạnh","type":"xa","slug":"xa-tan-thanh","name_with_type":"Xã Tân Thạnh","path":"Xã Tân Thạnh, Thị xã Tân Châu, Tỉnh An Giang","path_with_type":"Xã Tân Thạnh, Thị xã Tân Châu, Tỉnh An Giang","code":"30387","parent_code":"887"},"30388":{"name":"Xã Tân An","type":"xa","slug":"xa-tan-an","name_with_type":"Xã Tân An","path":"Xã Tân An, Thị xã Tân Châu, Tỉnh An Giang","path_with_type":"Xã Tân An, Thị xã Tân Châu, Tỉnh An Giang","code":"30388","parent_code":"887"},"30391":{"name":"Xã Long An","type":"xa","slug":"xa-long-an","name_with_type":"Xã Long An","path":"Xã Long An, Thị xã Tân Châu, Tỉnh An Giang","path_with_type":"Xã Long An, Thị xã Tân Châu, Tỉnh An Giang","code":"30391","parent_code":"887"},"30394":{"name":"Phường Long Phú","type":"phuong","slug":"phuong-long-phu","name_with_type":"Phường Long Phú","path":"Phường Long Phú, Thị xã Tân Châu, Tỉnh An Giang","path_with_type":"Phường Long Phú, Thị xã Tân Châu, Tỉnh An Giang","code":"30394","parent_code":"887"},"30397":{"name":"Xã Châu Phong","type":"xa","slug":"xa-chau-phong","name_with_type":"Xã Châu Phong","path":"Xã Châu Phong, Thị xã Tân Châu, Tỉnh An Giang","path_with_type":"Xã Châu Phong, Thị xã Tân Châu, Tỉnh An Giang","code":"30397","parent_code":"887"},"30400":{"name":"Xã Phú Vĩnh","type":"xa","slug":"xa-phu-vinh","name_with_type":"Xã Phú Vĩnh","path":"Xã Phú Vĩnh, Thị xã Tân Châu, Tỉnh An Giang","path_with_type":"Xã Phú Vĩnh, Thị xã Tân Châu, Tỉnh An Giang","code":"30400","parent_code":"887"},"30403":{"name":"Xã Lê Chánh","type":"xa","slug":"xa-le-chanh","name_with_type":"Xã Lê Chánh","path":"Xã Lê Chánh, Thị xã Tân Châu, Tỉnh An Giang","path_with_type":"Xã Lê Chánh, Thị xã Tân Châu, Tỉnh An Giang","code":"30403","parent_code":"887"},"30406":{"name":"Thị trấn Phú Mỹ","type":"thi-tran","slug":"thi-tran-phu-my","name_with_type":"Thị trấn Phú Mỹ","path":"Thị trấn Phú Mỹ, Huyện Phú Tân, Tỉnh An Giang","path_with_type":"Thị trấn Phú Mỹ, Huyện Phú Tân, Tỉnh An Giang","code":"30406","parent_code":"888"},"30409":{"name":"Thị trấn Chợ Vàm","type":"thi-tran","slug":"thi-tran-cho-vam","name_with_type":"Thị trấn Chợ Vàm","path":"Thị trấn Chợ Vàm, Huyện Phú Tân, Tỉnh An Giang","path_with_type":"Thị trấn Chợ Vàm, Huyện Phú Tân, Tỉnh An Giang","code":"30409","parent_code":"888"},"30412":{"name":"Phường Long Sơn","type":"phuong","slug":"phuong-long-son","name_with_type":"Phường Long Sơn","path":"Phường Long Sơn, Thị xã Tân Châu, Tỉnh An Giang","path_with_type":"Phường Long Sơn, Thị xã Tân Châu, Tỉnh An Giang","code":"30412","parent_code":"887"},"30415":{"name":"Xã Long Hoà","type":"xa","slug":"xa-long-hoa","name_with_type":"Xã Long Hoà","path":"Xã Long Hoà, Huyện Phú Tân, Tỉnh An Giang","path_with_type":"Xã Long Hoà, Huyện Phú Tân, Tỉnh An Giang","code":"30415","parent_code":"888"},"30418":{"name":"Xã Phú Long","type":"xa","slug":"xa-phu-long","name_with_type":"Xã Phú Long","path":"Xã Phú Long, Huyện Phú Tân, Tỉnh An Giang","path_with_type":"Xã Phú Long, Huyện Phú Tân, Tỉnh An Giang","code":"30418","parent_code":"888"},"30421":{"name":"Xã Phú Lâm","type":"xa","slug":"xa-phu-lam","name_with_type":"Xã Phú Lâm","path":"Xã Phú Lâm, Huyện Phú Tân, Tỉnh An Giang","path_with_type":"Xã Phú Lâm, Huyện Phú Tân, Tỉnh An Giang","code":"30421","parent_code":"888"},"30424":{"name":"Xã Phú Hiệp","type":"xa","slug":"xa-phu-hiep","name_with_type":"Xã Phú Hiệp","path":"Xã Phú Hiệp, Huyện Phú Tân, Tỉnh An Giang","path_with_type":"Xã Phú Hiệp, Huyện Phú Tân, Tỉnh An Giang","code":"30424","parent_code":"888"},"30427":{"name":"Xã Phú Thạnh","type":"xa","slug":"xa-phu-thanh","name_with_type":"Xã Phú Thạnh","path":"Xã Phú Thạnh, Huyện Phú Tân, Tỉnh An Giang","path_with_type":"Xã Phú Thạnh, Huyện Phú Tân, Tỉnh An Giang","code":"30427","parent_code":"888"},"30430":{"name":"Xã Hoà Lạc","type":"xa","slug":"xa-hoa-lac","name_with_type":"Xã Hoà Lạc","path":"Xã Hoà Lạc, Huyện Phú Tân, Tỉnh An Giang","path_with_type":"Xã Hoà Lạc, Huyện Phú Tân, Tỉnh An Giang","code":"30430","parent_code":"888"},"30433":{"name":"Xã Phú Thành","type":"xa","slug":"xa-phu-thanh","name_with_type":"Xã Phú Thành","path":"Xã Phú Thành, Huyện Phú Tân, Tỉnh An Giang","path_with_type":"Xã Phú Thành, Huyện Phú Tân, Tỉnh An Giang","code":"30433","parent_code":"888"},"30436":{"name":"Xã Phú An","type":"xa","slug":"xa-phu-an","name_with_type":"Xã Phú An","path":"Xã Phú An, Huyện Phú Tân, Tỉnh An Giang","path_with_type":"Xã Phú An, Huyện Phú Tân, Tỉnh An Giang","code":"30436","parent_code":"888"},"30439":{"name":"Xã Phú Xuân","type":"xa","slug":"xa-phu-xuan","name_with_type":"Xã Phú Xuân","path":"Xã Phú Xuân, Huyện Phú Tân, Tỉnh An Giang","path_with_type":"Xã Phú Xuân, Huyện Phú Tân, Tỉnh An Giang","code":"30439","parent_code":"888"},"30442":{"name":"Xã Hiệp Xương","type":"xa","slug":"xa-hiep-xuong","name_with_type":"Xã Hiệp Xương","path":"Xã Hiệp Xương, Huyện Phú Tân, Tỉnh An Giang","path_with_type":"Xã Hiệp Xương, Huyện Phú Tân, Tỉnh An Giang","code":"30442","parent_code":"888"},"30445":{"name":"Xã Phú Bình","type":"xa","slug":"xa-phu-binh","name_with_type":"Xã Phú Bình","path":"Xã Phú Bình, Huyện Phú Tân, Tỉnh An Giang","path_with_type":"Xã Phú Bình, Huyện Phú Tân, Tỉnh An Giang","code":"30445","parent_code":"888"},"30448":{"name":"Xã Phú Thọ","type":"xa","slug":"xa-phu-tho","name_with_type":"Xã Phú Thọ","path":"Xã Phú Thọ, Huyện Phú Tân, Tỉnh An Giang","path_with_type":"Xã Phú Thọ, Huyện Phú Tân, Tỉnh An Giang","code":"30448","parent_code":"888"},"30451":{"name":"Xã Phú Hưng","type":"xa","slug":"xa-phu-hung","name_with_type":"Xã Phú Hưng","path":"Xã Phú Hưng, Huyện Phú Tân, Tỉnh An Giang","path_with_type":"Xã Phú Hưng, Huyện Phú Tân, Tỉnh An Giang","code":"30451","parent_code":"888"},"30454":{"name":"Xã Bình Thạnh Đông","type":"xa","slug":"xa-binh-thanh-dong","name_with_type":"Xã Bình Thạnh Đông","path":"Xã Bình Thạnh Đông, Huyện Phú Tân, Tỉnh An Giang","path_with_type":"Xã Bình Thạnh Đông, Huyện Phú Tân, Tỉnh An Giang","code":"30454","parent_code":"888"},"30457":{"name":"Xã Tân Hòa","type":"xa","slug":"xa-tan-hoa","name_with_type":"Xã Tân Hòa","path":"Xã Tân Hòa, Huyện Phú Tân, Tỉnh An Giang","path_with_type":"Xã Tân Hòa, Huyện Phú Tân, Tỉnh An Giang","code":"30457","parent_code":"888"},"30460":{"name":"Xã Tân Trung","type":"xa","slug":"xa-tan-trung","name_with_type":"Xã Tân Trung","path":"Xã Tân Trung, Huyện Phú Tân, Tỉnh An Giang","path_with_type":"Xã Tân Trung, Huyện Phú Tân, Tỉnh An Giang","code":"30460","parent_code":"888"},"30463":{"name":"Thị trấn Cái Dầu","type":"thi-tran","slug":"thi-tran-cai-dau","name_with_type":"Thị trấn Cái Dầu","path":"Thị trấn Cái Dầu, Huyện Châu Phú, Tỉnh An Giang","path_with_type":"Thị trấn Cái Dầu, Huyện Châu Phú, Tỉnh An Giang","code":"30463","parent_code":"889"},"30466":{"name":"Xã Khánh Hòa","type":"xa","slug":"xa-khanh-hoa","name_with_type":"Xã Khánh Hòa","path":"Xã Khánh Hòa, Huyện Châu Phú, Tỉnh An Giang","path_with_type":"Xã Khánh Hòa, Huyện Châu Phú, Tỉnh An Giang","code":"30466","parent_code":"889"},"30469":{"name":"Xã Mỹ Đức","type":"xa","slug":"xa-my-duc","name_with_type":"Xã Mỹ Đức","path":"Xã Mỹ Đức, Huyện Châu Phú, Tỉnh An Giang","path_with_type":"Xã Mỹ Đức, Huyện Châu Phú, Tỉnh An Giang","code":"30469","parent_code":"889"},"30472":{"name":"Xã Mỹ Phú","type":"xa","slug":"xa-my-phu","name_with_type":"Xã Mỹ Phú","path":"Xã Mỹ Phú, Huyện Châu Phú, Tỉnh An Giang","path_with_type":"Xã Mỹ Phú, Huyện Châu Phú, Tỉnh An Giang","code":"30472","parent_code":"889"},"30475":{"name":"Xã Ô Long Vỹ","type":"xa","slug":"xa-o-long-vy","name_with_type":"Xã Ô Long Vỹ","path":"Xã Ô Long Vỹ, Huyện Châu Phú, Tỉnh An Giang","path_with_type":"Xã Ô Long Vỹ, Huyện Châu Phú, Tỉnh An Giang","code":"30475","parent_code":"889"},"30478":{"name":"Thị trấn Vĩnh Thạnh Trung","type":"thi-tran","slug":"thi-tran-vinh-thanh-trung","name_with_type":"Thị trấn Vĩnh Thạnh Trung","path":"Thị trấn Vĩnh Thạnh Trung, Huyện Châu Phú, Tỉnh An Giang","path_with_type":"Thị trấn Vĩnh Thạnh Trung, Huyện Châu Phú, Tỉnh An Giang","code":"30478","parent_code":"889"},"30481":{"name":"Xã Thạnh Mỹ Tây","type":"xa","slug":"xa-thanh-my-tay","name_with_type":"Xã Thạnh Mỹ Tây","path":"Xã Thạnh Mỹ Tây, Huyện Châu Phú, Tỉnh An Giang","path_with_type":"Xã Thạnh Mỹ Tây, Huyện Châu Phú, Tỉnh An Giang","code":"30481","parent_code":"889"},"30484":{"name":"Xã Bình Long","type":"xa","slug":"xa-binh-long","name_with_type":"Xã Bình Long","path":"Xã Bình Long, Huyện Châu Phú, Tỉnh An Giang","path_with_type":"Xã Bình Long, Huyện Châu Phú, Tỉnh An Giang","code":"30484","parent_code":"889"},"30487":{"name":"Xã Bình Mỹ","type":"xa","slug":"xa-binh-my","name_with_type":"Xã Bình Mỹ","path":"Xã Bình Mỹ, Huyện Châu Phú, Tỉnh An Giang","path_with_type":"Xã Bình Mỹ, Huyện Châu Phú, Tỉnh An Giang","code":"30487","parent_code":"889"},"30490":{"name":"Xã Bình Thủy","type":"xa","slug":"xa-binh-thuy","name_with_type":"Xã Bình Thủy","path":"Xã Bình Thủy, Huyện Châu Phú, Tỉnh An Giang","path_with_type":"Xã Bình Thủy, Huyện Châu Phú, Tỉnh An Giang","code":"30490","parent_code":"889"},"30493":{"name":"Xã Đào Hữu Cảnh","type":"xa","slug":"xa-dao-huu-canh","name_with_type":"Xã Đào Hữu Cảnh","path":"Xã Đào Hữu Cảnh, Huyện Châu Phú, Tỉnh An Giang","path_with_type":"Xã Đào Hữu Cảnh, Huyện Châu Phú, Tỉnh An Giang","code":"30493","parent_code":"889"},"30496":{"name":"Xã Bình Phú","type":"xa","slug":"xa-binh-phu","name_with_type":"Xã Bình Phú","path":"Xã Bình Phú, Huyện Châu Phú, Tỉnh An Giang","path_with_type":"Xã Bình Phú, Huyện Châu Phú, Tỉnh An Giang","code":"30496","parent_code":"889"},"30499":{"name":"Xã Bình Chánh","type":"xa","slug":"xa-binh-chanh","name_with_type":"Xã Bình Chánh","path":"Xã Bình Chánh, Huyện Châu Phú, Tỉnh An Giang","path_with_type":"Xã Bình Chánh, Huyện Châu Phú, Tỉnh An Giang","code":"30499","parent_code":"889"},"30502":{"name":"Phường Nhà Bàng","type":"phuong","slug":"phuong-nha-bang","name_with_type":"Phường Nhà Bàng","path":"Phường Nhà Bàng, Thị xã Tịnh Biên, Tỉnh An Giang","path_with_type":"Phường Nhà Bàng, Thị xã Tịnh Biên, Tỉnh An Giang","code":"30502","parent_code":"890"},"30505":{"name":"Phường Chi Lăng","type":"phuong","slug":"phuong-chi-lang","name_with_type":"Phường Chi Lăng","path":"Phường Chi Lăng, Thị xã Tịnh Biên, Tỉnh An Giang","path_with_type":"Phường Chi Lăng, Thị xã Tịnh Biên, Tỉnh An Giang","code":"30505","parent_code":"890"},"30508":{"name":"Phường Núi Voi","type":"phuong","slug":"phuong-nui-voi","name_with_type":"Phường Núi Voi","path":"Phường Núi Voi, Thị xã Tịnh Biên, Tỉnh An Giang","path_with_type":"Phường Núi Voi, Thị xã Tịnh Biên, Tỉnh An Giang","code":"30508","parent_code":"890"},"30511":{"name":"Phường Nhơn Hưng","type":"phuong","slug":"phuong-nhon-hung","name_with_type":"Phường Nhơn Hưng","path":"Phường Nhơn Hưng, Thị xã Tịnh Biên, Tỉnh An Giang","path_with_type":"Phường Nhơn Hưng, Thị xã Tịnh Biên, Tỉnh An Giang","code":"30511","parent_code":"890"},"30514":{"name":"Phường An Phú","type":"phuong","slug":"phuong-an-phu","name_with_type":"Phường An Phú","path":"Phường An Phú, Thị xã Tịnh Biên, Tỉnh An Giang","path_with_type":"Phường An Phú, Thị xã Tịnh Biên, Tỉnh An Giang","code":"30514","parent_code":"890"},"30517":{"name":"Phường Thới Sơn","type":"phuong","slug":"phuong-thoi-son","name_with_type":"Phường Thới Sơn","path":"Phường Thới Sơn, Thị xã Tịnh Biên, Tỉnh An Giang","path_with_type":"Phường Thới Sơn, Thị xã Tịnh Biên, Tỉnh An Giang","code":"30517","parent_code":"890"},"30520":{"name":"Phường Tịnh Biên","type":"phuong","slug":"phuong-tinh-bien","name_with_type":"Phường Tịnh Biên","path":"Phường Tịnh Biên, Thị xã Tịnh Biên, Tỉnh An Giang","path_with_type":"Phường Tịnh Biên, Thị xã Tịnh Biên, Tỉnh An Giang","code":"30520","parent_code":"890"},"30523":{"name":"Xã Văn Giáo","type":"xa","slug":"xa-van-giao","name_with_type":"Xã Văn Giáo","path":"Xã Văn Giáo, Thị xã Tịnh Biên, Tỉnh An Giang","path_with_type":"Xã Văn Giáo, Thị xã Tịnh Biên, Tỉnh An Giang","code":"30523","parent_code":"890"},"30526":{"name":"Xã An Cư","type":"xa","slug":"xa-an-cu","name_with_type":"Xã An Cư","path":"Xã An Cư, Thị xã Tịnh Biên, Tỉnh An Giang","path_with_type":"Xã An Cư, Thị xã Tịnh Biên, Tỉnh An Giang","code":"30526","parent_code":"890"},"30529":{"name":"Xã An Nông","type":"xa","slug":"xa-an-nong","name_with_type":"Xã An Nông","path":"Xã An Nông, Thị xã Tịnh Biên, Tỉnh An Giang","path_with_type":"Xã An Nông, Thị xã Tịnh Biên, Tỉnh An Giang","code":"30529","parent_code":"890"},"30532":{"name":"Xã Vĩnh Trung","type":"xa","slug":"xa-vinh-trung","name_with_type":"Xã Vĩnh Trung","path":"Xã Vĩnh Trung, Thị xã Tịnh Biên, Tỉnh An Giang","path_with_type":"Xã Vĩnh Trung, Thị xã Tịnh Biên, Tỉnh An Giang","code":"30532","parent_code":"890"},"30535":{"name":"Xã Tân Lợi","type":"xa","slug":"xa-tan-loi","name_with_type":"Xã Tân Lợi","path":"Xã Tân Lợi, Thị xã Tịnh Biên, Tỉnh An Giang","path_with_type":"Xã Tân Lợi, Thị xã Tịnh Biên, Tỉnh An Giang","code":"30535","parent_code":"890"},"30538":{"name":"Xã An Hảo","type":"xa","slug":"xa-an-hao","name_with_type":"Xã An Hảo","path":"Xã An Hảo, Thị xã Tịnh Biên, Tỉnh An Giang","path_with_type":"Xã An Hảo, Thị xã Tịnh Biên, Tỉnh An Giang","code":"30538","parent_code":"890"},"30541":{"name":"Xã Tân Lập","type":"xa","slug":"xa-tan-lap","name_with_type":"Xã Tân Lập","path":"Xã Tân Lập, Thị xã Tịnh Biên, Tỉnh An Giang","path_with_type":"Xã Tân Lập, Thị xã Tịnh Biên, Tỉnh An Giang","code":"30541","parent_code":"890"},"30544":{"name":"Thị trấn Tri Tôn","type":"thi-tran","slug":"thi-tran-tri-ton","name_with_type":"Thị trấn Tri Tôn","path":"Thị trấn Tri Tôn, Huyện Tri Tôn, Tỉnh An Giang","path_with_type":"Thị trấn Tri Tôn, Huyện Tri Tôn, Tỉnh An Giang","code":"30544","parent_code":"891"},"30547":{"name":"Thị trấn Ba Chúc","type":"thi-tran","slug":"thi-tran-ba-chuc","name_with_type":"Thị trấn Ba Chúc","path":"Thị trấn Ba Chúc, Huyện Tri Tôn, Tỉnh An Giang","path_with_type":"Thị trấn Ba Chúc, Huyện Tri Tôn, Tỉnh An Giang","code":"30547","parent_code":"891"},"30550":{"name":"Xã Lạc Quới","type":"xa","slug":"xa-lac-quoi","name_with_type":"Xã Lạc Quới","path":"Xã Lạc Quới, Huyện Tri Tôn, Tỉnh An Giang","path_with_type":"Xã Lạc Quới, Huyện Tri Tôn, Tỉnh An Giang","code":"30550","parent_code":"891"},"30553":{"name":"Xã Lê Trì","type":"xa","slug":"xa-le-tri","name_with_type":"Xã Lê Trì","path":"Xã Lê Trì, Huyện Tri Tôn, Tỉnh An Giang","path_with_type":"Xã Lê Trì, Huyện Tri Tôn, Tỉnh An Giang","code":"30553","parent_code":"891"},"30556":{"name":"Xã Vĩnh Gia","type":"xa","slug":"xa-vinh-gia","name_with_type":"Xã Vĩnh Gia","path":"Xã Vĩnh Gia, Huyện Tri Tôn, Tỉnh An Giang","path_with_type":"Xã Vĩnh Gia, Huyện Tri Tôn, Tỉnh An Giang","code":"30556","parent_code":"891"},"30559":{"name":"Xã Vĩnh Phước","type":"xa","slug":"xa-vinh-phuoc","name_with_type":"Xã Vĩnh Phước","path":"Xã Vĩnh Phước, Huyện Tri Tôn, Tỉnh An Giang","path_with_type":"Xã Vĩnh Phước, Huyện Tri Tôn, Tỉnh An Giang","code":"30559","parent_code":"891"},"30562":{"name":"Xã Châu Lăng","type":"xa","slug":"xa-chau-lang","name_with_type":"Xã Châu Lăng","path":"Xã Châu Lăng, Huyện Tri Tôn, Tỉnh An Giang","path_with_type":"Xã Châu Lăng, Huyện Tri Tôn, Tỉnh An Giang","code":"30562","parent_code":"891"},"30565":{"name":"Xã Lương Phi","type":"xa","slug":"xa-luong-phi","name_with_type":"Xã Lương Phi","path":"Xã Lương Phi, Huyện Tri Tôn, Tỉnh An Giang","path_with_type":"Xã Lương Phi, Huyện Tri Tôn, Tỉnh An Giang","code":"30565","parent_code":"891"},"30568":{"name":"Xã Lương An Trà","type":"xa","slug":"xa-luong-an-tra","name_with_type":"Xã Lương An Trà","path":"Xã Lương An Trà, Huyện Tri Tôn, Tỉnh An Giang","path_with_type":"Xã Lương An Trà, Huyện Tri Tôn, Tỉnh An Giang","code":"30568","parent_code":"891"},"30571":{"name":"Xã Tà Đảnh","type":"xa","slug":"xa-ta-danh","name_with_type":"Xã Tà Đảnh","path":"Xã Tà Đảnh, Huyện Tri Tôn, Tỉnh An Giang","path_with_type":"Xã Tà Đảnh, Huyện Tri Tôn, Tỉnh An Giang","code":"30571","parent_code":"891"},"30574":{"name":"Xã Núi Tô","type":"xa","slug":"xa-nui-to","name_with_type":"Xã Núi Tô","path":"Xã Núi Tô, Huyện Tri Tôn, Tỉnh An Giang","path_with_type":"Xã Núi Tô, Huyện Tri Tôn, Tỉnh An Giang","code":"30574","parent_code":"891"},"30577":{"name":"Xã An Tức","type":"xa","slug":"xa-an-tuc","name_with_type":"Xã An Tức","path":"Xã An Tức, Huyện Tri Tôn, Tỉnh An Giang","path_with_type":"Xã An Tức, Huyện Tri Tôn, Tỉnh An Giang","code":"30577","parent_code":"891"},"30580":{"name":"Thị trấn Cô Tô","type":"thi-tran","slug":"thi-tran-co-to","name_with_type":"Thị trấn Cô Tô","path":"Thị trấn Cô Tô, Huyện Tri Tôn, Tỉnh An Giang","path_with_type":"Thị trấn Cô Tô, Huyện Tri Tôn, Tỉnh An Giang","code":"30580","parent_code":"891"},"30583":{"name":"Xã Tân Tuyến","type":"xa","slug":"xa-tan-tuyen","name_with_type":"Xã Tân Tuyến","path":"Xã Tân Tuyến, Huyện Tri Tôn, Tỉnh An Giang","path_with_type":"Xã Tân Tuyến, Huyện Tri Tôn, Tỉnh An Giang","code":"30583","parent_code":"891"},"30586":{"name":"Xã Ô Lâm","type":"xa","slug":"xa-o-lam","name_with_type":"Xã Ô Lâm","path":"Xã Ô Lâm, Huyện Tri Tôn, Tỉnh An Giang","path_with_type":"Xã Ô Lâm, Huyện Tri Tôn, Tỉnh An Giang","code":"30586","parent_code":"891"},"30589":{"name":"Thị trấn An Châu","type":"thi-tran","slug":"thi-tran-an-chau","name_with_type":"Thị trấn An Châu","path":"Thị trấn An Châu, Huyện Châu Thành, Tỉnh An Giang","path_with_type":"Thị trấn An Châu, Huyện Châu Thành, Tỉnh An Giang","code":"30589","parent_code":"892"},"30592":{"name":"Xã An Hòa","type":"xa","slug":"xa-an-hoa","name_with_type":"Xã An Hòa","path":"Xã An Hòa, Huyện Châu Thành, Tỉnh An Giang","path_with_type":"Xã An Hòa, Huyện Châu Thành, Tỉnh An Giang","code":"30592","parent_code":"892"},"30595":{"name":"Xã Cần Đăng","type":"xa","slug":"xa-can-dang","name_with_type":"Xã Cần Đăng","path":"Xã Cần Đăng, Huyện Châu Thành, Tỉnh An Giang","path_with_type":"Xã Cần Đăng, Huyện Châu Thành, Tỉnh An Giang","code":"30595","parent_code":"892"},"30598":{"name":"Xã Vĩnh Hanh","type":"xa","slug":"xa-vinh-hanh","name_with_type":"Xã Vĩnh Hanh","path":"Xã Vĩnh Hanh, Huyện Châu Thành, Tỉnh An Giang","path_with_type":"Xã Vĩnh Hanh, Huyện Châu Thành, Tỉnh An Giang","code":"30598","parent_code":"892"},"30601":{"name":"Xã Bình Thạnh","type":"xa","slug":"xa-binh-thanh","name_with_type":"Xã Bình Thạnh","path":"Xã Bình Thạnh, Huyện Châu Thành, Tỉnh An Giang","path_with_type":"Xã Bình Thạnh, Huyện Châu Thành, Tỉnh An Giang","code":"30601","parent_code":"892"},"30604":{"name":"Thị trấn Vĩnh Bình","type":"thi-tran","slug":"thi-tran-vinh-binh","name_with_type":"Thị trấn Vĩnh Bình","path":"Thị trấn Vĩnh Bình, Huyện Châu Thành, Tỉnh An Giang","path_with_type":"Thị trấn Vĩnh Bình, Huyện Châu Thành, Tỉnh An Giang","code":"30604","parent_code":"892"},"30607":{"name":"Xã Bình Hòa","type":"xa","slug":"xa-binh-hoa","name_with_type":"Xã Bình Hòa","path":"Xã Bình Hòa, Huyện Châu Thành, Tỉnh An Giang","path_with_type":"Xã Bình Hòa, Huyện Châu Thành, Tỉnh An Giang","code":"30607","parent_code":"892"},"30610":{"name":"Xã Vĩnh An","type":"xa","slug":"xa-vinh-an","name_with_type":"Xã Vĩnh An","path":"Xã Vĩnh An, Huyện Châu Thành, Tỉnh An Giang","path_with_type":"Xã Vĩnh An, Huyện Châu Thành, Tỉnh An Giang","code":"30610","parent_code":"892"},"30613":{"name":"Xã Hòa Bình Thạnh","type":"xa","slug":"xa-hoa-binh-thanh","name_with_type":"Xã Hòa Bình Thạnh","path":"Xã Hòa Bình Thạnh, Huyện Châu Thành, Tỉnh An Giang","path_with_type":"Xã Hòa Bình Thạnh, Huyện Châu Thành, Tỉnh An Giang","code":"30613","parent_code":"892"},"30616":{"name":"Xã Vĩnh Lợi","type":"xa","slug":"xa-vinh-loi","name_with_type":"Xã Vĩnh Lợi","path":"Xã Vĩnh Lợi, Huyện Châu Thành, Tỉnh An Giang","path_with_type":"Xã Vĩnh Lợi, Huyện Châu Thành, Tỉnh An Giang","code":"30616","parent_code":"892"},"30619":{"name":"Xã Vĩnh Nhuận","type":"xa","slug":"xa-vinh-nhuan","name_with_type":"Xã Vĩnh Nhuận","path":"Xã Vĩnh Nhuận, Huyện Châu Thành, Tỉnh An Giang","path_with_type":"Xã Vĩnh Nhuận, Huyện Châu Thành, Tỉnh An Giang","code":"30619","parent_code":"892"},"30622":{"name":"Xã Tân Phú","type":"xa","slug":"xa-tan-phu","name_with_type":"Xã Tân Phú","path":"Xã Tân Phú, Huyện Châu Thành, Tỉnh An Giang","path_with_type":"Xã Tân Phú, Huyện Châu Thành, Tỉnh An Giang","code":"30622","parent_code":"892"},"30625":{"name":"Xã Vĩnh Thành","type":"xa","slug":"xa-vinh-thanh","name_with_type":"Xã Vĩnh Thành","path":"Xã Vĩnh Thành, Huyện Châu Thành, Tỉnh An Giang","path_with_type":"Xã Vĩnh Thành, Huyện Châu Thành, Tỉnh An Giang","code":"30625","parent_code":"892"},"30628":{"name":"Thị trấn Chợ Mới","type":"thi-tran","slug":"thi-tran-cho-moi","name_with_type":"Thị trấn Chợ Mới","path":"Thị trấn Chợ Mới, Huyện Chợ Mới, Tỉnh An Giang","path_with_type":"Thị trấn Chợ Mới, Huyện Chợ Mới, Tỉnh An Giang","code":"30628","parent_code":"893"},"30631":{"name":"Thị trấn Mỹ Luông","type":"thi-tran","slug":"thi-tran-my-luong","name_with_type":"Thị trấn Mỹ Luông","path":"Thị trấn Mỹ Luông, Huyện Chợ Mới, Tỉnh An Giang","path_with_type":"Thị trấn Mỹ Luông, Huyện Chợ Mới, Tỉnh An Giang","code":"30631","parent_code":"893"},"30634":{"name":"Xã Kiến An","type":"xa","slug":"xa-kien-an","name_with_type":"Xã Kiến An","path":"Xã Kiến An, Huyện Chợ Mới, Tỉnh An Giang","path_with_type":"Xã Kiến An, Huyện Chợ Mới, Tỉnh An Giang","code":"30634","parent_code":"893"},"30637":{"name":"Xã Mỹ Hội Đông","type":"xa","slug":"xa-my-hoi-dong","name_with_type":"Xã Mỹ Hội Đông","path":"Xã Mỹ Hội Đông, Huyện Chợ Mới, Tỉnh An Giang","path_with_type":"Xã Mỹ Hội Đông, Huyện Chợ Mới, Tỉnh An Giang","code":"30637","parent_code":"893"},"30640":{"name":"Xã Long Điền A","type":"xa","slug":"xa-long-dien-a","name_with_type":"Xã Long Điền A","path":"Xã Long Điền A, Huyện Chợ Mới, Tỉnh An Giang","path_with_type":"Xã Long Điền A, Huyện Chợ Mới, Tỉnh An Giang","code":"30640","parent_code":"893"},"30643":{"name":"Xã Tấn Mỹ","type":"xa","slug":"xa-tan-my","name_with_type":"Xã Tấn Mỹ","path":"Xã Tấn Mỹ, Huyện Chợ Mới, Tỉnh An Giang","path_with_type":"Xã Tấn Mỹ, Huyện Chợ Mới, Tỉnh An Giang","code":"30643","parent_code":"893"},"30646":{"name":"Xã Long Điền B","type":"xa","slug":"xa-long-dien-b","name_with_type":"Xã Long Điền B","path":"Xã Long Điền B, Huyện Chợ Mới, Tỉnh An Giang","path_with_type":"Xã Long Điền B, Huyện Chợ Mới, Tỉnh An Giang","code":"30646","parent_code":"893"},"30649":{"name":"Xã Kiến Thành","type":"xa","slug":"xa-kien-thanh","name_with_type":"Xã Kiến Thành","path":"Xã Kiến Thành, Huyện Chợ Mới, Tỉnh An Giang","path_with_type":"Xã Kiến Thành, Huyện Chợ Mới, Tỉnh An Giang","code":"30649","parent_code":"893"},"30652":{"name":"Xã Mỹ Hiệp","type":"xa","slug":"xa-my-hiep","name_with_type":"Xã Mỹ Hiệp","path":"Xã Mỹ Hiệp, Huyện Chợ Mới, Tỉnh An Giang","path_with_type":"Xã Mỹ Hiệp, Huyện Chợ Mới, Tỉnh An Giang","code":"30652","parent_code":"893"},"30655":{"name":"Xã Mỹ An","type":"xa","slug":"xa-my-an","name_with_type":"Xã Mỹ An","path":"Xã Mỹ An, Huyện Chợ Mới, Tỉnh An Giang","path_with_type":"Xã Mỹ An, Huyện Chợ Mới, Tỉnh An Giang","code":"30655","parent_code":"893"},"30658":{"name":"Xã Nhơn Mỹ","type":"xa","slug":"xa-nhon-my","name_with_type":"Xã Nhơn Mỹ","path":"Xã Nhơn Mỹ, Huyện Chợ Mới, Tỉnh An Giang","path_with_type":"Xã Nhơn Mỹ, Huyện Chợ Mới, Tỉnh An Giang","code":"30658","parent_code":"893"},"30661":{"name":"Xã Long Giang","type":"xa","slug":"xa-long-giang","name_with_type":"Xã Long Giang","path":"Xã Long Giang, Huyện Chợ Mới, Tỉnh An Giang","path_with_type":"Xã Long Giang, Huyện Chợ Mới, Tỉnh An Giang","code":"30661","parent_code":"893"},"30664":{"name":"Xã Long Kiến","type":"xa","slug":"xa-long-kien","name_with_type":"Xã Long Kiến","path":"Xã Long Kiến, Huyện Chợ Mới, Tỉnh An Giang","path_with_type":"Xã Long Kiến, Huyện Chợ Mới, Tỉnh An Giang","code":"30664","parent_code":"893"},"30667":{"name":"Xã Bình Phước Xuân","type":"xa","slug":"xa-binh-phuoc-xuan","name_with_type":"Xã Bình Phước Xuân","path":"Xã Bình Phước Xuân, Huyện Chợ Mới, Tỉnh An Giang","path_with_type":"Xã Bình Phước Xuân, Huyện Chợ Mới, Tỉnh An Giang","code":"30667","parent_code":"893"},"30670":{"name":"Xã An Thạnh Trung","type":"xa","slug":"xa-an-thanh-trung","name_with_type":"Xã An Thạnh Trung","path":"Xã An Thạnh Trung, Huyện Chợ Mới, Tỉnh An Giang","path_with_type":"Xã An Thạnh Trung, Huyện Chợ Mới, Tỉnh An Giang","code":"30670","parent_code":"893"},"30673":{"name":"Thị trấn Hội An","type":"thi-tran","slug":"thi-tran-hoi-an","name_with_type":"Thị trấn Hội An","path":"Thị trấn Hội An, Huyện Chợ Mới, Tỉnh An Giang","path_with_type":"Thị trấn Hội An, Huyện Chợ Mới, Tỉnh An Giang","code":"30673","parent_code":"893"},"30676":{"name":"Xã Hòa Bình","type":"xa","slug":"xa-hoa-binh","name_with_type":"Xã Hòa Bình","path":"Xã Hòa Bình, Huyện Chợ Mới, Tỉnh An Giang","path_with_type":"Xã Hòa Bình, Huyện Chợ Mới, Tỉnh An Giang","code":"30676","parent_code":"893"},"30679":{"name":"Xã Hòa An","type":"xa","slug":"xa-hoa-an","name_with_type":"Xã Hòa An","path":"Xã Hòa An, Huyện Chợ Mới, Tỉnh An Giang","path_with_type":"Xã Hòa An, Huyện Chợ Mới, Tỉnh An Giang","code":"30679","parent_code":"893"},"30682":{"name":"Thị trấn Núi Sập","type":"thi-tran","slug":"thi-tran-nui-sap","name_with_type":"Thị trấn Núi Sập","path":"Thị trấn Núi Sập, Huyện Thoại Sơn, Tỉnh An Giang","path_with_type":"Thị trấn Núi Sập, Huyện Thoại Sơn, Tỉnh An Giang","code":"30682","parent_code":"894"},"30685":{"name":"Thị trấn Phú Hoà","type":"thi-tran","slug":"thi-tran-phu-hoa","name_with_type":"Thị trấn Phú Hoà","path":"Thị trấn Phú Hoà, Huyện Thoại Sơn, Tỉnh An Giang","path_with_type":"Thị trấn Phú Hoà, Huyện Thoại Sơn, Tỉnh An Giang","code":"30685","parent_code":"894"},"30688":{"name":"Thị Trấn Óc Eo","type":"thi-tran","slug":"thi-tran-oc-eo","name_with_type":"Thị Trấn Óc Eo","path":"Thị Trấn Óc Eo, Huyện Thoại Sơn, Tỉnh An Giang","path_with_type":"Thị Trấn Óc Eo, Huyện Thoại Sơn, Tỉnh An Giang","code":"30688","parent_code":"894"},"30691":{"name":"Xã Tây Phú","type":"xa","slug":"xa-tay-phu","name_with_type":"Xã Tây Phú","path":"Xã Tây Phú, Huyện Thoại Sơn, Tỉnh An Giang","path_with_type":"Xã Tây Phú, Huyện Thoại Sơn, Tỉnh An Giang","code":"30691","parent_code":"894"},"30692":{"name":"Xã An Bình","type":"xa","slug":"xa-an-binh","name_with_type":"Xã An Bình","path":"Xã An Bình, Huyện Thoại Sơn, Tỉnh An Giang","path_with_type":"Xã An Bình, Huyện Thoại Sơn, Tỉnh An Giang","code":"30692","parent_code":"894"},"30694":{"name":"Xã Vĩnh Phú","type":"xa","slug":"xa-vinh-phu","name_with_type":"Xã Vĩnh Phú","path":"Xã Vĩnh Phú, Huyện Thoại Sơn, Tỉnh An Giang","path_with_type":"Xã Vĩnh Phú, Huyện Thoại Sơn, Tỉnh An Giang","code":"30694","parent_code":"894"},"30697":{"name":"Xã Vĩnh Trạch","type":"xa","slug":"xa-vinh-trach","name_with_type":"Xã Vĩnh Trạch","path":"Xã Vĩnh Trạch, Huyện Thoại Sơn, Tỉnh An Giang","path_with_type":"Xã Vĩnh Trạch, Huyện Thoại Sơn, Tỉnh An Giang","code":"30697","parent_code":"894"},"30700":{"name":"Xã Phú Thuận","type":"xa","slug":"xa-phu-thuan","name_with_type":"Xã Phú Thuận","path":"Xã Phú Thuận, Huyện Thoại Sơn, Tỉnh An Giang","path_with_type":"Xã Phú Thuận, Huyện Thoại Sơn, Tỉnh An Giang","code":"30700","parent_code":"894"},"30703":{"name":"Xã Vĩnh Chánh","type":"xa","slug":"xa-vinh-chanh","name_with_type":"Xã Vĩnh Chánh","path":"Xã Vĩnh Chánh, Huyện Thoại Sơn, Tỉnh An Giang","path_with_type":"Xã Vĩnh Chánh, Huyện Thoại Sơn, Tỉnh An Giang","code":"30703","parent_code":"894"},"30706":{"name":"Xã Định Mỹ","type":"xa","slug":"xa-dinh-my","name_with_type":"Xã Định Mỹ","path":"Xã Định Mỹ, Huyện Thoại Sơn, Tỉnh An Giang","path_with_type":"Xã Định Mỹ, Huyện Thoại Sơn, Tỉnh An Giang","code":"30706","parent_code":"894"},"30709":{"name":"Xã Định Thành","type":"xa","slug":"xa-dinh-thanh","name_with_type":"Xã Định Thành","path":"Xã Định Thành, Huyện Thoại Sơn, Tỉnh An Giang","path_with_type":"Xã Định Thành, Huyện Thoại Sơn, Tỉnh An Giang","code":"30709","parent_code":"894"},"30712":{"name":"Xã Mỹ Phú Đông","type":"xa","slug":"xa-my-phu-dong","name_with_type":"Xã Mỹ Phú Đông","path":"Xã Mỹ Phú Đông, Huyện Thoại Sơn, Tỉnh An Giang","path_with_type":"Xã Mỹ Phú Đông, Huyện Thoại Sơn, Tỉnh An Giang","code":"30712","parent_code":"894"},"30715":{"name":"Xã Vọng Đông","type":"xa","slug":"xa-vong-dong","name_with_type":"Xã Vọng Đông","path":"Xã Vọng Đông, Huyện Thoại Sơn, Tỉnh An Giang","path_with_type":"Xã Vọng Đông, Huyện Thoại Sơn, Tỉnh An Giang","code":"30715","parent_code":"894"},"30718":{"name":"Xã Vĩnh Khánh","type":"xa","slug":"xa-vinh-khanh","name_with_type":"Xã Vĩnh Khánh","path":"Xã Vĩnh Khánh, Huyện Thoại Sơn, Tỉnh An Giang","path_with_type":"Xã Vĩnh Khánh, Huyện Thoại Sơn, Tỉnh An Giang","code":"30718","parent_code":"894"},"30721":{"name":"Xã Thoại Giang","type":"xa","slug":"xa-thoai-giang","name_with_type":"Xã Thoại Giang","path":"Xã Thoại Giang, Huyện Thoại Sơn, Tỉnh An Giang","path_with_type":"Xã Thoại Giang, Huyện Thoại Sơn, Tỉnh An Giang","code":"30721","parent_code":"894"},"30724":{"name":"Xã Bình Thành","type":"xa","slug":"xa-binh-thanh","name_with_type":"Xã Bình Thành","path":"Xã Bình Thành, Huyện Thoại Sơn, Tỉnh An Giang","path_with_type":"Xã Bình Thành, Huyện Thoại Sơn, Tỉnh An Giang","code":"30724","parent_code":"894"},"30727":{"name":"Xã Vọng Thê","type":"xa","slug":"xa-vong-the","name_with_type":"Xã Vọng Thê","path":"Xã Vọng Thê, Huyện Thoại Sơn, Tỉnh An Giang","path_with_type":"Xã Vọng Thê, Huyện Thoại Sơn, Tỉnh An Giang","code":"30727","parent_code":"894"},"30733":{"name":"Phường Vĩnh Thanh","type":"phuong","slug":"phuong-vinh-thanh","name_with_type":"Phường Vĩnh Thanh","path":"Phường Vĩnh Thanh, Thành phố Rạch Giá, Tỉnh Kiên Giang","path_with_type":"Phường Vĩnh Thanh, Thành phố Rạch Giá, Tỉnh Kiên Giang","code":"30733","parent_code":"899"},"30736":{"name":"Phường Vĩnh Quang","type":"phuong","slug":"phuong-vinh-quang","name_with_type":"Phường Vĩnh Quang","path":"Phường Vĩnh Quang, Thành phố Rạch Giá, Tỉnh Kiên Giang","path_with_type":"Phường Vĩnh Quang, Thành phố Rạch Giá, Tỉnh Kiên Giang","code":"30736","parent_code":"899"},"30739":{"name":"Phường Vĩnh Hiệp","type":"phuong","slug":"phuong-vinh-hiep","name_with_type":"Phường Vĩnh Hiệp","path":"Phường Vĩnh Hiệp, Thành phố Rạch Giá, Tỉnh Kiên Giang","path_with_type":"Phường Vĩnh Hiệp, Thành phố Rạch Giá, Tỉnh Kiên Giang","code":"30739","parent_code":"899"},"30742":{"name":"Phường Vĩnh Thanh Vân","type":"phuong","slug":"phuong-vinh-thanh-van","name_with_type":"Phường Vĩnh Thanh Vân","path":"Phường Vĩnh Thanh Vân, Thành phố Rạch Giá, Tỉnh Kiên Giang","path_with_type":"Phường Vĩnh Thanh Vân, Thành phố Rạch Giá, Tỉnh Kiên Giang","code":"30742","parent_code":"899"},"30745":{"name":"Phường Vĩnh Lạc","type":"phuong","slug":"phuong-vinh-lac","name_with_type":"Phường Vĩnh Lạc","path":"Phường Vĩnh Lạc, Thành phố Rạch Giá, Tỉnh Kiên Giang","path_with_type":"Phường Vĩnh Lạc, Thành phố Rạch Giá, Tỉnh Kiên Giang","code":"30745","parent_code":"899"},"30748":{"name":"Phường An Hòa","type":"phuong","slug":"phuong-an-hoa","name_with_type":"Phường An Hòa","path":"Phường An Hòa, Thành phố Rạch Giá, Tỉnh Kiên Giang","path_with_type":"Phường An Hòa, Thành phố Rạch Giá, Tỉnh Kiên Giang","code":"30748","parent_code":"899"},"30751":{"name":"Phường An Bình","type":"phuong","slug":"phuong-an-binh","name_with_type":"Phường An Bình","path":"Phường An Bình, Thành phố Rạch Giá, Tỉnh Kiên Giang","path_with_type":"Phường An Bình, Thành phố Rạch Giá, Tỉnh Kiên Giang","code":"30751","parent_code":"899"},"30754":{"name":"Phường Rạch Sỏi","type":"phuong","slug":"phuong-rach-soi","name_with_type":"Phường Rạch Sỏi","path":"Phường Rạch Sỏi, Thành phố Rạch Giá, Tỉnh Kiên Giang","path_with_type":"Phường Rạch Sỏi, Thành phố Rạch Giá, Tỉnh Kiên Giang","code":"30754","parent_code":"899"},"30757":{"name":"Phường Vĩnh Lợi","type":"phuong","slug":"phuong-vinh-loi","name_with_type":"Phường Vĩnh Lợi","path":"Phường Vĩnh Lợi, Thành phố Rạch Giá, Tỉnh Kiên Giang","path_with_type":"Phường Vĩnh Lợi, Thành phố Rạch Giá, Tỉnh Kiên Giang","code":"30757","parent_code":"899"},"30760":{"name":"Phường Vĩnh Thông","type":"phuong","slug":"phuong-vinh-thong","name_with_type":"Phường Vĩnh Thông","path":"Phường Vĩnh Thông, Thành phố Rạch Giá, Tỉnh Kiên Giang","path_with_type":"Phường Vĩnh Thông, Thành phố Rạch Giá, Tỉnh Kiên Giang","code":"30760","parent_code":"899"},"30763":{"name":"Xã Phi Thông","type":"xa","slug":"xa-phi-thong","name_with_type":"Xã Phi Thông","path":"Xã Phi Thông, Thành phố Rạch Giá, Tỉnh Kiên Giang","path_with_type":"Xã Phi Thông, Thành phố Rạch Giá, Tỉnh Kiên Giang","code":"30763","parent_code":"899"},"30766":{"name":"Phường Tô Châu","type":"phuong","slug":"phuong-to-chau","name_with_type":"Phường Tô Châu","path":"Phường Tô Châu, Thành phố Hà Tiên, Tỉnh Kiên Giang","path_with_type":"Phường Tô Châu, Thành phố Hà Tiên, Tỉnh Kiên Giang","code":"30766","parent_code":"900"},"30769":{"name":"Phường Đông Hồ","type":"phuong","slug":"phuong-dong-ho","name_with_type":"Phường Đông Hồ","path":"Phường Đông Hồ, Thành phố Hà Tiên, Tỉnh Kiên Giang","path_with_type":"Phường Đông Hồ, Thành phố Hà Tiên, Tỉnh Kiên Giang","code":"30769","parent_code":"900"},"30772":{"name":"Phường Bình San","type":"phuong","slug":"phuong-binh-san","name_with_type":"Phường Bình San","path":"Phường Bình San, Thành phố Hà Tiên, Tỉnh Kiên Giang","path_with_type":"Phường Bình San, Thành phố Hà Tiên, Tỉnh Kiên Giang","code":"30772","parent_code":"900"},"30775":{"name":"Phường Pháo Đài","type":"phuong","slug":"phuong-phao-dai","name_with_type":"Phường Pháo Đài","path":"Phường Pháo Đài, Thành phố Hà Tiên, Tỉnh Kiên Giang","path_with_type":"Phường Pháo Đài, Thành phố Hà Tiên, Tỉnh Kiên Giang","code":"30775","parent_code":"900"},"30778":{"name":"Phường Mỹ Đức","type":"phuong","slug":"phuong-my-duc","name_with_type":"Phường Mỹ Đức","path":"Phường Mỹ Đức, Thành phố Hà Tiên, Tỉnh Kiên Giang","path_with_type":"Phường Mỹ Đức, Thành phố Hà Tiên, Tỉnh Kiên Giang","code":"30778","parent_code":"900"},"30781":{"name":"Xã Tiên Hải","type":"xa","slug":"xa-tien-hai","name_with_type":"Xã Tiên Hải","path":"Xã Tiên Hải, Thành phố Hà Tiên, Tỉnh Kiên Giang","path_with_type":"Xã Tiên Hải, Thành phố Hà Tiên, Tỉnh Kiên Giang","code":"30781","parent_code":"900"},"30784":{"name":"Xã Thuận Yên","type":"xa","slug":"xa-thuan-yen","name_with_type":"Xã Thuận Yên","path":"Xã Thuận Yên, Thành phố Hà Tiên, Tỉnh Kiên Giang","path_with_type":"Xã Thuận Yên, Thành phố Hà Tiên, Tỉnh Kiên Giang","code":"30784","parent_code":"900"},"30787":{"name":"Thị trấn Kiên Lương","type":"thi-tran","slug":"thi-tran-kien-luong","name_with_type":"Thị trấn Kiên Lương","path":"Thị trấn Kiên Lương, Huyện Kiên Lương, Tỉnh Kiên Giang","path_with_type":"Thị trấn Kiên Lương, Huyện Kiên Lương, Tỉnh Kiên Giang","code":"30787","parent_code":"902"},"30790":{"name":"Xã Kiên Bình","type":"xa","slug":"xa-kien-binh","name_with_type":"Xã Kiên Bình","path":"Xã Kiên Bình, Huyện Kiên Lương, Tỉnh Kiên Giang","path_with_type":"Xã Kiên Bình, Huyện Kiên Lương, Tỉnh Kiên Giang","code":"30790","parent_code":"902"},"30791":{"name":"Xã Vĩnh Phú","type":"xa","slug":"xa-vinh-phu","name_with_type":"Xã Vĩnh Phú","path":"Xã Vĩnh Phú, Huyện Giang Thành, Tỉnh Kiên Giang","path_with_type":"Xã Vĩnh Phú, Huyện Giang Thành, Tỉnh Kiên Giang","code":"30791","parent_code":"914"},"30793":{"name":"Xã Vĩnh Điều","type":"xa","slug":"xa-vinh-dieu","name_with_type":"Xã Vĩnh Điều","path":"Xã Vĩnh Điều, Huyện Giang Thành, Tỉnh Kiên Giang","path_with_type":"Xã Vĩnh Điều, Huyện Giang Thành, Tỉnh Kiên Giang","code":"30793","parent_code":"914"},"30796":{"name":"Xã Tân Khánh Hòa","type":"xa","slug":"xa-tan-khanh-hoa","name_with_type":"Xã Tân Khánh Hòa","path":"Xã Tân Khánh Hòa, Huyện Giang Thành, Tỉnh Kiên Giang","path_with_type":"Xã Tân Khánh Hòa, Huyện Giang Thành, Tỉnh Kiên Giang","code":"30796","parent_code":"914"},"30797":{"name":"Xã Phú Lợi","type":"xa","slug":"xa-phu-loi","name_with_type":"Xã Phú Lợi","path":"Xã Phú Lợi, Huyện Giang Thành, Tỉnh Kiên Giang","path_with_type":"Xã Phú Lợi, Huyện Giang Thành, Tỉnh Kiên Giang","code":"30797","parent_code":"914"},"30799":{"name":"Xã Phú Mỹ","type":"xa","slug":"xa-phu-my","name_with_type":"Xã Phú Mỹ","path":"Xã Phú Mỹ, Huyện Giang Thành, Tỉnh Kiên Giang","path_with_type":"Xã Phú Mỹ, Huyện Giang Thành, Tỉnh Kiên Giang","code":"30799","parent_code":"914"},"30802":{"name":"Xã Hòa Điền","type":"xa","slug":"xa-hoa-dien","name_with_type":"Xã Hòa Điền","path":"Xã Hòa Điền, Huyện Kiên Lương, Tỉnh Kiên Giang","path_with_type":"Xã Hòa Điền, Huyện Kiên Lương, Tỉnh Kiên Giang","code":"30802","parent_code":"902"},"30805":{"name":"Xã Dương Hòa","type":"xa","slug":"xa-duong-hoa","name_with_type":"Xã Dương Hòa","path":"Xã Dương Hòa, Huyện Kiên Lương, Tỉnh Kiên Giang","path_with_type":"Xã Dương Hòa, Huyện Kiên Lương, Tỉnh Kiên Giang","code":"30805","parent_code":"902"},"30808":{"name":"Xã Bình An","type":"xa","slug":"xa-binh-an","name_with_type":"Xã Bình An","path":"Xã Bình An, Huyện Kiên Lương, Tỉnh Kiên Giang","path_with_type":"Xã Bình An, Huyện Kiên Lương, Tỉnh Kiên Giang","code":"30808","parent_code":"902"},"30809":{"name":"Xã Bình Trị","type":"xa","slug":"xa-binh-tri","name_with_type":"Xã Bình Trị","path":"Xã Bình Trị, Huyện Kiên Lương, Tỉnh Kiên Giang","path_with_type":"Xã Bình Trị, Huyện Kiên Lương, Tỉnh Kiên Giang","code":"30809","parent_code":"902"},"30811":{"name":"Xã Sơn Hải","type":"xa","slug":"xa-son-hai","name_with_type":"Xã Sơn Hải","path":"Xã Sơn Hải, Huyện Kiên Lương, Tỉnh Kiên Giang","path_with_type":"Xã Sơn Hải, Huyện Kiên Lương, Tỉnh Kiên Giang","code":"30811","parent_code":"902"},"30814":{"name":"Xã Hòn Nghệ","type":"xa","slug":"xa-hon-nghe","name_with_type":"Xã Hòn Nghệ","path":"Xã Hòn Nghệ, Huyện Kiên Lương, Tỉnh Kiên Giang","path_with_type":"Xã Hòn Nghệ, Huyện Kiên Lương, Tỉnh Kiên Giang","code":"30814","parent_code":"902"},"30817":{"name":"Thị trấn Hòn Đất","type":"thi-tran","slug":"thi-tran-hon-dat","name_with_type":"Thị trấn Hòn Đất","path":"Thị trấn Hòn Đất, Huyện Hòn Đất, Tỉnh Kiên Giang","path_with_type":"Thị trấn Hòn Đất, Huyện Hòn Đất, Tỉnh Kiên Giang","code":"30817","parent_code":"903"},"30820":{"name":"Thị trấn Sóc Sơn","type":"thi-tran","slug":"thi-tran-soc-son","name_with_type":"Thị trấn Sóc Sơn","path":"Thị trấn Sóc Sơn, Huyện Hòn Đất, Tỉnh Kiên Giang","path_with_type":"Thị trấn Sóc Sơn, Huyện Hòn Đất, Tỉnh Kiên Giang","code":"30820","parent_code":"903"},"30823":{"name":"Xã Bình Sơn","type":"xa","slug":"xa-binh-son","name_with_type":"Xã Bình Sơn","path":"Xã Bình Sơn, Huyện Hòn Đất, Tỉnh Kiên Giang","path_with_type":"Xã Bình Sơn, Huyện Hòn Đất, Tỉnh Kiên Giang","code":"30823","parent_code":"903"},"30826":{"name":"Xã Bình Giang","type":"xa","slug":"xa-binh-giang","name_with_type":"Xã Bình Giang","path":"Xã Bình Giang, Huyện Hòn Đất, Tỉnh Kiên Giang","path_with_type":"Xã Bình Giang, Huyện Hòn Đất, Tỉnh Kiên Giang","code":"30826","parent_code":"903"},"30828":{"name":"Xã Mỹ Thái","type":"xa","slug":"xa-my-thai","name_with_type":"Xã Mỹ Thái","path":"Xã Mỹ Thái, Huyện Hòn Đất, Tỉnh Kiên Giang","path_with_type":"Xã Mỹ Thái, Huyện Hòn Đất, Tỉnh Kiên Giang","code":"30828","parent_code":"903"},"30829":{"name":"Xã Nam Thái Sơn","type":"xa","slug":"xa-nam-thai-son","name_with_type":"Xã Nam Thái Sơn","path":"Xã Nam Thái Sơn, Huyện Hòn Đất, Tỉnh Kiên Giang","path_with_type":"Xã Nam Thái Sơn, Huyện Hòn Đất, Tỉnh Kiên Giang","code":"30829","parent_code":"903"},"30832":{"name":"Xã Mỹ Hiệp Sơn","type":"xa","slug":"xa-my-hiep-son","name_with_type":"Xã Mỹ Hiệp Sơn","path":"Xã Mỹ Hiệp Sơn, Huyện Hòn Đất, Tỉnh Kiên Giang","path_with_type":"Xã Mỹ Hiệp Sơn, Huyện Hòn Đất, Tỉnh Kiên Giang","code":"30832","parent_code":"903"},"30835":{"name":"Xã Sơn Kiên","type":"xa","slug":"xa-son-kien","name_with_type":"Xã Sơn Kiên","path":"Xã Sơn Kiên, Huyện Hòn Đất, Tỉnh Kiên Giang","path_with_type":"Xã Sơn Kiên, Huyện Hòn Đất, Tỉnh Kiên Giang","code":"30835","parent_code":"903"},"30836":{"name":"Xã Sơn Bình","type":"xa","slug":"xa-son-binh","name_with_type":"Xã Sơn Bình","path":"Xã Sơn Bình, Huyện Hòn Đất, Tỉnh Kiên Giang","path_with_type":"Xã Sơn Bình, Huyện Hòn Đất, Tỉnh Kiên Giang","code":"30836","parent_code":"903"},"30838":{"name":"Xã Mỹ Thuận","type":"xa","slug":"xa-my-thuan","name_with_type":"Xã Mỹ Thuận","path":"Xã Mỹ Thuận, Huyện Hòn Đất, Tỉnh Kiên Giang","path_with_type":"Xã Mỹ Thuận, Huyện Hòn Đất, Tỉnh Kiên Giang","code":"30838","parent_code":"903"},"30840":{"name":"Xã Lình Huỳnh","type":"xa","slug":"xa-linh-huynh","name_with_type":"Xã Lình Huỳnh","path":"Xã Lình Huỳnh, Huyện Hòn Đất, Tỉnh Kiên Giang","path_with_type":"Xã Lình Huỳnh, Huyện Hòn Đất, Tỉnh Kiên Giang","code":"30840","parent_code":"903"},"30841":{"name":"Xã Thổ Sơn","type":"xa","slug":"xa-tho-son","name_with_type":"Xã Thổ Sơn","path":"Xã Thổ Sơn, Huyện Hòn Đất, Tỉnh Kiên Giang","path_with_type":"Xã Thổ Sơn, Huyện Hòn Đất, Tỉnh Kiên Giang","code":"30841","parent_code":"903"},"30844":{"name":"Xã Mỹ Lâm","type":"xa","slug":"xa-my-lam","name_with_type":"Xã Mỹ Lâm","path":"Xã Mỹ Lâm, Huyện Hòn Đất, Tỉnh Kiên Giang","path_with_type":"Xã Mỹ Lâm, Huyện Hòn Đất, Tỉnh Kiên Giang","code":"30844","parent_code":"903"},"30847":{"name":"Xã Mỹ Phước","type":"xa","slug":"xa-my-phuoc","name_with_type":"Xã Mỹ Phước","path":"Xã Mỹ Phước, Huyện Hòn Đất, Tỉnh Kiên Giang","path_with_type":"Xã Mỹ Phước, Huyện Hòn Đất, Tỉnh Kiên Giang","code":"30847","parent_code":"903"},"30850":{"name":"Thị trấn Tân Hiệp","type":"thi-tran","slug":"thi-tran-tan-hiep","name_with_type":"Thị trấn Tân Hiệp","path":"Thị trấn Tân Hiệp, Huyện Tân Hiệp, Tỉnh Kiên Giang","path_with_type":"Thị trấn Tân Hiệp, Huyện Tân Hiệp, Tỉnh Kiên Giang","code":"30850","parent_code":"904"},"30853":{"name":"Xã Tân Hội","type":"xa","slug":"xa-tan-hoi","name_with_type":"Xã Tân Hội","path":"Xã Tân Hội, Huyện Tân Hiệp, Tỉnh Kiên Giang","path_with_type":"Xã Tân Hội, Huyện Tân Hiệp, Tỉnh Kiên Giang","code":"30853","parent_code":"904"},"30856":{"name":"Xã Tân Thành","type":"xa","slug":"xa-tan-thanh","name_with_type":"Xã Tân Thành","path":"Xã Tân Thành, Huyện Tân Hiệp, Tỉnh Kiên Giang","path_with_type":"Xã Tân Thành, Huyện Tân Hiệp, Tỉnh Kiên Giang","code":"30856","parent_code":"904"},"30859":{"name":"Xã Tân Hiệp B","type":"xa","slug":"xa-tan-hiep-b","name_with_type":"Xã Tân Hiệp B","path":"Xã Tân Hiệp B, Huyện Tân Hiệp, Tỉnh Kiên Giang","path_with_type":"Xã Tân Hiệp B, Huyện Tân Hiệp, Tỉnh Kiên Giang","code":"30859","parent_code":"904"},"30860":{"name":"Xã Tân Hoà","type":"xa","slug":"xa-tan-hoa","name_with_type":"Xã Tân Hoà","path":"Xã Tân Hoà, Huyện Tân Hiệp, Tỉnh Kiên Giang","path_with_type":"Xã Tân Hoà, Huyện Tân Hiệp, Tỉnh Kiên Giang","code":"30860","parent_code":"904"},"30862":{"name":"Xã Thạnh Đông B","type":"xa","slug":"xa-thanh-dong-b","name_with_type":"Xã Thạnh Đông B","path":"Xã Thạnh Đông B, Huyện Tân Hiệp, Tỉnh Kiên Giang","path_with_type":"Xã Thạnh Đông B, Huyện Tân Hiệp, Tỉnh Kiên Giang","code":"30862","parent_code":"904"},"30865":{"name":"Xã Thạnh Đông","type":"xa","slug":"xa-thanh-dong","name_with_type":"Xã Thạnh Đông","path":"Xã Thạnh Đông, Huyện Tân Hiệp, Tỉnh Kiên Giang","path_with_type":"Xã Thạnh Đông, Huyện Tân Hiệp, Tỉnh Kiên Giang","code":"30865","parent_code":"904"},"30868":{"name":"Xã Tân Hiệp A","type":"xa","slug":"xa-tan-hiep-a","name_with_type":"Xã Tân Hiệp A","path":"Xã Tân Hiệp A, Huyện Tân Hiệp, Tỉnh Kiên Giang","path_with_type":"Xã Tân Hiệp A, Huyện Tân Hiệp, Tỉnh Kiên Giang","code":"30868","parent_code":"904"},"30871":{"name":"Xã Tân An","type":"xa","slug":"xa-tan-an","name_with_type":"Xã Tân An","path":"Xã Tân An, Huyện Tân Hiệp, Tỉnh Kiên Giang","path_with_type":"Xã Tân An, Huyện Tân Hiệp, Tỉnh Kiên Giang","code":"30871","parent_code":"904"},"30874":{"name":"Xã Thạnh Đông A","type":"xa","slug":"xa-thanh-dong-a","name_with_type":"Xã Thạnh Đông A","path":"Xã Thạnh Đông A, Huyện Tân Hiệp, Tỉnh Kiên Giang","path_with_type":"Xã Thạnh Đông A, Huyện Tân Hiệp, Tỉnh Kiên Giang","code":"30874","parent_code":"904"},"30877":{"name":"Xã Thạnh Trị","type":"xa","slug":"xa-thanh-tri","name_with_type":"Xã Thạnh Trị","path":"Xã Thạnh Trị, Huyện Tân Hiệp, Tỉnh Kiên Giang","path_with_type":"Xã Thạnh Trị, Huyện Tân Hiệp, Tỉnh Kiên Giang","code":"30877","parent_code":"904"},"30880":{"name":"Thị trấn Minh Lương","type":"thi-tran","slug":"thi-tran-minh-luong","name_with_type":"Thị trấn Minh Lương","path":"Thị trấn Minh Lương, Huyện Châu Thành, Tỉnh Kiên Giang","path_with_type":"Thị trấn Minh Lương, Huyện Châu Thành, Tỉnh Kiên Giang","code":"30880","parent_code":"905"},"30883":{"name":"Xã Mong Thọ A","type":"xa","slug":"xa-mong-tho-a","name_with_type":"Xã Mong Thọ A","path":"Xã Mong Thọ A, Huyện Châu Thành, Tỉnh Kiên Giang","path_with_type":"Xã Mong Thọ A, Huyện Châu Thành, Tỉnh Kiên Giang","code":"30883","parent_code":"905"},"30886":{"name":"Xã Mong Thọ B","type":"xa","slug":"xa-mong-tho-b","name_with_type":"Xã Mong Thọ B","path":"Xã Mong Thọ B, Huyện Châu Thành, Tỉnh Kiên Giang","path_with_type":"Xã Mong Thọ B, Huyện Châu Thành, Tỉnh Kiên Giang","code":"30886","parent_code":"905"},"30887":{"name":"Xã Mong Thọ","type":"xa","slug":"xa-mong-tho","name_with_type":"Xã Mong Thọ","path":"Xã Mong Thọ, Huyện Châu Thành, Tỉnh Kiên Giang","path_with_type":"Xã Mong Thọ, Huyện Châu Thành, Tỉnh Kiên Giang","code":"30887","parent_code":"905"},"30889":{"name":"Xã Giục Tượng","type":"xa","slug":"xa-giuc-tuong","name_with_type":"Xã Giục Tượng","path":"Xã Giục Tượng, Huyện Châu Thành, Tỉnh Kiên Giang","path_with_type":"Xã Giục Tượng, Huyện Châu Thành, Tỉnh Kiên Giang","code":"30889","parent_code":"905"},"30892":{"name":"Xã Vĩnh Hòa Hiệp","type":"xa","slug":"xa-vinh-hoa-hiep","name_with_type":"Xã Vĩnh Hòa Hiệp","path":"Xã Vĩnh Hòa Hiệp, Huyện Châu Thành, Tỉnh Kiên Giang","path_with_type":"Xã Vĩnh Hòa Hiệp, Huyện Châu Thành, Tỉnh Kiên Giang","code":"30892","parent_code":"905"},"30893":{"name":"Xã Vĩnh Hoà Phú","type":"xa","slug":"xa-vinh-hoa-phu","name_with_type":"Xã Vĩnh Hoà Phú","path":"Xã Vĩnh Hoà Phú, Huyện Châu Thành, Tỉnh Kiên Giang","path_with_type":"Xã Vĩnh Hoà Phú, Huyện Châu Thành, Tỉnh Kiên Giang","code":"30893","parent_code":"905"},"30895":{"name":"Xã Minh Hòa","type":"xa","slug":"xa-minh-hoa","name_with_type":"Xã Minh Hòa","path":"Xã Minh Hòa, Huyện Châu Thành, Tỉnh Kiên Giang","path_with_type":"Xã Minh Hòa, Huyện Châu Thành, Tỉnh Kiên Giang","code":"30895","parent_code":"905"},"30898":{"name":"Xã Bình An","type":"xa","slug":"xa-binh-an","name_with_type":"Xã Bình An","path":"Xã Bình An, Huyện Châu Thành, Tỉnh Kiên Giang","path_with_type":"Xã Bình An, Huyện Châu Thành, Tỉnh Kiên Giang","code":"30898","parent_code":"905"},"30901":{"name":"Xã Thạnh Lộc","type":"xa","slug":"xa-thanh-loc","name_with_type":"Xã Thạnh Lộc","path":"Xã Thạnh Lộc, Huyện Châu Thành, Tỉnh Kiên Giang","path_with_type":"Xã Thạnh Lộc, Huyện Châu Thành, Tỉnh Kiên Giang","code":"30901","parent_code":"905"},"30904":{"name":"Thị Trấn Giồng Riềng","type":"thi-tran","slug":"thi-tran-giong-rieng","name_with_type":"Thị Trấn Giồng Riềng","path":"Thị Trấn Giồng Riềng, Huyện Giồng Riềng, Tỉnh Kiên Giang","path_with_type":"Thị Trấn Giồng Riềng, Huyện Giồng Riềng, Tỉnh Kiên Giang","code":"30904","parent_code":"906"},"30907":{"name":"Xã Thạnh Hưng","type":"xa","slug":"xa-thanh-hung","name_with_type":"Xã Thạnh Hưng","path":"Xã Thạnh Hưng, Huyện Giồng Riềng, Tỉnh Kiên Giang","path_with_type":"Xã Thạnh Hưng, Huyện Giồng Riềng, Tỉnh Kiên Giang","code":"30907","parent_code":"906"},"30910":{"name":"Xã Thạnh Phước","type":"xa","slug":"xa-thanh-phuoc","name_with_type":"Xã Thạnh Phước","path":"Xã Thạnh Phước, Huyện Giồng Riềng, Tỉnh Kiên Giang","path_with_type":"Xã Thạnh Phước, Huyện Giồng Riềng, Tỉnh Kiên Giang","code":"30910","parent_code":"906"},"30913":{"name":"Xã Thạnh Lộc","type":"xa","slug":"xa-thanh-loc","name_with_type":"Xã Thạnh Lộc","path":"Xã Thạnh Lộc, Huyện Giồng Riềng, Tỉnh Kiên Giang","path_with_type":"Xã Thạnh Lộc, Huyện Giồng Riềng, Tỉnh Kiên Giang","code":"30913","parent_code":"906"},"30916":{"name":"Xã Thạnh Hòa","type":"xa","slug":"xa-thanh-hoa","name_with_type":"Xã Thạnh Hòa","path":"Xã Thạnh Hòa, Huyện Giồng Riềng, Tỉnh Kiên Giang","path_with_type":"Xã Thạnh Hòa, Huyện Giồng Riềng, Tỉnh Kiên Giang","code":"30916","parent_code":"906"},"30917":{"name":"Xã Thạnh Bình","type":"xa","slug":"xa-thanh-binh","name_with_type":"Xã Thạnh Bình","path":"Xã Thạnh Bình, Huyện Giồng Riềng, Tỉnh Kiên Giang","path_with_type":"Xã Thạnh Bình, Huyện Giồng Riềng, Tỉnh Kiên Giang","code":"30917","parent_code":"906"},"30919":{"name":"Xã Bàn Thạch","type":"xa","slug":"xa-ban-thach","name_with_type":"Xã Bàn Thạch","path":"Xã Bàn Thạch, Huyện Giồng Riềng, Tỉnh Kiên Giang","path_with_type":"Xã Bàn Thạch, Huyện Giồng Riềng, Tỉnh Kiên Giang","code":"30919","parent_code":"906"},"30922":{"name":"Xã Bàn Tân Định","type":"xa","slug":"xa-ban-tan-dinh","name_with_type":"Xã Bàn Tân Định","path":"Xã Bàn Tân Định, Huyện Giồng Riềng, Tỉnh Kiên Giang","path_with_type":"Xã Bàn Tân Định, Huyện Giồng Riềng, Tỉnh Kiên Giang","code":"30922","parent_code":"906"},"30925":{"name":"Xã Ngọc Thành","type":"xa","slug":"xa-ngoc-thanh","name_with_type":"Xã Ngọc Thành","path":"Xã Ngọc Thành, Huyện Giồng Riềng, Tỉnh Kiên Giang","path_with_type":"Xã Ngọc Thành, Huyện Giồng Riềng, Tỉnh Kiên Giang","code":"30925","parent_code":"906"},"30928":{"name":"Xã Ngọc Chúc","type":"xa","slug":"xa-ngoc-chuc","name_with_type":"Xã Ngọc Chúc","path":"Xã Ngọc Chúc, Huyện Giồng Riềng, Tỉnh Kiên Giang","path_with_type":"Xã Ngọc Chúc, Huyện Giồng Riềng, Tỉnh Kiên Giang","code":"30928","parent_code":"906"},"30931":{"name":"Xã Ngọc Thuận","type":"xa","slug":"xa-ngoc-thuan","name_with_type":"Xã Ngọc Thuận","path":"Xã Ngọc Thuận, Huyện Giồng Riềng, Tỉnh Kiên Giang","path_with_type":"Xã Ngọc Thuận, Huyện Giồng Riềng, Tỉnh Kiên Giang","code":"30931","parent_code":"906"},"30934":{"name":"Xã Hòa Hưng","type":"xa","slug":"xa-hoa-hung","name_with_type":"Xã Hòa Hưng","path":"Xã Hòa Hưng, Huyện Giồng Riềng, Tỉnh Kiên Giang","path_with_type":"Xã Hòa Hưng, Huyện Giồng Riềng, Tỉnh Kiên Giang","code":"30934","parent_code":"906"},"30937":{"name":"Xã Hoà Lợi","type":"xa","slug":"xa-hoa-loi","name_with_type":"Xã Hoà Lợi","path":"Xã Hoà Lợi, Huyện Giồng Riềng, Tỉnh Kiên Giang","path_with_type":"Xã Hoà Lợi, Huyện Giồng Riềng, Tỉnh Kiên Giang","code":"30937","parent_code":"906"},"30940":{"name":"Xã Hoà An","type":"xa","slug":"xa-hoa-an","name_with_type":"Xã Hoà An","path":"Xã Hoà An, Huyện Giồng Riềng, Tỉnh Kiên Giang","path_with_type":"Xã Hoà An, Huyện Giồng Riềng, Tỉnh Kiên Giang","code":"30940","parent_code":"906"},"30943":{"name":"Xã Long Thạnh","type":"xa","slug":"xa-long-thanh","name_with_type":"Xã Long Thạnh","path":"Xã Long Thạnh, Huyện Giồng Riềng, Tỉnh Kiên Giang","path_with_type":"Xã Long Thạnh, Huyện Giồng Riềng, Tỉnh Kiên Giang","code":"30943","parent_code":"906"},"30946":{"name":"Xã Vĩnh Thạnh","type":"xa","slug":"xa-vinh-thanh","name_with_type":"Xã Vĩnh Thạnh","path":"Xã Vĩnh Thạnh, Huyện Giồng Riềng, Tỉnh Kiên Giang","path_with_type":"Xã Vĩnh Thạnh, Huyện Giồng Riềng, Tỉnh Kiên Giang","code":"30946","parent_code":"906"},"30947":{"name":"Xã Vĩnh Phú","type":"xa","slug":"xa-vinh-phu","name_with_type":"Xã Vĩnh Phú","path":"Xã Vĩnh Phú, Huyện Giồng Riềng, Tỉnh Kiên Giang","path_with_type":"Xã Vĩnh Phú, Huyện Giồng Riềng, Tỉnh Kiên Giang","code":"30947","parent_code":"906"},"30949":{"name":"Xã  Hòa Thuận","type":"xa","slug":"xa-hoa-thuan","name_with_type":"Xã  Hòa Thuận","path":"Xã  Hòa Thuận, Huyện Giồng Riềng, Tỉnh Kiên Giang","path_with_type":"Xã  Hòa Thuận, Huyện Giồng Riềng, Tỉnh Kiên Giang","code":"30949","parent_code":"906"},"30950":{"name":"Xã Ngọc Hoà","type":"xa","slug":"xa-ngoc-hoa","name_with_type":"Xã Ngọc Hoà","path":"Xã Ngọc Hoà, Huyện Giồng Riềng, Tỉnh Kiên Giang","path_with_type":"Xã Ngọc Hoà, Huyện Giồng Riềng, Tỉnh Kiên Giang","code":"30950","parent_code":"906"},"30952":{"name":"Thị trấn Gò Quao","type":"thi-tran","slug":"thi-tran-go-quao","name_with_type":"Thị trấn Gò Quao","path":"Thị trấn Gò Quao, Huyện Gò Quao, Tỉnh Kiên Giang","path_with_type":"Thị trấn Gò Quao, Huyện Gò Quao, Tỉnh Kiên Giang","code":"30952","parent_code":"907"},"30955":{"name":"Xã Vĩnh Hòa Hưng Bắc","type":"xa","slug":"xa-vinh-hoa-hung-bac","name_with_type":"Xã Vĩnh Hòa Hưng Bắc","path":"Xã Vĩnh Hòa Hưng Bắc, Huyện Gò Quao, Tỉnh Kiên Giang","path_with_type":"Xã Vĩnh Hòa Hưng Bắc, Huyện Gò Quao, Tỉnh Kiên Giang","code":"30955","parent_code":"907"},"30958":{"name":"Xã Định Hòa","type":"xa","slug":"xa-dinh-hoa","name_with_type":"Xã Định Hòa","path":"Xã Định Hòa, Huyện Gò Quao, Tỉnh Kiên Giang","path_with_type":"Xã Định Hòa, Huyện Gò Quao, Tỉnh Kiên Giang","code":"30958","parent_code":"907"},"30961":{"name":"Xã Thới Quản","type":"xa","slug":"xa-thoi-quan","name_with_type":"Xã Thới Quản","path":"Xã Thới Quản, Huyện Gò Quao, Tỉnh Kiên Giang","path_with_type":"Xã Thới Quản, Huyện Gò Quao, Tỉnh Kiên Giang","code":"30961","parent_code":"907"},"30964":{"name":"Xã Định An","type":"xa","slug":"xa-dinh-an","name_with_type":"Xã Định An","path":"Xã Định An, Huyện Gò Quao, Tỉnh Kiên Giang","path_with_type":"Xã Định An, Huyện Gò Quao, Tỉnh Kiên Giang","code":"30964","parent_code":"907"},"30967":{"name":"Xã Thủy Liễu","type":"xa","slug":"xa-thuy-lieu","name_with_type":"Xã Thủy Liễu","path":"Xã Thủy Liễu, Huyện Gò Quao, Tỉnh Kiên Giang","path_with_type":"Xã Thủy Liễu, Huyện Gò Quao, Tỉnh Kiên Giang","code":"30967","parent_code":"907"},"30970":{"name":"Xã Vĩnh Hòa Hưng Nam","type":"xa","slug":"xa-vinh-hoa-hung-nam","name_with_type":"Xã Vĩnh Hòa Hưng Nam","path":"Xã Vĩnh Hòa Hưng Nam, Huyện Gò Quao, Tỉnh Kiên Giang","path_with_type":"Xã Vĩnh Hòa Hưng Nam, Huyện Gò Quao, Tỉnh Kiên Giang","code":"30970","parent_code":"907"},"30973":{"name":"Xã Vĩnh Phước A","type":"xa","slug":"xa-vinh-phuoc-a","name_with_type":"Xã Vĩnh Phước A","path":"Xã Vĩnh Phước A, Huyện Gò Quao, Tỉnh Kiên Giang","path_with_type":"Xã Vĩnh Phước A, Huyện Gò Quao, Tỉnh Kiên Giang","code":"30973","parent_code":"907"},"30976":{"name":"Xã Vĩnh Phước B","type":"xa","slug":"xa-vinh-phuoc-b","name_with_type":"Xã Vĩnh Phước B","path":"Xã Vĩnh Phước B, Huyện Gò Quao, Tỉnh Kiên Giang","path_with_type":"Xã Vĩnh Phước B, Huyện Gò Quao, Tỉnh Kiên Giang","code":"30976","parent_code":"907"},"30979":{"name":"Xã Vĩnh Tuy","type":"xa","slug":"xa-vinh-tuy","name_with_type":"Xã Vĩnh Tuy","path":"Xã Vĩnh Tuy, Huyện Gò Quao, Tỉnh Kiên Giang","path_with_type":"Xã Vĩnh Tuy, Huyện Gò Quao, Tỉnh Kiên Giang","code":"30979","parent_code":"907"},"30982":{"name":"Xã Vĩnh Thắng","type":"xa","slug":"xa-vinh-thang","name_with_type":"Xã Vĩnh Thắng","path":"Xã Vĩnh Thắng, Huyện Gò Quao, Tỉnh Kiên Giang","path_with_type":"Xã Vĩnh Thắng, Huyện Gò Quao, Tỉnh Kiên Giang","code":"30982","parent_code":"907"},"30985":{"name":"Thị trấn Thứ Ba","type":"thi-tran","slug":"thi-tran-thu-ba","name_with_type":"Thị trấn Thứ Ba","path":"Thị trấn Thứ Ba, Huyện An Biên, Tỉnh Kiên Giang","path_with_type":"Thị trấn Thứ Ba, Huyện An Biên, Tỉnh Kiên Giang","code":"30985","parent_code":"908"},"30988":{"name":"Xã Tây Yên","type":"xa","slug":"xa-tay-yen","name_with_type":"Xã Tây Yên","path":"Xã Tây Yên, Huyện An Biên, Tỉnh Kiên Giang","path_with_type":"Xã Tây Yên, Huyện An Biên, Tỉnh Kiên Giang","code":"30988","parent_code":"908"},"30991":{"name":"Xã Tây Yên A","type":"xa","slug":"xa-tay-yen-a","name_with_type":"Xã Tây Yên A","path":"Xã Tây Yên A, Huyện An Biên, Tỉnh Kiên Giang","path_with_type":"Xã Tây Yên A, Huyện An Biên, Tỉnh Kiên Giang","code":"30991","parent_code":"908"},"30994":{"name":"Xã Nam Yên","type":"xa","slug":"xa-nam-yen","name_with_type":"Xã Nam Yên","path":"Xã Nam Yên, Huyện An Biên, Tỉnh Kiên Giang","path_with_type":"Xã Nam Yên, Huyện An Biên, Tỉnh Kiên Giang","code":"30994","parent_code":"908"},"30997":{"name":"Xã Hưng Yên","type":"xa","slug":"xa-hung-yen","name_with_type":"Xã Hưng Yên","path":"Xã Hưng Yên, Huyện An Biên, Tỉnh Kiên Giang","path_with_type":"Xã Hưng Yên, Huyện An Biên, Tỉnh Kiên Giang","code":"30997","parent_code":"908"},"31000":{"name":"Xã Nam Thái","type":"xa","slug":"xa-nam-thai","name_with_type":"Xã Nam Thái","path":"Xã Nam Thái, Huyện An Biên, Tỉnh Kiên Giang","path_with_type":"Xã Nam Thái, Huyện An Biên, Tỉnh Kiên Giang","code":"31000","parent_code":"908"},"31003":{"name":"Xã Nam Thái A","type":"xa","slug":"xa-nam-thai-a","name_with_type":"Xã Nam Thái A","path":"Xã Nam Thái A, Huyện An Biên, Tỉnh Kiên Giang","path_with_type":"Xã Nam Thái A, Huyện An Biên, Tỉnh Kiên Giang","code":"31003","parent_code":"908"},"31006":{"name":"Xã Đông Thái","type":"xa","slug":"xa-dong-thai","name_with_type":"Xã Đông Thái","path":"Xã Đông Thái, Huyện An Biên, Tỉnh Kiên Giang","path_with_type":"Xã Đông Thái, Huyện An Biên, Tỉnh Kiên Giang","code":"31006","parent_code":"908"},"31009":{"name":"Xã Đông Yên","type":"xa","slug":"xa-dong-yen","name_with_type":"Xã Đông Yên","path":"Xã Đông Yên, Huyện An Biên, Tỉnh Kiên Giang","path_with_type":"Xã Đông Yên, Huyện An Biên, Tỉnh Kiên Giang","code":"31009","parent_code":"908"},"31012":{"name":"Xã Thạnh Yên","type":"xa","slug":"xa-thanh-yen","name_with_type":"Xã Thạnh Yên","path":"Xã Thạnh Yên, Huyện U Minh Thượng, Tỉnh Kiên Giang","path_with_type":"Xã Thạnh Yên, Huyện U Minh Thượng, Tỉnh Kiên Giang","code":"31012","parent_code":"913"},"31015":{"name":"Xã Thạnh Yên A","type":"xa","slug":"xa-thanh-yen-a","name_with_type":"Xã Thạnh Yên A","path":"Xã Thạnh Yên A, Huyện U Minh Thượng, Tỉnh Kiên Giang","path_with_type":"Xã Thạnh Yên A, Huyện U Minh Thượng, Tỉnh Kiên Giang","code":"31015","parent_code":"913"},"31018":{"name":"Thị trấn Thứ Mười Một","type":"thi-tran","slug":"thi-tran-thu-muoi-mot","name_with_type":"Thị trấn Thứ Mười Một","path":"Thị trấn Thứ Mười Một, Huyện An Minh, Tỉnh Kiên Giang","path_with_type":"Thị trấn Thứ Mười Một, Huyện An Minh, Tỉnh Kiên Giang","code":"31018","parent_code":"909"},"31021":{"name":"Xã Thuận Hoà","type":"xa","slug":"xa-thuan-hoa","name_with_type":"Xã Thuận Hoà","path":"Xã Thuận Hoà, Huyện An Minh, Tỉnh Kiên Giang","path_with_type":"Xã Thuận Hoà, Huyện An Minh, Tỉnh Kiên Giang","code":"31021","parent_code":"909"},"31024":{"name":"Xã Đông Hòa","type":"xa","slug":"xa-dong-hoa","name_with_type":"Xã Đông Hòa","path":"Xã Đông Hòa, Huyện An Minh, Tỉnh Kiên Giang","path_with_type":"Xã Đông Hòa, Huyện An Minh, Tỉnh Kiên Giang","code":"31024","parent_code":"909"},"31027":{"name":"Xã An Minh Bắc","type":"xa","slug":"xa-an-minh-bac","name_with_type":"Xã An Minh Bắc","path":"Xã An Minh Bắc, Huyện U Minh Thượng, Tỉnh Kiên Giang","path_with_type":"Xã An Minh Bắc, Huyện U Minh Thượng, Tỉnh Kiên Giang","code":"31027","parent_code":"913"},"31030":{"name":"Xã Đông Thạnh","type":"xa","slug":"xa-dong-thanh","name_with_type":"Xã Đông Thạnh","path":"Xã Đông Thạnh, Huyện An Minh, Tỉnh Kiên Giang","path_with_type":"Xã Đông Thạnh, Huyện An Minh, Tỉnh Kiên Giang","code":"31030","parent_code":"909"},"31031":{"name":"Xã Tân Thạnh","type":"xa","slug":"xa-tan-thanh","name_with_type":"Xã Tân Thạnh","path":"Xã Tân Thạnh, Huyện An Minh, Tỉnh Kiên Giang","path_with_type":"Xã Tân Thạnh, Huyện An Minh, Tỉnh Kiên Giang","code":"31031","parent_code":"909"},"31033":{"name":"Xã Đông Hưng","type":"xa","slug":"xa-dong-hung","name_with_type":"Xã Đông Hưng","path":"Xã Đông Hưng, Huyện An Minh, Tỉnh Kiên Giang","path_with_type":"Xã Đông Hưng, Huyện An Minh, Tỉnh Kiên Giang","code":"31033","parent_code":"909"},"31036":{"name":"Xã Đông Hưng A","type":"xa","slug":"xa-dong-hung-a","name_with_type":"Xã Đông Hưng A","path":"Xã Đông Hưng A, Huyện An Minh, Tỉnh Kiên Giang","path_with_type":"Xã Đông Hưng A, Huyện An Minh, Tỉnh Kiên Giang","code":"31036","parent_code":"909"},"31039":{"name":"Xã Đông Hưng B","type":"xa","slug":"xa-dong-hung-b","name_with_type":"Xã Đông Hưng B","path":"Xã Đông Hưng B, Huyện An Minh, Tỉnh Kiên Giang","path_with_type":"Xã Đông Hưng B, Huyện An Minh, Tỉnh Kiên Giang","code":"31039","parent_code":"909"},"31042":{"name":"Xã Vân Khánh","type":"xa","slug":"xa-van-khanh","name_with_type":"Xã Vân Khánh","path":"Xã Vân Khánh, Huyện An Minh, Tỉnh Kiên Giang","path_with_type":"Xã Vân Khánh, Huyện An Minh, Tỉnh Kiên Giang","code":"31042","parent_code":"909"},"31045":{"name":"Xã Vân Khánh Đông","type":"xa","slug":"xa-van-khanh-dong","name_with_type":"Xã Vân Khánh Đông","path":"Xã Vân Khánh Đông, Huyện An Minh, Tỉnh Kiên Giang","path_with_type":"Xã Vân Khánh Đông, Huyện An Minh, Tỉnh Kiên Giang","code":"31045","parent_code":"909"},"31048":{"name":"Xã Vân Khánh Tây","type":"xa","slug":"xa-van-khanh-tay","name_with_type":"Xã Vân Khánh Tây","path":"Xã Vân Khánh Tây, Huyện An Minh, Tỉnh Kiên Giang","path_with_type":"Xã Vân Khánh Tây, Huyện An Minh, Tỉnh Kiên Giang","code":"31048","parent_code":"909"},"31051":{"name":"Thị trấn Vĩnh Thuận","type":"thi-tran","slug":"thi-tran-vinh-thuan","name_with_type":"Thị trấn Vĩnh Thuận","path":"Thị trấn Vĩnh Thuận, Huyện Vĩnh Thuận, Tỉnh Kiên Giang","path_with_type":"Thị trấn Vĩnh Thuận, Huyện Vĩnh Thuận, Tỉnh Kiên Giang","code":"31051","parent_code":"910"},"31054":{"name":"Xã Vĩnh Hòa","type":"xa","slug":"xa-vinh-hoa","name_with_type":"Xã Vĩnh Hòa","path":"Xã Vĩnh Hòa, Huyện U Minh Thượng, Tỉnh Kiên Giang","path_with_type":"Xã Vĩnh Hòa, Huyện U Minh Thượng, Tỉnh Kiên Giang","code":"31054","parent_code":"913"},"31057":{"name":"Xã Hoà Chánh","type":"xa","slug":"xa-hoa-chanh","name_with_type":"Xã Hoà Chánh","path":"Xã Hoà Chánh, Huyện U Minh Thượng, Tỉnh Kiên Giang","path_with_type":"Xã Hoà Chánh, Huyện U Minh Thượng, Tỉnh Kiên Giang","code":"31057","parent_code":"913"},"31060":{"name":"Xã Vĩnh Bình Bắc","type":"xa","slug":"xa-vinh-binh-bac","name_with_type":"Xã Vĩnh Bình Bắc","path":"Xã Vĩnh Bình Bắc, Huyện Vĩnh Thuận, Tỉnh Kiên Giang","path_with_type":"Xã Vĩnh Bình Bắc, Huyện Vĩnh Thuận, Tỉnh Kiên Giang","code":"31060","parent_code":"910"},"31063":{"name":"Xã Vĩnh Bình Nam","type":"xa","slug":"xa-vinh-binh-nam","name_with_type":"Xã Vĩnh Bình Nam","path":"Xã Vĩnh Bình Nam, Huyện Vĩnh Thuận, Tỉnh Kiên Giang","path_with_type":"Xã Vĩnh Bình Nam, Huyện Vĩnh Thuận, Tỉnh Kiên Giang","code":"31063","parent_code":"910"},"31064":{"name":"Xã Bình Minh","type":"xa","slug":"xa-binh-minh","name_with_type":"Xã Bình Minh","path":"Xã Bình Minh, Huyện Vĩnh Thuận, Tỉnh Kiên Giang","path_with_type":"Xã Bình Minh, Huyện Vĩnh Thuận, Tỉnh Kiên Giang","code":"31064","parent_code":"910"},"31066":{"name":"Xã Minh Thuận","type":"xa","slug":"xa-minh-thuan","name_with_type":"Xã Minh Thuận","path":"Xã Minh Thuận, Huyện U Minh Thượng, Tỉnh Kiên Giang","path_with_type":"Xã Minh Thuận, Huyện U Minh Thượng, Tỉnh Kiên Giang","code":"31066","parent_code":"913"},"31069":{"name":"Xã Vĩnh Thuận","type":"xa","slug":"xa-vinh-thuan","name_with_type":"Xã Vĩnh Thuận","path":"Xã Vĩnh Thuận, Huyện Vĩnh Thuận, Tỉnh Kiên Giang","path_with_type":"Xã Vĩnh Thuận, Huyện Vĩnh Thuận, Tỉnh Kiên Giang","code":"31069","parent_code":"910"},"31072":{"name":"Xã Tân Thuận","type":"xa","slug":"xa-tan-thuan","name_with_type":"Xã Tân Thuận","path":"Xã Tân Thuận, Huyện Vĩnh Thuận, Tỉnh Kiên Giang","path_with_type":"Xã Tân Thuận, Huyện Vĩnh Thuận, Tỉnh Kiên Giang","code":"31072","parent_code":"910"},"31074":{"name":"Xã Phong Đông","type":"xa","slug":"xa-phong-dong","name_with_type":"Xã Phong Đông","path":"Xã Phong Đông, Huyện Vĩnh Thuận, Tỉnh Kiên Giang","path_with_type":"Xã Phong Đông, Huyện Vĩnh Thuận, Tỉnh Kiên Giang","code":"31074","parent_code":"910"},"31075":{"name":"Xã Vĩnh Phong","type":"xa","slug":"xa-vinh-phong","name_with_type":"Xã Vĩnh Phong","path":"Xã Vĩnh Phong, Huyện Vĩnh Thuận, Tỉnh Kiên Giang","path_with_type":"Xã Vĩnh Phong, Huyện Vĩnh Thuận, Tỉnh Kiên Giang","code":"31075","parent_code":"910"},"31078":{"name":"Phường Dương Đông","type":"phuong","slug":"phuong-duong-dong","name_with_type":"Phường Dương Đông","path":"Phường Dương Đông, Thành phố Phú Quốc, Tỉnh Kiên Giang","path_with_type":"Phường Dương Đông, Thành phố Phú Quốc, Tỉnh Kiên Giang","code":"31078","parent_code":"911"},"31081":{"name":"Phường An Thới","type":"phuong","slug":"phuong-an-thoi","name_with_type":"Phường An Thới","path":"Phường An Thới, Thành phố Phú Quốc, Tỉnh Kiên Giang","path_with_type":"Phường An Thới, Thành phố Phú Quốc, Tỉnh Kiên Giang","code":"31081","parent_code":"911"},"31084":{"name":"Xã Cửa Cạn","type":"xa","slug":"xa-cua-can","name_with_type":"Xã Cửa Cạn","path":"Xã Cửa Cạn, Thành phố Phú Quốc, Tỉnh Kiên Giang","path_with_type":"Xã Cửa Cạn, Thành phố Phú Quốc, Tỉnh Kiên Giang","code":"31084","parent_code":"911"},"31087":{"name":"Xã Gành Dầu","type":"xa","slug":"xa-ganh-dau","name_with_type":"Xã Gành Dầu","path":"Xã Gành Dầu, Thành phố Phú Quốc, Tỉnh Kiên Giang","path_with_type":"Xã Gành Dầu, Thành phố Phú Quốc, Tỉnh Kiên Giang","code":"31087","parent_code":"911"},"31090":{"name":"Xã Cửa Dương","type":"xa","slug":"xa-cua-duong","name_with_type":"Xã Cửa Dương","path":"Xã Cửa Dương, Thành phố Phú Quốc, Tỉnh Kiên Giang","path_with_type":"Xã Cửa Dương, Thành phố Phú Quốc, Tỉnh Kiên Giang","code":"31090","parent_code":"911"},"31093":{"name":"Xã Hàm Ninh","type":"xa","slug":"xa-ham-ninh","name_with_type":"Xã Hàm Ninh","path":"Xã Hàm Ninh, Thành phố Phú Quốc, Tỉnh Kiên Giang","path_with_type":"Xã Hàm Ninh, Thành phố Phú Quốc, Tỉnh Kiên Giang","code":"31093","parent_code":"911"},"31096":{"name":"Xã Dương Tơ","type":"xa","slug":"xa-duong-to","name_with_type":"Xã Dương Tơ","path":"Xã Dương Tơ, Thành phố Phú Quốc, Tỉnh Kiên Giang","path_with_type":"Xã Dương Tơ, Thành phố Phú Quốc, Tỉnh Kiên Giang","code":"31096","parent_code":"911"},"31102":{"name":"Xã Bãi Thơm","type":"xa","slug":"xa-bai-thom","name_with_type":"Xã Bãi Thơm","path":"Xã Bãi Thơm, Thành phố Phú Quốc, Tỉnh Kiên Giang","path_with_type":"Xã Bãi Thơm, Thành phố Phú Quốc, Tỉnh Kiên Giang","code":"31102","parent_code":"911"},"31105":{"name":"Xã Thổ Châu","type":"xa","slug":"xa-tho-chau","name_with_type":"Xã Thổ Châu","path":"Xã Thổ Châu, Thành phố Phú Quốc, Tỉnh Kiên Giang","path_with_type":"Xã Thổ Châu, Thành phố Phú Quốc, Tỉnh Kiên Giang","code":"31105","parent_code":"911"},"31108":{"name":"Xã Hòn Tre","type":"xa","slug":"xa-hon-tre","name_with_type":"Xã Hòn Tre","path":"Xã Hòn Tre, Huyện Kiên Hải, Tỉnh Kiên Giang","path_with_type":"Xã Hòn Tre, Huyện Kiên Hải, Tỉnh Kiên Giang","code":"31108","parent_code":"912"},"31111":{"name":"Xã Lại Sơn","type":"xa","slug":"xa-lai-son","name_with_type":"Xã Lại Sơn","path":"Xã Lại Sơn, Huyện Kiên Hải, Tỉnh Kiên Giang","path_with_type":"Xã Lại Sơn, Huyện Kiên Hải, Tỉnh Kiên Giang","code":"31111","parent_code":"912"},"31114":{"name":"Xã An Sơn","type":"xa","slug":"xa-an-son","name_with_type":"Xã An Sơn","path":"Xã An Sơn, Huyện Kiên Hải, Tỉnh Kiên Giang","path_with_type":"Xã An Sơn, Huyện Kiên Hải, Tỉnh Kiên Giang","code":"31114","parent_code":"912"},"31115":{"name":"Xã Nam Du","type":"xa","slug":"xa-nam-du","name_with_type":"Xã Nam Du","path":"Xã Nam Du, Huyện Kiên Hải, Tỉnh Kiên Giang","path_with_type":"Xã Nam Du, Huyện Kiên Hải, Tỉnh Kiên Giang","code":"31115","parent_code":"912"},"31117":{"name":"Phường Cái Khế","type":"phuong","slug":"phuong-cai-khe","name_with_type":"Phường Cái Khế","path":"Phường Cái Khế, Quận Ninh Kiều, Thành phố Cần Thơ","path_with_type":"Phường Cái Khế, Quận Ninh Kiều, Thành phố Cần Thơ","code":"31117","parent_code":"916"},"31120":{"name":"Phường An Hòa","type":"phuong","slug":"phuong-an-hoa","name_with_type":"Phường An Hòa","path":"Phường An Hòa, Quận Ninh Kiều, Thành phố Cần Thơ","path_with_type":"Phường An Hòa, Quận Ninh Kiều, Thành phố Cần Thơ","code":"31120","parent_code":"916"},"31123":{"name":"Phường Thới Bình","type":"phuong","slug":"phuong-thoi-binh","name_with_type":"Phường Thới Bình","path":"Phường Thới Bình, Quận Ninh Kiều, Thành phố Cần Thơ","path_with_type":"Phường Thới Bình, Quận Ninh Kiều, Thành phố Cần Thơ","code":"31123","parent_code":"916"},"31135":{"name":"Phường Tân An","type":"phuong","slug":"phuong-tan-an","name_with_type":"Phường Tân An","path":"Phường Tân An, Quận Ninh Kiều, Thành phố Cần Thơ","path_with_type":"Phường Tân An, Quận Ninh Kiều, Thành phố Cần Thơ","code":"31135","parent_code":"916"},"31144":{"name":"Phường Xuân Khánh","type":"phuong","slug":"phuong-xuan-khanh","name_with_type":"Phường Xuân Khánh","path":"Phường Xuân Khánh, Quận Ninh Kiều, Thành phố Cần Thơ","path_with_type":"Phường Xuân Khánh, Quận Ninh Kiều, Thành phố Cần Thơ","code":"31144","parent_code":"916"},"31147":{"name":"Phường Hưng Lợi","type":"phuong","slug":"phuong-hung-loi","name_with_type":"Phường Hưng Lợi","path":"Phường Hưng Lợi, Quận Ninh Kiều, Thành phố Cần Thơ","path_with_type":"Phường Hưng Lợi, Quận Ninh Kiều, Thành phố Cần Thơ","code":"31147","parent_code":"916"},"31149":{"name":"Phường An Khánh","type":"phuong","slug":"phuong-an-khanh","name_with_type":"Phường An Khánh","path":"Phường An Khánh, Quận Ninh Kiều, Thành phố Cần Thơ","path_with_type":"Phường An Khánh, Quận Ninh Kiều, Thành phố Cần Thơ","code":"31149","parent_code":"916"},"31150":{"name":"Phường An Bình","type":"phuong","slug":"phuong-an-binh","name_with_type":"Phường An Bình","path":"Phường An Bình, Quận Ninh Kiều, Thành phố Cần Thơ","path_with_type":"Phường An Bình, Quận Ninh Kiều, Thành phố Cần Thơ","code":"31150","parent_code":"916"},"31153":{"name":"Phường Châu Văn Liêm","type":"phuong","slug":"phuong-chau-van-liem","name_with_type":"Phường Châu Văn Liêm","path":"Phường Châu Văn Liêm, Quận Ô Môn, Thành phố Cần Thơ","path_with_type":"Phường Châu Văn Liêm, Quận Ô Môn, Thành phố Cần Thơ","code":"31153","parent_code":"917"},"31154":{"name":"Phường Thới Hòa","type":"phuong","slug":"phuong-thoi-hoa","name_with_type":"Phường Thới Hòa","path":"Phường Thới Hòa, Quận Ô Môn, Thành phố Cần Thơ","path_with_type":"Phường Thới Hòa, Quận Ô Môn, Thành phố Cần Thơ","code":"31154","parent_code":"917"},"31156":{"name":"Phường Thới Long","type":"phuong","slug":"phuong-thoi-long","name_with_type":"Phường Thới Long","path":"Phường Thới Long, Quận Ô Môn, Thành phố Cần Thơ","path_with_type":"Phường Thới Long, Quận Ô Môn, Thành phố Cần Thơ","code":"31156","parent_code":"917"},"31157":{"name":"Phường Long Hưng","type":"phuong","slug":"phuong-long-hung","name_with_type":"Phường Long Hưng","path":"Phường Long Hưng, Quận Ô Môn, Thành phố Cần Thơ","path_with_type":"Phường Long Hưng, Quận Ô Môn, Thành phố Cần Thơ","code":"31157","parent_code":"917"},"31159":{"name":"Phường Thới An","type":"phuong","slug":"phuong-thoi-an","name_with_type":"Phường Thới An","path":"Phường Thới An, Quận Ô Môn, Thành phố Cần Thơ","path_with_type":"Phường Thới An, Quận Ô Môn, Thành phố Cần Thơ","code":"31159","parent_code":"917"},"31162":{"name":"Phường Phước Thới","type":"phuong","slug":"phuong-phuoc-thoi","name_with_type":"Phường Phước Thới","path":"Phường Phước Thới, Quận Ô Môn, Thành phố Cần Thơ","path_with_type":"Phường Phước Thới, Quận Ô Môn, Thành phố Cần Thơ","code":"31162","parent_code":"917"},"31165":{"name":"Phường Trường Lạc","type":"phuong","slug":"phuong-truong-lac","name_with_type":"Phường Trường Lạc","path":"Phường Trường Lạc, Quận Ô Môn, Thành phố Cần Thơ","path_with_type":"Phường Trường Lạc, Quận Ô Môn, Thành phố Cần Thơ","code":"31165","parent_code":"917"},"31168":{"name":"Phường Bình Thủy","type":"phuong","slug":"phuong-binh-thuy","name_with_type":"Phường Bình Thủy","path":"Phường Bình Thủy, Quận Bình Thuỷ, Thành phố Cần Thơ","path_with_type":"Phường Bình Thủy, Quận Bình Thuỷ, Thành phố Cần Thơ","code":"31168","parent_code":"918"},"31169":{"name":"Phường Trà An","type":"phuong","slug":"phuong-tra-an","name_with_type":"Phường Trà An","path":"Phường Trà An, Quận Bình Thuỷ, Thành phố Cần Thơ","path_with_type":"Phường Trà An, Quận Bình Thuỷ, Thành phố Cần Thơ","code":"31169","parent_code":"918"},"31171":{"name":"Phường Trà Nóc","type":"phuong","slug":"phuong-tra-noc","name_with_type":"Phường Trà Nóc","path":"Phường Trà Nóc, Quận Bình Thuỷ, Thành phố Cần Thơ","path_with_type":"Phường Trà Nóc, Quận Bình Thuỷ, Thành phố Cần Thơ","code":"31171","parent_code":"918"},"31174":{"name":"Phường Thới An Đông","type":"phuong","slug":"phuong-thoi-an-dong","name_with_type":"Phường Thới An Đông","path":"Phường Thới An Đông, Quận Bình Thuỷ, Thành phố Cần Thơ","path_with_type":"Phường Thới An Đông, Quận Bình Thuỷ, Thành phố Cần Thơ","code":"31174","parent_code":"918"},"31177":{"name":"Phường An Thới","type":"phuong","slug":"phuong-an-thoi","name_with_type":"Phường An Thới","path":"Phường An Thới, Quận Bình Thuỷ, Thành phố Cần Thơ","path_with_type":"Phường An Thới, Quận Bình Thuỷ, Thành phố Cần Thơ","code":"31177","parent_code":"918"},"31178":{"name":"Phường Bùi Hữu Nghĩa","type":"phuong","slug":"phuong-bui-huu-nghia","name_with_type":"Phường Bùi Hữu Nghĩa","path":"Phường Bùi Hữu Nghĩa, Quận Bình Thuỷ, Thành phố Cần Thơ","path_with_type":"Phường Bùi Hữu Nghĩa, Quận Bình Thuỷ, Thành phố Cần Thơ","code":"31178","parent_code":"918"},"31180":{"name":"Phường Long Hòa","type":"phuong","slug":"phuong-long-hoa","name_with_type":"Phường Long Hòa","path":"Phường Long Hòa, Quận Bình Thuỷ, Thành phố Cần Thơ","path_with_type":"Phường Long Hòa, Quận Bình Thuỷ, Thành phố Cần Thơ","code":"31180","parent_code":"918"},"31183":{"name":"Phường Long Tuyền","type":"phuong","slug":"phuong-long-tuyen","name_with_type":"Phường Long Tuyền","path":"Phường Long Tuyền, Quận Bình Thuỷ, Thành phố Cần Thơ","path_with_type":"Phường Long Tuyền, Quận Bình Thuỷ, Thành phố Cần Thơ","code":"31183","parent_code":"918"},"31186":{"name":"Phường Lê Bình","type":"phuong","slug":"phuong-le-binh","name_with_type":"Phường Lê Bình","path":"Phường Lê Bình, Quận Cái Răng, Thành phố Cần Thơ","path_with_type":"Phường Lê Bình, Quận Cái Răng, Thành phố Cần Thơ","code":"31186","parent_code":"919"},"31189":{"name":"Phường Hưng Phú","type":"phuong","slug":"phuong-hung-phu","name_with_type":"Phường Hưng Phú","path":"Phường Hưng Phú, Quận Cái Răng, Thành phố Cần Thơ","path_with_type":"Phường Hưng Phú, Quận Cái Răng, Thành phố Cần Thơ","code":"31189","parent_code":"919"},"31192":{"name":"Phường Hưng Thạnh","type":"phuong","slug":"phuong-hung-thanh","name_with_type":"Phường Hưng Thạnh","path":"Phường Hưng Thạnh, Quận Cái Răng, Thành phố Cần Thơ","path_with_type":"Phường Hưng Thạnh, Quận Cái Răng, Thành phố Cần Thơ","code":"31192","parent_code":"919"},"31195":{"name":"Phường Ba Láng","type":"phuong","slug":"phuong-ba-lang","name_with_type":"Phường Ba Láng","path":"Phường Ba Láng, Quận Cái Răng, Thành phố Cần Thơ","path_with_type":"Phường Ba Láng, Quận Cái Răng, Thành phố Cần Thơ","code":"31195","parent_code":"919"},"31198":{"name":"Phường Thường Thạnh","type":"phuong","slug":"phuong-thuong-thanh","name_with_type":"Phường Thường Thạnh","path":"Phường Thường Thạnh, Quận Cái Răng, Thành phố Cần Thơ","path_with_type":"Phường Thường Thạnh, Quận Cái Răng, Thành phố Cần Thơ","code":"31198","parent_code":"919"},"31201":{"name":"Phường Phú Thứ","type":"phuong","slug":"phuong-phu-thu","name_with_type":"Phường Phú Thứ","path":"Phường Phú Thứ, Quận Cái Răng, Thành phố Cần Thơ","path_with_type":"Phường Phú Thứ, Quận Cái Răng, Thành phố Cần Thơ","code":"31201","parent_code":"919"},"31204":{"name":"Phường Tân Phú","type":"phuong","slug":"phuong-tan-phu","name_with_type":"Phường Tân Phú","path":"Phường Tân Phú, Quận Cái Răng, Thành phố Cần Thơ","path_with_type":"Phường Tân Phú, Quận Cái Răng, Thành phố Cần Thơ","code":"31204","parent_code":"919"},"31207":{"name":"Phường Thốt Nốt","type":"phuong","slug":"phuong-thot-not","name_with_type":"Phường Thốt Nốt","path":"Phường Thốt Nốt, Quận Thốt Nốt, Thành phố Cần Thơ","path_with_type":"Phường Thốt Nốt, Quận Thốt Nốt, Thành phố Cần Thơ","code":"31207","parent_code":"923"},"31210":{"name":"Phường Thới Thuận","type":"phuong","slug":"phuong-thoi-thuan","name_with_type":"Phường Thới Thuận","path":"Phường Thới Thuận, Quận Thốt Nốt, Thành phố Cần Thơ","path_with_type":"Phường Thới Thuận, Quận Thốt Nốt, Thành phố Cần Thơ","code":"31210","parent_code":"923"},"31211":{"name":"Xã Vĩnh Bình","type":"xa","slug":"xa-vinh-binh","name_with_type":"Xã Vĩnh Bình","path":"Xã Vĩnh Bình, Huyện Vĩnh Thạnh, Thành phố Cần Thơ","path_with_type":"Xã Vĩnh Bình, Huyện Vĩnh Thạnh, Thành phố Cần Thơ","code":"31211","parent_code":"924"},"31212":{"name":"Phường Thuận An","type":"phuong","slug":"phuong-thuan-an","name_with_type":"Phường Thuận An","path":"Phường Thuận An, Quận Thốt Nốt, Thành phố Cần Thơ","path_with_type":"Phường Thuận An, Quận Thốt Nốt, Thành phố Cần Thơ","code":"31212","parent_code":"923"},"31213":{"name":"Phường Tân Lộc","type":"phuong","slug":"phuong-tan-loc","name_with_type":"Phường Tân Lộc","path":"Phường Tân Lộc, Quận Thốt Nốt, Thành phố Cần Thơ","path_with_type":"Phường Tân Lộc, Quận Thốt Nốt, Thành phố Cần Thơ","code":"31213","parent_code":"923"},"31216":{"name":"Phường Trung Nhứt","type":"phuong","slug":"phuong-trung-nhut","name_with_type":"Phường Trung Nhứt","path":"Phường Trung Nhứt, Quận Thốt Nốt, Thành phố Cần Thơ","path_with_type":"Phường Trung Nhứt, Quận Thốt Nốt, Thành phố Cần Thơ","code":"31216","parent_code":"923"},"31217":{"name":"Phường Thạnh Hoà","type":"phuong","slug":"phuong-thanh-hoa","name_with_type":"Phường Thạnh Hoà","path":"Phường Thạnh Hoà, Quận Thốt Nốt, Thành phố Cần Thơ","path_with_type":"Phường Thạnh Hoà, Quận Thốt Nốt, Thành phố Cần Thơ","code":"31217","parent_code":"923"},"31219":{"name":"Phường Trung Kiên","type":"phuong","slug":"phuong-trung-kien","name_with_type":"Phường Trung Kiên","path":"Phường Trung Kiên, Quận Thốt Nốt, Thành phố Cần Thơ","path_with_type":"Phường Trung Kiên, Quận Thốt Nốt, Thành phố Cần Thơ","code":"31219","parent_code":"923"},"31222":{"name":"Xã Trung An","type":"xa","slug":"xa-trung-an","name_with_type":"Xã Trung An","path":"Xã Trung An, Huyện Cờ Đỏ, Thành phố Cần Thơ","path_with_type":"Xã Trung An, Huyện Cờ Đỏ, Thành phố Cần Thơ","code":"31222","parent_code":"925"},"31225":{"name":"Xã Trung Thạnh","type":"xa","slug":"xa-trung-thanh","name_with_type":"Xã Trung Thạnh","path":"Xã Trung Thạnh, Huyện Cờ Đỏ, Thành phố Cần Thơ","path_with_type":"Xã Trung Thạnh, Huyện Cờ Đỏ, Thành phố Cần Thơ","code":"31225","parent_code":"925"},"31227":{"name":"Phường Tân Hưng","type":"phuong","slug":"phuong-tan-hung","name_with_type":"Phường Tân Hưng","path":"Phường Tân Hưng, Quận Thốt Nốt, Thành phố Cần Thơ","path_with_type":"Phường Tân Hưng, Quận Thốt Nốt, Thành phố Cần Thơ","code":"31227","parent_code":"923"},"31228":{"name":"Phường Thuận Hưng","type":"phuong","slug":"phuong-thuan-hung","name_with_type":"Phường Thuận Hưng","path":"Phường Thuận Hưng, Quận Thốt Nốt, Thành phố Cần Thơ","path_with_type":"Phường Thuận Hưng, Quận Thốt Nốt, Thành phố Cần Thơ","code":"31228","parent_code":"923"},"31231":{"name":"Thị trấn Thanh An","type":"thi-tran","slug":"thi-tran-thanh-an","name_with_type":"Thị trấn Thanh An","path":"Thị trấn Thanh An, Huyện Vĩnh Thạnh, Thành phố Cần Thơ","path_with_type":"Thị trấn Thanh An, Huyện Vĩnh Thạnh, Thành phố Cần Thơ","code":"31231","parent_code":"924"},"31232":{"name":"Thị trấn Vĩnh Thạnh","type":"thi-tran","slug":"thi-tran-vinh-thanh","name_with_type":"Thị trấn Vĩnh Thạnh","path":"Thị trấn Vĩnh Thạnh, Huyện Vĩnh Thạnh, Thành phố Cần Thơ","path_with_type":"Thị trấn Vĩnh Thạnh, Huyện Vĩnh Thạnh, Thành phố Cần Thơ","code":"31232","parent_code":"924"},"31234":{"name":"Xã Thạnh Mỹ","type":"xa","slug":"xa-thanh-my","name_with_type":"Xã Thạnh Mỹ","path":"Xã Thạnh Mỹ, Huyện Vĩnh Thạnh, Thành phố Cần Thơ","path_with_type":"Xã Thạnh Mỹ, Huyện Vĩnh Thạnh, Thành phố Cần Thơ","code":"31234","parent_code":"924"},"31237":{"name":"Xã Vĩnh Trinh","type":"xa","slug":"xa-vinh-trinh","name_with_type":"Xã Vĩnh Trinh","path":"Xã Vĩnh Trinh, Huyện Vĩnh Thạnh, Thành phố Cần Thơ","path_with_type":"Xã Vĩnh Trinh, Huyện Vĩnh Thạnh, Thành phố Cần Thơ","code":"31237","parent_code":"924"},"31240":{"name":"Xã Thạnh An","type":"xa","slug":"xa-thanh-an","name_with_type":"Xã Thạnh An","path":"Xã Thạnh An, Huyện Vĩnh Thạnh, Thành phố Cần Thơ","path_with_type":"Xã Thạnh An, Huyện Vĩnh Thạnh, Thành phố Cần Thơ","code":"31240","parent_code":"924"},"31241":{"name":"Xã Thạnh Tiến","type":"xa","slug":"xa-thanh-tien","name_with_type":"Xã Thạnh Tiến","path":"Xã Thạnh Tiến, Huyện Vĩnh Thạnh, Thành phố Cần Thơ","path_with_type":"Xã Thạnh Tiến, Huyện Vĩnh Thạnh, Thành phố Cần Thơ","code":"31241","parent_code":"924"},"31243":{"name":"Xã Thạnh Thắng","type":"xa","slug":"xa-thanh-thang","name_with_type":"Xã Thạnh Thắng","path":"Xã Thạnh Thắng, Huyện Vĩnh Thạnh, Thành phố Cần Thơ","path_with_type":"Xã Thạnh Thắng, Huyện Vĩnh Thạnh, Thành phố Cần Thơ","code":"31243","parent_code":"924"},"31244":{"name":"Xã Thạnh Lợi","type":"xa","slug":"xa-thanh-loi","name_with_type":"Xã Thạnh Lợi","path":"Xã Thạnh Lợi, Huyện Vĩnh Thạnh, Thành phố Cần Thơ","path_with_type":"Xã Thạnh Lợi, Huyện Vĩnh Thạnh, Thành phố Cần Thơ","code":"31244","parent_code":"924"},"31246":{"name":"Xã Thạnh Qưới","type":"xa","slug":"xa-thanh-quoi","name_with_type":"Xã Thạnh Qưới","path":"Xã Thạnh Qưới, Huyện Vĩnh Thạnh, Thành phố Cần Thơ","path_with_type":"Xã Thạnh Qưới, Huyện Vĩnh Thạnh, Thành phố Cần Thơ","code":"31246","parent_code":"924"},"31249":{"name":"Xã Thạnh Phú","type":"xa","slug":"xa-thanh-phu","name_with_type":"Xã Thạnh Phú","path":"Xã Thạnh Phú, Huyện Cờ Đỏ, Thành phố Cần Thơ","path_with_type":"Xã Thạnh Phú, Huyện Cờ Đỏ, Thành phố Cần Thơ","code":"31249","parent_code":"925"},"31252":{"name":"Xã Thạnh Lộc","type":"xa","slug":"xa-thanh-loc","name_with_type":"Xã Thạnh Lộc","path":"Xã Thạnh Lộc, Huyện Vĩnh Thạnh, Thành phố Cần Thơ","path_with_type":"Xã Thạnh Lộc, Huyện Vĩnh Thạnh, Thành phố Cần Thơ","code":"31252","parent_code":"924"},"31255":{"name":"Xã Trung Hưng","type":"xa","slug":"xa-trung-hung","name_with_type":"Xã Trung Hưng","path":"Xã Trung Hưng, Huyện Cờ Đỏ, Thành phố Cần Thơ","path_with_type":"Xã Trung Hưng, Huyện Cờ Đỏ, Thành phố Cần Thơ","code":"31255","parent_code":"925"},"31258":{"name":"Thị trấn Thới Lai","type":"thi-tran","slug":"thi-tran-thoi-lai","name_with_type":"Thị trấn Thới Lai","path":"Thị trấn Thới Lai, Huyện Thới Lai, Thành phố Cần Thơ","path_with_type":"Thị trấn Thới Lai, Huyện Thới Lai, Thành phố Cần Thơ","code":"31258","parent_code":"927"},"31261":{"name":"Thị trấn Cờ Đỏ","type":"thi-tran","slug":"thi-tran-co-do","name_with_type":"Thị trấn Cờ Đỏ","path":"Thị trấn Cờ Đỏ, Huyện Cờ Đỏ, Thành phố Cần Thơ","path_with_type":"Thị trấn Cờ Đỏ, Huyện Cờ Đỏ, Thành phố Cần Thơ","code":"31261","parent_code":"925"},"31264":{"name":"Xã Thới Hưng","type":"xa","slug":"xa-thoi-hung","name_with_type":"Xã Thới Hưng","path":"Xã Thới Hưng, Huyện Cờ Đỏ, Thành phố Cần Thơ","path_with_type":"Xã Thới Hưng, Huyện Cờ Đỏ, Thành phố Cần Thơ","code":"31264","parent_code":"925"},"31267":{"name":"Xã Thới Thạnh","type":"xa","slug":"xa-thoi-thanh","name_with_type":"Xã Thới Thạnh","path":"Xã Thới Thạnh, Huyện Thới Lai, Thành phố Cần Thơ","path_with_type":"Xã Thới Thạnh, Huyện Thới Lai, Thành phố Cần Thơ","code":"31267","parent_code":"927"},"31268":{"name":"Xã Tân Thạnh","type":"xa","slug":"xa-tan-thanh","name_with_type":"Xã Tân Thạnh","path":"Xã Tân Thạnh, Huyện Thới Lai, Thành phố Cần Thơ","path_with_type":"Xã Tân Thạnh, Huyện Thới Lai, Thành phố Cần Thơ","code":"31268","parent_code":"927"},"31270":{"name":"Xã Xuân Thắng","type":"xa","slug":"xa-xuan-thang","name_with_type":"Xã Xuân Thắng","path":"Xã Xuân Thắng, Huyện Thới Lai, Thành phố Cần Thơ","path_with_type":"Xã Xuân Thắng, Huyện Thới Lai, Thành phố Cần Thơ","code":"31270","parent_code":"927"},"31273":{"name":"Xã Đông Hiệp","type":"xa","slug":"xa-dong-hiep","name_with_type":"Xã Đông Hiệp","path":"Xã Đông Hiệp, Huyện Cờ Đỏ, Thành phố Cần Thơ","path_with_type":"Xã Đông Hiệp, Huyện Cờ Đỏ, Thành phố Cần Thơ","code":"31273","parent_code":"925"},"31274":{"name":"Xã Đông Thắng","type":"xa","slug":"xa-dong-thang","name_with_type":"Xã Đông Thắng","path":"Xã Đông Thắng, Huyện Cờ Đỏ, Thành phố Cần Thơ","path_with_type":"Xã Đông Thắng, Huyện Cờ Đỏ, Thành phố Cần Thơ","code":"31274","parent_code":"925"},"31276":{"name":"Xã Thới Đông","type":"xa","slug":"xa-thoi-dong","name_with_type":"Xã Thới Đông","path":"Xã Thới Đông, Huyện Cờ Đỏ, Thành phố Cần Thơ","path_with_type":"Xã Thới Đông, Huyện Cờ Đỏ, Thành phố Cần Thơ","code":"31276","parent_code":"925"},"31277":{"name":"Xã Thới Xuân","type":"xa","slug":"xa-thoi-xuan","name_with_type":"Xã Thới Xuân","path":"Xã Thới Xuân, Huyện Cờ Đỏ, Thành phố Cần Thơ","path_with_type":"Xã Thới Xuân, Huyện Cờ Đỏ, Thành phố Cần Thơ","code":"31277","parent_code":"925"},"31279":{"name":"Xã Đông Bình","type":"xa","slug":"xa-dong-binh","name_with_type":"Xã Đông Bình","path":"Xã Đông Bình, Huyện Thới Lai, Thành phố Cần Thơ","path_with_type":"Xã Đông Bình, Huyện Thới Lai, Thành phố Cần Thơ","code":"31279","parent_code":"927"},"31282":{"name":"Xã Đông Thuận","type":"xa","slug":"xa-dong-thuan","name_with_type":"Xã Đông Thuận","path":"Xã Đông Thuận, Huyện Thới Lai, Thành phố Cần Thơ","path_with_type":"Xã Đông Thuận, Huyện Thới Lai, Thành phố Cần Thơ","code":"31282","parent_code":"927"},"31285":{"name":"Xã Thới Tân","type":"xa","slug":"xa-thoi-tan","name_with_type":"Xã Thới Tân","path":"Xã Thới Tân, Huyện Thới Lai, Thành phố Cần Thơ","path_with_type":"Xã Thới Tân, Huyện Thới Lai, Thành phố Cần Thơ","code":"31285","parent_code":"927"},"31286":{"name":"Xã Trường Thắng","type":"xa","slug":"xa-truong-thang","name_with_type":"Xã Trường Thắng","path":"Xã Trường Thắng, Huyện Thới Lai, Thành phố Cần Thơ","path_with_type":"Xã Trường Thắng, Huyện Thới Lai, Thành phố Cần Thơ","code":"31286","parent_code":"927"},"31288":{"name":"Xã Định Môn","type":"xa","slug":"xa-dinh-mon","name_with_type":"Xã Định Môn","path":"Xã Định Môn, Huyện Thới Lai, Thành phố Cần Thơ","path_with_type":"Xã Định Môn, Huyện Thới Lai, Thành phố Cần Thơ","code":"31288","parent_code":"927"},"31291":{"name":"Xã Trường Thành","type":"xa","slug":"xa-truong-thanh","name_with_type":"Xã Trường Thành","path":"Xã Trường Thành, Huyện Thới Lai, Thành phố Cần Thơ","path_with_type":"Xã Trường Thành, Huyện Thới Lai, Thành phố Cần Thơ","code":"31291","parent_code":"927"},"31294":{"name":"Xã Trường Xuân","type":"xa","slug":"xa-truong-xuan","name_with_type":"Xã Trường Xuân","path":"Xã Trường Xuân, Huyện Thới Lai, Thành phố Cần Thơ","path_with_type":"Xã Trường Xuân, Huyện Thới Lai, Thành phố Cần Thơ","code":"31294","parent_code":"927"},"31297":{"name":"Xã Trường Xuân A","type":"xa","slug":"xa-truong-xuan-a","name_with_type":"Xã Trường Xuân A","path":"Xã Trường Xuân A, Huyện Thới Lai, Thành phố Cần Thơ","path_with_type":"Xã Trường Xuân A, Huyện Thới Lai, Thành phố Cần Thơ","code":"31297","parent_code":"927"},"31298":{"name":"Xã Trường Xuân B","type":"xa","slug":"xa-truong-xuan-b","name_with_type":"Xã Trường Xuân B","path":"Xã Trường Xuân B, Huyện Thới Lai, Thành phố Cần Thơ","path_with_type":"Xã Trường Xuân B, Huyện Thới Lai, Thành phố Cần Thơ","code":"31298","parent_code":"927"},"31299":{"name":"Thị trấn Phong Điền","type":"thi-tran","slug":"thi-tran-phong-dien","name_with_type":"Thị trấn Phong Điền","path":"Thị trấn Phong Điền, Huyện Phong Điền, Thành phố Cần Thơ","path_with_type":"Thị trấn Phong Điền, Huyện Phong Điền, Thành phố Cần Thơ","code":"31299","parent_code":"926"},"31300":{"name":"Xã Nhơn Ái","type":"xa","slug":"xa-nhon-ai","name_with_type":"Xã Nhơn Ái","path":"Xã Nhơn Ái, Huyện Phong Điền, Thành phố Cần Thơ","path_with_type":"Xã Nhơn Ái, Huyện Phong Điền, Thành phố Cần Thơ","code":"31300","parent_code":"926"},"31303":{"name":"Xã Giai Xuân","type":"xa","slug":"xa-giai-xuan","name_with_type":"Xã Giai Xuân","path":"Xã Giai Xuân, Huyện Phong Điền, Thành phố Cần Thơ","path_with_type":"Xã Giai Xuân, Huyện Phong Điền, Thành phố Cần Thơ","code":"31303","parent_code":"926"},"31306":{"name":"Xã Tân Thới","type":"xa","slug":"xa-tan-thoi","name_with_type":"Xã Tân Thới","path":"Xã Tân Thới, Huyện Phong Điền, Thành phố Cần Thơ","path_with_type":"Xã Tân Thới, Huyện Phong Điền, Thành phố Cần Thơ","code":"31306","parent_code":"926"},"31309":{"name":"Xã Trường Long","type":"xa","slug":"xa-truong-long","name_with_type":"Xã Trường Long","path":"Xã Trường Long, Huyện Phong Điền, Thành phố Cần Thơ","path_with_type":"Xã Trường Long, Huyện Phong Điền, Thành phố Cần Thơ","code":"31309","parent_code":"926"},"31312":{"name":"Xã Mỹ Khánh","type":"xa","slug":"xa-my-khanh","name_with_type":"Xã Mỹ Khánh","path":"Xã Mỹ Khánh, Huyện Phong Điền, Thành phố Cần Thơ","path_with_type":"Xã Mỹ Khánh, Huyện Phong Điền, Thành phố Cần Thơ","code":"31312","parent_code":"926"},"31315":{"name":"Xã Nhơn Nghĩa","type":"xa","slug":"xa-nhon-nghia","name_with_type":"Xã Nhơn Nghĩa","path":"Xã Nhơn Nghĩa, Huyện Phong Điền, Thành phố Cần Thơ","path_with_type":"Xã Nhơn Nghĩa, Huyện Phong Điền, Thành phố Cần Thơ","code":"31315","parent_code":"926"},"31318":{"name":"Phường I","type":"phuong","slug":"phuong-i","name_with_type":"Phường I","path":"Phường I, Thành phố Vị Thanh, Tỉnh Hậu Giang","path_with_type":"Phường I, Thành phố Vị Thanh, Tỉnh Hậu Giang","code":"31318","parent_code":"930"},"31321":{"name":"Phường III","type":"phuong","slug":"phuong-iii","name_with_type":"Phường III","path":"Phường III, Thành phố Vị Thanh, Tỉnh Hậu Giang","path_with_type":"Phường III, Thành phố Vị Thanh, Tỉnh Hậu Giang","code":"31321","parent_code":"930"},"31324":{"name":"Phường IV","type":"phuong","slug":"phuong-iv","name_with_type":"Phường IV","path":"Phường IV, Thành phố Vị Thanh, Tỉnh Hậu Giang","path_with_type":"Phường IV, Thành phố Vị Thanh, Tỉnh Hậu Giang","code":"31324","parent_code":"930"},"31327":{"name":"Phường V","type":"phuong","slug":"phuong-v","name_with_type":"Phường V","path":"Phường V, Thành phố Vị Thanh, Tỉnh Hậu Giang","path_with_type":"Phường V, Thành phố Vị Thanh, Tỉnh Hậu Giang","code":"31327","parent_code":"930"},"31330":{"name":"Phường VII","type":"phuong","slug":"phuong-vii","name_with_type":"Phường VII","path":"Phường VII, Thành phố Vị Thanh, Tỉnh Hậu Giang","path_with_type":"Phường VII, Thành phố Vị Thanh, Tỉnh Hậu Giang","code":"31330","parent_code":"930"},"31333":{"name":"Xã Vị Tân","type":"xa","slug":"xa-vi-tan","name_with_type":"Xã Vị Tân","path":"Xã Vị Tân, Thành phố Vị Thanh, Tỉnh Hậu Giang","path_with_type":"Xã Vị Tân, Thành phố Vị Thanh, Tỉnh Hậu Giang","code":"31333","parent_code":"930"},"31336":{"name":"Xã Hoả Lựu","type":"xa","slug":"xa-hoa-luu","name_with_type":"Xã Hoả Lựu","path":"Xã Hoả Lựu, Thành phố Vị Thanh, Tỉnh Hậu Giang","path_with_type":"Xã Hoả Lựu, Thành phố Vị Thanh, Tỉnh Hậu Giang","code":"31336","parent_code":"930"},"31338":{"name":"Xã Tân Tiến","type":"xa","slug":"xa-tan-tien","name_with_type":"Xã Tân Tiến","path":"Xã Tân Tiến, Thành phố Vị Thanh, Tỉnh Hậu Giang","path_with_type":"Xã Tân Tiến, Thành phố Vị Thanh, Tỉnh Hậu Giang","code":"31338","parent_code":"930"},"31339":{"name":"Xã Hoả Tiến","type":"xa","slug":"xa-hoa-tien","name_with_type":"Xã Hoả Tiến","path":"Xã Hoả Tiến, Thành phố Vị Thanh, Tỉnh Hậu Giang","path_with_type":"Xã Hoả Tiến, Thành phố Vị Thanh, Tỉnh Hậu Giang","code":"31339","parent_code":"930"},"31340":{"name":"Phường Ngã Bảy","type":"phuong","slug":"phuong-nga-bay","name_with_type":"Phường Ngã Bảy","path":"Phường Ngã Bảy, Thành phố Ngã Bảy, Tỉnh Hậu Giang","path_with_type":"Phường Ngã Bảy, Thành phố Ngã Bảy, Tỉnh Hậu Giang","code":"31340","parent_code":"931"},"31341":{"name":"Phường Lái Hiếu","type":"phuong","slug":"phuong-lai-hieu","name_with_type":"Phường Lái Hiếu","path":"Phường Lái Hiếu, Thành phố Ngã Bảy, Tỉnh Hậu Giang","path_with_type":"Phường Lái Hiếu, Thành phố Ngã Bảy, Tỉnh Hậu Giang","code":"31341","parent_code":"931"},"31342":{"name":"Thị trấn Một Ngàn","type":"thi-tran","slug":"thi-tran-mot-ngan","name_with_type":"Thị trấn Một Ngàn","path":"Thị trấn Một Ngàn, Huyện Châu Thành A, Tỉnh Hậu Giang","path_with_type":"Thị trấn Một Ngàn, Huyện Châu Thành A, Tỉnh Hậu Giang","code":"31342","parent_code":"932"},"31343":{"name":"Phường Hiệp Thành","type":"phuong","slug":"phuong-hiep-thanh","name_with_type":"Phường Hiệp Thành","path":"Phường Hiệp Thành, Thành phố Ngã Bảy, Tỉnh Hậu Giang","path_with_type":"Phường Hiệp Thành, Thành phố Ngã Bảy, Tỉnh Hậu Giang","code":"31343","parent_code":"931"},"31344":{"name":"Phường Hiệp Lợi","type":"phuong","slug":"phuong-hiep-loi","name_with_type":"Phường Hiệp Lợi","path":"Phường Hiệp Lợi, Thành phố Ngã Bảy, Tỉnh Hậu Giang","path_with_type":"Phường Hiệp Lợi, Thành phố Ngã Bảy, Tỉnh Hậu Giang","code":"31344","parent_code":"931"},"31345":{"name":"Xã Tân Hoà","type":"xa","slug":"xa-tan-hoa","name_with_type":"Xã Tân Hoà","path":"Xã Tân Hoà, Huyện Châu Thành A, Tỉnh Hậu Giang","path_with_type":"Xã Tân Hoà, Huyện Châu Thành A, Tỉnh Hậu Giang","code":"31345","parent_code":"932"},"31346":{"name":"Thị trấn Bảy Ngàn","type":"thi-tran","slug":"thi-tran-bay-ngan","name_with_type":"Thị trấn Bảy Ngàn","path":"Thị trấn Bảy Ngàn, Huyện Châu Thành A, Tỉnh Hậu Giang","path_with_type":"Thị trấn Bảy Ngàn, Huyện Châu Thành A, Tỉnh Hậu Giang","code":"31346","parent_code":"932"},"31348":{"name":"Xã Trường Long Tây","type":"xa","slug":"xa-truong-long-tay","name_with_type":"Xã Trường Long Tây","path":"Xã Trường Long Tây, Huyện Châu Thành A, Tỉnh Hậu Giang","path_with_type":"Xã Trường Long Tây, Huyện Châu Thành A, Tỉnh Hậu Giang","code":"31348","parent_code":"932"},"31351":{"name":"Xã Trường Long A","type":"xa","slug":"xa-truong-long-a","name_with_type":"Xã Trường Long A","path":"Xã Trường Long A, Huyện Châu Thành A, Tỉnh Hậu Giang","path_with_type":"Xã Trường Long A, Huyện Châu Thành A, Tỉnh Hậu Giang","code":"31351","parent_code":"932"},"31357":{"name":"Xã Nhơn Nghĩa A","type":"xa","slug":"xa-nhon-nghia-a","name_with_type":"Xã Nhơn Nghĩa A","path":"Xã Nhơn Nghĩa A, Huyện Châu Thành A, Tỉnh Hậu Giang","path_with_type":"Xã Nhơn Nghĩa A, Huyện Châu Thành A, Tỉnh Hậu Giang","code":"31357","parent_code":"932"},"31359":{"name":"Thị trấn Rạch Gòi","type":"thi-tran","slug":"thi-tran-rach-goi","name_with_type":"Thị trấn Rạch Gòi","path":"Thị trấn Rạch Gòi, Huyện Châu Thành A, Tỉnh Hậu Giang","path_with_type":"Thị trấn Rạch Gòi, Huyện Châu Thành A, Tỉnh Hậu Giang","code":"31359","parent_code":"932"},"31360":{"name":"Xã Thạnh Xuân","type":"xa","slug":"xa-thanh-xuan","name_with_type":"Xã Thạnh Xuân","path":"Xã Thạnh Xuân, Huyện Châu Thành A, Tỉnh Hậu Giang","path_with_type":"Xã Thạnh Xuân, Huyện Châu Thành A, Tỉnh Hậu Giang","code":"31360","parent_code":"932"},"31362":{"name":"Thị trấn Cái Tắc","type":"thi-tran","slug":"thi-tran-cai-tac","name_with_type":"Thị trấn Cái Tắc","path":"Thị trấn Cái Tắc, Huyện Châu Thành A, Tỉnh Hậu Giang","path_with_type":"Thị trấn Cái Tắc, Huyện Châu Thành A, Tỉnh Hậu Giang","code":"31362","parent_code":"932"},"31363":{"name":"Xã Tân Phú Thạnh","type":"xa","slug":"xa-tan-phu-thanh","name_with_type":"Xã Tân Phú Thạnh","path":"Xã Tân Phú Thạnh, Huyện Châu Thành A, Tỉnh Hậu Giang","path_with_type":"Xã Tân Phú Thạnh, Huyện Châu Thành A, Tỉnh Hậu Giang","code":"31363","parent_code":"932"},"31366":{"name":"Thị Trấn Ngã Sáu","type":"thi-tran","slug":"thi-tran-nga-sau","name_with_type":"Thị Trấn Ngã Sáu","path":"Thị Trấn Ngã Sáu, Huyện Châu Thành, Tỉnh Hậu Giang","path_with_type":"Thị Trấn Ngã Sáu, Huyện Châu Thành, Tỉnh Hậu Giang","code":"31366","parent_code":"933"},"31369":{"name":"Xã Đông Thạnh","type":"xa","slug":"xa-dong-thanh","name_with_type":"Xã Đông Thạnh","path":"Xã Đông Thạnh, Huyện Châu Thành, Tỉnh Hậu Giang","path_with_type":"Xã Đông Thạnh, Huyện Châu Thành, Tỉnh Hậu Giang","code":"31369","parent_code":"933"},"31375":{"name":"Xã Đông Phú","type":"xa","slug":"xa-dong-phu","name_with_type":"Xã Đông Phú","path":"Xã Đông Phú, Huyện Châu Thành, Tỉnh Hậu Giang","path_with_type":"Xã Đông Phú, Huyện Châu Thành, Tỉnh Hậu Giang","code":"31375","parent_code":"933"},"31378":{"name":"Xã Phú Hữu","type":"xa","slug":"xa-phu-huu","name_with_type":"Xã Phú Hữu","path":"Xã Phú Hữu, Huyện Châu Thành, Tỉnh Hậu Giang","path_with_type":"Xã Phú Hữu, Huyện Châu Thành, Tỉnh Hậu Giang","code":"31378","parent_code":"933"},"31379":{"name":"Xã Phú Tân","type":"xa","slug":"xa-phu-tan","name_with_type":"Xã Phú Tân","path":"Xã Phú Tân, Huyện Châu Thành, Tỉnh Hậu Giang","path_with_type":"Xã Phú Tân, Huyện Châu Thành, Tỉnh Hậu Giang","code":"31379","parent_code":"933"},"31381":{"name":"Thị trấn Mái Dầm","type":"thi-tran","slug":"thi-tran-mai-dam","name_with_type":"Thị trấn Mái Dầm","path":"Thị trấn Mái Dầm, Huyện Châu Thành, Tỉnh Hậu Giang","path_with_type":"Thị trấn Mái Dầm, Huyện Châu Thành, Tỉnh Hậu Giang","code":"31381","parent_code":"933"},"31384":{"name":"Xã Đông Phước","type":"xa","slug":"xa-dong-phuoc","name_with_type":"Xã Đông Phước","path":"Xã Đông Phước, Huyện Châu Thành, Tỉnh Hậu Giang","path_with_type":"Xã Đông Phước, Huyện Châu Thành, Tỉnh Hậu Giang","code":"31384","parent_code":"933"},"31387":{"name":"Xã Đông Phước A","type":"xa","slug":"xa-dong-phuoc-a","name_with_type":"Xã Đông Phước A","path":"Xã Đông Phước A, Huyện Châu Thành, Tỉnh Hậu Giang","path_with_type":"Xã Đông Phước A, Huyện Châu Thành, Tỉnh Hậu Giang","code":"31387","parent_code":"933"},"31393":{"name":"Thị trấn Kinh Cùng","type":"thi-tran","slug":"thi-tran-kinh-cung","name_with_type":"Thị trấn Kinh Cùng","path":"Thị trấn Kinh Cùng, Huyện Phụng Hiệp, Tỉnh Hậu Giang","path_with_type":"Thị trấn Kinh Cùng, Huyện Phụng Hiệp, Tỉnh Hậu Giang","code":"31393","parent_code":"934"},"31396":{"name":"Thị trấn Cây Dương","type":"thi-tran","slug":"thi-tran-cay-duong","name_with_type":"Thị trấn Cây Dương","path":"Thị trấn Cây Dương, Huyện Phụng Hiệp, Tỉnh Hậu Giang","path_with_type":"Thị trấn Cây Dương, Huyện Phụng Hiệp, Tỉnh Hậu Giang","code":"31396","parent_code":"934"},"31399":{"name":"Xã Tân Bình","type":"xa","slug":"xa-tan-binh","name_with_type":"Xã Tân Bình","path":"Xã Tân Bình, Huyện Phụng Hiệp, Tỉnh Hậu Giang","path_with_type":"Xã Tân Bình, Huyện Phụng Hiệp, Tỉnh Hậu Giang","code":"31399","parent_code":"934"},"31402":{"name":"Xã Bình Thành","type":"xa","slug":"xa-binh-thanh","name_with_type":"Xã Bình Thành","path":"Xã Bình Thành, Huyện Phụng Hiệp, Tỉnh Hậu Giang","path_with_type":"Xã Bình Thành, Huyện Phụng Hiệp, Tỉnh Hậu Giang","code":"31402","parent_code":"934"},"31405":{"name":"Xã Thạnh Hòa","type":"xa","slug":"xa-thanh-hoa","name_with_type":"Xã Thạnh Hòa","path":"Xã Thạnh Hòa, Huyện Phụng Hiệp, Tỉnh Hậu Giang","path_with_type":"Xã Thạnh Hòa, Huyện Phụng Hiệp, Tỉnh Hậu Giang","code":"31405","parent_code":"934"},"31408":{"name":"Xã Long Thạnh","type":"xa","slug":"xa-long-thanh","name_with_type":"Xã Long Thạnh","path":"Xã Long Thạnh, Huyện Phụng Hiệp, Tỉnh Hậu Giang","path_with_type":"Xã Long Thạnh, Huyện Phụng Hiệp, Tỉnh Hậu Giang","code":"31408","parent_code":"934"},"31411":{"name":"Xã Đại Thành","type":"xa","slug":"xa-dai-thanh","name_with_type":"Xã Đại Thành","path":"Xã Đại Thành, Thành phố Ngã Bảy, Tỉnh Hậu Giang","path_with_type":"Xã Đại Thành, Thành phố Ngã Bảy, Tỉnh Hậu Giang","code":"31411","parent_code":"931"},"31414":{"name":"Xã Tân Thành","type":"xa","slug":"xa-tan-thanh","name_with_type":"Xã Tân Thành","path":"Xã Tân Thành, Thành phố Ngã Bảy, Tỉnh Hậu Giang","path_with_type":"Xã Tân Thành, Thành phố Ngã Bảy, Tỉnh Hậu Giang","code":"31414","parent_code":"931"},"31417":{"name":"Xã Phụng Hiệp","type":"xa","slug":"xa-phung-hiep","name_with_type":"Xã Phụng Hiệp","path":"Xã Phụng Hiệp, Huyện Phụng Hiệp, Tỉnh Hậu Giang","path_with_type":"Xã Phụng Hiệp, Huyện Phụng Hiệp, Tỉnh Hậu Giang","code":"31417","parent_code":"934"},"31420":{"name":"Xã Hòa Mỹ","type":"xa","slug":"xa-hoa-my","name_with_type":"Xã Hòa Mỹ","path":"Xã Hòa Mỹ, Huyện Phụng Hiệp, Tỉnh Hậu Giang","path_with_type":"Xã Hòa Mỹ, Huyện Phụng Hiệp, Tỉnh Hậu Giang","code":"31420","parent_code":"934"},"31423":{"name":"Xã Hòa An","type":"xa","slug":"xa-hoa-an","name_with_type":"Xã Hòa An","path":"Xã Hòa An, Huyện Phụng Hiệp, Tỉnh Hậu Giang","path_with_type":"Xã Hòa An, Huyện Phụng Hiệp, Tỉnh Hậu Giang","code":"31423","parent_code":"934"},"31426":{"name":"Xã Phương Bình","type":"xa","slug":"xa-phuong-binh","name_with_type":"Xã Phương Bình","path":"Xã Phương Bình, Huyện Phụng Hiệp, Tỉnh Hậu Giang","path_with_type":"Xã Phương Bình, Huyện Phụng Hiệp, Tỉnh Hậu Giang","code":"31426","parent_code":"934"},"31429":{"name":"Xã Hiệp Hưng","type":"xa","slug":"xa-hiep-hung","name_with_type":"Xã Hiệp Hưng","path":"Xã Hiệp Hưng, Huyện Phụng Hiệp, Tỉnh Hậu Giang","path_with_type":"Xã Hiệp Hưng, Huyện Phụng Hiệp, Tỉnh Hậu Giang","code":"31429","parent_code":"934"},"31432":{"name":"Xã Tân Phước Hưng","type":"xa","slug":"xa-tan-phuoc-hung","name_with_type":"Xã Tân Phước Hưng","path":"Xã Tân Phước Hưng, Huyện Phụng Hiệp, Tỉnh Hậu Giang","path_with_type":"Xã Tân Phước Hưng, Huyện Phụng Hiệp, Tỉnh Hậu Giang","code":"31432","parent_code":"934"},"31433":{"name":"Thị trấn Búng Tàu","type":"thi-tran","slug":"thi-tran-bung-tau","name_with_type":"Thị trấn Búng Tàu","path":"Thị trấn Búng Tàu, Huyện Phụng Hiệp, Tỉnh Hậu Giang","path_with_type":"Thị trấn Búng Tàu, Huyện Phụng Hiệp, Tỉnh Hậu Giang","code":"31433","parent_code":"934"},"31435":{"name":"Xã Phương Phú","type":"xa","slug":"xa-phuong-phu","name_with_type":"Xã Phương Phú","path":"Xã Phương Phú, Huyện Phụng Hiệp, Tỉnh Hậu Giang","path_with_type":"Xã Phương Phú, Huyện Phụng Hiệp, Tỉnh Hậu Giang","code":"31435","parent_code":"934"},"31438":{"name":"Xã Tân Long","type":"xa","slug":"xa-tan-long","name_with_type":"Xã Tân Long","path":"Xã Tân Long, Huyện Phụng Hiệp, Tỉnh Hậu Giang","path_with_type":"Xã Tân Long, Huyện Phụng Hiệp, Tỉnh Hậu Giang","code":"31438","parent_code":"934"},"31441":{"name":"Thị trấn Nàng Mau","type":"thi-tran","slug":"thi-tran-nang-mau","name_with_type":"Thị trấn Nàng Mau","path":"Thị trấn Nàng Mau, Huyện Vị Thuỷ, Tỉnh Hậu Giang","path_with_type":"Thị trấn Nàng Mau, Huyện Vị Thuỷ, Tỉnh Hậu Giang","code":"31441","parent_code":"935"},"31444":{"name":"Xã Vị Trung","type":"xa","slug":"xa-vi-trung","name_with_type":"Xã Vị Trung","path":"Xã Vị Trung, Huyện Vị Thuỷ, Tỉnh Hậu Giang","path_with_type":"Xã Vị Trung, Huyện Vị Thuỷ, Tỉnh Hậu Giang","code":"31444","parent_code":"935"},"31447":{"name":"Xã Vị Thuỷ","type":"xa","slug":"xa-vi-thuy","name_with_type":"Xã Vị Thuỷ","path":"Xã Vị Thuỷ, Huyện Vị Thuỷ, Tỉnh Hậu Giang","path_with_type":"Xã Vị Thuỷ, Huyện Vị Thuỷ, Tỉnh Hậu Giang","code":"31447","parent_code":"935"},"31450":{"name":"Xã Vị Thắng","type":"xa","slug":"xa-vi-thang","name_with_type":"Xã Vị Thắng","path":"Xã Vị Thắng, Huyện Vị Thuỷ, Tỉnh Hậu Giang","path_with_type":"Xã Vị Thắng, Huyện Vị Thuỷ, Tỉnh Hậu Giang","code":"31450","parent_code":"935"},"31453":{"name":"Xã Vĩnh Thuận Tây","type":"xa","slug":"xa-vinh-thuan-tay","name_with_type":"Xã Vĩnh Thuận Tây","path":"Xã Vĩnh Thuận Tây, Huyện Vị Thuỷ, Tỉnh Hậu Giang","path_with_type":"Xã Vĩnh Thuận Tây, Huyện Vị Thuỷ, Tỉnh Hậu Giang","code":"31453","parent_code":"935"},"31456":{"name":"Xã Vĩnh Trung","type":"xa","slug":"xa-vinh-trung","name_with_type":"Xã Vĩnh Trung","path":"Xã Vĩnh Trung, Huyện Vị Thuỷ, Tỉnh Hậu Giang","path_with_type":"Xã Vĩnh Trung, Huyện Vị Thuỷ, Tỉnh Hậu Giang","code":"31456","parent_code":"935"},"31459":{"name":"Xã Vĩnh Tường","type":"xa","slug":"xa-vinh-tuong","name_with_type":"Xã Vĩnh Tường","path":"Xã Vĩnh Tường, Huyện Vị Thuỷ, Tỉnh Hậu Giang","path_with_type":"Xã Vĩnh Tường, Huyện Vị Thuỷ, Tỉnh Hậu Giang","code":"31459","parent_code":"935"},"31462":{"name":"Xã Vị Đông","type":"xa","slug":"xa-vi-dong","name_with_type":"Xã Vị Đông","path":"Xã Vị Đông, Huyện Vị Thuỷ, Tỉnh Hậu Giang","path_with_type":"Xã Vị Đông, Huyện Vị Thuỷ, Tỉnh Hậu Giang","code":"31462","parent_code":"935"},"31465":{"name":"Xã Vị Thanh","type":"xa","slug":"xa-vi-thanh","name_with_type":"Xã Vị Thanh","path":"Xã Vị Thanh, Huyện Vị Thuỷ, Tỉnh Hậu Giang","path_with_type":"Xã Vị Thanh, Huyện Vị Thuỷ, Tỉnh Hậu Giang","code":"31465","parent_code":"935"},"31468":{"name":"Xã Vị Bình","type":"xa","slug":"xa-vi-binh","name_with_type":"Xã Vị Bình","path":"Xã Vị Bình, Huyện Vị Thuỷ, Tỉnh Hậu Giang","path_with_type":"Xã Vị Bình, Huyện Vị Thuỷ, Tỉnh Hậu Giang","code":"31468","parent_code":"935"},"31471":{"name":"Phường Thuận An","type":"phuong","slug":"phuong-thuan-an","name_with_type":"Phường Thuận An","path":"Phường Thuận An, Thị xã Long Mỹ, Tỉnh Hậu Giang","path_with_type":"Phường Thuận An, Thị xã Long Mỹ, Tỉnh Hậu Giang","code":"31471","parent_code":"937"},"31472":{"name":"Phường Trà Lồng","type":"phuong","slug":"phuong-tra-long","name_with_type":"Phường Trà Lồng","path":"Phường Trà Lồng, Thị xã Long Mỹ, Tỉnh Hậu Giang","path_with_type":"Phường Trà Lồng, Thị xã Long Mỹ, Tỉnh Hậu Giang","code":"31472","parent_code":"937"},"31473":{"name":"Phường Bình Thạnh","type":"phuong","slug":"phuong-binh-thanh","name_with_type":"Phường Bình Thạnh","path":"Phường Bình Thạnh, Thị xã Long Mỹ, Tỉnh Hậu Giang","path_with_type":"Phường Bình Thạnh, Thị xã Long Mỹ, Tỉnh Hậu Giang","code":"31473","parent_code":"937"},"31474":{"name":"Xã Long Bình","type":"xa","slug":"xa-long-binh","name_with_type":"Xã Long Bình","path":"Xã Long Bình, Thị xã Long Mỹ, Tỉnh Hậu Giang","path_with_type":"Xã Long Bình, Thị xã Long Mỹ, Tỉnh Hậu Giang","code":"31474","parent_code":"937"},"31475":{"name":"Phường Vĩnh Tường","type":"phuong","slug":"phuong-vinh-tuong","name_with_type":"Phường Vĩnh Tường","path":"Phường Vĩnh Tường, Thị xã Long Mỹ, Tỉnh Hậu Giang","path_with_type":"Phường Vĩnh Tường, Thị xã Long Mỹ, Tỉnh Hậu Giang","code":"31475","parent_code":"937"},"31477":{"name":"Xã Long Trị","type":"xa","slug":"xa-long-tri","name_with_type":"Xã Long Trị","path":"Xã Long Trị, Thị xã Long Mỹ, Tỉnh Hậu Giang","path_with_type":"Xã Long Trị, Thị xã Long Mỹ, Tỉnh Hậu Giang","code":"31477","parent_code":"937"},"31478":{"name":"Xã Long Trị A","type":"xa","slug":"xa-long-tri-a","name_with_type":"Xã Long Trị A","path":"Xã Long Trị A, Thị xã Long Mỹ, Tỉnh Hậu Giang","path_with_type":"Xã Long Trị A, Thị xã Long Mỹ, Tỉnh Hậu Giang","code":"31478","parent_code":"937"},"31480":{"name":"Xã Long Phú","type":"xa","slug":"xa-long-phu","name_with_type":"Xã Long Phú","path":"Xã Long Phú, Thị xã Long Mỹ, Tỉnh Hậu Giang","path_with_type":"Xã Long Phú, Thị xã Long Mỹ, Tỉnh Hậu Giang","code":"31480","parent_code":"937"},"31481":{"name":"Xã Tân Phú","type":"xa","slug":"xa-tan-phu","name_with_type":"Xã Tân Phú","path":"Xã Tân Phú, Thị xã Long Mỹ, Tỉnh Hậu Giang","path_with_type":"Xã Tân Phú, Thị xã Long Mỹ, Tỉnh Hậu Giang","code":"31481","parent_code":"937"},"31483":{"name":"Xã Thuận Hưng","type":"xa","slug":"xa-thuan-hung","name_with_type":"Xã Thuận Hưng","path":"Xã Thuận Hưng, Huyện Long Mỹ, Tỉnh Hậu Giang","path_with_type":"Xã Thuận Hưng, Huyện Long Mỹ, Tỉnh Hậu Giang","code":"31483","parent_code":"936"},"31484":{"name":"Xã Thuận Hòa","type":"xa","slug":"xa-thuan-hoa","name_with_type":"Xã Thuận Hòa","path":"Xã Thuận Hòa, Huyện Long Mỹ, Tỉnh Hậu Giang","path_with_type":"Xã Thuận Hòa, Huyện Long Mỹ, Tỉnh Hậu Giang","code":"31484","parent_code":"936"},"31486":{"name":"Xã Vĩnh Thuận Đông","type":"xa","slug":"xa-vinh-thuan-dong","name_with_type":"Xã Vĩnh Thuận Đông","path":"Xã Vĩnh Thuận Đông, Huyện Long Mỹ, Tỉnh Hậu Giang","path_with_type":"Xã Vĩnh Thuận Đông, Huyện Long Mỹ, Tỉnh Hậu Giang","code":"31486","parent_code":"936"},"31489":{"name":"Thị trấn Vĩnh Viễn","type":"thi-tran","slug":"thi-tran-vinh-vien","name_with_type":"Thị trấn Vĩnh Viễn","path":"Thị trấn Vĩnh Viễn, Huyện Long Mỹ, Tỉnh Hậu Giang","path_with_type":"Thị trấn Vĩnh Viễn, Huyện Long Mỹ, Tỉnh Hậu Giang","code":"31489","parent_code":"936"},"31490":{"name":"Xã Vĩnh Viễn A","type":"xa","slug":"xa-vinh-vien-a","name_with_type":"Xã Vĩnh Viễn A","path":"Xã Vĩnh Viễn A, Huyện Long Mỹ, Tỉnh Hậu Giang","path_with_type":"Xã Vĩnh Viễn A, Huyện Long Mỹ, Tỉnh Hậu Giang","code":"31490","parent_code":"936"},"31492":{"name":"Xã Lương Tâm","type":"xa","slug":"xa-luong-tam","name_with_type":"Xã Lương Tâm","path":"Xã Lương Tâm, Huyện Long Mỹ, Tỉnh Hậu Giang","path_with_type":"Xã Lương Tâm, Huyện Long Mỹ, Tỉnh Hậu Giang","code":"31492","parent_code":"936"},"31493":{"name":"Xã Lương Nghĩa","type":"xa","slug":"xa-luong-nghia","name_with_type":"Xã Lương Nghĩa","path":"Xã Lương Nghĩa, Huyện Long Mỹ, Tỉnh Hậu Giang","path_with_type":"Xã Lương Nghĩa, Huyện Long Mỹ, Tỉnh Hậu Giang","code":"31493","parent_code":"936"},"31495":{"name":"Xã Xà Phiên","type":"xa","slug":"xa-xa-phien","name_with_type":"Xã Xà Phiên","path":"Xã Xà Phiên, Huyện Long Mỹ, Tỉnh Hậu Giang","path_with_type":"Xã Xà Phiên, Huyện Long Mỹ, Tỉnh Hậu Giang","code":"31495","parent_code":"936"},"31498":{"name":"Phường 5","type":"phuong","slug":"phuong-5","name_with_type":"Phường 5","path":"Phường 5, Thành phố Sóc Trăng, Tỉnh Sóc Trăng","path_with_type":"Phường 5, Thành phố Sóc Trăng, Tỉnh Sóc Trăng","code":"31498","parent_code":"941"},"31501":{"name":"Phường 7","type":"phuong","slug":"phuong-7","name_with_type":"Phường 7","path":"Phường 7, Thành phố Sóc Trăng, Tỉnh Sóc Trăng","path_with_type":"Phường 7, Thành phố Sóc Trăng, Tỉnh Sóc Trăng","code":"31501","parent_code":"941"},"31504":{"name":"Phường 8","type":"phuong","slug":"phuong-8","name_with_type":"Phường 8","path":"Phường 8, Thành phố Sóc Trăng, Tỉnh Sóc Trăng","path_with_type":"Phường 8, Thành phố Sóc Trăng, Tỉnh Sóc Trăng","code":"31504","parent_code":"941"},"31507":{"name":"Phường 6","type":"phuong","slug":"phuong-6","name_with_type":"Phường 6","path":"Phường 6, Thành phố Sóc Trăng, Tỉnh Sóc Trăng","path_with_type":"Phường 6, Thành phố Sóc Trăng, Tỉnh Sóc Trăng","code":"31507","parent_code":"941"},"31510":{"name":"Phường 2","type":"phuong","slug":"phuong-2","name_with_type":"Phường 2","path":"Phường 2, Thành phố Sóc Trăng, Tỉnh Sóc Trăng","path_with_type":"Phường 2, Thành phố Sóc Trăng, Tỉnh Sóc Trăng","code":"31510","parent_code":"941"},"31516":{"name":"Phường 4","type":"phuong","slug":"phuong-4","name_with_type":"Phường 4","path":"Phường 4, Thành phố Sóc Trăng, Tỉnh Sóc Trăng","path_with_type":"Phường 4, Thành phố Sóc Trăng, Tỉnh Sóc Trăng","code":"31516","parent_code":"941"},"31519":{"name":"Phường 3","type":"phuong","slug":"phuong-3","name_with_type":"Phường 3","path":"Phường 3, Thành phố Sóc Trăng, Tỉnh Sóc Trăng","path_with_type":"Phường 3, Thành phố Sóc Trăng, Tỉnh Sóc Trăng","code":"31519","parent_code":"941"},"31522":{"name":"Phường 1","type":"phuong","slug":"phuong-1","name_with_type":"Phường 1","path":"Phường 1, Thành phố Sóc Trăng, Tỉnh Sóc Trăng","path_with_type":"Phường 1, Thành phố Sóc Trăng, Tỉnh Sóc Trăng","code":"31522","parent_code":"941"},"31525":{"name":"Phường 10","type":"phuong","slug":"phuong-10","name_with_type":"Phường 10","path":"Phường 10, Thành phố Sóc Trăng, Tỉnh Sóc Trăng","path_with_type":"Phường 10, Thành phố Sóc Trăng, Tỉnh Sóc Trăng","code":"31525","parent_code":"941"},"31528":{"name":"Thị trấn Kế Sách","type":"thi-tran","slug":"thi-tran-ke-sach","name_with_type":"Thị trấn Kế Sách","path":"Thị trấn Kế Sách, Huyện Kế Sách, Tỉnh Sóc Trăng","path_with_type":"Thị trấn Kế Sách, Huyện Kế Sách, Tỉnh Sóc Trăng","code":"31528","parent_code":"943"},"31531":{"name":"Thị trấn An Lạc Thôn","type":"thi-tran","slug":"thi-tran-an-lac-thon","name_with_type":"Thị trấn An Lạc Thôn","path":"Thị trấn An Lạc Thôn, Huyện Kế Sách, Tỉnh Sóc Trăng","path_with_type":"Thị trấn An Lạc Thôn, Huyện Kế Sách, Tỉnh Sóc Trăng","code":"31531","parent_code":"943"},"31534":{"name":"Xã Xuân Hòa","type":"xa","slug":"xa-xuan-hoa","name_with_type":"Xã Xuân Hòa","path":"Xã Xuân Hòa, Huyện Kế Sách, Tỉnh Sóc Trăng","path_with_type":"Xã Xuân Hòa, Huyện Kế Sách, Tỉnh Sóc Trăng","code":"31534","parent_code":"943"},"31537":{"name":"Xã Phong Nẫm","type":"xa","slug":"xa-phong-nam","name_with_type":"Xã Phong Nẫm","path":"Xã Phong Nẫm, Huyện Kế Sách, Tỉnh Sóc Trăng","path_with_type":"Xã Phong Nẫm, Huyện Kế Sách, Tỉnh Sóc Trăng","code":"31537","parent_code":"943"},"31540":{"name":"Xã An Lạc Tây","type":"xa","slug":"xa-an-lac-tay","name_with_type":"Xã An Lạc Tây","path":"Xã An Lạc Tây, Huyện Kế Sách, Tỉnh Sóc Trăng","path_with_type":"Xã An Lạc Tây, Huyện Kế Sách, Tỉnh Sóc Trăng","code":"31540","parent_code":"943"},"31543":{"name":"Xã Trinh Phú","type":"xa","slug":"xa-trinh-phu","name_with_type":"Xã Trinh Phú","path":"Xã Trinh Phú, Huyện Kế Sách, Tỉnh Sóc Trăng","path_with_type":"Xã Trinh Phú, Huyện Kế Sách, Tỉnh Sóc Trăng","code":"31543","parent_code":"943"},"31546":{"name":"Xã Ba Trinh","type":"xa","slug":"xa-ba-trinh","name_with_type":"Xã Ba Trinh","path":"Xã Ba Trinh, Huyện Kế Sách, Tỉnh Sóc Trăng","path_with_type":"Xã Ba Trinh, Huyện Kế Sách, Tỉnh Sóc Trăng","code":"31546","parent_code":"943"},"31549":{"name":"Xã Thới An Hội","type":"xa","slug":"xa-thoi-an-hoi","name_with_type":"Xã Thới An Hội","path":"Xã Thới An Hội, Huyện Kế Sách, Tỉnh Sóc Trăng","path_with_type":"Xã Thới An Hội, Huyện Kế Sách, Tỉnh Sóc Trăng","code":"31549","parent_code":"943"},"31552":{"name":"Xã Nhơn Mỹ","type":"xa","slug":"xa-nhon-my","name_with_type":"Xã Nhơn Mỹ","path":"Xã Nhơn Mỹ, Huyện Kế Sách, Tỉnh Sóc Trăng","path_with_type":"Xã Nhơn Mỹ, Huyện Kế Sách, Tỉnh Sóc Trăng","code":"31552","parent_code":"943"},"31555":{"name":"Xã Kế Thành","type":"xa","slug":"xa-ke-thanh","name_with_type":"Xã Kế Thành","path":"Xã Kế Thành, Huyện Kế Sách, Tỉnh Sóc Trăng","path_with_type":"Xã Kế Thành, Huyện Kế Sách, Tỉnh Sóc Trăng","code":"31555","parent_code":"943"},"31558":{"name":"Xã Kế An","type":"xa","slug":"xa-ke-an","name_with_type":"Xã Kế An","path":"Xã Kế An, Huyện Kế Sách, Tỉnh Sóc Trăng","path_with_type":"Xã Kế An, Huyện Kế Sách, Tỉnh Sóc Trăng","code":"31558","parent_code":"943"},"31561":{"name":"Xã Đại Hải","type":"xa","slug":"xa-dai-hai","name_with_type":"Xã Đại Hải","path":"Xã Đại Hải, Huyện Kế Sách, Tỉnh Sóc Trăng","path_with_type":"Xã Đại Hải, Huyện Kế Sách, Tỉnh Sóc Trăng","code":"31561","parent_code":"943"},"31564":{"name":"Xã An Mỹ","type":"xa","slug":"xa-an-my","name_with_type":"Xã An Mỹ","path":"Xã An Mỹ, Huyện Kế Sách, Tỉnh Sóc Trăng","path_with_type":"Xã An Mỹ, Huyện Kế Sách, Tỉnh Sóc Trăng","code":"31564","parent_code":"943"},"31567":{"name":"Thị trấn Huỳnh Hữu Nghĩa","type":"thi-tran","slug":"thi-tran-huynh-huu-nghia","name_with_type":"Thị trấn Huỳnh Hữu Nghĩa","path":"Thị trấn Huỳnh Hữu Nghĩa, Huyện Mỹ Tú, Tỉnh Sóc Trăng","path_with_type":"Thị trấn Huỳnh Hữu Nghĩa, Huyện Mỹ Tú, Tỉnh Sóc Trăng","code":"31567","parent_code":"944"},"31569":{"name":"Thị trấn Châu Thành","type":"thi-tran","slug":"thi-tran-chau-thanh","name_with_type":"Thị trấn Châu Thành","path":"Thị trấn Châu Thành, Huyện Châu Thành, Tỉnh Sóc Trăng","path_with_type":"Thị trấn Châu Thành, Huyện Châu Thành, Tỉnh Sóc Trăng","code":"31569","parent_code":"942"},"31570":{"name":"Xã Hồ Đắc Kiện","type":"xa","slug":"xa-ho-dac-kien","name_with_type":"Xã Hồ Đắc Kiện","path":"Xã Hồ Đắc Kiện, Huyện Châu Thành, Tỉnh Sóc Trăng","path_with_type":"Xã Hồ Đắc Kiện, Huyện Châu Thành, Tỉnh Sóc Trăng","code":"31570","parent_code":"942"},"31573":{"name":"Xã Phú Tâm","type":"xa","slug":"xa-phu-tam","name_with_type":"Xã Phú Tâm","path":"Xã Phú Tâm, Huyện Châu Thành, Tỉnh Sóc Trăng","path_with_type":"Xã Phú Tâm, Huyện Châu Thành, Tỉnh Sóc Trăng","code":"31573","parent_code":"942"},"31576":{"name":"Xã Thuận Hòa","type":"xa","slug":"xa-thuan-hoa","name_with_type":"Xã Thuận Hòa","path":"Xã Thuận Hòa, Huyện Châu Thành, Tỉnh Sóc Trăng","path_with_type":"Xã Thuận Hòa, Huyện Châu Thành, Tỉnh Sóc Trăng","code":"31576","parent_code":"942"},"31579":{"name":"Xã Long Hưng","type":"xa","slug":"xa-long-hung","name_with_type":"Xã Long Hưng","path":"Xã Long Hưng, Huyện Mỹ Tú, Tỉnh Sóc Trăng","path_with_type":"Xã Long Hưng, Huyện Mỹ Tú, Tỉnh Sóc Trăng","code":"31579","parent_code":"944"},"31582":{"name":"Xã Phú Tân","type":"xa","slug":"xa-phu-tan","name_with_type":"Xã Phú Tân","path":"Xã Phú Tân, Huyện Châu Thành, Tỉnh Sóc Trăng","path_with_type":"Xã Phú Tân, Huyện Châu Thành, Tỉnh Sóc Trăng","code":"31582","parent_code":"942"},"31585":{"name":"Xã Thiện Mỹ","type":"xa","slug":"xa-thien-my","name_with_type":"Xã Thiện Mỹ","path":"Xã Thiện Mỹ, Huyện Châu Thành, Tỉnh Sóc Trăng","path_with_type":"Xã Thiện Mỹ, Huyện Châu Thành, Tỉnh Sóc Trăng","code":"31585","parent_code":"942"},"31588":{"name":"Xã Hưng Phú","type":"xa","slug":"xa-hung-phu","name_with_type":"Xã Hưng Phú","path":"Xã Hưng Phú, Huyện Mỹ Tú, Tỉnh Sóc Trăng","path_with_type":"Xã Hưng Phú, Huyện Mỹ Tú, Tỉnh Sóc Trăng","code":"31588","parent_code":"944"},"31591":{"name":"Xã Mỹ Hương","type":"xa","slug":"xa-my-huong","name_with_type":"Xã Mỹ Hương","path":"Xã Mỹ Hương, Huyện Mỹ Tú, Tỉnh Sóc Trăng","path_with_type":"Xã Mỹ Hương, Huyện Mỹ Tú, Tỉnh Sóc Trăng","code":"31591","parent_code":"944"},"31594":{"name":"Xã An Hiệp","type":"xa","slug":"xa-an-hiep","name_with_type":"Xã An Hiệp","path":"Xã An Hiệp, Huyện Châu Thành, Tỉnh Sóc Trăng","path_with_type":"Xã An Hiệp, Huyện Châu Thành, Tỉnh Sóc Trăng","code":"31594","parent_code":"942"},"31597":{"name":"Xã Mỹ Tú","type":"xa","slug":"xa-my-tu","name_with_type":"Xã Mỹ Tú","path":"Xã Mỹ Tú, Huyện Mỹ Tú, Tỉnh Sóc Trăng","path_with_type":"Xã Mỹ Tú, Huyện Mỹ Tú, Tỉnh Sóc Trăng","code":"31597","parent_code":"944"},"31600":{"name":"Xã An Ninh","type":"xa","slug":"xa-an-ninh","name_with_type":"Xã An Ninh","path":"Xã An Ninh, Huyện Châu Thành, Tỉnh Sóc Trăng","path_with_type":"Xã An Ninh, Huyện Châu Thành, Tỉnh Sóc Trăng","code":"31600","parent_code":"942"},"31603":{"name":"Xã Mỹ Phước","type":"xa","slug":"xa-my-phuoc","name_with_type":"Xã Mỹ Phước","path":"Xã Mỹ Phước, Huyện Mỹ Tú, Tỉnh Sóc Trăng","path_with_type":"Xã Mỹ Phước, Huyện Mỹ Tú, Tỉnh Sóc Trăng","code":"31603","parent_code":"944"},"31606":{"name":"Xã Thuận Hưng","type":"xa","slug":"xa-thuan-hung","name_with_type":"Xã Thuận Hưng","path":"Xã Thuận Hưng, Huyện Mỹ Tú, Tỉnh Sóc Trăng","path_with_type":"Xã Thuận Hưng, Huyện Mỹ Tú, Tỉnh Sóc Trăng","code":"31606","parent_code":"944"},"31609":{"name":"Xã Mỹ Thuận","type":"xa","slug":"xa-my-thuan","name_with_type":"Xã Mỹ Thuận","path":"Xã Mỹ Thuận, Huyện Mỹ Tú, Tỉnh Sóc Trăng","path_with_type":"Xã Mỹ Thuận, Huyện Mỹ Tú, Tỉnh Sóc Trăng","code":"31609","parent_code":"944"},"31612":{"name":"Xã Phú Mỹ","type":"xa","slug":"xa-phu-my","name_with_type":"Xã Phú Mỹ","path":"Xã Phú Mỹ, Huyện Mỹ Tú, Tỉnh Sóc Trăng","path_with_type":"Xã Phú Mỹ, Huyện Mỹ Tú, Tỉnh Sóc Trăng","code":"31612","parent_code":"944"},"31615":{"name":"Thị trấn Cù Lao Dung","type":"thi-tran","slug":"thi-tran-cu-lao-dung","name_with_type":"Thị trấn Cù Lao Dung","path":"Thị trấn Cù Lao Dung, Huyện Cù Lao Dung, Tỉnh Sóc Trăng","path_with_type":"Thị trấn Cù Lao Dung, Huyện Cù Lao Dung, Tỉnh Sóc Trăng","code":"31615","parent_code":"945"},"31618":{"name":"Xã An Thạnh 1","type":"xa","slug":"xa-an-thanh-1","name_with_type":"Xã An Thạnh 1","path":"Xã An Thạnh 1, Huyện Cù Lao Dung, Tỉnh Sóc Trăng","path_with_type":"Xã An Thạnh 1, Huyện Cù Lao Dung, Tỉnh Sóc Trăng","code":"31618","parent_code":"945"},"31621":{"name":"Xã An Thạnh Tây","type":"xa","slug":"xa-an-thanh-tay","name_with_type":"Xã An Thạnh Tây","path":"Xã An Thạnh Tây, Huyện Cù Lao Dung, Tỉnh Sóc Trăng","path_with_type":"Xã An Thạnh Tây, Huyện Cù Lao Dung, Tỉnh Sóc Trăng","code":"31621","parent_code":"945"},"31624":{"name":"Xã An Thạnh Đông","type":"xa","slug":"xa-an-thanh-dong","name_with_type":"Xã An Thạnh Đông","path":"Xã An Thạnh Đông, Huyện Cù Lao Dung, Tỉnh Sóc Trăng","path_with_type":"Xã An Thạnh Đông, Huyện Cù Lao Dung, Tỉnh Sóc Trăng","code":"31624","parent_code":"945"},"31627":{"name":"Xã Đại Ân 1","type":"xa","slug":"xa-dai-an-1","name_with_type":"Xã Đại Ân 1","path":"Xã Đại Ân 1, Huyện Cù Lao Dung, Tỉnh Sóc Trăng","path_with_type":"Xã Đại Ân 1, Huyện Cù Lao Dung, Tỉnh Sóc Trăng","code":"31627","parent_code":"945"},"31630":{"name":"Xã An Thạnh 2","type":"xa","slug":"xa-an-thanh-2","name_with_type":"Xã An Thạnh 2","path":"Xã An Thạnh 2, Huyện Cù Lao Dung, Tỉnh Sóc Trăng","path_with_type":"Xã An Thạnh 2, Huyện Cù Lao Dung, Tỉnh Sóc Trăng","code":"31630","parent_code":"945"},"31633":{"name":"Xã An Thạnh 3","type":"xa","slug":"xa-an-thanh-3","name_with_type":"Xã An Thạnh 3","path":"Xã An Thạnh 3, Huyện Cù Lao Dung, Tỉnh Sóc Trăng","path_with_type":"Xã An Thạnh 3, Huyện Cù Lao Dung, Tỉnh Sóc Trăng","code":"31633","parent_code":"945"},"31636":{"name":"Xã An Thạnh Nam","type":"xa","slug":"xa-an-thanh-nam","name_with_type":"Xã An Thạnh Nam","path":"Xã An Thạnh Nam, Huyện Cù Lao Dung, Tỉnh Sóc Trăng","path_with_type":"Xã An Thạnh Nam, Huyện Cù Lao Dung, Tỉnh Sóc Trăng","code":"31636","parent_code":"945"},"31639":{"name":"Thị trấn Long Phú","type":"thi-tran","slug":"thi-tran-long-phu","name_with_type":"Thị trấn Long Phú","path":"Thị trấn Long Phú, Huyện Long Phú, Tỉnh Sóc Trăng","path_with_type":"Thị trấn Long Phú, Huyện Long Phú, Tỉnh Sóc Trăng","code":"31639","parent_code":"946"},"31642":{"name":"Xã Song Phụng","type":"xa","slug":"xa-song-phung","name_with_type":"Xã Song Phụng","path":"Xã Song Phụng, Huyện Long Phú, Tỉnh Sóc Trăng","path_with_type":"Xã Song Phụng, Huyện Long Phú, Tỉnh Sóc Trăng","code":"31642","parent_code":"946"},"31645":{"name":"Thị trấn Đại Ngãi","type":"thi-tran","slug":"thi-tran-dai-ngai","name_with_type":"Thị trấn Đại Ngãi","path":"Thị trấn Đại Ngãi, Huyện Long Phú, Tỉnh Sóc Trăng","path_with_type":"Thị trấn Đại Ngãi, Huyện Long Phú, Tỉnh Sóc Trăng","code":"31645","parent_code":"946"},"31648":{"name":"Xã Hậu Thạnh","type":"xa","slug":"xa-hau-thanh","name_with_type":"Xã Hậu Thạnh","path":"Xã Hậu Thạnh, Huyện Long Phú, Tỉnh Sóc Trăng","path_with_type":"Xã Hậu Thạnh, Huyện Long Phú, Tỉnh Sóc Trăng","code":"31648","parent_code":"946"},"31651":{"name":"Xã Long Đức","type":"xa","slug":"xa-long-duc","name_with_type":"Xã Long Đức","path":"Xã Long Đức, Huyện Long Phú, Tỉnh Sóc Trăng","path_with_type":"Xã Long Đức, Huyện Long Phú, Tỉnh Sóc Trăng","code":"31651","parent_code":"946"},"31654":{"name":"Xã Trường Khánh","type":"xa","slug":"xa-truong-khanh","name_with_type":"Xã Trường Khánh","path":"Xã Trường Khánh, Huyện Long Phú, Tỉnh Sóc Trăng","path_with_type":"Xã Trường Khánh, Huyện Long Phú, Tỉnh Sóc Trăng","code":"31654","parent_code":"946"},"31657":{"name":"Xã Phú Hữu","type":"xa","slug":"xa-phu-huu","name_with_type":"Xã Phú Hữu","path":"Xã Phú Hữu, Huyện Long Phú, Tỉnh Sóc Trăng","path_with_type":"Xã Phú Hữu, Huyện Long Phú, Tỉnh Sóc Trăng","code":"31657","parent_code":"946"},"31660":{"name":"Xã Tân Hưng","type":"xa","slug":"xa-tan-hung","name_with_type":"Xã Tân Hưng","path":"Xã Tân Hưng, Huyện Long Phú, Tỉnh Sóc Trăng","path_with_type":"Xã Tân Hưng, Huyện Long Phú, Tỉnh Sóc Trăng","code":"31660","parent_code":"946"},"31663":{"name":"Xã Châu Khánh","type":"xa","slug":"xa-chau-khanh","name_with_type":"Xã Châu Khánh","path":"Xã Châu Khánh, Huyện Long Phú, Tỉnh Sóc Trăng","path_with_type":"Xã Châu Khánh, Huyện Long Phú, Tỉnh Sóc Trăng","code":"31663","parent_code":"946"},"31666":{"name":"Xã Tân Thạnh","type":"xa","slug":"xa-tan-thanh","name_with_type":"Xã Tân Thạnh","path":"Xã Tân Thạnh, Huyện Long Phú, Tỉnh Sóc Trăng","path_with_type":"Xã Tân Thạnh, Huyện Long Phú, Tỉnh Sóc Trăng","code":"31666","parent_code":"946"},"31669":{"name":"Xã Long Phú","type":"xa","slug":"xa-long-phu","name_with_type":"Xã Long Phú","path":"Xã Long Phú, Huyện Long Phú, Tỉnh Sóc Trăng","path_with_type":"Xã Long Phú, Huyện Long Phú, Tỉnh Sóc Trăng","code":"31669","parent_code":"946"},"31672":{"name":"Xã Đại Ân  2","type":"xa","slug":"xa-dai-an-2","name_with_type":"Xã Đại Ân  2","path":"Xã Đại Ân  2, Huyện Trần Đề, Tỉnh Sóc Trăng","path_with_type":"Xã Đại Ân  2, Huyện Trần Đề, Tỉnh Sóc Trăng","code":"31672","parent_code":"951"},"31673":{"name":"Thị trấn Trần Đề","type":"thi-tran","slug":"thi-tran-tran-de","name_with_type":"Thị trấn Trần Đề","path":"Thị trấn Trần Đề, Huyện Trần Đề, Tỉnh Sóc Trăng","path_with_type":"Thị trấn Trần Đề, Huyện Trần Đề, Tỉnh Sóc Trăng","code":"31673","parent_code":"951"},"31675":{"name":"Xã Liêu Tú","type":"xa","slug":"xa-lieu-tu","name_with_type":"Xã Liêu Tú","path":"Xã Liêu Tú, Huyện Trần Đề, Tỉnh Sóc Trăng","path_with_type":"Xã Liêu Tú, Huyện Trần Đề, Tỉnh Sóc Trăng","code":"31675","parent_code":"951"},"31678":{"name":"Xã Lịch Hội Thượng","type":"xa","slug":"xa-lich-hoi-thuong","name_with_type":"Xã Lịch Hội Thượng","path":"Xã Lịch Hội Thượng, Huyện Trần Đề, Tỉnh Sóc Trăng","path_with_type":"Xã Lịch Hội Thượng, Huyện Trần Đề, Tỉnh Sóc Trăng","code":"31678","parent_code":"951"},"31679":{"name":"Thị trấn Lịch Hội Thượng","type":"thi-tran","slug":"thi-tran-lich-hoi-thuong","name_with_type":"Thị trấn Lịch Hội Thượng","path":"Thị trấn Lịch Hội Thượng, Huyện Trần Đề, Tỉnh Sóc Trăng","path_with_type":"Thị trấn Lịch Hội Thượng, Huyện Trần Đề, Tỉnh Sóc Trăng","code":"31679","parent_code":"951"},"31681":{"name":"Xã Trung Bình","type":"xa","slug":"xa-trung-binh","name_with_type":"Xã Trung Bình","path":"Xã Trung Bình, Huyện Trần Đề, Tỉnh Sóc Trăng","path_with_type":"Xã Trung Bình, Huyện Trần Đề, Tỉnh Sóc Trăng","code":"31681","parent_code":"951"},"31684":{"name":"Thị trấn Mỹ Xuyên","type":"thi-tran","slug":"thi-tran-my-xuyen","name_with_type":"Thị trấn Mỹ Xuyên","path":"Thị trấn Mỹ Xuyên, Huyện Mỹ Xuyên, Tỉnh Sóc Trăng","path_with_type":"Thị trấn Mỹ Xuyên, Huyện Mỹ Xuyên, Tỉnh Sóc Trăng","code":"31684","parent_code":"947"},"31687":{"name":"Xã Tài Văn","type":"xa","slug":"xa-tai-van","name_with_type":"Xã Tài Văn","path":"Xã Tài Văn, Huyện Trần Đề, Tỉnh Sóc Trăng","path_with_type":"Xã Tài Văn, Huyện Trần Đề, Tỉnh Sóc Trăng","code":"31687","parent_code":"951"},"31690":{"name":"Xã Đại Tâm","type":"xa","slug":"xa-dai-tam","name_with_type":"Xã Đại Tâm","path":"Xã Đại Tâm, Huyện Mỹ Xuyên, Tỉnh Sóc Trăng","path_with_type":"Xã Đại Tâm, Huyện Mỹ Xuyên, Tỉnh Sóc Trăng","code":"31690","parent_code":"947"},"31693":{"name":"Xã Tham Đôn","type":"xa","slug":"xa-tham-don","name_with_type":"Xã Tham Đôn","path":"Xã Tham Đôn, Huyện Mỹ Xuyên, Tỉnh Sóc Trăng","path_with_type":"Xã Tham Đôn, Huyện Mỹ Xuyên, Tỉnh Sóc Trăng","code":"31693","parent_code":"947"},"31696":{"name":"Xã Viên An","type":"xa","slug":"xa-vien-an","name_with_type":"Xã Viên An","path":"Xã Viên An, Huyện Trần Đề, Tỉnh Sóc Trăng","path_with_type":"Xã Viên An, Huyện Trần Đề, Tỉnh Sóc Trăng","code":"31696","parent_code":"951"},"31699":{"name":"Xã Thạnh Thới An","type":"xa","slug":"xa-thanh-thoi-an","name_with_type":"Xã Thạnh Thới An","path":"Xã Thạnh Thới An, Huyện Trần Đề, Tỉnh Sóc Trăng","path_with_type":"Xã Thạnh Thới An, Huyện Trần Đề, Tỉnh Sóc Trăng","code":"31699","parent_code":"951"},"31702":{"name":"Xã Thạnh Thới Thuận","type":"xa","slug":"xa-thanh-thoi-thuan","name_with_type":"Xã Thạnh Thới Thuận","path":"Xã Thạnh Thới Thuận, Huyện Trần Đề, Tỉnh Sóc Trăng","path_with_type":"Xã Thạnh Thới Thuận, Huyện Trần Đề, Tỉnh Sóc Trăng","code":"31702","parent_code":"951"},"31705":{"name":"Xã Viên Bình","type":"xa","slug":"xa-vien-binh","name_with_type":"Xã Viên Bình","path":"Xã Viên Bình, Huyện Trần Đề, Tỉnh Sóc Trăng","path_with_type":"Xã Viên Bình, Huyện Trần Đề, Tỉnh Sóc Trăng","code":"31705","parent_code":"951"},"31708":{"name":"Xã Thạnh Phú","type":"xa","slug":"xa-thanh-phu","name_with_type":"Xã Thạnh Phú","path":"Xã Thạnh Phú, Huyện Mỹ Xuyên, Tỉnh Sóc Trăng","path_with_type":"Xã Thạnh Phú, Huyện Mỹ Xuyên, Tỉnh Sóc Trăng","code":"31708","parent_code":"947"},"31711":{"name":"Xã Ngọc Đông","type":"xa","slug":"xa-ngoc-dong","name_with_type":"Xã Ngọc Đông","path":"Xã Ngọc Đông, Huyện Mỹ Xuyên, Tỉnh Sóc Trăng","path_with_type":"Xã Ngọc Đông, Huyện Mỹ Xuyên, Tỉnh Sóc Trăng","code":"31711","parent_code":"947"},"31714":{"name":"Xã Thạnh Quới","type":"xa","slug":"xa-thanh-quoi","name_with_type":"Xã Thạnh Quới","path":"Xã Thạnh Quới, Huyện Mỹ Xuyên, Tỉnh Sóc Trăng","path_with_type":"Xã Thạnh Quới, Huyện Mỹ Xuyên, Tỉnh Sóc Trăng","code":"31714","parent_code":"947"},"31717":{"name":"Xã Hòa Tú 1","type":"xa","slug":"xa-hoa-tu-1","name_with_type":"Xã Hòa Tú 1","path":"Xã Hòa Tú 1, Huyện Mỹ Xuyên, Tỉnh Sóc Trăng","path_with_type":"Xã Hòa Tú 1, Huyện Mỹ Xuyên, Tỉnh Sóc Trăng","code":"31717","parent_code":"947"},"31720":{"name":"Xã Gia Hòa 1","type":"xa","slug":"xa-gia-hoa-1","name_with_type":"Xã Gia Hòa 1","path":"Xã Gia Hòa 1, Huyện Mỹ Xuyên, Tỉnh Sóc Trăng","path_with_type":"Xã Gia Hòa 1, Huyện Mỹ Xuyên, Tỉnh Sóc Trăng","code":"31720","parent_code":"947"},"31723":{"name":"Xã Ngọc Tố","type":"xa","slug":"xa-ngoc-to","name_with_type":"Xã Ngọc Tố","path":"Xã Ngọc Tố, Huyện Mỹ Xuyên, Tỉnh Sóc Trăng","path_with_type":"Xã Ngọc Tố, Huyện Mỹ Xuyên, Tỉnh Sóc Trăng","code":"31723","parent_code":"947"},"31726":{"name":"Xã Gia Hòa 2","type":"xa","slug":"xa-gia-hoa-2","name_with_type":"Xã Gia Hòa 2","path":"Xã Gia Hòa 2, Huyện Mỹ Xuyên, Tỉnh Sóc Trăng","path_with_type":"Xã Gia Hòa 2, Huyện Mỹ Xuyên, Tỉnh Sóc Trăng","code":"31726","parent_code":"947"},"31729":{"name":"Xã Hòa Tú II","type":"xa","slug":"xa-hoa-tu-ii","name_with_type":"Xã Hòa Tú II","path":"Xã Hòa Tú II, Huyện Mỹ Xuyên, Tỉnh Sóc Trăng","path_with_type":"Xã Hòa Tú II, Huyện Mỹ Xuyên, Tỉnh Sóc Trăng","code":"31729","parent_code":"947"},"31732":{"name":"Phường 1","type":"phuong","slug":"phuong-1","name_with_type":"Phường 1","path":"Phường 1, Thị xã Ngã Năm, Tỉnh Sóc Trăng","path_with_type":"Phường 1, Thị xã Ngã Năm, Tỉnh Sóc Trăng","code":"31732","parent_code":"948"},"31735":{"name":"Phường 2","type":"phuong","slug":"phuong-2","name_with_type":"Phường 2","path":"Phường 2, Thị xã Ngã Năm, Tỉnh Sóc Trăng","path_with_type":"Phường 2, Thị xã Ngã Năm, Tỉnh Sóc Trăng","code":"31735","parent_code":"948"},"31738":{"name":"Xã Vĩnh Quới","type":"xa","slug":"xa-vinh-quoi","name_with_type":"Xã Vĩnh Quới","path":"Xã Vĩnh Quới, Thị xã Ngã Năm, Tỉnh Sóc Trăng","path_with_type":"Xã Vĩnh Quới, Thị xã Ngã Năm, Tỉnh Sóc Trăng","code":"31738","parent_code":"948"},"31741":{"name":"Xã Tân Long","type":"xa","slug":"xa-tan-long","name_with_type":"Xã Tân Long","path":"Xã Tân Long, Thị xã Ngã Năm, Tỉnh Sóc Trăng","path_with_type":"Xã Tân Long, Thị xã Ngã Năm, Tỉnh Sóc Trăng","code":"31741","parent_code":"948"},"31744":{"name":"Xã Long Bình","type":"xa","slug":"xa-long-binh","name_with_type":"Xã Long Bình","path":"Xã Long Bình, Thị xã Ngã Năm, Tỉnh Sóc Trăng","path_with_type":"Xã Long Bình, Thị xã Ngã Năm, Tỉnh Sóc Trăng","code":"31744","parent_code":"948"},"31747":{"name":"Phường 3","type":"phuong","slug":"phuong-3","name_with_type":"Phường 3","path":"Phường 3, Thị xã Ngã Năm, Tỉnh Sóc Trăng","path_with_type":"Phường 3, Thị xã Ngã Năm, Tỉnh Sóc Trăng","code":"31747","parent_code":"948"},"31750":{"name":"Xã Mỹ Bình","type":"xa","slug":"xa-my-binh","name_with_type":"Xã Mỹ Bình","path":"Xã Mỹ Bình, Thị xã Ngã Năm, Tỉnh Sóc Trăng","path_with_type":"Xã Mỹ Bình, Thị xã Ngã Năm, Tỉnh Sóc Trăng","code":"31750","parent_code":"948"},"31753":{"name":"Xã Mỹ Quới","type":"xa","slug":"xa-my-quoi","name_with_type":"Xã Mỹ Quới","path":"Xã Mỹ Quới, Thị xã Ngã Năm, Tỉnh Sóc Trăng","path_with_type":"Xã Mỹ Quới, Thị xã Ngã Năm, Tỉnh Sóc Trăng","code":"31753","parent_code":"948"},"31756":{"name":"Thị trấn Phú Lộc","type":"thi-tran","slug":"thi-tran-phu-loc","name_with_type":"Thị trấn Phú Lộc","path":"Thị trấn Phú Lộc, Huyện Thạnh Trị, Tỉnh Sóc Trăng","path_with_type":"Thị trấn Phú Lộc, Huyện Thạnh Trị, Tỉnh Sóc Trăng","code":"31756","parent_code":"949"},"31757":{"name":"Thị trấn Hưng Lợi","type":"thi-tran","slug":"thi-tran-hung-loi","name_with_type":"Thị trấn Hưng Lợi","path":"Thị trấn Hưng Lợi, Huyện Thạnh Trị, Tỉnh Sóc Trăng","path_with_type":"Thị trấn Hưng Lợi, Huyện Thạnh Trị, Tỉnh Sóc Trăng","code":"31757","parent_code":"949"},"31759":{"name":"Xã Lâm Tân","type":"xa","slug":"xa-lam-tan","name_with_type":"Xã Lâm Tân","path":"Xã Lâm Tân, Huyện Thạnh Trị, Tỉnh Sóc Trăng","path_with_type":"Xã Lâm Tân, Huyện Thạnh Trị, Tỉnh Sóc Trăng","code":"31759","parent_code":"949"},"31762":{"name":"Xã Thạnh Tân","type":"xa","slug":"xa-thanh-tan","name_with_type":"Xã Thạnh Tân","path":"Xã Thạnh Tân, Huyện Thạnh Trị, Tỉnh Sóc Trăng","path_with_type":"Xã Thạnh Tân, Huyện Thạnh Trị, Tỉnh Sóc Trăng","code":"31762","parent_code":"949"},"31765":{"name":"Xã Lâm Kiết","type":"xa","slug":"xa-lam-kiet","name_with_type":"Xã Lâm Kiết","path":"Xã Lâm Kiết, Huyện Thạnh Trị, Tỉnh Sóc Trăng","path_with_type":"Xã Lâm Kiết, Huyện Thạnh Trị, Tỉnh Sóc Trăng","code":"31765","parent_code":"949"},"31768":{"name":"Xã Tuân Tức","type":"xa","slug":"xa-tuan-tuc","name_with_type":"Xã Tuân Tức","path":"Xã Tuân Tức, Huyện Thạnh Trị, Tỉnh Sóc Trăng","path_with_type":"Xã Tuân Tức, Huyện Thạnh Trị, Tỉnh Sóc Trăng","code":"31768","parent_code":"949"},"31771":{"name":"Xã Vĩnh Thành","type":"xa","slug":"xa-vinh-thanh","name_with_type":"Xã Vĩnh Thành","path":"Xã Vĩnh Thành, Huyện Thạnh Trị, Tỉnh Sóc Trăng","path_with_type":"Xã Vĩnh Thành, Huyện Thạnh Trị, Tỉnh Sóc Trăng","code":"31771","parent_code":"949"},"31774":{"name":"Xã Thạnh Trị","type":"xa","slug":"xa-thanh-tri","name_with_type":"Xã Thạnh Trị","path":"Xã Thạnh Trị, Huyện Thạnh Trị, Tỉnh Sóc Trăng","path_with_type":"Xã Thạnh Trị, Huyện Thạnh Trị, Tỉnh Sóc Trăng","code":"31774","parent_code":"949"},"31777":{"name":"Xã Vĩnh Lợi","type":"xa","slug":"xa-vinh-loi","name_with_type":"Xã Vĩnh Lợi","path":"Xã Vĩnh Lợi, Huyện Thạnh Trị, Tỉnh Sóc Trăng","path_with_type":"Xã Vĩnh Lợi, Huyện Thạnh Trị, Tỉnh Sóc Trăng","code":"31777","parent_code":"949"},"31780":{"name":"Xã Châu Hưng","type":"xa","slug":"xa-chau-hung","name_with_type":"Xã Châu Hưng","path":"Xã Châu Hưng, Huyện Thạnh Trị, Tỉnh Sóc Trăng","path_with_type":"Xã Châu Hưng, Huyện Thạnh Trị, Tỉnh Sóc Trăng","code":"31780","parent_code":"949"},"31783":{"name":"Phường 1","type":"phuong","slug":"phuong-1","name_with_type":"Phường 1","path":"Phường 1, Thị xã Vĩnh Châu, Tỉnh Sóc Trăng","path_with_type":"Phường 1, Thị xã Vĩnh Châu, Tỉnh Sóc Trăng","code":"31783","parent_code":"950"},"31786":{"name":"Xã Hòa Đông","type":"xa","slug":"xa-hoa-dong","name_with_type":"Xã Hòa Đông","path":"Xã Hòa Đông, Thị xã Vĩnh Châu, Tỉnh Sóc Trăng","path_with_type":"Xã Hòa Đông, Thị xã Vĩnh Châu, Tỉnh Sóc Trăng","code":"31786","parent_code":"950"},"31789":{"name":"Phường Khánh Hòa","type":"phuong","slug":"phuong-khanh-hoa","name_with_type":"Phường Khánh Hòa","path":"Phường Khánh Hòa, Thị xã Vĩnh Châu, Tỉnh Sóc Trăng","path_with_type":"Phường Khánh Hòa, Thị xã Vĩnh Châu, Tỉnh Sóc Trăng","code":"31789","parent_code":"950"},"31792":{"name":"Xã Vĩnh Hiệp","type":"xa","slug":"xa-vinh-hiep","name_with_type":"Xã Vĩnh Hiệp","path":"Xã Vĩnh Hiệp, Thị xã Vĩnh Châu, Tỉnh Sóc Trăng","path_with_type":"Xã Vĩnh Hiệp, Thị xã Vĩnh Châu, Tỉnh Sóc Trăng","code":"31792","parent_code":"950"},"31795":{"name":"Xã Vĩnh Hải","type":"xa","slug":"xa-vinh-hai","name_with_type":"Xã Vĩnh Hải","path":"Xã Vĩnh Hải, Thị xã Vĩnh Châu, Tỉnh Sóc Trăng","path_with_type":"Xã Vĩnh Hải, Thị xã Vĩnh Châu, Tỉnh Sóc Trăng","code":"31795","parent_code":"950"},"31798":{"name":"Xã Lạc Hòa","type":"xa","slug":"xa-lac-hoa","name_with_type":"Xã Lạc Hòa","path":"Xã Lạc Hòa, Thị xã Vĩnh Châu, Tỉnh Sóc Trăng","path_with_type":"Xã Lạc Hòa, Thị xã Vĩnh Châu, Tỉnh Sóc Trăng","code":"31798","parent_code":"950"},"31801":{"name":"Phường 2","type":"phuong","slug":"phuong-2","name_with_type":"Phường 2","path":"Phường 2, Thị xã Vĩnh Châu, Tỉnh Sóc Trăng","path_with_type":"Phường 2, Thị xã Vĩnh Châu, Tỉnh Sóc Trăng","code":"31801","parent_code":"950"},"31804":{"name":"Phường Vĩnh Phước","type":"phuong","slug":"phuong-vinh-phuoc","name_with_type":"Phường Vĩnh Phước","path":"Phường Vĩnh Phước, Thị xã Vĩnh Châu, Tỉnh Sóc Trăng","path_with_type":"Phường Vĩnh Phước, Thị xã Vĩnh Châu, Tỉnh Sóc Trăng","code":"31804","parent_code":"950"},"31807":{"name":"Xã Vĩnh Tân","type":"xa","slug":"xa-vinh-tan","name_with_type":"Xã Vĩnh Tân","path":"Xã Vĩnh Tân, Thị xã Vĩnh Châu, Tỉnh Sóc Trăng","path_with_type":"Xã Vĩnh Tân, Thị xã Vĩnh Châu, Tỉnh Sóc Trăng","code":"31807","parent_code":"950"},"31810":{"name":"Xã Lai Hòa","type":"xa","slug":"xa-lai-hoa","name_with_type":"Xã Lai Hòa","path":"Xã Lai Hòa, Thị xã Vĩnh Châu, Tỉnh Sóc Trăng","path_with_type":"Xã Lai Hòa, Thị xã Vĩnh Châu, Tỉnh Sóc Trăng","code":"31810","parent_code":"950"},"31813":{"name":"Phường 2","type":"phuong","slug":"phuong-2","name_with_type":"Phường 2","path":"Phường 2, Thành phố Bạc Liêu, Tỉnh Bạc Liêu","path_with_type":"Phường 2, Thành phố Bạc Liêu, Tỉnh Bạc Liêu","code":"31813","parent_code":"954"},"31816":{"name":"Phường 3","type":"phuong","slug":"phuong-3","name_with_type":"Phường 3","path":"Phường 3, Thành phố Bạc Liêu, Tỉnh Bạc Liêu","path_with_type":"Phường 3, Thành phố Bạc Liêu, Tỉnh Bạc Liêu","code":"31816","parent_code":"954"},"31819":{"name":"Phường 5","type":"phuong","slug":"phuong-5","name_with_type":"Phường 5","path":"Phường 5, Thành phố Bạc Liêu, Tỉnh Bạc Liêu","path_with_type":"Phường 5, Thành phố Bạc Liêu, Tỉnh Bạc Liêu","code":"31819","parent_code":"954"},"31822":{"name":"Phường 7","type":"phuong","slug":"phuong-7","name_with_type":"Phường 7","path":"Phường 7, Thành phố Bạc Liêu, Tỉnh Bạc Liêu","path_with_type":"Phường 7, Thành phố Bạc Liêu, Tỉnh Bạc Liêu","code":"31822","parent_code":"954"},"31825":{"name":"Phường 1","type":"phuong","slug":"phuong-1","name_with_type":"Phường 1","path":"Phường 1, Thành phố Bạc Liêu, Tỉnh Bạc Liêu","path_with_type":"Phường 1, Thành phố Bạc Liêu, Tỉnh Bạc Liêu","code":"31825","parent_code":"954"},"31828":{"name":"Phường 8","type":"phuong","slug":"phuong-8","name_with_type":"Phường 8","path":"Phường 8, Thành phố Bạc Liêu, Tỉnh Bạc Liêu","path_with_type":"Phường 8, Thành phố Bạc Liêu, Tỉnh Bạc Liêu","code":"31828","parent_code":"954"},"31831":{"name":"Phường Nhà Mát","type":"phuong","slug":"phuong-nha-mat","name_with_type":"Phường Nhà Mát","path":"Phường Nhà Mát, Thành phố Bạc Liêu, Tỉnh Bạc Liêu","path_with_type":"Phường Nhà Mát, Thành phố Bạc Liêu, Tỉnh Bạc Liêu","code":"31831","parent_code":"954"},"31834":{"name":"Xã Vĩnh Trạch","type":"xa","slug":"xa-vinh-trach","name_with_type":"Xã Vĩnh Trạch","path":"Xã Vĩnh Trạch, Thành phố Bạc Liêu, Tỉnh Bạc Liêu","path_with_type":"Xã Vĩnh Trạch, Thành phố Bạc Liêu, Tỉnh Bạc Liêu","code":"31834","parent_code":"954"},"31837":{"name":"Xã Vĩnh Trạch Đông","type":"xa","slug":"xa-vinh-trach-dong","name_with_type":"Xã Vĩnh Trạch Đông","path":"Xã Vĩnh Trạch Đông, Thành phố Bạc Liêu, Tỉnh Bạc Liêu","path_with_type":"Xã Vĩnh Trạch Đông, Thành phố Bạc Liêu, Tỉnh Bạc Liêu","code":"31837","parent_code":"954"},"31840":{"name":"Xã Hiệp Thành","type":"xa","slug":"xa-hiep-thanh","name_with_type":"Xã Hiệp Thành","path":"Xã Hiệp Thành, Thành phố Bạc Liêu, Tỉnh Bạc Liêu","path_with_type":"Xã Hiệp Thành, Thành phố Bạc Liêu, Tỉnh Bạc Liêu","code":"31840","parent_code":"954"},"31843":{"name":"Thị trấn Ngan Dừa","type":"thi-tran","slug":"thi-tran-ngan-dua","name_with_type":"Thị trấn Ngan Dừa","path":"Thị trấn Ngan Dừa, Huyện Hồng Dân, Tỉnh Bạc Liêu","path_with_type":"Thị trấn Ngan Dừa, Huyện Hồng Dân, Tỉnh Bạc Liêu","code":"31843","parent_code":"956"},"31846":{"name":"Xã Ninh Quới","type":"xa","slug":"xa-ninh-quoi","name_with_type":"Xã Ninh Quới","path":"Xã Ninh Quới, Huyện Hồng Dân, Tỉnh Bạc Liêu","path_with_type":"Xã Ninh Quới, Huyện Hồng Dân, Tỉnh Bạc Liêu","code":"31846","parent_code":"956"},"31849":{"name":"Xã Ninh Quới A","type":"xa","slug":"xa-ninh-quoi-a","name_with_type":"Xã Ninh Quới A","path":"Xã Ninh Quới A, Huyện Hồng Dân, Tỉnh Bạc Liêu","path_with_type":"Xã Ninh Quới A, Huyện Hồng Dân, Tỉnh Bạc Liêu","code":"31849","parent_code":"956"},"31852":{"name":"Xã Ninh Hòa","type":"xa","slug":"xa-ninh-hoa","name_with_type":"Xã Ninh Hòa","path":"Xã Ninh Hòa, Huyện Hồng Dân, Tỉnh Bạc Liêu","path_with_type":"Xã Ninh Hòa, Huyện Hồng Dân, Tỉnh Bạc Liêu","code":"31852","parent_code":"956"},"31855":{"name":"Xã Lộc Ninh","type":"xa","slug":"xa-loc-ninh","name_with_type":"Xã Lộc Ninh","path":"Xã Lộc Ninh, Huyện Hồng Dân, Tỉnh Bạc Liêu","path_with_type":"Xã Lộc Ninh, Huyện Hồng Dân, Tỉnh Bạc Liêu","code":"31855","parent_code":"956"},"31858":{"name":"Xã Vĩnh Lộc","type":"xa","slug":"xa-vinh-loc","name_with_type":"Xã Vĩnh Lộc","path":"Xã Vĩnh Lộc, Huyện Hồng Dân, Tỉnh Bạc Liêu","path_with_type":"Xã Vĩnh Lộc, Huyện Hồng Dân, Tỉnh Bạc Liêu","code":"31858","parent_code":"956"},"31861":{"name":"Xã Vĩnh Lộc A","type":"xa","slug":"xa-vinh-loc-a","name_with_type":"Xã Vĩnh Lộc A","path":"Xã Vĩnh Lộc A, Huyện Hồng Dân, Tỉnh Bạc Liêu","path_with_type":"Xã Vĩnh Lộc A, Huyện Hồng Dân, Tỉnh Bạc Liêu","code":"31861","parent_code":"956"},"31863":{"name":"Xã Ninh Thạnh Lợi A","type":"xa","slug":"xa-ninh-thanh-loi-a","name_with_type":"Xã Ninh Thạnh Lợi A","path":"Xã Ninh Thạnh Lợi A, Huyện Hồng Dân, Tỉnh Bạc Liêu","path_with_type":"Xã Ninh Thạnh Lợi A, Huyện Hồng Dân, Tỉnh Bạc Liêu","code":"31863","parent_code":"956"},"31864":{"name":"Xã Ninh Thạnh Lợi","type":"xa","slug":"xa-ninh-thanh-loi","name_with_type":"Xã Ninh Thạnh Lợi","path":"Xã Ninh Thạnh Lợi, Huyện Hồng Dân, Tỉnh Bạc Liêu","path_with_type":"Xã Ninh Thạnh Lợi, Huyện Hồng Dân, Tỉnh Bạc Liêu","code":"31864","parent_code":"956"},"31867":{"name":"Thị trấn Phước Long","type":"thi-tran","slug":"thi-tran-phuoc-long","name_with_type":"Thị trấn Phước Long","path":"Thị trấn Phước Long, Huyện Phước Long, Tỉnh Bạc Liêu","path_with_type":"Thị trấn Phước Long, Huyện Phước Long, Tỉnh Bạc Liêu","code":"31867","parent_code":"957"},"31870":{"name":"Xã Vĩnh Phú Đông","type":"xa","slug":"xa-vinh-phu-dong","name_with_type":"Xã Vĩnh Phú Đông","path":"Xã Vĩnh Phú Đông, Huyện Phước Long, Tỉnh Bạc Liêu","path_with_type":"Xã Vĩnh Phú Đông, Huyện Phước Long, Tỉnh Bạc Liêu","code":"31870","parent_code":"957"},"31873":{"name":"Xã Vĩnh Phú Tây","type":"xa","slug":"xa-vinh-phu-tay","name_with_type":"Xã Vĩnh Phú Tây","path":"Xã Vĩnh Phú Tây, Huyện Phước Long, Tỉnh Bạc Liêu","path_with_type":"Xã Vĩnh Phú Tây, Huyện Phước Long, Tỉnh Bạc Liêu","code":"31873","parent_code":"957"},"31876":{"name":"Xã Phước Long","type":"xa","slug":"xa-phuoc-long","name_with_type":"Xã Phước Long","path":"Xã Phước Long, Huyện Phước Long, Tỉnh Bạc Liêu","path_with_type":"Xã Phước Long, Huyện Phước Long, Tỉnh Bạc Liêu","code":"31876","parent_code":"957"},"31879":{"name":"Xã Hưng Phú","type":"xa","slug":"xa-hung-phu","name_with_type":"Xã Hưng Phú","path":"Xã Hưng Phú, Huyện Phước Long, Tỉnh Bạc Liêu","path_with_type":"Xã Hưng Phú, Huyện Phước Long, Tỉnh Bạc Liêu","code":"31879","parent_code":"957"},"31882":{"name":"Xã Vĩnh Thanh","type":"xa","slug":"xa-vinh-thanh","name_with_type":"Xã Vĩnh Thanh","path":"Xã Vĩnh Thanh, Huyện Phước Long, Tỉnh Bạc Liêu","path_with_type":"Xã Vĩnh Thanh, Huyện Phước Long, Tỉnh Bạc Liêu","code":"31882","parent_code":"957"},"31885":{"name":"Xã Phong Thạnh Tây A","type":"xa","slug":"xa-phong-thanh-tay-a","name_with_type":"Xã Phong Thạnh Tây A","path":"Xã Phong Thạnh Tây A, Huyện Phước Long, Tỉnh Bạc Liêu","path_with_type":"Xã Phong Thạnh Tây A, Huyện Phước Long, Tỉnh Bạc Liêu","code":"31885","parent_code":"957"},"31888":{"name":"Xã Phong Thạnh Tây B","type":"xa","slug":"xa-phong-thanh-tay-b","name_with_type":"Xã Phong Thạnh Tây B","path":"Xã Phong Thạnh Tây B, Huyện Phước Long, Tỉnh Bạc Liêu","path_with_type":"Xã Phong Thạnh Tây B, Huyện Phước Long, Tỉnh Bạc Liêu","code":"31888","parent_code":"957"},"31891":{"name":"Thị trấn Hòa Bình","type":"thi-tran","slug":"thi-tran-hoa-binh","name_with_type":"Thị trấn Hòa Bình","path":"Thị trấn Hòa Bình, Huyện Hoà Bình, Tỉnh Bạc Liêu","path_with_type":"Thị trấn Hòa Bình, Huyện Hoà Bình, Tỉnh Bạc Liêu","code":"31891","parent_code":"961"},"31894":{"name":"Xã Vĩnh Hưng","type":"xa","slug":"xa-vinh-hung","name_with_type":"Xã Vĩnh Hưng","path":"Xã Vĩnh Hưng, Huyện Vĩnh Lợi, Tỉnh Bạc Liêu","path_with_type":"Xã Vĩnh Hưng, Huyện Vĩnh Lợi, Tỉnh Bạc Liêu","code":"31894","parent_code":"958"},"31897":{"name":"Xã Vĩnh Hưng A","type":"xa","slug":"xa-vinh-hung-a","name_with_type":"Xã Vĩnh Hưng A","path":"Xã Vĩnh Hưng A, Huyện Vĩnh Lợi, Tỉnh Bạc Liêu","path_with_type":"Xã Vĩnh Hưng A, Huyện Vĩnh Lợi, Tỉnh Bạc Liêu","code":"31897","parent_code":"958"},"31900":{"name":"Thị trấn Châu Hưng","type":"thi-tran","slug":"thi-tran-chau-hung","name_with_type":"Thị trấn Châu Hưng","path":"Thị trấn Châu Hưng, Huyện Vĩnh Lợi, Tỉnh Bạc Liêu","path_with_type":"Thị trấn Châu Hưng, Huyện Vĩnh Lợi, Tỉnh Bạc Liêu","code":"31900","parent_code":"958"},"31903":{"name":"Xã Châu Hưng A","type":"xa","slug":"xa-chau-hung-a","name_with_type":"Xã Châu Hưng A","path":"Xã Châu Hưng A, Huyện Vĩnh Lợi, Tỉnh Bạc Liêu","path_with_type":"Xã Châu Hưng A, Huyện Vĩnh Lợi, Tỉnh Bạc Liêu","code":"31903","parent_code":"958"},"31906":{"name":"Xã Hưng Thành","type":"xa","slug":"xa-hung-thanh","name_with_type":"Xã Hưng Thành","path":"Xã Hưng Thành, Huyện Vĩnh Lợi, Tỉnh Bạc Liêu","path_with_type":"Xã Hưng Thành, Huyện Vĩnh Lợi, Tỉnh Bạc Liêu","code":"31906","parent_code":"958"},"31909":{"name":"Xã Hưng Hội","type":"xa","slug":"xa-hung-hoi","name_with_type":"Xã Hưng Hội","path":"Xã Hưng Hội, Huyện Vĩnh Lợi, Tỉnh Bạc Liêu","path_with_type":"Xã Hưng Hội, Huyện Vĩnh Lợi, Tỉnh Bạc Liêu","code":"31909","parent_code":"958"},"31912":{"name":"Xã Châu Thới","type":"xa","slug":"xa-chau-thoi","name_with_type":"Xã Châu Thới","path":"Xã Châu Thới, Huyện Vĩnh Lợi, Tỉnh Bạc Liêu","path_with_type":"Xã Châu Thới, Huyện Vĩnh Lợi, Tỉnh Bạc Liêu","code":"31912","parent_code":"958"},"31915":{"name":"Xã Minh Diệu","type":"xa","slug":"xa-minh-dieu","name_with_type":"Xã Minh Diệu","path":"Xã Minh Diệu, Huyện Hoà Bình, Tỉnh Bạc Liêu","path_with_type":"Xã Minh Diệu, Huyện Hoà Bình, Tỉnh Bạc Liêu","code":"31915","parent_code":"961"},"31918":{"name":"Xã Vĩnh Bình","type":"xa","slug":"xa-vinh-binh","name_with_type":"Xã Vĩnh Bình","path":"Xã Vĩnh Bình, Huyện Hoà Bình, Tỉnh Bạc Liêu","path_with_type":"Xã Vĩnh Bình, Huyện Hoà Bình, Tỉnh Bạc Liêu","code":"31918","parent_code":"961"},"31921":{"name":"Xã Long Thạnh","type":"xa","slug":"xa-long-thanh","name_with_type":"Xã Long Thạnh","path":"Xã Long Thạnh, Huyện Vĩnh Lợi, Tỉnh Bạc Liêu","path_with_type":"Xã Long Thạnh, Huyện Vĩnh Lợi, Tỉnh Bạc Liêu","code":"31921","parent_code":"958"},"31924":{"name":"Xã Vĩnh Mỹ B","type":"xa","slug":"xa-vinh-my-b","name_with_type":"Xã Vĩnh Mỹ B","path":"Xã Vĩnh Mỹ B, Huyện Hoà Bình, Tỉnh Bạc Liêu","path_with_type":"Xã Vĩnh Mỹ B, Huyện Hoà Bình, Tỉnh Bạc Liêu","code":"31924","parent_code":"961"},"31927":{"name":"Xã Vĩnh Hậu","type":"xa","slug":"xa-vinh-hau","name_with_type":"Xã Vĩnh Hậu","path":"Xã Vĩnh Hậu, Huyện Hoà Bình, Tỉnh Bạc Liêu","path_with_type":"Xã Vĩnh Hậu, Huyện Hoà Bình, Tỉnh Bạc Liêu","code":"31927","parent_code":"961"},"31930":{"name":"Xã Vĩnh Hậu A","type":"xa","slug":"xa-vinh-hau-a","name_with_type":"Xã Vĩnh Hậu A","path":"Xã Vĩnh Hậu A, Huyện Hoà Bình, Tỉnh Bạc Liêu","path_with_type":"Xã Vĩnh Hậu A, Huyện Hoà Bình, Tỉnh Bạc Liêu","code":"31930","parent_code":"961"},"31933":{"name":"Xã Vĩnh Mỹ A","type":"xa","slug":"xa-vinh-my-a","name_with_type":"Xã Vĩnh Mỹ A","path":"Xã Vĩnh Mỹ A, Huyện Hoà Bình, Tỉnh Bạc Liêu","path_with_type":"Xã Vĩnh Mỹ A, Huyện Hoà Bình, Tỉnh Bạc Liêu","code":"31933","parent_code":"961"},"31936":{"name":"Xã Vĩnh Thịnh","type":"xa","slug":"xa-vinh-thinh","name_with_type":"Xã Vĩnh Thịnh","path":"Xã Vĩnh Thịnh, Huyện Hoà Bình, Tỉnh Bạc Liêu","path_with_type":"Xã Vĩnh Thịnh, Huyện Hoà Bình, Tỉnh Bạc Liêu","code":"31936","parent_code":"961"},"31942":{"name":"Phường 1","type":"phuong","slug":"phuong-1","name_with_type":"Phường 1","path":"Phường 1, Thị xã Giá Rai, Tỉnh Bạc Liêu","path_with_type":"Phường 1, Thị xã Giá Rai, Tỉnh Bạc Liêu","code":"31942","parent_code":"959"},"31945":{"name":"Phường Hộ Phòng","type":"phuong","slug":"phuong-ho-phong","name_with_type":"Phường Hộ Phòng","path":"Phường Hộ Phòng, Thị xã Giá Rai, Tỉnh Bạc Liêu","path_with_type":"Phường Hộ Phòng, Thị xã Giá Rai, Tỉnh Bạc Liêu","code":"31945","parent_code":"959"},"31948":{"name":"Xã Phong Thạnh Đông","type":"xa","slug":"xa-phong-thanh-dong","name_with_type":"Xã Phong Thạnh Đông","path":"Xã Phong Thạnh Đông, Thị xã Giá Rai, Tỉnh Bạc Liêu","path_with_type":"Xã Phong Thạnh Đông, Thị xã Giá Rai, Tỉnh Bạc Liêu","code":"31948","parent_code":"959"},"31951":{"name":"Phường Láng Tròn","type":"phuong","slug":"phuong-lang-tron","name_with_type":"Phường Láng Tròn","path":"Phường Láng Tròn, Thị xã Giá Rai, Tỉnh Bạc Liêu","path_with_type":"Phường Láng Tròn, Thị xã Giá Rai, Tỉnh Bạc Liêu","code":"31951","parent_code":"959"},"31954":{"name":"Xã Phong Tân","type":"xa","slug":"xa-phong-tan","name_with_type":"Xã Phong Tân","path":"Xã Phong Tân, Thị xã Giá Rai, Tỉnh Bạc Liêu","path_with_type":"Xã Phong Tân, Thị xã Giá Rai, Tỉnh Bạc Liêu","code":"31954","parent_code":"959"},"31957":{"name":"Xã Tân Phong","type":"xa","slug":"xa-tan-phong","name_with_type":"Xã Tân Phong","path":"Xã Tân Phong, Thị xã Giá Rai, Tỉnh Bạc Liêu","path_with_type":"Xã Tân Phong, Thị xã Giá Rai, Tỉnh Bạc Liêu","code":"31957","parent_code":"959"},"31960":{"name":"Xã Phong Thạnh","type":"xa","slug":"xa-phong-thanh","name_with_type":"Xã Phong Thạnh","path":"Xã Phong Thạnh, Thị xã Giá Rai, Tỉnh Bạc Liêu","path_with_type":"Xã Phong Thạnh, Thị xã Giá Rai, Tỉnh Bạc Liêu","code":"31960","parent_code":"959"},"31963":{"name":"Xã Phong Thạnh A","type":"xa","slug":"xa-phong-thanh-a","name_with_type":"Xã Phong Thạnh A","path":"Xã Phong Thạnh A, Thị xã Giá Rai, Tỉnh Bạc Liêu","path_with_type":"Xã Phong Thạnh A, Thị xã Giá Rai, Tỉnh Bạc Liêu","code":"31963","parent_code":"959"},"31966":{"name":"Xã Phong Thạnh Tây","type":"xa","slug":"xa-phong-thanh-tay","name_with_type":"Xã Phong Thạnh Tây","path":"Xã Phong Thạnh Tây, Thị xã Giá Rai, Tỉnh Bạc Liêu","path_with_type":"Xã Phong Thạnh Tây, Thị xã Giá Rai, Tỉnh Bạc Liêu","code":"31966","parent_code":"959"},"31969":{"name":"Xã Tân Thạnh","type":"xa","slug":"xa-tan-thanh","name_with_type":"Xã Tân Thạnh","path":"Xã Tân Thạnh, Thị xã Giá Rai, Tỉnh Bạc Liêu","path_with_type":"Xã Tân Thạnh, Thị xã Giá Rai, Tỉnh Bạc Liêu","code":"31969","parent_code":"959"},"31972":{"name":"Thị trấn Gành Hào","type":"thi-tran","slug":"thi-tran-ganh-hao","name_with_type":"Thị trấn Gành Hào","path":"Thị trấn Gành Hào, Huyện Đông Hải, Tỉnh Bạc Liêu","path_with_type":"Thị trấn Gành Hào, Huyện Đông Hải, Tỉnh Bạc Liêu","code":"31972","parent_code":"960"},"31975":{"name":"Xã Long Điền Đông","type":"xa","slug":"xa-long-dien-dong","name_with_type":"Xã Long Điền Đông","path":"Xã Long Điền Đông, Huyện Đông Hải, Tỉnh Bạc Liêu","path_with_type":"Xã Long Điền Đông, Huyện Đông Hải, Tỉnh Bạc Liêu","code":"31975","parent_code":"960"},"31978":{"name":"Xã Long Điền Đông A","type":"xa","slug":"xa-long-dien-dong-a","name_with_type":"Xã Long Điền Đông A","path":"Xã Long Điền Đông A, Huyện Đông Hải, Tỉnh Bạc Liêu","path_with_type":"Xã Long Điền Đông A, Huyện Đông Hải, Tỉnh Bạc Liêu","code":"31978","parent_code":"960"},"31981":{"name":"Xã Long Điền","type":"xa","slug":"xa-long-dien","name_with_type":"Xã Long Điền","path":"Xã Long Điền, Huyện Đông Hải, Tỉnh Bạc Liêu","path_with_type":"Xã Long Điền, Huyện Đông Hải, Tỉnh Bạc Liêu","code":"31981","parent_code":"960"},"31984":{"name":"Xã Long Điền Tây","type":"xa","slug":"xa-long-dien-tay","name_with_type":"Xã Long Điền Tây","path":"Xã Long Điền Tây, Huyện Đông Hải, Tỉnh Bạc Liêu","path_with_type":"Xã Long Điền Tây, Huyện Đông Hải, Tỉnh Bạc Liêu","code":"31984","parent_code":"960"},"31985":{"name":"Xã Điền Hải","type":"xa","slug":"xa-dien-hai","name_with_type":"Xã Điền Hải","path":"Xã Điền Hải, Huyện Đông Hải, Tỉnh Bạc Liêu","path_with_type":"Xã Điền Hải, Huyện Đông Hải, Tỉnh Bạc Liêu","code":"31985","parent_code":"960"},"31987":{"name":"Xã An Trạch","type":"xa","slug":"xa-an-trach","name_with_type":"Xã An Trạch","path":"Xã An Trạch, Huyện Đông Hải, Tỉnh Bạc Liêu","path_with_type":"Xã An Trạch, Huyện Đông Hải, Tỉnh Bạc Liêu","code":"31987","parent_code":"960"},"31988":{"name":"Xã An Trạch A","type":"xa","slug":"xa-an-trach-a","name_with_type":"Xã An Trạch A","path":"Xã An Trạch A, Huyện Đông Hải, Tỉnh Bạc Liêu","path_with_type":"Xã An Trạch A, Huyện Đông Hải, Tỉnh Bạc Liêu","code":"31988","parent_code":"960"},"31990":{"name":"Xã An Phúc","type":"xa","slug":"xa-an-phuc","name_with_type":"Xã An Phúc","path":"Xã An Phúc, Huyện Đông Hải, Tỉnh Bạc Liêu","path_with_type":"Xã An Phúc, Huyện Đông Hải, Tỉnh Bạc Liêu","code":"31990","parent_code":"960"},"31993":{"name":"Xã Định Thành","type":"xa","slug":"xa-dinh-thanh","name_with_type":"Xã Định Thành","path":"Xã Định Thành, Huyện Đông Hải, Tỉnh Bạc Liêu","path_with_type":"Xã Định Thành, Huyện Đông Hải, Tỉnh Bạc Liêu","code":"31993","parent_code":"960"},"31996":{"name":"Xã Định Thành A","type":"xa","slug":"xa-dinh-thanh-a","name_with_type":"Xã Định Thành A","path":"Xã Định Thành A, Huyện Đông Hải, Tỉnh Bạc Liêu","path_with_type":"Xã Định Thành A, Huyện Đông Hải, Tỉnh Bạc Liêu","code":"31996","parent_code":"960"},"31999":{"name":"Phường 9","type":"phuong","slug":"phuong-9","name_with_type":"Phường 9","path":"Phường 9, Thành phố Cà Mau, Tỉnh Cà Mau","path_with_type":"Phường 9, Thành phố Cà Mau, Tỉnh Cà Mau","code":"31999","parent_code":"964"},"32002":{"name":"Phường 2","type":"phuong","slug":"phuong-2","name_with_type":"Phường 2","path":"Phường 2, Thành phố Cà Mau, Tỉnh Cà Mau","path_with_type":"Phường 2, Thành phố Cà Mau, Tỉnh Cà Mau","code":"32002","parent_code":"964"},"32005":{"name":"Phường 1","type":"phuong","slug":"phuong-1","name_with_type":"Phường 1","path":"Phường 1, Thành phố Cà Mau, Tỉnh Cà Mau","path_with_type":"Phường 1, Thành phố Cà Mau, Tỉnh Cà Mau","code":"32005","parent_code":"964"},"32008":{"name":"Phường 5","type":"phuong","slug":"phuong-5","name_with_type":"Phường 5","path":"Phường 5, Thành phố Cà Mau, Tỉnh Cà Mau","path_with_type":"Phường 5, Thành phố Cà Mau, Tỉnh Cà Mau","code":"32008","parent_code":"964"},"32014":{"name":"Phường 8","type":"phuong","slug":"phuong-8","name_with_type":"Phường 8","path":"Phường 8, Thành phố Cà Mau, Tỉnh Cà Mau","path_with_type":"Phường 8, Thành phố Cà Mau, Tỉnh Cà Mau","code":"32014","parent_code":"964"},"32017":{"name":"Phường 6","type":"phuong","slug":"phuong-6","name_with_type":"Phường 6","path":"Phường 6, Thành phố Cà Mau, Tỉnh Cà Mau","path_with_type":"Phường 6, Thành phố Cà Mau, Tỉnh Cà Mau","code":"32017","parent_code":"964"},"32020":{"name":"Phường 7","type":"phuong","slug":"phuong-7","name_with_type":"Phường 7","path":"Phường 7, Thành phố Cà Mau, Tỉnh Cà Mau","path_with_type":"Phường 7, Thành phố Cà Mau, Tỉnh Cà Mau","code":"32020","parent_code":"964"},"32022":{"name":"Phường Tân Xuyên","type":"phuong","slug":"phuong-tan-xuyen","name_with_type":"Phường Tân Xuyên","path":"Phường Tân Xuyên, Thành phố Cà Mau, Tỉnh Cà Mau","path_with_type":"Phường Tân Xuyên, Thành phố Cà Mau, Tỉnh Cà Mau","code":"32022","parent_code":"964"},"32023":{"name":"Xã An Xuyên","type":"xa","slug":"xa-an-xuyen","name_with_type":"Xã An Xuyên","path":"Xã An Xuyên, Thành phố Cà Mau, Tỉnh Cà Mau","path_with_type":"Xã An Xuyên, Thành phố Cà Mau, Tỉnh Cà Mau","code":"32023","parent_code":"964"},"32025":{"name":"Phường Tân Thành","type":"phuong","slug":"phuong-tan-thanh","name_with_type":"Phường Tân Thành","path":"Phường Tân Thành, Thành phố Cà Mau, Tỉnh Cà Mau","path_with_type":"Phường Tân Thành, Thành phố Cà Mau, Tỉnh Cà Mau","code":"32025","parent_code":"964"},"32026":{"name":"Xã Tân Thành","type":"xa","slug":"xa-tan-thanh","name_with_type":"Xã Tân Thành","path":"Xã Tân Thành, Thành phố Cà Mau, Tỉnh Cà Mau","path_with_type":"Xã Tân Thành, Thành phố Cà Mau, Tỉnh Cà Mau","code":"32026","parent_code":"964"},"32029":{"name":"Xã Tắc Vân","type":"xa","slug":"xa-tac-van","name_with_type":"Xã Tắc Vân","path":"Xã Tắc Vân, Thành phố Cà Mau, Tỉnh Cà Mau","path_with_type":"Xã Tắc Vân, Thành phố Cà Mau, Tỉnh Cà Mau","code":"32029","parent_code":"964"},"32032":{"name":"Xã Lý Văn Lâm","type":"xa","slug":"xa-ly-van-lam","name_with_type":"Xã Lý Văn Lâm","path":"Xã Lý Văn Lâm, Thành phố Cà Mau, Tỉnh Cà Mau","path_with_type":"Xã Lý Văn Lâm, Thành phố Cà Mau, Tỉnh Cà Mau","code":"32032","parent_code":"964"},"32035":{"name":"Xã Định Bình","type":"xa","slug":"xa-dinh-binh","name_with_type":"Xã Định Bình","path":"Xã Định Bình, Thành phố Cà Mau, Tỉnh Cà Mau","path_with_type":"Xã Định Bình, Thành phố Cà Mau, Tỉnh Cà Mau","code":"32035","parent_code":"964"},"32038":{"name":"Xã Hòa Thành","type":"xa","slug":"xa-hoa-thanh","name_with_type":"Xã Hòa Thành","path":"Xã Hòa Thành, Thành phố Cà Mau, Tỉnh Cà Mau","path_with_type":"Xã Hòa Thành, Thành phố Cà Mau, Tỉnh Cà Mau","code":"32038","parent_code":"964"},"32041":{"name":"Xã Hòa Tân","type":"xa","slug":"xa-hoa-tan","name_with_type":"Xã Hòa Tân","path":"Xã Hòa Tân, Thành phố Cà Mau, Tỉnh Cà Mau","path_with_type":"Xã Hòa Tân, Thành phố Cà Mau, Tỉnh Cà Mau","code":"32041","parent_code":"964"},"32044":{"name":"Thị trấn U Minh","type":"thi-tran","slug":"thi-tran-u-minh","name_with_type":"Thị trấn U Minh","path":"Thị trấn U Minh, Huyện U Minh, Tỉnh Cà Mau","path_with_type":"Thị trấn U Minh, Huyện U Minh, Tỉnh Cà Mau","code":"32044","parent_code":"966"},"32047":{"name":"Xã Khánh Hòa","type":"xa","slug":"xa-khanh-hoa","name_with_type":"Xã Khánh Hòa","path":"Xã Khánh Hòa, Huyện U Minh, Tỉnh Cà Mau","path_with_type":"Xã Khánh Hòa, Huyện U Minh, Tỉnh Cà Mau","code":"32047","parent_code":"966"},"32048":{"name":"Xã Khánh Thuận","type":"xa","slug":"xa-khanh-thuan","name_with_type":"Xã Khánh Thuận","path":"Xã Khánh Thuận, Huyện U Minh, Tỉnh Cà Mau","path_with_type":"Xã Khánh Thuận, Huyện U Minh, Tỉnh Cà Mau","code":"32048","parent_code":"966"},"32050":{"name":"Xã Khánh Tiến","type":"xa","slug":"xa-khanh-tien","name_with_type":"Xã Khánh Tiến","path":"Xã Khánh Tiến, Huyện U Minh, Tỉnh Cà Mau","path_with_type":"Xã Khánh Tiến, Huyện U Minh, Tỉnh Cà Mau","code":"32050","parent_code":"966"},"32053":{"name":"Xã Nguyễn Phích","type":"xa","slug":"xa-nguyen-phich","name_with_type":"Xã Nguyễn Phích","path":"Xã Nguyễn Phích, Huyện U Minh, Tỉnh Cà Mau","path_with_type":"Xã Nguyễn Phích, Huyện U Minh, Tỉnh Cà Mau","code":"32053","parent_code":"966"},"32056":{"name":"Xã Khánh Lâm","type":"xa","slug":"xa-khanh-lam","name_with_type":"Xã Khánh Lâm","path":"Xã Khánh Lâm, Huyện U Minh, Tỉnh Cà Mau","path_with_type":"Xã Khánh Lâm, Huyện U Minh, Tỉnh Cà Mau","code":"32056","parent_code":"966"},"32059":{"name":"Xã Khánh An","type":"xa","slug":"xa-khanh-an","name_with_type":"Xã Khánh An","path":"Xã Khánh An, Huyện U Minh, Tỉnh Cà Mau","path_with_type":"Xã Khánh An, Huyện U Minh, Tỉnh Cà Mau","code":"32059","parent_code":"966"},"32062":{"name":"Xã Khánh Hội","type":"xa","slug":"xa-khanh-hoi","name_with_type":"Xã Khánh Hội","path":"Xã Khánh Hội, Huyện U Minh, Tỉnh Cà Mau","path_with_type":"Xã Khánh Hội, Huyện U Minh, Tỉnh Cà Mau","code":"32062","parent_code":"966"},"32065":{"name":"Thị trấn Thới Bình","type":"thi-tran","slug":"thi-tran-thoi-binh","name_with_type":"Thị trấn Thới Bình","path":"Thị trấn Thới Bình, Huyện Thới Bình, Tỉnh Cà Mau","path_with_type":"Thị trấn Thới Bình, Huyện Thới Bình, Tỉnh Cà Mau","code":"32065","parent_code":"967"},"32068":{"name":"Xã Biển Bạch","type":"xa","slug":"xa-bien-bach","name_with_type":"Xã Biển Bạch","path":"Xã Biển Bạch, Huyện Thới Bình, Tỉnh Cà Mau","path_with_type":"Xã Biển Bạch, Huyện Thới Bình, Tỉnh Cà Mau","code":"32068","parent_code":"967"},"32069":{"name":"Xã Tân Bằng","type":"xa","slug":"xa-tan-bang","name_with_type":"Xã Tân Bằng","path":"Xã Tân Bằng, Huyện Thới Bình, Tỉnh Cà Mau","path_with_type":"Xã Tân Bằng, Huyện Thới Bình, Tỉnh Cà Mau","code":"32069","parent_code":"967"},"32071":{"name":"Xã Trí Phải","type":"xa","slug":"xa-tri-phai","name_with_type":"Xã Trí Phải","path":"Xã Trí Phải, Huyện Thới Bình, Tỉnh Cà Mau","path_with_type":"Xã Trí Phải, Huyện Thới Bình, Tỉnh Cà Mau","code":"32071","parent_code":"967"},"32072":{"name":"Xã Trí Lực","type":"xa","slug":"xa-tri-luc","name_with_type":"Xã Trí Lực","path":"Xã Trí Lực, Huyện Thới Bình, Tỉnh Cà Mau","path_with_type":"Xã Trí Lực, Huyện Thới Bình, Tỉnh Cà Mau","code":"32072","parent_code":"967"},"32074":{"name":"Xã Biển Bạch Đông","type":"xa","slug":"xa-bien-bach-dong","name_with_type":"Xã Biển Bạch Đông","path":"Xã Biển Bạch Đông, Huyện Thới Bình, Tỉnh Cà Mau","path_with_type":"Xã Biển Bạch Đông, Huyện Thới Bình, Tỉnh Cà Mau","code":"32074","parent_code":"967"},"32077":{"name":"Xã Thới Bình","type":"xa","slug":"xa-thoi-binh","name_with_type":"Xã Thới Bình","path":"Xã Thới Bình, Huyện Thới Bình, Tỉnh Cà Mau","path_with_type":"Xã Thới Bình, Huyện Thới Bình, Tỉnh Cà Mau","code":"32077","parent_code":"967"},"32080":{"name":"Xã Tân Phú","type":"xa","slug":"xa-tan-phu","name_with_type":"Xã Tân Phú","path":"Xã Tân Phú, Huyện Thới Bình, Tỉnh Cà Mau","path_with_type":"Xã Tân Phú, Huyện Thới Bình, Tỉnh Cà Mau","code":"32080","parent_code":"967"},"32083":{"name":"Xã Tân Lộc Bắc","type":"xa","slug":"xa-tan-loc-bac","name_with_type":"Xã Tân Lộc Bắc","path":"Xã Tân Lộc Bắc, Huyện Thới Bình, Tỉnh Cà Mau","path_with_type":"Xã Tân Lộc Bắc, Huyện Thới Bình, Tỉnh Cà Mau","code":"32083","parent_code":"967"},"32086":{"name":"Xã Tân Lộc","type":"xa","slug":"xa-tan-loc","name_with_type":"Xã Tân Lộc","path":"Xã Tân Lộc, Huyện Thới Bình, Tỉnh Cà Mau","path_with_type":"Xã Tân Lộc, Huyện Thới Bình, Tỉnh Cà Mau","code":"32086","parent_code":"967"},"32089":{"name":"Xã Tân Lộc Đông","type":"xa","slug":"xa-tan-loc-dong","name_with_type":"Xã Tân Lộc Đông","path":"Xã Tân Lộc Đông, Huyện Thới Bình, Tỉnh Cà Mau","path_with_type":"Xã Tân Lộc Đông, Huyện Thới Bình, Tỉnh Cà Mau","code":"32089","parent_code":"967"},"32092":{"name":"Xã Hồ Thị Kỷ","type":"xa","slug":"xa-ho-thi-ky","name_with_type":"Xã Hồ Thị Kỷ","path":"Xã Hồ Thị Kỷ, Huyện Thới Bình, Tỉnh Cà Mau","path_with_type":"Xã Hồ Thị Kỷ, Huyện Thới Bình, Tỉnh Cà Mau","code":"32092","parent_code":"967"},"32095":{"name":"Thị trấn Trần Văn Thời","type":"thi-tran","slug":"thi-tran-tran-van-thoi","name_with_type":"Thị trấn Trần Văn Thời","path":"Thị trấn Trần Văn Thời, Huyện Trần Văn Thời, Tỉnh Cà Mau","path_with_type":"Thị trấn Trần Văn Thời, Huyện Trần Văn Thời, Tỉnh Cà Mau","code":"32095","parent_code":"968"},"32098":{"name":"Thị trấn Sông Đốc","type":"thi-tran","slug":"thi-tran-song-doc","name_with_type":"Thị trấn Sông Đốc","path":"Thị trấn Sông Đốc, Huyện Trần Văn Thời, Tỉnh Cà Mau","path_with_type":"Thị trấn Sông Đốc, Huyện Trần Văn Thời, Tỉnh Cà Mau","code":"32098","parent_code":"968"},"32101":{"name":"Xã Khánh Bình Tây Bắc","type":"xa","slug":"xa-khanh-binh-tay-bac","name_with_type":"Xã Khánh Bình Tây Bắc","path":"Xã Khánh Bình Tây Bắc, Huyện Trần Văn Thời, Tỉnh Cà Mau","path_with_type":"Xã Khánh Bình Tây Bắc, Huyện Trần Văn Thời, Tỉnh Cà Mau","code":"32101","parent_code":"968"},"32104":{"name":"Xã Khánh Bình Tây","type":"xa","slug":"xa-khanh-binh-tay","name_with_type":"Xã Khánh Bình Tây","path":"Xã Khánh Bình Tây, Huyện Trần Văn Thời, Tỉnh Cà Mau","path_with_type":"Xã Khánh Bình Tây, Huyện Trần Văn Thời, Tỉnh Cà Mau","code":"32104","parent_code":"968"},"32107":{"name":"Xã Trần Hợi","type":"xa","slug":"xa-tran-hoi","name_with_type":"Xã Trần Hợi","path":"Xã Trần Hợi, Huyện Trần Văn Thời, Tỉnh Cà Mau","path_with_type":"Xã Trần Hợi, Huyện Trần Văn Thời, Tỉnh Cà Mau","code":"32107","parent_code":"968"},"32108":{"name":"Xã Khánh Lộc","type":"xa","slug":"xa-khanh-loc","name_with_type":"Xã Khánh Lộc","path":"Xã Khánh Lộc, Huyện Trần Văn Thời, Tỉnh Cà Mau","path_with_type":"Xã Khánh Lộc, Huyện Trần Văn Thời, Tỉnh Cà Mau","code":"32108","parent_code":"968"},"32110":{"name":"Xã Khánh Bình","type":"xa","slug":"xa-khanh-binh","name_with_type":"Xã Khánh Bình","path":"Xã Khánh Bình, Huyện Trần Văn Thời, Tỉnh Cà Mau","path_with_type":"Xã Khánh Bình, Huyện Trần Văn Thời, Tỉnh Cà Mau","code":"32110","parent_code":"968"},"32113":{"name":"Xã Khánh Hưng","type":"xa","slug":"xa-khanh-hung","name_with_type":"Xã Khánh Hưng","path":"Xã Khánh Hưng, Huyện Trần Văn Thời, Tỉnh Cà Mau","path_with_type":"Xã Khánh Hưng, Huyện Trần Văn Thời, Tỉnh Cà Mau","code":"32113","parent_code":"968"},"32116":{"name":"Xã Khánh Bình Đông","type":"xa","slug":"xa-khanh-binh-dong","name_with_type":"Xã Khánh Bình Đông","path":"Xã Khánh Bình Đông, Huyện Trần Văn Thời, Tỉnh Cà Mau","path_with_type":"Xã Khánh Bình Đông, Huyện Trần Văn Thời, Tỉnh Cà Mau","code":"32116","parent_code":"968"},"32119":{"name":"Xã Khánh Hải","type":"xa","slug":"xa-khanh-hai","name_with_type":"Xã Khánh Hải","path":"Xã Khánh Hải, Huyện Trần Văn Thời, Tỉnh Cà Mau","path_with_type":"Xã Khánh Hải, Huyện Trần Văn Thời, Tỉnh Cà Mau","code":"32119","parent_code":"968"},"32122":{"name":"Xã Lợi An","type":"xa","slug":"xa-loi-an","name_with_type":"Xã Lợi An","path":"Xã Lợi An, Huyện Trần Văn Thời, Tỉnh Cà Mau","path_with_type":"Xã Lợi An, Huyện Trần Văn Thời, Tỉnh Cà Mau","code":"32122","parent_code":"968"},"32124":{"name":"Xã Phong Điền","type":"xa","slug":"xa-phong-dien","name_with_type":"Xã Phong Điền","path":"Xã Phong Điền, Huyện Trần Văn Thời, Tỉnh Cà Mau","path_with_type":"Xã Phong Điền, Huyện Trần Văn Thời, Tỉnh Cà Mau","code":"32124","parent_code":"968"},"32125":{"name":"Xã Phong Lạc","type":"xa","slug":"xa-phong-lac","name_with_type":"Xã Phong Lạc","path":"Xã Phong Lạc, Huyện Trần Văn Thời, Tỉnh Cà Mau","path_with_type":"Xã Phong Lạc, Huyện Trần Văn Thời, Tỉnh Cà Mau","code":"32125","parent_code":"968"},"32128":{"name":"Thị trấn Cái Nước","type":"thi-tran","slug":"thi-tran-cai-nuoc","name_with_type":"Thị trấn Cái Nước","path":"Thị trấn Cái Nước, Huyện Cái Nước, Tỉnh Cà Mau","path_with_type":"Thị trấn Cái Nước, Huyện Cái Nước, Tỉnh Cà Mau","code":"32128","parent_code":"969"},"32130":{"name":"Xã Thạnh Phú","type":"xa","slug":"xa-thanh-phu","name_with_type":"Xã Thạnh Phú","path":"Xã Thạnh Phú, Huyện Cái Nước, Tỉnh Cà Mau","path_with_type":"Xã Thạnh Phú, Huyện Cái Nước, Tỉnh Cà Mau","code":"32130","parent_code":"969"},"32131":{"name":"Xã Lương Thế Trân","type":"xa","slug":"xa-luong-the-tran","name_with_type":"Xã Lương Thế Trân","path":"Xã Lương Thế Trân, Huyện Cái Nước, Tỉnh Cà Mau","path_with_type":"Xã Lương Thế Trân, Huyện Cái Nước, Tỉnh Cà Mau","code":"32131","parent_code":"969"},"32134":{"name":"Xã Phú Hưng","type":"xa","slug":"xa-phu-hung","name_with_type":"Xã Phú Hưng","path":"Xã Phú Hưng, Huyện Cái Nước, Tỉnh Cà Mau","path_with_type":"Xã Phú Hưng, Huyện Cái Nước, Tỉnh Cà Mau","code":"32134","parent_code":"969"},"32137":{"name":"Xã Tân Hưng","type":"xa","slug":"xa-tan-hung","name_with_type":"Xã Tân Hưng","path":"Xã Tân Hưng, Huyện Cái Nước, Tỉnh Cà Mau","path_with_type":"Xã Tân Hưng, Huyện Cái Nước, Tỉnh Cà Mau","code":"32137","parent_code":"969"},"32140":{"name":"Xã Hưng Mỹ","type":"xa","slug":"xa-hung-my","name_with_type":"Xã Hưng Mỹ","path":"Xã Hưng Mỹ, Huyện Cái Nước, Tỉnh Cà Mau","path_with_type":"Xã Hưng Mỹ, Huyện Cái Nước, Tỉnh Cà Mau","code":"32140","parent_code":"969"},"32141":{"name":"Xã Hoà Mỹ","type":"xa","slug":"xa-hoa-my","name_with_type":"Xã Hoà Mỹ","path":"Xã Hoà Mỹ, Huyện Cái Nước, Tỉnh Cà Mau","path_with_type":"Xã Hoà Mỹ, Huyện Cái Nước, Tỉnh Cà Mau","code":"32141","parent_code":"969"},"32142":{"name":"Xã Đông Hưng","type":"xa","slug":"xa-dong-hung","name_with_type":"Xã Đông Hưng","path":"Xã Đông Hưng, Huyện Cái Nước, Tỉnh Cà Mau","path_with_type":"Xã Đông Hưng, Huyện Cái Nước, Tỉnh Cà Mau","code":"32142","parent_code":"969"},"32143":{"name":"Xã Đông Thới","type":"xa","slug":"xa-dong-thoi","name_with_type":"Xã Đông Thới","path":"Xã Đông Thới, Huyện Cái Nước, Tỉnh Cà Mau","path_with_type":"Xã Đông Thới, Huyện Cái Nước, Tỉnh Cà Mau","code":"32143","parent_code":"969"},"32146":{"name":"Xã Tân Hưng Đông","type":"xa","slug":"xa-tan-hung-dong","name_with_type":"Xã Tân Hưng Đông","path":"Xã Tân Hưng Đông, Huyện Cái Nước, Tỉnh Cà Mau","path_with_type":"Xã Tân Hưng Đông, Huyện Cái Nước, Tỉnh Cà Mau","code":"32146","parent_code":"969"},"32149":{"name":"Xã Trần Thới","type":"xa","slug":"xa-tran-thoi","name_with_type":"Xã Trần Thới","path":"Xã Trần Thới, Huyện Cái Nước, Tỉnh Cà Mau","path_with_type":"Xã Trần Thới, Huyện Cái Nước, Tỉnh Cà Mau","code":"32149","parent_code":"969"},"32152":{"name":"Thị trấn Đầm Dơi","type":"thi-tran","slug":"thi-tran-dam-doi","name_with_type":"Thị trấn Đầm Dơi","path":"Thị trấn Đầm Dơi, Huyện Đầm Dơi, Tỉnh Cà Mau","path_with_type":"Thị trấn Đầm Dơi, Huyện Đầm Dơi, Tỉnh Cà Mau","code":"32152","parent_code":"970"},"32155":{"name":"Xã Tạ An Khương","type":"xa","slug":"xa-ta-an-khuong","name_with_type":"Xã Tạ An Khương","path":"Xã Tạ An Khương, Huyện Đầm Dơi, Tỉnh Cà Mau","path_with_type":"Xã Tạ An Khương, Huyện Đầm Dơi, Tỉnh Cà Mau","code":"32155","parent_code":"970"},"32158":{"name":"Xã Tạ An Khương  Đông","type":"xa","slug":"xa-ta-an-khuong-dong","name_with_type":"Xã Tạ An Khương  Đông","path":"Xã Tạ An Khương  Đông, Huyện Đầm Dơi, Tỉnh Cà Mau","path_with_type":"Xã Tạ An Khương  Đông, Huyện Đầm Dơi, Tỉnh Cà Mau","code":"32158","parent_code":"970"},"32161":{"name":"Xã Trần Phán","type":"xa","slug":"xa-tran-phan","name_with_type":"Xã Trần Phán","path":"Xã Trần Phán, Huyện Đầm Dơi, Tỉnh Cà Mau","path_with_type":"Xã Trần Phán, Huyện Đầm Dơi, Tỉnh Cà Mau","code":"32161","parent_code":"970"},"32162":{"name":"Xã Tân Trung","type":"xa","slug":"xa-tan-trung","name_with_type":"Xã Tân Trung","path":"Xã Tân Trung, Huyện Đầm Dơi, Tỉnh Cà Mau","path_with_type":"Xã Tân Trung, Huyện Đầm Dơi, Tỉnh Cà Mau","code":"32162","parent_code":"970"},"32164":{"name":"Xã Tân Đức","type":"xa","slug":"xa-tan-duc","name_with_type":"Xã Tân Đức","path":"Xã Tân Đức, Huyện Đầm Dơi, Tỉnh Cà Mau","path_with_type":"Xã Tân Đức, Huyện Đầm Dơi, Tỉnh Cà Mau","code":"32164","parent_code":"970"},"32167":{"name":"Xã Tân Thuận","type":"xa","slug":"xa-tan-thuan","name_with_type":"Xã Tân Thuận","path":"Xã Tân Thuận, Huyện Đầm Dơi, Tỉnh Cà Mau","path_with_type":"Xã Tân Thuận, Huyện Đầm Dơi, Tỉnh Cà Mau","code":"32167","parent_code":"970"},"32170":{"name":"Xã Tạ An Khương  Nam","type":"xa","slug":"xa-ta-an-khuong-nam","name_with_type":"Xã Tạ An Khương  Nam","path":"Xã Tạ An Khương  Nam, Huyện Đầm Dơi, Tỉnh Cà Mau","path_with_type":"Xã Tạ An Khương  Nam, Huyện Đầm Dơi, Tỉnh Cà Mau","code":"32170","parent_code":"970"},"32173":{"name":"Xã Tân Duyệt","type":"xa","slug":"xa-tan-duyet","name_with_type":"Xã Tân Duyệt","path":"Xã Tân Duyệt, Huyện Đầm Dơi, Tỉnh Cà Mau","path_with_type":"Xã Tân Duyệt, Huyện Đầm Dơi, Tỉnh Cà Mau","code":"32173","parent_code":"970"},"32174":{"name":"Xã Tân Dân","type":"xa","slug":"xa-tan-dan","name_with_type":"Xã Tân Dân","path":"Xã Tân Dân, Huyện Đầm Dơi, Tỉnh Cà Mau","path_with_type":"Xã Tân Dân, Huyện Đầm Dơi, Tỉnh Cà Mau","code":"32174","parent_code":"970"},"32176":{"name":"Xã Tân Tiến","type":"xa","slug":"xa-tan-tien","name_with_type":"Xã Tân Tiến","path":"Xã Tân Tiến, Huyện Đầm Dơi, Tỉnh Cà Mau","path_with_type":"Xã Tân Tiến, Huyện Đầm Dơi, Tỉnh Cà Mau","code":"32176","parent_code":"970"},"32179":{"name":"Xã Quách Phẩm Bắc","type":"xa","slug":"xa-quach-pham-bac","name_with_type":"Xã Quách Phẩm Bắc","path":"Xã Quách Phẩm Bắc, Huyện Đầm Dơi, Tỉnh Cà Mau","path_with_type":"Xã Quách Phẩm Bắc, Huyện Đầm Dơi, Tỉnh Cà Mau","code":"32179","parent_code":"970"},"32182":{"name":"Xã Quách Phẩm","type":"xa","slug":"xa-quach-pham","name_with_type":"Xã Quách Phẩm","path":"Xã Quách Phẩm, Huyện Đầm Dơi, Tỉnh Cà Mau","path_with_type":"Xã Quách Phẩm, Huyện Đầm Dơi, Tỉnh Cà Mau","code":"32182","parent_code":"970"},"32185":{"name":"Xã Thanh Tùng","type":"xa","slug":"xa-thanh-tung","name_with_type":"Xã Thanh Tùng","path":"Xã Thanh Tùng, Huyện Đầm Dơi, Tỉnh Cà Mau","path_with_type":"Xã Thanh Tùng, Huyện Đầm Dơi, Tỉnh Cà Mau","code":"32185","parent_code":"970"},"32186":{"name":"Xã Ngọc Chánh","type":"xa","slug":"xa-ngoc-chanh","name_with_type":"Xã Ngọc Chánh","path":"Xã Ngọc Chánh, Huyện Đầm Dơi, Tỉnh Cà Mau","path_with_type":"Xã Ngọc Chánh, Huyện Đầm Dơi, Tỉnh Cà Mau","code":"32186","parent_code":"970"},"32188":{"name":"Xã Nguyễn Huân","type":"xa","slug":"xa-nguyen-huan","name_with_type":"Xã Nguyễn Huân","path":"Xã Nguyễn Huân, Huyện Đầm Dơi, Tỉnh Cà Mau","path_with_type":"Xã Nguyễn Huân, Huyện Đầm Dơi, Tỉnh Cà Mau","code":"32188","parent_code":"970"},"32191":{"name":"Thị Trấn Năm Căn","type":"thi-tran","slug":"thi-tran-nam-can","name_with_type":"Thị Trấn Năm Căn","path":"Thị Trấn Năm Căn, Huyện Năm Căn, Tỉnh Cà Mau","path_with_type":"Thị Trấn Năm Căn, Huyện Năm Căn, Tỉnh Cà Mau","code":"32191","parent_code":"971"},"32194":{"name":"Xã Hàm Rồng","type":"xa","slug":"xa-ham-rong","name_with_type":"Xã Hàm Rồng","path":"Xã Hàm Rồng, Huyện Năm Căn, Tỉnh Cà Mau","path_with_type":"Xã Hàm Rồng, Huyện Năm Căn, Tỉnh Cà Mau","code":"32194","parent_code":"971"},"32197":{"name":"Xã Hiệp Tùng","type":"xa","slug":"xa-hiep-tung","name_with_type":"Xã Hiệp Tùng","path":"Xã Hiệp Tùng, Huyện Năm Căn, Tỉnh Cà Mau","path_with_type":"Xã Hiệp Tùng, Huyện Năm Căn, Tỉnh Cà Mau","code":"32197","parent_code":"971"},"32200":{"name":"Xã Đất Mới","type":"xa","slug":"xa-dat-moi","name_with_type":"Xã Đất Mới","path":"Xã Đất Mới, Huyện Năm Căn, Tỉnh Cà Mau","path_with_type":"Xã Đất Mới, Huyện Năm Căn, Tỉnh Cà Mau","code":"32200","parent_code":"971"},"32201":{"name":"Xã Lâm Hải","type":"xa","slug":"xa-lam-hai","name_with_type":"Xã Lâm Hải","path":"Xã Lâm Hải, Huyện Năm Căn, Tỉnh Cà Mau","path_with_type":"Xã Lâm Hải, Huyện Năm Căn, Tỉnh Cà Mau","code":"32201","parent_code":"971"},"32203":{"name":"Xã Hàng Vịnh","type":"xa","slug":"xa-hang-vinh","name_with_type":"Xã Hàng Vịnh","path":"Xã Hàng Vịnh, Huyện Năm Căn, Tỉnh Cà Mau","path_with_type":"Xã Hàng Vịnh, Huyện Năm Căn, Tỉnh Cà Mau","code":"32203","parent_code":"971"},"32206":{"name":"Xã Tam Giang","type":"xa","slug":"xa-tam-giang","name_with_type":"Xã Tam Giang","path":"Xã Tam Giang, Huyện Năm Căn, Tỉnh Cà Mau","path_with_type":"Xã Tam Giang, Huyện Năm Căn, Tỉnh Cà Mau","code":"32206","parent_code":"971"},"32209":{"name":"Xã Tam Giang Đông","type":"xa","slug":"xa-tam-giang-dong","name_with_type":"Xã Tam Giang Đông","path":"Xã Tam Giang Đông, Huyện Năm Căn, Tỉnh Cà Mau","path_with_type":"Xã Tam Giang Đông, Huyện Năm Căn, Tỉnh Cà Mau","code":"32209","parent_code":"971"},"32212":{"name":"Thị trấn Cái Đôi Vàm","type":"thi-tran","slug":"thi-tran-cai-doi-vam","name_with_type":"Thị trấn Cái Đôi Vàm","path":"Thị trấn Cái Đôi Vàm, Huyện Phú Tân, Tỉnh Cà Mau","path_with_type":"Thị trấn Cái Đôi Vàm, Huyện Phú Tân, Tỉnh Cà Mau","code":"32212","parent_code":"972"},"32214":{"name":"Xã Phú Thuận","type":"xa","slug":"xa-phu-thuan","name_with_type":"Xã Phú Thuận","path":"Xã Phú Thuận, Huyện Phú Tân, Tỉnh Cà Mau","path_with_type":"Xã Phú Thuận, Huyện Phú Tân, Tỉnh Cà Mau","code":"32214","parent_code":"972"},"32215":{"name":"Xã Phú Mỹ","type":"xa","slug":"xa-phu-my","name_with_type":"Xã Phú Mỹ","path":"Xã Phú Mỹ, Huyện Phú Tân, Tỉnh Cà Mau","path_with_type":"Xã Phú Mỹ, Huyện Phú Tân, Tỉnh Cà Mau","code":"32215","parent_code":"972"},"32218":{"name":"Xã Phú Tân","type":"xa","slug":"xa-phu-tan","name_with_type":"Xã Phú Tân","path":"Xã Phú Tân, Huyện Phú Tân, Tỉnh Cà Mau","path_with_type":"Xã Phú Tân, Huyện Phú Tân, Tỉnh Cà Mau","code":"32218","parent_code":"972"},"32221":{"name":"Xã Tân Hải","type":"xa","slug":"xa-tan-hai","name_with_type":"Xã Tân Hải","path":"Xã Tân Hải, Huyện Phú Tân, Tỉnh Cà Mau","path_with_type":"Xã Tân Hải, Huyện Phú Tân, Tỉnh Cà Mau","code":"32221","parent_code":"972"},"32224":{"name":"Xã Việt Thắng","type":"xa","slug":"xa-viet-thang","name_with_type":"Xã Việt Thắng","path":"Xã Việt Thắng, Huyện Phú Tân, Tỉnh Cà Mau","path_with_type":"Xã Việt Thắng, Huyện Phú Tân, Tỉnh Cà Mau","code":"32224","parent_code":"972"},"32227":{"name":"Xã Tân Hưng Tây","type":"xa","slug":"xa-tan-hung-tay","name_with_type":"Xã Tân Hưng Tây","path":"Xã Tân Hưng Tây, Huyện Phú Tân, Tỉnh Cà Mau","path_with_type":"Xã Tân Hưng Tây, Huyện Phú Tân, Tỉnh Cà Mau","code":"32227","parent_code":"972"},"32228":{"name":"Xã Rạch Chèo","type":"xa","slug":"xa-rach-cheo","name_with_type":"Xã Rạch Chèo","path":"Xã Rạch Chèo, Huyện Phú Tân, Tỉnh Cà Mau","path_with_type":"Xã Rạch Chèo, Huyện Phú Tân, Tỉnh Cà Mau","code":"32228","parent_code":"972"},"32230":{"name":"Xã Nguyễn Việt Khái","type":"xa","slug":"xa-nguyen-viet-khai","name_with_type":"Xã Nguyễn Việt Khái","path":"Xã Nguyễn Việt Khái, Huyện Phú Tân, Tỉnh Cà Mau","path_with_type":"Xã Nguyễn Việt Khái, Huyện Phú Tân, Tỉnh Cà Mau","code":"32230","parent_code":"972"},"32233":{"name":"Xã Tam Giang Tây","type":"xa","slug":"xa-tam-giang-tay","name_with_type":"Xã Tam Giang Tây","path":"Xã Tam Giang Tây, Huyện Ngọc Hiển, Tỉnh Cà Mau","path_with_type":"Xã Tam Giang Tây, Huyện Ngọc Hiển, Tỉnh Cà Mau","code":"32233","parent_code":"973"},"32236":{"name":"Xã Tân Ân Tây","type":"xa","slug":"xa-tan-an-tay","name_with_type":"Xã Tân Ân Tây","path":"Xã Tân Ân Tây, Huyện Ngọc Hiển, Tỉnh Cà Mau","path_with_type":"Xã Tân Ân Tây, Huyện Ngọc Hiển, Tỉnh Cà Mau","code":"32236","parent_code":"973"},"32239":{"name":"Xã Viên An Đông","type":"xa","slug":"xa-vien-an-dong","name_with_type":"Xã Viên An Đông","path":"Xã Viên An Đông, Huyện Ngọc Hiển, Tỉnh Cà Mau","path_with_type":"Xã Viên An Đông, Huyện Ngọc Hiển, Tỉnh Cà Mau","code":"32239","parent_code":"973"},"32242":{"name":"Xã Viên An","type":"xa","slug":"xa-vien-an","name_with_type":"Xã Viên An","path":"Xã Viên An, Huyện Ngọc Hiển, Tỉnh Cà Mau","path_with_type":"Xã Viên An, Huyện Ngọc Hiển, Tỉnh Cà Mau","code":"32242","parent_code":"973"},"32244":{"name":"Thị trấn Rạch Gốc","type":"thi-tran","slug":"thi-tran-rach-goc","name_with_type":"Thị trấn Rạch Gốc","path":"Thị trấn Rạch Gốc, Huyện Ngọc Hiển, Tỉnh Cà Mau","path_with_type":"Thị trấn Rạch Gốc, Huyện Ngọc Hiển, Tỉnh Cà Mau","code":"32244","parent_code":"973"},"32245":{"name":"Xã Tân Ân","type":"xa","slug":"xa-tan-an","name_with_type":"Xã Tân Ân","path":"Xã Tân Ân, Huyện Ngọc Hiển, Tỉnh Cà Mau","path_with_type":"Xã Tân Ân, Huyện Ngọc Hiển, Tỉnh Cà Mau","code":"32245","parent_code":"973"},"32248":{"name":"Xã Đất Mũi","type":"xa","slug":"xa-dat-mui","name_with_type":"Xã Đất Mũi","path":"Xã Đất Mũi, Huyện Ngọc Hiển, Tỉnh Cà Mau","path_with_type":"Xã Đất Mũi, Huyện Ngọc Hiển, Tỉnh Cà Mau","code":"32248","parent_code":"973"},"00001":{"name":"Phường Phúc Xá","type":"phuong","slug":"phuong-phuc-xa","name_with_type":"Phường Phúc Xá","path":"Phường Phúc Xá, Quận Ba Đình, Thành phố Hà Nội","path_with_type":"Phường Phúc Xá, Quận Ba Đình, Thành phố Hà Nội","code":"00001","parent_code":"001"},"00004":{"name":"Phường Trúc Bạch","type":"phuong","slug":"phuong-truc-bach","name_with_type":"Phường Trúc Bạch","path":"Phường Trúc Bạch, Quận Ba Đình, Thành phố Hà Nội","path_with_type":"Phường Trúc Bạch, Quận Ba Đình, Thành phố Hà Nội","code":"00004","parent_code":"001"},"00006":{"name":"Phường Vĩnh Phúc","type":"phuong","slug":"phuong-vinh-phuc","name_with_type":"Phường Vĩnh Phúc","path":"Phường Vĩnh Phúc, Quận Ba Đình, Thành phố Hà Nội","path_with_type":"Phường Vĩnh Phúc, Quận Ba Đình, Thành phố Hà Nội","code":"00006","parent_code":"001"},"00007":{"name":"Phường Cống Vị","type":"phuong","slug":"phuong-cong-vi","name_with_type":"Phường Cống Vị","path":"Phường Cống Vị, Quận Ba Đình, Thành phố Hà Nội","path_with_type":"Phường Cống Vị, Quận Ba Đình, Thành phố Hà Nội","code":"00007","parent_code":"001"},"00008":{"name":"Phường Liễu Giai","type":"phuong","slug":"phuong-lieu-giai","name_with_type":"Phường Liễu Giai","path":"Phường Liễu Giai, Quận Ba Đình, Thành phố Hà Nội","path_with_type":"Phường Liễu Giai, Quận Ba Đình, Thành phố Hà Nội","code":"00008","parent_code":"001"},"00013":{"name":"Phường Quán Thánh","type":"phuong","slug":"phuong-quan-thanh","name_with_type":"Phường Quán Thánh","path":"Phường Quán Thánh, Quận Ba Đình, Thành phố Hà Nội","path_with_type":"Phường Quán Thánh, Quận Ba Đình, Thành phố Hà Nội","code":"00013","parent_code":"001"},"00016":{"name":"Phường Ngọc Hà","type":"phuong","slug":"phuong-ngoc-ha","name_with_type":"Phường Ngọc Hà","path":"Phường Ngọc Hà, Quận Ba Đình, Thành phố Hà Nội","path_with_type":"Phường Ngọc Hà, Quận Ba Đình, Thành phố Hà Nội","code":"00016","parent_code":"001"},"00019":{"name":"Phường Điện Biên","type":"phuong","slug":"phuong-dien-bien","name_with_type":"Phường Điện Biên","path":"Phường Điện Biên, Quận Ba Đình, Thành phố Hà Nội","path_with_type":"Phường Điện Biên, Quận Ba Đình, Thành phố Hà Nội","code":"00019","parent_code":"001"},"00022":{"name":"Phường Đội Cấn","type":"phuong","slug":"phuong-doi-can","name_with_type":"Phường Đội Cấn","path":"Phường Đội Cấn, Quận Ba Đình, Thành phố Hà Nội","path_with_type":"Phường Đội Cấn, Quận Ba Đình, Thành phố Hà Nội","code":"00022","parent_code":"001"},"00025":{"name":"Phường Ngọc Khánh","type":"phuong","slug":"phuong-ngoc-khanh","name_with_type":"Phường Ngọc Khánh","path":"Phường Ngọc Khánh, Quận Ba Đình, Thành phố Hà Nội","path_with_type":"Phường Ngọc Khánh, Quận Ba Đình, Thành phố Hà Nội","code":"00025","parent_code":"001"},"00028":{"name":"Phường Kim Mã","type":"phuong","slug":"phuong-kim-ma","name_with_type":"Phường Kim Mã","path":"Phường Kim Mã, Quận Ba Đình, Thành phố Hà Nội","path_with_type":"Phường Kim Mã, Quận Ba Đình, Thành phố Hà Nội","code":"00028","parent_code":"001"},"00031":{"name":"Phường Giảng Võ","type":"phuong","slug":"phuong-giang-vo","name_with_type":"Phường Giảng Võ","path":"Phường Giảng Võ, Quận Ba Đình, Thành phố Hà Nội","path_with_type":"Phường Giảng Võ, Quận Ba Đình, Thành phố Hà Nội","code":"00031","parent_code":"001"},"00034":{"name":"Phường Thành Công","type":"phuong","slug":"phuong-thanh-cong","name_with_type":"Phường Thành Công","path":"Phường Thành Công, Quận Ba Đình, Thành phố Hà Nội","path_with_type":"Phường Thành Công, Quận Ba Đình, Thành phố Hà Nội","code":"00034","parent_code":"001"},"00037":{"name":"Phường Phúc Tân","type":"phuong","slug":"phuong-phuc-tan","name_with_type":"Phường Phúc Tân","path":"Phường Phúc Tân, Quận Hoàn Kiếm, Thành phố Hà Nội","path_with_type":"Phường Phúc Tân, Quận Hoàn Kiếm, Thành phố Hà Nội","code":"00037","parent_code":"002"},"00040":{"name":"Phường Đồng Xuân","type":"phuong","slug":"phuong-dong-xuan","name_with_type":"Phường Đồng Xuân","path":"Phường Đồng Xuân, Quận Hoàn Kiếm, Thành phố Hà Nội","path_with_type":"Phường Đồng Xuân, Quận Hoàn Kiếm, Thành phố Hà Nội","code":"00040","parent_code":"002"},"00043":{"name":"Phường Hàng Mã","type":"phuong","slug":"phuong-hang-ma","name_with_type":"Phường Hàng Mã","path":"Phường Hàng Mã, Quận Hoàn Kiếm, Thành phố Hà Nội","path_with_type":"Phường Hàng Mã, Quận Hoàn Kiếm, Thành phố Hà Nội","code":"00043","parent_code":"002"},"00046":{"name":"Phường Hàng Buồm","type":"phuong","slug":"phuong-hang-buom","name_with_type":"Phường Hàng Buồm","path":"Phường Hàng Buồm, Quận Hoàn Kiếm, Thành phố Hà Nội","path_with_type":"Phường Hàng Buồm, Quận Hoàn Kiếm, Thành phố Hà Nội","code":"00046","parent_code":"002"},"00049":{"name":"Phường Hàng Đào","type":"phuong","slug":"phuong-hang-dao","name_with_type":"Phường Hàng Đào","path":"Phường Hàng Đào, Quận Hoàn Kiếm, Thành phố Hà Nội","path_with_type":"Phường Hàng Đào, Quận Hoàn Kiếm, Thành phố Hà Nội","code":"00049","parent_code":"002"},"00052":{"name":"Phường Hàng Bồ","type":"phuong","slug":"phuong-hang-bo","name_with_type":"Phường Hàng Bồ","path":"Phường Hàng Bồ, Quận Hoàn Kiếm, Thành phố Hà Nội","path_with_type":"Phường Hàng Bồ, Quận Hoàn Kiếm, Thành phố Hà Nội","code":"00052","parent_code":"002"},"00055":{"name":"Phường Cửa Đông","type":"phuong","slug":"phuong-cua-dong","name_with_type":"Phường Cửa Đông","path":"Phường Cửa Đông, Quận Hoàn Kiếm, Thành phố Hà Nội","path_with_type":"Phường Cửa Đông, Quận Hoàn Kiếm, Thành phố Hà Nội","code":"00055","parent_code":"002"},"00058":{"name":"Phường Lý Thái Tổ","type":"phuong","slug":"phuong-ly-thai-to","name_with_type":"Phường Lý Thái Tổ","path":"Phường Lý Thái Tổ, Quận Hoàn Kiếm, Thành phố Hà Nội","path_with_type":"Phường Lý Thái Tổ, Quận Hoàn Kiếm, Thành phố Hà Nội","code":"00058","parent_code":"002"},"00061":{"name":"Phường Hàng Bạc","type":"phuong","slug":"phuong-hang-bac","name_with_type":"Phường Hàng Bạc","path":"Phường Hàng Bạc, Quận Hoàn Kiếm, Thành phố Hà Nội","path_with_type":"Phường Hàng Bạc, Quận Hoàn Kiếm, Thành phố Hà Nội","code":"00061","parent_code":"002"},"00064":{"name":"Phường Hàng Gai","type":"phuong","slug":"phuong-hang-gai","name_with_type":"Phường Hàng Gai","path":"Phường Hàng Gai, Quận Hoàn Kiếm, Thành phố Hà Nội","path_with_type":"Phường Hàng Gai, Quận Hoàn Kiếm, Thành phố Hà Nội","code":"00064","parent_code":"002"},"00067":{"name":"Phường Chương Dương","type":"phuong","slug":"phuong-chuong-duong","name_with_type":"Phường Chương Dương","path":"Phường Chương Dương, Quận Hoàn Kiếm, Thành phố Hà Nội","path_with_type":"Phường Chương Dương, Quận Hoàn Kiếm, Thành phố Hà Nội","code":"00067","parent_code":"002"},"00070":{"name":"Phường Hàng Trống","type":"phuong","slug":"phuong-hang-trong","name_with_type":"Phường Hàng Trống","path":"Phường Hàng Trống, Quận Hoàn Kiếm, Thành phố Hà Nội","path_with_type":"Phường Hàng Trống, Quận Hoàn Kiếm, Thành phố Hà Nội","code":"00070","parent_code":"002"},"00073":{"name":"Phường Cửa Nam","type":"phuong","slug":"phuong-cua-nam","name_with_type":"Phường Cửa Nam","path":"Phường Cửa Nam, Quận Hoàn Kiếm, Thành phố Hà Nội","path_with_type":"Phường Cửa Nam, Quận Hoàn Kiếm, Thành phố Hà Nội","code":"00073","parent_code":"002"},"00076":{"name":"Phường Hàng Bông","type":"phuong","slug":"phuong-hang-bong","name_with_type":"Phường Hàng Bông","path":"Phường Hàng Bông, Quận Hoàn Kiếm, Thành phố Hà Nội","path_with_type":"Phường Hàng Bông, Quận Hoàn Kiếm, Thành phố Hà Nội","code":"00076","parent_code":"002"},"00079":{"name":"Phường Tràng Tiền","type":"phuong","slug":"phuong-trang-tien","name_with_type":"Phường Tràng Tiền","path":"Phường Tràng Tiền, Quận Hoàn Kiếm, Thành phố Hà Nội","path_with_type":"Phường Tràng Tiền, Quận Hoàn Kiếm, Thành phố Hà Nội","code":"00079","parent_code":"002"},"00082":{"name":"Phường Trần Hưng Đạo","type":"phuong","slug":"phuong-tran-hung-dao","name_with_type":"Phường Trần Hưng Đạo","path":"Phường Trần Hưng Đạo, Quận Hoàn Kiếm, Thành phố Hà Nội","path_with_type":"Phường Trần Hưng Đạo, Quận Hoàn Kiếm, Thành phố Hà Nội","code":"00082","parent_code":"002"},"00085":{"name":"Phường Phan Chu Trinh","type":"phuong","slug":"phuong-phan-chu-trinh","name_with_type":"Phường Phan Chu Trinh","path":"Phường Phan Chu Trinh, Quận Hoàn Kiếm, Thành phố Hà Nội","path_with_type":"Phường Phan Chu Trinh, Quận Hoàn Kiếm, Thành phố Hà Nội","code":"00085","parent_code":"002"},"00088":{"name":"Phường Hàng Bài","type":"phuong","slug":"phuong-hang-bai","name_with_type":"Phường Hàng Bài","path":"Phường Hàng Bài, Quận Hoàn Kiếm, Thành phố Hà Nội","path_with_type":"Phường Hàng Bài, Quận Hoàn Kiếm, Thành phố Hà Nội","code":"00088","parent_code":"002"},"00091":{"name":"Phường Phú Thượng","type":"phuong","slug":"phuong-phu-thuong","name_with_type":"Phường Phú Thượng","path":"Phường Phú Thượng, Quận Tây Hồ, Thành phố Hà Nội","path_with_type":"Phường Phú Thượng, Quận Tây Hồ, Thành phố Hà Nội","code":"00091","parent_code":"003"},"00094":{"name":"Phường Nhật Tân","type":"phuong","slug":"phuong-nhat-tan","name_with_type":"Phường Nhật Tân","path":"Phường Nhật Tân, Quận Tây Hồ, Thành phố Hà Nội","path_with_type":"Phường Nhật Tân, Quận Tây Hồ, Thành phố Hà Nội","code":"00094","parent_code":"003"},"00097":{"name":"Phường Tứ Liên","type":"phuong","slug":"phuong-tu-lien","name_with_type":"Phường Tứ Liên","path":"Phường Tứ Liên, Quận Tây Hồ, Thành phố Hà Nội","path_with_type":"Phường Tứ Liên, Quận Tây Hồ, Thành phố Hà Nội","code":"00097","parent_code":"003"},"00100":{"name":"Phường Quảng An","type":"phuong","slug":"phuong-quang-an","name_with_type":"Phường Quảng An","path":"Phường Quảng An, Quận Tây Hồ, Thành phố Hà Nội","path_with_type":"Phường Quảng An, Quận Tây Hồ, Thành phố Hà Nội","code":"00100","parent_code":"003"},"00103":{"name":"Phường Xuân La","type":"phuong","slug":"phuong-xuan-la","name_with_type":"Phường Xuân La","path":"Phường Xuân La, Quận Tây Hồ, Thành phố Hà Nội","path_with_type":"Phường Xuân La, Quận Tây Hồ, Thành phố Hà Nội","code":"00103","parent_code":"003"},"00106":{"name":"Phường Yên Phụ","type":"phuong","slug":"phuong-yen-phu","name_with_type":"Phường Yên Phụ","path":"Phường Yên Phụ, Quận Tây Hồ, Thành phố Hà Nội","path_with_type":"Phường Yên Phụ, Quận Tây Hồ, Thành phố Hà Nội","code":"00106","parent_code":"003"},"00109":{"name":"Phường Bưởi","type":"phuong","slug":"phuong-buoi","name_with_type":"Phường Bưởi","path":"Phường Bưởi, Quận Tây Hồ, Thành phố Hà Nội","path_with_type":"Phường Bưởi, Quận Tây Hồ, Thành phố Hà Nội","code":"00109","parent_code":"003"},"00112":{"name":"Phường Thụy Khuê","type":"phuong","slug":"phuong-thuy-khue","name_with_type":"Phường Thụy Khuê","path":"Phường Thụy Khuê, Quận Tây Hồ, Thành phố Hà Nội","path_with_type":"Phường Thụy Khuê, Quận Tây Hồ, Thành phố Hà Nội","code":"00112","parent_code":"003"},"00115":{"name":"Phường Thượng Thanh","type":"phuong","slug":"phuong-thuong-thanh","name_with_type":"Phường Thượng Thanh","path":"Phường Thượng Thanh, Quận Long Biên, Thành phố Hà Nội","path_with_type":"Phường Thượng Thanh, Quận Long Biên, Thành phố Hà Nội","code":"00115","parent_code":"004"},"00118":{"name":"Phường Ngọc Thụy","type":"phuong","slug":"phuong-ngoc-thuy","name_with_type":"Phường Ngọc Thụy","path":"Phường Ngọc Thụy, Quận Long Biên, Thành phố Hà Nội","path_with_type":"Phường Ngọc Thụy, Quận Long Biên, Thành phố Hà Nội","code":"00118","parent_code":"004"},"00121":{"name":"Phường Giang Biên","type":"phuong","slug":"phuong-giang-bien","name_with_type":"Phường Giang Biên","path":"Phường Giang Biên, Quận Long Biên, Thành phố Hà Nội","path_with_type":"Phường Giang Biên, Quận Long Biên, Thành phố Hà Nội","code":"00121","parent_code":"004"},"00124":{"name":"Phường Đức Giang","type":"phuong","slug":"phuong-duc-giang","name_with_type":"Phường Đức Giang","path":"Phường Đức Giang, Quận Long Biên, Thành phố Hà Nội","path_with_type":"Phường Đức Giang, Quận Long Biên, Thành phố Hà Nội","code":"00124","parent_code":"004"},"00127":{"name":"Phường Việt Hưng","type":"phuong","slug":"phuong-viet-hung","name_with_type":"Phường Việt Hưng","path":"Phường Việt Hưng, Quận Long Biên, Thành phố Hà Nội","path_with_type":"Phường Việt Hưng, Quận Long Biên, Thành phố Hà Nội","code":"00127","parent_code":"004"},"00130":{"name":"Phường Gia Thụy","type":"phuong","slug":"phuong-gia-thuy","name_with_type":"Phường Gia Thụy","path":"Phường Gia Thụy, Quận Long Biên, Thành phố Hà Nội","path_with_type":"Phường Gia Thụy, Quận Long Biên, Thành phố Hà Nội","code":"00130","parent_code":"004"},"00133":{"name":"Phường Ngọc Lâm","type":"phuong","slug":"phuong-ngoc-lam","name_with_type":"Phường Ngọc Lâm","path":"Phường Ngọc Lâm, Quận Long Biên, Thành phố Hà Nội","path_with_type":"Phường Ngọc Lâm, Quận Long Biên, Thành phố Hà Nội","code":"00133","parent_code":"004"},"00136":{"name":"Phường Phúc Lợi","type":"phuong","slug":"phuong-phuc-loi","name_with_type":"Phường Phúc Lợi","path":"Phường Phúc Lợi, Quận Long Biên, Thành phố Hà Nội","path_with_type":"Phường Phúc Lợi, Quận Long Biên, Thành phố Hà Nội","code":"00136","parent_code":"004"},"00139":{"name":"Phường Bồ Đề","type":"phuong","slug":"phuong-bo-de","name_with_type":"Phường Bồ Đề","path":"Phường Bồ Đề, Quận Long Biên, Thành phố Hà Nội","path_with_type":"Phường Bồ Đề, Quận Long Biên, Thành phố Hà Nội","code":"00139","parent_code":"004"},"00145":{"name":"Phường Long Biên","type":"phuong","slug":"phuong-long-bien","name_with_type":"Phường Long Biên","path":"Phường Long Biên, Quận Long Biên, Thành phố Hà Nội","path_with_type":"Phường Long Biên, Quận Long Biên, Thành phố Hà Nội","code":"00145","parent_code":"004"},"00148":{"name":"Phường Thạch Bàn","type":"phuong","slug":"phuong-thach-ban","name_with_type":"Phường Thạch Bàn","path":"Phường Thạch Bàn, Quận Long Biên, Thành phố Hà Nội","path_with_type":"Phường Thạch Bàn, Quận Long Biên, Thành phố Hà Nội","code":"00148","parent_code":"004"},"00151":{"name":"Phường Phúc Đồng","type":"phuong","slug":"phuong-phuc-dong","name_with_type":"Phường Phúc Đồng","path":"Phường Phúc Đồng, Quận Long Biên, Thành phố Hà Nội","path_with_type":"Phường Phúc Đồng, Quận Long Biên, Thành phố Hà Nội","code":"00151","parent_code":"004"},"00154":{"name":"Phường Cự Khối","type":"phuong","slug":"phuong-cu-khoi","name_with_type":"Phường Cự Khối","path":"Phường Cự Khối, Quận Long Biên, Thành phố Hà Nội","path_with_type":"Phường Cự Khối, Quận Long Biên, Thành phố Hà Nội","code":"00154","parent_code":"004"},"00157":{"name":"Phường Nghĩa Đô","type":"phuong","slug":"phuong-nghia-do","name_with_type":"Phường Nghĩa Đô","path":"Phường Nghĩa Đô, Quận Cầu Giấy, Thành phố Hà Nội","path_with_type":"Phường Nghĩa Đô, Quận Cầu Giấy, Thành phố Hà Nội","code":"00157","parent_code":"005"},"00160":{"name":"Phường Nghĩa Tân","type":"phuong","slug":"phuong-nghia-tan","name_with_type":"Phường Nghĩa Tân","path":"Phường Nghĩa Tân, Quận Cầu Giấy, Thành phố Hà Nội","path_with_type":"Phường Nghĩa Tân, Quận Cầu Giấy, Thành phố Hà Nội","code":"00160","parent_code":"005"},"00163":{"name":"Phường Mai Dịch","type":"phuong","slug":"phuong-mai-dich","name_with_type":"Phường Mai Dịch","path":"Phường Mai Dịch, Quận Cầu Giấy, Thành phố Hà Nội","path_with_type":"Phường Mai Dịch, Quận Cầu Giấy, Thành phố Hà Nội","code":"00163","parent_code":"005"},"00166":{"name":"Phường Dịch Vọng","type":"phuong","slug":"phuong-dich-vong","name_with_type":"Phường Dịch Vọng","path":"Phường Dịch Vọng, Quận Cầu Giấy, Thành phố Hà Nội","path_with_type":"Phường Dịch Vọng, Quận Cầu Giấy, Thành phố Hà Nội","code":"00166","parent_code":"005"},"00167":{"name":"Phường Dịch Vọng Hậu","type":"phuong","slug":"phuong-dich-vong-hau","name_with_type":"Phường Dịch Vọng Hậu","path":"Phường Dịch Vọng Hậu, Quận Cầu Giấy, Thành phố Hà Nội","path_with_type":"Phường Dịch Vọng Hậu, Quận Cầu Giấy, Thành phố Hà Nội","code":"00167","parent_code":"005"},"00169":{"name":"Phường Quan Hoa","type":"phuong","slug":"phuong-quan-hoa","name_with_type":"Phường Quan Hoa","path":"Phường Quan Hoa, Quận Cầu Giấy, Thành phố Hà Nội","path_with_type":"Phường Quan Hoa, Quận Cầu Giấy, Thành phố Hà Nội","code":"00169","parent_code":"005"},"00172":{"name":"Phường Yên Hoà","type":"phuong","slug":"phuong-yen-hoa","name_with_type":"Phường Yên Hoà","path":"Phường Yên Hoà, Quận Cầu Giấy, Thành phố Hà Nội","path_with_type":"Phường Yên Hoà, Quận Cầu Giấy, Thành phố Hà Nội","code":"00172","parent_code":"005"},"00175":{"name":"Phường Trung Hoà","type":"phuong","slug":"phuong-trung-hoa","name_with_type":"Phường Trung Hoà","path":"Phường Trung Hoà, Quận Cầu Giấy, Thành phố Hà Nội","path_with_type":"Phường Trung Hoà, Quận Cầu Giấy, Thành phố Hà Nội","code":"00175","parent_code":"005"},"00178":{"name":"Phường Cát Linh","type":"phuong","slug":"phuong-cat-linh","name_with_type":"Phường Cát Linh","path":"Phường Cát Linh, Quận Đống Đa, Thành phố Hà Nội","path_with_type":"Phường Cát Linh, Quận Đống Đa, Thành phố Hà Nội","code":"00178","parent_code":"006"},"00181":{"name":"Phường Văn Miếu - Quốc Tử Giám","type":"phuong","slug":"phuong-van-mieu---quoc-tu-giam","name_with_type":"Phường Văn Miếu - Quốc Tử Giám","path":"Phường Văn Miếu - Quốc Tử Giám, Quận Đống Đa, Thành phố Hà Nội","path_with_type":"Phường Văn Miếu - Quốc Tử Giám, Quận Đống Đa, Thành phố Hà Nội","code":"00181","parent_code":"006"},"00187":{"name":"Phường Láng Thượng","type":"phuong","slug":"phuong-lang-thuong","name_with_type":"Phường Láng Thượng","path":"Phường Láng Thượng, Quận Đống Đa, Thành phố Hà Nội","path_with_type":"Phường Láng Thượng, Quận Đống Đa, Thành phố Hà Nội","code":"00187","parent_code":"006"},"00190":{"name":"Phường Ô Chợ Dừa","type":"phuong","slug":"phuong-o-cho-dua","name_with_type":"Phường Ô Chợ Dừa","path":"Phường Ô Chợ Dừa, Quận Đống Đa, Thành phố Hà Nội","path_with_type":"Phường Ô Chợ Dừa, Quận Đống Đa, Thành phố Hà Nội","code":"00190","parent_code":"006"},"00193":{"name":"Phường Văn Chương","type":"phuong","slug":"phuong-van-chuong","name_with_type":"Phường Văn Chương","path":"Phường Văn Chương, Quận Đống Đa, Thành phố Hà Nội","path_with_type":"Phường Văn Chương, Quận Đống Đa, Thành phố Hà Nội","code":"00193","parent_code":"006"},"00196":{"name":"Phường Hàng Bột","type":"phuong","slug":"phuong-hang-bot","name_with_type":"Phường Hàng Bột","path":"Phường Hàng Bột, Quận Đống Đa, Thành phố Hà Nội","path_with_type":"Phường Hàng Bột, Quận Đống Đa, Thành phố Hà Nội","code":"00196","parent_code":"006"},"00199":{"name":"Phường Láng Hạ","type":"phuong","slug":"phuong-lang-ha","name_with_type":"Phường Láng Hạ","path":"Phường Láng Hạ, Quận Đống Đa, Thành phố Hà Nội","path_with_type":"Phường Láng Hạ, Quận Đống Đa, Thành phố Hà Nội","code":"00199","parent_code":"006"},"00202":{"name":"Phường Khâm Thiên","type":"phuong","slug":"phuong-kham-thien","name_with_type":"Phường Khâm Thiên","path":"Phường Khâm Thiên, Quận Đống Đa, Thành phố Hà Nội","path_with_type":"Phường Khâm Thiên, Quận Đống Đa, Thành phố Hà Nội","code":"00202","parent_code":"006"},"00205":{"name":"Phường Thổ Quan","type":"phuong","slug":"phuong-tho-quan","name_with_type":"Phường Thổ Quan","path":"Phường Thổ Quan, Quận Đống Đa, Thành phố Hà Nội","path_with_type":"Phường Thổ Quan, Quận Đống Đa, Thành phố Hà Nội","code":"00205","parent_code":"006"},"00208":{"name":"Phường Nam Đồng","type":"phuong","slug":"phuong-nam-dong","name_with_type":"Phường Nam Đồng","path":"Phường Nam Đồng, Quận Đống Đa, Thành phố Hà Nội","path_with_type":"Phường Nam Đồng, Quận Đống Đa, Thành phố Hà Nội","code":"00208","parent_code":"006"},"00214":{"name":"Phường Quang Trung","type":"phuong","slug":"phuong-quang-trung","name_with_type":"Phường Quang Trung","path":"Phường Quang Trung, Quận Đống Đa, Thành phố Hà Nội","path_with_type":"Phường Quang Trung, Quận Đống Đa, Thành phố Hà Nội","code":"00214","parent_code":"006"},"00217":{"name":"Phường Trung Liệt","type":"phuong","slug":"phuong-trung-liet","name_with_type":"Phường Trung Liệt","path":"Phường Trung Liệt, Quận Đống Đa, Thành phố Hà Nội","path_with_type":"Phường Trung Liệt, Quận Đống Đa, Thành phố Hà Nội","code":"00217","parent_code":"006"},"00226":{"name":"Phường Phương Liên - Trung Tự","type":"phuong","slug":"phuong-phuong-lien---trung-tu","name_with_type":"Phường Phương Liên - Trung Tự","path":"Phường Phương Liên - Trung Tự, Quận Đống Đa, Thành phố Hà Nội","path_with_type":"Phường Phương Liên - Trung Tự, Quận Đống Đa, Thành phố Hà Nội","code":"00226","parent_code":"006"},"00229":{"name":"Phường Kim Liên","type":"phuong","slug":"phuong-kim-lien","name_with_type":"Phường Kim Liên","path":"Phường Kim Liên, Quận Đống Đa, Thành phố Hà Nội","path_with_type":"Phường Kim Liên, Quận Đống Đa, Thành phố Hà Nội","code":"00229","parent_code":"006"},"00232":{"name":"Phường Phương Mai","type":"phuong","slug":"phuong-phuong-mai","name_with_type":"Phường Phương Mai","path":"Phường Phương Mai, Quận Đống Đa, Thành phố Hà Nội","path_with_type":"Phường Phương Mai, Quận Đống Đa, Thành phố Hà Nội","code":"00232","parent_code":"006"},"00235":{"name":"Phường Thịnh Quang","type":"phuong","slug":"phuong-thinh-quang","name_with_type":"Phường Thịnh Quang","path":"Phường Thịnh Quang, Quận Đống Đa, Thành phố Hà Nội","path_with_type":"Phường Thịnh Quang, Quận Đống Đa, Thành phố Hà Nội","code":"00235","parent_code":"006"},"00238":{"name":"Phường Khương Thượng","type":"phuong","slug":"phuong-khuong-thuong","name_with_type":"Phường Khương Thượng","path":"Phường Khương Thượng, Quận Đống Đa, Thành phố Hà Nội","path_with_type":"Phường Khương Thượng, Quận Đống Đa, Thành phố Hà Nội","code":"00238","parent_code":"006"},"00241":{"name":"Phường Nguyễn Du","type":"phuong","slug":"phuong-nguyen-du","name_with_type":"Phường Nguyễn Du","path":"Phường Nguyễn Du, Quận Hai Bà Trưng, Thành phố Hà Nội","path_with_type":"Phường Nguyễn Du, Quận Hai Bà Trưng, Thành phố Hà Nội","code":"00241","parent_code":"007"},"00244":{"name":"Phường Bạch Đằng","type":"phuong","slug":"phuong-bach-dang","name_with_type":"Phường Bạch Đằng","path":"Phường Bạch Đằng, Quận Hai Bà Trưng, Thành phố Hà Nội","path_with_type":"Phường Bạch Đằng, Quận Hai Bà Trưng, Thành phố Hà Nội","code":"00244","parent_code":"007"},"00247":{"name":"Phường Phạm Đình Hổ","type":"phuong","slug":"phuong-pham-dinh-ho","name_with_type":"Phường Phạm Đình Hổ","path":"Phường Phạm Đình Hổ, Quận Hai Bà Trưng, Thành phố Hà Nội","path_with_type":"Phường Phạm Đình Hổ, Quận Hai Bà Trưng, Thành phố Hà Nội","code":"00247","parent_code":"007"},"00256":{"name":"Phường Lê Đại Hành","type":"phuong","slug":"phuong-le-dai-hanh","name_with_type":"Phường Lê Đại Hành","path":"Phường Lê Đại Hành, Quận Hai Bà Trưng, Thành phố Hà Nội","path_with_type":"Phường Lê Đại Hành, Quận Hai Bà Trưng, Thành phố Hà Nội","code":"00256","parent_code":"007"},"00259":{"name":"Phường Đồng Nhân","type":"phuong","slug":"phuong-dong-nhan","name_with_type":"Phường Đồng Nhân","path":"Phường Đồng Nhân, Quận Hai Bà Trưng, Thành phố Hà Nội","path_with_type":"Phường Đồng Nhân, Quận Hai Bà Trưng, Thành phố Hà Nội","code":"00259","parent_code":"007"},"00262":{"name":"Phường Phố Huế","type":"phuong","slug":"phuong-pho-hue","name_with_type":"Phường Phố Huế","path":"Phường Phố Huế, Quận Hai Bà Trưng, Thành phố Hà Nội","path_with_type":"Phường Phố Huế, Quận Hai Bà Trưng, Thành phố Hà Nội","code":"00262","parent_code":"007"},"00268":{"name":"Phường Thanh Lương","type":"phuong","slug":"phuong-thanh-luong","name_with_type":"Phường Thanh Lương","path":"Phường Thanh Lương, Quận Hai Bà Trưng, Thành phố Hà Nội","path_with_type":"Phường Thanh Lương, Quận Hai Bà Trưng, Thành phố Hà Nội","code":"00268","parent_code":"007"},"00271":{"name":"Phường Thanh Nhàn","type":"phuong","slug":"phuong-thanh-nhan","name_with_type":"Phường Thanh Nhàn","path":"Phường Thanh Nhàn, Quận Hai Bà Trưng, Thành phố Hà Nội","path_with_type":"Phường Thanh Nhàn, Quận Hai Bà Trưng, Thành phố Hà Nội","code":"00271","parent_code":"007"},"00277":{"name":"Phường Bách Khoa","type":"phuong","slug":"phuong-bach-khoa","name_with_type":"Phường Bách Khoa","path":"Phường Bách Khoa, Quận Hai Bà Trưng, Thành phố Hà Nội","path_with_type":"Phường Bách Khoa, Quận Hai Bà Trưng, Thành phố Hà Nội","code":"00277","parent_code":"007"},"00280":{"name":"Phường Đồng Tâm","type":"phuong","slug":"phuong-dong-tam","name_with_type":"Phường Đồng Tâm","path":"Phường Đồng Tâm, Quận Hai Bà Trưng, Thành phố Hà Nội","path_with_type":"Phường Đồng Tâm, Quận Hai Bà Trưng, Thành phố Hà Nội","code":"00280","parent_code":"007"},"00283":{"name":"Phường Vĩnh Tuy","type":"phuong","slug":"phuong-vinh-tuy","name_with_type":"Phường Vĩnh Tuy","path":"Phường Vĩnh Tuy, Quận Hai Bà Trưng, Thành phố Hà Nội","path_with_type":"Phường Vĩnh Tuy, Quận Hai Bà Trưng, Thành phố Hà Nội","code":"00283","parent_code":"007"},"00286":{"name":"Phường Bạch Mai","type":"phuong","slug":"phuong-bach-mai","name_with_type":"Phường Bạch Mai","path":"Phường Bạch Mai, Quận Hai Bà Trưng, Thành phố Hà Nội","path_with_type":"Phường Bạch Mai, Quận Hai Bà Trưng, Thành phố Hà Nội","code":"00286","parent_code":"007"},"00289":{"name":"Phường Quỳnh Mai","type":"phuong","slug":"phuong-quynh-mai","name_with_type":"Phường Quỳnh Mai","path":"Phường Quỳnh Mai, Quận Hai Bà Trưng, Thành phố Hà Nội","path_with_type":"Phường Quỳnh Mai, Quận Hai Bà Trưng, Thành phố Hà Nội","code":"00289","parent_code":"007"},"00295":{"name":"Phường Minh Khai","type":"phuong","slug":"phuong-minh-khai","name_with_type":"Phường Minh Khai","path":"Phường Minh Khai, Quận Hai Bà Trưng, Thành phố Hà Nội","path_with_type":"Phường Minh Khai, Quận Hai Bà Trưng, Thành phố Hà Nội","code":"00295","parent_code":"007"},"00298":{"name":"Phường Trương Định","type":"phuong","slug":"phuong-truong-dinh","name_with_type":"Phường Trương Định","path":"Phường Trương Định, Quận Hai Bà Trưng, Thành phố Hà Nội","path_with_type":"Phường Trương Định, Quận Hai Bà Trưng, Thành phố Hà Nội","code":"00298","parent_code":"007"},"00301":{"name":"Phường Thanh Trì","type":"phuong","slug":"phuong-thanh-tri","name_with_type":"Phường Thanh Trì","path":"Phường Thanh Trì, Quận Hoàng Mai, Thành phố Hà Nội","path_with_type":"Phường Thanh Trì, Quận Hoàng Mai, Thành phố Hà Nội","code":"00301","parent_code":"008"},"00304":{"name":"Phường Vĩnh Hưng","type":"phuong","slug":"phuong-vinh-hung","name_with_type":"Phường Vĩnh Hưng","path":"Phường Vĩnh Hưng, Quận Hoàng Mai, Thành phố Hà Nội","path_with_type":"Phường Vĩnh Hưng, Quận Hoàng Mai, Thành phố Hà Nội","code":"00304","parent_code":"008"},"00307":{"name":"Phường Định Công","type":"phuong","slug":"phuong-dinh-cong","name_with_type":"Phường Định Công","path":"Phường Định Công, Quận Hoàng Mai, Thành phố Hà Nội","path_with_type":"Phường Định Công, Quận Hoàng Mai, Thành phố Hà Nội","code":"00307","parent_code":"008"},"00310":{"name":"Phường Mai Động","type":"phuong","slug":"phuong-mai-dong","name_with_type":"Phường Mai Động","path":"Phường Mai Động, Quận Hoàng Mai, Thành phố Hà Nội","path_with_type":"Phường Mai Động, Quận Hoàng Mai, Thành phố Hà Nội","code":"00310","parent_code":"008"},"00313":{"name":"Phường Tương Mai","type":"phuong","slug":"phuong-tuong-mai","name_with_type":"Phường Tương Mai","path":"Phường Tương Mai, Quận Hoàng Mai, Thành phố Hà Nội","path_with_type":"Phường Tương Mai, Quận Hoàng Mai, Thành phố Hà Nội","code":"00313","parent_code":"008"},"00316":{"name":"Phường Đại Kim","type":"phuong","slug":"phuong-dai-kim","name_with_type":"Phường Đại Kim","path":"Phường Đại Kim, Quận Hoàng Mai, Thành phố Hà Nội","path_with_type":"Phường Đại Kim, Quận Hoàng Mai, Thành phố Hà Nội","code":"00316","parent_code":"008"},"00319":{"name":"Phường Tân Mai","type":"phuong","slug":"phuong-tan-mai","name_with_type":"Phường Tân Mai","path":"Phường Tân Mai, Quận Hoàng Mai, Thành phố Hà Nội","path_with_type":"Phường Tân Mai, Quận Hoàng Mai, Thành phố Hà Nội","code":"00319","parent_code":"008"},"00322":{"name":"Phường Hoàng Văn Thụ","type":"phuong","slug":"phuong-hoang-van-thu","name_with_type":"Phường Hoàng Văn Thụ","path":"Phường Hoàng Văn Thụ, Quận Hoàng Mai, Thành phố Hà Nội","path_with_type":"Phường Hoàng Văn Thụ, Quận Hoàng Mai, Thành phố Hà Nội","code":"00322","parent_code":"008"},"00325":{"name":"Phường Giáp Bát","type":"phuong","slug":"phuong-giap-bat","name_with_type":"Phường Giáp Bát","path":"Phường Giáp Bát, Quận Hoàng Mai, Thành phố Hà Nội","path_with_type":"Phường Giáp Bát, Quận Hoàng Mai, Thành phố Hà Nội","code":"00325","parent_code":"008"},"00328":{"name":"Phường Lĩnh Nam","type":"phuong","slug":"phuong-linh-nam","name_with_type":"Phường Lĩnh Nam","path":"Phường Lĩnh Nam, Quận Hoàng Mai, Thành phố Hà Nội","path_with_type":"Phường Lĩnh Nam, Quận Hoàng Mai, Thành phố Hà Nội","code":"00328","parent_code":"008"},"00331":{"name":"Phường Thịnh Liệt","type":"phuong","slug":"phuong-thinh-liet","name_with_type":"Phường Thịnh Liệt","path":"Phường Thịnh Liệt, Quận Hoàng Mai, Thành phố Hà Nội","path_with_type":"Phường Thịnh Liệt, Quận Hoàng Mai, Thành phố Hà Nội","code":"00331","parent_code":"008"},"00334":{"name":"Phường Trần Phú","type":"phuong","slug":"phuong-tran-phu","name_with_type":"Phường Trần Phú","path":"Phường Trần Phú, Quận Hoàng Mai, Thành phố Hà Nội","path_with_type":"Phường Trần Phú, Quận Hoàng Mai, Thành phố Hà Nội","code":"00334","parent_code":"008"},"00337":{"name":"Phường Hoàng Liệt","type":"phuong","slug":"phuong-hoang-liet","name_with_type":"Phường Hoàng Liệt","path":"Phường Hoàng Liệt, Quận Hoàng Mai, Thành phố Hà Nội","path_with_type":"Phường Hoàng Liệt, Quận Hoàng Mai, Thành phố Hà Nội","code":"00337","parent_code":"008"},"00340":{"name":"Phường Yên Sở","type":"phuong","slug":"phuong-yen-so","name_with_type":"Phường Yên Sở","path":"Phường Yên Sở, Quận Hoàng Mai, Thành phố Hà Nội","path_with_type":"Phường Yên Sở, Quận Hoàng Mai, Thành phố Hà Nội","code":"00340","parent_code":"008"},"00343":{"name":"Phường Nhân Chính","type":"phuong","slug":"phuong-nhan-chinh","name_with_type":"Phường Nhân Chính","path":"Phường Nhân Chính, Quận Thanh Xuân, Thành phố Hà Nội","path_with_type":"Phường Nhân Chính, Quận Thanh Xuân, Thành phố Hà Nội","code":"00343","parent_code":"009"},"00346":{"name":"Phường Thượng Đình","type":"phuong","slug":"phuong-thuong-dinh","name_with_type":"Phường Thượng Đình","path":"Phường Thượng Đình, Quận Thanh Xuân, Thành phố Hà Nội","path_with_type":"Phường Thượng Đình, Quận Thanh Xuân, Thành phố Hà Nội","code":"00346","parent_code":"009"},"00349":{"name":"Phường Khương Trung","type":"phuong","slug":"phuong-khuong-trung","name_with_type":"Phường Khương Trung","path":"Phường Khương Trung, Quận Thanh Xuân, Thành phố Hà Nội","path_with_type":"Phường Khương Trung, Quận Thanh Xuân, Thành phố Hà Nội","code":"00349","parent_code":"009"},"00352":{"name":"Phường Khương Mai","type":"phuong","slug":"phuong-khuong-mai","name_with_type":"Phường Khương Mai","path":"Phường Khương Mai, Quận Thanh Xuân, Thành phố Hà Nội","path_with_type":"Phường Khương Mai, Quận Thanh Xuân, Thành phố Hà Nội","code":"00352","parent_code":"009"},"00355":{"name":"Phường Thanh Xuân Trung","type":"phuong","slug":"phuong-thanh-xuan-trung","name_with_type":"Phường Thanh Xuân Trung","path":"Phường Thanh Xuân Trung, Quận Thanh Xuân, Thành phố Hà Nội","path_with_type":"Phường Thanh Xuân Trung, Quận Thanh Xuân, Thành phố Hà Nội","code":"00355","parent_code":"009"},"00358":{"name":"Phường Phương Liệt","type":"phuong","slug":"phuong-phuong-liet","name_with_type":"Phường Phương Liệt","path":"Phường Phương Liệt, Quận Thanh Xuân, Thành phố Hà Nội","path_with_type":"Phường Phương Liệt, Quận Thanh Xuân, Thành phố Hà Nội","code":"00358","parent_code":"009"},"00364":{"name":"Phường Khương Đình","type":"phuong","slug":"phuong-khuong-dinh","name_with_type":"Phường Khương Đình","path":"Phường Khương Đình, Quận Thanh Xuân, Thành phố Hà Nội","path_with_type":"Phường Khương Đình, Quận Thanh Xuân, Thành phố Hà Nội","code":"00364","parent_code":"009"},"00367":{"name":"Phường Thanh Xuân Bắc","type":"phuong","slug":"phuong-thanh-xuan-bac","name_with_type":"Phường Thanh Xuân Bắc","path":"Phường Thanh Xuân Bắc, Quận Thanh Xuân, Thành phố Hà Nội","path_with_type":"Phường Thanh Xuân Bắc, Quận Thanh Xuân, Thành phố Hà Nội","code":"00367","parent_code":"009"},"00373":{"name":"Phường Hạ Đình","type":"phuong","slug":"phuong-ha-dinh","name_with_type":"Phường Hạ Đình","path":"Phường Hạ Đình, Quận Thanh Xuân, Thành phố Hà Nội","path_with_type":"Phường Hạ Đình, Quận Thanh Xuân, Thành phố Hà Nội","code":"00373","parent_code":"009"},"00376":{"name":"Thị trấn Sóc Sơn","type":"thi-tran","slug":"thi-tran-soc-son","name_with_type":"Thị trấn Sóc Sơn","path":"Thị trấn Sóc Sơn, Huyện Sóc Sơn, Thành phố Hà Nội","path_with_type":"Thị trấn Sóc Sơn, Huyện Sóc Sơn, Thành phố Hà Nội","code":"00376","parent_code":"016"},"00379":{"name":"Xã Bắc Sơn","type":"xa","slug":"xa-bac-son","name_with_type":"Xã Bắc Sơn","path":"Xã Bắc Sơn, Huyện Sóc Sơn, Thành phố Hà Nội","path_with_type":"Xã Bắc Sơn, Huyện Sóc Sơn, Thành phố Hà Nội","code":"00379","parent_code":"016"},"00382":{"name":"Xã Minh Trí","type":"xa","slug":"xa-minh-tri","name_with_type":"Xã Minh Trí","path":"Xã Minh Trí, Huyện Sóc Sơn, Thành phố Hà Nội","path_with_type":"Xã Minh Trí, Huyện Sóc Sơn, Thành phố Hà Nội","code":"00382","parent_code":"016"},"00385":{"name":"Xã Hồng Kỳ","type":"xa","slug":"xa-hong-ky","name_with_type":"Xã Hồng Kỳ","path":"Xã Hồng Kỳ, Huyện Sóc Sơn, Thành phố Hà Nội","path_with_type":"Xã Hồng Kỳ, Huyện Sóc Sơn, Thành phố Hà Nội","code":"00385","parent_code":"016"},"00388":{"name":"Xã Nam Sơn","type":"xa","slug":"xa-nam-son","name_with_type":"Xã Nam Sơn","path":"Xã Nam Sơn, Huyện Sóc Sơn, Thành phố Hà Nội","path_with_type":"Xã Nam Sơn, Huyện Sóc Sơn, Thành phố Hà Nội","code":"00388","parent_code":"016"},"00391":{"name":"Xã Trung Giã","type":"xa","slug":"xa-trung-gia","name_with_type":"Xã Trung Giã","path":"Xã Trung Giã, Huyện Sóc Sơn, Thành phố Hà Nội","path_with_type":"Xã Trung Giã, Huyện Sóc Sơn, Thành phố Hà Nội","code":"00391","parent_code":"016"},"00394":{"name":"Xã Tân Hưng","type":"xa","slug":"xa-tan-hung","name_with_type":"Xã Tân Hưng","path":"Xã Tân Hưng, Huyện Sóc Sơn, Thành phố Hà Nội","path_with_type":"Xã Tân Hưng, Huyện Sóc Sơn, Thành phố Hà Nội","code":"00394","parent_code":"016"},"00397":{"name":"Xã Minh Phú","type":"xa","slug":"xa-minh-phu","name_with_type":"Xã Minh Phú","path":"Xã Minh Phú, Huyện Sóc Sơn, Thành phố Hà Nội","path_with_type":"Xã Minh Phú, Huyện Sóc Sơn, Thành phố Hà Nội","code":"00397","parent_code":"016"},"00400":{"name":"Xã Phù Linh","type":"xa","slug":"xa-phu-linh","name_with_type":"Xã Phù Linh","path":"Xã Phù Linh, Huyện Sóc Sơn, Thành phố Hà Nội","path_with_type":"Xã Phù Linh, Huyện Sóc Sơn, Thành phố Hà Nội","code":"00400","parent_code":"016"},"00403":{"name":"Xã Bắc Phú","type":"xa","slug":"xa-bac-phu","name_with_type":"Xã Bắc Phú","path":"Xã Bắc Phú, Huyện Sóc Sơn, Thành phố Hà Nội","path_with_type":"Xã Bắc Phú, Huyện Sóc Sơn, Thành phố Hà Nội","code":"00403","parent_code":"016"},"00406":{"name":"Xã Tân Minh","type":"xa","slug":"xa-tan-minh","name_with_type":"Xã Tân Minh","path":"Xã Tân Minh, Huyện Sóc Sơn, Thành phố Hà Nội","path_with_type":"Xã Tân Minh, Huyện Sóc Sơn, Thành phố Hà Nội","code":"00406","parent_code":"016"},"00409":{"name":"Xã Quang Tiến","type":"xa","slug":"xa-quang-tien","name_with_type":"Xã Quang Tiến","path":"Xã Quang Tiến, Huyện Sóc Sơn, Thành phố Hà Nội","path_with_type":"Xã Quang Tiến, Huyện Sóc Sơn, Thành phố Hà Nội","code":"00409","parent_code":"016"},"00412":{"name":"Xã Hiền Ninh","type":"xa","slug":"xa-hien-ninh","name_with_type":"Xã Hiền Ninh","path":"Xã Hiền Ninh, Huyện Sóc Sơn, Thành phố Hà Nội","path_with_type":"Xã Hiền Ninh, Huyện Sóc Sơn, Thành phố Hà Nội","code":"00412","parent_code":"016"},"00415":{"name":"Xã Tân Dân","type":"xa","slug":"xa-tan-dan","name_with_type":"Xã Tân Dân","path":"Xã Tân Dân, Huyện Sóc Sơn, Thành phố Hà Nội","path_with_type":"Xã Tân Dân, Huyện Sóc Sơn, Thành phố Hà Nội","code":"00415","parent_code":"016"},"00418":{"name":"Xã Tiên Dược","type":"xa","slug":"xa-tien-duoc","name_with_type":"Xã Tiên Dược","path":"Xã Tiên Dược, Huyện Sóc Sơn, Thành phố Hà Nội","path_with_type":"Xã Tiên Dược, Huyện Sóc Sơn, Thành phố Hà Nội","code":"00418","parent_code":"016"},"00421":{"name":"Xã Việt Long","type":"xa","slug":"xa-viet-long","name_with_type":"Xã Việt Long","path":"Xã Việt Long, Huyện Sóc Sơn, Thành phố Hà Nội","path_with_type":"Xã Việt Long, Huyện Sóc Sơn, Thành phố Hà Nội","code":"00421","parent_code":"016"},"00424":{"name":"Xã Xuân Giang","type":"xa","slug":"xa-xuan-giang","name_with_type":"Xã Xuân Giang","path":"Xã Xuân Giang, Huyện Sóc Sơn, Thành phố Hà Nội","path_with_type":"Xã Xuân Giang, Huyện Sóc Sơn, Thành phố Hà Nội","code":"00424","parent_code":"016"},"00427":{"name":"Xã Mai Đình","type":"xa","slug":"xa-mai-dinh","name_with_type":"Xã Mai Đình","path":"Xã Mai Đình, Huyện Sóc Sơn, Thành phố Hà Nội","path_with_type":"Xã Mai Đình, Huyện Sóc Sơn, Thành phố Hà Nội","code":"00427","parent_code":"016"},"00430":{"name":"Xã Đức Hoà","type":"xa","slug":"xa-duc-hoa","name_with_type":"Xã Đức Hoà","path":"Xã Đức Hoà, Huyện Sóc Sơn, Thành phố Hà Nội","path_with_type":"Xã Đức Hoà, Huyện Sóc Sơn, Thành phố Hà Nội","code":"00430","parent_code":"016"},"00433":{"name":"Xã Thanh Xuân","type":"xa","slug":"xa-thanh-xuan","name_with_type":"Xã Thanh Xuân","path":"Xã Thanh Xuân, Huyện Sóc Sơn, Thành phố Hà Nội","path_with_type":"Xã Thanh Xuân, Huyện Sóc Sơn, Thành phố Hà Nội","code":"00433","parent_code":"016"},"00436":{"name":"Xã Đông Xuân","type":"xa","slug":"xa-dong-xuan","name_with_type":"Xã Đông Xuân","path":"Xã Đông Xuân, Huyện Sóc Sơn, Thành phố Hà Nội","path_with_type":"Xã Đông Xuân, Huyện Sóc Sơn, Thành phố Hà Nội","code":"00436","parent_code":"016"},"00439":{"name":"Xã Kim Lũ","type":"xa","slug":"xa-kim-lu","name_with_type":"Xã Kim Lũ","path":"Xã Kim Lũ, Huyện Sóc Sơn, Thành phố Hà Nội","path_with_type":"Xã Kim Lũ, Huyện Sóc Sơn, Thành phố Hà Nội","code":"00439","parent_code":"016"},"00442":{"name":"Xã Phú Cường","type":"xa","slug":"xa-phu-cuong","name_with_type":"Xã Phú Cường","path":"Xã Phú Cường, Huyện Sóc Sơn, Thành phố Hà Nội","path_with_type":"Xã Phú Cường, Huyện Sóc Sơn, Thành phố Hà Nội","code":"00442","parent_code":"016"},"00445":{"name":"Xã Phú Minh","type":"xa","slug":"xa-phu-minh","name_with_type":"Xã Phú Minh","path":"Xã Phú Minh, Huyện Sóc Sơn, Thành phố Hà Nội","path_with_type":"Xã Phú Minh, Huyện Sóc Sơn, Thành phố Hà Nội","code":"00445","parent_code":"016"},"00448":{"name":"Xã Phù Lỗ","type":"xa","slug":"xa-phu-lo","name_with_type":"Xã Phù Lỗ","path":"Xã Phù Lỗ, Huyện Sóc Sơn, Thành phố Hà Nội","path_with_type":"Xã Phù Lỗ, Huyện Sóc Sơn, Thành phố Hà Nội","code":"00448","parent_code":"016"},"00451":{"name":"Xã Xuân Thu","type":"xa","slug":"xa-xuan-thu","name_with_type":"Xã Xuân Thu","path":"Xã Xuân Thu, Huyện Sóc Sơn, Thành phố Hà Nội","path_with_type":"Xã Xuân Thu, Huyện Sóc Sơn, Thành phố Hà Nội","code":"00451","parent_code":"016"},"00454":{"name":"Thị trấn Đông Anh","type":"thi-tran","slug":"thi-tran-dong-anh","name_with_type":"Thị trấn Đông Anh","path":"Thị trấn Đông Anh, Huyện Đông Anh, Thành phố Hà Nội","path_with_type":"Thị trấn Đông Anh, Huyện Đông Anh, Thành phố Hà Nội","code":"00454","parent_code":"017"},"00457":{"name":"Xã Xuân Nộn","type":"xa","slug":"xa-xuan-non","name_with_type":"Xã Xuân Nộn","path":"Xã Xuân Nộn, Huyện Đông Anh, Thành phố Hà Nội","path_with_type":"Xã Xuân Nộn, Huyện Đông Anh, Thành phố Hà Nội","code":"00457","parent_code":"017"},"00460":{"name":"Xã Thuỵ Lâm","type":"xa","slug":"xa-thuy-lam","name_with_type":"Xã Thuỵ Lâm","path":"Xã Thuỵ Lâm, Huyện Đông Anh, Thành phố Hà Nội","path_with_type":"Xã Thuỵ Lâm, Huyện Đông Anh, Thành phố Hà Nội","code":"00460","parent_code":"017"},"00463":{"name":"Xã Bắc Hồng","type":"xa","slug":"xa-bac-hong","name_with_type":"Xã Bắc Hồng","path":"Xã Bắc Hồng, Huyện Đông Anh, Thành phố Hà Nội","path_with_type":"Xã Bắc Hồng, Huyện Đông Anh, Thành phố Hà Nội","code":"00463","parent_code":"017"},"00466":{"name":"Xã Nguyên Khê","type":"xa","slug":"xa-nguyen-khe","name_with_type":"Xã Nguyên Khê","path":"Xã Nguyên Khê, Huyện Đông Anh, Thành phố Hà Nội","path_with_type":"Xã Nguyên Khê, Huyện Đông Anh, Thành phố Hà Nội","code":"00466","parent_code":"017"},"00469":{"name":"Xã Nam Hồng","type":"xa","slug":"xa-nam-hong","name_with_type":"Xã Nam Hồng","path":"Xã Nam Hồng, Huyện Đông Anh, Thành phố Hà Nội","path_with_type":"Xã Nam Hồng, Huyện Đông Anh, Thành phố Hà Nội","code":"00469","parent_code":"017"},"00472":{"name":"Xã Tiên Dương","type":"xa","slug":"xa-tien-duong","name_with_type":"Xã Tiên Dương","path":"Xã Tiên Dương, Huyện Đông Anh, Thành phố Hà Nội","path_with_type":"Xã Tiên Dương, Huyện Đông Anh, Thành phố Hà Nội","code":"00472","parent_code":"017"},"00475":{"name":"Xã Vân Hà","type":"xa","slug":"xa-van-ha","name_with_type":"Xã Vân Hà","path":"Xã Vân Hà, Huyện Đông Anh, Thành phố Hà Nội","path_with_type":"Xã Vân Hà, Huyện Đông Anh, Thành phố Hà Nội","code":"00475","parent_code":"017"},"00478":{"name":"Xã Uy Nỗ","type":"xa","slug":"xa-uy-no","name_with_type":"Xã Uy Nỗ","path":"Xã Uy Nỗ, Huyện Đông Anh, Thành phố Hà Nội","path_with_type":"Xã Uy Nỗ, Huyện Đông Anh, Thành phố Hà Nội","code":"00478","parent_code":"017"},"00481":{"name":"Xã Vân Nội","type":"xa","slug":"xa-van-noi","name_with_type":"Xã Vân Nội","path":"Xã Vân Nội, Huyện Đông Anh, Thành phố Hà Nội","path_with_type":"Xã Vân Nội, Huyện Đông Anh, Thành phố Hà Nội","code":"00481","parent_code":"017"},"00484":{"name":"Xã Liên Hà","type":"xa","slug":"xa-lien-ha","name_with_type":"Xã Liên Hà","path":"Xã Liên Hà, Huyện Đông Anh, Thành phố Hà Nội","path_with_type":"Xã Liên Hà, Huyện Đông Anh, Thành phố Hà Nội","code":"00484","parent_code":"017"},"00487":{"name":"Xã Việt Hùng","type":"xa","slug":"xa-viet-hung","name_with_type":"Xã Việt Hùng","path":"Xã Việt Hùng, Huyện Đông Anh, Thành phố Hà Nội","path_with_type":"Xã Việt Hùng, Huyện Đông Anh, Thành phố Hà Nội","code":"00487","parent_code":"017"},"00490":{"name":"Xã Kim Nỗ","type":"xa","slug":"xa-kim-no","name_with_type":"Xã Kim Nỗ","path":"Xã Kim Nỗ, Huyện Đông Anh, Thành phố Hà Nội","path_with_type":"Xã Kim Nỗ, Huyện Đông Anh, Thành phố Hà Nội","code":"00490","parent_code":"017"},"00493":{"name":"Xã Kim Chung","type":"xa","slug":"xa-kim-chung","name_with_type":"Xã Kim Chung","path":"Xã Kim Chung, Huyện Đông Anh, Thành phố Hà Nội","path_with_type":"Xã Kim Chung, Huyện Đông Anh, Thành phố Hà Nội","code":"00493","parent_code":"017"},"00496":{"name":"Xã Dục Tú","type":"xa","slug":"xa-duc-tu","name_with_type":"Xã Dục Tú","path":"Xã Dục Tú, Huyện Đông Anh, Thành phố Hà Nội","path_with_type":"Xã Dục Tú, Huyện Đông Anh, Thành phố Hà Nội","code":"00496","parent_code":"017"},"00499":{"name":"Xã Đại Mạch","type":"xa","slug":"xa-dai-mach","name_with_type":"Xã Đại Mạch","path":"Xã Đại Mạch, Huyện Đông Anh, Thành phố Hà Nội","path_with_type":"Xã Đại Mạch, Huyện Đông Anh, Thành phố Hà Nội","code":"00499","parent_code":"017"},"00502":{"name":"Xã Vĩnh Ngọc","type":"xa","slug":"xa-vinh-ngoc","name_with_type":"Xã Vĩnh Ngọc","path":"Xã Vĩnh Ngọc, Huyện Đông Anh, Thành phố Hà Nội","path_with_type":"Xã Vĩnh Ngọc, Huyện Đông Anh, Thành phố Hà Nội","code":"00502","parent_code":"017"},"00505":{"name":"Xã Cổ Loa","type":"xa","slug":"xa-co-loa","name_with_type":"Xã Cổ Loa","path":"Xã Cổ Loa, Huyện Đông Anh, Thành phố Hà Nội","path_with_type":"Xã Cổ Loa, Huyện Đông Anh, Thành phố Hà Nội","code":"00505","parent_code":"017"},"00508":{"name":"Xã Hải Bối","type":"xa","slug":"xa-hai-boi","name_with_type":"Xã Hải Bối","path":"Xã Hải Bối, Huyện Đông Anh, Thành phố Hà Nội","path_with_type":"Xã Hải Bối, Huyện Đông Anh, Thành phố Hà Nội","code":"00508","parent_code":"017"},"00511":{"name":"Xã Xuân Canh","type":"xa","slug":"xa-xuan-canh","name_with_type":"Xã Xuân Canh","path":"Xã Xuân Canh, Huyện Đông Anh, Thành phố Hà Nội","path_with_type":"Xã Xuân Canh, Huyện Đông Anh, Thành phố Hà Nội","code":"00511","parent_code":"017"},"00514":{"name":"Xã Võng La","type":"xa","slug":"xa-vong-la","name_with_type":"Xã Võng La","path":"Xã Võng La, Huyện Đông Anh, Thành phố Hà Nội","path_with_type":"Xã Võng La, Huyện Đông Anh, Thành phố Hà Nội","code":"00514","parent_code":"017"},"00517":{"name":"Xã Tàm Xá","type":"xa","slug":"xa-tam-xa","name_with_type":"Xã Tàm Xá","path":"Xã Tàm Xá, Huyện Đông Anh, Thành phố Hà Nội","path_with_type":"Xã Tàm Xá, Huyện Đông Anh, Thành phố Hà Nội","code":"00517","parent_code":"017"},"00520":{"name":"Xã Mai Lâm","type":"xa","slug":"xa-mai-lam","name_with_type":"Xã Mai Lâm","path":"Xã Mai Lâm, Huyện Đông Anh, Thành phố Hà Nội","path_with_type":"Xã Mai Lâm, Huyện Đông Anh, Thành phố Hà Nội","code":"00520","parent_code":"017"},"00523":{"name":"Xã Đông Hội","type":"xa","slug":"xa-dong-hoi","name_with_type":"Xã Đông Hội","path":"Xã Đông Hội, Huyện Đông Anh, Thành phố Hà Nội","path_with_type":"Xã Đông Hội, Huyện Đông Anh, Thành phố Hà Nội","code":"00523","parent_code":"017"},"00526":{"name":"Thị trấn Yên Viên","type":"thi-tran","slug":"thi-tran-yen-vien","name_with_type":"Thị trấn Yên Viên","path":"Thị trấn Yên Viên, Huyện Gia Lâm, Thành phố Hà Nội","path_with_type":"Thị trấn Yên Viên, Huyện Gia Lâm, Thành phố Hà Nội","code":"00526","parent_code":"018"},"00529":{"name":"Xã Yên Thường","type":"xa","slug":"xa-yen-thuong","name_with_type":"Xã Yên Thường","path":"Xã Yên Thường, Huyện Gia Lâm, Thành phố Hà Nội","path_with_type":"Xã Yên Thường, Huyện Gia Lâm, Thành phố Hà Nội","code":"00529","parent_code":"018"},"00532":{"name":"Xã Yên Viên","type":"xa","slug":"xa-yen-vien","name_with_type":"Xã Yên Viên","path":"Xã Yên Viên, Huyện Gia Lâm, Thành phố Hà Nội","path_with_type":"Xã Yên Viên, Huyện Gia Lâm, Thành phố Hà Nội","code":"00532","parent_code":"018"},"00535":{"name":"Xã Ninh Hiệp","type":"xa","slug":"xa-ninh-hiep","name_with_type":"Xã Ninh Hiệp","path":"Xã Ninh Hiệp, Huyện Gia Lâm, Thành phố Hà Nội","path_with_type":"Xã Ninh Hiệp, Huyện Gia Lâm, Thành phố Hà Nội","code":"00535","parent_code":"018"},"00541":{"name":"Xã Thiên Đức","type":"xa","slug":"xa-thien-duc","name_with_type":"Xã Thiên Đức","path":"Xã Thiên Đức, Huyện Gia Lâm, Thành phố Hà Nội","path_with_type":"Xã Thiên Đức, Huyện Gia Lâm, Thành phố Hà Nội","code":"00541","parent_code":"018"},"00544":{"name":"Xã Phù Đổng","type":"xa","slug":"xa-phu-dong","name_with_type":"Xã Phù Đổng","path":"Xã Phù Đổng, Huyện Gia Lâm, Thành phố Hà Nội","path_with_type":"Xã Phù Đổng, Huyện Gia Lâm, Thành phố Hà Nội","code":"00544","parent_code":"018"},"00550":{"name":"Xã Lệ Chi","type":"xa","slug":"xa-le-chi","name_with_type":"Xã Lệ Chi","path":"Xã Lệ Chi, Huyện Gia Lâm, Thành phố Hà Nội","path_with_type":"Xã Lệ Chi, Huyện Gia Lâm, Thành phố Hà Nội","code":"00550","parent_code":"018"},"00553":{"name":"Xã Cổ Bi","type":"xa","slug":"xa-co-bi","name_with_type":"Xã Cổ Bi","path":"Xã Cổ Bi, Huyện Gia Lâm, Thành phố Hà Nội","path_with_type":"Xã Cổ Bi, Huyện Gia Lâm, Thành phố Hà Nội","code":"00553","parent_code":"018"},"00556":{"name":"Xã Đặng Xá","type":"xa","slug":"xa-dang-xa","name_with_type":"Xã Đặng Xá","path":"Xã Đặng Xá, Huyện Gia Lâm, Thành phố Hà Nội","path_with_type":"Xã Đặng Xá, Huyện Gia Lâm, Thành phố Hà Nội","code":"00556","parent_code":"018"},"00562":{"name":"Xã Phú Sơn","type":"xa","slug":"xa-phu-son","name_with_type":"Xã Phú Sơn","path":"Xã Phú Sơn, Huyện Gia Lâm, Thành phố Hà Nội","path_with_type":"Xã Phú Sơn, Huyện Gia Lâm, Thành phố Hà Nội","code":"00562","parent_code":"018"},"00565":{"name":"Thị trấn Trâu Quỳ","type":"thi-tran","slug":"thi-tran-trau-quy","name_with_type":"Thị trấn Trâu Quỳ","path":"Thị trấn Trâu Quỳ, Huyện Gia Lâm, Thành phố Hà Nội","path_with_type":"Thị trấn Trâu Quỳ, Huyện Gia Lâm, Thành phố Hà Nội","code":"00565","parent_code":"018"},"00568":{"name":"Xã Dương Quang","type":"xa","slug":"xa-duong-quang","name_with_type":"Xã Dương Quang","path":"Xã Dương Quang, Huyện Gia Lâm, Thành phố Hà Nội","path_with_type":"Xã Dương Quang, Huyện Gia Lâm, Thành phố Hà Nội","code":"00568","parent_code":"018"},"00571":{"name":"Xã Dương Xá","type":"xa","slug":"xa-duong-xa","name_with_type":"Xã Dương Xá","path":"Xã Dương Xá, Huyện Gia Lâm, Thành phố Hà Nội","path_with_type":"Xã Dương Xá, Huyện Gia Lâm, Thành phố Hà Nội","code":"00571","parent_code":"018"},"00577":{"name":"Xã Đa Tốn","type":"xa","slug":"xa-da-ton","name_with_type":"Xã Đa Tốn","path":"Xã Đa Tốn, Huyện Gia Lâm, Thành phố Hà Nội","path_with_type":"Xã Đa Tốn, Huyện Gia Lâm, Thành phố Hà Nội","code":"00577","parent_code":"018"},"00580":{"name":"Xã Kiêu Kỵ","type":"xa","slug":"xa-kieu-ky","name_with_type":"Xã Kiêu Kỵ","path":"Xã Kiêu Kỵ, Huyện Gia Lâm, Thành phố Hà Nội","path_with_type":"Xã Kiêu Kỵ, Huyện Gia Lâm, Thành phố Hà Nội","code":"00580","parent_code":"018"},"00583":{"name":"Xã Bát Tràng","type":"xa","slug":"xa-bat-trang","name_with_type":"Xã Bát Tràng","path":"Xã Bát Tràng, Huyện Gia Lâm, Thành phố Hà Nội","path_with_type":"Xã Bát Tràng, Huyện Gia Lâm, Thành phố Hà Nội","code":"00583","parent_code":"018"},"00589":{"name":"Xã Kim Đức","type":"xa","slug":"xa-kim-duc","name_with_type":"Xã Kim Đức","path":"Xã Kim Đức, Huyện Gia Lâm, Thành phố Hà Nội","path_with_type":"Xã Kim Đức, Huyện Gia Lâm, Thành phố Hà Nội","code":"00589","parent_code":"018"},"00592":{"name":"Phường Cầu Diễn","type":"phuong","slug":"phuong-cau-dien","name_with_type":"Phường Cầu Diễn","path":"Phường Cầu Diễn, Quận Nam Từ Liêm, Thành phố Hà Nội","path_with_type":"Phường Cầu Diễn, Quận Nam Từ Liêm, Thành phố Hà Nội","code":"00592","parent_code":"019"},"00622":{"name":"Phường Xuân Phương","type":"phuong","slug":"phuong-xuan-phuong","name_with_type":"Phường Xuân Phương","path":"Phường Xuân Phương, Quận Nam Từ Liêm, Thành phố Hà Nội","path_with_type":"Phường Xuân Phương, Quận Nam Từ Liêm, Thành phố Hà Nội","code":"00622","parent_code":"019"},"00623":{"name":"Phường Phương Canh","type":"phuong","slug":"phuong-phuong-canh","name_with_type":"Phường Phương Canh","path":"Phường Phương Canh, Quận Nam Từ Liêm, Thành phố Hà Nội","path_with_type":"Phường Phương Canh, Quận Nam Từ Liêm, Thành phố Hà Nội","code":"00623","parent_code":"019"},"00625":{"name":"Phường Mỹ Đình 1","type":"phuong","slug":"phuong-my-dinh-1","name_with_type":"Phường Mỹ Đình 1","path":"Phường Mỹ Đình 1, Quận Nam Từ Liêm, Thành phố Hà Nội","path_with_type":"Phường Mỹ Đình 1, Quận Nam Từ Liêm, Thành phố Hà Nội","code":"00625","parent_code":"019"},"00626":{"name":"Phường Mỹ Đình 2","type":"phuong","slug":"phuong-my-dinh-2","name_with_type":"Phường Mỹ Đình 2","path":"Phường Mỹ Đình 2, Quận Nam Từ Liêm, Thành phố Hà Nội","path_with_type":"Phường Mỹ Đình 2, Quận Nam Từ Liêm, Thành phố Hà Nội","code":"00626","parent_code":"019"},"00628":{"name":"Phường Tây Mỗ","type":"phuong","slug":"phuong-tay-mo","name_with_type":"Phường Tây Mỗ","path":"Phường Tây Mỗ, Quận Nam Từ Liêm, Thành phố Hà Nội","path_with_type":"Phường Tây Mỗ, Quận Nam Từ Liêm, Thành phố Hà Nội","code":"00628","parent_code":"019"},"00631":{"name":"Phường Mễ Trì","type":"phuong","slug":"phuong-me-tri","name_with_type":"Phường Mễ Trì","path":"Phường Mễ Trì, Quận Nam Từ Liêm, Thành phố Hà Nội","path_with_type":"Phường Mễ Trì, Quận Nam Từ Liêm, Thành phố Hà Nội","code":"00631","parent_code":"019"},"00632":{"name":"Phường Phú Đô","type":"phuong","slug":"phuong-phu-do","name_with_type":"Phường Phú Đô","path":"Phường Phú Đô, Quận Nam Từ Liêm, Thành phố Hà Nội","path_with_type":"Phường Phú Đô, Quận Nam Từ Liêm, Thành phố Hà Nội","code":"00632","parent_code":"019"},"00634":{"name":"Phường Đại Mỗ","type":"phuong","slug":"phuong-dai-mo","name_with_type":"Phường Đại Mỗ","path":"Phường Đại Mỗ, Quận Nam Từ Liêm, Thành phố Hà Nội","path_with_type":"Phường Đại Mỗ, Quận Nam Từ Liêm, Thành phố Hà Nội","code":"00634","parent_code":"019"},"00637":{"name":"Phường Trung Văn","type":"phuong","slug":"phuong-trung-van","name_with_type":"Phường Trung Văn","path":"Phường Trung Văn, Quận Nam Từ Liêm, Thành phố Hà Nội","path_with_type":"Phường Trung Văn, Quận Nam Từ Liêm, Thành phố Hà Nội","code":"00637","parent_code":"019"},"00640":{"name":"Thị trấn Văn Điển","type":"thi-tran","slug":"thi-tran-van-dien","name_with_type":"Thị trấn Văn Điển","path":"Thị trấn Văn Điển, Huyện Thanh Trì, Thành phố Hà Nội","path_with_type":"Thị trấn Văn Điển, Huyện Thanh Trì, Thành phố Hà Nội","code":"00640","parent_code":"020"},"00643":{"name":"Xã Tân Triều","type":"xa","slug":"xa-tan-trieu","name_with_type":"Xã Tân Triều","path":"Xã Tân Triều, Huyện Thanh Trì, Thành phố Hà Nội","path_with_type":"Xã Tân Triều, Huyện Thanh Trì, Thành phố Hà Nội","code":"00643","parent_code":"020"},"00646":{"name":"Xã Thanh Liệt","type":"xa","slug":"xa-thanh-liet","name_with_type":"Xã Thanh Liệt","path":"Xã Thanh Liệt, Huyện Thanh Trì, Thành phố Hà Nội","path_with_type":"Xã Thanh Liệt, Huyện Thanh Trì, Thành phố Hà Nội","code":"00646","parent_code":"020"},"00649":{"name":"Xã Tả Thanh Oai","type":"xa","slug":"xa-ta-thanh-oai","name_with_type":"Xã Tả Thanh Oai","path":"Xã Tả Thanh Oai, Huyện Thanh Trì, Thành phố Hà Nội","path_with_type":"Xã Tả Thanh Oai, Huyện Thanh Trì, Thành phố Hà Nội","code":"00649","parent_code":"020"},"00652":{"name":"Xã Hữu Hoà","type":"xa","slug":"xa-huu-hoa","name_with_type":"Xã Hữu Hoà","path":"Xã Hữu Hoà, Huyện Thanh Trì, Thành phố Hà Nội","path_with_type":"Xã Hữu Hoà, Huyện Thanh Trì, Thành phố Hà Nội","code":"00652","parent_code":"020"},"00655":{"name":"Xã Tam Hiệp","type":"xa","slug":"xa-tam-hiep","name_with_type":"Xã Tam Hiệp","path":"Xã Tam Hiệp, Huyện Thanh Trì, Thành phố Hà Nội","path_with_type":"Xã Tam Hiệp, Huyện Thanh Trì, Thành phố Hà Nội","code":"00655","parent_code":"020"},"00658":{"name":"Xã Tứ Hiệp","type":"xa","slug":"xa-tu-hiep","name_with_type":"Xã Tứ Hiệp","path":"Xã Tứ Hiệp, Huyện Thanh Trì, Thành phố Hà Nội","path_with_type":"Xã Tứ Hiệp, Huyện Thanh Trì, Thành phố Hà Nội","code":"00658","parent_code":"020"},"00661":{"name":"Xã Yên Mỹ","type":"xa","slug":"xa-yen-my","name_with_type":"Xã Yên Mỹ","path":"Xã Yên Mỹ, Huyện Thanh Trì, Thành phố Hà Nội","path_with_type":"Xã Yên Mỹ, Huyện Thanh Trì, Thành phố Hà Nội","code":"00661","parent_code":"020"},"00664":{"name":"Xã Vĩnh Quỳnh","type":"xa","slug":"xa-vinh-quynh","name_with_type":"Xã Vĩnh Quỳnh","path":"Xã Vĩnh Quỳnh, Huyện Thanh Trì, Thành phố Hà Nội","path_with_type":"Xã Vĩnh Quỳnh, Huyện Thanh Trì, Thành phố Hà Nội","code":"00664","parent_code":"020"},"00667":{"name":"Xã Ngũ Hiệp","type":"xa","slug":"xa-ngu-hiep","name_with_type":"Xã Ngũ Hiệp","path":"Xã Ngũ Hiệp, Huyện Thanh Trì, Thành phố Hà Nội","path_with_type":"Xã Ngũ Hiệp, Huyện Thanh Trì, Thành phố Hà Nội","code":"00667","parent_code":"020"},"00670":{"name":"Xã Duyên Hà","type":"xa","slug":"xa-duyen-ha","name_with_type":"Xã Duyên Hà","path":"Xã Duyên Hà, Huyện Thanh Trì, Thành phố Hà Nội","path_with_type":"Xã Duyên Hà, Huyện Thanh Trì, Thành phố Hà Nội","code":"00670","parent_code":"020"},"00673":{"name":"Xã Ngọc Hồi","type":"xa","slug":"xa-ngoc-hoi","name_with_type":"Xã Ngọc Hồi","path":"Xã Ngọc Hồi, Huyện Thanh Trì, Thành phố Hà Nội","path_with_type":"Xã Ngọc Hồi, Huyện Thanh Trì, Thành phố Hà Nội","code":"00673","parent_code":"020"},"00676":{"name":"Xã Vạn Phúc","type":"xa","slug":"xa-van-phuc","name_with_type":"Xã Vạn Phúc","path":"Xã Vạn Phúc, Huyện Thanh Trì, Thành phố Hà Nội","path_with_type":"Xã Vạn Phúc, Huyện Thanh Trì, Thành phố Hà Nội","code":"00676","parent_code":"020"},"00679":{"name":"Xã Đại áng","type":"xa","slug":"xa-dai-ang","name_with_type":"Xã Đại áng","path":"Xã Đại áng, Huyện Thanh Trì, Thành phố Hà Nội","path_with_type":"Xã Đại áng, Huyện Thanh Trì, Thành phố Hà Nội","code":"00679","parent_code":"020"},"00682":{"name":"Xã Liên Ninh","type":"xa","slug":"xa-lien-ninh","name_with_type":"Xã Liên Ninh","path":"Xã Liên Ninh, Huyện Thanh Trì, Thành phố Hà Nội","path_with_type":"Xã Liên Ninh, Huyện Thanh Trì, Thành phố Hà Nội","code":"00682","parent_code":"020"},"00685":{"name":"Xã Đông Mỹ","type":"xa","slug":"xa-dong-my","name_with_type":"Xã Đông Mỹ","path":"Xã Đông Mỹ, Huyện Thanh Trì, Thành phố Hà Nội","path_with_type":"Xã Đông Mỹ, Huyện Thanh Trì, Thành phố Hà Nội","code":"00685","parent_code":"020"},"00595":{"name":"Phường Thượng Cát","type":"phuong","slug":"phuong-thuong-cat","name_with_type":"Phường Thượng Cát","path":"Phường Thượng Cát, Quận Bắc Từ Liêm, Thành phố Hà Nội","path_with_type":"Phường Thượng Cát, Quận Bắc Từ Liêm, Thành phố Hà Nội","code":"00595","parent_code":"021"},"00598":{"name":"Phường Liên Mạc","type":"phuong","slug":"phuong-lien-mac","name_with_type":"Phường Liên Mạc","path":"Phường Liên Mạc, Quận Bắc Từ Liêm, Thành phố Hà Nội","path_with_type":"Phường Liên Mạc, Quận Bắc Từ Liêm, Thành phố Hà Nội","code":"00598","parent_code":"021"},"00601":{"name":"Phường Đông Ngạc","type":"phuong","slug":"phuong-dong-ngac","name_with_type":"Phường Đông Ngạc","path":"Phường Đông Ngạc, Quận Bắc Từ Liêm, Thành phố Hà Nội","path_with_type":"Phường Đông Ngạc, Quận Bắc Từ Liêm, Thành phố Hà Nội","code":"00601","parent_code":"021"},"00602":{"name":"Phường Đức Thắng","type":"phuong","slug":"phuong-duc-thang","name_with_type":"Phường Đức Thắng","path":"Phường Đức Thắng, Quận Bắc Từ Liêm, Thành phố Hà Nội","path_with_type":"Phường Đức Thắng, Quận Bắc Từ Liêm, Thành phố Hà Nội","code":"00602","parent_code":"021"},"00604":{"name":"Phường Thụy Phương","type":"phuong","slug":"phuong-thuy-phuong","name_with_type":"Phường Thụy Phương","path":"Phường Thụy Phương, Quận Bắc Từ Liêm, Thành phố Hà Nội","path_with_type":"Phường Thụy Phương, Quận Bắc Từ Liêm, Thành phố Hà Nội","code":"00604","parent_code":"021"},"00607":{"name":"Phường Tây Tựu","type":"phuong","slug":"phuong-tay-tuu","name_with_type":"Phường Tây Tựu","path":"Phường Tây Tựu, Quận Bắc Từ Liêm, Thành phố Hà Nội","path_with_type":"Phường Tây Tựu, Quận Bắc Từ Liêm, Thành phố Hà Nội","code":"00607","parent_code":"021"},"00610":{"name":"Phường Xuân Đỉnh","type":"phuong","slug":"phuong-xuan-dinh","name_with_type":"Phường Xuân Đỉnh","path":"Phường Xuân Đỉnh, Quận Bắc Từ Liêm, Thành phố Hà Nội","path_with_type":"Phường Xuân Đỉnh, Quận Bắc Từ Liêm, Thành phố Hà Nội","code":"00610","parent_code":"021"},"00611":{"name":"Phường Xuân Tảo","type":"phuong","slug":"phuong-xuan-tao","name_with_type":"Phường Xuân Tảo","path":"Phường Xuân Tảo, Quận Bắc Từ Liêm, Thành phố Hà Nội","path_with_type":"Phường Xuân Tảo, Quận Bắc Từ Liêm, Thành phố Hà Nội","code":"00611","parent_code":"021"},"00613":{"name":"Phường Minh Khai","type":"phuong","slug":"phuong-minh-khai","name_with_type":"Phường Minh Khai","path":"Phường Minh Khai, Quận Bắc Từ Liêm, Thành phố Hà Nội","path_with_type":"Phường Minh Khai, Quận Bắc Từ Liêm, Thành phố Hà Nội","code":"00613","parent_code":"021"},"00616":{"name":"Phường Cổ Nhuế 1","type":"phuong","slug":"phuong-co-nhue-1","name_with_type":"Phường Cổ Nhuế 1","path":"Phường Cổ Nhuế 1, Quận Bắc Từ Liêm, Thành phố Hà Nội","path_with_type":"Phường Cổ Nhuế 1, Quận Bắc Từ Liêm, Thành phố Hà Nội","code":"00616","parent_code":"021"},"00617":{"name":"Phường Cổ Nhuế 2","type":"phuong","slug":"phuong-co-nhue-2","name_with_type":"Phường Cổ Nhuế 2","path":"Phường Cổ Nhuế 2, Quận Bắc Từ Liêm, Thành phố Hà Nội","path_with_type":"Phường Cổ Nhuế 2, Quận Bắc Từ Liêm, Thành phố Hà Nội","code":"00617","parent_code":"021"},"00619":{"name":"Phường Phú Diễn","type":"phuong","slug":"phuong-phu-dien","name_with_type":"Phường Phú Diễn","path":"Phường Phú Diễn, Quận Bắc Từ Liêm, Thành phố Hà Nội","path_with_type":"Phường Phú Diễn, Quận Bắc Từ Liêm, Thành phố Hà Nội","code":"00619","parent_code":"021"},"00620":{"name":"Phường Phúc Diễn","type":"phuong","slug":"phuong-phuc-dien","name_with_type":"Phường Phúc Diễn","path":"Phường Phúc Diễn, Quận Bắc Từ Liêm, Thành phố Hà Nội","path_with_type":"Phường Phúc Diễn, Quận Bắc Từ Liêm, Thành phố Hà Nội","code":"00620","parent_code":"021"},"08973":{"name":"Thị trấn Chi Đông","type":"thi-tran","slug":"thi-tran-chi-dong","name_with_type":"Thị trấn Chi Đông","path":"Thị trấn Chi Đông, Huyện Mê Linh, Thành phố Hà Nội","path_with_type":"Thị trấn Chi Đông, Huyện Mê Linh, Thành phố Hà Nội","code":"08973","parent_code":"250"},"08974":{"name":"Xã Đại Thịnh","type":"xa","slug":"xa-dai-thinh","name_with_type":"Xã Đại Thịnh","path":"Xã Đại Thịnh, Huyện Mê Linh, Thành phố Hà Nội","path_with_type":"Xã Đại Thịnh, Huyện Mê Linh, Thành phố Hà Nội","code":"08974","parent_code":"250"},"08977":{"name":"Xã Kim Hoa","type":"xa","slug":"xa-kim-hoa","name_with_type":"Xã Kim Hoa","path":"Xã Kim Hoa, Huyện Mê Linh, Thành phố Hà Nội","path_with_type":"Xã Kim Hoa, Huyện Mê Linh, Thành phố Hà Nội","code":"08977","parent_code":"250"},"08980":{"name":"Xã Thạch Đà","type":"xa","slug":"xa-thach-da","name_with_type":"Xã Thạch Đà","path":"Xã Thạch Đà, Huyện Mê Linh, Thành phố Hà Nội","path_with_type":"Xã Thạch Đà, Huyện Mê Linh, Thành phố Hà Nội","code":"08980","parent_code":"250"},"08983":{"name":"Xã Tiến Thắng","type":"xa","slug":"xa-tien-thang","name_with_type":"Xã Tiến Thắng","path":"Xã Tiến Thắng, Huyện Mê Linh, Thành phố Hà Nội","path_with_type":"Xã Tiến Thắng, Huyện Mê Linh, Thành phố Hà Nội","code":"08983","parent_code":"250"},"08986":{"name":"Xã Tự Lập","type":"xa","slug":"xa-tu-lap","name_with_type":"Xã Tự Lập","path":"Xã Tự Lập, Huyện Mê Linh, Thành phố Hà Nội","path_with_type":"Xã Tự Lập, Huyện Mê Linh, Thành phố Hà Nội","code":"08986","parent_code":"250"},"08989":{"name":"Thị trấn Quang Minh","type":"thi-tran","slug":"thi-tran-quang-minh","name_with_type":"Thị trấn Quang Minh","path":"Thị trấn Quang Minh, Huyện Mê Linh, Thành phố Hà Nội","path_with_type":"Thị trấn Quang Minh, Huyện Mê Linh, Thành phố Hà Nội","code":"08989","parent_code":"250"},"08992":{"name":"Xã Thanh Lâm","type":"xa","slug":"xa-thanh-lam","name_with_type":"Xã Thanh Lâm","path":"Xã Thanh Lâm, Huyện Mê Linh, Thành phố Hà Nội","path_with_type":"Xã Thanh Lâm, Huyện Mê Linh, Thành phố Hà Nội","code":"08992","parent_code":"250"},"08995":{"name":"Xã Tam Đồng","type":"xa","slug":"xa-tam-dong","name_with_type":"Xã Tam Đồng","path":"Xã Tam Đồng, Huyện Mê Linh, Thành phố Hà Nội","path_with_type":"Xã Tam Đồng, Huyện Mê Linh, Thành phố Hà Nội","code":"08995","parent_code":"250"},"08998":{"name":"Xã Liên Mạc","type":"xa","slug":"xa-lien-mac","name_with_type":"Xã Liên Mạc","path":"Xã Liên Mạc, Huyện Mê Linh, Thành phố Hà Nội","path_with_type":"Xã Liên Mạc, Huyện Mê Linh, Thành phố Hà Nội","code":"08998","parent_code":"250"},"09004":{"name":"Xã Chu Phan","type":"xa","slug":"xa-chu-phan","name_with_type":"Xã Chu Phan","path":"Xã Chu Phan, Huyện Mê Linh, Thành phố Hà Nội","path_with_type":"Xã Chu Phan, Huyện Mê Linh, Thành phố Hà Nội","code":"09004","parent_code":"250"},"09007":{"name":"Xã Tiến Thịnh","type":"xa","slug":"xa-tien-thinh","name_with_type":"Xã Tiến Thịnh","path":"Xã Tiến Thịnh, Huyện Mê Linh, Thành phố Hà Nội","path_with_type":"Xã Tiến Thịnh, Huyện Mê Linh, Thành phố Hà Nội","code":"09007","parent_code":"250"},"09010":{"name":"Xã Mê Linh","type":"xa","slug":"xa-me-linh","name_with_type":"Xã Mê Linh","path":"Xã Mê Linh, Huyện Mê Linh, Thành phố Hà Nội","path_with_type":"Xã Mê Linh, Huyện Mê Linh, Thành phố Hà Nội","code":"09010","parent_code":"250"},"09013":{"name":"Xã Văn Khê","type":"xa","slug":"xa-van-khe","name_with_type":"Xã Văn Khê","path":"Xã Văn Khê, Huyện Mê Linh, Thành phố Hà Nội","path_with_type":"Xã Văn Khê, Huyện Mê Linh, Thành phố Hà Nội","code":"09013","parent_code":"250"},"09016":{"name":"Xã Hoàng Kim","type":"xa","slug":"xa-hoang-kim","name_with_type":"Xã Hoàng Kim","path":"Xã Hoàng Kim, Huyện Mê Linh, Thành phố Hà Nội","path_with_type":"Xã Hoàng Kim, Huyện Mê Linh, Thành phố Hà Nội","code":"09016","parent_code":"250"},"09019":{"name":"Xã Tiền Phong","type":"xa","slug":"xa-tien-phong","name_with_type":"Xã Tiền Phong","path":"Xã Tiền Phong, Huyện Mê Linh, Thành phố Hà Nội","path_with_type":"Xã Tiền Phong, Huyện Mê Linh, Thành phố Hà Nội","code":"09019","parent_code":"250"},"09022":{"name":"Xã Tráng Việt","type":"xa","slug":"xa-trang-viet","name_with_type":"Xã Tráng Việt","path":"Xã Tráng Việt, Huyện Mê Linh, Thành phố Hà Nội","path_with_type":"Xã Tráng Việt, Huyện Mê Linh, Thành phố Hà Nội","code":"09022","parent_code":"250"},"09538":{"name":"Phường Quang Trung","type":"phuong","slug":"phuong-quang-trung","name_with_type":"Phường Quang Trung","path":"Phường Quang Trung, Quận Hà Đông, Thành phố Hà Nội","path_with_type":"Phường Quang Trung, Quận Hà Đông, Thành phố Hà Nội","code":"09538","parent_code":"268"},"09541":{"name":"Phường Mộ Lao","type":"phuong","slug":"phuong-mo-lao","name_with_type":"Phường Mộ Lao","path":"Phường Mộ Lao, Quận Hà Đông, Thành phố Hà Nội","path_with_type":"Phường Mộ Lao, Quận Hà Đông, Thành phố Hà Nội","code":"09541","parent_code":"268"},"09542":{"name":"Phường Văn Quán","type":"phuong","slug":"phuong-van-quan","name_with_type":"Phường Văn Quán","path":"Phường Văn Quán, Quận Hà Đông, Thành phố Hà Nội","path_with_type":"Phường Văn Quán, Quận Hà Đông, Thành phố Hà Nội","code":"09542","parent_code":"268"},"09544":{"name":"Phường Vạn Phúc","type":"phuong","slug":"phuong-van-phuc","name_with_type":"Phường Vạn Phúc","path":"Phường Vạn Phúc, Quận Hà Đông, Thành phố Hà Nội","path_with_type":"Phường Vạn Phúc, Quận Hà Đông, Thành phố Hà Nội","code":"09544","parent_code":"268"},"09551":{"name":"Phường La Khê","type":"phuong","slug":"phuong-la-khe","name_with_type":"Phường La Khê","path":"Phường La Khê, Quận Hà Đông, Thành phố Hà Nội","path_with_type":"Phường La Khê, Quận Hà Đông, Thành phố Hà Nội","code":"09551","parent_code":"268"},"09552":{"name":"Phường Phú La","type":"phuong","slug":"phuong-phu-la","name_with_type":"Phường Phú La","path":"Phường Phú La, Quận Hà Đông, Thành phố Hà Nội","path_with_type":"Phường Phú La, Quận Hà Đông, Thành phố Hà Nội","code":"09552","parent_code":"268"},"09553":{"name":"Phường Phúc La","type":"phuong","slug":"phuong-phuc-la","name_with_type":"Phường Phúc La","path":"Phường Phúc La, Quận Hà Đông, Thành phố Hà Nội","path_with_type":"Phường Phúc La, Quận Hà Đông, Thành phố Hà Nội","code":"09553","parent_code":"268"},"09556":{"name":"Phường Hà Cầu","type":"phuong","slug":"phuong-ha-cau","name_with_type":"Phường Hà Cầu","path":"Phường Hà Cầu, Quận Hà Đông, Thành phố Hà Nội","path_with_type":"Phường Hà Cầu, Quận Hà Đông, Thành phố Hà Nội","code":"09556","parent_code":"268"},"09562":{"name":"Phường Yên Nghĩa","type":"phuong","slug":"phuong-yen-nghia","name_with_type":"Phường Yên Nghĩa","path":"Phường Yên Nghĩa, Quận Hà Đông, Thành phố Hà Nội","path_with_type":"Phường Yên Nghĩa, Quận Hà Đông, Thành phố Hà Nội","code":"09562","parent_code":"268"},"09565":{"name":"Phường Kiến Hưng","type":"phuong","slug":"phuong-kien-hung","name_with_type":"Phường Kiến Hưng","path":"Phường Kiến Hưng, Quận Hà Đông, Thành phố Hà Nội","path_with_type":"Phường Kiến Hưng, Quận Hà Đông, Thành phố Hà Nội","code":"09565","parent_code":"268"},"09568":{"name":"Phường Phú Lãm","type":"phuong","slug":"phuong-phu-lam","name_with_type":"Phường Phú Lãm","path":"Phường Phú Lãm, Quận Hà Đông, Thành phố Hà Nội","path_with_type":"Phường Phú Lãm, Quận Hà Đông, Thành phố Hà Nội","code":"09568","parent_code":"268"},"09571":{"name":"Phường Phú Lương","type":"phuong","slug":"phuong-phu-luong","name_with_type":"Phường Phú Lương","path":"Phường Phú Lương, Quận Hà Đông, Thành phố Hà Nội","path_with_type":"Phường Phú Lương, Quận Hà Đông, Thành phố Hà Nội","code":"09571","parent_code":"268"},"09886":{"name":"Phường Dương Nội","type":"phuong","slug":"phuong-duong-noi","name_with_type":"Phường Dương Nội","path":"Phường Dương Nội, Quận Hà Đông, Thành phố Hà Nội","path_with_type":"Phường Dương Nội, Quận Hà Đông, Thành phố Hà Nội","code":"09886","parent_code":"268"},"09574":{"name":"Phường Ngô Quyền","type":"phuong","slug":"phuong-ngo-quyen","name_with_type":"Phường Ngô Quyền","path":"Phường Ngô Quyền, Thị xã Sơn Tây, Thành phố Hà Nội","path_with_type":"Phường Ngô Quyền, Thị xã Sơn Tây, Thành phố Hà Nội","code":"09574","parent_code":"269"},"09577":{"name":"Phường Phú Thịnh","type":"phuong","slug":"phuong-phu-thinh","name_with_type":"Phường Phú Thịnh","path":"Phường Phú Thịnh, Thị xã Sơn Tây, Thành phố Hà Nội","path_with_type":"Phường Phú Thịnh, Thị xã Sơn Tây, Thành phố Hà Nội","code":"09577","parent_code":"269"},"09586":{"name":"Phường Sơn Lộc","type":"phuong","slug":"phuong-son-loc","name_with_type":"Phường Sơn Lộc","path":"Phường Sơn Lộc, Thị xã Sơn Tây, Thành phố Hà Nội","path_with_type":"Phường Sơn Lộc, Thị xã Sơn Tây, Thành phố Hà Nội","code":"09586","parent_code":"269"},"09589":{"name":"Phường Xuân Khanh","type":"phuong","slug":"phuong-xuan-khanh","name_with_type":"Phường Xuân Khanh","path":"Phường Xuân Khanh, Thị xã Sơn Tây, Thành phố Hà Nội","path_with_type":"Phường Xuân Khanh, Thị xã Sơn Tây, Thành phố Hà Nội","code":"09589","parent_code":"269"},"09592":{"name":"Xã Đường Lâm","type":"xa","slug":"xa-duong-lam","name_with_type":"Xã Đường Lâm","path":"Xã Đường Lâm, Thị xã Sơn Tây, Thành phố Hà Nội","path_with_type":"Xã Đường Lâm, Thị xã Sơn Tây, Thành phố Hà Nội","code":"09592","parent_code":"269"},"09595":{"name":"Phường Viên Sơn","type":"phuong","slug":"phuong-vien-son","name_with_type":"Phường Viên Sơn","path":"Phường Viên Sơn, Thị xã Sơn Tây, Thành phố Hà Nội","path_with_type":"Phường Viên Sơn, Thị xã Sơn Tây, Thành phố Hà Nội","code":"09595","parent_code":"269"},"09598":{"name":"Xã Xuân Sơn","type":"xa","slug":"xa-xuan-son","name_with_type":"Xã Xuân Sơn","path":"Xã Xuân Sơn, Thị xã Sơn Tây, Thành phố Hà Nội","path_with_type":"Xã Xuân Sơn, Thị xã Sơn Tây, Thành phố Hà Nội","code":"09598","parent_code":"269"},"09601":{"name":"Phường Trung Hưng","type":"phuong","slug":"phuong-trung-hung","name_with_type":"Phường Trung Hưng","path":"Phường Trung Hưng, Thị xã Sơn Tây, Thành phố Hà Nội","path_with_type":"Phường Trung Hưng, Thị xã Sơn Tây, Thành phố Hà Nội","code":"09601","parent_code":"269"},"09604":{"name":"Xã Thanh Mỹ","type":"xa","slug":"xa-thanh-my","name_with_type":"Xã Thanh Mỹ","path":"Xã Thanh Mỹ, Thị xã Sơn Tây, Thành phố Hà Nội","path_with_type":"Xã Thanh Mỹ, Thị xã Sơn Tây, Thành phố Hà Nội","code":"09604","parent_code":"269"},"09607":{"name":"Phường Trung Sơn Trầm","type":"phuong","slug":"phuong-trung-son-tram","name_with_type":"Phường Trung Sơn Trầm","path":"Phường Trung Sơn Trầm, Thị xã Sơn Tây, Thành phố Hà Nội","path_with_type":"Phường Trung Sơn Trầm, Thị xã Sơn Tây, Thành phố Hà Nội","code":"09607","parent_code":"269"},"09610":{"name":"Xã Kim Sơn","type":"xa","slug":"xa-kim-son","name_with_type":"Xã Kim Sơn","path":"Xã Kim Sơn, Thị xã Sơn Tây, Thành phố Hà Nội","path_with_type":"Xã Kim Sơn, Thị xã Sơn Tây, Thành phố Hà Nội","code":"09610","parent_code":"269"},"09613":{"name":"Xã Sơn Đông","type":"xa","slug":"xa-son-dong","name_with_type":"Xã Sơn Đông","path":"Xã Sơn Đông, Thị xã Sơn Tây, Thành phố Hà Nội","path_with_type":"Xã Sơn Đông, Thị xã Sơn Tây, Thành phố Hà Nội","code":"09613","parent_code":"269"},"09616":{"name":"Xã Cổ Đông","type":"xa","slug":"xa-co-dong","name_with_type":"Xã Cổ Đông","path":"Xã Cổ Đông, Thị xã Sơn Tây, Thành phố Hà Nội","path_with_type":"Xã Cổ Đông, Thị xã Sơn Tây, Thành phố Hà Nội","code":"09616","parent_code":"269"},"09619":{"name":"Thị trấn Tây Đằng","type":"thi-tran","slug":"thi-tran-tay-dang","name_with_type":"Thị trấn Tây Đằng","path":"Thị trấn Tây Đằng, Huyện Ba Vì, Thành phố Hà Nội","path_with_type":"Thị trấn Tây Đằng, Huyện Ba Vì, Thành phố Hà Nội","code":"09619","parent_code":"271"},"09625":{"name":"Xã Phú Cường","type":"xa","slug":"xa-phu-cuong","name_with_type":"Xã Phú Cường","path":"Xã Phú Cường, Huyện Ba Vì, Thành phố Hà Nội","path_with_type":"Xã Phú Cường, Huyện Ba Vì, Thành phố Hà Nội","code":"09625","parent_code":"271"},"09628":{"name":"Xã Cổ Đô","type":"xa","slug":"xa-co-do","name_with_type":"Xã Cổ Đô","path":"Xã Cổ Đô, Huyện Ba Vì, Thành phố Hà Nội","path_with_type":"Xã Cổ Đô, Huyện Ba Vì, Thành phố Hà Nội","code":"09628","parent_code":"271"},"09634":{"name":"Xã Vạn Thắng","type":"xa","slug":"xa-van-thang","name_with_type":"Xã Vạn Thắng","path":"Xã Vạn Thắng, Huyện Ba Vì, Thành phố Hà Nội","path_with_type":"Xã Vạn Thắng, Huyện Ba Vì, Thành phố Hà Nội","code":"09634","parent_code":"271"},"09640":{"name":"Xã Phong Vân","type":"xa","slug":"xa-phong-van","name_with_type":"Xã Phong Vân","path":"Xã Phong Vân, Huyện Ba Vì, Thành phố Hà Nội","path_with_type":"Xã Phong Vân, Huyện Ba Vì, Thành phố Hà Nội","code":"09640","parent_code":"271"},"09643":{"name":"Xã Phú Đông","type":"xa","slug":"xa-phu-dong","name_with_type":"Xã Phú Đông","path":"Xã Phú Đông, Huyện Ba Vì, Thành phố Hà Nội","path_with_type":"Xã Phú Đông, Huyện Ba Vì, Thành phố Hà Nội","code":"09643","parent_code":"271"},"09646":{"name":"Xã Phú Hồng","type":"xa","slug":"xa-phu-hong","name_with_type":"Xã Phú Hồng","path":"Xã Phú Hồng, Huyện Ba Vì, Thành phố Hà Nội","path_with_type":"Xã Phú Hồng, Huyện Ba Vì, Thành phố Hà Nội","code":"09646","parent_code":"271"},"09649":{"name":"Xã Phú Châu","type":"xa","slug":"xa-phu-chau","name_with_type":"Xã Phú Châu","path":"Xã Phú Châu, Huyện Ba Vì, Thành phố Hà Nội","path_with_type":"Xã Phú Châu, Huyện Ba Vì, Thành phố Hà Nội","code":"09649","parent_code":"271"},"09652":{"name":"Xã Thái Hòa","type":"xa","slug":"xa-thai-hoa","name_with_type":"Xã Thái Hòa","path":"Xã Thái Hòa, Huyện Ba Vì, Thành phố Hà Nội","path_with_type":"Xã Thái Hòa, Huyện Ba Vì, Thành phố Hà Nội","code":"09652","parent_code":"271"},"09655":{"name":"Xã Đồng Thái","type":"xa","slug":"xa-dong-thai","name_with_type":"Xã Đồng Thái","path":"Xã Đồng Thái, Huyện Ba Vì, Thành phố Hà Nội","path_with_type":"Xã Đồng Thái, Huyện Ba Vì, Thành phố Hà Nội","code":"09655","parent_code":"271"},"09658":{"name":"Xã Phú Sơn","type":"xa","slug":"xa-phu-son","name_with_type":"Xã Phú Sơn","path":"Xã Phú Sơn, Huyện Ba Vì, Thành phố Hà Nội","path_with_type":"Xã Phú Sơn, Huyện Ba Vì, Thành phố Hà Nội","code":"09658","parent_code":"271"},"09661":{"name":"Xã Minh Châu","type":"xa","slug":"xa-minh-chau","name_with_type":"Xã Minh Châu","path":"Xã Minh Châu, Huyện Ba Vì, Thành phố Hà Nội","path_with_type":"Xã Minh Châu, Huyện Ba Vì, Thành phố Hà Nội","code":"09661","parent_code":"271"},"09664":{"name":"Xã Vật Lại","type":"xa","slug":"xa-vat-lai","name_with_type":"Xã Vật Lại","path":"Xã Vật Lại, Huyện Ba Vì, Thành phố Hà Nội","path_with_type":"Xã Vật Lại, Huyện Ba Vì, Thành phố Hà Nội","code":"09664","parent_code":"271"},"09667":{"name":"Xã Chu Minh","type":"xa","slug":"xa-chu-minh","name_with_type":"Xã Chu Minh","path":"Xã Chu Minh, Huyện Ba Vì, Thành phố Hà Nội","path_with_type":"Xã Chu Minh, Huyện Ba Vì, Thành phố Hà Nội","code":"09667","parent_code":"271"},"09670":{"name":"Xã Tòng Bạt","type":"xa","slug":"xa-tong-bat","name_with_type":"Xã Tòng Bạt","path":"Xã Tòng Bạt, Huyện Ba Vì, Thành phố Hà Nội","path_with_type":"Xã Tòng Bạt, Huyện Ba Vì, Thành phố Hà Nội","code":"09670","parent_code":"271"},"09673":{"name":"Xã Cẩm Lĩnh","type":"xa","slug":"xa-cam-linh","name_with_type":"Xã Cẩm Lĩnh","path":"Xã Cẩm Lĩnh, Huyện Ba Vì, Thành phố Hà Nội","path_with_type":"Xã Cẩm Lĩnh, Huyện Ba Vì, Thành phố Hà Nội","code":"09673","parent_code":"271"},"09676":{"name":"Xã Sơn Đà","type":"xa","slug":"xa-son-da","name_with_type":"Xã Sơn Đà","path":"Xã Sơn Đà, Huyện Ba Vì, Thành phố Hà Nội","path_with_type":"Xã Sơn Đà, Huyện Ba Vì, Thành phố Hà Nội","code":"09676","parent_code":"271"},"09679":{"name":"Xã Đông Quang","type":"xa","slug":"xa-dong-quang","name_with_type":"Xã Đông Quang","path":"Xã Đông Quang, Huyện Ba Vì, Thành phố Hà Nội","path_with_type":"Xã Đông Quang, Huyện Ba Vì, Thành phố Hà Nội","code":"09679","parent_code":"271"},"09682":{"name":"Xã Tiên Phong","type":"xa","slug":"xa-tien-phong","name_with_type":"Xã Tiên Phong","path":"Xã Tiên Phong, Huyện Ba Vì, Thành phố Hà Nội","path_with_type":"Xã Tiên Phong, Huyện Ba Vì, Thành phố Hà Nội","code":"09682","parent_code":"271"},"09685":{"name":"Xã Thụy An","type":"xa","slug":"xa-thuy-an","name_with_type":"Xã Thụy An","path":"Xã Thụy An, Huyện Ba Vì, Thành phố Hà Nội","path_with_type":"Xã Thụy An, Huyện Ba Vì, Thành phố Hà Nội","code":"09685","parent_code":"271"},"09688":{"name":"Xã Cam Thượng","type":"xa","slug":"xa-cam-thuong","name_with_type":"Xã Cam Thượng","path":"Xã Cam Thượng, Huyện Ba Vì, Thành phố Hà Nội","path_with_type":"Xã Cam Thượng, Huyện Ba Vì, Thành phố Hà Nội","code":"09688","parent_code":"271"},"09691":{"name":"Xã Thuần Mỹ","type":"xa","slug":"xa-thuan-my","name_with_type":"Xã Thuần Mỹ","path":"Xã Thuần Mỹ, Huyện Ba Vì, Thành phố Hà Nội","path_with_type":"Xã Thuần Mỹ, Huyện Ba Vì, Thành phố Hà Nội","code":"09691","parent_code":"271"},"09694":{"name":"Xã Tản Lĩnh","type":"xa","slug":"xa-tan-linh","name_with_type":"Xã Tản Lĩnh","path":"Xã Tản Lĩnh, Huyện Ba Vì, Thành phố Hà Nội","path_with_type":"Xã Tản Lĩnh, Huyện Ba Vì, Thành phố Hà Nội","code":"09694","parent_code":"271"},"09697":{"name":"Xã Ba Trại","type":"xa","slug":"xa-ba-trai","name_with_type":"Xã Ba Trại","path":"Xã Ba Trại, Huyện Ba Vì, Thành phố Hà Nội","path_with_type":"Xã Ba Trại, Huyện Ba Vì, Thành phố Hà Nội","code":"09697","parent_code":"271"},"09700":{"name":"Xã Minh Quang","type":"xa","slug":"xa-minh-quang","name_with_type":"Xã Minh Quang","path":"Xã Minh Quang, Huyện Ba Vì, Thành phố Hà Nội","path_with_type":"Xã Minh Quang, Huyện Ba Vì, Thành phố Hà Nội","code":"09700","parent_code":"271"},"09703":{"name":"Xã Ba Vì","type":"xa","slug":"xa-ba-vi","name_with_type":"Xã Ba Vì","path":"Xã Ba Vì, Huyện Ba Vì, Thành phố Hà Nội","path_with_type":"Xã Ba Vì, Huyện Ba Vì, Thành phố Hà Nội","code":"09703","parent_code":"271"},"09706":{"name":"Xã Vân Hòa","type":"xa","slug":"xa-van-hoa","name_with_type":"Xã Vân Hòa","path":"Xã Vân Hòa, Huyện Ba Vì, Thành phố Hà Nội","path_with_type":"Xã Vân Hòa, Huyện Ba Vì, Thành phố Hà Nội","code":"09706","parent_code":"271"},"09709":{"name":"Xã Yên Bài","type":"xa","slug":"xa-yen-bai","name_with_type":"Xã Yên Bài","path":"Xã Yên Bài, Huyện Ba Vì, Thành phố Hà Nội","path_with_type":"Xã Yên Bài, Huyện Ba Vì, Thành phố Hà Nội","code":"09709","parent_code":"271"},"09712":{"name":"Xã Khánh Thượng","type":"xa","slug":"xa-khanh-thuong","name_with_type":"Xã Khánh Thượng","path":"Xã Khánh Thượng, Huyện Ba Vì, Thành phố Hà Nội","path_with_type":"Xã Khánh Thượng, Huyện Ba Vì, Thành phố Hà Nội","code":"09712","parent_code":"271"},"09715":{"name":"Thị trấn Phúc Thọ","type":"thi-tran","slug":"thi-tran-phuc-tho","name_with_type":"Thị trấn Phúc Thọ","path":"Thị trấn Phúc Thọ, Huyện Phúc Thọ, Thành phố Hà Nội","path_with_type":"Thị trấn Phúc Thọ, Huyện Phúc Thọ, Thành phố Hà Nội","code":"09715","parent_code":"272"},"09721":{"name":"Xã Vân Phúc","type":"xa","slug":"xa-van-phuc","name_with_type":"Xã Vân Phúc","path":"Xã Vân Phúc, Huyện Phúc Thọ, Thành phố Hà Nội","path_with_type":"Xã Vân Phúc, Huyện Phúc Thọ, Thành phố Hà Nội","code":"09721","parent_code":"272"},"09724":{"name":"Xã Nam Hà","type":"xa","slug":"xa-nam-ha","name_with_type":"Xã Nam Hà","path":"Xã Nam Hà, Huyện Phúc Thọ, Thành phố Hà Nội","path_with_type":"Xã Nam Hà, Huyện Phúc Thọ, Thành phố Hà Nội","code":"09724","parent_code":"272"},"09727":{"name":"Xã Xuân Đình","type":"xa","slug":"xa-xuan-dinh","name_with_type":"Xã Xuân Đình","path":"Xã Xuân Đình, Huyện Phúc Thọ, Thành phố Hà Nội","path_with_type":"Xã Xuân Đình, Huyện Phúc Thọ, Thành phố Hà Nội","code":"09727","parent_code":"272"},"09733":{"name":"Xã Sen Phương","type":"xa","slug":"xa-sen-phuong","name_with_type":"Xã Sen Phương","path":"Xã Sen Phương, Huyện Phúc Thọ, Thành phố Hà Nội","path_with_type":"Xã Sen Phương, Huyện Phúc Thọ, Thành phố Hà Nội","code":"09733","parent_code":"272"},"09739":{"name":"Xã Võng Xuyên","type":"xa","slug":"xa-vong-xuyen","name_with_type":"Xã Võng Xuyên","path":"Xã Võng Xuyên, Huyện Phúc Thọ, Thành phố Hà Nội","path_with_type":"Xã Võng Xuyên, Huyện Phúc Thọ, Thành phố Hà Nội","code":"09739","parent_code":"272"},"09742":{"name":"Xã Tích Lộc","type":"xa","slug":"xa-tich-loc","name_with_type":"Xã Tích Lộc","path":"Xã Tích Lộc, Huyện Phúc Thọ, Thành phố Hà Nội","path_with_type":"Xã Tích Lộc, Huyện Phúc Thọ, Thành phố Hà Nội","code":"09742","parent_code":"272"},"09745":{"name":"Xã Long Thượng","type":"xa","slug":"xa-long-thuong","name_with_type":"Xã Long Thượng","path":"Xã Long Thượng, Huyện Phúc Thọ, Thành phố Hà Nội","path_with_type":"Xã Long Thượng, Huyện Phúc Thọ, Thành phố Hà Nội","code":"09745","parent_code":"272"},"09751":{"name":"Xã Hát Môn","type":"xa","slug":"xa-hat-mon","name_with_type":"Xã Hát Môn","path":"Xã Hát Môn, Huyện Phúc Thọ, Thành phố Hà Nội","path_with_type":"Xã Hát Môn, Huyện Phúc Thọ, Thành phố Hà Nội","code":"09751","parent_code":"272"},"09757":{"name":"Xã Thanh Đa","type":"xa","slug":"xa-thanh-da","name_with_type":"Xã Thanh Đa","path":"Xã Thanh Đa, Huyện Phúc Thọ, Thành phố Hà Nội","path_with_type":"Xã Thanh Đa, Huyện Phúc Thọ, Thành phố Hà Nội","code":"09757","parent_code":"272"},"09760":{"name":"Xã Trạch Mỹ Lộc","type":"xa","slug":"xa-trach-my-loc","name_with_type":"Xã Trạch Mỹ Lộc","path":"Xã Trạch Mỹ Lộc, Huyện Phúc Thọ, Thành phố Hà Nội","path_with_type":"Xã Trạch Mỹ Lộc, Huyện Phúc Thọ, Thành phố Hà Nội","code":"09760","parent_code":"272"},"09763":{"name":"Xã Phúc Hòa","type":"xa","slug":"xa-phuc-hoa","name_with_type":"Xã Phúc Hòa","path":"Xã Phúc Hòa, Huyện Phúc Thọ, Thành phố Hà Nội","path_with_type":"Xã Phúc Hòa, Huyện Phúc Thọ, Thành phố Hà Nội","code":"09763","parent_code":"272"},"09766":{"name":"Xã Ngọc Tảo","type":"xa","slug":"xa-ngoc-tao","name_with_type":"Xã Ngọc Tảo","path":"Xã Ngọc Tảo, Huyện Phúc Thọ, Thành phố Hà Nội","path_with_type":"Xã Ngọc Tảo, Huyện Phúc Thọ, Thành phố Hà Nội","code":"09766","parent_code":"272"},"09769":{"name":"Xã Phụng Thượng","type":"xa","slug":"xa-phung-thuong","name_with_type":"Xã Phụng Thượng","path":"Xã Phụng Thượng, Huyện Phúc Thọ, Thành phố Hà Nội","path_with_type":"Xã Phụng Thượng, Huyện Phúc Thọ, Thành phố Hà Nội","code":"09769","parent_code":"272"},"09772":{"name":"Xã Tam Thuấn","type":"xa","slug":"xa-tam-thuan","name_with_type":"Xã Tam Thuấn","path":"Xã Tam Thuấn, Huyện Phúc Thọ, Thành phố Hà Nội","path_with_type":"Xã Tam Thuấn, Huyện Phúc Thọ, Thành phố Hà Nội","code":"09772","parent_code":"272"},"09775":{"name":"Xã Tam Hiệp","type":"xa","slug":"xa-tam-hiep","name_with_type":"Xã Tam Hiệp","path":"Xã Tam Hiệp, Huyện Phúc Thọ, Thành phố Hà Nội","path_with_type":"Xã Tam Hiệp, Huyện Phúc Thọ, Thành phố Hà Nội","code":"09775","parent_code":"272"},"09778":{"name":"Xã Hiệp Thuận","type":"xa","slug":"xa-hiep-thuan","name_with_type":"Xã Hiệp Thuận","path":"Xã Hiệp Thuận, Huyện Phúc Thọ, Thành phố Hà Nội","path_with_type":"Xã Hiệp Thuận, Huyện Phúc Thọ, Thành phố Hà Nội","code":"09778","parent_code":"272"},"09781":{"name":"Xã Liên Hiệp","type":"xa","slug":"xa-lien-hiep","name_with_type":"Xã Liên Hiệp","path":"Xã Liên Hiệp, Huyện Phúc Thọ, Thành phố Hà Nội","path_with_type":"Xã Liên Hiệp, Huyện Phúc Thọ, Thành phố Hà Nội","code":"09781","parent_code":"272"},"09784":{"name":"Thị trấn Phùng","type":"thi-tran","slug":"thi-tran-phung","name_with_type":"Thị trấn Phùng","path":"Thị trấn Phùng, Huyện Đan Phượng, Thành phố Hà Nội","path_with_type":"Thị trấn Phùng, Huyện Đan Phượng, Thành phố Hà Nội","code":"09784","parent_code":"273"},"09787":{"name":"Xã Trung Châu","type":"xa","slug":"xa-trung-chau","name_with_type":"Xã Trung Châu","path":"Xã Trung Châu, Huyện Đan Phượng, Thành phố Hà Nội","path_with_type":"Xã Trung Châu, Huyện Đan Phượng, Thành phố Hà Nội","code":"09787","parent_code":"273"},"09790":{"name":"Xã Thọ An","type":"xa","slug":"xa-tho-an","name_with_type":"Xã Thọ An","path":"Xã Thọ An, Huyện Đan Phượng, Thành phố Hà Nội","path_with_type":"Xã Thọ An, Huyện Đan Phượng, Thành phố Hà Nội","code":"09790","parent_code":"273"},"09793":{"name":"Xã Thọ Xuân","type":"xa","slug":"xa-tho-xuan","name_with_type":"Xã Thọ Xuân","path":"Xã Thọ Xuân, Huyện Đan Phượng, Thành phố Hà Nội","path_with_type":"Xã Thọ Xuân, Huyện Đan Phượng, Thành phố Hà Nội","code":"09793","parent_code":"273"},"09796":{"name":"Xã Hồng Hà","type":"xa","slug":"xa-hong-ha","name_with_type":"Xã Hồng Hà","path":"Xã Hồng Hà, Huyện Đan Phượng, Thành phố Hà Nội","path_with_type":"Xã Hồng Hà, Huyện Đan Phượng, Thành phố Hà Nội","code":"09796","parent_code":"273"},"09799":{"name":"Xã Liên Hồng","type":"xa","slug":"xa-lien-hong","name_with_type":"Xã Liên Hồng","path":"Xã Liên Hồng, Huyện Đan Phượng, Thành phố Hà Nội","path_with_type":"Xã Liên Hồng, Huyện Đan Phượng, Thành phố Hà Nội","code":"09799","parent_code":"273"},"09802":{"name":"Xã Liên Hà","type":"xa","slug":"xa-lien-ha","name_with_type":"Xã Liên Hà","path":"Xã Liên Hà, Huyện Đan Phượng, Thành phố Hà Nội","path_with_type":"Xã Liên Hà, Huyện Đan Phượng, Thành phố Hà Nội","code":"09802","parent_code":"273"},"09805":{"name":"Xã Hạ Mỗ","type":"xa","slug":"xa-ha-mo","name_with_type":"Xã Hạ Mỗ","path":"Xã Hạ Mỗ, Huyện Đan Phượng, Thành phố Hà Nội","path_with_type":"Xã Hạ Mỗ, Huyện Đan Phượng, Thành phố Hà Nội","code":"09805","parent_code":"273"},"09808":{"name":"Xã Liên Trung","type":"xa","slug":"xa-lien-trung","name_with_type":"Xã Liên Trung","path":"Xã Liên Trung, Huyện Đan Phượng, Thành phố Hà Nội","path_with_type":"Xã Liên Trung, Huyện Đan Phượng, Thành phố Hà Nội","code":"09808","parent_code":"273"},"09811":{"name":"Xã Phương Đình","type":"xa","slug":"xa-phuong-dinh","name_with_type":"Xã Phương Đình","path":"Xã Phương Đình, Huyện Đan Phượng, Thành phố Hà Nội","path_with_type":"Xã Phương Đình, Huyện Đan Phượng, Thành phố Hà Nội","code":"09811","parent_code":"273"},"09814":{"name":"Xã Thượng Mỗ","type":"xa","slug":"xa-thuong-mo","name_with_type":"Xã Thượng Mỗ","path":"Xã Thượng Mỗ, Huyện Đan Phượng, Thành phố Hà Nội","path_with_type":"Xã Thượng Mỗ, Huyện Đan Phượng, Thành phố Hà Nội","code":"09814","parent_code":"273"},"09817":{"name":"Xã Tân Hội","type":"xa","slug":"xa-tan-hoi","name_with_type":"Xã Tân Hội","path":"Xã Tân Hội, Huyện Đan Phượng, Thành phố Hà Nội","path_with_type":"Xã Tân Hội, Huyện Đan Phượng, Thành phố Hà Nội","code":"09817","parent_code":"273"},"09820":{"name":"Xã Tân Lập","type":"xa","slug":"xa-tan-lap","name_with_type":"Xã Tân Lập","path":"Xã Tân Lập, Huyện Đan Phượng, Thành phố Hà Nội","path_with_type":"Xã Tân Lập, Huyện Đan Phượng, Thành phố Hà Nội","code":"09820","parent_code":"273"},"09823":{"name":"Xã Đan Phượng","type":"xa","slug":"xa-dan-phuong","name_with_type":"Xã Đan Phượng","path":"Xã Đan Phượng, Huyện Đan Phượng, Thành phố Hà Nội","path_with_type":"Xã Đan Phượng, Huyện Đan Phượng, Thành phố Hà Nội","code":"09823","parent_code":"273"},"09826":{"name":"Xã Đồng Tháp","type":"xa","slug":"xa-dong-thap","name_with_type":"Xã Đồng Tháp","path":"Xã Đồng Tháp, Huyện Đan Phượng, Thành phố Hà Nội","path_with_type":"Xã Đồng Tháp, Huyện Đan Phượng, Thành phố Hà Nội","code":"09826","parent_code":"273"},"09829":{"name":"Xã Song Phượng","type":"xa","slug":"xa-song-phuong","name_with_type":"Xã Song Phượng","path":"Xã Song Phượng, Huyện Đan Phượng, Thành phố Hà Nội","path_with_type":"Xã Song Phượng, Huyện Đan Phượng, Thành phố Hà Nội","code":"09829","parent_code":"273"},"09832":{"name":"Thị trấn Trạm Trôi","type":"thi-tran","slug":"thi-tran-tram-troi","name_with_type":"Thị trấn Trạm Trôi","path":"Thị trấn Trạm Trôi, Huyện Hoài Đức, Thành phố Hà Nội","path_with_type":"Thị trấn Trạm Trôi, Huyện Hoài Đức, Thành phố Hà Nội","code":"09832","parent_code":"274"},"09835":{"name":"Xã Đức Thượng","type":"xa","slug":"xa-duc-thuong","name_with_type":"Xã Đức Thượng","path":"Xã Đức Thượng, Huyện Hoài Đức, Thành phố Hà Nội","path_with_type":"Xã Đức Thượng, Huyện Hoài Đức, Thành phố Hà Nội","code":"09835","parent_code":"274"},"09838":{"name":"Xã Minh Khai","type":"xa","slug":"xa-minh-khai","name_with_type":"Xã Minh Khai","path":"Xã Minh Khai, Huyện Hoài Đức, Thành phố Hà Nội","path_with_type":"Xã Minh Khai, Huyện Hoài Đức, Thành phố Hà Nội","code":"09838","parent_code":"274"},"09841":{"name":"Xã Dương Liễu","type":"xa","slug":"xa-duong-lieu","name_with_type":"Xã Dương Liễu","path":"Xã Dương Liễu, Huyện Hoài Đức, Thành phố Hà Nội","path_with_type":"Xã Dương Liễu, Huyện Hoài Đức, Thành phố Hà Nội","code":"09841","parent_code":"274"},"09844":{"name":"Xã Di Trạch","type":"xa","slug":"xa-di-trach","name_with_type":"Xã Di Trạch","path":"Xã Di Trạch, Huyện Hoài Đức, Thành phố Hà Nội","path_with_type":"Xã Di Trạch, Huyện Hoài Đức, Thành phố Hà Nội","code":"09844","parent_code":"274"},"09847":{"name":"Xã Đức Giang","type":"xa","slug":"xa-duc-giang","name_with_type":"Xã Đức Giang","path":"Xã Đức Giang, Huyện Hoài Đức, Thành phố Hà Nội","path_with_type":"Xã Đức Giang, Huyện Hoài Đức, Thành phố Hà Nội","code":"09847","parent_code":"274"},"09850":{"name":"Xã Cát Quế","type":"xa","slug":"xa-cat-que","name_with_type":"Xã Cát Quế","path":"Xã Cát Quế, Huyện Hoài Đức, Thành phố Hà Nội","path_with_type":"Xã Cát Quế, Huyện Hoài Đức, Thành phố Hà Nội","code":"09850","parent_code":"274"},"09853":{"name":"Xã Kim Chung","type":"xa","slug":"xa-kim-chung","name_with_type":"Xã Kim Chung","path":"Xã Kim Chung, Huyện Hoài Đức, Thành phố Hà Nội","path_with_type":"Xã Kim Chung, Huyện Hoài Đức, Thành phố Hà Nội","code":"09853","parent_code":"274"},"09856":{"name":"Xã Yên Sở","type":"xa","slug":"xa-yen-so","name_with_type":"Xã Yên Sở","path":"Xã Yên Sở, Huyện Hoài Đức, Thành phố Hà Nội","path_with_type":"Xã Yên Sở, Huyện Hoài Đức, Thành phố Hà Nội","code":"09856","parent_code":"274"},"09859":{"name":"Xã Sơn Đồng","type":"xa","slug":"xa-son-dong","name_with_type":"Xã Sơn Đồng","path":"Xã Sơn Đồng, Huyện Hoài Đức, Thành phố Hà Nội","path_with_type":"Xã Sơn Đồng, Huyện Hoài Đức, Thành phố Hà Nội","code":"09859","parent_code":"274"},"09862":{"name":"Xã Vân Canh","type":"xa","slug":"xa-van-canh","name_with_type":"Xã Vân Canh","path":"Xã Vân Canh, Huyện Hoài Đức, Thành phố Hà Nội","path_with_type":"Xã Vân Canh, Huyện Hoài Đức, Thành phố Hà Nội","code":"09862","parent_code":"274"},"09865":{"name":"Xã Đắc Sở","type":"xa","slug":"xa-dac-so","name_with_type":"Xã Đắc Sở","path":"Xã Đắc Sở, Huyện Hoài Đức, Thành phố Hà Nội","path_with_type":"Xã Đắc Sở, Huyện Hoài Đức, Thành phố Hà Nội","code":"09865","parent_code":"274"},"09868":{"name":"Xã Lại Yên","type":"xa","slug":"xa-lai-yen","name_with_type":"Xã Lại Yên","path":"Xã Lại Yên, Huyện Hoài Đức, Thành phố Hà Nội","path_with_type":"Xã Lại Yên, Huyện Hoài Đức, Thành phố Hà Nội","code":"09868","parent_code":"274"},"09871":{"name":"Xã Tiền Yên","type":"xa","slug":"xa-tien-yen","name_with_type":"Xã Tiền Yên","path":"Xã Tiền Yên, Huyện Hoài Đức, Thành phố Hà Nội","path_with_type":"Xã Tiền Yên, Huyện Hoài Đức, Thành phố Hà Nội","code":"09871","parent_code":"274"},"09874":{"name":"Xã Song Phương","type":"xa","slug":"xa-song-phuong","name_with_type":"Xã Song Phương","path":"Xã Song Phương, Huyện Hoài Đức, Thành phố Hà Nội","path_with_type":"Xã Song Phương, Huyện Hoài Đức, Thành phố Hà Nội","code":"09874","parent_code":"274"},"09877":{"name":"Xã An Khánh","type":"xa","slug":"xa-an-khanh","name_with_type":"Xã An Khánh","path":"Xã An Khánh, Huyện Hoài Đức, Thành phố Hà Nội","path_with_type":"Xã An Khánh, Huyện Hoài Đức, Thành phố Hà Nội","code":"09877","parent_code":"274"},"09880":{"name":"Xã An Thượng","type":"xa","slug":"xa-an-thuong","name_with_type":"Xã An Thượng","path":"Xã An Thượng, Huyện Hoài Đức, Thành phố Hà Nội","path_with_type":"Xã An Thượng, Huyện Hoài Đức, Thành phố Hà Nội","code":"09880","parent_code":"274"},"09883":{"name":"Xã Vân Côn","type":"xa","slug":"xa-van-con","name_with_type":"Xã Vân Côn","path":"Xã Vân Côn, Huyện Hoài Đức, Thành phố Hà Nội","path_with_type":"Xã Vân Côn, Huyện Hoài Đức, Thành phố Hà Nội","code":"09883","parent_code":"274"},"09889":{"name":"Xã La Phù","type":"xa","slug":"xa-la-phu","name_with_type":"Xã La Phù","path":"Xã La Phù, Huyện Hoài Đức, Thành phố Hà Nội","path_with_type":"Xã La Phù, Huyện Hoài Đức, Thành phố Hà Nội","code":"09889","parent_code":"274"},"09892":{"name":"Xã Đông La","type":"xa","slug":"xa-dong-la","name_with_type":"Xã Đông La","path":"Xã Đông La, Huyện Hoài Đức, Thành phố Hà Nội","path_with_type":"Xã Đông La, Huyện Hoài Đức, Thành phố Hà Nội","code":"09892","parent_code":"274"},"04939":{"name":"Xã Đông Xuân","type":"xa","slug":"xa-dong-xuan","name_with_type":"Xã Đông Xuân","path":"Xã Đông Xuân, Huyện Quốc Oai, Thành phố Hà Nội","path_with_type":"Xã Đông Xuân, Huyện Quốc Oai, Thành phố Hà Nội","code":"04939","parent_code":"275"},"09895":{"name":"Thị trấn Quốc Oai","type":"thi-tran","slug":"thi-tran-quoc-oai","name_with_type":"Thị trấn Quốc Oai","path":"Thị trấn Quốc Oai, Huyện Quốc Oai, Thành phố Hà Nội","path_with_type":"Thị trấn Quốc Oai, Huyện Quốc Oai, Thành phố Hà Nội","code":"09895","parent_code":"275"},"09898":{"name":"Xã Sài Sơn","type":"xa","slug":"xa-sai-son","name_with_type":"Xã Sài Sơn","path":"Xã Sài Sơn, Huyện Quốc Oai, Thành phố Hà Nội","path_with_type":"Xã Sài Sơn, Huyện Quốc Oai, Thành phố Hà Nội","code":"09898","parent_code":"275"},"09904":{"name":"Xã Phượng Sơn","type":"xa","slug":"xa-phuong-son","name_with_type":"Xã Phượng Sơn","path":"Xã Phượng Sơn, Huyện Quốc Oai, Thành phố Hà Nội","path_with_type":"Xã Phượng Sơn, Huyện Quốc Oai, Thành phố Hà Nội","code":"09904","parent_code":"275"},"09907":{"name":"Xã Ngọc Liệp","type":"xa","slug":"xa-ngoc-liep","name_with_type":"Xã Ngọc Liệp","path":"Xã Ngọc Liệp, Huyện Quốc Oai, Thành phố Hà Nội","path_with_type":"Xã Ngọc Liệp, Huyện Quốc Oai, Thành phố Hà Nội","code":"09907","parent_code":"275"},"09910":{"name":"Xã Ngọc Mỹ","type":"xa","slug":"xa-ngoc-my","name_with_type":"Xã Ngọc Mỹ","path":"Xã Ngọc Mỹ, Huyện Quốc Oai, Thành phố Hà Nội","path_with_type":"Xã Ngọc Mỹ, Huyện Quốc Oai, Thành phố Hà Nội","code":"09910","parent_code":"275"},"09916":{"name":"Xã Thạch Thán","type":"xa","slug":"xa-thach-than","name_with_type":"Xã Thạch Thán","path":"Xã Thạch Thán, Huyện Quốc Oai, Thành phố Hà Nội","path_with_type":"Xã Thạch Thán, Huyện Quốc Oai, Thành phố Hà Nội","code":"09916","parent_code":"275"},"09919":{"name":"Xã Đồng Quang","type":"xa","slug":"xa-dong-quang","name_with_type":"Xã Đồng Quang","path":"Xã Đồng Quang, Huyện Quốc Oai, Thành phố Hà Nội","path_with_type":"Xã Đồng Quang, Huyện Quốc Oai, Thành phố Hà Nội","code":"09919","parent_code":"275"},"09922":{"name":"Xã Phú Cát","type":"xa","slug":"xa-phu-cat","name_with_type":"Xã Phú Cát","path":"Xã Phú Cát, Huyện Quốc Oai, Thành phố Hà Nội","path_with_type":"Xã Phú Cát, Huyện Quốc Oai, Thành phố Hà Nội","code":"09922","parent_code":"275"},"09925":{"name":"Xã Tuyết Nghĩa","type":"xa","slug":"xa-tuyet-nghia","name_with_type":"Xã Tuyết Nghĩa","path":"Xã Tuyết Nghĩa, Huyện Quốc Oai, Thành phố Hà Nội","path_with_type":"Xã Tuyết Nghĩa, Huyện Quốc Oai, Thành phố Hà Nội","code":"09925","parent_code":"275"},"09928":{"name":"Xã Liệp Nghĩa","type":"xa","slug":"xa-liep-nghia","name_with_type":"Xã Liệp Nghĩa","path":"Xã Liệp Nghĩa, Huyện Quốc Oai, Thành phố Hà Nội","path_with_type":"Xã Liệp Nghĩa, Huyện Quốc Oai, Thành phố Hà Nội","code":"09928","parent_code":"275"},"09931":{"name":"Xã Cộng Hòa","type":"xa","slug":"xa-cong-hoa","name_with_type":"Xã Cộng Hòa","path":"Xã Cộng Hòa, Huyện Quốc Oai, Thành phố Hà Nội","path_with_type":"Xã Cộng Hòa, Huyện Quốc Oai, Thành phố Hà Nội","code":"09931","parent_code":"275"},"09934":{"name":"Xã Hưng Đạo","type":"xa","slug":"xa-hung-dao","name_with_type":"Xã Hưng Đạo","path":"Xã Hưng Đạo, Huyện Quốc Oai, Thành phố Hà Nội","path_with_type":"Xã Hưng Đạo, Huyện Quốc Oai, Thành phố Hà Nội","code":"09934","parent_code":"275"},"09940":{"name":"Xã Phú Mãn","type":"xa","slug":"xa-phu-man","name_with_type":"Xã Phú Mãn","path":"Xã Phú Mãn, Huyện Quốc Oai, Thành phố Hà Nội","path_with_type":"Xã Phú Mãn, Huyện Quốc Oai, Thành phố Hà Nội","code":"09940","parent_code":"275"},"09943":{"name":"Xã Cấn Hữu","type":"xa","slug":"xa-can-huu","name_with_type":"Xã Cấn Hữu","path":"Xã Cấn Hữu, Huyện Quốc Oai, Thành phố Hà Nội","path_with_type":"Xã Cấn Hữu, Huyện Quốc Oai, Thành phố Hà Nội","code":"09943","parent_code":"275"},"09949":{"name":"Xã Hòa Thạch","type":"xa","slug":"xa-hoa-thach","name_with_type":"Xã Hòa Thạch","path":"Xã Hòa Thạch, Huyện Quốc Oai, Thành phố Hà Nội","path_with_type":"Xã Hòa Thạch, Huyện Quốc Oai, Thành phố Hà Nội","code":"09949","parent_code":"275"},"09952":{"name":"Xã Đông Yên","type":"xa","slug":"xa-dong-yen","name_with_type":"Xã Đông Yên","path":"Xã Đông Yên, Huyện Quốc Oai, Thành phố Hà Nội","path_with_type":"Xã Đông Yên, Huyện Quốc Oai, Thành phố Hà Nội","code":"09952","parent_code":"275"},"04927":{"name":"Xã Yên Trung","type":"xa","slug":"xa-yen-trung","name_with_type":"Xã Yên Trung","path":"Xã Yên Trung, Huyện Thạch Thất, Thành phố Hà Nội","path_with_type":"Xã Yên Trung, Huyện Thạch Thất, Thành phố Hà Nội","code":"04927","parent_code":"276"},"04930":{"name":"Xã Yên Bình","type":"xa","slug":"xa-yen-binh","name_with_type":"Xã Yên Bình","path":"Xã Yên Bình, Huyện Thạch Thất, Thành phố Hà Nội","path_with_type":"Xã Yên Bình, Huyện Thạch Thất, Thành phố Hà Nội","code":"04930","parent_code":"276"},"04936":{"name":"Xã Tiến Xuân","type":"xa","slug":"xa-tien-xuan","name_with_type":"Xã Tiến Xuân","path":"Xã Tiến Xuân, Huyện Thạch Thất, Thành phố Hà Nội","path_with_type":"Xã Tiến Xuân, Huyện Thạch Thất, Thành phố Hà Nội","code":"04936","parent_code":"276"},"09955":{"name":"Thị trấn Liên Quan","type":"thi-tran","slug":"thi-tran-lien-quan","name_with_type":"Thị trấn Liên Quan","path":"Thị trấn Liên Quan, Huyện Thạch Thất, Thành phố Hà Nội","path_with_type":"Thị trấn Liên Quan, Huyện Thạch Thất, Thành phố Hà Nội","code":"09955","parent_code":"276"},"09958":{"name":"Xã Đại Đồng","type":"xa","slug":"xa-dai-dong","name_with_type":"Xã Đại Đồng","path":"Xã Đại Đồng, Huyện Thạch Thất, Thành phố Hà Nội","path_with_type":"Xã Đại Đồng, Huyện Thạch Thất, Thành phố Hà Nội","code":"09958","parent_code":"276"},"09961":{"name":"Xã Cẩm Yên","type":"xa","slug":"xa-cam-yen","name_with_type":"Xã Cẩm Yên","path":"Xã Cẩm Yên, Huyện Thạch Thất, Thành phố Hà Nội","path_with_type":"Xã Cẩm Yên, Huyện Thạch Thất, Thành phố Hà Nội","code":"09961","parent_code":"276"},"09964":{"name":"Xã Lại Thượng","type":"xa","slug":"xa-lai-thuong","name_with_type":"Xã Lại Thượng","path":"Xã Lại Thượng, Huyện Thạch Thất, Thành phố Hà Nội","path_with_type":"Xã Lại Thượng, Huyện Thạch Thất, Thành phố Hà Nội","code":"09964","parent_code":"276"},"09967":{"name":"Xã Phú Kim","type":"xa","slug":"xa-phu-kim","name_with_type":"Xã Phú Kim","path":"Xã Phú Kim, Huyện Thạch Thất, Thành phố Hà Nội","path_with_type":"Xã Phú Kim, Huyện Thạch Thất, Thành phố Hà Nội","code":"09967","parent_code":"276"},"09970":{"name":"Xã Hương Ngải","type":"xa","slug":"xa-huong-ngai","name_with_type":"Xã Hương Ngải","path":"Xã Hương Ngải, Huyện Thạch Thất, Thành phố Hà Nội","path_with_type":"Xã Hương Ngải, Huyện Thạch Thất, Thành phố Hà Nội","code":"09970","parent_code":"276"},"09973":{"name":"Xã Lam Sơn","type":"xa","slug":"xa-lam-son","name_with_type":"Xã Lam Sơn","path":"Xã Lam Sơn, Huyện Thạch Thất, Thành phố Hà Nội","path_with_type":"Xã Lam Sơn, Huyện Thạch Thất, Thành phố Hà Nội","code":"09973","parent_code":"276"},"09976":{"name":"Xã Kim Quan","type":"xa","slug":"xa-kim-quan","name_with_type":"Xã Kim Quan","path":"Xã Kim Quan, Huyện Thạch Thất, Thành phố Hà Nội","path_with_type":"Xã Kim Quan, Huyện Thạch Thất, Thành phố Hà Nội","code":"09976","parent_code":"276"},"09982":{"name":"Xã Bình Yên","type":"xa","slug":"xa-binh-yen","name_with_type":"Xã Bình Yên","path":"Xã Bình Yên, Huyện Thạch Thất, Thành phố Hà Nội","path_with_type":"Xã Bình Yên, Huyện Thạch Thất, Thành phố Hà Nội","code":"09982","parent_code":"276"},"09988":{"name":"Xã Thạch Hoà","type":"xa","slug":"xa-thach-hoa","name_with_type":"Xã Thạch Hoà","path":"Xã Thạch Hoà, Huyện Thạch Thất, Thành phố Hà Nội","path_with_type":"Xã Thạch Hoà, Huyện Thạch Thất, Thành phố Hà Nội","code":"09988","parent_code":"276"},"09991":{"name":"Xã Cần Kiệm","type":"xa","slug":"xa-can-kiem","name_with_type":"Xã Cần Kiệm","path":"Xã Cần Kiệm, Huyện Thạch Thất, Thành phố Hà Nội","path_with_type":"Xã Cần Kiệm, Huyện Thạch Thất, Thành phố Hà Nội","code":"09991","parent_code":"276"},"09997":{"name":"Xã Phùng Xá","type":"xa","slug":"xa-phung-xa","name_with_type":"Xã Phùng Xá","path":"Xã Phùng Xá, Huyện Thạch Thất, Thành phố Hà Nội","path_with_type":"Xã Phùng Xá, Huyện Thạch Thất, Thành phố Hà Nội","code":"09997","parent_code":"276"},"00688":{"name":"Phường Quang Trung","type":"phuong","slug":"phuong-quang-trung","name_with_type":"Phường Quang Trung","path":"Phường Quang Trung, Thành phố Hà Giang, Tỉnh Hà Giang","path_with_type":"Phường Quang Trung, Thành phố Hà Giang, Tỉnh Hà Giang","code":"00688","parent_code":"024"},"00691":{"name":"Phường Trần Phú","type":"phuong","slug":"phuong-tran-phu","name_with_type":"Phường Trần Phú","path":"Phường Trần Phú, Thành phố Hà Giang, Tỉnh Hà Giang","path_with_type":"Phường Trần Phú, Thành phố Hà Giang, Tỉnh Hà Giang","code":"00691","parent_code":"024"},"00692":{"name":"Phường Ngọc Hà","type":"phuong","slug":"phuong-ngoc-ha","name_with_type":"Phường Ngọc Hà","path":"Phường Ngọc Hà, Thành phố Hà Giang, Tỉnh Hà Giang","path_with_type":"Phường Ngọc Hà, Thành phố Hà Giang, Tỉnh Hà Giang","code":"00692","parent_code":"024"},"00694":{"name":"Phường Nguyễn Trãi","type":"phuong","slug":"phuong-nguyen-trai","name_with_type":"Phường Nguyễn Trãi","path":"Phường Nguyễn Trãi, Thành phố Hà Giang, Tỉnh Hà Giang","path_with_type":"Phường Nguyễn Trãi, Thành phố Hà Giang, Tỉnh Hà Giang","code":"00694","parent_code":"024"},"00697":{"name":"Phường Minh Khai","type":"phuong","slug":"phuong-minh-khai","name_with_type":"Phường Minh Khai","path":"Phường Minh Khai, Thành phố Hà Giang, Tỉnh Hà Giang","path_with_type":"Phường Minh Khai, Thành phố Hà Giang, Tỉnh Hà Giang","code":"00697","parent_code":"024"},"00700":{"name":"Xã Ngọc Đường","type":"xa","slug":"xa-ngoc-duong","name_with_type":"Xã Ngọc Đường","path":"Xã Ngọc Đường, Thành phố Hà Giang, Tỉnh Hà Giang","path_with_type":"Xã Ngọc Đường, Thành phố Hà Giang, Tỉnh Hà Giang","code":"00700","parent_code":"024"},"00946":{"name":"Xã Phương Độ","type":"xa","slug":"xa-phuong-do","name_with_type":"Xã Phương Độ","path":"Xã Phương Độ, Thành phố Hà Giang, Tỉnh Hà Giang","path_with_type":"Xã Phương Độ, Thành phố Hà Giang, Tỉnh Hà Giang","code":"00946","parent_code":"024"},"00949":{"name":"Xã Phương Thiện","type":"xa","slug":"xa-phuong-thien","name_with_type":"Xã Phương Thiện","path":"Xã Phương Thiện, Thành phố Hà Giang, Tỉnh Hà Giang","path_with_type":"Xã Phương Thiện, Thành phố Hà Giang, Tỉnh Hà Giang","code":"00949","parent_code":"024"},"00712":{"name":"Thị trấn Phó Bảng","type":"thi-tran","slug":"thi-tran-pho-bang","name_with_type":"Thị trấn Phó Bảng","path":"Thị trấn Phó Bảng, Huyện Đồng Văn, Tỉnh Hà Giang","path_with_type":"Thị trấn Phó Bảng, Huyện Đồng Văn, Tỉnh Hà Giang","code":"00712","parent_code":"026"},"00715":{"name":"Xã Lũng Cú","type":"xa","slug":"xa-lung-cu","name_with_type":"Xã Lũng Cú","path":"Xã Lũng Cú, Huyện Đồng Văn, Tỉnh Hà Giang","path_with_type":"Xã Lũng Cú, Huyện Đồng Văn, Tỉnh Hà Giang","code":"00715","parent_code":"026"},"00718":{"name":"Xã Má Lé","type":"xa","slug":"xa-ma-le","name_with_type":"Xã Má Lé","path":"Xã Má Lé, Huyện Đồng Văn, Tỉnh Hà Giang","path_with_type":"Xã Má Lé, Huyện Đồng Văn, Tỉnh Hà Giang","code":"00718","parent_code":"026"},"00721":{"name":"Thị trấn Đồng Văn","type":"thi-tran","slug":"thi-tran-dong-van","name_with_type":"Thị trấn Đồng Văn","path":"Thị trấn Đồng Văn, Huyện Đồng Văn, Tỉnh Hà Giang","path_with_type":"Thị trấn Đồng Văn, Huyện Đồng Văn, Tỉnh Hà Giang","code":"00721","parent_code":"026"},"00724":{"name":"Xã Lũng Táo","type":"xa","slug":"xa-lung-tao","name_with_type":"Xã Lũng Táo","path":"Xã Lũng Táo, Huyện Đồng Văn, Tỉnh Hà Giang","path_with_type":"Xã Lũng Táo, Huyện Đồng Văn, Tỉnh Hà Giang","code":"00724","parent_code":"026"},"00727":{"name":"Xã Phố Là","type":"xa","slug":"xa-pho-la","name_with_type":"Xã Phố Là","path":"Xã Phố Là, Huyện Đồng Văn, Tỉnh Hà Giang","path_with_type":"Xã Phố Là, Huyện Đồng Văn, Tỉnh Hà Giang","code":"00727","parent_code":"026"},"00730":{"name":"Xã Thài Phìn Tủng","type":"xa","slug":"xa-thai-phin-tung","name_with_type":"Xã Thài Phìn Tủng","path":"Xã Thài Phìn Tủng, Huyện Đồng Văn, Tỉnh Hà Giang","path_with_type":"Xã Thài Phìn Tủng, Huyện Đồng Văn, Tỉnh Hà Giang","code":"00730","parent_code":"026"},"00733":{"name":"Xã Sủng Là","type":"xa","slug":"xa-sung-la","name_with_type":"Xã Sủng Là","path":"Xã Sủng Là, Huyện Đồng Văn, Tỉnh Hà Giang","path_with_type":"Xã Sủng Là, Huyện Đồng Văn, Tỉnh Hà Giang","code":"00733","parent_code":"026"},"00736":{"name":"Xã Xà Phìn","type":"xa","slug":"xa-xa-phin","name_with_type":"Xã Xà Phìn","path":"Xã Xà Phìn, Huyện Đồng Văn, Tỉnh Hà Giang","path_with_type":"Xã Xà Phìn, Huyện Đồng Văn, Tỉnh Hà Giang","code":"00736","parent_code":"026"},"00739":{"name":"Xã Tả Phìn","type":"xa","slug":"xa-ta-phin","name_with_type":"Xã Tả Phìn","path":"Xã Tả Phìn, Huyện Đồng Văn, Tỉnh Hà Giang","path_with_type":"Xã Tả Phìn, Huyện Đồng Văn, Tỉnh Hà Giang","code":"00739","parent_code":"026"},"00742":{"name":"Xã Tả Lủng","type":"xa","slug":"xa-ta-lung","name_with_type":"Xã Tả Lủng","path":"Xã Tả Lủng, Huyện Đồng Văn, Tỉnh Hà Giang","path_with_type":"Xã Tả Lủng, Huyện Đồng Văn, Tỉnh Hà Giang","code":"00742","parent_code":"026"},"00745":{"name":"Xã Phố Cáo","type":"xa","slug":"xa-pho-cao","name_with_type":"Xã Phố Cáo","path":"Xã Phố Cáo, Huyện Đồng Văn, Tỉnh Hà Giang","path_with_type":"Xã Phố Cáo, Huyện Đồng Văn, Tỉnh Hà Giang","code":"00745","parent_code":"026"},"00748":{"name":"Xã Sính Lủng","type":"xa","slug":"xa-sinh-lung","name_with_type":"Xã Sính Lủng","path":"Xã Sính Lủng, Huyện Đồng Văn, Tỉnh Hà Giang","path_with_type":"Xã Sính Lủng, Huyện Đồng Văn, Tỉnh Hà Giang","code":"00748","parent_code":"026"},"00751":{"name":"Xã Sảng Tủng","type":"xa","slug":"xa-sang-tung","name_with_type":"Xã Sảng Tủng","path":"Xã Sảng Tủng, Huyện Đồng Văn, Tỉnh Hà Giang","path_with_type":"Xã Sảng Tủng, Huyện Đồng Văn, Tỉnh Hà Giang","code":"00751","parent_code":"026"},"00754":{"name":"Xã Lũng Thầu","type":"xa","slug":"xa-lung-thau","name_with_type":"Xã Lũng Thầu","path":"Xã Lũng Thầu, Huyện Đồng Văn, Tỉnh Hà Giang","path_with_type":"Xã Lũng Thầu, Huyện Đồng Văn, Tỉnh Hà Giang","code":"00754","parent_code":"026"},"00757":{"name":"Xã Hố Quáng Phìn","type":"xa","slug":"xa-ho-quang-phin","name_with_type":"Xã Hố Quáng Phìn","path":"Xã Hố Quáng Phìn, Huyện Đồng Văn, Tỉnh Hà Giang","path_with_type":"Xã Hố Quáng Phìn, Huyện Đồng Văn, Tỉnh Hà Giang","code":"00757","parent_code":"026"},"00760":{"name":"Xã Vần Chải","type":"xa","slug":"xa-van-chai","name_with_type":"Xã Vần Chải","path":"Xã Vần Chải, Huyện Đồng Văn, Tỉnh Hà Giang","path_with_type":"Xã Vần Chải, Huyện Đồng Văn, Tỉnh Hà Giang","code":"00760","parent_code":"026"},"00763":{"name":"Xã Lũng Phìn","type":"xa","slug":"xa-lung-phin","name_with_type":"Xã Lũng Phìn","path":"Xã Lũng Phìn, Huyện Đồng Văn, Tỉnh Hà Giang","path_with_type":"Xã Lũng Phìn, Huyện Đồng Văn, Tỉnh Hà Giang","code":"00763","parent_code":"026"},"00766":{"name":"Xã Sủng Trái","type":"xa","slug":"xa-sung-trai","name_with_type":"Xã Sủng Trái","path":"Xã Sủng Trái, Huyện Đồng Văn, Tỉnh Hà Giang","path_with_type":"Xã Sủng Trái, Huyện Đồng Văn, Tỉnh Hà Giang","code":"00766","parent_code":"026"},"00769":{"name":"Thị trấn Mèo Vạc","type":"thi-tran","slug":"thi-tran-meo-vac","name_with_type":"Thị trấn Mèo Vạc","path":"Thị trấn Mèo Vạc, Huyện Mèo Vạc, Tỉnh Hà Giang","path_with_type":"Thị trấn Mèo Vạc, Huyện Mèo Vạc, Tỉnh Hà Giang","code":"00769","parent_code":"027"},"00772":{"name":"Xã Thượng Phùng","type":"xa","slug":"xa-thuong-phung","name_with_type":"Xã Thượng Phùng","path":"Xã Thượng Phùng, Huyện Mèo Vạc, Tỉnh Hà Giang","path_with_type":"Xã Thượng Phùng, Huyện Mèo Vạc, Tỉnh Hà Giang","code":"00772","parent_code":"027"},"00775":{"name":"Xã Pải Lủng","type":"xa","slug":"xa-pai-lung","name_with_type":"Xã Pải Lủng","path":"Xã Pải Lủng, Huyện Mèo Vạc, Tỉnh Hà Giang","path_with_type":"Xã Pải Lủng, Huyện Mèo Vạc, Tỉnh Hà Giang","code":"00775","parent_code":"027"},"00778":{"name":"Xã Xín Cái","type":"xa","slug":"xa-xin-cai","name_with_type":"Xã Xín Cái","path":"Xã Xín Cái, Huyện Mèo Vạc, Tỉnh Hà Giang","path_with_type":"Xã Xín Cái, Huyện Mèo Vạc, Tỉnh Hà Giang","code":"00778","parent_code":"027"},"00781":{"name":"Xã Pả Vi","type":"xa","slug":"xa-pa-vi","name_with_type":"Xã Pả Vi","path":"Xã Pả Vi, Huyện Mèo Vạc, Tỉnh Hà Giang","path_with_type":"Xã Pả Vi, Huyện Mèo Vạc, Tỉnh Hà Giang","code":"00781","parent_code":"027"},"00784":{"name":"Xã Giàng Chu Phìn","type":"xa","slug":"xa-giang-chu-phin","name_with_type":"Xã Giàng Chu Phìn","path":"Xã Giàng Chu Phìn, Huyện Mèo Vạc, Tỉnh Hà Giang","path_with_type":"Xã Giàng Chu Phìn, Huyện Mèo Vạc, Tỉnh Hà Giang","code":"00784","parent_code":"027"},"00787":{"name":"Xã Sủng Trà","type":"xa","slug":"xa-sung-tra","name_with_type":"Xã Sủng Trà","path":"Xã Sủng Trà, Huyện Mèo Vạc, Tỉnh Hà Giang","path_with_type":"Xã Sủng Trà, Huyện Mèo Vạc, Tỉnh Hà Giang","code":"00787","parent_code":"027"},"00790":{"name":"Xã Sủng Máng","type":"xa","slug":"xa-sung-mang","name_with_type":"Xã Sủng Máng","path":"Xã Sủng Máng, Huyện Mèo Vạc, Tỉnh Hà Giang","path_with_type":"Xã Sủng Máng, Huyện Mèo Vạc, Tỉnh Hà Giang","code":"00790","parent_code":"027"},"00793":{"name":"Xã Sơn Vĩ","type":"xa","slug":"xa-son-vi","name_with_type":"Xã Sơn Vĩ","path":"Xã Sơn Vĩ, Huyện Mèo Vạc, Tỉnh Hà Giang","path_with_type":"Xã Sơn Vĩ, Huyện Mèo Vạc, Tỉnh Hà Giang","code":"00793","parent_code":"027"},"00796":{"name":"Xã Tả Lủng","type":"xa","slug":"xa-ta-lung","name_with_type":"Xã Tả Lủng","path":"Xã Tả Lủng, Huyện Mèo Vạc, Tỉnh Hà Giang","path_with_type":"Xã Tả Lủng, Huyện Mèo Vạc, Tỉnh Hà Giang","code":"00796","parent_code":"027"},"00799":{"name":"Xã Cán Chu Phìn","type":"xa","slug":"xa-can-chu-phin","name_with_type":"Xã Cán Chu Phìn","path":"Xã Cán Chu Phìn, Huyện Mèo Vạc, Tỉnh Hà Giang","path_with_type":"Xã Cán Chu Phìn, Huyện Mèo Vạc, Tỉnh Hà Giang","code":"00799","parent_code":"027"},"00802":{"name":"Xã Lũng Pù","type":"xa","slug":"xa-lung-pu","name_with_type":"Xã Lũng Pù","path":"Xã Lũng Pù, Huyện Mèo Vạc, Tỉnh Hà Giang","path_with_type":"Xã Lũng Pù, Huyện Mèo Vạc, Tỉnh Hà Giang","code":"00802","parent_code":"027"},"00805":{"name":"Xã Lũng Chinh","type":"xa","slug":"xa-lung-chinh","name_with_type":"Xã Lũng Chinh","path":"Xã Lũng Chinh, Huyện Mèo Vạc, Tỉnh Hà Giang","path_with_type":"Xã Lũng Chinh, Huyện Mèo Vạc, Tỉnh Hà Giang","code":"00805","parent_code":"027"},"00808":{"name":"Xã Tát Ngà","type":"xa","slug":"xa-tat-nga","name_with_type":"Xã Tát Ngà","path":"Xã Tát Ngà, Huyện Mèo Vạc, Tỉnh Hà Giang","path_with_type":"Xã Tát Ngà, Huyện Mèo Vạc, Tỉnh Hà Giang","code":"00808","parent_code":"027"},"00811":{"name":"Xã Nậm Ban","type":"xa","slug":"xa-nam-ban","name_with_type":"Xã Nậm Ban","path":"Xã Nậm Ban, Huyện Mèo Vạc, Tỉnh Hà Giang","path_with_type":"Xã Nậm Ban, Huyện Mèo Vạc, Tỉnh Hà Giang","code":"00811","parent_code":"027"},"00814":{"name":"Xã Khâu Vai","type":"xa","slug":"xa-khau-vai","name_with_type":"Xã Khâu Vai","path":"Xã Khâu Vai, Huyện Mèo Vạc, Tỉnh Hà Giang","path_with_type":"Xã Khâu Vai, Huyện Mèo Vạc, Tỉnh Hà Giang","code":"00814","parent_code":"027"},"00815":{"name":"Xã Niêm Tòng","type":"xa","slug":"xa-niem-tong","name_with_type":"Xã Niêm Tòng","path":"Xã Niêm Tòng, Huyện Mèo Vạc, Tỉnh Hà Giang","path_with_type":"Xã Niêm Tòng, Huyện Mèo Vạc, Tỉnh Hà Giang","code":"00815","parent_code":"027"},"00817":{"name":"Xã Niêm Sơn","type":"xa","slug":"xa-niem-son","name_with_type":"Xã Niêm Sơn","path":"Xã Niêm Sơn, Huyện Mèo Vạc, Tỉnh Hà Giang","path_with_type":"Xã Niêm Sơn, Huyện Mèo Vạc, Tỉnh Hà Giang","code":"00817","parent_code":"027"},"00820":{"name":"Thị trấn Yên Minh","type":"thi-tran","slug":"thi-tran-yen-minh","name_with_type":"Thị trấn Yên Minh","path":"Thị trấn Yên Minh, Huyện Yên Minh, Tỉnh Hà Giang","path_with_type":"Thị trấn Yên Minh, Huyện Yên Minh, Tỉnh Hà Giang","code":"00820","parent_code":"028"},"00823":{"name":"Xã Thắng Mố","type":"xa","slug":"xa-thang-mo","name_with_type":"Xã Thắng Mố","path":"Xã Thắng Mố, Huyện Yên Minh, Tỉnh Hà Giang","path_with_type":"Xã Thắng Mố, Huyện Yên Minh, Tỉnh Hà Giang","code":"00823","parent_code":"028"},"00826":{"name":"Xã Phú Lũng","type":"xa","slug":"xa-phu-lung","name_with_type":"Xã Phú Lũng","path":"Xã Phú Lũng, Huyện Yên Minh, Tỉnh Hà Giang","path_with_type":"Xã Phú Lũng, Huyện Yên Minh, Tỉnh Hà Giang","code":"00826","parent_code":"028"},"00829":{"name":"Xã Sủng Tráng","type":"xa","slug":"xa-sung-trang","name_with_type":"Xã Sủng Tráng","path":"Xã Sủng Tráng, Huyện Yên Minh, Tỉnh Hà Giang","path_with_type":"Xã Sủng Tráng, Huyện Yên Minh, Tỉnh Hà Giang","code":"00829","parent_code":"028"},"00832":{"name":"Xã Bạch Đích","type":"xa","slug":"xa-bach-dich","name_with_type":"Xã Bạch Đích","path":"Xã Bạch Đích, Huyện Yên Minh, Tỉnh Hà Giang","path_with_type":"Xã Bạch Đích, Huyện Yên Minh, Tỉnh Hà Giang","code":"00832","parent_code":"028"},"00835":{"name":"Xã Na Khê","type":"xa","slug":"xa-na-khe","name_with_type":"Xã Na Khê","path":"Xã Na Khê, Huyện Yên Minh, Tỉnh Hà Giang","path_with_type":"Xã Na Khê, Huyện Yên Minh, Tỉnh Hà Giang","code":"00835","parent_code":"028"},"00838":{"name":"Xã Sủng Thài","type":"xa","slug":"xa-sung-thai","name_with_type":"Xã Sủng Thài","path":"Xã Sủng Thài, Huyện Yên Minh, Tỉnh Hà Giang","path_with_type":"Xã Sủng Thài, Huyện Yên Minh, Tỉnh Hà Giang","code":"00838","parent_code":"028"},"00841":{"name":"Xã Hữu Vinh","type":"xa","slug":"xa-huu-vinh","name_with_type":"Xã Hữu Vinh","path":"Xã Hữu Vinh, Huyện Yên Minh, Tỉnh Hà Giang","path_with_type":"Xã Hữu Vinh, Huyện Yên Minh, Tỉnh Hà Giang","code":"00841","parent_code":"028"},"00844":{"name":"Xã Lao Và Chải","type":"xa","slug":"xa-lao-va-chai","name_with_type":"Xã Lao Và Chải","path":"Xã Lao Và Chải, Huyện Yên Minh, Tỉnh Hà Giang","path_with_type":"Xã Lao Và Chải, Huyện Yên Minh, Tỉnh Hà Giang","code":"00844","parent_code":"028"},"00847":{"name":"Xã Mậu Duệ","type":"xa","slug":"xa-mau-due","name_with_type":"Xã Mậu Duệ","path":"Xã Mậu Duệ, Huyện Yên Minh, Tỉnh Hà Giang","path_with_type":"Xã Mậu Duệ, Huyện Yên Minh, Tỉnh Hà Giang","code":"00847","parent_code":"028"},"00850":{"name":"Xã Đông Minh","type":"xa","slug":"xa-dong-minh","name_with_type":"Xã Đông Minh","path":"Xã Đông Minh, Huyện Yên Minh, Tỉnh Hà Giang","path_with_type":"Xã Đông Minh, Huyện Yên Minh, Tỉnh Hà Giang","code":"00850","parent_code":"028"},"00853":{"name":"Xã Mậu Long","type":"xa","slug":"xa-mau-long","name_with_type":"Xã Mậu Long","path":"Xã Mậu Long, Huyện Yên Minh, Tỉnh Hà Giang","path_with_type":"Xã Mậu Long, Huyện Yên Minh, Tỉnh Hà Giang","code":"00853","parent_code":"028"},"00856":{"name":"Xã Ngam La","type":"xa","slug":"xa-ngam-la","name_with_type":"Xã Ngam La","path":"Xã Ngam La, Huyện Yên Minh, Tỉnh Hà Giang","path_with_type":"Xã Ngam La, Huyện Yên Minh, Tỉnh Hà Giang","code":"00856","parent_code":"028"},"00859":{"name":"Xã Ngọc Long","type":"xa","slug":"xa-ngoc-long","name_with_type":"Xã Ngọc Long","path":"Xã Ngọc Long, Huyện Yên Minh, Tỉnh Hà Giang","path_with_type":"Xã Ngọc Long, Huyện Yên Minh, Tỉnh Hà Giang","code":"00859","parent_code":"028"},"00862":{"name":"Xã Đường Thượng","type":"xa","slug":"xa-duong-thuong","name_with_type":"Xã Đường Thượng","path":"Xã Đường Thượng, Huyện Yên Minh, Tỉnh Hà Giang","path_with_type":"Xã Đường Thượng, Huyện Yên Minh, Tỉnh Hà Giang","code":"00862","parent_code":"028"},"00865":{"name":"Xã Lũng Hồ","type":"xa","slug":"xa-lung-ho","name_with_type":"Xã Lũng Hồ","path":"Xã Lũng Hồ, Huyện Yên Minh, Tỉnh Hà Giang","path_with_type":"Xã Lũng Hồ, Huyện Yên Minh, Tỉnh Hà Giang","code":"00865","parent_code":"028"},"00868":{"name":"Xã Du Tiến","type":"xa","slug":"xa-du-tien","name_with_type":"Xã Du Tiến","path":"Xã Du Tiến, Huyện Yên Minh, Tỉnh Hà Giang","path_with_type":"Xã Du Tiến, Huyện Yên Minh, Tỉnh Hà Giang","code":"00868","parent_code":"028"},"00871":{"name":"Xã Du Già","type":"xa","slug":"xa-du-gia","name_with_type":"Xã Du Già","path":"Xã Du Già, Huyện Yên Minh, Tỉnh Hà Giang","path_with_type":"Xã Du Già, Huyện Yên Minh, Tỉnh Hà Giang","code":"00871","parent_code":"028"},"00874":{"name":"Thị trấn Tam Sơn","type":"thi-tran","slug":"thi-tran-tam-son","name_with_type":"Thị trấn Tam Sơn","path":"Thị trấn Tam Sơn, Huyện Quản Bạ, Tỉnh Hà Giang","path_with_type":"Thị trấn Tam Sơn, Huyện Quản Bạ, Tỉnh Hà Giang","code":"00874","parent_code":"029"},"00877":{"name":"Xã Bát Đại Sơn","type":"xa","slug":"xa-bat-dai-son","name_with_type":"Xã Bát Đại Sơn","path":"Xã Bát Đại Sơn, Huyện Quản Bạ, Tỉnh Hà Giang","path_with_type":"Xã Bát Đại Sơn, Huyện Quản Bạ, Tỉnh Hà Giang","code":"00877","parent_code":"029"},"00880":{"name":"Xã Nghĩa Thuận","type":"xa","slug":"xa-nghia-thuan","name_with_type":"Xã Nghĩa Thuận","path":"Xã Nghĩa Thuận, Huyện Quản Bạ, Tỉnh Hà Giang","path_with_type":"Xã Nghĩa Thuận, Huyện Quản Bạ, Tỉnh Hà Giang","code":"00880","parent_code":"029"},"00883":{"name":"Xã Cán Tỷ","type":"xa","slug":"xa-can-ty","name_with_type":"Xã Cán Tỷ","path":"Xã Cán Tỷ, Huyện Quản Bạ, Tỉnh Hà Giang","path_with_type":"Xã Cán Tỷ, Huyện Quản Bạ, Tỉnh Hà Giang","code":"00883","parent_code":"029"},"00886":{"name":"Xã Cao Mã Pờ","type":"xa","slug":"xa-cao-ma-po","name_with_type":"Xã Cao Mã Pờ","path":"Xã Cao Mã Pờ, Huyện Quản Bạ, Tỉnh Hà Giang","path_with_type":"Xã Cao Mã Pờ, Huyện Quản Bạ, Tỉnh Hà Giang","code":"00886","parent_code":"029"},"00889":{"name":"Xã Thanh Vân","type":"xa","slug":"xa-thanh-van","name_with_type":"Xã Thanh Vân","path":"Xã Thanh Vân, Huyện Quản Bạ, Tỉnh Hà Giang","path_with_type":"Xã Thanh Vân, Huyện Quản Bạ, Tỉnh Hà Giang","code":"00889","parent_code":"029"},"00892":{"name":"Xã Tùng Vài","type":"xa","slug":"xa-tung-vai","name_with_type":"Xã Tùng Vài","path":"Xã Tùng Vài, Huyện Quản Bạ, Tỉnh Hà Giang","path_with_type":"Xã Tùng Vài, Huyện Quản Bạ, Tỉnh Hà Giang","code":"00892","parent_code":"029"},"00895":{"name":"Xã Đông Hà","type":"xa","slug":"xa-dong-ha","name_with_type":"Xã Đông Hà","path":"Xã Đông Hà, Huyện Quản Bạ, Tỉnh Hà Giang","path_with_type":"Xã Đông Hà, Huyện Quản Bạ, Tỉnh Hà Giang","code":"00895","parent_code":"029"},"00898":{"name":"Xã Quản Bạ","type":"xa","slug":"xa-quan-ba","name_with_type":"Xã Quản Bạ","path":"Xã Quản Bạ, Huyện Quản Bạ, Tỉnh Hà Giang","path_with_type":"Xã Quản Bạ, Huyện Quản Bạ, Tỉnh Hà Giang","code":"00898","parent_code":"029"},"00901":{"name":"Xã Lùng Tám","type":"xa","slug":"xa-lung-tam","name_with_type":"Xã Lùng Tám","path":"Xã Lùng Tám, Huyện Quản Bạ, Tỉnh Hà Giang","path_with_type":"Xã Lùng Tám, Huyện Quản Bạ, Tỉnh Hà Giang","code":"00901","parent_code":"029"},"00904":{"name":"Xã Quyết Tiến","type":"xa","slug":"xa-quyet-tien","name_with_type":"Xã Quyết Tiến","path":"Xã Quyết Tiến, Huyện Quản Bạ, Tỉnh Hà Giang","path_with_type":"Xã Quyết Tiến, Huyện Quản Bạ, Tỉnh Hà Giang","code":"00904","parent_code":"029"},"00907":{"name":"Xã Tả Ván","type":"xa","slug":"xa-ta-van","name_with_type":"Xã Tả Ván","path":"Xã Tả Ván, Huyện Quản Bạ, Tỉnh Hà Giang","path_with_type":"Xã Tả Ván, Huyện Quản Bạ, Tỉnh Hà Giang","code":"00907","parent_code":"029"},"00910":{"name":"Xã Thái An","type":"xa","slug":"xa-thai-an","name_with_type":"Xã Thái An","path":"Xã Thái An, Huyện Quản Bạ, Tỉnh Hà Giang","path_with_type":"Xã Thái An, Huyện Quản Bạ, Tỉnh Hà Giang","code":"00910","parent_code":"029"},"00703":{"name":"Xã Kim Thạch","type":"xa","slug":"xa-kim-thach","name_with_type":"Xã Kim Thạch","path":"Xã Kim Thạch, Huyện Vị Xuyên, Tỉnh Hà Giang","path_with_type":"Xã Kim Thạch, Huyện Vị Xuyên, Tỉnh Hà Giang","code":"00703","parent_code":"030"},"00706":{"name":"Xã Phú Linh","type":"xa","slug":"xa-phu-linh","name_with_type":"Xã Phú Linh","path":"Xã Phú Linh, Huyện Vị Xuyên, Tỉnh Hà Giang","path_with_type":"Xã Phú Linh, Huyện Vị Xuyên, Tỉnh Hà Giang","code":"00706","parent_code":"030"},"00709":{"name":"Xã Kim Linh","type":"xa","slug":"xa-kim-linh","name_with_type":"Xã Kim Linh","path":"Xã Kim Linh, Huyện Vị Xuyên, Tỉnh Hà Giang","path_with_type":"Xã Kim Linh, Huyện Vị Xuyên, Tỉnh Hà Giang","code":"00709","parent_code":"030"},"00913":{"name":"Thị trấn Vị Xuyên","type":"thi-tran","slug":"thi-tran-vi-xuyen","name_with_type":"Thị trấn Vị Xuyên","path":"Thị trấn Vị Xuyên, Huyện Vị Xuyên, Tỉnh Hà Giang","path_with_type":"Thị trấn Vị Xuyên, Huyện Vị Xuyên, Tỉnh Hà Giang","code":"00913","parent_code":"030"},"00916":{"name":"Thị trấn Nông Trường Việt Lâm","type":"thi-tran","slug":"thi-tran-nong-truong-viet-lam","name_with_type":"Thị trấn Nông Trường Việt Lâm","path":"Thị trấn Nông Trường Việt Lâm, Huyện Vị Xuyên, Tỉnh Hà Giang","path_with_type":"Thị trấn Nông Trường Việt Lâm, Huyện Vị Xuyên, Tỉnh Hà Giang","code":"00916","parent_code":"030"},"00919":{"name":"Xã Minh Tân","type":"xa","slug":"xa-minh-tan","name_with_type":"Xã Minh Tân","path":"Xã Minh Tân, Huyện Vị Xuyên, Tỉnh Hà Giang","path_with_type":"Xã Minh Tân, Huyện Vị Xuyên, Tỉnh Hà Giang","code":"00919","parent_code":"030"},"00922":{"name":"Xã Thuận Hoà","type":"xa","slug":"xa-thuan-hoa","name_with_type":"Xã Thuận Hoà","path":"Xã Thuận Hoà, Huyện Vị Xuyên, Tỉnh Hà Giang","path_with_type":"Xã Thuận Hoà, Huyện Vị Xuyên, Tỉnh Hà Giang","code":"00922","parent_code":"030"},"00925":{"name":"Xã Tùng Bá","type":"xa","slug":"xa-tung-ba","name_with_type":"Xã Tùng Bá","path":"Xã Tùng Bá, Huyện Vị Xuyên, Tỉnh Hà Giang","path_with_type":"Xã Tùng Bá, Huyện Vị Xuyên, Tỉnh Hà Giang","code":"00925","parent_code":"030"},"00928":{"name":"Xã Thanh Thủy","type":"xa","slug":"xa-thanh-thuy","name_with_type":"Xã Thanh Thủy","path":"Xã Thanh Thủy, Huyện Vị Xuyên, Tỉnh Hà Giang","path_with_type":"Xã Thanh Thủy, Huyện Vị Xuyên, Tỉnh Hà Giang","code":"00928","parent_code":"030"},"00931":{"name":"Xã Thanh Đức","type":"xa","slug":"xa-thanh-duc","name_with_type":"Xã Thanh Đức","path":"Xã Thanh Đức, Huyện Vị Xuyên, Tỉnh Hà Giang","path_with_type":"Xã Thanh Đức, Huyện Vị Xuyên, Tỉnh Hà Giang","code":"00931","parent_code":"030"},"00934":{"name":"Xã Phong Quang","type":"xa","slug":"xa-phong-quang","name_with_type":"Xã Phong Quang","path":"Xã Phong Quang, Huyện Vị Xuyên, Tỉnh Hà Giang","path_with_type":"Xã Phong Quang, Huyện Vị Xuyên, Tỉnh Hà Giang","code":"00934","parent_code":"030"},"00937":{"name":"Xã Xín Chải","type":"xa","slug":"xa-xin-chai","name_with_type":"Xã Xín Chải","path":"Xã Xín Chải, Huyện Vị Xuyên, Tỉnh Hà Giang","path_with_type":"Xã Xín Chải, Huyện Vị Xuyên, Tỉnh Hà Giang","code":"00937","parent_code":"030"},"00940":{"name":"Xã Phương Tiến","type":"xa","slug":"xa-phuong-tien","name_with_type":"Xã Phương Tiến","path":"Xã Phương Tiến, Huyện Vị Xuyên, Tỉnh Hà Giang","path_with_type":"Xã Phương Tiến, Huyện Vị Xuyên, Tỉnh Hà Giang","code":"00940","parent_code":"030"},"00943":{"name":"Xã Lao Chải","type":"xa","slug":"xa-lao-chai","name_with_type":"Xã Lao Chải","path":"Xã Lao Chải, Huyện Vị Xuyên, Tỉnh Hà Giang","path_with_type":"Xã Lao Chải, Huyện Vị Xuyên, Tỉnh Hà Giang","code":"00943","parent_code":"030"},"00952":{"name":"Xã Cao Bồ","type":"xa","slug":"xa-cao-bo","name_with_type":"Xã Cao Bồ","path":"Xã Cao Bồ, Huyện Vị Xuyên, Tỉnh Hà Giang","path_with_type":"Xã Cao Bồ, Huyện Vị Xuyên, Tỉnh Hà Giang","code":"00952","parent_code":"030"},"00955":{"name":"Xã Đạo Đức","type":"xa","slug":"xa-dao-duc","name_with_type":"Xã Đạo Đức","path":"Xã Đạo Đức, Huyện Vị Xuyên, Tỉnh Hà Giang","path_with_type":"Xã Đạo Đức, Huyện Vị Xuyên, Tỉnh Hà Giang","code":"00955","parent_code":"030"},"00958":{"name":"Xã Thượng Sơn","type":"xa","slug":"xa-thuong-son","name_with_type":"Xã Thượng Sơn","path":"Xã Thượng Sơn, Huyện Vị Xuyên, Tỉnh Hà Giang","path_with_type":"Xã Thượng Sơn, Huyện Vị Xuyên, Tỉnh Hà Giang","code":"00958","parent_code":"030"},"00961":{"name":"Xã Linh Hồ","type":"xa","slug":"xa-linh-ho","name_with_type":"Xã Linh Hồ","path":"Xã Linh Hồ, Huyện Vị Xuyên, Tỉnh Hà Giang","path_with_type":"Xã Linh Hồ, Huyện Vị Xuyên, Tỉnh Hà Giang","code":"00961","parent_code":"030"},"00964":{"name":"Xã Quảng Ngần","type":"xa","slug":"xa-quang-ngan","name_with_type":"Xã Quảng Ngần","path":"Xã Quảng Ngần, Huyện Vị Xuyên, Tỉnh Hà Giang","path_with_type":"Xã Quảng Ngần, Huyện Vị Xuyên, Tỉnh Hà Giang","code":"00964","parent_code":"030"},"00967":{"name":"Xã Việt Lâm","type":"xa","slug":"xa-viet-lam","name_with_type":"Xã Việt Lâm","path":"Xã Việt Lâm, Huyện Vị Xuyên, Tỉnh Hà Giang","path_with_type":"Xã Việt Lâm, Huyện Vị Xuyên, Tỉnh Hà Giang","code":"00967","parent_code":"030"},"00970":{"name":"Xã Ngọc Linh","type":"xa","slug":"xa-ngoc-linh","name_with_type":"Xã Ngọc Linh","path":"Xã Ngọc Linh, Huyện Vị Xuyên, Tỉnh Hà Giang","path_with_type":"Xã Ngọc Linh, Huyện Vị Xuyên, Tỉnh Hà Giang","code":"00970","parent_code":"030"},"00973":{"name":"Xã Ngọc Minh","type":"xa","slug":"xa-ngoc-minh","name_with_type":"Xã Ngọc Minh","path":"Xã Ngọc Minh, Huyện Vị Xuyên, Tỉnh Hà Giang","path_with_type":"Xã Ngọc Minh, Huyện Vị Xuyên, Tỉnh Hà Giang","code":"00973","parent_code":"030"},"00976":{"name":"Xã Bạch Ngọc","type":"xa","slug":"xa-bach-ngoc","name_with_type":"Xã Bạch Ngọc","path":"Xã Bạch Ngọc, Huyện Vị Xuyên, Tỉnh Hà Giang","path_with_type":"Xã Bạch Ngọc, Huyện Vị Xuyên, Tỉnh Hà Giang","code":"00976","parent_code":"030"},"00979":{"name":"Xã Trung Thành","type":"xa","slug":"xa-trung-thanh","name_with_type":"Xã Trung Thành","path":"Xã Trung Thành, Huyện Vị Xuyên, Tỉnh Hà Giang","path_with_type":"Xã Trung Thành, Huyện Vị Xuyên, Tỉnh Hà Giang","code":"00979","parent_code":"030"},"00982":{"name":"Xã Minh Sơn","type":"xa","slug":"xa-minh-son","name_with_type":"Xã Minh Sơn","path":"Xã Minh Sơn, Huyện Bắc Mê, Tỉnh Hà Giang","path_with_type":"Xã Minh Sơn, Huyện Bắc Mê, Tỉnh Hà Giang","code":"00982","parent_code":"031"},"00985":{"name":"Xã Giáp Trung","type":"xa","slug":"xa-giap-trung","name_with_type":"Xã Giáp Trung","path":"Xã Giáp Trung, Huyện Bắc Mê, Tỉnh Hà Giang","path_with_type":"Xã Giáp Trung, Huyện Bắc Mê, Tỉnh Hà Giang","code":"00985","parent_code":"031"},"00988":{"name":"Xã Yên Định","type":"xa","slug":"xa-yen-dinh","name_with_type":"Xã Yên Định","path":"Xã Yên Định, Huyện Bắc Mê, Tỉnh Hà Giang","path_with_type":"Xã Yên Định, Huyện Bắc Mê, Tỉnh Hà Giang","code":"00988","parent_code":"031"},"00991":{"name":"Thị trấn Yên Phú","type":"thi-tran","slug":"thi-tran-yen-phu","name_with_type":"Thị trấn Yên Phú","path":"Thị trấn Yên Phú, Huyện Bắc Mê, Tỉnh Hà Giang","path_with_type":"Thị trấn Yên Phú, Huyện Bắc Mê, Tỉnh Hà Giang","code":"00991","parent_code":"031"},"00994":{"name":"Xã Minh Ngọc","type":"xa","slug":"xa-minh-ngoc","name_with_type":"Xã Minh Ngọc","path":"Xã Minh Ngọc, Huyện Bắc Mê, Tỉnh Hà Giang","path_with_type":"Xã Minh Ngọc, Huyện Bắc Mê, Tỉnh Hà Giang","code":"00994","parent_code":"031"},"00997":{"name":"Xã Yên Phong","type":"xa","slug":"xa-yen-phong","name_with_type":"Xã Yên Phong","path":"Xã Yên Phong, Huyện Bắc Mê, Tỉnh Hà Giang","path_with_type":"Xã Yên Phong, Huyện Bắc Mê, Tỉnh Hà Giang","code":"00997","parent_code":"031"},"01000":{"name":"Xã Lạc Nông","type":"xa","slug":"xa-lac-nong","name_with_type":"Xã Lạc Nông","path":"Xã Lạc Nông, Huyện Bắc Mê, Tỉnh Hà Giang","path_with_type":"Xã Lạc Nông, Huyện Bắc Mê, Tỉnh Hà Giang","code":"01000","parent_code":"031"},"01003":{"name":"Xã Phú Nam","type":"xa","slug":"xa-phu-nam","name_with_type":"Xã Phú Nam","path":"Xã Phú Nam, Huyện Bắc Mê, Tỉnh Hà Giang","path_with_type":"Xã Phú Nam, Huyện Bắc Mê, Tỉnh Hà Giang","code":"01003","parent_code":"031"},"01006":{"name":"Xã Yên Cường","type":"xa","slug":"xa-yen-cuong","name_with_type":"Xã Yên Cường","path":"Xã Yên Cường, Huyện Bắc Mê, Tỉnh Hà Giang","path_with_type":"Xã Yên Cường, Huyện Bắc Mê, Tỉnh Hà Giang","code":"01006","parent_code":"031"},"01009":{"name":"Xã Thượng Tân","type":"xa","slug":"xa-thuong-tan","name_with_type":"Xã Thượng Tân","path":"Xã Thượng Tân, Huyện Bắc Mê, Tỉnh Hà Giang","path_with_type":"Xã Thượng Tân, Huyện Bắc Mê, Tỉnh Hà Giang","code":"01009","parent_code":"031"},"01012":{"name":"Xã Đường Âm","type":"xa","slug":"xa-duong-am","name_with_type":"Xã Đường Âm","path":"Xã Đường Âm, Huyện Bắc Mê, Tỉnh Hà Giang","path_with_type":"Xã Đường Âm, Huyện Bắc Mê, Tỉnh Hà Giang","code":"01012","parent_code":"031"},"01015":{"name":"Xã Đường Hồng","type":"xa","slug":"xa-duong-hong","name_with_type":"Xã Đường Hồng","path":"Xã Đường Hồng, Huyện Bắc Mê, Tỉnh Hà Giang","path_with_type":"Xã Đường Hồng, Huyện Bắc Mê, Tỉnh Hà Giang","code":"01015","parent_code":"031"},"01018":{"name":"Xã Phiêng Luông","type":"xa","slug":"xa-phieng-luong","name_with_type":"Xã Phiêng Luông","path":"Xã Phiêng Luông, Huyện Bắc Mê, Tỉnh Hà Giang","path_with_type":"Xã Phiêng Luông, Huyện Bắc Mê, Tỉnh Hà Giang","code":"01018","parent_code":"031"},"01021":{"name":"Thị trấn Vinh Quang","type":"thi-tran","slug":"thi-tran-vinh-quang","name_with_type":"Thị trấn Vinh Quang","path":"Thị trấn Vinh Quang, Huyện Hoàng Su Phì, Tỉnh Hà Giang","path_with_type":"Thị trấn Vinh Quang, Huyện Hoàng Su Phì, Tỉnh Hà Giang","code":"01021","parent_code":"032"},"01024":{"name":"Xã Bản Máy","type":"xa","slug":"xa-ban-may","name_with_type":"Xã Bản Máy","path":"Xã Bản Máy, Huyện Hoàng Su Phì, Tỉnh Hà Giang","path_with_type":"Xã Bản Máy, Huyện Hoàng Su Phì, Tỉnh Hà Giang","code":"01024","parent_code":"032"},"01027":{"name":"Xã Thàng Tín","type":"xa","slug":"xa-thang-tin","name_with_type":"Xã Thàng Tín","path":"Xã Thàng Tín, Huyện Hoàng Su Phì, Tỉnh Hà Giang","path_with_type":"Xã Thàng Tín, Huyện Hoàng Su Phì, Tỉnh Hà Giang","code":"01027","parent_code":"032"},"01030":{"name":"Xã Thèn Chu Phìn","type":"xa","slug":"xa-then-chu-phin","name_with_type":"Xã Thèn Chu Phìn","path":"Xã Thèn Chu Phìn, Huyện Hoàng Su Phì, Tỉnh Hà Giang","path_with_type":"Xã Thèn Chu Phìn, Huyện Hoàng Su Phì, Tỉnh Hà Giang","code":"01030","parent_code":"032"},"01033":{"name":"Xã Pố Lồ","type":"xa","slug":"xa-po-lo","name_with_type":"Xã Pố Lồ","path":"Xã Pố Lồ, Huyện Hoàng Su Phì, Tỉnh Hà Giang","path_with_type":"Xã Pố Lồ, Huyện Hoàng Su Phì, Tỉnh Hà Giang","code":"01033","parent_code":"032"},"01036":{"name":"Xã Bản Phùng","type":"xa","slug":"xa-ban-phung","name_with_type":"Xã Bản Phùng","path":"Xã Bản Phùng, Huyện Hoàng Su Phì, Tỉnh Hà Giang","path_with_type":"Xã Bản Phùng, Huyện Hoàng Su Phì, Tỉnh Hà Giang","code":"01036","parent_code":"032"},"01039":{"name":"Xã Túng Sán","type":"xa","slug":"xa-tung-san","name_with_type":"Xã Túng Sán","path":"Xã Túng Sán, Huyện Hoàng Su Phì, Tỉnh Hà Giang","path_with_type":"Xã Túng Sán, Huyện Hoàng Su Phì, Tỉnh Hà Giang","code":"01039","parent_code":"032"},"01042":{"name":"Xã Chiến Phố","type":"xa","slug":"xa-chien-pho","name_with_type":"Xã Chiến Phố","path":"Xã Chiến Phố, Huyện Hoàng Su Phì, Tỉnh Hà Giang","path_with_type":"Xã Chiến Phố, Huyện Hoàng Su Phì, Tỉnh Hà Giang","code":"01042","parent_code":"032"},"01045":{"name":"Xã Đản Ván","type":"xa","slug":"xa-dan-van","name_with_type":"Xã Đản Ván","path":"Xã Đản Ván, Huyện Hoàng Su Phì, Tỉnh Hà Giang","path_with_type":"Xã Đản Ván, Huyện Hoàng Su Phì, Tỉnh Hà Giang","code":"01045","parent_code":"032"},"01048":{"name":"Xã Tụ Nhân","type":"xa","slug":"xa-tu-nhan","name_with_type":"Xã Tụ Nhân","path":"Xã Tụ Nhân, Huyện Hoàng Su Phì, Tỉnh Hà Giang","path_with_type":"Xã Tụ Nhân, Huyện Hoàng Su Phì, Tỉnh Hà Giang","code":"01048","parent_code":"032"},"01051":{"name":"Xã Tân Tiến","type":"xa","slug":"xa-tan-tien","name_with_type":"Xã Tân Tiến","path":"Xã Tân Tiến, Huyện Hoàng Su Phì, Tỉnh Hà Giang","path_with_type":"Xã Tân Tiến, Huyện Hoàng Su Phì, Tỉnh Hà Giang","code":"01051","parent_code":"032"},"01054":{"name":"Xã Nàng Đôn","type":"xa","slug":"xa-nang-don","name_with_type":"Xã Nàng Đôn","path":"Xã Nàng Đôn, Huyện Hoàng Su Phì, Tỉnh Hà Giang","path_with_type":"Xã Nàng Đôn, Huyện Hoàng Su Phì, Tỉnh Hà Giang","code":"01054","parent_code":"032"},"01057":{"name":"Xã Pờ Ly Ngài","type":"xa","slug":"xa-po-ly-ngai","name_with_type":"Xã Pờ Ly Ngài","path":"Xã Pờ Ly Ngài, Huyện Hoàng Su Phì, Tỉnh Hà Giang","path_with_type":"Xã Pờ Ly Ngài, Huyện Hoàng Su Phì, Tỉnh Hà Giang","code":"01057","parent_code":"032"},"01060":{"name":"Xã Sán Xả Hồ","type":"xa","slug":"xa-san-xa-ho","name_with_type":"Xã Sán Xả Hồ","path":"Xã Sán Xả Hồ, Huyện Hoàng Su Phì, Tỉnh Hà Giang","path_with_type":"Xã Sán Xả Hồ, Huyện Hoàng Su Phì, Tỉnh Hà Giang","code":"01060","parent_code":"032"},"01063":{"name":"Xã Bản Luốc","type":"xa","slug":"xa-ban-luoc","name_with_type":"Xã Bản Luốc","path":"Xã Bản Luốc, Huyện Hoàng Su Phì, Tỉnh Hà Giang","path_with_type":"Xã Bản Luốc, Huyện Hoàng Su Phì, Tỉnh Hà Giang","code":"01063","parent_code":"032"},"01066":{"name":"Xã Ngàm Đăng Vài","type":"xa","slug":"xa-ngam-dang-vai","name_with_type":"Xã Ngàm Đăng Vài","path":"Xã Ngàm Đăng Vài, Huyện Hoàng Su Phì, Tỉnh Hà Giang","path_with_type":"Xã Ngàm Đăng Vài, Huyện Hoàng Su Phì, Tỉnh Hà Giang","code":"01066","parent_code":"032"},"01069":{"name":"Xã Bản Nhùng","type":"xa","slug":"xa-ban-nhung","name_with_type":"Xã Bản Nhùng","path":"Xã Bản Nhùng, Huyện Hoàng Su Phì, Tỉnh Hà Giang","path_with_type":"Xã Bản Nhùng, Huyện Hoàng Su Phì, Tỉnh Hà Giang","code":"01069","parent_code":"032"},"01072":{"name":"Xã Tả Sử Choóng","type":"xa","slug":"xa-ta-su-choong","name_with_type":"Xã Tả Sử Choóng","path":"Xã Tả Sử Choóng, Huyện Hoàng Su Phì, Tỉnh Hà Giang","path_with_type":"Xã Tả Sử Choóng, Huyện Hoàng Su Phì, Tỉnh Hà Giang","code":"01072","parent_code":"032"},"01075":{"name":"Xã Nậm Dịch","type":"xa","slug":"xa-nam-dich","name_with_type":"Xã Nậm Dịch","path":"Xã Nậm Dịch, Huyện Hoàng Su Phì, Tỉnh Hà Giang","path_with_type":"Xã Nậm Dịch, Huyện Hoàng Su Phì, Tỉnh Hà Giang","code":"01075","parent_code":"032"},"01081":{"name":"Xã Hồ Thầu","type":"xa","slug":"xa-ho-thau","name_with_type":"Xã Hồ Thầu","path":"Xã Hồ Thầu, Huyện Hoàng Su Phì, Tỉnh Hà Giang","path_with_type":"Xã Hồ Thầu, Huyện Hoàng Su Phì, Tỉnh Hà Giang","code":"01081","parent_code":"032"},"01084":{"name":"Xã Nam Sơn","type":"xa","slug":"xa-nam-son","name_with_type":"Xã Nam Sơn","path":"Xã Nam Sơn, Huyện Hoàng Su Phì, Tỉnh Hà Giang","path_with_type":"Xã Nam Sơn, Huyện Hoàng Su Phì, Tỉnh Hà Giang","code":"01084","parent_code":"032"},"01087":{"name":"Xã Nậm Tỵ","type":"xa","slug":"xa-nam-ty","name_with_type":"Xã Nậm Tỵ","path":"Xã Nậm Tỵ, Huyện Hoàng Su Phì, Tỉnh Hà Giang","path_with_type":"Xã Nậm Tỵ, Huyện Hoàng Su Phì, Tỉnh Hà Giang","code":"01087","parent_code":"032"},"01090":{"name":"Xã Thông Nguyên","type":"xa","slug":"xa-thong-nguyen","name_with_type":"Xã Thông Nguyên","path":"Xã Thông Nguyên, Huyện Hoàng Su Phì, Tỉnh Hà Giang","path_with_type":"Xã Thông Nguyên, Huyện Hoàng Su Phì, Tỉnh Hà Giang","code":"01090","parent_code":"032"},"01093":{"name":"Xã Nậm Khòa","type":"xa","slug":"xa-nam-khoa","name_with_type":"Xã Nậm Khòa","path":"Xã Nậm Khòa, Huyện Hoàng Su Phì, Tỉnh Hà Giang","path_with_type":"Xã Nậm Khòa, Huyện Hoàng Su Phì, Tỉnh Hà Giang","code":"01093","parent_code":"032"},"01096":{"name":"Thị trấn Cốc Pài","type":"thi-tran","slug":"thi-tran-coc-pai","name_with_type":"Thị trấn Cốc Pài","path":"Thị trấn Cốc Pài, Huyện Xín Mần, Tỉnh Hà Giang","path_with_type":"Thị trấn Cốc Pài, Huyện Xín Mần, Tỉnh Hà Giang","code":"01096","parent_code":"033"},"01099":{"name":"Xã Nàn Xỉn","type":"xa","slug":"xa-nan-xin","name_with_type":"Xã Nàn Xỉn","path":"Xã Nàn Xỉn, Huyện Xín Mần, Tỉnh Hà Giang","path_with_type":"Xã Nàn Xỉn, Huyện Xín Mần, Tỉnh Hà Giang","code":"01099","parent_code":"033"},"01102":{"name":"Xã Bản Díu","type":"xa","slug":"xa-ban-diu","name_with_type":"Xã Bản Díu","path":"Xã Bản Díu, Huyện Xín Mần, Tỉnh Hà Giang","path_with_type":"Xã Bản Díu, Huyện Xín Mần, Tỉnh Hà Giang","code":"01102","parent_code":"033"},"01105":{"name":"Xã Chí Cà","type":"xa","slug":"xa-chi-ca","name_with_type":"Xã Chí Cà","path":"Xã Chí Cà, Huyện Xín Mần, Tỉnh Hà Giang","path_with_type":"Xã Chí Cà, Huyện Xín Mần, Tỉnh Hà Giang","code":"01105","parent_code":"033"},"01108":{"name":"Xã Xín Mần","type":"xa","slug":"xa-xin-man","name_with_type":"Xã Xín Mần","path":"Xã Xín Mần, Huyện Xín Mần, Tỉnh Hà Giang","path_with_type":"Xã Xín Mần, Huyện Xín Mần, Tỉnh Hà Giang","code":"01108","parent_code":"033"},"01114":{"name":"Xã Thèn Phàng","type":"xa","slug":"xa-then-phang","name_with_type":"Xã Thèn Phàng","path":"Xã Thèn Phàng, Huyện Xín Mần, Tỉnh Hà Giang","path_with_type":"Xã Thèn Phàng, Huyện Xín Mần, Tỉnh Hà Giang","code":"01114","parent_code":"033"},"01117":{"name":"Xã Trung Thịnh","type":"xa","slug":"xa-trung-thinh","name_with_type":"Xã Trung Thịnh","path":"Xã Trung Thịnh, Huyện Xín Mần, Tỉnh Hà Giang","path_with_type":"Xã Trung Thịnh, Huyện Xín Mần, Tỉnh Hà Giang","code":"01117","parent_code":"033"},"01120":{"name":"Xã Pà Vầy Sủ","type":"xa","slug":"xa-pa-vay-su","name_with_type":"Xã Pà Vầy Sủ","path":"Xã Pà Vầy Sủ, Huyện Xín Mần, Tỉnh Hà Giang","path_with_type":"Xã Pà Vầy Sủ, Huyện Xín Mần, Tỉnh Hà Giang","code":"01120","parent_code":"033"},"01123":{"name":"Xã Cốc Rế","type":"xa","slug":"xa-coc-re","name_with_type":"Xã Cốc Rế","path":"Xã Cốc Rế, Huyện Xín Mần, Tỉnh Hà Giang","path_with_type":"Xã Cốc Rế, Huyện Xín Mần, Tỉnh Hà Giang","code":"01123","parent_code":"033"},"01126":{"name":"Xã Thu Tà","type":"xa","slug":"xa-thu-ta","name_with_type":"Xã Thu Tà","path":"Xã Thu Tà, Huyện Xín Mần, Tỉnh Hà Giang","path_with_type":"Xã Thu Tà, Huyện Xín Mần, Tỉnh Hà Giang","code":"01126","parent_code":"033"},"01129":{"name":"Xã Nàn Ma","type":"xa","slug":"xa-nan-ma","name_with_type":"Xã Nàn Ma","path":"Xã Nàn Ma, Huyện Xín Mần, Tỉnh Hà Giang","path_with_type":"Xã Nàn Ma, Huyện Xín Mần, Tỉnh Hà Giang","code":"01129","parent_code":"033"},"01132":{"name":"Xã Tả Nhìu","type":"xa","slug":"xa-ta-nhiu","name_with_type":"Xã Tả Nhìu","path":"Xã Tả Nhìu, Huyện Xín Mần, Tỉnh Hà Giang","path_with_type":"Xã Tả Nhìu, Huyện Xín Mần, Tỉnh Hà Giang","code":"01132","parent_code":"033"},"01135":{"name":"Xã Bản Ngò","type":"xa","slug":"xa-ban-ngo","name_with_type":"Xã Bản Ngò","path":"Xã Bản Ngò, Huyện Xín Mần, Tỉnh Hà Giang","path_with_type":"Xã Bản Ngò, Huyện Xín Mần, Tỉnh Hà Giang","code":"01135","parent_code":"033"},"01138":{"name":"Xã Chế Là","type":"xa","slug":"xa-che-la","name_with_type":"Xã Chế Là","path":"Xã Chế Là, Huyện Xín Mần, Tỉnh Hà Giang","path_with_type":"Xã Chế Là, Huyện Xín Mần, Tỉnh Hà Giang","code":"01138","parent_code":"033"},"01141":{"name":"Xã Nấm Dẩn","type":"xa","slug":"xa-nam-dan","name_with_type":"Xã Nấm Dẩn","path":"Xã Nấm Dẩn, Huyện Xín Mần, Tỉnh Hà Giang","path_with_type":"Xã Nấm Dẩn, Huyện Xín Mần, Tỉnh Hà Giang","code":"01141","parent_code":"033"},"01144":{"name":"Xã Quảng Nguyên","type":"xa","slug":"xa-quang-nguyen","name_with_type":"Xã Quảng Nguyên","path":"Xã Quảng Nguyên, Huyện Xín Mần, Tỉnh Hà Giang","path_with_type":"Xã Quảng Nguyên, Huyện Xín Mần, Tỉnh Hà Giang","code":"01144","parent_code":"033"},"01147":{"name":"Xã Nà Chì","type":"xa","slug":"xa-na-chi","name_with_type":"Xã Nà Chì","path":"Xã Nà Chì, Huyện Xín Mần, Tỉnh Hà Giang","path_with_type":"Xã Nà Chì, Huyện Xín Mần, Tỉnh Hà Giang","code":"01147","parent_code":"033"},"01150":{"name":"Xã Khuôn Lùng","type":"xa","slug":"xa-khuon-lung","name_with_type":"Xã Khuôn Lùng","path":"Xã Khuôn Lùng, Huyện Xín Mần, Tỉnh Hà Giang","path_with_type":"Xã Khuôn Lùng, Huyện Xín Mần, Tỉnh Hà Giang","code":"01150","parent_code":"033"},"01153":{"name":"Thị trấn Việt Quang","type":"thi-tran","slug":"thi-tran-viet-quang","name_with_type":"Thị trấn Việt Quang","path":"Thị trấn Việt Quang, Huyện Bắc Quang, Tỉnh Hà Giang","path_with_type":"Thị trấn Việt Quang, Huyện Bắc Quang, Tỉnh Hà Giang","code":"01153","parent_code":"034"},"01156":{"name":"Thị trấn Vĩnh Tuy","type":"thi-tran","slug":"thi-tran-vinh-tuy","name_with_type":"Thị trấn Vĩnh Tuy","path":"Thị trấn Vĩnh Tuy, Huyện Bắc Quang, Tỉnh Hà Giang","path_with_type":"Thị trấn Vĩnh Tuy, Huyện Bắc Quang, Tỉnh Hà Giang","code":"01156","parent_code":"034"},"01159":{"name":"Xã Tân Lập","type":"xa","slug":"xa-tan-lap","name_with_type":"Xã Tân Lập","path":"Xã Tân Lập, Huyện Bắc Quang, Tỉnh Hà Giang","path_with_type":"Xã Tân Lập, Huyện Bắc Quang, Tỉnh Hà Giang","code":"01159","parent_code":"034"},"01162":{"name":"Xã Tân Thành","type":"xa","slug":"xa-tan-thanh","name_with_type":"Xã Tân Thành","path":"Xã Tân Thành, Huyện Bắc Quang, Tỉnh Hà Giang","path_with_type":"Xã Tân Thành, Huyện Bắc Quang, Tỉnh Hà Giang","code":"01162","parent_code":"034"},"01165":{"name":"Xã Đồng Tiến","type":"xa","slug":"xa-dong-tien","name_with_type":"Xã Đồng Tiến","path":"Xã Đồng Tiến, Huyện Bắc Quang, Tỉnh Hà Giang","path_with_type":"Xã Đồng Tiến, Huyện Bắc Quang, Tỉnh Hà Giang","code":"01165","parent_code":"034"},"01168":{"name":"Xã Đồng Tâm","type":"xa","slug":"xa-dong-tam","name_with_type":"Xã Đồng Tâm","path":"Xã Đồng Tâm, Huyện Bắc Quang, Tỉnh Hà Giang","path_with_type":"Xã Đồng Tâm, Huyện Bắc Quang, Tỉnh Hà Giang","code":"01168","parent_code":"034"},"01171":{"name":"Xã Tân Quang","type":"xa","slug":"xa-tan-quang","name_with_type":"Xã Tân Quang","path":"Xã Tân Quang, Huyện Bắc Quang, Tỉnh Hà Giang","path_with_type":"Xã Tân Quang, Huyện Bắc Quang, Tỉnh Hà Giang","code":"01171","parent_code":"034"},"01174":{"name":"Xã Thượng Bình","type":"xa","slug":"xa-thuong-binh","name_with_type":"Xã Thượng Bình","path":"Xã Thượng Bình, Huyện Bắc Quang, Tỉnh Hà Giang","path_with_type":"Xã Thượng Bình, Huyện Bắc Quang, Tỉnh Hà Giang","code":"01174","parent_code":"034"},"01177":{"name":"Xã Hữu Sản","type":"xa","slug":"xa-huu-san","name_with_type":"Xã Hữu Sản","path":"Xã Hữu Sản, Huyện Bắc Quang, Tỉnh Hà Giang","path_with_type":"Xã Hữu Sản, Huyện Bắc Quang, Tỉnh Hà Giang","code":"01177","parent_code":"034"},"01180":{"name":"Xã Kim Ngọc","type":"xa","slug":"xa-kim-ngoc","name_with_type":"Xã Kim Ngọc","path":"Xã Kim Ngọc, Huyện Bắc Quang, Tỉnh Hà Giang","path_with_type":"Xã Kim Ngọc, Huyện Bắc Quang, Tỉnh Hà Giang","code":"01180","parent_code":"034"},"01183":{"name":"Xã Việt Vinh","type":"xa","slug":"xa-viet-vinh","name_with_type":"Xã Việt Vinh","path":"Xã Việt Vinh, Huyện Bắc Quang, Tỉnh Hà Giang","path_with_type":"Xã Việt Vinh, Huyện Bắc Quang, Tỉnh Hà Giang","code":"01183","parent_code":"034"},"01186":{"name":"Xã Bằng Hành","type":"xa","slug":"xa-bang-hanh","name_with_type":"Xã Bằng Hành","path":"Xã Bằng Hành, Huyện Bắc Quang, Tỉnh Hà Giang","path_with_type":"Xã Bằng Hành, Huyện Bắc Quang, Tỉnh Hà Giang","code":"01186","parent_code":"034"},"01189":{"name":"Xã Quang Minh","type":"xa","slug":"xa-quang-minh","name_with_type":"Xã Quang Minh","path":"Xã Quang Minh, Huyện Bắc Quang, Tỉnh Hà Giang","path_with_type":"Xã Quang Minh, Huyện Bắc Quang, Tỉnh Hà Giang","code":"01189","parent_code":"034"},"01192":{"name":"Xã Liên Hiệp","type":"xa","slug":"xa-lien-hiep","name_with_type":"Xã Liên Hiệp","path":"Xã Liên Hiệp, Huyện Bắc Quang, Tỉnh Hà Giang","path_with_type":"Xã Liên Hiệp, Huyện Bắc Quang, Tỉnh Hà Giang","code":"01192","parent_code":"034"},"01195":{"name":"Xã Vô Điếm","type":"xa","slug":"xa-vo-diem","name_with_type":"Xã Vô Điếm","path":"Xã Vô Điếm, Huyện Bắc Quang, Tỉnh Hà Giang","path_with_type":"Xã Vô Điếm, Huyện Bắc Quang, Tỉnh Hà Giang","code":"01195","parent_code":"034"},"01198":{"name":"Xã Việt Hồng","type":"xa","slug":"xa-viet-hong","name_with_type":"Xã Việt Hồng","path":"Xã Việt Hồng, Huyện Bắc Quang, Tỉnh Hà Giang","path_with_type":"Xã Việt Hồng, Huyện Bắc Quang, Tỉnh Hà Giang","code":"01198","parent_code":"034"},"01201":{"name":"Xã Hùng An","type":"xa","slug":"xa-hung-an","name_with_type":"Xã Hùng An","path":"Xã Hùng An, Huyện Bắc Quang, Tỉnh Hà Giang","path_with_type":"Xã Hùng An, Huyện Bắc Quang, Tỉnh Hà Giang","code":"01201","parent_code":"034"},"01204":{"name":"Xã Đức Xuân","type":"xa","slug":"xa-duc-xuan","name_with_type":"Xã Đức Xuân","path":"Xã Đức Xuân, Huyện Bắc Quang, Tỉnh Hà Giang","path_with_type":"Xã Đức Xuân, Huyện Bắc Quang, Tỉnh Hà Giang","code":"01204","parent_code":"034"},"01207":{"name":"Xã Tiên Kiều","type":"xa","slug":"xa-tien-kieu","name_with_type":"Xã Tiên Kiều","path":"Xã Tiên Kiều, Huyện Bắc Quang, Tỉnh Hà Giang","path_with_type":"Xã Tiên Kiều, Huyện Bắc Quang, Tỉnh Hà Giang","code":"01207","parent_code":"034"},"01210":{"name":"Xã Vĩnh Hảo","type":"xa","slug":"xa-vinh-hao","name_with_type":"Xã Vĩnh Hảo","path":"Xã Vĩnh Hảo, Huyện Bắc Quang, Tỉnh Hà Giang","path_with_type":"Xã Vĩnh Hảo, Huyện Bắc Quang, Tỉnh Hà Giang","code":"01210","parent_code":"034"},"01213":{"name":"Xã Vĩnh Phúc","type":"xa","slug":"xa-vinh-phuc","name_with_type":"Xã Vĩnh Phúc","path":"Xã Vĩnh Phúc, Huyện Bắc Quang, Tỉnh Hà Giang","path_with_type":"Xã Vĩnh Phúc, Huyện Bắc Quang, Tỉnh Hà Giang","code":"01213","parent_code":"034"},"01216":{"name":"Xã Đồng Yên","type":"xa","slug":"xa-dong-yen","name_with_type":"Xã Đồng Yên","path":"Xã Đồng Yên, Huyện Bắc Quang, Tỉnh Hà Giang","path_with_type":"Xã Đồng Yên, Huyện Bắc Quang, Tỉnh Hà Giang","code":"01216","parent_code":"034"},"01219":{"name":"Xã Đông Thành","type":"xa","slug":"xa-dong-thanh","name_with_type":"Xã Đông Thành","path":"Xã Đông Thành, Huyện Bắc Quang, Tỉnh Hà Giang","path_with_type":"Xã Đông Thành, Huyện Bắc Quang, Tỉnh Hà Giang","code":"01219","parent_code":"034"},"01222":{"name":"Xã Xuân Minh","type":"xa","slug":"xa-xuan-minh","name_with_type":"Xã Xuân Minh","path":"Xã Xuân Minh, Huyện Quang Bình, Tỉnh Hà Giang","path_with_type":"Xã Xuân Minh, Huyện Quang Bình, Tỉnh Hà Giang","code":"01222","parent_code":"035"},"01225":{"name":"Xã Tiên Nguyên","type":"xa","slug":"xa-tien-nguyen","name_with_type":"Xã Tiên Nguyên","path":"Xã Tiên Nguyên, Huyện Quang Bình, Tỉnh Hà Giang","path_with_type":"Xã Tiên Nguyên, Huyện Quang Bình, Tỉnh Hà Giang","code":"01225","parent_code":"035"},"01228":{"name":"Xã Tân Nam","type":"xa","slug":"xa-tan-nam","name_with_type":"Xã Tân Nam","path":"Xã Tân Nam, Huyện Quang Bình, Tỉnh Hà Giang","path_with_type":"Xã Tân Nam, Huyện Quang Bình, Tỉnh Hà Giang","code":"01228","parent_code":"035"},"01231":{"name":"Xã Bản Rịa","type":"xa","slug":"xa-ban-ria","name_with_type":"Xã Bản Rịa","path":"Xã Bản Rịa, Huyện Quang Bình, Tỉnh Hà Giang","path_with_type":"Xã Bản Rịa, Huyện Quang Bình, Tỉnh Hà Giang","code":"01231","parent_code":"035"},"01234":{"name":"Xã Yên Thành","type":"xa","slug":"xa-yen-thanh","name_with_type":"Xã Yên Thành","path":"Xã Yên Thành, Huyện Quang Bình, Tỉnh Hà Giang","path_with_type":"Xã Yên Thành, Huyện Quang Bình, Tỉnh Hà Giang","code":"01234","parent_code":"035"},"01237":{"name":"Thị trấn Yên Bình","type":"thi-tran","slug":"thi-tran-yen-binh","name_with_type":"Thị trấn Yên Bình","path":"Thị trấn Yên Bình, Huyện Quang Bình, Tỉnh Hà Giang","path_with_type":"Thị trấn Yên Bình, Huyện Quang Bình, Tỉnh Hà Giang","code":"01237","parent_code":"035"},"01240":{"name":"Xã Tân Trịnh","type":"xa","slug":"xa-tan-trinh","name_with_type":"Xã Tân Trịnh","path":"Xã Tân Trịnh, Huyện Quang Bình, Tỉnh Hà Giang","path_with_type":"Xã Tân Trịnh, Huyện Quang Bình, Tỉnh Hà Giang","code":"01240","parent_code":"035"},"01243":{"name":"Xã Tân Bắc","type":"xa","slug":"xa-tan-bac","name_with_type":"Xã Tân Bắc","path":"Xã Tân Bắc, Huyện Quang Bình, Tỉnh Hà Giang","path_with_type":"Xã Tân Bắc, Huyện Quang Bình, Tỉnh Hà Giang","code":"01243","parent_code":"035"},"01246":{"name":"Xã Bằng Lang","type":"xa","slug":"xa-bang-lang","name_with_type":"Xã Bằng Lang","path":"Xã Bằng Lang, Huyện Quang Bình, Tỉnh Hà Giang","path_with_type":"Xã Bằng Lang, Huyện Quang Bình, Tỉnh Hà Giang","code":"01246","parent_code":"035"},"01249":{"name":"Xã Yên Hà","type":"xa","slug":"xa-yen-ha","name_with_type":"Xã Yên Hà","path":"Xã Yên Hà, Huyện Quang Bình, Tỉnh Hà Giang","path_with_type":"Xã Yên Hà, Huyện Quang Bình, Tỉnh Hà Giang","code":"01249","parent_code":"035"},"01252":{"name":"Xã Hương Sơn","type":"xa","slug":"xa-huong-son","name_with_type":"Xã Hương Sơn","path":"Xã Hương Sơn, Huyện Quang Bình, Tỉnh Hà Giang","path_with_type":"Xã Hương Sơn, Huyện Quang Bình, Tỉnh Hà Giang","code":"01252","parent_code":"035"},"01255":{"name":"Xã Xuân Giang","type":"xa","slug":"xa-xuan-giang","name_with_type":"Xã Xuân Giang","path":"Xã Xuân Giang, Huyện Quang Bình, Tỉnh Hà Giang","path_with_type":"Xã Xuân Giang, Huyện Quang Bình, Tỉnh Hà Giang","code":"01255","parent_code":"035"},"01258":{"name":"Xã Nà Khương","type":"xa","slug":"xa-na-khuong","name_with_type":"Xã Nà Khương","path":"Xã Nà Khương, Huyện Quang Bình, Tỉnh Hà Giang","path_with_type":"Xã Nà Khương, Huyện Quang Bình, Tỉnh Hà Giang","code":"01258","parent_code":"035"},"01261":{"name":"Xã Tiên Yên","type":"xa","slug":"xa-tien-yen","name_with_type":"Xã Tiên Yên","path":"Xã Tiên Yên, Huyện Quang Bình, Tỉnh Hà Giang","path_with_type":"Xã Tiên Yên, Huyện Quang Bình, Tỉnh Hà Giang","code":"01261","parent_code":"035"},"01264":{"name":"Xã Vĩ Thượng","type":"xa","slug":"xa-vi-thuong","name_with_type":"Xã Vĩ Thượng","path":"Xã Vĩ Thượng, Huyện Quang Bình, Tỉnh Hà Giang","path_with_type":"Xã Vĩ Thượng, Huyện Quang Bình, Tỉnh Hà Giang","code":"01264","parent_code":"035"},"01267":{"name":"Phường Sông Hiến","type":"phuong","slug":"phuong-song-hien","name_with_type":"Phường Sông Hiến","path":"Phường Sông Hiến, Thành phố Cao Bằng, Tỉnh Cao Bằng","path_with_type":"Phường Sông Hiến, Thành phố Cao Bằng, Tỉnh Cao Bằng","code":"01267","parent_code":"040"},"01270":{"name":"Phường Sông Bằng","type":"phuong","slug":"phuong-song-bang","name_with_type":"Phường Sông Bằng","path":"Phường Sông Bằng, Thành phố Cao Bằng, Tỉnh Cao Bằng","path_with_type":"Phường Sông Bằng, Thành phố Cao Bằng, Tỉnh Cao Bằng","code":"01270","parent_code":"040"},"01273":{"name":"Phường Hợp Giang","type":"phuong","slug":"phuong-hop-giang","name_with_type":"Phường Hợp Giang","path":"Phường Hợp Giang, Thành phố Cao Bằng, Tỉnh Cao Bằng","path_with_type":"Phường Hợp Giang, Thành phố Cao Bằng, Tỉnh Cao Bằng","code":"01273","parent_code":"040"},"01276":{"name":"Phường Tân Giang","type":"phuong","slug":"phuong-tan-giang","name_with_type":"Phường Tân Giang","path":"Phường Tân Giang, Thành phố Cao Bằng, Tỉnh Cao Bằng","path_with_type":"Phường Tân Giang, Thành phố Cao Bằng, Tỉnh Cao Bằng","code":"01276","parent_code":"040"},"01279":{"name":"Phường Ngọc Xuân","type":"phuong","slug":"phuong-ngoc-xuan","name_with_type":"Phường Ngọc Xuân","path":"Phường Ngọc Xuân, Thành phố Cao Bằng, Tỉnh Cao Bằng","path_with_type":"Phường Ngọc Xuân, Thành phố Cao Bằng, Tỉnh Cao Bằng","code":"01279","parent_code":"040"},"01282":{"name":"Phường Đề Thám","type":"phuong","slug":"phuong-de-tham","name_with_type":"Phường Đề Thám","path":"Phường Đề Thám, Thành phố Cao Bằng, Tỉnh Cao Bằng","path_with_type":"Phường Đề Thám, Thành phố Cao Bằng, Tỉnh Cao Bằng","code":"01282","parent_code":"040"},"01285":{"name":"Phường Hoà Chung","type":"phuong","slug":"phuong-hoa-chung","name_with_type":"Phường Hoà Chung","path":"Phường Hoà Chung, Thành phố Cao Bằng, Tỉnh Cao Bằng","path_with_type":"Phường Hoà Chung, Thành phố Cao Bằng, Tỉnh Cao Bằng","code":"01285","parent_code":"040"},"01288":{"name":"Phường Duyệt Trung","type":"phuong","slug":"phuong-duyet-trung","name_with_type":"Phường Duyệt Trung","path":"Phường Duyệt Trung, Thành phố Cao Bằng, Tỉnh Cao Bằng","path_with_type":"Phường Duyệt Trung, Thành phố Cao Bằng, Tỉnh Cao Bằng","code":"01288","parent_code":"040"},"01693":{"name":"Xã Vĩnh Quang","type":"xa","slug":"xa-vinh-quang","name_with_type":"Xã Vĩnh Quang","path":"Xã Vĩnh Quang, Thành phố Cao Bằng, Tỉnh Cao Bằng","path_with_type":"Xã Vĩnh Quang, Thành phố Cao Bằng, Tỉnh Cao Bằng","code":"01693","parent_code":"040"},"01705":{"name":"Xã Hưng Đạo","type":"xa","slug":"xa-hung-dao","name_with_type":"Xã Hưng Đạo","path":"Xã Hưng Đạo, Thành phố Cao Bằng, Tỉnh Cao Bằng","path_with_type":"Xã Hưng Đạo, Thành phố Cao Bằng, Tỉnh Cao Bằng","code":"01705","parent_code":"040"},"01720":{"name":"Xã Chu Trinh","type":"xa","slug":"xa-chu-trinh","name_with_type":"Xã Chu Trinh","path":"Xã Chu Trinh, Thành phố Cao Bằng, Tỉnh Cao Bằng","path_with_type":"Xã Chu Trinh, Thành phố Cao Bằng, Tỉnh Cao Bằng","code":"01720","parent_code":"040"},"01290":{"name":"Thị trấn Pác Miầu","type":"thi-tran","slug":"thi-tran-pac-miau","name_with_type":"Thị trấn Pác Miầu","path":"Thị trấn Pác Miầu, Huyện Bảo Lâm, Tỉnh Cao Bằng","path_with_type":"Thị trấn Pác Miầu, Huyện Bảo Lâm, Tỉnh Cao Bằng","code":"01290","parent_code":"042"},"01291":{"name":"Xã Đức Hạnh","type":"xa","slug":"xa-duc-hanh","name_with_type":"Xã Đức Hạnh","path":"Xã Đức Hạnh, Huyện Bảo Lâm, Tỉnh Cao Bằng","path_with_type":"Xã Đức Hạnh, Huyện Bảo Lâm, Tỉnh Cao Bằng","code":"01291","parent_code":"042"},"01294":{"name":"Xã Lý Bôn","type":"xa","slug":"xa-ly-bon","name_with_type":"Xã Lý Bôn","path":"Xã Lý Bôn, Huyện Bảo Lâm, Tỉnh Cao Bằng","path_with_type":"Xã Lý Bôn, Huyện Bảo Lâm, Tỉnh Cao Bằng","code":"01294","parent_code":"042"},"01296":{"name":"Xã Nam Cao","type":"xa","slug":"xa-nam-cao","name_with_type":"Xã Nam Cao","path":"Xã Nam Cao, Huyện Bảo Lâm, Tỉnh Cao Bằng","path_with_type":"Xã Nam Cao, Huyện Bảo Lâm, Tỉnh Cao Bằng","code":"01296","parent_code":"042"},"01297":{"name":"Xã Nam Quang","type":"xa","slug":"xa-nam-quang","name_with_type":"Xã Nam Quang","path":"Xã Nam Quang, Huyện Bảo Lâm, Tỉnh Cao Bằng","path_with_type":"Xã Nam Quang, Huyện Bảo Lâm, Tỉnh Cao Bằng","code":"01297","parent_code":"042"},"01300":{"name":"Xã Vĩnh Quang","type":"xa","slug":"xa-vinh-quang","name_with_type":"Xã Vĩnh Quang","path":"Xã Vĩnh Quang, Huyện Bảo Lâm, Tỉnh Cao Bằng","path_with_type":"Xã Vĩnh Quang, Huyện Bảo Lâm, Tỉnh Cao Bằng","code":"01300","parent_code":"042"},"01303":{"name":"Xã Quảng Lâm","type":"xa","slug":"xa-quang-lam","name_with_type":"Xã Quảng Lâm","path":"Xã Quảng Lâm, Huyện Bảo Lâm, Tỉnh Cao Bằng","path_with_type":"Xã Quảng Lâm, Huyện Bảo Lâm, Tỉnh Cao Bằng","code":"01303","parent_code":"042"},"01304":{"name":"Xã Thạch Lâm","type":"xa","slug":"xa-thach-lam","name_with_type":"Xã Thạch Lâm","path":"Xã Thạch Lâm, Huyện Bảo Lâm, Tỉnh Cao Bằng","path_with_type":"Xã Thạch Lâm, Huyện Bảo Lâm, Tỉnh Cao Bằng","code":"01304","parent_code":"042"},"01309":{"name":"Xã Vĩnh Phong","type":"xa","slug":"xa-vinh-phong","name_with_type":"Xã Vĩnh Phong","path":"Xã Vĩnh Phong, Huyện Bảo Lâm, Tỉnh Cao Bằng","path_with_type":"Xã Vĩnh Phong, Huyện Bảo Lâm, Tỉnh Cao Bằng","code":"01309","parent_code":"042"},"01312":{"name":"Xã Mông Ân","type":"xa","slug":"xa-mong-an","name_with_type":"Xã Mông Ân","path":"Xã Mông Ân, Huyện Bảo Lâm, Tỉnh Cao Bằng","path_with_type":"Xã Mông Ân, Huyện Bảo Lâm, Tỉnh Cao Bằng","code":"01312","parent_code":"042"},"01315":{"name":"Xã Thái Học","type":"xa","slug":"xa-thai-hoc","name_with_type":"Xã Thái Học","path":"Xã Thái Học, Huyện Bảo Lâm, Tỉnh Cao Bằng","path_with_type":"Xã Thái Học, Huyện Bảo Lâm, Tỉnh Cao Bằng","code":"01315","parent_code":"042"},"01316":{"name":"Xã Thái Sơn","type":"xa","slug":"xa-thai-son","name_with_type":"Xã Thái Sơn","path":"Xã Thái Sơn, Huyện Bảo Lâm, Tỉnh Cao Bằng","path_with_type":"Xã Thái Sơn, Huyện Bảo Lâm, Tỉnh Cao Bằng","code":"01316","parent_code":"042"},"01318":{"name":"Xã Yên Thổ","type":"xa","slug":"xa-yen-tho","name_with_type":"Xã Yên Thổ","path":"Xã Yên Thổ, Huyện Bảo Lâm, Tỉnh Cao Bằng","path_with_type":"Xã Yên Thổ, Huyện Bảo Lâm, Tỉnh Cao Bằng","code":"01318","parent_code":"042"},"01321":{"name":"Thị trấn Bảo Lạc","type":"thi-tran","slug":"thi-tran-bao-lac","name_with_type":"Thị trấn Bảo Lạc","path":"Thị trấn Bảo Lạc, Huyện Bảo Lạc, Tỉnh Cao Bằng","path_with_type":"Thị trấn Bảo Lạc, Huyện Bảo Lạc, Tỉnh Cao Bằng","code":"01321","parent_code":"043"},"01324":{"name":"Xã Cốc Pàng","type":"xa","slug":"xa-coc-pang","name_with_type":"Xã Cốc Pàng","path":"Xã Cốc Pàng, Huyện Bảo Lạc, Tỉnh Cao Bằng","path_with_type":"Xã Cốc Pàng, Huyện Bảo Lạc, Tỉnh Cao Bằng","code":"01324","parent_code":"043"},"01327":{"name":"Xã Thượng Hà","type":"xa","slug":"xa-thuong-ha","name_with_type":"Xã Thượng Hà","path":"Xã Thượng Hà, Huyện Bảo Lạc, Tỉnh Cao Bằng","path_with_type":"Xã Thượng Hà, Huyện Bảo Lạc, Tỉnh Cao Bằng","code":"01327","parent_code":"043"},"01330":{"name":"Xã Cô Ba","type":"xa","slug":"xa-co-ba","name_with_type":"Xã Cô Ba","path":"Xã Cô Ba, Huyện Bảo Lạc, Tỉnh Cao Bằng","path_with_type":"Xã Cô Ba, Huyện Bảo Lạc, Tỉnh Cao Bằng","code":"01330","parent_code":"043"},"01333":{"name":"Xã Bảo Toàn","type":"xa","slug":"xa-bao-toan","name_with_type":"Xã Bảo Toàn","path":"Xã Bảo Toàn, Huyện Bảo Lạc, Tỉnh Cao Bằng","path_with_type":"Xã Bảo Toàn, Huyện Bảo Lạc, Tỉnh Cao Bằng","code":"01333","parent_code":"043"},"01336":{"name":"Xã Khánh Xuân","type":"xa","slug":"xa-khanh-xuan","name_with_type":"Xã Khánh Xuân","path":"Xã Khánh Xuân, Huyện Bảo Lạc, Tỉnh Cao Bằng","path_with_type":"Xã Khánh Xuân, Huyện Bảo Lạc, Tỉnh Cao Bằng","code":"01336","parent_code":"043"},"01339":{"name":"Xã Xuân Trường","type":"xa","slug":"xa-xuan-truong","name_with_type":"Xã Xuân Trường","path":"Xã Xuân Trường, Huyện Bảo Lạc, Tỉnh Cao Bằng","path_with_type":"Xã Xuân Trường, Huyện Bảo Lạc, Tỉnh Cao Bằng","code":"01339","parent_code":"043"},"01342":{"name":"Xã Hồng Trị","type":"xa","slug":"xa-hong-tri","name_with_type":"Xã Hồng Trị","path":"Xã Hồng Trị, Huyện Bảo Lạc, Tỉnh Cao Bằng","path_with_type":"Xã Hồng Trị, Huyện Bảo Lạc, Tỉnh Cao Bằng","code":"01342","parent_code":"043"},"01343":{"name":"Xã Kim Cúc","type":"xa","slug":"xa-kim-cuc","name_with_type":"Xã Kim Cúc","path":"Xã Kim Cúc, Huyện Bảo Lạc, Tỉnh Cao Bằng","path_with_type":"Xã Kim Cúc, Huyện Bảo Lạc, Tỉnh Cao Bằng","code":"01343","parent_code":"043"},"01345":{"name":"Xã Phan Thanh","type":"xa","slug":"xa-phan-thanh","name_with_type":"Xã Phan Thanh","path":"Xã Phan Thanh, Huyện Bảo Lạc, Tỉnh Cao Bằng","path_with_type":"Xã Phan Thanh, Huyện Bảo Lạc, Tỉnh Cao Bằng","code":"01345","parent_code":"043"},"01348":{"name":"Xã Hồng An","type":"xa","slug":"xa-hong-an","name_with_type":"Xã Hồng An","path":"Xã Hồng An, Huyện Bảo Lạc, Tỉnh Cao Bằng","path_with_type":"Xã Hồng An, Huyện Bảo Lạc, Tỉnh Cao Bằng","code":"01348","parent_code":"043"},"01351":{"name":"Xã Hưng Đạo","type":"xa","slug":"xa-hung-dao","name_with_type":"Xã Hưng Đạo","path":"Xã Hưng Đạo, Huyện Bảo Lạc, Tỉnh Cao Bằng","path_with_type":"Xã Hưng Đạo, Huyện Bảo Lạc, Tỉnh Cao Bằng","code":"01351","parent_code":"043"},"01352":{"name":"Xã Hưng Thịnh","type":"xa","slug":"xa-hung-thinh","name_with_type":"Xã Hưng Thịnh","path":"Xã Hưng Thịnh, Huyện Bảo Lạc, Tỉnh Cao Bằng","path_with_type":"Xã Hưng Thịnh, Huyện Bảo Lạc, Tỉnh Cao Bằng","code":"01352","parent_code":"043"},"01354":{"name":"Xã Huy Giáp","type":"xa","slug":"xa-huy-giap","name_with_type":"Xã Huy Giáp","path":"Xã Huy Giáp, Huyện Bảo Lạc, Tỉnh Cao Bằng","path_with_type":"Xã Huy Giáp, Huyện Bảo Lạc, Tỉnh Cao Bằng","code":"01354","parent_code":"043"},"01357":{"name":"Xã Đình Phùng","type":"xa","slug":"xa-dinh-phung","name_with_type":"Xã Đình Phùng","path":"Xã Đình Phùng, Huyện Bảo Lạc, Tỉnh Cao Bằng","path_with_type":"Xã Đình Phùng, Huyện Bảo Lạc, Tỉnh Cao Bằng","code":"01357","parent_code":"043"},"01359":{"name":"Xã Sơn Lập","type":"xa","slug":"xa-son-lap","name_with_type":"Xã Sơn Lập","path":"Xã Sơn Lập, Huyện Bảo Lạc, Tỉnh Cao Bằng","path_with_type":"Xã Sơn Lập, Huyện Bảo Lạc, Tỉnh Cao Bằng","code":"01359","parent_code":"043"},"01360":{"name":"Xã Sơn Lộ","type":"xa","slug":"xa-son-lo","name_with_type":"Xã Sơn Lộ","path":"Xã Sơn Lộ, Huyện Bảo Lạc, Tỉnh Cao Bằng","path_with_type":"Xã Sơn Lộ, Huyện Bảo Lạc, Tỉnh Cao Bằng","code":"01360","parent_code":"043"},"01363":{"name":"Thị trấn Thông Nông","type":"thi-tran","slug":"thi-tran-thong-nong","name_with_type":"Thị trấn Thông Nông","path":"Thị trấn Thông Nông, Huyện Hà Quảng, Tỉnh Cao Bằng","path_with_type":"Thị trấn Thông Nông, Huyện Hà Quảng, Tỉnh Cao Bằng","code":"01363","parent_code":"045"},"01366":{"name":"Xã Cần Yên","type":"xa","slug":"xa-can-yen","name_with_type":"Xã Cần Yên","path":"Xã Cần Yên, Huyện Hà Quảng, Tỉnh Cao Bằng","path_with_type":"Xã Cần Yên, Huyện Hà Quảng, Tỉnh Cao Bằng","code":"01366","parent_code":"045"},"01367":{"name":"Xã Cần Nông","type":"xa","slug":"xa-can-nong","name_with_type":"Xã Cần Nông","path":"Xã Cần Nông, Huyện Hà Quảng, Tỉnh Cao Bằng","path_with_type":"Xã Cần Nông, Huyện Hà Quảng, Tỉnh Cao Bằng","code":"01367","parent_code":"045"},"01372":{"name":"Xã Lương Thông","type":"xa","slug":"xa-luong-thong","name_with_type":"Xã Lương Thông","path":"Xã Lương Thông, Huyện Hà Quảng, Tỉnh Cao Bằng","path_with_type":"Xã Lương Thông, Huyện Hà Quảng, Tỉnh Cao Bằng","code":"01372","parent_code":"045"},"01375":{"name":"Xã Đa Thông","type":"xa","slug":"xa-da-thong","name_with_type":"Xã Đa Thông","path":"Xã Đa Thông, Huyện Hà Quảng, Tỉnh Cao Bằng","path_with_type":"Xã Đa Thông, Huyện Hà Quảng, Tỉnh Cao Bằng","code":"01375","parent_code":"045"},"01378":{"name":"Xã Ngọc Động","type":"xa","slug":"xa-ngoc-dong","name_with_type":"Xã Ngọc Động","path":"Xã Ngọc Động, Huyện Hà Quảng, Tỉnh Cao Bằng","path_with_type":"Xã Ngọc Động, Huyện Hà Quảng, Tỉnh Cao Bằng","code":"01378","parent_code":"045"},"01381":{"name":"Xã Yên Sơn","type":"xa","slug":"xa-yen-son","name_with_type":"Xã Yên Sơn","path":"Xã Yên Sơn, Huyện Hà Quảng, Tỉnh Cao Bằng","path_with_type":"Xã Yên Sơn, Huyện Hà Quảng, Tỉnh Cao Bằng","code":"01381","parent_code":"045"},"01384":{"name":"Xã Lương Can","type":"xa","slug":"xa-luong-can","name_with_type":"Xã Lương Can","path":"Xã Lương Can, Huyện Hà Quảng, Tỉnh Cao Bằng","path_with_type":"Xã Lương Can, Huyện Hà Quảng, Tỉnh Cao Bằng","code":"01384","parent_code":"045"},"01387":{"name":"Xã Thanh Long","type":"xa","slug":"xa-thanh-long","name_with_type":"Xã Thanh Long","path":"Xã Thanh Long, Huyện Hà Quảng, Tỉnh Cao Bằng","path_with_type":"Xã Thanh Long, Huyện Hà Quảng, Tỉnh Cao Bằng","code":"01387","parent_code":"045"},"01392":{"name":"Thị trấn Xuân Hòa","type":"thi-tran","slug":"thi-tran-xuan-hoa","name_with_type":"Thị trấn Xuân Hòa","path":"Thị trấn Xuân Hòa, Huyện Hà Quảng, Tỉnh Cao Bằng","path_with_type":"Thị trấn Xuân Hòa, Huyện Hà Quảng, Tỉnh Cao Bằng","code":"01392","parent_code":"045"},"01393":{"name":"Xã Lũng Nặm","type":"xa","slug":"xa-lung-nam","name_with_type":"Xã Lũng Nặm","path":"Xã Lũng Nặm, Huyện Hà Quảng, Tỉnh Cao Bằng","path_with_type":"Xã Lũng Nặm, Huyện Hà Quảng, Tỉnh Cao Bằng","code":"01393","parent_code":"045"},"01399":{"name":"Xã Trường Hà","type":"xa","slug":"xa-truong-ha","name_with_type":"Xã Trường Hà","path":"Xã Trường Hà, Huyện Hà Quảng, Tỉnh Cao Bằng","path_with_type":"Xã Trường Hà, Huyện Hà Quảng, Tỉnh Cao Bằng","code":"01399","parent_code":"045"},"01402":{"name":"Xã Cải Viên","type":"xa","slug":"xa-cai-vien","name_with_type":"Xã Cải Viên","path":"Xã Cải Viên, Huyện Hà Quảng, Tỉnh Cao Bằng","path_with_type":"Xã Cải Viên, Huyện Hà Quảng, Tỉnh Cao Bằng","code":"01402","parent_code":"045"},"01411":{"name":"Xã Nội Thôn","type":"xa","slug":"xa-noi-thon","name_with_type":"Xã Nội Thôn","path":"Xã Nội Thôn, Huyện Hà Quảng, Tỉnh Cao Bằng","path_with_type":"Xã Nội Thôn, Huyện Hà Quảng, Tỉnh Cao Bằng","code":"01411","parent_code":"045"},"01414":{"name":"Xã Tổng Cọt","type":"xa","slug":"xa-tong-cot","name_with_type":"Xã Tổng Cọt","path":"Xã Tổng Cọt, Huyện Hà Quảng, Tỉnh Cao Bằng","path_with_type":"Xã Tổng Cọt, Huyện Hà Quảng, Tỉnh Cao Bằng","code":"01414","parent_code":"045"},"01417":{"name":"Xã Sóc Hà","type":"xa","slug":"xa-soc-ha","name_with_type":"Xã Sóc Hà","path":"Xã Sóc Hà, Huyện Hà Quảng, Tỉnh Cao Bằng","path_with_type":"Xã Sóc Hà, Huyện Hà Quảng, Tỉnh Cao Bằng","code":"01417","parent_code":"045"},"01420":{"name":"Xã Thượng Thôn","type":"xa","slug":"xa-thuong-thon","name_with_type":"Xã Thượng Thôn","path":"Xã Thượng Thôn, Huyện Hà Quảng, Tỉnh Cao Bằng","path_with_type":"Xã Thượng Thôn, Huyện Hà Quảng, Tỉnh Cao Bằng","code":"01420","parent_code":"045"},"01429":{"name":"Xã Hồng Sỹ","type":"xa","slug":"xa-hong-sy","name_with_type":"Xã Hồng Sỹ","path":"Xã Hồng Sỹ, Huyện Hà Quảng, Tỉnh Cao Bằng","path_with_type":"Xã Hồng Sỹ, Huyện Hà Quảng, Tỉnh Cao Bằng","code":"01429","parent_code":"045"},"01432":{"name":"Xã Quý Quân","type":"xa","slug":"xa-quy-quan","name_with_type":"Xã Quý Quân","path":"Xã Quý Quân, Huyện Hà Quảng, Tỉnh Cao Bằng","path_with_type":"Xã Quý Quân, Huyện Hà Quảng, Tỉnh Cao Bằng","code":"01432","parent_code":"045"},"01435":{"name":"Xã Mã Ba","type":"xa","slug":"xa-ma-ba","name_with_type":"Xã Mã Ba","path":"Xã Mã Ba, Huyện Hà Quảng, Tỉnh Cao Bằng","path_with_type":"Xã Mã Ba, Huyện Hà Quảng, Tỉnh Cao Bằng","code":"01435","parent_code":"045"},"01438":{"name":"Xã Ngọc Đào","type":"xa","slug":"xa-ngoc-dao","name_with_type":"Xã Ngọc Đào","path":"Xã Ngọc Đào, Huyện Hà Quảng, Tỉnh Cao Bằng","path_with_type":"Xã Ngọc Đào, Huyện Hà Quảng, Tỉnh Cao Bằng","code":"01438","parent_code":"045"},"01447":{"name":"Thị trấn Trà Lĩnh","type":"thi-tran","slug":"thi-tran-tra-linh","name_with_type":"Thị trấn Trà Lĩnh","path":"Thị trấn Trà Lĩnh, Huyện Trùng Khánh, Tỉnh Cao Bằng","path_with_type":"Thị trấn Trà Lĩnh, Huyện Trùng Khánh, Tỉnh Cao Bằng","code":"01447","parent_code":"047"},"01453":{"name":"Xã Tri Phương","type":"xa","slug":"xa-tri-phuong","name_with_type":"Xã Tri Phương","path":"Xã Tri Phương, Huyện Trùng Khánh, Tỉnh Cao Bằng","path_with_type":"Xã Tri Phương, Huyện Trùng Khánh, Tỉnh Cao Bằng","code":"01453","parent_code":"047"},"01456":{"name":"Xã Quang Hán","type":"xa","slug":"xa-quang-han","name_with_type":"Xã Quang Hán","path":"Xã Quang Hán, Huyện Trùng Khánh, Tỉnh Cao Bằng","path_with_type":"Xã Quang Hán, Huyện Trùng Khánh, Tỉnh Cao Bằng","code":"01456","parent_code":"047"},"01462":{"name":"Xã Xuân Nội","type":"xa","slug":"xa-xuan-noi","name_with_type":"Xã Xuân Nội","path":"Xã Xuân Nội, Huyện Trùng Khánh, Tỉnh Cao Bằng","path_with_type":"Xã Xuân Nội, Huyện Trùng Khánh, Tỉnh Cao Bằng","code":"01462","parent_code":"047"},"01465":{"name":"Xã Quang Trung","type":"xa","slug":"xa-quang-trung","name_with_type":"Xã Quang Trung","path":"Xã Quang Trung, Huyện Trùng Khánh, Tỉnh Cao Bằng","path_with_type":"Xã Quang Trung, Huyện Trùng Khánh, Tỉnh Cao Bằng","code":"01465","parent_code":"047"},"01468":{"name":"Xã Quang Vinh","type":"xa","slug":"xa-quang-vinh","name_with_type":"Xã Quang Vinh","path":"Xã Quang Vinh, Huyện Trùng Khánh, Tỉnh Cao Bằng","path_with_type":"Xã Quang Vinh, Huyện Trùng Khánh, Tỉnh Cao Bằng","code":"01468","parent_code":"047"},"01471":{"name":"Xã Cao Chương","type":"xa","slug":"xa-cao-chuong","name_with_type":"Xã Cao Chương","path":"Xã Cao Chương, Huyện Trùng Khánh, Tỉnh Cao Bằng","path_with_type":"Xã Cao Chương, Huyện Trùng Khánh, Tỉnh Cao Bằng","code":"01471","parent_code":"047"},"01477":{"name":"Thị trấn Trùng Khánh","type":"thi-tran","slug":"thi-tran-trung-khanh","name_with_type":"Thị trấn Trùng Khánh","path":"Thị trấn Trùng Khánh, Huyện Trùng Khánh, Tỉnh Cao Bằng","path_with_type":"Thị trấn Trùng Khánh, Huyện Trùng Khánh, Tỉnh Cao Bằng","code":"01477","parent_code":"047"},"01480":{"name":"Xã Ngọc Khê","type":"xa","slug":"xa-ngoc-khe","name_with_type":"Xã Ngọc Khê","path":"Xã Ngọc Khê, Huyện Trùng Khánh, Tỉnh Cao Bằng","path_with_type":"Xã Ngọc Khê, Huyện Trùng Khánh, Tỉnh Cao Bằng","code":"01480","parent_code":"047"},"01481":{"name":"Xã Ngọc Côn","type":"xa","slug":"xa-ngoc-con","name_with_type":"Xã Ngọc Côn","path":"Xã Ngọc Côn, Huyện Trùng Khánh, Tỉnh Cao Bằng","path_with_type":"Xã Ngọc Côn, Huyện Trùng Khánh, Tỉnh Cao Bằng","code":"01481","parent_code":"047"},"01483":{"name":"Xã Phong Nậm","type":"xa","slug":"xa-phong-nam","name_with_type":"Xã Phong Nậm","path":"Xã Phong Nậm, Huyện Trùng Khánh, Tỉnh Cao Bằng","path_with_type":"Xã Phong Nậm, Huyện Trùng Khánh, Tỉnh Cao Bằng","code":"01483","parent_code":"047"},"01489":{"name":"Xã Đình Phong","type":"xa","slug":"xa-dinh-phong","name_with_type":"Xã Đình Phong","path":"Xã Đình Phong, Huyện Trùng Khánh, Tỉnh Cao Bằng","path_with_type":"Xã Đình Phong, Huyện Trùng Khánh, Tỉnh Cao Bằng","code":"01489","parent_code":"047"},"01495":{"name":"Xã Đàm Thuỷ","type":"xa","slug":"xa-dam-thuy","name_with_type":"Xã Đàm Thuỷ","path":"Xã Đàm Thuỷ, Huyện Trùng Khánh, Tỉnh Cao Bằng","path_with_type":"Xã Đàm Thuỷ, Huyện Trùng Khánh, Tỉnh Cao Bằng","code":"01495","parent_code":"047"},"01498":{"name":"Xã Khâm Thành","type":"xa","slug":"xa-kham-thanh","name_with_type":"Xã Khâm Thành","path":"Xã Khâm Thành, Huyện Trùng Khánh, Tỉnh Cao Bằng","path_with_type":"Xã Khâm Thành, Huyện Trùng Khánh, Tỉnh Cao Bằng","code":"01498","parent_code":"047"},"01501":{"name":"Xã Chí Viễn","type":"xa","slug":"xa-chi-vien","name_with_type":"Xã Chí Viễn","path":"Xã Chí Viễn, Huyện Trùng Khánh, Tỉnh Cao Bằng","path_with_type":"Xã Chí Viễn, Huyện Trùng Khánh, Tỉnh Cao Bằng","code":"01501","parent_code":"047"},"01504":{"name":"Xã Lăng Hiếu","type":"xa","slug":"xa-lang-hieu","name_with_type":"Xã Lăng Hiếu","path":"Xã Lăng Hiếu, Huyện Trùng Khánh, Tỉnh Cao Bằng","path_with_type":"Xã Lăng Hiếu, Huyện Trùng Khánh, Tỉnh Cao Bằng","code":"01504","parent_code":"047"},"01507":{"name":"Xã Phong Châu","type":"xa","slug":"xa-phong-chau","name_with_type":"Xã Phong Châu","path":"Xã Phong Châu, Huyện Trùng Khánh, Tỉnh Cao Bằng","path_with_type":"Xã Phong Châu, Huyện Trùng Khánh, Tỉnh Cao Bằng","code":"01507","parent_code":"047"},"01516":{"name":"Xã Trung Phúc","type":"xa","slug":"xa-trung-phuc","name_with_type":"Xã Trung Phúc","path":"Xã Trung Phúc, Huyện Trùng Khánh, Tỉnh Cao Bằng","path_with_type":"Xã Trung Phúc, Huyện Trùng Khánh, Tỉnh Cao Bằng","code":"01516","parent_code":"047"},"01519":{"name":"Xã Cao Thăng","type":"xa","slug":"xa-cao-thang","name_with_type":"Xã Cao Thăng","path":"Xã Cao Thăng, Huyện Trùng Khánh, Tỉnh Cao Bằng","path_with_type":"Xã Cao Thăng, Huyện Trùng Khánh, Tỉnh Cao Bằng","code":"01519","parent_code":"047"},"01522":{"name":"Xã Đức Hồng","type":"xa","slug":"xa-duc-hong","name_with_type":"Xã Đức Hồng","path":"Xã Đức Hồng, Huyện Trùng Khánh, Tỉnh Cao Bằng","path_with_type":"Xã Đức Hồng, Huyện Trùng Khánh, Tỉnh Cao Bằng","code":"01522","parent_code":"047"},"01525":{"name":"Xã Đoài Dương","type":"xa","slug":"xa-doai-duong","name_with_type":"Xã Đoài Dương","path":"Xã Đoài Dương, Huyện Trùng Khánh, Tỉnh Cao Bằng","path_with_type":"Xã Đoài Dương, Huyện Trùng Khánh, Tỉnh Cao Bằng","code":"01525","parent_code":"047"},"01534":{"name":"Xã Minh Long","type":"xa","slug":"xa-minh-long","name_with_type":"Xã Minh Long","path":"Xã Minh Long, Huyện Hạ Lang, Tỉnh Cao Bằng","path_with_type":"Xã Minh Long, Huyện Hạ Lang, Tỉnh Cao Bằng","code":"01534","parent_code":"048"},"01537":{"name":"Xã Lý Quốc","type":"xa","slug":"xa-ly-quoc","name_with_type":"Xã Lý Quốc","path":"Xã Lý Quốc, Huyện Hạ Lang, Tỉnh Cao Bằng","path_with_type":"Xã Lý Quốc, Huyện Hạ Lang, Tỉnh Cao Bằng","code":"01537","parent_code":"048"},"01540":{"name":"Xã Thắng Lợi","type":"xa","slug":"xa-thang-loi","name_with_type":"Xã Thắng Lợi","path":"Xã Thắng Lợi, Huyện Hạ Lang, Tỉnh Cao Bằng","path_with_type":"Xã Thắng Lợi, Huyện Hạ Lang, Tỉnh Cao Bằng","code":"01540","parent_code":"048"},"01543":{"name":"Xã Đồng Loan","type":"xa","slug":"xa-dong-loan","name_with_type":"Xã Đồng Loan","path":"Xã Đồng Loan, Huyện Hạ Lang, Tỉnh Cao Bằng","path_with_type":"Xã Đồng Loan, Huyện Hạ Lang, Tỉnh Cao Bằng","code":"01543","parent_code":"048"},"01546":{"name":"Xã Đức Quang","type":"xa","slug":"xa-duc-quang","name_with_type":"Xã Đức Quang","path":"Xã Đức Quang, Huyện Hạ Lang, Tỉnh Cao Bằng","path_with_type":"Xã Đức Quang, Huyện Hạ Lang, Tỉnh Cao Bằng","code":"01546","parent_code":"048"},"01549":{"name":"Xã Kim Loan","type":"xa","slug":"xa-kim-loan","name_with_type":"Xã Kim Loan","path":"Xã Kim Loan, Huyện Hạ Lang, Tỉnh Cao Bằng","path_with_type":"Xã Kim Loan, Huyện Hạ Lang, Tỉnh Cao Bằng","code":"01549","parent_code":"048"},"01552":{"name":"Xã Quang Long","type":"xa","slug":"xa-quang-long","name_with_type":"Xã Quang Long","path":"Xã Quang Long, Huyện Hạ Lang, Tỉnh Cao Bằng","path_with_type":"Xã Quang Long, Huyện Hạ Lang, Tỉnh Cao Bằng","code":"01552","parent_code":"048"},"01555":{"name":"Xã An Lạc","type":"xa","slug":"xa-an-lac","name_with_type":"Xã An Lạc","path":"Xã An Lạc, Huyện Hạ Lang, Tỉnh Cao Bằng","path_with_type":"Xã An Lạc, Huyện Hạ Lang, Tỉnh Cao Bằng","code":"01555","parent_code":"048"},"01558":{"name":"Thị trấn Thanh Nhật","type":"thi-tran","slug":"thi-tran-thanh-nhat","name_with_type":"Thị trấn Thanh Nhật","path":"Thị trấn Thanh Nhật, Huyện Hạ Lang, Tỉnh Cao Bằng","path_with_type":"Thị trấn Thanh Nhật, Huyện Hạ Lang, Tỉnh Cao Bằng","code":"01558","parent_code":"048"},"01561":{"name":"Xã Vinh Quý","type":"xa","slug":"xa-vinh-quy","name_with_type":"Xã Vinh Quý","path":"Xã Vinh Quý, Huyện Hạ Lang, Tỉnh Cao Bằng","path_with_type":"Xã Vinh Quý, Huyện Hạ Lang, Tỉnh Cao Bằng","code":"01561","parent_code":"048"},"01564":{"name":"Xã Thống Nhất","type":"xa","slug":"xa-thong-nhat","name_with_type":"Xã Thống Nhất","path":"Xã Thống Nhất, Huyện Hạ Lang, Tỉnh Cao Bằng","path_with_type":"Xã Thống Nhất, Huyện Hạ Lang, Tỉnh Cao Bằng","code":"01564","parent_code":"048"},"01567":{"name":"Xã Cô Ngân","type":"xa","slug":"xa-co-ngan","name_with_type":"Xã Cô Ngân","path":"Xã Cô Ngân, Huyện Hạ Lang, Tỉnh Cao Bằng","path_with_type":"Xã Cô Ngân, Huyện Hạ Lang, Tỉnh Cao Bằng","code":"01567","parent_code":"048"},"01573":{"name":"Xã Thị Hoa","type":"xa","slug":"xa-thi-hoa","name_with_type":"Xã Thị Hoa","path":"Xã Thị Hoa, Huyện Hạ Lang, Tỉnh Cao Bằng","path_with_type":"Xã Thị Hoa, Huyện Hạ Lang, Tỉnh Cao Bằng","code":"01573","parent_code":"048"},"01474":{"name":"Xã Quốc Toản","type":"xa","slug":"xa-quoc-toan","name_with_type":"Xã Quốc Toản","path":"Xã Quốc Toản, Huyện Quảng Hòa, Tỉnh Cao Bằng","path_with_type":"Xã Quốc Toản, Huyện Quảng Hòa, Tỉnh Cao Bằng","code":"01474","parent_code":"049"},"01576":{"name":"Thị trấn Quảng Uyên","type":"thi-tran","slug":"thi-tran-quang-uyen","name_with_type":"Thị trấn Quảng Uyên","path":"Thị trấn Quảng Uyên, Huyện Quảng Hòa, Tỉnh Cao Bằng","path_with_type":"Thị trấn Quảng Uyên, Huyện Quảng Hòa, Tỉnh Cao Bằng","code":"01576","parent_code":"049"},"01579":{"name":"Xã Phi Hải","type":"xa","slug":"xa-phi-hai","name_with_type":"Xã Phi Hải","path":"Xã Phi Hải, Huyện Quảng Hòa, Tỉnh Cao Bằng","path_with_type":"Xã Phi Hải, Huyện Quảng Hòa, Tỉnh Cao Bằng","code":"01579","parent_code":"049"},"01582":{"name":"Xã Quảng Hưng","type":"xa","slug":"xa-quang-hung","name_with_type":"Xã Quảng Hưng","path":"Xã Quảng Hưng, Huyện Quảng Hòa, Tỉnh Cao Bằng","path_with_type":"Xã Quảng Hưng, Huyện Quảng Hòa, Tỉnh Cao Bằng","code":"01582","parent_code":"049"},"01594":{"name":"Xã Độc Lập","type":"xa","slug":"xa-doc-lap","name_with_type":"Xã Độc Lập","path":"Xã Độc Lập, Huyện Quảng Hòa, Tỉnh Cao Bằng","path_with_type":"Xã Độc Lập, Huyện Quảng Hòa, Tỉnh Cao Bằng","code":"01594","parent_code":"049"},"01597":{"name":"Xã Cai Bộ","type":"xa","slug":"xa-cai-bo","name_with_type":"Xã Cai Bộ","path":"Xã Cai Bộ, Huyện Quảng Hòa, Tỉnh Cao Bằng","path_with_type":"Xã Cai Bộ, Huyện Quảng Hòa, Tỉnh Cao Bằng","code":"01597","parent_code":"049"},"01603":{"name":"Xã Phúc Sen","type":"xa","slug":"xa-phuc-sen","name_with_type":"Xã Phúc Sen","path":"Xã Phúc Sen, Huyện Quảng Hòa, Tỉnh Cao Bằng","path_with_type":"Xã Phúc Sen, Huyện Quảng Hòa, Tỉnh Cao Bằng","code":"01603","parent_code":"049"},"01606":{"name":"Xã Chí Thảo","type":"xa","slug":"xa-chi-thao","name_with_type":"Xã Chí Thảo","path":"Xã Chí Thảo, Huyện Quảng Hòa, Tỉnh Cao Bằng","path_with_type":"Xã Chí Thảo, Huyện Quảng Hòa, Tỉnh Cao Bằng","code":"01606","parent_code":"049"},"01609":{"name":"Xã Tự Do","type":"xa","slug":"xa-tu-do","name_with_type":"Xã Tự Do","path":"Xã Tự Do, Huyện Quảng Hòa, Tỉnh Cao Bằng","path_with_type":"Xã Tự Do, Huyện Quảng Hòa, Tỉnh Cao Bằng","code":"01609","parent_code":"049"},"01615":{"name":"Xã Hồng Quang","type":"xa","slug":"xa-hong-quang","name_with_type":"Xã Hồng Quang","path":"Xã Hồng Quang, Huyện Quảng Hòa, Tỉnh Cao Bằng","path_with_type":"Xã Hồng Quang, Huyện Quảng Hòa, Tỉnh Cao Bằng","code":"01615","parent_code":"049"},"01618":{"name":"Xã Ngọc Động","type":"xa","slug":"xa-ngoc-dong","name_with_type":"Xã Ngọc Động","path":"Xã Ngọc Động, Huyện Quảng Hòa, Tỉnh Cao Bằng","path_with_type":"Xã Ngọc Động, Huyện Quảng Hòa, Tỉnh Cao Bằng","code":"01618","parent_code":"049"},"01624":{"name":"Xã Hạnh Phúc","type":"xa","slug":"xa-hanh-phuc","name_with_type":"Xã Hạnh Phúc","path":"Xã Hạnh Phúc, Huyện Quảng Hòa, Tỉnh Cao Bằng","path_with_type":"Xã Hạnh Phúc, Huyện Quảng Hòa, Tỉnh Cao Bằng","code":"01624","parent_code":"049"},"01627":{"name":"Thị trấn Tà Lùng","type":"thi-tran","slug":"thi-tran-ta-lung","name_with_type":"Thị trấn Tà Lùng","path":"Thị trấn Tà Lùng, Huyện Quảng Hòa, Tỉnh Cao Bằng","path_with_type":"Thị trấn Tà Lùng, Huyện Quảng Hòa, Tỉnh Cao Bằng","code":"01627","parent_code":"049"},"01630":{"name":"Xã Bế Văn Đàn","type":"xa","slug":"xa-be-van-dan","name_with_type":"Xã Bế Văn Đàn","path":"Xã Bế Văn Đàn, Huyện Quảng Hòa, Tỉnh Cao Bằng","path_with_type":"Xã Bế Văn Đàn, Huyện Quảng Hòa, Tỉnh Cao Bằng","code":"01630","parent_code":"049"},"01636":{"name":"Xã Cách Linh","type":"xa","slug":"xa-cach-linh","name_with_type":"Xã Cách Linh","path":"Xã Cách Linh, Huyện Quảng Hòa, Tỉnh Cao Bằng","path_with_type":"Xã Cách Linh, Huyện Quảng Hòa, Tỉnh Cao Bằng","code":"01636","parent_code":"049"},"01639":{"name":"Xã Đại Sơn","type":"xa","slug":"xa-dai-son","name_with_type":"Xã Đại Sơn","path":"Xã Đại Sơn, Huyện Quảng Hòa, Tỉnh Cao Bằng","path_with_type":"Xã Đại Sơn, Huyện Quảng Hòa, Tỉnh Cao Bằng","code":"01639","parent_code":"049"},"01645":{"name":"Xã Tiên Thành","type":"xa","slug":"xa-tien-thanh","name_with_type":"Xã Tiên Thành","path":"Xã Tiên Thành, Huyện Quảng Hòa, Tỉnh Cao Bằng","path_with_type":"Xã Tiên Thành, Huyện Quảng Hòa, Tỉnh Cao Bằng","code":"01645","parent_code":"049"},"01648":{"name":"Thị trấn Hoà Thuận","type":"thi-tran","slug":"thi-tran-hoa-thuan","name_with_type":"Thị trấn Hoà Thuận","path":"Thị trấn Hoà Thuận, Huyện Quảng Hòa, Tỉnh Cao Bằng","path_with_type":"Thị trấn Hoà Thuận, Huyện Quảng Hòa, Tỉnh Cao Bằng","code":"01648","parent_code":"049"},"01651":{"name":"Xã Mỹ Hưng","type":"xa","slug":"xa-my-hung","name_with_type":"Xã Mỹ Hưng","path":"Xã Mỹ Hưng, Huyện Quảng Hòa, Tỉnh Cao Bằng","path_with_type":"Xã Mỹ Hưng, Huyện Quảng Hòa, Tỉnh Cao Bằng","code":"01651","parent_code":"049"},"01654":{"name":"Thị trấn Nước Hai","type":"thi-tran","slug":"thi-tran-nuoc-hai","name_with_type":"Thị trấn Nước Hai","path":"Thị trấn Nước Hai, Huyện Hoà An, Tỉnh Cao Bằng","path_with_type":"Thị trấn Nước Hai, Huyện Hoà An, Tỉnh Cao Bằng","code":"01654","parent_code":"051"},"01657":{"name":"Xã Dân Chủ","type":"xa","slug":"xa-dan-chu","name_with_type":"Xã Dân Chủ","path":"Xã Dân Chủ, Huyện Hoà An, Tỉnh Cao Bằng","path_with_type":"Xã Dân Chủ, Huyện Hoà An, Tỉnh Cao Bằng","code":"01657","parent_code":"051"},"01660":{"name":"Xã Nam Tuấn","type":"xa","slug":"xa-nam-tuan","name_with_type":"Xã Nam Tuấn","path":"Xã Nam Tuấn, Huyện Hoà An, Tỉnh Cao Bằng","path_with_type":"Xã Nam Tuấn, Huyện Hoà An, Tỉnh Cao Bằng","code":"01660","parent_code":"051"},"01666":{"name":"Xã Đại Tiến","type":"xa","slug":"xa-dai-tien","name_with_type":"Xã Đại Tiến","path":"Xã Đại Tiến, Huyện Hoà An, Tỉnh Cao Bằng","path_with_type":"Xã Đại Tiến, Huyện Hoà An, Tỉnh Cao Bằng","code":"01666","parent_code":"051"},"01669":{"name":"Xã Đức Long","type":"xa","slug":"xa-duc-long","name_with_type":"Xã Đức Long","path":"Xã Đức Long, Huyện Hoà An, Tỉnh Cao Bằng","path_with_type":"Xã Đức Long, Huyện Hoà An, Tỉnh Cao Bằng","code":"01669","parent_code":"051"},"01672":{"name":"Xã Ngũ Lão","type":"xa","slug":"xa-ngu-lao","name_with_type":"Xã Ngũ Lão","path":"Xã Ngũ Lão, Huyện Hoà An, Tỉnh Cao Bằng","path_with_type":"Xã Ngũ Lão, Huyện Hoà An, Tỉnh Cao Bằng","code":"01672","parent_code":"051"},"01675":{"name":"Xã Trương Lương","type":"xa","slug":"xa-truong-luong","name_with_type":"Xã Trương Lương","path":"Xã Trương Lương, Huyện Hoà An, Tỉnh Cao Bằng","path_with_type":"Xã Trương Lương, Huyện Hoà An, Tỉnh Cao Bằng","code":"01675","parent_code":"051"},"01687":{"name":"Xã Hồng Việt","type":"xa","slug":"xa-hong-viet","name_with_type":"Xã Hồng Việt","path":"Xã Hồng Việt, Huyện Hoà An, Tỉnh Cao Bằng","path_with_type":"Xã Hồng Việt, Huyện Hoà An, Tỉnh Cao Bằng","code":"01687","parent_code":"051"},"01696":{"name":"Xã Hoàng Tung","type":"xa","slug":"xa-hoang-tung","name_with_type":"Xã Hoàng Tung","path":"Xã Hoàng Tung, Huyện Hoà An, Tỉnh Cao Bằng","path_with_type":"Xã Hoàng Tung, Huyện Hoà An, Tỉnh Cao Bằng","code":"01696","parent_code":"051"},"01699":{"name":"Xã Nguyễn Huệ","type":"xa","slug":"xa-nguyen-hue","name_with_type":"Xã Nguyễn Huệ","path":"Xã Nguyễn Huệ, Huyện Hoà An, Tỉnh Cao Bằng","path_with_type":"Xã Nguyễn Huệ, Huyện Hoà An, Tỉnh Cao Bằng","code":"01699","parent_code":"051"},"01702":{"name":"Xã Quang Trung","type":"xa","slug":"xa-quang-trung","name_with_type":"Xã Quang Trung","path":"Xã Quang Trung, Huyện Hoà An, Tỉnh Cao Bằng","path_with_type":"Xã Quang Trung, Huyện Hoà An, Tỉnh Cao Bằng","code":"01702","parent_code":"051"},"01708":{"name":"Xã Bạch Đằng","type":"xa","slug":"xa-bach-dang","name_with_type":"Xã Bạch Đằng","path":"Xã Bạch Đằng, Huyện Hoà An, Tỉnh Cao Bằng","path_with_type":"Xã Bạch Đằng, Huyện Hoà An, Tỉnh Cao Bằng","code":"01708","parent_code":"051"},"01711":{"name":"Xã Bình Dương","type":"xa","slug":"xa-binh-duong","name_with_type":"Xã Bình Dương","path":"Xã Bình Dương, Huyện Hoà An, Tỉnh Cao Bằng","path_with_type":"Xã Bình Dương, Huyện Hoà An, Tỉnh Cao Bằng","code":"01711","parent_code":"051"},"01714":{"name":"Xã Lê Chung","type":"xa","slug":"xa-le-chung","name_with_type":"Xã Lê Chung","path":"Xã Lê Chung, Huyện Hoà An, Tỉnh Cao Bằng","path_with_type":"Xã Lê Chung, Huyện Hoà An, Tỉnh Cao Bằng","code":"01714","parent_code":"051"},"01723":{"name":"Xã Hồng Nam","type":"xa","slug":"xa-hong-nam","name_with_type":"Xã Hồng Nam","path":"Xã Hồng Nam, Huyện Hoà An, Tỉnh Cao Bằng","path_with_type":"Xã Hồng Nam, Huyện Hoà An, Tỉnh Cao Bằng","code":"01723","parent_code":"051"},"01726":{"name":"Thị trấn Nguyên Bình","type":"thi-tran","slug":"thi-tran-nguyen-binh","name_with_type":"Thị trấn Nguyên Bình","path":"Thị trấn Nguyên Bình, Huyện Nguyên Bình, Tỉnh Cao Bằng","path_with_type":"Thị trấn Nguyên Bình, Huyện Nguyên Bình, Tỉnh Cao Bằng","code":"01726","parent_code":"052"},"01729":{"name":"Thị trấn Tĩnh Túc","type":"thi-tran","slug":"thi-tran-tinh-tuc","name_with_type":"Thị trấn Tĩnh Túc","path":"Thị trấn Tĩnh Túc, Huyện Nguyên Bình, Tỉnh Cao Bằng","path_with_type":"Thị trấn Tĩnh Túc, Huyện Nguyên Bình, Tỉnh Cao Bằng","code":"01729","parent_code":"052"},"01732":{"name":"Xã Yên Lạc","type":"xa","slug":"xa-yen-lac","name_with_type":"Xã Yên Lạc","path":"Xã Yên Lạc, Huyện Nguyên Bình, Tỉnh Cao Bằng","path_with_type":"Xã Yên Lạc, Huyện Nguyên Bình, Tỉnh Cao Bằng","code":"01732","parent_code":"052"},"01735":{"name":"Xã Triệu Nguyên","type":"xa","slug":"xa-trieu-nguyen","name_with_type":"Xã Triệu Nguyên","path":"Xã Triệu Nguyên, Huyện Nguyên Bình, Tỉnh Cao Bằng","path_with_type":"Xã Triệu Nguyên, Huyện Nguyên Bình, Tỉnh Cao Bằng","code":"01735","parent_code":"052"},"01738":{"name":"Xã Ca Thành","type":"xa","slug":"xa-ca-thanh","name_with_type":"Xã Ca Thành","path":"Xã Ca Thành, Huyện Nguyên Bình, Tỉnh Cao Bằng","path_with_type":"Xã Ca Thành, Huyện Nguyên Bình, Tỉnh Cao Bằng","code":"01738","parent_code":"052"},"01744":{"name":"Xã Vũ Nông","type":"xa","slug":"xa-vu-nong","name_with_type":"Xã Vũ Nông","path":"Xã Vũ Nông, Huyện Nguyên Bình, Tỉnh Cao Bằng","path_with_type":"Xã Vũ Nông, Huyện Nguyên Bình, Tỉnh Cao Bằng","code":"01744","parent_code":"052"},"01747":{"name":"Xã Minh Tâm","type":"xa","slug":"xa-minh-tam","name_with_type":"Xã Minh Tâm","path":"Xã Minh Tâm, Huyện Nguyên Bình, Tỉnh Cao Bằng","path_with_type":"Xã Minh Tâm, Huyện Nguyên Bình, Tỉnh Cao Bằng","code":"01747","parent_code":"052"},"01750":{"name":"Xã Thể Dục","type":"xa","slug":"xa-the-duc","name_with_type":"Xã Thể Dục","path":"Xã Thể Dục, Huyện Nguyên Bình, Tỉnh Cao Bằng","path_with_type":"Xã Thể Dục, Huyện Nguyên Bình, Tỉnh Cao Bằng","code":"01750","parent_code":"052"},"01756":{"name":"Xã Mai Long","type":"xa","slug":"xa-mai-long","name_with_type":"Xã Mai Long","path":"Xã Mai Long, Huyện Nguyên Bình, Tỉnh Cao Bằng","path_with_type":"Xã Mai Long, Huyện Nguyên Bình, Tỉnh Cao Bằng","code":"01756","parent_code":"052"},"01762":{"name":"Xã Vũ Minh","type":"xa","slug":"xa-vu-minh","name_with_type":"Xã Vũ Minh","path":"Xã Vũ Minh, Huyện Nguyên Bình, Tỉnh Cao Bằng","path_with_type":"Xã Vũ Minh, Huyện Nguyên Bình, Tỉnh Cao Bằng","code":"01762","parent_code":"052"},"01765":{"name":"Xã Hoa Thám","type":"xa","slug":"xa-hoa-tham","name_with_type":"Xã Hoa Thám","path":"Xã Hoa Thám, Huyện Nguyên Bình, Tỉnh Cao Bằng","path_with_type":"Xã Hoa Thám, Huyện Nguyên Bình, Tỉnh Cao Bằng","code":"01765","parent_code":"052"},"01768":{"name":"Xã Phan Thanh","type":"xa","slug":"xa-phan-thanh","name_with_type":"Xã Phan Thanh","path":"Xã Phan Thanh, Huyện Nguyên Bình, Tỉnh Cao Bằng","path_with_type":"Xã Phan Thanh, Huyện Nguyên Bình, Tỉnh Cao Bằng","code":"01768","parent_code":"052"},"01771":{"name":"Xã Quang Thành","type":"xa","slug":"xa-quang-thanh","name_with_type":"Xã Quang Thành","path":"Xã Quang Thành, Huyện Nguyên Bình, Tỉnh Cao Bằng","path_with_type":"Xã Quang Thành, Huyện Nguyên Bình, Tỉnh Cao Bằng","code":"01771","parent_code":"052"},"01774":{"name":"Xã Tam Kim","type":"xa","slug":"xa-tam-kim","name_with_type":"Xã Tam Kim","path":"Xã Tam Kim, Huyện Nguyên Bình, Tỉnh Cao Bằng","path_with_type":"Xã Tam Kim, Huyện Nguyên Bình, Tỉnh Cao Bằng","code":"01774","parent_code":"052"},"01777":{"name":"Xã Thành Công","type":"xa","slug":"xa-thanh-cong","name_with_type":"Xã Thành Công","path":"Xã Thành Công, Huyện Nguyên Bình, Tỉnh Cao Bằng","path_with_type":"Xã Thành Công, Huyện Nguyên Bình, Tỉnh Cao Bằng","code":"01777","parent_code":"052"},"01780":{"name":"Xã Thịnh Vượng","type":"xa","slug":"xa-thinh-vuong","name_with_type":"Xã Thịnh Vượng","path":"Xã Thịnh Vượng, Huyện Nguyên Bình, Tỉnh Cao Bằng","path_with_type":"Xã Thịnh Vượng, Huyện Nguyên Bình, Tỉnh Cao Bằng","code":"01780","parent_code":"052"},"01783":{"name":"Xã Hưng Đạo","type":"xa","slug":"xa-hung-dao","name_with_type":"Xã Hưng Đạo","path":"Xã Hưng Đạo, Huyện Nguyên Bình, Tỉnh Cao Bằng","path_with_type":"Xã Hưng Đạo, Huyện Nguyên Bình, Tỉnh Cao Bằng","code":"01783","parent_code":"052"},"01786":{"name":"Thị trấn Đông Khê","type":"thi-tran","slug":"thi-tran-dong-khe","name_with_type":"Thị trấn Đông Khê","path":"Thị trấn Đông Khê, Huyện Thạch An, Tỉnh Cao Bằng","path_with_type":"Thị trấn Đông Khê, Huyện Thạch An, Tỉnh Cao Bằng","code":"01786","parent_code":"053"},"01789":{"name":"Xã Canh Tân","type":"xa","slug":"xa-canh-tan","name_with_type":"Xã Canh Tân","path":"Xã Canh Tân, Huyện Thạch An, Tỉnh Cao Bằng","path_with_type":"Xã Canh Tân, Huyện Thạch An, Tỉnh Cao Bằng","code":"01789","parent_code":"053"},"01792":{"name":"Xã Kim Đồng","type":"xa","slug":"xa-kim-dong","name_with_type":"Xã Kim Đồng","path":"Xã Kim Đồng, Huyện Thạch An, Tỉnh Cao Bằng","path_with_type":"Xã Kim Đồng, Huyện Thạch An, Tỉnh Cao Bằng","code":"01792","parent_code":"053"},"01795":{"name":"Xã Minh Khai","type":"xa","slug":"xa-minh-khai","name_with_type":"Xã Minh Khai","path":"Xã Minh Khai, Huyện Thạch An, Tỉnh Cao Bằng","path_with_type":"Xã Minh Khai, Huyện Thạch An, Tỉnh Cao Bằng","code":"01795","parent_code":"053"},"01801":{"name":"Xã Đức Thông","type":"xa","slug":"xa-duc-thong","name_with_type":"Xã Đức Thông","path":"Xã Đức Thông, Huyện Thạch An, Tỉnh Cao Bằng","path_with_type":"Xã Đức Thông, Huyện Thạch An, Tỉnh Cao Bằng","code":"01801","parent_code":"053"},"01804":{"name":"Xã Thái Cường","type":"xa","slug":"xa-thai-cuong","name_with_type":"Xã Thái Cường","path":"Xã Thái Cường, Huyện Thạch An, Tỉnh Cao Bằng","path_with_type":"Xã Thái Cường, Huyện Thạch An, Tỉnh Cao Bằng","code":"01804","parent_code":"053"},"01807":{"name":"Xã Vân Trình","type":"xa","slug":"xa-van-trinh","name_with_type":"Xã Vân Trình","path":"Xã Vân Trình, Huyện Thạch An, Tỉnh Cao Bằng","path_with_type":"Xã Vân Trình, Huyện Thạch An, Tỉnh Cao Bằng","code":"01807","parent_code":"053"},"01810":{"name":"Xã Thụy Hùng","type":"xa","slug":"xa-thuy-hung","name_with_type":"Xã Thụy Hùng","path":"Xã Thụy Hùng, Huyện Thạch An, Tỉnh Cao Bằng","path_with_type":"Xã Thụy Hùng, Huyện Thạch An, Tỉnh Cao Bằng","code":"01810","parent_code":"053"},"01813":{"name":"Xã Quang Trọng","type":"xa","slug":"xa-quang-trong","name_with_type":"Xã Quang Trọng","path":"Xã Quang Trọng, Huyện Thạch An, Tỉnh Cao Bằng","path_with_type":"Xã Quang Trọng, Huyện Thạch An, Tỉnh Cao Bằng","code":"01813","parent_code":"053"},"01816":{"name":"Xã Trọng Con","type":"xa","slug":"xa-trong-con","name_with_type":"Xã Trọng Con","path":"Xã Trọng Con, Huyện Thạch An, Tỉnh Cao Bằng","path_with_type":"Xã Trọng Con, Huyện Thạch An, Tỉnh Cao Bằng","code":"01816","parent_code":"053"},"01819":{"name":"Xã Lê Lai","type":"xa","slug":"xa-le-lai","name_with_type":"Xã Lê Lai","path":"Xã Lê Lai, Huyện Thạch An, Tỉnh Cao Bằng","path_with_type":"Xã Lê Lai, Huyện Thạch An, Tỉnh Cao Bằng","code":"01819","parent_code":"053"},"01822":{"name":"Xã Đức Long","type":"xa","slug":"xa-duc-long","name_with_type":"Xã Đức Long","path":"Xã Đức Long, Huyện Thạch An, Tỉnh Cao Bằng","path_with_type":"Xã Đức Long, Huyện Thạch An, Tỉnh Cao Bằng","code":"01822","parent_code":"053"},"01828":{"name":"Xã Lê Lợi","type":"xa","slug":"xa-le-loi","name_with_type":"Xã Lê Lợi","path":"Xã Lê Lợi, Huyện Thạch An, Tỉnh Cao Bằng","path_with_type":"Xã Lê Lợi, Huyện Thạch An, Tỉnh Cao Bằng","code":"01828","parent_code":"053"},"01831":{"name":"Xã Đức Xuân","type":"xa","slug":"xa-duc-xuan","name_with_type":"Xã Đức Xuân","path":"Xã Đức Xuân, Huyện Thạch An, Tỉnh Cao Bằng","path_with_type":"Xã Đức Xuân, Huyện Thạch An, Tỉnh Cao Bằng","code":"01831","parent_code":"053"},"01834":{"name":"Phường Nguyễn Thị Minh Khai","type":"phuong","slug":"phuong-nguyen-thi-minh-khai","name_with_type":"Phường Nguyễn Thị Minh Khai","path":"Phường Nguyễn Thị Minh Khai, Thành Phố Bắc Kạn, Tỉnh Bắc Kạn","path_with_type":"Phường Nguyễn Thị Minh Khai, Thành Phố Bắc Kạn, Tỉnh Bắc Kạn","code":"01834","parent_code":"058"},"01837":{"name":"Phường Sông Cầu","type":"phuong","slug":"phuong-song-cau","name_with_type":"Phường Sông Cầu","path":"Phường Sông Cầu, Thành Phố Bắc Kạn, Tỉnh Bắc Kạn","path_with_type":"Phường Sông Cầu, Thành Phố Bắc Kạn, Tỉnh Bắc Kạn","code":"01837","parent_code":"058"},"01840":{"name":"Phường Đức Xuân","type":"phuong","slug":"phuong-duc-xuan","name_with_type":"Phường Đức Xuân","path":"Phường Đức Xuân, Thành Phố Bắc Kạn, Tỉnh Bắc Kạn","path_with_type":"Phường Đức Xuân, Thành Phố Bắc Kạn, Tỉnh Bắc Kạn","code":"01840","parent_code":"058"},"01843":{"name":"Phường Phùng Chí Kiên","type":"phuong","slug":"phuong-phung-chi-kien","name_with_type":"Phường Phùng Chí Kiên","path":"Phường Phùng Chí Kiên, Thành Phố Bắc Kạn, Tỉnh Bắc Kạn","path_with_type":"Phường Phùng Chí Kiên, Thành Phố Bắc Kạn, Tỉnh Bắc Kạn","code":"01843","parent_code":"058"},"01846":{"name":"Phường Huyền Tụng","type":"phuong","slug":"phuong-huyen-tung","name_with_type":"Phường Huyền Tụng","path":"Phường Huyền Tụng, Thành Phố Bắc Kạn, Tỉnh Bắc Kạn","path_with_type":"Phường Huyền Tụng, Thành Phố Bắc Kạn, Tỉnh Bắc Kạn","code":"01846","parent_code":"058"},"01849":{"name":"Xã Dương Quang","type":"xa","slug":"xa-duong-quang","name_with_type":"Xã Dương Quang","path":"Xã Dương Quang, Thành Phố Bắc Kạn, Tỉnh Bắc Kạn","path_with_type":"Xã Dương Quang, Thành Phố Bắc Kạn, Tỉnh Bắc Kạn","code":"01849","parent_code":"058"},"01852":{"name":"Xã Nông Thượng","type":"xa","slug":"xa-nong-thuong","name_with_type":"Xã Nông Thượng","path":"Xã Nông Thượng, Thành Phố Bắc Kạn, Tỉnh Bắc Kạn","path_with_type":"Xã Nông Thượng, Thành Phố Bắc Kạn, Tỉnh Bắc Kạn","code":"01852","parent_code":"058"},"01855":{"name":"Phường Xuất Hóa","type":"phuong","slug":"phuong-xuat-hoa","name_with_type":"Phường Xuất Hóa","path":"Phường Xuất Hóa, Thành Phố Bắc Kạn, Tỉnh Bắc Kạn","path_with_type":"Phường Xuất Hóa, Thành Phố Bắc Kạn, Tỉnh Bắc Kạn","code":"01855","parent_code":"058"},"01858":{"name":"Xã Bằng Thành","type":"xa","slug":"xa-bang-thanh","name_with_type":"Xã Bằng Thành","path":"Xã Bằng Thành, Huyện Pác Nặm, Tỉnh Bắc Kạn","path_with_type":"Xã Bằng Thành, Huyện Pác Nặm, Tỉnh Bắc Kạn","code":"01858","parent_code":"060"},"01861":{"name":"Xã Nhạn Môn","type":"xa","slug":"xa-nhan-mon","name_with_type":"Xã Nhạn Môn","path":"Xã Nhạn Môn, Huyện Pác Nặm, Tỉnh Bắc Kạn","path_with_type":"Xã Nhạn Môn, Huyện Pác Nặm, Tỉnh Bắc Kạn","code":"01861","parent_code":"060"},"01864":{"name":"Xã Bộc Bố","type":"xa","slug":"xa-boc-bo","name_with_type":"Xã Bộc Bố","path":"Xã Bộc Bố, Huyện Pác Nặm, Tỉnh Bắc Kạn","path_with_type":"Xã Bộc Bố, Huyện Pác Nặm, Tỉnh Bắc Kạn","code":"01864","parent_code":"060"},"01867":{"name":"Xã Công Bằng","type":"xa","slug":"xa-cong-bang","name_with_type":"Xã Công Bằng","path":"Xã Công Bằng, Huyện Pác Nặm, Tỉnh Bắc Kạn","path_with_type":"Xã Công Bằng, Huyện Pác Nặm, Tỉnh Bắc Kạn","code":"01867","parent_code":"060"},"01870":{"name":"Xã Giáo Hiệu","type":"xa","slug":"xa-giao-hieu","name_with_type":"Xã Giáo Hiệu","path":"Xã Giáo Hiệu, Huyện Pác Nặm, Tỉnh Bắc Kạn","path_with_type":"Xã Giáo Hiệu, Huyện Pác Nặm, Tỉnh Bắc Kạn","code":"01870","parent_code":"060"},"01873":{"name":"Xã Xuân La","type":"xa","slug":"xa-xuan-la","name_with_type":"Xã Xuân La","path":"Xã Xuân La, Huyện Pác Nặm, Tỉnh Bắc Kạn","path_with_type":"Xã Xuân La, Huyện Pác Nặm, Tỉnh Bắc Kạn","code":"01873","parent_code":"060"},"01876":{"name":"Xã An Thắng","type":"xa","slug":"xa-an-thang","name_with_type":"Xã An Thắng","path":"Xã An Thắng, Huyện Pác Nặm, Tỉnh Bắc Kạn","path_with_type":"Xã An Thắng, Huyện Pác Nặm, Tỉnh Bắc Kạn","code":"01876","parent_code":"060"},"01879":{"name":"Xã Cổ Linh","type":"xa","slug":"xa-co-linh","name_with_type":"Xã Cổ Linh","path":"Xã Cổ Linh, Huyện Pác Nặm, Tỉnh Bắc Kạn","path_with_type":"Xã Cổ Linh, Huyện Pác Nặm, Tỉnh Bắc Kạn","code":"01879","parent_code":"060"},"01882":{"name":"Xã Nghiên Loan","type":"xa","slug":"xa-nghien-loan","name_with_type":"Xã Nghiên Loan","path":"Xã Nghiên Loan, Huyện Pác Nặm, Tỉnh Bắc Kạn","path_with_type":"Xã Nghiên Loan, Huyện Pác Nặm, Tỉnh Bắc Kạn","code":"01882","parent_code":"060"},"01885":{"name":"Xã Cao Tân","type":"xa","slug":"xa-cao-tan","name_with_type":"Xã Cao Tân","path":"Xã Cao Tân, Huyện Pác Nặm, Tỉnh Bắc Kạn","path_with_type":"Xã Cao Tân, Huyện Pác Nặm, Tỉnh Bắc Kạn","code":"01885","parent_code":"060"},"01888":{"name":"Thị trấn Chợ Rã","type":"thi-tran","slug":"thi-tran-cho-ra","name_with_type":"Thị trấn Chợ Rã","path":"Thị trấn Chợ Rã, Huyện Ba Bể, Tỉnh Bắc Kạn","path_with_type":"Thị trấn Chợ Rã, Huyện Ba Bể, Tỉnh Bắc Kạn","code":"01888","parent_code":"061"},"01891":{"name":"Xã Bành Trạch","type":"xa","slug":"xa-banh-trach","name_with_type":"Xã Bành Trạch","path":"Xã Bành Trạch, Huyện Ba Bể, Tỉnh Bắc Kạn","path_with_type":"Xã Bành Trạch, Huyện Ba Bể, Tỉnh Bắc Kạn","code":"01891","parent_code":"061"},"01894":{"name":"Xã Phúc Lộc","type":"xa","slug":"xa-phuc-loc","name_with_type":"Xã Phúc Lộc","path":"Xã Phúc Lộc, Huyện Ba Bể, Tỉnh Bắc Kạn","path_with_type":"Xã Phúc Lộc, Huyện Ba Bể, Tỉnh Bắc Kạn","code":"01894","parent_code":"061"},"01897":{"name":"Xã Hà Hiệu","type":"xa","slug":"xa-ha-hieu","name_with_type":"Xã Hà Hiệu","path":"Xã Hà Hiệu, Huyện Ba Bể, Tỉnh Bắc Kạn","path_with_type":"Xã Hà Hiệu, Huyện Ba Bể, Tỉnh Bắc Kạn","code":"01897","parent_code":"061"},"01900":{"name":"Xã Cao Thượng","type":"xa","slug":"xa-cao-thuong","name_with_type":"Xã Cao Thượng","path":"Xã Cao Thượng, Huyện Ba Bể, Tỉnh Bắc Kạn","path_with_type":"Xã Cao Thượng, Huyện Ba Bể, Tỉnh Bắc Kạn","code":"01900","parent_code":"061"},"01906":{"name":"Xã Khang Ninh","type":"xa","slug":"xa-khang-ninh","name_with_type":"Xã Khang Ninh","path":"Xã Khang Ninh, Huyện Ba Bể, Tỉnh Bắc Kạn","path_with_type":"Xã Khang Ninh, Huyện Ba Bể, Tỉnh Bắc Kạn","code":"01906","parent_code":"061"},"01909":{"name":"Xã Nam Mẫu","type":"xa","slug":"xa-nam-mau","name_with_type":"Xã Nam Mẫu","path":"Xã Nam Mẫu, Huyện Ba Bể, Tỉnh Bắc Kạn","path_with_type":"Xã Nam Mẫu, Huyện Ba Bể, Tỉnh Bắc Kạn","code":"01909","parent_code":"061"},"01912":{"name":"Xã Thượng Giáo","type":"xa","slug":"xa-thuong-giao","name_with_type":"Xã Thượng Giáo","path":"Xã Thượng Giáo, Huyện Ba Bể, Tỉnh Bắc Kạn","path_with_type":"Xã Thượng Giáo, Huyện Ba Bể, Tỉnh Bắc Kạn","code":"01912","parent_code":"061"},"01915":{"name":"Xã Địa Linh","type":"xa","slug":"xa-dia-linh","name_with_type":"Xã Địa Linh","path":"Xã Địa Linh, Huyện Ba Bể, Tỉnh Bắc Kạn","path_with_type":"Xã Địa Linh, Huyện Ba Bể, Tỉnh Bắc Kạn","code":"01915","parent_code":"061"},"01918":{"name":"Xã Yến Dương","type":"xa","slug":"xa-yen-duong","name_with_type":"Xã Yến Dương","path":"Xã Yến Dương, Huyện Ba Bể, Tỉnh Bắc Kạn","path_with_type":"Xã Yến Dương, Huyện Ba Bể, Tỉnh Bắc Kạn","code":"01918","parent_code":"061"},"01921":{"name":"Xã Chu Hương","type":"xa","slug":"xa-chu-huong","name_with_type":"Xã Chu Hương","path":"Xã Chu Hương, Huyện Ba Bể, Tỉnh Bắc Kạn","path_with_type":"Xã Chu Hương, Huyện Ba Bể, Tỉnh Bắc Kạn","code":"01921","parent_code":"061"},"01924":{"name":"Xã Quảng Khê","type":"xa","slug":"xa-quang-khe","name_with_type":"Xã Quảng Khê","path":"Xã Quảng Khê, Huyện Ba Bể, Tỉnh Bắc Kạn","path_with_type":"Xã Quảng Khê, Huyện Ba Bể, Tỉnh Bắc Kạn","code":"01924","parent_code":"061"},"01927":{"name":"Xã Mỹ Phương","type":"xa","slug":"xa-my-phuong","name_with_type":"Xã Mỹ Phương","path":"Xã Mỹ Phương, Huyện Ba Bể, Tỉnh Bắc Kạn","path_with_type":"Xã Mỹ Phương, Huyện Ba Bể, Tỉnh Bắc Kạn","code":"01927","parent_code":"061"},"01930":{"name":"Xã Hoàng Trĩ","type":"xa","slug":"xa-hoang-tri","name_with_type":"Xã Hoàng Trĩ","path":"Xã Hoàng Trĩ, Huyện Ba Bể, Tỉnh Bắc Kạn","path_with_type":"Xã Hoàng Trĩ, Huyện Ba Bể, Tỉnh Bắc Kạn","code":"01930","parent_code":"061"},"01933":{"name":"Xã Đồng Phúc","type":"xa","slug":"xa-dong-phuc","name_with_type":"Xã Đồng Phúc","path":"Xã Đồng Phúc, Huyện Ba Bể, Tỉnh Bắc Kạn","path_with_type":"Xã Đồng Phúc, Huyện Ba Bể, Tỉnh Bắc Kạn","code":"01933","parent_code":"061"},"01936":{"name":"Thị trấn Nà Phặc","type":"thi-tran","slug":"thi-tran-na-phac","name_with_type":"Thị trấn Nà Phặc","path":"Thị trấn Nà Phặc, Huyện Ngân Sơn, Tỉnh Bắc Kạn","path_with_type":"Thị trấn Nà Phặc, Huyện Ngân Sơn, Tỉnh Bắc Kạn","code":"01936","parent_code":"062"},"01939":{"name":"Xã Thượng Ân","type":"xa","slug":"xa-thuong-an","name_with_type":"Xã Thượng Ân","path":"Xã Thượng Ân, Huyện Ngân Sơn, Tỉnh Bắc Kạn","path_with_type":"Xã Thượng Ân, Huyện Ngân Sơn, Tỉnh Bắc Kạn","code":"01939","parent_code":"062"},"01942":{"name":"Xã Bằng Vân","type":"xa","slug":"xa-bang-van","name_with_type":"Xã Bằng Vân","path":"Xã Bằng Vân, Huyện Ngân Sơn, Tỉnh Bắc Kạn","path_with_type":"Xã Bằng Vân, Huyện Ngân Sơn, Tỉnh Bắc Kạn","code":"01942","parent_code":"062"},"01945":{"name":"Xã Cốc Đán","type":"xa","slug":"xa-coc-dan","name_with_type":"Xã Cốc Đán","path":"Xã Cốc Đán, Huyện Ngân Sơn, Tỉnh Bắc Kạn","path_with_type":"Xã Cốc Đán, Huyện Ngân Sơn, Tỉnh Bắc Kạn","code":"01945","parent_code":"062"},"01948":{"name":"Xã Trung Hoà","type":"xa","slug":"xa-trung-hoa","name_with_type":"Xã Trung Hoà","path":"Xã Trung Hoà, Huyện Ngân Sơn, Tỉnh Bắc Kạn","path_with_type":"Xã Trung Hoà, Huyện Ngân Sơn, Tỉnh Bắc Kạn","code":"01948","parent_code":"062"},"01951":{"name":"Xã Đức Vân","type":"xa","slug":"xa-duc-van","name_with_type":"Xã Đức Vân","path":"Xã Đức Vân, Huyện Ngân Sơn, Tỉnh Bắc Kạn","path_with_type":"Xã Đức Vân, Huyện Ngân Sơn, Tỉnh Bắc Kạn","code":"01951","parent_code":"062"},"01954":{"name":"Thị trấn Vân Tùng","type":"thi-tran","slug":"thi-tran-van-tung","name_with_type":"Thị trấn Vân Tùng","path":"Thị trấn Vân Tùng, Huyện Ngân Sơn, Tỉnh Bắc Kạn","path_with_type":"Thị trấn Vân Tùng, Huyện Ngân Sơn, Tỉnh Bắc Kạn","code":"01954","parent_code":"062"},"01957":{"name":"Xã Thượng Quan","type":"xa","slug":"xa-thuong-quan","name_with_type":"Xã Thượng Quan","path":"Xã Thượng Quan, Huyện Ngân Sơn, Tỉnh Bắc Kạn","path_with_type":"Xã Thượng Quan, Huyện Ngân Sơn, Tỉnh Bắc Kạn","code":"01957","parent_code":"062"},"01960":{"name":"Xã Hiệp Lực","type":"xa","slug":"xa-hiep-luc","name_with_type":"Xã Hiệp Lực","path":"Xã Hiệp Lực, Huyện Ngân Sơn, Tỉnh Bắc Kạn","path_with_type":"Xã Hiệp Lực, Huyện Ngân Sơn, Tỉnh Bắc Kạn","code":"01960","parent_code":"062"},"01963":{"name":"Xã Thuần Mang","type":"xa","slug":"xa-thuan-mang","name_with_type":"Xã Thuần Mang","path":"Xã Thuần Mang, Huyện Ngân Sơn, Tỉnh Bắc Kạn","path_with_type":"Xã Thuần Mang, Huyện Ngân Sơn, Tỉnh Bắc Kạn","code":"01963","parent_code":"062"},"01969":{"name":"Thị trấn Phủ Thông","type":"thi-tran","slug":"thi-tran-phu-thong","name_with_type":"Thị trấn Phủ Thông","path":"Thị trấn Phủ Thông, Huyện Bạch Thông, Tỉnh Bắc Kạn","path_with_type":"Thị trấn Phủ Thông, Huyện Bạch Thông, Tỉnh Bắc Kạn","code":"01969","parent_code":"063"},"01975":{"name":"Xã Vi Hương","type":"xa","slug":"xa-vi-huong","name_with_type":"Xã Vi Hương","path":"Xã Vi Hương, Huyện Bạch Thông, Tỉnh Bắc Kạn","path_with_type":"Xã Vi Hương, Huyện Bạch Thông, Tỉnh Bắc Kạn","code":"01975","parent_code":"063"},"01978":{"name":"Xã Sĩ Bình","type":"xa","slug":"xa-si-binh","name_with_type":"Xã Sĩ Bình","path":"Xã Sĩ Bình, Huyện Bạch Thông, Tỉnh Bắc Kạn","path_with_type":"Xã Sĩ Bình, Huyện Bạch Thông, Tỉnh Bắc Kạn","code":"01978","parent_code":"063"},"01981":{"name":"Xã Vũ Muộn","type":"xa","slug":"xa-vu-muon","name_with_type":"Xã Vũ Muộn","path":"Xã Vũ Muộn, Huyện Bạch Thông, Tỉnh Bắc Kạn","path_with_type":"Xã Vũ Muộn, Huyện Bạch Thông, Tỉnh Bắc Kạn","code":"01981","parent_code":"063"},"01984":{"name":"Xã Đôn Phong","type":"xa","slug":"xa-don-phong","name_with_type":"Xã Đôn Phong","path":"Xã Đôn Phong, Huyện Bạch Thông, Tỉnh Bắc Kạn","path_with_type":"Xã Đôn Phong, Huyện Bạch Thông, Tỉnh Bắc Kạn","code":"01984","parent_code":"063"},"01990":{"name":"Xã Lục Bình","type":"xa","slug":"xa-luc-binh","name_with_type":"Xã Lục Bình","path":"Xã Lục Bình, Huyện Bạch Thông, Tỉnh Bắc Kạn","path_with_type":"Xã Lục Bình, Huyện Bạch Thông, Tỉnh Bắc Kạn","code":"01990","parent_code":"063"},"01993":{"name":"Xã Tân Tú","type":"xa","slug":"xa-tan-tu","name_with_type":"Xã Tân Tú","path":"Xã Tân Tú, Huyện Bạch Thông, Tỉnh Bắc Kạn","path_with_type":"Xã Tân Tú, Huyện Bạch Thông, Tỉnh Bắc Kạn","code":"01993","parent_code":"063"},"01999":{"name":"Xã Nguyên Phúc","type":"xa","slug":"xa-nguyen-phuc","name_with_type":"Xã Nguyên Phúc","path":"Xã Nguyên Phúc, Huyện Bạch Thông, Tỉnh Bắc Kạn","path_with_type":"Xã Nguyên Phúc, Huyện Bạch Thông, Tỉnh Bắc Kạn","code":"01999","parent_code":"063"},"02002":{"name":"Xã Cao Sơn","type":"xa","slug":"xa-cao-son","name_with_type":"Xã Cao Sơn","path":"Xã Cao Sơn, Huyện Bạch Thông, Tỉnh Bắc Kạn","path_with_type":"Xã Cao Sơn, Huyện Bạch Thông, Tỉnh Bắc Kạn","code":"02002","parent_code":"063"},"02005":{"name":"Xã Quân Hà","type":"xa","slug":"xa-quan-ha","name_with_type":"Xã Quân Hà","path":"Xã Quân Hà, Huyện Bạch Thông, Tỉnh Bắc Kạn","path_with_type":"Xã Quân Hà, Huyện Bạch Thông, Tỉnh Bắc Kạn","code":"02005","parent_code":"063"},"02008":{"name":"Xã Cẩm Giàng","type":"xa","slug":"xa-cam-giang","name_with_type":"Xã Cẩm Giàng","path":"Xã Cẩm Giàng, Huyện Bạch Thông, Tỉnh Bắc Kạn","path_with_type":"Xã Cẩm Giàng, Huyện Bạch Thông, Tỉnh Bắc Kạn","code":"02008","parent_code":"063"},"02011":{"name":"Xã Mỹ Thanh","type":"xa","slug":"xa-my-thanh","name_with_type":"Xã Mỹ Thanh","path":"Xã Mỹ Thanh, Huyện Bạch Thông, Tỉnh Bắc Kạn","path_with_type":"Xã Mỹ Thanh, Huyện Bạch Thông, Tỉnh Bắc Kạn","code":"02011","parent_code":"063"},"02014":{"name":"Xã Dương Phong","type":"xa","slug":"xa-duong-phong","name_with_type":"Xã Dương Phong","path":"Xã Dương Phong, Huyện Bạch Thông, Tỉnh Bắc Kạn","path_with_type":"Xã Dương Phong, Huyện Bạch Thông, Tỉnh Bắc Kạn","code":"02014","parent_code":"063"},"02017":{"name":"Xã Quang Thuận","type":"xa","slug":"xa-quang-thuan","name_with_type":"Xã Quang Thuận","path":"Xã Quang Thuận, Huyện Bạch Thông, Tỉnh Bắc Kạn","path_with_type":"Xã Quang Thuận, Huyện Bạch Thông, Tỉnh Bắc Kạn","code":"02017","parent_code":"063"},"02020":{"name":"Thị trấn Bằng Lũng","type":"thi-tran","slug":"thi-tran-bang-lung","name_with_type":"Thị trấn Bằng Lũng","path":"Thị trấn Bằng Lũng, Huyện Chợ Đồn, Tỉnh Bắc Kạn","path_with_type":"Thị trấn Bằng Lũng, Huyện Chợ Đồn, Tỉnh Bắc Kạn","code":"02020","parent_code":"064"},"02023":{"name":"Xã Xuân Lạc","type":"xa","slug":"xa-xuan-lac","name_with_type":"Xã Xuân Lạc","path":"Xã Xuân Lạc, Huyện Chợ Đồn, Tỉnh Bắc Kạn","path_with_type":"Xã Xuân Lạc, Huyện Chợ Đồn, Tỉnh Bắc Kạn","code":"02023","parent_code":"064"},"02026":{"name":"Xã Nam Cường","type":"xa","slug":"xa-nam-cuong","name_with_type":"Xã Nam Cường","path":"Xã Nam Cường, Huyện Chợ Đồn, Tỉnh Bắc Kạn","path_with_type":"Xã Nam Cường, Huyện Chợ Đồn, Tỉnh Bắc Kạn","code":"02026","parent_code":"064"},"02029":{"name":"Xã Đồng Lạc","type":"xa","slug":"xa-dong-lac","name_with_type":"Xã Đồng Lạc","path":"Xã Đồng Lạc, Huyện Chợ Đồn, Tỉnh Bắc Kạn","path_with_type":"Xã Đồng Lạc, Huyện Chợ Đồn, Tỉnh Bắc Kạn","code":"02029","parent_code":"064"},"02032":{"name":"Xã Tân Lập","type":"xa","slug":"xa-tan-lap","name_with_type":"Xã Tân Lập","path":"Xã Tân Lập, Huyện Chợ Đồn, Tỉnh Bắc Kạn","path_with_type":"Xã Tân Lập, Huyện Chợ Đồn, Tỉnh Bắc Kạn","code":"02032","parent_code":"064"},"02035":{"name":"Xã Bản Thi","type":"xa","slug":"xa-ban-thi","name_with_type":"Xã Bản Thi","path":"Xã Bản Thi, Huyện Chợ Đồn, Tỉnh Bắc Kạn","path_with_type":"Xã Bản Thi, Huyện Chợ Đồn, Tỉnh Bắc Kạn","code":"02035","parent_code":"064"},"02038":{"name":"Xã Quảng Bạch","type":"xa","slug":"xa-quang-bach","name_with_type":"Xã Quảng Bạch","path":"Xã Quảng Bạch, Huyện Chợ Đồn, Tỉnh Bắc Kạn","path_with_type":"Xã Quảng Bạch, Huyện Chợ Đồn, Tỉnh Bắc Kạn","code":"02038","parent_code":"064"},"02041":{"name":"Xã Bằng Phúc","type":"xa","slug":"xa-bang-phuc","name_with_type":"Xã Bằng Phúc","path":"Xã Bằng Phúc, Huyện Chợ Đồn, Tỉnh Bắc Kạn","path_with_type":"Xã Bằng Phúc, Huyện Chợ Đồn, Tỉnh Bắc Kạn","code":"02041","parent_code":"064"},"02044":{"name":"Xã Yên Thịnh","type":"xa","slug":"xa-yen-thinh","name_with_type":"Xã Yên Thịnh","path":"Xã Yên Thịnh, Huyện Chợ Đồn, Tỉnh Bắc Kạn","path_with_type":"Xã Yên Thịnh, Huyện Chợ Đồn, Tỉnh Bắc Kạn","code":"02044","parent_code":"064"},"02047":{"name":"Xã Yên Thượng","type":"xa","slug":"xa-yen-thuong","name_with_type":"Xã Yên Thượng","path":"Xã Yên Thượng, Huyện Chợ Đồn, Tỉnh Bắc Kạn","path_with_type":"Xã Yên Thượng, Huyện Chợ Đồn, Tỉnh Bắc Kạn","code":"02047","parent_code":"064"},"02050":{"name":"Xã Phương Viên","type":"xa","slug":"xa-phuong-vien","name_with_type":"Xã Phương Viên","path":"Xã Phương Viên, Huyện Chợ Đồn, Tỉnh Bắc Kạn","path_with_type":"Xã Phương Viên, Huyện Chợ Đồn, Tỉnh Bắc Kạn","code":"02050","parent_code":"064"},"02053":{"name":"Xã Ngọc Phái","type":"xa","slug":"xa-ngoc-phai","name_with_type":"Xã Ngọc Phái","path":"Xã Ngọc Phái, Huyện Chợ Đồn, Tỉnh Bắc Kạn","path_with_type":"Xã Ngọc Phái, Huyện Chợ Đồn, Tỉnh Bắc Kạn","code":"02053","parent_code":"064"},"02059":{"name":"Xã Đồng Thắng","type":"xa","slug":"xa-dong-thang","name_with_type":"Xã Đồng Thắng","path":"Xã Đồng Thắng, Huyện Chợ Đồn, Tỉnh Bắc Kạn","path_with_type":"Xã Đồng Thắng, Huyện Chợ Đồn, Tỉnh Bắc Kạn","code":"02059","parent_code":"064"},"02062":{"name":"Xã Lương Bằng","type":"xa","slug":"xa-luong-bang","name_with_type":"Xã Lương Bằng","path":"Xã Lương Bằng, Huyện Chợ Đồn, Tỉnh Bắc Kạn","path_with_type":"Xã Lương Bằng, Huyện Chợ Đồn, Tỉnh Bắc Kạn","code":"02062","parent_code":"064"},"02065":{"name":"Xã Bằng Lãng","type":"xa","slug":"xa-bang-lang","name_with_type":"Xã Bằng Lãng","path":"Xã Bằng Lãng, Huyện Chợ Đồn, Tỉnh Bắc Kạn","path_with_type":"Xã Bằng Lãng, Huyện Chợ Đồn, Tỉnh Bắc Kạn","code":"02065","parent_code":"064"},"02068":{"name":"Xã Đại Sảo","type":"xa","slug":"xa-dai-sao","name_with_type":"Xã Đại Sảo","path":"Xã Đại Sảo, Huyện Chợ Đồn, Tỉnh Bắc Kạn","path_with_type":"Xã Đại Sảo, Huyện Chợ Đồn, Tỉnh Bắc Kạn","code":"02068","parent_code":"064"},"02071":{"name":"Xã Nghĩa Tá","type":"xa","slug":"xa-nghia-ta","name_with_type":"Xã Nghĩa Tá","path":"Xã Nghĩa Tá, Huyện Chợ Đồn, Tỉnh Bắc Kạn","path_with_type":"Xã Nghĩa Tá, Huyện Chợ Đồn, Tỉnh Bắc Kạn","code":"02071","parent_code":"064"},"02077":{"name":"Xã Yên Mỹ","type":"xa","slug":"xa-yen-my","name_with_type":"Xã Yên Mỹ","path":"Xã Yên Mỹ, Huyện Chợ Đồn, Tỉnh Bắc Kạn","path_with_type":"Xã Yên Mỹ, Huyện Chợ Đồn, Tỉnh Bắc Kạn","code":"02077","parent_code":"064"},"02080":{"name":"Xã Bình Trung","type":"xa","slug":"xa-binh-trung","name_with_type":"Xã Bình Trung","path":"Xã Bình Trung, Huyện Chợ Đồn, Tỉnh Bắc Kạn","path_with_type":"Xã Bình Trung, Huyện Chợ Đồn, Tỉnh Bắc Kạn","code":"02080","parent_code":"064"},"02083":{"name":"Xã Yên Phong","type":"xa","slug":"xa-yen-phong","name_with_type":"Xã Yên Phong","path":"Xã Yên Phong, Huyện Chợ Đồn, Tỉnh Bắc Kạn","path_with_type":"Xã Yên Phong, Huyện Chợ Đồn, Tỉnh Bắc Kạn","code":"02083","parent_code":"064"},"02086":{"name":"Thị trấn Đồng Tâm","type":"thi-tran","slug":"thi-tran-dong-tam","name_with_type":"Thị trấn Đồng Tâm","path":"Thị trấn Đồng Tâm, Huyện Chợ Mới, Tỉnh Bắc Kạn","path_with_type":"Thị trấn Đồng Tâm, Huyện Chợ Mới, Tỉnh Bắc Kạn","code":"02086","parent_code":"065"},"02089":{"name":"Xã Tân Sơn","type":"xa","slug":"xa-tan-son","name_with_type":"Xã Tân Sơn","path":"Xã Tân Sơn, Huyện Chợ Mới, Tỉnh Bắc Kạn","path_with_type":"Xã Tân Sơn, Huyện Chợ Mới, Tỉnh Bắc Kạn","code":"02089","parent_code":"065"},"02092":{"name":"Xã Thanh Vận","type":"xa","slug":"xa-thanh-van","name_with_type":"Xã Thanh Vận","path":"Xã Thanh Vận, Huyện Chợ Mới, Tỉnh Bắc Kạn","path_with_type":"Xã Thanh Vận, Huyện Chợ Mới, Tỉnh Bắc Kạn","code":"02092","parent_code":"065"},"02095":{"name":"Xã Mai Lạp","type":"xa","slug":"xa-mai-lap","name_with_type":"Xã Mai Lạp","path":"Xã Mai Lạp, Huyện Chợ Mới, Tỉnh Bắc Kạn","path_with_type":"Xã Mai Lạp, Huyện Chợ Mới, Tỉnh Bắc Kạn","code":"02095","parent_code":"065"},"02098":{"name":"Xã Hoà Mục","type":"xa","slug":"xa-hoa-muc","name_with_type":"Xã Hoà Mục","path":"Xã Hoà Mục, Huyện Chợ Mới, Tỉnh Bắc Kạn","path_with_type":"Xã Hoà Mục, Huyện Chợ Mới, Tỉnh Bắc Kạn","code":"02098","parent_code":"065"},"02101":{"name":"Xã Thanh Mai","type":"xa","slug":"xa-thanh-mai","name_with_type":"Xã Thanh Mai","path":"Xã Thanh Mai, Huyện Chợ Mới, Tỉnh Bắc Kạn","path_with_type":"Xã Thanh Mai, Huyện Chợ Mới, Tỉnh Bắc Kạn","code":"02101","parent_code":"065"},"02104":{"name":"Xã Cao Kỳ","type":"xa","slug":"xa-cao-ky","name_with_type":"Xã Cao Kỳ","path":"Xã Cao Kỳ, Huyện Chợ Mới, Tỉnh Bắc Kạn","path_with_type":"Xã Cao Kỳ, Huyện Chợ Mới, Tỉnh Bắc Kạn","code":"02104","parent_code":"065"},"02107":{"name":"Xã Nông Hạ","type":"xa","slug":"xa-nong-ha","name_with_type":"Xã Nông Hạ","path":"Xã Nông Hạ, Huyện Chợ Mới, Tỉnh Bắc Kạn","path_with_type":"Xã Nông Hạ, Huyện Chợ Mới, Tỉnh Bắc Kạn","code":"02107","parent_code":"065"},"02110":{"name":"Xã Yên Cư","type":"xa","slug":"xa-yen-cu","name_with_type":"Xã Yên Cư","path":"Xã Yên Cư, Huyện Chợ Mới, Tỉnh Bắc Kạn","path_with_type":"Xã Yên Cư, Huyện Chợ Mới, Tỉnh Bắc Kạn","code":"02110","parent_code":"065"},"02113":{"name":"Xã Thanh Thịnh","type":"xa","slug":"xa-thanh-thinh","name_with_type":"Xã Thanh Thịnh","path":"Xã Thanh Thịnh, Huyện Chợ Mới, Tỉnh Bắc Kạn","path_with_type":"Xã Thanh Thịnh, Huyện Chợ Mới, Tỉnh Bắc Kạn","code":"02113","parent_code":"065"},"02116":{"name":"Xã Yên Hân","type":"xa","slug":"xa-yen-han","name_with_type":"Xã Yên Hân","path":"Xã Yên Hân, Huyện Chợ Mới, Tỉnh Bắc Kạn","path_with_type":"Xã Yên Hân, Huyện Chợ Mới, Tỉnh Bắc Kạn","code":"02116","parent_code":"065"},"02122":{"name":"Xã Như Cố","type":"xa","slug":"xa-nhu-co","name_with_type":"Xã Như Cố","path":"Xã Như Cố, Huyện Chợ Mới, Tỉnh Bắc Kạn","path_with_type":"Xã Như Cố, Huyện Chợ Mới, Tỉnh Bắc Kạn","code":"02122","parent_code":"065"},"02125":{"name":"Xã Bình Văn","type":"xa","slug":"xa-binh-van","name_with_type":"Xã Bình Văn","path":"Xã Bình Văn, Huyện Chợ Mới, Tỉnh Bắc Kạn","path_with_type":"Xã Bình Văn, Huyện Chợ Mới, Tỉnh Bắc Kạn","code":"02125","parent_code":"065"},"02131":{"name":"Xã Quảng Chu","type":"xa","slug":"xa-quang-chu","name_with_type":"Xã Quảng Chu","path":"Xã Quảng Chu, Huyện Chợ Mới, Tỉnh Bắc Kạn","path_with_type":"Xã Quảng Chu, Huyện Chợ Mới, Tỉnh Bắc Kạn","code":"02131","parent_code":"065"},"02137":{"name":"Xã Văn Vũ","type":"xa","slug":"xa-van-vu","name_with_type":"Xã Văn Vũ","path":"Xã Văn Vũ, Huyện Na Rì, Tỉnh Bắc Kạn","path_with_type":"Xã Văn Vũ, Huyện Na Rì, Tỉnh Bắc Kạn","code":"02137","parent_code":"066"},"02140":{"name":"Xã Văn Lang","type":"xa","slug":"xa-van-lang","name_with_type":"Xã Văn Lang","path":"Xã Văn Lang, Huyện Na Rì, Tỉnh Bắc Kạn","path_with_type":"Xã Văn Lang, Huyện Na Rì, Tỉnh Bắc Kạn","code":"02140","parent_code":"066"},"02143":{"name":"Xã Lương Thượng","type":"xa","slug":"xa-luong-thuong","name_with_type":"Xã Lương Thượng","path":"Xã Lương Thượng, Huyện Na Rì, Tỉnh Bắc Kạn","path_with_type":"Xã Lương Thượng, Huyện Na Rì, Tỉnh Bắc Kạn","code":"02143","parent_code":"066"},"02146":{"name":"Xã Kim Hỷ","type":"xa","slug":"xa-kim-hy","name_with_type":"Xã Kim Hỷ","path":"Xã Kim Hỷ, Huyện Na Rì, Tỉnh Bắc Kạn","path_with_type":"Xã Kim Hỷ, Huyện Na Rì, Tỉnh Bắc Kạn","code":"02146","parent_code":"066"},"02152":{"name":"Xã Cường Lợi","type":"xa","slug":"xa-cuong-loi","name_with_type":"Xã Cường Lợi","path":"Xã Cường Lợi, Huyện Na Rì, Tỉnh Bắc Kạn","path_with_type":"Xã Cường Lợi, Huyện Na Rì, Tỉnh Bắc Kạn","code":"02152","parent_code":"066"},"02155":{"name":"Thị trấn Yến Lạc","type":"thi-tran","slug":"thi-tran-yen-lac","name_with_type":"Thị trấn Yến Lạc","path":"Thị trấn Yến Lạc, Huyện Na Rì, Tỉnh Bắc Kạn","path_with_type":"Thị trấn Yến Lạc, Huyện Na Rì, Tỉnh Bắc Kạn","code":"02155","parent_code":"066"},"02158":{"name":"Xã Kim Lư","type":"xa","slug":"xa-kim-lu","name_with_type":"Xã Kim Lư","path":"Xã Kim Lư, Huyện Na Rì, Tỉnh Bắc Kạn","path_with_type":"Xã Kim Lư, Huyện Na Rì, Tỉnh Bắc Kạn","code":"02158","parent_code":"066"},"02161":{"name":"Xã Sơn Thành","type":"xa","slug":"xa-son-thanh","name_with_type":"Xã Sơn Thành","path":"Xã Sơn Thành, Huyện Na Rì, Tỉnh Bắc Kạn","path_with_type":"Xã Sơn Thành, Huyện Na Rì, Tỉnh Bắc Kạn","code":"02161","parent_code":"066"},"02170":{"name":"Xã Văn Minh","type":"xa","slug":"xa-van-minh","name_with_type":"Xã Văn Minh","path":"Xã Văn Minh, Huyện Na Rì, Tỉnh Bắc Kạn","path_with_type":"Xã Văn Minh, Huyện Na Rì, Tỉnh Bắc Kạn","code":"02170","parent_code":"066"},"02173":{"name":"Xã Côn Minh","type":"xa","slug":"xa-con-minh","name_with_type":"Xã Côn Minh","path":"Xã Côn Minh, Huyện Na Rì, Tỉnh Bắc Kạn","path_with_type":"Xã Côn Minh, Huyện Na Rì, Tỉnh Bắc Kạn","code":"02173","parent_code":"066"},"02176":{"name":"Xã Cư Lễ","type":"xa","slug":"xa-cu-le","name_with_type":"Xã Cư Lễ","path":"Xã Cư Lễ, Huyện Na Rì, Tỉnh Bắc Kạn","path_with_type":"Xã Cư Lễ, Huyện Na Rì, Tỉnh Bắc Kạn","code":"02176","parent_code":"066"},"02179":{"name":"Xã Trần Phú","type":"xa","slug":"xa-tran-phu","name_with_type":"Xã Trần Phú","path":"Xã Trần Phú, Huyện Na Rì, Tỉnh Bắc Kạn","path_with_type":"Xã Trần Phú, Huyện Na Rì, Tỉnh Bắc Kạn","code":"02179","parent_code":"066"},"02185":{"name":"Xã Quang Phong","type":"xa","slug":"xa-quang-phong","name_with_type":"Xã Quang Phong","path":"Xã Quang Phong, Huyện Na Rì, Tỉnh Bắc Kạn","path_with_type":"Xã Quang Phong, Huyện Na Rì, Tỉnh Bắc Kạn","code":"02185","parent_code":"066"},"02188":{"name":"Xã Dương Sơn","type":"xa","slug":"xa-duong-son","name_with_type":"Xã Dương Sơn","path":"Xã Dương Sơn, Huyện Na Rì, Tỉnh Bắc Kạn","path_with_type":"Xã Dương Sơn, Huyện Na Rì, Tỉnh Bắc Kạn","code":"02188","parent_code":"066"},"02191":{"name":"Xã Xuân Dương","type":"xa","slug":"xa-xuan-duong","name_with_type":"Xã Xuân Dương","path":"Xã Xuân Dương, Huyện Na Rì, Tỉnh Bắc Kạn","path_with_type":"Xã Xuân Dương, Huyện Na Rì, Tỉnh Bắc Kạn","code":"02191","parent_code":"066"},"02194":{"name":"Xã Đổng Xá","type":"xa","slug":"xa-dong-xa","name_with_type":"Xã Đổng Xá","path":"Xã Đổng Xá, Huyện Na Rì, Tỉnh Bắc Kạn","path_with_type":"Xã Đổng Xá, Huyện Na Rì, Tỉnh Bắc Kạn","code":"02194","parent_code":"066"},"02197":{"name":"Xã Liêm Thuỷ","type":"xa","slug":"xa-liem-thuy","name_with_type":"Xã Liêm Thuỷ","path":"Xã Liêm Thuỷ, Huyện Na Rì, Tỉnh Bắc Kạn","path_with_type":"Xã Liêm Thuỷ, Huyện Na Rì, Tỉnh Bắc Kạn","code":"02197","parent_code":"066"},"02200":{"name":"Phường Phan Thiết","type":"phuong","slug":"phuong-phan-thiet","name_with_type":"Phường Phan Thiết","path":"Phường Phan Thiết, Thành phố Tuyên Quang, Tỉnh Tuyên Quang","path_with_type":"Phường Phan Thiết, Thành phố Tuyên Quang, Tỉnh Tuyên Quang","code":"02200","parent_code":"070"},"02203":{"name":"Phường Minh Xuân","type":"phuong","slug":"phuong-minh-xuan","name_with_type":"Phường Minh Xuân","path":"Phường Minh Xuân, Thành phố Tuyên Quang, Tỉnh Tuyên Quang","path_with_type":"Phường Minh Xuân, Thành phố Tuyên Quang, Tỉnh Tuyên Quang","code":"02203","parent_code":"070"},"02206":{"name":"Phường Tân Quang","type":"phuong","slug":"phuong-tan-quang","name_with_type":"Phường Tân Quang","path":"Phường Tân Quang, Thành phố Tuyên Quang, Tỉnh Tuyên Quang","path_with_type":"Phường Tân Quang, Thành phố Tuyên Quang, Tỉnh Tuyên Quang","code":"02206","parent_code":"070"},"02209":{"name":"Xã Tràng Đà","type":"xa","slug":"xa-trang-da","name_with_type":"Xã Tràng Đà","path":"Xã Tràng Đà, Thành phố Tuyên Quang, Tỉnh Tuyên Quang","path_with_type":"Xã Tràng Đà, Thành phố Tuyên Quang, Tỉnh Tuyên Quang","code":"02209","parent_code":"070"},"02212":{"name":"Phường Nông Tiến","type":"phuong","slug":"phuong-nong-tien","name_with_type":"Phường Nông Tiến","path":"Phường Nông Tiến, Thành phố Tuyên Quang, Tỉnh Tuyên Quang","path_with_type":"Phường Nông Tiến, Thành phố Tuyên Quang, Tỉnh Tuyên Quang","code":"02212","parent_code":"070"},"02215":{"name":"Phường Ỷ La","type":"phuong","slug":"phuong-y-la","name_with_type":"Phường Ỷ La","path":"Phường Ỷ La, Thành phố Tuyên Quang, Tỉnh Tuyên Quang","path_with_type":"Phường Ỷ La, Thành phố Tuyên Quang, Tỉnh Tuyên Quang","code":"02215","parent_code":"070"},"02216":{"name":"Phường Tân Hà","type":"phuong","slug":"phuong-tan-ha","name_with_type":"Phường Tân Hà","path":"Phường Tân Hà, Thành phố Tuyên Quang, Tỉnh Tuyên Quang","path_with_type":"Phường Tân Hà, Thành phố Tuyên Quang, Tỉnh Tuyên Quang","code":"02216","parent_code":"070"},"02218":{"name":"Phường Hưng Thành","type":"phuong","slug":"phuong-hung-thanh","name_with_type":"Phường Hưng Thành","path":"Phường Hưng Thành, Thành phố Tuyên Quang, Tỉnh Tuyên Quang","path_with_type":"Phường Hưng Thành, Thành phố Tuyên Quang, Tỉnh Tuyên Quang","code":"02218","parent_code":"070"},"02497":{"name":"Xã Kim Phú","type":"xa","slug":"xa-kim-phu","name_with_type":"Xã Kim Phú","path":"Xã Kim Phú, Thành phố Tuyên Quang, Tỉnh Tuyên Quang","path_with_type":"Xã Kim Phú, Thành phố Tuyên Quang, Tỉnh Tuyên Quang","code":"02497","parent_code":"070"},"02503":{"name":"Xã An Khang","type":"xa","slug":"xa-an-khang","name_with_type":"Xã An Khang","path":"Xã An Khang, Thành phố Tuyên Quang, Tỉnh Tuyên Quang","path_with_type":"Xã An Khang, Thành phố Tuyên Quang, Tỉnh Tuyên Quang","code":"02503","parent_code":"070"},"02509":{"name":"Phường Mỹ Lâm","type":"phuong","slug":"phuong-my-lam","name_with_type":"Phường Mỹ Lâm","path":"Phường Mỹ Lâm, Thành phố Tuyên Quang, Tỉnh Tuyên Quang","path_with_type":"Phường Mỹ Lâm, Thành phố Tuyên Quang, Tỉnh Tuyên Quang","code":"02509","parent_code":"070"},"02512":{"name":"Phường An Tường","type":"phuong","slug":"phuong-an-tuong","name_with_type":"Phường An Tường","path":"Phường An Tường, Thành phố Tuyên Quang, Tỉnh Tuyên Quang","path_with_type":"Phường An Tường, Thành phố Tuyên Quang, Tỉnh Tuyên Quang","code":"02512","parent_code":"070"},"02515":{"name":"Xã Lưỡng Vượng","type":"xa","slug":"xa-luong-vuong","name_with_type":"Xã Lưỡng Vượng","path":"Xã Lưỡng Vượng, Thành phố Tuyên Quang, Tỉnh Tuyên Quang","path_with_type":"Xã Lưỡng Vượng, Thành phố Tuyên Quang, Tỉnh Tuyên Quang","code":"02515","parent_code":"070"},"02521":{"name":"Xã Thái Long","type":"xa","slug":"xa-thai-long","name_with_type":"Xã Thái Long","path":"Xã Thái Long, Thành phố Tuyên Quang, Tỉnh Tuyên Quang","path_with_type":"Xã Thái Long, Thành phố Tuyên Quang, Tỉnh Tuyên Quang","code":"02521","parent_code":"070"},"02524":{"name":"Phường Đội Cấn","type":"phuong","slug":"phuong-doi-can","name_with_type":"Phường Đội Cấn","path":"Phường Đội Cấn, Thành phố Tuyên Quang, Tỉnh Tuyên Quang","path_with_type":"Phường Đội Cấn, Thành phố Tuyên Quang, Tỉnh Tuyên Quang","code":"02524","parent_code":"070"},"02233":{"name":"Xã Phúc Yên","type":"xa","slug":"xa-phuc-yen","name_with_type":"Xã Phúc Yên","path":"Xã Phúc Yên, Huyện Lâm Bình, Tỉnh Tuyên Quang","path_with_type":"Xã Phúc Yên, Huyện Lâm Bình, Tỉnh Tuyên Quang","code":"02233","parent_code":"071"},"02242":{"name":"Xã Xuân Lập","type":"xa","slug":"xa-xuan-lap","name_with_type":"Xã Xuân Lập","path":"Xã Xuân Lập, Huyện Lâm Bình, Tỉnh Tuyên Quang","path_with_type":"Xã Xuân Lập, Huyện Lâm Bình, Tỉnh Tuyên Quang","code":"02242","parent_code":"071"},"02251":{"name":"Xã Khuôn Hà","type":"xa","slug":"xa-khuon-ha","name_with_type":"Xã Khuôn Hà","path":"Xã Khuôn Hà, Huyện Lâm Bình, Tỉnh Tuyên Quang","path_with_type":"Xã Khuôn Hà, Huyện Lâm Bình, Tỉnh Tuyên Quang","code":"02251","parent_code":"071"},"02266":{"name":"Thị trấn Lăng Can","type":"thi-tran","slug":"thi-tran-lang-can","name_with_type":"Thị trấn Lăng Can","path":"Thị trấn Lăng Can, Huyện Lâm Bình, Tỉnh Tuyên Quang","path_with_type":"Thị trấn Lăng Can, Huyện Lâm Bình, Tỉnh Tuyên Quang","code":"02266","parent_code":"071"},"02269":{"name":"Xã Thượng Lâm","type":"xa","slug":"xa-thuong-lam","name_with_type":"Xã Thượng Lâm","path":"Xã Thượng Lâm, Huyện Lâm Bình, Tỉnh Tuyên Quang","path_with_type":"Xã Thượng Lâm, Huyện Lâm Bình, Tỉnh Tuyên Quang","code":"02269","parent_code":"071"},"02290":{"name":"Xã Bình An","type":"xa","slug":"xa-binh-an","name_with_type":"Xã Bình An","path":"Xã Bình An, Huyện Lâm Bình, Tỉnh Tuyên Quang","path_with_type":"Xã Bình An, Huyện Lâm Bình, Tỉnh Tuyên Quang","code":"02290","parent_code":"071"},"02293":{"name":"Xã Hồng Quang","type":"xa","slug":"xa-hong-quang","name_with_type":"Xã Hồng Quang","path":"Xã Hồng Quang, Huyện Lâm Bình, Tỉnh Tuyên Quang","path_with_type":"Xã Hồng Quang, Huyện Lâm Bình, Tỉnh Tuyên Quang","code":"02293","parent_code":"071"},"02296":{"name":"Xã Thổ Bình","type":"xa","slug":"xa-tho-binh","name_with_type":"Xã Thổ Bình","path":"Xã Thổ Bình, Huyện Lâm Bình, Tỉnh Tuyên Quang","path_with_type":"Xã Thổ Bình, Huyện Lâm Bình, Tỉnh Tuyên Quang","code":"02296","parent_code":"071"},"02299":{"name":"Xã Phúc Sơn","type":"xa","slug":"xa-phuc-son","name_with_type":"Xã Phúc Sơn","path":"Xã Phúc Sơn, Huyện Lâm Bình, Tỉnh Tuyên Quang","path_with_type":"Xã Phúc Sơn, Huyện Lâm Bình, Tỉnh Tuyên Quang","code":"02299","parent_code":"071"},"02302":{"name":"Xã Minh Quang","type":"xa","slug":"xa-minh-quang","name_with_type":"Xã Minh Quang","path":"Xã Minh Quang, Huyện Lâm Bình, Tỉnh Tuyên Quang","path_with_type":"Xã Minh Quang, Huyện Lâm Bình, Tỉnh Tuyên Quang","code":"02302","parent_code":"071"},"02221":{"name":"Thị trấn Na Hang","type":"thi-tran","slug":"thi-tran-na-hang","name_with_type":"Thị trấn Na Hang","path":"Thị trấn Na Hang, Huyện Na Hang, Tỉnh Tuyên Quang","path_with_type":"Thị trấn Na Hang, Huyện Na Hang, Tỉnh Tuyên Quang","code":"02221","parent_code":"072"},"02227":{"name":"Xã Sinh Long","type":"xa","slug":"xa-sinh-long","name_with_type":"Xã Sinh Long","path":"Xã Sinh Long, Huyện Na Hang, Tỉnh Tuyên Quang","path_with_type":"Xã Sinh Long, Huyện Na Hang, Tỉnh Tuyên Quang","code":"02227","parent_code":"072"},"02230":{"name":"Xã Thượng Giáp","type":"xa","slug":"xa-thuong-giap","name_with_type":"Xã Thượng Giáp","path":"Xã Thượng Giáp, Huyện Na Hang, Tỉnh Tuyên Quang","path_with_type":"Xã Thượng Giáp, Huyện Na Hang, Tỉnh Tuyên Quang","code":"02230","parent_code":"072"},"02239":{"name":"Xã Thượng Nông","type":"xa","slug":"xa-thuong-nong","name_with_type":"Xã Thượng Nông","path":"Xã Thượng Nông, Huyện Na Hang, Tỉnh Tuyên Quang","path_with_type":"Xã Thượng Nông, Huyện Na Hang, Tỉnh Tuyên Quang","code":"02239","parent_code":"072"},"02245":{"name":"Xã Côn Lôn","type":"xa","slug":"xa-con-lon","name_with_type":"Xã Côn Lôn","path":"Xã Côn Lôn, Huyện Na Hang, Tỉnh Tuyên Quang","path_with_type":"Xã Côn Lôn, Huyện Na Hang, Tỉnh Tuyên Quang","code":"02245","parent_code":"072"},"02248":{"name":"Xã Yên Hoa","type":"xa","slug":"xa-yen-hoa","name_with_type":"Xã Yên Hoa","path":"Xã Yên Hoa, Huyện Na Hang, Tỉnh Tuyên Quang","path_with_type":"Xã Yên Hoa, Huyện Na Hang, Tỉnh Tuyên Quang","code":"02248","parent_code":"072"},"02254":{"name":"Xã Hồng Thái","type":"xa","slug":"xa-hong-thai","name_with_type":"Xã Hồng Thái","path":"Xã Hồng Thái, Huyện Na Hang, Tỉnh Tuyên Quang","path_with_type":"Xã Hồng Thái, Huyện Na Hang, Tỉnh Tuyên Quang","code":"02254","parent_code":"072"},"02260":{"name":"Xã Đà Vị","type":"xa","slug":"xa-da-vi","name_with_type":"Xã Đà Vị","path":"Xã Đà Vị, Huyện Na Hang, Tỉnh Tuyên Quang","path_with_type":"Xã Đà Vị, Huyện Na Hang, Tỉnh Tuyên Quang","code":"02260","parent_code":"072"},"02263":{"name":"Xã Khau Tinh","type":"xa","slug":"xa-khau-tinh","name_with_type":"Xã Khau Tinh","path":"Xã Khau Tinh, Huyện Na Hang, Tỉnh Tuyên Quang","path_with_type":"Xã Khau Tinh, Huyện Na Hang, Tỉnh Tuyên Quang","code":"02263","parent_code":"072"},"02275":{"name":"Xã Sơn Phú","type":"xa","slug":"xa-son-phu","name_with_type":"Xã Sơn Phú","path":"Xã Sơn Phú, Huyện Na Hang, Tỉnh Tuyên Quang","path_with_type":"Xã Sơn Phú, Huyện Na Hang, Tỉnh Tuyên Quang","code":"02275","parent_code":"072"},"02281":{"name":"Xã Năng Khả","type":"xa","slug":"xa-nang-kha","name_with_type":"Xã Năng Khả","path":"Xã Năng Khả, Huyện Na Hang, Tỉnh Tuyên Quang","path_with_type":"Xã Năng Khả, Huyện Na Hang, Tỉnh Tuyên Quang","code":"02281","parent_code":"072"},"02284":{"name":"Xã Thanh Tương","type":"xa","slug":"xa-thanh-tuong","name_with_type":"Xã Thanh Tương","path":"Xã Thanh Tương, Huyện Na Hang, Tỉnh Tuyên Quang","path_with_type":"Xã Thanh Tương, Huyện Na Hang, Tỉnh Tuyên Quang","code":"02284","parent_code":"072"},"02287":{"name":"Thị trấn Vĩnh Lộc","type":"thi-tran","slug":"thi-tran-vinh-loc","name_with_type":"Thị trấn Vĩnh Lộc","path":"Thị trấn Vĩnh Lộc, Huyện Chiêm Hóa, Tỉnh Tuyên Quang","path_with_type":"Thị trấn Vĩnh Lộc, Huyện Chiêm Hóa, Tỉnh Tuyên Quang","code":"02287","parent_code":"073"},"02305":{"name":"Xã Trung Hà","type":"xa","slug":"xa-trung-ha","name_with_type":"Xã Trung Hà","path":"Xã Trung Hà, Huyện Chiêm Hóa, Tỉnh Tuyên Quang","path_with_type":"Xã Trung Hà, Huyện Chiêm Hóa, Tỉnh Tuyên Quang","code":"02305","parent_code":"073"},"02308":{"name":"Xã Tân Mỹ","type":"xa","slug":"xa-tan-my","name_with_type":"Xã Tân Mỹ","path":"Xã Tân Mỹ, Huyện Chiêm Hóa, Tỉnh Tuyên Quang","path_with_type":"Xã Tân Mỹ, Huyện Chiêm Hóa, Tỉnh Tuyên Quang","code":"02308","parent_code":"073"},"02311":{"name":"Xã Hà Lang","type":"xa","slug":"xa-ha-lang","name_with_type":"Xã Hà Lang","path":"Xã Hà Lang, Huyện Chiêm Hóa, Tỉnh Tuyên Quang","path_with_type":"Xã Hà Lang, Huyện Chiêm Hóa, Tỉnh Tuyên Quang","code":"02311","parent_code":"073"},"02314":{"name":"Xã Hùng Mỹ","type":"xa","slug":"xa-hung-my","name_with_type":"Xã Hùng Mỹ","path":"Xã Hùng Mỹ, Huyện Chiêm Hóa, Tỉnh Tuyên Quang","path_with_type":"Xã Hùng Mỹ, Huyện Chiêm Hóa, Tỉnh Tuyên Quang","code":"02314","parent_code":"073"},"02317":{"name":"Xã Yên Lập","type":"xa","slug":"xa-yen-lap","name_with_type":"Xã Yên Lập","path":"Xã Yên Lập, Huyện Chiêm Hóa, Tỉnh Tuyên Quang","path_with_type":"Xã Yên Lập, Huyện Chiêm Hóa, Tỉnh Tuyên Quang","code":"02317","parent_code":"073"},"02320":{"name":"Xã Tân An","type":"xa","slug":"xa-tan-an","name_with_type":"Xã Tân An","path":"Xã Tân An, Huyện Chiêm Hóa, Tỉnh Tuyên Quang","path_with_type":"Xã Tân An, Huyện Chiêm Hóa, Tỉnh Tuyên Quang","code":"02320","parent_code":"073"},"02323":{"name":"Xã Bình Phú","type":"xa","slug":"xa-binh-phu","name_with_type":"Xã Bình Phú","path":"Xã Bình Phú, Huyện Chiêm Hóa, Tỉnh Tuyên Quang","path_with_type":"Xã Bình Phú, Huyện Chiêm Hóa, Tỉnh Tuyên Quang","code":"02323","parent_code":"073"},"02326":{"name":"Xã Xuân Quang","type":"xa","slug":"xa-xuan-quang","name_with_type":"Xã Xuân Quang","path":"Xã Xuân Quang, Huyện Chiêm Hóa, Tỉnh Tuyên Quang","path_with_type":"Xã Xuân Quang, Huyện Chiêm Hóa, Tỉnh Tuyên Quang","code":"02326","parent_code":"073"},"02329":{"name":"Xã Ngọc Hội","type":"xa","slug":"xa-ngoc-hoi","name_with_type":"Xã Ngọc Hội","path":"Xã Ngọc Hội, Huyện Chiêm Hóa, Tỉnh Tuyên Quang","path_with_type":"Xã Ngọc Hội, Huyện Chiêm Hóa, Tỉnh Tuyên Quang","code":"02329","parent_code":"073"},"02332":{"name":"Xã Phú Bình","type":"xa","slug":"xa-phu-binh","name_with_type":"Xã Phú Bình","path":"Xã Phú Bình, Huyện Chiêm Hóa, Tỉnh Tuyên Quang","path_with_type":"Xã Phú Bình, Huyện Chiêm Hóa, Tỉnh Tuyên Quang","code":"02332","parent_code":"073"},"02335":{"name":"Xã Hòa Phú","type":"xa","slug":"xa-hoa-phu","name_with_type":"Xã Hòa Phú","path":"Xã Hòa Phú, Huyện Chiêm Hóa, Tỉnh Tuyên Quang","path_with_type":"Xã Hòa Phú, Huyện Chiêm Hóa, Tỉnh Tuyên Quang","code":"02335","parent_code":"073"},"02338":{"name":"Xã Phúc Thịnh","type":"xa","slug":"xa-phuc-thinh","name_with_type":"Xã Phúc Thịnh","path":"Xã Phúc Thịnh, Huyện Chiêm Hóa, Tỉnh Tuyên Quang","path_with_type":"Xã Phúc Thịnh, Huyện Chiêm Hóa, Tỉnh Tuyên Quang","code":"02338","parent_code":"073"},"02341":{"name":"Xã Kiên Đài","type":"xa","slug":"xa-kien-dai","name_with_type":"Xã Kiên Đài","path":"Xã Kiên Đài, Huyện Chiêm Hóa, Tỉnh Tuyên Quang","path_with_type":"Xã Kiên Đài, Huyện Chiêm Hóa, Tỉnh Tuyên Quang","code":"02341","parent_code":"073"},"02344":{"name":"Xã Tân Thịnh","type":"xa","slug":"xa-tan-thinh","name_with_type":"Xã Tân Thịnh","path":"Xã Tân Thịnh, Huyện Chiêm Hóa, Tỉnh Tuyên Quang","path_with_type":"Xã Tân Thịnh, Huyện Chiêm Hóa, Tỉnh Tuyên Quang","code":"02344","parent_code":"073"},"02347":{"name":"Xã Trung Hòa","type":"xa","slug":"xa-trung-hoa","name_with_type":"Xã Trung Hòa","path":"Xã Trung Hòa, Huyện Chiêm Hóa, Tỉnh Tuyên Quang","path_with_type":"Xã Trung Hòa, Huyện Chiêm Hóa, Tỉnh Tuyên Quang","code":"02347","parent_code":"073"},"02350":{"name":"Xã Kim Bình","type":"xa","slug":"xa-kim-binh","name_with_type":"Xã Kim Bình","path":"Xã Kim Bình, Huyện Chiêm Hóa, Tỉnh Tuyên Quang","path_with_type":"Xã Kim Bình, Huyện Chiêm Hóa, Tỉnh Tuyên Quang","code":"02350","parent_code":"073"},"02353":{"name":"Xã Hòa An","type":"xa","slug":"xa-hoa-an","name_with_type":"Xã Hòa An","path":"Xã Hòa An, Huyện Chiêm Hóa, Tỉnh Tuyên Quang","path_with_type":"Xã Hòa An, Huyện Chiêm Hóa, Tỉnh Tuyên Quang","code":"02353","parent_code":"073"},"02356":{"name":"Xã Vinh Quang","type":"xa","slug":"xa-vinh-quang","name_with_type":"Xã Vinh Quang","path":"Xã Vinh Quang, Huyện Chiêm Hóa, Tỉnh Tuyên Quang","path_with_type":"Xã Vinh Quang, Huyện Chiêm Hóa, Tỉnh Tuyên Quang","code":"02356","parent_code":"073"},"02359":{"name":"Xã Tri Phú","type":"xa","slug":"xa-tri-phu","name_with_type":"Xã Tri Phú","path":"Xã Tri Phú, Huyện Chiêm Hóa, Tỉnh Tuyên Quang","path_with_type":"Xã Tri Phú, Huyện Chiêm Hóa, Tỉnh Tuyên Quang","code":"02359","parent_code":"073"},"02362":{"name":"Xã Nhân Lý","type":"xa","slug":"xa-nhan-ly","name_with_type":"Xã Nhân Lý","path":"Xã Nhân Lý, Huyện Chiêm Hóa, Tỉnh Tuyên Quang","path_with_type":"Xã Nhân Lý, Huyện Chiêm Hóa, Tỉnh Tuyên Quang","code":"02362","parent_code":"073"},"02365":{"name":"Xã Yên Nguyên","type":"xa","slug":"xa-yen-nguyen","name_with_type":"Xã Yên Nguyên","path":"Xã Yên Nguyên, Huyện Chiêm Hóa, Tỉnh Tuyên Quang","path_with_type":"Xã Yên Nguyên, Huyện Chiêm Hóa, Tỉnh Tuyên Quang","code":"02365","parent_code":"073"},"02368":{"name":"Xã Linh Phú","type":"xa","slug":"xa-linh-phu","name_with_type":"Xã Linh Phú","path":"Xã Linh Phú, Huyện Chiêm Hóa, Tỉnh Tuyên Quang","path_with_type":"Xã Linh Phú, Huyện Chiêm Hóa, Tỉnh Tuyên Quang","code":"02368","parent_code":"073"},"02371":{"name":"Xã Bình Nhân","type":"xa","slug":"xa-binh-nhan","name_with_type":"Xã Bình Nhân","path":"Xã Bình Nhân, Huyện Chiêm Hóa, Tỉnh Tuyên Quang","path_with_type":"Xã Bình Nhân, Huyện Chiêm Hóa, Tỉnh Tuyên Quang","code":"02371","parent_code":"073"},"02374":{"name":"Thị trấn Tân Yên","type":"thi-tran","slug":"thi-tran-tan-yen","name_with_type":"Thị trấn Tân Yên","path":"Thị trấn Tân Yên, Huyện Hàm Yên, Tỉnh Tuyên Quang","path_with_type":"Thị trấn Tân Yên, Huyện Hàm Yên, Tỉnh Tuyên Quang","code":"02374","parent_code":"074"},"02377":{"name":"Xã Yên Thuận","type":"xa","slug":"xa-yen-thuan","name_with_type":"Xã Yên Thuận","path":"Xã Yên Thuận, Huyện Hàm Yên, Tỉnh Tuyên Quang","path_with_type":"Xã Yên Thuận, Huyện Hàm Yên, Tỉnh Tuyên Quang","code":"02377","parent_code":"074"},"02380":{"name":"Xã Bạch Xa","type":"xa","slug":"xa-bach-xa","name_with_type":"Xã Bạch Xa","path":"Xã Bạch Xa, Huyện Hàm Yên, Tỉnh Tuyên Quang","path_with_type":"Xã Bạch Xa, Huyện Hàm Yên, Tỉnh Tuyên Quang","code":"02380","parent_code":"074"},"02383":{"name":"Xã Minh Khương","type":"xa","slug":"xa-minh-khuong","name_with_type":"Xã Minh Khương","path":"Xã Minh Khương, Huyện Hàm Yên, Tỉnh Tuyên Quang","path_with_type":"Xã Minh Khương, Huyện Hàm Yên, Tỉnh Tuyên Quang","code":"02383","parent_code":"074"},"02386":{"name":"Xã Yên Lâm","type":"xa","slug":"xa-yen-lam","name_with_type":"Xã Yên Lâm","path":"Xã Yên Lâm, Huyện Hàm Yên, Tỉnh Tuyên Quang","path_with_type":"Xã Yên Lâm, Huyện Hàm Yên, Tỉnh Tuyên Quang","code":"02386","parent_code":"074"},"02389":{"name":"Xã Minh Dân","type":"xa","slug":"xa-minh-dan","name_with_type":"Xã Minh Dân","path":"Xã Minh Dân, Huyện Hàm Yên, Tỉnh Tuyên Quang","path_with_type":"Xã Minh Dân, Huyện Hàm Yên, Tỉnh Tuyên Quang","code":"02389","parent_code":"074"},"02392":{"name":"Xã Phù Lưu","type":"xa","slug":"xa-phu-luu","name_with_type":"Xã Phù Lưu","path":"Xã Phù Lưu, Huyện Hàm Yên, Tỉnh Tuyên Quang","path_with_type":"Xã Phù Lưu, Huyện Hàm Yên, Tỉnh Tuyên Quang","code":"02392","parent_code":"074"},"02395":{"name":"Xã Minh Hương","type":"xa","slug":"xa-minh-huong","name_with_type":"Xã Minh Hương","path":"Xã Minh Hương, Huyện Hàm Yên, Tỉnh Tuyên Quang","path_with_type":"Xã Minh Hương, Huyện Hàm Yên, Tỉnh Tuyên Quang","code":"02395","parent_code":"074"},"02398":{"name":"Xã Yên Phú","type":"xa","slug":"xa-yen-phu","name_with_type":"Xã Yên Phú","path":"Xã Yên Phú, Huyện Hàm Yên, Tỉnh Tuyên Quang","path_with_type":"Xã Yên Phú, Huyện Hàm Yên, Tỉnh Tuyên Quang","code":"02398","parent_code":"074"},"02401":{"name":"Xã Tân Thành","type":"xa","slug":"xa-tan-thanh","name_with_type":"Xã Tân Thành","path":"Xã Tân Thành, Huyện Hàm Yên, Tỉnh Tuyên Quang","path_with_type":"Xã Tân Thành, Huyện Hàm Yên, Tỉnh Tuyên Quang","code":"02401","parent_code":"074"},"02404":{"name":"Xã Bình Xa","type":"xa","slug":"xa-binh-xa","name_with_type":"Xã Bình Xa","path":"Xã Bình Xa, Huyện Hàm Yên, Tỉnh Tuyên Quang","path_with_type":"Xã Bình Xa, Huyện Hàm Yên, Tỉnh Tuyên Quang","code":"02404","parent_code":"074"},"02407":{"name":"Xã Thái Sơn","type":"xa","slug":"xa-thai-son","name_with_type":"Xã Thái Sơn","path":"Xã Thái Sơn, Huyện Hàm Yên, Tỉnh Tuyên Quang","path_with_type":"Xã Thái Sơn, Huyện Hàm Yên, Tỉnh Tuyên Quang","code":"02407","parent_code":"074"},"02410":{"name":"Xã Nhân Mục","type":"xa","slug":"xa-nhan-muc","name_with_type":"Xã Nhân Mục","path":"Xã Nhân Mục, Huyện Hàm Yên, Tỉnh Tuyên Quang","path_with_type":"Xã Nhân Mục, Huyện Hàm Yên, Tỉnh Tuyên Quang","code":"02410","parent_code":"074"},"02413":{"name":"Xã Thành Long","type":"xa","slug":"xa-thanh-long","name_with_type":"Xã Thành Long","path":"Xã Thành Long, Huyện Hàm Yên, Tỉnh Tuyên Quang","path_with_type":"Xã Thành Long, Huyện Hàm Yên, Tỉnh Tuyên Quang","code":"02413","parent_code":"074"},"02416":{"name":"Xã Bằng Cốc","type":"xa","slug":"xa-bang-coc","name_with_type":"Xã Bằng Cốc","path":"Xã Bằng Cốc, Huyện Hàm Yên, Tỉnh Tuyên Quang","path_with_type":"Xã Bằng Cốc, Huyện Hàm Yên, Tỉnh Tuyên Quang","code":"02416","parent_code":"074"},"02419":{"name":"Xã Thái Hòa","type":"xa","slug":"xa-thai-hoa","name_with_type":"Xã Thái Hòa","path":"Xã Thái Hòa, Huyện Hàm Yên, Tỉnh Tuyên Quang","path_with_type":"Xã Thái Hòa, Huyện Hàm Yên, Tỉnh Tuyên Quang","code":"02419","parent_code":"074"},"02422":{"name":"Xã Đức Ninh","type":"xa","slug":"xa-duc-ninh","name_with_type":"Xã Đức Ninh","path":"Xã Đức Ninh, Huyện Hàm Yên, Tỉnh Tuyên Quang","path_with_type":"Xã Đức Ninh, Huyện Hàm Yên, Tỉnh Tuyên Quang","code":"02422","parent_code":"074"},"02425":{"name":"Xã Hùng Đức","type":"xa","slug":"xa-hung-duc","name_with_type":"Xã Hùng Đức","path":"Xã Hùng Đức, Huyện Hàm Yên, Tỉnh Tuyên Quang","path_with_type":"Xã Hùng Đức, Huyện Hàm Yên, Tỉnh Tuyên Quang","code":"02425","parent_code":"074"},"02431":{"name":"Xã Quí Quân","type":"xa","slug":"xa-qui-quan","name_with_type":"Xã Quí Quân","path":"Xã Quí Quân, Huyện Yên Sơn, Tỉnh Tuyên Quang","path_with_type":"Xã Quí Quân, Huyện Yên Sơn, Tỉnh Tuyên Quang","code":"02431","parent_code":"075"},"02434":{"name":"Xã Lực Hành","type":"xa","slug":"xa-luc-hanh","name_with_type":"Xã Lực Hành","path":"Xã Lực Hành, Huyện Yên Sơn, Tỉnh Tuyên Quang","path_with_type":"Xã Lực Hành, Huyện Yên Sơn, Tỉnh Tuyên Quang","code":"02434","parent_code":"075"},"02437":{"name":"Xã Kiến Thiết","type":"xa","slug":"xa-kien-thiet","name_with_type":"Xã Kiến Thiết","path":"Xã Kiến Thiết, Huyện Yên Sơn, Tỉnh Tuyên Quang","path_with_type":"Xã Kiến Thiết, Huyện Yên Sơn, Tỉnh Tuyên Quang","code":"02437","parent_code":"075"},"02440":{"name":"Xã Trung Minh","type":"xa","slug":"xa-trung-minh","name_with_type":"Xã Trung Minh","path":"Xã Trung Minh, Huyện Yên Sơn, Tỉnh Tuyên Quang","path_with_type":"Xã Trung Minh, Huyện Yên Sơn, Tỉnh Tuyên Quang","code":"02440","parent_code":"075"},"02443":{"name":"Xã Chiêu Yên","type":"xa","slug":"xa-chieu-yen","name_with_type":"Xã Chiêu Yên","path":"Xã Chiêu Yên, Huyện Yên Sơn, Tỉnh Tuyên Quang","path_with_type":"Xã Chiêu Yên, Huyện Yên Sơn, Tỉnh Tuyên Quang","code":"02443","parent_code":"075"},"02446":{"name":"Xã Trung Trực","type":"xa","slug":"xa-trung-truc","name_with_type":"Xã Trung Trực","path":"Xã Trung Trực, Huyện Yên Sơn, Tỉnh Tuyên Quang","path_with_type":"Xã Trung Trực, Huyện Yên Sơn, Tỉnh Tuyên Quang","code":"02446","parent_code":"075"},"02449":{"name":"Xã Xuân Vân","type":"xa","slug":"xa-xuan-van","name_with_type":"Xã Xuân Vân","path":"Xã Xuân Vân, Huyện Yên Sơn, Tỉnh Tuyên Quang","path_with_type":"Xã Xuân Vân, Huyện Yên Sơn, Tỉnh Tuyên Quang","code":"02449","parent_code":"075"},"02452":{"name":"Xã Phúc Ninh","type":"xa","slug":"xa-phuc-ninh","name_with_type":"Xã Phúc Ninh","path":"Xã Phúc Ninh, Huyện Yên Sơn, Tỉnh Tuyên Quang","path_with_type":"Xã Phúc Ninh, Huyện Yên Sơn, Tỉnh Tuyên Quang","code":"02452","parent_code":"075"},"02455":{"name":"Xã Hùng Lợi","type":"xa","slug":"xa-hung-loi","name_with_type":"Xã Hùng Lợi","path":"Xã Hùng Lợi, Huyện Yên Sơn, Tỉnh Tuyên Quang","path_with_type":"Xã Hùng Lợi, Huyện Yên Sơn, Tỉnh Tuyên Quang","code":"02455","parent_code":"075"},"02458":{"name":"Xã Trung Sơn","type":"xa","slug":"xa-trung-son","name_with_type":"Xã Trung Sơn","path":"Xã Trung Sơn, Huyện Yên Sơn, Tỉnh Tuyên Quang","path_with_type":"Xã Trung Sơn, Huyện Yên Sơn, Tỉnh Tuyên Quang","code":"02458","parent_code":"075"},"02461":{"name":"Xã Tân Tiến","type":"xa","slug":"xa-tan-tien","name_with_type":"Xã Tân Tiến","path":"Xã Tân Tiến, Huyện Yên Sơn, Tỉnh Tuyên Quang","path_with_type":"Xã Tân Tiến, Huyện Yên Sơn, Tỉnh Tuyên Quang","code":"02461","parent_code":"075"},"02464":{"name":"Xã Tứ Quận","type":"xa","slug":"xa-tu-quan","name_with_type":"Xã Tứ Quận","path":"Xã Tứ Quận, Huyện Yên Sơn, Tỉnh Tuyên Quang","path_with_type":"Xã Tứ Quận, Huyện Yên Sơn, Tỉnh Tuyên Quang","code":"02464","parent_code":"075"},"02467":{"name":"Xã Đạo Viện","type":"xa","slug":"xa-dao-vien","name_with_type":"Xã Đạo Viện","path":"Xã Đạo Viện, Huyện Yên Sơn, Tỉnh Tuyên Quang","path_with_type":"Xã Đạo Viện, Huyện Yên Sơn, Tỉnh Tuyên Quang","code":"02467","parent_code":"075"},"02470":{"name":"Xã Tân Long","type":"xa","slug":"xa-tan-long","name_with_type":"Xã Tân Long","path":"Xã Tân Long, Huyện Yên Sơn, Tỉnh Tuyên Quang","path_with_type":"Xã Tân Long, Huyện Yên Sơn, Tỉnh Tuyên Quang","code":"02470","parent_code":"075"},"02473":{"name":"Thị trấn Yên Sơn","type":"thi-tran","slug":"thi-tran-yen-son","name_with_type":"Thị trấn Yên Sơn","path":"Thị trấn Yên Sơn, Huyện Yên Sơn, Tỉnh Tuyên Quang","path_with_type":"Thị trấn Yên Sơn, Huyện Yên Sơn, Tỉnh Tuyên Quang","code":"02473","parent_code":"075"},"02476":{"name":"Xã Kim Quan","type":"xa","slug":"xa-kim-quan","name_with_type":"Xã Kim Quan","path":"Xã Kim Quan, Huyện Yên Sơn, Tỉnh Tuyên Quang","path_with_type":"Xã Kim Quan, Huyện Yên Sơn, Tỉnh Tuyên Quang","code":"02476","parent_code":"075"},"02479":{"name":"Xã Lang Quán","type":"xa","slug":"xa-lang-quan","name_with_type":"Xã Lang Quán","path":"Xã Lang Quán, Huyện Yên Sơn, Tỉnh Tuyên Quang","path_with_type":"Xã Lang Quán, Huyện Yên Sơn, Tỉnh Tuyên Quang","code":"02479","parent_code":"075"},"02482":{"name":"Xã Phú Thịnh","type":"xa","slug":"xa-phu-thinh","name_with_type":"Xã Phú Thịnh","path":"Xã Phú Thịnh, Huyện Yên Sơn, Tỉnh Tuyên Quang","path_with_type":"Xã Phú Thịnh, Huyện Yên Sơn, Tỉnh Tuyên Quang","code":"02482","parent_code":"075"},"02485":{"name":"Xã Công Đa","type":"xa","slug":"xa-cong-da","name_with_type":"Xã Công Đa","path":"Xã Công Đa, Huyện Yên Sơn, Tỉnh Tuyên Quang","path_with_type":"Xã Công Đa, Huyện Yên Sơn, Tỉnh Tuyên Quang","code":"02485","parent_code":"075"},"02488":{"name":"Xã Trung Môn","type":"xa","slug":"xa-trung-mon","name_with_type":"Xã Trung Môn","path":"Xã Trung Môn, Huyện Yên Sơn, Tỉnh Tuyên Quang","path_with_type":"Xã Trung Môn, Huyện Yên Sơn, Tỉnh Tuyên Quang","code":"02488","parent_code":"075"},"02491":{"name":"Xã Chân Sơn","type":"xa","slug":"xa-chan-son","name_with_type":"Xã Chân Sơn","path":"Xã Chân Sơn, Huyện Yên Sơn, Tỉnh Tuyên Quang","path_with_type":"Xã Chân Sơn, Huyện Yên Sơn, Tỉnh Tuyên Quang","code":"02491","parent_code":"075"},"02494":{"name":"Xã Thái Bình","type":"xa","slug":"xa-thai-binh","name_with_type":"Xã Thái Bình","path":"Xã Thái Bình, Huyện Yên Sơn, Tỉnh Tuyên Quang","path_with_type":"Xã Thái Bình, Huyện Yên Sơn, Tỉnh Tuyên Quang","code":"02494","parent_code":"075"},"02500":{"name":"Xã Tiến Bộ","type":"xa","slug":"xa-tien-bo","name_with_type":"Xã Tiến Bộ","path":"Xã Tiến Bộ, Huyện Yên Sơn, Tỉnh Tuyên Quang","path_with_type":"Xã Tiến Bộ, Huyện Yên Sơn, Tỉnh Tuyên Quang","code":"02500","parent_code":"075"},"02506":{"name":"Xã Mỹ Bằng","type":"xa","slug":"xa-my-bang","name_with_type":"Xã Mỹ Bằng","path":"Xã Mỹ Bằng, Huyện Yên Sơn, Tỉnh Tuyên Quang","path_with_type":"Xã Mỹ Bằng, Huyện Yên Sơn, Tỉnh Tuyên Quang","code":"02506","parent_code":"075"},"02518":{"name":"Xã Hoàng Khai","type":"xa","slug":"xa-hoang-khai","name_with_type":"Xã Hoàng Khai","path":"Xã Hoàng Khai, Huyện Yên Sơn, Tỉnh Tuyên Quang","path_with_type":"Xã Hoàng Khai, Huyện Yên Sơn, Tỉnh Tuyên Quang","code":"02518","parent_code":"075"},"02527":{"name":"Xã Nhữ Hán","type":"xa","slug":"xa-nhu-han","name_with_type":"Xã Nhữ Hán","path":"Xã Nhữ Hán, Huyện Yên Sơn, Tỉnh Tuyên Quang","path_with_type":"Xã Nhữ Hán, Huyện Yên Sơn, Tỉnh Tuyên Quang","code":"02527","parent_code":"075"},"02530":{"name":"Xã Nhữ Khê","type":"xa","slug":"xa-nhu-khe","name_with_type":"Xã Nhữ Khê","path":"Xã Nhữ Khê, Huyện Yên Sơn, Tỉnh Tuyên Quang","path_with_type":"Xã Nhữ Khê, Huyện Yên Sơn, Tỉnh Tuyên Quang","code":"02530","parent_code":"075"},"02533":{"name":"Xã Đội Bình","type":"xa","slug":"xa-doi-binh","name_with_type":"Xã Đội Bình","path":"Xã Đội Bình, Huyện Yên Sơn, Tỉnh Tuyên Quang","path_with_type":"Xã Đội Bình, Huyện Yên Sơn, Tỉnh Tuyên Quang","code":"02533","parent_code":"075"},"02536":{"name":"Thị trấn Sơn Dương","type":"thi-tran","slug":"thi-tran-son-duong","name_with_type":"Thị trấn Sơn Dương","path":"Thị trấn Sơn Dương, Huyện Sơn Dương, Tỉnh Tuyên Quang","path_with_type":"Thị trấn Sơn Dương, Huyện Sơn Dương, Tỉnh Tuyên Quang","code":"02536","parent_code":"076"},"02539":{"name":"Xã Trung Yên","type":"xa","slug":"xa-trung-yen","name_with_type":"Xã Trung Yên","path":"Xã Trung Yên, Huyện Sơn Dương, Tỉnh Tuyên Quang","path_with_type":"Xã Trung Yên, Huyện Sơn Dương, Tỉnh Tuyên Quang","code":"02539","parent_code":"076"},"02542":{"name":"Xã Minh Thanh","type":"xa","slug":"xa-minh-thanh","name_with_type":"Xã Minh Thanh","path":"Xã Minh Thanh, Huyện Sơn Dương, Tỉnh Tuyên Quang","path_with_type":"Xã Minh Thanh, Huyện Sơn Dương, Tỉnh Tuyên Quang","code":"02542","parent_code":"076"},"02545":{"name":"Xã Tân Trào","type":"xa","slug":"xa-tan-trao","name_with_type":"Xã Tân Trào","path":"Xã Tân Trào, Huyện Sơn Dương, Tỉnh Tuyên Quang","path_with_type":"Xã Tân Trào, Huyện Sơn Dương, Tỉnh Tuyên Quang","code":"02545","parent_code":"076"},"02548":{"name":"Xã Vĩnh Lợi","type":"xa","slug":"xa-vinh-loi","name_with_type":"Xã Vĩnh Lợi","path":"Xã Vĩnh Lợi, Huyện Sơn Dương, Tỉnh Tuyên Quang","path_with_type":"Xã Vĩnh Lợi, Huyện Sơn Dương, Tỉnh Tuyên Quang","code":"02548","parent_code":"076"},"02551":{"name":"Xã Thượng Ấm","type":"xa","slug":"xa-thuong-am","name_with_type":"Xã Thượng Ấm","path":"Xã Thượng Ấm, Huyện Sơn Dương, Tỉnh Tuyên Quang","path_with_type":"Xã Thượng Ấm, Huyện Sơn Dương, Tỉnh Tuyên Quang","code":"02551","parent_code":"076"},"02554":{"name":"Xã Bình Yên","type":"xa","slug":"xa-binh-yen","name_with_type":"Xã Bình Yên","path":"Xã Bình Yên, Huyện Sơn Dương, Tỉnh Tuyên Quang","path_with_type":"Xã Bình Yên, Huyện Sơn Dương, Tỉnh Tuyên Quang","code":"02554","parent_code":"076"},"02557":{"name":"Xã Lương Thiện","type":"xa","slug":"xa-luong-thien","name_with_type":"Xã Lương Thiện","path":"Xã Lương Thiện, Huyện Sơn Dương, Tỉnh Tuyên Quang","path_with_type":"Xã Lương Thiện, Huyện Sơn Dương, Tỉnh Tuyên Quang","code":"02557","parent_code":"076"},"02560":{"name":"Xã Tú Thịnh","type":"xa","slug":"xa-tu-thinh","name_with_type":"Xã Tú Thịnh","path":"Xã Tú Thịnh, Huyện Sơn Dương, Tỉnh Tuyên Quang","path_with_type":"Xã Tú Thịnh, Huyện Sơn Dương, Tỉnh Tuyên Quang","code":"02560","parent_code":"076"},"02563":{"name":"Xã Cấp Tiến","type":"xa","slug":"xa-cap-tien","name_with_type":"Xã Cấp Tiến","path":"Xã Cấp Tiến, Huyện Sơn Dương, Tỉnh Tuyên Quang","path_with_type":"Xã Cấp Tiến, Huyện Sơn Dương, Tỉnh Tuyên Quang","code":"02563","parent_code":"076"},"02566":{"name":"Xã Hợp Thành","type":"xa","slug":"xa-hop-thanh","name_with_type":"Xã Hợp Thành","path":"Xã Hợp Thành, Huyện Sơn Dương, Tỉnh Tuyên Quang","path_with_type":"Xã Hợp Thành, Huyện Sơn Dương, Tỉnh Tuyên Quang","code":"02566","parent_code":"076"},"02569":{"name":"Xã Phúc Ứng","type":"xa","slug":"xa-phuc-ung","name_with_type":"Xã Phúc Ứng","path":"Xã Phúc Ứng, Huyện Sơn Dương, Tỉnh Tuyên Quang","path_with_type":"Xã Phúc Ứng, Huyện Sơn Dương, Tỉnh Tuyên Quang","code":"02569","parent_code":"076"},"02572":{"name":"Xã Đông Thọ","type":"xa","slug":"xa-dong-tho","name_with_type":"Xã Đông Thọ","path":"Xã Đông Thọ, Huyện Sơn Dương, Tỉnh Tuyên Quang","path_with_type":"Xã Đông Thọ, Huyện Sơn Dương, Tỉnh Tuyên Quang","code":"02572","parent_code":"076"},"02575":{"name":"Xã Kháng Nhật","type":"xa","slug":"xa-khang-nhat","name_with_type":"Xã Kháng Nhật","path":"Xã Kháng Nhật, Huyện Sơn Dương, Tỉnh Tuyên Quang","path_with_type":"Xã Kháng Nhật, Huyện Sơn Dương, Tỉnh Tuyên Quang","code":"02575","parent_code":"076"},"02578":{"name":"Xã Hợp Hòa","type":"xa","slug":"xa-hop-hoa","name_with_type":"Xã Hợp Hòa","path":"Xã Hợp Hòa, Huyện Sơn Dương, Tỉnh Tuyên Quang","path_with_type":"Xã Hợp Hòa, Huyện Sơn Dương, Tỉnh Tuyên Quang","code":"02578","parent_code":"076"},"02584":{"name":"Xã Quyết Thắng","type":"xa","slug":"xa-quyet-thang","name_with_type":"Xã Quyết Thắng","path":"Xã Quyết Thắng, Huyện Sơn Dương, Tỉnh Tuyên Quang","path_with_type":"Xã Quyết Thắng, Huyện Sơn Dương, Tỉnh Tuyên Quang","code":"02584","parent_code":"076"},"02587":{"name":"Xã Đồng Quý","type":"xa","slug":"xa-dong-quy","name_with_type":"Xã Đồng Quý","path":"Xã Đồng Quý, Huyện Sơn Dương, Tỉnh Tuyên Quang","path_with_type":"Xã Đồng Quý, Huyện Sơn Dương, Tỉnh Tuyên Quang","code":"02587","parent_code":"076"},"02590":{"name":"Xã Tân Thanh","type":"xa","slug":"xa-tan-thanh","name_with_type":"Xã Tân Thanh","path":"Xã Tân Thanh, Huyện Sơn Dương, Tỉnh Tuyên Quang","path_with_type":"Xã Tân Thanh, Huyện Sơn Dương, Tỉnh Tuyên Quang","code":"02590","parent_code":"076"},"02596":{"name":"Xã Văn Phú","type":"xa","slug":"xa-van-phu","name_with_type":"Xã Văn Phú","path":"Xã Văn Phú, Huyện Sơn Dương, Tỉnh Tuyên Quang","path_with_type":"Xã Văn Phú, Huyện Sơn Dương, Tỉnh Tuyên Quang","code":"02596","parent_code":"076"},"02599":{"name":"Xã Chi Thiết","type":"xa","slug":"xa-chi-thiet","name_with_type":"Xã Chi Thiết","path":"Xã Chi Thiết, Huyện Sơn Dương, Tỉnh Tuyên Quang","path_with_type":"Xã Chi Thiết, Huyện Sơn Dương, Tỉnh Tuyên Quang","code":"02599","parent_code":"076"},"02602":{"name":"Xã Đông Lợi","type":"xa","slug":"xa-dong-loi","name_with_type":"Xã Đông Lợi","path":"Xã Đông Lợi, Huyện Sơn Dương, Tỉnh Tuyên Quang","path_with_type":"Xã Đông Lợi, Huyện Sơn Dương, Tỉnh Tuyên Quang","code":"02602","parent_code":"076"},"02605":{"name":"Xã Thiện Kế","type":"xa","slug":"xa-thien-ke","name_with_type":"Xã Thiện Kế","path":"Xã Thiện Kế, Huyện Sơn Dương, Tỉnh Tuyên Quang","path_with_type":"Xã Thiện Kế, Huyện Sơn Dương, Tỉnh Tuyên Quang","code":"02605","parent_code":"076"},"02608":{"name":"Xã Hồng Sơn","type":"xa","slug":"xa-hong-son","name_with_type":"Xã Hồng Sơn","path":"Xã Hồng Sơn, Huyện Sơn Dương, Tỉnh Tuyên Quang","path_with_type":"Xã Hồng Sơn, Huyện Sơn Dương, Tỉnh Tuyên Quang","code":"02608","parent_code":"076"},"02611":{"name":"Xã Phú Lương","type":"xa","slug":"xa-phu-luong","name_with_type":"Xã Phú Lương","path":"Xã Phú Lương, Huyện Sơn Dương, Tỉnh Tuyên Quang","path_with_type":"Xã Phú Lương, Huyện Sơn Dương, Tỉnh Tuyên Quang","code":"02611","parent_code":"076"},"02614":{"name":"Xã Ninh Lai","type":"xa","slug":"xa-ninh-lai","name_with_type":"Xã Ninh Lai","path":"Xã Ninh Lai, Huyện Sơn Dương, Tỉnh Tuyên Quang","path_with_type":"Xã Ninh Lai, Huyện Sơn Dương, Tỉnh Tuyên Quang","code":"02614","parent_code":"076"},"02617":{"name":"Xã Đại Phú","type":"xa","slug":"xa-dai-phu","name_with_type":"Xã Đại Phú","path":"Xã Đại Phú, Huyện Sơn Dương, Tỉnh Tuyên Quang","path_with_type":"Xã Đại Phú, Huyện Sơn Dương, Tỉnh Tuyên Quang","code":"02617","parent_code":"076"},"02620":{"name":"Xã Sơn Nam","type":"xa","slug":"xa-son-nam","name_with_type":"Xã Sơn Nam","path":"Xã Sơn Nam, Huyện Sơn Dương, Tỉnh Tuyên Quang","path_with_type":"Xã Sơn Nam, Huyện Sơn Dương, Tỉnh Tuyên Quang","code":"02620","parent_code":"076"},"02623":{"name":"Xã Hào Phú","type":"xa","slug":"xa-hao-phu","name_with_type":"Xã Hào Phú","path":"Xã Hào Phú, Huyện Sơn Dương, Tỉnh Tuyên Quang","path_with_type":"Xã Hào Phú, Huyện Sơn Dương, Tỉnh Tuyên Quang","code":"02623","parent_code":"076"},"02626":{"name":"Xã Tam Đa","type":"xa","slug":"xa-tam-da","name_with_type":"Xã Tam Đa","path":"Xã Tam Đa, Huyện Sơn Dương, Tỉnh Tuyên Quang","path_with_type":"Xã Tam Đa, Huyện Sơn Dương, Tỉnh Tuyên Quang","code":"02626","parent_code":"076"},"02632":{"name":"Xã Trường Sinh","type":"xa","slug":"xa-truong-sinh","name_with_type":"Xã Trường Sinh","path":"Xã Trường Sinh, Huyện Sơn Dương, Tỉnh Tuyên Quang","path_with_type":"Xã Trường Sinh, Huyện Sơn Dương, Tỉnh Tuyên Quang","code":"02632","parent_code":"076"},"02635":{"name":"Phường Duyên Hải","type":"phuong","slug":"phuong-duyen-hai","name_with_type":"Phường Duyên Hải","path":"Phường Duyên Hải, Thành phố Lào Cai, Tỉnh Lào Cai","path_with_type":"Phường Duyên Hải, Thành phố Lào Cai, Tỉnh Lào Cai","code":"02635","parent_code":"080"},"02641":{"name":"Phường Lào Cai","type":"phuong","slug":"phuong-lao-cai","name_with_type":"Phường Lào Cai","path":"Phường Lào Cai, Thành phố Lào Cai, Tỉnh Lào Cai","path_with_type":"Phường Lào Cai, Thành phố Lào Cai, Tỉnh Lào Cai","code":"02641","parent_code":"080"},"02644":{"name":"Phường Cốc Lếu","type":"phuong","slug":"phuong-coc-leu","name_with_type":"Phường Cốc Lếu","path":"Phường Cốc Lếu, Thành phố Lào Cai, Tỉnh Lào Cai","path_with_type":"Phường Cốc Lếu, Thành phố Lào Cai, Tỉnh Lào Cai","code":"02644","parent_code":"080"},"02647":{"name":"Phường Kim Tân","type":"phuong","slug":"phuong-kim-tan","name_with_type":"Phường Kim Tân","path":"Phường Kim Tân, Thành phố Lào Cai, Tỉnh Lào Cai","path_with_type":"Phường Kim Tân, Thành phố Lào Cai, Tỉnh Lào Cai","code":"02647","parent_code":"080"},"02650":{"name":"Phường Bắc Lệnh","type":"phuong","slug":"phuong-bac-lenh","name_with_type":"Phường Bắc Lệnh","path":"Phường Bắc Lệnh, Thành phố Lào Cai, Tỉnh Lào Cai","path_with_type":"Phường Bắc Lệnh, Thành phố Lào Cai, Tỉnh Lào Cai","code":"02650","parent_code":"080"},"02653":{"name":"Phường Pom Hán","type":"phuong","slug":"phuong-pom-han","name_with_type":"Phường Pom Hán","path":"Phường Pom Hán, Thành phố Lào Cai, Tỉnh Lào Cai","path_with_type":"Phường Pom Hán, Thành phố Lào Cai, Tỉnh Lào Cai","code":"02653","parent_code":"080"},"02656":{"name":"Phường Xuân Tăng","type":"phuong","slug":"phuong-xuan-tang","name_with_type":"Phường Xuân Tăng","path":"Phường Xuân Tăng, Thành phố Lào Cai, Tỉnh Lào Cai","path_with_type":"Phường Xuân Tăng, Thành phố Lào Cai, Tỉnh Lào Cai","code":"02656","parent_code":"080"},"02658":{"name":"Phường Bình Minh","type":"phuong","slug":"phuong-binh-minh","name_with_type":"Phường Bình Minh","path":"Phường Bình Minh, Thành phố Lào Cai, Tỉnh Lào Cai","path_with_type":"Phường Bình Minh, Thành phố Lào Cai, Tỉnh Lào Cai","code":"02658","parent_code":"080"},"02659":{"name":"Xã Thống Nhất","type":"xa","slug":"xa-thong-nhat","name_with_type":"Xã Thống Nhất","path":"Xã Thống Nhất, Thành phố Lào Cai, Tỉnh Lào Cai","path_with_type":"Xã Thống Nhất, Thành phố Lào Cai, Tỉnh Lào Cai","code":"02659","parent_code":"080"},"02662":{"name":"Xã Đồng Tuyển","type":"xa","slug":"xa-dong-tuyen","name_with_type":"Xã Đồng Tuyển","path":"Xã Đồng Tuyển, Thành phố Lào Cai, Tỉnh Lào Cai","path_with_type":"Xã Đồng Tuyển, Thành phố Lào Cai, Tỉnh Lào Cai","code":"02662","parent_code":"080"},"02665":{"name":"Xã Vạn Hoà","type":"xa","slug":"xa-van-hoa","name_with_type":"Xã Vạn Hoà","path":"Xã Vạn Hoà, Thành phố Lào Cai, Tỉnh Lào Cai","path_with_type":"Xã Vạn Hoà, Thành phố Lào Cai, Tỉnh Lào Cai","code":"02665","parent_code":"080"},"02668":{"name":"Phường Bắc Cường","type":"phuong","slug":"phuong-bac-cuong","name_with_type":"Phường Bắc Cường","path":"Phường Bắc Cường, Thành phố Lào Cai, Tỉnh Lào Cai","path_with_type":"Phường Bắc Cường, Thành phố Lào Cai, Tỉnh Lào Cai","code":"02668","parent_code":"080"},"02671":{"name":"Phường Nam Cường","type":"phuong","slug":"phuong-nam-cuong","name_with_type":"Phường Nam Cường","path":"Phường Nam Cường, Thành phố Lào Cai, Tỉnh Lào Cai","path_with_type":"Phường Nam Cường, Thành phố Lào Cai, Tỉnh Lào Cai","code":"02671","parent_code":"080"},"02674":{"name":"Xã Cam Đường","type":"xa","slug":"xa-cam-duong","name_with_type":"Xã Cam Đường","path":"Xã Cam Đường, Thành phố Lào Cai, Tỉnh Lào Cai","path_with_type":"Xã Cam Đường, Thành phố Lào Cai, Tỉnh Lào Cai","code":"02674","parent_code":"080"},"02677":{"name":"Xã Tả Phời","type":"xa","slug":"xa-ta-phoi","name_with_type":"Xã Tả Phời","path":"Xã Tả Phời, Thành phố Lào Cai, Tỉnh Lào Cai","path_with_type":"Xã Tả Phời, Thành phố Lào Cai, Tỉnh Lào Cai","code":"02677","parent_code":"080"},"02680":{"name":"Xã Hợp Thành","type":"xa","slug":"xa-hop-thanh","name_with_type":"Xã Hợp Thành","path":"Xã Hợp Thành, Thành phố Lào Cai, Tỉnh Lào Cai","path_with_type":"Xã Hợp Thành, Thành phố Lào Cai, Tỉnh Lào Cai","code":"02680","parent_code":"080"},"02746":{"name":"Xã Cốc San","type":"xa","slug":"xa-coc-san","name_with_type":"Xã Cốc San","path":"Xã Cốc San, Thành phố Lào Cai, Tỉnh Lào Cai","path_with_type":"Xã Cốc San, Thành phố Lào Cai, Tỉnh Lào Cai","code":"02746","parent_code":"080"},"02683":{"name":"Thị trấn Bát Xát","type":"thi-tran","slug":"thi-tran-bat-xat","name_with_type":"Thị trấn Bát Xát","path":"Thị trấn Bát Xát, Huyện Bát Xát, Tỉnh Lào Cai","path_with_type":"Thị trấn Bát Xát, Huyện Bát Xát, Tỉnh Lào Cai","code":"02683","parent_code":"082"},"02686":{"name":"Xã A Mú Sung","type":"xa","slug":"xa-a-mu-sung","name_with_type":"Xã A Mú Sung","path":"Xã A Mú Sung, Huyện Bát Xát, Tỉnh Lào Cai","path_with_type":"Xã A Mú Sung, Huyện Bát Xát, Tỉnh Lào Cai","code":"02686","parent_code":"082"},"02689":{"name":"Xã Nậm Chạc","type":"xa","slug":"xa-nam-chac","name_with_type":"Xã Nậm Chạc","path":"Xã Nậm Chạc, Huyện Bát Xát, Tỉnh Lào Cai","path_with_type":"Xã Nậm Chạc, Huyện Bát Xát, Tỉnh Lào Cai","code":"02689","parent_code":"082"},"02692":{"name":"Xã A Lù","type":"xa","slug":"xa-a-lu","name_with_type":"Xã A Lù","path":"Xã A Lù, Huyện Bát Xát, Tỉnh Lào Cai","path_with_type":"Xã A Lù, Huyện Bát Xát, Tỉnh Lào Cai","code":"02692","parent_code":"082"},"02695":{"name":"Xã Trịnh Tường","type":"xa","slug":"xa-trinh-tuong","name_with_type":"Xã Trịnh Tường","path":"Xã Trịnh Tường, Huyện Bát Xát, Tỉnh Lào Cai","path_with_type":"Xã Trịnh Tường, Huyện Bát Xát, Tỉnh Lào Cai","code":"02695","parent_code":"082"},"02701":{"name":"Xã Y Tý","type":"xa","slug":"xa-y-ty","name_with_type":"Xã Y Tý","path":"Xã Y Tý, Huyện Bát Xát, Tỉnh Lào Cai","path_with_type":"Xã Y Tý, Huyện Bát Xát, Tỉnh Lào Cai","code":"02701","parent_code":"082"},"02704":{"name":"Xã Cốc Mỳ","type":"xa","slug":"xa-coc-my","name_with_type":"Xã Cốc Mỳ","path":"Xã Cốc Mỳ, Huyện Bát Xát, Tỉnh Lào Cai","path_with_type":"Xã Cốc Mỳ, Huyện Bát Xát, Tỉnh Lào Cai","code":"02704","parent_code":"082"},"02707":{"name":"Xã Dền Sáng","type":"xa","slug":"xa-den-sang","name_with_type":"Xã Dền Sáng","path":"Xã Dền Sáng, Huyện Bát Xát, Tỉnh Lào Cai","path_with_type":"Xã Dền Sáng, Huyện Bát Xát, Tỉnh Lào Cai","code":"02707","parent_code":"082"},"02710":{"name":"Xã Bản Vược","type":"xa","slug":"xa-ban-vuoc","name_with_type":"Xã Bản Vược","path":"Xã Bản Vược, Huyện Bát Xát, Tỉnh Lào Cai","path_with_type":"Xã Bản Vược, Huyện Bát Xát, Tỉnh Lào Cai","code":"02710","parent_code":"082"},"02713":{"name":"Xã Sàng Ma Sáo","type":"xa","slug":"xa-sang-ma-sao","name_with_type":"Xã Sàng Ma Sáo","path":"Xã Sàng Ma Sáo, Huyện Bát Xát, Tỉnh Lào Cai","path_with_type":"Xã Sàng Ma Sáo, Huyện Bát Xát, Tỉnh Lào Cai","code":"02713","parent_code":"082"},"02716":{"name":"Xã Bản Qua","type":"xa","slug":"xa-ban-qua","name_with_type":"Xã Bản Qua","path":"Xã Bản Qua, Huyện Bát Xát, Tỉnh Lào Cai","path_with_type":"Xã Bản Qua, Huyện Bát Xát, Tỉnh Lào Cai","code":"02716","parent_code":"082"},"02719":{"name":"Xã Mường Vi","type":"xa","slug":"xa-muong-vi","name_with_type":"Xã Mường Vi","path":"Xã Mường Vi, Huyện Bát Xát, Tỉnh Lào Cai","path_with_type":"Xã Mường Vi, Huyện Bát Xát, Tỉnh Lào Cai","code":"02719","parent_code":"082"},"02722":{"name":"Xã Dền Thàng","type":"xa","slug":"xa-den-thang","name_with_type":"Xã Dền Thàng","path":"Xã Dền Thàng, Huyện Bát Xát, Tỉnh Lào Cai","path_with_type":"Xã Dền Thàng, Huyện Bát Xát, Tỉnh Lào Cai","code":"02722","parent_code":"082"},"02725":{"name":"Xã Bản Xèo","type":"xa","slug":"xa-ban-xeo","name_with_type":"Xã Bản Xèo","path":"Xã Bản Xèo, Huyện Bát Xát, Tỉnh Lào Cai","path_with_type":"Xã Bản Xèo, Huyện Bát Xát, Tỉnh Lào Cai","code":"02725","parent_code":"082"},"02728":{"name":"Xã Mường Hum","type":"xa","slug":"xa-muong-hum","name_with_type":"Xã Mường Hum","path":"Xã Mường Hum, Huyện Bát Xát, Tỉnh Lào Cai","path_with_type":"Xã Mường Hum, Huyện Bát Xát, Tỉnh Lào Cai","code":"02728","parent_code":"082"},"02731":{"name":"Xã Trung Lèng Hồ","type":"xa","slug":"xa-trung-leng-ho","name_with_type":"Xã Trung Lèng Hồ","path":"Xã Trung Lèng Hồ, Huyện Bát Xát, Tỉnh Lào Cai","path_with_type":"Xã Trung Lèng Hồ, Huyện Bát Xát, Tỉnh Lào Cai","code":"02731","parent_code":"082"},"02734":{"name":"Xã Quang Kim","type":"xa","slug":"xa-quang-kim","name_with_type":"Xã Quang Kim","path":"Xã Quang Kim, Huyện Bát Xát, Tỉnh Lào Cai","path_with_type":"Xã Quang Kim, Huyện Bát Xát, Tỉnh Lào Cai","code":"02734","parent_code":"082"},"02737":{"name":"Xã Pa Cheo","type":"xa","slug":"xa-pa-cheo","name_with_type":"Xã Pa Cheo","path":"Xã Pa Cheo, Huyện Bát Xát, Tỉnh Lào Cai","path_with_type":"Xã Pa Cheo, Huyện Bát Xát, Tỉnh Lào Cai","code":"02737","parent_code":"082"},"02740":{"name":"Xã Nậm Pung","type":"xa","slug":"xa-nam-pung","name_with_type":"Xã Nậm Pung","path":"Xã Nậm Pung, Huyện Bát Xát, Tỉnh Lào Cai","path_with_type":"Xã Nậm Pung, Huyện Bát Xát, Tỉnh Lào Cai","code":"02740","parent_code":"082"},"02743":{"name":"Xã Phìn Ngan","type":"xa","slug":"xa-phin-ngan","name_with_type":"Xã Phìn Ngan","path":"Xã Phìn Ngan, Huyện Bát Xát, Tỉnh Lào Cai","path_with_type":"Xã Phìn Ngan, Huyện Bát Xát, Tỉnh Lào Cai","code":"02743","parent_code":"082"},"02749":{"name":"Xã Tòng Sành","type":"xa","slug":"xa-tong-sanh","name_with_type":"Xã Tòng Sành","path":"Xã Tòng Sành, Huyện Bát Xát, Tỉnh Lào Cai","path_with_type":"Xã Tòng Sành, Huyện Bát Xát, Tỉnh Lào Cai","code":"02749","parent_code":"082"},"02752":{"name":"Xã Pha Long","type":"xa","slug":"xa-pha-long","name_with_type":"Xã Pha Long","path":"Xã Pha Long, Huyện Mường Khương, Tỉnh Lào Cai","path_with_type":"Xã Pha Long, Huyện Mường Khương, Tỉnh Lào Cai","code":"02752","parent_code":"083"},"02755":{"name":"Xã Tả Ngải Chồ","type":"xa","slug":"xa-ta-ngai-cho","name_with_type":"Xã Tả Ngải Chồ","path":"Xã Tả Ngải Chồ, Huyện Mường Khương, Tỉnh Lào Cai","path_with_type":"Xã Tả Ngải Chồ, Huyện Mường Khương, Tỉnh Lào Cai","code":"02755","parent_code":"083"},"02758":{"name":"Xã Tung Chung Phố","type":"xa","slug":"xa-tung-chung-pho","name_with_type":"Xã Tung Chung Phố","path":"Xã Tung Chung Phố, Huyện Mường Khương, Tỉnh Lào Cai","path_with_type":"Xã Tung Chung Phố, Huyện Mường Khương, Tỉnh Lào Cai","code":"02758","parent_code":"083"},"02761":{"name":"Thị trấn Mường Khương","type":"thi-tran","slug":"thi-tran-muong-khuong","name_with_type":"Thị trấn Mường Khương","path":"Thị trấn Mường Khương, Huyện Mường Khương, Tỉnh Lào Cai","path_with_type":"Thị trấn Mường Khương, Huyện Mường Khương, Tỉnh Lào Cai","code":"02761","parent_code":"083"},"02764":{"name":"Xã Dìn Chin","type":"xa","slug":"xa-din-chin","name_with_type":"Xã Dìn Chin","path":"Xã Dìn Chin, Huyện Mường Khương, Tỉnh Lào Cai","path_with_type":"Xã Dìn Chin, Huyện Mường Khương, Tỉnh Lào Cai","code":"02764","parent_code":"083"},"02767":{"name":"Xã Tả Gia Khâu","type":"xa","slug":"xa-ta-gia-khau","name_with_type":"Xã Tả Gia Khâu","path":"Xã Tả Gia Khâu, Huyện Mường Khương, Tỉnh Lào Cai","path_with_type":"Xã Tả Gia Khâu, Huyện Mường Khương, Tỉnh Lào Cai","code":"02767","parent_code":"083"},"02770":{"name":"Xã Nậm Chảy","type":"xa","slug":"xa-nam-chay","name_with_type":"Xã Nậm Chảy","path":"Xã Nậm Chảy, Huyện Mường Khương, Tỉnh Lào Cai","path_with_type":"Xã Nậm Chảy, Huyện Mường Khương, Tỉnh Lào Cai","code":"02770","parent_code":"083"},"02773":{"name":"Xã Nấm Lư","type":"xa","slug":"xa-nam-lu","name_with_type":"Xã Nấm Lư","path":"Xã Nấm Lư, Huyện Mường Khương, Tỉnh Lào Cai","path_with_type":"Xã Nấm Lư, Huyện Mường Khương, Tỉnh Lào Cai","code":"02773","parent_code":"083"},"02776":{"name":"Xã Lùng Khấu Nhin","type":"xa","slug":"xa-lung-khau-nhin","name_with_type":"Xã Lùng Khấu Nhin","path":"Xã Lùng Khấu Nhin, Huyện Mường Khương, Tỉnh Lào Cai","path_with_type":"Xã Lùng Khấu Nhin, Huyện Mường Khương, Tỉnh Lào Cai","code":"02776","parent_code":"083"},"02779":{"name":"Xã Thanh Bình","type":"xa","slug":"xa-thanh-binh","name_with_type":"Xã Thanh Bình","path":"Xã Thanh Bình, Huyện Mường Khương, Tỉnh Lào Cai","path_with_type":"Xã Thanh Bình, Huyện Mường Khương, Tỉnh Lào Cai","code":"02779","parent_code":"083"},"02782":{"name":"Xã Cao Sơn","type":"xa","slug":"xa-cao-son","name_with_type":"Xã Cao Sơn","path":"Xã Cao Sơn, Huyện Mường Khương, Tỉnh Lào Cai","path_with_type":"Xã Cao Sơn, Huyện Mường Khương, Tỉnh Lào Cai","code":"02782","parent_code":"083"},"02785":{"name":"Xã Lùng Vai","type":"xa","slug":"xa-lung-vai","name_with_type":"Xã Lùng Vai","path":"Xã Lùng Vai, Huyện Mường Khương, Tỉnh Lào Cai","path_with_type":"Xã Lùng Vai, Huyện Mường Khương, Tỉnh Lào Cai","code":"02785","parent_code":"083"},"02788":{"name":"Xã Bản Lầu","type":"xa","slug":"xa-ban-lau","name_with_type":"Xã Bản Lầu","path":"Xã Bản Lầu, Huyện Mường Khương, Tỉnh Lào Cai","path_with_type":"Xã Bản Lầu, Huyện Mường Khương, Tỉnh Lào Cai","code":"02788","parent_code":"083"},"02791":{"name":"Xã La Pan Tẩn","type":"xa","slug":"xa-la-pan-tan","name_with_type":"Xã La Pan Tẩn","path":"Xã La Pan Tẩn, Huyện Mường Khương, Tỉnh Lào Cai","path_with_type":"Xã La Pan Tẩn, Huyện Mường Khương, Tỉnh Lào Cai","code":"02791","parent_code":"083"},"02794":{"name":"Xã Tả Thàng","type":"xa","slug":"xa-ta-thang","name_with_type":"Xã Tả Thàng","path":"Xã Tả Thàng, Huyện Mường Khương, Tỉnh Lào Cai","path_with_type":"Xã Tả Thàng, Huyện Mường Khương, Tỉnh Lào Cai","code":"02794","parent_code":"083"},"02797":{"name":"Xã Bản Sen","type":"xa","slug":"xa-ban-sen","name_with_type":"Xã Bản Sen","path":"Xã Bản Sen, Huyện Mường Khương, Tỉnh Lào Cai","path_with_type":"Xã Bản Sen, Huyện Mường Khương, Tỉnh Lào Cai","code":"02797","parent_code":"083"},"02800":{"name":"Xã Nàn Sán","type":"xa","slug":"xa-nan-san","name_with_type":"Xã Nàn Sán","path":"Xã Nàn Sán, Huyện Si Ma Cai, Tỉnh Lào Cai","path_with_type":"Xã Nàn Sán, Huyện Si Ma Cai, Tỉnh Lào Cai","code":"02800","parent_code":"084"},"02803":{"name":"Xã Thào Chư Phìn","type":"xa","slug":"xa-thao-chu-phin","name_with_type":"Xã Thào Chư Phìn","path":"Xã Thào Chư Phìn, Huyện Si Ma Cai, Tỉnh Lào Cai","path_with_type":"Xã Thào Chư Phìn, Huyện Si Ma Cai, Tỉnh Lào Cai","code":"02803","parent_code":"084"},"02806":{"name":"Xã Bản Mế","type":"xa","slug":"xa-ban-me","name_with_type":"Xã Bản Mế","path":"Xã Bản Mế, Huyện Si Ma Cai, Tỉnh Lào Cai","path_with_type":"Xã Bản Mế, Huyện Si Ma Cai, Tỉnh Lào Cai","code":"02806","parent_code":"084"},"02809":{"name":"Thị trấn Si Ma Cai","type":"thi-tran","slug":"thi-tran-si-ma-cai","name_with_type":"Thị trấn Si Ma Cai","path":"Thị trấn Si Ma Cai, Huyện Si Ma Cai, Tỉnh Lào Cai","path_with_type":"Thị trấn Si Ma Cai, Huyện Si Ma Cai, Tỉnh Lào Cai","code":"02809","parent_code":"084"},"02812":{"name":"Xã Sán Chải","type":"xa","slug":"xa-san-chai","name_with_type":"Xã Sán Chải","path":"Xã Sán Chải, Huyện Si Ma Cai, Tỉnh Lào Cai","path_with_type":"Xã Sán Chải, Huyện Si Ma Cai, Tỉnh Lào Cai","code":"02812","parent_code":"084"},"02818":{"name":"Xã Lùng Thẩn","type":"xa","slug":"xa-lung-than","name_with_type":"Xã Lùng Thẩn","path":"Xã Lùng Thẩn, Huyện Si Ma Cai, Tỉnh Lào Cai","path_with_type":"Xã Lùng Thẩn, Huyện Si Ma Cai, Tỉnh Lào Cai","code":"02818","parent_code":"084"},"02821":{"name":"Xã Cán Cấu","type":"xa","slug":"xa-can-cau","name_with_type":"Xã Cán Cấu","path":"Xã Cán Cấu, Huyện Si Ma Cai, Tỉnh Lào Cai","path_with_type":"Xã Cán Cấu, Huyện Si Ma Cai, Tỉnh Lào Cai","code":"02821","parent_code":"084"},"02824":{"name":"Xã Sín Chéng","type":"xa","slug":"xa-sin-cheng","name_with_type":"Xã Sín Chéng","path":"Xã Sín Chéng, Huyện Si Ma Cai, Tỉnh Lào Cai","path_with_type":"Xã Sín Chéng, Huyện Si Ma Cai, Tỉnh Lào Cai","code":"02824","parent_code":"084"},"02827":{"name":"Xã Quan Hồ Thẩn","type":"xa","slug":"xa-quan-ho-than","name_with_type":"Xã Quan Hồ Thẩn","path":"Xã Quan Hồ Thẩn, Huyện Si Ma Cai, Tỉnh Lào Cai","path_with_type":"Xã Quan Hồ Thẩn, Huyện Si Ma Cai, Tỉnh Lào Cai","code":"02827","parent_code":"084"},"02836":{"name":"Xã Nàn Xín","type":"xa","slug":"xa-nan-xin","name_with_type":"Xã Nàn Xín","path":"Xã Nàn Xín, Huyện Si Ma Cai, Tỉnh Lào Cai","path_with_type":"Xã Nàn Xín, Huyện Si Ma Cai, Tỉnh Lào Cai","code":"02836","parent_code":"084"},"02839":{"name":"Thị trấn Bắc Hà","type":"thi-tran","slug":"thi-tran-bac-ha","name_with_type":"Thị trấn Bắc Hà","path":"Thị trấn Bắc Hà, Huyện Bắc Hà, Tỉnh Lào Cai","path_with_type":"Thị trấn Bắc Hà, Huyện Bắc Hà, Tỉnh Lào Cai","code":"02839","parent_code":"085"},"02842":{"name":"Xã Lùng Cải","type":"xa","slug":"xa-lung-cai","name_with_type":"Xã Lùng Cải","path":"Xã Lùng Cải, Huyện Bắc Hà, Tỉnh Lào Cai","path_with_type":"Xã Lùng Cải, Huyện Bắc Hà, Tỉnh Lào Cai","code":"02842","parent_code":"085"},"02848":{"name":"Xã Lùng Phình","type":"xa","slug":"xa-lung-phinh","name_with_type":"Xã Lùng Phình","path":"Xã Lùng Phình, Huyện Bắc Hà, Tỉnh Lào Cai","path_with_type":"Xã Lùng Phình, Huyện Bắc Hà, Tỉnh Lào Cai","code":"02848","parent_code":"085"},"02851":{"name":"Xã Tả Van Chư","type":"xa","slug":"xa-ta-van-chu","name_with_type":"Xã Tả Van Chư","path":"Xã Tả Van Chư, Huyện Bắc Hà, Tỉnh Lào Cai","path_with_type":"Xã Tả Van Chư, Huyện Bắc Hà, Tỉnh Lào Cai","code":"02851","parent_code":"085"},"02854":{"name":"Xã Tả Củ Tỷ","type":"xa","slug":"xa-ta-cu-ty","name_with_type":"Xã Tả Củ Tỷ","path":"Xã Tả Củ Tỷ, Huyện Bắc Hà, Tỉnh Lào Cai","path_with_type":"Xã Tả Củ Tỷ, Huyện Bắc Hà, Tỉnh Lào Cai","code":"02854","parent_code":"085"},"02857":{"name":"Xã Thải Giàng Phố","type":"xa","slug":"xa-thai-giang-pho","name_with_type":"Xã Thải Giàng Phố","path":"Xã Thải Giàng Phố, Huyện Bắc Hà, Tỉnh Lào Cai","path_with_type":"Xã Thải Giàng Phố, Huyện Bắc Hà, Tỉnh Lào Cai","code":"02857","parent_code":"085"},"02863":{"name":"Xã Hoàng Thu Phố","type":"xa","slug":"xa-hoang-thu-pho","name_with_type":"Xã Hoàng Thu Phố","path":"Xã Hoàng Thu Phố, Huyện Bắc Hà, Tỉnh Lào Cai","path_with_type":"Xã Hoàng Thu Phố, Huyện Bắc Hà, Tỉnh Lào Cai","code":"02863","parent_code":"085"},"02866":{"name":"Xã Bản Phố","type":"xa","slug":"xa-ban-pho","name_with_type":"Xã Bản Phố","path":"Xã Bản Phố, Huyện Bắc Hà, Tỉnh Lào Cai","path_with_type":"Xã Bản Phố, Huyện Bắc Hà, Tỉnh Lào Cai","code":"02866","parent_code":"085"},"02869":{"name":"Xã Bản Liền","type":"xa","slug":"xa-ban-lien","name_with_type":"Xã Bản Liền","path":"Xã Bản Liền, Huyện Bắc Hà, Tỉnh Lào Cai","path_with_type":"Xã Bản Liền, Huyện Bắc Hà, Tỉnh Lào Cai","code":"02869","parent_code":"085"},"02875":{"name":"Xã Na Hối","type":"xa","slug":"xa-na-hoi","name_with_type":"Xã Na Hối","path":"Xã Na Hối, Huyện Bắc Hà, Tỉnh Lào Cai","path_with_type":"Xã Na Hối, Huyện Bắc Hà, Tỉnh Lào Cai","code":"02875","parent_code":"085"},"02878":{"name":"Xã Cốc Ly","type":"xa","slug":"xa-coc-ly","name_with_type":"Xã Cốc Ly","path":"Xã Cốc Ly, Huyện Bắc Hà, Tỉnh Lào Cai","path_with_type":"Xã Cốc Ly, Huyện Bắc Hà, Tỉnh Lào Cai","code":"02878","parent_code":"085"},"02881":{"name":"Xã Nậm Mòn","type":"xa","slug":"xa-nam-mon","name_with_type":"Xã Nậm Mòn","path":"Xã Nậm Mòn, Huyện Bắc Hà, Tỉnh Lào Cai","path_with_type":"Xã Nậm Mòn, Huyện Bắc Hà, Tỉnh Lào Cai","code":"02881","parent_code":"085"},"02884":{"name":"Xã Nậm Đét","type":"xa","slug":"xa-nam-det","name_with_type":"Xã Nậm Đét","path":"Xã Nậm Đét, Huyện Bắc Hà, Tỉnh Lào Cai","path_with_type":"Xã Nậm Đét, Huyện Bắc Hà, Tỉnh Lào Cai","code":"02884","parent_code":"085"},"02887":{"name":"Xã Nậm Khánh","type":"xa","slug":"xa-nam-khanh","name_with_type":"Xã Nậm Khánh","path":"Xã Nậm Khánh, Huyện Bắc Hà, Tỉnh Lào Cai","path_with_type":"Xã Nậm Khánh, Huyện Bắc Hà, Tỉnh Lào Cai","code":"02887","parent_code":"085"},"02890":{"name":"Xã Bảo Nhai","type":"xa","slug":"xa-bao-nhai","name_with_type":"Xã Bảo Nhai","path":"Xã Bảo Nhai, Huyện Bắc Hà, Tỉnh Lào Cai","path_with_type":"Xã Bảo Nhai, Huyện Bắc Hà, Tỉnh Lào Cai","code":"02890","parent_code":"085"},"02893":{"name":"Xã Nậm Lúc","type":"xa","slug":"xa-nam-luc","name_with_type":"Xã Nậm Lúc","path":"Xã Nậm Lúc, Huyện Bắc Hà, Tỉnh Lào Cai","path_with_type":"Xã Nậm Lúc, Huyện Bắc Hà, Tỉnh Lào Cai","code":"02893","parent_code":"085"},"02896":{"name":"Xã Cốc Lầu","type":"xa","slug":"xa-coc-lau","name_with_type":"Xã Cốc Lầu","path":"Xã Cốc Lầu, Huyện Bắc Hà, Tỉnh Lào Cai","path_with_type":"Xã Cốc Lầu, Huyện Bắc Hà, Tỉnh Lào Cai","code":"02896","parent_code":"085"},"02899":{"name":"Xã Bản Cái","type":"xa","slug":"xa-ban-cai","name_with_type":"Xã Bản Cái","path":"Xã Bản Cái, Huyện Bắc Hà, Tỉnh Lào Cai","path_with_type":"Xã Bản Cái, Huyện Bắc Hà, Tỉnh Lào Cai","code":"02899","parent_code":"085"},"02902":{"name":"Thị trấn N.T Phong Hải","type":"thi-tran","slug":"thi-tran-n.t-phong-hai","name_with_type":"Thị trấn N.T Phong Hải","path":"Thị trấn N.T Phong Hải, Huyện Bảo Thắng, Tỉnh Lào Cai","path_with_type":"Thị trấn N.T Phong Hải, Huyện Bảo Thắng, Tỉnh Lào Cai","code":"02902","parent_code":"086"},"02905":{"name":"Thị trấn Phố Lu","type":"thi-tran","slug":"thi-tran-pho-lu","name_with_type":"Thị trấn Phố Lu","path":"Thị trấn Phố Lu, Huyện Bảo Thắng, Tỉnh Lào Cai","path_with_type":"Thị trấn Phố Lu, Huyện Bảo Thắng, Tỉnh Lào Cai","code":"02905","parent_code":"086"},"02908":{"name":"Thị trấn Tằng Loỏng","type":"thi-tran","slug":"thi-tran-tang-loong","name_with_type":"Thị trấn Tằng Loỏng","path":"Thị trấn Tằng Loỏng, Huyện Bảo Thắng, Tỉnh Lào Cai","path_with_type":"Thị trấn Tằng Loỏng, Huyện Bảo Thắng, Tỉnh Lào Cai","code":"02908","parent_code":"086"},"02911":{"name":"Xã Bản Phiệt","type":"xa","slug":"xa-ban-phiet","name_with_type":"Xã Bản Phiệt","path":"Xã Bản Phiệt, Huyện Bảo Thắng, Tỉnh Lào Cai","path_with_type":"Xã Bản Phiệt, Huyện Bảo Thắng, Tỉnh Lào Cai","code":"02911","parent_code":"086"},"02914":{"name":"Xã Bản Cầm","type":"xa","slug":"xa-ban-cam","name_with_type":"Xã Bản Cầm","path":"Xã Bản Cầm, Huyện Bảo Thắng, Tỉnh Lào Cai","path_with_type":"Xã Bản Cầm, Huyện Bảo Thắng, Tỉnh Lào Cai","code":"02914","parent_code":"086"},"02917":{"name":"Xã Thái Niên","type":"xa","slug":"xa-thai-nien","name_with_type":"Xã Thái Niên","path":"Xã Thái Niên, Huyện Bảo Thắng, Tỉnh Lào Cai","path_with_type":"Xã Thái Niên, Huyện Bảo Thắng, Tỉnh Lào Cai","code":"02917","parent_code":"086"},"02920":{"name":"Xã Phong Niên","type":"xa","slug":"xa-phong-nien","name_with_type":"Xã Phong Niên","path":"Xã Phong Niên, Huyện Bảo Thắng, Tỉnh Lào Cai","path_with_type":"Xã Phong Niên, Huyện Bảo Thắng, Tỉnh Lào Cai","code":"02920","parent_code":"086"},"02923":{"name":"Xã Gia Phú","type":"xa","slug":"xa-gia-phu","name_with_type":"Xã Gia Phú","path":"Xã Gia Phú, Huyện Bảo Thắng, Tỉnh Lào Cai","path_with_type":"Xã Gia Phú, Huyện Bảo Thắng, Tỉnh Lào Cai","code":"02923","parent_code":"086"},"02926":{"name":"Xã Xuân Quang","type":"xa","slug":"xa-xuan-quang","name_with_type":"Xã Xuân Quang","path":"Xã Xuân Quang, Huyện Bảo Thắng, Tỉnh Lào Cai","path_with_type":"Xã Xuân Quang, Huyện Bảo Thắng, Tỉnh Lào Cai","code":"02926","parent_code":"086"},"02929":{"name":"Xã Sơn Hải","type":"xa","slug":"xa-son-hai","name_with_type":"Xã Sơn Hải","path":"Xã Sơn Hải, Huyện Bảo Thắng, Tỉnh Lào Cai","path_with_type":"Xã Sơn Hải, Huyện Bảo Thắng, Tỉnh Lào Cai","code":"02929","parent_code":"086"},"02932":{"name":"Xã Xuân Giao","type":"xa","slug":"xa-xuan-giao","name_with_type":"Xã Xuân Giao","path":"Xã Xuân Giao, Huyện Bảo Thắng, Tỉnh Lào Cai","path_with_type":"Xã Xuân Giao, Huyện Bảo Thắng, Tỉnh Lào Cai","code":"02932","parent_code":"086"},"02935":{"name":"Xã Trì Quang","type":"xa","slug":"xa-tri-quang","name_with_type":"Xã Trì Quang","path":"Xã Trì Quang, Huyện Bảo Thắng, Tỉnh Lào Cai","path_with_type":"Xã Trì Quang, Huyện Bảo Thắng, Tỉnh Lào Cai","code":"02935","parent_code":"086"},"02938":{"name":"Xã Sơn Hà","type":"xa","slug":"xa-son-ha","name_with_type":"Xã Sơn Hà","path":"Xã Sơn Hà, Huyện Bảo Thắng, Tỉnh Lào Cai","path_with_type":"Xã Sơn Hà, Huyện Bảo Thắng, Tỉnh Lào Cai","code":"02938","parent_code":"086"},"02944":{"name":"Xã Phú Nhuận","type":"xa","slug":"xa-phu-nhuan","name_with_type":"Xã Phú Nhuận","path":"Xã Phú Nhuận, Huyện Bảo Thắng, Tỉnh Lào Cai","path_with_type":"Xã Phú Nhuận, Huyện Bảo Thắng, Tỉnh Lào Cai","code":"02944","parent_code":"086"},"02947":{"name":"Thị trấn Phố Ràng","type":"thi-tran","slug":"thi-tran-pho-rang","name_with_type":"Thị trấn Phố Ràng","path":"Thị trấn Phố Ràng, Huyện Bảo Yên, Tỉnh Lào Cai","path_with_type":"Thị trấn Phố Ràng, Huyện Bảo Yên, Tỉnh Lào Cai","code":"02947","parent_code":"087"},"02950":{"name":"Xã Tân Tiến","type":"xa","slug":"xa-tan-tien","name_with_type":"Xã Tân Tiến","path":"Xã Tân Tiến, Huyện Bảo Yên, Tỉnh Lào Cai","path_with_type":"Xã Tân Tiến, Huyện Bảo Yên, Tỉnh Lào Cai","code":"02950","parent_code":"087"},"02953":{"name":"Xã Nghĩa Đô","type":"xa","slug":"xa-nghia-do","name_with_type":"Xã Nghĩa Đô","path":"Xã Nghĩa Đô, Huyện Bảo Yên, Tỉnh Lào Cai","path_with_type":"Xã Nghĩa Đô, Huyện Bảo Yên, Tỉnh Lào Cai","code":"02953","parent_code":"087"},"02956":{"name":"Xã Vĩnh Yên","type":"xa","slug":"xa-vinh-yen","name_with_type":"Xã Vĩnh Yên","path":"Xã Vĩnh Yên, Huyện Bảo Yên, Tỉnh Lào Cai","path_with_type":"Xã Vĩnh Yên, Huyện Bảo Yên, Tỉnh Lào Cai","code":"02956","parent_code":"087"},"02959":{"name":"Xã Điện Quan","type":"xa","slug":"xa-dien-quan","name_with_type":"Xã Điện Quan","path":"Xã Điện Quan, Huyện Bảo Yên, Tỉnh Lào Cai","path_with_type":"Xã Điện Quan, Huyện Bảo Yên, Tỉnh Lào Cai","code":"02959","parent_code":"087"},"02962":{"name":"Xã Xuân Hoà","type":"xa","slug":"xa-xuan-hoa","name_with_type":"Xã Xuân Hoà","path":"Xã Xuân Hoà, Huyện Bảo Yên, Tỉnh Lào Cai","path_with_type":"Xã Xuân Hoà, Huyện Bảo Yên, Tỉnh Lào Cai","code":"02962","parent_code":"087"},"02965":{"name":"Xã Tân Dương","type":"xa","slug":"xa-tan-duong","name_with_type":"Xã Tân Dương","path":"Xã Tân Dương, Huyện Bảo Yên, Tỉnh Lào Cai","path_with_type":"Xã Tân Dương, Huyện Bảo Yên, Tỉnh Lào Cai","code":"02965","parent_code":"087"},"02968":{"name":"Xã Thượng Hà","type":"xa","slug":"xa-thuong-ha","name_with_type":"Xã Thượng Hà","path":"Xã Thượng Hà, Huyện Bảo Yên, Tỉnh Lào Cai","path_with_type":"Xã Thượng Hà, Huyện Bảo Yên, Tỉnh Lào Cai","code":"02968","parent_code":"087"},"02971":{"name":"Xã Kim Sơn","type":"xa","slug":"xa-kim-son","name_with_type":"Xã Kim Sơn","path":"Xã Kim Sơn, Huyện Bảo Yên, Tỉnh Lào Cai","path_with_type":"Xã Kim Sơn, Huyện Bảo Yên, Tỉnh Lào Cai","code":"02971","parent_code":"087"},"02974":{"name":"Xã Cam Cọn","type":"xa","slug":"xa-cam-con","name_with_type":"Xã Cam Cọn","path":"Xã Cam Cọn, Huyện Bảo Yên, Tỉnh Lào Cai","path_with_type":"Xã Cam Cọn, Huyện Bảo Yên, Tỉnh Lào Cai","code":"02974","parent_code":"087"},"02977":{"name":"Xã Minh Tân","type":"xa","slug":"xa-minh-tan","name_with_type":"Xã Minh Tân","path":"Xã Minh Tân, Huyện Bảo Yên, Tỉnh Lào Cai","path_with_type":"Xã Minh Tân, Huyện Bảo Yên, Tỉnh Lào Cai","code":"02977","parent_code":"087"},"02980":{"name":"Xã Xuân Thượng","type":"xa","slug":"xa-xuan-thuong","name_with_type":"Xã Xuân Thượng","path":"Xã Xuân Thượng, Huyện Bảo Yên, Tỉnh Lào Cai","path_with_type":"Xã Xuân Thượng, Huyện Bảo Yên, Tỉnh Lào Cai","code":"02980","parent_code":"087"},"02983":{"name":"Xã Việt Tiến","type":"xa","slug":"xa-viet-tien","name_with_type":"Xã Việt Tiến","path":"Xã Việt Tiến, Huyện Bảo Yên, Tỉnh Lào Cai","path_with_type":"Xã Việt Tiến, Huyện Bảo Yên, Tỉnh Lào Cai","code":"02983","parent_code":"087"},"02986":{"name":"Xã Yên Sơn","type":"xa","slug":"xa-yen-son","name_with_type":"Xã Yên Sơn","path":"Xã Yên Sơn, Huyện Bảo Yên, Tỉnh Lào Cai","path_with_type":"Xã Yên Sơn, Huyện Bảo Yên, Tỉnh Lào Cai","code":"02986","parent_code":"087"},"02989":{"name":"Xã Bảo Hà","type":"xa","slug":"xa-bao-ha","name_with_type":"Xã Bảo Hà","path":"Xã Bảo Hà, Huyện Bảo Yên, Tỉnh Lào Cai","path_with_type":"Xã Bảo Hà, Huyện Bảo Yên, Tỉnh Lào Cai","code":"02989","parent_code":"087"},"02992":{"name":"Xã Lương Sơn","type":"xa","slug":"xa-luong-son","name_with_type":"Xã Lương Sơn","path":"Xã Lương Sơn, Huyện Bảo Yên, Tỉnh Lào Cai","path_with_type":"Xã Lương Sơn, Huyện Bảo Yên, Tỉnh Lào Cai","code":"02992","parent_code":"087"},"02998":{"name":"Xã Phúc Khánh","type":"xa","slug":"xa-phuc-khanh","name_with_type":"Xã Phúc Khánh","path":"Xã Phúc Khánh, Huyện Bảo Yên, Tỉnh Lào Cai","path_with_type":"Xã Phúc Khánh, Huyện Bảo Yên, Tỉnh Lào Cai","code":"02998","parent_code":"087"},"03001":{"name":"Phường Sa Pa","type":"phuong","slug":"phuong-sa-pa","name_with_type":"Phường Sa Pa","path":"Phường Sa Pa, Thị xã Sa Pa, Tỉnh Lào Cai","path_with_type":"Phường Sa Pa, Thị xã Sa Pa, Tỉnh Lào Cai","code":"03001","parent_code":"088"},"03002":{"name":"Phường Sa Pả","type":"phuong","slug":"phuong-sa-pa","name_with_type":"Phường Sa Pả","path":"Phường Sa Pả, Thị xã Sa Pa, Tỉnh Lào Cai","path_with_type":"Phường Sa Pả, Thị xã Sa Pa, Tỉnh Lào Cai","code":"03002","parent_code":"088"},"03003":{"name":"Phường Ô Quý Hồ","type":"phuong","slug":"phuong-o-quy-ho","name_with_type":"Phường Ô Quý Hồ","path":"Phường Ô Quý Hồ, Thị xã Sa Pa, Tỉnh Lào Cai","path_with_type":"Phường Ô Quý Hồ, Thị xã Sa Pa, Tỉnh Lào Cai","code":"03003","parent_code":"088"},"03004":{"name":"Xã Ngũ Chỉ Sơn","type":"xa","slug":"xa-ngu-chi-son","name_with_type":"Xã Ngũ Chỉ Sơn","path":"Xã Ngũ Chỉ Sơn, Thị xã Sa Pa, Tỉnh Lào Cai","path_with_type":"Xã Ngũ Chỉ Sơn, Thị xã Sa Pa, Tỉnh Lào Cai","code":"03004","parent_code":"088"},"03006":{"name":"Phường Phan Si Păng","type":"phuong","slug":"phuong-phan-si-pang","name_with_type":"Phường Phan Si Păng","path":"Phường Phan Si Păng, Thị xã Sa Pa, Tỉnh Lào Cai","path_with_type":"Phường Phan Si Păng, Thị xã Sa Pa, Tỉnh Lào Cai","code":"03006","parent_code":"088"},"03010":{"name":"Xã Trung Chải","type":"xa","slug":"xa-trung-chai","name_with_type":"Xã Trung Chải","path":"Xã Trung Chải, Thị xã Sa Pa, Tỉnh Lào Cai","path_with_type":"Xã Trung Chải, Thị xã Sa Pa, Tỉnh Lào Cai","code":"03010","parent_code":"088"},"03013":{"name":"Xã Tả Phìn","type":"xa","slug":"xa-ta-phin","name_with_type":"Xã Tả Phìn","path":"Xã Tả Phìn, Thị xã Sa Pa, Tỉnh Lào Cai","path_with_type":"Xã Tả Phìn, Thị xã Sa Pa, Tỉnh Lào Cai","code":"03013","parent_code":"088"},"03016":{"name":"Phường Hàm Rồng","type":"phuong","slug":"phuong-ham-rong","name_with_type":"Phường Hàm Rồng","path":"Phường Hàm Rồng, Thị xã Sa Pa, Tỉnh Lào Cai","path_with_type":"Phường Hàm Rồng, Thị xã Sa Pa, Tỉnh Lào Cai","code":"03016","parent_code":"088"},"03019":{"name":"Xã Hoàng Liên","type":"xa","slug":"xa-hoang-lien","name_with_type":"Xã Hoàng Liên","path":"Xã Hoàng Liên, Thị xã Sa Pa, Tỉnh Lào Cai","path_with_type":"Xã Hoàng Liên, Thị xã Sa Pa, Tỉnh Lào Cai","code":"03019","parent_code":"088"},"03022":{"name":"Xã Thanh Bình","type":"xa","slug":"xa-thanh-binh","name_with_type":"Xã Thanh Bình","path":"Xã Thanh Bình, Thị xã Sa Pa, Tỉnh Lào Cai","path_with_type":"Xã Thanh Bình, Thị xã Sa Pa, Tỉnh Lào Cai","code":"03022","parent_code":"088"},"03028":{"name":"Phường Cầu Mây","type":"phuong","slug":"phuong-cau-may","name_with_type":"Phường Cầu Mây","path":"Phường Cầu Mây, Thị xã Sa Pa, Tỉnh Lào Cai","path_with_type":"Phường Cầu Mây, Thị xã Sa Pa, Tỉnh Lào Cai","code":"03028","parent_code":"088"},"03037":{"name":"Xã Mường Hoa","type":"xa","slug":"xa-muong-hoa","name_with_type":"Xã Mường Hoa","path":"Xã Mường Hoa, Thị xã Sa Pa, Tỉnh Lào Cai","path_with_type":"Xã Mường Hoa, Thị xã Sa Pa, Tỉnh Lào Cai","code":"03037","parent_code":"088"},"03040":{"name":"Xã Tả Van","type":"xa","slug":"xa-ta-van","name_with_type":"Xã Tả Van","path":"Xã Tả Van, Thị xã Sa Pa, Tỉnh Lào Cai","path_with_type":"Xã Tả Van, Thị xã Sa Pa, Tỉnh Lào Cai","code":"03040","parent_code":"088"},"03043":{"name":"Xã Mường Bo","type":"xa","slug":"xa-muong-bo","name_with_type":"Xã Mường Bo","path":"Xã Mường Bo, Thị xã Sa Pa, Tỉnh Lào Cai","path_with_type":"Xã Mường Bo, Thị xã Sa Pa, Tỉnh Lào Cai","code":"03043","parent_code":"088"},"03046":{"name":"Xã Bản Hồ","type":"xa","slug":"xa-ban-ho","name_with_type":"Xã Bản Hồ","path":"Xã Bản Hồ, Thị xã Sa Pa, Tỉnh Lào Cai","path_with_type":"Xã Bản Hồ, Thị xã Sa Pa, Tỉnh Lào Cai","code":"03046","parent_code":"088"},"03052":{"name":"Xã Liên Minh","type":"xa","slug":"xa-lien-minh","name_with_type":"Xã Liên Minh","path":"Xã Liên Minh, Thị xã Sa Pa, Tỉnh Lào Cai","path_with_type":"Xã Liên Minh, Thị xã Sa Pa, Tỉnh Lào Cai","code":"03052","parent_code":"088"},"03055":{"name":"Thị trấn Khánh Yên","type":"thi-tran","slug":"thi-tran-khanh-yen","name_with_type":"Thị trấn Khánh Yên","path":"Thị trấn Khánh Yên, Huyện Văn Bàn, Tỉnh Lào Cai","path_with_type":"Thị trấn Khánh Yên, Huyện Văn Bàn, Tỉnh Lào Cai","code":"03055","parent_code":"089"},"03061":{"name":"Xã Võ Lao","type":"xa","slug":"xa-vo-lao","name_with_type":"Xã Võ Lao","path":"Xã Võ Lao, Huyện Văn Bàn, Tỉnh Lào Cai","path_with_type":"Xã Võ Lao, Huyện Văn Bàn, Tỉnh Lào Cai","code":"03061","parent_code":"089"},"03064":{"name":"Xã Sơn Thuỷ","type":"xa","slug":"xa-son-thuy","name_with_type":"Xã Sơn Thuỷ","path":"Xã Sơn Thuỷ, Huyện Văn Bàn, Tỉnh Lào Cai","path_with_type":"Xã Sơn Thuỷ, Huyện Văn Bàn, Tỉnh Lào Cai","code":"03064","parent_code":"089"},"03067":{"name":"Xã Nậm Mả","type":"xa","slug":"xa-nam-ma","name_with_type":"Xã Nậm Mả","path":"Xã Nậm Mả, Huyện Văn Bàn, Tỉnh Lào Cai","path_with_type":"Xã Nậm Mả, Huyện Văn Bàn, Tỉnh Lào Cai","code":"03067","parent_code":"089"},"03070":{"name":"Xã Tân Thượng","type":"xa","slug":"xa-tan-thuong","name_with_type":"Xã Tân Thượng","path":"Xã Tân Thượng, Huyện Văn Bàn, Tỉnh Lào Cai","path_with_type":"Xã Tân Thượng, Huyện Văn Bàn, Tỉnh Lào Cai","code":"03070","parent_code":"089"},"03073":{"name":"Xã Nậm Rạng","type":"xa","slug":"xa-nam-rang","name_with_type":"Xã Nậm Rạng","path":"Xã Nậm Rạng, Huyện Văn Bàn, Tỉnh Lào Cai","path_with_type":"Xã Nậm Rạng, Huyện Văn Bàn, Tỉnh Lào Cai","code":"03073","parent_code":"089"},"03076":{"name":"Xã Nậm Chầy","type":"xa","slug":"xa-nam-chay","name_with_type":"Xã Nậm Chầy","path":"Xã Nậm Chầy, Huyện Văn Bàn, Tỉnh Lào Cai","path_with_type":"Xã Nậm Chầy, Huyện Văn Bàn, Tỉnh Lào Cai","code":"03076","parent_code":"089"},"03079":{"name":"Xã Tân An","type":"xa","slug":"xa-tan-an","name_with_type":"Xã Tân An","path":"Xã Tân An, Huyện Văn Bàn, Tỉnh Lào Cai","path_with_type":"Xã Tân An, Huyện Văn Bàn, Tỉnh Lào Cai","code":"03079","parent_code":"089"},"03082":{"name":"Xã Khánh Yên Thượng","type":"xa","slug":"xa-khanh-yen-thuong","name_with_type":"Xã Khánh Yên Thượng","path":"Xã Khánh Yên Thượng, Huyện Văn Bàn, Tỉnh Lào Cai","path_with_type":"Xã Khánh Yên Thượng, Huyện Văn Bàn, Tỉnh Lào Cai","code":"03082","parent_code":"089"},"03085":{"name":"Xã Nậm Xé","type":"xa","slug":"xa-nam-xe","name_with_type":"Xã Nậm Xé","path":"Xã Nậm Xé, Huyện Văn Bàn, Tỉnh Lào Cai","path_with_type":"Xã Nậm Xé, Huyện Văn Bàn, Tỉnh Lào Cai","code":"03085","parent_code":"089"},"03088":{"name":"Xã Dần Thàng","type":"xa","slug":"xa-dan-thang","name_with_type":"Xã Dần Thàng","path":"Xã Dần Thàng, Huyện Văn Bàn, Tỉnh Lào Cai","path_with_type":"Xã Dần Thàng, Huyện Văn Bàn, Tỉnh Lào Cai","code":"03088","parent_code":"089"},"03091":{"name":"Xã Chiềng Ken","type":"xa","slug":"xa-chieng-ken","name_with_type":"Xã Chiềng Ken","path":"Xã Chiềng Ken, Huyện Văn Bàn, Tỉnh Lào Cai","path_with_type":"Xã Chiềng Ken, Huyện Văn Bàn, Tỉnh Lào Cai","code":"03091","parent_code":"089"},"03094":{"name":"Xã Làng Giàng","type":"xa","slug":"xa-lang-giang","name_with_type":"Xã Làng Giàng","path":"Xã Làng Giàng, Huyện Văn Bàn, Tỉnh Lào Cai","path_with_type":"Xã Làng Giàng, Huyện Văn Bàn, Tỉnh Lào Cai","code":"03094","parent_code":"089"},"03097":{"name":"Xã Hoà Mạc","type":"xa","slug":"xa-hoa-mac","name_with_type":"Xã Hoà Mạc","path":"Xã Hoà Mạc, Huyện Văn Bàn, Tỉnh Lào Cai","path_with_type":"Xã Hoà Mạc, Huyện Văn Bàn, Tỉnh Lào Cai","code":"03097","parent_code":"089"},"03100":{"name":"Xã Khánh Yên Trung","type":"xa","slug":"xa-khanh-yen-trung","name_with_type":"Xã Khánh Yên Trung","path":"Xã Khánh Yên Trung, Huyện Văn Bàn, Tỉnh Lào Cai","path_with_type":"Xã Khánh Yên Trung, Huyện Văn Bàn, Tỉnh Lào Cai","code":"03100","parent_code":"089"},"03103":{"name":"Xã Khánh Yên Hạ","type":"xa","slug":"xa-khanh-yen-ha","name_with_type":"Xã Khánh Yên Hạ","path":"Xã Khánh Yên Hạ, Huyện Văn Bàn, Tỉnh Lào Cai","path_with_type":"Xã Khánh Yên Hạ, Huyện Văn Bàn, Tỉnh Lào Cai","code":"03103","parent_code":"089"},"03106":{"name":"Xã Dương Quỳ","type":"xa","slug":"xa-duong-quy","name_with_type":"Xã Dương Quỳ","path":"Xã Dương Quỳ, Huyện Văn Bàn, Tỉnh Lào Cai","path_with_type":"Xã Dương Quỳ, Huyện Văn Bàn, Tỉnh Lào Cai","code":"03106","parent_code":"089"},"03109":{"name":"Xã Nậm Tha","type":"xa","slug":"xa-nam-tha","name_with_type":"Xã Nậm Tha","path":"Xã Nậm Tha, Huyện Văn Bàn, Tỉnh Lào Cai","path_with_type":"Xã Nậm Tha, Huyện Văn Bàn, Tỉnh Lào Cai","code":"03109","parent_code":"089"},"03112":{"name":"Xã Minh Lương","type":"xa","slug":"xa-minh-luong","name_with_type":"Xã Minh Lương","path":"Xã Minh Lương, Huyện Văn Bàn, Tỉnh Lào Cai","path_with_type":"Xã Minh Lương, Huyện Văn Bàn, Tỉnh Lào Cai","code":"03112","parent_code":"089"},"03115":{"name":"Xã Thẩm Dương","type":"xa","slug":"xa-tham-duong","name_with_type":"Xã Thẩm Dương","path":"Xã Thẩm Dương, Huyện Văn Bàn, Tỉnh Lào Cai","path_with_type":"Xã Thẩm Dương, Huyện Văn Bàn, Tỉnh Lào Cai","code":"03115","parent_code":"089"},"03118":{"name":"Xã Liêm Phú","type":"xa","slug":"xa-liem-phu","name_with_type":"Xã Liêm Phú","path":"Xã Liêm Phú, Huyện Văn Bàn, Tỉnh Lào Cai","path_with_type":"Xã Liêm Phú, Huyện Văn Bàn, Tỉnh Lào Cai","code":"03118","parent_code":"089"},"03121":{"name":"Xã Nậm Xây","type":"xa","slug":"xa-nam-xay","name_with_type":"Xã Nậm Xây","path":"Xã Nậm Xây, Huyện Văn Bàn, Tỉnh Lào Cai","path_with_type":"Xã Nậm Xây, Huyện Văn Bàn, Tỉnh Lào Cai","code":"03121","parent_code":"089"},"03124":{"name":"Phường Noong Bua","type":"phuong","slug":"phuong-noong-bua","name_with_type":"Phường Noong Bua","path":"Phường Noong Bua, Thành phố Điện Biên Phủ, Tỉnh Điện Biên","path_with_type":"Phường Noong Bua, Thành phố Điện Biên Phủ, Tỉnh Điện Biên","code":"03124","parent_code":"094"},"03127":{"name":"Phường Him Lam","type":"phuong","slug":"phuong-him-lam","name_with_type":"Phường Him Lam","path":"Phường Him Lam, Thành phố Điện Biên Phủ, Tỉnh Điện Biên","path_with_type":"Phường Him Lam, Thành phố Điện Biên Phủ, Tỉnh Điện Biên","code":"03127","parent_code":"094"},"03130":{"name":"Phường Thanh Bình","type":"phuong","slug":"phuong-thanh-binh","name_with_type":"Phường Thanh Bình","path":"Phường Thanh Bình, Thành phố Điện Biên Phủ, Tỉnh Điện Biên","path_with_type":"Phường Thanh Bình, Thành phố Điện Biên Phủ, Tỉnh Điện Biên","code":"03130","parent_code":"094"},"03133":{"name":"Phường Tân Thanh","type":"phuong","slug":"phuong-tan-thanh","name_with_type":"Phường Tân Thanh","path":"Phường Tân Thanh, Thành phố Điện Biên Phủ, Tỉnh Điện Biên","path_with_type":"Phường Tân Thanh, Thành phố Điện Biên Phủ, Tỉnh Điện Biên","code":"03133","parent_code":"094"},"03136":{"name":"Phường Mường Thanh","type":"phuong","slug":"phuong-muong-thanh","name_with_type":"Phường Mường Thanh","path":"Phường Mường Thanh, Thành phố Điện Biên Phủ, Tỉnh Điện Biên","path_with_type":"Phường Mường Thanh, Thành phố Điện Biên Phủ, Tỉnh Điện Biên","code":"03136","parent_code":"094"},"03139":{"name":"Phường Nam Thanh","type":"phuong","slug":"phuong-nam-thanh","name_with_type":"Phường Nam Thanh","path":"Phường Nam Thanh, Thành phố Điện Biên Phủ, Tỉnh Điện Biên","path_with_type":"Phường Nam Thanh, Thành phố Điện Biên Phủ, Tỉnh Điện Biên","code":"03139","parent_code":"094"},"03142":{"name":"Phường Thanh Trường","type":"phuong","slug":"phuong-thanh-truong","name_with_type":"Phường Thanh Trường","path":"Phường Thanh Trường, Thành phố Điện Biên Phủ, Tỉnh Điện Biên","path_with_type":"Phường Thanh Trường, Thành phố Điện Biên Phủ, Tỉnh Điện Biên","code":"03142","parent_code":"094"},"03145":{"name":"Xã Thanh Minh","type":"xa","slug":"xa-thanh-minh","name_with_type":"Xã Thanh Minh","path":"Xã Thanh Minh, Thành phố Điện Biên Phủ, Tỉnh Điện Biên","path_with_type":"Xã Thanh Minh, Thành phố Điện Biên Phủ, Tỉnh Điện Biên","code":"03145","parent_code":"094"},"03316":{"name":"Xã Nà Tấu","type":"xa","slug":"xa-na-tau","name_with_type":"Xã Nà Tấu","path":"Xã Nà Tấu, Thành phố Điện Biên Phủ, Tỉnh Điện Biên","path_with_type":"Xã Nà Tấu, Thành phố Điện Biên Phủ, Tỉnh Điện Biên","code":"03316","parent_code":"094"},"03317":{"name":"Xã Nà Nhạn","type":"xa","slug":"xa-na-nhan","name_with_type":"Xã Nà Nhạn","path":"Xã Nà Nhạn, Thành phố Điện Biên Phủ, Tỉnh Điện Biên","path_with_type":"Xã Nà Nhạn, Thành phố Điện Biên Phủ, Tỉnh Điện Biên","code":"03317","parent_code":"094"},"03325":{"name":"Xã Mường Phăng","type":"xa","slug":"xa-muong-phang","name_with_type":"Xã Mường Phăng","path":"Xã Mường Phăng, Thành phố Điện Biên Phủ, Tỉnh Điện Biên","path_with_type":"Xã Mường Phăng, Thành phố Điện Biên Phủ, Tỉnh Điện Biên","code":"03325","parent_code":"094"},"03326":{"name":"Xã Pá Khoang","type":"xa","slug":"xa-pa-khoang","name_with_type":"Xã Pá Khoang","path":"Xã Pá Khoang, Thành phố Điện Biên Phủ, Tỉnh Điện Biên","path_with_type":"Xã Pá Khoang, Thành phố Điện Biên Phủ, Tỉnh Điện Biên","code":"03326","parent_code":"094"},"03148":{"name":"Phường Sông Đà","type":"phuong","slug":"phuong-song-da","name_with_type":"Phường Sông Đà","path":"Phường Sông Đà, Thị Xã Mường Lay, Tỉnh Điện Biên","path_with_type":"Phường Sông Đà, Thị Xã Mường Lay, Tỉnh Điện Biên","code":"03148","parent_code":"095"},"03151":{"name":"Phường Na Lay","type":"phuong","slug":"phuong-na-lay","name_with_type":"Phường Na Lay","path":"Phường Na Lay, Thị Xã Mường Lay, Tỉnh Điện Biên","path_with_type":"Phường Na Lay, Thị Xã Mường Lay, Tỉnh Điện Biên","code":"03151","parent_code":"095"},"03184":{"name":"Xã Lay Nưa","type":"xa","slug":"xa-lay-nua","name_with_type":"Xã Lay Nưa","path":"Xã Lay Nưa, Thị Xã Mường Lay, Tỉnh Điện Biên","path_with_type":"Xã Lay Nưa, Thị Xã Mường Lay, Tỉnh Điện Biên","code":"03184","parent_code":"095"},"03154":{"name":"Xã Sín Thầu","type":"xa","slug":"xa-sin-thau","name_with_type":"Xã Sín Thầu","path":"Xã Sín Thầu, Huyện Mường Nhé, Tỉnh Điện Biên","path_with_type":"Xã Sín Thầu, Huyện Mường Nhé, Tỉnh Điện Biên","code":"03154","parent_code":"096"},"03155":{"name":"Xã Sen Thượng","type":"xa","slug":"xa-sen-thuong","name_with_type":"Xã Sen Thượng","path":"Xã Sen Thượng, Huyện Mường Nhé, Tỉnh Điện Biên","path_with_type":"Xã Sen Thượng, Huyện Mường Nhé, Tỉnh Điện Biên","code":"03155","parent_code":"096"},"03157":{"name":"Xã Chung Chải","type":"xa","slug":"xa-chung-chai","name_with_type":"Xã Chung Chải","path":"Xã Chung Chải, Huyện Mường Nhé, Tỉnh Điện Biên","path_with_type":"Xã Chung Chải, Huyện Mường Nhé, Tỉnh Điện Biên","code":"03157","parent_code":"096"},"03158":{"name":"Xã Leng Su Sìn","type":"xa","slug":"xa-leng-su-sin","name_with_type":"Xã Leng Su Sìn","path":"Xã Leng Su Sìn, Huyện Mường Nhé, Tỉnh Điện Biên","path_with_type":"Xã Leng Su Sìn, Huyện Mường Nhé, Tỉnh Điện Biên","code":"03158","parent_code":"096"},"03159":{"name":"Xã Pá Mỳ","type":"xa","slug":"xa-pa-my","name_with_type":"Xã Pá Mỳ","path":"Xã Pá Mỳ, Huyện Mường Nhé, Tỉnh Điện Biên","path_with_type":"Xã Pá Mỳ, Huyện Mường Nhé, Tỉnh Điện Biên","code":"03159","parent_code":"096"},"03160":{"name":"Xã Mường Nhé","type":"xa","slug":"xa-muong-nhe","name_with_type":"Xã Mường Nhé","path":"Xã Mường Nhé, Huyện Mường Nhé, Tỉnh Điện Biên","path_with_type":"Xã Mường Nhé, Huyện Mường Nhé, Tỉnh Điện Biên","code":"03160","parent_code":"096"},"03161":{"name":"Xã Nậm Vì","type":"xa","slug":"xa-nam-vi","name_with_type":"Xã Nậm Vì","path":"Xã Nậm Vì, Huyện Mường Nhé, Tỉnh Điện Biên","path_with_type":"Xã Nậm Vì, Huyện Mường Nhé, Tỉnh Điện Biên","code":"03161","parent_code":"096"},"03162":{"name":"Xã Nậm Kè","type":"xa","slug":"xa-nam-ke","name_with_type":"Xã Nậm Kè","path":"Xã Nậm Kè, Huyện Mường Nhé, Tỉnh Điện Biên","path_with_type":"Xã Nậm Kè, Huyện Mường Nhé, Tỉnh Điện Biên","code":"03162","parent_code":"096"},"03163":{"name":"Xã Mường Toong","type":"xa","slug":"xa-muong-toong","name_with_type":"Xã Mường Toong","path":"Xã Mường Toong, Huyện Mường Nhé, Tỉnh Điện Biên","path_with_type":"Xã Mường Toong, Huyện Mường Nhé, Tỉnh Điện Biên","code":"03163","parent_code":"096"},"03164":{"name":"Xã Quảng Lâm","type":"xa","slug":"xa-quang-lam","name_with_type":"Xã Quảng Lâm","path":"Xã Quảng Lâm, Huyện Mường Nhé, Tỉnh Điện Biên","path_with_type":"Xã Quảng Lâm, Huyện Mường Nhé, Tỉnh Điện Biên","code":"03164","parent_code":"096"},"03177":{"name":"Xã Huổi Lếnh","type":"xa","slug":"xa-huoi-lenh","name_with_type":"Xã Huổi Lếnh","path":"Xã Huổi Lếnh, Huyện Mường Nhé, Tỉnh Điện Biên","path_with_type":"Xã Huổi Lếnh, Huyện Mường Nhé, Tỉnh Điện Biên","code":"03177","parent_code":"096"},"03172":{"name":"Thị Trấn Mường Chà","type":"thi-tran","slug":"thi-tran-muong-cha","name_with_type":"Thị Trấn Mường Chà","path":"Thị Trấn Mường Chà, Huyện Mường Chà, Tỉnh Điện Biên","path_with_type":"Thị Trấn Mường Chà, Huyện Mường Chà, Tỉnh Điện Biên","code":"03172","parent_code":"097"},"03178":{"name":"Xã Xá Tổng","type":"xa","slug":"xa-xa-tong","name_with_type":"Xã Xá Tổng","path":"Xã Xá Tổng, Huyện Mường Chà, Tỉnh Điện Biên","path_with_type":"Xã Xá Tổng, Huyện Mường Chà, Tỉnh Điện Biên","code":"03178","parent_code":"097"},"03181":{"name":"Xã Mường Tùng","type":"xa","slug":"xa-muong-tung","name_with_type":"Xã Mường Tùng","path":"Xã Mường Tùng, Huyện Mường Chà, Tỉnh Điện Biên","path_with_type":"Xã Mường Tùng, Huyện Mường Chà, Tỉnh Điện Biên","code":"03181","parent_code":"097"},"03190":{"name":"Xã Hừa Ngài","type":"xa","slug":"xa-hua-ngai","name_with_type":"Xã Hừa Ngài","path":"Xã Hừa Ngài, Huyện Mường Chà, Tỉnh Điện Biên","path_with_type":"Xã Hừa Ngài, Huyện Mường Chà, Tỉnh Điện Biên","code":"03190","parent_code":"097"},"03191":{"name":"Xã Huổi Mí","type":"xa","slug":"xa-huoi-mi","name_with_type":"Xã Huổi Mí","path":"Xã Huổi Mí, Huyện Mường Chà, Tỉnh Điện Biên","path_with_type":"Xã Huổi Mí, Huyện Mường Chà, Tỉnh Điện Biên","code":"03191","parent_code":"097"},"03193":{"name":"Xã Pa Ham","type":"xa","slug":"xa-pa-ham","name_with_type":"Xã Pa Ham","path":"Xã Pa Ham, Huyện Mường Chà, Tỉnh Điện Biên","path_with_type":"Xã Pa Ham, Huyện Mường Chà, Tỉnh Điện Biên","code":"03193","parent_code":"097"},"03194":{"name":"Xã Nậm Nèn","type":"xa","slug":"xa-nam-nen","name_with_type":"Xã Nậm Nèn","path":"Xã Nậm Nèn, Huyện Mường Chà, Tỉnh Điện Biên","path_with_type":"Xã Nậm Nèn, Huyện Mường Chà, Tỉnh Điện Biên","code":"03194","parent_code":"097"},"03196":{"name":"Xã Huổi Lèng","type":"xa","slug":"xa-huoi-leng","name_with_type":"Xã Huổi Lèng","path":"Xã Huổi Lèng, Huyện Mường Chà, Tỉnh Điện Biên","path_with_type":"Xã Huổi Lèng, Huyện Mường Chà, Tỉnh Điện Biên","code":"03196","parent_code":"097"},"03197":{"name":"Xã Sa Lông","type":"xa","slug":"xa-sa-long","name_with_type":"Xã Sa Lông","path":"Xã Sa Lông, Huyện Mường Chà, Tỉnh Điện Biên","path_with_type":"Xã Sa Lông, Huyện Mường Chà, Tỉnh Điện Biên","code":"03197","parent_code":"097"},"03200":{"name":"Xã Ma Thì Hồ","type":"xa","slug":"xa-ma-thi-ho","name_with_type":"Xã Ma Thì Hồ","path":"Xã Ma Thì Hồ, Huyện Mường Chà, Tỉnh Điện Biên","path_with_type":"Xã Ma Thì Hồ, Huyện Mường Chà, Tỉnh Điện Biên","code":"03200","parent_code":"097"},"03201":{"name":"Xã Na Sang","type":"xa","slug":"xa-na-sang","name_with_type":"Xã Na Sang","path":"Xã Na Sang, Huyện Mường Chà, Tỉnh Điện Biên","path_with_type":"Xã Na Sang, Huyện Mường Chà, Tỉnh Điện Biên","code":"03201","parent_code":"097"},"03202":{"name":"Xã Mường Mươn","type":"xa","slug":"xa-muong-muon","name_with_type":"Xã Mường Mươn","path":"Xã Mường Mươn, Huyện Mường Chà, Tỉnh Điện Biên","path_with_type":"Xã Mường Mươn, Huyện Mường Chà, Tỉnh Điện Biên","code":"03202","parent_code":"097"},"03217":{"name":"Thị trấn Tủa Chùa","type":"thi-tran","slug":"thi-tran-tua-chua","name_with_type":"Thị trấn Tủa Chùa","path":"Thị trấn Tủa Chùa, Huyện Tủa Chùa, Tỉnh Điện Biên","path_with_type":"Thị trấn Tủa Chùa, Huyện Tủa Chùa, Tỉnh Điện Biên","code":"03217","parent_code":"098"},"03220":{"name":"Xã Huổi Só","type":"xa","slug":"xa-huoi-so","name_with_type":"Xã Huổi Só","path":"Xã Huổi Só, Huyện Tủa Chùa, Tỉnh Điện Biên","path_with_type":"Xã Huổi Só, Huyện Tủa Chùa, Tỉnh Điện Biên","code":"03220","parent_code":"098"},"03223":{"name":"Xã Xín Chải","type":"xa","slug":"xa-xin-chai","name_with_type":"Xã Xín Chải","path":"Xã Xín Chải, Huyện Tủa Chùa, Tỉnh Điện Biên","path_with_type":"Xã Xín Chải, Huyện Tủa Chùa, Tỉnh Điện Biên","code":"03223","parent_code":"098"},"03226":{"name":"Xã Tả Sìn Thàng","type":"xa","slug":"xa-ta-sin-thang","name_with_type":"Xã Tả Sìn Thàng","path":"Xã Tả Sìn Thàng, Huyện Tủa Chùa, Tỉnh Điện Biên","path_with_type":"Xã Tả Sìn Thàng, Huyện Tủa Chùa, Tỉnh Điện Biên","code":"03226","parent_code":"098"},"03229":{"name":"Xã Lao Xả Phình","type":"xa","slug":"xa-lao-xa-phinh","name_with_type":"Xã Lao Xả Phình","path":"Xã Lao Xả Phình, Huyện Tủa Chùa, Tỉnh Điện Biên","path_with_type":"Xã Lao Xả Phình, Huyện Tủa Chùa, Tỉnh Điện Biên","code":"03229","parent_code":"098"},"03232":{"name":"Xã Tả Phìn","type":"xa","slug":"xa-ta-phin","name_with_type":"Xã Tả Phìn","path":"Xã Tả Phìn, Huyện Tủa Chùa, Tỉnh Điện Biên","path_with_type":"Xã Tả Phìn, Huyện Tủa Chùa, Tỉnh Điện Biên","code":"03232","parent_code":"098"},"03235":{"name":"Xã Tủa Thàng","type":"xa","slug":"xa-tua-thang","name_with_type":"Xã Tủa Thàng","path":"Xã Tủa Thàng, Huyện Tủa Chùa, Tỉnh Điện Biên","path_with_type":"Xã Tủa Thàng, Huyện Tủa Chùa, Tỉnh Điện Biên","code":"03235","parent_code":"098"},"03238":{"name":"Xã Trung Thu","type":"xa","slug":"xa-trung-thu","name_with_type":"Xã Trung Thu","path":"Xã Trung Thu, Huyện Tủa Chùa, Tỉnh Điện Biên","path_with_type":"Xã Trung Thu, Huyện Tủa Chùa, Tỉnh Điện Biên","code":"03238","parent_code":"098"},"03241":{"name":"Xã Sính Phình","type":"xa","slug":"xa-sinh-phinh","name_with_type":"Xã Sính Phình","path":"Xã Sính Phình, Huyện Tủa Chùa, Tỉnh Điện Biên","path_with_type":"Xã Sính Phình, Huyện Tủa Chùa, Tỉnh Điện Biên","code":"03241","parent_code":"098"},"03244":{"name":"Xã Sáng Nhè","type":"xa","slug":"xa-sang-nhe","name_with_type":"Xã Sáng Nhè","path":"Xã Sáng Nhè, Huyện Tủa Chùa, Tỉnh Điện Biên","path_with_type":"Xã Sáng Nhè, Huyện Tủa Chùa, Tỉnh Điện Biên","code":"03244","parent_code":"098"},"03247":{"name":"Xã Mường Đun","type":"xa","slug":"xa-muong-dun","name_with_type":"Xã Mường Đun","path":"Xã Mường Đun, Huyện Tủa Chùa, Tỉnh Điện Biên","path_with_type":"Xã Mường Đun, Huyện Tủa Chùa, Tỉnh Điện Biên","code":"03247","parent_code":"098"},"03250":{"name":"Xã Mường Báng","type":"xa","slug":"xa-muong-bang","name_with_type":"Xã Mường Báng","path":"Xã Mường Báng, Huyện Tủa Chùa, Tỉnh Điện Biên","path_with_type":"Xã Mường Báng, Huyện Tủa Chùa, Tỉnh Điện Biên","code":"03250","parent_code":"098"},"03253":{"name":"Thị trấn Tuần Giáo","type":"thi-tran","slug":"thi-tran-tuan-giao","name_with_type":"Thị trấn Tuần Giáo","path":"Thị trấn Tuần Giáo, Huyện Tuần Giáo, Tỉnh Điện Biên","path_with_type":"Thị trấn Tuần Giáo, Huyện Tuần Giáo, Tỉnh Điện Biên","code":"03253","parent_code":"099"},"03259":{"name":"Xã Phình Sáng","type":"xa","slug":"xa-phinh-sang","name_with_type":"Xã Phình Sáng","path":"Xã Phình Sáng, Huyện Tuần Giáo, Tỉnh Điện Biên","path_with_type":"Xã Phình Sáng, Huyện Tuần Giáo, Tỉnh Điện Biên","code":"03259","parent_code":"099"},"03260":{"name":"Xã Rạng Đông","type":"xa","slug":"xa-rang-dong","name_with_type":"Xã Rạng Đông","path":"Xã Rạng Đông, Huyện Tuần Giáo, Tỉnh Điện Biên","path_with_type":"Xã Rạng Đông, Huyện Tuần Giáo, Tỉnh Điện Biên","code":"03260","parent_code":"099"},"03262":{"name":"Xã Mùn Chung","type":"xa","slug":"xa-mun-chung","name_with_type":"Xã Mùn Chung","path":"Xã Mùn Chung, Huyện Tuần Giáo, Tỉnh Điện Biên","path_with_type":"Xã Mùn Chung, Huyện Tuần Giáo, Tỉnh Điện Biên","code":"03262","parent_code":"099"},"03263":{"name":"Xã Nà Tòng","type":"xa","slug":"xa-na-tong","name_with_type":"Xã Nà Tòng","path":"Xã Nà Tòng, Huyện Tuần Giáo, Tỉnh Điện Biên","path_with_type":"Xã Nà Tòng, Huyện Tuần Giáo, Tỉnh Điện Biên","code":"03263","parent_code":"099"},"03265":{"name":"Xã Ta Ma","type":"xa","slug":"xa-ta-ma","name_with_type":"Xã Ta Ma","path":"Xã Ta Ma, Huyện Tuần Giáo, Tỉnh Điện Biên","path_with_type":"Xã Ta Ma, Huyện Tuần Giáo, Tỉnh Điện Biên","code":"03265","parent_code":"099"},"03268":{"name":"Xã Mường Mùn","type":"xa","slug":"xa-muong-mun","name_with_type":"Xã Mường Mùn","path":"Xã Mường Mùn, Huyện Tuần Giáo, Tỉnh Điện Biên","path_with_type":"Xã Mường Mùn, Huyện Tuần Giáo, Tỉnh Điện Biên","code":"03268","parent_code":"099"},"03269":{"name":"Xã Pú Xi","type":"xa","slug":"xa-pu-xi","name_with_type":"Xã Pú Xi","path":"Xã Pú Xi, Huyện Tuần Giáo, Tỉnh Điện Biên","path_with_type":"Xã Pú Xi, Huyện Tuần Giáo, Tỉnh Điện Biên","code":"03269","parent_code":"099"},"03271":{"name":"Xã Pú Nhung","type":"xa","slug":"xa-pu-nhung","name_with_type":"Xã Pú Nhung","path":"Xã Pú Nhung, Huyện Tuần Giáo, Tỉnh Điện Biên","path_with_type":"Xã Pú Nhung, Huyện Tuần Giáo, Tỉnh Điện Biên","code":"03271","parent_code":"099"},"03274":{"name":"Xã Quài Nưa","type":"xa","slug":"xa-quai-nua","name_with_type":"Xã Quài Nưa","path":"Xã Quài Nưa, Huyện Tuần Giáo, Tỉnh Điện Biên","path_with_type":"Xã Quài Nưa, Huyện Tuần Giáo, Tỉnh Điện Biên","code":"03274","parent_code":"099"},"03277":{"name":"Xã Mường Thín","type":"xa","slug":"xa-muong-thin","name_with_type":"Xã Mường Thín","path":"Xã Mường Thín, Huyện Tuần Giáo, Tỉnh Điện Biên","path_with_type":"Xã Mường Thín, Huyện Tuần Giáo, Tỉnh Điện Biên","code":"03277","parent_code":"099"},"03280":{"name":"Xã Tỏa Tình","type":"xa","slug":"xa-toa-tinh","name_with_type":"Xã Tỏa Tình","path":"Xã Tỏa Tình, Huyện Tuần Giáo, Tỉnh Điện Biên","path_with_type":"Xã Tỏa Tình, Huyện Tuần Giáo, Tỉnh Điện Biên","code":"03280","parent_code":"099"},"03283":{"name":"Xã Nà Sáy","type":"xa","slug":"xa-na-say","name_with_type":"Xã Nà Sáy","path":"Xã Nà Sáy, Huyện Tuần Giáo, Tỉnh Điện Biên","path_with_type":"Xã Nà Sáy, Huyện Tuần Giáo, Tỉnh Điện Biên","code":"03283","parent_code":"099"},"03284":{"name":"Xã Mường Khong","type":"xa","slug":"xa-muong-khong","name_with_type":"Xã Mường Khong","path":"Xã Mường Khong, Huyện Tuần Giáo, Tỉnh Điện Biên","path_with_type":"Xã Mường Khong, Huyện Tuần Giáo, Tỉnh Điện Biên","code":"03284","parent_code":"099"},"03289":{"name":"Xã Quài Cang","type":"xa","slug":"xa-quai-cang","name_with_type":"Xã Quài Cang","path":"Xã Quài Cang, Huyện Tuần Giáo, Tỉnh Điện Biên","path_with_type":"Xã Quài Cang, Huyện Tuần Giáo, Tỉnh Điện Biên","code":"03289","parent_code":"099"},"03295":{"name":"Xã Quài Tở","type":"xa","slug":"xa-quai-to","name_with_type":"Xã Quài Tở","path":"Xã Quài Tở, Huyện Tuần Giáo, Tỉnh Điện Biên","path_with_type":"Xã Quài Tở, Huyện Tuần Giáo, Tỉnh Điện Biên","code":"03295","parent_code":"099"},"03298":{"name":"Xã Chiềng Sinh","type":"xa","slug":"xa-chieng-sinh","name_with_type":"Xã Chiềng Sinh","path":"Xã Chiềng Sinh, Huyện Tuần Giáo, Tỉnh Điện Biên","path_with_type":"Xã Chiềng Sinh, Huyện Tuần Giáo, Tỉnh Điện Biên","code":"03298","parent_code":"099"},"03299":{"name":"Xã Chiềng Đông","type":"xa","slug":"xa-chieng-dong","name_with_type":"Xã Chiềng Đông","path":"Xã Chiềng Đông, Huyện Tuần Giáo, Tỉnh Điện Biên","path_with_type":"Xã Chiềng Đông, Huyện Tuần Giáo, Tỉnh Điện Biên","code":"03299","parent_code":"099"},"03304":{"name":"Xã Tênh Phông","type":"xa","slug":"xa-tenh-phong","name_with_type":"Xã Tênh Phông","path":"Xã Tênh Phông, Huyện Tuần Giáo, Tỉnh Điện Biên","path_with_type":"Xã Tênh Phông, Huyện Tuần Giáo, Tỉnh Điện Biên","code":"03304","parent_code":"099"},"03319":{"name":"Xã Mường Pồn","type":"xa","slug":"xa-muong-pon","name_with_type":"Xã Mường Pồn","path":"Xã Mường Pồn, Huyện Điện Biên, Tỉnh Điện Biên","path_with_type":"Xã Mường Pồn, Huyện Điện Biên, Tỉnh Điện Biên","code":"03319","parent_code":"100"},"03322":{"name":"Xã Thanh Nưa","type":"xa","slug":"xa-thanh-nua","name_with_type":"Xã Thanh Nưa","path":"Xã Thanh Nưa, Huyện Điện Biên, Tỉnh Điện Biên","path_with_type":"Xã Thanh Nưa, Huyện Điện Biên, Tỉnh Điện Biên","code":"03322","parent_code":"100"},"03323":{"name":"Xã Hua Thanh","type":"xa","slug":"xa-hua-thanh","name_with_type":"Xã Hua Thanh","path":"Xã Hua Thanh, Huyện Điện Biên, Tỉnh Điện Biên","path_with_type":"Xã Hua Thanh, Huyện Điện Biên, Tỉnh Điện Biên","code":"03323","parent_code":"100"},"03328":{"name":"Xã Thanh Luông","type":"xa","slug":"xa-thanh-luong","name_with_type":"Xã Thanh Luông","path":"Xã Thanh Luông, Huyện Điện Biên, Tỉnh Điện Biên","path_with_type":"Xã Thanh Luông, Huyện Điện Biên, Tỉnh Điện Biên","code":"03328","parent_code":"100"},"03331":{"name":"Xã Thanh Hưng","type":"xa","slug":"xa-thanh-hung","name_with_type":"Xã Thanh Hưng","path":"Xã Thanh Hưng, Huyện Điện Biên, Tỉnh Điện Biên","path_with_type":"Xã Thanh Hưng, Huyện Điện Biên, Tỉnh Điện Biên","code":"03331","parent_code":"100"},"03334":{"name":"Xã Thanh Xương","type":"xa","slug":"xa-thanh-xuong","name_with_type":"Xã Thanh Xương","path":"Xã Thanh Xương, Huyện Điện Biên, Tỉnh Điện Biên","path_with_type":"Xã Thanh Xương, Huyện Điện Biên, Tỉnh Điện Biên","code":"03334","parent_code":"100"},"03337":{"name":"Xã Thanh Chăn","type":"xa","slug":"xa-thanh-chan","name_with_type":"Xã Thanh Chăn","path":"Xã Thanh Chăn, Huyện Điện Biên, Tỉnh Điện Biên","path_with_type":"Xã Thanh Chăn, Huyện Điện Biên, Tỉnh Điện Biên","code":"03337","parent_code":"100"},"03340":{"name":"Xã Pa Thơm","type":"xa","slug":"xa-pa-thom","name_with_type":"Xã Pa Thơm","path":"Xã Pa Thơm, Huyện Điện Biên, Tỉnh Điện Biên","path_with_type":"Xã Pa Thơm, Huyện Điện Biên, Tỉnh Điện Biên","code":"03340","parent_code":"100"},"03343":{"name":"Xã Thanh An","type":"xa","slug":"xa-thanh-an","name_with_type":"Xã Thanh An","path":"Xã Thanh An, Huyện Điện Biên, Tỉnh Điện Biên","path_with_type":"Xã Thanh An, Huyện Điện Biên, Tỉnh Điện Biên","code":"03343","parent_code":"100"},"03346":{"name":"Xã Thanh Yên","type":"xa","slug":"xa-thanh-yen","name_with_type":"Xã Thanh Yên","path":"Xã Thanh Yên, Huyện Điện Biên, Tỉnh Điện Biên","path_with_type":"Xã Thanh Yên, Huyện Điện Biên, Tỉnh Điện Biên","code":"03346","parent_code":"100"},"03349":{"name":"Xã Noong Luống","type":"xa","slug":"xa-noong-luong","name_with_type":"Xã Noong Luống","path":"Xã Noong Luống, Huyện Điện Biên, Tỉnh Điện Biên","path_with_type":"Xã Noong Luống, Huyện Điện Biên, Tỉnh Điện Biên","code":"03349","parent_code":"100"},"03352":{"name":"Xã Noọng Hẹt","type":"xa","slug":"xa-noong-het","name_with_type":"Xã Noọng Hẹt","path":"Xã Noọng Hẹt, Huyện Điện Biên, Tỉnh Điện Biên","path_with_type":"Xã Noọng Hẹt, Huyện Điện Biên, Tỉnh Điện Biên","code":"03352","parent_code":"100"},"03355":{"name":"Xã Sam Mứn","type":"xa","slug":"xa-sam-mun","name_with_type":"Xã Sam Mứn","path":"Xã Sam Mứn, Huyện Điện Biên, Tỉnh Điện Biên","path_with_type":"Xã Sam Mứn, Huyện Điện Biên, Tỉnh Điện Biên","code":"03355","parent_code":"100"},"03356":{"name":"Xã Pom Lót","type":"xa","slug":"xa-pom-lot","name_with_type":"Xã Pom Lót","path":"Xã Pom Lót, Huyện Điện Biên, Tỉnh Điện Biên","path_with_type":"Xã Pom Lót, Huyện Điện Biên, Tỉnh Điện Biên","code":"03356","parent_code":"100"},"03358":{"name":"Xã Núa Ngam","type":"xa","slug":"xa-nua-ngam","name_with_type":"Xã Núa Ngam","path":"Xã Núa Ngam, Huyện Điện Biên, Tỉnh Điện Biên","path_with_type":"Xã Núa Ngam, Huyện Điện Biên, Tỉnh Điện Biên","code":"03358","parent_code":"100"},"03359":{"name":"Xã Hẹ Muông","type":"xa","slug":"xa-he-muong","name_with_type":"Xã Hẹ Muông","path":"Xã Hẹ Muông, Huyện Điện Biên, Tỉnh Điện Biên","path_with_type":"Xã Hẹ Muông, Huyện Điện Biên, Tỉnh Điện Biên","code":"03359","parent_code":"100"},"03361":{"name":"Xã Na Ư","type":"xa","slug":"xa-na-u","name_with_type":"Xã Na Ư","path":"Xã Na Ư, Huyện Điện Biên, Tỉnh Điện Biên","path_with_type":"Xã Na Ư, Huyện Điện Biên, Tỉnh Điện Biên","code":"03361","parent_code":"100"},"03364":{"name":"Xã Mường Nhà","type":"xa","slug":"xa-muong-nha","name_with_type":"Xã Mường Nhà","path":"Xã Mường Nhà, Huyện Điện Biên, Tỉnh Điện Biên","path_with_type":"Xã Mường Nhà, Huyện Điện Biên, Tỉnh Điện Biên","code":"03364","parent_code":"100"},"03365":{"name":"Xã Na Tông","type":"xa","slug":"xa-na-tong","name_with_type":"Xã Na Tông","path":"Xã Na Tông, Huyện Điện Biên, Tỉnh Điện Biên","path_with_type":"Xã Na Tông, Huyện Điện Biên, Tỉnh Điện Biên","code":"03365","parent_code":"100"},"03367":{"name":"Xã Mường Lói","type":"xa","slug":"xa-muong-loi","name_with_type":"Xã Mường Lói","path":"Xã Mường Lói, Huyện Điện Biên, Tỉnh Điện Biên","path_with_type":"Xã Mường Lói, Huyện Điện Biên, Tỉnh Điện Biên","code":"03367","parent_code":"100"},"03368":{"name":"Xã Phu Luông","type":"xa","slug":"xa-phu-luong","name_with_type":"Xã Phu Luông","path":"Xã Phu Luông, Huyện Điện Biên, Tỉnh Điện Biên","path_with_type":"Xã Phu Luông, Huyện Điện Biên, Tỉnh Điện Biên","code":"03368","parent_code":"100"},"03203":{"name":"Thị trấn Điện Biên Đông","type":"thi-tran","slug":"thi-tran-dien-bien-dong","name_with_type":"Thị trấn Điện Biên Đông","path":"Thị trấn Điện Biên Đông, Huyện Điện Biên Đông, Tỉnh Điện Biên","path_with_type":"Thị trấn Điện Biên Đông, Huyện Điện Biên Đông, Tỉnh Điện Biên","code":"03203","parent_code":"101"},"03205":{"name":"Xã Na Son","type":"xa","slug":"xa-na-son","name_with_type":"Xã Na Son","path":"Xã Na Son, Huyện Điện Biên Đông, Tỉnh Điện Biên","path_with_type":"Xã Na Son, Huyện Điện Biên Đông, Tỉnh Điện Biên","code":"03205","parent_code":"101"},"03208":{"name":"Xã Phì Nhừ","type":"xa","slug":"xa-phi-nhu","name_with_type":"Xã Phì Nhừ","path":"Xã Phì Nhừ, Huyện Điện Biên Đông, Tỉnh Điện Biên","path_with_type":"Xã Phì Nhừ, Huyện Điện Biên Đông, Tỉnh Điện Biên","code":"03208","parent_code":"101"},"03211":{"name":"Xã Chiềng Sơ","type":"xa","slug":"xa-chieng-so","name_with_type":"Xã Chiềng Sơ","path":"Xã Chiềng Sơ, Huyện Điện Biên Đông, Tỉnh Điện Biên","path_with_type":"Xã Chiềng Sơ, Huyện Điện Biên Đông, Tỉnh Điện Biên","code":"03211","parent_code":"101"},"03214":{"name":"Xã Mường Luân","type":"xa","slug":"xa-muong-luan","name_with_type":"Xã Mường Luân","path":"Xã Mường Luân, Huyện Điện Biên Đông, Tỉnh Điện Biên","path_with_type":"Xã Mường Luân, Huyện Điện Biên Đông, Tỉnh Điện Biên","code":"03214","parent_code":"101"},"03370":{"name":"Xã Pú Nhi","type":"xa","slug":"xa-pu-nhi","name_with_type":"Xã Pú Nhi","path":"Xã Pú Nhi, Huyện Điện Biên Đông, Tỉnh Điện Biên","path_with_type":"Xã Pú Nhi, Huyện Điện Biên Đông, Tỉnh Điện Biên","code":"03370","parent_code":"101"},"03371":{"name":"Xã Nong U","type":"xa","slug":"xa-nong-u","name_with_type":"Xã Nong U","path":"Xã Nong U, Huyện Điện Biên Đông, Tỉnh Điện Biên","path_with_type":"Xã Nong U, Huyện Điện Biên Đông, Tỉnh Điện Biên","code":"03371","parent_code":"101"},"03373":{"name":"Xã Xa Dung","type":"xa","slug":"xa-xa-dung","name_with_type":"Xã Xa Dung","path":"Xã Xa Dung, Huyện Điện Biên Đông, Tỉnh Điện Biên","path_with_type":"Xã Xa Dung, Huyện Điện Biên Đông, Tỉnh Điện Biên","code":"03373","parent_code":"101"},"03376":{"name":"Xã Keo Lôm","type":"xa","slug":"xa-keo-lom","name_with_type":"Xã Keo Lôm","path":"Xã Keo Lôm, Huyện Điện Biên Đông, Tỉnh Điện Biên","path_with_type":"Xã Keo Lôm, Huyện Điện Biên Đông, Tỉnh Điện Biên","code":"03376","parent_code":"101"},"03379":{"name":"Xã Luân Giới","type":"xa","slug":"xa-luan-gioi","name_with_type":"Xã Luân Giới","path":"Xã Luân Giới, Huyện Điện Biên Đông, Tỉnh Điện Biên","path_with_type":"Xã Luân Giới, Huyện Điện Biên Đông, Tỉnh Điện Biên","code":"03379","parent_code":"101"},"03382":{"name":"Xã Phình Giàng","type":"xa","slug":"xa-phinh-giang","name_with_type":"Xã Phình Giàng","path":"Xã Phình Giàng, Huyện Điện Biên Đông, Tỉnh Điện Biên","path_with_type":"Xã Phình Giàng, Huyện Điện Biên Đông, Tỉnh Điện Biên","code":"03382","parent_code":"101"},"03383":{"name":"Xã Pú Hồng","type":"xa","slug":"xa-pu-hong","name_with_type":"Xã Pú Hồng","path":"Xã Pú Hồng, Huyện Điện Biên Đông, Tỉnh Điện Biên","path_with_type":"Xã Pú Hồng, Huyện Điện Biên Đông, Tỉnh Điện Biên","code":"03383","parent_code":"101"},"03384":{"name":"Xã Tìa Dình","type":"xa","slug":"xa-tia-dinh","name_with_type":"Xã Tìa Dình","path":"Xã Tìa Dình, Huyện Điện Biên Đông, Tỉnh Điện Biên","path_with_type":"Xã Tìa Dình, Huyện Điện Biên Đông, Tỉnh Điện Biên","code":"03384","parent_code":"101"},"03385":{"name":"Xã Háng Lìa","type":"xa","slug":"xa-hang-lia","name_with_type":"Xã Háng Lìa","path":"Xã Háng Lìa, Huyện Điện Biên Đông, Tỉnh Điện Biên","path_with_type":"Xã Háng Lìa, Huyện Điện Biên Đông, Tỉnh Điện Biên","code":"03385","parent_code":"101"},"03256":{"name":"Thị trấn Mường Ảng","type":"thi-tran","slug":"thi-tran-muong-ang","name_with_type":"Thị trấn Mường Ảng","path":"Thị trấn Mường Ảng, Huyện Mường Ảng, Tỉnh Điện Biên","path_with_type":"Thị trấn Mường Ảng, Huyện Mường Ảng, Tỉnh Điện Biên","code":"03256","parent_code":"102"},"03286":{"name":"Xã Mường Đăng","type":"xa","slug":"xa-muong-dang","name_with_type":"Xã Mường Đăng","path":"Xã Mường Đăng, Huyện Mường Ảng, Tỉnh Điện Biên","path_with_type":"Xã Mường Đăng, Huyện Mường Ảng, Tỉnh Điện Biên","code":"03286","parent_code":"102"},"03287":{"name":"Xã Ngối Cáy","type":"xa","slug":"xa-ngoi-cay","name_with_type":"Xã Ngối Cáy","path":"Xã Ngối Cáy, Huyện Mường Ảng, Tỉnh Điện Biên","path_with_type":"Xã Ngối Cáy, Huyện Mường Ảng, Tỉnh Điện Biên","code":"03287","parent_code":"102"},"03292":{"name":"Xã Ẳng Tở","type":"xa","slug":"xa-ang-to","name_with_type":"Xã Ẳng Tở","path":"Xã Ẳng Tở, Huyện Mường Ảng, Tỉnh Điện Biên","path_with_type":"Xã Ẳng Tở, Huyện Mường Ảng, Tỉnh Điện Biên","code":"03292","parent_code":"102"},"03301":{"name":"Xã Búng Lao","type":"xa","slug":"xa-bung-lao","name_with_type":"Xã Búng Lao","path":"Xã Búng Lao, Huyện Mường Ảng, Tỉnh Điện Biên","path_with_type":"Xã Búng Lao, Huyện Mường Ảng, Tỉnh Điện Biên","code":"03301","parent_code":"102"},"03302":{"name":"Xã Xuân Lao","type":"xa","slug":"xa-xuan-lao","name_with_type":"Xã Xuân Lao","path":"Xã Xuân Lao, Huyện Mường Ảng, Tỉnh Điện Biên","path_with_type":"Xã Xuân Lao, Huyện Mường Ảng, Tỉnh Điện Biên","code":"03302","parent_code":"102"},"03307":{"name":"Xã Ẳng Nưa","type":"xa","slug":"xa-ang-nua","name_with_type":"Xã Ẳng Nưa","path":"Xã Ẳng Nưa, Huyện Mường Ảng, Tỉnh Điện Biên","path_with_type":"Xã Ẳng Nưa, Huyện Mường Ảng, Tỉnh Điện Biên","code":"03307","parent_code":"102"},"03310":{"name":"Xã Ẳng Cang","type":"xa","slug":"xa-ang-cang","name_with_type":"Xã Ẳng Cang","path":"Xã Ẳng Cang, Huyện Mường Ảng, Tỉnh Điện Biên","path_with_type":"Xã Ẳng Cang, Huyện Mường Ảng, Tỉnh Điện Biên","code":"03310","parent_code":"102"},"03312":{"name":"Xã Nặm Lịch","type":"xa","slug":"xa-nam-lich","name_with_type":"Xã Nặm Lịch","path":"Xã Nặm Lịch, Huyện Mường Ảng, Tỉnh Điện Biên","path_with_type":"Xã Nặm Lịch, Huyện Mường Ảng, Tỉnh Điện Biên","code":"03312","parent_code":"102"},"03313":{"name":"Xã Mường Lạn","type":"xa","slug":"xa-muong-lan","name_with_type":"Xã Mường Lạn","path":"Xã Mường Lạn, Huyện Mường Ảng, Tỉnh Điện Biên","path_with_type":"Xã Mường Lạn, Huyện Mường Ảng, Tỉnh Điện Biên","code":"03313","parent_code":"102"},"03156":{"name":"Xã Nậm Tin","type":"xa","slug":"xa-nam-tin","name_with_type":"Xã Nậm Tin","path":"Xã Nậm Tin, Huyện Nậm Pồ, Tỉnh Điện Biên","path_with_type":"Xã Nậm Tin, Huyện Nậm Pồ, Tỉnh Điện Biên","code":"03156","parent_code":"103"},"03165":{"name":"Xã Pa Tần","type":"xa","slug":"xa-pa-tan","name_with_type":"Xã Pa Tần","path":"Xã Pa Tần, Huyện Nậm Pồ, Tỉnh Điện Biên","path_with_type":"Xã Pa Tần, Huyện Nậm Pồ, Tỉnh Điện Biên","code":"03165","parent_code":"103"},"03166":{"name":"Xã Chà Cang","type":"xa","slug":"xa-cha-cang","name_with_type":"Xã Chà Cang","path":"Xã Chà Cang, Huyện Nậm Pồ, Tỉnh Điện Biên","path_with_type":"Xã Chà Cang, Huyện Nậm Pồ, Tỉnh Điện Biên","code":"03166","parent_code":"103"},"03167":{"name":"Xã Na Cô Sa","type":"xa","slug":"xa-na-co-sa","name_with_type":"Xã Na Cô Sa","path":"Xã Na Cô Sa, Huyện Nậm Pồ, Tỉnh Điện Biên","path_with_type":"Xã Na Cô Sa, Huyện Nậm Pồ, Tỉnh Điện Biên","code":"03167","parent_code":"103"},"03168":{"name":"Xã Nà Khoa","type":"xa","slug":"xa-na-khoa","name_with_type":"Xã Nà Khoa","path":"Xã Nà Khoa, Huyện Nậm Pồ, Tỉnh Điện Biên","path_with_type":"Xã Nà Khoa, Huyện Nậm Pồ, Tỉnh Điện Biên","code":"03168","parent_code":"103"},"03169":{"name":"Xã Nà Hỳ","type":"xa","slug":"xa-na-hy","name_with_type":"Xã Nà Hỳ","path":"Xã Nà Hỳ, Huyện Nậm Pồ, Tỉnh Điện Biên","path_with_type":"Xã Nà Hỳ, Huyện Nậm Pồ, Tỉnh Điện Biên","code":"03169","parent_code":"103"},"03170":{"name":"Xã Nà Bủng","type":"xa","slug":"xa-na-bung","name_with_type":"Xã Nà Bủng","path":"Xã Nà Bủng, Huyện Nậm Pồ, Tỉnh Điện Biên","path_with_type":"Xã Nà Bủng, Huyện Nậm Pồ, Tỉnh Điện Biên","code":"03170","parent_code":"103"},"03171":{"name":"Xã Nậm Nhừ","type":"xa","slug":"xa-nam-nhu","name_with_type":"Xã Nậm Nhừ","path":"Xã Nậm Nhừ, Huyện Nậm Pồ, Tỉnh Điện Biên","path_with_type":"Xã Nậm Nhừ, Huyện Nậm Pồ, Tỉnh Điện Biên","code":"03171","parent_code":"103"},"03173":{"name":"Xã Nậm Chua","type":"xa","slug":"xa-nam-chua","name_with_type":"Xã Nậm Chua","path":"Xã Nậm Chua, Huyện Nậm Pồ, Tỉnh Điện Biên","path_with_type":"Xã Nậm Chua, Huyện Nậm Pồ, Tỉnh Điện Biên","code":"03173","parent_code":"103"},"03174":{"name":"Xã Nậm Khăn","type":"xa","slug":"xa-nam-khan","name_with_type":"Xã Nậm Khăn","path":"Xã Nậm Khăn, Huyện Nậm Pồ, Tỉnh Điện Biên","path_with_type":"Xã Nậm Khăn, Huyện Nậm Pồ, Tỉnh Điện Biên","code":"03174","parent_code":"103"},"03175":{"name":"Xã Chà Tở","type":"xa","slug":"xa-cha-to","name_with_type":"Xã Chà Tở","path":"Xã Chà Tở, Huyện Nậm Pồ, Tỉnh Điện Biên","path_with_type":"Xã Chà Tở, Huyện Nậm Pồ, Tỉnh Điện Biên","code":"03175","parent_code":"103"},"03176":{"name":"Xã Vàng Đán","type":"xa","slug":"xa-vang-dan","name_with_type":"Xã Vàng Đán","path":"Xã Vàng Đán, Huyện Nậm Pồ, Tỉnh Điện Biên","path_with_type":"Xã Vàng Đán, Huyện Nậm Pồ, Tỉnh Điện Biên","code":"03176","parent_code":"103"},"03187":{"name":"Xã Chà Nưa","type":"xa","slug":"xa-cha-nua","name_with_type":"Xã Chà Nưa","path":"Xã Chà Nưa, Huyện Nậm Pồ, Tỉnh Điện Biên","path_with_type":"Xã Chà Nưa, Huyện Nậm Pồ, Tỉnh Điện Biên","code":"03187","parent_code":"103"},"03198":{"name":"Xã Phìn Hồ","type":"xa","slug":"xa-phin-ho","name_with_type":"Xã Phìn Hồ","path":"Xã Phìn Hồ, Huyện Nậm Pồ, Tỉnh Điện Biên","path_with_type":"Xã Phìn Hồ, Huyện Nậm Pồ, Tỉnh Điện Biên","code":"03198","parent_code":"103"},"03199":{"name":"Xã Si Pa Phìn","type":"xa","slug":"xa-si-pa-phin","name_with_type":"Xã Si Pa Phìn","path":"Xã Si Pa Phìn, Huyện Nậm Pồ, Tỉnh Điện Biên","path_with_type":"Xã Si Pa Phìn, Huyện Nậm Pồ, Tỉnh Điện Biên","code":"03199","parent_code":"103"},"03386":{"name":"Phường Quyết Thắng","type":"phuong","slug":"phuong-quyet-thang","name_with_type":"Phường Quyết Thắng","path":"Phường Quyết Thắng, Thành phố Lai Châu, Tỉnh Lai Châu","path_with_type":"Phường Quyết Thắng, Thành phố Lai Châu, Tỉnh Lai Châu","code":"03386","parent_code":"105"},"03387":{"name":"Phường Tân Phong","type":"phuong","slug":"phuong-tan-phong","name_with_type":"Phường Tân Phong","path":"Phường Tân Phong, Thành phố Lai Châu, Tỉnh Lai Châu","path_with_type":"Phường Tân Phong, Thành phố Lai Châu, Tỉnh Lai Châu","code":"03387","parent_code":"105"},"03388":{"name":"Phường Quyết Tiến","type":"phuong","slug":"phuong-quyet-tien","name_with_type":"Phường Quyết Tiến","path":"Phường Quyết Tiến, Thành phố Lai Châu, Tỉnh Lai Châu","path_with_type":"Phường Quyết Tiến, Thành phố Lai Châu, Tỉnh Lai Châu","code":"03388","parent_code":"105"},"03389":{"name":"Phường Đoàn Kết","type":"phuong","slug":"phuong-doan-ket","name_with_type":"Phường Đoàn Kết","path":"Phường Đoàn Kết, Thành phố Lai Châu, Tỉnh Lai Châu","path_with_type":"Phường Đoàn Kết, Thành phố Lai Châu, Tỉnh Lai Châu","code":"03389","parent_code":"105"},"03403":{"name":"Xã Sùng Phài","type":"xa","slug":"xa-sung-phai","name_with_type":"Xã Sùng Phài","path":"Xã Sùng Phài, Thành phố Lai Châu, Tỉnh Lai Châu","path_with_type":"Xã Sùng Phài, Thành phố Lai Châu, Tỉnh Lai Châu","code":"03403","parent_code":"105"},"03408":{"name":"Phường Đông Phong","type":"phuong","slug":"phuong-dong-phong","name_with_type":"Phường Đông Phong","path":"Phường Đông Phong, Thành phố Lai Châu, Tỉnh Lai Châu","path_with_type":"Phường Đông Phong, Thành phố Lai Châu, Tỉnh Lai Châu","code":"03408","parent_code":"105"},"03409":{"name":"Xã San Thàng","type":"xa","slug":"xa-san-thang","name_with_type":"Xã San Thàng","path":"Xã San Thàng, Thành phố Lai Châu, Tỉnh Lai Châu","path_with_type":"Xã San Thàng, Thành phố Lai Châu, Tỉnh Lai Châu","code":"03409","parent_code":"105"},"03390":{"name":"Thị trấn Tam Đường","type":"thi-tran","slug":"thi-tran-tam-duong","name_with_type":"Thị trấn Tam Đường","path":"Thị trấn Tam Đường, Huyện Tam Đường, Tỉnh Lai Châu","path_with_type":"Thị trấn Tam Đường, Huyện Tam Đường, Tỉnh Lai Châu","code":"03390","parent_code":"106"},"03394":{"name":"Xã Thèn Sin","type":"xa","slug":"xa-then-sin","name_with_type":"Xã Thèn Sin","path":"Xã Thèn Sin, Huyện Tam Đường, Tỉnh Lai Châu","path_with_type":"Xã Thèn Sin, Huyện Tam Đường, Tỉnh Lai Châu","code":"03394","parent_code":"106"},"03400":{"name":"Xã Tả Lèng","type":"xa","slug":"xa-ta-leng","name_with_type":"Xã Tả Lèng","path":"Xã Tả Lèng, Huyện Tam Đường, Tỉnh Lai Châu","path_with_type":"Xã Tả Lèng, Huyện Tam Đường, Tỉnh Lai Châu","code":"03400","parent_code":"106"},"03405":{"name":"Xã Giang Ma","type":"xa","slug":"xa-giang-ma","name_with_type":"Xã Giang Ma","path":"Xã Giang Ma, Huyện Tam Đường, Tỉnh Lai Châu","path_with_type":"Xã Giang Ma, Huyện Tam Đường, Tỉnh Lai Châu","code":"03405","parent_code":"106"},"03406":{"name":"Xã Hồ Thầu","type":"xa","slug":"xa-ho-thau","name_with_type":"Xã Hồ Thầu","path":"Xã Hồ Thầu, Huyện Tam Đường, Tỉnh Lai Châu","path_with_type":"Xã Hồ Thầu, Huyện Tam Đường, Tỉnh Lai Châu","code":"03406","parent_code":"106"},"03412":{"name":"Xã Bình Lư","type":"xa","slug":"xa-binh-lu","name_with_type":"Xã Bình Lư","path":"Xã Bình Lư, Huyện Tam Đường, Tỉnh Lai Châu","path_with_type":"Xã Bình Lư, Huyện Tam Đường, Tỉnh Lai Châu","code":"03412","parent_code":"106"},"03413":{"name":"Xã Sơn Bình","type":"xa","slug":"xa-son-binh","name_with_type":"Xã Sơn Bình","path":"Xã Sơn Bình, Huyện Tam Đường, Tỉnh Lai Châu","path_with_type":"Xã Sơn Bình, Huyện Tam Đường, Tỉnh Lai Châu","code":"03413","parent_code":"106"},"03415":{"name":"Xã Nùng Nàng","type":"xa","slug":"xa-nung-nang","name_with_type":"Xã Nùng Nàng","path":"Xã Nùng Nàng, Huyện Tam Đường, Tỉnh Lai Châu","path_with_type":"Xã Nùng Nàng, Huyện Tam Đường, Tỉnh Lai Châu","code":"03415","parent_code":"106"},"03418":{"name":"Xã Bản Giang","type":"xa","slug":"xa-ban-giang","name_with_type":"Xã Bản Giang","path":"Xã Bản Giang, Huyện Tam Đường, Tỉnh Lai Châu","path_with_type":"Xã Bản Giang, Huyện Tam Đường, Tỉnh Lai Châu","code":"03418","parent_code":"106"},"03421":{"name":"Xã Bản Hon","type":"xa","slug":"xa-ban-hon","name_with_type":"Xã Bản Hon","path":"Xã Bản Hon, Huyện Tam Đường, Tỉnh Lai Châu","path_with_type":"Xã Bản Hon, Huyện Tam Đường, Tỉnh Lai Châu","code":"03421","parent_code":"106"},"03424":{"name":"Xã Bản Bo","type":"xa","slug":"xa-ban-bo","name_with_type":"Xã Bản Bo","path":"Xã Bản Bo, Huyện Tam Đường, Tỉnh Lai Châu","path_with_type":"Xã Bản Bo, Huyện Tam Đường, Tỉnh Lai Châu","code":"03424","parent_code":"106"},"03427":{"name":"Xã Nà Tăm","type":"xa","slug":"xa-na-tam","name_with_type":"Xã Nà Tăm","path":"Xã Nà Tăm, Huyện Tam Đường, Tỉnh Lai Châu","path_with_type":"Xã Nà Tăm, Huyện Tam Đường, Tỉnh Lai Châu","code":"03427","parent_code":"106"},"03430":{"name":"Xã Khun Há","type":"xa","slug":"xa-khun-ha","name_with_type":"Xã Khun Há","path":"Xã Khun Há, Huyện Tam Đường, Tỉnh Lai Châu","path_with_type":"Xã Khun Há, Huyện Tam Đường, Tỉnh Lai Châu","code":"03430","parent_code":"106"},"03433":{"name":"Thị trấn Mường Tè","type":"thi-tran","slug":"thi-tran-muong-te","name_with_type":"Thị trấn Mường Tè","path":"Thị trấn Mường Tè, Huyện Mường Tè, Tỉnh Lai Châu","path_with_type":"Thị trấn Mường Tè, Huyện Mường Tè, Tỉnh Lai Châu","code":"03433","parent_code":"107"},"03436":{"name":"Xã Thu Lũm","type":"xa","slug":"xa-thu-lum","name_with_type":"Xã Thu Lũm","path":"Xã Thu Lũm, Huyện Mường Tè, Tỉnh Lai Châu","path_with_type":"Xã Thu Lũm, Huyện Mường Tè, Tỉnh Lai Châu","code":"03436","parent_code":"107"},"03439":{"name":"Xã Ka Lăng","type":"xa","slug":"xa-ka-lang","name_with_type":"Xã Ka Lăng","path":"Xã Ka Lăng, Huyện Mường Tè, Tỉnh Lai Châu","path_with_type":"Xã Ka Lăng, Huyện Mường Tè, Tỉnh Lai Châu","code":"03439","parent_code":"107"},"03440":{"name":"Xã Tá Bạ","type":"xa","slug":"xa-ta-ba","name_with_type":"Xã Tá Bạ","path":"Xã Tá Bạ, Huyện Mường Tè, Tỉnh Lai Châu","path_with_type":"Xã Tá Bạ, Huyện Mường Tè, Tỉnh Lai Châu","code":"03440","parent_code":"107"},"03442":{"name":"Xã Pa ủ","type":"xa","slug":"xa-pa-u","name_with_type":"Xã Pa ủ","path":"Xã Pa ủ, Huyện Mường Tè, Tỉnh Lai Châu","path_with_type":"Xã Pa ủ, Huyện Mường Tè, Tỉnh Lai Châu","code":"03442","parent_code":"107"},"03445":{"name":"Xã Mường Tè","type":"xa","slug":"xa-muong-te","name_with_type":"Xã Mường Tè","path":"Xã Mường Tè, Huyện Mường Tè, Tỉnh Lai Châu","path_with_type":"Xã Mường Tè, Huyện Mường Tè, Tỉnh Lai Châu","code":"03445","parent_code":"107"},"03448":{"name":"Xã Pa Vệ Sử","type":"xa","slug":"xa-pa-ve-su","name_with_type":"Xã Pa Vệ Sử","path":"Xã Pa Vệ Sử, Huyện Mường Tè, Tỉnh Lai Châu","path_with_type":"Xã Pa Vệ Sử, Huyện Mường Tè, Tỉnh Lai Châu","code":"03448","parent_code":"107"},"03451":{"name":"Xã Mù Cả","type":"xa","slug":"xa-mu-ca","name_with_type":"Xã Mù Cả","path":"Xã Mù Cả, Huyện Mường Tè, Tỉnh Lai Châu","path_with_type":"Xã Mù Cả, Huyện Mường Tè, Tỉnh Lai Châu","code":"03451","parent_code":"107"},"03454":{"name":"Xã Bum Tở","type":"xa","slug":"xa-bum-to","name_with_type":"Xã Bum Tở","path":"Xã Bum Tở, Huyện Mường Tè, Tỉnh Lai Châu","path_with_type":"Xã Bum Tở, Huyện Mường Tè, Tỉnh Lai Châu","code":"03454","parent_code":"107"},"03457":{"name":"Xã Nậm Khao","type":"xa","slug":"xa-nam-khao","name_with_type":"Xã Nậm Khao","path":"Xã Nậm Khao, Huyện Mường Tè, Tỉnh Lai Châu","path_with_type":"Xã Nậm Khao, Huyện Mường Tè, Tỉnh Lai Châu","code":"03457","parent_code":"107"},"03463":{"name":"Xã Tà Tổng","type":"xa","slug":"xa-ta-tong","name_with_type":"Xã Tà Tổng","path":"Xã Tà Tổng, Huyện Mường Tè, Tỉnh Lai Châu","path_with_type":"Xã Tà Tổng, Huyện Mường Tè, Tỉnh Lai Châu","code":"03463","parent_code":"107"},"03466":{"name":"Xã Bum Nưa","type":"xa","slug":"xa-bum-nua","name_with_type":"Xã Bum Nưa","path":"Xã Bum Nưa, Huyện Mường Tè, Tỉnh Lai Châu","path_with_type":"Xã Bum Nưa, Huyện Mường Tè, Tỉnh Lai Châu","code":"03466","parent_code":"107"},"03467":{"name":"Xã Vàng San","type":"xa","slug":"xa-vang-san","name_with_type":"Xã Vàng San","path":"Xã Vàng San, Huyện Mường Tè, Tỉnh Lai Châu","path_with_type":"Xã Vàng San, Huyện Mường Tè, Tỉnh Lai Châu","code":"03467","parent_code":"107"},"03469":{"name":"Xã Kan Hồ","type":"xa","slug":"xa-kan-ho","name_with_type":"Xã Kan Hồ","path":"Xã Kan Hồ, Huyện Mường Tè, Tỉnh Lai Châu","path_with_type":"Xã Kan Hồ, Huyện Mường Tè, Tỉnh Lai Châu","code":"03469","parent_code":"107"},"03478":{"name":"Thị trấn Sìn Hồ","type":"thi-tran","slug":"thi-tran-sin-ho","name_with_type":"Thị trấn Sìn Hồ","path":"Thị trấn Sìn Hồ, Huyện Sìn Hồ, Tỉnh Lai Châu","path_with_type":"Thị trấn Sìn Hồ, Huyện Sìn Hồ, Tỉnh Lai Châu","code":"03478","parent_code":"108"},"03487":{"name":"Xã Chăn Nưa","type":"xa","slug":"xa-chan-nua","name_with_type":"Xã Chăn Nưa","path":"Xã Chăn Nưa, Huyện Sìn Hồ, Tỉnh Lai Châu","path_with_type":"Xã Chăn Nưa, Huyện Sìn Hồ, Tỉnh Lai Châu","code":"03487","parent_code":"108"},"03493":{"name":"Xã Pa Tần","type":"xa","slug":"xa-pa-tan","name_with_type":"Xã Pa Tần","path":"Xã Pa Tần, Huyện Sìn Hồ, Tỉnh Lai Châu","path_with_type":"Xã Pa Tần, Huyện Sìn Hồ, Tỉnh Lai Châu","code":"03493","parent_code":"108"},"03496":{"name":"Xã Phìn Hồ","type":"xa","slug":"xa-phin-ho","name_with_type":"Xã Phìn Hồ","path":"Xã Phìn Hồ, Huyện Sìn Hồ, Tỉnh Lai Châu","path_with_type":"Xã Phìn Hồ, Huyện Sìn Hồ, Tỉnh Lai Châu","code":"03496","parent_code":"108"},"03499":{"name":"Xã Hồng Thu","type":"xa","slug":"xa-hong-thu","name_with_type":"Xã Hồng Thu","path":"Xã Hồng Thu, Huyện Sìn Hồ, Tỉnh Lai Châu","path_with_type":"Xã Hồng Thu, Huyện Sìn Hồ, Tỉnh Lai Châu","code":"03499","parent_code":"108"},"03505":{"name":"Xã Phăng Sô Lin","type":"xa","slug":"xa-phang-so-lin","name_with_type":"Xã Phăng Sô Lin","path":"Xã Phăng Sô Lin, Huyện Sìn Hồ, Tỉnh Lai Châu","path_with_type":"Xã Phăng Sô Lin, Huyện Sìn Hồ, Tỉnh Lai Châu","code":"03505","parent_code":"108"},"03508":{"name":"Xã Ma Quai","type":"xa","slug":"xa-ma-quai","name_with_type":"Xã Ma Quai","path":"Xã Ma Quai, Huyện Sìn Hồ, Tỉnh Lai Châu","path_with_type":"Xã Ma Quai, Huyện Sìn Hồ, Tỉnh Lai Châu","code":"03508","parent_code":"108"},"03509":{"name":"Xã Lùng Thàng","type":"xa","slug":"xa-lung-thang","name_with_type":"Xã Lùng Thàng","path":"Xã Lùng Thàng, Huyện Sìn Hồ, Tỉnh Lai Châu","path_with_type":"Xã Lùng Thàng, Huyện Sìn Hồ, Tỉnh Lai Châu","code":"03509","parent_code":"108"},"03511":{"name":"Xã Tả Phìn","type":"xa","slug":"xa-ta-phin","name_with_type":"Xã Tả Phìn","path":"Xã Tả Phìn, Huyện Sìn Hồ, Tỉnh Lai Châu","path_with_type":"Xã Tả Phìn, Huyện Sìn Hồ, Tỉnh Lai Châu","code":"03511","parent_code":"108"},"03514":{"name":"Xã Sà Dề Phìn","type":"xa","slug":"xa-sa-de-phin","name_with_type":"Xã Sà Dề Phìn","path":"Xã Sà Dề Phìn, Huyện Sìn Hồ, Tỉnh Lai Châu","path_with_type":"Xã Sà Dề Phìn, Huyện Sìn Hồ, Tỉnh Lai Châu","code":"03514","parent_code":"108"},"03517":{"name":"Xã Nậm Tăm","type":"xa","slug":"xa-nam-tam","name_with_type":"Xã Nậm Tăm","path":"Xã Nậm Tăm, Huyện Sìn Hồ, Tỉnh Lai Châu","path_with_type":"Xã Nậm Tăm, Huyện Sìn Hồ, Tỉnh Lai Châu","code":"03517","parent_code":"108"},"03520":{"name":"Xã Tả Ngảo","type":"xa","slug":"xa-ta-ngao","name_with_type":"Xã Tả Ngảo","path":"Xã Tả Ngảo, Huyện Sìn Hồ, Tỉnh Lai Châu","path_with_type":"Xã Tả Ngảo, Huyện Sìn Hồ, Tỉnh Lai Châu","code":"03520","parent_code":"108"},"03523":{"name":"Xã Pu Sam Cáp","type":"xa","slug":"xa-pu-sam-cap","name_with_type":"Xã Pu Sam Cáp","path":"Xã Pu Sam Cáp, Huyện Sìn Hồ, Tỉnh Lai Châu","path_with_type":"Xã Pu Sam Cáp, Huyện Sìn Hồ, Tỉnh Lai Châu","code":"03523","parent_code":"108"},"03526":{"name":"Xã Nậm Cha","type":"xa","slug":"xa-nam-cha","name_with_type":"Xã Nậm Cha","path":"Xã Nậm Cha, Huyện Sìn Hồ, Tỉnh Lai Châu","path_with_type":"Xã Nậm Cha, Huyện Sìn Hồ, Tỉnh Lai Châu","code":"03526","parent_code":"108"},"03527":{"name":"Xã Pa Khoá","type":"xa","slug":"xa-pa-khoa","name_with_type":"Xã Pa Khoá","path":"Xã Pa Khoá, Huyện Sìn Hồ, Tỉnh Lai Châu","path_with_type":"Xã Pa Khoá, Huyện Sìn Hồ, Tỉnh Lai Châu","code":"03527","parent_code":"108"},"03529":{"name":"Xã Làng Mô","type":"xa","slug":"xa-lang-mo","name_with_type":"Xã Làng Mô","path":"Xã Làng Mô, Huyện Sìn Hồ, Tỉnh Lai Châu","path_with_type":"Xã Làng Mô, Huyện Sìn Hồ, Tỉnh Lai Châu","code":"03529","parent_code":"108"},"03532":{"name":"Xã Noong Hẻo","type":"xa","slug":"xa-noong-heo","name_with_type":"Xã Noong Hẻo","path":"Xã Noong Hẻo, Huyện Sìn Hồ, Tỉnh Lai Châu","path_with_type":"Xã Noong Hẻo, Huyện Sìn Hồ, Tỉnh Lai Châu","code":"03532","parent_code":"108"},"03535":{"name":"Xã Nậm Mạ","type":"xa","slug":"xa-nam-ma","name_with_type":"Xã Nậm Mạ","path":"Xã Nậm Mạ, Huyện Sìn Hồ, Tỉnh Lai Châu","path_with_type":"Xã Nậm Mạ, Huyện Sìn Hồ, Tỉnh Lai Châu","code":"03535","parent_code":"108"},"03538":{"name":"Xã Căn Co","type":"xa","slug":"xa-can-co","name_with_type":"Xã Căn Co","path":"Xã Căn Co, Huyện Sìn Hồ, Tỉnh Lai Châu","path_with_type":"Xã Căn Co, Huyện Sìn Hồ, Tỉnh Lai Châu","code":"03538","parent_code":"108"},"03541":{"name":"Xã Tủa Sín Chải","type":"xa","slug":"xa-tua-sin-chai","name_with_type":"Xã Tủa Sín Chải","path":"Xã Tủa Sín Chải, Huyện Sìn Hồ, Tỉnh Lai Châu","path_with_type":"Xã Tủa Sín Chải, Huyện Sìn Hồ, Tỉnh Lai Châu","code":"03541","parent_code":"108"},"03544":{"name":"Xã Nậm Cuổi","type":"xa","slug":"xa-nam-cuoi","name_with_type":"Xã Nậm Cuổi","path":"Xã Nậm Cuổi, Huyện Sìn Hồ, Tỉnh Lai Châu","path_with_type":"Xã Nậm Cuổi, Huyện Sìn Hồ, Tỉnh Lai Châu","code":"03544","parent_code":"108"},"03547":{"name":"Xã Nậm Hăn","type":"xa","slug":"xa-nam-han","name_with_type":"Xã Nậm Hăn","path":"Xã Nậm Hăn, Huyện Sìn Hồ, Tỉnh Lai Châu","path_with_type":"Xã Nậm Hăn, Huyện Sìn Hồ, Tỉnh Lai Châu","code":"03547","parent_code":"108"},"03391":{"name":"Xã Lả Nhì Thàng","type":"xa","slug":"xa-la-nhi-thang","name_with_type":"Xã Lả Nhì Thàng","path":"Xã Lả Nhì Thàng, Huyện Phong Thổ, Tỉnh Lai Châu","path_with_type":"Xã Lả Nhì Thàng, Huyện Phong Thổ, Tỉnh Lai Châu","code":"03391","parent_code":"109"},"03490":{"name":"Xã Huổi Luông","type":"xa","slug":"xa-huoi-luong","name_with_type":"Xã Huổi Luông","path":"Xã Huổi Luông, Huyện Phong Thổ, Tỉnh Lai Châu","path_with_type":"Xã Huổi Luông, Huyện Phong Thổ, Tỉnh Lai Châu","code":"03490","parent_code":"109"},"03549":{"name":"Thị trấn Phong Thổ","type":"thi-tran","slug":"thi-tran-phong-tho","name_with_type":"Thị trấn Phong Thổ","path":"Thị trấn Phong Thổ, Huyện Phong Thổ, Tỉnh Lai Châu","path_with_type":"Thị trấn Phong Thổ, Huyện Phong Thổ, Tỉnh Lai Châu","code":"03549","parent_code":"109"},"03550":{"name":"Xã Sì Lở Lầu","type":"xa","slug":"xa-si-lo-lau","name_with_type":"Xã Sì Lở Lầu","path":"Xã Sì Lở Lầu, Huyện Phong Thổ, Tỉnh Lai Châu","path_with_type":"Xã Sì Lở Lầu, Huyện Phong Thổ, Tỉnh Lai Châu","code":"03550","parent_code":"109"},"03553":{"name":"Xã Mồ Sì San","type":"xa","slug":"xa-mo-si-san","name_with_type":"Xã Mồ Sì San","path":"Xã Mồ Sì San, Huyện Phong Thổ, Tỉnh Lai Châu","path_with_type":"Xã Mồ Sì San, Huyện Phong Thổ, Tỉnh Lai Châu","code":"03553","parent_code":"109"},"03559":{"name":"Xã Pa Vây Sử","type":"xa","slug":"xa-pa-vay-su","name_with_type":"Xã Pa Vây Sử","path":"Xã Pa Vây Sử, Huyện Phong Thổ, Tỉnh Lai Châu","path_with_type":"Xã Pa Vây Sử, Huyện Phong Thổ, Tỉnh Lai Châu","code":"03559","parent_code":"109"},"03562":{"name":"Xã Vàng Ma Chải","type":"xa","slug":"xa-vang-ma-chai","name_with_type":"Xã Vàng Ma Chải","path":"Xã Vàng Ma Chải, Huyện Phong Thổ, Tỉnh Lai Châu","path_with_type":"Xã Vàng Ma Chải, Huyện Phong Thổ, Tỉnh Lai Châu","code":"03562","parent_code":"109"},"03565":{"name":"Xã Tông Qua Lìn","type":"xa","slug":"xa-tong-qua-lin","name_with_type":"Xã Tông Qua Lìn","path":"Xã Tông Qua Lìn, Huyện Phong Thổ, Tỉnh Lai Châu","path_with_type":"Xã Tông Qua Lìn, Huyện Phong Thổ, Tỉnh Lai Châu","code":"03565","parent_code":"109"},"03568":{"name":"Xã Mù Sang","type":"xa","slug":"xa-mu-sang","name_with_type":"Xã Mù Sang","path":"Xã Mù Sang, Huyện Phong Thổ, Tỉnh Lai Châu","path_with_type":"Xã Mù Sang, Huyện Phong Thổ, Tỉnh Lai Châu","code":"03568","parent_code":"109"},"03571":{"name":"Xã Dào San","type":"xa","slug":"xa-dao-san","name_with_type":"Xã Dào San","path":"Xã Dào San, Huyện Phong Thổ, Tỉnh Lai Châu","path_with_type":"Xã Dào San, Huyện Phong Thổ, Tỉnh Lai Châu","code":"03571","parent_code":"109"},"03574":{"name":"Xã Ma Ly Pho","type":"xa","slug":"xa-ma-ly-pho","name_with_type":"Xã Ma Ly Pho","path":"Xã Ma Ly Pho, Huyện Phong Thổ, Tỉnh Lai Châu","path_with_type":"Xã Ma Ly Pho, Huyện Phong Thổ, Tỉnh Lai Châu","code":"03574","parent_code":"109"},"03577":{"name":"Xã Bản Lang","type":"xa","slug":"xa-ban-lang","name_with_type":"Xã Bản Lang","path":"Xã Bản Lang, Huyện Phong Thổ, Tỉnh Lai Châu","path_with_type":"Xã Bản Lang, Huyện Phong Thổ, Tỉnh Lai Châu","code":"03577","parent_code":"109"},"03580":{"name":"Xã Hoang Thèn","type":"xa","slug":"xa-hoang-then","name_with_type":"Xã Hoang Thèn","path":"Xã Hoang Thèn, Huyện Phong Thổ, Tỉnh Lai Châu","path_with_type":"Xã Hoang Thèn, Huyện Phong Thổ, Tỉnh Lai Châu","code":"03580","parent_code":"109"},"03583":{"name":"Xã Khổng Lào","type":"xa","slug":"xa-khong-lao","name_with_type":"Xã Khổng Lào","path":"Xã Khổng Lào, Huyện Phong Thổ, Tỉnh Lai Châu","path_with_type":"Xã Khổng Lào, Huyện Phong Thổ, Tỉnh Lai Châu","code":"03583","parent_code":"109"},"03586":{"name":"Xã Nậm Xe","type":"xa","slug":"xa-nam-xe","name_with_type":"Xã Nậm Xe","path":"Xã Nậm Xe, Huyện Phong Thổ, Tỉnh Lai Châu","path_with_type":"Xã Nậm Xe, Huyện Phong Thổ, Tỉnh Lai Châu","code":"03586","parent_code":"109"},"03589":{"name":"Xã Mường So","type":"xa","slug":"xa-muong-so","name_with_type":"Xã Mường So","path":"Xã Mường So, Huyện Phong Thổ, Tỉnh Lai Châu","path_with_type":"Xã Mường So, Huyện Phong Thổ, Tỉnh Lai Châu","code":"03589","parent_code":"109"},"03592":{"name":"Xã Sin Suối Hồ","type":"xa","slug":"xa-sin-suoi-ho","name_with_type":"Xã Sin Suối Hồ","path":"Xã Sin Suối Hồ, Huyện Phong Thổ, Tỉnh Lai Châu","path_with_type":"Xã Sin Suối Hồ, Huyện Phong Thổ, Tỉnh Lai Châu","code":"03592","parent_code":"109"},"03595":{"name":"Thị trấn Than Uyên","type":"thi-tran","slug":"thi-tran-than-uyen","name_with_type":"Thị trấn Than Uyên","path":"Thị trấn Than Uyên, Huyện Than Uyên, Tỉnh Lai Châu","path_with_type":"Thị trấn Than Uyên, Huyện Than Uyên, Tỉnh Lai Châu","code":"03595","parent_code":"110"},"03618":{"name":"Xã Phúc Than","type":"xa","slug":"xa-phuc-than","name_with_type":"Xã Phúc Than","path":"Xã Phúc Than, Huyện Than Uyên, Tỉnh Lai Châu","path_with_type":"Xã Phúc Than, Huyện Than Uyên, Tỉnh Lai Châu","code":"03618","parent_code":"110"},"03619":{"name":"Xã Mường Than","type":"xa","slug":"xa-muong-than","name_with_type":"Xã Mường Than","path":"Xã Mường Than, Huyện Than Uyên, Tỉnh Lai Châu","path_with_type":"Xã Mường Than, Huyện Than Uyên, Tỉnh Lai Châu","code":"03619","parent_code":"110"},"03625":{"name":"Xã Mường Mít","type":"xa","slug":"xa-muong-mit","name_with_type":"Xã Mường Mít","path":"Xã Mường Mít, Huyện Than Uyên, Tỉnh Lai Châu","path_with_type":"Xã Mường Mít, Huyện Than Uyên, Tỉnh Lai Châu","code":"03625","parent_code":"110"},"03628":{"name":"Xã Pha Mu","type":"xa","slug":"xa-pha-mu","name_with_type":"Xã Pha Mu","path":"Xã Pha Mu, Huyện Than Uyên, Tỉnh Lai Châu","path_with_type":"Xã Pha Mu, Huyện Than Uyên, Tỉnh Lai Châu","code":"03628","parent_code":"110"},"03631":{"name":"Xã Mường Cang","type":"xa","slug":"xa-muong-cang","name_with_type":"Xã Mường Cang","path":"Xã Mường Cang, Huyện Than Uyên, Tỉnh Lai Châu","path_with_type":"Xã Mường Cang, Huyện Than Uyên, Tỉnh Lai Châu","code":"03631","parent_code":"110"},"03632":{"name":"Xã Hua Nà","type":"xa","slug":"xa-hua-na","name_with_type":"Xã Hua Nà","path":"Xã Hua Nà, Huyện Than Uyên, Tỉnh Lai Châu","path_with_type":"Xã Hua Nà, Huyện Than Uyên, Tỉnh Lai Châu","code":"03632","parent_code":"110"},"03634":{"name":"Xã Tà Hừa","type":"xa","slug":"xa-ta-hua","name_with_type":"Xã Tà Hừa","path":"Xã Tà Hừa, Huyện Than Uyên, Tỉnh Lai Châu","path_with_type":"Xã Tà Hừa, Huyện Than Uyên, Tỉnh Lai Châu","code":"03634","parent_code":"110"},"03637":{"name":"Xã Mường Kim","type":"xa","slug":"xa-muong-kim","name_with_type":"Xã Mường Kim","path":"Xã Mường Kim, Huyện Than Uyên, Tỉnh Lai Châu","path_with_type":"Xã Mường Kim, Huyện Than Uyên, Tỉnh Lai Châu","code":"03637","parent_code":"110"},"03638":{"name":"Xã Tà Mung","type":"xa","slug":"xa-ta-mung","name_with_type":"Xã Tà Mung","path":"Xã Tà Mung, Huyện Than Uyên, Tỉnh Lai Châu","path_with_type":"Xã Tà Mung, Huyện Than Uyên, Tỉnh Lai Châu","code":"03638","parent_code":"110"},"03640":{"name":"Xã Tà Gia","type":"xa","slug":"xa-ta-gia","name_with_type":"Xã Tà Gia","path":"Xã Tà Gia, Huyện Than Uyên, Tỉnh Lai Châu","path_with_type":"Xã Tà Gia, Huyện Than Uyên, Tỉnh Lai Châu","code":"03640","parent_code":"110"},"03643":{"name":"Xã Khoen On","type":"xa","slug":"xa-khoen-on","name_with_type":"Xã Khoen On","path":"Xã Khoen On, Huyện Than Uyên, Tỉnh Lai Châu","path_with_type":"Xã Khoen On, Huyện Than Uyên, Tỉnh Lai Châu","code":"03643","parent_code":"110"},"03598":{"name":"Thị trấn Tân Uyên","type":"thi-tran","slug":"thi-tran-tan-uyen","name_with_type":"Thị trấn Tân Uyên","path":"Thị trấn Tân Uyên, Huyện Tân Uyên, Tỉnh Lai Châu","path_with_type":"Thị trấn Tân Uyên, Huyện Tân Uyên, Tỉnh Lai Châu","code":"03598","parent_code":"111"},"03601":{"name":"Xã Mường Khoa","type":"xa","slug":"xa-muong-khoa","name_with_type":"Xã Mường Khoa","path":"Xã Mường Khoa, Huyện Tân Uyên, Tỉnh Lai Châu","path_with_type":"Xã Mường Khoa, Huyện Tân Uyên, Tỉnh Lai Châu","code":"03601","parent_code":"111"},"03602":{"name":"Xã Phúc Khoa","type":"xa","slug":"xa-phuc-khoa","name_with_type":"Xã Phúc Khoa","path":"Xã Phúc Khoa, Huyện Tân Uyên, Tỉnh Lai Châu","path_with_type":"Xã Phúc Khoa, Huyện Tân Uyên, Tỉnh Lai Châu","code":"03602","parent_code":"111"},"03604":{"name":"Xã Thân Thuộc","type":"xa","slug":"xa-than-thuoc","name_with_type":"Xã Thân Thuộc","path":"Xã Thân Thuộc, Huyện Tân Uyên, Tỉnh Lai Châu","path_with_type":"Xã Thân Thuộc, Huyện Tân Uyên, Tỉnh Lai Châu","code":"03604","parent_code":"111"},"03605":{"name":"Xã Trung Đồng","type":"xa","slug":"xa-trung-dong","name_with_type":"Xã Trung Đồng","path":"Xã Trung Đồng, Huyện Tân Uyên, Tỉnh Lai Châu","path_with_type":"Xã Trung Đồng, Huyện Tân Uyên, Tỉnh Lai Châu","code":"03605","parent_code":"111"},"03607":{"name":"Xã Hố Mít","type":"xa","slug":"xa-ho-mit","name_with_type":"Xã Hố Mít","path":"Xã Hố Mít, Huyện Tân Uyên, Tỉnh Lai Châu","path_with_type":"Xã Hố Mít, Huyện Tân Uyên, Tỉnh Lai Châu","code":"03607","parent_code":"111"},"03610":{"name":"Xã Nậm Cần","type":"xa","slug":"xa-nam-can","name_with_type":"Xã Nậm Cần","path":"Xã Nậm Cần, Huyện Tân Uyên, Tỉnh Lai Châu","path_with_type":"Xã Nậm Cần, Huyện Tân Uyên, Tỉnh Lai Châu","code":"03610","parent_code":"111"},"03613":{"name":"Xã Nậm Sỏ","type":"xa","slug":"xa-nam-so","name_with_type":"Xã Nậm Sỏ","path":"Xã Nậm Sỏ, Huyện Tân Uyên, Tỉnh Lai Châu","path_with_type":"Xã Nậm Sỏ, Huyện Tân Uyên, Tỉnh Lai Châu","code":"03613","parent_code":"111"},"03616":{"name":"Xã Pắc Ta","type":"xa","slug":"xa-pac-ta","name_with_type":"Xã Pắc Ta","path":"Xã Pắc Ta, Huyện Tân Uyên, Tỉnh Lai Châu","path_with_type":"Xã Pắc Ta, Huyện Tân Uyên, Tỉnh Lai Châu","code":"03616","parent_code":"111"},"03622":{"name":"Xã Tà Mít","type":"xa","slug":"xa-ta-mit","name_with_type":"Xã Tà Mít","path":"Xã Tà Mít, Huyện Tân Uyên, Tỉnh Lai Châu","path_with_type":"Xã Tà Mít, Huyện Tân Uyên, Tỉnh Lai Châu","code":"03622","parent_code":"111"},"03434":{"name":"Thị trấn Nậm Nhùn","type":"thi-tran","slug":"thi-tran-nam-nhun","name_with_type":"Thị trấn Nậm Nhùn","path":"Thị trấn Nậm Nhùn, Huyện Nậm Nhùn, Tỉnh Lai Châu","path_with_type":"Thị trấn Nậm Nhùn, Huyện Nậm Nhùn, Tỉnh Lai Châu","code":"03434","parent_code":"112"},"03460":{"name":"Xã Hua Bun","type":"xa","slug":"xa-hua-bun","name_with_type":"Xã Hua Bun","path":"Xã Hua Bun, Huyện Nậm Nhùn, Tỉnh Lai Châu","path_with_type":"Xã Hua Bun, Huyện Nậm Nhùn, Tỉnh Lai Châu","code":"03460","parent_code":"112"},"03472":{"name":"Xã Mường Mô","type":"xa","slug":"xa-muong-mo","name_with_type":"Xã Mường Mô","path":"Xã Mường Mô, Huyện Nậm Nhùn, Tỉnh Lai Châu","path_with_type":"Xã Mường Mô, Huyện Nậm Nhùn, Tỉnh Lai Châu","code":"03472","parent_code":"112"},"03473":{"name":"Xã Nậm Chà","type":"xa","slug":"xa-nam-cha","name_with_type":"Xã Nậm Chà","path":"Xã Nậm Chà, Huyện Nậm Nhùn, Tỉnh Lai Châu","path_with_type":"Xã Nậm Chà, Huyện Nậm Nhùn, Tỉnh Lai Châu","code":"03473","parent_code":"112"},"03474":{"name":"Xã Nậm Manh","type":"xa","slug":"xa-nam-manh","name_with_type":"Xã Nậm Manh","path":"Xã Nậm Manh, Huyện Nậm Nhùn, Tỉnh Lai Châu","path_with_type":"Xã Nậm Manh, Huyện Nậm Nhùn, Tỉnh Lai Châu","code":"03474","parent_code":"112"},"03475":{"name":"Xã Nậm Hàng","type":"xa","slug":"xa-nam-hang","name_with_type":"Xã Nậm Hàng","path":"Xã Nậm Hàng, Huyện Nậm Nhùn, Tỉnh Lai Châu","path_with_type":"Xã Nậm Hàng, Huyện Nậm Nhùn, Tỉnh Lai Châu","code":"03475","parent_code":"112"},"03481":{"name":"Xã Lê Lợi","type":"xa","slug":"xa-le-loi","name_with_type":"Xã Lê Lợi","path":"Xã Lê Lợi, Huyện Nậm Nhùn, Tỉnh Lai Châu","path_with_type":"Xã Lê Lợi, Huyện Nậm Nhùn, Tỉnh Lai Châu","code":"03481","parent_code":"112"},"03484":{"name":"Xã Pú Đao","type":"xa","slug":"xa-pu-dao","name_with_type":"Xã Pú Đao","path":"Xã Pú Đao, Huyện Nậm Nhùn, Tỉnh Lai Châu","path_with_type":"Xã Pú Đao, Huyện Nậm Nhùn, Tỉnh Lai Châu","code":"03484","parent_code":"112"},"03488":{"name":"Xã Nậm Pì","type":"xa","slug":"xa-nam-pi","name_with_type":"Xã Nậm Pì","path":"Xã Nậm Pì, Huyện Nậm Nhùn, Tỉnh Lai Châu","path_with_type":"Xã Nậm Pì, Huyện Nậm Nhùn, Tỉnh Lai Châu","code":"03488","parent_code":"112"},"03502":{"name":"Xã Nậm Ban","type":"xa","slug":"xa-nam-ban","name_with_type":"Xã Nậm Ban","path":"Xã Nậm Ban, Huyện Nậm Nhùn, Tỉnh Lai Châu","path_with_type":"Xã Nậm Ban, Huyện Nậm Nhùn, Tỉnh Lai Châu","code":"03502","parent_code":"112"},"03503":{"name":"Xã Trung Chải","type":"xa","slug":"xa-trung-chai","name_with_type":"Xã Trung Chải","path":"Xã Trung Chải, Huyện Nậm Nhùn, Tỉnh Lai Châu","path_with_type":"Xã Trung Chải, Huyện Nậm Nhùn, Tỉnh Lai Châu","code":"03503","parent_code":"112"},"03646":{"name":"Phường Chiềng Lề","type":"phuong","slug":"phuong-chieng-le","name_with_type":"Phường Chiềng Lề","path":"Phường Chiềng Lề, Thành phố Sơn La, Tỉnh Sơn La","path_with_type":"Phường Chiềng Lề, Thành phố Sơn La, Tỉnh Sơn La","code":"03646","parent_code":"116"},"03649":{"name":"Phường Tô Hiệu","type":"phuong","slug":"phuong-to-hieu","name_with_type":"Phường Tô Hiệu","path":"Phường Tô Hiệu, Thành phố Sơn La, Tỉnh Sơn La","path_with_type":"Phường Tô Hiệu, Thành phố Sơn La, Tỉnh Sơn La","code":"03649","parent_code":"116"},"03652":{"name":"Phường Quyết Thắng","type":"phuong","slug":"phuong-quyet-thang","name_with_type":"Phường Quyết Thắng","path":"Phường Quyết Thắng, Thành phố Sơn La, Tỉnh Sơn La","path_with_type":"Phường Quyết Thắng, Thành phố Sơn La, Tỉnh Sơn La","code":"03652","parent_code":"116"},"03655":{"name":"Phường Quyết Tâm","type":"phuong","slug":"phuong-quyet-tam","name_with_type":"Phường Quyết Tâm","path":"Phường Quyết Tâm, Thành phố Sơn La, Tỉnh Sơn La","path_with_type":"Phường Quyết Tâm, Thành phố Sơn La, Tỉnh Sơn La","code":"03655","parent_code":"116"},"03658":{"name":"Xã Chiềng Cọ","type":"xa","slug":"xa-chieng-co","name_with_type":"Xã Chiềng Cọ","path":"Xã Chiềng Cọ, Thành phố Sơn La, Tỉnh Sơn La","path_with_type":"Xã Chiềng Cọ, Thành phố Sơn La, Tỉnh Sơn La","code":"03658","parent_code":"116"},"03661":{"name":"Xã Chiềng Đen","type":"xa","slug":"xa-chieng-den","name_with_type":"Xã Chiềng Đen","path":"Xã Chiềng Đen, Thành phố Sơn La, Tỉnh Sơn La","path_with_type":"Xã Chiềng Đen, Thành phố Sơn La, Tỉnh Sơn La","code":"03661","parent_code":"116"},"03664":{"name":"Xã Chiềng Xôm","type":"xa","slug":"xa-chieng-xom","name_with_type":"Xã Chiềng Xôm","path":"Xã Chiềng Xôm, Thành phố Sơn La, Tỉnh Sơn La","path_with_type":"Xã Chiềng Xôm, Thành phố Sơn La, Tỉnh Sơn La","code":"03664","parent_code":"116"},"03667":{"name":"Phường Chiềng An","type":"phuong","slug":"phuong-chieng-an","name_with_type":"Phường Chiềng An","path":"Phường Chiềng An, Thành phố Sơn La, Tỉnh Sơn La","path_with_type":"Phường Chiềng An, Thành phố Sơn La, Tỉnh Sơn La","code":"03667","parent_code":"116"},"03670":{"name":"Phường Chiềng Cơi","type":"phuong","slug":"phuong-chieng-coi","name_with_type":"Phường Chiềng Cơi","path":"Phường Chiềng Cơi, Thành phố Sơn La, Tỉnh Sơn La","path_with_type":"Phường Chiềng Cơi, Thành phố Sơn La, Tỉnh Sơn La","code":"03670","parent_code":"116"},"03673":{"name":"Xã Chiềng Ngần","type":"xa","slug":"xa-chieng-ngan","name_with_type":"Xã Chiềng Ngần","path":"Xã Chiềng Ngần, Thành phố Sơn La, Tỉnh Sơn La","path_with_type":"Xã Chiềng Ngần, Thành phố Sơn La, Tỉnh Sơn La","code":"03673","parent_code":"116"},"03676":{"name":"Xã Hua La","type":"xa","slug":"xa-hua-la","name_with_type":"Xã Hua La","path":"Xã Hua La, Thành phố Sơn La, Tỉnh Sơn La","path_with_type":"Xã Hua La, Thành phố Sơn La, Tỉnh Sơn La","code":"03676","parent_code":"116"},"03679":{"name":"Phường Chiềng Sinh","type":"phuong","slug":"phuong-chieng-sinh","name_with_type":"Phường Chiềng Sinh","path":"Phường Chiềng Sinh, Thành phố Sơn La, Tỉnh Sơn La","path_with_type":"Phường Chiềng Sinh, Thành phố Sơn La, Tỉnh Sơn La","code":"03679","parent_code":"116"},"03682":{"name":"Xã Mường Chiên","type":"xa","slug":"xa-muong-chien","name_with_type":"Xã Mường Chiên","path":"Xã Mường Chiên, Huyện Quỳnh Nhai, Tỉnh Sơn La","path_with_type":"Xã Mường Chiên, Huyện Quỳnh Nhai, Tỉnh Sơn La","code":"03682","parent_code":"118"},"03685":{"name":"Xã Cà Nàng","type":"xa","slug":"xa-ca-nang","name_with_type":"Xã Cà Nàng","path":"Xã Cà Nàng, Huyện Quỳnh Nhai, Tỉnh Sơn La","path_with_type":"Xã Cà Nàng, Huyện Quỳnh Nhai, Tỉnh Sơn La","code":"03685","parent_code":"118"},"03688":{"name":"Xã Chiềng Khay","type":"xa","slug":"xa-chieng-khay","name_with_type":"Xã Chiềng Khay","path":"Xã Chiềng Khay, Huyện Quỳnh Nhai, Tỉnh Sơn La","path_with_type":"Xã Chiềng Khay, Huyện Quỳnh Nhai, Tỉnh Sơn La","code":"03688","parent_code":"118"},"03694":{"name":"Xã Mường Giôn","type":"xa","slug":"xa-muong-gion","name_with_type":"Xã Mường Giôn","path":"Xã Mường Giôn, Huyện Quỳnh Nhai, Tỉnh Sơn La","path_with_type":"Xã Mường Giôn, Huyện Quỳnh Nhai, Tỉnh Sơn La","code":"03694","parent_code":"118"},"03697":{"name":"Xã Pá Ma Pha Khinh","type":"xa","slug":"xa-pa-ma-pha-khinh","name_with_type":"Xã Pá Ma Pha Khinh","path":"Xã Pá Ma Pha Khinh, Huyện Quỳnh Nhai, Tỉnh Sơn La","path_with_type":"Xã Pá Ma Pha Khinh, Huyện Quỳnh Nhai, Tỉnh Sơn La","code":"03697","parent_code":"118"},"03700":{"name":"Xã Chiềng Ơn","type":"xa","slug":"xa-chieng-on","name_with_type":"Xã Chiềng Ơn","path":"Xã Chiềng Ơn, Huyện Quỳnh Nhai, Tỉnh Sơn La","path_with_type":"Xã Chiềng Ơn, Huyện Quỳnh Nhai, Tỉnh Sơn La","code":"03700","parent_code":"118"},"03703":{"name":"Xã Mường Giàng","type":"xa","slug":"xa-muong-giang","name_with_type":"Xã Mường Giàng","path":"Xã Mường Giàng, Huyện Quỳnh Nhai, Tỉnh Sơn La","path_with_type":"Xã Mường Giàng, Huyện Quỳnh Nhai, Tỉnh Sơn La","code":"03703","parent_code":"118"},"03706":{"name":"Xã Chiềng Bằng","type":"xa","slug":"xa-chieng-bang","name_with_type":"Xã Chiềng Bằng","path":"Xã Chiềng Bằng, Huyện Quỳnh Nhai, Tỉnh Sơn La","path_with_type":"Xã Chiềng Bằng, Huyện Quỳnh Nhai, Tỉnh Sơn La","code":"03706","parent_code":"118"},"03709":{"name":"Xã Mường Sại","type":"xa","slug":"xa-muong-sai","name_with_type":"Xã Mường Sại","path":"Xã Mường Sại, Huyện Quỳnh Nhai, Tỉnh Sơn La","path_with_type":"Xã Mường Sại, Huyện Quỳnh Nhai, Tỉnh Sơn La","code":"03709","parent_code":"118"},"03712":{"name":"Xã Nậm ét","type":"xa","slug":"xa-nam-et","name_with_type":"Xã Nậm ét","path":"Xã Nậm ét, Huyện Quỳnh Nhai, Tỉnh Sơn La","path_with_type":"Xã Nậm ét, Huyện Quỳnh Nhai, Tỉnh Sơn La","code":"03712","parent_code":"118"},"03718":{"name":"Xã Chiềng Khoang","type":"xa","slug":"xa-chieng-khoang","name_with_type":"Xã Chiềng Khoang","path":"Xã Chiềng Khoang, Huyện Quỳnh Nhai, Tỉnh Sơn La","path_with_type":"Xã Chiềng Khoang, Huyện Quỳnh Nhai, Tỉnh Sơn La","code":"03718","parent_code":"118"},"03721":{"name":"Thị trấn Thuận Châu","type":"thi-tran","slug":"thi-tran-thuan-chau","name_with_type":"Thị trấn Thuận Châu","path":"Thị trấn Thuận Châu, Huyện Thuận Châu, Tỉnh Sơn La","path_with_type":"Thị trấn Thuận Châu, Huyện Thuận Châu, Tỉnh Sơn La","code":"03721","parent_code":"119"},"03724":{"name":"Xã Phổng Lái","type":"xa","slug":"xa-phong-lai","name_with_type":"Xã Phổng Lái","path":"Xã Phổng Lái, Huyện Thuận Châu, Tỉnh Sơn La","path_with_type":"Xã Phổng Lái, Huyện Thuận Châu, Tỉnh Sơn La","code":"03724","parent_code":"119"},"03727":{"name":"Xã Mường é","type":"xa","slug":"xa-muong-e","name_with_type":"Xã Mường é","path":"Xã Mường é, Huyện Thuận Châu, Tỉnh Sơn La","path_with_type":"Xã Mường é, Huyện Thuận Châu, Tỉnh Sơn La","code":"03727","parent_code":"119"},"03730":{"name":"Xã Chiềng Pha","type":"xa","slug":"xa-chieng-pha","name_with_type":"Xã Chiềng Pha","path":"Xã Chiềng Pha, Huyện Thuận Châu, Tỉnh Sơn La","path_with_type":"Xã Chiềng Pha, Huyện Thuận Châu, Tỉnh Sơn La","code":"03730","parent_code":"119"},"03733":{"name":"Xã Chiềng La","type":"xa","slug":"xa-chieng-la","name_with_type":"Xã Chiềng La","path":"Xã Chiềng La, Huyện Thuận Châu, Tỉnh Sơn La","path_with_type":"Xã Chiềng La, Huyện Thuận Châu, Tỉnh Sơn La","code":"03733","parent_code":"119"},"03736":{"name":"Xã Chiềng Ngàm","type":"xa","slug":"xa-chieng-ngam","name_with_type":"Xã Chiềng Ngàm","path":"Xã Chiềng Ngàm, Huyện Thuận Châu, Tỉnh Sơn La","path_with_type":"Xã Chiềng Ngàm, Huyện Thuận Châu, Tỉnh Sơn La","code":"03736","parent_code":"119"},"03739":{"name":"Xã Liệp Tè","type":"xa","slug":"xa-liep-te","name_with_type":"Xã Liệp Tè","path":"Xã Liệp Tè, Huyện Thuận Châu, Tỉnh Sơn La","path_with_type":"Xã Liệp Tè, Huyện Thuận Châu, Tỉnh Sơn La","code":"03739","parent_code":"119"},"03742":{"name":"Xã é Tòng","type":"xa","slug":"xa-e-tong","name_with_type":"Xã é Tòng","path":"Xã é Tòng, Huyện Thuận Châu, Tỉnh Sơn La","path_with_type":"Xã é Tòng, Huyện Thuận Châu, Tỉnh Sơn La","code":"03742","parent_code":"119"},"03745":{"name":"Xã Phổng Lập","type":"xa","slug":"xa-phong-lap","name_with_type":"Xã Phổng Lập","path":"Xã Phổng Lập, Huyện Thuận Châu, Tỉnh Sơn La","path_with_type":"Xã Phổng Lập, Huyện Thuận Châu, Tỉnh Sơn La","code":"03745","parent_code":"119"},"03748":{"name":"Xã Phổng Lăng","type":"xa","slug":"xa-phong-lang","name_with_type":"Xã Phổng Lăng","path":"Xã Phổng Lăng, Huyện Thuận Châu, Tỉnh Sơn La","path_with_type":"Xã Phổng Lăng, Huyện Thuận Châu, Tỉnh Sơn La","code":"03748","parent_code":"119"},"03751":{"name":"Xã Chiềng Ly","type":"xa","slug":"xa-chieng-ly","name_with_type":"Xã Chiềng Ly","path":"Xã Chiềng Ly, Huyện Thuận Châu, Tỉnh Sơn La","path_with_type":"Xã Chiềng Ly, Huyện Thuận Châu, Tỉnh Sơn La","code":"03751","parent_code":"119"},"03754":{"name":"Xã Noong Lay","type":"xa","slug":"xa-noong-lay","name_with_type":"Xã Noong Lay","path":"Xã Noong Lay, Huyện Thuận Châu, Tỉnh Sơn La","path_with_type":"Xã Noong Lay, Huyện Thuận Châu, Tỉnh Sơn La","code":"03754","parent_code":"119"},"03757":{"name":"Xã Mường Khiêng","type":"xa","slug":"xa-muong-khieng","name_with_type":"Xã Mường Khiêng","path":"Xã Mường Khiêng, Huyện Thuận Châu, Tỉnh Sơn La","path_with_type":"Xã Mường Khiêng, Huyện Thuận Châu, Tỉnh Sơn La","code":"03757","parent_code":"119"},"03760":{"name":"Xã Mường Bám","type":"xa","slug":"xa-muong-bam","name_with_type":"Xã Mường Bám","path":"Xã Mường Bám, Huyện Thuận Châu, Tỉnh Sơn La","path_with_type":"Xã Mường Bám, Huyện Thuận Châu, Tỉnh Sơn La","code":"03760","parent_code":"119"},"03763":{"name":"Xã Long Hẹ","type":"xa","slug":"xa-long-he","name_with_type":"Xã Long Hẹ","path":"Xã Long Hẹ, Huyện Thuận Châu, Tỉnh Sơn La","path_with_type":"Xã Long Hẹ, Huyện Thuận Châu, Tỉnh Sơn La","code":"03763","parent_code":"119"},"03766":{"name":"Xã Chiềng Bôm","type":"xa","slug":"xa-chieng-bom","name_with_type":"Xã Chiềng Bôm","path":"Xã Chiềng Bôm, Huyện Thuận Châu, Tỉnh Sơn La","path_with_type":"Xã Chiềng Bôm, Huyện Thuận Châu, Tỉnh Sơn La","code":"03766","parent_code":"119"},"03769":{"name":"Xã Thôm Mòn","type":"xa","slug":"xa-thom-mon","name_with_type":"Xã Thôm Mòn","path":"Xã Thôm Mòn, Huyện Thuận Châu, Tỉnh Sơn La","path_with_type":"Xã Thôm Mòn, Huyện Thuận Châu, Tỉnh Sơn La","code":"03769","parent_code":"119"},"03772":{"name":"Xã Tông Lạnh","type":"xa","slug":"xa-tong-lanh","name_with_type":"Xã Tông Lạnh","path":"Xã Tông Lạnh, Huyện Thuận Châu, Tỉnh Sơn La","path_with_type":"Xã Tông Lạnh, Huyện Thuận Châu, Tỉnh Sơn La","code":"03772","parent_code":"119"},"03775":{"name":"Xã Tông Cọ","type":"xa","slug":"xa-tong-co","name_with_type":"Xã Tông Cọ","path":"Xã Tông Cọ, Huyện Thuận Châu, Tỉnh Sơn La","path_with_type":"Xã Tông Cọ, Huyện Thuận Châu, Tỉnh Sơn La","code":"03775","parent_code":"119"},"03778":{"name":"Xã Bó Mười","type":"xa","slug":"xa-bo-muoi","name_with_type":"Xã Bó Mười","path":"Xã Bó Mười, Huyện Thuận Châu, Tỉnh Sơn La","path_with_type":"Xã Bó Mười, Huyện Thuận Châu, Tỉnh Sơn La","code":"03778","parent_code":"119"},"03781":{"name":"Xã Co Mạ","type":"xa","slug":"xa-co-ma","name_with_type":"Xã Co Mạ","path":"Xã Co Mạ, Huyện Thuận Châu, Tỉnh Sơn La","path_with_type":"Xã Co Mạ, Huyện Thuận Châu, Tỉnh Sơn La","code":"03781","parent_code":"119"},"03784":{"name":"Xã Púng Tra","type":"xa","slug":"xa-pung-tra","name_with_type":"Xã Púng Tra","path":"Xã Púng Tra, Huyện Thuận Châu, Tỉnh Sơn La","path_with_type":"Xã Púng Tra, Huyện Thuận Châu, Tỉnh Sơn La","code":"03784","parent_code":"119"},"03787":{"name":"Xã Chiềng Pấc","type":"xa","slug":"xa-chieng-pac","name_with_type":"Xã Chiềng Pấc","path":"Xã Chiềng Pấc, Huyện Thuận Châu, Tỉnh Sơn La","path_with_type":"Xã Chiềng Pấc, Huyện Thuận Châu, Tỉnh Sơn La","code":"03787","parent_code":"119"},"03790":{"name":"Xã Nậm Lầu","type":"xa","slug":"xa-nam-lau","name_with_type":"Xã Nậm Lầu","path":"Xã Nậm Lầu, Huyện Thuận Châu, Tỉnh Sơn La","path_with_type":"Xã Nậm Lầu, Huyện Thuận Châu, Tỉnh Sơn La","code":"03790","parent_code":"119"},"03793":{"name":"Xã Bon Phặng","type":"xa","slug":"xa-bon-phang","name_with_type":"Xã Bon Phặng","path":"Xã Bon Phặng, Huyện Thuận Châu, Tỉnh Sơn La","path_with_type":"Xã Bon Phặng, Huyện Thuận Châu, Tỉnh Sơn La","code":"03793","parent_code":"119"},"03796":{"name":"Xã Co Tòng","type":"xa","slug":"xa-co-tong","name_with_type":"Xã Co Tòng","path":"Xã Co Tòng, Huyện Thuận Châu, Tỉnh Sơn La","path_with_type":"Xã Co Tòng, Huyện Thuận Châu, Tỉnh Sơn La","code":"03796","parent_code":"119"},"03799":{"name":"Xã Muổi Nọi","type":"xa","slug":"xa-muoi-noi","name_with_type":"Xã Muổi Nọi","path":"Xã Muổi Nọi, Huyện Thuận Châu, Tỉnh Sơn La","path_with_type":"Xã Muổi Nọi, Huyện Thuận Châu, Tỉnh Sơn La","code":"03799","parent_code":"119"},"03802":{"name":"Xã Pá Lông","type":"xa","slug":"xa-pa-long","name_with_type":"Xã Pá Lông","path":"Xã Pá Lông, Huyện Thuận Châu, Tỉnh Sơn La","path_with_type":"Xã Pá Lông, Huyện Thuận Châu, Tỉnh Sơn La","code":"03802","parent_code":"119"},"03805":{"name":"Xã Bản Lầm","type":"xa","slug":"xa-ban-lam","name_with_type":"Xã Bản Lầm","path":"Xã Bản Lầm, Huyện Thuận Châu, Tỉnh Sơn La","path_with_type":"Xã Bản Lầm, Huyện Thuận Châu, Tỉnh Sơn La","code":"03805","parent_code":"119"},"03808":{"name":"Thị trấn Ít Ong","type":"thi-tran","slug":"thi-tran-it-ong","name_with_type":"Thị trấn Ít Ong","path":"Thị trấn Ít Ong, Huyện Mường La, Tỉnh Sơn La","path_with_type":"Thị trấn Ít Ong, Huyện Mường La, Tỉnh Sơn La","code":"03808","parent_code":"120"},"03811":{"name":"Xã Nậm Giôn","type":"xa","slug":"xa-nam-gion","name_with_type":"Xã Nậm Giôn","path":"Xã Nậm Giôn, Huyện Mường La, Tỉnh Sơn La","path_with_type":"Xã Nậm Giôn, Huyện Mường La, Tỉnh Sơn La","code":"03811","parent_code":"120"},"03814":{"name":"Xã Chiềng Lao","type":"xa","slug":"xa-chieng-lao","name_with_type":"Xã Chiềng Lao","path":"Xã Chiềng Lao, Huyện Mường La, Tỉnh Sơn La","path_with_type":"Xã Chiềng Lao, Huyện Mường La, Tỉnh Sơn La","code":"03814","parent_code":"120"},"03817":{"name":"Xã Hua Trai","type":"xa","slug":"xa-hua-trai","name_with_type":"Xã Hua Trai","path":"Xã Hua Trai, Huyện Mường La, Tỉnh Sơn La","path_with_type":"Xã Hua Trai, Huyện Mường La, Tỉnh Sơn La","code":"03817","parent_code":"120"},"03820":{"name":"Xã Ngọc Chiến","type":"xa","slug":"xa-ngoc-chien","name_with_type":"Xã Ngọc Chiến","path":"Xã Ngọc Chiến, Huyện Mường La, Tỉnh Sơn La","path_with_type":"Xã Ngọc Chiến, Huyện Mường La, Tỉnh Sơn La","code":"03820","parent_code":"120"},"03823":{"name":"Xã Mường Trai","type":"xa","slug":"xa-muong-trai","name_with_type":"Xã Mường Trai","path":"Xã Mường Trai, Huyện Mường La, Tỉnh Sơn La","path_with_type":"Xã Mường Trai, Huyện Mường La, Tỉnh Sơn La","code":"03823","parent_code":"120"},"03826":{"name":"Xã Nậm Păm","type":"xa","slug":"xa-nam-pam","name_with_type":"Xã Nậm Păm","path":"Xã Nậm Păm, Huyện Mường La, Tỉnh Sơn La","path_with_type":"Xã Nậm Păm, Huyện Mường La, Tỉnh Sơn La","code":"03826","parent_code":"120"},"03829":{"name":"Xã Chiềng Muôn","type":"xa","slug":"xa-chieng-muon","name_with_type":"Xã Chiềng Muôn","path":"Xã Chiềng Muôn, Huyện Mường La, Tỉnh Sơn La","path_with_type":"Xã Chiềng Muôn, Huyện Mường La, Tỉnh Sơn La","code":"03829","parent_code":"120"},"03832":{"name":"Xã Chiềng Ân","type":"xa","slug":"xa-chieng-an","name_with_type":"Xã Chiềng Ân","path":"Xã Chiềng Ân, Huyện Mường La, Tỉnh Sơn La","path_with_type":"Xã Chiềng Ân, Huyện Mường La, Tỉnh Sơn La","code":"03832","parent_code":"120"},"03835":{"name":"Xã Pi Toong","type":"xa","slug":"xa-pi-toong","name_with_type":"Xã Pi Toong","path":"Xã Pi Toong, Huyện Mường La, Tỉnh Sơn La","path_with_type":"Xã Pi Toong, Huyện Mường La, Tỉnh Sơn La","code":"03835","parent_code":"120"},"03838":{"name":"Xã Chiềng Công","type":"xa","slug":"xa-chieng-cong","name_with_type":"Xã Chiềng Công","path":"Xã Chiềng Công, Huyện Mường La, Tỉnh Sơn La","path_with_type":"Xã Chiềng Công, Huyện Mường La, Tỉnh Sơn La","code":"03838","parent_code":"120"},"03841":{"name":"Xã Tạ Bú","type":"xa","slug":"xa-ta-bu","name_with_type":"Xã Tạ Bú","path":"Xã Tạ Bú, Huyện Mường La, Tỉnh Sơn La","path_with_type":"Xã Tạ Bú, Huyện Mường La, Tỉnh Sơn La","code":"03841","parent_code":"120"},"03844":{"name":"Xã Chiềng San","type":"xa","slug":"xa-chieng-san","name_with_type":"Xã Chiềng San","path":"Xã Chiềng San, Huyện Mường La, Tỉnh Sơn La","path_with_type":"Xã Chiềng San, Huyện Mường La, Tỉnh Sơn La","code":"03844","parent_code":"120"},"03847":{"name":"Xã Mường Bú","type":"xa","slug":"xa-muong-bu","name_with_type":"Xã Mường Bú","path":"Xã Mường Bú, Huyện Mường La, Tỉnh Sơn La","path_with_type":"Xã Mường Bú, Huyện Mường La, Tỉnh Sơn La","code":"03847","parent_code":"120"},"03850":{"name":"Xã Chiềng Hoa","type":"xa","slug":"xa-chieng-hoa","name_with_type":"Xã Chiềng Hoa","path":"Xã Chiềng Hoa, Huyện Mường La, Tỉnh Sơn La","path_with_type":"Xã Chiềng Hoa, Huyện Mường La, Tỉnh Sơn La","code":"03850","parent_code":"120"},"03853":{"name":"Xã Mường Chùm","type":"xa","slug":"xa-muong-chum","name_with_type":"Xã Mường Chùm","path":"Xã Mường Chùm, Huyện Mường La, Tỉnh Sơn La","path_with_type":"Xã Mường Chùm, Huyện Mường La, Tỉnh Sơn La","code":"03853","parent_code":"120"},"03856":{"name":"Thị trấn Bắc Yên","type":"thi-tran","slug":"thi-tran-bac-yen","name_with_type":"Thị trấn Bắc Yên","path":"Thị trấn Bắc Yên, Huyện Bắc Yên, Tỉnh Sơn La","path_with_type":"Thị trấn Bắc Yên, Huyện Bắc Yên, Tỉnh Sơn La","code":"03856","parent_code":"121"},"03859":{"name":"Xã Phiêng Ban","type":"xa","slug":"xa-phieng-ban","name_with_type":"Xã Phiêng Ban","path":"Xã Phiêng Ban, Huyện Bắc Yên, Tỉnh Sơn La","path_with_type":"Xã Phiêng Ban, Huyện Bắc Yên, Tỉnh Sơn La","code":"03859","parent_code":"121"},"03862":{"name":"Xã Hang Chú","type":"xa","slug":"xa-hang-chu","name_with_type":"Xã Hang Chú","path":"Xã Hang Chú, Huyện Bắc Yên, Tỉnh Sơn La","path_with_type":"Xã Hang Chú, Huyện Bắc Yên, Tỉnh Sơn La","code":"03862","parent_code":"121"},"03865":{"name":"Xã Xím Vàng","type":"xa","slug":"xa-xim-vang","name_with_type":"Xã Xím Vàng","path":"Xã Xím Vàng, Huyện Bắc Yên, Tỉnh Sơn La","path_with_type":"Xã Xím Vàng, Huyện Bắc Yên, Tỉnh Sơn La","code":"03865","parent_code":"121"},"03868":{"name":"Xã Tà Xùa","type":"xa","slug":"xa-ta-xua","name_with_type":"Xã Tà Xùa","path":"Xã Tà Xùa, Huyện Bắc Yên, Tỉnh Sơn La","path_with_type":"Xã Tà Xùa, Huyện Bắc Yên, Tỉnh Sơn La","code":"03868","parent_code":"121"},"03869":{"name":"Xã Háng Đồng","type":"xa","slug":"xa-hang-dong","name_with_type":"Xã Háng Đồng","path":"Xã Háng Đồng, Huyện Bắc Yên, Tỉnh Sơn La","path_with_type":"Xã Háng Đồng, Huyện Bắc Yên, Tỉnh Sơn La","code":"03869","parent_code":"121"},"03871":{"name":"Xã Pắc Ngà","type":"xa","slug":"xa-pac-nga","name_with_type":"Xã Pắc Ngà","path":"Xã Pắc Ngà, Huyện Bắc Yên, Tỉnh Sơn La","path_with_type":"Xã Pắc Ngà, Huyện Bắc Yên, Tỉnh Sơn La","code":"03871","parent_code":"121"},"03874":{"name":"Xã Làng Chếu","type":"xa","slug":"xa-lang-cheu","name_with_type":"Xã Làng Chếu","path":"Xã Làng Chếu, Huyện Bắc Yên, Tỉnh Sơn La","path_with_type":"Xã Làng Chếu, Huyện Bắc Yên, Tỉnh Sơn La","code":"03874","parent_code":"121"},"03877":{"name":"Xã Chim Vàn","type":"xa","slug":"xa-chim-van","name_with_type":"Xã Chim Vàn","path":"Xã Chim Vàn, Huyện Bắc Yên, Tỉnh Sơn La","path_with_type":"Xã Chim Vàn, Huyện Bắc Yên, Tỉnh Sơn La","code":"03877","parent_code":"121"},"03880":{"name":"Xã Mường Khoa","type":"xa","slug":"xa-muong-khoa","name_with_type":"Xã Mường Khoa","path":"Xã Mường Khoa, Huyện Bắc Yên, Tỉnh Sơn La","path_with_type":"Xã Mường Khoa, Huyện Bắc Yên, Tỉnh Sơn La","code":"03880","parent_code":"121"},"03883":{"name":"Xã Song Pe","type":"xa","slug":"xa-song-pe","name_with_type":"Xã Song Pe","path":"Xã Song Pe, Huyện Bắc Yên, Tỉnh Sơn La","path_with_type":"Xã Song Pe, Huyện Bắc Yên, Tỉnh Sơn La","code":"03883","parent_code":"121"},"03886":{"name":"Xã Hồng Ngài","type":"xa","slug":"xa-hong-ngai","name_with_type":"Xã Hồng Ngài","path":"Xã Hồng Ngài, Huyện Bắc Yên, Tỉnh Sơn La","path_with_type":"Xã Hồng Ngài, Huyện Bắc Yên, Tỉnh Sơn La","code":"03886","parent_code":"121"},"03889":{"name":"Xã Tạ Khoa","type":"xa","slug":"xa-ta-khoa","name_with_type":"Xã Tạ Khoa","path":"Xã Tạ Khoa, Huyện Bắc Yên, Tỉnh Sơn La","path_with_type":"Xã Tạ Khoa, Huyện Bắc Yên, Tỉnh Sơn La","code":"03889","parent_code":"121"},"03890":{"name":"Xã Hua Nhàn","type":"xa","slug":"xa-hua-nhan","name_with_type":"Xã Hua Nhàn","path":"Xã Hua Nhàn, Huyện Bắc Yên, Tỉnh Sơn La","path_with_type":"Xã Hua Nhàn, Huyện Bắc Yên, Tỉnh Sơn La","code":"03890","parent_code":"121"},"03892":{"name":"Xã Phiêng Côn","type":"xa","slug":"xa-phieng-con","name_with_type":"Xã Phiêng Côn","path":"Xã Phiêng Côn, Huyện Bắc Yên, Tỉnh Sơn La","path_with_type":"Xã Phiêng Côn, Huyện Bắc Yên, Tỉnh Sơn La","code":"03892","parent_code":"121"},"03895":{"name":"Xã Chiềng Sại","type":"xa","slug":"xa-chieng-sai","name_with_type":"Xã Chiềng Sại","path":"Xã Chiềng Sại, Huyện Bắc Yên, Tỉnh Sơn La","path_with_type":"Xã Chiềng Sại, Huyện Bắc Yên, Tỉnh Sơn La","code":"03895","parent_code":"121"},"03898":{"name":"Thị trấn Phù Yên","type":"thi-tran","slug":"thi-tran-phu-yen","name_with_type":"Thị trấn Phù Yên","path":"Thị trấn Phù Yên, Huyện Phù Yên, Tỉnh Sơn La","path_with_type":"Thị trấn Phù Yên, Huyện Phù Yên, Tỉnh Sơn La","code":"03898","parent_code":"122"},"03901":{"name":"Xã Suối Tọ","type":"xa","slug":"xa-suoi-to","name_with_type":"Xã Suối Tọ","path":"Xã Suối Tọ, Huyện Phù Yên, Tỉnh Sơn La","path_with_type":"Xã Suối Tọ, Huyện Phù Yên, Tỉnh Sơn La","code":"03901","parent_code":"122"},"03904":{"name":"Xã Mường Thải","type":"xa","slug":"xa-muong-thai","name_with_type":"Xã Mường Thải","path":"Xã Mường Thải, Huyện Phù Yên, Tỉnh Sơn La","path_with_type":"Xã Mường Thải, Huyện Phù Yên, Tỉnh Sơn La","code":"03904","parent_code":"122"},"03907":{"name":"Xã Mường Cơi","type":"xa","slug":"xa-muong-coi","name_with_type":"Xã Mường Cơi","path":"Xã Mường Cơi, Huyện Phù Yên, Tỉnh Sơn La","path_with_type":"Xã Mường Cơi, Huyện Phù Yên, Tỉnh Sơn La","code":"03907","parent_code":"122"},"03910":{"name":"Xã Quang Huy","type":"xa","slug":"xa-quang-huy","name_with_type":"Xã Quang Huy","path":"Xã Quang Huy, Huyện Phù Yên, Tỉnh Sơn La","path_with_type":"Xã Quang Huy, Huyện Phù Yên, Tỉnh Sơn La","code":"03910","parent_code":"122"},"03913":{"name":"Xã Huy Bắc","type":"xa","slug":"xa-huy-bac","name_with_type":"Xã Huy Bắc","path":"Xã Huy Bắc, Huyện Phù Yên, Tỉnh Sơn La","path_with_type":"Xã Huy Bắc, Huyện Phù Yên, Tỉnh Sơn La","code":"03913","parent_code":"122"},"03916":{"name":"Xã Huy Thượng","type":"xa","slug":"xa-huy-thuong","name_with_type":"Xã Huy Thượng","path":"Xã Huy Thượng, Huyện Phù Yên, Tỉnh Sơn La","path_with_type":"Xã Huy Thượng, Huyện Phù Yên, Tỉnh Sơn La","code":"03916","parent_code":"122"},"03919":{"name":"Xã Tân Lang","type":"xa","slug":"xa-tan-lang","name_with_type":"Xã Tân Lang","path":"Xã Tân Lang, Huyện Phù Yên, Tỉnh Sơn La","path_with_type":"Xã Tân Lang, Huyện Phù Yên, Tỉnh Sơn La","code":"03919","parent_code":"122"},"03922":{"name":"Xã Gia Phù","type":"xa","slug":"xa-gia-phu","name_with_type":"Xã Gia Phù","path":"Xã Gia Phù, Huyện Phù Yên, Tỉnh Sơn La","path_with_type":"Xã Gia Phù, Huyện Phù Yên, Tỉnh Sơn La","code":"03922","parent_code":"122"},"03925":{"name":"Xã Tường Phù","type":"xa","slug":"xa-tuong-phu","name_with_type":"Xã Tường Phù","path":"Xã Tường Phù, Huyện Phù Yên, Tỉnh Sơn La","path_with_type":"Xã Tường Phù, Huyện Phù Yên, Tỉnh Sơn La","code":"03925","parent_code":"122"},"03928":{"name":"Xã Huy Hạ","type":"xa","slug":"xa-huy-ha","name_with_type":"Xã Huy Hạ","path":"Xã Huy Hạ, Huyện Phù Yên, Tỉnh Sơn La","path_with_type":"Xã Huy Hạ, Huyện Phù Yên, Tỉnh Sơn La","code":"03928","parent_code":"122"},"03931":{"name":"Xã Huy Tân","type":"xa","slug":"xa-huy-tan","name_with_type":"Xã Huy Tân","path":"Xã Huy Tân, Huyện Phù Yên, Tỉnh Sơn La","path_with_type":"Xã Huy Tân, Huyện Phù Yên, Tỉnh Sơn La","code":"03931","parent_code":"122"},"03934":{"name":"Xã Mường Lang","type":"xa","slug":"xa-muong-lang","name_with_type":"Xã Mường Lang","path":"Xã Mường Lang, Huyện Phù Yên, Tỉnh Sơn La","path_with_type":"Xã Mường Lang, Huyện Phù Yên, Tỉnh Sơn La","code":"03934","parent_code":"122"},"03937":{"name":"Xã Suối Bau","type":"xa","slug":"xa-suoi-bau","name_with_type":"Xã Suối Bau","path":"Xã Suối Bau, Huyện Phù Yên, Tỉnh Sơn La","path_with_type":"Xã Suối Bau, Huyện Phù Yên, Tỉnh Sơn La","code":"03937","parent_code":"122"},"03940":{"name":"Xã Huy Tường","type":"xa","slug":"xa-huy-tuong","name_with_type":"Xã Huy Tường","path":"Xã Huy Tường, Huyện Phù Yên, Tỉnh Sơn La","path_with_type":"Xã Huy Tường, Huyện Phù Yên, Tỉnh Sơn La","code":"03940","parent_code":"122"},"03943":{"name":"Xã Mường Do","type":"xa","slug":"xa-muong-do","name_with_type":"Xã Mường Do","path":"Xã Mường Do, Huyện Phù Yên, Tỉnh Sơn La","path_with_type":"Xã Mường Do, Huyện Phù Yên, Tỉnh Sơn La","code":"03943","parent_code":"122"},"03946":{"name":"Xã Sập Xa","type":"xa","slug":"xa-sap-xa","name_with_type":"Xã Sập Xa","path":"Xã Sập Xa, Huyện Phù Yên, Tỉnh Sơn La","path_with_type":"Xã Sập Xa, Huyện Phù Yên, Tỉnh Sơn La","code":"03946","parent_code":"122"},"03949":{"name":"Xã Tường Thượng","type":"xa","slug":"xa-tuong-thuong","name_with_type":"Xã Tường Thượng","path":"Xã Tường Thượng, Huyện Phù Yên, Tỉnh Sơn La","path_with_type":"Xã Tường Thượng, Huyện Phù Yên, Tỉnh Sơn La","code":"03949","parent_code":"122"},"03952":{"name":"Xã Tường Tiến","type":"xa","slug":"xa-tuong-tien","name_with_type":"Xã Tường Tiến","path":"Xã Tường Tiến, Huyện Phù Yên, Tỉnh Sơn La","path_with_type":"Xã Tường Tiến, Huyện Phù Yên, Tỉnh Sơn La","code":"03952","parent_code":"122"},"03955":{"name":"Xã Tường Phong","type":"xa","slug":"xa-tuong-phong","name_with_type":"Xã Tường Phong","path":"Xã Tường Phong, Huyện Phù Yên, Tỉnh Sơn La","path_with_type":"Xã Tường Phong, Huyện Phù Yên, Tỉnh Sơn La","code":"03955","parent_code":"122"},"03958":{"name":"Xã Tường Hạ","type":"xa","slug":"xa-tuong-ha","name_with_type":"Xã Tường Hạ","path":"Xã Tường Hạ, Huyện Phù Yên, Tỉnh Sơn La","path_with_type":"Xã Tường Hạ, Huyện Phù Yên, Tỉnh Sơn La","code":"03958","parent_code":"122"},"03961":{"name":"Xã Kim Bon","type":"xa","slug":"xa-kim-bon","name_with_type":"Xã Kim Bon","path":"Xã Kim Bon, Huyện Phù Yên, Tỉnh Sơn La","path_with_type":"Xã Kim Bon, Huyện Phù Yên, Tỉnh Sơn La","code":"03961","parent_code":"122"},"03964":{"name":"Xã Mường Bang","type":"xa","slug":"xa-muong-bang","name_with_type":"Xã Mường Bang","path":"Xã Mường Bang, Huyện Phù Yên, Tỉnh Sơn La","path_with_type":"Xã Mường Bang, Huyện Phù Yên, Tỉnh Sơn La","code":"03964","parent_code":"122"},"03967":{"name":"Xã Đá Đỏ","type":"xa","slug":"xa-da-do","name_with_type":"Xã Đá Đỏ","path":"Xã Đá Đỏ, Huyện Phù Yên, Tỉnh Sơn La","path_with_type":"Xã Đá Đỏ, Huyện Phù Yên, Tỉnh Sơn La","code":"03967","parent_code":"122"},"03970":{"name":"Xã Tân Phong","type":"xa","slug":"xa-tan-phong","name_with_type":"Xã Tân Phong","path":"Xã Tân Phong, Huyện Phù Yên, Tỉnh Sơn La","path_with_type":"Xã Tân Phong, Huyện Phù Yên, Tỉnh Sơn La","code":"03970","parent_code":"122"},"03973":{"name":"Xã Nam Phong","type":"xa","slug":"xa-nam-phong","name_with_type":"Xã Nam Phong","path":"Xã Nam Phong, Huyện Phù Yên, Tỉnh Sơn La","path_with_type":"Xã Nam Phong, Huyện Phù Yên, Tỉnh Sơn La","code":"03973","parent_code":"122"},"03976":{"name":"Xã Bắc Phong","type":"xa","slug":"xa-bac-phong","name_with_type":"Xã Bắc Phong","path":"Xã Bắc Phong, Huyện Phù Yên, Tỉnh Sơn La","path_with_type":"Xã Bắc Phong, Huyện Phù Yên, Tỉnh Sơn La","code":"03976","parent_code":"122"},"03979":{"name":"Thị trấn Mộc Châu","type":"thi-tran","slug":"thi-tran-moc-chau","name_with_type":"Thị trấn Mộc Châu","path":"Thị trấn Mộc Châu, Huyện Mộc Châu, Tỉnh Sơn La","path_with_type":"Thị trấn Mộc Châu, Huyện Mộc Châu, Tỉnh Sơn La","code":"03979","parent_code":"123"},"03982":{"name":"Thị trấn NT Mộc Châu","type":"thi-tran","slug":"thi-tran-nt-moc-chau","name_with_type":"Thị trấn NT Mộc Châu","path":"Thị trấn NT Mộc Châu, Huyện Mộc Châu, Tỉnh Sơn La","path_with_type":"Thị trấn NT Mộc Châu, Huyện Mộc Châu, Tỉnh Sơn La","code":"03982","parent_code":"123"},"03985":{"name":"Xã Chiềng Sơn","type":"xa","slug":"xa-chieng-son","name_with_type":"Xã Chiềng Sơn","path":"Xã Chiềng Sơn, Huyện Mộc Châu, Tỉnh Sơn La","path_with_type":"Xã Chiềng Sơn, Huyện Mộc Châu, Tỉnh Sơn La","code":"03985","parent_code":"123"},"03988":{"name":"Xã Tân Hợp","type":"xa","slug":"xa-tan-hop","name_with_type":"Xã Tân Hợp","path":"Xã Tân Hợp, Huyện Mộc Châu, Tỉnh Sơn La","path_with_type":"Xã Tân Hợp, Huyện Mộc Châu, Tỉnh Sơn La","code":"03988","parent_code":"123"},"03991":{"name":"Xã Qui Hướng","type":"xa","slug":"xa-qui-huong","name_with_type":"Xã Qui Hướng","path":"Xã Qui Hướng, Huyện Mộc Châu, Tỉnh Sơn La","path_with_type":"Xã Qui Hướng, Huyện Mộc Châu, Tỉnh Sơn La","code":"03991","parent_code":"123"},"03997":{"name":"Xã Tân Lập","type":"xa","slug":"xa-tan-lap","name_with_type":"Xã Tân Lập","path":"Xã Tân Lập, Huyện Mộc Châu, Tỉnh Sơn La","path_with_type":"Xã Tân Lập, Huyện Mộc Châu, Tỉnh Sơn La","code":"03997","parent_code":"123"},"04000":{"name":"Xã Nà Mường","type":"xa","slug":"xa-na-muong","name_with_type":"Xã Nà Mường","path":"Xã Nà Mường, Huyện Mộc Châu, Tỉnh Sơn La","path_with_type":"Xã Nà Mường, Huyện Mộc Châu, Tỉnh Sơn La","code":"04000","parent_code":"123"},"04003":{"name":"Xã Tà Lai","type":"xa","slug":"xa-ta-lai","name_with_type":"Xã Tà Lai","path":"Xã Tà Lai, Huyện Mộc Châu, Tỉnh Sơn La","path_with_type":"Xã Tà Lai, Huyện Mộc Châu, Tỉnh Sơn La","code":"04003","parent_code":"123"},"04012":{"name":"Xã Chiềng Hắc","type":"xa","slug":"xa-chieng-hac","name_with_type":"Xã Chiềng Hắc","path":"Xã Chiềng Hắc, Huyện Mộc Châu, Tỉnh Sơn La","path_with_type":"Xã Chiềng Hắc, Huyện Mộc Châu, Tỉnh Sơn La","code":"04012","parent_code":"123"},"04015":{"name":"Xã Hua Păng","type":"xa","slug":"xa-hua-pang","name_with_type":"Xã Hua Păng","path":"Xã Hua Păng, Huyện Mộc Châu, Tỉnh Sơn La","path_with_type":"Xã Hua Păng, Huyện Mộc Châu, Tỉnh Sơn La","code":"04015","parent_code":"123"},"04024":{"name":"Xã Chiềng Khừa","type":"xa","slug":"xa-chieng-khua","name_with_type":"Xã Chiềng Khừa","path":"Xã Chiềng Khừa, Huyện Mộc Châu, Tỉnh Sơn La","path_with_type":"Xã Chiềng Khừa, Huyện Mộc Châu, Tỉnh Sơn La","code":"04024","parent_code":"123"},"04027":{"name":"Xã Mường Sang","type":"xa","slug":"xa-muong-sang","name_with_type":"Xã Mường Sang","path":"Xã Mường Sang, Huyện Mộc Châu, Tỉnh Sơn La","path_with_type":"Xã Mường Sang, Huyện Mộc Châu, Tỉnh Sơn La","code":"04027","parent_code":"123"},"04030":{"name":"Xã Đông Sang","type":"xa","slug":"xa-dong-sang","name_with_type":"Xã Đông Sang","path":"Xã Đông Sang, Huyện Mộc Châu, Tỉnh Sơn La","path_with_type":"Xã Đông Sang, Huyện Mộc Châu, Tỉnh Sơn La","code":"04030","parent_code":"123"},"04033":{"name":"Xã Phiêng Luông","type":"xa","slug":"xa-phieng-luong","name_with_type":"Xã Phiêng Luông","path":"Xã Phiêng Luông, Huyện Mộc Châu, Tỉnh Sơn La","path_with_type":"Xã Phiêng Luông, Huyện Mộc Châu, Tỉnh Sơn La","code":"04033","parent_code":"123"},"04045":{"name":"Xã Lóng Sập","type":"xa","slug":"xa-long-sap","name_with_type":"Xã Lóng Sập","path":"Xã Lóng Sập, Huyện Mộc Châu, Tỉnh Sơn La","path_with_type":"Xã Lóng Sập, Huyện Mộc Châu, Tỉnh Sơn La","code":"04045","parent_code":"123"},"04060":{"name":"Thị trấn Yên Châu","type":"thi-tran","slug":"thi-tran-yen-chau","name_with_type":"Thị trấn Yên Châu","path":"Thị trấn Yên Châu, Huyện Yên Châu, Tỉnh Sơn La","path_with_type":"Thị trấn Yên Châu, Huyện Yên Châu, Tỉnh Sơn La","code":"04060","parent_code":"124"},"04063":{"name":"Xã Chiềng Đông","type":"xa","slug":"xa-chieng-dong","name_with_type":"Xã Chiềng Đông","path":"Xã Chiềng Đông, Huyện Yên Châu, Tỉnh Sơn La","path_with_type":"Xã Chiềng Đông, Huyện Yên Châu, Tỉnh Sơn La","code":"04063","parent_code":"124"},"04066":{"name":"Xã Sập Vạt","type":"xa","slug":"xa-sap-vat","name_with_type":"Xã Sập Vạt","path":"Xã Sập Vạt, Huyện Yên Châu, Tỉnh Sơn La","path_with_type":"Xã Sập Vạt, Huyện Yên Châu, Tỉnh Sơn La","code":"04066","parent_code":"124"},"04069":{"name":"Xã Chiềng Sàng","type":"xa","slug":"xa-chieng-sang","name_with_type":"Xã Chiềng Sàng","path":"Xã Chiềng Sàng, Huyện Yên Châu, Tỉnh Sơn La","path_with_type":"Xã Chiềng Sàng, Huyện Yên Châu, Tỉnh Sơn La","code":"04069","parent_code":"124"},"04072":{"name":"Xã Chiềng Pằn","type":"xa","slug":"xa-chieng-pan","name_with_type":"Xã Chiềng Pằn","path":"Xã Chiềng Pằn, Huyện Yên Châu, Tỉnh Sơn La","path_with_type":"Xã Chiềng Pằn, Huyện Yên Châu, Tỉnh Sơn La","code":"04072","parent_code":"124"},"04075":{"name":"Xã Viêng Lán","type":"xa","slug":"xa-vieng-lan","name_with_type":"Xã Viêng Lán","path":"Xã Viêng Lán, Huyện Yên Châu, Tỉnh Sơn La","path_with_type":"Xã Viêng Lán, Huyện Yên Châu, Tỉnh Sơn La","code":"04075","parent_code":"124"},"04078":{"name":"Xã Chiềng Hặc","type":"xa","slug":"xa-chieng-hac","name_with_type":"Xã Chiềng Hặc","path":"Xã Chiềng Hặc, Huyện Yên Châu, Tỉnh Sơn La","path_with_type":"Xã Chiềng Hặc, Huyện Yên Châu, Tỉnh Sơn La","code":"04078","parent_code":"124"},"04081":{"name":"Xã Mường Lựm","type":"xa","slug":"xa-muong-lum","name_with_type":"Xã Mường Lựm","path":"Xã Mường Lựm, Huyện Yên Châu, Tỉnh Sơn La","path_with_type":"Xã Mường Lựm, Huyện Yên Châu, Tỉnh Sơn La","code":"04081","parent_code":"124"},"04084":{"name":"Xã Chiềng On","type":"xa","slug":"xa-chieng-on","name_with_type":"Xã Chiềng On","path":"Xã Chiềng On, Huyện Yên Châu, Tỉnh Sơn La","path_with_type":"Xã Chiềng On, Huyện Yên Châu, Tỉnh Sơn La","code":"04084","parent_code":"124"},"04087":{"name":"Xã Yên Sơn","type":"xa","slug":"xa-yen-son","name_with_type":"Xã Yên Sơn","path":"Xã Yên Sơn, Huyện Yên Châu, Tỉnh Sơn La","path_with_type":"Xã Yên Sơn, Huyện Yên Châu, Tỉnh Sơn La","code":"04087","parent_code":"124"},"04090":{"name":"Xã Chiềng Khoi","type":"xa","slug":"xa-chieng-khoi","name_with_type":"Xã Chiềng Khoi","path":"Xã Chiềng Khoi, Huyện Yên Châu, Tỉnh Sơn La","path_with_type":"Xã Chiềng Khoi, Huyện Yên Châu, Tỉnh Sơn La","code":"04090","parent_code":"124"},"04093":{"name":"Xã Tú Nang","type":"xa","slug":"xa-tu-nang","name_with_type":"Xã Tú Nang","path":"Xã Tú Nang, Huyện Yên Châu, Tỉnh Sơn La","path_with_type":"Xã Tú Nang, Huyện Yên Châu, Tỉnh Sơn La","code":"04093","parent_code":"124"},"04096":{"name":"Xã Lóng Phiêng","type":"xa","slug":"xa-long-phieng","name_with_type":"Xã Lóng Phiêng","path":"Xã Lóng Phiêng, Huyện Yên Châu, Tỉnh Sơn La","path_with_type":"Xã Lóng Phiêng, Huyện Yên Châu, Tỉnh Sơn La","code":"04096","parent_code":"124"},"04099":{"name":"Xã Phiêng Khoài","type":"xa","slug":"xa-phieng-khoai","name_with_type":"Xã Phiêng Khoài","path":"Xã Phiêng Khoài, Huyện Yên Châu, Tỉnh Sơn La","path_with_type":"Xã Phiêng Khoài, Huyện Yên Châu, Tỉnh Sơn La","code":"04099","parent_code":"124"},"04102":{"name":"Xã Chiềng Tương","type":"xa","slug":"xa-chieng-tuong","name_with_type":"Xã Chiềng Tương","path":"Xã Chiềng Tương, Huyện Yên Châu, Tỉnh Sơn La","path_with_type":"Xã Chiềng Tương, Huyện Yên Châu, Tỉnh Sơn La","code":"04102","parent_code":"124"},"04105":{"name":"Thị trấn Hát Lót","type":"thi-tran","slug":"thi-tran-hat-lot","name_with_type":"Thị trấn Hát Lót","path":"Thị trấn Hát Lót, Huyện Mai Sơn, Tỉnh Sơn La","path_with_type":"Thị trấn Hát Lót, Huyện Mai Sơn, Tỉnh Sơn La","code":"04105","parent_code":"125"},"04108":{"name":"Xã Chiềng Sung","type":"xa","slug":"xa-chieng-sung","name_with_type":"Xã Chiềng Sung","path":"Xã Chiềng Sung, Huyện Mai Sơn, Tỉnh Sơn La","path_with_type":"Xã Chiềng Sung, Huyện Mai Sơn, Tỉnh Sơn La","code":"04108","parent_code":"125"},"04111":{"name":"Xã Mường Bằng","type":"xa","slug":"xa-muong-bang","name_with_type":"Xã Mường Bằng","path":"Xã Mường Bằng, Huyện Mai Sơn, Tỉnh Sơn La","path_with_type":"Xã Mường Bằng, Huyện Mai Sơn, Tỉnh Sơn La","code":"04111","parent_code":"125"},"04114":{"name":"Xã Chiềng Chăn","type":"xa","slug":"xa-chieng-chan","name_with_type":"Xã Chiềng Chăn","path":"Xã Chiềng Chăn, Huyện Mai Sơn, Tỉnh Sơn La","path_with_type":"Xã Chiềng Chăn, Huyện Mai Sơn, Tỉnh Sơn La","code":"04114","parent_code":"125"},"04117":{"name":"Xã Mương Chanh","type":"xa","slug":"xa-muong-chanh","name_with_type":"Xã Mương Chanh","path":"Xã Mương Chanh, Huyện Mai Sơn, Tỉnh Sơn La","path_with_type":"Xã Mương Chanh, Huyện Mai Sơn, Tỉnh Sơn La","code":"04117","parent_code":"125"},"04120":{"name":"Xã Chiềng Ban","type":"xa","slug":"xa-chieng-ban","name_with_type":"Xã Chiềng Ban","path":"Xã Chiềng Ban, Huyện Mai Sơn, Tỉnh Sơn La","path_with_type":"Xã Chiềng Ban, Huyện Mai Sơn, Tỉnh Sơn La","code":"04120","parent_code":"125"},"04123":{"name":"Xã Chiềng Mung","type":"xa","slug":"xa-chieng-mung","name_with_type":"Xã Chiềng Mung","path":"Xã Chiềng Mung, Huyện Mai Sơn, Tỉnh Sơn La","path_with_type":"Xã Chiềng Mung, Huyện Mai Sơn, Tỉnh Sơn La","code":"04123","parent_code":"125"},"04126":{"name":"Xã Mường Bon","type":"xa","slug":"xa-muong-bon","name_with_type":"Xã Mường Bon","path":"Xã Mường Bon, Huyện Mai Sơn, Tỉnh Sơn La","path_with_type":"Xã Mường Bon, Huyện Mai Sơn, Tỉnh Sơn La","code":"04126","parent_code":"125"},"04129":{"name":"Xã Chiềng Chung","type":"xa","slug":"xa-chieng-chung","name_with_type":"Xã Chiềng Chung","path":"Xã Chiềng Chung, Huyện Mai Sơn, Tỉnh Sơn La","path_with_type":"Xã Chiềng Chung, Huyện Mai Sơn, Tỉnh Sơn La","code":"04129","parent_code":"125"},"04132":{"name":"Xã Chiềng Mai","type":"xa","slug":"xa-chieng-mai","name_with_type":"Xã Chiềng Mai","path":"Xã Chiềng Mai, Huyện Mai Sơn, Tỉnh Sơn La","path_with_type":"Xã Chiềng Mai, Huyện Mai Sơn, Tỉnh Sơn La","code":"04132","parent_code":"125"},"04135":{"name":"Xã Hát Lót","type":"xa","slug":"xa-hat-lot","name_with_type":"Xã Hát Lót","path":"Xã Hát Lót, Huyện Mai Sơn, Tỉnh Sơn La","path_with_type":"Xã Hát Lót, Huyện Mai Sơn, Tỉnh Sơn La","code":"04135","parent_code":"125"},"04136":{"name":"Xã Nà Pó","type":"xa","slug":"xa-na-po","name_with_type":"Xã Nà Pó","path":"Xã Nà Pó, Huyện Mai Sơn, Tỉnh Sơn La","path_with_type":"Xã Nà Pó, Huyện Mai Sơn, Tỉnh Sơn La","code":"04136","parent_code":"125"},"04138":{"name":"Xã Cò  Nòi","type":"xa","slug":"xa-co-noi","name_with_type":"Xã Cò  Nòi","path":"Xã Cò  Nòi, Huyện Mai Sơn, Tỉnh Sơn La","path_with_type":"Xã Cò  Nòi, Huyện Mai Sơn, Tỉnh Sơn La","code":"04138","parent_code":"125"},"04141":{"name":"Xã Chiềng Nơi","type":"xa","slug":"xa-chieng-noi","name_with_type":"Xã Chiềng Nơi","path":"Xã Chiềng Nơi, Huyện Mai Sơn, Tỉnh Sơn La","path_with_type":"Xã Chiềng Nơi, Huyện Mai Sơn, Tỉnh Sơn La","code":"04141","parent_code":"125"},"04144":{"name":"Xã Phiêng Cằm","type":"xa","slug":"xa-phieng-cam","name_with_type":"Xã Phiêng Cằm","path":"Xã Phiêng Cằm, Huyện Mai Sơn, Tỉnh Sơn La","path_with_type":"Xã Phiêng Cằm, Huyện Mai Sơn, Tỉnh Sơn La","code":"04144","parent_code":"125"},"04147":{"name":"Xã Chiềng Dong","type":"xa","slug":"xa-chieng-dong","name_with_type":"Xã Chiềng Dong","path":"Xã Chiềng Dong, Huyện Mai Sơn, Tỉnh Sơn La","path_with_type":"Xã Chiềng Dong, Huyện Mai Sơn, Tỉnh Sơn La","code":"04147","parent_code":"125"},"04150":{"name":"Xã Chiềng Kheo","type":"xa","slug":"xa-chieng-kheo","name_with_type":"Xã Chiềng Kheo","path":"Xã Chiềng Kheo, Huyện Mai Sơn, Tỉnh Sơn La","path_with_type":"Xã Chiềng Kheo, Huyện Mai Sơn, Tỉnh Sơn La","code":"04150","parent_code":"125"},"04153":{"name":"Xã Chiềng Ve","type":"xa","slug":"xa-chieng-ve","name_with_type":"Xã Chiềng Ve","path":"Xã Chiềng Ve, Huyện Mai Sơn, Tỉnh Sơn La","path_with_type":"Xã Chiềng Ve, Huyện Mai Sơn, Tỉnh Sơn La","code":"04153","parent_code":"125"},"04156":{"name":"Xã Chiềng Lương","type":"xa","slug":"xa-chieng-luong","name_with_type":"Xã Chiềng Lương","path":"Xã Chiềng Lương, Huyện Mai Sơn, Tỉnh Sơn La","path_with_type":"Xã Chiềng Lương, Huyện Mai Sơn, Tỉnh Sơn La","code":"04156","parent_code":"125"},"04159":{"name":"Xã Phiêng Pằn","type":"xa","slug":"xa-phieng-pan","name_with_type":"Xã Phiêng Pằn","path":"Xã Phiêng Pằn, Huyện Mai Sơn, Tỉnh Sơn La","path_with_type":"Xã Phiêng Pằn, Huyện Mai Sơn, Tỉnh Sơn La","code":"04159","parent_code":"125"},"04162":{"name":"Xã Nà Ơt","type":"xa","slug":"xa-na-ot","name_with_type":"Xã Nà Ơt","path":"Xã Nà Ơt, Huyện Mai Sơn, Tỉnh Sơn La","path_with_type":"Xã Nà Ơt, Huyện Mai Sơn, Tỉnh Sơn La","code":"04162","parent_code":"125"},"04165":{"name":"Xã Tà Hộc","type":"xa","slug":"xa-ta-hoc","name_with_type":"Xã Tà Hộc","path":"Xã Tà Hộc, Huyện Mai Sơn, Tỉnh Sơn La","path_with_type":"Xã Tà Hộc, Huyện Mai Sơn, Tỉnh Sơn La","code":"04165","parent_code":"125"},"04168":{"name":"Thị trấn Sông Mã","type":"thi-tran","slug":"thi-tran-song-ma","name_with_type":"Thị trấn Sông Mã","path":"Thị trấn Sông Mã, Huyện Sông Mã, Tỉnh Sơn La","path_with_type":"Thị trấn Sông Mã, Huyện Sông Mã, Tỉnh Sơn La","code":"04168","parent_code":"126"},"04171":{"name":"Xã Bó Sinh","type":"xa","slug":"xa-bo-sinh","name_with_type":"Xã Bó Sinh","path":"Xã Bó Sinh, Huyện Sông Mã, Tỉnh Sơn La","path_with_type":"Xã Bó Sinh, Huyện Sông Mã, Tỉnh Sơn La","code":"04171","parent_code":"126"},"04174":{"name":"Xã Pú Pẩu","type":"xa","slug":"xa-pu-pau","name_with_type":"Xã Pú Pẩu","path":"Xã Pú Pẩu, Huyện Sông Mã, Tỉnh Sơn La","path_with_type":"Xã Pú Pẩu, Huyện Sông Mã, Tỉnh Sơn La","code":"04174","parent_code":"126"},"04177":{"name":"Xã Chiềng Phung","type":"xa","slug":"xa-chieng-phung","name_with_type":"Xã Chiềng Phung","path":"Xã Chiềng Phung, Huyện Sông Mã, Tỉnh Sơn La","path_with_type":"Xã Chiềng Phung, Huyện Sông Mã, Tỉnh Sơn La","code":"04177","parent_code":"126"},"04180":{"name":"Xã Chiềng En","type":"xa","slug":"xa-chieng-en","name_with_type":"Xã Chiềng En","path":"Xã Chiềng En, Huyện Sông Mã, Tỉnh Sơn La","path_with_type":"Xã Chiềng En, Huyện Sông Mã, Tỉnh Sơn La","code":"04180","parent_code":"126"},"04183":{"name":"Xã Mường Lầm","type":"xa","slug":"xa-muong-lam","name_with_type":"Xã Mường Lầm","path":"Xã Mường Lầm, Huyện Sông Mã, Tỉnh Sơn La","path_with_type":"Xã Mường Lầm, Huyện Sông Mã, Tỉnh Sơn La","code":"04183","parent_code":"126"},"04186":{"name":"Xã Nậm Ty","type":"xa","slug":"xa-nam-ty","name_with_type":"Xã Nậm Ty","path":"Xã Nậm Ty, Huyện Sông Mã, Tỉnh Sơn La","path_with_type":"Xã Nậm Ty, Huyện Sông Mã, Tỉnh Sơn La","code":"04186","parent_code":"126"},"04189":{"name":"Xã Đứa Mòn","type":"xa","slug":"xa-dua-mon","name_with_type":"Xã Đứa Mòn","path":"Xã Đứa Mòn, Huyện Sông Mã, Tỉnh Sơn La","path_with_type":"Xã Đứa Mòn, Huyện Sông Mã, Tỉnh Sơn La","code":"04189","parent_code":"126"},"04192":{"name":"Xã Yên Hưng","type":"xa","slug":"xa-yen-hung","name_with_type":"Xã Yên Hưng","path":"Xã Yên Hưng, Huyện Sông Mã, Tỉnh Sơn La","path_with_type":"Xã Yên Hưng, Huyện Sông Mã, Tỉnh Sơn La","code":"04192","parent_code":"126"},"04195":{"name":"Xã Chiềng Sơ","type":"xa","slug":"xa-chieng-so","name_with_type":"Xã Chiềng Sơ","path":"Xã Chiềng Sơ, Huyện Sông Mã, Tỉnh Sơn La","path_with_type":"Xã Chiềng Sơ, Huyện Sông Mã, Tỉnh Sơn La","code":"04195","parent_code":"126"},"04198":{"name":"Xã Nà Nghịu","type":"xa","slug":"xa-na-nghiu","name_with_type":"Xã Nà Nghịu","path":"Xã Nà Nghịu, Huyện Sông Mã, Tỉnh Sơn La","path_with_type":"Xã Nà Nghịu, Huyện Sông Mã, Tỉnh Sơn La","code":"04198","parent_code":"126"},"04201":{"name":"Xã Nậm Mằn","type":"xa","slug":"xa-nam-man","name_with_type":"Xã Nậm Mằn","path":"Xã Nậm Mằn, Huyện Sông Mã, Tỉnh Sơn La","path_with_type":"Xã Nậm Mằn, Huyện Sông Mã, Tỉnh Sơn La","code":"04201","parent_code":"126"},"04204":{"name":"Xã Chiềng Khoong","type":"xa","slug":"xa-chieng-khoong","name_with_type":"Xã Chiềng Khoong","path":"Xã Chiềng Khoong, Huyện Sông Mã, Tỉnh Sơn La","path_with_type":"Xã Chiềng Khoong, Huyện Sông Mã, Tỉnh Sơn La","code":"04204","parent_code":"126"},"04207":{"name":"Xã Chiềng Cang","type":"xa","slug":"xa-chieng-cang","name_with_type":"Xã Chiềng Cang","path":"Xã Chiềng Cang, Huyện Sông Mã, Tỉnh Sơn La","path_with_type":"Xã Chiềng Cang, Huyện Sông Mã, Tỉnh Sơn La","code":"04207","parent_code":"126"},"04210":{"name":"Xã Huổi Một","type":"xa","slug":"xa-huoi-mot","name_with_type":"Xã Huổi Một","path":"Xã Huổi Một, Huyện Sông Mã, Tỉnh Sơn La","path_with_type":"Xã Huổi Một, Huyện Sông Mã, Tỉnh Sơn La","code":"04210","parent_code":"126"},"04213":{"name":"Xã Mường Sai","type":"xa","slug":"xa-muong-sai","name_with_type":"Xã Mường Sai","path":"Xã Mường Sai, Huyện Sông Mã, Tỉnh Sơn La","path_with_type":"Xã Mường Sai, Huyện Sông Mã, Tỉnh Sơn La","code":"04213","parent_code":"126"},"04216":{"name":"Xã Mường Cai","type":"xa","slug":"xa-muong-cai","name_with_type":"Xã Mường Cai","path":"Xã Mường Cai, Huyện Sông Mã, Tỉnh Sơn La","path_with_type":"Xã Mường Cai, Huyện Sông Mã, Tỉnh Sơn La","code":"04216","parent_code":"126"},"04219":{"name":"Xã Mường Hung","type":"xa","slug":"xa-muong-hung","name_with_type":"Xã Mường Hung","path":"Xã Mường Hung, Huyện Sông Mã, Tỉnh Sơn La","path_with_type":"Xã Mường Hung, Huyện Sông Mã, Tỉnh Sơn La","code":"04219","parent_code":"126"},"04222":{"name":"Xã Chiềng Khương","type":"xa","slug":"xa-chieng-khuong","name_with_type":"Xã Chiềng Khương","path":"Xã Chiềng Khương, Huyện Sông Mã, Tỉnh Sơn La","path_with_type":"Xã Chiềng Khương, Huyện Sông Mã, Tỉnh Sơn La","code":"04222","parent_code":"126"},"04225":{"name":"Xã Sam Kha","type":"xa","slug":"xa-sam-kha","name_with_type":"Xã Sam Kha","path":"Xã Sam Kha, Huyện Sốp Cộp, Tỉnh Sơn La","path_with_type":"Xã Sam Kha, Huyện Sốp Cộp, Tỉnh Sơn La","code":"04225","parent_code":"127"},"04228":{"name":"Xã Púng Bánh","type":"xa","slug":"xa-pung-banh","name_with_type":"Xã Púng Bánh","path":"Xã Púng Bánh, Huyện Sốp Cộp, Tỉnh Sơn La","path_with_type":"Xã Púng Bánh, Huyện Sốp Cộp, Tỉnh Sơn La","code":"04228","parent_code":"127"},"04231":{"name":"Xã Sốp Cộp","type":"xa","slug":"xa-sop-cop","name_with_type":"Xã Sốp Cộp","path":"Xã Sốp Cộp, Huyện Sốp Cộp, Tỉnh Sơn La","path_with_type":"Xã Sốp Cộp, Huyện Sốp Cộp, Tỉnh Sơn La","code":"04231","parent_code":"127"},"04234":{"name":"Xã Dồm Cang","type":"xa","slug":"xa-dom-cang","name_with_type":"Xã Dồm Cang","path":"Xã Dồm Cang, Huyện Sốp Cộp, Tỉnh Sơn La","path_with_type":"Xã Dồm Cang, Huyện Sốp Cộp, Tỉnh Sơn La","code":"04234","parent_code":"127"},"04237":{"name":"Xã Nậm Lạnh","type":"xa","slug":"xa-nam-lanh","name_with_type":"Xã Nậm Lạnh","path":"Xã Nậm Lạnh, Huyện Sốp Cộp, Tỉnh Sơn La","path_with_type":"Xã Nậm Lạnh, Huyện Sốp Cộp, Tỉnh Sơn La","code":"04237","parent_code":"127"},"04240":{"name":"Xã Mường Lèo","type":"xa","slug":"xa-muong-leo","name_with_type":"Xã Mường Lèo","path":"Xã Mường Lèo, Huyện Sốp Cộp, Tỉnh Sơn La","path_with_type":"Xã Mường Lèo, Huyện Sốp Cộp, Tỉnh Sơn La","code":"04240","parent_code":"127"},"04243":{"name":"Xã Mường Và","type":"xa","slug":"xa-muong-va","name_with_type":"Xã Mường Và","path":"Xã Mường Và, Huyện Sốp Cộp, Tỉnh Sơn La","path_with_type":"Xã Mường Và, Huyện Sốp Cộp, Tỉnh Sơn La","code":"04243","parent_code":"127"},"04246":{"name":"Xã Mường Lạn","type":"xa","slug":"xa-muong-lan","name_with_type":"Xã Mường Lạn","path":"Xã Mường Lạn, Huyện Sốp Cộp, Tỉnh Sơn La","path_with_type":"Xã Mường Lạn, Huyện Sốp Cộp, Tỉnh Sơn La","code":"04246","parent_code":"127"},"03994":{"name":"Xã Suối Bàng","type":"xa","slug":"xa-suoi-bang","name_with_type":"Xã Suối Bàng","path":"Xã Suối Bàng, Huyện Vân Hồ, Tỉnh Sơn La","path_with_type":"Xã Suối Bàng, Huyện Vân Hồ, Tỉnh Sơn La","code":"03994","parent_code":"128"},"04006":{"name":"Xã Song Khủa","type":"xa","slug":"xa-song-khua","name_with_type":"Xã Song Khủa","path":"Xã Song Khủa, Huyện Vân Hồ, Tỉnh Sơn La","path_with_type":"Xã Song Khủa, Huyện Vân Hồ, Tỉnh Sơn La","code":"04006","parent_code":"128"},"04009":{"name":"Xã Liên Hoà","type":"xa","slug":"xa-lien-hoa","name_with_type":"Xã Liên Hoà","path":"Xã Liên Hoà, Huyện Vân Hồ, Tỉnh Sơn La","path_with_type":"Xã Liên Hoà, Huyện Vân Hồ, Tỉnh Sơn La","code":"04009","parent_code":"128"},"04018":{"name":"Xã Tô Múa","type":"xa","slug":"xa-to-mua","name_with_type":"Xã Tô Múa","path":"Xã Tô Múa, Huyện Vân Hồ, Tỉnh Sơn La","path_with_type":"Xã Tô Múa, Huyện Vân Hồ, Tỉnh Sơn La","code":"04018","parent_code":"128"},"04021":{"name":"Xã Mường Tè","type":"xa","slug":"xa-muong-te","name_with_type":"Xã Mường Tè","path":"Xã Mường Tè, Huyện Vân Hồ, Tỉnh Sơn La","path_with_type":"Xã Mường Tè, Huyện Vân Hồ, Tỉnh Sơn La","code":"04021","parent_code":"128"},"04036":{"name":"Xã Chiềng Khoa","type":"xa","slug":"xa-chieng-khoa","name_with_type":"Xã Chiềng Khoa","path":"Xã Chiềng Khoa, Huyện Vân Hồ, Tỉnh Sơn La","path_with_type":"Xã Chiềng Khoa, Huyện Vân Hồ, Tỉnh Sơn La","code":"04036","parent_code":"128"},"04039":{"name":"Xã Mường Men","type":"xa","slug":"xa-muong-men","name_with_type":"Xã Mường Men","path":"Xã Mường Men, Huyện Vân Hồ, Tỉnh Sơn La","path_with_type":"Xã Mường Men, Huyện Vân Hồ, Tỉnh Sơn La","code":"04039","parent_code":"128"},"04042":{"name":"Xã Quang Minh","type":"xa","slug":"xa-quang-minh","name_with_type":"Xã Quang Minh","path":"Xã Quang Minh, Huyện Vân Hồ, Tỉnh Sơn La","path_with_type":"Xã Quang Minh, Huyện Vân Hồ, Tỉnh Sơn La","code":"04042","parent_code":"128"},"04048":{"name":"Xã Vân Hồ","type":"xa","slug":"xa-van-ho","name_with_type":"Xã Vân Hồ","path":"Xã Vân Hồ, Huyện Vân Hồ, Tỉnh Sơn La","path_with_type":"Xã Vân Hồ, Huyện Vân Hồ, Tỉnh Sơn La","code":"04048","parent_code":"128"},"04051":{"name":"Xã Lóng Luông","type":"xa","slug":"xa-long-luong","name_with_type":"Xã Lóng Luông","path":"Xã Lóng Luông, Huyện Vân Hồ, Tỉnh Sơn La","path_with_type":"Xã Lóng Luông, Huyện Vân Hồ, Tỉnh Sơn La","code":"04051","parent_code":"128"},"04054":{"name":"Xã Chiềng Yên","type":"xa","slug":"xa-chieng-yen","name_with_type":"Xã Chiềng Yên","path":"Xã Chiềng Yên, Huyện Vân Hồ, Tỉnh Sơn La","path_with_type":"Xã Chiềng Yên, Huyện Vân Hồ, Tỉnh Sơn La","code":"04054","parent_code":"128"},"04056":{"name":"Xã Chiềng Xuân","type":"xa","slug":"xa-chieng-xuan","name_with_type":"Xã Chiềng Xuân","path":"Xã Chiềng Xuân, Huyện Vân Hồ, Tỉnh Sơn La","path_with_type":"Xã Chiềng Xuân, Huyện Vân Hồ, Tỉnh Sơn La","code":"04056","parent_code":"128"},"04057":{"name":"Xã Xuân Nha","type":"xa","slug":"xa-xuan-nha","name_with_type":"Xã Xuân Nha","path":"Xã Xuân Nha, Huyện Vân Hồ, Tỉnh Sơn La","path_with_type":"Xã Xuân Nha, Huyện Vân Hồ, Tỉnh Sơn La","code":"04057","parent_code":"128"},"04058":{"name":"Xã Tân Xuân","type":"xa","slug":"xa-tan-xuan","name_with_type":"Xã Tân Xuân","path":"Xã Tân Xuân, Huyện Vân Hồ, Tỉnh Sơn La","path_with_type":"Xã Tân Xuân, Huyện Vân Hồ, Tỉnh Sơn La","code":"04058","parent_code":"128"},"04249":{"name":"Phường Yên Thịnh","type":"phuong","slug":"phuong-yen-thinh","name_with_type":"Phường Yên Thịnh","path":"Phường Yên Thịnh, Thành phố Yên Bái, Tỉnh Yên Bái","path_with_type":"Phường Yên Thịnh, Thành phố Yên Bái, Tỉnh Yên Bái","code":"04249","parent_code":"132"},"04252":{"name":"Phường Yên Ninh","type":"phuong","slug":"phuong-yen-ninh","name_with_type":"Phường Yên Ninh","path":"Phường Yên Ninh, Thành phố Yên Bái, Tỉnh Yên Bái","path_with_type":"Phường Yên Ninh, Thành phố Yên Bái, Tỉnh Yên Bái","code":"04252","parent_code":"132"},"04255":{"name":"Phường Minh Tân","type":"phuong","slug":"phuong-minh-tan","name_with_type":"Phường Minh Tân","path":"Phường Minh Tân, Thành phố Yên Bái, Tỉnh Yên Bái","path_with_type":"Phường Minh Tân, Thành phố Yên Bái, Tỉnh Yên Bái","code":"04255","parent_code":"132"},"04258":{"name":"Phường Nguyễn Thái Học","type":"phuong","slug":"phuong-nguyen-thai-hoc","name_with_type":"Phường Nguyễn Thái Học","path":"Phường Nguyễn Thái Học, Thành phố Yên Bái, Tỉnh Yên Bái","path_with_type":"Phường Nguyễn Thái Học, Thành phố Yên Bái, Tỉnh Yên Bái","code":"04258","parent_code":"132"},"04261":{"name":"Phường Đồng Tâm","type":"phuong","slug":"phuong-dong-tam","name_with_type":"Phường Đồng Tâm","path":"Phường Đồng Tâm, Thành phố Yên Bái, Tỉnh Yên Bái","path_with_type":"Phường Đồng Tâm, Thành phố Yên Bái, Tỉnh Yên Bái","code":"04261","parent_code":"132"},"04264":{"name":"Phường Hồng Hà","type":"phuong","slug":"phuong-hong-ha","name_with_type":"Phường Hồng Hà","path":"Phường Hồng Hà, Thành phố Yên Bái, Tỉnh Yên Bái","path_with_type":"Phường Hồng Hà, Thành phố Yên Bái, Tỉnh Yên Bái","code":"04264","parent_code":"132"},"04270":{"name":"Xã Minh Bảo","type":"xa","slug":"xa-minh-bao","name_with_type":"Xã Minh Bảo","path":"Xã Minh Bảo, Thành phố Yên Bái, Tỉnh Yên Bái","path_with_type":"Xã Minh Bảo, Thành phố Yên Bái, Tỉnh Yên Bái","code":"04270","parent_code":"132"},"04273":{"name":"Phường Nam Cường","type":"phuong","slug":"phuong-nam-cuong","name_with_type":"Phường Nam Cường","path":"Phường Nam Cường, Thành phố Yên Bái, Tỉnh Yên Bái","path_with_type":"Phường Nam Cường, Thành phố Yên Bái, Tỉnh Yên Bái","code":"04273","parent_code":"132"},"04276":{"name":"Xã Tuy Lộc","type":"xa","slug":"xa-tuy-loc","name_with_type":"Xã Tuy Lộc","path":"Xã Tuy Lộc, Thành phố Yên Bái, Tỉnh Yên Bái","path_with_type":"Xã Tuy Lộc, Thành phố Yên Bái, Tỉnh Yên Bái","code":"04276","parent_code":"132"},"04279":{"name":"Xã Tân Thịnh","type":"xa","slug":"xa-tan-thinh","name_with_type":"Xã Tân Thịnh","path":"Xã Tân Thịnh, Thành phố Yên Bái, Tỉnh Yên Bái","path_with_type":"Xã Tân Thịnh, Thành phố Yên Bái, Tỉnh Yên Bái","code":"04279","parent_code":"132"},"04540":{"name":"Xã Âu Lâu","type":"xa","slug":"xa-au-lau","name_with_type":"Xã Âu Lâu","path":"Xã Âu Lâu, Thành phố Yên Bái, Tỉnh Yên Bái","path_with_type":"Xã Âu Lâu, Thành phố Yên Bái, Tỉnh Yên Bái","code":"04540","parent_code":"132"},"04543":{"name":"Xã Giới Phiên","type":"xa","slug":"xa-gioi-phien","name_with_type":"Xã Giới Phiên","path":"Xã Giới Phiên, Thành phố Yên Bái, Tỉnh Yên Bái","path_with_type":"Xã Giới Phiên, Thành phố Yên Bái, Tỉnh Yên Bái","code":"04543","parent_code":"132"},"04546":{"name":"Phường Hợp Minh","type":"phuong","slug":"phuong-hop-minh","name_with_type":"Phường Hợp Minh","path":"Phường Hợp Minh, Thành phố Yên Bái, Tỉnh Yên Bái","path_with_type":"Phường Hợp Minh, Thành phố Yên Bái, Tỉnh Yên Bái","code":"04546","parent_code":"132"},"04558":{"name":"Xã Văn Phú","type":"xa","slug":"xa-van-phu","name_with_type":"Xã Văn Phú","path":"Xã Văn Phú, Thành phố Yên Bái, Tỉnh Yên Bái","path_with_type":"Xã Văn Phú, Thành phố Yên Bái, Tỉnh Yên Bái","code":"04558","parent_code":"132"},"04282":{"name":"Phường Pú Trạng","type":"phuong","slug":"phuong-pu-trang","name_with_type":"Phường Pú Trạng","path":"Phường Pú Trạng, Thị xã Nghĩa Lộ, Tỉnh Yên Bái","path_with_type":"Phường Pú Trạng, Thị xã Nghĩa Lộ, Tỉnh Yên Bái","code":"04282","parent_code":"133"},"04285":{"name":"Phường Trung Tâm","type":"phuong","slug":"phuong-trung-tam","name_with_type":"Phường Trung Tâm","path":"Phường Trung Tâm, Thị xã Nghĩa Lộ, Tỉnh Yên Bái","path_with_type":"Phường Trung Tâm, Thị xã Nghĩa Lộ, Tỉnh Yên Bái","code":"04285","parent_code":"133"},"04288":{"name":"Phường Tân An","type":"phuong","slug":"phuong-tan-an","name_with_type":"Phường Tân An","path":"Phường Tân An, Thị xã Nghĩa Lộ, Tỉnh Yên Bái","path_with_type":"Phường Tân An, Thị xã Nghĩa Lộ, Tỉnh Yên Bái","code":"04288","parent_code":"133"},"04291":{"name":"Phường Cầu Thia","type":"phuong","slug":"phuong-cau-thia","name_with_type":"Phường Cầu Thia","path":"Phường Cầu Thia, Thị xã Nghĩa Lộ, Tỉnh Yên Bái","path_with_type":"Phường Cầu Thia, Thị xã Nghĩa Lộ, Tỉnh Yên Bái","code":"04291","parent_code":"133"},"04294":{"name":"Xã Nghĩa Lợi","type":"xa","slug":"xa-nghia-loi","name_with_type":"Xã Nghĩa Lợi","path":"Xã Nghĩa Lợi, Thị xã Nghĩa Lộ, Tỉnh Yên Bái","path_with_type":"Xã Nghĩa Lợi, Thị xã Nghĩa Lộ, Tỉnh Yên Bái","code":"04294","parent_code":"133"},"04297":{"name":"Xã Nghĩa Phúc","type":"xa","slug":"xa-nghia-phuc","name_with_type":"Xã Nghĩa Phúc","path":"Xã Nghĩa Phúc, Thị xã Nghĩa Lộ, Tỉnh Yên Bái","path_with_type":"Xã Nghĩa Phúc, Thị xã Nghĩa Lộ, Tỉnh Yên Bái","code":"04297","parent_code":"133"},"04300":{"name":"Xã Nghĩa An","type":"xa","slug":"xa-nghia-an","name_with_type":"Xã Nghĩa An","path":"Xã Nghĩa An, Thị xã Nghĩa Lộ, Tỉnh Yên Bái","path_with_type":"Xã Nghĩa An, Thị xã Nghĩa Lộ, Tỉnh Yên Bái","code":"04300","parent_code":"133"},"04624":{"name":"Xã Nghĩa Lộ","type":"xa","slug":"xa-nghia-lo","name_with_type":"Xã Nghĩa Lộ","path":"Xã Nghĩa Lộ, Thị xã Nghĩa Lộ, Tỉnh Yên Bái","path_with_type":"Xã Nghĩa Lộ, Thị xã Nghĩa Lộ, Tỉnh Yên Bái","code":"04624","parent_code":"133"},"04660":{"name":"Xã Sơn A","type":"xa","slug":"xa-son-a","name_with_type":"Xã Sơn A","path":"Xã Sơn A, Thị xã Nghĩa Lộ, Tỉnh Yên Bái","path_with_type":"Xã Sơn A, Thị xã Nghĩa Lộ, Tỉnh Yên Bái","code":"04660","parent_code":"133"},"04663":{"name":"Xã Phù Nham","type":"xa","slug":"xa-phu-nham","name_with_type":"Xã Phù Nham","path":"Xã Phù Nham, Thị xã Nghĩa Lộ, Tỉnh Yên Bái","path_with_type":"Xã Phù Nham, Thị xã Nghĩa Lộ, Tỉnh Yên Bái","code":"04663","parent_code":"133"},"04675":{"name":"Xã Thanh Lương","type":"xa","slug":"xa-thanh-luong","name_with_type":"Xã Thanh Lương","path":"Xã Thanh Lương, Thị xã Nghĩa Lộ, Tỉnh Yên Bái","path_with_type":"Xã Thanh Lương, Thị xã Nghĩa Lộ, Tỉnh Yên Bái","code":"04675","parent_code":"133"},"04678":{"name":"Xã Hạnh Sơn","type":"xa","slug":"xa-hanh-son","name_with_type":"Xã Hạnh Sơn","path":"Xã Hạnh Sơn, Thị xã Nghĩa Lộ, Tỉnh Yên Bái","path_with_type":"Xã Hạnh Sơn, Thị xã Nghĩa Lộ, Tỉnh Yên Bái","code":"04678","parent_code":"133"},"04681":{"name":"Xã Phúc Sơn","type":"xa","slug":"xa-phuc-son","name_with_type":"Xã Phúc Sơn","path":"Xã Phúc Sơn, Thị xã Nghĩa Lộ, Tỉnh Yên Bái","path_with_type":"Xã Phúc Sơn, Thị xã Nghĩa Lộ, Tỉnh Yên Bái","code":"04681","parent_code":"133"},"04684":{"name":"Xã Thạch Lương","type":"xa","slug":"xa-thach-luong","name_with_type":"Xã Thạch Lương","path":"Xã Thạch Lương, Thị xã Nghĩa Lộ, Tỉnh Yên Bái","path_with_type":"Xã Thạch Lương, Thị xã Nghĩa Lộ, Tỉnh Yên Bái","code":"04684","parent_code":"133"},"04303":{"name":"Thị trấn Yên Thế","type":"thi-tran","slug":"thi-tran-yen-the","name_with_type":"Thị trấn Yên Thế","path":"Thị trấn Yên Thế, Huyện Lục Yên, Tỉnh Yên Bái","path_with_type":"Thị trấn Yên Thế, Huyện Lục Yên, Tỉnh Yên Bái","code":"04303","parent_code":"135"},"04306":{"name":"Xã Tân Phượng","type":"xa","slug":"xa-tan-phuong","name_with_type":"Xã Tân Phượng","path":"Xã Tân Phượng, Huyện Lục Yên, Tỉnh Yên Bái","path_with_type":"Xã Tân Phượng, Huyện Lục Yên, Tỉnh Yên Bái","code":"04306","parent_code":"135"},"04309":{"name":"Xã Lâm Thượng","type":"xa","slug":"xa-lam-thuong","name_with_type":"Xã Lâm Thượng","path":"Xã Lâm Thượng, Huyện Lục Yên, Tỉnh Yên Bái","path_with_type":"Xã Lâm Thượng, Huyện Lục Yên, Tỉnh Yên Bái","code":"04309","parent_code":"135"},"04312":{"name":"Xã Khánh Thiện","type":"xa","slug":"xa-khanh-thien","name_with_type":"Xã Khánh Thiện","path":"Xã Khánh Thiện, Huyện Lục Yên, Tỉnh Yên Bái","path_with_type":"Xã Khánh Thiện, Huyện Lục Yên, Tỉnh Yên Bái","code":"04312","parent_code":"135"},"04315":{"name":"Xã Minh Chuẩn","type":"xa","slug":"xa-minh-chuan","name_with_type":"Xã Minh Chuẩn","path":"Xã Minh Chuẩn, Huyện Lục Yên, Tỉnh Yên Bái","path_with_type":"Xã Minh Chuẩn, Huyện Lục Yên, Tỉnh Yên Bái","code":"04315","parent_code":"135"},"04318":{"name":"Xã Mai Sơn","type":"xa","slug":"xa-mai-son","name_with_type":"Xã Mai Sơn","path":"Xã Mai Sơn, Huyện Lục Yên, Tỉnh Yên Bái","path_with_type":"Xã Mai Sơn, Huyện Lục Yên, Tỉnh Yên Bái","code":"04318","parent_code":"135"},"04321":{"name":"Xã Khai Trung","type":"xa","slug":"xa-khai-trung","name_with_type":"Xã Khai Trung","path":"Xã Khai Trung, Huyện Lục Yên, Tỉnh Yên Bái","path_with_type":"Xã Khai Trung, Huyện Lục Yên, Tỉnh Yên Bái","code":"04321","parent_code":"135"},"04324":{"name":"Xã Mường Lai","type":"xa","slug":"xa-muong-lai","name_with_type":"Xã Mường Lai","path":"Xã Mường Lai, Huyện Lục Yên, Tỉnh Yên Bái","path_with_type":"Xã Mường Lai, Huyện Lục Yên, Tỉnh Yên Bái","code":"04324","parent_code":"135"},"04327":{"name":"Xã An Lạc","type":"xa","slug":"xa-an-lac","name_with_type":"Xã An Lạc","path":"Xã An Lạc, Huyện Lục Yên, Tỉnh Yên Bái","path_with_type":"Xã An Lạc, Huyện Lục Yên, Tỉnh Yên Bái","code":"04327","parent_code":"135"},"04330":{"name":"Xã Minh Xuân","type":"xa","slug":"xa-minh-xuan","name_with_type":"Xã Minh Xuân","path":"Xã Minh Xuân, Huyện Lục Yên, Tỉnh Yên Bái","path_with_type":"Xã Minh Xuân, Huyện Lục Yên, Tỉnh Yên Bái","code":"04330","parent_code":"135"},"04333":{"name":"Xã Tô Mậu","type":"xa","slug":"xa-to-mau","name_with_type":"Xã Tô Mậu","path":"Xã Tô Mậu, Huyện Lục Yên, Tỉnh Yên Bái","path_with_type":"Xã Tô Mậu, Huyện Lục Yên, Tỉnh Yên Bái","code":"04333","parent_code":"135"},"04336":{"name":"Xã Tân Lĩnh","type":"xa","slug":"xa-tan-linh","name_with_type":"Xã Tân Lĩnh","path":"Xã Tân Lĩnh, Huyện Lục Yên, Tỉnh Yên Bái","path_with_type":"Xã Tân Lĩnh, Huyện Lục Yên, Tỉnh Yên Bái","code":"04336","parent_code":"135"},"04339":{"name":"Xã Yên Thắng","type":"xa","slug":"xa-yen-thang","name_with_type":"Xã Yên Thắng","path":"Xã Yên Thắng, Huyện Lục Yên, Tỉnh Yên Bái","path_with_type":"Xã Yên Thắng, Huyện Lục Yên, Tỉnh Yên Bái","code":"04339","parent_code":"135"},"04342":{"name":"Xã Khánh Hoà","type":"xa","slug":"xa-khanh-hoa","name_with_type":"Xã Khánh Hoà","path":"Xã Khánh Hoà, Huyện Lục Yên, Tỉnh Yên Bái","path_with_type":"Xã Khánh Hoà, Huyện Lục Yên, Tỉnh Yên Bái","code":"04342","parent_code":"135"},"04345":{"name":"Xã Vĩnh Lạc","type":"xa","slug":"xa-vinh-lac","name_with_type":"Xã Vĩnh Lạc","path":"Xã Vĩnh Lạc, Huyện Lục Yên, Tỉnh Yên Bái","path_with_type":"Xã Vĩnh Lạc, Huyện Lục Yên, Tỉnh Yên Bái","code":"04345","parent_code":"135"},"04348":{"name":"Xã Liễu Đô","type":"xa","slug":"xa-lieu-do","name_with_type":"Xã Liễu Đô","path":"Xã Liễu Đô, Huyện Lục Yên, Tỉnh Yên Bái","path_with_type":"Xã Liễu Đô, Huyện Lục Yên, Tỉnh Yên Bái","code":"04348","parent_code":"135"},"04351":{"name":"Xã Động Quan","type":"xa","slug":"xa-dong-quan","name_with_type":"Xã Động Quan","path":"Xã Động Quan, Huyện Lục Yên, Tỉnh Yên Bái","path_with_type":"Xã Động Quan, Huyện Lục Yên, Tỉnh Yên Bái","code":"04351","parent_code":"135"},"04354":{"name":"Xã Tân Lập","type":"xa","slug":"xa-tan-lap","name_with_type":"Xã Tân Lập","path":"Xã Tân Lập, Huyện Lục Yên, Tỉnh Yên Bái","path_with_type":"Xã Tân Lập, Huyện Lục Yên, Tỉnh Yên Bái","code":"04354","parent_code":"135"},"04357":{"name":"Xã Minh Tiến","type":"xa","slug":"xa-minh-tien","name_with_type":"Xã Minh Tiến","path":"Xã Minh Tiến, Huyện Lục Yên, Tỉnh Yên Bái","path_with_type":"Xã Minh Tiến, Huyện Lục Yên, Tỉnh Yên Bái","code":"04357","parent_code":"135"},"04360":{"name":"Xã Trúc Lâu","type":"xa","slug":"xa-truc-lau","name_with_type":"Xã Trúc Lâu","path":"Xã Trúc Lâu, Huyện Lục Yên, Tỉnh Yên Bái","path_with_type":"Xã Trúc Lâu, Huyện Lục Yên, Tỉnh Yên Bái","code":"04360","parent_code":"135"},"04363":{"name":"Xã Phúc Lợi","type":"xa","slug":"xa-phuc-loi","name_with_type":"Xã Phúc Lợi","path":"Xã Phúc Lợi, Huyện Lục Yên, Tỉnh Yên Bái","path_with_type":"Xã Phúc Lợi, Huyện Lục Yên, Tỉnh Yên Bái","code":"04363","parent_code":"135"},"04366":{"name":"Xã Phan Thanh","type":"xa","slug":"xa-phan-thanh","name_with_type":"Xã Phan Thanh","path":"Xã Phan Thanh, Huyện Lục Yên, Tỉnh Yên Bái","path_with_type":"Xã Phan Thanh, Huyện Lục Yên, Tỉnh Yên Bái","code":"04366","parent_code":"135"},"04369":{"name":"Xã An Phú","type":"xa","slug":"xa-an-phu","name_with_type":"Xã An Phú","path":"Xã An Phú, Huyện Lục Yên, Tỉnh Yên Bái","path_with_type":"Xã An Phú, Huyện Lục Yên, Tỉnh Yên Bái","code":"04369","parent_code":"135"},"04372":{"name":"Xã Trung Tâm","type":"xa","slug":"xa-trung-tam","name_with_type":"Xã Trung Tâm","path":"Xã Trung Tâm, Huyện Lục Yên, Tỉnh Yên Bái","path_with_type":"Xã Trung Tâm, Huyện Lục Yên, Tỉnh Yên Bái","code":"04372","parent_code":"135"},"04375":{"name":"Thị trấn Mậu A","type":"thi-tran","slug":"thi-tran-mau-a","name_with_type":"Thị trấn Mậu A","path":"Thị trấn Mậu A, Huyện Văn Yên, Tỉnh Yên Bái","path_with_type":"Thị trấn Mậu A, Huyện Văn Yên, Tỉnh Yên Bái","code":"04375","parent_code":"136"},"04378":{"name":"Xã Lang Thíp","type":"xa","slug":"xa-lang-thip","name_with_type":"Xã Lang Thíp","path":"Xã Lang Thíp, Huyện Văn Yên, Tỉnh Yên Bái","path_with_type":"Xã Lang Thíp, Huyện Văn Yên, Tỉnh Yên Bái","code":"04378","parent_code":"136"},"04381":{"name":"Xã Lâm Giang","type":"xa","slug":"xa-lam-giang","name_with_type":"Xã Lâm Giang","path":"Xã Lâm Giang, Huyện Văn Yên, Tỉnh Yên Bái","path_with_type":"Xã Lâm Giang, Huyện Văn Yên, Tỉnh Yên Bái","code":"04381","parent_code":"136"},"04384":{"name":"Xã Châu Quế Thượng","type":"xa","slug":"xa-chau-que-thuong","name_with_type":"Xã Châu Quế Thượng","path":"Xã Châu Quế Thượng, Huyện Văn Yên, Tỉnh Yên Bái","path_with_type":"Xã Châu Quế Thượng, Huyện Văn Yên, Tỉnh Yên Bái","code":"04384","parent_code":"136"},"04387":{"name":"Xã Châu Quế Hạ","type":"xa","slug":"xa-chau-que-ha","name_with_type":"Xã Châu Quế Hạ","path":"Xã Châu Quế Hạ, Huyện Văn Yên, Tỉnh Yên Bái","path_with_type":"Xã Châu Quế Hạ, Huyện Văn Yên, Tỉnh Yên Bái","code":"04387","parent_code":"136"},"04390":{"name":"Xã An Bình","type":"xa","slug":"xa-an-binh","name_with_type":"Xã An Bình","path":"Xã An Bình, Huyện Văn Yên, Tỉnh Yên Bái","path_with_type":"Xã An Bình, Huyện Văn Yên, Tỉnh Yên Bái","code":"04390","parent_code":"136"},"04393":{"name":"Xã Quang Minh","type":"xa","slug":"xa-quang-minh","name_with_type":"Xã Quang Minh","path":"Xã Quang Minh, Huyện Văn Yên, Tỉnh Yên Bái","path_with_type":"Xã Quang Minh, Huyện Văn Yên, Tỉnh Yên Bái","code":"04393","parent_code":"136"},"04396":{"name":"Xã Đông An","type":"xa","slug":"xa-dong-an","name_with_type":"Xã Đông An","path":"Xã Đông An, Huyện Văn Yên, Tỉnh Yên Bái","path_with_type":"Xã Đông An, Huyện Văn Yên, Tỉnh Yên Bái","code":"04396","parent_code":"136"},"04399":{"name":"Xã Đông Cuông","type":"xa","slug":"xa-dong-cuong","name_with_type":"Xã Đông Cuông","path":"Xã Đông Cuông, Huyện Văn Yên, Tỉnh Yên Bái","path_with_type":"Xã Đông Cuông, Huyện Văn Yên, Tỉnh Yên Bái","code":"04399","parent_code":"136"},"04402":{"name":"Xã Phong Dụ Hạ","type":"xa","slug":"xa-phong-du-ha","name_with_type":"Xã Phong Dụ Hạ","path":"Xã Phong Dụ Hạ, Huyện Văn Yên, Tỉnh Yên Bái","path_with_type":"Xã Phong Dụ Hạ, Huyện Văn Yên, Tỉnh Yên Bái","code":"04402","parent_code":"136"},"04405":{"name":"Xã Mậu Đông","type":"xa","slug":"xa-mau-dong","name_with_type":"Xã Mậu Đông","path":"Xã Mậu Đông, Huyện Văn Yên, Tỉnh Yên Bái","path_with_type":"Xã Mậu Đông, Huyện Văn Yên, Tỉnh Yên Bái","code":"04405","parent_code":"136"},"04408":{"name":"Xã Ngòi A","type":"xa","slug":"xa-ngoi-a","name_with_type":"Xã Ngòi A","path":"Xã Ngòi A, Huyện Văn Yên, Tỉnh Yên Bái","path_with_type":"Xã Ngòi A, Huyện Văn Yên, Tỉnh Yên Bái","code":"04408","parent_code":"136"},"04411":{"name":"Xã Xuân Tầm","type":"xa","slug":"xa-xuan-tam","name_with_type":"Xã Xuân Tầm","path":"Xã Xuân Tầm, Huyện Văn Yên, Tỉnh Yên Bái","path_with_type":"Xã Xuân Tầm, Huyện Văn Yên, Tỉnh Yên Bái","code":"04411","parent_code":"136"},"04414":{"name":"Xã Tân Hợp","type":"xa","slug":"xa-tan-hop","name_with_type":"Xã Tân Hợp","path":"Xã Tân Hợp, Huyện Văn Yên, Tỉnh Yên Bái","path_with_type":"Xã Tân Hợp, Huyện Văn Yên, Tỉnh Yên Bái","code":"04414","parent_code":"136"},"04417":{"name":"Xã An Thịnh","type":"xa","slug":"xa-an-thinh","name_with_type":"Xã An Thịnh","path":"Xã An Thịnh, Huyện Văn Yên, Tỉnh Yên Bái","path_with_type":"Xã An Thịnh, Huyện Văn Yên, Tỉnh Yên Bái","code":"04417","parent_code":"136"},"04420":{"name":"Xã Yên Thái","type":"xa","slug":"xa-yen-thai","name_with_type":"Xã Yên Thái","path":"Xã Yên Thái, Huyện Văn Yên, Tỉnh Yên Bái","path_with_type":"Xã Yên Thái, Huyện Văn Yên, Tỉnh Yên Bái","code":"04420","parent_code":"136"},"04423":{"name":"Xã Phong Dụ Thượng","type":"xa","slug":"xa-phong-du-thuong","name_with_type":"Xã Phong Dụ Thượng","path":"Xã Phong Dụ Thượng, Huyện Văn Yên, Tỉnh Yên Bái","path_with_type":"Xã Phong Dụ Thượng, Huyện Văn Yên, Tỉnh Yên Bái","code":"04423","parent_code":"136"},"04426":{"name":"Xã Yên Hợp","type":"xa","slug":"xa-yen-hop","name_with_type":"Xã Yên Hợp","path":"Xã Yên Hợp, Huyện Văn Yên, Tỉnh Yên Bái","path_with_type":"Xã Yên Hợp, Huyện Văn Yên, Tỉnh Yên Bái","code":"04426","parent_code":"136"},"04429":{"name":"Xã Đại Sơn","type":"xa","slug":"xa-dai-son","name_with_type":"Xã Đại Sơn","path":"Xã Đại Sơn, Huyện Văn Yên, Tỉnh Yên Bái","path_with_type":"Xã Đại Sơn, Huyện Văn Yên, Tỉnh Yên Bái","code":"04429","parent_code":"136"},"04435":{"name":"Xã Đại Phác","type":"xa","slug":"xa-dai-phac","name_with_type":"Xã Đại Phác","path":"Xã Đại Phác, Huyện Văn Yên, Tỉnh Yên Bái","path_with_type":"Xã Đại Phác, Huyện Văn Yên, Tỉnh Yên Bái","code":"04435","parent_code":"136"},"04438":{"name":"Xã Yên Phú","type":"xa","slug":"xa-yen-phu","name_with_type":"Xã Yên Phú","path":"Xã Yên Phú, Huyện Văn Yên, Tỉnh Yên Bái","path_with_type":"Xã Yên Phú, Huyện Văn Yên, Tỉnh Yên Bái","code":"04438","parent_code":"136"},"04441":{"name":"Xã Xuân Ái","type":"xa","slug":"xa-xuan-ai","name_with_type":"Xã Xuân Ái","path":"Xã Xuân Ái, Huyện Văn Yên, Tỉnh Yên Bái","path_with_type":"Xã Xuân Ái, Huyện Văn Yên, Tỉnh Yên Bái","code":"04441","parent_code":"136"},"04447":{"name":"Xã Viễn Sơn","type":"xa","slug":"xa-vien-son","name_with_type":"Xã Viễn Sơn","path":"Xã Viễn Sơn, Huyện Văn Yên, Tỉnh Yên Bái","path_with_type":"Xã Viễn Sơn, Huyện Văn Yên, Tỉnh Yên Bái","code":"04447","parent_code":"136"},"04450":{"name":"Xã Mỏ Vàng","type":"xa","slug":"xa-mo-vang","name_with_type":"Xã Mỏ Vàng","path":"Xã Mỏ Vàng, Huyện Văn Yên, Tỉnh Yên Bái","path_with_type":"Xã Mỏ Vàng, Huyện Văn Yên, Tỉnh Yên Bái","code":"04450","parent_code":"136"},"04453":{"name":"Xã Nà Hẩu","type":"xa","slug":"xa-na-hau","name_with_type":"Xã Nà Hẩu","path":"Xã Nà Hẩu, Huyện Văn Yên, Tỉnh Yên Bái","path_with_type":"Xã Nà Hẩu, Huyện Văn Yên, Tỉnh Yên Bái","code":"04453","parent_code":"136"},"04456":{"name":"Thị trấn Mù Căng Chải","type":"thi-tran","slug":"thi-tran-mu-cang-chai","name_with_type":"Thị trấn Mù Căng Chải","path":"Thị trấn Mù Căng Chải, Huyện Mù Căng Chải, Tỉnh Yên Bái","path_with_type":"Thị trấn Mù Căng Chải, Huyện Mù Căng Chải, Tỉnh Yên Bái","code":"04456","parent_code":"137"},"04459":{"name":"Xã Hồ Bốn","type":"xa","slug":"xa-ho-bon","name_with_type":"Xã Hồ Bốn","path":"Xã Hồ Bốn, Huyện Mù Căng Chải, Tỉnh Yên Bái","path_with_type":"Xã Hồ Bốn, Huyện Mù Căng Chải, Tỉnh Yên Bái","code":"04459","parent_code":"137"},"04462":{"name":"Xã Nậm Có","type":"xa","slug":"xa-nam-co","name_with_type":"Xã Nậm Có","path":"Xã Nậm Có, Huyện Mù Căng Chải, Tỉnh Yên Bái","path_with_type":"Xã Nậm Có, Huyện Mù Căng Chải, Tỉnh Yên Bái","code":"04462","parent_code":"137"},"04465":{"name":"Xã Khao Mang","type":"xa","slug":"xa-khao-mang","name_with_type":"Xã Khao Mang","path":"Xã Khao Mang, Huyện Mù Căng Chải, Tỉnh Yên Bái","path_with_type":"Xã Khao Mang, Huyện Mù Căng Chải, Tỉnh Yên Bái","code":"04465","parent_code":"137"},"04468":{"name":"Xã Mồ Dề","type":"xa","slug":"xa-mo-de","name_with_type":"Xã Mồ Dề","path":"Xã Mồ Dề, Huyện Mù Căng Chải, Tỉnh Yên Bái","path_with_type":"Xã Mồ Dề, Huyện Mù Căng Chải, Tỉnh Yên Bái","code":"04468","parent_code":"137"},"04471":{"name":"Xã Chế Cu Nha","type":"xa","slug":"xa-che-cu-nha","name_with_type":"Xã Chế Cu Nha","path":"Xã Chế Cu Nha, Huyện Mù Căng Chải, Tỉnh Yên Bái","path_with_type":"Xã Chế Cu Nha, Huyện Mù Căng Chải, Tỉnh Yên Bái","code":"04471","parent_code":"137"},"04474":{"name":"Xã Lao Chải","type":"xa","slug":"xa-lao-chai","name_with_type":"Xã Lao Chải","path":"Xã Lao Chải, Huyện Mù Căng Chải, Tỉnh Yên Bái","path_with_type":"Xã Lao Chải, Huyện Mù Căng Chải, Tỉnh Yên Bái","code":"04474","parent_code":"137"},"04477":{"name":"Xã Kim Nọi","type":"xa","slug":"xa-kim-noi","name_with_type":"Xã Kim Nọi","path":"Xã Kim Nọi, Huyện Mù Căng Chải, Tỉnh Yên Bái","path_with_type":"Xã Kim Nọi, Huyện Mù Căng Chải, Tỉnh Yên Bái","code":"04477","parent_code":"137"},"04480":{"name":"Xã Cao Phạ","type":"xa","slug":"xa-cao-pha","name_with_type":"Xã Cao Phạ","path":"Xã Cao Phạ, Huyện Mù Căng Chải, Tỉnh Yên Bái","path_with_type":"Xã Cao Phạ, Huyện Mù Căng Chải, Tỉnh Yên Bái","code":"04480","parent_code":"137"},"04483":{"name":"Xã La Pán Tẩn","type":"xa","slug":"xa-la-pan-tan","name_with_type":"Xã La Pán Tẩn","path":"Xã La Pán Tẩn, Huyện Mù Căng Chải, Tỉnh Yên Bái","path_with_type":"Xã La Pán Tẩn, Huyện Mù Căng Chải, Tỉnh Yên Bái","code":"04483","parent_code":"137"},"04486":{"name":"Xã Dế Su Phình","type":"xa","slug":"xa-de-su-phinh","name_with_type":"Xã Dế Su Phình","path":"Xã Dế Su Phình, Huyện Mù Căng Chải, Tỉnh Yên Bái","path_with_type":"Xã Dế Su Phình, Huyện Mù Căng Chải, Tỉnh Yên Bái","code":"04486","parent_code":"137"},"04489":{"name":"Xã Chế Tạo","type":"xa","slug":"xa-che-tao","name_with_type":"Xã Chế Tạo","path":"Xã Chế Tạo, Huyện Mù Căng Chải, Tỉnh Yên Bái","path_with_type":"Xã Chế Tạo, Huyện Mù Căng Chải, Tỉnh Yên Bái","code":"04489","parent_code":"137"},"04492":{"name":"Xã Púng Luông","type":"xa","slug":"xa-pung-luong","name_with_type":"Xã Púng Luông","path":"Xã Púng Luông, Huyện Mù Căng Chải, Tỉnh Yên Bái","path_with_type":"Xã Púng Luông, Huyện Mù Căng Chải, Tỉnh Yên Bái","code":"04492","parent_code":"137"},"04495":{"name":"Xã Nậm Khắt","type":"xa","slug":"xa-nam-khat","name_with_type":"Xã Nậm Khắt","path":"Xã Nậm Khắt, Huyện Mù Căng Chải, Tỉnh Yên Bái","path_with_type":"Xã Nậm Khắt, Huyện Mù Căng Chải, Tỉnh Yên Bái","code":"04495","parent_code":"137"},"04498":{"name":"Thị trấn Cổ Phúc","type":"thi-tran","slug":"thi-tran-co-phuc","name_with_type":"Thị trấn Cổ Phúc","path":"Thị trấn Cổ Phúc, Huyện Trấn Yên, Tỉnh Yên Bái","path_with_type":"Thị trấn Cổ Phúc, Huyện Trấn Yên, Tỉnh Yên Bái","code":"04498","parent_code":"138"},"04501":{"name":"Xã Tân Đồng","type":"xa","slug":"xa-tan-dong","name_with_type":"Xã Tân Đồng","path":"Xã Tân Đồng, Huyện Trấn Yên, Tỉnh Yên Bái","path_with_type":"Xã Tân Đồng, Huyện Trấn Yên, Tỉnh Yên Bái","code":"04501","parent_code":"138"},"04504":{"name":"Xã Báo Đáp","type":"xa","slug":"xa-bao-dap","name_with_type":"Xã Báo Đáp","path":"Xã Báo Đáp, Huyện Trấn Yên, Tỉnh Yên Bái","path_with_type":"Xã Báo Đáp, Huyện Trấn Yên, Tỉnh Yên Bái","code":"04504","parent_code":"138"},"04510":{"name":"Xã Thành Thịnh","type":"xa","slug":"xa-thanh-thinh","name_with_type":"Xã Thành Thịnh","path":"Xã Thành Thịnh, Huyện Trấn Yên, Tỉnh Yên Bái","path_with_type":"Xã Thành Thịnh, Huyện Trấn Yên, Tỉnh Yên Bái","code":"04510","parent_code":"138"},"04513":{"name":"Xã Hòa Cuông","type":"xa","slug":"xa-hoa-cuong","name_with_type":"Xã Hòa Cuông","path":"Xã Hòa Cuông, Huyện Trấn Yên, Tỉnh Yên Bái","path_with_type":"Xã Hòa Cuông, Huyện Trấn Yên, Tỉnh Yên Bái","code":"04513","parent_code":"138"},"04516":{"name":"Xã Minh Quán","type":"xa","slug":"xa-minh-quan","name_with_type":"Xã Minh Quán","path":"Xã Minh Quán, Huyện Trấn Yên, Tỉnh Yên Bái","path_with_type":"Xã Minh Quán, Huyện Trấn Yên, Tỉnh Yên Bái","code":"04516","parent_code":"138"},"04519":{"name":"Xã Quy Mông","type":"xa","slug":"xa-quy-mong","name_with_type":"Xã Quy Mông","path":"Xã Quy Mông, Huyện Trấn Yên, Tỉnh Yên Bái","path_with_type":"Xã Quy Mông, Huyện Trấn Yên, Tỉnh Yên Bái","code":"04519","parent_code":"138"},"04522":{"name":"Xã Cường Thịnh","type":"xa","slug":"xa-cuong-thinh","name_with_type":"Xã Cường Thịnh","path":"Xã Cường Thịnh, Huyện Trấn Yên, Tỉnh Yên Bái","path_with_type":"Xã Cường Thịnh, Huyện Trấn Yên, Tỉnh Yên Bái","code":"04522","parent_code":"138"},"04525":{"name":"Xã Kiên Thành","type":"xa","slug":"xa-kien-thanh","name_with_type":"Xã Kiên Thành","path":"Xã Kiên Thành, Huyện Trấn Yên, Tỉnh Yên Bái","path_with_type":"Xã Kiên Thành, Huyện Trấn Yên, Tỉnh Yên Bái","code":"04525","parent_code":"138"},"04531":{"name":"Xã Y Can","type":"xa","slug":"xa-y-can","name_with_type":"Xã Y Can","path":"Xã Y Can, Huyện Trấn Yên, Tỉnh Yên Bái","path_with_type":"Xã Y Can, Huyện Trấn Yên, Tỉnh Yên Bái","code":"04531","parent_code":"138"},"04537":{"name":"Xã Lương Thịnh","type":"xa","slug":"xa-luong-thinh","name_with_type":"Xã Lương Thịnh","path":"Xã Lương Thịnh, Huyện Trấn Yên, Tỉnh Yên Bái","path_with_type":"Xã Lương Thịnh, Huyện Trấn Yên, Tỉnh Yên Bái","code":"04537","parent_code":"138"},"04564":{"name":"Xã Việt Cường","type":"xa","slug":"xa-viet-cuong","name_with_type":"Xã Việt Cường","path":"Xã Việt Cường, Huyện Trấn Yên, Tỉnh Yên Bái","path_with_type":"Xã Việt Cường, Huyện Trấn Yên, Tỉnh Yên Bái","code":"04564","parent_code":"138"},"04567":{"name":"Xã Minh Quân","type":"xa","slug":"xa-minh-quan","name_with_type":"Xã Minh Quân","path":"Xã Minh Quân, Huyện Trấn Yên, Tỉnh Yên Bái","path_with_type":"Xã Minh Quân, Huyện Trấn Yên, Tỉnh Yên Bái","code":"04567","parent_code":"138"},"04570":{"name":"Xã Hồng Ca","type":"xa","slug":"xa-hong-ca","name_with_type":"Xã Hồng Ca","path":"Xã Hồng Ca, Huyện Trấn Yên, Tỉnh Yên Bái","path_with_type":"Xã Hồng Ca, Huyện Trấn Yên, Tỉnh Yên Bái","code":"04570","parent_code":"138"},"04573":{"name":"Xã Hưng Thịnh","type":"xa","slug":"xa-hung-thinh","name_with_type":"Xã Hưng Thịnh","path":"Xã Hưng Thịnh, Huyện Trấn Yên, Tỉnh Yên Bái","path_with_type":"Xã Hưng Thịnh, Huyện Trấn Yên, Tỉnh Yên Bái","code":"04573","parent_code":"138"},"04576":{"name":"Xã Hưng Khánh","type":"xa","slug":"xa-hung-khanh","name_with_type":"Xã Hưng Khánh","path":"Xã Hưng Khánh, Huyện Trấn Yên, Tỉnh Yên Bái","path_with_type":"Xã Hưng Khánh, Huyện Trấn Yên, Tỉnh Yên Bái","code":"04576","parent_code":"138"},"04579":{"name":"Xã Việt Hồng","type":"xa","slug":"xa-viet-hong","name_with_type":"Xã Việt Hồng","path":"Xã Việt Hồng, Huyện Trấn Yên, Tỉnh Yên Bái","path_with_type":"Xã Việt Hồng, Huyện Trấn Yên, Tỉnh Yên Bái","code":"04579","parent_code":"138"},"04582":{"name":"Xã Vân Hội","type":"xa","slug":"xa-van-hoi","name_with_type":"Xã Vân Hội","path":"Xã Vân Hội, Huyện Trấn Yên, Tỉnh Yên Bái","path_with_type":"Xã Vân Hội, Huyện Trấn Yên, Tỉnh Yên Bái","code":"04582","parent_code":"138"},"04585":{"name":"Thị trấn Trạm Tấu","type":"thi-tran","slug":"thi-tran-tram-tau","name_with_type":"Thị trấn Trạm Tấu","path":"Thị trấn Trạm Tấu, Huyện Trạm Tấu, Tỉnh Yên Bái","path_with_type":"Thị trấn Trạm Tấu, Huyện Trạm Tấu, Tỉnh Yên Bái","code":"04585","parent_code":"139"},"04588":{"name":"Xã Túc Đán","type":"xa","slug":"xa-tuc-dan","name_with_type":"Xã Túc Đán","path":"Xã Túc Đán, Huyện Trạm Tấu, Tỉnh Yên Bái","path_with_type":"Xã Túc Đán, Huyện Trạm Tấu, Tỉnh Yên Bái","code":"04588","parent_code":"139"},"04591":{"name":"Xã Pá Lau","type":"xa","slug":"xa-pa-lau","name_with_type":"Xã Pá Lau","path":"Xã Pá Lau, Huyện Trạm Tấu, Tỉnh Yên Bái","path_with_type":"Xã Pá Lau, Huyện Trạm Tấu, Tỉnh Yên Bái","code":"04591","parent_code":"139"},"04594":{"name":"Xã Xà Hồ","type":"xa","slug":"xa-xa-ho","name_with_type":"Xã Xà Hồ","path":"Xã Xà Hồ, Huyện Trạm Tấu, Tỉnh Yên Bái","path_with_type":"Xã Xà Hồ, Huyện Trạm Tấu, Tỉnh Yên Bái","code":"04594","parent_code":"139"},"04597":{"name":"Xã Phình Hồ","type":"xa","slug":"xa-phinh-ho","name_with_type":"Xã Phình Hồ","path":"Xã Phình Hồ, Huyện Trạm Tấu, Tỉnh Yên Bái","path_with_type":"Xã Phình Hồ, Huyện Trạm Tấu, Tỉnh Yên Bái","code":"04597","parent_code":"139"},"04600":{"name":"Xã Trạm Tấu","type":"xa","slug":"xa-tram-tau","name_with_type":"Xã Trạm Tấu","path":"Xã Trạm Tấu, Huyện Trạm Tấu, Tỉnh Yên Bái","path_with_type":"Xã Trạm Tấu, Huyện Trạm Tấu, Tỉnh Yên Bái","code":"04600","parent_code":"139"},"04603":{"name":"Xã Tà Si Láng","type":"xa","slug":"xa-ta-si-lang","name_with_type":"Xã Tà Si Láng","path":"Xã Tà Si Láng, Huyện Trạm Tấu, Tỉnh Yên Bái","path_with_type":"Xã Tà Si Láng, Huyện Trạm Tấu, Tỉnh Yên Bái","code":"04603","parent_code":"139"},"04606":{"name":"Xã Pá Hu","type":"xa","slug":"xa-pa-hu","name_with_type":"Xã Pá Hu","path":"Xã Pá Hu, Huyện Trạm Tấu, Tỉnh Yên Bái","path_with_type":"Xã Pá Hu, Huyện Trạm Tấu, Tỉnh Yên Bái","code":"04606","parent_code":"139"},"04609":{"name":"Xã Làng Nhì","type":"xa","slug":"xa-lang-nhi","name_with_type":"Xã Làng Nhì","path":"Xã Làng Nhì, Huyện Trạm Tấu, Tỉnh Yên Bái","path_with_type":"Xã Làng Nhì, Huyện Trạm Tấu, Tỉnh Yên Bái","code":"04609","parent_code":"139"},"04612":{"name":"Xã Bản Công","type":"xa","slug":"xa-ban-cong","name_with_type":"Xã Bản Công","path":"Xã Bản Công, Huyện Trạm Tấu, Tỉnh Yên Bái","path_with_type":"Xã Bản Công, Huyện Trạm Tấu, Tỉnh Yên Bái","code":"04612","parent_code":"139"},"04615":{"name":"Xã Bản Mù","type":"xa","slug":"xa-ban-mu","name_with_type":"Xã Bản Mù","path":"Xã Bản Mù, Huyện Trạm Tấu, Tỉnh Yên Bái","path_with_type":"Xã Bản Mù, Huyện Trạm Tấu, Tỉnh Yên Bái","code":"04615","parent_code":"139"},"04618":{"name":"Xã Hát Lìu","type":"xa","slug":"xa-hat-liu","name_with_type":"Xã Hát Lìu","path":"Xã Hát Lìu, Huyện Trạm Tấu, Tỉnh Yên Bái","path_with_type":"Xã Hát Lìu, Huyện Trạm Tấu, Tỉnh Yên Bái","code":"04618","parent_code":"139"},"04621":{"name":"Thị trấn NT Liên Sơn","type":"thi-tran","slug":"thi-tran-nt-lien-son","name_with_type":"Thị trấn NT Liên Sơn","path":"Thị trấn NT Liên Sơn, Huyện Văn Chấn, Tỉnh Yên Bái","path_with_type":"Thị trấn NT Liên Sơn, Huyện Văn Chấn, Tỉnh Yên Bái","code":"04621","parent_code":"140"},"04627":{"name":"Thị trấn NT Trần Phú","type":"thi-tran","slug":"thi-tran-nt-tran-phu","name_with_type":"Thị trấn NT Trần Phú","path":"Thị trấn NT Trần Phú, Huyện Văn Chấn, Tỉnh Yên Bái","path_with_type":"Thị trấn NT Trần Phú, Huyện Văn Chấn, Tỉnh Yên Bái","code":"04627","parent_code":"140"},"04630":{"name":"Xã Tú Lệ","type":"xa","slug":"xa-tu-le","name_with_type":"Xã Tú Lệ","path":"Xã Tú Lệ, Huyện Văn Chấn, Tỉnh Yên Bái","path_with_type":"Xã Tú Lệ, Huyện Văn Chấn, Tỉnh Yên Bái","code":"04630","parent_code":"140"},"04633":{"name":"Xã Nậm Búng","type":"xa","slug":"xa-nam-bung","name_with_type":"Xã Nậm Búng","path":"Xã Nậm Búng, Huyện Văn Chấn, Tỉnh Yên Bái","path_with_type":"Xã Nậm Búng, Huyện Văn Chấn, Tỉnh Yên Bái","code":"04633","parent_code":"140"},"04636":{"name":"Xã Gia Hội","type":"xa","slug":"xa-gia-hoi","name_with_type":"Xã Gia Hội","path":"Xã Gia Hội, Huyện Văn Chấn, Tỉnh Yên Bái","path_with_type":"Xã Gia Hội, Huyện Văn Chấn, Tỉnh Yên Bái","code":"04636","parent_code":"140"},"04639":{"name":"Xã Sùng Đô","type":"xa","slug":"xa-sung-do","name_with_type":"Xã Sùng Đô","path":"Xã Sùng Đô, Huyện Văn Chấn, Tỉnh Yên Bái","path_with_type":"Xã Sùng Đô, Huyện Văn Chấn, Tỉnh Yên Bái","code":"04639","parent_code":"140"},"04642":{"name":"Xã Nậm Mười","type":"xa","slug":"xa-nam-muoi","name_with_type":"Xã Nậm Mười","path":"Xã Nậm Mười, Huyện Văn Chấn, Tỉnh Yên Bái","path_with_type":"Xã Nậm Mười, Huyện Văn Chấn, Tỉnh Yên Bái","code":"04642","parent_code":"140"},"04645":{"name":"Xã An Lương","type":"xa","slug":"xa-an-luong","name_with_type":"Xã An Lương","path":"Xã An Lương, Huyện Văn Chấn, Tỉnh Yên Bái","path_with_type":"Xã An Lương, Huyện Văn Chấn, Tỉnh Yên Bái","code":"04645","parent_code":"140"},"04648":{"name":"Xã Nậm Lành","type":"xa","slug":"xa-nam-lanh","name_with_type":"Xã Nậm Lành","path":"Xã Nậm Lành, Huyện Văn Chấn, Tỉnh Yên Bái","path_with_type":"Xã Nậm Lành, Huyện Văn Chấn, Tỉnh Yên Bái","code":"04648","parent_code":"140"},"04651":{"name":"Xã Sơn Lương","type":"xa","slug":"xa-son-luong","name_with_type":"Xã Sơn Lương","path":"Xã Sơn Lương, Huyện Văn Chấn, Tỉnh Yên Bái","path_with_type":"Xã Sơn Lương, Huyện Văn Chấn, Tỉnh Yên Bái","code":"04651","parent_code":"140"},"04654":{"name":"Xã Suối Quyền","type":"xa","slug":"xa-suoi-quyen","name_with_type":"Xã Suối Quyền","path":"Xã Suối Quyền, Huyện Văn Chấn, Tỉnh Yên Bái","path_with_type":"Xã Suối Quyền, Huyện Văn Chấn, Tỉnh Yên Bái","code":"04654","parent_code":"140"},"04657":{"name":"Xã Suối Giàng","type":"xa","slug":"xa-suoi-giang","name_with_type":"Xã Suối Giàng","path":"Xã Suối Giàng, Huyện Văn Chấn, Tỉnh Yên Bái","path_with_type":"Xã Suối Giàng, Huyện Văn Chấn, Tỉnh Yên Bái","code":"04657","parent_code":"140"},"04666":{"name":"Xã Nghĩa Sơn","type":"xa","slug":"xa-nghia-son","name_with_type":"Xã Nghĩa Sơn","path":"Xã Nghĩa Sơn, Huyện Văn Chấn, Tỉnh Yên Bái","path_with_type":"Xã Nghĩa Sơn, Huyện Văn Chấn, Tỉnh Yên Bái","code":"04666","parent_code":"140"},"04669":{"name":"Xã Suối Bu","type":"xa","slug":"xa-suoi-bu","name_with_type":"Xã Suối Bu","path":"Xã Suối Bu, Huyện Văn Chấn, Tỉnh Yên Bái","path_with_type":"Xã Suối Bu, Huyện Văn Chấn, Tỉnh Yên Bái","code":"04669","parent_code":"140"},"04672":{"name":"Thị trấn Sơn Thịnh","type":"thi-tran","slug":"thi-tran-son-thinh","name_with_type":"Thị trấn Sơn Thịnh","path":"Thị trấn Sơn Thịnh, Huyện Văn Chấn, Tỉnh Yên Bái","path_with_type":"Thị trấn Sơn Thịnh, Huyện Văn Chấn, Tỉnh Yên Bái","code":"04672","parent_code":"140"},"04687":{"name":"Xã Đại Lịch","type":"xa","slug":"xa-dai-lich","name_with_type":"Xã Đại Lịch","path":"Xã Đại Lịch, Huyện Văn Chấn, Tỉnh Yên Bái","path_with_type":"Xã Đại Lịch, Huyện Văn Chấn, Tỉnh Yên Bái","code":"04687","parent_code":"140"},"04690":{"name":"Xã Đồng Khê","type":"xa","slug":"xa-dong-khe","name_with_type":"Xã Đồng Khê","path":"Xã Đồng Khê, Huyện Văn Chấn, Tỉnh Yên Bái","path_with_type":"Xã Đồng Khê, Huyện Văn Chấn, Tỉnh Yên Bái","code":"04690","parent_code":"140"},"04693":{"name":"Xã Cát Thịnh","type":"xa","slug":"xa-cat-thinh","name_with_type":"Xã Cát Thịnh","path":"Xã Cát Thịnh, Huyện Văn Chấn, Tỉnh Yên Bái","path_with_type":"Xã Cát Thịnh, Huyện Văn Chấn, Tỉnh Yên Bái","code":"04693","parent_code":"140"},"04696":{"name":"Xã Tân Thịnh","type":"xa","slug":"xa-tan-thinh","name_with_type":"Xã Tân Thịnh","path":"Xã Tân Thịnh, Huyện Văn Chấn, Tỉnh Yên Bái","path_with_type":"Xã Tân Thịnh, Huyện Văn Chấn, Tỉnh Yên Bái","code":"04696","parent_code":"140"},"04699":{"name":"Xã Chấn Thịnh","type":"xa","slug":"xa-chan-thinh","name_with_type":"Xã Chấn Thịnh","path":"Xã Chấn Thịnh, Huyện Văn Chấn, Tỉnh Yên Bái","path_with_type":"Xã Chấn Thịnh, Huyện Văn Chấn, Tỉnh Yên Bái","code":"04699","parent_code":"140"},"04702":{"name":"Xã Bình Thuận","type":"xa","slug":"xa-binh-thuan","name_with_type":"Xã Bình Thuận","path":"Xã Bình Thuận, Huyện Văn Chấn, Tỉnh Yên Bái","path_with_type":"Xã Bình Thuận, Huyện Văn Chấn, Tỉnh Yên Bái","code":"04702","parent_code":"140"},"04705":{"name":"Xã Thượng Bằng La","type":"xa","slug":"xa-thuong-bang-la","name_with_type":"Xã Thượng Bằng La","path":"Xã Thượng Bằng La, Huyện Văn Chấn, Tỉnh Yên Bái","path_with_type":"Xã Thượng Bằng La, Huyện Văn Chấn, Tỉnh Yên Bái","code":"04705","parent_code":"140"},"04708":{"name":"Xã Minh An","type":"xa","slug":"xa-minh-an","name_with_type":"Xã Minh An","path":"Xã Minh An, Huyện Văn Chấn, Tỉnh Yên Bái","path_with_type":"Xã Minh An, Huyện Văn Chấn, Tỉnh Yên Bái","code":"04708","parent_code":"140"},"04711":{"name":"Xã Nghĩa Tâm","type":"xa","slug":"xa-nghia-tam","name_with_type":"Xã Nghĩa Tâm","path":"Xã Nghĩa Tâm, Huyện Văn Chấn, Tỉnh Yên Bái","path_with_type":"Xã Nghĩa Tâm, Huyện Văn Chấn, Tỉnh Yên Bái","code":"04711","parent_code":"140"},"04714":{"name":"Thị trấn Yên Bình","type":"thi-tran","slug":"thi-tran-yen-binh","name_with_type":"Thị trấn Yên Bình","path":"Thị trấn Yên Bình, Huyện Yên Bình, Tỉnh Yên Bái","path_with_type":"Thị trấn Yên Bình, Huyện Yên Bình, Tỉnh Yên Bái","code":"04714","parent_code":"141"},"04717":{"name":"Thị trấn Thác Bà","type":"thi-tran","slug":"thi-tran-thac-ba","name_with_type":"Thị trấn Thác Bà","path":"Thị trấn Thác Bà, Huyện Yên Bình, Tỉnh Yên Bái","path_with_type":"Thị trấn Thác Bà, Huyện Yên Bình, Tỉnh Yên Bái","code":"04717","parent_code":"141"},"04720":{"name":"Xã Xuân Long","type":"xa","slug":"xa-xuan-long","name_with_type":"Xã Xuân Long","path":"Xã Xuân Long, Huyện Yên Bình, Tỉnh Yên Bái","path_with_type":"Xã Xuân Long, Huyện Yên Bình, Tỉnh Yên Bái","code":"04720","parent_code":"141"},"04726":{"name":"Xã Cảm Nhân","type":"xa","slug":"xa-cam-nhan","name_with_type":"Xã Cảm Nhân","path":"Xã Cảm Nhân, Huyện Yên Bình, Tỉnh Yên Bái","path_with_type":"Xã Cảm Nhân, Huyện Yên Bình, Tỉnh Yên Bái","code":"04726","parent_code":"141"},"04729":{"name":"Xã Ngọc Chấn","type":"xa","slug":"xa-ngoc-chan","name_with_type":"Xã Ngọc Chấn","path":"Xã Ngọc Chấn, Huyện Yên Bình, Tỉnh Yên Bái","path_with_type":"Xã Ngọc Chấn, Huyện Yên Bình, Tỉnh Yên Bái","code":"04729","parent_code":"141"},"04732":{"name":"Xã Tân Nguyên","type":"xa","slug":"xa-tan-nguyen","name_with_type":"Xã Tân Nguyên","path":"Xã Tân Nguyên, Huyện Yên Bình, Tỉnh Yên Bái","path_with_type":"Xã Tân Nguyên, Huyện Yên Bình, Tỉnh Yên Bái","code":"04732","parent_code":"141"},"04735":{"name":"Xã Phúc Ninh","type":"xa","slug":"xa-phuc-ninh","name_with_type":"Xã Phúc Ninh","path":"Xã Phúc Ninh, Huyện Yên Bình, Tỉnh Yên Bái","path_with_type":"Xã Phúc Ninh, Huyện Yên Bình, Tỉnh Yên Bái","code":"04735","parent_code":"141"},"04738":{"name":"Xã Bảo Ái","type":"xa","slug":"xa-bao-ai","name_with_type":"Xã Bảo Ái","path":"Xã Bảo Ái, Huyện Yên Bình, Tỉnh Yên Bái","path_with_type":"Xã Bảo Ái, Huyện Yên Bình, Tỉnh Yên Bái","code":"04738","parent_code":"141"},"04741":{"name":"Xã Mỹ Gia","type":"xa","slug":"xa-my-gia","name_with_type":"Xã Mỹ Gia","path":"Xã Mỹ Gia, Huyện Yên Bình, Tỉnh Yên Bái","path_with_type":"Xã Mỹ Gia, Huyện Yên Bình, Tỉnh Yên Bái","code":"04741","parent_code":"141"},"04744":{"name":"Xã Xuân Lai","type":"xa","slug":"xa-xuan-lai","name_with_type":"Xã Xuân Lai","path":"Xã Xuân Lai, Huyện Yên Bình, Tỉnh Yên Bái","path_with_type":"Xã Xuân Lai, Huyện Yên Bình, Tỉnh Yên Bái","code":"04744","parent_code":"141"},"04747":{"name":"Xã Mông Sơn","type":"xa","slug":"xa-mong-son","name_with_type":"Xã Mông Sơn","path":"Xã Mông Sơn, Huyện Yên Bình, Tỉnh Yên Bái","path_with_type":"Xã Mông Sơn, Huyện Yên Bình, Tỉnh Yên Bái","code":"04747","parent_code":"141"},"04750":{"name":"Xã Cảm Ân","type":"xa","slug":"xa-cam-an","name_with_type":"Xã Cảm Ân","path":"Xã Cảm Ân, Huyện Yên Bình, Tỉnh Yên Bái","path_with_type":"Xã Cảm Ân, Huyện Yên Bình, Tỉnh Yên Bái","code":"04750","parent_code":"141"},"04753":{"name":"Xã Yên Thành","type":"xa","slug":"xa-yen-thanh","name_with_type":"Xã Yên Thành","path":"Xã Yên Thành, Huyện Yên Bình, Tỉnh Yên Bái","path_with_type":"Xã Yên Thành, Huyện Yên Bình, Tỉnh Yên Bái","code":"04753","parent_code":"141"},"04756":{"name":"Xã Tân Hương","type":"xa","slug":"xa-tan-huong","name_with_type":"Xã Tân Hương","path":"Xã Tân Hương, Huyện Yên Bình, Tỉnh Yên Bái","path_with_type":"Xã Tân Hương, Huyện Yên Bình, Tỉnh Yên Bái","code":"04756","parent_code":"141"},"04759":{"name":"Xã Phúc An","type":"xa","slug":"xa-phuc-an","name_with_type":"Xã Phúc An","path":"Xã Phúc An, Huyện Yên Bình, Tỉnh Yên Bái","path_with_type":"Xã Phúc An, Huyện Yên Bình, Tỉnh Yên Bái","code":"04759","parent_code":"141"},"04762":{"name":"Xã Bạch Hà","type":"xa","slug":"xa-bach-ha","name_with_type":"Xã Bạch Hà","path":"Xã Bạch Hà, Huyện Yên Bình, Tỉnh Yên Bái","path_with_type":"Xã Bạch Hà, Huyện Yên Bình, Tỉnh Yên Bái","code":"04762","parent_code":"141"},"04765":{"name":"Xã Vũ Linh","type":"xa","slug":"xa-vu-linh","name_with_type":"Xã Vũ Linh","path":"Xã Vũ Linh, Huyện Yên Bình, Tỉnh Yên Bái","path_with_type":"Xã Vũ Linh, Huyện Yên Bình, Tỉnh Yên Bái","code":"04765","parent_code":"141"},"04768":{"name":"Xã Đại Đồng","type":"xa","slug":"xa-dai-dong","name_with_type":"Xã Đại Đồng","path":"Xã Đại Đồng, Huyện Yên Bình, Tỉnh Yên Bái","path_with_type":"Xã Đại Đồng, Huyện Yên Bình, Tỉnh Yên Bái","code":"04768","parent_code":"141"},"04771":{"name":"Xã Vĩnh Kiên","type":"xa","slug":"xa-vinh-kien","name_with_type":"Xã Vĩnh Kiên","path":"Xã Vĩnh Kiên, Huyện Yên Bình, Tỉnh Yên Bái","path_with_type":"Xã Vĩnh Kiên, Huyện Yên Bình, Tỉnh Yên Bái","code":"04771","parent_code":"141"},"04777":{"name":"Xã Thịnh Hưng","type":"xa","slug":"xa-thinh-hung","name_with_type":"Xã Thịnh Hưng","path":"Xã Thịnh Hưng, Huyện Yên Bình, Tỉnh Yên Bái","path_with_type":"Xã Thịnh Hưng, Huyện Yên Bình, Tỉnh Yên Bái","code":"04777","parent_code":"141"},"04780":{"name":"Xã Hán Đà","type":"xa","slug":"xa-han-da","name_with_type":"Xã Hán Đà","path":"Xã Hán Đà, Huyện Yên Bình, Tỉnh Yên Bái","path_with_type":"Xã Hán Đà, Huyện Yên Bình, Tỉnh Yên Bái","code":"04780","parent_code":"141"},"04783":{"name":"Xã Phú Thịnh","type":"xa","slug":"xa-phu-thinh","name_with_type":"Xã Phú Thịnh","path":"Xã Phú Thịnh, Huyện Yên Bình, Tỉnh Yên Bái","path_with_type":"Xã Phú Thịnh, Huyện Yên Bình, Tỉnh Yên Bái","code":"04783","parent_code":"141"},"04786":{"name":"Xã Đại Minh","type":"xa","slug":"xa-dai-minh","name_with_type":"Xã Đại Minh","path":"Xã Đại Minh, Huyện Yên Bình, Tỉnh Yên Bái","path_with_type":"Xã Đại Minh, Huyện Yên Bình, Tỉnh Yên Bái","code":"04786","parent_code":"141"},"04789":{"name":"Phường Thái Bình","type":"phuong","slug":"phuong-thai-binh","name_with_type":"Phường Thái Bình","path":"Phường Thái Bình, Thành phố Hòa Bình, Tỉnh Hoà Bình","path_with_type":"Phường Thái Bình, Thành phố Hòa Bình, Tỉnh Hoà Bình","code":"04789","parent_code":"148"},"04792":{"name":"Phường Tân Hòa","type":"phuong","slug":"phuong-tan-hoa","name_with_type":"Phường Tân Hòa","path":"Phường Tân Hòa, Thành phố Hòa Bình, Tỉnh Hoà Bình","path_with_type":"Phường Tân Hòa, Thành phố Hòa Bình, Tỉnh Hoà Bình","code":"04792","parent_code":"148"},"04795":{"name":"Phường Thịnh Lang","type":"phuong","slug":"phuong-thinh-lang","name_with_type":"Phường Thịnh Lang","path":"Phường Thịnh Lang, Thành phố Hòa Bình, Tỉnh Hoà Bình","path_with_type":"Phường Thịnh Lang, Thành phố Hòa Bình, Tỉnh Hoà Bình","code":"04795","parent_code":"148"},"04798":{"name":"Phường Hữu Nghị","type":"phuong","slug":"phuong-huu-nghi","name_with_type":"Phường Hữu Nghị","path":"Phường Hữu Nghị, Thành phố Hòa Bình, Tỉnh Hoà Bình","path_with_type":"Phường Hữu Nghị, Thành phố Hòa Bình, Tỉnh Hoà Bình","code":"04798","parent_code":"148"},"04801":{"name":"Phường Tân Thịnh","type":"phuong","slug":"phuong-tan-thinh","name_with_type":"Phường Tân Thịnh","path":"Phường Tân Thịnh, Thành phố Hòa Bình, Tỉnh Hoà Bình","path_with_type":"Phường Tân Thịnh, Thành phố Hòa Bình, Tỉnh Hoà Bình","code":"04801","parent_code":"148"},"04804":{"name":"Phường Đồng Tiến","type":"phuong","slug":"phuong-dong-tien","name_with_type":"Phường Đồng Tiến","path":"Phường Đồng Tiến, Thành phố Hòa Bình, Tỉnh Hoà Bình","path_with_type":"Phường Đồng Tiến, Thành phố Hòa Bình, Tỉnh Hoà Bình","code":"04804","parent_code":"148"},"04807":{"name":"Phường Phương Lâm","type":"phuong","slug":"phuong-phuong-lam","name_with_type":"Phường Phương Lâm","path":"Phường Phương Lâm, Thành phố Hòa Bình, Tỉnh Hoà Bình","path_with_type":"Phường Phương Lâm, Thành phố Hòa Bình, Tỉnh Hoà Bình","code":"04807","parent_code":"148"},"04813":{"name":"Xã Yên Mông","type":"xa","slug":"xa-yen-mong","name_with_type":"Xã Yên Mông","path":"Xã Yên Mông, Thành phố Hòa Bình, Tỉnh Hoà Bình","path_with_type":"Xã Yên Mông, Thành phố Hòa Bình, Tỉnh Hoà Bình","code":"04813","parent_code":"148"},"04816":{"name":"Phường Quỳnh Lâm","type":"phuong","slug":"phuong-quynh-lam","name_with_type":"Phường Quỳnh Lâm","path":"Phường Quỳnh Lâm, Thành phố Hòa Bình, Tỉnh Hoà Bình","path_with_type":"Phường Quỳnh Lâm, Thành phố Hòa Bình, Tỉnh Hoà Bình","code":"04816","parent_code":"148"},"04819":{"name":"Phường Dân Chủ","type":"phuong","slug":"phuong-dan-chu","name_with_type":"Phường Dân Chủ","path":"Phường Dân Chủ, Thành phố Hòa Bình, Tỉnh Hoà Bình","path_with_type":"Phường Dân Chủ, Thành phố Hòa Bình, Tỉnh Hoà Bình","code":"04819","parent_code":"148"},"04825":{"name":"Xã Hòa Bình","type":"xa","slug":"xa-hoa-binh","name_with_type":"Xã Hòa Bình","path":"Xã Hòa Bình, Thành phố Hòa Bình, Tỉnh Hoà Bình","path_with_type":"Xã Hòa Bình, Thành phố Hòa Bình, Tỉnh Hoà Bình","code":"04825","parent_code":"148"},"04828":{"name":"Phường Thống Nhất","type":"phuong","slug":"phuong-thong-nhat","name_with_type":"Phường Thống Nhất","path":"Phường Thống Nhất, Thành phố Hòa Bình, Tỉnh Hoà Bình","path_with_type":"Phường Thống Nhất, Thành phố Hòa Bình, Tỉnh Hoà Bình","code":"04828","parent_code":"148"},"04894":{"name":"Phường Kỳ Sơn","type":"phuong","slug":"phuong-ky-son","name_with_type":"Phường Kỳ Sơn","path":"Phường Kỳ Sơn, Thành phố Hòa Bình, Tỉnh Hoà Bình","path_with_type":"Phường Kỳ Sơn, Thành phố Hòa Bình, Tỉnh Hoà Bình","code":"04894","parent_code":"148"},"04897":{"name":"Xã Thịnh Minh","type":"xa","slug":"xa-thinh-minh","name_with_type":"Xã Thịnh Minh","path":"Xã Thịnh Minh, Thành phố Hòa Bình, Tỉnh Hoà Bình","path_with_type":"Xã Thịnh Minh, Thành phố Hòa Bình, Tỉnh Hoà Bình","code":"04897","parent_code":"148"},"04903":{"name":"Xã Hợp Thành","type":"xa","slug":"xa-hop-thanh","name_with_type":"Xã Hợp Thành","path":"Xã Hợp Thành, Thành phố Hòa Bình, Tỉnh Hoà Bình","path_with_type":"Xã Hợp Thành, Thành phố Hòa Bình, Tỉnh Hoà Bình","code":"04903","parent_code":"148"},"04906":{"name":"Xã Quang Tiến","type":"xa","slug":"xa-quang-tien","name_with_type":"Xã Quang Tiến","path":"Xã Quang Tiến, Thành phố Hòa Bình, Tỉnh Hoà Bình","path_with_type":"Xã Quang Tiến, Thành phố Hòa Bình, Tỉnh Hoà Bình","code":"04906","parent_code":"148"},"04912":{"name":"Xã Mông Hóa","type":"xa","slug":"xa-mong-hoa","name_with_type":"Xã Mông Hóa","path":"Xã Mông Hóa, Thành phố Hòa Bình, Tỉnh Hoà Bình","path_with_type":"Xã Mông Hóa, Thành phố Hòa Bình, Tỉnh Hoà Bình","code":"04912","parent_code":"148"},"04918":{"name":"Phường Trung Minh","type":"phuong","slug":"phuong-trung-minh","name_with_type":"Phường Trung Minh","path":"Phường Trung Minh, Thành phố Hòa Bình, Tỉnh Hoà Bình","path_with_type":"Phường Trung Minh, Thành phố Hòa Bình, Tỉnh Hoà Bình","code":"04918","parent_code":"148"},"04921":{"name":"Xã Độc Lập","type":"xa","slug":"xa-doc-lap","name_with_type":"Xã Độc Lập","path":"Xã Độc Lập, Thành phố Hòa Bình, Tỉnh Hoà Bình","path_with_type":"Xã Độc Lập, Thành phố Hòa Bình, Tỉnh Hoà Bình","code":"04921","parent_code":"148"},"04831":{"name":"Thị trấn Đà Bắc","type":"thi-tran","slug":"thi-tran-da-bac","name_with_type":"Thị trấn Đà Bắc","path":"Thị trấn Đà Bắc, Huyện Đà Bắc, Tỉnh Hoà Bình","path_with_type":"Thị trấn Đà Bắc, Huyện Đà Bắc, Tỉnh Hoà Bình","code":"04831","parent_code":"150"},"04834":{"name":"Xã Nánh Nghê","type":"xa","slug":"xa-nanh-nghe","name_with_type":"Xã Nánh Nghê","path":"Xã Nánh Nghê, Huyện Đà Bắc, Tỉnh Hoà Bình","path_with_type":"Xã Nánh Nghê, Huyện Đà Bắc, Tỉnh Hoà Bình","code":"04834","parent_code":"150"},"04840":{"name":"Xã Giáp Đắt","type":"xa","slug":"xa-giap-dat","name_with_type":"Xã Giáp Đắt","path":"Xã Giáp Đắt, Huyện Đà Bắc, Tỉnh Hoà Bình","path_with_type":"Xã Giáp Đắt, Huyện Đà Bắc, Tỉnh Hoà Bình","code":"04840","parent_code":"150"},"04846":{"name":"Xã Mường Chiềng","type":"xa","slug":"xa-muong-chieng","name_with_type":"Xã Mường Chiềng","path":"Xã Mường Chiềng, Huyện Đà Bắc, Tỉnh Hoà Bình","path_with_type":"Xã Mường Chiềng, Huyện Đà Bắc, Tỉnh Hoà Bình","code":"04846","parent_code":"150"},"04849":{"name":"Xã Tân Pheo","type":"xa","slug":"xa-tan-pheo","name_with_type":"Xã Tân Pheo","path":"Xã Tân Pheo, Huyện Đà Bắc, Tỉnh Hoà Bình","path_with_type":"Xã Tân Pheo, Huyện Đà Bắc, Tỉnh Hoà Bình","code":"04849","parent_code":"150"},"04852":{"name":"Xã Đồng Chum","type":"xa","slug":"xa-dong-chum","name_with_type":"Xã Đồng Chum","path":"Xã Đồng Chum, Huyện Đà Bắc, Tỉnh Hoà Bình","path_with_type":"Xã Đồng Chum, Huyện Đà Bắc, Tỉnh Hoà Bình","code":"04852","parent_code":"150"},"04855":{"name":"Xã Tân Minh","type":"xa","slug":"xa-tan-minh","name_with_type":"Xã Tân Minh","path":"Xã Tân Minh, Huyện Đà Bắc, Tỉnh Hoà Bình","path_with_type":"Xã Tân Minh, Huyện Đà Bắc, Tỉnh Hoà Bình","code":"04855","parent_code":"150"},"04858":{"name":"Xã Đoàn Kết","type":"xa","slug":"xa-doan-ket","name_with_type":"Xã Đoàn Kết","path":"Xã Đoàn Kết, Huyện Đà Bắc, Tỉnh Hoà Bình","path_with_type":"Xã Đoàn Kết, Huyện Đà Bắc, Tỉnh Hoà Bình","code":"04858","parent_code":"150"},"04861":{"name":"Xã Đồng Ruộng","type":"xa","slug":"xa-dong-ruong","name_with_type":"Xã Đồng Ruộng","path":"Xã Đồng Ruộng, Huyện Đà Bắc, Tỉnh Hoà Bình","path_with_type":"Xã Đồng Ruộng, Huyện Đà Bắc, Tỉnh Hoà Bình","code":"04861","parent_code":"150"},"04867":{"name":"Xã Tú Lý","type":"xa","slug":"xa-tu-ly","name_with_type":"Xã Tú Lý","path":"Xã Tú Lý, Huyện Đà Bắc, Tỉnh Hoà Bình","path_with_type":"Xã Tú Lý, Huyện Đà Bắc, Tỉnh Hoà Bình","code":"04867","parent_code":"150"},"04870":{"name":"Xã Trung Thành","type":"xa","slug":"xa-trung-thanh","name_with_type":"Xã Trung Thành","path":"Xã Trung Thành, Huyện Đà Bắc, Tỉnh Hoà Bình","path_with_type":"Xã Trung Thành, Huyện Đà Bắc, Tỉnh Hoà Bình","code":"04870","parent_code":"150"},"04873":{"name":"Xã Yên Hòa","type":"xa","slug":"xa-yen-hoa","name_with_type":"Xã Yên Hòa","path":"Xã Yên Hòa, Huyện Đà Bắc, Tỉnh Hoà Bình","path_with_type":"Xã Yên Hòa, Huyện Đà Bắc, Tỉnh Hoà Bình","code":"04873","parent_code":"150"},"04876":{"name":"Xã Cao Sơn","type":"xa","slug":"xa-cao-son","name_with_type":"Xã Cao Sơn","path":"Xã Cao Sơn, Huyện Đà Bắc, Tỉnh Hoà Bình","path_with_type":"Xã Cao Sơn, Huyện Đà Bắc, Tỉnh Hoà Bình","code":"04876","parent_code":"150"},"04879":{"name":"Xã Toàn Sơn","type":"xa","slug":"xa-toan-son","name_with_type":"Xã Toàn Sơn","path":"Xã Toàn Sơn, Huyện Đà Bắc, Tỉnh Hoà Bình","path_with_type":"Xã Toàn Sơn, Huyện Đà Bắc, Tỉnh Hoà Bình","code":"04879","parent_code":"150"},"04885":{"name":"Xã Hiền Lương","type":"xa","slug":"xa-hien-luong","name_with_type":"Xã Hiền Lương","path":"Xã Hiền Lương, Huyện Đà Bắc, Tỉnh Hoà Bình","path_with_type":"Xã Hiền Lương, Huyện Đà Bắc, Tỉnh Hoà Bình","code":"04885","parent_code":"150"},"04888":{"name":"Xã Tiền Phong","type":"xa","slug":"xa-tien-phong","name_with_type":"Xã Tiền Phong","path":"Xã Tiền Phong, Huyện Đà Bắc, Tỉnh Hoà Bình","path_with_type":"Xã Tiền Phong, Huyện Đà Bắc, Tỉnh Hoà Bình","code":"04888","parent_code":"150"},"04891":{"name":"Xã Vầy Nưa","type":"xa","slug":"xa-vay-nua","name_with_type":"Xã Vầy Nưa","path":"Xã Vầy Nưa, Huyện Đà Bắc, Tỉnh Hoà Bình","path_with_type":"Xã Vầy Nưa, Huyện Đà Bắc, Tỉnh Hoà Bình","code":"04891","parent_code":"150"},"04924":{"name":"Thị trấn Lương Sơn","type":"thi-tran","slug":"thi-tran-luong-son","name_with_type":"Thị trấn Lương Sơn","path":"Thị trấn Lương Sơn, Huyện Lương Sơn, Tỉnh Hoà Bình","path_with_type":"Thị trấn Lương Sơn, Huyện Lương Sơn, Tỉnh Hoà Bình","code":"04924","parent_code":"152"},"04942":{"name":"Xã Lâm Sơn","type":"xa","slug":"xa-lam-son","name_with_type":"Xã Lâm Sơn","path":"Xã Lâm Sơn, Huyện Lương Sơn, Tỉnh Hoà Bình","path_with_type":"Xã Lâm Sơn, Huyện Lương Sơn, Tỉnh Hoà Bình","code":"04942","parent_code":"152"},"04945":{"name":"Xã Hòa Sơn","type":"xa","slug":"xa-hoa-son","name_with_type":"Xã Hòa Sơn","path":"Xã Hòa Sơn, Huyện Lương Sơn, Tỉnh Hoà Bình","path_with_type":"Xã Hòa Sơn, Huyện Lương Sơn, Tỉnh Hoà Bình","code":"04945","parent_code":"152"},"04951":{"name":"Xã Tân Vinh","type":"xa","slug":"xa-tan-vinh","name_with_type":"Xã Tân Vinh","path":"Xã Tân Vinh, Huyện Lương Sơn, Tỉnh Hoà Bình","path_with_type":"Xã Tân Vinh, Huyện Lương Sơn, Tỉnh Hoà Bình","code":"04951","parent_code":"152"},"04954":{"name":"Xã Nhuận Trạch","type":"xa","slug":"xa-nhuan-trach","name_with_type":"Xã Nhuận Trạch","path":"Xã Nhuận Trạch, Huyện Lương Sơn, Tỉnh Hoà Bình","path_with_type":"Xã Nhuận Trạch, Huyện Lương Sơn, Tỉnh Hoà Bình","code":"04954","parent_code":"152"},"04957":{"name":"Xã Cao Sơn","type":"xa","slug":"xa-cao-son","name_with_type":"Xã Cao Sơn","path":"Xã Cao Sơn, Huyện Lương Sơn, Tỉnh Hoà Bình","path_with_type":"Xã Cao Sơn, Huyện Lương Sơn, Tỉnh Hoà Bình","code":"04957","parent_code":"152"},"04960":{"name":"Xã Cư Yên","type":"xa","slug":"xa-cu-yen","name_with_type":"Xã Cư Yên","path":"Xã Cư Yên, Huyện Lương Sơn, Tỉnh Hoà Bình","path_with_type":"Xã Cư Yên, Huyện Lương Sơn, Tỉnh Hoà Bình","code":"04960","parent_code":"152"},"04969":{"name":"Xã Liên Sơn","type":"xa","slug":"xa-lien-son","name_with_type":"Xã Liên Sơn","path":"Xã Liên Sơn, Huyện Lương Sơn, Tỉnh Hoà Bình","path_with_type":"Xã Liên Sơn, Huyện Lương Sơn, Tỉnh Hoà Bình","code":"04969","parent_code":"152"},"05008":{"name":"Xã Cao Dương","type":"xa","slug":"xa-cao-duong","name_with_type":"Xã Cao Dương","path":"Xã Cao Dương, Huyện Lương Sơn, Tỉnh Hoà Bình","path_with_type":"Xã Cao Dương, Huyện Lương Sơn, Tỉnh Hoà Bình","code":"05008","parent_code":"152"},"05041":{"name":"Xã Thanh Sơn","type":"xa","slug":"xa-thanh-son","name_with_type":"Xã Thanh Sơn","path":"Xã Thanh Sơn, Huyện Lương Sơn, Tỉnh Hoà Bình","path_with_type":"Xã Thanh Sơn, Huyện Lương Sơn, Tỉnh Hoà Bình","code":"05041","parent_code":"152"},"05047":{"name":"Xã Thanh Cao","type":"xa","slug":"xa-thanh-cao","name_with_type":"Xã Thanh Cao","path":"Xã Thanh Cao, Huyện Lương Sơn, Tỉnh Hoà Bình","path_with_type":"Xã Thanh Cao, Huyện Lương Sơn, Tỉnh Hoà Bình","code":"05047","parent_code":"152"},"04978":{"name":"Thị trấn Bo","type":"thi-tran","slug":"thi-tran-bo","name_with_type":"Thị trấn Bo","path":"Thị trấn Bo, Huyện Kim Bôi, Tỉnh Hoà Bình","path_with_type":"Thị trấn Bo, Huyện Kim Bôi, Tỉnh Hoà Bình","code":"04978","parent_code":"153"},"04984":{"name":"Xã Đú Sáng","type":"xa","slug":"xa-du-sang","name_with_type":"Xã Đú Sáng","path":"Xã Đú Sáng, Huyện Kim Bôi, Tỉnh Hoà Bình","path_with_type":"Xã Đú Sáng, Huyện Kim Bôi, Tỉnh Hoà Bình","code":"04984","parent_code":"153"},"04987":{"name":"Xã Hùng Sơn","type":"xa","slug":"xa-hung-son","name_with_type":"Xã Hùng Sơn","path":"Xã Hùng Sơn, Huyện Kim Bôi, Tỉnh Hoà Bình","path_with_type":"Xã Hùng Sơn, Huyện Kim Bôi, Tỉnh Hoà Bình","code":"04987","parent_code":"153"},"04990":{"name":"Xã Bình Sơn","type":"xa","slug":"xa-binh-son","name_with_type":"Xã Bình Sơn","path":"Xã Bình Sơn, Huyện Kim Bôi, Tỉnh Hoà Bình","path_with_type":"Xã Bình Sơn, Huyện Kim Bôi, Tỉnh Hoà Bình","code":"04990","parent_code":"153"},"04999":{"name":"Xã Tú Sơn","type":"xa","slug":"xa-tu-son","name_with_type":"Xã Tú Sơn","path":"Xã Tú Sơn, Huyện Kim Bôi, Tỉnh Hoà Bình","path_with_type":"Xã Tú Sơn, Huyện Kim Bôi, Tỉnh Hoà Bình","code":"04999","parent_code":"153"},"05005":{"name":"Xã Vĩnh Tiến","type":"xa","slug":"xa-vinh-tien","name_with_type":"Xã Vĩnh Tiến","path":"Xã Vĩnh Tiến, Huyện Kim Bôi, Tỉnh Hoà Bình","path_with_type":"Xã Vĩnh Tiến, Huyện Kim Bôi, Tỉnh Hoà Bình","code":"05005","parent_code":"153"},"05014":{"name":"Xã Đông Bắc","type":"xa","slug":"xa-dong-bac","name_with_type":"Xã Đông Bắc","path":"Xã Đông Bắc, Huyện Kim Bôi, Tỉnh Hoà Bình","path_with_type":"Xã Đông Bắc, Huyện Kim Bôi, Tỉnh Hoà Bình","code":"05014","parent_code":"153"},"05017":{"name":"Xã Xuân Thủy","type":"xa","slug":"xa-xuan-thuy","name_with_type":"Xã Xuân Thủy","path":"Xã Xuân Thủy, Huyện Kim Bôi, Tỉnh Hoà Bình","path_with_type":"Xã Xuân Thủy, Huyện Kim Bôi, Tỉnh Hoà Bình","code":"05017","parent_code":"153"},"05026":{"name":"Xã Vĩnh Đồng","type":"xa","slug":"xa-vinh-dong","name_with_type":"Xã Vĩnh Đồng","path":"Xã Vĩnh Đồng, Huyện Kim Bôi, Tỉnh Hoà Bình","path_with_type":"Xã Vĩnh Đồng, Huyện Kim Bôi, Tỉnh Hoà Bình","code":"05026","parent_code":"153"},"05035":{"name":"Xã Kim Lập","type":"xa","slug":"xa-kim-lap","name_with_type":"Xã Kim Lập","path":"Xã Kim Lập, Huyện Kim Bôi, Tỉnh Hoà Bình","path_with_type":"Xã Kim Lập, Huyện Kim Bôi, Tỉnh Hoà Bình","code":"05035","parent_code":"153"},"05038":{"name":"Xã Hợp Tiến","type":"xa","slug":"xa-hop-tien","name_with_type":"Xã Hợp Tiến","path":"Xã Hợp Tiến, Huyện Kim Bôi, Tỉnh Hoà Bình","path_with_type":"Xã Hợp Tiến, Huyện Kim Bôi, Tỉnh Hoà Bình","code":"05038","parent_code":"153"},"05065":{"name":"Xã Kim Bôi","type":"xa","slug":"xa-kim-boi","name_with_type":"Xã Kim Bôi","path":"Xã Kim Bôi, Huyện Kim Bôi, Tỉnh Hoà Bình","path_with_type":"Xã Kim Bôi, Huyện Kim Bôi, Tỉnh Hoà Bình","code":"05065","parent_code":"153"},"05068":{"name":"Xã Nam Thượng","type":"xa","slug":"xa-nam-thuong","name_with_type":"Xã Nam Thượng","path":"Xã Nam Thượng, Huyện Kim Bôi, Tỉnh Hoà Bình","path_with_type":"Xã Nam Thượng, Huyện Kim Bôi, Tỉnh Hoà Bình","code":"05068","parent_code":"153"},"05077":{"name":"Xã Cuối Hạ","type":"xa","slug":"xa-cuoi-ha","name_with_type":"Xã Cuối Hạ","path":"Xã Cuối Hạ, Huyện Kim Bôi, Tỉnh Hoà Bình","path_with_type":"Xã Cuối Hạ, Huyện Kim Bôi, Tỉnh Hoà Bình","code":"05077","parent_code":"153"},"05080":{"name":"Xã Sào Báy","type":"xa","slug":"xa-sao-bay","name_with_type":"Xã Sào Báy","path":"Xã Sào Báy, Huyện Kim Bôi, Tỉnh Hoà Bình","path_with_type":"Xã Sào Báy, Huyện Kim Bôi, Tỉnh Hoà Bình","code":"05080","parent_code":"153"},"05083":{"name":"Xã Mi Hòa","type":"xa","slug":"xa-mi-hoa","name_with_type":"Xã Mi Hòa","path":"Xã Mi Hòa, Huyện Kim Bôi, Tỉnh Hoà Bình","path_with_type":"Xã Mi Hòa, Huyện Kim Bôi, Tỉnh Hoà Bình","code":"05083","parent_code":"153"},"05086":{"name":"Xã Nuông Dăm","type":"xa","slug":"xa-nuong-dam","name_with_type":"Xã Nuông Dăm","path":"Xã Nuông Dăm, Huyện Kim Bôi, Tỉnh Hoà Bình","path_with_type":"Xã Nuông Dăm, Huyện Kim Bôi, Tỉnh Hoà Bình","code":"05086","parent_code":"153"},"05089":{"name":"Thị trấn Cao Phong","type":"thi-tran","slug":"thi-tran-cao-phong","name_with_type":"Thị trấn Cao Phong","path":"Thị trấn Cao Phong, Huyện Cao Phong, Tỉnh Hoà Bình","path_with_type":"Thị trấn Cao Phong, Huyện Cao Phong, Tỉnh Hoà Bình","code":"05089","parent_code":"154"},"05092":{"name":"Xã Bình Thanh","type":"xa","slug":"xa-binh-thanh","name_with_type":"Xã Bình Thanh","path":"Xã Bình Thanh, Huyện Cao Phong, Tỉnh Hoà Bình","path_with_type":"Xã Bình Thanh, Huyện Cao Phong, Tỉnh Hoà Bình","code":"05092","parent_code":"154"},"05095":{"name":"Xã Thung Nai","type":"xa","slug":"xa-thung-nai","name_with_type":"Xã Thung Nai","path":"Xã Thung Nai, Huyện Cao Phong, Tỉnh Hoà Bình","path_with_type":"Xã Thung Nai, Huyện Cao Phong, Tỉnh Hoà Bình","code":"05095","parent_code":"154"},"05098":{"name":"Xã Bắc Phong","type":"xa","slug":"xa-bac-phong","name_with_type":"Xã Bắc Phong","path":"Xã Bắc Phong, Huyện Cao Phong, Tỉnh Hoà Bình","path_with_type":"Xã Bắc Phong, Huyện Cao Phong, Tỉnh Hoà Bình","code":"05098","parent_code":"154"},"05101":{"name":"Xã Thu Phong","type":"xa","slug":"xa-thu-phong","name_with_type":"Xã Thu Phong","path":"Xã Thu Phong, Huyện Cao Phong, Tỉnh Hoà Bình","path_with_type":"Xã Thu Phong, Huyện Cao Phong, Tỉnh Hoà Bình","code":"05101","parent_code":"154"},"05104":{"name":"Xã Hợp Phong","type":"xa","slug":"xa-hop-phong","name_with_type":"Xã Hợp Phong","path":"Xã Hợp Phong, Huyện Cao Phong, Tỉnh Hoà Bình","path_with_type":"Xã Hợp Phong, Huyện Cao Phong, Tỉnh Hoà Bình","code":"05104","parent_code":"154"},"05110":{"name":"Xã Tây Phong","type":"xa","slug":"xa-tay-phong","name_with_type":"Xã Tây Phong","path":"Xã Tây Phong, Huyện Cao Phong, Tỉnh Hoà Bình","path_with_type":"Xã Tây Phong, Huyện Cao Phong, Tỉnh Hoà Bình","code":"05110","parent_code":"154"},"05116":{"name":"Xã Dũng Phong","type":"xa","slug":"xa-dung-phong","name_with_type":"Xã Dũng Phong","path":"Xã Dũng Phong, Huyện Cao Phong, Tỉnh Hoà Bình","path_with_type":"Xã Dũng Phong, Huyện Cao Phong, Tỉnh Hoà Bình","code":"05116","parent_code":"154"},"05119":{"name":"Xã Nam Phong","type":"xa","slug":"xa-nam-phong","name_with_type":"Xã Nam Phong","path":"Xã Nam Phong, Huyện Cao Phong, Tỉnh Hoà Bình","path_with_type":"Xã Nam Phong, Huyện Cao Phong, Tỉnh Hoà Bình","code":"05119","parent_code":"154"},"05125":{"name":"Xã Thạch Yên","type":"xa","slug":"xa-thach-yen","name_with_type":"Xã Thạch Yên","path":"Xã Thạch Yên, Huyện Cao Phong, Tỉnh Hoà Bình","path_with_type":"Xã Thạch Yên, Huyện Cao Phong, Tỉnh Hoà Bình","code":"05125","parent_code":"154"},"05128":{"name":"Thị trấn Mãn Đức","type":"thi-tran","slug":"thi-tran-man-duc","name_with_type":"Thị trấn Mãn Đức","path":"Thị trấn Mãn Đức, Huyện Tân Lạc, Tỉnh Hoà Bình","path_with_type":"Thị trấn Mãn Đức, Huyện Tân Lạc, Tỉnh Hoà Bình","code":"05128","parent_code":"155"},"05134":{"name":"Xã Suối Hoa","type":"xa","slug":"xa-suoi-hoa","name_with_type":"Xã Suối Hoa","path":"Xã Suối Hoa, Huyện Tân Lạc, Tỉnh Hoà Bình","path_with_type":"Xã Suối Hoa, Huyện Tân Lạc, Tỉnh Hoà Bình","code":"05134","parent_code":"155"},"05137":{"name":"Xã Phú Vinh","type":"xa","slug":"xa-phu-vinh","name_with_type":"Xã Phú Vinh","path":"Xã Phú Vinh, Huyện Tân Lạc, Tỉnh Hoà Bình","path_with_type":"Xã Phú Vinh, Huyện Tân Lạc, Tỉnh Hoà Bình","code":"05137","parent_code":"155"},"05140":{"name":"Xã Phú Cường","type":"xa","slug":"xa-phu-cuong","name_with_type":"Xã Phú Cường","path":"Xã Phú Cường, Huyện Tân Lạc, Tỉnh Hoà Bình","path_with_type":"Xã Phú Cường, Huyện Tân Lạc, Tỉnh Hoà Bình","code":"05140","parent_code":"155"},"05143":{"name":"Xã Mỹ Hòa","type":"xa","slug":"xa-my-hoa","name_with_type":"Xã Mỹ Hòa","path":"Xã Mỹ Hòa, Huyện Tân Lạc, Tỉnh Hoà Bình","path_with_type":"Xã Mỹ Hòa, Huyện Tân Lạc, Tỉnh Hoà Bình","code":"05143","parent_code":"155"},"05152":{"name":"Xã Quyết Chiến","type":"xa","slug":"xa-quyet-chien","name_with_type":"Xã Quyết Chiến","path":"Xã Quyết Chiến, Huyện Tân Lạc, Tỉnh Hoà Bình","path_with_type":"Xã Quyết Chiến, Huyện Tân Lạc, Tỉnh Hoà Bình","code":"05152","parent_code":"155"},"05158":{"name":"Xã Phong Phú","type":"xa","slug":"xa-phong-phu","name_with_type":"Xã Phong Phú","path":"Xã Phong Phú, Huyện Tân Lạc, Tỉnh Hoà Bình","path_with_type":"Xã Phong Phú, Huyện Tân Lạc, Tỉnh Hoà Bình","code":"05158","parent_code":"155"},"05164":{"name":"Xã Tử Nê","type":"xa","slug":"xa-tu-ne","name_with_type":"Xã Tử Nê","path":"Xã Tử Nê, Huyện Tân Lạc, Tỉnh Hoà Bình","path_with_type":"Xã Tử Nê, Huyện Tân Lạc, Tỉnh Hoà Bình","code":"05164","parent_code":"155"},"05167":{"name":"Xã Thanh Hối","type":"xa","slug":"xa-thanh-hoi","name_with_type":"Xã Thanh Hối","path":"Xã Thanh Hối, Huyện Tân Lạc, Tỉnh Hoà Bình","path_with_type":"Xã Thanh Hối, Huyện Tân Lạc, Tỉnh Hoà Bình","code":"05167","parent_code":"155"},"05170":{"name":"Xã Ngọc Mỹ","type":"xa","slug":"xa-ngoc-my","name_with_type":"Xã Ngọc Mỹ","path":"Xã Ngọc Mỹ, Huyện Tân Lạc, Tỉnh Hoà Bình","path_with_type":"Xã Ngọc Mỹ, Huyện Tân Lạc, Tỉnh Hoà Bình","code":"05170","parent_code":"155"},"05173":{"name":"Xã Đông Lai","type":"xa","slug":"xa-dong-lai","name_with_type":"Xã Đông Lai","path":"Xã Đông Lai, Huyện Tân Lạc, Tỉnh Hoà Bình","path_with_type":"Xã Đông Lai, Huyện Tân Lạc, Tỉnh Hoà Bình","code":"05173","parent_code":"155"},"05176":{"name":"Xã Vân Sơn","type":"xa","slug":"xa-van-son","name_with_type":"Xã Vân Sơn","path":"Xã Vân Sơn, Huyện Tân Lạc, Tỉnh Hoà Bình","path_with_type":"Xã Vân Sơn, Huyện Tân Lạc, Tỉnh Hoà Bình","code":"05176","parent_code":"155"},"05182":{"name":"Xã Nhân Mỹ","type":"xa","slug":"xa-nhan-my","name_with_type":"Xã Nhân Mỹ","path":"Xã Nhân Mỹ, Huyện Tân Lạc, Tỉnh Hoà Bình","path_with_type":"Xã Nhân Mỹ, Huyện Tân Lạc, Tỉnh Hoà Bình","code":"05182","parent_code":"155"},"05191":{"name":"Xã Lỗ Sơn","type":"xa","slug":"xa-lo-son","name_with_type":"Xã Lỗ Sơn","path":"Xã Lỗ Sơn, Huyện Tân Lạc, Tỉnh Hoà Bình","path_with_type":"Xã Lỗ Sơn, Huyện Tân Lạc, Tỉnh Hoà Bình","code":"05191","parent_code":"155"},"05194":{"name":"Xã Ngổ Luông","type":"xa","slug":"xa-ngo-luong","name_with_type":"Xã Ngổ Luông","path":"Xã Ngổ Luông, Huyện Tân Lạc, Tỉnh Hoà Bình","path_with_type":"Xã Ngổ Luông, Huyện Tân Lạc, Tỉnh Hoà Bình","code":"05194","parent_code":"155"},"05197":{"name":"Xã Gia Mô","type":"xa","slug":"xa-gia-mo","name_with_type":"Xã Gia Mô","path":"Xã Gia Mô, Huyện Tân Lạc, Tỉnh Hoà Bình","path_with_type":"Xã Gia Mô, Huyện Tân Lạc, Tỉnh Hoà Bình","code":"05197","parent_code":"155"},"04882":{"name":"Xã Tân Thành","type":"xa","slug":"xa-tan-thanh","name_with_type":"Xã Tân Thành","path":"Xã Tân Thành, Huyện Mai Châu, Tỉnh Hoà Bình","path_with_type":"Xã Tân Thành, Huyện Mai Châu, Tỉnh Hoà Bình","code":"04882","parent_code":"156"},"05200":{"name":"Thị trấn Mai Châu","type":"thi-tran","slug":"thi-tran-mai-chau","name_with_type":"Thị trấn Mai Châu","path":"Thị trấn Mai Châu, Huyện Mai Châu, Tỉnh Hoà Bình","path_with_type":"Thị trấn Mai Châu, Huyện Mai Châu, Tỉnh Hoà Bình","code":"05200","parent_code":"156"},"05206":{"name":"Xã Sơn Thủy","type":"xa","slug":"xa-son-thuy","name_with_type":"Xã Sơn Thủy","path":"Xã Sơn Thủy, Huyện Mai Châu, Tỉnh Hoà Bình","path_with_type":"Xã Sơn Thủy, Huyện Mai Châu, Tỉnh Hoà Bình","code":"05206","parent_code":"156"},"05209":{"name":"Xã Pà Cò","type":"xa","slug":"xa-pa-co","name_with_type":"Xã Pà Cò","path":"Xã Pà Cò, Huyện Mai Châu, Tỉnh Hoà Bình","path_with_type":"Xã Pà Cò, Huyện Mai Châu, Tỉnh Hoà Bình","code":"05209","parent_code":"156"},"05212":{"name":"Xã Hang Kia","type":"xa","slug":"xa-hang-kia","name_with_type":"Xã Hang Kia","path":"Xã Hang Kia, Huyện Mai Châu, Tỉnh Hoà Bình","path_with_type":"Xã Hang Kia, Huyện Mai Châu, Tỉnh Hoà Bình","code":"05212","parent_code":"156"},"05221":{"name":"Xã Đồng Tân","type":"xa","slug":"xa-dong-tan","name_with_type":"Xã Đồng Tân","path":"Xã Đồng Tân, Huyện Mai Châu, Tỉnh Hoà Bình","path_with_type":"Xã Đồng Tân, Huyện Mai Châu, Tỉnh Hoà Bình","code":"05221","parent_code":"156"},"05224":{"name":"Xã Cun Pheo","type":"xa","slug":"xa-cun-pheo","name_with_type":"Xã Cun Pheo","path":"Xã Cun Pheo, Huyện Mai Châu, Tỉnh Hoà Bình","path_with_type":"Xã Cun Pheo, Huyện Mai Châu, Tỉnh Hoà Bình","code":"05224","parent_code":"156"},"05227":{"name":"Xã Bao La","type":"xa","slug":"xa-bao-la","name_with_type":"Xã Bao La","path":"Xã Bao La, Huyện Mai Châu, Tỉnh Hoà Bình","path_with_type":"Xã Bao La, Huyện Mai Châu, Tỉnh Hoà Bình","code":"05227","parent_code":"156"},"05233":{"name":"Xã Tòng Đậu","type":"xa","slug":"xa-tong-dau","name_with_type":"Xã Tòng Đậu","path":"Xã Tòng Đậu, Huyện Mai Châu, Tỉnh Hoà Bình","path_with_type":"Xã Tòng Đậu, Huyện Mai Châu, Tỉnh Hoà Bình","code":"05233","parent_code":"156"},"05242":{"name":"Xã Nà Phòn","type":"xa","slug":"xa-na-phon","name_with_type":"Xã Nà Phòn","path":"Xã Nà Phòn, Huyện Mai Châu, Tỉnh Hoà Bình","path_with_type":"Xã Nà Phòn, Huyện Mai Châu, Tỉnh Hoà Bình","code":"05242","parent_code":"156"},"05245":{"name":"Xã Săm Khóe","type":"xa","slug":"xa-sam-khoe","name_with_type":"Xã Săm Khóe","path":"Xã Săm Khóe, Huyện Mai Châu, Tỉnh Hoà Bình","path_with_type":"Xã Săm Khóe, Huyện Mai Châu, Tỉnh Hoà Bình","code":"05245","parent_code":"156"},"05248":{"name":"Xã Chiềng Châu","type":"xa","slug":"xa-chieng-chau","name_with_type":"Xã Chiềng Châu","path":"Xã Chiềng Châu, Huyện Mai Châu, Tỉnh Hoà Bình","path_with_type":"Xã Chiềng Châu, Huyện Mai Châu, Tỉnh Hoà Bình","code":"05248","parent_code":"156"},"05251":{"name":"Xã Mai Hạ","type":"xa","slug":"xa-mai-ha","name_with_type":"Xã Mai Hạ","path":"Xã Mai Hạ, Huyện Mai Châu, Tỉnh Hoà Bình","path_with_type":"Xã Mai Hạ, Huyện Mai Châu, Tỉnh Hoà Bình","code":"05251","parent_code":"156"},"05254":{"name":"Xã Thành Sơn","type":"xa","slug":"xa-thanh-son","name_with_type":"Xã Thành Sơn","path":"Xã Thành Sơn, Huyện Mai Châu, Tỉnh Hoà Bình","path_with_type":"Xã Thành Sơn, Huyện Mai Châu, Tỉnh Hoà Bình","code":"05254","parent_code":"156"},"05257":{"name":"Xã Mai Hịch","type":"xa","slug":"xa-mai-hich","name_with_type":"Xã Mai Hịch","path":"Xã Mai Hịch, Huyện Mai Châu, Tỉnh Hoà Bình","path_with_type":"Xã Mai Hịch, Huyện Mai Châu, Tỉnh Hoà Bình","code":"05257","parent_code":"156"},"05263":{"name":"Xã Vạn Mai","type":"xa","slug":"xa-van-mai","name_with_type":"Xã Vạn Mai","path":"Xã Vạn Mai, Huyện Mai Châu, Tỉnh Hoà Bình","path_with_type":"Xã Vạn Mai, Huyện Mai Châu, Tỉnh Hoà Bình","code":"05263","parent_code":"156"},"05266":{"name":"Thị trấn Vụ Bản","type":"thi-tran","slug":"thi-tran-vu-ban","name_with_type":"Thị trấn Vụ Bản","path":"Thị trấn Vụ Bản, Huyện Lạc Sơn, Tỉnh Hoà Bình","path_with_type":"Thị trấn Vụ Bản, Huyện Lạc Sơn, Tỉnh Hoà Bình","code":"05266","parent_code":"157"},"05269":{"name":"Xã Quý Hòa","type":"xa","slug":"xa-quy-hoa","name_with_type":"Xã Quý Hòa","path":"Xã Quý Hòa, Huyện Lạc Sơn, Tỉnh Hoà Bình","path_with_type":"Xã Quý Hòa, Huyện Lạc Sơn, Tỉnh Hoà Bình","code":"05269","parent_code":"157"},"05272":{"name":"Xã Miền Đồi","type":"xa","slug":"xa-mien-doi","name_with_type":"Xã Miền Đồi","path":"Xã Miền Đồi, Huyện Lạc Sơn, Tỉnh Hoà Bình","path_with_type":"Xã Miền Đồi, Huyện Lạc Sơn, Tỉnh Hoà Bình","code":"05272","parent_code":"157"},"05275":{"name":"Xã Mỹ Thành","type":"xa","slug":"xa-my-thanh","name_with_type":"Xã Mỹ Thành","path":"Xã Mỹ Thành, Huyện Lạc Sơn, Tỉnh Hoà Bình","path_with_type":"Xã Mỹ Thành, Huyện Lạc Sơn, Tỉnh Hoà Bình","code":"05275","parent_code":"157"},"05278":{"name":"Xã Tuân Đạo","type":"xa","slug":"xa-tuan-dao","name_with_type":"Xã Tuân Đạo","path":"Xã Tuân Đạo, Huyện Lạc Sơn, Tỉnh Hoà Bình","path_with_type":"Xã Tuân Đạo, Huyện Lạc Sơn, Tỉnh Hoà Bình","code":"05278","parent_code":"157"},"05281":{"name":"Xã Văn Nghĩa","type":"xa","slug":"xa-van-nghia","name_with_type":"Xã Văn Nghĩa","path":"Xã Văn Nghĩa, Huyện Lạc Sơn, Tỉnh Hoà Bình","path_with_type":"Xã Văn Nghĩa, Huyện Lạc Sơn, Tỉnh Hoà Bình","code":"05281","parent_code":"157"},"05284":{"name":"Xã Văn Sơn","type":"xa","slug":"xa-van-son","name_with_type":"Xã Văn Sơn","path":"Xã Văn Sơn, Huyện Lạc Sơn, Tỉnh Hoà Bình","path_with_type":"Xã Văn Sơn, Huyện Lạc Sơn, Tỉnh Hoà Bình","code":"05284","parent_code":"157"},"05287":{"name":"Xã Tân Lập","type":"xa","slug":"xa-tan-lap","name_with_type":"Xã Tân Lập","path":"Xã Tân Lập, Huyện Lạc Sơn, Tỉnh Hoà Bình","path_with_type":"Xã Tân Lập, Huyện Lạc Sơn, Tỉnh Hoà Bình","code":"05287","parent_code":"157"},"05290":{"name":"Xã Nhân Nghĩa","type":"xa","slug":"xa-nhan-nghia","name_with_type":"Xã Nhân Nghĩa","path":"Xã Nhân Nghĩa, Huyện Lạc Sơn, Tỉnh Hoà Bình","path_with_type":"Xã Nhân Nghĩa, Huyện Lạc Sơn, Tỉnh Hoà Bình","code":"05290","parent_code":"157"},"05293":{"name":"Xã Thượng Cốc","type":"xa","slug":"xa-thuong-coc","name_with_type":"Xã Thượng Cốc","path":"Xã Thượng Cốc, Huyện Lạc Sơn, Tỉnh Hoà Bình","path_with_type":"Xã Thượng Cốc, Huyện Lạc Sơn, Tỉnh Hoà Bình","code":"05293","parent_code":"157"},"05299":{"name":"Xã Quyết Thắng","type":"xa","slug":"xa-quyet-thang","name_with_type":"Xã Quyết Thắng","path":"Xã Quyết Thắng, Huyện Lạc Sơn, Tỉnh Hoà Bình","path_with_type":"Xã Quyết Thắng, Huyện Lạc Sơn, Tỉnh Hoà Bình","code":"05299","parent_code":"157"},"05302":{"name":"Xã Xuất Hóa","type":"xa","slug":"xa-xuat-hoa","name_with_type":"Xã Xuất Hóa","path":"Xã Xuất Hóa, Huyện Lạc Sơn, Tỉnh Hoà Bình","path_with_type":"Xã Xuất Hóa, Huyện Lạc Sơn, Tỉnh Hoà Bình","code":"05302","parent_code":"157"},"05305":{"name":"Xã Yên Phú","type":"xa","slug":"xa-yen-phu","name_with_type":"Xã Yên Phú","path":"Xã Yên Phú, Huyện Lạc Sơn, Tỉnh Hoà Bình","path_with_type":"Xã Yên Phú, Huyện Lạc Sơn, Tỉnh Hoà Bình","code":"05305","parent_code":"157"},"05308":{"name":"Xã Bình Hẻm","type":"xa","slug":"xa-binh-hem","name_with_type":"Xã Bình Hẻm","path":"Xã Bình Hẻm, Huyện Lạc Sơn, Tỉnh Hoà Bình","path_with_type":"Xã Bình Hẻm, Huyện Lạc Sơn, Tỉnh Hoà Bình","code":"05308","parent_code":"157"},"05320":{"name":"Xã Định Cư","type":"xa","slug":"xa-dinh-cu","name_with_type":"Xã Định Cư","path":"Xã Định Cư, Huyện Lạc Sơn, Tỉnh Hoà Bình","path_with_type":"Xã Định Cư, Huyện Lạc Sơn, Tỉnh Hoà Bình","code":"05320","parent_code":"157"},"05323":{"name":"Xã Chí Đạo","type":"xa","slug":"xa-chi-dao","name_with_type":"Xã Chí Đạo","path":"Xã Chí Đạo, Huyện Lạc Sơn, Tỉnh Hoà Bình","path_with_type":"Xã Chí Đạo, Huyện Lạc Sơn, Tỉnh Hoà Bình","code":"05323","parent_code":"157"},"05329":{"name":"Xã Ngọc Sơn","type":"xa","slug":"xa-ngoc-son","name_with_type":"Xã Ngọc Sơn","path":"Xã Ngọc Sơn, Huyện Lạc Sơn, Tỉnh Hoà Bình","path_with_type":"Xã Ngọc Sơn, Huyện Lạc Sơn, Tỉnh Hoà Bình","code":"05329","parent_code":"157"},"05332":{"name":"Xã Hương Nhượng","type":"xa","slug":"xa-huong-nhuong","name_with_type":"Xã Hương Nhượng","path":"Xã Hương Nhượng, Huyện Lạc Sơn, Tỉnh Hoà Bình","path_with_type":"Xã Hương Nhượng, Huyện Lạc Sơn, Tỉnh Hoà Bình","code":"05332","parent_code":"157"},"05335":{"name":"Xã Vũ Bình","type":"xa","slug":"xa-vu-binh","name_with_type":"Xã Vũ Bình","path":"Xã Vũ Bình, Huyện Lạc Sơn, Tỉnh Hoà Bình","path_with_type":"Xã Vũ Bình, Huyện Lạc Sơn, Tỉnh Hoà Bình","code":"05335","parent_code":"157"},"05338":{"name":"Xã Tự Do","type":"xa","slug":"xa-tu-do","name_with_type":"Xã Tự Do","path":"Xã Tự Do, Huyện Lạc Sơn, Tỉnh Hoà Bình","path_with_type":"Xã Tự Do, Huyện Lạc Sơn, Tỉnh Hoà Bình","code":"05338","parent_code":"157"},"05341":{"name":"Xã Yên Nghiệp","type":"xa","slug":"xa-yen-nghiep","name_with_type":"Xã Yên Nghiệp","path":"Xã Yên Nghiệp, Huyện Lạc Sơn, Tỉnh Hoà Bình","path_with_type":"Xã Yên Nghiệp, Huyện Lạc Sơn, Tỉnh Hoà Bình","code":"05341","parent_code":"157"},"05344":{"name":"Xã Tân Mỹ","type":"xa","slug":"xa-tan-my","name_with_type":"Xã Tân Mỹ","path":"Xã Tân Mỹ, Huyện Lạc Sơn, Tỉnh Hoà Bình","path_with_type":"Xã Tân Mỹ, Huyện Lạc Sơn, Tỉnh Hoà Bình","code":"05344","parent_code":"157"},"05347":{"name":"Xã Ân Nghĩa","type":"xa","slug":"xa-an-nghia","name_with_type":"Xã Ân Nghĩa","path":"Xã Ân Nghĩa, Huyện Lạc Sơn, Tỉnh Hoà Bình","path_with_type":"Xã Ân Nghĩa, Huyện Lạc Sơn, Tỉnh Hoà Bình","code":"05347","parent_code":"157"},"05350":{"name":"Xã Ngọc Lâu","type":"xa","slug":"xa-ngoc-lau","name_with_type":"Xã Ngọc Lâu","path":"Xã Ngọc Lâu, Huyện Lạc Sơn, Tỉnh Hoà Bình","path_with_type":"Xã Ngọc Lâu, Huyện Lạc Sơn, Tỉnh Hoà Bình","code":"05350","parent_code":"157"},"05353":{"name":"Thị trấn Hàng Trạm","type":"thi-tran","slug":"thi-tran-hang-tram","name_with_type":"Thị trấn Hàng Trạm","path":"Thị trấn Hàng Trạm, Huyện Yên Thủy, Tỉnh Hoà Bình","path_with_type":"Thị trấn Hàng Trạm, Huyện Yên Thủy, Tỉnh Hoà Bình","code":"05353","parent_code":"158"},"05356":{"name":"Xã Lạc Sỹ","type":"xa","slug":"xa-lac-sy","name_with_type":"Xã Lạc Sỹ","path":"Xã Lạc Sỹ, Huyện Yên Thủy, Tỉnh Hoà Bình","path_with_type":"Xã Lạc Sỹ, Huyện Yên Thủy, Tỉnh Hoà Bình","code":"05356","parent_code":"158"},"05362":{"name":"Xã Lạc Lương","type":"xa","slug":"xa-lac-luong","name_with_type":"Xã Lạc Lương","path":"Xã Lạc Lương, Huyện Yên Thủy, Tỉnh Hoà Bình","path_with_type":"Xã Lạc Lương, Huyện Yên Thủy, Tỉnh Hoà Bình","code":"05362","parent_code":"158"},"05365":{"name":"Xã Bảo Hiệu","type":"xa","slug":"xa-bao-hieu","name_with_type":"Xã Bảo Hiệu","path":"Xã Bảo Hiệu, Huyện Yên Thủy, Tỉnh Hoà Bình","path_with_type":"Xã Bảo Hiệu, Huyện Yên Thủy, Tỉnh Hoà Bình","code":"05365","parent_code":"158"},"05368":{"name":"Xã Đa Phúc","type":"xa","slug":"xa-da-phuc","name_with_type":"Xã Đa Phúc","path":"Xã Đa Phúc, Huyện Yên Thủy, Tỉnh Hoà Bình","path_with_type":"Xã Đa Phúc, Huyện Yên Thủy, Tỉnh Hoà Bình","code":"05368","parent_code":"158"},"05371":{"name":"Xã Hữu Lợi","type":"xa","slug":"xa-huu-loi","name_with_type":"Xã Hữu Lợi","path":"Xã Hữu Lợi, Huyện Yên Thủy, Tỉnh Hoà Bình","path_with_type":"Xã Hữu Lợi, Huyện Yên Thủy, Tỉnh Hoà Bình","code":"05371","parent_code":"158"},"05374":{"name":"Xã Lạc Thịnh","type":"xa","slug":"xa-lac-thinh","name_with_type":"Xã Lạc Thịnh","path":"Xã Lạc Thịnh, Huyện Yên Thủy, Tỉnh Hoà Bình","path_with_type":"Xã Lạc Thịnh, Huyện Yên Thủy, Tỉnh Hoà Bình","code":"05374","parent_code":"158"},"05380":{"name":"Xã Đoàn Kết","type":"xa","slug":"xa-doan-ket","name_with_type":"Xã Đoàn Kết","path":"Xã Đoàn Kết, Huyện Yên Thủy, Tỉnh Hoà Bình","path_with_type":"Xã Đoàn Kết, Huyện Yên Thủy, Tỉnh Hoà Bình","code":"05380","parent_code":"158"},"05383":{"name":"Xã Phú Lai","type":"xa","slug":"xa-phu-lai","name_with_type":"Xã Phú Lai","path":"Xã Phú Lai, Huyện Yên Thủy, Tỉnh Hoà Bình","path_with_type":"Xã Phú Lai, Huyện Yên Thủy, Tỉnh Hoà Bình","code":"05383","parent_code":"158"},"05386":{"name":"Xã Yên Trị","type":"xa","slug":"xa-yen-tri","name_with_type":"Xã Yên Trị","path":"Xã Yên Trị, Huyện Yên Thủy, Tỉnh Hoà Bình","path_with_type":"Xã Yên Trị, Huyện Yên Thủy, Tỉnh Hoà Bình","code":"05386","parent_code":"158"},"05389":{"name":"Xã Ngọc Lương","type":"xa","slug":"xa-ngoc-luong","name_with_type":"Xã Ngọc Lương","path":"Xã Ngọc Lương, Huyện Yên Thủy, Tỉnh Hoà Bình","path_with_type":"Xã Ngọc Lương, Huyện Yên Thủy, Tỉnh Hoà Bình","code":"05389","parent_code":"158"},"04981":{"name":"Thị trấn Ba Hàng Đồi","type":"thi-tran","slug":"thi-tran-ba-hang-doi","name_with_type":"Thị trấn Ba Hàng Đồi","path":"Thị trấn Ba Hàng Đồi, Huyện Lạc Thủy, Tỉnh Hoà Bình","path_with_type":"Thị trấn Ba Hàng Đồi, Huyện Lạc Thủy, Tỉnh Hoà Bình","code":"04981","parent_code":"159"},"05392":{"name":"Thị trấn Chi Nê","type":"thi-tran","slug":"thi-tran-chi-ne","name_with_type":"Thị trấn Chi Nê","path":"Thị trấn Chi Nê, Huyện Lạc Thủy, Tỉnh Hoà Bình","path_with_type":"Thị trấn Chi Nê, Huyện Lạc Thủy, Tỉnh Hoà Bình","code":"05392","parent_code":"159"},"05395":{"name":"Xã Phú Nghĩa","type":"xa","slug":"xa-phu-nghia","name_with_type":"Xã Phú Nghĩa","path":"Xã Phú Nghĩa, Huyện Lạc Thủy, Tỉnh Hoà Bình","path_with_type":"Xã Phú Nghĩa, Huyện Lạc Thủy, Tỉnh Hoà Bình","code":"05395","parent_code":"159"},"05398":{"name":"Xã Phú Thành","type":"xa","slug":"xa-phu-thanh","name_with_type":"Xã Phú Thành","path":"Xã Phú Thành, Huyện Lạc Thủy, Tỉnh Hoà Bình","path_with_type":"Xã Phú Thành, Huyện Lạc Thủy, Tỉnh Hoà Bình","code":"05398","parent_code":"159"},"05404":{"name":"Xã Hưng Thi","type":"xa","slug":"xa-hung-thi","name_with_type":"Xã Hưng Thi","path":"Xã Hưng Thi, Huyện Lạc Thủy, Tỉnh Hoà Bình","path_with_type":"Xã Hưng Thi, Huyện Lạc Thủy, Tỉnh Hoà Bình","code":"05404","parent_code":"159"},"05413":{"name":"Xã Khoan Dụ","type":"xa","slug":"xa-khoan-du","name_with_type":"Xã Khoan Dụ","path":"Xã Khoan Dụ, Huyện Lạc Thủy, Tỉnh Hoà Bình","path_with_type":"Xã Khoan Dụ, Huyện Lạc Thủy, Tỉnh Hoà Bình","code":"05413","parent_code":"159"},"05419":{"name":"Xã Đồng Tâm","type":"xa","slug":"xa-dong-tam","name_with_type":"Xã Đồng Tâm","path":"Xã Đồng Tâm, Huyện Lạc Thủy, Tỉnh Hoà Bình","path_with_type":"Xã Đồng Tâm, Huyện Lạc Thủy, Tỉnh Hoà Bình","code":"05419","parent_code":"159"},"05422":{"name":"Xã Yên Bồng","type":"xa","slug":"xa-yen-bong","name_with_type":"Xã Yên Bồng","path":"Xã Yên Bồng, Huyện Lạc Thủy, Tỉnh Hoà Bình","path_with_type":"Xã Yên Bồng, Huyện Lạc Thủy, Tỉnh Hoà Bình","code":"05422","parent_code":"159"},"05425":{"name":"Xã Thống Nhất","type":"xa","slug":"xa-thong-nhat","name_with_type":"Xã Thống Nhất","path":"Xã Thống Nhất, Huyện Lạc Thủy, Tỉnh Hoà Bình","path_with_type":"Xã Thống Nhất, Huyện Lạc Thủy, Tỉnh Hoà Bình","code":"05425","parent_code":"159"},"05428":{"name":"Xã An Bình","type":"xa","slug":"xa-an-binh","name_with_type":"Xã An Bình","path":"Xã An Bình, Huyện Lạc Thủy, Tỉnh Hoà Bình","path_with_type":"Xã An Bình, Huyện Lạc Thủy, Tỉnh Hoà Bình","code":"05428","parent_code":"159"},"05431":{"name":"Phường Quán Triều","type":"phuong","slug":"phuong-quan-trieu","name_with_type":"Phường Quán Triều","path":"Phường Quán Triều, Thành phố Thái Nguyên, Tỉnh Thái Nguyên","path_with_type":"Phường Quán Triều, Thành phố Thái Nguyên, Tỉnh Thái Nguyên","code":"05431","parent_code":"164"},"05434":{"name":"Phường Quang Vinh","type":"phuong","slug":"phuong-quang-vinh","name_with_type":"Phường Quang Vinh","path":"Phường Quang Vinh, Thành phố Thái Nguyên, Tỉnh Thái Nguyên","path_with_type":"Phường Quang Vinh, Thành phố Thái Nguyên, Tỉnh Thái Nguyên","code":"05434","parent_code":"164"},"05437":{"name":"Phường Túc Duyên","type":"phuong","slug":"phuong-tuc-duyen","name_with_type":"Phường Túc Duyên","path":"Phường Túc Duyên, Thành phố Thái Nguyên, Tỉnh Thái Nguyên","path_with_type":"Phường Túc Duyên, Thành phố Thái Nguyên, Tỉnh Thái Nguyên","code":"05437","parent_code":"164"},"05440":{"name":"Phường Hoàng Văn Thụ","type":"phuong","slug":"phuong-hoang-van-thu","name_with_type":"Phường Hoàng Văn Thụ","path":"Phường Hoàng Văn Thụ, Thành phố Thái Nguyên, Tỉnh Thái Nguyên","path_with_type":"Phường Hoàng Văn Thụ, Thành phố Thái Nguyên, Tỉnh Thái Nguyên","code":"05440","parent_code":"164"},"05443":{"name":"Phường Trưng Vương","type":"phuong","slug":"phuong-trung-vuong","name_with_type":"Phường Trưng Vương","path":"Phường Trưng Vương, Thành phố Thái Nguyên, Tỉnh Thái Nguyên","path_with_type":"Phường Trưng Vương, Thành phố Thái Nguyên, Tỉnh Thái Nguyên","code":"05443","parent_code":"164"},"05446":{"name":"Phường Quang Trung","type":"phuong","slug":"phuong-quang-trung","name_with_type":"Phường Quang Trung","path":"Phường Quang Trung, Thành phố Thái Nguyên, Tỉnh Thái Nguyên","path_with_type":"Phường Quang Trung, Thành phố Thái Nguyên, Tỉnh Thái Nguyên","code":"05446","parent_code":"164"},"05449":{"name":"Phường Phan Đình Phùng","type":"phuong","slug":"phuong-phan-dinh-phung","name_with_type":"Phường Phan Đình Phùng","path":"Phường Phan Đình Phùng, Thành phố Thái Nguyên, Tỉnh Thái Nguyên","path_with_type":"Phường Phan Đình Phùng, Thành phố Thái Nguyên, Tỉnh Thái Nguyên","code":"05449","parent_code":"164"},"05452":{"name":"Phường Tân Thịnh","type":"phuong","slug":"phuong-tan-thinh","name_with_type":"Phường Tân Thịnh","path":"Phường Tân Thịnh, Thành phố Thái Nguyên, Tỉnh Thái Nguyên","path_with_type":"Phường Tân Thịnh, Thành phố Thái Nguyên, Tỉnh Thái Nguyên","code":"05452","parent_code":"164"},"05455":{"name":"Phường Thịnh Đán","type":"phuong","slug":"phuong-thinh-dan","name_with_type":"Phường Thịnh Đán","path":"Phường Thịnh Đán, Thành phố Thái Nguyên, Tỉnh Thái Nguyên","path_with_type":"Phường Thịnh Đán, Thành phố Thái Nguyên, Tỉnh Thái Nguyên","code":"05455","parent_code":"164"},"05458":{"name":"Phường Đồng Quang","type":"phuong","slug":"phuong-dong-quang","name_with_type":"Phường Đồng Quang","path":"Phường Đồng Quang, Thành phố Thái Nguyên, Tỉnh Thái Nguyên","path_with_type":"Phường Đồng Quang, Thành phố Thái Nguyên, Tỉnh Thái Nguyên","code":"05458","parent_code":"164"},"05461":{"name":"Phường Gia Sàng","type":"phuong","slug":"phuong-gia-sang","name_with_type":"Phường Gia Sàng","path":"Phường Gia Sàng, Thành phố Thái Nguyên, Tỉnh Thái Nguyên","path_with_type":"Phường Gia Sàng, Thành phố Thái Nguyên, Tỉnh Thái Nguyên","code":"05461","parent_code":"164"},"05464":{"name":"Phường Tân Lập","type":"phuong","slug":"phuong-tan-lap","name_with_type":"Phường Tân Lập","path":"Phường Tân Lập, Thành phố Thái Nguyên, Tỉnh Thái Nguyên","path_with_type":"Phường Tân Lập, Thành phố Thái Nguyên, Tỉnh Thái Nguyên","code":"05464","parent_code":"164"},"05467":{"name":"Phường Cam Giá","type":"phuong","slug":"phuong-cam-gia","name_with_type":"Phường Cam Giá","path":"Phường Cam Giá, Thành phố Thái Nguyên, Tỉnh Thái Nguyên","path_with_type":"Phường Cam Giá, Thành phố Thái Nguyên, Tỉnh Thái Nguyên","code":"05467","parent_code":"164"},"05470":{"name":"Phường Phú Xá","type":"phuong","slug":"phuong-phu-xa","name_with_type":"Phường Phú Xá","path":"Phường Phú Xá, Thành phố Thái Nguyên, Tỉnh Thái Nguyên","path_with_type":"Phường Phú Xá, Thành phố Thái Nguyên, Tỉnh Thái Nguyên","code":"05470","parent_code":"164"},"05473":{"name":"Phường Hương Sơn","type":"phuong","slug":"phuong-huong-son","name_with_type":"Phường Hương Sơn","path":"Phường Hương Sơn, Thành phố Thái Nguyên, Tỉnh Thái Nguyên","path_with_type":"Phường Hương Sơn, Thành phố Thái Nguyên, Tỉnh Thái Nguyên","code":"05473","parent_code":"164"},"05476":{"name":"Phường Trung Thành","type":"phuong","slug":"phuong-trung-thanh","name_with_type":"Phường Trung Thành","path":"Phường Trung Thành, Thành phố Thái Nguyên, Tỉnh Thái Nguyên","path_with_type":"Phường Trung Thành, Thành phố Thái Nguyên, Tỉnh Thái Nguyên","code":"05476","parent_code":"164"},"05479":{"name":"Phường Tân Thành","type":"phuong","slug":"phuong-tan-thanh","name_with_type":"Phường Tân Thành","path":"Phường Tân Thành, Thành phố Thái Nguyên, Tỉnh Thái Nguyên","path_with_type":"Phường Tân Thành, Thành phố Thái Nguyên, Tỉnh Thái Nguyên","code":"05479","parent_code":"164"},"05482":{"name":"Phường Tân Long","type":"phuong","slug":"phuong-tan-long","name_with_type":"Phường Tân Long","path":"Phường Tân Long, Thành phố Thái Nguyên, Tỉnh Thái Nguyên","path_with_type":"Phường Tân Long, Thành phố Thái Nguyên, Tỉnh Thái Nguyên","code":"05482","parent_code":"164"},"05485":{"name":"Xã Phúc Hà","type":"xa","slug":"xa-phuc-ha","name_with_type":"Xã Phúc Hà","path":"Xã Phúc Hà, Thành phố Thái Nguyên, Tỉnh Thái Nguyên","path_with_type":"Xã Phúc Hà, Thành phố Thái Nguyên, Tỉnh Thái Nguyên","code":"05485","parent_code":"164"},"05488":{"name":"Xã Phúc Xuân","type":"xa","slug":"xa-phuc-xuan","name_with_type":"Xã Phúc Xuân","path":"Xã Phúc Xuân, Thành phố Thái Nguyên, Tỉnh Thái Nguyên","path_with_type":"Xã Phúc Xuân, Thành phố Thái Nguyên, Tỉnh Thái Nguyên","code":"05488","parent_code":"164"},"05491":{"name":"Xã Quyết Thắng","type":"xa","slug":"xa-quyet-thang","name_with_type":"Xã Quyết Thắng","path":"Xã Quyết Thắng, Thành phố Thái Nguyên, Tỉnh Thái Nguyên","path_with_type":"Xã Quyết Thắng, Thành phố Thái Nguyên, Tỉnh Thái Nguyên","code":"05491","parent_code":"164"},"05494":{"name":"Xã Phúc Trìu","type":"xa","slug":"xa-phuc-triu","name_with_type":"Xã Phúc Trìu","path":"Xã Phúc Trìu, Thành phố Thái Nguyên, Tỉnh Thái Nguyên","path_with_type":"Xã Phúc Trìu, Thành phố Thái Nguyên, Tỉnh Thái Nguyên","code":"05494","parent_code":"164"},"05497":{"name":"Xã Thịnh Đức","type":"xa","slug":"xa-thinh-duc","name_with_type":"Xã Thịnh Đức","path":"Xã Thịnh Đức, Thành phố Thái Nguyên, Tỉnh Thái Nguyên","path_with_type":"Xã Thịnh Đức, Thành phố Thái Nguyên, Tỉnh Thái Nguyên","code":"05497","parent_code":"164"},"05500":{"name":"Phường Tích Lương","type":"phuong","slug":"phuong-tich-luong","name_with_type":"Phường Tích Lương","path":"Phường Tích Lương, Thành phố Thái Nguyên, Tỉnh Thái Nguyên","path_with_type":"Phường Tích Lương, Thành phố Thái Nguyên, Tỉnh Thái Nguyên","code":"05500","parent_code":"164"},"05503":{"name":"Xã Tân Cương","type":"xa","slug":"xa-tan-cuong","name_with_type":"Xã Tân Cương","path":"Xã Tân Cương, Thành phố Thái Nguyên, Tỉnh Thái Nguyên","path_with_type":"Xã Tân Cương, Thành phố Thái Nguyên, Tỉnh Thái Nguyên","code":"05503","parent_code":"164"},"05653":{"name":"Xã Sơn Cẩm","type":"xa","slug":"xa-son-cam","name_with_type":"Xã Sơn Cẩm","path":"Xã Sơn Cẩm, Thành phố Thái Nguyên, Tỉnh Thái Nguyên","path_with_type":"Xã Sơn Cẩm, Thành phố Thái Nguyên, Tỉnh Thái Nguyên","code":"05653","parent_code":"164"},"05659":{"name":"Phường Chùa Hang","type":"phuong","slug":"phuong-chua-hang","name_with_type":"Phường Chùa Hang","path":"Phường Chùa Hang, Thành phố Thái Nguyên, Tỉnh Thái Nguyên","path_with_type":"Phường Chùa Hang, Thành phố Thái Nguyên, Tỉnh Thái Nguyên","code":"05659","parent_code":"164"},"05695":{"name":"Xã Cao Ngạn","type":"xa","slug":"xa-cao-ngan","name_with_type":"Xã Cao Ngạn","path":"Xã Cao Ngạn, Thành phố Thái Nguyên, Tỉnh Thái Nguyên","path_with_type":"Xã Cao Ngạn, Thành phố Thái Nguyên, Tỉnh Thái Nguyên","code":"05695","parent_code":"164"},"05701":{"name":"Xã Linh Sơn","type":"xa","slug":"xa-linh-son","name_with_type":"Xã Linh Sơn","path":"Xã Linh Sơn, Thành phố Thái Nguyên, Tỉnh Thái Nguyên","path_with_type":"Xã Linh Sơn, Thành phố Thái Nguyên, Tỉnh Thái Nguyên","code":"05701","parent_code":"164"},"05710":{"name":"Phường Đồng Bẩm","type":"phuong","slug":"phuong-dong-bam","name_with_type":"Phường Đồng Bẩm","path":"Phường Đồng Bẩm, Thành phố Thái Nguyên, Tỉnh Thái Nguyên","path_with_type":"Phường Đồng Bẩm, Thành phố Thái Nguyên, Tỉnh Thái Nguyên","code":"05710","parent_code":"164"},"05713":{"name":"Xã Huống Thượng","type":"xa","slug":"xa-huong-thuong","name_with_type":"Xã Huống Thượng","path":"Xã Huống Thượng, Thành phố Thái Nguyên, Tỉnh Thái Nguyên","path_with_type":"Xã Huống Thượng, Thành phố Thái Nguyên, Tỉnh Thái Nguyên","code":"05713","parent_code":"164"},"05914":{"name":"Xã Đồng Liên","type":"xa","slug":"xa-dong-lien","name_with_type":"Xã Đồng Liên","path":"Xã Đồng Liên, Thành phố Thái Nguyên, Tỉnh Thái Nguyên","path_with_type":"Xã Đồng Liên, Thành phố Thái Nguyên, Tỉnh Thái Nguyên","code":"05914","parent_code":"164"},"05506":{"name":"Phường Lương Sơn","type":"phuong","slug":"phuong-luong-son","name_with_type":"Phường Lương Sơn","path":"Phường Lương Sơn, Thành phố Sông Công, Tỉnh Thái Nguyên","path_with_type":"Phường Lương Sơn, Thành phố Sông Công, Tỉnh Thái Nguyên","code":"05506","parent_code":"165"},"05509":{"name":"Phường Châu Sơn","type":"phuong","slug":"phuong-chau-son","name_with_type":"Phường Châu Sơn","path":"Phường Châu Sơn, Thành phố Sông Công, Tỉnh Thái Nguyên","path_with_type":"Phường Châu Sơn, Thành phố Sông Công, Tỉnh Thái Nguyên","code":"05509","parent_code":"165"},"05512":{"name":"Phường Mỏ Chè","type":"phuong","slug":"phuong-mo-che","name_with_type":"Phường Mỏ Chè","path":"Phường Mỏ Chè, Thành phố Sông Công, Tỉnh Thái Nguyên","path_with_type":"Phường Mỏ Chè, Thành phố Sông Công, Tỉnh Thái Nguyên","code":"05512","parent_code":"165"},"05515":{"name":"Phường Cải Đan","type":"phuong","slug":"phuong-cai-dan","name_with_type":"Phường Cải Đan","path":"Phường Cải Đan, Thành phố Sông Công, Tỉnh Thái Nguyên","path_with_type":"Phường Cải Đan, Thành phố Sông Công, Tỉnh Thái Nguyên","code":"05515","parent_code":"165"},"05518":{"name":"Phường Thắng Lợi","type":"phuong","slug":"phuong-thang-loi","name_with_type":"Phường Thắng Lợi","path":"Phường Thắng Lợi, Thành phố Sông Công, Tỉnh Thái Nguyên","path_with_type":"Phường Thắng Lợi, Thành phố Sông Công, Tỉnh Thái Nguyên","code":"05518","parent_code":"165"},"05521":{"name":"Phường Phố Cò","type":"phuong","slug":"phuong-pho-co","name_with_type":"Phường Phố Cò","path":"Phường Phố Cò, Thành phố Sông Công, Tỉnh Thái Nguyên","path_with_type":"Phường Phố Cò, Thành phố Sông Công, Tỉnh Thái Nguyên","code":"05521","parent_code":"165"},"05527":{"name":"Xã Tân Quang","type":"xa","slug":"xa-tan-quang","name_with_type":"Xã Tân Quang","path":"Xã Tân Quang, Thành phố Sông Công, Tỉnh Thái Nguyên","path_with_type":"Xã Tân Quang, Thành phố Sông Công, Tỉnh Thái Nguyên","code":"05527","parent_code":"165"},"05528":{"name":"Phường Bách Quang","type":"phuong","slug":"phuong-bach-quang","name_with_type":"Phường Bách Quang","path":"Phường Bách Quang, Thành phố Sông Công, Tỉnh Thái Nguyên","path_with_type":"Phường Bách Quang, Thành phố Sông Công, Tỉnh Thái Nguyên","code":"05528","parent_code":"165"},"05530":{"name":"Xã Bình Sơn","type":"xa","slug":"xa-binh-son","name_with_type":"Xã Bình Sơn","path":"Xã Bình Sơn, Thành phố Sông Công, Tỉnh Thái Nguyên","path_with_type":"Xã Bình Sơn, Thành phố Sông Công, Tỉnh Thái Nguyên","code":"05530","parent_code":"165"},"05533":{"name":"Xã Bá Xuyên","type":"xa","slug":"xa-ba-xuyen","name_with_type":"Xã Bá Xuyên","path":"Xã Bá Xuyên, Thành phố Sông Công, Tỉnh Thái Nguyên","path_with_type":"Xã Bá Xuyên, Thành phố Sông Công, Tỉnh Thái Nguyên","code":"05533","parent_code":"165"},"05539":{"name":"Xã Linh Thông","type":"xa","slug":"xa-linh-thong","name_with_type":"Xã Linh Thông","path":"Xã Linh Thông, Huyện Định Hóa, Tỉnh Thái Nguyên","path_with_type":"Xã Linh Thông, Huyện Định Hóa, Tỉnh Thái Nguyên","code":"05539","parent_code":"167"},"05542":{"name":"Xã Lam Vỹ","type":"xa","slug":"xa-lam-vy","name_with_type":"Xã Lam Vỹ","path":"Xã Lam Vỹ, Huyện Định Hóa, Tỉnh Thái Nguyên","path_with_type":"Xã Lam Vỹ, Huyện Định Hóa, Tỉnh Thái Nguyên","code":"05542","parent_code":"167"},"05545":{"name":"Xã Quy Kỳ","type":"xa","slug":"xa-quy-ky","name_with_type":"Xã Quy Kỳ","path":"Xã Quy Kỳ, Huyện Định Hóa, Tỉnh Thái Nguyên","path_with_type":"Xã Quy Kỳ, Huyện Định Hóa, Tỉnh Thái Nguyên","code":"05545","parent_code":"167"},"05548":{"name":"Xã Tân Thịnh","type":"xa","slug":"xa-tan-thinh","name_with_type":"Xã Tân Thịnh","path":"Xã Tân Thịnh, Huyện Định Hóa, Tỉnh Thái Nguyên","path_with_type":"Xã Tân Thịnh, Huyện Định Hóa, Tỉnh Thái Nguyên","code":"05548","parent_code":"167"},"05551":{"name":"Xã Kim Phượng","type":"xa","slug":"xa-kim-phuong","name_with_type":"Xã Kim Phượng","path":"Xã Kim Phượng, Huyện Định Hóa, Tỉnh Thái Nguyên","path_with_type":"Xã Kim Phượng, Huyện Định Hóa, Tỉnh Thái Nguyên","code":"05551","parent_code":"167"},"05554":{"name":"Xã Bảo Linh","type":"xa","slug":"xa-bao-linh","name_with_type":"Xã Bảo Linh","path":"Xã Bảo Linh, Huyện Định Hóa, Tỉnh Thái Nguyên","path_with_type":"Xã Bảo Linh, Huyện Định Hóa, Tỉnh Thái Nguyên","code":"05554","parent_code":"167"},"05560":{"name":"Xã Phúc Chu","type":"xa","slug":"xa-phuc-chu","name_with_type":"Xã Phúc Chu","path":"Xã Phúc Chu, Huyện Định Hóa, Tỉnh Thái Nguyên","path_with_type":"Xã Phúc Chu, Huyện Định Hóa, Tỉnh Thái Nguyên","code":"05560","parent_code":"167"},"05563":{"name":"Xã Tân Dương","type":"xa","slug":"xa-tan-duong","name_with_type":"Xã Tân Dương","path":"Xã Tân Dương, Huyện Định Hóa, Tỉnh Thái Nguyên","path_with_type":"Xã Tân Dương, Huyện Định Hóa, Tỉnh Thái Nguyên","code":"05563","parent_code":"167"},"05566":{"name":"Xã Phượng Tiến","type":"xa","slug":"xa-phuong-tien","name_with_type":"Xã Phượng Tiến","path":"Xã Phượng Tiến, Huyện Định Hóa, Tỉnh Thái Nguyên","path_with_type":"Xã Phượng Tiến, Huyện Định Hóa, Tỉnh Thái Nguyên","code":"05566","parent_code":"167"},"05569":{"name":"Thị trấn Chợ Chu","type":"thi-tran","slug":"thi-tran-cho-chu","name_with_type":"Thị trấn Chợ Chu","path":"Thị trấn Chợ Chu, Huyện Định Hóa, Tỉnh Thái Nguyên","path_with_type":"Thị trấn Chợ Chu, Huyện Định Hóa, Tỉnh Thái Nguyên","code":"05569","parent_code":"167"},"05572":{"name":"Xã Đồng Thịnh","type":"xa","slug":"xa-dong-thinh","name_with_type":"Xã Đồng Thịnh","path":"Xã Đồng Thịnh, Huyện Định Hóa, Tỉnh Thái Nguyên","path_with_type":"Xã Đồng Thịnh, Huyện Định Hóa, Tỉnh Thái Nguyên","code":"05572","parent_code":"167"},"05575":{"name":"Xã Định Biên","type":"xa","slug":"xa-dinh-bien","name_with_type":"Xã Định Biên","path":"Xã Định Biên, Huyện Định Hóa, Tỉnh Thái Nguyên","path_with_type":"Xã Định Biên, Huyện Định Hóa, Tỉnh Thái Nguyên","code":"05575","parent_code":"167"},"05578":{"name":"Xã Thanh Định","type":"xa","slug":"xa-thanh-dinh","name_with_type":"Xã Thanh Định","path":"Xã Thanh Định, Huyện Định Hóa, Tỉnh Thái Nguyên","path_with_type":"Xã Thanh Định, Huyện Định Hóa, Tỉnh Thái Nguyên","code":"05578","parent_code":"167"},"05581":{"name":"Xã Trung Hội","type":"xa","slug":"xa-trung-hoi","name_with_type":"Xã Trung Hội","path":"Xã Trung Hội, Huyện Định Hóa, Tỉnh Thái Nguyên","path_with_type":"Xã Trung Hội, Huyện Định Hóa, Tỉnh Thái Nguyên","code":"05581","parent_code":"167"},"05584":{"name":"Xã Trung Lương","type":"xa","slug":"xa-trung-luong","name_with_type":"Xã Trung Lương","path":"Xã Trung Lương, Huyện Định Hóa, Tỉnh Thái Nguyên","path_with_type":"Xã Trung Lương, Huyện Định Hóa, Tỉnh Thái Nguyên","code":"05584","parent_code":"167"},"05587":{"name":"Xã Bình Yên","type":"xa","slug":"xa-binh-yen","name_with_type":"Xã Bình Yên","path":"Xã Bình Yên, Huyện Định Hóa, Tỉnh Thái Nguyên","path_with_type":"Xã Bình Yên, Huyện Định Hóa, Tỉnh Thái Nguyên","code":"05587","parent_code":"167"},"05590":{"name":"Xã Điềm Mặc","type":"xa","slug":"xa-diem-mac","name_with_type":"Xã Điềm Mặc","path":"Xã Điềm Mặc, Huyện Định Hóa, Tỉnh Thái Nguyên","path_with_type":"Xã Điềm Mặc, Huyện Định Hóa, Tỉnh Thái Nguyên","code":"05590","parent_code":"167"},"05593":{"name":"Xã Phú Tiến","type":"xa","slug":"xa-phu-tien","name_with_type":"Xã Phú Tiến","path":"Xã Phú Tiến, Huyện Định Hóa, Tỉnh Thái Nguyên","path_with_type":"Xã Phú Tiến, Huyện Định Hóa, Tỉnh Thái Nguyên","code":"05593","parent_code":"167"},"05596":{"name":"Xã Bộc Nhiêu","type":"xa","slug":"xa-boc-nhieu","name_with_type":"Xã Bộc Nhiêu","path":"Xã Bộc Nhiêu, Huyện Định Hóa, Tỉnh Thái Nguyên","path_with_type":"Xã Bộc Nhiêu, Huyện Định Hóa, Tỉnh Thái Nguyên","code":"05596","parent_code":"167"},"05599":{"name":"Xã Sơn Phú","type":"xa","slug":"xa-son-phu","name_with_type":"Xã Sơn Phú","path":"Xã Sơn Phú, Huyện Định Hóa, Tỉnh Thái Nguyên","path_with_type":"Xã Sơn Phú, Huyện Định Hóa, Tỉnh Thái Nguyên","code":"05599","parent_code":"167"},"05602":{"name":"Xã Phú Đình","type":"xa","slug":"xa-phu-dinh","name_with_type":"Xã Phú Đình","path":"Xã Phú Đình, Huyện Định Hóa, Tỉnh Thái Nguyên","path_with_type":"Xã Phú Đình, Huyện Định Hóa, Tỉnh Thái Nguyên","code":"05602","parent_code":"167"},"05605":{"name":"Xã Bình Thành","type":"xa","slug":"xa-binh-thanh","name_with_type":"Xã Bình Thành","path":"Xã Bình Thành, Huyện Định Hóa, Tỉnh Thái Nguyên","path_with_type":"Xã Bình Thành, Huyện Định Hóa, Tỉnh Thái Nguyên","code":"05605","parent_code":"167"},"05611":{"name":"Thị trấn Đu","type":"thi-tran","slug":"thi-tran-du","name_with_type":"Thị trấn Đu","path":"Thị trấn Đu, Huyện Phú Lương, Tỉnh Thái Nguyên","path_with_type":"Thị trấn Đu, Huyện Phú Lương, Tỉnh Thái Nguyên","code":"05611","parent_code":"168"},"05614":{"name":"Xã Yên Ninh","type":"xa","slug":"xa-yen-ninh","name_with_type":"Xã Yên Ninh","path":"Xã Yên Ninh, Huyện Phú Lương, Tỉnh Thái Nguyên","path_with_type":"Xã Yên Ninh, Huyện Phú Lương, Tỉnh Thái Nguyên","code":"05614","parent_code":"168"},"05617":{"name":"Xã Yên Trạch","type":"xa","slug":"xa-yen-trach","name_with_type":"Xã Yên Trạch","path":"Xã Yên Trạch, Huyện Phú Lương, Tỉnh Thái Nguyên","path_with_type":"Xã Yên Trạch, Huyện Phú Lương, Tỉnh Thái Nguyên","code":"05617","parent_code":"168"},"05620":{"name":"Xã Yên Đổ","type":"xa","slug":"xa-yen-do","name_with_type":"Xã Yên Đổ","path":"Xã Yên Đổ, Huyện Phú Lương, Tỉnh Thái Nguyên","path_with_type":"Xã Yên Đổ, Huyện Phú Lương, Tỉnh Thái Nguyên","code":"05620","parent_code":"168"},"05623":{"name":"Xã Yên Lạc","type":"xa","slug":"xa-yen-lac","name_with_type":"Xã Yên Lạc","path":"Xã Yên Lạc, Huyện Phú Lương, Tỉnh Thái Nguyên","path_with_type":"Xã Yên Lạc, Huyện Phú Lương, Tỉnh Thái Nguyên","code":"05623","parent_code":"168"},"05626":{"name":"Xã Ôn Lương","type":"xa","slug":"xa-on-luong","name_with_type":"Xã Ôn Lương","path":"Xã Ôn Lương, Huyện Phú Lương, Tỉnh Thái Nguyên","path_with_type":"Xã Ôn Lương, Huyện Phú Lương, Tỉnh Thái Nguyên","code":"05626","parent_code":"168"},"05629":{"name":"Xã Động Đạt","type":"xa","slug":"xa-dong-dat","name_with_type":"Xã Động Đạt","path":"Xã Động Đạt, Huyện Phú Lương, Tỉnh Thái Nguyên","path_with_type":"Xã Động Đạt, Huyện Phú Lương, Tỉnh Thái Nguyên","code":"05629","parent_code":"168"},"05632":{"name":"Xã Phủ Lý","type":"xa","slug":"xa-phu-ly","name_with_type":"Xã Phủ Lý","path":"Xã Phủ Lý, Huyện Phú Lương, Tỉnh Thái Nguyên","path_with_type":"Xã Phủ Lý, Huyện Phú Lương, Tỉnh Thái Nguyên","code":"05632","parent_code":"168"},"05635":{"name":"Xã Phú Đô","type":"xa","slug":"xa-phu-do","name_with_type":"Xã Phú Đô","path":"Xã Phú Đô, Huyện Phú Lương, Tỉnh Thái Nguyên","path_with_type":"Xã Phú Đô, Huyện Phú Lương, Tỉnh Thái Nguyên","code":"05635","parent_code":"168"},"05638":{"name":"Xã Hợp Thành","type":"xa","slug":"xa-hop-thanh","name_with_type":"Xã Hợp Thành","path":"Xã Hợp Thành, Huyện Phú Lương, Tỉnh Thái Nguyên","path_with_type":"Xã Hợp Thành, Huyện Phú Lương, Tỉnh Thái Nguyên","code":"05638","parent_code":"168"},"05641":{"name":"Xã Tức Tranh","type":"xa","slug":"xa-tuc-tranh","name_with_type":"Xã Tức Tranh","path":"Xã Tức Tranh, Huyện Phú Lương, Tỉnh Thái Nguyên","path_with_type":"Xã Tức Tranh, Huyện Phú Lương, Tỉnh Thái Nguyên","code":"05641","parent_code":"168"},"05644":{"name":"Thị trấn Giang Tiên","type":"thi-tran","slug":"thi-tran-giang-tien","name_with_type":"Thị trấn Giang Tiên","path":"Thị trấn Giang Tiên, Huyện Phú Lương, Tỉnh Thái Nguyên","path_with_type":"Thị trấn Giang Tiên, Huyện Phú Lương, Tỉnh Thái Nguyên","code":"05644","parent_code":"168"},"05647":{"name":"Xã Vô Tranh","type":"xa","slug":"xa-vo-tranh","name_with_type":"Xã Vô Tranh","path":"Xã Vô Tranh, Huyện Phú Lương, Tỉnh Thái Nguyên","path_with_type":"Xã Vô Tranh, Huyện Phú Lương, Tỉnh Thái Nguyên","code":"05647","parent_code":"168"},"05650":{"name":"Xã Cổ Lũng","type":"xa","slug":"xa-co-lung","name_with_type":"Xã Cổ Lũng","path":"Xã Cổ Lũng, Huyện Phú Lương, Tỉnh Thái Nguyên","path_with_type":"Xã Cổ Lũng, Huyện Phú Lương, Tỉnh Thái Nguyên","code":"05650","parent_code":"168"},"05656":{"name":"Thị trấn Sông Cầu","type":"thi-tran","slug":"thi-tran-song-cau","name_with_type":"Thị trấn Sông Cầu","path":"Thị trấn Sông Cầu, Huyện Đồng Hỷ, Tỉnh Thái Nguyên","path_with_type":"Thị trấn Sông Cầu, Huyện Đồng Hỷ, Tỉnh Thái Nguyên","code":"05656","parent_code":"169"},"05662":{"name":"Thị trấn Trại Cau","type":"thi-tran","slug":"thi-tran-trai-cau","name_with_type":"Thị trấn Trại Cau","path":"Thị trấn Trại Cau, Huyện Đồng Hỷ, Tỉnh Thái Nguyên","path_with_type":"Thị trấn Trại Cau, Huyện Đồng Hỷ, Tỉnh Thái Nguyên","code":"05662","parent_code":"169"},"05665":{"name":"Xã Văn Lăng","type":"xa","slug":"xa-van-lang","name_with_type":"Xã Văn Lăng","path":"Xã Văn Lăng, Huyện Đồng Hỷ, Tỉnh Thái Nguyên","path_with_type":"Xã Văn Lăng, Huyện Đồng Hỷ, Tỉnh Thái Nguyên","code":"05665","parent_code":"169"},"05668":{"name":"Xã Tân Long","type":"xa","slug":"xa-tan-long","name_with_type":"Xã Tân Long","path":"Xã Tân Long, Huyện Đồng Hỷ, Tỉnh Thái Nguyên","path_with_type":"Xã Tân Long, Huyện Đồng Hỷ, Tỉnh Thái Nguyên","code":"05668","parent_code":"169"},"05671":{"name":"Xã Hòa Bình","type":"xa","slug":"xa-hoa-binh","name_with_type":"Xã Hòa Bình","path":"Xã Hòa Bình, Huyện Đồng Hỷ, Tỉnh Thái Nguyên","path_with_type":"Xã Hòa Bình, Huyện Đồng Hỷ, Tỉnh Thái Nguyên","code":"05671","parent_code":"169"},"05674":{"name":"Xã Quang Sơn","type":"xa","slug":"xa-quang-son","name_with_type":"Xã Quang Sơn","path":"Xã Quang Sơn, Huyện Đồng Hỷ, Tỉnh Thái Nguyên","path_with_type":"Xã Quang Sơn, Huyện Đồng Hỷ, Tỉnh Thái Nguyên","code":"05674","parent_code":"169"},"05677":{"name":"Xã Minh Lập","type":"xa","slug":"xa-minh-lap","name_with_type":"Xã Minh Lập","path":"Xã Minh Lập, Huyện Đồng Hỷ, Tỉnh Thái Nguyên","path_with_type":"Xã Minh Lập, Huyện Đồng Hỷ, Tỉnh Thái Nguyên","code":"05677","parent_code":"169"},"05680":{"name":"Xã Văn Hán","type":"xa","slug":"xa-van-han","name_with_type":"Xã Văn Hán","path":"Xã Văn Hán, Huyện Đồng Hỷ, Tỉnh Thái Nguyên","path_with_type":"Xã Văn Hán, Huyện Đồng Hỷ, Tỉnh Thái Nguyên","code":"05680","parent_code":"169"},"05683":{"name":"Xã Hóa Trung","type":"xa","slug":"xa-hoa-trung","name_with_type":"Xã Hóa Trung","path":"Xã Hóa Trung, Huyện Đồng Hỷ, Tỉnh Thái Nguyên","path_with_type":"Xã Hóa Trung, Huyện Đồng Hỷ, Tỉnh Thái Nguyên","code":"05683","parent_code":"169"},"05686":{"name":"Xã Khe Mo","type":"xa","slug":"xa-khe-mo","name_with_type":"Xã Khe Mo","path":"Xã Khe Mo, Huyện Đồng Hỷ, Tỉnh Thái Nguyên","path_with_type":"Xã Khe Mo, Huyện Đồng Hỷ, Tỉnh Thái Nguyên","code":"05686","parent_code":"169"},"05689":{"name":"Xã Cây Thị","type":"xa","slug":"xa-cay-thi","name_with_type":"Xã Cây Thị","path":"Xã Cây Thị, Huyện Đồng Hỷ, Tỉnh Thái Nguyên","path_with_type":"Xã Cây Thị, Huyện Đồng Hỷ, Tỉnh Thái Nguyên","code":"05689","parent_code":"169"},"05692":{"name":"Thị trấn Hóa Thượng","type":"thi-tran","slug":"thi-tran-hoa-thuong","name_with_type":"Thị trấn Hóa Thượng","path":"Thị trấn Hóa Thượng, Huyện Đồng Hỷ, Tỉnh Thái Nguyên","path_with_type":"Thị trấn Hóa Thượng, Huyện Đồng Hỷ, Tỉnh Thái Nguyên","code":"05692","parent_code":"169"},"05698":{"name":"Xã Hợp Tiến","type":"xa","slug":"xa-hop-tien","name_with_type":"Xã Hợp Tiến","path":"Xã Hợp Tiến, Huyện Đồng Hỷ, Tỉnh Thái Nguyên","path_with_type":"Xã Hợp Tiến, Huyện Đồng Hỷ, Tỉnh Thái Nguyên","code":"05698","parent_code":"169"},"05707":{"name":"Xã Nam Hòa","type":"xa","slug":"xa-nam-hoa","name_with_type":"Xã Nam Hòa","path":"Xã Nam Hòa, Huyện Đồng Hỷ, Tỉnh Thái Nguyên","path_with_type":"Xã Nam Hòa, Huyện Đồng Hỷ, Tỉnh Thái Nguyên","code":"05707","parent_code":"169"},"05716":{"name":"Thị trấn Đình Cả","type":"thi-tran","slug":"thi-tran-dinh-ca","name_with_type":"Thị trấn Đình Cả","path":"Thị trấn Đình Cả, Huyện Võ Nhai, Tỉnh Thái Nguyên","path_with_type":"Thị trấn Đình Cả, Huyện Võ Nhai, Tỉnh Thái Nguyên","code":"05716","parent_code":"170"},"05719":{"name":"Xã Sảng Mộc","type":"xa","slug":"xa-sang-moc","name_with_type":"Xã Sảng Mộc","path":"Xã Sảng Mộc, Huyện Võ Nhai, Tỉnh Thái Nguyên","path_with_type":"Xã Sảng Mộc, Huyện Võ Nhai, Tỉnh Thái Nguyên","code":"05719","parent_code":"170"},"05722":{"name":"Xã Nghinh Tường","type":"xa","slug":"xa-nghinh-tuong","name_with_type":"Xã Nghinh Tường","path":"Xã Nghinh Tường, Huyện Võ Nhai, Tỉnh Thái Nguyên","path_with_type":"Xã Nghinh Tường, Huyện Võ Nhai, Tỉnh Thái Nguyên","code":"05722","parent_code":"170"},"05725":{"name":"Xã Thần Xa","type":"xa","slug":"xa-than-xa","name_with_type":"Xã Thần Xa","path":"Xã Thần Xa, Huyện Võ Nhai, Tỉnh Thái Nguyên","path_with_type":"Xã Thần Xa, Huyện Võ Nhai, Tỉnh Thái Nguyên","code":"05725","parent_code":"170"},"05728":{"name":"Xã Vũ Chấn","type":"xa","slug":"xa-vu-chan","name_with_type":"Xã Vũ Chấn","path":"Xã Vũ Chấn, Huyện Võ Nhai, Tỉnh Thái Nguyên","path_with_type":"Xã Vũ Chấn, Huyện Võ Nhai, Tỉnh Thái Nguyên","code":"05728","parent_code":"170"},"05731":{"name":"Xã Thượng Nung","type":"xa","slug":"xa-thuong-nung","name_with_type":"Xã Thượng Nung","path":"Xã Thượng Nung, Huyện Võ Nhai, Tỉnh Thái Nguyên","path_with_type":"Xã Thượng Nung, Huyện Võ Nhai, Tỉnh Thái Nguyên","code":"05731","parent_code":"170"},"05734":{"name":"Xã Phú Thượng","type":"xa","slug":"xa-phu-thuong","name_with_type":"Xã Phú Thượng","path":"Xã Phú Thượng, Huyện Võ Nhai, Tỉnh Thái Nguyên","path_with_type":"Xã Phú Thượng, Huyện Võ Nhai, Tỉnh Thái Nguyên","code":"05734","parent_code":"170"},"05737":{"name":"Xã Cúc Đường","type":"xa","slug":"xa-cuc-duong","name_with_type":"Xã Cúc Đường","path":"Xã Cúc Đường, Huyện Võ Nhai, Tỉnh Thái Nguyên","path_with_type":"Xã Cúc Đường, Huyện Võ Nhai, Tỉnh Thái Nguyên","code":"05737","parent_code":"170"},"05740":{"name":"Xã La Hiên","type":"xa","slug":"xa-la-hien","name_with_type":"Xã La Hiên","path":"Xã La Hiên, Huyện Võ Nhai, Tỉnh Thái Nguyên","path_with_type":"Xã La Hiên, Huyện Võ Nhai, Tỉnh Thái Nguyên","code":"05740","parent_code":"170"},"05743":{"name":"Xã Lâu Thượng","type":"xa","slug":"xa-lau-thuong","name_with_type":"Xã Lâu Thượng","path":"Xã Lâu Thượng, Huyện Võ Nhai, Tỉnh Thái Nguyên","path_with_type":"Xã Lâu Thượng, Huyện Võ Nhai, Tỉnh Thái Nguyên","code":"05743","parent_code":"170"},"05746":{"name":"Xã Tràng Xá","type":"xa","slug":"xa-trang-xa","name_with_type":"Xã Tràng Xá","path":"Xã Tràng Xá, Huyện Võ Nhai, Tỉnh Thái Nguyên","path_with_type":"Xã Tràng Xá, Huyện Võ Nhai, Tỉnh Thái Nguyên","code":"05746","parent_code":"170"},"05749":{"name":"Xã Phương Giao","type":"xa","slug":"xa-phuong-giao","name_with_type":"Xã Phương Giao","path":"Xã Phương Giao, Huyện Võ Nhai, Tỉnh Thái Nguyên","path_with_type":"Xã Phương Giao, Huyện Võ Nhai, Tỉnh Thái Nguyên","code":"05749","parent_code":"170"},"05752":{"name":"Xã Liên Minh","type":"xa","slug":"xa-lien-minh","name_with_type":"Xã Liên Minh","path":"Xã Liên Minh, Huyện Võ Nhai, Tỉnh Thái Nguyên","path_with_type":"Xã Liên Minh, Huyện Võ Nhai, Tỉnh Thái Nguyên","code":"05752","parent_code":"170"},"05755":{"name":"Xã Dân Tiến","type":"xa","slug":"xa-dan-tien","name_with_type":"Xã Dân Tiến","path":"Xã Dân Tiến, Huyện Võ Nhai, Tỉnh Thái Nguyên","path_with_type":"Xã Dân Tiến, Huyện Võ Nhai, Tỉnh Thái Nguyên","code":"05755","parent_code":"170"},"05758":{"name":"Xã Bình Long","type":"xa","slug":"xa-binh-long","name_with_type":"Xã Bình Long","path":"Xã Bình Long, Huyện Võ Nhai, Tỉnh Thái Nguyên","path_with_type":"Xã Bình Long, Huyện Võ Nhai, Tỉnh Thái Nguyên","code":"05758","parent_code":"170"},"05761":{"name":"Thị trấn Hùng Sơn","type":"thi-tran","slug":"thi-tran-hung-son","name_with_type":"Thị trấn Hùng Sơn","path":"Thị trấn Hùng Sơn, Huyện Đại Từ, Tỉnh Thái Nguyên","path_with_type":"Thị trấn Hùng Sơn, Huyện Đại Từ, Tỉnh Thái Nguyên","code":"05761","parent_code":"171"},"05767":{"name":"Xã Phúc Lương","type":"xa","slug":"xa-phuc-luong","name_with_type":"Xã Phúc Lương","path":"Xã Phúc Lương, Huyện Đại Từ, Tỉnh Thái Nguyên","path_with_type":"Xã Phúc Lương, Huyện Đại Từ, Tỉnh Thái Nguyên","code":"05767","parent_code":"171"},"05770":{"name":"Xã Minh Tiến","type":"xa","slug":"xa-minh-tien","name_with_type":"Xã Minh Tiến","path":"Xã Minh Tiến, Huyện Đại Từ, Tỉnh Thái Nguyên","path_with_type":"Xã Minh Tiến, Huyện Đại Từ, Tỉnh Thái Nguyên","code":"05770","parent_code":"171"},"05773":{"name":"Xã Yên Lãng","type":"xa","slug":"xa-yen-lang","name_with_type":"Xã Yên Lãng","path":"Xã Yên Lãng, Huyện Đại Từ, Tỉnh Thái Nguyên","path_with_type":"Xã Yên Lãng, Huyện Đại Từ, Tỉnh Thái Nguyên","code":"05773","parent_code":"171"},"05776":{"name":"Xã Đức Lương","type":"xa","slug":"xa-duc-luong","name_with_type":"Xã Đức Lương","path":"Xã Đức Lương, Huyện Đại Từ, Tỉnh Thái Nguyên","path_with_type":"Xã Đức Lương, Huyện Đại Từ, Tỉnh Thái Nguyên","code":"05776","parent_code":"171"},"05779":{"name":"Xã Phú Cường","type":"xa","slug":"xa-phu-cuong","name_with_type":"Xã Phú Cường","path":"Xã Phú Cường, Huyện Đại Từ, Tỉnh Thái Nguyên","path_with_type":"Xã Phú Cường, Huyện Đại Từ, Tỉnh Thái Nguyên","code":"05779","parent_code":"171"},"05785":{"name":"Xã Phú Lạc","type":"xa","slug":"xa-phu-lac","name_with_type":"Xã Phú Lạc","path":"Xã Phú Lạc, Huyện Đại Từ, Tỉnh Thái Nguyên","path_with_type":"Xã Phú Lạc, Huyện Đại Từ, Tỉnh Thái Nguyên","code":"05785","parent_code":"171"},"05788":{"name":"Xã Tân Linh","type":"xa","slug":"xa-tan-linh","name_with_type":"Xã Tân Linh","path":"Xã Tân Linh, Huyện Đại Từ, Tỉnh Thái Nguyên","path_with_type":"Xã Tân Linh, Huyện Đại Từ, Tỉnh Thái Nguyên","code":"05788","parent_code":"171"},"05791":{"name":"Xã Phú Thịnh","type":"xa","slug":"xa-phu-thinh","name_with_type":"Xã Phú Thịnh","path":"Xã Phú Thịnh, Huyện Đại Từ, Tỉnh Thái Nguyên","path_with_type":"Xã Phú Thịnh, Huyện Đại Từ, Tỉnh Thái Nguyên","code":"05791","parent_code":"171"},"05794":{"name":"Xã Phục Linh","type":"xa","slug":"xa-phuc-linh","name_with_type":"Xã Phục Linh","path":"Xã Phục Linh, Huyện Đại Từ, Tỉnh Thái Nguyên","path_with_type":"Xã Phục Linh, Huyện Đại Từ, Tỉnh Thái Nguyên","code":"05794","parent_code":"171"},"05797":{"name":"Xã Phú Xuyên","type":"xa","slug":"xa-phu-xuyen","name_with_type":"Xã Phú Xuyên","path":"Xã Phú Xuyên, Huyện Đại Từ, Tỉnh Thái Nguyên","path_with_type":"Xã Phú Xuyên, Huyện Đại Từ, Tỉnh Thái Nguyên","code":"05797","parent_code":"171"},"05800":{"name":"Xã Bản Ngoại","type":"xa","slug":"xa-ban-ngoai","name_with_type":"Xã Bản Ngoại","path":"Xã Bản Ngoại, Huyện Đại Từ, Tỉnh Thái Nguyên","path_with_type":"Xã Bản Ngoại, Huyện Đại Từ, Tỉnh Thái Nguyên","code":"05800","parent_code":"171"},"05803":{"name":"Xã Tiên Hội","type":"xa","slug":"xa-tien-hoi","name_with_type":"Xã Tiên Hội","path":"Xã Tiên Hội, Huyện Đại Từ, Tỉnh Thái Nguyên","path_with_type":"Xã Tiên Hội, Huyện Đại Từ, Tỉnh Thái Nguyên","code":"05803","parent_code":"171"},"05809":{"name":"Xã Cù Vân","type":"xa","slug":"xa-cu-van","name_with_type":"Xã Cù Vân","path":"Xã Cù Vân, Huyện Đại Từ, Tỉnh Thái Nguyên","path_with_type":"Xã Cù Vân, Huyện Đại Từ, Tỉnh Thái Nguyên","code":"05809","parent_code":"171"},"05812":{"name":"Xã Hà Thượng","type":"xa","slug":"xa-ha-thuong","name_with_type":"Xã Hà Thượng","path":"Xã Hà Thượng, Huyện Đại Từ, Tỉnh Thái Nguyên","path_with_type":"Xã Hà Thượng, Huyện Đại Từ, Tỉnh Thái Nguyên","code":"05812","parent_code":"171"},"05815":{"name":"Xã La Bằng","type":"xa","slug":"xa-la-bang","name_with_type":"Xã La Bằng","path":"Xã La Bằng, Huyện Đại Từ, Tỉnh Thái Nguyên","path_with_type":"Xã La Bằng, Huyện Đại Từ, Tỉnh Thái Nguyên","code":"05815","parent_code":"171"},"05818":{"name":"Xã Hoàng Nông","type":"xa","slug":"xa-hoang-nong","name_with_type":"Xã Hoàng Nông","path":"Xã Hoàng Nông, Huyện Đại Từ, Tỉnh Thái Nguyên","path_with_type":"Xã Hoàng Nông, Huyện Đại Từ, Tỉnh Thái Nguyên","code":"05818","parent_code":"171"},"05821":{"name":"Xã Khôi Kỳ","type":"xa","slug":"xa-khoi-ky","name_with_type":"Xã Khôi Kỳ","path":"Xã Khôi Kỳ, Huyện Đại Từ, Tỉnh Thái Nguyên","path_with_type":"Xã Khôi Kỳ, Huyện Đại Từ, Tỉnh Thái Nguyên","code":"05821","parent_code":"171"},"05824":{"name":"Xã An Khánh","type":"xa","slug":"xa-an-khanh","name_with_type":"Xã An Khánh","path":"Xã An Khánh, Huyện Đại Từ, Tỉnh Thái Nguyên","path_with_type":"Xã An Khánh, Huyện Đại Từ, Tỉnh Thái Nguyên","code":"05824","parent_code":"171"},"05827":{"name":"Xã Tân Thái","type":"xa","slug":"xa-tan-thai","name_with_type":"Xã Tân Thái","path":"Xã Tân Thái, Huyện Đại Từ, Tỉnh Thái Nguyên","path_with_type":"Xã Tân Thái, Huyện Đại Từ, Tỉnh Thái Nguyên","code":"05827","parent_code":"171"},"05830":{"name":"Xã Bình Thuận","type":"xa","slug":"xa-binh-thuan","name_with_type":"Xã Bình Thuận","path":"Xã Bình Thuận, Huyện Đại Từ, Tỉnh Thái Nguyên","path_with_type":"Xã Bình Thuận, Huyện Đại Từ, Tỉnh Thái Nguyên","code":"05830","parent_code":"171"},"05833":{"name":"Xã Lục Ba","type":"xa","slug":"xa-luc-ba","name_with_type":"Xã Lục Ba","path":"Xã Lục Ba, Huyện Đại Từ, Tỉnh Thái Nguyên","path_with_type":"Xã Lục Ba, Huyện Đại Từ, Tỉnh Thái Nguyên","code":"05833","parent_code":"171"},"05836":{"name":"Xã Mỹ Yên","type":"xa","slug":"xa-my-yen","name_with_type":"Xã Mỹ Yên","path":"Xã Mỹ Yên, Huyện Đại Từ, Tỉnh Thái Nguyên","path_with_type":"Xã Mỹ Yên, Huyện Đại Từ, Tỉnh Thái Nguyên","code":"05836","parent_code":"171"},"05842":{"name":"Xã Văn Yên","type":"xa","slug":"xa-van-yen","name_with_type":"Xã Văn Yên","path":"Xã Văn Yên, Huyện Đại Từ, Tỉnh Thái Nguyên","path_with_type":"Xã Văn Yên, Huyện Đại Từ, Tỉnh Thái Nguyên","code":"05842","parent_code":"171"},"05845":{"name":"Xã Vạn Phú","type":"xa","slug":"xa-van-phu","name_with_type":"Xã Vạn Phú","path":"Xã Vạn Phú, Huyện Đại Từ, Tỉnh Thái Nguyên","path_with_type":"Xã Vạn Phú, Huyện Đại Từ, Tỉnh Thái Nguyên","code":"05845","parent_code":"171"},"05848":{"name":"Xã Cát Nê","type":"xa","slug":"xa-cat-ne","name_with_type":"Xã Cát Nê","path":"Xã Cát Nê, Huyện Đại Từ, Tỉnh Thái Nguyên","path_with_type":"Xã Cát Nê, Huyện Đại Từ, Tỉnh Thái Nguyên","code":"05848","parent_code":"171"},"05851":{"name":"Thị trấn Quân Chu","type":"thi-tran","slug":"thi-tran-quan-chu","name_with_type":"Thị trấn Quân Chu","path":"Thị trấn Quân Chu, Huyện Đại Từ, Tỉnh Thái Nguyên","path_with_type":"Thị trấn Quân Chu, Huyện Đại Từ, Tỉnh Thái Nguyên","code":"05851","parent_code":"171"},"05854":{"name":"Phường Bãi Bông","type":"phuong","slug":"phuong-bai-bong","name_with_type":"Phường Bãi Bông","path":"Phường Bãi Bông, Thành phố Phổ Yên, Tỉnh Thái Nguyên","path_with_type":"Phường Bãi Bông, Thành phố Phổ Yên, Tỉnh Thái Nguyên","code":"05854","parent_code":"172"},"05857":{"name":"Phường Bắc Sơn","type":"phuong","slug":"phuong-bac-son","name_with_type":"Phường Bắc Sơn","path":"Phường Bắc Sơn, Thành phố Phổ Yên, Tỉnh Thái Nguyên","path_with_type":"Phường Bắc Sơn, Thành phố Phổ Yên, Tỉnh Thái Nguyên","code":"05857","parent_code":"172"},"05860":{"name":"Phường Ba Hàng","type":"phuong","slug":"phuong-ba-hang","name_with_type":"Phường Ba Hàng","path":"Phường Ba Hàng, Thành phố Phổ Yên, Tỉnh Thái Nguyên","path_with_type":"Phường Ba Hàng, Thành phố Phổ Yên, Tỉnh Thái Nguyên","code":"05860","parent_code":"172"},"05863":{"name":"Xã Phúc Tân","type":"xa","slug":"xa-phuc-tan","name_with_type":"Xã Phúc Tân","path":"Xã Phúc Tân, Thành phố Phổ Yên, Tỉnh Thái Nguyên","path_with_type":"Xã Phúc Tân, Thành phố Phổ Yên, Tỉnh Thái Nguyên","code":"05863","parent_code":"172"},"05866":{"name":"Xã Phúc Thuận","type":"xa","slug":"xa-phuc-thuan","name_with_type":"Xã Phúc Thuận","path":"Xã Phúc Thuận, Thành phố Phổ Yên, Tỉnh Thái Nguyên","path_with_type":"Xã Phúc Thuận, Thành phố Phổ Yên, Tỉnh Thái Nguyên","code":"05866","parent_code":"172"},"05869":{"name":"Phường Hồng Tiến","type":"phuong","slug":"phuong-hong-tien","name_with_type":"Phường Hồng Tiến","path":"Phường Hồng Tiến, Thành phố Phổ Yên, Tỉnh Thái Nguyên","path_with_type":"Phường Hồng Tiến, Thành phố Phổ Yên, Tỉnh Thái Nguyên","code":"05869","parent_code":"172"},"05872":{"name":"Xã Minh Đức","type":"xa","slug":"xa-minh-duc","name_with_type":"Xã Minh Đức","path":"Xã Minh Đức, Thành phố Phổ Yên, Tỉnh Thái Nguyên","path_with_type":"Xã Minh Đức, Thành phố Phổ Yên, Tỉnh Thái Nguyên","code":"05872","parent_code":"172"},"05875":{"name":"Phường Đắc Sơn","type":"phuong","slug":"phuong-dac-son","name_with_type":"Phường Đắc Sơn","path":"Phường Đắc Sơn, Thành phố Phổ Yên, Tỉnh Thái Nguyên","path_with_type":"Phường Đắc Sơn, Thành phố Phổ Yên, Tỉnh Thái Nguyên","code":"05875","parent_code":"172"},"05878":{"name":"Phường Đồng Tiến","type":"phuong","slug":"phuong-dong-tien","name_with_type":"Phường Đồng Tiến","path":"Phường Đồng Tiến, Thành phố Phổ Yên, Tỉnh Thái Nguyên","path_with_type":"Phường Đồng Tiến, Thành phố Phổ Yên, Tỉnh Thái Nguyên","code":"05878","parent_code":"172"},"05881":{"name":"Xã Thành Công","type":"xa","slug":"xa-thanh-cong","name_with_type":"Xã Thành Công","path":"Xã Thành Công, Thành phố Phổ Yên, Tỉnh Thái Nguyên","path_with_type":"Xã Thành Công, Thành phố Phổ Yên, Tỉnh Thái Nguyên","code":"05881","parent_code":"172"},"05884":{"name":"Phường Tiên Phong","type":"phuong","slug":"phuong-tien-phong","name_with_type":"Phường Tiên Phong","path":"Phường Tiên Phong, Thành phố Phổ Yên, Tỉnh Thái Nguyên","path_with_type":"Phường Tiên Phong, Thành phố Phổ Yên, Tỉnh Thái Nguyên","code":"05884","parent_code":"172"},"05887":{"name":"Xã Vạn Phái","type":"xa","slug":"xa-van-phai","name_with_type":"Xã Vạn Phái","path":"Xã Vạn Phái, Thành phố Phổ Yên, Tỉnh Thái Nguyên","path_with_type":"Xã Vạn Phái, Thành phố Phổ Yên, Tỉnh Thái Nguyên","code":"05887","parent_code":"172"},"05890":{"name":"Phường Nam Tiến","type":"phuong","slug":"phuong-nam-tien","name_with_type":"Phường Nam Tiến","path":"Phường Nam Tiến, Thành phố Phổ Yên, Tỉnh Thái Nguyên","path_with_type":"Phường Nam Tiến, Thành phố Phổ Yên, Tỉnh Thái Nguyên","code":"05890","parent_code":"172"},"05893":{"name":"Phường Tân Hương","type":"phuong","slug":"phuong-tan-huong","name_with_type":"Phường Tân Hương","path":"Phường Tân Hương, Thành phố Phổ Yên, Tỉnh Thái Nguyên","path_with_type":"Phường Tân Hương, Thành phố Phổ Yên, Tỉnh Thái Nguyên","code":"05893","parent_code":"172"},"05896":{"name":"Phường Đông Cao","type":"phuong","slug":"phuong-dong-cao","name_with_type":"Phường Đông Cao","path":"Phường Đông Cao, Thành phố Phổ Yên, Tỉnh Thái Nguyên","path_with_type":"Phường Đông Cao, Thành phố Phổ Yên, Tỉnh Thái Nguyên","code":"05896","parent_code":"172"},"05899":{"name":"Phường Trung Thành","type":"phuong","slug":"phuong-trung-thanh","name_with_type":"Phường Trung Thành","path":"Phường Trung Thành, Thành phố Phổ Yên, Tỉnh Thái Nguyên","path_with_type":"Phường Trung Thành, Thành phố Phổ Yên, Tỉnh Thái Nguyên","code":"05899","parent_code":"172"},"05902":{"name":"Phường Tân Phú","type":"phuong","slug":"phuong-tan-phu","name_with_type":"Phường Tân Phú","path":"Phường Tân Phú, Thành phố Phổ Yên, Tỉnh Thái Nguyên","path_with_type":"Phường Tân Phú, Thành phố Phổ Yên, Tỉnh Thái Nguyên","code":"05902","parent_code":"172"},"05905":{"name":"Phường Thuận Thành","type":"phuong","slug":"phuong-thuan-thanh","name_with_type":"Phường Thuận Thành","path":"Phường Thuận Thành, Thành phố Phổ Yên, Tỉnh Thái Nguyên","path_with_type":"Phường Thuận Thành, Thành phố Phổ Yên, Tỉnh Thái Nguyên","code":"05905","parent_code":"172"},"05908":{"name":"Thị trấn Hương Sơn","type":"thi-tran","slug":"thi-tran-huong-son","name_with_type":"Thị trấn Hương Sơn","path":"Thị trấn Hương Sơn, Huyện Phú Bình, Tỉnh Thái Nguyên","path_with_type":"Thị trấn Hương Sơn, Huyện Phú Bình, Tỉnh Thái Nguyên","code":"05908","parent_code":"173"},"05911":{"name":"Xã Bàn Đạt","type":"xa","slug":"xa-ban-dat","name_with_type":"Xã Bàn Đạt","path":"Xã Bàn Đạt, Huyện Phú Bình, Tỉnh Thái Nguyên","path_with_type":"Xã Bàn Đạt, Huyện Phú Bình, Tỉnh Thái Nguyên","code":"05911","parent_code":"173"},"05917":{"name":"Xã Tân Khánh","type":"xa","slug":"xa-tan-khanh","name_with_type":"Xã Tân Khánh","path":"Xã Tân Khánh, Huyện Phú Bình, Tỉnh Thái Nguyên","path_with_type":"Xã Tân Khánh, Huyện Phú Bình, Tỉnh Thái Nguyên","code":"05917","parent_code":"173"},"05920":{"name":"Xã Tân Kim","type":"xa","slug":"xa-tan-kim","name_with_type":"Xã Tân Kim","path":"Xã Tân Kim, Huyện Phú Bình, Tỉnh Thái Nguyên","path_with_type":"Xã Tân Kim, Huyện Phú Bình, Tỉnh Thái Nguyên","code":"05920","parent_code":"173"},"05923":{"name":"Xã Tân Thành","type":"xa","slug":"xa-tan-thanh","name_with_type":"Xã Tân Thành","path":"Xã Tân Thành, Huyện Phú Bình, Tỉnh Thái Nguyên","path_with_type":"Xã Tân Thành, Huyện Phú Bình, Tỉnh Thái Nguyên","code":"05923","parent_code":"173"},"05926":{"name":"Xã Đào Xá","type":"xa","slug":"xa-dao-xa","name_with_type":"Xã Đào Xá","path":"Xã Đào Xá, Huyện Phú Bình, Tỉnh Thái Nguyên","path_with_type":"Xã Đào Xá, Huyện Phú Bình, Tỉnh Thái Nguyên","code":"05926","parent_code":"173"},"05929":{"name":"Xã Bảo Lý","type":"xa","slug":"xa-bao-ly","name_with_type":"Xã Bảo Lý","path":"Xã Bảo Lý, Huyện Phú Bình, Tỉnh Thái Nguyên","path_with_type":"Xã Bảo Lý, Huyện Phú Bình, Tỉnh Thái Nguyên","code":"05929","parent_code":"173"},"05932":{"name":"Xã Thượng Đình","type":"xa","slug":"xa-thuong-dinh","name_with_type":"Xã Thượng Đình","path":"Xã Thượng Đình, Huyện Phú Bình, Tỉnh Thái Nguyên","path_with_type":"Xã Thượng Đình, Huyện Phú Bình, Tỉnh Thái Nguyên","code":"05932","parent_code":"173"},"05935":{"name":"Xã Tân Hòa","type":"xa","slug":"xa-tan-hoa","name_with_type":"Xã Tân Hòa","path":"Xã Tân Hòa, Huyện Phú Bình, Tỉnh Thái Nguyên","path_with_type":"Xã Tân Hòa, Huyện Phú Bình, Tỉnh Thái Nguyên","code":"05935","parent_code":"173"},"05938":{"name":"Xã Nhã Lộng","type":"xa","slug":"xa-nha-long","name_with_type":"Xã Nhã Lộng","path":"Xã Nhã Lộng, Huyện Phú Bình, Tỉnh Thái Nguyên","path_with_type":"Xã Nhã Lộng, Huyện Phú Bình, Tỉnh Thái Nguyên","code":"05938","parent_code":"173"},"05941":{"name":"Xã Điềm Thụy","type":"xa","slug":"xa-diem-thuy","name_with_type":"Xã Điềm Thụy","path":"Xã Điềm Thụy, Huyện Phú Bình, Tỉnh Thái Nguyên","path_with_type":"Xã Điềm Thụy, Huyện Phú Bình, Tỉnh Thái Nguyên","code":"05941","parent_code":"173"},"05944":{"name":"Xã Xuân Phương","type":"xa","slug":"xa-xuan-phuong","name_with_type":"Xã Xuân Phương","path":"Xã Xuân Phương, Huyện Phú Bình, Tỉnh Thái Nguyên","path_with_type":"Xã Xuân Phương, Huyện Phú Bình, Tỉnh Thái Nguyên","code":"05944","parent_code":"173"},"05947":{"name":"Xã Tân Đức","type":"xa","slug":"xa-tan-duc","name_with_type":"Xã Tân Đức","path":"Xã Tân Đức, Huyện Phú Bình, Tỉnh Thái Nguyên","path_with_type":"Xã Tân Đức, Huyện Phú Bình, Tỉnh Thái Nguyên","code":"05947","parent_code":"173"},"05950":{"name":"Xã Úc Kỳ","type":"xa","slug":"xa-uc-ky","name_with_type":"Xã Úc Kỳ","path":"Xã Úc Kỳ, Huyện Phú Bình, Tỉnh Thái Nguyên","path_with_type":"Xã Úc Kỳ, Huyện Phú Bình, Tỉnh Thái Nguyên","code":"05950","parent_code":"173"},"05953":{"name":"Xã Lương Phú","type":"xa","slug":"xa-luong-phu","name_with_type":"Xã Lương Phú","path":"Xã Lương Phú, Huyện Phú Bình, Tỉnh Thái Nguyên","path_with_type":"Xã Lương Phú, Huyện Phú Bình, Tỉnh Thái Nguyên","code":"05953","parent_code":"173"},"05956":{"name":"Xã Nga My","type":"xa","slug":"xa-nga-my","name_with_type":"Xã Nga My","path":"Xã Nga My, Huyện Phú Bình, Tỉnh Thái Nguyên","path_with_type":"Xã Nga My, Huyện Phú Bình, Tỉnh Thái Nguyên","code":"05956","parent_code":"173"},"05959":{"name":"Xã Kha Sơn","type":"xa","slug":"xa-kha-son","name_with_type":"Xã Kha Sơn","path":"Xã Kha Sơn, Huyện Phú Bình, Tỉnh Thái Nguyên","path_with_type":"Xã Kha Sơn, Huyện Phú Bình, Tỉnh Thái Nguyên","code":"05959","parent_code":"173"},"05962":{"name":"Xã Thanh Ninh","type":"xa","slug":"xa-thanh-ninh","name_with_type":"Xã Thanh Ninh","path":"Xã Thanh Ninh, Huyện Phú Bình, Tỉnh Thái Nguyên","path_with_type":"Xã Thanh Ninh, Huyện Phú Bình, Tỉnh Thái Nguyên","code":"05962","parent_code":"173"},"05965":{"name":"Xã Dương Thành","type":"xa","slug":"xa-duong-thanh","name_with_type":"Xã Dương Thành","path":"Xã Dương Thành, Huyện Phú Bình, Tỉnh Thái Nguyên","path_with_type":"Xã Dương Thành, Huyện Phú Bình, Tỉnh Thái Nguyên","code":"05965","parent_code":"173"},"05968":{"name":"Xã Hà Châu","type":"xa","slug":"xa-ha-chau","name_with_type":"Xã Hà Châu","path":"Xã Hà Châu, Huyện Phú Bình, Tỉnh Thái Nguyên","path_with_type":"Xã Hà Châu, Huyện Phú Bình, Tỉnh Thái Nguyên","code":"05968","parent_code":"173"},"05971":{"name":"Phường Hoàng Văn Thụ","type":"phuong","slug":"phuong-hoang-van-thu","name_with_type":"Phường Hoàng Văn Thụ","path":"Phường Hoàng Văn Thụ, Thành phố Lạng Sơn, Tỉnh Lạng Sơn","path_with_type":"Phường Hoàng Văn Thụ, Thành phố Lạng Sơn, Tỉnh Lạng Sơn","code":"05971","parent_code":"178"},"05974":{"name":"Phường Tam Thanh","type":"phuong","slug":"phuong-tam-thanh","name_with_type":"Phường Tam Thanh","path":"Phường Tam Thanh, Thành phố Lạng Sơn, Tỉnh Lạng Sơn","path_with_type":"Phường Tam Thanh, Thành phố Lạng Sơn, Tỉnh Lạng Sơn","code":"05974","parent_code":"178"},"05977":{"name":"Phường Vĩnh Trại","type":"phuong","slug":"phuong-vinh-trai","name_with_type":"Phường Vĩnh Trại","path":"Phường Vĩnh Trại, Thành phố Lạng Sơn, Tỉnh Lạng Sơn","path_with_type":"Phường Vĩnh Trại, Thành phố Lạng Sơn, Tỉnh Lạng Sơn","code":"05977","parent_code":"178"},"05980":{"name":"Phường Đông Kinh","type":"phuong","slug":"phuong-dong-kinh","name_with_type":"Phường Đông Kinh","path":"Phường Đông Kinh, Thành phố Lạng Sơn, Tỉnh Lạng Sơn","path_with_type":"Phường Đông Kinh, Thành phố Lạng Sơn, Tỉnh Lạng Sơn","code":"05980","parent_code":"178"},"05983":{"name":"Phường Chi Lăng","type":"phuong","slug":"phuong-chi-lang","name_with_type":"Phường Chi Lăng","path":"Phường Chi Lăng, Thành phố Lạng Sơn, Tỉnh Lạng Sơn","path_with_type":"Phường Chi Lăng, Thành phố Lạng Sơn, Tỉnh Lạng Sơn","code":"05983","parent_code":"178"},"05986":{"name":"Xã Hoàng Đồng","type":"xa","slug":"xa-hoang-dong","name_with_type":"Xã Hoàng Đồng","path":"Xã Hoàng Đồng, Thành phố Lạng Sơn, Tỉnh Lạng Sơn","path_with_type":"Xã Hoàng Đồng, Thành phố Lạng Sơn, Tỉnh Lạng Sơn","code":"05986","parent_code":"178"},"05989":{"name":"Xã Quảng Lạc","type":"xa","slug":"xa-quang-lac","name_with_type":"Xã Quảng Lạc","path":"Xã Quảng Lạc, Thành phố Lạng Sơn, Tỉnh Lạng Sơn","path_with_type":"Xã Quảng Lạc, Thành phố Lạng Sơn, Tỉnh Lạng Sơn","code":"05989","parent_code":"178"},"05992":{"name":"Xã Mai Pha","type":"xa","slug":"xa-mai-pha","name_with_type":"Xã Mai Pha","path":"Xã Mai Pha, Thành phố Lạng Sơn, Tỉnh Lạng Sơn","path_with_type":"Xã Mai Pha, Thành phố Lạng Sơn, Tỉnh Lạng Sơn","code":"05992","parent_code":"178"},"05998":{"name":"Xã Khánh Long","type":"xa","slug":"xa-khanh-long","name_with_type":"Xã Khánh Long","path":"Xã Khánh Long, Huyện Tràng Định, Tỉnh Lạng Sơn","path_with_type":"Xã Khánh Long, Huyện Tràng Định, Tỉnh Lạng Sơn","code":"05998","parent_code":"180"},"06001":{"name":"Xã Đoàn Kết","type":"xa","slug":"xa-doan-ket","name_with_type":"Xã Đoàn Kết","path":"Xã Đoàn Kết, Huyện Tràng Định, Tỉnh Lạng Sơn","path_with_type":"Xã Đoàn Kết, Huyện Tràng Định, Tỉnh Lạng Sơn","code":"06001","parent_code":"180"},"06004":{"name":"Xã Quốc Khánh","type":"xa","slug":"xa-quoc-khanh","name_with_type":"Xã Quốc Khánh","path":"Xã Quốc Khánh, Huyện Tràng Định, Tỉnh Lạng Sơn","path_with_type":"Xã Quốc Khánh, Huyện Tràng Định, Tỉnh Lạng Sơn","code":"06004","parent_code":"180"},"06010":{"name":"Xã Cao Minh","type":"xa","slug":"xa-cao-minh","name_with_type":"Xã Cao Minh","path":"Xã Cao Minh, Huyện Tràng Định, Tỉnh Lạng Sơn","path_with_type":"Xã Cao Minh, Huyện Tràng Định, Tỉnh Lạng Sơn","code":"06010","parent_code":"180"},"06013":{"name":"Xã Chí Minh","type":"xa","slug":"xa-chi-minh","name_with_type":"Xã Chí Minh","path":"Xã Chí Minh, Huyện Tràng Định, Tỉnh Lạng Sơn","path_with_type":"Xã Chí Minh, Huyện Tràng Định, Tỉnh Lạng Sơn","code":"06013","parent_code":"180"},"06016":{"name":"Xã Tri Phương","type":"xa","slug":"xa-tri-phuong","name_with_type":"Xã Tri Phương","path":"Xã Tri Phương, Huyện Tràng Định, Tỉnh Lạng Sơn","path_with_type":"Xã Tri Phương, Huyện Tràng Định, Tỉnh Lạng Sơn","code":"06016","parent_code":"180"},"06019":{"name":"Xã Tân Tiến","type":"xa","slug":"xa-tan-tien","name_with_type":"Xã Tân Tiến","path":"Xã Tân Tiến, Huyện Tràng Định, Tỉnh Lạng Sơn","path_with_type":"Xã Tân Tiến, Huyện Tràng Định, Tỉnh Lạng Sơn","code":"06019","parent_code":"180"},"06022":{"name":"Xã Tân Yên","type":"xa","slug":"xa-tan-yen","name_with_type":"Xã Tân Yên","path":"Xã Tân Yên, Huyện Tràng Định, Tỉnh Lạng Sơn","path_with_type":"Xã Tân Yên, Huyện Tràng Định, Tỉnh Lạng Sơn","code":"06022","parent_code":"180"},"06025":{"name":"Xã Đội Cấn","type":"xa","slug":"xa-doi-can","name_with_type":"Xã Đội Cấn","path":"Xã Đội Cấn, Huyện Tràng Định, Tỉnh Lạng Sơn","path_with_type":"Xã Đội Cấn, Huyện Tràng Định, Tỉnh Lạng Sơn","code":"06025","parent_code":"180"},"06028":{"name":"Xã Tân Minh","type":"xa","slug":"xa-tan-minh","name_with_type":"Xã Tân Minh","path":"Xã Tân Minh, Huyện Tràng Định, Tỉnh Lạng Sơn","path_with_type":"Xã Tân Minh, Huyện Tràng Định, Tỉnh Lạng Sơn","code":"06028","parent_code":"180"},"06031":{"name":"Xã Kim Đồng","type":"xa","slug":"xa-kim-dong","name_with_type":"Xã Kim Đồng","path":"Xã Kim Đồng, Huyện Tràng Định, Tỉnh Lạng Sơn","path_with_type":"Xã Kim Đồng, Huyện Tràng Định, Tỉnh Lạng Sơn","code":"06031","parent_code":"180"},"06034":{"name":"Xã Chi Lăng","type":"xa","slug":"xa-chi-lang","name_with_type":"Xã Chi Lăng","path":"Xã Chi Lăng, Huyện Tràng Định, Tỉnh Lạng Sơn","path_with_type":"Xã Chi Lăng, Huyện Tràng Định, Tỉnh Lạng Sơn","code":"06034","parent_code":"180"},"06037":{"name":"Xã Trung Thành","type":"xa","slug":"xa-trung-thanh","name_with_type":"Xã Trung Thành","path":"Xã Trung Thành, Huyện Tràng Định, Tỉnh Lạng Sơn","path_with_type":"Xã Trung Thành, Huyện Tràng Định, Tỉnh Lạng Sơn","code":"06037","parent_code":"180"},"06040":{"name":"Thị trấn Thất Khê","type":"thi-tran","slug":"thi-tran-that-khe","name_with_type":"Thị trấn Thất Khê","path":"Thị trấn Thất Khê, Huyện Tràng Định, Tỉnh Lạng Sơn","path_with_type":"Thị trấn Thất Khê, Huyện Tràng Định, Tỉnh Lạng Sơn","code":"06040","parent_code":"180"},"06043":{"name":"Xã Đào Viên","type":"xa","slug":"xa-dao-vien","name_with_type":"Xã Đào Viên","path":"Xã Đào Viên, Huyện Tràng Định, Tỉnh Lạng Sơn","path_with_type":"Xã Đào Viên, Huyện Tràng Định, Tỉnh Lạng Sơn","code":"06043","parent_code":"180"},"06046":{"name":"Xã Đề Thám","type":"xa","slug":"xa-de-tham","name_with_type":"Xã Đề Thám","path":"Xã Đề Thám, Huyện Tràng Định, Tỉnh Lạng Sơn","path_with_type":"Xã Đề Thám, Huyện Tràng Định, Tỉnh Lạng Sơn","code":"06046","parent_code":"180"},"06049":{"name":"Xã Kháng Chiến","type":"xa","slug":"xa-khang-chien","name_with_type":"Xã Kháng Chiến","path":"Xã Kháng Chiến, Huyện Tràng Định, Tỉnh Lạng Sơn","path_with_type":"Xã Kháng Chiến, Huyện Tràng Định, Tỉnh Lạng Sơn","code":"06049","parent_code":"180"},"06055":{"name":"Xã Hùng Sơn","type":"xa","slug":"xa-hung-son","name_with_type":"Xã Hùng Sơn","path":"Xã Hùng Sơn, Huyện Tràng Định, Tỉnh Lạng Sơn","path_with_type":"Xã Hùng Sơn, Huyện Tràng Định, Tỉnh Lạng Sơn","code":"06055","parent_code":"180"},"06058":{"name":"Xã Quốc Việt","type":"xa","slug":"xa-quoc-viet","name_with_type":"Xã Quốc Việt","path":"Xã Quốc Việt, Huyện Tràng Định, Tỉnh Lạng Sơn","path_with_type":"Xã Quốc Việt, Huyện Tràng Định, Tỉnh Lạng Sơn","code":"06058","parent_code":"180"},"06061":{"name":"Xã Hùng Việt","type":"xa","slug":"xa-hung-viet","name_with_type":"Xã Hùng Việt","path":"Xã Hùng Việt, Huyện Tràng Định, Tỉnh Lạng Sơn","path_with_type":"Xã Hùng Việt, Huyện Tràng Định, Tỉnh Lạng Sơn","code":"06061","parent_code":"180"},"06067":{"name":"Xã Hưng Đạo","type":"xa","slug":"xa-hung-dao","name_with_type":"Xã Hưng Đạo","path":"Xã Hưng Đạo, Huyện Bình Gia, Tỉnh Lạng Sơn","path_with_type":"Xã Hưng Đạo, Huyện Bình Gia, Tỉnh Lạng Sơn","code":"06067","parent_code":"181"},"06070":{"name":"Xã Vĩnh Yên","type":"xa","slug":"xa-vinh-yen","name_with_type":"Xã Vĩnh Yên","path":"Xã Vĩnh Yên, Huyện Bình Gia, Tỉnh Lạng Sơn","path_with_type":"Xã Vĩnh Yên, Huyện Bình Gia, Tỉnh Lạng Sơn","code":"06070","parent_code":"181"},"06073":{"name":"Xã Hoa Thám","type":"xa","slug":"xa-hoa-tham","name_with_type":"Xã Hoa Thám","path":"Xã Hoa Thám, Huyện Bình Gia, Tỉnh Lạng Sơn","path_with_type":"Xã Hoa Thám, Huyện Bình Gia, Tỉnh Lạng Sơn","code":"06073","parent_code":"181"},"06076":{"name":"Xã Quý Hòa","type":"xa","slug":"xa-quy-hoa","name_with_type":"Xã Quý Hòa","path":"Xã Quý Hòa, Huyện Bình Gia, Tỉnh Lạng Sơn","path_with_type":"Xã Quý Hòa, Huyện Bình Gia, Tỉnh Lạng Sơn","code":"06076","parent_code":"181"},"06079":{"name":"Xã Hồng Phong","type":"xa","slug":"xa-hong-phong","name_with_type":"Xã Hồng Phong","path":"Xã Hồng Phong, Huyện Bình Gia, Tỉnh Lạng Sơn","path_with_type":"Xã Hồng Phong, Huyện Bình Gia, Tỉnh Lạng Sơn","code":"06079","parent_code":"181"},"06082":{"name":"Xã Yên Lỗ","type":"xa","slug":"xa-yen-lo","name_with_type":"Xã Yên Lỗ","path":"Xã Yên Lỗ, Huyện Bình Gia, Tỉnh Lạng Sơn","path_with_type":"Xã Yên Lỗ, Huyện Bình Gia, Tỉnh Lạng Sơn","code":"06082","parent_code":"181"},"06085":{"name":"Xã Thiện Hòa","type":"xa","slug":"xa-thien-hoa","name_with_type":"Xã Thiện Hòa","path":"Xã Thiện Hòa, Huyện Bình Gia, Tỉnh Lạng Sơn","path_with_type":"Xã Thiện Hòa, Huyện Bình Gia, Tỉnh Lạng Sơn","code":"06085","parent_code":"181"},"06088":{"name":"Xã Quang Trung","type":"xa","slug":"xa-quang-trung","name_with_type":"Xã Quang Trung","path":"Xã Quang Trung, Huyện Bình Gia, Tỉnh Lạng Sơn","path_with_type":"Xã Quang Trung, Huyện Bình Gia, Tỉnh Lạng Sơn","code":"06088","parent_code":"181"},"06091":{"name":"Xã Thiện Thuật","type":"xa","slug":"xa-thien-thuat","name_with_type":"Xã Thiện Thuật","path":"Xã Thiện Thuật, Huyện Bình Gia, Tỉnh Lạng Sơn","path_with_type":"Xã Thiện Thuật, Huyện Bình Gia, Tỉnh Lạng Sơn","code":"06091","parent_code":"181"},"06094":{"name":"Xã Minh Khai","type":"xa","slug":"xa-minh-khai","name_with_type":"Xã Minh Khai","path":"Xã Minh Khai, Huyện Bình Gia, Tỉnh Lạng Sơn","path_with_type":"Xã Minh Khai, Huyện Bình Gia, Tỉnh Lạng Sơn","code":"06094","parent_code":"181"},"06097":{"name":"Xã Thiện Long","type":"xa","slug":"xa-thien-long","name_with_type":"Xã Thiện Long","path":"Xã Thiện Long, Huyện Bình Gia, Tỉnh Lạng Sơn","path_with_type":"Xã Thiện Long, Huyện Bình Gia, Tỉnh Lạng Sơn","code":"06097","parent_code":"181"},"06100":{"name":"Xã Hoàng Văn Thụ","type":"xa","slug":"xa-hoang-van-thu","name_with_type":"Xã Hoàng Văn Thụ","path":"Xã Hoàng Văn Thụ, Huyện Bình Gia, Tỉnh Lạng Sơn","path_with_type":"Xã Hoàng Văn Thụ, Huyện Bình Gia, Tỉnh Lạng Sơn","code":"06100","parent_code":"181"},"06103":{"name":"Xã Hòa Bình","type":"xa","slug":"xa-hoa-binh","name_with_type":"Xã Hòa Bình","path":"Xã Hòa Bình, Huyện Bình Gia, Tỉnh Lạng Sơn","path_with_type":"Xã Hòa Bình, Huyện Bình Gia, Tỉnh Lạng Sơn","code":"06103","parent_code":"181"},"06106":{"name":"Xã Mông Ân","type":"xa","slug":"xa-mong-an","name_with_type":"Xã Mông Ân","path":"Xã Mông Ân, Huyện Bình Gia, Tỉnh Lạng Sơn","path_with_type":"Xã Mông Ân, Huyện Bình Gia, Tỉnh Lạng Sơn","code":"06106","parent_code":"181"},"06109":{"name":"Xã Tân Hòa","type":"xa","slug":"xa-tan-hoa","name_with_type":"Xã Tân Hòa","path":"Xã Tân Hòa, Huyện Bình Gia, Tỉnh Lạng Sơn","path_with_type":"Xã Tân Hòa, Huyện Bình Gia, Tỉnh Lạng Sơn","code":"06109","parent_code":"181"},"06112":{"name":"Thị trấn Bình Gia","type":"thi-tran","slug":"thi-tran-binh-gia","name_with_type":"Thị trấn Bình Gia","path":"Thị trấn Bình Gia, Huyện Bình Gia, Tỉnh Lạng Sơn","path_with_type":"Thị trấn Bình Gia, Huyện Bình Gia, Tỉnh Lạng Sơn","code":"06112","parent_code":"181"},"06115":{"name":"Xã Hồng Thái","type":"xa","slug":"xa-hong-thai","name_with_type":"Xã Hồng Thái","path":"Xã Hồng Thái, Huyện Bình Gia, Tỉnh Lạng Sơn","path_with_type":"Xã Hồng Thái, Huyện Bình Gia, Tỉnh Lạng Sơn","code":"06115","parent_code":"181"},"06118":{"name":"Xã Bình La","type":"xa","slug":"xa-binh-la","name_with_type":"Xã Bình La","path":"Xã Bình La, Huyện Bình Gia, Tỉnh Lạng Sơn","path_with_type":"Xã Bình La, Huyện Bình Gia, Tỉnh Lạng Sơn","code":"06118","parent_code":"181"},"06121":{"name":"Xã Tân Văn","type":"xa","slug":"xa-tan-van","name_with_type":"Xã Tân Văn","path":"Xã Tân Văn, Huyện Bình Gia, Tỉnh Lạng Sơn","path_with_type":"Xã Tân Văn, Huyện Bình Gia, Tỉnh Lạng Sơn","code":"06121","parent_code":"181"},"06124":{"name":"Thị trấn Na Sầm","type":"thi-tran","slug":"thi-tran-na-sam","name_with_type":"Thị trấn Na Sầm","path":"Thị trấn Na Sầm, Huyện Văn Lãng, Tỉnh Lạng Sơn","path_with_type":"Thị trấn Na Sầm, Huyện Văn Lãng, Tỉnh Lạng Sơn","code":"06124","parent_code":"182"},"06127":{"name":"Xã Trùng Khánh","type":"xa","slug":"xa-trung-khanh","name_with_type":"Xã Trùng Khánh","path":"Xã Trùng Khánh, Huyện Văn Lãng, Tỉnh Lạng Sơn","path_with_type":"Xã Trùng Khánh, Huyện Văn Lãng, Tỉnh Lạng Sơn","code":"06127","parent_code":"182"},"06133":{"name":"Xã Bắc La","type":"xa","slug":"xa-bac-la","name_with_type":"Xã Bắc La","path":"Xã Bắc La, Huyện Văn Lãng, Tỉnh Lạng Sơn","path_with_type":"Xã Bắc La, Huyện Văn Lãng, Tỉnh Lạng Sơn","code":"06133","parent_code":"182"},"06136":{"name":"Xã Thụy Hùng","type":"xa","slug":"xa-thuy-hung","name_with_type":"Xã Thụy Hùng","path":"Xã Thụy Hùng, Huyện Văn Lãng, Tỉnh Lạng Sơn","path_with_type":"Xã Thụy Hùng, Huyện Văn Lãng, Tỉnh Lạng Sơn","code":"06136","parent_code":"182"},"06139":{"name":"Xã Bắc Hùng","type":"xa","slug":"xa-bac-hung","name_with_type":"Xã Bắc Hùng","path":"Xã Bắc Hùng, Huyện Văn Lãng, Tỉnh Lạng Sơn","path_with_type":"Xã Bắc Hùng, Huyện Văn Lãng, Tỉnh Lạng Sơn","code":"06139","parent_code":"182"},"06142":{"name":"Xã Tân Tác","type":"xa","slug":"xa-tan-tac","name_with_type":"Xã Tân Tác","path":"Xã Tân Tác, Huyện Văn Lãng, Tỉnh Lạng Sơn","path_with_type":"Xã Tân Tác, Huyện Văn Lãng, Tỉnh Lạng Sơn","code":"06142","parent_code":"182"},"06148":{"name":"Xã Thanh Long","type":"xa","slug":"xa-thanh-long","name_with_type":"Xã Thanh Long","path":"Xã Thanh Long, Huyện Văn Lãng, Tỉnh Lạng Sơn","path_with_type":"Xã Thanh Long, Huyện Văn Lãng, Tỉnh Lạng Sơn","code":"06148","parent_code":"182"},"06151":{"name":"Xã Hội Hoan","type":"xa","slug":"xa-hoi-hoan","name_with_type":"Xã Hội Hoan","path":"Xã Hội Hoan, Huyện Văn Lãng, Tỉnh Lạng Sơn","path_with_type":"Xã Hội Hoan, Huyện Văn Lãng, Tỉnh Lạng Sơn","code":"06151","parent_code":"182"},"06154":{"name":"Xã Bắc Việt","type":"xa","slug":"xa-bac-viet","name_with_type":"Xã Bắc Việt","path":"Xã Bắc Việt, Huyện Văn Lãng, Tỉnh Lạng Sơn","path_with_type":"Xã Bắc Việt, Huyện Văn Lãng, Tỉnh Lạng Sơn","code":"06154","parent_code":"182"},"06157":{"name":"Xã Hoàng Việt","type":"xa","slug":"xa-hoang-viet","name_with_type":"Xã Hoàng Việt","path":"Xã Hoàng Việt, Huyện Văn Lãng, Tỉnh Lạng Sơn","path_with_type":"Xã Hoàng Việt, Huyện Văn Lãng, Tỉnh Lạng Sơn","code":"06157","parent_code":"182"},"06160":{"name":"Xã Gia Miễn","type":"xa","slug":"xa-gia-mien","name_with_type":"Xã Gia Miễn","path":"Xã Gia Miễn, Huyện Văn Lãng, Tỉnh Lạng Sơn","path_with_type":"Xã Gia Miễn, Huyện Văn Lãng, Tỉnh Lạng Sơn","code":"06160","parent_code":"182"},"06163":{"name":"Xã Thành Hòa","type":"xa","slug":"xa-thanh-hoa","name_with_type":"Xã Thành Hòa","path":"Xã Thành Hòa, Huyện Văn Lãng, Tỉnh Lạng Sơn","path_with_type":"Xã Thành Hòa, Huyện Văn Lãng, Tỉnh Lạng Sơn","code":"06163","parent_code":"182"},"06166":{"name":"Xã Tân Thanh","type":"xa","slug":"xa-tan-thanh","name_with_type":"Xã Tân Thanh","path":"Xã Tân Thanh, Huyện Văn Lãng, Tỉnh Lạng Sơn","path_with_type":"Xã Tân Thanh, Huyện Văn Lãng, Tỉnh Lạng Sơn","code":"06166","parent_code":"182"},"06172":{"name":"Xã Tân Mỹ","type":"xa","slug":"xa-tan-my","name_with_type":"Xã Tân Mỹ","path":"Xã Tân Mỹ, Huyện Văn Lãng, Tỉnh Lạng Sơn","path_with_type":"Xã Tân Mỹ, Huyện Văn Lãng, Tỉnh Lạng Sơn","code":"06172","parent_code":"182"},"06175":{"name":"Xã Hồng Thái","type":"xa","slug":"xa-hong-thai","name_with_type":"Xã Hồng Thái","path":"Xã Hồng Thái, Huyện Văn Lãng, Tỉnh Lạng Sơn","path_with_type":"Xã Hồng Thái, Huyện Văn Lãng, Tỉnh Lạng Sơn","code":"06175","parent_code":"182"},"06178":{"name":"Xã  Hoàng Văn Thụ","type":"xa","slug":"xa-hoang-van-thu","name_with_type":"Xã  Hoàng Văn Thụ","path":"Xã  Hoàng Văn Thụ, Huyện Văn Lãng, Tỉnh Lạng Sơn","path_with_type":"Xã  Hoàng Văn Thụ, Huyện Văn Lãng, Tỉnh Lạng Sơn","code":"06178","parent_code":"182"},"06181":{"name":"Xã Nhạc Kỳ","type":"xa","slug":"xa-nhac-ky","name_with_type":"Xã Nhạc Kỳ","path":"Xã Nhạc Kỳ, Huyện Văn Lãng, Tỉnh Lạng Sơn","path_with_type":"Xã Nhạc Kỳ, Huyện Văn Lãng, Tỉnh Lạng Sơn","code":"06181","parent_code":"182"},"06184":{"name":"Thị trấn Đồng Đăng","type":"thi-tran","slug":"thi-tran-dong-dang","name_with_type":"Thị trấn Đồng Đăng","path":"Thị trấn Đồng Đăng, Huyện Cao Lộc, Tỉnh Lạng Sơn","path_with_type":"Thị trấn Đồng Đăng, Huyện Cao Lộc, Tỉnh Lạng Sơn","code":"06184","parent_code":"183"},"06187":{"name":"Thị trấn Cao Lộc","type":"thi-tran","slug":"thi-tran-cao-loc","name_with_type":"Thị trấn Cao Lộc","path":"Thị trấn Cao Lộc, Huyện Cao Lộc, Tỉnh Lạng Sơn","path_with_type":"Thị trấn Cao Lộc, Huyện Cao Lộc, Tỉnh Lạng Sơn","code":"06187","parent_code":"183"},"06190":{"name":"Xã Bảo Lâm","type":"xa","slug":"xa-bao-lam","name_with_type":"Xã Bảo Lâm","path":"Xã Bảo Lâm, Huyện Cao Lộc, Tỉnh Lạng Sơn","path_with_type":"Xã Bảo Lâm, Huyện Cao Lộc, Tỉnh Lạng Sơn","code":"06190","parent_code":"183"},"06193":{"name":"Xã Thanh Lòa","type":"xa","slug":"xa-thanh-loa","name_with_type":"Xã Thanh Lòa","path":"Xã Thanh Lòa, Huyện Cao Lộc, Tỉnh Lạng Sơn","path_with_type":"Xã Thanh Lòa, Huyện Cao Lộc, Tỉnh Lạng Sơn","code":"06193","parent_code":"183"},"06196":{"name":"Xã Cao Lâu","type":"xa","slug":"xa-cao-lau","name_with_type":"Xã Cao Lâu","path":"Xã Cao Lâu, Huyện Cao Lộc, Tỉnh Lạng Sơn","path_with_type":"Xã Cao Lâu, Huyện Cao Lộc, Tỉnh Lạng Sơn","code":"06196","parent_code":"183"},"06199":{"name":"Xã Thạch Đạn","type":"xa","slug":"xa-thach-dan","name_with_type":"Xã Thạch Đạn","path":"Xã Thạch Đạn, Huyện Cao Lộc, Tỉnh Lạng Sơn","path_with_type":"Xã Thạch Đạn, Huyện Cao Lộc, Tỉnh Lạng Sơn","code":"06199","parent_code":"183"},"06202":{"name":"Xã Xuất Lễ","type":"xa","slug":"xa-xuat-le","name_with_type":"Xã Xuất Lễ","path":"Xã Xuất Lễ, Huyện Cao Lộc, Tỉnh Lạng Sơn","path_with_type":"Xã Xuất Lễ, Huyện Cao Lộc, Tỉnh Lạng Sơn","code":"06202","parent_code":"183"},"06205":{"name":"Xã Hồng Phong","type":"xa","slug":"xa-hong-phong","name_with_type":"Xã Hồng Phong","path":"Xã Hồng Phong, Huyện Cao Lộc, Tỉnh Lạng Sơn","path_with_type":"Xã Hồng Phong, Huyện Cao Lộc, Tỉnh Lạng Sơn","code":"06205","parent_code":"183"},"06208":{"name":"Xã Thụy Hùng","type":"xa","slug":"xa-thuy-hung","name_with_type":"Xã Thụy Hùng","path":"Xã Thụy Hùng, Huyện Cao Lộc, Tỉnh Lạng Sơn","path_with_type":"Xã Thụy Hùng, Huyện Cao Lộc, Tỉnh Lạng Sơn","code":"06208","parent_code":"183"},"06211":{"name":"Xã Lộc Yên","type":"xa","slug":"xa-loc-yen","name_with_type":"Xã Lộc Yên","path":"Xã Lộc Yên, Huyện Cao Lộc, Tỉnh Lạng Sơn","path_with_type":"Xã Lộc Yên, Huyện Cao Lộc, Tỉnh Lạng Sơn","code":"06211","parent_code":"183"},"06214":{"name":"Xã Phú Xá","type":"xa","slug":"xa-phu-xa","name_with_type":"Xã Phú Xá","path":"Xã Phú Xá, Huyện Cao Lộc, Tỉnh Lạng Sơn","path_with_type":"Xã Phú Xá, Huyện Cao Lộc, Tỉnh Lạng Sơn","code":"06214","parent_code":"183"},"06217":{"name":"Xã Bình Trung","type":"xa","slug":"xa-binh-trung","name_with_type":"Xã Bình Trung","path":"Xã Bình Trung, Huyện Cao Lộc, Tỉnh Lạng Sơn","path_with_type":"Xã Bình Trung, Huyện Cao Lộc, Tỉnh Lạng Sơn","code":"06217","parent_code":"183"},"06220":{"name":"Xã Hải Yến","type":"xa","slug":"xa-hai-yen","name_with_type":"Xã Hải Yến","path":"Xã Hải Yến, Huyện Cao Lộc, Tỉnh Lạng Sơn","path_with_type":"Xã Hải Yến, Huyện Cao Lộc, Tỉnh Lạng Sơn","code":"06220","parent_code":"183"},"06223":{"name":"Xã Hòa Cư","type":"xa","slug":"xa-hoa-cu","name_with_type":"Xã Hòa Cư","path":"Xã Hòa Cư, Huyện Cao Lộc, Tỉnh Lạng Sơn","path_with_type":"Xã Hòa Cư, Huyện Cao Lộc, Tỉnh Lạng Sơn","code":"06223","parent_code":"183"},"06226":{"name":"Xã Hợp Thành","type":"xa","slug":"xa-hop-thanh","name_with_type":"Xã Hợp Thành","path":"Xã Hợp Thành, Huyện Cao Lộc, Tỉnh Lạng Sơn","path_with_type":"Xã Hợp Thành, Huyện Cao Lộc, Tỉnh Lạng Sơn","code":"06226","parent_code":"183"},"06232":{"name":"Xã Công Sơn","type":"xa","slug":"xa-cong-son","name_with_type":"Xã Công Sơn","path":"Xã Công Sơn, Huyện Cao Lộc, Tỉnh Lạng Sơn","path_with_type":"Xã Công Sơn, Huyện Cao Lộc, Tỉnh Lạng Sơn","code":"06232","parent_code":"183"},"06235":{"name":"Xã Gia Cát","type":"xa","slug":"xa-gia-cat","name_with_type":"Xã Gia Cát","path":"Xã Gia Cát, Huyện Cao Lộc, Tỉnh Lạng Sơn","path_with_type":"Xã Gia Cát, Huyện Cao Lộc, Tỉnh Lạng Sơn","code":"06235","parent_code":"183"},"06238":{"name":"Xã Mẫu Sơn","type":"xa","slug":"xa-mau-son","name_with_type":"Xã Mẫu Sơn","path":"Xã Mẫu Sơn, Huyện Cao Lộc, Tỉnh Lạng Sơn","path_with_type":"Xã Mẫu Sơn, Huyện Cao Lộc, Tỉnh Lạng Sơn","code":"06238","parent_code":"183"},"06241":{"name":"Xã Xuân Long","type":"xa","slug":"xa-xuan-long","name_with_type":"Xã Xuân Long","path":"Xã Xuân Long, Huyện Cao Lộc, Tỉnh Lạng Sơn","path_with_type":"Xã Xuân Long, Huyện Cao Lộc, Tỉnh Lạng Sơn","code":"06241","parent_code":"183"},"06244":{"name":"Xã Tân Liên","type":"xa","slug":"xa-tan-lien","name_with_type":"Xã Tân Liên","path":"Xã Tân Liên, Huyện Cao Lộc, Tỉnh Lạng Sơn","path_with_type":"Xã Tân Liên, Huyện Cao Lộc, Tỉnh Lạng Sơn","code":"06244","parent_code":"183"},"06247":{"name":"Xã Yên Trạch","type":"xa","slug":"xa-yen-trach","name_with_type":"Xã Yên Trạch","path":"Xã Yên Trạch, Huyện Cao Lộc, Tỉnh Lạng Sơn","path_with_type":"Xã Yên Trạch, Huyện Cao Lộc, Tỉnh Lạng Sơn","code":"06247","parent_code":"183"},"06250":{"name":"Xã Tân Thành","type":"xa","slug":"xa-tan-thanh","name_with_type":"Xã Tân Thành","path":"Xã Tân Thành, Huyện Cao Lộc, Tỉnh Lạng Sơn","path_with_type":"Xã Tân Thành, Huyện Cao Lộc, Tỉnh Lạng Sơn","code":"06250","parent_code":"183"},"06253":{"name":"Thị trấn Văn Quan","type":"thi-tran","slug":"thi-tran-van-quan","name_with_type":"Thị trấn Văn Quan","path":"Thị trấn Văn Quan, Huyện Văn Quan, Tỉnh Lạng Sơn","path_with_type":"Thị trấn Văn Quan, Huyện Văn Quan, Tỉnh Lạng Sơn","code":"06253","parent_code":"184"},"06256":{"name":"Xã Trấn Ninh","type":"xa","slug":"xa-tran-ninh","name_with_type":"Xã Trấn Ninh","path":"Xã Trấn Ninh, Huyện Văn Quan, Tỉnh Lạng Sơn","path_with_type":"Xã Trấn Ninh, Huyện Văn Quan, Tỉnh Lạng Sơn","code":"06256","parent_code":"184"},"06268":{"name":"Xã Liên Hội","type":"xa","slug":"xa-lien-hoi","name_with_type":"Xã Liên Hội","path":"Xã Liên Hội, Huyện Văn Quan, Tỉnh Lạng Sơn","path_with_type":"Xã Liên Hội, Huyện Văn Quan, Tỉnh Lạng Sơn","code":"06268","parent_code":"184"},"06274":{"name":"Xã Hòa Bình","type":"xa","slug":"xa-hoa-binh","name_with_type":"Xã Hòa Bình","path":"Xã Hòa Bình, Huyện Văn Quan, Tỉnh Lạng Sơn","path_with_type":"Xã Hòa Bình, Huyện Văn Quan, Tỉnh Lạng Sơn","code":"06274","parent_code":"184"},"06277":{"name":"Xã Tú Xuyên","type":"xa","slug":"xa-tu-xuyen","name_with_type":"Xã Tú Xuyên","path":"Xã Tú Xuyên, Huyện Văn Quan, Tỉnh Lạng Sơn","path_with_type":"Xã Tú Xuyên, Huyện Văn Quan, Tỉnh Lạng Sơn","code":"06277","parent_code":"184"},"06280":{"name":"Xã Điềm He","type":"xa","slug":"xa-diem-he","name_with_type":"Xã Điềm He","path":"Xã Điềm He, Huyện Văn Quan, Tỉnh Lạng Sơn","path_with_type":"Xã Điềm He, Huyện Văn Quan, Tỉnh Lạng Sơn","code":"06280","parent_code":"184"},"06283":{"name":"Xã An Sơn","type":"xa","slug":"xa-an-son","name_with_type":"Xã An Sơn","path":"Xã An Sơn, Huyện Văn Quan, Tỉnh Lạng Sơn","path_with_type":"Xã An Sơn, Huyện Văn Quan, Tỉnh Lạng Sơn","code":"06283","parent_code":"184"},"06286":{"name":"Xã Khánh Khê","type":"xa","slug":"xa-khanh-khe","name_with_type":"Xã Khánh Khê","path":"Xã Khánh Khê, Huyện Văn Quan, Tỉnh Lạng Sơn","path_with_type":"Xã Khánh Khê, Huyện Văn Quan, Tỉnh Lạng Sơn","code":"06286","parent_code":"184"},"06292":{"name":"Xã Lương Năng","type":"xa","slug":"xa-luong-nang","name_with_type":"Xã Lương Năng","path":"Xã Lương Năng, Huyện Văn Quan, Tỉnh Lạng Sơn","path_with_type":"Xã Lương Năng, Huyện Văn Quan, Tỉnh Lạng Sơn","code":"06292","parent_code":"184"},"06298":{"name":"Xã Bình Phúc","type":"xa","slug":"xa-binh-phuc","name_with_type":"Xã Bình Phúc","path":"Xã Bình Phúc, Huyện Văn Quan, Tỉnh Lạng Sơn","path_with_type":"Xã Bình Phúc, Huyện Văn Quan, Tỉnh Lạng Sơn","code":"06298","parent_code":"184"},"06307":{"name":"Xã Tân Đoàn","type":"xa","slug":"xa-tan-doan","name_with_type":"Xã Tân Đoàn","path":"Xã Tân Đoàn, Huyện Văn Quan, Tỉnh Lạng Sơn","path_with_type":"Xã Tân Đoàn, Huyện Văn Quan, Tỉnh Lạng Sơn","code":"06307","parent_code":"184"},"06313":{"name":"Xã Tri Lễ","type":"xa","slug":"xa-tri-le","name_with_type":"Xã Tri Lễ","path":"Xã Tri Lễ, Huyện Văn Quan, Tỉnh Lạng Sơn","path_with_type":"Xã Tri Lễ, Huyện Văn Quan, Tỉnh Lạng Sơn","code":"06313","parent_code":"184"},"06316":{"name":"Xã Tràng Phái","type":"xa","slug":"xa-trang-phai","name_with_type":"Xã Tràng Phái","path":"Xã Tràng Phái, Huyện Văn Quan, Tỉnh Lạng Sơn","path_with_type":"Xã Tràng Phái, Huyện Văn Quan, Tỉnh Lạng Sơn","code":"06316","parent_code":"184"},"06319":{"name":"Xã Yên Phúc","type":"xa","slug":"xa-yen-phuc","name_with_type":"Xã Yên Phúc","path":"Xã Yên Phúc, Huyện Văn Quan, Tỉnh Lạng Sơn","path_with_type":"Xã Yên Phúc, Huyện Văn Quan, Tỉnh Lạng Sơn","code":"06319","parent_code":"184"},"06322":{"name":"Xã Hữu Lễ","type":"xa","slug":"xa-huu-le","name_with_type":"Xã Hữu Lễ","path":"Xã Hữu Lễ, Huyện Văn Quan, Tỉnh Lạng Sơn","path_with_type":"Xã Hữu Lễ, Huyện Văn Quan, Tỉnh Lạng Sơn","code":"06322","parent_code":"184"},"06325":{"name":"Thị trấn Bắc Sơn","type":"thi-tran","slug":"thi-tran-bac-son","name_with_type":"Thị trấn Bắc Sơn","path":"Thị trấn Bắc Sơn, Huyện Bắc Sơn, Tỉnh Lạng Sơn","path_with_type":"Thị trấn Bắc Sơn, Huyện Bắc Sơn, Tỉnh Lạng Sơn","code":"06325","parent_code":"185"},"06328":{"name":"Xã Long Đống","type":"xa","slug":"xa-long-dong","name_with_type":"Xã Long Đống","path":"Xã Long Đống, Huyện Bắc Sơn, Tỉnh Lạng Sơn","path_with_type":"Xã Long Đống, Huyện Bắc Sơn, Tỉnh Lạng Sơn","code":"06328","parent_code":"185"},"06331":{"name":"Xã Vạn Thủy","type":"xa","slug":"xa-van-thuy","name_with_type":"Xã Vạn Thủy","path":"Xã Vạn Thủy, Huyện Bắc Sơn, Tỉnh Lạng Sơn","path_with_type":"Xã Vạn Thủy, Huyện Bắc Sơn, Tỉnh Lạng Sơn","code":"06331","parent_code":"185"},"06337":{"name":"Xã Đồng ý","type":"xa","slug":"xa-dong-y","name_with_type":"Xã Đồng ý","path":"Xã Đồng ý, Huyện Bắc Sơn, Tỉnh Lạng Sơn","path_with_type":"Xã Đồng ý, Huyện Bắc Sơn, Tỉnh Lạng Sơn","code":"06337","parent_code":"185"},"06340":{"name":"Xã Tân Tri","type":"xa","slug":"xa-tan-tri","name_with_type":"Xã Tân Tri","path":"Xã Tân Tri, Huyện Bắc Sơn, Tỉnh Lạng Sơn","path_with_type":"Xã Tân Tri, Huyện Bắc Sơn, Tỉnh Lạng Sơn","code":"06340","parent_code":"185"},"06343":{"name":"Xã Bắc Quỳnh","type":"xa","slug":"xa-bac-quynh","name_with_type":"Xã Bắc Quỳnh","path":"Xã Bắc Quỳnh, Huyện Bắc Sơn, Tỉnh Lạng Sơn","path_with_type":"Xã Bắc Quỳnh, Huyện Bắc Sơn, Tỉnh Lạng Sơn","code":"06343","parent_code":"185"},"06349":{"name":"Xã Hưng Vũ","type":"xa","slug":"xa-hung-vu","name_with_type":"Xã Hưng Vũ","path":"Xã Hưng Vũ, Huyện Bắc Sơn, Tỉnh Lạng Sơn","path_with_type":"Xã Hưng Vũ, Huyện Bắc Sơn, Tỉnh Lạng Sơn","code":"06349","parent_code":"185"},"06352":{"name":"Xã Tân Lập","type":"xa","slug":"xa-tan-lap","name_with_type":"Xã Tân Lập","path":"Xã Tân Lập, Huyện Bắc Sơn, Tỉnh Lạng Sơn","path_with_type":"Xã Tân Lập, Huyện Bắc Sơn, Tỉnh Lạng Sơn","code":"06352","parent_code":"185"},"06355":{"name":"Xã Vũ Sơn","type":"xa","slug":"xa-vu-son","name_with_type":"Xã Vũ Sơn","path":"Xã Vũ Sơn, Huyện Bắc Sơn, Tỉnh Lạng Sơn","path_with_type":"Xã Vũ Sơn, Huyện Bắc Sơn, Tỉnh Lạng Sơn","code":"06355","parent_code":"185"},"06358":{"name":"Xã Chiêu Vũ","type":"xa","slug":"xa-chieu-vu","name_with_type":"Xã Chiêu Vũ","path":"Xã Chiêu Vũ, Huyện Bắc Sơn, Tỉnh Lạng Sơn","path_with_type":"Xã Chiêu Vũ, Huyện Bắc Sơn, Tỉnh Lạng Sơn","code":"06358","parent_code":"185"},"06361":{"name":"Xã Tân Hương","type":"xa","slug":"xa-tan-huong","name_with_type":"Xã Tân Hương","path":"Xã Tân Hương, Huyện Bắc Sơn, Tỉnh Lạng Sơn","path_with_type":"Xã Tân Hương, Huyện Bắc Sơn, Tỉnh Lạng Sơn","code":"06361","parent_code":"185"},"06364":{"name":"Xã Chiến Thắng","type":"xa","slug":"xa-chien-thang","name_with_type":"Xã Chiến Thắng","path":"Xã Chiến Thắng, Huyện Bắc Sơn, Tỉnh Lạng Sơn","path_with_type":"Xã Chiến Thắng, Huyện Bắc Sơn, Tỉnh Lạng Sơn","code":"06364","parent_code":"185"},"06367":{"name":"Xã Vũ Lăng","type":"xa","slug":"xa-vu-lang","name_with_type":"Xã Vũ Lăng","path":"Xã Vũ Lăng, Huyện Bắc Sơn, Tỉnh Lạng Sơn","path_with_type":"Xã Vũ Lăng, Huyện Bắc Sơn, Tỉnh Lạng Sơn","code":"06367","parent_code":"185"},"06370":{"name":"Xã Trấn Yên","type":"xa","slug":"xa-tran-yen","name_with_type":"Xã Trấn Yên","path":"Xã Trấn Yên, Huyện Bắc Sơn, Tỉnh Lạng Sơn","path_with_type":"Xã Trấn Yên, Huyện Bắc Sơn, Tỉnh Lạng Sơn","code":"06370","parent_code":"185"},"06373":{"name":"Xã Vũ Lễ","type":"xa","slug":"xa-vu-le","name_with_type":"Xã Vũ Lễ","path":"Xã Vũ Lễ, Huyện Bắc Sơn, Tỉnh Lạng Sơn","path_with_type":"Xã Vũ Lễ, Huyện Bắc Sơn, Tỉnh Lạng Sơn","code":"06373","parent_code":"185"},"06376":{"name":"Xã Nhất Hòa","type":"xa","slug":"xa-nhat-hoa","name_with_type":"Xã Nhất Hòa","path":"Xã Nhất Hòa, Huyện Bắc Sơn, Tỉnh Lạng Sơn","path_with_type":"Xã Nhất Hòa, Huyện Bắc Sơn, Tỉnh Lạng Sơn","code":"06376","parent_code":"185"},"06379":{"name":"Xã Tân Thành","type":"xa","slug":"xa-tan-thanh","name_with_type":"Xã Tân Thành","path":"Xã Tân Thành, Huyện Bắc Sơn, Tỉnh Lạng Sơn","path_with_type":"Xã Tân Thành, Huyện Bắc Sơn, Tỉnh Lạng Sơn","code":"06379","parent_code":"185"},"06382":{"name":"Xã Nhất Tiến","type":"xa","slug":"xa-nhat-tien","name_with_type":"Xã Nhất Tiến","path":"Xã Nhất Tiến, Huyện Bắc Sơn, Tỉnh Lạng Sơn","path_with_type":"Xã Nhất Tiến, Huyện Bắc Sơn, Tỉnh Lạng Sơn","code":"06382","parent_code":"185"},"06385":{"name":"Thị trấn Hữu Lũng","type":"thi-tran","slug":"thi-tran-huu-lung","name_with_type":"Thị trấn Hữu Lũng","path":"Thị trấn Hữu Lũng, Huyện Hữu Lũng, Tỉnh Lạng Sơn","path_with_type":"Thị trấn Hữu Lũng, Huyện Hữu Lũng, Tỉnh Lạng Sơn","code":"06385","parent_code":"186"},"06388":{"name":"Xã Hữu Liên","type":"xa","slug":"xa-huu-lien","name_with_type":"Xã Hữu Liên","path":"Xã Hữu Liên, Huyện Hữu Lũng, Tỉnh Lạng Sơn","path_with_type":"Xã Hữu Liên, Huyện Hữu Lũng, Tỉnh Lạng Sơn","code":"06388","parent_code":"186"},"06391":{"name":"Xã Yên Bình","type":"xa","slug":"xa-yen-binh","name_with_type":"Xã Yên Bình","path":"Xã Yên Bình, Huyện Hữu Lũng, Tỉnh Lạng Sơn","path_with_type":"Xã Yên Bình, Huyện Hữu Lũng, Tỉnh Lạng Sơn","code":"06391","parent_code":"186"},"06394":{"name":"Xã Quyết Thắng","type":"xa","slug":"xa-quyet-thang","name_with_type":"Xã Quyết Thắng","path":"Xã Quyết Thắng, Huyện Hữu Lũng, Tỉnh Lạng Sơn","path_with_type":"Xã Quyết Thắng, Huyện Hữu Lũng, Tỉnh Lạng Sơn","code":"06394","parent_code":"186"},"06397":{"name":"Xã Hòa Bình","type":"xa","slug":"xa-hoa-binh","name_with_type":"Xã Hòa Bình","path":"Xã Hòa Bình, Huyện Hữu Lũng, Tỉnh Lạng Sơn","path_with_type":"Xã Hòa Bình, Huyện Hữu Lũng, Tỉnh Lạng Sơn","code":"06397","parent_code":"186"},"06400":{"name":"Xã Yên Thịnh","type":"xa","slug":"xa-yen-thinh","name_with_type":"Xã Yên Thịnh","path":"Xã Yên Thịnh, Huyện Hữu Lũng, Tỉnh Lạng Sơn","path_with_type":"Xã Yên Thịnh, Huyện Hữu Lũng, Tỉnh Lạng Sơn","code":"06400","parent_code":"186"},"06403":{"name":"Xã Yên Sơn","type":"xa","slug":"xa-yen-son","name_with_type":"Xã Yên Sơn","path":"Xã Yên Sơn, Huyện Hữu Lũng, Tỉnh Lạng Sơn","path_with_type":"Xã Yên Sơn, Huyện Hữu Lũng, Tỉnh Lạng Sơn","code":"06403","parent_code":"186"},"06406":{"name":"Xã Thiện Tân","type":"xa","slug":"xa-thien-tan","name_with_type":"Xã Thiện Tân","path":"Xã Thiện Tân, Huyện Hữu Lũng, Tỉnh Lạng Sơn","path_with_type":"Xã Thiện Tân, Huyện Hữu Lũng, Tỉnh Lạng Sơn","code":"06406","parent_code":"186"},"06412":{"name":"Xã Yên Vượng","type":"xa","slug":"xa-yen-vuong","name_with_type":"Xã Yên Vượng","path":"Xã Yên Vượng, Huyện Hữu Lũng, Tỉnh Lạng Sơn","path_with_type":"Xã Yên Vượng, Huyện Hữu Lũng, Tỉnh Lạng Sơn","code":"06412","parent_code":"186"},"06415":{"name":"Xã Minh Tiến","type":"xa","slug":"xa-minh-tien","name_with_type":"Xã Minh Tiến","path":"Xã Minh Tiến, Huyện Hữu Lũng, Tỉnh Lạng Sơn","path_with_type":"Xã Minh Tiến, Huyện Hữu Lũng, Tỉnh Lạng Sơn","code":"06415","parent_code":"186"},"06418":{"name":"Xã Nhật Tiến","type":"xa","slug":"xa-nhat-tien","name_with_type":"Xã Nhật Tiến","path":"Xã Nhật Tiến, Huyện Hữu Lũng, Tỉnh Lạng Sơn","path_with_type":"Xã Nhật Tiến, Huyện Hữu Lũng, Tỉnh Lạng Sơn","code":"06418","parent_code":"186"},"06421":{"name":"Xã Thanh Sơn","type":"xa","slug":"xa-thanh-son","name_with_type":"Xã Thanh Sơn","path":"Xã Thanh Sơn, Huyện Hữu Lũng, Tỉnh Lạng Sơn","path_with_type":"Xã Thanh Sơn, Huyện Hữu Lũng, Tỉnh Lạng Sơn","code":"06421","parent_code":"186"},"06424":{"name":"Xã Đồng Tân","type":"xa","slug":"xa-dong-tan","name_with_type":"Xã Đồng Tân","path":"Xã Đồng Tân, Huyện Hữu Lũng, Tỉnh Lạng Sơn","path_with_type":"Xã Đồng Tân, Huyện Hữu Lũng, Tỉnh Lạng Sơn","code":"06424","parent_code":"186"},"06427":{"name":"Xã Cai Kinh","type":"xa","slug":"xa-cai-kinh","name_with_type":"Xã Cai Kinh","path":"Xã Cai Kinh, Huyện Hữu Lũng, Tỉnh Lạng Sơn","path_with_type":"Xã Cai Kinh, Huyện Hữu Lũng, Tỉnh Lạng Sơn","code":"06427","parent_code":"186"},"06430":{"name":"Xã Hòa Lạc","type":"xa","slug":"xa-hoa-lac","name_with_type":"Xã Hòa Lạc","path":"Xã Hòa Lạc, Huyện Hữu Lũng, Tỉnh Lạng Sơn","path_with_type":"Xã Hòa Lạc, Huyện Hữu Lũng, Tỉnh Lạng Sơn","code":"06430","parent_code":"186"},"06433":{"name":"Xã Vân Nham","type":"xa","slug":"xa-van-nham","name_with_type":"Xã Vân Nham","path":"Xã Vân Nham, Huyện Hữu Lũng, Tỉnh Lạng Sơn","path_with_type":"Xã Vân Nham, Huyện Hữu Lũng, Tỉnh Lạng Sơn","code":"06433","parent_code":"186"},"06436":{"name":"Xã Đồng Tiến","type":"xa","slug":"xa-dong-tien","name_with_type":"Xã Đồng Tiến","path":"Xã Đồng Tiến, Huyện Hữu Lũng, Tỉnh Lạng Sơn","path_with_type":"Xã Đồng Tiến, Huyện Hữu Lũng, Tỉnh Lạng Sơn","code":"06436","parent_code":"186"},"06442":{"name":"Xã Tân Thành","type":"xa","slug":"xa-tan-thanh","name_with_type":"Xã Tân Thành","path":"Xã Tân Thành, Huyện Hữu Lũng, Tỉnh Lạng Sơn","path_with_type":"Xã Tân Thành, Huyện Hữu Lũng, Tỉnh Lạng Sơn","code":"06442","parent_code":"186"},"06445":{"name":"Xã Hòa Sơn","type":"xa","slug":"xa-hoa-son","name_with_type":"Xã Hòa Sơn","path":"Xã Hòa Sơn, Huyện Hữu Lũng, Tỉnh Lạng Sơn","path_with_type":"Xã Hòa Sơn, Huyện Hữu Lũng, Tỉnh Lạng Sơn","code":"06445","parent_code":"186"},"06448":{"name":"Xã Minh Sơn","type":"xa","slug":"xa-minh-son","name_with_type":"Xã Minh Sơn","path":"Xã Minh Sơn, Huyện Hữu Lũng, Tỉnh Lạng Sơn","path_with_type":"Xã Minh Sơn, Huyện Hữu Lũng, Tỉnh Lạng Sơn","code":"06448","parent_code":"186"},"06451":{"name":"Xã Hồ Sơn","type":"xa","slug":"xa-ho-son","name_with_type":"Xã Hồ Sơn","path":"Xã Hồ Sơn, Huyện Hữu Lũng, Tỉnh Lạng Sơn","path_with_type":"Xã Hồ Sơn, Huyện Hữu Lũng, Tỉnh Lạng Sơn","code":"06451","parent_code":"186"},"06457":{"name":"Xã Minh Hòa","type":"xa","slug":"xa-minh-hoa","name_with_type":"Xã Minh Hòa","path":"Xã Minh Hòa, Huyện Hữu Lũng, Tỉnh Lạng Sơn","path_with_type":"Xã Minh Hòa, Huyện Hữu Lũng, Tỉnh Lạng Sơn","code":"06457","parent_code":"186"},"06460":{"name":"Xã Hòa Thắng","type":"xa","slug":"xa-hoa-thang","name_with_type":"Xã Hòa Thắng","path":"Xã Hòa Thắng, Huyện Hữu Lũng, Tỉnh Lạng Sơn","path_with_type":"Xã Hòa Thắng, Huyện Hữu Lũng, Tỉnh Lạng Sơn","code":"06460","parent_code":"186"},"06463":{"name":"Thị trấn Đồng Mỏ","type":"thi-tran","slug":"thi-tran-dong-mo","name_with_type":"Thị trấn Đồng Mỏ","path":"Thị trấn Đồng Mỏ, Huyện Chi Lăng, Tỉnh Lạng Sơn","path_with_type":"Thị trấn Đồng Mỏ, Huyện Chi Lăng, Tỉnh Lạng Sơn","code":"06463","parent_code":"187"},"06466":{"name":"Thị trấn Chi Lăng","type":"thi-tran","slug":"thi-tran-chi-lang","name_with_type":"Thị trấn Chi Lăng","path":"Thị trấn Chi Lăng, Huyện Chi Lăng, Tỉnh Lạng Sơn","path_with_type":"Thị trấn Chi Lăng, Huyện Chi Lăng, Tỉnh Lạng Sơn","code":"06466","parent_code":"187"},"06469":{"name":"Xã Vân An","type":"xa","slug":"xa-van-an","name_with_type":"Xã Vân An","path":"Xã Vân An, Huyện Chi Lăng, Tỉnh Lạng Sơn","path_with_type":"Xã Vân An, Huyện Chi Lăng, Tỉnh Lạng Sơn","code":"06469","parent_code":"187"},"06472":{"name":"Xã Vân Thủy","type":"xa","slug":"xa-van-thuy","name_with_type":"Xã Vân Thủy","path":"Xã Vân Thủy, Huyện Chi Lăng, Tỉnh Lạng Sơn","path_with_type":"Xã Vân Thủy, Huyện Chi Lăng, Tỉnh Lạng Sơn","code":"06472","parent_code":"187"},"06475":{"name":"Xã Gia Lộc","type":"xa","slug":"xa-gia-loc","name_with_type":"Xã Gia Lộc","path":"Xã Gia Lộc, Huyện Chi Lăng, Tỉnh Lạng Sơn","path_with_type":"Xã Gia Lộc, Huyện Chi Lăng, Tỉnh Lạng Sơn","code":"06475","parent_code":"187"},"06478":{"name":"Xã Bắc Thủy","type":"xa","slug":"xa-bac-thuy","name_with_type":"Xã Bắc Thủy","path":"Xã Bắc Thủy, Huyện Chi Lăng, Tỉnh Lạng Sơn","path_with_type":"Xã Bắc Thủy, Huyện Chi Lăng, Tỉnh Lạng Sơn","code":"06478","parent_code":"187"},"06481":{"name":"Xã Chiến Thắng","type":"xa","slug":"xa-chien-thang","name_with_type":"Xã Chiến Thắng","path":"Xã Chiến Thắng, Huyện Chi Lăng, Tỉnh Lạng Sơn","path_with_type":"Xã Chiến Thắng, Huyện Chi Lăng, Tỉnh Lạng Sơn","code":"06481","parent_code":"187"},"06484":{"name":"Xã Mai Sao","type":"xa","slug":"xa-mai-sao","name_with_type":"Xã Mai Sao","path":"Xã Mai Sao, Huyện Chi Lăng, Tỉnh Lạng Sơn","path_with_type":"Xã Mai Sao, Huyện Chi Lăng, Tỉnh Lạng Sơn","code":"06484","parent_code":"187"},"06487":{"name":"Xã Bằng Hữu","type":"xa","slug":"xa-bang-huu","name_with_type":"Xã Bằng Hữu","path":"Xã Bằng Hữu, Huyện Chi Lăng, Tỉnh Lạng Sơn","path_with_type":"Xã Bằng Hữu, Huyện Chi Lăng, Tỉnh Lạng Sơn","code":"06487","parent_code":"187"},"06490":{"name":"Xã Thượng Cường","type":"xa","slug":"xa-thuong-cuong","name_with_type":"Xã Thượng Cường","path":"Xã Thượng Cường, Huyện Chi Lăng, Tỉnh Lạng Sơn","path_with_type":"Xã Thượng Cường, Huyện Chi Lăng, Tỉnh Lạng Sơn","code":"06490","parent_code":"187"},"06493":{"name":"Xã Bằng Mạc","type":"xa","slug":"xa-bang-mac","name_with_type":"Xã Bằng Mạc","path":"Xã Bằng Mạc, Huyện Chi Lăng, Tỉnh Lạng Sơn","path_with_type":"Xã Bằng Mạc, Huyện Chi Lăng, Tỉnh Lạng Sơn","code":"06493","parent_code":"187"},"06496":{"name":"Xã Nhân Lý","type":"xa","slug":"xa-nhan-ly","name_with_type":"Xã Nhân Lý","path":"Xã Nhân Lý, Huyện Chi Lăng, Tỉnh Lạng Sơn","path_with_type":"Xã Nhân Lý, Huyện Chi Lăng, Tỉnh Lạng Sơn","code":"06496","parent_code":"187"},"06499":{"name":"Xã Lâm Sơn","type":"xa","slug":"xa-lam-son","name_with_type":"Xã Lâm Sơn","path":"Xã Lâm Sơn, Huyện Chi Lăng, Tỉnh Lạng Sơn","path_with_type":"Xã Lâm Sơn, Huyện Chi Lăng, Tỉnh Lạng Sơn","code":"06499","parent_code":"187"},"06502":{"name":"Xã Liên Sơn","type":"xa","slug":"xa-lien-son","name_with_type":"Xã Liên Sơn","path":"Xã Liên Sơn, Huyện Chi Lăng, Tỉnh Lạng Sơn","path_with_type":"Xã Liên Sơn, Huyện Chi Lăng, Tỉnh Lạng Sơn","code":"06502","parent_code":"187"},"06505":{"name":"Xã Vạn Linh","type":"xa","slug":"xa-van-linh","name_with_type":"Xã Vạn Linh","path":"Xã Vạn Linh, Huyện Chi Lăng, Tỉnh Lạng Sơn","path_with_type":"Xã Vạn Linh, Huyện Chi Lăng, Tỉnh Lạng Sơn","code":"06505","parent_code":"187"},"06508":{"name":"Xã Hòa Bình","type":"xa","slug":"xa-hoa-binh","name_with_type":"Xã Hòa Bình","path":"Xã Hòa Bình, Huyện Chi Lăng, Tỉnh Lạng Sơn","path_with_type":"Xã Hòa Bình, Huyện Chi Lăng, Tỉnh Lạng Sơn","code":"06508","parent_code":"187"},"06514":{"name":"Xã Hữu Kiên","type":"xa","slug":"xa-huu-kien","name_with_type":"Xã Hữu Kiên","path":"Xã Hữu Kiên, Huyện Chi Lăng, Tỉnh Lạng Sơn","path_with_type":"Xã Hữu Kiên, Huyện Chi Lăng, Tỉnh Lạng Sơn","code":"06514","parent_code":"187"},"06517":{"name":"Xã Quan Sơn","type":"xa","slug":"xa-quan-son","name_with_type":"Xã Quan Sơn","path":"Xã Quan Sơn, Huyện Chi Lăng, Tỉnh Lạng Sơn","path_with_type":"Xã Quan Sơn, Huyện Chi Lăng, Tỉnh Lạng Sơn","code":"06517","parent_code":"187"},"06520":{"name":"Xã Y Tịch","type":"xa","slug":"xa-y-tich","name_with_type":"Xã Y Tịch","path":"Xã Y Tịch, Huyện Chi Lăng, Tỉnh Lạng Sơn","path_with_type":"Xã Y Tịch, Huyện Chi Lăng, Tỉnh Lạng Sơn","code":"06520","parent_code":"187"},"06523":{"name":"Xã Chi Lăng","type":"xa","slug":"xa-chi-lang","name_with_type":"Xã Chi Lăng","path":"Xã Chi Lăng, Huyện Chi Lăng, Tỉnh Lạng Sơn","path_with_type":"Xã Chi Lăng, Huyện Chi Lăng, Tỉnh Lạng Sơn","code":"06523","parent_code":"187"},"06526":{"name":"Thị trấn Na Dương","type":"thi-tran","slug":"thi-tran-na-duong","name_with_type":"Thị trấn Na Dương","path":"Thị trấn Na Dương, Huyện Lộc Bình, Tỉnh Lạng Sơn","path_with_type":"Thị trấn Na Dương, Huyện Lộc Bình, Tỉnh Lạng Sơn","code":"06526","parent_code":"188"},"06529":{"name":"Thị trấn Lộc Bình","type":"thi-tran","slug":"thi-tran-loc-binh","name_with_type":"Thị trấn Lộc Bình","path":"Thị trấn Lộc Bình, Huyện Lộc Bình, Tỉnh Lạng Sơn","path_with_type":"Thị trấn Lộc Bình, Huyện Lộc Bình, Tỉnh Lạng Sơn","code":"06529","parent_code":"188"},"06532":{"name":"Xã Mẫu Sơn","type":"xa","slug":"xa-mau-son","name_with_type":"Xã Mẫu Sơn","path":"Xã Mẫu Sơn, Huyện Lộc Bình, Tỉnh Lạng Sơn","path_with_type":"Xã Mẫu Sơn, Huyện Lộc Bình, Tỉnh Lạng Sơn","code":"06532","parent_code":"188"},"06541":{"name":"Xã Yên Khoái","type":"xa","slug":"xa-yen-khoai","name_with_type":"Xã Yên Khoái","path":"Xã Yên Khoái, Huyện Lộc Bình, Tỉnh Lạng Sơn","path_with_type":"Xã Yên Khoái, Huyện Lộc Bình, Tỉnh Lạng Sơn","code":"06541","parent_code":"188"},"06544":{"name":"Xã Khánh Xuân","type":"xa","slug":"xa-khanh-xuan","name_with_type":"Xã Khánh Xuân","path":"Xã Khánh Xuân, Huyện Lộc Bình, Tỉnh Lạng Sơn","path_with_type":"Xã Khánh Xuân, Huyện Lộc Bình, Tỉnh Lạng Sơn","code":"06544","parent_code":"188"},"06547":{"name":"Xã Tú Mịch","type":"xa","slug":"xa-tu-mich","name_with_type":"Xã Tú Mịch","path":"Xã Tú Mịch, Huyện Lộc Bình, Tỉnh Lạng Sơn","path_with_type":"Xã Tú Mịch, Huyện Lộc Bình, Tỉnh Lạng Sơn","code":"06547","parent_code":"188"},"06550":{"name":"Xã Hữu Khánh","type":"xa","slug":"xa-huu-khanh","name_with_type":"Xã Hữu Khánh","path":"Xã Hữu Khánh, Huyện Lộc Bình, Tỉnh Lạng Sơn","path_with_type":"Xã Hữu Khánh, Huyện Lộc Bình, Tỉnh Lạng Sơn","code":"06550","parent_code":"188"},"06553":{"name":"Xã Đồng Bục","type":"xa","slug":"xa-dong-buc","name_with_type":"Xã Đồng Bục","path":"Xã Đồng Bục, Huyện Lộc Bình, Tỉnh Lạng Sơn","path_with_type":"Xã Đồng Bục, Huyện Lộc Bình, Tỉnh Lạng Sơn","code":"06553","parent_code":"188"},"06559":{"name":"Xã Tam Gia","type":"xa","slug":"xa-tam-gia","name_with_type":"Xã Tam Gia","path":"Xã Tam Gia, Huyện Lộc Bình, Tỉnh Lạng Sơn","path_with_type":"Xã Tam Gia, Huyện Lộc Bình, Tỉnh Lạng Sơn","code":"06559","parent_code":"188"},"06562":{"name":"Xã Tú Đoạn","type":"xa","slug":"xa-tu-doan","name_with_type":"Xã Tú Đoạn","path":"Xã Tú Đoạn, Huyện Lộc Bình, Tỉnh Lạng Sơn","path_with_type":"Xã Tú Đoạn, Huyện Lộc Bình, Tỉnh Lạng Sơn","code":"06562","parent_code":"188"},"06565":{"name":"Xã Khuất Xá","type":"xa","slug":"xa-khuat-xa","name_with_type":"Xã Khuất Xá","path":"Xã Khuất Xá, Huyện Lộc Bình, Tỉnh Lạng Sơn","path_with_type":"Xã Khuất Xá, Huyện Lộc Bình, Tỉnh Lạng Sơn","code":"06565","parent_code":"188"},"06577":{"name":"Xã Thống Nhất","type":"xa","slug":"xa-thong-nhat","name_with_type":"Xã Thống Nhất","path":"Xã Thống Nhất, Huyện Lộc Bình, Tỉnh Lạng Sơn","path_with_type":"Xã Thống Nhất, Huyện Lộc Bình, Tỉnh Lạng Sơn","code":"06577","parent_code":"188"},"06589":{"name":"Xã Sàn Viên","type":"xa","slug":"xa-san-vien","name_with_type":"Xã Sàn Viên","path":"Xã Sàn Viên, Huyện Lộc Bình, Tỉnh Lạng Sơn","path_with_type":"Xã Sàn Viên, Huyện Lộc Bình, Tỉnh Lạng Sơn","code":"06589","parent_code":"188"},"06592":{"name":"Xã Đông Quan","type":"xa","slug":"xa-dong-quan","name_with_type":"Xã Đông Quan","path":"Xã Đông Quan, Huyện Lộc Bình, Tỉnh Lạng Sơn","path_with_type":"Xã Đông Quan, Huyện Lộc Bình, Tỉnh Lạng Sơn","code":"06592","parent_code":"188"},"06595":{"name":"Xã Minh Hiệp","type":"xa","slug":"xa-minh-hiep","name_with_type":"Xã Minh Hiệp","path":"Xã Minh Hiệp, Huyện Lộc Bình, Tỉnh Lạng Sơn","path_with_type":"Xã Minh Hiệp, Huyện Lộc Bình, Tỉnh Lạng Sơn","code":"06595","parent_code":"188"},"06598":{"name":"Xã Hữu Lân","type":"xa","slug":"xa-huu-lan","name_with_type":"Xã Hữu Lân","path":"Xã Hữu Lân, Huyện Lộc Bình, Tỉnh Lạng Sơn","path_with_type":"Xã Hữu Lân, Huyện Lộc Bình, Tỉnh Lạng Sơn","code":"06598","parent_code":"188"},"06601":{"name":"Xã Lợi Bác","type":"xa","slug":"xa-loi-bac","name_with_type":"Xã Lợi Bác","path":"Xã Lợi Bác, Huyện Lộc Bình, Tỉnh Lạng Sơn","path_with_type":"Xã Lợi Bác, Huyện Lộc Bình, Tỉnh Lạng Sơn","code":"06601","parent_code":"188"},"06604":{"name":"Xã Nam Quan","type":"xa","slug":"xa-nam-quan","name_with_type":"Xã Nam Quan","path":"Xã Nam Quan, Huyện Lộc Bình, Tỉnh Lạng Sơn","path_with_type":"Xã Nam Quan, Huyện Lộc Bình, Tỉnh Lạng Sơn","code":"06604","parent_code":"188"},"06607":{"name":"Xã Xuân Dương","type":"xa","slug":"xa-xuan-duong","name_with_type":"Xã Xuân Dương","path":"Xã Xuân Dương, Huyện Lộc Bình, Tỉnh Lạng Sơn","path_with_type":"Xã Xuân Dương, Huyện Lộc Bình, Tỉnh Lạng Sơn","code":"06607","parent_code":"188"},"06610":{"name":"Xã Ái Quốc","type":"xa","slug":"xa-ai-quoc","name_with_type":"Xã Ái Quốc","path":"Xã Ái Quốc, Huyện Lộc Bình, Tỉnh Lạng Sơn","path_with_type":"Xã Ái Quốc, Huyện Lộc Bình, Tỉnh Lạng Sơn","code":"06610","parent_code":"188"},"06613":{"name":"Thị trấn Đình Lập","type":"thi-tran","slug":"thi-tran-dinh-lap","name_with_type":"Thị trấn Đình Lập","path":"Thị trấn Đình Lập, Huyện Đình Lập, Tỉnh Lạng Sơn","path_with_type":"Thị trấn Đình Lập, Huyện Đình Lập, Tỉnh Lạng Sơn","code":"06613","parent_code":"189"},"06616":{"name":"Thị trấn NT Thái Bình","type":"thi-tran","slug":"thi-tran-nt-thai-binh","name_with_type":"Thị trấn NT Thái Bình","path":"Thị trấn NT Thái Bình, Huyện Đình Lập, Tỉnh Lạng Sơn","path_with_type":"Thị trấn NT Thái Bình, Huyện Đình Lập, Tỉnh Lạng Sơn","code":"06616","parent_code":"189"},"06619":{"name":"Xã Bắc Xa","type":"xa","slug":"xa-bac-xa","name_with_type":"Xã Bắc Xa","path":"Xã Bắc Xa, Huyện Đình Lập, Tỉnh Lạng Sơn","path_with_type":"Xã Bắc Xa, Huyện Đình Lập, Tỉnh Lạng Sơn","code":"06619","parent_code":"189"},"06622":{"name":"Xã Bính Xá","type":"xa","slug":"xa-binh-xa","name_with_type":"Xã Bính Xá","path":"Xã Bính Xá, Huyện Đình Lập, Tỉnh Lạng Sơn","path_with_type":"Xã Bính Xá, Huyện Đình Lập, Tỉnh Lạng Sơn","code":"06622","parent_code":"189"},"06625":{"name":"Xã Kiên Mộc","type":"xa","slug":"xa-kien-moc","name_with_type":"Xã Kiên Mộc","path":"Xã Kiên Mộc, Huyện Đình Lập, Tỉnh Lạng Sơn","path_with_type":"Xã Kiên Mộc, Huyện Đình Lập, Tỉnh Lạng Sơn","code":"06625","parent_code":"189"},"06628":{"name":"Xã Đình Lập","type":"xa","slug":"xa-dinh-lap","name_with_type":"Xã Đình Lập","path":"Xã Đình Lập, Huyện Đình Lập, Tỉnh Lạng Sơn","path_with_type":"Xã Đình Lập, Huyện Đình Lập, Tỉnh Lạng Sơn","code":"06628","parent_code":"189"},"06631":{"name":"Xã Thái Bình","type":"xa","slug":"xa-thai-binh","name_with_type":"Xã Thái Bình","path":"Xã Thái Bình, Huyện Đình Lập, Tỉnh Lạng Sơn","path_with_type":"Xã Thái Bình, Huyện Đình Lập, Tỉnh Lạng Sơn","code":"06631","parent_code":"189"},"06634":{"name":"Xã Cường Lợi","type":"xa","slug":"xa-cuong-loi","name_with_type":"Xã Cường Lợi","path":"Xã Cường Lợi, Huyện Đình Lập, Tỉnh Lạng Sơn","path_with_type":"Xã Cường Lợi, Huyện Đình Lập, Tỉnh Lạng Sơn","code":"06634","parent_code":"189"},"06637":{"name":"Xã Châu Sơn","type":"xa","slug":"xa-chau-son","name_with_type":"Xã Châu Sơn","path":"Xã Châu Sơn, Huyện Đình Lập, Tỉnh Lạng Sơn","path_with_type":"Xã Châu Sơn, Huyện Đình Lập, Tỉnh Lạng Sơn","code":"06637","parent_code":"189"},"06640":{"name":"Xã Lâm Ca","type":"xa","slug":"xa-lam-ca","name_with_type":"Xã Lâm Ca","path":"Xã Lâm Ca, Huyện Đình Lập, Tỉnh Lạng Sơn","path_with_type":"Xã Lâm Ca, Huyện Đình Lập, Tỉnh Lạng Sơn","code":"06640","parent_code":"189"},"06643":{"name":"Xã Đồng Thắng","type":"xa","slug":"xa-dong-thang","name_with_type":"Xã Đồng Thắng","path":"Xã Đồng Thắng, Huyện Đình Lập, Tỉnh Lạng Sơn","path_with_type":"Xã Đồng Thắng, Huyện Đình Lập, Tỉnh Lạng Sơn","code":"06643","parent_code":"189"},"06646":{"name":"Xã Bắc Lãng","type":"xa","slug":"xa-bac-lang","name_with_type":"Xã Bắc Lãng","path":"Xã Bắc Lãng, Huyện Đình Lập, Tỉnh Lạng Sơn","path_with_type":"Xã Bắc Lãng, Huyện Đình Lập, Tỉnh Lạng Sơn","code":"06646","parent_code":"189"},"06649":{"name":"Phường Hà Khánh","type":"phuong","slug":"phuong-ha-khanh","name_with_type":"Phường Hà Khánh","path":"Phường Hà Khánh, Thành phố Hạ Long, Tỉnh Quảng Ninh","path_with_type":"Phường Hà Khánh, Thành phố Hạ Long, Tỉnh Quảng Ninh","code":"06649","parent_code":"193"},"06652":{"name":"Phường Hà Phong","type":"phuong","slug":"phuong-ha-phong","name_with_type":"Phường Hà Phong","path":"Phường Hà Phong, Thành phố Hạ Long, Tỉnh Quảng Ninh","path_with_type":"Phường Hà Phong, Thành phố Hạ Long, Tỉnh Quảng Ninh","code":"06652","parent_code":"193"},"06655":{"name":"Phường Hà Khẩu","type":"phuong","slug":"phuong-ha-khau","name_with_type":"Phường Hà Khẩu","path":"Phường Hà Khẩu, Thành phố Hạ Long, Tỉnh Quảng Ninh","path_with_type":"Phường Hà Khẩu, Thành phố Hạ Long, Tỉnh Quảng Ninh","code":"06655","parent_code":"193"},"06658":{"name":"Phường Cao Xanh","type":"phuong","slug":"phuong-cao-xanh","name_with_type":"Phường Cao Xanh","path":"Phường Cao Xanh, Thành phố Hạ Long, Tỉnh Quảng Ninh","path_with_type":"Phường Cao Xanh, Thành phố Hạ Long, Tỉnh Quảng Ninh","code":"06658","parent_code":"193"},"06661":{"name":"Phường Giếng Đáy","type":"phuong","slug":"phuong-gieng-day","name_with_type":"Phường Giếng Đáy","path":"Phường Giếng Đáy, Thành phố Hạ Long, Tỉnh Quảng Ninh","path_with_type":"Phường Giếng Đáy, Thành phố Hạ Long, Tỉnh Quảng Ninh","code":"06661","parent_code":"193"},"06664":{"name":"Phường Hà Tu","type":"phuong","slug":"phuong-ha-tu","name_with_type":"Phường Hà Tu","path":"Phường Hà Tu, Thành phố Hạ Long, Tỉnh Quảng Ninh","path_with_type":"Phường Hà Tu, Thành phố Hạ Long, Tỉnh Quảng Ninh","code":"06664","parent_code":"193"},"06667":{"name":"Phường Hà Trung","type":"phuong","slug":"phuong-ha-trung","name_with_type":"Phường Hà Trung","path":"Phường Hà Trung, Thành phố Hạ Long, Tỉnh Quảng Ninh","path_with_type":"Phường Hà Trung, Thành phố Hạ Long, Tỉnh Quảng Ninh","code":"06667","parent_code":"193"},"06670":{"name":"Phường Hà Lầm","type":"phuong","slug":"phuong-ha-lam","name_with_type":"Phường Hà Lầm","path":"Phường Hà Lầm, Thành phố Hạ Long, Tỉnh Quảng Ninh","path_with_type":"Phường Hà Lầm, Thành phố Hạ Long, Tỉnh Quảng Ninh","code":"06670","parent_code":"193"},"06673":{"name":"Phường Bãi Cháy","type":"phuong","slug":"phuong-bai-chay","name_with_type":"Phường Bãi Cháy","path":"Phường Bãi Cháy, Thành phố Hạ Long, Tỉnh Quảng Ninh","path_with_type":"Phường Bãi Cháy, Thành phố Hạ Long, Tỉnh Quảng Ninh","code":"06673","parent_code":"193"},"06676":{"name":"Phường Cao Thắng","type":"phuong","slug":"phuong-cao-thang","name_with_type":"Phường Cao Thắng","path":"Phường Cao Thắng, Thành phố Hạ Long, Tỉnh Quảng Ninh","path_with_type":"Phường Cao Thắng, Thành phố Hạ Long, Tỉnh Quảng Ninh","code":"06676","parent_code":"193"},"06679":{"name":"Phường Hùng Thắng","type":"phuong","slug":"phuong-hung-thang","name_with_type":"Phường Hùng Thắng","path":"Phường Hùng Thắng, Thành phố Hạ Long, Tỉnh Quảng Ninh","path_with_type":"Phường Hùng Thắng, Thành phố Hạ Long, Tỉnh Quảng Ninh","code":"06679","parent_code":"193"},"06685":{"name":"Phường Trần Hưng Đạo","type":"phuong","slug":"phuong-tran-hung-dao","name_with_type":"Phường Trần Hưng Đạo","path":"Phường Trần Hưng Đạo, Thành phố Hạ Long, Tỉnh Quảng Ninh","path_with_type":"Phường Trần Hưng Đạo, Thành phố Hạ Long, Tỉnh Quảng Ninh","code":"06685","parent_code":"193"},"06688":{"name":"Phường Hồng Hải","type":"phuong","slug":"phuong-hong-hai","name_with_type":"Phường Hồng Hải","path":"Phường Hồng Hải, Thành phố Hạ Long, Tỉnh Quảng Ninh","path_with_type":"Phường Hồng Hải, Thành phố Hạ Long, Tỉnh Quảng Ninh","code":"06688","parent_code":"193"},"06691":{"name":"Phường Hồng Gai","type":"phuong","slug":"phuong-hong-gai","name_with_type":"Phường Hồng Gai","path":"Phường Hồng Gai, Thành phố Hạ Long, Tỉnh Quảng Ninh","path_with_type":"Phường Hồng Gai, Thành phố Hạ Long, Tỉnh Quảng Ninh","code":"06691","parent_code":"193"},"06694":{"name":"Phường Bạch Đằng","type":"phuong","slug":"phuong-bach-dang","name_with_type":"Phường Bạch Đằng","path":"Phường Bạch Đằng, Thành phố Hạ Long, Tỉnh Quảng Ninh","path_with_type":"Phường Bạch Đằng, Thành phố Hạ Long, Tỉnh Quảng Ninh","code":"06694","parent_code":"193"},"06697":{"name":"Phường Hồng Hà","type":"phuong","slug":"phuong-hong-ha","name_with_type":"Phường Hồng Hà","path":"Phường Hồng Hà, Thành phố Hạ Long, Tỉnh Quảng Ninh","path_with_type":"Phường Hồng Hà, Thành phố Hạ Long, Tỉnh Quảng Ninh","code":"06697","parent_code":"193"},"06700":{"name":"Phường Tuần Châu","type":"phuong","slug":"phuong-tuan-chau","name_with_type":"Phường Tuần Châu","path":"Phường Tuần Châu, Thành phố Hạ Long, Tỉnh Quảng Ninh","path_with_type":"Phường Tuần Châu, Thành phố Hạ Long, Tỉnh Quảng Ninh","code":"06700","parent_code":"193"},"06703":{"name":"Phường Việt Hưng","type":"phuong","slug":"phuong-viet-hung","name_with_type":"Phường Việt Hưng","path":"Phường Việt Hưng, Thành phố Hạ Long, Tỉnh Quảng Ninh","path_with_type":"Phường Việt Hưng, Thành phố Hạ Long, Tỉnh Quảng Ninh","code":"06703","parent_code":"193"},"06706":{"name":"Phường Đại Yên","type":"phuong","slug":"phuong-dai-yen","name_with_type":"Phường Đại Yên","path":"Phường Đại Yên, Thành phố Hạ Long, Tỉnh Quảng Ninh","path_with_type":"Phường Đại Yên, Thành phố Hạ Long, Tỉnh Quảng Ninh","code":"06706","parent_code":"193"},"07030":{"name":"Phường Hoành Bồ","type":"phuong","slug":"phuong-hoanh-bo","name_with_type":"Phường Hoành Bồ","path":"Phường Hoành Bồ, Thành phố Hạ Long, Tỉnh Quảng Ninh","path_with_type":"Phường Hoành Bồ, Thành phố Hạ Long, Tỉnh Quảng Ninh","code":"07030","parent_code":"193"},"07033":{"name":"Xã Kỳ Thượng","type":"xa","slug":"xa-ky-thuong","name_with_type":"Xã Kỳ Thượng","path":"Xã Kỳ Thượng, Thành phố Hạ Long, Tỉnh Quảng Ninh","path_with_type":"Xã Kỳ Thượng, Thành phố Hạ Long, Tỉnh Quảng Ninh","code":"07033","parent_code":"193"},"07036":{"name":"Xã Đồng Sơn","type":"xa","slug":"xa-dong-son","name_with_type":"Xã Đồng Sơn","path":"Xã Đồng Sơn, Thành phố Hạ Long, Tỉnh Quảng Ninh","path_with_type":"Xã Đồng Sơn, Thành phố Hạ Long, Tỉnh Quảng Ninh","code":"07036","parent_code":"193"},"07039":{"name":"Xã Tân Dân","type":"xa","slug":"xa-tan-dan","name_with_type":"Xã Tân Dân","path":"Xã Tân Dân, Thành phố Hạ Long, Tỉnh Quảng Ninh","path_with_type":"Xã Tân Dân, Thành phố Hạ Long, Tỉnh Quảng Ninh","code":"07039","parent_code":"193"},"07042":{"name":"Xã Đồng Lâm","type":"xa","slug":"xa-dong-lam","name_with_type":"Xã Đồng Lâm","path":"Xã Đồng Lâm, Thành phố Hạ Long, Tỉnh Quảng Ninh","path_with_type":"Xã Đồng Lâm, Thành phố Hạ Long, Tỉnh Quảng Ninh","code":"07042","parent_code":"193"},"07045":{"name":"Xã Hòa Bình","type":"xa","slug":"xa-hoa-binh","name_with_type":"Xã Hòa Bình","path":"Xã Hòa Bình, Thành phố Hạ Long, Tỉnh Quảng Ninh","path_with_type":"Xã Hòa Bình, Thành phố Hạ Long, Tỉnh Quảng Ninh","code":"07045","parent_code":"193"},"07048":{"name":"Xã Vũ Oai","type":"xa","slug":"xa-vu-oai","name_with_type":"Xã Vũ Oai","path":"Xã Vũ Oai, Thành phố Hạ Long, Tỉnh Quảng Ninh","path_with_type":"Xã Vũ Oai, Thành phố Hạ Long, Tỉnh Quảng Ninh","code":"07048","parent_code":"193"},"07051":{"name":"Xã Dân Chủ","type":"xa","slug":"xa-dan-chu","name_with_type":"Xã Dân Chủ","path":"Xã Dân Chủ, Thành phố Hạ Long, Tỉnh Quảng Ninh","path_with_type":"Xã Dân Chủ, Thành phố Hạ Long, Tỉnh Quảng Ninh","code":"07051","parent_code":"193"},"07054":{"name":"Xã Quảng La","type":"xa","slug":"xa-quang-la","name_with_type":"Xã Quảng La","path":"Xã Quảng La, Thành phố Hạ Long, Tỉnh Quảng Ninh","path_with_type":"Xã Quảng La, Thành phố Hạ Long, Tỉnh Quảng Ninh","code":"07054","parent_code":"193"},"07057":{"name":"Xã Bằng Cả","type":"xa","slug":"xa-bang-ca","name_with_type":"Xã Bằng Cả","path":"Xã Bằng Cả, Thành phố Hạ Long, Tỉnh Quảng Ninh","path_with_type":"Xã Bằng Cả, Thành phố Hạ Long, Tỉnh Quảng Ninh","code":"07057","parent_code":"193"},"07060":{"name":"Xã Thống Nhất","type":"xa","slug":"xa-thong-nhat","name_with_type":"Xã Thống Nhất","path":"Xã Thống Nhất, Thành phố Hạ Long, Tỉnh Quảng Ninh","path_with_type":"Xã Thống Nhất, Thành phố Hạ Long, Tỉnh Quảng Ninh","code":"07060","parent_code":"193"},"07063":{"name":"Xã Sơn Dương","type":"xa","slug":"xa-son-duong","name_with_type":"Xã Sơn Dương","path":"Xã Sơn Dương, Thành phố Hạ Long, Tỉnh Quảng Ninh","path_with_type":"Xã Sơn Dương, Thành phố Hạ Long, Tỉnh Quảng Ninh","code":"07063","parent_code":"193"},"07066":{"name":"Xã Lê Lợi","type":"xa","slug":"xa-le-loi","name_with_type":"Xã Lê Lợi","path":"Xã Lê Lợi, Thành phố Hạ Long, Tỉnh Quảng Ninh","path_with_type":"Xã Lê Lợi, Thành phố Hạ Long, Tỉnh Quảng Ninh","code":"07066","parent_code":"193"},"06709":{"name":"Phường Ka Long","type":"phuong","slug":"phuong-ka-long","name_with_type":"Phường Ka Long","path":"Phường Ka Long, Thành phố Móng Cái, Tỉnh Quảng Ninh","path_with_type":"Phường Ka Long, Thành phố Móng Cái, Tỉnh Quảng Ninh","code":"06709","parent_code":"194"},"06712":{"name":"Phường Trần Phú","type":"phuong","slug":"phuong-tran-phu","name_with_type":"Phường Trần Phú","path":"Phường Trần Phú, Thành phố Móng Cái, Tỉnh Quảng Ninh","path_with_type":"Phường Trần Phú, Thành phố Móng Cái, Tỉnh Quảng Ninh","code":"06712","parent_code":"194"},"06715":{"name":"Phường Ninh Dương","type":"phuong","slug":"phuong-ninh-duong","name_with_type":"Phường Ninh Dương","path":"Phường Ninh Dương, Thành phố Móng Cái, Tỉnh Quảng Ninh","path_with_type":"Phường Ninh Dương, Thành phố Móng Cái, Tỉnh Quảng Ninh","code":"06715","parent_code":"194"},"06721":{"name":"Phường Trà Cổ","type":"phuong","slug":"phuong-tra-co","name_with_type":"Phường Trà Cổ","path":"Phường Trà Cổ, Thành phố Móng Cái, Tỉnh Quảng Ninh","path_with_type":"Phường Trà Cổ, Thành phố Móng Cái, Tỉnh Quảng Ninh","code":"06721","parent_code":"194"},"06724":{"name":"Xã Hải Sơn","type":"xa","slug":"xa-hai-son","name_with_type":"Xã Hải Sơn","path":"Xã Hải Sơn, Thành phố Móng Cái, Tỉnh Quảng Ninh","path_with_type":"Xã Hải Sơn, Thành phố Móng Cái, Tỉnh Quảng Ninh","code":"06724","parent_code":"194"},"06727":{"name":"Xã Bắc Sơn","type":"xa","slug":"xa-bac-son","name_with_type":"Xã Bắc Sơn","path":"Xã Bắc Sơn, Thành phố Móng Cái, Tỉnh Quảng Ninh","path_with_type":"Xã Bắc Sơn, Thành phố Móng Cái, Tỉnh Quảng Ninh","code":"06727","parent_code":"194"},"06730":{"name":"Xã Hải Đông","type":"xa","slug":"xa-hai-dong","name_with_type":"Xã Hải Đông","path":"Xã Hải Đông, Thành phố Móng Cái, Tỉnh Quảng Ninh","path_with_type":"Xã Hải Đông, Thành phố Móng Cái, Tỉnh Quảng Ninh","code":"06730","parent_code":"194"},"06733":{"name":"Xã Hải Tiến","type":"xa","slug":"xa-hai-tien","name_with_type":"Xã Hải Tiến","path":"Xã Hải Tiến, Thành phố Móng Cái, Tỉnh Quảng Ninh","path_with_type":"Xã Hải Tiến, Thành phố Móng Cái, Tỉnh Quảng Ninh","code":"06733","parent_code":"194"},"06736":{"name":"Phường Hải Yên","type":"phuong","slug":"phuong-hai-yen","name_with_type":"Phường Hải Yên","path":"Phường Hải Yên, Thành phố Móng Cái, Tỉnh Quảng Ninh","path_with_type":"Phường Hải Yên, Thành phố Móng Cái, Tỉnh Quảng Ninh","code":"06736","parent_code":"194"},"06739":{"name":"Xã Quảng Nghĩa","type":"xa","slug":"xa-quang-nghia","name_with_type":"Xã Quảng Nghĩa","path":"Xã Quảng Nghĩa, Thành phố Móng Cái, Tỉnh Quảng Ninh","path_with_type":"Xã Quảng Nghĩa, Thành phố Móng Cái, Tỉnh Quảng Ninh","code":"06739","parent_code":"194"},"06742":{"name":"Phường Hải Hoà","type":"phuong","slug":"phuong-hai-hoa","name_with_type":"Phường Hải Hoà","path":"Phường Hải Hoà, Thành phố Móng Cái, Tỉnh Quảng Ninh","path_with_type":"Phường Hải Hoà, Thành phố Móng Cái, Tỉnh Quảng Ninh","code":"06742","parent_code":"194"},"06745":{"name":"Xã Hải Xuân","type":"xa","slug":"xa-hai-xuan","name_with_type":"Xã Hải Xuân","path":"Xã Hải Xuân, Thành phố Móng Cái, Tỉnh Quảng Ninh","path_with_type":"Xã Hải Xuân, Thành phố Móng Cái, Tỉnh Quảng Ninh","code":"06745","parent_code":"194"},"06748":{"name":"Xã Vạn Ninh","type":"xa","slug":"xa-van-ninh","name_with_type":"Xã Vạn Ninh","path":"Xã Vạn Ninh, Thành phố Móng Cái, Tỉnh Quảng Ninh","path_with_type":"Xã Vạn Ninh, Thành phố Móng Cái, Tỉnh Quảng Ninh","code":"06748","parent_code":"194"},"06751":{"name":"Phường Bình Ngọc","type":"phuong","slug":"phuong-binh-ngoc","name_with_type":"Phường Bình Ngọc","path":"Phường Bình Ngọc, Thành phố Móng Cái, Tỉnh Quảng Ninh","path_with_type":"Phường Bình Ngọc, Thành phố Móng Cái, Tỉnh Quảng Ninh","code":"06751","parent_code":"194"},"06754":{"name":"Xã Vĩnh Trung","type":"xa","slug":"xa-vinh-trung","name_with_type":"Xã Vĩnh Trung","path":"Xã Vĩnh Trung, Thành phố Móng Cái, Tỉnh Quảng Ninh","path_with_type":"Xã Vĩnh Trung, Thành phố Móng Cái, Tỉnh Quảng Ninh","code":"06754","parent_code":"194"},"06757":{"name":"Xã Vĩnh Thực","type":"xa","slug":"xa-vinh-thuc","name_with_type":"Xã Vĩnh Thực","path":"Xã Vĩnh Thực, Thành phố Móng Cái, Tỉnh Quảng Ninh","path_with_type":"Xã Vĩnh Thực, Thành phố Móng Cái, Tỉnh Quảng Ninh","code":"06757","parent_code":"194"},"06760":{"name":"Phường Mông Dương","type":"phuong","slug":"phuong-mong-duong","name_with_type":"Phường Mông Dương","path":"Phường Mông Dương, Thành phố Cẩm Phả, Tỉnh Quảng Ninh","path_with_type":"Phường Mông Dương, Thành phố Cẩm Phả, Tỉnh Quảng Ninh","code":"06760","parent_code":"195"},"06763":{"name":"Phường Cửa Ông","type":"phuong","slug":"phuong-cua-ong","name_with_type":"Phường Cửa Ông","path":"Phường Cửa Ông, Thành phố Cẩm Phả, Tỉnh Quảng Ninh","path_with_type":"Phường Cửa Ông, Thành phố Cẩm Phả, Tỉnh Quảng Ninh","code":"06763","parent_code":"195"},"06766":{"name":"Phường Cẩm Sơn","type":"phuong","slug":"phuong-cam-son","name_with_type":"Phường Cẩm Sơn","path":"Phường Cẩm Sơn, Thành phố Cẩm Phả, Tỉnh Quảng Ninh","path_with_type":"Phường Cẩm Sơn, Thành phố Cẩm Phả, Tỉnh Quảng Ninh","code":"06766","parent_code":"195"},"06769":{"name":"Phường Cẩm Đông","type":"phuong","slug":"phuong-cam-dong","name_with_type":"Phường Cẩm Đông","path":"Phường Cẩm Đông, Thành phố Cẩm Phả, Tỉnh Quảng Ninh","path_with_type":"Phường Cẩm Đông, Thành phố Cẩm Phả, Tỉnh Quảng Ninh","code":"06769","parent_code":"195"},"06772":{"name":"Phường Cẩm Phú","type":"phuong","slug":"phuong-cam-phu","name_with_type":"Phường Cẩm Phú","path":"Phường Cẩm Phú, Thành phố Cẩm Phả, Tỉnh Quảng Ninh","path_with_type":"Phường Cẩm Phú, Thành phố Cẩm Phả, Tỉnh Quảng Ninh","code":"06772","parent_code":"195"},"06775":{"name":"Phường Cẩm Tây","type":"phuong","slug":"phuong-cam-tay","name_with_type":"Phường Cẩm Tây","path":"Phường Cẩm Tây, Thành phố Cẩm Phả, Tỉnh Quảng Ninh","path_with_type":"Phường Cẩm Tây, Thành phố Cẩm Phả, Tỉnh Quảng Ninh","code":"06775","parent_code":"195"},"06778":{"name":"Phường Quang Hanh","type":"phuong","slug":"phuong-quang-hanh","name_with_type":"Phường Quang Hanh","path":"Phường Quang Hanh, Thành phố Cẩm Phả, Tỉnh Quảng Ninh","path_with_type":"Phường Quang Hanh, Thành phố Cẩm Phả, Tỉnh Quảng Ninh","code":"06778","parent_code":"195"},"06781":{"name":"Phường Cẩm Thịnh","type":"phuong","slug":"phuong-cam-thinh","name_with_type":"Phường Cẩm Thịnh","path":"Phường Cẩm Thịnh, Thành phố Cẩm Phả, Tỉnh Quảng Ninh","path_with_type":"Phường Cẩm Thịnh, Thành phố Cẩm Phả, Tỉnh Quảng Ninh","code":"06781","parent_code":"195"},"06784":{"name":"Phường Cẩm Thủy","type":"phuong","slug":"phuong-cam-thuy","name_with_type":"Phường Cẩm Thủy","path":"Phường Cẩm Thủy, Thành phố Cẩm Phả, Tỉnh Quảng Ninh","path_with_type":"Phường Cẩm Thủy, Thành phố Cẩm Phả, Tỉnh Quảng Ninh","code":"06784","parent_code":"195"},"06787":{"name":"Phường Cẩm Thạch","type":"phuong","slug":"phuong-cam-thach","name_with_type":"Phường Cẩm Thạch","path":"Phường Cẩm Thạch, Thành phố Cẩm Phả, Tỉnh Quảng Ninh","path_with_type":"Phường Cẩm Thạch, Thành phố Cẩm Phả, Tỉnh Quảng Ninh","code":"06787","parent_code":"195"},"06790":{"name":"Phường Cẩm Thành","type":"phuong","slug":"phuong-cam-thanh","name_with_type":"Phường Cẩm Thành","path":"Phường Cẩm Thành, Thành phố Cẩm Phả, Tỉnh Quảng Ninh","path_with_type":"Phường Cẩm Thành, Thành phố Cẩm Phả, Tỉnh Quảng Ninh","code":"06790","parent_code":"195"},"06793":{"name":"Phường Cẩm Trung","type":"phuong","slug":"phuong-cam-trung","name_with_type":"Phường Cẩm Trung","path":"Phường Cẩm Trung, Thành phố Cẩm Phả, Tỉnh Quảng Ninh","path_with_type":"Phường Cẩm Trung, Thành phố Cẩm Phả, Tỉnh Quảng Ninh","code":"06793","parent_code":"195"},"06796":{"name":"Phường Cẩm Bình","type":"phuong","slug":"phuong-cam-binh","name_with_type":"Phường Cẩm Bình","path":"Phường Cẩm Bình, Thành phố Cẩm Phả, Tỉnh Quảng Ninh","path_with_type":"Phường Cẩm Bình, Thành phố Cẩm Phả, Tỉnh Quảng Ninh","code":"06796","parent_code":"195"},"06799":{"name":"Xã Hải Hòa","type":"xa","slug":"xa-hai-hoa","name_with_type":"Xã Hải Hòa","path":"Xã Hải Hòa, Thành phố Cẩm Phả, Tỉnh Quảng Ninh","path_with_type":"Xã Hải Hòa, Thành phố Cẩm Phả, Tỉnh Quảng Ninh","code":"06799","parent_code":"195"},"06805":{"name":"Xã Dương Huy","type":"xa","slug":"xa-duong-huy","name_with_type":"Xã Dương Huy","path":"Xã Dương Huy, Thành phố Cẩm Phả, Tỉnh Quảng Ninh","path_with_type":"Xã Dương Huy, Thành phố Cẩm Phả, Tỉnh Quảng Ninh","code":"06805","parent_code":"195"},"06808":{"name":"Phường Vàng Danh","type":"phuong","slug":"phuong-vang-danh","name_with_type":"Phường Vàng Danh","path":"Phường Vàng Danh, Thành phố Uông Bí, Tỉnh Quảng Ninh","path_with_type":"Phường Vàng Danh, Thành phố Uông Bí, Tỉnh Quảng Ninh","code":"06808","parent_code":"196"},"06811":{"name":"Phường Thanh Sơn","type":"phuong","slug":"phuong-thanh-son","name_with_type":"Phường Thanh Sơn","path":"Phường Thanh Sơn, Thành phố Uông Bí, Tỉnh Quảng Ninh","path_with_type":"Phường Thanh Sơn, Thành phố Uông Bí, Tỉnh Quảng Ninh","code":"06811","parent_code":"196"},"06814":{"name":"Phường Bắc Sơn","type":"phuong","slug":"phuong-bac-son","name_with_type":"Phường Bắc Sơn","path":"Phường Bắc Sơn, Thành phố Uông Bí, Tỉnh Quảng Ninh","path_with_type":"Phường Bắc Sơn, Thành phố Uông Bí, Tỉnh Quảng Ninh","code":"06814","parent_code":"196"},"06817":{"name":"Phường Quang Trung","type":"phuong","slug":"phuong-quang-trung","name_with_type":"Phường Quang Trung","path":"Phường Quang Trung, Thành phố Uông Bí, Tỉnh Quảng Ninh","path_with_type":"Phường Quang Trung, Thành phố Uông Bí, Tỉnh Quảng Ninh","code":"06817","parent_code":"196"},"06820":{"name":"Phường Trưng Vương","type":"phuong","slug":"phuong-trung-vuong","name_with_type":"Phường Trưng Vương","path":"Phường Trưng Vương, Thành phố Uông Bí, Tỉnh Quảng Ninh","path_with_type":"Phường Trưng Vương, Thành phố Uông Bí, Tỉnh Quảng Ninh","code":"06820","parent_code":"196"},"06823":{"name":"Phường Nam Khê","type":"phuong","slug":"phuong-nam-khe","name_with_type":"Phường Nam Khê","path":"Phường Nam Khê, Thành phố Uông Bí, Tỉnh Quảng Ninh","path_with_type":"Phường Nam Khê, Thành phố Uông Bí, Tỉnh Quảng Ninh","code":"06823","parent_code":"196"},"06826":{"name":"Phường Yên Thanh","type":"phuong","slug":"phuong-yen-thanh","name_with_type":"Phường Yên Thanh","path":"Phường Yên Thanh, Thành phố Uông Bí, Tỉnh Quảng Ninh","path_with_type":"Phường Yên Thanh, Thành phố Uông Bí, Tỉnh Quảng Ninh","code":"06826","parent_code":"196"},"06829":{"name":"Xã Thượng Yên Công","type":"xa","slug":"xa-thuong-yen-cong","name_with_type":"Xã Thượng Yên Công","path":"Xã Thượng Yên Công, Thành phố Uông Bí, Tỉnh Quảng Ninh","path_with_type":"Xã Thượng Yên Công, Thành phố Uông Bí, Tỉnh Quảng Ninh","code":"06829","parent_code":"196"},"06832":{"name":"Phường Phương Đông","type":"phuong","slug":"phuong-phuong-dong","name_with_type":"Phường Phương Đông","path":"Phường Phương Đông, Thành phố Uông Bí, Tỉnh Quảng Ninh","path_with_type":"Phường Phương Đông, Thành phố Uông Bí, Tỉnh Quảng Ninh","code":"06832","parent_code":"196"},"06835":{"name":"Phường Phương Nam","type":"phuong","slug":"phuong-phuong-nam","name_with_type":"Phường Phương Nam","path":"Phường Phương Nam, Thành phố Uông Bí, Tỉnh Quảng Ninh","path_with_type":"Phường Phương Nam, Thành phố Uông Bí, Tỉnh Quảng Ninh","code":"06835","parent_code":"196"},"06838":{"name":"Thị trấn Bình Liêu","type":"thi-tran","slug":"thi-tran-binh-lieu","name_with_type":"Thị trấn Bình Liêu","path":"Thị trấn Bình Liêu, Huyện Bình Liêu, Tỉnh Quảng Ninh","path_with_type":"Thị trấn Bình Liêu, Huyện Bình Liêu, Tỉnh Quảng Ninh","code":"06838","parent_code":"198"},"06841":{"name":"Xã Hoành Mô","type":"xa","slug":"xa-hoanh-mo","name_with_type":"Xã Hoành Mô","path":"Xã Hoành Mô, Huyện Bình Liêu, Tỉnh Quảng Ninh","path_with_type":"Xã Hoành Mô, Huyện Bình Liêu, Tỉnh Quảng Ninh","code":"06841","parent_code":"198"},"06844":{"name":"Xã Đồng Tâm","type":"xa","slug":"xa-dong-tam","name_with_type":"Xã Đồng Tâm","path":"Xã Đồng Tâm, Huyện Bình Liêu, Tỉnh Quảng Ninh","path_with_type":"Xã Đồng Tâm, Huyện Bình Liêu, Tỉnh Quảng Ninh","code":"06844","parent_code":"198"},"06847":{"name":"Xã Đồng Văn","type":"xa","slug":"xa-dong-van","name_with_type":"Xã Đồng Văn","path":"Xã Đồng Văn, Huyện Bình Liêu, Tỉnh Quảng Ninh","path_with_type":"Xã Đồng Văn, Huyện Bình Liêu, Tỉnh Quảng Ninh","code":"06847","parent_code":"198"},"06853":{"name":"Xã Vô Ngại","type":"xa","slug":"xa-vo-ngai","name_with_type":"Xã Vô Ngại","path":"Xã Vô Ngại, Huyện Bình Liêu, Tỉnh Quảng Ninh","path_with_type":"Xã Vô Ngại, Huyện Bình Liêu, Tỉnh Quảng Ninh","code":"06853","parent_code":"198"},"06856":{"name":"Xã Lục Hồn","type":"xa","slug":"xa-luc-hon","name_with_type":"Xã Lục Hồn","path":"Xã Lục Hồn, Huyện Bình Liêu, Tỉnh Quảng Ninh","path_with_type":"Xã Lục Hồn, Huyện Bình Liêu, Tỉnh Quảng Ninh","code":"06856","parent_code":"198"},"06859":{"name":"Xã Húc Động","type":"xa","slug":"xa-huc-dong","name_with_type":"Xã Húc Động","path":"Xã Húc Động, Huyện Bình Liêu, Tỉnh Quảng Ninh","path_with_type":"Xã Húc Động, Huyện Bình Liêu, Tỉnh Quảng Ninh","code":"06859","parent_code":"198"},"06862":{"name":"Thị trấn Tiên Yên","type":"thi-tran","slug":"thi-tran-tien-yen","name_with_type":"Thị trấn Tiên Yên","path":"Thị trấn Tiên Yên, Huyện Tiên Yên, Tỉnh Quảng Ninh","path_with_type":"Thị trấn Tiên Yên, Huyện Tiên Yên, Tỉnh Quảng Ninh","code":"06862","parent_code":"199"},"06865":{"name":"Xã Hà Lâu","type":"xa","slug":"xa-ha-lau","name_with_type":"Xã Hà Lâu","path":"Xã Hà Lâu, Huyện Tiên Yên, Tỉnh Quảng Ninh","path_with_type":"Xã Hà Lâu, Huyện Tiên Yên, Tỉnh Quảng Ninh","code":"06865","parent_code":"199"},"06868":{"name":"Xã Đại Dực","type":"xa","slug":"xa-dai-duc","name_with_type":"Xã Đại Dực","path":"Xã Đại Dực, Huyện Tiên Yên, Tỉnh Quảng Ninh","path_with_type":"Xã Đại Dực, Huyện Tiên Yên, Tỉnh Quảng Ninh","code":"06868","parent_code":"199"},"06871":{"name":"Xã Phong Dụ","type":"xa","slug":"xa-phong-du","name_with_type":"Xã Phong Dụ","path":"Xã Phong Dụ, Huyện Tiên Yên, Tỉnh Quảng Ninh","path_with_type":"Xã Phong Dụ, Huyện Tiên Yên, Tỉnh Quảng Ninh","code":"06871","parent_code":"199"},"06874":{"name":"Xã Điền Xá","type":"xa","slug":"xa-dien-xa","name_with_type":"Xã Điền Xá","path":"Xã Điền Xá, Huyện Tiên Yên, Tỉnh Quảng Ninh","path_with_type":"Xã Điền Xá, Huyện Tiên Yên, Tỉnh Quảng Ninh","code":"06874","parent_code":"199"},"06877":{"name":"Xã Đông Ngũ","type":"xa","slug":"xa-dong-ngu","name_with_type":"Xã Đông Ngũ","path":"Xã Đông Ngũ, Huyện Tiên Yên, Tỉnh Quảng Ninh","path_with_type":"Xã Đông Ngũ, Huyện Tiên Yên, Tỉnh Quảng Ninh","code":"06877","parent_code":"199"},"06880":{"name":"Xã Yên Than","type":"xa","slug":"xa-yen-than","name_with_type":"Xã Yên Than","path":"Xã Yên Than, Huyện Tiên Yên, Tỉnh Quảng Ninh","path_with_type":"Xã Yên Than, Huyện Tiên Yên, Tỉnh Quảng Ninh","code":"06880","parent_code":"199"},"06883":{"name":"Xã Đông Hải","type":"xa","slug":"xa-dong-hai","name_with_type":"Xã Đông Hải","path":"Xã Đông Hải, Huyện Tiên Yên, Tỉnh Quảng Ninh","path_with_type":"Xã Đông Hải, Huyện Tiên Yên, Tỉnh Quảng Ninh","code":"06883","parent_code":"199"},"06886":{"name":"Xã Hải Lạng","type":"xa","slug":"xa-hai-lang","name_with_type":"Xã Hải Lạng","path":"Xã Hải Lạng, Huyện Tiên Yên, Tỉnh Quảng Ninh","path_with_type":"Xã Hải Lạng, Huyện Tiên Yên, Tỉnh Quảng Ninh","code":"06886","parent_code":"199"},"06889":{"name":"Xã Tiên Lãng","type":"xa","slug":"xa-tien-lang","name_with_type":"Xã Tiên Lãng","path":"Xã Tiên Lãng, Huyện Tiên Yên, Tỉnh Quảng Ninh","path_with_type":"Xã Tiên Lãng, Huyện Tiên Yên, Tỉnh Quảng Ninh","code":"06889","parent_code":"199"},"06892":{"name":"Xã Đồng Rui","type":"xa","slug":"xa-dong-rui","name_with_type":"Xã Đồng Rui","path":"Xã Đồng Rui, Huyện Tiên Yên, Tỉnh Quảng Ninh","path_with_type":"Xã Đồng Rui, Huyện Tiên Yên, Tỉnh Quảng Ninh","code":"06892","parent_code":"199"},"06895":{"name":"Thị trấn Đầm Hà","type":"thi-tran","slug":"thi-tran-dam-ha","name_with_type":"Thị trấn Đầm Hà","path":"Thị trấn Đầm Hà, Huyện Đầm Hà, Tỉnh Quảng Ninh","path_with_type":"Thị trấn Đầm Hà, Huyện Đầm Hà, Tỉnh Quảng Ninh","code":"06895","parent_code":"200"},"06898":{"name":"Xã Quảng Lâm","type":"xa","slug":"xa-quang-lam","name_with_type":"Xã Quảng Lâm","path":"Xã Quảng Lâm, Huyện Đầm Hà, Tỉnh Quảng Ninh","path_with_type":"Xã Quảng Lâm, Huyện Đầm Hà, Tỉnh Quảng Ninh","code":"06898","parent_code":"200"},"06901":{"name":"Xã Quảng An","type":"xa","slug":"xa-quang-an","name_with_type":"Xã Quảng An","path":"Xã Quảng An, Huyện Đầm Hà, Tỉnh Quảng Ninh","path_with_type":"Xã Quảng An, Huyện Đầm Hà, Tỉnh Quảng Ninh","code":"06901","parent_code":"200"},"06904":{"name":"Xã Tân Bình","type":"xa","slug":"xa-tan-binh","name_with_type":"Xã Tân Bình","path":"Xã Tân Bình, Huyện Đầm Hà, Tỉnh Quảng Ninh","path_with_type":"Xã Tân Bình, Huyện Đầm Hà, Tỉnh Quảng Ninh","code":"06904","parent_code":"200"},"06910":{"name":"Xã Dực Yên","type":"xa","slug":"xa-duc-yen","name_with_type":"Xã Dực Yên","path":"Xã Dực Yên, Huyện Đầm Hà, Tỉnh Quảng Ninh","path_with_type":"Xã Dực Yên, Huyện Đầm Hà, Tỉnh Quảng Ninh","code":"06910","parent_code":"200"},"06913":{"name":"Xã Quảng Tân","type":"xa","slug":"xa-quang-tan","name_with_type":"Xã Quảng Tân","path":"Xã Quảng Tân, Huyện Đầm Hà, Tỉnh Quảng Ninh","path_with_type":"Xã Quảng Tân, Huyện Đầm Hà, Tỉnh Quảng Ninh","code":"06913","parent_code":"200"},"06916":{"name":"Xã Đầm Hà","type":"xa","slug":"xa-dam-ha","name_with_type":"Xã Đầm Hà","path":"Xã Đầm Hà, Huyện Đầm Hà, Tỉnh Quảng Ninh","path_with_type":"Xã Đầm Hà, Huyện Đầm Hà, Tỉnh Quảng Ninh","code":"06916","parent_code":"200"},"06917":{"name":"Xã Tân Lập","type":"xa","slug":"xa-tan-lap","name_with_type":"Xã Tân Lập","path":"Xã Tân Lập, Huyện Đầm Hà, Tỉnh Quảng Ninh","path_with_type":"Xã Tân Lập, Huyện Đầm Hà, Tỉnh Quảng Ninh","code":"06917","parent_code":"200"},"06919":{"name":"Xã Đại Bình","type":"xa","slug":"xa-dai-binh","name_with_type":"Xã Đại Bình","path":"Xã Đại Bình, Huyện Đầm Hà, Tỉnh Quảng Ninh","path_with_type":"Xã Đại Bình, Huyện Đầm Hà, Tỉnh Quảng Ninh","code":"06919","parent_code":"200"},"06922":{"name":"Thị trấn Quảng Hà","type":"thi-tran","slug":"thi-tran-quang-ha","name_with_type":"Thị trấn Quảng Hà","path":"Thị trấn Quảng Hà, Huyện Hải Hà, Tỉnh Quảng Ninh","path_with_type":"Thị trấn Quảng Hà, Huyện Hải Hà, Tỉnh Quảng Ninh","code":"06922","parent_code":"201"},"06925":{"name":"Xã Quảng Đức","type":"xa","slug":"xa-quang-duc","name_with_type":"Xã Quảng Đức","path":"Xã Quảng Đức, Huyện Hải Hà, Tỉnh Quảng Ninh","path_with_type":"Xã Quảng Đức, Huyện Hải Hà, Tỉnh Quảng Ninh","code":"06925","parent_code":"201"},"06928":{"name":"Xã Quảng Sơn","type":"xa","slug":"xa-quang-son","name_with_type":"Xã Quảng Sơn","path":"Xã Quảng Sơn, Huyện Hải Hà, Tỉnh Quảng Ninh","path_with_type":"Xã Quảng Sơn, Huyện Hải Hà, Tỉnh Quảng Ninh","code":"06928","parent_code":"201"},"06931":{"name":"Xã Quảng Thành","type":"xa","slug":"xa-quang-thanh","name_with_type":"Xã Quảng Thành","path":"Xã Quảng Thành, Huyện Hải Hà, Tỉnh Quảng Ninh","path_with_type":"Xã Quảng Thành, Huyện Hải Hà, Tỉnh Quảng Ninh","code":"06931","parent_code":"201"},"06937":{"name":"Xã Quảng Thịnh","type":"xa","slug":"xa-quang-thinh","name_with_type":"Xã Quảng Thịnh","path":"Xã Quảng Thịnh, Huyện Hải Hà, Tỉnh Quảng Ninh","path_with_type":"Xã Quảng Thịnh, Huyện Hải Hà, Tỉnh Quảng Ninh","code":"06937","parent_code":"201"},"06940":{"name":"Xã Quảng Minh","type":"xa","slug":"xa-quang-minh","name_with_type":"Xã Quảng Minh","path":"Xã Quảng Minh, Huyện Hải Hà, Tỉnh Quảng Ninh","path_with_type":"Xã Quảng Minh, Huyện Hải Hà, Tỉnh Quảng Ninh","code":"06940","parent_code":"201"},"06943":{"name":"Xã Quảng Chính","type":"xa","slug":"xa-quang-chinh","name_with_type":"Xã Quảng Chính","path":"Xã Quảng Chính, Huyện Hải Hà, Tỉnh Quảng Ninh","path_with_type":"Xã Quảng Chính, Huyện Hải Hà, Tỉnh Quảng Ninh","code":"06943","parent_code":"201"},"06946":{"name":"Xã Quảng Long","type":"xa","slug":"xa-quang-long","name_with_type":"Xã Quảng Long","path":"Xã Quảng Long, Huyện Hải Hà, Tỉnh Quảng Ninh","path_with_type":"Xã Quảng Long, Huyện Hải Hà, Tỉnh Quảng Ninh","code":"06946","parent_code":"201"},"06949":{"name":"Xã Đường Hoa","type":"xa","slug":"xa-duong-hoa","name_with_type":"Xã Đường Hoa","path":"Xã Đường Hoa, Huyện Hải Hà, Tỉnh Quảng Ninh","path_with_type":"Xã Đường Hoa, Huyện Hải Hà, Tỉnh Quảng Ninh","code":"06949","parent_code":"201"},"06952":{"name":"Xã Quảng Phong","type":"xa","slug":"xa-quang-phong","name_with_type":"Xã Quảng Phong","path":"Xã Quảng Phong, Huyện Hải Hà, Tỉnh Quảng Ninh","path_with_type":"Xã Quảng Phong, Huyện Hải Hà, Tỉnh Quảng Ninh","code":"06952","parent_code":"201"},"06967":{"name":"Xã Cái Chiên","type":"xa","slug":"xa-cai-chien","name_with_type":"Xã Cái Chiên","path":"Xã Cái Chiên, Huyện Hải Hà, Tỉnh Quảng Ninh","path_with_type":"Xã Cái Chiên, Huyện Hải Hà, Tỉnh Quảng Ninh","code":"06967","parent_code":"201"},"06970":{"name":"Thị trấn Ba Chẽ","type":"thi-tran","slug":"thi-tran-ba-che","name_with_type":"Thị trấn Ba Chẽ","path":"Thị trấn Ba Chẽ, Huyện Ba Chẽ, Tỉnh Quảng Ninh","path_with_type":"Thị trấn Ba Chẽ, Huyện Ba Chẽ, Tỉnh Quảng Ninh","code":"06970","parent_code":"202"},"06973":{"name":"Xã Thanh Sơn","type":"xa","slug":"xa-thanh-son","name_with_type":"Xã Thanh Sơn","path":"Xã Thanh Sơn, Huyện Ba Chẽ, Tỉnh Quảng Ninh","path_with_type":"Xã Thanh Sơn, Huyện Ba Chẽ, Tỉnh Quảng Ninh","code":"06973","parent_code":"202"},"06976":{"name":"Xã Thanh Lâm","type":"xa","slug":"xa-thanh-lam","name_with_type":"Xã Thanh Lâm","path":"Xã Thanh Lâm, Huyện Ba Chẽ, Tỉnh Quảng Ninh","path_with_type":"Xã Thanh Lâm, Huyện Ba Chẽ, Tỉnh Quảng Ninh","code":"06976","parent_code":"202"},"06979":{"name":"Xã Đạp Thanh","type":"xa","slug":"xa-dap-thanh","name_with_type":"Xã Đạp Thanh","path":"Xã Đạp Thanh, Huyện Ba Chẽ, Tỉnh Quảng Ninh","path_with_type":"Xã Đạp Thanh, Huyện Ba Chẽ, Tỉnh Quảng Ninh","code":"06979","parent_code":"202"},"06982":{"name":"Xã Nam Sơn","type":"xa","slug":"xa-nam-son","name_with_type":"Xã Nam Sơn","path":"Xã Nam Sơn, Huyện Ba Chẽ, Tỉnh Quảng Ninh","path_with_type":"Xã Nam Sơn, Huyện Ba Chẽ, Tỉnh Quảng Ninh","code":"06982","parent_code":"202"},"06985":{"name":"Xã Lương Minh","type":"xa","slug":"xa-luong-minh","name_with_type":"Xã Lương Minh","path":"Xã Lương Minh, Huyện Ba Chẽ, Tỉnh Quảng Ninh","path_with_type":"Xã Lương Minh, Huyện Ba Chẽ, Tỉnh Quảng Ninh","code":"06985","parent_code":"202"},"06988":{"name":"Xã Đồn Đạc","type":"xa","slug":"xa-don-dac","name_with_type":"Xã Đồn Đạc","path":"Xã Đồn Đạc, Huyện Ba Chẽ, Tỉnh Quảng Ninh","path_with_type":"Xã Đồn Đạc, Huyện Ba Chẽ, Tỉnh Quảng Ninh","code":"06988","parent_code":"202"},"06994":{"name":"Thị trấn Cái Rồng","type":"thi-tran","slug":"thi-tran-cai-rong","name_with_type":"Thị trấn Cái Rồng","path":"Thị trấn Cái Rồng, Huyện Vân Đồn, Tỉnh Quảng Ninh","path_with_type":"Thị trấn Cái Rồng, Huyện Vân Đồn, Tỉnh Quảng Ninh","code":"06994","parent_code":"203"},"06997":{"name":"Xã Đài Xuyên","type":"xa","slug":"xa-dai-xuyen","name_with_type":"Xã Đài Xuyên","path":"Xã Đài Xuyên, Huyện Vân Đồn, Tỉnh Quảng Ninh","path_with_type":"Xã Đài Xuyên, Huyện Vân Đồn, Tỉnh Quảng Ninh","code":"06997","parent_code":"203"},"07000":{"name":"Xã Bình Dân","type":"xa","slug":"xa-binh-dan","name_with_type":"Xã Bình Dân","path":"Xã Bình Dân, Huyện Vân Đồn, Tỉnh Quảng Ninh","path_with_type":"Xã Bình Dân, Huyện Vân Đồn, Tỉnh Quảng Ninh","code":"07000","parent_code":"203"},"07003":{"name":"Xã Vạn Yên","type":"xa","slug":"xa-van-yen","name_with_type":"Xã Vạn Yên","path":"Xã Vạn Yên, Huyện Vân Đồn, Tỉnh Quảng Ninh","path_with_type":"Xã Vạn Yên, Huyện Vân Đồn, Tỉnh Quảng Ninh","code":"07003","parent_code":"203"},"07006":{"name":"Xã Minh Châu","type":"xa","slug":"xa-minh-chau","name_with_type":"Xã Minh Châu","path":"Xã Minh Châu, Huyện Vân Đồn, Tỉnh Quảng Ninh","path_with_type":"Xã Minh Châu, Huyện Vân Đồn, Tỉnh Quảng Ninh","code":"07006","parent_code":"203"},"07009":{"name":"Xã Đoàn Kết","type":"xa","slug":"xa-doan-ket","name_with_type":"Xã Đoàn Kết","path":"Xã Đoàn Kết, Huyện Vân Đồn, Tỉnh Quảng Ninh","path_with_type":"Xã Đoàn Kết, Huyện Vân Đồn, Tỉnh Quảng Ninh","code":"07009","parent_code":"203"},"07012":{"name":"Xã Hạ Long","type":"xa","slug":"xa-ha-long","name_with_type":"Xã Hạ Long","path":"Xã Hạ Long, Huyện Vân Đồn, Tỉnh Quảng Ninh","path_with_type":"Xã Hạ Long, Huyện Vân Đồn, Tỉnh Quảng Ninh","code":"07012","parent_code":"203"},"07015":{"name":"Xã Đông Xá","type":"xa","slug":"xa-dong-xa","name_with_type":"Xã Đông Xá","path":"Xã Đông Xá, Huyện Vân Đồn, Tỉnh Quảng Ninh","path_with_type":"Xã Đông Xá, Huyện Vân Đồn, Tỉnh Quảng Ninh","code":"07015","parent_code":"203"},"07018":{"name":"Xã Bản Sen","type":"xa","slug":"xa-ban-sen","name_with_type":"Xã Bản Sen","path":"Xã Bản Sen, Huyện Vân Đồn, Tỉnh Quảng Ninh","path_with_type":"Xã Bản Sen, Huyện Vân Đồn, Tỉnh Quảng Ninh","code":"07018","parent_code":"203"},"07021":{"name":"Xã Thắng Lợi","type":"xa","slug":"xa-thang-loi","name_with_type":"Xã Thắng Lợi","path":"Xã Thắng Lợi, Huyện Vân Đồn, Tỉnh Quảng Ninh","path_with_type":"Xã Thắng Lợi, Huyện Vân Đồn, Tỉnh Quảng Ninh","code":"07021","parent_code":"203"},"07024":{"name":"Xã Quan Lạn","type":"xa","slug":"xa-quan-lan","name_with_type":"Xã Quan Lạn","path":"Xã Quan Lạn, Huyện Vân Đồn, Tỉnh Quảng Ninh","path_with_type":"Xã Quan Lạn, Huyện Vân Đồn, Tỉnh Quảng Ninh","code":"07024","parent_code":"203"},"07027":{"name":"Xã Ngọc Vừng","type":"xa","slug":"xa-ngoc-vung","name_with_type":"Xã Ngọc Vừng","path":"Xã Ngọc Vừng, Huyện Vân Đồn, Tỉnh Quảng Ninh","path_with_type":"Xã Ngọc Vừng, Huyện Vân Đồn, Tỉnh Quảng Ninh","code":"07027","parent_code":"203"},"07069":{"name":"Phường Mạo Khê","type":"phuong","slug":"phuong-mao-khe","name_with_type":"Phường Mạo Khê","path":"Phường Mạo Khê, Thành phố Đông Triều, Tỉnh Quảng Ninh","path_with_type":"Phường Mạo Khê, Thành phố Đông Triều, Tỉnh Quảng Ninh","code":"07069","parent_code":"205"},"07075":{"name":"Xã An Sinh","type":"xa","slug":"xa-an-sinh","name_with_type":"Xã An Sinh","path":"Xã An Sinh, Thành phố Đông Triều, Tỉnh Quảng Ninh","path_with_type":"Xã An Sinh, Thành phố Đông Triều, Tỉnh Quảng Ninh","code":"07075","parent_code":"205"},"07078":{"name":"Xã Tràng Lương","type":"xa","slug":"xa-trang-luong","name_with_type":"Xã Tràng Lương","path":"Xã Tràng Lương, Thành phố Đông Triều, Tỉnh Quảng Ninh","path_with_type":"Xã Tràng Lương, Thành phố Đông Triều, Tỉnh Quảng Ninh","code":"07078","parent_code":"205"},"07081":{"name":"Phường Bình Khê","type":"phuong","slug":"phuong-binh-khe","name_with_type":"Phường Bình Khê","path":"Phường Bình Khê, Thành phố Đông Triều, Tỉnh Quảng Ninh","path_with_type":"Phường Bình Khê, Thành phố Đông Triều, Tỉnh Quảng Ninh","code":"07081","parent_code":"205"},"07084":{"name":"Xã Việt Dân","type":"xa","slug":"xa-viet-dan","name_with_type":"Xã Việt Dân","path":"Xã Việt Dân, Thành phố Đông Triều, Tỉnh Quảng Ninh","path_with_type":"Xã Việt Dân, Thành phố Đông Triều, Tỉnh Quảng Ninh","code":"07084","parent_code":"205"},"07090":{"name":"Phường Bình Dương","type":"phuong","slug":"phuong-binh-duong","name_with_type":"Phường Bình Dương","path":"Phường Bình Dương, Thành phố Đông Triều, Tỉnh Quảng Ninh","path_with_type":"Phường Bình Dương, Thành phố Đông Triều, Tỉnh Quảng Ninh","code":"07090","parent_code":"205"},"07093":{"name":"Phường Đức Chính","type":"phuong","slug":"phuong-duc-chinh","name_with_type":"Phường Đức Chính","path":"Phường Đức Chính, Thành phố Đông Triều, Tỉnh Quảng Ninh","path_with_type":"Phường Đức Chính, Thành phố Đông Triều, Tỉnh Quảng Ninh","code":"07093","parent_code":"205"},"07096":{"name":"Phường Tràng An","type":"phuong","slug":"phuong-trang-an","name_with_type":"Phường Tràng An","path":"Phường Tràng An, Thành phố Đông Triều, Tỉnh Quảng Ninh","path_with_type":"Phường Tràng An, Thành phố Đông Triều, Tỉnh Quảng Ninh","code":"07096","parent_code":"205"},"07099":{"name":"Xã Nguyễn Huệ","type":"xa","slug":"xa-nguyen-hue","name_with_type":"Xã Nguyễn Huệ","path":"Xã Nguyễn Huệ, Thành phố Đông Triều, Tỉnh Quảng Ninh","path_with_type":"Xã Nguyễn Huệ, Thành phố Đông Triều, Tỉnh Quảng Ninh","code":"07099","parent_code":"205"},"07102":{"name":"Phường Thủy An","type":"phuong","slug":"phuong-thuy-an","name_with_type":"Phường Thủy An","path":"Phường Thủy An, Thành phố Đông Triều, Tỉnh Quảng Ninh","path_with_type":"Phường Thủy An, Thành phố Đông Triều, Tỉnh Quảng Ninh","code":"07102","parent_code":"205"},"07105":{"name":"Phường Xuân Sơn","type":"phuong","slug":"phuong-xuan-son","name_with_type":"Phường Xuân Sơn","path":"Phường Xuân Sơn, Thành phố Đông Triều, Tỉnh Quảng Ninh","path_with_type":"Phường Xuân Sơn, Thành phố Đông Triều, Tỉnh Quảng Ninh","code":"07105","parent_code":"205"},"07108":{"name":"Xã Hồng Thái Tây","type":"xa","slug":"xa-hong-thai-tay","name_with_type":"Xã Hồng Thái Tây","path":"Xã Hồng Thái Tây, Thành phố Đông Triều, Tỉnh Quảng Ninh","path_with_type":"Xã Hồng Thái Tây, Thành phố Đông Triều, Tỉnh Quảng Ninh","code":"07108","parent_code":"205"},"07111":{"name":"Xã Hồng Thái Đông","type":"xa","slug":"xa-hong-thai-dong","name_with_type":"Xã Hồng Thái Đông","path":"Xã Hồng Thái Đông, Thành phố Đông Triều, Tỉnh Quảng Ninh","path_with_type":"Xã Hồng Thái Đông, Thành phố Đông Triều, Tỉnh Quảng Ninh","code":"07111","parent_code":"205"},"07114":{"name":"Phường Hoàng Quế","type":"phuong","slug":"phuong-hoang-que","name_with_type":"Phường Hoàng Quế","path":"Phường Hoàng Quế, Thành phố Đông Triều, Tỉnh Quảng Ninh","path_with_type":"Phường Hoàng Quế, Thành phố Đông Triều, Tỉnh Quảng Ninh","code":"07114","parent_code":"205"},"07117":{"name":"Phường Yên Thọ","type":"phuong","slug":"phuong-yen-tho","name_with_type":"Phường Yên Thọ","path":"Phường Yên Thọ, Thành phố Đông Triều, Tỉnh Quảng Ninh","path_with_type":"Phường Yên Thọ, Thành phố Đông Triều, Tỉnh Quảng Ninh","code":"07117","parent_code":"205"},"07120":{"name":"Phường Hồng Phong","type":"phuong","slug":"phuong-hong-phong","name_with_type":"Phường Hồng Phong","path":"Phường Hồng Phong, Thành phố Đông Triều, Tỉnh Quảng Ninh","path_with_type":"Phường Hồng Phong, Thành phố Đông Triều, Tỉnh Quảng Ninh","code":"07120","parent_code":"205"},"07123":{"name":"Phường Kim Sơn","type":"phuong","slug":"phuong-kim-son","name_with_type":"Phường Kim Sơn","path":"Phường Kim Sơn, Thành phố Đông Triều, Tỉnh Quảng Ninh","path_with_type":"Phường Kim Sơn, Thành phố Đông Triều, Tỉnh Quảng Ninh","code":"07123","parent_code":"205"},"07126":{"name":"Phường Hưng Đạo","type":"phuong","slug":"phuong-hung-dao","name_with_type":"Phường Hưng Đạo","path":"Phường Hưng Đạo, Thành phố Đông Triều, Tỉnh Quảng Ninh","path_with_type":"Phường Hưng Đạo, Thành phố Đông Triều, Tỉnh Quảng Ninh","code":"07126","parent_code":"205"},"07129":{"name":"Phường Yên Đức","type":"phuong","slug":"phuong-yen-duc","name_with_type":"Phường Yên Đức","path":"Phường Yên Đức, Thành phố Đông Triều, Tỉnh Quảng Ninh","path_with_type":"Phường Yên Đức, Thành phố Đông Triều, Tỉnh Quảng Ninh","code":"07129","parent_code":"205"},"07132":{"name":"Phường Quảng Yên","type":"phuong","slug":"phuong-quang-yen","name_with_type":"Phường Quảng Yên","path":"Phường Quảng Yên, Thị xã Quảng Yên, Tỉnh Quảng Ninh","path_with_type":"Phường Quảng Yên, Thị xã Quảng Yên, Tỉnh Quảng Ninh","code":"07132","parent_code":"206"},"07135":{"name":"Phường Đông Mai","type":"phuong","slug":"phuong-dong-mai","name_with_type":"Phường Đông Mai","path":"Phường Đông Mai, Thị xã Quảng Yên, Tỉnh Quảng Ninh","path_with_type":"Phường Đông Mai, Thị xã Quảng Yên, Tỉnh Quảng Ninh","code":"07135","parent_code":"206"},"07138":{"name":"Phường Minh Thành","type":"phuong","slug":"phuong-minh-thanh","name_with_type":"Phường Minh Thành","path":"Phường Minh Thành, Thị xã Quảng Yên, Tỉnh Quảng Ninh","path_with_type":"Phường Minh Thành, Thị xã Quảng Yên, Tỉnh Quảng Ninh","code":"07138","parent_code":"206"},"07144":{"name":"Xã Sông Khoai","type":"xa","slug":"xa-song-khoai","name_with_type":"Xã Sông Khoai","path":"Xã Sông Khoai, Thị xã Quảng Yên, Tỉnh Quảng Ninh","path_with_type":"Xã Sông Khoai, Thị xã Quảng Yên, Tỉnh Quảng Ninh","code":"07144","parent_code":"206"},"07147":{"name":"Xã Hiệp Hòa","type":"xa","slug":"xa-hiep-hoa","name_with_type":"Xã Hiệp Hòa","path":"Xã Hiệp Hòa, Thị xã Quảng Yên, Tỉnh Quảng Ninh","path_with_type":"Xã Hiệp Hòa, Thị xã Quảng Yên, Tỉnh Quảng Ninh","code":"07147","parent_code":"206"},"07150":{"name":"Phường Cộng Hòa","type":"phuong","slug":"phuong-cong-hoa","name_with_type":"Phường Cộng Hòa","path":"Phường Cộng Hòa, Thị xã Quảng Yên, Tỉnh Quảng Ninh","path_with_type":"Phường Cộng Hòa, Thị xã Quảng Yên, Tỉnh Quảng Ninh","code":"07150","parent_code":"206"},"07153":{"name":"Xã Tiền An","type":"xa","slug":"xa-tien-an","name_with_type":"Xã Tiền An","path":"Xã Tiền An, Thị xã Quảng Yên, Tỉnh Quảng Ninh","path_with_type":"Xã Tiền An, Thị xã Quảng Yên, Tỉnh Quảng Ninh","code":"07153","parent_code":"206"},"07156":{"name":"Xã Hoàng Tân","type":"xa","slug":"xa-hoang-tan","name_with_type":"Xã Hoàng Tân","path":"Xã Hoàng Tân, Thị xã Quảng Yên, Tỉnh Quảng Ninh","path_with_type":"Xã Hoàng Tân, Thị xã Quảng Yên, Tỉnh Quảng Ninh","code":"07156","parent_code":"206"},"07159":{"name":"Phường Tân An","type":"phuong","slug":"phuong-tan-an","name_with_type":"Phường Tân An","path":"Phường Tân An, Thị xã Quảng Yên, Tỉnh Quảng Ninh","path_with_type":"Phường Tân An, Thị xã Quảng Yên, Tỉnh Quảng Ninh","code":"07159","parent_code":"206"},"07162":{"name":"Phường Yên Giang","type":"phuong","slug":"phuong-yen-giang","name_with_type":"Phường Yên Giang","path":"Phường Yên Giang, Thị xã Quảng Yên, Tỉnh Quảng Ninh","path_with_type":"Phường Yên Giang, Thị xã Quảng Yên, Tỉnh Quảng Ninh","code":"07162","parent_code":"206"},"07165":{"name":"Phường Nam Hoà","type":"phuong","slug":"phuong-nam-hoa","name_with_type":"Phường Nam Hoà","path":"Phường Nam Hoà, Thị xã Quảng Yên, Tỉnh Quảng Ninh","path_with_type":"Phường Nam Hoà, Thị xã Quảng Yên, Tỉnh Quảng Ninh","code":"07165","parent_code":"206"},"07168":{"name":"Phường Hà An","type":"phuong","slug":"phuong-ha-an","name_with_type":"Phường Hà An","path":"Phường Hà An, Thị xã Quảng Yên, Tỉnh Quảng Ninh","path_with_type":"Phường Hà An, Thị xã Quảng Yên, Tỉnh Quảng Ninh","code":"07168","parent_code":"206"},"07171":{"name":"Xã Cẩm La","type":"xa","slug":"xa-cam-la","name_with_type":"Xã Cẩm La","path":"Xã Cẩm La, Thị xã Quảng Yên, Tỉnh Quảng Ninh","path_with_type":"Xã Cẩm La, Thị xã Quảng Yên, Tỉnh Quảng Ninh","code":"07171","parent_code":"206"},"07174":{"name":"Phường Phong Hải","type":"phuong","slug":"phuong-phong-hai","name_with_type":"Phường Phong Hải","path":"Phường Phong Hải, Thị xã Quảng Yên, Tỉnh Quảng Ninh","path_with_type":"Phường Phong Hải, Thị xã Quảng Yên, Tỉnh Quảng Ninh","code":"07174","parent_code":"206"},"07177":{"name":"Phường Yên Hải","type":"phuong","slug":"phuong-yen-hai","name_with_type":"Phường Yên Hải","path":"Phường Yên Hải, Thị xã Quảng Yên, Tỉnh Quảng Ninh","path_with_type":"Phường Yên Hải, Thị xã Quảng Yên, Tỉnh Quảng Ninh","code":"07177","parent_code":"206"},"07180":{"name":"Xã Liên Hòa","type":"xa","slug":"xa-lien-hoa","name_with_type":"Xã Liên Hòa","path":"Xã Liên Hòa, Thị xã Quảng Yên, Tỉnh Quảng Ninh","path_with_type":"Xã Liên Hòa, Thị xã Quảng Yên, Tỉnh Quảng Ninh","code":"07180","parent_code":"206"},"07183":{"name":"Phường Phong Cốc","type":"phuong","slug":"phuong-phong-coc","name_with_type":"Phường Phong Cốc","path":"Phường Phong Cốc, Thị xã Quảng Yên, Tỉnh Quảng Ninh","path_with_type":"Phường Phong Cốc, Thị xã Quảng Yên, Tỉnh Quảng Ninh","code":"07183","parent_code":"206"},"07186":{"name":"Xã Liên Vị","type":"xa","slug":"xa-lien-vi","name_with_type":"Xã Liên Vị","path":"Xã Liên Vị, Thị xã Quảng Yên, Tỉnh Quảng Ninh","path_with_type":"Xã Liên Vị, Thị xã Quảng Yên, Tỉnh Quảng Ninh","code":"07186","parent_code":"206"},"07189":{"name":"Xã Tiền Phong","type":"xa","slug":"xa-tien-phong","name_with_type":"Xã Tiền Phong","path":"Xã Tiền Phong, Thị xã Quảng Yên, Tỉnh Quảng Ninh","path_with_type":"Xã Tiền Phong, Thị xã Quảng Yên, Tỉnh Quảng Ninh","code":"07189","parent_code":"206"},"07192":{"name":"Thị trấn Cô Tô","type":"thi-tran","slug":"thi-tran-co-to","name_with_type":"Thị trấn Cô Tô","path":"Thị trấn Cô Tô, Huyện Cô Tô, Tỉnh Quảng Ninh","path_with_type":"Thị trấn Cô Tô, Huyện Cô Tô, Tỉnh Quảng Ninh","code":"07192","parent_code":"207"},"07195":{"name":"Xã Đồng Tiến","type":"xa","slug":"xa-dong-tien","name_with_type":"Xã Đồng Tiến","path":"Xã Đồng Tiến, Huyện Cô Tô, Tỉnh Quảng Ninh","path_with_type":"Xã Đồng Tiến, Huyện Cô Tô, Tỉnh Quảng Ninh","code":"07195","parent_code":"207"},"07198":{"name":"Xã Thanh Lân","type":"xa","slug":"xa-thanh-lan","name_with_type":"Xã Thanh Lân","path":"Xã Thanh Lân, Huyện Cô Tô, Tỉnh Quảng Ninh","path_with_type":"Xã Thanh Lân, Huyện Cô Tô, Tỉnh Quảng Ninh","code":"07198","parent_code":"207"},"07201":{"name":"Phường Thọ Xương","type":"phuong","slug":"phuong-tho-xuong","name_with_type":"Phường Thọ Xương","path":"Phường Thọ Xương, Thành phố Bắc Giang, Tỉnh Bắc Giang","path_with_type":"Phường Thọ Xương, Thành phố Bắc Giang, Tỉnh Bắc Giang","code":"07201","parent_code":"213"},"07207":{"name":"Phường Ngô Quyền","type":"phuong","slug":"phuong-ngo-quyen","name_with_type":"Phường Ngô Quyền","path":"Phường Ngô Quyền, Thành phố Bắc Giang, Tỉnh Bắc Giang","path_with_type":"Phường Ngô Quyền, Thành phố Bắc Giang, Tỉnh Bắc Giang","code":"07207","parent_code":"213"},"07210":{"name":"Phường Hoàng Văn Thụ","type":"phuong","slug":"phuong-hoang-van-thu","name_with_type":"Phường Hoàng Văn Thụ","path":"Phường Hoàng Văn Thụ, Thành phố Bắc Giang, Tỉnh Bắc Giang","path_with_type":"Phường Hoàng Văn Thụ, Thành phố Bắc Giang, Tỉnh Bắc Giang","code":"07210","parent_code":"213"},"07213":{"name":"Phường Trần Phú","type":"phuong","slug":"phuong-tran-phu","name_with_type":"Phường Trần Phú","path":"Phường Trần Phú, Thành phố Bắc Giang, Tỉnh Bắc Giang","path_with_type":"Phường Trần Phú, Thành phố Bắc Giang, Tỉnh Bắc Giang","code":"07213","parent_code":"213"},"07216":{"name":"Phường Mỹ Độ","type":"phuong","slug":"phuong-my-do","name_with_type":"Phường Mỹ Độ","path":"Phường Mỹ Độ, Thành phố Bắc Giang, Tỉnh Bắc Giang","path_with_type":"Phường Mỹ Độ, Thành phố Bắc Giang, Tỉnh Bắc Giang","code":"07216","parent_code":"213"},"07222":{"name":"Phường Song Mai","type":"phuong","slug":"phuong-song-mai","name_with_type":"Phường Song Mai","path":"Phường Song Mai, Thành phố Bắc Giang, Tỉnh Bắc Giang","path_with_type":"Phường Song Mai, Thành phố Bắc Giang, Tỉnh Bắc Giang","code":"07222","parent_code":"213"},"07225":{"name":"Phường Xương Giang","type":"phuong","slug":"phuong-xuong-giang","name_with_type":"Phường Xương Giang","path":"Phường Xương Giang, Thành phố Bắc Giang, Tỉnh Bắc Giang","path_with_type":"Phường Xương Giang, Thành phố Bắc Giang, Tỉnh Bắc Giang","code":"07225","parent_code":"213"},"07228":{"name":"Phường Đa Mai","type":"phuong","slug":"phuong-da-mai","name_with_type":"Phường Đa Mai","path":"Phường Đa Mai, Thành phố Bắc Giang, Tỉnh Bắc Giang","path_with_type":"Phường Đa Mai, Thành phố Bắc Giang, Tỉnh Bắc Giang","code":"07228","parent_code":"213"},"07231":{"name":"Phường Dĩnh Kế","type":"phuong","slug":"phuong-dinh-ke","name_with_type":"Phường Dĩnh Kế","path":"Phường Dĩnh Kế, Thành phố Bắc Giang, Tỉnh Bắc Giang","path_with_type":"Phường Dĩnh Kế, Thành phố Bắc Giang, Tỉnh Bắc Giang","code":"07231","parent_code":"213"},"07441":{"name":"Phường Dĩnh Trì","type":"phuong","slug":"phuong-dinh-tri","name_with_type":"Phường Dĩnh Trì","path":"Phường Dĩnh Trì, Thành phố Bắc Giang, Tỉnh Bắc Giang","path_with_type":"Phường Dĩnh Trì, Thành phố Bắc Giang, Tỉnh Bắc Giang","code":"07441","parent_code":"213"},"07681":{"name":"Phường Nham Biền","type":"phuong","slug":"phuong-nham-bien","name_with_type":"Phường Nham Biền","path":"Phường Nham Biền, Thành phố Bắc Giang, Tỉnh Bắc Giang","path_with_type":"Phường Nham Biền, Thành phố Bắc Giang, Tỉnh Bắc Giang","code":"07681","parent_code":"213"},"07682":{"name":"Phường Tân An","type":"phuong","slug":"phuong-tan-an","name_with_type":"Phường Tân An","path":"Phường Tân An, Thành phố Bắc Giang, Tỉnh Bắc Giang","path_with_type":"Phường Tân An, Thành phố Bắc Giang, Tỉnh Bắc Giang","code":"07682","parent_code":"213"},"07687":{"name":"Phường Tân Mỹ","type":"phuong","slug":"phuong-tan-my","name_with_type":"Phường Tân Mỹ","path":"Phường Tân Mỹ, Thành phố Bắc Giang, Tỉnh Bắc Giang","path_with_type":"Phường Tân Mỹ, Thành phố Bắc Giang, Tỉnh Bắc Giang","code":"07687","parent_code":"213"},"07690":{"name":"Phường Hương Gián","type":"phuong","slug":"phuong-huong-gian","name_with_type":"Phường Hương Gián","path":"Phường Hương Gián, Thành phố Bắc Giang, Tỉnh Bắc Giang","path_with_type":"Phường Hương Gián, Thành phố Bắc Giang, Tỉnh Bắc Giang","code":"07690","parent_code":"213"},"07693":{"name":"Xã Tân An","type":"xa","slug":"xa-tan-an","name_with_type":"Xã Tân An","path":"Xã Tân An, Thành phố Bắc Giang, Tỉnh Bắc Giang","path_with_type":"Xã Tân An, Thành phố Bắc Giang, Tỉnh Bắc Giang","code":"07693","parent_code":"213"},"07696":{"name":"Phường Đồng Sơn","type":"phuong","slug":"phuong-dong-son","name_with_type":"Phường Đồng Sơn","path":"Phường Đồng Sơn, Thành phố Bắc Giang, Tỉnh Bắc Giang","path_with_type":"Phường Đồng Sơn, Thành phố Bắc Giang, Tỉnh Bắc Giang","code":"07696","parent_code":"213"},"07699":{"name":"Phường Tân Tiến","type":"phuong","slug":"phuong-tan-tien","name_with_type":"Phường Tân Tiến","path":"Phường Tân Tiến, Thành phố Bắc Giang, Tỉnh Bắc Giang","path_with_type":"Phường Tân Tiến, Thành phố Bắc Giang, Tỉnh Bắc Giang","code":"07699","parent_code":"213"},"07702":{"name":"Xã Quỳnh Sơn","type":"xa","slug":"xa-quynh-son","name_with_type":"Xã Quỳnh Sơn","path":"Xã Quỳnh Sơn, Thành phố Bắc Giang, Tỉnh Bắc Giang","path_with_type":"Xã Quỳnh Sơn, Thành phố Bắc Giang, Tỉnh Bắc Giang","code":"07702","parent_code":"213"},"07705":{"name":"Phường Song Khê","type":"phuong","slug":"phuong-song-khe","name_with_type":"Phường Song Khê","path":"Phường Song Khê, Thành phố Bắc Giang, Tỉnh Bắc Giang","path_with_type":"Phường Song Khê, Thành phố Bắc Giang, Tỉnh Bắc Giang","code":"07705","parent_code":"213"},"07708":{"name":"Phường Nội Hoàng","type":"phuong","slug":"phuong-noi-hoang","name_with_type":"Phường Nội Hoàng","path":"Phường Nội Hoàng, Thành phố Bắc Giang, Tỉnh Bắc Giang","path_with_type":"Phường Nội Hoàng, Thành phố Bắc Giang, Tỉnh Bắc Giang","code":"07708","parent_code":"213"},"07711":{"name":"Phường Tiền Phong","type":"phuong","slug":"phuong-tien-phong","name_with_type":"Phường Tiền Phong","path":"Phường Tiền Phong, Thành phố Bắc Giang, Tỉnh Bắc Giang","path_with_type":"Phường Tiền Phong, Thành phố Bắc Giang, Tỉnh Bắc Giang","code":"07711","parent_code":"213"},"07714":{"name":"Xã Xuân Phú","type":"xa","slug":"xa-xuan-phu","name_with_type":"Xã Xuân Phú","path":"Xã Xuân Phú, Thành phố Bắc Giang, Tỉnh Bắc Giang","path_with_type":"Xã Xuân Phú, Thành phố Bắc Giang, Tỉnh Bắc Giang","code":"07714","parent_code":"213"},"07717":{"name":"Phường Tân Liễu","type":"phuong","slug":"phuong-tan-lieu","name_with_type":"Phường Tân Liễu","path":"Phường Tân Liễu, Thành phố Bắc Giang, Tỉnh Bắc Giang","path_with_type":"Phường Tân Liễu, Thành phố Bắc Giang, Tỉnh Bắc Giang","code":"07717","parent_code":"213"},"07720":{"name":"Xã Trí Yên","type":"xa","slug":"xa-tri-yen","name_with_type":"Xã Trí Yên","path":"Xã Trí Yên, Thành phố Bắc Giang, Tỉnh Bắc Giang","path_with_type":"Xã Trí Yên, Thành phố Bắc Giang, Tỉnh Bắc Giang","code":"07720","parent_code":"213"},"07723":{"name":"Xã Lãng Sơn","type":"xa","slug":"xa-lang-son","name_with_type":"Xã Lãng Sơn","path":"Xã Lãng Sơn, Thành phố Bắc Giang, Tỉnh Bắc Giang","path_with_type":"Xã Lãng Sơn, Thành phố Bắc Giang, Tỉnh Bắc Giang","code":"07723","parent_code":"213"},"07726":{"name":"Xã Yên Lư","type":"xa","slug":"xa-yen-lu","name_with_type":"Xã Yên Lư","path":"Xã Yên Lư, Thành phố Bắc Giang, Tỉnh Bắc Giang","path_with_type":"Xã Yên Lư, Thành phố Bắc Giang, Tỉnh Bắc Giang","code":"07726","parent_code":"213"},"07729":{"name":"Xã Tiến Dũng","type":"xa","slug":"xa-tien-dung","name_with_type":"Xã Tiến Dũng","path":"Xã Tiến Dũng, Thành phố Bắc Giang, Tỉnh Bắc Giang","path_with_type":"Xã Tiến Dũng, Thành phố Bắc Giang, Tỉnh Bắc Giang","code":"07729","parent_code":"213"},"07732":{"name":"Xã Nham Sơn","type":"xa","slug":"xa-nham-son","name_with_type":"Xã Nham Sơn","path":"Xã Nham Sơn, Thành phố Bắc Giang, Tỉnh Bắc Giang","path_with_type":"Xã Nham Sơn, Thành phố Bắc Giang, Tỉnh Bắc Giang","code":"07732","parent_code":"213"},"07735":{"name":"Xã Đức Giang","type":"xa","slug":"xa-duc-giang","name_with_type":"Xã Đức Giang","path":"Xã Đức Giang, Thành phố Bắc Giang, Tỉnh Bắc Giang","path_with_type":"Xã Đức Giang, Thành phố Bắc Giang, Tỉnh Bắc Giang","code":"07735","parent_code":"213"},"07738":{"name":"Phường Cảnh Thụy","type":"phuong","slug":"phuong-canh-thuy","name_with_type":"Phường Cảnh Thụy","path":"Phường Cảnh Thụy, Thành phố Bắc Giang, Tỉnh Bắc Giang","path_with_type":"Phường Cảnh Thụy, Thành phố Bắc Giang, Tỉnh Bắc Giang","code":"07738","parent_code":"213"},"07741":{"name":"Xã Tư Mại","type":"xa","slug":"xa-tu-mai","name_with_type":"Xã Tư Mại","path":"Xã Tư Mại, Thành phố Bắc Giang, Tỉnh Bắc Giang","path_with_type":"Xã Tư Mại, Thành phố Bắc Giang, Tỉnh Bắc Giang","code":"07741","parent_code":"213"},"07744":{"name":"Xã Thắng Cương","type":"xa","slug":"xa-thang-cuong","name_with_type":"Xã Thắng Cương","path":"Xã Thắng Cương, Thành phố Bắc Giang, Tỉnh Bắc Giang","path_with_type":"Xã Thắng Cương, Thành phố Bắc Giang, Tỉnh Bắc Giang","code":"07744","parent_code":"213"},"07747":{"name":"Xã Đồng Việt","type":"xa","slug":"xa-dong-viet","name_with_type":"Xã Đồng Việt","path":"Xã Đồng Việt, Thành phố Bắc Giang, Tỉnh Bắc Giang","path_with_type":"Xã Đồng Việt, Thành phố Bắc Giang, Tỉnh Bắc Giang","code":"07747","parent_code":"213"},"07750":{"name":"Xã Đồng Phúc","type":"xa","slug":"xa-dong-phuc","name_with_type":"Xã Đồng Phúc","path":"Xã Đồng Phúc, Thành phố Bắc Giang, Tỉnh Bắc Giang","path_with_type":"Xã Đồng Phúc, Thành phố Bắc Giang, Tỉnh Bắc Giang","code":"07750","parent_code":"213"},"07243":{"name":"Xã Đồng Tiến","type":"xa","slug":"xa-dong-tien","name_with_type":"Xã Đồng Tiến","path":"Xã Đồng Tiến, Huyện Yên Thế, Tỉnh Bắc Giang","path_with_type":"Xã Đồng Tiến, Huyện Yên Thế, Tỉnh Bắc Giang","code":"07243","parent_code":"215"},"07246":{"name":"Xã Canh Nậu","type":"xa","slug":"xa-canh-nau","name_with_type":"Xã Canh Nậu","path":"Xã Canh Nậu, Huyện Yên Thế, Tỉnh Bắc Giang","path_with_type":"Xã Canh Nậu, Huyện Yên Thế, Tỉnh Bắc Giang","code":"07246","parent_code":"215"},"07249":{"name":"Xã Xuân Lương","type":"xa","slug":"xa-xuan-luong","name_with_type":"Xã Xuân Lương","path":"Xã Xuân Lương, Huyện Yên Thế, Tỉnh Bắc Giang","path_with_type":"Xã Xuân Lương, Huyện Yên Thế, Tỉnh Bắc Giang","code":"07249","parent_code":"215"},"07252":{"name":"Xã Tam Tiến","type":"xa","slug":"xa-tam-tien","name_with_type":"Xã Tam Tiến","path":"Xã Tam Tiến, Huyện Yên Thế, Tỉnh Bắc Giang","path_with_type":"Xã Tam Tiến, Huyện Yên Thế, Tỉnh Bắc Giang","code":"07252","parent_code":"215"},"07255":{"name":"Xã Đồng Vương","type":"xa","slug":"xa-dong-vuong","name_with_type":"Xã Đồng Vương","path":"Xã Đồng Vương, Huyện Yên Thế, Tỉnh Bắc Giang","path_with_type":"Xã Đồng Vương, Huyện Yên Thế, Tỉnh Bắc Giang","code":"07255","parent_code":"215"},"07258":{"name":"Xã Đồng Hưu","type":"xa","slug":"xa-dong-huu","name_with_type":"Xã Đồng Hưu","path":"Xã Đồng Hưu, Huyện Yên Thế, Tỉnh Bắc Giang","path_with_type":"Xã Đồng Hưu, Huyện Yên Thế, Tỉnh Bắc Giang","code":"07258","parent_code":"215"},"07260":{"name":"Xã Đồng Tâm","type":"xa","slug":"xa-dong-tam","name_with_type":"Xã Đồng Tâm","path":"Xã Đồng Tâm, Huyện Yên Thế, Tỉnh Bắc Giang","path_with_type":"Xã Đồng Tâm, Huyện Yên Thế, Tỉnh Bắc Giang","code":"07260","parent_code":"215"},"07261":{"name":"Xã Tân Hiệp","type":"xa","slug":"xa-tan-hiep","name_with_type":"Xã Tân Hiệp","path":"Xã Tân Hiệp, Huyện Yên Thế, Tỉnh Bắc Giang","path_with_type":"Xã Tân Hiệp, Huyện Yên Thế, Tỉnh Bắc Giang","code":"07261","parent_code":"215"},"07264":{"name":"Xã Tiến Thắng","type":"xa","slug":"xa-tien-thang","name_with_type":"Xã Tiến Thắng","path":"Xã Tiến Thắng, Huyện Yên Thế, Tỉnh Bắc Giang","path_with_type":"Xã Tiến Thắng, Huyện Yên Thế, Tỉnh Bắc Giang","code":"07264","parent_code":"215"},"07270":{"name":"Xã Đồng Lạc","type":"xa","slug":"xa-dong-lac","name_with_type":"Xã Đồng Lạc","path":"Xã Đồng Lạc, Huyện Yên Thế, Tỉnh Bắc Giang","path_with_type":"Xã Đồng Lạc, Huyện Yên Thế, Tỉnh Bắc Giang","code":"07270","parent_code":"215"},"07273":{"name":"Xã Đông Sơn","type":"xa","slug":"xa-dong-son","name_with_type":"Xã Đông Sơn","path":"Xã Đông Sơn, Huyện Yên Thế, Tỉnh Bắc Giang","path_with_type":"Xã Đông Sơn, Huyện Yên Thế, Tỉnh Bắc Giang","code":"07273","parent_code":"215"},"07279":{"name":"Xã Hương Vĩ","type":"xa","slug":"xa-huong-vi","name_with_type":"Xã Hương Vĩ","path":"Xã Hương Vĩ, Huyện Yên Thế, Tỉnh Bắc Giang","path_with_type":"Xã Hương Vĩ, Huyện Yên Thế, Tỉnh Bắc Giang","code":"07279","parent_code":"215"},"07282":{"name":"Xã Đồng Kỳ","type":"xa","slug":"xa-dong-ky","name_with_type":"Xã Đồng Kỳ","path":"Xã Đồng Kỳ, Huyện Yên Thế, Tỉnh Bắc Giang","path_with_type":"Xã Đồng Kỳ, Huyện Yên Thế, Tỉnh Bắc Giang","code":"07282","parent_code":"215"},"07285":{"name":"Xã An Thượng","type":"xa","slug":"xa-an-thuong","name_with_type":"Xã An Thượng","path":"Xã An Thượng, Huyện Yên Thế, Tỉnh Bắc Giang","path_with_type":"Xã An Thượng, Huyện Yên Thế, Tỉnh Bắc Giang","code":"07285","parent_code":"215"},"07288":{"name":"Thị trấn Phồn Xương","type":"thi-tran","slug":"thi-tran-phon-xuong","name_with_type":"Thị trấn Phồn Xương","path":"Thị trấn Phồn Xương, Huyện Yên Thế, Tỉnh Bắc Giang","path_with_type":"Thị trấn Phồn Xương, Huyện Yên Thế, Tỉnh Bắc Giang","code":"07288","parent_code":"215"},"07291":{"name":"Xã Tân Sỏi","type":"xa","slug":"xa-tan-soi","name_with_type":"Xã Tân Sỏi","path":"Xã Tân Sỏi, Huyện Yên Thế, Tỉnh Bắc Giang","path_with_type":"Xã Tân Sỏi, Huyện Yên Thế, Tỉnh Bắc Giang","code":"07291","parent_code":"215"},"07294":{"name":"Thị trấn Bố Hạ","type":"thi-tran","slug":"thi-tran-bo-ha","name_with_type":"Thị trấn Bố Hạ","path":"Thị trấn Bố Hạ, Huyện Yên Thế, Tỉnh Bắc Giang","path_with_type":"Thị trấn Bố Hạ, Huyện Yên Thế, Tỉnh Bắc Giang","code":"07294","parent_code":"215"},"07306":{"name":"Thị trấn Nhã Nam","type":"thi-tran","slug":"thi-tran-nha-nam","name_with_type":"Thị trấn Nhã Nam","path":"Thị trấn Nhã Nam, Huyện Tân Yên, Tỉnh Bắc Giang","path_with_type":"Thị trấn Nhã Nam, Huyện Tân Yên, Tỉnh Bắc Giang","code":"07306","parent_code":"216"},"07309":{"name":"Xã Tân Trung","type":"xa","slug":"xa-tan-trung","name_with_type":"Xã Tân Trung","path":"Xã Tân Trung, Huyện Tân Yên, Tỉnh Bắc Giang","path_with_type":"Xã Tân Trung, Huyện Tân Yên, Tỉnh Bắc Giang","code":"07309","parent_code":"216"},"07315":{"name":"Xã Quang Trung","type":"xa","slug":"xa-quang-trung","name_with_type":"Xã Quang Trung","path":"Xã Quang Trung, Huyện Tân Yên, Tỉnh Bắc Giang","path_with_type":"Xã Quang Trung, Huyện Tân Yên, Tỉnh Bắc Giang","code":"07315","parent_code":"216"},"07321":{"name":"Xã An Dương","type":"xa","slug":"xa-an-duong","name_with_type":"Xã An Dương","path":"Xã An Dương, Huyện Tân Yên, Tỉnh Bắc Giang","path_with_type":"Xã An Dương, Huyện Tân Yên, Tỉnh Bắc Giang","code":"07321","parent_code":"216"},"07324":{"name":"Xã Phúc Hòa","type":"xa","slug":"xa-phuc-hoa","name_with_type":"Xã Phúc Hòa","path":"Xã Phúc Hòa, Huyện Tân Yên, Tỉnh Bắc Giang","path_with_type":"Xã Phúc Hòa, Huyện Tân Yên, Tỉnh Bắc Giang","code":"07324","parent_code":"216"},"07327":{"name":"Xã Liên Sơn","type":"xa","slug":"xa-lien-son","name_with_type":"Xã Liên Sơn","path":"Xã Liên Sơn, Huyện Tân Yên, Tỉnh Bắc Giang","path_with_type":"Xã Liên Sơn, Huyện Tân Yên, Tỉnh Bắc Giang","code":"07327","parent_code":"216"},"07330":{"name":"Xã Hợp Đức","type":"xa","slug":"xa-hop-duc","name_with_type":"Xã Hợp Đức","path":"Xã Hợp Đức, Huyện Tân Yên, Tỉnh Bắc Giang","path_with_type":"Xã Hợp Đức, Huyện Tân Yên, Tỉnh Bắc Giang","code":"07330","parent_code":"216"},"07333":{"name":"Xã Lam Sơn","type":"xa","slug":"xa-lam-son","name_with_type":"Xã Lam Sơn","path":"Xã Lam Sơn, Huyện Tân Yên, Tỉnh Bắc Giang","path_with_type":"Xã Lam Sơn, Huyện Tân Yên, Tỉnh Bắc Giang","code":"07333","parent_code":"216"},"07336":{"name":"Xã Cao Xá","type":"xa","slug":"xa-cao-xa","name_with_type":"Xã Cao Xá","path":"Xã Cao Xá, Huyện Tân Yên, Tỉnh Bắc Giang","path_with_type":"Xã Cao Xá, Huyện Tân Yên, Tỉnh Bắc Giang","code":"07336","parent_code":"216"},"07339":{"name":"Thị trấn Cao Thượng","type":"thi-tran","slug":"thi-tran-cao-thuong","name_with_type":"Thị trấn Cao Thượng","path":"Thị trấn Cao Thượng, Huyện Tân Yên, Tỉnh Bắc Giang","path_with_type":"Thị trấn Cao Thượng, Huyện Tân Yên, Tỉnh Bắc Giang","code":"07339","parent_code":"216"},"07342":{"name":"Xã Việt Ngọc","type":"xa","slug":"xa-viet-ngoc","name_with_type":"Xã Việt Ngọc","path":"Xã Việt Ngọc, Huyện Tân Yên, Tỉnh Bắc Giang","path_with_type":"Xã Việt Ngọc, Huyện Tân Yên, Tỉnh Bắc Giang","code":"07342","parent_code":"216"},"07345":{"name":"Xã Song Vân","type":"xa","slug":"xa-song-van","name_with_type":"Xã Song Vân","path":"Xã Song Vân, Huyện Tân Yên, Tỉnh Bắc Giang","path_with_type":"Xã Song Vân, Huyện Tân Yên, Tỉnh Bắc Giang","code":"07345","parent_code":"216"},"07348":{"name":"Xã Ngọc Châu","type":"xa","slug":"xa-ngoc-chau","name_with_type":"Xã Ngọc Châu","path":"Xã Ngọc Châu, Huyện Tân Yên, Tỉnh Bắc Giang","path_with_type":"Xã Ngọc Châu, Huyện Tân Yên, Tỉnh Bắc Giang","code":"07348","parent_code":"216"},"07351":{"name":"Xã Ngọc Vân","type":"xa","slug":"xa-ngoc-van","name_with_type":"Xã Ngọc Vân","path":"Xã Ngọc Vân, Huyện Tân Yên, Tỉnh Bắc Giang","path_with_type":"Xã Ngọc Vân, Huyện Tân Yên, Tỉnh Bắc Giang","code":"07351","parent_code":"216"},"07354":{"name":"Xã Việt Lập","type":"xa","slug":"xa-viet-lap","name_with_type":"Xã Việt Lập","path":"Xã Việt Lập, Huyện Tân Yên, Tỉnh Bắc Giang","path_with_type":"Xã Việt Lập, Huyện Tân Yên, Tỉnh Bắc Giang","code":"07354","parent_code":"216"},"07357":{"name":"Xã Liên Chung","type":"xa","slug":"xa-lien-chung","name_with_type":"Xã Liên Chung","path":"Xã Liên Chung, Huyện Tân Yên, Tỉnh Bắc Giang","path_with_type":"Xã Liên Chung, Huyện Tân Yên, Tỉnh Bắc Giang","code":"07357","parent_code":"216"},"07360":{"name":"Xã Ngọc Thiện","type":"xa","slug":"xa-ngoc-thien","name_with_type":"Xã Ngọc Thiện","path":"Xã Ngọc Thiện, Huyện Tân Yên, Tỉnh Bắc Giang","path_with_type":"Xã Ngọc Thiện, Huyện Tân Yên, Tỉnh Bắc Giang","code":"07360","parent_code":"216"},"07363":{"name":"Xã Ngọc Lý","type":"xa","slug":"xa-ngoc-ly","name_with_type":"Xã Ngọc Lý","path":"Xã Ngọc Lý, Huyện Tân Yên, Tỉnh Bắc Giang","path_with_type":"Xã Ngọc Lý, Huyện Tân Yên, Tỉnh Bắc Giang","code":"07363","parent_code":"216"},"07366":{"name":"Xã Quế Nham","type":"xa","slug":"xa-que-nham","name_with_type":"Xã Quế Nham","path":"Xã Quế Nham, Huyện Tân Yên, Tỉnh Bắc Giang","path_with_type":"Xã Quế Nham, Huyện Tân Yên, Tỉnh Bắc Giang","code":"07366","parent_code":"216"},"07375":{"name":"Thị trấn Vôi","type":"thi-tran","slug":"thi-tran-voi","name_with_type":"Thị trấn Vôi","path":"Thị trấn Vôi, Huyện Lạng Giang, Tỉnh Bắc Giang","path_with_type":"Thị trấn Vôi, Huyện Lạng Giang, Tỉnh Bắc Giang","code":"07375","parent_code":"217"},"07378":{"name":"Xã Nghĩa Hòa","type":"xa","slug":"xa-nghia-hoa","name_with_type":"Xã Nghĩa Hòa","path":"Xã Nghĩa Hòa, Huyện Lạng Giang, Tỉnh Bắc Giang","path_with_type":"Xã Nghĩa Hòa, Huyện Lạng Giang, Tỉnh Bắc Giang","code":"07378","parent_code":"217"},"07381":{"name":"Xã Nghĩa Hưng","type":"xa","slug":"xa-nghia-hung","name_with_type":"Xã Nghĩa Hưng","path":"Xã Nghĩa Hưng, Huyện Lạng Giang, Tỉnh Bắc Giang","path_with_type":"Xã Nghĩa Hưng, Huyện Lạng Giang, Tỉnh Bắc Giang","code":"07381","parent_code":"217"},"07384":{"name":"Xã Quang Thịnh","type":"xa","slug":"xa-quang-thinh","name_with_type":"Xã Quang Thịnh","path":"Xã Quang Thịnh, Huyện Lạng Giang, Tỉnh Bắc Giang","path_with_type":"Xã Quang Thịnh, Huyện Lạng Giang, Tỉnh Bắc Giang","code":"07384","parent_code":"217"},"07387":{"name":"Xã Hương Sơn","type":"xa","slug":"xa-huong-son","name_with_type":"Xã Hương Sơn","path":"Xã Hương Sơn, Huyện Lạng Giang, Tỉnh Bắc Giang","path_with_type":"Xã Hương Sơn, Huyện Lạng Giang, Tỉnh Bắc Giang","code":"07387","parent_code":"217"},"07390":{"name":"Xã Đào Mỹ","type":"xa","slug":"xa-dao-my","name_with_type":"Xã Đào Mỹ","path":"Xã Đào Mỹ, Huyện Lạng Giang, Tỉnh Bắc Giang","path_with_type":"Xã Đào Mỹ, Huyện Lạng Giang, Tỉnh Bắc Giang","code":"07390","parent_code":"217"},"07393":{"name":"Xã Tiên Lục","type":"xa","slug":"xa-tien-luc","name_with_type":"Xã Tiên Lục","path":"Xã Tiên Lục, Huyện Lạng Giang, Tỉnh Bắc Giang","path_with_type":"Xã Tiên Lục, Huyện Lạng Giang, Tỉnh Bắc Giang","code":"07393","parent_code":"217"},"07396":{"name":"Xã An Hà","type":"xa","slug":"xa-an-ha","name_with_type":"Xã An Hà","path":"Xã An Hà, Huyện Lạng Giang, Tỉnh Bắc Giang","path_with_type":"Xã An Hà, Huyện Lạng Giang, Tỉnh Bắc Giang","code":"07396","parent_code":"217"},"07399":{"name":"Thị trấn Kép","type":"thi-tran","slug":"thi-tran-kep","name_with_type":"Thị trấn Kép","path":"Thị trấn Kép, Huyện Lạng Giang, Tỉnh Bắc Giang","path_with_type":"Thị trấn Kép, Huyện Lạng Giang, Tỉnh Bắc Giang","code":"07399","parent_code":"217"},"07405":{"name":"Xã Hương Lạc","type":"xa","slug":"xa-huong-lac","name_with_type":"Xã Hương Lạc","path":"Xã Hương Lạc, Huyện Lạng Giang, Tỉnh Bắc Giang","path_with_type":"Xã Hương Lạc, Huyện Lạng Giang, Tỉnh Bắc Giang","code":"07405","parent_code":"217"},"07408":{"name":"Xã Dương Đức","type":"xa","slug":"xa-duong-duc","name_with_type":"Xã Dương Đức","path":"Xã Dương Đức, Huyện Lạng Giang, Tỉnh Bắc Giang","path_with_type":"Xã Dương Đức, Huyện Lạng Giang, Tỉnh Bắc Giang","code":"07408","parent_code":"217"},"07411":{"name":"Xã Tân Thanh","type":"xa","slug":"xa-tan-thanh","name_with_type":"Xã Tân Thanh","path":"Xã Tân Thanh, Huyện Lạng Giang, Tỉnh Bắc Giang","path_with_type":"Xã Tân Thanh, Huyện Lạng Giang, Tỉnh Bắc Giang","code":"07411","parent_code":"217"},"07417":{"name":"Xã Tân Hưng","type":"xa","slug":"xa-tan-hung","name_with_type":"Xã Tân Hưng","path":"Xã Tân Hưng, Huyện Lạng Giang, Tỉnh Bắc Giang","path_with_type":"Xã Tân Hưng, Huyện Lạng Giang, Tỉnh Bắc Giang","code":"07417","parent_code":"217"},"07420":{"name":"Xã Mỹ Thái","type":"xa","slug":"xa-my-thai","name_with_type":"Xã Mỹ Thái","path":"Xã Mỹ Thái, Huyện Lạng Giang, Tỉnh Bắc Giang","path_with_type":"Xã Mỹ Thái, Huyện Lạng Giang, Tỉnh Bắc Giang","code":"07420","parent_code":"217"},"07426":{"name":"Xã Xương Lâm","type":"xa","slug":"xa-xuong-lam","name_with_type":"Xã Xương Lâm","path":"Xã Xương Lâm, Huyện Lạng Giang, Tỉnh Bắc Giang","path_with_type":"Xã Xương Lâm, Huyện Lạng Giang, Tỉnh Bắc Giang","code":"07426","parent_code":"217"},"07429":{"name":"Xã Xuân Hương","type":"xa","slug":"xa-xuan-huong","name_with_type":"Xã Xuân Hương","path":"Xã Xuân Hương, Huyện Lạng Giang, Tỉnh Bắc Giang","path_with_type":"Xã Xuân Hương, Huyện Lạng Giang, Tỉnh Bắc Giang","code":"07429","parent_code":"217"},"07432":{"name":"Xã Tân Dĩnh","type":"xa","slug":"xa-tan-dinh","name_with_type":"Xã Tân Dĩnh","path":"Xã Tân Dĩnh, Huyện Lạng Giang, Tỉnh Bắc Giang","path_with_type":"Xã Tân Dĩnh, Huyện Lạng Giang, Tỉnh Bắc Giang","code":"07432","parent_code":"217"},"07435":{"name":"Xã Đại Lâm","type":"xa","slug":"xa-dai-lam","name_with_type":"Xã Đại Lâm","path":"Xã Đại Lâm, Huyện Lạng Giang, Tỉnh Bắc Giang","path_with_type":"Xã Đại Lâm, Huyện Lạng Giang, Tỉnh Bắc Giang","code":"07435","parent_code":"217"},"07438":{"name":"Xã Thái Đào","type":"xa","slug":"xa-thai-dao","name_with_type":"Xã Thái Đào","path":"Xã Thái Đào, Huyện Lạng Giang, Tỉnh Bắc Giang","path_with_type":"Xã Thái Đào, Huyện Lạng Giang, Tỉnh Bắc Giang","code":"07438","parent_code":"217"},"07444":{"name":"Thị trấn Đồi Ngô","type":"thi-tran","slug":"thi-tran-doi-ngo","name_with_type":"Thị trấn Đồi Ngô","path":"Thị trấn Đồi Ngô, Huyện Lục Nam, Tỉnh Bắc Giang","path_with_type":"Thị trấn Đồi Ngô, Huyện Lục Nam, Tỉnh Bắc Giang","code":"07444","parent_code":"218"},"07450":{"name":"Xã Đông Hưng","type":"xa","slug":"xa-dong-hung","name_with_type":"Xã Đông Hưng","path":"Xã Đông Hưng, Huyện Lục Nam, Tỉnh Bắc Giang","path_with_type":"Xã Đông Hưng, Huyện Lục Nam, Tỉnh Bắc Giang","code":"07450","parent_code":"218"},"07453":{"name":"Xã Đông Phú","type":"xa","slug":"xa-dong-phu","name_with_type":"Xã Đông Phú","path":"Xã Đông Phú, Huyện Lục Nam, Tỉnh Bắc Giang","path_with_type":"Xã Đông Phú, Huyện Lục Nam, Tỉnh Bắc Giang","code":"07453","parent_code":"218"},"07456":{"name":"Xã Tam Dị","type":"xa","slug":"xa-tam-di","name_with_type":"Xã Tam Dị","path":"Xã Tam Dị, Huyện Lục Nam, Tỉnh Bắc Giang","path_with_type":"Xã Tam Dị, Huyện Lục Nam, Tỉnh Bắc Giang","code":"07456","parent_code":"218"},"07459":{"name":"Xã Bảo Sơn","type":"xa","slug":"xa-bao-son","name_with_type":"Xã Bảo Sơn","path":"Xã Bảo Sơn, Huyện Lục Nam, Tỉnh Bắc Giang","path_with_type":"Xã Bảo Sơn, Huyện Lục Nam, Tỉnh Bắc Giang","code":"07459","parent_code":"218"},"07462":{"name":"Xã Bảo Đài","type":"xa","slug":"xa-bao-dai","name_with_type":"Xã Bảo Đài","path":"Xã Bảo Đài, Huyện Lục Nam, Tỉnh Bắc Giang","path_with_type":"Xã Bảo Đài, Huyện Lục Nam, Tỉnh Bắc Giang","code":"07462","parent_code":"218"},"07465":{"name":"Xã Thanh Lâm","type":"xa","slug":"xa-thanh-lam","name_with_type":"Xã Thanh Lâm","path":"Xã Thanh Lâm, Huyện Lục Nam, Tỉnh Bắc Giang","path_with_type":"Xã Thanh Lâm, Huyện Lục Nam, Tỉnh Bắc Giang","code":"07465","parent_code":"218"},"07468":{"name":"Xã Tiên Nha","type":"xa","slug":"xa-tien-nha","name_with_type":"Xã Tiên Nha","path":"Xã Tiên Nha, Huyện Lục Nam, Tỉnh Bắc Giang","path_with_type":"Xã Tiên Nha, Huyện Lục Nam, Tỉnh Bắc Giang","code":"07468","parent_code":"218"},"07471":{"name":"Xã Trường Giang","type":"xa","slug":"xa-truong-giang","name_with_type":"Xã Trường Giang","path":"Xã Trường Giang, Huyện Lục Nam, Tỉnh Bắc Giang","path_with_type":"Xã Trường Giang, Huyện Lục Nam, Tỉnh Bắc Giang","code":"07471","parent_code":"218"},"07477":{"name":"Thị trấn Phương Sơn","type":"thi-tran","slug":"thi-tran-phuong-son","name_with_type":"Thị trấn Phương Sơn","path":"Thị trấn Phương Sơn, Huyện Lục Nam, Tỉnh Bắc Giang","path_with_type":"Thị trấn Phương Sơn, Huyện Lục Nam, Tỉnh Bắc Giang","code":"07477","parent_code":"218"},"07480":{"name":"Xã Chu Điện","type":"xa","slug":"xa-chu-dien","name_with_type":"Xã Chu Điện","path":"Xã Chu Điện, Huyện Lục Nam, Tỉnh Bắc Giang","path_with_type":"Xã Chu Điện, Huyện Lục Nam, Tỉnh Bắc Giang","code":"07480","parent_code":"218"},"07483":{"name":"Xã Cương Sơn","type":"xa","slug":"xa-cuong-son","name_with_type":"Xã Cương Sơn","path":"Xã Cương Sơn, Huyện Lục Nam, Tỉnh Bắc Giang","path_with_type":"Xã Cương Sơn, Huyện Lục Nam, Tỉnh Bắc Giang","code":"07483","parent_code":"218"},"07486":{"name":"Xã Nghĩa Phương","type":"xa","slug":"xa-nghia-phuong","name_with_type":"Xã Nghĩa Phương","path":"Xã Nghĩa Phương, Huyện Lục Nam, Tỉnh Bắc Giang","path_with_type":"Xã Nghĩa Phương, Huyện Lục Nam, Tỉnh Bắc Giang","code":"07486","parent_code":"218"},"07489":{"name":"Xã Vô Tranh","type":"xa","slug":"xa-vo-tranh","name_with_type":"Xã Vô Tranh","path":"Xã Vô Tranh, Huyện Lục Nam, Tỉnh Bắc Giang","path_with_type":"Xã Vô Tranh, Huyện Lục Nam, Tỉnh Bắc Giang","code":"07489","parent_code":"218"},"07492":{"name":"Xã Bình Sơn","type":"xa","slug":"xa-binh-son","name_with_type":"Xã Bình Sơn","path":"Xã Bình Sơn, Huyện Lục Nam, Tỉnh Bắc Giang","path_with_type":"Xã Bình Sơn, Huyện Lục Nam, Tỉnh Bắc Giang","code":"07492","parent_code":"218"},"07495":{"name":"Xã Lan Mẫu","type":"xa","slug":"xa-lan-mau","name_with_type":"Xã Lan Mẫu","path":"Xã Lan Mẫu, Huyện Lục Nam, Tỉnh Bắc Giang","path_with_type":"Xã Lan Mẫu, Huyện Lục Nam, Tỉnh Bắc Giang","code":"07495","parent_code":"218"},"07498":{"name":"Xã Yên Sơn","type":"xa","slug":"xa-yen-son","name_with_type":"Xã Yên Sơn","path":"Xã Yên Sơn, Huyện Lục Nam, Tỉnh Bắc Giang","path_with_type":"Xã Yên Sơn, Huyện Lục Nam, Tỉnh Bắc Giang","code":"07498","parent_code":"218"},"07501":{"name":"Xã Khám Lạng","type":"xa","slug":"xa-kham-lang","name_with_type":"Xã Khám Lạng","path":"Xã Khám Lạng, Huyện Lục Nam, Tỉnh Bắc Giang","path_with_type":"Xã Khám Lạng, Huyện Lục Nam, Tỉnh Bắc Giang","code":"07501","parent_code":"218"},"07504":{"name":"Xã Huyền Sơn","type":"xa","slug":"xa-huyen-son","name_with_type":"Xã Huyền Sơn","path":"Xã Huyền Sơn, Huyện Lục Nam, Tỉnh Bắc Giang","path_with_type":"Xã Huyền Sơn, Huyện Lục Nam, Tỉnh Bắc Giang","code":"07504","parent_code":"218"},"07507":{"name":"Xã Trường Sơn","type":"xa","slug":"xa-truong-son","name_with_type":"Xã Trường Sơn","path":"Xã Trường Sơn, Huyện Lục Nam, Tỉnh Bắc Giang","path_with_type":"Xã Trường Sơn, Huyện Lục Nam, Tỉnh Bắc Giang","code":"07507","parent_code":"218"},"07510":{"name":"Xã Lục Sơn","type":"xa","slug":"xa-luc-son","name_with_type":"Xã Lục Sơn","path":"Xã Lục Sơn, Huyện Lục Nam, Tỉnh Bắc Giang","path_with_type":"Xã Lục Sơn, Huyện Lục Nam, Tỉnh Bắc Giang","code":"07510","parent_code":"218"},"07513":{"name":"Xã Bắc Lũng","type":"xa","slug":"xa-bac-lung","name_with_type":"Xã Bắc Lũng","path":"Xã Bắc Lũng, Huyện Lục Nam, Tỉnh Bắc Giang","path_with_type":"Xã Bắc Lũng, Huyện Lục Nam, Tỉnh Bắc Giang","code":"07513","parent_code":"218"},"07519":{"name":"Xã Cẩm Lý","type":"xa","slug":"xa-cam-ly","name_with_type":"Xã Cẩm Lý","path":"Xã Cẩm Lý, Huyện Lục Nam, Tỉnh Bắc Giang","path_with_type":"Xã Cẩm Lý, Huyện Lục Nam, Tỉnh Bắc Giang","code":"07519","parent_code":"218"},"07522":{"name":"Xã Đan Hội","type":"xa","slug":"xa-dan-hoi","name_with_type":"Xã Đan Hội","path":"Xã Đan Hội, Huyện Lục Nam, Tỉnh Bắc Giang","path_with_type":"Xã Đan Hội, Huyện Lục Nam, Tỉnh Bắc Giang","code":"07522","parent_code":"218"},"07528":{"name":"Xã Cấm Sơn","type":"xa","slug":"xa-cam-son","name_with_type":"Xã Cấm Sơn","path":"Xã Cấm Sơn, Huyện Lục Ngạn, Tỉnh Bắc Giang","path_with_type":"Xã Cấm Sơn, Huyện Lục Ngạn, Tỉnh Bắc Giang","code":"07528","parent_code":"219"},"07531":{"name":"Xã Tân Sơn","type":"xa","slug":"xa-tan-son","name_with_type":"Xã Tân Sơn","path":"Xã Tân Sơn, Huyện Lục Ngạn, Tỉnh Bắc Giang","path_with_type":"Xã Tân Sơn, Huyện Lục Ngạn, Tỉnh Bắc Giang","code":"07531","parent_code":"219"},"07534":{"name":"Xã Phong Minh","type":"xa","slug":"xa-phong-minh","name_with_type":"Xã Phong Minh","path":"Xã Phong Minh, Huyện Lục Ngạn, Tỉnh Bắc Giang","path_with_type":"Xã Phong Minh, Huyện Lục Ngạn, Tỉnh Bắc Giang","code":"07534","parent_code":"219"},"07537":{"name":"Xã Phong Vân","type":"xa","slug":"xa-phong-van","name_with_type":"Xã Phong Vân","path":"Xã Phong Vân, Huyện Lục Ngạn, Tỉnh Bắc Giang","path_with_type":"Xã Phong Vân, Huyện Lục Ngạn, Tỉnh Bắc Giang","code":"07537","parent_code":"219"},"07540":{"name":"Xã Xa Lý","type":"xa","slug":"xa-xa-ly","name_with_type":"Xã Xa Lý","path":"Xã Xa Lý, Huyện Lục Ngạn, Tỉnh Bắc Giang","path_with_type":"Xã Xa Lý, Huyện Lục Ngạn, Tỉnh Bắc Giang","code":"07540","parent_code":"219"},"07543":{"name":"Xã Hộ Đáp","type":"xa","slug":"xa-ho-dap","name_with_type":"Xã Hộ Đáp","path":"Xã Hộ Đáp, Huyện Lục Ngạn, Tỉnh Bắc Giang","path_with_type":"Xã Hộ Đáp, Huyện Lục Ngạn, Tỉnh Bắc Giang","code":"07543","parent_code":"219"},"07546":{"name":"Xã Sơn Hải","type":"xa","slug":"xa-son-hai","name_with_type":"Xã Sơn Hải","path":"Xã Sơn Hải, Huyện Lục Ngạn, Tỉnh Bắc Giang","path_with_type":"Xã Sơn Hải, Huyện Lục Ngạn, Tỉnh Bắc Giang","code":"07546","parent_code":"219"},"07555":{"name":"Xã Biên Sơn","type":"xa","slug":"xa-bien-son","name_with_type":"Xã Biên Sơn","path":"Xã Biên Sơn, Huyện Lục Ngạn, Tỉnh Bắc Giang","path_with_type":"Xã Biên Sơn, Huyện Lục Ngạn, Tỉnh Bắc Giang","code":"07555","parent_code":"219"},"07564":{"name":"Xã Kim Sơn","type":"xa","slug":"xa-kim-son","name_with_type":"Xã Kim Sơn","path":"Xã Kim Sơn, Huyện Lục Ngạn, Tỉnh Bắc Giang","path_with_type":"Xã Kim Sơn, Huyện Lục Ngạn, Tỉnh Bắc Giang","code":"07564","parent_code":"219"},"07567":{"name":"Xã Tân Hoa","type":"xa","slug":"xa-tan-hoa","name_with_type":"Xã Tân Hoa","path":"Xã Tân Hoa, Huyện Lục Ngạn, Tỉnh Bắc Giang","path_with_type":"Xã Tân Hoa, Huyện Lục Ngạn, Tỉnh Bắc Giang","code":"07567","parent_code":"219"},"07570":{"name":"Xã Giáp Sơn","type":"xa","slug":"xa-giap-son","name_with_type":"Xã Giáp Sơn","path":"Xã Giáp Sơn, Huyện Lục Ngạn, Tỉnh Bắc Giang","path_with_type":"Xã Giáp Sơn, Huyện Lục Ngạn, Tỉnh Bắc Giang","code":"07570","parent_code":"219"},"07573":{"name":"Thị trấn Biển Động","type":"thi-tran","slug":"thi-tran-bien-dong","name_with_type":"Thị trấn Biển Động","path":"Thị trấn Biển Động, Huyện Lục Ngạn, Tỉnh Bắc Giang","path_with_type":"Thị trấn Biển Động, Huyện Lục Ngạn, Tỉnh Bắc Giang","code":"07573","parent_code":"219"},"07582":{"name":"Thị trấn Phì Điền","type":"thi-tran","slug":"thi-tran-phi-dien","name_with_type":"Thị trấn Phì Điền","path":"Thị trấn Phì Điền, Huyện Lục Ngạn, Tỉnh Bắc Giang","path_with_type":"Thị trấn Phì Điền, Huyện Lục Ngạn, Tỉnh Bắc Giang","code":"07582","parent_code":"219"},"07588":{"name":"Xã Tân Quang","type":"xa","slug":"xa-tan-quang","name_with_type":"Xã Tân Quang","path":"Xã Tân Quang, Huyện Lục Ngạn, Tỉnh Bắc Giang","path_with_type":"Xã Tân Quang, Huyện Lục Ngạn, Tỉnh Bắc Giang","code":"07588","parent_code":"219"},"07591":{"name":"Xã Đồng Cốc","type":"xa","slug":"xa-dong-coc","name_with_type":"Xã Đồng Cốc","path":"Xã Đồng Cốc, Huyện Lục Ngạn, Tỉnh Bắc Giang","path_with_type":"Xã Đồng Cốc, Huyện Lục Ngạn, Tỉnh Bắc Giang","code":"07591","parent_code":"219"},"07594":{"name":"Xã Tân Lập","type":"xa","slug":"xa-tan-lap","name_with_type":"Xã Tân Lập","path":"Xã Tân Lập, Huyện Lục Ngạn, Tỉnh Bắc Giang","path_with_type":"Xã Tân Lập, Huyện Lục Ngạn, Tỉnh Bắc Giang","code":"07594","parent_code":"219"},"07597":{"name":"Xã Phú Nhuận","type":"xa","slug":"xa-phu-nhuan","name_with_type":"Xã Phú Nhuận","path":"Xã Phú Nhuận, Huyện Lục Ngạn, Tỉnh Bắc Giang","path_with_type":"Xã Phú Nhuận, Huyện Lục Ngạn, Tỉnh Bắc Giang","code":"07597","parent_code":"219"},"07606":{"name":"Xã Tân Mộc","type":"xa","slug":"xa-tan-moc","name_with_type":"Xã Tân Mộc","path":"Xã Tân Mộc, Huyện Lục Ngạn, Tỉnh Bắc Giang","path_with_type":"Xã Tân Mộc, Huyện Lục Ngạn, Tỉnh Bắc Giang","code":"07606","parent_code":"219"},"07609":{"name":"Xã Đèo Gia","type":"xa","slug":"xa-deo-gia","name_with_type":"Xã Đèo Gia","path":"Xã Đèo Gia, Huyện Lục Ngạn, Tỉnh Bắc Giang","path_with_type":"Xã Đèo Gia, Huyện Lục Ngạn, Tỉnh Bắc Giang","code":"07609","parent_code":"219"},"07615":{"name":"Thị trấn An Châu","type":"thi-tran","slug":"thi-tran-an-chau","name_with_type":"Thị trấn An Châu","path":"Thị trấn An Châu, Huyện Sơn Động, Tỉnh Bắc Giang","path_with_type":"Thị trấn An Châu, Huyện Sơn Động, Tỉnh Bắc Giang","code":"07615","parent_code":"220"},"07616":{"name":"Thị trấn Tây Yên Tử","type":"thi-tran","slug":"thi-tran-tay-yen-tu","name_with_type":"Thị trấn Tây Yên Tử","path":"Thị trấn Tây Yên Tử, Huyện Sơn Động, Tỉnh Bắc Giang","path_with_type":"Thị trấn Tây Yên Tử, Huyện Sơn Động, Tỉnh Bắc Giang","code":"07616","parent_code":"220"},"07621":{"name":"Xã Vân Sơn","type":"xa","slug":"xa-van-son","name_with_type":"Xã Vân Sơn","path":"Xã Vân Sơn, Huyện Sơn Động, Tỉnh Bắc Giang","path_with_type":"Xã Vân Sơn, Huyện Sơn Động, Tỉnh Bắc Giang","code":"07621","parent_code":"220"},"07624":{"name":"Xã Hữu Sản","type":"xa","slug":"xa-huu-san","name_with_type":"Xã Hữu Sản","path":"Xã Hữu Sản, Huyện Sơn Động, Tỉnh Bắc Giang","path_with_type":"Xã Hữu Sản, Huyện Sơn Động, Tỉnh Bắc Giang","code":"07624","parent_code":"220"},"07627":{"name":"Xã Đại Sơn","type":"xa","slug":"xa-dai-son","name_with_type":"Xã Đại Sơn","path":"Xã Đại Sơn, Huyện Sơn Động, Tỉnh Bắc Giang","path_with_type":"Xã Đại Sơn, Huyện Sơn Động, Tỉnh Bắc Giang","code":"07627","parent_code":"220"},"07630":{"name":"Xã Phúc Sơn","type":"xa","slug":"xa-phuc-son","name_with_type":"Xã Phúc Sơn","path":"Xã Phúc Sơn, Huyện Sơn Động, Tỉnh Bắc Giang","path_with_type":"Xã Phúc Sơn, Huyện Sơn Động, Tỉnh Bắc Giang","code":"07630","parent_code":"220"},"07636":{"name":"Xã Giáo Liêm","type":"xa","slug":"xa-giao-liem","name_with_type":"Xã Giáo Liêm","path":"Xã Giáo Liêm, Huyện Sơn Động, Tỉnh Bắc Giang","path_with_type":"Xã Giáo Liêm, Huyện Sơn Động, Tỉnh Bắc Giang","code":"07636","parent_code":"220"},"07642":{"name":"Xã Cẩm Đàn","type":"xa","slug":"xa-cam-dan","name_with_type":"Xã Cẩm Đàn","path":"Xã Cẩm Đàn, Huyện Sơn Động, Tỉnh Bắc Giang","path_with_type":"Xã Cẩm Đàn, Huyện Sơn Động, Tỉnh Bắc Giang","code":"07642","parent_code":"220"},"07645":{"name":"Xã An Lạc","type":"xa","slug":"xa-an-lac","name_with_type":"Xã An Lạc","path":"Xã An Lạc, Huyện Sơn Động, Tỉnh Bắc Giang","path_with_type":"Xã An Lạc, Huyện Sơn Động, Tỉnh Bắc Giang","code":"07645","parent_code":"220"},"07648":{"name":"Xã Vĩnh An","type":"xa","slug":"xa-vinh-an","name_with_type":"Xã Vĩnh An","path":"Xã Vĩnh An, Huyện Sơn Động, Tỉnh Bắc Giang","path_with_type":"Xã Vĩnh An, Huyện Sơn Động, Tỉnh Bắc Giang","code":"07648","parent_code":"220"},"07651":{"name":"Xã Yên Định","type":"xa","slug":"xa-yen-dinh","name_with_type":"Xã Yên Định","path":"Xã Yên Định, Huyện Sơn Động, Tỉnh Bắc Giang","path_with_type":"Xã Yên Định, Huyện Sơn Động, Tỉnh Bắc Giang","code":"07651","parent_code":"220"},"07654":{"name":"Xã Lệ Viễn","type":"xa","slug":"xa-le-vien","name_with_type":"Xã Lệ Viễn","path":"Xã Lệ Viễn, Huyện Sơn Động, Tỉnh Bắc Giang","path_with_type":"Xã Lệ Viễn, Huyện Sơn Động, Tỉnh Bắc Giang","code":"07654","parent_code":"220"},"07660":{"name":"Xã An Bá","type":"xa","slug":"xa-an-ba","name_with_type":"Xã An Bá","path":"Xã An Bá, Huyện Sơn Động, Tỉnh Bắc Giang","path_with_type":"Xã An Bá, Huyện Sơn Động, Tỉnh Bắc Giang","code":"07660","parent_code":"220"},"07663":{"name":"Xã Tuấn Đạo","type":"xa","slug":"xa-tuan-dao","name_with_type":"Xã Tuấn Đạo","path":"Xã Tuấn Đạo, Huyện Sơn Động, Tỉnh Bắc Giang","path_with_type":"Xã Tuấn Đạo, Huyện Sơn Động, Tỉnh Bắc Giang","code":"07663","parent_code":"220"},"07666":{"name":"Xã Dương Hưu","type":"xa","slug":"xa-duong-huu","name_with_type":"Xã Dương Hưu","path":"Xã Dương Hưu, Huyện Sơn Động, Tỉnh Bắc Giang","path_with_type":"Xã Dương Hưu, Huyện Sơn Động, Tỉnh Bắc Giang","code":"07666","parent_code":"220"},"07672":{"name":"Xã Long Sơn","type":"xa","slug":"xa-long-son","name_with_type":"Xã Long Sơn","path":"Xã Long Sơn, Huyện Sơn Động, Tỉnh Bắc Giang","path_with_type":"Xã Long Sơn, Huyện Sơn Động, Tỉnh Bắc Giang","code":"07672","parent_code":"220"},"07678":{"name":"Xã Thanh Luận","type":"xa","slug":"xa-thanh-luan","name_with_type":"Xã Thanh Luận","path":"Xã Thanh Luận, Huyện Sơn Động, Tỉnh Bắc Giang","path_with_type":"Xã Thanh Luận, Huyện Sơn Động, Tỉnh Bắc Giang","code":"07678","parent_code":"220"},"07759":{"name":"Xã Thượng Lan","type":"xa","slug":"xa-thuong-lan","name_with_type":"Xã Thượng Lan","path":"Xã Thượng Lan, Thị Xã Việt Yên, Tỉnh Bắc Giang","path_with_type":"Xã Thượng Lan, Thị Xã Việt Yên, Tỉnh Bắc Giang","code":"07759","parent_code":"222"},"07762":{"name":"Xã Việt Tiến","type":"xa","slug":"xa-viet-tien","name_with_type":"Xã Việt Tiến","path":"Xã Việt Tiến, Thị Xã Việt Yên, Tỉnh Bắc Giang","path_with_type":"Xã Việt Tiến, Thị Xã Việt Yên, Tỉnh Bắc Giang","code":"07762","parent_code":"222"},"07765":{"name":"Xã Nghĩa Trung","type":"xa","slug":"xa-nghia-trung","name_with_type":"Xã Nghĩa Trung","path":"Xã Nghĩa Trung, Thị Xã Việt Yên, Tỉnh Bắc Giang","path_with_type":"Xã Nghĩa Trung, Thị Xã Việt Yên, Tỉnh Bắc Giang","code":"07765","parent_code":"222"},"07768":{"name":"Xã Minh Đức","type":"xa","slug":"xa-minh-duc","name_with_type":"Xã Minh Đức","path":"Xã Minh Đức, Thị Xã Việt Yên, Tỉnh Bắc Giang","path_with_type":"Xã Minh Đức, Thị Xã Việt Yên, Tỉnh Bắc Giang","code":"07768","parent_code":"222"},"07771":{"name":"Xã Hương Mai","type":"xa","slug":"xa-huong-mai","name_with_type":"Xã Hương Mai","path":"Xã Hương Mai, Thị Xã Việt Yên, Tỉnh Bắc Giang","path_with_type":"Xã Hương Mai, Thị Xã Việt Yên, Tỉnh Bắc Giang","code":"07771","parent_code":"222"},"07774":{"name":"Phường Tự Lạn","type":"phuong","slug":"phuong-tu-lan","name_with_type":"Phường Tự Lạn","path":"Phường Tự Lạn, Thị Xã Việt Yên, Tỉnh Bắc Giang","path_with_type":"Phường Tự Lạn, Thị Xã Việt Yên, Tỉnh Bắc Giang","code":"07774","parent_code":"222"},"07777":{"name":"Phường Bích Động","type":"phuong","slug":"phuong-bich-dong","name_with_type":"Phường Bích Động","path":"Phường Bích Động, Thị Xã Việt Yên, Tỉnh Bắc Giang","path_with_type":"Phường Bích Động, Thị Xã Việt Yên, Tỉnh Bắc Giang","code":"07777","parent_code":"222"},"07780":{"name":"Xã Trung Sơn","type":"xa","slug":"xa-trung-son","name_with_type":"Xã Trung Sơn","path":"Xã Trung Sơn, Thị Xã Việt Yên, Tỉnh Bắc Giang","path_with_type":"Xã Trung Sơn, Thị Xã Việt Yên, Tỉnh Bắc Giang","code":"07780","parent_code":"222"},"07783":{"name":"Phường Hồng Thái","type":"phuong","slug":"phuong-hong-thai","name_with_type":"Phường Hồng Thái","path":"Phường Hồng Thái, Thị Xã Việt Yên, Tỉnh Bắc Giang","path_with_type":"Phường Hồng Thái, Thị Xã Việt Yên, Tỉnh Bắc Giang","code":"07783","parent_code":"222"},"07786":{"name":"Xã Tiên Sơn","type":"xa","slug":"xa-tien-son","name_with_type":"Xã Tiên Sơn","path":"Xã Tiên Sơn, Thị Xã Việt Yên, Tỉnh Bắc Giang","path_with_type":"Xã Tiên Sơn, Thị Xã Việt Yên, Tỉnh Bắc Giang","code":"07786","parent_code":"222"},"07789":{"name":"Phường Tăng Tiến","type":"phuong","slug":"phuong-tang-tien","name_with_type":"Phường Tăng Tiến","path":"Phường Tăng Tiến, Thị Xã Việt Yên, Tỉnh Bắc Giang","path_with_type":"Phường Tăng Tiến, Thị Xã Việt Yên, Tỉnh Bắc Giang","code":"07789","parent_code":"222"},"07792":{"name":"Phường Quảng Minh","type":"phuong","slug":"phuong-quang-minh","name_with_type":"Phường Quảng Minh","path":"Phường Quảng Minh, Thị Xã Việt Yên, Tỉnh Bắc Giang","path_with_type":"Phường Quảng Minh, Thị Xã Việt Yên, Tỉnh Bắc Giang","code":"07792","parent_code":"222"},"07795":{"name":"Phường Nếnh","type":"phuong","slug":"phuong-nenh","name_with_type":"Phường Nếnh","path":"Phường Nếnh, Thị Xã Việt Yên, Tỉnh Bắc Giang","path_with_type":"Phường Nếnh, Thị Xã Việt Yên, Tỉnh Bắc Giang","code":"07795","parent_code":"222"},"07798":{"name":"Phường Ninh Sơn","type":"phuong","slug":"phuong-ninh-son","name_with_type":"Phường Ninh Sơn","path":"Phường Ninh Sơn, Thị Xã Việt Yên, Tỉnh Bắc Giang","path_with_type":"Phường Ninh Sơn, Thị Xã Việt Yên, Tỉnh Bắc Giang","code":"07798","parent_code":"222"},"07801":{"name":"Phường Vân Trung","type":"phuong","slug":"phuong-van-trung","name_with_type":"Phường Vân Trung","path":"Phường Vân Trung, Thị Xã Việt Yên, Tỉnh Bắc Giang","path_with_type":"Phường Vân Trung, Thị Xã Việt Yên, Tỉnh Bắc Giang","code":"07801","parent_code":"222"},"07804":{"name":"Xã Vân Hà","type":"xa","slug":"xa-van-ha","name_with_type":"Xã Vân Hà","path":"Xã Vân Hà, Thị Xã Việt Yên, Tỉnh Bắc Giang","path_with_type":"Xã Vân Hà, Thị Xã Việt Yên, Tỉnh Bắc Giang","code":"07804","parent_code":"222"},"07807":{"name":"Phường Quang Châu","type":"phuong","slug":"phuong-quang-chau","name_with_type":"Phường Quang Châu","path":"Phường Quang Châu, Thị Xã Việt Yên, Tỉnh Bắc Giang","path_with_type":"Phường Quang Châu, Thị Xã Việt Yên, Tỉnh Bắc Giang","code":"07807","parent_code":"222"},"07816":{"name":"Xã Đồng Tiến","type":"xa","slug":"xa-dong-tien","name_with_type":"Xã Đồng Tiến","path":"Xã Đồng Tiến, Huyện Hiệp Hòa, Tỉnh Bắc Giang","path_with_type":"Xã Đồng Tiến, Huyện Hiệp Hòa, Tỉnh Bắc Giang","code":"07816","parent_code":"223"},"07822":{"name":"Xã Hoàng Vân","type":"xa","slug":"xa-hoang-van","name_with_type":"Xã Hoàng Vân","path":"Xã Hoàng Vân, Huyện Hiệp Hòa, Tỉnh Bắc Giang","path_with_type":"Xã Hoàng Vân, Huyện Hiệp Hòa, Tỉnh Bắc Giang","code":"07822","parent_code":"223"},"07825":{"name":"Xã Toàn Thắng","type":"xa","slug":"xa-toan-thang","name_with_type":"Xã Toàn Thắng","path":"Xã Toàn Thắng, Huyện Hiệp Hòa, Tỉnh Bắc Giang","path_with_type":"Xã Toàn Thắng, Huyện Hiệp Hòa, Tỉnh Bắc Giang","code":"07825","parent_code":"223"},"07831":{"name":"Xã Ngọc Sơn","type":"xa","slug":"xa-ngoc-son","name_with_type":"Xã Ngọc Sơn","path":"Xã Ngọc Sơn, Huyện Hiệp Hòa, Tỉnh Bắc Giang","path_with_type":"Xã Ngọc Sơn, Huyện Hiệp Hòa, Tỉnh Bắc Giang","code":"07831","parent_code":"223"},"07840":{"name":"Thị trấn Thắng","type":"thi-tran","slug":"thi-tran-thang","name_with_type":"Thị trấn Thắng","path":"Thị trấn Thắng, Huyện Hiệp Hòa, Tỉnh Bắc Giang","path_with_type":"Thị trấn Thắng, Huyện Hiệp Hòa, Tỉnh Bắc Giang","code":"07840","parent_code":"223"},"07843":{"name":"Xã Sơn Thịnh","type":"xa","slug":"xa-son-thinh","name_with_type":"Xã Sơn Thịnh","path":"Xã Sơn Thịnh, Huyện Hiệp Hòa, Tỉnh Bắc Giang","path_with_type":"Xã Sơn Thịnh, Huyện Hiệp Hòa, Tỉnh Bắc Giang","code":"07843","parent_code":"223"},"07846":{"name":"Xã Lương Phong","type":"xa","slug":"xa-luong-phong","name_with_type":"Xã Lương Phong","path":"Xã Lương Phong, Huyện Hiệp Hòa, Tỉnh Bắc Giang","path_with_type":"Xã Lương Phong, Huyện Hiệp Hòa, Tỉnh Bắc Giang","code":"07846","parent_code":"223"},"07849":{"name":"Xã Hùng Thái","type":"xa","slug":"xa-hung-thai","name_with_type":"Xã Hùng Thái","path":"Xã Hùng Thái, Huyện Hiệp Hòa, Tỉnh Bắc Giang","path_with_type":"Xã Hùng Thái, Huyện Hiệp Hòa, Tỉnh Bắc Giang","code":"07849","parent_code":"223"},"07855":{"name":"Xã Thường Thắng","type":"xa","slug":"xa-thuong-thang","name_with_type":"Xã Thường Thắng","path":"Xã Thường Thắng, Huyện Hiệp Hòa, Tỉnh Bắc Giang","path_with_type":"Xã Thường Thắng, Huyện Hiệp Hòa, Tỉnh Bắc Giang","code":"07855","parent_code":"223"},"07858":{"name":"Xã Hợp Thịnh","type":"xa","slug":"xa-hop-thinh","name_with_type":"Xã Hợp Thịnh","path":"Xã Hợp Thịnh, Huyện Hiệp Hòa, Tỉnh Bắc Giang","path_with_type":"Xã Hợp Thịnh, Huyện Hiệp Hòa, Tỉnh Bắc Giang","code":"07858","parent_code":"223"},"07861":{"name":"Xã Danh Thắng","type":"xa","slug":"xa-danh-thang","name_with_type":"Xã Danh Thắng","path":"Xã Danh Thắng, Huyện Hiệp Hòa, Tỉnh Bắc Giang","path_with_type":"Xã Danh Thắng, Huyện Hiệp Hòa, Tỉnh Bắc Giang","code":"07861","parent_code":"223"},"07864":{"name":"Xã Mai Trung","type":"xa","slug":"xa-mai-trung","name_with_type":"Xã Mai Trung","path":"Xã Mai Trung, Huyện Hiệp Hòa, Tỉnh Bắc Giang","path_with_type":"Xã Mai Trung, Huyện Hiệp Hòa, Tỉnh Bắc Giang","code":"07864","parent_code":"223"},"07867":{"name":"Xã Đoan Bái","type":"xa","slug":"xa-doan-bai","name_with_type":"Xã Đoan Bái","path":"Xã Đoan Bái, Huyện Hiệp Hòa, Tỉnh Bắc Giang","path_with_type":"Xã Đoan Bái, Huyện Hiệp Hòa, Tỉnh Bắc Giang","code":"07867","parent_code":"223"},"07870":{"name":"Thị trấn Bắc Lý","type":"thi-tran","slug":"thi-tran-bac-ly","name_with_type":"Thị trấn Bắc Lý","path":"Thị trấn Bắc Lý, Huyện Hiệp Hòa, Tỉnh Bắc Giang","path_with_type":"Thị trấn Bắc Lý, Huyện Hiệp Hòa, Tỉnh Bắc Giang","code":"07870","parent_code":"223"},"07873":{"name":"Xã Xuân Cẩm","type":"xa","slug":"xa-xuan-cam","name_with_type":"Xã Xuân Cẩm","path":"Xã Xuân Cẩm, Huyện Hiệp Hòa, Tỉnh Bắc Giang","path_with_type":"Xã Xuân Cẩm, Huyện Hiệp Hòa, Tỉnh Bắc Giang","code":"07873","parent_code":"223"},"07876":{"name":"Xã Hương Lâm","type":"xa","slug":"xa-huong-lam","name_with_type":"Xã Hương Lâm","path":"Xã Hương Lâm, Huyện Hiệp Hòa, Tỉnh Bắc Giang","path_with_type":"Xã Hương Lâm, Huyện Hiệp Hòa, Tỉnh Bắc Giang","code":"07876","parent_code":"223"},"07879":{"name":"Xã Đông Lỗ","type":"xa","slug":"xa-dong-lo","name_with_type":"Xã Đông Lỗ","path":"Xã Đông Lỗ, Huyện Hiệp Hòa, Tỉnh Bắc Giang","path_with_type":"Xã Đông Lỗ, Huyện Hiệp Hòa, Tỉnh Bắc Giang","code":"07879","parent_code":"223"},"07882":{"name":"Xã Châu Minh","type":"xa","slug":"xa-chau-minh","name_with_type":"Xã Châu Minh","path":"Xã Châu Minh, Huyện Hiệp Hòa, Tỉnh Bắc Giang","path_with_type":"Xã Châu Minh, Huyện Hiệp Hòa, Tỉnh Bắc Giang","code":"07882","parent_code":"223"},"07885":{"name":"Xã Mai Đình","type":"xa","slug":"xa-mai-dinh","name_with_type":"Xã Mai Đình","path":"Xã Mai Đình, Huyện Hiệp Hòa, Tỉnh Bắc Giang","path_with_type":"Xã Mai Đình, Huyện Hiệp Hòa, Tỉnh Bắc Giang","code":"07885","parent_code":"223"},"07525":{"name":"Phường Chũ","type":"phuong","slug":"phuong-chu","name_with_type":"Phường Chũ","path":"Phường Chũ, Thị xã Chũ, Tỉnh Bắc Giang","path_with_type":"Phường Chũ, Thị xã Chũ, Tỉnh Bắc Giang","code":"07525","parent_code":"224"},"07549":{"name":"Phường Thanh Hải","type":"phuong","slug":"phuong-thanh-hai","name_with_type":"Phường Thanh Hải","path":"Phường Thanh Hải, Thị xã Chũ, Tỉnh Bắc Giang","path_with_type":"Phường Thanh Hải, Thị xã Chũ, Tỉnh Bắc Giang","code":"07549","parent_code":"224"},"07552":{"name":"Xã Kiên Lao","type":"xa","slug":"xa-kien-lao","name_with_type":"Xã Kiên Lao","path":"Xã Kiên Lao, Thị xã Chũ, Tỉnh Bắc Giang","path_with_type":"Xã Kiên Lao, Thị xã Chũ, Tỉnh Bắc Giang","code":"07552","parent_code":"224"},"07558":{"name":"Xã Kiên Thành","type":"xa","slug":"xa-kien-thanh","name_with_type":"Xã Kiên Thành","path":"Xã Kiên Thành, Thị xã Chũ, Tỉnh Bắc Giang","path_with_type":"Xã Kiên Thành, Thị xã Chũ, Tỉnh Bắc Giang","code":"07558","parent_code":"224"},"07561":{"name":"Phường Hồng Giang","type":"phuong","slug":"phuong-hong-giang","name_with_type":"Phường Hồng Giang","path":"Phường Hồng Giang, Thị xã Chũ, Tỉnh Bắc Giang","path_with_type":"Phường Hồng Giang, Thị xã Chũ, Tỉnh Bắc Giang","code":"07561","parent_code":"224"},"07576":{"name":"Xã Quý Sơn","type":"xa","slug":"xa-quy-son","name_with_type":"Xã Quý Sơn","path":"Xã Quý Sơn, Thị xã Chũ, Tỉnh Bắc Giang","path_with_type":"Xã Quý Sơn, Thị xã Chũ, Tỉnh Bắc Giang","code":"07576","parent_code":"224"},"07579":{"name":"Phường Trù Hựu","type":"phuong","slug":"phuong-tru-huu","name_with_type":"Phường Trù Hựu","path":"Phường Trù Hựu, Thị xã Chũ, Tỉnh Bắc Giang","path_with_type":"Phường Trù Hựu, Thị xã Chũ, Tỉnh Bắc Giang","code":"07579","parent_code":"224"},"07600":{"name":"Xã Mỹ An","type":"xa","slug":"xa-my-an","name_with_type":"Xã Mỹ An","path":"Xã Mỹ An, Thị xã Chũ, Tỉnh Bắc Giang","path_with_type":"Xã Mỹ An, Thị xã Chũ, Tỉnh Bắc Giang","code":"07600","parent_code":"224"},"07603":{"name":"Xã Nam Dương","type":"xa","slug":"xa-nam-duong","name_with_type":"Xã Nam Dương","path":"Xã Nam Dương, Thị xã Chũ, Tỉnh Bắc Giang","path_with_type":"Xã Nam Dương, Thị xã Chũ, Tỉnh Bắc Giang","code":"07603","parent_code":"224"},"07612":{"name":"Phường Phượng Sơn","type":"phuong","slug":"phuong-phuong-son","name_with_type":"Phường Phượng Sơn","path":"Phường Phượng Sơn, Thị xã Chũ, Tỉnh Bắc Giang","path_with_type":"Phường Phượng Sơn, Thị xã Chũ, Tỉnh Bắc Giang","code":"07612","parent_code":"224"},"07888":{"name":"Phường Dữu Lâu","type":"phuong","slug":"phuong-duu-lau","name_with_type":"Phường Dữu Lâu","path":"Phường Dữu Lâu, Thành phố Việt Trì, Tỉnh Phú Thọ","path_with_type":"Phường Dữu Lâu, Thành phố Việt Trì, Tỉnh Phú Thọ","code":"07888","parent_code":"227"},"07894":{"name":"Phường Nông Trang","type":"phuong","slug":"phuong-nong-trang","name_with_type":"Phường Nông Trang","path":"Phường Nông Trang, Thành phố Việt Trì, Tỉnh Phú Thọ","path_with_type":"Phường Nông Trang, Thành phố Việt Trì, Tỉnh Phú Thọ","code":"07894","parent_code":"227"},"07897":{"name":"Phường Tân Dân","type":"phuong","slug":"phuong-tan-dan","name_with_type":"Phường Tân Dân","path":"Phường Tân Dân, Thành phố Việt Trì, Tỉnh Phú Thọ","path_with_type":"Phường Tân Dân, Thành phố Việt Trì, Tỉnh Phú Thọ","code":"07897","parent_code":"227"},"07900":{"name":"Phường Gia Cẩm","type":"phuong","slug":"phuong-gia-cam","name_with_type":"Phường Gia Cẩm","path":"Phường Gia Cẩm, Thành phố Việt Trì, Tỉnh Phú Thọ","path_with_type":"Phường Gia Cẩm, Thành phố Việt Trì, Tỉnh Phú Thọ","code":"07900","parent_code":"227"},"07903":{"name":"Phường Tiên Cát","type":"phuong","slug":"phuong-tien-cat","name_with_type":"Phường Tiên Cát","path":"Phường Tiên Cát, Thành phố Việt Trì, Tỉnh Phú Thọ","path_with_type":"Phường Tiên Cát, Thành phố Việt Trì, Tỉnh Phú Thọ","code":"07903","parent_code":"227"},"07906":{"name":"Phường Thọ Sơn","type":"phuong","slug":"phuong-tho-son","name_with_type":"Phường Thọ Sơn","path":"Phường Thọ Sơn, Thành phố Việt Trì, Tỉnh Phú Thọ","path_with_type":"Phường Thọ Sơn, Thành phố Việt Trì, Tỉnh Phú Thọ","code":"07906","parent_code":"227"},"07909":{"name":"Phường Thanh Miếu","type":"phuong","slug":"phuong-thanh-mieu","name_with_type":"Phường Thanh Miếu","path":"Phường Thanh Miếu, Thành phố Việt Trì, Tỉnh Phú Thọ","path_with_type":"Phường Thanh Miếu, Thành phố Việt Trì, Tỉnh Phú Thọ","code":"07909","parent_code":"227"},"07912":{"name":"Phường Bạch Hạc","type":"phuong","slug":"phuong-bach-hac","name_with_type":"Phường Bạch Hạc","path":"Phường Bạch Hạc, Thành phố Việt Trì, Tỉnh Phú Thọ","path_with_type":"Phường Bạch Hạc, Thành phố Việt Trì, Tỉnh Phú Thọ","code":"07912","parent_code":"227"},"07918":{"name":"Phường Vân Phú","type":"phuong","slug":"phuong-van-phu","name_with_type":"Phường Vân Phú","path":"Phường Vân Phú, Thành phố Việt Trì, Tỉnh Phú Thọ","path_with_type":"Phường Vân Phú, Thành phố Việt Trì, Tỉnh Phú Thọ","code":"07918","parent_code":"227"},"07921":{"name":"Xã Phượng Lâu","type":"xa","slug":"xa-phuong-lau","name_with_type":"Xã Phượng Lâu","path":"Xã Phượng Lâu, Thành phố Việt Trì, Tỉnh Phú Thọ","path_with_type":"Xã Phượng Lâu, Thành phố Việt Trì, Tỉnh Phú Thọ","code":"07921","parent_code":"227"},"07924":{"name":"Xã Thụy Vân","type":"xa","slug":"xa-thuy-van","name_with_type":"Xã Thụy Vân","path":"Xã Thụy Vân, Thành phố Việt Trì, Tỉnh Phú Thọ","path_with_type":"Xã Thụy Vân, Thành phố Việt Trì, Tỉnh Phú Thọ","code":"07924","parent_code":"227"},"07927":{"name":"Phường Minh Phương","type":"phuong","slug":"phuong-minh-phuong","name_with_type":"Phường Minh Phương","path":"Phường Minh Phương, Thành phố Việt Trì, Tỉnh Phú Thọ","path_with_type":"Phường Minh Phương, Thành phố Việt Trì, Tỉnh Phú Thọ","code":"07927","parent_code":"227"},"07930":{"name":"Xã Trưng Vương","type":"xa","slug":"xa-trung-vuong","name_with_type":"Xã Trưng Vương","path":"Xã Trưng Vương, Thành phố Việt Trì, Tỉnh Phú Thọ","path_with_type":"Xã Trưng Vương, Thành phố Việt Trì, Tỉnh Phú Thọ","code":"07930","parent_code":"227"},"07933":{"name":"Phường Minh Nông","type":"phuong","slug":"phuong-minh-nong","name_with_type":"Phường Minh Nông","path":"Phường Minh Nông, Thành phố Việt Trì, Tỉnh Phú Thọ","path_with_type":"Phường Minh Nông, Thành phố Việt Trì, Tỉnh Phú Thọ","code":"07933","parent_code":"227"},"07936":{"name":"Xã Sông Lô","type":"xa","slug":"xa-song-lo","name_with_type":"Xã Sông Lô","path":"Xã Sông Lô, Thành phố Việt Trì, Tỉnh Phú Thọ","path_with_type":"Xã Sông Lô, Thành phố Việt Trì, Tỉnh Phú Thọ","code":"07936","parent_code":"227"},"08281":{"name":"Xã Kim Đức","type":"xa","slug":"xa-kim-duc","name_with_type":"Xã Kim Đức","path":"Xã Kim Đức, Thành phố Việt Trì, Tỉnh Phú Thọ","path_with_type":"Xã Kim Đức, Thành phố Việt Trì, Tỉnh Phú Thọ","code":"08281","parent_code":"227"},"08287":{"name":"Xã Hùng Lô","type":"xa","slug":"xa-hung-lo","name_with_type":"Xã Hùng Lô","path":"Xã Hùng Lô, Thành phố Việt Trì, Tỉnh Phú Thọ","path_with_type":"Xã Hùng Lô, Thành phố Việt Trì, Tỉnh Phú Thọ","code":"08287","parent_code":"227"},"08503":{"name":"Xã Hy Cương","type":"xa","slug":"xa-hy-cuong","name_with_type":"Xã Hy Cương","path":"Xã Hy Cương, Thành phố Việt Trì, Tỉnh Phú Thọ","path_with_type":"Xã Hy Cương, Thành phố Việt Trì, Tỉnh Phú Thọ","code":"08503","parent_code":"227"},"08506":{"name":"Xã Chu Hóa","type":"xa","slug":"xa-chu-hoa","name_with_type":"Xã Chu Hóa","path":"Xã Chu Hóa, Thành phố Việt Trì, Tỉnh Phú Thọ","path_with_type":"Xã Chu Hóa, Thành phố Việt Trì, Tỉnh Phú Thọ","code":"08506","parent_code":"227"},"08515":{"name":"Xã Thanh Đình","type":"xa","slug":"xa-thanh-dinh","name_with_type":"Xã Thanh Đình","path":"Xã Thanh Đình, Thành phố Việt Trì, Tỉnh Phú Thọ","path_with_type":"Xã Thanh Đình, Thành phố Việt Trì, Tỉnh Phú Thọ","code":"08515","parent_code":"227"},"07942":{"name":"Phường Hùng Vương","type":"phuong","slug":"phuong-hung-vuong","name_with_type":"Phường Hùng Vương","path":"Phường Hùng Vương, Thị xã Phú Thọ, Tỉnh Phú Thọ","path_with_type":"Phường Hùng Vương, Thị xã Phú Thọ, Tỉnh Phú Thọ","code":"07942","parent_code":"228"},"07945":{"name":"Phường Phong Châu","type":"phuong","slug":"phuong-phong-chau","name_with_type":"Phường Phong Châu","path":"Phường Phong Châu, Thị xã Phú Thọ, Tỉnh Phú Thọ","path_with_type":"Phường Phong Châu, Thị xã Phú Thọ, Tỉnh Phú Thọ","code":"07945","parent_code":"228"},"07948":{"name":"Phường Âu Cơ","type":"phuong","slug":"phuong-au-co","name_with_type":"Phường Âu Cơ","path":"Phường Âu Cơ, Thị xã Phú Thọ, Tỉnh Phú Thọ","path_with_type":"Phường Âu Cơ, Thị xã Phú Thọ, Tỉnh Phú Thọ","code":"07948","parent_code":"228"},"07951":{"name":"Xã Hà Lộc","type":"xa","slug":"xa-ha-loc","name_with_type":"Xã Hà Lộc","path":"Xã Hà Lộc, Thị xã Phú Thọ, Tỉnh Phú Thọ","path_with_type":"Xã Hà Lộc, Thị xã Phú Thọ, Tỉnh Phú Thọ","code":"07951","parent_code":"228"},"07954":{"name":"Xã Phú Hộ","type":"xa","slug":"xa-phu-ho","name_with_type":"Xã Phú Hộ","path":"Xã Phú Hộ, Thị xã Phú Thọ, Tỉnh Phú Thọ","path_with_type":"Xã Phú Hộ, Thị xã Phú Thọ, Tỉnh Phú Thọ","code":"07954","parent_code":"228"},"07957":{"name":"Xã Văn Lung","type":"xa","slug":"xa-van-lung","name_with_type":"Xã Văn Lung","path":"Xã Văn Lung, Thị xã Phú Thọ, Tỉnh Phú Thọ","path_with_type":"Xã Văn Lung, Thị xã Phú Thọ, Tỉnh Phú Thọ","code":"07957","parent_code":"228"},"07960":{"name":"Xã Thanh Minh","type":"xa","slug":"xa-thanh-minh","name_with_type":"Xã Thanh Minh","path":"Xã Thanh Minh, Thị xã Phú Thọ, Tỉnh Phú Thọ","path_with_type":"Xã Thanh Minh, Thị xã Phú Thọ, Tỉnh Phú Thọ","code":"07960","parent_code":"228"},"07963":{"name":"Xã Hà Thạch","type":"xa","slug":"xa-ha-thach","name_with_type":"Xã Hà Thạch","path":"Xã Hà Thạch, Thị xã Phú Thọ, Tỉnh Phú Thọ","path_with_type":"Xã Hà Thạch, Thị xã Phú Thọ, Tỉnh Phú Thọ","code":"07963","parent_code":"228"},"07966":{"name":"Phường Thanh Vinh","type":"phuong","slug":"phuong-thanh-vinh","name_with_type":"Phường Thanh Vinh","path":"Phường Thanh Vinh, Thị xã Phú Thọ, Tỉnh Phú Thọ","path_with_type":"Phường Thanh Vinh, Thị xã Phú Thọ, Tỉnh Phú Thọ","code":"07966","parent_code":"228"},"07969":{"name":"Thị trấn Đoan Hùng","type":"thi-tran","slug":"thi-tran-doan-hung","name_with_type":"Thị trấn Đoan Hùng","path":"Thị trấn Đoan Hùng, Huyện Đoan Hùng, Tỉnh Phú Thọ","path_with_type":"Thị trấn Đoan Hùng, Huyện Đoan Hùng, Tỉnh Phú Thọ","code":"07969","parent_code":"230"},"07975":{"name":"Xã Hùng Xuyên","type":"xa","slug":"xa-hung-xuyen","name_with_type":"Xã Hùng Xuyên","path":"Xã Hùng Xuyên, Huyện Đoan Hùng, Tỉnh Phú Thọ","path_with_type":"Xã Hùng Xuyên, Huyện Đoan Hùng, Tỉnh Phú Thọ","code":"07975","parent_code":"230"},"07981":{"name":"Xã Bằng Luân","type":"xa","slug":"xa-bang-luan","name_with_type":"Xã Bằng Luân","path":"Xã Bằng Luân, Huyện Đoan Hùng, Tỉnh Phú Thọ","path_with_type":"Xã Bằng Luân, Huyện Đoan Hùng, Tỉnh Phú Thọ","code":"07981","parent_code":"230"},"07987":{"name":"Xã Phú Lâm","type":"xa","slug":"xa-phu-lam","name_with_type":"Xã Phú Lâm","path":"Xã Phú Lâm, Huyện Đoan Hùng, Tỉnh Phú Thọ","path_with_type":"Xã Phú Lâm, Huyện Đoan Hùng, Tỉnh Phú Thọ","code":"07987","parent_code":"230"},"07996":{"name":"Xã Bằng Doãn","type":"xa","slug":"xa-bang-doan","name_with_type":"Xã Bằng Doãn","path":"Xã Bằng Doãn, Huyện Đoan Hùng, Tỉnh Phú Thọ","path_with_type":"Xã Bằng Doãn, Huyện Đoan Hùng, Tỉnh Phú Thọ","code":"07996","parent_code":"230"},"07999":{"name":"Xã Chí Đám","type":"xa","slug":"xa-chi-dam","name_with_type":"Xã Chí Đám","path":"Xã Chí Đám, Huyện Đoan Hùng, Tỉnh Phú Thọ","path_with_type":"Xã Chí Đám, Huyện Đoan Hùng, Tỉnh Phú Thọ","code":"07999","parent_code":"230"},"08005":{"name":"Xã Phúc Lai","type":"xa","slug":"xa-phuc-lai","name_with_type":"Xã Phúc Lai","path":"Xã Phúc Lai, Huyện Đoan Hùng, Tỉnh Phú Thọ","path_with_type":"Xã Phúc Lai, Huyện Đoan Hùng, Tỉnh Phú Thọ","code":"08005","parent_code":"230"},"08008":{"name":"Xã Ngọc Quan","type":"xa","slug":"xa-ngoc-quan","name_with_type":"Xã Ngọc Quan","path":"Xã Ngọc Quan, Huyện Đoan Hùng, Tỉnh Phú Thọ","path_with_type":"Xã Ngọc Quan, Huyện Đoan Hùng, Tỉnh Phú Thọ","code":"08008","parent_code":"230"},"08014":{"name":"Xã Hợp Nhất","type":"xa","slug":"xa-hop-nhat","name_with_type":"Xã Hợp Nhất","path":"Xã Hợp Nhất, Huyện Đoan Hùng, Tỉnh Phú Thọ","path_with_type":"Xã Hợp Nhất, Huyện Đoan Hùng, Tỉnh Phú Thọ","code":"08014","parent_code":"230"},"08023":{"name":"Xã Tây Cốc","type":"xa","slug":"xa-tay-coc","name_with_type":"Xã Tây Cốc","path":"Xã Tây Cốc, Huyện Đoan Hùng, Tỉnh Phú Thọ","path_with_type":"Xã Tây Cốc, Huyện Đoan Hùng, Tỉnh Phú Thọ","code":"08023","parent_code":"230"},"08035":{"name":"Xã Hùng Long","type":"xa","slug":"xa-hung-long","name_with_type":"Xã Hùng Long","path":"Xã Hùng Long, Huyện Đoan Hùng, Tỉnh Phú Thọ","path_with_type":"Xã Hùng Long, Huyện Đoan Hùng, Tỉnh Phú Thọ","code":"08035","parent_code":"230"},"08038":{"name":"Xã Yên Kiện","type":"xa","slug":"xa-yen-kien","name_with_type":"Xã Yên Kiện","path":"Xã Yên Kiện, Huyện Đoan Hùng, Tỉnh Phú Thọ","path_with_type":"Xã Yên Kiện, Huyện Đoan Hùng, Tỉnh Phú Thọ","code":"08038","parent_code":"230"},"08044":{"name":"Xã Chân Mộng","type":"xa","slug":"xa-chan-mong","name_with_type":"Xã Chân Mộng","path":"Xã Chân Mộng, Huyện Đoan Hùng, Tỉnh Phú Thọ","path_with_type":"Xã Chân Mộng, Huyện Đoan Hùng, Tỉnh Phú Thọ","code":"08044","parent_code":"230"},"08050":{"name":"Xã Ca Đình","type":"xa","slug":"xa-ca-dinh","name_with_type":"Xã Ca Đình","path":"Xã Ca Đình, Huyện Đoan Hùng, Tỉnh Phú Thọ","path_with_type":"Xã Ca Đình, Huyện Đoan Hùng, Tỉnh Phú Thọ","code":"08050","parent_code":"230"},"08053":{"name":"Thị trấn Hạ Hoà","type":"thi-tran","slug":"thi-tran-ha-hoa","name_with_type":"Thị trấn Hạ Hoà","path":"Thị trấn Hạ Hoà, Huyện Hạ Hoà, Tỉnh Phú Thọ","path_with_type":"Thị trấn Hạ Hoà, Huyện Hạ Hoà, Tỉnh Phú Thọ","code":"08053","parent_code":"231"},"08056":{"name":"Xã Đại Phạm","type":"xa","slug":"xa-dai-pham","name_with_type":"Xã Đại Phạm","path":"Xã Đại Phạm, Huyện Hạ Hoà, Tỉnh Phú Thọ","path_with_type":"Xã Đại Phạm, Huyện Hạ Hoà, Tỉnh Phú Thọ","code":"08056","parent_code":"231"},"08062":{"name":"Xã Đan Thượng","type":"xa","slug":"xa-dan-thuong","name_with_type":"Xã Đan Thượng","path":"Xã Đan Thượng, Huyện Hạ Hoà, Tỉnh Phú Thọ","path_with_type":"Xã Đan Thượng, Huyện Hạ Hoà, Tỉnh Phú Thọ","code":"08062","parent_code":"231"},"08065":{"name":"Xã Hà Lương","type":"xa","slug":"xa-ha-luong","name_with_type":"Xã Hà Lương","path":"Xã Hà Lương, Huyện Hạ Hoà, Tỉnh Phú Thọ","path_with_type":"Xã Hà Lương, Huyện Hạ Hoà, Tỉnh Phú Thọ","code":"08065","parent_code":"231"},"08071":{"name":"Xã Tứ Hiệp","type":"xa","slug":"xa-tu-hiep","name_with_type":"Xã Tứ Hiệp","path":"Xã Tứ Hiệp, Huyện Hạ Hoà, Tỉnh Phú Thọ","path_with_type":"Xã Tứ Hiệp, Huyện Hạ Hoà, Tỉnh Phú Thọ","code":"08071","parent_code":"231"},"08080":{"name":"Xã Hiền Lương","type":"xa","slug":"xa-hien-luong","name_with_type":"Xã Hiền Lương","path":"Xã Hiền Lương, Huyện Hạ Hoà, Tỉnh Phú Thọ","path_with_type":"Xã Hiền Lương, Huyện Hạ Hoà, Tỉnh Phú Thọ","code":"08080","parent_code":"231"},"08089":{"name":"Xã Phương Viên","type":"xa","slug":"xa-phuong-vien","name_with_type":"Xã Phương Viên","path":"Xã Phương Viên, Huyện Hạ Hoà, Tỉnh Phú Thọ","path_with_type":"Xã Phương Viên, Huyện Hạ Hoà, Tỉnh Phú Thọ","code":"08089","parent_code":"231"},"08092":{"name":"Xã Gia Điền","type":"xa","slug":"xa-gia-dien","name_with_type":"Xã Gia Điền","path":"Xã Gia Điền, Huyện Hạ Hoà, Tỉnh Phú Thọ","path_with_type":"Xã Gia Điền, Huyện Hạ Hoà, Tỉnh Phú Thọ","code":"08092","parent_code":"231"},"08095":{"name":"Xã Ấm Hạ","type":"xa","slug":"xa-am-ha","name_with_type":"Xã Ấm Hạ","path":"Xã Ấm Hạ, Huyện Hạ Hoà, Tỉnh Phú Thọ","path_with_type":"Xã Ấm Hạ, Huyện Hạ Hoà, Tỉnh Phú Thọ","code":"08095","parent_code":"231"},"08104":{"name":"Xã Hương Xạ","type":"xa","slug":"xa-huong-xa","name_with_type":"Xã Hương Xạ","path":"Xã Hương Xạ, Huyện Hạ Hoà, Tỉnh Phú Thọ","path_with_type":"Xã Hương Xạ, Huyện Hạ Hoà, Tỉnh Phú Thọ","code":"08104","parent_code":"231"},"08110":{"name":"Xã Xuân Áng","type":"xa","slug":"xa-xuan-ang","name_with_type":"Xã Xuân Áng","path":"Xã Xuân Áng, Huyện Hạ Hoà, Tỉnh Phú Thọ","path_with_type":"Xã Xuân Áng, Huyện Hạ Hoà, Tỉnh Phú Thọ","code":"08110","parent_code":"231"},"08113":{"name":"Xã Yên Kỳ","type":"xa","slug":"xa-yen-ky","name_with_type":"Xã Yên Kỳ","path":"Xã Yên Kỳ, Huyện Hạ Hoà, Tỉnh Phú Thọ","path_with_type":"Xã Yên Kỳ, Huyện Hạ Hoà, Tỉnh Phú Thọ","code":"08113","parent_code":"231"},"08119":{"name":"Xã Minh Hạc","type":"xa","slug":"xa-minh-hac","name_with_type":"Xã Minh Hạc","path":"Xã Minh Hạc, Huyện Hạ Hoà, Tỉnh Phú Thọ","path_with_type":"Xã Minh Hạc, Huyện Hạ Hoà, Tỉnh Phú Thọ","code":"08119","parent_code":"231"},"08122":{"name":"Xã Lang Sơn","type":"xa","slug":"xa-lang-son","name_with_type":"Xã Lang Sơn","path":"Xã Lang Sơn, Huyện Hạ Hoà, Tỉnh Phú Thọ","path_with_type":"Xã Lang Sơn, Huyện Hạ Hoà, Tỉnh Phú Thọ","code":"08122","parent_code":"231"},"08125":{"name":"Xã Bằng Giã","type":"xa","slug":"xa-bang-gia","name_with_type":"Xã Bằng Giã","path":"Xã Bằng Giã, Huyện Hạ Hoà, Tỉnh Phú Thọ","path_with_type":"Xã Bằng Giã, Huyện Hạ Hoà, Tỉnh Phú Thọ","code":"08125","parent_code":"231"},"08128":{"name":"Xã Yên Luật","type":"xa","slug":"xa-yen-luat","name_with_type":"Xã Yên Luật","path":"Xã Yên Luật, Huyện Hạ Hoà, Tỉnh Phú Thọ","path_with_type":"Xã Yên Luật, Huyện Hạ Hoà, Tỉnh Phú Thọ","code":"08128","parent_code":"231"},"08131":{"name":"Xã Vô Tranh","type":"xa","slug":"xa-vo-tranh","name_with_type":"Xã Vô Tranh","path":"Xã Vô Tranh, Huyện Hạ Hoà, Tỉnh Phú Thọ","path_with_type":"Xã Vô Tranh, Huyện Hạ Hoà, Tỉnh Phú Thọ","code":"08131","parent_code":"231"},"08134":{"name":"Xã Văn Lang","type":"xa","slug":"xa-van-lang","name_with_type":"Xã Văn Lang","path":"Xã Văn Lang, Huyện Hạ Hoà, Tỉnh Phú Thọ","path_with_type":"Xã Văn Lang, Huyện Hạ Hoà, Tỉnh Phú Thọ","code":"08134","parent_code":"231"},"08140":{"name":"Xã Minh Côi","type":"xa","slug":"xa-minh-coi","name_with_type":"Xã Minh Côi","path":"Xã Minh Côi, Huyện Hạ Hoà, Tỉnh Phú Thọ","path_with_type":"Xã Minh Côi, Huyện Hạ Hoà, Tỉnh Phú Thọ","code":"08140","parent_code":"231"},"08143":{"name":"Xã Vĩnh Chân","type":"xa","slug":"xa-vinh-chan","name_with_type":"Xã Vĩnh Chân","path":"Xã Vĩnh Chân, Huyện Hạ Hoà, Tỉnh Phú Thọ","path_with_type":"Xã Vĩnh Chân, Huyện Hạ Hoà, Tỉnh Phú Thọ","code":"08143","parent_code":"231"},"08152":{"name":"Thị trấn Thanh Ba","type":"thi-tran","slug":"thi-tran-thanh-ba","name_with_type":"Thị trấn Thanh Ba","path":"Thị trấn Thanh Ba, Huyện Thanh Ba, Tỉnh Phú Thọ","path_with_type":"Thị trấn Thanh Ba, Huyện Thanh Ba, Tỉnh Phú Thọ","code":"08152","parent_code":"232"},"08156":{"name":"Xã Vân Lĩnh","type":"xa","slug":"xa-van-linh","name_with_type":"Xã Vân Lĩnh","path":"Xã Vân Lĩnh, Huyện Thanh Ba, Tỉnh Phú Thọ","path_with_type":"Xã Vân Lĩnh, Huyện Thanh Ba, Tỉnh Phú Thọ","code":"08156","parent_code":"232"},"08158":{"name":"Xã Đông Lĩnh","type":"xa","slug":"xa-dong-linh","name_with_type":"Xã Đông Lĩnh","path":"Xã Đông Lĩnh, Huyện Thanh Ba, Tỉnh Phú Thọ","path_with_type":"Xã Đông Lĩnh, Huyện Thanh Ba, Tỉnh Phú Thọ","code":"08158","parent_code":"232"},"08161":{"name":"Xã Đại An","type":"xa","slug":"xa-dai-an","name_with_type":"Xã Đại An","path":"Xã Đại An, Huyện Thanh Ba, Tỉnh Phú Thọ","path_with_type":"Xã Đại An, Huyện Thanh Ba, Tỉnh Phú Thọ","code":"08161","parent_code":"232"},"08164":{"name":"Xã Hanh Cù","type":"xa","slug":"xa-hanh-cu","name_with_type":"Xã Hanh Cù","path":"Xã Hanh Cù, Huyện Thanh Ba, Tỉnh Phú Thọ","path_with_type":"Xã Hanh Cù, Huyện Thanh Ba, Tỉnh Phú Thọ","code":"08164","parent_code":"232"},"08170":{"name":"Xã Đồng Xuân","type":"xa","slug":"xa-dong-xuan","name_with_type":"Xã Đồng Xuân","path":"Xã Đồng Xuân, Huyện Thanh Ba, Tỉnh Phú Thọ","path_with_type":"Xã Đồng Xuân, Huyện Thanh Ba, Tỉnh Phú Thọ","code":"08170","parent_code":"232"},"08173":{"name":"Xã Quảng Yên","type":"xa","slug":"xa-quang-yen","name_with_type":"Xã Quảng Yên","path":"Xã Quảng Yên, Huyện Thanh Ba, Tỉnh Phú Thọ","path_with_type":"Xã Quảng Yên, Huyện Thanh Ba, Tỉnh Phú Thọ","code":"08173","parent_code":"232"},"08179":{"name":"Xã Ninh Dân","type":"xa","slug":"xa-ninh-dan","name_with_type":"Xã Ninh Dân","path":"Xã Ninh Dân, Huyện Thanh Ba, Tỉnh Phú Thọ","path_with_type":"Xã Ninh Dân, Huyện Thanh Ba, Tỉnh Phú Thọ","code":"08179","parent_code":"232"},"08194":{"name":"Xã Võ Lao","type":"xa","slug":"xa-vo-lao","name_with_type":"Xã Võ Lao","path":"Xã Võ Lao, Huyện Thanh Ba, Tỉnh Phú Thọ","path_with_type":"Xã Võ Lao, Huyện Thanh Ba, Tỉnh Phú Thọ","code":"08194","parent_code":"232"},"08197":{"name":"Xã Khải Xuân","type":"xa","slug":"xa-khai-xuan","name_with_type":"Xã Khải Xuân","path":"Xã Khải Xuân, Huyện Thanh Ba, Tỉnh Phú Thọ","path_with_type":"Xã Khải Xuân, Huyện Thanh Ba, Tỉnh Phú Thọ","code":"08197","parent_code":"232"},"08200":{"name":"Xã Mạn Lạn","type":"xa","slug":"xa-man-lan","name_with_type":"Xã Mạn Lạn","path":"Xã Mạn Lạn, Huyện Thanh Ba, Tỉnh Phú Thọ","path_with_type":"Xã Mạn Lạn, Huyện Thanh Ba, Tỉnh Phú Thọ","code":"08200","parent_code":"232"},"08203":{"name":"Xã Hoàng Cương","type":"xa","slug":"xa-hoang-cuong","name_with_type":"Xã Hoàng Cương","path":"Xã Hoàng Cương, Huyện Thanh Ba, Tỉnh Phú Thọ","path_with_type":"Xã Hoàng Cương, Huyện Thanh Ba, Tỉnh Phú Thọ","code":"08203","parent_code":"232"},"08206":{"name":"Xã Chí Tiên","type":"xa","slug":"xa-chi-tien","name_with_type":"Xã Chí Tiên","path":"Xã Chí Tiên, Huyện Thanh Ba, Tỉnh Phú Thọ","path_with_type":"Xã Chí Tiên, Huyện Thanh Ba, Tỉnh Phú Thọ","code":"08206","parent_code":"232"},"08209":{"name":"Xã Đông Thành","type":"xa","slug":"xa-dong-thanh","name_with_type":"Xã Đông Thành","path":"Xã Đông Thành, Huyện Thanh Ba, Tỉnh Phú Thọ","path_with_type":"Xã Đông Thành, Huyện Thanh Ba, Tỉnh Phú Thọ","code":"08209","parent_code":"232"},"08215":{"name":"Xã Sơn Cương","type":"xa","slug":"xa-son-cuong","name_with_type":"Xã Sơn Cương","path":"Xã Sơn Cương, Huyện Thanh Ba, Tỉnh Phú Thọ","path_with_type":"Xã Sơn Cương, Huyện Thanh Ba, Tỉnh Phú Thọ","code":"08215","parent_code":"232"},"08218":{"name":"Xã Thanh Hà","type":"xa","slug":"xa-thanh-ha","name_with_type":"Xã Thanh Hà","path":"Xã Thanh Hà, Huyện Thanh Ba, Tỉnh Phú Thọ","path_with_type":"Xã Thanh Hà, Huyện Thanh Ba, Tỉnh Phú Thọ","code":"08218","parent_code":"232"},"08221":{"name":"Xã Đỗ Sơn","type":"xa","slug":"xa-do-son","name_with_type":"Xã Đỗ Sơn","path":"Xã Đỗ Sơn, Huyện Thanh Ba, Tỉnh Phú Thọ","path_with_type":"Xã Đỗ Sơn, Huyện Thanh Ba, Tỉnh Phú Thọ","code":"08221","parent_code":"232"},"08224":{"name":"Xã Đỗ Xuyên","type":"xa","slug":"xa-do-xuyen","name_with_type":"Xã Đỗ Xuyên","path":"Xã Đỗ Xuyên, Huyện Thanh Ba, Tỉnh Phú Thọ","path_with_type":"Xã Đỗ Xuyên, Huyện Thanh Ba, Tỉnh Phú Thọ","code":"08224","parent_code":"232"},"08227":{"name":"Xã Lương Lỗ","type":"xa","slug":"xa-luong-lo","name_with_type":"Xã Lương Lỗ","path":"Xã Lương Lỗ, Huyện Thanh Ba, Tỉnh Phú Thọ","path_with_type":"Xã Lương Lỗ, Huyện Thanh Ba, Tỉnh Phú Thọ","code":"08227","parent_code":"232"},"08230":{"name":"Thị trấn Phong Châu","type":"thi-tran","slug":"thi-tran-phong-chau","name_with_type":"Thị trấn Phong Châu","path":"Thị trấn Phong Châu, Huyện Phù Ninh, Tỉnh Phú Thọ","path_with_type":"Thị trấn Phong Châu, Huyện Phù Ninh, Tỉnh Phú Thọ","code":"08230","parent_code":"233"},"08233":{"name":"Xã Phú Mỹ","type":"xa","slug":"xa-phu-my","name_with_type":"Xã Phú Mỹ","path":"Xã Phú Mỹ, Huyện Phù Ninh, Tỉnh Phú Thọ","path_with_type":"Xã Phú Mỹ, Huyện Phù Ninh, Tỉnh Phú Thọ","code":"08233","parent_code":"233"},"08234":{"name":"Xã Lệ Mỹ","type":"xa","slug":"xa-le-my","name_with_type":"Xã Lệ Mỹ","path":"Xã Lệ Mỹ, Huyện Phù Ninh, Tỉnh Phú Thọ","path_with_type":"Xã Lệ Mỹ, Huyện Phù Ninh, Tỉnh Phú Thọ","code":"08234","parent_code":"233"},"08236":{"name":"Xã Liên Hoa","type":"xa","slug":"xa-lien-hoa","name_with_type":"Xã Liên Hoa","path":"Xã Liên Hoa, Huyện Phù Ninh, Tỉnh Phú Thọ","path_with_type":"Xã Liên Hoa, Huyện Phù Ninh, Tỉnh Phú Thọ","code":"08236","parent_code":"233"},"08239":{"name":"Xã Trạm Thản","type":"xa","slug":"xa-tram-than","name_with_type":"Xã Trạm Thản","path":"Xã Trạm Thản, Huyện Phù Ninh, Tỉnh Phú Thọ","path_with_type":"Xã Trạm Thản, Huyện Phù Ninh, Tỉnh Phú Thọ","code":"08239","parent_code":"233"},"08242":{"name":"Xã Trị Quận","type":"xa","slug":"xa-tri-quan","name_with_type":"Xã Trị Quận","path":"Xã Trị Quận, Huyện Phù Ninh, Tỉnh Phú Thọ","path_with_type":"Xã Trị Quận, Huyện Phù Ninh, Tỉnh Phú Thọ","code":"08242","parent_code":"233"},"08245":{"name":"Xã Trung Giáp","type":"xa","slug":"xa-trung-giap","name_with_type":"Xã Trung Giáp","path":"Xã Trung Giáp, Huyện Phù Ninh, Tỉnh Phú Thọ","path_with_type":"Xã Trung Giáp, Huyện Phù Ninh, Tỉnh Phú Thọ","code":"08245","parent_code":"233"},"08248":{"name":"Xã Tiên Phú","type":"xa","slug":"xa-tien-phu","name_with_type":"Xã Tiên Phú","path":"Xã Tiên Phú, Huyện Phù Ninh, Tỉnh Phú Thọ","path_with_type":"Xã Tiên Phú, Huyện Phù Ninh, Tỉnh Phú Thọ","code":"08248","parent_code":"233"},"08251":{"name":"Xã Hạ Giáp","type":"xa","slug":"xa-ha-giap","name_with_type":"Xã Hạ Giáp","path":"Xã Hạ Giáp, Huyện Phù Ninh, Tỉnh Phú Thọ","path_with_type":"Xã Hạ Giáp, Huyện Phù Ninh, Tỉnh Phú Thọ","code":"08251","parent_code":"233"},"08254":{"name":"Xã Bảo Thanh","type":"xa","slug":"xa-bao-thanh","name_with_type":"Xã Bảo Thanh","path":"Xã Bảo Thanh, Huyện Phù Ninh, Tỉnh Phú Thọ","path_with_type":"Xã Bảo Thanh, Huyện Phù Ninh, Tỉnh Phú Thọ","code":"08254","parent_code":"233"},"08257":{"name":"Xã Phú Lộc","type":"xa","slug":"xa-phu-loc","name_with_type":"Xã Phú Lộc","path":"Xã Phú Lộc, Huyện Phù Ninh, Tỉnh Phú Thọ","path_with_type":"Xã Phú Lộc, Huyện Phù Ninh, Tỉnh Phú Thọ","code":"08257","parent_code":"233"},"08260":{"name":"Xã Gia Thanh","type":"xa","slug":"xa-gia-thanh","name_with_type":"Xã Gia Thanh","path":"Xã Gia Thanh, Huyện Phù Ninh, Tỉnh Phú Thọ","path_with_type":"Xã Gia Thanh, Huyện Phù Ninh, Tỉnh Phú Thọ","code":"08260","parent_code":"233"},"08263":{"name":"Xã Tiên Du","type":"xa","slug":"xa-tien-du","name_with_type":"Xã Tiên Du","path":"Xã Tiên Du, Huyện Phù Ninh, Tỉnh Phú Thọ","path_with_type":"Xã Tiên Du, Huyện Phù Ninh, Tỉnh Phú Thọ","code":"08263","parent_code":"233"},"08266":{"name":"Xã Phú Nham","type":"xa","slug":"xa-phu-nham","name_with_type":"Xã Phú Nham","path":"Xã Phú Nham, Huyện Phù Ninh, Tỉnh Phú Thọ","path_with_type":"Xã Phú Nham, Huyện Phù Ninh, Tỉnh Phú Thọ","code":"08266","parent_code":"233"},"08272":{"name":"Xã An Đạo","type":"xa","slug":"xa-an-dao","name_with_type":"Xã An Đạo","path":"Xã An Đạo, Huyện Phù Ninh, Tỉnh Phú Thọ","path_with_type":"Xã An Đạo, Huyện Phù Ninh, Tỉnh Phú Thọ","code":"08272","parent_code":"233"},"08275":{"name":"Xã Bình Phú","type":"xa","slug":"xa-binh-phu","name_with_type":"Xã Bình Phú","path":"Xã Bình Phú, Huyện Phù Ninh, Tỉnh Phú Thọ","path_with_type":"Xã Bình Phú, Huyện Phù Ninh, Tỉnh Phú Thọ","code":"08275","parent_code":"233"},"08278":{"name":"Xã Phù Ninh","type":"xa","slug":"xa-phu-ninh","name_with_type":"Xã Phù Ninh","path":"Xã Phù Ninh, Huyện Phù Ninh, Tỉnh Phú Thọ","path_with_type":"Xã Phù Ninh, Huyện Phù Ninh, Tỉnh Phú Thọ","code":"08278","parent_code":"233"},"08290":{"name":"Thị trấn Yên Lập","type":"thi-tran","slug":"thi-tran-yen-lap","name_with_type":"Thị trấn Yên Lập","path":"Thị trấn Yên Lập, Huyện Yên Lập, Tỉnh Phú Thọ","path_with_type":"Thị trấn Yên Lập, Huyện Yên Lập, Tỉnh Phú Thọ","code":"08290","parent_code":"234"},"08293":{"name":"Xã Mỹ Lung","type":"xa","slug":"xa-my-lung","name_with_type":"Xã Mỹ Lung","path":"Xã Mỹ Lung, Huyện Yên Lập, Tỉnh Phú Thọ","path_with_type":"Xã Mỹ Lung, Huyện Yên Lập, Tỉnh Phú Thọ","code":"08293","parent_code":"234"},"08296":{"name":"Xã Mỹ Lương","type":"xa","slug":"xa-my-luong","name_with_type":"Xã Mỹ Lương","path":"Xã Mỹ Lương, Huyện Yên Lập, Tỉnh Phú Thọ","path_with_type":"Xã Mỹ Lương, Huyện Yên Lập, Tỉnh Phú Thọ","code":"08296","parent_code":"234"},"08299":{"name":"Xã Lương Sơn","type":"xa","slug":"xa-luong-son","name_with_type":"Xã Lương Sơn","path":"Xã Lương Sơn, Huyện Yên Lập, Tỉnh Phú Thọ","path_with_type":"Xã Lương Sơn, Huyện Yên Lập, Tỉnh Phú Thọ","code":"08299","parent_code":"234"},"08302":{"name":"Xã Xuân An","type":"xa","slug":"xa-xuan-an","name_with_type":"Xã Xuân An","path":"Xã Xuân An, Huyện Yên Lập, Tỉnh Phú Thọ","path_with_type":"Xã Xuân An, Huyện Yên Lập, Tỉnh Phú Thọ","code":"08302","parent_code":"234"},"08305":{"name":"Xã Xuân Viên","type":"xa","slug":"xa-xuan-vien","name_with_type":"Xã Xuân Viên","path":"Xã Xuân Viên, Huyện Yên Lập, Tỉnh Phú Thọ","path_with_type":"Xã Xuân Viên, Huyện Yên Lập, Tỉnh Phú Thọ","code":"08305","parent_code":"234"},"08308":{"name":"Xã Xuân Thủy","type":"xa","slug":"xa-xuan-thuy","name_with_type":"Xã Xuân Thủy","path":"Xã Xuân Thủy, Huyện Yên Lập, Tỉnh Phú Thọ","path_with_type":"Xã Xuân Thủy, Huyện Yên Lập, Tỉnh Phú Thọ","code":"08308","parent_code":"234"},"08311":{"name":"Xã Trung Sơn","type":"xa","slug":"xa-trung-son","name_with_type":"Xã Trung Sơn","path":"Xã Trung Sơn, Huyện Yên Lập, Tỉnh Phú Thọ","path_with_type":"Xã Trung Sơn, Huyện Yên Lập, Tỉnh Phú Thọ","code":"08311","parent_code":"234"},"08314":{"name":"Xã Hưng Long","type":"xa","slug":"xa-hung-long","name_with_type":"Xã Hưng Long","path":"Xã Hưng Long, Huyện Yên Lập, Tỉnh Phú Thọ","path_with_type":"Xã Hưng Long, Huyện Yên Lập, Tỉnh Phú Thọ","code":"08314","parent_code":"234"},"08317":{"name":"Xã Nga Hoàng","type":"xa","slug":"xa-nga-hoang","name_with_type":"Xã Nga Hoàng","path":"Xã Nga Hoàng, Huyện Yên Lập, Tỉnh Phú Thọ","path_with_type":"Xã Nga Hoàng, Huyện Yên Lập, Tỉnh Phú Thọ","code":"08317","parent_code":"234"},"08320":{"name":"Xã Đồng Lạc","type":"xa","slug":"xa-dong-lac","name_with_type":"Xã Đồng Lạc","path":"Xã Đồng Lạc, Huyện Yên Lập, Tỉnh Phú Thọ","path_with_type":"Xã Đồng Lạc, Huyện Yên Lập, Tỉnh Phú Thọ","code":"08320","parent_code":"234"},"08323":{"name":"Xã Thượng Long","type":"xa","slug":"xa-thuong-long","name_with_type":"Xã Thượng Long","path":"Xã Thượng Long, Huyện Yên Lập, Tỉnh Phú Thọ","path_with_type":"Xã Thượng Long, Huyện Yên Lập, Tỉnh Phú Thọ","code":"08323","parent_code":"234"},"08326":{"name":"Xã Đồng Thịnh","type":"xa","slug":"xa-dong-thinh","name_with_type":"Xã Đồng Thịnh","path":"Xã Đồng Thịnh, Huyện Yên Lập, Tỉnh Phú Thọ","path_with_type":"Xã Đồng Thịnh, Huyện Yên Lập, Tỉnh Phú Thọ","code":"08326","parent_code":"234"},"08329":{"name":"Xã Phúc Khánh","type":"xa","slug":"xa-phuc-khanh","name_with_type":"Xã Phúc Khánh","path":"Xã Phúc Khánh, Huyện Yên Lập, Tỉnh Phú Thọ","path_with_type":"Xã Phúc Khánh, Huyện Yên Lập, Tỉnh Phú Thọ","code":"08329","parent_code":"234"},"08332":{"name":"Xã Minh Hòa","type":"xa","slug":"xa-minh-hoa","name_with_type":"Xã Minh Hòa","path":"Xã Minh Hòa, Huyện Yên Lập, Tỉnh Phú Thọ","path_with_type":"Xã Minh Hòa, Huyện Yên Lập, Tỉnh Phú Thọ","code":"08332","parent_code":"234"},"08335":{"name":"Xã Ngọc Lập","type":"xa","slug":"xa-ngoc-lap","name_with_type":"Xã Ngọc Lập","path":"Xã Ngọc Lập, Huyện Yên Lập, Tỉnh Phú Thọ","path_with_type":"Xã Ngọc Lập, Huyện Yên Lập, Tỉnh Phú Thọ","code":"08335","parent_code":"234"},"08338":{"name":"Xã Ngọc Đồng","type":"xa","slug":"xa-ngoc-dong","name_with_type":"Xã Ngọc Đồng","path":"Xã Ngọc Đồng, Huyện Yên Lập, Tỉnh Phú Thọ","path_with_type":"Xã Ngọc Đồng, Huyện Yên Lập, Tỉnh Phú Thọ","code":"08338","parent_code":"234"},"08341":{"name":"Thị trấn Cẩm Khê","type":"thi-tran","slug":"thi-tran-cam-khe","name_with_type":"Thị trấn Cẩm Khê","path":"Thị trấn Cẩm Khê, Huyện Cẩm Khê, Tỉnh Phú Thọ","path_with_type":"Thị trấn Cẩm Khê, Huyện Cẩm Khê, Tỉnh Phú Thọ","code":"08341","parent_code":"235"},"08344":{"name":"Xã Tiên Lương","type":"xa","slug":"xa-tien-luong","name_with_type":"Xã Tiên Lương","path":"Xã Tiên Lương, Huyện Cẩm Khê, Tỉnh Phú Thọ","path_with_type":"Xã Tiên Lương, Huyện Cẩm Khê, Tỉnh Phú Thọ","code":"08344","parent_code":"235"},"08350":{"name":"Xã Minh Thắng","type":"xa","slug":"xa-minh-thang","name_with_type":"Xã Minh Thắng","path":"Xã Minh Thắng, Huyện Cẩm Khê, Tỉnh Phú Thọ","path_with_type":"Xã Minh Thắng, Huyện Cẩm Khê, Tỉnh Phú Thọ","code":"08350","parent_code":"235"},"08353":{"name":"Xã Minh Tân","type":"xa","slug":"xa-minh-tan","name_with_type":"Xã Minh Tân","path":"Xã Minh Tân, Huyện Cẩm Khê, Tỉnh Phú Thọ","path_with_type":"Xã Minh Tân, Huyện Cẩm Khê, Tỉnh Phú Thọ","code":"08353","parent_code":"235"},"08356":{"name":"Xã Phượng Vĩ","type":"xa","slug":"xa-phuong-vi","name_with_type":"Xã Phượng Vĩ","path":"Xã Phượng Vĩ, Huyện Cẩm Khê, Tỉnh Phú Thọ","path_with_type":"Xã Phượng Vĩ, Huyện Cẩm Khê, Tỉnh Phú Thọ","code":"08356","parent_code":"235"},"08374":{"name":"Xã Tùng Khê","type":"xa","slug":"xa-tung-khe","name_with_type":"Xã Tùng Khê","path":"Xã Tùng Khê, Huyện Cẩm Khê, Tỉnh Phú Thọ","path_with_type":"Xã Tùng Khê, Huyện Cẩm Khê, Tỉnh Phú Thọ","code":"08374","parent_code":"235"},"08377":{"name":"Xã Tam Sơn","type":"xa","slug":"xa-tam-son","name_with_type":"Xã Tam Sơn","path":"Xã Tam Sơn, Huyện Cẩm Khê, Tỉnh Phú Thọ","path_with_type":"Xã Tam Sơn, Huyện Cẩm Khê, Tỉnh Phú Thọ","code":"08377","parent_code":"235"},"08380":{"name":"Xã Văn Bán","type":"xa","slug":"xa-van-ban","name_with_type":"Xã Văn Bán","path":"Xã Văn Bán, Huyện Cẩm Khê, Tỉnh Phú Thọ","path_with_type":"Xã Văn Bán, Huyện Cẩm Khê, Tỉnh Phú Thọ","code":"08380","parent_code":"235"},"08389":{"name":"Xã Phong Thịnh","type":"xa","slug":"xa-phong-thinh","name_with_type":"Xã Phong Thịnh","path":"Xã Phong Thịnh, Huyện Cẩm Khê, Tỉnh Phú Thọ","path_with_type":"Xã Phong Thịnh, Huyện Cẩm Khê, Tỉnh Phú Thọ","code":"08389","parent_code":"235"},"08398":{"name":"Xã Phú Khê","type":"xa","slug":"xa-phu-khe","name_with_type":"Xã Phú Khê","path":"Xã Phú Khê, Huyện Cẩm Khê, Tỉnh Phú Thọ","path_with_type":"Xã Phú Khê, Huyện Cẩm Khê, Tỉnh Phú Thọ","code":"08398","parent_code":"235"},"08401":{"name":"Xã Hương Lung","type":"xa","slug":"xa-huong-lung","name_with_type":"Xã Hương Lung","path":"Xã Hương Lung, Huyện Cẩm Khê, Tỉnh Phú Thọ","path_with_type":"Xã Hương Lung, Huyện Cẩm Khê, Tỉnh Phú Thọ","code":"08401","parent_code":"235"},"08413":{"name":"Xã Nhật Tiến","type":"xa","slug":"xa-nhat-tien","name_with_type":"Xã Nhật Tiến","path":"Xã Nhật Tiến, Huyện Cẩm Khê, Tỉnh Phú Thọ","path_with_type":"Xã Nhật Tiến, Huyện Cẩm Khê, Tỉnh Phú Thọ","code":"08413","parent_code":"235"},"08416":{"name":"Xã Hùng Việt","type":"xa","slug":"xa-hung-viet","name_with_type":"Xã Hùng Việt","path":"Xã Hùng Việt, Huyện Cẩm Khê, Tỉnh Phú Thọ","path_with_type":"Xã Hùng Việt, Huyện Cẩm Khê, Tỉnh Phú Thọ","code":"08416","parent_code":"235"},"08422":{"name":"Xã Yên Dưỡng","type":"xa","slug":"xa-yen-duong","name_with_type":"Xã Yên Dưỡng","path":"Xã Yên Dưỡng, Huyện Cẩm Khê, Tỉnh Phú Thọ","path_with_type":"Xã Yên Dưỡng, Huyện Cẩm Khê, Tỉnh Phú Thọ","code":"08422","parent_code":"235"},"08428":{"name":"Xã Điêu Lương","type":"xa","slug":"xa-dieu-luong","name_with_type":"Xã Điêu Lương","path":"Xã Điêu Lương, Huyện Cẩm Khê, Tỉnh Phú Thọ","path_with_type":"Xã Điêu Lương, Huyện Cẩm Khê, Tỉnh Phú Thọ","code":"08428","parent_code":"235"},"08431":{"name":"Xã Đồng Lương","type":"xa","slug":"xa-dong-luong","name_with_type":"Xã Đồng Lương","path":"Xã Đồng Lương, Huyện Cẩm Khê, Tỉnh Phú Thọ","path_with_type":"Xã Đồng Lương, Huyện Cẩm Khê, Tỉnh Phú Thọ","code":"08431","parent_code":"235"},"08434":{"name":"Thị trấn Hưng Hoá","type":"thi-tran","slug":"thi-tran-hung-hoa","name_with_type":"Thị trấn Hưng Hoá","path":"Thị trấn Hưng Hoá, Huyện Tam Nông, Tỉnh Phú Thọ","path_with_type":"Thị trấn Hưng Hoá, Huyện Tam Nông, Tỉnh Phú Thọ","code":"08434","parent_code":"236"},"08440":{"name":"Xã Hiền Quan","type":"xa","slug":"xa-hien-quan","name_with_type":"Xã Hiền Quan","path":"Xã Hiền Quan, Huyện Tam Nông, Tỉnh Phú Thọ","path_with_type":"Xã Hiền Quan, Huyện Tam Nông, Tỉnh Phú Thọ","code":"08440","parent_code":"236"},"08443":{"name":"Xã Bắc Sơn","type":"xa","slug":"xa-bac-son","name_with_type":"Xã Bắc Sơn","path":"Xã Bắc Sơn, Huyện Tam Nông, Tỉnh Phú Thọ","path_with_type":"Xã Bắc Sơn, Huyện Tam Nông, Tỉnh Phú Thọ","code":"08443","parent_code":"236"},"08446":{"name":"Xã Thanh Uyên","type":"xa","slug":"xa-thanh-uyen","name_with_type":"Xã Thanh Uyên","path":"Xã Thanh Uyên, Huyện Tam Nông, Tỉnh Phú Thọ","path_with_type":"Xã Thanh Uyên, Huyện Tam Nông, Tỉnh Phú Thọ","code":"08446","parent_code":"236"},"08461":{"name":"Xã Lam Sơn","type":"xa","slug":"xa-lam-son","name_with_type":"Xã Lam Sơn","path":"Xã Lam Sơn, Huyện Tam Nông, Tỉnh Phú Thọ","path_with_type":"Xã Lam Sơn, Huyện Tam Nông, Tỉnh Phú Thọ","code":"08461","parent_code":"236"},"08467":{"name":"Xã Vạn Xuân","type":"xa","slug":"xa-van-xuan","name_with_type":"Xã Vạn Xuân","path":"Xã Vạn Xuân, Huyện Tam Nông, Tỉnh Phú Thọ","path_with_type":"Xã Vạn Xuân, Huyện Tam Nông, Tỉnh Phú Thọ","code":"08467","parent_code":"236"},"08470":{"name":"Xã Quang Húc","type":"xa","slug":"xa-quang-huc","name_with_type":"Xã Quang Húc","path":"Xã Quang Húc, Huyện Tam Nông, Tỉnh Phú Thọ","path_with_type":"Xã Quang Húc, Huyện Tam Nông, Tỉnh Phú Thọ","code":"08470","parent_code":"236"},"08473":{"name":"Xã Hương Nộn","type":"xa","slug":"xa-huong-non","name_with_type":"Xã Hương Nộn","path":"Xã Hương Nộn, Huyện Tam Nông, Tỉnh Phú Thọ","path_with_type":"Xã Hương Nộn, Huyện Tam Nông, Tỉnh Phú Thọ","code":"08473","parent_code":"236"},"08476":{"name":"Xã Tề Lễ","type":"xa","slug":"xa-te-le","name_with_type":"Xã Tề Lễ","path":"Xã Tề Lễ, Huyện Tam Nông, Tỉnh Phú Thọ","path_with_type":"Xã Tề Lễ, Huyện Tam Nông, Tỉnh Phú Thọ","code":"08476","parent_code":"236"},"08479":{"name":"Xã Thọ Văn","type":"xa","slug":"xa-tho-van","name_with_type":"Xã Thọ Văn","path":"Xã Thọ Văn, Huyện Tam Nông, Tỉnh Phú Thọ","path_with_type":"Xã Thọ Văn, Huyện Tam Nông, Tỉnh Phú Thọ","code":"08479","parent_code":"236"},"08482":{"name":"Xã Dị Nậu","type":"xa","slug":"xa-di-nau","name_with_type":"Xã Dị Nậu","path":"Xã Dị Nậu, Huyện Tam Nông, Tỉnh Phú Thọ","path_with_type":"Xã Dị Nậu, Huyện Tam Nông, Tỉnh Phú Thọ","code":"08482","parent_code":"236"},"08491":{"name":"Xã Dân Quyền","type":"xa","slug":"xa-dan-quyen","name_with_type":"Xã Dân Quyền","path":"Xã Dân Quyền, Huyện Tam Nông, Tỉnh Phú Thọ","path_with_type":"Xã Dân Quyền, Huyện Tam Nông, Tỉnh Phú Thọ","code":"08491","parent_code":"236"},"08494":{"name":"Thị trấn Lâm Thao","type":"thi-tran","slug":"thi-tran-lam-thao","name_with_type":"Thị trấn Lâm Thao","path":"Thị trấn Lâm Thao, Huyện Lâm Thao, Tỉnh Phú Thọ","path_with_type":"Thị trấn Lâm Thao, Huyện Lâm Thao, Tỉnh Phú Thọ","code":"08494","parent_code":"237"},"08497":{"name":"Xã Tiên Kiên","type":"xa","slug":"xa-tien-kien","name_with_type":"Xã Tiên Kiên","path":"Xã Tiên Kiên, Huyện Lâm Thao, Tỉnh Phú Thọ","path_with_type":"Xã Tiên Kiên, Huyện Lâm Thao, Tỉnh Phú Thọ","code":"08497","parent_code":"237"},"08498":{"name":"Thị trấn Hùng Sơn","type":"thi-tran","slug":"thi-tran-hung-son","name_with_type":"Thị trấn Hùng Sơn","path":"Thị trấn Hùng Sơn, Huyện Lâm Thao, Tỉnh Phú Thọ","path_with_type":"Thị trấn Hùng Sơn, Huyện Lâm Thao, Tỉnh Phú Thọ","code":"08498","parent_code":"237"},"08500":{"name":"Xã Xuân Lũng","type":"xa","slug":"xa-xuan-lung","name_with_type":"Xã Xuân Lũng","path":"Xã Xuân Lũng, Huyện Lâm Thao, Tỉnh Phú Thọ","path_with_type":"Xã Xuân Lũng, Huyện Lâm Thao, Tỉnh Phú Thọ","code":"08500","parent_code":"237"},"08509":{"name":"Xã Xuân Huy","type":"xa","slug":"xa-xuan-huy","name_with_type":"Xã Xuân Huy","path":"Xã Xuân Huy, Huyện Lâm Thao, Tỉnh Phú Thọ","path_with_type":"Xã Xuân Huy, Huyện Lâm Thao, Tỉnh Phú Thọ","code":"08509","parent_code":"237"},"08512":{"name":"Xã Thạch Sơn","type":"xa","slug":"xa-thach-son","name_with_type":"Xã Thạch Sơn","path":"Xã Thạch Sơn, Huyện Lâm Thao, Tỉnh Phú Thọ","path_with_type":"Xã Thạch Sơn, Huyện Lâm Thao, Tỉnh Phú Thọ","code":"08512","parent_code":"237"},"08518":{"name":"Xã Sơn Vi","type":"xa","slug":"xa-son-vi","name_with_type":"Xã Sơn Vi","path":"Xã Sơn Vi, Huyện Lâm Thao, Tỉnh Phú Thọ","path_with_type":"Xã Sơn Vi, Huyện Lâm Thao, Tỉnh Phú Thọ","code":"08518","parent_code":"237"},"08521":{"name":"Xã Phùng Nguyên","type":"xa","slug":"xa-phung-nguyen","name_with_type":"Xã Phùng Nguyên","path":"Xã Phùng Nguyên, Huyện Lâm Thao, Tỉnh Phú Thọ","path_with_type":"Xã Phùng Nguyên, Huyện Lâm Thao, Tỉnh Phú Thọ","code":"08521","parent_code":"237"},"08527":{"name":"Xã Cao Xá","type":"xa","slug":"xa-cao-xa","name_with_type":"Xã Cao Xá","path":"Xã Cao Xá, Huyện Lâm Thao, Tỉnh Phú Thọ","path_with_type":"Xã Cao Xá, Huyện Lâm Thao, Tỉnh Phú Thọ","code":"08527","parent_code":"237"},"08533":{"name":"Xã Vĩnh Lại","type":"xa","slug":"xa-vinh-lai","name_with_type":"Xã Vĩnh Lại","path":"Xã Vĩnh Lại, Huyện Lâm Thao, Tỉnh Phú Thọ","path_with_type":"Xã Vĩnh Lại, Huyện Lâm Thao, Tỉnh Phú Thọ","code":"08533","parent_code":"237"},"08536":{"name":"Xã Tứ Xã","type":"xa","slug":"xa-tu-xa","name_with_type":"Xã Tứ Xã","path":"Xã Tứ Xã, Huyện Lâm Thao, Tỉnh Phú Thọ","path_with_type":"Xã Tứ Xã, Huyện Lâm Thao, Tỉnh Phú Thọ","code":"08536","parent_code":"237"},"08539":{"name":"Xã Bản Nguyên","type":"xa","slug":"xa-ban-nguyen","name_with_type":"Xã Bản Nguyên","path":"Xã Bản Nguyên, Huyện Lâm Thao, Tỉnh Phú Thọ","path_with_type":"Xã Bản Nguyên, Huyện Lâm Thao, Tỉnh Phú Thọ","code":"08539","parent_code":"237"},"08542":{"name":"Thị trấn Thanh Sơn","type":"thi-tran","slug":"thi-tran-thanh-son","name_with_type":"Thị trấn Thanh Sơn","path":"Thị trấn Thanh Sơn, Huyện Thanh Sơn, Tỉnh Phú Thọ","path_with_type":"Thị trấn Thanh Sơn, Huyện Thanh Sơn, Tỉnh Phú Thọ","code":"08542","parent_code":"238"},"08563":{"name":"Xã Sơn Hùng","type":"xa","slug":"xa-son-hung","name_with_type":"Xã Sơn Hùng","path":"Xã Sơn Hùng, Huyện Thanh Sơn, Tỉnh Phú Thọ","path_with_type":"Xã Sơn Hùng, Huyện Thanh Sơn, Tỉnh Phú Thọ","code":"08563","parent_code":"238"},"08572":{"name":"Xã Địch Quả","type":"xa","slug":"xa-dich-qua","name_with_type":"Xã Địch Quả","path":"Xã Địch Quả, Huyện Thanh Sơn, Tỉnh Phú Thọ","path_with_type":"Xã Địch Quả, Huyện Thanh Sơn, Tỉnh Phú Thọ","code":"08572","parent_code":"238"},"08575":{"name":"Xã Giáp Lai","type":"xa","slug":"xa-giap-lai","name_with_type":"Xã Giáp Lai","path":"Xã Giáp Lai, Huyện Thanh Sơn, Tỉnh Phú Thọ","path_with_type":"Xã Giáp Lai, Huyện Thanh Sơn, Tỉnh Phú Thọ","code":"08575","parent_code":"238"},"08581":{"name":"Xã Thục Luyện","type":"xa","slug":"xa-thuc-luyen","name_with_type":"Xã Thục Luyện","path":"Xã Thục Luyện, Huyện Thanh Sơn, Tỉnh Phú Thọ","path_with_type":"Xã Thục Luyện, Huyện Thanh Sơn, Tỉnh Phú Thọ","code":"08581","parent_code":"238"},"08584":{"name":"Xã Võ Miếu","type":"xa","slug":"xa-vo-mieu","name_with_type":"Xã Võ Miếu","path":"Xã Võ Miếu, Huyện Thanh Sơn, Tỉnh Phú Thọ","path_with_type":"Xã Võ Miếu, Huyện Thanh Sơn, Tỉnh Phú Thọ","code":"08584","parent_code":"238"},"08587":{"name":"Xã Thạch Khoán","type":"xa","slug":"xa-thach-khoan","name_with_type":"Xã Thạch Khoán","path":"Xã Thạch Khoán, Huyện Thanh Sơn, Tỉnh Phú Thọ","path_with_type":"Xã Thạch Khoán, Huyện Thanh Sơn, Tỉnh Phú Thọ","code":"08587","parent_code":"238"},"08602":{"name":"Xã Cự Thắng","type":"xa","slug":"xa-cu-thang","name_with_type":"Xã Cự Thắng","path":"Xã Cự Thắng, Huyện Thanh Sơn, Tỉnh Phú Thọ","path_with_type":"Xã Cự Thắng, Huyện Thanh Sơn, Tỉnh Phú Thọ","code":"08602","parent_code":"238"},"08605":{"name":"Xã Tất Thắng","type":"xa","slug":"xa-tat-thang","name_with_type":"Xã Tất Thắng","path":"Xã Tất Thắng, Huyện Thanh Sơn, Tỉnh Phú Thọ","path_with_type":"Xã Tất Thắng, Huyện Thanh Sơn, Tỉnh Phú Thọ","code":"08605","parent_code":"238"},"08611":{"name":"Xã Văn Miếu","type":"xa","slug":"xa-van-mieu","name_with_type":"Xã Văn Miếu","path":"Xã Văn Miếu, Huyện Thanh Sơn, Tỉnh Phú Thọ","path_with_type":"Xã Văn Miếu, Huyện Thanh Sơn, Tỉnh Phú Thọ","code":"08611","parent_code":"238"},"08614":{"name":"Xã Cự Đồng","type":"xa","slug":"xa-cu-dong","name_with_type":"Xã Cự Đồng","path":"Xã Cự Đồng, Huyện Thanh Sơn, Tỉnh Phú Thọ","path_with_type":"Xã Cự Đồng, Huyện Thanh Sơn, Tỉnh Phú Thọ","code":"08614","parent_code":"238"},"08623":{"name":"Xã Thắng Sơn","type":"xa","slug":"xa-thang-son","name_with_type":"Xã Thắng Sơn","path":"Xã Thắng Sơn, Huyện Thanh Sơn, Tỉnh Phú Thọ","path_with_type":"Xã Thắng Sơn, Huyện Thanh Sơn, Tỉnh Phú Thọ","code":"08623","parent_code":"238"},"08629":{"name":"Xã Tân Minh","type":"xa","slug":"xa-tan-minh","name_with_type":"Xã Tân Minh","path":"Xã Tân Minh, Huyện Thanh Sơn, Tỉnh Phú Thọ","path_with_type":"Xã Tân Minh, Huyện Thanh Sơn, Tỉnh Phú Thọ","code":"08629","parent_code":"238"},"08632":{"name":"Xã Hương Cần","type":"xa","slug":"xa-huong-can","name_with_type":"Xã Hương Cần","path":"Xã Hương Cần, Huyện Thanh Sơn, Tỉnh Phú Thọ","path_with_type":"Xã Hương Cần, Huyện Thanh Sơn, Tỉnh Phú Thọ","code":"08632","parent_code":"238"},"08635":{"name":"Xã Khả Cửu","type":"xa","slug":"xa-kha-cuu","name_with_type":"Xã Khả Cửu","path":"Xã Khả Cửu, Huyện Thanh Sơn, Tỉnh Phú Thọ","path_with_type":"Xã Khả Cửu, Huyện Thanh Sơn, Tỉnh Phú Thọ","code":"08635","parent_code":"238"},"08638":{"name":"Xã Đông Cửu","type":"xa","slug":"xa-dong-cuu","name_with_type":"Xã Đông Cửu","path":"Xã Đông Cửu, Huyện Thanh Sơn, Tỉnh Phú Thọ","path_with_type":"Xã Đông Cửu, Huyện Thanh Sơn, Tỉnh Phú Thọ","code":"08638","parent_code":"238"},"08641":{"name":"Xã Tân Lập","type":"xa","slug":"xa-tan-lap","name_with_type":"Xã Tân Lập","path":"Xã Tân Lập, Huyện Thanh Sơn, Tỉnh Phú Thọ","path_with_type":"Xã Tân Lập, Huyện Thanh Sơn, Tỉnh Phú Thọ","code":"08641","parent_code":"238"},"08644":{"name":"Xã Yên Lãng","type":"xa","slug":"xa-yen-lang","name_with_type":"Xã Yên Lãng","path":"Xã Yên Lãng, Huyện Thanh Sơn, Tỉnh Phú Thọ","path_with_type":"Xã Yên Lãng, Huyện Thanh Sơn, Tỉnh Phú Thọ","code":"08644","parent_code":"238"},"08647":{"name":"Xã Yên Lương","type":"xa","slug":"xa-yen-luong","name_with_type":"Xã Yên Lương","path":"Xã Yên Lương, Huyện Thanh Sơn, Tỉnh Phú Thọ","path_with_type":"Xã Yên Lương, Huyện Thanh Sơn, Tỉnh Phú Thọ","code":"08647","parent_code":"238"},"08650":{"name":"Xã Thượng Cửu","type":"xa","slug":"xa-thuong-cuu","name_with_type":"Xã Thượng Cửu","path":"Xã Thượng Cửu, Huyện Thanh Sơn, Tỉnh Phú Thọ","path_with_type":"Xã Thượng Cửu, Huyện Thanh Sơn, Tỉnh Phú Thọ","code":"08650","parent_code":"238"},"08653":{"name":"Xã Lương Nha","type":"xa","slug":"xa-luong-nha","name_with_type":"Xã Lương Nha","path":"Xã Lương Nha, Huyện Thanh Sơn, Tỉnh Phú Thọ","path_with_type":"Xã Lương Nha, Huyện Thanh Sơn, Tỉnh Phú Thọ","code":"08653","parent_code":"238"},"08656":{"name":"Xã Yên Sơn","type":"xa","slug":"xa-yen-son","name_with_type":"Xã Yên Sơn","path":"Xã Yên Sơn, Huyện Thanh Sơn, Tỉnh Phú Thọ","path_with_type":"Xã Yên Sơn, Huyện Thanh Sơn, Tỉnh Phú Thọ","code":"08656","parent_code":"238"},"08659":{"name":"Xã Tinh Nhuệ","type":"xa","slug":"xa-tinh-nhue","name_with_type":"Xã Tinh Nhuệ","path":"Xã Tinh Nhuệ, Huyện Thanh Sơn, Tỉnh Phú Thọ","path_with_type":"Xã Tinh Nhuệ, Huyện Thanh Sơn, Tỉnh Phú Thọ","code":"08659","parent_code":"238"},"08662":{"name":"Xã Đào Xá","type":"xa","slug":"xa-dao-xa","name_with_type":"Xã Đào Xá","path":"Xã Đào Xá, Huyện Thanh Thuỷ, Tỉnh Phú Thọ","path_with_type":"Xã Đào Xá, Huyện Thanh Thuỷ, Tỉnh Phú Thọ","code":"08662","parent_code":"239"},"08665":{"name":"Xã Thạch Đồng","type":"xa","slug":"xa-thach-dong","name_with_type":"Xã Thạch Đồng","path":"Xã Thạch Đồng, Huyện Thanh Thuỷ, Tỉnh Phú Thọ","path_with_type":"Xã Thạch Đồng, Huyện Thanh Thuỷ, Tỉnh Phú Thọ","code":"08665","parent_code":"239"},"08668":{"name":"Xã Xuân Lộc","type":"xa","slug":"xa-xuan-loc","name_with_type":"Xã Xuân Lộc","path":"Xã Xuân Lộc, Huyện Thanh Thuỷ, Tỉnh Phú Thọ","path_with_type":"Xã Xuân Lộc, Huyện Thanh Thuỷ, Tỉnh Phú Thọ","code":"08668","parent_code":"239"},"08671":{"name":"Xã Tân Phương","type":"xa","slug":"xa-tan-phuong","name_with_type":"Xã Tân Phương","path":"Xã Tân Phương, Huyện Thanh Thuỷ, Tỉnh Phú Thọ","path_with_type":"Xã Tân Phương, Huyện Thanh Thuỷ, Tỉnh Phú Thọ","code":"08671","parent_code":"239"},"08674":{"name":"Thị trấn Thanh Thủy","type":"thi-tran","slug":"thi-tran-thanh-thuy","name_with_type":"Thị trấn Thanh Thủy","path":"Thị trấn Thanh Thủy, Huyện Thanh Thuỷ, Tỉnh Phú Thọ","path_with_type":"Thị trấn Thanh Thủy, Huyện Thanh Thuỷ, Tỉnh Phú Thọ","code":"08674","parent_code":"239"},"08677":{"name":"Xã Sơn Thủy","type":"xa","slug":"xa-son-thuy","name_with_type":"Xã Sơn Thủy","path":"Xã Sơn Thủy, Huyện Thanh Thuỷ, Tỉnh Phú Thọ","path_with_type":"Xã Sơn Thủy, Huyện Thanh Thuỷ, Tỉnh Phú Thọ","code":"08677","parent_code":"239"},"08680":{"name":"Xã Bảo Yên","type":"xa","slug":"xa-bao-yen","name_with_type":"Xã Bảo Yên","path":"Xã Bảo Yên, Huyện Thanh Thuỷ, Tỉnh Phú Thọ","path_with_type":"Xã Bảo Yên, Huyện Thanh Thuỷ, Tỉnh Phú Thọ","code":"08680","parent_code":"239"},"08683":{"name":"Xã Đoan Hạ","type":"xa","slug":"xa-doan-ha","name_with_type":"Xã Đoan Hạ","path":"Xã Đoan Hạ, Huyện Thanh Thuỷ, Tỉnh Phú Thọ","path_with_type":"Xã Đoan Hạ, Huyện Thanh Thuỷ, Tỉnh Phú Thọ","code":"08683","parent_code":"239"},"08686":{"name":"Xã Đồng Trung","type":"xa","slug":"xa-dong-trung","name_with_type":"Xã Đồng Trung","path":"Xã Đồng Trung, Huyện Thanh Thuỷ, Tỉnh Phú Thọ","path_with_type":"Xã Đồng Trung, Huyện Thanh Thuỷ, Tỉnh Phú Thọ","code":"08686","parent_code":"239"},"08689":{"name":"Xã Hoàng Xá","type":"xa","slug":"xa-hoang-xa","name_with_type":"Xã Hoàng Xá","path":"Xã Hoàng Xá, Huyện Thanh Thuỷ, Tỉnh Phú Thọ","path_with_type":"Xã Hoàng Xá, Huyện Thanh Thuỷ, Tỉnh Phú Thọ","code":"08689","parent_code":"239"},"08701":{"name":"Xã Tu Vũ","type":"xa","slug":"xa-tu-vu","name_with_type":"Xã Tu Vũ","path":"Xã Tu Vũ, Huyện Thanh Thuỷ, Tỉnh Phú Thọ","path_with_type":"Xã Tu Vũ, Huyện Thanh Thuỷ, Tỉnh Phú Thọ","code":"08701","parent_code":"239"},"08545":{"name":"Xã Thu Cúc","type":"xa","slug":"xa-thu-cuc","name_with_type":"Xã Thu Cúc","path":"Xã Thu Cúc, Huyện Tân Sơn, Tỉnh Phú Thọ","path_with_type":"Xã Thu Cúc, Huyện Tân Sơn, Tỉnh Phú Thọ","code":"08545","parent_code":"240"},"08548":{"name":"Xã Thạch Kiệt","type":"xa","slug":"xa-thach-kiet","name_with_type":"Xã Thạch Kiệt","path":"Xã Thạch Kiệt, Huyện Tân Sơn, Tỉnh Phú Thọ","path_with_type":"Xã Thạch Kiệt, Huyện Tân Sơn, Tỉnh Phú Thọ","code":"08548","parent_code":"240"},"08551":{"name":"Xã Thu Ngạc","type":"xa","slug":"xa-thu-ngac","name_with_type":"Xã Thu Ngạc","path":"Xã Thu Ngạc, Huyện Tân Sơn, Tỉnh Phú Thọ","path_with_type":"Xã Thu Ngạc, Huyện Tân Sơn, Tỉnh Phú Thọ","code":"08551","parent_code":"240"},"08554":{"name":"Xã Kiệt Sơn","type":"xa","slug":"xa-kiet-son","name_with_type":"Xã Kiệt Sơn","path":"Xã Kiệt Sơn, Huyện Tân Sơn, Tỉnh Phú Thọ","path_with_type":"Xã Kiệt Sơn, Huyện Tân Sơn, Tỉnh Phú Thọ","code":"08554","parent_code":"240"},"08557":{"name":"Xã Đồng Sơn","type":"xa","slug":"xa-dong-son","name_with_type":"Xã Đồng Sơn","path":"Xã Đồng Sơn, Huyện Tân Sơn, Tỉnh Phú Thọ","path_with_type":"Xã Đồng Sơn, Huyện Tân Sơn, Tỉnh Phú Thọ","code":"08557","parent_code":"240"},"08560":{"name":"Xã Lai Đồng","type":"xa","slug":"xa-lai-dong","name_with_type":"Xã Lai Đồng","path":"Xã Lai Đồng, Huyện Tân Sơn, Tỉnh Phú Thọ","path_with_type":"Xã Lai Đồng, Huyện Tân Sơn, Tỉnh Phú Thọ","code":"08560","parent_code":"240"},"08566":{"name":"Thị trấn Tân Phú","type":"thi-tran","slug":"thi-tran-tan-phu","name_with_type":"Thị trấn Tân Phú","path":"Thị trấn Tân Phú, Huyện Tân Sơn, Tỉnh Phú Thọ","path_with_type":"Thị trấn Tân Phú, Huyện Tân Sơn, Tỉnh Phú Thọ","code":"08566","parent_code":"240"},"08569":{"name":"Xã Mỹ Thuận","type":"xa","slug":"xa-my-thuan","name_with_type":"Xã Mỹ Thuận","path":"Xã Mỹ Thuận, Huyện Tân Sơn, Tỉnh Phú Thọ","path_with_type":"Xã Mỹ Thuận, Huyện Tân Sơn, Tỉnh Phú Thọ","code":"08569","parent_code":"240"},"08578":{"name":"Xã Tân Sơn","type":"xa","slug":"xa-tan-son","name_with_type":"Xã Tân Sơn","path":"Xã Tân Sơn, Huyện Tân Sơn, Tỉnh Phú Thọ","path_with_type":"Xã Tân Sơn, Huyện Tân Sơn, Tỉnh Phú Thọ","code":"08578","parent_code":"240"},"08590":{"name":"Xã Xuân Đài","type":"xa","slug":"xa-xuan-dai","name_with_type":"Xã Xuân Đài","path":"Xã Xuân Đài, Huyện Tân Sơn, Tỉnh Phú Thọ","path_with_type":"Xã Xuân Đài, Huyện Tân Sơn, Tỉnh Phú Thọ","code":"08590","parent_code":"240"},"08593":{"name":"Xã Minh Đài","type":"xa","slug":"xa-minh-dai","name_with_type":"Xã Minh Đài","path":"Xã Minh Đài, Huyện Tân Sơn, Tỉnh Phú Thọ","path_with_type":"Xã Minh Đài, Huyện Tân Sơn, Tỉnh Phú Thọ","code":"08593","parent_code":"240"},"08596":{"name":"Xã Văn Luông","type":"xa","slug":"xa-van-luong","name_with_type":"Xã Văn Luông","path":"Xã Văn Luông, Huyện Tân Sơn, Tỉnh Phú Thọ","path_with_type":"Xã Văn Luông, Huyện Tân Sơn, Tỉnh Phú Thọ","code":"08596","parent_code":"240"},"08599":{"name":"Xã Xuân Sơn","type":"xa","slug":"xa-xuan-son","name_with_type":"Xã Xuân Sơn","path":"Xã Xuân Sơn, Huyện Tân Sơn, Tỉnh Phú Thọ","path_with_type":"Xã Xuân Sơn, Huyện Tân Sơn, Tỉnh Phú Thọ","code":"08599","parent_code":"240"},"08608":{"name":"Xã Long Cốc","type":"xa","slug":"xa-long-coc","name_with_type":"Xã Long Cốc","path":"Xã Long Cốc, Huyện Tân Sơn, Tỉnh Phú Thọ","path_with_type":"Xã Long Cốc, Huyện Tân Sơn, Tỉnh Phú Thọ","code":"08608","parent_code":"240"},"08617":{"name":"Xã Kim Thượng","type":"xa","slug":"xa-kim-thuong","name_with_type":"Xã Kim Thượng","path":"Xã Kim Thượng, Huyện Tân Sơn, Tỉnh Phú Thọ","path_with_type":"Xã Kim Thượng, Huyện Tân Sơn, Tỉnh Phú Thọ","code":"08617","parent_code":"240"},"08620":{"name":"Xã Tam Thanh","type":"xa","slug":"xa-tam-thanh","name_with_type":"Xã Tam Thanh","path":"Xã Tam Thanh, Huyện Tân Sơn, Tỉnh Phú Thọ","path_with_type":"Xã Tam Thanh, Huyện Tân Sơn, Tỉnh Phú Thọ","code":"08620","parent_code":"240"},"08626":{"name":"Xã Vinh Tiền","type":"xa","slug":"xa-vinh-tien","name_with_type":"Xã Vinh Tiền","path":"Xã Vinh Tiền, Huyện Tân Sơn, Tỉnh Phú Thọ","path_with_type":"Xã Vinh Tiền, Huyện Tân Sơn, Tỉnh Phú Thọ","code":"08626","parent_code":"240"},"08707":{"name":"Phường Tích Sơn","type":"phuong","slug":"phuong-tich-son","name_with_type":"Phường Tích Sơn","path":"Phường Tích Sơn, Thành phố Vĩnh Yên, Tỉnh Vĩnh Phúc","path_with_type":"Phường Tích Sơn, Thành phố Vĩnh Yên, Tỉnh Vĩnh Phúc","code":"08707","parent_code":"243"},"08710":{"name":"Phường Liên Bảo","type":"phuong","slug":"phuong-lien-bao","name_with_type":"Phường Liên Bảo","path":"Phường Liên Bảo, Thành phố Vĩnh Yên, Tỉnh Vĩnh Phúc","path_with_type":"Phường Liên Bảo, Thành phố Vĩnh Yên, Tỉnh Vĩnh Phúc","code":"08710","parent_code":"243"},"08713":{"name":"Phường Hội Hợp","type":"phuong","slug":"phuong-hoi-hop","name_with_type":"Phường Hội Hợp","path":"Phường Hội Hợp, Thành phố Vĩnh Yên, Tỉnh Vĩnh Phúc","path_with_type":"Phường Hội Hợp, Thành phố Vĩnh Yên, Tỉnh Vĩnh Phúc","code":"08713","parent_code":"243"},"08716":{"name":"Phường Đống Đa","type":"phuong","slug":"phuong-dong-da","name_with_type":"Phường Đống Đa","path":"Phường Đống Đa, Thành phố Vĩnh Yên, Tỉnh Vĩnh Phúc","path_with_type":"Phường Đống Đa, Thành phố Vĩnh Yên, Tỉnh Vĩnh Phúc","code":"08716","parent_code":"243"},"08719":{"name":"Phường Ngô Quyền","type":"phuong","slug":"phuong-ngo-quyen","name_with_type":"Phường Ngô Quyền","path":"Phường Ngô Quyền, Thành phố Vĩnh Yên, Tỉnh Vĩnh Phúc","path_with_type":"Phường Ngô Quyền, Thành phố Vĩnh Yên, Tỉnh Vĩnh Phúc","code":"08719","parent_code":"243"},"08722":{"name":"Phường Đồng Tâm","type":"phuong","slug":"phuong-dong-tam","name_with_type":"Phường Đồng Tâm","path":"Phường Đồng Tâm, Thành phố Vĩnh Yên, Tỉnh Vĩnh Phúc","path_with_type":"Phường Đồng Tâm, Thành phố Vĩnh Yên, Tỉnh Vĩnh Phúc","code":"08722","parent_code":"243"},"08725":{"name":"Phường Định Trung","type":"phuong","slug":"phuong-dinh-trung","name_with_type":"Phường Định Trung","path":"Phường Định Trung, Thành phố Vĩnh Yên, Tỉnh Vĩnh Phúc","path_with_type":"Phường Định Trung, Thành phố Vĩnh Yên, Tỉnh Vĩnh Phúc","code":"08725","parent_code":"243"},"08728":{"name":"Phường Khai Quang","type":"phuong","slug":"phuong-khai-quang","name_with_type":"Phường Khai Quang","path":"Phường Khai Quang, Thành phố Vĩnh Yên, Tỉnh Vĩnh Phúc","path_with_type":"Phường Khai Quang, Thành phố Vĩnh Yên, Tỉnh Vĩnh Phúc","code":"08728","parent_code":"243"},"08731":{"name":"Xã Thanh Trù","type":"xa","slug":"xa-thanh-tru","name_with_type":"Xã Thanh Trù","path":"Xã Thanh Trù, Thành phố Vĩnh Yên, Tỉnh Vĩnh Phúc","path_with_type":"Xã Thanh Trù, Thành phố Vĩnh Yên, Tỉnh Vĩnh Phúc","code":"08731","parent_code":"243"},"08737":{"name":"Phường Hùng Vương","type":"phuong","slug":"phuong-hung-vuong","name_with_type":"Phường Hùng Vương","path":"Phường Hùng Vương, Thành phố Phúc Yên, Tỉnh Vĩnh Phúc","path_with_type":"Phường Hùng Vương, Thành phố Phúc Yên, Tỉnh Vĩnh Phúc","code":"08737","parent_code":"244"},"08740":{"name":"Phường Hai Bà Trưng","type":"phuong","slug":"phuong-hai-ba-trung","name_with_type":"Phường Hai Bà Trưng","path":"Phường Hai Bà Trưng, Thành phố Phúc Yên, Tỉnh Vĩnh Phúc","path_with_type":"Phường Hai Bà Trưng, Thành phố Phúc Yên, Tỉnh Vĩnh Phúc","code":"08740","parent_code":"244"},"08743":{"name":"Phường Phúc Thắng","type":"phuong","slug":"phuong-phuc-thang","name_with_type":"Phường Phúc Thắng","path":"Phường Phúc Thắng, Thành phố Phúc Yên, Tỉnh Vĩnh Phúc","path_with_type":"Phường Phúc Thắng, Thành phố Phúc Yên, Tỉnh Vĩnh Phúc","code":"08743","parent_code":"244"},"08746":{"name":"Phường Xuân Hoà","type":"phuong","slug":"phuong-xuan-hoa","name_with_type":"Phường Xuân Hoà","path":"Phường Xuân Hoà, Thành phố Phúc Yên, Tỉnh Vĩnh Phúc","path_with_type":"Phường Xuân Hoà, Thành phố Phúc Yên, Tỉnh Vĩnh Phúc","code":"08746","parent_code":"244"},"08747":{"name":"Phường Đồng Xuân","type":"phuong","slug":"phuong-dong-xuan","name_with_type":"Phường Đồng Xuân","path":"Phường Đồng Xuân, Thành phố Phúc Yên, Tỉnh Vĩnh Phúc","path_with_type":"Phường Đồng Xuân, Thành phố Phúc Yên, Tỉnh Vĩnh Phúc","code":"08747","parent_code":"244"},"08749":{"name":"Xã Ngọc Thanh","type":"xa","slug":"xa-ngoc-thanh","name_with_type":"Xã Ngọc Thanh","path":"Xã Ngọc Thanh, Thành phố Phúc Yên, Tỉnh Vĩnh Phúc","path_with_type":"Xã Ngọc Thanh, Thành phố Phúc Yên, Tỉnh Vĩnh Phúc","code":"08749","parent_code":"244"},"08752":{"name":"Xã Cao Minh","type":"xa","slug":"xa-cao-minh","name_with_type":"Xã Cao Minh","path":"Xã Cao Minh, Thành phố Phúc Yên, Tỉnh Vĩnh Phúc","path_with_type":"Xã Cao Minh, Thành phố Phúc Yên, Tỉnh Vĩnh Phúc","code":"08752","parent_code":"244"},"08755":{"name":"Phường Nam Viêm","type":"phuong","slug":"phuong-nam-viem","name_with_type":"Phường Nam Viêm","path":"Phường Nam Viêm, Thành phố Phúc Yên, Tỉnh Vĩnh Phúc","path_with_type":"Phường Nam Viêm, Thành phố Phúc Yên, Tỉnh Vĩnh Phúc","code":"08755","parent_code":"244"},"08758":{"name":"Phường Tiền Châu","type":"phuong","slug":"phuong-tien-chau","name_with_type":"Phường Tiền Châu","path":"Phường Tiền Châu, Thành phố Phúc Yên, Tỉnh Vĩnh Phúc","path_with_type":"Phường Tiền Châu, Thành phố Phúc Yên, Tỉnh Vĩnh Phúc","code":"08758","parent_code":"244"},"08761":{"name":"Thị trấn Lập Thạch","type":"thi-tran","slug":"thi-tran-lap-thach","name_with_type":"Thị trấn Lập Thạch","path":"Thị trấn Lập Thạch, Huyện Lập Thạch, Tỉnh Vĩnh Phúc","path_with_type":"Thị trấn Lập Thạch, Huyện Lập Thạch, Tỉnh Vĩnh Phúc","code":"08761","parent_code":"246"},"08764":{"name":"Xã Quang Sơn","type":"xa","slug":"xa-quang-son","name_with_type":"Xã Quang Sơn","path":"Xã Quang Sơn, Huyện Lập Thạch, Tỉnh Vĩnh Phúc","path_with_type":"Xã Quang Sơn, Huyện Lập Thạch, Tỉnh Vĩnh Phúc","code":"08764","parent_code":"246"},"08767":{"name":"Xã Ngọc Mỹ","type":"xa","slug":"xa-ngoc-my","name_with_type":"Xã Ngọc Mỹ","path":"Xã Ngọc Mỹ, Huyện Lập Thạch, Tỉnh Vĩnh Phúc","path_with_type":"Xã Ngọc Mỹ, Huyện Lập Thạch, Tỉnh Vĩnh Phúc","code":"08767","parent_code":"246"},"08770":{"name":"Xã Hợp Lý","type":"xa","slug":"xa-hop-ly","name_with_type":"Xã Hợp Lý","path":"Xã Hợp Lý, Huyện Lập Thạch, Tỉnh Vĩnh Phúc","path_with_type":"Xã Hợp Lý, Huyện Lập Thạch, Tỉnh Vĩnh Phúc","code":"08770","parent_code":"246"},"08785":{"name":"Xã Bắc Bình","type":"xa","slug":"xa-bac-binh","name_with_type":"Xã Bắc Bình","path":"Xã Bắc Bình, Huyện Lập Thạch, Tỉnh Vĩnh Phúc","path_with_type":"Xã Bắc Bình, Huyện Lập Thạch, Tỉnh Vĩnh Phúc","code":"08785","parent_code":"246"},"08788":{"name":"Xã Thái Hòa","type":"xa","slug":"xa-thai-hoa","name_with_type":"Xã Thái Hòa","path":"Xã Thái Hòa, Huyện Lập Thạch, Tỉnh Vĩnh Phúc","path_with_type":"Xã Thái Hòa, Huyện Lập Thạch, Tỉnh Vĩnh Phúc","code":"08788","parent_code":"246"},"08789":{"name":"Thị trấn Hoa Sơn","type":"thi-tran","slug":"thi-tran-hoa-son","name_with_type":"Thị trấn Hoa Sơn","path":"Thị trấn Hoa Sơn, Huyện Lập Thạch, Tỉnh Vĩnh Phúc","path_with_type":"Thị trấn Hoa Sơn, Huyện Lập Thạch, Tỉnh Vĩnh Phúc","code":"08789","parent_code":"246"},"08791":{"name":"Xã Liễn Sơn","type":"xa","slug":"xa-lien-son","name_with_type":"Xã Liễn Sơn","path":"Xã Liễn Sơn, Huyện Lập Thạch, Tỉnh Vĩnh Phúc","path_with_type":"Xã Liễn Sơn, Huyện Lập Thạch, Tỉnh Vĩnh Phúc","code":"08791","parent_code":"246"},"08794":{"name":"Xã Xuân Hòa","type":"xa","slug":"xa-xuan-hoa","name_with_type":"Xã Xuân Hòa","path":"Xã Xuân Hòa, Huyện Lập Thạch, Tỉnh Vĩnh Phúc","path_with_type":"Xã Xuân Hòa, Huyện Lập Thạch, Tỉnh Vĩnh Phúc","code":"08794","parent_code":"246"},"08797":{"name":"Xã Vân Trục","type":"xa","slug":"xa-van-truc","name_with_type":"Xã Vân Trục","path":"Xã Vân Trục, Huyện Lập Thạch, Tỉnh Vĩnh Phúc","path_with_type":"Xã Vân Trục, Huyện Lập Thạch, Tỉnh Vĩnh Phúc","code":"08797","parent_code":"246"},"08812":{"name":"Xã Liên Hòa","type":"xa","slug":"xa-lien-hoa","name_with_type":"Xã Liên Hòa","path":"Xã Liên Hòa, Huyện Lập Thạch, Tỉnh Vĩnh Phúc","path_with_type":"Xã Liên Hòa, Huyện Lập Thạch, Tỉnh Vĩnh Phúc","code":"08812","parent_code":"246"},"08815":{"name":"Xã Tử Du","type":"xa","slug":"xa-tu-du","name_with_type":"Xã Tử Du","path":"Xã Tử Du, Huyện Lập Thạch, Tỉnh Vĩnh Phúc","path_with_type":"Xã Tử Du, Huyện Lập Thạch, Tỉnh Vĩnh Phúc","code":"08815","parent_code":"246"},"08833":{"name":"Xã Bàn Giản","type":"xa","slug":"xa-ban-gian","name_with_type":"Xã Bàn Giản","path":"Xã Bàn Giản, Huyện Lập Thạch, Tỉnh Vĩnh Phúc","path_with_type":"Xã Bàn Giản, Huyện Lập Thạch, Tỉnh Vĩnh Phúc","code":"08833","parent_code":"246"},"08836":{"name":"Xã Xuân Lôi","type":"xa","slug":"xa-xuan-loi","name_with_type":"Xã Xuân Lôi","path":"Xã Xuân Lôi, Huyện Lập Thạch, Tỉnh Vĩnh Phúc","path_with_type":"Xã Xuân Lôi, Huyện Lập Thạch, Tỉnh Vĩnh Phúc","code":"08836","parent_code":"246"},"08839":{"name":"Xã Đồng Ích","type":"xa","slug":"xa-dong-ich","name_with_type":"Xã Đồng Ích","path":"Xã Đồng Ích, Huyện Lập Thạch, Tỉnh Vĩnh Phúc","path_with_type":"Xã Đồng Ích, Huyện Lập Thạch, Tỉnh Vĩnh Phúc","code":"08839","parent_code":"246"},"08842":{"name":"Xã Tiên Lữ","type":"xa","slug":"xa-tien-lu","name_with_type":"Xã Tiên Lữ","path":"Xã Tiên Lữ, Huyện Lập Thạch, Tỉnh Vĩnh Phúc","path_with_type":"Xã Tiên Lữ, Huyện Lập Thạch, Tỉnh Vĩnh Phúc","code":"08842","parent_code":"246"},"08845":{"name":"Xã Văn Quán","type":"xa","slug":"xa-van-quan","name_with_type":"Xã Văn Quán","path":"Xã Văn Quán, Huyện Lập Thạch, Tỉnh Vĩnh Phúc","path_with_type":"Xã Văn Quán, Huyện Lập Thạch, Tỉnh Vĩnh Phúc","code":"08845","parent_code":"246"},"08863":{"name":"Xã Tây Sơn","type":"xa","slug":"xa-tay-son","name_with_type":"Xã Tây Sơn","path":"Xã Tây Sơn, Huyện Lập Thạch, Tỉnh Vĩnh Phúc","path_with_type":"Xã Tây Sơn, Huyện Lập Thạch, Tỉnh Vĩnh Phúc","code":"08863","parent_code":"246"},"08866":{"name":"Xã Sơn Đông","type":"xa","slug":"xa-son-dong","name_with_type":"Xã Sơn Đông","path":"Xã Sơn Đông, Huyện Lập Thạch, Tỉnh Vĩnh Phúc","path_with_type":"Xã Sơn Đông, Huyện Lập Thạch, Tỉnh Vĩnh Phúc","code":"08866","parent_code":"246"},"08869":{"name":"Thị trấn Hợp Hòa","type":"thi-tran","slug":"thi-tran-hop-hoa","name_with_type":"Thị trấn Hợp Hòa","path":"Thị trấn Hợp Hòa, Huyện Tam Dương, Tỉnh Vĩnh Phúc","path_with_type":"Thị trấn Hợp Hòa, Huyện Tam Dương, Tỉnh Vĩnh Phúc","code":"08869","parent_code":"247"},"08872":{"name":"Xã Hoàng Hoa","type":"xa","slug":"xa-hoang-hoa","name_with_type":"Xã Hoàng Hoa","path":"Xã Hoàng Hoa, Huyện Tam Dương, Tỉnh Vĩnh Phúc","path_with_type":"Xã Hoàng Hoa, Huyện Tam Dương, Tỉnh Vĩnh Phúc","code":"08872","parent_code":"247"},"08875":{"name":"Xã Đồng Tĩnh","type":"xa","slug":"xa-dong-tinh","name_with_type":"Xã Đồng Tĩnh","path":"Xã Đồng Tĩnh, Huyện Tam Dương, Tỉnh Vĩnh Phúc","path_with_type":"Xã Đồng Tĩnh, Huyện Tam Dương, Tỉnh Vĩnh Phúc","code":"08875","parent_code":"247"},"08878":{"name":"Thị trấn Kim Long","type":"thi-tran","slug":"thi-tran-kim-long","name_with_type":"Thị trấn Kim Long","path":"Thị trấn Kim Long, Huyện Tam Dương, Tỉnh Vĩnh Phúc","path_with_type":"Thị trấn Kim Long, Huyện Tam Dương, Tỉnh Vĩnh Phúc","code":"08878","parent_code":"247"},"08881":{"name":"Xã Hướng Đạo","type":"xa","slug":"xa-huong-dao","name_with_type":"Xã Hướng Đạo","path":"Xã Hướng Đạo, Huyện Tam Dương, Tỉnh Vĩnh Phúc","path_with_type":"Xã Hướng Đạo, Huyện Tam Dương, Tỉnh Vĩnh Phúc","code":"08881","parent_code":"247"},"08884":{"name":"Xã Đạo Tú","type":"xa","slug":"xa-dao-tu","name_with_type":"Xã Đạo Tú","path":"Xã Đạo Tú, Huyện Tam Dương, Tỉnh Vĩnh Phúc","path_with_type":"Xã Đạo Tú, Huyện Tam Dương, Tỉnh Vĩnh Phúc","code":"08884","parent_code":"247"},"08887":{"name":"Xã An Hòa","type":"xa","slug":"xa-an-hoa","name_with_type":"Xã An Hòa","path":"Xã An Hòa, Huyện Tam Dương, Tỉnh Vĩnh Phúc","path_with_type":"Xã An Hòa, Huyện Tam Dương, Tỉnh Vĩnh Phúc","code":"08887","parent_code":"247"},"08890":{"name":"Xã Thanh Vân","type":"xa","slug":"xa-thanh-van","name_with_type":"Xã Thanh Vân","path":"Xã Thanh Vân, Huyện Tam Dương, Tỉnh Vĩnh Phúc","path_with_type":"Xã Thanh Vân, Huyện Tam Dương, Tỉnh Vĩnh Phúc","code":"08890","parent_code":"247"},"08893":{"name":"Xã Duy Phiên","type":"xa","slug":"xa-duy-phien","name_with_type":"Xã Duy Phiên","path":"Xã Duy Phiên, Huyện Tam Dương, Tỉnh Vĩnh Phúc","path_with_type":"Xã Duy Phiên, Huyện Tam Dương, Tỉnh Vĩnh Phúc","code":"08893","parent_code":"247"},"08896":{"name":"Xã Hoàng Đan","type":"xa","slug":"xa-hoang-dan","name_with_type":"Xã Hoàng Đan","path":"Xã Hoàng Đan, Huyện Tam Dương, Tỉnh Vĩnh Phúc","path_with_type":"Xã Hoàng Đan, Huyện Tam Dương, Tỉnh Vĩnh Phúc","code":"08896","parent_code":"247"},"08899":{"name":"Xã Hoàng Lâu","type":"xa","slug":"xa-hoang-lau","name_with_type":"Xã Hoàng Lâu","path":"Xã Hoàng Lâu, Huyện Tam Dương, Tỉnh Vĩnh Phúc","path_with_type":"Xã Hoàng Lâu, Huyện Tam Dương, Tỉnh Vĩnh Phúc","code":"08899","parent_code":"247"},"08905":{"name":"Xã Hội Thịnh","type":"xa","slug":"xa-hoi-thinh","name_with_type":"Xã Hội Thịnh","path":"Xã Hội Thịnh, Huyện Tam Dương, Tỉnh Vĩnh Phúc","path_with_type":"Xã Hội Thịnh, Huyện Tam Dương, Tỉnh Vĩnh Phúc","code":"08905","parent_code":"247"},"08908":{"name":"Thị trấn Tam Đảo","type":"thi-tran","slug":"thi-tran-tam-dao","name_with_type":"Thị trấn Tam Đảo","path":"Thị trấn Tam Đảo, Huyện Tam Đảo, Tỉnh Vĩnh Phúc","path_with_type":"Thị trấn Tam Đảo, Huyện Tam Đảo, Tỉnh Vĩnh Phúc","code":"08908","parent_code":"248"},"08911":{"name":"Thị trấn Hợp Châu","type":"thi-tran","slug":"thi-tran-hop-chau","name_with_type":"Thị trấn Hợp Châu","path":"Thị trấn Hợp Châu, Huyện Tam Đảo, Tỉnh Vĩnh Phúc","path_with_type":"Thị trấn Hợp Châu, Huyện Tam Đảo, Tỉnh Vĩnh Phúc","code":"08911","parent_code":"248"},"08914":{"name":"Xã Đạo Trù","type":"xa","slug":"xa-dao-tru","name_with_type":"Xã Đạo Trù","path":"Xã Đạo Trù, Huyện Tam Đảo, Tỉnh Vĩnh Phúc","path_with_type":"Xã Đạo Trù, Huyện Tam Đảo, Tỉnh Vĩnh Phúc","code":"08914","parent_code":"248"},"08917":{"name":"Xã Yên Dương","type":"xa","slug":"xa-yen-duong","name_with_type":"Xã Yên Dương","path":"Xã Yên Dương, Huyện Tam Đảo, Tỉnh Vĩnh Phúc","path_with_type":"Xã Yên Dương, Huyện Tam Đảo, Tỉnh Vĩnh Phúc","code":"08917","parent_code":"248"},"08920":{"name":"Xã Bồ Lý","type":"xa","slug":"xa-bo-ly","name_with_type":"Xã Bồ Lý","path":"Xã Bồ Lý, Huyện Tam Đảo, Tỉnh Vĩnh Phúc","path_with_type":"Xã Bồ Lý, Huyện Tam Đảo, Tỉnh Vĩnh Phúc","code":"08920","parent_code":"248"},"08923":{"name":"Thị trấn Đại Đình","type":"thi-tran","slug":"thi-tran-dai-dinh","name_with_type":"Thị trấn Đại Đình","path":"Thị trấn Đại Đình, Huyện Tam Đảo, Tỉnh Vĩnh Phúc","path_with_type":"Thị trấn Đại Đình, Huyện Tam Đảo, Tỉnh Vĩnh Phúc","code":"08923","parent_code":"248"},"08926":{"name":"Xã Tam Quan","type":"xa","slug":"xa-tam-quan","name_with_type":"Xã Tam Quan","path":"Xã Tam Quan, Huyện Tam Đảo, Tỉnh Vĩnh Phúc","path_with_type":"Xã Tam Quan, Huyện Tam Đảo, Tỉnh Vĩnh Phúc","code":"08926","parent_code":"248"},"08929":{"name":"Xã Hồ Sơn","type":"xa","slug":"xa-ho-son","name_with_type":"Xã Hồ Sơn","path":"Xã Hồ Sơn, Huyện Tam Đảo, Tỉnh Vĩnh Phúc","path_with_type":"Xã Hồ Sơn, Huyện Tam Đảo, Tỉnh Vĩnh Phúc","code":"08929","parent_code":"248"},"08932":{"name":"Xã Minh Quang","type":"xa","slug":"xa-minh-quang","name_with_type":"Xã Minh Quang","path":"Xã Minh Quang, Huyện Tam Đảo, Tỉnh Vĩnh Phúc","path_with_type":"Xã Minh Quang, Huyện Tam Đảo, Tỉnh Vĩnh Phúc","code":"08932","parent_code":"248"},"08935":{"name":"Thị trấn Hương Canh","type":"thi-tran","slug":"thi-tran-huong-canh","name_with_type":"Thị trấn Hương Canh","path":"Thị trấn Hương Canh, Huyện Bình Xuyên, Tỉnh Vĩnh Phúc","path_with_type":"Thị trấn Hương Canh, Huyện Bình Xuyên, Tỉnh Vĩnh Phúc","code":"08935","parent_code":"249"},"08936":{"name":"Thị trấn Gia Khánh","type":"thi-tran","slug":"thi-tran-gia-khanh","name_with_type":"Thị trấn Gia Khánh","path":"Thị trấn Gia Khánh, Huyện Bình Xuyên, Tỉnh Vĩnh Phúc","path_with_type":"Thị trấn Gia Khánh, Huyện Bình Xuyên, Tỉnh Vĩnh Phúc","code":"08936","parent_code":"249"},"08938":{"name":"Xã Trung Mỹ","type":"xa","slug":"xa-trung-my","name_with_type":"Xã Trung Mỹ","path":"Xã Trung Mỹ, Huyện Bình Xuyên, Tỉnh Vĩnh Phúc","path_with_type":"Xã Trung Mỹ, Huyện Bình Xuyên, Tỉnh Vĩnh Phúc","code":"08938","parent_code":"249"},"08944":{"name":"Thị trấn Bá Hiến","type":"thi-tran","slug":"thi-tran-ba-hien","name_with_type":"Thị trấn Bá Hiến","path":"Thị trấn Bá Hiến, Huyện Bình Xuyên, Tỉnh Vĩnh Phúc","path_with_type":"Thị trấn Bá Hiến, Huyện Bình Xuyên, Tỉnh Vĩnh Phúc","code":"08944","parent_code":"249"},"08947":{"name":"Xã Thiện Kế","type":"xa","slug":"xa-thien-ke","name_with_type":"Xã Thiện Kế","path":"Xã Thiện Kế, Huyện Bình Xuyên, Tỉnh Vĩnh Phúc","path_with_type":"Xã Thiện Kế, Huyện Bình Xuyên, Tỉnh Vĩnh Phúc","code":"08947","parent_code":"249"},"08950":{"name":"Xã Hương Sơn","type":"xa","slug":"xa-huong-son","name_with_type":"Xã Hương Sơn","path":"Xã Hương Sơn, Huyện Bình Xuyên, Tỉnh Vĩnh Phúc","path_with_type":"Xã Hương Sơn, Huyện Bình Xuyên, Tỉnh Vĩnh Phúc","code":"08950","parent_code":"249"},"08953":{"name":"Xã Tam Hợp","type":"xa","slug":"xa-tam-hop","name_with_type":"Xã Tam Hợp","path":"Xã Tam Hợp, Huyện Bình Xuyên, Tỉnh Vĩnh Phúc","path_with_type":"Xã Tam Hợp, Huyện Bình Xuyên, Tỉnh Vĩnh Phúc","code":"08953","parent_code":"249"},"08956":{"name":"Xã Quất Lưu","type":"xa","slug":"xa-quat-luu","name_with_type":"Xã Quất Lưu","path":"Xã Quất Lưu, Huyện Bình Xuyên, Tỉnh Vĩnh Phúc","path_with_type":"Xã Quất Lưu, Huyện Bình Xuyên, Tỉnh Vĩnh Phúc","code":"08956","parent_code":"249"},"08959":{"name":"Xã Sơn Lôi","type":"xa","slug":"xa-son-loi","name_with_type":"Xã Sơn Lôi","path":"Xã Sơn Lôi, Huyện Bình Xuyên, Tỉnh Vĩnh Phúc","path_with_type":"Xã Sơn Lôi, Huyện Bình Xuyên, Tỉnh Vĩnh Phúc","code":"08959","parent_code":"249"},"08962":{"name":"Thị trấn Đạo Đức","type":"thi-tran","slug":"thi-tran-dao-duc","name_with_type":"Thị trấn Đạo Đức","path":"Thị trấn Đạo Đức, Huyện Bình Xuyên, Tỉnh Vĩnh Phúc","path_with_type":"Thị trấn Đạo Đức, Huyện Bình Xuyên, Tỉnh Vĩnh Phúc","code":"08962","parent_code":"249"},"08965":{"name":"Xã Tân Phong","type":"xa","slug":"xa-tan-phong","name_with_type":"Xã Tân Phong","path":"Xã Tân Phong, Huyện Bình Xuyên, Tỉnh Vĩnh Phúc","path_with_type":"Xã Tân Phong, Huyện Bình Xuyên, Tỉnh Vĩnh Phúc","code":"08965","parent_code":"249"},"08968":{"name":"Thị trấn Thanh Lãng","type":"thi-tran","slug":"thi-tran-thanh-lang","name_with_type":"Thị trấn Thanh Lãng","path":"Thị trấn Thanh Lãng, Huyện Bình Xuyên, Tỉnh Vĩnh Phúc","path_with_type":"Thị trấn Thanh Lãng, Huyện Bình Xuyên, Tỉnh Vĩnh Phúc","code":"08968","parent_code":"249"},"08971":{"name":"Xã Phú Xuân","type":"xa","slug":"xa-phu-xuan","name_with_type":"Xã Phú Xuân","path":"Xã Phú Xuân, Huyện Bình Xuyên, Tỉnh Vĩnh Phúc","path_with_type":"Xã Phú Xuân, Huyện Bình Xuyên, Tỉnh Vĩnh Phúc","code":"08971","parent_code":"249"},"09025":{"name":"Thị trấn Yên Lạc","type":"thi-tran","slug":"thi-tran-yen-lac","name_with_type":"Thị trấn Yên Lạc","path":"Thị trấn Yên Lạc, Huyện Yên Lạc, Tỉnh Vĩnh Phúc","path_with_type":"Thị trấn Yên Lạc, Huyện Yên Lạc, Tỉnh Vĩnh Phúc","code":"09025","parent_code":"251"},"09028":{"name":"Xã Đồng Cương","type":"xa","slug":"xa-dong-cuong","name_with_type":"Xã Đồng Cương","path":"Xã Đồng Cương, Huyện Yên Lạc, Tỉnh Vĩnh Phúc","path_with_type":"Xã Đồng Cương, Huyện Yên Lạc, Tỉnh Vĩnh Phúc","code":"09028","parent_code":"251"},"09031":{"name":"Xã Đồng Văn","type":"xa","slug":"xa-dong-van","name_with_type":"Xã Đồng Văn","path":"Xã Đồng Văn, Huyện Yên Lạc, Tỉnh Vĩnh Phúc","path_with_type":"Xã Đồng Văn, Huyện Yên Lạc, Tỉnh Vĩnh Phúc","code":"09031","parent_code":"251"},"09034":{"name":"Xã Bình Định","type":"xa","slug":"xa-binh-dinh","name_with_type":"Xã Bình Định","path":"Xã Bình Định, Huyện Yên Lạc, Tỉnh Vĩnh Phúc","path_with_type":"Xã Bình Định, Huyện Yên Lạc, Tỉnh Vĩnh Phúc","code":"09034","parent_code":"251"},"09037":{"name":"Xã Trung Nguyên","type":"xa","slug":"xa-trung-nguyen","name_with_type":"Xã Trung Nguyên","path":"Xã Trung Nguyên, Huyện Yên Lạc, Tỉnh Vĩnh Phúc","path_with_type":"Xã Trung Nguyên, Huyện Yên Lạc, Tỉnh Vĩnh Phúc","code":"09037","parent_code":"251"},"09040":{"name":"Xã Tề Lỗ","type":"xa","slug":"xa-te-lo","name_with_type":"Xã Tề Lỗ","path":"Xã Tề Lỗ, Huyện Yên Lạc, Tỉnh Vĩnh Phúc","path_with_type":"Xã Tề Lỗ, Huyện Yên Lạc, Tỉnh Vĩnh Phúc","code":"09040","parent_code":"251"},"09043":{"name":"Thị trấn Tam Hồng","type":"thi-tran","slug":"thi-tran-tam-hong","name_with_type":"Thị trấn Tam Hồng","path":"Thị trấn Tam Hồng, Huyện Yên Lạc, Tỉnh Vĩnh Phúc","path_with_type":"Thị trấn Tam Hồng, Huyện Yên Lạc, Tỉnh Vĩnh Phúc","code":"09043","parent_code":"251"},"09046":{"name":"Xã Yên Đồng","type":"xa","slug":"xa-yen-dong","name_with_type":"Xã Yên Đồng","path":"Xã Yên Đồng, Huyện Yên Lạc, Tỉnh Vĩnh Phúc","path_with_type":"Xã Yên Đồng, Huyện Yên Lạc, Tỉnh Vĩnh Phúc","code":"09046","parent_code":"251"},"09049":{"name":"Xã Văn Tiến","type":"xa","slug":"xa-van-tien","name_with_type":"Xã Văn Tiến","path":"Xã Văn Tiến, Huyện Yên Lạc, Tỉnh Vĩnh Phúc","path_with_type":"Xã Văn Tiến, Huyện Yên Lạc, Tỉnh Vĩnh Phúc","code":"09049","parent_code":"251"},"09052":{"name":"Xã Nguyệt Đức","type":"xa","slug":"xa-nguyet-duc","name_with_type":"Xã Nguyệt Đức","path":"Xã Nguyệt Đức, Huyện Yên Lạc, Tỉnh Vĩnh Phúc","path_with_type":"Xã Nguyệt Đức, Huyện Yên Lạc, Tỉnh Vĩnh Phúc","code":"09052","parent_code":"251"},"09055":{"name":"Xã Yên Phương","type":"xa","slug":"xa-yen-phuong","name_with_type":"Xã Yên Phương","path":"Xã Yên Phương, Huyện Yên Lạc, Tỉnh Vĩnh Phúc","path_with_type":"Xã Yên Phương, Huyện Yên Lạc, Tỉnh Vĩnh Phúc","code":"09055","parent_code":"251"},"09061":{"name":"Xã Trung Kiên","type":"xa","slug":"xa-trung-kien","name_with_type":"Xã Trung Kiên","path":"Xã Trung Kiên, Huyện Yên Lạc, Tỉnh Vĩnh Phúc","path_with_type":"Xã Trung Kiên, Huyện Yên Lạc, Tỉnh Vĩnh Phúc","code":"09061","parent_code":"251"},"09064":{"name":"Xã Liên Châu","type":"xa","slug":"xa-lien-chau","name_with_type":"Xã Liên Châu","path":"Xã Liên Châu, Huyện Yên Lạc, Tỉnh Vĩnh Phúc","path_with_type":"Xã Liên Châu, Huyện Yên Lạc, Tỉnh Vĩnh Phúc","code":"09064","parent_code":"251"},"09067":{"name":"Xã Đại Tự","type":"xa","slug":"xa-dai-tu","name_with_type":"Xã Đại Tự","path":"Xã Đại Tự, Huyện Yên Lạc, Tỉnh Vĩnh Phúc","path_with_type":"Xã Đại Tự, Huyện Yên Lạc, Tỉnh Vĩnh Phúc","code":"09067","parent_code":"251"},"09070":{"name":"Xã Hồng Châu","type":"xa","slug":"xa-hong-chau","name_with_type":"Xã Hồng Châu","path":"Xã Hồng Châu, Huyện Yên Lạc, Tỉnh Vĩnh Phúc","path_with_type":"Xã Hồng Châu, Huyện Yên Lạc, Tỉnh Vĩnh Phúc","code":"09070","parent_code":"251"},"09073":{"name":"Xã Trung Hà","type":"xa","slug":"xa-trung-ha","name_with_type":"Xã Trung Hà","path":"Xã Trung Hà, Huyện Yên Lạc, Tỉnh Vĩnh Phúc","path_with_type":"Xã Trung Hà, Huyện Yên Lạc, Tỉnh Vĩnh Phúc","code":"09073","parent_code":"251"},"09076":{"name":"Thị trấn Vĩnh Tường","type":"thi-tran","slug":"thi-tran-vinh-tuong","name_with_type":"Thị trấn Vĩnh Tường","path":"Thị trấn Vĩnh Tường, Huyện Vĩnh Tường, Tỉnh Vĩnh Phúc","path_with_type":"Thị trấn Vĩnh Tường, Huyện Vĩnh Tường, Tỉnh Vĩnh Phúc","code":"09076","parent_code":"252"},"09079":{"name":"Xã Kim Xá","type":"xa","slug":"xa-kim-xa","name_with_type":"Xã Kim Xá","path":"Xã Kim Xá, Huyện Vĩnh Tường, Tỉnh Vĩnh Phúc","path_with_type":"Xã Kim Xá, Huyện Vĩnh Tường, Tỉnh Vĩnh Phúc","code":"09079","parent_code":"252"},"09082":{"name":"Xã Yên Bình","type":"xa","slug":"xa-yen-binh","name_with_type":"Xã Yên Bình","path":"Xã Yên Bình, Huyện Vĩnh Tường, Tỉnh Vĩnh Phúc","path_with_type":"Xã Yên Bình, Huyện Vĩnh Tường, Tỉnh Vĩnh Phúc","code":"09082","parent_code":"252"},"09085":{"name":"Xã Chấn Hưng","type":"xa","slug":"xa-chan-hung","name_with_type":"Xã Chấn Hưng","path":"Xã Chấn Hưng, Huyện Vĩnh Tường, Tỉnh Vĩnh Phúc","path_with_type":"Xã Chấn Hưng, Huyện Vĩnh Tường, Tỉnh Vĩnh Phúc","code":"09085","parent_code":"252"},"09088":{"name":"Xã Nghĩa Hưng","type":"xa","slug":"xa-nghia-hung","name_with_type":"Xã Nghĩa Hưng","path":"Xã Nghĩa Hưng, Huyện Vĩnh Tường, Tỉnh Vĩnh Phúc","path_with_type":"Xã Nghĩa Hưng, Huyện Vĩnh Tường, Tỉnh Vĩnh Phúc","code":"09088","parent_code":"252"},"09091":{"name":"Xã Yên Lập","type":"xa","slug":"xa-yen-lap","name_with_type":"Xã Yên Lập","path":"Xã Yên Lập, Huyện Vĩnh Tường, Tỉnh Vĩnh Phúc","path_with_type":"Xã Yên Lập, Huyện Vĩnh Tường, Tỉnh Vĩnh Phúc","code":"09091","parent_code":"252"},"09097":{"name":"Xã Sao Đại Việt","type":"xa","slug":"xa-sao-dai-viet","name_with_type":"Xã Sao Đại Việt","path":"Xã Sao Đại Việt, Huyện Vĩnh Tường, Tỉnh Vĩnh Phúc","path_with_type":"Xã Sao Đại Việt, Huyện Vĩnh Tường, Tỉnh Vĩnh Phúc","code":"09097","parent_code":"252"},"09100":{"name":"Xã Đại Đồng","type":"xa","slug":"xa-dai-dong","name_with_type":"Xã Đại Đồng","path":"Xã Đại Đồng, Huyện Vĩnh Tường, Tỉnh Vĩnh Phúc","path_with_type":"Xã Đại Đồng, Huyện Vĩnh Tường, Tỉnh Vĩnh Phúc","code":"09100","parent_code":"252"},"09106":{"name":"Xã Lũng Hoà","type":"xa","slug":"xa-lung-hoa","name_with_type":"Xã Lũng Hoà","path":"Xã Lũng Hoà, Huyện Vĩnh Tường, Tỉnh Vĩnh Phúc","path_with_type":"Xã Lũng Hoà, Huyện Vĩnh Tường, Tỉnh Vĩnh Phúc","code":"09106","parent_code":"252"},"09112":{"name":"Thị Trấn Thổ Tang","type":"thi-tran","slug":"thi-tran-tho-tang","name_with_type":"Thị Trấn Thổ Tang","path":"Thị Trấn Thổ Tang, Huyện Vĩnh Tường, Tỉnh Vĩnh Phúc","path_with_type":"Thị Trấn Thổ Tang, Huyện Vĩnh Tường, Tỉnh Vĩnh Phúc","code":"09112","parent_code":"252"},"09118":{"name":"Xã Lương Điền","type":"xa","slug":"xa-luong-dien","name_with_type":"Xã Lương Điền","path":"Xã Lương Điền, Huyện Vĩnh Tường, Tỉnh Vĩnh Phúc","path_with_type":"Xã Lương Điền, Huyện Vĩnh Tường, Tỉnh Vĩnh Phúc","code":"09118","parent_code":"252"},"09124":{"name":"Xã Tân Phú","type":"xa","slug":"xa-tan-phu","name_with_type":"Xã Tân Phú","path":"Xã Tân Phú, Huyện Vĩnh Tường, Tỉnh Vĩnh Phúc","path_with_type":"Xã Tân Phú, Huyện Vĩnh Tường, Tỉnh Vĩnh Phúc","code":"09124","parent_code":"252"},"09127":{"name":"Xã Thượng Trưng","type":"xa","slug":"xa-thuong-trung","name_with_type":"Xã Thượng Trưng","path":"Xã Thượng Trưng, Huyện Vĩnh Tường, Tỉnh Vĩnh Phúc","path_with_type":"Xã Thượng Trưng, Huyện Vĩnh Tường, Tỉnh Vĩnh Phúc","code":"09127","parent_code":"252"},"09130":{"name":"Xã Vũ Di","type":"xa","slug":"xa-vu-di","name_with_type":"Xã Vũ Di","path":"Xã Vũ Di, Huyện Vĩnh Tường, Tỉnh Vĩnh Phúc","path_with_type":"Xã Vũ Di, Huyện Vĩnh Tường, Tỉnh Vĩnh Phúc","code":"09130","parent_code":"252"},"09136":{"name":"Xã Tuân Chính","type":"xa","slug":"xa-tuan-chinh","name_with_type":"Xã Tuân Chính","path":"Xã Tuân Chính, Huyện Vĩnh Tường, Tỉnh Vĩnh Phúc","path_with_type":"Xã Tuân Chính, Huyện Vĩnh Tường, Tỉnh Vĩnh Phúc","code":"09136","parent_code":"252"},"09145":{"name":"Thị trấn Tứ Trưng","type":"thi-tran","slug":"thi-tran-tu-trung","name_with_type":"Thị trấn Tứ Trưng","path":"Thị trấn Tứ Trưng, Huyện Vĩnh Tường, Tỉnh Vĩnh Phúc","path_with_type":"Thị trấn Tứ Trưng, Huyện Vĩnh Tường, Tỉnh Vĩnh Phúc","code":"09145","parent_code":"252"},"09148":{"name":"Xã Ngũ Kiên","type":"xa","slug":"xa-ngu-kien","name_with_type":"Xã Ngũ Kiên","path":"Xã Ngũ Kiên, Huyện Vĩnh Tường, Tỉnh Vĩnh Phúc","path_with_type":"Xã Ngũ Kiên, Huyện Vĩnh Tường, Tỉnh Vĩnh Phúc","code":"09148","parent_code":"252"},"09151":{"name":"Xã An Nhân","type":"xa","slug":"xa-an-nhan","name_with_type":"Xã An Nhân","path":"Xã An Nhân, Huyện Vĩnh Tường, Tỉnh Vĩnh Phúc","path_with_type":"Xã An Nhân, Huyện Vĩnh Tường, Tỉnh Vĩnh Phúc","code":"09151","parent_code":"252"},"09154":{"name":"Xã Vĩnh Thịnh","type":"xa","slug":"xa-vinh-thinh","name_with_type":"Xã Vĩnh Thịnh","path":"Xã Vĩnh Thịnh, Huyện Vĩnh Tường, Tỉnh Vĩnh Phúc","path_with_type":"Xã Vĩnh Thịnh, Huyện Vĩnh Tường, Tỉnh Vĩnh Phúc","code":"09154","parent_code":"252"},"09157":{"name":"Xã Vĩnh Phú","type":"xa","slug":"xa-vinh-phu","name_with_type":"Xã Vĩnh Phú","path":"Xã Vĩnh Phú, Huyện Vĩnh Tường, Tỉnh Vĩnh Phúc","path_with_type":"Xã Vĩnh Phú, Huyện Vĩnh Tường, Tỉnh Vĩnh Phúc","code":"09157","parent_code":"252"},"08773":{"name":"Xã Lãng Công","type":"xa","slug":"xa-lang-cong","name_with_type":"Xã Lãng Công","path":"Xã Lãng Công, Huyện Sông Lô, Tỉnh Vĩnh Phúc","path_with_type":"Xã Lãng Công, Huyện Sông Lô, Tỉnh Vĩnh Phúc","code":"08773","parent_code":"253"},"08776":{"name":"Xã Quang Yên","type":"xa","slug":"xa-quang-yen","name_with_type":"Xã Quang Yên","path":"Xã Quang Yên, Huyện Sông Lô, Tỉnh Vĩnh Phúc","path_with_type":"Xã Quang Yên, Huyện Sông Lô, Tỉnh Vĩnh Phúc","code":"08776","parent_code":"253"},"08782":{"name":"Xã Hải Lựu","type":"xa","slug":"xa-hai-luu","name_with_type":"Xã Hải Lựu","path":"Xã Hải Lựu, Huyện Sông Lô, Tỉnh Vĩnh Phúc","path_with_type":"Xã Hải Lựu, Huyện Sông Lô, Tỉnh Vĩnh Phúc","code":"08782","parent_code":"253"},"08800":{"name":"Xã Đồng Quế","type":"xa","slug":"xa-dong-que","name_with_type":"Xã Đồng Quế","path":"Xã Đồng Quế, Huyện Sông Lô, Tỉnh Vĩnh Phúc","path_with_type":"Xã Đồng Quế, Huyện Sông Lô, Tỉnh Vĩnh Phúc","code":"08800","parent_code":"253"},"08803":{"name":"Xã Nhân Đạo","type":"xa","slug":"xa-nhan-dao","name_with_type":"Xã Nhân Đạo","path":"Xã Nhân Đạo, Huyện Sông Lô, Tỉnh Vĩnh Phúc","path_with_type":"Xã Nhân Đạo, Huyện Sông Lô, Tỉnh Vĩnh Phúc","code":"08803","parent_code":"253"},"08806":{"name":"Xã Đôn Nhân","type":"xa","slug":"xa-don-nhan","name_with_type":"Xã Đôn Nhân","path":"Xã Đôn Nhân, Huyện Sông Lô, Tỉnh Vĩnh Phúc","path_with_type":"Xã Đôn Nhân, Huyện Sông Lô, Tỉnh Vĩnh Phúc","code":"08806","parent_code":"253"},"08809":{"name":"Xã Phương Khoan","type":"xa","slug":"xa-phuong-khoan","name_with_type":"Xã Phương Khoan","path":"Xã Phương Khoan, Huyện Sông Lô, Tỉnh Vĩnh Phúc","path_with_type":"Xã Phương Khoan, Huyện Sông Lô, Tỉnh Vĩnh Phúc","code":"08809","parent_code":"253"},"08818":{"name":"Xã Tân Lập","type":"xa","slug":"xa-tan-lap","name_with_type":"Xã Tân Lập","path":"Xã Tân Lập, Huyện Sông Lô, Tỉnh Vĩnh Phúc","path_with_type":"Xã Tân Lập, Huyện Sông Lô, Tỉnh Vĩnh Phúc","code":"08818","parent_code":"253"},"08824":{"name":"Thị trấn Tam Sơn","type":"thi-tran","slug":"thi-tran-tam-son","name_with_type":"Thị trấn Tam Sơn","path":"Thị trấn Tam Sơn, Huyện Sông Lô, Tỉnh Vĩnh Phúc","path_with_type":"Thị trấn Tam Sơn, Huyện Sông Lô, Tỉnh Vĩnh Phúc","code":"08824","parent_code":"253"},"08830":{"name":"Xã Yên Thạch","type":"xa","slug":"xa-yen-thach","name_with_type":"Xã Yên Thạch","path":"Xã Yên Thạch, Huyện Sông Lô, Tỉnh Vĩnh Phúc","path_with_type":"Xã Yên Thạch, Huyện Sông Lô, Tỉnh Vĩnh Phúc","code":"08830","parent_code":"253"},"08848":{"name":"Xã Đồng Thịnh","type":"xa","slug":"xa-dong-thinh","name_with_type":"Xã Đồng Thịnh","path":"Xã Đồng Thịnh, Huyện Sông Lô, Tỉnh Vĩnh Phúc","path_with_type":"Xã Đồng Thịnh, Huyện Sông Lô, Tỉnh Vĩnh Phúc","code":"08848","parent_code":"253"},"08851":{"name":"Xã Tứ Yên","type":"xa","slug":"xa-tu-yen","name_with_type":"Xã Tứ Yên","path":"Xã Tứ Yên, Huyện Sông Lô, Tỉnh Vĩnh Phúc","path_with_type":"Xã Tứ Yên, Huyện Sông Lô, Tỉnh Vĩnh Phúc","code":"08851","parent_code":"253"},"08854":{"name":"Xã Đức Bác","type":"xa","slug":"xa-duc-bac","name_with_type":"Xã Đức Bác","path":"Xã Đức Bác, Huyện Sông Lô, Tỉnh Vĩnh Phúc","path_with_type":"Xã Đức Bác, Huyện Sông Lô, Tỉnh Vĩnh Phúc","code":"08854","parent_code":"253"},"08860":{"name":"Xã Cao Phong","type":"xa","slug":"xa-cao-phong","name_with_type":"Xã Cao Phong","path":"Xã Cao Phong, Huyện Sông Lô, Tỉnh Vĩnh Phúc","path_with_type":"Xã Cao Phong, Huyện Sông Lô, Tỉnh Vĩnh Phúc","code":"08860","parent_code":"253"},"09163":{"name":"Phường Vũ Ninh","type":"phuong","slug":"phuong-vu-ninh","name_with_type":"Phường Vũ Ninh","path":"Phường Vũ Ninh, Thành phố Bắc Ninh, Tỉnh Bắc Ninh","path_with_type":"Phường Vũ Ninh, Thành phố Bắc Ninh, Tỉnh Bắc Ninh","code":"09163","parent_code":"256"},"09166":{"name":"Phường Đáp Cầu","type":"phuong","slug":"phuong-dap-cau","name_with_type":"Phường Đáp Cầu","path":"Phường Đáp Cầu, Thành phố Bắc Ninh, Tỉnh Bắc Ninh","path_with_type":"Phường Đáp Cầu, Thành phố Bắc Ninh, Tỉnh Bắc Ninh","code":"09166","parent_code":"256"},"09169":{"name":"Phường Thị Cầu","type":"phuong","slug":"phuong-thi-cau","name_with_type":"Phường Thị Cầu","path":"Phường Thị Cầu, Thành phố Bắc Ninh, Tỉnh Bắc Ninh","path_with_type":"Phường Thị Cầu, Thành phố Bắc Ninh, Tỉnh Bắc Ninh","code":"09169","parent_code":"256"},"09172":{"name":"Phường Kinh Bắc","type":"phuong","slug":"phuong-kinh-bac","name_with_type":"Phường Kinh Bắc","path":"Phường Kinh Bắc, Thành phố Bắc Ninh, Tỉnh Bắc Ninh","path_with_type":"Phường Kinh Bắc, Thành phố Bắc Ninh, Tỉnh Bắc Ninh","code":"09172","parent_code":"256"},"09181":{"name":"Phường Đại Phúc","type":"phuong","slug":"phuong-dai-phuc","name_with_type":"Phường Đại Phúc","path":"Phường Đại Phúc, Thành phố Bắc Ninh, Tỉnh Bắc Ninh","path_with_type":"Phường Đại Phúc, Thành phố Bắc Ninh, Tỉnh Bắc Ninh","code":"09181","parent_code":"256"},"09184":{"name":"Phường Tiền Ninh Vệ","type":"phuong","slug":"phuong-tien-ninh-ve","name_with_type":"Phường Tiền Ninh Vệ","path":"Phường Tiền Ninh Vệ, Thành phố Bắc Ninh, Tỉnh Bắc Ninh","path_with_type":"Phường Tiền Ninh Vệ, Thành phố Bắc Ninh, Tỉnh Bắc Ninh","code":"09184","parent_code":"256"},"09187":{"name":"Phường Suối Hoa","type":"phuong","slug":"phuong-suoi-hoa","name_with_type":"Phường Suối Hoa","path":"Phường Suối Hoa, Thành phố Bắc Ninh, Tỉnh Bắc Ninh","path_with_type":"Phường Suối Hoa, Thành phố Bắc Ninh, Tỉnh Bắc Ninh","code":"09187","parent_code":"256"},"09190":{"name":"Phường Võ Cường","type":"phuong","slug":"phuong-vo-cuong","name_with_type":"Phường Võ Cường","path":"Phường Võ Cường, Thành phố Bắc Ninh, Tỉnh Bắc Ninh","path_with_type":"Phường Võ Cường, Thành phố Bắc Ninh, Tỉnh Bắc Ninh","code":"09190","parent_code":"256"},"09214":{"name":"Phường Hòa Long","type":"phuong","slug":"phuong-hoa-long","name_with_type":"Phường Hòa Long","path":"Phường Hòa Long, Thành phố Bắc Ninh, Tỉnh Bắc Ninh","path_with_type":"Phường Hòa Long, Thành phố Bắc Ninh, Tỉnh Bắc Ninh","code":"09214","parent_code":"256"},"09226":{"name":"Phường Vạn An","type":"phuong","slug":"phuong-van-an","name_with_type":"Phường Vạn An","path":"Phường Vạn An, Thành phố Bắc Ninh, Tỉnh Bắc Ninh","path_with_type":"Phường Vạn An, Thành phố Bắc Ninh, Tỉnh Bắc Ninh","code":"09226","parent_code":"256"},"09235":{"name":"Phường Khúc Xuyên","type":"phuong","slug":"phuong-khuc-xuyen","name_with_type":"Phường Khúc Xuyên","path":"Phường Khúc Xuyên, Thành phố Bắc Ninh, Tỉnh Bắc Ninh","path_with_type":"Phường Khúc Xuyên, Thành phố Bắc Ninh, Tỉnh Bắc Ninh","code":"09235","parent_code":"256"},"09244":{"name":"Phường Phong Khê","type":"phuong","slug":"phuong-phong-khe","name_with_type":"Phường Phong Khê","path":"Phường Phong Khê, Thành phố Bắc Ninh, Tỉnh Bắc Ninh","path_with_type":"Phường Phong Khê, Thành phố Bắc Ninh, Tỉnh Bắc Ninh","code":"09244","parent_code":"256"},"09256":{"name":"Phường Kim Chân","type":"phuong","slug":"phuong-kim-chan","name_with_type":"Phường Kim Chân","path":"Phường Kim Chân, Thành phố Bắc Ninh, Tỉnh Bắc Ninh","path_with_type":"Phường Kim Chân, Thành phố Bắc Ninh, Tỉnh Bắc Ninh","code":"09256","parent_code":"256"},"09271":{"name":"Phường Vân Dương","type":"phuong","slug":"phuong-van-duong","name_with_type":"Phường Vân Dương","path":"Phường Vân Dương, Thành phố Bắc Ninh, Tỉnh Bắc Ninh","path_with_type":"Phường Vân Dương, Thành phố Bắc Ninh, Tỉnh Bắc Ninh","code":"09271","parent_code":"256"},"09286":{"name":"Phường Nam Sơn","type":"phuong","slug":"phuong-nam-son","name_with_type":"Phường Nam Sơn","path":"Phường Nam Sơn, Thành phố Bắc Ninh, Tỉnh Bắc Ninh","path_with_type":"Phường Nam Sơn, Thành phố Bắc Ninh, Tỉnh Bắc Ninh","code":"09286","parent_code":"256"},"09325":{"name":"Phường Khắc Niệm","type":"phuong","slug":"phuong-khac-niem","name_with_type":"Phường Khắc Niệm","path":"Phường Khắc Niệm, Thành phố Bắc Ninh, Tỉnh Bắc Ninh","path_with_type":"Phường Khắc Niệm, Thành phố Bắc Ninh, Tỉnh Bắc Ninh","code":"09325","parent_code":"256"},"09331":{"name":"Phường Hạp Lĩnh","type":"phuong","slug":"phuong-hap-linh","name_with_type":"Phường Hạp Lĩnh","path":"Phường Hạp Lĩnh, Thành phố Bắc Ninh, Tỉnh Bắc Ninh","path_with_type":"Phường Hạp Lĩnh, Thành phố Bắc Ninh, Tỉnh Bắc Ninh","code":"09331","parent_code":"256"},"09193":{"name":"Thị trấn Chờ","type":"thi-tran","slug":"thi-tran-cho","name_with_type":"Thị trấn Chờ","path":"Thị trấn Chờ, Huyện Yên Phong, Tỉnh Bắc Ninh","path_with_type":"Thị trấn Chờ, Huyện Yên Phong, Tỉnh Bắc Ninh","code":"09193","parent_code":"258"},"09196":{"name":"Xã Dũng Liệt","type":"xa","slug":"xa-dung-liet","name_with_type":"Xã Dũng Liệt","path":"Xã Dũng Liệt, Huyện Yên Phong, Tỉnh Bắc Ninh","path_with_type":"Xã Dũng Liệt, Huyện Yên Phong, Tỉnh Bắc Ninh","code":"09196","parent_code":"258"},"09199":{"name":"Xã Tam Đa","type":"xa","slug":"xa-tam-da","name_with_type":"Xã Tam Đa","path":"Xã Tam Đa, Huyện Yên Phong, Tỉnh Bắc Ninh","path_with_type":"Xã Tam Đa, Huyện Yên Phong, Tỉnh Bắc Ninh","code":"09199","parent_code":"258"},"09202":{"name":"Xã Tam Giang","type":"xa","slug":"xa-tam-giang","name_with_type":"Xã Tam Giang","path":"Xã Tam Giang, Huyện Yên Phong, Tỉnh Bắc Ninh","path_with_type":"Xã Tam Giang, Huyện Yên Phong, Tỉnh Bắc Ninh","code":"09202","parent_code":"258"},"09205":{"name":"Xã Yên Trung","type":"xa","slug":"xa-yen-trung","name_with_type":"Xã Yên Trung","path":"Xã Yên Trung, Huyện Yên Phong, Tỉnh Bắc Ninh","path_with_type":"Xã Yên Trung, Huyện Yên Phong, Tỉnh Bắc Ninh","code":"09205","parent_code":"258"},"09208":{"name":"Xã Thụy Hòa","type":"xa","slug":"xa-thuy-hoa","name_with_type":"Xã Thụy Hòa","path":"Xã Thụy Hòa, Huyện Yên Phong, Tỉnh Bắc Ninh","path_with_type":"Xã Thụy Hòa, Huyện Yên Phong, Tỉnh Bắc Ninh","code":"09208","parent_code":"258"},"09211":{"name":"Xã Hòa Tiến","type":"xa","slug":"xa-hoa-tien","name_with_type":"Xã Hòa Tiến","path":"Xã Hòa Tiến, Huyện Yên Phong, Tỉnh Bắc Ninh","path_with_type":"Xã Hòa Tiến, Huyện Yên Phong, Tỉnh Bắc Ninh","code":"09211","parent_code":"258"},"09217":{"name":"Xã Đông Tiến","type":"xa","slug":"xa-dong-tien","name_with_type":"Xã Đông Tiến","path":"Xã Đông Tiến, Huyện Yên Phong, Tỉnh Bắc Ninh","path_with_type":"Xã Đông Tiến, Huyện Yên Phong, Tỉnh Bắc Ninh","code":"09217","parent_code":"258"},"09220":{"name":"Xã Yên Phụ","type":"xa","slug":"xa-yen-phu","name_with_type":"Xã Yên Phụ","path":"Xã Yên Phụ, Huyện Yên Phong, Tỉnh Bắc Ninh","path_with_type":"Xã Yên Phụ, Huyện Yên Phong, Tỉnh Bắc Ninh","code":"09220","parent_code":"258"},"09223":{"name":"Xã Trung Nghĩa","type":"xa","slug":"xa-trung-nghia","name_with_type":"Xã Trung Nghĩa","path":"Xã Trung Nghĩa, Huyện Yên Phong, Tỉnh Bắc Ninh","path_with_type":"Xã Trung Nghĩa, Huyện Yên Phong, Tỉnh Bắc Ninh","code":"09223","parent_code":"258"},"09229":{"name":"Xã Đông Phong","type":"xa","slug":"xa-dong-phong","name_with_type":"Xã Đông Phong","path":"Xã Đông Phong, Huyện Yên Phong, Tỉnh Bắc Ninh","path_with_type":"Xã Đông Phong, Huyện Yên Phong, Tỉnh Bắc Ninh","code":"09229","parent_code":"258"},"09232":{"name":"Xã Long Châu","type":"xa","slug":"xa-long-chau","name_with_type":"Xã Long Châu","path":"Xã Long Châu, Huyện Yên Phong, Tỉnh Bắc Ninh","path_with_type":"Xã Long Châu, Huyện Yên Phong, Tỉnh Bắc Ninh","code":"09232","parent_code":"258"},"09238":{"name":"Xã Văn Môn","type":"xa","slug":"xa-van-mon","name_with_type":"Xã Văn Môn","path":"Xã Văn Môn, Huyện Yên Phong, Tỉnh Bắc Ninh","path_with_type":"Xã Văn Môn, Huyện Yên Phong, Tỉnh Bắc Ninh","code":"09238","parent_code":"258"},"09241":{"name":"Xã Đông Thọ","type":"xa","slug":"xa-dong-tho","name_with_type":"Xã Đông Thọ","path":"Xã Đông Thọ, Huyện Yên Phong, Tỉnh Bắc Ninh","path_with_type":"Xã Đông Thọ, Huyện Yên Phong, Tỉnh Bắc Ninh","code":"09241","parent_code":"258"},"09247":{"name":"Phường Phố Mới","type":"phuong","slug":"phuong-pho-moi","name_with_type":"Phường Phố Mới","path":"Phường Phố Mới, Thị xã Quế Võ, Tỉnh Bắc Ninh","path_with_type":"Phường Phố Mới, Thị xã Quế Võ, Tỉnh Bắc Ninh","code":"09247","parent_code":"259"},"09250":{"name":"Xã Việt Thống","type":"xa","slug":"xa-viet-thong","name_with_type":"Xã Việt Thống","path":"Xã Việt Thống, Thị xã Quế Võ, Tỉnh Bắc Ninh","path_with_type":"Xã Việt Thống, Thị xã Quế Võ, Tỉnh Bắc Ninh","code":"09250","parent_code":"259"},"09253":{"name":"Phường Đại Xuân","type":"phuong","slug":"phuong-dai-xuan","name_with_type":"Phường Đại Xuân","path":"Phường Đại Xuân, Thị xã Quế Võ, Tỉnh Bắc Ninh","path_with_type":"Phường Đại Xuân, Thị xã Quế Võ, Tỉnh Bắc Ninh","code":"09253","parent_code":"259"},"09259":{"name":"Phường Nhân Hòa","type":"phuong","slug":"phuong-nhan-hoa","name_with_type":"Phường Nhân Hòa","path":"Phường Nhân Hòa, Thị xã Quế Võ, Tỉnh Bắc Ninh","path_with_type":"Phường Nhân Hòa, Thị xã Quế Võ, Tỉnh Bắc Ninh","code":"09259","parent_code":"259"},"09262":{"name":"Phường Bằng An","type":"phuong","slug":"phuong-bang-an","name_with_type":"Phường Bằng An","path":"Phường Bằng An, Thị xã Quế Võ, Tỉnh Bắc Ninh","path_with_type":"Phường Bằng An, Thị xã Quế Võ, Tỉnh Bắc Ninh","code":"09262","parent_code":"259"},"09265":{"name":"Phường Phương Liễu","type":"phuong","slug":"phuong-phuong-lieu","name_with_type":"Phường Phương Liễu","path":"Phường Phương Liễu, Thị xã Quế Võ, Tỉnh Bắc Ninh","path_with_type":"Phường Phương Liễu, Thị xã Quế Võ, Tỉnh Bắc Ninh","code":"09265","parent_code":"259"},"09268":{"name":"Phường Quế Tân","type":"phuong","slug":"phuong-que-tan","name_with_type":"Phường Quế Tân","path":"Phường Quế Tân, Thị xã Quế Võ, Tỉnh Bắc Ninh","path_with_type":"Phường Quế Tân, Thị xã Quế Võ, Tỉnh Bắc Ninh","code":"09268","parent_code":"259"},"09274":{"name":"Phường Phù Lương","type":"phuong","slug":"phuong-phu-luong","name_with_type":"Phường Phù Lương","path":"Phường Phù Lương, Thị xã Quế Võ, Tỉnh Bắc Ninh","path_with_type":"Phường Phù Lương, Thị xã Quế Võ, Tỉnh Bắc Ninh","code":"09274","parent_code":"259"},"09277":{"name":"Xã Phù Lãng","type":"xa","slug":"xa-phu-lang","name_with_type":"Xã Phù Lãng","path":"Xã Phù Lãng, Thị xã Quế Võ, Tỉnh Bắc Ninh","path_with_type":"Xã Phù Lãng, Thị xã Quế Võ, Tỉnh Bắc Ninh","code":"09277","parent_code":"259"},"09280":{"name":"Phường Phượng Mao","type":"phuong","slug":"phuong-phuong-mao","name_with_type":"Phường Phượng Mao","path":"Phường Phượng Mao, Thị xã Quế Võ, Tỉnh Bắc Ninh","path_with_type":"Phường Phượng Mao, Thị xã Quế Võ, Tỉnh Bắc Ninh","code":"09280","parent_code":"259"},"09283":{"name":"Phường Việt Hùng","type":"phuong","slug":"phuong-viet-hung","name_with_type":"Phường Việt Hùng","path":"Phường Việt Hùng, Thị xã Quế Võ, Tỉnh Bắc Ninh","path_with_type":"Phường Việt Hùng, Thị xã Quế Võ, Tỉnh Bắc Ninh","code":"09283","parent_code":"259"},"09289":{"name":"Xã Ngọc Xá","type":"xa","slug":"xa-ngoc-xa","name_with_type":"Xã Ngọc Xá","path":"Xã Ngọc Xá, Thị xã Quế Võ, Tỉnh Bắc Ninh","path_with_type":"Xã Ngọc Xá, Thị xã Quế Võ, Tỉnh Bắc Ninh","code":"09289","parent_code":"259"},"09292":{"name":"Xã Châu Phong","type":"xa","slug":"xa-chau-phong","name_with_type":"Xã Châu Phong","path":"Xã Châu Phong, Thị xã Quế Võ, Tỉnh Bắc Ninh","path_with_type":"Xã Châu Phong, Thị xã Quế Võ, Tỉnh Bắc Ninh","code":"09292","parent_code":"259"},"09295":{"name":"Phường Bồng Lai","type":"phuong","slug":"phuong-bong-lai","name_with_type":"Phường Bồng Lai","path":"Phường Bồng Lai, Thị xã Quế Võ, Tỉnh Bắc Ninh","path_with_type":"Phường Bồng Lai, Thị xã Quế Võ, Tỉnh Bắc Ninh","code":"09295","parent_code":"259"},"09298":{"name":"Phường Cách Bi","type":"phuong","slug":"phuong-cach-bi","name_with_type":"Phường Cách Bi","path":"Phường Cách Bi, Thị xã Quế Võ, Tỉnh Bắc Ninh","path_with_type":"Phường Cách Bi, Thị xã Quế Võ, Tỉnh Bắc Ninh","code":"09298","parent_code":"259"},"09301":{"name":"Xã Đào Viên","type":"xa","slug":"xa-dao-vien","name_with_type":"Xã Đào Viên","path":"Xã Đào Viên, Thị xã Quế Võ, Tỉnh Bắc Ninh","path_with_type":"Xã Đào Viên, Thị xã Quế Võ, Tỉnh Bắc Ninh","code":"09301","parent_code":"259"},"09304":{"name":"Xã Yên Giả","type":"xa","slug":"xa-yen-gia","name_with_type":"Xã Yên Giả","path":"Xã Yên Giả, Thị xã Quế Võ, Tỉnh Bắc Ninh","path_with_type":"Xã Yên Giả, Thị xã Quế Võ, Tỉnh Bắc Ninh","code":"09304","parent_code":"259"},"09307":{"name":"Xã Mộ Đạo","type":"xa","slug":"xa-mo-dao","name_with_type":"Xã Mộ Đạo","path":"Xã Mộ Đạo, Thị xã Quế Võ, Tỉnh Bắc Ninh","path_with_type":"Xã Mộ Đạo, Thị xã Quế Võ, Tỉnh Bắc Ninh","code":"09307","parent_code":"259"},"09310":{"name":"Xã Đức Long","type":"xa","slug":"xa-duc-long","name_with_type":"Xã Đức Long","path":"Xã Đức Long, Thị xã Quế Võ, Tỉnh Bắc Ninh","path_with_type":"Xã Đức Long, Thị xã Quế Võ, Tỉnh Bắc Ninh","code":"09310","parent_code":"259"},"09313":{"name":"Xã Chi Lăng","type":"xa","slug":"xa-chi-lang","name_with_type":"Xã Chi Lăng","path":"Xã Chi Lăng, Thị xã Quế Võ, Tỉnh Bắc Ninh","path_with_type":"Xã Chi Lăng, Thị xã Quế Võ, Tỉnh Bắc Ninh","code":"09313","parent_code":"259"},"09319":{"name":"Thị trấn Lim","type":"thi-tran","slug":"thi-tran-lim","name_with_type":"Thị trấn Lim","path":"Thị trấn Lim, Huyện Tiên Du, Tỉnh Bắc Ninh","path_with_type":"Thị trấn Lim, Huyện Tiên Du, Tỉnh Bắc Ninh","code":"09319","parent_code":"260"},"09322":{"name":"Xã Phú Lâm","type":"xa","slug":"xa-phu-lam","name_with_type":"Xã Phú Lâm","path":"Xã Phú Lâm, Huyện Tiên Du, Tỉnh Bắc Ninh","path_with_type":"Xã Phú Lâm, Huyện Tiên Du, Tỉnh Bắc Ninh","code":"09322","parent_code":"260"},"09328":{"name":"Xã Nội Duệ","type":"xa","slug":"xa-noi-due","name_with_type":"Xã Nội Duệ","path":"Xã Nội Duệ, Huyện Tiên Du, Tỉnh Bắc Ninh","path_with_type":"Xã Nội Duệ, Huyện Tiên Du, Tỉnh Bắc Ninh","code":"09328","parent_code":"260"},"09334":{"name":"Xã Liên Bão","type":"xa","slug":"xa-lien-bao","name_with_type":"Xã Liên Bão","path":"Xã Liên Bão, Huyện Tiên Du, Tỉnh Bắc Ninh","path_with_type":"Xã Liên Bão, Huyện Tiên Du, Tỉnh Bắc Ninh","code":"09334","parent_code":"260"},"09337":{"name":"Xã Hiên Vân","type":"xa","slug":"xa-hien-van","name_with_type":"Xã Hiên Vân","path":"Xã Hiên Vân, Huyện Tiên Du, Tỉnh Bắc Ninh","path_with_type":"Xã Hiên Vân, Huyện Tiên Du, Tỉnh Bắc Ninh","code":"09337","parent_code":"260"},"09340":{"name":"Xã Hoàn Sơn","type":"xa","slug":"xa-hoan-son","name_with_type":"Xã Hoàn Sơn","path":"Xã Hoàn Sơn, Huyện Tiên Du, Tỉnh Bắc Ninh","path_with_type":"Xã Hoàn Sơn, Huyện Tiên Du, Tỉnh Bắc Ninh","code":"09340","parent_code":"260"},"09343":{"name":"Xã Lạc Vệ","type":"xa","slug":"xa-lac-ve","name_with_type":"Xã Lạc Vệ","path":"Xã Lạc Vệ, Huyện Tiên Du, Tỉnh Bắc Ninh","path_with_type":"Xã Lạc Vệ, Huyện Tiên Du, Tỉnh Bắc Ninh","code":"09343","parent_code":"260"},"09346":{"name":"Xã Việt Đoàn","type":"xa","slug":"xa-viet-doan","name_with_type":"Xã Việt Đoàn","path":"Xã Việt Đoàn, Huyện Tiên Du, Tỉnh Bắc Ninh","path_with_type":"Xã Việt Đoàn, Huyện Tiên Du, Tỉnh Bắc Ninh","code":"09346","parent_code":"260"},"09349":{"name":"Xã Phật Tích","type":"xa","slug":"xa-phat-tich","name_with_type":"Xã Phật Tích","path":"Xã Phật Tích, Huyện Tiên Du, Tỉnh Bắc Ninh","path_with_type":"Xã Phật Tích, Huyện Tiên Du, Tỉnh Bắc Ninh","code":"09349","parent_code":"260"},"09352":{"name":"Xã Tân Chi","type":"xa","slug":"xa-tan-chi","name_with_type":"Xã Tân Chi","path":"Xã Tân Chi, Huyện Tiên Du, Tỉnh Bắc Ninh","path_with_type":"Xã Tân Chi, Huyện Tiên Du, Tỉnh Bắc Ninh","code":"09352","parent_code":"260"},"09355":{"name":"Xã Đại Đồng","type":"xa","slug":"xa-dai-dong","name_with_type":"Xã Đại Đồng","path":"Xã Đại Đồng, Huyện Tiên Du, Tỉnh Bắc Ninh","path_with_type":"Xã Đại Đồng, Huyện Tiên Du, Tỉnh Bắc Ninh","code":"09355","parent_code":"260"},"09358":{"name":"Xã Tri Phương","type":"xa","slug":"xa-tri-phuong","name_with_type":"Xã Tri Phương","path":"Xã Tri Phương, Huyện Tiên Du, Tỉnh Bắc Ninh","path_with_type":"Xã Tri Phương, Huyện Tiên Du, Tỉnh Bắc Ninh","code":"09358","parent_code":"260"},"09361":{"name":"Xã Minh Đạo","type":"xa","slug":"xa-minh-dao","name_with_type":"Xã Minh Đạo","path":"Xã Minh Đạo, Huyện Tiên Du, Tỉnh Bắc Ninh","path_with_type":"Xã Minh Đạo, Huyện Tiên Du, Tỉnh Bắc Ninh","code":"09361","parent_code":"260"},"09364":{"name":"Xã Cảnh Hưng","type":"xa","slug":"xa-canh-hung","name_with_type":"Xã Cảnh Hưng","path":"Xã Cảnh Hưng, Huyện Tiên Du, Tỉnh Bắc Ninh","path_with_type":"Xã Cảnh Hưng, Huyện Tiên Du, Tỉnh Bắc Ninh","code":"09364","parent_code":"260"},"09367":{"name":"Phường Đông Ngàn","type":"phuong","slug":"phuong-dong-ngan","name_with_type":"Phường Đông Ngàn","path":"Phường Đông Ngàn, Thành phố Từ Sơn, Tỉnh Bắc Ninh","path_with_type":"Phường Đông Ngàn, Thành phố Từ Sơn, Tỉnh Bắc Ninh","code":"09367","parent_code":"261"},"09370":{"name":"Phường Tam Sơn","type":"phuong","slug":"phuong-tam-son","name_with_type":"Phường Tam Sơn","path":"Phường Tam Sơn, Thành phố Từ Sơn, Tỉnh Bắc Ninh","path_with_type":"Phường Tam Sơn, Thành phố Từ Sơn, Tỉnh Bắc Ninh","code":"09370","parent_code":"261"},"09373":{"name":"Phường Hương Mạc","type":"phuong","slug":"phuong-huong-mac","name_with_type":"Phường Hương Mạc","path":"Phường Hương Mạc, Thành phố Từ Sơn, Tỉnh Bắc Ninh","path_with_type":"Phường Hương Mạc, Thành phố Từ Sơn, Tỉnh Bắc Ninh","code":"09373","parent_code":"261"},"09376":{"name":"Phường Tương Giang","type":"phuong","slug":"phuong-tuong-giang","name_with_type":"Phường Tương Giang","path":"Phường Tương Giang, Thành phố Từ Sơn, Tỉnh Bắc Ninh","path_with_type":"Phường Tương Giang, Thành phố Từ Sơn, Tỉnh Bắc Ninh","code":"09376","parent_code":"261"},"09379":{"name":"Phường Phù Khê","type":"phuong","slug":"phuong-phu-khe","name_with_type":"Phường Phù Khê","path":"Phường Phù Khê, Thành phố Từ Sơn, Tỉnh Bắc Ninh","path_with_type":"Phường Phù Khê, Thành phố Từ Sơn, Tỉnh Bắc Ninh","code":"09379","parent_code":"261"},"09382":{"name":"Phường Đồng Kỵ","type":"phuong","slug":"phuong-dong-ky","name_with_type":"Phường Đồng Kỵ","path":"Phường Đồng Kỵ, Thành phố Từ Sơn, Tỉnh Bắc Ninh","path_with_type":"Phường Đồng Kỵ, Thành phố Từ Sơn, Tỉnh Bắc Ninh","code":"09382","parent_code":"261"},"09383":{"name":"Phường Trang Hạ","type":"phuong","slug":"phuong-trang-ha","name_with_type":"Phường Trang Hạ","path":"Phường Trang Hạ, Thành phố Từ Sơn, Tỉnh Bắc Ninh","path_with_type":"Phường Trang Hạ, Thành phố Từ Sơn, Tỉnh Bắc Ninh","code":"09383","parent_code":"261"},"09385":{"name":"Phường Đồng Nguyên","type":"phuong","slug":"phuong-dong-nguyen","name_with_type":"Phường Đồng Nguyên","path":"Phường Đồng Nguyên, Thành phố Từ Sơn, Tỉnh Bắc Ninh","path_with_type":"Phường Đồng Nguyên, Thành phố Từ Sơn, Tỉnh Bắc Ninh","code":"09385","parent_code":"261"},"09388":{"name":"Phường Châu Khê","type":"phuong","slug":"phuong-chau-khe","name_with_type":"Phường Châu Khê","path":"Phường Châu Khê, Thành phố Từ Sơn, Tỉnh Bắc Ninh","path_with_type":"Phường Châu Khê, Thành phố Từ Sơn, Tỉnh Bắc Ninh","code":"09388","parent_code":"261"},"09391":{"name":"Phường Tân Hồng","type":"phuong","slug":"phuong-tan-hong","name_with_type":"Phường Tân Hồng","path":"Phường Tân Hồng, Thành phố Từ Sơn, Tỉnh Bắc Ninh","path_with_type":"Phường Tân Hồng, Thành phố Từ Sơn, Tỉnh Bắc Ninh","code":"09391","parent_code":"261"},"09394":{"name":"Phường Đình Bảng","type":"phuong","slug":"phuong-dinh-bang","name_with_type":"Phường Đình Bảng","path":"Phường Đình Bảng, Thành phố Từ Sơn, Tỉnh Bắc Ninh","path_with_type":"Phường Đình Bảng, Thành phố Từ Sơn, Tỉnh Bắc Ninh","code":"09394","parent_code":"261"},"09397":{"name":"Phường Phù Chẩn","type":"phuong","slug":"phuong-phu-chan","name_with_type":"Phường Phù Chẩn","path":"Phường Phù Chẩn, Thành phố Từ Sơn, Tỉnh Bắc Ninh","path_with_type":"Phường Phù Chẩn, Thành phố Từ Sơn, Tỉnh Bắc Ninh","code":"09397","parent_code":"261"},"09400":{"name":"Phường Hồ","type":"phuong","slug":"phuong-ho","name_with_type":"Phường Hồ","path":"Phường Hồ, Thị xã Thuận Thành, Tỉnh Bắc Ninh","path_with_type":"Phường Hồ, Thị xã Thuận Thành, Tỉnh Bắc Ninh","code":"09400","parent_code":"262"},"09403":{"name":"Xã Hoài Thượng","type":"xa","slug":"xa-hoai-thuong","name_with_type":"Xã Hoài Thượng","path":"Xã Hoài Thượng, Thị xã Thuận Thành, Tỉnh Bắc Ninh","path_with_type":"Xã Hoài Thượng, Thị xã Thuận Thành, Tỉnh Bắc Ninh","code":"09403","parent_code":"262"},"09406":{"name":"Xã Đại Đồng Thành","type":"xa","slug":"xa-dai-dong-thanh","name_with_type":"Xã Đại Đồng Thành","path":"Xã Đại Đồng Thành, Thị xã Thuận Thành, Tỉnh Bắc Ninh","path_with_type":"Xã Đại Đồng Thành, Thị xã Thuận Thành, Tỉnh Bắc Ninh","code":"09406","parent_code":"262"},"09409":{"name":"Xã Mão Điền","type":"xa","slug":"xa-mao-dien","name_with_type":"Xã Mão Điền","path":"Xã Mão Điền, Thị xã Thuận Thành, Tỉnh Bắc Ninh","path_with_type":"Xã Mão Điền, Thị xã Thuận Thành, Tỉnh Bắc Ninh","code":"09409","parent_code":"262"},"09412":{"name":"Phường Song Hồ","type":"phuong","slug":"phuong-song-ho","name_with_type":"Phường Song Hồ","path":"Phường Song Hồ, Thị xã Thuận Thành, Tỉnh Bắc Ninh","path_with_type":"Phường Song Hồ, Thị xã Thuận Thành, Tỉnh Bắc Ninh","code":"09412","parent_code":"262"},"09415":{"name":"Xã Đình Tổ","type":"xa","slug":"xa-dinh-to","name_with_type":"Xã Đình Tổ","path":"Xã Đình Tổ, Thị xã Thuận Thành, Tỉnh Bắc Ninh","path_with_type":"Xã Đình Tổ, Thị xã Thuận Thành, Tỉnh Bắc Ninh","code":"09415","parent_code":"262"},"09418":{"name":"Phường An Bình","type":"phuong","slug":"phuong-an-binh","name_with_type":"Phường An Bình","path":"Phường An Bình, Thị xã Thuận Thành, Tỉnh Bắc Ninh","path_with_type":"Phường An Bình, Thị xã Thuận Thành, Tỉnh Bắc Ninh","code":"09418","parent_code":"262"},"09421":{"name":"Phường Trí Quả","type":"phuong","slug":"phuong-tri-qua","name_with_type":"Phường Trí Quả","path":"Phường Trí Quả, Thị xã Thuận Thành, Tỉnh Bắc Ninh","path_with_type":"Phường Trí Quả, Thị xã Thuận Thành, Tỉnh Bắc Ninh","code":"09421","parent_code":"262"},"09424":{"name":"Phường Gia Đông","type":"phuong","slug":"phuong-gia-dong","name_with_type":"Phường Gia Đông","path":"Phường Gia Đông, Thị xã Thuận Thành, Tỉnh Bắc Ninh","path_with_type":"Phường Gia Đông, Thị xã Thuận Thành, Tỉnh Bắc Ninh","code":"09424","parent_code":"262"},"09427":{"name":"Phường Thanh Khương","type":"phuong","slug":"phuong-thanh-khuong","name_with_type":"Phường Thanh Khương","path":"Phường Thanh Khương, Thị xã Thuận Thành, Tỉnh Bắc Ninh","path_with_type":"Phường Thanh Khương, Thị xã Thuận Thành, Tỉnh Bắc Ninh","code":"09427","parent_code":"262"},"09430":{"name":"Phường Trạm Lộ","type":"phuong","slug":"phuong-tram-lo","name_with_type":"Phường Trạm Lộ","path":"Phường Trạm Lộ, Thị xã Thuận Thành, Tỉnh Bắc Ninh","path_with_type":"Phường Trạm Lộ, Thị xã Thuận Thành, Tỉnh Bắc Ninh","code":"09430","parent_code":"262"},"09433":{"name":"Phường Xuân Lâm","type":"phuong","slug":"phuong-xuan-lam","name_with_type":"Phường Xuân Lâm","path":"Phường Xuân Lâm, Thị xã Thuận Thành, Tỉnh Bắc Ninh","path_with_type":"Phường Xuân Lâm, Thị xã Thuận Thành, Tỉnh Bắc Ninh","code":"09433","parent_code":"262"},"09436":{"name":"Phường Hà Mãn","type":"phuong","slug":"phuong-ha-man","name_with_type":"Phường Hà Mãn","path":"Phường Hà Mãn, Thị xã Thuận Thành, Tỉnh Bắc Ninh","path_with_type":"Phường Hà Mãn, Thị xã Thuận Thành, Tỉnh Bắc Ninh","code":"09436","parent_code":"262"},"09439":{"name":"Xã Ngũ Thái","type":"xa","slug":"xa-ngu-thai","name_with_type":"Xã Ngũ Thái","path":"Xã Ngũ Thái, Thị xã Thuận Thành, Tỉnh Bắc Ninh","path_with_type":"Xã Ngũ Thái, Thị xã Thuận Thành, Tỉnh Bắc Ninh","code":"09439","parent_code":"262"},"09442":{"name":"Xã Nguyệt Đức","type":"xa","slug":"xa-nguyet-duc","name_with_type":"Xã Nguyệt Đức","path":"Xã Nguyệt Đức, Thị xã Thuận Thành, Tỉnh Bắc Ninh","path_with_type":"Xã Nguyệt Đức, Thị xã Thuận Thành, Tỉnh Bắc Ninh","code":"09442","parent_code":"262"},"09445":{"name":"Phường Ninh Xá","type":"phuong","slug":"phuong-ninh-xa","name_with_type":"Phường Ninh Xá","path":"Phường Ninh Xá, Thị xã Thuận Thành, Tỉnh Bắc Ninh","path_with_type":"Phường Ninh Xá, Thị xã Thuận Thành, Tỉnh Bắc Ninh","code":"09445","parent_code":"262"},"09448":{"name":"Xã Nghĩa Đạo","type":"xa","slug":"xa-nghia-dao","name_with_type":"Xã Nghĩa Đạo","path":"Xã Nghĩa Đạo, Thị xã Thuận Thành, Tỉnh Bắc Ninh","path_with_type":"Xã Nghĩa Đạo, Thị xã Thuận Thành, Tỉnh Bắc Ninh","code":"09448","parent_code":"262"},"09451":{"name":"Xã Song Liễu","type":"xa","slug":"xa-song-lieu","name_with_type":"Xã Song Liễu","path":"Xã Song Liễu, Thị xã Thuận Thành, Tỉnh Bắc Ninh","path_with_type":"Xã Song Liễu, Thị xã Thuận Thành, Tỉnh Bắc Ninh","code":"09451","parent_code":"262"},"09454":{"name":"Thị trấn Gia Bình","type":"thi-tran","slug":"thi-tran-gia-binh","name_with_type":"Thị trấn Gia Bình","path":"Thị trấn Gia Bình, Huyện Gia Bình, Tỉnh Bắc Ninh","path_with_type":"Thị trấn Gia Bình, Huyện Gia Bình, Tỉnh Bắc Ninh","code":"09454","parent_code":"263"},"09457":{"name":"Xã Vạn Ninh","type":"xa","slug":"xa-van-ninh","name_with_type":"Xã Vạn Ninh","path":"Xã Vạn Ninh, Huyện Gia Bình, Tỉnh Bắc Ninh","path_with_type":"Xã Vạn Ninh, Huyện Gia Bình, Tỉnh Bắc Ninh","code":"09457","parent_code":"263"},"09460":{"name":"Xã Thái Bảo","type":"xa","slug":"xa-thai-bao","name_with_type":"Xã Thái Bảo","path":"Xã Thái Bảo, Huyện Gia Bình, Tỉnh Bắc Ninh","path_with_type":"Xã Thái Bảo, Huyện Gia Bình, Tỉnh Bắc Ninh","code":"09460","parent_code":"263"},"09463":{"name":"Xã Giang Sơn","type":"xa","slug":"xa-giang-son","name_with_type":"Xã Giang Sơn","path":"Xã Giang Sơn, Huyện Gia Bình, Tỉnh Bắc Ninh","path_with_type":"Xã Giang Sơn, Huyện Gia Bình, Tỉnh Bắc Ninh","code":"09463","parent_code":"263"},"09466":{"name":"Xã Cao Đức","type":"xa","slug":"xa-cao-duc","name_with_type":"Xã Cao Đức","path":"Xã Cao Đức, Huyện Gia Bình, Tỉnh Bắc Ninh","path_with_type":"Xã Cao Đức, Huyện Gia Bình, Tỉnh Bắc Ninh","code":"09466","parent_code":"263"},"09469":{"name":"Xã Đại Lai","type":"xa","slug":"xa-dai-lai","name_with_type":"Xã Đại Lai","path":"Xã Đại Lai, Huyện Gia Bình, Tỉnh Bắc Ninh","path_with_type":"Xã Đại Lai, Huyện Gia Bình, Tỉnh Bắc Ninh","code":"09469","parent_code":"263"},"09472":{"name":"Xã Song Giang","type":"xa","slug":"xa-song-giang","name_with_type":"Xã Song Giang","path":"Xã Song Giang, Huyện Gia Bình, Tỉnh Bắc Ninh","path_with_type":"Xã Song Giang, Huyện Gia Bình, Tỉnh Bắc Ninh","code":"09472","parent_code":"263"},"09475":{"name":"Xã Bình Dương","type":"xa","slug":"xa-binh-duong","name_with_type":"Xã Bình Dương","path":"Xã Bình Dương, Huyện Gia Bình, Tỉnh Bắc Ninh","path_with_type":"Xã Bình Dương, Huyện Gia Bình, Tỉnh Bắc Ninh","code":"09475","parent_code":"263"},"09478":{"name":"Xã Lãng Ngâm","type":"xa","slug":"xa-lang-ngam","name_with_type":"Xã Lãng Ngâm","path":"Xã Lãng Ngâm, Huyện Gia Bình, Tỉnh Bắc Ninh","path_with_type":"Xã Lãng Ngâm, Huyện Gia Bình, Tỉnh Bắc Ninh","code":"09478","parent_code":"263"},"09481":{"name":"Thị trấn Nhân Thắng","type":"thi-tran","slug":"thi-tran-nhan-thang","name_with_type":"Thị trấn Nhân Thắng","path":"Thị trấn Nhân Thắng, Huyện Gia Bình, Tỉnh Bắc Ninh","path_with_type":"Thị trấn Nhân Thắng, Huyện Gia Bình, Tỉnh Bắc Ninh","code":"09481","parent_code":"263"},"09484":{"name":"Xã Xuân Lai","type":"xa","slug":"xa-xuan-lai","name_with_type":"Xã Xuân Lai","path":"Xã Xuân Lai, Huyện Gia Bình, Tỉnh Bắc Ninh","path_with_type":"Xã Xuân Lai, Huyện Gia Bình, Tỉnh Bắc Ninh","code":"09484","parent_code":"263"},"09487":{"name":"Xã Đông Cứu","type":"xa","slug":"xa-dong-cuu","name_with_type":"Xã Đông Cứu","path":"Xã Đông Cứu, Huyện Gia Bình, Tỉnh Bắc Ninh","path_with_type":"Xã Đông Cứu, Huyện Gia Bình, Tỉnh Bắc Ninh","code":"09487","parent_code":"263"},"09490":{"name":"Xã Đại Bái","type":"xa","slug":"xa-dai-bai","name_with_type":"Xã Đại Bái","path":"Xã Đại Bái, Huyện Gia Bình, Tỉnh Bắc Ninh","path_with_type":"Xã Đại Bái, Huyện Gia Bình, Tỉnh Bắc Ninh","code":"09490","parent_code":"263"},"09493":{"name":"Xã Quỳnh Phú","type":"xa","slug":"xa-quynh-phu","name_with_type":"Xã Quỳnh Phú","path":"Xã Quỳnh Phú, Huyện Gia Bình, Tỉnh Bắc Ninh","path_with_type":"Xã Quỳnh Phú, Huyện Gia Bình, Tỉnh Bắc Ninh","code":"09493","parent_code":"263"},"09496":{"name":"Thị trấn Thứa","type":"thi-tran","slug":"thi-tran-thua","name_with_type":"Thị trấn Thứa","path":"Thị trấn Thứa, Huyện Lương Tài, Tỉnh Bắc Ninh","path_with_type":"Thị trấn Thứa, Huyện Lương Tài, Tỉnh Bắc Ninh","code":"09496","parent_code":"264"},"09499":{"name":"Xã An Thịnh","type":"xa","slug":"xa-an-thinh","name_with_type":"Xã An Thịnh","path":"Xã An Thịnh, Huyện Lương Tài, Tỉnh Bắc Ninh","path_with_type":"Xã An Thịnh, Huyện Lương Tài, Tỉnh Bắc Ninh","code":"09499","parent_code":"264"},"09502":{"name":"Xã Trung Kênh","type":"xa","slug":"xa-trung-kenh","name_with_type":"Xã Trung Kênh","path":"Xã Trung Kênh, Huyện Lương Tài, Tỉnh Bắc Ninh","path_with_type":"Xã Trung Kênh, Huyện Lương Tài, Tỉnh Bắc Ninh","code":"09502","parent_code":"264"},"09505":{"name":"Xã Phú Hòa","type":"xa","slug":"xa-phu-hoa","name_with_type":"Xã Phú Hòa","path":"Xã Phú Hòa, Huyện Lương Tài, Tỉnh Bắc Ninh","path_with_type":"Xã Phú Hòa, Huyện Lương Tài, Tỉnh Bắc Ninh","code":"09505","parent_code":"264"},"09508":{"name":"Xã An Tập","type":"xa","slug":"xa-an-tap","name_with_type":"Xã An Tập","path":"Xã An Tập, Huyện Lương Tài, Tỉnh Bắc Ninh","path_with_type":"Xã An Tập, Huyện Lương Tài, Tỉnh Bắc Ninh","code":"09508","parent_code":"264"},"09511":{"name":"Xã Tân Lãng","type":"xa","slug":"xa-tan-lang","name_with_type":"Xã Tân Lãng","path":"Xã Tân Lãng, Huyện Lương Tài, Tỉnh Bắc Ninh","path_with_type":"Xã Tân Lãng, Huyện Lương Tài, Tỉnh Bắc Ninh","code":"09511","parent_code":"264"},"09514":{"name":"Xã Quảng Phú","type":"xa","slug":"xa-quang-phu","name_with_type":"Xã Quảng Phú","path":"Xã Quảng Phú, Huyện Lương Tài, Tỉnh Bắc Ninh","path_with_type":"Xã Quảng Phú, Huyện Lương Tài, Tỉnh Bắc Ninh","code":"09514","parent_code":"264"},"09517":{"name":"Xã Quang Minh","type":"xa","slug":"xa-quang-minh","name_with_type":"Xã Quang Minh","path":"Xã Quang Minh, Huyện Lương Tài, Tỉnh Bắc Ninh","path_with_type":"Xã Quang Minh, Huyện Lương Tài, Tỉnh Bắc Ninh","code":"09517","parent_code":"264"},"09523":{"name":"Xã Trung Chính","type":"xa","slug":"xa-trung-chinh","name_with_type":"Xã Trung Chính","path":"Xã Trung Chính, Huyện Lương Tài, Tỉnh Bắc Ninh","path_with_type":"Xã Trung Chính, Huyện Lương Tài, Tỉnh Bắc Ninh","code":"09523","parent_code":"264"},"09529":{"name":"Xã Bình Định","type":"xa","slug":"xa-binh-dinh","name_with_type":"Xã Bình Định","path":"Xã Bình Định, Huyện Lương Tài, Tỉnh Bắc Ninh","path_with_type":"Xã Bình Định, Huyện Lương Tài, Tỉnh Bắc Ninh","code":"09529","parent_code":"264"},"09532":{"name":"Xã Phú Lương","type":"xa","slug":"xa-phu-luong","name_with_type":"Xã Phú Lương","path":"Xã Phú Lương, Huyện Lương Tài, Tỉnh Bắc Ninh","path_with_type":"Xã Phú Lương, Huyện Lương Tài, Tỉnh Bắc Ninh","code":"09532","parent_code":"264"},"09535":{"name":"Xã Lâm Thao","type":"xa","slug":"xa-lam-thao","name_with_type":"Xã Lâm Thao","path":"Xã Lâm Thao, Huyện Lương Tài, Tỉnh Bắc Ninh","path_with_type":"Xã Lâm Thao, Huyện Lương Tài, Tỉnh Bắc Ninh","code":"09535","parent_code":"264"}}');
// EXTERNAL MODULE: ./app/utils/index.tsx
var utils = __webpack_require__(90752);
// EXTERNAL MODULE: ./app/components/ui/select.tsx + 3 modules
var ui_select = __webpack_require__(80522);
;// CONCATENATED MODULE: ./app/components/address-merchandise/SelectAddress.tsx








const SelectAddress = (param)=>{
    let { params , setParams  } = param;
    var _listWards_find, _listDistricts_find, _listWards_find1, _listWards_filter;
    const { t  } = (0,esm/* useTranslation */.$G)();
    const listProvinces = (0,utils/* convertObjectToArray */.HS)(tinh_tp_namespaceObject).sort((a, b)=>a.name.localeCompare(b.name));
    const listDistricts = (0,utils/* convertObjectToArray */.HS)(quan_huyen_namespaceObject).sort((a, b)=>a.name.localeCompare(b.name));
    const listWards = (0,utils/* convertObjectToArray */.HS)(xa_phuong_namespaceObject).sort((a, b)=>a.name.localeCompare(b.name));
    const sortedProvices = listProvinces.sort((a, b)=>{
        // Đưa phần tử có index là 10 lên đầu
        if (a.key === "01") return -1;
        if (b.key === "01") return 1;
        // Đưa phần tử có key là 20 đứng sau phần tử có key là 10
        if (a.key === "79") return -1;
        if (b.key === "79") return 1;
        // Giữ nguyên thứ tự cho các phần tử còn lại
        return 0;
    });
    const onValueChange = (value, field)=>{
        if (field === "city") {
            setParams({
                ...params,
                city: value,
                district: "",
                ward: ""
            });
        }
        if (field === "district") {
            var _listWards_find;
            if (!((_listWards_find = listWards === null || listWards === void 0 ? void 0 : listWards.find((item)=>{
                return (item === null || item === void 0 ? void 0 : item.parent_code) === value;
            })) === null || _listWards_find === void 0 ? void 0 : _listWards_find.code)) {
                setParams({
                    ...params,
                    city: params.city,
                    district: value,
                    ward: value
                });
            } else {
                setParams({
                    ...params,
                    city: params.city,
                    district: value,
                    ward: ""
                });
            }
        }
        if (field === "ward") {
            setParams({
                ...params,
                ward: value
            });
        }
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "grid grid-cols-3 gap-2",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(ui_select/* Select */.Ph, {
                    value: params === null || params === void 0 ? void 0 : params.city,
                    onValueChange: (value)=>onValueChange(value, "city"),
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(ui_select/* SelectTrigger */.i4, {
                            className: "w-full border-0 h-[44px] border-b-[1px] md:border text-sm Nunito-600 text-bg-01 dark:text-white dark:bg-white/10 dark:backdrop-blur-[20px] rounded-[16px] text-left",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ui_select/* SelectValue */.ki, {
                                placeholder: t("merchandise.placeholder_province")
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(ui_select/* SelectContent */.Bw, {
                            className: "p-1 rounded-[16px]",
                            children: sortedProvices.map((item)=>/*#__PURE__*/ (0,jsx_runtime.jsx)(ui_select/* SelectItem */.Ql, {
                                    value: item.code,
                                    className: "p-3 rounded-[8px] hover:!bg-bg-disable hover:!text-main-01 text-base Nunito-600 focus:bg-bg-disable focus:text-main-01 dark:hover:!bg-[#F1F1FC]/[.1] dark:focus:!bg-[#F1F1FC]/[.1]",
                                    children: item.name_with_type
                                }, item.code))
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(ui_select/* Select */.Ph, {
                    onValueChange: (value)=>onValueChange(value, "district"),
                    disabled: !(params === null || params === void 0 ? void 0 : params.city),
                    value: params === null || params === void 0 ? void 0 : params.district,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(ui_select/* SelectTrigger */.i4, {
                            className: "w-full border-0 h-[44px] border-b-[1px] md:border text-sm Nunito-600 text-bg-01 dark:text-white dark:bg-white/10 dark:backdrop-blur-[20px] rounded-[16px] text-left",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ui_select/* SelectValue */.ki, {
                                placeholder: t("merchandise.placeholder_district")
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(ui_select/* SelectContent */.Bw, {
                            className: "p-1 rounded-[16px]",
                            children: listDistricts === null || listDistricts === void 0 ? void 0 : listDistricts.filter((item)=>item.parent_code === params.city).map((item)=>/*#__PURE__*/ (0,jsx_runtime.jsx)(ui_select/* SelectItem */.Ql, {
                                    value: item.code,
                                    className: "p-3 rounded-[8px] hover:!bg-bg-disable hover:!text-main-01 text-base Nunito-600 focus:bg-bg-disable focus:text-main-01 dark:hover:!bg-[#F1F1FC]/[.1] dark:focus:!bg-[#F1F1FC]/[.1]",
                                    children: item.name_with_type
                                }, item.code))
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                children: [
                    !((_listWards_find = listWards === null || listWards === void 0 ? void 0 : listWards.find((item)=>{
                        return (item === null || item === void 0 ? void 0 : item.parent_code) === (params === null || params === void 0 ? void 0 : params.district);
                    })) === null || _listWards_find === void 0 ? void 0 : _listWards_find.code) && (params === null || params === void 0 ? void 0 : params.district) && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "w-full h-[44px] p-[12px] rounded-[16px] border border-black/10 text-sm Nunito-600 text-bg-01 dark:text-white dark:bg-white/10 dark:backdrop-blur-[20px] truncate ...",
                        children: (_listDistricts_find = listDistricts === null || listDistricts === void 0 ? void 0 : listDistricts.find((item)=>item.code === params.district)) === null || _listDistricts_find === void 0 ? void 0 : _listDistricts_find.name_with_type
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(ui_select/* Select */.Ph, {
                        onValueChange: (value)=>onValueChange(value, "ward"),
                        disabled: !(params === null || params === void 0 ? void 0 : params.district),
                        value: params === null || params === void 0 ? void 0 : params.ward,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(ui_select/* SelectTrigger */.i4, {
                                className: "".concat(!((_listWards_find1 = listWards === null || listWards === void 0 ? void 0 : listWards.find((item)=>{
                                    return (item === null || item === void 0 ? void 0 : item.parent_code) === (params === null || params === void 0 ? void 0 : params.district);
                                })) === null || _listWards_find1 === void 0 ? void 0 : _listWards_find1.code) && (params === null || params === void 0 ? void 0 : params.district) && "hidden", " w-full h-[44px] border-0 border-b-[1px] md:border text-sm Nunito-600 text-bg-01 dark:text-white dark:bg-white/10 dark:backdrop-blur-[20px] rounded-[16px] text-left"),
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ui_select/* SelectValue */.ki, {
                                    placeholder: t("merchandise.placeholder_ward")
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(ui_select/* SelectContent */.Bw, {
                                className: "p-1 rounded-[16px]",
                                children: (_listWards_filter = listWards === null || listWards === void 0 ? void 0 : listWards.filter((item)=>{
                                    return (item === null || item === void 0 ? void 0 : item.parent_code) === (params === null || params === void 0 ? void 0 : params.district);
                                })) === null || _listWards_filter === void 0 ? void 0 : _listWards_filter.map((item)=>/*#__PURE__*/ (0,jsx_runtime.jsx)(ui_select/* SelectItem */.Ql, {
                                        value: item.code,
                                        className: "p-3 rounded-[8px] hover:!bg-bg-disable hover:!text-main-01 text-base Nunito-600 focus:bg-bg-disable focus:text-main-01 dark:hover:!bg-[#F1F1FC]/[.1] dark:focus:!bg-[#F1F1FC]/[.1]",
                                        children: item.name_with_type
                                    }, item.code))
                            })
                        ]
                    })
                ]
            })
        ]
    });
};

// EXTERNAL MODULE: ./app/services/query-fn/merchandise/merchandise-mutation.ts
var merchandise_mutation = __webpack_require__(213);
// EXTERNAL MODULE: ./app/components/ui/use-toast.ts
var use_toast = __webpack_require__(2786);
// EXTERNAL MODULE: ./node_modules/@tanstack/react-query/build/modern/QueryClientProvider.js
var QueryClientProvider = __webpack_require__(30202);
// EXTERNAL MODULE: ./app/configs/index.ts + 3 modules
var configs = __webpack_require__(54254);
// EXTERNAL MODULE: ./app/hooks/useGAEventsTracker.ts
var useGAEventsTracker = __webpack_require__(64800);
// EXTERNAL MODULE: ./node_modules/@radix-ui/react-dialog/dist/index.mjs
var dist = __webpack_require__(12854);
// EXTERNAL MODULE: ./app/hooks/useFacebookPixel.tsx
var useFacebookPixel = __webpack_require__(70125);
// EXTERNAL MODULE: ./app/containers/merchandise/facebookPixel.ts
var facebookPixel = __webpack_require__(44096);
;// CONCATENATED MODULE: ./app/components/address-merchandise/ModalAddressMerchandise.tsx




















const regexFullname = /^[a-zA-Z\sàáạảãâầấậẩẫăằắặẳẵèéẹẻẽêềếệểễìíịỉĩòóọỏõôồốộổỗơờớợởỡùúụủũưừứựửữỳýỵỷỹđÀÁẠẢÃÂẦẤẬẨẪĂẰẮẶẲẴÈÉẸẺẼÊỀẾỆỂỄÌÍỊỈĨÒÓỌỎÕÔỒỐỘỔỖƠỜỚỢỞỠÙÚỤỦŨƯỪỨỰỬỮỲÝỴỶỸĐ]+$/;
const regexPhone = /^[0-9]+$/;
const initialParams = {
    fullname: "",
    phone: "",
    city: "",
    district: "",
    ward: "",
    address: "",
    status: "backup"
};
const ModalAddressMerchandise = (param)=>{
    let { open , onOpenChange , dataEdit , isEdit  } = param;
    const { t  } = (0,esm/* useTranslation */.$G)();
    const queryClient = (0,QueryClientProvider/* useQueryClient */.NL)();
    const { mutate: addAddress  } = (0,merchandise_mutation/* useMutationCreateAddress */.Ic)();
    const { mutate: updateAddress  } = (0,merchandise_mutation/* useMutationUpdateAddress */.jY)();
    const { toast  } = (0,use_toast/* useToast */.pm)();
    const [flag, setFlag] = (0,react.useState)(false);
    const listProvinces = (0,utils/* convertObjectToArray */.HS)(tinh_tp_namespaceObject).sort((a, b)=>a.name.localeCompare(b.name));
    const listDistricts = (0,utils/* convertObjectToArray */.HS)(quan_huyen_namespaceObject).sort((a, b)=>a.name.localeCompare(b.name));
    const listWards = (0,utils/* convertObjectToArray */.HS)(xa_phuong_namespaceObject).sort((a, b)=>a.name.localeCompare(b.name));
    const [params, setParams] = (0,react.useState)(initialParams);
    const [error, setError] = (0,react.useState)(false);
    const GAEventsTracker = (0,useGAEventsTracker/* default */.Z)("Store_Merchandise");
    const pixel = (0,useFacebookPixel/* useFacebookPixel */.t)();
    (0,react.useEffect)(()=>{
        if (dataEdit === null || dataEdit === void 0 ? void 0 : dataEdit.id) {
            const _city = listProvinces.find((province)=>province.name_with_type === dataEdit.city);
            const _district = listDistricts.find((district)=>district.name_with_type === dataEdit.district);
            const _ward = listWards.find((ward)=>ward.name_with_type === dataEdit.ward && ward.parent_code === _district.code);
            setParams({
                ...dataEdit,
                city: _city.code,
                district: _district.code,
                ward: (_ward === null || _ward === void 0 ? void 0 : _ward.code) || (_district === null || _district === void 0 ? void 0 : _district.code)
            });
        }
    }, [
        dataEdit
    ]);
    const onSubmit = ()=>{
        const _city = listProvinces.find((province)=>province.code === params.city);
        const _district = listDistricts.find((district)=>district.code === params.district);
        const _ward = listWards.find((ward)=>ward.code === params.ward);
        if (!isEdit) {
            addAddress({
                ...params,
                city: _city.name_with_type,
                district: _district.name_with_type,
                ward: (_ward === null || _ward === void 0 ? void 0 : _ward.name_with_type) || (_district === null || _district === void 0 ? void 0 : _district.name_with_type)
            }, {
                onSuccess: ()=>{
                    GAEventsTracker("Add_new_address");
                    toast({
                        variant: "success",
                        title: "Th\xeam địa chỉ th\xe0nh c\xf4ng!"
                    });
                    setParams(initialParams);
                    setError(false);
                    onOpenChange();
                    queryClient.refetchQueries({
                        queryKey: [
                            configs/* QUERY_KEY.MERCHANDISE_ADDRESS */.lP.MERCHANDISE_ADDRESS
                        ]
                    });
                },
                onError (error, variables, context) {
                    var _error_response, _error_response_data, _error_data;
                    console.log(error);
                    toast({
                        variant: "error",
                        title: (error === null || error === void 0 ? void 0 : (_error_response = error.response) === null || _error_response === void 0 ? void 0 : (_error_response_data = _error_response.data) === null || _error_response_data === void 0 ? void 0 : _error_response_data.message) || (error === null || error === void 0 ? void 0 : (_error_data = error.data) === null || _error_data === void 0 ? void 0 : _error_data.message) || "C\xf3 lỗi xảy ra!"
                    });
                }
            });
            facebookPixel/* facebookPixel.onTrackNewAddress */.j.onTrackNewAddress(pixel);
        } else {
            updateAddress({
                ...params,
                city: _city.name_with_type,
                district: _district.name_with_type,
                ward: (_ward === null || _ward === void 0 ? void 0 : _ward.name_with_type) || (_district === null || _district === void 0 ? void 0 : _district.name_with_type),
                id: dataEdit.id,
                status: dataEdit.default ? "default" : "backup"
            }, {
                onSuccess: ()=>{
                    toast({
                        variant: "success",
                        title: "Cập nhật th\xe0nh c\xf4ng!"
                    });
                    setParams(initialParams);
                    onOpenChange();
                    setError(false);
                    queryClient.refetchQueries({
                        queryKey: [
                            configs/* QUERY_KEY.MERCHANDISE_ADDRESS */.lP.MERCHANDISE_ADDRESS
                        ]
                    });
                },
                onError (error, variables, context) {
                    var _error_response, _error_response_data, _error_data;
                    toast({
                        variant: "error",
                        title: (error === null || error === void 0 ? void 0 : (_error_response = error.response) === null || _error_response === void 0 ? void 0 : (_error_response_data = _error_response.data) === null || _error_response_data === void 0 ? void 0 : _error_response_data.message) || (error === null || error === void 0 ? void 0 : (_error_data = error.data) === null || _error_data === void 0 ? void 0 : _error_data.message)
                    });
                }
            });
        }
    };
    const onChangeValue = (value, key)=>{
        setParams({
            ...params,
            [key]: value || ""
        });
    };
    const isFail = !regexFullname.test(params.fullname) || params.fullname === "";
    const renderFullnameInput = (0,react.useMemo)(()=>{
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(input/* Input */.I, {
            onBlur: (e)=>{
                if (e.target.value === "") {
                    setError(true);
                } else {
                    setError(false);
                }
            },
            onChange: (e)=>{
                setError(false);
                if (regexFullname.test(e.target.value) || e.target.value === "") {
                    onChangeValue(e.target.value, "fullname");
                }
            },
            onKeyDown: (e)=>{
                setFlag(true);
            },
            maxLength: 50,
            value: params.fullname,
            placeholder: t("merchandise.placeholder_name"),
            className: "rounded-[16px] border-black/10 text-bg-01 placeholder-neutral-06 dark:text-main-white dark:bg-white/10 ".concat(error && "border-main-red-02")
        });
    }, [
        params.fullname,
        error
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(dialog/* Dialog */.Vq, {
        open: open,
        onOpenChange: ()=>{},
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* DialogTrigger */.hg, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(dialog/* DialogContent */.cZ, {
                onOpenAutoFocus: (e)=>e.preventDefault(),
                id: "modal-add-address",
                className: "sm:rounded-[16px] rounded-[16px] max-w-[90vw] md:max-w-[480px] p-[24px] border-0 focus-visible:outline-none dark:bg-bg-02",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "flex items-center justify-between w-full",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                className: "text-bg-01 Nunito-700 text-base mb-[40px dark:text-main-white",
                                children: t("merchandise.address_title")
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "w-[32px] h-[32px] rounded-[8px] flex items-center justify-center cursor-pointer",
                                onClick: ()=>{
                                    setError(false);
                                    setParams(initialParams);
                                    onOpenChange();
                                },
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(IconClose/* IconClose */.b, {})
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "flex flex-col w-full space-y-[24px]",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "flex flex-col gap-[6px] relative",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                                        className: "text-sm text-neutral-06 Nunito-400 dark:text-main-white",
                                        children: t("merchandise.label_name")
                                    }),
                                    renderFullnameInput,
                                    error && /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                        className: "Nunito-400 text-main-red-02 text-[12px] absolute bottom-[-18px] left-0",
                                        children: t("message.field_invalid", {
                                            field: t("merchandise.label_name")
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "flex flex-col gap-[6px]",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                                        className: "text-sm text-neutral-06 Nunito-400 dark:text-main-white",
                                        children: t("merchandise.label_phone")
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(input/* Input */.I, {
                                        value: params.phone,
                                        maxLength: 11,
                                        minLength: 10,
                                        onChange: (e)=>{
                                            if (regexPhone.test(e.target.value) || e.target.value === "") {
                                                onChangeValue(e.target.value, "phone");
                                            }
                                        },
                                        placeholder: t("merchandise.placeholder_phone"),
                                        className: "rounded-[16px] border-black/10 text-bg-01 placeholder-neutral-06 dark:text-main-white dark:bg-white/10"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "flex flex-col gap-[6px]",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                                        className: "text-sm text-neutral-06 Nunito-400 dark:text-main-white",
                                        children: t("merchandise.label_address")
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(SelectAddress, {
                                        params: params,
                                        setParams: setParams
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "flex flex-col gap-[6px]",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                                        className: "text-sm text-neutral-06 Nunito-400 dark:text-main-white",
                                        children: t("merchandise.label_detail_address")
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(input/* Input */.I, {
                                        onChange: (e)=>{
                                            onChangeValue(e.target.value, "address");
                                        },
                                        value: params.address,
                                        placeholder: t("merchandise.placeholder_detail_address"),
                                        className: "rounded-[16px] border-black/10 text-bg-01 placeholder-neutral-06 dark:text-main-white dark:bg-white/10"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "flex items-center justify-end w-full mt-[32px] gap-[16px]",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ui_button/* Button */.z, {
                                        variant: "none",
                                        className: "text-base bg-bg-button text-neutral-05 Nunito-700 rounded-[16px] dark:text-main-white dark:bg-[#ECECEE1A]",
                                        autoFocus: false,
                                        onClick: ()=>{
                                            setParams(initialParams);
                                            onOpenChange();
                                            setError(false);
                                        },
                                        children: t("common.cancel")
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ui_button/* Button */.z, {
                                        variant: "main",
                                        className: "text-base Nunito-700 rounded-[16px]",
                                        disabled: !params.fullname || !params.phone || !params.address || !params.city || !params.district || !params.ward || error,
                                        onClick: onSubmit,
                                        children: t("reward.confirm")
                                    })
                                ]
                            })
                        ]
                    })
                ]
            })
        ]
    });
};


/***/ }),

/***/ 40577:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "F": function() { return /* binding */ HoverUserAvatar; }
});

// EXTERNAL MODULE: ./node_modules/next/dist/compiled/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(41844);
// EXTERNAL MODULE: ./app/context/index.ts + 2 modules
var context = __webpack_require__(17986);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/react/index.js
var react = __webpack_require__(55784);
// EXTERNAL MODULE: ./app/components/ui/avatar.tsx + 1 modules
var avatar = __webpack_require__(88313);
// EXTERNAL MODULE: ./app/utils/index.tsx
var utils = __webpack_require__(90752);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./app/lib/utils.ts + 1 modules
var lib_utils = __webpack_require__(73848);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__(87462);
// EXTERNAL MODULE: ./node_modules/@radix-ui/primitive/dist/index.mjs
var dist = __webpack_require__(36206);
// EXTERNAL MODULE: ./node_modules/@radix-ui/react-compose-refs/dist/index.mjs
var react_compose_refs_dist = __webpack_require__(28771);
// EXTERNAL MODULE: ./node_modules/@radix-ui/react-context/dist/index.mjs
var react_context_dist = __webpack_require__(25360);
// EXTERNAL MODULE: ./node_modules/@radix-ui/react-dismissable-layer/dist/index.mjs + 1 modules
var react_dismissable_layer_dist = __webpack_require__(46063);
// EXTERNAL MODULE: ./node_modules/@radix-ui/react-id/dist/index.mjs
var react_id_dist = __webpack_require__(91276);
// EXTERNAL MODULE: ./node_modules/@radix-ui/react-popper/dist/index.mjs + 6 modules
var react_popper_dist = __webpack_require__(6565);
// EXTERNAL MODULE: ./node_modules/@radix-ui/react-portal/dist/index.mjs
var react_portal_dist = __webpack_require__(42651);
// EXTERNAL MODULE: ./node_modules/@radix-ui/react-presence/dist/index.mjs
var react_presence_dist = __webpack_require__(29115);
// EXTERNAL MODULE: ./node_modules/@radix-ui/react-primitive/dist/index.mjs
var react_primitive_dist = __webpack_require__(75320);
// EXTERNAL MODULE: ./node_modules/@radix-ui/react-slot/dist/index.mjs
var react_slot_dist = __webpack_require__(88426);
// EXTERNAL MODULE: ./node_modules/@radix-ui/react-use-controllable-state/dist/index.mjs
var react_use_controllable_state_dist = __webpack_require__(77342);
// EXTERNAL MODULE: ./node_modules/@radix-ui/react-visually-hidden/dist/index.mjs
var react_visually_hidden_dist = __webpack_require__(96219);
;// CONCATENATED MODULE: ./node_modules/@radix-ui/react-tooltip/dist/index.mjs






























const [$a093c7e1ec25a057$var$createTooltipContext, $a093c7e1ec25a057$export$1c540a2224f0d865] = (0,react_context_dist/* createContextScope */.b)('Tooltip', [
    react_popper_dist/* createPopperScope */.D7
]);
const $a093c7e1ec25a057$var$usePopperScope = (0,react_popper_dist/* createPopperScope */.D7)();
/* -------------------------------------------------------------------------------------------------
 * TooltipProvider
 * -----------------------------------------------------------------------------------------------*/ const $a093c7e1ec25a057$var$PROVIDER_NAME = 'TooltipProvider';
const $a093c7e1ec25a057$var$DEFAULT_DELAY_DURATION = 700;
const $a093c7e1ec25a057$var$TOOLTIP_OPEN = 'tooltip.open';
const [$a093c7e1ec25a057$var$TooltipProviderContextProvider, $a093c7e1ec25a057$var$useTooltipProviderContext] = $a093c7e1ec25a057$var$createTooltipContext($a093c7e1ec25a057$var$PROVIDER_NAME);
const $a093c7e1ec25a057$export$f78649fb9ca566b8 = (props)=>{
    const { __scopeTooltip: __scopeTooltip , delayDuration: delayDuration = $a093c7e1ec25a057$var$DEFAULT_DELAY_DURATION , skipDelayDuration: skipDelayDuration = 300 , disableHoverableContent: disableHoverableContent = false , children: children  } = props;
    const [isOpenDelayed, setIsOpenDelayed] = (0,react.useState)(true);
    const isPointerInTransitRef = (0,react.useRef)(false);
    const skipDelayTimerRef = (0,react.useRef)(0);
    (0,react.useEffect)(()=>{
        const skipDelayTimer = skipDelayTimerRef.current;
        return ()=>window.clearTimeout(skipDelayTimer)
        ;
    }, []);
    return /*#__PURE__*/ (0,react.createElement)($a093c7e1ec25a057$var$TooltipProviderContextProvider, {
        scope: __scopeTooltip,
        isOpenDelayed: isOpenDelayed,
        delayDuration: delayDuration,
        onOpen: (0,react.useCallback)(()=>{
            window.clearTimeout(skipDelayTimerRef.current);
            setIsOpenDelayed(false);
        }, []),
        onClose: (0,react.useCallback)(()=>{
            window.clearTimeout(skipDelayTimerRef.current);
            skipDelayTimerRef.current = window.setTimeout(()=>setIsOpenDelayed(true)
            , skipDelayDuration);
        }, [
            skipDelayDuration
        ]),
        isPointerInTransitRef: isPointerInTransitRef,
        onPointerInTransitChange: (0,react.useCallback)((inTransit)=>{
            isPointerInTransitRef.current = inTransit;
        }, []),
        disableHoverableContent: disableHoverableContent
    }, children);
};
/*#__PURE__*/ Object.assign($a093c7e1ec25a057$export$f78649fb9ca566b8, {
    displayName: $a093c7e1ec25a057$var$PROVIDER_NAME
});
/* -------------------------------------------------------------------------------------------------
 * Tooltip
 * -----------------------------------------------------------------------------------------------*/ const $a093c7e1ec25a057$var$TOOLTIP_NAME = 'Tooltip';
const [$a093c7e1ec25a057$var$TooltipContextProvider, $a093c7e1ec25a057$var$useTooltipContext] = $a093c7e1ec25a057$var$createTooltipContext($a093c7e1ec25a057$var$TOOLTIP_NAME);
const $a093c7e1ec25a057$export$28c660c63b792dea = (props)=>{
    const { __scopeTooltip: __scopeTooltip , children: children , open: openProp , defaultOpen: defaultOpen = false , onOpenChange: onOpenChange , disableHoverableContent: disableHoverableContentProp , delayDuration: delayDurationProp  } = props;
    const providerContext = $a093c7e1ec25a057$var$useTooltipProviderContext($a093c7e1ec25a057$var$TOOLTIP_NAME, props.__scopeTooltip);
    const popperScope = $a093c7e1ec25a057$var$usePopperScope(__scopeTooltip);
    const [trigger, setTrigger] = (0,react.useState)(null);
    const contentId = (0,react_id_dist/* useId */.M)();
    const openTimerRef = (0,react.useRef)(0);
    const disableHoverableContent = disableHoverableContentProp !== null && disableHoverableContentProp !== void 0 ? disableHoverableContentProp : providerContext.disableHoverableContent;
    const delayDuration = delayDurationProp !== null && delayDurationProp !== void 0 ? delayDurationProp : providerContext.delayDuration;
    const wasOpenDelayedRef = (0,react.useRef)(false);
    const [open1 = false, setOpen] = (0,react_use_controllable_state_dist/* useControllableState */.T)({
        prop: openProp,
        defaultProp: defaultOpen,
        onChange: (open)=>{
            if (open) {
                providerContext.onOpen(); // as `onChange` is called within a lifecycle method we
                // avoid dispatching via `dispatchDiscreteCustomEvent`.
                document.dispatchEvent(new CustomEvent($a093c7e1ec25a057$var$TOOLTIP_OPEN));
            } else providerContext.onClose();
            onOpenChange === null || onOpenChange === void 0 || onOpenChange(open);
        }
    });
    const stateAttribute = (0,react.useMemo)(()=>{
        return open1 ? wasOpenDelayedRef.current ? 'delayed-open' : 'instant-open' : 'closed';
    }, [
        open1
    ]);
    const handleOpen = (0,react.useCallback)(()=>{
        window.clearTimeout(openTimerRef.current);
        wasOpenDelayedRef.current = false;
        setOpen(true);
    }, [
        setOpen
    ]);
    const handleClose = (0,react.useCallback)(()=>{
        window.clearTimeout(openTimerRef.current);
        setOpen(false);
    }, [
        setOpen
    ]);
    const handleDelayedOpen = (0,react.useCallback)(()=>{
        window.clearTimeout(openTimerRef.current);
        openTimerRef.current = window.setTimeout(()=>{
            wasOpenDelayedRef.current = true;
            setOpen(true);
        }, delayDuration);
    }, [
        delayDuration,
        setOpen
    ]);
    (0,react.useEffect)(()=>{
        return ()=>window.clearTimeout(openTimerRef.current)
        ;
    }, []);
    return /*#__PURE__*/ (0,react.createElement)(react_popper_dist/* Root */.fC, popperScope, /*#__PURE__*/ (0,react.createElement)($a093c7e1ec25a057$var$TooltipContextProvider, {
        scope: __scopeTooltip,
        contentId: contentId,
        open: open1,
        stateAttribute: stateAttribute,
        trigger: trigger,
        onTriggerChange: setTrigger,
        onTriggerEnter: (0,react.useCallback)(()=>{
            if (providerContext.isOpenDelayed) handleDelayedOpen();
            else handleOpen();
        }, [
            providerContext.isOpenDelayed,
            handleDelayedOpen,
            handleOpen
        ]),
        onTriggerLeave: (0,react.useCallback)(()=>{
            if (disableHoverableContent) handleClose();
            else // Clear the timer in case the pointer leaves the trigger before the tooltip is opened.
            window.clearTimeout(openTimerRef.current);
        }, [
            handleClose,
            disableHoverableContent
        ]),
        onOpen: handleOpen,
        onClose: handleClose,
        disableHoverableContent: disableHoverableContent
    }, children));
};
/*#__PURE__*/ Object.assign($a093c7e1ec25a057$export$28c660c63b792dea, {
    displayName: $a093c7e1ec25a057$var$TOOLTIP_NAME
});
/* -------------------------------------------------------------------------------------------------
 * TooltipTrigger
 * -----------------------------------------------------------------------------------------------*/ const $a093c7e1ec25a057$var$TRIGGER_NAME = 'TooltipTrigger';
const $a093c7e1ec25a057$export$8c610744efcf8a1d = /*#__PURE__*/ (0,react.forwardRef)((props, forwardedRef)=>{
    const { __scopeTooltip: __scopeTooltip , ...triggerProps } = props;
    const context = $a093c7e1ec25a057$var$useTooltipContext($a093c7e1ec25a057$var$TRIGGER_NAME, __scopeTooltip);
    const providerContext = $a093c7e1ec25a057$var$useTooltipProviderContext($a093c7e1ec25a057$var$TRIGGER_NAME, __scopeTooltip);
    const popperScope = $a093c7e1ec25a057$var$usePopperScope(__scopeTooltip);
    const ref = (0,react.useRef)(null);
    const composedRefs = (0,react_compose_refs_dist/* useComposedRefs */.e)(forwardedRef, ref, context.onTriggerChange);
    const isPointerDownRef = (0,react.useRef)(false);
    const hasPointerMoveOpenedRef = (0,react.useRef)(false);
    const handlePointerUp = (0,react.useCallback)(()=>isPointerDownRef.current = false
    , []);
    (0,react.useEffect)(()=>{
        return ()=>document.removeEventListener('pointerup', handlePointerUp)
        ;
    }, [
        handlePointerUp
    ]);
    return /*#__PURE__*/ (0,react.createElement)(react_popper_dist/* Anchor */.ee, (0,esm_extends/* default */.Z)({
        asChild: true
    }, popperScope), /*#__PURE__*/ (0,react.createElement)(react_primitive_dist/* Primitive.button */.WV.button, (0,esm_extends/* default */.Z)({
        // We purposefully avoid adding `type=button` here because tooltip triggers are also
        // commonly anchors and the anchor `type` attribute signifies MIME type.
        "aria-describedby": context.open ? context.contentId : undefined,
        "data-state": context.stateAttribute
    }, triggerProps, {
        ref: composedRefs,
        onPointerMove: (0,dist/* composeEventHandlers */.M)(props.onPointerMove, (event)=>{
            if (event.pointerType === 'touch') return;
            if (!hasPointerMoveOpenedRef.current && !providerContext.isPointerInTransitRef.current) {
                context.onTriggerEnter();
                hasPointerMoveOpenedRef.current = true;
            }
        }),
        onPointerLeave: (0,dist/* composeEventHandlers */.M)(props.onPointerLeave, ()=>{
            context.onTriggerLeave();
            hasPointerMoveOpenedRef.current = false;
        }),
        onPointerDown: (0,dist/* composeEventHandlers */.M)(props.onPointerDown, ()=>{
            isPointerDownRef.current = true;
            document.addEventListener('pointerup', handlePointerUp, {
                once: true
            });
        }),
        onFocus: (0,dist/* composeEventHandlers */.M)(props.onFocus, ()=>{
            if (!isPointerDownRef.current) context.onOpen();
        }),
        onBlur: (0,dist/* composeEventHandlers */.M)(props.onBlur, context.onClose),
        onClick: (0,dist/* composeEventHandlers */.M)(props.onClick, context.onClose)
    })));
});
/*#__PURE__*/ Object.assign($a093c7e1ec25a057$export$8c610744efcf8a1d, {
    displayName: $a093c7e1ec25a057$var$TRIGGER_NAME
});
/* -------------------------------------------------------------------------------------------------
 * TooltipPortal
 * -----------------------------------------------------------------------------------------------*/ const $a093c7e1ec25a057$var$PORTAL_NAME = 'TooltipPortal';
const [$a093c7e1ec25a057$var$PortalProvider, $a093c7e1ec25a057$var$usePortalContext] = $a093c7e1ec25a057$var$createTooltipContext($a093c7e1ec25a057$var$PORTAL_NAME, {
    forceMount: undefined
});
const $a093c7e1ec25a057$export$7b36b8f925ab7497 = (props)=>{
    const { __scopeTooltip: __scopeTooltip , forceMount: forceMount , children: children , container: container  } = props;
    const context = $a093c7e1ec25a057$var$useTooltipContext($a093c7e1ec25a057$var$PORTAL_NAME, __scopeTooltip);
    return /*#__PURE__*/ (0,react.createElement)($a093c7e1ec25a057$var$PortalProvider, {
        scope: __scopeTooltip,
        forceMount: forceMount
    }, /*#__PURE__*/ (0,react.createElement)(react_presence_dist/* Presence */.z, {
        present: forceMount || context.open
    }, /*#__PURE__*/ (0,react.createElement)(react_portal_dist/* Portal */.h, {
        asChild: true,
        container: container
    }, children)));
};
/*#__PURE__*/ Object.assign($a093c7e1ec25a057$export$7b36b8f925ab7497, {
    displayName: $a093c7e1ec25a057$var$PORTAL_NAME
});
/* -------------------------------------------------------------------------------------------------
 * TooltipContent
 * -----------------------------------------------------------------------------------------------*/ const $a093c7e1ec25a057$var$CONTENT_NAME = 'TooltipContent';
const $a093c7e1ec25a057$export$e9003e2be37ec060 = /*#__PURE__*/ (0,react.forwardRef)((props, forwardedRef)=>{
    const portalContext = $a093c7e1ec25a057$var$usePortalContext($a093c7e1ec25a057$var$CONTENT_NAME, props.__scopeTooltip);
    const { forceMount: forceMount = portalContext.forceMount , side: side = 'top' , ...contentProps } = props;
    const context = $a093c7e1ec25a057$var$useTooltipContext($a093c7e1ec25a057$var$CONTENT_NAME, props.__scopeTooltip);
    return /*#__PURE__*/ (0,react.createElement)(react_presence_dist/* Presence */.z, {
        present: forceMount || context.open
    }, context.disableHoverableContent ? /*#__PURE__*/ (0,react.createElement)($a093c7e1ec25a057$var$TooltipContentImpl, (0,esm_extends/* default */.Z)({
        side: side
    }, contentProps, {
        ref: forwardedRef
    })) : /*#__PURE__*/ (0,react.createElement)($a093c7e1ec25a057$var$TooltipContentHoverable, (0,esm_extends/* default */.Z)({
        side: side
    }, contentProps, {
        ref: forwardedRef
    })));
});
const $a093c7e1ec25a057$var$TooltipContentHoverable = /*#__PURE__*/ (0,react.forwardRef)((props, forwardedRef)=>{
    const context = $a093c7e1ec25a057$var$useTooltipContext($a093c7e1ec25a057$var$CONTENT_NAME, props.__scopeTooltip);
    const providerContext = $a093c7e1ec25a057$var$useTooltipProviderContext($a093c7e1ec25a057$var$CONTENT_NAME, props.__scopeTooltip);
    const ref = (0,react.useRef)(null);
    const composedRefs = (0,react_compose_refs_dist/* useComposedRefs */.e)(forwardedRef, ref);
    const [pointerGraceArea, setPointerGraceArea] = (0,react.useState)(null);
    const { trigger: trigger , onClose: onClose  } = context;
    const content = ref.current;
    const { onPointerInTransitChange: onPointerInTransitChange  } = providerContext;
    const handleRemoveGraceArea = (0,react.useCallback)(()=>{
        setPointerGraceArea(null);
        onPointerInTransitChange(false);
    }, [
        onPointerInTransitChange
    ]);
    const handleCreateGraceArea = (0,react.useCallback)((event, hoverTarget)=>{
        const currentTarget = event.currentTarget;
        const exitPoint = {
            x: event.clientX,
            y: event.clientY
        };
        const exitSide = $a093c7e1ec25a057$var$getExitSideFromRect(exitPoint, currentTarget.getBoundingClientRect());
        const paddedExitPoints = $a093c7e1ec25a057$var$getPaddedExitPoints(exitPoint, exitSide);
        const hoverTargetPoints = $a093c7e1ec25a057$var$getPointsFromRect(hoverTarget.getBoundingClientRect());
        const graceArea = $a093c7e1ec25a057$var$getHull([
            ...paddedExitPoints,
            ...hoverTargetPoints
        ]);
        setPointerGraceArea(graceArea);
        onPointerInTransitChange(true);
    }, [
        onPointerInTransitChange
    ]);
    (0,react.useEffect)(()=>{
        return ()=>handleRemoveGraceArea()
        ;
    }, [
        handleRemoveGraceArea
    ]);
    (0,react.useEffect)(()=>{
        if (trigger && content) {
            const handleTriggerLeave = (event)=>handleCreateGraceArea(event, content)
            ;
            const handleContentLeave = (event)=>handleCreateGraceArea(event, trigger)
            ;
            trigger.addEventListener('pointerleave', handleTriggerLeave);
            content.addEventListener('pointerleave', handleContentLeave);
            return ()=>{
                trigger.removeEventListener('pointerleave', handleTriggerLeave);
                content.removeEventListener('pointerleave', handleContentLeave);
            };
        }
    }, [
        trigger,
        content,
        handleCreateGraceArea,
        handleRemoveGraceArea
    ]);
    (0,react.useEffect)(()=>{
        if (pointerGraceArea) {
            const handleTrackPointerGrace = (event)=>{
                const target = event.target;
                const pointerPosition = {
                    x: event.clientX,
                    y: event.clientY
                };
                const hasEnteredTarget = (trigger === null || trigger === void 0 ? void 0 : trigger.contains(target)) || (content === null || content === void 0 ? void 0 : content.contains(target));
                const isPointerOutsideGraceArea = !$a093c7e1ec25a057$var$isPointInPolygon(pointerPosition, pointerGraceArea);
                if (hasEnteredTarget) handleRemoveGraceArea();
                else if (isPointerOutsideGraceArea) {
                    handleRemoveGraceArea();
                    onClose();
                }
            };
            document.addEventListener('pointermove', handleTrackPointerGrace);
            return ()=>document.removeEventListener('pointermove', handleTrackPointerGrace)
            ;
        }
    }, [
        trigger,
        content,
        pointerGraceArea,
        onClose,
        handleRemoveGraceArea
    ]);
    return /*#__PURE__*/ (0,react.createElement)($a093c7e1ec25a057$var$TooltipContentImpl, (0,esm_extends/* default */.Z)({}, props, {
        ref: composedRefs
    }));
});
const [$a093c7e1ec25a057$var$VisuallyHiddenContentContextProvider, $a093c7e1ec25a057$var$useVisuallyHiddenContentContext] = $a093c7e1ec25a057$var$createTooltipContext($a093c7e1ec25a057$var$TOOLTIP_NAME, {
    isInside: false
});
const $a093c7e1ec25a057$var$TooltipContentImpl = /*#__PURE__*/ (0,react.forwardRef)((props, forwardedRef)=>{
    const { __scopeTooltip: __scopeTooltip , children: children , 'aria-label': ariaLabel , onEscapeKeyDown: onEscapeKeyDown , onPointerDownOutside: onPointerDownOutside , ...contentProps } = props;
    const context = $a093c7e1ec25a057$var$useTooltipContext($a093c7e1ec25a057$var$CONTENT_NAME, __scopeTooltip);
    const popperScope = $a093c7e1ec25a057$var$usePopperScope(__scopeTooltip);
    const { onClose: onClose  } = context; // Close this tooltip if another one opens
    (0,react.useEffect)(()=>{
        document.addEventListener($a093c7e1ec25a057$var$TOOLTIP_OPEN, onClose);
        return ()=>document.removeEventListener($a093c7e1ec25a057$var$TOOLTIP_OPEN, onClose)
        ;
    }, [
        onClose
    ]); // Close the tooltip if the trigger is scrolled
    (0,react.useEffect)(()=>{
        if (context.trigger) {
            const handleScroll = (event)=>{
                const target = event.target;
                if (target !== null && target !== void 0 && target.contains(context.trigger)) onClose();
            };
            window.addEventListener('scroll', handleScroll, {
                capture: true
            });
            return ()=>window.removeEventListener('scroll', handleScroll, {
                    capture: true
                })
            ;
        }
    }, [
        context.trigger,
        onClose
    ]);
    return /*#__PURE__*/ (0,react.createElement)(react_dismissable_layer_dist/* DismissableLayer */.XB, {
        asChild: true,
        disableOutsidePointerEvents: false,
        onEscapeKeyDown: onEscapeKeyDown,
        onPointerDownOutside: onPointerDownOutside,
        onFocusOutside: (event)=>event.preventDefault()
        ,
        onDismiss: onClose
    }, /*#__PURE__*/ (0,react.createElement)(react_popper_dist/* Content */.VY, (0,esm_extends/* default */.Z)({
        "data-state": context.stateAttribute
    }, popperScope, contentProps, {
        ref: forwardedRef,
        style: {
            ...contentProps.style,
            '--radix-tooltip-content-transform-origin': 'var(--radix-popper-transform-origin)',
            '--radix-tooltip-content-available-width': 'var(--radix-popper-available-width)',
            '--radix-tooltip-content-available-height': 'var(--radix-popper-available-height)',
            '--radix-tooltip-trigger-width': 'var(--radix-popper-anchor-width)',
            '--radix-tooltip-trigger-height': 'var(--radix-popper-anchor-height)'
        }
    }), /*#__PURE__*/ (0,react.createElement)(react_slot_dist/* Slottable */.A4, null, children), /*#__PURE__*/ (0,react.createElement)($a093c7e1ec25a057$var$VisuallyHiddenContentContextProvider, {
        scope: __scopeTooltip,
        isInside: true
    }, /*#__PURE__*/ (0,react.createElement)(react_visually_hidden_dist/* Root */.f, {
        id: context.contentId,
        role: "tooltip"
    }, ariaLabel || children))));
});
/*#__PURE__*/ Object.assign($a093c7e1ec25a057$export$e9003e2be37ec060, {
    displayName: $a093c7e1ec25a057$var$CONTENT_NAME
});
/* -------------------------------------------------------------------------------------------------
 * TooltipArrow
 * -----------------------------------------------------------------------------------------------*/ const $a093c7e1ec25a057$var$ARROW_NAME = 'TooltipArrow';
const $a093c7e1ec25a057$export$c27ee0ad710f7559 = /*#__PURE__*/ (0,react.forwardRef)((props, forwardedRef)=>{
    const { __scopeTooltip: __scopeTooltip , ...arrowProps } = props;
    const popperScope = $a093c7e1ec25a057$var$usePopperScope(__scopeTooltip);
    const visuallyHiddenContentContext = $a093c7e1ec25a057$var$useVisuallyHiddenContentContext($a093c7e1ec25a057$var$ARROW_NAME, __scopeTooltip); // if the arrow is inside the `VisuallyHidden`, we don't want to render it all to
    // prevent issues in positioning the arrow due to the duplicate
    return visuallyHiddenContentContext.isInside ? null : /*#__PURE__*/ (0,react.createElement)(react_popper_dist/* Arrow */.Eh, (0,esm_extends/* default */.Z)({}, popperScope, arrowProps, {
        ref: forwardedRef
    }));
});
/*#__PURE__*/ Object.assign($a093c7e1ec25a057$export$c27ee0ad710f7559, {
    displayName: $a093c7e1ec25a057$var$ARROW_NAME
});
/* -----------------------------------------------------------------------------------------------*/ function $a093c7e1ec25a057$var$getExitSideFromRect(point, rect) {
    const top = Math.abs(rect.top - point.y);
    const bottom = Math.abs(rect.bottom - point.y);
    const right = Math.abs(rect.right - point.x);
    const left = Math.abs(rect.left - point.x);
    switch(Math.min(top, bottom, right, left)){
        case left:
            return 'left';
        case right:
            return 'right';
        case top:
            return 'top';
        case bottom:
            return 'bottom';
        default:
            throw new Error('unreachable');
    }
}
function $a093c7e1ec25a057$var$getPaddedExitPoints(exitPoint, exitSide, padding = 5) {
    const paddedExitPoints = [];
    switch(exitSide){
        case 'top':
            paddedExitPoints.push({
                x: exitPoint.x - padding,
                y: exitPoint.y + padding
            }, {
                x: exitPoint.x + padding,
                y: exitPoint.y + padding
            });
            break;
        case 'bottom':
            paddedExitPoints.push({
                x: exitPoint.x - padding,
                y: exitPoint.y - padding
            }, {
                x: exitPoint.x + padding,
                y: exitPoint.y - padding
            });
            break;
        case 'left':
            paddedExitPoints.push({
                x: exitPoint.x + padding,
                y: exitPoint.y - padding
            }, {
                x: exitPoint.x + padding,
                y: exitPoint.y + padding
            });
            break;
        case 'right':
            paddedExitPoints.push({
                x: exitPoint.x - padding,
                y: exitPoint.y - padding
            }, {
                x: exitPoint.x - padding,
                y: exitPoint.y + padding
            });
            break;
    }
    return paddedExitPoints;
}
function $a093c7e1ec25a057$var$getPointsFromRect(rect) {
    const { top: top , right: right , bottom: bottom , left: left  } = rect;
    return [
        {
            x: left,
            y: top
        },
        {
            x: right,
            y: top
        },
        {
            x: right,
            y: bottom
        },
        {
            x: left,
            y: bottom
        }
    ];
} // Determine if a point is inside of a polygon.
// Based on https://github.com/substack/point-in-polygon
function $a093c7e1ec25a057$var$isPointInPolygon(point, polygon) {
    const { x: x , y: y  } = point;
    let inside = false;
    for(let i = 0, j = polygon.length - 1; i < polygon.length; j = i++){
        const xi = polygon[i].x;
        const yi = polygon[i].y;
        const xj = polygon[j].x;
        const yj = polygon[j].y; // prettier-ignore
        const intersect = yi > y !== yj > y && x < (xj - xi) * (y - yi) / (yj - yi) + xi;
        if (intersect) inside = !inside;
    }
    return inside;
} // Returns a new array of points representing the convex hull of the given set of points.
// https://www.nayuki.io/page/convex-hull-algorithm
function $a093c7e1ec25a057$var$getHull(points) {
    const newPoints = points.slice();
    newPoints.sort((a, b)=>{
        if (a.x < b.x) return -1;
        else if (a.x > b.x) return 1;
        else if (a.y < b.y) return -1;
        else if (a.y > b.y) return 1;
        else return 0;
    });
    return $a093c7e1ec25a057$var$getHullPresorted(newPoints);
} // Returns the convex hull, assuming that each points[i] <= points[i + 1]. Runs in O(n) time.
function $a093c7e1ec25a057$var$getHullPresorted(points) {
    if (points.length <= 1) return points.slice();
    const upperHull = [];
    for(let i = 0; i < points.length; i++){
        const p = points[i];
        while(upperHull.length >= 2){
            const q = upperHull[upperHull.length - 1];
            const r = upperHull[upperHull.length - 2];
            if ((q.x - r.x) * (p.y - r.y) >= (q.y - r.y) * (p.x - r.x)) upperHull.pop();
            else break;
        }
        upperHull.push(p);
    }
    upperHull.pop();
    const lowerHull = [];
    for(let i1 = points.length - 1; i1 >= 0; i1--){
        const p = points[i1];
        while(lowerHull.length >= 2){
            const q = lowerHull[lowerHull.length - 1];
            const r = lowerHull[lowerHull.length - 2];
            if ((q.x - r.x) * (p.y - r.y) >= (q.y - r.y) * (p.x - r.x)) lowerHull.pop();
            else break;
        }
        lowerHull.push(p);
    }
    lowerHull.pop();
    if (upperHull.length === 1 && lowerHull.length === 1 && upperHull[0].x === lowerHull[0].x && upperHull[0].y === lowerHull[0].y) return upperHull;
    else return upperHull.concat(lowerHull);
}
const $a093c7e1ec25a057$export$2881499e37b75b9a = $a093c7e1ec25a057$export$f78649fb9ca566b8;
const $a093c7e1ec25a057$export$be92b6f5f03c0fe9 = $a093c7e1ec25a057$export$28c660c63b792dea;
const $a093c7e1ec25a057$export$41fb9f06171c75f4 = $a093c7e1ec25a057$export$8c610744efcf8a1d;
const $a093c7e1ec25a057$export$602eac185826482c = (/* unused pure expression or super */ null && ($a093c7e1ec25a057$export$7b36b8f925ab7497));
const $a093c7e1ec25a057$export$7c6e2c02157bb7d2 = $a093c7e1ec25a057$export$e9003e2be37ec060;
const $a093c7e1ec25a057$export$21b07c8f274aebd5 = (/* unused pure expression or super */ null && ($a093c7e1ec25a057$export$c27ee0ad710f7559));





//# sourceMappingURL=index.mjs.map

;// CONCATENATED MODULE: ./app/components/ui/tooltip.tsx




const TooltipProvider = $a093c7e1ec25a057$export$2881499e37b75b9a;
const Tooltip = $a093c7e1ec25a057$export$be92b6f5f03c0fe9;
const TooltipTrigger = $a093c7e1ec25a057$export$41fb9f06171c75f4;
const TooltipContent = /*#__PURE__*/ react.forwardRef((param, ref)=>/*#__PURE__*/ {
    let { className , sideOffset =4 , ...props } = param;
    return (0,jsx_runtime.jsx)($a093c7e1ec25a057$export$7c6e2c02157bb7d2, {
        ref: ref,
        sideOffset: sideOffset,
        className: (0,lib_utils.cn)("z-50 overflow-hidden rounded-md border bg-popover px-3 py-1.5 text-sm text-popover-foreground shadow-md animate-in fade-in-0 zoom-in-95 data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=closed]:zoom-out-95 data-[side=bottom]:slide-in-from-top-2 data-[side=left]:slide-in-from-right-2 data-[side=right]:slide-in-from-left-2 data-[side=top]:slide-in-from-bottom-2", className),
        ...props
    });
});
TooltipContent.displayName = $a093c7e1ec25a057$export$7c6e2c02157bb7d2.displayName;


// EXTERNAL MODULE: ./app/components/connect-action/GroupConnectAction.tsx
var GroupConnectAction = __webpack_require__(95372);
// EXTERNAL MODULE: ./app/components/connect-action/GroupFollowAction.tsx
var GroupFollowAction = __webpack_require__(10727);
// EXTERNAL MODULE: ./app/hooks/useGAEventsTracker.ts
var useGAEventsTracker = __webpack_require__(64800);
;// CONCATENATED MODULE: ./app/components/app-avatar/HoverUserAvatar.tsx











const EXAMPLE_SIZE = 40;
const HOVER_DELAY = 300;
const HoverUserAvatar = (param)=>{
    let { avatarUser , size =EXAMPLE_SIZE , text , subtext  } = param;
    const router = (0,next_router.useRouter)();
    const { userInfo  } = (0,react.useContext)(context/* AppContext */.Il);
    const GAEventsTracker = (0,useGAEventsTracker/* default */.Z)("Profile");
    const onNavigateToProfile = (e)=>{
        e.stopPropagation();
        if ("authentic" in avatarUser && !!(avatarUser === null || avatarUser === void 0 ? void 0 : avatarUser.authentic)) {
            GAEventsTracker("Profile_infor");
            if (!!(avatarUser === null || avatarUser === void 0 ? void 0 : avatarUser.alias)) {
                router.push("/user/".concat(avatarUser === null || avatarUser === void 0 ? void 0 : avatarUser.alias));
            } else if ("userid" in avatarUser) {
                router.push("/user/".concat(avatarUser === null || avatarUser === void 0 ? void 0 : avatarUser.userid));
            } else {
                router.push("/user/".concat(avatarUser === null || avatarUser === void 0 ? void 0 : avatarUser.id));
            }
        }
    };
    const renderTriggerAvatar = ()=>{
        var _avatarUser_fullname;
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "flex items-center gap-4 cursor-pointer w-fit group",
            onClick: onNavigateToProfile,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "relative",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(avatar/* Avatar */.qE, {
                            className: "rounded-full w-[".concat(size, "px] h-[").concat(size, "px]"),
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(avatar/* AvatarImage */.F$, {
                                    src: !!(avatarUser === null || avatarUser === void 0 ? void 0 : avatarUser.small_avatar) ? avatarUser === null || avatarUser === void 0 ? void 0 : avatarUser.small_avatar : !!(avatarUser === null || avatarUser === void 0 ? void 0 : avatarUser.avatar) ? avatarUser === null || avatarUser === void 0 ? void 0 : avatarUser.avatar : "",
                                    alt: avatarUser === null || avatarUser === void 0 ? void 0 : avatarUser.fullname,
                                    height: size,
                                    width: size,
                                    className: "object-cover aspect-square w-[".concat(size, "px] h-[").concat(size, "px] rounded-full")
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(avatar/* AvatarFallback */.Q5, {
                                    className: "flex items-center justify-center w-full text-white bg-main-01",
                                    children: (0,utils/* convertNameString */.Nf)((_avatarUser_fullname = avatarUser === null || avatarUser === void 0 ? void 0 : avatarUser.fullname) !== null && _avatarUser_fullname !== void 0 ? _avatarUser_fullname : "P")
                                })
                            ]
                        }),
                        !!(avatarUser === null || avatarUser === void 0 ? void 0 : avatarUser.frame_avatar) && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "w-[".concat(size, "px] h-[").concat(size, "px] absolute top-0 left-0 rounded-full z-20"),
                            style: {
                                backgroundImage: "url(".concat(avatarUser === null || avatarUser === void 0 ? void 0 : avatarUser.frame_avatar, ")"),
                                backgroundSize: "100%"
                            }
                        })
                    ]
                }),
                !!text.node ? /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                    children: text.node
                }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "flex flex-col",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                            className: (0,lib_utils.cn)("flex items-center gap-[12px] ", text.className),
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    className: (0,lib_utils.cn)("line-clamp-1", text.className),
                                    children: text.text
                                }),
                                "authentic" in avatarUser && !!(avatarUser === null || avatarUser === void 0 ? void 0 : avatarUser.authentic) && /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
                                        width: "16",
                                        height: "16",
                                        viewBox: "0 0 16 16",
                                        fill: "none",
                                        xmlns: "http://www.w3.org/2000/svg",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                            fillRule: "evenodd",
                                            clipRule: "evenodd",
                                            d: "M7.9987 14.6663C11.6806 14.6663 14.6654 11.6816 14.6654 7.99967C14.6654 4.31778 11.6806 1.33301 7.9987 1.33301C4.3168 1.33301 1.33203 4.31778 1.33203 7.99967C1.33203 11.6816 4.3168 14.6663 7.9987 14.6663ZM11.06 6.30667C11.2296 6.08869 11.1903 5.77456 10.9723 5.60502C10.7544 5.43549 10.4402 5.47475 10.2707 5.69273L7.59936 9.1273C7.53996 9.20367 7.42822 9.21358 7.35631 9.14886L5.66652 7.62805C5.46126 7.44332 5.14512 7.45996 4.96039 7.66522C4.77566 7.87047 4.7923 8.18661 4.99755 8.37134L6.68734 9.89215C7.19076 10.3452 7.9729 10.2759 8.38871 9.74124L11.06 6.30667Z",
                                            fill: "#7673E6"
                                        })
                                    })
                                })
                            ]
                        }),
                        !!subtext && /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                            children: subtext
                        })
                    ]
                })
            ]
        });
    };
    var _avatarUser_fullname;
    if ("userid" in avatarUser && (avatarUser === null || avatarUser === void 0 ? void 0 : avatarUser.userid) !== (userInfo === null || userInfo === void 0 ? void 0 : userInfo.userid) || (avatarUser === null || avatarUser === void 0 ? void 0 : avatarUser.id) !== (userInfo === null || userInfo === void 0 ? void 0 : userInfo.userid) && !(userInfo === null || userInfo === void 0 ? void 0 : userInfo.authentic)) return /*#__PURE__*/ (0,jsx_runtime.jsx)(TooltipProvider, {
        delayDuration: HOVER_DELAY,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Tooltip, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(TooltipTrigger, {
                    asChild: true,
                    children: renderTriggerAvatar()
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(TooltipContent, {
                    className: "bg-white dark:bg-[#26243C] dark:border-0 rounded-[16px] w-fit max-w-[360px] p-[12px] shadow-[0_3px_30px_0_rgba(0,0,0,0.15)]",
                    side: "top",
                    align: "start",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "flex items-center justify-between w-full gap-[16px]",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "flex items-center gap-[12px] flex-1 cursor-pointer",
                                onClick: onNavigateToProfile,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "relative",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(avatar/* Avatar */.qE, {
                                                className: "rounded-full",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(avatar/* AvatarImage */.F$, {
                                                        src: (avatarUser === null || avatarUser === void 0 ? void 0 : avatarUser.small_avatar) ? avatarUser === null || avatarUser === void 0 ? void 0 : avatarUser.small_avatar : (avatarUser === null || avatarUser === void 0 ? void 0 : avatarUser.avatar) ? avatarUser === null || avatarUser === void 0 ? void 0 : avatarUser.avatar : "",
                                                        alt: avatarUser === null || avatarUser === void 0 ? void 0 : avatarUser.fullname,
                                                        height: EXAMPLE_SIZE,
                                                        width: EXAMPLE_SIZE,
                                                        className: "object-cover aspect-square"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(avatar/* AvatarFallback */.Q5, {
                                                        className: "flex items-center justify-center w-full text-white bg-main-01",
                                                        children: (0,utils/* convertNameString */.Nf)((_avatarUser_fullname = avatarUser === null || avatarUser === void 0 ? void 0 : avatarUser.fullname) !== null && _avatarUser_fullname !== void 0 ? _avatarUser_fullname : "P")
                                                    })
                                                ]
                                            }),
                                            !!(avatarUser === null || avatarUser === void 0 ? void 0 : avatarUser.frame_avatar) && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "w-[".concat(EXAMPLE_SIZE, "px] h-[").concat(EXAMPLE_SIZE, "px] absolute top-0 left-0 rounded-full z-20"),
                                                style: {
                                                    backgroundImage: "url(".concat(avatarUser === null || avatarUser === void 0 ? void 0 : avatarUser.frame_avatar, ")"),
                                                    backgroundSize: "100%"
                                                }
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                        className: "max-w-full text-base Nunito-700 text-bg-01 dark:text-main-white line-clamp-1",
                                        children: avatarUser === null || avatarUser === void 0 ? void 0 : avatarUser.fullname
                                    }),
                                    "authentic" in avatarUser && !!(avatarUser === null || avatarUser === void 0 ? void 0 : avatarUser.authentic) && /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
                                            width: "16",
                                            height: "16",
                                            viewBox: "0 0 16 16",
                                            fill: "none",
                                            xmlns: "http://www.w3.org/2000/svg",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                fillRule: "evenodd",
                                                clipRule: "evenodd",
                                                d: "M7.9987 14.6663C11.6806 14.6663 14.6654 11.6816 14.6654 7.99967C14.6654 4.31778 11.6806 1.33301 7.9987 1.33301C4.3168 1.33301 1.33203 4.31778 1.33203 7.99967C1.33203 11.6816 4.3168 14.6663 7.9987 14.6663ZM11.06 6.30667C11.2296 6.08869 11.1903 5.77456 10.9723 5.60502C10.7544 5.43549 10.4402 5.47475 10.2707 5.69273L7.59936 9.1273C7.53996 9.20367 7.42822 9.21358 7.35631 9.14886L5.66652 7.62805C5.46126 7.44332 5.14512 7.45996 4.96039 7.66522C4.77566 7.87047 4.7923 8.18661 4.99755 8.37134L6.68734 9.89215C7.19076 10.3452 7.9729 10.2759 8.38871 9.74124L11.06 6.30667Z",
                                                fill: "#7673E6"
                                            })
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(GroupFollowAction/* GroupFollowAction */.o, {
                                id: "userid" in avatarUser ? avatarUser === null || avatarUser === void 0 ? void 0 : avatarUser.userid : avatarUser === null || avatarUser === void 0 ? void 0 : avatarUser.id
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(GroupConnectAction/* GroupFriendAction */.o, {
                                id: "userid" in avatarUser ? avatarUser === null || avatarUser === void 0 ? void 0 : avatarUser.userid : avatarUser === null || avatarUser === void 0 ? void 0 : avatarUser.id
                            })
                        ]
                    })
                })
            ]
        })
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: renderTriggerAvatar()
    });
};


/***/ }),

/***/ 30897:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "T": function() { return /* binding */ OnlyShowAvatar; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(41844);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(55784);
/* harmony import */ var _ui_avatar__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(88313);
/* harmony import */ var _app_utils__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(90752);




const OnlyShowAvatar = (param)=>{
    let { size , avatarUser  } = param;
    var _avatarUser_fullname;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: "relative group",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_ui_avatar__WEBPACK_IMPORTED_MODULE_2__/* .Avatar */ .qE, {
                className: "rounded-full w-[".concat(size, "px] h-[").concat(size, "px]"),
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_ui_avatar__WEBPACK_IMPORTED_MODULE_2__/* .AvatarImage */ .F$, {
                        src: !!(avatarUser === null || avatarUser === void 0 ? void 0 : avatarUser.small_avatar) ? avatarUser === null || avatarUser === void 0 ? void 0 : avatarUser.small_avatar : !!(avatarUser === null || avatarUser === void 0 ? void 0 : avatarUser.avatar) ? avatarUser === null || avatarUser === void 0 ? void 0 : avatarUser.avatar : "",
                        alt: avatarUser === null || avatarUser === void 0 ? void 0 : avatarUser.fullname,
                        height: size,
                        width: size,
                        className: "object-cover aspect-square w-[".concat(size, "px] h-[").concat(size, "px] rounded-full")
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_ui_avatar__WEBPACK_IMPORTED_MODULE_2__/* .AvatarFallback */ .Q5, {
                        className: "flex items-center justify-center w-full text-white bg-main-01",
                        children: (0,_app_utils__WEBPACK_IMPORTED_MODULE_3__/* .convertNameString */ .Nf)((_avatarUser_fullname = avatarUser === null || avatarUser === void 0 ? void 0 : avatarUser.fullname) !== null && _avatarUser_fullname !== void 0 ? _avatarUser_fullname : "P")
                    })
                ]
            }),
            !!(avatarUser === null || avatarUser === void 0 ? void 0 : avatarUser.frame_avatar) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "w-[".concat(size, "px] h-[").concat(size, "px] absolute top-0 left-0 rounded-full z-20"),
                style: {
                    backgroundImage: "url(".concat(avatarUser === null || avatarUser === void 0 ? void 0 : avatarUser.frame_avatar, ")"),
                    backgroundSize: "100%"
                }
            })
        ]
    });
};


/***/ }),

/***/ 95372:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "o": function() { return /* binding */ GroupFriendAction; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(41844);
/* harmony import */ var next_i18next__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(93378);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(55784);
/* harmony import */ var _ui_button__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(34428);
/* harmony import */ var _app_services_query_fn__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(58512);
/* harmony import */ var _app_context__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(17986);
/* harmony import */ var _app_services_query_fn_user_user_friend_mutation__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(3201);
/* harmony import */ var _tanstack_react_query__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(30202);
/* harmony import */ var _app_configs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(54254);
/* harmony import */ var _ui_use_toast__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(2786);










const GroupFriendAction = (param)=>{
    let { id , gameId  } = param;
    const { t  } = (0,next_i18next__WEBPACK_IMPORTED_MODULE_1__/* .useTranslation */ .$G)();
    const { toast  } = (0,_ui_use_toast__WEBPACK_IMPORTED_MODULE_8__/* .useToast */ .pm)();
    const { data , isFetching  } = (0,_app_services_query_fn__WEBPACK_IMPORTED_MODULE_4__/* .useQueryGetProfileById */ .bK)(id);
    const { mutate: mutateAddFriend  } = (0,_app_services_query_fn_user_user_friend_mutation__WEBPACK_IMPORTED_MODULE_6__/* .useMutatonAddFriend */ .TY)();
    const { mutate: mutateDoActionFriend , isPending  } = (0,_app_services_query_fn_user_user_friend_mutation__WEBPACK_IMPORTED_MODULE_6__/* .useMutatonDoActionRequestFriend */ .CH)();
    const { mutate: mutateUnFriend  } = (0,_app_services_query_fn_user_user_friend_mutation__WEBPACK_IMPORTED_MODULE_6__/* .useMutatonUnFriend */ .OX)();
    const { mutate: mutateCancelSendingRequest  } = (0,_app_services_query_fn_user_user_friend_mutation__WEBPACK_IMPORTED_MODULE_6__/* .useMutatonCancelSendingRequestFn */ .er)();
    const queryClient = (0,_tanstack_react_query__WEBPACK_IMPORTED_MODULE_9__/* .useQueryClient */ .NL)();
    const onDoActionRequestFriend = (user, status)=>{
        mutateDoActionFriend({
            request_id: String(user === null || user === void 0 ? void 0 : user.pending_request_id),
            status
        }, {
            onSuccess (data, variables, context) {
                queryClient.refetchQueries({
                    queryKey: [
                        _app_configs__WEBPACK_IMPORTED_MODULE_7__/* .QUERY_KEY.LIST_SUGGEST_FRIEND */ .lP.LIST_SUGGEST_FRIEND
                    ]
                });
                queryClient.refetchQueries({
                    queryKey: [
                        _app_configs__WEBPACK_IMPORTED_MODULE_7__/* .QUERY_KEY.LIST_FRIEND */ .lP.LIST_FRIEND
                    ]
                });
                queryClient.refetchQueries({
                    queryKey: [
                        _app_configs__WEBPACK_IMPORTED_MODULE_7__/* .QUERY_KEY.LIST_REQUEST_FRIEND */ .lP.LIST_REQUEST_FRIEND
                    ]
                });
                queryClient.refetchQueries({
                    queryKey: [
                        _app_configs__WEBPACK_IMPORTED_MODULE_7__/* .QUERY_KEY.PROFILE_INFO */ .lP.PROFILE_INFO
                    ]
                });
                queryClient.refetchQueries({
                    queryKey: [
                        _app_configs__WEBPACK_IMPORTED_MODULE_7__/* .QUERY_KEY.GET_PROFILE_BY_ID */ .lP.GET_PROFILE_BY_ID,
                        id
                    ]
                });
                if (!!gameId) {
                    queryClient.refetchQueries({
                        queryKey: [
                            _app_configs__WEBPACK_IMPORTED_MODULE_7__/* .QUERY_KEY.LIST_SUGGEST_FRIEND_BY_GAME */ .lP.LIST_SUGGEST_FRIEND_BY_GAME,
                            gameId
                        ]
                    });
                }
                queryClient.invalidateQueries({
                    queryKey: [
                        _app_configs__WEBPACK_IMPORTED_MODULE_7__/* .QUERY_KEY.NOTIFICATION_LIST */ .lP.NOTIFICATION_LIST,
                        {
                            noticeType: "all"
                        }
                    ]
                });
                queryClient.invalidateQueries({
                    queryKey: [
                        _app_configs__WEBPACK_IMPORTED_MODULE_7__/* .QUERY_KEY.NOTIFICATION_LIST */ .lP.NOTIFICATION_LIST,
                        {
                            noticeType: "1"
                        }
                    ]
                });
            },
            onError (error) {
                var _error_data;
                toast({
                    variant: "error",
                    title: error === null || error === void 0 ? void 0 : (_error_data = error.data) === null || _error_data === void 0 ? void 0 : _error_data.message
                });
            }
        });
    };
    const onRequestAddFrend = (user)=>{
        if (user === null || user === void 0 ? void 0 : user.userid) {
            mutateAddFriend({
                friend_id: user === null || user === void 0 ? void 0 : user.userid
            }, {
                onSuccess (data, variables, context) {
                    queryClient.refetchQueries({
                        queryKey: [
                            _app_configs__WEBPACK_IMPORTED_MODULE_7__/* .QUERY_KEY.LIST_FRIEND */ .lP.LIST_FRIEND
                        ]
                    });
                    queryClient.refetchQueries({
                        queryKey: [
                            _app_configs__WEBPACK_IMPORTED_MODULE_7__/* .QUERY_KEY.LIST_SUGGEST_FRIEND */ .lP.LIST_SUGGEST_FRIEND
                        ]
                    });
                    queryClient.refetchQueries({
                        queryKey: [
                            _app_configs__WEBPACK_IMPORTED_MODULE_7__/* .QUERY_KEY.GET_PROFILE_BY_ID */ .lP.GET_PROFILE_BY_ID,
                            id
                        ]
                    });
                    if (!!gameId) {
                        queryClient.refetchQueries({
                            queryKey: [
                                _app_configs__WEBPACK_IMPORTED_MODULE_7__/* .QUERY_KEY.LIST_SUGGEST_FRIEND_BY_GAME */ .lP.LIST_SUGGEST_FRIEND_BY_GAME,
                                gameId
                            ]
                        });
                    }
                }
            });
        }
    };
    const onUnFriend = (user)=>{
        mutateUnFriend({
            friend_id: user === null || user === void 0 ? void 0 : user.userid
        }, {
            onSuccess (data, variables, context) {
                queryClient.refetchQueries({
                    queryKey: [
                        _app_configs__WEBPACK_IMPORTED_MODULE_7__/* .QUERY_KEY.LIST_FRIEND */ .lP.LIST_FRIEND
                    ]
                });
                queryClient.refetchQueries({
                    queryKey: [
                        _app_configs__WEBPACK_IMPORTED_MODULE_7__/* .QUERY_KEY.LIST_SUGGEST_FRIEND */ .lP.LIST_SUGGEST_FRIEND
                    ]
                });
                queryClient.refetchQueries({
                    queryKey: [
                        _app_configs__WEBPACK_IMPORTED_MODULE_7__/* .QUERY_KEY.PROFILE_INFO */ .lP.PROFILE_INFO
                    ]
                });
                queryClient.refetchQueries({
                    queryKey: [
                        _app_configs__WEBPACK_IMPORTED_MODULE_7__/* .QUERY_KEY.GET_PROFILE_BY_ID */ .lP.GET_PROFILE_BY_ID,
                        id
                    ]
                });
            }
        });
    };
    const onCancelSendingRequest = (user)=>{
        mutateCancelSendingRequest({
            request_id: String(user === null || user === void 0 ? void 0 : user.sending_request_id)
        }, {
            onSuccess (data, variables, context) {
                queryClient.invalidateQueries({
                    queryKey: [
                        _app_configs__WEBPACK_IMPORTED_MODULE_7__/* .QUERY_KEY.LIST_SUGGEST_FRIEND */ .lP.LIST_SUGGEST_FRIEND
                    ]
                });
                queryClient.invalidateQueries({
                    queryKey: [
                        _app_configs__WEBPACK_IMPORTED_MODULE_7__/* .QUERY_KEY.PROFILE_INFO */ .lP.PROFILE_INFO
                    ]
                });
                queryClient.invalidateQueries({
                    queryKey: [
                        _app_configs__WEBPACK_IMPORTED_MODULE_7__/* .QUERY_KEY.GET_PROFILE_BY_ID */ .lP.GET_PROFILE_BY_ID,
                        user === null || user === void 0 ? void 0 : user.id
                    ]
                });
            }
        });
    };
    const { userInfo  } = (0,react__WEBPACK_IMPORTED_MODULE_2__.useContext)(_app_context__WEBPACK_IMPORTED_MODULE_5__/* .AppContext */ .Il);
    const renderButtonNormalUser = (0,react__WEBPACK_IMPORTED_MODULE_2__.useCallback)(()=>{
        if (data === null || data === void 0 ? void 0 : data.sending_request) {
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_ui_button__WEBPACK_IMPORTED_MODULE_3__/* .Button */ .z, {
                variant: "main",
                className: "outline-none bg-transparent text-neutral-06 h-[28px] px-[16px] flex items-center justify-center border-[1px] border-neutral-06 rounded-[8px] Nunito-400 text-[14px]",
                onClick: (e)=>{
                    e.stopPropagation();
                    onCancelSendingRequest(data);
                },
                children: t("group.remove_invite")
            });
        }
        if ((data === null || data === void 0 ? void 0 : data.pending_request) && !!(data === null || data === void 0 ? void 0 : data.pending_request_id)) {
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: "flex items-center gap-2",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_ui_button__WEBPACK_IMPORTED_MODULE_3__/* .Button */ .z, {
                        variant: "main",
                        className: "outline-none bg-main-01 h-[28px] px-[16px] flex items-center justify-center text-white rounded-[8px] Nunito-400 text-[14px]",
                        onClick: (e)=>{
                            e.stopPropagation();
                            onDoActionRequestFriend(data, "accepted");
                        },
                        children: t("group.agree")
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_ui_button__WEBPACK_IMPORTED_MODULE_3__/* .Button */ .z, {
                        variant: "none",
                        className: "outline-none bg-transparent text-neutral-06 h-[28px] px-[16px] flex items-center justify-center border-[1px] border-neutral-06 rounded-[8px] Nunito-400 text-[14px]",
                        onClick: (e)=>{
                            e.stopPropagation();
                            onDoActionRequestFriend(data, "cancel");
                        },
                        children: t("group.reject")
                    })
                ]
            });
        }
        if (data === null || data === void 0 ? void 0 : data.is_friend) {
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_ui_button__WEBPACK_IMPORTED_MODULE_3__/* .Button */ .z, {
                variant: "none",
                className: "outline-none bg-transparent text-neutral-06 h-[28px] px-[16px] flex items-center justify-center border-[1px] border-neutral-06 rounded-[8px] Nunito-400 text-[14px]",
                onClick: (e)=>{
                    e.stopPropagation();
                    onUnFriend(data);
                },
                children: t("profile.unfriend")
            });
        } else return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_ui_button__WEBPACK_IMPORTED_MODULE_3__/* .Button */ .z, {
                    variant: "main",
                    className: "outline-none bg-main-01 h-[28px] px-[16px] hidden lg:flex items-center justify-center text-white rounded-[8px] Nunito-400 text-[14px]",
                    onClick: (e)=>{
                        e.stopPropagation();
                        onRequestAddFrend(data);
                    },
                    children: t("profile.addfriend")
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
                    className: "outline-none bg-transparent h-[28px] px-[16px] flex lg:hidden items-center justify-center text-white rounded-[8px]",
                    onClick: (e)=>{
                        e.stopPropagation();
                        onRequestAddFrend(data);
                    },
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
                        width: "21",
                        height: "21",
                        viewBox: "0 0 21 21",
                        fill: "none",
                        xmlns: "http://www.w3.org/2000/svg",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                            fillRule: "evenodd",
                            clipRule: "evenodd",
                            d: "M4.25 0.203125H16.25C18.4591 0.203125 20.25 1.99399 20.25 4.20312V16.2031C20.25 18.4123 18.4591 20.2031 16.25 20.2031H4.25C2.04086 20.2031 0.25 18.4123 0.25 16.2031V4.20313C0.25 1.99399 2.04086 0.203125 4.25 0.203125ZM10.25 5.45312C10.6642 5.45312 11 5.78891 11 6.20312V9.45312H14.25C14.6642 9.45312 15 9.78891 15 10.2031C15 10.6173 14.6642 10.9531 14.25 10.9531H11V14.2031C11 14.6173 10.6642 14.9531 10.25 14.9531C9.83579 14.9531 9.5 14.6173 9.5 14.2031V10.9531H6.25C5.83579 10.9531 5.5 10.6173 5.5 10.2031C5.5 9.78891 5.83579 9.45312 6.25 9.45312H9.5V6.20312C9.5 5.78891 9.83579 5.45312 10.25 5.45312Z",
                            fill: "#7673E6"
                        })
                    })
                })
            ]
        });
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        data,
        id
    ]);
    if (!(userInfo === null || userInfo === void 0 ? void 0 : userInfo.userid)) return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {});
    if (isFetching && !data) return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {});
    if ((userInfo === null || userInfo === void 0 ? void 0 : userInfo.userid) === id || (userInfo === null || userInfo === void 0 ? void 0 : userInfo.alias) === id) return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {});
    if ((data === null || data === void 0 ? void 0 : data.authentic) || (userInfo === null || userInfo === void 0 ? void 0 : userInfo.authentic)) return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {});
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: renderButtonNormalUser()
    });
};


/***/ }),

/***/ 10727:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "o": function() { return /* binding */ GroupFollowAction; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(41844);
/* harmony import */ var next_i18next__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(93378);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(55784);
/* harmony import */ var _ui_button__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(34428);
/* harmony import */ var _app_services_query_fn__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(58512);
/* harmony import */ var _app_context__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(17986);
/* harmony import */ var _tanstack_react_query__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(30202);
/* harmony import */ var _app_configs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(54254);








const GroupFollowAction = (param)=>{
    let { id  } = param;
    const { t  } = (0,next_i18next__WEBPACK_IMPORTED_MODULE_1__/* .useTranslation */ .$G)();
    const { data , isFetching  } = (0,_app_services_query_fn__WEBPACK_IMPORTED_MODULE_4__/* .useQueryGetProfileById */ .bK)(id);
    const { userInfo  } = (0,react__WEBPACK_IMPORTED_MODULE_2__.useContext)(_app_context__WEBPACK_IMPORTED_MODULE_5__/* .AppContext */ .Il);
    const queryClient = (0,_tanstack_react_query__WEBPACK_IMPORTED_MODULE_7__/* .useQueryClient */ .NL)();
    const { mutate: mutateFollow  } = (0,_app_services_query_fn__WEBPACK_IMPORTED_MODULE_4__/* .useMutationFollowPartner */ .Vj)();
    const onFollowPartner = ()=>{
        mutateFollow(String(data === null || data === void 0 ? void 0 : data.userid), {
            onSuccess (_data, variables, context) {
                queryClient.refetchQueries({
                    queryKey: [
                        _app_configs__WEBPACK_IMPORTED_MODULE_6__/* .QUERY_KEY.GET_PROFILE_BY_ID */ .lP.GET_PROFILE_BY_ID,
                        id
                    ]
                });
            }
        });
    };
    if (isFetching && !data) return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {});
    if ((userInfo === null || userInfo === void 0 ? void 0 : userInfo.authentic) || !(userInfo === null || userInfo === void 0 ? void 0 : userInfo.userid)) return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {});
    if (!(data === null || data === void 0 ? void 0 : data.authentic)) return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {});
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: (data === null || data === void 0 ? void 0 : data.followed) ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_ui_button__WEBPACK_IMPORTED_MODULE_3__/* .Button */ .z, {
            variant: "none",
            className: "outline-none bg-transparent text-neutral-06 h-[28px] py-[6px] md:py-2 px-[16px] flex items-center justify-center border-[1px] border-neutral-06 rounded-[8px] Nunito-400 text-[14px]",
            onClick: (e)=>{
                e.stopPropagation();
                onFollowPartner();
            },
            children: t("profile.unfollow")
        }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_ui_button__WEBPACK_IMPORTED_MODULE_3__/* .Button */ .z, {
            variant: "main",
            className: "outline-none bg-main-01 h-[28px] px-[16px] py-[6px] md:py-2 flex items-center justify-center text-white rounded-[8px] Nunito-400 text-[14px]",
            onClick: (e)=>{
                e.stopPropagation();
                onFollowPartner();
            },
            children: t("profile.follow")
        })
    });
};


/***/ }),

/***/ 98269:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "$": function() { return /* binding */ DataEmpty; }
});

// EXTERNAL MODULE: ./node_modules/next/dist/compiled/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(41844);
// EXTERNAL MODULE: ./node_modules/next-i18next/dist/esm/index.js + 41 modules
var esm = __webpack_require__(93378);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/react/index.js
var react = __webpack_require__(55784);
;// CONCATENATED MODULE: ./app/components/icon-tsx/IconNoVoucher.tsx


const IconNoVocher = (param)=>{
    let {} = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "24",
        height: "29",
        viewBox: "0 0 24 29",
        fill: "none",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M6.99965 5.6665C6.99965 2.90508 9.23822 0.666504 11.9996 0.666504C14.7611 0.666504 16.9996 2.90508 16.9996 5.6665V7.01287C19.5227 7.18883 21.599 9.12765 21.917 11.6717L23.2503 22.3383C23.6482 25.5215 21.1661 28.3332 17.9581 28.3332H6.04115C2.83316 28.3332 0.3511 25.5215 0.749002 22.3383L2.08233 11.6717C2.40034 9.12765 4.47657 7.18883 6.99965 7.01287V5.6665ZM14.9996 5.6665V6.99984H8.99965V5.6665C8.99965 4.00965 10.3428 2.6665 11.9996 2.6665C13.6565 2.6665 14.9996 4.00965 14.9996 5.6665ZM7.99967 16.6665C7.44739 16.6665 6.99967 17.1142 6.99967 17.6665C6.99967 18.2188 7.44739 18.6665 7.99967 18.6665H15.9997C16.552 18.6665 16.9997 18.2188 16.9997 17.6665C16.9997 17.1142 16.552 16.6665 15.9997 16.6665H7.99967Z",
            fill: "#7673E6"
        })
    });
};

;// CONCATENATED MODULE: ./app/components/data-empty/index.tsx




const DataEmpty = (param)=>{
    let { title , icon  } = param;
    const { t  } = (0,esm/* useTranslation */.$G)();
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "flex flex-col items-center",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "bg-button dark:bg-transparent w-[48px] h-[48px] flex items-center justify-center rounded-[12px]",
                children: icon ? icon : /*#__PURE__*/ (0,jsx_runtime.jsx)(IconNoVocher, {})
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                className: "pt-[16px] text-neutral-06 text-[14px] Nunito-500 dark:text-neutral-07",
                children: title || t("profile.no_data")
            })
        ]
    });
};


/***/ }),

/***/ 34399:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ header_NotificationHeader; },
  "L": function() { return /* binding */ listType; }
});

// EXTERNAL MODULE: ./node_modules/next/dist/compiled/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(41844);
// EXTERNAL MODULE: ./app/components/ui/dropdown-menu.tsx + 2 modules
var dropdown_menu = __webpack_require__(27357);
// EXTERNAL MODULE: ./app/configs/index.ts + 3 modules
var configs = __webpack_require__(54254);
// EXTERNAL MODULE: ./app/containers/notification/ListNotification.tsx + 3 modules
var ListNotification = __webpack_require__(66695);
// EXTERNAL MODULE: ./app/context/index.ts + 2 modules
var context = __webpack_require__(17986);
// EXTERNAL MODULE: ./app/hooks/useSocket.ts + 30 modules
var useSocket = __webpack_require__(71722);
// EXTERNAL MODULE: ./app/services/query-fn/notification/notification-query.ts + 1 modules
var notification_query = __webpack_require__(76767);
// EXTERNAL MODULE: ./node_modules/@tanstack/react-query/build/modern/QueryClientProvider.js
var QueryClientProvider = __webpack_require__(30202);
// EXTERNAL MODULE: ./node_modules/next-i18next/dist/esm/index.js + 41 modules
var esm = __webpack_require__(93378);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/react/index.js
var react = __webpack_require__(55784);
;// CONCATENATED MODULE: ./app/components/icon-tsx/IconNotice.tsx


const IconNotice = (param)=>{
    let { color ="#828282"  } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "19",
        height: "21",
        viewBox: "0 0 19 21",
        fill: "none",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("g", {
                clipPath: "url(#clip0_7860_29809)",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                    d: "M10.5 1.3125V2.1C13.4941 2.70826 15.75 5.35664 15.75 8.53125V9.30234C15.75 11.2342 16.4596 13.0922 17.7392 14.5359L18.0428 14.8764C18.3873 15.266 18.4734 15.8156 18.2601 16.2873C18.0469 16.759 17.5793 17.0625 17.0625 17.0625H1.31249C0.795693 17.0625 0.326926 16.759 0.115203 16.2873C-0.0965196 15.8156 -0.0118346 15.266 0.33156 14.8764L0.635732 14.5359C1.91706 13.0922 2.62499 11.2342 2.62499 9.30234V8.53125C2.62499 5.35664 4.84394 2.70826 7.87499 2.1V1.3125C7.87499 0.587754 8.46151 0 9.18749 0C9.91347 0 10.5 0.587754 10.5 1.3125ZM9.18749 21C8.49022 21 7.82167 20.7252 7.32948 20.233C6.83729 19.7408 6.56249 19.0354 6.56249 18.375H11.8125C11.8125 19.0354 11.5377 19.7408 11.0455 20.233C10.5533 20.7252 9.84784 21 9.18749 21Z",
                    fill: color
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("defs", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("clipPath", {
                    id: "clip0_7860_29809",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                        width: "18.375",
                        height: "21",
                        fill: "white"
                    })
                })
            })
        ]
    });
};

// EXTERNAL MODULE: ./app/components/icon-tsx/IconReadAll.tsx
var IconReadAll = __webpack_require__(21572);
// EXTERNAL MODULE: ./app/hooks/index.tsx
var hooks = __webpack_require__(38609);
// EXTERNAL MODULE: ./app/components/loading-btn/index.tsx + 2 modules
var loading_btn = __webpack_require__(25327);
// EXTERNAL MODULE: ./app/hooks/useGAEventsTracker.ts
var useGAEventsTracker = __webpack_require__(64800);
// EXTERNAL MODULE: ./app/components/ui/use-toast.ts
var use_toast = __webpack_require__(2786);
;// CONCATENATED MODULE: ./app/components/header/NotificationHeader.tsx

















const listType = [
    {
        title: "notification.all",
        value: "all"
    },
    {
        title: "notification.unread",
        value: "1"
    }
];
const NotificationHeader = ()=>{
    var _listNoti_pages;
    const router = (0,next_router.useRouter)();
    const { t  } = (0,esm/* useTranslation */.$G)();
    const queryClient = (0,QueryClientProvider/* useQueryClient */.NL)();
    const [width] = (0,hooks/* useWindowSize */.i)();
    const { toast  } = (0,use_toast/* useToast */.pm)();
    // const { isMobile } = useContext(MobileContext)
    const isMobile = !width || width < 768;
    const token = configs/* isClient */.C5 ? window.localStorage.getItem("token") || "" : "";
    const { unReadCount , setUnReadCount , themeApp  } = (0,react.useContext)(context/* AppContext */.Il);
    const [noticeId, setNoticeId] = (0,react.useState)(undefined);
    const [isShowNotices, setIsShowNotices] = (0,react.useState)(false);
    const [noticeType, setNoticeType] = (0,react.useState)("all");
    const [loadingReadAll, setLoadingReadAll] = (0,react.useState)(false);
    const { data: listNoti , isFetching , fetchNextPage  } = (0,notification_query/* useQueryGetListNotification */.H)(setUnReadCount, noticeType);
    const GAEventsTracker = (0,useGAEventsTracker/* default */.Z)("Spin");
    const GAEventsTrackerNoti = (0,useGAEventsTracker/* default */.Z)("Notification");
    const GAEventsTrackerReward = (0,useGAEventsTracker/* default */.Z)("Reward");
    const handleRefetch = ()=>{
        queryClient.refetchQueries({
            queryKey: [
                configs/* QUERY_KEY.NOTIFICATION_LIST */.lP.NOTIFICATION_LIST,
                {
                    noticeType
                }
            ]
        });
    };
    const handleEventNotification = (data)=>{
        if ((data === null || data === void 0 ? void 0 : data.type) === "purchase") {
            GAEventsTracker("Store_Buy_ReceiveSpin", "Thanh toan thanh cong");
        }
        if ((data === null || data === void 0 ? void 0 : data.type) === "spin") {
            setTimeout(()=>{
                handleRefetch();
            }, configs/* TIMEOUT_SPIN */.fy);
        } else {
            handleRefetch();
        }
        if ((data === null || data === void 0 ? void 0 : data.type) === "accept_request_friend") {
            queryClient.invalidateQueries({
                queryKey: [
                    configs/* QUERY_KEY.PROFILE_INFO */.lP.PROFILE_INFO
                ],
                refetchType: "active"
            });
        }
        if ((data === null || data === void 0 ? void 0 : data.type) === configs/* NOTIFICATION_TYPE.TASK */.tx.TASK) {
            var _data_content_id;
            GAEventsTrackerReward("Mission_Do_success", data === null || data === void 0 ? void 0 : (_data_content_id = data.content_id) === null || _data_content_id === void 0 ? void 0 : _data_content_id.task_id);
        }
        if ((data === null || data === void 0 ? void 0 : data.type) === configs/* NOTIFICATION_TYPE.TASK */.tx.TASK || (data === null || data === void 0 ? void 0 : data.type) === configs/* NOTIFICATION_TYPE.TOPUP_GAME_EVENT */.tx.TOPUP_GAME_EVENT) {
            toast({
                variant: "success",
                title: "Bạn đ\xe3 ho\xe0n th\xe0nh xong nhiệm vụ. Vui l\xf2ng kiểm tra th\xf4ng b\xe1o để nhận qu\xe0"
            });
        }
    };
    (0,useSocket/* useSocket */.s)({
        event: "connection",
        handleEvent: (msg)=>{
        // console.log(msg)
        },
        dependences: [
            listNoti === null || listNoti === void 0 ? void 0 : (_listNoti_pages = listNoti.pages) === null || _listNoti_pages === void 0 ? void 0 : _listNoti_pages.flat()
        ],
        handleEventNotification
    });
    (0,useSocket/* useSocket */.s)({
        event: "inbox",
        type: "emit",
        dependences: [
            noticeId
        ],
        handleEvent: !!noticeId ? [
            token,
            noticeId
        ] : ""
    });
    const handleOpenNotificationPage = ()=>{
        !isMobile && setIsShowNotices(!isShowNotices);
        isMobile && router.push("/notifications");
        GAEventsTrackerNoti("Notification_open");
        setUnReadCount(0);
    };
    const handleReadAllNotification = ()=>{
        // setIsShowNotices(false)
        setLoadingReadAll(true);
        setNoticeId("all");
        setTimeout(()=>{
            setLoadingReadAll(false);
            handleRefetch();
        }, 3000);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(dropdown_menu/* DropdownMenu */.h_, {
            open: isShowNotices,
            onOpenChange: handleOpenNotificationPage,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(dropdown_menu/* DropdownMenuTrigger */.$F, {
                    asChild: true,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "cursor-pointer relative ml-[24px] md:ml-0",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(IconNotice, {
                                color: "#7673E6"
                            }),
                            !isShowNotices && unReadCount > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                className: "absolute z-2 bottom-[60%] left-[50%] rounded-full Nunito-600 text-white text-[10px] bg-main-red px-1 text-center",
                                children: unReadCount
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(dropdown_menu/* DropdownMenuContent */.AW, {
                    align: "end",
                    className: "w-[400px] dark:bg-dark-mode-box p-[16px] rounded-[16px] shadow-[0px_3px_30px_0px_rgba(0,0,0,0.15)] space-y-[12px]",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                            className: "text-[18px] Nunito-700 leading-[25px]",
                            children: t("notification.notifications")
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "flex gap-[8px]",
                            children: listType.map((item)=>{
                                return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "px-[12px] h-[28px] flex items-center text-[14px] cursor-pointer border rounded-[12px] leading-[16px] Nunito-600 ".concat(noticeType === item.value ? "border-main-01 bg-main-01 text-white" : "border-black/10 dark:border-white/10 text-neutral-03 dark:text-main-white"),
                                    onClick: ()=>{
                                        setNoticeType(item.value);
                                    },
                                    children: t(item.title)
                                }, item.value);
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(ListNotification/* ListNotification */.Q, {
                            setNoticeId: setNoticeId,
                            listNoti: listNoti,
                            isFetching: isFetching,
                            fetchNextPage: fetchNextPage,
                            className: "h-[350px] xl:h-[504px]",
                            setIsShowNotices: setIsShowNotices,
                            handleRefetch: handleRefetch
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "flex items-center gap-[8px] text-main-01 dark:text-main-white text-[12px] Nunito-600 w-fit ".concat(loadingReadAll ? "" : "cursor-pointer"),
                            onClick: handleReadAllNotification,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(IconReadAll/* IconReadAll */.W, {
                                    fill: themeApp === "dark" ? "#FAF8FF" : ""
                                }),
                                t("notification.mark_read_all"),
                                loadingReadAll && /*#__PURE__*/ (0,jsx_runtime.jsx)(loading_btn/* LoadingBtnComponent */.n, {})
                            ]
                        })
                    ]
                })
            ]
        })
    });
};
/* harmony default export */ var header_NotificationHeader = (/*#__PURE__*/(0,react.memo)(NotificationHeader));


/***/ }),

/***/ 75075:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "n": function() { return /* binding */ SelectTheme; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(41844);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(55784);
/* harmony import */ var next_themes__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(82010);
/* harmony import */ var app_context_AppContext__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(95513);
/* harmony import */ var _icon_tsx_IconLight__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(93057);
/* harmony import */ var _icon_tsx_IconDark__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(38416);







const SelectTheme = ()=>{
    const [checked, setChecked] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false);
    const { theme , setTheme  } = (0,next_themes__WEBPACK_IMPORTED_MODULE_2__/* .useTheme */ .F)();
    const { setThemeApp  } = (0,react__WEBPACK_IMPORTED_MODULE_1__.useContext)(app_context_AppContext__WEBPACK_IMPORTED_MODULE_3__/* .AppContext */ .I);
    const handleChangeTheme = ()=>{
        if (checked) {
            setChecked(false);
            setTheme("light");
            localStorage.setItem("theme", "light");
            document.documentElement.classList.remove("dark");
        } else {
            setChecked(true);
            setTheme("dark");
            localStorage.setItem("theme", "dark");
            document.documentElement.classList.add("dark");
        }
    };
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(()=>{
        if (typeof localStorage !== "undefined") {
            const _theme = localStorage.getItem("theme");
            setTheme(_theme || "light");
            if (_theme === "dark") {
                setThemeApp("dark");
                setChecked(true);
                document.documentElement.classList.add("dark");
            } else {
                setChecked(false);
                setThemeApp("light");
                document.documentElement.classList.remove("dark");
            }
        }
    }, [
        theme
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("label", {
        className: "switch-container relative cursor-pointer outline-0",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_icon_tsx_IconLight__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                fill: checked ? "" : "white",
                className: "absolute z-10 top-[6px] left-[6px] bottom-0"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_icon_tsx_IconDark__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                fill: !checked ? "#907ED9" : "white",
                className: "absolute z-10 top-[6px] right-[6px] bottom-0"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("input", {
                type: "checkbox",
                checked: checked,
                onChange: handleChangeTheme
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                className: "switch-class round outline-0"
            })
        ]
    });
};


/***/ }),

/***/ 79233:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "B": function() { return /* binding */ IconArrowDown; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(41844);
/* harmony import */ var _app_context__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(17986);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(55784);



const IconArrowDown = (param)=>{
    let { className  } = param;
    const { themeApp  } = (0,react__WEBPACK_IMPORTED_MODULE_2__.useContext)(_app_context__WEBPACK_IMPORTED_MODULE_1__/* .AppContext */ .Il);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
        width: "12",
        height: "6",
        viewBox: "0 0 12 6",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        className: className,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("g", {
            id: "direaction down",
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                id: "Vector 175 (Stroke)",
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M0.414376 0.531506C0.673133 0.20806 1.1451 0.155619 1.46855 0.414376L6.00003 4.03956L10.5315 0.414376C10.855 0.155619 11.3269 0.20806 11.5857 0.531506C11.8444 0.854953 11.792 1.32692 11.4685 1.58568L6.46855 5.58568C6.19464 5.80481 5.80542 5.80481 5.53151 5.58568L0.531506 1.58568C0.20806 1.32692 0.155619 0.854953 0.414376 0.531506Z",
                fill: themeApp === "dark" ? "#FAF8FF" : "#100D28"
            })
        })
    });
};


/***/ }),

/***/ 82341:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "D": function() { return /* binding */ IconArrowLeft; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(41844);
/* harmony import */ var _app_context__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(17986);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(55784);



const IconArrowLeft = (param)=>{
    let { className  } = param;
    const { themeApp  } = (0,react__WEBPACK_IMPORTED_MODULE_2__.useContext)(_app_context__WEBPACK_IMPORTED_MODULE_1__/* .AppContext */ .Il);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        className: className,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
            d: "M14 7L10 12L14 17",
            stroke: "#7673E6",
            strokeWidth: "1.5",
            strokeLinecap: "round",
            strokeLinejoin: "round"
        })
    });
};


/***/ }),

/***/ 99777:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "E": function() { return /* binding */ IconArrowRight; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(41844);
/* harmony import */ var _app_context__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(17986);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(55784);



const IconArrowRight = (param)=>{
    let { className  } = param;
    const { themeApp  } = (0,react__WEBPACK_IMPORTED_MODULE_2__.useContext)(_app_context__WEBPACK_IMPORTED_MODULE_1__/* .AppContext */ .Il);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        className: className,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
            d: "M10 7L14 12L10 17",
            stroke: "#7673E6",
            strokeWidth: "1.5",
            strokeLinecap: "round",
            strokeLinejoin: "round"
        })
    });
};


/***/ }),

/***/ 20450:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "j": function() { return /* binding */ IconCalendar; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(41844);
/* harmony import */ var _app_context__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(17986);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(55784);



const IconCalendar = ()=>{
    const { themeApp  } = (0,react__WEBPACK_IMPORTED_MODULE_2__.useContext)(_app_context__WEBPACK_IMPORTED_MODULE_1__/* .AppContext */ .Il);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("svg", {
        width: "24",
        height: "25",
        viewBox: "0 0 24 25",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                d: "M3 8.38965C3 6.18051 4.79086 4.38965 7 4.38965H17C19.2091 4.38965 21 6.18051 21 8.38965V18.8896C21 21.0988 19.2091 22.8896 17 22.8896H7C4.79086 22.8896 3 21.0988 3 18.8896V8.38965Z",
                stroke: themeApp === "dark" ? "#fff" : "#100D28",
                strokeWidth: "1.5"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                d: "M3 9.88965H21",
                stroke: themeApp === "dark" ? "#fff" : "#100D28",
                strokeWidth: "1.5",
                strokeLinecap: "round"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                d: "M8 2.88965L8 5.88965",
                stroke: themeApp === "dark" ? "#fff" : "#100D28",
                strokeWidth: "1.5",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                d: "M16 2.88965V5.88965",
                stroke: themeApp === "dark" ? "#fff" : "#100D28",
                strokeWidth: "1.5",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("circle", {
                cx: "12",
                cy: "15.8896",
                r: "1",
                fill: themeApp === "dark" ? "#fff" : "#100D28"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("circle", {
                cx: "16",
                cy: "15.8896",
                r: "1",
                fill: themeApp === "dark" ? "#fff" : "#100D28"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("circle", {
                cx: "8",
                cy: "15.8896",
                r: "1",
                fill: themeApp === "dark" ? "#fff" : "#100D28"
            })
        ]
    });
};


/***/ }),

/***/ 26008:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "k": function() { return /* binding */ IconCart; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(41844);

const IconCart = (param)=>{
    let { className  } = param;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("svg", {
        width: "32",
        height: "32",
        viewBox: "0 0 32 32",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        className: className,
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                opacity: "0.4",
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M12.5143 1.80935C12.9879 2.09349 13.1415 2.70775 12.8573 3.18133L8.85734 9.848C8.57319 10.3216 7.95893 10.4751 7.48535 10.191C7.01177 9.90685 6.85821 9.29259 7.14236 8.81901L11.1424 2.15234C11.4265 1.67876 12.0408 1.5252 12.5143 1.80935Z",
                fill: "#7673E6"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                opacity: "0.4",
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M24.5143 10.191C24.0408 10.4751 23.4265 10.3216 23.1424 9.848L19.1424 3.18133C18.8582 2.70775 19.0118 2.09349 19.4854 1.80934C19.9589 1.5252 20.5732 1.67876 20.8573 2.15234L24.8573 8.81901C25.1415 9.29259 24.9879 9.90685 24.5143 10.191Z",
                fill: "#7673E6"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                opacity: "0.4",
                d: "M27.0429 25.0773C26.5365 27.5554 24.3744 29.3333 21.8673 29.3333H10.1334C7.62622 29.3333 5.46415 27.5554 4.95771 25.0773L2.77782 14.4107C2.10158 11.1017 4.6057 8 7.95347 8L24.0472 8C27.395 8 29.8991 11.1017 29.2228 14.4107L27.0429 25.0773Z",
                fill: "#7673E6"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                d: "M24.0472 8H7.95347C4.97283 8 2.66094 10.4587 2.667 13.3333H29.3336C29.3397 10.4587 27.0278 8 24.0472 8Z",
                fill: "#7673E6"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M12 17.6667C12.5523 17.6667 13 18.1144 13 18.6667L13 24C13 24.5523 12.5523 25 12 25C11.4477 25 11 24.5523 11 24L11 18.6667C11 18.1144 11.4477 17.6667 12 17.6667Z",
                fill: "#7673E6"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M20 17.6667C20.5523 17.6667 21 18.1144 21 18.6667L21 24C21 24.5523 20.5523 25 20 25C19.4477 25 19 24.5523 19 24L19 18.6667C19 18.1144 19.4477 17.6667 20 17.6667Z",
                fill: "#7673E6"
            })
        ]
    });
};


/***/ }),

/***/ 51337:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "b": function() { return /* binding */ IconClose; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(41844);
/* harmony import */ var _app_context__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(17986);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(55784);



const IconClose = (param)=>{
    let { className , fill , onClick  } = param;
    const { themeApp  } = (0,react__WEBPACK_IMPORTED_MODULE_2__.useContext)(_app_context__WEBPACK_IMPORTED_MODULE_1__/* .AppContext */ .Il);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        className: className,
        onClick: onClick,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
            d: "M16.2431 7.75786L7.75781 16.2431M16.2431 16.2431L7.75781 7.75781",
            stroke: fill ? fill : themeApp === "dark" ? "#FAF8FF" : "#28303F",
            strokeWidth: "1.5",
            strokeLinecap: "round",
            strokeLinejoin: "round"
        })
    });
};


/***/ }),

/***/ 60303:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "i": function() { return /* binding */ IconCopied; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(41844);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(55784);


const IconCopied = (param)=>{
    let { fill ="#27908C" , className  } = param;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("svg", {
        width: "18",
        height: "18",
        viewBox: "0 0 18 18",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        className: className,
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                d: "M9.67531 1.5C7.46288 1.5 6.37452 2.25121 6.08673 4.05369C5.99892 4.60363 6.4628 5.0625 7.01972 5.0625H8.32531C11.4753 5.0625 12.9378 6.525 12.9378 9.675V10.9806C12.9378 11.5375 13.3967 12.0014 13.9466 11.9136C15.7491 11.6258 16.5003 10.5374 16.5003 8.325V5.175C16.5003 2.55 15.4503 1.5 12.8253 1.5H9.67531Z",
                fill: fill
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M5.175 6C2.55 6 1.5 7.05 1.5 9.675V12.825C1.5 15.45 2.55 16.5 5.175 16.5H8.325C10.95 16.5 12 15.45 12 12.825V9.675C12 7.05 10.95 6 8.325 6H5.175ZM6.435 13.02C6.33 13.125 6.195 13.1775 6.0525 13.1775C5.91 13.1775 5.775 13.125 5.67 13.02L4.275 11.625C4.065 11.415 4.065 11.0775 4.275 10.8675C4.485 10.6575 4.8225 10.6575 5.0325 10.8675L6.045 11.88L8.4525 9.4725C8.6625 9.2625 9 9.2625 9.21 9.4725C9.42 9.6825 9.4275 10.0275 9.2175 10.2375L6.435 13.02Z",
                fill: fill
            })
        ]
    });
};


/***/ }),

/***/ 38416:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(41844);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(55784);


const IconDark = (param)=>{
    let { className , fill  } = param;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
        className: className,
        xmlns: "http://www.w3.org/2000/svg",
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
            d: "M9.99208 17.6111C12.8035 17.733 15.3178 16.4225 16.8264 14.3578C17.4511 13.5121 17.1159 12.9483 16.0721 13.1387C15.5616 13.2302 15.0359 13.2683 14.4873 13.2454C10.7616 13.093 7.71398 9.97683 7.69874 6.29683C7.69112 5.30636 7.89684 4.36922 8.27017 3.51588C8.6816 2.57112 8.18636 2.1216 7.23398 2.52541C4.21684 3.79779 2.15208 6.83779 2.40351 10.3197C2.67779 14.2435 6.00731 17.4359 9.99208 17.6111Z",
            fill: fill ? "" : fill,
            stroke: fill,
            strokeLinecap: "round",
            strokeLinejoin: "round"
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (IconDark);


/***/ }),

/***/ 97687:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "V": function() { return /* binding */ IconDirection; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(41844);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(55784);


const IconDirection = ()=>{
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("svg", {
        width: "24",
        height: "25",
        viewBox: "0 0 24 25",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                d: "M7 7.5L11 12.5L7 17.5",
                stroke: "#7673E6",
                strokeWidth: "1.5",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                d: "M13 7.5L17 12.5L13 17.5",
                stroke: "#7673E6",
                strokeWidth: "1.5",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            })
        ]
    });
};


/***/ }),

/***/ 12554:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "w": function() { return /* binding */ IconFilter; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(41844);

const IconFilter = (param)=>{
    let { className  } = param;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        className: className,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
            d: "M5.8335 17.5L5.8335 13.3333M5.8335 4.16667V2.5M5.8335 4.16667C7.21421 4.16667 8.3335 5.28595 8.3335 6.66667V8.33333C8.3335 9.71404 7.21421 10.8333 5.8335 10.8333C4.45278 10.8333 3.3335 9.71404 3.3335 8.33333V6.66667C3.3335 5.28595 4.45278 4.16667 5.8335 4.16667ZM14.1668 6.66667V2.5M14.1668 17.5V15.8333M14.1668 15.8333C15.5475 15.8333 16.6668 14.714 16.6668 13.3333V11.6667C16.6668 10.286 15.5475 9.16667 14.1668 9.16667C12.7861 9.16667 11.6668 10.286 11.6668 11.6667V13.3333C11.6668 14.714 12.7861 15.8333 14.1668 15.8333Z",
            stroke: "#7673E6",
            strokeLinecap: "round"
        })
    });
};


/***/ }),

/***/ 64340:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "A": function() { return /* binding */ IconHeart; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(41844);
/* harmony import */ var _app_context__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(17986);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(55784);



const IconHeart = (param)=>{
    let { className  } = param;
    const { themeApp  } = (0,react__WEBPACK_IMPORTED_MODULE_2__.useContext)(_app_context__WEBPACK_IMPORTED_MODULE_1__/* .AppContext */ .Il);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "24",
        height: "24",
        viewBox: "0 0 33 33",
        fill: "none",
        className: className,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
            d: "M23.1679 9.16722C24.6407 9.16722 25.8346 10.3611 25.8346 11.8339M16.5013 8.10394L17.4147 7.16722C20.2559 4.25351 24.8625 4.2535 27.7037 7.16722C30.4686 10.0027 30.5536 14.5723 27.8961 17.5138L20.2609 25.9648C18.2326 28.2099 14.77 28.2099 12.7416 25.9648L5.10654 17.5138C2.44901 14.5723 2.53397 10.0027 5.2989 7.16724C8.14013 4.25352 12.7467 4.25352 15.5879 7.16725L16.5013 8.10394Z",
            stroke: "#7673E6",
            strokeWidth: "2",
            strokeLinecap: "round",
            strokeLinejoin: "round"
        })
    });
};


/***/ }),

/***/ 27459:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "h": function() { return /* binding */ IconHelpCenter; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(41844);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(55784);


const IconHelpCenter = (param)=>{
    let { className  } = param;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
        width: "18",
        height: "18",
        viewBox: "0 0 18 18",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        className: className,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M17.3327 9.00033C17.3327 13.6027 13.6017 17.3337 8.99935 17.3337C4.39698 17.3337 0.666016 13.6027 0.666016 9.00033C0.666016 4.39795 4.39698 0.666992 8.99935 0.666992C13.6017 0.666992 17.3327 4.39795 17.3327 9.00033ZM8.99935 4.75033C8.03285 4.75033 7.24935 5.53383 7.24935 6.50033C7.24935 6.91454 6.91356 7.25033 6.49935 7.25033C6.08514 7.25033 5.74935 6.91454 5.74935 6.50033C5.74935 4.7054 7.20442 3.25033 8.99935 3.25033C10.7943 3.25033 12.2493 4.7054 12.2493 6.50033C12.2493 7.84738 11.43 9.00133 10.2654 9.49427C10.0933 9.56713 9.9491 9.66872 9.85714 9.77263C9.76899 9.87224 9.74935 9.94759 9.74935 10.0003V10.667C9.74935 11.0812 9.41356 11.417 8.99935 11.417C8.58514 11.417 8.24935 11.0812 8.24935 10.667V10.0003C8.24935 8.9978 9.06422 8.37389 9.68074 8.11293C10.3101 7.84652 10.7493 7.22386 10.7493 6.50033C10.7493 5.53383 9.96585 4.75033 8.99935 4.75033ZM8.99935 14.0003C9.45959 14.0003 9.83268 13.6272 9.83268 13.167C9.83268 12.7068 9.45959 12.3337 8.99935 12.3337C8.53911 12.3337 8.16602 12.7068 8.16602 13.167C8.16602 13.6272 8.53911 14.0003 8.99935 14.0003Z",
            fill: "#7673E6"
        })
    });
};


/***/ }),

/***/ 67895:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "h": function() { return /* binding */ IconInventory; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(41844);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(55784);


const IconInventory = (param)=>{
    let { className  } = param;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
        width: "16",
        height: "18",
        viewBox: "0 0 16 18",
        fill: "none",
        className: className,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M4.87429 3.16699C4.87429 1.4411 6.2734 0.0419922 7.99929 0.0419922C9.72518 0.0419922 11.1243 1.4411 11.1243 3.16699V4.00847C12.7012 4.11844 13.9989 5.33021 14.1976 6.92021L15.0309 13.5869C15.2796 15.5764 13.7283 17.3337 11.7233 17.3337H4.27523C2.27024 17.3337 0.718949 15.5764 0.967638 13.5869L1.80097 6.92021C1.99972 5.33021 3.29737 4.11844 4.87429 4.00847V3.16699ZM9.87429 3.16699V4.00033H6.12429V3.16699C6.12429 2.13146 6.96376 1.29199 7.99929 1.29199C9.03482 1.29199 9.87429 2.13146 9.87429 3.16699ZM10.8063 12.8781C11.1069 12.7086 11.2133 12.3274 11.0437 12.0267C10.8742 11.726 10.493 11.6197 10.1924 11.7892C9.24464 12.3235 8.59859 12.5408 7.99926 12.542C7.40107 12.5431 6.75518 12.329 5.80835 11.7904C5.50832 11.6197 5.12674 11.7246 4.95606 12.0246C4.78538 12.3246 4.89024 12.7062 5.19027 12.8769C6.20689 13.4552 7.08082 13.7938 8.00168 13.792C8.9214 13.7902 9.79361 13.449 10.8063 12.8781Z",
            fill: "#7673E6"
        })
    });
};


/***/ }),

/***/ 93057:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(41844);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(55784);


const IconLight = (param)=>{
    let { className , fill  } = param;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("svg", {
        className: className,
        xmlns: "http://www.w3.org/2000/svg",
        width: "19",
        height: "20",
        viewBox: "0 0 19 20",
        fill: "none",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("g", {
                clipPath: "url(#clip0_7860_36345)",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                        d: "M9.29124 14.3535C11.6957 14.3535 13.645 12.4042 13.645 9.99974C13.645 7.59523 11.6957 5.646 9.29124 5.646C6.88674 5.646 4.9375 7.59523 4.9375 9.99974C4.9375 12.4042 6.88674 14.3535 9.29124 14.3535Z",
                        fill: fill ? fill : "#907ED9"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                        d: "M17.1243 10.8705H16.2536C16.0226 10.8705 15.8011 10.7787 15.6378 10.6154C15.4746 10.4521 15.3828 10.2307 15.3828 9.99972C15.3828 9.76878 15.4746 9.5473 15.6378 9.384C15.8011 9.22071 16.0226 9.12897 16.2536 9.12897H17.1243C17.3552 9.12897 17.5767 9.22071 17.74 9.384C17.9033 9.5473 17.9951 9.76878 17.9951 9.99972C17.9951 10.2307 17.9033 10.4521 17.74 10.6154C17.5767 10.7787 17.3552 10.8705 17.1243 10.8705Z",
                        fill: fill ? fill : "#907ED9"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                        d: "M2.32743 10.8705H1.45669C1.22575 10.8705 1.00427 10.7787 0.840974 10.6154C0.677677 10.4521 0.585938 10.2307 0.585938 9.99972C0.585938 9.76878 0.677677 9.5473 0.840974 9.384C1.00427 9.22071 1.22575 9.12897 1.45669 9.12897H2.32743C2.55837 9.12897 2.77985 9.22071 2.94315 9.384C3.10644 9.5473 3.19818 9.76878 3.19818 9.99972C3.19818 10.2307 3.10644 10.4521 2.94315 10.6154C2.77985 10.7787 2.55837 10.8705 2.32743 10.8705Z",
                        fill: fill ? fill : "#907ED9"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                        d: "M14.2185 5.94205C14.0022 5.93226 13.7973 5.84223 13.6438 5.68954C13.4817 5.52639 13.3906 5.3057 13.3906 5.07566C13.3906 4.84562 13.4817 4.62493 13.6438 4.46178L14.2621 3.84355C14.3401 3.7524 14.4362 3.67837 14.5442 3.6261C14.6522 3.57384 14.7699 3.54447 14.8898 3.53983C15.0097 3.5352 15.1293 3.55541 15.2411 3.59918C15.3528 3.64296 15.4543 3.70936 15.5391 3.79422C15.624 3.87908 15.6904 3.98056 15.7342 4.0923C15.778 4.20404 15.7982 4.32362 15.7935 4.44354C15.7889 4.56346 15.7595 4.68113 15.7073 4.78916C15.655 4.89718 15.581 4.99324 15.4898 5.0713L14.8716 5.68954C14.7861 5.77453 14.684 5.84086 14.5716 5.88433C14.4591 5.92779 14.3389 5.94745 14.2185 5.94205Z",
                        fill: fill ? fill : "#907ED9"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                        d: "M3.75425 16.4084C3.63965 16.4091 3.52605 16.3871 3.41997 16.3438C3.31388 16.3005 3.21738 16.2366 3.13602 16.1559C2.97384 15.9928 2.88281 15.7721 2.88281 15.5421C2.88281 15.312 2.97384 15.0913 3.13602 14.9282L3.75425 14.3535C3.92083 14.2108 4.1351 14.1363 4.35424 14.1448C4.57339 14.1532 4.78127 14.2441 4.93635 14.3991C5.09142 14.5542 5.18227 14.7621 5.19073 14.9812C5.1992 15.2004 5.12466 15.4147 4.98201 15.5812L4.36377 16.1995C4.1948 16.3445 3.97667 16.4193 3.75425 16.4084Z",
                        fill: fill ? fill : "#907ED9"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                        d: "M9.29262 3.90448C9.06169 3.90448 8.84021 3.81274 8.67691 3.64944C8.51361 3.48615 8.42188 3.26467 8.42188 3.03373V2.16298C8.42188 1.93205 8.51361 1.71057 8.67691 1.54727C8.84021 1.38398 9.06169 1.29224 9.29262 1.29224C9.52356 1.29224 9.74504 1.38398 9.90833 1.54727C10.0716 1.71057 10.1634 1.93205 10.1634 2.16298V3.03373C10.1634 3.26467 10.0716 3.48615 9.90833 3.64944C9.74504 3.81274 9.52356 3.90448 9.29262 3.90448Z",
                        fill: fill ? fill : "#907ED9"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                        d: "M9.29262 18.7072C9.06169 18.7072 8.84021 18.6155 8.67691 18.4522C8.51361 18.2889 8.42188 18.0674 8.42188 17.8365V16.9657C8.42188 16.7348 8.51361 16.5133 8.67691 16.35C8.84021 16.1867 9.06169 16.095 9.29262 16.095C9.52356 16.095 9.74504 16.1867 9.90833 16.35C10.0716 16.5133 10.1634 16.7348 10.1634 16.9657V17.8365C10.1634 18.0674 10.0716 18.2889 9.90833 18.4522C9.74504 18.6155 9.52356 18.7072 9.29262 18.7072Z",
                        fill: fill ? fill : "#907ED9"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                        d: "M4.35901 5.94204C4.13058 5.94107 3.91167 5.85038 3.74948 5.68952L3.13125 5.07129C2.9886 4.90471 2.91406 4.69044 2.92252 4.4713C2.93099 4.25215 3.02184 4.04427 3.17691 3.88919C3.33199 3.73412 3.53987 3.64327 3.75902 3.6348C3.97816 3.62634 4.19243 3.70088 4.35901 3.84353L4.97724 4.46176C5.13942 4.62491 5.23045 4.8456 5.23045 5.07564C5.23045 5.30568 5.13942 5.52637 4.97724 5.68952C4.89588 5.77022 4.79938 5.83407 4.69329 5.8774C4.5872 5.92073 4.4736 5.9427 4.35901 5.94204Z",
                        fill: fill ? fill : "#907ED9"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                        d: "M14.8331 16.4084C14.6046 16.4075 14.3857 16.3168 14.2236 16.1559L13.6489 15.5377C13.5568 15.3722 13.5212 15.1813 13.5474 14.9938C13.5737 14.8064 13.6602 14.6325 13.7941 14.4987C13.928 14.3648 14.1018 14.2782 14.2893 14.252C14.4767 14.2258 14.6676 14.2614 14.8331 14.3534L15.4513 14.9717C15.6135 15.1348 15.7045 15.3555 15.7045 15.5856C15.7045 15.8156 15.6135 16.0363 15.4513 16.1994C15.2801 16.3466 15.0585 16.4215 14.8331 16.4084Z",
                        fill: fill ? fill : "#907ED9"
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("defs", {
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("clipPath", {
                    id: "clip0_7860_36345",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("rect", {
                        width: "18.2857",
                        height: "18.2857",
                        fill: fill ? fill : "#907ED9",
                        transform: "translate(0.148438 0.856873)"
                    })
                })
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (IconLight);


/***/ }),

/***/ 79766:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "g": function() { return /* binding */ IconLogout; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(41844);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(55784);


const IconLogout = (param)=>{
    let { className  } = param;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("svg", {
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        className: className,
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                d: "M15 7.5L17.5 10M17.5 10L15 12.5M17.5 10H7.5",
                stroke: "#7673E6",
                strokeWidth: "1.5",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                d: "M12.5 6.25V6.25C12.5 4.17893 10.8211 2.5 8.75 2.5H6.5C4.29086 2.5 2.5 4.29086 2.5 6.5V13.5C2.5 15.7091 4.29086 17.5 6.5 17.5H8.75C10.8211 17.5 12.5 15.8211 12.5 13.75V13.75",
                stroke: "#7673E6",
                strokeWidth: "1.5",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            })
        ]
    });
};


/***/ }),

/***/ 27298:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "x": function() { return /* binding */ IconNonCopy; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(41844);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(55784);


const IconNonCopy = (param)=>{
    let { stroke ="#9F9EA9" , className  } = param;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("svg", {
        width: "18",
        height: "18",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        className: className,
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("g", {
                clipPath: "url(#clip0_11185_37072)",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                    d: "M6.66602 6.6665V4.99984C6.66602 3.15889 8.1584 1.6665 9.99935 1.6665L14.9993 1.6665C16.8403 1.6665 18.3327 3.15889 18.3327 4.99984V9.99984C18.3327 11.8408 16.8403 13.3332 14.9993 13.3332H13.3327M6.66602 6.6665H4.99935C3.1584 6.6665 1.66602 8.15889 1.66602 9.99984V14.9998C1.66602 16.8408 3.1584 18.3332 4.99935 18.3332H9.99935C11.8403 18.3332 13.3327 16.8408 13.3327 14.9998V13.3332M6.66602 6.6665H9.99935C11.8403 6.6665 13.3327 8.15889 13.3327 9.99984V13.3332",
                    stroke: stroke,
                    strokeWidth: "1.5",
                    strokeLinejoin: "round"
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("defs", {
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("clipPath", {
                    id: "clip0_11185_37072",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("rect", {
                        width: "20",
                        height: "20",
                        fill: "white"
                    })
                })
            })
        ]
    });
};


/***/ }),

/***/ 21572:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "W": function() { return /* binding */ IconReadAll; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(41844);

const IconReadAll = (param)=>{
    let { className , fill  } = param;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        className: className,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
            d: "M1.66797 10.833L4.60665 13.184C5.29608 13.7355 6.29601 13.6537 6.88664 12.9975L13.3346 5.83301M6.66797 10.833L9.60666 13.184C10.2961 13.7355 11.296 13.6537 11.8866 12.9975L18.3346 5.83301",
            stroke: fill ? fill : "#7673E6",
            strokeWidth: "1.5",
            strokeLinecap: "round",
            strokeLinejoin: "round"
        })
    });
};


/***/ }),

/***/ 85634:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "j": function() { return /* binding */ IconSearch; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(41844);
/* harmony import */ var _app_helpers__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2993);


const IconSearch = (param)=>{
    let { fill ="#7673E6" , className , onClick  } = param;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
        width: "22",
        height: "21",
        viewBox: "0 0 22 21",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        className: className,
        onClick: !!onClick ? onClick : _app_helpers__WEBPACK_IMPORTED_MODULE_1__/* .doNothing */ .cn,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("g", {
            id: "search",
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                id: "combo shape",
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M17.5352 9.5C17.5352 13.7802 14.0654 17.25 9.78516 17.25C5.50495 17.25 2.03516 13.7802 2.03516 9.5C2.03516 5.21979 5.50495 1.75 9.78516 1.75C14.0654 1.75 17.5352 5.21979 17.5352 9.5ZM9.78516 18.75C14.8938 18.75 19.0352 14.6086 19.0352 9.5C19.0352 4.39137 14.8938 0.25 9.78516 0.25C4.67652 0.25 0.535156 4.39137 0.535156 9.5C0.535156 14.6086 4.67652 18.75 9.78516 18.75ZM20.7069 20.4217C19.9357 21.1928 18.6855 21.1928 17.9144 20.4217L16.0415 18.5488C17.1317 17.7936 18.0788 16.8465 18.8339 15.7563L20.7068 17.6292C21.478 18.4003 21.478 19.6506 20.7069 20.4217Z",
                fill: fill
            })
        })
    });
};


/***/ }),

/***/ 34748:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "k": function() { return /* binding */ IconSetting; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(41844);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(55784);


const IconSetting = (param)=>{
    let { className  } = param;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        className: className,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M9.20454 2.5H10.7955C11.6741 2.5 12.3864 3.17157 12.3864 4C12.3864 4.94801 13.4007 5.55074 14.2333 5.09748L14.3179 5.05145C15.0788 4.63723 16.0518 4.88305 16.4911 5.60049L17.2866 6.89952C17.7259 7.61696 17.4652 8.53435 16.7043 8.94856C15.8712 9.40203 15.8712 10.598 16.7043 11.0514C17.4652 11.4657 17.7259 12.383 17.2866 13.1005L16.4911 14.3995C16.0518 15.117 15.0788 15.3628 14.3179 14.9486L14.2333 14.9025C13.4007 14.4493 12.3864 15.052 12.3864 16C12.3864 16.8284 11.6741 17.5 10.7955 17.5H9.20454C8.3259 17.5 7.61363 16.8284 7.61363 16C7.61363 15.052 6.5993 14.4493 5.76667 14.9025L5.6821 14.9486C4.92117 15.3628 3.94818 15.117 3.50887 14.3995L2.71341 13.1005C2.27409 12.383 2.5348 11.4657 3.29572 11.0514C4.12876 10.598 4.12876 9.40202 3.29572 8.94855C2.5348 8.53434 2.27409 7.61695 2.71341 6.89951L3.50887 5.60048C3.94819 4.88304 4.92117 4.63722 5.6821 5.05144L5.76667 5.09747C6.5993 5.55073 7.61363 4.94801 7.61363 4C7.61363 3.17157 8.3259 2.5 9.20454 2.5ZM10 12.5C11.3807 12.5 12.5 11.3807 12.5 10C12.5 8.61929 11.3807 7.5 10 7.5C8.6193 7.5 7.50001 8.61929 7.50001 10C7.50001 11.3807 8.6193 12.5 10 12.5Z",
            fill: "#7673E6"
        })
    });
};


/***/ }),

/***/ 73416:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "k": function() { return /* binding */ IconStore; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(41844);
/* harmony import */ var _app_context__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(17986);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(55784);



const IconStore = (param)=>{
    let { fill , className  } = param;
    const { themeApp  } = (0,react__WEBPACK_IMPORTED_MODULE_2__.useContext)(_app_context__WEBPACK_IMPORTED_MODULE_1__/* .AppContext */ .Il);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "25",
        height: "24",
        viewBox: "0 0 25 24",
        fill: "none",
        className: className,
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                d: "M22.6445 8.25V6C22.6445 3.79086 20.8537 2 18.6445 2H6.64453C4.43539 2 2.64453 3.79086 2.64453 6V8.25C2.64453 10.3211 4.13692 12 5.97786 12C7.81881 12 9.3112 10.3211 9.3112 8.25C9.3112 10.3211 10.8036 12 12.6445 12C14.4855 12 15.9779 10.3211 15.9779 8.25C15.9779 10.3211 17.4703 12 19.3112 12C21.1521 12 22.6445 10.3211 22.6445 8.25Z",
                stroke: fill ? fill : "#65676B",
                strokeWidth: "1.5",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                d: "M9.64453 18C12.0007 19.3404 13.2921 19.3263 15.6445 18",
                stroke: fill ? fill : "#65676B",
                strokeWidth: "1.5",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                d: "M21.6445 11V18C21.6445 20.2091 19.8537 22 17.6445 22H7.64453C5.43539 22 3.64453 20.2091 3.64453 18V11",
                stroke: fill ? fill : "#65676B",
                strokeWidth: "1.5",
                strokeLinejoin: "round"
            })
        ]
    });
};


/***/ }),

/***/ 61552:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "s4": function() { return /* reexport */ IconCommentNews; },
  "xu": function() { return /* reexport */ IconCopyLink; },
  "zJ": function() { return /* reexport */ IconFacebook; },
  "vY": function() { return /* reexport */ IconGoogle; },
  "AU": function() { return /* reexport */ IconHeart/* IconHeart */.A; },
  "kx": function() { return /* reexport */ IconSave; },
  "jV": function() { return /* reexport */ IconSearch/* IconSearch */.j; },
  "D5": function() { return /* reexport */ IconSelectCreateEvent; },
  "l6": function() { return /* reexport */ IconSelectCreatePost; },
  "FO": function() { return /* reexport */ IconShare; },
  "z2": function() { return /* reexport */ IconToastError; }
});

// UNUSED EXPORTS: IconTabEvents, IconTabNews

// EXTERNAL MODULE: ./node_modules/next/dist/compiled/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(41844);
;// CONCATENATED MODULE: ./app/components/icon-tsx/IconGoogle.tsx

const IconGoogle = ()=>{
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M24.0104 12.2761C24.0104 11.4603 23.9443 10.6402 23.8032 9.83769H12.4844V14.4587H18.9661C18.6971 15.949 17.8329 17.2674 16.5674 18.1052V21.1035H20.4344C22.7052 19.0135 24.0104 15.927 24.0104 12.2761Z",
                fill: "#4285F4"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M12.4844 24.0005C15.7208 24.0005 18.4502 22.9378 20.4388 21.1035L16.5718 18.1052C15.4959 18.8371 14.107 19.2516 12.4888 19.2516C9.35815 19.2516 6.70373 17.1395 5.75132 14.2999H1.76087V17.3909C3.79798 21.443 7.94717 24.0005 12.4844 24.0005Z",
                fill: "#34A853"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M5.74692 14.2999C5.24426 12.8096 5.24426 11.1958 5.74692 9.7054V6.61446H1.76088C0.0588806 10.0052 0.0588683 14.0001 1.76087 17.3909L5.74692 14.2999Z",
                fill: "#FBBC04"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M12.4844 4.74929C14.1952 4.72284 15.8487 5.3666 17.0877 6.5483L20.5138 3.12225C18.3444 1.08514 15.4651 -0.0348322 12.4844 0.000442455C7.94717 0.000442455 3.79799 2.55787 1.76088 6.61446L5.74692 9.7054C6.69493 6.86138 9.35374 4.74929 12.4844 4.74929Z",
                fill: "#EA4335"
            })
        ]
    });
};

;// CONCATENATED MODULE: ./app/components/icon-tsx/IconFacebook.tsx

const IconFacebook = ()=>{
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
        width: "25",
        height: "24",
        viewBox: "0 0 25 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            d: "M24.75 12.0729C24.75 5.44545 19.3774 0.072876 12.75 0.072876C6.12258 0.072876 0.75 5.44545 0.75 12.0729C0.75 18.0623 5.1382 23.0269 10.875 23.9271V15.5416H7.82812V12.0729H10.875V9.42913C10.875 6.42163 12.6666 4.76038 15.4076 4.76038C16.7201 4.76038 18.0938 4.99475 18.0938 4.99475V7.94788H16.5806C15.09 7.94788 14.625 8.87295 14.625 9.82288V12.0729H17.9531L17.4211 15.5416H14.625V23.9271C20.3618 23.0269 24.75 18.0623 24.75 12.0729Z",
            fill: "white"
        })
    });
};

// EXTERNAL MODULE: ./node_modules/next/dist/compiled/react/index.js
var react = __webpack_require__(55784);
;// CONCATENATED MODULE: ./app/components/icon-tsx/IconToastError.tsx


const IconToastError = ()=>{
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
        width: "24",
        height: "25",
        viewBox: "0 0 24 25",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M17.02 3.38C16.54 2.9 15.58 2.5 14.9 2.5H9.1C8.42 2.5 7.46 2.9 6.98 3.38L2.88 7.48C2.4 7.96 2 8.92 2 9.6V15.4C2 16.08 2.4 17.04 2.88 17.52L6.98 21.62C7.46 22.1 8.42 22.5 9.1 22.5H14.9C15.58 22.5 16.54 22.1 17.02 21.62L21.12 17.52C21.6 17.04 22 16.08 22 15.4V9.6C22 8.92 21.6 7.96 21.12 7.48L17.02 3.38ZM16.03 16.53C15.88 16.68 15.69 16.75 15.5 16.75C15.31 16.75 15.12 16.68 14.97 16.53L12 13.56L9.03 16.53C8.88 16.68 8.69 16.75 8.5 16.75C8.31 16.75 8.12 16.68 7.97 16.53C7.68 16.24 7.68 15.76 7.97 15.47L10.94 12.5L7.97 9.53C7.68 9.24 7.68 8.76 7.97 8.47C8.26 8.18 8.74 8.18 9.03 8.47L12 11.44L14.97 8.47C15.26 8.18 15.74 8.18 16.03 8.47C16.32 8.76 16.32 9.24 16.03 9.53L13.06 12.5L16.03 15.47C16.32 15.76 16.32 16.24 16.03 16.53Z",
            fill: "#EB5757"
        })
    });
};

// EXTERNAL MODULE: ./app/components/icon-tsx/IconLight.tsx
var IconLight = __webpack_require__(93057);
// EXTERNAL MODULE: ./app/components/icon-tsx/IconDark.tsx
var IconDark = __webpack_require__(38416);
// EXTERNAL MODULE: ./app/components/icon-tsx/IconSearch.tsx
var IconSearch = __webpack_require__(85634);
;// CONCATENATED MODULE: ./app/components/icon-tsx/IconTabNews.tsx


const IconTabNews = ()=>{
    return /*#__PURE__*/ _jsx("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        strokeWidth: "1.5",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        children: /*#__PURE__*/ _jsx("path", {
            d: "M18 17H15M18 14H15M6 21H18C20.2091 21 22 19.2091 22 17V7C22 4.79086 20.2091 3 18 3H6C3.79086 3 2 4.79086 2 7V17C2 19.2091 3.79086 21 6 21ZM8 7H10C11.1046 7 12 7.89543 12 9C12 10.1046 11.1046 11 10 11H8C6.89543 11 6 10.1046 6 9C6 7.89543 6.89543 7 8 7Z"
        })
    });
};

;// CONCATENATED MODULE: ./app/components/icon-tsx/IconTabEvents.tsx


const IconTabEvents = ()=>{
    return /*#__PURE__*/ _jsxs("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "M16 2V5",
                stroke: "#706E7E",
                strokeWidth: "1.5",
                strokeLinecap: "round"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M8 2V5",
                stroke: "#706E7E",
                strokeWidth: "1.5",
                strokeLinecap: "round"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M3 7.5C3 5.29086 4.79086 3.5 7 3.5H17C19.2091 3.5 21 5.29086 21 7.5V18C21 20.2091 19.2091 22 17 22H7C4.79086 22 3 20.2091 3 18V7.5Z",
                stroke: "#706E7E",
                strokeWidth: "1.5"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M3 9H21",
                stroke: "#706E7E",
                strokeWidth: "1.5",
                strokeLinecap: "round"
            })
        ]
    });
};

;// CONCATENATED MODULE: ./app/components/icon-tsx/IconSelectCreatePost.tsx

const IconSelectCreatePost = (param)=>{
    let { className  } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
        width: "25",
        height: "24",
        viewBox: "0 0 25 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        className: className,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M3 6C3 4.20507 4.45507 2.75 6.25 2.75H12.25C12.6642 2.75 13 2.41421 13 2C13 1.58579 12.6642 1.25 12.25 1.25H6.25C3.62665 1.25 1.5 3.37665 1.5 6V18C1.5 20.6234 3.62665 22.75 6.25 22.75H18.25C20.8734 22.75 23 20.6234 23 18V12C23 11.5858 22.6642 11.25 22.25 11.25C21.8358 11.25 21.5 11.5858 21.5 12V18C21.5 19.7949 20.0449 21.25 18.25 21.25H6.25C4.45507 21.25 3 19.7949 3 18V6ZM16.669 2.67708C17.5718 1.77431 19.0355 1.77431 19.9383 2.67708L21.5729 4.31171C22.4757 5.21449 22.4757 6.67818 21.5729 7.58096L20.1236 9.03028C20.0098 8.97394 19.8901 8.91302 19.766 8.84767C18.9306 8.40786 17.9392 7.79057 17.1993 7.05069C16.4595 6.31082 15.8422 5.31945 15.4024 4.48403C15.337 4.35989 15.2761 4.24018 15.2197 4.12639L16.669 2.67708ZM16.1387 8.11135C17.0142 8.98687 18.1277 9.67594 19.0095 10.1444L13.31 15.8438C12.9564 16.1975 12.4975 16.4269 12.0023 16.4977L8.56963 16.9881C7.8068 17.097 7.15295 16.4432 7.26193 15.6804L7.75231 12.2477C7.82305 11.7525 8.05248 11.2936 8.40616 10.94L14.1056 5.24053C14.5741 6.12234 15.2631 7.23582 16.1387 8.11135Z",
            fill: "#7673E6"
        })
    });
};

;// CONCATENATED MODULE: ./app/components/icon-tsx/IconSelectCreateEvent.tsx

const IconSelectCreateEvent = (param)=>{
    let { className  } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
        width: "25",
        height: "24",
        viewBox: "0 0 25 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        className: className,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M9.5 2C9.5 1.58579 9.16421 1.25 8.75 1.25C8.33579 1.25 8 1.58579 8 2V3.5H7.75C5.54086 3.5 3.75 5.29086 3.75 7.5V8.25H21.75V7.5C21.75 5.29086 19.9591 3.5 17.75 3.5H17.5V2C17.5 1.58579 17.1642 1.25 16.75 1.25C16.3358 1.25 16 1.58579 16 2V3.5H9.5V2ZM21.75 9.75H3.75V18C3.75 20.2091 5.54086 22 7.75 22H17.75C19.9591 22 21.75 20.2091 21.75 18V9.75ZM13.5 12C13.5 11.5858 13.1642 11.25 12.75 11.25C12.3358 11.25 12 11.5858 12 12V14.25H9.75C9.33579 14.25 9 14.5858 9 15C9 15.4142 9.33579 15.75 9.75 15.75H12V18C12 18.4142 12.3358 18.75 12.75 18.75C13.1642 18.75 13.5 18.4142 13.5 18V15.75H15.75C16.1642 15.75 16.5 15.4142 16.5 15C16.5 14.5858 16.1642 14.25 15.75 14.25H13.5V12Z",
            fill: "#7673E6"
        })
    });
};

;// CONCATENATED MODULE: ./app/components/icon-tsx/IconShare.tsx


const IconShare = (param)=>{
    let { fill ="#585669"  } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            d: "M8 16C8 12 12 10 16 10M16 10L14 13M16 10L13 8M6 22H18C20.2091 22 22 20.2091 22 18V6C22 3.79086 20.2091 2 18 2H6C3.79086 2 2 3.79086 2 6V18C2 20.2091 3.79086 22 6 22Z",
            stroke: fill,
            strokeWidth: "1.5",
            strokeLinecap: "round",
            strokeLinejoin: "round"
        })
    });
};

;// CONCATENATED MODULE: ./app/components/icon-tsx/IconCopyLink.tsx


const IconCopyLink = (param)=>{
    let { fill ="#585669"  } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M14.1211 9.87866L9.87845 14.1213",
                stroke: fill,
                strokeWidth: "1.5",
                strokeLinecap: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M10.332 7.00003L11.9987 5.33336C13.8396 3.49239 16.8244 3.49239 18.6654 5.33335V5.33335C20.5063 7.17431 20.5063 10.1591 18.6654 12.0001L16.9987 13.6667",
                stroke: fill,
                strokeWidth: "1.5",
                strokeLinecap: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M13.668 17L12.0013 18.6666C10.1604 20.5076 7.17558 20.5076 5.33462 18.6666V18.6666C3.49365 16.8257 3.49365 13.8409 5.33462 11.9999L7.00129 10.3333",
                stroke: fill,
                strokeWidth: "1.5",
                strokeLinecap: "round"
            })
        ]
    });
};

;// CONCATENATED MODULE: ./app/components/icon-tsx/IconSave.tsx


const IconSave = (param)=>{
    let { fill ="#585669"  } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            d: "M4 7H20M4 4V18C4 19.6481 5.88153 20.5889 7.2 19.6L10.8 16.9C11.5111 16.3667 12.4889 16.3667 13.2 16.9L16.8 19.6C18.1185 20.5889 20 19.6481 20 18V4C20 2.89543 19.1046 2 18 2H6C4.89543 2 4 2.89543 4 4Z",
            stroke: fill,
            strokeWidth: "1.5",
            strokeLinecap: "round",
            strokeLinejoin: "round"
        })
    });
};

;// CONCATENATED MODULE: ./app/components/icon-tsx/IconCommentNews.tsx


const IconCommentNews = (param)=>{
    let { className  } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        className: className,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M13 3H11C6.02944 3 2 7.02944 2 12V17C2 19.2091 3.79086 21 6 21H13C17.9706 21 22 16.9706 22 12C22 7.02944 17.9706 3 13 3Z",
                stroke: "#7673E6",
                strokeWidth: "1.5",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("ellipse", {
                cx: "12",
                cy: "12",
                rx: "1",
                ry: "1",
                fill: "#7673E6"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("ellipse", {
                cx: "16",
                cy: "12",
                rx: "1",
                ry: "1",
                fill: "#7673E6"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("ellipse", {
                cx: "8",
                cy: "12",
                rx: "1",
                ry: "1",
                fill: "#7673E6"
            })
        ]
    });
};

// EXTERNAL MODULE: ./app/components/icon-tsx/IconHeart.tsx
var IconHeart = __webpack_require__(64340);
;// CONCATENATED MODULE: ./app/components/icon-tsx/index.ts

















/***/ }),

/***/ 25327:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "n": function() { return /* binding */ LoadingBtnComponent; }
});

// EXTERNAL MODULE: ./node_modules/next/dist/compiled/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(41844);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/react/index.js
var react = __webpack_require__(55784);
;// CONCATENATED MODULE: ./app/components/icon-tsx/LoadingOutside.tsx

const LoadingOutside = (param)=>{
    let { className , style  } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
        width: "19",
        height: "19",
        viewBox: "0 0 19 19",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        className: className,
        style: style,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            d: "M0.75 9.5C0.75 14.3325 4.66751 18.25 9.5 18.25C14.3325 18.25 18.25 14.3325 18.25 9.5C18.25 4.66751 14.3325 0.75 9.5 0.75",
            stroke: "white",
            strokeWidth: "1.5",
            strokeLinecap: "round",
            strokeLinejoin: "round"
        })
    });
};

;// CONCATENATED MODULE: ./app/components/icon-tsx/LoadingInside.tsx

const LoadingInside = (param)=>{
    let { className , style  } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
        width: "13",
        height: "13",
        viewBox: "0 0 13 13",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        className: className,
        style: style,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            d: "M11.75 6.5C11.75 3.60051 9.39949 1.25 6.5 1.25C3.60051 1.25 1.25 3.60051 1.25 6.5C1.25 9.39949 3.60051 11.75 6.5 11.75",
            stroke: "#FFBFCC",
            strokeWidth: "1.5",
            strokeLinecap: "round",
            strokeLinejoin: "round"
        })
    });
};

;// CONCATENATED MODULE: ./app/components/loading-btn/index.tsx




const LoadingBtnComponent = (param)=>{
    let { classname  } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "relative w-[21px] h-[21px] flex item-center ".concat(classname),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(LoadingOutside, {
                style: {
                    top: "15%",
                    transform: "translate(50%, 50%)"
                },
                className: "rotate absolute z-1"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(LoadingInside, {
                style: {
                    top: "25%",
                    left: "15%",
                    transform: "translate(50%, 50%)"
                },
                className: "rotate-back absolute"
            })
        ]
    });
};


/***/ }),

/***/ 66983:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ pagination; }
});

// EXTERNAL MODULE: ./node_modules/next/dist/compiled/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(41844);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/react/index.js
var react = __webpack_require__(55784);
;// CONCATENATED MODULE: ./app/components/pagination/usePagination.tsx


const DOTS = "...";
const range = (start, end)=>{
    let length = end - start + 1;
    return Array.from({
        length
    }, (_, idx)=>idx + start);
};
const usePagination = (param)=>{
    let { totalCount , pageSize , siblingCount =1 , currentPage  } = param;
    const paginationRange = (0,react.useMemo)(()=>{
        const totalPageCount = Math.ceil(totalCount / pageSize);
        // Pages count is determined as siblingCount + firstPage + lastPage + currentPage + 2*DOTS
        const totalPageNumbers = siblingCount + 5;
        /*
      If the number of pages is less than the page numbers we want to show in our
      paginationComponent, we return the range [1..totalPageCount]
    */ if (totalPageNumbers >= totalPageCount) {
            return range(1, totalPageCount);
        }
        const leftSiblingIndex = Math.max(currentPage - siblingCount, 1);
        const rightSiblingIndex = Math.min(currentPage + siblingCount, totalPageCount);
        /*
      We do not want to show dots if there is only one position left 
      after/before the left/right page count as that would lead to a change if our Pagination
      component size which we do not want
    */ const shouldShowLeftDots = leftSiblingIndex > 2;
        const shouldShowRightDots = rightSiblingIndex < totalPageCount - 2;
        const firstPageIndex = 1;
        const lastPageIndex = totalPageCount;
        if (!shouldShowLeftDots && shouldShowRightDots) {
            let leftItemCount = 3 + 2 * siblingCount;
            let leftRange = range(1, leftItemCount);
            return [
                ...leftRange,
                DOTS,
                totalPageCount
            ];
        }
        if (shouldShowLeftDots && !shouldShowRightDots) {
            let rightItemCount = 3 + 2 * siblingCount;
            let rightRange = range(totalPageCount - rightItemCount + 1, totalPageCount);
            return [
                firstPageIndex,
                DOTS,
                ...rightRange
            ];
        }
        if (shouldShowLeftDots && shouldShowRightDots) {
            let middleRange = range(leftSiblingIndex, rightSiblingIndex);
            return [
                firstPageIndex,
                DOTS,
                ...middleRange,
                DOTS,
                lastPageIndex
            ];
        }
    }, [
        totalCount,
        pageSize,
        siblingCount,
        currentPage
    ]);
    return paginationRange || [];
};

// EXTERNAL MODULE: ./app/components/icon-tsx/IconArrowRight.tsx
var IconArrowRight = __webpack_require__(99777);
// EXTERNAL MODULE: ./app/components/icon-tsx/IconArrowLeft.tsx
var IconArrowLeft = __webpack_require__(82341);
;// CONCATENATED MODULE: ./app/components/pagination/index.tsx





const Pagination = (props)=>{
    const { onPageChange , totalCount , siblingCount =1 , currentPage , pageSize , className  } = props;
    const paginationRange = usePagination({
        currentPage,
        totalCount,
        siblingCount,
        pageSize
    });
    if (currentPage === 0 || paginationRange.length < 2) {
        return null;
    }
    const onNext = ()=>{
        if (paginationRange && currentPage < Number(paginationRange[paginationRange.length - 1])) {
            onPageChange(currentPage + 1);
        }
    };
    const onPrevious = ()=>{
        if (currentPage > 1) onPageChange(currentPage - 1);
    };
    let lastPage = paginationRange[paginationRange.length - 1];
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("ul", {
        className: "flex gap-[8px] ".concat(className),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                className: "p-[3px] rounded-[8px] border border-main-01 h-fit mr-[8px] ".concat(currentPage === 1 ? "opacity-60" : "cursor-pointer"),
                onClick: onPrevious,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(IconArrowLeft/* IconArrowLeft */.D, {})
            }),
            paginationRange.map((pageNumber, index)=>{
                if (pageNumber === DOTS) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                        className: "pagination-item dots",
                        children: "…"
                    }, pageNumber + index);
                }
                return /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                    className: "w-[32px] h-[32px] rounded-[8px] text-[14px] justify-center items-center flex ".concat(pageNumber === currentPage ? "bg-main-01 text-main-white cursor-default" : "text-neutral-03 bg-white dark:bg-bg-button/10 dark:text-main-white border border-black/10 cursor-pointer"),
                    onClick: ()=>onPageChange(pageNumber),
                    children: pageNumber
                }, pageNumber);
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                className: "p-[3px] rounded-[8px] border border-main-01 h-fit ml-[8px] ".concat(currentPage === lastPage ? "opacity-60" : "cursor-pointer"),
                onClick: onNext,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(IconArrowRight/* IconArrowRight */.E, {})
            })
        ]
    });
};
/* harmony default export */ var pagination = (Pagination);


/***/ }),

/***/ 78121:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Q": function() { return /* binding */ PostEvent; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(41844);
/* harmony import */ var moment__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(30381);
/* harmony import */ var moment__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(moment__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(55784);
/* harmony import */ var _ui_button__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(34428);
/* harmony import */ var _icon_tsx_IconDirection__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(97687);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var _app_helpers_function__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(4203);
/* harmony import */ var next_i18next__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(93378);
/* harmony import */ var _app_configs__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(54254);
/* harmony import */ var _app_context__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(17986);
/* harmony import */ var _app_hooks_useGAEventsTracker__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(64800);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(25675);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_11___default = /*#__PURE__*/__webpack_require__.n(next_image__WEBPACK_IMPORTED_MODULE_11__);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(41664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_12___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_12__);
/* eslint-disable @next/next/no-img-element */ 












const PostEvent = (param)=>{
    let { event , onJoinEvent  } = param;
    var _event_post, _event_post1, _event_post2, _event_post3, _event_post4, _event_post5, _event_post6, _event_post7, _event_author, _event_post8, _event_post9, _event_post10, _event_post11, _event_post12, _event_post13, _event_post14, _event_post15, _event_post16, _event_post17;
    const { t  } = (0,next_i18next__WEBPACK_IMPORTED_MODULE_7__/* .useTranslation */ .$G)();
    const router = (0,next_router__WEBPACK_IMPORTED_MODULE_5__.useRouter)();
    const { userInfo  } = (0,react__WEBPACK_IMPORTED_MODULE_2__.useContext)(_app_context__WEBPACK_IMPORTED_MODULE_9__/* .AppContext */ .Il);
    const GAEventTracker = (0,_app_hooks_useGAEventsTracker__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)("Event");
    const token = _app_configs__WEBPACK_IMPORTED_MODULE_8__/* .isClient */ .C5 ? window.localStorage.getItem("token") : null;
    const navigateUrl = (0,react__WEBPACK_IMPORTED_MODULE_2__.useCallback)(()=>{
        var _event_post, _event_post1, _event_post2, _event_post3;
        const isNotPublish = (event === null || event === void 0 ? void 0 : (_event_post = event.post) === null || _event_post === void 0 ? void 0 : _event_post.public_at) * 1000 > Number(new Date().getTime());
        const id = !!isNotPublish ? event === null || event === void 0 ? void 0 : (_event_post1 = event.post) === null || _event_post1 === void 0 ? void 0 : _event_post1.id : (0,_app_helpers_function__WEBPACK_IMPORTED_MODULE_6__/* .createSlugNameDetail */ .ti)(event === null || event === void 0 ? void 0 : (_event_post2 = event.post) === null || _event_post2 === void 0 ? void 0 : _event_post2.title, event === null || event === void 0 ? void 0 : (_event_post3 = event.post) === null || _event_post3 === void 0 ? void 0 : _event_post3.id);
        const type = "event";
        const pathname = !!isNotPublish ? "/preview/".concat(type, "/").concat(id) : "/detail/".concat(type, "/").concat(id);
        return pathname;
    }, [
        event
    ]);
    const onNavigateToLinkEvent = ()=>{
        var _event_post;
        if (!!(event === null || event === void 0 ? void 0 : (_event_post = event.post) === null || _event_post === void 0 ? void 0 : _event_post.link_event)) {
            var _event_post1, _event_post_link_event, _event_post2, _event_post3;
            const link = (event === null || event === void 0 ? void 0 : (_event_post1 = event.post) === null || _event_post1 === void 0 ? void 0 : (_event_post_link_event = _event_post1.link_event) === null || _event_post_link_event === void 0 ? void 0 : _event_post_link_event.includes("https://event.playee.vn" || 0)) && token ? "".concat(event === null || event === void 0 ? void 0 : (_event_post2 = event.post) === null || _event_post2 === void 0 ? void 0 : _event_post2.link_event, "?token=").concat(token) : event === null || event === void 0 ? void 0 : (_event_post3 = event.post) === null || _event_post3 === void 0 ? void 0 : _event_post3.link_event;
            router.push(String(link));
        } else {
            var _event_post4;
            GAEventTracker("Click_event_banner", event === null || event === void 0 ? void 0 : (_event_post4 = event.post) === null || _event_post4 === void 0 ? void 0 : _event_post4.thumbnail);
            router.push(navigateUrl());
        }
    };
    const getTypeEvent = (start_time, end_time)=>{
        const moment = Number(new Date().getTime());
        if (moment > Number(end_time) * 1000 || !start_time || !end_time) {
            return "";
        }
        if (moment > Number(start_time) * 1000 && moment < Number(end_time) * 1000) {
            return t("news.happenning_event");
        }
        if (moment < Number(start_time) * 1000) {
            return t("news.incoming_event");
        }
    };
    const onSubmitReminderOrJoin = ()=>{
        var _event_post;
        onJoinEvent && onJoinEvent(event === null || event === void 0 ? void 0 : (_event_post = event.post) === null || _event_post === void 0 ? void 0 : _event_post.id);
    };
    const renderContent = (0,react__WEBPACK_IMPORTED_MODULE_2__.useMemo)(()=>{
        var _event_post;
        return typeof document === "undefined" ? null : event === null || event === void 0 ? void 0 : (_event_post = event.post) === null || _event_post === void 0 ? void 0 : _event_post.content;
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        event === null || event === void 0 ? void 0 : (_event_post = event.post) === null || _event_post === void 0 ? void 0 : _event_post.content
    ]);
    var _event_post_start_time, _extractText, _event_post_thumbnail;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: "flex-col md:flex-row flex gap-0 md:gap-[24px] mb-[24px] md:mb-[32px] w-full border-b border-black/10 dark:border-neutral-03 lg:border-0",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
            className: "grid grid-cols-12 gap-[24px] max-w-full",
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: "min-w-full col-span-12 grid grid-cols-12 gap-[12px] md:gap-[24px]",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: "flex flex-col order-1 w-full col-span-12 pb-4 lg:pb-0 md:order-0 md:col-span-8",
                        children: [
                            !!(event === null || event === void 0 ? void 0 : (_event_post1 = event.post) === null || _event_post1 === void 0 ? void 0 : _event_post1.public_at) && (event === null || event === void 0 ? void 0 : (_event_post2 = event.post) === null || _event_post2 === void 0 ? void 0 : _event_post2.public_at) * 1000 > Number(new Date().getTime()) ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("p", {
                                className: "text-[12px] Nunito-400 text-main-01 w-fit first-letter:uppercase",
                                children: [
                                    t("news.public_time"),
                                    "\xa0\xa0",
                                    moment__WEBPACK_IMPORTED_MODULE_1___default()(Number(event === null || event === void 0 ? void 0 : (_event_post3 = event.post) === null || _event_post3 === void 0 ? void 0 : _event_post3.public_at) * 1000).format(_app_configs__WEBPACK_IMPORTED_MODULE_8__/* .DATE_FORMAT_HOUR */ .fI)
                                ]
                            }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                className: "text-[12px] Nunito-400 text-bg-01 dark:text-white w-fit first-letter:uppercase",
                                children: moment__WEBPACK_IMPORTED_MODULE_1___default()(Number((_event_post_start_time = event === null || event === void 0 ? void 0 : (_event_post4 = event.post) === null || _event_post4 === void 0 ? void 0 : _event_post4.start_time) !== null && _event_post_start_time !== void 0 ? _event_post_start_time : event === null || event === void 0 ? void 0 : (_event_post5 = event.post) === null || _event_post5 === void 0 ? void 0 : _event_post5.public_at) * 1000).format(_app_configs__WEBPACK_IMPORTED_MODULE_8__/* .DATE_FORMAT_3 */ .Ly)
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: "relative flex justify-between",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_12___default()), {
                                    href: navigateUrl(),
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h3", {
                                        className: "w-fit max-w-full text-sm md:text-[18px] sd:text-[20px] text-bg-01 Nunito-700 line-clamp-1 leading-normal mt-[8px] dark:text-white overflow-hidden cursor-pointer",
                                        children: event === null || event === void 0 ? void 0 : (_event_post6 = event.post) === null || _event_post6 === void 0 ? void 0 : _event_post6.title
                                    })
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: "text-[14px] Nunito-500 line-clamp-3 dark:text-white my-[16px] w-fit max-w-[800px] break-words",
                                dangerouslySetInnerHTML: {
                                    __html: (_extractText = (0,_app_helpers_function__WEBPACK_IMPORTED_MODULE_6__/* .extractText */ .oc)("".concat(renderContent, "...") || 0)) !== null && _extractText !== void 0 ? _extractText : ""
                                }
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                className: "flex md:items-center flex-col md:flex-row gap-2 md:gap-[40px] flex-wrap",
                                children: [
                                    Number(event === null || event === void 0 ? void 0 : (_event_post7 = event.post) === null || _event_post7 === void 0 ? void 0 : _event_post7.end_time) * 1000 > Number(new Date().getTime()) && (event === null || event === void 0 ? void 0 : (_event_author = event.author) === null || _event_author === void 0 ? void 0 : _event_author.id) !== (userInfo === null || userInfo === void 0 ? void 0 : userInfo.userid) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                                        children: (event === null || event === void 0 ? void 0 : (_event_post8 = event.post) === null || _event_post8 === void 0 ? void 0 : _event_post8.joined) ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_ui_button__WEBPACK_IMPORTED_MODULE_3__/* .Button */ .z, {
                                            variant: "none",
                                            className: "bg-button text-main-01 dark:bg-[#efefff]/[.1] py-[6px] Nunito-600 text-sm cursor-default w-fit rounded-[12px] max-h-[32px]",
                                            children: t("news.joined")
                                        }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_ui_button__WEBPACK_IMPORTED_MODULE_3__/* .Button */ .z, {
                                            variant: "none",
                                            className: "w-fit bg-main-01 dark:bg-[#efefff]/[.1] text-white py-[6px] Nunito-600 text-sm rounded-[12px] max-h-[32px]",
                                            onClick: onSubmitReminderOrJoin,
                                            children: t("news.join")
                                        })
                                    }),
                                    (event === null || event === void 0 ? void 0 : (_event_post9 = event.post) === null || _event_post9 === void 0 ? void 0 : _event_post9.joined) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_ui_button__WEBPACK_IMPORTED_MODULE_3__/* .Button */ .z, {
                                        variant: "none",
                                        className: "px-0 text-sm bg-transparent text-main-01 Nunito-600 w-fit",
                                        onClick: onNavigateToLinkEvent,
                                        children: [
                                            t("news.go_to_event"),
                                            "\xa0\xa0",
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_icon_tsx_IconDirection__WEBPACK_IMPORTED_MODULE_4__/* .IconDirection */ .V, {})
                                        ]
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: "relative col-span-12 cursor-pointer order-0 md:order-1 md:col-span-4",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_12___default()), {
                                href: navigateUrl(),
                                onClick: ()=>{
                                    var _event_post;
                                    return GAEventTracker("Click_event_banner", event === null || event === void 0 ? void 0 : (_event_post = event.post) === null || _event_post === void 0 ? void 0 : _event_post.thumbnail);
                                },
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_11___default()), {
                                    src: (0,_app_helpers_function__WEBPACK_IMPORTED_MODULE_6__/* .getCdnImage */ .ZZ)((_event_post_thumbnail = event === null || event === void 0 ? void 0 : (_event_post10 = event.post) === null || _event_post10 === void 0 ? void 0 : _event_post10.thumbnail) !== null && _event_post_thumbnail !== void 0 ? _event_post_thumbnail : "", 100),
                                    width: 410,
                                    height: 230,
                                    loading: "lazy",
                                    className: "w-full rounded-[16px] object-cover aspect-[16/9]",
                                    title: event === null || event === void 0 ? void 0 : (_event_post11 = event.post) === null || _event_post11 === void 0 ? void 0 : _event_post11.title,
                                    alt: event === null || event === void 0 ? void 0 : (_event_post12 = event.post) === null || _event_post12 === void 0 ? void 0 : _event_post12.title
                                })
                            }),
                            !!getTypeEvent(event === null || event === void 0 ? void 0 : (_event_post13 = event.post) === null || _event_post13 === void 0 ? void 0 : _event_post13.start_time, event === null || event === void 0 ? void 0 : (_event_post14 = event.post) === null || _event_post14 === void 0 ? void 0 : _event_post14.end_time) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                className: "absolute top-1 right-1 sd:top-2 sd:right-2 bg-[#faf8ff]/[.4] rounded-lg px-2 py-1 text-xs sd:text-sm text-white",
                                style: {
                                    backdropFilter: "blur(1px)"
                                },
                                children: getTypeEvent(event === null || event === void 0 ? void 0 : (_event_post15 = event.post) === null || _event_post15 === void 0 ? void 0 : _event_post15.start_time, event === null || event === void 0 ? void 0 : (_event_post16 = event.post) === null || _event_post16 === void 0 ? void 0 : _event_post16.end_time)
                            })
                        ]
                    })
                ]
            })
        })
    }, event === null || event === void 0 ? void 0 : (_event_post17 = event.post) === null || _event_post17 === void 0 ? void 0 : _event_post17.id);
};


/***/ }),

/***/ 88313:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "qE": function() { return /* binding */ Avatar; },
  "Q5": function() { return /* binding */ AvatarFallback; },
  "F$": function() { return /* binding */ AvatarImage; }
});

// EXTERNAL MODULE: ./node_modules/next/dist/compiled/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(41844);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/react/index.js
var react = __webpack_require__(55784);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__(87462);
// EXTERNAL MODULE: ./node_modules/@radix-ui/react-context/dist/index.mjs
var dist = __webpack_require__(25360);
// EXTERNAL MODULE: ./node_modules/@radix-ui/react-use-callback-ref/dist/index.mjs
var react_use_callback_ref_dist = __webpack_require__(79698);
// EXTERNAL MODULE: ./node_modules/@radix-ui/react-use-layout-effect/dist/index.mjs
var react_use_layout_effect_dist = __webpack_require__(9981);
// EXTERNAL MODULE: ./node_modules/@radix-ui/react-primitive/dist/index.mjs
var react_primitive_dist = __webpack_require__(75320);
;// CONCATENATED MODULE: ./node_modules/@radix-ui/react-avatar/dist/index.mjs













/* -------------------------------------------------------------------------------------------------
 * Avatar
 * -----------------------------------------------------------------------------------------------*/ const $cddcb0b647441e34$var$AVATAR_NAME = 'Avatar';
const [$cddcb0b647441e34$var$createAvatarContext, $cddcb0b647441e34$export$90370d16b488820f] = (0,dist/* createContextScope */.b)($cddcb0b647441e34$var$AVATAR_NAME);
const [$cddcb0b647441e34$var$AvatarProvider, $cddcb0b647441e34$var$useAvatarContext] = $cddcb0b647441e34$var$createAvatarContext($cddcb0b647441e34$var$AVATAR_NAME);
const $cddcb0b647441e34$export$e2255cf6045e8d47 = /*#__PURE__*/ (0,react.forwardRef)((props, forwardedRef)=>{
    const { __scopeAvatar: __scopeAvatar , ...avatarProps } = props;
    const [imageLoadingStatus, setImageLoadingStatus] = (0,react.useState)('idle');
    return /*#__PURE__*/ (0,react.createElement)($cddcb0b647441e34$var$AvatarProvider, {
        scope: __scopeAvatar,
        imageLoadingStatus: imageLoadingStatus,
        onImageLoadingStatusChange: setImageLoadingStatus
    }, /*#__PURE__*/ (0,react.createElement)(react_primitive_dist/* Primitive.span */.WV.span, (0,esm_extends/* default */.Z)({}, avatarProps, {
        ref: forwardedRef
    })));
});
/*#__PURE__*/ Object.assign($cddcb0b647441e34$export$e2255cf6045e8d47, {
    displayName: $cddcb0b647441e34$var$AVATAR_NAME
});
/* -------------------------------------------------------------------------------------------------
 * AvatarImage
 * -----------------------------------------------------------------------------------------------*/ const $cddcb0b647441e34$var$IMAGE_NAME = 'AvatarImage';
const $cddcb0b647441e34$export$2cd8ae1985206fe8 = /*#__PURE__*/ (0,react.forwardRef)((props, forwardedRef)=>{
    const { __scopeAvatar: __scopeAvatar , src: src , onLoadingStatusChange: onLoadingStatusChange = ()=>{} , ...imageProps } = props;
    const context = $cddcb0b647441e34$var$useAvatarContext($cddcb0b647441e34$var$IMAGE_NAME, __scopeAvatar);
    const imageLoadingStatus = $cddcb0b647441e34$var$useImageLoadingStatus(src);
    const handleLoadingStatusChange = (0,react_use_callback_ref_dist/* useCallbackRef */.W)((status)=>{
        onLoadingStatusChange(status);
        context.onImageLoadingStatusChange(status);
    });
    (0,react_use_layout_effect_dist/* useLayoutEffect */.b)(()=>{
        if (imageLoadingStatus !== 'idle') handleLoadingStatusChange(imageLoadingStatus);
    }, [
        imageLoadingStatus,
        handleLoadingStatusChange
    ]);
    return imageLoadingStatus === 'loaded' ? /*#__PURE__*/ (0,react.createElement)(react_primitive_dist/* Primitive.img */.WV.img, (0,esm_extends/* default */.Z)({}, imageProps, {
        ref: forwardedRef,
        src: src
    })) : null;
});
/*#__PURE__*/ Object.assign($cddcb0b647441e34$export$2cd8ae1985206fe8, {
    displayName: $cddcb0b647441e34$var$IMAGE_NAME
});
/* -------------------------------------------------------------------------------------------------
 * AvatarFallback
 * -----------------------------------------------------------------------------------------------*/ const $cddcb0b647441e34$var$FALLBACK_NAME = 'AvatarFallback';
const $cddcb0b647441e34$export$69fffb6a9571fbfe = /*#__PURE__*/ (0,react.forwardRef)((props, forwardedRef)=>{
    const { __scopeAvatar: __scopeAvatar , delayMs: delayMs , ...fallbackProps } = props;
    const context = $cddcb0b647441e34$var$useAvatarContext($cddcb0b647441e34$var$FALLBACK_NAME, __scopeAvatar);
    const [canRender, setCanRender] = (0,react.useState)(delayMs === undefined);
    (0,react.useEffect)(()=>{
        if (delayMs !== undefined) {
            const timerId = window.setTimeout(()=>setCanRender(true)
            , delayMs);
            return ()=>window.clearTimeout(timerId)
            ;
        }
    }, [
        delayMs
    ]);
    return canRender && context.imageLoadingStatus !== 'loaded' ? /*#__PURE__*/ (0,react.createElement)(react_primitive_dist/* Primitive.span */.WV.span, (0,esm_extends/* default */.Z)({}, fallbackProps, {
        ref: forwardedRef
    })) : null;
});
/*#__PURE__*/ Object.assign($cddcb0b647441e34$export$69fffb6a9571fbfe, {
    displayName: $cddcb0b647441e34$var$FALLBACK_NAME
});
/* -----------------------------------------------------------------------------------------------*/ function $cddcb0b647441e34$var$useImageLoadingStatus(src) {
    const [loadingStatus, setLoadingStatus] = (0,react.useState)('idle');
    (0,react_use_layout_effect_dist/* useLayoutEffect */.b)(()=>{
        if (!src) {
            setLoadingStatus('error');
            return;
        }
        let isMounted = true;
        const image = new window.Image();
        const updateStatus = (status)=>()=>{
                if (!isMounted) return;
                setLoadingStatus(status);
            }
        ;
        setLoadingStatus('loading');
        image.onload = updateStatus('loaded');
        image.onerror = updateStatus('error');
        image.src = src;
        return ()=>{
            isMounted = false;
        };
    }, [
        src
    ]);
    return loadingStatus;
}
const $cddcb0b647441e34$export$be92b6f5f03c0fe9 = $cddcb0b647441e34$export$e2255cf6045e8d47;
const $cddcb0b647441e34$export$3e431a229df88919 = $cddcb0b647441e34$export$2cd8ae1985206fe8;
const $cddcb0b647441e34$export$fb8d7f40caaeea67 = $cddcb0b647441e34$export$69fffb6a9571fbfe;





//# sourceMappingURL=index.mjs.map

// EXTERNAL MODULE: ./app/lib/utils.ts + 1 modules
var utils = __webpack_require__(73848);
;// CONCATENATED MODULE: ./app/components/ui/avatar.tsx




const Avatar = /*#__PURE__*/ react.forwardRef((param, ref)=>/*#__PURE__*/ {
    let { className , ...props } = param;
    return (0,jsx_runtime.jsx)($cddcb0b647441e34$export$be92b6f5f03c0fe9, {
        ref: ref,
        className: (0,utils.cn)("relative flex h-10 w-10 shrink-0 overflow-hidden rounded-full", className),
        ...props
    });
});
Avatar.displayName = $cddcb0b647441e34$export$be92b6f5f03c0fe9.displayName;
const AvatarImage = /*#__PURE__*/ react.forwardRef((param, ref)=>/*#__PURE__*/ {
    let { className , ...props } = param;
    return (0,jsx_runtime.jsx)($cddcb0b647441e34$export$3e431a229df88919, {
        ref: ref,
        className: (0,utils.cn)("aspect-square h-full w-full", className),
        ...props
    });
});
AvatarImage.displayName = $cddcb0b647441e34$export$3e431a229df88919.displayName;
const AvatarFallback = /*#__PURE__*/ react.forwardRef((param, ref)=>/*#__PURE__*/ {
    let { className , ...props } = param;
    return (0,jsx_runtime.jsx)($cddcb0b647441e34$export$fb8d7f40caaeea67, {
        ref: ref,
        className: (0,utils.cn)("flex h-full w-full items-center justify-center rounded-full bg-muted", className),
        ...props
    });
});
AvatarFallback.displayName = $cddcb0b647441e34$export$fb8d7f40caaeea67.displayName;



/***/ }),

/***/ 34428:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "d": function() { return /* binding */ buttonVariants; },
/* harmony export */   "z": function() { return /* binding */ Button; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(41844);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(55784);
/* harmony import */ var _radix_ui_react_slot__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(88426);
/* harmony import */ var class_variance_authority__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(12003);
/* harmony import */ var _lib_utils__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(73848);





const buttonVariants = (0,class_variance_authority__WEBPACK_IMPORTED_MODULE_2__/* .cva */ .j)("inline-flex items-center justify-center whitespace-nowrap rounded-md text-sm font-medium ring-offset-background transition-colors focus-visible:outline-none focus-visible:ring-ring disabled:pointer-events-none disabled:opacity-60", {
    variants: {
        variant: {
            default: "bg-primary text-primary-foreground hover:bg-primary/90",
            destructive: "bg-destructive text-destructive-foreground hover:bg-destructive/90",
            outline: "border border-input bg-background hover:bg-accent hover:text-accent-foreground",
            secondary: "bg-bg-disable text-main-01 active:opacity-70",
            ghost_calendar: "bg-disable hover:bg-bg-disable hover:text-accent-foreground dark:hover:text-bg-01",
            ghost: "bg-bg-button  rounded-[12px] text-neutral-03 text-[16px] Nunito-700 h-[38px] leading-[16px] active:bg-white",
            link: "text-primary underline-offset-4 hover:underline",
            none: "text-primary",
            main: "rounded-[12px] bg-main-01 text-[16px] Nunito-700 leading-[16px] h-[38px] py-[8px] px-[16px] text-main-white active:bg-main-disable dark:disabled:bg-white/10 dark:disabled:text-neutral-07 dark:disabled:opacity-100",
            grey: "rounded-[12px] bg-bg-button dark:bg-bg-button/10 text-[16px] Nunito-700 leading-[16px] h-[38px] py-[8px] px-[16px] text-main-01 active:bg-white dark:active:bg-transparent",
            light: "text-primary bg-button rounded-[12px] text-main-01 text-[16px] Nunito-700 leading-[16px]",
            primary: "border bg-transparent border-main-01 text-main-01 rounded-[8px] text-[14px] Nunito-500"
        },
        size: {
            default: "h-10 px-4 py-2",
            sm: "h-9 rounded-md px-3",
            lg: "h-11 rounded-md px-8",
            icon: "h-10 w-10"
        }
    },
    defaultVariants: {
        variant: "default",
        size: "default"
    }
});
const Button = /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_1__.forwardRef((param, ref)=>{
    let { className , variant , size , asChild =false , loading , ...props } = param;
    const Comp = asChild ? _radix_ui_react_slot__WEBPACK_IMPORTED_MODULE_3__/* .Slot */ .g7 : "button";
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Comp, {
        className: (0,_lib_utils__WEBPACK_IMPORTED_MODULE_4__.cn)(buttonVariants({
            variant,
            size,
            className
        })),
        ref: ref,
        ...props
    });
});
Button.displayName = "Button";



/***/ }),

/***/ 87422:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "f": function() { return /* binding */ Calendar; }
});

// EXTERNAL MODULE: ./node_modules/next/dist/compiled/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(41844);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/react/index.js
var react = __webpack_require__(55784);
// EXTERNAL MODULE: ./node_modules/lucide-react/dist/esm/createLucideIcon.js + 1 modules
var createLucideIcon = __webpack_require__(84297);
;// CONCATENATED MODULE: ./node_modules/lucide-react/dist/esm/icons/chevron-left.js
/**
 * @license lucide-react v0.303.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */



const ChevronLeft = (0,createLucideIcon/* default */.Z)("ChevronLeft", [
  ["path", { d: "m15 18-6-6 6-6", key: "1wnfg3" }]
]);


//# sourceMappingURL=chevron-left.js.map

// EXTERNAL MODULE: ./node_modules/lucide-react/dist/esm/icons/chevron-right.js
var chevron_right = __webpack_require__(64998);
// EXTERNAL MODULE: ./node_modules/react-day-picker/dist/index.esm.js + 59 modules
var index_esm = __webpack_require__(28808);
// EXTERNAL MODULE: ./app/lib/utils.ts + 1 modules
var utils = __webpack_require__(73848);
// EXTERNAL MODULE: ./app/components/ui/button.tsx
var ui_button = __webpack_require__(34428);
;// CONCATENATED MODULE: ./app/components/ui/calendar.tsx






function Calendar(param) {
    let { className , classNames , showOutsideDays =true , ...props } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* DayPicker */._W, {
        showOutsideDays: showOutsideDays,
        className: (0,utils.cn)("p-3", className),
        classNames: {
            months: "flex flex-col sm:flex-row space-y-4 sm:space-x-4 sm:space-y-0",
            month: "".concat(props.components ? "" : "space-y-4"),
            caption: "flex justify-center pt-1 relative items-center text-main-01 text-base Nunito-700",
            caption_label: "text-sm font-medium ".concat(props.components ? "hidden" : ""),
            nav: "space-x-1 flex items-center",
            nav_button: (0,utils.cn)((0,ui_button/* buttonVariants */.d)({
                variant: "outline"
            }), "h-7 w-7 bg-transparent p-0 opacity-50 hover:opacity-100"),
            nav_button_previous: "absolute left-1",
            nav_button_next: "absolute right-1",
            table: "w-full border-collapse space-y-1",
            head_row: "flex",
            head_cell: "text-bg-01 Nunito-600 rounded-md w-9 font-normal text-[0.8rem]",
            row: "flex w-full mt-2 justify-between",
            cell: "h-9 w-9 text-center text-sm p-0 relative [&:has([aria-selected].day-range-end)]:rounded-r-md [&:has([aria-selected].day-outside)]:bg-accent/50 [&:has([aria-selected])]:bg-accent first:[&:has([aria-selected])]:rounded-l-md last:[&:has([aria-selected])]:rounded-r-md focus-within:relative focus-within:z-20",
            day: (0,utils.cn)((0,ui_button/* buttonVariants */.d)({
                variant: "ghost_calendar"
            }), "h-9 w-9 p-0 font-normal aria-selected:opacity-100"),
            day_range_end: "day-range-end",
            day_selected: "bg-main-01 text-primary-foreground hover:bg-main-01 hover:text-primary-foreground focus:bg-main-01 focus:text-primary-foreground",
            day_today: "bg-bg-disable text-accent-foreground dark:text-bg-01",
            day_outside: "day-outside text-muted-foreground opacity-50 aria-selected:bg-accent/50 aria-selected:text-muted-foreground aria-selected:opacity-30",
            day_disabled: "text-muted-foreground opacity-50",
            day_range_middle: "aria-selected:bg-accent aria-selected:text-accent-foreground",
            day_hidden: "invisible",
            ...classNames
        },
        components: {
            IconLeft: (param)=>/*#__PURE__*/ {
                let { ...props } = param;
                return (0,jsx_runtime.jsx)(ChevronLeft, {
                    className: "h-4 w-4"
                });
            },
            IconRight: (param)=>/*#__PURE__*/ {
                let { ...props } = param;
                return (0,jsx_runtime.jsx)(chevron_right/* default */.Z, {
                    className: "h-4 w-4"
                });
            }
        },
        ...props
    });
}
Calendar.displayName = "Calendar";



/***/ }),

/***/ 32757:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "lr": function() { return /* binding */ Carousel; },
  "KI": function() { return /* binding */ CarouselContent; },
  "d$": function() { return /* binding */ CarouselItem; },
  "Pz": function() { return /* binding */ CarouselNext; },
  "am": function() { return /* binding */ CarouselPrevious; }
});

// EXTERNAL MODULE: ./node_modules/next/dist/compiled/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(41844);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/react/index.js
var react = __webpack_require__(55784);
;// CONCATENATED MODULE: ./node_modules/embla-carousel-reactive-utils/esm/embla-carousel-reactive-utils.esm.js
function isObject(subject) {
  return Object.prototype.toString.call(subject) === '[object Object]';
}
function isRecord(subject) {
  return isObject(subject) || Array.isArray(subject);
}
function canUseDOM() {
  return !!(typeof window !== 'undefined' && window.document && window.document.createElement);
}
function areOptionsEqual(optionsA, optionsB) {
  const optionsAKeys = Object.keys(optionsA);
  const optionsBKeys = Object.keys(optionsB);
  if (optionsAKeys.length !== optionsBKeys.length) return false;
  const breakpointsA = JSON.stringify(Object.keys(optionsA.breakpoints || {}));
  const breakpointsB = JSON.stringify(Object.keys(optionsB.breakpoints || {}));
  if (breakpointsA !== breakpointsB) return false;
  return optionsAKeys.every(key => {
    const valueA = optionsA[key];
    const valueB = optionsB[key];
    if (typeof valueA === 'function') return `${valueA}` === `${valueB}`;
    if (!isRecord(valueA) || !isRecord(valueB)) return valueA === valueB;
    return areOptionsEqual(valueA, valueB);
  });
}
function sortAndMapPluginToOptions(plugins) {
  return plugins.concat().sort((a, b) => a.name > b.name ? 1 : -1).map(plugin => plugin.options);
}
function arePluginsEqual(pluginsA, pluginsB) {
  if (pluginsA.length !== pluginsB.length) return false;
  const optionsA = sortAndMapPluginToOptions(pluginsA);
  const optionsB = sortAndMapPluginToOptions(pluginsB);
  return optionsA.every((optionA, index) => {
    const optionB = optionsB[index];
    return areOptionsEqual(optionA, optionB);
  });
}


//# sourceMappingURL=embla-carousel-reactive-utils.esm.js.map

;// CONCATENATED MODULE: ./node_modules/embla-carousel/esm/embla-carousel.esm.js
function isNumber(subject) {
  return typeof subject === 'number';
}
function isString(subject) {
  return typeof subject === 'string';
}
function isBoolean(subject) {
  return typeof subject === 'boolean';
}
function embla_carousel_esm_isObject(subject) {
  return Object.prototype.toString.call(subject) === '[object Object]';
}
function mathAbs(n) {
  return Math.abs(n);
}
function mathSign(n) {
  return Math.sign(n);
}
function deltaAbs(valueB, valueA) {
  return mathAbs(valueB - valueA);
}
function factorAbs(valueB, valueA) {
  if (valueB === 0 || valueA === 0) return 0;
  if (mathAbs(valueB) <= mathAbs(valueA)) return 0;
  const diff = deltaAbs(mathAbs(valueB), mathAbs(valueA));
  return mathAbs(diff / valueB);
}
function arrayKeys(array) {
  return objectKeys(array).map(Number);
}
function arrayLast(array) {
  return array[arrayLastIndex(array)];
}
function arrayLastIndex(array) {
  return Math.max(0, array.length - 1);
}
function arrayIsLastIndex(array, index) {
  return index === arrayLastIndex(array);
}
function arrayFromNumber(n, startAt = 0) {
  return Array.from(Array(n), (_, i) => startAt + i);
}
function objectKeys(object) {
  return Object.keys(object);
}
function objectsMergeDeep(objectA, objectB) {
  return [objectA, objectB].reduce((mergedObjects, currentObject) => {
    objectKeys(currentObject).forEach(key => {
      const valueA = mergedObjects[key];
      const valueB = currentObject[key];
      const areObjects = embla_carousel_esm_isObject(valueA) && embla_carousel_esm_isObject(valueB);
      mergedObjects[key] = areObjects ? objectsMergeDeep(valueA, valueB) : valueB;
    });
    return mergedObjects;
  }, {});
}
function isMouseEvent(evt, ownerWindow) {
  return typeof ownerWindow.MouseEvent !== 'undefined' && evt instanceof ownerWindow.MouseEvent;
}

function Alignment(align, viewSize) {
  const predefined = {
    start,
    center,
    end
  };
  function start() {
    return 0;
  }
  function center(n) {
    return end(n) / 2;
  }
  function end(n) {
    return viewSize - n;
  }
  function measure(n, index) {
    if (isString(align)) return predefined[align](n);
    return align(viewSize, n, index);
  }
  const self = {
    measure
  };
  return self;
}

function EventStore() {
  let listeners = [];
  function add(node, type, handler, options = {
    passive: true
  }) {
    let removeListener;
    if ('addEventListener' in node) {
      node.addEventListener(type, handler, options);
      removeListener = () => node.removeEventListener(type, handler, options);
    } else {
      const legacyMediaQueryList = node;
      legacyMediaQueryList.addListener(handler);
      removeListener = () => legacyMediaQueryList.removeListener(handler);
    }
    listeners.push(removeListener);
    return self;
  }
  function clear() {
    listeners = listeners.filter(remove => remove());
  }
  const self = {
    add,
    clear
  };
  return self;
}

function Animations(ownerDocument, ownerWindow, update, render) {
  const documentVisibleHandler = EventStore();
  const timeStep = 1000 / 60;
  let lastTimeStamp = null;
  let lag = 0;
  let animationFrame = 0;
  function init() {
    documentVisibleHandler.add(ownerDocument, 'visibilitychange', () => {
      if (ownerDocument.hidden) reset();
    });
  }
  function destroy() {
    stop();
    documentVisibleHandler.clear();
  }
  function animate(timeStamp) {
    if (!lastTimeStamp) lastTimeStamp = timeStamp;
    const elapsed = timeStamp - lastTimeStamp;
    lastTimeStamp = timeStamp;
    lag += elapsed;
    while (lag >= timeStep) {
      update();
      lag -= timeStep;
    }
    const lagOffset = mathAbs(lag / timeStep);
    render(lagOffset);
    if (animationFrame) ownerWindow.requestAnimationFrame(animate);
  }
  function start() {
    if (animationFrame) return;
    animationFrame = ownerWindow.requestAnimationFrame(animate);
  }
  function stop() {
    ownerWindow.cancelAnimationFrame(animationFrame);
    lastTimeStamp = null;
    lag = 0;
    animationFrame = 0;
  }
  function reset() {
    lastTimeStamp = null;
    lag = 0;
  }
  const self = {
    init,
    destroy,
    start,
    stop,
    update,
    render
  };
  return self;
}

function Axis(axis, direction) {
  const scroll = axis === 'y' ? 'y' : 'x';
  const cross = axis === 'y' ? 'x' : 'y';
  const startEdge = getStartEdge();
  const endEdge = getEndEdge();
  function measureSize(nodeRect) {
    const {
      width,
      height
    } = nodeRect;
    return scroll === 'x' ? width : height;
  }
  function getStartEdge() {
    if (scroll === 'y') return 'top';
    return direction === 'rtl' ? 'right' : 'left';
  }
  function getEndEdge() {
    if (scroll === 'y') return 'bottom';
    return direction === 'rtl' ? 'left' : 'right';
  }
  const self = {
    scroll,
    cross,
    startEdge,
    endEdge,
    measureSize
  };
  return self;
}

function Limit(min = 0, max = 0) {
  const length = mathAbs(min - max);
  function reachedMin(n) {
    return n < min;
  }
  function reachedMax(n) {
    return n > max;
  }
  function reachedAny(n) {
    return reachedMin(n) || reachedMax(n);
  }
  function constrain(n) {
    if (!reachedAny(n)) return n;
    return reachedMin(n) ? min : max;
  }
  function removeOffset(n) {
    if (!length) return n;
    return n - length * Math.ceil((n - max) / length);
  }
  const self = {
    length,
    max,
    min,
    constrain,
    reachedAny,
    reachedMax,
    reachedMin,
    removeOffset
  };
  return self;
}

function Counter(max, start, loop) {
  const {
    constrain
  } = Limit(0, max);
  const loopEnd = max + 1;
  let counter = withinLimit(start);
  function withinLimit(n) {
    return !loop ? constrain(n) : mathAbs((loopEnd + n) % loopEnd);
  }
  function get() {
    return counter;
  }
  function set(n) {
    counter = withinLimit(n);
    return self;
  }
  function add(n) {
    return clone().set(get() + n);
  }
  function clone() {
    return Counter(max, get(), loop);
  }
  const self = {
    get,
    set,
    add,
    clone
  };
  return self;
}

function Direction(direction) {
  const sign = direction === 'rtl' ? -1 : 1;
  function apply(n) {
    return n * sign;
  }
  const self = {
    apply
  };
  return self;
}

function DragHandler(axis, direction, rootNode, ownerDocument, ownerWindow, target, dragTracker, location, animation, scrollTo, scrollBody, scrollTarget, index, eventHandler, percentOfView, dragFree, dragThreshold, skipSnaps, baseFriction, watchDrag) {
  const {
    cross: crossAxis
  } = axis;
  const focusNodes = ['INPUT', 'SELECT', 'TEXTAREA'];
  const nonPassiveEvent = {
    passive: false
  };
  const initEvents = EventStore();
  const dragEvents = EventStore();
  const goToNextThreshold = Limit(50, 225).constrain(percentOfView.measure(20));
  const snapForceBoost = {
    mouse: 300,
    touch: 400
  };
  const freeForceBoost = {
    mouse: 500,
    touch: 600
  };
  const baseSpeed = dragFree ? 43 : 25;
  let isMoving = false;
  let startScroll = 0;
  let startCross = 0;
  let pointerIsDown = false;
  let preventScroll = false;
  let preventClick = false;
  let isMouse = false;
  function init(emblaApi) {
    if (!watchDrag) return;
    function downIfAllowed(evt) {
      if (isBoolean(watchDrag) || watchDrag(emblaApi, evt)) down(evt);
    }
    const node = rootNode;
    initEvents.add(node, 'dragstart', evt => evt.preventDefault(), nonPassiveEvent).add(node, 'touchmove', () => undefined, nonPassiveEvent).add(node, 'touchend', () => undefined).add(node, 'touchstart', downIfAllowed).add(node, 'mousedown', downIfAllowed).add(node, 'touchcancel', up).add(node, 'contextmenu', up).add(node, 'click', click, true);
  }
  function destroy() {
    initEvents.clear();
    dragEvents.clear();
  }
  function addDragEvents() {
    const node = isMouse ? ownerDocument : rootNode;
    dragEvents.add(node, 'touchmove', move, nonPassiveEvent).add(node, 'touchend', up).add(node, 'mousemove', move, nonPassiveEvent).add(node, 'mouseup', up);
  }
  function isFocusNode(node) {
    const nodeName = node.nodeName || '';
    return focusNodes.includes(nodeName);
  }
  function forceBoost() {
    const boost = dragFree ? freeForceBoost : snapForceBoost;
    const type = isMouse ? 'mouse' : 'touch';
    return boost[type];
  }
  function allowedForce(force, targetChanged) {
    const next = index.add(mathSign(force) * -1);
    const baseForce = scrollTarget.byDistance(force, !dragFree).distance;
    if (dragFree || mathAbs(force) < goToNextThreshold) return baseForce;
    if (skipSnaps && targetChanged) return baseForce * 0.5;
    return scrollTarget.byIndex(next.get(), 0).distance;
  }
  function down(evt) {
    const isMouseEvt = isMouseEvent(evt, ownerWindow);
    isMouse = isMouseEvt;
    if (isMouseEvt && evt.button !== 0) return;
    if (isFocusNode(evt.target)) return;
    preventClick = dragFree && isMouseEvt && !evt.buttons && isMoving;
    isMoving = deltaAbs(target.get(), location.get()) >= 2;
    pointerIsDown = true;
    dragTracker.pointerDown(evt);
    scrollBody.useFriction(0).useDuration(0);
    target.set(location);
    addDragEvents();
    startScroll = dragTracker.readPoint(evt);
    startCross = dragTracker.readPoint(evt, crossAxis);
    eventHandler.emit('pointerDown');
  }
  function move(evt) {
    const lastScroll = dragTracker.readPoint(evt);
    const lastCross = dragTracker.readPoint(evt, crossAxis);
    const diffScroll = deltaAbs(lastScroll, startScroll);
    const diffCross = deltaAbs(lastCross, startCross);
    if (!preventScroll && !isMouse) {
      if (!evt.cancelable) return up(evt);
      preventScroll = diffScroll > diffCross;
      if (!preventScroll) return up(evt);
    }
    const diff = dragTracker.pointerMove(evt);
    if (diffScroll > dragThreshold) preventClick = true;
    scrollBody.useFriction(0.3).useDuration(1);
    animation.start();
    target.add(direction.apply(diff));
    evt.preventDefault();
  }
  function up(evt) {
    const currentLocation = scrollTarget.byDistance(0, false);
    const targetChanged = currentLocation.index !== index.get();
    const rawForce = dragTracker.pointerUp(evt) * forceBoost();
    const force = allowedForce(direction.apply(rawForce), targetChanged);
    const forceFactor = factorAbs(rawForce, force);
    const speed = baseSpeed - 10 * forceFactor;
    const friction = baseFriction + forceFactor / 50;
    preventScroll = false;
    pointerIsDown = false;
    dragEvents.clear();
    scrollBody.useDuration(speed).useFriction(friction);
    scrollTo.distance(force, !dragFree);
    isMouse = false;
    eventHandler.emit('pointerUp');
  }
  function click(evt) {
    if (preventClick) {
      evt.stopPropagation();
      evt.preventDefault();
    }
  }
  function pointerDown() {
    return pointerIsDown;
  }
  const self = {
    init,
    pointerDown,
    destroy
  };
  return self;
}

function DragTracker(axis, ownerWindow) {
  const logInterval = 170;
  let startEvent;
  let lastEvent;
  function readTime(evt) {
    return evt.timeStamp;
  }
  function readPoint(evt, evtAxis) {
    const property = evtAxis || axis.scroll;
    const coord = `client${property === 'x' ? 'X' : 'Y'}`;
    return (isMouseEvent(evt, ownerWindow) ? evt : evt.touches[0])[coord];
  }
  function pointerDown(evt) {
    startEvent = evt;
    lastEvent = evt;
    return readPoint(evt);
  }
  function pointerMove(evt) {
    const diff = readPoint(evt) - readPoint(lastEvent);
    const expired = readTime(evt) - readTime(startEvent) > logInterval;
    lastEvent = evt;
    if (expired) startEvent = evt;
    return diff;
  }
  function pointerUp(evt) {
    if (!startEvent || !lastEvent) return 0;
    const diffDrag = readPoint(lastEvent) - readPoint(startEvent);
    const diffTime = readTime(evt) - readTime(startEvent);
    const expired = readTime(evt) - readTime(lastEvent) > logInterval;
    const force = diffDrag / diffTime;
    const isFlick = diffTime && !expired && mathAbs(force) > 0.1;
    return isFlick ? force : 0;
  }
  const self = {
    pointerDown,
    pointerMove,
    pointerUp,
    readPoint
  };
  return self;
}

function NodeRects() {
  function measure(node) {
    const {
      offsetTop,
      offsetLeft,
      offsetWidth,
      offsetHeight
    } = node;
    const offset = {
      top: offsetTop,
      right: offsetLeft + offsetWidth,
      bottom: offsetTop + offsetHeight,
      left: offsetLeft,
      width: offsetWidth,
      height: offsetHeight
    };
    return offset;
  }
  const self = {
    measure
  };
  return self;
}

function PercentOfView(viewSize) {
  function measure(n) {
    return viewSize * (n / 100);
  }
  const self = {
    measure
  };
  return self;
}

function ResizeHandler(container, eventHandler, ownerWindow, slides, axis, watchResize, nodeRects) {
  let resizeObserver;
  let containerSize;
  let slideSizes = [];
  let destroyed = false;
  function readSize(node) {
    return axis.measureSize(nodeRects.measure(node));
  }
  function init(emblaApi) {
    if (!watchResize) return;
    containerSize = readSize(container);
    slideSizes = slides.map(readSize);
    function defaultCallback(entries) {
      for (const entry of entries) {
        const isContainer = entry.target === container;
        const slideIndex = slides.indexOf(entry.target);
        const lastSize = isContainer ? containerSize : slideSizes[slideIndex];
        const newSize = readSize(isContainer ? container : slides[slideIndex]);
        const diffSize = mathAbs(newSize - lastSize);
        if (diffSize >= 0.5) {
          ownerWindow.requestAnimationFrame(() => {
            emblaApi.reInit();
            eventHandler.emit('resize');
          });
          break;
        }
      }
    }
    resizeObserver = new ResizeObserver(entries => {
      if (destroyed) return;
      if (isBoolean(watchResize) || watchResize(emblaApi, entries)) {
        defaultCallback(entries);
      }
    });
    const observeNodes = [container].concat(slides);
    observeNodes.forEach(node => resizeObserver.observe(node));
  }
  function destroy() {
    if (resizeObserver) resizeObserver.disconnect();
    destroyed = true;
  }
  const self = {
    init,
    destroy
  };
  return self;
}

function ScrollBody(location, offsetLocation, target, baseDuration, baseFriction) {
  let bodyVelocity = 0;
  let scrollDirection = 0;
  let scrollDuration = baseDuration;
  let scrollFriction = baseFriction;
  let rawLocation = location.get();
  let rawLocationPrevious = 0;
  function seek() {
    const diff = target.get() - location.get();
    const isInstant = !scrollDuration;
    let directionDiff = 0;
    if (isInstant) {
      bodyVelocity = 0;
      location.set(target);
      directionDiff = diff;
    } else {
      bodyVelocity += diff / scrollDuration;
      bodyVelocity *= scrollFriction;
      rawLocation += bodyVelocity;
      location.add(bodyVelocity);
      directionDiff = rawLocation - rawLocationPrevious;
    }
    scrollDirection = mathSign(directionDiff);
    rawLocationPrevious = rawLocation;
    return self;
  }
  function settled() {
    const diff = target.get() - offsetLocation.get();
    return mathAbs(diff) < 0.001;
  }
  function duration() {
    return scrollDuration;
  }
  function direction() {
    return scrollDirection;
  }
  function velocity() {
    return bodyVelocity;
  }
  function useBaseDuration() {
    return useDuration(baseDuration);
  }
  function useBaseFriction() {
    return useFriction(baseFriction);
  }
  function useDuration(n) {
    scrollDuration = n;
    return self;
  }
  function useFriction(n) {
    scrollFriction = n;
    return self;
  }
  const self = {
    direction,
    duration,
    velocity,
    seek,
    settled,
    useBaseFriction,
    useBaseDuration,
    useFriction,
    useDuration
  };
  return self;
}

function ScrollBounds(limit, location, target, scrollBody, percentOfView) {
  const pullBackThreshold = percentOfView.measure(10);
  const edgeOffsetTolerance = percentOfView.measure(50);
  const frictionLimit = Limit(0.1, 0.99);
  let disabled = false;
  function shouldConstrain() {
    if (disabled) return false;
    if (!limit.reachedAny(target.get())) return false;
    if (!limit.reachedAny(location.get())) return false;
    return true;
  }
  function constrain(pointerDown) {
    if (!shouldConstrain()) return;
    const edge = limit.reachedMin(location.get()) ? 'min' : 'max';
    const diffToEdge = mathAbs(limit[edge] - location.get());
    const diffToTarget = target.get() - location.get();
    const friction = frictionLimit.constrain(diffToEdge / edgeOffsetTolerance);
    target.subtract(diffToTarget * friction);
    if (!pointerDown && mathAbs(diffToTarget) < pullBackThreshold) {
      target.set(limit.constrain(target.get()));
      scrollBody.useDuration(25).useBaseFriction();
    }
  }
  function toggleActive(active) {
    disabled = !active;
  }
  const self = {
    constrain,
    toggleActive
  };
  return self;
}

function ScrollContain(viewSize, contentSize, snapsAligned, containScroll, pixelTolerance) {
  const scrollBounds = Limit(-contentSize + viewSize, 0);
  const snapsBounded = measureBounded();
  const scrollContainLimit = findScrollContainLimit();
  const snapsContained = measureContained();
  function findScrollContainLimit() {
    const startSnap = snapsBounded[0];
    const endSnap = arrayLast(snapsBounded);
    const min = snapsBounded.lastIndexOf(startSnap);
    const max = snapsBounded.indexOf(endSnap) + 1;
    return Limit(min, max);
  }
  function measureBounded() {
    return snapsAligned.map((snapAligned, index) => {
      const isFirst = !index;
      const isLast = arrayIsLastIndex(snapsAligned, index);
      if (isFirst) return scrollBounds.max;
      if (isLast) return scrollBounds.min;
      return scrollBounds.constrain(snapAligned);
    }).map(scrollBound => parseFloat(scrollBound.toFixed(3)));
  }
  function measureContained() {
    if (contentSize <= viewSize + pixelTolerance) return [scrollBounds.max];
    if (containScroll === 'keepSnaps') return snapsBounded;
    const {
      min,
      max
    } = scrollContainLimit;
    return snapsBounded.slice(min, max);
  }
  const self = {
    snapsContained,
    scrollContainLimit
  };
  return self;
}

function ScrollLimit(contentSize, scrollSnaps, loop) {
  const max = scrollSnaps[0];
  const min = loop ? max - contentSize : arrayLast(scrollSnaps);
  const limit = Limit(min, max);
  const self = {
    limit
  };
  return self;
}

function ScrollLooper(contentSize, limit, offsetLocation, vectors) {
  const jointSafety = 0.1;
  const min = limit.min + jointSafety;
  const max = limit.max + jointSafety;
  const {
    reachedMin,
    reachedMax
  } = Limit(min, max);
  function shouldLoop(direction) {
    if (direction === 1) return reachedMax(offsetLocation.get());
    if (direction === -1) return reachedMin(offsetLocation.get());
    return false;
  }
  function loop(direction) {
    if (!shouldLoop(direction)) return;
    const loopDistance = contentSize * (direction * -1);
    vectors.forEach(v => v.add(loopDistance));
  }
  const self = {
    loop
  };
  return self;
}

function ScrollProgress(limit) {
  const {
    max,
    length
  } = limit;
  function get(n) {
    const currentLocation = n - max;
    return length ? currentLocation / -length : 0;
  }
  const self = {
    get
  };
  return self;
}

function ScrollSnaps(axis, alignment, containerRect, slideRects, slidesToScroll) {
  const {
    startEdge,
    endEdge
  } = axis;
  const {
    groupSlides
  } = slidesToScroll;
  const alignments = measureSizes().map(alignment.measure);
  const snaps = measureUnaligned();
  const snapsAligned = measureAligned();
  function measureSizes() {
    return groupSlides(slideRects).map(rects => arrayLast(rects)[endEdge] - rects[0][startEdge]).map(mathAbs);
  }
  function measureUnaligned() {
    return slideRects.map(rect => containerRect[startEdge] - rect[startEdge]).map(snap => -mathAbs(snap));
  }
  function measureAligned() {
    return groupSlides(snaps).map(g => g[0]).map((snap, index) => snap + alignments[index]);
  }
  const self = {
    snaps,
    snapsAligned
  };
  return self;
}

function SlideRegistry(containSnaps, containScroll, scrollSnaps, scrollContainLimit, slidesToScroll, slideIndexes) {
  const {
    groupSlides
  } = slidesToScroll;
  const {
    min,
    max
  } = scrollContainLimit;
  const slideRegistry = createSlideRegistry();
  function createSlideRegistry() {
    const groupedSlideIndexes = groupSlides(slideIndexes);
    const doNotContain = !containSnaps || containScroll === 'keepSnaps';
    if (scrollSnaps.length === 1) return [slideIndexes];
    if (doNotContain) return groupedSlideIndexes;
    return groupedSlideIndexes.slice(min, max).map((group, index, groups) => {
      const isFirst = !index;
      const isLast = arrayIsLastIndex(groups, index);
      if (isFirst) {
        const range = arrayLast(groups[0]) + 1;
        return arrayFromNumber(range);
      }
      if (isLast) {
        const range = arrayLastIndex(slideIndexes) - arrayLast(groups)[0] + 1;
        return arrayFromNumber(range, arrayLast(groups)[0]);
      }
      return group;
    });
  }
  const self = {
    slideRegistry
  };
  return self;
}

function ScrollTarget(loop, scrollSnaps, contentSize, limit, targetVector) {
  const {
    reachedAny,
    removeOffset,
    constrain
  } = limit;
  function minDistance(distances) {
    return distances.concat().sort((a, b) => mathAbs(a) - mathAbs(b))[0];
  }
  function findTargetSnap(target) {
    const distance = loop ? removeOffset(target) : constrain(target);
    const ascDiffsToSnaps = scrollSnaps.map(scrollSnap => scrollSnap - distance).map(diffToSnap => shortcut(diffToSnap, 0)).map((diff, i) => ({
      diff,
      index: i
    })).sort((d1, d2) => mathAbs(d1.diff) - mathAbs(d2.diff));
    const {
      index
    } = ascDiffsToSnaps[0];
    return {
      index,
      distance
    };
  }
  function shortcut(target, direction) {
    const targets = [target, target + contentSize, target - contentSize];
    if (!loop) return targets[0];
    if (!direction) return minDistance(targets);
    const matchingTargets = targets.filter(t => mathSign(t) === direction);
    if (matchingTargets.length) return minDistance(matchingTargets);
    return arrayLast(targets) - contentSize;
  }
  function byIndex(index, direction) {
    const diffToSnap = scrollSnaps[index] - targetVector.get();
    const distance = shortcut(diffToSnap, direction);
    return {
      index,
      distance
    };
  }
  function byDistance(distance, snap) {
    const target = targetVector.get() + distance;
    const {
      index,
      distance: targetSnapDistance
    } = findTargetSnap(target);
    const reachedBound = !loop && reachedAny(target);
    if (!snap || reachedBound) return {
      index,
      distance
    };
    const diffToSnap = scrollSnaps[index] - targetSnapDistance;
    const snapDistance = distance + shortcut(diffToSnap, 0);
    return {
      index,
      distance: snapDistance
    };
  }
  const self = {
    byDistance,
    byIndex,
    shortcut
  };
  return self;
}

function ScrollTo(animation, indexCurrent, indexPrevious, scrollBody, scrollTarget, targetVector, eventHandler) {
  function scrollTo(target) {
    const distanceDiff = target.distance;
    const indexDiff = target.index !== indexCurrent.get();
    targetVector.add(distanceDiff);
    if (distanceDiff) {
      if (scrollBody.duration()) {
        animation.start();
      } else {
        animation.update();
        animation.render(1);
        animation.update();
      }
    }
    if (indexDiff) {
      indexPrevious.set(indexCurrent.get());
      indexCurrent.set(target.index);
      eventHandler.emit('select');
    }
  }
  function distance(n, snap) {
    const target = scrollTarget.byDistance(n, snap);
    scrollTo(target);
  }
  function index(n, direction) {
    const targetIndex = indexCurrent.clone().set(n);
    const target = scrollTarget.byIndex(targetIndex.get(), direction);
    scrollTo(target);
  }
  const self = {
    distance,
    index
  };
  return self;
}

function SlideFocus(root, slides, slideRegistry, scrollTo, scrollBody, eventStore) {
  let lastTabPressTime = 0;
  function init() {
    eventStore.add(document, 'keydown', registerTabPress, false);
    slides.forEach(addSlideFocusEvent);
  }
  function registerTabPress(event) {
    if (event.code === 'Tab') lastTabPressTime = new Date().getTime();
  }
  function addSlideFocusEvent(slide) {
    const focus = () => {
      const nowTime = new Date().getTime();
      const diffTime = nowTime - lastTabPressTime;
      if (diffTime > 10) return;
      root.scrollLeft = 0;
      const index = slides.indexOf(slide);
      const group = slideRegistry.findIndex(group => group.includes(index));
      if (!isNumber(group)) return;
      scrollBody.useDuration(0);
      scrollTo.index(group, 0);
    };
    eventStore.add(slide, 'focus', focus, {
      passive: true,
      capture: true
    });
  }
  const self = {
    init
  };
  return self;
}

function Vector1D(initialValue) {
  let value = initialValue;
  function get() {
    return value;
  }
  function set(n) {
    value = normalizeInput(n);
  }
  function add(n) {
    value += normalizeInput(n);
  }
  function subtract(n) {
    value -= normalizeInput(n);
  }
  function normalizeInput(n) {
    return isNumber(n) ? n : n.get();
  }
  const self = {
    get,
    set,
    add,
    subtract
  };
  return self;
}

function Translate(axis, direction, container) {
  const translate = axis.scroll === 'x' ? x : y;
  const containerStyle = container.style;
  let disabled = false;
  function x(n) {
    return `translate3d(${n}px,0px,0px)`;
  }
  function y(n) {
    return `translate3d(0px,${n}px,0px)`;
  }
  function to(target) {
    if (disabled) return;
    containerStyle.transform = translate(direction.apply(target));
  }
  function toggleActive(active) {
    disabled = !active;
  }
  function clear() {
    if (disabled) return;
    containerStyle.transform = '';
    if (!container.getAttribute('style')) container.removeAttribute('style');
  }
  const self = {
    clear,
    to,
    toggleActive
  };
  return self;
}

function SlideLooper(axis, direction, viewSize, contentSize, slideSizes, slideSizesWithGaps, snaps, scrollSnaps, offsetLocation, slides) {
  const roundingSafety = 0.5;
  const ascItems = arrayKeys(slideSizesWithGaps);
  const descItems = arrayKeys(slideSizesWithGaps).reverse();
  const loopPoints = startPoints().concat(endPoints());
  function removeSlideSizes(indexes, from) {
    return indexes.reduce((a, i) => {
      return a - slideSizesWithGaps[i];
    }, from);
  }
  function slidesInGap(indexes, gap) {
    return indexes.reduce((a, i) => {
      const remainingGap = removeSlideSizes(a, gap);
      return remainingGap > 0 ? a.concat([i]) : a;
    }, []);
  }
  function findSlideBounds(offset) {
    return snaps.map((snap, index) => ({
      start: snap - slideSizes[index] + roundingSafety + offset,
      end: snap + viewSize - roundingSafety + offset
    }));
  }
  function findLoopPoints(indexes, offset, isEndEdge) {
    const slideBounds = findSlideBounds(offset);
    return indexes.map(index => {
      const initial = isEndEdge ? 0 : -contentSize;
      const altered = isEndEdge ? contentSize : 0;
      const boundEdge = isEndEdge ? 'end' : 'start';
      const loopPoint = slideBounds[index][boundEdge];
      return {
        index,
        loopPoint,
        slideLocation: Vector1D(-1),
        translate: Translate(axis, direction, slides[index]),
        target: () => offsetLocation.get() > loopPoint ? initial : altered
      };
    });
  }
  function startPoints() {
    const gap = scrollSnaps[0];
    const indexes = slidesInGap(descItems, gap);
    return findLoopPoints(indexes, contentSize, false);
  }
  function endPoints() {
    const gap = viewSize - scrollSnaps[0] - 1;
    const indexes = slidesInGap(ascItems, gap);
    return findLoopPoints(indexes, -contentSize, true);
  }
  function canLoop() {
    return loopPoints.every(({
      index
    }) => {
      const otherIndexes = ascItems.filter(i => i !== index);
      return removeSlideSizes(otherIndexes, viewSize) <= 0.1;
    });
  }
  function loop() {
    loopPoints.forEach(loopPoint => {
      const {
        target,
        translate,
        slideLocation
      } = loopPoint;
      const shiftLocation = target();
      if (shiftLocation === slideLocation.get()) return;
      translate.to(shiftLocation);
      slideLocation.set(shiftLocation);
    });
  }
  function clear() {
    loopPoints.forEach(loopPoint => loopPoint.translate.clear());
  }
  const self = {
    canLoop,
    clear,
    loop,
    loopPoints
  };
  return self;
}

function SlidesHandler(container, eventHandler, watchSlides) {
  let mutationObserver;
  let destroyed = false;
  function init(emblaApi) {
    if (!watchSlides) return;
    function defaultCallback(mutations) {
      for (const mutation of mutations) {
        if (mutation.type === 'childList') {
          emblaApi.reInit();
          eventHandler.emit('slidesChanged');
          break;
        }
      }
    }
    mutationObserver = new MutationObserver(mutations => {
      if (destroyed) return;
      if (isBoolean(watchSlides) || watchSlides(emblaApi, mutations)) {
        defaultCallback(mutations);
      }
    });
    mutationObserver.observe(container, {
      childList: true
    });
  }
  function destroy() {
    if (mutationObserver) mutationObserver.disconnect();
    destroyed = true;
  }
  const self = {
    init,
    destroy
  };
  return self;
}

function SlidesInView(container, slides, eventHandler, threshold) {
  const intersectionEntryMap = {};
  let inViewCache = null;
  let notInViewCache = null;
  let intersectionObserver;
  let destroyed = false;
  function init() {
    intersectionObserver = new IntersectionObserver(entries => {
      if (destroyed) return;
      entries.forEach(entry => {
        const index = slides.indexOf(entry.target);
        intersectionEntryMap[index] = entry;
      });
      inViewCache = null;
      notInViewCache = null;
      eventHandler.emit('slidesInView');
    }, {
      root: container.parentElement,
      threshold
    });
    slides.forEach(slide => intersectionObserver.observe(slide));
  }
  function destroy() {
    if (intersectionObserver) intersectionObserver.disconnect();
    destroyed = true;
  }
  function createInViewList(inView) {
    return objectKeys(intersectionEntryMap).reduce((list, slideIndex) => {
      const index = parseInt(slideIndex);
      const {
        isIntersecting
      } = intersectionEntryMap[index];
      const inViewMatch = inView && isIntersecting;
      const notInViewMatch = !inView && !isIntersecting;
      if (inViewMatch || notInViewMatch) list.push(index);
      return list;
    }, []);
  }
  function get(inView = true) {
    if (inView && inViewCache) return inViewCache;
    if (!inView && notInViewCache) return notInViewCache;
    const slideIndexes = createInViewList(inView);
    if (inView) inViewCache = slideIndexes;
    if (!inView) notInViewCache = slideIndexes;
    return slideIndexes;
  }
  const self = {
    init,
    destroy,
    get
  };
  return self;
}

function SlideSizes(axis, containerRect, slideRects, slides, readEdgeGap, ownerWindow) {
  const {
    measureSize,
    startEdge,
    endEdge
  } = axis;
  const withEdgeGap = slideRects[0] && readEdgeGap;
  const startGap = measureStartGap();
  const endGap = measureEndGap();
  const slideSizes = slideRects.map(measureSize);
  const slideSizesWithGaps = measureWithGaps();
  function measureStartGap() {
    if (!withEdgeGap) return 0;
    const slideRect = slideRects[0];
    return mathAbs(containerRect[startEdge] - slideRect[startEdge]);
  }
  function measureEndGap() {
    if (!withEdgeGap) return 0;
    const style = ownerWindow.getComputedStyle(arrayLast(slides));
    return parseFloat(style.getPropertyValue(`margin-${endEdge}`));
  }
  function measureWithGaps() {
    return slideRects.map((rect, index, rects) => {
      const isFirst = !index;
      const isLast = arrayIsLastIndex(rects, index);
      if (isFirst) return slideSizes[index] + startGap;
      if (isLast) return slideSizes[index] + endGap;
      return rects[index + 1][startEdge] - rect[startEdge];
    }).map(mathAbs);
  }
  const self = {
    slideSizes,
    slideSizesWithGaps,
    startGap,
    endGap
  };
  return self;
}

function SlidesToScroll(axis, direction, viewSize, slidesToScroll, loop, containerRect, slideRects, startGap, endGap, pixelTolerance) {
  const {
    startEdge,
    endEdge
  } = axis;
  const groupByNumber = isNumber(slidesToScroll);
  function byNumber(array, groupSize) {
    return arrayKeys(array).filter(i => i % groupSize === 0).map(i => array.slice(i, i + groupSize));
  }
  function bySize(array) {
    if (!array.length) return [];
    return arrayKeys(array).reduce((groups, rectB) => {
      const rectA = arrayLast(groups) || 0;
      const isFirst = rectA === 0;
      const isLast = rectB === arrayLastIndex(array);
      const edgeA = containerRect[startEdge] - slideRects[rectA][startEdge];
      const edgeB = containerRect[startEdge] - slideRects[rectB][endEdge];
      const gapA = !loop && isFirst ? direction.apply(startGap) : 0;
      const gapB = !loop && isLast ? direction.apply(endGap) : 0;
      const chunkSize = mathAbs(edgeB - gapB - (edgeA + gapA));
      if (chunkSize > viewSize + pixelTolerance) groups.push(rectB);
      if (isLast) groups.push(array.length);
      return groups;
    }, []).map((currentSize, index, groups) => {
      const previousSize = Math.max(groups[index - 1] || 0);
      return array.slice(previousSize, currentSize);
    });
  }
  function groupSlides(array) {
    return groupByNumber ? byNumber(array, slidesToScroll) : bySize(array);
  }
  const self = {
    groupSlides
  };
  return self;
}

function Engine(root, container, slides, ownerDocument, ownerWindow, options, eventHandler) {
  // Options
  const {
    align,
    axis: scrollAxis,
    direction: contentDirection,
    startIndex,
    loop,
    duration,
    dragFree,
    dragThreshold,
    inViewThreshold,
    slidesToScroll: groupSlides,
    skipSnaps,
    containScroll,
    watchResize,
    watchSlides,
    watchDrag
  } = options;
  // Measurements
  const pixelTolerance = 2;
  const nodeRects = NodeRects();
  const containerRect = nodeRects.measure(container);
  const slideRects = slides.map(nodeRects.measure);
  const direction = Direction(contentDirection);
  const axis = Axis(scrollAxis, contentDirection);
  const viewSize = axis.measureSize(containerRect);
  const percentOfView = PercentOfView(viewSize);
  const alignment = Alignment(align, viewSize);
  const containSnaps = !loop && !!containScroll;
  const readEdgeGap = loop || !!containScroll;
  const {
    slideSizes,
    slideSizesWithGaps,
    startGap,
    endGap
  } = SlideSizes(axis, containerRect, slideRects, slides, readEdgeGap, ownerWindow);
  const slidesToScroll = SlidesToScroll(axis, direction, viewSize, groupSlides, loop, containerRect, slideRects, startGap, endGap, pixelTolerance);
  const {
    snaps,
    snapsAligned
  } = ScrollSnaps(axis, alignment, containerRect, slideRects, slidesToScroll);
  const contentSize = -arrayLast(snaps) + arrayLast(slideSizesWithGaps);
  const {
    snapsContained,
    scrollContainLimit
  } = ScrollContain(viewSize, contentSize, snapsAligned, containScroll, pixelTolerance);
  const scrollSnaps = containSnaps ? snapsContained : snapsAligned;
  const {
    limit
  } = ScrollLimit(contentSize, scrollSnaps, loop);
  // Indexes
  const index = Counter(arrayLastIndex(scrollSnaps), startIndex, loop);
  const indexPrevious = index.clone();
  const slideIndexes = arrayKeys(slides);
  // Animation
  const update = ({
    dragHandler,
    scrollBody,
    scrollBounds,
    options: {
      loop
    }
  }) => {
    if (!loop) scrollBounds.constrain(dragHandler.pointerDown());
    scrollBody.seek();
  };
  const render = ({
    scrollBody,
    translate,
    location,
    offsetLocation,
    scrollLooper,
    slideLooper,
    dragHandler,
    animation,
    eventHandler,
    options: {
      loop
    }
  }, lagOffset) => {
    const velocity = scrollBody.velocity();
    const hasSettled = scrollBody.settled();
    if (hasSettled && !dragHandler.pointerDown()) {
      animation.stop();
      eventHandler.emit('settle');
    }
    if (!hasSettled) eventHandler.emit('scroll');
    offsetLocation.set(location.get() - velocity + velocity * lagOffset);
    if (loop) {
      scrollLooper.loop(scrollBody.direction());
      slideLooper.loop();
    }
    translate.to(offsetLocation.get());
  };
  const animation = Animations(ownerDocument, ownerWindow, () => update(engine), lagOffset => render(engine, lagOffset));
  // Shared
  const friction = 0.68;
  const startLocation = scrollSnaps[index.get()];
  const location = Vector1D(startLocation);
  const offsetLocation = Vector1D(startLocation);
  const target = Vector1D(startLocation);
  const scrollBody = ScrollBody(location, offsetLocation, target, duration, friction);
  const scrollTarget = ScrollTarget(loop, scrollSnaps, contentSize, limit, target);
  const scrollTo = ScrollTo(animation, index, indexPrevious, scrollBody, scrollTarget, target, eventHandler);
  const scrollProgress = ScrollProgress(limit);
  const eventStore = EventStore();
  const slidesInView = SlidesInView(container, slides, eventHandler, inViewThreshold);
  const {
    slideRegistry
  } = SlideRegistry(containSnaps, containScroll, scrollSnaps, scrollContainLimit, slidesToScroll, slideIndexes);
  const slideFocus = SlideFocus(root, slides, slideRegistry, scrollTo, scrollBody, eventStore);
  // Engine
  const engine = {
    ownerDocument,
    ownerWindow,
    eventHandler,
    containerRect,
    slideRects,
    animation,
    axis,
    direction,
    dragHandler: DragHandler(axis, direction, root, ownerDocument, ownerWindow, target, DragTracker(axis, ownerWindow), location, animation, scrollTo, scrollBody, scrollTarget, index, eventHandler, percentOfView, dragFree, dragThreshold, skipSnaps, friction, watchDrag),
    eventStore,
    percentOfView,
    index,
    indexPrevious,
    limit,
    location,
    offsetLocation,
    options,
    resizeHandler: ResizeHandler(container, eventHandler, ownerWindow, slides, axis, watchResize, nodeRects),
    scrollBody,
    scrollBounds: ScrollBounds(limit, location, target, scrollBody, percentOfView),
    scrollLooper: ScrollLooper(contentSize, limit, offsetLocation, [location, offsetLocation, target]),
    scrollProgress,
    scrollSnapList: scrollSnaps.map(scrollProgress.get),
    scrollSnaps,
    scrollTarget,
    scrollTo,
    slideLooper: SlideLooper(axis, direction, viewSize, contentSize, slideSizes, slideSizesWithGaps, snaps, scrollSnaps, offsetLocation, slides),
    slideFocus,
    slidesHandler: SlidesHandler(container, eventHandler, watchSlides),
    slidesInView,
    slideIndexes,
    slideRegistry,
    slidesToScroll,
    target,
    translate: Translate(axis, direction, container)
  };
  return engine;
}

function EventHandler() {
  const listeners = {};
  let api;
  function init(emblaApi) {
    api = emblaApi;
  }
  function getListeners(evt) {
    return listeners[evt] || [];
  }
  function emit(evt) {
    getListeners(evt).forEach(e => e(api, evt));
    return self;
  }
  function on(evt, cb) {
    listeners[evt] = getListeners(evt).concat([cb]);
    return self;
  }
  function off(evt, cb) {
    listeners[evt] = getListeners(evt).filter(e => e !== cb);
    return self;
  }
  const self = {
    init,
    emit,
    off,
    on
  };
  return self;
}

const defaultOptions = {
  align: 'center',
  axis: 'x',
  container: null,
  slides: null,
  containScroll: 'trimSnaps',
  direction: 'ltr',
  slidesToScroll: 1,
  inViewThreshold: 0,
  breakpoints: {},
  dragFree: false,
  dragThreshold: 10,
  loop: false,
  skipSnaps: false,
  duration: 25,
  startIndex: 0,
  active: true,
  watchDrag: true,
  watchResize: true,
  watchSlides: true
};

function OptionsHandler(ownerWindow) {
  function mergeOptions(optionsA, optionsB) {
    return objectsMergeDeep(optionsA, optionsB || {});
  }
  function optionsAtMedia(options) {
    const optionsAtMedia = options.breakpoints || {};
    const matchedMediaOptions = objectKeys(optionsAtMedia).filter(media => ownerWindow.matchMedia(media).matches).map(media => optionsAtMedia[media]).reduce((a, mediaOption) => mergeOptions(a, mediaOption), {});
    return mergeOptions(options, matchedMediaOptions);
  }
  function optionsMediaQueries(optionsList) {
    return optionsList.map(options => objectKeys(options.breakpoints || {})).reduce((acc, mediaQueries) => acc.concat(mediaQueries), []).map(ownerWindow.matchMedia);
  }
  const self = {
    mergeOptions,
    optionsAtMedia,
    optionsMediaQueries
  };
  return self;
}

function PluginsHandler(optionsHandler) {
  let activePlugins = [];
  function init(emblaApi, plugins) {
    activePlugins = plugins.filter(({
      options
    }) => optionsHandler.optionsAtMedia(options).active !== false);
    activePlugins.forEach(plugin => plugin.init(emblaApi, optionsHandler));
    return plugins.reduce((map, plugin) => Object.assign(map, {
      [plugin.name]: plugin
    }), {});
  }
  function destroy() {
    activePlugins = activePlugins.filter(plugin => plugin.destroy());
  }
  const self = {
    init,
    destroy
  };
  return self;
}

function EmblaCarousel(root, userOptions, userPlugins) {
  const ownerDocument = root.ownerDocument;
  const ownerWindow = ownerDocument.defaultView;
  const optionsHandler = OptionsHandler(ownerWindow);
  const pluginsHandler = PluginsHandler(optionsHandler);
  const mediaHandlers = EventStore();
  const eventHandler = EventHandler();
  const {
    mergeOptions,
    optionsAtMedia,
    optionsMediaQueries
  } = optionsHandler;
  const {
    on,
    off,
    emit
  } = eventHandler;
  const reInit = reActivate;
  let destroyed = false;
  let engine;
  let optionsBase = mergeOptions(defaultOptions, EmblaCarousel.globalOptions);
  let options = mergeOptions(optionsBase);
  let pluginList = [];
  let pluginApis;
  let container;
  let slides;
  function storeElements() {
    const {
      container: userContainer,
      slides: userSlides
    } = options;
    const customContainer = isString(userContainer) ? root.querySelector(userContainer) : userContainer;
    container = customContainer || root.children[0];
    const customSlides = isString(userSlides) ? container.querySelectorAll(userSlides) : userSlides;
    slides = [].slice.call(customSlides || container.children);
  }
  function createEngine(options) {
    const engine = Engine(root, container, slides, ownerDocument, ownerWindow, options, eventHandler);
    if (options.loop && !engine.slideLooper.canLoop()) {
      const optionsWithoutLoop = Object.assign({}, options, {
        loop: false
      });
      return createEngine(optionsWithoutLoop);
    }
    return engine;
  }
  function activate(withOptions, withPlugins) {
    if (destroyed) return;
    optionsBase = mergeOptions(optionsBase, withOptions);
    options = optionsAtMedia(optionsBase);
    pluginList = withPlugins || pluginList;
    storeElements();
    engine = createEngine(options);
    optionsMediaQueries([optionsBase, ...pluginList.map(({
      options
    }) => options)]).forEach(query => mediaHandlers.add(query, 'change', reActivate));
    if (!options.active) return;
    engine.translate.to(engine.location.get());
    engine.animation.init();
    engine.slidesInView.init();
    engine.slideFocus.init();
    engine.eventHandler.init(self);
    engine.resizeHandler.init(self);
    engine.slidesHandler.init(self);
    if (engine.options.loop) engine.slideLooper.loop();
    if (container.offsetParent && slides.length) engine.dragHandler.init(self);
    pluginApis = pluginsHandler.init(self, pluginList);
  }
  function reActivate(withOptions, withPlugins) {
    const startIndex = selectedScrollSnap();
    deActivate();
    activate(mergeOptions({
      startIndex
    }, withOptions), withPlugins);
    eventHandler.emit('reInit');
  }
  function deActivate() {
    engine.dragHandler.destroy();
    engine.eventStore.clear();
    engine.translate.clear();
    engine.slideLooper.clear();
    engine.resizeHandler.destroy();
    engine.slidesHandler.destroy();
    engine.slidesInView.destroy();
    engine.animation.destroy();
    pluginsHandler.destroy();
    mediaHandlers.clear();
  }
  function destroy() {
    if (destroyed) return;
    destroyed = true;
    mediaHandlers.clear();
    deActivate();
    eventHandler.emit('destroy');
  }
  function scrollTo(index, jump, direction) {
    if (!options.active || destroyed) return;
    engine.scrollBody.useBaseFriction().useDuration(jump === true ? 0 : options.duration);
    engine.scrollTo.index(index, direction || 0);
  }
  function scrollNext(jump) {
    const next = engine.index.add(1).get();
    scrollTo(next, jump, -1);
  }
  function scrollPrev(jump) {
    const prev = engine.index.add(-1).get();
    scrollTo(prev, jump, 1);
  }
  function canScrollNext() {
    const next = engine.index.add(1).get();
    return next !== selectedScrollSnap();
  }
  function canScrollPrev() {
    const prev = engine.index.add(-1).get();
    return prev !== selectedScrollSnap();
  }
  function scrollSnapList() {
    return engine.scrollSnapList;
  }
  function scrollProgress() {
    return engine.scrollProgress.get(engine.location.get());
  }
  function selectedScrollSnap() {
    return engine.index.get();
  }
  function previousScrollSnap() {
    return engine.indexPrevious.get();
  }
  function slidesInView() {
    return engine.slidesInView.get();
  }
  function slidesNotInView() {
    return engine.slidesInView.get(false);
  }
  function plugins() {
    return pluginApis;
  }
  function internalEngine() {
    return engine;
  }
  function rootNode() {
    return root;
  }
  function containerNode() {
    return container;
  }
  function slideNodes() {
    return slides;
  }
  const self = {
    canScrollNext,
    canScrollPrev,
    containerNode,
    internalEngine,
    destroy,
    off,
    on,
    emit,
    plugins,
    previousScrollSnap,
    reInit,
    rootNode,
    scrollNext,
    scrollPrev,
    scrollProgress,
    scrollSnapList,
    scrollTo,
    selectedScrollSnap,
    slideNodes,
    slidesInView,
    slidesNotInView
  };
  activate(userOptions, userPlugins);
  setTimeout(() => eventHandler.emit('init'), 0);
  return self;
}
EmblaCarousel.globalOptions = undefined;


//# sourceMappingURL=embla-carousel.esm.js.map

;// CONCATENATED MODULE: ./node_modules/embla-carousel-react/esm/embla-carousel-react.esm.js




function useEmblaCarousel(options = {}, plugins = []) {
  const storedOptions = (0,react.useRef)(options);
  const storedPlugins = (0,react.useRef)(plugins);
  const [emblaApi, setEmblaApi] = (0,react.useState)();
  const [viewport, setViewport] = (0,react.useState)();
  const reInit = (0,react.useCallback)(() => {
    if (emblaApi) emblaApi.reInit(storedOptions.current, storedPlugins.current);
  }, [emblaApi]);
  (0,react.useEffect)(() => {
    if (canUseDOM() && viewport) {
      EmblaCarousel.globalOptions = useEmblaCarousel.globalOptions;
      const newEmblaApi = EmblaCarousel(viewport, storedOptions.current, storedPlugins.current);
      setEmblaApi(newEmblaApi);
      return () => newEmblaApi.destroy();
    } else {
      setEmblaApi(undefined);
    }
  }, [viewport, setEmblaApi]);
  (0,react.useEffect)(() => {
    if (areOptionsEqual(storedOptions.current, options)) return;
    storedOptions.current = options;
    reInit();
  }, [options, reInit]);
  (0,react.useEffect)(() => {
    if (arePluginsEqual(storedPlugins.current, plugins)) return;
    storedPlugins.current = plugins;
    reInit();
  }, [plugins, reInit]);
  return [setViewport, emblaApi];
}
useEmblaCarousel.globalOptions = undefined;


//# sourceMappingURL=embla-carousel-react.esm.js.map

// EXTERNAL MODULE: ./node_modules/lucide-react/dist/esm/createLucideIcon.js + 1 modules
var createLucideIcon = __webpack_require__(84297);
;// CONCATENATED MODULE: ./node_modules/lucide-react/dist/esm/icons/arrow-left.js
/**
 * @license lucide-react v0.303.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */



const ArrowLeft = (0,createLucideIcon/* default */.Z)("ArrowLeft", [
  ["path", { d: "m12 19-7-7 7-7", key: "1l729n" }],
  ["path", { d: "M19 12H5", key: "x3x0zl" }]
]);


//# sourceMappingURL=arrow-left.js.map

;// CONCATENATED MODULE: ./node_modules/lucide-react/dist/esm/icons/arrow-right.js
/**
 * @license lucide-react v0.303.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */



const ArrowRight = (0,createLucideIcon/* default */.Z)("ArrowRight", [
  ["path", { d: "M5 12h14", key: "1ays0h" }],
  ["path", { d: "m12 5 7 7-7 7", key: "xquz4c" }]
]);


//# sourceMappingURL=arrow-right.js.map

// EXTERNAL MODULE: ./app/lib/utils.ts + 1 modules
var utils = __webpack_require__(73848);
// EXTERNAL MODULE: ./app/components/ui/button.tsx
var ui_button = __webpack_require__(34428);
;// CONCATENATED MODULE: ./app/components/ui/carousel.tsx






const CarouselContext = /*#__PURE__*/ react.createContext(null);
function useCarousel() {
    const context = react.useContext(CarouselContext);
    if (!context) {
        throw new Error("useCarousel must be used within a <Carousel />");
    }
    return context;
}
const Carousel = /*#__PURE__*/ react.forwardRef((param, ref)=>{
    let { orientation ="horizontal" , opts , setApi , plugins , className , children , ...props } = param;
    const [carouselRef, api] = useEmblaCarousel({
        ...opts,
        axis: orientation === "horizontal" ? "x" : "y"
    }, plugins);
    const [canScrollPrev, setCanScrollPrev] = react.useState(false);
    const [canScrollNext, setCanScrollNext] = react.useState(false);
    const onSelect = react.useCallback((api)=>{
        if (!api) {
            return;
        }
        setCanScrollPrev(api.canScrollPrev());
        setCanScrollNext(api.canScrollNext());
    }, []);
    const scrollPrev = react.useCallback(()=>{
        api === null || api === void 0 ? void 0 : api.scrollPrev();
    }, [
        api
    ]);
    const scrollNext = react.useCallback(()=>{
        api === null || api === void 0 ? void 0 : api.scrollNext();
    }, [
        api
    ]);
    const handleKeyDown = react.useCallback((event)=>{
        if (event.key === "ArrowLeft") {
            event.preventDefault();
            scrollPrev();
        } else if (event.key === "ArrowRight") {
            event.preventDefault();
            scrollNext();
        }
    }, [
        scrollPrev,
        scrollNext
    ]);
    react.useEffect(()=>{
        if (!api || !setApi) {
            return;
        }
        setApi(api);
    }, [
        api,
        setApi
    ]);
    react.useEffect(()=>{
        if (!api) {
            return;
        }
        onSelect(api);
        api.on("reInit", onSelect);
        api.on("select", onSelect);
        return ()=>{
            api === null || api === void 0 ? void 0 : api.off("select", onSelect);
        };
    }, [
        api,
        onSelect
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(CarouselContext.Provider, {
        value: {
            carouselRef,
            api: api,
            opts,
            orientation: orientation || ((opts === null || opts === void 0 ? void 0 : opts.axis) === "y" ? "vertical" : "horizontal"),
            scrollPrev,
            scrollNext,
            canScrollPrev,
            canScrollNext
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            ref: ref,
            onKeyDownCapture: handleKeyDown,
            className: (0,utils.cn)("relative", className),
            role: "region",
            "aria-roledescription": "carousel",
            ...props,
            children: children
        })
    });
});
Carousel.displayName = "Carousel";
const CarouselContent = /*#__PURE__*/ react.forwardRef((param, ref)=>{
    let { className , ...props } = param;
    const { carouselRef , orientation  } = useCarousel();
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        ref: carouselRef,
        className: "overflow-hidden",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            ref: ref,
            className: (0,utils.cn)("flex", orientation === "horizontal" ? "-ml-4" : "-mt-4 flex-col", className),
            ...props
        })
    });
});
CarouselContent.displayName = "CarouselContent";
const CarouselItem = /*#__PURE__*/ react.forwardRef((param, ref)=>{
    let { className , ...props } = param;
    const { orientation  } = useCarousel();
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        ref: ref,
        role: "group",
        "aria-roledescription": "slide",
        className: (0,utils.cn)("min-w-0 shrink-0 grow-0 basis-full", orientation === "horizontal" ? "pl-4" : "pt-4", className),
        ...props
    });
});
CarouselItem.displayName = "CarouselItem";
const CarouselPrevious = /*#__PURE__*/ react.forwardRef((param, ref)=>{
    let { className , variant ="outline" , size ="icon" , ...props } = param;
    const { orientation , scrollPrev , canScrollPrev  } = useCarousel();
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(ui_button/* Button */.z, {
        ref: ref,
        variant: variant,
        size: size,
        className: (0,utils.cn)("absolute  h-8 w-8 rounded-full", orientation === "horizontal" ? "-left-12 top-1/2 -translate-y-1/2" : "-top-12 left-1/2 -translate-x-1/2 rotate-90", className),
        disabled: !canScrollPrev,
        onClick: scrollPrev,
        ...props,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ArrowLeft, {
                className: "h-4 w-4"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                className: "sr-only",
                children: "Previous slide"
            })
        ]
    });
});
CarouselPrevious.displayName = "CarouselPrevious";
const CarouselNext = /*#__PURE__*/ react.forwardRef((param, ref)=>{
    let { className , variant ="outline" , size ="icon" , ...props } = param;
    const { orientation , scrollNext , canScrollNext  } = useCarousel();
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(ui_button/* Button */.z, {
        ref: ref,
        variant: variant,
        size: size,
        className: (0,utils.cn)("absolute h-8 w-8 rounded-full", orientation === "horizontal" ? "-right-12 top-1/2 -translate-y-1/2" : "-bottom-12 left-1/2 -translate-x-1/2 rotate-90", className),
        disabled: !canScrollNext,
        onClick: scrollNext,
        ...props,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ArrowRight, {
                className: "h-4 w-4"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                className: "sr-only",
                children: "Next slide"
            })
        ]
    });
});
CarouselNext.displayName = "CarouselNext";



/***/ }),

/***/ 93769:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "X": function() { return /* binding */ Checkbox; }
});

// EXTERNAL MODULE: ./node_modules/next/dist/compiled/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(41844);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/react/index.js
var react = __webpack_require__(55784);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__(87462);
// EXTERNAL MODULE: ./node_modules/@radix-ui/react-compose-refs/dist/index.mjs
var dist = __webpack_require__(28771);
// EXTERNAL MODULE: ./node_modules/@radix-ui/react-context/dist/index.mjs
var react_context_dist = __webpack_require__(25360);
// EXTERNAL MODULE: ./node_modules/@radix-ui/primitive/dist/index.mjs
var primitive_dist = __webpack_require__(36206);
// EXTERNAL MODULE: ./node_modules/@radix-ui/react-use-controllable-state/dist/index.mjs
var react_use_controllable_state_dist = __webpack_require__(77342);
// EXTERNAL MODULE: ./node_modules/@radix-ui/react-use-previous/dist/index.mjs
var react_use_previous_dist = __webpack_require__(57898);
// EXTERNAL MODULE: ./node_modules/@radix-ui/react-use-size/dist/index.mjs
var react_use_size_dist = __webpack_require__(7546);
// EXTERNAL MODULE: ./node_modules/@radix-ui/react-presence/dist/index.mjs
var react_presence_dist = __webpack_require__(29115);
// EXTERNAL MODULE: ./node_modules/@radix-ui/react-primitive/dist/index.mjs
var react_primitive_dist = __webpack_require__(75320);
;// CONCATENATED MODULE: ./node_modules/@radix-ui/react-checkbox/dist/index.mjs





















/* -------------------------------------------------------------------------------------------------
 * Checkbox
 * -----------------------------------------------------------------------------------------------*/ const $e698a72e93240346$var$CHECKBOX_NAME = 'Checkbox';
const [$e698a72e93240346$var$createCheckboxContext, $e698a72e93240346$export$b566c4ff5488ea01] = (0,react_context_dist/* createContextScope */.b)($e698a72e93240346$var$CHECKBOX_NAME);
const [$e698a72e93240346$var$CheckboxProvider, $e698a72e93240346$var$useCheckboxContext] = $e698a72e93240346$var$createCheckboxContext($e698a72e93240346$var$CHECKBOX_NAME);
const $e698a72e93240346$export$48513f6b9f8ce62d = /*#__PURE__*/ (0,react.forwardRef)((props, forwardedRef)=>{
    const { __scopeCheckbox: __scopeCheckbox , name: name , checked: checkedProp , defaultChecked: defaultChecked , required: required , disabled: disabled , value: value = 'on' , onCheckedChange: onCheckedChange , ...checkboxProps } = props;
    const [button, setButton] = (0,react.useState)(null);
    const composedRefs = (0,dist/* useComposedRefs */.e)(forwardedRef, (node)=>setButton(node)
    );
    const hasConsumerStoppedPropagationRef = (0,react.useRef)(false); // We set this to true by default so that events bubble to forms without JS (SSR)
    const isFormControl = button ? Boolean(button.closest('form')) : true;
    const [checked = false, setChecked] = (0,react_use_controllable_state_dist/* useControllableState */.T)({
        prop: checkedProp,
        defaultProp: defaultChecked,
        onChange: onCheckedChange
    });
    const initialCheckedStateRef = (0,react.useRef)(checked);
    (0,react.useEffect)(()=>{
        const form = button === null || button === void 0 ? void 0 : button.form;
        if (form) {
            const reset = ()=>setChecked(initialCheckedStateRef.current)
            ;
            form.addEventListener('reset', reset);
            return ()=>form.removeEventListener('reset', reset)
            ;
        }
    }, [
        button,
        setChecked
    ]);
    return /*#__PURE__*/ (0,react.createElement)($e698a72e93240346$var$CheckboxProvider, {
        scope: __scopeCheckbox,
        state: checked,
        disabled: disabled
    }, /*#__PURE__*/ (0,react.createElement)(react_primitive_dist/* Primitive.button */.WV.button, (0,esm_extends/* default */.Z)({
        type: "button",
        role: "checkbox",
        "aria-checked": $e698a72e93240346$var$isIndeterminate(checked) ? 'mixed' : checked,
        "aria-required": required,
        "data-state": $e698a72e93240346$var$getState(checked),
        "data-disabled": disabled ? '' : undefined,
        disabled: disabled,
        value: value
    }, checkboxProps, {
        ref: composedRefs,
        onKeyDown: (0,primitive_dist/* composeEventHandlers */.M)(props.onKeyDown, (event)=>{
            // According to WAI ARIA, Checkboxes don't activate on enter keypress
            if (event.key === 'Enter') event.preventDefault();
        }),
        onClick: (0,primitive_dist/* composeEventHandlers */.M)(props.onClick, (event)=>{
            setChecked((prevChecked)=>$e698a72e93240346$var$isIndeterminate(prevChecked) ? true : !prevChecked
            );
            if (isFormControl) {
                hasConsumerStoppedPropagationRef.current = event.isPropagationStopped(); // if checkbox is in a form, stop propagation from the button so that we only propagate
                // one click event (from the input). We propagate changes from an input so that native
                // form validation works and form events reflect checkbox updates.
                if (!hasConsumerStoppedPropagationRef.current) event.stopPropagation();
            }
        })
    })), isFormControl && /*#__PURE__*/ (0,react.createElement)($e698a72e93240346$var$BubbleInput, {
        control: button,
        bubbles: !hasConsumerStoppedPropagationRef.current,
        name: name,
        value: value,
        checked: checked,
        required: required,
        disabled: disabled // We transform because the input is absolutely positioned but we have
        ,
        style: {
            transform: 'translateX(-100%)'
        }
    }));
});
/*#__PURE__*/ Object.assign($e698a72e93240346$export$48513f6b9f8ce62d, {
    displayName: $e698a72e93240346$var$CHECKBOX_NAME
});
/* -------------------------------------------------------------------------------------------------
 * CheckboxIndicator
 * -----------------------------------------------------------------------------------------------*/ const $e698a72e93240346$var$INDICATOR_NAME = 'CheckboxIndicator';
const $e698a72e93240346$export$59aad738f51d1c05 = /*#__PURE__*/ (0,react.forwardRef)((props, forwardedRef)=>{
    const { __scopeCheckbox: __scopeCheckbox , forceMount: forceMount , ...indicatorProps } = props;
    const context = $e698a72e93240346$var$useCheckboxContext($e698a72e93240346$var$INDICATOR_NAME, __scopeCheckbox);
    return /*#__PURE__*/ (0,react.createElement)(react_presence_dist/* Presence */.z, {
        present: forceMount || $e698a72e93240346$var$isIndeterminate(context.state) || context.state === true
    }, /*#__PURE__*/ (0,react.createElement)(react_primitive_dist/* Primitive.span */.WV.span, (0,esm_extends/* default */.Z)({
        "data-state": $e698a72e93240346$var$getState(context.state),
        "data-disabled": context.disabled ? '' : undefined
    }, indicatorProps, {
        ref: forwardedRef,
        style: {
            pointerEvents: 'none',
            ...props.style
        }
    })));
});
/*#__PURE__*/ Object.assign($e698a72e93240346$export$59aad738f51d1c05, {
    displayName: $e698a72e93240346$var$INDICATOR_NAME
});
/* ---------------------------------------------------------------------------------------------- */ const $e698a72e93240346$var$BubbleInput = (props)=>{
    const { control: control , checked: checked , bubbles: bubbles = true , ...inputProps } = props;
    const ref = (0,react.useRef)(null);
    const prevChecked = (0,react_use_previous_dist/* usePrevious */.D)(checked);
    const controlSize = (0,react_use_size_dist/* useSize */.t)(control); // Bubble checked change to parents (e.g form change event)
    (0,react.useEffect)(()=>{
        const input = ref.current;
        const inputProto = window.HTMLInputElement.prototype;
        const descriptor = Object.getOwnPropertyDescriptor(inputProto, 'checked');
        const setChecked = descriptor.set;
        if (prevChecked !== checked && setChecked) {
            const event = new Event('click', {
                bubbles: bubbles
            });
            input.indeterminate = $e698a72e93240346$var$isIndeterminate(checked);
            setChecked.call(input, $e698a72e93240346$var$isIndeterminate(checked) ? false : checked);
            input.dispatchEvent(event);
        }
    }, [
        prevChecked,
        checked,
        bubbles
    ]);
    return /*#__PURE__*/ (0,react.createElement)("input", (0,esm_extends/* default */.Z)({
        type: "checkbox",
        "aria-hidden": true,
        defaultChecked: $e698a72e93240346$var$isIndeterminate(checked) ? false : checked
    }, inputProps, {
        tabIndex: -1,
        ref: ref,
        style: {
            ...props.style,
            ...controlSize,
            position: 'absolute',
            pointerEvents: 'none',
            opacity: 0,
            margin: 0
        }
    }));
};
function $e698a72e93240346$var$isIndeterminate(checked) {
    return checked === 'indeterminate';
}
function $e698a72e93240346$var$getState(checked) {
    return $e698a72e93240346$var$isIndeterminate(checked) ? 'indeterminate' : checked ? 'checked' : 'unchecked';
}
const $e698a72e93240346$export$be92b6f5f03c0fe9 = $e698a72e93240346$export$48513f6b9f8ce62d;
const $e698a72e93240346$export$adb584737d712b70 = $e698a72e93240346$export$59aad738f51d1c05;





//# sourceMappingURL=index.mjs.map

// EXTERNAL MODULE: ./node_modules/lucide-react/dist/esm/icons/check.js
var check = __webpack_require__(13742);
// EXTERNAL MODULE: ./app/lib/utils.ts + 1 modules
var utils = __webpack_require__(73848);
;// CONCATENATED MODULE: ./app/components/ui/checkbox.tsx





const Checkbox = /*#__PURE__*/ react.forwardRef((param, ref)=>/*#__PURE__*/ {
    let { className , ...props } = param;
    return (0,jsx_runtime.jsx)($e698a72e93240346$export$be92b6f5f03c0fe9, {
        ref: ref,
        className: (0,utils.cn)("peer h-[18px] w-[18px] shrink-0 rounded-sm border border-black/10 dark:border-neutral-05 ring-offset-background focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50 data-[state=checked]:bg-main-01 data-[state=checked]:text-main-white data-[state=checked]:border-0", className),
        ...props,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)($e698a72e93240346$export$adb584737d712b70, {
            className: (0,utils.cn)("flex items-center justify-center text-white dark:text-black"),
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(check/* default */.Z, {
                className: "h-3 w-3"
            })
        })
    });
});
Checkbox.displayName = $e698a72e93240346$export$be92b6f5f03c0fe9.displayName;



/***/ }),

/***/ 76500:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "GG": function() { return /* binding */ DialogClose; },
/* harmony export */   "Vq": function() { return /* binding */ Dialog; },
/* harmony export */   "cZ": function() { return /* binding */ DialogContent; },
/* harmony export */   "fK": function() { return /* binding */ DialogHeader; },
/* harmony export */   "hg": function() { return /* binding */ DialogTrigger; }
/* harmony export */ });
/* unused harmony exports DialogPortal, DialogOverlay, DialogFooter, DialogTitle, DialogDescription */
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(41844);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(55784);
/* harmony import */ var _radix_ui_react_dialog__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(12854);
/* harmony import */ var _lib_utils__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(73848);




const Dialog = _radix_ui_react_dialog__WEBPACK_IMPORTED_MODULE_2__/* .Root */ .fC;
const DialogTrigger = _radix_ui_react_dialog__WEBPACK_IMPORTED_MODULE_2__/* .Trigger */ .xz;
const DialogPortal = _radix_ui_react_dialog__WEBPACK_IMPORTED_MODULE_2__/* .Portal */ .h_;
// const DialogClose = DialogPrimitive.Close
const DialogClose = /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_1__.forwardRef((param, ref)=>/*#__PURE__*/ {
    let { children , ...props } = param;
    return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_radix_ui_react_dialog__WEBPACK_IMPORTED_MODULE_2__/* .Close */ .x8, {
        ref: ref,
        ...props,
        children: children
    });
});
DialogClose.displayName = _radix_ui_react_dialog__WEBPACK_IMPORTED_MODULE_2__/* .Close.displayName */ .x8.displayName;
const DialogOverlay = /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_1__.forwardRef((param, ref)=>/*#__PURE__*/ {
    let { className , ...props } = param;
    return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_radix_ui_react_dialog__WEBPACK_IMPORTED_MODULE_2__/* .Overlay */ .aV, {
        ref: ref,
        className: (0,_lib_utils__WEBPACK_IMPORTED_MODULE_3__.cn)("fixed inset-0 z-50 bg-black/40  data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0", className),
        ...props
    });
});
DialogOverlay.displayName = _radix_ui_react_dialog__WEBPACK_IMPORTED_MODULE_2__/* .Overlay.displayName */ .aV.displayName;
const DialogContent = /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_1__.forwardRef((param, ref)=>/*#__PURE__*/ {
    let { className , children , ...props } = param;
    return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(DialogPortal, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(DialogOverlay, {}),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_radix_ui_react_dialog__WEBPACK_IMPORTED_MODULE_2__/* .Content */ .VY, {
                ref: ref,
                className: (0,_lib_utils__WEBPACK_IMPORTED_MODULE_3__.cn)("fixed left-[50%] top-[50%] z-50 grid w-full sm:h-auto max-w-lg translate-x-[-50%] translate-y-[-50%] gap-4 border bg-white dark:bg-bg-02 p-6 shadow-lg duration-200 data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0 data-[state=closed]:zoom-out-95 data-[state=open]:zoom-in-95 data-[state=closed]:slide-out-to-left-1/2 data-[state=closed]:slide-out-to-top-[48%] data-[state=open]:slide-in-from-left-1/2 data-[state=open]:slide-in-from-top-[48%] sm:rounded-lg", className),
                ...props,
                children: children
            })
        ]
    });
});
DialogContent.displayName = _radix_ui_react_dialog__WEBPACK_IMPORTED_MODULE_2__/* .Content.displayName */ .VY.displayName;
const DialogHeader = (param)=>/*#__PURE__*/ {
    let { className , ...props } = param;
    return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: (0,_lib_utils__WEBPACK_IMPORTED_MODULE_3__.cn)("flex flex-col space-y-1.5 text-center sm:text-left", className),
        ...props
    });
};
DialogHeader.displayName = "DialogHeader";
const DialogFooter = (param)=>/*#__PURE__*/ {
    let { className , ...props } = param;
    return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: (0,_lib_utils__WEBPACK_IMPORTED_MODULE_3__.cn)("flex flex-col-reverse sm:flex-row sm:justify-end sm:space-x-2", className),
        ...props
    });
};
DialogFooter.displayName = "DialogFooter";
const DialogTitle = /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_1__.forwardRef((param, ref)=>/*#__PURE__*/ {
    let { className , ...props } = param;
    return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_radix_ui_react_dialog__WEBPACK_IMPORTED_MODULE_2__/* .Title */ .Dx, {
        ref: ref,
        className: (0,_lib_utils__WEBPACK_IMPORTED_MODULE_3__.cn)("text-lg font-semibold leading-none tracking-tight", className),
        ...props
    });
});
DialogTitle.displayName = _radix_ui_react_dialog__WEBPACK_IMPORTED_MODULE_2__/* .Title.displayName */ .Dx.displayName;
const DialogDescription = /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_1__.forwardRef((param, ref)=>/*#__PURE__*/ {
    let { className , ...props } = param;
    return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_radix_ui_react_dialog__WEBPACK_IMPORTED_MODULE_2__/* .Description */ .dk, {
        ref: ref,
        className: (0,_lib_utils__WEBPACK_IMPORTED_MODULE_3__.cn)("text-sm text-muted-foreground", className),
        ...props
    });
});
DialogDescription.displayName = _radix_ui_react_dialog__WEBPACK_IMPORTED_MODULE_2__/* .Description.displayName */ .dk.displayName;



/***/ }),

/***/ 27357:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "h_": function() { return /* binding */ DropdownMenu; },
  "bO": function() { return /* binding */ DropdownMenuCheckboxItem; },
  "AW": function() { return /* binding */ DropdownMenuContent; },
  "Xi": function() { return /* binding */ DropdownMenuItem; },
  "$F": function() { return /* binding */ DropdownMenuTrigger; }
});

// UNUSED EXPORTS: DropdownMenuGroup, DropdownMenuLabel, DropdownMenuPortal, DropdownMenuRadioGroup, DropdownMenuRadioItem, DropdownMenuSeparator, DropdownMenuShortcut, DropdownMenuSub, DropdownMenuSubContent, DropdownMenuSubTrigger

// EXTERNAL MODULE: ./node_modules/next/dist/compiled/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(41844);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/react/index.js
var react = __webpack_require__(55784);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__(87462);
// EXTERNAL MODULE: ./node_modules/@radix-ui/primitive/dist/index.mjs
var dist = __webpack_require__(36206);
// EXTERNAL MODULE: ./node_modules/@radix-ui/react-compose-refs/dist/index.mjs
var react_compose_refs_dist = __webpack_require__(28771);
// EXTERNAL MODULE: ./node_modules/@radix-ui/react-context/dist/index.mjs
var react_context_dist = __webpack_require__(25360);
// EXTERNAL MODULE: ./node_modules/@radix-ui/react-use-controllable-state/dist/index.mjs
var react_use_controllable_state_dist = __webpack_require__(77342);
// EXTERNAL MODULE: ./node_modules/@radix-ui/react-primitive/dist/index.mjs
var react_primitive_dist = __webpack_require__(75320);
// EXTERNAL MODULE: ./node_modules/@radix-ui/react-collection/dist/index.mjs
var react_collection_dist = __webpack_require__(65936);
// EXTERNAL MODULE: ./node_modules/@radix-ui/react-direction/dist/index.mjs
var react_direction_dist = __webpack_require__(78990);
// EXTERNAL MODULE: ./node_modules/@radix-ui/react-dismissable-layer/dist/index.mjs + 1 modules
var react_dismissable_layer_dist = __webpack_require__(46063);
// EXTERNAL MODULE: ./node_modules/@radix-ui/react-focus-guards/dist/index.mjs
var react_focus_guards_dist = __webpack_require__(27552);
// EXTERNAL MODULE: ./node_modules/@radix-ui/react-focus-scope/dist/index.mjs
var react_focus_scope_dist = __webpack_require__(95420);
// EXTERNAL MODULE: ./node_modules/@radix-ui/react-id/dist/index.mjs
var react_id_dist = __webpack_require__(91276);
// EXTERNAL MODULE: ./node_modules/@radix-ui/react-popper/dist/index.mjs + 6 modules
var react_popper_dist = __webpack_require__(6565);
// EXTERNAL MODULE: ./node_modules/@radix-ui/react-portal/dist/index.mjs
var react_portal_dist = __webpack_require__(42651);
// EXTERNAL MODULE: ./node_modules/@radix-ui/react-presence/dist/index.mjs
var react_presence_dist = __webpack_require__(29115);
// EXTERNAL MODULE: ./node_modules/@radix-ui/react-roving-focus/dist/index.mjs
var react_roving_focus_dist = __webpack_require__(66681);
// EXTERNAL MODULE: ./node_modules/@radix-ui/react-slot/dist/index.mjs
var react_slot_dist = __webpack_require__(88426);
// EXTERNAL MODULE: ./node_modules/@radix-ui/react-use-callback-ref/dist/index.mjs
var react_use_callback_ref_dist = __webpack_require__(79698);
// EXTERNAL MODULE: ./node_modules/aria-hidden/dist/es2015/index.js
var es2015 = __webpack_require__(23541);
// EXTERNAL MODULE: ./node_modules/react-remove-scroll/dist/es2015/Combination.js + 21 modules
var Combination = __webpack_require__(6223);
;// CONCATENATED MODULE: ./node_modules/@radix-ui/react-menu/dist/index.mjs











































const $6cc32821e9371a1c$var$SELECTION_KEYS = [
    'Enter',
    ' '
];
const $6cc32821e9371a1c$var$FIRST_KEYS = [
    'ArrowDown',
    'PageUp',
    'Home'
];
const $6cc32821e9371a1c$var$LAST_KEYS = [
    'ArrowUp',
    'PageDown',
    'End'
];
const $6cc32821e9371a1c$var$FIRST_LAST_KEYS = [
    ...$6cc32821e9371a1c$var$FIRST_KEYS,
    ...$6cc32821e9371a1c$var$LAST_KEYS
];
const $6cc32821e9371a1c$var$SUB_OPEN_KEYS = {
    ltr: [
        ...$6cc32821e9371a1c$var$SELECTION_KEYS,
        'ArrowRight'
    ],
    rtl: [
        ...$6cc32821e9371a1c$var$SELECTION_KEYS,
        'ArrowLeft'
    ]
};
const $6cc32821e9371a1c$var$SUB_CLOSE_KEYS = {
    ltr: [
        'ArrowLeft'
    ],
    rtl: [
        'ArrowRight'
    ]
};
/* -------------------------------------------------------------------------------------------------
 * Menu
 * -----------------------------------------------------------------------------------------------*/ const $6cc32821e9371a1c$var$MENU_NAME = 'Menu';
const [$6cc32821e9371a1c$var$Collection, $6cc32821e9371a1c$var$useCollection, $6cc32821e9371a1c$var$createCollectionScope] = (0,react_collection_dist/* createCollection */.B)($6cc32821e9371a1c$var$MENU_NAME);
const [$6cc32821e9371a1c$var$createMenuContext, $6cc32821e9371a1c$export$4027731b685e72eb] = (0,react_context_dist/* createContextScope */.b)($6cc32821e9371a1c$var$MENU_NAME, [
    $6cc32821e9371a1c$var$createCollectionScope,
    react_popper_dist/* createPopperScope */.D7,
    react_roving_focus_dist/* createRovingFocusGroupScope */.Pc
]);
const $6cc32821e9371a1c$var$usePopperScope = (0,react_popper_dist/* createPopperScope */.D7)();
const $6cc32821e9371a1c$var$useRovingFocusGroupScope = (0,react_roving_focus_dist/* createRovingFocusGroupScope */.Pc)();
const [$6cc32821e9371a1c$var$MenuProvider, $6cc32821e9371a1c$var$useMenuContext] = $6cc32821e9371a1c$var$createMenuContext($6cc32821e9371a1c$var$MENU_NAME);
const [$6cc32821e9371a1c$var$MenuRootProvider, $6cc32821e9371a1c$var$useMenuRootContext] = $6cc32821e9371a1c$var$createMenuContext($6cc32821e9371a1c$var$MENU_NAME);
const $6cc32821e9371a1c$export$d9b273488cd8ce6f = (props)=>{
    const { __scopeMenu: __scopeMenu , open: open = false , children: children , dir: dir , onOpenChange: onOpenChange , modal: modal = true  } = props;
    const popperScope = $6cc32821e9371a1c$var$usePopperScope(__scopeMenu);
    const [content, setContent] = (0,react.useState)(null);
    const isUsingKeyboardRef = (0,react.useRef)(false);
    const handleOpenChange = (0,react_use_callback_ref_dist/* useCallbackRef */.W)(onOpenChange);
    const direction = (0,react_direction_dist/* useDirection */.gm)(dir);
    (0,react.useEffect)(()=>{
        // Capture phase ensures we set the boolean before any side effects execute
        // in response to the key or pointer event as they might depend on this value.
        const handleKeyDown = ()=>{
            isUsingKeyboardRef.current = true;
            document.addEventListener('pointerdown', handlePointer, {
                capture: true,
                once: true
            });
            document.addEventListener('pointermove', handlePointer, {
                capture: true,
                once: true
            });
        };
        const handlePointer = ()=>isUsingKeyboardRef.current = false
        ;
        document.addEventListener('keydown', handleKeyDown, {
            capture: true
        });
        return ()=>{
            document.removeEventListener('keydown', handleKeyDown, {
                capture: true
            });
            document.removeEventListener('pointerdown', handlePointer, {
                capture: true
            });
            document.removeEventListener('pointermove', handlePointer, {
                capture: true
            });
        };
    }, []);
    return /*#__PURE__*/ (0,react.createElement)(react_popper_dist/* Root */.fC, popperScope, /*#__PURE__*/ (0,react.createElement)($6cc32821e9371a1c$var$MenuProvider, {
        scope: __scopeMenu,
        open: open,
        onOpenChange: handleOpenChange,
        content: content,
        onContentChange: setContent
    }, /*#__PURE__*/ (0,react.createElement)($6cc32821e9371a1c$var$MenuRootProvider, {
        scope: __scopeMenu,
        onClose: (0,react.useCallback)(()=>handleOpenChange(false)
        , [
            handleOpenChange
        ]),
        isUsingKeyboardRef: isUsingKeyboardRef,
        dir: direction,
        modal: modal
    }, children)));
};
/*#__PURE__*/ Object.assign($6cc32821e9371a1c$export$d9b273488cd8ce6f, {
    displayName: $6cc32821e9371a1c$var$MENU_NAME
});
/* -------------------------------------------------------------------------------------------------
 * MenuAnchor
 * -----------------------------------------------------------------------------------------------*/ const $6cc32821e9371a1c$var$ANCHOR_NAME = 'MenuAnchor';
const $6cc32821e9371a1c$export$9fa5ebd18bee4d43 = /*#__PURE__*/ (0,react.forwardRef)((props, forwardedRef)=>{
    const { __scopeMenu: __scopeMenu , ...anchorProps } = props;
    const popperScope = $6cc32821e9371a1c$var$usePopperScope(__scopeMenu);
    return /*#__PURE__*/ (0,react.createElement)(react_popper_dist/* Anchor */.ee, (0,esm_extends/* default */.Z)({}, popperScope, anchorProps, {
        ref: forwardedRef
    }));
});
/*#__PURE__*/ Object.assign($6cc32821e9371a1c$export$9fa5ebd18bee4d43, {
    displayName: $6cc32821e9371a1c$var$ANCHOR_NAME
});
/* -------------------------------------------------------------------------------------------------
 * MenuPortal
 * -----------------------------------------------------------------------------------------------*/ const $6cc32821e9371a1c$var$PORTAL_NAME = 'MenuPortal';
const [$6cc32821e9371a1c$var$PortalProvider, $6cc32821e9371a1c$var$usePortalContext] = $6cc32821e9371a1c$var$createMenuContext($6cc32821e9371a1c$var$PORTAL_NAME, {
    forceMount: undefined
});
const $6cc32821e9371a1c$export$793392f970497feb = (props)=>{
    const { __scopeMenu: __scopeMenu , forceMount: forceMount , children: children , container: container  } = props;
    const context = $6cc32821e9371a1c$var$useMenuContext($6cc32821e9371a1c$var$PORTAL_NAME, __scopeMenu);
    return /*#__PURE__*/ (0,react.createElement)($6cc32821e9371a1c$var$PortalProvider, {
        scope: __scopeMenu,
        forceMount: forceMount
    }, /*#__PURE__*/ (0,react.createElement)(react_presence_dist/* Presence */.z, {
        present: forceMount || context.open
    }, /*#__PURE__*/ (0,react.createElement)(react_portal_dist/* Portal */.h, {
        asChild: true,
        container: container
    }, children)));
};
/*#__PURE__*/ Object.assign($6cc32821e9371a1c$export$793392f970497feb, {
    displayName: $6cc32821e9371a1c$var$PORTAL_NAME
});
/* -------------------------------------------------------------------------------------------------
 * MenuContent
 * -----------------------------------------------------------------------------------------------*/ const $6cc32821e9371a1c$var$CONTENT_NAME = 'MenuContent';
const [$6cc32821e9371a1c$var$MenuContentProvider, $6cc32821e9371a1c$var$useMenuContentContext] = $6cc32821e9371a1c$var$createMenuContext($6cc32821e9371a1c$var$CONTENT_NAME);
const $6cc32821e9371a1c$export$479f0f2f71193efe = /*#__PURE__*/ (0,react.forwardRef)((props, forwardedRef)=>{
    const portalContext = $6cc32821e9371a1c$var$usePortalContext($6cc32821e9371a1c$var$CONTENT_NAME, props.__scopeMenu);
    const { forceMount: forceMount = portalContext.forceMount , ...contentProps } = props;
    const context = $6cc32821e9371a1c$var$useMenuContext($6cc32821e9371a1c$var$CONTENT_NAME, props.__scopeMenu);
    const rootContext = $6cc32821e9371a1c$var$useMenuRootContext($6cc32821e9371a1c$var$CONTENT_NAME, props.__scopeMenu);
    return /*#__PURE__*/ (0,react.createElement)($6cc32821e9371a1c$var$Collection.Provider, {
        scope: props.__scopeMenu
    }, /*#__PURE__*/ (0,react.createElement)(react_presence_dist/* Presence */.z, {
        present: forceMount || context.open
    }, /*#__PURE__*/ (0,react.createElement)($6cc32821e9371a1c$var$Collection.Slot, {
        scope: props.__scopeMenu
    }, rootContext.modal ? /*#__PURE__*/ (0,react.createElement)($6cc32821e9371a1c$var$MenuRootContentModal, (0,esm_extends/* default */.Z)({}, contentProps, {
        ref: forwardedRef
    })) : /*#__PURE__*/ (0,react.createElement)($6cc32821e9371a1c$var$MenuRootContentNonModal, (0,esm_extends/* default */.Z)({}, contentProps, {
        ref: forwardedRef
    })))));
});
/* ---------------------------------------------------------------------------------------------- */ const $6cc32821e9371a1c$var$MenuRootContentModal = /*#__PURE__*/ (0,react.forwardRef)((props, forwardedRef)=>{
    const context = $6cc32821e9371a1c$var$useMenuContext($6cc32821e9371a1c$var$CONTENT_NAME, props.__scopeMenu);
    const ref = (0,react.useRef)(null);
    const composedRefs = (0,react_compose_refs_dist/* useComposedRefs */.e)(forwardedRef, ref); // Hide everything from ARIA except the `MenuContent`
    (0,react.useEffect)(()=>{
        const content = ref.current;
        if (content) return (0,es2015/* hideOthers */.Ry)(content);
    }, []);
    return /*#__PURE__*/ (0,react.createElement)($6cc32821e9371a1c$var$MenuContentImpl, (0,esm_extends/* default */.Z)({}, props, {
        ref: composedRefs // we make sure we're not trapping once it's been closed
        ,
        trapFocus: context.open // make sure to only disable pointer events when open
        ,
        disableOutsidePointerEvents: context.open,
        disableOutsideScroll: true // When focus is trapped, a `focusout` event may still happen.
        ,
        onFocusOutside: (0,dist/* composeEventHandlers */.M)(props.onFocusOutside, (event)=>event.preventDefault()
        , {
            checkForDefaultPrevented: false
        }),
        onDismiss: ()=>context.onOpenChange(false)
    }));
});
const $6cc32821e9371a1c$var$MenuRootContentNonModal = /*#__PURE__*/ (0,react.forwardRef)((props, forwardedRef)=>{
    const context = $6cc32821e9371a1c$var$useMenuContext($6cc32821e9371a1c$var$CONTENT_NAME, props.__scopeMenu);
    return /*#__PURE__*/ (0,react.createElement)($6cc32821e9371a1c$var$MenuContentImpl, (0,esm_extends/* default */.Z)({}, props, {
        ref: forwardedRef,
        trapFocus: false,
        disableOutsidePointerEvents: false,
        disableOutsideScroll: false,
        onDismiss: ()=>context.onOpenChange(false)
    }));
});
/* ---------------------------------------------------------------------------------------------- */ const $6cc32821e9371a1c$var$MenuContentImpl = /*#__PURE__*/ (0,react.forwardRef)((props, forwardedRef)=>{
    const { __scopeMenu: __scopeMenu , loop: loop = false , trapFocus: trapFocus , onOpenAutoFocus: onOpenAutoFocus , onCloseAutoFocus: onCloseAutoFocus , disableOutsidePointerEvents: disableOutsidePointerEvents , onEntryFocus: onEntryFocus , onEscapeKeyDown: onEscapeKeyDown , onPointerDownOutside: onPointerDownOutside , onFocusOutside: onFocusOutside , onInteractOutside: onInteractOutside , onDismiss: onDismiss , disableOutsideScroll: disableOutsideScroll , ...contentProps } = props;
    const context = $6cc32821e9371a1c$var$useMenuContext($6cc32821e9371a1c$var$CONTENT_NAME, __scopeMenu);
    const rootContext = $6cc32821e9371a1c$var$useMenuRootContext($6cc32821e9371a1c$var$CONTENT_NAME, __scopeMenu);
    const popperScope = $6cc32821e9371a1c$var$usePopperScope(__scopeMenu);
    const rovingFocusGroupScope = $6cc32821e9371a1c$var$useRovingFocusGroupScope(__scopeMenu);
    const getItems = $6cc32821e9371a1c$var$useCollection(__scopeMenu);
    const [currentItemId, setCurrentItemId] = (0,react.useState)(null);
    const contentRef = (0,react.useRef)(null);
    const composedRefs = (0,react_compose_refs_dist/* useComposedRefs */.e)(forwardedRef, contentRef, context.onContentChange);
    const timerRef = (0,react.useRef)(0);
    const searchRef = (0,react.useRef)('');
    const pointerGraceTimerRef = (0,react.useRef)(0);
    const pointerGraceIntentRef = (0,react.useRef)(null);
    const pointerDirRef = (0,react.useRef)('right');
    const lastPointerXRef = (0,react.useRef)(0);
    const ScrollLockWrapper = disableOutsideScroll ? Combination/* default */.Z : react.Fragment;
    const scrollLockWrapperProps = disableOutsideScroll ? {
        as: react_slot_dist/* Slot */.g7,
        allowPinchZoom: true
    } : undefined;
    const handleTypeaheadSearch = (key)=>{
        var _items$find, _items$find2;
        const search = searchRef.current + key;
        const items = getItems().filter((item)=>!item.disabled
        );
        const currentItem = document.activeElement;
        const currentMatch = (_items$find = items.find((item)=>item.ref.current === currentItem
        )) === null || _items$find === void 0 ? void 0 : _items$find.textValue;
        const values = items.map((item)=>item.textValue
        );
        const nextMatch = $6cc32821e9371a1c$var$getNextMatch(values, search, currentMatch);
        const newItem = (_items$find2 = items.find((item)=>item.textValue === nextMatch
        )) === null || _items$find2 === void 0 ? void 0 : _items$find2.ref.current; // Reset `searchRef` 1 second after it was last updated
        (function updateSearch(value) {
            searchRef.current = value;
            window.clearTimeout(timerRef.current);
            if (value !== '') timerRef.current = window.setTimeout(()=>updateSearch('')
            , 1000);
        })(search);
        if (newItem) /**
       * Imperative focus during keydown is risky so we prevent React's batching updates
       * to avoid potential bugs. See: https://github.com/facebook/react/issues/20332
       */ setTimeout(()=>newItem.focus()
        );
    };
    (0,react.useEffect)(()=>{
        return ()=>window.clearTimeout(timerRef.current)
        ;
    }, []); // Make sure the whole tree has focus guards as our `MenuContent` may be
    // the last element in the DOM (beacuse of the `Portal`)
    (0,react_focus_guards_dist/* useFocusGuards */.EW)();
    const isPointerMovingToSubmenu = (0,react.useCallback)((event)=>{
        var _pointerGraceIntentRe, _pointerGraceIntentRe2;
        const isMovingTowards = pointerDirRef.current === ((_pointerGraceIntentRe = pointerGraceIntentRef.current) === null || _pointerGraceIntentRe === void 0 ? void 0 : _pointerGraceIntentRe.side);
        return isMovingTowards && $6cc32821e9371a1c$var$isPointerInGraceArea(event, (_pointerGraceIntentRe2 = pointerGraceIntentRef.current) === null || _pointerGraceIntentRe2 === void 0 ? void 0 : _pointerGraceIntentRe2.area);
    }, []);
    return /*#__PURE__*/ (0,react.createElement)($6cc32821e9371a1c$var$MenuContentProvider, {
        scope: __scopeMenu,
        searchRef: searchRef,
        onItemEnter: (0,react.useCallback)((event)=>{
            if (isPointerMovingToSubmenu(event)) event.preventDefault();
        }, [
            isPointerMovingToSubmenu
        ]),
        onItemLeave: (0,react.useCallback)((event)=>{
            var _contentRef$current;
            if (isPointerMovingToSubmenu(event)) return;
            (_contentRef$current = contentRef.current) === null || _contentRef$current === void 0 || _contentRef$current.focus();
            setCurrentItemId(null);
        }, [
            isPointerMovingToSubmenu
        ]),
        onTriggerLeave: (0,react.useCallback)((event)=>{
            if (isPointerMovingToSubmenu(event)) event.preventDefault();
        }, [
            isPointerMovingToSubmenu
        ]),
        pointerGraceTimerRef: pointerGraceTimerRef,
        onPointerGraceIntentChange: (0,react.useCallback)((intent)=>{
            pointerGraceIntentRef.current = intent;
        }, [])
    }, /*#__PURE__*/ (0,react.createElement)(ScrollLockWrapper, scrollLockWrapperProps, /*#__PURE__*/ (0,react.createElement)(react_focus_scope_dist/* FocusScope */.M, {
        asChild: true,
        trapped: trapFocus,
        onMountAutoFocus: (0,dist/* composeEventHandlers */.M)(onOpenAutoFocus, (event)=>{
            var _contentRef$current2;
            // when opening, explicitly focus the content area only and leave
            // `onEntryFocus` in  control of focusing first item
            event.preventDefault();
            (_contentRef$current2 = contentRef.current) === null || _contentRef$current2 === void 0 || _contentRef$current2.focus();
        }),
        onUnmountAutoFocus: onCloseAutoFocus
    }, /*#__PURE__*/ (0,react.createElement)(react_dismissable_layer_dist/* DismissableLayer */.XB, {
        asChild: true,
        disableOutsidePointerEvents: disableOutsidePointerEvents,
        onEscapeKeyDown: onEscapeKeyDown,
        onPointerDownOutside: onPointerDownOutside,
        onFocusOutside: onFocusOutside,
        onInteractOutside: onInteractOutside,
        onDismiss: onDismiss
    }, /*#__PURE__*/ (0,react.createElement)(react_roving_focus_dist/* Root */.fC, (0,esm_extends/* default */.Z)({
        asChild: true
    }, rovingFocusGroupScope, {
        dir: rootContext.dir,
        orientation: "vertical",
        loop: loop,
        currentTabStopId: currentItemId,
        onCurrentTabStopIdChange: setCurrentItemId,
        onEntryFocus: (0,dist/* composeEventHandlers */.M)(onEntryFocus, (event)=>{
            // only focus first item when using keyboard
            if (!rootContext.isUsingKeyboardRef.current) event.preventDefault();
        })
    }), /*#__PURE__*/ (0,react.createElement)(react_popper_dist/* Content */.VY, (0,esm_extends/* default */.Z)({
        role: "menu",
        "aria-orientation": "vertical",
        "data-state": $6cc32821e9371a1c$var$getOpenState(context.open),
        "data-radix-menu-content": "",
        dir: rootContext.dir
    }, popperScope, contentProps, {
        ref: composedRefs,
        style: {
            outline: 'none',
            ...contentProps.style
        },
        onKeyDown: (0,dist/* composeEventHandlers */.M)(contentProps.onKeyDown, (event)=>{
            // submenu key events bubble through portals. We only care about keys in this menu.
            const target = event.target;
            const isKeyDownInside = target.closest('[data-radix-menu-content]') === event.currentTarget;
            const isModifierKey = event.ctrlKey || event.altKey || event.metaKey;
            const isCharacterKey = event.key.length === 1;
            if (isKeyDownInside) {
                // menus should not be navigated using tab key so we prevent it
                if (event.key === 'Tab') event.preventDefault();
                if (!isModifierKey && isCharacterKey) handleTypeaheadSearch(event.key);
            } // focus first/last item based on key pressed
            const content = contentRef.current;
            if (event.target !== content) return;
            if (!$6cc32821e9371a1c$var$FIRST_LAST_KEYS.includes(event.key)) return;
            event.preventDefault();
            const items = getItems().filter((item)=>!item.disabled
            );
            const candidateNodes = items.map((item)=>item.ref.current
            );
            if ($6cc32821e9371a1c$var$LAST_KEYS.includes(event.key)) candidateNodes.reverse();
            $6cc32821e9371a1c$var$focusFirst(candidateNodes);
        }),
        onBlur: (0,dist/* composeEventHandlers */.M)(props.onBlur, (event)=>{
            // clear search buffer when leaving the menu
            if (!event.currentTarget.contains(event.target)) {
                window.clearTimeout(timerRef.current);
                searchRef.current = '';
            }
        }),
        onPointerMove: (0,dist/* composeEventHandlers */.M)(props.onPointerMove, $6cc32821e9371a1c$var$whenMouse((event)=>{
            const target = event.target;
            const pointerXHasChanged = lastPointerXRef.current !== event.clientX; // We don't use `event.movementX` for this check because Safari will
            // always return `0` on a pointer event.
            if (event.currentTarget.contains(target) && pointerXHasChanged) {
                const newDir = event.clientX > lastPointerXRef.current ? 'right' : 'left';
                pointerDirRef.current = newDir;
                lastPointerXRef.current = event.clientX;
            }
        }))
    })))))));
});
/*#__PURE__*/ Object.assign($6cc32821e9371a1c$export$479f0f2f71193efe, {
    displayName: $6cc32821e9371a1c$var$CONTENT_NAME
});
/* -------------------------------------------------------------------------------------------------
 * MenuGroup
 * -----------------------------------------------------------------------------------------------*/ const $6cc32821e9371a1c$var$GROUP_NAME = 'MenuGroup';
const $6cc32821e9371a1c$export$22a631d1f72787bb = /*#__PURE__*/ (0,react.forwardRef)((props, forwardedRef)=>{
    const { __scopeMenu: __scopeMenu , ...groupProps } = props;
    return /*#__PURE__*/ (0,react.createElement)(react_primitive_dist/* Primitive.div */.WV.div, (0,esm_extends/* default */.Z)({
        role: "group"
    }, groupProps, {
        ref: forwardedRef
    }));
});
/*#__PURE__*/ Object.assign($6cc32821e9371a1c$export$22a631d1f72787bb, {
    displayName: $6cc32821e9371a1c$var$GROUP_NAME
});
/* -------------------------------------------------------------------------------------------------
 * MenuLabel
 * -----------------------------------------------------------------------------------------------*/ const $6cc32821e9371a1c$var$LABEL_NAME = 'MenuLabel';
const $6cc32821e9371a1c$export$dd37bec0e8a99143 = /*#__PURE__*/ (0,react.forwardRef)((props, forwardedRef)=>{
    const { __scopeMenu: __scopeMenu , ...labelProps } = props;
    return /*#__PURE__*/ (0,react.createElement)(react_primitive_dist/* Primitive.div */.WV.div, (0,esm_extends/* default */.Z)({}, labelProps, {
        ref: forwardedRef
    }));
});
/*#__PURE__*/ Object.assign($6cc32821e9371a1c$export$dd37bec0e8a99143, {
    displayName: $6cc32821e9371a1c$var$LABEL_NAME
});
/* -------------------------------------------------------------------------------------------------
 * MenuItem
 * -----------------------------------------------------------------------------------------------*/ const $6cc32821e9371a1c$var$ITEM_NAME = 'MenuItem';
const $6cc32821e9371a1c$var$ITEM_SELECT = 'menu.itemSelect';
const $6cc32821e9371a1c$export$2ce376c2cc3355c8 = /*#__PURE__*/ (0,react.forwardRef)((props, forwardedRef)=>{
    const { disabled: disabled = false , onSelect: onSelect , ...itemProps } = props;
    const ref = (0,react.useRef)(null);
    const rootContext = $6cc32821e9371a1c$var$useMenuRootContext($6cc32821e9371a1c$var$ITEM_NAME, props.__scopeMenu);
    const contentContext = $6cc32821e9371a1c$var$useMenuContentContext($6cc32821e9371a1c$var$ITEM_NAME, props.__scopeMenu);
    const composedRefs = (0,react_compose_refs_dist/* useComposedRefs */.e)(forwardedRef, ref);
    const isPointerDownRef = (0,react.useRef)(false);
    const handleSelect = ()=>{
        const menuItem = ref.current;
        if (!disabled && menuItem) {
            const itemSelectEvent = new CustomEvent($6cc32821e9371a1c$var$ITEM_SELECT, {
                bubbles: true,
                cancelable: true
            });
            menuItem.addEventListener($6cc32821e9371a1c$var$ITEM_SELECT, (event)=>onSelect === null || onSelect === void 0 ? void 0 : onSelect(event)
            , {
                once: true
            });
            (0,react_primitive_dist/* dispatchDiscreteCustomEvent */.jH)(menuItem, itemSelectEvent);
            if (itemSelectEvent.defaultPrevented) isPointerDownRef.current = false;
            else rootContext.onClose();
        }
    };
    return /*#__PURE__*/ (0,react.createElement)($6cc32821e9371a1c$var$MenuItemImpl, (0,esm_extends/* default */.Z)({}, itemProps, {
        ref: composedRefs,
        disabled: disabled,
        onClick: (0,dist/* composeEventHandlers */.M)(props.onClick, handleSelect),
        onPointerDown: (event)=>{
            var _props$onPointerDown;
            (_props$onPointerDown = props.onPointerDown) === null || _props$onPointerDown === void 0 || _props$onPointerDown.call(props, event);
            isPointerDownRef.current = true;
        },
        onPointerUp: (0,dist/* composeEventHandlers */.M)(props.onPointerUp, (event)=>{
            var _event$currentTarget;
            // Pointer down can move to a different menu item which should activate it on pointer up.
            // We dispatch a click for selection to allow composition with click based triggers and to
            // prevent Firefox from getting stuck in text selection mode when the menu closes.
            if (!isPointerDownRef.current) (_event$currentTarget = event.currentTarget) === null || _event$currentTarget === void 0 || _event$currentTarget.click();
        }),
        onKeyDown: (0,dist/* composeEventHandlers */.M)(props.onKeyDown, (event)=>{
            const isTypingAhead = contentContext.searchRef.current !== '';
            if (disabled || isTypingAhead && event.key === ' ') return;
            if ($6cc32821e9371a1c$var$SELECTION_KEYS.includes(event.key)) {
                event.currentTarget.click();
                /**
         * We prevent default browser behaviour for selection keys as they should trigger
         * a selection only:
         * - prevents space from scrolling the page.
         * - if keydown causes focus to move, prevents keydown from firing on the new target.
         */ event.preventDefault();
            }
        })
    }));
});
/*#__PURE__*/ Object.assign($6cc32821e9371a1c$export$2ce376c2cc3355c8, {
    displayName: $6cc32821e9371a1c$var$ITEM_NAME
});
/* ---------------------------------------------------------------------------------------------- */ const $6cc32821e9371a1c$var$MenuItemImpl = /*#__PURE__*/ (0,react.forwardRef)((props, forwardedRef)=>{
    const { __scopeMenu: __scopeMenu , disabled: disabled = false , textValue: textValue , ...itemProps } = props;
    const contentContext = $6cc32821e9371a1c$var$useMenuContentContext($6cc32821e9371a1c$var$ITEM_NAME, __scopeMenu);
    const rovingFocusGroupScope = $6cc32821e9371a1c$var$useRovingFocusGroupScope(__scopeMenu);
    const ref = (0,react.useRef)(null);
    const composedRefs = (0,react_compose_refs_dist/* useComposedRefs */.e)(forwardedRef, ref);
    const [isFocused, setIsFocused] = (0,react.useState)(false); // get the item's `.textContent` as default strategy for typeahead `textValue`
    const [textContent, setTextContent] = (0,react.useState)('');
    (0,react.useEffect)(()=>{
        const menuItem = ref.current;
        if (menuItem) {
            var _menuItem$textContent;
            setTextContent(((_menuItem$textContent = menuItem.textContent) !== null && _menuItem$textContent !== void 0 ? _menuItem$textContent : '').trim());
        }
    }, [
        itemProps.children
    ]);
    return /*#__PURE__*/ (0,react.createElement)($6cc32821e9371a1c$var$Collection.ItemSlot, {
        scope: __scopeMenu,
        disabled: disabled,
        textValue: textValue !== null && textValue !== void 0 ? textValue : textContent
    }, /*#__PURE__*/ (0,react.createElement)(react_roving_focus_dist/* Item */.ck, (0,esm_extends/* default */.Z)({
        asChild: true
    }, rovingFocusGroupScope, {
        focusable: !disabled
    }), /*#__PURE__*/ (0,react.createElement)(react_primitive_dist/* Primitive.div */.WV.div, (0,esm_extends/* default */.Z)({
        role: "menuitem",
        "data-highlighted": isFocused ? '' : undefined,
        "aria-disabled": disabled || undefined,
        "data-disabled": disabled ? '' : undefined
    }, itemProps, {
        ref: composedRefs,
        onPointerMove: (0,dist/* composeEventHandlers */.M)(props.onPointerMove, $6cc32821e9371a1c$var$whenMouse((event)=>{
            if (disabled) contentContext.onItemLeave(event);
            else {
                contentContext.onItemEnter(event);
                if (!event.defaultPrevented) {
                    const item = event.currentTarget;
                    item.focus();
                }
            }
        })),
        onPointerLeave: (0,dist/* composeEventHandlers */.M)(props.onPointerLeave, $6cc32821e9371a1c$var$whenMouse((event)=>contentContext.onItemLeave(event)
        )),
        onFocus: (0,dist/* composeEventHandlers */.M)(props.onFocus, ()=>setIsFocused(true)
        ),
        onBlur: (0,dist/* composeEventHandlers */.M)(props.onBlur, ()=>setIsFocused(false)
        )
    }))));
});
/* -------------------------------------------------------------------------------------------------
 * MenuCheckboxItem
 * -----------------------------------------------------------------------------------------------*/ const $6cc32821e9371a1c$var$CHECKBOX_ITEM_NAME = 'MenuCheckboxItem';
const $6cc32821e9371a1c$export$f6f243521332502d = /*#__PURE__*/ (0,react.forwardRef)((props, forwardedRef)=>{
    const { checked: checked = false , onCheckedChange: onCheckedChange , ...checkboxItemProps } = props;
    return /*#__PURE__*/ (0,react.createElement)($6cc32821e9371a1c$var$ItemIndicatorProvider, {
        scope: props.__scopeMenu,
        checked: checked
    }, /*#__PURE__*/ (0,react.createElement)($6cc32821e9371a1c$export$2ce376c2cc3355c8, (0,esm_extends/* default */.Z)({
        role: "menuitemcheckbox",
        "aria-checked": $6cc32821e9371a1c$var$isIndeterminate(checked) ? 'mixed' : checked
    }, checkboxItemProps, {
        ref: forwardedRef,
        "data-state": $6cc32821e9371a1c$var$getCheckedState(checked),
        onSelect: (0,dist/* composeEventHandlers */.M)(checkboxItemProps.onSelect, ()=>onCheckedChange === null || onCheckedChange === void 0 ? void 0 : onCheckedChange($6cc32821e9371a1c$var$isIndeterminate(checked) ? true : !checked)
        , {
            checkForDefaultPrevented: false
        })
    })));
});
/*#__PURE__*/ Object.assign($6cc32821e9371a1c$export$f6f243521332502d, {
    displayName: $6cc32821e9371a1c$var$CHECKBOX_ITEM_NAME
});
/* -------------------------------------------------------------------------------------------------
 * MenuRadioGroup
 * -----------------------------------------------------------------------------------------------*/ const $6cc32821e9371a1c$var$RADIO_GROUP_NAME = 'MenuRadioGroup';
const [$6cc32821e9371a1c$var$RadioGroupProvider, $6cc32821e9371a1c$var$useRadioGroupContext] = $6cc32821e9371a1c$var$createMenuContext($6cc32821e9371a1c$var$RADIO_GROUP_NAME, {
    value: undefined,
    onValueChange: ()=>{}
});
const $6cc32821e9371a1c$export$ea2200c9eee416b3 = /*#__PURE__*/ (0,react.forwardRef)((props, forwardedRef)=>{
    const { value: value , onValueChange: onValueChange , ...groupProps } = props;
    const handleValueChange = (0,react_use_callback_ref_dist/* useCallbackRef */.W)(onValueChange);
    return /*#__PURE__*/ (0,react.createElement)($6cc32821e9371a1c$var$RadioGroupProvider, {
        scope: props.__scopeMenu,
        value: value,
        onValueChange: handleValueChange
    }, /*#__PURE__*/ (0,react.createElement)($6cc32821e9371a1c$export$22a631d1f72787bb, (0,esm_extends/* default */.Z)({}, groupProps, {
        ref: forwardedRef
    })));
});
/*#__PURE__*/ Object.assign($6cc32821e9371a1c$export$ea2200c9eee416b3, {
    displayName: $6cc32821e9371a1c$var$RADIO_GROUP_NAME
});
/* -------------------------------------------------------------------------------------------------
 * MenuRadioItem
 * -----------------------------------------------------------------------------------------------*/ const $6cc32821e9371a1c$var$RADIO_ITEM_NAME = 'MenuRadioItem';
const $6cc32821e9371a1c$export$69bd225e9817f6d0 = /*#__PURE__*/ (0,react.forwardRef)((props, forwardedRef)=>{
    const { value: value , ...radioItemProps } = props;
    const context = $6cc32821e9371a1c$var$useRadioGroupContext($6cc32821e9371a1c$var$RADIO_ITEM_NAME, props.__scopeMenu);
    const checked = value === context.value;
    return /*#__PURE__*/ (0,react.createElement)($6cc32821e9371a1c$var$ItemIndicatorProvider, {
        scope: props.__scopeMenu,
        checked: checked
    }, /*#__PURE__*/ (0,react.createElement)($6cc32821e9371a1c$export$2ce376c2cc3355c8, (0,esm_extends/* default */.Z)({
        role: "menuitemradio",
        "aria-checked": checked
    }, radioItemProps, {
        ref: forwardedRef,
        "data-state": $6cc32821e9371a1c$var$getCheckedState(checked),
        onSelect: (0,dist/* composeEventHandlers */.M)(radioItemProps.onSelect, ()=>{
            var _context$onValueChang;
            return (_context$onValueChang = context.onValueChange) === null || _context$onValueChang === void 0 ? void 0 : _context$onValueChang.call(context, value);
        }, {
            checkForDefaultPrevented: false
        })
    })));
});
/*#__PURE__*/ Object.assign($6cc32821e9371a1c$export$69bd225e9817f6d0, {
    displayName: $6cc32821e9371a1c$var$RADIO_ITEM_NAME
});
/* -------------------------------------------------------------------------------------------------
 * MenuItemIndicator
 * -----------------------------------------------------------------------------------------------*/ const $6cc32821e9371a1c$var$ITEM_INDICATOR_NAME = 'MenuItemIndicator';
const [$6cc32821e9371a1c$var$ItemIndicatorProvider, $6cc32821e9371a1c$var$useItemIndicatorContext] = $6cc32821e9371a1c$var$createMenuContext($6cc32821e9371a1c$var$ITEM_INDICATOR_NAME, {
    checked: false
});
const $6cc32821e9371a1c$export$a2593e23056970a3 = /*#__PURE__*/ (0,react.forwardRef)((props, forwardedRef)=>{
    const { __scopeMenu: __scopeMenu , forceMount: forceMount , ...itemIndicatorProps } = props;
    const indicatorContext = $6cc32821e9371a1c$var$useItemIndicatorContext($6cc32821e9371a1c$var$ITEM_INDICATOR_NAME, __scopeMenu);
    return /*#__PURE__*/ (0,react.createElement)(react_presence_dist/* Presence */.z, {
        present: forceMount || $6cc32821e9371a1c$var$isIndeterminate(indicatorContext.checked) || indicatorContext.checked === true
    }, /*#__PURE__*/ (0,react.createElement)(react_primitive_dist/* Primitive.span */.WV.span, (0,esm_extends/* default */.Z)({}, itemIndicatorProps, {
        ref: forwardedRef,
        "data-state": $6cc32821e9371a1c$var$getCheckedState(indicatorContext.checked)
    })));
});
/*#__PURE__*/ Object.assign($6cc32821e9371a1c$export$a2593e23056970a3, {
    displayName: $6cc32821e9371a1c$var$ITEM_INDICATOR_NAME
});
/* -------------------------------------------------------------------------------------------------
 * MenuSeparator
 * -----------------------------------------------------------------------------------------------*/ const $6cc32821e9371a1c$var$SEPARATOR_NAME = 'MenuSeparator';
const $6cc32821e9371a1c$export$1cec7dcdd713e220 = /*#__PURE__*/ (0,react.forwardRef)((props, forwardedRef)=>{
    const { __scopeMenu: __scopeMenu , ...separatorProps } = props;
    return /*#__PURE__*/ (0,react.createElement)(react_primitive_dist/* Primitive.div */.WV.div, (0,esm_extends/* default */.Z)({
        role: "separator",
        "aria-orientation": "horizontal"
    }, separatorProps, {
        ref: forwardedRef
    }));
});
/*#__PURE__*/ Object.assign($6cc32821e9371a1c$export$1cec7dcdd713e220, {
    displayName: $6cc32821e9371a1c$var$SEPARATOR_NAME
});
/* -------------------------------------------------------------------------------------------------
 * MenuArrow
 * -----------------------------------------------------------------------------------------------*/ const $6cc32821e9371a1c$var$ARROW_NAME = 'MenuArrow';
const $6cc32821e9371a1c$export$bcdda4773debf5fa = /*#__PURE__*/ (0,react.forwardRef)((props, forwardedRef)=>{
    const { __scopeMenu: __scopeMenu , ...arrowProps } = props;
    const popperScope = $6cc32821e9371a1c$var$usePopperScope(__scopeMenu);
    return /*#__PURE__*/ (0,react.createElement)(react_popper_dist/* Arrow */.Eh, (0,esm_extends/* default */.Z)({}, popperScope, arrowProps, {
        ref: forwardedRef
    }));
});
/*#__PURE__*/ Object.assign($6cc32821e9371a1c$export$bcdda4773debf5fa, {
    displayName: $6cc32821e9371a1c$var$ARROW_NAME
});
/* -------------------------------------------------------------------------------------------------
 * MenuSub
 * -----------------------------------------------------------------------------------------------*/ const $6cc32821e9371a1c$var$SUB_NAME = 'MenuSub';
const [$6cc32821e9371a1c$var$MenuSubProvider, $6cc32821e9371a1c$var$useMenuSubContext] = $6cc32821e9371a1c$var$createMenuContext($6cc32821e9371a1c$var$SUB_NAME);
const $6cc32821e9371a1c$export$71bdb9d1e2909932 = (props)=>{
    const { __scopeMenu: __scopeMenu , children: children , open: open = false , onOpenChange: onOpenChange  } = props;
    const parentMenuContext = $6cc32821e9371a1c$var$useMenuContext($6cc32821e9371a1c$var$SUB_NAME, __scopeMenu);
    const popperScope = $6cc32821e9371a1c$var$usePopperScope(__scopeMenu);
    const [trigger, setTrigger] = (0,react.useState)(null);
    const [content, setContent] = (0,react.useState)(null);
    const handleOpenChange = (0,react_use_callback_ref_dist/* useCallbackRef */.W)(onOpenChange); // Prevent the parent menu from reopening with open submenus.
    (0,react.useEffect)(()=>{
        if (parentMenuContext.open === false) handleOpenChange(false);
        return ()=>handleOpenChange(false)
        ;
    }, [
        parentMenuContext.open,
        handleOpenChange
    ]);
    return /*#__PURE__*/ (0,react.createElement)(react_popper_dist/* Root */.fC, popperScope, /*#__PURE__*/ (0,react.createElement)($6cc32821e9371a1c$var$MenuProvider, {
        scope: __scopeMenu,
        open: open,
        onOpenChange: handleOpenChange,
        content: content,
        onContentChange: setContent
    }, /*#__PURE__*/ (0,react.createElement)($6cc32821e9371a1c$var$MenuSubProvider, {
        scope: __scopeMenu,
        contentId: (0,react_id_dist/* useId */.M)(),
        triggerId: (0,react_id_dist/* useId */.M)(),
        trigger: trigger,
        onTriggerChange: setTrigger
    }, children)));
};
/*#__PURE__*/ Object.assign($6cc32821e9371a1c$export$71bdb9d1e2909932, {
    displayName: $6cc32821e9371a1c$var$SUB_NAME
});
/* -------------------------------------------------------------------------------------------------
 * MenuSubTrigger
 * -----------------------------------------------------------------------------------------------*/ const $6cc32821e9371a1c$var$SUB_TRIGGER_NAME = 'MenuSubTrigger';
const $6cc32821e9371a1c$export$5fbbb3ba7297405f = /*#__PURE__*/ (0,react.forwardRef)((props, forwardedRef)=>{
    const context = $6cc32821e9371a1c$var$useMenuContext($6cc32821e9371a1c$var$SUB_TRIGGER_NAME, props.__scopeMenu);
    const rootContext = $6cc32821e9371a1c$var$useMenuRootContext($6cc32821e9371a1c$var$SUB_TRIGGER_NAME, props.__scopeMenu);
    const subContext = $6cc32821e9371a1c$var$useMenuSubContext($6cc32821e9371a1c$var$SUB_TRIGGER_NAME, props.__scopeMenu);
    const contentContext = $6cc32821e9371a1c$var$useMenuContentContext($6cc32821e9371a1c$var$SUB_TRIGGER_NAME, props.__scopeMenu);
    const openTimerRef = (0,react.useRef)(null);
    const { pointerGraceTimerRef: pointerGraceTimerRef , onPointerGraceIntentChange: onPointerGraceIntentChange  } = contentContext;
    const scope = {
        __scopeMenu: props.__scopeMenu
    };
    const clearOpenTimer = (0,react.useCallback)(()=>{
        if (openTimerRef.current) window.clearTimeout(openTimerRef.current);
        openTimerRef.current = null;
    }, []);
    (0,react.useEffect)(()=>clearOpenTimer
    , [
        clearOpenTimer
    ]);
    (0,react.useEffect)(()=>{
        const pointerGraceTimer = pointerGraceTimerRef.current;
        return ()=>{
            window.clearTimeout(pointerGraceTimer);
            onPointerGraceIntentChange(null);
        };
    }, [
        pointerGraceTimerRef,
        onPointerGraceIntentChange
    ]);
    return /*#__PURE__*/ (0,react.createElement)($6cc32821e9371a1c$export$9fa5ebd18bee4d43, (0,esm_extends/* default */.Z)({
        asChild: true
    }, scope), /*#__PURE__*/ (0,react.createElement)($6cc32821e9371a1c$var$MenuItemImpl, (0,esm_extends/* default */.Z)({
        id: subContext.triggerId,
        "aria-haspopup": "menu",
        "aria-expanded": context.open,
        "aria-controls": subContext.contentId,
        "data-state": $6cc32821e9371a1c$var$getOpenState(context.open)
    }, props, {
        ref: (0,react_compose_refs_dist/* composeRefs */.F)(forwardedRef, subContext.onTriggerChange) // This is redundant for mouse users but we cannot determine pointer type from
        ,
        onClick: (event)=>{
            var _props$onClick;
            (_props$onClick = props.onClick) === null || _props$onClick === void 0 || _props$onClick.call(props, event);
            if (props.disabled || event.defaultPrevented) return;
            /**
       * We manually focus because iOS Safari doesn't always focus on click (e.g. buttons)
       * and we rely heavily on `onFocusOutside` for submenus to close when switching
       * between separate submenus.
       */ event.currentTarget.focus();
            if (!context.open) context.onOpenChange(true);
        },
        onPointerMove: (0,dist/* composeEventHandlers */.M)(props.onPointerMove, $6cc32821e9371a1c$var$whenMouse((event)=>{
            contentContext.onItemEnter(event);
            if (event.defaultPrevented) return;
            if (!props.disabled && !context.open && !openTimerRef.current) {
                contentContext.onPointerGraceIntentChange(null);
                openTimerRef.current = window.setTimeout(()=>{
                    context.onOpenChange(true);
                    clearOpenTimer();
                }, 100);
            }
        })),
        onPointerLeave: (0,dist/* composeEventHandlers */.M)(props.onPointerLeave, $6cc32821e9371a1c$var$whenMouse((event)=>{
            var _context$content;
            clearOpenTimer();
            const contentRect = (_context$content = context.content) === null || _context$content === void 0 ? void 0 : _context$content.getBoundingClientRect();
            if (contentRect) {
                var _context$content2;
                // TODO: make sure to update this when we change positioning logic
                const side = (_context$content2 = context.content) === null || _context$content2 === void 0 ? void 0 : _context$content2.dataset.side;
                const rightSide = side === 'right';
                const bleed = rightSide ? -5 : 5;
                const contentNearEdge = contentRect[rightSide ? 'left' : 'right'];
                const contentFarEdge = contentRect[rightSide ? 'right' : 'left'];
                contentContext.onPointerGraceIntentChange({
                    area: [
                        // consistently within polygon bounds
                        {
                            x: event.clientX + bleed,
                            y: event.clientY
                        },
                        {
                            x: contentNearEdge,
                            y: contentRect.top
                        },
                        {
                            x: contentFarEdge,
                            y: contentRect.top
                        },
                        {
                            x: contentFarEdge,
                            y: contentRect.bottom
                        },
                        {
                            x: contentNearEdge,
                            y: contentRect.bottom
                        }
                    ],
                    side: side
                });
                window.clearTimeout(pointerGraceTimerRef.current);
                pointerGraceTimerRef.current = window.setTimeout(()=>contentContext.onPointerGraceIntentChange(null)
                , 300);
            } else {
                contentContext.onTriggerLeave(event);
                if (event.defaultPrevented) return; // There's 100ms where the user may leave an item before the submenu was opened.
                contentContext.onPointerGraceIntentChange(null);
            }
        })),
        onKeyDown: (0,dist/* composeEventHandlers */.M)(props.onKeyDown, (event)=>{
            const isTypingAhead = contentContext.searchRef.current !== '';
            if (props.disabled || isTypingAhead && event.key === ' ') return;
            if ($6cc32821e9371a1c$var$SUB_OPEN_KEYS[rootContext.dir].includes(event.key)) {
                var _context$content3;
                context.onOpenChange(true); // The trigger may hold focus if opened via pointer interaction
                // so we ensure content is given focus again when switching to keyboard.
                (_context$content3 = context.content) === null || _context$content3 === void 0 || _context$content3.focus(); // prevent window from scrolling
                event.preventDefault();
            }
        })
    })));
});
/*#__PURE__*/ Object.assign($6cc32821e9371a1c$export$5fbbb3ba7297405f, {
    displayName: $6cc32821e9371a1c$var$SUB_TRIGGER_NAME
});
/* -------------------------------------------------------------------------------------------------
 * MenuSubContent
 * -----------------------------------------------------------------------------------------------*/ const $6cc32821e9371a1c$var$SUB_CONTENT_NAME = 'MenuSubContent';
const $6cc32821e9371a1c$export$e7142ab31822bde6 = /*#__PURE__*/ (0,react.forwardRef)((props, forwardedRef)=>{
    const portalContext = $6cc32821e9371a1c$var$usePortalContext($6cc32821e9371a1c$var$CONTENT_NAME, props.__scopeMenu);
    const { forceMount: forceMount = portalContext.forceMount , ...subContentProps } = props;
    const context = $6cc32821e9371a1c$var$useMenuContext($6cc32821e9371a1c$var$CONTENT_NAME, props.__scopeMenu);
    const rootContext = $6cc32821e9371a1c$var$useMenuRootContext($6cc32821e9371a1c$var$CONTENT_NAME, props.__scopeMenu);
    const subContext = $6cc32821e9371a1c$var$useMenuSubContext($6cc32821e9371a1c$var$SUB_CONTENT_NAME, props.__scopeMenu);
    const ref = (0,react.useRef)(null);
    const composedRefs = (0,react_compose_refs_dist/* useComposedRefs */.e)(forwardedRef, ref);
    return /*#__PURE__*/ (0,react.createElement)($6cc32821e9371a1c$var$Collection.Provider, {
        scope: props.__scopeMenu
    }, /*#__PURE__*/ (0,react.createElement)(react_presence_dist/* Presence */.z, {
        present: forceMount || context.open
    }, /*#__PURE__*/ (0,react.createElement)($6cc32821e9371a1c$var$Collection.Slot, {
        scope: props.__scopeMenu
    }, /*#__PURE__*/ (0,react.createElement)($6cc32821e9371a1c$var$MenuContentImpl, (0,esm_extends/* default */.Z)({
        id: subContext.contentId,
        "aria-labelledby": subContext.triggerId
    }, subContentProps, {
        ref: composedRefs,
        align: "start",
        side: rootContext.dir === 'rtl' ? 'left' : 'right',
        disableOutsidePointerEvents: false,
        disableOutsideScroll: false,
        trapFocus: false,
        onOpenAutoFocus: (event)=>{
            var _ref$current;
            // when opening a submenu, focus content for keyboard users only
            if (rootContext.isUsingKeyboardRef.current) (_ref$current = ref.current) === null || _ref$current === void 0 || _ref$current.focus();
            event.preventDefault();
        } // The menu might close because of focusing another menu item in the parent menu. We
        ,
        onCloseAutoFocus: (event)=>event.preventDefault()
        ,
        onFocusOutside: (0,dist/* composeEventHandlers */.M)(props.onFocusOutside, (event)=>{
            // We prevent closing when the trigger is focused to avoid triggering a re-open animation
            // on pointer interaction.
            if (event.target !== subContext.trigger) context.onOpenChange(false);
        }),
        onEscapeKeyDown: (0,dist/* composeEventHandlers */.M)(props.onEscapeKeyDown, (event)=>{
            rootContext.onClose(); // ensure pressing escape in submenu doesn't escape full screen mode
            event.preventDefault();
        }),
        onKeyDown: (0,dist/* composeEventHandlers */.M)(props.onKeyDown, (event)=>{
            // Submenu key events bubble through portals. We only care about keys in this menu.
            const isKeyDownInside = event.currentTarget.contains(event.target);
            const isCloseKey = $6cc32821e9371a1c$var$SUB_CLOSE_KEYS[rootContext.dir].includes(event.key);
            if (isKeyDownInside && isCloseKey) {
                var _subContext$trigger;
                context.onOpenChange(false); // We focus manually because we prevented it in `onCloseAutoFocus`
                (_subContext$trigger = subContext.trigger) === null || _subContext$trigger === void 0 || _subContext$trigger.focus(); // prevent window from scrolling
                event.preventDefault();
            }
        })
    })))));
});
/*#__PURE__*/ Object.assign($6cc32821e9371a1c$export$e7142ab31822bde6, {
    displayName: $6cc32821e9371a1c$var$SUB_CONTENT_NAME
});
/* -----------------------------------------------------------------------------------------------*/ function $6cc32821e9371a1c$var$getOpenState(open) {
    return open ? 'open' : 'closed';
}
function $6cc32821e9371a1c$var$isIndeterminate(checked) {
    return checked === 'indeterminate';
}
function $6cc32821e9371a1c$var$getCheckedState(checked) {
    return $6cc32821e9371a1c$var$isIndeterminate(checked) ? 'indeterminate' : checked ? 'checked' : 'unchecked';
}
function $6cc32821e9371a1c$var$focusFirst(candidates) {
    const PREVIOUSLY_FOCUSED_ELEMENT = document.activeElement;
    for (const candidate of candidates){
        // if focus is already where we want to go, we don't want to keep going through the candidates
        if (candidate === PREVIOUSLY_FOCUSED_ELEMENT) return;
        candidate.focus();
        if (document.activeElement !== PREVIOUSLY_FOCUSED_ELEMENT) return;
    }
}
/**
 * Wraps an array around itself at a given start index
 * Example: `wrapArray(['a', 'b', 'c', 'd'], 2) === ['c', 'd', 'a', 'b']`
 */ function $6cc32821e9371a1c$var$wrapArray(array, startIndex) {
    return array.map((_, index)=>array[(startIndex + index) % array.length]
    );
}
/**
 * This is the "meat" of the typeahead matching logic. It takes in all the values,
 * the search and the current match, and returns the next match (or `undefined`).
 *
 * We normalize the search because if a user has repeatedly pressed a character,
 * we want the exact same behavior as if we only had that one character
 * (ie. cycle through options starting with that character)
 *
 * We also reorder the values by wrapping the array around the current match.
 * This is so we always look forward from the current match, and picking the first
 * match will always be the correct one.
 *
 * Finally, if the normalized search is exactly one character, we exclude the
 * current match from the values because otherwise it would be the first to match always
 * and focus would never move. This is as opposed to the regular case, where we
 * don't want focus to move if the current match still matches.
 */ function $6cc32821e9371a1c$var$getNextMatch(values, search, currentMatch) {
    const isRepeated = search.length > 1 && Array.from(search).every((char)=>char === search[0]
    );
    const normalizedSearch = isRepeated ? search[0] : search;
    const currentMatchIndex = currentMatch ? values.indexOf(currentMatch) : -1;
    let wrappedValues = $6cc32821e9371a1c$var$wrapArray(values, Math.max(currentMatchIndex, 0));
    const excludeCurrentMatch = normalizedSearch.length === 1;
    if (excludeCurrentMatch) wrappedValues = wrappedValues.filter((v)=>v !== currentMatch
    );
    const nextMatch = wrappedValues.find((value)=>value.toLowerCase().startsWith(normalizedSearch.toLowerCase())
    );
    return nextMatch !== currentMatch ? nextMatch : undefined;
}
// Determine if a point is inside of a polygon.
// Based on https://github.com/substack/point-in-polygon
function $6cc32821e9371a1c$var$isPointInPolygon(point, polygon) {
    const { x: x , y: y  } = point;
    let inside = false;
    for(let i = 0, j = polygon.length - 1; i < polygon.length; j = i++){
        const xi = polygon[i].x;
        const yi = polygon[i].y;
        const xj = polygon[j].x;
        const yj = polygon[j].y; // prettier-ignore
        const intersect = yi > y !== yj > y && x < (xj - xi) * (y - yi) / (yj - yi) + xi;
        if (intersect) inside = !inside;
    }
    return inside;
}
function $6cc32821e9371a1c$var$isPointerInGraceArea(event, area) {
    if (!area) return false;
    const cursorPos = {
        x: event.clientX,
        y: event.clientY
    };
    return $6cc32821e9371a1c$var$isPointInPolygon(cursorPos, area);
}
function $6cc32821e9371a1c$var$whenMouse(handler) {
    return (event)=>event.pointerType === 'mouse' ? handler(event) : undefined
    ;
}
const $6cc32821e9371a1c$export$be92b6f5f03c0fe9 = $6cc32821e9371a1c$export$d9b273488cd8ce6f;
const $6cc32821e9371a1c$export$b688253958b8dfe7 = $6cc32821e9371a1c$export$9fa5ebd18bee4d43;
const $6cc32821e9371a1c$export$602eac185826482c = $6cc32821e9371a1c$export$793392f970497feb;
const $6cc32821e9371a1c$export$7c6e2c02157bb7d2 = $6cc32821e9371a1c$export$479f0f2f71193efe;
const $6cc32821e9371a1c$export$eb2fcfdbd7ba97d4 = $6cc32821e9371a1c$export$22a631d1f72787bb;
const $6cc32821e9371a1c$export$b04be29aa201d4f5 = $6cc32821e9371a1c$export$dd37bec0e8a99143;
const $6cc32821e9371a1c$export$6d08773d2e66f8f2 = $6cc32821e9371a1c$export$2ce376c2cc3355c8;
const $6cc32821e9371a1c$export$16ce288f89fa631c = $6cc32821e9371a1c$export$f6f243521332502d;
const $6cc32821e9371a1c$export$a98f0dcb43a68a25 = $6cc32821e9371a1c$export$ea2200c9eee416b3;
const $6cc32821e9371a1c$export$371ab307eab489c0 = $6cc32821e9371a1c$export$69bd225e9817f6d0;
const $6cc32821e9371a1c$export$c3468e2714d175fa = $6cc32821e9371a1c$export$a2593e23056970a3;
const $6cc32821e9371a1c$export$1ff3c3f08ae963c0 = $6cc32821e9371a1c$export$1cec7dcdd713e220;
const $6cc32821e9371a1c$export$21b07c8f274aebd5 = $6cc32821e9371a1c$export$bcdda4773debf5fa;
const $6cc32821e9371a1c$export$d7a01e11500dfb6f = $6cc32821e9371a1c$export$71bdb9d1e2909932;
const $6cc32821e9371a1c$export$2ea8a7a591ac5eac = $6cc32821e9371a1c$export$5fbbb3ba7297405f;
const $6cc32821e9371a1c$export$6d4de93b380beddf = $6cc32821e9371a1c$export$e7142ab31822bde6;





//# sourceMappingURL=index.mjs.map

;// CONCATENATED MODULE: ./node_modules/@radix-ui/react-dropdown-menu/dist/index.mjs




















/* -------------------------------------------------------------------------------------------------
 * DropdownMenu
 * -----------------------------------------------------------------------------------------------*/ const $d08ef79370b62062$var$DROPDOWN_MENU_NAME = 'DropdownMenu';
const [$d08ef79370b62062$var$createDropdownMenuContext, $d08ef79370b62062$export$c0623cd925aeb687] = (0,react_context_dist/* createContextScope */.b)($d08ef79370b62062$var$DROPDOWN_MENU_NAME, [
    $6cc32821e9371a1c$export$4027731b685e72eb
]);
const $d08ef79370b62062$var$useMenuScope = $6cc32821e9371a1c$export$4027731b685e72eb();
const [$d08ef79370b62062$var$DropdownMenuProvider, $d08ef79370b62062$var$useDropdownMenuContext] = $d08ef79370b62062$var$createDropdownMenuContext($d08ef79370b62062$var$DROPDOWN_MENU_NAME);
const $d08ef79370b62062$export$e44a253a59704894 = (props)=>{
    const { __scopeDropdownMenu: __scopeDropdownMenu , children: children , dir: dir , open: openProp , defaultOpen: defaultOpen , onOpenChange: onOpenChange , modal: modal = true  } = props;
    const menuScope = $d08ef79370b62062$var$useMenuScope(__scopeDropdownMenu);
    const triggerRef = (0,react.useRef)(null);
    const [open = false, setOpen] = (0,react_use_controllable_state_dist/* useControllableState */.T)({
        prop: openProp,
        defaultProp: defaultOpen,
        onChange: onOpenChange
    });
    return /*#__PURE__*/ (0,react.createElement)($d08ef79370b62062$var$DropdownMenuProvider, {
        scope: __scopeDropdownMenu,
        triggerId: (0,react_id_dist/* useId */.M)(),
        triggerRef: triggerRef,
        contentId: (0,react_id_dist/* useId */.M)(),
        open: open,
        onOpenChange: setOpen,
        onOpenToggle: (0,react.useCallback)(()=>setOpen((prevOpen)=>!prevOpen
            )
        , [
            setOpen
        ]),
        modal: modal
    }, /*#__PURE__*/ (0,react.createElement)($6cc32821e9371a1c$export$be92b6f5f03c0fe9, (0,esm_extends/* default */.Z)({}, menuScope, {
        open: open,
        onOpenChange: setOpen,
        dir: dir,
        modal: modal
    }), children));
};
/*#__PURE__*/ Object.assign($d08ef79370b62062$export$e44a253a59704894, {
    displayName: $d08ef79370b62062$var$DROPDOWN_MENU_NAME
});
/* -------------------------------------------------------------------------------------------------
 * DropdownMenuTrigger
 * -----------------------------------------------------------------------------------------------*/ const $d08ef79370b62062$var$TRIGGER_NAME = 'DropdownMenuTrigger';
const $d08ef79370b62062$export$d2469213b3befba9 = /*#__PURE__*/ (0,react.forwardRef)((props, forwardedRef)=>{
    const { __scopeDropdownMenu: __scopeDropdownMenu , disabled: disabled = false , ...triggerProps } = props;
    const context = $d08ef79370b62062$var$useDropdownMenuContext($d08ef79370b62062$var$TRIGGER_NAME, __scopeDropdownMenu);
    const menuScope = $d08ef79370b62062$var$useMenuScope(__scopeDropdownMenu);
    return /*#__PURE__*/ (0,react.createElement)($6cc32821e9371a1c$export$b688253958b8dfe7, (0,esm_extends/* default */.Z)({
        asChild: true
    }, menuScope), /*#__PURE__*/ (0,react.createElement)(react_primitive_dist/* Primitive.button */.WV.button, (0,esm_extends/* default */.Z)({
        type: "button",
        id: context.triggerId,
        "aria-haspopup": "menu",
        "aria-expanded": context.open,
        "aria-controls": context.open ? context.contentId : undefined,
        "data-state": context.open ? 'open' : 'closed',
        "data-disabled": disabled ? '' : undefined,
        disabled: disabled
    }, triggerProps, {
        ref: (0,react_compose_refs_dist/* composeRefs */.F)(forwardedRef, context.triggerRef),
        onPointerDown: (0,dist/* composeEventHandlers */.M)(props.onPointerDown, (event)=>{
            // only call handler if it's the left button (mousedown gets triggered by all mouse buttons)
            // but not when the control key is pressed (avoiding MacOS right click)
            if (!disabled && event.button === 0 && event.ctrlKey === false) {
                context.onOpenToggle(); // prevent trigger focusing when opening
                // this allows the content to be given focus without competition
                if (!context.open) event.preventDefault();
            }
        }),
        onKeyDown: (0,dist/* composeEventHandlers */.M)(props.onKeyDown, (event)=>{
            if (disabled) return;
            if ([
                'Enter',
                ' '
            ].includes(event.key)) context.onOpenToggle();
            if (event.key === 'ArrowDown') context.onOpenChange(true); // prevent keydown from scrolling window / first focused item to execute
            // that keydown (inadvertently closing the menu)
            if ([
                'Enter',
                ' ',
                'ArrowDown'
            ].includes(event.key)) event.preventDefault();
        })
    })));
});
/*#__PURE__*/ Object.assign($d08ef79370b62062$export$d2469213b3befba9, {
    displayName: $d08ef79370b62062$var$TRIGGER_NAME
});
/* -------------------------------------------------------------------------------------------------
 * DropdownMenuPortal
 * -----------------------------------------------------------------------------------------------*/ const $d08ef79370b62062$var$PORTAL_NAME = 'DropdownMenuPortal';
const $d08ef79370b62062$export$cd369b4d4d54efc9 = (props)=>{
    const { __scopeDropdownMenu: __scopeDropdownMenu , ...portalProps } = props;
    const menuScope = $d08ef79370b62062$var$useMenuScope(__scopeDropdownMenu);
    return /*#__PURE__*/ (0,react.createElement)($6cc32821e9371a1c$export$602eac185826482c, (0,esm_extends/* default */.Z)({}, menuScope, portalProps));
};
/*#__PURE__*/ Object.assign($d08ef79370b62062$export$cd369b4d4d54efc9, {
    displayName: $d08ef79370b62062$var$PORTAL_NAME
});
/* -------------------------------------------------------------------------------------------------
 * DropdownMenuContent
 * -----------------------------------------------------------------------------------------------*/ const $d08ef79370b62062$var$CONTENT_NAME = 'DropdownMenuContent';
const $d08ef79370b62062$export$6e76d93a37c01248 = /*#__PURE__*/ (0,react.forwardRef)((props, forwardedRef)=>{
    const { __scopeDropdownMenu: __scopeDropdownMenu , ...contentProps } = props;
    const context = $d08ef79370b62062$var$useDropdownMenuContext($d08ef79370b62062$var$CONTENT_NAME, __scopeDropdownMenu);
    const menuScope = $d08ef79370b62062$var$useMenuScope(__scopeDropdownMenu);
    const hasInteractedOutsideRef = (0,react.useRef)(false);
    return /*#__PURE__*/ (0,react.createElement)($6cc32821e9371a1c$export$7c6e2c02157bb7d2, (0,esm_extends/* default */.Z)({
        id: context.contentId,
        "aria-labelledby": context.triggerId
    }, menuScope, contentProps, {
        ref: forwardedRef,
        onCloseAutoFocus: (0,dist/* composeEventHandlers */.M)(props.onCloseAutoFocus, (event)=>{
            var _context$triggerRef$c;
            if (!hasInteractedOutsideRef.current) (_context$triggerRef$c = context.triggerRef.current) === null || _context$triggerRef$c === void 0 || _context$triggerRef$c.focus();
            hasInteractedOutsideRef.current = false; // Always prevent auto focus because we either focus manually or want user agent focus
            event.preventDefault();
        }),
        onInteractOutside: (0,dist/* composeEventHandlers */.M)(props.onInteractOutside, (event)=>{
            const originalEvent = event.detail.originalEvent;
            const ctrlLeftClick = originalEvent.button === 0 && originalEvent.ctrlKey === true;
            const isRightClick = originalEvent.button === 2 || ctrlLeftClick;
            if (!context.modal || isRightClick) hasInteractedOutsideRef.current = true;
        }),
        style: {
            ...props.style,
            '--radix-dropdown-menu-content-transform-origin': 'var(--radix-popper-transform-origin)',
            '--radix-dropdown-menu-content-available-width': 'var(--radix-popper-available-width)',
            '--radix-dropdown-menu-content-available-height': 'var(--radix-popper-available-height)',
            '--radix-dropdown-menu-trigger-width': 'var(--radix-popper-anchor-width)',
            '--radix-dropdown-menu-trigger-height': 'var(--radix-popper-anchor-height)'
        }
    }));
});
/*#__PURE__*/ Object.assign($d08ef79370b62062$export$6e76d93a37c01248, {
    displayName: $d08ef79370b62062$var$CONTENT_NAME
});
/* -------------------------------------------------------------------------------------------------
 * DropdownMenuGroup
 * -----------------------------------------------------------------------------------------------*/ const $d08ef79370b62062$var$GROUP_NAME = 'DropdownMenuGroup';
const $d08ef79370b62062$export$246bebaba3a2f70e = /*#__PURE__*/ (0,react.forwardRef)((props, forwardedRef)=>{
    const { __scopeDropdownMenu: __scopeDropdownMenu , ...groupProps } = props;
    const menuScope = $d08ef79370b62062$var$useMenuScope(__scopeDropdownMenu);
    return /*#__PURE__*/ (0,react.createElement)($6cc32821e9371a1c$export$eb2fcfdbd7ba97d4, (0,esm_extends/* default */.Z)({}, menuScope, groupProps, {
        ref: forwardedRef
    }));
});
/*#__PURE__*/ Object.assign($d08ef79370b62062$export$246bebaba3a2f70e, {
    displayName: $d08ef79370b62062$var$GROUP_NAME
});
/* -------------------------------------------------------------------------------------------------
 * DropdownMenuLabel
 * -----------------------------------------------------------------------------------------------*/ const $d08ef79370b62062$var$LABEL_NAME = 'DropdownMenuLabel';
const $d08ef79370b62062$export$76e48c5b57f24495 = /*#__PURE__*/ (0,react.forwardRef)((props, forwardedRef)=>{
    const { __scopeDropdownMenu: __scopeDropdownMenu , ...labelProps } = props;
    const menuScope = $d08ef79370b62062$var$useMenuScope(__scopeDropdownMenu);
    return /*#__PURE__*/ (0,react.createElement)($6cc32821e9371a1c$export$b04be29aa201d4f5, (0,esm_extends/* default */.Z)({}, menuScope, labelProps, {
        ref: forwardedRef
    }));
});
/*#__PURE__*/ Object.assign($d08ef79370b62062$export$76e48c5b57f24495, {
    displayName: $d08ef79370b62062$var$LABEL_NAME
});
/* -------------------------------------------------------------------------------------------------
 * DropdownMenuItem
 * -----------------------------------------------------------------------------------------------*/ const $d08ef79370b62062$var$ITEM_NAME = 'DropdownMenuItem';
const $d08ef79370b62062$export$ed97964d1871885d = /*#__PURE__*/ (0,react.forwardRef)((props, forwardedRef)=>{
    const { __scopeDropdownMenu: __scopeDropdownMenu , ...itemProps } = props;
    const menuScope = $d08ef79370b62062$var$useMenuScope(__scopeDropdownMenu);
    return /*#__PURE__*/ (0,react.createElement)($6cc32821e9371a1c$export$6d08773d2e66f8f2, (0,esm_extends/* default */.Z)({}, menuScope, itemProps, {
        ref: forwardedRef
    }));
});
/*#__PURE__*/ Object.assign($d08ef79370b62062$export$ed97964d1871885d, {
    displayName: $d08ef79370b62062$var$ITEM_NAME
});
/* -------------------------------------------------------------------------------------------------
 * DropdownMenuCheckboxItem
 * -----------------------------------------------------------------------------------------------*/ const $d08ef79370b62062$var$CHECKBOX_ITEM_NAME = 'DropdownMenuCheckboxItem';
const $d08ef79370b62062$export$53a69729da201fa9 = /*#__PURE__*/ (0,react.forwardRef)((props, forwardedRef)=>{
    const { __scopeDropdownMenu: __scopeDropdownMenu , ...checkboxItemProps } = props;
    const menuScope = $d08ef79370b62062$var$useMenuScope(__scopeDropdownMenu);
    return /*#__PURE__*/ (0,react.createElement)($6cc32821e9371a1c$export$16ce288f89fa631c, (0,esm_extends/* default */.Z)({}, menuScope, checkboxItemProps, {
        ref: forwardedRef
    }));
});
/*#__PURE__*/ Object.assign($d08ef79370b62062$export$53a69729da201fa9, {
    displayName: $d08ef79370b62062$var$CHECKBOX_ITEM_NAME
});
/* -------------------------------------------------------------------------------------------------
 * DropdownMenuRadioGroup
 * -----------------------------------------------------------------------------------------------*/ const $d08ef79370b62062$var$RADIO_GROUP_NAME = 'DropdownMenuRadioGroup';
const $d08ef79370b62062$export$3323ad73d55f587e = /*#__PURE__*/ (0,react.forwardRef)((props, forwardedRef)=>{
    const { __scopeDropdownMenu: __scopeDropdownMenu , ...radioGroupProps } = props;
    const menuScope = $d08ef79370b62062$var$useMenuScope(__scopeDropdownMenu);
    return /*#__PURE__*/ (0,react.createElement)($6cc32821e9371a1c$export$a98f0dcb43a68a25, (0,esm_extends/* default */.Z)({}, menuScope, radioGroupProps, {
        ref: forwardedRef
    }));
});
/*#__PURE__*/ Object.assign($d08ef79370b62062$export$3323ad73d55f587e, {
    displayName: $d08ef79370b62062$var$RADIO_GROUP_NAME
});
/* -------------------------------------------------------------------------------------------------
 * DropdownMenuRadioItem
 * -----------------------------------------------------------------------------------------------*/ const $d08ef79370b62062$var$RADIO_ITEM_NAME = 'DropdownMenuRadioItem';
const $d08ef79370b62062$export$e4f69b41b1637536 = /*#__PURE__*/ (0,react.forwardRef)((props, forwardedRef)=>{
    const { __scopeDropdownMenu: __scopeDropdownMenu , ...radioItemProps } = props;
    const menuScope = $d08ef79370b62062$var$useMenuScope(__scopeDropdownMenu);
    return /*#__PURE__*/ (0,react.createElement)($6cc32821e9371a1c$export$371ab307eab489c0, (0,esm_extends/* default */.Z)({}, menuScope, radioItemProps, {
        ref: forwardedRef
    }));
});
/*#__PURE__*/ Object.assign($d08ef79370b62062$export$e4f69b41b1637536, {
    displayName: $d08ef79370b62062$var$RADIO_ITEM_NAME
});
/* -------------------------------------------------------------------------------------------------
 * DropdownMenuItemIndicator
 * -----------------------------------------------------------------------------------------------*/ const $d08ef79370b62062$var$INDICATOR_NAME = 'DropdownMenuItemIndicator';
const $d08ef79370b62062$export$42355ae145153fb6 = /*#__PURE__*/ (0,react.forwardRef)((props, forwardedRef)=>{
    const { __scopeDropdownMenu: __scopeDropdownMenu , ...itemIndicatorProps } = props;
    const menuScope = $d08ef79370b62062$var$useMenuScope(__scopeDropdownMenu);
    return /*#__PURE__*/ (0,react.createElement)($6cc32821e9371a1c$export$c3468e2714d175fa, (0,esm_extends/* default */.Z)({}, menuScope, itemIndicatorProps, {
        ref: forwardedRef
    }));
});
/*#__PURE__*/ Object.assign($d08ef79370b62062$export$42355ae145153fb6, {
    displayName: $d08ef79370b62062$var$INDICATOR_NAME
});
/* -------------------------------------------------------------------------------------------------
 * DropdownMenuSeparator
 * -----------------------------------------------------------------------------------------------*/ const $d08ef79370b62062$var$SEPARATOR_NAME = 'DropdownMenuSeparator';
const $d08ef79370b62062$export$da160178fd3bc7e9 = /*#__PURE__*/ (0,react.forwardRef)((props, forwardedRef)=>{
    const { __scopeDropdownMenu: __scopeDropdownMenu , ...separatorProps } = props;
    const menuScope = $d08ef79370b62062$var$useMenuScope(__scopeDropdownMenu);
    return /*#__PURE__*/ (0,react.createElement)($6cc32821e9371a1c$export$1ff3c3f08ae963c0, (0,esm_extends/* default */.Z)({}, menuScope, separatorProps, {
        ref: forwardedRef
    }));
});
/*#__PURE__*/ Object.assign($d08ef79370b62062$export$da160178fd3bc7e9, {
    displayName: $d08ef79370b62062$var$SEPARATOR_NAME
});
/* -------------------------------------------------------------------------------------------------
 * DropdownMenuArrow
 * -----------------------------------------------------------------------------------------------*/ const $d08ef79370b62062$var$ARROW_NAME = 'DropdownMenuArrow';
const $d08ef79370b62062$export$34b8980744021ec5 = /*#__PURE__*/ (0,react.forwardRef)((props, forwardedRef)=>{
    const { __scopeDropdownMenu: __scopeDropdownMenu , ...arrowProps } = props;
    const menuScope = $d08ef79370b62062$var$useMenuScope(__scopeDropdownMenu);
    return /*#__PURE__*/ (0,react.createElement)($6cc32821e9371a1c$export$21b07c8f274aebd5, (0,esm_extends/* default */.Z)({}, menuScope, arrowProps, {
        ref: forwardedRef
    }));
});
/*#__PURE__*/ Object.assign($d08ef79370b62062$export$34b8980744021ec5, {
    displayName: $d08ef79370b62062$var$ARROW_NAME
});
/* -------------------------------------------------------------------------------------------------
 * DropdownMenuSub
 * -----------------------------------------------------------------------------------------------*/ const $d08ef79370b62062$export$2f307d81a64f5442 = (props)=>{
    const { __scopeDropdownMenu: __scopeDropdownMenu , children: children , open: openProp , onOpenChange: onOpenChange , defaultOpen: defaultOpen  } = props;
    const menuScope = $d08ef79370b62062$var$useMenuScope(__scopeDropdownMenu);
    const [open = false, setOpen] = (0,react_use_controllable_state_dist/* useControllableState */.T)({
        prop: openProp,
        defaultProp: defaultOpen,
        onChange: onOpenChange
    });
    return /*#__PURE__*/ (0,react.createElement)($6cc32821e9371a1c$export$d7a01e11500dfb6f, (0,esm_extends/* default */.Z)({}, menuScope, {
        open: open,
        onOpenChange: setOpen
    }), children);
};
/* -------------------------------------------------------------------------------------------------
 * DropdownMenuSubTrigger
 * -----------------------------------------------------------------------------------------------*/ const $d08ef79370b62062$var$SUB_TRIGGER_NAME = 'DropdownMenuSubTrigger';
const $d08ef79370b62062$export$21dcb7ec56f874cf = /*#__PURE__*/ (0,react.forwardRef)((props, forwardedRef)=>{
    const { __scopeDropdownMenu: __scopeDropdownMenu , ...subTriggerProps } = props;
    const menuScope = $d08ef79370b62062$var$useMenuScope(__scopeDropdownMenu);
    return /*#__PURE__*/ (0,react.createElement)($6cc32821e9371a1c$export$2ea8a7a591ac5eac, (0,esm_extends/* default */.Z)({}, menuScope, subTriggerProps, {
        ref: forwardedRef
    }));
});
/*#__PURE__*/ Object.assign($d08ef79370b62062$export$21dcb7ec56f874cf, {
    displayName: $d08ef79370b62062$var$SUB_TRIGGER_NAME
});
/* -------------------------------------------------------------------------------------------------
 * DropdownMenuSubContent
 * -----------------------------------------------------------------------------------------------*/ const $d08ef79370b62062$var$SUB_CONTENT_NAME = 'DropdownMenuSubContent';
const $d08ef79370b62062$export$f34ec8bc2482cc5f = /*#__PURE__*/ (0,react.forwardRef)((props, forwardedRef)=>{
    const { __scopeDropdownMenu: __scopeDropdownMenu , ...subContentProps } = props;
    const menuScope = $d08ef79370b62062$var$useMenuScope(__scopeDropdownMenu);
    return /*#__PURE__*/ (0,react.createElement)($6cc32821e9371a1c$export$6d4de93b380beddf, (0,esm_extends/* default */.Z)({}, menuScope, subContentProps, {
        ref: forwardedRef,
        style: {
            ...props.style,
            '--radix-dropdown-menu-content-transform-origin': 'var(--radix-popper-transform-origin)',
            '--radix-dropdown-menu-content-available-width': 'var(--radix-popper-available-width)',
            '--radix-dropdown-menu-content-available-height': 'var(--radix-popper-available-height)',
            '--radix-dropdown-menu-trigger-width': 'var(--radix-popper-anchor-width)',
            '--radix-dropdown-menu-trigger-height': 'var(--radix-popper-anchor-height)'
        }
    }));
});
/*#__PURE__*/ Object.assign($d08ef79370b62062$export$f34ec8bc2482cc5f, {
    displayName: $d08ef79370b62062$var$SUB_CONTENT_NAME
});
/* -----------------------------------------------------------------------------------------------*/ const $d08ef79370b62062$export$be92b6f5f03c0fe9 = $d08ef79370b62062$export$e44a253a59704894;
const $d08ef79370b62062$export$41fb9f06171c75f4 = $d08ef79370b62062$export$d2469213b3befba9;
const $d08ef79370b62062$export$602eac185826482c = $d08ef79370b62062$export$cd369b4d4d54efc9;
const $d08ef79370b62062$export$7c6e2c02157bb7d2 = $d08ef79370b62062$export$6e76d93a37c01248;
const $d08ef79370b62062$export$eb2fcfdbd7ba97d4 = $d08ef79370b62062$export$246bebaba3a2f70e;
const $d08ef79370b62062$export$b04be29aa201d4f5 = $d08ef79370b62062$export$76e48c5b57f24495;
const $d08ef79370b62062$export$6d08773d2e66f8f2 = $d08ef79370b62062$export$ed97964d1871885d;
const $d08ef79370b62062$export$16ce288f89fa631c = $d08ef79370b62062$export$53a69729da201fa9;
const $d08ef79370b62062$export$a98f0dcb43a68a25 = $d08ef79370b62062$export$3323ad73d55f587e;
const $d08ef79370b62062$export$371ab307eab489c0 = $d08ef79370b62062$export$e4f69b41b1637536;
const $d08ef79370b62062$export$c3468e2714d175fa = $d08ef79370b62062$export$42355ae145153fb6;
const $d08ef79370b62062$export$1ff3c3f08ae963c0 = $d08ef79370b62062$export$da160178fd3bc7e9;
const $d08ef79370b62062$export$21b07c8f274aebd5 = (/* unused pure expression or super */ null && ($d08ef79370b62062$export$34b8980744021ec5));
const $d08ef79370b62062$export$d7a01e11500dfb6f = $d08ef79370b62062$export$2f307d81a64f5442;
const $d08ef79370b62062$export$2ea8a7a591ac5eac = $d08ef79370b62062$export$21dcb7ec56f874cf;
const $d08ef79370b62062$export$6d4de93b380beddf = $d08ef79370b62062$export$f34ec8bc2482cc5f;





//# sourceMappingURL=index.mjs.map

// EXTERNAL MODULE: ./node_modules/lucide-react/dist/esm/icons/chevron-right.js
var chevron_right = __webpack_require__(64998);
// EXTERNAL MODULE: ./node_modules/lucide-react/dist/esm/icons/check.js
var check = __webpack_require__(13742);
// EXTERNAL MODULE: ./node_modules/lucide-react/dist/esm/icons/circle.js
var circle = __webpack_require__(50316);
// EXTERNAL MODULE: ./app/lib/utils.ts + 1 modules
var utils = __webpack_require__(73848);
;// CONCATENATED MODULE: ./app/components/ui/dropdown-menu.tsx





const DropdownMenu = $d08ef79370b62062$export$be92b6f5f03c0fe9;
const DropdownMenuTrigger = $d08ef79370b62062$export$41fb9f06171c75f4;
const DropdownMenuGroup = $d08ef79370b62062$export$eb2fcfdbd7ba97d4;
const DropdownMenuPortal = $d08ef79370b62062$export$602eac185826482c;
const DropdownMenuSub = $d08ef79370b62062$export$d7a01e11500dfb6f;
const DropdownMenuRadioGroup = $d08ef79370b62062$export$a98f0dcb43a68a25;
const DropdownMenuSubTrigger = /*#__PURE__*/ react.forwardRef((param, ref)=>/*#__PURE__*/ {
    let { className , inset , children , ...props } = param;
    return (0,jsx_runtime.jsxs)($d08ef79370b62062$export$2ea8a7a591ac5eac, {
        ref: ref,
        className: (0,utils.cn)("flex cursor-default select-none items-center rounded-sm px-2 py-1.5 text-sm outline-none focus:bg-accent data-[state=open]:bg-accent", inset && "pl-8", className),
        ...props,
        children: [
            children,
            /*#__PURE__*/ (0,jsx_runtime.jsx)(chevron_right/* default */.Z, {
                className: "w-4 h-4 ml-auto"
            })
        ]
    });
});
DropdownMenuSubTrigger.displayName = $d08ef79370b62062$export$2ea8a7a591ac5eac.displayName;
const DropdownMenuSubContent = /*#__PURE__*/ react.forwardRef((param, ref)=>/*#__PURE__*/ {
    let { className , ...props } = param;
    return (0,jsx_runtime.jsx)($d08ef79370b62062$export$6d4de93b380beddf, {
        ref: ref,
        className: (0,utils.cn)("z-50 min-w-[8rem] overflow-hidden rounded-md border bg-popover p-1 text-popover-foreground shadow-lg data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0 data-[state=closed]:zoom-out-95 data-[state=open]:zoom-in-95 data-[side=bottom]:slide-in-from-top-2 data-[side=left]:slide-in-from-right-2 data-[side=right]:slide-in-from-left-2 data-[side=top]:slide-in-from-bottom-2", className),
        ...props
    });
});
DropdownMenuSubContent.displayName = $d08ef79370b62062$export$6d4de93b380beddf.displayName;
const DropdownMenuContent = /*#__PURE__*/ react.forwardRef((param, ref)=>/*#__PURE__*/ {
    let { className , sideOffset =4 , ...props } = param;
    return (0,jsx_runtime.jsx)($d08ef79370b62062$export$602eac185826482c, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)($d08ef79370b62062$export$7c6e2c02157bb7d2, {
            ref: ref,
            sideOffset: sideOffset,
            className: (0,utils.cn)("z-50 min-w-[8rem] overflow-hidden rounded-[16px] bg-white dark:bg-dark-mode-box p-[8px] text-bg-01 dark:text-main-white shadow-md data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0 data-[state=closed]:zoom-out-95 data-[state=open]:zoom-in-95 data-[side=bottom]:slide-in-from-top-2 data-[side=left]:slide-in-from-right-2 data-[side=right]:slide-in-from-left-2 data-[side=top]:slide-in-from-bottom-2", className),
            style: {
                boxShadow: "0px 3px 30px 0px rgba(0, 0, 0, 0.15)"
            },
            ...props
        })
    });
});
DropdownMenuContent.displayName = $d08ef79370b62062$export$7c6e2c02157bb7d2.displayName;
const DropdownMenuItem = /*#__PURE__*/ react.forwardRef((param, ref)=>/*#__PURE__*/ {
    let { className , inset , ...props } = param;
    return (0,jsx_runtime.jsx)($d08ef79370b62062$export$6d08773d2e66f8f2, {
        ref: ref,
        className: (0,utils.cn)("relative flex cursor-pointer select-none items-center rounded-sm px-2 py-1.5 text-sm outline-none transition-colors focus:bg-accent focus:text-accent-foreground data-[disabled]:pointer-events-none data-[disabled]:opacity-50", inset && "pl-8", className),
        ...props
    });
});
DropdownMenuItem.displayName = $d08ef79370b62062$export$6d08773d2e66f8f2.displayName;
const DropdownMenuCheckboxItem = /*#__PURE__*/ react.forwardRef((param, ref)=>/*#__PURE__*/ {
    let { className , children , checked , ...props } = param;
    return (0,jsx_runtime.jsxs)($d08ef79370b62062$export$16ce288f89fa631c, {
        ref: ref,
        className: (0,utils.cn)("relative flex mb-1 cursor-pointer select-none items-center rounded-[8px] py-[16px] pl-10 pr-[20px] text-[16px] Nunito-700 outline-none transition-colors data-[disabled]:pointer-events-none data-[disabled]:opacity-50 hover:bg-bg-disable hover:text-main-01 dark:hover:bg-main-01 dark:hover:text-white", className, checked && "bg-bg-disable text-main-01 dark:bg-main-01 dark:text-white"),
        checked: checked,
        ...props,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                className: "absolute left-2 flex h-[20px] w-[20px] items-center justify-center",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)($d08ef79370b62062$export$c3468e2714d175fa, {
                        className: "bg-main-01 h-[18px] w-[18px] rounded-[4px] flex items-center justify-center dark:bg-white",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(check/* default */.Z, {
                            className: "h-[16px] w-[16px] text-white dark:text-main-01"
                        })
                    }),
                    !checked && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "h-[20px] w-[20px] rounded-[5px] border border-black/10 border-[2px] dark:border-white"
                    })
                ]
            }),
            children
        ]
    });
});
DropdownMenuCheckboxItem.displayName = $d08ef79370b62062$export$16ce288f89fa631c.displayName;
const DropdownMenuRadioItem = /*#__PURE__*/ react.forwardRef((param, ref)=>/*#__PURE__*/ {
    let { className , children , ...props } = param;
    return (0,jsx_runtime.jsxs)($d08ef79370b62062$export$371ab307eab489c0, {
        ref: ref,
        className: (0,utils.cn)("relative flex cursor-default select-none items-center rounded-sm py-1.5 pl-8 pr-2 text-sm outline-none transition-colors focus:bg-accent focus:text-accent-foreground data-[disabled]:pointer-events-none data-[disabled]:opacity-50", className),
        ...props,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                className: "absolute left-2 flex h-3.5 w-3.5 items-center justify-center",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)($d08ef79370b62062$export$c3468e2714d175fa, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(circle/* default */.Z, {
                        className: "w-2 h-2 fill-current"
                    })
                })
            }),
            children
        ]
    });
});
DropdownMenuRadioItem.displayName = $d08ef79370b62062$export$371ab307eab489c0.displayName;
const DropdownMenuLabel = /*#__PURE__*/ react.forwardRef((param, ref)=>/*#__PURE__*/ {
    let { className , inset , ...props } = param;
    return (0,jsx_runtime.jsx)($d08ef79370b62062$export$b04be29aa201d4f5, {
        ref: ref,
        className: (0,utils.cn)("px-2 py-1.5 text-sm font-semibold", inset && "pl-8", className),
        ...props
    });
});
DropdownMenuLabel.displayName = $d08ef79370b62062$export$b04be29aa201d4f5.displayName;
const DropdownMenuSeparator = /*#__PURE__*/ react.forwardRef((param, ref)=>/*#__PURE__*/ {
    let { className , ...props } = param;
    return (0,jsx_runtime.jsx)($d08ef79370b62062$export$1ff3c3f08ae963c0, {
        ref: ref,
        className: (0,utils.cn)("-mx-1 my-1 h-px bg-muted", className),
        ...props
    });
});
DropdownMenuSeparator.displayName = $d08ef79370b62062$export$1ff3c3f08ae963c0.displayName;
const DropdownMenuShortcut = (param)=>{
    let { className , ...props } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
        className: (0,utils.cn)("ml-auto text-xs tracking-widest opacity-60", className),
        ...props
    });
};
DropdownMenuShortcut.displayName = "DropdownMenuShortcut";



/***/ }),

/***/ 78634:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "I": function() { return /* binding */ Input; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(41844);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(55784);
/* harmony import */ var _lib_utils__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(73848);



const Input = /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_1__.forwardRef((param, ref)=>{
    let { className , type , ...props } = param;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("input", {
        type: type,
        className: (0,_lib_utils__WEBPACK_IMPORTED_MODULE_2__.cn)("flex h-10 w-full rounded-md border border-input bg-background px-3 py-2 text-sm ring-offset-background file:border-0 file:bg-transparent file:text-sm file:font-medium placeholder:text-neutral-06 focus-visible:outline-none  disabled:cursor-not-allowed disabled:opacity-50", className),
        autoFocus: false,
        ref: ref,
        ...props
    });
});
Input.displayName = "Input";



/***/ }),

/***/ 63645:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "E": function() { return /* binding */ RadioGroup; },
  "m": function() { return /* binding */ RadioGroupItem; }
});

// EXTERNAL MODULE: ./node_modules/next/dist/compiled/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(41844);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/react/index.js
var react = __webpack_require__(55784);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__(87462);
// EXTERNAL MODULE: ./node_modules/@radix-ui/primitive/dist/index.mjs
var dist = __webpack_require__(36206);
// EXTERNAL MODULE: ./node_modules/@radix-ui/react-compose-refs/dist/index.mjs
var react_compose_refs_dist = __webpack_require__(28771);
// EXTERNAL MODULE: ./node_modules/@radix-ui/react-context/dist/index.mjs
var react_context_dist = __webpack_require__(25360);
// EXTERNAL MODULE: ./node_modules/@radix-ui/react-primitive/dist/index.mjs
var react_primitive_dist = __webpack_require__(75320);
// EXTERNAL MODULE: ./node_modules/@radix-ui/react-roving-focus/dist/index.mjs
var react_roving_focus_dist = __webpack_require__(66681);
// EXTERNAL MODULE: ./node_modules/@radix-ui/react-use-controllable-state/dist/index.mjs
var react_use_controllable_state_dist = __webpack_require__(77342);
// EXTERNAL MODULE: ./node_modules/@radix-ui/react-direction/dist/index.mjs
var react_direction_dist = __webpack_require__(78990);
// EXTERNAL MODULE: ./node_modules/@radix-ui/react-use-size/dist/index.mjs
var react_use_size_dist = __webpack_require__(7546);
// EXTERNAL MODULE: ./node_modules/@radix-ui/react-use-previous/dist/index.mjs
var react_use_previous_dist = __webpack_require__(57898);
// EXTERNAL MODULE: ./node_modules/@radix-ui/react-presence/dist/index.mjs
var react_presence_dist = __webpack_require__(29115);
;// CONCATENATED MODULE: ./node_modules/@radix-ui/react-radio-group/dist/index.mjs
































/* -------------------------------------------------------------------------------------------------
 * Radio
 * -----------------------------------------------------------------------------------------------*/ const $ce77a8961b41be9e$var$RADIO_NAME = 'Radio';
const [$ce77a8961b41be9e$var$createRadioContext, $ce77a8961b41be9e$export$67d2296460f1b002] = (0,react_context_dist/* createContextScope */.b)($ce77a8961b41be9e$var$RADIO_NAME);
const [$ce77a8961b41be9e$var$RadioProvider, $ce77a8961b41be9e$var$useRadioContext] = $ce77a8961b41be9e$var$createRadioContext($ce77a8961b41be9e$var$RADIO_NAME);
const $ce77a8961b41be9e$export$d7b12c4107be0d61 = /*#__PURE__*/ (0,react.forwardRef)((props, forwardedRef)=>{
    const { __scopeRadio: __scopeRadio , name: name , checked: checked = false , required: required , disabled: disabled , value: value = 'on' , onCheck: onCheck , ...radioProps } = props;
    const [button, setButton] = (0,react.useState)(null);
    const composedRefs = (0,react_compose_refs_dist/* useComposedRefs */.e)(forwardedRef, (node)=>setButton(node)
    );
    const hasConsumerStoppedPropagationRef = (0,react.useRef)(false); // We set this to true by default so that events bubble to forms without JS (SSR)
    const isFormControl = button ? Boolean(button.closest('form')) : true;
    return /*#__PURE__*/ (0,react.createElement)($ce77a8961b41be9e$var$RadioProvider, {
        scope: __scopeRadio,
        checked: checked,
        disabled: disabled
    }, /*#__PURE__*/ (0,react.createElement)(react_primitive_dist/* Primitive.button */.WV.button, (0,esm_extends/* default */.Z)({
        type: "button",
        role: "radio",
        "aria-checked": checked,
        "data-state": $ce77a8961b41be9e$var$getState(checked),
        "data-disabled": disabled ? '' : undefined,
        disabled: disabled,
        value: value
    }, radioProps, {
        ref: composedRefs,
        onClick: (0,dist/* composeEventHandlers */.M)(props.onClick, (event)=>{
            // radios cannot be unchecked so we only communicate a checked state
            if (!checked) onCheck === null || onCheck === void 0 || onCheck();
            if (isFormControl) {
                hasConsumerStoppedPropagationRef.current = event.isPropagationStopped(); // if radio is in a form, stop propagation from the button so that we only propagate
                // one click event (from the input). We propagate changes from an input so that native
                // form validation works and form events reflect radio updates.
                if (!hasConsumerStoppedPropagationRef.current) event.stopPropagation();
            }
        })
    })), isFormControl && /*#__PURE__*/ (0,react.createElement)($ce77a8961b41be9e$var$BubbleInput, {
        control: button,
        bubbles: !hasConsumerStoppedPropagationRef.current,
        name: name,
        value: value,
        checked: checked,
        required: required,
        disabled: disabled // We transform because the input is absolutely positioned but we have
        ,
        style: {
            transform: 'translateX(-100%)'
        }
    }));
});
/*#__PURE__*/ Object.assign($ce77a8961b41be9e$export$d7b12c4107be0d61, {
    displayName: $ce77a8961b41be9e$var$RADIO_NAME
});
/* -------------------------------------------------------------------------------------------------
 * RadioIndicator
 * -----------------------------------------------------------------------------------------------*/ const $ce77a8961b41be9e$var$INDICATOR_NAME = 'RadioIndicator';
const $ce77a8961b41be9e$export$d35a9ffa9a04f9e7 = /*#__PURE__*/ (0,react.forwardRef)((props, forwardedRef)=>{
    const { __scopeRadio: __scopeRadio , forceMount: forceMount , ...indicatorProps } = props;
    const context = $ce77a8961b41be9e$var$useRadioContext($ce77a8961b41be9e$var$INDICATOR_NAME, __scopeRadio);
    return /*#__PURE__*/ (0,react.createElement)(react_presence_dist/* Presence */.z, {
        present: forceMount || context.checked
    }, /*#__PURE__*/ (0,react.createElement)(react_primitive_dist/* Primitive.span */.WV.span, (0,esm_extends/* default */.Z)({
        "data-state": $ce77a8961b41be9e$var$getState(context.checked),
        "data-disabled": context.disabled ? '' : undefined
    }, indicatorProps, {
        ref: forwardedRef
    })));
});
/*#__PURE__*/ Object.assign($ce77a8961b41be9e$export$d35a9ffa9a04f9e7, {
    displayName: $ce77a8961b41be9e$var$INDICATOR_NAME
});
/* ---------------------------------------------------------------------------------------------- */ const $ce77a8961b41be9e$var$BubbleInput = (props)=>{
    const { control: control , checked: checked , bubbles: bubbles = true , ...inputProps } = props;
    const ref = (0,react.useRef)(null);
    const prevChecked = (0,react_use_previous_dist/* usePrevious */.D)(checked);
    const controlSize = (0,react_use_size_dist/* useSize */.t)(control); // Bubble checked change to parents (e.g form change event)
    (0,react.useEffect)(()=>{
        const input = ref.current;
        const inputProto = window.HTMLInputElement.prototype;
        const descriptor = Object.getOwnPropertyDescriptor(inputProto, 'checked');
        const setChecked = descriptor.set;
        if (prevChecked !== checked && setChecked) {
            const event = new Event('click', {
                bubbles: bubbles
            });
            setChecked.call(input, checked);
            input.dispatchEvent(event);
        }
    }, [
        prevChecked,
        checked,
        bubbles
    ]);
    return /*#__PURE__*/ (0,react.createElement)("input", (0,esm_extends/* default */.Z)({
        type: "radio",
        "aria-hidden": true,
        defaultChecked: checked
    }, inputProps, {
        tabIndex: -1,
        ref: ref,
        style: {
            ...props.style,
            ...controlSize,
            position: 'absolute',
            pointerEvents: 'none',
            opacity: 0,
            margin: 0
        }
    }));
};
function $ce77a8961b41be9e$var$getState(checked) {
    return checked ? 'checked' : 'unchecked';
}


const $f99a8c78507165f7$var$ARROW_KEYS = [
    'ArrowUp',
    'ArrowDown',
    'ArrowLeft',
    'ArrowRight'
];
/* -------------------------------------------------------------------------------------------------
 * RadioGroup
 * -----------------------------------------------------------------------------------------------*/ const $f99a8c78507165f7$var$RADIO_GROUP_NAME = 'RadioGroup';
const [$f99a8c78507165f7$var$createRadioGroupContext, $f99a8c78507165f7$export$c547093f11b76da2] = (0,react_context_dist/* createContextScope */.b)($f99a8c78507165f7$var$RADIO_GROUP_NAME, [
    react_roving_focus_dist/* createRovingFocusGroupScope */.Pc,
    $ce77a8961b41be9e$export$67d2296460f1b002
]);
const $f99a8c78507165f7$var$useRovingFocusGroupScope = (0,react_roving_focus_dist/* createRovingFocusGroupScope */.Pc)();
const $f99a8c78507165f7$var$useRadioScope = $ce77a8961b41be9e$export$67d2296460f1b002();
const [$f99a8c78507165f7$var$RadioGroupProvider, $f99a8c78507165f7$var$useRadioGroupContext] = $f99a8c78507165f7$var$createRadioGroupContext($f99a8c78507165f7$var$RADIO_GROUP_NAME);
const $f99a8c78507165f7$export$a98f0dcb43a68a25 = /*#__PURE__*/ (0,react.forwardRef)((props, forwardedRef)=>{
    const { __scopeRadioGroup: __scopeRadioGroup , name: name , defaultValue: defaultValue , value: valueProp , required: required = false , disabled: disabled = false , orientation: orientation , dir: dir , loop: loop = true , onValueChange: onValueChange , ...groupProps } = props;
    const rovingFocusGroupScope = $f99a8c78507165f7$var$useRovingFocusGroupScope(__scopeRadioGroup);
    const direction = (0,react_direction_dist/* useDirection */.gm)(dir);
    const [value, setValue] = (0,react_use_controllable_state_dist/* useControllableState */.T)({
        prop: valueProp,
        defaultProp: defaultValue,
        onChange: onValueChange
    });
    return /*#__PURE__*/ (0,react.createElement)($f99a8c78507165f7$var$RadioGroupProvider, {
        scope: __scopeRadioGroup,
        name: name,
        required: required,
        disabled: disabled,
        value: value,
        onValueChange: setValue
    }, /*#__PURE__*/ (0,react.createElement)(react_roving_focus_dist/* Root */.fC, (0,esm_extends/* default */.Z)({
        asChild: true
    }, rovingFocusGroupScope, {
        orientation: orientation,
        dir: direction,
        loop: loop
    }), /*#__PURE__*/ (0,react.createElement)(react_primitive_dist/* Primitive.div */.WV.div, (0,esm_extends/* default */.Z)({
        role: "radiogroup",
        "aria-required": required,
        "aria-orientation": orientation,
        "data-disabled": disabled ? '' : undefined,
        dir: direction
    }, groupProps, {
        ref: forwardedRef
    }))));
});
/*#__PURE__*/ Object.assign($f99a8c78507165f7$export$a98f0dcb43a68a25, {
    displayName: $f99a8c78507165f7$var$RADIO_GROUP_NAME
});
/* -------------------------------------------------------------------------------------------------
 * RadioGroupItem
 * -----------------------------------------------------------------------------------------------*/ const $f99a8c78507165f7$var$ITEM_NAME = 'RadioGroupItem';
const $f99a8c78507165f7$export$9f866c100ef519e4 = /*#__PURE__*/ (0,react.forwardRef)((props, forwardedRef)=>{
    const { __scopeRadioGroup: __scopeRadioGroup , disabled: disabled , ...itemProps } = props;
    const context = $f99a8c78507165f7$var$useRadioGroupContext($f99a8c78507165f7$var$ITEM_NAME, __scopeRadioGroup);
    const isDisabled = context.disabled || disabled;
    const rovingFocusGroupScope = $f99a8c78507165f7$var$useRovingFocusGroupScope(__scopeRadioGroup);
    const radioScope = $f99a8c78507165f7$var$useRadioScope(__scopeRadioGroup);
    const ref = (0,react.useRef)(null);
    const composedRefs = (0,react_compose_refs_dist/* useComposedRefs */.e)(forwardedRef, ref);
    const checked = context.value === itemProps.value;
    const isArrowKeyPressedRef = (0,react.useRef)(false);
    (0,react.useEffect)(()=>{
        const handleKeyDown = (event)=>{
            if ($f99a8c78507165f7$var$ARROW_KEYS.includes(event.key)) isArrowKeyPressedRef.current = true;
        };
        const handleKeyUp = ()=>isArrowKeyPressedRef.current = false
        ;
        document.addEventListener('keydown', handleKeyDown);
        document.addEventListener('keyup', handleKeyUp);
        return ()=>{
            document.removeEventListener('keydown', handleKeyDown);
            document.removeEventListener('keyup', handleKeyUp);
        };
    }, []);
    return /*#__PURE__*/ (0,react.createElement)(react_roving_focus_dist/* Item */.ck, (0,esm_extends/* default */.Z)({
        asChild: true
    }, rovingFocusGroupScope, {
        focusable: !isDisabled,
        active: checked
    }), /*#__PURE__*/ (0,react.createElement)($ce77a8961b41be9e$export$d7b12c4107be0d61, (0,esm_extends/* default */.Z)({
        disabled: isDisabled,
        required: context.required,
        checked: checked
    }, radioScope, itemProps, {
        name: context.name,
        ref: composedRefs,
        onCheck: ()=>context.onValueChange(itemProps.value)
        ,
        onKeyDown: (0,dist/* composeEventHandlers */.M)((event)=>{
            // According to WAI ARIA, radio groups don't activate items on enter keypress
            if (event.key === 'Enter') event.preventDefault();
        }),
        onFocus: (0,dist/* composeEventHandlers */.M)(itemProps.onFocus, ()=>{
            var _ref$current;
            /**
       * Our `RovingFocusGroup` will focus the radio when navigating with arrow keys
       * and we need to "check" it in that case. We click it to "check" it (instead
       * of updating `context.value`) so that the radio change event fires.
       */ if (isArrowKeyPressedRef.current) (_ref$current = ref.current) === null || _ref$current === void 0 || _ref$current.click();
        })
    })));
});
/*#__PURE__*/ Object.assign($f99a8c78507165f7$export$9f866c100ef519e4, {
    displayName: $f99a8c78507165f7$var$ITEM_NAME
});
/* -------------------------------------------------------------------------------------------------
 * RadioGroupIndicator
 * -----------------------------------------------------------------------------------------------*/ const $f99a8c78507165f7$var$INDICATOR_NAME = 'RadioGroupIndicator';
const $f99a8c78507165f7$export$5fb54c671a65c88 = /*#__PURE__*/ (0,react.forwardRef)((props, forwardedRef)=>{
    const { __scopeRadioGroup: __scopeRadioGroup , ...indicatorProps } = props;
    const radioScope = $f99a8c78507165f7$var$useRadioScope(__scopeRadioGroup);
    return /*#__PURE__*/ (0,react.createElement)($ce77a8961b41be9e$export$d35a9ffa9a04f9e7, (0,esm_extends/* default */.Z)({}, radioScope, indicatorProps, {
        ref: forwardedRef
    }));
});
/*#__PURE__*/ Object.assign($f99a8c78507165f7$export$5fb54c671a65c88, {
    displayName: $f99a8c78507165f7$var$INDICATOR_NAME
});
/* ---------------------------------------------------------------------------------------------- */ const $f99a8c78507165f7$export$be92b6f5f03c0fe9 = $f99a8c78507165f7$export$a98f0dcb43a68a25;
const $f99a8c78507165f7$export$6d08773d2e66f8f2 = $f99a8c78507165f7$export$9f866c100ef519e4;
const $f99a8c78507165f7$export$adb584737d712b70 = $f99a8c78507165f7$export$5fb54c671a65c88;





//# sourceMappingURL=index.mjs.map

// EXTERNAL MODULE: ./node_modules/lucide-react/dist/esm/icons/circle.js
var circle = __webpack_require__(50316);
// EXTERNAL MODULE: ./app/lib/utils.ts + 1 modules
var utils = __webpack_require__(73848);
;// CONCATENATED MODULE: ./app/components/ui/radio-group.tsx





const RadioGroup = /*#__PURE__*/ react.forwardRef((param, ref)=>{
    let { className , ...props } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)($f99a8c78507165f7$export$be92b6f5f03c0fe9, {
        className: (0,utils.cn)("grid gap-2", className),
        ...props,
        ref: ref
    });
});
RadioGroup.displayName = $f99a8c78507165f7$export$be92b6f5f03c0fe9.displayName;
const RadioGroupItem = /*#__PURE__*/ react.forwardRef((param, ref)=>{
    let { className , ...props } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)($f99a8c78507165f7$export$6d08773d2e66f8f2, {
        ref: ref,
        className: (0,utils.cn)("aspect-square h-[18px] w-[18px] rounded-full border border-[2px] border-black/10 dark:border-white/10 dark:data-[state=checked]:border-main-01 data-[state=checked]:border-main-01 ring-offset-background focus:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50", className),
        ...props,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)($f99a8c78507165f7$export$adb584737d712b70, {
            className: "flex items-center justify-center",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(circle/* default */.Z, {
                className: "h-2.5 w-2.5 fill-main-01 text-main-01"
            })
        })
    });
});
RadioGroupItem.displayName = $f99a8c78507165f7$export$6d08773d2e66f8f2.displayName;



/***/ }),

/***/ 36128:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "x": function() { return /* binding */ ScrollArea; }
/* harmony export */ });
/* unused harmony export ScrollBar */
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(41844);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(55784);
/* harmony import */ var _radix_ui_react_scroll_area__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(25443);
/* harmony import */ var _lib_utils__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(73848);




const ScrollArea = /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_1__.forwardRef((param, ref)=>/*#__PURE__*/ {
    let { className , children , ...props } = param;
    return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_radix_ui_react_scroll_area__WEBPACK_IMPORTED_MODULE_2__/* .Root */ .fC, {
        ref: ref,
        className: (0,_lib_utils__WEBPACK_IMPORTED_MODULE_3__.cn)("relative overflow-hidden", className),
        ...props,
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_radix_ui_react_scroll_area__WEBPACK_IMPORTED_MODULE_2__/* .Viewport */ .l_, {
                className: "h-full w-full rounded-[inherit]",
                children: children
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(ScrollBar, {}),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_radix_ui_react_scroll_area__WEBPACK_IMPORTED_MODULE_2__/* .Corner */ .Ns, {})
        ]
    });
});
ScrollArea.displayName = _radix_ui_react_scroll_area__WEBPACK_IMPORTED_MODULE_2__/* .Root.displayName */ .fC.displayName;
const ScrollBar = /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_1__.forwardRef((param, ref)=>/*#__PURE__*/ {
    let { className , orientation ="vertical" , ...props } = param;
    return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_radix_ui_react_scroll_area__WEBPACK_IMPORTED_MODULE_2__/* .ScrollAreaScrollbar */ .gb, {
        ref: ref,
        orientation: orientation,
        className: (0,_lib_utils__WEBPACK_IMPORTED_MODULE_3__.cn)("flex touch-none select-none transition-colors", orientation === "vertical" && "h-full w-2.5 border-l border-l-transparent p-[1px]", orientation === "horizontal" && "h-2.5 flex-col border-t border-t-transparent p-[1px]", className),
        ...props,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_radix_ui_react_scroll_area__WEBPACK_IMPORTED_MODULE_2__/* .ScrollAreaThumb */ .q4, {
            className: "relative flex-1 rounded-full bg-border"
        })
    });
});
ScrollBar.displayName = _radix_ui_react_scroll_area__WEBPACK_IMPORTED_MODULE_2__/* .ScrollAreaScrollbar.displayName */ .gb.displayName;



/***/ }),

/***/ 80522:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Ph": function() { return /* binding */ Select; },
  "Bw": function() { return /* binding */ SelectContent; },
  "Ql": function() { return /* binding */ SelectItem; },
  "i4": function() { return /* binding */ SelectTrigger; },
  "ki": function() { return /* binding */ SelectValue; }
});

// UNUSED EXPORTS: SelectGroup, SelectLabel, SelectScrollDownButton, SelectScrollUpButton, SelectSeparator

// EXTERNAL MODULE: ./node_modules/next/dist/compiled/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(41844);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/react/index.js
var react = __webpack_require__(55784);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__(87462);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/react-dom/index.js
var react_dom = __webpack_require__(18369);
// EXTERNAL MODULE: ./node_modules/@radix-ui/number/dist/index.mjs
var dist = __webpack_require__(42614);
// EXTERNAL MODULE: ./node_modules/@radix-ui/primitive/dist/index.mjs
var primitive_dist = __webpack_require__(36206);
// EXTERNAL MODULE: ./node_modules/@radix-ui/react-collection/dist/index.mjs
var react_collection_dist = __webpack_require__(65936);
// EXTERNAL MODULE: ./node_modules/@radix-ui/react-compose-refs/dist/index.mjs
var react_compose_refs_dist = __webpack_require__(28771);
// EXTERNAL MODULE: ./node_modules/@radix-ui/react-context/dist/index.mjs
var react_context_dist = __webpack_require__(25360);
// EXTERNAL MODULE: ./node_modules/@radix-ui/react-direction/dist/index.mjs
var react_direction_dist = __webpack_require__(78990);
// EXTERNAL MODULE: ./node_modules/@radix-ui/react-dismissable-layer/dist/index.mjs + 1 modules
var react_dismissable_layer_dist = __webpack_require__(46063);
// EXTERNAL MODULE: ./node_modules/@radix-ui/react-focus-guards/dist/index.mjs
var react_focus_guards_dist = __webpack_require__(27552);
// EXTERNAL MODULE: ./node_modules/@radix-ui/react-focus-scope/dist/index.mjs
var react_focus_scope_dist = __webpack_require__(95420);
// EXTERNAL MODULE: ./node_modules/@radix-ui/react-id/dist/index.mjs
var react_id_dist = __webpack_require__(91276);
// EXTERNAL MODULE: ./node_modules/@radix-ui/react-popper/dist/index.mjs + 6 modules
var react_popper_dist = __webpack_require__(6565);
// EXTERNAL MODULE: ./node_modules/@radix-ui/react-portal/dist/index.mjs
var react_portal_dist = __webpack_require__(42651);
// EXTERNAL MODULE: ./node_modules/@radix-ui/react-primitive/dist/index.mjs
var react_primitive_dist = __webpack_require__(75320);
// EXTERNAL MODULE: ./node_modules/@radix-ui/react-slot/dist/index.mjs
var react_slot_dist = __webpack_require__(88426);
// EXTERNAL MODULE: ./node_modules/@radix-ui/react-use-callback-ref/dist/index.mjs
var react_use_callback_ref_dist = __webpack_require__(79698);
// EXTERNAL MODULE: ./node_modules/@radix-ui/react-use-controllable-state/dist/index.mjs
var react_use_controllable_state_dist = __webpack_require__(77342);
// EXTERNAL MODULE: ./node_modules/@radix-ui/react-use-layout-effect/dist/index.mjs
var react_use_layout_effect_dist = __webpack_require__(9981);
// EXTERNAL MODULE: ./node_modules/@radix-ui/react-use-previous/dist/index.mjs
var react_use_previous_dist = __webpack_require__(57898);
// EXTERNAL MODULE: ./node_modules/@radix-ui/react-visually-hidden/dist/index.mjs
var react_visually_hidden_dist = __webpack_require__(96219);
// EXTERNAL MODULE: ./node_modules/aria-hidden/dist/es2015/index.js
var es2015 = __webpack_require__(23541);
// EXTERNAL MODULE: ./node_modules/react-remove-scroll/dist/es2015/Combination.js + 21 modules
var Combination = __webpack_require__(6223);
;// CONCATENATED MODULE: ./node_modules/@radix-ui/react-select/dist/index.mjs


















































const $cc7e05a45900e73f$var$OPEN_KEYS = [
    ' ',
    'Enter',
    'ArrowUp',
    'ArrowDown'
];
const $cc7e05a45900e73f$var$SELECTION_KEYS = [
    ' ',
    'Enter'
];
/* -------------------------------------------------------------------------------------------------
 * Select
 * -----------------------------------------------------------------------------------------------*/ const $cc7e05a45900e73f$var$SELECT_NAME = 'Select';
const [$cc7e05a45900e73f$var$Collection, $cc7e05a45900e73f$var$useCollection, $cc7e05a45900e73f$var$createCollectionScope] = (0,react_collection_dist/* createCollection */.B)($cc7e05a45900e73f$var$SELECT_NAME);
const [$cc7e05a45900e73f$var$createSelectContext, $cc7e05a45900e73f$export$286727a75dc039bd] = (0,react_context_dist/* createContextScope */.b)($cc7e05a45900e73f$var$SELECT_NAME, [
    $cc7e05a45900e73f$var$createCollectionScope,
    react_popper_dist/* createPopperScope */.D7
]);
const $cc7e05a45900e73f$var$usePopperScope = (0,react_popper_dist/* createPopperScope */.D7)();
const [$cc7e05a45900e73f$var$SelectProvider, $cc7e05a45900e73f$var$useSelectContext] = $cc7e05a45900e73f$var$createSelectContext($cc7e05a45900e73f$var$SELECT_NAME);
const [$cc7e05a45900e73f$var$SelectNativeOptionsProvider, $cc7e05a45900e73f$var$useSelectNativeOptionsContext] = $cc7e05a45900e73f$var$createSelectContext($cc7e05a45900e73f$var$SELECT_NAME);
const $cc7e05a45900e73f$export$ef9b1a59e592288f = (props)=>{
    const { __scopeSelect: __scopeSelect , children: children , open: openProp , defaultOpen: defaultOpen , onOpenChange: onOpenChange , value: valueProp , defaultValue: defaultValue , onValueChange: onValueChange , dir: dir , name: name , autoComplete: autoComplete , disabled: disabled , required: required  } = props;
    const popperScope = $cc7e05a45900e73f$var$usePopperScope(__scopeSelect);
    const [trigger, setTrigger] = (0,react.useState)(null);
    const [valueNode, setValueNode] = (0,react.useState)(null);
    const [valueNodeHasChildren, setValueNodeHasChildren] = (0,react.useState)(false);
    const direction = (0,react_direction_dist/* useDirection */.gm)(dir);
    const [open = false, setOpen] = (0,react_use_controllable_state_dist/* useControllableState */.T)({
        prop: openProp,
        defaultProp: defaultOpen,
        onChange: onOpenChange
    });
    const [value, setValue] = (0,react_use_controllable_state_dist/* useControllableState */.T)({
        prop: valueProp,
        defaultProp: defaultValue,
        onChange: onValueChange
    });
    const triggerPointerDownPosRef = (0,react.useRef)(null); // We set this to true by default so that events bubble to forms without JS (SSR)
    const isFormControl = trigger ? Boolean(trigger.closest('form')) : true;
    const [nativeOptionsSet, setNativeOptionsSet] = (0,react.useState)(new Set()); // The native `select` only associates the correct default value if the corresponding
    // `option` is rendered as a child **at the same time** as itself.
    // Because it might take a few renders for our items to gather the information to build
    // the native `option`(s), we generate a key on the `select` to make sure React re-builds it
    // each time the options change.
    const nativeSelectKey = Array.from(nativeOptionsSet).map((option)=>option.props.value
    ).join(';');
    return /*#__PURE__*/ (0,react.createElement)(react_popper_dist/* Root */.fC, popperScope, /*#__PURE__*/ (0,react.createElement)($cc7e05a45900e73f$var$SelectProvider, {
        required: required,
        scope: __scopeSelect,
        trigger: trigger,
        onTriggerChange: setTrigger,
        valueNode: valueNode,
        onValueNodeChange: setValueNode,
        valueNodeHasChildren: valueNodeHasChildren,
        onValueNodeHasChildrenChange: setValueNodeHasChildren,
        contentId: (0,react_id_dist/* useId */.M)(),
        value: value,
        onValueChange: setValue,
        open: open,
        onOpenChange: setOpen,
        dir: direction,
        triggerPointerDownPosRef: triggerPointerDownPosRef,
        disabled: disabled
    }, /*#__PURE__*/ (0,react.createElement)($cc7e05a45900e73f$var$Collection.Provider, {
        scope: __scopeSelect
    }, /*#__PURE__*/ (0,react.createElement)($cc7e05a45900e73f$var$SelectNativeOptionsProvider, {
        scope: props.__scopeSelect,
        onNativeOptionAdd: (0,react.useCallback)((option)=>{
            setNativeOptionsSet((prev)=>new Set(prev).add(option)
            );
        }, []),
        onNativeOptionRemove: (0,react.useCallback)((option)=>{
            setNativeOptionsSet((prev)=>{
                const optionsSet = new Set(prev);
                optionsSet.delete(option);
                return optionsSet;
            });
        }, [])
    }, children)), isFormControl ? /*#__PURE__*/ (0,react.createElement)($cc7e05a45900e73f$var$BubbleSelect, {
        key: nativeSelectKey,
        "aria-hidden": true,
        required: required,
        tabIndex: -1,
        name: name,
        autoComplete: autoComplete,
        value: value // enable form autofill
        ,
        onChange: (event)=>setValue(event.target.value)
        ,
        disabled: disabled
    }, value === undefined ? /*#__PURE__*/ (0,react.createElement)("option", {
        value: ""
    }) : null, Array.from(nativeOptionsSet)) : null));
};
/*#__PURE__*/ Object.assign($cc7e05a45900e73f$export$ef9b1a59e592288f, {
    displayName: $cc7e05a45900e73f$var$SELECT_NAME
});
/* -------------------------------------------------------------------------------------------------
 * SelectTrigger
 * -----------------------------------------------------------------------------------------------*/ const $cc7e05a45900e73f$var$TRIGGER_NAME = 'SelectTrigger';
const $cc7e05a45900e73f$export$3ac1e88a1c0b9f1 = /*#__PURE__*/ (0,react.forwardRef)((props, forwardedRef)=>{
    const { __scopeSelect: __scopeSelect , disabled: disabled = false , ...triggerProps } = props;
    const popperScope = $cc7e05a45900e73f$var$usePopperScope(__scopeSelect);
    const context = $cc7e05a45900e73f$var$useSelectContext($cc7e05a45900e73f$var$TRIGGER_NAME, __scopeSelect);
    const isDisabled = context.disabled || disabled;
    const composedRefs = (0,react_compose_refs_dist/* useComposedRefs */.e)(forwardedRef, context.onTriggerChange);
    const getItems = $cc7e05a45900e73f$var$useCollection(__scopeSelect);
    const [searchRef, handleTypeaheadSearch, resetTypeahead] = $cc7e05a45900e73f$var$useTypeaheadSearch((search)=>{
        const enabledItems = getItems().filter((item)=>!item.disabled
        );
        const currentItem = enabledItems.find((item)=>item.value === context.value
        );
        const nextItem = $cc7e05a45900e73f$var$findNextItem(enabledItems, search, currentItem);
        if (nextItem !== undefined) context.onValueChange(nextItem.value);
    });
    const handleOpen = ()=>{
        if (!isDisabled) {
            context.onOpenChange(true); // reset typeahead when we open
            resetTypeahead();
        }
    };
    return /*#__PURE__*/ (0,react.createElement)(react_popper_dist/* Anchor */.ee, (0,esm_extends/* default */.Z)({
        asChild: true
    }, popperScope), /*#__PURE__*/ (0,react.createElement)(react_primitive_dist/* Primitive.button */.WV.button, (0,esm_extends/* default */.Z)({
        type: "button",
        role: "combobox",
        "aria-controls": context.contentId,
        "aria-expanded": context.open,
        "aria-required": context.required,
        "aria-autocomplete": "none",
        dir: context.dir,
        "data-state": context.open ? 'open' : 'closed',
        disabled: isDisabled,
        "data-disabled": isDisabled ? '' : undefined,
        "data-placeholder": $cc7e05a45900e73f$var$shouldShowPlaceholder(context.value) ? '' : undefined
    }, triggerProps, {
        ref: composedRefs // Enable compatibility with native label or custom `Label` "click" for Safari:
        ,
        onClick: (0,primitive_dist/* composeEventHandlers */.M)(triggerProps.onClick, (event)=>{
            // Whilst browsers generally have no issue focusing the trigger when clicking
            // on a label, Safari seems to struggle with the fact that there's no `onClick`.
            // We force `focus` in this case. Note: this doesn't create any other side-effect
            // because we are preventing default in `onPointerDown` so effectively
            // this only runs for a label "click"
            event.currentTarget.focus();
        }),
        onPointerDown: (0,primitive_dist/* composeEventHandlers */.M)(triggerProps.onPointerDown, (event)=>{
            // prevent implicit pointer capture
            // https://www.w3.org/TR/pointerevents3/#implicit-pointer-capture
            const target = event.target;
            if (target.hasPointerCapture(event.pointerId)) target.releasePointerCapture(event.pointerId);
             // only call handler if it's the left button (mousedown gets triggered by all mouse buttons)
            // but not when the control key is pressed (avoiding MacOS right click)
            if (event.button === 0 && event.ctrlKey === false) {
                handleOpen();
                context.triggerPointerDownPosRef.current = {
                    x: Math.round(event.pageX),
                    y: Math.round(event.pageY)
                }; // prevent trigger from stealing focus from the active item after opening.
                event.preventDefault();
            }
        }),
        onKeyDown: (0,primitive_dist/* composeEventHandlers */.M)(triggerProps.onKeyDown, (event)=>{
            const isTypingAhead = searchRef.current !== '';
            const isModifierKey = event.ctrlKey || event.altKey || event.metaKey;
            if (!isModifierKey && event.key.length === 1) handleTypeaheadSearch(event.key);
            if (isTypingAhead && event.key === ' ') return;
            if ($cc7e05a45900e73f$var$OPEN_KEYS.includes(event.key)) {
                handleOpen();
                event.preventDefault();
            }
        })
    })));
});
/*#__PURE__*/ Object.assign($cc7e05a45900e73f$export$3ac1e88a1c0b9f1, {
    displayName: $cc7e05a45900e73f$var$TRIGGER_NAME
});
/* -------------------------------------------------------------------------------------------------
 * SelectValue
 * -----------------------------------------------------------------------------------------------*/ const $cc7e05a45900e73f$var$VALUE_NAME = 'SelectValue';
const $cc7e05a45900e73f$export$e288731fd71264f0 = /*#__PURE__*/ (0,react.forwardRef)((props, forwardedRef)=>{
    // We ignore `className` and `style` as this part shouldn't be styled.
    const { __scopeSelect: __scopeSelect , className: className , style: style , children: children , placeholder: placeholder = '' , ...valueProps } = props;
    const context = $cc7e05a45900e73f$var$useSelectContext($cc7e05a45900e73f$var$VALUE_NAME, __scopeSelect);
    const { onValueNodeHasChildrenChange: onValueNodeHasChildrenChange  } = context;
    const hasChildren = children !== undefined;
    const composedRefs = (0,react_compose_refs_dist/* useComposedRefs */.e)(forwardedRef, context.onValueNodeChange);
    (0,react_use_layout_effect_dist/* useLayoutEffect */.b)(()=>{
        onValueNodeHasChildrenChange(hasChildren);
    }, [
        onValueNodeHasChildrenChange,
        hasChildren
    ]);
    return /*#__PURE__*/ (0,react.createElement)(react_primitive_dist/* Primitive.span */.WV.span, (0,esm_extends/* default */.Z)({}, valueProps, {
        ref: composedRefs // we don't want events from the portalled `SelectValue` children to bubble
        ,
        style: {
            pointerEvents: 'none'
        }
    }), $cc7e05a45900e73f$var$shouldShowPlaceholder(context.value) ? /*#__PURE__*/ (0,react.createElement)(react.Fragment, null, placeholder) : children);
});
/*#__PURE__*/ Object.assign($cc7e05a45900e73f$export$e288731fd71264f0, {
    displayName: $cc7e05a45900e73f$var$VALUE_NAME
});
/* -------------------------------------------------------------------------------------------------
 * SelectIcon
 * -----------------------------------------------------------------------------------------------*/ const $cc7e05a45900e73f$var$ICON_NAME = 'SelectIcon';
const $cc7e05a45900e73f$export$99b400cabb58c515 = /*#__PURE__*/ (0,react.forwardRef)((props, forwardedRef)=>{
    const { __scopeSelect: __scopeSelect , children: children , ...iconProps } = props;
    return /*#__PURE__*/ (0,react.createElement)(react_primitive_dist/* Primitive.span */.WV.span, (0,esm_extends/* default */.Z)({
        "aria-hidden": true
    }, iconProps, {
        ref: forwardedRef
    }), children || '▼');
});
/*#__PURE__*/ Object.assign($cc7e05a45900e73f$export$99b400cabb58c515, {
    displayName: $cc7e05a45900e73f$var$ICON_NAME
});
/* -------------------------------------------------------------------------------------------------
 * SelectPortal
 * -----------------------------------------------------------------------------------------------*/ const $cc7e05a45900e73f$var$PORTAL_NAME = 'SelectPortal';
const $cc7e05a45900e73f$export$b2af6c9944296213 = (props)=>{
    return /*#__PURE__*/ (0,react.createElement)(react_portal_dist/* Portal */.h, (0,esm_extends/* default */.Z)({
        asChild: true
    }, props));
};
/*#__PURE__*/ Object.assign($cc7e05a45900e73f$export$b2af6c9944296213, {
    displayName: $cc7e05a45900e73f$var$PORTAL_NAME
});
/* -------------------------------------------------------------------------------------------------
 * SelectContent
 * -----------------------------------------------------------------------------------------------*/ const $cc7e05a45900e73f$var$CONTENT_NAME = 'SelectContent';
const $cc7e05a45900e73f$export$c973a4b3cb86a03d = /*#__PURE__*/ (0,react.forwardRef)((props, forwardedRef)=>{
    const context = $cc7e05a45900e73f$var$useSelectContext($cc7e05a45900e73f$var$CONTENT_NAME, props.__scopeSelect);
    const [fragment, setFragment] = (0,react.useState)(); // setting the fragment in `useLayoutEffect` as `DocumentFragment` doesn't exist on the server
    (0,react_use_layout_effect_dist/* useLayoutEffect */.b)(()=>{
        setFragment(new DocumentFragment());
    }, []);
    if (!context.open) {
        const frag = fragment;
        return frag ? /*#__PURE__*/ (0,react_dom.createPortal)(/*#__PURE__*/ (0,react.createElement)($cc7e05a45900e73f$var$SelectContentProvider, {
            scope: props.__scopeSelect
        }, /*#__PURE__*/ (0,react.createElement)($cc7e05a45900e73f$var$Collection.Slot, {
            scope: props.__scopeSelect
        }, /*#__PURE__*/ (0,react.createElement)("div", null, props.children))), frag) : null;
    }
    return /*#__PURE__*/ (0,react.createElement)($cc7e05a45900e73f$var$SelectContentImpl, (0,esm_extends/* default */.Z)({}, props, {
        ref: forwardedRef
    }));
});
/*#__PURE__*/ Object.assign($cc7e05a45900e73f$export$c973a4b3cb86a03d, {
    displayName: $cc7e05a45900e73f$var$CONTENT_NAME
});
/* -------------------------------------------------------------------------------------------------
 * SelectContentImpl
 * -----------------------------------------------------------------------------------------------*/ const $cc7e05a45900e73f$var$CONTENT_MARGIN = 10;
const [$cc7e05a45900e73f$var$SelectContentProvider, $cc7e05a45900e73f$var$useSelectContentContext] = $cc7e05a45900e73f$var$createSelectContext($cc7e05a45900e73f$var$CONTENT_NAME);
const $cc7e05a45900e73f$var$CONTENT_IMPL_NAME = 'SelectContentImpl';
const $cc7e05a45900e73f$var$SelectContentImpl = /*#__PURE__*/ (0,react.forwardRef)((props, forwardedRef)=>{
    const { __scopeSelect: __scopeSelect , position: position = 'item-aligned' , onCloseAutoFocus: onCloseAutoFocus , onEscapeKeyDown: onEscapeKeyDown , onPointerDownOutside: onPointerDownOutside , side: //
    // PopperContent props
    side , sideOffset: sideOffset , align: align , alignOffset: alignOffset , arrowPadding: arrowPadding , collisionBoundary: collisionBoundary , collisionPadding: collisionPadding , sticky: sticky , hideWhenDetached: hideWhenDetached , avoidCollisions: avoidCollisions , //
    ...contentProps } = props;
    const context = $cc7e05a45900e73f$var$useSelectContext($cc7e05a45900e73f$var$CONTENT_NAME, __scopeSelect);
    const [content, setContent] = (0,react.useState)(null);
    const [viewport, setViewport] = (0,react.useState)(null);
    const composedRefs = (0,react_compose_refs_dist/* useComposedRefs */.e)(forwardedRef, (node)=>setContent(node)
    );
    const [selectedItem, setSelectedItem] = (0,react.useState)(null);
    const [selectedItemText, setSelectedItemText] = (0,react.useState)(null);
    const getItems = $cc7e05a45900e73f$var$useCollection(__scopeSelect);
    const [isPositioned, setIsPositioned] = (0,react.useState)(false);
    const firstValidItemFoundRef = (0,react.useRef)(false); // aria-hide everything except the content (better supported equivalent to setting aria-modal)
    (0,react.useEffect)(()=>{
        if (content) return (0,es2015/* hideOthers */.Ry)(content);
    }, [
        content
    ]); // Make sure the whole tree has focus guards as our `Select` may be
    // the last element in the DOM (because of the `Portal`)
    (0,react_focus_guards_dist/* useFocusGuards */.EW)();
    const focusFirst = (0,react.useCallback)((candidates)=>{
        const [firstItem, ...restItems] = getItems().map((item)=>item.ref.current
        );
        const [lastItem] = restItems.slice(-1);
        const PREVIOUSLY_FOCUSED_ELEMENT = document.activeElement;
        for (const candidate of candidates){
            // if focus is already where we want to go, we don't want to keep going through the candidates
            if (candidate === PREVIOUSLY_FOCUSED_ELEMENT) return;
            candidate === null || candidate === void 0 || candidate.scrollIntoView({
                block: 'nearest'
            }); // viewport might have padding so scroll to its edges when focusing first/last items.
            if (candidate === firstItem && viewport) viewport.scrollTop = 0;
            if (candidate === lastItem && viewport) viewport.scrollTop = viewport.scrollHeight;
            candidate === null || candidate === void 0 || candidate.focus();
            if (document.activeElement !== PREVIOUSLY_FOCUSED_ELEMENT) return;
        }
    }, [
        getItems,
        viewport
    ]);
    const focusSelectedItem = (0,react.useCallback)(()=>focusFirst([
            selectedItem,
            content
        ])
    , [
        focusFirst,
        selectedItem,
        content
    ]); // Since this is not dependent on layout, we want to ensure this runs at the same time as
    // other effects across components. Hence why we don't call `focusSelectedItem` inside `position`.
    (0,react.useEffect)(()=>{
        if (isPositioned) focusSelectedItem();
    }, [
        isPositioned,
        focusSelectedItem
    ]); // prevent selecting items on `pointerup` in some cases after opening from `pointerdown`
    // and close on `pointerup` outside.
    const { onOpenChange: onOpenChange , triggerPointerDownPosRef: triggerPointerDownPosRef  } = context;
    (0,react.useEffect)(()=>{
        if (content) {
            let pointerMoveDelta = {
                x: 0,
                y: 0
            };
            const handlePointerMove = (event)=>{
                var _triggerPointerDownPo, _triggerPointerDownPo2, _triggerPointerDownPo3, _triggerPointerDownPo4;
                pointerMoveDelta = {
                    x: Math.abs(Math.round(event.pageX) - ((_triggerPointerDownPo = (_triggerPointerDownPo2 = triggerPointerDownPosRef.current) === null || _triggerPointerDownPo2 === void 0 ? void 0 : _triggerPointerDownPo2.x) !== null && _triggerPointerDownPo !== void 0 ? _triggerPointerDownPo : 0)),
                    y: Math.abs(Math.round(event.pageY) - ((_triggerPointerDownPo3 = (_triggerPointerDownPo4 = triggerPointerDownPosRef.current) === null || _triggerPointerDownPo4 === void 0 ? void 0 : _triggerPointerDownPo4.y) !== null && _triggerPointerDownPo3 !== void 0 ? _triggerPointerDownPo3 : 0))
                };
            };
            const handlePointerUp = (event)=>{
                // If the pointer hasn't moved by a certain threshold then we prevent selecting item on `pointerup`.
                if (pointerMoveDelta.x <= 10 && pointerMoveDelta.y <= 10) event.preventDefault();
                else // otherwise, if the event was outside the content, close.
                if (!content.contains(event.target)) onOpenChange(false);
                document.removeEventListener('pointermove', handlePointerMove);
                triggerPointerDownPosRef.current = null;
            };
            if (triggerPointerDownPosRef.current !== null) {
                document.addEventListener('pointermove', handlePointerMove);
                document.addEventListener('pointerup', handlePointerUp, {
                    capture: true,
                    once: true
                });
            }
            return ()=>{
                document.removeEventListener('pointermove', handlePointerMove);
                document.removeEventListener('pointerup', handlePointerUp, {
                    capture: true
                });
            };
        }
    }, [
        content,
        onOpenChange,
        triggerPointerDownPosRef
    ]);
    (0,react.useEffect)(()=>{
        const close = ()=>onOpenChange(false)
        ;
        window.addEventListener('blur', close);
        window.addEventListener('resize', close);
        return ()=>{
            window.removeEventListener('blur', close);
            window.removeEventListener('resize', close);
        };
    }, [
        onOpenChange
    ]);
    const [searchRef, handleTypeaheadSearch] = $cc7e05a45900e73f$var$useTypeaheadSearch((search)=>{
        const enabledItems = getItems().filter((item)=>!item.disabled
        );
        const currentItem = enabledItems.find((item)=>item.ref.current === document.activeElement
        );
        const nextItem = $cc7e05a45900e73f$var$findNextItem(enabledItems, search, currentItem);
        if (nextItem) /**
       * Imperative focus during keydown is risky so we prevent React's batching updates
       * to avoid potential bugs. See: https://github.com/facebook/react/issues/20332
       */ setTimeout(()=>nextItem.ref.current.focus()
        );
    });
    const itemRefCallback = (0,react.useCallback)((node, value, disabled)=>{
        const isFirstValidItem = !firstValidItemFoundRef.current && !disabled;
        const isSelectedItem = context.value !== undefined && context.value === value;
        if (isSelectedItem || isFirstValidItem) {
            setSelectedItem(node);
            if (isFirstValidItem) firstValidItemFoundRef.current = true;
        }
    }, [
        context.value
    ]);
    const handleItemLeave = (0,react.useCallback)(()=>content === null || content === void 0 ? void 0 : content.focus()
    , [
        content
    ]);
    const itemTextRefCallback = (0,react.useCallback)((node, value, disabled)=>{
        const isFirstValidItem = !firstValidItemFoundRef.current && !disabled;
        const isSelectedItem = context.value !== undefined && context.value === value;
        if (isSelectedItem || isFirstValidItem) setSelectedItemText(node);
    }, [
        context.value
    ]);
    const SelectPosition = position === 'popper' ? $cc7e05a45900e73f$var$SelectPopperPosition : $cc7e05a45900e73f$var$SelectItemAlignedPosition; // Silently ignore props that are not supported by `SelectItemAlignedPosition`
    const popperContentProps = SelectPosition === $cc7e05a45900e73f$var$SelectPopperPosition ? {
        side: side,
        sideOffset: sideOffset,
        align: align,
        alignOffset: alignOffset,
        arrowPadding: arrowPadding,
        collisionBoundary: collisionBoundary,
        collisionPadding: collisionPadding,
        sticky: sticky,
        hideWhenDetached: hideWhenDetached,
        avoidCollisions: avoidCollisions
    } : {};
    return /*#__PURE__*/ (0,react.createElement)($cc7e05a45900e73f$var$SelectContentProvider, {
        scope: __scopeSelect,
        content: content,
        viewport: viewport,
        onViewportChange: setViewport,
        itemRefCallback: itemRefCallback,
        selectedItem: selectedItem,
        onItemLeave: handleItemLeave,
        itemTextRefCallback: itemTextRefCallback,
        focusSelectedItem: focusSelectedItem,
        selectedItemText: selectedItemText,
        position: position,
        isPositioned: isPositioned,
        searchRef: searchRef
    }, /*#__PURE__*/ (0,react.createElement)(Combination/* default */.Z, {
        as: react_slot_dist/* Slot */.g7,
        allowPinchZoom: true
    }, /*#__PURE__*/ (0,react.createElement)(react_focus_scope_dist/* FocusScope */.M, {
        asChild: true // we make sure we're not trapping once it's been closed
        ,
        trapped: context.open,
        onMountAutoFocus: (event)=>{
            // we prevent open autofocus because we manually focus the selected item
            event.preventDefault();
        },
        onUnmountAutoFocus: (0,primitive_dist/* composeEventHandlers */.M)(onCloseAutoFocus, (event)=>{
            var _context$trigger;
            (_context$trigger = context.trigger) === null || _context$trigger === void 0 || _context$trigger.focus({
                preventScroll: true
            });
            event.preventDefault();
        })
    }, /*#__PURE__*/ (0,react.createElement)(react_dismissable_layer_dist/* DismissableLayer */.XB, {
        asChild: true,
        disableOutsidePointerEvents: true,
        onEscapeKeyDown: onEscapeKeyDown,
        onPointerDownOutside: onPointerDownOutside // When focus is trapped, a focusout event may still happen.
        ,
        onFocusOutside: (event)=>event.preventDefault()
        ,
        onDismiss: ()=>context.onOpenChange(false)
    }, /*#__PURE__*/ (0,react.createElement)(SelectPosition, (0,esm_extends/* default */.Z)({
        role: "listbox",
        id: context.contentId,
        "data-state": context.open ? 'open' : 'closed',
        dir: context.dir,
        onContextMenu: (event)=>event.preventDefault()
    }, contentProps, popperContentProps, {
        onPlaced: ()=>setIsPositioned(true)
        ,
        ref: composedRefs,
        style: {
            // flex layout so we can place the scroll buttons properly
            display: 'flex',
            flexDirection: 'column',
            // reset the outline by default as the content MAY get focused
            outline: 'none',
            ...contentProps.style
        },
        onKeyDown: (0,primitive_dist/* composeEventHandlers */.M)(contentProps.onKeyDown, (event)=>{
            const isModifierKey = event.ctrlKey || event.altKey || event.metaKey; // select should not be navigated using tab key so we prevent it
            if (event.key === 'Tab') event.preventDefault();
            if (!isModifierKey && event.key.length === 1) handleTypeaheadSearch(event.key);
            if ([
                'ArrowUp',
                'ArrowDown',
                'Home',
                'End'
            ].includes(event.key)) {
                const items = getItems().filter((item)=>!item.disabled
                );
                let candidateNodes = items.map((item)=>item.ref.current
                );
                if ([
                    'ArrowUp',
                    'End'
                ].includes(event.key)) candidateNodes = candidateNodes.slice().reverse();
                if ([
                    'ArrowUp',
                    'ArrowDown'
                ].includes(event.key)) {
                    const currentElement = event.target;
                    const currentIndex = candidateNodes.indexOf(currentElement);
                    candidateNodes = candidateNodes.slice(currentIndex + 1);
                }
                /**
         * Imperative focus during keydown is risky so we prevent React's batching updates
         * to avoid potential bugs. See: https://github.com/facebook/react/issues/20332
         */ setTimeout(()=>focusFirst(candidateNodes)
                );
                event.preventDefault();
            }
        })
    }))))));
});
/*#__PURE__*/ Object.assign($cc7e05a45900e73f$var$SelectContentImpl, {
    displayName: $cc7e05a45900e73f$var$CONTENT_IMPL_NAME
});
/* -------------------------------------------------------------------------------------------------
 * SelectItemAlignedPosition
 * -----------------------------------------------------------------------------------------------*/ const $cc7e05a45900e73f$var$ITEM_ALIGNED_POSITION_NAME = 'SelectItemAlignedPosition';
const $cc7e05a45900e73f$var$SelectItemAlignedPosition = /*#__PURE__*/ (0,react.forwardRef)((props, forwardedRef)=>{
    const { __scopeSelect: __scopeSelect , onPlaced: onPlaced , ...popperProps } = props;
    const context = $cc7e05a45900e73f$var$useSelectContext($cc7e05a45900e73f$var$CONTENT_NAME, __scopeSelect);
    const contentContext = $cc7e05a45900e73f$var$useSelectContentContext($cc7e05a45900e73f$var$CONTENT_NAME, __scopeSelect);
    const [contentWrapper, setContentWrapper] = (0,react.useState)(null);
    const [content, setContent] = (0,react.useState)(null);
    const composedRefs = (0,react_compose_refs_dist/* useComposedRefs */.e)(forwardedRef, (node)=>setContent(node)
    );
    const getItems = $cc7e05a45900e73f$var$useCollection(__scopeSelect);
    const shouldExpandOnScrollRef = (0,react.useRef)(false);
    const shouldRepositionRef = (0,react.useRef)(true);
    const { viewport: viewport , selectedItem: selectedItem , selectedItemText: selectedItemText , focusSelectedItem: focusSelectedItem  } = contentContext;
    const position = (0,react.useCallback)(()=>{
        if (context.trigger && context.valueNode && contentWrapper && content && viewport && selectedItem && selectedItemText) {
            const triggerRect = context.trigger.getBoundingClientRect(); // -----------------------------------------------------------------------------------------
            //  Horizontal positioning
            // -----------------------------------------------------------------------------------------
            const contentRect = content.getBoundingClientRect();
            const valueNodeRect = context.valueNode.getBoundingClientRect();
            const itemTextRect = selectedItemText.getBoundingClientRect();
            if (context.dir !== 'rtl') {
                const itemTextOffset = itemTextRect.left - contentRect.left;
                const left = valueNodeRect.left - itemTextOffset;
                const leftDelta = triggerRect.left - left;
                const minContentWidth = triggerRect.width + leftDelta;
                const contentWidth = Math.max(minContentWidth, contentRect.width);
                const rightEdge = window.innerWidth - $cc7e05a45900e73f$var$CONTENT_MARGIN;
                const clampedLeft = (0,dist/* clamp */.u)(left, [
                    $cc7e05a45900e73f$var$CONTENT_MARGIN,
                    rightEdge - contentWidth
                ]);
                contentWrapper.style.minWidth = minContentWidth + 'px';
                contentWrapper.style.left = clampedLeft + 'px';
            } else {
                const itemTextOffset = contentRect.right - itemTextRect.right;
                const right = window.innerWidth - valueNodeRect.right - itemTextOffset;
                const rightDelta = window.innerWidth - triggerRect.right - right;
                const minContentWidth = triggerRect.width + rightDelta;
                const contentWidth = Math.max(minContentWidth, contentRect.width);
                const leftEdge = window.innerWidth - $cc7e05a45900e73f$var$CONTENT_MARGIN;
                const clampedRight = (0,dist/* clamp */.u)(right, [
                    $cc7e05a45900e73f$var$CONTENT_MARGIN,
                    leftEdge - contentWidth
                ]);
                contentWrapper.style.minWidth = minContentWidth + 'px';
                contentWrapper.style.right = clampedRight + 'px';
            } // -----------------------------------------------------------------------------------------
            // Vertical positioning
            // -----------------------------------------------------------------------------------------
            const items = getItems();
            const availableHeight = window.innerHeight - $cc7e05a45900e73f$var$CONTENT_MARGIN * 2;
            const itemsHeight = viewport.scrollHeight;
            const contentStyles = window.getComputedStyle(content);
            const contentBorderTopWidth = parseInt(contentStyles.borderTopWidth, 10);
            const contentPaddingTop = parseInt(contentStyles.paddingTop, 10);
            const contentBorderBottomWidth = parseInt(contentStyles.borderBottomWidth, 10);
            const contentPaddingBottom = parseInt(contentStyles.paddingBottom, 10);
            const fullContentHeight = contentBorderTopWidth + contentPaddingTop + itemsHeight + contentPaddingBottom + contentBorderBottomWidth; // prettier-ignore
            const minContentHeight = Math.min(selectedItem.offsetHeight * 5, fullContentHeight);
            const viewportStyles = window.getComputedStyle(viewport);
            const viewportPaddingTop = parseInt(viewportStyles.paddingTop, 10);
            const viewportPaddingBottom = parseInt(viewportStyles.paddingBottom, 10);
            const topEdgeToTriggerMiddle = triggerRect.top + triggerRect.height / 2 - $cc7e05a45900e73f$var$CONTENT_MARGIN;
            const triggerMiddleToBottomEdge = availableHeight - topEdgeToTriggerMiddle;
            const selectedItemHalfHeight = selectedItem.offsetHeight / 2;
            const itemOffsetMiddle = selectedItem.offsetTop + selectedItemHalfHeight;
            const contentTopToItemMiddle = contentBorderTopWidth + contentPaddingTop + itemOffsetMiddle;
            const itemMiddleToContentBottom = fullContentHeight - contentTopToItemMiddle;
            const willAlignWithoutTopOverflow = contentTopToItemMiddle <= topEdgeToTriggerMiddle;
            if (willAlignWithoutTopOverflow) {
                const isLastItem = selectedItem === items[items.length - 1].ref.current;
                contentWrapper.style.bottom = "0px";
                const viewportOffsetBottom = content.clientHeight - viewport.offsetTop - viewport.offsetHeight;
                const clampedTriggerMiddleToBottomEdge = Math.max(triggerMiddleToBottomEdge, selectedItemHalfHeight + (isLastItem ? viewportPaddingBottom : 0) + viewportOffsetBottom + contentBorderBottomWidth);
                const height = contentTopToItemMiddle + clampedTriggerMiddleToBottomEdge;
                contentWrapper.style.height = height + 'px';
            } else {
                const isFirstItem = selectedItem === items[0].ref.current;
                contentWrapper.style.top = "0px";
                const clampedTopEdgeToTriggerMiddle = Math.max(topEdgeToTriggerMiddle, contentBorderTopWidth + viewport.offsetTop + (isFirstItem ? viewportPaddingTop : 0) + selectedItemHalfHeight);
                const height = clampedTopEdgeToTriggerMiddle + itemMiddleToContentBottom;
                contentWrapper.style.height = height + 'px';
                viewport.scrollTop = contentTopToItemMiddle - topEdgeToTriggerMiddle + viewport.offsetTop;
            }
            contentWrapper.style.margin = `${$cc7e05a45900e73f$var$CONTENT_MARGIN}px 0`;
            contentWrapper.style.minHeight = minContentHeight + 'px';
            contentWrapper.style.maxHeight = availableHeight + 'px'; // -----------------------------------------------------------------------------------------
            onPlaced === null || onPlaced === void 0 || onPlaced(); // we don't want the initial scroll position adjustment to trigger "expand on scroll"
            // so we explicitly turn it on only after they've registered.
            requestAnimationFrame(()=>shouldExpandOnScrollRef.current = true
            );
        }
    }, [
        getItems,
        context.trigger,
        context.valueNode,
        contentWrapper,
        content,
        viewport,
        selectedItem,
        selectedItemText,
        context.dir,
        onPlaced
    ]);
    (0,react_use_layout_effect_dist/* useLayoutEffect */.b)(()=>position()
    , [
        position
    ]); // copy z-index from content to wrapper
    const [contentZIndex, setContentZIndex] = (0,react.useState)();
    (0,react_use_layout_effect_dist/* useLayoutEffect */.b)(()=>{
        if (content) setContentZIndex(window.getComputedStyle(content).zIndex);
    }, [
        content
    ]); // When the viewport becomes scrollable at the top, the scroll up button will mount.
    // Because it is part of the normal flow, it will push down the viewport, thus throwing our
    // trigger => selectedItem alignment off by the amount the viewport was pushed down.
    // We wait for this to happen and then re-run the positining logic one more time to account for it.
    const handleScrollButtonChange = (0,react.useCallback)((node)=>{
        if (node && shouldRepositionRef.current === true) {
            position();
            focusSelectedItem === null || focusSelectedItem === void 0 || focusSelectedItem();
            shouldRepositionRef.current = false;
        }
    }, [
        position,
        focusSelectedItem
    ]);
    return /*#__PURE__*/ (0,react.createElement)($cc7e05a45900e73f$var$SelectViewportProvider, {
        scope: __scopeSelect,
        contentWrapper: contentWrapper,
        shouldExpandOnScrollRef: shouldExpandOnScrollRef,
        onScrollButtonChange: handleScrollButtonChange
    }, /*#__PURE__*/ (0,react.createElement)("div", {
        ref: setContentWrapper,
        style: {
            display: 'flex',
            flexDirection: 'column',
            position: 'fixed',
            zIndex: contentZIndex
        }
    }, /*#__PURE__*/ (0,react.createElement)(react_primitive_dist/* Primitive.div */.WV.div, (0,esm_extends/* default */.Z)({}, popperProps, {
        ref: composedRefs,
        style: {
            // When we get the height of the content, it includes borders. If we were to set
            // the height without having `boxSizing: 'border-box'` it would be too big.
            boxSizing: 'border-box',
            // We need to ensure the content doesn't get taller than the wrapper
            maxHeight: '100%',
            ...popperProps.style
        }
    }))));
});
/*#__PURE__*/ Object.assign($cc7e05a45900e73f$var$SelectItemAlignedPosition, {
    displayName: $cc7e05a45900e73f$var$ITEM_ALIGNED_POSITION_NAME
});
/* -------------------------------------------------------------------------------------------------
 * SelectPopperPosition
 * -----------------------------------------------------------------------------------------------*/ const $cc7e05a45900e73f$var$POPPER_POSITION_NAME = 'SelectPopperPosition';
const $cc7e05a45900e73f$var$SelectPopperPosition = /*#__PURE__*/ (0,react.forwardRef)((props, forwardedRef)=>{
    const { __scopeSelect: __scopeSelect , align: align = 'start' , collisionPadding: collisionPadding = $cc7e05a45900e73f$var$CONTENT_MARGIN , ...popperProps } = props;
    const popperScope = $cc7e05a45900e73f$var$usePopperScope(__scopeSelect);
    return /*#__PURE__*/ (0,react.createElement)(react_popper_dist/* Content */.VY, (0,esm_extends/* default */.Z)({}, popperScope, popperProps, {
        ref: forwardedRef,
        align: align,
        collisionPadding: collisionPadding,
        style: {
            // Ensure border-box for floating-ui calculations
            boxSizing: 'border-box',
            ...popperProps.style,
            '--radix-select-content-transform-origin': 'var(--radix-popper-transform-origin)',
            '--radix-select-content-available-width': 'var(--radix-popper-available-width)',
            '--radix-select-content-available-height': 'var(--radix-popper-available-height)',
            '--radix-select-trigger-width': 'var(--radix-popper-anchor-width)',
            '--radix-select-trigger-height': 'var(--radix-popper-anchor-height)'
        }
    }));
});
/*#__PURE__*/ Object.assign($cc7e05a45900e73f$var$SelectPopperPosition, {
    displayName: $cc7e05a45900e73f$var$POPPER_POSITION_NAME
});
/* -------------------------------------------------------------------------------------------------
 * SelectViewport
 * -----------------------------------------------------------------------------------------------*/ const [$cc7e05a45900e73f$var$SelectViewportProvider, $cc7e05a45900e73f$var$useSelectViewportContext] = $cc7e05a45900e73f$var$createSelectContext($cc7e05a45900e73f$var$CONTENT_NAME, {});
const $cc7e05a45900e73f$var$VIEWPORT_NAME = 'SelectViewport';
const $cc7e05a45900e73f$export$9ed6e7b40248d36d = /*#__PURE__*/ (0,react.forwardRef)((props, forwardedRef)=>{
    const { __scopeSelect: __scopeSelect , ...viewportProps } = props;
    const contentContext = $cc7e05a45900e73f$var$useSelectContentContext($cc7e05a45900e73f$var$VIEWPORT_NAME, __scopeSelect);
    const viewportContext = $cc7e05a45900e73f$var$useSelectViewportContext($cc7e05a45900e73f$var$VIEWPORT_NAME, __scopeSelect);
    const composedRefs = (0,react_compose_refs_dist/* useComposedRefs */.e)(forwardedRef, contentContext.onViewportChange);
    const prevScrollTopRef = (0,react.useRef)(0);
    return /*#__PURE__*/ (0,react.createElement)(react.Fragment, null, /*#__PURE__*/ (0,react.createElement)("style", {
        dangerouslySetInnerHTML: {
            __html: `[data-radix-select-viewport]{scrollbar-width:none;-ms-overflow-style:none;-webkit-overflow-scrolling:touch;}[data-radix-select-viewport]::-webkit-scrollbar{display:none}`
        }
    }), /*#__PURE__*/ (0,react.createElement)($cc7e05a45900e73f$var$Collection.Slot, {
        scope: __scopeSelect
    }, /*#__PURE__*/ (0,react.createElement)(react_primitive_dist/* Primitive.div */.WV.div, (0,esm_extends/* default */.Z)({
        "data-radix-select-viewport": "",
        role: "presentation"
    }, viewportProps, {
        ref: composedRefs,
        style: {
            // we use position: 'relative' here on the `viewport` so that when we call
            // `selectedItem.offsetTop` in calculations, the offset is relative to the viewport
            // (independent of the scrollUpButton).
            position: 'relative',
            flex: 1,
            overflow: 'auto',
            ...viewportProps.style
        },
        onScroll: (0,primitive_dist/* composeEventHandlers */.M)(viewportProps.onScroll, (event)=>{
            const viewport = event.currentTarget;
            const { contentWrapper: contentWrapper , shouldExpandOnScrollRef: shouldExpandOnScrollRef  } = viewportContext;
            if (shouldExpandOnScrollRef !== null && shouldExpandOnScrollRef !== void 0 && shouldExpandOnScrollRef.current && contentWrapper) {
                const scrolledBy = Math.abs(prevScrollTopRef.current - viewport.scrollTop);
                if (scrolledBy > 0) {
                    const availableHeight = window.innerHeight - $cc7e05a45900e73f$var$CONTENT_MARGIN * 2;
                    const cssMinHeight = parseFloat(contentWrapper.style.minHeight);
                    const cssHeight = parseFloat(contentWrapper.style.height);
                    const prevHeight = Math.max(cssMinHeight, cssHeight);
                    if (prevHeight < availableHeight) {
                        const nextHeight = prevHeight + scrolledBy;
                        const clampedNextHeight = Math.min(availableHeight, nextHeight);
                        const heightDiff = nextHeight - clampedNextHeight;
                        contentWrapper.style.height = clampedNextHeight + 'px';
                        if (contentWrapper.style.bottom === '0px') {
                            viewport.scrollTop = heightDiff > 0 ? heightDiff : 0; // ensure the content stays pinned to the bottom
                            contentWrapper.style.justifyContent = 'flex-end';
                        }
                    }
                }
            }
            prevScrollTopRef.current = viewport.scrollTop;
        })
    }))));
});
/*#__PURE__*/ Object.assign($cc7e05a45900e73f$export$9ed6e7b40248d36d, {
    displayName: $cc7e05a45900e73f$var$VIEWPORT_NAME
});
/* -------------------------------------------------------------------------------------------------
 * SelectGroup
 * -----------------------------------------------------------------------------------------------*/ const $cc7e05a45900e73f$var$GROUP_NAME = 'SelectGroup';
const [$cc7e05a45900e73f$var$SelectGroupContextProvider, $cc7e05a45900e73f$var$useSelectGroupContext] = $cc7e05a45900e73f$var$createSelectContext($cc7e05a45900e73f$var$GROUP_NAME);
const $cc7e05a45900e73f$export$ee25a334c55de1f4 = /*#__PURE__*/ (0,react.forwardRef)((props, forwardedRef)=>{
    const { __scopeSelect: __scopeSelect , ...groupProps } = props;
    const groupId = (0,react_id_dist/* useId */.M)();
    return /*#__PURE__*/ (0,react.createElement)($cc7e05a45900e73f$var$SelectGroupContextProvider, {
        scope: __scopeSelect,
        id: groupId
    }, /*#__PURE__*/ (0,react.createElement)(react_primitive_dist/* Primitive.div */.WV.div, (0,esm_extends/* default */.Z)({
        role: "group",
        "aria-labelledby": groupId
    }, groupProps, {
        ref: forwardedRef
    })));
});
/*#__PURE__*/ Object.assign($cc7e05a45900e73f$export$ee25a334c55de1f4, {
    displayName: $cc7e05a45900e73f$var$GROUP_NAME
});
/* -------------------------------------------------------------------------------------------------
 * SelectLabel
 * -----------------------------------------------------------------------------------------------*/ const $cc7e05a45900e73f$var$LABEL_NAME = 'SelectLabel';
const $cc7e05a45900e73f$export$f67338d29bd972f8 = /*#__PURE__*/ (0,react.forwardRef)((props, forwardedRef)=>{
    const { __scopeSelect: __scopeSelect , ...labelProps } = props;
    const groupContext = $cc7e05a45900e73f$var$useSelectGroupContext($cc7e05a45900e73f$var$LABEL_NAME, __scopeSelect);
    return /*#__PURE__*/ (0,react.createElement)(react_primitive_dist/* Primitive.div */.WV.div, (0,esm_extends/* default */.Z)({
        id: groupContext.id
    }, labelProps, {
        ref: forwardedRef
    }));
});
/*#__PURE__*/ Object.assign($cc7e05a45900e73f$export$f67338d29bd972f8, {
    displayName: $cc7e05a45900e73f$var$LABEL_NAME
});
/* -------------------------------------------------------------------------------------------------
 * SelectItem
 * -----------------------------------------------------------------------------------------------*/ const $cc7e05a45900e73f$var$ITEM_NAME = 'SelectItem';
const [$cc7e05a45900e73f$var$SelectItemContextProvider, $cc7e05a45900e73f$var$useSelectItemContext] = $cc7e05a45900e73f$var$createSelectContext($cc7e05a45900e73f$var$ITEM_NAME);
const $cc7e05a45900e73f$export$13ef48a934230896 = /*#__PURE__*/ (0,react.forwardRef)((props, forwardedRef)=>{
    const { __scopeSelect: __scopeSelect , value: value , disabled: disabled = false , textValue: textValueProp , ...itemProps } = props;
    const context = $cc7e05a45900e73f$var$useSelectContext($cc7e05a45900e73f$var$ITEM_NAME, __scopeSelect);
    const contentContext = $cc7e05a45900e73f$var$useSelectContentContext($cc7e05a45900e73f$var$ITEM_NAME, __scopeSelect);
    const isSelected = context.value === value;
    const [textValue, setTextValue] = (0,react.useState)(textValueProp !== null && textValueProp !== void 0 ? textValueProp : '');
    const [isFocused, setIsFocused] = (0,react.useState)(false);
    const composedRefs = (0,react_compose_refs_dist/* useComposedRefs */.e)(forwardedRef, (node)=>{
        var _contentContext$itemR;
        return (_contentContext$itemR = contentContext.itemRefCallback) === null || _contentContext$itemR === void 0 ? void 0 : _contentContext$itemR.call(contentContext, node, value, disabled);
    });
    const textId = (0,react_id_dist/* useId */.M)();
    const handleSelect = ()=>{
        if (!disabled) {
            context.onValueChange(value);
            context.onOpenChange(false);
        }
    };
    if (value === '') throw new Error('A <Select.Item /> must have a value prop that is not an empty string. This is because the Select value can be set to an empty string to clear the selection and show the placeholder.');
    return /*#__PURE__*/ (0,react.createElement)($cc7e05a45900e73f$var$SelectItemContextProvider, {
        scope: __scopeSelect,
        value: value,
        disabled: disabled,
        textId: textId,
        isSelected: isSelected,
        onItemTextChange: (0,react.useCallback)((node)=>{
            setTextValue((prevTextValue)=>{
                var _node$textContent;
                return prevTextValue || ((_node$textContent = node === null || node === void 0 ? void 0 : node.textContent) !== null && _node$textContent !== void 0 ? _node$textContent : '').trim();
            });
        }, [])
    }, /*#__PURE__*/ (0,react.createElement)($cc7e05a45900e73f$var$Collection.ItemSlot, {
        scope: __scopeSelect,
        value: value,
        disabled: disabled,
        textValue: textValue
    }, /*#__PURE__*/ (0,react.createElement)(react_primitive_dist/* Primitive.div */.WV.div, (0,esm_extends/* default */.Z)({
        role: "option",
        "aria-labelledby": textId,
        "data-highlighted": isFocused ? '' : undefined // `isFocused` caveat fixes stuttering in VoiceOver
        ,
        "aria-selected": isSelected && isFocused,
        "data-state": isSelected ? 'checked' : 'unchecked',
        "aria-disabled": disabled || undefined,
        "data-disabled": disabled ? '' : undefined,
        tabIndex: disabled ? undefined : -1
    }, itemProps, {
        ref: composedRefs,
        onFocus: (0,primitive_dist/* composeEventHandlers */.M)(itemProps.onFocus, ()=>setIsFocused(true)
        ),
        onBlur: (0,primitive_dist/* composeEventHandlers */.M)(itemProps.onBlur, ()=>setIsFocused(false)
        ),
        onPointerUp: (0,primitive_dist/* composeEventHandlers */.M)(itemProps.onPointerUp, handleSelect),
        onPointerMove: (0,primitive_dist/* composeEventHandlers */.M)(itemProps.onPointerMove, (event)=>{
            if (disabled) {
                var _contentContext$onIte;
                (_contentContext$onIte = contentContext.onItemLeave) === null || _contentContext$onIte === void 0 || _contentContext$onIte.call(contentContext);
            } else // even though safari doesn't support this option, it's acceptable
            // as it only means it might scroll a few pixels when using the pointer.
            event.currentTarget.focus({
                preventScroll: true
            });
        }),
        onPointerLeave: (0,primitive_dist/* composeEventHandlers */.M)(itemProps.onPointerLeave, (event)=>{
            if (event.currentTarget === document.activeElement) {
                var _contentContext$onIte2;
                (_contentContext$onIte2 = contentContext.onItemLeave) === null || _contentContext$onIte2 === void 0 || _contentContext$onIte2.call(contentContext);
            }
        }),
        onKeyDown: (0,primitive_dist/* composeEventHandlers */.M)(itemProps.onKeyDown, (event)=>{
            var _contentContext$searc;
            const isTypingAhead = ((_contentContext$searc = contentContext.searchRef) === null || _contentContext$searc === void 0 ? void 0 : _contentContext$searc.current) !== '';
            if (isTypingAhead && event.key === ' ') return;
            if ($cc7e05a45900e73f$var$SELECTION_KEYS.includes(event.key)) handleSelect(); // prevent page scroll if using the space key to select an item
            if (event.key === ' ') event.preventDefault();
        })
    }))));
});
/*#__PURE__*/ Object.assign($cc7e05a45900e73f$export$13ef48a934230896, {
    displayName: $cc7e05a45900e73f$var$ITEM_NAME
});
/* -------------------------------------------------------------------------------------------------
 * SelectItemText
 * -----------------------------------------------------------------------------------------------*/ const $cc7e05a45900e73f$var$ITEM_TEXT_NAME = 'SelectItemText';
const $cc7e05a45900e73f$export$3572fb0fb821ff49 = /*#__PURE__*/ (0,react.forwardRef)((props, forwardedRef)=>{
    // We ignore `className` and `style` as this part shouldn't be styled.
    const { __scopeSelect: __scopeSelect , className: className , style: style , ...itemTextProps } = props;
    const context = $cc7e05a45900e73f$var$useSelectContext($cc7e05a45900e73f$var$ITEM_TEXT_NAME, __scopeSelect);
    const contentContext = $cc7e05a45900e73f$var$useSelectContentContext($cc7e05a45900e73f$var$ITEM_TEXT_NAME, __scopeSelect);
    const itemContext = $cc7e05a45900e73f$var$useSelectItemContext($cc7e05a45900e73f$var$ITEM_TEXT_NAME, __scopeSelect);
    const nativeOptionsContext = $cc7e05a45900e73f$var$useSelectNativeOptionsContext($cc7e05a45900e73f$var$ITEM_TEXT_NAME, __scopeSelect);
    const [itemTextNode, setItemTextNode] = (0,react.useState)(null);
    const composedRefs = (0,react_compose_refs_dist/* useComposedRefs */.e)(forwardedRef, (node)=>setItemTextNode(node)
    , itemContext.onItemTextChange, (node)=>{
        var _contentContext$itemT;
        return (_contentContext$itemT = contentContext.itemTextRefCallback) === null || _contentContext$itemT === void 0 ? void 0 : _contentContext$itemT.call(contentContext, node, itemContext.value, itemContext.disabled);
    });
    const textContent = itemTextNode === null || itemTextNode === void 0 ? void 0 : itemTextNode.textContent;
    const nativeOption = (0,react.useMemo)(()=>/*#__PURE__*/ (0,react.createElement)("option", {
            key: itemContext.value,
            value: itemContext.value,
            disabled: itemContext.disabled
        }, textContent)
    , [
        itemContext.disabled,
        itemContext.value,
        textContent
    ]);
    const { onNativeOptionAdd: onNativeOptionAdd , onNativeOptionRemove: onNativeOptionRemove  } = nativeOptionsContext;
    (0,react_use_layout_effect_dist/* useLayoutEffect */.b)(()=>{
        onNativeOptionAdd(nativeOption);
        return ()=>onNativeOptionRemove(nativeOption)
        ;
    }, [
        onNativeOptionAdd,
        onNativeOptionRemove,
        nativeOption
    ]);
    return /*#__PURE__*/ (0,react.createElement)(react.Fragment, null, /*#__PURE__*/ (0,react.createElement)(react_primitive_dist/* Primitive.span */.WV.span, (0,esm_extends/* default */.Z)({
        id: itemContext.textId
    }, itemTextProps, {
        ref: composedRefs
    })), itemContext.isSelected && context.valueNode && !context.valueNodeHasChildren ? /*#__PURE__*/ (0,react_dom.createPortal)(itemTextProps.children, context.valueNode) : null);
});
/*#__PURE__*/ Object.assign($cc7e05a45900e73f$export$3572fb0fb821ff49, {
    displayName: $cc7e05a45900e73f$var$ITEM_TEXT_NAME
});
/* -------------------------------------------------------------------------------------------------
 * SelectItemIndicator
 * -----------------------------------------------------------------------------------------------*/ const $cc7e05a45900e73f$var$ITEM_INDICATOR_NAME = 'SelectItemIndicator';
const $cc7e05a45900e73f$export$6b9198de19accfe6 = /*#__PURE__*/ (0,react.forwardRef)((props, forwardedRef)=>{
    const { __scopeSelect: __scopeSelect , ...itemIndicatorProps } = props;
    const itemContext = $cc7e05a45900e73f$var$useSelectItemContext($cc7e05a45900e73f$var$ITEM_INDICATOR_NAME, __scopeSelect);
    return itemContext.isSelected ? /*#__PURE__*/ (0,react.createElement)(react_primitive_dist/* Primitive.span */.WV.span, (0,esm_extends/* default */.Z)({
        "aria-hidden": true
    }, itemIndicatorProps, {
        ref: forwardedRef
    })) : null;
});
/*#__PURE__*/ Object.assign($cc7e05a45900e73f$export$6b9198de19accfe6, {
    displayName: $cc7e05a45900e73f$var$ITEM_INDICATOR_NAME
});
/* -------------------------------------------------------------------------------------------------
 * SelectScrollUpButton
 * -----------------------------------------------------------------------------------------------*/ const $cc7e05a45900e73f$var$SCROLL_UP_BUTTON_NAME = 'SelectScrollUpButton';
const $cc7e05a45900e73f$export$d8117927658af6d7 = /*#__PURE__*/ (0,react.forwardRef)((props, forwardedRef)=>{
    const contentContext = $cc7e05a45900e73f$var$useSelectContentContext($cc7e05a45900e73f$var$SCROLL_UP_BUTTON_NAME, props.__scopeSelect);
    const viewportContext = $cc7e05a45900e73f$var$useSelectViewportContext($cc7e05a45900e73f$var$SCROLL_UP_BUTTON_NAME, props.__scopeSelect);
    const [canScrollUp1, setCanScrollUp] = (0,react.useState)(false);
    const composedRefs = (0,react_compose_refs_dist/* useComposedRefs */.e)(forwardedRef, viewportContext.onScrollButtonChange);
    (0,react_use_layout_effect_dist/* useLayoutEffect */.b)(()=>{
        if (contentContext.viewport && contentContext.isPositioned) {
            const viewport = contentContext.viewport;
            function handleScroll() {
                const canScrollUp = viewport.scrollTop > 0;
                setCanScrollUp(canScrollUp);
            }
            handleScroll();
            viewport.addEventListener('scroll', handleScroll);
            return ()=>viewport.removeEventListener('scroll', handleScroll)
            ;
        }
    }, [
        contentContext.viewport,
        contentContext.isPositioned
    ]);
    return canScrollUp1 ? /*#__PURE__*/ (0,react.createElement)($cc7e05a45900e73f$var$SelectScrollButtonImpl, (0,esm_extends/* default */.Z)({}, props, {
        ref: composedRefs,
        onAutoScroll: ()=>{
            const { viewport: viewport , selectedItem: selectedItem  } = contentContext;
            if (viewport && selectedItem) viewport.scrollTop = viewport.scrollTop - selectedItem.offsetHeight;
        }
    })) : null;
});
/*#__PURE__*/ Object.assign($cc7e05a45900e73f$export$d8117927658af6d7, {
    displayName: $cc7e05a45900e73f$var$SCROLL_UP_BUTTON_NAME
});
/* -------------------------------------------------------------------------------------------------
 * SelectScrollDownButton
 * -----------------------------------------------------------------------------------------------*/ const $cc7e05a45900e73f$var$SCROLL_DOWN_BUTTON_NAME = 'SelectScrollDownButton';
const $cc7e05a45900e73f$export$ff951e476c12189 = /*#__PURE__*/ (0,react.forwardRef)((props, forwardedRef)=>{
    const contentContext = $cc7e05a45900e73f$var$useSelectContentContext($cc7e05a45900e73f$var$SCROLL_DOWN_BUTTON_NAME, props.__scopeSelect);
    const viewportContext = $cc7e05a45900e73f$var$useSelectViewportContext($cc7e05a45900e73f$var$SCROLL_DOWN_BUTTON_NAME, props.__scopeSelect);
    const [canScrollDown1, setCanScrollDown] = (0,react.useState)(false);
    const composedRefs = (0,react_compose_refs_dist/* useComposedRefs */.e)(forwardedRef, viewportContext.onScrollButtonChange);
    (0,react_use_layout_effect_dist/* useLayoutEffect */.b)(()=>{
        if (contentContext.viewport && contentContext.isPositioned) {
            const viewport = contentContext.viewport;
            function handleScroll() {
                const maxScroll = viewport.scrollHeight - viewport.clientHeight; // we use Math.ceil here because if the UI is zoomed-in
                // `scrollTop` is not always reported as an integer
                const canScrollDown = Math.ceil(viewport.scrollTop) < maxScroll;
                setCanScrollDown(canScrollDown);
            }
            handleScroll();
            viewport.addEventListener('scroll', handleScroll);
            return ()=>viewport.removeEventListener('scroll', handleScroll)
            ;
        }
    }, [
        contentContext.viewport,
        contentContext.isPositioned
    ]);
    return canScrollDown1 ? /*#__PURE__*/ (0,react.createElement)($cc7e05a45900e73f$var$SelectScrollButtonImpl, (0,esm_extends/* default */.Z)({}, props, {
        ref: composedRefs,
        onAutoScroll: ()=>{
            const { viewport: viewport , selectedItem: selectedItem  } = contentContext;
            if (viewport && selectedItem) viewport.scrollTop = viewport.scrollTop + selectedItem.offsetHeight;
        }
    })) : null;
});
/*#__PURE__*/ Object.assign($cc7e05a45900e73f$export$ff951e476c12189, {
    displayName: $cc7e05a45900e73f$var$SCROLL_DOWN_BUTTON_NAME
});
const $cc7e05a45900e73f$var$SelectScrollButtonImpl = /*#__PURE__*/ (0,react.forwardRef)((props, forwardedRef)=>{
    const { __scopeSelect: __scopeSelect , onAutoScroll: onAutoScroll , ...scrollIndicatorProps } = props;
    const contentContext = $cc7e05a45900e73f$var$useSelectContentContext('SelectScrollButton', __scopeSelect);
    const autoScrollTimerRef = (0,react.useRef)(null);
    const getItems = $cc7e05a45900e73f$var$useCollection(__scopeSelect);
    const clearAutoScrollTimer = (0,react.useCallback)(()=>{
        if (autoScrollTimerRef.current !== null) {
            window.clearInterval(autoScrollTimerRef.current);
            autoScrollTimerRef.current = null;
        }
    }, []);
    (0,react.useEffect)(()=>{
        return ()=>clearAutoScrollTimer()
        ;
    }, [
        clearAutoScrollTimer
    ]); // When the viewport becomes scrollable on either side, the relevant scroll button will mount.
    // Because it is part of the normal flow, it will push down (top button) or shrink (bottom button)
    // the viewport, potentially causing the active item to now be partially out of view.
    // We re-run the `scrollIntoView` logic to make sure it stays within the viewport.
    (0,react_use_layout_effect_dist/* useLayoutEffect */.b)(()=>{
        var _activeItem$ref$curre;
        const activeItem = getItems().find((item)=>item.ref.current === document.activeElement
        );
        activeItem === null || activeItem === void 0 || (_activeItem$ref$curre = activeItem.ref.current) === null || _activeItem$ref$curre === void 0 || _activeItem$ref$curre.scrollIntoView({
            block: 'nearest'
        });
    }, [
        getItems
    ]);
    return /*#__PURE__*/ (0,react.createElement)(react_primitive_dist/* Primitive.div */.WV.div, (0,esm_extends/* default */.Z)({
        "aria-hidden": true
    }, scrollIndicatorProps, {
        ref: forwardedRef,
        style: {
            flexShrink: 0,
            ...scrollIndicatorProps.style
        },
        onPointerDown: (0,primitive_dist/* composeEventHandlers */.M)(scrollIndicatorProps.onPointerDown, ()=>{
            if (autoScrollTimerRef.current === null) autoScrollTimerRef.current = window.setInterval(onAutoScroll, 50);
        }),
        onPointerMove: (0,primitive_dist/* composeEventHandlers */.M)(scrollIndicatorProps.onPointerMove, ()=>{
            var _contentContext$onIte3;
            (_contentContext$onIte3 = contentContext.onItemLeave) === null || _contentContext$onIte3 === void 0 || _contentContext$onIte3.call(contentContext);
            if (autoScrollTimerRef.current === null) autoScrollTimerRef.current = window.setInterval(onAutoScroll, 50);
        }),
        onPointerLeave: (0,primitive_dist/* composeEventHandlers */.M)(scrollIndicatorProps.onPointerLeave, ()=>{
            clearAutoScrollTimer();
        })
    }));
});
/* -------------------------------------------------------------------------------------------------
 * SelectSeparator
 * -----------------------------------------------------------------------------------------------*/ const $cc7e05a45900e73f$var$SEPARATOR_NAME = 'SelectSeparator';
const $cc7e05a45900e73f$export$eba4b1df07cb1d3 = /*#__PURE__*/ (0,react.forwardRef)((props, forwardedRef)=>{
    const { __scopeSelect: __scopeSelect , ...separatorProps } = props;
    return /*#__PURE__*/ (0,react.createElement)(react_primitive_dist/* Primitive.div */.WV.div, (0,esm_extends/* default */.Z)({
        "aria-hidden": true
    }, separatorProps, {
        ref: forwardedRef
    }));
});
/*#__PURE__*/ Object.assign($cc7e05a45900e73f$export$eba4b1df07cb1d3, {
    displayName: $cc7e05a45900e73f$var$SEPARATOR_NAME
});
/* -------------------------------------------------------------------------------------------------
 * SelectArrow
 * -----------------------------------------------------------------------------------------------*/ const $cc7e05a45900e73f$var$ARROW_NAME = 'SelectArrow';
const $cc7e05a45900e73f$export$314f4cb8f8099628 = /*#__PURE__*/ (0,react.forwardRef)((props, forwardedRef)=>{
    const { __scopeSelect: __scopeSelect , ...arrowProps } = props;
    const popperScope = $cc7e05a45900e73f$var$usePopperScope(__scopeSelect);
    const context = $cc7e05a45900e73f$var$useSelectContext($cc7e05a45900e73f$var$ARROW_NAME, __scopeSelect);
    const contentContext = $cc7e05a45900e73f$var$useSelectContentContext($cc7e05a45900e73f$var$ARROW_NAME, __scopeSelect);
    return context.open && contentContext.position === 'popper' ? /*#__PURE__*/ (0,react.createElement)(react_popper_dist/* Arrow */.Eh, (0,esm_extends/* default */.Z)({}, popperScope, arrowProps, {
        ref: forwardedRef
    })) : null;
});
/*#__PURE__*/ Object.assign($cc7e05a45900e73f$export$314f4cb8f8099628, {
    displayName: $cc7e05a45900e73f$var$ARROW_NAME
});
/* -----------------------------------------------------------------------------------------------*/ function $cc7e05a45900e73f$var$shouldShowPlaceholder(value) {
    return value === '' || value === undefined;
}
const $cc7e05a45900e73f$var$BubbleSelect = /*#__PURE__*/ (0,react.forwardRef)((props, forwardedRef)=>{
    const { value: value , ...selectProps } = props;
    const ref = (0,react.useRef)(null);
    const composedRefs = (0,react_compose_refs_dist/* useComposedRefs */.e)(forwardedRef, ref);
    const prevValue = (0,react_use_previous_dist/* usePrevious */.D)(value); // Bubble value change to parents (e.g form change event)
    (0,react.useEffect)(()=>{
        const select = ref.current;
        const selectProto = window.HTMLSelectElement.prototype;
        const descriptor = Object.getOwnPropertyDescriptor(selectProto, 'value');
        const setValue = descriptor.set;
        if (prevValue !== value && setValue) {
            const event = new Event('change', {
                bubbles: true
            });
            setValue.call(select, value);
            select.dispatchEvent(event);
        }
    }, [
        prevValue,
        value
    ]);
    /**
   * We purposefully use a `select` here to support form autofill as much
   * as possible.
   *
   * We purposefully do not add the `value` attribute here to allow the value
   * to be set programatically and bubble to any parent form `onChange` event.
   * Adding the `value` will cause React to consider the programatic
   * dispatch a duplicate and it will get swallowed.
   *
   * We use `VisuallyHidden` rather than `display: "none"` because Safari autofill
   * won't work otherwise.
   */ return /*#__PURE__*/ (0,react.createElement)(react_visually_hidden_dist/* VisuallyHidden */.T, {
        asChild: true
    }, /*#__PURE__*/ (0,react.createElement)("select", (0,esm_extends/* default */.Z)({}, selectProps, {
        ref: composedRefs,
        defaultValue: value
    })));
});
$cc7e05a45900e73f$var$BubbleSelect.displayName = 'BubbleSelect';
function $cc7e05a45900e73f$var$useTypeaheadSearch(onSearchChange) {
    const handleSearchChange = (0,react_use_callback_ref_dist/* useCallbackRef */.W)(onSearchChange);
    const searchRef = (0,react.useRef)('');
    const timerRef = (0,react.useRef)(0);
    const handleTypeaheadSearch = (0,react.useCallback)((key)=>{
        const search = searchRef.current + key;
        handleSearchChange(search);
        (function updateSearch(value) {
            searchRef.current = value;
            window.clearTimeout(timerRef.current); // Reset `searchRef` 1 second after it was last updated
            if (value !== '') timerRef.current = window.setTimeout(()=>updateSearch('')
            , 1000);
        })(search);
    }, [
        handleSearchChange
    ]);
    const resetTypeahead = (0,react.useCallback)(()=>{
        searchRef.current = '';
        window.clearTimeout(timerRef.current);
    }, []);
    (0,react.useEffect)(()=>{
        return ()=>window.clearTimeout(timerRef.current)
        ;
    }, []);
    return [
        searchRef,
        handleTypeaheadSearch,
        resetTypeahead
    ];
}
/**
 * This is the "meat" of the typeahead matching logic. It takes in a list of items,
 * the search and the current item, and returns the next item (or `undefined`).
 *
 * We normalize the search because if a user has repeatedly pressed a character,
 * we want the exact same behavior as if we only had that one character
 * (ie. cycle through items starting with that character)
 *
 * We also reorder the items by wrapping the array around the current item.
 * This is so we always look forward from the current item, and picking the first
 * item will always be the correct one.
 *
 * Finally, if the normalized search is exactly one character, we exclude the
 * current item from the values because otherwise it would be the first to match always
 * and focus would never move. This is as opposed to the regular case, where we
 * don't want focus to move if the current item still matches.
 */ function $cc7e05a45900e73f$var$findNextItem(items, search, currentItem) {
    const isRepeated = search.length > 1 && Array.from(search).every((char)=>char === search[0]
    );
    const normalizedSearch = isRepeated ? search[0] : search;
    const currentItemIndex = currentItem ? items.indexOf(currentItem) : -1;
    let wrappedItems = $cc7e05a45900e73f$var$wrapArray(items, Math.max(currentItemIndex, 0));
    const excludeCurrentItem = normalizedSearch.length === 1;
    if (excludeCurrentItem) wrappedItems = wrappedItems.filter((v)=>v !== currentItem
    );
    const nextItem = wrappedItems.find((item)=>item.textValue.toLowerCase().startsWith(normalizedSearch.toLowerCase())
    );
    return nextItem !== currentItem ? nextItem : undefined;
}
/**
 * Wraps an array around itself at a given start index
 * Example: `wrapArray(['a', 'b', 'c', 'd'], 2) === ['c', 'd', 'a', 'b']`
 */ function $cc7e05a45900e73f$var$wrapArray(array, startIndex) {
    return array.map((_, index)=>array[(startIndex + index) % array.length]
    );
}
const $cc7e05a45900e73f$export$be92b6f5f03c0fe9 = $cc7e05a45900e73f$export$ef9b1a59e592288f;
const $cc7e05a45900e73f$export$41fb9f06171c75f4 = $cc7e05a45900e73f$export$3ac1e88a1c0b9f1;
const $cc7e05a45900e73f$export$4c8d1a57a761ef94 = $cc7e05a45900e73f$export$e288731fd71264f0;
const $cc7e05a45900e73f$export$f04a61298a47a40f = $cc7e05a45900e73f$export$99b400cabb58c515;
const $cc7e05a45900e73f$export$602eac185826482c = $cc7e05a45900e73f$export$b2af6c9944296213;
const $cc7e05a45900e73f$export$7c6e2c02157bb7d2 = $cc7e05a45900e73f$export$c973a4b3cb86a03d;
const $cc7e05a45900e73f$export$d5c6c08dc2d3ca7 = $cc7e05a45900e73f$export$9ed6e7b40248d36d;
const $cc7e05a45900e73f$export$eb2fcfdbd7ba97d4 = $cc7e05a45900e73f$export$ee25a334c55de1f4;
const $cc7e05a45900e73f$export$b04be29aa201d4f5 = $cc7e05a45900e73f$export$f67338d29bd972f8;
const $cc7e05a45900e73f$export$6d08773d2e66f8f2 = $cc7e05a45900e73f$export$13ef48a934230896;
const $cc7e05a45900e73f$export$d6e5bf9c43ea9319 = $cc7e05a45900e73f$export$3572fb0fb821ff49;
const $cc7e05a45900e73f$export$c3468e2714d175fa = (/* unused pure expression or super */ null && ($cc7e05a45900e73f$export$6b9198de19accfe6));
const $cc7e05a45900e73f$export$2f60d3ec9ad468f2 = $cc7e05a45900e73f$export$d8117927658af6d7;
const $cc7e05a45900e73f$export$bf1aedc3039c8d63 = $cc7e05a45900e73f$export$ff951e476c12189;
const $cc7e05a45900e73f$export$1ff3c3f08ae963c0 = $cc7e05a45900e73f$export$eba4b1df07cb1d3;
const $cc7e05a45900e73f$export$21b07c8f274aebd5 = (/* unused pure expression or super */ null && ($cc7e05a45900e73f$export$314f4cb8f8099628));





//# sourceMappingURL=index.mjs.map

// EXTERNAL MODULE: ./node_modules/lucide-react/dist/esm/createLucideIcon.js + 1 modules
var createLucideIcon = __webpack_require__(84297);
;// CONCATENATED MODULE: ./node_modules/lucide-react/dist/esm/icons/chevron-down.js
/**
 * @license lucide-react v0.303.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */



const ChevronDown = (0,createLucideIcon/* default */.Z)("ChevronDown", [
  ["path", { d: "m6 9 6 6 6-6", key: "qrunsl" }]
]);


//# sourceMappingURL=chevron-down.js.map

;// CONCATENATED MODULE: ./node_modules/lucide-react/dist/esm/icons/chevron-up.js
/**
 * @license lucide-react v0.303.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */



const ChevronUp = (0,createLucideIcon/* default */.Z)("ChevronUp", [["path", { d: "m18 15-6-6-6 6", key: "153udz" }]]);


//# sourceMappingURL=chevron-up.js.map

// EXTERNAL MODULE: ./app/lib/utils.ts + 1 modules
var utils = __webpack_require__(73848);
;// CONCATENATED MODULE: ./app/components/ui/select.tsx





const Select = $cc7e05a45900e73f$export$be92b6f5f03c0fe9;
const SelectGroup = $cc7e05a45900e73f$export$eb2fcfdbd7ba97d4;
const SelectValue = $cc7e05a45900e73f$export$4c8d1a57a761ef94;
const SelectTrigger = /*#__PURE__*/ react.forwardRef((param, ref)=>/*#__PURE__*/ {
    let { className , children , asChild =true , ...props } = param;
    return (0,jsx_runtime.jsxs)($cc7e05a45900e73f$export$41fb9f06171c75f4, {
        ref: ref,
        className: (0,utils.cn)("flex h-10 w-full items-center justify-between rounded-md border border-input bg-background px-3 py-2 text-sm placeholder:text-muted-foreground focus:outline-none disabled:cursor-not-allowed disabled:opacity-50 [&>span]:line-clamp-1", className),
        ...props,
        children: [
            children,
            asChild && /*#__PURE__*/ (0,jsx_runtime.jsx)($cc7e05a45900e73f$export$f04a61298a47a40f, {
                asChild: true,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ChevronDown, {
                    className: "w-4 h-4"
                })
            })
        ]
    });
});
SelectTrigger.displayName = $cc7e05a45900e73f$export$41fb9f06171c75f4.displayName;
const SelectScrollUpButton = /*#__PURE__*/ react.forwardRef((param, ref)=>/*#__PURE__*/ {
    let { className , ...props } = param;
    return (0,jsx_runtime.jsx)($cc7e05a45900e73f$export$2f60d3ec9ad468f2, {
        ref: ref,
        className: (0,utils.cn)("flex cursor-default items-center justify-center py-1", className),
        ...props,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ChevronUp, {
            className: "w-4 h-4"
        })
    });
});
SelectScrollUpButton.displayName = $cc7e05a45900e73f$export$2f60d3ec9ad468f2.displayName;
const SelectScrollDownButton = /*#__PURE__*/ react.forwardRef((param, ref)=>/*#__PURE__*/ {
    let { className , ...props } = param;
    return (0,jsx_runtime.jsx)($cc7e05a45900e73f$export$bf1aedc3039c8d63, {
        ref: ref,
        className: (0,utils.cn)("flex cursor-default items-center justify-center py-1", className),
        ...props,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ChevronDown, {
            className: "w-4 h-4"
        })
    });
});
SelectScrollDownButton.displayName = $cc7e05a45900e73f$export$bf1aedc3039c8d63.displayName;
const SelectContent = /*#__PURE__*/ react.forwardRef((param, ref)=>/*#__PURE__*/ {
    let { className , children , position ="popper" , ...props } = param;
    return (0,jsx_runtime.jsx)($cc7e05a45900e73f$export$602eac185826482c, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)($cc7e05a45900e73f$export$7c6e2c02157bb7d2, {
            // ref={ref}
            ref: (instance)=>{
                if (typeof ref === "function") {
                    ref(instance);
                } else if (ref) {
                    ref.current = instance;
                }
                if (!instance) return;
                // THIS IS A HACK
                instance.ontouchend = (e)=>{
                    e.cancelable && e.preventDefault();
                };
            },
            className: (0,utils.cn)("relative z-50 max-h-96 min-w-[8rem] overflow-hidden rounded-md border dark:border-0 bg-popover text-popover-foreground dark:text-white dark:bg-dark-mode-box dark:backdrop-blur-[20px] shadow-md data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0 data-[state=closed]:zoom-out-95 data-[state=open]:zoom-in-95 data-[side=bottom]:slide-in-from-top-2 data-[side=left]:slide-in-from-right-2 data-[side=right]:slide-in-from-left-2 data-[side=top]:slide-in-from-bottom-2", position === "popper" && "data-[side=bottom]:translate-y-1 data-[side=left]:-translate-x-1 data-[side=right]:translate-x-1 data-[side=top]:-translate-y-1", className),
            position: position,
            ...props,
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)($cc7e05a45900e73f$export$d5c6c08dc2d3ca7, {
                className: (0,utils.cn)("p-1", position === "popper" && "h-[var(--radix-select-trigger-height)] w-full min-w-[var(--radix-select-trigger-width)]"),
                children: children
            })
        })
    });
});
SelectContent.displayName = $cc7e05a45900e73f$export$7c6e2c02157bb7d2.displayName;
const SelectLabel = /*#__PURE__*/ react.forwardRef((param, ref)=>/*#__PURE__*/ {
    let { className , ...props } = param;
    return (0,jsx_runtime.jsx)($cc7e05a45900e73f$export$b04be29aa201d4f5, {
        ref: ref,
        className: (0,utils.cn)("py-1.5 pl-8 pr-2 text-sm font-semibold", className),
        ...props
    });
});
SelectLabel.displayName = $cc7e05a45900e73f$export$b04be29aa201d4f5.displayName;
const SelectItem = /*#__PURE__*/ react.forwardRef((param, ref)=>/*#__PURE__*/ {
    let { className , children , ...props } = param;
    return (0,jsx_runtime.jsx)($cc7e05a45900e73f$export$6d08773d2e66f8f2, {
        ref: ref,
        className: (0,utils.cn)("relative flex w-full cursor-default select-none items-center rounded-sm py-1.5 px-2 text-sm outline-none focus:bg-accent focus:text-accent-foreground data-[disabled]:pointer-events-none data-[disabled]:opacity-50", className),
        ...props,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)($cc7e05a45900e73f$export$d6e5bf9c43ea9319, {
            children: children
        })
    });
});
SelectItem.displayName = $cc7e05a45900e73f$export$6d08773d2e66f8f2.displayName;
const SelectSeparator = /*#__PURE__*/ react.forwardRef((param, ref)=>/*#__PURE__*/ {
    let { className , ...props } = param;
    return (0,jsx_runtime.jsx)($cc7e05a45900e73f$export$1ff3c3f08ae963c0, {
        ref: ref,
        className: (0,utils.cn)("-mx-1 my-1 h-px bg-muted", className),
        ...props
    });
});
SelectSeparator.displayName = $cc7e05a45900e73f$export$1ff3c3f08ae963c0.displayName;



/***/ }),

/***/ 87194:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "aM": function() { return /* binding */ SheetTrigger; },
/* harmony export */   "ue": function() { return /* binding */ SheetContent; },
/* harmony export */   "yo": function() { return /* binding */ Sheet; }
/* harmony export */ });
/* unused harmony exports SheetPortal, SheetOverlay, SheetClose, SheetHeader, SheetFooter, SheetTitle, SheetDescription */
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(41844);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(55784);
/* harmony import */ var _radix_ui_react_dialog__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(12854);
/* harmony import */ var class_variance_authority__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(12003);
/* harmony import */ var _lib_utils__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(73848);





const Sheet = _radix_ui_react_dialog__WEBPACK_IMPORTED_MODULE_2__/* .Root */ .fC;
const SheetTrigger = _radix_ui_react_dialog__WEBPACK_IMPORTED_MODULE_2__/* .Trigger */ .xz;
const SheetClose = _radix_ui_react_dialog__WEBPACK_IMPORTED_MODULE_2__/* .Close */ .x8;
const SheetPortal = _radix_ui_react_dialog__WEBPACK_IMPORTED_MODULE_2__/* .Portal */ .h_;
const SheetOverlay = /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_1__.forwardRef((param, ref)=>/*#__PURE__*/ {
    let { className , ...props } = param;
    return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_radix_ui_react_dialog__WEBPACK_IMPORTED_MODULE_2__/* .Overlay */ .aV, {
        className: (0,_lib_utils__WEBPACK_IMPORTED_MODULE_3__.cn)("fixed inset-0 z-50 bg-black/30  data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0", className),
        ...props,
        ref: ref
    });
});
SheetOverlay.displayName = _radix_ui_react_dialog__WEBPACK_IMPORTED_MODULE_2__/* .Overlay.displayName */ .aV.displayName;
const sheetVariants = (0,class_variance_authority__WEBPACK_IMPORTED_MODULE_4__/* .cva */ .j)("fixed z-50 gap-4 bg-background p-6 shadow-lg transition ease-in-out data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:duration-300 data-[state=open]:duration-500", {
    variants: {
        side: {
            top: "inset-x-0 top-0 border-b data-[state=closed]:slide-out-to-top data-[state=open]:slide-in-from-top",
            bottom: "inset-x-0 bottom-0 border-t data-[state=closed]:slide-out-to-bottom data-[state=open]:slide-in-from-bottom",
            left: "inset-y-0 left-0 h-full w-[86%] border-r data-[state=closed]:slide-out-to-left data-[state=open]:slide-in-from-left sm:max-w-sm",
            right: "inset-y-0 right-0 h-full w-[86%]  border-l data-[state=closed]:slide-out-to-right data-[state=open]:slide-in-from-right sm:max-w-sm"
        }
    },
    defaultVariants: {
        side: "right"
    }
});
const SheetContent = /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_1__.forwardRef((param, ref)=>/*#__PURE__*/ {
    let { side ="right" , className , children , ...props } = param;
    return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(SheetPortal, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(SheetOverlay, {}),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_radix_ui_react_dialog__WEBPACK_IMPORTED_MODULE_2__/* .Content */ .VY, {
                ref: ref,
                className: (0,_lib_utils__WEBPACK_IMPORTED_MODULE_3__.cn)(sheetVariants({
                    side
                }), className),
                ...props,
                children: children
            })
        ]
    });
});
SheetContent.displayName = _radix_ui_react_dialog__WEBPACK_IMPORTED_MODULE_2__/* .Content.displayName */ .VY.displayName;
const SheetHeader = (param)=>/*#__PURE__*/ {
    let { className , ...props } = param;
    return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: (0,_lib_utils__WEBPACK_IMPORTED_MODULE_3__.cn)("flex flex-col space-y-2 text-center sm:text-left", className),
        ...props
    });
};
SheetHeader.displayName = "SheetHeader";
const SheetFooter = (param)=>/*#__PURE__*/ {
    let { className , ...props } = param;
    return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: (0,_lib_utils__WEBPACK_IMPORTED_MODULE_3__.cn)("flex flex-col-reverse sm:flex-row sm:justify-end sm:space-x-2", className),
        ...props
    });
};
SheetFooter.displayName = "SheetFooter";
const SheetTitle = /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_1__.forwardRef((param, ref)=>/*#__PURE__*/ {
    let { className , ...props } = param;
    return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_radix_ui_react_dialog__WEBPACK_IMPORTED_MODULE_2__/* .Title */ .Dx, {
        ref: ref,
        className: (0,_lib_utils__WEBPACK_IMPORTED_MODULE_3__.cn)("text-lg font-semibold text-foreground", className),
        ...props
    });
});
SheetTitle.displayName = _radix_ui_react_dialog__WEBPACK_IMPORTED_MODULE_2__/* .Title.displayName */ .Dx.displayName;
const SheetDescription = /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_1__.forwardRef((param, ref)=>/*#__PURE__*/ {
    let { className , ...props } = param;
    return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_radix_ui_react_dialog__WEBPACK_IMPORTED_MODULE_2__/* .Description */ .dk, {
        ref: ref,
        className: (0,_lib_utils__WEBPACK_IMPORTED_MODULE_3__.cn)("text-sm text-muted-foreground", className),
        ...props
    });
});
SheetDescription.displayName = _radix_ui_react_dialog__WEBPACK_IMPORTED_MODULE_2__/* .Description.displayName */ .dk.displayName;



/***/ }),

/***/ 84751:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "O": function() { return /* binding */ Skeleton; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(41844);
/* harmony import */ var _lib_utils__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(73848);


function Skeleton(param) {
    let { className , ...props } = param;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: (0,_lib_utils__WEBPACK_IMPORTED_MODULE_1__.cn)("animate-pulse rounded-md bg-muted", className),
        ...props
    });
}



/***/ }),

/***/ 1045:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "RM": function() { return /* binding */ TableBody; },
/* harmony export */   "SC": function() { return /* binding */ TableRow; },
/* harmony export */   "iA": function() { return /* binding */ Table; },
/* harmony export */   "pj": function() { return /* binding */ TableCell; },
/* harmony export */   "ss": function() { return /* binding */ TableHead; },
/* harmony export */   "xD": function() { return /* binding */ TableHeader; }
/* harmony export */ });
/* unused harmony exports TableFooter, TableCaption */
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(41844);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(55784);
/* harmony import */ var _lib_utils__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(73848);



const Table = /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_1__.forwardRef((param, ref)=>/*#__PURE__*/ {
    let { className , ...props } = param;
    return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: "relative w-full overflow-auto",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("table", {
            ref: ref,
            className: (0,_lib_utils__WEBPACK_IMPORTED_MODULE_2__.cn)("w-full caption-bottom text-sm", className),
            ...props
        })
    });
});
Table.displayName = "Table";
const TableHeader = /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_1__.forwardRef((param, ref)=>/*#__PURE__*/ {
    let { className , ...props } = param;
    return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("thead", {
        ref: ref,
        className: (0,_lib_utils__WEBPACK_IMPORTED_MODULE_2__.cn)("[&_tr]:border-b border-black/10", className),
        ...props
    });
});
TableHeader.displayName = "TableHeader";
const TableBody = /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_1__.forwardRef((param, ref)=>/*#__PURE__*/ {
    let { className , ...props } = param;
    return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("tbody", {
        ref: ref,
        className: (0,_lib_utils__WEBPACK_IMPORTED_MODULE_2__.cn)("[&_tr:last-child]:border-0 [&_tr]:translate-y-[12px]", className),
        ...props
    });
});
TableBody.displayName = "TableBody";
const TableFooter = /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_1__.forwardRef((param, ref)=>/*#__PURE__*/ {
    let { className , ...props } = param;
    return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("tfoot", {
        ref: ref,
        className: (0,_lib_utils__WEBPACK_IMPORTED_MODULE_2__.cn)("border-t bg-muted/50 font-medium [&>tr]:last:border-b-0", className),
        ...props
    });
});
TableFooter.displayName = "TableFooter";
const TableRow = /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_1__.forwardRef((param, ref)=>/*#__PURE__*/ {
    let { className , ...props } = param;
    return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("tr", {
        ref: ref,
        className: (0,_lib_utils__WEBPACK_IMPORTED_MODULE_2__.cn)("transition-colors dark:border-neutral-03", className),
        ...props
    });
});
TableRow.displayName = "TableRow";
const TableHead = /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_1__.forwardRef((param, ref)=>/*#__PURE__*/ {
    let { className , ...props } = param;
    return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("th", {
        ref: ref,
        className: (0,_lib_utils__WEBPACK_IMPORTED_MODULE_2__.cn)("text-left px-[16px] font-normal first:pl-0 py-[12px] align-middle text-neutral-04 dark:text-main-white Nunito-400 [&:has([role=checkbox])]:pr-0", className),
        ...props
    });
});
TableHead.displayName = "TableHead";
const TableCell = /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_1__.forwardRef((param, ref)=>/*#__PURE__*/ {
    let { className , ...props } = param;
    return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("td", {
        ref: ref,
        className: (0,_lib_utils__WEBPACK_IMPORTED_MODULE_2__.cn)("py-[12px] px-[16px] first:pl-0 align-middle [&:has([role=checkbox])]:pr-0", className),
        ...props
    });
});
TableCell.displayName = "TableCell";
const TableCaption = /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_1__.forwardRef((param, ref)=>/*#__PURE__*/ {
    let { className , ...props } = param;
    return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("caption", {
        ref: ref,
        className: (0,_lib_utils__WEBPACK_IMPORTED_MODULE_2__.cn)("mt-4 text-sm text-muted-foreground", className),
        ...props
    });
});
TableCaption.displayName = "TableCaption";



/***/ }),

/***/ 98241:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "mQ": function() { return /* binding */ Tabs; },
  "nU": function() { return /* binding */ TabsContent; },
  "dr": function() { return /* binding */ TabsList; },
  "SP": function() { return /* binding */ TabsTrigger; }
});

// EXTERNAL MODULE: ./node_modules/next/dist/compiled/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(41844);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/react/index.js
var react = __webpack_require__(55784);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__(87462);
// EXTERNAL MODULE: ./node_modules/@radix-ui/primitive/dist/index.mjs
var dist = __webpack_require__(36206);
// EXTERNAL MODULE: ./node_modules/@radix-ui/react-context/dist/index.mjs
var react_context_dist = __webpack_require__(25360);
// EXTERNAL MODULE: ./node_modules/@radix-ui/react-roving-focus/dist/index.mjs
var react_roving_focus_dist = __webpack_require__(66681);
// EXTERNAL MODULE: ./node_modules/@radix-ui/react-presence/dist/index.mjs
var react_presence_dist = __webpack_require__(29115);
// EXTERNAL MODULE: ./node_modules/@radix-ui/react-primitive/dist/index.mjs
var react_primitive_dist = __webpack_require__(75320);
// EXTERNAL MODULE: ./node_modules/@radix-ui/react-direction/dist/index.mjs
var react_direction_dist = __webpack_require__(78990);
// EXTERNAL MODULE: ./node_modules/@radix-ui/react-use-controllable-state/dist/index.mjs
var react_use_controllable_state_dist = __webpack_require__(77342);
// EXTERNAL MODULE: ./node_modules/@radix-ui/react-id/dist/index.mjs
var react_id_dist = __webpack_require__(91276);
;// CONCATENATED MODULE: ./node_modules/@radix-ui/react-tabs/dist/index.mjs






















/* -------------------------------------------------------------------------------------------------
 * Tabs
 * -----------------------------------------------------------------------------------------------*/ const $69cb30bb0017df05$var$TABS_NAME = 'Tabs';
const [$69cb30bb0017df05$var$createTabsContext, $69cb30bb0017df05$export$355f5bd209d7b13a] = (0,react_context_dist/* createContextScope */.b)($69cb30bb0017df05$var$TABS_NAME, [
    react_roving_focus_dist/* createRovingFocusGroupScope */.Pc
]);
const $69cb30bb0017df05$var$useRovingFocusGroupScope = (0,react_roving_focus_dist/* createRovingFocusGroupScope */.Pc)();
const [$69cb30bb0017df05$var$TabsProvider, $69cb30bb0017df05$var$useTabsContext] = $69cb30bb0017df05$var$createTabsContext($69cb30bb0017df05$var$TABS_NAME);
const $69cb30bb0017df05$export$b2539bed5023c21c = /*#__PURE__*/ (0,react.forwardRef)((props, forwardedRef)=>{
    const { __scopeTabs: __scopeTabs , value: valueProp , onValueChange: onValueChange , defaultValue: defaultValue , orientation: orientation = 'horizontal' , dir: dir , activationMode: activationMode = 'automatic' , ...tabsProps } = props;
    const direction = (0,react_direction_dist/* useDirection */.gm)(dir);
    const [value, setValue] = (0,react_use_controllable_state_dist/* useControllableState */.T)({
        prop: valueProp,
        onChange: onValueChange,
        defaultProp: defaultValue
    });
    return /*#__PURE__*/ (0,react.createElement)($69cb30bb0017df05$var$TabsProvider, {
        scope: __scopeTabs,
        baseId: (0,react_id_dist/* useId */.M)(),
        value: value,
        onValueChange: setValue,
        orientation: orientation,
        dir: direction,
        activationMode: activationMode
    }, /*#__PURE__*/ (0,react.createElement)(react_primitive_dist/* Primitive.div */.WV.div, (0,esm_extends/* default */.Z)({
        dir: direction,
        "data-orientation": orientation
    }, tabsProps, {
        ref: forwardedRef
    })));
});
/*#__PURE__*/ Object.assign($69cb30bb0017df05$export$b2539bed5023c21c, {
    displayName: $69cb30bb0017df05$var$TABS_NAME
});
/* -------------------------------------------------------------------------------------------------
 * TabsList
 * -----------------------------------------------------------------------------------------------*/ const $69cb30bb0017df05$var$TAB_LIST_NAME = 'TabsList';
const $69cb30bb0017df05$export$9712d22edc0d78c1 = /*#__PURE__*/ (0,react.forwardRef)((props, forwardedRef)=>{
    const { __scopeTabs: __scopeTabs , loop: loop = true , ...listProps } = props;
    const context = $69cb30bb0017df05$var$useTabsContext($69cb30bb0017df05$var$TAB_LIST_NAME, __scopeTabs);
    const rovingFocusGroupScope = $69cb30bb0017df05$var$useRovingFocusGroupScope(__scopeTabs);
    return /*#__PURE__*/ (0,react.createElement)(react_roving_focus_dist/* Root */.fC, (0,esm_extends/* default */.Z)({
        asChild: true
    }, rovingFocusGroupScope, {
        orientation: context.orientation,
        dir: context.dir,
        loop: loop
    }), /*#__PURE__*/ (0,react.createElement)(react_primitive_dist/* Primitive.div */.WV.div, (0,esm_extends/* default */.Z)({
        role: "tablist",
        "aria-orientation": context.orientation
    }, listProps, {
        ref: forwardedRef
    })));
});
/*#__PURE__*/ Object.assign($69cb30bb0017df05$export$9712d22edc0d78c1, {
    displayName: $69cb30bb0017df05$var$TAB_LIST_NAME
});
/* -------------------------------------------------------------------------------------------------
 * TabsTrigger
 * -----------------------------------------------------------------------------------------------*/ const $69cb30bb0017df05$var$TRIGGER_NAME = 'TabsTrigger';
const $69cb30bb0017df05$export$8114b9fdfdf9f3ba = /*#__PURE__*/ (0,react.forwardRef)((props, forwardedRef)=>{
    const { __scopeTabs: __scopeTabs , value: value , disabled: disabled = false , ...triggerProps } = props;
    const context = $69cb30bb0017df05$var$useTabsContext($69cb30bb0017df05$var$TRIGGER_NAME, __scopeTabs);
    const rovingFocusGroupScope = $69cb30bb0017df05$var$useRovingFocusGroupScope(__scopeTabs);
    const triggerId = $69cb30bb0017df05$var$makeTriggerId(context.baseId, value);
    const contentId = $69cb30bb0017df05$var$makeContentId(context.baseId, value);
    const isSelected = value === context.value;
    return /*#__PURE__*/ (0,react.createElement)(react_roving_focus_dist/* Item */.ck, (0,esm_extends/* default */.Z)({
        asChild: true
    }, rovingFocusGroupScope, {
        focusable: !disabled,
        active: isSelected
    }), /*#__PURE__*/ (0,react.createElement)(react_primitive_dist/* Primitive.button */.WV.button, (0,esm_extends/* default */.Z)({
        type: "button",
        role: "tab",
        "aria-selected": isSelected,
        "aria-controls": contentId,
        "data-state": isSelected ? 'active' : 'inactive',
        "data-disabled": disabled ? '' : undefined,
        disabled: disabled,
        id: triggerId
    }, triggerProps, {
        ref: forwardedRef,
        onMouseDown: (0,dist/* composeEventHandlers */.M)(props.onMouseDown, (event)=>{
            // only call handler if it's the left button (mousedown gets triggered by all mouse buttons)
            // but not when the control key is pressed (avoiding MacOS right click)
            if (!disabled && event.button === 0 && event.ctrlKey === false) context.onValueChange(value);
            else // prevent focus to avoid accidental activation
            event.preventDefault();
        }),
        onKeyDown: (0,dist/* composeEventHandlers */.M)(props.onKeyDown, (event)=>{
            if ([
                ' ',
                'Enter'
            ].includes(event.key)) context.onValueChange(value);
        }),
        onFocus: (0,dist/* composeEventHandlers */.M)(props.onFocus, ()=>{
            // handle "automatic" activation if necessary
            // ie. activate tab following focus
            const isAutomaticActivation = context.activationMode !== 'manual';
            if (!isSelected && !disabled && isAutomaticActivation) context.onValueChange(value);
        })
    })));
});
/*#__PURE__*/ Object.assign($69cb30bb0017df05$export$8114b9fdfdf9f3ba, {
    displayName: $69cb30bb0017df05$var$TRIGGER_NAME
});
/* -------------------------------------------------------------------------------------------------
 * TabsContent
 * -----------------------------------------------------------------------------------------------*/ const $69cb30bb0017df05$var$CONTENT_NAME = 'TabsContent';
const $69cb30bb0017df05$export$bd905d70e8fd2ebb = /*#__PURE__*/ (0,react.forwardRef)((props, forwardedRef)=>{
    const { __scopeTabs: __scopeTabs , value: value , forceMount: forceMount , children: children , ...contentProps } = props;
    const context = $69cb30bb0017df05$var$useTabsContext($69cb30bb0017df05$var$CONTENT_NAME, __scopeTabs);
    const triggerId = $69cb30bb0017df05$var$makeTriggerId(context.baseId, value);
    const contentId = $69cb30bb0017df05$var$makeContentId(context.baseId, value);
    const isSelected = value === context.value;
    const isMountAnimationPreventedRef = (0,react.useRef)(isSelected);
    (0,react.useEffect)(()=>{
        const rAF = requestAnimationFrame(()=>isMountAnimationPreventedRef.current = false
        );
        return ()=>cancelAnimationFrame(rAF)
        ;
    }, []);
    return /*#__PURE__*/ (0,react.createElement)(react_presence_dist/* Presence */.z, {
        present: forceMount || isSelected
    }, ({ present: present  })=>/*#__PURE__*/ (0,react.createElement)(react_primitive_dist/* Primitive.div */.WV.div, (0,esm_extends/* default */.Z)({
            "data-state": isSelected ? 'active' : 'inactive',
            "data-orientation": context.orientation,
            role: "tabpanel",
            "aria-labelledby": triggerId,
            hidden: !present,
            id: contentId,
            tabIndex: 0
        }, contentProps, {
            ref: forwardedRef,
            style: {
                ...props.style,
                animationDuration: isMountAnimationPreventedRef.current ? '0s' : undefined
            }
        }), present && children)
    );
});
/*#__PURE__*/ Object.assign($69cb30bb0017df05$export$bd905d70e8fd2ebb, {
    displayName: $69cb30bb0017df05$var$CONTENT_NAME
});
/* ---------------------------------------------------------------------------------------------- */ function $69cb30bb0017df05$var$makeTriggerId(baseId, value) {
    return `${baseId}-trigger-${value}`;
}
function $69cb30bb0017df05$var$makeContentId(baseId, value) {
    return `${baseId}-content-${value}`;
}
const $69cb30bb0017df05$export$be92b6f5f03c0fe9 = $69cb30bb0017df05$export$b2539bed5023c21c;
const $69cb30bb0017df05$export$54c2e3dc7acea9f5 = $69cb30bb0017df05$export$9712d22edc0d78c1;
const $69cb30bb0017df05$export$41fb9f06171c75f4 = $69cb30bb0017df05$export$8114b9fdfdf9f3ba;
const $69cb30bb0017df05$export$7c6e2c02157bb7d2 = $69cb30bb0017df05$export$bd905d70e8fd2ebb;





//# sourceMappingURL=index.mjs.map

// EXTERNAL MODULE: ./app/lib/utils.ts + 1 modules
var utils = __webpack_require__(73848);
;// CONCATENATED MODULE: ./app/components/ui/tabs.tsx




const Tabs = $69cb30bb0017df05$export$be92b6f5f03c0fe9;
const TabsList = /*#__PURE__*/ react.forwardRef((param, ref)=>/*#__PURE__*/ {
    let { className , ...props } = param;
    return (0,jsx_runtime.jsx)($69cb30bb0017df05$export$54c2e3dc7acea9f5, {
        ref: ref,
        className: (0,utils.cn)("inline-flex items-center justify-center rounded-md px-[20px] gap-[24px] text-neutral-06 dark:text-neutral-07 border-b-[1px] border-black/10", className),
        ...props
    });
});
TabsList.displayName = $69cb30bb0017df05$export$54c2e3dc7acea9f5.displayName;
const TabsTrigger = /*#__PURE__*/ react.forwardRef((param, ref)=>/*#__PURE__*/ {
    let { className , ...props } = param;
    return (0,jsx_runtime.jsx)($69cb30bb0017df05$export$41fb9f06171c75f4, {
        ref: ref,
        className: (0,utils.cn)("inline-flex items-center justify-center whitespace-nowrap px-[24px] py-[12px] transition-ease-in-out focus-visible:outline-none focus:bg-transparent disabled:pointer-events-none disabled:opacity-50 data-[state=active]:bg-transparent data-[state=active]:text-main-01 Nunito-600 data-[state=active]:Nunito-700 data-[state=active]:border-b-[1.5px] data-[state=active]:border-main-01 dark:data-[state=inactive]:text-main-white", className),
        ...props
    });
});
TabsTrigger.displayName = $69cb30bb0017df05$export$41fb9f06171c75f4.displayName;
const TabsContent = /*#__PURE__*/ react.forwardRef((param, ref)=>/*#__PURE__*/ {
    let { className , ...props } = param;
    return (0,jsx_runtime.jsx)($69cb30bb0017df05$export$7c6e2c02157bb7d2, {
        ref: ref,
        className: (0,utils.cn)("mt-2 ring-offset-background focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2", className),
        ...props
    });
});
TabsContent.displayName = $69cb30bb0017df05$export$7c6e2c02157bb7d2.displayName;



/***/ }),

/***/ 61397:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "g": function() { return /* binding */ Textarea; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(41844);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(55784);
/* harmony import */ var _lib_utils__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(73848);



const Textarea = /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_1__.forwardRef((param, ref)=>{
    let { className , ...props } = param;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("textarea", {
        className: (0,_lib_utils__WEBPACK_IMPORTED_MODULE_2__.cn)("flex min-h-[80px] w-full rounded-[12px] border border-black/10 px-3 py-2 text-[16px] outline-0 placeholder:text-neutral-05 disabled:cursor-not-allowed disabled:opacity-50", className),
        ref: ref,
        ...props
    });
});
Textarea.displayName = "Textarea";



/***/ }),

/***/ 2786:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Am": function() { return /* binding */ toast; },
/* harmony export */   "pm": function() { return /* binding */ useToast; }
/* harmony export */ });
/* unused harmony export reducer */
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(55784);
// Inspired by react-hot-toast library

const TOAST_LIMIT = 1;
const TOAST_REMOVE_DELAY = 1000000;
const actionTypes = {
    ADD_TOAST: "ADD_TOAST",
    UPDATE_TOAST: "UPDATE_TOAST",
    DISMISS_TOAST: "DISMISS_TOAST",
    REMOVE_TOAST: "REMOVE_TOAST"
};
let count = 0;
function genId() {
    count = (count + 1) % Number.MAX_SAFE_INTEGER;
    return count.toString();
}
const toastTimeouts = new Map();
const addToRemoveQueue = (toastId)=>{
    if (toastTimeouts.has(toastId)) {
        return;
    }
    const timeout = setTimeout(()=>{
        toastTimeouts.delete(toastId);
        dispatch({
            type: "REMOVE_TOAST",
            toastId: toastId
        });
    }, TOAST_REMOVE_DELAY);
    toastTimeouts.set(toastId, timeout);
};
const reducer = (state, action)=>{
    switch(action.type){
        case "ADD_TOAST":
            return {
                ...state,
                toasts: [
                    action.toast,
                    ...state.toasts
                ].slice(0, TOAST_LIMIT)
            };
        case "UPDATE_TOAST":
            return {
                ...state,
                toasts: state.toasts.map((t)=>t.id === action.toast.id ? {
                        ...t,
                        ...action.toast
                    } : t)
            };
        case "DISMISS_TOAST":
            {
                const { toastId  } = action;
                // ! Side effects ! - This could be extracted into a dismissToast() action,
                // but I'll keep it here for simplicity
                if (toastId) {
                    addToRemoveQueue(toastId);
                } else {
                    state.toasts.forEach((toast)=>{
                        addToRemoveQueue(toast.id);
                    });
                }
                return {
                    ...state,
                    toasts: state.toasts.map((t)=>t.id === toastId || toastId === undefined ? {
                            ...t,
                            open: false
                        } : t)
                };
            }
        case "REMOVE_TOAST":
            if (action.toastId === undefined) {
                return {
                    ...state,
                    toasts: []
                };
            }
            return {
                ...state,
                toasts: state.toasts.filter((t)=>t.id !== action.toastId)
            };
    }
};
const listeners = [];
let memoryState = {
    toasts: []
};
function dispatch(action) {
    memoryState = reducer(memoryState, action);
    listeners.forEach((listener)=>{
        listener(memoryState);
    });
}
function toast(param) {
    let { ...props } = param;
    const id = genId();
    const update = (props)=>dispatch({
            type: "UPDATE_TOAST",
            toast: {
                ...props,
                id
            }
        });
    const dismiss = ()=>dispatch({
            type: "DISMISS_TOAST",
            toastId: id
        });
    dispatch({
        type: "ADD_TOAST",
        toast: {
            ...props,
            id,
            open: true,
            onOpenChange: (open)=>{
                if (!open) dismiss();
            }
        }
    });
    return {
        id: id,
        dismiss,
        update
    };
}
function useToast() {
    const [state, setState] = react__WEBPACK_IMPORTED_MODULE_0__.useState(memoryState);
    react__WEBPACK_IMPORTED_MODULE_0__.useEffect(()=>{
        listeners.push(setState);
        return ()=>{
            const index = listeners.indexOf(setState);
            if (index > -1) {
                listeners.splice(index, 1);
            }
        };
    }, [
        state
    ]);
    return {
        ...state,
        toast,
        dismiss: (toastId)=>dispatch({
                type: "DISMISS_TOAST",
                toastId
            })
    };
}



/***/ }),

/***/ 27673:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "V": function() { return /* binding */ ModalViewMedia; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(41844);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(55784);
/* harmony import */ var _app_components_ui_dialog__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(76500);



const ModalViewMedia = (param)=>{
    let { open , src , handleClose  } = param;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_app_components_ui_dialog__WEBPACK_IMPORTED_MODULE_2__/* .Dialog */ .Vq, {
        open: open,
        onOpenChange: handleClose,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_app_components_ui_dialog__WEBPACK_IMPORTED_MODULE_2__/* .DialogContent */ .cZ, {
            className: "sm:rounded-[24px] px-6 py-4 bg-transparent outline-none border-0 flex items-center justify-center w-fit",
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                src: src,
                className: "max-w-[80vw] max-h-[80vh]"
            })
        })
    });
};


/***/ }),

/***/ 54254:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "au": function() { return /* reexport */ COMMENT_LIMIT_SIZE; },
  "q0": function() { return /* reexport */ CreateType; },
  "zT": function() { return /* reexport */ DATE_FORMAT; },
  "G": function() { return /* reexport */ DATE_FORMAT_2; },
  "V7": function() { return /* reexport */ DATE_FORMAT_2_REVERT; },
  "Ly": function() { return /* reexport */ DATE_FORMAT_3; },
  "Ob": function() { return /* reexport */ DATE_FORMAT_FULL; },
  "fI": function() { return /* reexport */ DATE_FORMAT_HOUR; },
  "ji": function() { return /* reexport */ EMOTION_ELEMENT_HEIGHT; },
  "As": function() { return /* reexport */ END_YEAR; },
  "aL": function() { return /* reexport */ FACEBOOK_PIXEL_ID; },
  "cB": function() { return /* reexport */ FROM_YEAR; },
  "yf": function() { return /* reexport */ GC_TYPE; },
  "yO": function() { return /* reexport */ GIFTCODE_TYPE; },
  "sd": function() { return /* reexport */ INTERACTIVE_TYPE; },
  "ZD": function() { return /* reexport */ LANGUAGE_OPTION; },
  "gS": function() { return /* reexport */ LIMIT_PAGE_POST; },
  "Fy": function() { return /* reexport */ LIST_FILE_TYPE_IMAGE; },
  "yz": function() { return /* reexport */ MAX_LENGTH_TITLE; },
  "rK": function() { return /* reexport */ MENU_TAB; },
  "ES": function() { return /* reexport */ MISSION_TYPE; },
  "tx": function() { return /* reexport */ NOTIFICATION_TYPE; },
  "a6": function() { return /* reexport */ OPEN_MODAL; },
  "uG": function() { return /* reexport */ PACKAGE_TYPE; },
  "lP": function() { return /* reexport */ QUERY_KEY; },
  "bn": function() { return /* reexport */ REPLY_LIMIT_SIZE; },
  "rb": function() { return /* reexport */ SPIN_TYPE; },
  "xb": function() { return /* reexport */ SPLIT_URL_STRING; },
  "vC": function() { return /* reexport */ TAB_ITEM_PACKAGE_TYPE; },
  "fy": function() { return /* reexport */ TIMEOUT_SPIN; },
  "eU": function() { return /* reexport */ TIMEOUT_SPIN_LIXI; },
  "_W": function() { return /* reexport */ XSOLLA_METHOD; },
  "Ax": function() { return /* reexport */ _15M_TIME_STAMP; },
  "$N": function() { return /* reexport */ defaultOptions; },
  "C5": function() { return /* reexport */ isClient; },
  "r8": function() { return /* reexport */ isDev; },
  "$y": function() { return /* reexport */ meta; },
  "e7": function() { return /* reexport */ months; },
  "YO": function() { return /* reexport */ vnMonth; }
});

// UNUSED EXPORTS: GA_ID, LIMIT_QUANTITY, REWARD_TAB, STALE_TIME, _24H_TIME_STAMP, isMain

;// CONCATENATED MODULE: ./app/configs/environments.ts
const API_URL = "https://api.playee.net";
const isClient = "object" !== "undefined";
const isDev = API_URL === null || API_URL === void 0 ? void 0 : API_URL.includes("dev");
const isMain = !isDev;

;// CONCATENATED MODULE: ./app/configs/constants.ts
const GA_ID = (/* unused pure expression or super */ null && ("G-YWFRPYDZRY"));
const FACEBOOK_PIXEL_ID = "2582194471816724";
var _process_env_NEXT_PUBLIC_HOST_URL;
const URI = (_process_env_NEXT_PUBLIC_HOST_URL = "https://playee.vn") !== null && _process_env_NEXT_PUBLIC_HOST_URL !== void 0 ? _process_env_NEXT_PUBLIC_HOST_URL : "";
const DATE_FORMAT = "DD/MM/YYYY";
const DATE_FORMAT_2 = "DD-MM-YYYY";
const DATE_FORMAT_FULL = "HH:mm:ss DD/MM/YYYY";
const DATE_FORMAT_3 = "HH:mm DD/MM/YYYY";
const DATE_FORMAT_2_REVERT = "YYYY-MM-DD";
const DATE_FORMAT_HOUR = "h[h] DD/MM/YYYY";
const LANGUAGE_OPTION = {
    VIETNAMESE: "vi",
    ENGLISH: "en"
};
const OPEN_MODAL = {
    SELECT_CREATE_POST_MODAL: "select-create-post-modal",
    LOGIN_MODAL: "login-modal",
    SHARE_MODAL: "share-modal",
    VIEW_MEDIA: "view-media",
    COMMINGSOON_MODAL: "commingsoon_modal",
    FRIEND_MODAL: "friend-modal",
    EDIT_HASHTAG: "edit-hashtag",
    SHARE_REFER_CODE: "share-refer-code"
};
const MENU_TAB = {
    GAME_TAB: "/game",
    NEWS_TAB: "/news",
    STORE_TAB: "/",
    USER: "/user/[id]",
    SELECT_CREATE_POST: "/?modal=".concat(OPEN_MODAL.SELECT_CREATE_POST_MODAL),
    OPTION_PROFILE: "/option-profile"
};
const meta = {
    title: "Playee - Entertaining the world",
    desc: "Tham gia cộng đồng Playee, kh\xe1m ph\xe1 thế giới game v\xf4 tận",
    keyword: "",
    url: URI,
    site_name: "Playee",
    image: URI + "/img/playee_portal.png",
    canonical: URI
};
const QUERY_KEY = {
    // common
    SEARCH: "search",
    LOGIN_FACEBOOK: "login-facebook",
    LOGIN_GOOGLE: "login-google",
    LOGIN_NORMAL: "login-normal",
    GET_URL_LOGIN_FACEBOOK: "get-url-login-facebook",
    GET_URL_LOGIN_GOOGLE: "get-url-login-google",
    PROFILE_INFO: "profile-info",
    NOTIFICATION_LIST: "notification-list",
    // Game
    LIST_GAME: "list-game",
    LIST_GAME_BANNER: "list-game-banner",
    LIST_CATEGORY: "list-category",
    GAME_DETAIL: "game-detail",
    FOLLOW_GAME: "follow-game",
    REGISTER_GAME: "register-game",
    GAME_REVIEW_LIST: "game-review-list",
    LIKE_REVIEW: "like-review",
    RATE_GAME: "rate-game",
    REPLY_REVIEW_GAME: "reply-review-game",
    DELETE_REVIEW_GAME: "delete-review-game",
    DELETE_REPLY_REVIEW_GAME: "delete-reply-review-game",
    LIST_GAME_INFINITE: "list-game-infinite",
    // News Events
    LIST_NEWS: "list-news",
    LIST_EVENT: "list-event",
    NEWS_DETAIL: "news-detail",
    LIST_COMMENT: "list-comments",
    CREATE_NEWS: "create-news",
    SAVE_DRAFT: "save-draft",
    ADD_COMMENT: "add-comment",
    LIKE_POST: "like-post",
    LIKE_COMMENT: "like-comment",
    REPLY_COMMENT: "reply-comment",
    LIST_REPLY: "list-reply",
    DELETE_COMMENT: "delete-comment",
    UPDATE_COMMENT: "update-comment",
    GET_STICKER_USER: "get-sticker-user",
    CHECK_DRAFT: "check-draft",
    CHECK_DRAFT_EVENT: "check-draft-event",
    DELETE_DRAFT: "delete-draft",
    UPLOAD_MEDIA: "upload-media",
    DELETE_NEWS: "delete-news",
    CREATE_EVENT: "create-event",
    EVENT_DETAIL: "event-detail",
    DELETE_EVENT: "delete-event",
    EDIT_NEWS: "edit-news",
    EDIT_EVENT: "edit-event",
    JOIN_EVENT: "join-event",
    DELETE_DRAFT_EVENT: "delete-draft-event",
    SAVE_DRAFT_EVENTS: "save-draft-event",
    LIST_RELATED_NEWS: "list-related-news",
    LIST_HOT: "list-hot",
    NEWS_FOR_YOU: "news-for-you",
    LIST_NEWS_LATEST: "list-news-latest",
    LIST_NEWS_BY_HASHTAG: "list-news-by-hashtag",
    LIST_EVENT_BY_TYPE: "list-event-by-type",
    LIST_RELATED_NEWS_BY_GAME: "list-related-news-by-game",
    LIST_RELATED_EVENT_BY_GAME: "list-related-event-by-game",
    LIST_RELATED_EVENT: "list-related-event",
    REG_NOTIFICATION_EVENT: "reg-notification-event",
    LIST_NEWS_BY_USER: "list-news-by-user",
    LIST_NEWS_BY_OTHER_USER: "list-news-by-other-user",
    MY_NEWS_BY_FILTER: "my-news-by-filter",
    MY_EVENT_BY_FILTER: "my-event-by-filter",
    LIST_EVENT_BY_HASHTAG: "list-event-by-hashtag",
    // profile
    FOLLOW_PARTNER: "follow-partner",
    LIST_FOLLOWING: "list-following",
    UPDATE_LANGUAGE: "update-language",
    UPLOAD_AVATAR: "upload-avatar",
    UPDATE_PROFILE: "update-profile",
    STORE_NEWS: "store-new",
    REMOVE_STORE_NEWS: "remove-store-news",
    LIST_STORED_NEWS: "list-stored-news",
    HOT_TOPIC: "hot-topic",
    LIST_HOBBIES: "list-hobbies",
    UPDATE_INTEREST_TOPIC: "update-interest-topic",
    TOPUP_TRANSACTION: "topup-transaction",
    CARD_TRANSACTION: "card-transaction",
    POINT_HISTORY: "point-history",
    UPDATE_INVITE_CODE: "update-invite-code",
    NEWS_DETAIL_FOR_EDIT: "news-detail-for-edit",
    EVENT_DETAIL_FOR_EDIT: "event-detail-for-edit",
    ANALYTIC_GET_TOTAL_NEWS: "analytic-get-total-news",
    ANALYTIC_GET_TOTAL_EVENT: "analytic-get-total-event",
    ANALYTIC_GET_TOTAL_USER_FOLLOW_PARTNER: "analytic-get-total-user-follow-partner",
    ANALYTIC_GET_TOTAL_USER_JOINED_EVENT: "analytic-get-total-user-joined-event",
    ANALYTIC_NEWS: "analytic-news",
    ANALYTIC_EVENT: "analytic-event",
    GET_PROFILE_BY_ID: "get-profile-by-id",
    ANALYTIC_GET_TOTAL_LIKE_NEWS: "analytic-get-total-like-news",
    ANALYTIC_GET_TOTAL_COMMENT_NEWS: "analytic-get-total-comment-news",
    LIST_FRIEND: "list-friend",
    LIST_FRIEND_WITH_SEARCH: "list-friend-with-search",
    LIST_SUGGEST_FRIEND: "list-suggest-friend",
    ADD_FRIEND: "add-friend",
    SEND_FRIEND: "send-friend",
    ACTION_REQUEST_FRIEND: "action-request-friend",
    UN_FRIEND: "un-friend",
    LIST_REQUEST_FRIEND: " list-request-friend",
    ANALYTIC_CHART_DATA: "analytic-chart-data",
    LIST_SUGGEST_FRIEND_BY_GAME: "list-suggest-friend-by-game",
    OTHER_USER_EVENT_BY_FILTER: "other-user-event-by-filter",
    OTHER_USER_NEWS_BY_FILTER: "other-user-news-by-filter",
    CANCEL_SENDING_REQUEST: "cancel-sending-request",
    //store
    LIST_PRODUCT: "list-product",
    TOPUP_LIST_GAME: "topup-list-game",
    TOPUP_GAME_DETAIL: "topup-game-detail",
    TOPUP_GAME_SERVER: "topup-game-serser",
    TOPUP_GAME_ROLE: "topup-game-role",
    TOPUP_CHECK_PIN: "topup-check-pin",
    TOPUP_DO_LA_CHARGING: "topup-do-la-charging",
    TOPUP_LA_TRANSACTION: "topup-la-transaction",
    ALL_PROVINCE: "all-province",
    CREATE_ADDRESS: "create-address",
    // reward-center
    LIST_SHOP_ITEM: "list-shop-item",
    BUY_ITEM_SHOP: "buy-item-shop",
    LIST_MISSION: "list-mission",
    LIST_GAME_FOLLOW: "list-game-follow",
    PACKAGE_LIST: "package-list",
    REFERRAL_HISTORY: "referral-history",
    USE_ITEM: "use-item",
    LIST_GAME_BY_GIFTCODE: "list-game-by-giftcode",
    // help-center
    GET_LIST_CATEGORY: "get-list-category",
    GET_LIST_TICKET_CATEGORY: "get-list-ticket-category",
    SUBMIT_TICKET: "submit-ticket",
    GET_LIST_TICKET: "get-list-ticket",
    // merchandise
    MERCHANDISE_LIST: "merchandise-list",
    MERCHANDISE_CATEGORY_LIST: "merchandise-category-list",
    MERCHANDISE_GAME_LIST: "merchandise-game-list",
    MERCHANDISE_CART: "merchandise-cart",
    MERCHANDISE_DETAIL: "merchandise-detail",
    MERCHANDISE_METHOD: "merchandise-method",
    MERCHANDISE_ADDRESS: "merchandise-address",
    BUY_NOW_MERCHANDISE: "buy-now-merchandise",
    CREATE_NOW_PAYMENT_MERCHANDISE: "create-now-payment-merchandise",
    ADD_TO_CART_MERCHANDISE: "add-to-cart-merchandise",
    UPDATE_CART_MERCHANDISE: "update-cart-merchandise",
    UPDATE_QUICK_CART_MERCHANDISE: "update-quick-cart-merchandise",
    DELETE_CART_MERCHANDISE: "delete-cart-merchandise",
    DESTROY_ORDER: "destroy-order",
    DELETE_ADDRESS_MERCHANDISE: "delete-address-merchandise",
    UPDATE_ADDRESS_MERCHANDISE: "update-address-merchandise",
    CREATE_PAYMENT_MERCHANDISE: "create-payment-merchandise",
    CALLBACK_PAYMENT_MERCHANDISE: "callback-payment-merchandise",
    CALLBACK_ONEPAY_MERCHANDISE: "callback-onepay-merchandise",
    PAYMENT_TRANSACTION_MERCHANDISE: "payment-transaction-merchandise",
    MERCHANDISE_PAYMENT_FEE_SHIP: "merchandise-payment-fee-ship",
    MERCHANDISE_HISTORY: "merchandise-history",
    //giftcode
    LIST_GIFTCODE: "list-giftcode",
    LIST_GAME_GIFTCODE: "list-game-giftcode",
    LIST_SERVER_GIFTCODE: "list-server-giftcode",
    LIST_ROLE_GIFTCODE: "list-role-giftcode",
    GIFTCODE_DETAIL: "giftcode-detail",
    GIFTCODE_INFO: "giftcode-info",
    USE_GIFTCODE: "use-giftcode"
};
const STALE_TIME = 60 * 1000;
const MAX_LENGTH_TITLE = 100;
const COMMENT_LIMIT_SIZE = 5;
const REPLY_LIMIT_SIZE = 10;
const LIMIT_QUANTITY = 20;
const LIMIT_PAGE_POST = 10;
const SPLIT_URL_STRING = "/Gifs_";
const LIST_FILE_TYPE_IMAGE = [
    "png",
    "jpeg",
    "jpg",
    "svg",
    "gif"
];
const NOTIFICATION_TYPE = {
    COMMENT: "comment",
    REPLY_COMMENT: "reply_comment",
    LIKE: "like",
    TASK: "task",
    SPIN: "spin",
    SHOP: "shop",
    EVENT: "event",
    TICKET: "ticket",
    GROUP_NOTI: "group_noti",
    PURCHASE: "purchase",
    PAYMENT_RESULT: "payment_result",
    CREATE_ORDER_RESULT: "create_order_result",
    TOPUP_GAME: "topup_game",
    SPIN_GAME: "spin_game",
    TOPUP_GAME_EVENT: "topup_game_event",
    REG_NOTI_EVEMT: "reg_noti_event",
    REQUEST_FRIEND: "request_friend",
    ACCEPT_FRIEND: "accept_request_friend",
    BAG_EXPIRED: "bag_expired",
    EVENT_MERCHANDISE: "event_merchandise",
    SEND_GIFT_FRIEND: "send_gift_friend"
};
const GC_TYPE = {
    BY_GAME: "by-game",
    FOR_YOU: "for-you",
    IS_HOT: "is-hot",
    AVAILABLE: "available"
};
const MISSION_TYPE = {
    CHECKIN: "checkin",
    ACTIVATE: "activate",
    INVITE: "invite",
    INTERACTIVE: "interaction",
    VERIFY_ACCOUNT: "verify_account"
};
const INTERACTIVE_TYPE = {
    REVIEW_GAME: "comment_review_game",
    RATE_GAME: "rate_game",
    POST_CONTENT: "post_content",
    JOIN_GROUP: "join_group",
    COMMENT_CONTENT: "comment_content",
    FOLLOW_USER: "follow_user"
};
const REWARD_TAB = {
    MY_ORDER: "my-order",
    SHOP_GOLD: "shop-gold",
    EXCHANGE_ITEM: "exchange-item",
    REWARD_CENTER: "reward-center"
};
const EMOTION_ELEMENT_HEIGHT = 454;
var CreateType;
(function(CreateType) {
    CreateType["CREATE_POST"] = "create-news";
    CreateType["CREATE_EVENT"] = "create-event";
})(CreateType || (CreateType = {}));
const vnMonth = [
    "Th\xe1ng 1",
    "Th\xe1ng 2",
    "Th\xe1ng 3",
    "Th\xe1ng 4",
    "Th\xe1ng 5",
    "Th\xe1ng 6",
    "Th\xe1ng 7",
    "Th\xe1ng 8",
    "Th\xe1ng 9",
    "Th\xe1ng 10",
    "Th\xe1ng 11",
    "Th\xe1ng 12"
];
const months = [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec"
];
const FROM_YEAR = 2020;
const END_YEAR = 2100;
const TIMEOUT_SPIN = 4000;
const TIMEOUT_SPIN_LIXI = 3000;
const SPIN_TYPE = {
    POINT: "point",
    GIFTCODE: "giftcode",
    LOST_TURN: "lost_turn",
    GIFT_ITEM: "gift_item",
    SECRET_GIFT: "secret_gift",
    TURNS: "turns",
    PLAYEE_VOUCHER: "playee_voucher",
    APPOTA_CARD: "appota_card"
};
const PACKAGE_TYPE = {
    AVATAR: "avatar",
    GIFTCODE: "giftcode",
    GC: "gc",
    STICKER: "sticker",
    APPOTA_CARD: "appota_card",
    VOUCHER: "voucher",
    GIFT_VOUCHER: "gift_voucher",
    GIFT_ITEM: "gift_item"
};
const GIFTCODE_TYPE = {
    USED: "done",
    PENDING: "pending"
};
const TAB_ITEM_PACKAGE_TYPE = {
    GIFTCODE: "giftcode",
    CARD: "appota_card",
    VOUCHER: "voucher",
    OTHER: "other"
};
const _24H_TIME_STAMP = 86400;
const _15M_TIME_STAMP = 900;
const XSOLLA_METHOD = "xsolla";

;// CONCATENATED MODULE: ./app/configs/queryOption.ts

const defaultOptions = {
    queries: {
        // onError: queryErrorHandler,
        staleTime: STALE_TIME,
        refetchOnMount: true,
        refetchOnReconnect: false,
        refetchOnWindowFocus: false,
        retry: false
    },
    mutations: {
    }
};

;// CONCATENATED MODULE: ./app/configs/index.ts





/***/ }),

/***/ 73126:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "k": function() { return /* binding */ CustomSelectMonthYear; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(41844);
/* harmony import */ var react_day_picker__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(28808);
/* harmony import */ var _app_components_ui_select__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(80522);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(55784);
/* harmony import */ var next_i18next__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(93378);
/* harmony import */ var _app_configs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(54254);
/* harmony import */ var _app_context__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(17986);
/* eslint-disable react/jsx-key */ 






function CustomSelectMonthYear(props) {
    const { t  } = (0,next_i18next__WEBPACK_IMPORTED_MODULE_4__/* .useTranslation */ .$G)();
    const { userInfo  } = (0,react__WEBPACK_IMPORTED_MODULE_3__.useContext)(_app_context__WEBPACK_IMPORTED_MODULE_6__/* .AppContext */ .Il);
    const { currentMonth , goToMonth  } = (0,react_day_picker__WEBPACK_IMPORTED_MODULE_1__/* .useNavigation */ .HJ)();
    const [date, setDate] = (0,react__WEBPACK_IMPORTED_MODULE_3__.useState)({
        month: Number(currentMonth.getMonth()),
        year: Number(currentMonth.getFullYear())
    });
    const listMonth = (userInfo === null || userInfo === void 0 ? void 0 : userInfo.lang) === "vi" ? _app_configs__WEBPACK_IMPORTED_MODULE_5__/* .vnMonth */ .YO : _app_configs__WEBPACK_IMPORTED_MODULE_5__/* .months */ .e7;
    const listYear = Array.from({
        length: _app_configs__WEBPACK_IMPORTED_MODULE_5__/* .END_YEAR */ .As - _app_configs__WEBPACK_IMPORTED_MODULE_5__/* .FROM_YEAR */ .cB + 1
    }, (_, index)=>_app_configs__WEBPACK_IMPORTED_MODULE_5__/* .FROM_YEAR */ .cB + index);
    const onValueChange = (value, type)=>{
        if (type === "year") {
            const month = date.month;
            const year = Number(value);
            setDate({
                ...date,
                year
            });
            goToMonth(new Date(year, month));
        }
        if (type === "month") {
            const month1 = listMonth.indexOf(value);
            const year1 = date.year;
            setDate({
                ...date,
                month: month1
            });
            goToMonth(new Date(year1, month1));
        }
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: "grid grid-cols-2 gap-2",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_app_components_ui_select__WEBPACK_IMPORTED_MODULE_2__/* .Select */ .Ph, {
                    onValueChange: (value)=>onValueChange(value, "month"),
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_app_components_ui_select__WEBPACK_IMPORTED_MODULE_2__/* .SelectTrigger */ .i4, {
                            className: "w-full border-0 m-0 md:m-2 Nunito-700 text-base text-main-01 placeholder:text-main-01 dark:text-white dark:bg-white/10 dark:backdrop-blur-[20px]",
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_app_components_ui_select__WEBPACK_IMPORTED_MODULE_2__/* .SelectValue */ .ki, {
                                placeholder: listMonth[Number(currentMonth.getMonth())]
                            })
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_app_components_ui_select__WEBPACK_IMPORTED_MODULE_2__/* .SelectContent */ .Bw, {
                            className: "p-1 rounded-[16px] max-h-[250px]",
                            children: listMonth.map((item)=>/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_app_components_ui_select__WEBPACK_IMPORTED_MODULE_2__/* .SelectItem */ .Ql, {
                                    value: item,
                                    className: "py-[8px] px-[16px] rounded-[12px] hover:!bg-bg-disable hover:!text-main-01 text-base Nunito-600 focus:bg-bg-disable focus:text-main-01 dark:hover:!bg-[#F1F1FC]/[.1] dark:focus:!bg-[#F1F1FC]/[.1] text-center flex items-center justify-center cursor-pointer",
                                    children: item
                                }, String(item)))
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_app_components_ui_select__WEBPACK_IMPORTED_MODULE_2__/* .Select */ .Ph, {
                    onValueChange: (value)=>onValueChange(value, "year"),
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_app_components_ui_select__WEBPACK_IMPORTED_MODULE_2__/* .SelectTrigger */ .i4, {
                            className: "w-full border-0 m-0 md:m-2 Nunito-700 text-base text-main-01 placeholder:text-main-01 dark:text-white dark:bg-white/10 dark:backdrop-blur-[20px]",
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_app_components_ui_select__WEBPACK_IMPORTED_MODULE_2__/* .SelectValue */ .ki, {
                                placeholder: Number(currentMonth.getFullYear()),
                                className: "text-base Nunito-700 text-main-01 placeholder:text-main-01"
                            })
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_app_components_ui_select__WEBPACK_IMPORTED_MODULE_2__/* .SelectContent */ .Bw, {
                            className: "p-1 rounded-[16px] rounded-tl-none rounded-tr-none max-h-[250px]",
                            children: listYear.map((item)=>/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_app_components_ui_select__WEBPACK_IMPORTED_MODULE_2__/* .SelectItem */ .Ql, {
                                    value: String(item),
                                    className: "py-[8px] px-[16px] rounded-[12px] hover:!bg-bg-disable hover:!text-main-01 text-base Nunito-600 focus:bg-bg-disable focus:text-main-01 dark:hover:!bg-[#F1F1FC]/[.1] dark:focus:!bg-[#F1F1FC]/[.1] text-center flex items-center justify-center cursor-pointer",
                                    children: item
                                }, String(item)))
                        })
                    ]
                })
            })
        ]
    });
}


/***/ }),

/***/ 16314:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "NX": function() { return /* reexport */ CreatePostContainer; },
  "_A": function() { return /* reexport */ LoginModal; },
  "Os": function() { return /* reexport */ SelectCreatePostModal; }
});

// UNUSED EXPORTS: initialCreatePostValues

// EXTERNAL MODULE: ./node_modules/next/dist/compiled/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(41844);
// EXTERNAL MODULE: ./node_modules/react-hook-form/dist/index.esm.mjs
var index_esm = __webpack_require__(87536);
;// CONCATENATED MODULE: ./node_modules/@hookform/resolvers/dist/resolvers.mjs
var t=function(e,t,i){if(e&&"reportValidity"in e){var n=(0,index_esm/* get */.U2)(i,t);e.setCustomValidity(n&&n.message||""),e.reportValidity()}},resolvers_i=function(r,e){var i=function(i){var n=e.fields[i];n&&n.ref&&"reportValidity"in n.ref?t(n.ref,i,r):n.refs&&n.refs.forEach(function(e){return t(e,i,r)})};for(var n in e.fields)i(n)},n=function(t,n){n.shouldUseNativeValidation&&resolvers_i(t,n);var f={};for(var s in t){var u=(0,index_esm/* get */.U2)(n.fields,s),c=Object.assign(t[s]||{},{ref:u&&u.ref});if(a(n.names||Object.keys(t),s)){var l=Object.assign({},o((0,index_esm/* get */.U2)(f,s)));(0,index_esm/* set */.t8)(l,"root",c),(0,index_esm/* set */.t8)(f,s,l)}else (0,index_esm/* set */.t8)(f,s,c)}return f},o=function(r){return Array.isArray(r)?r.filter(Boolean):[]},a=function(r,e){return r.some(function(r){return r.startsWith(e+".")})};
//# sourceMappingURL=resolvers.module.js.map

;// CONCATENATED MODULE: ./node_modules/@hookform/resolvers/zod/dist/zod.mjs
var zod_n=function(e,o){for(var n={};e.length;){var t=e[0],s=t.code,i=t.message,a=t.path.join(".");if(!n[a])if("unionErrors"in t){var u=t.unionErrors[0].errors[0];n[a]={message:u.message,type:u.code}}else n[a]={message:i,type:s};if("unionErrors"in t&&t.unionErrors.forEach(function(r){return r.errors.forEach(function(r){return e.push(r)})}),o){var c=n[a].types,f=c&&c[t.code];n[a]=(0,index_esm/* appendErrors */.KN)(a,o,n,s,f?[].concat(f,t.message):t.message)}e.shift()}return n},zod_t=function(r,t,s){return void 0===s&&(s={}),function(i,a,u){try{return Promise.resolve(function(o,n){try{var a=Promise.resolve(r["sync"===s.mode?"parse":"parseAsync"](i,t)).then(function(r){return u.shouldUseNativeValidation&&resolvers_i({},u),{errors:{},values:s.raw?i:r}})}catch(r){return n(r)}return a&&a.then?a.then(void 0,n):a}(0,function(r){if(function(r){return null!=r.errors}(r))return{values:{},errors:n(zod_n(r.errors,!u.shouldUseNativeValidation&&"all"===u.criteriaMode),u)};throw r}))}catch(r){return Promise.reject(r)}}};
//# sourceMappingURL=zod.module.js.map

// EXTERNAL MODULE: ./node_modules/next-i18next/dist/esm/index.js + 41 modules
var esm = __webpack_require__(93378);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/react/index.js
var react = __webpack_require__(55784);
var react_namespaceObject = /*#__PURE__*/__webpack_require__.t(react, 2);
;// CONCATENATED MODULE: ./node_modules/zod/lib/index.mjs
var util;
(function (util) {
    util.assertEqual = (val) => val;
    function assertIs(_arg) { }
    util.assertIs = assertIs;
    function assertNever(_x) {
        throw new Error();
    }
    util.assertNever = assertNever;
    util.arrayToEnum = (items) => {
        const obj = {};
        for (const item of items) {
            obj[item] = item;
        }
        return obj;
    };
    util.getValidEnumValues = (obj) => {
        const validKeys = util.objectKeys(obj).filter((k) => typeof obj[obj[k]] !== "number");
        const filtered = {};
        for (const k of validKeys) {
            filtered[k] = obj[k];
        }
        return util.objectValues(filtered);
    };
    util.objectValues = (obj) => {
        return util.objectKeys(obj).map(function (e) {
            return obj[e];
        });
    };
    util.objectKeys = typeof Object.keys === "function" // eslint-disable-line ban/ban
        ? (obj) => Object.keys(obj) // eslint-disable-line ban/ban
        : (object) => {
            const keys = [];
            for (const key in object) {
                if (Object.prototype.hasOwnProperty.call(object, key)) {
                    keys.push(key);
                }
            }
            return keys;
        };
    util.find = (arr, checker) => {
        for (const item of arr) {
            if (checker(item))
                return item;
        }
        return undefined;
    };
    util.isInteger = typeof Number.isInteger === "function"
        ? (val) => Number.isInteger(val) // eslint-disable-line ban/ban
        : (val) => typeof val === "number" && isFinite(val) && Math.floor(val) === val;
    function joinValues(array, separator = " | ") {
        return array
            .map((val) => (typeof val === "string" ? `'${val}'` : val))
            .join(separator);
    }
    util.joinValues = joinValues;
    util.jsonStringifyReplacer = (_, value) => {
        if (typeof value === "bigint") {
            return value.toString();
        }
        return value;
    };
})(util || (util = {}));
var objectUtil;
(function (objectUtil) {
    objectUtil.mergeShapes = (first, second) => {
        return {
            ...first,
            ...second, // second overwrites first
        };
    };
})(objectUtil || (objectUtil = {}));
const ZodParsedType = util.arrayToEnum([
    "string",
    "nan",
    "number",
    "integer",
    "float",
    "boolean",
    "date",
    "bigint",
    "symbol",
    "function",
    "undefined",
    "null",
    "array",
    "object",
    "unknown",
    "promise",
    "void",
    "never",
    "map",
    "set",
]);
const getParsedType = (data) => {
    const t = typeof data;
    switch (t) {
        case "undefined":
            return ZodParsedType.undefined;
        case "string":
            return ZodParsedType.string;
        case "number":
            return isNaN(data) ? ZodParsedType.nan : ZodParsedType.number;
        case "boolean":
            return ZodParsedType.boolean;
        case "function":
            return ZodParsedType.function;
        case "bigint":
            return ZodParsedType.bigint;
        case "symbol":
            return ZodParsedType.symbol;
        case "object":
            if (Array.isArray(data)) {
                return ZodParsedType.array;
            }
            if (data === null) {
                return ZodParsedType.null;
            }
            if (data.then &&
                typeof data.then === "function" &&
                data.catch &&
                typeof data.catch === "function") {
                return ZodParsedType.promise;
            }
            if (typeof Map !== "undefined" && data instanceof Map) {
                return ZodParsedType.map;
            }
            if (typeof Set !== "undefined" && data instanceof Set) {
                return ZodParsedType.set;
            }
            if (typeof Date !== "undefined" && data instanceof Date) {
                return ZodParsedType.date;
            }
            return ZodParsedType.object;
        default:
            return ZodParsedType.unknown;
    }
};

const ZodIssueCode = util.arrayToEnum([
    "invalid_type",
    "invalid_literal",
    "custom",
    "invalid_union",
    "invalid_union_discriminator",
    "invalid_enum_value",
    "unrecognized_keys",
    "invalid_arguments",
    "invalid_return_type",
    "invalid_date",
    "invalid_string",
    "too_small",
    "too_big",
    "invalid_intersection_types",
    "not_multiple_of",
    "not_finite",
]);
const quotelessJson = (obj) => {
    const json = JSON.stringify(obj, null, 2);
    return json.replace(/"([^"]+)":/g, "$1:");
};
class ZodError extends Error {
    constructor(issues) {
        super();
        this.issues = [];
        this.addIssue = (sub) => {
            this.issues = [...this.issues, sub];
        };
        this.addIssues = (subs = []) => {
            this.issues = [...this.issues, ...subs];
        };
        const actualProto = new.target.prototype;
        if (Object.setPrototypeOf) {
            // eslint-disable-next-line ban/ban
            Object.setPrototypeOf(this, actualProto);
        }
        else {
            this.__proto__ = actualProto;
        }
        this.name = "ZodError";
        this.issues = issues;
    }
    get errors() {
        return this.issues;
    }
    format(_mapper) {
        const mapper = _mapper ||
            function (issue) {
                return issue.message;
            };
        const fieldErrors = { _errors: [] };
        const processError = (error) => {
            for (const issue of error.issues) {
                if (issue.code === "invalid_union") {
                    issue.unionErrors.map(processError);
                }
                else if (issue.code === "invalid_return_type") {
                    processError(issue.returnTypeError);
                }
                else if (issue.code === "invalid_arguments") {
                    processError(issue.argumentsError);
                }
                else if (issue.path.length === 0) {
                    fieldErrors._errors.push(mapper(issue));
                }
                else {
                    let curr = fieldErrors;
                    let i = 0;
                    while (i < issue.path.length) {
                        const el = issue.path[i];
                        const terminal = i === issue.path.length - 1;
                        if (!terminal) {
                            curr[el] = curr[el] || { _errors: [] };
                            // if (typeof el === "string") {
                            //   curr[el] = curr[el] || { _errors: [] };
                            // } else if (typeof el === "number") {
                            //   const errorArray: any = [];
                            //   errorArray._errors = [];
                            //   curr[el] = curr[el] || errorArray;
                            // }
                        }
                        else {
                            curr[el] = curr[el] || { _errors: [] };
                            curr[el]._errors.push(mapper(issue));
                        }
                        curr = curr[el];
                        i++;
                    }
                }
            }
        };
        processError(this);
        return fieldErrors;
    }
    toString() {
        return this.message;
    }
    get message() {
        return JSON.stringify(this.issues, util.jsonStringifyReplacer, 2);
    }
    get isEmpty() {
        return this.issues.length === 0;
    }
    flatten(mapper = (issue) => issue.message) {
        const fieldErrors = {};
        const formErrors = [];
        for (const sub of this.issues) {
            if (sub.path.length > 0) {
                fieldErrors[sub.path[0]] = fieldErrors[sub.path[0]] || [];
                fieldErrors[sub.path[0]].push(mapper(sub));
            }
            else {
                formErrors.push(mapper(sub));
            }
        }
        return { formErrors, fieldErrors };
    }
    get formErrors() {
        return this.flatten();
    }
}
ZodError.create = (issues) => {
    const error = new ZodError(issues);
    return error;
};

const errorMap = (issue, _ctx) => {
    let message;
    switch (issue.code) {
        case ZodIssueCode.invalid_type:
            if (issue.received === ZodParsedType.undefined) {
                message = "Required";
            }
            else {
                message = `Expected ${issue.expected}, received ${issue.received}`;
            }
            break;
        case ZodIssueCode.invalid_literal:
            message = `Invalid literal value, expected ${JSON.stringify(issue.expected, util.jsonStringifyReplacer)}`;
            break;
        case ZodIssueCode.unrecognized_keys:
            message = `Unrecognized key(s) in object: ${util.joinValues(issue.keys, ", ")}`;
            break;
        case ZodIssueCode.invalid_union:
            message = `Invalid input`;
            break;
        case ZodIssueCode.invalid_union_discriminator:
            message = `Invalid discriminator value. Expected ${util.joinValues(issue.options)}`;
            break;
        case ZodIssueCode.invalid_enum_value:
            message = `Invalid enum value. Expected ${util.joinValues(issue.options)}, received '${issue.received}'`;
            break;
        case ZodIssueCode.invalid_arguments:
            message = `Invalid function arguments`;
            break;
        case ZodIssueCode.invalid_return_type:
            message = `Invalid function return type`;
            break;
        case ZodIssueCode.invalid_date:
            message = `Invalid date`;
            break;
        case ZodIssueCode.invalid_string:
            if (typeof issue.validation === "object") {
                if ("includes" in issue.validation) {
                    message = `Invalid input: must include "${issue.validation.includes}"`;
                    if (typeof issue.validation.position === "number") {
                        message = `${message} at one or more positions greater than or equal to ${issue.validation.position}`;
                    }
                }
                else if ("startsWith" in issue.validation) {
                    message = `Invalid input: must start with "${issue.validation.startsWith}"`;
                }
                else if ("endsWith" in issue.validation) {
                    message = `Invalid input: must end with "${issue.validation.endsWith}"`;
                }
                else {
                    util.assertNever(issue.validation);
                }
            }
            else if (issue.validation !== "regex") {
                message = `Invalid ${issue.validation}`;
            }
            else {
                message = "Invalid";
            }
            break;
        case ZodIssueCode.too_small:
            if (issue.type === "array")
                message = `Array must contain ${issue.exact ? "exactly" : issue.inclusive ? `at least` : `more than`} ${issue.minimum} element(s)`;
            else if (issue.type === "string")
                message = `String must contain ${issue.exact ? "exactly" : issue.inclusive ? `at least` : `over`} ${issue.minimum} character(s)`;
            else if (issue.type === "number")
                message = `Number must be ${issue.exact
                    ? `exactly equal to `
                    : issue.inclusive
                        ? `greater than or equal to `
                        : `greater than `}${issue.minimum}`;
            else if (issue.type === "date")
                message = `Date must be ${issue.exact
                    ? `exactly equal to `
                    : issue.inclusive
                        ? `greater than or equal to `
                        : `greater than `}${new Date(Number(issue.minimum))}`;
            else
                message = "Invalid input";
            break;
        case ZodIssueCode.too_big:
            if (issue.type === "array")
                message = `Array must contain ${issue.exact ? `exactly` : issue.inclusive ? `at most` : `less than`} ${issue.maximum} element(s)`;
            else if (issue.type === "string")
                message = `String must contain ${issue.exact ? `exactly` : issue.inclusive ? `at most` : `under`} ${issue.maximum} character(s)`;
            else if (issue.type === "number")
                message = `Number must be ${issue.exact
                    ? `exactly`
                    : issue.inclusive
                        ? `less than or equal to`
                        : `less than`} ${issue.maximum}`;
            else if (issue.type === "bigint")
                message = `BigInt must be ${issue.exact
                    ? `exactly`
                    : issue.inclusive
                        ? `less than or equal to`
                        : `less than`} ${issue.maximum}`;
            else if (issue.type === "date")
                message = `Date must be ${issue.exact
                    ? `exactly`
                    : issue.inclusive
                        ? `smaller than or equal to`
                        : `smaller than`} ${new Date(Number(issue.maximum))}`;
            else
                message = "Invalid input";
            break;
        case ZodIssueCode.custom:
            message = `Invalid input`;
            break;
        case ZodIssueCode.invalid_intersection_types:
            message = `Intersection results could not be merged`;
            break;
        case ZodIssueCode.not_multiple_of:
            message = `Number must be a multiple of ${issue.multipleOf}`;
            break;
        case ZodIssueCode.not_finite:
            message = "Number must be finite";
            break;
        default:
            message = _ctx.defaultError;
            util.assertNever(issue);
    }
    return { message };
};

let overrideErrorMap = errorMap;
function setErrorMap(map) {
    overrideErrorMap = map;
}
function getErrorMap() {
    return overrideErrorMap;
}

const makeIssue = (params) => {
    const { data, path, errorMaps, issueData } = params;
    const fullPath = [...path, ...(issueData.path || [])];
    const fullIssue = {
        ...issueData,
        path: fullPath,
    };
    let errorMessage = "";
    const maps = errorMaps
        .filter((m) => !!m)
        .slice()
        .reverse();
    for (const map of maps) {
        errorMessage = map(fullIssue, { data, defaultError: errorMessage }).message;
    }
    return {
        ...issueData,
        path: fullPath,
        message: issueData.message || errorMessage,
    };
};
const EMPTY_PATH = [];
function addIssueToContext(ctx, issueData) {
    const issue = makeIssue({
        issueData: issueData,
        data: ctx.data,
        path: ctx.path,
        errorMaps: [
            ctx.common.contextualErrorMap,
            ctx.schemaErrorMap,
            getErrorMap(),
            errorMap, // then global default map
        ].filter((x) => !!x),
    });
    ctx.common.issues.push(issue);
}
class ParseStatus {
    constructor() {
        this.value = "valid";
    }
    dirty() {
        if (this.value === "valid")
            this.value = "dirty";
    }
    abort() {
        if (this.value !== "aborted")
            this.value = "aborted";
    }
    static mergeArray(status, results) {
        const arrayValue = [];
        for (const s of results) {
            if (s.status === "aborted")
                return INVALID;
            if (s.status === "dirty")
                status.dirty();
            arrayValue.push(s.value);
        }
        return { status: status.value, value: arrayValue };
    }
    static async mergeObjectAsync(status, pairs) {
        const syncPairs = [];
        for (const pair of pairs) {
            syncPairs.push({
                key: await pair.key,
                value: await pair.value,
            });
        }
        return ParseStatus.mergeObjectSync(status, syncPairs);
    }
    static mergeObjectSync(status, pairs) {
        const finalObject = {};
        for (const pair of pairs) {
            const { key, value } = pair;
            if (key.status === "aborted")
                return INVALID;
            if (value.status === "aborted")
                return INVALID;
            if (key.status === "dirty")
                status.dirty();
            if (value.status === "dirty")
                status.dirty();
            if (key.value !== "__proto__" &&
                (typeof value.value !== "undefined" || pair.alwaysSet)) {
                finalObject[key.value] = value.value;
            }
        }
        return { status: status.value, value: finalObject };
    }
}
const INVALID = Object.freeze({
    status: "aborted",
});
const DIRTY = (value) => ({ status: "dirty", value });
const OK = (value) => ({ status: "valid", value });
const isAborted = (x) => x.status === "aborted";
const isDirty = (x) => x.status === "dirty";
const isValid = (x) => x.status === "valid";
const isAsync = (x) => typeof Promise !== "undefined" && x instanceof Promise;

var errorUtil;
(function (errorUtil) {
    errorUtil.errToObj = (message) => typeof message === "string" ? { message } : message || {};
    errorUtil.toString = (message) => typeof message === "string" ? message : message === null || message === void 0 ? void 0 : message.message;
})(errorUtil || (errorUtil = {}));

class ParseInputLazyPath {
    constructor(parent, value, path, key) {
        this._cachedPath = [];
        this.parent = parent;
        this.data = value;
        this._path = path;
        this._key = key;
    }
    get path() {
        if (!this._cachedPath.length) {
            if (this._key instanceof Array) {
                this._cachedPath.push(...this._path, ...this._key);
            }
            else {
                this._cachedPath.push(...this._path, this._key);
            }
        }
        return this._cachedPath;
    }
}
const handleResult = (ctx, result) => {
    if (isValid(result)) {
        return { success: true, data: result.value };
    }
    else {
        if (!ctx.common.issues.length) {
            throw new Error("Validation failed but no issues detected.");
        }
        return {
            success: false,
            get error() {
                if (this._error)
                    return this._error;
                const error = new ZodError(ctx.common.issues);
                this._error = error;
                return this._error;
            },
        };
    }
};
function processCreateParams(params) {
    if (!params)
        return {};
    const { errorMap, invalid_type_error, required_error, description } = params;
    if (errorMap && (invalid_type_error || required_error)) {
        throw new Error(`Can't use "invalid_type_error" or "required_error" in conjunction with custom error map.`);
    }
    if (errorMap)
        return { errorMap: errorMap, description };
    const customMap = (iss, ctx) => {
        if (iss.code !== "invalid_type")
            return { message: ctx.defaultError };
        if (typeof ctx.data === "undefined") {
            return { message: required_error !== null && required_error !== void 0 ? required_error : ctx.defaultError };
        }
        return { message: invalid_type_error !== null && invalid_type_error !== void 0 ? invalid_type_error : ctx.defaultError };
    };
    return { errorMap: customMap, description };
}
class ZodType {
    constructor(def) {
        /** Alias of safeParseAsync */
        this.spa = this.safeParseAsync;
        this._def = def;
        this.parse = this.parse.bind(this);
        this.safeParse = this.safeParse.bind(this);
        this.parseAsync = this.parseAsync.bind(this);
        this.safeParseAsync = this.safeParseAsync.bind(this);
        this.spa = this.spa.bind(this);
        this.refine = this.refine.bind(this);
        this.refinement = this.refinement.bind(this);
        this.superRefine = this.superRefine.bind(this);
        this.optional = this.optional.bind(this);
        this.nullable = this.nullable.bind(this);
        this.nullish = this.nullish.bind(this);
        this.array = this.array.bind(this);
        this.promise = this.promise.bind(this);
        this.or = this.or.bind(this);
        this.and = this.and.bind(this);
        this.transform = this.transform.bind(this);
        this.brand = this.brand.bind(this);
        this.default = this.default.bind(this);
        this.catch = this.catch.bind(this);
        this.describe = this.describe.bind(this);
        this.pipe = this.pipe.bind(this);
        this.readonly = this.readonly.bind(this);
        this.isNullable = this.isNullable.bind(this);
        this.isOptional = this.isOptional.bind(this);
    }
    get description() {
        return this._def.description;
    }
    _getType(input) {
        return getParsedType(input.data);
    }
    _getOrReturnCtx(input, ctx) {
        return (ctx || {
            common: input.parent.common,
            data: input.data,
            parsedType: getParsedType(input.data),
            schemaErrorMap: this._def.errorMap,
            path: input.path,
            parent: input.parent,
        });
    }
    _processInputParams(input) {
        return {
            status: new ParseStatus(),
            ctx: {
                common: input.parent.common,
                data: input.data,
                parsedType: getParsedType(input.data),
                schemaErrorMap: this._def.errorMap,
                path: input.path,
                parent: input.parent,
            },
        };
    }
    _parseSync(input) {
        const result = this._parse(input);
        if (isAsync(result)) {
            throw new Error("Synchronous parse encountered promise.");
        }
        return result;
    }
    _parseAsync(input) {
        const result = this._parse(input);
        return Promise.resolve(result);
    }
    parse(data, params) {
        const result = this.safeParse(data, params);
        if (result.success)
            return result.data;
        throw result.error;
    }
    safeParse(data, params) {
        var _a;
        const ctx = {
            common: {
                issues: [],
                async: (_a = params === null || params === void 0 ? void 0 : params.async) !== null && _a !== void 0 ? _a : false,
                contextualErrorMap: params === null || params === void 0 ? void 0 : params.errorMap,
            },
            path: (params === null || params === void 0 ? void 0 : params.path) || [],
            schemaErrorMap: this._def.errorMap,
            parent: null,
            data,
            parsedType: getParsedType(data),
        };
        const result = this._parseSync({ data, path: ctx.path, parent: ctx });
        return handleResult(ctx, result);
    }
    async parseAsync(data, params) {
        const result = await this.safeParseAsync(data, params);
        if (result.success)
            return result.data;
        throw result.error;
    }
    async safeParseAsync(data, params) {
        const ctx = {
            common: {
                issues: [],
                contextualErrorMap: params === null || params === void 0 ? void 0 : params.errorMap,
                async: true,
            },
            path: (params === null || params === void 0 ? void 0 : params.path) || [],
            schemaErrorMap: this._def.errorMap,
            parent: null,
            data,
            parsedType: getParsedType(data),
        };
        const maybeAsyncResult = this._parse({ data, path: ctx.path, parent: ctx });
        const result = await (isAsync(maybeAsyncResult)
            ? maybeAsyncResult
            : Promise.resolve(maybeAsyncResult));
        return handleResult(ctx, result);
    }
    refine(check, message) {
        const getIssueProperties = (val) => {
            if (typeof message === "string" || typeof message === "undefined") {
                return { message };
            }
            else if (typeof message === "function") {
                return message(val);
            }
            else {
                return message;
            }
        };
        return this._refinement((val, ctx) => {
            const result = check(val);
            const setError = () => ctx.addIssue({
                code: ZodIssueCode.custom,
                ...getIssueProperties(val),
            });
            if (typeof Promise !== "undefined" && result instanceof Promise) {
                return result.then((data) => {
                    if (!data) {
                        setError();
                        return false;
                    }
                    else {
                        return true;
                    }
                });
            }
            if (!result) {
                setError();
                return false;
            }
            else {
                return true;
            }
        });
    }
    refinement(check, refinementData) {
        return this._refinement((val, ctx) => {
            if (!check(val)) {
                ctx.addIssue(typeof refinementData === "function"
                    ? refinementData(val, ctx)
                    : refinementData);
                return false;
            }
            else {
                return true;
            }
        });
    }
    _refinement(refinement) {
        return new ZodEffects({
            schema: this,
            typeName: ZodFirstPartyTypeKind.ZodEffects,
            effect: { type: "refinement", refinement },
        });
    }
    superRefine(refinement) {
        return this._refinement(refinement);
    }
    optional() {
        return ZodOptional.create(this, this._def);
    }
    nullable() {
        return ZodNullable.create(this, this._def);
    }
    nullish() {
        return this.nullable().optional();
    }
    array() {
        return ZodArray.create(this, this._def);
    }
    promise() {
        return ZodPromise.create(this, this._def);
    }
    or(option) {
        return ZodUnion.create([this, option], this._def);
    }
    and(incoming) {
        return ZodIntersection.create(this, incoming, this._def);
    }
    transform(transform) {
        return new ZodEffects({
            ...processCreateParams(this._def),
            schema: this,
            typeName: ZodFirstPartyTypeKind.ZodEffects,
            effect: { type: "transform", transform },
        });
    }
    default(def) {
        const defaultValueFunc = typeof def === "function" ? def : () => def;
        return new ZodDefault({
            ...processCreateParams(this._def),
            innerType: this,
            defaultValue: defaultValueFunc,
            typeName: ZodFirstPartyTypeKind.ZodDefault,
        });
    }
    brand() {
        return new ZodBranded({
            typeName: ZodFirstPartyTypeKind.ZodBranded,
            type: this,
            ...processCreateParams(this._def),
        });
    }
    catch(def) {
        const catchValueFunc = typeof def === "function" ? def : () => def;
        return new ZodCatch({
            ...processCreateParams(this._def),
            innerType: this,
            catchValue: catchValueFunc,
            typeName: ZodFirstPartyTypeKind.ZodCatch,
        });
    }
    describe(description) {
        const This = this.constructor;
        return new This({
            ...this._def,
            description,
        });
    }
    pipe(target) {
        return ZodPipeline.create(this, target);
    }
    readonly() {
        return ZodReadonly.create(this);
    }
    isOptional() {
        return this.safeParse(undefined).success;
    }
    isNullable() {
        return this.safeParse(null).success;
    }
}
const cuidRegex = /^c[^\s-]{8,}$/i;
const cuid2Regex = /^[a-z][a-z0-9]*$/;
const ulidRegex = /^[0-9A-HJKMNP-TV-Z]{26}$/;
// const uuidRegex =
//   /^([a-f0-9]{8}-[a-f0-9]{4}-[1-5][a-f0-9]{3}-[a-f0-9]{4}-[a-f0-9]{12}|00000000-0000-0000-0000-000000000000)$/i;
const uuidRegex = /^[0-9a-fA-F]{8}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{12}$/i;
// from https://stackoverflow.com/a/46181/1550155
// old version: too slow, didn't support unicode
// const emailRegex = /^((([a-z]|\d|[!#\$%&'\*\+\-\/=\?\^_`{\|}~]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])+(\.([a-z]|\d|[!#\$%&'\*\+\-\/=\?\^_`{\|}~]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])+)*)|((\x22)((((\x20|\x09)*(\x0d\x0a))?(\x20|\x09)+)?(([\x01-\x08\x0b\x0c\x0e-\x1f\x7f]|\x21|[\x23-\x5b]|[\x5d-\x7e]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(\\([\x01-\x09\x0b\x0c\x0d-\x7f]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]))))*(((\x20|\x09)*(\x0d\x0a))?(\x20|\x09)+)?(\x22)))@((([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.)+(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))$/i;
//old email regex
// const emailRegex = /^(([^<>()[\].,;:\s@"]+(\.[^<>()[\].,;:\s@"]+)*)|(".+"))@((?!-)([^<>()[\].,;:\s@"]+\.)+[^<>()[\].,;:\s@"]{1,})[^-<>()[\].,;:\s@"]$/i;
// eslint-disable-next-line
// const emailRegex =
//   /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[(((25[0-5])|(2[0-4][0-9])|(1[0-9]{2})|([0-9]{1,2}))\.){3}((25[0-5])|(2[0-4][0-9])|(1[0-9]{2})|([0-9]{1,2}))\])|(\[IPv6:(([a-f0-9]{1,4}:){7}|::([a-f0-9]{1,4}:){0,6}|([a-f0-9]{1,4}:){1}:([a-f0-9]{1,4}:){0,5}|([a-f0-9]{1,4}:){2}:([a-f0-9]{1,4}:){0,4}|([a-f0-9]{1,4}:){3}:([a-f0-9]{1,4}:){0,3}|([a-f0-9]{1,4}:){4}:([a-f0-9]{1,4}:){0,2}|([a-f0-9]{1,4}:){5}:([a-f0-9]{1,4}:){0,1})([a-f0-9]{1,4}|(((25[0-5])|(2[0-4][0-9])|(1[0-9]{2})|([0-9]{1,2}))\.){3}((25[0-5])|(2[0-4][0-9])|(1[0-9]{2})|([0-9]{1,2})))\])|([A-Za-z0-9]([A-Za-z0-9-]*[A-Za-z0-9])*(\.[A-Za-z]{2,})+))$/;
// const emailRegex =
//   /^[a-zA-Z0-9\.\!\#\$\%\&\'\*\+\/\=\?\^\_\`\{\|\}\~\-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$/;
// const emailRegex =
//   /^(?:[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*|"(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21\x23-\x5b\x5d-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])*")@(?:(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?|\[(?:(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.){3}(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?|[a-z0-9-]*[a-z0-9]:(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21-\x5a\x53-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])+)\])$/i;
const emailRegex = /^(?!\.)(?!.*\.\.)([A-Z0-9_+-\.]*)[A-Z0-9_+-]@([A-Z0-9][A-Z0-9\-]*\.)+[A-Z]{2,}$/i;
// const emailRegex =
//   /^[a-z0-9.!#$%&’*+/=?^_`{|}~-]+@[a-z0-9-]+(?:\.[a-z0-9\-]+)*$/i;
// from https://thekevinscott.com/emojis-in-javascript/#writing-a-regular-expression
const _emojiRegex = `^(\\p{Extended_Pictographic}|\\p{Emoji_Component})+$`;
let emojiRegex;
const ipv4Regex = /^(((25[0-5])|(2[0-4][0-9])|(1[0-9]{2})|([0-9]{1,2}))\.){3}((25[0-5])|(2[0-4][0-9])|(1[0-9]{2})|([0-9]{1,2}))$/;
const ipv6Regex = /^(([a-f0-9]{1,4}:){7}|::([a-f0-9]{1,4}:){0,6}|([a-f0-9]{1,4}:){1}:([a-f0-9]{1,4}:){0,5}|([a-f0-9]{1,4}:){2}:([a-f0-9]{1,4}:){0,4}|([a-f0-9]{1,4}:){3}:([a-f0-9]{1,4}:){0,3}|([a-f0-9]{1,4}:){4}:([a-f0-9]{1,4}:){0,2}|([a-f0-9]{1,4}:){5}:([a-f0-9]{1,4}:){0,1})([a-f0-9]{1,4}|(((25[0-5])|(2[0-4][0-9])|(1[0-9]{2})|([0-9]{1,2}))\.){3}((25[0-5])|(2[0-4][0-9])|(1[0-9]{2})|([0-9]{1,2})))$/;
// Adapted from https://stackoverflow.com/a/3143231
const datetimeRegex = (args) => {
    if (args.precision) {
        if (args.offset) {
            return new RegExp(`^\\d{4}-\\d{2}-\\d{2}T\\d{2}:\\d{2}:\\d{2}\\.\\d{${args.precision}}(([+-]\\d{2}(:?\\d{2})?)|Z)$`);
        }
        else {
            return new RegExp(`^\\d{4}-\\d{2}-\\d{2}T\\d{2}:\\d{2}:\\d{2}\\.\\d{${args.precision}}Z$`);
        }
    }
    else if (args.precision === 0) {
        if (args.offset) {
            return new RegExp(`^\\d{4}-\\d{2}-\\d{2}T\\d{2}:\\d{2}:\\d{2}(([+-]\\d{2}(:?\\d{2})?)|Z)$`);
        }
        else {
            return new RegExp(`^\\d{4}-\\d{2}-\\d{2}T\\d{2}:\\d{2}:\\d{2}Z$`);
        }
    }
    else {
        if (args.offset) {
            return new RegExp(`^\\d{4}-\\d{2}-\\d{2}T\\d{2}:\\d{2}:\\d{2}(\\.\\d+)?(([+-]\\d{2}(:?\\d{2})?)|Z)$`);
        }
        else {
            return new RegExp(`^\\d{4}-\\d{2}-\\d{2}T\\d{2}:\\d{2}:\\d{2}(\\.\\d+)?Z$`);
        }
    }
};
function isValidIP(ip, version) {
    if ((version === "v4" || !version) && ipv4Regex.test(ip)) {
        return true;
    }
    if ((version === "v6" || !version) && ipv6Regex.test(ip)) {
        return true;
    }
    return false;
}
class ZodString extends ZodType {
    _parse(input) {
        if (this._def.coerce) {
            input.data = String(input.data);
        }
        const parsedType = this._getType(input);
        if (parsedType !== ZodParsedType.string) {
            const ctx = this._getOrReturnCtx(input);
            addIssueToContext(ctx, {
                code: ZodIssueCode.invalid_type,
                expected: ZodParsedType.string,
                received: ctx.parsedType,
            }
            //
            );
            return INVALID;
        }
        const status = new ParseStatus();
        let ctx = undefined;
        for (const check of this._def.checks) {
            if (check.kind === "min") {
                if (input.data.length < check.value) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    addIssueToContext(ctx, {
                        code: ZodIssueCode.too_small,
                        minimum: check.value,
                        type: "string",
                        inclusive: true,
                        exact: false,
                        message: check.message,
                    });
                    status.dirty();
                }
            }
            else if (check.kind === "max") {
                if (input.data.length > check.value) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    addIssueToContext(ctx, {
                        code: ZodIssueCode.too_big,
                        maximum: check.value,
                        type: "string",
                        inclusive: true,
                        exact: false,
                        message: check.message,
                    });
                    status.dirty();
                }
            }
            else if (check.kind === "length") {
                const tooBig = input.data.length > check.value;
                const tooSmall = input.data.length < check.value;
                if (tooBig || tooSmall) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    if (tooBig) {
                        addIssueToContext(ctx, {
                            code: ZodIssueCode.too_big,
                            maximum: check.value,
                            type: "string",
                            inclusive: true,
                            exact: true,
                            message: check.message,
                        });
                    }
                    else if (tooSmall) {
                        addIssueToContext(ctx, {
                            code: ZodIssueCode.too_small,
                            minimum: check.value,
                            type: "string",
                            inclusive: true,
                            exact: true,
                            message: check.message,
                        });
                    }
                    status.dirty();
                }
            }
            else if (check.kind === "email") {
                if (!emailRegex.test(input.data)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    addIssueToContext(ctx, {
                        validation: "email",
                        code: ZodIssueCode.invalid_string,
                        message: check.message,
                    });
                    status.dirty();
                }
            }
            else if (check.kind === "emoji") {
                if (!emojiRegex) {
                    emojiRegex = new RegExp(_emojiRegex, "u");
                }
                if (!emojiRegex.test(input.data)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    addIssueToContext(ctx, {
                        validation: "emoji",
                        code: ZodIssueCode.invalid_string,
                        message: check.message,
                    });
                    status.dirty();
                }
            }
            else if (check.kind === "uuid") {
                if (!uuidRegex.test(input.data)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    addIssueToContext(ctx, {
                        validation: "uuid",
                        code: ZodIssueCode.invalid_string,
                        message: check.message,
                    });
                    status.dirty();
                }
            }
            else if (check.kind === "cuid") {
                if (!cuidRegex.test(input.data)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    addIssueToContext(ctx, {
                        validation: "cuid",
                        code: ZodIssueCode.invalid_string,
                        message: check.message,
                    });
                    status.dirty();
                }
            }
            else if (check.kind === "cuid2") {
                if (!cuid2Regex.test(input.data)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    addIssueToContext(ctx, {
                        validation: "cuid2",
                        code: ZodIssueCode.invalid_string,
                        message: check.message,
                    });
                    status.dirty();
                }
            }
            else if (check.kind === "ulid") {
                if (!ulidRegex.test(input.data)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    addIssueToContext(ctx, {
                        validation: "ulid",
                        code: ZodIssueCode.invalid_string,
                        message: check.message,
                    });
                    status.dirty();
                }
            }
            else if (check.kind === "url") {
                try {
                    new URL(input.data);
                }
                catch (_a) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    addIssueToContext(ctx, {
                        validation: "url",
                        code: ZodIssueCode.invalid_string,
                        message: check.message,
                    });
                    status.dirty();
                }
            }
            else if (check.kind === "regex") {
                check.regex.lastIndex = 0;
                const testResult = check.regex.test(input.data);
                if (!testResult) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    addIssueToContext(ctx, {
                        validation: "regex",
                        code: ZodIssueCode.invalid_string,
                        message: check.message,
                    });
                    status.dirty();
                }
            }
            else if (check.kind === "trim") {
                input.data = input.data.trim();
            }
            else if (check.kind === "includes") {
                if (!input.data.includes(check.value, check.position)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    addIssueToContext(ctx, {
                        code: ZodIssueCode.invalid_string,
                        validation: { includes: check.value, position: check.position },
                        message: check.message,
                    });
                    status.dirty();
                }
            }
            else if (check.kind === "toLowerCase") {
                input.data = input.data.toLowerCase();
            }
            else if (check.kind === "toUpperCase") {
                input.data = input.data.toUpperCase();
            }
            else if (check.kind === "startsWith") {
                if (!input.data.startsWith(check.value)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    addIssueToContext(ctx, {
                        code: ZodIssueCode.invalid_string,
                        validation: { startsWith: check.value },
                        message: check.message,
                    });
                    status.dirty();
                }
            }
            else if (check.kind === "endsWith") {
                if (!input.data.endsWith(check.value)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    addIssueToContext(ctx, {
                        code: ZodIssueCode.invalid_string,
                        validation: { endsWith: check.value },
                        message: check.message,
                    });
                    status.dirty();
                }
            }
            else if (check.kind === "datetime") {
                const regex = datetimeRegex(check);
                if (!regex.test(input.data)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    addIssueToContext(ctx, {
                        code: ZodIssueCode.invalid_string,
                        validation: "datetime",
                        message: check.message,
                    });
                    status.dirty();
                }
            }
            else if (check.kind === "ip") {
                if (!isValidIP(input.data, check.version)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    addIssueToContext(ctx, {
                        validation: "ip",
                        code: ZodIssueCode.invalid_string,
                        message: check.message,
                    });
                    status.dirty();
                }
            }
            else {
                util.assertNever(check);
            }
        }
        return { status: status.value, value: input.data };
    }
    _regex(regex, validation, message) {
        return this.refinement((data) => regex.test(data), {
            validation,
            code: ZodIssueCode.invalid_string,
            ...errorUtil.errToObj(message),
        });
    }
    _addCheck(check) {
        return new ZodString({
            ...this._def,
            checks: [...this._def.checks, check],
        });
    }
    email(message) {
        return this._addCheck({ kind: "email", ...errorUtil.errToObj(message) });
    }
    url(message) {
        return this._addCheck({ kind: "url", ...errorUtil.errToObj(message) });
    }
    emoji(message) {
        return this._addCheck({ kind: "emoji", ...errorUtil.errToObj(message) });
    }
    uuid(message) {
        return this._addCheck({ kind: "uuid", ...errorUtil.errToObj(message) });
    }
    cuid(message) {
        return this._addCheck({ kind: "cuid", ...errorUtil.errToObj(message) });
    }
    cuid2(message) {
        return this._addCheck({ kind: "cuid2", ...errorUtil.errToObj(message) });
    }
    ulid(message) {
        return this._addCheck({ kind: "ulid", ...errorUtil.errToObj(message) });
    }
    ip(options) {
        return this._addCheck({ kind: "ip", ...errorUtil.errToObj(options) });
    }
    datetime(options) {
        var _a;
        if (typeof options === "string") {
            return this._addCheck({
                kind: "datetime",
                precision: null,
                offset: false,
                message: options,
            });
        }
        return this._addCheck({
            kind: "datetime",
            precision: typeof (options === null || options === void 0 ? void 0 : options.precision) === "undefined" ? null : options === null || options === void 0 ? void 0 : options.precision,
            offset: (_a = options === null || options === void 0 ? void 0 : options.offset) !== null && _a !== void 0 ? _a : false,
            ...errorUtil.errToObj(options === null || options === void 0 ? void 0 : options.message),
        });
    }
    regex(regex, message) {
        return this._addCheck({
            kind: "regex",
            regex: regex,
            ...errorUtil.errToObj(message),
        });
    }
    includes(value, options) {
        return this._addCheck({
            kind: "includes",
            value: value,
            position: options === null || options === void 0 ? void 0 : options.position,
            ...errorUtil.errToObj(options === null || options === void 0 ? void 0 : options.message),
        });
    }
    startsWith(value, message) {
        return this._addCheck({
            kind: "startsWith",
            value: value,
            ...errorUtil.errToObj(message),
        });
    }
    endsWith(value, message) {
        return this._addCheck({
            kind: "endsWith",
            value: value,
            ...errorUtil.errToObj(message),
        });
    }
    min(minLength, message) {
        return this._addCheck({
            kind: "min",
            value: minLength,
            ...errorUtil.errToObj(message),
        });
    }
    max(maxLength, message) {
        return this._addCheck({
            kind: "max",
            value: maxLength,
            ...errorUtil.errToObj(message),
        });
    }
    length(len, message) {
        return this._addCheck({
            kind: "length",
            value: len,
            ...errorUtil.errToObj(message),
        });
    }
    /**
     * @deprecated Use z.string().min(1) instead.
     * @see {@link ZodString.min}
     */
    nonempty(message) {
        return this.min(1, errorUtil.errToObj(message));
    }
    trim() {
        return new ZodString({
            ...this._def,
            checks: [...this._def.checks, { kind: "trim" }],
        });
    }
    toLowerCase() {
        return new ZodString({
            ...this._def,
            checks: [...this._def.checks, { kind: "toLowerCase" }],
        });
    }
    toUpperCase() {
        return new ZodString({
            ...this._def,
            checks: [...this._def.checks, { kind: "toUpperCase" }],
        });
    }
    get isDatetime() {
        return !!this._def.checks.find((ch) => ch.kind === "datetime");
    }
    get isEmail() {
        return !!this._def.checks.find((ch) => ch.kind === "email");
    }
    get isURL() {
        return !!this._def.checks.find((ch) => ch.kind === "url");
    }
    get isEmoji() {
        return !!this._def.checks.find((ch) => ch.kind === "emoji");
    }
    get isUUID() {
        return !!this._def.checks.find((ch) => ch.kind === "uuid");
    }
    get isCUID() {
        return !!this._def.checks.find((ch) => ch.kind === "cuid");
    }
    get isCUID2() {
        return !!this._def.checks.find((ch) => ch.kind === "cuid2");
    }
    get isULID() {
        return !!this._def.checks.find((ch) => ch.kind === "ulid");
    }
    get isIP() {
        return !!this._def.checks.find((ch) => ch.kind === "ip");
    }
    get minLength() {
        let min = null;
        for (const ch of this._def.checks) {
            if (ch.kind === "min") {
                if (min === null || ch.value > min)
                    min = ch.value;
            }
        }
        return min;
    }
    get maxLength() {
        let max = null;
        for (const ch of this._def.checks) {
            if (ch.kind === "max") {
                if (max === null || ch.value < max)
                    max = ch.value;
            }
        }
        return max;
    }
}
ZodString.create = (params) => {
    var _a;
    return new ZodString({
        checks: [],
        typeName: ZodFirstPartyTypeKind.ZodString,
        coerce: (_a = params === null || params === void 0 ? void 0 : params.coerce) !== null && _a !== void 0 ? _a : false,
        ...processCreateParams(params),
    });
};
// https://stackoverflow.com/questions/3966484/why-does-modulus-operator-return-fractional-number-in-javascript/31711034#31711034
function floatSafeRemainder(val, step) {
    const valDecCount = (val.toString().split(".")[1] || "").length;
    const stepDecCount = (step.toString().split(".")[1] || "").length;
    const decCount = valDecCount > stepDecCount ? valDecCount : stepDecCount;
    const valInt = parseInt(val.toFixed(decCount).replace(".", ""));
    const stepInt = parseInt(step.toFixed(decCount).replace(".", ""));
    return (valInt % stepInt) / Math.pow(10, decCount);
}
class ZodNumber extends ZodType {
    constructor() {
        super(...arguments);
        this.min = this.gte;
        this.max = this.lte;
        this.step = this.multipleOf;
    }
    _parse(input) {
        if (this._def.coerce) {
            input.data = Number(input.data);
        }
        const parsedType = this._getType(input);
        if (parsedType !== ZodParsedType.number) {
            const ctx = this._getOrReturnCtx(input);
            addIssueToContext(ctx, {
                code: ZodIssueCode.invalid_type,
                expected: ZodParsedType.number,
                received: ctx.parsedType,
            });
            return INVALID;
        }
        let ctx = undefined;
        const status = new ParseStatus();
        for (const check of this._def.checks) {
            if (check.kind === "int") {
                if (!util.isInteger(input.data)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    addIssueToContext(ctx, {
                        code: ZodIssueCode.invalid_type,
                        expected: "integer",
                        received: "float",
                        message: check.message,
                    });
                    status.dirty();
                }
            }
            else if (check.kind === "min") {
                const tooSmall = check.inclusive
                    ? input.data < check.value
                    : input.data <= check.value;
                if (tooSmall) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    addIssueToContext(ctx, {
                        code: ZodIssueCode.too_small,
                        minimum: check.value,
                        type: "number",
                        inclusive: check.inclusive,
                        exact: false,
                        message: check.message,
                    });
                    status.dirty();
                }
            }
            else if (check.kind === "max") {
                const tooBig = check.inclusive
                    ? input.data > check.value
                    : input.data >= check.value;
                if (tooBig) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    addIssueToContext(ctx, {
                        code: ZodIssueCode.too_big,
                        maximum: check.value,
                        type: "number",
                        inclusive: check.inclusive,
                        exact: false,
                        message: check.message,
                    });
                    status.dirty();
                }
            }
            else if (check.kind === "multipleOf") {
                if (floatSafeRemainder(input.data, check.value) !== 0) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    addIssueToContext(ctx, {
                        code: ZodIssueCode.not_multiple_of,
                        multipleOf: check.value,
                        message: check.message,
                    });
                    status.dirty();
                }
            }
            else if (check.kind === "finite") {
                if (!Number.isFinite(input.data)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    addIssueToContext(ctx, {
                        code: ZodIssueCode.not_finite,
                        message: check.message,
                    });
                    status.dirty();
                }
            }
            else {
                util.assertNever(check);
            }
        }
        return { status: status.value, value: input.data };
    }
    gte(value, message) {
        return this.setLimit("min", value, true, errorUtil.toString(message));
    }
    gt(value, message) {
        return this.setLimit("min", value, false, errorUtil.toString(message));
    }
    lte(value, message) {
        return this.setLimit("max", value, true, errorUtil.toString(message));
    }
    lt(value, message) {
        return this.setLimit("max", value, false, errorUtil.toString(message));
    }
    setLimit(kind, value, inclusive, message) {
        return new ZodNumber({
            ...this._def,
            checks: [
                ...this._def.checks,
                {
                    kind,
                    value,
                    inclusive,
                    message: errorUtil.toString(message),
                },
            ],
        });
    }
    _addCheck(check) {
        return new ZodNumber({
            ...this._def,
            checks: [...this._def.checks, check],
        });
    }
    int(message) {
        return this._addCheck({
            kind: "int",
            message: errorUtil.toString(message),
        });
    }
    positive(message) {
        return this._addCheck({
            kind: "min",
            value: 0,
            inclusive: false,
            message: errorUtil.toString(message),
        });
    }
    negative(message) {
        return this._addCheck({
            kind: "max",
            value: 0,
            inclusive: false,
            message: errorUtil.toString(message),
        });
    }
    nonpositive(message) {
        return this._addCheck({
            kind: "max",
            value: 0,
            inclusive: true,
            message: errorUtil.toString(message),
        });
    }
    nonnegative(message) {
        return this._addCheck({
            kind: "min",
            value: 0,
            inclusive: true,
            message: errorUtil.toString(message),
        });
    }
    multipleOf(value, message) {
        return this._addCheck({
            kind: "multipleOf",
            value: value,
            message: errorUtil.toString(message),
        });
    }
    finite(message) {
        return this._addCheck({
            kind: "finite",
            message: errorUtil.toString(message),
        });
    }
    safe(message) {
        return this._addCheck({
            kind: "min",
            inclusive: true,
            value: Number.MIN_SAFE_INTEGER,
            message: errorUtil.toString(message),
        })._addCheck({
            kind: "max",
            inclusive: true,
            value: Number.MAX_SAFE_INTEGER,
            message: errorUtil.toString(message),
        });
    }
    get minValue() {
        let min = null;
        for (const ch of this._def.checks) {
            if (ch.kind === "min") {
                if (min === null || ch.value > min)
                    min = ch.value;
            }
        }
        return min;
    }
    get maxValue() {
        let max = null;
        for (const ch of this._def.checks) {
            if (ch.kind === "max") {
                if (max === null || ch.value < max)
                    max = ch.value;
            }
        }
        return max;
    }
    get isInt() {
        return !!this._def.checks.find((ch) => ch.kind === "int" ||
            (ch.kind === "multipleOf" && util.isInteger(ch.value)));
    }
    get isFinite() {
        let max = null, min = null;
        for (const ch of this._def.checks) {
            if (ch.kind === "finite" ||
                ch.kind === "int" ||
                ch.kind === "multipleOf") {
                return true;
            }
            else if (ch.kind === "min") {
                if (min === null || ch.value > min)
                    min = ch.value;
            }
            else if (ch.kind === "max") {
                if (max === null || ch.value < max)
                    max = ch.value;
            }
        }
        return Number.isFinite(min) && Number.isFinite(max);
    }
}
ZodNumber.create = (params) => {
    return new ZodNumber({
        checks: [],
        typeName: ZodFirstPartyTypeKind.ZodNumber,
        coerce: (params === null || params === void 0 ? void 0 : params.coerce) || false,
        ...processCreateParams(params),
    });
};
class ZodBigInt extends ZodType {
    constructor() {
        super(...arguments);
        this.min = this.gte;
        this.max = this.lte;
    }
    _parse(input) {
        if (this._def.coerce) {
            input.data = BigInt(input.data);
        }
        const parsedType = this._getType(input);
        if (parsedType !== ZodParsedType.bigint) {
            const ctx = this._getOrReturnCtx(input);
            addIssueToContext(ctx, {
                code: ZodIssueCode.invalid_type,
                expected: ZodParsedType.bigint,
                received: ctx.parsedType,
            });
            return INVALID;
        }
        let ctx = undefined;
        const status = new ParseStatus();
        for (const check of this._def.checks) {
            if (check.kind === "min") {
                const tooSmall = check.inclusive
                    ? input.data < check.value
                    : input.data <= check.value;
                if (tooSmall) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    addIssueToContext(ctx, {
                        code: ZodIssueCode.too_small,
                        type: "bigint",
                        minimum: check.value,
                        inclusive: check.inclusive,
                        message: check.message,
                    });
                    status.dirty();
                }
            }
            else if (check.kind === "max") {
                const tooBig = check.inclusive
                    ? input.data > check.value
                    : input.data >= check.value;
                if (tooBig) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    addIssueToContext(ctx, {
                        code: ZodIssueCode.too_big,
                        type: "bigint",
                        maximum: check.value,
                        inclusive: check.inclusive,
                        message: check.message,
                    });
                    status.dirty();
                }
            }
            else if (check.kind === "multipleOf") {
                if (input.data % check.value !== BigInt(0)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    addIssueToContext(ctx, {
                        code: ZodIssueCode.not_multiple_of,
                        multipleOf: check.value,
                        message: check.message,
                    });
                    status.dirty();
                }
            }
            else {
                util.assertNever(check);
            }
        }
        return { status: status.value, value: input.data };
    }
    gte(value, message) {
        return this.setLimit("min", value, true, errorUtil.toString(message));
    }
    gt(value, message) {
        return this.setLimit("min", value, false, errorUtil.toString(message));
    }
    lte(value, message) {
        return this.setLimit("max", value, true, errorUtil.toString(message));
    }
    lt(value, message) {
        return this.setLimit("max", value, false, errorUtil.toString(message));
    }
    setLimit(kind, value, inclusive, message) {
        return new ZodBigInt({
            ...this._def,
            checks: [
                ...this._def.checks,
                {
                    kind,
                    value,
                    inclusive,
                    message: errorUtil.toString(message),
                },
            ],
        });
    }
    _addCheck(check) {
        return new ZodBigInt({
            ...this._def,
            checks: [...this._def.checks, check],
        });
    }
    positive(message) {
        return this._addCheck({
            kind: "min",
            value: BigInt(0),
            inclusive: false,
            message: errorUtil.toString(message),
        });
    }
    negative(message) {
        return this._addCheck({
            kind: "max",
            value: BigInt(0),
            inclusive: false,
            message: errorUtil.toString(message),
        });
    }
    nonpositive(message) {
        return this._addCheck({
            kind: "max",
            value: BigInt(0),
            inclusive: true,
            message: errorUtil.toString(message),
        });
    }
    nonnegative(message) {
        return this._addCheck({
            kind: "min",
            value: BigInt(0),
            inclusive: true,
            message: errorUtil.toString(message),
        });
    }
    multipleOf(value, message) {
        return this._addCheck({
            kind: "multipleOf",
            value,
            message: errorUtil.toString(message),
        });
    }
    get minValue() {
        let min = null;
        for (const ch of this._def.checks) {
            if (ch.kind === "min") {
                if (min === null || ch.value > min)
                    min = ch.value;
            }
        }
        return min;
    }
    get maxValue() {
        let max = null;
        for (const ch of this._def.checks) {
            if (ch.kind === "max") {
                if (max === null || ch.value < max)
                    max = ch.value;
            }
        }
        return max;
    }
}
ZodBigInt.create = (params) => {
    var _a;
    return new ZodBigInt({
        checks: [],
        typeName: ZodFirstPartyTypeKind.ZodBigInt,
        coerce: (_a = params === null || params === void 0 ? void 0 : params.coerce) !== null && _a !== void 0 ? _a : false,
        ...processCreateParams(params),
    });
};
class ZodBoolean extends ZodType {
    _parse(input) {
        if (this._def.coerce) {
            input.data = Boolean(input.data);
        }
        const parsedType = this._getType(input);
        if (parsedType !== ZodParsedType.boolean) {
            const ctx = this._getOrReturnCtx(input);
            addIssueToContext(ctx, {
                code: ZodIssueCode.invalid_type,
                expected: ZodParsedType.boolean,
                received: ctx.parsedType,
            });
            return INVALID;
        }
        return OK(input.data);
    }
}
ZodBoolean.create = (params) => {
    return new ZodBoolean({
        typeName: ZodFirstPartyTypeKind.ZodBoolean,
        coerce: (params === null || params === void 0 ? void 0 : params.coerce) || false,
        ...processCreateParams(params),
    });
};
class ZodDate extends ZodType {
    _parse(input) {
        if (this._def.coerce) {
            input.data = new Date(input.data);
        }
        const parsedType = this._getType(input);
        if (parsedType !== ZodParsedType.date) {
            const ctx = this._getOrReturnCtx(input);
            addIssueToContext(ctx, {
                code: ZodIssueCode.invalid_type,
                expected: ZodParsedType.date,
                received: ctx.parsedType,
            });
            return INVALID;
        }
        if (isNaN(input.data.getTime())) {
            const ctx = this._getOrReturnCtx(input);
            addIssueToContext(ctx, {
                code: ZodIssueCode.invalid_date,
            });
            return INVALID;
        }
        const status = new ParseStatus();
        let ctx = undefined;
        for (const check of this._def.checks) {
            if (check.kind === "min") {
                if (input.data.getTime() < check.value) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    addIssueToContext(ctx, {
                        code: ZodIssueCode.too_small,
                        message: check.message,
                        inclusive: true,
                        exact: false,
                        minimum: check.value,
                        type: "date",
                    });
                    status.dirty();
                }
            }
            else if (check.kind === "max") {
                if (input.data.getTime() > check.value) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    addIssueToContext(ctx, {
                        code: ZodIssueCode.too_big,
                        message: check.message,
                        inclusive: true,
                        exact: false,
                        maximum: check.value,
                        type: "date",
                    });
                    status.dirty();
                }
            }
            else {
                util.assertNever(check);
            }
        }
        return {
            status: status.value,
            value: new Date(input.data.getTime()),
        };
    }
    _addCheck(check) {
        return new ZodDate({
            ...this._def,
            checks: [...this._def.checks, check],
        });
    }
    min(minDate, message) {
        return this._addCheck({
            kind: "min",
            value: minDate.getTime(),
            message: errorUtil.toString(message),
        });
    }
    max(maxDate, message) {
        return this._addCheck({
            kind: "max",
            value: maxDate.getTime(),
            message: errorUtil.toString(message),
        });
    }
    get minDate() {
        let min = null;
        for (const ch of this._def.checks) {
            if (ch.kind === "min") {
                if (min === null || ch.value > min)
                    min = ch.value;
            }
        }
        return min != null ? new Date(min) : null;
    }
    get maxDate() {
        let max = null;
        for (const ch of this._def.checks) {
            if (ch.kind === "max") {
                if (max === null || ch.value < max)
                    max = ch.value;
            }
        }
        return max != null ? new Date(max) : null;
    }
}
ZodDate.create = (params) => {
    return new ZodDate({
        checks: [],
        coerce: (params === null || params === void 0 ? void 0 : params.coerce) || false,
        typeName: ZodFirstPartyTypeKind.ZodDate,
        ...processCreateParams(params),
    });
};
class ZodSymbol extends ZodType {
    _parse(input) {
        const parsedType = this._getType(input);
        if (parsedType !== ZodParsedType.symbol) {
            const ctx = this._getOrReturnCtx(input);
            addIssueToContext(ctx, {
                code: ZodIssueCode.invalid_type,
                expected: ZodParsedType.symbol,
                received: ctx.parsedType,
            });
            return INVALID;
        }
        return OK(input.data);
    }
}
ZodSymbol.create = (params) => {
    return new ZodSymbol({
        typeName: ZodFirstPartyTypeKind.ZodSymbol,
        ...processCreateParams(params),
    });
};
class ZodUndefined extends ZodType {
    _parse(input) {
        const parsedType = this._getType(input);
        if (parsedType !== ZodParsedType.undefined) {
            const ctx = this._getOrReturnCtx(input);
            addIssueToContext(ctx, {
                code: ZodIssueCode.invalid_type,
                expected: ZodParsedType.undefined,
                received: ctx.parsedType,
            });
            return INVALID;
        }
        return OK(input.data);
    }
}
ZodUndefined.create = (params) => {
    return new ZodUndefined({
        typeName: ZodFirstPartyTypeKind.ZodUndefined,
        ...processCreateParams(params),
    });
};
class ZodNull extends ZodType {
    _parse(input) {
        const parsedType = this._getType(input);
        if (parsedType !== ZodParsedType.null) {
            const ctx = this._getOrReturnCtx(input);
            addIssueToContext(ctx, {
                code: ZodIssueCode.invalid_type,
                expected: ZodParsedType.null,
                received: ctx.parsedType,
            });
            return INVALID;
        }
        return OK(input.data);
    }
}
ZodNull.create = (params) => {
    return new ZodNull({
        typeName: ZodFirstPartyTypeKind.ZodNull,
        ...processCreateParams(params),
    });
};
class ZodAny extends ZodType {
    constructor() {
        super(...arguments);
        // to prevent instances of other classes from extending ZodAny. this causes issues with catchall in ZodObject.
        this._any = true;
    }
    _parse(input) {
        return OK(input.data);
    }
}
ZodAny.create = (params) => {
    return new ZodAny({
        typeName: ZodFirstPartyTypeKind.ZodAny,
        ...processCreateParams(params),
    });
};
class ZodUnknown extends ZodType {
    constructor() {
        super(...arguments);
        // required
        this._unknown = true;
    }
    _parse(input) {
        return OK(input.data);
    }
}
ZodUnknown.create = (params) => {
    return new ZodUnknown({
        typeName: ZodFirstPartyTypeKind.ZodUnknown,
        ...processCreateParams(params),
    });
};
class ZodNever extends ZodType {
    _parse(input) {
        const ctx = this._getOrReturnCtx(input);
        addIssueToContext(ctx, {
            code: ZodIssueCode.invalid_type,
            expected: ZodParsedType.never,
            received: ctx.parsedType,
        });
        return INVALID;
    }
}
ZodNever.create = (params) => {
    return new ZodNever({
        typeName: ZodFirstPartyTypeKind.ZodNever,
        ...processCreateParams(params),
    });
};
class ZodVoid extends ZodType {
    _parse(input) {
        const parsedType = this._getType(input);
        if (parsedType !== ZodParsedType.undefined) {
            const ctx = this._getOrReturnCtx(input);
            addIssueToContext(ctx, {
                code: ZodIssueCode.invalid_type,
                expected: ZodParsedType.void,
                received: ctx.parsedType,
            });
            return INVALID;
        }
        return OK(input.data);
    }
}
ZodVoid.create = (params) => {
    return new ZodVoid({
        typeName: ZodFirstPartyTypeKind.ZodVoid,
        ...processCreateParams(params),
    });
};
class ZodArray extends ZodType {
    _parse(input) {
        const { ctx, status } = this._processInputParams(input);
        const def = this._def;
        if (ctx.parsedType !== ZodParsedType.array) {
            addIssueToContext(ctx, {
                code: ZodIssueCode.invalid_type,
                expected: ZodParsedType.array,
                received: ctx.parsedType,
            });
            return INVALID;
        }
        if (def.exactLength !== null) {
            const tooBig = ctx.data.length > def.exactLength.value;
            const tooSmall = ctx.data.length < def.exactLength.value;
            if (tooBig || tooSmall) {
                addIssueToContext(ctx, {
                    code: tooBig ? ZodIssueCode.too_big : ZodIssueCode.too_small,
                    minimum: (tooSmall ? def.exactLength.value : undefined),
                    maximum: (tooBig ? def.exactLength.value : undefined),
                    type: "array",
                    inclusive: true,
                    exact: true,
                    message: def.exactLength.message,
                });
                status.dirty();
            }
        }
        if (def.minLength !== null) {
            if (ctx.data.length < def.minLength.value) {
                addIssueToContext(ctx, {
                    code: ZodIssueCode.too_small,
                    minimum: def.minLength.value,
                    type: "array",
                    inclusive: true,
                    exact: false,
                    message: def.minLength.message,
                });
                status.dirty();
            }
        }
        if (def.maxLength !== null) {
            if (ctx.data.length > def.maxLength.value) {
                addIssueToContext(ctx, {
                    code: ZodIssueCode.too_big,
                    maximum: def.maxLength.value,
                    type: "array",
                    inclusive: true,
                    exact: false,
                    message: def.maxLength.message,
                });
                status.dirty();
            }
        }
        if (ctx.common.async) {
            return Promise.all([...ctx.data].map((item, i) => {
                return def.type._parseAsync(new ParseInputLazyPath(ctx, item, ctx.path, i));
            })).then((result) => {
                return ParseStatus.mergeArray(status, result);
            });
        }
        const result = [...ctx.data].map((item, i) => {
            return def.type._parseSync(new ParseInputLazyPath(ctx, item, ctx.path, i));
        });
        return ParseStatus.mergeArray(status, result);
    }
    get element() {
        return this._def.type;
    }
    min(minLength, message) {
        return new ZodArray({
            ...this._def,
            minLength: { value: minLength, message: errorUtil.toString(message) },
        });
    }
    max(maxLength, message) {
        return new ZodArray({
            ...this._def,
            maxLength: { value: maxLength, message: errorUtil.toString(message) },
        });
    }
    length(len, message) {
        return new ZodArray({
            ...this._def,
            exactLength: { value: len, message: errorUtil.toString(message) },
        });
    }
    nonempty(message) {
        return this.min(1, message);
    }
}
ZodArray.create = (schema, params) => {
    return new ZodArray({
        type: schema,
        minLength: null,
        maxLength: null,
        exactLength: null,
        typeName: ZodFirstPartyTypeKind.ZodArray,
        ...processCreateParams(params),
    });
};
function deepPartialify(schema) {
    if (schema instanceof ZodObject) {
        const newShape = {};
        for (const key in schema.shape) {
            const fieldSchema = schema.shape[key];
            newShape[key] = ZodOptional.create(deepPartialify(fieldSchema));
        }
        return new ZodObject({
            ...schema._def,
            shape: () => newShape,
        });
    }
    else if (schema instanceof ZodArray) {
        return new ZodArray({
            ...schema._def,
            type: deepPartialify(schema.element),
        });
    }
    else if (schema instanceof ZodOptional) {
        return ZodOptional.create(deepPartialify(schema.unwrap()));
    }
    else if (schema instanceof ZodNullable) {
        return ZodNullable.create(deepPartialify(schema.unwrap()));
    }
    else if (schema instanceof ZodTuple) {
        return ZodTuple.create(schema.items.map((item) => deepPartialify(item)));
    }
    else {
        return schema;
    }
}
class ZodObject extends ZodType {
    constructor() {
        super(...arguments);
        this._cached = null;
        /**
         * @deprecated In most cases, this is no longer needed - unknown properties are now silently stripped.
         * If you want to pass through unknown properties, use `.passthrough()` instead.
         */
        this.nonstrict = this.passthrough;
        // extend<
        //   Augmentation extends ZodRawShape,
        //   NewOutput extends util.flatten<{
        //     [k in keyof Augmentation | keyof Output]: k extends keyof Augmentation
        //       ? Augmentation[k]["_output"]
        //       : k extends keyof Output
        //       ? Output[k]
        //       : never;
        //   }>,
        //   NewInput extends util.flatten<{
        //     [k in keyof Augmentation | keyof Input]: k extends keyof Augmentation
        //       ? Augmentation[k]["_input"]
        //       : k extends keyof Input
        //       ? Input[k]
        //       : never;
        //   }>
        // >(
        //   augmentation: Augmentation
        // ): ZodObject<
        //   extendShape<T, Augmentation>,
        //   UnknownKeys,
        //   Catchall,
        //   NewOutput,
        //   NewInput
        // > {
        //   return new ZodObject({
        //     ...this._def,
        //     shape: () => ({
        //       ...this._def.shape(),
        //       ...augmentation,
        //     }),
        //   }) as any;
        // }
        /**
         * @deprecated Use `.extend` instead
         *  */
        this.augment = this.extend;
    }
    _getCached() {
        if (this._cached !== null)
            return this._cached;
        const shape = this._def.shape();
        const keys = util.objectKeys(shape);
        return (this._cached = { shape, keys });
    }
    _parse(input) {
        const parsedType = this._getType(input);
        if (parsedType !== ZodParsedType.object) {
            const ctx = this._getOrReturnCtx(input);
            addIssueToContext(ctx, {
                code: ZodIssueCode.invalid_type,
                expected: ZodParsedType.object,
                received: ctx.parsedType,
            });
            return INVALID;
        }
        const { status, ctx } = this._processInputParams(input);
        const { shape, keys: shapeKeys } = this._getCached();
        const extraKeys = [];
        if (!(this._def.catchall instanceof ZodNever &&
            this._def.unknownKeys === "strip")) {
            for (const key in ctx.data) {
                if (!shapeKeys.includes(key)) {
                    extraKeys.push(key);
                }
            }
        }
        const pairs = [];
        for (const key of shapeKeys) {
            const keyValidator = shape[key];
            const value = ctx.data[key];
            pairs.push({
                key: { status: "valid", value: key },
                value: keyValidator._parse(new ParseInputLazyPath(ctx, value, ctx.path, key)),
                alwaysSet: key in ctx.data,
            });
        }
        if (this._def.catchall instanceof ZodNever) {
            const unknownKeys = this._def.unknownKeys;
            if (unknownKeys === "passthrough") {
                for (const key of extraKeys) {
                    pairs.push({
                        key: { status: "valid", value: key },
                        value: { status: "valid", value: ctx.data[key] },
                    });
                }
            }
            else if (unknownKeys === "strict") {
                if (extraKeys.length > 0) {
                    addIssueToContext(ctx, {
                        code: ZodIssueCode.unrecognized_keys,
                        keys: extraKeys,
                    });
                    status.dirty();
                }
            }
            else if (unknownKeys === "strip") ;
            else {
                throw new Error(`Internal ZodObject error: invalid unknownKeys value.`);
            }
        }
        else {
            // run catchall validation
            const catchall = this._def.catchall;
            for (const key of extraKeys) {
                const value = ctx.data[key];
                pairs.push({
                    key: { status: "valid", value: key },
                    value: catchall._parse(new ParseInputLazyPath(ctx, value, ctx.path, key) //, ctx.child(key), value, getParsedType(value)
                    ),
                    alwaysSet: key in ctx.data,
                });
            }
        }
        if (ctx.common.async) {
            return Promise.resolve()
                .then(async () => {
                const syncPairs = [];
                for (const pair of pairs) {
                    const key = await pair.key;
                    syncPairs.push({
                        key,
                        value: await pair.value,
                        alwaysSet: pair.alwaysSet,
                    });
                }
                return syncPairs;
            })
                .then((syncPairs) => {
                return ParseStatus.mergeObjectSync(status, syncPairs);
            });
        }
        else {
            return ParseStatus.mergeObjectSync(status, pairs);
        }
    }
    get shape() {
        return this._def.shape();
    }
    strict(message) {
        errorUtil.errToObj;
        return new ZodObject({
            ...this._def,
            unknownKeys: "strict",
            ...(message !== undefined
                ? {
                    errorMap: (issue, ctx) => {
                        var _a, _b, _c, _d;
                        const defaultError = (_c = (_b = (_a = this._def).errorMap) === null || _b === void 0 ? void 0 : _b.call(_a, issue, ctx).message) !== null && _c !== void 0 ? _c : ctx.defaultError;
                        if (issue.code === "unrecognized_keys")
                            return {
                                message: (_d = errorUtil.errToObj(message).message) !== null && _d !== void 0 ? _d : defaultError,
                            };
                        return {
                            message: defaultError,
                        };
                    },
                }
                : {}),
        });
    }
    strip() {
        return new ZodObject({
            ...this._def,
            unknownKeys: "strip",
        });
    }
    passthrough() {
        return new ZodObject({
            ...this._def,
            unknownKeys: "passthrough",
        });
    }
    // const AugmentFactory =
    //   <Def extends ZodObjectDef>(def: Def) =>
    //   <Augmentation extends ZodRawShape>(
    //     augmentation: Augmentation
    //   ): ZodObject<
    //     extendShape<ReturnType<Def["shape"]>, Augmentation>,
    //     Def["unknownKeys"],
    //     Def["catchall"]
    //   > => {
    //     return new ZodObject({
    //       ...def,
    //       shape: () => ({
    //         ...def.shape(),
    //         ...augmentation,
    //       }),
    //     }) as any;
    //   };
    extend(augmentation) {
        return new ZodObject({
            ...this._def,
            shape: () => ({
                ...this._def.shape(),
                ...augmentation,
            }),
        });
    }
    /**
     * Prior to zod@1.0.12 there was a bug in the
     * inferred type of merged objects. Please
     * upgrade if you are experiencing issues.
     */
    merge(merging) {
        const merged = new ZodObject({
            unknownKeys: merging._def.unknownKeys,
            catchall: merging._def.catchall,
            shape: () => ({
                ...this._def.shape(),
                ...merging._def.shape(),
            }),
            typeName: ZodFirstPartyTypeKind.ZodObject,
        });
        return merged;
    }
    // merge<
    //   Incoming extends AnyZodObject,
    //   Augmentation extends Incoming["shape"],
    //   NewOutput extends {
    //     [k in keyof Augmentation | keyof Output]: k extends keyof Augmentation
    //       ? Augmentation[k]["_output"]
    //       : k extends keyof Output
    //       ? Output[k]
    //       : never;
    //   },
    //   NewInput extends {
    //     [k in keyof Augmentation | keyof Input]: k extends keyof Augmentation
    //       ? Augmentation[k]["_input"]
    //       : k extends keyof Input
    //       ? Input[k]
    //       : never;
    //   }
    // >(
    //   merging: Incoming
    // ): ZodObject<
    //   extendShape<T, ReturnType<Incoming["_def"]["shape"]>>,
    //   Incoming["_def"]["unknownKeys"],
    //   Incoming["_def"]["catchall"],
    //   NewOutput,
    //   NewInput
    // > {
    //   const merged: any = new ZodObject({
    //     unknownKeys: merging._def.unknownKeys,
    //     catchall: merging._def.catchall,
    //     shape: () =>
    //       objectUtil.mergeShapes(this._def.shape(), merging._def.shape()),
    //     typeName: ZodFirstPartyTypeKind.ZodObject,
    //   }) as any;
    //   return merged;
    // }
    setKey(key, schema) {
        return this.augment({ [key]: schema });
    }
    // merge<Incoming extends AnyZodObject>(
    //   merging: Incoming
    // ): //ZodObject<T & Incoming["_shape"], UnknownKeys, Catchall> = (merging) => {
    // ZodObject<
    //   extendShape<T, ReturnType<Incoming["_def"]["shape"]>>,
    //   Incoming["_def"]["unknownKeys"],
    //   Incoming["_def"]["catchall"]
    // > {
    //   // const mergedShape = objectUtil.mergeShapes(
    //   //   this._def.shape(),
    //   //   merging._def.shape()
    //   // );
    //   const merged: any = new ZodObject({
    //     unknownKeys: merging._def.unknownKeys,
    //     catchall: merging._def.catchall,
    //     shape: () =>
    //       objectUtil.mergeShapes(this._def.shape(), merging._def.shape()),
    //     typeName: ZodFirstPartyTypeKind.ZodObject,
    //   }) as any;
    //   return merged;
    // }
    catchall(index) {
        return new ZodObject({
            ...this._def,
            catchall: index,
        });
    }
    pick(mask) {
        const shape = {};
        util.objectKeys(mask).forEach((key) => {
            if (mask[key] && this.shape[key]) {
                shape[key] = this.shape[key];
            }
        });
        return new ZodObject({
            ...this._def,
            shape: () => shape,
        });
    }
    omit(mask) {
        const shape = {};
        util.objectKeys(this.shape).forEach((key) => {
            if (!mask[key]) {
                shape[key] = this.shape[key];
            }
        });
        return new ZodObject({
            ...this._def,
            shape: () => shape,
        });
    }
    /**
     * @deprecated
     */
    deepPartial() {
        return deepPartialify(this);
    }
    partial(mask) {
        const newShape = {};
        util.objectKeys(this.shape).forEach((key) => {
            const fieldSchema = this.shape[key];
            if (mask && !mask[key]) {
                newShape[key] = fieldSchema;
            }
            else {
                newShape[key] = fieldSchema.optional();
            }
        });
        return new ZodObject({
            ...this._def,
            shape: () => newShape,
        });
    }
    required(mask) {
        const newShape = {};
        util.objectKeys(this.shape).forEach((key) => {
            if (mask && !mask[key]) {
                newShape[key] = this.shape[key];
            }
            else {
                const fieldSchema = this.shape[key];
                let newField = fieldSchema;
                while (newField instanceof ZodOptional) {
                    newField = newField._def.innerType;
                }
                newShape[key] = newField;
            }
        });
        return new ZodObject({
            ...this._def,
            shape: () => newShape,
        });
    }
    keyof() {
        return createZodEnum(util.objectKeys(this.shape));
    }
}
ZodObject.create = (shape, params) => {
    return new ZodObject({
        shape: () => shape,
        unknownKeys: "strip",
        catchall: ZodNever.create(),
        typeName: ZodFirstPartyTypeKind.ZodObject,
        ...processCreateParams(params),
    });
};
ZodObject.strictCreate = (shape, params) => {
    return new ZodObject({
        shape: () => shape,
        unknownKeys: "strict",
        catchall: ZodNever.create(),
        typeName: ZodFirstPartyTypeKind.ZodObject,
        ...processCreateParams(params),
    });
};
ZodObject.lazycreate = (shape, params) => {
    return new ZodObject({
        shape,
        unknownKeys: "strip",
        catchall: ZodNever.create(),
        typeName: ZodFirstPartyTypeKind.ZodObject,
        ...processCreateParams(params),
    });
};
class ZodUnion extends ZodType {
    _parse(input) {
        const { ctx } = this._processInputParams(input);
        const options = this._def.options;
        function handleResults(results) {
            // return first issue-free validation if it exists
            for (const result of results) {
                if (result.result.status === "valid") {
                    return result.result;
                }
            }
            for (const result of results) {
                if (result.result.status === "dirty") {
                    // add issues from dirty option
                    ctx.common.issues.push(...result.ctx.common.issues);
                    return result.result;
                }
            }
            // return invalid
            const unionErrors = results.map((result) => new ZodError(result.ctx.common.issues));
            addIssueToContext(ctx, {
                code: ZodIssueCode.invalid_union,
                unionErrors,
            });
            return INVALID;
        }
        if (ctx.common.async) {
            return Promise.all(options.map(async (option) => {
                const childCtx = {
                    ...ctx,
                    common: {
                        ...ctx.common,
                        issues: [],
                    },
                    parent: null,
                };
                return {
                    result: await option._parseAsync({
                        data: ctx.data,
                        path: ctx.path,
                        parent: childCtx,
                    }),
                    ctx: childCtx,
                };
            })).then(handleResults);
        }
        else {
            let dirty = undefined;
            const issues = [];
            for (const option of options) {
                const childCtx = {
                    ...ctx,
                    common: {
                        ...ctx.common,
                        issues: [],
                    },
                    parent: null,
                };
                const result = option._parseSync({
                    data: ctx.data,
                    path: ctx.path,
                    parent: childCtx,
                });
                if (result.status === "valid") {
                    return result;
                }
                else if (result.status === "dirty" && !dirty) {
                    dirty = { result, ctx: childCtx };
                }
                if (childCtx.common.issues.length) {
                    issues.push(childCtx.common.issues);
                }
            }
            if (dirty) {
                ctx.common.issues.push(...dirty.ctx.common.issues);
                return dirty.result;
            }
            const unionErrors = issues.map((issues) => new ZodError(issues));
            addIssueToContext(ctx, {
                code: ZodIssueCode.invalid_union,
                unionErrors,
            });
            return INVALID;
        }
    }
    get options() {
        return this._def.options;
    }
}
ZodUnion.create = (types, params) => {
    return new ZodUnion({
        options: types,
        typeName: ZodFirstPartyTypeKind.ZodUnion,
        ...processCreateParams(params),
    });
};
/////////////////////////////////////////////////////
/////////////////////////////////////////////////////
//////////                                 //////////
//////////      ZodDiscriminatedUnion      //////////
//////////                                 //////////
/////////////////////////////////////////////////////
/////////////////////////////////////////////////////
const getDiscriminator = (type) => {
    if (type instanceof ZodLazy) {
        return getDiscriminator(type.schema);
    }
    else if (type instanceof ZodEffects) {
        return getDiscriminator(type.innerType());
    }
    else if (type instanceof ZodLiteral) {
        return [type.value];
    }
    else if (type instanceof ZodEnum) {
        return type.options;
    }
    else if (type instanceof ZodNativeEnum) {
        // eslint-disable-next-line ban/ban
        return Object.keys(type.enum);
    }
    else if (type instanceof ZodDefault) {
        return getDiscriminator(type._def.innerType);
    }
    else if (type instanceof ZodUndefined) {
        return [undefined];
    }
    else if (type instanceof ZodNull) {
        return [null];
    }
    else {
        return null;
    }
};
class ZodDiscriminatedUnion extends ZodType {
    _parse(input) {
        const { ctx } = this._processInputParams(input);
        if (ctx.parsedType !== ZodParsedType.object) {
            addIssueToContext(ctx, {
                code: ZodIssueCode.invalid_type,
                expected: ZodParsedType.object,
                received: ctx.parsedType,
            });
            return INVALID;
        }
        const discriminator = this.discriminator;
        const discriminatorValue = ctx.data[discriminator];
        const option = this.optionsMap.get(discriminatorValue);
        if (!option) {
            addIssueToContext(ctx, {
                code: ZodIssueCode.invalid_union_discriminator,
                options: Array.from(this.optionsMap.keys()),
                path: [discriminator],
            });
            return INVALID;
        }
        if (ctx.common.async) {
            return option._parseAsync({
                data: ctx.data,
                path: ctx.path,
                parent: ctx,
            });
        }
        else {
            return option._parseSync({
                data: ctx.data,
                path: ctx.path,
                parent: ctx,
            });
        }
    }
    get discriminator() {
        return this._def.discriminator;
    }
    get options() {
        return this._def.options;
    }
    get optionsMap() {
        return this._def.optionsMap;
    }
    /**
     * The constructor of the discriminated union schema. Its behaviour is very similar to that of the normal z.union() constructor.
     * However, it only allows a union of objects, all of which need to share a discriminator property. This property must
     * have a different value for each object in the union.
     * @param discriminator the name of the discriminator property
     * @param types an array of object schemas
     * @param params
     */
    static create(discriminator, options, params) {
        // Get all the valid discriminator values
        const optionsMap = new Map();
        // try {
        for (const type of options) {
            const discriminatorValues = getDiscriminator(type.shape[discriminator]);
            if (!discriminatorValues) {
                throw new Error(`A discriminator value for key \`${discriminator}\` could not be extracted from all schema options`);
            }
            for (const value of discriminatorValues) {
                if (optionsMap.has(value)) {
                    throw new Error(`Discriminator property ${String(discriminator)} has duplicate value ${String(value)}`);
                }
                optionsMap.set(value, type);
            }
        }
        return new ZodDiscriminatedUnion({
            typeName: ZodFirstPartyTypeKind.ZodDiscriminatedUnion,
            discriminator,
            options,
            optionsMap,
            ...processCreateParams(params),
        });
    }
}
function mergeValues(a, b) {
    const aType = getParsedType(a);
    const bType = getParsedType(b);
    if (a === b) {
        return { valid: true, data: a };
    }
    else if (aType === ZodParsedType.object && bType === ZodParsedType.object) {
        const bKeys = util.objectKeys(b);
        const sharedKeys = util
            .objectKeys(a)
            .filter((key) => bKeys.indexOf(key) !== -1);
        const newObj = { ...a, ...b };
        for (const key of sharedKeys) {
            const sharedValue = mergeValues(a[key], b[key]);
            if (!sharedValue.valid) {
                return { valid: false };
            }
            newObj[key] = sharedValue.data;
        }
        return { valid: true, data: newObj };
    }
    else if (aType === ZodParsedType.array && bType === ZodParsedType.array) {
        if (a.length !== b.length) {
            return { valid: false };
        }
        const newArray = [];
        for (let index = 0; index < a.length; index++) {
            const itemA = a[index];
            const itemB = b[index];
            const sharedValue = mergeValues(itemA, itemB);
            if (!sharedValue.valid) {
                return { valid: false };
            }
            newArray.push(sharedValue.data);
        }
        return { valid: true, data: newArray };
    }
    else if (aType === ZodParsedType.date &&
        bType === ZodParsedType.date &&
        +a === +b) {
        return { valid: true, data: a };
    }
    else {
        return { valid: false };
    }
}
class ZodIntersection extends ZodType {
    _parse(input) {
        const { status, ctx } = this._processInputParams(input);
        const handleParsed = (parsedLeft, parsedRight) => {
            if (isAborted(parsedLeft) || isAborted(parsedRight)) {
                return INVALID;
            }
            const merged = mergeValues(parsedLeft.value, parsedRight.value);
            if (!merged.valid) {
                addIssueToContext(ctx, {
                    code: ZodIssueCode.invalid_intersection_types,
                });
                return INVALID;
            }
            if (isDirty(parsedLeft) || isDirty(parsedRight)) {
                status.dirty();
            }
            return { status: status.value, value: merged.data };
        };
        if (ctx.common.async) {
            return Promise.all([
                this._def.left._parseAsync({
                    data: ctx.data,
                    path: ctx.path,
                    parent: ctx,
                }),
                this._def.right._parseAsync({
                    data: ctx.data,
                    path: ctx.path,
                    parent: ctx,
                }),
            ]).then(([left, right]) => handleParsed(left, right));
        }
        else {
            return handleParsed(this._def.left._parseSync({
                data: ctx.data,
                path: ctx.path,
                parent: ctx,
            }), this._def.right._parseSync({
                data: ctx.data,
                path: ctx.path,
                parent: ctx,
            }));
        }
    }
}
ZodIntersection.create = (left, right, params) => {
    return new ZodIntersection({
        left: left,
        right: right,
        typeName: ZodFirstPartyTypeKind.ZodIntersection,
        ...processCreateParams(params),
    });
};
class ZodTuple extends ZodType {
    _parse(input) {
        const { status, ctx } = this._processInputParams(input);
        if (ctx.parsedType !== ZodParsedType.array) {
            addIssueToContext(ctx, {
                code: ZodIssueCode.invalid_type,
                expected: ZodParsedType.array,
                received: ctx.parsedType,
            });
            return INVALID;
        }
        if (ctx.data.length < this._def.items.length) {
            addIssueToContext(ctx, {
                code: ZodIssueCode.too_small,
                minimum: this._def.items.length,
                inclusive: true,
                exact: false,
                type: "array",
            });
            return INVALID;
        }
        const rest = this._def.rest;
        if (!rest && ctx.data.length > this._def.items.length) {
            addIssueToContext(ctx, {
                code: ZodIssueCode.too_big,
                maximum: this._def.items.length,
                inclusive: true,
                exact: false,
                type: "array",
            });
            status.dirty();
        }
        const items = [...ctx.data]
            .map((item, itemIndex) => {
            const schema = this._def.items[itemIndex] || this._def.rest;
            if (!schema)
                return null;
            return schema._parse(new ParseInputLazyPath(ctx, item, ctx.path, itemIndex));
        })
            .filter((x) => !!x); // filter nulls
        if (ctx.common.async) {
            return Promise.all(items).then((results) => {
                return ParseStatus.mergeArray(status, results);
            });
        }
        else {
            return ParseStatus.mergeArray(status, items);
        }
    }
    get items() {
        return this._def.items;
    }
    rest(rest) {
        return new ZodTuple({
            ...this._def,
            rest,
        });
    }
}
ZodTuple.create = (schemas, params) => {
    if (!Array.isArray(schemas)) {
        throw new Error("You must pass an array of schemas to z.tuple([ ... ])");
    }
    return new ZodTuple({
        items: schemas,
        typeName: ZodFirstPartyTypeKind.ZodTuple,
        rest: null,
        ...processCreateParams(params),
    });
};
class ZodRecord extends ZodType {
    get keySchema() {
        return this._def.keyType;
    }
    get valueSchema() {
        return this._def.valueType;
    }
    _parse(input) {
        const { status, ctx } = this._processInputParams(input);
        if (ctx.parsedType !== ZodParsedType.object) {
            addIssueToContext(ctx, {
                code: ZodIssueCode.invalid_type,
                expected: ZodParsedType.object,
                received: ctx.parsedType,
            });
            return INVALID;
        }
        const pairs = [];
        const keyType = this._def.keyType;
        const valueType = this._def.valueType;
        for (const key in ctx.data) {
            pairs.push({
                key: keyType._parse(new ParseInputLazyPath(ctx, key, ctx.path, key)),
                value: valueType._parse(new ParseInputLazyPath(ctx, ctx.data[key], ctx.path, key)),
            });
        }
        if (ctx.common.async) {
            return ParseStatus.mergeObjectAsync(status, pairs);
        }
        else {
            return ParseStatus.mergeObjectSync(status, pairs);
        }
    }
    get element() {
        return this._def.valueType;
    }
    static create(first, second, third) {
        if (second instanceof ZodType) {
            return new ZodRecord({
                keyType: first,
                valueType: second,
                typeName: ZodFirstPartyTypeKind.ZodRecord,
                ...processCreateParams(third),
            });
        }
        return new ZodRecord({
            keyType: ZodString.create(),
            valueType: first,
            typeName: ZodFirstPartyTypeKind.ZodRecord,
            ...processCreateParams(second),
        });
    }
}
class ZodMap extends ZodType {
    get keySchema() {
        return this._def.keyType;
    }
    get valueSchema() {
        return this._def.valueType;
    }
    _parse(input) {
        const { status, ctx } = this._processInputParams(input);
        if (ctx.parsedType !== ZodParsedType.map) {
            addIssueToContext(ctx, {
                code: ZodIssueCode.invalid_type,
                expected: ZodParsedType.map,
                received: ctx.parsedType,
            });
            return INVALID;
        }
        const keyType = this._def.keyType;
        const valueType = this._def.valueType;
        const pairs = [...ctx.data.entries()].map(([key, value], index) => {
            return {
                key: keyType._parse(new ParseInputLazyPath(ctx, key, ctx.path, [index, "key"])),
                value: valueType._parse(new ParseInputLazyPath(ctx, value, ctx.path, [index, "value"])),
            };
        });
        if (ctx.common.async) {
            const finalMap = new Map();
            return Promise.resolve().then(async () => {
                for (const pair of pairs) {
                    const key = await pair.key;
                    const value = await pair.value;
                    if (key.status === "aborted" || value.status === "aborted") {
                        return INVALID;
                    }
                    if (key.status === "dirty" || value.status === "dirty") {
                        status.dirty();
                    }
                    finalMap.set(key.value, value.value);
                }
                return { status: status.value, value: finalMap };
            });
        }
        else {
            const finalMap = new Map();
            for (const pair of pairs) {
                const key = pair.key;
                const value = pair.value;
                if (key.status === "aborted" || value.status === "aborted") {
                    return INVALID;
                }
                if (key.status === "dirty" || value.status === "dirty") {
                    status.dirty();
                }
                finalMap.set(key.value, value.value);
            }
            return { status: status.value, value: finalMap };
        }
    }
}
ZodMap.create = (keyType, valueType, params) => {
    return new ZodMap({
        valueType,
        keyType,
        typeName: ZodFirstPartyTypeKind.ZodMap,
        ...processCreateParams(params),
    });
};
class ZodSet extends ZodType {
    _parse(input) {
        const { status, ctx } = this._processInputParams(input);
        if (ctx.parsedType !== ZodParsedType.set) {
            addIssueToContext(ctx, {
                code: ZodIssueCode.invalid_type,
                expected: ZodParsedType.set,
                received: ctx.parsedType,
            });
            return INVALID;
        }
        const def = this._def;
        if (def.minSize !== null) {
            if (ctx.data.size < def.minSize.value) {
                addIssueToContext(ctx, {
                    code: ZodIssueCode.too_small,
                    minimum: def.minSize.value,
                    type: "set",
                    inclusive: true,
                    exact: false,
                    message: def.minSize.message,
                });
                status.dirty();
            }
        }
        if (def.maxSize !== null) {
            if (ctx.data.size > def.maxSize.value) {
                addIssueToContext(ctx, {
                    code: ZodIssueCode.too_big,
                    maximum: def.maxSize.value,
                    type: "set",
                    inclusive: true,
                    exact: false,
                    message: def.maxSize.message,
                });
                status.dirty();
            }
        }
        const valueType = this._def.valueType;
        function finalizeSet(elements) {
            const parsedSet = new Set();
            for (const element of elements) {
                if (element.status === "aborted")
                    return INVALID;
                if (element.status === "dirty")
                    status.dirty();
                parsedSet.add(element.value);
            }
            return { status: status.value, value: parsedSet };
        }
        const elements = [...ctx.data.values()].map((item, i) => valueType._parse(new ParseInputLazyPath(ctx, item, ctx.path, i)));
        if (ctx.common.async) {
            return Promise.all(elements).then((elements) => finalizeSet(elements));
        }
        else {
            return finalizeSet(elements);
        }
    }
    min(minSize, message) {
        return new ZodSet({
            ...this._def,
            minSize: { value: minSize, message: errorUtil.toString(message) },
        });
    }
    max(maxSize, message) {
        return new ZodSet({
            ...this._def,
            maxSize: { value: maxSize, message: errorUtil.toString(message) },
        });
    }
    size(size, message) {
        return this.min(size, message).max(size, message);
    }
    nonempty(message) {
        return this.min(1, message);
    }
}
ZodSet.create = (valueType, params) => {
    return new ZodSet({
        valueType,
        minSize: null,
        maxSize: null,
        typeName: ZodFirstPartyTypeKind.ZodSet,
        ...processCreateParams(params),
    });
};
class ZodFunction extends ZodType {
    constructor() {
        super(...arguments);
        this.validate = this.implement;
    }
    _parse(input) {
        const { ctx } = this._processInputParams(input);
        if (ctx.parsedType !== ZodParsedType.function) {
            addIssueToContext(ctx, {
                code: ZodIssueCode.invalid_type,
                expected: ZodParsedType.function,
                received: ctx.parsedType,
            });
            return INVALID;
        }
        function makeArgsIssue(args, error) {
            return makeIssue({
                data: args,
                path: ctx.path,
                errorMaps: [
                    ctx.common.contextualErrorMap,
                    ctx.schemaErrorMap,
                    getErrorMap(),
                    errorMap,
                ].filter((x) => !!x),
                issueData: {
                    code: ZodIssueCode.invalid_arguments,
                    argumentsError: error,
                },
            });
        }
        function makeReturnsIssue(returns, error) {
            return makeIssue({
                data: returns,
                path: ctx.path,
                errorMaps: [
                    ctx.common.contextualErrorMap,
                    ctx.schemaErrorMap,
                    getErrorMap(),
                    errorMap,
                ].filter((x) => !!x),
                issueData: {
                    code: ZodIssueCode.invalid_return_type,
                    returnTypeError: error,
                },
            });
        }
        const params = { errorMap: ctx.common.contextualErrorMap };
        const fn = ctx.data;
        if (this._def.returns instanceof ZodPromise) {
            // Would love a way to avoid disabling this rule, but we need
            // an alias (using an arrow function was what caused 2651).
            // eslint-disable-next-line @typescript-eslint/no-this-alias
            const me = this;
            return OK(async function (...args) {
                const error = new ZodError([]);
                const parsedArgs = await me._def.args
                    .parseAsync(args, params)
                    .catch((e) => {
                    error.addIssue(makeArgsIssue(args, e));
                    throw error;
                });
                const result = await Reflect.apply(fn, this, parsedArgs);
                const parsedReturns = await me._def.returns._def.type
                    .parseAsync(result, params)
                    .catch((e) => {
                    error.addIssue(makeReturnsIssue(result, e));
                    throw error;
                });
                return parsedReturns;
            });
        }
        else {
            // Would love a way to avoid disabling this rule, but we need
            // an alias (using an arrow function was what caused 2651).
            // eslint-disable-next-line @typescript-eslint/no-this-alias
            const me = this;
            return OK(function (...args) {
                const parsedArgs = me._def.args.safeParse(args, params);
                if (!parsedArgs.success) {
                    throw new ZodError([makeArgsIssue(args, parsedArgs.error)]);
                }
                const result = Reflect.apply(fn, this, parsedArgs.data);
                const parsedReturns = me._def.returns.safeParse(result, params);
                if (!parsedReturns.success) {
                    throw new ZodError([makeReturnsIssue(result, parsedReturns.error)]);
                }
                return parsedReturns.data;
            });
        }
    }
    parameters() {
        return this._def.args;
    }
    returnType() {
        return this._def.returns;
    }
    args(...items) {
        return new ZodFunction({
            ...this._def,
            args: ZodTuple.create(items).rest(ZodUnknown.create()),
        });
    }
    returns(returnType) {
        return new ZodFunction({
            ...this._def,
            returns: returnType,
        });
    }
    implement(func) {
        const validatedFunc = this.parse(func);
        return validatedFunc;
    }
    strictImplement(func) {
        const validatedFunc = this.parse(func);
        return validatedFunc;
    }
    static create(args, returns, params) {
        return new ZodFunction({
            args: (args
                ? args
                : ZodTuple.create([]).rest(ZodUnknown.create())),
            returns: returns || ZodUnknown.create(),
            typeName: ZodFirstPartyTypeKind.ZodFunction,
            ...processCreateParams(params),
        });
    }
}
class ZodLazy extends ZodType {
    get schema() {
        return this._def.getter();
    }
    _parse(input) {
        const { ctx } = this._processInputParams(input);
        const lazySchema = this._def.getter();
        return lazySchema._parse({ data: ctx.data, path: ctx.path, parent: ctx });
    }
}
ZodLazy.create = (getter, params) => {
    return new ZodLazy({
        getter: getter,
        typeName: ZodFirstPartyTypeKind.ZodLazy,
        ...processCreateParams(params),
    });
};
class ZodLiteral extends ZodType {
    _parse(input) {
        if (input.data !== this._def.value) {
            const ctx = this._getOrReturnCtx(input);
            addIssueToContext(ctx, {
                received: ctx.data,
                code: ZodIssueCode.invalid_literal,
                expected: this._def.value,
            });
            return INVALID;
        }
        return { status: "valid", value: input.data };
    }
    get value() {
        return this._def.value;
    }
}
ZodLiteral.create = (value, params) => {
    return new ZodLiteral({
        value: value,
        typeName: ZodFirstPartyTypeKind.ZodLiteral,
        ...processCreateParams(params),
    });
};
function createZodEnum(values, params) {
    return new ZodEnum({
        values,
        typeName: ZodFirstPartyTypeKind.ZodEnum,
        ...processCreateParams(params),
    });
}
class ZodEnum extends ZodType {
    _parse(input) {
        if (typeof input.data !== "string") {
            const ctx = this._getOrReturnCtx(input);
            const expectedValues = this._def.values;
            addIssueToContext(ctx, {
                expected: util.joinValues(expectedValues),
                received: ctx.parsedType,
                code: ZodIssueCode.invalid_type,
            });
            return INVALID;
        }
        if (this._def.values.indexOf(input.data) === -1) {
            const ctx = this._getOrReturnCtx(input);
            const expectedValues = this._def.values;
            addIssueToContext(ctx, {
                received: ctx.data,
                code: ZodIssueCode.invalid_enum_value,
                options: expectedValues,
            });
            return INVALID;
        }
        return OK(input.data);
    }
    get options() {
        return this._def.values;
    }
    get enum() {
        const enumValues = {};
        for (const val of this._def.values) {
            enumValues[val] = val;
        }
        return enumValues;
    }
    get Values() {
        const enumValues = {};
        for (const val of this._def.values) {
            enumValues[val] = val;
        }
        return enumValues;
    }
    get Enum() {
        const enumValues = {};
        for (const val of this._def.values) {
            enumValues[val] = val;
        }
        return enumValues;
    }
    extract(values) {
        return ZodEnum.create(values);
    }
    exclude(values) {
        return ZodEnum.create(this.options.filter((opt) => !values.includes(opt)));
    }
}
ZodEnum.create = createZodEnum;
class ZodNativeEnum extends ZodType {
    _parse(input) {
        const nativeEnumValues = util.getValidEnumValues(this._def.values);
        const ctx = this._getOrReturnCtx(input);
        if (ctx.parsedType !== ZodParsedType.string &&
            ctx.parsedType !== ZodParsedType.number) {
            const expectedValues = util.objectValues(nativeEnumValues);
            addIssueToContext(ctx, {
                expected: util.joinValues(expectedValues),
                received: ctx.parsedType,
                code: ZodIssueCode.invalid_type,
            });
            return INVALID;
        }
        if (nativeEnumValues.indexOf(input.data) === -1) {
            const expectedValues = util.objectValues(nativeEnumValues);
            addIssueToContext(ctx, {
                received: ctx.data,
                code: ZodIssueCode.invalid_enum_value,
                options: expectedValues,
            });
            return INVALID;
        }
        return OK(input.data);
    }
    get enum() {
        return this._def.values;
    }
}
ZodNativeEnum.create = (values, params) => {
    return new ZodNativeEnum({
        values: values,
        typeName: ZodFirstPartyTypeKind.ZodNativeEnum,
        ...processCreateParams(params),
    });
};
class ZodPromise extends ZodType {
    unwrap() {
        return this._def.type;
    }
    _parse(input) {
        const { ctx } = this._processInputParams(input);
        if (ctx.parsedType !== ZodParsedType.promise &&
            ctx.common.async === false) {
            addIssueToContext(ctx, {
                code: ZodIssueCode.invalid_type,
                expected: ZodParsedType.promise,
                received: ctx.parsedType,
            });
            return INVALID;
        }
        const promisified = ctx.parsedType === ZodParsedType.promise
            ? ctx.data
            : Promise.resolve(ctx.data);
        return OK(promisified.then((data) => {
            return this._def.type.parseAsync(data, {
                path: ctx.path,
                errorMap: ctx.common.contextualErrorMap,
            });
        }));
    }
}
ZodPromise.create = (schema, params) => {
    return new ZodPromise({
        type: schema,
        typeName: ZodFirstPartyTypeKind.ZodPromise,
        ...processCreateParams(params),
    });
};
class ZodEffects extends ZodType {
    innerType() {
        return this._def.schema;
    }
    sourceType() {
        return this._def.schema._def.typeName === ZodFirstPartyTypeKind.ZodEffects
            ? this._def.schema.sourceType()
            : this._def.schema;
    }
    _parse(input) {
        const { status, ctx } = this._processInputParams(input);
        const effect = this._def.effect || null;
        const checkCtx = {
            addIssue: (arg) => {
                addIssueToContext(ctx, arg);
                if (arg.fatal) {
                    status.abort();
                }
                else {
                    status.dirty();
                }
            },
            get path() {
                return ctx.path;
            },
        };
        checkCtx.addIssue = checkCtx.addIssue.bind(checkCtx);
        if (effect.type === "preprocess") {
            const processed = effect.transform(ctx.data, checkCtx);
            if (ctx.common.issues.length) {
                return {
                    status: "dirty",
                    value: ctx.data,
                };
            }
            if (ctx.common.async) {
                return Promise.resolve(processed).then((processed) => {
                    return this._def.schema._parseAsync({
                        data: processed,
                        path: ctx.path,
                        parent: ctx,
                    });
                });
            }
            else {
                return this._def.schema._parseSync({
                    data: processed,
                    path: ctx.path,
                    parent: ctx,
                });
            }
        }
        if (effect.type === "refinement") {
            const executeRefinement = (acc
            // effect: RefinementEffect<any>
            ) => {
                const result = effect.refinement(acc, checkCtx);
                if (ctx.common.async) {
                    return Promise.resolve(result);
                }
                if (result instanceof Promise) {
                    throw new Error("Async refinement encountered during synchronous parse operation. Use .parseAsync instead.");
                }
                return acc;
            };
            if (ctx.common.async === false) {
                const inner = this._def.schema._parseSync({
                    data: ctx.data,
                    path: ctx.path,
                    parent: ctx,
                });
                if (inner.status === "aborted")
                    return INVALID;
                if (inner.status === "dirty")
                    status.dirty();
                // return value is ignored
                executeRefinement(inner.value);
                return { status: status.value, value: inner.value };
            }
            else {
                return this._def.schema
                    ._parseAsync({ data: ctx.data, path: ctx.path, parent: ctx })
                    .then((inner) => {
                    if (inner.status === "aborted")
                        return INVALID;
                    if (inner.status === "dirty")
                        status.dirty();
                    return executeRefinement(inner.value).then(() => {
                        return { status: status.value, value: inner.value };
                    });
                });
            }
        }
        if (effect.type === "transform") {
            if (ctx.common.async === false) {
                const base = this._def.schema._parseSync({
                    data: ctx.data,
                    path: ctx.path,
                    parent: ctx,
                });
                if (!isValid(base))
                    return base;
                const result = effect.transform(base.value, checkCtx);
                if (result instanceof Promise) {
                    throw new Error(`Asynchronous transform encountered during synchronous parse operation. Use .parseAsync instead.`);
                }
                return { status: status.value, value: result };
            }
            else {
                return this._def.schema
                    ._parseAsync({ data: ctx.data, path: ctx.path, parent: ctx })
                    .then((base) => {
                    if (!isValid(base))
                        return base;
                    return Promise.resolve(effect.transform(base.value, checkCtx)).then((result) => ({ status: status.value, value: result }));
                });
            }
        }
        util.assertNever(effect);
    }
}
ZodEffects.create = (schema, effect, params) => {
    return new ZodEffects({
        schema,
        typeName: ZodFirstPartyTypeKind.ZodEffects,
        effect,
        ...processCreateParams(params),
    });
};
ZodEffects.createWithPreprocess = (preprocess, schema, params) => {
    return new ZodEffects({
        schema,
        effect: { type: "preprocess", transform: preprocess },
        typeName: ZodFirstPartyTypeKind.ZodEffects,
        ...processCreateParams(params),
    });
};
class ZodOptional extends ZodType {
    _parse(input) {
        const parsedType = this._getType(input);
        if (parsedType === ZodParsedType.undefined) {
            return OK(undefined);
        }
        return this._def.innerType._parse(input);
    }
    unwrap() {
        return this._def.innerType;
    }
}
ZodOptional.create = (type, params) => {
    return new ZodOptional({
        innerType: type,
        typeName: ZodFirstPartyTypeKind.ZodOptional,
        ...processCreateParams(params),
    });
};
class ZodNullable extends ZodType {
    _parse(input) {
        const parsedType = this._getType(input);
        if (parsedType === ZodParsedType.null) {
            return OK(null);
        }
        return this._def.innerType._parse(input);
    }
    unwrap() {
        return this._def.innerType;
    }
}
ZodNullable.create = (type, params) => {
    return new ZodNullable({
        innerType: type,
        typeName: ZodFirstPartyTypeKind.ZodNullable,
        ...processCreateParams(params),
    });
};
class ZodDefault extends ZodType {
    _parse(input) {
        const { ctx } = this._processInputParams(input);
        let data = ctx.data;
        if (ctx.parsedType === ZodParsedType.undefined) {
            data = this._def.defaultValue();
        }
        return this._def.innerType._parse({
            data,
            path: ctx.path,
            parent: ctx,
        });
    }
    removeDefault() {
        return this._def.innerType;
    }
}
ZodDefault.create = (type, params) => {
    return new ZodDefault({
        innerType: type,
        typeName: ZodFirstPartyTypeKind.ZodDefault,
        defaultValue: typeof params.default === "function"
            ? params.default
            : () => params.default,
        ...processCreateParams(params),
    });
};
class ZodCatch extends ZodType {
    _parse(input) {
        const { ctx } = this._processInputParams(input);
        // newCtx is used to not collect issues from inner types in ctx
        const newCtx = {
            ...ctx,
            common: {
                ...ctx.common,
                issues: [],
            },
        };
        const result = this._def.innerType._parse({
            data: newCtx.data,
            path: newCtx.path,
            parent: {
                ...newCtx,
            },
        });
        if (isAsync(result)) {
            return result.then((result) => {
                return {
                    status: "valid",
                    value: result.status === "valid"
                        ? result.value
                        : this._def.catchValue({
                            get error() {
                                return new ZodError(newCtx.common.issues);
                            },
                            input: newCtx.data,
                        }),
                };
            });
        }
        else {
            return {
                status: "valid",
                value: result.status === "valid"
                    ? result.value
                    : this._def.catchValue({
                        get error() {
                            return new ZodError(newCtx.common.issues);
                        },
                        input: newCtx.data,
                    }),
            };
        }
    }
    removeCatch() {
        return this._def.innerType;
    }
}
ZodCatch.create = (type, params) => {
    return new ZodCatch({
        innerType: type,
        typeName: ZodFirstPartyTypeKind.ZodCatch,
        catchValue: typeof params.catch === "function" ? params.catch : () => params.catch,
        ...processCreateParams(params),
    });
};
class ZodNaN extends ZodType {
    _parse(input) {
        const parsedType = this._getType(input);
        if (parsedType !== ZodParsedType.nan) {
            const ctx = this._getOrReturnCtx(input);
            addIssueToContext(ctx, {
                code: ZodIssueCode.invalid_type,
                expected: ZodParsedType.nan,
                received: ctx.parsedType,
            });
            return INVALID;
        }
        return { status: "valid", value: input.data };
    }
}
ZodNaN.create = (params) => {
    return new ZodNaN({
        typeName: ZodFirstPartyTypeKind.ZodNaN,
        ...processCreateParams(params),
    });
};
const BRAND = Symbol("zod_brand");
class ZodBranded extends ZodType {
    _parse(input) {
        const { ctx } = this._processInputParams(input);
        const data = ctx.data;
        return this._def.type._parse({
            data,
            path: ctx.path,
            parent: ctx,
        });
    }
    unwrap() {
        return this._def.type;
    }
}
class ZodPipeline extends ZodType {
    _parse(input) {
        const { status, ctx } = this._processInputParams(input);
        if (ctx.common.async) {
            const handleAsync = async () => {
                const inResult = await this._def.in._parseAsync({
                    data: ctx.data,
                    path: ctx.path,
                    parent: ctx,
                });
                if (inResult.status === "aborted")
                    return INVALID;
                if (inResult.status === "dirty") {
                    status.dirty();
                    return DIRTY(inResult.value);
                }
                else {
                    return this._def.out._parseAsync({
                        data: inResult.value,
                        path: ctx.path,
                        parent: ctx,
                    });
                }
            };
            return handleAsync();
        }
        else {
            const inResult = this._def.in._parseSync({
                data: ctx.data,
                path: ctx.path,
                parent: ctx,
            });
            if (inResult.status === "aborted")
                return INVALID;
            if (inResult.status === "dirty") {
                status.dirty();
                return {
                    status: "dirty",
                    value: inResult.value,
                };
            }
            else {
                return this._def.out._parseSync({
                    data: inResult.value,
                    path: ctx.path,
                    parent: ctx,
                });
            }
        }
    }
    static create(a, b) {
        return new ZodPipeline({
            in: a,
            out: b,
            typeName: ZodFirstPartyTypeKind.ZodPipeline,
        });
    }
}
class ZodReadonly extends ZodType {
    _parse(input) {
        const result = this._def.innerType._parse(input);
        if (isValid(result)) {
            result.value = Object.freeze(result.value);
        }
        return result;
    }
}
ZodReadonly.create = (type, params) => {
    return new ZodReadonly({
        innerType: type,
        typeName: ZodFirstPartyTypeKind.ZodReadonly,
        ...processCreateParams(params),
    });
};
const custom = (check, params = {}, 
/**
 * @deprecated
 *
 * Pass `fatal` into the params object instead:
 *
 * ```ts
 * z.string().custom((val) => val.length > 5, { fatal: false })
 * ```
 *
 */
fatal) => {
    if (check)
        return ZodAny.create().superRefine((data, ctx) => {
            var _a, _b;
            if (!check(data)) {
                const p = typeof params === "function"
                    ? params(data)
                    : typeof params === "string"
                        ? { message: params }
                        : params;
                const _fatal = (_b = (_a = p.fatal) !== null && _a !== void 0 ? _a : fatal) !== null && _b !== void 0 ? _b : true;
                const p2 = typeof p === "string" ? { message: p } : p;
                ctx.addIssue({ code: "custom", ...p2, fatal: _fatal });
            }
        });
    return ZodAny.create();
};
const late = {
    object: ZodObject.lazycreate,
};
var ZodFirstPartyTypeKind;
(function (ZodFirstPartyTypeKind) {
    ZodFirstPartyTypeKind["ZodString"] = "ZodString";
    ZodFirstPartyTypeKind["ZodNumber"] = "ZodNumber";
    ZodFirstPartyTypeKind["ZodNaN"] = "ZodNaN";
    ZodFirstPartyTypeKind["ZodBigInt"] = "ZodBigInt";
    ZodFirstPartyTypeKind["ZodBoolean"] = "ZodBoolean";
    ZodFirstPartyTypeKind["ZodDate"] = "ZodDate";
    ZodFirstPartyTypeKind["ZodSymbol"] = "ZodSymbol";
    ZodFirstPartyTypeKind["ZodUndefined"] = "ZodUndefined";
    ZodFirstPartyTypeKind["ZodNull"] = "ZodNull";
    ZodFirstPartyTypeKind["ZodAny"] = "ZodAny";
    ZodFirstPartyTypeKind["ZodUnknown"] = "ZodUnknown";
    ZodFirstPartyTypeKind["ZodNever"] = "ZodNever";
    ZodFirstPartyTypeKind["ZodVoid"] = "ZodVoid";
    ZodFirstPartyTypeKind["ZodArray"] = "ZodArray";
    ZodFirstPartyTypeKind["ZodObject"] = "ZodObject";
    ZodFirstPartyTypeKind["ZodUnion"] = "ZodUnion";
    ZodFirstPartyTypeKind["ZodDiscriminatedUnion"] = "ZodDiscriminatedUnion";
    ZodFirstPartyTypeKind["ZodIntersection"] = "ZodIntersection";
    ZodFirstPartyTypeKind["ZodTuple"] = "ZodTuple";
    ZodFirstPartyTypeKind["ZodRecord"] = "ZodRecord";
    ZodFirstPartyTypeKind["ZodMap"] = "ZodMap";
    ZodFirstPartyTypeKind["ZodSet"] = "ZodSet";
    ZodFirstPartyTypeKind["ZodFunction"] = "ZodFunction";
    ZodFirstPartyTypeKind["ZodLazy"] = "ZodLazy";
    ZodFirstPartyTypeKind["ZodLiteral"] = "ZodLiteral";
    ZodFirstPartyTypeKind["ZodEnum"] = "ZodEnum";
    ZodFirstPartyTypeKind["ZodEffects"] = "ZodEffects";
    ZodFirstPartyTypeKind["ZodNativeEnum"] = "ZodNativeEnum";
    ZodFirstPartyTypeKind["ZodOptional"] = "ZodOptional";
    ZodFirstPartyTypeKind["ZodNullable"] = "ZodNullable";
    ZodFirstPartyTypeKind["ZodDefault"] = "ZodDefault";
    ZodFirstPartyTypeKind["ZodCatch"] = "ZodCatch";
    ZodFirstPartyTypeKind["ZodPromise"] = "ZodPromise";
    ZodFirstPartyTypeKind["ZodBranded"] = "ZodBranded";
    ZodFirstPartyTypeKind["ZodPipeline"] = "ZodPipeline";
    ZodFirstPartyTypeKind["ZodReadonly"] = "ZodReadonly";
})(ZodFirstPartyTypeKind || (ZodFirstPartyTypeKind = {}));
const instanceOfType = (
// const instanceOfType = <T extends new (...args: any[]) => any>(
cls, params = {
    message: `Input not instance of ${cls.name}`,
}) => custom((data) => data instanceof cls, params);
const stringType = ZodString.create;
const numberType = ZodNumber.create;
const nanType = ZodNaN.create;
const bigIntType = ZodBigInt.create;
const booleanType = ZodBoolean.create;
const dateType = ZodDate.create;
const symbolType = ZodSymbol.create;
const undefinedType = ZodUndefined.create;
const nullType = ZodNull.create;
const anyType = ZodAny.create;
const unknownType = ZodUnknown.create;
const neverType = ZodNever.create;
const voidType = ZodVoid.create;
const arrayType = ZodArray.create;
const objectType = ZodObject.create;
const strictObjectType = ZodObject.strictCreate;
const unionType = ZodUnion.create;
const discriminatedUnionType = ZodDiscriminatedUnion.create;
const intersectionType = ZodIntersection.create;
const tupleType = ZodTuple.create;
const recordType = ZodRecord.create;
const mapType = ZodMap.create;
const setType = ZodSet.create;
const functionType = ZodFunction.create;
const lazyType = ZodLazy.create;
const literalType = ZodLiteral.create;
const enumType = ZodEnum.create;
const nativeEnumType = ZodNativeEnum.create;
const promiseType = ZodPromise.create;
const effectsType = ZodEffects.create;
const optionalType = ZodOptional.create;
const nullableType = ZodNullable.create;
const preprocessType = ZodEffects.createWithPreprocess;
const pipelineType = ZodPipeline.create;
const ostring = () => stringType().optional();
const onumber = () => numberType().optional();
const oboolean = () => booleanType().optional();
const coerce = {
    string: ((arg) => ZodString.create({ ...arg, coerce: true })),
    number: ((arg) => ZodNumber.create({ ...arg, coerce: true })),
    boolean: ((arg) => ZodBoolean.create({
        ...arg,
        coerce: true,
    })),
    bigint: ((arg) => ZodBigInt.create({ ...arg, coerce: true })),
    date: ((arg) => ZodDate.create({ ...arg, coerce: true })),
};
const NEVER = INVALID;

var z = /*#__PURE__*/Object.freeze({
    __proto__: null,
    defaultErrorMap: errorMap,
    setErrorMap: setErrorMap,
    getErrorMap: getErrorMap,
    makeIssue: makeIssue,
    EMPTY_PATH: EMPTY_PATH,
    addIssueToContext: addIssueToContext,
    ParseStatus: ParseStatus,
    INVALID: INVALID,
    DIRTY: DIRTY,
    OK: OK,
    isAborted: isAborted,
    isDirty: isDirty,
    isValid: isValid,
    isAsync: isAsync,
    get util () { return util; },
    get objectUtil () { return objectUtil; },
    ZodParsedType: ZodParsedType,
    getParsedType: getParsedType,
    ZodType: ZodType,
    ZodString: ZodString,
    ZodNumber: ZodNumber,
    ZodBigInt: ZodBigInt,
    ZodBoolean: ZodBoolean,
    ZodDate: ZodDate,
    ZodSymbol: ZodSymbol,
    ZodUndefined: ZodUndefined,
    ZodNull: ZodNull,
    ZodAny: ZodAny,
    ZodUnknown: ZodUnknown,
    ZodNever: ZodNever,
    ZodVoid: ZodVoid,
    ZodArray: ZodArray,
    ZodObject: ZodObject,
    ZodUnion: ZodUnion,
    ZodDiscriminatedUnion: ZodDiscriminatedUnion,
    ZodIntersection: ZodIntersection,
    ZodTuple: ZodTuple,
    ZodRecord: ZodRecord,
    ZodMap: ZodMap,
    ZodSet: ZodSet,
    ZodFunction: ZodFunction,
    ZodLazy: ZodLazy,
    ZodLiteral: ZodLiteral,
    ZodEnum: ZodEnum,
    ZodNativeEnum: ZodNativeEnum,
    ZodPromise: ZodPromise,
    ZodEffects: ZodEffects,
    ZodTransformer: ZodEffects,
    ZodOptional: ZodOptional,
    ZodNullable: ZodNullable,
    ZodDefault: ZodDefault,
    ZodCatch: ZodCatch,
    ZodNaN: ZodNaN,
    BRAND: BRAND,
    ZodBranded: ZodBranded,
    ZodPipeline: ZodPipeline,
    ZodReadonly: ZodReadonly,
    custom: custom,
    Schema: ZodType,
    ZodSchema: ZodType,
    late: late,
    get ZodFirstPartyTypeKind () { return ZodFirstPartyTypeKind; },
    coerce: coerce,
    any: anyType,
    array: arrayType,
    bigint: bigIntType,
    boolean: booleanType,
    date: dateType,
    discriminatedUnion: discriminatedUnionType,
    effect: effectsType,
    'enum': enumType,
    'function': functionType,
    'instanceof': instanceOfType,
    intersection: intersectionType,
    lazy: lazyType,
    literal: literalType,
    map: mapType,
    nan: nanType,
    nativeEnum: nativeEnumType,
    never: neverType,
    'null': nullType,
    nullable: nullableType,
    number: numberType,
    object: objectType,
    oboolean: oboolean,
    onumber: onumber,
    optional: optionalType,
    ostring: ostring,
    pipeline: pipelineType,
    preprocess: preprocessType,
    promise: promiseType,
    record: recordType,
    set: setType,
    strictObject: strictObjectType,
    string: stringType,
    symbol: symbolType,
    transformer: effectsType,
    tuple: tupleType,
    'undefined': undefinedType,
    union: unionType,
    unknown: unknownType,
    'void': voidType,
    NEVER: NEVER,
    ZodIssueCode: ZodIssueCode,
    quotelessJson: quotelessJson,
    ZodError: ZodError
});



// EXTERNAL MODULE: ./app/components/icon-tsx/index.ts + 11 modules
var icon_tsx = __webpack_require__(61552);
// EXTERNAL MODULE: ./app/helpers/index.ts + 2 modules
var helpers = __webpack_require__(2993);
;// CONCATENATED MODULE: ./app/components/icon-tsx/IconClearInput.tsx



const IconClearInput = (param)=>{
    let { onClick =helpers/* doNothing */.cn , onMouseDown =helpers/* doNothing */.cn  } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
        width: "24",
        height: "25",
        viewBox: "0 0 24 25",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        onClick: onClick,
        onMouseDown: onMouseDown,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M22 12.5C22 18.0228 17.5228 22.5 12 22.5C6.47715 22.5 2 18.0228 2 12.5C2 6.97715 6.47715 2.5 12 2.5C17.5228 2.5 22 6.97715 22 12.5ZM15.3588 15.8587C15.0659 16.1516 14.591 16.1516 14.2981 15.8587L12 13.5606L9.7019 15.8587C9.40901 16.1516 8.93413 16.1516 8.64124 15.8587C8.34835 15.5658 8.34835 15.0909 8.64124 14.798L10.9393 12.4999L8.64125 10.2018C8.34836 9.90895 8.34836 9.43408 8.64125 9.14118C8.93415 8.84829 9.40902 8.84829 9.70191 9.14118L12 11.4393L14.2981 9.14119C14.591 8.8483 15.0659 8.8483 15.3588 9.14119C15.6516 9.43409 15.6516 9.90896 15.3588 10.2019L13.0607 12.4999L15.3588 14.798C15.6517 15.0909 15.6517 15.5658 15.3588 15.8587Z",
            fill: "#C8CACC"
        })
    });
};

// EXTERNAL MODULE: ./app/components/ui/button.tsx
var ui_button = __webpack_require__(34428);
// EXTERNAL MODULE: ./app/components/ui/dialog.tsx
var dialog = __webpack_require__(76500);
// EXTERNAL MODULE: ./app/lib/utils.ts + 1 modules
var utils = __webpack_require__(73848);
;// CONCATENATED MODULE: ./app/components/ui/floating-input.tsx



// eslint-disable-next-line react/display-name
const FloatingInput = /*#__PURE__*/ react.forwardRef((param, ref)=>{
    let { postfixIcon , onFocus , onBlur , label , placeholder , className , labelClassName , ...props } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "relative",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                type: "text",
                id: "floating_outlined-".concat(label),
                className: (0,utils.cn)("peer block w-full appearance-none rounded-lg border-[1px] border-stroke dark:border-neutral-03 bg-transparent dark:bg-transparent px-[24px] text-sm text-gray-900 focus:border-main-01 focus:outline-none focus:ring-0", className),
                placeholder: " ",
                onFocus: onFocus,
                onBlur: onBlur,
                ...props
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                htmlFor: "floating_outlined-".concat(label),
                className: (0,utils.cn)("ml-2 peer-focus:ml-0 absolute text-sm text-text-grey-03 duration-300 transform -translate-y-4 scale-75 top-2 z-10 origin-[0] bg-white dark:bg-bg-02 px-2 peer-focus:px-2 peer-focus:text-main-01  peer-placeholder-shown:scale-100 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:top-1/2 peer-focus:top-2 peer-focus:scale-75 peer-focus:-translate-y-4 peer-focus:translate-x-4 rtl:peer-focus:left-auto start-1", labelClassName),
                children: label
            }),
            postfixIcon && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "absolute top-1/2 right-[24px] transform -translate-y-1/2 cursor-pointer",
                children: postfixIcon
            })
        ]
    });
});

// EXTERNAL MODULE: ./node_modules/@radix-ui/react-slot/dist/index.mjs
var dist = __webpack_require__(88426);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__(87462);
// EXTERNAL MODULE: ./node_modules/@radix-ui/react-primitive/dist/index.mjs
var react_primitive_dist = __webpack_require__(75320);
;// CONCATENATED MODULE: ./node_modules/@radix-ui/react-label/dist/index.mjs







/* -------------------------------------------------------------------------------------------------
 * Label
 * -----------------------------------------------------------------------------------------------*/ const $b73a6c6685e72184$var$NAME = 'Label';
const $b73a6c6685e72184$export$b04be29aa201d4f5 = /*#__PURE__*/ (0,react.forwardRef)((props, forwardedRef)=>{
    return /*#__PURE__*/ (0,react.createElement)(react_primitive_dist/* Primitive.label */.WV.label, (0,esm_extends/* default */.Z)({}, props, {
        ref: forwardedRef,
        onMouseDown: (event)=>{
            var _props$onMouseDown;
            (_props$onMouseDown = props.onMouseDown) === null || _props$onMouseDown === void 0 || _props$onMouseDown.call(props, event); // prevent text selection when double clicking label
            if (!event.defaultPrevented && event.detail > 1) event.preventDefault();
        }
    }));
});
/*#__PURE__*/ Object.assign($b73a6c6685e72184$export$b04be29aa201d4f5, {
    displayName: $b73a6c6685e72184$var$NAME
});
/* -----------------------------------------------------------------------------------------------*/ const $b73a6c6685e72184$export$be92b6f5f03c0fe9 = $b73a6c6685e72184$export$b04be29aa201d4f5;





//# sourceMappingURL=index.mjs.map

// EXTERNAL MODULE: ./node_modules/class-variance-authority/dist/index.mjs
var class_variance_authority_dist = __webpack_require__(12003);
;// CONCATENATED MODULE: ./app/components/ui/label.tsx





const labelVariants = (0,class_variance_authority_dist/* cva */.j)("text-sm font-medium leading-none peer-disabled:cursor-not-allowed peer-disabled:opacity-70");
const Label = /*#__PURE__*/ react.forwardRef((param, ref)=>/*#__PURE__*/ {
    let { className , ...props } = param;
    return (0,jsx_runtime.jsx)($b73a6c6685e72184$export$be92b6f5f03c0fe9, {
        ref: ref,
        className: (0,utils.cn)(labelVariants(), className),
        ...props
    });
});
Label.displayName = $b73a6c6685e72184$export$be92b6f5f03c0fe9.displayName;


;// CONCATENATED MODULE: ./app/components/ui/form.tsx






const Form = index_esm/* FormProvider */.RV;
const FormFieldContext = /*#__PURE__*/ react.createContext({});
const FormField = (param)=>{
    let { ...props } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(FormFieldContext.Provider, {
        value: {
            name: props.name
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Controller */.Qr, {
            ...props
        })
    });
};
const useFormField = ()=>{
    const fieldContext = react.useContext(FormFieldContext);
    const itemContext = react.useContext(FormItemContext);
    const { getFieldState , formState  } = (0,index_esm/* useFormContext */.Gc)();
    const fieldState = getFieldState(fieldContext.name, formState);
    if (!fieldContext) {
        throw new Error("useFormField should be used within <FormField>");
    }
    const { id  } = itemContext;
    return {
        id,
        name: fieldContext.name,
        formItemId: "".concat(id, "-form-item"),
        formDescriptionId: "".concat(id, "-form-item-description"),
        formMessageId: "".concat(id, "-form-item-message"),
        ...fieldState
    };
};
const FormItemContext = /*#__PURE__*/ react.createContext({});
const FormItem = /*#__PURE__*/ react.forwardRef((param, ref)=>{
    let { className , ...props } = param;
    const id = react.useId();
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(FormItemContext.Provider, {
        value: {
            id
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            ref: ref,
            className: (0,utils.cn)("space-y-2", className),
            ...props
        })
    });
});
FormItem.displayName = "FormItem";
const FormLabel = /*#__PURE__*/ react.forwardRef((param, ref)=>{
    let { className , ...props } = param;
    const { error , formItemId  } = useFormField();
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Label, {
        ref: ref,
        className: (0,utils.cn)(error && "text-destructive", className),
        htmlFor: formItemId,
        ...props
    });
});
FormLabel.displayName = "FormLabel";
const FormControl = /*#__PURE__*/ react.forwardRef((param, ref)=>{
    let { ...props } = param;
    const { error , formItemId , formDescriptionId , formMessageId  } = useFormField();
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* Slot */.g7, {
        ref: ref,
        id: formItemId,
        "aria-describedby": !error ? "".concat(formDescriptionId) : "".concat(formDescriptionId, " ").concat(formMessageId),
        "aria-invalid": !!error,
        ...props
    });
});
FormControl.displayName = "FormControl";
const FormDescription = /*#__PURE__*/ react.forwardRef((param, ref)=>{
    let { className , ...props } = param;
    const { formDescriptionId  } = useFormField();
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
        ref: ref,
        id: formDescriptionId,
        className: (0,utils.cn)("text-sm text-muted-foreground", className),
        ...props
    });
});
FormDescription.displayName = "FormDescription";
const FormMessage = /*#__PURE__*/ react.forwardRef((param, ref)=>{
    let { className , children , ...props } = param;
    const { error , formMessageId  } = useFormField();
    const body = error ? String(error === null || error === void 0 ? void 0 : error.message) : children;
    if (!body) {
        return null;
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
        ref: ref,
        id: formMessageId,
        className: (0,utils.cn)("text-sm font-medium text-destructive", className),
        ...props,
        children: body
    });
});
FormMessage.displayName = "FormMessage";


// EXTERNAL MODULE: ./app/components/ui/use-toast.ts
var use_toast = __webpack_require__(2786);
// EXTERNAL MODULE: ./app/configs/index.ts + 3 modules
var configs = __webpack_require__(54254);
// EXTERNAL MODULE: ./app/services/query-fn/index.ts + 6 modules
var query_fn = __webpack_require__(58512);
// EXTERNAL MODULE: ./node_modules/lucide-react/dist/esm/createLucideIcon.js + 1 modules
var createLucideIcon = __webpack_require__(84297);
;// CONCATENATED MODULE: ./node_modules/lucide-react/dist/esm/icons/eye.js
/**
 * @license lucide-react v0.303.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */



const Eye = (0,createLucideIcon/* default */.Z)("Eye", [
  ["path", { d: "M2 12s3-7 10-7 10 7 10 7-3 7-10 7-10-7-10-7Z", key: "rwhkz3" }],
  ["circle", { cx: "12", cy: "12", r: "3", key: "1v7zrd" }]
]);


//# sourceMappingURL=eye.js.map

;// CONCATENATED MODULE: ./node_modules/lucide-react/dist/esm/icons/eye-off.js
/**
 * @license lucide-react v0.303.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */



const EyeOff = (0,createLucideIcon/* default */.Z)("EyeOff", [
  ["path", { d: "M9.88 9.88a3 3 0 1 0 4.24 4.24", key: "1jxqfv" }],
  [
    "path",
    {
      d: "M10.73 5.08A10.43 10.43 0 0 1 12 5c7 0 10 7 10 7a13.16 13.16 0 0 1-1.67 2.68",
      key: "9wicm4"
    }
  ],
  [
    "path",
    { d: "M6.61 6.61A13.526 13.526 0 0 0 2 12s3 7 10 7a9.74 9.74 0 0 0 5.39-1.61", key: "1jreej" }
  ],
  ["line", { x1: "2", x2: "22", y1: "2", y2: "22", key: "a6p6uj" }]
]);


//# sourceMappingURL=eye-off.js.map

// EXTERNAL MODULE: ./node_modules/@tanstack/react-query/build/modern/QueryClientProvider.js
var QueryClientProvider = __webpack_require__(30202);
// EXTERNAL MODULE: ./public/img/playee_full_text.png
var playee_full_text = __webpack_require__(89038);
// EXTERNAL MODULE: ./public/img/playee_full_text_dark.png
var playee_full_text_dark = __webpack_require__(74050);
// EXTERNAL MODULE: ./app/context/index.ts + 2 modules
var context = __webpack_require__(17986);
// EXTERNAL MODULE: ./app/hooks/useGAEventsTracker.ts
var useGAEventsTracker = __webpack_require__(64800);
;// CONCATENATED MODULE: ./app/containers/auth/LoginModal.tsx






















const LoginFormSchema = objectType({
    username: stringType().min(1, {
        message: esm/* i18n */.ag === null || esm/* i18n */.ag === void 0 ? void 0 : esm/* i18n.t */.ag.t("message.required", {
            field: "Gamota Id"
        })
    }),
    password: stringType().min(1, {
        message: esm/* i18n */.ag === null || esm/* i18n */.ag === void 0 ? void 0 : esm/* i18n.t */.ag.t("message.required", {
            field: esm/* i18n */.ag === null || esm/* i18n */.ag === void 0 ? void 0 : esm/* i18n.t */.ag.t("common.password")
        })
    })
});
const LoginModal = (param)=>{
    let { trigger  } = param;
    const router = (0,next_router.useRouter)();
    const { toast  } = (0,use_toast/* useToast */.pm)();
    const { t  } = (0,esm/* useTranslation */.$G)();
    const GAEventsTracker = (0,useGAEventsTracker/* default */.Z)("Login");
    const GAEventsTrackerRegister = (0,useGAEventsTracker/* default */.Z)("Register");
    const { themeApp  } = (0,react.useContext)(context/* AppContext */.Il);
    const { openModal , setOpenModal  } = (0,react.useContext)(context/* AppContext */.Il);
    const token = configs/* isClient */.C5 ? window.localStorage.getItem("token") : null;
    const secureOffPassword = (0,react.useMemo)(()=>{
        var _router_query;
        return (router === null || router === void 0 ? void 0 : (_router_query = router.query) === null || _router_query === void 0 ? void 0 : _router_query.secure) === "off";
    }, [
        router
    ]);
    const queryClient = (0,QueryClientProvider/* useQueryClient */.NL)();
    const [focus, setFocus] = (0,react.useState)();
    const loginForm = (0,index_esm/* useForm */.cI)({
        resolver: zod_t(LoginFormSchema),
        defaultValues: {
            username: "",
            password: ""
        }
    });
    (0,react.useEffect)(()=>{
        if (!!token && openModal === configs/* OPEN_MODAL.LOGIN_MODAL */.a6.LOGIN_MODAL) {
            onRemoveParamAndNavigate(true);
        }
        if (!token && openModal === configs/* OPEN_MODAL.LOGIN_MODAL */.a6.LOGIN_MODAL) {
            GAEventsTracker("Open_login_modal");
        }
    }, [
        token,
        openModal
    ]);
    const { mutate , isPending  } = (0,query_fn/* useMutationNormalLogin */.eN)();
    const { data: dataLoginGoogle , refetch: refetchGetUrlLoginGoogle , isFetching: isFetchingGoogleUrl  } = (0,query_fn/* useQueryGetUrlLoginGoogle */.Zr)();
    const { data: dataLoginFacebook , refetch: refetchGetUrlLoginFacebook , isFetching: isFetchingFacebookUrl  } = (0,query_fn/* useQueryGetUrlLoginFacebook */.p$)();
    const { handleSubmit , control , formState: { isValid  } , clearErrors , reset , watch , setValue  } = loginForm;
    const watchUsername = watch("username");
    const watchPassword = watch("password");
    const onRemoveParamAndNavigate = (success)=>{
        if (success || ![
            "/user/[id]",
            "/topup/[slug_name]",
            "/reward-center/rut-li-xi"
        ].includes(router === null || router === void 0 ? void 0 : router.pathname)) {
            setOpenModal(null);
        } else {
            toast({
                variant: "error",
                title: t("message.need_login_to_view")
            });
        }
    };
    const onSubmitForm = (_data)=>{
        GAEventsTracker("Login_Normal");
        mutate(_data, {
            onSuccess (data) {
                var _data_data;
                const res = data === null || data === void 0 ? void 0 : (_data_data = data.data) === null || _data_data === void 0 ? void 0 : _data_data.data;
                if (!!(res === null || res === void 0 ? void 0 : res.access_token) && configs/* isClient */.C5) {
                    localStorage.setItem("token", res === null || res === void 0 ? void 0 : res.access_token);
                }
                queryClient.invalidateQueries({
                    queryKey: [
                        configs/* QUERY_KEY.PROFILE_INFO */.lP.PROFILE_INFO
                    ],
                    refetchType: "active"
                });
                onLoginSuccess();
            },
            onError (error) {
                var _error_data;
                toast({
                    variant: "error",
                    title: error === null || error === void 0 ? void 0 : (_error_data = error.data) === null || _error_data === void 0 ? void 0 : _error_data.message
                });
            }
        });
    };
    const onLoginSuccess = ()=>{
        // router.back()
        onRemoveParamAndNavigate(true);
        queryClient.invalidateQueries();
        clearErrors();
        reset();
    };
    const handleClose = ()=>{
        onRemoveParamAndNavigate(false);
        clearErrors();
        reset();
    };
    const onChangeSeePassword = (show)=>{
        const { secure , ...currentQuery } = router.query;
        if (!!show) {
            router.push({
                pathname: router.pathname,
                query: {
                    ...currentQuery,
                    secure: "off"
                }
            });
        } else {
            router.push({
                pathname: router.pathname,
                query: currentQuery
            });
        }
    };
    const onChangeFocus = (field)=>{
        setFocus(field);
    };
    const onChangeBlur = (e)=>{
        e.stopPropagation();
        setFocus(undefined);
    };
    const onResetField = (field)=>(e)=>{
            setValue(field, "");
        };
    const getURlGoogleAndRedirect = (0,react.useCallback)(()=>{
        GAEventsTracker("Login_by_Google");
        // refetchGetUrlLoginGoogle()
        if (dataLoginGoogle === null || dataLoginGoogle === void 0 ? void 0 : dataLoginGoogle.data) {
            var _dataLoginGoogle_data;
            localStorage.setItem("urlBeforeLogin", router.asPath);
            router.push(dataLoginGoogle === null || dataLoginGoogle === void 0 ? void 0 : (_dataLoginGoogle_data = dataLoginGoogle.data) === null || _dataLoginGoogle_data === void 0 ? void 0 : _dataLoginGoogle_data._url);
        }
    }, [
        GAEventsTracker,
        dataLoginGoogle === null || dataLoginGoogle === void 0 ? void 0 : dataLoginGoogle.data,
        router
    ]);
    const getURlFacebookAndRedirect = (0,react.useCallback)(()=>{
        GAEventsTracker("Login_by_Facebook");
        // refetchGetUrlLoginFacebook()
        if (dataLoginFacebook === null || dataLoginFacebook === void 0 ? void 0 : dataLoginFacebook.data) {
            var _dataLoginFacebook_data;
            localStorage.setItem("urlBeforeLogin", router.asPath);
            router.push(dataLoginFacebook === null || dataLoginFacebook === void 0 ? void 0 : (_dataLoginFacebook_data = dataLoginFacebook.data) === null || _dataLoginFacebook_data === void 0 ? void 0 : _dataLoginFacebook_data._url);
        }
    }, [
        GAEventsTracker,
        dataLoginFacebook === null || dataLoginFacebook === void 0 ? void 0 : dataLoginFacebook.data,
        router
    ]);
    const onNavigateToRegister = ()=>{
        GAEventsTrackerRegister("Register_Account");
        router.push("https://id.gamota.com/register");
    };
    const onNavigateToForgotPassword = ()=>{
        GAEventsTracker("ForgotPassword_Open");
        router.push("https://id.gamota.com/forgot_password");
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(dialog/* Dialog */.Vq, {
        open: openModal === configs/* OPEN_MODAL.LOGIN_MODAL */.a6.LOGIN_MODAL,
        onOpenChange: handleClose,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(dialog/* DialogTrigger */.hg, {
                asChild: true,
                children: trigger
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(dialog/* DialogContent */.cZ, {
                className: "sm:rounded-[48px] md:max-w-[473px] py-[48px] px-[24px] md:px-[60px] dark:bg-bg-02 outline-none dark:border-0 h-[100vh]",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "flex flex-col items-center justify-center w-full",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                            src: themeApp === "dark" ? playee_full_text_dark/* default.src */.Z.src : playee_full_text/* default.src */.Z.src,
                            className: "w-[234px] h-[81px]"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "w-full mt-[32px]",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Form, {
                                    ...loginForm,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("form", {
                                        onSubmit: handleSubmit(onSubmitForm),
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(FormField, {
                                                control: control,
                                                name: "username",
                                                render: (param)=>/*#__PURE__*/ {
                                                    let { field  } = param;
                                                    return (0,jsx_runtime.jsx)(FormControl, {
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(FloatingInput, {
                                                                placeholder: "Gamota Id",
                                                                label: "Gamota Id",
                                                                ...field,
                                                                className: "block rounded-2xl h-[52px] px-[24px] mb-4 dark:text-white inputDark ".concat(!!watchUsername ? "dark:bg-transparent" : ""),
                                                                labelClassName: "".concat(!!watchUsername ? "dark:bg-bg-02" : ""),
                                                                postfixIcon: !!watch("username") && focus === "username" ? /*#__PURE__*/ (0,jsx_runtime.jsx)(IconClearInput, {
                                                                    onMouseDown: onResetField("username")
                                                                }) : null,
                                                                onFocus: ()=>onChangeFocus("username"),
                                                                onBlur: onChangeBlur
                                                            })
                                                        })
                                                    });
                                                }
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(FormField, {
                                                control: control,
                                                name: "password",
                                                render: (param)=>/*#__PURE__*/ {
                                                    let { field  } = param;
                                                    return (0,jsx_runtime.jsx)(FormControl, {
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(FloatingInput, {
                                                                placeholder: t("common.password"),
                                                                type: secureOffPassword ? "text" : "password",
                                                                label: t("common.password"),
                                                                security: "",
                                                                ...field,
                                                                className: "rounded-2xl h-[52px] px-[24px] mb-4 dark:text-white inputDark ".concat(!!watchPassword ? "dark:bg-transparent" : ""),
                                                                labelClassName: "".concat(!!watchPassword ? "dark:bg-bg-02" : ""),
                                                                onFocus: ()=>onChangeFocus("password"),
                                                                onBlur: onChangeBlur,
                                                                postfixIcon: !!watch("password") && focus === "password" ? /*#__PURE__*/ (0,jsx_runtime.jsx)(IconClearInput, {
                                                                    onMouseDown: onResetField("password")
                                                                }) : secureOffPassword ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Eye, {
                                                                    size: 24,
                                                                    color: "#1C1E1E",
                                                                    onClick: ()=>onChangeSeePassword(false)
                                                                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(EyeOff, {
                                                                    size: 24,
                                                                    color: "#1C1E1E",
                                                                    onClick: ()=>onChangeSeePassword(true)
                                                                })
                                                            })
                                                        })
                                                    });
                                                }
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                className: "flex mt-0 ml-auto text-sm cursor-pointer Nunito-500 w-fit text-main-01 md:mb-4",
                                                onClick: onNavigateToForgotPassword,
                                                children: t("common.forgot_password")
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: "flex flex-col items-center w-full",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                        className: "w-full",
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(ui_button/* Button */.z, {
                                                                type: "submit",
                                                                variant: "none",
                                                                disabled: isPending || !isValid,
                                                                className: "w-full Nunito-700 text-sm rounded-2xl mt-[32px] md:mt-0 px-[24px] h-[52px] flex items-center justify-center ".concat(isPending || !isValid ? "bg-button text-main-01 dark:bg-white/10 dark:text-white" : "text-white bg-main-01"),
                                                                children: t("common.login")
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                                                className: "Nunito-400 text-[#706E7E] text-sm mt-4 text-center",
                                                                children: [
                                                                    "Chưa c\xf3 t\xe0i khoản",
                                                                    " ",
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                        className: "text-sm cursor-pointer Nunito-400 text-main-01",
                                                                        onClick: onNavigateToRegister,
                                                                        children: t("common.register")
                                                                    })
                                                                ]
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                        className: "w-full",
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                className: "w-full flex gap-4 mb-4 mt-[48px] md:mt-4 items-center",
                                                                children: [
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                        className: "h-[1px] w-full bg-black/[.1]"
                                                                    }),
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                        className: "text-[#706E7E] Nunito-400 text-sm",
                                                                        children: t("common.or")
                                                                    }),
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                        className: "h-[1px] w-full bg-black/[.1]"
                                                                    })
                                                                ]
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                className: "w-full grid grid-cols-2 gap-[24px]",
                                                                children: [
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ui_button/* Button */.z, {
                                                                        type: "button",
                                                                        variant: "link",
                                                                        disabled: isFetchingGoogleUrl,
                                                                        className: "rounded-2xl h-[52px] bg-white border border-black/10 dark:border-0 dark:bg-white/10",
                                                                        onClick: getURlGoogleAndRedirect,
                                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(icon_tsx/* IconGoogle */.vY, {})
                                                                    }),
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ui_button/* Button */.z, {
                                                                        type: "button",
                                                                        disabled: isFetchingFacebookUrl,
                                                                        variant: "link",
                                                                        className: "rounded-2xl h-[52px] bg-[#1877F2]",
                                                                        onClick: getURlFacebookAndRedirect,
                                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(icon_tsx/* IconFacebook */.zJ, {})
                                                                    })
                                                                ]
                                                            })
                                                        ]
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "mt-8 text-xs text-center Nunito-500 text-text-02",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(esm/* Trans */.cC, {
                                        i18nKey: t("common.login_desc"),
                                        components: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                className: "text-xs cursor-pointer text-main-01 Nunito-700",
                                                onClick: ()=>{
                                                    router.push("/term-of-services");
                                                }
                                            }, 0),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                className: "text-xs cursor-pointer text-main-01 Nunito-700",
                                                onClick: ()=>{
                                                    router.push("/privacy-policy");
                                                }
                                            }, 1)
                                        ]
                                    })
                                })
                            ]
                        })
                    ]
                })
            })
        ]
    });
};

;// CONCATENATED MODULE: ./app/containers/auth/index.ts


// EXTERNAL MODULE: ./app/components/ui/input.tsx
var input = __webpack_require__(78634);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(25675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ./app/services/query-fn/game/index.ts + 1 modules
var game = __webpack_require__(82190);
// EXTERNAL MODULE: ./app/hooks/useDebounceEffect.tsx
var useDebounceEffect = __webpack_require__(45724);
;// CONCATENATED MODULE: ./app/containers/create-post/add-on/GameMention.tsx










const LIMIT_GAME = 10;
const TIME_DEBOUNCE = 300;
const GameMention = ()=>{
    var _games_pages_flat, _games_pages, _games_pages_at, _games_pages1;
    const { t  } = (0,esm/* useTranslation */.$G)();
    const { setValue , watch  } = (0,index_esm/* useFormContext */.Gc)();
    const { themeApp  } = (0,react.useContext)(context/* AppContext */.Il);
    const [showInput, setShowInput] = (0,react.useState)(false);
    const [searchValue, setSearchValue] = (0,react.useState)("");
    const [debounceSearch, setDebounceSearch] = (0,react.useState)("");
    const { data: games , fetchNextPage  } = (0,game/* useInfiniteGetListGame */.b$)({
        category: "",
        type: "",
        keyword: debounceSearch,
        limit: 10,
        page: 1
    });
    (0,useDebounceEffect/* useDebounceEffect */.s)(()=>setDebounceSearch(searchValue), TIME_DEBOUNCE, [
        searchValue
    ]);
    const selectedGames = watch("selectedGames", []);
    const handleSelectGame = (game)=>{
        setValue("selectedGames", [
            game
        ]);
        setShowInput(false);
    };
    const onChangeSearch = (e)=>{
        var _e_target;
        setSearchValue(e === null || e === void 0 ? void 0 : (_e_target = e.target) === null || _e_target === void 0 ? void 0 : _e_target.value);
    };
    const onRemoveSelectedMentionGame = (id)=>{
        setValue("selectedGames", selectedGames.filter((game)=>game.id !== id));
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "flex items-center gap-3 cursor-pointer",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        className: "text-bg-01 text-[18px] Nunito-700 dark:text-white",
                        children: t("news.mention_game")
                    }),
                    showInput ? /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
                        width: "24",
                        height: "24",
                        viewBox: "0 0 24 24",
                        fill: "none",
                        xmlns: "http://www.w3.org/2000/svg",
                        onClick: ()=>setShowInput(false),
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                            fillRule: "evenodd",
                            clipRule: "evenodd",
                            d: "M18 2H6C3.79086 2 2 3.79086 2 6V18C2 20.2091 3.79086 22 6 22H18C20.2091 22 22 20.2091 22 18V6C22 3.79086 20.2091 2 18 2ZM16 12.75C16.4142 12.75 16.75 12.4142 16.75 12C16.75 11.5858 16.4142 11.25 16 11.25H8C7.58579 11.25 7.25 11.5858 7.25 12C7.25 12.4142 7.58579 12.75 8 12.75H16Z",
                            fill: themeApp === "dark" ? "#fff" : "#100D28"
                        })
                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
                        width: "24",
                        height: "24",
                        viewBox: "0 0 24 24",
                        fill: "none",
                        xmlns: "http://www.w3.org/2000/svg",
                        onClick: ()=>setShowInput(true),
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                            fillRule: "evenodd",
                            clipRule: "evenodd",
                            d: "M6 2H18C20.2091 2 22 3.79086 22 6V18C22 20.2091 20.2091 22 18 22H6C3.79086 22 2 20.2091 2 18V6C2 3.79086 3.79086 2 6 2ZM12 7.25C12.4142 7.25 12.75 7.58579 12.75 8V11.25H16C16.4142 11.25 16.75 11.5858 16.75 12C16.75 12.4142 16.4142 12.75 16 12.75H12.75V16C12.75 16.4142 12.4142 16.75 12 16.75C11.5858 16.75 11.25 16.4142 11.25 16V12.75H8C7.58579 12.75 7.25 12.4142 7.25 12C7.25 11.5858 7.58579 11.25 8 11.25H11.25V8C11.25 7.58579 11.5858 7.25 12 7.25Z",
                            fill: themeApp === "dark" ? "#fff" : "#100D28"
                        })
                    })
                ]
            }),
            showInput ? /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "relative w-full",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(input/* Input */.I, {
                            autoFocus: showInput,
                            placeholder: t("news.placeholder_mention_game"),
                            value: searchValue,
                            onChange: onChangeSearch,
                            className: "border-0 border-b-[1px] rounded-none h-10 dark:bg-transparent"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "w-full absolute top-[57px] bg-white dark:bg-dark-mode-box h-[250px] overflow-auto p-3 rounded-tr-sm rounded-tl-sm rounded-bl-2xl rounded-br-2xl no-scrollbar z-10",
                            style: {
                                boxShadow: "0px 3px 30px 0px rgba(0, 0, 0, 0.15)"
                            },
                            children: [
                                react.Children.toArray((_games_pages_flat = games === null || games === void 0 ? void 0 : (_games_pages = games.pages) === null || _games_pages === void 0 ? void 0 : _games_pages.flat()) === null || _games_pages_flat === void 0 ? void 0 : _games_pages_flat.map((game)=>{
                                    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "w-full rounded-xl py-[6px] px-3 flex gap-4 items-center cursor-pointer bg-white dark:bg-transparent hover:bg-bg-disable dark:hover:bg-white/10",
                                        onClick: ()=>handleSelectGame(game),
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                                src: game === null || game === void 0 ? void 0 : game.icon,
                                                alt: "game",
                                                width: 40,
                                                height: 40,
                                                className: "rounded-xl w-[40px] h-[40px] object-contain"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: "flex flex-col group",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                        className: "text-sm Nunito-700 text-bg-01 dark:text-white group-hover:text-main-01 group-focus:text-main-01 dark:group-hover:text-main-white dark:group-focus:text-main-white",
                                                        children: game.game_name
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                        className: "flex items-center",
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                className: "w-[12px] h-[12px]",
                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
                                                                    width: "10",
                                                                    height: "10",
                                                                    viewBox: "0 0 12 12",
                                                                    fill: "none",
                                                                    xmlns: "http://www.w3.org/2000/svg",
                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                                        d: "M5.01641 1.63571C5.41875 0.788099 6.58125 0.788097 6.98359 1.6357L7.67895 3.10059C7.83872 3.43717 8.14755 3.67047 8.50481 3.72444L10.0597 3.95935C10.9593 4.09527 11.3186 5.24477 10.6676 5.90454L9.54246 7.0448C9.28394 7.30679 9.16598 7.68427 9.22701 8.05421L9.49261 9.66427C9.64629 10.5959 8.70581 11.3063 7.90112 10.8665L6.51041 10.1063C6.19087 9.93164 5.80913 9.93164 5.48959 10.1063L4.09888 10.8665C3.2942 11.3063 2.35371 10.5959 2.50739 9.66428L2.77299 8.05421C2.83402 7.68427 2.71606 7.30679 2.45754 7.0448L1.33244 5.90454C0.681433 5.24477 1.04066 4.09527 1.94033 3.95935L3.49519 3.72444C3.85244 3.67047 4.16128 3.43717 4.32105 3.10059L5.01641 1.63571Z",
                                                                        fill: "#7673E6"
                                                                    })
                                                                })
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                className: "text-neutral text-[10px] Nunito-400 dark:text-white",
                                                                children: game.rating.stars
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                className: "w-1 h-1 rounded-full bg-neutral mx-[6px]"
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                className: "text-neutral dark:text-neutral-08 text-[10px] Nunito-400",
                                                                children: game.developer
                                                            })
                                                        ]
                                                    })
                                                ]
                                            })
                                        ]
                                    });
                                })),
                                Number((_games_pages_at = games === null || games === void 0 ? void 0 : (_games_pages1 = games.pages) === null || _games_pages1 === void 0 ? void 0 : _games_pages1.at(-1)) === null || _games_pages_at === void 0 ? void 0 : _games_pages_at.length) >= LIMIT_GAME && /*#__PURE__*/ (0,jsx_runtime.jsx)(ui_button/* Button */.z, {
                                    variant: "none",
                                    className: "px-[24px] text-[16px] rounded-[8px] Nunito-500 my-auto text-main-01 h-[30px]",
                                    onClick: ()=>fetchNextPage(),
                                    children: t("common.view_more")
                                })
                            ]
                        })
                    ]
                })
            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "grid grid-cols-1 mt-3 ",
                children: react.Children.toArray(Array.from(new Set(selectedGames)).map((game)=>{
                    /*#__PURE__*/ return (0,jsx_runtime.jsxs)("div", {
                        className: "max-w-full w-fit border-[1px] border-main-01 px-2 py-[6px] flex justify-between rounded-lg items-center gap-2",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "flex items-center gap-2",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                        src: game === null || game === void 0 ? void 0 : game.icon,
                                        alt: "game",
                                        width: 40,
                                        height: 40,
                                        className: "rounded-xl w-[40px] h-[40px] object-contain"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        className: "text-sm Nunito-700 text-main-01 line-clamp-1",
                                        children: game.game_name
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                onClick: ()=>{
                                    return onRemoveSelectedMentionGame(game === null || game === void 0 ? void 0 : game.id);
                                },
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
                                    width: "24",
                                    height: "24",
                                    viewBox: "0 0 24 24",
                                    fill: "none",
                                    xmlns: "http://www.w3.org/2000/svg",
                                    className: "cursor-pointer",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                        d: "M16.2431 7.75786L7.75781 16.2431M16.2431 16.2431L7.75781 7.75781",
                                        stroke: "#7673E6",
                                        strokeWidth: "1.5",
                                        strokeLinecap: "round",
                                        strokeLinejoin: "round"
                                    })
                                })
                            })
                        ]
                    });
                }))
            })
        ]
    });
};

;// CONCATENATED MODULE: ./node_modules/react-select/node_modules/@babel/runtime/helpers/esm/extends.js
function extends_extends() {
  extends_extends = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return extends_extends.apply(this, arguments);
}
;// CONCATENATED MODULE: ./node_modules/react-select/node_modules/@babel/runtime/helpers/esm/defineProperty.js
function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
;// CONCATENATED MODULE: ./node_modules/react-select/node_modules/@babel/runtime/helpers/esm/objectSpread2.js

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }
  return keys;
}
function objectSpread2_objectSpread2(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      _defineProperty(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }
  return target;
}
;// CONCATENATED MODULE: ./node_modules/react-select/node_modules/@babel/runtime/helpers/esm/classCallCheck.js
function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
;// CONCATENATED MODULE: ./node_modules/react-select/node_modules/@babel/runtime/helpers/esm/createClass.js
function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}
function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  Object.defineProperty(Constructor, "prototype", {
    writable: false
  });
  return Constructor;
}
;// CONCATENATED MODULE: ./node_modules/react-select/node_modules/@babel/runtime/helpers/esm/setPrototypeOf.js
function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };
  return _setPrototypeOf(o, p);
}
;// CONCATENATED MODULE: ./node_modules/react-select/node_modules/@babel/runtime/helpers/esm/inherits.js

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }
  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  Object.defineProperty(subClass, "prototype", {
    writable: false
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}
;// CONCATENATED MODULE: ./node_modules/react-select/node_modules/@babel/runtime/helpers/esm/getPrototypeOf.js
function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}
;// CONCATENATED MODULE: ./node_modules/react-select/node_modules/@babel/runtime/helpers/esm/isNativeReflectConstruct.js
function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;
  try {
    Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}
;// CONCATENATED MODULE: ./node_modules/react-select/node_modules/@babel/runtime/helpers/esm/typeof.js
function _typeof(obj) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) {
    return typeof obj;
  } : function (obj) {
    return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
  }, _typeof(obj);
}
;// CONCATENATED MODULE: ./node_modules/react-select/node_modules/@babel/runtime/helpers/esm/assertThisInitialized.js
function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return self;
}
;// CONCATENATED MODULE: ./node_modules/react-select/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn.js


function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  } else if (call !== void 0) {
    throw new TypeError("Derived constructors may only return object or undefined");
  }
  return _assertThisInitialized(self);
}
;// CONCATENATED MODULE: ./node_modules/react-select/node_modules/@babel/runtime/helpers/esm/createSuper.js



function _createSuper(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct();
  return function _createSuperInternal() {
    var Super = _getPrototypeOf(Derived),
      result;
    if (hasNativeReflectConstruct) {
      var NewTarget = _getPrototypeOf(this).constructor;
      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }
    return _possibleConstructorReturn(this, result);
  };
}
;// CONCATENATED MODULE: ./node_modules/react-select/node_modules/@babel/runtime/helpers/esm/arrayLikeToArray.js
function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;
  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }
  return arr2;
}
;// CONCATENATED MODULE: ./node_modules/react-select/node_modules/@babel/runtime/helpers/esm/arrayWithoutHoles.js

function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}
;// CONCATENATED MODULE: ./node_modules/react-select/node_modules/@babel/runtime/helpers/esm/iterableToArray.js
function _iterableToArray(iter) {
  if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
;// CONCATENATED MODULE: ./node_modules/react-select/node_modules/@babel/runtime/helpers/esm/unsupportedIterableToArray.js

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
;// CONCATENATED MODULE: ./node_modules/react-select/node_modules/@babel/runtime/helpers/esm/nonIterableSpread.js
function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
;// CONCATENATED MODULE: ./node_modules/react-select/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js




function _toConsumableArray(arr) {
  return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}
;// CONCATENATED MODULE: ./node_modules/@emotion/sheet/dist/emotion-sheet.browser.esm.js
/*

Based off glamor's StyleSheet, thanks Sunil ❤️

high performance StyleSheet for css-in-js systems

- uses multiple style tags behind the scenes for millions of rules
- uses `insertRule` for appending in production for *much* faster performance

// usage

import { StyleSheet } from '@emotion/sheet'

let styleSheet = new StyleSheet({ key: '', container: document.head })

styleSheet.insert('#box { border: 1px solid red; }')
- appends a css rule into the stylesheet

styleSheet.flush()
- empties the stylesheet of all its contents

*/
// $FlowFixMe
function sheetForTag(tag) {
  if (tag.sheet) {
    // $FlowFixMe
    return tag.sheet;
  } // this weirdness brought to you by firefox

  /* istanbul ignore next */


  for (var i = 0; i < document.styleSheets.length; i++) {
    if (document.styleSheets[i].ownerNode === tag) {
      // $FlowFixMe
      return document.styleSheets[i];
    }
  }
}

function createStyleElement(options) {
  var tag = document.createElement('style');
  tag.setAttribute('data-emotion', options.key);

  if (options.nonce !== undefined) {
    tag.setAttribute('nonce', options.nonce);
  }

  tag.appendChild(document.createTextNode(''));
  tag.setAttribute('data-s', '');
  return tag;
}

var StyleSheet = /*#__PURE__*/function () {
  // Using Node instead of HTMLElement since container may be a ShadowRoot
  function StyleSheet(options) {
    var _this = this;

    this._insertTag = function (tag) {
      var before;

      if (_this.tags.length === 0) {
        if (_this.insertionPoint) {
          before = _this.insertionPoint.nextSibling;
        } else if (_this.prepend) {
          before = _this.container.firstChild;
        } else {
          before = _this.before;
        }
      } else {
        before = _this.tags[_this.tags.length - 1].nextSibling;
      }

      _this.container.insertBefore(tag, before);

      _this.tags.push(tag);
    };

    this.isSpeedy = options.speedy === undefined ? "production" === 'production' : options.speedy;
    this.tags = [];
    this.ctr = 0;
    this.nonce = options.nonce; // key is the value of the data-emotion attribute, it's used to identify different sheets

    this.key = options.key;
    this.container = options.container;
    this.prepend = options.prepend;
    this.insertionPoint = options.insertionPoint;
    this.before = null;
  }

  var _proto = StyleSheet.prototype;

  _proto.hydrate = function hydrate(nodes) {
    nodes.forEach(this._insertTag);
  };

  _proto.insert = function insert(rule) {
    // the max length is how many rules we have per style tag, it's 65000 in speedy mode
    // it's 1 in dev because we insert source maps that map a single rule to a location
    // and you can only have one source map per style tag
    if (this.ctr % (this.isSpeedy ? 65000 : 1) === 0) {
      this._insertTag(createStyleElement(this));
    }

    var tag = this.tags[this.tags.length - 1];

    if (false) { var isImportRule; }

    if (this.isSpeedy) {
      var sheet = sheetForTag(tag);

      try {
        // this is the ultrafast version, works across browsers
        // the big drawback is that the css won't be editable in devtools
        sheet.insertRule(rule, sheet.cssRules.length);
      } catch (e) {
        if (false) {}
      }
    } else {
      tag.appendChild(document.createTextNode(rule));
    }

    this.ctr++;
  };

  _proto.flush = function flush() {
    // $FlowFixMe
    this.tags.forEach(function (tag) {
      return tag.parentNode && tag.parentNode.removeChild(tag);
    });
    this.tags = [];
    this.ctr = 0;

    if (false) {}
  };

  return StyleSheet;
}();



;// CONCATENATED MODULE: ./node_modules/stylis/src/Utility.js
/**
 * @param {number}
 * @return {number}
 */
var abs = Math.abs

/**
 * @param {number}
 * @return {string}
 */
var Utility_from = String.fromCharCode

/**
 * @param {object}
 * @return {object}
 */
var Utility_assign = Object.assign

/**
 * @param {string} value
 * @param {number} length
 * @return {number}
 */
function hash (value, length) {
	return Utility_charat(value, 0) ^ 45 ? (((((((length << 2) ^ Utility_charat(value, 0)) << 2) ^ Utility_charat(value, 1)) << 2) ^ Utility_charat(value, 2)) << 2) ^ Utility_charat(value, 3) : 0
}

/**
 * @param {string} value
 * @return {string}
 */
function trim (value) {
	return value.trim()
}

/**
 * @param {string} value
 * @param {RegExp} pattern
 * @return {string?}
 */
function Utility_match (value, pattern) {
	return (value = pattern.exec(value)) ? value[0] : value
}

/**
 * @param {string} value
 * @param {(string|RegExp)} pattern
 * @param {string} replacement
 * @return {string}
 */
function Utility_replace (value, pattern, replacement) {
	return value.replace(pattern, replacement)
}

/**
 * @param {string} value
 * @param {string} search
 * @return {number}
 */
function indexof (value, search) {
	return value.indexOf(search)
}

/**
 * @param {string} value
 * @param {number} index
 * @return {number}
 */
function Utility_charat (value, index) {
	return value.charCodeAt(index) | 0
}

/**
 * @param {string} value
 * @param {number} begin
 * @param {number} end
 * @return {string}
 */
function Utility_substr (value, begin, end) {
	return value.slice(begin, end)
}

/**
 * @param {string} value
 * @return {number}
 */
function Utility_strlen (value) {
	return value.length
}

/**
 * @param {any[]} value
 * @return {number}
 */
function Utility_sizeof (value) {
	return value.length
}

/**
 * @param {any} value
 * @param {any[]} array
 * @return {any}
 */
function Utility_append (value, array) {
	return array.push(value), value
}

/**
 * @param {string[]} array
 * @param {function} callback
 * @return {string}
 */
function Utility_combine (array, callback) {
	return array.map(callback).join('')
}

;// CONCATENATED MODULE: ./node_modules/stylis/src/Tokenizer.js


var line = 1
var column = 1
var Tokenizer_length = 0
var position = 0
var character = 0
var characters = ''

/**
 * @param {string} value
 * @param {object | null} root
 * @param {object | null} parent
 * @param {string} type
 * @param {string[] | string} props
 * @param {object[] | string} children
 * @param {number} length
 */
function node (value, root, parent, type, props, children, length) {
	return {value: value, root: root, parent: parent, type: type, props: props, children: children, line: line, column: column, length: length, return: ''}
}

/**
 * @param {object} root
 * @param {object} props
 * @return {object}
 */
function Tokenizer_copy (root, props) {
	return Utility_assign(node('', null, null, '', null, null, 0), root, {length: -root.length}, props)
}

/**
 * @return {number}
 */
function Tokenizer_char () {
	return character
}

/**
 * @return {number}
 */
function prev () {
	character = position > 0 ? Utility_charat(characters, --position) : 0

	if (column--, character === 10)
		column = 1, line--

	return character
}

/**
 * @return {number}
 */
function next () {
	character = position < Tokenizer_length ? Utility_charat(characters, position++) : 0

	if (column++, character === 10)
		column = 1, line++

	return character
}

/**
 * @return {number}
 */
function peek () {
	return Utility_charat(characters, position)
}

/**
 * @return {number}
 */
function caret () {
	return position
}

/**
 * @param {number} begin
 * @param {number} end
 * @return {string}
 */
function slice (begin, end) {
	return Utility_substr(characters, begin, end)
}

/**
 * @param {number} type
 * @return {number}
 */
function token (type) {
	switch (type) {
		// \0 \t \n \r \s whitespace token
		case 0: case 9: case 10: case 13: case 32:
			return 5
		// ! + , / > @ ~ isolate token
		case 33: case 43: case 44: case 47: case 62: case 64: case 126:
		// ; { } breakpoint token
		case 59: case 123: case 125:
			return 4
		// : accompanied token
		case 58:
			return 3
		// " ' ( [ opening delimit token
		case 34: case 39: case 40: case 91:
			return 2
		// ) ] closing delimit token
		case 41: case 93:
			return 1
	}

	return 0
}

/**
 * @param {string} value
 * @return {any[]}
 */
function alloc (value) {
	return line = column = 1, Tokenizer_length = Utility_strlen(characters = value), position = 0, []
}

/**
 * @param {any} value
 * @return {any}
 */
function dealloc (value) {
	return characters = '', value
}

/**
 * @param {number} type
 * @return {string}
 */
function delimit (type) {
	return trim(slice(position - 1, delimiter(type === 91 ? type + 2 : type === 40 ? type + 1 : type)))
}

/**
 * @param {string} value
 * @return {string[]}
 */
function Tokenizer_tokenize (value) {
	return dealloc(tokenizer(alloc(value)))
}

/**
 * @param {number} type
 * @return {string}
 */
function whitespace (type) {
	while (character = peek())
		if (character < 33)
			next()
		else
			break

	return token(type) > 2 || token(character) > 3 ? '' : ' '
}

/**
 * @param {string[]} children
 * @return {string[]}
 */
function tokenizer (children) {
	while (next())
		switch (token(character)) {
			case 0: append(identifier(position - 1), children)
				break
			case 2: append(delimit(character), children)
				break
			default: append(from(character), children)
		}

	return children
}

/**
 * @param {number} index
 * @param {number} count
 * @return {string}
 */
function escaping (index, count) {
	while (--count && next())
		// not 0-9 A-F a-f
		if (character < 48 || character > 102 || (character > 57 && character < 65) || (character > 70 && character < 97))
			break

	return slice(index, caret() + (count < 6 && peek() == 32 && next() == 32))
}

/**
 * @param {number} type
 * @return {number}
 */
function delimiter (type) {
	while (next())
		switch (character) {
			// ] ) " '
			case type:
				return position
			// " '
			case 34: case 39:
				if (type !== 34 && type !== 39)
					delimiter(character)
				break
			// (
			case 40:
				if (type === 41)
					delimiter(type)
				break
			// \
			case 92:
				next()
				break
		}

	return position
}

/**
 * @param {number} type
 * @param {number} index
 * @return {number}
 */
function commenter (type, index) {
	while (next())
		// //
		if (type + character === 47 + 10)
			break
		// /*
		else if (type + character === 42 + 42 && peek() === 47)
			break

	return '/*' + slice(index, position - 1) + '*' + Utility_from(type === 47 ? type : next())
}

/**
 * @param {number} index
 * @return {string}
 */
function identifier (index) {
	while (!token(peek()))
		next()

	return slice(index, position)
}

;// CONCATENATED MODULE: ./node_modules/stylis/src/Enum.js
var Enum_MS = '-ms-'
var Enum_MOZ = '-moz-'
var Enum_WEBKIT = '-webkit-'

var COMMENT = 'comm'
var Enum_RULESET = 'rule'
var Enum_DECLARATION = 'decl'

var PAGE = '@page'
var MEDIA = '@media'
var IMPORT = '@import'
var CHARSET = '@charset'
var VIEWPORT = '@viewport'
var SUPPORTS = '@supports'
var DOCUMENT = '@document'
var NAMESPACE = '@namespace'
var Enum_KEYFRAMES = '@keyframes'
var FONT_FACE = '@font-face'
var COUNTER_STYLE = '@counter-style'
var FONT_FEATURE_VALUES = '@font-feature-values'
var LAYER = '@layer'

;// CONCATENATED MODULE: ./node_modules/stylis/src/Serializer.js



/**
 * @param {object[]} children
 * @param {function} callback
 * @return {string}
 */
function Serializer_serialize (children, callback) {
	var output = ''
	var length = Utility_sizeof(children)

	for (var i = 0; i < length; i++)
		output += callback(children[i], i, children, callback) || ''

	return output
}

/**
 * @param {object} element
 * @param {number} index
 * @param {object[]} children
 * @param {function} callback
 * @return {string}
 */
function stringify (element, index, children, callback) {
	switch (element.type) {
		case LAYER: if (element.children.length) break
		case IMPORT: case Enum_DECLARATION: return element.return = element.return || element.value
		case COMMENT: return ''
		case Enum_KEYFRAMES: return element.return = element.value + '{' + Serializer_serialize(element.children, callback) + '}'
		case Enum_RULESET: element.value = element.props.join(',')
	}

	return Utility_strlen(children = Serializer_serialize(element.children, callback)) ? element.return = element.value + '{' + children + '}' : ''
}

;// CONCATENATED MODULE: ./node_modules/stylis/src/Middleware.js






/**
 * @param {function[]} collection
 * @return {function}
 */
function middleware (collection) {
	var length = Utility_sizeof(collection)

	return function (element, index, children, callback) {
		var output = ''

		for (var i = 0; i < length; i++)
			output += collection[i](element, index, children, callback) || ''

		return output
	}
}

/**
 * @param {function} callback
 * @return {function}
 */
function rulesheet (callback) {
	return function (element) {
		if (!element.root)
			if (element = element.return)
				callback(element)
	}
}

/**
 * @param {object} element
 * @param {number} index
 * @param {object[]} children
 * @param {function} callback
 */
function prefixer (element, index, children, callback) {
	if (element.length > -1)
		if (!element.return)
			switch (element.type) {
				case DECLARATION: element.return = prefix(element.value, element.length, children)
					return
				case KEYFRAMES:
					return serialize([copy(element, {value: replace(element.value, '@', '@' + WEBKIT)})], callback)
				case RULESET:
					if (element.length)
						return combine(element.props, function (value) {
							switch (match(value, /(::plac\w+|:read-\w+)/)) {
								// :read-(only|write)
								case ':read-only': case ':read-write':
									return serialize([copy(element, {props: [replace(value, /:(read-\w+)/, ':' + MOZ + '$1')]})], callback)
								// :placeholder
								case '::placeholder':
									return serialize([
										copy(element, {props: [replace(value, /:(plac\w+)/, ':' + WEBKIT + 'input-$1')]}),
										copy(element, {props: [replace(value, /:(plac\w+)/, ':' + MOZ + '$1')]}),
										copy(element, {props: [replace(value, /:(plac\w+)/, MS + 'input-$1')]})
									], callback)
							}

							return ''
						})
			}
}

/**
 * @param {object} element
 * @param {number} index
 * @param {object[]} children
 */
function namespace (element) {
	switch (element.type) {
		case RULESET:
			element.props = element.props.map(function (value) {
				return combine(tokenize(value), function (value, index, children) {
					switch (charat(value, 0)) {
						// \f
						case 12:
							return substr(value, 1, strlen(value))
						// \0 ( + > ~
						case 0: case 40: case 43: case 62: case 126:
							return value
						// :
						case 58:
							if (children[++index] === 'global')
								children[index] = '', children[++index] = '\f' + substr(children[index], index = 1, -1)
						// \s
						case 32:
							return index === 1 ? '' : value
						default:
							switch (index) {
								case 0: element = value
									return sizeof(children) > 1 ? '' : value
								case index = sizeof(children) - 1: case 2:
									return index === 2 ? value + element + element : value + element
								default:
									return value
							}
					}
				})
			})
	}
}

;// CONCATENATED MODULE: ./node_modules/stylis/src/Parser.js




/**
 * @param {string} value
 * @return {object[]}
 */
function compile (value) {
	return dealloc(parse('', null, null, null, [''], value = alloc(value), 0, [0], value))
}

/**
 * @param {string} value
 * @param {object} root
 * @param {object?} parent
 * @param {string[]} rule
 * @param {string[]} rules
 * @param {string[]} rulesets
 * @param {number[]} pseudo
 * @param {number[]} points
 * @param {string[]} declarations
 * @return {object}
 */
function parse (value, root, parent, rule, rules, rulesets, pseudo, points, declarations) {
	var index = 0
	var offset = 0
	var length = pseudo
	var atrule = 0
	var property = 0
	var previous = 0
	var variable = 1
	var scanning = 1
	var ampersand = 1
	var character = 0
	var type = ''
	var props = rules
	var children = rulesets
	var reference = rule
	var characters = type

	while (scanning)
		switch (previous = character, character = next()) {
			// (
			case 40:
				if (previous != 108 && Utility_charat(characters, length - 1) == 58) {
					if (indexof(characters += Utility_replace(delimit(character), '&', '&\f'), '&\f') != -1)
						ampersand = -1
					break
				}
			// " ' [
			case 34: case 39: case 91:
				characters += delimit(character)
				break
			// \t \n \r \s
			case 9: case 10: case 13: case 32:
				characters += whitespace(previous)
				break
			// \
			case 92:
				characters += escaping(caret() - 1, 7)
				continue
			// /
			case 47:
				switch (peek()) {
					case 42: case 47:
						Utility_append(comment(commenter(next(), caret()), root, parent), declarations)
						break
					default:
						characters += '/'
				}
				break
			// {
			case 123 * variable:
				points[index++] = Utility_strlen(characters) * ampersand
			// } ; \0
			case 125 * variable: case 59: case 0:
				switch (character) {
					// \0 }
					case 0: case 125: scanning = 0
					// ;
					case 59 + offset: if (ampersand == -1) characters = Utility_replace(characters, /\f/g, '')
						if (property > 0 && (Utility_strlen(characters) - length))
							Utility_append(property > 32 ? declaration(characters + ';', rule, parent, length - 1) : declaration(Utility_replace(characters, ' ', '') + ';', rule, parent, length - 2), declarations)
						break
					// @ ;
					case 59: characters += ';'
					// { rule/at-rule
					default:
						Utility_append(reference = ruleset(characters, root, parent, index, offset, rules, points, type, props = [], children = [], length), rulesets)

						if (character === 123)
							if (offset === 0)
								parse(characters, root, reference, reference, props, rulesets, length, points, children)
							else
								switch (atrule === 99 && Utility_charat(characters, 3) === 110 ? 100 : atrule) {
									// d l m s
									case 100: case 108: case 109: case 115:
										parse(value, reference, reference, rule && Utility_append(ruleset(value, reference, reference, 0, 0, rules, points, type, rules, props = [], length), children), rules, children, length, points, rule ? props : children)
										break
									default:
										parse(characters, reference, reference, reference, [''], children, 0, points, children)
								}
				}

				index = offset = property = 0, variable = ampersand = 1, type = characters = '', length = pseudo
				break
			// :
			case 58:
				length = 1 + Utility_strlen(characters), property = previous
			default:
				if (variable < 1)
					if (character == 123)
						--variable
					else if (character == 125 && variable++ == 0 && prev() == 125)
						continue

				switch (characters += Utility_from(character), character * variable) {
					// &
					case 38:
						ampersand = offset > 0 ? 1 : (characters += '\f', -1)
						break
					// ,
					case 44:
						points[index++] = (Utility_strlen(characters) - 1) * ampersand, ampersand = 1
						break
					// @
					case 64:
						// -
						if (peek() === 45)
							characters += delimit(next())

						atrule = peek(), offset = length = Utility_strlen(type = characters += identifier(caret())), character++
						break
					// -
					case 45:
						if (previous === 45 && Utility_strlen(characters) == 2)
							variable = 0
				}
		}

	return rulesets
}

/**
 * @param {string} value
 * @param {object} root
 * @param {object?} parent
 * @param {number} index
 * @param {number} offset
 * @param {string[]} rules
 * @param {number[]} points
 * @param {string} type
 * @param {string[]} props
 * @param {string[]} children
 * @param {number} length
 * @return {object}
 */
function ruleset (value, root, parent, index, offset, rules, points, type, props, children, length) {
	var post = offset - 1
	var rule = offset === 0 ? rules : ['']
	var size = Utility_sizeof(rule)

	for (var i = 0, j = 0, k = 0; i < index; ++i)
		for (var x = 0, y = Utility_substr(value, post + 1, post = abs(j = points[i])), z = value; x < size; ++x)
			if (z = trim(j > 0 ? rule[x] + ' ' + y : Utility_replace(y, /&\f/g, rule[x])))
				props[k++] = z

	return node(value, root, parent, offset === 0 ? Enum_RULESET : type, props, children, length)
}

/**
 * @param {number} value
 * @param {object} root
 * @param {object?} parent
 * @return {object}
 */
function comment (value, root, parent) {
	return node(value, root, parent, COMMENT, Utility_from(Tokenizer_char()), Utility_substr(value, 2, -2), 0)
}

/**
 * @param {string} value
 * @param {object} root
 * @param {object?} parent
 * @param {number} length
 * @return {object}
 */
function declaration (value, root, parent, length) {
	return node(value, root, parent, Enum_DECLARATION, Utility_substr(value, 0, length), Utility_substr(value, length + 1, -1), length)
}

;// CONCATENATED MODULE: ./node_modules/@emotion/cache/dist/emotion-cache.browser.esm.js





var identifierWithPointTracking = function identifierWithPointTracking(begin, points, index) {
  var previous = 0;
  var character = 0;

  while (true) {
    previous = character;
    character = peek(); // &\f

    if (previous === 38 && character === 12) {
      points[index] = 1;
    }

    if (token(character)) {
      break;
    }

    next();
  }

  return slice(begin, position);
};

var toRules = function toRules(parsed, points) {
  // pretend we've started with a comma
  var index = -1;
  var character = 44;

  do {
    switch (token(character)) {
      case 0:
        // &\f
        if (character === 38 && peek() === 12) {
          // this is not 100% correct, we don't account for literal sequences here - like for example quoted strings
          // stylis inserts \f after & to know when & where it should replace this sequence with the context selector
          // and when it should just concatenate the outer and inner selectors
          // it's very unlikely for this sequence to actually appear in a different context, so we just leverage this fact here
          points[index] = 1;
        }

        parsed[index] += identifierWithPointTracking(position - 1, points, index);
        break;

      case 2:
        parsed[index] += delimit(character);
        break;

      case 4:
        // comma
        if (character === 44) {
          // colon
          parsed[++index] = peek() === 58 ? '&\f' : '';
          points[index] = parsed[index].length;
          break;
        }

      // fallthrough

      default:
        parsed[index] += Utility_from(character);
    }
  } while (character = next());

  return parsed;
};

var getRules = function getRules(value, points) {
  return dealloc(toRules(alloc(value), points));
}; // WeakSet would be more appropriate, but only WeakMap is supported in IE11


var fixedElements = /* #__PURE__ */new WeakMap();
var compat = function compat(element) {
  if (element.type !== 'rule' || !element.parent || // positive .length indicates that this rule contains pseudo
  // negative .length indicates that this rule has been already prefixed
  element.length < 1) {
    return;
  }

  var value = element.value,
      parent = element.parent;
  var isImplicitRule = element.column === parent.column && element.line === parent.line;

  while (parent.type !== 'rule') {
    parent = parent.parent;
    if (!parent) return;
  } // short-circuit for the simplest case


  if (element.props.length === 1 && value.charCodeAt(0) !== 58
  /* colon */
  && !fixedElements.get(parent)) {
    return;
  } // if this is an implicitly inserted rule (the one eagerly inserted at the each new nested level)
  // then the props has already been manipulated beforehand as they that array is shared between it and its "rule parent"


  if (isImplicitRule) {
    return;
  }

  fixedElements.set(element, true);
  var points = [];
  var rules = getRules(value, points);
  var parentRules = parent.props;

  for (var i = 0, k = 0; i < rules.length; i++) {
    for (var j = 0; j < parentRules.length; j++, k++) {
      element.props[k] = points[i] ? rules[i].replace(/&\f/g, parentRules[j]) : parentRules[j] + " " + rules[i];
    }
  }
};
var removeLabel = function removeLabel(element) {
  if (element.type === 'decl') {
    var value = element.value;

    if ( // charcode for l
    value.charCodeAt(0) === 108 && // charcode for b
    value.charCodeAt(2) === 98) {
      // this ignores label
      element["return"] = '';
      element.value = '';
    }
  }
};
var ignoreFlag = 'emotion-disable-server-rendering-unsafe-selector-warning-please-do-not-use-this-the-warning-exists-for-a-reason';

var isIgnoringComment = function isIgnoringComment(element) {
  return element.type === 'comm' && element.children.indexOf(ignoreFlag) > -1;
};

var createUnsafeSelectorsAlarm = function createUnsafeSelectorsAlarm(cache) {
  return function (element, index, children) {
    if (element.type !== 'rule' || cache.compat) return;
    var unsafePseudoClasses = element.value.match(/(:first|:nth|:nth-last)-child/g);

    if (unsafePseudoClasses) {
      var isNested = !!element.parent; // in nested rules comments become children of the "auto-inserted" rule and that's always the `element.parent`
      //
      // considering this input:
      // .a {
      //   .b /* comm */ {}
      //   color: hotpink;
      // }
      // we get output corresponding to this:
      // .a {
      //   & {
      //     /* comm */
      //     color: hotpink;
      //   }
      //   .b {}
      // }

      var commentContainer = isNested ? element.parent.children : // global rule at the root level
      children;

      for (var i = commentContainer.length - 1; i >= 0; i--) {
        var node = commentContainer[i];

        if (node.line < element.line) {
          break;
        } // it is quite weird but comments are *usually* put at `column: element.column - 1`
        // so we seek *from the end* for the node that is earlier than the rule's `element` and check that
        // this will also match inputs like this:
        // .a {
        //   /* comm */
        //   .b {}
        // }
        //
        // but that is fine
        //
        // it would be the easiest to change the placement of the comment to be the first child of the rule:
        // .a {
        //   .b { /* comm */ }
        // }
        // with such inputs we wouldn't have to search for the comment at all
        // TODO: consider changing this comment placement in the next major version


        if (node.column < element.column) {
          if (isIgnoringComment(node)) {
            return;
          }

          break;
        }
      }

      unsafePseudoClasses.forEach(function (unsafePseudoClass) {
        console.error("The pseudo class \"" + unsafePseudoClass + "\" is potentially unsafe when doing server-side rendering. Try changing it to \"" + unsafePseudoClass.split('-child')[0] + "-of-type\".");
      });
    }
  };
};

var isImportRule = function isImportRule(element) {
  return element.type.charCodeAt(1) === 105 && element.type.charCodeAt(0) === 64;
};

var isPrependedWithRegularRules = function isPrependedWithRegularRules(index, children) {
  for (var i = index - 1; i >= 0; i--) {
    if (!isImportRule(children[i])) {
      return true;
    }
  }

  return false;
}; // use this to remove incorrect elements from further processing
// so they don't get handed to the `sheet` (or anything else)
// as that could potentially lead to additional logs which in turn could be overhelming to the user


var nullifyElement = function nullifyElement(element) {
  element.type = '';
  element.value = '';
  element["return"] = '';
  element.children = '';
  element.props = '';
};

var incorrectImportAlarm = function incorrectImportAlarm(element, index, children) {
  if (!isImportRule(element)) {
    return;
  }

  if (element.parent) {
    console.error("`@import` rules can't be nested inside other rules. Please move it to the top level and put it before regular rules. Keep in mind that they can only be used within global styles.");
    nullifyElement(element);
  } else if (isPrependedWithRegularRules(index, children)) {
    console.error("`@import` rules can't be after other rules. Please put your `@import` rules before your other rules.");
    nullifyElement(element);
  }
};

/* eslint-disable no-fallthrough */

function emotion_cache_browser_esm_prefix(value, length) {
  switch (hash(value, length)) {
    // color-adjust
    case 5103:
      return Enum_WEBKIT + 'print-' + value + value;
    // animation, animation-(delay|direction|duration|fill-mode|iteration-count|name|play-state|timing-function)

    case 5737:
    case 4201:
    case 3177:
    case 3433:
    case 1641:
    case 4457:
    case 2921: // text-decoration, filter, clip-path, backface-visibility, column, box-decoration-break

    case 5572:
    case 6356:
    case 5844:
    case 3191:
    case 6645:
    case 3005: // mask, mask-image, mask-(mode|clip|size), mask-(repeat|origin), mask-position, mask-composite,

    case 6391:
    case 5879:
    case 5623:
    case 6135:
    case 4599:
    case 4855: // background-clip, columns, column-(count|fill|gap|rule|rule-color|rule-style|rule-width|span|width)

    case 4215:
    case 6389:
    case 5109:
    case 5365:
    case 5621:
    case 3829:
      return Enum_WEBKIT + value + value;
    // appearance, user-select, transform, hyphens, text-size-adjust

    case 5349:
    case 4246:
    case 4810:
    case 6968:
    case 2756:
      return Enum_WEBKIT + value + Enum_MOZ + value + Enum_MS + value + value;
    // flex, flex-direction

    case 6828:
    case 4268:
      return Enum_WEBKIT + value + Enum_MS + value + value;
    // order

    case 6165:
      return Enum_WEBKIT + value + Enum_MS + 'flex-' + value + value;
    // align-items

    case 5187:
      return Enum_WEBKIT + value + Utility_replace(value, /(\w+).+(:[^]+)/, Enum_WEBKIT + 'box-$1$2' + Enum_MS + 'flex-$1$2') + value;
    // align-self

    case 5443:
      return Enum_WEBKIT + value + Enum_MS + 'flex-item-' + Utility_replace(value, /flex-|-self/, '') + value;
    // align-content

    case 4675:
      return Enum_WEBKIT + value + Enum_MS + 'flex-line-pack' + Utility_replace(value, /align-content|flex-|-self/, '') + value;
    // flex-shrink

    case 5548:
      return Enum_WEBKIT + value + Enum_MS + Utility_replace(value, 'shrink', 'negative') + value;
    // flex-basis

    case 5292:
      return Enum_WEBKIT + value + Enum_MS + Utility_replace(value, 'basis', 'preferred-size') + value;
    // flex-grow

    case 6060:
      return Enum_WEBKIT + 'box-' + Utility_replace(value, '-grow', '') + Enum_WEBKIT + value + Enum_MS + Utility_replace(value, 'grow', 'positive') + value;
    // transition

    case 4554:
      return Enum_WEBKIT + Utility_replace(value, /([^-])(transform)/g, '$1' + Enum_WEBKIT + '$2') + value;
    // cursor

    case 6187:
      return Utility_replace(Utility_replace(Utility_replace(value, /(zoom-|grab)/, Enum_WEBKIT + '$1'), /(image-set)/, Enum_WEBKIT + '$1'), value, '') + value;
    // background, background-image

    case 5495:
    case 3959:
      return Utility_replace(value, /(image-set\([^]*)/, Enum_WEBKIT + '$1' + '$`$1');
    // justify-content

    case 4968:
      return Utility_replace(Utility_replace(value, /(.+:)(flex-)?(.*)/, Enum_WEBKIT + 'box-pack:$3' + Enum_MS + 'flex-pack:$3'), /s.+-b[^;]+/, 'justify') + Enum_WEBKIT + value + value;
    // (margin|padding)-inline-(start|end)

    case 4095:
    case 3583:
    case 4068:
    case 2532:
      return Utility_replace(value, /(.+)-inline(.+)/, Enum_WEBKIT + '$1$2') + value;
    // (min|max)?(width|height|inline-size|block-size)

    case 8116:
    case 7059:
    case 5753:
    case 5535:
    case 5445:
    case 5701:
    case 4933:
    case 4677:
    case 5533:
    case 5789:
    case 5021:
    case 4765:
      // stretch, max-content, min-content, fill-available
      if (Utility_strlen(value) - 1 - length > 6) switch (Utility_charat(value, length + 1)) {
        // (m)ax-content, (m)in-content
        case 109:
          // -
          if (Utility_charat(value, length + 4) !== 45) break;
        // (f)ill-available, (f)it-content

        case 102:
          return Utility_replace(value, /(.+:)(.+)-([^]+)/, '$1' + Enum_WEBKIT + '$2-$3' + '$1' + Enum_MOZ + (Utility_charat(value, length + 3) == 108 ? '$3' : '$2-$3')) + value;
        // (s)tretch

        case 115:
          return ~indexof(value, 'stretch') ? emotion_cache_browser_esm_prefix(Utility_replace(value, 'stretch', 'fill-available'), length) + value : value;
      }
      break;
    // position: sticky

    case 4949:
      // (s)ticky?
      if (Utility_charat(value, length + 1) !== 115) break;
    // display: (flex|inline-flex)

    case 6444:
      switch (Utility_charat(value, Utility_strlen(value) - 3 - (~indexof(value, '!important') && 10))) {
        // stic(k)y
        case 107:
          return Utility_replace(value, ':', ':' + Enum_WEBKIT) + value;
        // (inline-)?fl(e)x

        case 101:
          return Utility_replace(value, /(.+:)([^;!]+)(;|!.+)?/, '$1' + Enum_WEBKIT + (Utility_charat(value, 14) === 45 ? 'inline-' : '') + 'box$3' + '$1' + Enum_WEBKIT + '$2$3' + '$1' + Enum_MS + '$2box$3') + value;
      }

      break;
    // writing-mode

    case 5936:
      switch (Utility_charat(value, length + 11)) {
        // vertical-l(r)
        case 114:
          return Enum_WEBKIT + value + Enum_MS + Utility_replace(value, /[svh]\w+-[tblr]{2}/, 'tb') + value;
        // vertical-r(l)

        case 108:
          return Enum_WEBKIT + value + Enum_MS + Utility_replace(value, /[svh]\w+-[tblr]{2}/, 'tb-rl') + value;
        // horizontal(-)tb

        case 45:
          return Enum_WEBKIT + value + Enum_MS + Utility_replace(value, /[svh]\w+-[tblr]{2}/, 'lr') + value;
      }

      return Enum_WEBKIT + value + Enum_MS + value + value;
  }

  return value;
}

var emotion_cache_browser_esm_prefixer = function prefixer(element, index, children, callback) {
  if (element.length > -1) if (!element["return"]) switch (element.type) {
    case Enum_DECLARATION:
      element["return"] = emotion_cache_browser_esm_prefix(element.value, element.length);
      break;

    case Enum_KEYFRAMES:
      return Serializer_serialize([Tokenizer_copy(element, {
        value: Utility_replace(element.value, '@', '@' + Enum_WEBKIT)
      })], callback);

    case Enum_RULESET:
      if (element.length) return Utility_combine(element.props, function (value) {
        switch (Utility_match(value, /(::plac\w+|:read-\w+)/)) {
          // :read-(only|write)
          case ':read-only':
          case ':read-write':
            return Serializer_serialize([Tokenizer_copy(element, {
              props: [Utility_replace(value, /:(read-\w+)/, ':' + Enum_MOZ + '$1')]
            })], callback);
          // :placeholder

          case '::placeholder':
            return Serializer_serialize([Tokenizer_copy(element, {
              props: [Utility_replace(value, /:(plac\w+)/, ':' + Enum_WEBKIT + 'input-$1')]
            }), Tokenizer_copy(element, {
              props: [Utility_replace(value, /:(plac\w+)/, ':' + Enum_MOZ + '$1')]
            }), Tokenizer_copy(element, {
              props: [Utility_replace(value, /:(plac\w+)/, Enum_MS + 'input-$1')]
            })], callback);
        }

        return '';
      });
  }
};

var defaultStylisPlugins = [emotion_cache_browser_esm_prefixer];

var createCache = function createCache(options) {
  var key = options.key;

  if (false) {}

  if (key === 'css') {
    var ssrStyles = document.querySelectorAll("style[data-emotion]:not([data-s])"); // get SSRed styles out of the way of React's hydration
    // document.head is a safe place to move them to(though note document.head is not necessarily the last place they will be)
    // note this very very intentionally targets all style elements regardless of the key to ensure
    // that creating a cache works inside of render of a React component

    Array.prototype.forEach.call(ssrStyles, function (node) {
      // we want to only move elements which have a space in the data-emotion attribute value
      // because that indicates that it is an Emotion 11 server-side rendered style elements
      // while we will already ignore Emotion 11 client-side inserted styles because of the :not([data-s]) part in the selector
      // Emotion 10 client-side inserted styles did not have data-s (but importantly did not have a space in their data-emotion attributes)
      // so checking for the space ensures that loading Emotion 11 after Emotion 10 has inserted some styles
      // will not result in the Emotion 10 styles being destroyed
      var dataEmotionAttribute = node.getAttribute('data-emotion');

      if (dataEmotionAttribute.indexOf(' ') === -1) {
        return;
      }
      document.head.appendChild(node);
      node.setAttribute('data-s', '');
    });
  }

  var stylisPlugins = options.stylisPlugins || defaultStylisPlugins;

  if (false) {}

  var inserted = {};
  var container;
  var nodesToHydrate = [];

  {
    container = options.container || document.head;
    Array.prototype.forEach.call( // this means we will ignore elements which don't have a space in them which
    // means that the style elements we're looking at are only Emotion 11 server-rendered style elements
    document.querySelectorAll("style[data-emotion^=\"" + key + " \"]"), function (node) {
      var attrib = node.getAttribute("data-emotion").split(' '); // $FlowFixMe

      for (var i = 1; i < attrib.length; i++) {
        inserted[attrib[i]] = true;
      }

      nodesToHydrate.push(node);
    });
  }

  var _insert;

  var omnipresentPlugins = [compat, removeLabel];

  if (false) {}

  {
    var currentSheet;
    var finalizingPlugins = [stringify,  false ? 0 : rulesheet(function (rule) {
      currentSheet.insert(rule);
    })];
    var serializer = middleware(omnipresentPlugins.concat(stylisPlugins, finalizingPlugins));

    var stylis = function stylis(styles) {
      return Serializer_serialize(compile(styles), serializer);
    };

    _insert = function insert(selector, serialized, sheet, shouldCache) {
      currentSheet = sheet;

      if (false) {}

      stylis(selector ? selector + "{" + serialized.styles + "}" : serialized.styles);

      if (shouldCache) {
        cache.inserted[serialized.name] = true;
      }
    };
  }

  var cache = {
    key: key,
    sheet: new StyleSheet({
      key: key,
      container: container,
      nonce: options.nonce,
      speedy: options.speedy,
      prepend: options.prepend,
      insertionPoint: options.insertionPoint
    }),
    nonce: options.nonce,
    inserted: inserted,
    registered: {},
    insert: _insert
  };
  cache.sheet.hydrate(nodesToHydrate);
  return cache;
};



;// CONCATENATED MODULE: ./node_modules/@emotion/utils/dist/emotion-utils.browser.esm.js
var isBrowser = "object" !== 'undefined';
function emotion_utils_browser_esm_getRegisteredStyles(registered, registeredStyles, classNames) {
  var rawClassName = '';
  classNames.split(' ').forEach(function (className) {
    if (registered[className] !== undefined) {
      registeredStyles.push(registered[className] + ";");
    } else {
      rawClassName += className + " ";
    }
  });
  return rawClassName;
}
var emotion_utils_browser_esm_registerStyles = function registerStyles(cache, serialized, isStringTag) {
  var className = cache.key + "-" + serialized.name;

  if ( // we only need to add the styles to the registered cache if the
  // class name could be used further down
  // the tree but if it's a string tag, we know it won't
  // so we don't have to add it to registered cache.
  // this improves memory usage since we can avoid storing the whole style string
  (isStringTag === false || // we need to always store it if we're in compat mode and
  // in node since emotion-server relies on whether a style is in
  // the registered cache to know whether a style is global or not
  // also, note that this check will be dead code eliminated in the browser
  isBrowser === false ) && cache.registered[className] === undefined) {
    cache.registered[className] = serialized.styles;
  }
};
var emotion_utils_browser_esm_insertStyles = function insertStyles(cache, serialized, isStringTag) {
  emotion_utils_browser_esm_registerStyles(cache, serialized, isStringTag);
  var className = cache.key + "-" + serialized.name;

  if (cache.inserted[serialized.name] === undefined) {
    var current = serialized;

    do {
      cache.insert(serialized === current ? "." + className : '', current, cache.sheet, true);

      current = current.next;
    } while (current !== undefined);
  }
};



;// CONCATENATED MODULE: ./node_modules/@emotion/hash/dist/emotion-hash.esm.js
/* eslint-disable */
// Inspired by https://github.com/garycourt/murmurhash-js
// Ported from https://github.com/aappleby/smhasher/blob/61a0530f28277f2e850bfc39600ce61d02b518de/src/MurmurHash2.cpp#L37-L86
function murmur2(str) {
  // 'm' and 'r' are mixing constants generated offline.
  // They're not really 'magic', they just happen to work well.
  // const m = 0x5bd1e995;
  // const r = 24;
  // Initialize the hash
  var h = 0; // Mix 4 bytes at a time into the hash

  var k,
      i = 0,
      len = str.length;

  for (; len >= 4; ++i, len -= 4) {
    k = str.charCodeAt(i) & 0xff | (str.charCodeAt(++i) & 0xff) << 8 | (str.charCodeAt(++i) & 0xff) << 16 | (str.charCodeAt(++i) & 0xff) << 24;
    k =
    /* Math.imul(k, m): */
    (k & 0xffff) * 0x5bd1e995 + ((k >>> 16) * 0xe995 << 16);
    k ^=
    /* k >>> r: */
    k >>> 24;
    h =
    /* Math.imul(k, m): */
    (k & 0xffff) * 0x5bd1e995 + ((k >>> 16) * 0xe995 << 16) ^
    /* Math.imul(h, m): */
    (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
  } // Handle the last few bytes of the input array


  switch (len) {
    case 3:
      h ^= (str.charCodeAt(i + 2) & 0xff) << 16;

    case 2:
      h ^= (str.charCodeAt(i + 1) & 0xff) << 8;

    case 1:
      h ^= str.charCodeAt(i) & 0xff;
      h =
      /* Math.imul(h, m): */
      (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
  } // Do a few final mixes of the hash to ensure the last few
  // bytes are well-incorporated.


  h ^= h >>> 13;
  h =
  /* Math.imul(h, m): */
  (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
  return ((h ^ h >>> 15) >>> 0).toString(36);
}



;// CONCATENATED MODULE: ./node_modules/@emotion/unitless/dist/emotion-unitless.esm.js
var unitlessKeys = {
  animationIterationCount: 1,
  aspectRatio: 1,
  borderImageOutset: 1,
  borderImageSlice: 1,
  borderImageWidth: 1,
  boxFlex: 1,
  boxFlexGroup: 1,
  boxOrdinalGroup: 1,
  columnCount: 1,
  columns: 1,
  flex: 1,
  flexGrow: 1,
  flexPositive: 1,
  flexShrink: 1,
  flexNegative: 1,
  flexOrder: 1,
  gridRow: 1,
  gridRowEnd: 1,
  gridRowSpan: 1,
  gridRowStart: 1,
  gridColumn: 1,
  gridColumnEnd: 1,
  gridColumnSpan: 1,
  gridColumnStart: 1,
  msGridRow: 1,
  msGridRowSpan: 1,
  msGridColumn: 1,
  msGridColumnSpan: 1,
  fontWeight: 1,
  lineHeight: 1,
  opacity: 1,
  order: 1,
  orphans: 1,
  tabSize: 1,
  widows: 1,
  zIndex: 1,
  zoom: 1,
  WebkitLineClamp: 1,
  // SVG-related properties
  fillOpacity: 1,
  floodOpacity: 1,
  stopOpacity: 1,
  strokeDasharray: 1,
  strokeDashoffset: 1,
  strokeMiterlimit: 1,
  strokeOpacity: 1,
  strokeWidth: 1
};



;// CONCATENATED MODULE: ./node_modules/@emotion/memoize/dist/emotion-memoize.esm.js
function memoize(fn) {
  var cache = Object.create(null);
  return function (arg) {
    if (cache[arg] === undefined) cache[arg] = fn(arg);
    return cache[arg];
  };
}



;// CONCATENATED MODULE: ./node_modules/@emotion/serialize/dist/emotion-serialize.browser.esm.js




var ILLEGAL_ESCAPE_SEQUENCE_ERROR = "You have illegal escape sequence in your template literal, most likely inside content's property value.\nBecause you write your CSS inside a JavaScript string you actually have to do double escaping, so for example \"content: '\\00d7';\" should become \"content: '\\\\00d7';\".\nYou can read more about this here:\nhttps://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Template_literals#ES2018_revision_of_illegal_escape_sequences";
var UNDEFINED_AS_OBJECT_KEY_ERROR = "You have passed in falsy value as style object's key (can happen when in example you pass unexported component as computed key).";
var hyphenateRegex = /[A-Z]|^ms/g;
var animationRegex = /_EMO_([^_]+?)_([^]*?)_EMO_/g;

var isCustomProperty = function isCustomProperty(property) {
  return property.charCodeAt(1) === 45;
};

var isProcessableValue = function isProcessableValue(value) {
  return value != null && typeof value !== 'boolean';
};

var processStyleName = /* #__PURE__ */memoize(function (styleName) {
  return isCustomProperty(styleName) ? styleName : styleName.replace(hyphenateRegex, '-$&').toLowerCase();
});

var processStyleValue = function processStyleValue(key, value) {
  switch (key) {
    case 'animation':
    case 'animationName':
      {
        if (typeof value === 'string') {
          return value.replace(animationRegex, function (match, p1, p2) {
            cursor = {
              name: p1,
              styles: p2,
              next: cursor
            };
            return p1;
          });
        }
      }
  }

  if (unitlessKeys[key] !== 1 && !isCustomProperty(key) && typeof value === 'number' && value !== 0) {
    return value + 'px';
  }

  return value;
};

if (false) { var hyphenatedCache, hyphenPattern, msPattern, oldProcessStyleValue, contentValues, contentValuePattern; }

var noComponentSelectorMessage = (/* unused pure expression or super */ null && ('Component selectors can only be used in conjunction with ' + '@emotion/babel-plugin, the swc Emotion plugin, or another Emotion-aware ' + 'compiler transform.'));

function handleInterpolation(mergedProps, registered, interpolation) {
  if (interpolation == null) {
    return '';
  }

  if (interpolation.__emotion_styles !== undefined) {
    if (false) {}

    return interpolation;
  }

  switch (typeof interpolation) {
    case 'boolean':
      {
        return '';
      }

    case 'object':
      {
        if (interpolation.anim === 1) {
          cursor = {
            name: interpolation.name,
            styles: interpolation.styles,
            next: cursor
          };
          return interpolation.name;
        }

        if (interpolation.styles !== undefined) {
          var next = interpolation.next;

          if (next !== undefined) {
            // not the most efficient thing ever but this is a pretty rare case
            // and there will be very few iterations of this generally
            while (next !== undefined) {
              cursor = {
                name: next.name,
                styles: next.styles,
                next: cursor
              };
              next = next.next;
            }
          }

          var styles = interpolation.styles + ";";

          if (false) {}

          return styles;
        }

        return createStringFromObject(mergedProps, registered, interpolation);
      }

    case 'function':
      {
        if (mergedProps !== undefined) {
          var previousCursor = cursor;
          var result = interpolation(mergedProps);
          cursor = previousCursor;
          return handleInterpolation(mergedProps, registered, result);
        } else if (false) {}

        break;
      }

    case 'string':
      if (false) { var replaced, matched; }

      break;
  } // finalize string values (regular strings and functions interpolated into css calls)


  if (registered == null) {
    return interpolation;
  }

  var cached = registered[interpolation];
  return cached !== undefined ? cached : interpolation;
}

function createStringFromObject(mergedProps, registered, obj) {
  var string = '';

  if (Array.isArray(obj)) {
    for (var i = 0; i < obj.length; i++) {
      string += handleInterpolation(mergedProps, registered, obj[i]) + ";";
    }
  } else {
    for (var _key in obj) {
      var value = obj[_key];

      if (typeof value !== 'object') {
        if (registered != null && registered[value] !== undefined) {
          string += _key + "{" + registered[value] + "}";
        } else if (isProcessableValue(value)) {
          string += processStyleName(_key) + ":" + processStyleValue(_key, value) + ";";
        }
      } else {
        if (_key === 'NO_COMPONENT_SELECTOR' && "production" !== 'production') {}

        if (Array.isArray(value) && typeof value[0] === 'string' && (registered == null || registered[value[0]] === undefined)) {
          for (var _i = 0; _i < value.length; _i++) {
            if (isProcessableValue(value[_i])) {
              string += processStyleName(_key) + ":" + processStyleValue(_key, value[_i]) + ";";
            }
          }
        } else {
          var interpolated = handleInterpolation(mergedProps, registered, value);

          switch (_key) {
            case 'animation':
            case 'animationName':
              {
                string += processStyleName(_key) + ":" + interpolated + ";";
                break;
              }

            default:
              {
                if (false) {}

                string += _key + "{" + interpolated + "}";
              }
          }
        }
      }
    }
  }

  return string;
}

var labelPattern = /label:\s*([^\s;\n{]+)\s*(;|$)/g;
var sourceMapPattern;

if (false) {} // this is the cursor for keyframes
// keyframes are stored on the SerializedStyles object as a linked list


var cursor;
var emotion_serialize_browser_esm_serializeStyles = function serializeStyles(args, registered, mergedProps) {
  if (args.length === 1 && typeof args[0] === 'object' && args[0] !== null && args[0].styles !== undefined) {
    return args[0];
  }

  var stringMode = true;
  var styles = '';
  cursor = undefined;
  var strings = args[0];

  if (strings == null || strings.raw === undefined) {
    stringMode = false;
    styles += handleInterpolation(mergedProps, registered, strings);
  } else {
    if (false) {}

    styles += strings[0];
  } // we start at 1 since we've already handled the first arg


  for (var i = 1; i < args.length; i++) {
    styles += handleInterpolation(mergedProps, registered, args[i]);

    if (stringMode) {
      if (false) {}

      styles += strings[i];
    }
  }

  var sourceMap;

  if (false) {} // using a global regex with .exec is stateful so lastIndex has to be reset each time


  labelPattern.lastIndex = 0;
  var identifierName = '';
  var match; // https://esbench.com/bench/5b809c2cf2949800a0f61fb5

  while ((match = labelPattern.exec(styles)) !== null) {
    identifierName += '-' + // $FlowFixMe we know it's not null
    match[1];
  }

  var name = murmur2(styles) + identifierName;

  if (false) {}

  return {
    name: name,
    styles: styles,
    next: cursor
  };
};



;// CONCATENATED MODULE: ./node_modules/@emotion/use-insertion-effect-with-fallbacks/dist/emotion-use-insertion-effect-with-fallbacks.browser.esm.js


var syncFallback = function syncFallback(create) {
  return create();
};

var useInsertionEffect = react_namespaceObject['useInsertion' + 'Effect'] ? react_namespaceObject['useInsertion' + 'Effect'] : false;
var emotion_use_insertion_effect_with_fallbacks_browser_esm_useInsertionEffectAlwaysWithSyncFallback = useInsertionEffect || syncFallback;
var emotion_use_insertion_effect_with_fallbacks_browser_esm_useInsertionEffectWithLayoutFallback = useInsertionEffect || react.useLayoutEffect;



;// CONCATENATED MODULE: ./node_modules/@emotion/react/dist/emotion-element-43c6fea0.browser.esm.js










var emotion_element_43c6fea0_browser_esm_isBrowser = "object" !== 'undefined';
var hasOwn = {}.hasOwnProperty;

var EmotionCacheContext = /* #__PURE__ */react.createContext( // we're doing this to avoid preconstruct's dead code elimination in this one case
// because this module is primarily intended for the browser and node
// but it's also required in react native and similar environments sometimes
// and we could have a special build just for that
// but this is much easier and the native packages
// might use a different theme context in the future anyway
typeof HTMLElement !== 'undefined' ? /* #__PURE__ */createCache({
  key: 'css'
}) : null);

if (false) {}

var CacheProvider = EmotionCacheContext.Provider;
var __unsafe_useEmotionCache = function useEmotionCache() {
  return useContext(EmotionCacheContext);
};

var emotion_element_43c6fea0_browser_esm_withEmotionCache = function withEmotionCache(func) {
  // $FlowFixMe
  return /*#__PURE__*/(0,react.forwardRef)(function (props, ref) {
    // the cache will never be null in the browser
    var cache = (0,react.useContext)(EmotionCacheContext);
    return func(props, cache, ref);
  });
};

if (!emotion_element_43c6fea0_browser_esm_isBrowser) {
  emotion_element_43c6fea0_browser_esm_withEmotionCache = function withEmotionCache(func) {
    return function (props) {
      var cache = (0,react.useContext)(EmotionCacheContext);

      if (cache === null) {
        // yes, we're potentially creating this on every render
        // it doesn't actually matter though since it's only on the server
        // so there will only every be a single render
        // that could change in the future because of suspense and etc. but for now,
        // this works and i don't want to optimise for a future thing that we aren't sure about
        cache = createCache({
          key: 'css'
        });
        return /*#__PURE__*/react.createElement(EmotionCacheContext.Provider, {
          value: cache
        }, func(props, cache));
      } else {
        return func(props, cache);
      }
    };
  };
}

var emotion_element_43c6fea0_browser_esm_ThemeContext = /* #__PURE__ */react.createContext({});

if (false) {}

var useTheme = function useTheme() {
  return React.useContext(emotion_element_43c6fea0_browser_esm_ThemeContext);
};

var getTheme = function getTheme(outerTheme, theme) {
  if (typeof theme === 'function') {
    var mergedTheme = theme(outerTheme);

    if (false) {}

    return mergedTheme;
  }

  if (false) {}

  return _extends({}, outerTheme, theme);
};

var createCacheWithTheme = /* #__PURE__ */(/* unused pure expression or super */ null && (weakMemoize(function (outerTheme) {
  return weakMemoize(function (theme) {
    return getTheme(outerTheme, theme);
  });
})));
var ThemeProvider = function ThemeProvider(props) {
  var theme = React.useContext(emotion_element_43c6fea0_browser_esm_ThemeContext);

  if (props.theme !== theme) {
    theme = createCacheWithTheme(theme)(props.theme);
  }

  return /*#__PURE__*/React.createElement(emotion_element_43c6fea0_browser_esm_ThemeContext.Provider, {
    value: theme
  }, props.children);
};
function withTheme(Component) {
  var componentName = Component.displayName || Component.name || 'Component';

  var render = function render(props, ref) {
    var theme = React.useContext(emotion_element_43c6fea0_browser_esm_ThemeContext);
    return /*#__PURE__*/React.createElement(Component, _extends({
      theme: theme,
      ref: ref
    }, props));
  }; // $FlowFixMe


  var WithTheme = /*#__PURE__*/React.forwardRef(render);
  WithTheme.displayName = "WithTheme(" + componentName + ")";
  return hoistNonReactStatics(WithTheme, Component);
}

var getLastPart = function getLastPart(functionName) {
  // The match may be something like 'Object.createEmotionProps' or
  // 'Loader.prototype.render'
  var parts = functionName.split('.');
  return parts[parts.length - 1];
};

var getFunctionNameFromStackTraceLine = function getFunctionNameFromStackTraceLine(line) {
  // V8
  var match = /^\s+at\s+([A-Za-z0-9$.]+)\s/.exec(line);
  if (match) return getLastPart(match[1]); // Safari / Firefox

  match = /^([A-Za-z0-9$.]+)@/.exec(line);
  if (match) return getLastPart(match[1]);
  return undefined;
};

var internalReactFunctionNames = /* #__PURE__ */new Set(['renderWithHooks', 'processChild', 'finishClassComponent', 'renderToString']); // These identifiers come from error stacks, so they have to be valid JS
// identifiers, thus we only need to replace what is a valid character for JS,
// but not for CSS.

var sanitizeIdentifier = function sanitizeIdentifier(identifier) {
  return identifier.replace(/\$/g, '-');
};

var getLabelFromStackTrace = function getLabelFromStackTrace(stackTrace) {
  if (!stackTrace) return undefined;
  var lines = stackTrace.split('\n');

  for (var i = 0; i < lines.length; i++) {
    var functionName = getFunctionNameFromStackTraceLine(lines[i]); // The first line of V8 stack traces is just "Error"

    if (!functionName) continue; // If we reach one of these, we have gone too far and should quit

    if (internalReactFunctionNames.has(functionName)) break; // The component name is the first function in the stack that starts with an
    // uppercase letter

    if (/^[A-Z]/.test(functionName)) return sanitizeIdentifier(functionName);
  }

  return undefined;
};

var typePropName = '__EMOTION_TYPE_PLEASE_DO_NOT_USE__';
var labelPropName = '__EMOTION_LABEL_PLEASE_DO_NOT_USE__';
var createEmotionProps = function createEmotionProps(type, props) {
  if (false) {}

  var newProps = {};

  for (var key in props) {
    if (hasOwn.call(props, key)) {
      newProps[key] = props[key];
    }
  }

  newProps[typePropName] = type; // For performance, only call getLabelFromStackTrace in development and when
  // the label hasn't already been computed

  if (false) { var label; }

  return newProps;
};

var Insertion = function Insertion(_ref) {
  var cache = _ref.cache,
      serialized = _ref.serialized,
      isStringTag = _ref.isStringTag;
  emotion_utils_browser_esm_registerStyles(cache, serialized, isStringTag);
  emotion_use_insertion_effect_with_fallbacks_browser_esm_useInsertionEffectAlwaysWithSyncFallback(function () {
    return emotion_utils_browser_esm_insertStyles(cache, serialized, isStringTag);
  });

  return null;
};

var Emotion = /* #__PURE__ */emotion_element_43c6fea0_browser_esm_withEmotionCache(function (props, cache, ref) {
  var cssProp = props.css; // so that using `css` from `emotion` and passing the result to the css prop works
  // not passing the registered cache to serializeStyles because it would
  // make certain babel optimisations not possible

  if (typeof cssProp === 'string' && cache.registered[cssProp] !== undefined) {
    cssProp = cache.registered[cssProp];
  }

  var WrappedComponent = props[typePropName];
  var registeredStyles = [cssProp];
  var className = '';

  if (typeof props.className === 'string') {
    className = emotion_utils_browser_esm_getRegisteredStyles(cache.registered, registeredStyles, props.className);
  } else if (props.className != null) {
    className = props.className + " ";
  }

  var serialized = emotion_serialize_browser_esm_serializeStyles(registeredStyles, undefined, react.useContext(emotion_element_43c6fea0_browser_esm_ThemeContext));

  if (false) { var labelFromStack; }

  className += cache.key + "-" + serialized.name;
  var newProps = {};

  for (var key in props) {
    if (hasOwn.call(props, key) && key !== 'css' && key !== typePropName && ( true || 0)) {
      newProps[key] = props[key];
    }
  }

  newProps.ref = ref;
  newProps.className = className;
  return /*#__PURE__*/react.createElement(react.Fragment, null, /*#__PURE__*/react.createElement(Insertion, {
    cache: cache,
    serialized: serialized,
    isStringTag: typeof WrappedComponent === 'string'
  }), /*#__PURE__*/react.createElement(WrappedComponent, newProps));
});

if (false) {}

var Emotion$1 = Emotion;



// EXTERNAL MODULE: ./node_modules/hoist-non-react-statics/dist/hoist-non-react-statics.cjs.js
var hoist_non_react_statics_cjs = __webpack_require__(8679);
;// CONCATENATED MODULE: ./node_modules/@emotion/react/dist/emotion-react.browser.esm.js












var pkg = {
	name: "@emotion/react",
	version: "11.11.4",
	main: "dist/emotion-react.cjs.js",
	module: "dist/emotion-react.esm.js",
	browser: {
		"./dist/emotion-react.esm.js": "./dist/emotion-react.browser.esm.js"
	},
	exports: {
		".": {
			module: {
				worker: "./dist/emotion-react.worker.esm.js",
				browser: "./dist/emotion-react.browser.esm.js",
				"default": "./dist/emotion-react.esm.js"
			},
			"import": "./dist/emotion-react.cjs.mjs",
			"default": "./dist/emotion-react.cjs.js"
		},
		"./jsx-runtime": {
			module: {
				worker: "./jsx-runtime/dist/emotion-react-jsx-runtime.worker.esm.js",
				browser: "./jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js",
				"default": "./jsx-runtime/dist/emotion-react-jsx-runtime.esm.js"
			},
			"import": "./jsx-runtime/dist/emotion-react-jsx-runtime.cjs.mjs",
			"default": "./jsx-runtime/dist/emotion-react-jsx-runtime.cjs.js"
		},
		"./_isolated-hnrs": {
			module: {
				worker: "./_isolated-hnrs/dist/emotion-react-_isolated-hnrs.worker.esm.js",
				browser: "./_isolated-hnrs/dist/emotion-react-_isolated-hnrs.browser.esm.js",
				"default": "./_isolated-hnrs/dist/emotion-react-_isolated-hnrs.esm.js"
			},
			"import": "./_isolated-hnrs/dist/emotion-react-_isolated-hnrs.cjs.mjs",
			"default": "./_isolated-hnrs/dist/emotion-react-_isolated-hnrs.cjs.js"
		},
		"./jsx-dev-runtime": {
			module: {
				worker: "./jsx-dev-runtime/dist/emotion-react-jsx-dev-runtime.worker.esm.js",
				browser: "./jsx-dev-runtime/dist/emotion-react-jsx-dev-runtime.browser.esm.js",
				"default": "./jsx-dev-runtime/dist/emotion-react-jsx-dev-runtime.esm.js"
			},
			"import": "./jsx-dev-runtime/dist/emotion-react-jsx-dev-runtime.cjs.mjs",
			"default": "./jsx-dev-runtime/dist/emotion-react-jsx-dev-runtime.cjs.js"
		},
		"./package.json": "./package.json",
		"./types/css-prop": "./types/css-prop.d.ts",
		"./macro": {
			types: {
				"import": "./macro.d.mts",
				"default": "./macro.d.ts"
			},
			"default": "./macro.js"
		}
	},
	types: "types/index.d.ts",
	files: [
		"src",
		"dist",
		"jsx-runtime",
		"jsx-dev-runtime",
		"_isolated-hnrs",
		"types/*.d.ts",
		"macro.*"
	],
	sideEffects: false,
	author: "Emotion Contributors",
	license: "MIT",
	scripts: {
		"test:typescript": "dtslint types"
	},
	dependencies: {
		"@babel/runtime": "^7.18.3",
		"@emotion/babel-plugin": "^11.11.0",
		"@emotion/cache": "^11.11.0",
		"@emotion/serialize": "^1.1.3",
		"@emotion/use-insertion-effect-with-fallbacks": "^1.0.1",
		"@emotion/utils": "^1.2.1",
		"@emotion/weak-memoize": "^0.3.1",
		"hoist-non-react-statics": "^3.3.1"
	},
	peerDependencies: {
		react: ">=16.8.0"
	},
	peerDependenciesMeta: {
		"@types/react": {
			optional: true
		}
	},
	devDependencies: {
		"@definitelytyped/dtslint": "0.0.112",
		"@emotion/css": "11.11.2",
		"@emotion/css-prettifier": "1.1.3",
		"@emotion/server": "11.11.0",
		"@emotion/styled": "11.11.0",
		"html-tag-names": "^1.1.2",
		react: "16.14.0",
		"svg-tag-names": "^1.1.1",
		typescript: "^4.5.5"
	},
	repository: "https://github.com/emotion-js/emotion/tree/main/packages/react",
	publishConfig: {
		access: "public"
	},
	"umd:main": "dist/emotion-react.umd.min.js",
	preconstruct: {
		entrypoints: [
			"./index.js",
			"./jsx-runtime.js",
			"./jsx-dev-runtime.js",
			"./_isolated-hnrs.js"
		],
		umdName: "emotionReact",
		exports: {
			envConditions: [
				"browser",
				"worker"
			],
			extra: {
				"./types/css-prop": "./types/css-prop.d.ts",
				"./macro": {
					types: {
						"import": "./macro.d.mts",
						"default": "./macro.d.ts"
					},
					"default": "./macro.js"
				}
			}
		}
	}
};

var jsx = function jsx(type, props) {
  var args = arguments;

  if (props == null || !hasOwn.call(props, 'css')) {
    // $FlowFixMe
    return react.createElement.apply(undefined, args);
  }

  var argsLength = args.length;
  var createElementArgArray = new Array(argsLength);
  createElementArgArray[0] = Emotion$1;
  createElementArgArray[1] = createEmotionProps(type, props);

  for (var i = 2; i < argsLength; i++) {
    createElementArgArray[i] = args[i];
  } // $FlowFixMe


  return react.createElement.apply(null, createElementArgArray);
};

var warnedAboutCssPropForGlobal = false; // maintain place over rerenders.
// initial render from browser, insertBefore context.sheet.tags[0] or if a style hasn't been inserted there yet, appendChild
// initial client-side render from SSR, use place of hydrating tag

var Global = /* #__PURE__ */(/* unused pure expression or super */ null && (withEmotionCache(function (props, cache) {
  if (false) {}

  var styles = props.styles;
  var serialized = serializeStyles([styles], undefined, React.useContext(ThemeContext));

  if (!isBrowser$1) {
    var _ref;

    var serializedNames = serialized.name;
    var serializedStyles = serialized.styles;
    var next = serialized.next;

    while (next !== undefined) {
      serializedNames += ' ' + next.name;
      serializedStyles += next.styles;
      next = next.next;
    }

    var shouldCache = cache.compat === true;
    var rules = cache.insert("", {
      name: serializedNames,
      styles: serializedStyles
    }, cache.sheet, shouldCache);

    if (shouldCache) {
      return null;
    }

    return /*#__PURE__*/React.createElement("style", (_ref = {}, _ref["data-emotion"] = cache.key + "-global " + serializedNames, _ref.dangerouslySetInnerHTML = {
      __html: rules
    }, _ref.nonce = cache.sheet.nonce, _ref));
  } // yes, i know these hooks are used conditionally
  // but it is based on a constant that will never change at runtime
  // it's effectively like having two implementations and switching them out
  // so it's not actually breaking anything


  var sheetRef = React.useRef();
  useInsertionEffectWithLayoutFallback(function () {
    var key = cache.key + "-global"; // use case of https://github.com/emotion-js/emotion/issues/2675

    var sheet = new cache.sheet.constructor({
      key: key,
      nonce: cache.sheet.nonce,
      container: cache.sheet.container,
      speedy: cache.sheet.isSpeedy
    });
    var rehydrating = false; // $FlowFixMe

    var node = document.querySelector("style[data-emotion=\"" + key + " " + serialized.name + "\"]");

    if (cache.sheet.tags.length) {
      sheet.before = cache.sheet.tags[0];
    }

    if (node !== null) {
      rehydrating = true; // clear the hash so this node won't be recognizable as rehydratable by other <Global/>s

      node.setAttribute('data-emotion', key);
      sheet.hydrate([node]);
    }

    sheetRef.current = [sheet, rehydrating];
    return function () {
      sheet.flush();
    };
  }, [cache]);
  useInsertionEffectWithLayoutFallback(function () {
    var sheetRefCurrent = sheetRef.current;
    var sheet = sheetRefCurrent[0],
        rehydrating = sheetRefCurrent[1];

    if (rehydrating) {
      sheetRefCurrent[1] = false;
      return;
    }

    if (serialized.next !== undefined) {
      // insert keyframes
      insertStyles(cache, serialized.next, true);
    }

    if (sheet.tags.length) {
      // if this doesn't exist then it will be null so the style element will be appended
      var element = sheet.tags[sheet.tags.length - 1].nextElementSibling;
      sheet.before = element;
      sheet.flush();
    }

    cache.insert("", serialized, sheet, false);
  }, [cache, serialized.name]);
  return null;
})));

if (false) {}

function css() {
  for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
    args[_key] = arguments[_key];
  }

  return emotion_serialize_browser_esm_serializeStyles(args);
}

var keyframes = function keyframes() {
  var insertable = css.apply(void 0, arguments);
  var name = "animation-" + insertable.name; // $FlowFixMe

  return {
    name: name,
    styles: "@keyframes " + name + "{" + insertable.styles + "}",
    anim: 1,
    toString: function toString() {
      return "_EMO_" + this.name + "_" + this.styles + "_EMO_";
    }
  };
};

var classnames = function classnames(args) {
  var len = args.length;
  var i = 0;
  var cls = '';

  for (; i < len; i++) {
    var arg = args[i];
    if (arg == null) continue;
    var toAdd = void 0;

    switch (typeof arg) {
      case 'boolean':
        break;

      case 'object':
        {
          if (Array.isArray(arg)) {
            toAdd = classnames(arg);
          } else {
            if (false) {}

            toAdd = '';

            for (var k in arg) {
              if (arg[k] && k) {
                toAdd && (toAdd += ' ');
                toAdd += k;
              }
            }
          }

          break;
        }

      default:
        {
          toAdd = arg;
        }
    }

    if (toAdd) {
      cls && (cls += ' ');
      cls += toAdd;
    }
  }

  return cls;
};

function merge(registered, css, className) {
  var registeredStyles = [];
  var rawClassName = getRegisteredStyles(registered, registeredStyles, className);

  if (registeredStyles.length < 2) {
    return className;
  }

  return rawClassName + css(registeredStyles);
}

var emotion_react_browser_esm_Insertion = function Insertion(_ref) {
  var cache = _ref.cache,
      serializedArr = _ref.serializedArr;
  useInsertionEffectAlwaysWithSyncFallback(function () {

    for (var i = 0; i < serializedArr.length; i++) {
      insertStyles(cache, serializedArr[i], false);
    }
  });

  return null;
};

var ClassNames = /* #__PURE__ */(/* unused pure expression or super */ null && (withEmotionCache(function (props, cache) {
  var hasRendered = false;
  var serializedArr = [];

  var css = function css() {
    if (hasRendered && "production" !== 'production') {}

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    var serialized = serializeStyles(args, cache.registered);
    serializedArr.push(serialized); // registration has to happen here as the result of this might get consumed by `cx`

    registerStyles(cache, serialized, false);
    return cache.key + "-" + serialized.name;
  };

  var cx = function cx() {
    if (hasRendered && "production" !== 'production') {}

    for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      args[_key2] = arguments[_key2];
    }

    return merge(cache.registered, css, classnames(args));
  };

  var content = {
    css: css,
    cx: cx,
    theme: React.useContext(ThemeContext)
  };
  var ele = props.children(content);
  hasRendered = true;
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(emotion_react_browser_esm_Insertion, {
    cache: cache,
    serializedArr: serializedArr
  }), ele);
})));

if (false) {}

if (false) { var globalKey, globalContext, isTestEnv, emotion_react_browser_esm_isBrowser; }



;// CONCATENATED MODULE: ./node_modules/react-select/node_modules/@babel/runtime/helpers/esm/arrayWithHoles.js
function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}
;// CONCATENATED MODULE: ./node_modules/react-select/node_modules/@babel/runtime/helpers/esm/iterableToArrayLimit.js
function _iterableToArrayLimit(arr, i) {
  var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
  if (_i == null) return;
  var _arr = [];
  var _n = true;
  var _d = false;
  var _s, _e;
  try {
    for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);
      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }
  return _arr;
}
;// CONCATENATED MODULE: ./node_modules/react-select/node_modules/@babel/runtime/helpers/esm/nonIterableRest.js
function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
;// CONCATENATED MODULE: ./node_modules/react-select/node_modules/@babel/runtime/helpers/esm/slicedToArray.js




function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
;// CONCATENATED MODULE: ./node_modules/react-select/node_modules/@babel/runtime/helpers/esm/objectWithoutPropertiesLoose.js
function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;
  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }
  return target;
}
;// CONCATENATED MODULE: ./node_modules/react-select/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};
  var target = _objectWithoutPropertiesLoose(source, excluded);
  var key, i;
  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }
  return target;
}
;// CONCATENATED MODULE: ./node_modules/react-select/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral.js
function _taggedTemplateLiteral(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }
  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
}
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/react-dom/index.js
var react_dom = __webpack_require__(18369);
;// CONCATENATED MODULE: ./node_modules/@floating-ui/core/node_modules/@floating-ui/utils/dist/floating-ui.utils.mjs
/**
 * Custom positioning reference element.
 * @see https://floating-ui.com/docs/virtual-elements
 */

const sides = (/* unused pure expression or super */ null && (['top', 'right', 'bottom', 'left']));
const alignments = (/* unused pure expression or super */ null && (['start', 'end']));
const placements = /*#__PURE__*/(/* unused pure expression or super */ null && (sides.reduce((acc, side) => acc.concat(side, side + "-" + alignments[0], side + "-" + alignments[1]), [])));
const min = Math.min;
const max = Math.max;
const round = Math.round;
const floor = Math.floor;
const createCoords = v => ({
  x: v,
  y: v
});
const oppositeSideMap = {
  left: 'right',
  right: 'left',
  bottom: 'top',
  top: 'bottom'
};
const oppositeAlignmentMap = {
  start: 'end',
  end: 'start'
};
function clamp(start, value, end) {
  return max(start, min(value, end));
}
function evaluate(value, param) {
  return typeof value === 'function' ? value(param) : value;
}
function getSide(placement) {
  return placement.split('-')[0];
}
function getAlignment(placement) {
  return placement.split('-')[1];
}
function getOppositeAxis(axis) {
  return axis === 'x' ? 'y' : 'x';
}
function getAxisLength(axis) {
  return axis === 'y' ? 'height' : 'width';
}
function getSideAxis(placement) {
  return ['top', 'bottom'].includes(getSide(placement)) ? 'y' : 'x';
}
function getAlignmentAxis(placement) {
  return getOppositeAxis(getSideAxis(placement));
}
function getAlignmentSides(placement, rects, rtl) {
  if (rtl === void 0) {
    rtl = false;
  }
  const alignment = getAlignment(placement);
  const alignmentAxis = getAlignmentAxis(placement);
  const length = getAxisLength(alignmentAxis);
  let mainAlignmentSide = alignmentAxis === 'x' ? alignment === (rtl ? 'end' : 'start') ? 'right' : 'left' : alignment === 'start' ? 'bottom' : 'top';
  if (rects.reference[length] > rects.floating[length]) {
    mainAlignmentSide = getOppositePlacement(mainAlignmentSide);
  }
  return [mainAlignmentSide, getOppositePlacement(mainAlignmentSide)];
}
function getExpandedPlacements(placement) {
  const oppositePlacement = getOppositePlacement(placement);
  return [getOppositeAlignmentPlacement(placement), oppositePlacement, getOppositeAlignmentPlacement(oppositePlacement)];
}
function getOppositeAlignmentPlacement(placement) {
  return placement.replace(/start|end/g, alignment => oppositeAlignmentMap[alignment]);
}
function getSideList(side, isStart, rtl) {
  const lr = ['left', 'right'];
  const rl = ['right', 'left'];
  const tb = ['top', 'bottom'];
  const bt = ['bottom', 'top'];
  switch (side) {
    case 'top':
    case 'bottom':
      if (rtl) return isStart ? rl : lr;
      return isStart ? lr : rl;
    case 'left':
    case 'right':
      return isStart ? tb : bt;
    default:
      return [];
  }
}
function getOppositeAxisPlacements(placement, flipAlignment, direction, rtl) {
  const alignment = getAlignment(placement);
  let list = getSideList(getSide(placement), direction === 'start', rtl);
  if (alignment) {
    list = list.map(side => side + "-" + alignment);
    if (flipAlignment) {
      list = list.concat(list.map(getOppositeAlignmentPlacement));
    }
  }
  return list;
}
function getOppositePlacement(placement) {
  return placement.replace(/left|right|bottom|top/g, side => oppositeSideMap[side]);
}
function expandPaddingObject(padding) {
  return {
    top: 0,
    right: 0,
    bottom: 0,
    left: 0,
    ...padding
  };
}
function getPaddingObject(padding) {
  return typeof padding !== 'number' ? expandPaddingObject(padding) : {
    top: padding,
    right: padding,
    bottom: padding,
    left: padding
  };
}
function rectToClientRect(rect) {
  const {
    x,
    y,
    width,
    height
  } = rect;
  return {
    width,
    height,
    top: y,
    left: x,
    right: x + width,
    bottom: y + height,
    x,
    y
  };
}



;// CONCATENATED MODULE: ./node_modules/@floating-ui/dom/node_modules/@floating-ui/utils/dist/floating-ui.utils.mjs
/**
 * Custom positioning reference element.
 * @see https://floating-ui.com/docs/virtual-elements
 */

const floating_ui_utils_sides = (/* unused pure expression or super */ null && (['top', 'right', 'bottom', 'left']));
const floating_ui_utils_alignments = (/* unused pure expression or super */ null && (['start', 'end']));
const floating_ui_utils_placements = /*#__PURE__*/(/* unused pure expression or super */ null && (floating_ui_utils_sides.reduce((acc, side) => acc.concat(side, side + "-" + floating_ui_utils_alignments[0], side + "-" + floating_ui_utils_alignments[1]), [])));
const floating_ui_utils_min = Math.min;
const floating_ui_utils_max = Math.max;
const floating_ui_utils_round = Math.round;
const floating_ui_utils_floor = Math.floor;
const floating_ui_utils_createCoords = v => ({
  x: v,
  y: v
});
const floating_ui_utils_oppositeSideMap = {
  left: 'right',
  right: 'left',
  bottom: 'top',
  top: 'bottom'
};
const floating_ui_utils_oppositeAlignmentMap = {
  start: 'end',
  end: 'start'
};
function floating_ui_utils_clamp(start, value, end) {
  return floating_ui_utils_max(start, floating_ui_utils_min(value, end));
}
function floating_ui_utils_evaluate(value, param) {
  return typeof value === 'function' ? value(param) : value;
}
function floating_ui_utils_getSide(placement) {
  return placement.split('-')[0];
}
function floating_ui_utils_getAlignment(placement) {
  return placement.split('-')[1];
}
function floating_ui_utils_getOppositeAxis(axis) {
  return axis === 'x' ? 'y' : 'x';
}
function floating_ui_utils_getAxisLength(axis) {
  return axis === 'y' ? 'height' : 'width';
}
function floating_ui_utils_getSideAxis(placement) {
  return ['top', 'bottom'].includes(floating_ui_utils_getSide(placement)) ? 'y' : 'x';
}
function floating_ui_utils_getAlignmentAxis(placement) {
  return floating_ui_utils_getOppositeAxis(floating_ui_utils_getSideAxis(placement));
}
function floating_ui_utils_getAlignmentSides(placement, rects, rtl) {
  if (rtl === void 0) {
    rtl = false;
  }
  const alignment = floating_ui_utils_getAlignment(placement);
  const alignmentAxis = floating_ui_utils_getAlignmentAxis(placement);
  const length = floating_ui_utils_getAxisLength(alignmentAxis);
  let mainAlignmentSide = alignmentAxis === 'x' ? alignment === (rtl ? 'end' : 'start') ? 'right' : 'left' : alignment === 'start' ? 'bottom' : 'top';
  if (rects.reference[length] > rects.floating[length]) {
    mainAlignmentSide = floating_ui_utils_getOppositePlacement(mainAlignmentSide);
  }
  return [mainAlignmentSide, floating_ui_utils_getOppositePlacement(mainAlignmentSide)];
}
function floating_ui_utils_getExpandedPlacements(placement) {
  const oppositePlacement = floating_ui_utils_getOppositePlacement(placement);
  return [floating_ui_utils_getOppositeAlignmentPlacement(placement), oppositePlacement, floating_ui_utils_getOppositeAlignmentPlacement(oppositePlacement)];
}
function floating_ui_utils_getOppositeAlignmentPlacement(placement) {
  return placement.replace(/start|end/g, alignment => floating_ui_utils_oppositeAlignmentMap[alignment]);
}
function floating_ui_utils_getSideList(side, isStart, rtl) {
  const lr = ['left', 'right'];
  const rl = ['right', 'left'];
  const tb = ['top', 'bottom'];
  const bt = ['bottom', 'top'];
  switch (side) {
    case 'top':
    case 'bottom':
      if (rtl) return isStart ? rl : lr;
      return isStart ? lr : rl;
    case 'left':
    case 'right':
      return isStart ? tb : bt;
    default:
      return [];
  }
}
function floating_ui_utils_getOppositeAxisPlacements(placement, flipAlignment, direction, rtl) {
  const alignment = floating_ui_utils_getAlignment(placement);
  let list = floating_ui_utils_getSideList(floating_ui_utils_getSide(placement), direction === 'start', rtl);
  if (alignment) {
    list = list.map(side => side + "-" + alignment);
    if (flipAlignment) {
      list = list.concat(list.map(floating_ui_utils_getOppositeAlignmentPlacement));
    }
  }
  return list;
}
function floating_ui_utils_getOppositePlacement(placement) {
  return placement.replace(/left|right|bottom|top/g, side => floating_ui_utils_oppositeSideMap[side]);
}
function floating_ui_utils_expandPaddingObject(padding) {
  return {
    top: 0,
    right: 0,
    bottom: 0,
    left: 0,
    ...padding
  };
}
function floating_ui_utils_getPaddingObject(padding) {
  return typeof padding !== 'number' ? floating_ui_utils_expandPaddingObject(padding) : {
    top: padding,
    right: padding,
    bottom: padding,
    left: padding
  };
}
function floating_ui_utils_rectToClientRect(rect) {
  const {
    x,
    y,
    width,
    height
  } = rect;
  return {
    width,
    height,
    top: y,
    left: x,
    right: x + width,
    bottom: y + height,
    x,
    y
  };
}



;// CONCATENATED MODULE: ./node_modules/@floating-ui/dom/node_modules/@floating-ui/utils/dist/floating-ui.utils.dom.mjs
function getNodeName(node) {
  if (isNode(node)) {
    return (node.nodeName || '').toLowerCase();
  }
  // Mocked nodes in testing environments may not be instances of Node. By
  // returning `#document` an infinite loop won't occur.
  // https://github.com/floating-ui/floating-ui/issues/2317
  return '#document';
}
function getWindow(node) {
  var _node$ownerDocument;
  return (node == null || (_node$ownerDocument = node.ownerDocument) == null ? void 0 : _node$ownerDocument.defaultView) || window;
}
function getDocumentElement(node) {
  var _ref;
  return (_ref = (isNode(node) ? node.ownerDocument : node.document) || window.document) == null ? void 0 : _ref.documentElement;
}
function isNode(value) {
  return value instanceof Node || value instanceof getWindow(value).Node;
}
function isElement(value) {
  return value instanceof Element || value instanceof getWindow(value).Element;
}
function isHTMLElement(value) {
  return value instanceof HTMLElement || value instanceof getWindow(value).HTMLElement;
}
function isShadowRoot(value) {
  // Browsers without `ShadowRoot` support.
  if (typeof ShadowRoot === 'undefined') {
    return false;
  }
  return value instanceof ShadowRoot || value instanceof getWindow(value).ShadowRoot;
}
function isOverflowElement(element) {
  const {
    overflow,
    overflowX,
    overflowY,
    display
  } = floating_ui_utils_dom_getComputedStyle(element);
  return /auto|scroll|overlay|hidden|clip/.test(overflow + overflowY + overflowX) && !['inline', 'contents'].includes(display);
}
function isTableElement(element) {
  return ['table', 'td', 'th'].includes(getNodeName(element));
}
function isContainingBlock(element) {
  const webkit = isWebKit();
  const css = floating_ui_utils_dom_getComputedStyle(element);

  // https://developer.mozilla.org/en-US/docs/Web/CSS/Containing_block#identifying_the_containing_block
  return css.transform !== 'none' || css.perspective !== 'none' || (css.containerType ? css.containerType !== 'normal' : false) || !webkit && (css.backdropFilter ? css.backdropFilter !== 'none' : false) || !webkit && (css.filter ? css.filter !== 'none' : false) || ['transform', 'perspective', 'filter'].some(value => (css.willChange || '').includes(value)) || ['paint', 'layout', 'strict', 'content'].some(value => (css.contain || '').includes(value));
}
function getContainingBlock(element) {
  let currentNode = getParentNode(element);
  while (isHTMLElement(currentNode) && !isLastTraversableNode(currentNode)) {
    if (isContainingBlock(currentNode)) {
      return currentNode;
    }
    currentNode = getParentNode(currentNode);
  }
  return null;
}
function isWebKit() {
  if (typeof CSS === 'undefined' || !CSS.supports) return false;
  return CSS.supports('-webkit-backdrop-filter', 'none');
}
function isLastTraversableNode(node) {
  return ['html', 'body', '#document'].includes(getNodeName(node));
}
function floating_ui_utils_dom_getComputedStyle(element) {
  return getWindow(element).getComputedStyle(element);
}
function getNodeScroll(element) {
  if (isElement(element)) {
    return {
      scrollLeft: element.scrollLeft,
      scrollTop: element.scrollTop
    };
  }
  return {
    scrollLeft: element.pageXOffset,
    scrollTop: element.pageYOffset
  };
}
function getParentNode(node) {
  if (getNodeName(node) === 'html') {
    return node;
  }
  const result =
  // Step into the shadow DOM of the parent of a slotted node.
  node.assignedSlot ||
  // DOM Element detected.
  node.parentNode ||
  // ShadowRoot detected.
  isShadowRoot(node) && node.host ||
  // Fallback.
  getDocumentElement(node);
  return isShadowRoot(result) ? result.host : result;
}
function getNearestOverflowAncestor(node) {
  const parentNode = getParentNode(node);
  if (isLastTraversableNode(parentNode)) {
    return node.ownerDocument ? node.ownerDocument.body : node.body;
  }
  if (isHTMLElement(parentNode) && isOverflowElement(parentNode)) {
    return parentNode;
  }
  return getNearestOverflowAncestor(parentNode);
}
function getOverflowAncestors(node, list, traverseIframes) {
  var _node$ownerDocument2;
  if (list === void 0) {
    list = [];
  }
  if (traverseIframes === void 0) {
    traverseIframes = true;
  }
  const scrollableAncestor = getNearestOverflowAncestor(node);
  const isBody = scrollableAncestor === ((_node$ownerDocument2 = node.ownerDocument) == null ? void 0 : _node$ownerDocument2.body);
  const win = getWindow(scrollableAncestor);
  if (isBody) {
    return list.concat(win, win.visualViewport || [], isOverflowElement(scrollableAncestor) ? scrollableAncestor : [], win.frameElement && traverseIframes ? getOverflowAncestors(win.frameElement) : []);
  }
  return list.concat(scrollableAncestor, getOverflowAncestors(scrollableAncestor, [], traverseIframes));
}



;// CONCATENATED MODULE: ./node_modules/@floating-ui/dom/dist/floating-ui.dom.mjs





function getCssDimensions(element) {
  const css = floating_ui_utils_dom_getComputedStyle(element);
  // In testing environments, the `width` and `height` properties are empty
  // strings for SVG elements, returning NaN. Fallback to `0` in this case.
  let width = parseFloat(css.width) || 0;
  let height = parseFloat(css.height) || 0;
  const hasOffset = isHTMLElement(element);
  const offsetWidth = hasOffset ? element.offsetWidth : width;
  const offsetHeight = hasOffset ? element.offsetHeight : height;
  const shouldFallback = floating_ui_utils_round(width) !== offsetWidth || floating_ui_utils_round(height) !== offsetHeight;
  if (shouldFallback) {
    width = offsetWidth;
    height = offsetHeight;
  }
  return {
    width,
    height,
    $: shouldFallback
  };
}

function unwrapElement(element) {
  return !isElement(element) ? element.contextElement : element;
}

function getScale(element) {
  const domElement = unwrapElement(element);
  if (!isHTMLElement(domElement)) {
    return floating_ui_utils_createCoords(1);
  }
  const rect = domElement.getBoundingClientRect();
  const {
    width,
    height,
    $
  } = getCssDimensions(domElement);
  let x = ($ ? floating_ui_utils_round(rect.width) : rect.width) / width;
  let y = ($ ? floating_ui_utils_round(rect.height) : rect.height) / height;

  // 0, NaN, or Infinity should always fallback to 1.

  if (!x || !Number.isFinite(x)) {
    x = 1;
  }
  if (!y || !Number.isFinite(y)) {
    y = 1;
  }
  return {
    x,
    y
  };
}

const noOffsets = /*#__PURE__*/floating_ui_utils_createCoords(0);
function getVisualOffsets(element) {
  const win = getWindow(element);
  if (!isWebKit() || !win.visualViewport) {
    return noOffsets;
  }
  return {
    x: win.visualViewport.offsetLeft,
    y: win.visualViewport.offsetTop
  };
}
function shouldAddVisualOffsets(element, isFixed, floatingOffsetParent) {
  if (isFixed === void 0) {
    isFixed = false;
  }
  if (!floatingOffsetParent || isFixed && floatingOffsetParent !== getWindow(element)) {
    return false;
  }
  return isFixed;
}

function getBoundingClientRect(element, includeScale, isFixedStrategy, offsetParent) {
  if (includeScale === void 0) {
    includeScale = false;
  }
  if (isFixedStrategy === void 0) {
    isFixedStrategy = false;
  }
  const clientRect = element.getBoundingClientRect();
  const domElement = unwrapElement(element);
  let scale = floating_ui_utils_createCoords(1);
  if (includeScale) {
    if (offsetParent) {
      if (isElement(offsetParent)) {
        scale = getScale(offsetParent);
      }
    } else {
      scale = getScale(element);
    }
  }
  const visualOffsets = shouldAddVisualOffsets(domElement, isFixedStrategy, offsetParent) ? getVisualOffsets(domElement) : floating_ui_utils_createCoords(0);
  let x = (clientRect.left + visualOffsets.x) / scale.x;
  let y = (clientRect.top + visualOffsets.y) / scale.y;
  let width = clientRect.width / scale.x;
  let height = clientRect.height / scale.y;
  if (domElement) {
    const win = getWindow(domElement);
    const offsetWin = offsetParent && isElement(offsetParent) ? getWindow(offsetParent) : offsetParent;
    let currentWin = win;
    let currentIFrame = currentWin.frameElement;
    while (currentIFrame && offsetParent && offsetWin !== currentWin) {
      const iframeScale = getScale(currentIFrame);
      const iframeRect = currentIFrame.getBoundingClientRect();
      const css = floating_ui_utils_dom_getComputedStyle(currentIFrame);
      const left = iframeRect.left + (currentIFrame.clientLeft + parseFloat(css.paddingLeft)) * iframeScale.x;
      const top = iframeRect.top + (currentIFrame.clientTop + parseFloat(css.paddingTop)) * iframeScale.y;
      x *= iframeScale.x;
      y *= iframeScale.y;
      width *= iframeScale.x;
      height *= iframeScale.y;
      x += left;
      y += top;
      currentWin = getWindow(currentIFrame);
      currentIFrame = currentWin.frameElement;
    }
  }
  return rectToClientRect({
    width,
    height,
    x,
    y
  });
}

const topLayerSelectors = [':popover-open', ':modal'];
function isTopLayer(element) {
  return topLayerSelectors.some(selector => {
    try {
      return element.matches(selector);
    } catch (e) {
      return false;
    }
  });
}

function convertOffsetParentRelativeRectToViewportRelativeRect(_ref) {
  let {
    elements,
    rect,
    offsetParent,
    strategy
  } = _ref;
  const isFixed = strategy === 'fixed';
  const documentElement = getDocumentElement(offsetParent);
  const topLayer = elements ? isTopLayer(elements.floating) : false;
  if (offsetParent === documentElement || topLayer && isFixed) {
    return rect;
  }
  let scroll = {
    scrollLeft: 0,
    scrollTop: 0
  };
  let scale = floating_ui_utils_createCoords(1);
  const offsets = floating_ui_utils_createCoords(0);
  const isOffsetParentAnElement = isHTMLElement(offsetParent);
  if (isOffsetParentAnElement || !isOffsetParentAnElement && !isFixed) {
    if (getNodeName(offsetParent) !== 'body' || isOverflowElement(documentElement)) {
      scroll = getNodeScroll(offsetParent);
    }
    if (isHTMLElement(offsetParent)) {
      const offsetRect = getBoundingClientRect(offsetParent);
      scale = getScale(offsetParent);
      offsets.x = offsetRect.x + offsetParent.clientLeft;
      offsets.y = offsetRect.y + offsetParent.clientTop;
    }
  }
  return {
    width: rect.width * scale.x,
    height: rect.height * scale.y,
    x: rect.x * scale.x - scroll.scrollLeft * scale.x + offsets.x,
    y: rect.y * scale.y - scroll.scrollTop * scale.y + offsets.y
  };
}

function getClientRects(element) {
  return Array.from(element.getClientRects());
}

function getWindowScrollBarX(element) {
  // If <html> has a CSS width greater than the viewport, then this will be
  // incorrect for RTL.
  return getBoundingClientRect(getDocumentElement(element)).left + getNodeScroll(element).scrollLeft;
}

// Gets the entire size of the scrollable document area, even extending outside
// of the `<html>` and `<body>` rect bounds if horizontally scrollable.
function getDocumentRect(element) {
  const html = getDocumentElement(element);
  const scroll = getNodeScroll(element);
  const body = element.ownerDocument.body;
  const width = floating_ui_utils_max(html.scrollWidth, html.clientWidth, body.scrollWidth, body.clientWidth);
  const height = floating_ui_utils_max(html.scrollHeight, html.clientHeight, body.scrollHeight, body.clientHeight);
  let x = -scroll.scrollLeft + getWindowScrollBarX(element);
  const y = -scroll.scrollTop;
  if (floating_ui_utils_dom_getComputedStyle(body).direction === 'rtl') {
    x += floating_ui_utils_max(html.clientWidth, body.clientWidth) - width;
  }
  return {
    width,
    height,
    x,
    y
  };
}

function getViewportRect(element, strategy) {
  const win = getWindow(element);
  const html = getDocumentElement(element);
  const visualViewport = win.visualViewport;
  let width = html.clientWidth;
  let height = html.clientHeight;
  let x = 0;
  let y = 0;
  if (visualViewport) {
    width = visualViewport.width;
    height = visualViewport.height;
    const visualViewportBased = isWebKit();
    if (!visualViewportBased || visualViewportBased && strategy === 'fixed') {
      x = visualViewport.offsetLeft;
      y = visualViewport.offsetTop;
    }
  }
  return {
    width,
    height,
    x,
    y
  };
}

// Returns the inner client rect, subtracting scrollbars if present.
function getInnerBoundingClientRect(element, strategy) {
  const clientRect = getBoundingClientRect(element, true, strategy === 'fixed');
  const top = clientRect.top + element.clientTop;
  const left = clientRect.left + element.clientLeft;
  const scale = isHTMLElement(element) ? getScale(element) : floating_ui_utils_createCoords(1);
  const width = element.clientWidth * scale.x;
  const height = element.clientHeight * scale.y;
  const x = left * scale.x;
  const y = top * scale.y;
  return {
    width,
    height,
    x,
    y
  };
}
function getClientRectFromClippingAncestor(element, clippingAncestor, strategy) {
  let rect;
  if (clippingAncestor === 'viewport') {
    rect = getViewportRect(element, strategy);
  } else if (clippingAncestor === 'document') {
    rect = getDocumentRect(getDocumentElement(element));
  } else if (isElement(clippingAncestor)) {
    rect = getInnerBoundingClientRect(clippingAncestor, strategy);
  } else {
    const visualOffsets = getVisualOffsets(element);
    rect = {
      ...clippingAncestor,
      x: clippingAncestor.x - visualOffsets.x,
      y: clippingAncestor.y - visualOffsets.y
    };
  }
  return rectToClientRect(rect);
}
function hasFixedPositionAncestor(element, stopNode) {
  const parentNode = getParentNode(element);
  if (parentNode === stopNode || !isElement(parentNode) || isLastTraversableNode(parentNode)) {
    return false;
  }
  return floating_ui_utils_dom_getComputedStyle(parentNode).position === 'fixed' || hasFixedPositionAncestor(parentNode, stopNode);
}

// A "clipping ancestor" is an `overflow` element with the characteristic of
// clipping (or hiding) child elements. This returns all clipping ancestors
// of the given element up the tree.
function getClippingElementAncestors(element, cache) {
  const cachedResult = cache.get(element);
  if (cachedResult) {
    return cachedResult;
  }
  let result = getOverflowAncestors(element, [], false).filter(el => isElement(el) && getNodeName(el) !== 'body');
  let currentContainingBlockComputedStyle = null;
  const elementIsFixed = floating_ui_utils_dom_getComputedStyle(element).position === 'fixed';
  let currentNode = elementIsFixed ? getParentNode(element) : element;

  // https://developer.mozilla.org/en-US/docs/Web/CSS/Containing_block#identifying_the_containing_block
  while (isElement(currentNode) && !isLastTraversableNode(currentNode)) {
    const computedStyle = floating_ui_utils_dom_getComputedStyle(currentNode);
    const currentNodeIsContaining = isContainingBlock(currentNode);
    if (!currentNodeIsContaining && computedStyle.position === 'fixed') {
      currentContainingBlockComputedStyle = null;
    }
    const shouldDropCurrentNode = elementIsFixed ? !currentNodeIsContaining && !currentContainingBlockComputedStyle : !currentNodeIsContaining && computedStyle.position === 'static' && !!currentContainingBlockComputedStyle && ['absolute', 'fixed'].includes(currentContainingBlockComputedStyle.position) || isOverflowElement(currentNode) && !currentNodeIsContaining && hasFixedPositionAncestor(element, currentNode);
    if (shouldDropCurrentNode) {
      // Drop non-containing blocks.
      result = result.filter(ancestor => ancestor !== currentNode);
    } else {
      // Record last containing block for next iteration.
      currentContainingBlockComputedStyle = computedStyle;
    }
    currentNode = getParentNode(currentNode);
  }
  cache.set(element, result);
  return result;
}

// Gets the maximum area that the element is visible in due to any number of
// clipping ancestors.
function getClippingRect(_ref) {
  let {
    element,
    boundary,
    rootBoundary,
    strategy
  } = _ref;
  const elementClippingAncestors = boundary === 'clippingAncestors' ? isTopLayer(element) ? [] : getClippingElementAncestors(element, this._c) : [].concat(boundary);
  const clippingAncestors = [...elementClippingAncestors, rootBoundary];
  const firstClippingAncestor = clippingAncestors[0];
  const clippingRect = clippingAncestors.reduce((accRect, clippingAncestor) => {
    const rect = getClientRectFromClippingAncestor(element, clippingAncestor, strategy);
    accRect.top = floating_ui_utils_max(rect.top, accRect.top);
    accRect.right = floating_ui_utils_min(rect.right, accRect.right);
    accRect.bottom = floating_ui_utils_min(rect.bottom, accRect.bottom);
    accRect.left = floating_ui_utils_max(rect.left, accRect.left);
    return accRect;
  }, getClientRectFromClippingAncestor(element, firstClippingAncestor, strategy));
  return {
    width: clippingRect.right - clippingRect.left,
    height: clippingRect.bottom - clippingRect.top,
    x: clippingRect.left,
    y: clippingRect.top
  };
}

function getDimensions(element) {
  const {
    width,
    height
  } = getCssDimensions(element);
  return {
    width,
    height
  };
}

function getRectRelativeToOffsetParent(element, offsetParent, strategy) {
  const isOffsetParentAnElement = isHTMLElement(offsetParent);
  const documentElement = getDocumentElement(offsetParent);
  const isFixed = strategy === 'fixed';
  const rect = getBoundingClientRect(element, true, isFixed, offsetParent);
  let scroll = {
    scrollLeft: 0,
    scrollTop: 0
  };
  const offsets = floating_ui_utils_createCoords(0);
  if (isOffsetParentAnElement || !isOffsetParentAnElement && !isFixed) {
    if (getNodeName(offsetParent) !== 'body' || isOverflowElement(documentElement)) {
      scroll = getNodeScroll(offsetParent);
    }
    if (isOffsetParentAnElement) {
      const offsetRect = getBoundingClientRect(offsetParent, true, isFixed, offsetParent);
      offsets.x = offsetRect.x + offsetParent.clientLeft;
      offsets.y = offsetRect.y + offsetParent.clientTop;
    } else if (documentElement) {
      offsets.x = getWindowScrollBarX(documentElement);
    }
  }
  const x = rect.left + scroll.scrollLeft - offsets.x;
  const y = rect.top + scroll.scrollTop - offsets.y;
  return {
    x,
    y,
    width: rect.width,
    height: rect.height
  };
}

function isStaticPositioned(element) {
  return floating_ui_utils_dom_getComputedStyle(element).position === 'static';
}

function getTrueOffsetParent(element, polyfill) {
  if (!isHTMLElement(element) || floating_ui_utils_dom_getComputedStyle(element).position === 'fixed') {
    return null;
  }
  if (polyfill) {
    return polyfill(element);
  }
  return element.offsetParent;
}

// Gets the closest ancestor positioned element. Handles some edge cases,
// such as table ancestors and cross browser bugs.
function getOffsetParent(element, polyfill) {
  const win = getWindow(element);
  if (isTopLayer(element)) {
    return win;
  }
  if (!isHTMLElement(element)) {
    let svgOffsetParent = getParentNode(element);
    while (svgOffsetParent && !isLastTraversableNode(svgOffsetParent)) {
      if (isElement(svgOffsetParent) && !isStaticPositioned(svgOffsetParent)) {
        return svgOffsetParent;
      }
      svgOffsetParent = getParentNode(svgOffsetParent);
    }
    return win;
  }
  let offsetParent = getTrueOffsetParent(element, polyfill);
  while (offsetParent && isTableElement(offsetParent) && isStaticPositioned(offsetParent)) {
    offsetParent = getTrueOffsetParent(offsetParent, polyfill);
  }
  if (offsetParent && isLastTraversableNode(offsetParent) && isStaticPositioned(offsetParent) && !isContainingBlock(offsetParent)) {
    return win;
  }
  return offsetParent || getContainingBlock(element) || win;
}

const getElementRects = async function (data) {
  const getOffsetParentFn = this.getOffsetParent || getOffsetParent;
  const getDimensionsFn = this.getDimensions;
  const floatingDimensions = await getDimensionsFn(data.floating);
  return {
    reference: getRectRelativeToOffsetParent(data.reference, await getOffsetParentFn(data.floating), data.strategy),
    floating: {
      x: 0,
      y: 0,
      width: floatingDimensions.width,
      height: floatingDimensions.height
    }
  };
};

function isRTL(element) {
  return floating_ui_utils_dom_getComputedStyle(element).direction === 'rtl';
}

const platform = {
  convertOffsetParentRelativeRectToViewportRelativeRect,
  getDocumentElement: getDocumentElement,
  getClippingRect,
  getOffsetParent,
  getElementRects,
  getClientRects,
  getDimensions,
  getScale,
  isElement: isElement,
  isRTL
};

// https://samthor.au/2021/observing-dom/
function observeMove(element, onMove) {
  let io = null;
  let timeoutId;
  const root = getDocumentElement(element);
  function cleanup() {
    var _io;
    clearTimeout(timeoutId);
    (_io = io) == null || _io.disconnect();
    io = null;
  }
  function refresh(skip, threshold) {
    if (skip === void 0) {
      skip = false;
    }
    if (threshold === void 0) {
      threshold = 1;
    }
    cleanup();
    const {
      left,
      top,
      width,
      height
    } = element.getBoundingClientRect();
    if (!skip) {
      onMove();
    }
    if (!width || !height) {
      return;
    }
    const insetTop = floating_ui_utils_floor(top);
    const insetRight = floating_ui_utils_floor(root.clientWidth - (left + width));
    const insetBottom = floating_ui_utils_floor(root.clientHeight - (top + height));
    const insetLeft = floating_ui_utils_floor(left);
    const rootMargin = -insetTop + "px " + -insetRight + "px " + -insetBottom + "px " + -insetLeft + "px";
    const options = {
      rootMargin,
      threshold: floating_ui_utils_max(0, floating_ui_utils_min(1, threshold)) || 1
    };
    let isFirstUpdate = true;
    function handleObserve(entries) {
      const ratio = entries[0].intersectionRatio;
      if (ratio !== threshold) {
        if (!isFirstUpdate) {
          return refresh();
        }
        if (!ratio) {
          // If the reference is clipped, the ratio is 0. Throttle the refresh
          // to prevent an infinite loop of updates.
          timeoutId = setTimeout(() => {
            refresh(false, 1e-7);
          }, 1000);
        } else {
          refresh(false, ratio);
        }
      }
      isFirstUpdate = false;
    }

    // Older browsers don't support a `document` as the root and will throw an
    // error.
    try {
      io = new IntersectionObserver(handleObserve, {
        ...options,
        // Handle <iframe>s
        root: root.ownerDocument
      });
    } catch (e) {
      io = new IntersectionObserver(handleObserve, options);
    }
    io.observe(element);
  }
  refresh(true);
  return cleanup;
}

/**
 * Automatically updates the position of the floating element when necessary.
 * Should only be called when the floating element is mounted on the DOM or
 * visible on the screen.
 * @returns cleanup function that should be invoked when the floating element is
 * removed from the DOM or hidden from the screen.
 * @see https://floating-ui.com/docs/autoUpdate
 */
function autoUpdate(reference, floating, update, options) {
  if (options === void 0) {
    options = {};
  }
  const {
    ancestorScroll = true,
    ancestorResize = true,
    elementResize = typeof ResizeObserver === 'function',
    layoutShift = typeof IntersectionObserver === 'function',
    animationFrame = false
  } = options;
  const referenceEl = unwrapElement(reference);
  const ancestors = ancestorScroll || ancestorResize ? [...(referenceEl ? getOverflowAncestors(referenceEl) : []), ...getOverflowAncestors(floating)] : [];
  ancestors.forEach(ancestor => {
    ancestorScroll && ancestor.addEventListener('scroll', update, {
      passive: true
    });
    ancestorResize && ancestor.addEventListener('resize', update);
  });
  const cleanupIo = referenceEl && layoutShift ? observeMove(referenceEl, update) : null;
  let reobserveFrame = -1;
  let resizeObserver = null;
  if (elementResize) {
    resizeObserver = new ResizeObserver(_ref => {
      let [firstEntry] = _ref;
      if (firstEntry && firstEntry.target === referenceEl && resizeObserver) {
        // Prevent update loops when using the `size` middleware.
        // https://github.com/floating-ui/floating-ui/issues/1740
        resizeObserver.unobserve(floating);
        cancelAnimationFrame(reobserveFrame);
        reobserveFrame = requestAnimationFrame(() => {
          var _resizeObserver;
          (_resizeObserver = resizeObserver) == null || _resizeObserver.observe(floating);
        });
      }
      update();
    });
    if (referenceEl && !animationFrame) {
      resizeObserver.observe(referenceEl);
    }
    resizeObserver.observe(floating);
  }
  let frameId;
  let prevRefRect = animationFrame ? getBoundingClientRect(reference) : null;
  if (animationFrame) {
    frameLoop();
  }
  function frameLoop() {
    const nextRefRect = getBoundingClientRect(reference);
    if (prevRefRect && (nextRefRect.x !== prevRefRect.x || nextRefRect.y !== prevRefRect.y || nextRefRect.width !== prevRefRect.width || nextRefRect.height !== prevRefRect.height)) {
      update();
    }
    prevRefRect = nextRefRect;
    frameId = requestAnimationFrame(frameLoop);
  }
  update();
  return () => {
    var _resizeObserver2;
    ancestors.forEach(ancestor => {
      ancestorScroll && ancestor.removeEventListener('scroll', update);
      ancestorResize && ancestor.removeEventListener('resize', update);
    });
    cleanupIo == null || cleanupIo();
    (_resizeObserver2 = resizeObserver) == null || _resizeObserver2.disconnect();
    resizeObserver = null;
    if (animationFrame) {
      cancelAnimationFrame(frameId);
    }
  };
}

/**
 * Resolves with an object of overflow side offsets that determine how much the
 * element is overflowing a given clipping boundary on each side.
 * - positive = overflowing the boundary by that number of pixels
 * - negative = how many pixels left before it will overflow
 * - 0 = lies flush with the boundary
 * @see https://floating-ui.com/docs/detectOverflow
 */
const detectOverflow = (/* unused pure expression or super */ null && (detectOverflow$1));

/**
 * Modifies the placement by translating the floating element along the
 * specified axes.
 * A number (shorthand for `mainAxis` or distance), or an axes configuration
 * object may be passed.
 * @see https://floating-ui.com/docs/offset
 */
const offset = (/* unused pure expression or super */ null && (offset$1));

/**
 * Optimizes the visibility of the floating element by choosing the placement
 * that has the most space available automatically, without needing to specify a
 * preferred placement. Alternative to `flip`.
 * @see https://floating-ui.com/docs/autoPlacement
 */
const autoPlacement = (/* unused pure expression or super */ null && (autoPlacement$1));

/**
 * Optimizes the visibility of the floating element by shifting it in order to
 * keep it in view when it will overflow the clipping boundary.
 * @see https://floating-ui.com/docs/shift
 */
const shift = (/* unused pure expression or super */ null && (shift$1));

/**
 * Optimizes the visibility of the floating element by flipping the `placement`
 * in order to keep it in view when the preferred placement(s) will overflow the
 * clipping boundary. Alternative to `autoPlacement`.
 * @see https://floating-ui.com/docs/flip
 */
const flip = (/* unused pure expression or super */ null && (flip$1));

/**
 * Provides data that allows you to change the size of the floating element —
 * for instance, prevent it from overflowing the clipping boundary or match the
 * width of the reference element.
 * @see https://floating-ui.com/docs/size
 */
const size = (/* unused pure expression or super */ null && (size$1));

/**
 * Provides data to hide the floating element in applicable situations, such as
 * when it is not in the same clipping context as the reference element.
 * @see https://floating-ui.com/docs/hide
 */
const hide = (/* unused pure expression or super */ null && (hide$1));

/**
 * Provides data to position an inner element of the floating element so that it
 * appears centered to the reference element.
 * @see https://floating-ui.com/docs/arrow
 */
const arrow = (/* unused pure expression or super */ null && (arrow$1));

/**
 * Provides improved positioning for inline reference elements that can span
 * over multiple lines, such as hyperlinks or range selections.
 * @see https://floating-ui.com/docs/inline
 */
const inline = (/* unused pure expression or super */ null && (inline$1));

/**
 * Built-in `limiter` that will stop `shift()` at a certain point.
 */
const limitShift = (/* unused pure expression or super */ null && (limitShift$1));

/**
 * Computes the `x` and `y` coordinates that will place the floating element
 * next to a given reference element.
 */
const computePosition = (reference, floating, options) => {
  // This caches the expensive `getClippingElementAncestors` function so that
  // multiple lifecycle resets re-use the same result. It only lives for a
  // single call. If other functions become expensive, we can add them as well.
  const cache = new Map();
  const mergedOptions = {
    platform,
    ...options
  };
  const platformWithCache = {
    ...mergedOptions.platform,
    _c: cache
  };
  return computePosition$1(reference, floating, {
    ...mergedOptions,
    platform: platformWithCache
  });
};



;// CONCATENATED MODULE: ./node_modules/use-isomorphic-layout-effect/dist/use-isomorphic-layout-effect.browser.esm.js


var index =  react.useLayoutEffect ;

/* harmony default export */ var use_isomorphic_layout_effect_browser_esm = (index);

;// CONCATENATED MODULE: ./node_modules/react-select/dist/index-a301f526.esm.js













var _excluded$4 = ["className", "clearValue", "cx", "getStyles", "getClassNames", "getValue", "hasValue", "isMulti", "isRtl", "options", "selectOption", "selectProps", "setValue", "theme"];
// ==============================
// NO OP
// ==============================

var noop = function noop() {};

// ==============================
// Class Name Prefixer
// ==============================

/**
 String representation of component state for styling with class names.

 Expects an array of strings OR a string/object pair:
 - className(['comp', 'comp-arg', 'comp-arg-2'])
   @returns 'react-select__comp react-select__comp-arg react-select__comp-arg-2'
 - className('comp', { some: true, state: false })
   @returns 'react-select__comp react-select__comp--some'
*/
function applyPrefixToName(prefix, name) {
  if (!name) {
    return prefix;
  } else if (name[0] === '-') {
    return prefix + name;
  } else {
    return prefix + '__' + name;
  }
}
function classNames(prefix, state) {
  for (var _len = arguments.length, classNameList = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
    classNameList[_key - 2] = arguments[_key];
  }
  var arr = [].concat(classNameList);
  if (state && prefix) {
    for (var key in state) {
      if (state.hasOwnProperty(key) && state[key]) {
        arr.push("".concat(applyPrefixToName(prefix, key)));
      }
    }
  }
  return arr.filter(function (i) {
    return i;
  }).map(function (i) {
    return String(i).trim();
  }).join(' ');
}
// ==============================
// Clean Value
// ==============================

var cleanValue = function cleanValue(value) {
  if (isArray(value)) return value.filter(Boolean);
  if (_typeof(value) === 'object' && value !== null) return [value];
  return [];
};

// ==============================
// Clean Common Props
// ==============================

var cleanCommonProps = function cleanCommonProps(props) {
  //className
  props.className;
    props.clearValue;
    props.cx;
    props.getStyles;
    props.getClassNames;
    props.getValue;
    props.hasValue;
    props.isMulti;
    props.isRtl;
    props.options;
    props.selectOption;
    props.selectProps;
    props.setValue;
    props.theme;
    var innerProps = _objectWithoutProperties(props, _excluded$4);
  return objectSpread2_objectSpread2({}, innerProps);
};

// ==============================
// Get Style Props
// ==============================

var getStyleProps = function getStyleProps(props, name, classNamesState) {
  var cx = props.cx,
    getStyles = props.getStyles,
    getClassNames = props.getClassNames,
    className = props.className;
  return {
    css: getStyles(name, props),
    className: cx(classNamesState !== null && classNamesState !== void 0 ? classNamesState : {}, getClassNames(name, props), className)
  };
};

// ==============================
// Handle Input Change
// ==============================

function handleInputChange(inputValue, actionMeta, onInputChange) {
  if (onInputChange) {
    var _newValue = onInputChange(inputValue, actionMeta);
    if (typeof _newValue === 'string') return _newValue;
  }
  return inputValue;
}

// ==============================
// Scroll Helpers
// ==============================

function isDocumentElement(el) {
  return [document.documentElement, document.body, window].indexOf(el) > -1;
}

// Normalized Scroll Top
// ------------------------------

function normalizedHeight(el) {
  if (isDocumentElement(el)) {
    return window.innerHeight;
  }
  return el.clientHeight;
}

// Normalized scrollTo & scrollTop
// ------------------------------

function getScrollTop(el) {
  if (isDocumentElement(el)) {
    return window.pageYOffset;
  }
  return el.scrollTop;
}
function scrollTo(el, top) {
  // with a scroll distance, we perform scroll on the element
  if (isDocumentElement(el)) {
    window.scrollTo(0, top);
    return;
  }
  el.scrollTop = top;
}

// Get Scroll Parent
// ------------------------------

function getScrollParent(element) {
  var style = getComputedStyle(element);
  var excludeStaticParent = style.position === 'absolute';
  var overflowRx = /(auto|scroll)/;
  if (style.position === 'fixed') return document.documentElement;
  for (var parent = element; parent = parent.parentElement;) {
    style = getComputedStyle(parent);
    if (excludeStaticParent && style.position === 'static') {
      continue;
    }
    if (overflowRx.test(style.overflow + style.overflowY + style.overflowX)) {
      return parent;
    }
  }
  return document.documentElement;
}

// Animated Scroll To
// ------------------------------

/**
  @param t: time (elapsed)
  @param b: initial value
  @param c: amount of change
  @param d: duration
*/
function easeOutCubic(t, b, c, d) {
  return c * ((t = t / d - 1) * t * t + 1) + b;
}
function animatedScrollTo(element, to) {
  var duration = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 200;
  var callback = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : noop;
  var start = getScrollTop(element);
  var change = to - start;
  var increment = 10;
  var currentTime = 0;
  function animateScroll() {
    currentTime += increment;
    var val = easeOutCubic(currentTime, start, change, duration);
    scrollTo(element, val);
    if (currentTime < duration) {
      window.requestAnimationFrame(animateScroll);
    } else {
      callback(element);
    }
  }
  animateScroll();
}

// Scroll Into View
// ------------------------------

function scrollIntoView(menuEl, focusedEl) {
  var menuRect = menuEl.getBoundingClientRect();
  var focusedRect = focusedEl.getBoundingClientRect();
  var overScroll = focusedEl.offsetHeight / 3;
  if (focusedRect.bottom + overScroll > menuRect.bottom) {
    scrollTo(menuEl, Math.min(focusedEl.offsetTop + focusedEl.clientHeight - menuEl.offsetHeight + overScroll, menuEl.scrollHeight));
  } else if (focusedRect.top - overScroll < menuRect.top) {
    scrollTo(menuEl, Math.max(focusedEl.offsetTop - overScroll, 0));
  }
}

// ==============================
// Get bounding client object
// ==============================

// cannot get keys using array notation with DOMRect
function getBoundingClientObj(element) {
  var rect = element.getBoundingClientRect();
  return {
    bottom: rect.bottom,
    height: rect.height,
    left: rect.left,
    right: rect.right,
    top: rect.top,
    width: rect.width
  };
}

// ==============================
// Touch Capability Detector
// ==============================

function isTouchCapable() {
  try {
    document.createEvent('TouchEvent');
    return true;
  } catch (e) {
    return false;
  }
}

// ==============================
// Mobile Device Detector
// ==============================

function isMobileDevice() {
  try {
    return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
  } catch (e) {
    return false;
  }
}

// ==============================
// Passive Event Detector
// ==============================

// https://github.com/rafgraph/detect-it/blob/main/src/index.ts#L19-L36
var passiveOptionAccessed = false;
var options = {
  get passive() {
    return passiveOptionAccessed = true;
  }
};
// check for SSR
var w = typeof window !== 'undefined' ? window : {};
if (w.addEventListener && w.removeEventListener) {
  w.addEventListener('p', noop, options);
  w.removeEventListener('p', noop, false);
}
var supportsPassiveEvents = passiveOptionAccessed;
function notNullish(item) {
  return item != null;
}
function isArray(arg) {
  return Array.isArray(arg);
}
function valueTernary(isMulti, multiValue, singleValue) {
  return isMulti ? multiValue : singleValue;
}
function singleValueAsValue(singleValue) {
  return singleValue;
}
function multiValueAsValue(multiValue) {
  return multiValue;
}
var removeProps = function removeProps(propsObj) {
  for (var _len2 = arguments.length, properties = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
    properties[_key2 - 1] = arguments[_key2];
  }
  var propsMap = Object.entries(propsObj).filter(function (_ref) {
    var _ref2 = _slicedToArray(_ref, 1),
      key = _ref2[0];
    return !properties.includes(key);
  });
  return propsMap.reduce(function (newProps, _ref3) {
    var _ref4 = _slicedToArray(_ref3, 2),
      key = _ref4[0],
      val = _ref4[1];
    newProps[key] = val;
    return newProps;
  }, {});
};

var _excluded$3 = ["children", "innerProps"],
  _excluded2$1 = ["children", "innerProps"];
function getMenuPlacement(_ref) {
  var preferredMaxHeight = _ref.maxHeight,
    menuEl = _ref.menuEl,
    minHeight = _ref.minHeight,
    preferredPlacement = _ref.placement,
    shouldScroll = _ref.shouldScroll,
    isFixedPosition = _ref.isFixedPosition,
    controlHeight = _ref.controlHeight;
  var scrollParent = getScrollParent(menuEl);
  var defaultState = {
    placement: 'bottom',
    maxHeight: preferredMaxHeight
  };

  // something went wrong, return default state
  if (!menuEl || !menuEl.offsetParent) return defaultState;

  // we can't trust `scrollParent.scrollHeight` --> it may increase when
  // the menu is rendered
  var _scrollParent$getBoun = scrollParent.getBoundingClientRect(),
    scrollHeight = _scrollParent$getBoun.height;
  var _menuEl$getBoundingCl = menuEl.getBoundingClientRect(),
    menuBottom = _menuEl$getBoundingCl.bottom,
    menuHeight = _menuEl$getBoundingCl.height,
    menuTop = _menuEl$getBoundingCl.top;
  var _menuEl$offsetParent$ = menuEl.offsetParent.getBoundingClientRect(),
    containerTop = _menuEl$offsetParent$.top;
  var viewHeight = isFixedPosition ? window.innerHeight : normalizedHeight(scrollParent);
  var scrollTop = getScrollTop(scrollParent);
  var marginBottom = parseInt(getComputedStyle(menuEl).marginBottom, 10);
  var marginTop = parseInt(getComputedStyle(menuEl).marginTop, 10);
  var viewSpaceAbove = containerTop - marginTop;
  var viewSpaceBelow = viewHeight - menuTop;
  var scrollSpaceAbove = viewSpaceAbove + scrollTop;
  var scrollSpaceBelow = scrollHeight - scrollTop - menuTop;
  var scrollDown = menuBottom - viewHeight + scrollTop + marginBottom;
  var scrollUp = scrollTop + menuTop - marginTop;
  var scrollDuration = 160;
  switch (preferredPlacement) {
    case 'auto':
    case 'bottom':
      // 1: the menu will fit, do nothing
      if (viewSpaceBelow >= menuHeight) {
        return {
          placement: 'bottom',
          maxHeight: preferredMaxHeight
        };
      }

      // 2: the menu will fit, if scrolled
      if (scrollSpaceBelow >= menuHeight && !isFixedPosition) {
        if (shouldScroll) {
          animatedScrollTo(scrollParent, scrollDown, scrollDuration);
        }
        return {
          placement: 'bottom',
          maxHeight: preferredMaxHeight
        };
      }

      // 3: the menu will fit, if constrained
      if (!isFixedPosition && scrollSpaceBelow >= minHeight || isFixedPosition && viewSpaceBelow >= minHeight) {
        if (shouldScroll) {
          animatedScrollTo(scrollParent, scrollDown, scrollDuration);
        }

        // we want to provide as much of the menu as possible to the user,
        // so give them whatever is available below rather than the minHeight.
        var constrainedHeight = isFixedPosition ? viewSpaceBelow - marginBottom : scrollSpaceBelow - marginBottom;
        return {
          placement: 'bottom',
          maxHeight: constrainedHeight
        };
      }

      // 4. Forked beviour when there isn't enough space below

      // AUTO: flip the menu, render above
      if (preferredPlacement === 'auto' || isFixedPosition) {
        // may need to be constrained after flipping
        var _constrainedHeight = preferredMaxHeight;
        var spaceAbove = isFixedPosition ? viewSpaceAbove : scrollSpaceAbove;
        if (spaceAbove >= minHeight) {
          _constrainedHeight = Math.min(spaceAbove - marginBottom - controlHeight, preferredMaxHeight);
        }
        return {
          placement: 'top',
          maxHeight: _constrainedHeight
        };
      }

      // BOTTOM: allow browser to increase scrollable area and immediately set scroll
      if (preferredPlacement === 'bottom') {
        if (shouldScroll) {
          scrollTo(scrollParent, scrollDown);
        }
        return {
          placement: 'bottom',
          maxHeight: preferredMaxHeight
        };
      }
      break;
    case 'top':
      // 1: the menu will fit, do nothing
      if (viewSpaceAbove >= menuHeight) {
        return {
          placement: 'top',
          maxHeight: preferredMaxHeight
        };
      }

      // 2: the menu will fit, if scrolled
      if (scrollSpaceAbove >= menuHeight && !isFixedPosition) {
        if (shouldScroll) {
          animatedScrollTo(scrollParent, scrollUp, scrollDuration);
        }
        return {
          placement: 'top',
          maxHeight: preferredMaxHeight
        };
      }

      // 3: the menu will fit, if constrained
      if (!isFixedPosition && scrollSpaceAbove >= minHeight || isFixedPosition && viewSpaceAbove >= minHeight) {
        var _constrainedHeight2 = preferredMaxHeight;

        // we want to provide as much of the menu as possible to the user,
        // so give them whatever is available below rather than the minHeight.
        if (!isFixedPosition && scrollSpaceAbove >= minHeight || isFixedPosition && viewSpaceAbove >= minHeight) {
          _constrainedHeight2 = isFixedPosition ? viewSpaceAbove - marginTop : scrollSpaceAbove - marginTop;
        }
        if (shouldScroll) {
          animatedScrollTo(scrollParent, scrollUp, scrollDuration);
        }
        return {
          placement: 'top',
          maxHeight: _constrainedHeight2
        };
      }

      // 4. not enough space, the browser WILL NOT increase scrollable area when
      // absolutely positioned element rendered above the viewport (only below).
      // Flip the menu, render below
      return {
        placement: 'bottom',
        maxHeight: preferredMaxHeight
      };
    default:
      throw new Error("Invalid placement provided \"".concat(preferredPlacement, "\"."));
  }
  return defaultState;
}

// Menu Component
// ------------------------------

function alignToControl(placement) {
  var placementToCSSProp = {
    bottom: 'top',
    top: 'bottom'
  };
  return placement ? placementToCSSProp[placement] : 'bottom';
}
var coercePlacement = function coercePlacement(p) {
  return p === 'auto' ? 'bottom' : p;
};
var menuCSS = function menuCSS(_ref2, unstyled) {
  var _objectSpread2;
  var placement = _ref2.placement,
    _ref2$theme = _ref2.theme,
    borderRadius = _ref2$theme.borderRadius,
    spacing = _ref2$theme.spacing,
    colors = _ref2$theme.colors;
  return objectSpread2_objectSpread2((_objectSpread2 = {
    label: 'menu'
  }, _defineProperty(_objectSpread2, alignToControl(placement), '100%'), _defineProperty(_objectSpread2, "position", 'absolute'), _defineProperty(_objectSpread2, "width", '100%'), _defineProperty(_objectSpread2, "zIndex", 1), _objectSpread2), unstyled ? {} : {
    backgroundColor: colors.neutral0,
    borderRadius: borderRadius,
    boxShadow: '0 0 0 1px hsla(0, 0%, 0%, 0.1), 0 4px 11px hsla(0, 0%, 0%, 0.1)',
    marginBottom: spacing.menuGutter,
    marginTop: spacing.menuGutter
  });
};
var PortalPlacementContext = /*#__PURE__*/(0,react.createContext)(null);

// NOTE: internal only
var MenuPlacer = function MenuPlacer(props) {
  var children = props.children,
    minMenuHeight = props.minMenuHeight,
    maxMenuHeight = props.maxMenuHeight,
    menuPlacement = props.menuPlacement,
    menuPosition = props.menuPosition,
    menuShouldScrollIntoView = props.menuShouldScrollIntoView,
    theme = props.theme;
  var _ref3 = (0,react.useContext)(PortalPlacementContext) || {},
    setPortalPlacement = _ref3.setPortalPlacement;
  var ref = (0,react.useRef)(null);
  var _useState = (0,react.useState)(maxMenuHeight),
    _useState2 = _slicedToArray(_useState, 2),
    maxHeight = _useState2[0],
    setMaxHeight = _useState2[1];
  var _useState3 = (0,react.useState)(null),
    _useState4 = _slicedToArray(_useState3, 2),
    placement = _useState4[0],
    setPlacement = _useState4[1];
  var controlHeight = theme.spacing.controlHeight;
  use_isomorphic_layout_effect_browser_esm(function () {
    var menuEl = ref.current;
    if (!menuEl) return;

    // DO NOT scroll if position is fixed
    var isFixedPosition = menuPosition === 'fixed';
    var shouldScroll = menuShouldScrollIntoView && !isFixedPosition;
    var state = getMenuPlacement({
      maxHeight: maxMenuHeight,
      menuEl: menuEl,
      minHeight: minMenuHeight,
      placement: menuPlacement,
      shouldScroll: shouldScroll,
      isFixedPosition: isFixedPosition,
      controlHeight: controlHeight
    });
    setMaxHeight(state.maxHeight);
    setPlacement(state.placement);
    setPortalPlacement === null || setPortalPlacement === void 0 ? void 0 : setPortalPlacement(state.placement);
  }, [maxMenuHeight, menuPlacement, menuPosition, menuShouldScrollIntoView, minMenuHeight, setPortalPlacement, controlHeight]);
  return children({
    ref: ref,
    placerProps: objectSpread2_objectSpread2(objectSpread2_objectSpread2({}, props), {}, {
      placement: placement || coercePlacement(menuPlacement),
      maxHeight: maxHeight
    })
  });
};
var Menu = function Menu(props) {
  var children = props.children,
    innerRef = props.innerRef,
    innerProps = props.innerProps;
  return jsx("div", extends_extends({}, getStyleProps(props, 'menu', {
    menu: true
  }), {
    ref: innerRef
  }, innerProps), children);
};
var Menu$1 = Menu;

// ==============================
// Menu List
// ==============================

var menuListCSS = function menuListCSS(_ref4, unstyled) {
  var maxHeight = _ref4.maxHeight,
    baseUnit = _ref4.theme.spacing.baseUnit;
  return objectSpread2_objectSpread2({
    maxHeight: maxHeight,
    overflowY: 'auto',
    position: 'relative',
    // required for offset[Height, Top] > keyboard scroll
    WebkitOverflowScrolling: 'touch'
  }, unstyled ? {} : {
    paddingBottom: baseUnit,
    paddingTop: baseUnit
  });
};
var MenuList = function MenuList(props) {
  var children = props.children,
    innerProps = props.innerProps,
    innerRef = props.innerRef,
    isMulti = props.isMulti;
  return jsx("div", extends_extends({}, getStyleProps(props, 'menuList', {
    'menu-list': true,
    'menu-list--is-multi': isMulti
  }), {
    ref: innerRef
  }, innerProps), children);
};

// ==============================
// Menu Notices
// ==============================

var noticeCSS = function noticeCSS(_ref5, unstyled) {
  var _ref5$theme = _ref5.theme,
    baseUnit = _ref5$theme.spacing.baseUnit,
    colors = _ref5$theme.colors;
  return objectSpread2_objectSpread2({
    textAlign: 'center'
  }, unstyled ? {} : {
    color: colors.neutral40,
    padding: "".concat(baseUnit * 2, "px ").concat(baseUnit * 3, "px")
  });
};
var noOptionsMessageCSS = noticeCSS;
var loadingMessageCSS = noticeCSS;
var NoOptionsMessage = function NoOptionsMessage(_ref6) {
  var _ref6$children = _ref6.children,
    children = _ref6$children === void 0 ? 'No options' : _ref6$children,
    innerProps = _ref6.innerProps,
    restProps = _objectWithoutProperties(_ref6, _excluded$3);
  return jsx("div", extends_extends({}, getStyleProps(objectSpread2_objectSpread2(objectSpread2_objectSpread2({}, restProps), {}, {
    children: children,
    innerProps: innerProps
  }), 'noOptionsMessage', {
    'menu-notice': true,
    'menu-notice--no-options': true
  }), innerProps), children);
};
var LoadingMessage = function LoadingMessage(_ref7) {
  var _ref7$children = _ref7.children,
    children = _ref7$children === void 0 ? 'Loading...' : _ref7$children,
    innerProps = _ref7.innerProps,
    restProps = _objectWithoutProperties(_ref7, _excluded2$1);
  return jsx("div", extends_extends({}, getStyleProps(objectSpread2_objectSpread2(objectSpread2_objectSpread2({}, restProps), {}, {
    children: children,
    innerProps: innerProps
  }), 'loadingMessage', {
    'menu-notice': true,
    'menu-notice--loading': true
  }), innerProps), children);
};

// ==============================
// Menu Portal
// ==============================

var menuPortalCSS = function menuPortalCSS(_ref8) {
  var rect = _ref8.rect,
    offset = _ref8.offset,
    position = _ref8.position;
  return {
    left: rect.left,
    position: position,
    top: offset,
    width: rect.width,
    zIndex: 1
  };
};
var MenuPortal = function MenuPortal(props) {
  var appendTo = props.appendTo,
    children = props.children,
    controlElement = props.controlElement,
    innerProps = props.innerProps,
    menuPlacement = props.menuPlacement,
    menuPosition = props.menuPosition;
  var menuPortalRef = (0,react.useRef)(null);
  var cleanupRef = (0,react.useRef)(null);
  var _useState5 = (0,react.useState)(coercePlacement(menuPlacement)),
    _useState6 = _slicedToArray(_useState5, 2),
    placement = _useState6[0],
    setPortalPlacement = _useState6[1];
  var portalPlacementContext = (0,react.useMemo)(function () {
    return {
      setPortalPlacement: setPortalPlacement
    };
  }, []);
  var _useState7 = (0,react.useState)(null),
    _useState8 = _slicedToArray(_useState7, 2),
    computedPosition = _useState8[0],
    setComputedPosition = _useState8[1];
  var updateComputedPosition = (0,react.useCallback)(function () {
    if (!controlElement) return;
    var rect = getBoundingClientObj(controlElement);
    var scrollDistance = menuPosition === 'fixed' ? 0 : window.pageYOffset;
    var offset = rect[placement] + scrollDistance;
    if (offset !== (computedPosition === null || computedPosition === void 0 ? void 0 : computedPosition.offset) || rect.left !== (computedPosition === null || computedPosition === void 0 ? void 0 : computedPosition.rect.left) || rect.width !== (computedPosition === null || computedPosition === void 0 ? void 0 : computedPosition.rect.width)) {
      setComputedPosition({
        offset: offset,
        rect: rect
      });
    }
  }, [controlElement, menuPosition, placement, computedPosition === null || computedPosition === void 0 ? void 0 : computedPosition.offset, computedPosition === null || computedPosition === void 0 ? void 0 : computedPosition.rect.left, computedPosition === null || computedPosition === void 0 ? void 0 : computedPosition.rect.width]);
  use_isomorphic_layout_effect_browser_esm(function () {
    updateComputedPosition();
  }, [updateComputedPosition]);
  var runAutoUpdate = (0,react.useCallback)(function () {
    if (typeof cleanupRef.current === 'function') {
      cleanupRef.current();
      cleanupRef.current = null;
    }
    if (controlElement && menuPortalRef.current) {
      cleanupRef.current = autoUpdate(controlElement, menuPortalRef.current, updateComputedPosition, {
        elementResize: 'ResizeObserver' in window
      });
    }
  }, [controlElement, updateComputedPosition]);
  use_isomorphic_layout_effect_browser_esm(function () {
    runAutoUpdate();
  }, [runAutoUpdate]);
  var setMenuPortalElement = (0,react.useCallback)(function (menuPortalElement) {
    menuPortalRef.current = menuPortalElement;
    runAutoUpdate();
  }, [runAutoUpdate]);

  // bail early if required elements aren't present
  if (!appendTo && menuPosition !== 'fixed' || !computedPosition) return null;

  // same wrapper element whether fixed or portalled
  var menuWrapper = jsx("div", extends_extends({
    ref: setMenuPortalElement
  }, getStyleProps(objectSpread2_objectSpread2(objectSpread2_objectSpread2({}, props), {}, {
    offset: computedPosition.offset,
    position: menuPosition,
    rect: computedPosition.rect
  }), 'menuPortal', {
    'menu-portal': true
  }), innerProps), children);
  return jsx(PortalPlacementContext.Provider, {
    value: portalPlacementContext
  }, appendTo ? /*#__PURE__*/(0,react_dom.createPortal)(menuWrapper, appendTo) : menuWrapper);
};

// ==============================
// Root Container
// ==============================

var containerCSS = function containerCSS(_ref) {
  var isDisabled = _ref.isDisabled,
    isRtl = _ref.isRtl;
  return {
    label: 'container',
    direction: isRtl ? 'rtl' : undefined,
    pointerEvents: isDisabled ? 'none' : undefined,
    // cancel mouse events when disabled
    position: 'relative'
  };
};
var SelectContainer = function SelectContainer(props) {
  var children = props.children,
    innerProps = props.innerProps,
    isDisabled = props.isDisabled,
    isRtl = props.isRtl;
  return jsx("div", extends_extends({}, getStyleProps(props, 'container', {
    '--is-disabled': isDisabled,
    '--is-rtl': isRtl
  }), innerProps), children);
};

// ==============================
// Value Container
// ==============================

var valueContainerCSS = function valueContainerCSS(_ref2, unstyled) {
  var spacing = _ref2.theme.spacing,
    isMulti = _ref2.isMulti,
    hasValue = _ref2.hasValue,
    controlShouldRenderValue = _ref2.selectProps.controlShouldRenderValue;
  return objectSpread2_objectSpread2({
    alignItems: 'center',
    display: isMulti && hasValue && controlShouldRenderValue ? 'flex' : 'grid',
    flex: 1,
    flexWrap: 'wrap',
    WebkitOverflowScrolling: 'touch',
    position: 'relative',
    overflow: 'hidden'
  }, unstyled ? {} : {
    padding: "".concat(spacing.baseUnit / 2, "px ").concat(spacing.baseUnit * 2, "px")
  });
};
var ValueContainer = function ValueContainer(props) {
  var children = props.children,
    innerProps = props.innerProps,
    isMulti = props.isMulti,
    hasValue = props.hasValue;
  return jsx("div", extends_extends({}, getStyleProps(props, 'valueContainer', {
    'value-container': true,
    'value-container--is-multi': isMulti,
    'value-container--has-value': hasValue
  }), innerProps), children);
};

// ==============================
// Indicator Container
// ==============================

var indicatorsContainerCSS = function indicatorsContainerCSS() {
  return {
    alignItems: 'center',
    alignSelf: 'stretch',
    display: 'flex',
    flexShrink: 0
  };
};
var IndicatorsContainer = function IndicatorsContainer(props) {
  var children = props.children,
    innerProps = props.innerProps;
  return jsx("div", extends_extends({}, getStyleProps(props, 'indicatorsContainer', {
    indicators: true
  }), innerProps), children);
};

var _templateObject;
var _excluded$2 = ["size"],
  _excluded2 = ["innerProps", "isRtl", "size"];
function _EMOTION_STRINGIFIED_CSS_ERROR__() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }

// ==============================
// Dropdown & Clear Icons
// ==============================
var _ref2 =  true ? {
  name: "8mmkcg",
  styles: "display:inline-block;fill:currentColor;line-height:1;stroke:currentColor;stroke-width:0"
} : 0;
var Svg = function Svg(_ref) {
  var size = _ref.size,
    props = _objectWithoutProperties(_ref, _excluded$2);
  return jsx("svg", extends_extends({
    height: size,
    width: size,
    viewBox: "0 0 20 20",
    "aria-hidden": "true",
    focusable: "false",
    css: _ref2
  }, props));
};
var CrossIcon = function CrossIcon(props) {
  return jsx(Svg, extends_extends({
    size: 20
  }, props), jsx("path", {
    d: "M14.348 14.849c-0.469 0.469-1.229 0.469-1.697 0l-2.651-3.030-2.651 3.029c-0.469 0.469-1.229 0.469-1.697 0-0.469-0.469-0.469-1.229 0-1.697l2.758-3.15-2.759-3.152c-0.469-0.469-0.469-1.228 0-1.697s1.228-0.469 1.697 0l2.652 3.031 2.651-3.031c0.469-0.469 1.228-0.469 1.697 0s0.469 1.229 0 1.697l-2.758 3.152 2.758 3.15c0.469 0.469 0.469 1.229 0 1.698z"
  }));
};
var DownChevron = function DownChevron(props) {
  return jsx(Svg, extends_extends({
    size: 20
  }, props), jsx("path", {
    d: "M4.516 7.548c0.436-0.446 1.043-0.481 1.576 0l3.908 3.747 3.908-3.747c0.533-0.481 1.141-0.446 1.574 0 0.436 0.445 0.408 1.197 0 1.615-0.406 0.418-4.695 4.502-4.695 4.502-0.217 0.223-0.502 0.335-0.787 0.335s-0.57-0.112-0.789-0.335c0 0-4.287-4.084-4.695-4.502s-0.436-1.17 0-1.615z"
  }));
};

// ==============================
// Dropdown & Clear Buttons
// ==============================

var baseCSS = function baseCSS(_ref3, unstyled) {
  var isFocused = _ref3.isFocused,
    _ref3$theme = _ref3.theme,
    baseUnit = _ref3$theme.spacing.baseUnit,
    colors = _ref3$theme.colors;
  return objectSpread2_objectSpread2({
    label: 'indicatorContainer',
    display: 'flex',
    transition: 'color 150ms'
  }, unstyled ? {} : {
    color: isFocused ? colors.neutral60 : colors.neutral20,
    padding: baseUnit * 2,
    ':hover': {
      color: isFocused ? colors.neutral80 : colors.neutral40
    }
  });
};
var dropdownIndicatorCSS = baseCSS;
var DropdownIndicator = function DropdownIndicator(props) {
  var children = props.children,
    innerProps = props.innerProps;
  return jsx("div", extends_extends({}, getStyleProps(props, 'dropdownIndicator', {
    indicator: true,
    'dropdown-indicator': true
  }), innerProps), children || jsx(DownChevron, null));
};
var clearIndicatorCSS = baseCSS;
var ClearIndicator = function ClearIndicator(props) {
  var children = props.children,
    innerProps = props.innerProps;
  return jsx("div", extends_extends({}, getStyleProps(props, 'clearIndicator', {
    indicator: true,
    'clear-indicator': true
  }), innerProps), children || jsx(CrossIcon, null));
};

// ==============================
// Separator
// ==============================

var indicatorSeparatorCSS = function indicatorSeparatorCSS(_ref4, unstyled) {
  var isDisabled = _ref4.isDisabled,
    _ref4$theme = _ref4.theme,
    baseUnit = _ref4$theme.spacing.baseUnit,
    colors = _ref4$theme.colors;
  return objectSpread2_objectSpread2({
    label: 'indicatorSeparator',
    alignSelf: 'stretch',
    width: 1
  }, unstyled ? {} : {
    backgroundColor: isDisabled ? colors.neutral10 : colors.neutral20,
    marginBottom: baseUnit * 2,
    marginTop: baseUnit * 2
  });
};
var IndicatorSeparator = function IndicatorSeparator(props) {
  var innerProps = props.innerProps;
  return jsx("span", extends_extends({}, innerProps, getStyleProps(props, 'indicatorSeparator', {
    'indicator-separator': true
  })));
};

// ==============================
// Loading
// ==============================

var loadingDotAnimations = keyframes(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  0%, 80%, 100% { opacity: 0; }\n  40% { opacity: 1; }\n"])));
var loadingIndicatorCSS = function loadingIndicatorCSS(_ref5, unstyled) {
  var isFocused = _ref5.isFocused,
    size = _ref5.size,
    _ref5$theme = _ref5.theme,
    colors = _ref5$theme.colors,
    baseUnit = _ref5$theme.spacing.baseUnit;
  return objectSpread2_objectSpread2({
    label: 'loadingIndicator',
    display: 'flex',
    transition: 'color 150ms',
    alignSelf: 'center',
    fontSize: size,
    lineHeight: 1,
    marginRight: size,
    textAlign: 'center',
    verticalAlign: 'middle'
  }, unstyled ? {} : {
    color: isFocused ? colors.neutral60 : colors.neutral20,
    padding: baseUnit * 2
  });
};
var LoadingDot = function LoadingDot(_ref6) {
  var delay = _ref6.delay,
    offset = _ref6.offset;
  return jsx("span", {
    css: /*#__PURE__*/css({
      animation: "".concat(loadingDotAnimations, " 1s ease-in-out ").concat(delay, "ms infinite;"),
      backgroundColor: 'currentColor',
      borderRadius: '1em',
      display: 'inline-block',
      marginLeft: offset ? '1em' : undefined,
      height: '1em',
      verticalAlign: 'top',
      width: '1em'
    },  true ? "" : 0,  true ? "" : 0)
  });
};
var LoadingIndicator = function LoadingIndicator(_ref7) {
  var innerProps = _ref7.innerProps,
    isRtl = _ref7.isRtl,
    _ref7$size = _ref7.size,
    size = _ref7$size === void 0 ? 4 : _ref7$size,
    restProps = _objectWithoutProperties(_ref7, _excluded2);
  return jsx("div", extends_extends({}, getStyleProps(objectSpread2_objectSpread2(objectSpread2_objectSpread2({}, restProps), {}, {
    innerProps: innerProps,
    isRtl: isRtl,
    size: size
  }), 'loadingIndicator', {
    indicator: true,
    'loading-indicator': true
  }), innerProps), jsx(LoadingDot, {
    delay: 0,
    offset: isRtl
  }), jsx(LoadingDot, {
    delay: 160,
    offset: true
  }), jsx(LoadingDot, {
    delay: 320,
    offset: !isRtl
  }));
};

var css$1 = function css(_ref, unstyled) {
  var isDisabled = _ref.isDisabled,
    isFocused = _ref.isFocused,
    _ref$theme = _ref.theme,
    colors = _ref$theme.colors,
    borderRadius = _ref$theme.borderRadius,
    spacing = _ref$theme.spacing;
  return objectSpread2_objectSpread2({
    label: 'control',
    alignItems: 'center',
    cursor: 'default',
    display: 'flex',
    flexWrap: 'wrap',
    justifyContent: 'space-between',
    minHeight: spacing.controlHeight,
    outline: '0 !important',
    position: 'relative',
    transition: 'all 100ms'
  }, unstyled ? {} : {
    backgroundColor: isDisabled ? colors.neutral5 : colors.neutral0,
    borderColor: isDisabled ? colors.neutral10 : isFocused ? colors.primary : colors.neutral20,
    borderRadius: borderRadius,
    borderStyle: 'solid',
    borderWidth: 1,
    boxShadow: isFocused ? "0 0 0 1px ".concat(colors.primary) : undefined,
    '&:hover': {
      borderColor: isFocused ? colors.primary : colors.neutral30
    }
  });
};
var Control = function Control(props) {
  var children = props.children,
    isDisabled = props.isDisabled,
    isFocused = props.isFocused,
    innerRef = props.innerRef,
    innerProps = props.innerProps,
    menuIsOpen = props.menuIsOpen;
  return jsx("div", extends_extends({
    ref: innerRef
  }, getStyleProps(props, 'control', {
    control: true,
    'control--is-disabled': isDisabled,
    'control--is-focused': isFocused,
    'control--menu-is-open': menuIsOpen
  }), innerProps, {
    "aria-disabled": isDisabled || undefined
  }), children);
};
var Control$1 = Control;

var _excluded$1 = ["data"];
var groupCSS = function groupCSS(_ref, unstyled) {
  var spacing = _ref.theme.spacing;
  return unstyled ? {} : {
    paddingBottom: spacing.baseUnit * 2,
    paddingTop: spacing.baseUnit * 2
  };
};
var Group = function Group(props) {
  var children = props.children,
    cx = props.cx,
    getStyles = props.getStyles,
    getClassNames = props.getClassNames,
    Heading = props.Heading,
    headingProps = props.headingProps,
    innerProps = props.innerProps,
    label = props.label,
    theme = props.theme,
    selectProps = props.selectProps;
  return jsx("div", extends_extends({}, getStyleProps(props, 'group', {
    group: true
  }), innerProps), jsx(Heading, extends_extends({}, headingProps, {
    selectProps: selectProps,
    theme: theme,
    getStyles: getStyles,
    getClassNames: getClassNames,
    cx: cx
  }), label), jsx("div", null, children));
};
var groupHeadingCSS = function groupHeadingCSS(_ref2, unstyled) {
  var _ref2$theme = _ref2.theme,
    colors = _ref2$theme.colors,
    spacing = _ref2$theme.spacing;
  return objectSpread2_objectSpread2({
    label: 'group',
    cursor: 'default',
    display: 'block'
  }, unstyled ? {} : {
    color: colors.neutral40,
    fontSize: '75%',
    fontWeight: 500,
    marginBottom: '0.25em',
    paddingLeft: spacing.baseUnit * 3,
    paddingRight: spacing.baseUnit * 3,
    textTransform: 'uppercase'
  });
};
var GroupHeading = function GroupHeading(props) {
  var _cleanCommonProps = cleanCommonProps(props);
    _cleanCommonProps.data;
    var innerProps = _objectWithoutProperties(_cleanCommonProps, _excluded$1);
  return jsx("div", extends_extends({}, getStyleProps(props, 'groupHeading', {
    'group-heading': true
  }), innerProps));
};
var Group$1 = Group;

var _excluded = ["innerRef", "isDisabled", "isHidden", "inputClassName"];
var inputCSS = function inputCSS(_ref, unstyled) {
  var isDisabled = _ref.isDisabled,
    value = _ref.value,
    _ref$theme = _ref.theme,
    spacing = _ref$theme.spacing,
    colors = _ref$theme.colors;
  return objectSpread2_objectSpread2(objectSpread2_objectSpread2({
    visibility: isDisabled ? 'hidden' : 'visible',
    // force css to recompute when value change due to @emotion bug.
    // We can remove it whenever the bug is fixed.
    transform: value ? 'translateZ(0)' : ''
  }, containerStyle), unstyled ? {} : {
    margin: spacing.baseUnit / 2,
    paddingBottom: spacing.baseUnit / 2,
    paddingTop: spacing.baseUnit / 2,
    color: colors.neutral80
  });
};
var spacingStyle = {
  gridArea: '1 / 2',
  font: 'inherit',
  minWidth: '2px',
  border: 0,
  margin: 0,
  outline: 0,
  padding: 0
};
var containerStyle = {
  flex: '1 1 auto',
  display: 'inline-grid',
  gridArea: '1 / 1 / 2 / 3',
  gridTemplateColumns: '0 min-content',
  '&:after': objectSpread2_objectSpread2({
    content: 'attr(data-value) " "',
    visibility: 'hidden',
    whiteSpace: 'pre'
  }, spacingStyle)
};
var inputStyle = function inputStyle(isHidden) {
  return objectSpread2_objectSpread2({
    label: 'input',
    color: 'inherit',
    background: 0,
    opacity: isHidden ? 0 : 1,
    width: '100%'
  }, spacingStyle);
};
var Input = function Input(props) {
  var cx = props.cx,
    value = props.value;
  var _cleanCommonProps = cleanCommonProps(props),
    innerRef = _cleanCommonProps.innerRef,
    isDisabled = _cleanCommonProps.isDisabled,
    isHidden = _cleanCommonProps.isHidden,
    inputClassName = _cleanCommonProps.inputClassName,
    innerProps = _objectWithoutProperties(_cleanCommonProps, _excluded);
  return jsx("div", extends_extends({}, getStyleProps(props, 'input', {
    'input-container': true
  }), {
    "data-value": value || ''
  }), jsx("input", extends_extends({
    className: cx({
      input: true
    }, inputClassName),
    ref: innerRef,
    style: inputStyle(isHidden),
    disabled: isDisabled
  }, innerProps)));
};
var Input$1 = Input;

var multiValueCSS = function multiValueCSS(_ref, unstyled) {
  var _ref$theme = _ref.theme,
    spacing = _ref$theme.spacing,
    borderRadius = _ref$theme.borderRadius,
    colors = _ref$theme.colors;
  return objectSpread2_objectSpread2({
    label: 'multiValue',
    display: 'flex',
    minWidth: 0
  }, unstyled ? {} : {
    backgroundColor: colors.neutral10,
    borderRadius: borderRadius / 2,
    margin: spacing.baseUnit / 2
  });
};
var multiValueLabelCSS = function multiValueLabelCSS(_ref2, unstyled) {
  var _ref2$theme = _ref2.theme,
    borderRadius = _ref2$theme.borderRadius,
    colors = _ref2$theme.colors,
    cropWithEllipsis = _ref2.cropWithEllipsis;
  return objectSpread2_objectSpread2({
    overflow: 'hidden',
    textOverflow: cropWithEllipsis || cropWithEllipsis === undefined ? 'ellipsis' : undefined,
    whiteSpace: 'nowrap'
  }, unstyled ? {} : {
    borderRadius: borderRadius / 2,
    color: colors.neutral80,
    fontSize: '85%',
    padding: 3,
    paddingLeft: 6
  });
};
var multiValueRemoveCSS = function multiValueRemoveCSS(_ref3, unstyled) {
  var _ref3$theme = _ref3.theme,
    spacing = _ref3$theme.spacing,
    borderRadius = _ref3$theme.borderRadius,
    colors = _ref3$theme.colors,
    isFocused = _ref3.isFocused;
  return objectSpread2_objectSpread2({
    alignItems: 'center',
    display: 'flex'
  }, unstyled ? {} : {
    borderRadius: borderRadius / 2,
    backgroundColor: isFocused ? colors.dangerLight : undefined,
    paddingLeft: spacing.baseUnit,
    paddingRight: spacing.baseUnit,
    ':hover': {
      backgroundColor: colors.dangerLight,
      color: colors.danger
    }
  });
};
var MultiValueGeneric = function MultiValueGeneric(_ref4) {
  var children = _ref4.children,
    innerProps = _ref4.innerProps;
  return jsx("div", innerProps, children);
};
var MultiValueContainer = MultiValueGeneric;
var MultiValueLabel = MultiValueGeneric;
function MultiValueRemove(_ref5) {
  var children = _ref5.children,
    innerProps = _ref5.innerProps;
  return jsx("div", extends_extends({
    role: "button"
  }, innerProps), children || jsx(CrossIcon, {
    size: 14
  }));
}
var MultiValue = function MultiValue(props) {
  var children = props.children,
    components = props.components,
    data = props.data,
    innerProps = props.innerProps,
    isDisabled = props.isDisabled,
    removeProps = props.removeProps,
    selectProps = props.selectProps;
  var Container = components.Container,
    Label = components.Label,
    Remove = components.Remove;
  return jsx(Container, {
    data: data,
    innerProps: objectSpread2_objectSpread2(objectSpread2_objectSpread2({}, getStyleProps(props, 'multiValue', {
      'multi-value': true,
      'multi-value--is-disabled': isDisabled
    })), innerProps),
    selectProps: selectProps
  }, jsx(Label, {
    data: data,
    innerProps: objectSpread2_objectSpread2({}, getStyleProps(props, 'multiValueLabel', {
      'multi-value__label': true
    })),
    selectProps: selectProps
  }, children), jsx(Remove, {
    data: data,
    innerProps: objectSpread2_objectSpread2(objectSpread2_objectSpread2({}, getStyleProps(props, 'multiValueRemove', {
      'multi-value__remove': true
    })), {}, {
      'aria-label': "Remove ".concat(children || 'option')
    }, removeProps),
    selectProps: selectProps
  }));
};
var MultiValue$1 = MultiValue;

var optionCSS = function optionCSS(_ref, unstyled) {
  var isDisabled = _ref.isDisabled,
    isFocused = _ref.isFocused,
    isSelected = _ref.isSelected,
    _ref$theme = _ref.theme,
    spacing = _ref$theme.spacing,
    colors = _ref$theme.colors;
  return objectSpread2_objectSpread2({
    label: 'option',
    cursor: 'default',
    display: 'block',
    fontSize: 'inherit',
    width: '100%',
    userSelect: 'none',
    WebkitTapHighlightColor: 'rgba(0, 0, 0, 0)'
  }, unstyled ? {} : {
    backgroundColor: isSelected ? colors.primary : isFocused ? colors.primary25 : 'transparent',
    color: isDisabled ? colors.neutral20 : isSelected ? colors.neutral0 : 'inherit',
    padding: "".concat(spacing.baseUnit * 2, "px ").concat(spacing.baseUnit * 3, "px"),
    // provide some affordance on touch devices
    ':active': {
      backgroundColor: !isDisabled ? isSelected ? colors.primary : colors.primary50 : undefined
    }
  });
};
var Option = function Option(props) {
  var children = props.children,
    isDisabled = props.isDisabled,
    isFocused = props.isFocused,
    isSelected = props.isSelected,
    innerRef = props.innerRef,
    innerProps = props.innerProps;
  return jsx("div", extends_extends({}, getStyleProps(props, 'option', {
    option: true,
    'option--is-disabled': isDisabled,
    'option--is-focused': isFocused,
    'option--is-selected': isSelected
  }), {
    ref: innerRef,
    "aria-disabled": isDisabled
  }, innerProps), children);
};
var Option$1 = Option;

var placeholderCSS = function placeholderCSS(_ref, unstyled) {
  var _ref$theme = _ref.theme,
    spacing = _ref$theme.spacing,
    colors = _ref$theme.colors;
  return objectSpread2_objectSpread2({
    label: 'placeholder',
    gridArea: '1 / 1 / 2 / 3'
  }, unstyled ? {} : {
    color: colors.neutral50,
    marginLeft: spacing.baseUnit / 2,
    marginRight: spacing.baseUnit / 2
  });
};
var Placeholder = function Placeholder(props) {
  var children = props.children,
    innerProps = props.innerProps;
  return jsx("div", extends_extends({}, getStyleProps(props, 'placeholder', {
    placeholder: true
  }), innerProps), children);
};
var Placeholder$1 = Placeholder;

var index_a301f526_esm_css = function css(_ref, unstyled) {
  var isDisabled = _ref.isDisabled,
    _ref$theme = _ref.theme,
    spacing = _ref$theme.spacing,
    colors = _ref$theme.colors;
  return objectSpread2_objectSpread2({
    label: 'singleValue',
    gridArea: '1 / 1 / 2 / 3',
    maxWidth: '100%',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap'
  }, unstyled ? {} : {
    color: isDisabled ? colors.neutral40 : colors.neutral80,
    marginLeft: spacing.baseUnit / 2,
    marginRight: spacing.baseUnit / 2
  });
};
var SingleValue = function SingleValue(props) {
  var children = props.children,
    isDisabled = props.isDisabled,
    innerProps = props.innerProps;
  return jsx("div", extends_extends({}, getStyleProps(props, 'singleValue', {
    'single-value': true,
    'single-value--is-disabled': isDisabled
  }), innerProps), children);
};
var SingleValue$1 = SingleValue;

var components = {
  ClearIndicator: ClearIndicator,
  Control: Control$1,
  DropdownIndicator: DropdownIndicator,
  DownChevron: DownChevron,
  CrossIcon: CrossIcon,
  Group: Group$1,
  GroupHeading: GroupHeading,
  IndicatorsContainer: IndicatorsContainer,
  IndicatorSeparator: IndicatorSeparator,
  Input: Input$1,
  LoadingIndicator: LoadingIndicator,
  Menu: Menu$1,
  MenuList: MenuList,
  MenuPortal: MenuPortal,
  LoadingMessage: LoadingMessage,
  NoOptionsMessage: NoOptionsMessage,
  MultiValue: MultiValue$1,
  MultiValueContainer: MultiValueContainer,
  MultiValueLabel: MultiValueLabel,
  MultiValueRemove: MultiValueRemove,
  Option: Option$1,
  Placeholder: Placeholder$1,
  SelectContainer: SelectContainer,
  SingleValue: SingleValue$1,
  ValueContainer: ValueContainer
};
var defaultComponents = function defaultComponents(props) {
  return objectSpread2_objectSpread2(objectSpread2_objectSpread2({}, components), props.components);
};



;// CONCATENATED MODULE: ./node_modules/react-select/node_modules/memoize-one/dist/memoize-one.esm.js
var safeIsNaN = Number.isNaN ||
    function ponyfill(value) {
        return typeof value === 'number' && value !== value;
    };
function isEqual(first, second) {
    if (first === second) {
        return true;
    }
    if (safeIsNaN(first) && safeIsNaN(second)) {
        return true;
    }
    return false;
}
function areInputsEqual(newInputs, lastInputs) {
    if (newInputs.length !== lastInputs.length) {
        return false;
    }
    for (var i = 0; i < newInputs.length; i++) {
        if (!isEqual(newInputs[i], lastInputs[i])) {
            return false;
        }
    }
    return true;
}

function memoizeOne(resultFn, isEqual) {
    if (isEqual === void 0) { isEqual = areInputsEqual; }
    var cache = null;
    function memoized() {
        var newArgs = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            newArgs[_i] = arguments[_i];
        }
        if (cache && cache.lastThis === this && isEqual(newArgs, cache.lastArgs)) {
            return cache.lastResult;
        }
        var lastResult = resultFn.apply(this, newArgs);
        cache = {
            lastResult: lastResult,
            lastArgs: newArgs,
            lastThis: this,
        };
        return lastResult;
    }
    memoized.clear = function clear() {
        cache = null;
    };
    return memoized;
}



;// CONCATENATED MODULE: ./node_modules/react-select/dist/Select-49a62830.esm.js














function _EMOTION_STRINGIFIED_CSS_ERROR__$2() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }

// Assistive text to describe visual elements. Hidden for sighted users.
var _ref =  true ? {
  name: "7pg0cj-a11yText",
  styles: "label:a11yText;z-index:9999;border:0;clip:rect(1px, 1px, 1px, 1px);height:1px;width:1px;position:absolute;overflow:hidden;padding:0;white-space:nowrap"
} : 0;
var A11yText = function A11yText(props) {
  return jsx("span", extends_extends({
    css: _ref
  }, props));
};
var A11yText$1 = A11yText;

var defaultAriaLiveMessages = {
  guidance: function guidance(props) {
    var isSearchable = props.isSearchable,
      isMulti = props.isMulti,
      tabSelectsValue = props.tabSelectsValue,
      context = props.context,
      isInitialFocus = props.isInitialFocus;
    switch (context) {
      case 'menu':
        return "Use Up and Down to choose options, press Enter to select the currently focused option, press Escape to exit the menu".concat(tabSelectsValue ? ', press Tab to select the option and exit the menu' : '', ".");
      case 'input':
        return isInitialFocus ? "".concat(props['aria-label'] || 'Select', " is focused ").concat(isSearchable ? ',type to refine list' : '', ", press Down to open the menu, ").concat(isMulti ? ' press left to focus selected values' : '') : '';
      case 'value':
        return 'Use left and right to toggle between focused values, press Backspace to remove the currently focused value';
      default:
        return '';
    }
  },
  onChange: function onChange(props) {
    var action = props.action,
      _props$label = props.label,
      label = _props$label === void 0 ? '' : _props$label,
      labels = props.labels,
      isDisabled = props.isDisabled;
    switch (action) {
      case 'deselect-option':
      case 'pop-value':
      case 'remove-value':
        return "option ".concat(label, ", deselected.");
      case 'clear':
        return 'All selected options have been cleared.';
      case 'initial-input-focus':
        return "option".concat(labels.length > 1 ? 's' : '', " ").concat(labels.join(','), ", selected.");
      case 'select-option':
        return isDisabled ? "option ".concat(label, " is disabled. Select another option.") : "option ".concat(label, ", selected.");
      default:
        return '';
    }
  },
  onFocus: function onFocus(props) {
    var context = props.context,
      focused = props.focused,
      options = props.options,
      _props$label2 = props.label,
      label = _props$label2 === void 0 ? '' : _props$label2,
      selectValue = props.selectValue,
      isDisabled = props.isDisabled,
      isSelected = props.isSelected,
      isAppleDevice = props.isAppleDevice;
    var getArrayIndex = function getArrayIndex(arr, item) {
      return arr && arr.length ? "".concat(arr.indexOf(item) + 1, " of ").concat(arr.length) : '';
    };
    if (context === 'value' && selectValue) {
      return "value ".concat(label, " focused, ").concat(getArrayIndex(selectValue, focused), ".");
    }
    if (context === 'menu' && isAppleDevice) {
      var disabled = isDisabled ? ' disabled' : '';
      var status = "".concat(isSelected ? ' selected' : '').concat(disabled);
      return "".concat(label).concat(status, ", ").concat(getArrayIndex(options, focused), ".");
    }
    return '';
  },
  onFilter: function onFilter(props) {
    var inputValue = props.inputValue,
      resultsMessage = props.resultsMessage;
    return "".concat(resultsMessage).concat(inputValue ? ' for search term ' + inputValue : '', ".");
  }
};

var LiveRegion = function LiveRegion(props) {
  var ariaSelection = props.ariaSelection,
    focusedOption = props.focusedOption,
    focusedValue = props.focusedValue,
    focusableOptions = props.focusableOptions,
    isFocused = props.isFocused,
    selectValue = props.selectValue,
    selectProps = props.selectProps,
    id = props.id,
    isAppleDevice = props.isAppleDevice;
  var ariaLiveMessages = selectProps.ariaLiveMessages,
    getOptionLabel = selectProps.getOptionLabel,
    inputValue = selectProps.inputValue,
    isMulti = selectProps.isMulti,
    isOptionDisabled = selectProps.isOptionDisabled,
    isSearchable = selectProps.isSearchable,
    menuIsOpen = selectProps.menuIsOpen,
    options = selectProps.options,
    screenReaderStatus = selectProps.screenReaderStatus,
    tabSelectsValue = selectProps.tabSelectsValue,
    isLoading = selectProps.isLoading;
  var ariaLabel = selectProps['aria-label'];
  var ariaLive = selectProps['aria-live'];

  // Update aria live message configuration when prop changes
  var messages = (0,react.useMemo)(function () {
    return objectSpread2_objectSpread2(objectSpread2_objectSpread2({}, defaultAriaLiveMessages), ariaLiveMessages || {});
  }, [ariaLiveMessages]);

  // Update aria live selected option when prop changes
  var ariaSelected = (0,react.useMemo)(function () {
    var message = '';
    if (ariaSelection && messages.onChange) {
      var option = ariaSelection.option,
        selectedOptions = ariaSelection.options,
        removedValue = ariaSelection.removedValue,
        removedValues = ariaSelection.removedValues,
        value = ariaSelection.value;
      // select-option when !isMulti does not return option so we assume selected option is value
      var asOption = function asOption(val) {
        return !Array.isArray(val) ? val : null;
      };

      // If there is just one item from the action then get its label
      var selected = removedValue || option || asOption(value);
      var label = selected ? getOptionLabel(selected) : '';

      // If there are multiple items from the action then return an array of labels
      var multiSelected = selectedOptions || removedValues || undefined;
      var labels = multiSelected ? multiSelected.map(getOptionLabel) : [];
      var onChangeProps = objectSpread2_objectSpread2({
        // multiSelected items are usually items that have already been selected
        // or set by the user as a default value so we assume they are not disabled
        isDisabled: selected && isOptionDisabled(selected, selectValue),
        label: label,
        labels: labels
      }, ariaSelection);
      message = messages.onChange(onChangeProps);
    }
    return message;
  }, [ariaSelection, messages, isOptionDisabled, selectValue, getOptionLabel]);
  var ariaFocused = (0,react.useMemo)(function () {
    var focusMsg = '';
    var focused = focusedOption || focusedValue;
    var isSelected = !!(focusedOption && selectValue && selectValue.includes(focusedOption));
    if (focused && messages.onFocus) {
      var onFocusProps = {
        focused: focused,
        label: getOptionLabel(focused),
        isDisabled: isOptionDisabled(focused, selectValue),
        isSelected: isSelected,
        options: focusableOptions,
        context: focused === focusedOption ? 'menu' : 'value',
        selectValue: selectValue,
        isAppleDevice: isAppleDevice
      };
      focusMsg = messages.onFocus(onFocusProps);
    }
    return focusMsg;
  }, [focusedOption, focusedValue, getOptionLabel, isOptionDisabled, messages, focusableOptions, selectValue, isAppleDevice]);
  var ariaResults = (0,react.useMemo)(function () {
    var resultsMsg = '';
    if (menuIsOpen && options.length && !isLoading && messages.onFilter) {
      var resultsMessage = screenReaderStatus({
        count: focusableOptions.length
      });
      resultsMsg = messages.onFilter({
        inputValue: inputValue,
        resultsMessage: resultsMessage
      });
    }
    return resultsMsg;
  }, [focusableOptions, inputValue, menuIsOpen, messages, options, screenReaderStatus, isLoading]);
  var isInitialFocus = (ariaSelection === null || ariaSelection === void 0 ? void 0 : ariaSelection.action) === 'initial-input-focus';
  var ariaGuidance = (0,react.useMemo)(function () {
    var guidanceMsg = '';
    if (messages.guidance) {
      var context = focusedValue ? 'value' : menuIsOpen ? 'menu' : 'input';
      guidanceMsg = messages.guidance({
        'aria-label': ariaLabel,
        context: context,
        isDisabled: focusedOption && isOptionDisabled(focusedOption, selectValue),
        isMulti: isMulti,
        isSearchable: isSearchable,
        tabSelectsValue: tabSelectsValue,
        isInitialFocus: isInitialFocus
      });
    }
    return guidanceMsg;
  }, [ariaLabel, focusedOption, focusedValue, isMulti, isOptionDisabled, isSearchable, menuIsOpen, messages, selectValue, tabSelectsValue, isInitialFocus]);
  var ScreenReaderText = jsx(react.Fragment, null, jsx("span", {
    id: "aria-selection"
  }, ariaSelected), jsx("span", {
    id: "aria-focused"
  }, ariaFocused), jsx("span", {
    id: "aria-results"
  }, ariaResults), jsx("span", {
    id: "aria-guidance"
  }, ariaGuidance));
  return jsx(react.Fragment, null, jsx(A11yText$1, {
    id: id
  }, isInitialFocus && ScreenReaderText), jsx(A11yText$1, {
    "aria-live": ariaLive,
    "aria-atomic": "false",
    "aria-relevant": "additions text",
    role: "log"
  }, isFocused && !isInitialFocus && ScreenReaderText));
};
var LiveRegion$1 = LiveRegion;

var diacritics = [{
  base: 'A',
  letters: "A\u24B6\uFF21\xC0\xC1\xC2\u1EA6\u1EA4\u1EAA\u1EA8\xC3\u0100\u0102\u1EB0\u1EAE\u1EB4\u1EB2\u0226\u01E0\xC4\u01DE\u1EA2\xC5\u01FA\u01CD\u0200\u0202\u1EA0\u1EAC\u1EB6\u1E00\u0104\u023A\u2C6F"
}, {
  base: 'AA',
  letters: "\uA732"
}, {
  base: 'AE',
  letters: "\xC6\u01FC\u01E2"
}, {
  base: 'AO',
  letters: "\uA734"
}, {
  base: 'AU',
  letters: "\uA736"
}, {
  base: 'AV',
  letters: "\uA738\uA73A"
}, {
  base: 'AY',
  letters: "\uA73C"
}, {
  base: 'B',
  letters: "B\u24B7\uFF22\u1E02\u1E04\u1E06\u0243\u0182\u0181"
}, {
  base: 'C',
  letters: "C\u24B8\uFF23\u0106\u0108\u010A\u010C\xC7\u1E08\u0187\u023B\uA73E"
}, {
  base: 'D',
  letters: "D\u24B9\uFF24\u1E0A\u010E\u1E0C\u1E10\u1E12\u1E0E\u0110\u018B\u018A\u0189\uA779"
}, {
  base: 'DZ',
  letters: "\u01F1\u01C4"
}, {
  base: 'Dz',
  letters: "\u01F2\u01C5"
}, {
  base: 'E',
  letters: "E\u24BA\uFF25\xC8\xC9\xCA\u1EC0\u1EBE\u1EC4\u1EC2\u1EBC\u0112\u1E14\u1E16\u0114\u0116\xCB\u1EBA\u011A\u0204\u0206\u1EB8\u1EC6\u0228\u1E1C\u0118\u1E18\u1E1A\u0190\u018E"
}, {
  base: 'F',
  letters: "F\u24BB\uFF26\u1E1E\u0191\uA77B"
}, {
  base: 'G',
  letters: "G\u24BC\uFF27\u01F4\u011C\u1E20\u011E\u0120\u01E6\u0122\u01E4\u0193\uA7A0\uA77D\uA77E"
}, {
  base: 'H',
  letters: "H\u24BD\uFF28\u0124\u1E22\u1E26\u021E\u1E24\u1E28\u1E2A\u0126\u2C67\u2C75\uA78D"
}, {
  base: 'I',
  letters: "I\u24BE\uFF29\xCC\xCD\xCE\u0128\u012A\u012C\u0130\xCF\u1E2E\u1EC8\u01CF\u0208\u020A\u1ECA\u012E\u1E2C\u0197"
}, {
  base: 'J',
  letters: "J\u24BF\uFF2A\u0134\u0248"
}, {
  base: 'K',
  letters: "K\u24C0\uFF2B\u1E30\u01E8\u1E32\u0136\u1E34\u0198\u2C69\uA740\uA742\uA744\uA7A2"
}, {
  base: 'L',
  letters: "L\u24C1\uFF2C\u013F\u0139\u013D\u1E36\u1E38\u013B\u1E3C\u1E3A\u0141\u023D\u2C62\u2C60\uA748\uA746\uA780"
}, {
  base: 'LJ',
  letters: "\u01C7"
}, {
  base: 'Lj',
  letters: "\u01C8"
}, {
  base: 'M',
  letters: "M\u24C2\uFF2D\u1E3E\u1E40\u1E42\u2C6E\u019C"
}, {
  base: 'N',
  letters: "N\u24C3\uFF2E\u01F8\u0143\xD1\u1E44\u0147\u1E46\u0145\u1E4A\u1E48\u0220\u019D\uA790\uA7A4"
}, {
  base: 'NJ',
  letters: "\u01CA"
}, {
  base: 'Nj',
  letters: "\u01CB"
}, {
  base: 'O',
  letters: "O\u24C4\uFF2F\xD2\xD3\xD4\u1ED2\u1ED0\u1ED6\u1ED4\xD5\u1E4C\u022C\u1E4E\u014C\u1E50\u1E52\u014E\u022E\u0230\xD6\u022A\u1ECE\u0150\u01D1\u020C\u020E\u01A0\u1EDC\u1EDA\u1EE0\u1EDE\u1EE2\u1ECC\u1ED8\u01EA\u01EC\xD8\u01FE\u0186\u019F\uA74A\uA74C"
}, {
  base: 'OI',
  letters: "\u01A2"
}, {
  base: 'OO',
  letters: "\uA74E"
}, {
  base: 'OU',
  letters: "\u0222"
}, {
  base: 'P',
  letters: "P\u24C5\uFF30\u1E54\u1E56\u01A4\u2C63\uA750\uA752\uA754"
}, {
  base: 'Q',
  letters: "Q\u24C6\uFF31\uA756\uA758\u024A"
}, {
  base: 'R',
  letters: "R\u24C7\uFF32\u0154\u1E58\u0158\u0210\u0212\u1E5A\u1E5C\u0156\u1E5E\u024C\u2C64\uA75A\uA7A6\uA782"
}, {
  base: 'S',
  letters: "S\u24C8\uFF33\u1E9E\u015A\u1E64\u015C\u1E60\u0160\u1E66\u1E62\u1E68\u0218\u015E\u2C7E\uA7A8\uA784"
}, {
  base: 'T',
  letters: "T\u24C9\uFF34\u1E6A\u0164\u1E6C\u021A\u0162\u1E70\u1E6E\u0166\u01AC\u01AE\u023E\uA786"
}, {
  base: 'TZ',
  letters: "\uA728"
}, {
  base: 'U',
  letters: "U\u24CA\uFF35\xD9\xDA\xDB\u0168\u1E78\u016A\u1E7A\u016C\xDC\u01DB\u01D7\u01D5\u01D9\u1EE6\u016E\u0170\u01D3\u0214\u0216\u01AF\u1EEA\u1EE8\u1EEE\u1EEC\u1EF0\u1EE4\u1E72\u0172\u1E76\u1E74\u0244"
}, {
  base: 'V',
  letters: "V\u24CB\uFF36\u1E7C\u1E7E\u01B2\uA75E\u0245"
}, {
  base: 'VY',
  letters: "\uA760"
}, {
  base: 'W',
  letters: "W\u24CC\uFF37\u1E80\u1E82\u0174\u1E86\u1E84\u1E88\u2C72"
}, {
  base: 'X',
  letters: "X\u24CD\uFF38\u1E8A\u1E8C"
}, {
  base: 'Y',
  letters: "Y\u24CE\uFF39\u1EF2\xDD\u0176\u1EF8\u0232\u1E8E\u0178\u1EF6\u1EF4\u01B3\u024E\u1EFE"
}, {
  base: 'Z',
  letters: "Z\u24CF\uFF3A\u0179\u1E90\u017B\u017D\u1E92\u1E94\u01B5\u0224\u2C7F\u2C6B\uA762"
}, {
  base: 'a',
  letters: "a\u24D0\uFF41\u1E9A\xE0\xE1\xE2\u1EA7\u1EA5\u1EAB\u1EA9\xE3\u0101\u0103\u1EB1\u1EAF\u1EB5\u1EB3\u0227\u01E1\xE4\u01DF\u1EA3\xE5\u01FB\u01CE\u0201\u0203\u1EA1\u1EAD\u1EB7\u1E01\u0105\u2C65\u0250"
}, {
  base: 'aa',
  letters: "\uA733"
}, {
  base: 'ae',
  letters: "\xE6\u01FD\u01E3"
}, {
  base: 'ao',
  letters: "\uA735"
}, {
  base: 'au',
  letters: "\uA737"
}, {
  base: 'av',
  letters: "\uA739\uA73B"
}, {
  base: 'ay',
  letters: "\uA73D"
}, {
  base: 'b',
  letters: "b\u24D1\uFF42\u1E03\u1E05\u1E07\u0180\u0183\u0253"
}, {
  base: 'c',
  letters: "c\u24D2\uFF43\u0107\u0109\u010B\u010D\xE7\u1E09\u0188\u023C\uA73F\u2184"
}, {
  base: 'd',
  letters: "d\u24D3\uFF44\u1E0B\u010F\u1E0D\u1E11\u1E13\u1E0F\u0111\u018C\u0256\u0257\uA77A"
}, {
  base: 'dz',
  letters: "\u01F3\u01C6"
}, {
  base: 'e',
  letters: "e\u24D4\uFF45\xE8\xE9\xEA\u1EC1\u1EBF\u1EC5\u1EC3\u1EBD\u0113\u1E15\u1E17\u0115\u0117\xEB\u1EBB\u011B\u0205\u0207\u1EB9\u1EC7\u0229\u1E1D\u0119\u1E19\u1E1B\u0247\u025B\u01DD"
}, {
  base: 'f',
  letters: "f\u24D5\uFF46\u1E1F\u0192\uA77C"
}, {
  base: 'g',
  letters: "g\u24D6\uFF47\u01F5\u011D\u1E21\u011F\u0121\u01E7\u0123\u01E5\u0260\uA7A1\u1D79\uA77F"
}, {
  base: 'h',
  letters: "h\u24D7\uFF48\u0125\u1E23\u1E27\u021F\u1E25\u1E29\u1E2B\u1E96\u0127\u2C68\u2C76\u0265"
}, {
  base: 'hv',
  letters: "\u0195"
}, {
  base: 'i',
  letters: "i\u24D8\uFF49\xEC\xED\xEE\u0129\u012B\u012D\xEF\u1E2F\u1EC9\u01D0\u0209\u020B\u1ECB\u012F\u1E2D\u0268\u0131"
}, {
  base: 'j',
  letters: "j\u24D9\uFF4A\u0135\u01F0\u0249"
}, {
  base: 'k',
  letters: "k\u24DA\uFF4B\u1E31\u01E9\u1E33\u0137\u1E35\u0199\u2C6A\uA741\uA743\uA745\uA7A3"
}, {
  base: 'l',
  letters: "l\u24DB\uFF4C\u0140\u013A\u013E\u1E37\u1E39\u013C\u1E3D\u1E3B\u017F\u0142\u019A\u026B\u2C61\uA749\uA781\uA747"
}, {
  base: 'lj',
  letters: "\u01C9"
}, {
  base: 'm',
  letters: "m\u24DC\uFF4D\u1E3F\u1E41\u1E43\u0271\u026F"
}, {
  base: 'n',
  letters: "n\u24DD\uFF4E\u01F9\u0144\xF1\u1E45\u0148\u1E47\u0146\u1E4B\u1E49\u019E\u0272\u0149\uA791\uA7A5"
}, {
  base: 'nj',
  letters: "\u01CC"
}, {
  base: 'o',
  letters: "o\u24DE\uFF4F\xF2\xF3\xF4\u1ED3\u1ED1\u1ED7\u1ED5\xF5\u1E4D\u022D\u1E4F\u014D\u1E51\u1E53\u014F\u022F\u0231\xF6\u022B\u1ECF\u0151\u01D2\u020D\u020F\u01A1\u1EDD\u1EDB\u1EE1\u1EDF\u1EE3\u1ECD\u1ED9\u01EB\u01ED\xF8\u01FF\u0254\uA74B\uA74D\u0275"
}, {
  base: 'oi',
  letters: "\u01A3"
}, {
  base: 'ou',
  letters: "\u0223"
}, {
  base: 'oo',
  letters: "\uA74F"
}, {
  base: 'p',
  letters: "p\u24DF\uFF50\u1E55\u1E57\u01A5\u1D7D\uA751\uA753\uA755"
}, {
  base: 'q',
  letters: "q\u24E0\uFF51\u024B\uA757\uA759"
}, {
  base: 'r',
  letters: "r\u24E1\uFF52\u0155\u1E59\u0159\u0211\u0213\u1E5B\u1E5D\u0157\u1E5F\u024D\u027D\uA75B\uA7A7\uA783"
}, {
  base: 's',
  letters: "s\u24E2\uFF53\xDF\u015B\u1E65\u015D\u1E61\u0161\u1E67\u1E63\u1E69\u0219\u015F\u023F\uA7A9\uA785\u1E9B"
}, {
  base: 't',
  letters: "t\u24E3\uFF54\u1E6B\u1E97\u0165\u1E6D\u021B\u0163\u1E71\u1E6F\u0167\u01AD\u0288\u2C66\uA787"
}, {
  base: 'tz',
  letters: "\uA729"
}, {
  base: 'u',
  letters: "u\u24E4\uFF55\xF9\xFA\xFB\u0169\u1E79\u016B\u1E7B\u016D\xFC\u01DC\u01D8\u01D6\u01DA\u1EE7\u016F\u0171\u01D4\u0215\u0217\u01B0\u1EEB\u1EE9\u1EEF\u1EED\u1EF1\u1EE5\u1E73\u0173\u1E77\u1E75\u0289"
}, {
  base: 'v',
  letters: "v\u24E5\uFF56\u1E7D\u1E7F\u028B\uA75F\u028C"
}, {
  base: 'vy',
  letters: "\uA761"
}, {
  base: 'w',
  letters: "w\u24E6\uFF57\u1E81\u1E83\u0175\u1E87\u1E85\u1E98\u1E89\u2C73"
}, {
  base: 'x',
  letters: "x\u24E7\uFF58\u1E8B\u1E8D"
}, {
  base: 'y',
  letters: "y\u24E8\uFF59\u1EF3\xFD\u0177\u1EF9\u0233\u1E8F\xFF\u1EF7\u1E99\u1EF5\u01B4\u024F\u1EFF"
}, {
  base: 'z',
  letters: "z\u24E9\uFF5A\u017A\u1E91\u017C\u017E\u1E93\u1E95\u01B6\u0225\u0240\u2C6C\uA763"
}];
var anyDiacritic = new RegExp('[' + diacritics.map(function (d) {
  return d.letters;
}).join('') + ']', 'g');
var diacriticToBase = {};
for (var i = 0; i < diacritics.length; i++) {
  var diacritic = diacritics[i];
  for (var j = 0; j < diacritic.letters.length; j++) {
    diacriticToBase[diacritic.letters[j]] = diacritic.base;
  }
}
var stripDiacritics = function stripDiacritics(str) {
  return str.replace(anyDiacritic, function (match) {
    return diacriticToBase[match];
  });
};

var memoizedStripDiacriticsForInput = memoizeOne(stripDiacritics);
var trimString = function trimString(str) {
  return str.replace(/^\s+|\s+$/g, '');
};
var defaultStringify = function defaultStringify(option) {
  return "".concat(option.label, " ").concat(option.value);
};
var createFilter = function createFilter(config) {
  return function (option, rawInput) {
    // eslint-disable-next-line no-underscore-dangle
    if (option.data.__isNew__) return true;
    var _ignoreCase$ignoreAcc = objectSpread2_objectSpread2({
        ignoreCase: true,
        ignoreAccents: true,
        stringify: defaultStringify,
        trim: true,
        matchFrom: 'any'
      }, config),
      ignoreCase = _ignoreCase$ignoreAcc.ignoreCase,
      ignoreAccents = _ignoreCase$ignoreAcc.ignoreAccents,
      stringify = _ignoreCase$ignoreAcc.stringify,
      trim = _ignoreCase$ignoreAcc.trim,
      matchFrom = _ignoreCase$ignoreAcc.matchFrom;
    var input = trim ? trimString(rawInput) : rawInput;
    var candidate = trim ? trimString(stringify(option)) : stringify(option);
    if (ignoreCase) {
      input = input.toLowerCase();
      candidate = candidate.toLowerCase();
    }
    if (ignoreAccents) {
      input = memoizedStripDiacriticsForInput(input);
      candidate = stripDiacritics(candidate);
    }
    return matchFrom === 'start' ? candidate.substr(0, input.length) === input : candidate.indexOf(input) > -1;
  };
};

var Select_49a62830_esm_excluded = ["innerRef"];
function DummyInput(_ref) {
  var innerRef = _ref.innerRef,
    props = _objectWithoutProperties(_ref, Select_49a62830_esm_excluded);
  // Remove animation props not meant for HTML elements
  var filteredProps = removeProps(props, 'onExited', 'in', 'enter', 'exit', 'appear');
  return jsx("input", extends_extends({
    ref: innerRef
  }, filteredProps, {
    css: /*#__PURE__*/css({
      label: 'dummyInput',
      // get rid of any default styles
      background: 0,
      border: 0,
      // important! this hides the flashing cursor
      caretColor: 'transparent',
      fontSize: 'inherit',
      gridArea: '1 / 1 / 2 / 3',
      outline: 0,
      padding: 0,
      // important! without `width` browsers won't allow focus
      width: 1,
      // remove cursor on desktop
      color: 'transparent',
      // remove cursor on mobile whilst maintaining "scroll into view" behaviour
      left: -100,
      opacity: 0,
      position: 'relative',
      transform: 'scale(.01)'
    },  true ? "" : 0,  true ? "" : 0)
  }));
}

var cancelScroll = function cancelScroll(event) {
  if (event.cancelable) event.preventDefault();
  event.stopPropagation();
};
function useScrollCapture(_ref) {
  var isEnabled = _ref.isEnabled,
    onBottomArrive = _ref.onBottomArrive,
    onBottomLeave = _ref.onBottomLeave,
    onTopArrive = _ref.onTopArrive,
    onTopLeave = _ref.onTopLeave;
  var isBottom = (0,react.useRef)(false);
  var isTop = (0,react.useRef)(false);
  var touchStart = (0,react.useRef)(0);
  var scrollTarget = (0,react.useRef)(null);
  var handleEventDelta = (0,react.useCallback)(function (event, delta) {
    if (scrollTarget.current === null) return;
    var _scrollTarget$current = scrollTarget.current,
      scrollTop = _scrollTarget$current.scrollTop,
      scrollHeight = _scrollTarget$current.scrollHeight,
      clientHeight = _scrollTarget$current.clientHeight;
    var target = scrollTarget.current;
    var isDeltaPositive = delta > 0;
    var availableScroll = scrollHeight - clientHeight - scrollTop;
    var shouldCancelScroll = false;

    // reset bottom/top flags
    if (availableScroll > delta && isBottom.current) {
      if (onBottomLeave) onBottomLeave(event);
      isBottom.current = false;
    }
    if (isDeltaPositive && isTop.current) {
      if (onTopLeave) onTopLeave(event);
      isTop.current = false;
    }

    // bottom limit
    if (isDeltaPositive && delta > availableScroll) {
      if (onBottomArrive && !isBottom.current) {
        onBottomArrive(event);
      }
      target.scrollTop = scrollHeight;
      shouldCancelScroll = true;
      isBottom.current = true;

      // top limit
    } else if (!isDeltaPositive && -delta > scrollTop) {
      if (onTopArrive && !isTop.current) {
        onTopArrive(event);
      }
      target.scrollTop = 0;
      shouldCancelScroll = true;
      isTop.current = true;
    }

    // cancel scroll
    if (shouldCancelScroll) {
      cancelScroll(event);
    }
  }, [onBottomArrive, onBottomLeave, onTopArrive, onTopLeave]);
  var onWheel = (0,react.useCallback)(function (event) {
    handleEventDelta(event, event.deltaY);
  }, [handleEventDelta]);
  var onTouchStart = (0,react.useCallback)(function (event) {
    // set touch start so we can calculate touchmove delta
    touchStart.current = event.changedTouches[0].clientY;
  }, []);
  var onTouchMove = (0,react.useCallback)(function (event) {
    var deltaY = touchStart.current - event.changedTouches[0].clientY;
    handleEventDelta(event, deltaY);
  }, [handleEventDelta]);
  var startListening = (0,react.useCallback)(function (el) {
    // bail early if no element is available to attach to
    if (!el) return;
    var notPassive = supportsPassiveEvents ? {
      passive: false
    } : false;
    el.addEventListener('wheel', onWheel, notPassive);
    el.addEventListener('touchstart', onTouchStart, notPassive);
    el.addEventListener('touchmove', onTouchMove, notPassive);
  }, [onTouchMove, onTouchStart, onWheel]);
  var stopListening = (0,react.useCallback)(function (el) {
    // bail early if no element is available to detach from
    if (!el) return;
    el.removeEventListener('wheel', onWheel, false);
    el.removeEventListener('touchstart', onTouchStart, false);
    el.removeEventListener('touchmove', onTouchMove, false);
  }, [onTouchMove, onTouchStart, onWheel]);
  (0,react.useEffect)(function () {
    if (!isEnabled) return;
    var element = scrollTarget.current;
    startListening(element);
    return function () {
      stopListening(element);
    };
  }, [isEnabled, startListening, stopListening]);
  return function (element) {
    scrollTarget.current = element;
  };
}

var STYLE_KEYS = ['boxSizing', 'height', 'overflow', 'paddingRight', 'position'];
var LOCK_STYLES = {
  boxSizing: 'border-box',
  // account for possible declaration `width: 100%;` on body
  overflow: 'hidden',
  position: 'relative',
  height: '100%'
};
function preventTouchMove(e) {
  e.preventDefault();
}
function allowTouchMove(e) {
  e.stopPropagation();
}
function preventInertiaScroll() {
  var top = this.scrollTop;
  var totalScroll = this.scrollHeight;
  var currentScroll = top + this.offsetHeight;
  if (top === 0) {
    this.scrollTop = 1;
  } else if (currentScroll === totalScroll) {
    this.scrollTop = top - 1;
  }
}

// `ontouchstart` check works on most browsers
// `maxTouchPoints` works on IE10/11 and Surface
function isTouchDevice() {
  return 'ontouchstart' in window || navigator.maxTouchPoints;
}
var canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);
var activeScrollLocks = 0;
var listenerOptions = {
  capture: false,
  passive: false
};
function useScrollLock(_ref) {
  var isEnabled = _ref.isEnabled,
    _ref$accountForScroll = _ref.accountForScrollbars,
    accountForScrollbars = _ref$accountForScroll === void 0 ? true : _ref$accountForScroll;
  var originalStyles = (0,react.useRef)({});
  var scrollTarget = (0,react.useRef)(null);
  var addScrollLock = (0,react.useCallback)(function (touchScrollTarget) {
    if (!canUseDOM) return;
    var target = document.body;
    var targetStyle = target && target.style;
    if (accountForScrollbars) {
      // store any styles already applied to the body
      STYLE_KEYS.forEach(function (key) {
        var val = targetStyle && targetStyle[key];
        originalStyles.current[key] = val;
      });
    }

    // apply the lock styles and padding if this is the first scroll lock
    if (accountForScrollbars && activeScrollLocks < 1) {
      var currentPadding = parseInt(originalStyles.current.paddingRight, 10) || 0;
      var clientWidth = document.body ? document.body.clientWidth : 0;
      var adjustedPadding = window.innerWidth - clientWidth + currentPadding || 0;
      Object.keys(LOCK_STYLES).forEach(function (key) {
        var val = LOCK_STYLES[key];
        if (targetStyle) {
          targetStyle[key] = val;
        }
      });
      if (targetStyle) {
        targetStyle.paddingRight = "".concat(adjustedPadding, "px");
      }
    }

    // account for touch devices
    if (target && isTouchDevice()) {
      // Mobile Safari ignores { overflow: hidden } declaration on the body.
      target.addEventListener('touchmove', preventTouchMove, listenerOptions);

      // Allow scroll on provided target
      if (touchScrollTarget) {
        touchScrollTarget.addEventListener('touchstart', preventInertiaScroll, listenerOptions);
        touchScrollTarget.addEventListener('touchmove', allowTouchMove, listenerOptions);
      }
    }

    // increment active scroll locks
    activeScrollLocks += 1;
  }, [accountForScrollbars]);
  var removeScrollLock = (0,react.useCallback)(function (touchScrollTarget) {
    if (!canUseDOM) return;
    var target = document.body;
    var targetStyle = target && target.style;

    // safely decrement active scroll locks
    activeScrollLocks = Math.max(activeScrollLocks - 1, 0);

    // reapply original body styles, if any
    if (accountForScrollbars && activeScrollLocks < 1) {
      STYLE_KEYS.forEach(function (key) {
        var val = originalStyles.current[key];
        if (targetStyle) {
          targetStyle[key] = val;
        }
      });
    }

    // remove touch listeners
    if (target && isTouchDevice()) {
      target.removeEventListener('touchmove', preventTouchMove, listenerOptions);
      if (touchScrollTarget) {
        touchScrollTarget.removeEventListener('touchstart', preventInertiaScroll, listenerOptions);
        touchScrollTarget.removeEventListener('touchmove', allowTouchMove, listenerOptions);
      }
    }
  }, [accountForScrollbars]);
  (0,react.useEffect)(function () {
    if (!isEnabled) return;
    var element = scrollTarget.current;
    addScrollLock(element);
    return function () {
      removeScrollLock(element);
    };
  }, [isEnabled, addScrollLock, removeScrollLock]);
  return function (element) {
    scrollTarget.current = element;
  };
}

function _EMOTION_STRINGIFIED_CSS_ERROR__$1() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }
var blurSelectInput = function blurSelectInput(event) {
  var element = event.target;
  return element.ownerDocument.activeElement && element.ownerDocument.activeElement.blur();
};
var _ref2$1 =  true ? {
  name: "1kfdb0e",
  styles: "position:fixed;left:0;bottom:0;right:0;top:0"
} : 0;
function ScrollManager(_ref) {
  var children = _ref.children,
    lockEnabled = _ref.lockEnabled,
    _ref$captureEnabled = _ref.captureEnabled,
    captureEnabled = _ref$captureEnabled === void 0 ? true : _ref$captureEnabled,
    onBottomArrive = _ref.onBottomArrive,
    onBottomLeave = _ref.onBottomLeave,
    onTopArrive = _ref.onTopArrive,
    onTopLeave = _ref.onTopLeave;
  var setScrollCaptureTarget = useScrollCapture({
    isEnabled: captureEnabled,
    onBottomArrive: onBottomArrive,
    onBottomLeave: onBottomLeave,
    onTopArrive: onTopArrive,
    onTopLeave: onTopLeave
  });
  var setScrollLockTarget = useScrollLock({
    isEnabled: lockEnabled
  });
  var targetRef = function targetRef(element) {
    setScrollCaptureTarget(element);
    setScrollLockTarget(element);
  };
  return jsx(react.Fragment, null, lockEnabled && jsx("div", {
    onClick: blurSelectInput,
    css: _ref2$1
  }), children(targetRef));
}

function Select_49a62830_esm_EMOTION_STRINGIFIED_CSS_ERROR_() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }
var Select_49a62830_esm_ref2 =  true ? {
  name: "1a0ro4n-requiredInput",
  styles: "label:requiredInput;opacity:0;pointer-events:none;position:absolute;bottom:0;left:0;right:0;width:100%"
} : 0;
var RequiredInput = function RequiredInput(_ref) {
  var name = _ref.name,
    onFocus = _ref.onFocus;
  return jsx("input", {
    required: true,
    name: name,
    tabIndex: -1,
    "aria-hidden": "true",
    onFocus: onFocus,
    css: Select_49a62830_esm_ref2
    // Prevent `Switching from uncontrolled to controlled` error
    ,
    value: "",
    onChange: function onChange() {}
  });
};
var RequiredInput$1 = RequiredInput;

/// <reference types="user-agent-data-types" />

function testPlatform(re) {
  var _window$navigator$use;
  return typeof window !== 'undefined' && window.navigator != null ? re.test(((_window$navigator$use = window.navigator['userAgentData']) === null || _window$navigator$use === void 0 ? void 0 : _window$navigator$use.platform) || window.navigator.platform) : false;
}
function isIPhone() {
  return testPlatform(/^iPhone/i);
}
function isMac() {
  return testPlatform(/^Mac/i);
}
function isIPad() {
  return testPlatform(/^iPad/i) ||
  // iPadOS 13 lies and says it's a Mac, but we can distinguish by detecting touch support.
  isMac() && navigator.maxTouchPoints > 1;
}
function isIOS() {
  return isIPhone() || isIPad();
}
function isAppleDevice() {
  return isMac() || isIOS();
}

var formatGroupLabel = function formatGroupLabel(group) {
  return group.label;
};
var Select_49a62830_esm_getOptionLabel$1 = function getOptionLabel(option) {
  return option.label;
};
var Select_49a62830_esm_getOptionValue$1 = function getOptionValue(option) {
  return option.value;
};
var isOptionDisabled = function isOptionDisabled(option) {
  return !!option.isDisabled;
};

var defaultStyles = {
  clearIndicator: clearIndicatorCSS,
  container: containerCSS,
  control: css$1,
  dropdownIndicator: dropdownIndicatorCSS,
  group: groupCSS,
  groupHeading: groupHeadingCSS,
  indicatorsContainer: indicatorsContainerCSS,
  indicatorSeparator: indicatorSeparatorCSS,
  input: inputCSS,
  loadingIndicator: loadingIndicatorCSS,
  loadingMessage: loadingMessageCSS,
  menu: menuCSS,
  menuList: menuListCSS,
  menuPortal: menuPortalCSS,
  multiValue: multiValueCSS,
  multiValueLabel: multiValueLabelCSS,
  multiValueRemove: multiValueRemoveCSS,
  noOptionsMessage: noOptionsMessageCSS,
  option: optionCSS,
  placeholder: placeholderCSS,
  singleValue: index_a301f526_esm_css,
  valueContainer: valueContainerCSS
};
// Merge Utility
// Allows consumers to extend a base Select with additional styles

function mergeStyles(source) {
  var target = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  // initialize with source styles
  var styles = _objectSpread({}, source);

  // massage in target styles
  Object.keys(target).forEach(function (keyAsString) {
    var key = keyAsString;
    if (source[key]) {
      styles[key] = function (rsCss, props) {
        return target[key](source[key](rsCss, props), props);
      };
    } else {
      styles[key] = target[key];
    }
  });
  return styles;
}

var colors = {
  primary: '#2684FF',
  primary75: '#4C9AFF',
  primary50: '#B2D4FF',
  primary25: '#DEEBFF',
  danger: '#DE350B',
  dangerLight: '#FFBDAD',
  neutral0: 'hsl(0, 0%, 100%)',
  neutral5: 'hsl(0, 0%, 95%)',
  neutral10: 'hsl(0, 0%, 90%)',
  neutral20: 'hsl(0, 0%, 80%)',
  neutral30: 'hsl(0, 0%, 70%)',
  neutral40: 'hsl(0, 0%, 60%)',
  neutral50: 'hsl(0, 0%, 50%)',
  neutral60: 'hsl(0, 0%, 40%)',
  neutral70: 'hsl(0, 0%, 30%)',
  neutral80: 'hsl(0, 0%, 20%)',
  neutral90: 'hsl(0, 0%, 10%)'
};
var borderRadius = 4;
// Used to calculate consistent margin/padding on elements
var baseUnit = 4;
// The minimum height of the control
var controlHeight = 38;
// The amount of space between the control and menu */
var menuGutter = baseUnit * 2;
var spacing = {
  baseUnit: baseUnit,
  controlHeight: controlHeight,
  menuGutter: menuGutter
};
var defaultTheme = {
  borderRadius: borderRadius,
  colors: colors,
  spacing: spacing
};

var defaultProps = {
  'aria-live': 'polite',
  backspaceRemovesValue: true,
  blurInputOnSelect: isTouchCapable(),
  captureMenuScroll: !isTouchCapable(),
  classNames: {},
  closeMenuOnSelect: true,
  closeMenuOnScroll: false,
  components: {},
  controlShouldRenderValue: true,
  escapeClearsValue: false,
  filterOption: createFilter(),
  formatGroupLabel: formatGroupLabel,
  getOptionLabel: Select_49a62830_esm_getOptionLabel$1,
  getOptionValue: Select_49a62830_esm_getOptionValue$1,
  isDisabled: false,
  isLoading: false,
  isMulti: false,
  isRtl: false,
  isSearchable: true,
  isOptionDisabled: isOptionDisabled,
  loadingMessage: function loadingMessage() {
    return 'Loading...';
  },
  maxMenuHeight: 300,
  minMenuHeight: 140,
  menuIsOpen: false,
  menuPlacement: 'bottom',
  menuPosition: 'absolute',
  menuShouldBlockScroll: false,
  menuShouldScrollIntoView: !isMobileDevice(),
  noOptionsMessage: function noOptionsMessage() {
    return 'No options';
  },
  openMenuOnFocus: false,
  openMenuOnClick: true,
  options: [],
  pageSize: 5,
  placeholder: 'Select...',
  screenReaderStatus: function screenReaderStatus(_ref) {
    var count = _ref.count;
    return "".concat(count, " result").concat(count !== 1 ? 's' : '', " available");
  },
  styles: {},
  tabIndex: 0,
  tabSelectsValue: true,
  unstyled: false
};
function toCategorizedOption(props, option, selectValue, index) {
  var isDisabled = _isOptionDisabled(props, option, selectValue);
  var isSelected = _isOptionSelected(props, option, selectValue);
  var label = getOptionLabel(props, option);
  var value = getOptionValue(props, option);
  return {
    type: 'option',
    data: option,
    isDisabled: isDisabled,
    isSelected: isSelected,
    label: label,
    value: value,
    index: index
  };
}
function buildCategorizedOptions(props, selectValue) {
  return props.options.map(function (groupOrOption, groupOrOptionIndex) {
    if ('options' in groupOrOption) {
      var categorizedOptions = groupOrOption.options.map(function (option, optionIndex) {
        return toCategorizedOption(props, option, selectValue, optionIndex);
      }).filter(function (categorizedOption) {
        return isFocusable(props, categorizedOption);
      });
      return categorizedOptions.length > 0 ? {
        type: 'group',
        data: groupOrOption,
        options: categorizedOptions,
        index: groupOrOptionIndex
      } : undefined;
    }
    var categorizedOption = toCategorizedOption(props, groupOrOption, selectValue, groupOrOptionIndex);
    return isFocusable(props, categorizedOption) ? categorizedOption : undefined;
  }).filter(notNullish);
}
function buildFocusableOptionsFromCategorizedOptions(categorizedOptions) {
  return categorizedOptions.reduce(function (optionsAccumulator, categorizedOption) {
    if (categorizedOption.type === 'group') {
      optionsAccumulator.push.apply(optionsAccumulator, _toConsumableArray(categorizedOption.options.map(function (option) {
        return option.data;
      })));
    } else {
      optionsAccumulator.push(categorizedOption.data);
    }
    return optionsAccumulator;
  }, []);
}
function buildFocusableOptionsWithIds(categorizedOptions, optionId) {
  return categorizedOptions.reduce(function (optionsAccumulator, categorizedOption) {
    if (categorizedOption.type === 'group') {
      optionsAccumulator.push.apply(optionsAccumulator, _toConsumableArray(categorizedOption.options.map(function (option) {
        return {
          data: option.data,
          id: "".concat(optionId, "-").concat(categorizedOption.index, "-").concat(option.index)
        };
      })));
    } else {
      optionsAccumulator.push({
        data: categorizedOption.data,
        id: "".concat(optionId, "-").concat(categorizedOption.index)
      });
    }
    return optionsAccumulator;
  }, []);
}
function buildFocusableOptions(props, selectValue) {
  return buildFocusableOptionsFromCategorizedOptions(buildCategorizedOptions(props, selectValue));
}
function isFocusable(props, categorizedOption) {
  var _props$inputValue = props.inputValue,
    inputValue = _props$inputValue === void 0 ? '' : _props$inputValue;
  var data = categorizedOption.data,
    isSelected = categorizedOption.isSelected,
    label = categorizedOption.label,
    value = categorizedOption.value;
  return (!shouldHideSelectedOptions(props) || !isSelected) && _filterOption(props, {
    label: label,
    value: value,
    data: data
  }, inputValue);
}
function getNextFocusedValue(state, nextSelectValue) {
  var focusedValue = state.focusedValue,
    lastSelectValue = state.selectValue;
  var lastFocusedIndex = lastSelectValue.indexOf(focusedValue);
  if (lastFocusedIndex > -1) {
    var nextFocusedIndex = nextSelectValue.indexOf(focusedValue);
    if (nextFocusedIndex > -1) {
      // the focused value is still in the selectValue, return it
      return focusedValue;
    } else if (lastFocusedIndex < nextSelectValue.length) {
      // the focusedValue is not present in the next selectValue array by
      // reference, so return the new value at the same index
      return nextSelectValue[lastFocusedIndex];
    }
  }
  return null;
}
function getNextFocusedOption(state, options) {
  var lastFocusedOption = state.focusedOption;
  return lastFocusedOption && options.indexOf(lastFocusedOption) > -1 ? lastFocusedOption : options[0];
}
var getFocusedOptionId = function getFocusedOptionId(focusableOptionsWithIds, focusedOption) {
  var _focusableOptionsWith;
  var focusedOptionId = (_focusableOptionsWith = focusableOptionsWithIds.find(function (option) {
    return option.data === focusedOption;
  })) === null || _focusableOptionsWith === void 0 ? void 0 : _focusableOptionsWith.id;
  return focusedOptionId || null;
};
var getOptionLabel = function getOptionLabel(props, data) {
  return props.getOptionLabel(data);
};
var getOptionValue = function getOptionValue(props, data) {
  return props.getOptionValue(data);
};
function _isOptionDisabled(props, option, selectValue) {
  return typeof props.isOptionDisabled === 'function' ? props.isOptionDisabled(option, selectValue) : false;
}
function _isOptionSelected(props, option, selectValue) {
  if (selectValue.indexOf(option) > -1) return true;
  if (typeof props.isOptionSelected === 'function') {
    return props.isOptionSelected(option, selectValue);
  }
  var candidate = getOptionValue(props, option);
  return selectValue.some(function (i) {
    return getOptionValue(props, i) === candidate;
  });
}
function _filterOption(props, option, inputValue) {
  return props.filterOption ? props.filterOption(option, inputValue) : true;
}
var shouldHideSelectedOptions = function shouldHideSelectedOptions(props) {
  var hideSelectedOptions = props.hideSelectedOptions,
    isMulti = props.isMulti;
  if (hideSelectedOptions === undefined) return isMulti;
  return hideSelectedOptions;
};
var instanceId = 1;
var Select = /*#__PURE__*/function (_Component) {
  _inherits(Select, _Component);
  var _super = _createSuper(Select);
  // Misc. Instance Properties
  // ------------------------------

  // TODO

  // Refs
  // ------------------------------

  // Lifecycle
  // ------------------------------

  function Select(_props) {
    var _this;
    _classCallCheck(this, Select);
    _this = _super.call(this, _props);
    _this.state = {
      ariaSelection: null,
      focusedOption: null,
      focusedOptionId: null,
      focusableOptionsWithIds: [],
      focusedValue: null,
      inputIsHidden: false,
      isFocused: false,
      selectValue: [],
      clearFocusValueOnUpdate: false,
      prevWasFocused: false,
      inputIsHiddenAfterUpdate: undefined,
      prevProps: undefined,
      instancePrefix: ''
    };
    _this.blockOptionHover = false;
    _this.isComposing = false;
    _this.commonProps = void 0;
    _this.initialTouchX = 0;
    _this.initialTouchY = 0;
    _this.openAfterFocus = false;
    _this.scrollToFocusedOptionOnUpdate = false;
    _this.userIsDragging = void 0;
    _this.isAppleDevice = isAppleDevice();
    _this.controlRef = null;
    _this.getControlRef = function (ref) {
      _this.controlRef = ref;
    };
    _this.focusedOptionRef = null;
    _this.getFocusedOptionRef = function (ref) {
      _this.focusedOptionRef = ref;
    };
    _this.menuListRef = null;
    _this.getMenuListRef = function (ref) {
      _this.menuListRef = ref;
    };
    _this.inputRef = null;
    _this.getInputRef = function (ref) {
      _this.inputRef = ref;
    };
    _this.focus = _this.focusInput;
    _this.blur = _this.blurInput;
    _this.onChange = function (newValue, actionMeta) {
      var _this$props = _this.props,
        onChange = _this$props.onChange,
        name = _this$props.name;
      actionMeta.name = name;
      _this.ariaOnChange(newValue, actionMeta);
      onChange(newValue, actionMeta);
    };
    _this.setValue = function (newValue, action, option) {
      var _this$props2 = _this.props,
        closeMenuOnSelect = _this$props2.closeMenuOnSelect,
        isMulti = _this$props2.isMulti,
        inputValue = _this$props2.inputValue;
      _this.onInputChange('', {
        action: 'set-value',
        prevInputValue: inputValue
      });
      if (closeMenuOnSelect) {
        _this.setState({
          inputIsHiddenAfterUpdate: !isMulti
        });
        _this.onMenuClose();
      }
      // when the select value should change, we should reset focusedValue
      _this.setState({
        clearFocusValueOnUpdate: true
      });
      _this.onChange(newValue, {
        action: action,
        option: option
      });
    };
    _this.selectOption = function (newValue) {
      var _this$props3 = _this.props,
        blurInputOnSelect = _this$props3.blurInputOnSelect,
        isMulti = _this$props3.isMulti,
        name = _this$props3.name;
      var selectValue = _this.state.selectValue;
      var deselected = isMulti && _this.isOptionSelected(newValue, selectValue);
      var isDisabled = _this.isOptionDisabled(newValue, selectValue);
      if (deselected) {
        var candidate = _this.getOptionValue(newValue);
        _this.setValue(multiValueAsValue(selectValue.filter(function (i) {
          return _this.getOptionValue(i) !== candidate;
        })), 'deselect-option', newValue);
      } else if (!isDisabled) {
        // Select option if option is not disabled
        if (isMulti) {
          _this.setValue(multiValueAsValue([].concat(_toConsumableArray(selectValue), [newValue])), 'select-option', newValue);
        } else {
          _this.setValue(singleValueAsValue(newValue), 'select-option');
        }
      } else {
        _this.ariaOnChange(singleValueAsValue(newValue), {
          action: 'select-option',
          option: newValue,
          name: name
        });
        return;
      }
      if (blurInputOnSelect) {
        _this.blurInput();
      }
    };
    _this.removeValue = function (removedValue) {
      var isMulti = _this.props.isMulti;
      var selectValue = _this.state.selectValue;
      var candidate = _this.getOptionValue(removedValue);
      var newValueArray = selectValue.filter(function (i) {
        return _this.getOptionValue(i) !== candidate;
      });
      var newValue = valueTernary(isMulti, newValueArray, newValueArray[0] || null);
      _this.onChange(newValue, {
        action: 'remove-value',
        removedValue: removedValue
      });
      _this.focusInput();
    };
    _this.clearValue = function () {
      var selectValue = _this.state.selectValue;
      _this.onChange(valueTernary(_this.props.isMulti, [], null), {
        action: 'clear',
        removedValues: selectValue
      });
    };
    _this.popValue = function () {
      var isMulti = _this.props.isMulti;
      var selectValue = _this.state.selectValue;
      var lastSelectedValue = selectValue[selectValue.length - 1];
      var newValueArray = selectValue.slice(0, selectValue.length - 1);
      var newValue = valueTernary(isMulti, newValueArray, newValueArray[0] || null);
      _this.onChange(newValue, {
        action: 'pop-value',
        removedValue: lastSelectedValue
      });
    };
    _this.getFocusedOptionId = function (focusedOption) {
      return getFocusedOptionId(_this.state.focusableOptionsWithIds, focusedOption);
    };
    _this.getFocusableOptionsWithIds = function () {
      return buildFocusableOptionsWithIds(buildCategorizedOptions(_this.props, _this.state.selectValue), _this.getElementId('option'));
    };
    _this.getValue = function () {
      return _this.state.selectValue;
    };
    _this.cx = function () {
      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }
      return classNames.apply(void 0, [_this.props.classNamePrefix].concat(args));
    };
    _this.getOptionLabel = function (data) {
      return getOptionLabel(_this.props, data);
    };
    _this.getOptionValue = function (data) {
      return getOptionValue(_this.props, data);
    };
    _this.getStyles = function (key, props) {
      var unstyled = _this.props.unstyled;
      var base = defaultStyles[key](props, unstyled);
      base.boxSizing = 'border-box';
      var custom = _this.props.styles[key];
      return custom ? custom(base, props) : base;
    };
    _this.getClassNames = function (key, props) {
      var _this$props$className, _this$props$className2;
      return (_this$props$className = (_this$props$className2 = _this.props.classNames)[key]) === null || _this$props$className === void 0 ? void 0 : _this$props$className.call(_this$props$className2, props);
    };
    _this.getElementId = function (element) {
      return "".concat(_this.state.instancePrefix, "-").concat(element);
    };
    _this.getComponents = function () {
      return defaultComponents(_this.props);
    };
    _this.buildCategorizedOptions = function () {
      return buildCategorizedOptions(_this.props, _this.state.selectValue);
    };
    _this.getCategorizedOptions = function () {
      return _this.props.menuIsOpen ? _this.buildCategorizedOptions() : [];
    };
    _this.buildFocusableOptions = function () {
      return buildFocusableOptionsFromCategorizedOptions(_this.buildCategorizedOptions());
    };
    _this.getFocusableOptions = function () {
      return _this.props.menuIsOpen ? _this.buildFocusableOptions() : [];
    };
    _this.ariaOnChange = function (value, actionMeta) {
      _this.setState({
        ariaSelection: objectSpread2_objectSpread2({
          value: value
        }, actionMeta)
      });
    };
    _this.onMenuMouseDown = function (event) {
      if (event.button !== 0) {
        return;
      }
      event.stopPropagation();
      event.preventDefault();
      _this.focusInput();
    };
    _this.onMenuMouseMove = function (event) {
      _this.blockOptionHover = false;
    };
    _this.onControlMouseDown = function (event) {
      // Event captured by dropdown indicator
      if (event.defaultPrevented) {
        return;
      }
      var openMenuOnClick = _this.props.openMenuOnClick;
      if (!_this.state.isFocused) {
        if (openMenuOnClick) {
          _this.openAfterFocus = true;
        }
        _this.focusInput();
      } else if (!_this.props.menuIsOpen) {
        if (openMenuOnClick) {
          _this.openMenu('first');
        }
      } else {
        if (event.target.tagName !== 'INPUT' && event.target.tagName !== 'TEXTAREA') {
          _this.onMenuClose();
        }
      }
      if (event.target.tagName !== 'INPUT' && event.target.tagName !== 'TEXTAREA') {
        event.preventDefault();
      }
    };
    _this.onDropdownIndicatorMouseDown = function (event) {
      // ignore mouse events that weren't triggered by the primary button
      if (event && event.type === 'mousedown' && event.button !== 0) {
        return;
      }
      if (_this.props.isDisabled) return;
      var _this$props4 = _this.props,
        isMulti = _this$props4.isMulti,
        menuIsOpen = _this$props4.menuIsOpen;
      _this.focusInput();
      if (menuIsOpen) {
        _this.setState({
          inputIsHiddenAfterUpdate: !isMulti
        });
        _this.onMenuClose();
      } else {
        _this.openMenu('first');
      }
      event.preventDefault();
    };
    _this.onClearIndicatorMouseDown = function (event) {
      // ignore mouse events that weren't triggered by the primary button
      if (event && event.type === 'mousedown' && event.button !== 0) {
        return;
      }
      _this.clearValue();
      event.preventDefault();
      _this.openAfterFocus = false;
      if (event.type === 'touchend') {
        _this.focusInput();
      } else {
        setTimeout(function () {
          return _this.focusInput();
        });
      }
    };
    _this.onScroll = function (event) {
      if (typeof _this.props.closeMenuOnScroll === 'boolean') {
        if (event.target instanceof HTMLElement && isDocumentElement(event.target)) {
          _this.props.onMenuClose();
        }
      } else if (typeof _this.props.closeMenuOnScroll === 'function') {
        if (_this.props.closeMenuOnScroll(event)) {
          _this.props.onMenuClose();
        }
      }
    };
    _this.onCompositionStart = function () {
      _this.isComposing = true;
    };
    _this.onCompositionEnd = function () {
      _this.isComposing = false;
    };
    _this.onTouchStart = function (_ref2) {
      var touches = _ref2.touches;
      var touch = touches && touches.item(0);
      if (!touch) {
        return;
      }
      _this.initialTouchX = touch.clientX;
      _this.initialTouchY = touch.clientY;
      _this.userIsDragging = false;
    };
    _this.onTouchMove = function (_ref3) {
      var touches = _ref3.touches;
      var touch = touches && touches.item(0);
      if (!touch) {
        return;
      }
      var deltaX = Math.abs(touch.clientX - _this.initialTouchX);
      var deltaY = Math.abs(touch.clientY - _this.initialTouchY);
      var moveThreshold = 5;
      _this.userIsDragging = deltaX > moveThreshold || deltaY > moveThreshold;
    };
    _this.onTouchEnd = function (event) {
      if (_this.userIsDragging) return;

      // close the menu if the user taps outside
      // we're checking on event.target here instead of event.currentTarget, because we want to assert information
      // on events on child elements, not the document (which we've attached this handler to).
      if (_this.controlRef && !_this.controlRef.contains(event.target) && _this.menuListRef && !_this.menuListRef.contains(event.target)) {
        _this.blurInput();
      }

      // reset move vars
      _this.initialTouchX = 0;
      _this.initialTouchY = 0;
    };
    _this.onControlTouchEnd = function (event) {
      if (_this.userIsDragging) return;
      _this.onControlMouseDown(event);
    };
    _this.onClearIndicatorTouchEnd = function (event) {
      if (_this.userIsDragging) return;
      _this.onClearIndicatorMouseDown(event);
    };
    _this.onDropdownIndicatorTouchEnd = function (event) {
      if (_this.userIsDragging) return;
      _this.onDropdownIndicatorMouseDown(event);
    };
    _this.handleInputChange = function (event) {
      var prevInputValue = _this.props.inputValue;
      var inputValue = event.currentTarget.value;
      _this.setState({
        inputIsHiddenAfterUpdate: false
      });
      _this.onInputChange(inputValue, {
        action: 'input-change',
        prevInputValue: prevInputValue
      });
      if (!_this.props.menuIsOpen) {
        _this.onMenuOpen();
      }
    };
    _this.onInputFocus = function (event) {
      if (_this.props.onFocus) {
        _this.props.onFocus(event);
      }
      _this.setState({
        inputIsHiddenAfterUpdate: false,
        isFocused: true
      });
      if (_this.openAfterFocus || _this.props.openMenuOnFocus) {
        _this.openMenu('first');
      }
      _this.openAfterFocus = false;
    };
    _this.onInputBlur = function (event) {
      var prevInputValue = _this.props.inputValue;
      if (_this.menuListRef && _this.menuListRef.contains(document.activeElement)) {
        _this.inputRef.focus();
        return;
      }
      if (_this.props.onBlur) {
        _this.props.onBlur(event);
      }
      _this.onInputChange('', {
        action: 'input-blur',
        prevInputValue: prevInputValue
      });
      _this.onMenuClose();
      _this.setState({
        focusedValue: null,
        isFocused: false
      });
    };
    _this.onOptionHover = function (focusedOption) {
      if (_this.blockOptionHover || _this.state.focusedOption === focusedOption) {
        return;
      }
      var options = _this.getFocusableOptions();
      var focusedOptionIndex = options.indexOf(focusedOption);
      _this.setState({
        focusedOption: focusedOption,
        focusedOptionId: focusedOptionIndex > -1 ? _this.getFocusedOptionId(focusedOption) : null
      });
    };
    _this.shouldHideSelectedOptions = function () {
      return shouldHideSelectedOptions(_this.props);
    };
    _this.onValueInputFocus = function (e) {
      e.preventDefault();
      e.stopPropagation();
      _this.focus();
    };
    _this.onKeyDown = function (event) {
      var _this$props5 = _this.props,
        isMulti = _this$props5.isMulti,
        backspaceRemovesValue = _this$props5.backspaceRemovesValue,
        escapeClearsValue = _this$props5.escapeClearsValue,
        inputValue = _this$props5.inputValue,
        isClearable = _this$props5.isClearable,
        isDisabled = _this$props5.isDisabled,
        menuIsOpen = _this$props5.menuIsOpen,
        onKeyDown = _this$props5.onKeyDown,
        tabSelectsValue = _this$props5.tabSelectsValue,
        openMenuOnFocus = _this$props5.openMenuOnFocus;
      var _this$state = _this.state,
        focusedOption = _this$state.focusedOption,
        focusedValue = _this$state.focusedValue,
        selectValue = _this$state.selectValue;
      if (isDisabled) return;
      if (typeof onKeyDown === 'function') {
        onKeyDown(event);
        if (event.defaultPrevented) {
          return;
        }
      }

      // Block option hover events when the user has just pressed a key
      _this.blockOptionHover = true;
      switch (event.key) {
        case 'ArrowLeft':
          if (!isMulti || inputValue) return;
          _this.focusValue('previous');
          break;
        case 'ArrowRight':
          if (!isMulti || inputValue) return;
          _this.focusValue('next');
          break;
        case 'Delete':
        case 'Backspace':
          if (inputValue) return;
          if (focusedValue) {
            _this.removeValue(focusedValue);
          } else {
            if (!backspaceRemovesValue) return;
            if (isMulti) {
              _this.popValue();
            } else if (isClearable) {
              _this.clearValue();
            }
          }
          break;
        case 'Tab':
          if (_this.isComposing) return;
          if (event.shiftKey || !menuIsOpen || !tabSelectsValue || !focusedOption ||
          // don't capture the event if the menu opens on focus and the focused
          // option is already selected; it breaks the flow of navigation
          openMenuOnFocus && _this.isOptionSelected(focusedOption, selectValue)) {
            return;
          }
          _this.selectOption(focusedOption);
          break;
        case 'Enter':
          if (event.keyCode === 229) {
            // ignore the keydown event from an Input Method Editor(IME)
            // ref. https://www.w3.org/TR/uievents/#determine-keydown-keyup-keyCode
            break;
          }
          if (menuIsOpen) {
            if (!focusedOption) return;
            if (_this.isComposing) return;
            _this.selectOption(focusedOption);
            break;
          }
          return;
        case 'Escape':
          if (menuIsOpen) {
            _this.setState({
              inputIsHiddenAfterUpdate: false
            });
            _this.onInputChange('', {
              action: 'menu-close',
              prevInputValue: inputValue
            });
            _this.onMenuClose();
          } else if (isClearable && escapeClearsValue) {
            _this.clearValue();
          }
          break;
        case ' ':
          // space
          if (inputValue) {
            return;
          }
          if (!menuIsOpen) {
            _this.openMenu('first');
            break;
          }
          if (!focusedOption) return;
          _this.selectOption(focusedOption);
          break;
        case 'ArrowUp':
          if (menuIsOpen) {
            _this.focusOption('up');
          } else {
            _this.openMenu('last');
          }
          break;
        case 'ArrowDown':
          if (menuIsOpen) {
            _this.focusOption('down');
          } else {
            _this.openMenu('first');
          }
          break;
        case 'PageUp':
          if (!menuIsOpen) return;
          _this.focusOption('pageup');
          break;
        case 'PageDown':
          if (!menuIsOpen) return;
          _this.focusOption('pagedown');
          break;
        case 'Home':
          if (!menuIsOpen) return;
          _this.focusOption('first');
          break;
        case 'End':
          if (!menuIsOpen) return;
          _this.focusOption('last');
          break;
        default:
          return;
      }
      event.preventDefault();
    };
    _this.state.instancePrefix = 'react-select-' + (_this.props.instanceId || ++instanceId);
    _this.state.selectValue = cleanValue(_props.value);
    // Set focusedOption if menuIsOpen is set on init (e.g. defaultMenuIsOpen)
    if (_props.menuIsOpen && _this.state.selectValue.length) {
      var focusableOptionsWithIds = _this.getFocusableOptionsWithIds();
      var focusableOptions = _this.buildFocusableOptions();
      var optionIndex = focusableOptions.indexOf(_this.state.selectValue[0]);
      _this.state.focusableOptionsWithIds = focusableOptionsWithIds;
      _this.state.focusedOption = focusableOptions[optionIndex];
      _this.state.focusedOptionId = getFocusedOptionId(focusableOptionsWithIds, focusableOptions[optionIndex]);
    }
    return _this;
  }
  _createClass(Select, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.startListeningComposition();
      this.startListeningToTouch();
      if (this.props.closeMenuOnScroll && document && document.addEventListener) {
        // Listen to all scroll events, and filter them out inside of 'onScroll'
        document.addEventListener('scroll', this.onScroll, true);
      }
      if (this.props.autoFocus) {
        this.focusInput();
      }

      // Scroll focusedOption into view if menuIsOpen is set on mount (e.g. defaultMenuIsOpen)
      if (this.props.menuIsOpen && this.state.focusedOption && this.menuListRef && this.focusedOptionRef) {
        scrollIntoView(this.menuListRef, this.focusedOptionRef);
      }
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      var _this$props6 = this.props,
        isDisabled = _this$props6.isDisabled,
        menuIsOpen = _this$props6.menuIsOpen;
      var isFocused = this.state.isFocused;
      if (
      // ensure focus is restored correctly when the control becomes enabled
      isFocused && !isDisabled && prevProps.isDisabled ||
      // ensure focus is on the Input when the menu opens
      isFocused && menuIsOpen && !prevProps.menuIsOpen) {
        this.focusInput();
      }
      if (isFocused && isDisabled && !prevProps.isDisabled) {
        // ensure select state gets blurred in case Select is programmatically disabled while focused
        // eslint-disable-next-line react/no-did-update-set-state
        this.setState({
          isFocused: false
        }, this.onMenuClose);
      } else if (!isFocused && !isDisabled && prevProps.isDisabled && this.inputRef === document.activeElement) {
        // ensure select state gets focused in case Select is programatically re-enabled while focused (Firefox)
        // eslint-disable-next-line react/no-did-update-set-state
        this.setState({
          isFocused: true
        });
      }

      // scroll the focused option into view if necessary
      if (this.menuListRef && this.focusedOptionRef && this.scrollToFocusedOptionOnUpdate) {
        scrollIntoView(this.menuListRef, this.focusedOptionRef);
        this.scrollToFocusedOptionOnUpdate = false;
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.stopListeningComposition();
      this.stopListeningToTouch();
      document.removeEventListener('scroll', this.onScroll, true);
    }

    // ==============================
    // Consumer Handlers
    // ==============================
  }, {
    key: "onMenuOpen",
    value: function onMenuOpen() {
      this.props.onMenuOpen();
    }
  }, {
    key: "onMenuClose",
    value: function onMenuClose() {
      this.onInputChange('', {
        action: 'menu-close',
        prevInputValue: this.props.inputValue
      });
      this.props.onMenuClose();
    }
  }, {
    key: "onInputChange",
    value: function onInputChange(newValue, actionMeta) {
      this.props.onInputChange(newValue, actionMeta);
    }

    // ==============================
    // Methods
    // ==============================
  }, {
    key: "focusInput",
    value: function focusInput() {
      if (!this.inputRef) return;
      this.inputRef.focus();
    }
  }, {
    key: "blurInput",
    value: function blurInput() {
      if (!this.inputRef) return;
      this.inputRef.blur();
    }

    // aliased for consumers
  }, {
    key: "openMenu",
    value: function openMenu(focusOption) {
      var _this2 = this;
      var _this$state2 = this.state,
        selectValue = _this$state2.selectValue,
        isFocused = _this$state2.isFocused;
      var focusableOptions = this.buildFocusableOptions();
      var openAtIndex = focusOption === 'first' ? 0 : focusableOptions.length - 1;
      if (!this.props.isMulti) {
        var selectedIndex = focusableOptions.indexOf(selectValue[0]);
        if (selectedIndex > -1) {
          openAtIndex = selectedIndex;
        }
      }

      // only scroll if the menu isn't already open
      this.scrollToFocusedOptionOnUpdate = !(isFocused && this.menuListRef);
      this.setState({
        inputIsHiddenAfterUpdate: false,
        focusedValue: null,
        focusedOption: focusableOptions[openAtIndex],
        focusedOptionId: this.getFocusedOptionId(focusableOptions[openAtIndex])
      }, function () {
        return _this2.onMenuOpen();
      });
    }
  }, {
    key: "focusValue",
    value: function focusValue(direction) {
      var _this$state3 = this.state,
        selectValue = _this$state3.selectValue,
        focusedValue = _this$state3.focusedValue;

      // Only multiselects support value focusing
      if (!this.props.isMulti) return;
      this.setState({
        focusedOption: null
      });
      var focusedIndex = selectValue.indexOf(focusedValue);
      if (!focusedValue) {
        focusedIndex = -1;
      }
      var lastIndex = selectValue.length - 1;
      var nextFocus = -1;
      if (!selectValue.length) return;
      switch (direction) {
        case 'previous':
          if (focusedIndex === 0) {
            // don't cycle from the start to the end
            nextFocus = 0;
          } else if (focusedIndex === -1) {
            // if nothing is focused, focus the last value first
            nextFocus = lastIndex;
          } else {
            nextFocus = focusedIndex - 1;
          }
          break;
        case 'next':
          if (focusedIndex > -1 && focusedIndex < lastIndex) {
            nextFocus = focusedIndex + 1;
          }
          break;
      }
      this.setState({
        inputIsHidden: nextFocus !== -1,
        focusedValue: selectValue[nextFocus]
      });
    }
  }, {
    key: "focusOption",
    value: function focusOption() {
      var direction = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'first';
      var pageSize = this.props.pageSize;
      var focusedOption = this.state.focusedOption;
      var options = this.getFocusableOptions();
      if (!options.length) return;
      var nextFocus = 0; // handles 'first'
      var focusedIndex = options.indexOf(focusedOption);
      if (!focusedOption) {
        focusedIndex = -1;
      }
      if (direction === 'up') {
        nextFocus = focusedIndex > 0 ? focusedIndex - 1 : options.length - 1;
      } else if (direction === 'down') {
        nextFocus = (focusedIndex + 1) % options.length;
      } else if (direction === 'pageup') {
        nextFocus = focusedIndex - pageSize;
        if (nextFocus < 0) nextFocus = 0;
      } else if (direction === 'pagedown') {
        nextFocus = focusedIndex + pageSize;
        if (nextFocus > options.length - 1) nextFocus = options.length - 1;
      } else if (direction === 'last') {
        nextFocus = options.length - 1;
      }
      this.scrollToFocusedOptionOnUpdate = true;
      this.setState({
        focusedOption: options[nextFocus],
        focusedValue: null,
        focusedOptionId: this.getFocusedOptionId(options[nextFocus])
      });
    }
  }, {
    key: "getTheme",
    value:
    // ==============================
    // Getters
    // ==============================

    function getTheme() {
      // Use the default theme if there are no customisations.
      if (!this.props.theme) {
        return defaultTheme;
      }
      // If the theme prop is a function, assume the function
      // knows how to merge the passed-in default theme with
      // its own modifications.
      if (typeof this.props.theme === 'function') {
        return this.props.theme(defaultTheme);
      }
      // Otherwise, if a plain theme object was passed in,
      // overlay it with the default theme.
      return objectSpread2_objectSpread2(objectSpread2_objectSpread2({}, defaultTheme), this.props.theme);
    }
  }, {
    key: "getCommonProps",
    value: function getCommonProps() {
      var clearValue = this.clearValue,
        cx = this.cx,
        getStyles = this.getStyles,
        getClassNames = this.getClassNames,
        getValue = this.getValue,
        selectOption = this.selectOption,
        setValue = this.setValue,
        props = this.props;
      var isMulti = props.isMulti,
        isRtl = props.isRtl,
        options = props.options;
      var hasValue = this.hasValue();
      return {
        clearValue: clearValue,
        cx: cx,
        getStyles: getStyles,
        getClassNames: getClassNames,
        getValue: getValue,
        hasValue: hasValue,
        isMulti: isMulti,
        isRtl: isRtl,
        options: options,
        selectOption: selectOption,
        selectProps: props,
        setValue: setValue,
        theme: this.getTheme()
      };
    }
  }, {
    key: "hasValue",
    value: function hasValue() {
      var selectValue = this.state.selectValue;
      return selectValue.length > 0;
    }
  }, {
    key: "hasOptions",
    value: function hasOptions() {
      return !!this.getFocusableOptions().length;
    }
  }, {
    key: "isClearable",
    value: function isClearable() {
      var _this$props7 = this.props,
        isClearable = _this$props7.isClearable,
        isMulti = _this$props7.isMulti;

      // single select, by default, IS NOT clearable
      // multi select, by default, IS clearable
      if (isClearable === undefined) return isMulti;
      return isClearable;
    }
  }, {
    key: "isOptionDisabled",
    value: function isOptionDisabled(option, selectValue) {
      return _isOptionDisabled(this.props, option, selectValue);
    }
  }, {
    key: "isOptionSelected",
    value: function isOptionSelected(option, selectValue) {
      return _isOptionSelected(this.props, option, selectValue);
    }
  }, {
    key: "filterOption",
    value: function filterOption(option, inputValue) {
      return _filterOption(this.props, option, inputValue);
    }
  }, {
    key: "formatOptionLabel",
    value: function formatOptionLabel(data, context) {
      if (typeof this.props.formatOptionLabel === 'function') {
        var _inputValue = this.props.inputValue;
        var _selectValue = this.state.selectValue;
        return this.props.formatOptionLabel(data, {
          context: context,
          inputValue: _inputValue,
          selectValue: _selectValue
        });
      } else {
        return this.getOptionLabel(data);
      }
    }
  }, {
    key: "formatGroupLabel",
    value: function formatGroupLabel(data) {
      return this.props.formatGroupLabel(data);
    }

    // ==============================
    // Mouse Handlers
    // ==============================
  }, {
    key: "startListeningComposition",
    value:
    // ==============================
    // Composition Handlers
    // ==============================

    function startListeningComposition() {
      if (document && document.addEventListener) {
        document.addEventListener('compositionstart', this.onCompositionStart, false);
        document.addEventListener('compositionend', this.onCompositionEnd, false);
      }
    }
  }, {
    key: "stopListeningComposition",
    value: function stopListeningComposition() {
      if (document && document.removeEventListener) {
        document.removeEventListener('compositionstart', this.onCompositionStart);
        document.removeEventListener('compositionend', this.onCompositionEnd);
      }
    }
  }, {
    key: "startListeningToTouch",
    value:
    // ==============================
    // Touch Handlers
    // ==============================

    function startListeningToTouch() {
      if (document && document.addEventListener) {
        document.addEventListener('touchstart', this.onTouchStart, false);
        document.addEventListener('touchmove', this.onTouchMove, false);
        document.addEventListener('touchend', this.onTouchEnd, false);
      }
    }
  }, {
    key: "stopListeningToTouch",
    value: function stopListeningToTouch() {
      if (document && document.removeEventListener) {
        document.removeEventListener('touchstart', this.onTouchStart);
        document.removeEventListener('touchmove', this.onTouchMove);
        document.removeEventListener('touchend', this.onTouchEnd);
      }
    }
  }, {
    key: "renderInput",
    value:
    // ==============================
    // Renderers
    // ==============================
    function renderInput() {
      var _this$props8 = this.props,
        isDisabled = _this$props8.isDisabled,
        isSearchable = _this$props8.isSearchable,
        inputId = _this$props8.inputId,
        inputValue = _this$props8.inputValue,
        tabIndex = _this$props8.tabIndex,
        form = _this$props8.form,
        menuIsOpen = _this$props8.menuIsOpen,
        required = _this$props8.required;
      var _this$getComponents = this.getComponents(),
        Input = _this$getComponents.Input;
      var _this$state4 = this.state,
        inputIsHidden = _this$state4.inputIsHidden,
        ariaSelection = _this$state4.ariaSelection;
      var commonProps = this.commonProps;
      var id = inputId || this.getElementId('input');

      // aria attributes makes the JSX "noisy", separated for clarity
      var ariaAttributes = objectSpread2_objectSpread2(objectSpread2_objectSpread2(objectSpread2_objectSpread2({
        'aria-autocomplete': 'list',
        'aria-expanded': menuIsOpen,
        'aria-haspopup': true,
        'aria-errormessage': this.props['aria-errormessage'],
        'aria-invalid': this.props['aria-invalid'],
        'aria-label': this.props['aria-label'],
        'aria-labelledby': this.props['aria-labelledby'],
        'aria-required': required,
        role: 'combobox',
        'aria-activedescendant': this.isAppleDevice ? undefined : this.state.focusedOptionId || ''
      }, menuIsOpen && {
        'aria-controls': this.getElementId('listbox')
      }), !isSearchable && {
        'aria-readonly': true
      }), this.hasValue() ? (ariaSelection === null || ariaSelection === void 0 ? void 0 : ariaSelection.action) === 'initial-input-focus' && {
        'aria-describedby': this.getElementId('live-region')
      } : {
        'aria-describedby': this.getElementId('placeholder')
      });
      if (!isSearchable) {
        // use a dummy input to maintain focus/blur functionality
        return /*#__PURE__*/react.createElement(DummyInput, extends_extends({
          id: id,
          innerRef: this.getInputRef,
          onBlur: this.onInputBlur,
          onChange: noop,
          onFocus: this.onInputFocus,
          disabled: isDisabled,
          tabIndex: tabIndex,
          inputMode: "none",
          form: form,
          value: ""
        }, ariaAttributes));
      }
      return /*#__PURE__*/react.createElement(Input, extends_extends({}, commonProps, {
        autoCapitalize: "none",
        autoComplete: "off",
        autoCorrect: "off",
        id: id,
        innerRef: this.getInputRef,
        isDisabled: isDisabled,
        isHidden: inputIsHidden,
        onBlur: this.onInputBlur,
        onChange: this.handleInputChange,
        onFocus: this.onInputFocus,
        spellCheck: "false",
        tabIndex: tabIndex,
        form: form,
        type: "text",
        value: inputValue
      }, ariaAttributes));
    }
  }, {
    key: "renderPlaceholderOrValue",
    value: function renderPlaceholderOrValue() {
      var _this3 = this;
      var _this$getComponents2 = this.getComponents(),
        MultiValue = _this$getComponents2.MultiValue,
        MultiValueContainer = _this$getComponents2.MultiValueContainer,
        MultiValueLabel = _this$getComponents2.MultiValueLabel,
        MultiValueRemove = _this$getComponents2.MultiValueRemove,
        SingleValue = _this$getComponents2.SingleValue,
        Placeholder = _this$getComponents2.Placeholder;
      var commonProps = this.commonProps;
      var _this$props9 = this.props,
        controlShouldRenderValue = _this$props9.controlShouldRenderValue,
        isDisabled = _this$props9.isDisabled,
        isMulti = _this$props9.isMulti,
        inputValue = _this$props9.inputValue,
        placeholder = _this$props9.placeholder;
      var _this$state5 = this.state,
        selectValue = _this$state5.selectValue,
        focusedValue = _this$state5.focusedValue,
        isFocused = _this$state5.isFocused;
      if (!this.hasValue() || !controlShouldRenderValue) {
        return inputValue ? null : /*#__PURE__*/react.createElement(Placeholder, extends_extends({}, commonProps, {
          key: "placeholder",
          isDisabled: isDisabled,
          isFocused: isFocused,
          innerProps: {
            id: this.getElementId('placeholder')
          }
        }), placeholder);
      }
      if (isMulti) {
        return selectValue.map(function (opt, index) {
          var isOptionFocused = opt === focusedValue;
          var key = "".concat(_this3.getOptionLabel(opt), "-").concat(_this3.getOptionValue(opt));
          return /*#__PURE__*/react.createElement(MultiValue, extends_extends({}, commonProps, {
            components: {
              Container: MultiValueContainer,
              Label: MultiValueLabel,
              Remove: MultiValueRemove
            },
            isFocused: isOptionFocused,
            isDisabled: isDisabled,
            key: key,
            index: index,
            removeProps: {
              onClick: function onClick() {
                return _this3.removeValue(opt);
              },
              onTouchEnd: function onTouchEnd() {
                return _this3.removeValue(opt);
              },
              onMouseDown: function onMouseDown(e) {
                e.preventDefault();
              }
            },
            data: opt
          }), _this3.formatOptionLabel(opt, 'value'));
        });
      }
      if (inputValue) {
        return null;
      }
      var singleValue = selectValue[0];
      return /*#__PURE__*/react.createElement(SingleValue, extends_extends({}, commonProps, {
        data: singleValue,
        isDisabled: isDisabled
      }), this.formatOptionLabel(singleValue, 'value'));
    }
  }, {
    key: "renderClearIndicator",
    value: function renderClearIndicator() {
      var _this$getComponents3 = this.getComponents(),
        ClearIndicator = _this$getComponents3.ClearIndicator;
      var commonProps = this.commonProps;
      var _this$props10 = this.props,
        isDisabled = _this$props10.isDisabled,
        isLoading = _this$props10.isLoading;
      var isFocused = this.state.isFocused;
      if (!this.isClearable() || !ClearIndicator || isDisabled || !this.hasValue() || isLoading) {
        return null;
      }
      var innerProps = {
        onMouseDown: this.onClearIndicatorMouseDown,
        onTouchEnd: this.onClearIndicatorTouchEnd,
        'aria-hidden': 'true'
      };
      return /*#__PURE__*/react.createElement(ClearIndicator, extends_extends({}, commonProps, {
        innerProps: innerProps,
        isFocused: isFocused
      }));
    }
  }, {
    key: "renderLoadingIndicator",
    value: function renderLoadingIndicator() {
      var _this$getComponents4 = this.getComponents(),
        LoadingIndicator = _this$getComponents4.LoadingIndicator;
      var commonProps = this.commonProps;
      var _this$props11 = this.props,
        isDisabled = _this$props11.isDisabled,
        isLoading = _this$props11.isLoading;
      var isFocused = this.state.isFocused;
      if (!LoadingIndicator || !isLoading) return null;
      var innerProps = {
        'aria-hidden': 'true'
      };
      return /*#__PURE__*/react.createElement(LoadingIndicator, extends_extends({}, commonProps, {
        innerProps: innerProps,
        isDisabled: isDisabled,
        isFocused: isFocused
      }));
    }
  }, {
    key: "renderIndicatorSeparator",
    value: function renderIndicatorSeparator() {
      var _this$getComponents5 = this.getComponents(),
        DropdownIndicator = _this$getComponents5.DropdownIndicator,
        IndicatorSeparator = _this$getComponents5.IndicatorSeparator;

      // separator doesn't make sense without the dropdown indicator
      if (!DropdownIndicator || !IndicatorSeparator) return null;
      var commonProps = this.commonProps;
      var isDisabled = this.props.isDisabled;
      var isFocused = this.state.isFocused;
      return /*#__PURE__*/react.createElement(IndicatorSeparator, extends_extends({}, commonProps, {
        isDisabled: isDisabled,
        isFocused: isFocused
      }));
    }
  }, {
    key: "renderDropdownIndicator",
    value: function renderDropdownIndicator() {
      var _this$getComponents6 = this.getComponents(),
        DropdownIndicator = _this$getComponents6.DropdownIndicator;
      if (!DropdownIndicator) return null;
      var commonProps = this.commonProps;
      var isDisabled = this.props.isDisabled;
      var isFocused = this.state.isFocused;
      var innerProps = {
        onMouseDown: this.onDropdownIndicatorMouseDown,
        onTouchEnd: this.onDropdownIndicatorTouchEnd,
        'aria-hidden': 'true'
      };
      return /*#__PURE__*/react.createElement(DropdownIndicator, extends_extends({}, commonProps, {
        innerProps: innerProps,
        isDisabled: isDisabled,
        isFocused: isFocused
      }));
    }
  }, {
    key: "renderMenu",
    value: function renderMenu() {
      var _this4 = this;
      var _this$getComponents7 = this.getComponents(),
        Group = _this$getComponents7.Group,
        GroupHeading = _this$getComponents7.GroupHeading,
        Menu = _this$getComponents7.Menu,
        MenuList = _this$getComponents7.MenuList,
        MenuPortal = _this$getComponents7.MenuPortal,
        LoadingMessage = _this$getComponents7.LoadingMessage,
        NoOptionsMessage = _this$getComponents7.NoOptionsMessage,
        Option = _this$getComponents7.Option;
      var commonProps = this.commonProps;
      var focusedOption = this.state.focusedOption;
      var _this$props12 = this.props,
        captureMenuScroll = _this$props12.captureMenuScroll,
        inputValue = _this$props12.inputValue,
        isLoading = _this$props12.isLoading,
        loadingMessage = _this$props12.loadingMessage,
        minMenuHeight = _this$props12.minMenuHeight,
        maxMenuHeight = _this$props12.maxMenuHeight,
        menuIsOpen = _this$props12.menuIsOpen,
        menuPlacement = _this$props12.menuPlacement,
        menuPosition = _this$props12.menuPosition,
        menuPortalTarget = _this$props12.menuPortalTarget,
        menuShouldBlockScroll = _this$props12.menuShouldBlockScroll,
        menuShouldScrollIntoView = _this$props12.menuShouldScrollIntoView,
        noOptionsMessage = _this$props12.noOptionsMessage,
        onMenuScrollToTop = _this$props12.onMenuScrollToTop,
        onMenuScrollToBottom = _this$props12.onMenuScrollToBottom;
      if (!menuIsOpen) return null;

      // TODO: Internal Option Type here
      var render = function render(props, id) {
        var type = props.type,
          data = props.data,
          isDisabled = props.isDisabled,
          isSelected = props.isSelected,
          label = props.label,
          value = props.value;
        var isFocused = focusedOption === data;
        var onHover = isDisabled ? undefined : function () {
          return _this4.onOptionHover(data);
        };
        var onSelect = isDisabled ? undefined : function () {
          return _this4.selectOption(data);
        };
        var optionId = "".concat(_this4.getElementId('option'), "-").concat(id);
        var innerProps = {
          id: optionId,
          onClick: onSelect,
          onMouseMove: onHover,
          onMouseOver: onHover,
          tabIndex: -1,
          role: 'option',
          'aria-selected': _this4.isAppleDevice ? undefined : isSelected // is not supported on Apple devices
        };

        return /*#__PURE__*/react.createElement(Option, extends_extends({}, commonProps, {
          innerProps: innerProps,
          data: data,
          isDisabled: isDisabled,
          isSelected: isSelected,
          key: optionId,
          label: label,
          type: type,
          value: value,
          isFocused: isFocused,
          innerRef: isFocused ? _this4.getFocusedOptionRef : undefined
        }), _this4.formatOptionLabel(props.data, 'menu'));
      };
      var menuUI;
      if (this.hasOptions()) {
        menuUI = this.getCategorizedOptions().map(function (item) {
          if (item.type === 'group') {
            var _data = item.data,
              options = item.options,
              groupIndex = item.index;
            var groupId = "".concat(_this4.getElementId('group'), "-").concat(groupIndex);
            var headingId = "".concat(groupId, "-heading");
            return /*#__PURE__*/react.createElement(Group, extends_extends({}, commonProps, {
              key: groupId,
              data: _data,
              options: options,
              Heading: GroupHeading,
              headingProps: {
                id: headingId,
                data: item.data
              },
              label: _this4.formatGroupLabel(item.data)
            }), item.options.map(function (option) {
              return render(option, "".concat(groupIndex, "-").concat(option.index));
            }));
          } else if (item.type === 'option') {
            return render(item, "".concat(item.index));
          }
        });
      } else if (isLoading) {
        var message = loadingMessage({
          inputValue: inputValue
        });
        if (message === null) return null;
        menuUI = /*#__PURE__*/react.createElement(LoadingMessage, commonProps, message);
      } else {
        var _message = noOptionsMessage({
          inputValue: inputValue
        });
        if (_message === null) return null;
        menuUI = /*#__PURE__*/react.createElement(NoOptionsMessage, commonProps, _message);
      }
      var menuPlacementProps = {
        minMenuHeight: minMenuHeight,
        maxMenuHeight: maxMenuHeight,
        menuPlacement: menuPlacement,
        menuPosition: menuPosition,
        menuShouldScrollIntoView: menuShouldScrollIntoView
      };
      var menuElement = /*#__PURE__*/react.createElement(MenuPlacer, extends_extends({}, commonProps, menuPlacementProps), function (_ref4) {
        var ref = _ref4.ref,
          _ref4$placerProps = _ref4.placerProps,
          placement = _ref4$placerProps.placement,
          maxHeight = _ref4$placerProps.maxHeight;
        return /*#__PURE__*/react.createElement(Menu, extends_extends({}, commonProps, menuPlacementProps, {
          innerRef: ref,
          innerProps: {
            onMouseDown: _this4.onMenuMouseDown,
            onMouseMove: _this4.onMenuMouseMove
          },
          isLoading: isLoading,
          placement: placement
        }), /*#__PURE__*/react.createElement(ScrollManager, {
          captureEnabled: captureMenuScroll,
          onTopArrive: onMenuScrollToTop,
          onBottomArrive: onMenuScrollToBottom,
          lockEnabled: menuShouldBlockScroll
        }, function (scrollTargetRef) {
          return /*#__PURE__*/react.createElement(MenuList, extends_extends({}, commonProps, {
            innerRef: function innerRef(instance) {
              _this4.getMenuListRef(instance);
              scrollTargetRef(instance);
            },
            innerProps: {
              role: 'listbox',
              'aria-multiselectable': commonProps.isMulti,
              id: _this4.getElementId('listbox')
            },
            isLoading: isLoading,
            maxHeight: maxHeight,
            focusedOption: focusedOption
          }), menuUI);
        }));
      });

      // positioning behaviour is almost identical for portalled and fixed,
      // so we use the same component. the actual portalling logic is forked
      // within the component based on `menuPosition`
      return menuPortalTarget || menuPosition === 'fixed' ? /*#__PURE__*/react.createElement(MenuPortal, extends_extends({}, commonProps, {
        appendTo: menuPortalTarget,
        controlElement: this.controlRef,
        menuPlacement: menuPlacement,
        menuPosition: menuPosition
      }), menuElement) : menuElement;
    }
  }, {
    key: "renderFormField",
    value: function renderFormField() {
      var _this5 = this;
      var _this$props13 = this.props,
        delimiter = _this$props13.delimiter,
        isDisabled = _this$props13.isDisabled,
        isMulti = _this$props13.isMulti,
        name = _this$props13.name,
        required = _this$props13.required;
      var selectValue = this.state.selectValue;
      if (required && !this.hasValue() && !isDisabled) {
        return /*#__PURE__*/react.createElement(RequiredInput$1, {
          name: name,
          onFocus: this.onValueInputFocus
        });
      }
      if (!name || isDisabled) return;
      if (isMulti) {
        if (delimiter) {
          var value = selectValue.map(function (opt) {
            return _this5.getOptionValue(opt);
          }).join(delimiter);
          return /*#__PURE__*/react.createElement("input", {
            name: name,
            type: "hidden",
            value: value
          });
        } else {
          var input = selectValue.length > 0 ? selectValue.map(function (opt, i) {
            return /*#__PURE__*/react.createElement("input", {
              key: "i-".concat(i),
              name: name,
              type: "hidden",
              value: _this5.getOptionValue(opt)
            });
          }) : /*#__PURE__*/react.createElement("input", {
            name: name,
            type: "hidden",
            value: ""
          });
          return /*#__PURE__*/react.createElement("div", null, input);
        }
      } else {
        var _value = selectValue[0] ? this.getOptionValue(selectValue[0]) : '';
        return /*#__PURE__*/react.createElement("input", {
          name: name,
          type: "hidden",
          value: _value
        });
      }
    }
  }, {
    key: "renderLiveRegion",
    value: function renderLiveRegion() {
      var commonProps = this.commonProps;
      var _this$state6 = this.state,
        ariaSelection = _this$state6.ariaSelection,
        focusedOption = _this$state6.focusedOption,
        focusedValue = _this$state6.focusedValue,
        isFocused = _this$state6.isFocused,
        selectValue = _this$state6.selectValue;
      var focusableOptions = this.getFocusableOptions();
      return /*#__PURE__*/react.createElement(LiveRegion$1, extends_extends({}, commonProps, {
        id: this.getElementId('live-region'),
        ariaSelection: ariaSelection,
        focusedOption: focusedOption,
        focusedValue: focusedValue,
        isFocused: isFocused,
        selectValue: selectValue,
        focusableOptions: focusableOptions,
        isAppleDevice: this.isAppleDevice
      }));
    }
  }, {
    key: "render",
    value: function render() {
      var _this$getComponents8 = this.getComponents(),
        Control = _this$getComponents8.Control,
        IndicatorsContainer = _this$getComponents8.IndicatorsContainer,
        SelectContainer = _this$getComponents8.SelectContainer,
        ValueContainer = _this$getComponents8.ValueContainer;
      var _this$props14 = this.props,
        className = _this$props14.className,
        id = _this$props14.id,
        isDisabled = _this$props14.isDisabled,
        menuIsOpen = _this$props14.menuIsOpen;
      var isFocused = this.state.isFocused;
      var commonProps = this.commonProps = this.getCommonProps();
      return /*#__PURE__*/react.createElement(SelectContainer, extends_extends({}, commonProps, {
        className: className,
        innerProps: {
          id: id,
          onKeyDown: this.onKeyDown
        },
        isDisabled: isDisabled,
        isFocused: isFocused
      }), this.renderLiveRegion(), /*#__PURE__*/react.createElement(Control, extends_extends({}, commonProps, {
        innerRef: this.getControlRef,
        innerProps: {
          onMouseDown: this.onControlMouseDown,
          onTouchEnd: this.onControlTouchEnd
        },
        isDisabled: isDisabled,
        isFocused: isFocused,
        menuIsOpen: menuIsOpen
      }), /*#__PURE__*/react.createElement(ValueContainer, extends_extends({}, commonProps, {
        isDisabled: isDisabled
      }), this.renderPlaceholderOrValue(), this.renderInput()), /*#__PURE__*/react.createElement(IndicatorsContainer, extends_extends({}, commonProps, {
        isDisabled: isDisabled
      }), this.renderClearIndicator(), this.renderLoadingIndicator(), this.renderIndicatorSeparator(), this.renderDropdownIndicator())), this.renderMenu(), this.renderFormField());
    }
  }], [{
    key: "getDerivedStateFromProps",
    value: function getDerivedStateFromProps(props, state) {
      var prevProps = state.prevProps,
        clearFocusValueOnUpdate = state.clearFocusValueOnUpdate,
        inputIsHiddenAfterUpdate = state.inputIsHiddenAfterUpdate,
        ariaSelection = state.ariaSelection,
        isFocused = state.isFocused,
        prevWasFocused = state.prevWasFocused,
        instancePrefix = state.instancePrefix;
      var options = props.options,
        value = props.value,
        menuIsOpen = props.menuIsOpen,
        inputValue = props.inputValue,
        isMulti = props.isMulti;
      var selectValue = cleanValue(value);
      var newMenuOptionsState = {};
      if (prevProps && (value !== prevProps.value || options !== prevProps.options || menuIsOpen !== prevProps.menuIsOpen || inputValue !== prevProps.inputValue)) {
        var focusableOptions = menuIsOpen ? buildFocusableOptions(props, selectValue) : [];
        var focusableOptionsWithIds = menuIsOpen ? buildFocusableOptionsWithIds(buildCategorizedOptions(props, selectValue), "".concat(instancePrefix, "-option")) : [];
        var focusedValue = clearFocusValueOnUpdate ? getNextFocusedValue(state, selectValue) : null;
        var focusedOption = getNextFocusedOption(state, focusableOptions);
        var focusedOptionId = getFocusedOptionId(focusableOptionsWithIds, focusedOption);
        newMenuOptionsState = {
          selectValue: selectValue,
          focusedOption: focusedOption,
          focusedOptionId: focusedOptionId,
          focusableOptionsWithIds: focusableOptionsWithIds,
          focusedValue: focusedValue,
          clearFocusValueOnUpdate: false
        };
      }
      // some updates should toggle the state of the input visibility
      var newInputIsHiddenState = inputIsHiddenAfterUpdate != null && props !== prevProps ? {
        inputIsHidden: inputIsHiddenAfterUpdate,
        inputIsHiddenAfterUpdate: undefined
      } : {};
      var newAriaSelection = ariaSelection;
      var hasKeptFocus = isFocused && prevWasFocused;
      if (isFocused && !hasKeptFocus) {
        // If `value` or `defaultValue` props are not empty then announce them
        // when the Select is initially focused
        newAriaSelection = {
          value: valueTernary(isMulti, selectValue, selectValue[0] || null),
          options: selectValue,
          action: 'initial-input-focus'
        };
        hasKeptFocus = !prevWasFocused;
      }

      // If the 'initial-input-focus' action has been set already
      // then reset the ariaSelection to null
      if ((ariaSelection === null || ariaSelection === void 0 ? void 0 : ariaSelection.action) === 'initial-input-focus') {
        newAriaSelection = null;
      }
      return objectSpread2_objectSpread2(objectSpread2_objectSpread2(objectSpread2_objectSpread2({}, newMenuOptionsState), newInputIsHiddenState), {}, {
        prevProps: props,
        ariaSelection: newAriaSelection,
        prevWasFocused: hasKeptFocus
      });
    }
  }]);
  return Select;
}(react.Component);
Select.defaultProps = defaultProps;



;// CONCATENATED MODULE: ./node_modules/react-select/dist/useStateManager-7e1e8489.esm.js





var useStateManager_7e1e8489_esm_excluded = ["defaultInputValue", "defaultMenuIsOpen", "defaultValue", "inputValue", "menuIsOpen", "onChange", "onInputChange", "onMenuClose", "onMenuOpen", "value"];
function useStateManager(_ref) {
  var _ref$defaultInputValu = _ref.defaultInputValue,
    defaultInputValue = _ref$defaultInputValu === void 0 ? '' : _ref$defaultInputValu,
    _ref$defaultMenuIsOpe = _ref.defaultMenuIsOpen,
    defaultMenuIsOpen = _ref$defaultMenuIsOpe === void 0 ? false : _ref$defaultMenuIsOpe,
    _ref$defaultValue = _ref.defaultValue,
    defaultValue = _ref$defaultValue === void 0 ? null : _ref$defaultValue,
    propsInputValue = _ref.inputValue,
    propsMenuIsOpen = _ref.menuIsOpen,
    propsOnChange = _ref.onChange,
    propsOnInputChange = _ref.onInputChange,
    propsOnMenuClose = _ref.onMenuClose,
    propsOnMenuOpen = _ref.onMenuOpen,
    propsValue = _ref.value,
    restSelectProps = _objectWithoutProperties(_ref, useStateManager_7e1e8489_esm_excluded);
  var _useState = (0,react.useState)(propsInputValue !== undefined ? propsInputValue : defaultInputValue),
    _useState2 = _slicedToArray(_useState, 2),
    stateInputValue = _useState2[0],
    setStateInputValue = _useState2[1];
  var _useState3 = (0,react.useState)(propsMenuIsOpen !== undefined ? propsMenuIsOpen : defaultMenuIsOpen),
    _useState4 = _slicedToArray(_useState3, 2),
    stateMenuIsOpen = _useState4[0],
    setStateMenuIsOpen = _useState4[1];
  var _useState5 = (0,react.useState)(propsValue !== undefined ? propsValue : defaultValue),
    _useState6 = _slicedToArray(_useState5, 2),
    stateValue = _useState6[0],
    setStateValue = _useState6[1];
  var onChange = (0,react.useCallback)(function (value, actionMeta) {
    if (typeof propsOnChange === 'function') {
      propsOnChange(value, actionMeta);
    }
    setStateValue(value);
  }, [propsOnChange]);
  var onInputChange = (0,react.useCallback)(function (value, actionMeta) {
    var newValue;
    if (typeof propsOnInputChange === 'function') {
      newValue = propsOnInputChange(value, actionMeta);
    }
    setStateInputValue(newValue !== undefined ? newValue : value);
  }, [propsOnInputChange]);
  var onMenuOpen = (0,react.useCallback)(function () {
    if (typeof propsOnMenuOpen === 'function') {
      propsOnMenuOpen();
    }
    setStateMenuIsOpen(true);
  }, [propsOnMenuOpen]);
  var onMenuClose = (0,react.useCallback)(function () {
    if (typeof propsOnMenuClose === 'function') {
      propsOnMenuClose();
    }
    setStateMenuIsOpen(false);
  }, [propsOnMenuClose]);
  var inputValue = propsInputValue !== undefined ? propsInputValue : stateInputValue;
  var menuIsOpen = propsMenuIsOpen !== undefined ? propsMenuIsOpen : stateMenuIsOpen;
  var value = propsValue !== undefined ? propsValue : stateValue;
  return objectSpread2_objectSpread2(objectSpread2_objectSpread2({}, restSelectProps), {}, {
    inputValue: inputValue,
    menuIsOpen: menuIsOpen,
    onChange: onChange,
    onInputChange: onInputChange,
    onMenuClose: onMenuClose,
    onMenuOpen: onMenuOpen,
    value: value
  });
}



;// CONCATENATED MODULE: ./node_modules/react-select/dist/useCreatable-d97ef2c9.esm.js







var useCreatable_d97ef2c9_esm_excluded = ["allowCreateWhileLoading", "createOptionPosition", "formatCreateLabel", "isValidNewOption", "getNewOptionData", "onCreateOption", "options", "onChange"];
var compareOption = function compareOption() {
  var inputValue = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  var option = arguments.length > 1 ? arguments[1] : undefined;
  var accessors = arguments.length > 2 ? arguments[2] : undefined;
  var candidate = String(inputValue).toLowerCase();
  var optionValue = String(accessors.getOptionValue(option)).toLowerCase();
  var optionLabel = String(accessors.getOptionLabel(option)).toLowerCase();
  return optionValue === candidate || optionLabel === candidate;
};
var builtins = {
  formatCreateLabel: function formatCreateLabel(inputValue) {
    return "Create \"".concat(inputValue, "\"");
  },
  isValidNewOption: function isValidNewOption(inputValue, selectValue, selectOptions, accessors) {
    return !(!inputValue || selectValue.some(function (option) {
      return compareOption(inputValue, option, accessors);
    }) || selectOptions.some(function (option) {
      return compareOption(inputValue, option, accessors);
    }));
  },
  getNewOptionData: function getNewOptionData(inputValue, optionLabel) {
    return {
      label: optionLabel,
      value: inputValue,
      __isNew__: true
    };
  }
};
function useCreatable(_ref) {
  var _ref$allowCreateWhile = _ref.allowCreateWhileLoading,
    allowCreateWhileLoading = _ref$allowCreateWhile === void 0 ? false : _ref$allowCreateWhile,
    _ref$createOptionPosi = _ref.createOptionPosition,
    createOptionPosition = _ref$createOptionPosi === void 0 ? 'last' : _ref$createOptionPosi,
    _ref$formatCreateLabe = _ref.formatCreateLabel,
    formatCreateLabel = _ref$formatCreateLabe === void 0 ? builtins.formatCreateLabel : _ref$formatCreateLabe,
    _ref$isValidNewOption = _ref.isValidNewOption,
    isValidNewOption = _ref$isValidNewOption === void 0 ? builtins.isValidNewOption : _ref$isValidNewOption,
    _ref$getNewOptionData = _ref.getNewOptionData,
    getNewOptionData = _ref$getNewOptionData === void 0 ? builtins.getNewOptionData : _ref$getNewOptionData,
    onCreateOption = _ref.onCreateOption,
    _ref$options = _ref.options,
    propsOptions = _ref$options === void 0 ? [] : _ref$options,
    propsOnChange = _ref.onChange,
    restSelectProps = _objectWithoutProperties(_ref, useCreatable_d97ef2c9_esm_excluded);
  var _restSelectProps$getO = restSelectProps.getOptionValue,
    getOptionValue$1 = _restSelectProps$getO === void 0 ? Select_49a62830_esm_getOptionValue$1 : _restSelectProps$getO,
    _restSelectProps$getO2 = restSelectProps.getOptionLabel,
    getOptionLabel$1 = _restSelectProps$getO2 === void 0 ? Select_49a62830_esm_getOptionLabel$1 : _restSelectProps$getO2,
    inputValue = restSelectProps.inputValue,
    isLoading = restSelectProps.isLoading,
    isMulti = restSelectProps.isMulti,
    value = restSelectProps.value,
    name = restSelectProps.name;
  var newOption = (0,react.useMemo)(function () {
    return isValidNewOption(inputValue, cleanValue(value), propsOptions, {
      getOptionValue: getOptionValue$1,
      getOptionLabel: getOptionLabel$1
    }) ? getNewOptionData(inputValue, formatCreateLabel(inputValue)) : undefined;
  }, [formatCreateLabel, getNewOptionData, getOptionLabel$1, getOptionValue$1, inputValue, isValidNewOption, propsOptions, value]);
  var options = (0,react.useMemo)(function () {
    return (allowCreateWhileLoading || !isLoading) && newOption ? createOptionPosition === 'first' ? [newOption].concat(_toConsumableArray(propsOptions)) : [].concat(_toConsumableArray(propsOptions), [newOption]) : propsOptions;
  }, [allowCreateWhileLoading, createOptionPosition, isLoading, newOption, propsOptions]);
  var onChange = (0,react.useCallback)(function (newValue, actionMeta) {
    if (actionMeta.action !== 'select-option') {
      return propsOnChange(newValue, actionMeta);
    }
    var valueArray = Array.isArray(newValue) ? newValue : [newValue];
    if (valueArray[valueArray.length - 1] === newOption) {
      if (onCreateOption) onCreateOption(inputValue);else {
        var newOptionData = getNewOptionData(inputValue, inputValue);
        var newActionMeta = {
          action: 'create-option',
          name: name,
          option: newOptionData
        };
        propsOnChange(valueTernary(isMulti, [].concat(_toConsumableArray(cleanValue(value)), [newOptionData]), newOptionData), newActionMeta);
      }
      return;
    }
    propsOnChange(newValue, actionMeta);
  }, [getNewOptionData, inputValue, isMulti, name, newOption, onCreateOption, propsOnChange, value]);
  return objectSpread2_objectSpread2(objectSpread2_objectSpread2({}, restSelectProps), {}, {
    options: options,
    onChange: onChange
  });
}



;// CONCATENATED MODULE: ./node_modules/react-select/creatable/dist/react-select-creatable.esm.js

























var CreatableSelect = /*#__PURE__*/(0,react.forwardRef)(function (props, ref) {
  var creatableProps = useStateManager(props);
  var selectProps = useCreatable(creatableProps);
  return /*#__PURE__*/react.createElement(Select, extends_extends({
    ref: ref
  }, selectProps));
});
var CreatableSelect$1 = CreatableSelect;



// EXTERNAL MODULE: ./app/helpers/function.ts + 23 modules
var helpers_function = __webpack_require__(4203);
;// CONCATENATED MODULE: ./app/containers/create-post/add-on/TagMention.tsx








const LIMIT_TAG = 10;
const SPACE_KEYCODE = 32;
const TagMention = ()=>{
    var _filter, _ref;
    const { toast  } = (0,use_toast/* useToast */.pm)();
    const { t  } = (0,esm/* useTranslation */.$G)();
    const { data: otherHashtag  } = (0,query_fn/* useQueryGetHotTopic */.i9)();
    const tagRef = (0,react.useRef)();
    const [valueInput, setValueInput] = (0,react.useState)([]);
    const { setValue , watch  } = (0,index_esm/* useFormContext */.Gc)();
    const tags = watch("tags", []);
    const options = (otherHashtag === null || otherHashtag === void 0 ? void 0 : otherHashtag.length) ? otherHashtag.map((hashtag)=>({
            value: hashtag.hashtag,
            label: "#".concat(hashtag.hashtag.replaceAll("#", ""))
        })) : [];
    (0,react.useEffect)(()=>{
        if (tags.length > 0 && !!tagRef && !!(tagRef === null || tagRef === void 0 ? void 0 : tagRef.current) && !(valueInput === null || valueInput === void 0 ? void 0 : valueInput.length) && tags.every((element)=>element !== null)) {
            setValueInput(tags.map((hashtag)=>{
                return {
                    value: hashtag,
                    label: "#".concat(hashtag === null || hashtag === void 0 ? void 0 : hashtag.replaceAll("#", ""))
                };
            }));
        }
    }, [
        tags,
        tagRef,
        valueInput
    ]);
    const onChangeValue = (newValue, actionMeta)=>{
        if ((newValue === null || newValue === void 0 ? void 0 : newValue.length) <= LIMIT_TAG) {
            const validValue = newValue.map((item)=>{
                var _item_label;
                return {
                    ...item,
                    value: (0,helpers_function/* removeVietnameseTones */.CQ)(item === null || item === void 0 ? void 0 : item.value),
                    label: (0,helpers_function/* removeVietnameseTones */.CQ)("#".concat(item === null || item === void 0 ? void 0 : (_item_label = item.label) === null || _item_label === void 0 ? void 0 : _item_label.replaceAll("#", "")))
                };
            });
            setValue("tags", validValue.map((item)=>{
                return item === null || item === void 0 ? void 0 : item.value;
            }));
            setValueInput(validValue);
        } else {
            toast({
                variant: "error",
                title: t("news.limit_hashtag_alert")
            });
        }
    };
    const onKeyDown = (e)=>{
        if (tagRef && (tagRef === null || tagRef === void 0 ? void 0 : tagRef.current)) {
            var _selectInstance_state;
            const selectInstance = tagRef === null || tagRef === void 0 ? void 0 : tagRef.current;
            const focusedOption = selectInstance === null || selectInstance === void 0 ? void 0 : (_selectInstance_state = selectInstance.state) === null || _selectInstance_state === void 0 ? void 0 : _selectInstance_state.focusedOption;
            if (e.keyCode == SPACE_KEYCODE && !e.shiftKey && (e === null || e === void 0 ? void 0 : e.target) && !!focusedOption) {
                selectInstance === null || selectInstance === void 0 ? void 0 : selectInstance.selectOption(focusedOption);
            }
        }
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "flex items-center gap-3 cursor-pointer",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                    className: "text-bg-01 text-[18px] Nunito-700 dark:text-white",
                    children: [
                        "Tag (",
                        (_filter = (_ref = tags !== null && tags !== void 0 ? tags : []) === null || _ref === void 0 ? void 0 : _ref.filter((element)=>element !== null)) === null || _filter === void 0 ? void 0 : _filter.length,
                        " /",
                        " ",
                        LIMIT_TAG,
                        ")"
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "relative w-full",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CreatableSelect$1, {
                        isMulti: true,
                        ref: tagRef,
                        options: options,
                        value: valueInput,
                        placeholder: t("news.input_content"),
                        components: {
                            DropdownIndicator: ()=>null,
                            IndicatorSeparator: ()=>null
                        },
                        classNamePrefix: "react-select",
                        onChange: onChangeValue,
                        onKeyDown: onKeyDown
                    })
                })
            })
        ]
    });
};

;// CONCATENATED MODULE: ./app/containers/create-post/add-on/LinkEvent.tsx





const LinkEvent = ()=>{
    const { t  } = (0,esm/* useTranslation */.$G)();
    const { watch , setValue  } = (0,index_esm/* useFormContext */.Gc)();
    const watchLinkEvent = watch("link_event", "");
    const onChangeValue = (e)=>{
        var _e_target;
        setValue("link_event", e === null || e === void 0 ? void 0 : (_e_target = e.target) === null || _e_target === void 0 ? void 0 : _e_target.value);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "relative w-full",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                className: "text-bg-01 text-[18px] Nunito-700 dark:text-white",
                children: t("news.attach_link")
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(input/* Input */.I, {
                onChange: onChangeValue,
                value: watchLinkEvent,
                placeholder: t("news.input_content"),
                className: "border-0 border-b-[1px] rounded-none h-10 dark:bg-transparent"
            })
        ]
    });
};

// EXTERNAL MODULE: ./app/components/ui/dropdown-menu.tsx + 2 modules
var dropdown_menu = __webpack_require__(27357);
// EXTERNAL MODULE: ./app/components/icon-tsx/IconCalendar.tsx
var IconCalendar = __webpack_require__(20450);
// EXTERNAL MODULE: ./app/components/ui/scroll-area.tsx
var scroll_area = __webpack_require__(36128);
// EXTERNAL MODULE: ./app/components/ui/calendar.tsx + 1 modules
var ui_calendar = __webpack_require__(87422);
// EXTERNAL MODULE: ./node_modules/moment/moment.js
var moment = __webpack_require__(30381);
var moment_default = /*#__PURE__*/__webpack_require__.n(moment);
// EXTERNAL MODULE: ./app/containers/create-post/add-on/CustomSelectMontYear.tsx
var CustomSelectMontYear = __webpack_require__(73126);
;// CONCATENATED MODULE: ./app/containers/create-post/add-on/StartTime.tsx












const StartTime = ()=>{
    const { t  } = (0,esm/* useTranslation */.$G)();
    const { setValue , watch  } = (0,index_esm/* useFormContext */.Gc)();
    const [openStartTime, setOpenStartTime] = (0,react.useState)(false);
    const [timeStart, setTimeStart] = (0,react.useState)("00:00");
    const selectedStartTime = watch("start_time", undefined);
    const selectedEndTime = watch("end_time", undefined);
    const handleStartTimeChange = (e)=>{
        const time = e.target.value;
        if (!selectedStartTime) {
            setTimeStart(time);
            return;
        }
        const [hours, minutes] = time.split(":").map((str)=>parseInt(str, 10));
        const newSelectedDate = new Date(selectedStartTime.getFullYear(), selectedStartTime.getMonth(), selectedStartTime.getDate(), hours, minutes);
        setValue("start_time", newSelectedDate);
        setTimeStart(time);
    };
    const handleDaySelectStartTime = (date)=>{
        if (!timeStart || !date) {
            setValue("start_time", date);
            return;
        }
        const [hours, minutes] = timeStart.split(":").map((str)=>parseInt(str, 10));
        const newDate = new Date(date.getFullYear(), date.getMonth(), date.getDate(), hours, minutes);
        setValue("start_time", newDate);
    };
    const onCloseSelectStartDate = ()=>{
        setOpenStartTime(false);
        setValue("start_time", undefined);
    };
    const onSubmitSelectTime = ()=>{
        setOpenStartTime(false);
    };
    const content = (0,react.useMemo)(()=>{
        return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "flex-1",
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(dropdown_menu/* DropdownMenu */.h_, {
                open: openStartTime,
                onOpenChange: onCloseSelectStartDate,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(dropdown_menu/* DropdownMenuTrigger */.$F, {
                        asChild: true,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(ui_button/* Button */.z, {
                            variant: "none",
                            className: "bg-disable w-full text-neutral flex justify-between items-center py-[8px] dark:text-white",
                            onClick: ()=>setOpenStartTime(true),
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    children: selectedStartTime ? moment_default()(selectedStartTime).format(configs/* DATE_FORMAT_3 */.Ly) : t("news.start")
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(IconCalendar/* IconCalendar */.j, {})
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(dropdown_menu/* DropdownMenuContent */.AW, {
                        className: "w-[276px]",
                        align: "center",
                        side: "left",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(scroll_area/* ScrollArea */.x, {
                            className: "h-fit",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ui_calendar/* Calendar */.f, {
                                mode: "single",
                                selected: selectedStartTime,
                                onSelect: handleDaySelectStartTime,
                                className: "p-0 rounded-md",
                                showOutsideDays: true,
                                captionLayout: "dropdown",
                                fromYear: new Date().getFullYear(),
                                toYear: configs/* END_YEAR */.As,
                                components: {
                                    Head: ()=>/*#__PURE__*/ (0,jsx_runtime.jsx)(CustomSelectMontYear/* CustomSelectMonthYear */.k, {})
                                },
                                footer: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "space-y-[24px]",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: "flex items-center justify-between mt-2",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                                    className: "text-base Nunito-600 text-main-01",
                                                    children: [
                                                        t("news.post_time"),
                                                        ":"
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                                    type: "time",
                                                    value: timeStart,
                                                    onChange: handleStartTimeChange,
                                                    className: "text-base"
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: "flex items-center justify-end gap-4",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(ui_button/* Button */.z, {
                                                    variant: "none",
                                                    className: "bg-disable text-neutral dark:text-white rounded-[12px] max-h-[34px] py-[6px] px-[24px]",
                                                    onClick: onCloseSelectStartDate,
                                                    children: t("common.cancel")
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(ui_button/* Button */.z, {
                                                    variant: "none",
                                                    disabled: !selectedStartTime || selectedStartTime < new Date() || !!selectedEndTime && selectedStartTime > selectedEndTime,
                                                    className: "text-white bg-disable bg-main-01 rounded-[12px] max-h-[34px] py-[6px] px-[24px]",
                                                    onClick: onSubmitSelectTime,
                                                    children: t("news.set_time")
                                                })
                                            ]
                                        }),
                                        selectedStartTime < new Date() ? /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                            className: "mt-1 text-xs Nunito-400 text-main-red",
                                            children: t("news.please_select_future_date")
                                        }) : !!selectedEndTime && selectedStartTime > selectedEndTime ? /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                            className: "mt-1 text-xs Nunito-400 text-main-red",
                                            children: t("news.start_time_smaller")
                                        }) : ""
                                    ]
                                })
                            })
                        })
                    })
                ]
            })
        });
    }, [
        selectedStartTime,
        selectedEndTime,
        openStartTime,
        timeStart
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: content
    });
};

;// CONCATENATED MODULE: ./app/containers/create-post/add-on/EndTime.tsx












const EndTime = ()=>{
    const { t  } = (0,esm/* useTranslation */.$G)();
    const { setValue , watch  } = (0,index_esm/* useFormContext */.Gc)();
    const [openEndTime, setOpenEndTime] = (0,react.useState)(false);
    const [timeEnd, setTimeEnd] = (0,react.useState)("00:00");
    const selectedStartTime = watch("start_time", undefined);
    const selectedEndTime = watch("end_time", undefined);
    const handleEndTimeChange = (e)=>{
        const time = e.target.value;
        if (!selectedEndTime) {
            setTimeEnd(time);
            return;
        }
        const [hours, minutes] = time.split(":").map((str)=>parseInt(str, 10));
        const newSelectedDate = new Date(selectedEndTime.getFullYear(), selectedEndTime.getMonth(), selectedEndTime.getDate(), hours, minutes);
        setValue("end_time", newSelectedDate);
        setTimeEnd(time);
    };
    const handleDaySelectEndTime = (date)=>{
        if (!timeEnd || !date) {
            setValue("end_time", date);
            return;
        }
        const [hours, minutes] = timeEnd.split(":").map((str)=>parseInt(str, 10));
        const newDate = new Date(date.getFullYear(), date.getMonth(), date.getDate(), hours, minutes);
        setValue("end_time", newDate);
    };
    const onCloseSelectEndDate = ()=>{
        setOpenEndTime(false);
        setValue("end_time", undefined);
    };
    const onSubmitSelectTime = ()=>{
        setOpenEndTime(false);
    };
    const content = (0,react.useMemo)(()=>{
        return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "flex-1",
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(dropdown_menu/* DropdownMenu */.h_, {
                open: openEndTime,
                onOpenChange: onCloseSelectEndDate,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(dropdown_menu/* DropdownMenuTrigger */.$F, {
                        asChild: true,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(ui_button/* Button */.z, {
                            variant: "none",
                            className: "bg-disable w-full text-neutral flex justify-between items-center py-[8px] dark:text-white",
                            onClick: ()=>setOpenEndTime(true),
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    children: selectedEndTime ? moment_default()(selectedEndTime).format(configs/* DATE_FORMAT_3 */.Ly) : t("news.end")
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(IconCalendar/* IconCalendar */.j, {})
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(dropdown_menu/* DropdownMenuContent */.AW, {
                        className: "w-[276px]",
                        align: "center",
                        side: "left",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(scroll_area/* ScrollArea */.x, {
                            className: "h-fit",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ui_calendar/* Calendar */.f, {
                                mode: "single",
                                selected: selectedEndTime,
                                onSelect: handleDaySelectEndTime,
                                className: "p-0 rounded-md",
                                showOutsideDays: true,
                                captionLayout: "dropdown",
                                fromYear: new Date().getFullYear(),
                                toYear: configs/* END_YEAR */.As,
                                components: {
                                    Head: ()=>/*#__PURE__*/ (0,jsx_runtime.jsx)(CustomSelectMontYear/* CustomSelectMonthYear */.k, {})
                                },
                                footer: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "space-y-[24px]",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: "flex items-center justify-between mt-2",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                                    className: "text-base Nunito-600 text-main-01",
                                                    children: [
                                                        t("news.post_time"),
                                                        ":"
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                                    type: "time",
                                                    value: timeEnd,
                                                    onChange: handleEndTimeChange,
                                                    className: "text-base"
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: "flex items-center justify-end gap-4",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(ui_button/* Button */.z, {
                                                    variant: "none",
                                                    className: "bg-disable text-neutral dark:text-white rounded-[12px] max-h-[34px] py-[6px] px-[24px]",
                                                    onClick: onCloseSelectEndDate,
                                                    children: t("common.cancel")
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(ui_button/* Button */.z, {
                                                    variant: "none",
                                                    disabled: !selectedEndTime || selectedEndTime < new Date() || !!selectedStartTime && selectedEndTime < selectedStartTime,
                                                    className: "text-white bg-disable bg-main-01 rounded-[12px] max-h-[34px] py-[6px] px-[24px]",
                                                    onClick: onSubmitSelectTime,
                                                    children: t("news.set_time")
                                                })
                                            ]
                                        }),
                                        selectedEndTime < new Date() ? /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                            className: "mt-1 text-xs Nunito-400 text-main-red",
                                            children: t("news.please_select_future_date")
                                        }) : !!selectedStartTime && selectedEndTime < selectedStartTime ? /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                            className: "mt-1 text-xs Nunito-400 text-main-red",
                                            children: t("news.end_time_larger")
                                        }) : ""
                                    ]
                                })
                            })
                        })
                    })
                ]
            })
        });
    }, [
        openEndTime,
        timeEnd,
        selectedStartTime,
        selectedEndTime
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: content
    });
};

;// CONCATENATED MODULE: ./app/containers/create-post/add-on/StartTimeMobile.tsx











const StartTimeMobile = ()=>{
    const { t  } = (0,esm/* useTranslation */.$G)();
    const { setValue , watch  } = (0,index_esm/* useFormContext */.Gc)();
    const [openStartTime, setOpenStartTime] = (0,react.useState)(false);
    const [timeStart, setTimeStart] = (0,react.useState)("00:00");
    const selectedStartTime = watch("start_time", undefined);
    const selectedEndTime = watch("end_time", undefined);
    const handleStartTimeChange = (e)=>{
        const time = e.target.value;
        if (!selectedStartTime) {
            setTimeStart(time);
            return;
        }
        const [hours, minutes] = time.split(":").map((str)=>parseInt(str, 10));
        const newSelectedDate = new Date(selectedStartTime.getFullYear(), selectedStartTime.getMonth(), selectedStartTime.getDate(), hours, minutes);
        setValue("start_time", newSelectedDate);
        setTimeStart(time);
    };
    const handleDaySelectStartTime = (date)=>{
        if (!timeStart || !date) {
            setValue("start_time", date);
            return;
        }
        const [hours, minutes] = timeStart.split(":").map((str)=>parseInt(str, 10));
        const newDate = new Date(date.getFullYear(), date.getMonth(), date.getDate(), hours, minutes);
        setValue("start_time", newDate);
    };
    const onCloseSelectStartDate = ()=>{
        setOpenStartTime(!openStartTime);
        setValue("start_time", undefined);
    };
    const onSubmitSelectTime = ()=>{
        setOpenStartTime(false);
    };
    const memoCalendar = (0,react.useMemo)(()=>{
        return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "w-full bg-white space-y-[24px] dark:bg-transparent",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ui_calendar/* Calendar */.f, {
                mode: "single",
                selected: selectedStartTime,
                onSelect: handleDaySelectStartTime,
                className: "p-0 rounded-md",
                showOutsideDays: true,
                captionLayout: "dropdown",
                fromYear: new Date().getFullYear(),
                toYear: configs/* END_YEAR */.As,
                components: {
                    Head: ()=>/*#__PURE__*/ (0,jsx_runtime.jsx)(CustomSelectMontYear/* CustomSelectMonthYear */.k, {})
                },
                footer: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "space-y-[24px]",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "flex items-center justify-between mt-2",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                    className: "text-base Nunito-600 text-main-01",
                                    children: [
                                        t("news.post_time"),
                                        ":"
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                    type: "time",
                                    value: timeStart,
                                    onChange: handleStartTimeChange,
                                    className: "text-base"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "flex items-center justify-end gap-4",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(ui_button/* Button */.z, {
                                    variant: "none",
                                    className: "bg-disable text-neutral dark:text-white rounded-[12px] max-h-[34px] py-[6px] px-[24px]",
                                    onClick: onCloseSelectStartDate,
                                    children: t("common.cancel")
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(ui_button/* Button */.z, {
                                    variant: "none",
                                    disabled: !selectedStartTime || selectedStartTime < new Date() || !!selectedEndTime && selectedStartTime > selectedEndTime,
                                    className: "text-white bg-disable bg-main-01 rounded-[12px] max-h-[34px] py-[6px] px-[24px]",
                                    onClick: onSubmitSelectTime,
                                    children: t("news.set_time")
                                })
                            ]
                        }),
                        selectedStartTime < new Date() ? /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                            className: "mt-1 text-xs Nunito-400 text-main-red",
                            children: t("news.please_select_future_date")
                        }) : !!selectedEndTime && selectedStartTime > selectedEndTime ? /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                            className: "mt-1 text-xs Nunito-400 text-main-red",
                            children: t("news.start_time_smaller")
                        }) : ""
                    ]
                })
            })
        });
    }, [
        openStartTime,
        timeStart,
        selectedStartTime,
        selectedEndTime
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "flex-1 w-full",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(dialog/* Dialog */.Vq, {
            open: openStartTime,
            onOpenChange: onCloseSelectStartDate,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(dialog/* DialogTrigger */.hg, {
                    className: "w-full",
                    asChild: true,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(ui_button/* Button */.z, {
                        variant: "none",
                        className: "bg-disable w-full text-neutral flex justify-between items-center py-[8px] dark:text-white",
                        onClick: ()=>setOpenStartTime(true),
                        children: [
                            selectedStartTime && /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                className: "text-sm Nunito-500 text-main-01",
                                children: t("news.start")
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                children: selectedStartTime ? moment_default()(selectedStartTime).format(configs/* DATE_FORMAT_3 */.Ly) : t("news.start")
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(IconCalendar/* IconCalendar */.j, {})
                        ]
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(dialog/* DialogContent */.cZ, {
                    className: "w-[90vw] rounded-[24px] p-4 dark:border-0 dark:bg-[#1A1925]",
                    children: memoCalendar
                })
            ]
        })
    });
};

;// CONCATENATED MODULE: ./app/containers/create-post/add-on/EndTimeMobile.tsx











const EndTimeMobile = ()=>{
    const { t  } = (0,esm/* useTranslation */.$G)();
    const { setValue , watch  } = (0,index_esm/* useFormContext */.Gc)();
    const [openEndTime, setOpenEndTime] = (0,react.useState)(false);
    const [timeEnd, setTimeEnd] = (0,react.useState)("00:00");
    const selectedStartTime = watch("start_time", undefined);
    const selectedEndTime = watch("end_time", undefined);
    const handleEndTimeChange = (e)=>{
        const time = e.target.value;
        if (!selectedEndTime) {
            setTimeEnd(time);
            return;
        }
        const [hours, minutes] = time.split(":").map((str)=>parseInt(str, 10));
        const newSelectedDate = new Date(selectedEndTime.getFullYear(), selectedEndTime.getMonth(), selectedEndTime.getDate(), hours, minutes);
        setValue("end_time", newSelectedDate);
        setTimeEnd(time);
    };
    const handleDaySelectEndTime = (date)=>{
        if (!timeEnd || !date) {
            setValue("end_time", date);
            return;
        }
        const [hours, minutes] = timeEnd.split(":").map((str)=>parseInt(str, 10));
        const newDate = new Date(date.getFullYear(), date.getMonth(), date.getDate(), hours, minutes);
        setValue("end_time", newDate);
    };
    const onCloseSelectEndDate = ()=>{
        setOpenEndTime(!openEndTime);
        setValue("end_time", undefined);
    };
    const onSubmitSelectTime = ()=>{
        setOpenEndTime(false);
    };
    const memoCalendar = (0,react.useMemo)(()=>{
        return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "w-full bg-white space-y-[24px] dark:bg-transparent",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ui_calendar/* Calendar */.f, {
                mode: "single",
                selected: selectedEndTime,
                onSelect: handleDaySelectEndTime,
                className: "p-0 rounded-md",
                showOutsideDays: true,
                captionLayout: "dropdown",
                fromYear: new Date().getFullYear(),
                toYear: configs/* END_YEAR */.As,
                components: {
                    Head: ()=>/*#__PURE__*/ (0,jsx_runtime.jsx)(CustomSelectMontYear/* CustomSelectMonthYear */.k, {})
                },
                footer: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "space-y-[24px]",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "flex items-center justify-between mt-2",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                    className: "text-base Nunito-600 text-main-01",
                                    children: [
                                        t("news.post_time"),
                                        ":"
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                    type: "time",
                                    value: timeEnd,
                                    onChange: handleEndTimeChange,
                                    className: "text-base"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "flex items-center justify-end gap-4",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(ui_button/* Button */.z, {
                                    variant: "none",
                                    className: "bg-disable text-neutral dark:text-white rounded-[12px] max-h-[34px] py-[6px] px-[24px]",
                                    onClick: onCloseSelectEndDate,
                                    children: t("common.cancel")
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(ui_button/* Button */.z, {
                                    variant: "none",
                                    disabled: !selectedEndTime || selectedEndTime < new Date() || !!selectedStartTime && selectedEndTime < selectedStartTime,
                                    className: "text-white bg-disable bg-main-01 rounded-[12px] max-h-[34px] py-[6px] px-[24px]",
                                    onClick: onSubmitSelectTime,
                                    children: t("news.set_time")
                                })
                            ]
                        }),
                        selectedEndTime < new Date() ? /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                            className: "mt-1 text-xs Nunito-400 text-main-red",
                            children: t("news.please_select_future_date")
                        }) : !!selectedStartTime && selectedEndTime < selectedStartTime ? /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                            className: "mt-1 text-xs Nunito-400 text-main-red",
                            children: t("news.end_time_larger")
                        }) : ""
                    ]
                })
            })
        });
    }, [
        openEndTime,
        timeEnd,
        selectedStartTime,
        selectedEndTime
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "flex-1 w-full",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(dialog/* Dialog */.Vq, {
            open: openEndTime,
            onOpenChange: onCloseSelectEndDate,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(dialog/* DialogTrigger */.hg, {
                    className: "w-full",
                    asChild: true,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(ui_button/* Button */.z, {
                        variant: "none",
                        className: "bg-disable w-full text-neutral flex justify-between items-center py-[8px] dark:text-white",
                        onClick: ()=>setOpenEndTime(true),
                        children: [
                            selectedEndTime && /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                className: "text-sm Nunito-500 text-main-01",
                                children: t("news.end")
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                children: selectedEndTime ? moment_default()(selectedEndTime).format(configs/* DATE_FORMAT_3 */.Ly) : t("news.end")
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(IconCalendar/* IconCalendar */.j, {})
                        ]
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(dialog/* DialogContent */.cZ, {
                    className: "w-[90vw] rounded-[24px] p-4 dark:border-0 dark:bg-[#1A1925]",
                    children: memoCalendar
                })
            ]
        })
    });
};

;// CONCATENATED MODULE: ./app/containers/create-post/add-on/EventDate.tsx







const EventDate = ()=>{
    const { t  } = (0,esm/* useTranslation */.$G)();
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "relative w-full",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                className: "text-bg-01 text-[18px] Nunito-700 dark:text-white",
                children: t("news.time_happen")
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "w-full hidden md:flex items-center justify-between flex-wrap",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(StartTime, {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(EndTime, {})
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "w-full md:hidden flex items-center justify-between flex-wrap",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(StartTimeMobile, {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(EndTimeMobile, {})
                ]
            })
        ]
    });
};

;// CONCATENATED MODULE: ./app/containers/create-post/add-on/TimePublic.tsx
/**
 * Cho phép chọn thời gian đăng bài, nhưng sẽ ẩn nếu về mobile,
 * Hẹn thời gian đăng bài ở mobile sẽ chuyển sang phần submit của editor
 */ 








const TimePublic = (param)=>{
    let {} = param;
    const { t  } = (0,esm/* useTranslation */.$G)();
    const [open, setOpen] = (0,react.useState)(false);
    const [publicNow, setPublicNow] = (0,react.useState)("true");
    const [timeValue, setTimeValue] = react.useState("00:00");
    const { setValue , watch  } = (0,index_esm/* useFormContext */.Gc)();
    const selectedPublicAt = watch("public_at", undefined);
    const startTime = watch("start_time", undefined);
    (0,react.useEffect)(()=>{
        if (!!selectedPublicAt) {
            setPublicNow("false");
        }
    }, [
        selectedPublicAt
    ]);
    const handleChangeValue = (e)=>{
        var _e_target, _e_target1;
        setPublicNow(e === null || e === void 0 ? void 0 : (_e_target = e.target) === null || _e_target === void 0 ? void 0 : _e_target.value);
        if ((e === null || e === void 0 ? void 0 : (_e_target1 = e.target) === null || _e_target1 === void 0 ? void 0 : _e_target1.value) === "false") {
            setOpen(true);
        } else setValue("public_at", undefined);
    };
    const onSubmitSelectTime = (value)=>{
        setPublicNow(value);
        if (!!selectedPublicAt && value === "false") {
            setOpen(false);
        }
        if (value === "true") {
            setValue("public_at", undefined);
            setOpen(false);
        }
    };
    const handleTimeChange = (e)=>{
        const time = e.target.value;
        if (!selectedPublicAt) {
            setTimeValue(time);
            return;
        }
        const [hours, minutes] = time.split(":").map((str)=>parseInt(str, 10));
        const newSelectedDate = new Date(selectedPublicAt.getFullYear(), selectedPublicAt.getMonth(), selectedPublicAt.getDate(), hours, minutes);
        setValue("public_at", newSelectedDate);
        setTimeValue(time);
    };
    const handleDaySelect = (date)=>{
        if (!timeValue || !date) {
            setValue("public_at", date);
            return;
        }
        const [hours, minutes] = timeValue.split(":").map((str)=>parseInt(str, 10));
        const newDate = new Date(date.getFullYear(), date.getMonth(), date.getDate(), hours, minutes);
        setValue("public_at", newDate);
    };
    const calendar = (0,react.useMemo)(()=>{
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(ui_calendar/* Calendar */.f, {
            mode: "single",
            selected: selectedPublicAt,
            onSelect: handleDaySelect,
            className: "p-0 rounded-md",
            showOutsideDays: true,
            captionLayout: "dropdown",
            fromYear: new Date().getFullYear(),
            toYear: configs/* END_YEAR */.As,
            components: {
                Head: ()=>/*#__PURE__*/ (0,jsx_runtime.jsx)(CustomSelectMontYear/* CustomSelectMonthYear */.k, {})
            },
            footer: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "space-y-[24px]",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "flex items-center justify-between mt-2",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                className: "text-base Nunito-600 text-main-01",
                                children: [
                                    t("news.post_time"),
                                    ":"
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                type: "time",
                                value: timeValue,
                                onChange: handleTimeChange,
                                className: "text-base"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "flex items-center justify-end gap-4",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(ui_button/* Button */.z, {
                                variant: "none",
                                className: "bg-bg-disable text-neutral rounded-[12px] max-h-[34px] ",
                                onClick: ()=>onSubmitSelectTime("true"),
                                children: t("common.cancel")
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(ui_button/* Button */.z, {
                                variant: "none",
                                disabled: !selectedPublicAt || selectedPublicAt < new Date() || !!startTime && startTime < selectedPublicAt,
                                className: "text-white bg-disable bg-main-01 rounded-[12px] max-h-[34px] py-[6px] px-[24px]",
                                onClick: ()=>onSubmitSelectTime("false"),
                                children: t("news.set_time")
                            })
                        ]
                    }),
                    selectedPublicAt < new Date() && /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        className: "mt-1 text-xs Nunito-400 text-main-red",
                        children: t("news.please_select_future_date")
                    }),
                    !!startTime && startTime < selectedPublicAt && /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        className: "mt-1 text-xs Nunito-400 text-main-red",
                        children: t("news.please_select_smaller_than_start_time")
                    })
                ]
            })
        });
    }, [
        open,
        publicNow,
        timeValue,
        selectedPublicAt,
        startTime
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "hidden md:block",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "flex items-center gap-3",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                    className: "text-bg-01 text-[18px] Nunito-700 dark:text-white",
                    children: t("news.public_time")
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "space-y-[18px] mt-6",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("label", {
                        className: "flex w-full text-base cursor-pointer Nunito-400 text-neutral dark:text-white",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                type: "radio",
                                value: "true",
                                checked: publicNow === "true",
                                onChange: handleChangeValue,
                                className: "w-6 h-6 mr-4 border-gray-300 accent-main-01",
                                "aria-labelledby": "mod",
                                "aria-describedby": "mod"
                            }),
                            t("news.public_now")
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(dropdown_menu/* DropdownMenu */.h_, {
                        open: open,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(dropdown_menu/* DropdownMenuTrigger */.$F, {
                                asChild: true,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("label", {
                                    className: "relative flex w-full text-base cursor-pointer Nunito-400 text-bg-01 dark:text-white",
                                    onClick: ()=>setOpen(true),
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                            type: "radio",
                                            value: "false",
                                            checked: publicNow === "false",
                                            onChange: handleChangeValue,
                                            className: "w-6 h-6 mr-4 border-gray-300 accent-main-01",
                                            "aria-labelledby": "mod",
                                            "aria-describedby": "mod"
                                        }),
                                        !!selectedPublicAt ? selectedPublicAt.toLocaleString() : t("news.select_time")
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(dropdown_menu/* DropdownMenuContent */.AW, {
                                className: "w-[276px]",
                                align: "start",
                                side: "top",
                                children: calendar
                            })
                        ]
                    })
                ]
            })
        ]
    });
};

;// CONCATENATED MODULE: ./app/containers/create-post/add-on/PublicAtMobile.tsx









const PublicAtMobile = (param)=>{
    let { showModal , onChangeShowModal  } = param;
    const { t  } = (0,esm/* useTranslation */.$G)();
    const { setValue , watch  } = (0,index_esm/* useFormContext */.Gc)();
    const [timeValue, setTimeValue] = (0,react.useState)("00:00");
    const selectedPublicAt = watch("public_at", undefined);
    const [date, setDate] = (0,react.useState)(selectedPublicAt);
    const onSubmitSelectTime = (value)=>{
        if (!!date && value === "false") {
            setValue("public_at", date);
            onChangeShowModal();
        }
        if (value === "true") {
            setDate(undefined);
            onChangeShowModal();
        }
    };
    const handleTimeChange = (e)=>{
        const time = e.target.value;
        if (!selectedPublicAt) {
            setTimeValue(time);
            return;
        }
        const [hours, minutes] = time.split(":").map((str)=>parseInt(str, 10));
        const newSelectedDate = new Date(selectedPublicAt.getFullYear(), selectedPublicAt.getMonth(), selectedPublicAt.getDate(), hours, minutes);
        setDate(newSelectedDate);
        setTimeValue(time);
    };
    const handleDaySelect = (date)=>{
        if (!timeValue || !date) {
            setValue("public_at", date);
            return;
        }
        const [hours, minutes] = timeValue.split(":").map((str)=>parseInt(str, 10));
        const newDate = new Date(date.getFullYear(), date.getMonth(), date.getDate(), hours, minutes);
        setDate(newDate);
    };
    const onCancelPublicTime = ()=>{
        setValue("public_at", undefined);
        setTimeValue("00:00");
        setDate(undefined);
        onChangeShowModal();
    };
    const memoCalendar = (0,react.useMemo)(()=>{
        /*#__PURE__*/ return (0,jsx_runtime.jsx)("div", {
            className: "w-full bg-white space-y-[24px] dark:bg-transparent",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ui_calendar/* Calendar */.f, {
                mode: "single",
                selected: date,
                onSelect: handleDaySelect,
                className: "p-0 rounded-md",
                showOutsideDays: true,
                captionLayout: "dropdown",
                fromYear: new Date().getFullYear(),
                toYear: configs/* END_YEAR */.As,
                components: {
                    Head: ()=>/*#__PURE__*/ (0,jsx_runtime.jsx)(CustomSelectMontYear/* CustomSelectMonthYear */.k, {})
                },
                footer: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "space-y-[24px]",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "flex items-center justify-between mt-2",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                    className: "text-base Nunito-600 text-main-01",
                                    children: [
                                        t("news.post_time"),
                                        ":"
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                    type: "time",
                                    value: timeValue,
                                    onChange: handleTimeChange,
                                    className: "text-base"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "flex items-center justify-end gap-4",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(ui_button/* Button */.z, {
                                    variant: "none",
                                    className: "bg-disable text-neutral rounded-[12px] max-h-[34px] py-[6px] px-[24px]",
                                    onClick: ()=>onSubmitSelectTime("true"),
                                    children: t("common.cancel")
                                }),
                                (selectedPublicAt === null || selectedPublicAt === void 0 ? void 0 : selectedPublicAt.getTime()) !== (date === null || date === void 0 ? void 0 : date.getTime()) ? /*#__PURE__*/ (0,jsx_runtime.jsx)(ui_button/* Button */.z, {
                                    variant: "none",
                                    disabled: !date || date < new Date(),
                                    className: "text-white bg-disable bg-main-01 rounded-[12px] max-h-[34px] py-[6px] px-[24px]",
                                    onClick: ()=>onSubmitSelectTime("false"),
                                    children: t("news.set_time")
                                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(ui_button/* Button */.z, {
                                    variant: "none",
                                    className: "text-white bg-disable bg-main-01 rounded-[12px] max-h-[34px] py-[6px] px-[24px]",
                                    onClick: onCancelPublicTime,
                                    children: "Hủy hẹn lịch"
                                })
                            ]
                        }),
                        date < new Date() && /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                            className: "mt-1 text-xs Nunito-400 text-main-red",
                            children: t("news.please_select_future_date")
                        })
                    ]
                })
            })
        });
    }, [
        timeValue,
        selectedPublicAt,
        date,
        showModal
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "flex md:hidden",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(dialog/* Dialog */.Vq, {
            open: showModal,
            onOpenChange: onChangeShowModal,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(dialog/* DialogTrigger */.hg, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "".concat(!!selectedPublicAt ? "bg-main-01" : "border-main-01 border-[1px]", " rounded-[12px] w-[44px] h-[44px] min-w-[44px] min-h-[44px] flex items-center justify-center"),
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
                            width: "24",
                            height: "24",
                            viewBox: "0 0 24 24",
                            fill: "none",
                            xmlns: "http://www.w3.org/2000/svg",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                    d: "M16 2V5",
                                    stroke: selectedPublicAt ? "#fff" : "#7673E6",
                                    strokeWidth: "1.5",
                                    strokeLinecap: "round"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                    d: "M8 2V5",
                                    stroke: selectedPublicAt ? "#fff" : "#7673E6",
                                    strokeWidth: "1.5",
                                    strokeLinecap: "round"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                    d: "M3 7.5C3 5.29086 4.79086 3.5 7 3.5H17C19.2091 3.5 21 5.29086 21 7.5V18C21 20.2091 19.2091 22 17 22H7C4.79086 22 3 20.2091 3 18V7.5Z",
                                    stroke: selectedPublicAt ? "#fff" : "#7673E6",
                                    strokeWidth: "1.5"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                    d: "M3 9H21",
                                    stroke: selectedPublicAt ? "#fff" : "#7673E6",
                                    strokeWidth: "1.5",
                                    strokeLinecap: "round"
                                })
                            ]
                        })
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(dialog/* DialogContent */.cZ, {
                    className: "w-[90vw] rounded-[24px] p-4 dark:border-0 dark:bg-[#1A1925]",
                    children: memoCalendar
                })
            ]
        })
    });
};

;// CONCATENATED MODULE: ./app/containers/create-post/add-on/Submit.tsx








const Submit = (param)=>{
    let { disable , onSubmit  } = param;
    const { t  } = (0,esm/* useTranslation */.$G)();
    const [showModal, setShowModal] = (0,react.useState)(false);
    const { watch , handleSubmit  } = (0,index_esm/* useFormContext */.Gc)();
    const selectedPublicAt = watch("public_at", undefined);
    const onChangeShowModal = ()=>{
        setShowModal(!showModal);
    };
    const router = (0,next_router.useRouter)();
    const editId = (0,react.useMemo)(()=>{
        var _router_query;
        return router === null || router === void 0 ? void 0 : (_router_query = router.query) === null || _router_query === void 0 ? void 0 : _router_query.editId;
    }, [
        router
    ]);
    const type = (0,react.useMemo)(()=>{
        var _router_query;
        return router === null || router === void 0 ? void 0 : (_router_query = router.query) === null || _router_query === void 0 ? void 0 : _router_query.type;
    }, [
        router
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ui_button/* Button */.z, {
                variant: "none",
                className: "hidden md:flex text-white bg-main-01 text-[18px] Nunito-700 rounded-xl py-2 px-3",
                onClick: handleSubmit(onSubmit),
                disabled: disable,
                children: editId ? t("profile.save") : t("news.create_title", {
                    field: (type === null || type === void 0 ? void 0 : type.includes("event")) ? t("news.event") : t("news.post")
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "w-full flex md:hidden justify-between items-center gap-[8px]",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(ui_button/* Button */.z, {
                        variant: "none",
                        className: "text-white bg-main-01 text-[18px] Nunito-700 rounded-xl h-[44px] w-full items-center justify-center flex flex-col",
                        onClick: handleSubmit(onSubmit),
                        disabled: disable,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                className: "text-sm Nunito-700",
                                children: editId ? t("profile.save") : t("news.create_title", {
                                    field: (type === null || type === void 0 ? void 0 : type.includes("event")) ? t("news.event") : t("news.post")
                                })
                            }),
                            selectedPublicAt && /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                className: "text-xs Nunito-400",
                                children: [
                                    "(",
                                    moment_default()(selectedPublicAt).format("HH:mm DD/MM/YYYY"),
                                    ")"
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(PublicAtMobile, {
                        showModal: showModal,
                        onChangeShowModal: onChangeShowModal
                    })
                ]
            })
        ]
    });
};

;// CONCATENATED MODULE: ./app/containers/create-post/add-on/AddonChild.tsx










const AddonChild = (param)=>{
    let { hidden , setHidden , disable , onSubmit , hiddenContent  } = param;
    const router = (0,next_router.useRouter)();
    const type = (0,react.useMemo)(()=>{
        var _router_query;
        return router === null || router === void 0 ? void 0 : (_router_query = router.query) === null || _router_query === void 0 ? void 0 : _router_query.type;
    }, [
        router
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "w-[40px] h-[32px] flex items-center justify-center bg-bg-disable dark:bg-[#efefff]/10 rounded-[8px] cursor-pointer ".concat(hidden ? "rotate-0" : "rotate-180"),
                onClick: ()=>setHidden(!hidden),
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
                    width: "16",
                    height: "16",
                    viewBox: "0 0 16 16",
                    fill: "none",
                    xmlns: "http://www.w3.org/2000/svg",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                            d: "M15.168 2.33268L15.168 13.666C15.168 13.9393 14.9413 14.166 14.668 14.166C14.3946 14.166 14.168 13.9393 14.168 13.666L14.168 2.33268C14.168 2.05935 14.3946 1.83268 14.668 1.83268C14.9413 1.83268 15.168 2.05935 15.168 2.33268Z",
                            fill: "#7673E6"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                            d: "M14.6209 8.28715C14.5313 8.37672 14.4088 8.43329 14.2674 8.43329L1.06803 8.43328C0.794616 8.43328 0.568342 8.20701 0.568342 7.93359C0.568342 7.66018 0.794615 7.43391 1.06803 7.43391L14.2674 7.43391C14.5408 7.43391 14.767 7.66018 14.767 7.9336C14.767 8.07502 14.7105 8.19758 14.6209 8.28715Z",
                            fill: "#7673E6"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                            d: "M6.22435 13.2065C6.02729 13.4036 5.70048 13.4036 5.50342 13.2065L0.567493 8.27062C0.370441 8.07357 0.370441 7.74675 0.567494 7.54969L5.50342 2.61377C5.70048 2.41671 6.0273 2.41671 6.22435 2.61377C6.4214 2.81082 6.4214 3.13764 6.22435 3.33469L1.64888 7.91016L6.22435 12.4856C6.4214 12.6827 6.4214 13.0095 6.22435 13.2065Z",
                            fill: "#7673E6"
                        })
                    ]
                })
            }),
            !hiddenContent && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "w-full",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "".concat(type === configs/* CreateType.CREATE_EVENT */.q0.CREATE_EVENT ? "space-y-[48px]" : "space-y-[56px]", " py-4"),
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(GameMention, {}),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(TagMention, {}),
                                type === configs/* CreateType.CREATE_EVENT */.q0.CREATE_EVENT && /*#__PURE__*/ (0,jsx_runtime.jsx)(LinkEvent, {}),
                                type === configs/* CreateType.CREATE_EVENT */.q0.CREATE_EVENT && /*#__PURE__*/ (0,jsx_runtime.jsx)(EventDate, {}),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(TimePublic, {})
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Submit, {
                        disable: disable,
                        onSubmit: onSubmit
                    })
                ]
            })
        ]
    });
};

// EXTERNAL MODULE: ./app/components/ui/sheet.tsx
var sheet = __webpack_require__(87194);
;// CONCATENATED MODULE: ./app/containers/create-post/add-on/CreatePostAddon.tsx





const CreatePostAddon = (param)=>{
    let { onSubmit , disable , hidden , setHidden  } = param;
    const { isMobile  } = (0,react.useContext)(context/* MobileContext */.zw);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: isMobile ? /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(sheet/* Sheet */.yo, {
                open: hidden,
                onOpenChange: ()=>setHidden(false),
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(sheet/* SheetContent */.ue, {
                    className: "flex items-start bg-white border-0 h-dvh flex-col justify-between overflow-auto dark:bg-[#30303A]",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(AddonChild, {
                        disable: disable,
                        onSubmit: onSubmit,
                        hidden: hidden,
                        setHidden: setHidden
                    })
                })
            })
        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "flex fixed top-0 right-0 dark:bg-bg-02  ".concat(hidden ? "w-[112px] items-center" : "w-[340px] items-start", " bg-white h-screen p-[32px] flex-col justify-between overflow-auto z-20"),
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(AddonChild, {
                disable: disable,
                onSubmit: onSubmit,
                hidden: hidden,
                hiddenContent: !!hidden && !isMobile,
                setHidden: setHidden
            })
        })
    });
};

;// CONCATENATED MODULE: ./app/containers/create-post/add-on/index.ts


// EXTERNAL MODULE: ./app/services/query-fn/news/index.ts + 4 modules
var news = __webpack_require__(31033);
// EXTERNAL MODULE: ./node_modules/next/dynamic.js
var dynamic = __webpack_require__(5152);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
// EXTERNAL MODULE: ./node_modules/@tanstack/react-query/build/modern/useMutation.js + 1 modules
var useMutation = __webpack_require__(98029);
// EXTERNAL MODULE: ./app/services/services/EventServices.tsx
var EventServices = __webpack_require__(89174);
;// CONCATENATED MODULE: ./app/services/query-fn/event/create-event-mutation.ts



const addEventFn = (body)=>{
    return EventServices/* EventService.addEvent */.P.addEvent(body);
};
const editEventFn = (body)=>{
    return EventServices/* EventService.editEvent */.P.editEvent(body);
};
const saveDraftFn = (body)=>{
    return EventServices/* EventService.saveDraft */.P.saveDraft(body);
};
const deletaDraftFn = (body)=>{
    return EventServices/* EventService.deleteDraft */.P.deleteDraft(body);
};
const useMutationEditEvent = ()=>{
    return (0,useMutation/* useMutation */.D)({
        mutationKey: [
            configs/* QUERY_KEY.EDIT_EVENT */.lP.EDIT_EVENT
        ],
        mutationFn: editEventFn
    });
};
const useMutationCreateEvent = ()=>{
    return (0,useMutation/* useMutation */.D)({
        mutationKey: [
            configs/* QUERY_KEY.CREATE_EVENT */.lP.CREATE_EVENT
        ],
        mutationFn: addEventFn
    });
};
const useMutationSaveDraftEvent = ()=>{
    return (0,useMutation/* useMutation */.D)({
        mutationKey: [
            configs/* QUERY_KEY.SAVE_DRAFT_EVENTS */.lP.SAVE_DRAFT_EVENTS
        ],
        mutationFn: saveDraftFn
    });
};
const useMutationDeleteDraftEvent = ()=>{
    return (0,useMutation/* useMutation */.D)({
        mutationKey: [
            configs/* QUERY_KEY.DELETE_DRAFT_EVENT */.lP.DELETE_DRAFT_EVENT
        ],
        mutationFn: deletaDraftFn
    });
};

// EXTERNAL MODULE: ./app/services/query-fn/event/index.ts + 1 modules
var query_fn_event = __webpack_require__(54583);
// EXTERNAL MODULE: ./app/services/query-fn/event/event-detail-query.ts
var event_detail_query = __webpack_require__(82416);
;// CONCATENATED MODULE: ./app/containers/create-post/CreatePostContainer.tsx




















const Editor = dynamic_default()(()=>Promise.all(/* import() */[__webpack_require__.e(2937), __webpack_require__.e(6366), __webpack_require__.e(6922)]).then(__webpack_require__.bind(__webpack_require__, 26922)), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(26922)
            ]
    },
    ssr: false
});
const initialCreatePostValues = {
    title: "",
    content: "",
    thumbnail: "",
    selectedGames: [],
    public_at: undefined,
    tags: [],
    link_event: "",
    start_time: undefined,
    end_time: undefined
};
const CreatePostContainer = ()=>{
    var _router_query, _String, _router_query1, _String1;
    const methods = (0,index_esm/* useForm */.cI)({
        defaultValues: initialCreatePostValues
    });
    const { themeApp  } = (0,react.useContext)(context/* AppContext */.Il);
    const { control , setValue , watch , getValues  } = methods;
    const { t  } = (0,esm/* useTranslation */.$G)();
    const { toast  } = (0,use_toast/* useToast */.pm)();
    const { userInfo  } = (0,react.useContext)(context/* AppContext */.Il);
    const router = (0,next_router.useRouter)();
    const type = (0,react.useMemo)(()=>{
        var _router_query;
        return router === null || router === void 0 ? void 0 : (_router_query = router.query) === null || _router_query === void 0 ? void 0 : _router_query.type;
    }, [
        router
    ]);
    const editId = (0,react.useMemo)(()=>{
        var _router_query;
        return router === null || router === void 0 ? void 0 : (_router_query = router.query) === null || _router_query === void 0 ? void 0 : _router_query.editId;
    }, [
        router
    ]);
    const [showAlert, setShowAlert] = (0,react.useState)(false);
    const [showAlertDraft, setShowAlertDraft] = (0,react.useState)(false);
    const [hidden, setHidden] = (0,react.useState)(false);
    const [navigateUrl, setNavigateUrl] = (0,react.useState)("");
    const [isLoading, setIsLoading] = (0,react.useState)(false);
    const titleRef = (0,react.useRef)(null);
    const queryClient = (0,QueryClientProvider/* useQueryClient */.NL)();
    const dataDraftNews = (0,news/* useQueryCheckDraft */.wN)(String(type));
    const dataDraftEvent = (0,query_fn_event/* useQueryCheckDraftEvent */.Fu)(String(type));
    const dataDraft = (0,react.useMemo)(()=>{
        var _errorData_data;
        const data = type === configs/* CreateType.CREATE_EVENT */.q0.CREATE_EVENT ? dataDraftEvent : dataDraftNews;
        const errorData = data === null || data === void 0 ? void 0 : data.error;
        var _data_data;
        return (_data_data = data === null || data === void 0 ? void 0 : data.data) !== null && _data_data !== void 0 ? _data_data : errorData === null || errorData === void 0 ? void 0 : (_errorData_data = errorData.data) === null || _errorData_data === void 0 ? void 0 : _errorData_data.data;
    }, [
        dataDraftEvent,
        dataDraftNews,
        type
    ]);
    // news
    const { data: detailEditNews  } = (0,news/* useQueryGetNewsDetailForEdit */.mM)(String(router === null || router === void 0 ? void 0 : (_router_query = router.query) === null || _router_query === void 0 ? void 0 : _router_query.editId), (_String = String(type)) === null || _String === void 0 ? void 0 : _String.replace("create-", ""));
    const { mutate: mutateCreatePost , isPending: isPendingCreatePost  } = (0,news/* useMutationCreateNews */.Qk)();
    const { mutate: mutateSaveDraft  } = (0,news/* useMutationSaveDraft */.Wy)();
    const { mutate: mutateDeleteDraft , isPending: isPendingDeleteDraft  } = (0,news/* useMutationDeleteDraft */.fG)();
    const { mutate: mutateEditNews , isPending: isPendingEditNews  } = (0,news/* useMutationEditNews */.XF)();
    const GAEventsTracker = (0,useGAEventsTracker/* default */.Z)("User_Post_Action");
    // event
    const { data: detailEditEvent  } = (0,event_detail_query/* useQueryGetEventDetailForEdit */.w)(String(router === null || router === void 0 ? void 0 : (_router_query1 = router.query) === null || _router_query1 === void 0 ? void 0 : _router_query1.editId), (_String1 = String(type)) === null || _String1 === void 0 ? void 0 : _String1.replace("create-", ""));
    const { mutate: mutateCreateEvent , isPending: isPendingCreateEvent  } = useMutationCreateEvent();
    const { mutate: mutateSaveDraftEvent  } = useMutationSaveDraftEvent();
    const { mutate: mutateDeleteDraftEvent , isPending: isPendingDeleteDraftEvent  } = useMutationDeleteDraftEvent();
    const { mutate: mutateEditEvent , isPending: isPendingEditEvent  } = useMutationEditEvent();
    const fillDataIfExist = (data)=>{
        var _data_game, _ref;
        setValue("content", data === null || data === void 0 ? void 0 : data.content);
        if (data === null || data === void 0 ? void 0 : (_data_game = data.game) === null || _data_game === void 0 ? void 0 : _data_game.id) setValue("selectedGames", [
            data === null || data === void 0 ? void 0 : data.game
        ]);
        if (data === null || data === void 0 ? void 0 : data.hashtag) {
            if (Array.isArray(data === null || data === void 0 ? void 0 : data.hashtag)) {
                setValue("tags", data === null || data === void 0 ? void 0 : data.hashtag);
            } else {
                const result = [];
                for(let tag in data === null || data === void 0 ? void 0 : data.hashtag){
                    result.push(data === null || data === void 0 ? void 0 : data.hashtag[tag]);
                }
                setValue("tags", result);
            }
        }
        if (!!titleRef && !!(titleRef === null || titleRef === void 0 ? void 0 : titleRef.current)) {
            titleRef.current.innerText = data === null || data === void 0 ? void 0 : data.title;
            setValue("title", data === null || data === void 0 ? void 0 : data.title);
        }
        setValue("thumbnail", data === null || data === void 0 ? void 0 : data.thumbnail);
        if (data === null || data === void 0 ? void 0 : data.link_event) setValue("link_event", data === null || data === void 0 ? void 0 : data.link_event);
        if (!!(data === null || data === void 0 ? void 0 : data.start_time)) {
            setValue("start_time", moment_default().unix(data === null || data === void 0 ? void 0 : data.start_time).toDate());
        }
        if (!!(data === null || data === void 0 ? void 0 : data.end_time)) {
            setValue("end_time", moment_default().unix(data === null || data === void 0 ? void 0 : data.end_time).toDate());
        }
        const date = (_ref = new Date()) === null || _ref === void 0 ? void 0 : _ref.getTime();
        if (!!(data === null || data === void 0 ? void 0 : data.public_at) && (data === null || data === void 0 ? void 0 : data.public_at) * 1000 > date) {
            setValue("public_at", moment_default().unix(data === null || data === void 0 ? void 0 : data.public_at).toDate());
        }
        if (showAlertDraft) setShowAlertDraft(!showAlertDraft);
    };
    (0,react.useEffect)(()=>{
        if ((dataDraft === null || dataDraft === void 0 ? void 0 : dataDraft.id) && !showAlertDraft) {
            setShowAlertDraft(true);
        }
    }, [
        dataDraft
    ]);
    (0,react.useEffect)(()=>{
        if (!!detailEditEvent || detailEditNews) {
            const detail = type === configs/* CreateType.CREATE_POST */.q0.CREATE_POST ? detailEditNews : detailEditEvent;
            if (detail) {
                fillDataIfExist(detail === null || detail === void 0 ? void 0 : detail.post);
            }
        }
    }, [
        detailEditNews,
        detailEditEvent
    ]);
    (0,react.useEffect)(()=>{
        if (!!navigateUrl && !!router) {
            setIsLoading(true);
            router.push(navigateUrl);
        }
        return ()=>{
            setIsLoading(false);
        };
    }, [
        navigateUrl,
        router
    ]);
    const tranformDataBeforeSubmit = (data)=>{
        var _data_selectedGames;
        const { selectedGames , tags , public_at , link_event , start_time , end_time , ...dataWithoutTranform } = data;
        const result = {
            ...dataWithoutTranform,
            hashtag: data === null || data === void 0 ? void 0 : data.tags,
            game_id: data === null || data === void 0 ? void 0 : (_data_selectedGames = data.selectedGames) === null || _data_selectedGames === void 0 ? void 0 : _data_selectedGames.map((item)=>item.id)[0]
        };
        if (!!public_at) {
            result.public_at = moment_default()(public_at).format("YYYY-MM-DD HH:mm:ss");
        }
        if (!!link_event && type === configs/* CreateType.CREATE_EVENT */.q0.CREATE_EVENT) {
            result.link_event = link_event;
        }
        if (!!start_time && type === configs/* CreateType.CREATE_EVENT */.q0.CREATE_EVENT) {
            result.start_time = moment_default()(start_time).format("YYYY-MM-DD HH:mm:ss");
        }
        if (!!end_time && type === configs/* CreateType.CREATE_EVENT */.q0.CREATE_EVENT) {
            result.end_time = moment_default()(end_time).format("YYYY-MM-DD HH:mm:ss");
        }
        return result;
    };
    const isDisable = ()=>{
        var _watchTitle_trim;
        return isPendingCreatePost || isPendingCreateEvent || isPendingEditNews || isPendingCreateEvent || !(watchTitle === null || watchTitle === void 0 ? void 0 : watchTitle.trim()) || !(watchContent === null || watchContent === void 0 ? void 0 : watchContent.trim()) || !watchThumbnail || ((_watchTitle_trim = watchTitle === null || watchTitle === void 0 ? void 0 : watchTitle.trim()) === null || _watchTitle_trim === void 0 ? void 0 : _watchTitle_trim.length) > configs/* MAX_LENGTH_TITLE */.yz || type === configs/* CreateType.CREATE_EVENT */.q0.CREATE_EVENT && !watchEndTime || type === configs/* CreateType.CREATE_EVENT */.q0.CREATE_EVENT && !watchStartTime || type === configs/* CreateType.CREATE_EVENT */.q0.CREATE_EVENT && !(watchLinkEvent === null || watchLinkEvent === void 0 ? void 0 : watchLinkEvent.trim()) || isLoading;
    };
    const onSubmit = (data)=>{
        const result = tranformDataBeforeSubmit(data);
        setIsLoading(true);
        if (type === configs/* CreateType.CREATE_POST */.q0.CREATE_POST) {
            mutateCreatePost(result, {
                async onSuccess (data, variables, context) {
                    GAEventsTracker("Post_Created");
                    await Promise.all([
                        queryClient.invalidateQueries({
                            queryKey: [
                                configs/* QUERY_KEY.PROFILE_INFO */.lP.PROFILE_INFO
                            ]
                        }),
                        queryClient.invalidateQueries({
                            queryKey: [
                                configs/* QUERY_KEY.LIST_NEWS */.lP.LIST_NEWS
                            ]
                        }),
                        queryClient.invalidateQueries({
                            queryKey: [
                                configs/* QUERY_KEY.LIST_NEWS_BY_USER */.lP.LIST_NEWS_BY_USER,
                                1
                            ]
                        }),
                        queryClient.invalidateQueries({
                            queryKey: [
                                configs/* QUERY_KEY.LIST_NEWS_BY_USER */.lP.LIST_NEWS_BY_USER,
                                -1
                            ]
                        }),
                        queryClient.invalidateQueries({
                            queryKey: [
                                configs/* QUERY_KEY.LIST_NEWS_LATEST */.lP.LIST_NEWS_LATEST
                            ]
                        })
                    ]);
                },
                onError (error, variables, context) {},
                onSettled (data, error, variables, context) {
                    var _data_data, _data_data_data, _data_data_data_post, _data_data1, _data_data_data1, _data_data_data_post1, _data_data2, _data_data_data2, _data_data_data_post2;
                    setIsLoading(false);
                    if (Number(data === null || data === void 0 ? void 0 : (_data_data = data.data) === null || _data_data === void 0 ? void 0 : (_data_data_data = _data_data.data) === null || _data_data_data === void 0 ? void 0 : (_data_data_data_post = _data_data_data.post) === null || _data_data_data_post === void 0 ? void 0 : _data_data_data_post.public_at) * 1000 > new Date().getTime()) {
                        var _data_data3, _data_data_data3, _data_data_data_post3;
                        setNavigateUrl("/preview/news/".concat(data === null || data === void 0 ? void 0 : (_data_data3 = data.data) === null || _data_data3 === void 0 ? void 0 : (_data_data_data3 = _data_data3.data) === null || _data_data_data3 === void 0 ? void 0 : (_data_data_data_post3 = _data_data_data3.post) === null || _data_data_data_post3 === void 0 ? void 0 : _data_data_data_post3.id));
                    } else setNavigateUrl("/detail/news/".concat((0,helpers_function/* createSlugNameDetail */.ti)(data === null || data === void 0 ? void 0 : (_data_data1 = data.data) === null || _data_data1 === void 0 ? void 0 : (_data_data_data1 = _data_data1.data) === null || _data_data_data1 === void 0 ? void 0 : (_data_data_data_post1 = _data_data_data1.post) === null || _data_data_data_post1 === void 0 ? void 0 : _data_data_data_post1.title, data === null || data === void 0 ? void 0 : (_data_data2 = data.data) === null || _data_data2 === void 0 ? void 0 : (_data_data_data2 = _data_data2.data) === null || _data_data_data2 === void 0 ? void 0 : (_data_data_data_post2 = _data_data_data2.post) === null || _data_data_data_post2 === void 0 ? void 0 : _data_data_data_post2.id)));
                }
            });
        } else {
            mutateCreateEvent(result, {
                async onSuccess (data, variables, context) {
                    GAEventsTracker("Post_Created");
                    await Promise.all([
                        queryClient.invalidateQueries({
                            queryKey: [
                                configs/* QUERY_KEY.PROFILE_INFO */.lP.PROFILE_INFO
                            ]
                        }),
                        queryClient.invalidateQueries({
                            queryKey: [
                                configs/* QUERY_KEY.LIST_EVENT */.lP.LIST_EVENT,
                                ""
                            ]
                        }),
                        queryClient.invalidateQueries({
                            queryKey: [
                                configs/* QUERY_KEY.LIST_EVENT_BY_TYPE */.lP.LIST_EVENT_BY_TYPE,
                                "all__"
                            ]
                        }),
                        queryClient.invalidateQueries({
                            queryKey: [
                                configs/* QUERY_KEY.MY_EVENT_BY_FILTER */.lP.MY_EVENT_BY_FILTER,
                                "1-10"
                            ]
                        }),
                        queryClient.invalidateQueries({
                            queryKey: [
                                configs/* QUERY_KEY.MY_EVENT_BY_FILTER */.lP.MY_EVENT_BY_FILTER,
                                "-1-10"
                            ]
                        })
                    ]);
                },
                onError (error, variables, context) {},
                onSettled (data, error, variables, context) {
                    var _data_data, _data_data_data, _data_data_data_post, _data_data1, _data_data_data1, _data_data_data_post1, _data_data2, _data_data_data2, _data_data_data_post2;
                    setIsLoading(false);
                    if (Number(data === null || data === void 0 ? void 0 : (_data_data = data.data) === null || _data_data === void 0 ? void 0 : (_data_data_data = _data_data.data) === null || _data_data_data === void 0 ? void 0 : (_data_data_data_post = _data_data_data.post) === null || _data_data_data_post === void 0 ? void 0 : _data_data_data_post.public_at) * 1000 > new Date().getTime()) {
                        var _data_data3, _data_data_data3, _data_data_data_post3;
                        setNavigateUrl("/preview/event/".concat(data === null || data === void 0 ? void 0 : (_data_data3 = data.data) === null || _data_data3 === void 0 ? void 0 : (_data_data_data3 = _data_data3.data) === null || _data_data_data3 === void 0 ? void 0 : (_data_data_data_post3 = _data_data_data3.post) === null || _data_data_data_post3 === void 0 ? void 0 : _data_data_data_post3.id));
                    } else setNavigateUrl("/detail/event/".concat((0,helpers_function/* createSlugNameDetail */.ti)(data === null || data === void 0 ? void 0 : (_data_data1 = data.data) === null || _data_data1 === void 0 ? void 0 : (_data_data_data1 = _data_data1.data) === null || _data_data_data1 === void 0 ? void 0 : (_data_data_data_post1 = _data_data_data1.post) === null || _data_data_data_post1 === void 0 ? void 0 : _data_data_data_post1.title, data === null || data === void 0 ? void 0 : (_data_data2 = data.data) === null || _data_data2 === void 0 ? void 0 : (_data_data_data2 = _data_data2.data) === null || _data_data_data2 === void 0 ? void 0 : (_data_data_data_post2 = _data_data_data2.post) === null || _data_data_data_post2 === void 0 ? void 0 : _data_data_data_post2.id)));
                }
            });
        }
    };
    const onEdit = (data)=>{
        const result = tranformDataBeforeSubmit(data);
        let id = String(editId);
        if (typeof editId === "undefined" && !!(dataDraft === null || dataDraft === void 0 ? void 0 : dataDraft.id)) {
            id = dataDraft === null || dataDraft === void 0 ? void 0 : dataDraft.id;
        }
        setIsLoading(true);
        if (type === configs/* CreateType.CREATE_POST */.q0.CREATE_POST) {
            mutateEditNews({
                ...result,
                id: id
            }, {
                async onSuccess (data, variables, context) {
                    GAEventsTracker("Post_Edited");
                    await Promise.all([
                        queryClient.invalidateQueries({
                            queryKey: [
                                configs/* QUERY_KEY.PROFILE_INFO */.lP.PROFILE_INFO
                            ]
                        }),
                        queryClient.invalidateQueries({
                            queryKey: [
                                configs/* QUERY_KEY.NEWS_DETAIL */.lP.NEWS_DETAIL,
                                id
                            ]
                        }),
                        queryClient.invalidateQueries({
                            queryKey: [
                                configs/* QUERY_KEY.NEWS_DETAIL_FOR_EDIT */.lP.NEWS_DETAIL_FOR_EDIT,
                                id
                            ]
                        }),
                        queryClient.invalidateQueries({
                            queryKey: [
                                configs/* QUERY_KEY.LIST_NEWS */.lP.LIST_NEWS
                            ]
                        }),
                        queryClient.invalidateQueries({
                            queryKey: [
                                configs/* QUERY_KEY.CHECK_DRAFT */.lP.CHECK_DRAFT
                            ]
                        }),
                        queryClient.invalidateQueries({
                            queryKey: [
                                configs/* QUERY_KEY.LIST_NEWS_LATEST */.lP.LIST_NEWS_LATEST
                            ]
                        }),
                        queryClient.invalidateQueries({
                            queryKey: [
                                configs/* QUERY_KEY.LIST_NEWS_BY_USER */.lP.LIST_NEWS_BY_USER,
                                1
                            ]
                        }),
                        queryClient.invalidateQueries({
                            queryKey: [
                                configs/* QUERY_KEY.LIST_NEWS_BY_USER */.lP.LIST_NEWS_BY_USER,
                                -1
                            ]
                        })
                    ]);
                },
                onError (error, variables, context) {},
                onSettled (data, error, variables, context) {
                    var _data_data, _data_data_data, _data_data_data_post, _data_data1, _data_data_data1, _data_data_data_post1, _data_data2, _data_data_data2, _data_data_data_post2;
                    setIsLoading(false);
                    if (Number(data === null || data === void 0 ? void 0 : (_data_data = data.data) === null || _data_data === void 0 ? void 0 : (_data_data_data = _data_data.data) === null || _data_data_data === void 0 ? void 0 : (_data_data_data_post = _data_data_data.post) === null || _data_data_data_post === void 0 ? void 0 : _data_data_data_post.public_at) * 1000 > new Date().getTime()) {
                        var _data_data3, _data_data_data3, _data_data_data_post3;
                        setNavigateUrl("/preview/news/".concat(data === null || data === void 0 ? void 0 : (_data_data3 = data.data) === null || _data_data3 === void 0 ? void 0 : (_data_data_data3 = _data_data3.data) === null || _data_data_data3 === void 0 ? void 0 : (_data_data_data_post3 = _data_data_data3.post) === null || _data_data_data_post3 === void 0 ? void 0 : _data_data_data_post3.id));
                    } else setNavigateUrl("/detail/news/".concat((0,helpers_function/* createSlugNameDetail */.ti)(data === null || data === void 0 ? void 0 : (_data_data1 = data.data) === null || _data_data1 === void 0 ? void 0 : (_data_data_data1 = _data_data1.data) === null || _data_data_data1 === void 0 ? void 0 : (_data_data_data_post1 = _data_data_data1.post) === null || _data_data_data_post1 === void 0 ? void 0 : _data_data_data_post1.title, data === null || data === void 0 ? void 0 : (_data_data2 = data.data) === null || _data_data2 === void 0 ? void 0 : (_data_data_data2 = _data_data2.data) === null || _data_data_data2 === void 0 ? void 0 : (_data_data_data_post2 = _data_data_data2.post) === null || _data_data_data_post2 === void 0 ? void 0 : _data_data_data_post2.id)));
                }
            });
        } else {
            mutateEditEvent({
                ...result,
                id: id
            }, {
                async onSuccess (data, variables, context) {
                    GAEventsTracker("Post_Edited");
                    await Promise.all([
                        queryClient.invalidateQueries({
                            queryKey: [
                                configs/* QUERY_KEY.PROFILE_INFO */.lP.PROFILE_INFO
                            ]
                        }),
                        queryClient.invalidateQueries({
                            queryKey: [
                                configs/* QUERY_KEY.EVENT_DETAIL */.lP.EVENT_DETAIL,
                                id
                            ]
                        }),
                        queryClient.invalidateQueries({
                            queryKey: [
                                configs/* QUERY_KEY.EVENT_DETAIL_FOR_EDIT */.lP.EVENT_DETAIL_FOR_EDIT,
                                id
                            ]
                        }),
                        queryClient.invalidateQueries({
                            queryKey: [
                                configs/* QUERY_KEY.LIST_EVENT */.lP.LIST_EVENT,
                                ""
                            ]
                        }),
                        queryClient.invalidateQueries({
                            queryKey: [
                                configs/* QUERY_KEY.MY_EVENT_BY_FILTER */.lP.MY_EVENT_BY_FILTER,
                                "1-10"
                            ]
                        }),
                        queryClient.invalidateQueries({
                            queryKey: [
                                configs/* QUERY_KEY.MY_EVENT_BY_FILTER */.lP.MY_EVENT_BY_FILTER,
                                "-1-10"
                            ]
                        }),
                        queryClient.invalidateQueries({
                            queryKey: [
                                configs/* QUERY_KEY.CHECK_DRAFT_EVENT */.lP.CHECK_DRAFT_EVENT
                            ]
                        })
                    ]);
                },
                onError (error, variables, context) {},
                onSettled (data, error, variables, context) {
                    var _data_data, _data_data_data, _data_data_data_post, _data_data1, _data_data_data1, _data_data_data_post1, _data_data2, _data_data_data2, _data_data_data_post2;
                    setIsLoading(false);
                    if (Number(data === null || data === void 0 ? void 0 : (_data_data = data.data) === null || _data_data === void 0 ? void 0 : (_data_data_data = _data_data.data) === null || _data_data_data === void 0 ? void 0 : (_data_data_data_post = _data_data_data.post) === null || _data_data_data_post === void 0 ? void 0 : _data_data_data_post.public_at) * 1000 > new Date().getTime()) {
                        var _data_data3, _data_data_data3, _data_data_data_post3;
                        setNavigateUrl("/preview/event/".concat(data === null || data === void 0 ? void 0 : (_data_data3 = data.data) === null || _data_data3 === void 0 ? void 0 : (_data_data_data3 = _data_data3.data) === null || _data_data_data3 === void 0 ? void 0 : (_data_data_data_post3 = _data_data_data3.post) === null || _data_data_data_post3 === void 0 ? void 0 : _data_data_data_post3.id));
                    } else setNavigateUrl("/detail/event/".concat((0,helpers_function/* createSlugNameDetail */.ti)(data === null || data === void 0 ? void 0 : (_data_data1 = data.data) === null || _data_data1 === void 0 ? void 0 : (_data_data_data1 = _data_data1.data) === null || _data_data_data1 === void 0 ? void 0 : (_data_data_data_post1 = _data_data_data1.post) === null || _data_data_data_post1 === void 0 ? void 0 : _data_data_data_post1.title, data === null || data === void 0 ? void 0 : (_data_data2 = data.data) === null || _data_data2 === void 0 ? void 0 : (_data_data_data2 = _data_data2.data) === null || _data_data_data2 === void 0 ? void 0 : (_data_data_data_post2 = _data_data_data2.post) === null || _data_data_data_post2 === void 0 ? void 0 : _data_data_data_post2.id)));
                }
            });
        }
    };
    /** Save Draft */ const onSaveDraft = ()=>{
        var _getValues;
        const result = {
            title: watchTitle,
            content: watchContent,
            hashtag: getValues("tags"),
            game_id: (_getValues = getValues("selectedGames")) === null || _getValues === void 0 ? void 0 : _getValues.map((item)=>item.id)[0],
            public_at: moment_default()(getValues("public_at")).format("YYYY/MM/DD HH:mm:ss "),
            thumbnail: getValues("thumbnail")
        };
        if (!!watchLinkEvent && type === configs/* CreateType.CREATE_EVENT */.q0.CREATE_EVENT) {
            result.link_event = watchLinkEvent;
        }
        if (!!watchStartTime && type === configs/* CreateType.CREATE_EVENT */.q0.CREATE_EVENT) {
            result.start_time = moment_default()(watchStartTime).format("YYYY-MM-DD HH:mm:ss");
        }
        if (!!watchEndTime && type === configs/* CreateType.CREATE_EVENT */.q0.CREATE_EVENT) {
            result.end_time = moment_default()(watchEndTime).format("YYYY-MM-DD HH:mm:ss");
        }
        const mutate = type === configs/* CreateType.CREATE_EVENT */.q0.CREATE_EVENT ? mutateSaveDraftEvent : mutateSaveDraft;
        mutate(result, {
            onSuccess (data, variables, context) {
                setShowAlert(false);
                router.back();
            },
            onError (error, variables, context) {}
        });
    };
    /** DeleteDraft */ const onDeleteDraft = ()=>{
        const mutate = type === configs/* CreateType.CREATE_EVENT */.q0.CREATE_EVENT ? mutateDeleteDraftEvent : mutateDeleteDraft;
        mutate({
            id: dataDraft === null || dataDraft === void 0 ? void 0 : dataDraft.id
        }, {
            onSuccess (data, variables, context) {
                queryClient.invalidateQueries({
                    queryKey: [
                        configs/* QUERY_KEY.CHECK_DRAFT */.lP.CHECK_DRAFT
                    ],
                    refetchType: "active"
                });
                queryClient.invalidateQueries({
                    queryKey: [
                        configs/* QUERY_KEY.CHECK_DRAFT_EVENT */.lP.CHECK_DRAFT_EVENT
                    ],
                    refetchType: "active"
                });
                setShowAlertDraft(false);
            },
            onError (error, variables, context) {}
        });
    };
    const watchTitle = watch("title", "");
    const watchContent = watch("content", "");
    const watchThumbnail = watch("thumbnail", "");
    const watchStartTime = watch("start_time", undefined);
    const watchEndTime = watch("end_time", undefined);
    const watchLinkEvent = watch("link_event", "");
    // true: save draft, false: cancel save
    const onSubmitAlert = (value)=>{
        if (value) {
            onSaveDraft();
        } else {
            setShowAlert(false);
            router.push("/news");
        }
    };
    const throwError = (message)=>{
        toast({
            variant: "error",
            title: message
        });
    };
    const showAlertSaveDraft = ()=>{
        var _router_query;
        if (!!watchTitle && !!watchContent && !(router === null || router === void 0 ? void 0 : (_router_query = router.query) === null || _router_query === void 0 ? void 0 : _router_query.editId)) {
            setShowAlert(true);
        } else router.push("/news");
    };
    (0,react.useEffect)(()=>{
        router.beforePopState((param)=>{
            let { as  } = param;
            if (as !== router.asPath) {
                // Will run when leaving the current page; on back/forward actions
                // Add your logic here, like toggling the modal state
                showAlertSaveDraft();
            }
            return false;
        });
    // return () => {
    //     router.beforePopState(() => true);
    // };
    }, [
        router
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("main", {
        className: "overflow-auto relative w-full flex flex-col justify-center items-start md:items-center py-2 md:py-[100px] gap-[48px] md:gap-0",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "hidden ld:flex absolute top-[50px] left-[75px] w-[32px] h-[32px] bg-main-01 rounded-xl items-center justify-center cursor-pointer p-0",
                onClick: showAlertSaveDraft,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
                    width: "28",
                    height: "28",
                    viewBox: "0 0 28 28",
                    fill: "none",
                    xmlns: "http://www.w3.org/2000/svg",
                    className: "text-white",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M11.6667 9.3335L7 14.0002M7 14.0002L11.6667 18.6668M7 14.0002L21 14.0002",
                        stroke: "#FAF8FF",
                        strokeWidth: "1.5",
                        strokeLinecap: "round",
                        strokeLinejoin: "round"
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "flex items-center justify-between w-full p-4 ld:hidden",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "flex w-[32px] h-[32px] bg-bg-disable rounded-[8px] items-center justify-center dark:bg-[#efefff]/10",
                        onClick: showAlertSaveDraft,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
                            width: "24",
                            height: "24",
                            viewBox: "0 0 24 24",
                            fill: "none",
                            xmlns: "http://www.w3.org/2000/svg",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                d: "M14 7L10 12L14 17",
                                stroke: "#7673E6",
                                strokeWidth: "1.5",
                                strokeLinecap: "round",
                                strokeLinejoin: "round"
                            })
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "w-[40px] h-[32px] flex items-center justify-center bg-bg-disable rounded-[8px] dark:bg-[#efefff]/10",
                        onClick: ()=>setHidden(true),
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
                            width: "16",
                            height: "16",
                            viewBox: "0 0 16 16",
                            fill: "none",
                            xmlns: "http://www.w3.org/2000/svg",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                    d: "M15.168 2.33268L15.168 13.666C15.168 13.9393 14.9413 14.166 14.668 14.166C14.3946 14.166 14.168 13.9393 14.168 13.666L14.168 2.33268C14.168 2.05935 14.3946 1.83268 14.668 1.83268C14.9413 1.83268 15.168 2.05935 15.168 2.33268Z",
                                    fill: "#7673E6"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                    d: "M14.6209 8.28715C14.5313 8.37672 14.4088 8.43329 14.2674 8.43329L1.06803 8.43328C0.794616 8.43328 0.568342 8.20701 0.568342 7.93359C0.568342 7.66018 0.794615 7.43391 1.06803 7.43391L14.2674 7.43391C14.5408 7.43391 14.767 7.66018 14.767 7.9336C14.767 8.07502 14.7105 8.19758 14.6209 8.28715Z",
                                    fill: "#7673E6"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                    d: "M6.22435 13.2065C6.02729 13.4036 5.70048 13.4036 5.50342 13.2065L0.567493 8.27062C0.370441 8.07357 0.370441 7.74675 0.567494 7.54969L5.50342 2.61377C5.70048 2.41671 6.0273 2.41671 6.22435 2.61377C6.4214 2.81082 6.4214 3.13764 6.22435 3.33469L1.64888 7.91016L6.22435 12.4856C6.4214 12.6827 6.4214 13.0095 6.22435 13.2065Z",
                                    fill: "#7673E6"
                                })
                            ]
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_esm/* FormProvider */.RV, {
                ...methods,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "flex-1 w-full max-w-full md:w-[55%] md:max-w-[55%] min-h-[80vh]",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Controller */.Qr, {
                                name: "title",
                                control: control,
                                render: (param)=>{
                                    let { field  } = param;
                                    var _field_value, _field_value1;
                                    /*#__PURE__*/ return (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                                                className: "editor-title w-full text-bg-01 dark:text-white Nunito-700 text-[24px] md:text-[40px] outline-none bg-transparent border-0 px-4 md:px-0",
                                                contentEditable: true,
                                                ref: titleRef,
                                                placeholder: t("news.please_input_title", {
                                                    field: type === configs/* CreateType.CREATE_EVENT */.q0.CREATE_EVENT ? t("news.event") : t("news.post")
                                                }),
                                                onInput: (e)=>{
                                                    var _e_target;
                                                    setValue(field === null || field === void 0 ? void 0 : field.name, e === null || e === void 0 ? void 0 : (_e_target = e.target) === null || _e_target === void 0 ? void 0 : _e_target.innerText);
                                                }
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: "mt-[32px] px-4 md:px-0",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                        className: "text-base text-bg-01 Nunito-500 dark:text-white",
                                                        children: "(".concat((_field_value = field.value) === null || _field_value === void 0 ? void 0 : _field_value.length, "/").concat(configs/* MAX_LENGTH_TITLE */.yz, " k\xfd tự)")
                                                    }),
                                                    ((_field_value1 = field.value) === null || _field_value1 === void 0 ? void 0 : _field_value1.length) > configs/* MAX_LENGTH_TITLE */.yz && /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                        className: "text-xs text-main-red-02 Nunito-400",
                                                        children: t("news.limit_title_alert")
                                                    })
                                                ]
                                            })
                                        ]
                                    });
                                }
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Controller */.Qr, {
                                name: "content",
                                control: control,
                                render: (param)=>/*#__PURE__*/ {
                                    let { field: { value , onChange  }  } = param;
                                    return (0,jsx_runtime.jsx)(Editor, {
                                        id: "post-editor",
                                        value: value,
                                        onChange: onChange,
                                        themApp: themeApp,
                                        throwError: throwError
                                    });
                                }
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(CreatePostAddon, {
                        hidden: hidden,
                        setHidden: setHidden,
                        onSubmit: editId ? onEdit : (dataDraft === null || dataDraft === void 0 ? void 0 : dataDraft.id) ? onEdit : onSubmit,
                        disable: isDisable()
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(dialog/* Dialog */.Vq, {
                open: showAlert,
                onOpenChange: ()=>setShowAlert(false),
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dialog/* DialogContent */.cZ, {
                    className: "rounded-[24px] sm:rounded-[24px] max-w-[95vw] md:max-w-[320px] p-[24px] border-0 focus-visible:outline-none",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "flex flex-col items-center justify-center w-full",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                className: "text-base Nunito-700 text-bg-01 dark:text-white",
                                children: t("news.save_draft")
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "flex items-center justify-end w-full mt-[32px] gap-[16px]",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ui_button/* Button */.z, {
                                        variant: "none",
                                        className: "text-sm bg-bg-button text-main-01 Nunito-700 rounded-[8px] px-[16px] py-[6px] h-[36px]",
                                        autoFocus: false,
                                        onClick: ()=>onSubmitAlert(false),
                                        children: t("common.cancel")
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ui_button/* Button */.z, {
                                        variant: "none",
                                        className: "text-sm text-white bg-main-01 Nunito-700 rounded-[8px] px-[16px] py-[6px] h-[36px]",
                                        onClick: ()=>onSubmitAlert(true),
                                        children: t("profile.save")
                                    })
                                ]
                            })
                        ]
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(dialog/* Dialog */.Vq, {
                open: showAlertDraft,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dialog/* DialogContent */.cZ, {
                    className: "sm:rounded-[24px] md:max-w-[320px] p-[24px] border-0 focus-visible:outline-none",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "flex flex-col items-center justify-center w-full",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                className: "text-base Nunito-700 text-bg-01",
                                children: t("news.draft_exist")
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "flex items-center justify-end w-full mt-[32px] gap-[16px]",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ui_button/* Button */.z, {
                                        variant: "none",
                                        className: "text-sm bg-bg-button text-main-01 Nunito-700",
                                        autoFocus: false,
                                        disabled: isPendingDeleteDraft || isPendingDeleteDraftEvent,
                                        onClick: onDeleteDraft,
                                        children: t("news.delete_draft")
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ui_button/* Button */.z, {
                                        variant: "none",
                                        className: "text-sm text-white bg-main-01 Nunito-700",
                                        disabled: isPendingDeleteDraft || isPendingDeleteDraftEvent,
                                        onClick: ()=>fillDataIfExist(dataDraft),
                                        children: t("news.continue_edit")
                                    })
                                ]
                            })
                        ]
                    })
                })
            })
        ]
    });
};

;// CONCATENATED MODULE: ./app/containers/create-post/SelectCreatePostModal.tsx








const SelectCreatePostModal = ()=>{
    const { t  } = (0,esm/* useTranslation */.$G)();
    const router = (0,next_router.useRouter)();
    const { openModal , setOpenModal  } = (0,react.useContext)(context/* AppContext */.Il);
    const onRemoveParamAndNavigate = (0,react.useCallback)((type)=>{
        router.push("/create-post?type=".concat(type));
    }, [
        router
    ]);
    const handleClose = ()=>{
        setOpenModal(null);
    };
    const handleChooseType = (type)=>()=>{
            onRemoveParamAndNavigate(type);
            handleClose();
        };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(dialog/* Dialog */.Vq, {
        open: openModal === configs/* OPEN_MODAL.SELECT_CREATE_POST_MODAL */.a6.SELECT_CREATE_POST_MODAL,
        onOpenChange: handleClose,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dialog/* DialogContent */.cZ, {
            className: "sm:rounded-[48px] md:max-w-[473px] py-[48px] px-[24px] md:px-[60px] bg-transparent dark:bg-transparent border-0 focus-visible:outline-none shadow-none",
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "flex items-center justify-center w-full gap-16",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "outline-none cursor-pointer",
                        onClick: handleChooseType(configs/* CreateType.CREATE_POST */.q0.CREATE_POST),
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "bg-white w-[48px] h-[48px] rounded-[12px] flex items-center justify-center",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(icon_tsx/* IconSelectCreatePost */.l6, {})
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                className: "mt-4 text-center text-white",
                                children: t("news.upper_news")
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "outline-none cursor-pointer",
                        onClick: handleChooseType(configs/* CreateType.CREATE_EVENT */.q0.CREATE_EVENT),
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "bg-white w-[48px] h-[48px] rounded-[12px] flex items-center justify-center",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(icon_tsx/* IconSelectCreateEvent */.D5, {})
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                className: "mt-4 text-center text-white",
                                children: t("news.upper_event")
                            })
                        ]
                    })
                ]
            })
        })
    });
};

;// CONCATENATED MODULE: ./app/containers/create-post/index.ts



;// CONCATENATED MODULE: ./app/containers/index.ts




/***/ }),

/***/ 44096:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "j": function() { return /* binding */ facebookPixel; }
/* harmony export */ });
const onTrackPageView = (pixel, detailItem)=>{
    if (!!pixel && !!detailItem) {
        pixel.trackEvent("S1_PageView", {
            content_ids: detailItem === null || detailItem === void 0 ? void 0 : detailItem.id,
            content_category: "merchandise",
            content_name: detailItem === null || detailItem === void 0 ? void 0 : detailItem.name
        });
    }
};
const onTrackTimeView = (pixel, detailItem)=>{
    if (!!pixel && !!detailItem) {
        pixel.trackEvent("S1_Timeview", {
            content_ids: detailItem === null || detailItem === void 0 ? void 0 : detailItem.id,
            content_category: "merchandise",
            content_name: detailItem === null || detailItem === void 0 ? void 0 : detailItem.name
        });
    }
};
const onTrackBuyNow = (pixel, item)=>{
    var _item_price;
    if (!!pixel && !!item) pixel === null || pixel === void 0 ? void 0 : pixel.trackEvent("S2_BuyNow", {
        content_ids: item === null || item === void 0 ? void 0 : item.item_id,
        content_name: JSON.stringify([
            {
                id: item === null || item === void 0 ? void 0 : item.item_id,
                quantity: item === null || item === void 0 ? void 0 : item.quantity
            }
        ]),
        value: (_item_price = item === null || item === void 0 ? void 0 : item.price) !== null && _item_price !== void 0 ? _item_price : 0
    });
};
const onTrackNewAddress = (pixel)=>{
    const listPayment = window.localStorage.getItem("listPayment");
    const parstListPayment = JSON.parse(String(listPayment));
    const listId = Array.isArray(parstListPayment) ? parstListPayment === null || parstListPayment === void 0 ? void 0 : parstListPayment.map((item)=>{
        return item === null || item === void 0 ? void 0 : item.item_id;
    }) : [];
    pixel === null || pixel === void 0 ? void 0 : pixel.trackEvent("S2_Address", {
        content_category: "merchandise",
        content_ids: listId
    });
};
const onTrackVoucher = (pixel)=>{
    !!pixel && (pixel === null || pixel === void 0 ? void 0 : pixel.trackEvent("S2_Voucher"));
};
const onTrackApplyVoucher = (pixel)=>{
    const listPayment = window.localStorage.getItem("listPayment");
    const parstListPayment = JSON.parse(String(listPayment));
    const listId = Array.isArray(parstListPayment) ? parstListPayment === null || parstListPayment === void 0 ? void 0 : parstListPayment.map((item)=>{
        return item === null || item === void 0 ? void 0 : item.item_id;
    }) : [];
    const listContent = Array.isArray(parstListPayment) ? parstListPayment.map((item)=>{
        return {
            id: item === null || item === void 0 ? void 0 : item.item_id,
            quantity: item === null || item === void 0 ? void 0 : item.quantity
        };
    }) : [];
    const result = {
        content_ids: listId,
        contents: listContent
    };
    pixel === null || pixel === void 0 ? void 0 : pixel.trackEvent("S2_ApplyVoucher", result);
};
const onTrackPaymentNow = (pixel, productList)=>{
    const listId = productList.map((item)=>{
        return item === null || item === void 0 ? void 0 : item.item_id;
    });
    const listName = productList.map((item)=>{
        return item === null || item === void 0 ? void 0 : item.item_name;
    });
    const listContent = productList.map((item)=>{
        return {
            id: item === null || item === void 0 ? void 0 : item.item_id,
            quantity: item === null || item === void 0 ? void 0 : item.quantity
        };
    });
    const totalValue = productList.reduce((sum, currentItem)=>{
        return sum + Number(currentItem === null || currentItem === void 0 ? void 0 : currentItem.quantity) * Number(currentItem === null || currentItem === void 0 ? void 0 : currentItem.price);
    }, 0);
    const result = {
        content_ids: listId,
        content_name: listName,
        contents: listContent,
        currency: "VND",
        value: totalValue
    };
    !!pixel && (pixel === null || pixel === void 0 ? void 0 : pixel.trackEvent("S3_Pay", result));
};
const onTrackPaymentSuccess = (pixel, dataResult)=>{
    if (!!dataResult && !!pixel && !!(dataResult === null || dataResult === void 0 ? void 0 : dataResult.list_item)) {
        const listId = dataResult === null || dataResult === void 0 ? void 0 : dataResult.list_item.map((item)=>{
            return item === null || item === void 0 ? void 0 : item.card_id;
        });
        const listName = dataResult === null || dataResult === void 0 ? void 0 : dataResult.list_item.map((item)=>{
            return item === null || item === void 0 ? void 0 : item.item_name;
        });
        const listContent = dataResult === null || dataResult === void 0 ? void 0 : dataResult.list_item.map((item)=>{
            return {
                id: item === null || item === void 0 ? void 0 : item.card_id,
                quantity: item === null || item === void 0 ? void 0 : item.quantity
            };
        });
        const result = {
            content_ids: listId,
            content_name: listName,
            contents: listContent,
            currency: "VND",
            value: dataResult === null || dataResult === void 0 ? void 0 : dataResult.amount
        };
        !!pixel && (pixel === null || pixel === void 0 ? void 0 : pixel.trackEvent("S3_Success", result));
    }
};
const onTrackPaymentCancel = (pixel)=>{
    !!pixel && (pixel === null || pixel === void 0 ? void 0 : pixel.trackEvent("S3_Cancel"));
};
const onTrackBackToHome = (pixel)=>{
    !!pixel && (pixel === null || pixel === void 0 ? void 0 : pixel.trackEvent("S3_BackHome", {
        content_category: "merchandise"
    }));
};
const onTrackBuyAgain = (pixel)=>{
    !!pixel && (pixel === null || pixel === void 0 ? void 0 : pixel.trackEvent("S3_BuyAgain", {
        content_category: "merchandise"
    }));
};
const onTrackBackMerchandise = (pixel)=>{
    !!pixel && (pixel === null || pixel === void 0 ? void 0 : pixel.trackEvent("S3_BackMerchandise", {
        content_category: "merchandise",
        content_name: "inCardPage",
        content_type: "backMerchandise",
        currency: "VND"
    }));
};
const onTrackAddToCart = (pixel, detailItem)=>{
    if (!!pixel && !!detailItem) {
        pixel.trackEvent("S2_AddToCart", {
            content_ids: detailItem === null || detailItem === void 0 ? void 0 : detailItem.id,
            contents: detailItem === null || detailItem === void 0 ? void 0 : detailItem.name,
            currency: "VND",
            value: detailItem === null || detailItem === void 0 ? void 0 : detailItem.price
        });
    }
};
const onTrackShoppingCart = (pixel)=>{
    if (!!pixel) {
        pixel.trackEvent("S2_ShoppingCart", {
            content_category: "merchandise",
            content_name: "ViewShoppingCart",
            currency: "VND"
        });
    }
};
const facebookPixel = {
    onTrackPageView,
    onTrackTimeView,
    onTrackBuyNow,
    onTrackNewAddress,
    onTrackVoucher,
    onTrackApplyVoucher,
    onTrackPaymentNow,
    onTrackPaymentSuccess,
    onTrackPaymentCancel,
    onTrackBackToHome,
    onTrackBuyAgain,
    onTrackBackMerchandise,
    onTrackAddToCart,
    onTrackShoppingCart
};



/***/ }),

/***/ 66695:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Q": function() { return /* binding */ ListNotification; }
});

// EXTERNAL MODULE: ./node_modules/next/dist/compiled/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(41844);
// EXTERNAL MODULE: ./app/components/data-empty/index.tsx + 1 modules
var data_empty = __webpack_require__(98269);
;// CONCATENATED MODULE: ./app/components/icon-tsx/IconEvent.tsx

const IconEvent = (param)=>{
    let { className , fill  } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "12",
        height: "15",
        viewBox: "0 0 12 15",
        fill: "none",
        className: className,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M3.83333 1.33331C3.83333 1.05717 3.60948 0.833313 3.33333 0.833313C3.05719 0.833313 2.83333 1.05717 2.83333 1.33331V2.50612C1.4532 2.92631 0.389421 4.07256 0.0869288 5.49998H11.9131C11.6106 4.07256 10.5468 2.92631 9.16667 2.50613V1.33331C9.16667 1.05717 8.94281 0.833313 8.66667 0.833313C8.39052 0.833313 8.16667 1.05717 8.16667 1.33331V2.33672C8.11139 2.33446 8.05583 2.33331 8 2.33331H4C3.94417 2.33331 3.88861 2.33446 3.83333 2.33672L3.83333 1.33331ZM0 6.49998H12V10.6666C12 12.8758 10.2091 14.6666 8 14.6666H4C1.79086 14.6666 0 12.8758 0 10.6666V6.49998ZM6 10.6666C6.36819 10.6666 6.66667 10.3682 6.66667 9.99998C6.66667 9.63179 6.36819 9.33331 6 9.33331C5.63181 9.33331 5.33333 9.63179 5.33333 9.99998C5.33333 10.3682 5.63181 10.6666 6 10.6666ZM9.33333 9.99998C9.33333 10.3682 9.03486 10.6666 8.66667 10.6666C8.29848 10.6666 8 10.3682 8 9.99998C8 9.63179 8.29848 9.33331 8.66667 9.33331C9.03486 9.33331 9.33333 9.63179 9.33333 9.99998ZM3.33333 10.6666C3.70152 10.6666 4 10.3682 4 9.99998C4 9.63179 3.70152 9.33331 3.33333 9.33331C2.96514 9.33331 2.66667 9.63179 2.66667 9.99998C2.66667 10.3682 2.96514 10.6666 3.33333 10.6666Z",
            fill: fill ? fill : "#FAF8FF"
        })
    });
};

;// CONCATENATED MODULE: ./app/components/icon-tsx/IconNotiIcon.tsx

const IconNotiIcon = (param)=>{
    let { className  } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "14",
        height: "14",
        viewBox: "0 0 14 14",
        fill: "none",
        className: className,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                opacity: "0.4",
                d: "M5.66536 13.6667C8.61088 13.6667 10.9987 11.2789 10.9987 8.33333C10.9987 7.86007 10.9371 7.40121 10.8214 6.96434C10.6617 6.98783 10.4983 7 10.332 7C8.49108 7 6.9987 5.50762 6.9987 3.66667C6.9987 3.50043 7.01087 3.33704 7.03436 3.17733C6.59749 3.06164 6.13862 3 5.66536 3C2.71985 3 0.332031 5.38781 0.332031 8.33333C0.332031 11.2789 2.71985 13.6667 5.66536 13.6667Z",
                fill: "#7673E6"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M13.6667 3.66634C13.6667 5.34106 12.4316 6.72731 10.8227 6.96401C10.663 6.98751 10.4996 6.99967 10.3333 6.99967C8.49238 6.99967 7 5.50729 7 3.66634C7 3.50011 7.01217 3.33672 7.03566 3.17701C7.27236 1.56804 8.65862 0.333008 10.3333 0.333008C12.1743 0.333008 13.6667 1.82539 13.6667 3.66634Z",
                fill: "#7673E6"
            })
        ]
    });
};

// EXTERNAL MODULE: ./app/components/icon-tsx/IconStore.tsx
var IconStore = __webpack_require__(73416);
// EXTERNAL MODULE: ./app/components/ui/skeleton.tsx
var skeleton = __webpack_require__(84751);
// EXTERNAL MODULE: ./app/configs/index.ts + 3 modules
var configs = __webpack_require__(54254);
// EXTERNAL MODULE: ./node_modules/moment/moment.js
var moment = __webpack_require__(30381);
var moment_default = /*#__PURE__*/__webpack_require__.n(moment);
// EXTERNAL MODULE: ./node_modules/next-i18next/dist/esm/index.js + 41 modules
var esm = __webpack_require__(93378);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/react/index.js
var react = __webpack_require__(55784);
// EXTERNAL MODULE: ./node_modules/react-intersection-observer/index.mjs
var react_intersection_observer = __webpack_require__(42708);
// EXTERNAL MODULE: ./app/containers/reward-center/index.tsx + 38 modules
var reward_center = __webpack_require__(52389);
// EXTERNAL MODULE: ./app/components/ui/button.tsx
var ui_button = __webpack_require__(34428);
// EXTERNAL MODULE: ./app/components/ui/use-toast.ts
var use_toast = __webpack_require__(2786);
// EXTERNAL MODULE: ./app/services/query-fn/user/user-friend-mutation.ts
var user_friend_mutation = __webpack_require__(3201);
// EXTERNAL MODULE: ./node_modules/@tanstack/react-query/build/modern/QueryClientProvider.js
var QueryClientProvider = __webpack_require__(30202);
;// CONCATENATED MODULE: ./app/containers/notification/ActionFriendNotification.tsx








const ActionFriendNotification = (param)=>{
    let { noti , handleNoti  } = param;
    var _noti_content_id;
    const { t  } = (0,esm/* useTranslation */.$G)();
    const { toast  } = (0,use_toast/* useToast */.pm)();
    const { mutate: mutateDoActionFriend , isPending  } = (0,user_friend_mutation/* useMutatonDoActionRequestFriend */.CH)();
    const queryClient = (0,QueryClientProvider/* useQueryClient */.NL)();
    const onDoActionRequestFriend = (status)=>{
        var _noti_content_id;
        handleNoti(noti);
        mutateDoActionFriend({
            request_id: String(noti === null || noti === void 0 ? void 0 : (_noti_content_id = noti.content_id) === null || _noti_content_id === void 0 ? void 0 : _noti_content_id.request_id),
            status
        }, {
            onSuccess (data, variables, context) {
                var _noti_content_id;
                toast({
                    variant: "success",
                    title: status === "accepted" ? t("profile.accept_add_friend") : t("profile.cancel_add_friend")
                });
                queryClient.refetchQueries({
                    queryKey: [
                        configs/* QUERY_KEY.LIST_SUGGEST_FRIEND */.lP.LIST_SUGGEST_FRIEND
                    ]
                });
                queryClient.refetchQueries({
                    queryKey: [
                        configs/* QUERY_KEY.LIST_FRIEND */.lP.LIST_FRIEND
                    ]
                });
                queryClient.refetchQueries({
                    queryKey: [
                        configs/* QUERY_KEY.LIST_REQUEST_FRIEND */.lP.LIST_REQUEST_FRIEND
                    ]
                });
                queryClient.refetchQueries({
                    queryKey: [
                        configs/* QUERY_KEY.PROFILE_INFO */.lP.PROFILE_INFO
                    ]
                });
                queryClient.refetchQueries({
                    queryKey: [
                        configs/* QUERY_KEY.GET_PROFILE_BY_ID */.lP.GET_PROFILE_BY_ID,
                        noti === null || noti === void 0 ? void 0 : (_noti_content_id = noti.content_id) === null || _noti_content_id === void 0 ? void 0 : _noti_content_id.user_id
                    ]
                });
                queryClient.invalidateQueries({
                    queryKey: [
                        configs/* QUERY_KEY.NOTIFICATION_LIST */.lP.NOTIFICATION_LIST,
                        {
                            noticeType: "all"
                        }
                    ]
                });
                queryClient.invalidateQueries({
                    queryKey: [
                        configs/* QUERY_KEY.NOTIFICATION_LIST */.lP.NOTIFICATION_LIST,
                        {
                            noticeType: "1"
                        }
                    ]
                });
            },
            onError (error) {
                var _error_data;
                toast({
                    variant: "error",
                    title: error === null || error === void 0 ? void 0 : (_error_data = error.data) === null || _error_data === void 0 ? void 0 : _error_data.message
                });
            }
        });
    };
    if (!noti || (noti === null || noti === void 0 ? void 0 : (_noti_content_id = noti.content_id) === null || _noti_content_id === void 0 ? void 0 : _noti_content_id.confirm)) return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {});
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "mt-[12px] flex gap-[8px]",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ui_button/* Button */.z, {
                variant: "main",
                className: "h-[24px] rounded-[8px] px-[12px] text-[12px] Nunito-400",
                disabled: isPending,
                onClick: (e)=>{
                    e.stopPropagation();
                    onDoActionRequestFriend("accepted");
                },
                children: t("common.yes_did_id")
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ui_button/* Button */.z, {
                variant: "grey",
                className: "h-[24px] dark:text-neutral-08 rounded-[8px] px-[12px] text-[12px] Nunito-400 border-black/10 border bg-transparent text-neutral-06 active:opacity-60",
                disabled: isPending,
                onClick: (e)=>{
                    e.stopPropagation();
                    onDoActionRequestFriend("cancel");
                },
                children: t("group.reject")
            })
        ]
    });
};

// EXTERNAL MODULE: ./app/context/index.ts + 2 modules
var context = __webpack_require__(17986);
// EXTERNAL MODULE: ./app/hooks/useGAEventsTracker.ts
var useGAEventsTracker = __webpack_require__(64800);
// EXTERNAL MODULE: ./app/helpers/function.ts + 23 modules
var helpers_function = __webpack_require__(4203);
;// CONCATENATED MODULE: ./app/containers/notification/ListNotification.tsx


















const ListNotification = (param)=>{
    let { className , setNoticeId , listNoti , isFetching , fetchNextPage , setIsShowNotices , handleRefetch  } = param;
    var _listNoti_pages_flat, _listNoti_pages, _listNoti_pages_flat1, _listNoti_pages1, _listNoti_pages_flat2, _listNoti_pages2, _listNoti_pages_at, _listNoti_pages3;
    const router = (0,next_router.useRouter)();
    const { ref , inView  } = (0,react_intersection_observer/* useInView */.YD)();
    const { t  } = (0,esm/* useTranslation */.$G)();
    const { userInfo  } = (0,react.useContext)(context/* AppContext */.Il);
    const GAEventsTrackerNoti = (0,useGAEventsTracker/* default */.Z)("Notification");
    const queryClient = (0,QueryClientProvider/* useQueryClient */.NL)();
    react.useEffect(()=>{
        if (inView) {
            fetchNextPage();
        }
    }, [
        fetchNextPage,
        inView
    ]);
    const handleNoti = (noti)=>{
        GAEventsTrackerNoti("Notification_view", noti === null || noti === void 0 ? void 0 : noti.type);
        if (!noti.is_read) {
            setNoticeId(noti.id);
            setTimeout(()=>{
                handleRefetch();
            }, 1000);
        }
        if ([
            configs/* NOTIFICATION_TYPE.COMMENT */.tx.COMMENT,
            configs/* NOTIFICATION_TYPE.LIKE */.tx.LIKE,
            configs/* NOTIFICATION_TYPE.REPLY_COMMENT */.tx.REPLY_COMMENT
        ].includes(noti === null || noti === void 0 ? void 0 : noti.type)) {
            var _noti_content_id, _noti_content_id1;
            router.push("/detail/news/".concat((0,helpers_function/* createSlugNameDetail */.ti)(noti === null || noti === void 0 ? void 0 : (_noti_content_id = noti.content_id) === null || _noti_content_id === void 0 ? void 0 : _noti_content_id.post_title, noti === null || noti === void 0 ? void 0 : (_noti_content_id1 = noti.content_id) === null || _noti_content_id1 === void 0 ? void 0 : _noti_content_id1.post_id)));
        }
        if ([
            configs/* NOTIFICATION_TYPE.TICKET */.tx.TICKET
        ].includes(noti === null || noti === void 0 ? void 0 : noti.type)) {
            var _noti_content_id2;
            router.push({
                pathname: "/help-center/detail",
                query: {
                    faqId: (_noti_content_id2 = noti.content_id) === null || _noti_content_id2 === void 0 ? void 0 : _noti_content_id2.ticket_id,
                    view: "ticket"
                }
            });
        }
        if ([
            configs/* NOTIFICATION_TYPE.PAYMENT_RESULT */.tx.PAYMENT_RESULT
        ].includes(noti === null || noti === void 0 ? void 0 : noti.type)) {
            router.push("/user/".concat((userInfo === null || userInfo === void 0 ? void 0 : userInfo.alias) ? userInfo === null || userInfo === void 0 ? void 0 : userInfo.alias : userInfo === null || userInfo === void 0 ? void 0 : userInfo.userid, "?tab=transaction-manager"));
        }
        if ([
            configs/* NOTIFICATION_TYPE.TOPUP_GAME */.tx.TOPUP_GAME
        ].includes(noti === null || noti === void 0 ? void 0 : noti.type)) {
            router.push("/user/".concat((userInfo === null || userInfo === void 0 ? void 0 : userInfo.alias) ? userInfo === null || userInfo === void 0 ? void 0 : userInfo.alias : userInfo === null || userInfo === void 0 ? void 0 : userInfo.userid, "?tab=transaction-manager&type=topup"));
        }
        if ([
            configs/* NOTIFICATION_TYPE.CREATE_ORDER_RESULT */.tx.CREATE_ORDER_RESULT
        ].includes(noti === null || noti === void 0 ? void 0 : noti.type)) {
            router.push("/user/".concat((userInfo === null || userInfo === void 0 ? void 0 : userInfo.alias) ? userInfo === null || userInfo === void 0 ? void 0 : userInfo.alias : userInfo === null || userInfo === void 0 ? void 0 : userInfo.userid, "?tab=transaction-manager&type=merchandise"));
        }
        if ([
            configs/* NOTIFICATION_TYPE.SHOP */.tx.SHOP,
            configs/* NOTIFICATION_TYPE */.tx === null || configs/* NOTIFICATION_TYPE */.tx === void 0 ? void 0 : configs/* NOTIFICATION_TYPE.EVENT */.tx.EVENT
        ].includes(noti === null || noti === void 0 ? void 0 : noti.type)) {
            var _noti_content_id3, _noti_content_id_item, _noti_content_id4, _noti_content_id_item1;
            if ((noti === null || noti === void 0 ? void 0 : (_noti_content_id3 = noti.content_id) === null || _noti_content_id3 === void 0 ? void 0 : (_noti_content_id_item = _noti_content_id3.item) === null || _noti_content_id_item === void 0 ? void 0 : _noti_content_id_item.item_type) === "sticker") {
                router.push("/reward-center?item=other&tab=".concat(reward_center/* ENUM_NORMAL_TAB.PACKAGE */.z.PACKAGE));
            } else if ((noti === null || noti === void 0 ? void 0 : (_noti_content_id4 = noti.content_id) === null || _noti_content_id4 === void 0 ? void 0 : (_noti_content_id_item1 = _noti_content_id4.item) === null || _noti_content_id_item1 === void 0 ? void 0 : _noti_content_id_item1.item_type) === "voucher") {
                router.push("/reward-center?tab=".concat(reward_center/* ENUM_NORMAL_TAB.PACKAGE */.z.PACKAGE, "&item=voucher"));
            } else {
                router.push("/reward-center?tab=".concat(reward_center/* ENUM_NORMAL_TAB.PACKAGE */.z.PACKAGE, "&item="));
            }
        }
        if ([
            configs/* NOTIFICATION_TYPE.SPIN */.tx.SPIN
        ].includes(noti === null || noti === void 0 ? void 0 : noti.type)) {
            var _noti_content_id5, _noti_content_id6, _noti_content_id7, _noti_content_id8, _noti_content_id9, _noti_content_id10, _noti_content_id11;
            if ((noti === null || noti === void 0 ? void 0 : (_noti_content_id5 = noti.content_id) === null || _noti_content_id5 === void 0 ? void 0 : _noti_content_id5.item.type) === "point") {
                router.push("/user/".concat(userInfo === null || userInfo === void 0 ? void 0 : userInfo.userid, "?tab=transaction-manager&gold=earn-all"));
            } else if ((noti === null || noti === void 0 ? void 0 : (_noti_content_id6 = noti.content_id) === null || _noti_content_id6 === void 0 ? void 0 : _noti_content_id6.item.type) === "giftcode") {
                router.push("/reward-center?item=giftcode&tab=".concat(reward_center/* ENUM_NORMAL_TAB.PACKAGE */.z.PACKAGE));
            } else if ((noti === null || noti === void 0 ? void 0 : (_noti_content_id7 = noti.content_id) === null || _noti_content_id7 === void 0 ? void 0 : _noti_content_id7.item.type) === "gift_voucher" || (noti === null || noti === void 0 ? void 0 : (_noti_content_id8 = noti.content_id) === null || _noti_content_id8 === void 0 ? void 0 : _noti_content_id8.item.type) === "voucher" || (noti === null || noti === void 0 ? void 0 : (_noti_content_id9 = noti.content_id) === null || _noti_content_id9 === void 0 ? void 0 : _noti_content_id9.item.type) === "playee_voucher") {
                router.push("/reward-center?item=voucher&tab=".concat(reward_center/* ENUM_NORMAL_TAB.PACKAGE */.z.PACKAGE));
            } else if ((noti === null || noti === void 0 ? void 0 : (_noti_content_id10 = noti.content_id) === null || _noti_content_id10 === void 0 ? void 0 : _noti_content_id10.item.type) === "appota_card") {
                router.push("/reward-center?item=appota_card&tab=".concat(reward_center/* ENUM_NORMAL_TAB.PACKAGE */.z.PACKAGE));
            } else if ((noti === null || noti === void 0 ? void 0 : (_noti_content_id11 = noti.content_id) === null || _noti_content_id11 === void 0 ? void 0 : _noti_content_id11.item.type) === "turns") {
                router.push("/reward-center/lucky-spin");
            } else {
                router.push("/reward-center?item=other&tab=".concat(reward_center/* ENUM_NORMAL_TAB.PACKAGE */.z.PACKAGE));
            }
        }
        if ([
            configs/* NOTIFICATION_TYPE.TASK */.tx.TASK
        ].includes(noti === null || noti === void 0 ? void 0 : noti.type)) {
            var _noti_content_id12, _noti_content_id13, _noti_content_id14, _noti_content_id15, _noti_content_id16;
            if ((noti === null || noti === void 0 ? void 0 : (_noti_content_id12 = noti.content_id) === null || _noti_content_id12 === void 0 ? void 0 : _noti_content_id12.return) === "point") {
                router.push("/user/".concat(userInfo === null || userInfo === void 0 ? void 0 : userInfo.userid, "?tab=transaction-manager&gold=earn-all"));
            } else if ((noti === null || noti === void 0 ? void 0 : (_noti_content_id13 = noti.content_id) === null || _noti_content_id13 === void 0 ? void 0 : _noti_content_id13.return) === "spin_game") {
                // router.push("/reward-center/rut-li-xi")
                // router.push(`/reward-center/lucky-spin`)
                router.push("/event/landing/lordsmobile");
            } else if ((noti === null || noti === void 0 ? void 0 : (_noti_content_id14 = noti.content_id) === null || _noti_content_id14 === void 0 ? void 0 : _noti_content_id14.return) === "giftcode" || (noti === null || noti === void 0 ? void 0 : (_noti_content_id15 = noti.content_id) === null || _noti_content_id15 === void 0 ? void 0 : _noti_content_id15.return) === "gc_task") {
                router.push("/reward-center?item=giftcode&tab=".concat(reward_center/* ENUM_NORMAL_TAB.PACKAGE */.z.PACKAGE));
            } else if ((noti === null || noti === void 0 ? void 0 : (_noti_content_id16 = noti.content_id) === null || _noti_content_id16 === void 0 ? void 0 : _noti_content_id16.return) === "gift_voucher") {
                router.push("/reward-center?item=voucher&tab=".concat(reward_center/* ENUM_NORMAL_TAB.PACKAGE */.z.PACKAGE));
            } else {
                router.push("/reward-center?item=other&tab=".concat(reward_center/* ENUM_NORMAL_TAB.PACKAGE */.z.PACKAGE));
            }
        }
        if ([
            configs/* NOTIFICATION_TYPE */.tx === null || configs/* NOTIFICATION_TYPE */.tx === void 0 ? void 0 : configs/* NOTIFICATION_TYPE.PURCHASE */.tx.PURCHASE,
            configs/* NOTIFICATION_TYPE */.tx === null || configs/* NOTIFICATION_TYPE */.tx === void 0 ? void 0 : configs/* NOTIFICATION_TYPE.TOPUP_GAME_EVENT */.tx.TOPUP_GAME_EVENT
        ].includes(noti === null || noti === void 0 ? void 0 : noti.type)) {
            // router.push("/reward-center/rut-li-xi")
            // router.push(`/reward-center/lucky-spin`)
            router.push("/event/landing/lordsmobile");
        }
        if ([
            configs/* NOTIFICATION_TYPE */.tx === null || configs/* NOTIFICATION_TYPE */.tx === void 0 ? void 0 : configs/* NOTIFICATION_TYPE.EVENT_MERCHANDISE */.tx.EVENT_MERCHANDISE
        ].includes(noti === null || noti === void 0 ? void 0 : noti.type)) {
            var _noti_content_id17, _noti_content_id18, _noti_content_id19, _noti_content_id20;
            if ((noti === null || noti === void 0 ? void 0 : (_noti_content_id17 = noti.content_id) === null || _noti_content_id17 === void 0 ? void 0 : _noti_content_id17.return_type) === "giftcode" || (noti === null || noti === void 0 ? void 0 : (_noti_content_id18 = noti.content_id) === null || _noti_content_id18 === void 0 ? void 0 : _noti_content_id18.return_type) === "gc") {
                router.push("/reward-center?item=giftcode&tab=".concat(reward_center/* ENUM_NORMAL_TAB.PACKAGE */.z.PACKAGE));
            } else if ((noti === null || noti === void 0 ? void 0 : (_noti_content_id19 = noti.content_id) === null || _noti_content_id19 === void 0 ? void 0 : _noti_content_id19.return_type) === "gift_voucher" || (noti === null || noti === void 0 ? void 0 : (_noti_content_id20 = noti.content_id) === null || _noti_content_id20 === void 0 ? void 0 : _noti_content_id20.return_type) === "voucher") {
                router.push("/reward-center?item=voucher&tab=".concat(reward_center/* ENUM_NORMAL_TAB.PACKAGE */.z.PACKAGE));
            }
        }
        if ([
            configs/* NOTIFICATION_TYPE */.tx === null || configs/* NOTIFICATION_TYPE */.tx === void 0 ? void 0 : configs/* NOTIFICATION_TYPE.SEND_GIFT_FRIEND */.tx.SEND_GIFT_FRIEND
        ].includes(noti === null || noti === void 0 ? void 0 : noti.type)) {
            router.push("/reward-center?tab=".concat(reward_center/* ENUM_NORMAL_TAB.PACKAGE */.z.PACKAGE));
        }
        if ([
            configs/* NOTIFICATION_TYPE */.tx === null || configs/* NOTIFICATION_TYPE */.tx === void 0 ? void 0 : configs/* NOTIFICATION_TYPE.REG_NOTI_EVEMT */.tx.REG_NOTI_EVEMT
        ].includes(noti === null || noti === void 0 ? void 0 : noti.type)) {
            var _noti_content_id21, _noti_content_id_event, _noti_content_id22, _noti_content_id_event1;
            router.push("/detail/event/".concat((0,helpers_function/* createSlugNameDetail */.ti)(noti === null || noti === void 0 ? void 0 : (_noti_content_id21 = noti.content_id) === null || _noti_content_id21 === void 0 ? void 0 : (_noti_content_id_event = _noti_content_id21.event) === null || _noti_content_id_event === void 0 ? void 0 : _noti_content_id_event.title, noti === null || noti === void 0 ? void 0 : (_noti_content_id22 = noti.content_id) === null || _noti_content_id22 === void 0 ? void 0 : (_noti_content_id_event1 = _noti_content_id22.event) === null || _noti_content_id_event1 === void 0 ? void 0 : _noti_content_id_event1.event_id)));
        // router.push(`/detail/event/${noti.content_id?.event?.event_id}`)
        }
        if ((noti === null || noti === void 0 ? void 0 : noti.type) === configs/* NOTIFICATION_TYPE.ACCEPT_FRIEND */.tx.ACCEPT_FRIEND) {
            queryClient.invalidateQueries({
                queryKey: [
                    configs/* QUERY_KEY.PROFILE_INFO */.lP.PROFILE_INFO
                ],
                refetchType: "active"
            });
        }
        if ([
            configs/* NOTIFICATION_TYPE.BAG_EXPIRED */.tx.BAG_EXPIRED
        ].includes(noti === null || noti === void 0 ? void 0 : noti.type)) {
            router.push("/reward-center?item=voucher&tab=".concat(reward_center/* ENUM_NORMAL_TAB.PACKAGE */.z.PACKAGE));
        }
    };
    const NotiItem = (param)=>{
        let { noti  } = param;
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "py-[12px] flex gap-[8px] cursor-pointer active:opacity-60 dark:border-b-[1px] dark:border-neutral-03 dark:last:border-0",
            onClick: ()=>{
                setIsShowNotices && setIsShowNotices(false);
                handleNoti(noti);
            },
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "flex items-center h-fit gap-[4px]",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "w-[4px] h-[4px] rounded-[4px] ".concat(!!noti.is_read ? "bg-transparent" : "bg-main-01", " ")
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "w-[32px] h-[32px] rounded-[12px] bg-button dark:bg-button/10 flex items-center justify-center",
                            children: [
                                configs/* NOTIFICATION_TYPE.PAYMENT_RESULT */.tx.PAYMENT_RESULT,
                                configs/* NOTIFICATION_TYPE.TOPUP_GAME */.tx.TOPUP_GAME,
                                configs/* NOTIFICATION_TYPE.CREATE_ORDER_RESULT */.tx.CREATE_ORDER_RESULT,
                                configs/* NOTIFICATION_TYPE.SHOP */.tx.SHOP,
                                configs/* NOTIFICATION_TYPE */.tx === null || configs/* NOTIFICATION_TYPE */.tx === void 0 ? void 0 : configs/* NOTIFICATION_TYPE.EVENT */.tx.EVENT,
                                configs/* NOTIFICATION_TYPE.SPIN */.tx.SPIN,
                                configs/* NOTIFICATION_TYPE.TASK */.tx.TASK,
                                configs/* NOTIFICATION_TYPE */.tx === null || configs/* NOTIFICATION_TYPE */.tx === void 0 ? void 0 : configs/* NOTIFICATION_TYPE.PURCHASE */.tx.PURCHASE,
                                configs/* NOTIFICATION_TYPE */.tx === null || configs/* NOTIFICATION_TYPE */.tx === void 0 ? void 0 : configs/* NOTIFICATION_TYPE.TOPUP_GAME_EVENT */.tx.TOPUP_GAME_EVENT
                            ].includes(noti === null || noti === void 0 ? void 0 : noti.type) ? /*#__PURE__*/ (0,jsx_runtime.jsx)(IconStore/* IconStore */.k, {
                                className: "w-[16px] h-[16px]",
                                fill: "#7673E5"
                            }) : noti.type === configs/* NOTIFICATION_TYPE.REG_NOTI_EVEMT */.tx.REG_NOTI_EVEMT ? /*#__PURE__*/ (0,jsx_runtime.jsx)(IconEvent, {
                                className: "w-[16px] h-[16px]"
                            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(IconNotiIcon, {
                                className: "w-[16px] h-[16px]"
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "Nunito-600 text-[14px] pb-[12px] [&_strong]:text-main-01",
                            dangerouslySetInnerHTML: {
                                __html: noti.message || ""
                            }
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                            className: "text-[12px] text-main-01",
                            children: moment_default()(noti.created_at * 1000).format(configs/* DATE_FORMAT_FULL */.Ob)
                        }),
                        noti.type === configs/* NOTIFICATION_TYPE.REQUEST_FRIEND */.tx.REQUEST_FRIEND && /*#__PURE__*/ (0,jsx_runtime.jsx)(ActionFriendNotification, {
                            noti: noti,
                            handleNoti: handleNoti
                        })
                    ]
                })
            ]
        }, noti.id);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "".concat(className, " overflow-auto"),
        children: [
            !!listNoti && !!((_listNoti_pages_flat = listNoti === null || listNoti === void 0 ? void 0 : (_listNoti_pages = listNoti.pages) === null || _listNoti_pages === void 0 ? void 0 : _listNoti_pages.flat()) === null || _listNoti_pages_flat === void 0 ? void 0 : _listNoti_pages_flat.length) && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "w-full",
                children: react.Children.toArray((_listNoti_pages_flat1 = listNoti === null || listNoti === void 0 ? void 0 : (_listNoti_pages1 = listNoti.pages) === null || _listNoti_pages1 === void 0 ? void 0 : _listNoti_pages1.flat()) === null || _listNoti_pages_flat1 === void 0 ? void 0 : _listNoti_pages_flat1.map((item, index)=>/*#__PURE__*/ (0,jsx_runtime.jsx)(NotiItem, {
                        noti: item
                    })))
            }),
            isFetching && Array(3).fill("").map((index)=>{
                return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "py-[12px] flex gap-[8px]",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(skeleton/* Skeleton */.O, {
                            className: "w-[4px] mt-[14px] h-[4px] rounded-[12px] bg-[#EAEAEA] dark:bg-white/10"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(skeleton/* Skeleton */.O, {
                            className: "w-[32px] h-[32px] rounded-[12px] bg-[#EAEAEA] dark:bg-white/10"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "flex-1",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(skeleton/* Skeleton */.O, {
                                    className: "w-full h-[12px] rounded-[6px] bg-[#EAEAEA] dark:bg-white/10 mb-2"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(skeleton/* Skeleton */.O, {
                                    className: "w-full h-[12px] rounded-[6px] bg-[#EAEAEA] dark:bg-white/10 mb-4"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(skeleton/* Skeleton */.O, {
                                    className: "w-[100px] h-[12px] rounded-[8px] bg-[#EAEAEA] dark:bg-white/10"
                                })
                            ]
                        })
                    ]
                }, index);
            }),
            !((_listNoti_pages_flat2 = listNoti === null || listNoti === void 0 ? void 0 : (_listNoti_pages2 = listNoti.pages) === null || _listNoti_pages2 === void 0 ? void 0 : _listNoti_pages2.flat()) === null || _listNoti_pages_flat2 === void 0 ? void 0 : _listNoti_pages_flat2.length) && !isFetching && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "h-[300px] flex items-center justify-center",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(data_empty/* DataEmpty */.$, {
                    title: t("profile.no_data")
                })
            }),
            Number((_listNoti_pages_at = listNoti === null || listNoti === void 0 ? void 0 : (_listNoti_pages3 = listNoti.pages) === null || _listNoti_pages3 === void 0 ? void 0 : _listNoti_pages3.at(-1)) === null || _listNoti_pages_at === void 0 ? void 0 : _listNoti_pages_at.length) >= configs/* REPLY_LIMIT_SIZE */.bn && /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                ref: ref,
                className: "opacity-0",
                children: "Load more"
            })
        ]
    });
};


/***/ }),

/***/ 52389:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "z": function() { return /* binding */ ENUM_NORMAL_TAB; },
  "l": function() { return /* binding */ RewardCenterContainer; }
});

// EXTERNAL MODULE: ./node_modules/next/dist/compiled/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(41844);
// EXTERNAL MODULE: ./app/components/ui/tabs.tsx + 1 modules
var tabs = __webpack_require__(98241);
// EXTERNAL MODULE: ./node_modules/next-i18next/dist/esm/index.js + 41 modules
var esm = __webpack_require__(93378);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/react/index.js
var react = __webpack_require__(55784);
// EXTERNAL MODULE: ./app/configs/index.ts + 3 modules
var configs = __webpack_require__(54254);
// EXTERNAL MODULE: ./app/services/query-fn/game/index.ts + 1 modules
var query_fn_game = __webpack_require__(82190);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./node_modules/swiper/swiper.esm.js + 90 modules
var swiper_esm = __webpack_require__(71911);
// EXTERNAL MODULE: ./node_modules/swiper/react/swiper-react.js + 15 modules
var swiper_react = __webpack_require__(30719);
;// CONCATENATED MODULE: ./app/containers/reward-center/mission-center/RewardBanner.tsx







const RewardBanner = ()=>{
    const { data: listRewardBanner  } = (0,query_fn_game/* useQueryGetListGameBanner */.LI)({
        type: "reward"
    });
    const token = configs/* isClient */.C5 ? window.localStorage.getItem("token") : null;
    const convertLink = (url)=>{
        const link = (url === null || url === void 0 ? void 0 : url.includes("https://event.playee.vn" || 0)) && token ? "".concat(url, "?token=").concat(token) : url;
        return link;
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(swiper_react/* Swiper */.tq, {
            modules: [
                swiper_esm/* Autoplay */.pt,
                swiper_esm/* Pagination */.tl
            ],
            slidesPerView: 1,
            pagination: {
                clickable: true
            },
            autoplay: {
                delay: 5000,
                disableOnInteraction: false
            },
            children: (listRewardBanner === null || listRewardBanner === void 0 ? void 0 : listRewardBanner.length) ? listRewardBanner.map((item, i)=>{
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(swiper_react/* SwiperSlide */.o5, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "relative",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                            href: convertLink(item.click_url),
                            target: "_blank",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "rounded-[16px] overflow-hidden relative",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                    src: item === null || item === void 0 ? void 0 : item.banner,
                                    alt: item.game_id,
                                    className: "w-[100%] aspect-[3/1] object-cover"
                                })
                            })
                        })
                    })
                }, i);
            }) : null
        })
    });
};

;// CONCATENATED MODULE: ./app/components/icon-tsx/IconGift.tsx

const IconGift = (param)=>{
    let { className , fill  } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "36",
        height: "36",
        viewBox: "0 0 36 36",
        fill: "none",
        className: className,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M29 11.0007H26.605C26.846 10.5243 26.9808 10.0012 27 9.46767C26.9653 8.52443 26.5615 7.63254 25.8757 6.98408C25.1898 6.33562 24.2767 5.98247 23.333 6.00067C22.2089 6.04909 21.1191 6.40183 20.1799 7.02124C19.2406 7.64066 18.4872 8.5035 18 9.51767C17.518 8.50634 16.7703 7.64495 15.8369 7.0255C14.9034 6.40606 13.8191 6.05183 12.7 6.00067C12.662 6.00067 12.624 6.00067 12.586 6.00067C11.6558 6.00216 10.7624 6.36425 10.0936 7.01081C9.42489 7.65738 9.03287 8.53805 9 9.46767V9.53367C9.01951 10.0442 9.14878 10.5446 9.379 11.0007H7C6.73478 11.0007 6.48043 11.106 6.29289 11.2936C6.10536 11.4811 6 11.7355 6 12.0007V15.0007C6 15.2659 6.10536 15.5202 6.29289 15.7078C6.48043 15.8953 6.73478 16.0007 7 16.0007H29C29.2652 16.0007 29.5196 15.8953 29.7071 15.7078C29.8946 15.5202 30 15.2659 30 15.0007V12.0007C30 11.7355 29.8946 11.4811 29.7071 11.2936C29.5196 11.106 29.2652 11.0007 29 11.0007ZM23.364 8.00067C23.7724 7.99007 24.1695 8.13614 24.4737 8.40891C24.7779 8.68168 24.9662 9.06049 25 9.46767C24.9858 9.87699 24.8141 10.265 24.5206 10.5507C24.2271 10.8363 23.8346 10.9976 23.425 11.0007H19.478C20.1 9.74167 21.337 8.00067 23.364 8.00067ZM11 9.50067C11.0256 9.09146 11.2073 8.7077 11.5077 8.42857C11.808 8.14945 12.204 7.99628 12.614 8.00067C14.683 8.00867 15.895 9.73167 16.524 11.0007H12.624C12.2134 11.0038 11.817 10.8504 11.5154 10.5718C11.2137 10.2932 11.0295 9.91023 11 9.50067Z",
                fill: fill ? fill : "url(#paint0_linear_12722_57509)"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M20 18.0006V30.0006H25C25.7956 30.0006 26.5587 29.6845 27.1213 29.1219C27.6839 28.5593 28 27.7963 28 27.0006V18.0006H20Z",
                fill: fill ? fill : "url(#paint1_linear_12722_57509)"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M16 18.0006H8V27.0006C8 27.7963 8.31607 28.5593 8.87868 29.1219C9.44129 29.6845 10.2044 30.0006 11 30.0006H16V18.0006Z",
                fill: fill ? fill : "url(#paint2_linear_12722_57509)"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("defs", {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("linearGradient", {
                        id: "paint0_linear_12722_57509",
                        x1: "33.6923",
                        y1: "5.37496",
                        x2: "5.23446",
                        y2: "8.14991",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                "stop-color": "#B6B4F8"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                offset: "0.457045",
                                stopColor: "#AEAAF8"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                offset: "1",
                                stopColor: "#A39FD1"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("linearGradient", {
                        id: "paint1_linear_12722_57509",
                        x1: "29.2308",
                        y1: "17.2506",
                        x2: "19.6616",
                        y2: "17.5098",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                "stop-color": "#B6B4F8"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                offset: "0.457045",
                                stopColor: "#AEAAF8"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                offset: "1",
                                stopColor: "#A39FD1"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("linearGradient", {
                        id: "paint2_linear_12722_57509",
                        x1: "17.2308",
                        y1: "17.2506",
                        x2: "7.66165",
                        y2: "17.5098",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                "stop-color": "#B6B4F8"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                offset: "0.457045",
                                stopColor: "#AEAAF8"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                offset: "1",
                                stopColor: "#A39FD1"
                            })
                        ]
                    })
                ]
            })
        ]
    });
};

;// CONCATENATED MODULE: ./app/components/icon-tsx/IconGold.tsx

const IconGold = (param)=>{
    let { className  } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "16",
        height: "16",
        viewBox: "0 0 16 16",
        fill: "none",
        className: className,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M12 12C14.2091 9.79086 14.2091 6.20914 12 4C9.79086 1.79086 6.20914 1.79086 4 4C1.79086 6.20914 1.79086 9.79086 4 12C6.20914 14.2091 9.79086 14.2091 12 12Z",
                fill: "#E9B522"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M8.00045 14.7657C4.26963 14.7657 1.23438 11.7304 1.23438 7.99962C1.23438 4.26881 4.26963 1.23358 8.00045 1.23358C11.7313 1.23358 14.7665 4.26881 14.7665 7.99962C14.7665 11.7304 11.7313 14.7657 8.00045 14.7657ZM8.00045 2.34274C4.88124 2.34274 2.34354 4.88041 2.34354 7.99962C2.34354 11.1188 4.88124 13.6566 8.00045 13.6566C11.1197 13.6566 13.6574 11.1189 13.6574 7.99962C13.6574 4.88038 11.1197 2.34274 8.00045 2.34274Z",
                fill: "#F7DE61"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M1.64696 7.99962C1.64696 4.33786 4.57099 1.34648 8.20672 1.23701C8.13818 1.23494 8.06947 1.23358 8.00045 1.23358C4.26963 1.23358 1.23438 4.26881 1.23438 7.99962C1.23438 11.7304 4.26963 14.7657 8.00045 14.7657C8.0695 14.7657 8.13821 14.7643 8.20672 14.7623C4.57099 14.6528 1.64696 11.6614 1.64696 7.99962Z",
                fill: "#FFF2BD"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M7.99996 2.34296C7.93949 2.34296 7.87936 2.34425 7.81934 2.34615C10.8553 2.44187 13.2956 4.94106 13.2956 7.99983C13.2956 11.0586 10.8553 13.5578 7.81934 13.6536C7.87933 13.6555 7.93949 13.6568 7.99996 13.6568C11.1192 13.6568 13.6569 11.1191 13.6569 7.99983C13.6569 4.88059 11.1192 2.34296 7.99996 2.34296Z",
                fill: "#CE9811"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("g", {
                filter: "url(#filter0_d_12475_61912)",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                    d: "M8.12033 11.452C7.37988 11.452 6.75144 11.312 6.23499 11.032C5.72477 10.752 5.33588 10.36 5.06833 9.85602C4.80077 9.35202 4.66699 8.76091 4.66699 8.08269C4.66699 7.56002 4.74477 7.09024 4.90033 6.67335C5.0621 6.25024 5.29233 5.89246 5.59099 5.60002C5.89588 5.30135 6.26299 5.07113 6.69233 4.90935C7.12788 4.74758 7.61944 4.66669 8.16699 4.66669C8.50299 4.66669 8.83899 4.70402 9.17499 4.77869C9.51099 4.85335 9.83455 4.9778 10.1457 5.15202C10.2763 5.22669 10.3634 5.32313 10.407 5.44135C10.4568 5.55335 10.4692 5.67469 10.4443 5.80535C10.4257 5.9298 10.3759 6.0418 10.295 6.14135C10.2203 6.23469 10.1208 6.29691 9.99633 6.32802C9.8781 6.35291 9.74121 6.32802 9.58566 6.25335C9.38033 6.14135 9.16255 6.06046 8.93233 6.01069C8.7021 5.95469 8.4501 5.92669 8.17633 5.92669C7.73455 5.92669 7.36433 6.01069 7.06566 6.17869C6.76699 6.34047 6.54299 6.58313 6.39366 6.90669C6.25055 7.22402 6.17899 7.61602 6.17899 8.08269C6.17899 8.7858 6.34699 9.3178 6.68299 9.67869C7.02521 10.0396 7.52921 10.22 8.19499 10.22C8.41899 10.22 8.64921 10.1982 8.88566 10.1547C9.1221 10.1111 9.35544 10.0489 9.58566 9.96802L9.31499 10.556V8.76402H8.47499C8.28833 8.76402 8.14521 8.71735 8.04566 8.62402C7.9461 8.53069 7.89633 8.40313 7.89633 8.24135C7.89633 8.07335 7.9461 7.9458 8.04566 7.85869C8.14521 7.76535 8.28833 7.71869 8.47499 7.71869H9.94033C10.127 7.71869 10.267 7.76847 10.3603 7.86802C10.4599 7.96758 10.5097 8.11069 10.5097 8.29735V10.4627C10.5097 10.6245 10.4785 10.7614 10.4163 10.8734C10.3541 10.9854 10.2483 11.0662 10.099 11.116C9.81899 11.2156 9.50477 11.2965 9.15633 11.3587C8.80788 11.4209 8.46255 11.452 8.12033 11.452Z",
                    fill: "#F7DE61"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("defs", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("filter", {
                    id: "filter0_d_12475_61912",
                    x: "4.66699",
                    y: "4.66669",
                    width: "6.34277",
                    height: "7.28534",
                    filterUnits: "userSpaceOnUse",
                    colorInterpolationFilters: "sRGB",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("feFlood", {
                            floodOpacity: "0",
                            result: "BackgroundImageFix"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("feColorMatrix", {
                            in: "SourceAlpha",
                            type: "matrix",
                            values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
                            result: "hardAlpha"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("feOffset", {
                            dx: "0.5",
                            dy: "0.5"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("feComposite", {
                            in2: "hardAlpha",
                            operator: "out"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("feColorMatrix", {
                            type: "matrix",
                            values: "0 0 0 0 0.807843 0 0 0 0 0.596078 0 0 0 0 0.0666667 0 0 0 1 0"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("feBlend", {
                            mode: "normal",
                            in2: "BackgroundImageFix",
                            result: "effect1_dropShadow_12475_61912"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("feBlend", {
                            mode: "normal",
                            in: "SourceGraphic",
                            in2: "effect1_dropShadow_12475_61912",
                            result: "shape"
                        })
                    ]
                })
            })
        ]
    });
};

// EXTERNAL MODULE: ./app/components/ui/button.tsx
var ui_button = __webpack_require__(34428);
// EXTERNAL MODULE: ./app/context/index.ts + 2 modules
var context = __webpack_require__(17986);
// EXTERNAL MODULE: ./app/context/RewardContext.tsx
var RewardContext = __webpack_require__(9378);
// EXTERNAL MODULE: ./app/hooks/useGAEventsTracker.ts
var useGAEventsTracker = __webpack_require__(64800);
// EXTERNAL MODULE: ./app/services/services/RewardService.ts
var RewardService = __webpack_require__(97393);
// EXTERNAL MODULE: ./node_modules/@tanstack/react-query/build/modern/QueryClientProvider.js
var QueryClientProvider = __webpack_require__(30202);
;// CONCATENATED MODULE: ./app/containers/reward-center/mission-center/DailyLogin.tsx













const DailyLogin = (param)=>{
    let { dataReward  } = param;
    var _listDaily_my_task, _listDaily_my_task1, _listDaily_sub_tasks, _listDaily_sub_tasks1, _listDaily_sub_tasks2;
    const { t  } = (0,esm/* useTranslation */.$G)();
    const router = (0,next_router.useRouter)();
    const queryClient = (0,QueryClientProvider/* useQueryClient */.NL)();
    const { userInfo , themeApp  } = (0,react.useContext)(context/* AppContext */.Il);
    const [listDaily, setListDaily] = (0,react.useState)({});
    const { getPoint , pointReward  } = (0,react.useContext)(RewardContext/* RewardContext */.w);
    const GAEventsTracker = (0,useGAEventsTracker/* default */.Z)("Reward");
    const handleClick = ()=>{
        var _listDaily_my_task;
        if (Object.keys((listDaily === null || listDaily === void 0 ? void 0 : (_listDaily_my_task = listDaily.my_task) === null || _listDaily_my_task === void 0 ? void 0 : _listDaily_my_task.tasks) || []).includes(listDaily.today)) {
            return;
        } else {
            GAEventsTracker("Mission_Checkin", "Checkin");
            GAEventsTracker("Mission_Do_success", "Checkin");
            RewardService/* default.confirmTask */.Z.confirmTask(listDaily === null || listDaily === void 0 ? void 0 : listDaily.id).then(()=>{
                getPoint();
                queryClient.invalidateQueries({
                    queryKey: [
                        configs/* QUERY_KEY.LIST_MISSION */.lP.LIST_MISSION
                    ],
                    type: "active",
                    exact: true
                });
                queryClient.refetchQueries({
                    queryKey: [
                        configs/* QUERY_KEY.POINT_HISTORY */.lP.POINT_HISTORY,
                        userInfo === null || userInfo === void 0 ? void 0 : userInfo.userid,
                        {
                            type: "earn",
                            source: "",
                            start_date: "",
                            end_date: ""
                        }
                    ]
                });
            }).catch((e)=>{
                GAEventsTracker("Mission_Do_failed", "Checkin");
            });
        }
    };
    (0,react.useEffect)(()=>{
        setListDaily(dataReward === null || dataReward === void 0 ? void 0 : dataReward.find((item)=>{
            return (item === null || item === void 0 ? void 0 : item.type) === configs/* MISSION_TYPE.CHECKIN */.ES.CHECKIN;
        }));
    }, [
        dataReward
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "w-full md:px-[24px] mt-[16px] md:mt-0",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "flex items-center",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "flex gap-[4px] items-center",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(IconGold, {
                                className: "w-[20px] h-[20px]"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                className: "w-full text-[14px] Nunito-700 flex-1",
                                children: pointReward.toLocaleString()
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "bg-black/10 w-[1px] h-[16px] mx-[8px]"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        className: "cursor-pointer text-main-01 Nunito-400",
                        onClick: ()=>{
                            router.push("/user/".concat((userInfo === null || userInfo === void 0 ? void 0 : userInfo.alias) ? userInfo === null || userInfo === void 0 ? void 0 : userInfo.alias : userInfo === null || userInfo === void 0 ? void 0 : userInfo.userid, "?tab=transaction-manager&gold=earn-all"));
                        },
                        children: t("reward.get_point_history")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "ml-auto mr-0",
                        children: !Object.keys((listDaily === null || listDaily === void 0 ? void 0 : (_listDaily_my_task = listDaily.my_task) === null || _listDaily_my_task === void 0 ? void 0 : _listDaily_my_task.tasks) || []).includes(listDaily === null || listDaily === void 0 ? void 0 : listDaily.today) ? /*#__PURE__*/ (0,jsx_runtime.jsx)(ui_button/* Button */.z, {
                            onClick: ()=>handleClick(),
                            variant: "main",
                            className: "text-[12px] Nunito-700 rounded-[8px] px-[16px] h-[28px] w-[93px]",
                            children: t("reward.daily_login")
                        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(ui_button/* Button */.z, {
                            variant: "none",
                            className: "text-[12px] Nunito-500 cursor-default rounded-[8px] px-[16px] h-[28px] bg-button dark:bg-button/10 text-main-disable min-w-[108px]",
                            children: t("reward.daily_login_success")
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "sd:mt-[60px] mt-[24px] md:mt-[32px]",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "mb-[16px] px-[24px]",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "bg-bg-button dark:bg-white/10 rounded-[10px] flex-1 h-[6px] relative",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "bg-main-disable-02 dark:bg-main-01 rounded-[10px] h-full",
                                    style: {
                                        width: "min(".concat(100 * ((listDaily === null || listDaily === void 0 ? void 0 : (_listDaily_my_task1 = listDaily.my_task) === null || _listDaily_my_task1 === void 0 ? void 0 : _listDaily_my_task1.totalTaskSuccess) - 1) / ((listDaily === null || listDaily === void 0 ? void 0 : (_listDaily_sub_tasks = listDaily.sub_tasks) === null || _listDaily_sub_tasks === void 0 ? void 0 : _listDaily_sub_tasks.length) - 1), "%, 100%)")
                                    }
                                }),
                                listDaily === null || listDaily === void 0 ? void 0 : (_listDaily_sub_tasks1 = listDaily.sub_tasks) === null || _listDaily_sub_tasks1 === void 0 ? void 0 : _listDaily_sub_tasks1.map((item, index)=>{
                                    var _listDaily_sub_tasks;
                                    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "absolute w-[6px] h-[6px] bg-main-01 dark:bg-main-disable-02 top-0 rounded-[8px]",
                                        style: {
                                            left: "calc(".concat(100 * index / ((listDaily === null || listDaily === void 0 ? void 0 : (_listDaily_sub_tasks = listDaily.sub_tasks) === null || _listDaily_sub_tasks === void 0 ? void 0 : _listDaily_sub_tasks.length) - 1), "% - 3px)")
                                        }
                                    }, index + 10);
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "flex justify-between w-full",
                        children: listDaily === null || listDaily === void 0 ? void 0 : (_listDaily_sub_tasks2 = listDaily.sub_tasks) === null || _listDaily_sub_tasks2 === void 0 ? void 0 : _listDaily_sub_tasks2.map((item, index)=>{
                            var _listDaily_my_task;
                            return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "flex flex-col items-center gap-[16px]",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                        className: "text-neural-03 text-[14px] Nunito-700",
                                        children: t("reward.day_login", {
                                            day: item === null || item === void 0 ? void 0 : item.day
                                        })
                                    }),
                                    (listDaily === null || listDaily === void 0 ? void 0 : (_listDaily_my_task = listDaily.my_task) === null || _listDaily_my_task === void 0 ? void 0 : _listDaily_my_task.totalTaskSuccess) >= (item === null || item === void 0 ? void 0 : item.day) ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "w-[36px] h-[36px] rounded-[36px] flex items-center justify-center bg-bg-green",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
                                            xmlns: "http://www.w3.org/2000/svg",
                                            width: "56",
                                            height: "56",
                                            viewBox: "0 0 56 56",
                                            fill: "none",
                                            className: "w-[20px] h-[20px]",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                d: "M28.1438 5.14404C15.5495 5.14404 5.28662 15.4069 5.28662 28.0012C5.28662 40.5955 15.5495 50.8583 28.1438 50.8583C40.7381 50.8583 51.0009 40.5955 51.0009 28.0012C51.0009 15.4069 40.7381 5.14404 28.1438 5.14404ZM39.0695 22.744L26.1095 35.704C25.7895 36.024 25.3552 36.2069 24.8981 36.2069C24.4409 36.2069 24.0066 36.024 23.6866 35.704L17.2181 29.2355C16.5552 28.5726 16.5552 27.4755 17.2181 26.8126C17.8809 26.1498 18.9781 26.1498 19.6409 26.8126L24.8981 32.0698L36.6466 20.3212C37.3095 19.6583 38.4066 19.6583 39.0695 20.3212C39.7323 20.984 39.7323 22.0583 39.0695 22.744Z",
                                                fill: "#27908C"
                                            })
                                        })
                                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(IconGift, {
                                        fill: themeApp === "dark" ? "#7673E5" : ""
                                    })
                                ]
                            }, index);
                        })
                    })
                ]
            })
        ]
    });
};

// EXTERNAL MODULE: ./app/components/icon-tsx/IconArrowRight.tsx
var IconArrowRight = __webpack_require__(99777);
// EXTERNAL MODULE: ./app/components/icon-tsx/IconCopied.tsx
var IconCopied = __webpack_require__(60303);
// EXTERNAL MODULE: ./app/components/icon-tsx/IconNonCopy.tsx
var IconNonCopy = __webpack_require__(27298);
// EXTERNAL MODULE: ./app/components/ui/dialog.tsx
var dialog = __webpack_require__(76500);
// EXTERNAL MODULE: ./app/components/icon-tsx/IconClose.tsx
var IconClose = __webpack_require__(51337);
// EXTERNAL MODULE: ./app/components/ui/use-toast.ts
var use_toast = __webpack_require__(2786);
// EXTERNAL MODULE: ./app/services/query-fn/user/setting-mutation.ts
var setting_mutation = __webpack_require__(88663);
// EXTERNAL MODULE: ./public/img/playee_logo.png
var playee_logo = __webpack_require__(8313);
;// CONCATENATED MODULE: ./app/containers/reward-center/mission-center/ModalShareInviteCode.tsx













const ModalShareInviteCode = (param)=>{
    let { open , handleClose  } = param;
    const { userInfo  } = (0,react.useContext)(context/* AppContext */.Il);
    const { t  } = (0,esm/* useTranslation */.$G)();
    const { toast  } = (0,use_toast/* useToast */.pm)();
    const queryClient = (0,QueryClientProvider/* useQueryClient */.NL)();
    const [value, setValue] = (0,react.useState)("");
    const { mutate  } = (0,setting_mutation/* useMutationUpdateInviteCode */.E2)();
    const [shareContent, setShareContent] = (0,react.useState)("");
    const onChangeValue = (e)=>{
        var _e_target;
        setValue(e === null || e === void 0 ? void 0 : (_e_target = e.target) === null || _e_target === void 0 ? void 0 : _e_target.value);
    };
    const onCopyLink = ()=>{
        const link = "".concat("https://playee.vn", "?referent_code=").concat(userInfo === null || userInfo === void 0 ? void 0 : userInfo.referent_code);
        navigator.clipboard.writeText(link);
        toast({
            variant: "success",
            title: t("message.copied")
        });
    };
    const onSubmitInviteCode = ()=>{
        mutate({
            invite_code: value === null || value === void 0 ? void 0 : value.trim()
        }, {
            onSuccess (data, variables, context) {
                queryClient.invalidateQueries({
                    queryKey: [
                        configs/* QUERY_KEY.PROFILE_INFO */.lP.PROFILE_INFO
                    ],
                    refetchType: "active"
                });
                handleClose();
            },
            onError (error, variables, context) {
                var _error_data;
                toast({
                    title: error === null || error === void 0 ? void 0 : (_error_data = error.data) === null || _error_data === void 0 ? void 0 : _error_data.message,
                    variant: "error"
                });
            }
        });
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(dialog/* Dialog */.Vq, {
        open: open,
        onOpenChange: handleClose,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(dialog/* DialogContent */.cZ, {
            className: "w-fit rounded-[24px] sm:rounded-[24px] md:min-w-[468px] md:max-w-[473px] px-6 py-4 dark:border-0 dark:bg-[#1A1925] min-w-[90vw]",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(dialog/* DialogClose */.GG, {
                    className: "absolute transition-opacity rounded-sm right-6 top-3 focus:outline-none disabled:pointer-events-none"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "flex flex-col justify-center w-full",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "flex items-center justify-between w-full",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                    className: "text-bg-01 Nunito-700 text-base mb-[40px dark:text-main-white",
                                    children: t("common.share_referal_link")
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "w-[32px] h-[32px] rounded-[8px] flex items-center justify-center bg-bg-button dark:bg-[#ECECEE]/10 cursor-pointer",
                                    onClick: handleClose,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(IconClose/* IconClose */.b, {})
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "w-full",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "w-full mb-[24px] mt-[16px] md:w-[76%] p-3 flex gap-3 border-[1px] border-black/10 rounded-2xl dark:bg-white/10",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                        src: playee_logo/* default.src */.Z.src,
                                        className: "w-[48px] aspect-square rounded-xl h-fit object-cover"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "flex flex-col",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                className: "text-base leading-normal text-bg-01 Nunito-700 line-clamp-1 dark:text-main-white",
                                                children: "Playee - Entertaining the world"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "text-[12px]",
                                                dangerouslySetInnerHTML: {
                                                    __html: "".concat("https://playee.vn", "?referent_code=").concat(userInfo === null || userInfo === void 0 ? void 0 : userInfo.referent_code)
                                                }
                                            })
                                        ]
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "flex items-center justify-between w-full border-t-[1px] pt-[24px] border-black/10",
                            children: [
                                 true && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "flex w-full gap-4",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                            href: "https://www.facebook.com/sharer/sharer.php?u=".concat("https://playee.vn", "?referent_code=").concat(userInfo === null || userInfo === void 0 ? void 0 : userInfo.referent_code, "&t=").concat(shareContent),
                                            target: "_blank",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
                                                width: "32",
                                                height: "32",
                                                viewBox: "0 0 48 48",
                                                fill: "none",
                                                xmlns: "http://www.w3.org/2000/svg",
                                                className: "cursor-pointer",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                                                        width: "48",
                                                        height: "48",
                                                        rx: "16",
                                                        fill: "#337FFF"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                        d: "M29.8737 25.5625L30.5576 21.2172H26.3447V18.3927C26.3447 17.2046 26.9329 16.0436 28.8136 16.0436H30.7559V12.3433C29.6248 12.1629 28.4819 12.0653 27.3364 12.0513C23.869 12.0513 21.6053 14.1357 21.6053 17.9039V21.2172H17.7617V25.5625H21.6053V36.0727H26.3447V25.5625H29.8737Z",
                                                        fill: "white"
                                                    })
                                                ]
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                            href: "https://t.me/share/url?url=".concat("https://playee.vn", "?referent_code=").concat(userInfo === null || userInfo === void 0 ? void 0 : userInfo.referent_code),
                                            target: "_blank",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
                                                width: "32",
                                                height: "32",
                                                viewBox: "0 0 48 48",
                                                fill: "none",
                                                xmlns: "http://www.w3.org/2000/svg",
                                                className: "cursor-pointer",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                                                        width: "48",
                                                        height: "48",
                                                        rx: "16",
                                                        fill: "#34AADF"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                        d: "M13.3537 23.1498C13.3537 23.1498 23.1191 19.0367 26.506 17.5884C27.8043 17.0092 32.2072 15.1553 32.2072 15.1553C32.2072 15.1553 34.2393 14.3443 34.07 16.314C34.0135 17.125 33.5619 19.9636 33.1104 23.0339C32.433 27.3788 31.6992 32.129 31.6992 32.129C31.6992 32.129 31.5863 33.4615 30.6267 33.6932C29.6671 33.9249 28.0865 32.8822 27.8043 32.6504C27.5784 32.4767 23.5707 29.8698 22.1031 28.5953C21.7079 28.2477 21.2564 27.5526 22.1595 26.7415C24.1916 24.8298 26.6188 22.4547 28.0865 20.9485C28.7639 20.2533 29.4412 18.6312 26.6188 20.6008C22.6111 23.4395 18.6598 26.1043 18.6598 26.1043C18.6598 26.1043 17.7566 26.6835 16.0632 26.1622C14.3697 25.6409 12.394 24.9456 12.394 24.9456C12.394 24.9456 11.0394 24.0767 13.3537 23.1498Z",
                                                        fill: "white"
                                                    })
                                                ]
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                            href: "https://twitter.com/intent/tweet?text=".concat(shareContent).concat(shareContent !== "" ? "%0A" : "").concat("https://playee.vn", "?referent_code=").concat(userInfo === null || userInfo === void 0 ? void 0 : userInfo.referent_code),
                                            target: "_blank",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
                                                width: "32",
                                                height: "32",
                                                viewBox: "0 0 48 48",
                                                fill: "none",
                                                xmlns: "http://www.w3.org/2000/svg",
                                                className: "cursor-pointer",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                                                        width: "48",
                                                        height: "48",
                                                        rx: "16",
                                                        fill: "#0F1419"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                        d: "M25.905 22.4695L33.3512 14H31.5869L25.1184 21.3524L19.9558 14H14L21.8086 25.1192L14 34H15.7643L22.591 26.2338L28.0442 34H34L25.905 22.4695ZM23.4877 25.2168L22.6954 24.1089L16.4005 15.3015H19.1108L24.1925 22.412L24.9815 23.5199L31.5861 32.7619H28.8758L23.4877 25.2168Z",
                                                        fill: "white"
                                                    })
                                                ]
                                            })
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(ui_button/* Button */.z, {
                                    variant: "none",
                                    onClick: onCopyLink,
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
                                            width: "24",
                                            height: "24",
                                            viewBox: "0 0 24 24",
                                            fill: "none",
                                            xmlns: "http://www.w3.org/2000/svg",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                    d: "M14.1211 9.87866L9.87845 14.1213",
                                                    stroke: "#7673E6",
                                                    strokeWidth: "1.5",
                                                    strokeLinecap: "round"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                    d: "M10.332 7.00003L11.9987 5.33336C13.8396 3.49239 16.8244 3.49239 18.6654 5.33335V5.33335C20.5063 7.17431 20.5063 10.1591 18.6654 12.0001L16.9987 13.6667",
                                                    stroke: "#7673E6",
                                                    strokeWidth: "1.5",
                                                    strokeLinecap: "round"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                    d: "M13.668 17L12.0013 18.6666C10.1604 20.5076 7.17558 20.5076 5.33462 18.6666V18.6666C3.49365 16.8257 3.49365 13.8409 5.33462 11.9999L7.00129 10.3333",
                                                    stroke: "#7673E6",
                                                    strokeWidth: "1.5",
                                                    strokeLinecap: "round"
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                            className: "text-sm text-bg-01 Nunito-700 dark:text-white",
                                            children: [
                                                "\xa0\xa0",
                                                t("reward.copy")
                                            ]
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                })
            ]
        })
    });
};

;// CONCATENATED MODULE: ./app/containers/reward-center/mission-center/ReferralMission.tsx











const ReferralMission = (param)=>{
    let { dataReward  } = param;
    var _listReferal_sub_tasks, _listReferal_sub_tasks1, _ref;
    const { t  } = (0,esm/* useTranslation */.$G)();
    const [listReferal, setListReferal] = (0,react.useState)({});
    const { userInfo: userProfile , themeApp  } = (0,react.useContext)(context/* AppContext */.Il);
    const [copied, setIsCopied] = (0,react.useState)(false);
    const router = (0,next_router.useRouter)();
    const [showModal, setShowModal] = (0,react.useState)(false);
    const onChangeShowModal = ()=>{
        setShowModal(!showModal);
    };
    const onCopyInviteCode = ()=>{
        navigator.clipboard.writeText(userProfile === null || userProfile === void 0 ? void 0 : userProfile.referent_code);
        setIsCopied(true);
    };
    const renderCode = ()=>{
        var _userProfile_referent_code, _userProfile_referent_code1;
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "flex items-center md:px-[12px] md:py-[6px] rounded-[12px] md:border border-black/10 dark:border-neutral-03 h-fit",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "Nunito-400 dark:text-neutral-09",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            className: "",
                            children: userProfile === null || userProfile === void 0 ? void 0 : (_userProfile_referent_code = userProfile.referent_code) === null || _userProfile_referent_code === void 0 ? void 0 : _userProfile_referent_code.replace(userProfile === null || userProfile === void 0 ? void 0 : (_userProfile_referent_code1 = userProfile.referent_code) === null || _userProfile_referent_code1 === void 0 ? void 0 : _userProfile_referent_code1.substring(4, 15), "xxx")
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            className: "h-full w-[1px] bg-black/10 dark:bg-neutral-03"
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "cursor-pointer w-fit ml-[8px]",
                    onClick: onCopyInviteCode,
                    children: copied ? /*#__PURE__*/ (0,jsx_runtime.jsx)(IconCopied/* IconCopied */.i, {}) : /*#__PURE__*/ (0,jsx_runtime.jsx)(IconNonCopy/* IconNonCopy */.x, {
                        stroke: "#9F9EA9"
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "w-[1px] h-[16px] mx-[12px] bg-black/10 dark:bg-neutral-03"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "w-[32px] h-[32px] rounded-[12px] flex items-center justify-center cursor-pointer bg-bg-02-text-box dark:bg-white/10",
                    onClick: onChangeShowModal,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
                        width: "16",
                        height: "16",
                        viewBox: "0 0 16 16",
                        fill: "none",
                        xmlns: "http://www.w3.org/2000/svg",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                d: "M8.66602 7.33337L14.1327 1.8667",
                                stroke: themeApp === "dark" ? "#fff" : "#585669",
                                strokeWidth: "1.5",
                                strokeLinecap: "round",
                                strokeLinejoin: "round"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                d: "M14.6668 4.5335V1.3335H11.4668",
                                stroke: themeApp === "dark" ? "#fff" : "#585669",
                                strokeWidth: "1.5",
                                strokeLinecap: "round",
                                strokeLinejoin: "round"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                d: "M7.33398 1.3335H6.00065C2.66732 1.3335 1.33398 2.66683 1.33398 6.00016V10.0002C1.33398 13.3335 2.66732 14.6668 6.00065 14.6668H10.0007C13.334 14.6668 14.6673 13.3335 14.6673 10.0002V8.66683",
                                stroke: themeApp === "dark" ? "#fff" : "#585669",
                                strokeWidth: "1.5",
                                strokeLinecap: "round",
                                strokeLinejoin: "round"
                            })
                        ]
                    })
                })
            ]
        });
    };
    (0,react.useEffect)(()=>{
        setListReferal(dataReward === null || dataReward === void 0 ? void 0 : dataReward.find((item)=>{
            return (item === null || item === void 0 ? void 0 : item.type) === configs/* MISSION_TYPE.INVITE */.ES.INVITE;
        }));
    }, [
        dataReward
    ]);
    return (listReferal === null || listReferal === void 0 ? void 0 : (_listReferal_sub_tasks = listReferal.sub_tasks) === null || _listReferal_sub_tasks === void 0 ? void 0 : _listReferal_sub_tasks.length) ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "w-full space-y-[16px]",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "flex justify-between",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "flex md:justify-between items-center md:w-full",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                className: "Nunito-700 text-[16px]",
                                children: t("reward.invite_friend_title")
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "w-[1px] h-[16px] bg-black/10 dark:bg-white/10 mx-[8px] md:hidden"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "flex text-main-01 cursor-pointer items-center gap-[12px] text-[14px]",
                                onClick: ()=>router.push("/reward-center/referral-history"),
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                        className: "",
                                        onClick: ()=>router.push("/reward-center/referral-history"),
                                        children: t("reward.invite_friend_history")
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(IconArrowRight/* IconArrowRight */.E, {
                                        className: "hidden md:block"
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "md:hidden",
                        children: renderCode()
                    })
                ]
            }),
            (userProfile === null || userProfile === void 0 ? void 0 : userProfile.id) && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "flex gap-[32px]",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        className: "text-neutral-04 dark:text-neutral-09 text-[14px] w-full flex-1",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(esm/* Trans */.cC, {
                            i18nKey: t("reward.invite_friend_desc"),
                            components: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    className: "text-main-01 Nunito-600"
                                }, 0)
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "hidden md:block",
                        children: renderCode()
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "flex justify-evenly",
                children: (listReferal === null || listReferal === void 0 ? void 0 : (_listReferal_sub_tasks1 = listReferal.sub_tasks) === null || _listReferal_sub_tasks1 === void 0 ? void 0 : _listReferal_sub_tasks1.length) && ((_ref = [
                    ...listReferal === null || listReferal === void 0 ? void 0 : listReferal.sub_tasks
                ]) === null || _ref === void 0 ? void 0 : _ref.map((item, index)=>{
                    var _listReferal_my_task;
                    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "flex flex-col items-center gap-[16px]",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                className: "text-neural-03 dark:text-main-white text-[14px] Nunito-700",
                                children: t("reward.invite_number", {
                                    number: item === null || item === void 0 ? void 0 : item.day
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    children: (listReferal === null || listReferal === void 0 ? void 0 : (_listReferal_my_task = listReferal.my_task) === null || _listReferal_my_task === void 0 ? void 0 : _listReferal_my_task.totalTaskSuccess) >= (item === null || item === void 0 ? void 0 : item.day) ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "w-[36px] h-[36px] rounded-[36px] flex items-center justify-center bg-bg-green",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
                                            xmlns: "http://www.w3.org/2000/svg",
                                            width: "56",
                                            height: "56",
                                            viewBox: "0 0 56 56",
                                            fill: "none",
                                            className: "w-[20px] h-[20px]",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                d: "M28.1438 5.14404C15.5495 5.14404 5.28662 15.4069 5.28662 28.0012C5.28662 40.5955 15.5495 50.8583 28.1438 50.8583C40.7381 50.8583 51.0009 40.5955 51.0009 28.0012C51.0009 15.4069 40.7381 5.14404 28.1438 5.14404ZM39.0695 22.744L26.1095 35.704C25.7895 36.024 25.3552 36.2069 24.8981 36.2069C24.4409 36.2069 24.0066 36.024 23.6866 35.704L17.2181 29.2355C16.5552 28.5726 16.5552 27.4755 17.2181 26.8126C17.8809 26.1498 18.9781 26.1498 19.6409 26.8126L24.8981 32.0698L36.6466 20.3212C37.3095 19.6583 38.4066 19.6583 39.0695 20.3212C39.7323 20.984 39.7323 22.0583 39.0695 22.744Z",
                                                fill: "#27908C"
                                            })
                                        })
                                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(IconGift, {
                                        fill: themeApp === "dark" ? "#7673E5" : ""
                                    })
                                })
                            })
                        ]
                    }, index);
                }))
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ModalShareInviteCode, {
                open: showModal,
                handleClose: onChangeShowModal
            })
        ]
    }) : null;
};

// EXTERNAL MODULE: ./node_modules/moment/moment.js
var moment = __webpack_require__(30381);
var moment_default = /*#__PURE__*/__webpack_require__.n(moment);
;// CONCATENATED MODULE: ./app/containers/reward-center/mission-center/InteractiveMission.tsx









const InteractiveMission = (param)=>{
    let { dataReward  } = param;
    const { t  } = (0,esm/* useTranslation */.$G)();
    const [listMission, setListMission] = (0,react.useState)({});
    const router = (0,next_router.useRouter)();
    const { isMobile  } = (0,react.useContext)(context/* MobileContext */.zw);
    const GAEventsTracker = (0,useGAEventsTracker/* default */.Z)("Reward");
    const onDoMission = (item)=>{
        var _item_my_task;
        GAEventsTracker("Mission_do_begin", item === null || item === void 0 ? void 0 : item.title);
        if (!(item === null || item === void 0 ? void 0 : (_item_my_task = item.my_task) === null || _item_my_task === void 0 ? void 0 : _item_my_task.totalTaskSuccess)) {
            var _item_condition, _item_condition1, _item_condition2, _item_condition3;
            if ((item === null || item === void 0 ? void 0 : (_item_condition = item.condition) === null || _item_condition === void 0 ? void 0 : _item_condition.interaction) === configs/* INTERACTIVE_TYPE.JOIN_GROUP */.sd.JOIN_GROUP) {
                var _item_condition4;
                router.push("/groups/".concat(item === null || item === void 0 ? void 0 : (_item_condition4 = item.condition) === null || _item_condition4 === void 0 ? void 0 : _item_condition4.group_alias));
            } else if ((item === null || item === void 0 ? void 0 : (_item_condition1 = item.condition) === null || _item_condition1 === void 0 ? void 0 : _item_condition1.interaction) === configs/* INTERACTIVE_TYPE.POST_CONTENT */.sd.POST_CONTENT) {
                router.push("/");
            } else if ((item === null || item === void 0 ? void 0 : (_item_condition2 = item.condition) === null || _item_condition2 === void 0 ? void 0 : _item_condition2.interaction) === configs/* INTERACTIVE_TYPE.COMMENT_CONTENT */.sd.COMMENT_CONTENT) {
                var _item_condition5;
                router.push("/detail/news/".concat(item === null || item === void 0 ? void 0 : (_item_condition5 = item.condition) === null || _item_condition5 === void 0 ? void 0 : _item_condition5.news_id));
            } else if ((item === null || item === void 0 ? void 0 : (_item_condition3 = item.condition) === null || _item_condition3 === void 0 ? void 0 : _item_condition3.interaction) === configs/* INTERACTIVE_TYPE.FOLLOW_USER */.sd.FOLLOW_USER) {
                var _item_condition6;
                router.push("/user/".concat(item === null || item === void 0 ? void 0 : (_item_condition6 = item.condition) === null || _item_condition6 === void 0 ? void 0 : _item_condition6.user_id));
            } else {
                var _item_condition7;
                router.push("/game/".concat(item === null || item === void 0 ? void 0 : (_item_condition7 = item.condition) === null || _item_condition7 === void 0 ? void 0 : _item_condition7.slug_name, "?tab=rating"));
            }
        }
    };
    (0,react.useEffect)(()=>{
        setListMission(dataReward === null || dataReward === void 0 ? void 0 : dataReward.filter((item)=>{
            return (item === null || item === void 0 ? void 0 : item.type) === configs/* MISSION_TYPE.INTERACTIVE */.ES.INTERACTIVE;
        }));
    }, [
        dataReward
    ]);
    return (listMission === null || listMission === void 0 ? void 0 : listMission.length) ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "mt-[40px] md:mt-0",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                className: "text-[16px] Nunito-700 pb-[24px]",
                children: t("reward.mission")
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "grid md:grid-cols-2 gap-[16px] md:gap-x-[24px] sd:gap-x-[56px] gap-y-[16px] sd:gap-y-[24px]",
                children: listMission === null || listMission === void 0 ? void 0 : listMission.map((item, index)=>{
                    var _item_condition, _item_condition1, _item_condition2, _item_condition3, _item_my_task;
                    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        onClick: ()=>{
                            onDoMission(item);
                        },
                        className: "w-full p-[12px] rounded-[16px] border border-black/10 dark:border-neutral-03 flex gap-[12px] items-center cursor-pointer",
                        children: [
                            (item === null || item === void 0 ? void 0 : (_item_condition = item.condition) === null || _item_condition === void 0 ? void 0 : _item_condition.game_icon) || (item === null || item === void 0 ? void 0 : (_item_condition1 = item.condition) === null || _item_condition1 === void 0 ? void 0 : _item_condition1.group_avatar) ? /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                src: (item === null || item === void 0 ? void 0 : (_item_condition2 = item.condition) === null || _item_condition2 === void 0 ? void 0 : _item_condition2.game_icon) || (item === null || item === void 0 ? void 0 : (_item_condition3 = item.condition) === null || _item_condition3 === void 0 ? void 0 : _item_condition3.group_avatar),
                                alt: item === null || item === void 0 ? void 0 : item.title,
                                title: item === null || item === void 0 ? void 0 : item.title,
                                width: 48,
                                height: 48,
                                className: "rounded-[12px]"
                            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "w-[48px] h-[48px] rounded-[12px] flex items-center justify-center",
                                style: {
                                    background: "linear-gradient(268deg, #B6B4F8 -15.03%, #AEAAF8 37.55%, #A39FD1 100%)"
                                },
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
                                    xmlns: "http://www.w3.org/2000/svg",
                                    width: "24",
                                    height: "26",
                                    viewBox: "0 0 24 26",
                                    fill: "none",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                        d: "M7.33333 10.6667H16.6667M7.33333 15.3334H16.6667M7.33333 20H12M7.33333 3.66671C7.33333 4.95537 8.378 6.00004 9.66667 6.00004H14.3333C15.622 6.00004 16.6667 4.95537 16.6667 3.66671M7.33333 3.66671C7.33333 2.37804 8.378 1.33337 9.66667 1.33337H14.3333C15.622 1.33337 16.6667 2.37804 16.6667 3.66671M7.33333 3.66671H6.16667C3.58934 3.66671 1.5 5.75605 1.5 8.33337V20C1.5 22.5774 3.58934 24.6667 6.16667 24.6667H17.8333C20.4107 24.6667 22.5 22.5774 22.5 20V8.33337C22.5 5.75605 20.4107 3.66671 17.8333 3.66671H16.6667",
                                        stroke: "#FAF8FF",
                                        strokeWidth: "1.5",
                                        strokeLinecap: "round"
                                    })
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                        className: "text-[14px] Nunito-600",
                                        children: item.title
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                        className: "text-[12px] text-neutral-05 dark:text-neutral-08",
                                        children: [
                                            moment_default()(item.start_time).format(configs/* DATE_FORMAT */.zT),
                                            " -",
                                            " ",
                                            moment_default()(item.end_time).format(configs/* DATE_FORMAT */.zT)
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "ml-auto mr-0",
                                children: !(item === null || item === void 0 ? void 0 : (_item_my_task = item.my_task) === null || _item_my_task === void 0 ? void 0 : _item_my_task.totalTaskSuccess) ? /*#__PURE__*/ (0,jsx_runtime.jsx)(ui_button/* Button */.z, {
                                    variant: "main",
                                    className: "h-[32px] px-[20px] rounded-[12px] text-[12px]",
                                    children: t("reward.do_now")
                                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "w-[36px] h-[36px] rounded-[36px] flex items-center justify-center bg-bg-green",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
                                        xmlns: "http://www.w3.org/2000/svg",
                                        width: "56",
                                        height: "56",
                                        viewBox: "0 0 56 56",
                                        fill: "none",
                                        className: "w-[20px] h-[20px]",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                            d: "M28.1438 5.14404C15.5495 5.14404 5.28662 15.4069 5.28662 28.0012C5.28662 40.5955 15.5495 50.8583 28.1438 50.8583C40.7381 50.8583 51.0009 40.5955 51.0009 28.0012C51.0009 15.4069 40.7381 5.14404 28.1438 5.14404ZM39.0695 22.744L26.1095 35.704C25.7895 36.024 25.3552 36.2069 24.8981 36.2069C24.4409 36.2069 24.0066 36.024 23.6866 35.704L17.2181 29.2355C16.5552 28.5726 16.5552 27.4755 17.2181 26.8126C17.8809 26.1498 18.9781 26.1498 19.6409 26.8126L24.8981 32.0698L36.6466 20.3212C37.3095 19.6583 38.4066 19.6583 39.0695 20.3212C39.7323 20.984 39.7323 22.0583 39.0695 22.744Z",
                                            fill: "#27908C"
                                        })
                                    })
                                })
                            })
                        ]
                    }, index);
                })
            })
        ]
    }) : null;
};

// EXTERNAL MODULE: ./node_modules/@tanstack/react-query/build/modern/useQuery.js
var useQuery = __webpack_require__(78551);
;// CONCATENATED MODULE: ./app/services/query-fn/reward-center/mission-center/mission-query.tsx



const getListMissionFn = async ()=>{
    const data = await RewardService/* default.getListTask */.Z.getListTask();
    return data.data.data;
};
const useQueryGetListMission = ()=>{
    return (0,useQuery/* useQuery */.a)({
        queryKey: [
            configs/* QUERY_KEY.LIST_MISSION */.lP.LIST_MISSION
        ],
        queryFn: ()=>getListMissionFn(),
        refetchOnWindowFocus: false,
        retry: 0
    });
};

;// CONCATENATED MODULE: ./app/containers/reward-center/mission-center/index.tsx







const MissionCenterContainer = ()=>{
    const { data: dataReward  } = useQueryGetListMission();
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "mt-[16px] md:space-y-[40px]",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(RewardBanner, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "flex gap-[56px] xs:gap-[40px] flex-col ld:flex-row",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(DailyLogin, {
                        dataReward: dataReward
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ReferralMission, {
                        dataReward: dataReward
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(InteractiveMission, {
                dataReward: dataReward
            })
        ]
    });
};

// EXTERNAL MODULE: ./app/components/icon-tsx/IconFilter.tsx
var IconFilter = __webpack_require__(12554);
// EXTERNAL MODULE: ./app/components/pagination/index.tsx + 1 modules
var pagination = __webpack_require__(66983);
// EXTERNAL MODULE: ./app/components/ui/dropdown-menu.tsx + 2 modules
var dropdown_menu = __webpack_require__(27357);
// EXTERNAL MODULE: ./app/components/ui/select.tsx + 3 modules
var ui_select = __webpack_require__(80522);
// EXTERNAL MODULE: ./node_modules/@tanstack/react-query/build/modern/useMutation.js + 1 modules
var useMutation = __webpack_require__(98029);
;// CONCATENATED MODULE: ./app/services/query-fn/reward-center/shop/shop-mutation.ts



const buyItemFn = (body)=>{
    return RewardService/* default.buyItem */.Z.buyItem(body);
};
const useMutationBuyItem = ()=>{
    return (0,useMutation/* useMutation */.D)({
        mutationKey: [
            configs/* QUERY_KEY.BUY_ITEM_SHOP */.lP.BUY_ITEM_SHOP
        ],
        mutationFn: buyItemFn
    });
};

;// CONCATENATED MODULE: ./app/services/query-fn/reward-center/shop/shop-query.ts



const getListShopItemFn = async (params)=>{
    const data = await RewardService/* default.getListShop */.Z.getListShop(params);
    return data.data;
};
const useQueryGetListShopItem = (params)=>{
    return (0,useQuery/* useQuery */.a)({
        queryKey: [
            configs/* QUERY_KEY.LIST_SHOP_ITEM */.lP.LIST_SHOP_ITEM,
            params
        ],
        queryFn: ()=>getListShopItemFn(params),
        enabled: !!params,
        refetchOnWindowFocus: false,
        retry: 0
    });
};

;// CONCATENATED MODULE: ./app/containers/reward-center/gold-shop/ModalConfirmBuy.tsx







const ModalConfirmBuy = (param)=>{
    let { open , onOpenChange , dataSelected , onBuy  } = param;
    const { t  } = (0,esm/* useTranslation */.$G)();
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(dialog/* Dialog */.Vq, {
        open: open,
        onOpenChange: onOpenChange,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(dialog/* DialogContent */.cZ, {
            className: "sm:rounded-[16px] gap-0 rounded-[16px] max-w-[90vw] md:max-w-[354px] p-[24px] border-0 focus-visible:outline-none dark:bg-bg-02 space-y-[40px]",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "w-full flex items-center justify-between",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                            className: "text-bg-01 Nunito-700 text-base mb-[40px dark:text-main-white",
                            children: t("common.buy_item")
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "w-[32px] h-[32px] rounded-[8px] flex items-center justify-center cursor-pointer",
                            onClick: onOpenChange,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(IconClose/* IconClose */.b, {})
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "space-y-[16px]",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "flex justify-between items-center",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                    className: "text-[14px] text-neutral-05 dark:text-neutral-07 pb-[6px] leading-[19px]",
                                    children: t("reward.exchange_package")
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                    className: "Nunito-500",
                                    children: dataSelected.item_name
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "flex justify-between items-center",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                    className: "text-[14px] text-neutral-05 dark:text-neutral-07 pb-[6px] leading-[19px]",
                                    children: t("reward.criteria")
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "text-[14px] flex items-center gap-[3px] Nunito-500",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                            className: "leading-[14px]",
                                            children: dataSelected.price
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(IconGold, {})
                                    ]
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "flex items-center justify-end gap-[16px]",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(ui_button/* Button */.z, {
                            variant: "grey",
                            className: "text-nutral-05 dark:text-neutral-07 rounded-[16px] px-[24px] py-[12px] h-[46px]",
                            onClick: onOpenChange,
                            children: t("merchandise.cancel")
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(ui_button/* Button */.z, {
                            variant: "main",
                            className: "px-[24px] py-[12px] h-[46px] rounded-[16px]",
                            onClick: onBuy,
                            children: t("store.buy_now")
                        })
                    ]
                })
            ]
        })
    });
};

;// CONCATENATED MODULE: ./app/containers/reward-center/gold-shop/ModalResultFail.tsx








const ModalResultFail = (param)=>{
    let { open , onOpenChange , textFail , notEnoughPoint =false  } = param;
    const { t  } = (0,esm/* useTranslation */.$G)();
    const router = (0,next_router.useRouter)();
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(dialog/* Dialog */.Vq, {
        open: open,
        onOpenChange: onOpenChange,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(dialog/* DialogContent */.cZ, {
            className: "sm:rounded-[16px] gap-0 rounded-[16px] max-w-[90vw] md:max-w-[461px] p-[24px] border-0 focus-visible:outline-none dark:bg-bg-02",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "w-full flex",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "w-[32px] h-[32px] rounded-[8px] flex items-center justify-center ml-auto mr-0 bg-bg-button dark:bg-bg-button/10 cursor-pointer",
                        onClick: onOpenChange,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(IconClose/* IconClose */.b, {})
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "w-[96px] h-[96px] rounded-[96px] mx-auto flex items-center justify-center mb-[24px] bg-error",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
                        xmlns: "http://www.w3.org/2000/svg",
                        width: "57",
                        height: "56",
                        viewBox: "0 0 57 56",
                        fill: "none",
                        className: "",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                            fillRule: "evenodd",
                            clipRule: "evenodd",
                            d: "M51.8332 27.9998C51.8332 40.8865 41.3865 51.3332 28.4998 51.3332C15.6132 51.3332 5.1665 40.8865 5.1665 27.9998C5.1665 15.1132 15.6132 4.6665 28.4998 4.6665C41.3865 4.6665 51.8332 15.1132 51.8332 27.9998ZM36.337 35.8368C35.6535 36.5202 34.5455 36.5202 33.8621 35.8368L28.4999 30.4746L23.1376 35.8368C22.4542 36.5202 21.3461 36.5202 20.6627 35.8368C19.9793 35.1534 19.9793 34.0454 20.6627 33.3619L26.025 27.9997L20.6628 22.6375C19.9793 21.9541 19.9793 20.846 20.6628 20.1626C21.3462 19.4792 22.4542 19.4792 23.1376 20.1626L28.4999 25.5248L33.8621 20.1626C34.5455 19.4792 35.6535 19.4792 36.3369 20.1626C37.0203 20.846 37.0203 21.9541 36.3369 22.6375L30.9747 27.9997L36.337 33.3619C37.0204 34.0453 37.0204 35.1534 36.337 35.8368Z",
                            fill: "#EB5757"
                        })
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                    className: "text-center Nunito-700 text-[18px] pb-[8px]",
                    children: t("reward.buy_gift_fail_title")
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                    className: "text-center text-neutral dark:text-neutral-08 Nunito-500 pb-[24px]",
                    children: textFail
                }),
                notEnoughPoint && /*#__PURE__*/ (0,jsx_runtime.jsxs)(ui_button/* Button */.z, {
                    variant: "main",
                    className: "px-[16px] py-[8px] h-[35px] rounded-[12px] w-fit text-[14px] Nunito-600 mx-auto",
                    onClick: ()=>{
                        router.push({
                            pathname: router.pathname,
                            query: {
                                tab: ENUM_NORMAL_TAB.MISSION_CENTER
                            }
                        });
                        onOpenChange();
                    },
                    children: [
                        t("common.get_more_spin"),
                        " Gold"
                    ]
                })
            ]
        })
    });
};

;// CONCATENATED MODULE: ./app/containers/reward-center/gold-shop/ModalResultSuccess.tsx








const ModalResultSuccess = (param)=>{
    let { open , onOpenChange , dataSelected  } = param;
    const { t  } = (0,esm/* useTranslation */.$G)();
    const router = (0,next_router.useRouter)();
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(dialog/* Dialog */.Vq, {
        open: open,
        onOpenChange: onOpenChange,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(dialog/* DialogContent */.cZ, {
            className: "sm:rounded-[24px] gap-0 rounded-[16px] max-w-[90vw] md:max-w-[461px] p-[24px] border-0 focus-visible:outline-none dark:bg-bg-02",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "w-full flex",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "w-[32px] h-[32px] rounded-[8px] flex items-center justify-center ml-auto mr-0 bg-bg-button dark:bg-bg-button/10 cursor-pointer",
                        onClick: onOpenChange,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(IconClose/* IconClose */.b, {})
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "w-[96px] h-[96px] rounded-[96px] mx-auto flex items-center justify-center mb-[24px] bg-bg-green",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
                        xmlns: "http://www.w3.org/2000/svg",
                        width: "56",
                        height: "56",
                        viewBox: "0 0 56 56",
                        fill: "none",
                        className: "mx-auto my-[20px]",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                            d: "M28.1438 5.14404C15.5495 5.14404 5.28662 15.4069 5.28662 28.0012C5.28662 40.5955 15.5495 50.8583 28.1438 50.8583C40.7381 50.8583 51.0009 40.5955 51.0009 28.0012C51.0009 15.4069 40.7381 5.14404 28.1438 5.14404ZM39.0695 22.744L26.1095 35.704C25.7895 36.024 25.3552 36.2069 24.8981 36.2069C24.4409 36.2069 24.0066 36.024 23.6866 35.704L17.2181 29.2355C16.5552 28.5726 16.5552 27.4755 17.2181 26.8126C17.8809 26.1498 18.9781 26.1498 19.6409 26.8126L24.8981 32.0698L36.6466 20.3212C37.3095 19.6583 38.4066 19.6583 39.0695 20.3212C39.7323 20.984 39.7323 22.0583 39.0695 22.744Z",
                            fill: "#27908C"
                        })
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                    className: "text-center Nunito-700 text-[18px] pb-[8px]",
                    children: t("store.payment_success_title")
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                    className: "text-center text-neutral dark:text-neutral-08 Nunito-500 pb-[24px]",
                    children: t("reward.buy_package_success_desc")
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(ui_button/* Button */.z, {
                    variant: "main",
                    className: "px-[16px] py-[8px] h-[35px] rounded-[12px] w-fit text-[14px] Nunito-600 mx-auto",
                    onClick: ()=>{
                        router.push({
                            pathname: router.pathname,
                            query: {
                                tab: ENUM_NORMAL_TAB.PACKAGE,
                                item: (dataSelected === null || dataSelected === void 0 ? void 0 : dataSelected.item_type) === configs/* PACKAGE_TYPE.AVATAR */.uG.AVATAR || (dataSelected === null || dataSelected === void 0 ? void 0 : dataSelected.item_type) === configs/* PACKAGE_TYPE.STICKER */.uG.STICKER ? configs/* TAB_ITEM_PACKAGE_TYPE.OTHER */.vC.OTHER : (dataSelected === null || dataSelected === void 0 ? void 0 : dataSelected.item_type) === configs/* PACKAGE_TYPE.VOUCHER */.uG.VOUCHER ? configs/* TAB_ITEM_PACKAGE_TYPE.VOUCHER */.vC.VOUCHER : (dataSelected === null || dataSelected === void 0 ? void 0 : dataSelected.item_type) === configs/* PACKAGE_TYPE.GIFTCODE */.uG.GIFTCODE ? configs/* TAB_ITEM_PACKAGE_TYPE.GIFTCODE */.vC.GIFTCODE : ""
                            }
                        });
                        onOpenChange();
                    },
                    children: t("reward.go_to_package")
                })
            ]
        })
    });
};

;// CONCATENATED MODULE: ./app/containers/reward-center/gold-shop/ModalViewItem.tsx







const ModalViewItem = (param)=>{
    let { open , onOpenChange , dataSelected , onConfirmBuy  } = param;
    const { t  } = (0,esm/* useTranslation */.$G)();
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(dialog/* Dialog */.Vq, {
        open: open,
        onOpenChange: onOpenChange,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(dialog/* DialogContent */.cZ, {
            className: "sm:rounded-[16px] gap-0 rounded-[16px] max-w-[90vw] md:max-w-[685px] p-[24px] border-0 focus-visible:outline-none dark:bg-bg-02 space-y-[24px]",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "w-full flex items-center justify-between",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                            className: "text-bg-01 Nunito-700 text-base mb-[40px dark:text-main-white",
                            children: t("reward.detail")
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "w-[32px] h-[32px] rounded-[8px] flex items-center justify-center cursor-pointer",
                            onClick: onOpenChange,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(IconClose/* IconClose */.b, {})
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "flex gap-[24px]",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                            src: dataSelected.image,
                            alt: dataSelected.item_name,
                            className: "object-cover aspect-square h-fit rounded-[12px] xs:rounded-[8px] w-[116px] sd:w-[230px]"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "flex flex-col justify-between",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                            className: "text-[14px] text-neutral-05 dark:text-neutral-07 pb-[6px] leading-[19px]",
                                            children: t("reward.exchange_package")
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                            className: "Nunito-500",
                                            children: dataSelected.item_name
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                            className: "text-[14px] text-neutral-05 dark:text-neutral-07 pb-[6px] leading-[19px]",
                                            children: t("reward.criteria")
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: "text-[14px] flex items-center gap-[3px] Nunito-500",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                    className: "leading-[14px]",
                                                    children: dataSelected.price
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(IconGold, {})
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "border border-dashed border-black/10 dark:border-neutral-07 dark:text-neutral-07 p-[12px] rounded-[12px] w-full text-[16px] Nunito-400 text-neutral-05",
                                    children: t("reward.exchange_note")
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "flex items-center justify-end gap-[16px]",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(ui_button/* Button */.z, {
                            variant: "grey",
                            className: "text-nutral-05 dark:text-neutral-08 rounded-[16px] px-[24px] py-[12px] h-[46px] w-full md:w-fit",
                            onClick: onOpenChange,
                            children: t("merchandise.cancel")
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(ui_button/* Button */.z, {
                            variant: "main",
                            className: "px-[24px] py-[12px] h-[46px] rounded-[16px] w-full md:w-fit",
                            onClick: onConfirmBuy,
                            children: t("store.buy_now")
                        })
                    ]
                })
            ]
        })
    });
};

;// CONCATENATED MODULE: ./app/containers/reward-center/gold-shop/index.tsx




















const listFilter = (t)=>[
        {
            title: t("reward.ascending"),
            value: "1"
        },
        {
            title: t("reward.decrease"),
            value: "-1"
        }
    ];
const listTab = (t)=>[
        {
            title: t("common.all"),
            value: ""
        },
        {
            title: "Voucher",
            value: "voucher"
        },
        {
            title: t("reward.tab_other"),
            value: "avatar,sticker,giftcode"
        }
    ];
const GoldShopContainer = ()=>{
    var _data_data;
    const { t  } = (0,esm/* useTranslation */.$G)();
    const router = (0,next_router.useRouter)();
    const { pointReward , getPoint  } = (0,react.useContext)(RewardContext/* RewardContext */.w);
    const { themeApp  } = (0,react.useContext)(context/* AppContext */.Il);
    const [textFail, setTextFail] = (0,react.useState)("");
    const [dataSelected, setDataSelected] = (0,react.useState)();
    const [params, setParams] = (0,react.useState)({
        item_type: "",
        order_price: "",
        page: 1,
        limit: 12
    });
    const [visible, setVisible] = (0,react.useState)({
        view: false,
        confirm: false,
        result: false,
        resultFail: false
    });
    const { data , isLoading  } = useQueryGetListShopItem(params);
    const { mutate  } = useMutationBuyItem();
    const { userInfo  } = (0,react.useContext)(context/* AppContext */.Il);
    const [isNotEnoughPoint, setIsNotEnoughPoint] = (0,react.useState)(false);
    const queryClient = (0,QueryClientProvider/* useQueryClient */.NL)();
    const GoldShopCard = (param)=>{
        let { cardItem  } = param;
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            onClick: ()=>{
                setDataSelected(cardItem);
                setVisible({
                    ...visible,
                    view: true
                });
            },
            className: "flex cursor-pointer flex-col p-[8px] bg-white dark:bg-white/10 rounded-[12px] xs:rounded-[8px] border border-black/10 cursor-pointer md:hover:shadow-[0px_3px_30px_0px_rgba(0,0,0,0.15)] transition duration-300 active:bg-bg-button active:border-bg-button dark:active:border-black/10 md:active:bg-white dark:md:active:bg-white/10 md:active:border-black/10 ",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                    src: cardItem.image,
                    alt: cardItem.item_name,
                    className: "w-full object-cover aspect-square rounded-[12px] xs:rounded-[8px]"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "mt-[8px] p-[8px] flex flex-col h-full flex-1",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                            className: "text-[14px] xs:text-[12px] text-center md:text-left xs:leading-[16px] Nunito-700 leading-[19px] pb-[8px]",
                            children: cardItem.item_name
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "text-[14px] text-neutral-05 dark:text-neutral-08 flex items-center gap-[3px] Nunito-500 mb-[16px]",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                    className: "leading-[14px]",
                                    children: cardItem.price
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(IconGold, {})
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "flex justify-betweem gap-[6px] mt-auto mb-0",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(ui_button/* Button */.z, {
                                    onClick: ()=>{
                                        setDataSelected(cardItem);
                                        setVisible({
                                            ...visible,
                                            view: true
                                        });
                                    },
                                    variant: "grey",
                                    className: "h-[24px] text-[12px] text-neutral-05 dark:text-neutral-08 Nunito-400 rounded-[8px] w-full px-0",
                                    children: t("reward.detail")
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(ui_button/* Button */.z, {
                                    onClick: (e)=>{
                                        e.stopPropagation();
                                        setDataSelected(cardItem);
                                        setVisible({
                                            ...visible,
                                            confirm: true
                                        });
                                    },
                                    variant: "main",
                                    className: "h-[24px] text-[12px] rounded-[8px] Nunito-400 w-full px-0",
                                    children: t("store.buy_now")
                                })
                            ]
                        })
                    ]
                })
            ]
        }, cardItem.id);
    };
    const handleBuy = (_data)=>{
        if ((dataSelected === null || dataSelected === void 0 ? void 0 : dataSelected.price) && pointReward < (dataSelected === null || dataSelected === void 0 ? void 0 : dataSelected.price)) {
            setTextFail(t("reward.buy_gift_fail_desc"));
            setVisible({
                ...visible,
                confirm: false,
                resultFail: true
            });
            setIsNotEnoughPoint(true);
        } else {
            mutate(_data, {
                onSuccess (data) {
                    if (data.data.errorCode === 0) {
                        setVisible({
                            ...visible,
                            confirm: false,
                            result: true
                        });
                        getPoint();
                        queryClient.refetchQueries({
                            queryKey: [
                                configs/* QUERY_KEY.POINT_HISTORY */.lP.POINT_HISTORY,
                                userInfo === null || userInfo === void 0 ? void 0 : userInfo.userid,
                                {
                                    type: "spent",
                                    source: "",
                                    start_date: "",
                                    end_date: ""
                                }
                            ]
                        });
                    // GAEventsTracker("Shop_Buy_Success")
                    } else {
                        // GAEventsTracker("Shop_Buy_Failed")
                        setTextFail(t("message.DEFAULT_ERROR"));
                        setVisible({
                            ...visible,
                            confirm: false,
                            resultFail: true
                        });
                    }
                },
                onError (error) {
                    var _error_data;
                    // GAEventsTracker("Shop_Buy_Failed")
                    setTextFail((error === null || error === void 0 ? void 0 : (_error_data = error.data) === null || _error_data === void 0 ? void 0 : _error_data.errorCode) === 400 ? t("message.max_buy_giftcode") : t("message.DEFAULT_ERROR"));
                    setVisible({
                        ...visible,
                        confirm: false,
                        resultFail: true
                    });
                }
            });
        }
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "flex justify-between items-center mt-[16px]",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "md:flex gap-[8px] hidden",
                        children: listTab(t).map((item)=>{
                            return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "px-[16px] py-[4px] border text-[14px] leading-[19px] rounded-[8px] cursor-pointer ".concat(params.item_type === item.value ? "bg-main-01 text-white border-main-01 Nunito-500" : "text-neutral border-black/10 dark:border-neutral-08 dark:text-neutral-08 Nunito-400"),
                                onClick: ()=>{
                                    setParams({
                                        ...params,
                                        item_type: item.value
                                    });
                                },
                                children: item.title
                            }, item.value);
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(ui_select/* Select */.Ph, {
                        value: params.item_type,
                        onValueChange: (value)=>setParams({
                                ...params,
                                item_type: value === "all" ? "" : value
                            }),
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(ui_select/* SelectTrigger */.i4, {
                                asChild: false,
                                className: "md:hidden w-[36px] h-[36px] rounded-[12px] bg-bg-disable dark:bg-white/10 flex items-center justify-center p-0",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "w-[36px] h-[36px] rounded-[12px] bg-bg-disable dark:bg-white/10 flex items-center justify-center p-0",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(IconFilter/* IconFilter */.w, {})
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(ui_select/* SelectContent */.Bw, {
                                className: "p-1 rounded-[16px]",
                                children: listTab(t).map((item)=>{
                                    /*#__PURE__*/ return (0,jsx_runtime.jsx)(ui_select/* SelectItem */.Ql, {
                                        value: (item === null || item === void 0 ? void 0 : item.value) === "" ? "all" : item === null || item === void 0 ? void 0 : item.value,
                                        className: "p-3 rounded-[8px] hover:!bg-bg-disable hover:!text-main-01 text-sm Nunito-600 focus:bg-bg-disable focus:text-main-01 dark:hover:!bg-[#F1F1FC]/[.1] dark:focus:!bg-[#F1F1FC]/[.1]",
                                        children: item === null || item === void 0 ? void 0 : item.title
                                    }, item === null || item === void 0 ? void 0 : item.value);
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(dropdown_menu/* DropdownMenu */.h_, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(dropdown_menu/* DropdownMenuTrigger */.$F, {
                                asChild: true,
                                className: "outline-0 mt-0",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "cursor-pointer h-[36px] px-[12px] rounded-[12px] bg-bg-disable dark:bg-white/10 text-main-01 dark:text-main-white text-[14px] Nunito-600 flex items-center gap-[8px]",
                                    children: [
                                        t("profile.filter_by"),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
                                            xmlns: "http://www.w3.org/2000/svg",
                                            width: "20",
                                            height: "20",
                                            viewBox: "0 0 20 20",
                                            fill: "none",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                d: "M10 5H17.5M10 10H15M10 15H12.5M2.5 13.0208L3.75432 14.4319C4.4173 15.1778 5.5827 15.1778 6.24568 14.4319L7.5 13.0208M5 15V5",
                                                stroke: themeApp === "dark" ? "#FAF8FF" : "#7673E6",
                                                strokeWidth: "1.5",
                                                strokeLinecap: "round"
                                            })
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(dropdown_menu/* DropdownMenuContent */.AW, {
                                className: "text-left p-[12px] space-y-[4px]",
                                align: "end",
                                children: listFilter(t).map((item)=>{
                                    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(dropdown_menu/* DropdownMenuItem */.Xi, {
                                        className: "justify-start ".concat(params.order_price === item.value ? "text-main-01 bg-bg-disable" : "dark:text-neutral-08", " items-center justify-between focus:bg-bg-disable dark:focus:bg-bg-disable/10 dark focus:text-main-01 dark:focus:text-main-01 Nunito-600 text-[16px] text-center flex px-4 py-3 rounded-[8px] w-[210px]"),
                                        onClick: ()=>{
                                            if (params.order_price !== item.value) {
                                                setParams({
                                                    ...params,
                                                    order_price: item.value
                                                });
                                            } else {
                                                setParams({
                                                    ...params,
                                                    order_price: ""
                                                });
                                            }
                                        },
                                        children: [
                                            item.title,
                                            params.order_price === item.value && /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
                                                xmlns: "http://www.w3.org/2000/svg",
                                                width: "16",
                                                height: "11",
                                                viewBox: "0 0 16 11",
                                                fill: "none",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                    fillRule: "evenodd",
                                                    clipRule: "evenodd",
                                                    d: "M15.5018 0.442536C15.8096 0.71963 15.8346 1.19385 15.5575 1.50173L7.8199 10.0991C6.84536 11.1819 5.19549 11.3168 4.05793 10.4068L0.531506 7.58566C0.20806 7.3269 0.155619 6.85493 0.414376 6.53149C0.673133 6.20804 1.1451 6.1556 1.46855 6.41436L4.99497 9.23549C5.51204 9.64915 6.26199 9.5878 6.70496 9.09561L14.4426 0.498283C14.7197 0.1904 15.1939 0.165442 15.5018 0.442536Z",
                                                    fill: "#7673E6"
                                                })
                                            })
                                        ]
                                    }, item.value);
                                })
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "mt-[24px] grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 pc:grid-cols-6 gap-[16px] pc:gap-[24px]",
                children: [
                    data === null || data === void 0 ? void 0 : (_data_data = data.data) === null || _data_data === void 0 ? void 0 : _data_data.map((item, index)=>{
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(GoldShopCard, {
                            cardItem: item
                        }, item === null || item === void 0 ? void 0 : item.id);
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "col-span-2 sm:col-span-3 md:col-span-4 lg:col-span-5 pc:col-span-6 flex justify-end mt-[8px]",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(pagination/* default */.Z, {
                            totalCount: (data === null || data === void 0 ? void 0 : data.totalItems) || 0,
                            onPageChange: (page)=>setParams({
                                    ...params,
                                    page: page
                                }),
                            pageSize: 12,
                            currentPage: params.page
                        })
                    })
                ]
            }),
            dataSelected && /*#__PURE__*/ (0,jsx_runtime.jsx)(ModalViewItem, {
                open: visible.view,
                onOpenChange: ()=>{
                    setVisible({
                        ...visible,
                        view: !visible.view
                    });
                },
                dataSelected: dataSelected,
                onConfirmBuy: ()=>{
                    setVisible({
                        ...visible,
                        view: false,
                        confirm: true
                    });
                }
            }),
            dataSelected && /*#__PURE__*/ (0,jsx_runtime.jsx)(ModalConfirmBuy, {
                open: visible.confirm,
                onOpenChange: ()=>{
                    setVisible({
                        ...visible,
                        confirm: !visible.confirm
                    });
                },
                dataSelected: dataSelected,
                onBuy: ()=>handleBuy({
                        item_id: dataSelected.id
                    })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ModalResultSuccess, {
                open: visible.result,
                onOpenChange: ()=>{
                    setVisible({
                        ...visible,
                        result: !visible.result
                    });
                },
                dataSelected: dataSelected
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ModalResultFail, {
                open: visible.resultFail,
                onOpenChange: ()=>{
                    setVisible({
                        ...visible,
                        resultFail: !visible.resultFail
                    });
                    setIsNotEnoughPoint(false);
                },
                textFail: textFail,
                notEnoughPoint: isNotEnoughPoint
            })
        ]
    });
};

// EXTERNAL MODULE: ./app/components/data-empty/index.tsx + 1 modules
var data_empty = __webpack_require__(98269);
// EXTERNAL MODULE: ./app/context/PackageContext.tsx
var PackageContext = __webpack_require__(61983);
;// CONCATENATED MODULE: ./app/services/query-fn/reward-center/package/package-query.ts



const getListPackageFn = async (params)=>{
    const data = await RewardService/* default.getPackage */.Z.getPackage(params);
    return data.data;
};
const getListGameByGiftcodeFn = async (params)=>{
    const data = await RewardService/* default.getGameByGiftcode */.Z.getGameByGiftcode(params);
    return data.data;
};
const useQueryGetListPackage = (params)=>{
    return (0,useQuery/* useQuery */.a)({
        queryKey: [
            configs/* QUERY_KEY.PACKAGE_LIST */.lP.PACKAGE_LIST,
            params
        ],
        queryFn: ()=>getListPackageFn(params),
        enabled: !!params,
        refetchOnWindowFocus: false,
        retry: 0
    });
};
const useQueryGetListGameByGiftcode = (params)=>{
    return (0,useQuery/* useQuery */.a)({
        queryKey: [
            configs/* QUERY_KEY.LIST_GAME_BY_GIFTCODE */.lP.LIST_GAME_BY_GIFTCODE,
            params
        ],
        queryFn: ()=>getListGameByGiftcodeFn(params),
        enabled: !!params,
        refetchOnWindowFocus: false,
        retry: 0
    });
};

// EXTERNAL MODULE: ./node_modules/react-hook-form/dist/index.esm.mjs
var index_esm = __webpack_require__(87536);
// EXTERNAL MODULE: ./app/containers/users/common/filter-post/StartTime.tsx
var StartTime = __webpack_require__(25193);
// EXTERNAL MODULE: ./app/containers/users/common/filter-post/EndTime.tsx
var EndTime = __webpack_require__(53064);
;// CONCATENATED MODULE: ./app/containers/reward-center/package/PackageFilter.tsx












const PackageFilter = (param)=>{
    let { params , setParams  } = param;
    var _router_query, _ref;
    const { t  } = (0,esm/* useTranslation */.$G)();
    const [game, setGame] = (0,react.useState)({
        game_name: t("common.all"),
        game_id: "all",
        icon: ""
    });
    const { data: listGame  } = (0,query_fn_game/* useQueryGetListGame */.Bu)({
        category: "",
        type: "",
        limit: 100,
        page: 1
    });
    const { setValue , watch  } = (0,index_esm/* useFormContext */.Gc)();
    const router = (0,next_router.useRouter)();
    const { themeApp  } = (0,react.useContext)(context/* AppContext */.Il);
    const [openFilter, setOpenFilter] = (0,react.useState)(false);
    const [openStartTime, setOpenStartTime] = (0,react.useState)(false);
    const [openEndTime, setOpenEndTime] = (0,react.useState)(false);
    const selectedStartTime = watch("start_date", undefined);
    const selectedEndTime = watch("end_date", undefined);
    const status = watch("status", "");
    const isEnable = (0,react.useMemo)(()=>{
        let result = true;
        if (selectedStartTime && selectedEndTime && selectedStartTime < selectedEndTime) {
            result = true;
        }
        if (selectedStartTime && !selectedEndTime || !selectedStartTime && selectedEndTime || selectedStartTime >= selectedEndTime) {
            result = false;
        }
        return result;
    }, [
        status,
        selectedStartTime,
        selectedEndTime
    ]);
    const OptionGame = !!listGame ? listGame : [];
    const OptionStatus = [
        {
            title: t("common.all"),
            value: "all"
        },
        {
            title: t("reward.not_use"),
            value: "pending"
        },
        {
            title: t("reward.used"),
            value: "done"
        }
    ];
    const onChangeStartTime = ()=>{
        setOpenStartTime(!openStartTime);
    };
    const onChangeEndTime = ()=>{
        setOpenEndTime(!openEndTime);
    };
    const clearFilter = ()=>{
        setValue("start_date", undefined);
        setValue("end_date", undefined);
        setValue("status", "");
        setParams({
            ...params,
            start_date: undefined,
            end_date: undefined,
            status: "",
            page: 1
        });
        setOpenFilter(false);
    };
    const onChangeType = (value)=>{
        if (value !== "all") {
            setValue("status", value);
        } else {
            setValue("status", "");
        }
    };
    const onChangeGame = (value)=>{
        const _game = OptionGame === null || OptionGame === void 0 ? void 0 : OptionGame.find((item)=>{
            return (item === null || item === void 0 ? void 0 : item.game_id) === value;
        });
        value === "all" ? setGame({
            game_name: t("common.all"),
            game_id: "all",
            icon: ""
        }) : setGame(_game);
        setParams({
            ...params,
            game_id: _game === null || _game === void 0 ? void 0 : _game.game_id
        });
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "flex items-center gap-[8px] justify-between md:justify-start",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(ui_select/* Select */.Ph, {
                value: (game === null || game === void 0 ? void 0 : game.game_id) || "all",
                onValueChange: (value)=>onChangeGame(value),
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "relative ".concat((router === null || router === void 0 ? void 0 : (_router_query = router.query) === null || _router_query === void 0 ? void 0 : _router_query.item) !== "giftcode" && "hidden"),
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(ui_select/* SelectTrigger */.i4, {
                            asChild: false,
                            className: "px-[8px] h-[28px] border-main-01 dark:bg-main-disable rounded-[8px] bg-bg-disable dark:bg-bg-disable/10 flex gap-[4px] items-center text-main-01 dark:text-main-disable text-[12px]",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(ui_select/* SelectValue */.ki, {
                                    placeholder: t("common.chose_game"),
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "flex-1 line-clamp-1",
                                        children: (game === null || game === void 0 ? void 0 : game.game_name) || ""
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
                                    width: "20",
                                    height: "20",
                                    viewBox: "0 0 20 20",
                                    fill: "none",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                        d: "M5.8335 8.3335L10.0002 11.6668L14.1668 8.3335",
                                        stroke: "#7673E6",
                                        strokeWidth: "1.5",
                                        strokeLinecap: "round",
                                        strokeLinejoin: "round"
                                    })
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ui_select/* SelectContent */.Bw, {
                        align: "end",
                        className: "p-1 rounded-[16px]",
                        children: OptionGame && ((_ref = [
                            {
                                game_name: t("common.all"),
                                game_id: "all",
                                icon: ""
                            },
                            ...OptionGame.sort((a, b)=>a.game_name.localeCompare(b.game_name))
                        ]) === null || _ref === void 0 ? void 0 : _ref.map((item)=>{
                            /*#__PURE__*/ return (0,jsx_runtime.jsx)(ui_select/* SelectItem */.Ql, {
                                value: item === null || item === void 0 ? void 0 : item.game_id,
                                className: "p-[6px] h-[36px] rounded-[12px] hover:!bg-bg-disable hover:!text-main-01 Nunito-500 focus:bg-bg-disable focus:text-main-01 dark:hover:!bg-[#F1F1FC]/[.1] dark:focus:!bg-[#F1F1FC]/[.1]",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "flex items-center gap-[6px]",
                                    title: item === null || item === void 0 ? void 0 : item.game_name,
                                    children: [
                                        (item === null || item === void 0 ? void 0 : item.icon) && /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                            src: item === null || item === void 0 ? void 0 : item.icon,
                                            alt: item === null || item === void 0 ? void 0 : item.game_name,
                                            className: "w-[24px] h-[24px] rounded-[6px]"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                            className: "flex-1 line-clamp-1",
                                            children: item === null || item === void 0 ? void 0 : item.game_name
                                        })
                                    ]
                                })
                            }, item === null || item === void 0 ? void 0 : item.game_id);
                        }))
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(dropdown_menu/* DropdownMenu */.h_, {
                open: openFilter,
                onOpenChange: ()=>setOpenFilter(false),
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(dropdown_menu/* DropdownMenuTrigger */.$F, {
                        asChild: true,
                        className: "outline-0 mt-0",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            onClick: ()=>setOpenFilter(true),
                            className: "w-fit ml-auto md:mt-0 border border-main-01 cursor-pointer h-[28px] px-[8px] rounded-[8px] bg-bg-disable dark:bg-white/10 text-main-01 dark:text-main-white text-[14px] Nunito-600 flex items-center gap-[8px]",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
                                xmlns: "http://www.w3.org/2000/svg",
                                width: "20",
                                height: "20",
                                viewBox: "0 0 20 20",
                                fill: "none",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                    d: "M2.5 5.83325H5M5 5.83325C5 7.21396 6.11929 8.33325 7.5 8.33325C8.88071 8.33325 10 7.21396 10 5.83325C10 4.45254 8.88071 3.33325 7.5 3.33325C6.11929 3.33325 5 4.45254 5 5.83325ZM2.5 14.1666H7.5M15 14.1666H17.5M15 14.1666C15 15.5473 13.8807 16.6666 12.5 16.6666C11.1193 16.6666 10 15.5473 10 14.1666C10 12.7859 11.1193 11.6666 12.5 11.6666C13.8807 11.6666 15 12.7859 15 14.1666ZM12.5 5.83325H17.5",
                                    stroke: "#7673E6",
                                    strokeWidth: "1.5",
                                    strokeLinecap: "round"
                                })
                            })
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(dropdown_menu/* DropdownMenuContent */.AW, {
                        align: "end",
                        className: "min-w-[343px] rounded-[24px] p-[16px] overflow-visible dark:bg-dark-mode-box",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "w-full bg-white dark:bg-dark-mode-box",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "mb-[24px]",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                            className: "text-[16px] Nunito-600 text-neutral-03 dark:text-neutral-06",
                                            children: t("reward.status")
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(ui_select/* Select */.Ph, {
                                            value: status !== "" ? status : "all",
                                            onValueChange: (value)=>onChangeType(value),
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(ui_select/* SelectTrigger */.i4, {
                                                    className: "w-full rounded-none border-0 border-b-[1px] border-black/10 dark:border-neutral-07 text-sm Nunito-500 text-neutral-05 dark:text-main-white dark:bg-transparent dark:backdrop-blur-[20px] text-left",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ui_select/* SelectValue */.ki, {
                                                        placeholder: t("reward.status_placeholder"),
                                                        defaultValue: ""
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(ui_select/* SelectContent */.Bw, {
                                                    className: "p-1 rounded-[16px]",
                                                    children: OptionStatus.map((item)=>{
                                                        /*#__PURE__*/ return (0,jsx_runtime.jsx)(ui_select/* SelectItem */.Ql, {
                                                            value: item === null || item === void 0 ? void 0 : item.value,
                                                            className: "p-3 rounded-[8px] hover:!bg-bg-disable hover:!text-main-01 text-sm Nunito-600 focus:bg-bg-disable focus:text-main-01 dark:hover:!bg-[#F1F1FC]/[.1] dark:focus:!bg-[#F1F1FC]/[.1]",
                                                            children: item === null || item === void 0 ? void 0 : item.title
                                                        }, item === null || item === void 0 ? void 0 : item.value);
                                                    })
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                            className: "text-base Nunito-600 text-neutral-03 dark:text-neutral-06",
                                            children: t("profile.time_title")
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: "flex items-center gap-[12px]",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(StartTime/* StartTimeFilter */.M, {
                                                    open: openStartTime,
                                                    onChange: onChangeStartTime
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                    children: "-"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(EndTime/* EndTimeFilter */.o, {
                                                    open: openEndTime,
                                                    onChange: onChangeEndTime
                                                })
                                            ]
                                        }),
                                        selectedStartTime >= selectedEndTime && /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                            className: "mt-2 text-xs text-main-red-02",
                                            children: t("profile.invalid_date")
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "w-full flex items-center justify-end gap-[16px] mt-[24px]",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(ui_button/* Button */.z, {
                                            variant: "grey",
                                            className: "text-[14px] bg-bg-button text-neutral-04 dark:text-neutral-08 Nunito-700 h-[30px] py-[6px] px-[24px] rounded-[12px]",
                                            autoFocus: false,
                                            onClick: clearFilter,
                                            children: t("merchandise.cancel")
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(ui_button/* Button */.z, {
                                            variant: "main",
                                            disabled: !isEnable,
                                            className: "text-[14px] h-[30px] Nunito-700 py-[6px] px-[24px] rounded-[12px]",
                                            onClick: ()=>{
                                                setOpenFilter(false);
                                                setParams({
                                                    ...params,
                                                    start_date: selectedStartTime,
                                                    end_date: selectedEndTime,
                                                    status: status,
                                                    page: 1
                                                });
                                            },
                                            children: t("profile.filter")
                                        })
                                    ]
                                })
                            ]
                        })
                    })
                ]
            })
        ]
    });
};

// EXTERNAL MODULE: ./app/components/view-media/ModalViewMedia.tsx
var ModalViewMedia = __webpack_require__(27673);
;// CONCATENATED MODULE: ./app/containers/reward-center/package/modal/ModalApplyAvatarSuccess.tsx






const ModalApplyAvatarSuccess = (param)=>{
    let { open , handleClose  } = param;
    const { visible , setVisible , setPreview , preview  } = (0,react.useContext)(PackageContext/* PackageContext */.M);
    const { t  } = (0,esm/* useTranslation */.$G)();
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(dialog/* Dialog */.Vq, {
        open: open,
        onOpenChange: handleClose,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(dialog/* DialogContent */.cZ, {
            className: "max-w-[320px] border-0 shadow-[0px_4px_30px_0px_rgba(0,0,0,0.06)] rounded-[24px] p-[24px] sm:rounded-[24px] gap-0 xs:w-[90vw]",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                    className: "text-[16px] Nunito-700 pb-[8px] leading-[22px] text-center",
                    children: "Bạn đ\xe3 \xe1p dụng avatar th\xe0nh c\xf4ng!"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                    className: "text-[14px] text-neutral-05 text-center dark:text-neutral-07",
                    children: "Truy cập Profile để cập nhật giao diện mới"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(ui_button/* Button */.z, {
                    variant: "main",
                    onClick: ()=>{
                        setVisible({
                            ...visible,
                            avatarSuccess: false
                        });
                    },
                    className: "text-[14px] rounded-[8px] px-[16px] py-[6px] w-fit h-[30px] mx-auto mt-[32px]",
                    children: t("common.close")
                })
            ]
        })
    });
};

;// CONCATENATED MODULE: ./app/services/query-fn/reward-center/package/package-mutation.ts



const useItemFn = (body)=>{
    return RewardService/* default.getItemBag */.Z.getItemBag(body);
};
const useMutationUseItem = ()=>{
    return (0,useMutation/* useMutation */.D)({
        mutationKey: [
            configs/* QUERY_KEY.USE_ITEM */.lP.USE_ITEM
        ],
        mutationFn: useItemFn
    });
};

;// CONCATENATED MODULE: ./app/containers/reward-center/package/modal/ModalCardDetail.tsx













const ModalCardDetail = (param)=>{
    let { open , handleClose , listItem  } = param;
    var _dataSelected_item_received, _dataSelected_item_received1, _dataSelected_item_received2, _dataSelected_item_received3, _dataSelected_item_received4, _dataSelected_item_received5, _dataSelected_item_received6, _dataSelected_item_received7;
    const { visible , setVisible , dataSelected , setDataSelected  } = (0,react.useContext)(PackageContext/* PackageContext */.M);
    const { t  } = (0,esm/* useTranslation */.$G)();
    const queryClient = (0,QueryClientProvider/* useQueryClient */.NL)();
    const { toast  } = (0,use_toast/* useToast */.pm)();
    const { mutate , isPending  } = useMutationUseItem();
    const GAEventsTracker = (0,useGAEventsTracker/* default */.Z)("Inventory");
    const onClose = ()=>{
        setVisible({
            ...visible,
            view: false
        });
    };
    const onUse = async (item)=>{
        GAEventsTracker("Inventory_used_voucher", item === null || item === void 0 ? void 0 : item.name);
        mutate({
            item_id: item.id
        }, {
            onSuccess: ()=>{
                queryClient.refetchQueries({
                    queryKey: [
                        configs/* QUERY_KEY.PACKAGE_LIST */.lP.PACKAGE_LIST
                    ]
                });
                toast({
                    variant: "success",
                    title: "\xc1p dụng th\xe0nh c\xf4ng!"
                });
            },
            onError: ()=>{}
        });
    };
    (0,react.useEffect)(()=>{
        if ((listItem === null || listItem === void 0 ? void 0 : listItem.length) && dataSelected) {
            const _selected = listItem === null || listItem === void 0 ? void 0 : listItem.find((item)=>{
                return (item === null || item === void 0 ? void 0 : item.id) === dataSelected.id;
            });
            setDataSelected(_selected);
        }
    }, [
        listItem,
        dataSelected
    ]);
    const onCopyCode = ()=>{
        GAEventsTracker("Inventory_copied_voucher", dataSelected === null || dataSelected === void 0 ? void 0 : dataSelected.name);
        if ((dataSelected === null || dataSelected === void 0 ? void 0 : dataSelected.type) === configs/* PACKAGE_TYPE.GIFT_VOUCHER */.uG.GIFT_VOUCHER) {
            var _dataSelected_item_received;
            navigator.clipboard.writeText((dataSelected === null || dataSelected === void 0 ? void 0 : (_dataSelected_item_received = dataSelected.item_received) === null || _dataSelected_item_received === void 0 ? void 0 : _dataSelected_item_received.gift_voucher) || "");
        }
        if ((dataSelected === null || dataSelected === void 0 ? void 0 : dataSelected.type) === configs/* PACKAGE_TYPE.VOUCHER */.uG.VOUCHER) {
            var _dataSelected_item_received1;
            navigator.clipboard.writeText((dataSelected === null || dataSelected === void 0 ? void 0 : (_dataSelected_item_received1 = dataSelected.item_received) === null || _dataSelected_item_received1 === void 0 ? void 0 : _dataSelected_item_received1.voucher_code) || "");
        }
        toast({
            variant: "success",
            title: "Sao ch\xe9p th\xe0nh c\xf4ng!"
        });
        onClose();
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(dialog/* Dialog */.Vq, {
        open: open,
        onOpenChange: handleClose,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(dialog/* DialogContent */.cZ, {
            className: "max-w-[502px] border-0 shadow-[0px_4px_30px_0px_rgba(0,0,0,0.06)] rounded-[24px] p-[24px] sm:rounded-[24px] gap-0 space-y-[24px] xs:w-[90vw]",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "flex items-center justify-between",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                            className: "text-[16px] Nunito-700",
                            children: "Voucher"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(IconClose/* IconClose */.b, {
                            className: "cursor-pointer",
                            onClick: ()=>onClose()
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "flex-1 space-y-[24px]",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                        className: "text-[14px] text-neutral-05 dark:text-neutral-07",
                                        children: t("reward.voucher_type")
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                        className: "text-[16px] Nunito-500",
                                        children: dataSelected === null || dataSelected === void 0 ? void 0 : dataSelected.name
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                        className: "text-[14px] text-neutral-05 dark:text-neutral-07",
                                        children: t("reward.received_time")
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                        className: "text-[16px] Nunito-500",
                                        children: moment_default().unix(dataSelected === null || dataSelected === void 0 ? void 0 : dataSelected.created_at).format(configs/* DATE_FORMAT */.zT)
                                    })
                                ]
                            }),
                            (dataSelected === null || dataSelected === void 0 ? void 0 : (_dataSelected_item_received = dataSelected.item_received) === null || _dataSelected_item_received === void 0 ? void 0 : _dataSelected_item_received.description) && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                        className: "text-[14px] text-neutral-05 dark:text-neutral-07",
                                        children: t("reward.voucher_content")
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                        dangerouslySetInnerHTML: {
                                            __html: dataSelected === null || dataSelected === void 0 ? void 0 : (_dataSelected_item_received1 = dataSelected.item_received) === null || _dataSelected_item_received1 === void 0 ? void 0 : _dataSelected_item_received1.description.replaceAll("\n", "<br/>")
                                        },
                                        className: "text-[16px] Nunito-500"
                                    })
                                ]
                            }),
                            ((dataSelected === null || dataSelected === void 0 ? void 0 : (_dataSelected_item_received2 = dataSelected.item_received) === null || _dataSelected_item_received2 === void 0 ? void 0 : _dataSelected_item_received2.gift_voucher) || (dataSelected === null || dataSelected === void 0 ? void 0 : (_dataSelected_item_received3 = dataSelected.item_received) === null || _dataSelected_item_received3 === void 0 ? void 0 : _dataSelected_item_received3.voucher_code)) && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "border border-dashed border-black/10 dark:border-neutral-07 rounded-[12px] p-[12px] text-[24px] Nunito-700 text-main-01 text-center",
                                children: [
                                    (dataSelected === null || dataSelected === void 0 ? void 0 : dataSelected.type) === configs/* PACKAGE_TYPE.GIFT_VOUCHER */.uG.GIFT_VOUCHER ? dataSelected === null || dataSelected === void 0 ? void 0 : (_dataSelected_item_received4 = dataSelected.item_received) === null || _dataSelected_item_received4 === void 0 ? void 0 : _dataSelected_item_received4.gift_voucher : (dataSelected === null || dataSelected === void 0 ? void 0 : dataSelected.type) === configs/* PACKAGE_TYPE.VOUCHER */.uG.VOUCHER ? dataSelected === null || dataSelected === void 0 ? void 0 : (_dataSelected_item_received5 = dataSelected.item_received) === null || _dataSelected_item_received5 === void 0 ? void 0 : _dataSelected_item_received5.voucher_code : "",
                                    (dataSelected === null || dataSelected === void 0 ? void 0 : (_dataSelected_item_received6 = dataSelected.item_received) === null || _dataSelected_item_received6 === void 0 ? void 0 : _dataSelected_item_received6.expired_date) && /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                        className: "text-[14px] text-neutral-05 dark:text-neutral-07 Nunito-400 leading-[19px]",
                                        children: [
                                            "HSD:",
                                            " ",
                                            moment_default()(dataSelected === null || dataSelected === void 0 ? void 0 : (_dataSelected_item_received7 = dataSelected.item_received) === null || _dataSelected_item_received7 === void 0 ? void 0 : _dataSelected_item_received7.expired_date).format(configs/* DATE_FORMAT */.zT)
                                        ]
                                    })
                                ]
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "flex gap-[16px] justify-end items-center",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(ui_button/* Button */.z, {
                            variant: "grey",
                            onClick: ()=>onClose(),
                            className: "text-neutral-05 dark:text-neutral-08 rounded-[16px] px-[24px] py-[12px] w-fit h-[46px]",
                            children: t("merchandise.cancel")
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(ui_button/* Button */.z, {
                            variant: "main",
                            loading: isPending,
                            onClick: ()=>{
                                onCopyCode();
                            },
                            className: "rounded-[16px] px-[24px] py-[12px] w-fit h-[46px]",
                            children: t("reward.copy")
                        })
                    ]
                })
            ]
        })
    });
};

;// CONCATENATED MODULE: ./app/containers/reward-center/package/modal/ModalAppotaCard.tsx















const ModalAppotaCardDetail = (param)=>{
    let { open , handleClose , listItem  } = param;
    var _dataSelected_item_received, _dataSelected_item_received1, _dataSelected_item_received2, _dataSelected_item_received3, _dataSelected_item_received4, _dataSelected_item_received5;
    const { visible , setVisible , dataSelected , setDataSelected  } = (0,react.useContext)(PackageContext/* PackageContext */.M);
    const { t  } = (0,esm/* useTranslation */.$G)();
    const queryClient = (0,QueryClientProvider/* useQueryClient */.NL)();
    const { toast  } = (0,use_toast/* useToast */.pm)();
    const { mutate , isPending  } = useMutationUseItem();
    const [copySerial, setCopySerial] = (0,react.useState)(false);
    const GAEventsTracker = (0,useGAEventsTracker/* default */.Z)("Inventory");
    const onClose = ()=>{
        setVisible({
            ...visible,
            appotaDetail: false
        });
        setDataSelected();
    };
    const onUse = async (item)=>{
        GAEventsTracker("Inventory_used_ACard");
        mutate({
            item_id: item.id
        }, {
            onSuccess: ()=>{
                queryClient.refetchQueries({
                    queryKey: [
                        configs/* QUERY_KEY.PACKAGE_LIST */.lP.PACKAGE_LIST
                    ]
                });
                toast({
                    variant: "success",
                    title: "\xc1p dụng th\xe0nh c\xf4ng!"
                });
            },
            onError: ()=>{
                toast({
                    variant: "error",
                    title: t("message.out_of_giftcode")
                });
            }
        });
    };
    (0,react.useEffect)(()=>{
        if ((listItem === null || listItem === void 0 ? void 0 : listItem.length) && dataSelected) {
            const _selected = listItem === null || listItem === void 0 ? void 0 : listItem.find((item)=>{
                return (item === null || item === void 0 ? void 0 : item.id) === dataSelected.id;
            });
            setDataSelected(_selected);
        }
    }, [
        listItem,
        dataSelected
    ]);
    const onCopyCode = (type)=>{
        if (type === "code") {
            var _dataSelected_item_received;
            navigator.clipboard.writeText((dataSelected === null || dataSelected === void 0 ? void 0 : (_dataSelected_item_received = dataSelected.item_received) === null || _dataSelected_item_received === void 0 ? void 0 : _dataSelected_item_received.card_code) || "");
            toast({
                variant: "success",
                title: "Sao ch\xe9p th\xe0nh c\xf4ng!"
            });
            onClose();
        }
        if (type === "serial") {
            var _dataSelected_item_received1;
            setCopySerial(true);
            navigator.clipboard.writeText((dataSelected === null || dataSelected === void 0 ? void 0 : (_dataSelected_item_received1 = dataSelected.item_received) === null || _dataSelected_item_received1 === void 0 ? void 0 : _dataSelected_item_received1.card_seri) || "");
        }
    };
    (0,react.useEffect)(()=>{
        if (copySerial) {
            setTimeout(()=>{
                setCopySerial(false);
            }, 2000);
        }
    }, [
        copySerial
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(dialog/* Dialog */.Vq, {
        open: open,
        onOpenChange: handleClose,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(dialog/* DialogContent */.cZ, {
            className: "max-w-[420px] rounded-[24px] p-[24px] border-0 shadow-[0px_4px_30px_0px_rgba(0,0,0,0.06)] sm:rounded-[24px] gap-0 space-y-[24px] xs:w-[90vw]",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "flex items-center justify-between",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                            className: "text-[16px] Nunito-700",
                            children: t("reward.card_information")
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(IconClose/* IconClose */.b, {
                            className: "cursor-pointer",
                            onClick: ()=>onClose()
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                            className: "text-[14px] text-neutral-05 dark:text-neutral-07",
                            children: t("reward.exchange_package")
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                            className: "text-[16px] Nunito-500",
                            children: dataSelected === null || dataSelected === void 0 ? void 0 : dataSelected.name
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                            className: "text-[14px] text-neutral-05 dark:text-neutral-07",
                            children: t("reward.exchange_time")
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                            className: "text-[16px] Nunito-500",
                            children: moment_default().unix(dataSelected === null || dataSelected === void 0 ? void 0 : dataSelected.created_at).format(configs/* DATE_FORMAT */.zT)
                        })
                    ]
                }),
                (dataSelected === null || dataSelected === void 0 ? void 0 : (_dataSelected_item_received = dataSelected.item_received) === null || _dataSelected_item_received === void 0 ? void 0 : _dataSelected_item_received.card_seri) && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                            className: "text-[14px] text-neutral-05 dark:text-neutral-07",
                            children: t("store.serial_code")
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            onClick: ()=>onCopyCode("serial"),
                            className: "flex w-fit items-center cursor-pointer",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                    className: "text-[16px] Nunito-500 border-r dark:border-neutral-07 pr-[8px] mr-[8px]",
                                    children: dataSelected === null || dataSelected === void 0 ? void 0 : (_dataSelected_item_received1 = dataSelected.item_received) === null || _dataSelected_item_received1 === void 0 ? void 0 : _dataSelected_item_received1.card_seri
                                }),
                                copySerial ? /*#__PURE__*/ (0,jsx_runtime.jsx)(IconCopied/* IconCopied */.i, {}) : /*#__PURE__*/ (0,jsx_runtime.jsx)(IconNonCopy/* IconNonCopy */.x, {
                                    stroke: "#9F9EA9"
                                })
                            ]
                        })
                    ]
                }),
                (dataSelected === null || dataSelected === void 0 ? void 0 : (_dataSelected_item_received2 = dataSelected.item_received) === null || _dataSelected_item_received2 === void 0 ? void 0 : _dataSelected_item_received2.card_code) && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "border border-dashed border-black/10 dark:border-neutral-07 rounded-[12px] p-[12px] text-[24px] Nunito-700 text-main-01 text-center leading-[38px]",
                    children: [
                        dataSelected === null || dataSelected === void 0 ? void 0 : (_dataSelected_item_received3 = dataSelected.item_received) === null || _dataSelected_item_received3 === void 0 ? void 0 : _dataSelected_item_received3.card_code,
                        (dataSelected === null || dataSelected === void 0 ? void 0 : (_dataSelected_item_received4 = dataSelected.item_received) === null || _dataSelected_item_received4 === void 0 ? void 0 : _dataSelected_item_received4.expired_date) && /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                            className: "text-[14px] text-neutral-05 dark:text-neutral-07 Nunito-400 leading-[19px]",
                            children: [
                                "HSD:",
                                " ",
                                moment_default()(dataSelected === null || dataSelected === void 0 ? void 0 : (_dataSelected_item_received5 = dataSelected.item_received) === null || _dataSelected_item_received5 === void 0 ? void 0 : _dataSelected_item_received5.expired_date).format(configs/* DATE_FORMAT */.zT)
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "flex gap-[16px] justify-end items-center",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(ui_button/* Button */.z, {
                            variant: "grey",
                            onClick: ()=>onClose(),
                            className: "text-neutral-05 dark:text-neutral-08 rounded-[16px] px-[24px] py-[12px] w-fit h-[46px]",
                            children: t("merchandise.cancel")
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(ui_button/* Button */.z, {
                            variant: "main",
                            loading: isPending,
                            onClick: ()=>{
                                if ((dataSelected === null || dataSelected === void 0 ? void 0 : dataSelected.status) === configs/* GIFTCODE_TYPE.PENDING */.yO.PENDING) {
                                    onUse(dataSelected);
                                } else {
                                    onCopyCode("code");
                                }
                            },
                            className: "rounded-[16px] px-[24px] py-[12px] w-fit h-[46px]",
                            children: (dataSelected === null || dataSelected === void 0 ? void 0 : dataSelected.status) === configs/* GIFTCODE_TYPE.PENDING */.yO.PENDING ? t("reward.use_now") : t("reward.copy")
                        })
                    ]
                })
            ]
        })
    });
};

;// CONCATENATED MODULE: ./app/containers/reward-center/package/modal/ModalUseGiftcode.tsx














const ModalUseGiftcode = (param)=>{
    let { open , handleClose , listItem  } = param;
    const { visible , setVisible , dataSelected , setDataSelected  } = (0,react.useContext)(PackageContext/* PackageContext */.M);
    const { t  } = (0,esm/* useTranslation */.$G)();
    const queryClient = (0,QueryClientProvider/* useQueryClient */.NL)();
    const { toast  } = (0,use_toast/* useToast */.pm)();
    const { mutate , isPending  } = useMutationUseItem();
    const [game, setGame] = (0,react.useState)();
    const { data: listGame  } = useQueryGetListGameByGiftcode({
        item_id: (dataSelected === null || dataSelected === void 0 ? void 0 : dataSelected.id) || ""
    });
    const GAEventsTracker = (0,useGAEventsTracker/* default */.Z)("Inventory");
    const OptionGame = (listGame === null || listGame === void 0 ? void 0 : listGame.data) || [];
    const onChangeGame = (value)=>{
        const _game = OptionGame.find((item)=>{
            return (item === null || item === void 0 ? void 0 : item.game_id) === value;
        });
        setGame(_game);
        GAEventsTracker("Inventory_selected_game", _game === null || _game === void 0 ? void 0 : _game.game_name);
    };
    const onClose = ()=>{
        setVisible({
            ...visible,
            confirmGiftcode: false
        });
        setDataSelected();
    };
    const onUse = async (item)=>{
        GAEventsTracker("Inventory_used_giftcode", item === null || item === void 0 ? void 0 : item.name);
        mutate({
            item_id: item.id,
            game_id: (game === null || game === void 0 ? void 0 : game.game_id) || ""
        }, {
            onSuccess: ()=>{
                queryClient.refetchQueries({
                    queryKey: [
                        configs/* QUERY_KEY.PACKAGE_LIST */.lP.PACKAGE_LIST
                    ]
                });
                toast({
                    variant: "success",
                    title: "\xc1p dụng th\xe0nh c\xf4ng!"
                });
                onClose();
            },
            onError: ()=>{}
        });
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(dialog/* Dialog */.Vq, {
        open: open,
        onOpenChange: handleClose,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(dialog/* DialogContent */.cZ, {
            className: "max-w-[420px] border-0 shadow-[0px_4px_30px_0px_rgba(0,0,0,0.06)] rounded-[24px] p-[24px] sm:rounded-[24px] gap-0 space-y-[24px] xs:w-[90vw]",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "flex items-center justify-between",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                            className: "text-[16px] Nunito-700",
                            children: t("reward.exchange_giftcode")
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(IconClose/* IconClose */.b, {
                            className: "cursor-pointer",
                            onClick: ()=>onClose()
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                            className: "text-[14px] text-neutral-05 dark:text-neutral-07 pb-[8px]",
                            children: t("reward.pick_game_by_giftcode")
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(ui_select/* Select */.Ph, {
                            value: (game === null || game === void 0 ? void 0 : game.game_id) || "",
                            onValueChange: (value)=>onChangeGame(value),
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "relative",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(ui_select/* SelectTrigger */.i4, {
                                            asChild: false,
                                            className: "w-full h-[46px] rounded-[16px] border border-black/10 Nunito-400 dark:bg-white/10 dark:backdrop-blur-[20px] text-left",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ui_select/* SelectValue */.ki, {
                                                placeholder: t("common.chose_game"),
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: "flex-1",
                                                    children: (game === null || game === void 0 ? void 0 : game.game_name) || ""
                                                })
                                            })
                                        }),
                                        (game === null || game === void 0 ? void 0 : game.game_id) && /*#__PURE__*/ (0,jsx_runtime.jsx)(IconClose/* IconClose */.b, {
                                            className: "cursor-pointer absolute top-[50%] translate-y-[-50%] right-[16px]",
                                            onClick: ()=>{
                                                setGame({});
                                            }
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(ui_select/* SelectContent */.Bw, {
                                    className: "p-1 rounded-[16px]",
                                    children: OptionGame.map((item)=>{
                                        /*#__PURE__*/ return (0,jsx_runtime.jsx)(ui_select/* SelectItem */.Ql, {
                                            value: item === null || item === void 0 ? void 0 : item.game_id,
                                            "aria-expanded": true,
                                            className: "p-3 rounded-[8px] hover:!bg-bg-disable hover:!text-main-01 Nunito-500 focus:bg-bg-disable focus:text-main-01 dark:hover:!bg-[#F1F1FC]/[.1] dark:focus:!bg-[#F1F1FC]/[.1]",
                                            children: item === null || item === void 0 ? void 0 : item.game_name
                                        }, item === null || item === void 0 ? void 0 : item.game_id);
                                    })
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                            className: "text-[14px] text-neutral-05 dark:text-neutral-07",
                            children: t("reward.giftcode_name")
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                            className: "text-[16px] Nunito-500",
                            children: dataSelected === null || dataSelected === void 0 ? void 0 : dataSelected.name
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "flex gap-[16px] justify-end items-center",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(ui_button/* Button */.z, {
                            variant: "grey",
                            onClick: ()=>onClose(),
                            className: "text-neutral-05 dark:text-neutral-08 rounded-[16px] px-[24px] py-[12px] w-fit h-[46px]",
                            children: t("merchandise.cancel")
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(ui_button/* Button */.z, {
                            variant: "main",
                            loading: isPending,
                            disabled: !(game === null || game === void 0 ? void 0 : game.game_id),
                            onClick: ()=>{
                                if ((dataSelected === null || dataSelected === void 0 ? void 0 : dataSelected.status) === configs/* GIFTCODE_TYPE.PENDING */.yO.PENDING) {
                                    onUse(dataSelected);
                                }
                            },
                            className: "rounded-[16px] px-[24px] py-[12px] w-fit h-[46px]",
                            children: t("reward.use_now")
                        })
                    ]
                })
            ]
        })
    });
};

;// CONCATENATED MODULE: ./app/containers/reward-center/package/modal/ModalViewGiftcode.tsx










const ModalViewGiftcode = (param)=>{
    let { open , handleClose  } = param;
    var _dataSelected_item_received, _dataSelected_item_received1, _dataSelected_item_received2, _dataSelected_item_received3, _dataSelected_item_received4, _dataSelected_item_received5, _dataSelected_item_received6, _dataSelected_item_received7;
    const { visible , setVisible , dataSelected , setDataSelected  } = (0,react.useContext)(PackageContext/* PackageContext */.M);
    const { t  } = (0,esm/* useTranslation */.$G)();
    const { toast  } = (0,use_toast/* useToast */.pm)();
    const onClose = ()=>{
        setVisible({
            ...visible,
            viewGiftcode: false
        });
        setDataSelected();
    };
    const onCopyCode = ()=>{
        var _dataSelected_item_received;
        navigator.clipboard.writeText((dataSelected === null || dataSelected === void 0 ? void 0 : (_dataSelected_item_received = dataSelected.item_received) === null || _dataSelected_item_received === void 0 ? void 0 : _dataSelected_item_received.giftcode) || "");
        toast({
            variant: "success",
            title: "Sao ch\xe9p th\xe0nh c\xf4ng!"
        });
        onClose();
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(dialog/* Dialog */.Vq, {
        open: open,
        onOpenChange: handleClose,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(dialog/* DialogContent */.cZ, {
            className: "max-w-[420px] border-0 shadow-[0px_4px_30px_0px_rgba(0,0,0,0.06)] rounded-[24px] p-[24px] sm:rounded-[24px] gap-0 space-y-[24px] xs:w-[90vw]",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "flex items-center justify-between",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                            className: "text-[16px] Nunito-700",
                            children: "Giftcode"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(IconClose/* IconClose */.b, {
                            className: "cursor-pointer",
                            onClick: ()=>onClose()
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                            className: "text-[14px] text-neutral-05 dark:text-neutral-07",
                            children: t("reward.exchange_package")
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                            className: "text-[16px] Nunito-500",
                            children: dataSelected === null || dataSelected === void 0 ? void 0 : dataSelected.name
                        })
                    ]
                }),
                !(dataSelected === null || dataSelected === void 0 ? void 0 : dataSelected.is_used) && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                            className: "text-[14px] text-neutral-05 dark:text-neutral-07",
                            children: t("reward.received_time")
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                            className: "text-[16px] Nunito-500",
                            children: moment_default().unix(dataSelected === null || dataSelected === void 0 ? void 0 : dataSelected.created_at).format(configs/* DATE_FORMAT */.zT)
                        })
                    ]
                }),
                ((dataSelected === null || dataSelected === void 0 ? void 0 : (_dataSelected_item_received = dataSelected.item_received) === null || _dataSelected_item_received === void 0 ? void 0 : _dataSelected_item_received.game_name) || (dataSelected === null || dataSelected === void 0 ? void 0 : (_dataSelected_item_received1 = dataSelected.item_received) === null || _dataSelected_item_received1 === void 0 ? void 0 : _dataSelected_item_received1.gc_game_name)) && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                            className: "text-[14px] text-neutral-05 dark:text-neutral-07",
                            children: t("game.range_use")
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                            className: "text-[16px] Nunito-500",
                            children: (dataSelected === null || dataSelected === void 0 ? void 0 : (_dataSelected_item_received2 = dataSelected.item_received) === null || _dataSelected_item_received2 === void 0 ? void 0 : _dataSelected_item_received2.game_name) || (dataSelected === null || dataSelected === void 0 ? void 0 : (_dataSelected_item_received3 = dataSelected.item_received) === null || _dataSelected_item_received3 === void 0 ? void 0 : _dataSelected_item_received3.gc_game_name)
                        })
                    ]
                }),
                (dataSelected === null || dataSelected === void 0 ? void 0 : dataSelected.is_used) && (dataSelected === null || dataSelected === void 0 ? void 0 : dataSelected.updated_at) && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                            className: "text-[14px] text-neutral-05 dark:text-neutral-07",
                            children: t("giftcode.date_of_use")
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                            className: "text-[16px] Nunito-500",
                            children: moment_default().unix(dataSelected === null || dataSelected === void 0 ? void 0 : dataSelected.updated_at).format(configs/* DATE_FORMAT */.zT)
                        })
                    ]
                }),
                (dataSelected === null || dataSelected === void 0 ? void 0 : dataSelected.is_used) && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                            className: "text-[14px] text-neutral-05 dark:text-neutral-07",
                            children: t("giftcode.status")
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                            className: "text-[16px] Nunito-500",
                            children: t("giftcode.used")
                        })
                    ]
                }),
                (dataSelected === null || dataSelected === void 0 ? void 0 : (_dataSelected_item_received4 = dataSelected.item_received) === null || _dataSelected_item_received4 === void 0 ? void 0 : _dataSelected_item_received4.giftcode) && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "border border-dashed border-black/10 dark:border-neutral-07 rounded-[12px] p-[12px] text-[24px] Nunito-700 text-main-01 text-center leading-[38px]",
                    children: [
                        dataSelected === null || dataSelected === void 0 ? void 0 : (_dataSelected_item_received5 = dataSelected.item_received) === null || _dataSelected_item_received5 === void 0 ? void 0 : _dataSelected_item_received5.giftcode,
                        (dataSelected === null || dataSelected === void 0 ? void 0 : (_dataSelected_item_received6 = dataSelected.item_received) === null || _dataSelected_item_received6 === void 0 ? void 0 : _dataSelected_item_received6.expired_date) && /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                            className: "text-[14px] text-neutral-05 dark:text-neutral-07 Nunito-400 leading-[19px]",
                            children: [
                                "HSD:",
                                " ",
                                moment_default()(dataSelected === null || dataSelected === void 0 ? void 0 : (_dataSelected_item_received7 = dataSelected.item_received) === null || _dataSelected_item_received7 === void 0 ? void 0 : _dataSelected_item_received7.expired_date).format(configs/* DATE_FORMAT */.zT)
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "flex gap-[16px] justify-end items-center",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(ui_button/* Button */.z, {
                            variant: "grey",
                            onClick: ()=>onClose(),
                            className: "text-neutral-05 dark:text-neutral-08 rounded-[16px] px-[24px] py-[12px] w-fit h-[46px]",
                            children: t("merchandise.cancel")
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(ui_button/* Button */.z, {
                            variant: "main",
                            onClick: ()=>{
                                if ((dataSelected === null || dataSelected === void 0 ? void 0 : dataSelected.status) === configs/* GIFTCODE_TYPE.PENDING */.yO.PENDING) {
                                    setVisible({
                                        ...visible,
                                        viewGiftcode: false,
                                        confirmGiftcode: true
                                    });
                                } else {
                                    onCopyCode();
                                }
                            },
                            className: "rounded-[16px] px-[24px] py-[12px] w-fit h-[46px]",
                            children: (dataSelected === null || dataSelected === void 0 ? void 0 : dataSelected.status) === configs/* GIFTCODE_TYPE.PENDING */.yO.PENDING ? t("reward.use_now") : t("reward.copy")
                        })
                    ]
                })
            ]
        })
    });
};

;// CONCATENATED MODULE: ./public/img/reward/package_default.png
/* harmony default export */ var package_default = ({"src":"/_next/static/media/package_default.a315b90f.png","height":354,"width":354,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAICAYAAADED76LAAAAmElEQVR42j2NTQqDUAyEvySvrXtBz+CxC71TN16gBRduWtT30xfUBj6SMDOMPO7PTfUWKpg2+FYzREGVGCglAHVByoUCIBAUgHCIxd0MQ4PIhXHMeEAARSDFQt9fmKaI03VKSqeBPW2mLEuugP/iCvDv37ZM214RUT5f4KgILqrB+7Uwz4qqkFLAzIN7RQQQgXXNleL3OfEHDftCJNZ7xcgAAAAASUVORK5CYII=","blurWidth":8,"blurHeight":8});
;// CONCATENATED MODULE: ./app/containers/reward-center/package/modal/ModalViewSticker.tsx








const ModalViewSticker = (param)=>{
    let { open , handleClose  } = param;
    const { visible , setVisible , dataSelected , setDataSelected  } = (0,react.useContext)(PackageContext/* PackageContext */.M);
    const { t  } = (0,esm/* useTranslation */.$G)();
    const onClose = ()=>{
        setVisible({
            ...visible,
            viewSticker: false
        });
        setDataSelected();
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(dialog/* Dialog */.Vq, {
        open: open,
        onOpenChange: handleClose,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(dialog/* DialogContent */.cZ, {
            className: "max-w-[520px] rounded-[24px] p-[24px] border-0 shadow-[0px_4px_30px_0px_rgba(0,0,0,0.06)] sm:rounded-[24px] gap-0 space-y-[24px] xs:w-[90vw]",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "flex items-center justify-between",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                            className: "text-[16px] Nunito-700",
                            children: t("reward.detail")
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(IconClose/* IconClose */.b, {
                            className: "cursor-pointer",
                            onClick: ()=>onClose()
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "flex gap-[24px]",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                            src: (dataSelected === null || dataSelected === void 0 ? void 0 : dataSelected.image) ? dataSelected === null || dataSelected === void 0 ? void 0 : dataSelected.image : package_default.src,
                            className: "w-[152px] rounded-[8px] aspect-square h-fit object-cover"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "flex-1 space-y-[16px]",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                            className: "text-[14px] text-neutral-05 dark:text-neutral-07",
                                            children: t("reward.exchange_package")
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                            className: "text-[16px] Nunito-500",
                                            children: dataSelected === null || dataSelected === void 0 ? void 0 : dataSelected.name
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "border border-dashed border-black/10 dark:border-neutral-07 text-neutral-03 dark:text-neutral-08 rounded-[12px] p-[12px] text-[14px]",
                                    children: t("reward.sticker_guide_desc")
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "flex gap-[16px] justify-center items-center",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ui_button/* Button */.z, {
                        variant: "main",
                        className: "rounded-[16px] px-[24px] py-[12px] w-fit h-[46px]",
                        onClick: ()=>{
                            window.open("https://playee.vn/help-center/detail?faqId=649ebf2da6fc952f1342566f");
                        },
                        children: t("reward.sticker_guide")
                    })
                })
            ]
        })
    });
};

// EXTERNAL MODULE: ./app/components/app-avatar/OnlyShowAvatar.tsx
var OnlyShowAvatar = __webpack_require__(30897);
// EXTERNAL MODULE: ./app/components/icon-tsx/index.ts + 11 modules
var icon_tsx = __webpack_require__(61552);
// EXTERNAL MODULE: ./app/components/loading-btn/index.tsx + 2 modules
var loading_btn = __webpack_require__(25327);
// EXTERNAL MODULE: ./app/components/ui/checkbox.tsx + 1 modules
var ui_checkbox = __webpack_require__(93769);
// EXTERNAL MODULE: ./app/hooks/useDebounceEffect.tsx
var useDebounceEffect = __webpack_require__(45724);
// EXTERNAL MODULE: ./app/services/query-fn/user/user-friend-mutation.ts
var user_friend_mutation = __webpack_require__(3201);
// EXTERNAL MODULE: ./app/services/query-fn/user/user-friend-query.ts
var user_friend_query = __webpack_require__(74799);
// EXTERNAL MODULE: ./node_modules/@radix-ui/react-scroll-area/dist/index.mjs
var dist = __webpack_require__(25443);
// EXTERNAL MODULE: ./node_modules/react-intersection-observer/index.mjs
var react_intersection_observer = __webpack_require__(42708);
;// CONCATENATED MODULE: ./app/containers/reward-center/package/modal/ModalChooseFriend.tsx




















const TIME_DEBOUNCE = 700;
const ListFriend = (param)=>{
    let { active =false , searchValue ="" , setSelectedFriend , selectedFriend  } = param;
    var _listFriendWithoutAuthenticate;
    const { t  } = (0,esm/* useTranslation */.$G)();
    const { data: listFriendWithoutSearch , fetchNextPage: fetchWithoutSearch  } = (0,user_friend_query/* useQueryGetListFriend */.tf)(!!active, searchValue);
    const { data: listFriendWithSearch , fetchNextPage: fetchWithSearch  } = (0,user_friend_query/* useQueryGetListFriendWithSearch */.Ue)(!!active, searchValue);
    const { ref , inView  } = (0,react_intersection_observer/* useInView */.YD)();
    const listFriendWithoutAuthenticate = ()=>{
        var _listFriend_pages_flat, _listFriend_pages, _listFriend_pages_flat1, _listFriend_pages1;
        const listFriend = !!searchValue ? listFriendWithSearch : listFriendWithoutSearch;
        return ((_listFriend_pages_flat = listFriend === null || listFriend === void 0 ? void 0 : (_listFriend_pages = listFriend.pages) === null || _listFriend_pages === void 0 ? void 0 : _listFriend_pages.flat()) === null || _listFriend_pages_flat === void 0 ? void 0 : _listFriend_pages_flat.length) ? (_listFriend_pages_flat1 = listFriend === null || listFriend === void 0 ? void 0 : (_listFriend_pages1 = listFriend.pages) === null || _listFriend_pages1 === void 0 ? void 0 : _listFriend_pages1.flat()) === null || _listFriend_pages_flat1 === void 0 ? void 0 : _listFriend_pages_flat1.filter((item)=>{
            return !(item === null || item === void 0 ? void 0 : item.authentic);
        }) : [];
    };
    (0,react.useEffect)(()=>{
        if (inView) {
            searchValue ? fetchWithSearch() : fetchWithoutSearch();
        }
    }, [
        fetchWithoutSearch,
        fetchWithSearch,
        searchValue,
        inView
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            ((_listFriendWithoutAuthenticate = listFriendWithoutAuthenticate()) === null || _listFriendWithoutAuthenticate === void 0 ? void 0 : _listFriendWithoutAuthenticate.length) ? listFriendWithoutAuthenticate().map((item, index)=>{
                /*#__PURE__*/ return (0,jsx_runtime.jsxs)("div", {
                    className: "flex items-center justify-between w-full gap-4",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(ui_checkbox/* Checkbox */.X, {
                            id: "friend",
                            onCheckedChange: (value)=>{
                                if (value) {
                                    setSelectedFriend(item);
                                } else {
                                    setSelectedFriend(undefined);
                                }
                            },
                            checked: !!(selectedFriend === null || selectedFriend === void 0 ? void 0 : selectedFriend.id) && item.id === (selectedFriend === null || selectedFriend === void 0 ? void 0 : selectedFriend.id)
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "flex flex-1 gap-4",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(OnlyShowAvatar/* OnlyShowAvatar */.T, {
                                    size: 40,
                                    avatarUser: item
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                    className: "flex items-center text-base Nunito-700 text-bg-01 dark:text-white",
                                    children: item === null || item === void 0 ? void 0 : item.fullname
                                })
                            ]
                        })
                    ]
                }, index);
            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "w-full flex items-center justify-center h-[200px]",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(data_empty/* DataEmpty */.$, {
                    title: t("profile.no_data")
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                ref: ref,
                className: "opacity-0",
                children: "Load more"
            })
        ]
    });
};
const ModalViewFriend = (param)=>{
    let { open , handleClose  } = param;
    const { visible , setVisible , dataSelected , setSelectedFriend: setFriend  } = (0,react.useContext)(PackageContext/* PackageContext */.M);
    const { t  } = (0,esm/* useTranslation */.$G)();
    const queryClient = (0,QueryClientProvider/* useQueryClient */.NL)();
    const { toast  } = (0,use_toast/* useToast */.pm)();
    const { themeApp  } = (0,react.useContext)(context/* AppContext */.Il);
    const [keyword, setKeyword] = (0,react.useState)("");
    const [tempSearchValue, setTempSearchValue] = (0,react.useState)("");
    const [selectedFriend, setSelectedFriend] = (0,react.useState)(undefined);
    const { mutate , isPending  } = (0,user_friend_mutation/* useMutatonSendGift */.aK)();
    const onClose = ()=>{
        setVisible({
            ...visible,
            viewFriend: false
        });
    };
    const onChange = (e)=>{
        var _e_target;
        setTempSearchValue(e === null || e === void 0 ? void 0 : (_e_target = e.target) === null || _e_target === void 0 ? void 0 : _e_target.value);
    };
    (0,useDebounceEffect/* useDebounceEffect */.s)(()=>{
        return setKeyword(tempSearchValue === null || tempSearchValue === void 0 ? void 0 : tempSearchValue.trim());
    }, TIME_DEBOUNCE, [
        tempSearchValue
    ]);
    const onSubmit = ()=>{
        mutate({
            item_id: dataSelected === null || dataSelected === void 0 ? void 0 : dataSelected.id,
            user_id: (selectedFriend === null || selectedFriend === void 0 ? void 0 : selectedFriend.id) || ""
        }, {
            onSuccess: ()=>{
                setVisible({
                    ...visible,
                    sendSuccess: true,
                    viewFriend: false
                });
                setFriend(selectedFriend);
                setSelectedFriend(undefined);
            },
            onError: (e)=>{
                var _e_data;
                setVisible({
                    ...visible,
                    viewFriend: false
                });
                setSelectedFriend(undefined);
                toast({
                    variant: "error",
                    title: e === null || e === void 0 ? void 0 : (_e_data = e.data) === null || _e_data === void 0 ? void 0 : _e_data.message
                });
            }
        });
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(dialog/* Dialog */.Vq, {
        open: open,
        onOpenChange: handleClose,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(dialog/* DialogContent */.cZ, {
            className: "max-w-[420px] border-0 shadow-[0px_4px_30px_0px_rgba(0,0,0,0.06)] rounded-[24px] px-0 py-[16px] sm:rounded-[24px] gap-0 space-y-[12px] xs:w-[90vw]",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "flex items-center justify-between p-[16px] pt-0 border-b-[1px] border-black/10 dark:border-white/10",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                            className: "text-[16px] Nunito-700",
                            children: "Chọn bạn b\xe8"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(IconClose/* IconClose */.b, {
                            className: "cursor-pointer",
                            onClick: ()=>onClose()
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "flex px-[24px] justify-between gap-4 py-3 mb-4 border-0 h-[44px]",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(icon_tsx/* IconSearch */.jV, {
                            fill: themeApp === "dark" ? "#fff" : "#100D28",
                            className: "w-[20px]"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                            type: "text",
                            value: tempSearchValue,
                            className: "flex-1 text-sm border-0 outline-none dark:text-white dark:bg-transparent",
                            placeholder: t("profile.search"),
                            onChange: onChange
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* ScrollArea */.xr, {
                    className: "h-[188px] px-[24px] sm:h-[268px] ld:h-[290px] overflow-auto space-y-[24px]",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ListFriend, {
                        active: open,
                        searchValue: keyword,
                        setSelectedFriend: setSelectedFriend,
                        selectedFriend: selectedFriend
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "flex gap-[16px] justify-center items-center",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ui_button/* Button */.z, {
                        variant: "main",
                        disabled: !selectedFriend,
                        onClick: onSubmit,
                        className: "rounded-[16px] px-[24px] py-[12px] w-fit h-[43px]",
                        children: isPending ? /*#__PURE__*/ (0,jsx_runtime.jsx)(loading_btn/* LoadingBtnComponent */.n, {}) : t("reward.confirm")
                    })
                })
            ]
        })
    });
};

;// CONCATENATED MODULE: ./app/containers/reward-center/package/modal/ModalSendSuccess.tsx







const ModalSendSuccess = (param)=>{
    let { open , handleClose , resetQuery  } = param;
    const queryClient = (0,QueryClientProvider/* useQueryClient */.NL)();
    const { visible , setVisible , dataSelected , setDataSelected , selectedFriend , setSelectedFriend  } = (0,react.useContext)(PackageContext/* PackageContext */.M);
    const { t  } = (0,esm/* useTranslation */.$G)();
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(dialog/* Dialog */.Vq, {
        open: open,
        onOpenChange: handleClose,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(dialog/* DialogContent */.cZ, {
            className: "max-w-[320px] border-0 shadow-[0px_4px_30px_0px_rgba(0,0,0,0.06)] rounded-[24px] p-[24px] sm:rounded-[24px] gap-0 xs:w-[90vw]",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "w-[80px] h-[80px] rounded-[80px] mx-auto flex items-center justify-center mb-[24px] bg-bg-green",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
                        xmlns: "http://www.w3.org/2000/svg",
                        width: "40",
                        height: "40",
                        viewBox: "0 0 40 40",
                        fill: "none",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                            d: "M19.9999 3.33337C10.8166 3.33337 3.33324 10.8167 3.33324 20C3.33324 29.1834 10.8166 36.6667 19.9999 36.6667C29.1832 36.6667 36.6666 29.1834 36.6666 20C36.6666 10.8167 29.1832 3.33337 19.9999 3.33337ZM27.9666 16.1667L18.5166 25.6167C18.2832 25.85 17.9666 25.9834 17.6332 25.9834C17.2999 25.9834 16.9832 25.85 16.7499 25.6167L12.0332 20.9C11.5499 20.4167 11.5499 19.6167 12.0332 19.1334C12.5166 18.65 13.3166 18.65 13.7999 19.1334L17.6332 22.9667L26.1999 14.4C26.6832 13.9167 27.4832 13.9167 27.9666 14.4C28.4499 14.8834 28.4499 15.6667 27.9666 16.1667Z",
                            fill: "#27908C"
                        })
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                    className: "text-[16px] Nunito-700 pb-[8px] leading-[22px] text-center",
                    children: "Tặng qu\xe0 th\xe0nh c\xf4ng"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                    className: "text-[14px] text-neutral-05 text-center dark:text-neutral-07",
                    children: [
                        "Qu\xe0 đ\xe3 đươc chuyển tới ",
                        selectedFriend === null || selectedFriend === void 0 ? void 0 : selectedFriend.fullname
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(ui_button/* Button */.z, {
                    variant: "main",
                    onClick: ()=>{
                        setVisible({
                            ...visible,
                            sendSuccess: false
                        });
                        setDataSelected({});
                        resetQuery();
                        setSelectedFriend(undefined);
                    },
                    className: "text-[14px] leading-[19px] h-[40px] Nunito-700 rounded-[16px] px-[24px] py-[10px] w-fit mx-auto mt-[20px]",
                    children: t("common.close")
                })
            ]
        })
    });
};

;// CONCATENATED MODULE: ./app/containers/reward-center/package/PackageModalContainer.tsx












const PackageModalContainer = (param)=>{
    let { listItem , resetQuery  } = param;
    const { visible , setVisible , setPreview , preview , dataSelected  } = (0,react.useContext)(PackageContext/* PackageContext */.M);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ModalViewGiftcode, {
                open: visible.viewGiftcode,
                handleClose: ()=>{}
            }),
            (dataSelected === null || dataSelected === void 0 ? void 0 : dataSelected.id) && /*#__PURE__*/ (0,jsx_runtime.jsx)(ModalUseGiftcode, {
                open: visible.confirmGiftcode,
                handleClose: ()=>{},
                listItem: listItem
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ModalAppotaCardDetail, {
                open: visible.appotaDetail,
                handleClose: ()=>{},
                listItem: listItem
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ModalCardDetail, {
                open: visible.view,
                handleClose: ()=>{},
                listItem: listItem
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ModalApplyAvatarSuccess, {
                open: visible.avatarSuccess,
                handleClose: ()=>{}
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ModalViewSticker, {
                open: visible.viewSticker,
                handleClose: ()=>{}
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ModalViewMedia/* ModalViewMedia */.V, {
                open: preview.open,
                src: preview.src,
                handleClose: ()=>setPreview({
                        open: false,
                        src: ""
                    })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ModalViewFriend, {
                open: visible.viewFriend,
                handleClose: ()=>{}
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ModalSendSuccess, {
                open: visible.sendSuccess,
                handleClose: ()=>{},
                resetQuery: resetQuery
            })
        ]
    });
};

;// CONCATENATED MODULE: ./public/img/reward/voucher_default.png
/* harmony default export */ var voucher_default = ({"src":"/_next/static/media/voucher_default.a2a0b4a8.png","height":355,"width":355,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAICAYAAADED76LAAAAnElEQVR42jXMQarCUAyF4T8nebRScAGu/g1ck2Od6FwHwu29jaFiIJCTL8TO/5enfF5k05ZMuGbiz3HHTLTAWDJTCrQswsxoDTLB4BDAVkGn00QfTrjtHx73AZDK0ggKYRtbXRt9/e6KTLAPhMNa8HqOH+4VBoyemMHxGEgOFcYAD4gEk+B2fTMfEsnoHSKABEE2KHBybUk1Er9aPw6TR096CSFZAAAAAElFTkSuQmCC","blurWidth":8,"blurHeight":8});
;// CONCATENATED MODULE: ./public/img/reward/giftcode_default.png
/* harmony default export */ var giftcode_default = ({"src":"/_next/static/media/giftcode_default.e141d2f2.png","height":355,"width":355,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAICAYAAADED76LAAAAo0lEQVR42i2OzUpDQRSDv5wzdLSgiEt9esF3cq2IGwuli0J/7pz0DjQQQsi3iD4/vo4RvWc+ONRRdDITBYrg1ICtDWMxpEnBGNAEc2u2qzXi7b3zuO0rmFQFu//CpsIFm43oPTjsF/5+B7NPuyDAcJdtACKgyiBoElwutXrw8tp5eg7OZ7MM0B3QPPjzfaIlZBNYa0ImCsNVmkVWAJhILAFwvQGHSkRZS8LgRAAAAABJRU5ErkJggg==","blurWidth":8,"blurHeight":8});
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(25675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
;// CONCATENATED MODULE: ./app/containers/reward-center/package/PackageCard.tsx











const PackageCard = (param)=>{
    let { cardItem , textDetail , textAction , actionDetail , action , loading =false , src  } = param;
    const { setVisible , visible , setDataSelected  } = (0,react.useContext)(PackageContext/* PackageContext */.M);
    const { userInfo  } = (0,react.useContext)(context/* AppContext */.Il);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        onClick: ()=>{
            if ((cardItem === null || cardItem === void 0 ? void 0 : cardItem.type) === configs/* PACKAGE_TYPE.GC */.uG.GC) {
                actionDetail && actionDetail();
            }
        },
        title: cardItem.name,
        className: "flex flex-col p-[8px] bg-white dark:bg-white/10 rounded-[12px] xs:rounded-[8px] border border-black/10 cursor-pointer md:hover:shadow-[0px_3px_30px_0px_rgba(0,0,0,0.15)] transition duration-300 active:bg-bg-button active:border-bg-button dark:active:border-black/10 md:active:bg-white dark:md:active:bg-white/10 md:active:border-black/10 ",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "w-full relative rounded-[12px] overflow-hidden",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                        width: 177,
                        height: 177,
                        src: src ? src : cardItem.image ? cardItem.image : (cardItem === null || cardItem === void 0 ? void 0 : cardItem.type) === configs/* PACKAGE_TYPE.GIFTCODE */.uG.GIFTCODE ? giftcode_default.src : (cardItem === null || cardItem === void 0 ? void 0 : cardItem.type) === configs/* PACKAGE_TYPE.VOUCHER */.uG.VOUCHER || (cardItem === null || cardItem === void 0 ? void 0 : cardItem.type) === configs/* PACKAGE_TYPE.GIFT_VOUCHER */.uG.GIFT_VOUCHER ? voucher_default.src : package_default.src,
                        alt: cardItem.name,
                        className: "w-full object-cover aspect-square rounded-[12px] xs:rounded-[8px]"
                    }),
                    ((cardItem === null || cardItem === void 0 ? void 0 : cardItem.total_group) > 0 || (cardItem === null || cardItem === void 0 ? void 0 : cardItem.item_group) > 0) && /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        className: "absolute bottom-0 right-0 rounded-tl-[6px] bg-white text-main-01 text-[12px] Nunito-700 leading-[16px] p-[4px] min-w-[24px] text-center",
                        children: (cardItem === null || cardItem === void 0 ? void 0 : cardItem.total_group) || (cardItem === null || cardItem === void 0 ? void 0 : cardItem.item_group)
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "mt-[8px] p-[8px] flex flex-col h-full flex-1",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        title: cardItem.name,
                        className: "text-[14px] xs:text-[12px] text-left xs:leading-[16px] Nunito-700 leading-[19px] mb-[8px] line-clamp-2 xs:line-clamp-1",
                        children: cardItem.name
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "flex justify-between gap-[6px] mt-auto mb-0",
                        children: [
                            textDetail && /*#__PURE__*/ (0,jsx_runtime.jsx)(ui_button/* Button */.z, {
                                onClick: actionDetail,
                                variant: "grey",
                                className: "h-[28px] flex-1 text-[12px] text-neutral-05 dark:text-neutral-08 Nunito-400 rounded-[8px] w-full px-0",
                                children: textDetail
                            }),
                            textAction && /*#__PURE__*/ (0,jsx_runtime.jsx)(ui_button/* Button */.z, {
                                onClick: action,
                                variant: "main",
                                className: "h-[28px] flex-1 text-[12px] rounded-[8px] Nunito-400 w-full px-0",
                                children: loading ? /*#__PURE__*/ (0,jsx_runtime.jsx)(loading_btn/* LoadingBtnComponent */.n, {
                                    classname: "scale-[0.7]"
                                }) : textAction
                            }),
                            !(cardItem === null || cardItem === void 0 ? void 0 : cardItem.is_used) && !(userInfo === null || userInfo === void 0 ? void 0 : userInfo.authentic) && ![
                                configs/* PACKAGE_TYPE.GIFT_ITEM */.uG.GIFT_ITEM,
                                configs/* PACKAGE_TYPE.APPOTA_CARD */.uG.APPOTA_CARD
                            ].includes(cardItem.type) && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "w-fit w-[28px] h-[28px] bg-bg-button rounded-[8px] flex items-center justify-center cursor-pointer active:opacity-60",
                                onClick: (e)=>{
                                    e.stopPropagation();
                                    setVisible({
                                        ...visible,
                                        viewFriend: true
                                    });
                                    setDataSelected(cardItem);
                                },
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
                                    width: "17",
                                    height: "16",
                                    viewBox: "0 0 17 16",
                                    fill: "none",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                        d: "M3.00002 7.33331H13.6667M3.00002 7.33331C2.26364 7.33331 1.66669 6.73636 1.66669 5.99998V5.33331C1.66669 4.59693 2.26364 3.99998 3.00002 3.99998H13.6667C14.4031 3.99998 15 4.59693 15 5.33331V5.99998C15 6.73636 14.4031 7.33331 13.6667 7.33331M3.00002 7.33331L3.00002 13.3333C3.00002 14.0697 3.59697 14.6666 4.33335 14.6666H12.3334C13.0697 14.6666 13.6667 14.0697 13.6667 13.3333V7.33331M8.33335 3.99998H11C11.7364 3.99998 12.3334 3.40303 12.3334 2.66665C12.3334 1.93027 11.7364 1.33331 11 1.33331C9.52726 1.33331 8.33335 2.52722 8.33335 3.99998ZM8.33335 3.99998H5.66669C4.93031 3.99998 4.33335 3.40303 4.33335 2.66665C4.33335 1.93027 4.93031 1.33331 5.66669 1.33331C7.13945 1.33331 8.33335 2.52722 8.33335 3.99998ZM8.33335 3.99998V14.6666",
                                        stroke: "#7673E6",
                                        strokeLinecap: "round"
                                    })
                                })
                            })
                        ]
                    })
                ]
            })
        ]
    }, "".concat(cardItem.id, "-").concat(cardItem === null || cardItem === void 0 ? void 0 : cardItem.type));
};

;// CONCATENATED MODULE: ./app/containers/reward-center/package/card-item/AppotaCardItem.tsx











const AppotaCardItem = (param)=>{
    let { item  } = param;
    const { t  } = (0,esm/* useTranslation */.$G)();
    const { userInfo: userProfile  } = (0,react.useContext)(context/* AppContext */.Il);
    const { visible , setVisible , setDataSelected  } = (0,react.useContext)(PackageContext/* PackageContext */.M);
    const { mutate , isPending  } = useMutationUseItem();
    const queryClient = (0,QueryClientProvider/* useQueryClient */.NL)();
    const { toast  } = (0,use_toast/* useToast */.pm)();
    const GAEventsTracker = (0,useGAEventsTracker/* default */.Z)("Inventory");
    const textDetail = ()=>{
        let result = "";
        if (item.status === configs/* GIFTCODE_TYPE.USED */.yO.USED) {
            result = t("reward.detail");
        }
        return result;
    };
    const textAction = ()=>{
        let result = "";
        if (item.status === configs/* GIFTCODE_TYPE.PENDING */.yO.PENDING) {
            result = t("reward.use_now");
        }
        return result;
    };
    const onUse = async (item)=>{
        GAEventsTracker("Inventory_used_ACard");
        mutate({
            item_id: item.id
        }, {
            onSuccess: ()=>{
                queryClient.refetchQueries({
                    queryKey: [
                        configs/* QUERY_KEY.PACKAGE_LIST */.lP.PACKAGE_LIST
                    ]
                });
                toast({
                    variant: "success",
                    title: "\xc1p dụng th\xe0nh c\xf4ng!"
                });
            },
            onError: ()=>{
                toast({
                    variant: "error",
                    title: t("message.out_of_giftcode")
                });
            }
        });
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(PackageCard, {
        cardItem: item,
        textDetail: textDetail(),
        textAction: textAction(),
        actionDetail: ()=>{
            GAEventsTracker("Inventory_view_ACard");
            setVisible({
                ...visible,
                appotaDetail: true
            });
            setDataSelected(item);
        },
        action: ()=>onUse(item),
        loading: isPending
    });
};

;// CONCATENATED MODULE: ./app/containers/reward-center/package/card-item/GiftcodeItem.tsx








const GiftcodeItem = (param)=>{
    let { item  } = param;
    const { t  } = (0,esm/* useTranslation */.$G)();
    const { visible , setVisible , setDataSelected  } = (0,react.useContext)(PackageContext/* PackageContext */.M);
    const GAEventsTracker = (0,useGAEventsTracker/* default */.Z)("Inventory");
    const { setVisibleGiftcodeDetail , setSelectedGiftcode  } = (0,react.useContext)(context/* AppContext */.Il);
    const textDetail = ()=>{
        let result = "";
        if (item.status === configs/* GIFTCODE_TYPE.USED */.yO.USED) {
            result = t("reward.detail");
        }
        return result;
    };
    const textAction = ()=>{
        let result = "";
        if (item.status === configs/* GIFTCODE_TYPE.PENDING */.yO.PENDING) {
            result = t("reward.use_now");
        }
        return result;
    };
    const onUse = (item)=>{
        setVisible({
            ...visible,
            confirmGiftcode: true
        });
        setDataSelected(item);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(PackageCard, {
        cardItem: item,
        textDetail: textDetail(),
        textAction: textAction(),
        actionDetail: ()=>{
            GAEventsTracker("Inventory_view_giftcode");
            if ((item === null || item === void 0 ? void 0 : item.type) === configs/* PACKAGE_TYPE.GIFTCODE */.uG.GIFTCODE || (item === null || item === void 0 ? void 0 : item.is_used)) {
                setVisible({
                    ...visible,
                    viewGiftcode: true
                });
                setDataSelected(item);
            }
            if ((item === null || item === void 0 ? void 0 : item.type) === configs/* PACKAGE_TYPE.GC */.uG.GC && !(item === null || item === void 0 ? void 0 : item.is_used)) {
                var _item_item_received;
                setVisibleGiftcodeDetail(true);
                setSelectedGiftcode({
                    id: item === null || item === void 0 ? void 0 : (_item_item_received = item.item_received) === null || _item_item_received === void 0 ? void 0 : _item_item_received.gc_event_id,
                    has_used: item === null || item === void 0 ? void 0 : item.has_used
                });
            }
        },
        action: ()=>onUse(item)
    });
};

;// CONCATENATED MODULE: ./app/containers/reward-center/package/card-item/OtherCardItem.tsx












const OtherCardItem = (param)=>{
    let { item  } = param;
    var _item_item_received;
    const { t  } = (0,esm/* useTranslation */.$G)();
    const { userInfo: userProfile  } = (0,react.useContext)(context/* AppContext */.Il);
    const { visible , setVisible , setPreview , setDataSelected  } = (0,react.useContext)(PackageContext/* PackageContext */.M);
    const { mutate , isPending  } = useMutationUseItem();
    const queryClient = (0,QueryClientProvider/* useQueryClient */.NL)();
    const { toast  } = (0,use_toast/* useToast */.pm)();
    const GAEventsTracker = (0,useGAEventsTracker/* default */.Z)("Inventory");
    // gift_item => không show action gì
    // avatar, sticker => nếu chưa dùng => hiển thị dùng ngay
    // avatar => dùng rồi => hiển thị gỡ
    // sticker => đã dùng => hiển thị chi tiết
    const textAction = ()=>{
        const isGiftItem = (item === null || item === void 0 ? void 0 : item.type) === configs/* PACKAGE_TYPE.GIFT_ITEM */.uG.GIFT_ITEM;
        const isAvatar = (item === null || item === void 0 ? void 0 : item.type) === configs/* PACKAGE_TYPE.AVATAR */.uG.AVATAR;
        let result = "";
        if (!isGiftItem) {
            if (!isAvatar) {
                result = item.status === configs/* GIFTCODE_TYPE.PENDING */.yO.PENDING ? t("reward.use_now") : "";
            } else {
                var _item_item_received;
                result = (userProfile === null || userProfile === void 0 ? void 0 : userProfile.frame_avatar) === (item === null || item === void 0 ? void 0 : (_item_item_received = item.item_received) === null || _item_item_received === void 0 ? void 0 : _item_item_received.frame_avatar) ? t("common.delete_frame") : t("reward.use_now");
            }
        }
        return result;
    };
    const textDetail = ()=>{
        const isGiftItem = (item === null || item === void 0 ? void 0 : item.type) === configs/* PACKAGE_TYPE.GIFT_ITEM */.uG.GIFT_ITEM;
        const isAvatar = (item === null || item === void 0 ? void 0 : item.type) === configs/* PACKAGE_TYPE.AVATAR */.uG.AVATAR;
        let result = "";
        if (!isGiftItem && !isAvatar) {
            result = item.status === configs/* GIFTCODE_TYPE.USED */.yO.USED ? t("reward.detail") : "";
        }
        return result;
    };
    const onUse = async (item)=>{
        var _item_item_received;
        if ((userProfile === null || userProfile === void 0 ? void 0 : userProfile.frame_avatar) === (item === null || item === void 0 ? void 0 : (_item_item_received = item.item_received) === null || _item_item_received === void 0 ? void 0 : _item_item_received.frame_avatar)) {
            mutate({
                item_id: item.id,
                game_id: "",
                revoke: "yes"
            }, {
                onSuccess: ()=>{
                    GAEventsTracker("Inventory_removed_frame");
                    queryClient.resetQueries({
                        queryKey: [
                            configs/* QUERY_KEY.PROFILE_INFO */.lP.PROFILE_INFO
                        ]
                    });
                    queryClient.refetchQueries({
                        queryKey: [
                            configs/* QUERY_KEY.PACKAGE_LIST */.lP.PACKAGE_LIST
                        ]
                    });
                    toast({
                        variant: "success",
                        title: "Gỡ th\xe0nh c\xf4ng!"
                    });
                },
                onError: ()=>{}
            });
        } else {
            mutate({
                item_id: item.id
            }, {
                onSuccess: ()=>{
                    if ((item === null || item === void 0 ? void 0 : item.type) === configs/* PACKAGE_TYPE.AVATAR */.uG.AVATAR) {
                        GAEventsTracker("Inventory_used_frame");
                    }
                    if ((item === null || item === void 0 ? void 0 : item.type) === configs/* PACKAGE_TYPE.STICKER */.uG.STICKER) {
                        GAEventsTracker("Inventory_used_sticker");
                    }
                    queryClient.resetQueries({
                        queryKey: [
                            configs/* QUERY_KEY.PROFILE_INFO */.lP.PROFILE_INFO
                        ]
                    });
                    queryClient.refetchQueries({
                        queryKey: [
                            configs/* QUERY_KEY.PACKAGE_LIST */.lP.PACKAGE_LIST
                        ]
                    });
                    queryClient.refetchQueries({
                        queryKey: [
                            configs/* QUERY_KEY.GET_STICKER_USER */.lP.GET_STICKER_USER
                        ]
                    });
                    if (item.type === configs/* PACKAGE_TYPE.AVATAR */.uG.AVATAR) {
                        // show modal apply avatar success
                        setVisible({
                            ...visible,
                            avatarSuccess: true
                        });
                    } else {
                        toast({
                            variant: "success",
                            title: "\xc1p dụng th\xe0nh c\xf4ng!"
                        });
                    }
                },
                onError: ()=>{}
            });
        }
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(PackageCard, {
        cardItem: item,
        textDetail: textDetail(),
        textAction: textAction(),
        src: item === null || item === void 0 ? void 0 : (_item_item_received = item.item_received) === null || _item_item_received === void 0 ? void 0 : _item_item_received.icon,
        actionDetail: ()=>{
            GAEventsTracker("Inventory_view_sticker");
            if ((item === null || item === void 0 ? void 0 : item.type) === configs/* PACKAGE_TYPE.STICKER */.uG.STICKER) {
                setVisible({
                    ...visible,
                    viewSticker: true
                });
                setDataSelected(item);
            } else {
                setPreview({
                    open: true,
                    src: !!(item === null || item === void 0 ? void 0 : item.image) ? item === null || item === void 0 ? void 0 : item.image : package_default.src
                });
            }
        },
        action: ()=>onUse(item),
        loading: isPending
    });
};

;// CONCATENATED MODULE: ./app/containers/reward-center/package/card-item/VoucherCardItem.tsx











const VoucherCardItem = (param)=>{
    let { item  } = param;
    var _item_item_received, _item_item_received_store_product, _item_item_received1, _item_item_received_store_product1;
    const { t  } = (0,esm/* useTranslation */.$G)();
    const { userInfo: userProfile  } = (0,react.useContext)(context/* AppContext */.Il);
    const { visible , setVisible , setDataSelected  } = (0,react.useContext)(PackageContext/* PackageContext */.M);
    const { mutate , isPending  } = useMutationUseItem();
    const queryClient = (0,QueryClientProvider/* useQueryClient */.NL)();
    const { toast  } = (0,use_toast/* useToast */.pm)();
    const GAEventsTracker = (0,useGAEventsTracker/* default */.Z)("Inventory");
    const textAction = ()=>{
        let result = "";
        if (item.status === configs/* GIFTCODE_TYPE.PENDING */.yO.PENDING) {
            result = t("reward.use_now");
        }
        return result;
    };
    const textDetail = ()=>{
        let result = "";
        if (// item.type === PACKAGE_TYPE.VOUCHER ||
        item.status === configs/* GIFTCODE_TYPE.USED */.yO.USED) {
            result = t("reward.detail");
        }
        return result;
    };
    const onUse = async (item)=>{
        GAEventsTracker("Inventory_used_voucher", item === null || item === void 0 ? void 0 : item.name);
        mutate({
            item_id: item.id
        }, {
            onSuccess: async (data)=>{
                var _data_data_data;
                await queryClient.refetchQueries({
                    queryKey: [
                        configs/* QUERY_KEY.PACKAGE_LIST */.lP.PACKAGE_LIST
                    ]
                });
                toast({
                    variant: "success",
                    title: "\xc1p dụng th\xe0nh c\xf4ng!"
                });
                GAEventsTracker("Inventory_view_voucher");
                setVisible({
                    ...visible,
                    view: true
                });
                setDataSelected({
                    ...item,
                    status: "done",
                    item_received: ((_data_data_data = data.data.data) === null || _data_data_data === void 0 ? void 0 : _data_data_data.item_received) || []
                });
            },
            onError: ()=>{}
        });
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(PackageCard, {
        cardItem: item,
        textDetail: textDetail(),
        textAction: textAction(),
        src: (item === null || item === void 0 ? void 0 : item.image) ? item === null || item === void 0 ? void 0 : item.image : !!(item === null || item === void 0 ? void 0 : (_item_item_received = item.item_received) === null || _item_item_received === void 0 ? void 0 : (_item_item_received_store_product = _item_item_received.store_product) === null || _item_item_received_store_product === void 0 ? void 0 : _item_item_received_store_product.icon) ? item === null || item === void 0 ? void 0 : (_item_item_received1 = item.item_received) === null || _item_item_received1 === void 0 ? void 0 : (_item_item_received_store_product1 = _item_item_received1.store_product) === null || _item_item_received_store_product1 === void 0 ? void 0 : _item_item_received_store_product1.icon : "",
        actionDetail: ()=>{
            GAEventsTracker("Inventory_view_voucher");
            setVisible({
                ...visible,
                view: true
            });
            setDataSelected(item);
        },
        action: ()=>{
            onUse(item);
        },
        loading: isPending
    });
};

// EXTERNAL MODULE: ./app/lib/utils.ts + 1 modules
var utils = __webpack_require__(73848);
;// CONCATENATED MODULE: ./app/containers/reward-center/package/function.ts


const function_listTab = (t)=>[
        {
            title: t("common.all"),
            value: "",
            tab: ""
        },
        {
            title: "Giftcode",
            value: "giftcode,gc",
            tab: configs/* TAB_ITEM_PACKAGE_TYPE.GIFTCODE */.vC.GIFTCODE
        },
        {
            title: "Voucher",
            value: "voucher,gift_voucher",
            tab: configs/* TAB_ITEM_PACKAGE_TYPE.VOUCHER */.vC.VOUCHER
        },
        {
            title: t("reward.tab_card"),
            value: "appota_card",
            tab: configs/* TAB_ITEM_PACKAGE_TYPE.CARD */.vC.CARD
        },
        {
            title: t("reward.tab_other"),
            value: "avatar,sticker,gift_item",
            tab: configs/* TAB_ITEM_PACKAGE_TYPE.OTHER */.vC.OTHER
        }
    ];
const convertData = (data)=>{
    var _data_giftcode, _data_gc, _data_sticker, _data_sticker1, _data_avatar, _data_avatar1, _data_appota_card, _data_appota_card1, _data_voucher, _data_voucher1, _data_gift_voucher, _data_gift_voucher1, _data_gift_item, _data_gift_item1;
    const _listGift = (data === null || data === void 0 ? void 0 : (_data_giftcode = data.giftcode) === null || _data_giftcode === void 0 ? void 0 : _data_giftcode.length) ? [
        ...data.giftcode.map((item)=>{
            return {
                ...item,
                type: configs/* PACKAGE_TYPE.GIFTCODE */.uG.GIFTCODE
            };
        })
    ] : [];
    const _listGCNew = (data === null || data === void 0 ? void 0 : (_data_gc = data.gc) === null || _data_gc === void 0 ? void 0 : _data_gc.length) ? [
        ...data.gc.map((item)=>{
            return {
                ...item,
                type: configs/* PACKAGE_TYPE.GC */.uG.GC
            };
        })
    ] : [];
    const _listSticker = (data === null || data === void 0 ? void 0 : (_data_sticker = data.sticker) === null || _data_sticker === void 0 ? void 0 : _data_sticker.length) ? [
        ...data === null || data === void 0 ? void 0 : (_data_sticker1 = data.sticker) === null || _data_sticker1 === void 0 ? void 0 : _data_sticker1.map((item)=>{
            return {
                ...item,
                type: configs/* PACKAGE_TYPE.STICKER */.uG.STICKER
            };
        })
    ] : [];
    const _listAvatar = (data === null || data === void 0 ? void 0 : (_data_avatar = data.avatar) === null || _data_avatar === void 0 ? void 0 : _data_avatar.length) ? [
        ...data === null || data === void 0 ? void 0 : (_data_avatar1 = data.avatar) === null || _data_avatar1 === void 0 ? void 0 : _data_avatar1.map((item)=>{
            return {
                ...item,
                type: configs/* PACKAGE_TYPE.AVATAR */.uG.AVATAR
            };
        })
    ] : [];
    const _listAppotaCard = (data === null || data === void 0 ? void 0 : (_data_appota_card = data.appota_card) === null || _data_appota_card === void 0 ? void 0 : _data_appota_card.length) ? [
        ...data === null || data === void 0 ? void 0 : (_data_appota_card1 = data.appota_card) === null || _data_appota_card1 === void 0 ? void 0 : _data_appota_card1.map((item)=>{
            return {
                ...item,
                type: configs/* PACKAGE_TYPE.APPOTA_CARD */.uG.APPOTA_CARD
            };
        })
    ] : [];
    const _listVoucher = (data === null || data === void 0 ? void 0 : (_data_voucher = data.voucher) === null || _data_voucher === void 0 ? void 0 : _data_voucher.length) ? [
        ...data === null || data === void 0 ? void 0 : (_data_voucher1 = data.voucher) === null || _data_voucher1 === void 0 ? void 0 : _data_voucher1.map((item)=>{
            return {
                ...item,
                type: configs/* PACKAGE_TYPE.VOUCHER */.uG.VOUCHER
            };
        })
    ] : [];
    const _listGiftVoucher = (data === null || data === void 0 ? void 0 : (_data_gift_voucher = data.gift_voucher) === null || _data_gift_voucher === void 0 ? void 0 : _data_gift_voucher.length) ? [
        ...data === null || data === void 0 ? void 0 : (_data_gift_voucher1 = data.gift_voucher) === null || _data_gift_voucher1 === void 0 ? void 0 : _data_gift_voucher1.map((item)=>{
            return {
                ...item,
                type: configs/* PACKAGE_TYPE.GIFT_VOUCHER */.uG.GIFT_VOUCHER
            };
        })
    ] : [];
    const _listGiftItem = (data === null || data === void 0 ? void 0 : (_data_gift_item = data.gift_item) === null || _data_gift_item === void 0 ? void 0 : _data_gift_item.length) ? [
        ...data === null || data === void 0 ? void 0 : (_data_gift_item1 = data.gift_item) === null || _data_gift_item1 === void 0 ? void 0 : _data_gift_item1.map((item)=>{
            return {
                ...item,
                type: configs/* PACKAGE_TYPE.GIFT_ITEM */.uG.GIFT_ITEM
            };
        })
    ] : [];
    const _list = [
        ..._listAppotaCard,
        ..._listGift,
        ..._listGCNew,
        ..._listAvatar,
        ..._listSticker,
        ..._listVoucher,
        ..._listGiftVoucher,
        ..._listGiftItem
    ].sort((0,utils/* compareValues */.fC)("created_at", "desc"));
    return _list;
};

// EXTERNAL MODULE: ./app/components/ui/skeleton.tsx
var skeleton = __webpack_require__(84751);
;// CONCATENATED MODULE: ./app/containers/reward-center/package/index.tsx




















const initialFilter = {
    start_date: undefined,
    end_date: undefined,
    status: ""
};
const PackageContainer = ()=>{
    var _convertData;
    const { t  } = (0,esm/* useTranslation */.$G)();
    const queryClient = (0,QueryClientProvider/* useQueryClient */.NL)();
    const router = (0,next_router.useRouter)();
    const [dataSelected, setDataSelected] = (0,react.useState)();
    const methods = (0,index_esm/* useForm */.cI)({
        defaultValues: initialFilter
    });
    const [curtab, setCurtab] = (0,react.useState)("");
    const [params, setParams] = (0,react.useState)({
        item_type: "",
        status: "",
        start_date: "",
        end_date: "",
        limit: 12,
        page: 1,
        game_id: ""
    });
    const { data: listItem , isLoading  } = useQueryGetListPackage({
        ...params,
        start_date: params.start_date ? moment_default()(params.start_date).format(configs/* DATE_FORMAT_2 */.G) : "",
        end_date: params.end_date ? moment_default()(params.end_date).format(configs/* DATE_FORMAT_2 */.G) : ""
    });
    (0,react.useEffect)(()=>{
        var _router_query;
        if (!!(router === null || router === void 0 ? void 0 : (_router_query = router.query) === null || _router_query === void 0 ? void 0 : _router_query.item)) {
            var _router_query1, _listTab_find;
            setCurtab(String(router === null || router === void 0 ? void 0 : (_router_query1 = router.query) === null || _router_query1 === void 0 ? void 0 : _router_query1.item));
            const _value_type = ((_listTab_find = function_listTab(t).find((item)=>{
                var _router_query;
                return item.tab === (router === null || router === void 0 ? void 0 : (_router_query = router.query) === null || _router_query === void 0 ? void 0 : _router_query.item);
            })) === null || _listTab_find === void 0 ? void 0 : _listTab_find.value) || "";
            setParams({
                ...params,
                item_type: _value_type
            });
        }
    }, [
        router
    ]);
    const triggerContent = (item)=>{
        switch(item.type){
            case configs/* PACKAGE_TYPE.APPOTA_CARD */.uG.APPOTA_CARD:
                {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(AppotaCardItem, {
                        item: item
                    }, item.id);
                }
            case configs/* PACKAGE_TYPE.VOUCHER */.uG.VOUCHER:
            case configs/* PACKAGE_TYPE.GIFT_VOUCHER */.uG.GIFT_VOUCHER:
                {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(VoucherCardItem, {
                        item: item
                    }, item.id);
                }
            case configs/* PACKAGE_TYPE.AVATAR */.uG.AVATAR:
            case configs/* PACKAGE_TYPE.STICKER */.uG.STICKER:
            case configs/* PACKAGE_TYPE.GIFT_ITEM */.uG.GIFT_ITEM:
                {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(OtherCardItem, {
                        item: item
                    }, item.id);
                }
            default:
                {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(GiftcodeItem, {
                        item: item
                    }, item.id);
                }
        }
    };
    const resetQuery = ()=>{
        queryClient.refetchQueries({
            queryKey: [
                configs/* QUERY_KEY.PACKAGE_LIST */.lP.PACKAGE_LIST,
                {
                    ...params,
                    start_date: params.start_date ? moment_default()(params.start_date).format(configs/* DATE_FORMAT_2 */.G) : "",
                    end_date: params.end_date ? moment_default()(params.end_date).format(configs/* DATE_FORMAT_2 */.G) : ""
                }
            ]
        });
    };
    const renderLoading = ()=>{
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "flex flex-col w-full h-[265px] p-[8px] bg-white dark:bg-white/10 rounded-[12px] xs:rounded-[8px] border border-black/10",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(skeleton/* Skeleton */.O, {
                    className: "w-[full] rounded-[12px] aspect-square xs:rounded-[8px] bg-[#EAEAEA] dark:bg-[#FFFFFF]/10"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "space-y-2 mt-3",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(skeleton/* Skeleton */.O, {
                            className: "h-[16px] w-[60%] bg-[#EAEAEA] dark:bg-[#FFFFFF]/10"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(skeleton/* Skeleton */.O, {
                            className: "h-[32px] w-[50%] bg-[#EAEAEA] dark:bg-[#FFFFFF]/10"
                        })
                    ]
                })
            ]
        });
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(PackageContext/* PackageProvider */.q, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "flex flex-col md:flex-row justify-between md:items-center mt-[16px] gap-[16px]",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "flex gap-[8px] max-w-[576px] overflow-scroll",
                                children: function_listTab(t).map((item)=>{
                                    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "px-[16px] py-[4px] border text-[14px] leading-[19px] rounded-[8px] cursor-pointer whitespace-nowrap ".concat(curtab === item.tab ? "bg-main-01 text-white border-main-01 Nunito-500" : "text-neutral border-black/10 dark:text-neutral-08 dark:border-neutral-08 Nunito-400"),
                                        onClick: ()=>{
                                            setParams({
                                                ...params,
                                                item_type: item.value,
                                                page: 1,
                                                game_id: ""
                                            });
                                            setCurtab(item.tab);
                                            router.replace({
                                                pathname: router.pathname,
                                                query: {
                                                    ...router.query,
                                                    item: item.tab
                                                }
                                            });
                                        },
                                        children: item.title
                                    }, item.value);
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* FormProvider */.RV, {
                                ...methods,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(PackageFilter, {
                                    params: params,
                                    setParams: setParams
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "mt-[24px] grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 pc:grid-cols-6 gap-[16px] pc:gap-[24px]",
                        children: [
                            (_convertData = convertData(listItem === null || listItem === void 0 ? void 0 : listItem.data)) === null || _convertData === void 0 ? void 0 : _convertData.map((item, index)=>{
                                return triggerContent(item);
                            }),
                            isLoading && Array(12).fill(1).map((number)=>{
                                return renderLoading();
                            }),
                            !isLoading && convertData(listItem === null || listItem === void 0 ? void 0 : listItem.data).length === 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "mt-[60px] col-span-6",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(data_empty/* DataEmpty */.$, {
                                    title: t("profile.no_data")
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "col-span-2 sm:col-span-3 md:col-span-4 lg:col-span-5 pc:col-span-6 flex justify-end mt-[8px]",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(pagination/* default */.Z, {
                                    totalCount: (listItem === null || listItem === void 0 ? void 0 : listItem.totalItems) || 0,
                                    onPageChange: (page)=>setParams({
                                            ...params,
                                            page: page
                                        }),
                                    pageSize: 12,
                                    currentPage: params.page
                                })
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(PackageModalContainer, {
                listItem: convertData(listItem === null || listItem === void 0 ? void 0 : listItem.data),
                resetQuery: resetQuery
            })
        ]
    });
};

;// CONCATENATED MODULE: ./app/containers/reward-center/index.tsx











var ENUM_NORMAL_TAB;
(function(ENUM_NORMAL_TAB) {
    ENUM_NORMAL_TAB["PACKAGE"] = "package";
    ENUM_NORMAL_TAB["GOLD_SHOP"] = "gold-shop";
    ENUM_NORMAL_TAB["MISSION_CENTER"] = "mission-center";
})(ENUM_NORMAL_TAB || (ENUM_NORMAL_TAB = {}));
const RewardCenterContainer = ()=>{
    const { t  } = (0,esm/* useTranslation */.$G)();
    const router = (0,next_router.useRouter)();
    const { setOpenModal  } = (0,react.useContext)(context/* AppContext */.Il);
    const [activeTab, setActiveTab] = (0,react.useState)(router.query.tab || ENUM_NORMAL_TAB.PACKAGE);
    const queryClient = (0,QueryClientProvider/* useQueryClient */.NL)();
    const accessToken = configs/* isClient */.C5 ? window.localStorage.getItem("token") : null;
    const handleChangeTab = (value)=>{
        router.push({
            pathname: router.pathname,
            query: {
                tab: value
            }
        });
    };
    (0,react.useEffect)(()=>{
        if (router.query.tab) {
            setActiveTab(router.query.tab);
            queryClient.refetchQueries({
                queryKey: [
                    configs/* QUERY_KEY.LIST_MISSION */.lP.LIST_MISSION
                ]
            });
        }
    }, [
        router
    ]);
    (0,react.useEffect)(()=>{
        if (!accessToken) {
            setOpenModal(configs/* OPEN_MODAL.LOGIN_MODAL */.a6.LOGIN_MODAL);
        }
    }, [
        accessToken
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "w-full xs:mt-0 mt-[40px]",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(tabs/* Tabs */.mQ, {
            defaultValue: [
                "undefined",
                ENUM_NORMAL_TAB.MISSION_CENTER
            ].includes(String(activeTab)) ? ENUM_NORMAL_TAB.MISSION_CENTER : String(activeTab),
            className: "relative w-full",
            style: {
                zIndex: 2
            },
            value: String(activeTab),
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "max-w-full sm:overflow-auto",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(tabs/* TabsList */.dr, {
                        className: "flex px-0 border-0 w-fit xs:gap-0 xs:justify-between xs:w-full",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(tabs/* TabsTrigger */.SP, {
                                value: ENUM_NORMAL_TAB.PACKAGE,
                                className: "xs:w-[31%] xs:text-[14px] xs:py-0 xs:h-[54px] flex items-center gap-[10px] text-neutral-05 dark:text-main-01 dark:data-[state=active]:text-main-01 dark:data-[state=active]:border-main-01 dark:data-[state=inactive]:text-neutral-08 w-fit",
                                onClick: ()=>handleChangeTab(ENUM_NORMAL_TAB.PACKAGE),
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    children: t("common.inventory")
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(tabs/* TabsTrigger */.SP, {
                                value: ENUM_NORMAL_TAB.GOLD_SHOP,
                                className: "xs:w-[31%] xs:text-[14px] xs:py-0 xs:h-[54px] flex items-center gap-[10px] text-neutral-05 dark:text-main-01 dark:data-[state=active]:text-main-01 dark:data-[state=active]:border-main-01 dark:data-[state=inactive]:text-neutral-08 w-fit",
                                onClick: ()=>handleChangeTab(ENUM_NORMAL_TAB.GOLD_SHOP),
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    children: "Gold shop"
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(tabs/* TabsTrigger */.SP, {
                                value: ENUM_NORMAL_TAB.MISSION_CENTER,
                                className: "xs:w-[31%] xs:text-[14px] break-word whitespace-normal xs:px-3 xs:py-0 xs:h-[54px] flex items-center gap-[10px] text-neutral-05 dark:text-main-01 dark:data-[state=active]:text-main-01 dark:data-[state=active]:border-main-01 dark:data-[state=inactive]:text-neutral-08 w-fit",
                                onClick: ()=>handleChangeTab(ENUM_NORMAL_TAB.MISSION_CENTER),
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    children: t("common.mission_center")
                                })
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "mt-0 border-t-[1px] border-black/10 w-full dark:border-neutral-03",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(tabs/* TabsContent */.nU, {
                            value: ENUM_NORMAL_TAB.PACKAGE,
                            className: "w-full",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(PackageContainer, {})
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(tabs/* TabsContent */.nU, {
                            value: ENUM_NORMAL_TAB.GOLD_SHOP,
                            className: "w-full",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(GoldShopContainer, {})
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(tabs/* TabsContent */.nU, {
                            value: ENUM_NORMAL_TAB.MISSION_CENTER,
                            className: "w-full",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(MissionCenterContainer, {})
                        })
                    ]
                })
            ]
        })
    });
};


/***/ }),

/***/ 14699:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "n": function() { return /* binding */ ActionOtherUser; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(41844);
/* harmony import */ var _app_components_connect_action_GroupFollowAction__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(10727);
/* harmony import */ var _app_components_ui_button__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(34428);
/* harmony import */ var _app_configs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(54254);
/* harmony import */ var _app_context__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(17986);
/* harmony import */ var jwt_decode__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(61202);
/* harmony import */ var next_i18next__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(93378);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(55784);









const ActionOtherUser = ()=>{
    var _router_query;
    const { t  } = (0,next_i18next__WEBPACK_IMPORTED_MODULE_6__/* .useTranslation */ .$G)();
    const router = (0,next_router__WEBPACK_IMPORTED_MODULE_7__.useRouter)();
    const { userInfo  } = (0,react__WEBPACK_IMPORTED_MODULE_8__.useContext)(_app_context__WEBPACK_IMPORTED_MODULE_4__/* .AppContext */ .Il);
    const userid = (0,react__WEBPACK_IMPORTED_MODULE_8__.useMemo)(()=>{
        var _router_query;
        return router === null || router === void 0 ? void 0 : (_router_query = router.query) === null || _router_query === void 0 ? void 0 : _router_query.id;
    }, [
        router
    ]);
    const onNavigate = ()=>{
        if (_app_configs__WEBPACK_IMPORTED_MODULE_3__/* .isClient */ .C5) {
            const token = localStorage.getItem("token");
            if (token) {
                var _decodeToken_data;
                const decodeToken = (0,jwt_decode__WEBPACK_IMPORTED_MODULE_5__/* .jwtDecode */ .o)(token);
                router.push("https://id.gamota.com/authorize?access_token=".concat(decodeToken === null || decodeToken === void 0 ? void 0 : (_decodeToken_data = decodeToken.data) === null || _decodeToken_data === void 0 ? void 0 : _decodeToken_data.id, "&callback=/user/verify_email&redirect=").concat(window.location.href));
            }
        }
    };
    if ((userInfo === null || userInfo === void 0 ? void 0 : userInfo.userid) !== userid && userid !== (userInfo === null || userInfo === void 0 ? void 0 : userInfo.alias)) {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "w-fit mx-auto my-[24px]",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_app_components_connect_action_GroupFollowAction__WEBPACK_IMPORTED_MODULE_1__/* .GroupFollowAction */ .o, {
                    id: String(userid)
                })
            })
        });
    }
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: !(userInfo === null || userInfo === void 0 ? void 0 : userInfo.email_verified) && (router === null || router === void 0 ? void 0 : (_router_query = router.query) === null || _router_query === void 0 ? void 0 : _router_query.update) !== "1" && ((userInfo === null || userInfo === void 0 ? void 0 : userInfo.userid) === userid || (userInfo === null || userInfo === void 0 ? void 0 : userInfo.alias) === userid) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_app_components_ui_button__WEBPACK_IMPORTED_MODULE_2__/* .Button */ .z, {
            variant: "none",
            className: "gap-[8px]",
            onClick: onNavigate,
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                    className: "text-main-01 text-[16px] Nunito-600",
                    children: t("profile.account_not_verified")
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
                    width: "24",
                    height: "24",
                    viewBox: "0 0 24 24",
                    fill: "none",
                    xmlns: "http://www.w3.org/2000/svg",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                        d: "M14 16L18 12M18 12L14 8M18 12L6 12",
                        stroke: "#7673E6",
                        strokeWidth: "1.5",
                        strokeLinecap: "round",
                        strokeLinejoin: "round"
                    })
                })
            ]
        })
    });
};


/***/ }),

/***/ 56588:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "n": function() { return /* binding */ AvatarAndName; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(41844);
/* harmony import */ var _app_components_ui_dropdown_menu__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(27357);
/* harmony import */ var _app_context__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(17986);
/* harmony import */ var next_i18next__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(93378);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(55784);
/* harmony import */ var _modal_ModalUploadImage__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(74542);
/* harmony import */ var _app_services_query_fn_user_setting_mutation__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(88663);
/* harmony import */ var _app_configs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(54254);
/* harmony import */ var _tanstack_react_query__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(30202);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var _app_services_query_fn__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(58512);
/* harmony import */ var _app_hooks__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(38609);
/* harmony import */ var _app_components_ui_avatar__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(88313);
/* harmony import */ var _app_utils__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(90752);














const AvatarAndName = ()=>{
    const { t  } = (0,next_i18next__WEBPACK_IMPORTED_MODULE_3__/* .useTranslation */ .$G)();
    const router = (0,next_router__WEBPACK_IMPORTED_MODULE_8__.useRouter)();
    const userId = (0,react__WEBPACK_IMPORTED_MODULE_4__.useMemo)(()=>{
        var _router_query;
        return router === null || router === void 0 ? void 0 : (_router_query = router.query) === null || _router_query === void 0 ? void 0 : _router_query.id;
    }, [
        router
    ]);
    const { userInfo  } = (0,react__WEBPACK_IMPORTED_MODULE_4__.useContext)(_app_context__WEBPACK_IMPORTED_MODULE_2__/* .AppContext */ .Il);
    const [width] = (0,_app_hooks__WEBPACK_IMPORTED_MODULE_10__/* .useWindowSize */ .i)();
    const [changeAvatar, setChangeAvatar] = (0,react__WEBPACK_IMPORTED_MODULE_4__.useState)(false);
    const queryClient = (0,_tanstack_react_query__WEBPACK_IMPORTED_MODULE_12__/* .useQueryClient */ .NL)();
    const { mutate: mutateRemoveFrame  } = (0,_app_services_query_fn_user_setting_mutation__WEBPACK_IMPORTED_MODULE_6__/* .useMutationUpdateProfile */ .Re)();
    const { data: otherUser  } = (0,_app_services_query_fn__WEBPACK_IMPORTED_MODULE_9__/* .useQueryGetProfileById */ .bK)(userId !== (userInfo === null || userInfo === void 0 ? void 0 : userInfo.userid) && userId !== (userInfo === null || userInfo === void 0 ? void 0 : userInfo.alias) ? String(userId) : undefined);
    // useEffect(() => {
    //   if (
    //     !!userInfo &&
    //     userId !== userInfo?.userid &&
    //     userId !== userInfo?.alias &&
    //     !!otherUser
    //   ) {
    //     if (!otherUser?.authentic) {
    //       router.back()
    //     }
    //   }
    // }, [userId, userInfo, otherUser, router])
    const dataUser = userId !== (userInfo === null || userInfo === void 0 ? void 0 : userInfo.userid) && userId !== (userInfo === null || userInfo === void 0 ? void 0 : userInfo.alias) && !!otherUser ? otherUser : userInfo;
    const onRemoveFrame = ()=>{
        mutateRemoveFrame({
            fullname: userInfo === null || userInfo === void 0 ? void 0 : userInfo.fullname,
            revoke_frame: "yes"
        }, {
            onSuccess (data, variables, context) {
                queryClient.invalidateQueries({
                    queryKey: [
                        _app_configs__WEBPACK_IMPORTED_MODULE_7__/* .QUERY_KEY.PROFILE_INFO */ .lP.PROFILE_INFO
                    ],
                    refetchType: "active"
                });
            }
        });
    };
    const onChangeAvatar = ()=>{
        setChangeAvatar(!changeAvatar);
    };
    var _dataUser_fullname, _dataUser_fullname1;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: "flex flex-col items-center w-full",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: "relative w-[80px] h-[80px] lg:w-[120px] lg:h-[120px]",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: "relative group z-10",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_app_components_ui_avatar__WEBPACK_IMPORTED_MODULE_11__/* .Avatar */ .qE, {
                                className: "w-[80px] h-[80px] lg:w-[120px] lg:h-[120px]",
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_app_components_ui_avatar__WEBPACK_IMPORTED_MODULE_11__/* .AvatarImage */ .F$, {
                                        src: !!(dataUser === null || dataUser === void 0 ? void 0 : dataUser.small_avatar) ? dataUser === null || dataUser === void 0 ? void 0 : dataUser.small_avatar : !!(dataUser === null || dataUser === void 0 ? void 0 : dataUser.avatar) ? dataUser === null || dataUser === void 0 ? void 0 : dataUser.avatar : "",
                                        alt: (_dataUser_fullname = dataUser.fullname) !== null && _dataUser_fullname !== void 0 ? _dataUser_fullname : "",
                                        className: "object-cover"
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_app_components_ui_avatar__WEBPACK_IMPORTED_MODULE_11__/* .AvatarFallback */ .Q5, {
                                        className: "flex items-center justify-center w-full text-white bg-main-01",
                                        children: (0,_app_utils__WEBPACK_IMPORTED_MODULE_13__/* .convertNameString */ .Nf)((_dataUser_fullname1 = dataUser.fullname) !== null && _dataUser_fullname1 !== void 0 ? _dataUser_fullname1 : "")
                                    })
                                ]
                            }),
                            !!(dataUser === null || dataUser === void 0 ? void 0 : dataUser.frame_avatar) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: "w-[80px] h-[80px] lg:w-[120px] lg:h-[120px] absolute top-0 left-0 rounded-full z-10",
                                style: {
                                    backgroundImage: "url(".concat(dataUser === null || dataUser === void 0 ? void 0 : dataUser.frame_avatar, ")"),
                                    backgroundSize: "100%"
                                }
                            })
                        ]
                    }),
                    (userId === (userInfo === null || userInfo === void 0 ? void 0 : userInfo.userid) || userId === (userInfo === null || userInfo === void 0 ? void 0 : userInfo.alias)) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_app_components_ui_dropdown_menu__WEBPACK_IMPORTED_MODULE_1__/* .DropdownMenu */ .h_, {
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_app_components_ui_dropdown_menu__WEBPACK_IMPORTED_MODULE_1__/* .DropdownMenuTrigger */ .$F, {
                                asChild: true,
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                    className: "absolute flex items-center justify-center w-[22px] h-[22px] bg-white rounded-full bottom-[-11px] left-[50%] translate-x-[-50%] cursor-pointer z-20",
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                        className: "w-[20px] h-[20px] flex items-center justify-center bg-bg-button rounded-full relative z-30",
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
                                            width: "17",
                                            height: "16",
                                            viewBox: "0 0 17 16",
                                            fill: "none",
                                            xmlns: "http://www.w3.org/2000/svg",
                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                                d: "M4.75129 3.72265C4.59812 3.95241 4.6602 4.26285 4.88997 4.41603C5.11973 4.5692 5.43017 4.50711 5.58334 4.27735L4.75129 3.72265ZM6.10483 2.59373L6.52085 2.87108V2.87108L6.10483 2.59373ZM10.8965 2.59373L11.3125 2.31638L10.8965 2.59373ZM11.418 4.27735C11.5711 4.50711 11.8816 4.5692 12.1113 4.41603C12.3411 4.26285 12.4032 3.95241 12.25 3.72265L11.418 4.27735ZM10.0007 9C10.0007 9.82843 9.32908 10.5 8.50065 10.5V11.5C9.88136 11.5 11.0007 10.3807 11.0007 9H10.0007ZM8.50065 10.5C7.67222 10.5 7.00065 9.82843 7.00065 9H6.00065C6.00065 10.3807 7.11994 11.5 8.50065 11.5V10.5ZM7.00065 9C7.00065 8.17157 7.67222 7.5 8.50065 7.5V6.5C7.11994 6.5 6.00065 7.61929 6.00065 9H7.00065ZM8.50065 7.5C9.32908 7.5 10.0007 8.17157 10.0007 9H11.0007C11.0007 7.61929 9.88136 6.5 8.50065 6.5V7.5ZM5.58334 4.27735L6.52085 2.87108L5.6888 2.31638L4.75129 3.72265L5.58334 4.27735ZM7.21423 2.5H9.78707V1.5H7.21423V2.5ZM10.4804 2.87108L11.418 4.27735L12.25 3.72265L11.3125 2.31638L10.4804 2.87108ZM9.78707 2.5C10.0657 2.5 10.3259 2.63925 10.4804 2.87108L11.3125 2.31638C10.9725 1.80635 10.4001 1.5 9.78707 1.5V2.5ZM6.52085 2.87108C6.67541 2.63925 6.9356 2.5 7.21423 2.5V1.5C6.60125 1.5 6.02882 1.80635 5.6888 2.31638L6.52085 2.87108ZM4.50065 4.5H12.5007V3.5H4.50065V4.5ZM14.6673 6.66667V11.3333H15.6673V6.66667H14.6673ZM12.5007 13.5H4.50065V14.5H12.5007V13.5ZM2.33398 11.3333V6.66667H1.33398V11.3333H2.33398ZM4.50065 13.5C3.30403 13.5 2.33398 12.53 2.33398 11.3333H1.33398C1.33398 13.0822 2.75175 14.5 4.50065 14.5V13.5ZM14.6673 11.3333C14.6673 12.53 13.6973 13.5 12.5007 13.5V14.5C14.2496 14.5 15.6673 13.0822 15.6673 11.3333H14.6673ZM12.5007 4.5C13.6973 4.5 14.6673 5.47005 14.6673 6.66667H15.6673C15.6673 4.91777 14.2496 3.5 12.5007 3.5V4.5ZM4.50065 3.5C2.75175 3.5 1.33398 4.91777 1.33398 6.66667H2.33398C2.33398 5.47005 3.30403 4.5 4.50065 4.5V3.5Z",
                                                fill: "#7673E6"
                                            })
                                        })
                                    })
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_app_components_ui_dropdown_menu__WEBPACK_IMPORTED_MODULE_1__/* .DropdownMenuContent */ .AW, {
                                className: "w-fit",
                                align: "center",
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_app_components_ui_dropdown_menu__WEBPACK_IMPORTED_MODULE_1__/* .DropdownMenuItem */ .Xi, {
                                        className: "focus:bg-bg-disable focus:text-main-01 bold-600--700 text-sm text-start flex justify-start px-4 py-3 rounded-[8px]",
                                        onClick: onChangeAvatar,
                                        children: t("common.change_avatar")
                                    }),
                                    !!(userInfo === null || userInfo === void 0 ? void 0 : userInfo.frame_avatar) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_app_components_ui_dropdown_menu__WEBPACK_IMPORTED_MODULE_1__/* .DropdownMenuItem */ .Xi, {
                                        className: "focus:bg-bg-disable focus:text-main-01 bold-600--700 text-sm text-start flex justify-start px-4 py-3 rounded-[8px]",
                                        onClick: onRemoveFrame,
                                        children: t("common.delete_frame_profile")
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("p", {
                className: "text-base lg:text-[18px] text-bg-01 mt-[24px] lg:mt-[16px] Nunito-700 dark:text-white flex gap-2 items-center",
                children: [
                    dataUser === null || dataUser === void 0 ? void 0 : dataUser.fullname,
                    !!(dataUser === null || dataUser === void 0 ? void 0 : dataUser.authentic) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
                            width: "16",
                            height: "16",
                            viewBox: "0 0 16 16",
                            fill: "none",
                            xmlns: "http://www.w3.org/2000/svg",
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                fillRule: "evenodd",
                                clipRule: "evenodd",
                                d: "M7.9987 14.6663C11.6806 14.6663 14.6654 11.6816 14.6654 7.99967C14.6654 4.31778 11.6806 1.33301 7.9987 1.33301C4.3168 1.33301 1.33203 4.31778 1.33203 7.99967C1.33203 11.6816 4.3168 14.6663 7.9987 14.6663ZM11.06 6.30667C11.2296 6.08869 11.1903 5.77456 10.9723 5.60502C10.7544 5.43549 10.4402 5.47475 10.2707 5.69273L7.59936 9.1273C7.53996 9.20367 7.42822 9.21358 7.35631 9.14886L5.66652 7.62805C5.46126 7.44332 5.14512 7.45996 4.96039 7.66522C4.77566 7.87047 4.7923 8.18661 4.99755 8.37134L6.68734 9.89215C7.19076 10.3452 7.9729 10.2759 8.38871 9.74124L11.06 6.30667Z",
                                fill: "#7673E6"
                            })
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_modal_ModalUploadImage__WEBPACK_IMPORTED_MODULE_5__/* .ModalUploadImage */ .g, {
                open: changeAvatar,
                onClose: onChangeAvatar
            })
        ]
    });
};


/***/ }),

/***/ 2027:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "j": function() { return /* binding */ InviteCode; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(41844);
/* harmony import */ var _app_components_icon_tsx_IconCopied__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(60303);
/* harmony import */ var _app_components_icon_tsx_IconNonCopy__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(27298);
/* harmony import */ var _app_context__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(17986);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(55784);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var _app_services_query_fn__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(58512);
/* harmony import */ var _app_configs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(54254);








const TIME_OUT = 3000;
const InviteCode = ()=>{
    const router = (0,next_router__WEBPACK_IMPORTED_MODULE_5__.useRouter)();
    const { userInfo , themeApp , setOpenModal  } = (0,react__WEBPACK_IMPORTED_MODULE_4__.useContext)(_app_context__WEBPACK_IMPORTED_MODULE_3__/* .AppContext */ .Il);
    const userId = (0,react__WEBPACK_IMPORTED_MODULE_4__.useMemo)(()=>{
        var _router_query;
        return router === null || router === void 0 ? void 0 : (_router_query = router.query) === null || _router_query === void 0 ? void 0 : _router_query.id;
    }, [
        router
    ]);
    const { data: otherUser  } = (0,_app_services_query_fn__WEBPACK_IMPORTED_MODULE_6__/* .useQueryGetProfileById */ .bK)(userId !== (userInfo === null || userInfo === void 0 ? void 0 : userInfo.userid) && userId !== (userInfo === null || userInfo === void 0 ? void 0 : userInfo.alias) ? String(userId) : undefined);
    const dataUser = userId !== (userInfo === null || userInfo === void 0 ? void 0 : userInfo.userid) && userId !== (userInfo === null || userInfo === void 0 ? void 0 : userInfo.alias) && !!otherUser ? otherUser : userInfo;
    const [copied, setIsCopied] = (0,react__WEBPACK_IMPORTED_MODULE_4__.useState)(false);
    const onCopyInviteCode = ()=>{
        navigator.clipboard.writeText(dataUser === null || dataUser === void 0 ? void 0 : dataUser.referent_code);
        setIsCopied(true);
    };
    const onChangeShowModal = ()=>{
        setOpenModal(_app_configs__WEBPACK_IMPORTED_MODULE_7__/* .OPEN_MODAL.SHARE_REFER_CODE */ .a6.SHARE_REFER_CODE);
    };
    (0,react__WEBPACK_IMPORTED_MODULE_4__.useEffect)(()=>{
        const timeout = setTimeout(()=>{
            if (copied) setIsCopied(false);
        }, TIME_OUT);
        return ()=>{
            clearTimeout(timeout);
        };
    }, [
        copied
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
            className: "w-full flex items-center justify-center my-1 md:my-[8px] gap-[20px]",
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: "flex gap-[7px] items-center",
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("p", {
                            className: "text-[#27908C] text-sm Nunito-400",
                            children: [
                                "Invite code:",
                                " ",
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                    className: "Nunito-700",
                                    children: dataUser === null || dataUser === void 0 ? void 0 : dataUser.referent_code
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: "w-[1px] h-[17px] bg-[#27908C]"
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: "cursor-pointer w-fit",
                            onClick: onCopyInviteCode,
                            children: copied ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_app_components_icon_tsx_IconCopied__WEBPACK_IMPORTED_MODULE_1__/* .IconCopied */ .i, {}) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_app_components_icon_tsx_IconNonCopy__WEBPACK_IMPORTED_MODULE_2__/* .IconNonCopy */ .x, {
                                stroke: "#27908C"
                            })
                        })
                    ]
                }),
                (userId === (userInfo === null || userInfo === void 0 ? void 0 : userInfo.userid) || userId === (userInfo === null || userInfo === void 0 ? void 0 : userInfo.alias)) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: "w-[34px] h-[34px] rounded-[10px] flex items-center justify-center cursor-pointer dark:bg-[rgba(240,242,245,0.1)]",
                    onClick: onChangeShowModal,
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("svg", {
                        width: "16",
                        height: "16",
                        viewBox: "0 0 16 16",
                        fill: "none",
                        xmlns: "http://www.w3.org/2000/svg",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                d: "M8.66602 7.33337L14.1327 1.8667",
                                stroke: themeApp === "dark" ? "#fff" : "#585669",
                                strokeWidth: "1.5",
                                strokeLinecap: "round",
                                strokeLinejoin: "round"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                d: "M14.6668 4.53334V1.33334H11.4668",
                                stroke: themeApp === "dark" ? "#fff" : "#585669",
                                strokeWidth: "1.5",
                                strokeLinecap: "round",
                                strokeLinejoin: "round"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                d: "M7.33398 1.33334H6.00065C2.66732 1.33334 1.33398 2.66668 1.33398 6.00001V10C1.33398 13.3333 2.66732 14.6667 6.00065 14.6667H10.0007C13.334 14.6667 14.6673 13.3333 14.6673 10V8.66668",
                                stroke: themeApp === "dark" ? "#fff" : "#585669",
                                strokeWidth: "1.5",
                                strokeLinecap: "round",
                                strokeLinejoin: "round"
                            })
                        ]
                    })
                })
            ]
        })
    });
};


/***/ }),

/***/ 45612:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "g": function() { return /* binding */ Overview; }
});

// EXTERNAL MODULE: ./node_modules/next/dist/compiled/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(41844);
// EXTERNAL MODULE: ./app/context/index.ts + 2 modules
var context = __webpack_require__(17986);
// EXTERNAL MODULE: ./node_modules/next-i18next/dist/esm/index.js + 41 modules
var esm = __webpack_require__(93378);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/react/index.js
var react = __webpack_require__(55784);
// EXTERNAL MODULE: ./app/components/app-avatar/HoverUserAvatar.tsx + 2 modules
var HoverUserAvatar = __webpack_require__(40577);
// EXTERNAL MODULE: ./app/components/data-empty/index.tsx + 1 modules
var data_empty = __webpack_require__(98269);
// EXTERNAL MODULE: ./app/components/icon-tsx/index.ts + 11 modules
var icon_tsx = __webpack_require__(61552);
// EXTERNAL MODULE: ./app/components/icon-tsx/IconClose.tsx
var IconClose = __webpack_require__(51337);
// EXTERNAL MODULE: ./app/components/ui/dialog.tsx
var dialog = __webpack_require__(76500);
// EXTERNAL MODULE: ./app/hooks/useDebounceEffect.tsx
var useDebounceEffect = __webpack_require__(45724);
// EXTERNAL MODULE: ./app/services/query-fn/index.ts + 6 modules
var query_fn = __webpack_require__(58512);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./node_modules/react-intersection-observer/index.mjs
var react_intersection_observer = __webpack_require__(42708);
;// CONCATENATED MODULE: ./app/containers/users/partner/modal/ModalFollower.tsx













const TIME_DEBOUNCE = 300;
const ModalFollower = (param)=>{
    let { open , onClose  } = param;
    var _data_pages_flat, _data_pages, _data_pages1, _data_pages_flat1, _data_pages2;
    const { t  } = (0,esm/* useTranslation */.$G)();
    const router = (0,next_router.useRouter)();
    const userid = (0,react.useMemo)(()=>{
        var _router_query;
        return router === null || router === void 0 ? void 0 : (_router_query = router.query) === null || _router_query === void 0 ? void 0 : _router_query.id;
    }, [
        router
    ]);
    const { themeApp  } = (0,react.useContext)(context/* AppContext */.Il);
    const [tempValue, setTempValue] = (0,react.useState)("");
    const [searchValue, setSearchValue] = (0,react.useState)("");
    const { data , fetchNextPage  } = (0,query_fn/* useQueryGetMyFollowing */.Po)(String(userid), open, searchValue);
    const onChange = (e)=>{
        var _e_target;
        setTempValue(e === null || e === void 0 ? void 0 : (_e_target = e.target) === null || _e_target === void 0 ? void 0 : _e_target.value);
    };
    const { ref , inView  } = (0,react_intersection_observer/* useInView */.YD)();
    (0,react.useEffect)(()=>{
        if (inView) {
            fetchNextPage();
        }
    }, [
        fetchNextPage,
        inView
    ]);
    (0,useDebounceEffect/* useDebounceEffect */.s)(()=>setSearchValue(tempValue), TIME_DEBOUNCE, [
        tempValue
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(dialog/* Dialog */.Vq, {
        open: open,
        onOpenChange: onClose,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(dialog/* DialogContent */.cZ, {
            className: "sm:rounded-[24px] rounded-[24px] w-[90vw] md:max-w-[406px] p-[32px] dark:bg-bg-02 dark:border-0 ",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(dialog/* DialogHeader */.fK, {
                    className: "flex flex-row items-center justify-between w-full",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                            className: "Nunito-700 text-[16px] text-bg-01 dark:text-white",
                            children: t("profile.follower")
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "cursor-pointer",
                            onClick: onClose,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(IconClose/* IconClose */.b, {})
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "flex items-center justify-between border-b-[1px] dark:border-0 gap-4 py-3",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(icon_tsx/* IconSearch */.jV, {
                            fill: themeApp === "dark" ? "#fff" : "#100D28"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                            type: "text",
                            value: tempValue,
                            className: "flex-1 text-base border-0 outline-none dark:text-white dark:bg-transparent",
                            placeholder: t("profile.find_follower_placeholder"),
                            onChange: onChange
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "w-full",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "h-[412px] space-y-[24px] overflow-auto",
                        children: [
                            ((_data_pages_flat = data === null || data === void 0 ? void 0 : (_data_pages = data.pages) === null || _data_pages === void 0 ? void 0 : _data_pages.flat()) === null || _data_pages_flat === void 0 ? void 0 : _data_pages_flat.length) ? data === null || data === void 0 ? void 0 : (_data_pages1 = data.pages) === null || _data_pages1 === void 0 ? void 0 : _data_pages1.flat().map((item, index)=>{
                                /*#__PURE__*/ return (0,jsx_runtime.jsx)("div", {
                                    className: "flex items-center justify-between w-full",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(HoverUserAvatar/* HoverUserAvatar */.F, {
                                        avatarUser: item,
                                        size: 40,
                                        text: {
                                            text: item === null || item === void 0 ? void 0 : item.fullname,
                                            className: "flex-1 text-base Nunito-700 text-bg-01 dark:text-white"
                                        }
                                    })
                                }, index);
                            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "w-full flex items-center justify-center h-[200px]",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(data_empty/* DataEmpty */.$, {
                                    title: t("profile.no_data")
                                })
                            }),
                            !!data && !!((_data_pages_flat1 = data === null || data === void 0 ? void 0 : (_data_pages2 = data.pages) === null || _data_pages2 === void 0 ? void 0 : _data_pages2.flat()) === null || _data_pages_flat1 === void 0 ? void 0 : _data_pages_flat1.length) && /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                ref: ref,
                                className: "opacity-0",
                                children: "Load more"
                            })
                        ]
                    })
                })
            ]
        })
    });
};

;// CONCATENATED MODULE: ./app/containers/users/partner/modal/index.ts


// EXTERNAL MODULE: ./app/components/ui/tabs.tsx + 1 modules
var tabs = __webpack_require__(98241);
// EXTERNAL MODULE: ./node_modules/@radix-ui/react-scroll-area/dist/index.mjs
var dist = __webpack_require__(25443);
// EXTERNAL MODULE: ./app/components/ui/button.tsx
var ui_button = __webpack_require__(34428);
// EXTERNAL MODULE: ./app/services/query-fn/user/user-friend-query.ts
var user_friend_query = __webpack_require__(74799);
// EXTERNAL MODULE: ./app/services/query-fn/user/user-friend-mutation.ts
var user_friend_mutation = __webpack_require__(3201);
// EXTERNAL MODULE: ./node_modules/@tanstack/react-query/build/modern/QueryClientProvider.js
var QueryClientProvider = __webpack_require__(30202);
// EXTERNAL MODULE: ./app/configs/index.ts + 3 modules
var configs = __webpack_require__(54254);
// EXTERNAL MODULE: ./app/components/app-avatar/OnlyShowAvatar.tsx
var OnlyShowAvatar = __webpack_require__(30897);
;// CONCATENATED MODULE: ./app/containers/users/normal-user/modal/ListFriend.tsx











const ListFriend = (param)=>{
    let { active =false , searchValue =""  } = param;
    var _listFriendWithoutAuthenticate;
    const { t  } = (0,esm/* useTranslation */.$G)();
    const { data: listFriendWithoutSearch , fetchNextPage: fetchWithoutSearch  } = (0,user_friend_query/* useQueryGetListFriend */.tf)(!!active, searchValue);
    const { data: listFriendWithSearch , fetchNextPage: fetchWithSearch  } = (0,user_friend_query/* useQueryGetListFriendWithSearch */.Ue)(!!active, searchValue);
    const { ref , inView  } = (0,react_intersection_observer/* useInView */.YD)();
    const { mutate  } = (0,user_friend_mutation/* useMutatonUnFriend */.OX)();
    const queryClent = (0,QueryClientProvider/* useQueryClient */.NL)();
    const onUnFriend = (user)=>{
        mutate({
            friend_id: user === null || user === void 0 ? void 0 : user.id
        }, {
            onSuccess (data, variables, context) {
                queryClent.refetchQueries({
                    queryKey: [
                        configs/* QUERY_KEY.LIST_FRIEND */.lP.LIST_FRIEND
                    ]
                });
                queryClent.refetchQueries({
                    queryKey: [
                        configs/* QUERY_KEY.LIST_SUGGEST_FRIEND */.lP.LIST_SUGGEST_FRIEND
                    ]
                });
                queryClent.refetchQueries({
                    queryKey: [
                        configs/* QUERY_KEY.PROFILE_INFO */.lP.PROFILE_INFO
                    ]
                });
            }
        });
    };
    const listFriendWithoutAuthenticate = ()=>{
        var _listFriend_pages_flat, _listFriend_pages, _listFriend_pages1;
        const listFriend = !!searchValue ? listFriendWithSearch : listFriendWithoutSearch;
        return ((_listFriend_pages_flat = listFriend === null || listFriend === void 0 ? void 0 : (_listFriend_pages = listFriend.pages) === null || _listFriend_pages === void 0 ? void 0 : _listFriend_pages.flat()) === null || _listFriend_pages_flat === void 0 ? void 0 : _listFriend_pages_flat.length) ? listFriend === null || listFriend === void 0 ? void 0 : (_listFriend_pages1 = listFriend.pages) === null || _listFriend_pages1 === void 0 ? void 0 : _listFriend_pages1.flat() : [];
    };
    (0,react.useEffect)(()=>{
        if (inView) {
            searchValue ? fetchWithSearch() : fetchWithoutSearch();
        }
    }, [
        fetchWithoutSearch,
        fetchWithSearch,
        searchValue,
        inView
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            ((_listFriendWithoutAuthenticate = listFriendWithoutAuthenticate()) === null || _listFriendWithoutAuthenticate === void 0 ? void 0 : _listFriendWithoutAuthenticate.length) ? listFriendWithoutAuthenticate().map((item, index)=>{
                /*#__PURE__*/ return (0,jsx_runtime.jsxs)("div", {
                    className: "flex items-center justify-between w-full",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "flex flex-1 gap-4",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(OnlyShowAvatar/* OnlyShowAvatar */.T, {
                                    size: 40,
                                    avatarUser: item
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                    className: "flex items-center text-base Nunito-700 text-bg-01 dark:text-white",
                                    children: item === null || item === void 0 ? void 0 : item.fullname
                                })
                            ]
                        }),
                        !(item === null || item === void 0 ? void 0 : item.authentic) && /*#__PURE__*/ (0,jsx_runtime.jsx)(ui_button/* Button */.z, {
                            variant: "none",
                            className: "outline-none bg-transparent text-neutral-06 h-[27px] px-[12px] flex items-center justify-center border-[1px] border-neutral-06 rounded-[8px]",
                            onClick: ()=>onUnFriend(item),
                            children: t("profile.unfriend")
                        })
                    ]
                }, item === null || item === void 0 ? void 0 : item.id);
            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "w-full flex items-center justify-center h-[200px]",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(data_empty/* DataEmpty */.$, {
                    title: t("profile.no_data")
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                ref: ref,
                className: "opacity-0",
                children: "Load more"
            })
        ]
    });
};

;// CONCATENATED MODULE: ./app/containers/users/normal-user/modal/ListProposeFriend.tsx











const ListProposeFriend = (param)=>{
    let { active =false  } = param;
    const { t  } = (0,esm/* useTranslation */.$G)();
    const { data: listFriend , fetchNextPage  } = (0,user_friend_query/* useQueryGetSuggestFriend */.Z6)(!!active);
    const { ref , inView  } = (0,react_intersection_observer/* useInView */.YD)();
    (0,react.useEffect)(()=>{
        if (inView) {
            fetchNextPage();
        }
    }, [
        fetchNextPage,
        inView
    ]);
    const listWithoutAuthenticate = (0,react.useMemo)(()=>{
        var _listFriend_pages_flat, _listFriend_pages, _listFriend_pages_flat1, _listFriend_pages1;
        return ((_listFriend_pages_flat = listFriend === null || listFriend === void 0 ? void 0 : (_listFriend_pages = listFriend.pages) === null || _listFriend_pages === void 0 ? void 0 : _listFriend_pages.flat()) === null || _listFriend_pages_flat === void 0 ? void 0 : _listFriend_pages_flat.length) ? (_listFriend_pages_flat1 = listFriend === null || listFriend === void 0 ? void 0 : (_listFriend_pages1 = listFriend.pages) === null || _listFriend_pages1 === void 0 ? void 0 : _listFriend_pages1.flat()) === null || _listFriend_pages_flat1 === void 0 ? void 0 : _listFriend_pages_flat1.filter((item)=>{
            return !(item === null || item === void 0 ? void 0 : item.authentic);
        }) : [];
    }, [
        listFriend
    ]);
    const { mutate  } = (0,user_friend_mutation/* useMutatonAddFriend */.TY)();
    const queryClent = (0,QueryClientProvider/* useQueryClient */.NL)();
    const onRequestAddFrend = (user)=>{
        mutate({
            friend_id: user === null || user === void 0 ? void 0 : user.id
        }, {
            onSuccess (data, variables, context) {
                queryClent.refetchQueries({
                    queryKey: [
                        configs/* QUERY_KEY.LIST_FRIEND */.lP.LIST_FRIEND
                    ]
                });
                queryClent.refetchQueries({
                    queryKey: [
                        configs/* QUERY_KEY.LIST_SUGGEST_FRIEND */.lP.LIST_SUGGEST_FRIEND
                    ]
                });
            }
        });
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: (listWithoutAuthenticate === null || listWithoutAuthenticate === void 0 ? void 0 : listWithoutAuthenticate.length) ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "w-full space-y-[24px]",
            children: [
                listWithoutAuthenticate === null || listWithoutAuthenticate === void 0 ? void 0 : listWithoutAuthenticate.map((item, index)=>{
                    /*#__PURE__*/ return (0,jsx_runtime.jsxs)("div", {
                        className: "flex items-center justify-between w-full",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "flex flex-1 gap-4",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(OnlyShowAvatar/* OnlyShowAvatar */.T, {
                                        size: 40,
                                        avatarUser: item
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                        className: "flex items-center text-base Nunito-700 text-bg-01 dark:text-white",
                                        children: item === null || item === void 0 ? void 0 : item.fullname
                                    })
                                ]
                            }),
                            !(item === null || item === void 0 ? void 0 : item.authentic) && /*#__PURE__*/ (0,jsx_runtime.jsx)(ui_button/* Button */.z, {
                                variant: "none",
                                className: "outline-none bg-main-01 h-[27px] px-[12px] flex items-center justify-center text-white rounded-[8px]",
                                onClick: ()=>onRequestAddFrend(item),
                                children: t("profile.addfriend")
                            })
                        ]
                    }, index);
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                    ref: ref,
                    className: "opacity-0",
                    children: "Load more"
                })
            ]
        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "w-full flex items-center justify-center h-[200px]",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(data_empty/* DataEmpty */.$, {
                title: t("profile.no_data")
            })
        })
    });
};

;// CONCATENATED MODULE: ./app/containers/users/normal-user/modal/ListRequestFriend.tsx










const ListRequestFriend = (param)=>{
    let { active =false  } = param;
    const { t  } = (0,esm/* useTranslation */.$G)();
    const { data: listFriend  } = (0,user_friend_query/* useQueryGetRequestFriend */.Cm)(!!active);
    const queryClient = (0,QueryClientProvider/* useQueryClient */.NL)();
    const listWithoutAuthenticate = (0,react.useMemo)(()=>{
        var _listFriend_pages_flat, _listFriend_pages, _listFriend_pages_flat1, _listFriend_pages1;
        return ((_listFriend_pages_flat = listFriend === null || listFriend === void 0 ? void 0 : (_listFriend_pages = listFriend.pages) === null || _listFriend_pages === void 0 ? void 0 : _listFriend_pages.flat()) === null || _listFriend_pages_flat === void 0 ? void 0 : _listFriend_pages_flat.length) ? (_listFriend_pages_flat1 = listFriend === null || listFriend === void 0 ? void 0 : (_listFriend_pages1 = listFriend.pages) === null || _listFriend_pages1 === void 0 ? void 0 : _listFriend_pages1.flat()) === null || _listFriend_pages_flat1 === void 0 ? void 0 : _listFriend_pages_flat1.filter((item)=>{
            return !(item === null || item === void 0 ? void 0 : item.authentic);
        }) : [];
    }, [
        listFriend
    ]);
    const { mutate , isPending  } = (0,user_friend_mutation/* useMutatonDoActionRequestFriend */.CH)();
    const onDoActionRequestFriend = (user, status)=>{
        mutate({
            request_id: user === null || user === void 0 ? void 0 : user.request_id,
            status
        }, {
            onSuccess (data, variables, context) {
                queryClient.refetchQueries({
                    queryKey: [
                        configs/* QUERY_KEY.LIST_SUGGEST_FRIEND */.lP.LIST_SUGGEST_FRIEND
                    ]
                });
                queryClient.refetchQueries({
                    queryKey: [
                        configs/* QUERY_KEY.LIST_FRIEND */.lP.LIST_FRIEND
                    ]
                });
                queryClient.refetchQueries({
                    queryKey: [
                        configs/* QUERY_KEY.LIST_REQUEST_FRIEND */.lP.LIST_REQUEST_FRIEND
                    ]
                });
                queryClient.refetchQueries({
                    queryKey: [
                        configs/* QUERY_KEY.PROFILE_INFO */.lP.PROFILE_INFO
                    ]
                });
            }
        });
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: (listWithoutAuthenticate === null || listWithoutAuthenticate === void 0 ? void 0 : listWithoutAuthenticate.length) ? listWithoutAuthenticate === null || listWithoutAuthenticate === void 0 ? void 0 : listWithoutAuthenticate.map((item, index)=>{
            /*#__PURE__*/ return (0,jsx_runtime.jsxs)("div", {
                className: "flex items-center justify-between w-full",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "flex flex-1 gap-4",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(OnlyShowAvatar/* OnlyShowAvatar */.T, {
                                size: 40,
                                avatarUser: item
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                className: "flex items-center text-base Nunito-700 text-bg-01 dark:text-white",
                                children: item === null || item === void 0 ? void 0 : item.fullname
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "flex items-center gap-2",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(ui_button/* Button */.z, {
                                variant: "main",
                                className: "outline-none bg-main-01 h-[27px] px-[12px] flex items-center justify-center text-white rounded-[8px]",
                                onClick: ()=>onDoActionRequestFriend(item, "accepted"),
                                disabled: isPending,
                                children: t("group.agree")
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(ui_button/* Button */.z, {
                                variant: "none",
                                className: "outline-none bg-transparent text-neutral-06 h-[27px] px-[12px] flex items-center justify-center border-[1px] border-neutral-06 rounded-[8px]",
                                onClick: ()=>onDoActionRequestFriend(item, "cancel"),
                                disabled: isPending,
                                children: t("group.reject")
                            })
                        ]
                    })
                ]
            }, index);
        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "w-full flex items-center justify-center h-[200px]",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(data_empty/* DataEmpty */.$, {
                title: t("profile.no_data")
            })
        })
    });
};

;// CONCATENATED MODULE: ./app/containers/users/normal-user/modal/ModalFriend.tsx













const ModalFriend_TIME_DEBOUNCE = 700;
const ModalFriend = (param)=>{
    let { open , onClose  } = param;
    const { t  } = (0,esm/* useTranslation */.$G)();
    const { themeApp  } = (0,react.useContext)(context/* AppContext */.Il);
    const [tabActive, setTabActive] = (0,react.useState)("friend");
    const [keyword, setKeyword] = (0,react.useState)("");
    const [tempSearchValue, setTempSearchValue] = (0,react.useState)("");
    const onChange = (e)=>{
        var _e_target;
        setTempSearchValue(e === null || e === void 0 ? void 0 : (_e_target = e.target) === null || _e_target === void 0 ? void 0 : _e_target.value);
    };
    (0,useDebounceEffect/* useDebounceEffect */.s)(()=>{
        return setKeyword(tempSearchValue === null || tempSearchValue === void 0 ? void 0 : tempSearchValue.trim());
    }, ModalFriend_TIME_DEBOUNCE, [
        tempSearchValue
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(dialog/* Dialog */.Vq, {
        open: open,
        onOpenChange: onClose,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(dialog/* DialogContent */.cZ, {
            className: "rounded-[16px] sm:rounded-[16px] w-[90vw] md:max-w-[470px] p-0 dark:bg-bg-02 outline-none border-0",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(dialog/* DialogHeader */.fK, {
                    className: "w-full flex items-center justify-between flex-row border-b-[1px] border-black/10 py-[24px] px-[32px] h-[72px]",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                            className: "Nunito-700 text-[16px] text-bg-01 dark:text-white",
                            children: t("profile.list_friend")
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "cursor-pointer",
                            onClick: onClose,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(IconClose/* IconClose */.b, {})
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "h-[54px] w-full",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(tabs/* Tabs */.mQ, {
                        value: tabActive,
                        className: "w-full mt-0 relative px-[24px]",
                        style: {
                            zIndex: 2
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(tabs/* TabsList */.dr, {
                            className: "grid w-full grid-cols-3 px-0 border-b-[1px] border-black/10 dark:border-neutral-05",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(tabs/* TabsTrigger */.SP, {
                                    value: "friend",
                                    className: "flex items-center gap-[10px] dark:text-main-01 dark:data-[state=active]:text-main-01 dark:data-[state=active]:border-main-01 dark:data-[state=inactive]:text-neutral-05",
                                    onClick: ()=>setTabActive("friend"),
                                    children: t("profile.friend")
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(tabs/* TabsTrigger */.SP, {
                                    value: "propose",
                                    className: "flex items-center gap-[10px] dark:text-main-01 dark:data-[state=active]:text-main-01 dark:data-[state=active]:border-main-01 dark:data-[state=inactive]:text-neutral-05",
                                    onClick: ()=>setTabActive("propose"),
                                    children: t("profile.refer")
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(tabs/* TabsTrigger */.SP, {
                                    value: "request",
                                    className: "flex items-center gap-[10px] dark:text-main-01 dark:data-[state=active]:text-main-01 dark:data-[state=active]:border-main-01 dark:data-[state=inactive]:text-neutral-05",
                                    onClick: ()=>setTabActive("request"),
                                    children: t("profile.friend_request")
                                })
                            ]
                        })
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "w-full px-[24px] pb-[32px]",
                    children: [
                        tabActive === "friend" && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "flex justify-between gap-4 py-3 mb-4 border-0 h-[44px]",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(icon_tsx/* IconSearch */.jV, {
                                    fill: themeApp === "dark" ? "#fff" : "#100D28"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                    type: "text",
                                    value: tempSearchValue,
                                    className: "flex-1 text-sm border-0 outline-none dark:text-white dark:bg-transparent",
                                    placeholder: t("profile.search"),
                                    onChange: onChange
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(dist/* ScrollArea */.xr, {
                            className: "".concat(tabActive === "friend" ? "h-[188px] sm:h-[268px] ld:h-[290px]" : "h-[248px] sm:h-[328px] ld:h-[350px]", " overflow-auto space-y-[24px]"),
                            children: [
                                tabActive === "friend" && /*#__PURE__*/ (0,jsx_runtime.jsx)(ListFriend, {
                                    active: tabActive === "friend" && !!open,
                                    searchValue: keyword
                                }),
                                tabActive === "propose" && /*#__PURE__*/ (0,jsx_runtime.jsx)(ListProposeFriend, {
                                    active: tabActive === "propose" && !!open
                                }),
                                tabActive === "request" && /*#__PURE__*/ (0,jsx_runtime.jsx)(ListRequestFriend, {
                                    active: tabActive === "request" && !!open
                                })
                            ]
                        })
                    ]
                })
            ]
        })
    });
};

// EXTERNAL MODULE: ./app/helpers/function.ts + 23 modules
var helpers_function = __webpack_require__(4203);
// EXTERNAL MODULE: ./app/services/query-fn/game/index.ts + 1 modules
var game = __webpack_require__(82190);
;// CONCATENATED MODULE: ./app/containers/users/normal-user/modal/ModalGameFollowing.tsx













const ModalGameFollowing = (param)=>{
    let { open , onClose  } = param;
    var _newfollowingList, _newfollowingList1;
    const { t  } = (0,esm/* useTranslation */.$G)();
    const { themeApp  } = (0,react.useContext)(context/* AppContext */.Il);
    const [searchValue, setSearchValue] = (0,react.useState)("");
    const onChange = (e)=>{
        var _e_target;
        setSearchValue(e === null || e === void 0 ? void 0 : (_e_target = e.target) === null || _e_target === void 0 ? void 0 : _e_target.value);
    };
    const { data  } = (0,query_fn/* useQueryGetGameFollow */.dZ)(open);
    const { mutate  } = (0,game/* useMutationFollowGame */.dV)();
    const onFollowGame = (_data)=>{
        mutate(_data);
    };
    const newfollowingList = ()=>{
        var _searchValue_trim;
        if (!!((_searchValue_trim = searchValue === null || searchValue === void 0 ? void 0 : searchValue.trim()) === null || _searchValue_trim === void 0 ? void 0 : _searchValue_trim.length)) {
            var _data_game;
            return ((_data_game = data === null || data === void 0 ? void 0 : data.game) !== null && _data_game !== void 0 ? _data_game : []).filter((game)=>(0,helpers_function/* removeVietnameseTones */.CQ)(game.game_name).toLowerCase().includes((0,helpers_function/* removeVietnameseTones */.CQ)(searchValue).toLowerCase()));
        } else return data === null || data === void 0 ? void 0 : data.game;
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(dialog/* Dialog */.Vq, {
        open: open,
        onOpenChange: onClose,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(dialog/* DialogContent */.cZ, {
            className: "sm:rounded-[24px] rounded-[24px] w-[90vw] md:max-w-[480px] p-0 dark:bg-bg-02",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(dialog/* DialogHeader */.fK, {
                    className: "w-full flex items-center justify-between flex-row border-b-[1px] border-black/10 py-[24px] px-[32px]",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                            className: "Nunito-700 text-[16px] text-bg-01 dark:text-white",
                            children: t("profile.follow_game")
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "cursor-pointer",
                            onClick: onClose,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(IconClose/* IconClose */.b, {})
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "w-full px-[24px] pb-[32px]",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "flex items-center justify-between border-b-[1px] dark:border-0 gap-4 py-3 mb-4",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(icon_tsx/* IconSearch */.jV, {
                                    fill: themeApp === "dark" ? "#fff" : "#100D28"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                    type: "text",
                                    value: searchValue,
                                    className: "flex-1 text-sm border-0 outline-none dark:text-white dark:bg-transparent",
                                    placeholder: "T\xecm kiếm Game bạn đang theo d\xf5i",
                                    onChange: onChange
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* ScrollArea */.xr, {
                            className: "max-h-80 h-fit overflow-auto space-y-[12px]",
                            children: ((_newfollowingList = newfollowingList()) === null || _newfollowingList === void 0 ? void 0 : _newfollowingList.length) ? (_newfollowingList1 = newfollowingList()) === null || _newfollowingList1 === void 0 ? void 0 : _newfollowingList1.map((item, index)=>{
                                var _item_rating;
                                /*#__PURE__*/ return (0,jsx_runtime.jsxs)("div", {
                                    className: "flex items-center justify-between w-full py-2",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: "flex items-center gap-3",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                    src: item === null || item === void 0 ? void 0 : item.icon,
                                                    alt: "avatar",
                                                    width: 56,
                                                    height: 56,
                                                    className: "object-cover rounded-[16px]"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                    className: "flex flex-col gap-2",
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                            className: "flex-1 text-base Nunito-700 text-bg-01 dark:text-white",
                                                            children: item === null || item === void 0 ? void 0 : item.game_name
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                            className: "flex gap-[6px] items-center",
                                                            children: [
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                    className: "w-[14px] h-[14px] flex items-start justify-center",
                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
                                                                        width: "12",
                                                                        height: "12",
                                                                        viewBox: "0 0 12 12",
                                                                        fill: "none",
                                                                        xmlns: "http://www.w3.org/2000/svg",
                                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                                            d: "M4.85378 0.908161C5.32318 -0.0807139 6.67943 -0.0807157 7.14883 0.908159L7.96007 2.61719C8.14647 3.00987 8.50678 3.28205 8.92358 3.34502L10.7376 3.61908C11.7872 3.77765 12.2063 5.11874 11.4468 5.88847L10.1342 7.21876C9.83257 7.52443 9.69494 7.96482 9.76614 8.39642L10.076 10.2748C10.2553 11.3617 9.15807 12.1905 8.21927 11.6774L6.59678 10.7905C6.22399 10.5867 5.77862 10.5867 5.40582 10.7905L3.78333 11.6774C2.84453 12.1905 1.7473 11.3617 1.92659 10.2748L2.23646 8.39642C2.30766 7.96482 2.17003 7.52443 1.86843 7.21877L0.555813 5.88847C-0.203693 5.11874 0.21541 3.77765 1.26502 3.61908L3.07902 3.34502C3.49582 3.28205 3.85613 3.00987 4.04253 2.61719L4.85378 0.908161Z",
                                                                            fill: "#7673E6"
                                                                        })
                                                                    })
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                    className: "text-xs Nunito-400 text-neutral dark:text-neutral-08",
                                                                    children: item === null || item === void 0 ? void 0 : (_item_rating = item.rating) === null || _item_rating === void 0 ? void 0 : _item_rating.total
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                    className: "w-[4px] h-[4px] bg-neutral rounded-full dark:bg-white"
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                    className: "text-xs Nunito-400 text-neutral dark:text-neutral-08",
                                                                    children: item === null || item === void 0 ? void 0 : item.developer
                                                                })
                                                            ]
                                                        })
                                                    ]
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(ui_button/* Button */.z, {
                                            variant: "none",
                                            className: "outline-none bg-transparent text-neutral-06 h-[27px] px-[12px] flex items-center justify-center border-[1px] border-neutral-06 rounded-[8px] dark:text-neutral-08",
                                            onClick: ()=>{
                                                onFollowGame({
                                                    game_id: item === null || item === void 0 ? void 0 : item.id
                                                });
                                            },
                                            children: t("profile.unfollow")
                                        })
                                    ]
                                }, index);
                            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "w-full flex items-center justify-center h-[200px]",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(data_empty/* DataEmpty */.$, {
                                    title: t("profile.no_data")
                                })
                            })
                        })
                    ]
                })
            ]
        })
    });
};

;// CONCATENATED MODULE: ./app/containers/users/normal-user/modal/index.ts



;// CONCATENATED MODULE: ./app/containers/users/common/component/Overview.tsx








const Overview = ()=>{
    const { t  } = (0,esm/* useTranslation */.$G)();
    const router = (0,next_router.useRouter)();
    const { userInfo  } = (0,react.useContext)(context/* AppContext */.Il);
    const userId = (0,react.useMemo)(()=>{
        var _router_query;
        return router === null || router === void 0 ? void 0 : (_router_query = router.query) === null || _router_query === void 0 ? void 0 : _router_query.id;
    }, [
        router
    ]);
    const { data: otherUser  } = (0,query_fn/* useQueryGetProfileById */.bK)(userId !== (userInfo === null || userInfo === void 0 ? void 0 : userInfo.userid) && userId !== (userInfo === null || userInfo === void 0 ? void 0 : userInfo.alias) ? String(userId) : undefined);
    const dataUser = userId !== (userInfo === null || userInfo === void 0 ? void 0 : userInfo.userid) && userId !== (userInfo === null || userInfo === void 0 ? void 0 : userInfo.alias) && !!otherUser ? otherUser : userInfo;
    const [showModalUser, setShowModalUser] = (0,react.useState)(false);
    const [showModalPartner, setShowModalPartner] = (0,react.useState)(false);
    const [showModalGameFollowing, setShowModalGameFollowing] = (0,react.useState)(false);
    const { data  } = (0,query_fn/* useQueryGetGameFollow */.dZ)(!(dataUser === null || dataUser === void 0 ? void 0 : dataUser.authentic));
    const formatNumber = (num)=>{
        return Intl.NumberFormat("en-US", {
            notation: "compact",
            maximumFractionDigits: 1
        }).format(num);
    };
    const onNavigateToTab = (type)=>{
        var _router_query;
        router.push({
            pathname: router.pathname,
            query: {
                tab: userId !== (userInfo === null || userInfo === void 0 ? void 0 : userInfo.userid) && userId !== (userInfo === null || userInfo === void 0 ? void 0 : userInfo.alias) ? "other-partner-".concat(type) : "partner-".concat(type),
                id: router === null || router === void 0 ? void 0 : (_router_query = router.query) === null || _router_query === void 0 ? void 0 : _router_query.id
            }
        });
    };
    const contentPartner = ()=>{
        var _dataUser_total_follow, _dataUser_total_news;
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "w-full border border-black/10 bg-bg-02-text-box py-[10px] px-4 flex items-center justify-around rounded-[16px] cursor-pointer max-w-[288px] m-auto dark:bg-[rgba(240,242,245,0.1)]",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "flex flex-col items-center justify-center",
                    onClick: ()=>{
                        if (userId === (userInfo === null || userInfo === void 0 ? void 0 : userInfo.userid) || userId === (userInfo === null || userInfo === void 0 ? void 0 : userInfo.alias)) {
                            setShowModalPartner(true);
                        }
                    },
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                            className: "Nunito-700 text-bg-01 text-[16px] dark:text-white",
                            children: formatNumber(Number((_dataUser_total_follow = dataUser === null || dataUser === void 0 ? void 0 : dataUser.total_follow) !== null && _dataUser_total_follow !== void 0 ? _dataUser_total_follow : 0))
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                            className: "text-sm text-neutral-01 Nunito-500",
                            children: t("profile.overview_follower")
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "w-[1px] h-[32px] bg-black/10"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "flex flex-col items-center justify-center",
                    onClick: ()=>onNavigateToTab("post"),
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                            className: "Nunito-700 text-bg-01 text-[16px] dark:text-white",
                            children: formatNumber(Number((_dataUser_total_news = dataUser === null || dataUser === void 0 ? void 0 : dataUser.total_news) !== null && _dataUser_total_news !== void 0 ? _dataUser_total_news : 0))
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                            className: "text-sm text-neutral-01 Nunito-500",
                            children: t("common.post")
                        })
                    ]
                })
            ]
        });
    };
    const contentNormalUser = ()=>{
        var _dataUser_total_friend, _data_totalFollow;
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "w-full border border-black/10 bg-bg-02-text-box py-[10px] px-4 flex items-center justify-around rounded-[16px] dark:bg-[rgba(240,242,245,0.1)]",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "flex flex-col items-center justify-center cursor-pointer",
                    onClick: ()=>{
                        if (userId === (userInfo === null || userInfo === void 0 ? void 0 : userInfo.userid) || userId === (userInfo === null || userInfo === void 0 ? void 0 : userInfo.alias)) {
                            setShowModalUser(true);
                        }
                    },
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                            className: "Nunito-700 text-bg-01 text-[16px] dark:text-white",
                            children: formatNumber(Number((_dataUser_total_friend = dataUser === null || dataUser === void 0 ? void 0 : dataUser.total_friend) !== null && _dataUser_total_friend !== void 0 ? _dataUser_total_friend : 0))
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                            className: "text-sm text-neutral-01 Nunito-500",
                            children: t("profile.friend")
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "w-[1px] h-[32px] bg-black/10"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "flex flex-col items-center justify-center cursor-pointer",
                    onClick: ()=>{
                        if (userId === (userInfo === null || userInfo === void 0 ? void 0 : userInfo.userid) || userId === (userInfo === null || userInfo === void 0 ? void 0 : userInfo.alias)) {
                            setShowModalGameFollowing(true);
                        }
                    },
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                            className: "Nunito-700 text-bg-01 text-[16px] dark:text-white",
                            children: formatNumber(Number((_data_totalFollow = data === null || data === void 0 ? void 0 : data.totalFollow) !== null && _data_totalFollow !== void 0 ? _data_totalFollow : 0))
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                            className: "text-sm text-neutral-01 Nunito-500",
                            children: "Games"
                        })
                    ]
                })
            ]
        });
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "w-full mt-[16px] lg:mt-[48px]",
        children: [
            (dataUser === null || dataUser === void 0 ? void 0 : dataUser.authentic) ? contentPartner() : contentNormalUser(),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ModalFollower, {
                open: showModalPartner,
                onClose: ()=>setShowModalPartner(false)
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ModalFriend, {
                open: showModalUser,
                onClose: ()=>setShowModalUser(false)
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ModalGameFollowing, {
                open: showModalGameFollowing,
                onClose: ()=>setShowModalGameFollowing(false)
            })
        ]
    });
};


/***/ }),

/***/ 53064:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "o": function() { return /* binding */ EndTimeFilter; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(41844);
/* harmony import */ var _app_components_icon_tsx_IconCalendar__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(20450);
/* harmony import */ var _app_components_ui_button__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(34428);
/* harmony import */ var _app_components_ui_calendar__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(87422);
/* harmony import */ var _app_components_ui_dropdown_menu__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(27357);
/* harmony import */ var _app_components_ui_scroll_area__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(36128);
/* harmony import */ var _app_configs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(54254);
/* harmony import */ var _app_containers_create_post_add_on_CustomSelectMontYear__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(73126);
/* harmony import */ var moment__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(30381);
/* harmony import */ var moment__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(moment__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var next_i18next__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(93378);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(55784);
/* harmony import */ var react_hook_form__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(87536);












const EndTimeFilter = (param)=>{
    let { open , onChange  } = param;
    const { watch , setValue  } = (0,react_hook_form__WEBPACK_IMPORTED_MODULE_11__/* .useFormContext */ .Gc)();
    const { t  } = (0,next_i18next__WEBPACK_IMPORTED_MODULE_9__/* .useTranslation */ .$G)();
    const selectEndTime = watch("end_date", undefined);
    const handleDaySelectTime = (date)=>{
        setValue("end_date", date);
        onChange();
    };
    const content = (0,react__WEBPACK_IMPORTED_MODULE_10__.useMemo)(()=>{
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_app_components_ui_dropdown_menu__WEBPACK_IMPORTED_MODULE_4__/* .DropdownMenu */ .h_, {
            open: open,
            onOpenChange: onChange,
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_app_components_ui_dropdown_menu__WEBPACK_IMPORTED_MODULE_4__/* .DropdownMenuTrigger */ .$F, {
                    asChild: true,
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_app_components_ui_button__WEBPACK_IMPORTED_MODULE_2__/* .Button */ .z, {
                        variant: "none",
                        className: "bg-disable w-full text-neutral flex justify-between items-center py-[8px] dark:text-main-white border-b dark:border-neutral-07 rounded-none",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                children: selectEndTime ? moment__WEBPACK_IMPORTED_MODULE_8___default()(selectEndTime).format(_app_configs__WEBPACK_IMPORTED_MODULE_6__/* .DATE_FORMAT */ .zT) : t("profile.to_date")
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_app_components_icon_tsx_IconCalendar__WEBPACK_IMPORTED_MODULE_1__/* .IconCalendar */ .j, {})
                        ]
                    })
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_app_components_ui_dropdown_menu__WEBPACK_IMPORTED_MODULE_4__/* .DropdownMenuContent */ .AW, {
                    className: "w-[276px]",
                    align: "end",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_app_components_ui_scroll_area__WEBPACK_IMPORTED_MODULE_5__/* .ScrollArea */ .x, {
                        className: "h-fit",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_app_components_ui_calendar__WEBPACK_IMPORTED_MODULE_3__/* .Calendar */ .f, {
                            mode: "single",
                            selected: selectEndTime,
                            onSelect: handleDaySelectTime,
                            className: "p-0 rounded-md",
                            showOutsideDays: true,
                            captionLayout: "dropdown",
                            fromYear: _app_configs__WEBPACK_IMPORTED_MODULE_6__/* .FROM_YEAR */ .cB,
                            toYear: _app_configs__WEBPACK_IMPORTED_MODULE_6__/* .END_YEAR */ .As,
                            components: {
                                Head: ()=>/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_app_containers_create_post_add_on_CustomSelectMontYear__WEBPACK_IMPORTED_MODULE_7__/* .CustomSelectMonthYear */ .k, {})
                            }
                        })
                    })
                })
            ]
        });
    }, [
        open
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: content
    });
};


/***/ }),

/***/ 79786:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "n": function() { return /* binding */ FilterPostEvent; }
});

// EXTERNAL MODULE: ./node_modules/next/dist/compiled/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(41844);
// EXTERNAL MODULE: ./app/components/ui/button.tsx
var ui_button = __webpack_require__(34428);
// EXTERNAL MODULE: ./app/components/ui/dropdown-menu.tsx + 2 modules
var dropdown_menu = __webpack_require__(27357);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/react/index.js
var react = __webpack_require__(55784);
// EXTERNAL MODULE: ./node_modules/next-i18next/dist/esm/index.js + 41 modules
var esm = __webpack_require__(93378);
// EXTERNAL MODULE: ./node_modules/react-hook-form/dist/index.esm.mjs
var index_esm = __webpack_require__(87536);
;// CONCATENATED MODULE: ./app/containers/users/common/filter-post/ProfileSortFilter.tsx





const ProfileSortFilter = ()=>{
    const { t  } = (0,esm/* useTranslation */.$G)();
    const { setValue , watch  } = (0,index_esm/* useFormContext */.Gc)();
    const watchSort = watch("sort", -1);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(dropdown_menu/* DropdownMenuItem */.Xi, {
                className: "".concat(watchSort === -1 ? "bg-bg-disable dark:bg-[#F1F1FC1A] text-main-01" : "", " focus:bg-bg-disable dark:focus:bg-[#F1F1FC1A] focus:text-main-01 bold-600--700 text-sm text-left flex px-4 py-3 rounded-[8px]"),
                onClick: ()=>setValue("sort", -1),
                children: t("group.latest")
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(dropdown_menu/* DropdownMenuItem */.Xi, {
                className: "".concat(watchSort === 1 ? "bg-bg-disable dark:bg-[#F1F1FC1A] text-main-01" : "", "focus:bg-bg-disable dark:focus:bg-[#F1F1FC1A] focus:text-main-01 bold-600--700 text-sm text-left flex px-4 py-3 rounded-[8px]"),
                onClick: ()=>setValue("sort", 1),
                children: t("group.oldest")
            })
        ]
    });
};

;// CONCATENATED MODULE: ./app/containers/users/common/filter-post/FilterPostEvent.tsx






const FilterPostEvent = ()=>{
    const { t  } = (0,esm/* useTranslation */.$G)();
    const [openFilter, setOpenFilter] = (0,react.useState)(false);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(dropdown_menu/* DropdownMenu */.h_, {
        open: openFilter,
        onOpenChange: ()=>setOpenFilter(false),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(dropdown_menu/* DropdownMenuTrigger */.$F, {
                asChild: true,
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(ui_button/* Button */.z, {
                    variant: "none",
                    className: "flex items-center gap-[8px] bg-bg-disable dark:bg-white/10 text-main-01 outline-none focus:outline-none active:outline-none rounded-[12px]",
                    onClick: ()=>setOpenFilter(true),
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                            className: "hidden md:block",
                            children: [
                                t("profile.filter_by"),
                                "\xa0"
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
                                width: "20",
                                height: "20",
                                viewBox: "0 0 20 20",
                                fill: "none",
                                xmlns: "http://www.w3.org/2000/svg",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                    d: "M10 5H17.5M10 10H15M10 15H12.5M2.5 13.0208L3.75432 14.4319C4.4173 15.1778 5.5827 15.1778 6.24568 14.4319L7.5 13.0208M5 15V5",
                                    stroke: "#7673E6",
                                    strokeWidth: "1.5",
                                    strokeLinecap: "round"
                                })
                            })
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(dropdown_menu/* DropdownMenuContent */.AW, {
                align: "end",
                className: "w-[120px] rounded-[16px] p-2 overflow-visible dark:bg-[#30303A]",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ProfileSortFilter, {})
            })
        ]
    });
};


/***/ }),

/***/ 25193:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "M": function() { return /* binding */ StartTimeFilter; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(41844);
/* harmony import */ var _app_components_icon_tsx_IconCalendar__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(20450);
/* harmony import */ var _app_components_ui_button__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(34428);
/* harmony import */ var _app_components_ui_calendar__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(87422);
/* harmony import */ var _app_components_ui_dropdown_menu__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(27357);
/* harmony import */ var _app_components_ui_scroll_area__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(36128);
/* harmony import */ var _app_configs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(54254);
/* harmony import */ var _app_containers_create_post_add_on_CustomSelectMontYear__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(73126);
/* harmony import */ var moment__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(30381);
/* harmony import */ var moment__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(moment__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var next_i18next__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(93378);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(55784);
/* harmony import */ var react_hook_form__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(87536);












const StartTimeFilter = (param)=>{
    let { open , onChange  } = param;
    const { watch , setValue  } = (0,react_hook_form__WEBPACK_IMPORTED_MODULE_11__/* .useFormContext */ .Gc)();
    const { t  } = (0,next_i18next__WEBPACK_IMPORTED_MODULE_9__/* .useTranslation */ .$G)();
    const selectedStartTime = watch("start_date", undefined);
    const handleDaySelectStartTime = (date)=>{
        setValue("start_date", date);
        onChange();
    };
    const content = (0,react__WEBPACK_IMPORTED_MODULE_10__.useMemo)(()=>{
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_app_components_ui_dropdown_menu__WEBPACK_IMPORTED_MODULE_4__/* .DropdownMenu */ .h_, {
            open: open,
            onOpenChange: onChange,
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_app_components_ui_dropdown_menu__WEBPACK_IMPORTED_MODULE_4__/* .DropdownMenuTrigger */ .$F, {
                    asChild: true,
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_app_components_ui_button__WEBPACK_IMPORTED_MODULE_2__/* .Button */ .z, {
                        variant: "none",
                        className: "bg-disable w-full text-neutral flex justify-between items-center py-[8px] dark:text-main-white border-b dark:border-neutral-07 rounded-none",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                children: selectedStartTime ? moment__WEBPACK_IMPORTED_MODULE_8___default()(selectedStartTime).format(_app_configs__WEBPACK_IMPORTED_MODULE_6__/* .DATE_FORMAT */ .zT) : t("profile.from_date")
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_app_components_icon_tsx_IconCalendar__WEBPACK_IMPORTED_MODULE_1__/* .IconCalendar */ .j, {})
                        ]
                    })
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_app_components_ui_dropdown_menu__WEBPACK_IMPORTED_MODULE_4__/* .DropdownMenuContent */ .AW, {
                    className: "w-[276px]",
                    align: "end",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_app_components_ui_scroll_area__WEBPACK_IMPORTED_MODULE_5__/* .ScrollArea */ .x, {
                        className: "h-fit",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_app_components_ui_calendar__WEBPACK_IMPORTED_MODULE_3__/* .Calendar */ .f, {
                            mode: "single",
                            selected: selectedStartTime,
                            onSelect: handleDaySelectStartTime,
                            className: "p-0 rounded-md",
                            showOutsideDays: true,
                            captionLayout: "dropdown",
                            fromYear: _app_configs__WEBPACK_IMPORTED_MODULE_6__/* .FROM_YEAR */ .cB,
                            toYear: _app_configs__WEBPACK_IMPORTED_MODULE_6__/* .END_YEAR */ .As,
                            components: {
                                Head: ()=>/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_app_containers_create_post_add_on_CustomSelectMontYear__WEBPACK_IMPORTED_MODULE_7__/* .CustomSelectMonthYear */ .k, {})
                            }
                        })
                    })
                })
            ]
        });
    }, [
        open
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: content
    });
};


/***/ }),

/***/ 75025:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "nm": function() { return /* reexport */ FilterPostEvent/* FilterPostEvent */.n; },
  "Fo": function() { return /* reexport */ HelpCenter; },
  "d_": function() { return /* reexport */ SettingUserInfomation; },
  "wd": function() { return /* reexport */ SettingWeb; }
});

// UNUSED EXPORTS: ActionOtherUser, AvatarAndName, FavoriteHashtag, InviteCode, ModalUploadImage, Overview, RequireVerifiedModal

// EXTERNAL MODULE: ./app/containers/users/common/component/ActionOtherUser.tsx
var ActionOtherUser = __webpack_require__(14699);
// EXTERNAL MODULE: ./app/containers/users/common/component/AvatarAndName.tsx
var AvatarAndName = __webpack_require__(56588);
// EXTERNAL MODULE: ./app/containers/users/common/component/InviteCode.tsx
var InviteCode = __webpack_require__(2027);
// EXTERNAL MODULE: ./app/containers/users/common/component/Overview.tsx + 8 modules
var Overview = __webpack_require__(45612);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(41844);
// EXTERNAL MODULE: ./app/components/ui/button.tsx
var ui_button = __webpack_require__(34428);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/react/index.js
var react = __webpack_require__(55784);
// EXTERNAL MODULE: ./app/context/index.ts + 2 modules
var context = __webpack_require__(17986);
// EXTERNAL MODULE: ./app/configs/index.ts + 3 modules
var configs = __webpack_require__(54254);
;// CONCATENATED MODULE: ./app/containers/users/common/component/FavoriteHashtag.tsx





const FavoriteHashtag = ()=>{
    var _userInfo_topic_interest;
    const { userInfo , setOpenModal  } = useContext(AppContext);
    const onChangeShowEdit = ()=>{
        setOpenModal(OPEN_MODAL.EDIT_HASHTAG);
    };
    return /*#__PURE__*/ _jsx(_Fragment, {
        children: Array.isArray(userInfo === null || userInfo === void 0 ? void 0 : userInfo.topic_interest) && !!(userInfo === null || userInfo === void 0 ? void 0 : (_userInfo_topic_interest = userInfo.topic_interest) === null || _userInfo_topic_interest === void 0 ? void 0 : _userInfo_topic_interest.length) ? /*#__PURE__*/ _jsxs("div", {
            className: "w-full flex items-start justify-between mt-[48px] gap-[12px]",
            children: [
                /*#__PURE__*/ _jsx("div", {
                    className: "flex flex-wrap items-center gap-2",
                    children: React.Children.toArray(userInfo === null || userInfo === void 0 ? void 0 : userInfo.topic_interest.map((item)=>/*#__PURE__*/ _jsxs(Button, {
                            variant: "none",
                            className: "bg-button text-main-01 text-sm px-2 py-[2px] max-h-[32px] flex items-center dark:bg-[#EFEFFF1A]",
                            children: [
                                "#",
                                item
                            ]
                        })))
                }),
                /*#__PURE__*/ _jsx("div", {
                    className: "w-[1px] h-[16px] bg-black/10"
                }),
                /*#__PURE__*/ _jsx("div", {
                    className: "cursor-pointer",
                    onClick: onChangeShowEdit,
                    children: /*#__PURE__*/ _jsx("svg", {
                        width: "21",
                        height: "20",
                        viewBox: "0 0 21 20",
                        fill: "none",
                        xmlns: "http://www.w3.org/2000/svg",
                        children: /*#__PURE__*/ _jsx("path", {
                            d: "M3 17.5H18M11.987 4.42643C11.987 4.42643 11.987 5.78861 13.3492 7.1508C14.7114 8.51299 16.0736 8.51299 16.0736 8.51299M6.59969 14.9901L9.46028 14.5814C9.87291 14.5225 10.2553 14.3313 10.55 14.0365L17.4358 7.1508C18.1881 6.39848 18.1881 5.17874 17.4358 4.42642L16.0736 3.06424C15.3213 2.31192 14.1015 2.31192 13.3492 3.06424L6.46347 9.94997C6.16873 10.2447 5.97754 10.6271 5.91859 11.0397L5.50994 13.9003C5.41913 14.536 5.964 15.0809 6.59969 14.9901Z",
                            stroke: "#7673E6",
                            strokeLinecap: "round"
                        })
                    })
                })
            ]
        }) : null
    });
};

// EXTERNAL MODULE: ./app/hooks/useGAEventsTracker.ts
var useGAEventsTracker = __webpack_require__(64800);
// EXTERNAL MODULE: ./node_modules/next-i18next/dist/esm/index.js + 41 modules
var esm = __webpack_require__(93378);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
;// CONCATENATED MODULE: ./app/containers/users/common/component/HelpCenter.tsx




const HelpCenter = ()=>{
    const { t  } = (0,esm/* useTranslation */.$G)();
    const router = (0,next_router.useRouter)();
    const GAEventsTrackerHelpCenter = (0,useGAEventsTracker/* default */.Z)("HelpCenter");
    const onNavigateToHelpCenter = ()=>{
        GAEventsTrackerHelpCenter("Help_center_view_main");
        router.push("/help-center");
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "px-[16px] py-[24px] rounded-l-[24px] fixed right-0 top-[50%] z-10 bg-bg-button dark:bg-[#2F2F39] cursor-pointer hover:px-[32px] user-help-center overflow-hidden hidden md:block",
        onClick: onNavigateToHelpCenter,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "relative flex items-center gap-[8px] text-[14px] Nunito-700 text-main-01 whitespace-nowrap",
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
                width: "32",
                height: "32",
                viewBox: "0 0 32 32",
                fill: "none",
                xmlns: "http://www.w3.org/2000/svg",
                className: "ml-auto mr-0",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        opacity: "0.4",
                        fillRule: "evenodd",
                        clipRule: "evenodd",
                        d: "M9.09766 22C10.3179 25.4956 13.6105 28 17.4807 28H22.9009H26.3696C28.006 28 29.3326 26.6568 29.3326 25V20.5C29.3326 16.2149 26.7973 12.5293 23.1627 10.897C23.3222 11.5717 23.4067 12.2758 23.4067 13C23.4067 17.9706 19.427 22 14.5178 22H9.09766Z",
                        fill: "#7673E6"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fillRule: "evenodd",
                        clipRule: "evenodd",
                        d: "M13.0364 4H14.5179C18.7119 4 22.2274 6.94088 23.1628 10.897C23.3223 11.5717 23.4068 12.2758 23.4068 13C23.4068 17.9706 19.4271 22 14.5179 22H9.09774H5.62898C3.99258 22 2.66602 20.6569 2.66602 19V14.5C2.66602 8.70101 7.30899 4 13.0364 4ZM13.3327 9C12.4122 9 11.666 9.74619 11.666 10.6667C11.666 11.219 11.2183 11.6667 10.666 11.6667C10.1137 11.6667 9.66602 11.219 9.66602 10.6667C9.66602 8.64162 11.3076 7 13.3327 7C15.3577 7 16.9993 8.64162 16.9993 10.6667C16.9993 12.6917 15.3577 14.3333 13.3327 14.3333C12.7804 14.3333 12.3327 13.8856 12.3327 13.3333C12.3327 12.781 12.7804 12.3333 13.3327 12.3333C14.2532 12.3333 14.9993 11.5871 14.9993 10.6667C14.9993 9.74619 14.2532 9 13.3327 9ZM14.666 17.3333C14.666 18.0697 14.0691 18.6667 13.3327 18.6667C12.5963 18.6667 11.9993 18.0697 11.9993 17.3333C11.9993 16.597 12.5963 16 13.3327 16C14.0691 16 14.666 16.597 14.666 17.3333Z",
                        fill: "#7673E6"
                    })
                ]
            })
        })
    });
};

;// CONCATENATED MODULE: ./app/containers/users/common/component/index.ts







// EXTERNAL MODULE: ./app/containers/users/common/filter-post/FilterPostEvent.tsx + 1 modules
var FilterPostEvent = __webpack_require__(79786);
;// CONCATENATED MODULE: ./app/containers/users/common/filter-post/index.ts


// EXTERNAL MODULE: ./app/containers/users/common/modal/ModalUploadImage.tsx + 6 modules
var ModalUploadImage = __webpack_require__(74542);
// EXTERNAL MODULE: ./app/containers/users/common/modal/RequireVerifiedModal.tsx
var RequireVerifiedModal = __webpack_require__(90591);
;// CONCATENATED MODULE: ./app/containers/users/common/modal/index.ts



// EXTERNAL MODULE: ./app/components/icon-tsx/IconCopied.tsx
var IconCopied = __webpack_require__(60303);
// EXTERNAL MODULE: ./app/components/icon-tsx/IconNonCopy.tsx
var IconNonCopy = __webpack_require__(27298);
// EXTERNAL MODULE: ./node_modules/jwt-decode/build/esm/index.js
var build_esm = __webpack_require__(61202);
// EXTERNAL MODULE: ./node_modules/@react-spring/web/dist/react-spring_web.modern.mjs + 3 modules
var react_spring_web_modern = __webpack_require__(66005);
// EXTERNAL MODULE: ./app/components/address-merchandise/ModalAddressMerchandise.tsx + 4 modules
var ModalAddressMerchandise = __webpack_require__(82904);
// EXTERNAL MODULE: ./app/components/data-empty/index.tsx + 1 modules
var data_empty = __webpack_require__(98269);
// EXTERNAL MODULE: ./app/components/icon-tsx/IconClose.tsx
var IconClose = __webpack_require__(51337);
// EXTERNAL MODULE: ./app/components/ui/dialog.tsx
var dialog = __webpack_require__(76500);
// EXTERNAL MODULE: ./app/components/ui/dropdown-menu.tsx + 2 modules
var dropdown_menu = __webpack_require__(27357);
;// CONCATENATED MODULE: ./app/containers/users/common/component/OptionMerchandiseAddress.tsx





const OptionMerchandiseAddress = (param)=>{
    let { item , onSetAddressDefault , onDeleteAddress , onUpdateAddress  } = param;
    const { t  } = (0,esm/* useTranslation */.$G)();
    const { themeApp  } = (0,react.useContext)(context/* AppContext */.Il);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(dropdown_menu/* DropdownMenu */.h_, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(dropdown_menu/* DropdownMenuTrigger */.$F, {
                asChild: true,
                className: "outline-0 mt-0",
                onClick: (e)=>{
                    e.stopPropagation();
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "cursor-pointer w-[22px] h-[22px] rounded-[8px] bg-bg-button dark:bg-white/10 flex justify-center items-center rotate-90",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
                        xmlns: "http://www.w3.org/2000/svg",
                        width: "13",
                        height: "3",
                        viewBox: "0 0 13 3",
                        fill: "none",
                        className: "w-[10px] h-[3px]",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                            fillRule: "evenodd",
                            clipRule: "evenodd",
                            d: "M0 1.25C0 1.94036 0.559644 2.5 1.25 2.5C1.94036 2.5 2.5 1.94036 2.5 1.25C2.5 0.559644 1.94036 0 1.25 0C0.559644 0 0 0.559644 0 1.25ZM6.25 2.5C5.55964 2.5 5 1.94036 5 1.25C5 0.559644 5.55964 0 6.25 0C6.94036 0 7.5 0.559644 7.5 1.25C7.5 1.94036 6.94036 2.5 6.25 2.5ZM11.25 2.5C10.5596 2.5 10 1.94036 10 1.25C10 0.559644 10.5596 0 11.25 0C11.9404 0 12.5 0.559644 12.5 1.25C12.5 1.94036 11.9404 2.5 11.25 2.5Z",
                            fill: themeApp === "dark" ? "#fff" : "#28303F"
                        })
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(dropdown_menu/* DropdownMenuContent */.AW, {
                className: "text-left",
                align: "end",
                children: [
                    !(item === null || item === void 0 ? void 0 : item.default) && /*#__PURE__*/ (0,jsx_runtime.jsx)(dropdown_menu/* DropdownMenuItem */.Xi, {
                        className: "justify-start focus:bg-bg-disable focus:text-main-01 Nunito-600 text-[16px] text-center flex px-4 py-3 rounded-[8px]",
                        onClick: ()=>{
                            onSetAddressDefault(item);
                        },
                        children: t("merchandise.set_default_address")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(dropdown_menu/* DropdownMenuItem */.Xi, {
                        className: "justify-start focus:bg-bg-disable focus:text-main-01 Nunito-600 text-[16px] text-center flex px-4 py-3 rounded-[8px]",
                        onClick: ()=>onUpdateAddress(item),
                        children: t("common.edit_sth")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(dropdown_menu/* DropdownMenuItem */.Xi, {
                        className: "items-start focus:bg-bg-disable focus:text-main-01 Nunito-600 text-[16px] text-center flex px-4 py-3 rounded-[8px]",
                        onClick: ()=>onDeleteAddress(item.id),
                        children: t("merchandise.delete_address")
                    })
                ]
            })
        ]
    });
};

;// CONCATENATED MODULE: ./app/containers/users/common/component/ItemAddress.tsx



const OneItemAddress = (param)=>{
    let { border , address , onSetAddressDefault , onDeleteAddress , onUpdateAddress  } = param;
    const { t  } = (0,esm/* useTranslation */.$G)();
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "w-full space-y-[6px] py-[16px] ".concat(border ? "border-b border-black/10" : ""),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "flex items-center justify-between gap-[12px] group",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        className: "text-base text-bg-01 Nunito-600 dark:text-white flex-1",
                        children: address.fullname
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "flex items-center gap-[12px]",
                        children: [
                            address.default ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "rounded-[8px] bg-bg-disable dark:bg-white/10 h-[24px] px-[12px] text-main-01 text-xs flex items-center justify-center",
                                children: t("merchandise.default_address")
                            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {}),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "relative w-fit",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(OptionMerchandiseAddress, {
                                    item: address,
                                    onSetAddressDefault: onSetAddressDefault,
                                    onDeleteAddress: onDeleteAddress,
                                    onUpdateAddress: onUpdateAddress
                                })
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                className: "text-sm text-neutral-05 Nunito-500",
                children: address.phone
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                className: "text-sm text-neutral-05 Nunito-500",
                children: [
                    address.address,
                    ", ",
                    address.ward,
                    ", ",
                    address.district,
                    ", ",
                    address.city
                ]
            })
        ]
    });
};

;// CONCATENATED MODULE: ./app/containers/users/common/modal/ModalSelectAddressProfile.tsx








const ModalSelectAddressProfile = (param)=>{
    let { open , onClose , onSelectAddNewAddress , listAddress , onDeleteAddress , onSetAddressDefault , onUpdateAddress  } = param;
    const { t  } = (0,esm/* useTranslation */.$G)();
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(dialog/* Dialog */.Vq, {
        open: open,
        onOpenChange: onClose,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(dialog/* DialogContent */.cZ, {
            className: "rounded-[16px] sm:rounded-[16px] w-[90vw] md:w-[480px] p-[24px] dark:bg-bg-02 dark:border-0 max-w-[90vw] md:max-w-[536px] overflow-auto outline-none",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(dialog/* DialogHeader */.fK, {
                    className: "flex flex-row items-center justify-between w-full",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                            className: "Nunito-700 text-[16px] text-bg-01 dark:text-main-white",
                            children: t("merchandise.address_title")
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "cursor-pointer",
                            onClick: onClose,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(IconClose/* IconClose */.b, {})
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "w-full",
                    children: (listAddress === null || listAddress === void 0 ? void 0 : listAddress.length) ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "w-full",
                        children: listAddress.map((item, index)=>{
                            /*#__PURE__*/ return (0,jsx_runtime.jsx)("div", {
                                className: "w-full space-y-[16px]",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(OneItemAddress, {
                                    border: index !== (listAddress === null || listAddress === void 0 ? void 0 : listAddress.length) - 1,
                                    address: item,
                                    onSetAddressDefault: onSetAddressDefault,
                                    onDeleteAddress: onDeleteAddress,
                                    onUpdateAddress: onUpdateAddress
                                })
                            }, item.id);
                        })
                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "flex items-center justify-center min-h-[300px] xs:min-h-[200px]",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(data_empty/* DataEmpty */.$, {})
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(ui_button/* Button */.z, {
                    variant: "main",
                    onClick: onSelectAddNewAddress,
                    children: "Th\xeam địa chỉ giao h\xe0ng mới"
                })
            ]
        })
    });
};

// EXTERNAL MODULE: ./app/components/ui/use-toast.ts
var use_toast = __webpack_require__(2786);
// EXTERNAL MODULE: ./node_modules/@tanstack/react-query/build/modern/QueryClientProvider.js
var QueryClientProvider = __webpack_require__(30202);
// EXTERNAL MODULE: ./app/services/query-fn/merchandise/merchandise-mutation.ts
var merchandise_mutation = __webpack_require__(213);
// EXTERNAL MODULE: ./app/services/query-fn/merchandise/merchandise-query.ts
var merchandise_query = __webpack_require__(29519);
;// CONCATENATED MODULE: ./app/containers/users/common/component/MyMerchandiseAddress.tsx









const MyMerchandiseAddress = ()=>{
    const [openListAddress, setOpenListAddress] = (0,react.useState)(false);
    const [openAddAddress, setOpenAddAddress] = (0,react.useState)(false);
    const [dataSeleted, setDataSelected] = (0,react.useState)();
    const { data: listAddress  } = (0,merchandise_query/* useQueryGetListMerchandiseAddress */.fc)();
    const defaultAddress = (0,react.useCallback)(()=>{
        const defaultItem = listAddress === null || listAddress === void 0 ? void 0 : listAddress.find((item)=>!!item.default);
        if (!!defaultItem) {
            return "".concat(defaultItem === null || defaultItem === void 0 ? void 0 : defaultItem.address, ", ").concat(defaultItem === null || defaultItem === void 0 ? void 0 : defaultItem.ward, ", ").concat(defaultItem === null || defaultItem === void 0 ? void 0 : defaultItem.district, ", ").concat(defaultItem === null || defaultItem === void 0 ? void 0 : defaultItem.city);
        } else return "";
    }, [
        listAddress
    ]);
    const onOpenChangeListAddress = ()=>{
        setOpenListAddress(!openListAddress);
    };
    const onOpenChangeAddAddress = ()=>{
        setOpenAddAddress(!openAddAddress);
    };
    const { toast  } = (0,use_toast/* useToast */.pm)();
    const queryClient = (0,QueryClientProvider/* useQueryClient */.NL)();
    const { mutate: updateAdress  } = (0,merchandise_mutation/* useMutationUpdateAddress */.jY)();
    const { mutate: deleteAddressFn  } = (0,merchandise_mutation/* useMutationDeleteAddress */.J)();
    const onSetAddressDefault = (address)=>{
        updateAdress({
            ...address,
            status: "default"
        }, {
            onSuccess: ()=>{
                toast({
                    variant: "success",
                    title: "Cập nhật th\xe0nh c\xf4ng!"
                });
                queryClient.refetchQueries({
                    queryKey: [
                        configs/* QUERY_KEY.MERCHANDISE_ADDRESS */.lP.MERCHANDISE_ADDRESS
                    ]
                });
            }
        });
    };
    const onDeleteAddress = (id)=>{
        deleteAddressFn({
            id
        }, {
            onSuccess: ()=>{
                toast({
                    variant: "success",
                    title: "Xo\xe1 th\xe0nh c\xf4ng!"
                });
                queryClient.refetchQueries({
                    queryKey: [
                        configs/* QUERY_KEY.MERCHANDISE_ADDRESS */.lP.MERCHANDISE_ADDRESS
                    ]
                });
            }
        });
    };
    const onUpdateAddress = (address)=>{
        setDataSelected(address);
        onOpenChangeAddAddress();
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "flex justify-end flex-1",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "flex items-center justify-center gap-[12px]",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "items-center hidden md:flex gap-[12px]",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                className: "text-sm text-bg-01 Nunito-500 dark:text-white",
                                children: defaultAddress()
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "w-[1px] h-[16px] bg-black/10 dark:bg-neutral-03"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "cursor-pointer flex w-[24px] h-[24px]",
                        onClick: onOpenChangeListAddress,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
                            width: "20",
                            height: "20",
                            viewBox: "0 0 20 20",
                            fill: "none",
                            xmlns: "http://www.w3.org/2000/svg",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                d: "M2.5 17.5H17.5M11.487 4.42643C11.487 4.42643 11.487 5.78861 12.8492 7.1508C14.2114 8.51299 15.5736 8.51299 15.5736 8.51299M6.09969 14.9901L8.96028 14.5814C9.37291 14.5225 9.7553 14.3313 10.05 14.0365L16.9358 7.1508C17.6881 6.39848 17.6881 5.17874 16.9358 4.42642L15.5736 3.06424C14.8213 2.31192 13.6015 2.31192 12.8492 3.06424L5.96347 9.94997C5.66873 10.2447 5.47754 10.6271 5.41859 11.0397L5.00994 13.9003C4.91913 14.536 5.464 15.0809 6.09969 14.9901Z",
                                stroke: "#7673E6",
                                strokeLinecap: "round"
                            })
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ModalSelectAddressProfile, {
                open: openListAddress,
                onClose: onOpenChangeListAddress,
                onSelectAddNewAddress: onOpenChangeAddAddress,
                listAddress: listAddress !== null && listAddress !== void 0 ? listAddress : [],
                onSetAddressDefault: onSetAddressDefault,
                onDeleteAddress: onDeleteAddress,
                onUpdateAddress: onUpdateAddress
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ModalAddressMerchandise/* ModalAddressMerchandise */.u, {
                open: openAddAddress,
                onOpenChange: onOpenChangeAddAddress,
                isEdit: !!(dataSeleted === null || dataSeleted === void 0 ? void 0 : dataSeleted.id),
                dataEdit: dataSeleted
            })
        ]
    });
};

// EXTERNAL MODULE: ./app/services/query-fn/game/index.ts + 1 modules
var game = __webpack_require__(82190);
;// CONCATENATED MODULE: ./app/containers/users/common/setting/SettingInfomation.tsx













const TIME_OUT = 3000;
const SettingUserInfomation = ()=>{
    var _renderListFavorite;
    const router = (0,next_router.useRouter)();
    const { t  } = (0,esm/* useTranslation */.$G)();
    const { userInfo , themeApp , setOpenModal  } = (0,react.useContext)(context/* AppContext */.Il);
    const { isMobile  } = (0,react.useContext)(context/* MobileContext */.zw);
    const LIMIT_HASHTAG = isMobile ? 1 : 5;
    const [copied, setIsCopied] = (0,react.useState)(false);
    const { data: games  } = (0,game/* useQueryGetListGame */.Bu)({
        category: "",
        type: "",
        limit: 100,
        page: 1
    });
    const onChangeShowModal = ()=>{
        setOpenModal(configs/* OPEN_MODAL.SHARE_REFER_CODE */.a6.SHARE_REFER_CODE);
    };
    const onChangeShowEdit = ()=>{
        setOpenModal(configs/* OPEN_MODAL.EDIT_HASHTAG */.a6.EDIT_HASHTAG);
    };
    const onCopyInviteCode = ()=>{
        navigator.clipboard.writeText(userInfo === null || userInfo === void 0 ? void 0 : userInfo.referent_code);
        setIsCopied(true);
    };
    const renderListFavorite = ()=>{
        var _games_filter, _userInfo_topic_interest, _userInfo_topic_interest1;
        const listGameName = !!games && ((_games_filter = games === null || games === void 0 ? void 0 : games.filter((game)=>{
            var _userInfo_games_interest;
            return userInfo === null || userInfo === void 0 ? void 0 : (_userInfo_games_interest = userInfo.games_interest) === null || _userInfo_games_interest === void 0 ? void 0 : _userInfo_games_interest.includes(game.id);
        })) === null || _games_filter === void 0 ? void 0 : _games_filter.map((game)=>{
            return game === null || game === void 0 ? void 0 : game.game_name;
        }));
        if (!!listGameName) return [
            ...userInfo === null || userInfo === void 0 ? void 0 : (_userInfo_topic_interest = userInfo.topic_interest) === null || _userInfo_topic_interest === void 0 ? void 0 : _userInfo_topic_interest.map((item)=>{
                return "#".concat(item === null || item === void 0 ? void 0 : item.replaceAll("#", ""));
            }),
            ...listGameName
        ];
        return (_userInfo_topic_interest1 = userInfo.topic_interest) === null || _userInfo_topic_interest1 === void 0 ? void 0 : _userInfo_topic_interest1.map((item)=>{
            return "#".concat(item === null || item === void 0 ? void 0 : item.replaceAll("#", ""));
        });
    };
    const onSubmitEdit = ()=>{
        if (configs/* isClient */.C5) {
            const token = localStorage.getItem("token");
            if (token) {
                var _decodeToken_data;
                const decodeToken = (0,build_esm/* jwtDecode */.o)(token);
                router.push("https://id.gamota.com/authorize?access_token=".concat(decodeToken === null || decodeToken === void 0 ? void 0 : (_decodeToken_data = decodeToken.data) === null || _decodeToken_data === void 0 ? void 0 : _decodeToken_data.id, "&callback=/user/update_profile&redirect=").concat(window.location.href));
            }
        }
    };
    const fade = (0,react_spring_web_modern/* useSpring */.q_)({
        opacity: 1,
        from: {
            opacity: 0
        },
        delay: 100
    });
    (0,react.useEffect)(()=>{
        const timeout = setTimeout(()=>{
            if (copied) setIsCopied(false);
        }, TIME_OUT);
        return ()=>{
            clearTimeout(timeout);
        };
    }, [
        copied
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(react_spring_web_modern/* animated.div */.q.div, {
        style: fade,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "w-full px-0 md:px-[32px] py-[24px] border-b dark:border-neutral-05",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "flex items-center justify-between w-full gap-[12px]",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                            className: "text-base Nunito-700 text-bg-01 dark:text-white min-w-fit",
                            children: t("profile.info")
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(ui_button/* Button */.z, {
                            variant: "none",
                            className: "p-0 text-main-01",
                            onClick: onSubmitEdit,
                            children: "Edit"
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "w-full",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "flex items-center justify-between w-full gap-[12px]",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                    className: "text-sm Nunito-400 text-neutral dark:text-white min-w-fit",
                                    children: t("profile.fullname")
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                    className: "text-sm Nunito-500 text-bg-01 dark:text-white",
                                    children: userInfo === null || userInfo === void 0 ? void 0 : userInfo.fullname
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "flex items-center justify-between w-full mt-[16px] gap-[12px]",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                    className: "text-sm Nunito-400 text-neutral dark:text-white min-w-fit",
                                    children: "Email"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                    className: "text-sm Nunito-500 text-bg-01 dark:text-white",
                                    children: userInfo === null || userInfo === void 0 ? void 0 : userInfo.email
                                })
                            ]
                        }),
                        !!(userInfo === null || userInfo === void 0 ? void 0 : userInfo.phone) && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "flex items-center justify-between w-full mt-[16px] gap-[12px]",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                    className: "text-sm Nunito-400 text-neutral dark:text-white min-w-fit",
                                    children: t("profile.phone")
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                    className: "text-sm Nunito-500 text-bg-01 dark:text-white",
                                    children: userInfo === null || userInfo === void 0 ? void 0 : userInfo.phone
                                })
                            ]
                        }),
                        !!(userInfo === null || userInfo === void 0 ? void 0 : userInfo.invite_code) && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "flex items-center justify-between w-full mt-[16px] gap-[12px]",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                    className: "text-sm Nunito-400 text-neutral dark:text-white min-w-fit",
                                    children: t("profile.ref_code_title")
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                    className: "text-sm text-bg-01 Nunito-500 dark:text-white",
                                    children: userInfo === null || userInfo === void 0 ? void 0 : userInfo.invite_code
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "flex items-center justify-between w-full mt-[16px] gap-[12px]",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                    className: "text-sm Nunito-400 text-neutral dark:text-white min-w-fit",
                                    children: t("profile.invite_code_title")
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "flex gap-[12px] items-center",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                            className: "text-sm text-bg-01 Nunito-500 dark:text-white",
                                            children: userInfo === null || userInfo === void 0 ? void 0 : userInfo.referent_code
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "cursor-pointer w-fit",
                                            onClick: onCopyInviteCode,
                                            children: copied ? /*#__PURE__*/ (0,jsx_runtime.jsx)(IconCopied/* IconCopied */.i, {}) : /*#__PURE__*/ (0,jsx_runtime.jsx)(IconNonCopy/* IconNonCopy */.x, {
                                                stroke: "#9F9EA9"
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "w-[1px] h-[17px] bg-black/10 dark:bg-neutral-03"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "w-[24px] h-[24px] rounded-[12px] flex items-center justify-center cursor-pointer bg-bg-02-text-box dark:bg-white/10",
                                            onClick: onChangeShowModal,
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
                                                width: "16",
                                                height: "16",
                                                viewBox: "0 0 16 16",
                                                fill: "none",
                                                xmlns: "http://www.w3.org/2000/svg",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                        d: "M8.66602 7.33337L14.1327 1.8667",
                                                        stroke: themeApp === "dark" ? "#fff" : "#585669",
                                                        strokeWidth: "1.5",
                                                        strokeLinecap: "round",
                                                        strokeLinejoin: "round"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                        d: "M14.6668 4.5335V1.3335H11.4668",
                                                        stroke: themeApp === "dark" ? "#fff" : "#585669",
                                                        strokeWidth: "1.5",
                                                        strokeLinecap: "round",
                                                        strokeLinejoin: "round"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                        d: "M7.33398 1.3335H6.00065C2.66732 1.3335 1.33398 2.66683 1.33398 6.00016V10.0002C1.33398 13.3335 2.66732 14.6668 6.00065 14.6668H10.0007C13.334 14.6668 14.6673 13.3335 14.6673 10.0002V8.66683",
                                                        stroke: themeApp === "dark" ? "#fff" : "#585669",
                                                        strokeWidth: "1.5",
                                                        strokeLinecap: "round",
                                                        strokeLinejoin: "round"
                                                    })
                                                ]
                                            })
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "flex items-center justify-between w-full mt-[16px] gap-[12px]",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                    className: "text-sm Nunito-400 text-neutral dark:text-white min-w-fit",
                                    children: t("merchandise.address_title")
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(MyMerchandiseAddress, {})
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "flex items-start justify-between w-full mt-[16px] gap-[12px]",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                    className: "text-sm Nunito-400 text-neutral dark:text-white min-w-fit",
                                    children: t("profile.interest")
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "flex items-start gap-[12px] max-w-[70%]",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "flex flex-wrap items-center justify-end gap-[12px] overflow-auto",
                                                children: (_renderListFavorite = renderListFavorite()) === null || _renderListFavorite === void 0 ? void 0 : _renderListFavorite.slice(0, LIMIT_HASHTAG).map((item, index)=>/*#__PURE__*/ (0,jsx_runtime.jsx)(ui_button/* Button */.z, {
                                                        variant: "none",
                                                        className: "h-[23px] px-[8px] py-[2px] flex items-center justify-center bg-button text-main-01 rounded-[8px] dark:bg-[#EFEFFF1A] min-w-fit overflow-hidden text-left truncate",
                                                        children: item
                                                    }, index))
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "h-[16px] w-[1px] bg-black/10 dark:bg-neutral-03"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(ui_button/* Button */.z, {
                                                variant: "none",
                                                className: "flex items-start p-0 min-w-[24px] w-[24px] h-[24px]",
                                                onClick: onChangeShowEdit,
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
                                                    width: "20",
                                                    height: "20",
                                                    viewBox: "0 0 20 20",
                                                    fill: "none",
                                                    xmlns: "http://www.w3.org/2000/svg",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                        d: "M2.5 17.5H17.5M11.487 4.42643C11.487 4.42643 11.487 5.78861 12.8492 7.1508C14.2114 8.51299 15.5736 8.51299 15.5736 8.51299M6.09969 14.9901L8.96028 14.5814C9.37291 14.5225 9.7553 14.3313 10.05 14.0365L16.9358 7.1508C17.6881 6.39848 17.6881 5.17874 16.9358 4.42642L15.5736 3.06424C14.8213 2.31192 13.6015 2.31192 12.8492 3.06424L5.96347 9.94997C5.66873 10.2447 5.47754 10.6271 5.41859 11.0397L5.00994 13.9003C4.91913 14.536 5.464 15.0809 6.09969 14.9901Z",
                                                        stroke: "#7673E6",
                                                        strokeLinecap: "round"
                                                    })
                                                })
                                            })
                                        ]
                                    })
                                })
                            ]
                        })
                    ]
                })
            ]
        })
    });
};

// EXTERNAL MODULE: ./app/components/header/SelectTheme.tsx
var SelectTheme = __webpack_require__(75075);
// EXTERNAL MODULE: ./app/services/query-fn/user/setting-mutation.ts
var setting_mutation = __webpack_require__(88663);
;// CONCATENATED MODULE: ./app/containers/users/common/setting/SettingWeb.tsx











const SettingWeb = ()=>{
    const { t  } = (0,esm/* useTranslation */.$G)();
    const router = (0,next_router.useRouter)();
    const { userInfo , themeApp  } = (0,react.useContext)(context/* AppContext */.Il);
    const queryClient = (0,QueryClientProvider/* useQueryClient */.NL)();
    const { mutate: mutateUpdateLanguage  } = (0,setting_mutation/* useMutationUpdateLanguage */.h4)();
    const handleChangeLang = async (value)=>{
        mutateUpdateLanguage({
            lang: value
        }, {
            onSettled (data, error, variables, context) {
                queryClient.invalidateQueries({
                    queryKey: [
                        configs/* QUERY_KEY.PROFILE_INFO */.lP.PROFILE_INFO
                    ],
                    refetchType: "active"
                });
            }
        });
        localStorage.setItem("language", value !== null && value !== void 0 ? value : "");
        // const tab = String(router?.query?.tab)
        // const pushInfo =
        //   tab === "undefined"
        //     ? "/user/[id]"
        //     : `/user/[id]?tab=${String(router?.query?.tab)}`
        router.push("", "", {
            locale: value
        });
    };
    const onSubmitChangePassword = ()=>{
        if (configs/* isClient */.C5) {
            const token = localStorage.getItem("token");
            if (token) {
                var _decodeToken_data;
                const decodeToken = (0,build_esm/* jwtDecode */.o)(token);
                router.push("https://id.gamota.com/authorize?access_token=".concat(decodeToken === null || decodeToken === void 0 ? void 0 : (_decodeToken_data = decodeToken.data) === null || _decodeToken_data === void 0 ? void 0 : _decodeToken_data.id, "&callback=/change_password&redirect=").concat(window.location.href));
            }
        }
    };
    const fade = (0,react_spring_web_modern/* useSpring */.q_)({
        opacity: 1,
        from: {
            opacity: 0
        },
        delay: 100
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(react_spring_web_modern/* animated.div */.q.div, {
            style: fade,
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "w-full px-0 md:px-[32px] py-[24px] pb-[80px]",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        className: "text-base Nunito-700 text-bg-01 dark:text-white",
                        children: t("profile.setting")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "w-full space-y-[16px] mt-[16px]",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "flex items-center justify-between w-full",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                        className: "text-sm Nunito-400 text-neutral dark:text-white",
                                        children: t("profile.theme")
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(SelectTheme/* SelectTheme */.n, {})
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "flex items-center justify-between w-full",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                        className: "text-sm Nunito-400 text-neutral dark:text-white",
                                        children: t("profile.language")
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "flex items-center gap-[12px]",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                className: "".concat((userInfo === null || userInfo === void 0 ? void 0 : userInfo.lang) === configs/* LANGUAGE_OPTION.VIETNAMESE */.ZD.VIETNAMESE ? "text-main-01" : "text-bg-01 dark:text-white", " Nunito-500 text-sm cursor-pointer"),
                                                onClick: ()=>handleChangeLang("vi"),
                                                children: t("profile.vietnamese")
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                className: "h-[16px] w-[1px] bg-black/10"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                className: "".concat((userInfo === null || userInfo === void 0 ? void 0 : userInfo.lang) === configs/* LANGUAGE_OPTION.ENGLISH */.ZD.ENGLISH ? "text-main-01" : "text-bg-01 dark:text-white", " Nunito-500 text-sm cursor-pointer"),
                                                onClick: ()=>handleChangeLang("en"),
                                                children: "English"
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "flex items-center justify-between w-full",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                        className: "text-sm Nunito-400 text-neutral dark:text-white",
                                        children: t("profile.change_password")
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                        className: "flex items-center text-sm cursor-pointer Nunito-500 text-bg-01 dark:text-white",
                                        onClick: onSubmitChangePassword,
                                        children: [
                                            t("profile.change"),
                                            "\xa0",
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
                                                    width: "24",
                                                    height: "24",
                                                    viewBox: "0 0 24 24",
                                                    fill: "none",
                                                    xmlns: "http://www.w3.org/2000/svg",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                        d: "M10 7L14 12L10 17",
                                                        stroke: themeApp === "dark" ? "#FAF8FF" : "#100D28",
                                                        strokeWidth: "1.5",
                                                        strokeLinecap: "round",
                                                        strokeLinejoin: "round"
                                                    })
                                                })
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    })
                ]
            })
        })
    });
};

;// CONCATENATED MODULE: ./app/containers/users/common/setting/index.ts



;// CONCATENATED MODULE: ./app/containers/users/common/index.ts






/***/ }),

/***/ 74542:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "g": function() { return /* binding */ ModalUploadImage; }
});

// EXTERNAL MODULE: ./node_modules/next/dist/compiled/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(41844);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/react/index.js
var react = __webpack_require__(55784);
// EXTERNAL MODULE: ./node_modules/react-dropzone/dist/es/index.js + 5 modules
var es = __webpack_require__(55162);
;// CONCATENATED MODULE: ./node_modules/react-image-crop/dist/index.js

const M = {
  x: 0,
  y: 0,
  width: 0,
  height: 0,
  unit: "px"
}, v = (o, e, t) => Math.min(Math.max(o, e), t), S = (...o) => o.filter((e) => e && typeof e == "string").join(" "), Y = (o, e) => o === e || o.width === e.width && o.height === e.height && o.x === e.x && o.y === e.y && o.unit === e.unit;
function H(o, e, t, h) {
  const i = y(o, t, h);
  return o.width && (i.height = i.width / e), o.height && (i.width = i.height * e), i.y + i.height > h && (i.height = h - i.y, i.width = i.height * e), i.x + i.width > t && (i.width = t - i.x, i.height = i.width / e), o.unit === "%" ? D(i, t, h) : i;
}
function I(o, e, t) {
  const h = y(o, e, t);
  return h.x = (e - h.width) / 2, h.y = (t - h.height) / 2, o.unit === "%" ? D(h, e, t) : h;
}
function D(o, e, t) {
  return o.unit === "%" ? { ...M, ...o, unit: "%" } : {
    unit: "%",
    x: o.x ? o.x / e * 100 : 0,
    y: o.y ? o.y / t * 100 : 0,
    width: o.width ? o.width / e * 100 : 0,
    height: o.height ? o.height / t * 100 : 0
  };
}
function y(o, e, t) {
  return o.unit ? o.unit === "px" ? { ...M, ...o, unit: "px" } : {
    unit: "px",
    x: o.x ? o.x * e / 100 : 0,
    y: o.y ? o.y * t / 100 : 0,
    width: o.width ? o.width * e / 100 : 0,
    height: o.height ? o.height * t / 100 : 0
  } : { ...M, ...o, unit: "px" };
}
function P(o, e, t, h, i, n = 0, s = 0, w = h, a = i) {
  const r = { ...o };
  let c = Math.min(n, h), d = Math.min(s, i), g = Math.min(w, h), l = Math.min(a, i);
  e && (e > 1 ? (c = s ? s * e : c, d = c / e, g = w * e) : (d = n ? n / e : d, c = d * e, l = a / e)), r.y < 0 && (r.height = Math.max(r.height + r.y, d), r.y = 0), r.x < 0 && (r.width = Math.max(r.width + r.x, c), r.x = 0);
  const m = h - (r.x + r.width);
  m < 0 && (r.x = Math.min(r.x, h - c), r.width += m);
  const x = i - (r.y + r.height);
  if (x < 0 && (r.y = Math.min(r.y, i - d), r.height += x), r.width < c && ((t === "sw" || t == "nw") && (r.x -= c - r.width), r.width = c), r.height < d && ((t === "nw" || t == "ne") && (r.y -= d - r.height), r.height = d), r.width > g && ((t === "sw" || t == "nw") && (r.x -= g - r.width), r.width = g), r.height > l && ((t === "nw" || t == "ne") && (r.y -= l - r.height), r.height = l), e) {
    const b = r.width / r.height;
    if (b < e) {
      const C = Math.max(r.width / e, d);
      (t === "nw" || t == "ne") && (r.y -= C - r.height), r.height = C;
    } else if (b > e) {
      const C = Math.max(r.height * e, c);
      (t === "sw" || t == "nw") && (r.x -= C - r.width), r.width = C;
    }
  }
  return r;
}
function _(o, e, t, h) {
  const i = { ...o };
  return e === "ArrowLeft" ? h === "nw" ? (i.x -= t, i.y -= t, i.width += t, i.height += t) : h === "w" ? (i.x -= t, i.width += t) : h === "sw" ? (i.x -= t, i.width += t, i.height += t) : h === "ne" ? (i.y += t, i.width -= t, i.height -= t) : h === "e" ? i.width -= t : h === "se" && (i.width -= t, i.height -= t) : e === "ArrowRight" && (h === "nw" ? (i.x += t, i.y += t, i.width -= t, i.height -= t) : h === "w" ? (i.x += t, i.width -= t) : h === "sw" ? (i.x += t, i.width -= t, i.height -= t) : h === "ne" ? (i.y -= t, i.width += t, i.height += t) : h === "e" ? i.width += t : h === "se" && (i.width += t, i.height += t)), e === "ArrowUp" ? h === "nw" ? (i.x -= t, i.y -= t, i.width += t, i.height += t) : h === "n" ? (i.y -= t, i.height += t) : h === "ne" ? (i.y -= t, i.width += t, i.height += t) : h === "sw" ? (i.x += t, i.width -= t, i.height -= t) : h === "s" ? i.height -= t : h === "se" && (i.width -= t, i.height -= t) : e === "ArrowDown" && (h === "nw" ? (i.x += t, i.y += t, i.width -= t, i.height -= t) : h === "n" ? (i.y += t, i.height -= t) : h === "ne" ? (i.y += t, i.width -= t, i.height -= t) : h === "sw" ? (i.x -= t, i.width += t, i.height += t) : h === "s" ? i.height += t : h === "se" && (i.width += t, i.height += t)), i;
}
const f = { capture: !0, passive: !1 };
let $ = 0;
const u = class u extends react.PureComponent {
  constructor() {
    super(...arguments), this.docMoveBound = !1, this.mouseDownOnCrop = !1, this.dragStarted = !1, this.evData = {
      startClientX: 0,
      startClientY: 0,
      startCropX: 0,
      startCropY: 0,
      clientX: 0,
      clientY: 0,
      isResize: !0
    }, this.componentRef = (0,react.createRef)(), this.mediaRef = (0,react.createRef)(), this.initChangeCalled = !1, this.instanceId = `rc-${$++}`, this.state = {
      cropIsActive: !1,
      newCropIsBeingDrawn: !1
    }, this.onCropPointerDown = (e) => {
      const { crop: t, disabled: h } = this.props, i = this.getBox();
      if (!t)
        return;
      const n = y(t, i.width, i.height);
      if (h)
        return;
      e.cancelable && e.preventDefault(), this.bindDocMove(), this.componentRef.current.focus({ preventScroll: !0 });
      const s = e.target.dataset.ord, w = !!s;
      let a = e.clientX, r = e.clientY, c = n.x, d = n.y;
      if (s) {
        const g = e.clientX - i.x, l = e.clientY - i.y;
        let m = 0, x = 0;
        s === "ne" || s == "e" ? (m = g - (n.x + n.width), x = l - n.y, c = n.x, d = n.y + n.height) : s === "se" || s === "s" ? (m = g - (n.x + n.width), x = l - (n.y + n.height), c = n.x, d = n.y) : s === "sw" || s == "w" ? (m = g - n.x, x = l - (n.y + n.height), c = n.x + n.width, d = n.y) : (s === "nw" || s == "n") && (m = g - n.x, x = l - n.y, c = n.x + n.width, d = n.y + n.height), a = c + i.x + m, r = d + i.y + x;
      }
      this.evData = {
        startClientX: a,
        startClientY: r,
        startCropX: c,
        startCropY: d,
        clientX: e.clientX,
        clientY: e.clientY,
        isResize: w,
        ord: s
      }, this.mouseDownOnCrop = !0, this.setState({ cropIsActive: !0 });
    }, this.onComponentPointerDown = (e) => {
      const { crop: t, disabled: h, locked: i, keepSelection: n, onChange: s } = this.props, w = this.getBox();
      if (h || i || n && t)
        return;
      e.cancelable && e.preventDefault(), this.bindDocMove(), this.componentRef.current.focus({ preventScroll: !0 });
      const a = e.clientX - w.x, r = e.clientY - w.y, c = {
        unit: "px",
        x: a,
        y: r,
        width: 0,
        height: 0
      };
      this.evData = {
        startClientX: e.clientX,
        startClientY: e.clientY,
        startCropX: a,
        startCropY: r,
        clientX: e.clientX,
        clientY: e.clientY,
        isResize: !0
      }, this.mouseDownOnCrop = !0, s(y(c, w.width, w.height), D(c, w.width, w.height)), this.setState({ cropIsActive: !0, newCropIsBeingDrawn: !0 });
    }, this.onDocPointerMove = (e) => {
      const { crop: t, disabled: h, onChange: i, onDragStart: n } = this.props, s = this.getBox();
      if (h || !t || !this.mouseDownOnCrop)
        return;
      e.cancelable && e.preventDefault(), this.dragStarted || (this.dragStarted = !0, n && n(e));
      const { evData: w } = this;
      w.clientX = e.clientX, w.clientY = e.clientY;
      let a;
      w.isResize ? a = this.resizeCrop() : a = this.dragCrop(), Y(t, a) || i(
        y(a, s.width, s.height),
        D(a, s.width, s.height)
      );
    }, this.onComponentKeyDown = (e) => {
      const { crop: t, disabled: h, onChange: i, onComplete: n } = this.props;
      if (h)
        return;
      const s = e.key;
      let w = !1;
      if (!t)
        return;
      const a = this.getBox(), r = this.makePixelCrop(a), d = (navigator.platform.match("Mac") ? e.metaKey : e.ctrlKey) ? u.nudgeStepLarge : e.shiftKey ? u.nudgeStepMedium : u.nudgeStep;
      if (s === "ArrowLeft" ? (r.x -= d, w = !0) : s === "ArrowRight" ? (r.x += d, w = !0) : s === "ArrowUp" ? (r.y -= d, w = !0) : s === "ArrowDown" && (r.y += d, w = !0), w) {
        e.cancelable && e.preventDefault(), r.x = v(r.x, 0, a.width - r.width), r.y = v(r.y, 0, a.height - r.height);
        const g = y(r, a.width, a.height), l = D(r, a.width, a.height);
        i(g, l), n && n(g, l);
      }
    }, this.onHandlerKeyDown = (e, t) => {
      const {
        aspect: h = 0,
        crop: i,
        disabled: n,
        minWidth: s = 0,
        minHeight: w = 0,
        maxWidth: a,
        maxHeight: r,
        onChange: c,
        onComplete: d
      } = this.props, g = this.getBox();
      if (n || !i)
        return;
      if (e.key === "ArrowUp" || e.key === "ArrowDown" || e.key === "ArrowLeft" || e.key === "ArrowRight")
        e.stopPropagation(), e.preventDefault();
      else
        return;
      const m = (navigator.platform.match("Mac") ? e.metaKey : e.ctrlKey) ? u.nudgeStepLarge : e.shiftKey ? u.nudgeStepMedium : u.nudgeStep, x = y(i, g.width, g.height), b = _(x, e.key, m, t), C = P(
        b,
        h,
        t,
        g.width,
        g.height,
        s,
        w,
        a,
        r
      );
      if (!Y(i, C)) {
        const R = D(C, g.width, g.height);
        c(C, R), d && d(C, R);
      }
    }, this.onDocPointerDone = (e) => {
      const { crop: t, disabled: h, onComplete: i, onDragEnd: n } = this.props, s = this.getBox();
      this.unbindDocMove(), !(h || !t) && this.mouseDownOnCrop && (this.mouseDownOnCrop = !1, this.dragStarted = !1, n && n(e), i && i(y(t, s.width, s.height), D(t, s.width, s.height)), this.setState({ cropIsActive: !1, newCropIsBeingDrawn: !1 }));
    }, this.onDragFocus = () => {
      var e;
      (e = this.componentRef.current) == null || e.scrollTo(0, 0);
    };
  }
  get document() {
    return document;
  }
  // We unfortunately get the bounding box every time as x+y changes
  // due to scrolling.
  getBox() {
    const e = this.mediaRef.current;
    if (!e)
      return { x: 0, y: 0, width: 0, height: 0 };
    const { x: t, y: h, width: i, height: n } = e.getBoundingClientRect();
    return { x: t, y: h, width: i, height: n };
  }
  componentDidUpdate(e) {
    const { crop: t, onComplete: h } = this.props;
    if (h && !e.crop && t) {
      const { width: i, height: n } = this.getBox();
      i && n && h(y(t, i, n), D(t, i, n));
    }
  }
  componentWillUnmount() {
    this.resizeObserver && this.resizeObserver.disconnect();
  }
  bindDocMove() {
    this.docMoveBound || (this.document.addEventListener("pointermove", this.onDocPointerMove, f), this.document.addEventListener("pointerup", this.onDocPointerDone, f), this.document.addEventListener("pointercancel", this.onDocPointerDone, f), this.docMoveBound = !0);
  }
  unbindDocMove() {
    this.docMoveBound && (this.document.removeEventListener("pointermove", this.onDocPointerMove, f), this.document.removeEventListener("pointerup", this.onDocPointerDone, f), this.document.removeEventListener("pointercancel", this.onDocPointerDone, f), this.docMoveBound = !1);
  }
  getCropStyle() {
    const { crop: e } = this.props;
    if (e)
      return {
        top: `${e.y}${e.unit}`,
        left: `${e.x}${e.unit}`,
        width: `${e.width}${e.unit}`,
        height: `${e.height}${e.unit}`
      };
  }
  dragCrop() {
    const { evData: e } = this, t = this.getBox(), h = this.makePixelCrop(t), i = e.clientX - e.startClientX, n = e.clientY - e.startClientY;
    return h.x = v(e.startCropX + i, 0, t.width - h.width), h.y = v(e.startCropY + n, 0, t.height - h.height), h;
  }
  getPointRegion(e, t, h, i) {
    const { evData: n } = this, s = n.clientX - e.x, w = n.clientY - e.y;
    let a;
    i && t ? a = t === "nw" || t === "n" || t === "ne" : a = w < n.startCropY;
    let r;
    return h && t ? r = t === "nw" || t === "w" || t === "sw" : r = s < n.startCropX, r ? a ? "nw" : "sw" : a ? "ne" : "se";
  }
  resolveMinDimensions(e, t, h = 0, i = 0) {
    const n = Math.min(h, e.width), s = Math.min(i, e.height);
    return !t || !n && !s ? [n, s] : t > 1 ? n ? [n, n / t] : [s * t, s] : s ? [s * t, s] : [n, n / t];
  }
  resizeCrop() {
    const { evData: e } = this, { aspect: t = 0, maxWidth: h, maxHeight: i } = this.props, n = this.getBox(), [s, w] = this.resolveMinDimensions(n, t, this.props.minWidth, this.props.minHeight);
    let a = this.makePixelCrop(n);
    const r = this.getPointRegion(n, e.ord, s, w), c = e.ord || r;
    let d = e.clientX - e.startClientX, g = e.clientY - e.startClientY;
    (s && c === "nw" || c === "w" || c === "sw") && (d = Math.min(d, -s)), (w && c === "nw" || c === "n" || c === "ne") && (g = Math.min(g, -w));
    const l = {
      unit: "px",
      x: 0,
      y: 0,
      width: 0,
      height: 0
    };
    r === "ne" ? (l.x = e.startCropX, l.width = d, t ? (l.height = l.width / t, l.y = e.startCropY - l.height) : (l.height = Math.abs(g), l.y = e.startCropY - l.height)) : r === "se" ? (l.x = e.startCropX, l.y = e.startCropY, l.width = d, t ? l.height = l.width / t : l.height = g) : r === "sw" ? (l.x = e.startCropX + d, l.y = e.startCropY, l.width = Math.abs(d), t ? l.height = l.width / t : l.height = g) : r === "nw" && (l.x = e.startCropX + d, l.width = Math.abs(d), t ? (l.height = l.width / t, l.y = e.startCropY - l.height) : (l.height = Math.abs(g), l.y = e.startCropY + g));
    const m = P(
      l,
      t,
      r,
      n.width,
      n.height,
      s,
      w,
      h,
      i
    );
    return t || u.xyOrds.indexOf(c) > -1 ? a = m : u.xOrds.indexOf(c) > -1 ? (a.x = m.x, a.width = m.width) : u.yOrds.indexOf(c) > -1 && (a.y = m.y, a.height = m.height), a.x = v(a.x, 0, n.width - a.width), a.y = v(a.y, 0, n.height - a.height), a;
  }
  renderCropSelection() {
    const {
      ariaLabels: e = u.defaultProps.ariaLabels,
      disabled: t,
      locked: h,
      renderSelectionAddon: i,
      ruleOfThirds: n,
      crop: s
    } = this.props, w = this.getCropStyle();
    if (s)
      return /* @__PURE__ */ react.createElement(
        "div",
        {
          style: w,
          className: "ReactCrop__crop-selection",
          onPointerDown: this.onCropPointerDown,
          "aria-label": e.cropArea,
          tabIndex: 0,
          onKeyDown: this.onComponentKeyDown,
          role: "group"
        },
        !t && !h && /* @__PURE__ */ react.createElement("div", { className: "ReactCrop__drag-elements", onFocus: this.onDragFocus }, /* @__PURE__ */ react.createElement("div", { className: "ReactCrop__drag-bar ord-n", "data-ord": "n" }), /* @__PURE__ */ react.createElement("div", { className: "ReactCrop__drag-bar ord-e", "data-ord": "e" }), /* @__PURE__ */ react.createElement("div", { className: "ReactCrop__drag-bar ord-s", "data-ord": "s" }), /* @__PURE__ */ react.createElement("div", { className: "ReactCrop__drag-bar ord-w", "data-ord": "w" }), /* @__PURE__ */ react.createElement(
          "div",
          {
            className: "ReactCrop__drag-handle ord-nw",
            "data-ord": "nw",
            tabIndex: 0,
            "aria-label": e.nwDragHandle,
            onKeyDown: (a) => this.onHandlerKeyDown(a, "nw"),
            role: "button"
          }
        ), /* @__PURE__ */ react.createElement(
          "div",
          {
            className: "ReactCrop__drag-handle ord-n",
            "data-ord": "n",
            tabIndex: 0,
            "aria-label": e.nDragHandle,
            onKeyDown: (a) => this.onHandlerKeyDown(a, "n"),
            role: "button"
          }
        ), /* @__PURE__ */ react.createElement(
          "div",
          {
            className: "ReactCrop__drag-handle ord-ne",
            "data-ord": "ne",
            tabIndex: 0,
            "aria-label": e.neDragHandle,
            onKeyDown: (a) => this.onHandlerKeyDown(a, "ne"),
            role: "button"
          }
        ), /* @__PURE__ */ react.createElement(
          "div",
          {
            className: "ReactCrop__drag-handle ord-e",
            "data-ord": "e",
            tabIndex: 0,
            "aria-label": e.eDragHandle,
            onKeyDown: (a) => this.onHandlerKeyDown(a, "e"),
            role: "button"
          }
        ), /* @__PURE__ */ react.createElement(
          "div",
          {
            className: "ReactCrop__drag-handle ord-se",
            "data-ord": "se",
            tabIndex: 0,
            "aria-label": e.seDragHandle,
            onKeyDown: (a) => this.onHandlerKeyDown(a, "se"),
            role: "button"
          }
        ), /* @__PURE__ */ react.createElement(
          "div",
          {
            className: "ReactCrop__drag-handle ord-s",
            "data-ord": "s",
            tabIndex: 0,
            "aria-label": e.sDragHandle,
            onKeyDown: (a) => this.onHandlerKeyDown(a, "s"),
            role: "button"
          }
        ), /* @__PURE__ */ react.createElement(
          "div",
          {
            className: "ReactCrop__drag-handle ord-sw",
            "data-ord": "sw",
            tabIndex: 0,
            "aria-label": e.swDragHandle,
            onKeyDown: (a) => this.onHandlerKeyDown(a, "sw"),
            role: "button"
          }
        ), /* @__PURE__ */ react.createElement(
          "div",
          {
            className: "ReactCrop__drag-handle ord-w",
            "data-ord": "w",
            tabIndex: 0,
            "aria-label": e.wDragHandle,
            onKeyDown: (a) => this.onHandlerKeyDown(a, "w"),
            role: "button"
          }
        )),
        i && /* @__PURE__ */ react.createElement("div", { className: "ReactCrop__selection-addon", onPointerDown: (a) => a.stopPropagation() }, i(this.state)),
        n && /* @__PURE__ */ react.createElement(react.Fragment, null, /* @__PURE__ */ react.createElement("div", { className: "ReactCrop__rule-of-thirds-hz" }), /* @__PURE__ */ react.createElement("div", { className: "ReactCrop__rule-of-thirds-vt" }))
      );
  }
  makePixelCrop(e) {
    const t = { ...M, ...this.props.crop || {} };
    return y(t, e.width, e.height);
  }
  render() {
    const { aspect: e, children: t, circularCrop: h, className: i, crop: n, disabled: s, locked: w, style: a, ruleOfThirds: r } = this.props, { cropIsActive: c, newCropIsBeingDrawn: d } = this.state, g = n ? this.renderCropSelection() : null, l = S(
      "ReactCrop",
      i,
      c && "ReactCrop--active",
      s && "ReactCrop--disabled",
      w && "ReactCrop--locked",
      d && "ReactCrop--new-crop",
      n && e && "ReactCrop--fixed-aspect",
      n && h && "ReactCrop--circular-crop",
      n && r && "ReactCrop--rule-of-thirds",
      !this.dragStarted && n && !n.width && !n.height && "ReactCrop--invisible-crop",
      h && "ReactCrop--no-animate"
    );
    return /* @__PURE__ */ react.createElement("div", { ref: this.componentRef, className: l, style: a }, /* @__PURE__ */ react.createElement("div", { ref: this.mediaRef, className: "ReactCrop__child-wrapper", onPointerDown: this.onComponentPointerDown }, t), n ? /* @__PURE__ */ react.createElement("svg", { className: "ReactCrop__crop-mask", width: "100%", height: "100%" }, /* @__PURE__ */ react.createElement("defs", null, /* @__PURE__ */ react.createElement("mask", { id: `hole-${this.instanceId}` }, /* @__PURE__ */ react.createElement("rect", { width: "100%", height: "100%", fill: "white" }), h ? /* @__PURE__ */ react.createElement(
      "ellipse",
      {
        cx: `${n.x + n.width / 2}${n.unit}`,
        cy: `${n.y + n.height / 2}${n.unit}`,
        rx: `${n.width / 2}${n.unit}`,
        ry: `${n.height / 2}${n.unit}`,
        fill: "black"
      }
    ) : /* @__PURE__ */ react.createElement(
      "rect",
      {
        x: `${n.x}${n.unit}`,
        y: `${n.y}${n.unit}`,
        width: `${n.width}${n.unit}`,
        height: `${n.height}${n.unit}`,
        fill: "black"
      }
    ))), /* @__PURE__ */ react.createElement("rect", { fill: "black", fillOpacity: 0.5, width: "100%", height: "100%", mask: `url(#hole-${this.instanceId})` })) : void 0, g);
  }
};
u.xOrds = ["e", "w"], u.yOrds = ["n", "s"], u.xyOrds = ["nw", "ne", "se", "sw"], u.nudgeStep = 1, u.nudgeStepMedium = 10, u.nudgeStepLarge = 100, u.defaultProps = {
  ariaLabels: {
    cropArea: "Use the arrow keys to move the crop selection area",
    nwDragHandle: "Use the arrow keys to move the north west drag handle to change the crop selection area",
    nDragHandle: "Use the up and down arrow keys to move the north drag handle to change the crop selection area",
    neDragHandle: "Use the arrow keys to move the north east drag handle to change the crop selection area",
    eDragHandle: "Use the up and down arrow keys to move the east drag handle to change the crop selection area",
    seDragHandle: "Use the arrow keys to move the south east drag handle to change the crop selection area",
    sDragHandle: "Use the up and down arrow keys to move the south drag handle to change the crop selection area",
    swDragHandle: "Use the arrow keys to move the south west drag handle to change the crop selection area",
    wDragHandle: "Use the up and down arrow keys to move the west drag handle to change the crop selection area"
  }
};
let X = u;


;// CONCATENATED MODULE: ./node_modules/react-image-crop/dist/ReactCrop.css
/* harmony default export */ var ReactCrop = ("3a726f6f747b2d2d72632d647261672d68616e646c652d73697a653a20313270783b2d2d72632d647261672d68616e646c652d6d6f62696c652d73697a653a20323470783b2d2d72632d647261672d68616e646c652d62672d636f6c6f75723a207267626128302c20302c20302c202e32293b2d2d72632d647261672d6261722d73697a653a203670783b2d2d72632d626f726465722d636f6c6f723a2072676261283235352c203235352c203235352c202e37293b2d2d72632d666f6375732d636f6c6f723a20233030383866667d2e526561637443726f707b706f736974696f6e3a72656c61746976653b646973706c61793a696e6c696e652d626c6f636b3b637572736f723a63726f7373686169723b6d61782d77696474683a313030257d2e526561637443726f70202a2c2e526561637443726f70202a3a6265666f72652c2e526561637443726f70202a3a61667465727b626f782d73697a696e673a626f726465722d626f787d2e526561637443726f702d2d64697361626c65642c2e526561637443726f702d2d6c6f636b65647b637572736f723a696e68657269747d2e526561637443726f705f5f6368696c642d777261707065727b6f766572666c6f773a68696464656e3b6d61782d6865696768743a696e68657269747d2e526561637443726f705f5f6368696c642d777261707065723e696d672c2e526561637443726f705f5f6368696c642d777261707065723e766964656f7b646973706c61793a626c6f636b3b6d61782d77696474683a313030253b6d61782d6865696768743a696e68657269747d2e526561637443726f703a6e6f74282e526561637443726f702d2d64697361626c656429202e526561637443726f705f5f6368696c642d777261707065723e696d672c2e526561637443726f703a6e6f74282e526561637443726f702d2d64697361626c656429202e526561637443726f705f5f6368696c642d777261707065723e766964656f7b746f7563682d616374696f6e3a6e6f6e657d2e526561637443726f703a6e6f74282e526561637443726f702d2d64697361626c656429202e526561637443726f705f5f63726f702d73656c656374696f6e7b746f7563682d616374696f6e3a6e6f6e657d2e526561637443726f705f5f63726f702d6d61736b7b706f736974696f6e3a6162736f6c7574653b746f703a303b72696768743a303b626f74746f6d3a303b6c6566743a303b706f696e7465722d6576656e74733a6e6f6e657d2e526561637443726f705f5f63726f702d73656c656374696f6e7b706f736974696f6e3a6162736f6c7574653b746f703a303b6c6566743a303b7472616e73666f726d3a7472616e736c6174655a2830293b637572736f723a6d6f76657d2e526561637443726f702d2d64697361626c6564202e526561637443726f705f5f63726f702d73656c656374696f6e7b637572736f723a696e68657269747d2e526561637443726f702d2d63697263756c61722d63726f70202e526561637443726f705f5f63726f702d73656c656374696f6e7b626f726465722d7261646975733a3530257d2e526561637443726f702d2d63697263756c61722d63726f70202e526561637443726f705f5f63726f702d73656c656374696f6e3a61667465727b706f696e7465722d6576656e74733a6e6f6e653b636f6e74656e743a22223b706f736974696f6e3a6162736f6c7574653b746f703a2d3170783b72696768743a2d3170783b626f74746f6d3a2d3170783b6c6566743a2d3170783b626f726465723a31707820736f6c696420766172282d2d72632d626f726465722d636f6c6f72293b6f7061636974793a2e337d2e526561637443726f702d2d6e6f2d616e696d617465202e526561637443726f705f5f63726f702d73656c656374696f6e7b6f75746c696e653a317078206461736865642077686974657d2e526561637443726f705f5f63726f702d73656c656374696f6e3a6e6f74282e526561637443726f702d2d6e6f2d616e696d617465202e526561637443726f705f5f63726f702d73656c656374696f6e297b616e696d6174696f6e3a6d61726368696e672d616e74732031733b6261636b67726f756e642d696d6167653a6c696e6561722d6772616469656e7428746f2072696768742c23666666203530252c2334343420353025292c6c696e6561722d6772616469656e7428746f2072696768742c23666666203530252c2334343420353025292c6c696e6561722d6772616469656e7428746f20626f74746f6d2c23666666203530252c2334343420353025292c6c696e6561722d6772616469656e7428746f20626f74746f6d2c23666666203530252c2334343420353025293b6261636b67726f756e642d73697a653a31307078203170782c31307078203170782c31707820313070782c31707820313070783b6261636b67726f756e642d706f736974696f6e3a3020302c3020313030252c3020302c3130302520303b6261636b67726f756e642d7265706561743a7265706561742d782c7265706561742d782c7265706561742d792c7265706561742d793b636f6c6f723a236666663b616e696d6174696f6e2d706c61792d73746174653a72756e6e696e673b616e696d6174696f6e2d74696d696e672d66756e6374696f6e3a6c696e6561723b616e696d6174696f6e2d697465726174696f6e2d636f756e743a696e66696e6974657d406b65796672616d6573206d61726368696e672d616e74737b30257b6261636b67726f756e642d706f736974696f6e3a3020302c3020313030252c3020302c3130302520307d746f7b6261636b67726f756e642d706f736974696f6e3a3230707820302c2d3230707820313030252c30202d323070782c3130302520323070787d7d2e526561637443726f705f5f63726f702d73656c656374696f6e3a666f6375737b6f75746c696e653a32707820736f6c696420766172282d2d72632d666f6375732d636f6c6f72293b6f75746c696e652d6f66667365743a2d3170787d2e526561637443726f702d2d696e76697369626c652d63726f70202e526561637443726f705f5f63726f702d6d61736b2c2e526561637443726f702d2d696e76697369626c652d63726f70202e526561637443726f705f5f63726f702d73656c656374696f6e7b646973706c61793a6e6f6e657d2e526561637443726f705f5f72756c652d6f662d7468697264732d76743a6265666f72652c2e526561637443726f705f5f72756c652d6f662d7468697264732d76743a61667465722c2e526561637443726f705f5f72756c652d6f662d7468697264732d687a3a6265666f72652c2e526561637443726f705f5f72756c652d6f662d7468697264732d687a3a61667465727b636f6e74656e743a22223b646973706c61793a626c6f636b3b706f736974696f6e3a6162736f6c7574653b6261636b67726f756e642d636f6c6f723a23666666367d2e526561637443726f705f5f72756c652d6f662d7468697264732d76743a6265666f72652c2e526561637443726f705f5f72756c652d6f662d7468697264732d76743a61667465727b77696474683a3170783b6865696768743a313030257d2e526561637443726f705f5f72756c652d6f662d7468697264732d76743a6265666f72657b6c6566743a33332e33333333333333333333257d2e526561637443726f705f5f72756c652d6f662d7468697264732d76743a61667465727b6c6566743a36362e36363636363636363637257d2e526561637443726f705f5f72756c652d6f662d7468697264732d687a3a6265666f72652c2e526561637443726f705f5f72756c652d6f662d7468697264732d687a3a61667465727b77696474683a313030253b6865696768743a3170787d2e526561637443726f705f5f72756c652d6f662d7468697264732d687a3a6265666f72657b746f703a33332e33333333333333333333257d2e526561637443726f705f5f72756c652d6f662d7468697264732d687a3a61667465727b746f703a36362e36363636363636363637257d2e526561637443726f705f5f647261672d68616e646c657b706f736974696f6e3a6162736f6c7574653b77696474683a766172282d2d72632d647261672d68616e646c652d73697a65293b6865696768743a766172282d2d72632d647261672d68616e646c652d73697a65293b6261636b67726f756e642d636f6c6f723a766172282d2d72632d647261672d68616e646c652d62672d636f6c6f7572293b626f726465723a31707820736f6c696420766172282d2d72632d626f726465722d636f6c6f72297d2e526561637443726f705f5f647261672d68616e646c653a666f6375737b6261636b67726f756e643a766172282d2d72632d666f6375732d636f6c6f72297d2e526561637443726f70202e6f72642d6e777b746f703a303b6c6566743a303b7472616e73666f726d3a7472616e736c617465282d3530252c2d353025293b637572736f723a6e772d726573697a657d2e526561637443726f70202e6f72642d6e7b746f703a303b6c6566743a3530253b7472616e73666f726d3a7472616e736c617465282d3530252c2d353025293b637572736f723a6e2d726573697a657d2e526561637443726f70202e6f72642d6e657b746f703a303b72696768743a303b7472616e73666f726d3a7472616e736c617465283530252c2d353025293b637572736f723a6e652d726573697a657d2e526561637443726f70202e6f72642d657b746f703a3530253b72696768743a303b7472616e73666f726d3a7472616e736c617465283530252c2d353025293b637572736f723a652d726573697a657d2e526561637443726f70202e6f72642d73657b626f74746f6d3a303b72696768743a303b7472616e73666f726d3a7472616e736c617465283530252c353025293b637572736f723a73652d726573697a657d2e526561637443726f70202e6f72642d737b626f74746f6d3a303b6c6566743a3530253b7472616e73666f726d3a7472616e736c617465282d3530252c353025293b637572736f723a732d726573697a657d2e526561637443726f70202e6f72642d73777b626f74746f6d3a303b6c6566743a303b7472616e73666f726d3a7472616e736c617465282d3530252c353025293b637572736f723a73772d726573697a657d2e526561637443726f70202e6f72642d777b746f703a3530253b6c6566743a303b7472616e73666f726d3a7472616e736c617465282d3530252c2d353025293b637572736f723a772d726573697a657d2e526561637443726f705f5f64697361626c6564202e526561637443726f705f5f647261672d68616e646c657b637572736f723a696e68657269747d2e526561637443726f705f5f647261672d6261727b706f736974696f6e3a6162736f6c7574657d2e526561637443726f705f5f647261672d6261722e6f72642d6e7b746f703a303b6c6566743a303b77696474683a313030253b6865696768743a766172282d2d72632d647261672d6261722d73697a65293b7472616e73666f726d3a7472616e736c61746559282d353025297d2e526561637443726f705f5f647261672d6261722e6f72642d657b72696768743a303b746f703a303b77696474683a766172282d2d72632d647261672d6261722d73697a65293b6865696768743a313030253b7472616e73666f726d3a7472616e736c61746528353025297d2e526561637443726f705f5f647261672d6261722e6f72642d737b626f74746f6d3a303b6c6566743a303b77696474683a313030253b6865696768743a766172282d2d72632d647261672d6261722d73697a65293b7472616e73666f726d3a7472616e736c6174655928353025297d2e526561637443726f705f5f647261672d6261722e6f72642d777b746f703a303b6c6566743a303b77696474683a766172282d2d72632d647261672d6261722d73697a65293b6865696768743a313030253b7472616e73666f726d3a7472616e736c617465282d353025297d2e526561637443726f702d2d6e65772d63726f70202e526561637443726f705f5f647261672d6261722c2e526561637443726f702d2d6e65772d63726f70202e526561637443726f705f5f647261672d68616e646c652c2e526561637443726f702d2d66697865642d617370656374202e526561637443726f705f5f647261672d6261722c2e526561637443726f702d2d66697865642d617370656374202e526561637443726f705f5f647261672d68616e646c652e6f72642d6e2c2e526561637443726f702d2d66697865642d617370656374202e526561637443726f705f5f647261672d68616e646c652e6f72642d652c2e526561637443726f702d2d66697865642d617370656374202e526561637443726f705f5f647261672d68616e646c652e6f72642d732c2e526561637443726f702d2d66697865642d617370656374202e526561637443726f705f5f647261672d68616e646c652e6f72642d777b646973706c61793a6e6f6e657d406d656469612028706f696e7465723a20636f61727365297b2e526561637443726f70202e6f72642d6e2c2e526561637443726f70202e6f72642d652c2e526561637443726f70202e6f72642d732c2e526561637443726f70202e6f72642d777b646973706c61793a6e6f6e657d2e526561637443726f705f5f647261672d68616e646c657b77696474683a766172282d2d72632d647261672d68616e646c652d6d6f62696c652d73697a65293b6865696768743a766172282d2d72632d647261672d68616e646c652d6d6f62696c652d73697a65297d7d0a");
;// CONCATENATED MODULE: ./app/components/crop-image/CanvasPreview.ts
const TO_RADIANS = Math.PI / 180;
async function canvasPreview(image, canvas, crop) {
    let scale = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : 1, rotate = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : 0;
    const ctx = canvas.getContext("2d");
    if (!ctx) {
        throw new Error("No 2d context");
    }
    const scaleX = image.naturalWidth / image.width;
    const scaleY = image.naturalHeight / image.height;
    // devicePixelRatio slightly increases sharpness on retina devices
    // at the expense of slightly slower render times and needing to
    // size the image back down if you want to download/upload and be
    // true to the images natural size.
    const pixelRatio = 1;
    // const pixelRatio = 1
    canvas.width = Math.floor(crop.width * scaleX * pixelRatio);
    canvas.height = Math.floor(crop.height * scaleY * pixelRatio);
    ctx.scale(pixelRatio, pixelRatio);
    ctx.imageSmoothingQuality = "high";
    const cropX = crop.x * scaleX;
    const cropY = crop.y * scaleY;
    const rotateRads = rotate * TO_RADIANS;
    const centerX = image.naturalWidth / 2;
    const centerY = image.naturalHeight / 2;
    ctx.save();
    // 5) Move the crop origin to the canvas origin (0,0)
    ctx.translate(-cropX, -cropY);
    // 4) Move the origin to the center of the original position
    ctx.translate(centerX, centerY);
    // 3) Rotate around the origin
    ctx.rotate(rotateRads);
    // 2) Scale the image
    ctx.scale(scale, scale);
    // 1) Move the center of the image to the origin (0,0)
    ctx.translate(-centerX, -centerY);
    ctx.drawImage(image, 0, 0, image.naturalWidth, image.naturalHeight, 0, 0, image.naturalWidth, image.naturalHeight);
    ctx.restore();
    return new Promise((resolve, reject)=>{
        canvas.toBlob((blob)=>{
            if (!blob) {
                console.error("Canvas is empty");
                return;
            }
            resolve(blob);
        }, "image/jpeg");
    });
}

// EXTERNAL MODULE: ./node_modules/next-i18next/dist/esm/index.js + 41 modules
var esm = __webpack_require__(93378);
// EXTERNAL MODULE: ./app/hooks/useDebounceEffect.tsx
var useDebounceEffect = __webpack_require__(45724);
// EXTERNAL MODULE: ./app/components/icon-tsx/IconClose.tsx
var IconClose = __webpack_require__(51337);
;// CONCATENATED MODULE: ./app/components/crop-image/style.css
/* harmony default export */ var style = ("2e72616e67652d736c69646572207b0a202020202d7765626b69742d617070656172616e63653a206e6f6e653b0a20202020617070656172616e63653a206e6f6e653b0a2020202077696474683a20313030253b0a202020206865696768743a203870783b0a202020206261636b67726f756e643a20234630463246353b0a202020206f75746c696e653a206e6f6e653b0a202020206f7061636974793a20302e373b0a202020207472616e736974696f6e3a206f706163697479202e32733b0a20202020626f726465722d7261646975733a203870783b0a7d0a0a2e72616e67652d736c696465723a686f766572207b0a202020206f7061636974793a20313b0a7d0a0a2e72616e67652d736c696465723a3a2d7765626b69742d736c696465722d7468756d62207b0a202020202d7765626b69742d617070656172616e63653a206e6f6e653b0a20202020617070656172616e63653a206e6f6e653b0a2020202077696474683a20323070783b0a202020206865696768743a20323070783b0a202020206261636b67726f756e643a20233736373345353b0a20202020637572736f723a20706f696e7465723b0a20202020626f726465722d7261646975733a203530253b0a7d0a0a2e72616e67652d736c696465723a3a2d6d6f7a2d72616e67652d7468756d62207b0a2020202077696474683a20323070783b0a202020206865696768743a20323070783b0a202020206261636b67726f756e643a20233736373345353b0a20202020637572736f723a20706f696e7465723b0a20202020626f726465722d7261646975733a203530253b0a7d0a0a2e72616e67652d736c696465722d76616c7565207b0a202020206d617267696e2d746f703a20313070783b0a20202020666f6e742d73697a653a20313870783b0a7d");
;// CONCATENATED MODULE: ./app/components/crop-image/ZoomSlider.tsx



const ZoomSlider = (param)=>{
    let { min , max , step =10000 , minVal , setMinVal , onChangeScaleImage  } = param;
    const minValRef = (0,react.useRef)(min);
    const onChangeInput = (value)=>{
        setMinVal(value);
        minValRef.current = value;
        onChangeScaleImage(value);
    };
    const onChangeMaxMinInput = ()=>{
        const value = minVal === min ? max : min;
        onChangeInput(value);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "flex w-full gap-2 mt-[32px] items-center",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "cursor-pointer",
                onClick: onChangeMaxMinInput,
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
                    width: "24",
                    height: "24",
                    viewBox: "0 0 24 24",
                    fill: "none",
                    xmlns: "http://www.w3.org/2000/svg",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                            d: "M17 7L13 11M7 17L11 13M13 11H17M13 11V7M11 13V17M11 13H7",
                            stroke: "#7673E6",
                            strokeWidth: "1.5",
                            strokeLinecap: "round",
                            strokeLinejoin: "round"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                            d: "M18 2H6C3.79086 2 2 3.79086 2 6V18C2 20.2091 3.79086 22 6 22H18C20.2091 22 22 20.2091 22 18V6C22 3.79086 20.2091 2 18 2Z",
                            stroke: "#7673E6",
                            strokeWidth: "1.5",
                            strokeLinecap: "round",
                            strokeLinejoin: "round"
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "flex flex-col items-center w-full",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                    type: "range",
                    min: min,
                    max: max,
                    step: step,
                    value: minVal,
                    onChange: (event)=>{
                        var _event_target;
                        return onChangeInput(Number(event === null || event === void 0 ? void 0 : (_event_target = event.target) === null || _event_target === void 0 ? void 0 : _event_target.value));
                    },
                    className: "range-slider"
                })
            })
        ]
    });
};

;// CONCATENATED MODULE: ./app/components/crop-image/index.tsx










// This is to demonstate how to make and center a % aspect crop
// which is a bit trickier so we use some helper functions.
function centerAspectCrop(mediaWidth, mediaHeight, aspect) {
    return I(H({
        unit: "%",
        width: 90
    }, aspect, mediaWidth, mediaHeight), mediaWidth, mediaHeight);
}
const MIN_VALUE = 1;
const MAX_VALUE = 3;
const STEP = 0.1;
function CropImage(param) {
    let { size , setImageSmall , setImage , image  } = param;
    const [imgSrc, setImgSrc] = (0,react.useState)("");
    const previewCanvasRef = (0,react.useRef)(null);
    const fileInput = (0,react.useRef)(null);
    const imgRef = (0,react.useRef)(null);
    const [crop, setCrop] = (0,react.useState)();
    const [completedCrop, setCompletedCrop] = (0,react.useState)();
    const [scale, setScale] = (0,react.useState)(1);
    const [rotate, setRotate] = (0,react.useState)(0);
    const [aspect, setAspect] = (0,react.useState)(1 / 1);
    const { t  } = (0,esm/* useTranslation */.$G)();
    const [file, setFile] = (0,react.useState)();
    const [files, setFiles] = (0,react.useState)([]);
    const [minVal, setMinVal] = (0,react.useState)(MIN_VALUE);
    function onSelectFile(e) {
        if (e.target.files && e.target.files.length > 0) {
            setImage(e.target.files[0]);
            setCrop(undefined) // Makes crop preview update between images.
            ;
            const reader = new FileReader();
            reader.addEventListener("load", ()=>{
                var _reader_result;
                return setImgSrc(((_reader_result = reader.result) === null || _reader_result === void 0 ? void 0 : _reader_result.toString()) || "");
            });
            reader.readAsDataURL(e.target.files[0]);
        }
    }
    function onImageLoad(e) {
        if (aspect) {
            const { width , height  } = e.currentTarget;
            setCrop(centerAspectCrop(width, height, size));
        } else if (imgRef.current) {
            const { width: width1 , height: height1  } = imgRef.current;
            setAspect(1 / 1);
            setCrop(centerAspectCrop(width1, height1, 1 / 1));
        }
    }
    (0,useDebounceEffect/* useDebounceEffect */.s)(async ()=>{
        if ((completedCrop === null || completedCrop === void 0 ? void 0 : completedCrop.width) && (completedCrop === null || completedCrop === void 0 ? void 0 : completedCrop.height) && imgRef.current && previewCanvasRef.current) {
            // We use canvasPreview as it's much faster than imgPreview.
            const file = await canvasPreview(imgRef.current, previewCanvasRef.current, completedCrop, scale);
            setFile(file);
        }
    }, 100, [
        completedCrop,
        scale,
        rotate
    ]);
    const onDrop = (acceptedFiles)=>{
        setFiles(acceptedFiles.map((file)=>{
            setImage(file);
            setCrop(undefined) // Makes crop preview update between images.
            ;
            setImgSrc(URL.createObjectURL(file));
        }));
    };
    const onDropImage = ()=>{
        setImgSrc("");
        setImage(null);
        setImageSmall(null);
    };
    const { getRootProps , getInputProps  } = (0,es/* useDropzone */.uI)({
        accept: {
            "image/jpeg": [
                ".jpeg",
                ".png"
            ]
        },
        maxFiles: 1,
        multiple: false,
        onDrop
    });
    (0,react.useEffect)(()=>{
        if (file) {
            setImageSmall(new File([
                file
            ], image === null || image === void 0 ? void 0 : image.name, {
                type: file === null || file === void 0 ? void 0 : file.type
            }));
        }
    }, [
        file
    ]);
    const onChangeScaleImage = (value)=>{
        if (imgRef && (imgRef === null || imgRef === void 0 ? void 0 : imgRef.current)) {
            imgRef.current.style.transform = "scale(".concat(value, ")");
        }
        setScale(value);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                ...getRootProps(),
                children: !imgSrc && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "rounded-[24px] bg-[rgba(0, 0, 0, 0.06)] border border-dashed dark:border-0 border-[#BDBDBD] w-full h-[220px] cursor-pointer flex items-center justify-center bg-bg-disable rounded-[24px] dark:bg-[#DAD9FE1A] opacity-100 active:opacity-60 outline-none",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                            ref: fileInput,
                            autoFocus: false,
                            type: "file",
                            accept: "image/*",
                            onChange: onSelectFile,
                            onClick: (event)=>{
                                event.target.value = "";
                            },
                            className: "hidden",
                            multiple: false,
                            ...getInputProps()
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "flex items-center justify-center gap-3 ",
                            onClick: ()=>{
                                var _fileInput_current;
                                return (fileInput === null || fileInput === void 0 ? void 0 : fileInput.current) && (fileInput === null || fileInput === void 0 ? void 0 : (_fileInput_current = fileInput.current) === null || _fileInput_current === void 0 ? void 0 : _fileInput_current.click());
                            },
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "w-[48px] h-[48px] flex items-center justify-center bg-main-disable-02 rounded-[16px]",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
                                        width: "24",
                                        height: "24",
                                        viewBox: "0 0 24 24",
                                        fill: "none",
                                        xmlns: "http://www.w3.org/2000/svg",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                            fillRule: "evenodd",
                                            clipRule: "evenodd",
                                            d: "M2.75 6C2.75 4.20507 4.20507 2.75 6 2.75H14C14.4142 2.75 14.75 2.41421 14.75 2C14.75 1.58579 14.4142 1.25 14 1.25H6C3.37665 1.25 1.25 3.37665 1.25 6V18C1.25 20.6234 3.37665 22.75 6 22.75H18C20.6234 22.75 22.75 20.6234 22.75 18V10C22.75 9.58579 22.4142 9.25 22 9.25C21.5858 9.25 21.25 9.58579 21.25 10V13.5091C21.2049 13.473 21.158 13.4387 21.1094 13.4063L18.7285 11.819C17.142 10.7613 15.0295 10.9705 13.6812 12.3188L10.3188 15.6812C8.9705 17.0295 6.85802 17.2387 5.27153 16.181L2.75 14.5V6ZM19.75 2C19.75 1.58579 19.4142 1.25 19 1.25C18.5858 1.25 18.25 1.58579 18.25 2V4.25H16C15.5858 4.25 15.25 4.58579 15.25 5C15.25 5.41421 15.5858 5.75 16 5.75H18.25V8C18.25 8.41421 18.5858 8.75 19 8.75C19.4142 8.75 19.75 8.41421 19.75 8V5.75H22C22.4142 5.75 22.75 5.41421 22.75 5C22.75 4.58579 22.4142 4.25 22 4.25H19.75V2ZM8.5 11C9.88071 11 11 9.88071 11 8.5C11 7.11929 9.88071 6 8.5 6C7.11929 6 6 7.11929 6 8.5C6 9.88071 7.11929 11 8.5 11Z",
                                            fill: "#7673E6"
                                        })
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "flex flex-col justify-center",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                            className: "text-base text-bg-01 Nunito-700 dark:text-white",
                                            children: "Tải ảnh l\xean"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                            className: "text-base text-bg-01 Nunito-400 dark:text-white",
                                            children: t("news.drag_drop")
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                })
            }),
            !!imgSrc && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "w-full bg-black p-3 relative flex justify-center rounded-[24px]",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(X, {
                                crop: crop,
                                onChange: (_, percentCrop)=>setCrop(percentCrop),
                                onComplete: (c)=>setCompletedCrop(c),
                                aspect: size,
                                className: "center",
                                circularCrop: true,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                    ref: imgRef,
                                    alt: "Crop me",
                                    src: imgSrc,
                                    className: "object-cover bg-black",
                                    style: {
                                        transform: "scale(".concat(1, ") rotate(", 0, "deg)"),
                                        aspectRatio: 1,
                                        width: "100%"
                                    },
                                    onLoad: onImageLoad
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "w-[28px] h-[28px] flex justify-center items-center cursor-pointer z-10 absolute top-[8px] right-[8px] bg-black rounded-[28px]",
                                onClick: onDropImage,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(IconClose/* IconClose */.b, {})
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ZoomSlider, {
                            min: MIN_VALUE,
                            max: MAX_VALUE,
                            step: STEP,
                            minVal: minVal,
                            setMinVal: setMinVal,
                            onChangeScaleImage: onChangeScaleImage
                        })
                    })
                ]
            }),
            !!completedCrop && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "hidden",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("canvas", {
                    ref: previewCanvasRef,
                    style: {
                        objectFit: "contain",
                        width: completedCrop.width,
                        height: completedCrop.height
                    }
                })
            })
        ]
    });
}

// EXTERNAL MODULE: ./app/components/ui/button.tsx
var ui_button = __webpack_require__(34428);
// EXTERNAL MODULE: ./app/components/ui/dialog.tsx
var dialog = __webpack_require__(76500);
// EXTERNAL MODULE: ./app/configs/index.ts + 3 modules
var configs = __webpack_require__(54254);
// EXTERNAL MODULE: ./app/services/query-fn/user/setting-mutation.ts
var setting_mutation = __webpack_require__(88663);
// EXTERNAL MODULE: ./node_modules/@tanstack/react-query/build/modern/QueryClientProvider.js
var QueryClientProvider = __webpack_require__(30202);
;// CONCATENATED MODULE: ./app/containers/users/common/modal/ModalUploadImage.tsx










const ModalUploadImage = (props)=>{
    const { open , onClose  } = props;
    const { t  } = (0,esm/* useTranslation */.$G)();
    const [image, setImage] = (0,react.useState)();
    const [imageSmall, setImageSmall] = (0,react.useState)();
    const queryClient = (0,QueryClientProvider/* useQueryClient */.NL)();
    const { mutate: mutateUploadAvatar , isPending  } = (0,setting_mutation/* useMutationUploadAvatar */.$6)();
    const onUpload = ()=>{
        const formData = new FormData();
        formData.append("avatar", image);
        formData.append("small_avatar", imageSmall);
        mutateUploadAvatar(formData, {
            onSuccess (data, variables, context) {
                queryClient.invalidateQueries({
                    queryKey: [
                        configs/* QUERY_KEY.PROFILE_INFO */.lP.PROFILE_INFO
                    ],
                    refetchType: "active"
                });
                onClose();
            }
        });
    };
    const onCancelUpload = ()=>{
        setImage(undefined);
        setImageSmall(undefined);
        onClose();
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(dialog/* Dialog */.Vq, {
        open: open,
        onOpenChange: onClose,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(dialog/* DialogContent */.cZ, {
            className: "rounded-[16px] sm:rounded-[16px] w-[90vw] md:w-[528px] p-[24px] outline-none",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(dialog/* DialogHeader */.fK, {
                    className: "flex flex-row items-center justify-between w-full",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                            className: "Nunito-700 text-[16px] text-bg-01 dark:text-white",
                            children: t("profile.avatar")
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "cursor-pointer",
                            onClick: onClose,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(IconClose/* IconClose */.b, {})
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "outline-none",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(CropImage, {
                            size: 1,
                            setImageSmall: setImageSmall,
                            setImage: setImage,
                            image: image
                        }),
                        image && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "mt-[32px] flex justify-end gap-4",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(ui_button/* Button */.z, {
                                    variant: "none",
                                    className: "bg-bg-button rounded-[16px] text-bg-01 Nunito-700",
                                    onClick: onCancelUpload,
                                    children: t("common.cancel")
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(ui_button/* Button */.z, {
                                    variant: "none",
                                    disabled: isPending,
                                    onClick: onUpload,
                                    className: "bg-main-01 rounded-[16px] text-white Nunito-700",
                                    children: t("profile.save")
                                })
                            ]
                        })
                    ]
                })
            ]
        })
    });
};


/***/ }),

/***/ 90591:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "g": function() { return /* binding */ RequireVerifiedModal; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(41844);
/* harmony import */ var next_i18next__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(93378);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(55784);
/* harmony import */ var _app_components_ui_dialog__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(76500);
/* harmony import */ var _app_components_ui_button__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(34428);
/* harmony import */ var _app_configs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(54254);
/* harmony import */ var jwt_decode__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(61202);
/* harmony import */ var _app_helpers__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(2993);
/* harmony import */ var _app_context__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(17986);










const RequireVerifiedModal = (param)=>{
    let { open  } = param;
    const router = (0,next_router__WEBPACK_IMPORTED_MODULE_2__.useRouter)();
    const { t  } = (0,next_i18next__WEBPACK_IMPORTED_MODULE_1__/* .useTranslation */ .$G)();
    const { userInfo  } = (0,react__WEBPACK_IMPORTED_MODULE_3__.useContext)(_app_context__WEBPACK_IMPORTED_MODULE_9__/* .AppContext */ .Il);
    const onNavigate = ()=>{
        if (_app_configs__WEBPACK_IMPORTED_MODULE_6__/* .isClient */ .C5) {
            const token = localStorage.getItem("token");
            if (token) {
                var _decodeToken_data;
                const decodeToken = (0,jwt_decode__WEBPACK_IMPORTED_MODULE_7__/* .jwtDecode */ .o)(token);
                const _callback = !!(userInfo === null || userInfo === void 0 ? void 0 : userInfo.email) ? "/user/verify_email" : "/user/update_email";
                router.push("https://id.gamota.com/authorize?access_token=".concat(decodeToken === null || decodeToken === void 0 ? void 0 : (_decodeToken_data = decodeToken.data) === null || _decodeToken_data === void 0 ? void 0 : _decodeToken_data.id, "&callback=").concat(_callback, "&redirect=").concat(window.location.href, "?update=1"));
            }
        }
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_app_components_ui_dialog__WEBPACK_IMPORTED_MODULE_4__/* .Dialog */ .Vq, {
        open: open,
        onOpenChange: _app_helpers__WEBPACK_IMPORTED_MODULE_8__/* .doNothing */ .cn,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_app_components_ui_dialog__WEBPACK_IMPORTED_MODULE_4__/* .DialogContent */ .cZ, {
            className: "sm:rounded-[24px] max-w-[95vw] md:max-w-fit p-[24px] border-0 focus-visible:outline-none w-fit rounded-[24px] min-w-[300px] dark:bg-bg-02",
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: "flex flex-col items-center w-full",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                        className: "text-base text-center align-middle w-fit Nunito-700 text-bg-01 dark:text-white",
                        children: t("profile.account_not_verified")
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "flex items-center justify-center w-full mt-[24px] gap-[16px]",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_app_components_ui_button__WEBPACK_IMPORTED_MODULE_5__/* .Button */ .z, {
                            variant: "main",
                            className: "text-sm text-white Nunito-700 rounded-[8px] outline-none focus:outline-none",
                            onClick: onNavigate,
                            children: t("reward.verify_now")
                        })
                    })
                ]
            })
        })
    });
};


/***/ }),

/***/ 66351:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "NZ": function() { return /* reexport */ Profile; },
  "J0": function() { return /* reexport */ SavedPost; },
  "wt": function() { return /* reexport */ TransactionManager; },
  "Uu": function() { return /* reexport */ enumTypeGold; },
  "a3": function() { return /* reexport */ enumTypeGoldViewAll; },
  "bi": function() { return /* reexport */ enumTypeTransaction; },
  "vh": function() { return /* reexport */ enumTypeViewAll; },
  "p_": function() { return /* reexport */ enumViewDetailTransaction; }
});

// UNUSED EXPORTS: JoinedEvent, initialFilterEvent, initialFilterPost

// EXTERNAL MODULE: ./node_modules/next/dist/compiled/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(41844);
// EXTERNAL MODULE: ./app/components/icon-tsx/index.ts + 11 modules
var icon_tsx = __webpack_require__(61552);
// EXTERNAL MODULE: ./app/components/post-event/PostEvent.tsx
var post_event_PostEvent = __webpack_require__(78121);
// EXTERNAL MODULE: ./app/services/query-fn/event/index.ts + 1 modules
var query_fn_event = __webpack_require__(54583);
// EXTERNAL MODULE: ./node_modules/next-i18next/dist/esm/index.js + 41 modules
var esm = __webpack_require__(93378);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/react/index.js
var react = __webpack_require__(55784);
// EXTERNAL MODULE: ./app/containers/users/common/filter-post/FilterPostEvent.tsx + 1 modules
var filter_post_FilterPostEvent = __webpack_require__(79786);
// EXTERNAL MODULE: ./app/context/index.ts + 2 modules
var context = __webpack_require__(17986);
// EXTERNAL MODULE: ./app/hooks/useDebounceEffect.tsx
var hooks_useDebounceEffect = __webpack_require__(45724);
// EXTERNAL MODULE: ./app/components/data-empty/index.tsx + 1 modules
var data_empty = __webpack_require__(98269);
;// CONCATENATED MODULE: ./app/containers/users/normal-user/tab/JoinedEvent.tsx













const initialFilterEvent = {
    keyword: "",
    sort: -1
};
// eslint-disable-next-line react/display-name
const JoinedEvent = ()=>{
    var _listEvent_pages_flat, _listEvent_pages, _listEvent_pages_flat1, _listEvent_pages1;
    const { t  } = useTranslation();
    const { themeApp  } = useContext(AppContext);
    const [tempSearch, setTempSearch] = useState("");
    const methods = useForm({
        defaultValues: initialFilterEvent
    });
    const watchKeyword = methods.watch("keyword", "");
    const watchSort = methods.watch("sort", -1);
    const { data: listEvent , fetchNextPage  } = useQueryGetListEventByType(removeNullKeyObject({
        type: "joined",
        keyword: watchKeyword,
        sort: watchSort
    }), true);
    const onChange = (e)=>{
        var _e_target;
        setTempSearch(e === null || e === void 0 ? void 0 : (_e_target = e.target) === null || _e_target === void 0 ? void 0 : _e_target.value);
    };
    useDebounceEffect(()=>methods.setValue("keyword", tempSearch), 300, [
        tempSearch
    ]);
    const { ref , inView  } = useInView();
    React.useEffect(()=>{
        if (inView) {
            fetchNextPage();
        }
    }, [
        fetchNextPage,
        inView
    ]);
    return /*#__PURE__*/ _jsxs("div", {
        className: "mt-4 md:mt-[32px] relative z-10",
        children: [
            /*#__PURE__*/ _jsx("div", {
                className: "flex items-center justify-between w-full",
                children: /*#__PURE__*/ _jsxs(FormProvider, {
                    ...methods,
                    children: [
                        /*#__PURE__*/ _jsx("div", {
                            className: "max-w-[320px]",
                            children: /*#__PURE__*/ _jsxs("div", {
                                className: "flex items-center justify-between border-b-[1px] dark:border-neutral-04 gap-4 py-3",
                                children: [
                                    /*#__PURE__*/ _jsx(IconSearch, {
                                        fill: themeApp === "dark" ? "#7673E5" : "#100D28",
                                        className: "w-[20px] h-[20px]"
                                    }),
                                    /*#__PURE__*/ _jsx("input", {
                                        type: "text",
                                        value: tempSearch,
                                        className: "flex-1 text-sm bg-transparent border-0 outline-none",
                                        placeholder: t("profile.find_event_placeholder"),
                                        onChange: onChange
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ _jsx(FilterPostEvent, {})
                    ]
                })
            }),
            !!listEvent && !!((_listEvent_pages_flat = listEvent === null || listEvent === void 0 ? void 0 : (_listEvent_pages = listEvent.pages) === null || _listEvent_pages === void 0 ? void 0 : _listEvent_pages.flat()) === null || _listEvent_pages_flat === void 0 ? void 0 : _listEvent_pages_flat.length) ? /*#__PURE__*/ _jsx("div", {
                className: "w-full mt-[24px]",
                children: React.Children.toArray((_listEvent_pages_flat1 = listEvent === null || listEvent === void 0 ? void 0 : (_listEvent_pages1 = listEvent.pages) === null || _listEvent_pages1 === void 0 ? void 0 : _listEvent_pages1.flat()) === null || _listEvent_pages_flat1 === void 0 ? void 0 : _listEvent_pages_flat1.map((item)=>/*#__PURE__*/ _jsx(PostEvent, {
                        event: item
                    })))
            }) : /*#__PURE__*/ _jsx("div", {
                className: "w-full flex items-center justify-center h-[200px]",
                children: /*#__PURE__*/ _jsx(DataEmpty, {
                    title: t("profile.no_data")
                })
            }),
            /*#__PURE__*/ _jsx("button", {
                ref: ref,
                className: "opacity-0",
                children: "Load more"
            })
        ]
    });
};

// EXTERNAL MODULE: ./app/containers/users/common/index.ts + 12 modules
var common = __webpack_require__(75025);
;// CONCATENATED MODULE: ./app/containers/users/normal-user/tab/Profile.tsx



const Profile = ()=>{
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "w-full",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(common/* SettingUserInfomation */.d_, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(common/* SettingWeb */.wd, {})
        ]
    });
};

// EXTERNAL MODULE: ./app/components/PostCard/index.tsx
var PostCard = __webpack_require__(4547);
// EXTERNAL MODULE: ./app/services/query-fn/news/index.ts + 4 modules
var news = __webpack_require__(31033);
// EXTERNAL MODULE: ./node_modules/react-intersection-observer/index.mjs
var react_intersection_observer = __webpack_require__(42708);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./node_modules/react-hook-form/dist/index.esm.mjs
var index_esm = __webpack_require__(87536);
;// CONCATENATED MODULE: ./app/containers/users/normal-user/tab/SavedPost.tsx













const initialFilterPost = {
    keyword: "",
    sort: -1
};
const SavedPost = ()=>{
    var _listNews_pages_flat, _listNews_pages, _listNews_pages_flat1, _listNews_pages1;
    const { t  } = (0,esm/* useTranslation */.$G)();
    const router = (0,next_router.useRouter)();
    const { themeApp  } = (0,react.useContext)(context/* AppContext */.Il);
    const id = (0,react.useMemo)(()=>{
        var _router_query;
        return router === null || router === void 0 ? void 0 : (_router_query = router.query) === null || _router_query === void 0 ? void 0 : _router_query.id;
    }, [
        router
    ]);
    const [tempSearch, setTempSearch] = (0,react.useState)("");
    const methods = (0,index_esm/* useForm */.cI)({
        defaultValues: initialFilterPost
    });
    const watchKeyword = methods.watch("keyword", "");
    const watchSort = methods.watch("sort", -1);
    const { data: listNews , fetchNextPage  } = (0,news/* useQueryGetListStoredNews */.Fy)(watchKeyword, watchSort);
    const onChange = (e)=>{
        var _e_target;
        setTempSearch(e === null || e === void 0 ? void 0 : (_e_target = e.target) === null || _e_target === void 0 ? void 0 : _e_target.value);
    };
    (0,hooks_useDebounceEffect/* useDebounceEffect */.s)(()=>methods.setValue("keyword", tempSearch), 300, [
        tempSearch
    ]);
    const { ref , inView  } = (0,react_intersection_observer/* useInView */.YD)();
    react.useEffect(()=>{
        if (inView) {
            fetchNextPage();
        }
    }, [
        fetchNextPage,
        inView
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "mt-4 md:mt-[32px] relative z-10",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "flex items-center justify-between w-full",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_esm/* FormProvider */.RV, {
                    ...methods,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "max-w-[320px]",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "flex items-center justify-between border-b-[1px] dark:border-neutral-04 gap-4 py-3",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(icon_tsx/* IconSearch */.jV, {
                                        fill: themeApp === "dark" ? "#7673E5" : "#100D28",
                                        className: "w-[20px] h-[20px]"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                        type: "text",
                                        value: tempSearch,
                                        className: "flex-1 text-sm bg-transparent border-0 outline-none",
                                        placeholder: t("profile.find_news_placeholder"),
                                        onChange: onChange
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(filter_post_FilterPostEvent/* FilterPostEvent */.n, {})
                    ]
                })
            }),
            !!listNews && !!((_listNews_pages_flat = listNews === null || listNews === void 0 ? void 0 : (_listNews_pages = listNews.pages) === null || _listNews_pages === void 0 ? void 0 : _listNews_pages.flat()) === null || _listNews_pages_flat === void 0 ? void 0 : _listNews_pages_flat.length) ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "w-full mt-[24px] space-y-[24px]",
                children: react.Children.toArray((_listNews_pages_flat1 = listNews === null || listNews === void 0 ? void 0 : (_listNews_pages1 = listNews.pages) === null || _listNews_pages1 === void 0 ? void 0 : _listNews_pages1.flat()) === null || _listNews_pages_flat1 === void 0 ? void 0 : _listNews_pages_flat1.map((item)=>/*#__PURE__*/ (0,jsx_runtime.jsx)(PostCard/* PostCard */.y, {
                        postcard: item,
                        isCheckHashtag: true
                    })))
            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "w-full flex items-center justify-center h-[200px]",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(data_empty/* DataEmpty */.$, {
                    title: t("profile.no_data")
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                ref: ref,
                className: "opacity-0",
                children: "Load more"
            })
        ]
    });
};

// EXTERNAL MODULE: ./app/components/ui/button.tsx
var ui_button = __webpack_require__(34428);
// EXTERNAL MODULE: ./app/components/icon-tsx/IconArrowLeft.tsx
var IconArrowLeft = __webpack_require__(82341);
// EXTERNAL MODULE: ./app/components/icon-tsx/IconArrowRight.tsx
var IconArrowRight = __webpack_require__(99777);
// EXTERNAL MODULE: ./app/components/ui/dropdown-menu.tsx + 2 modules
var dropdown_menu = __webpack_require__(27357);
// EXTERNAL MODULE: ./app/containers/users/common/filter-post/StartTime.tsx
var StartTime = __webpack_require__(25193);
// EXTERNAL MODULE: ./app/containers/users/common/filter-post/EndTime.tsx
var EndTime = __webpack_require__(53064);
;// CONCATENATED MODULE: ./app/containers/users/normal-user/component/filter-all/FilterAll.tsx











const FilterAllTransaction = ()=>{
    const { setValue , watch  } = (0,index_esm/* useFormContext */.Gc)();
    const { themeApp  } = (0,react.useContext)(context/* AppContext */.Il);
    const { t  } = (0,esm/* useTranslation */.$G)();
    const [openFilter, setOpenFilter] = (0,react.useState)(false);
    const [openStartTime, setOpenStartTime] = (0,react.useState)(false);
    const [tempSearch, setTempSearch] = (0,react.useState)("");
    const selectedStartTime = watch("start_date", undefined);
    const selectedEndTime = watch("end_date", undefined);
    const onChange = (e)=>{
        var _e_target;
        setTempSearch(e === null || e === void 0 ? void 0 : (_e_target = e.target) === null || _e_target === void 0 ? void 0 : _e_target.value);
    };
    (0,hooks_useDebounceEffect/* useDebounceEffect */.s)(()=>setValue("keyword", tempSearch), 300, [
        tempSearch
    ]);
    const onChangeStartTime = ()=>{
        setOpenStartTime(!openStartTime);
    };
    const [openEndTime, setOpenEndTime] = (0,react.useState)(false);
    const onChangeEndTime = ()=>{
        setOpenEndTime(!openEndTime);
    };
    const clearFilter = ()=>{
        setValue("start_date", undefined);
        setValue("end_date", undefined);
        setOpenFilter(false);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "md:max-w-[280px] w-full flex items-center justify-between border-b-[1px] px-[16px] py-[8px]",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "flex items-center justify-between gap-[12px]",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(icon_tsx/* IconSearch */.jV, {
                        fill: themeApp === "dark" ? "#7673E5" : "#100D28",
                        className: "w-[16px] h-[16px]"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                        type: "text",
                        className: "flex-1 text-sm bg-transparent border-0 outline-none",
                        placeholder: t("profile.search"),
                        onChange: onChange
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(dropdown_menu/* DropdownMenu */.h_, {
                open: openFilter,
                onOpenChange: ()=>setOpenFilter(false),
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(dropdown_menu/* DropdownMenuTrigger */.$F, {
                        asChild: true,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
                            width: "16",
                            height: "17",
                            viewBox: "0 0 16 17",
                            fill: "none",
                            xmlns: "http://www.w3.org/2000/svg",
                            className: "cursor-pointer",
                            onClick: ()=>setOpenFilter(true),
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                d: "M2 5.1665H4M4 5.1665C4 6.27107 4.89543 7.1665 6 7.1665C7.10457 7.1665 8 6.27107 8 5.1665C8 4.06193 7.10457 3.1665 6 3.1665C4.89543 3.1665 4 4.06193 4 5.1665ZM2 11.8332H6M12 11.8332H14M12 11.8332C12 12.9377 11.1046 13.8332 10 13.8332C8.89543 13.8332 8 12.9377 8 11.8332C8 10.7286 8.89543 9.83317 10 9.83317C11.1046 9.83317 12 10.7286 12 11.8332ZM10 5.1665H14",
                                stroke: themeApp === "dark" ? "#7673E5" : "#100D28",
                                strokeWidth: "1.5",
                                strokeLinecap: "round"
                            })
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(dropdown_menu/* DropdownMenuContent */.AW, {
                        align: "end",
                        className: "min-w-[281px] rounded-[24px] px-[16px] py-[24px] overflow-visible dark:bg-[#30303A]",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "w-full bg-white dark:bg-[#30303A]",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                    className: "text-base Nunito-600 text-neutral-03 dark:text-white",
                                    children: t("profile.time_title")
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "flex flex-col items-center gap-[12px]",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(StartTime/* StartTimeFilter */.M, {
                                            open: openStartTime,
                                            onChange: onChangeStartTime
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(EndTime/* EndTimeFilter */.o, {
                                            open: openEndTime,
                                            onChange: onChangeEndTime
                                        })
                                    ]
                                }),
                                selectedStartTime >= selectedEndTime && /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                    className: "mt-2 text-xs text-main-red-02",
                                    children: t("profile.invalid_date")
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "w-full flex items-center justify-end gap-[16px] mt-[24px]",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(ui_button/* Button */.z, {
                                            variant: "none",
                                            className: "text-base bg-bg-button text-neutral Nunito-700 h-[30px] py-[6px] px-[24px] rounded-[12px]",
                                            autoFocus: false,
                                            onClick: clearFilter,
                                            children: t("merchandise.cancel")
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(ui_button/* Button */.z, {
                                            variant: "none",
                                            disabled: !selectedStartTime || !selectedEndTime || selectedStartTime > selectedEndTime,
                                            className: "text-base text-white bg-main-01 h-[30px] Nunito-700 py-[6px] px-[24px] rounded-[12px]",
                                            onClick: ()=>setOpenFilter(false),
                                            children: t("profile.filter")
                                        })
                                    ]
                                })
                            ]
                        })
                    })
                ]
            })
        ]
    });
};

;// CONCATENATED MODULE: ./app/containers/users/normal-user/component/main-purchase/PurchaseHeader.tsx









const PurchaseHeader = (param)=>{
    let { prevRef , nextRef , handleChangeTab  } = param;
    var _String, _router_query, _router_query1, _router_query2, _router_query3, _String1, _router_query4;
    const { t  } = (0,esm/* useTranslation */.$G)();
    const router = (0,next_router.useRouter)();
    const onNavigateToStore = ()=>{
        router.push("/store");
    };
    return !((_String = String(router === null || router === void 0 ? void 0 : (_router_query = router.query) === null || _router_query === void 0 ? void 0 : _router_query.type)) === null || _String === void 0 ? void 0 : _String.includes("detail")) ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "flex gap-[32px] items-center",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        className: "text-base Nunito-700 text-bg-01 dark:text-white",
                        children: t("profile.buy")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "flex items-center gap-2 opacity-100 cursor-pointer active:opacity-70",
                        onClick: onNavigateToStore,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                className: "text-sm text-main-01 Nunito-500",
                                children: t("store.title")
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
                                width: "14",
                                height: "10",
                                viewBox: "0 0 14 10",
                                fill: "none",
                                xmlns: "http://www.w3.org/2000/svg",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                    fillRule: "evenodd",
                                    clipRule: "evenodd",
                                    d: "M13.5303 5.53033C13.8232 5.23744 13.8232 4.76256 13.5303 4.46967L9.53033 0.46967C9.23744 0.176777 8.76256 0.176777 8.46967 0.46967C8.17678 0.762563 8.17678 1.23744 8.46967 1.53033L11.1893 4.25H1C0.585787 4.25 0.25 4.58579 0.25 5C0.25 5.41421 0.585787 5.75 1 5.75H11.1893L8.46967 8.46967C8.17678 8.76256 8.17678 9.23744 8.46967 9.53033C8.76256 9.82322 9.23744 9.82322 9.53033 9.53033L13.5303 5.53033Z",
                                    fill: "#7673E6"
                                })
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "flex flex-col-reverse md:flex-row gap-4 md:items-center md:justify-between w-full",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "flex items-cente gap-[8px]",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(ui_button/* Button */.z, {
                                variant: "none",
                                className: "px-[16px] py-1 border rounded-[8px] Nunito-400 text-sm h-[29px] ".concat([
                                    "undefined",
                                    String(enumTypeTransaction.CARD),
                                    String(enumTypeViewAll.CARD_ALL),
                                    String(enumViewDetailTransaction.CARD_DETAIL)
                                ].includes(String(router === null || router === void 0 ? void 0 : (_router_query1 = router.query) === null || _router_query1 === void 0 ? void 0 : _router_query1.type)) ? "text-main-01 border-main-01" : "border-black/10 text-neutral-03 dark:border-neutral-08 dark:text-neutral-07"),
                                onClick: ()=>handleChangeTab(enumTypeTransaction.CARD),
                                children: t("profile.card")
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(ui_button/* Button */.z, {
                                variant: "none",
                                className: "px-[16px] py-1 border rounded-[8px] Nunito-400 text-sm h-[29px] ".concat([
                                    String(enumTypeTransaction.TOPUP),
                                    String(enumTypeViewAll.TOPUP_ALL),
                                    String(enumViewDetailTransaction.TOPUP_DETAIL)
                                ].includes(String(router === null || router === void 0 ? void 0 : (_router_query2 = router.query) === null || _router_query2 === void 0 ? void 0 : _router_query2.type)) ? "text-main-01 border-main-01" : "border-black/10 text-neutral-03 dark:border-neutral-08 dark:text-neutral-07"),
                                onClick: ()=>handleChangeTab(enumTypeTransaction.TOPUP),
                                children: t("profile.topup")
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(ui_button/* Button */.z, {
                                variant: "none",
                                className: "px-[16px] py-1 border rounded-[8px] Nunito-400 text-sm h-[29px] ".concat([
                                    String(enumTypeTransaction.MERCHANDISE),
                                    String(enumTypeViewAll.MERCHANDISE_ALL),
                                    String(enumViewDetailTransaction.MERCHANDISE_DETAIL)
                                ].includes(String(router === null || router === void 0 ? void 0 : (_router_query3 = router.query) === null || _router_query3 === void 0 ? void 0 : _router_query3.type)) ? "text-main-01 border-main-01" : "border-black/10 text-neutral-03 dark:border-neutral-08 dark:text-neutral-07"),
                                onClick: ()=>handleChangeTab(enumTypeTransaction.MERCHANDISE),
                                children: "Merchandise"
                            })
                        ]
                    }),
                    ((_String1 = String(router === null || router === void 0 ? void 0 : (_router_query4 = router.query) === null || _router_query4 === void 0 ? void 0 : _router_query4.type)) === null || _String1 === void 0 ? void 0 : _String1.includes("all")) ? /*#__PURE__*/ (0,jsx_runtime.jsx)(FilterAllTransaction, {}) : /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "hidden md:flex items-center gap-[8px] ml-auto",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "p-[2px] rounded-[10px] border border-main-01 cursor-pointer",
                                onClick: ()=>{
                                    (prevRef === null || prevRef === void 0 ? void 0 : prevRef.current) && prevRef.current.click();
                                },
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(IconArrowLeft/* IconArrowLeft */.D, {})
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "p-[2px] rounded-[10px] border border-main-01 cursor-pointer",
                                onClick: ()=>{
                                    (nextRef === null || nextRef === void 0 ? void 0 : nextRef.current) && nextRef.current.click();
                                },
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(IconArrowRight/* IconArrowRight */.E, {})
                            })
                        ]
                    })
                ]
            })
        ]
    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {});
};

// EXTERNAL MODULE: ./app/services/services/TopupService.ts
var TopupService = __webpack_require__(74617);
// EXTERNAL MODULE: ./node_modules/@tanstack/react-query/build/modern/useInfiniteQuery.js + 1 modules
var useInfiniteQuery = __webpack_require__(29726);
// EXTERNAL MODULE: ./app/configs/index.ts + 3 modules
var configs = __webpack_require__(54254);
// EXTERNAL MODULE: ./app/services/services/StoreServices.tsx
var StoreServices = __webpack_require__(50803);
// EXTERNAL MODULE: ./app/services/services/index.ts + 2 modules
var services = __webpack_require__(27020);
// EXTERNAL MODULE: ./app/services/services/MerchandiseService.tsx
var MerchandiseService = __webpack_require__(82303);
;// CONCATENATED MODULE: ./app/services/query-fn/user/user-tab-query.ts







const getTopupTransaction = async (param)=>{
    var _res_data;
    const res = await TopupService/* default.getPaymentHistory */.Z.getPaymentHistory(param);
    return res === null || res === void 0 ? void 0 : (_res_data = res.data) === null || _res_data === void 0 ? void 0 : _res_data.data;
};
const getCardTransaction = async (param)=>{
    var _res_data;
    const res = await StoreServices/* default.getPaymentHistory */.Z.getPaymentHistory(param);
    return res === null || res === void 0 ? void 0 : (_res_data = res.data) === null || _res_data === void 0 ? void 0 : _res_data.data;
};
const getUserPointHistory = async (param)=>{
    var _res_data;
    const res = await services/* UserService.getUserPointHistory */.K.getUserPointHistory(param);
    return res === null || res === void 0 ? void 0 : (_res_data = res.data) === null || _res_data === void 0 ? void 0 : _res_data.data;
};
const getMerchandiseTransaction = async (param)=>{
    var _res_data;
    const res = await MerchandiseService/* MerchandiseService.getPaymentMerchandiseHistory */.f.getPaymentMerchandiseHistory(param);
    return res === null || res === void 0 ? void 0 : (_res_data = res.data) === null || _res_data === void 0 ? void 0 : _res_data.data;
};
const useQueryGetUserPointHistory = (param, userId)=>{
    return (0,useInfiniteQuery/* useInfiniteQuery */.N)({
        queryKey: [
            configs/* QUERY_KEY.POINT_HISTORY */.lP.POINT_HISTORY,
            userId,
            param
        ],
        queryFn: (param1)=>{
            let { pageParam  } = param1;
            return getUserPointHistory({
                ...param,
                page: pageParam
            });
        },
        initialPageParam: 1,
        getNextPageParam: (lastPage, pages)=>{
            return (lastPage === null || lastPage === void 0 ? void 0 : lastPage.length) > 9 ? (pages === null || pages === void 0 ? void 0 : pages.length) + 1 : undefined;
        },
        enabled: !!userId && userId !== "undefined"
    });
};
const useQueryGetUserMerchandiseHistory = (param, userId, type)=>{
    return (0,useInfiniteQuery/* useInfiniteQuery */.N)({
        queryKey: [
            configs/* QUERY_KEY.MERCHANDISE_HISTORY */.lP.MERCHANDISE_HISTORY,
            userId,
            param
        ],
        queryFn: (param1)=>{
            let { pageParam  } = param1;
            return getMerchandiseTransaction({
                ...param,
                page: pageParam
            });
        },
        initialPageParam: 1,
        getNextPageParam: (lastPage, pages)=>{
            return (lastPage === null || lastPage === void 0 ? void 0 : lastPage.length) > 9 ? (pages === null || pages === void 0 ? void 0 : pages.length) + 1 : undefined;
        },
        enabled: !!userId && userId !== "undefined" && (type === String(enumTypeTransaction.MERCHANDISE) || type === String(enumTypeViewAll.MERCHANDISE_ALL))
    });
};
const useQueryGetTopupTransaction = (param, userId, type)=>{
    return (0,useInfiniteQuery/* useInfiniteQuery */.N)({
        queryKey: [
            configs/* QUERY_KEY.TOPUP_TRANSACTION */.lP.TOPUP_TRANSACTION,
            userId,
            param
        ],
        queryFn: (param1)=>{
            let { pageParam  } = param1;
            return getTopupTransaction({
                ...param,
                page: pageParam
            });
        },
        initialPageParam: 1,
        getNextPageParam: (lastPage, pages)=>{
            return (lastPage === null || lastPage === void 0 ? void 0 : lastPage.length) > 9 ? (pages === null || pages === void 0 ? void 0 : pages.length) + 1 : undefined;
        },
        enabled: !!userId && userId !== "undefined" && type === String(enumTypeTransaction.TOPUP) || type === String(enumTypeViewAll.TOPUP_ALL)
    });
};
const useQueryGetCardTransaction = (param, userId, type)=>{
    return (0,useInfiniteQuery/* useInfiniteQuery */.N)({
        queryKey: [
            configs/* QUERY_KEY.CARD_TRANSACTION */.lP.CARD_TRANSACTION,
            userId,
            param
        ],
        queryFn: (param1)=>{
            let { pageParam  } = param1;
            return getCardTransaction({
                ...param,
                page: pageParam
            });
        },
        initialPageParam: 1,
        getNextPageParam: (lastPage, pages)=>{
            return (lastPage === null || lastPage === void 0 ? void 0 : lastPage.length) > 9 ? (pages === null || pages === void 0 ? void 0 : pages.length) + 1 : undefined;
        },
        enabled: !!userId && userId !== "undefined" && type === String(enumTypeTransaction.CARD) || type === String(enumTypeViewAll.CARD_ALL) || type === "undefined"
    });
};

// EXTERNAL MODULE: ./node_modules/moment/moment.js
var moment = __webpack_require__(30381);
var moment_default = /*#__PURE__*/__webpack_require__.n(moment);
;// CONCATENATED MODULE: ./app/containers/users/normal-user/component/card/ItemCardTransaction.tsx







const ItemCardTransaction = (param)=>{
    let { item , onSelecteData  } = param;
    var _item_items, _item_items1, _item_amount;
    const { t  } = (0,esm/* useTranslation */.$G)();
    const router = (0,next_router.useRouter)();
    const onNavigateToDetail = ()=>{
        var _router_query, _router_query1, _router_query2;
        const type = String(router === null || router === void 0 ? void 0 : (_router_query = router.query) === null || _router_query === void 0 ? void 0 : _router_query.type);
        onSelecteData(item);
        router.push({
            pathname: router.pathname,
            query: {
                id: router === null || router === void 0 ? void 0 : (_router_query1 = router.query) === null || _router_query1 === void 0 ? void 0 : _router_query1.id,
                tab: router === null || router === void 0 ? void 0 : (_router_query2 = router.query) === null || _router_query2 === void 0 ? void 0 : _router_query2.tab,
                type: type === "undefined" ? enumViewDetailTransaction.CARD_DETAIL : "".concat(type === null || type === void 0 ? void 0 : type.replace("-all", ""), "-detail")
            }
        });
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "p-[12px] bg-white dark:bg-white/10 rounded-[16px] w-full cursor-pointer border border-black/10 hover:border-main-01 dark:border-0 space-y-[12px]",
        onClick: onNavigateToDetail,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "flex items-center justify-between",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        className: "text-xs text-neutral-06 Nunito-400 dark:text-neutral-08",
                        children: moment_default().unix(item === null || item === void 0 ? void 0 : item.created_at).format(configs/* DATE_FORMAT_FULL */.Ob)
                    }),
                    !(item === null || item === void 0 ? void 0 : (_item_items = item.items) === null || _item_items === void 0 ? void 0 : _item_items.length) ? /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        className: " text-[#F28585] text-[12px] Nunito-600 rounded-[8px] w-fit line-clamp-1",
                        children: t("store.wait_export_card")
                    }) : (item === null || item === void 0 ? void 0 : (_item_items1 = item.items) === null || _item_items1 === void 0 ? void 0 : _item_items1.every((item)=>{
                        return !(item === null || item === void 0 ? void 0 : item.is_used);
                    })) ? /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        className: " text-[#F28585] text-[12px] Nunito-600 rounded-[8px] w-fit line-clamp-1",
                        children: t("common.available")
                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        className: " text-[#F28585] text-[12px] Nunito-600 rounded-[8px] w-fit line-clamp-1",
                        children: t("reward.used")
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "flex gap-1 sm:flex-row rounded-[8px] w-full",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                        src: item === null || item === void 0 ? void 0 : item.item_icon,
                        alt: item === null || item === void 0 ? void 0 : item.item_name,
                        className: "w-[55px] h-[55px] rounded-[8px] mr-[13px] object-cover"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "flex-1",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "flex items-center justify-between w-full mb-1",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                    className: "text-[14px] Nunito-600 line-clamp-1",
                                    children: item === null || item === void 0 ? void 0 : item.item_name
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                className: "text-[12px] Nunito-400 text-neutral-06 dark:text-neutral-08 line-clamp-1 break-all",
                                children: [
                                    t("profile.item_code_summary"),
                                    ": ",
                                    item === null || item === void 0 ? void 0 : item.transaction_id
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                className: "text-[12px] dark:text-neutral-08",
                                children: [
                                    "x",
                                    item === null || item === void 0 ? void 0 : item.item_quantity
                                ]
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "border-t-[1px] border-dashed border-[rgba(0, 0, 0, 0.10)] flex flex-col gap-[8px] pt-[12px]",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "flex items-center justify-between gap-2",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                            className: "text-xs text-neutral-06 dark:text-neutral-08",
                            children: [
                                t("store.total"),
                                ":"
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                            className: "text-sm text-main-01 Nunito-700 dark:text-main-red-02",
                            children: [
                                item === null || item === void 0 ? void 0 : (_item_amount = item.amount) === null || _item_amount === void 0 ? void 0 : _item_amount.toLocaleString(),
                                "\xa0đ"
                            ]
                        })
                    ]
                })
            })
        ]
    });
};

// EXTERNAL MODULE: ./app/components/ui/carousel.tsx + 5 modules
var carousel = __webpack_require__(32757);
;// CONCATENATED MODULE: ./app/containers/users/normal-user/component/card/CardTransaction.tsx








const LIMIT_CAROUSEL = 8;
const CardTransaction = (param)=>{
    let { prevRef , nextRef , onSelecteData  } = param;
    var _transactions_pages_flat, _transactions_pages, _transactions_pages_flat1, _transactions_pages1;
    const carouselRef = (0,react.useRef)(null);
    const { t  } = (0,esm/* useTranslation */.$G)();
    const router = (0,next_router.useRouter)();
    const userId = (0,react.useMemo)(()=>{
        var _router_query;
        return router === null || router === void 0 ? void 0 : (_router_query = router.query) === null || _router_query === void 0 ? void 0 : _router_query.id;
    }, [
        router
    ]);
    const type = (0,react.useMemo)(()=>{
        var _router_query;
        return router === null || router === void 0 ? void 0 : (_router_query = router.query) === null || _router_query === void 0 ? void 0 : _router_query.type;
    }, [
        router
    ]);
    const { data: transactions  } = useQueryGetCardTransaction({}, String(userId), String(type));
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "relative flex",
            children: !!((_transactions_pages_flat = transactions === null || transactions === void 0 ? void 0 : (_transactions_pages = transactions.pages) === null || _transactions_pages === void 0 ? void 0 : _transactions_pages.flat()) === null || _transactions_pages_flat === void 0 ? void 0 : _transactions_pages_flat.length) ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(carousel/* Carousel */.lr, {
                className: "w-full",
                opts: {
                    align: "start"
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "overflow-auto",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(carousel/* CarouselContent */.KI, {
                            className: "-ml-0 md:-ml-[24px] min-h-[159px]",
                            children: (_transactions_pages_flat1 = transactions === null || transactions === void 0 ? void 0 : (_transactions_pages1 = transactions.pages) === null || _transactions_pages1 === void 0 ? void 0 : _transactions_pages1.flat()) === null || _transactions_pages_flat1 === void 0 ? void 0 : _transactions_pages_flat1.slice(0, LIMIT_CAROUSEL).map((item, i)=>{
                                return /*#__PURE__*/ (0,jsx_runtime.jsx)(carousel/* CarouselItem */.d$, {
                                    className: "md:min-w-0 ".concat(i === 0 ? "basis-4/5 pl-0" : "pl-[8px]", " md:basis-1/2 lg:basis-1/3 2xl:basis-1/3 md:pl-[24px] flex"),
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ItemCardTransaction, {
                                        item: item,
                                        onSelecteData: onSelecteData
                                    }, i)
                                }, i);
                            })
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(carousel/* CarouselNext */.Pz, {
                        ref: nextRef,
                        className: "hidden"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(carousel/* CarouselPrevious */.am, {
                        ref: prevRef,
                        className: "hidden"
                    })
                ]
            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "w-full min-h-[160px] flex items-center justify-center",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(data_empty/* DataEmpty */.$, {
                    title: t("profile.no_data")
                })
            })
        })
    });
};

// EXTERNAL MODULE: ./app/components/icon-tsx/IconCopied.tsx
var IconCopied = __webpack_require__(60303);
// EXTERNAL MODULE: ./app/components/icon-tsx/IconNonCopy.tsx
var IconNonCopy = __webpack_require__(27298);
// EXTERNAL MODULE: ./app/hooks/useGAEventsTracker.ts
var useGAEventsTracker = __webpack_require__(64800);
// EXTERNAL MODULE: ./app/context/AppContext.tsx
var context_AppContext = __webpack_require__(95513);
;// CONCATENATED MODULE: ./node_modules/xlsx/xlsx.mjs
/* provided dependency */ var Buffer = __webpack_require__(20067)["Buffer"];
/* provided dependency */ var process = __webpack_require__(72061);
/*! xlsx.js (C) 2013-present SheetJS -- http://sheetjs.com */
/* vim: set ts=2: */
/*exported XLSX */
/*global process:false, Buffer:false, ArrayBuffer:false, DataView:false, Deno:false */
var XLSX = {};
XLSX.version = '0.18.5';
var current_codepage = 1200, current_ansi = 1252;

var VALID_ANSI = [ 874, 932, 936, 949, 950, 1250, 1251, 1252, 1253, 1254, 1255, 1256, 1257, 1258, 10000 ];
/* ECMA-376 Part I 18.4.1 charset to codepage mapping */
var CS2CP = ({
	/*::[*/0/*::]*/:    1252, /* ANSI */
	/*::[*/1/*::]*/:   65001, /* DEFAULT */
	/*::[*/2/*::]*/:   65001, /* SYMBOL */
	/*::[*/77/*::]*/:  10000, /* MAC */
	/*::[*/128/*::]*/:   932, /* SHIFTJIS */
	/*::[*/129/*::]*/:   949, /* HANGUL */
	/*::[*/130/*::]*/:  1361, /* JOHAB */
	/*::[*/134/*::]*/:   936, /* GB2312 */
	/*::[*/136/*::]*/:   950, /* CHINESEBIG5 */
	/*::[*/161/*::]*/:  1253, /* GREEK */
	/*::[*/162/*::]*/:  1254, /* TURKISH */
	/*::[*/163/*::]*/:  1258, /* VIETNAMESE */
	/*::[*/177/*::]*/:  1255, /* HEBREW */
	/*::[*/178/*::]*/:  1256, /* ARABIC */
	/*::[*/186/*::]*/:  1257, /* BALTIC */
	/*::[*/204/*::]*/:  1251, /* RUSSIAN */
	/*::[*/222/*::]*/:   874, /* THAI */
	/*::[*/238/*::]*/:  1250, /* EASTEUROPE */
	/*::[*/255/*::]*/:  1252, /* OEM */
	/*::[*/69/*::]*/:   6969  /* MISC */
}/*:any*/);

var set_ansi = function(cp/*:number*/) { if(VALID_ANSI.indexOf(cp) == -1) return; current_ansi = CS2CP[0] = cp; };
function reset_ansi() { set_ansi(1252); }

var set_cp = function(cp/*:number*/) { current_codepage = cp; set_ansi(cp); };
function reset_cp() { set_cp(1200); reset_ansi(); }

function char_codes(data/*:string*/)/*:Array<number>*/ { var o/*:Array<number>*/ = []; for(var i = 0, len = data.length; i < len; ++i) o[i] = data.charCodeAt(i); return o; }

function utf16leread(data/*:string*/)/*:string*/ {
	var o/*:Array<string>*/ = [];
	for(var i = 0; i < (data.length>>1); ++i) o[i] = String.fromCharCode(data.charCodeAt(2*i) + (data.charCodeAt(2*i+1)<<8));
	return o.join("");
}
function utf16beread(data/*:string*/)/*:string*/ {
	var o/*:Array<string>*/ = [];
	for(var i = 0; i < (data.length>>1); ++i) o[i] = String.fromCharCode(data.charCodeAt(2*i+1) + (data.charCodeAt(2*i)<<8));
	return o.join("");
}

var debom = function(data/*:string*/)/*:string*/ {
	var c1 = data.charCodeAt(0), c2 = data.charCodeAt(1);
	if(c1 == 0xFF && c2 == 0xFE) return utf16leread(data.slice(2));
	if(c1 == 0xFE && c2 == 0xFF) return utf16beread(data.slice(2));
	if(c1 == 0xFEFF) return data.slice(1);
	return data;
};

var _getchar = function _gc1(x/*:number*/)/*:string*/ { return String.fromCharCode(x); };
var _getansi = function _ga1(x/*:number*/)/*:string*/ { return String.fromCharCode(x); };

var $cptable;
function set_cptable(cptable) {
	$cptable = cptable;
	set_cp = function(cp/*:number*/) { current_codepage = cp; set_ansi(cp); };
	debom = function(data/*:string*/) {
		if(data.charCodeAt(0) === 0xFF && data.charCodeAt(1) === 0xFE) { return $cptable.utils.decode(1200, char_codes(data.slice(2))); }
		return data;
	};
	_getchar = function _gc2(x/*:number*/)/*:string*/ {
		if(current_codepage === 1200) return String.fromCharCode(x);
		return $cptable.utils.decode(current_codepage, [x&255,x>>8])[0];
	};
	_getansi = function _ga2(x/*:number*/)/*:string*/ {
		return $cptable.utils.decode(current_ansi, [x])[0];
	};
	cpdoit();
}

var DENSE = null;
var DIF_XL = true;
var Base64_map = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=";
function Base64_encode(input) {
  var o = "";
  var c1 = 0, c2 = 0, c3 = 0, e1 = 0, e2 = 0, e3 = 0, e4 = 0;
  for (var i = 0; i < input.length; ) {
    c1 = input.charCodeAt(i++);
    e1 = c1 >> 2;
    c2 = input.charCodeAt(i++);
    e2 = (c1 & 3) << 4 | c2 >> 4;
    c3 = input.charCodeAt(i++);
    e3 = (c2 & 15) << 2 | c3 >> 6;
    e4 = c3 & 63;
    if (isNaN(c2)) {
      e3 = e4 = 64;
    } else if (isNaN(c3)) {
      e4 = 64;
    }
    o += Base64_map.charAt(e1) + Base64_map.charAt(e2) + Base64_map.charAt(e3) + Base64_map.charAt(e4);
  }
  return o;
}
function Base64_decode(input) {
  var o = "";
  var c1 = 0, c2 = 0, c3 = 0, e1 = 0, e2 = 0, e3 = 0, e4 = 0;
  input = input.replace(/[^\w\+\/\=]/g, "");
  for (var i = 0; i < input.length; ) {
    e1 = Base64_map.indexOf(input.charAt(i++));
    e2 = Base64_map.indexOf(input.charAt(i++));
    c1 = e1 << 2 | e2 >> 4;
    o += String.fromCharCode(c1);
    e3 = Base64_map.indexOf(input.charAt(i++));
    c2 = (e2 & 15) << 4 | e3 >> 2;
    if (e3 !== 64) {
      o += String.fromCharCode(c2);
    }
    e4 = Base64_map.indexOf(input.charAt(i++));
    c3 = (e3 & 3) << 6 | e4;
    if (e4 !== 64) {
      o += String.fromCharCode(c3);
    }
  }
  return o;
}
var has_buf = /*#__PURE__*/(function() { return typeof Buffer !== 'undefined' && typeof process !== 'undefined' && typeof process.versions !== 'undefined' && !!process.versions.node; })();

var Buffer_from = /*#__PURE__*/(function() {
	if(typeof Buffer !== 'undefined') {
		var nbfs = !Buffer.from;
		if(!nbfs) try { Buffer.from("foo", "utf8"); } catch(e) { nbfs = true; }
		return nbfs ? function(buf, enc) { return (enc) ? new Buffer(buf, enc) : new Buffer(buf); } : Buffer.from.bind(Buffer);
	}
	return function() {};
})();


function new_raw_buf(len/*:number*/) {
	/* jshint -W056 */
	if(has_buf) return Buffer.alloc ? Buffer.alloc(len) : new Buffer(len);
	return typeof Uint8Array != "undefined" ? new Uint8Array(len) : new Array(len);
	/* jshint +W056 */
}

function new_unsafe_buf(len/*:number*/) {
	/* jshint -W056 */
	if(has_buf) return Buffer.allocUnsafe ? Buffer.allocUnsafe(len) : new Buffer(len);
	return typeof Uint8Array != "undefined" ? new Uint8Array(len) : new Array(len);
	/* jshint +W056 */
}

var s2a = function s2a(s/*:string*/)/*:any*/ {
	if(has_buf) return Buffer_from(s, "binary");
	return s.split("").map(function(x/*:string*/)/*:number*/{ return x.charCodeAt(0) & 0xff; });
};

function s2ab(s/*:string*/)/*:any*/ {
	if(typeof ArrayBuffer === 'undefined') return s2a(s);
	var buf = new ArrayBuffer(s.length), view = new Uint8Array(buf);
	for (var i=0; i!=s.length; ++i) view[i] = s.charCodeAt(i) & 0xFF;
	return buf;
}

function a2s(data/*:any*/)/*:string*/ {
	if(Array.isArray(data)) return data.map(function(c) { return String.fromCharCode(c); }).join("");
	var o/*:Array<string>*/ = []; for(var i = 0; i < data.length; ++i) o[i] = String.fromCharCode(data[i]); return o.join("");
}

function a2u(data/*:Array<number>*/)/*:Uint8Array*/ {
	if(typeof Uint8Array === 'undefined') throw new Error("Unsupported");
	return new Uint8Array(data);
}

function ab2a(data/*:ArrayBuffer|Uint8Array*/)/*:Array<number>*/ {
	if(typeof ArrayBuffer == 'undefined') throw new Error("Unsupported");
	if(data instanceof ArrayBuffer) return ab2a(new Uint8Array(data));
	/*:: if(data instanceof ArrayBuffer) throw new Error("unreachable"); */
	var o = new Array(data.length);
	for(var i = 0; i < data.length; ++i) o[i] = data[i];
	return o;
}

var bconcat = has_buf ? function(bufs) { return Buffer.concat(bufs.map(function(buf) { return Buffer.isBuffer(buf) ? buf : Buffer_from(buf); })); } : function(bufs) {
	if(typeof Uint8Array !== "undefined") {
		var i = 0, maxlen = 0;
		for(i = 0; i < bufs.length; ++i) maxlen += bufs[i].length;
		var o = new Uint8Array(maxlen);
		var len = 0;
		for(i = 0, maxlen = 0; i < bufs.length; maxlen += len, ++i) {
			len = bufs[i].length;
			if(bufs[i] instanceof Uint8Array) o.set(bufs[i], maxlen);
			else if(typeof bufs[i] == "string") { throw "wtf"; }
			else o.set(new Uint8Array(bufs[i]), maxlen);
		}
		return o;
	}
	return [].concat.apply([], bufs.map(function(buf) { return Array.isArray(buf) ? buf : [].slice.call(buf); }));
};

function utf8decode(content/*:string*/) {
	var out = [], widx = 0, L = content.length + 250;
	var o = new_raw_buf(content.length + 255);
	for(var ridx = 0; ridx < content.length; ++ridx) {
		var c = content.charCodeAt(ridx);
		if(c < 0x80) o[widx++] = c;
		else if(c < 0x800) {
			o[widx++] = (192|((c>>6)&31));
			o[widx++] = (128|(c&63));
		} else if(c >= 0xD800 && c < 0xE000) {
			c = (c&1023)+64;
			var d = content.charCodeAt(++ridx)&1023;
			o[widx++] = (240|((c>>8)&7));
			o[widx++] = (128|((c>>2)&63));
			o[widx++] = (128|((d>>6)&15)|((c&3)<<4));
			o[widx++] = (128|(d&63));
		} else {
			o[widx++] = (224|((c>>12)&15));
			o[widx++] = (128|((c>>6)&63));
			o[widx++] = (128|(c&63));
		}
		if(widx > L) {
			out.push(o.slice(0, widx));
			widx = 0;
			o = new_raw_buf(65535);
			L = 65530;
		}
	}
	out.push(o.slice(0, widx));
	return bconcat(out);
}

var chr0 = /\u0000/g, chr1 = /[\u0001-\u0006]/g;
/*::
declare type Block = any;
declare type BufArray = {
	newblk(sz:number):Block;
	next(sz:number):Block;
	end():any;
	push(buf:Block):void;
};

type RecordHopperCB = {(d:any, Rn:string, RT:number):?boolean;};

type EvertType = {[string]:string};
type EvertNumType = {[string]:number};
type EvertArrType = {[string]:Array<string>};

type StringConv = {(string):string};

*/
/* ssf.js (C) 2013-present SheetJS -- http://sheetjs.com */
/*jshint -W041 */
function _strrev(x/*:string*/)/*:string*/ { var o = "", i = x.length-1; while(i>=0) o += x.charAt(i--); return o; }
function pad0(v/*:any*/,d/*:number*/)/*:string*/{var t=""+v; return t.length>=d?t:fill('0',d-t.length)+t;}
function pad_(v/*:any*/,d/*:number*/)/*:string*/{var t=""+v;return t.length>=d?t:fill(' ',d-t.length)+t;}
function rpad_(v/*:any*/,d/*:number*/)/*:string*/{var t=""+v; return t.length>=d?t:t+fill(' ',d-t.length);}
function pad0r1(v/*:any*/,d/*:number*/)/*:string*/{var t=""+Math.round(v); return t.length>=d?t:fill('0',d-t.length)+t;}
function pad0r2(v/*:any*/,d/*:number*/)/*:string*/{var t=""+v; return t.length>=d?t:fill('0',d-t.length)+t;}
var p2_32 = /*#__PURE__*/Math.pow(2,32);
function pad0r(v/*:any*/,d/*:number*/)/*:string*/{if(v>p2_32||v<-p2_32) return pad0r1(v,d); var i = Math.round(v); return pad0r2(i,d); }
/* yes, in 2022 this is still faster than string compare */
function SSF_isgeneral(s/*:string*/, i/*:?number*/)/*:boolean*/ { i = i || 0; return s.length >= 7 + i && (s.charCodeAt(i)|32) === 103 && (s.charCodeAt(i+1)|32) === 101 && (s.charCodeAt(i+2)|32) === 110 && (s.charCodeAt(i+3)|32) === 101 && (s.charCodeAt(i+4)|32) === 114 && (s.charCodeAt(i+5)|32) === 97 && (s.charCodeAt(i+6)|32) === 108; }
var days/*:Array<Array<string> >*/ = [
	['Sun', 'Sunday'],
	['Mon', 'Monday'],
	['Tue', 'Tuesday'],
	['Wed', 'Wednesday'],
	['Thu', 'Thursday'],
	['Fri', 'Friday'],
	['Sat', 'Saturday']
];
var months/*:Array<Array<string> >*/ = [
	['J', 'Jan', 'January'],
	['F', 'Feb', 'February'],
	['M', 'Mar', 'March'],
	['A', 'Apr', 'April'],
	['M', 'May', 'May'],
	['J', 'Jun', 'June'],
	['J', 'Jul', 'July'],
	['A', 'Aug', 'August'],
	['S', 'Sep', 'September'],
	['O', 'Oct', 'October'],
	['N', 'Nov', 'November'],
	['D', 'Dec', 'December']
];
function SSF_init_table(t/*:any*/) {
	if(!t) t = {};
	t[0]=  'General';
	t[1]=  '0';
	t[2]=  '0.00';
	t[3]=  '#,##0';
	t[4]=  '#,##0.00';
	t[9]=  '0%';
	t[10]= '0.00%';
	t[11]= '0.00E+00';
	t[12]= '# ?/?';
	t[13]= '# ??/??';
	t[14]= 'm/d/yy';
	t[15]= 'd-mmm-yy';
	t[16]= 'd-mmm';
	t[17]= 'mmm-yy';
	t[18]= 'h:mm AM/PM';
	t[19]= 'h:mm:ss AM/PM';
	t[20]= 'h:mm';
	t[21]= 'h:mm:ss';
	t[22]= 'm/d/yy h:mm';
	t[37]= '#,##0 ;(#,##0)';
	t[38]= '#,##0 ;[Red](#,##0)';
	t[39]= '#,##0.00;(#,##0.00)';
	t[40]= '#,##0.00;[Red](#,##0.00)';
	t[45]= 'mm:ss';
	t[46]= '[h]:mm:ss';
	t[47]= 'mmss.0';
	t[48]= '##0.0E+0';
	t[49]= '@';
	t[56]= '"上午/下午 "hh"時"mm"分"ss"秒 "';
	return t;
}
/* repeated to satiate webpack */
var table_fmt = {
	0:  'General',
	1:  '0',
	2:  '0.00',
	3:  '#,##0',
	4:  '#,##0.00',
	9:  '0%',
	10: '0.00%',
	11: '0.00E+00',
	12: '# ?/?',
	13: '# ??/??',
	14: 'm/d/yy',
	15: 'd-mmm-yy',
	16: 'd-mmm',
	17: 'mmm-yy',
	18: 'h:mm AM/PM',
	19: 'h:mm:ss AM/PM',
	20: 'h:mm',
	21: 'h:mm:ss',
	22: 'm/d/yy h:mm',
	37: '#,##0 ;(#,##0)',
	38: '#,##0 ;[Red](#,##0)',
	39: '#,##0.00;(#,##0.00)',
	40: '#,##0.00;[Red](#,##0.00)',
	45: 'mm:ss',
	46: '[h]:mm:ss',
	47: 'mmss.0',
	48: '##0.0E+0',
	49: '@',
	56: '"上午/下午 "hh"時"mm"分"ss"秒 "'
};

/* Defaults determined by systematically testing in Excel 2019 */

/* These formats appear to default to other formats in the table */
var SSF_default_map = {
	5:  37, 6:  38, 7:  39, 8:  40,         //  5 -> 37 ...  8 -> 40

	23:  0, 24:  0, 25:  0, 26:  0,         // 23 ->  0 ... 26 ->  0

	27: 14, 28: 14, 29: 14, 30: 14, 31: 14, // 27 -> 14 ... 31 -> 14

	50: 14, 51: 14, 52: 14, 53: 14, 54: 14, // 50 -> 14 ... 58 -> 14
	55: 14, 56: 14, 57: 14, 58: 14,
	59:  1, 60:  2, 61:  3, 62:  4,         // 59 ->  1 ... 62 ->  4

	67:  9, 68: 10,                         // 67 ->  9 ... 68 -> 10
	69: 12, 70: 13, 71: 14,                 // 69 -> 12 ... 71 -> 14
	72: 14, 73: 15, 74: 16, 75: 17,         // 72 -> 14 ... 75 -> 17
	76: 20, 77: 21, 78: 22,                 // 76 -> 20 ... 78 -> 22
	79: 45, 80: 46, 81: 47,                 // 79 -> 45 ... 81 -> 47
	82: 0                                   // 82 ->  0 ... 65536 -> 0 (omitted)
};


/* These formats technically refer to Accounting formats with no equivalent */
var SSF_default_str = {
	//  5 -- Currency,   0 decimal, black negative
	5:  '"$"#,##0_);\\("$"#,##0\\)',
	63: '"$"#,##0_);\\("$"#,##0\\)',

	//  6 -- Currency,   0 decimal, red   negative
	6:  '"$"#,##0_);[Red]\\("$"#,##0\\)',
	64: '"$"#,##0_);[Red]\\("$"#,##0\\)',

	//  7 -- Currency,   2 decimal, black negative
	7:  '"$"#,##0.00_);\\("$"#,##0.00\\)',
	65: '"$"#,##0.00_);\\("$"#,##0.00\\)',

	//  8 -- Currency,   2 decimal, red   negative
	8:  '"$"#,##0.00_);[Red]\\("$"#,##0.00\\)',
	66: '"$"#,##0.00_);[Red]\\("$"#,##0.00\\)',

	// 41 -- Accounting, 0 decimal, No Symbol
	41: '_(* #,##0_);_(* \\(#,##0\\);_(* "-"_);_(@_)',

	// 42 -- Accounting, 0 decimal, $  Symbol
	42: '_("$"* #,##0_);_("$"* \\(#,##0\\);_("$"* "-"_);_(@_)',

	// 43 -- Accounting, 2 decimal, No Symbol
	43: '_(* #,##0.00_);_(* \\(#,##0.00\\);_(* "-"??_);_(@_)',

	// 44 -- Accounting, 2 decimal, $  Symbol
	44: '_("$"* #,##0.00_);_("$"* \\(#,##0.00\\);_("$"* "-"??_);_(@_)'
};

function SSF_frac(x/*:number*/, D/*:number*/, mixed/*:?boolean*/)/*:Array<number>*/ {
	var sgn = x < 0 ? -1 : 1;
	var B = x * sgn;
	var P_2 = 0, P_1 = 1, P = 0;
	var Q_2 = 1, Q_1 = 0, Q = 0;
	var A = Math.floor(B);
	while(Q_1 < D) {
		A = Math.floor(B);
		P = A * P_1 + P_2;
		Q = A * Q_1 + Q_2;
		if((B - A) < 0.00000005) break;
		B = 1 / (B - A);
		P_2 = P_1; P_1 = P;
		Q_2 = Q_1; Q_1 = Q;
	}
	if(Q > D) { if(Q_1 > D) { Q = Q_2; P = P_2; } else { Q = Q_1; P = P_1; } }
	if(!mixed) return [0, sgn * P, Q];
	var q = Math.floor(sgn * P/Q);
	return [q, sgn*P - q*Q, Q];
}
function SSF_parse_date_code(v/*:number*/,opts/*:?any*/,b2/*:?boolean*/) {
	if(v > 2958465 || v < 0) return null;
	var date = (v|0), time = Math.floor(86400 * (v - date)), dow=0;
	var dout=[];
	var out={D:date, T:time, u:86400*(v-date)-time,y:0,m:0,d:0,H:0,M:0,S:0,q:0};
	if(Math.abs(out.u) < 1e-6) out.u = 0;
	if(opts && opts.date1904) date += 1462;
	if(out.u > 0.9999) {
		out.u = 0;
		if(++time == 86400) { out.T = time = 0; ++date; ++out.D; }
	}
	if(date === 60) {dout = b2 ? [1317,10,29] : [1900,2,29]; dow=3;}
	else if(date === 0) {dout = b2 ? [1317,8,29] : [1900,1,0]; dow=6;}
	else {
		if(date > 60) --date;
		/* 1 = Jan 1 1900 in Gregorian */
		var d = new Date(1900, 0, 1);
		d.setDate(d.getDate() + date - 1);
		dout = [d.getFullYear(), d.getMonth()+1,d.getDate()];
		dow = d.getDay();
		if(date < 60) dow = (dow + 6) % 7;
		if(b2) dow = SSF_fix_hijri(d, dout);
	}
	out.y = dout[0]; out.m = dout[1]; out.d = dout[2];
	out.S = time % 60; time = Math.floor(time / 60);
	out.M = time % 60; time = Math.floor(time / 60);
	out.H = time;
	out.q = dow;
	return out;
}
var SSFbasedate = /*#__PURE__*/new Date(1899, 11, 31, 0, 0, 0);
var SSFdnthresh = /*#__PURE__*/SSFbasedate.getTime();
var SSFbase1904 = /*#__PURE__*/new Date(1900, 2, 1, 0, 0, 0);
function datenum_local(v/*:Date*/, date1904/*:?boolean*/)/*:number*/ {
	var epoch = /*#__PURE__*/v.getTime();
	if(date1904) epoch -= 1461*24*60*60*1000;
	else if(v >= SSFbase1904) epoch += 24*60*60*1000;
	return (epoch - (SSFdnthresh + (/*#__PURE__*/v.getTimezoneOffset() - /*#__PURE__*/SSFbasedate.getTimezoneOffset()) * 60000)) / (24 * 60 * 60 * 1000);
}
/* ECMA-376 18.8.30 numFmt*/
/* Note: `toPrecision` uses standard form when prec > E and E >= -6 */
/* exponent >= -9 and <= 9 */
function SSF_strip_decimal(o/*:string*/)/*:string*/ {
	return (o.indexOf(".") == -1) ? o : o.replace(/(?:\.0*|(\.\d*[1-9])0+)$/, "$1");
}

/* General Exponential always shows 2 digits exp and trims the mantissa */
function SSF_normalize_exp(o/*:string*/)/*:string*/ {
	if(o.indexOf("E") == -1) return o;
	return o.replace(/(?:\.0*|(\.\d*[1-9])0+)[Ee]/,"$1E").replace(/(E[+-])(\d)$/,"$10$2");
}

/* exponent >= -9 and <= 9 */
function SSF_small_exp(v/*:number*/)/*:string*/ {
	var w = (v<0?12:11);
	var o = SSF_strip_decimal(v.toFixed(12)); if(o.length <= w) return o;
	o = v.toPrecision(10); if(o.length <= w) return o;
	return v.toExponential(5);
}

/* exponent >= 11 or <= -10 likely exponential */
function SSF_large_exp(v/*:number*/)/*:string*/ {
	var o = SSF_strip_decimal(v.toFixed(11));
	return (o.length > (v<0?12:11) || o === "0" || o === "-0") ? v.toPrecision(6) : o;
}

function SSF_general_num(v/*:number*/)/*:string*/ {
	var V = Math.floor(Math.log(Math.abs(v))*Math.LOG10E), o;

	if(V >= -4 && V <= -1) o = v.toPrecision(10+V);
	else if(Math.abs(V) <= 9) o = SSF_small_exp(v);
	else if(V === 10) o = v.toFixed(10).substr(0,12);
	else o = SSF_large_exp(v);

	return SSF_strip_decimal(SSF_normalize_exp(o.toUpperCase()));
}


/*
	"General" rules:
	- text is passed through ("@")
	- booleans are rendered as TRUE/FALSE
	- "up to 11 characters" displayed for numbers
	- Default date format (code 14) used for Dates

	The longest 32-bit integer text is "-2147483648", exactly 11 chars
	TODO: technically the display depends on the width of the cell
*/
function SSF_general(v/*:any*/, opts/*:any*/) {
	switch(typeof v) {
		case 'string': return v;
		case 'boolean': return v ? "TRUE" : "FALSE";
		case 'number': return (v|0) === v ? v.toString(10) : SSF_general_num(v);
		case 'undefined': return "";
		case 'object':
			if(v == null) return "";
			if(v instanceof Date) return SSF_format(14, datenum_local(v, opts && opts.date1904), opts);
	}
	throw new Error("unsupported value in General format: " + v);
}

function SSF_fix_hijri(date/*:Date*/, o/*:[number, number, number]*/) {
  /* TODO: properly adjust y/m/d and  */
  o[0] -= 581;
  var dow = date.getDay();
  if(date < 60) dow = (dow + 6) % 7;
  return dow;
}
//var THAI_DIGITS = "\u0E50\u0E51\u0E52\u0E53\u0E54\u0E55\u0E56\u0E57\u0E58\u0E59".split("");
function SSF_write_date(type/*:number*/, fmt/*:string*/, val, ss0/*:?number*/)/*:string*/ {
	var o="", ss=0, tt=0, y = val.y, out, outl = 0;
	switch(type) {
		case 98: /* 'b' buddhist year */
			y = val.y + 543;
			/* falls through */
		case 121: /* 'y' year */
		switch(fmt.length) {
			case 1: case 2: out = y % 100; outl = 2; break;
			default: out = y % 10000; outl = 4; break;
		} break;
		case 109: /* 'm' month */
		switch(fmt.length) {
			case 1: case 2: out = val.m; outl = fmt.length; break;
			case 3: return months[val.m-1][1];
			case 5: return months[val.m-1][0];
			default: return months[val.m-1][2];
		} break;
		case 100: /* 'd' day */
		switch(fmt.length) {
			case 1: case 2: out = val.d; outl = fmt.length; break;
			case 3: return days[val.q][0];
			default: return days[val.q][1];
		} break;
		case 104: /* 'h' 12-hour */
		switch(fmt.length) {
			case 1: case 2: out = 1+(val.H+11)%12; outl = fmt.length; break;
			default: throw 'bad hour format: ' + fmt;
		} break;
		case 72: /* 'H' 24-hour */
		switch(fmt.length) {
			case 1: case 2: out = val.H; outl = fmt.length; break;
			default: throw 'bad hour format: ' + fmt;
		} break;
		case 77: /* 'M' minutes */
		switch(fmt.length) {
			case 1: case 2: out = val.M; outl = fmt.length; break;
			default: throw 'bad minute format: ' + fmt;
		} break;
		case 115: /* 's' seconds */
			if(fmt != 's' && fmt != 'ss' && fmt != '.0' && fmt != '.00' && fmt != '.000') throw 'bad second format: ' + fmt;
			if(val.u === 0 && (fmt == "s" || fmt == "ss")) return pad0(val.S, fmt.length);
			/*::if(!ss0) ss0 = 0; */
			if(ss0 >= 2) tt = ss0 === 3 ? 1000 : 100;
			else tt = ss0 === 1 ? 10 : 1;
			ss = Math.round((tt)*(val.S + val.u));
			if(ss >= 60*tt) ss = 0;
			if(fmt === 's') return ss === 0 ? "0" : ""+ss/tt;
			o = pad0(ss,2 + ss0);
			if(fmt === 'ss') return o.substr(0,2);
			return "." + o.substr(2,fmt.length-1);
		case 90: /* 'Z' absolute time */
		switch(fmt) {
			case '[h]': case '[hh]': out = val.D*24+val.H; break;
			case '[m]': case '[mm]': out = (val.D*24+val.H)*60+val.M; break;
			case '[s]': case '[ss]': out = ((val.D*24+val.H)*60+val.M)*60+Math.round(val.S+val.u); break;
			default: throw 'bad abstime format: ' + fmt;
		} outl = fmt.length === 3 ? 1 : 2; break;
		case 101: /* 'e' era */
			out = y; outl = 1; break;
	}
	var outstr = outl > 0 ? pad0(out, outl) : "";
	return outstr;
}


/*jshint -W086 */
/*jshint +W086 */
function commaify(s/*:string*/)/*:string*/ {
	var w = 3;
	if(s.length <= w) return s;
	var j = (s.length % w), o = s.substr(0,j);
	for(; j!=s.length; j+=w) o+=(o.length > 0 ? "," : "") + s.substr(j,w);
	return o;
}
var pct1 = /%/g;
function write_num_pct(type/*:string*/, fmt/*:string*/, val/*:number*/)/*:string*/{
	var sfmt = fmt.replace(pct1,""), mul = fmt.length - sfmt.length;
	return write_num(type, sfmt, val * Math.pow(10,2*mul)) + fill("%",mul);
}

function write_num_cm(type/*:string*/, fmt/*:string*/, val/*:number*/)/*:string*/{
	var idx = fmt.length - 1;
	while(fmt.charCodeAt(idx-1) === 44) --idx;
	return write_num(type, fmt.substr(0,idx), val / Math.pow(10,3*(fmt.length-idx)));
}

function write_num_exp(fmt/*:string*/, val/*:number*/)/*:string*/{
	var o/*:string*/;
	var idx = fmt.indexOf("E") - fmt.indexOf(".") - 1;
	if(fmt.match(/^#+0.0E\+0$/)) {
		if(val == 0) return "0.0E+0";
		else if(val < 0) return "-" + write_num_exp(fmt, -val);
		var period = fmt.indexOf("."); if(period === -1) period=fmt.indexOf('E');
		var ee = Math.floor(Math.log(val)*Math.LOG10E)%period;
		if(ee < 0) ee += period;
		o = (val/Math.pow(10,ee)).toPrecision(idx+1+(period+ee)%period);
		if(o.indexOf("e") === -1) {
			var fakee = Math.floor(Math.log(val)*Math.LOG10E);
			if(o.indexOf(".") === -1) o = o.charAt(0) + "." + o.substr(1) + "E+" + (fakee - o.length+ee);
			else o += "E+" + (fakee - ee);
			while(o.substr(0,2) === "0.") {
				o = o.charAt(0) + o.substr(2,period) + "." + o.substr(2+period);
				o = o.replace(/^0+([1-9])/,"$1").replace(/^0+\./,"0.");
			}
			o = o.replace(/\+-/,"-");
		}
		o = o.replace(/^([+-]?)(\d*)\.(\d*)[Ee]/,function($$,$1,$2,$3) { return $1 + $2 + $3.substr(0,(period+ee)%period) + "." + $3.substr(ee) + "E"; });
	} else o = val.toExponential(idx);
	if(fmt.match(/E\+00$/) && o.match(/e[+-]\d$/)) o = o.substr(0,o.length-1) + "0" + o.charAt(o.length-1);
	if(fmt.match(/E\-/) && o.match(/e\+/)) o = o.replace(/e\+/,"e");
	return o.replace("e","E");
}
var frac1 = /# (\?+)( ?)\/( ?)(\d+)/;
function write_num_f1(r/*:Array<string>*/, aval/*:number*/, sign/*:string*/)/*:string*/ {
	var den = parseInt(r[4],10), rr = Math.round(aval * den), base = Math.floor(rr/den);
	var myn = (rr - base*den), myd = den;
	return sign + (base === 0 ? "" : ""+base) + " " + (myn === 0 ? fill(" ", r[1].length + 1 + r[4].length) : pad_(myn,r[1].length) + r[2] + "/" + r[3] + pad0(myd,r[4].length));
}
function write_num_f2(r/*:Array<string>*/, aval/*:number*/, sign/*:string*/)/*:string*/ {
	return sign + (aval === 0 ? "" : ""+aval) + fill(" ", r[1].length + 2 + r[4].length);
}
var dec1 = /^#*0*\.([0#]+)/;
var closeparen = /\).*[0#]/;
var phone = /\(###\) ###\\?-####/;
function hashq(str/*:string*/)/*:string*/ {
	var o = "", cc;
	for(var i = 0; i != str.length; ++i) switch((cc=str.charCodeAt(i))) {
		case 35: break;
		case 63: o+= " "; break;
		case 48: o+= "0"; break;
		default: o+= String.fromCharCode(cc);
	}
	return o;
}
function rnd(val/*:number*/, d/*:number*/)/*:string*/ { var dd = Math.pow(10,d); return ""+(Math.round(val * dd)/dd); }
function dec(val/*:number*/, d/*:number*/)/*:number*/ {
	var _frac = val - Math.floor(val), dd = Math.pow(10,d);
	if (d < ('' + Math.round(_frac * dd)).length) return 0;
	return Math.round(_frac * dd);
}
function carry(val/*:number*/, d/*:number*/)/*:number*/ {
	if (d < ('' + Math.round((val-Math.floor(val))*Math.pow(10,d))).length) {
		return 1;
	}
	return 0;
}
function flr(val/*:number*/)/*:string*/ {
	if(val < 2147483647 && val > -2147483648) return ""+(val >= 0 ? (val|0) : (val-1|0));
	return ""+Math.floor(val);
}
function write_num_flt(type/*:string*/, fmt/*:string*/, val/*:number*/)/*:string*/ {
	if(type.charCodeAt(0) === 40 && !fmt.match(closeparen)) {
		var ffmt = fmt.replace(/\( */,"").replace(/ \)/,"").replace(/\)/,"");
		if(val >= 0) return write_num_flt('n', ffmt, val);
		return '(' + write_num_flt('n', ffmt, -val) + ')';
	}
	if(fmt.charCodeAt(fmt.length - 1) === 44) return write_num_cm(type, fmt, val);
	if(fmt.indexOf('%') !== -1) return write_num_pct(type, fmt, val);
	if(fmt.indexOf('E') !== -1) return write_num_exp(fmt, val);
	if(fmt.charCodeAt(0) === 36) return "$"+write_num_flt(type,fmt.substr(fmt.charAt(1)==' '?2:1),val);
	var o;
	var r/*:?Array<string>*/, ri, ff, aval = Math.abs(val), sign = val < 0 ? "-" : "";
	if(fmt.match(/^00+$/)) return sign + pad0r(aval,fmt.length);
	if(fmt.match(/^[#?]+$/)) {
		o = pad0r(val,0); if(o === "0") o = "";
		return o.length > fmt.length ? o : hashq(fmt.substr(0,fmt.length-o.length)) + o;
	}
	if((r = fmt.match(frac1))) return write_num_f1(r, aval, sign);
	if(fmt.match(/^#+0+$/)) return sign + pad0r(aval,fmt.length - fmt.indexOf("0"));
	if((r = fmt.match(dec1))) {
		o = rnd(val, r[1].length).replace(/^([^\.]+)$/,"$1."+hashq(r[1])).replace(/\.$/,"."+hashq(r[1])).replace(/\.(\d*)$/,function($$, $1) { return "." + $1 + fill("0", hashq(/*::(*/r/*::||[""])*/[1]).length-$1.length); });
		return fmt.indexOf("0.") !== -1 ? o : o.replace(/^0\./,".");
	}
	fmt = fmt.replace(/^#+([0.])/, "$1");
	if((r = fmt.match(/^(0*)\.(#*)$/))) {
		return sign + rnd(aval, r[2].length).replace(/\.(\d*[1-9])0*$/,".$1").replace(/^(-?\d*)$/,"$1.").replace(/^0\./,r[1].length?"0.":".");
	}
	if((r = fmt.match(/^#{1,3},##0(\.?)$/))) return sign + commaify(pad0r(aval,0));
	if((r = fmt.match(/^#,##0\.([#0]*0)$/))) {
		return val < 0 ? "-" + write_num_flt(type, fmt, -val) : commaify(""+(Math.floor(val) + carry(val, r[1].length))) + "." + pad0(dec(val, r[1].length),r[1].length);
	}
	if((r = fmt.match(/^#,#*,#0/))) return write_num_flt(type,fmt.replace(/^#,#*,/,""),val);
	if((r = fmt.match(/^([0#]+)(\\?-([0#]+))+$/))) {
		o = _strrev(write_num_flt(type, fmt.replace(/[\\-]/g,""), val));
		ri = 0;
		return _strrev(_strrev(fmt.replace(/\\/g,"")).replace(/[0#]/g,function(x){return ri<o.length?o.charAt(ri++):x==='0'?'0':"";}));
	}
	if(fmt.match(phone)) {
		o = write_num_flt(type, "##########", val);
		return "(" + o.substr(0,3) + ") " + o.substr(3, 3) + "-" + o.substr(6);
	}
	var oa = "";
	if((r = fmt.match(/^([#0?]+)( ?)\/( ?)([#0?]+)/))) {
		ri = Math.min(/*::String(*/r[4]/*::)*/.length,7);
		ff = SSF_frac(aval, Math.pow(10,ri)-1, false);
		o = "" + sign;
		oa = write_num("n", /*::String(*/r[1]/*::)*/, ff[1]);
		if(oa.charAt(oa.length-1) == " ") oa = oa.substr(0,oa.length-1) + "0";
		o += oa + /*::String(*/r[2]/*::)*/ + "/" + /*::String(*/r[3]/*::)*/;
		oa = rpad_(ff[2],ri);
		if(oa.length < r[4].length) oa = hashq(r[4].substr(r[4].length-oa.length)) + oa;
		o += oa;
		return o;
	}
	if((r = fmt.match(/^# ([#0?]+)( ?)\/( ?)([#0?]+)/))) {
		ri = Math.min(Math.max(r[1].length, r[4].length),7);
		ff = SSF_frac(aval, Math.pow(10,ri)-1, true);
		return sign + (ff[0]||(ff[1] ? "" : "0")) + " " + (ff[1] ? pad_(ff[1],ri) + r[2] + "/" + r[3] + rpad_(ff[2],ri): fill(" ", 2*ri+1 + r[2].length + r[3].length));
	}
	if((r = fmt.match(/^[#0?]+$/))) {
		o = pad0r(val, 0);
		if(fmt.length <= o.length) return o;
		return hashq(fmt.substr(0,fmt.length-o.length)) + o;
	}
	if((r = fmt.match(/^([#0?]+)\.([#0]+)$/))) {
		o = "" + val.toFixed(Math.min(r[2].length,10)).replace(/([^0])0+$/,"$1");
		ri = o.indexOf(".");
		var lres = fmt.indexOf(".") - ri, rres = fmt.length - o.length - lres;
		return hashq(fmt.substr(0,lres) + o + fmt.substr(fmt.length-rres));
	}
	if((r = fmt.match(/^00,000\.([#0]*0)$/))) {
		ri = dec(val, r[1].length);
		return val < 0 ? "-" + write_num_flt(type, fmt, -val) : commaify(flr(val)).replace(/^\d,\d{3}$/,"0$&").replace(/^\d*$/,function($$) { return "00," + ($$.length < 3 ? pad0(0,3-$$.length) : "") + $$; }) + "." + pad0(ri,r[1].length);
	}
	switch(fmt) {
		case "###,##0.00": return write_num_flt(type, "#,##0.00", val);
		case "###,###":
		case "##,###":
		case "#,###": var x = commaify(pad0r(aval,0)); return x !== "0" ? sign + x : "";
		case "###,###.00": return write_num_flt(type, "###,##0.00",val).replace(/^0\./,".");
		case "#,###.00": return write_num_flt(type, "#,##0.00",val).replace(/^0\./,".");
		default:
	}
	throw new Error("unsupported format |" + fmt + "|");
}
function write_num_cm2(type/*:string*/, fmt/*:string*/, val/*:number*/)/*:string*/{
	var idx = fmt.length - 1;
	while(fmt.charCodeAt(idx-1) === 44) --idx;
	return write_num(type, fmt.substr(0,idx), val / Math.pow(10,3*(fmt.length-idx)));
}
function write_num_pct2(type/*:string*/, fmt/*:string*/, val/*:number*/)/*:string*/{
	var sfmt = fmt.replace(pct1,""), mul = fmt.length - sfmt.length;
	return write_num(type, sfmt, val * Math.pow(10,2*mul)) + fill("%",mul);
}
function write_num_exp2(fmt/*:string*/, val/*:number*/)/*:string*/{
	var o/*:string*/;
	var idx = fmt.indexOf("E") - fmt.indexOf(".") - 1;
	if(fmt.match(/^#+0.0E\+0$/)) {
		if(val == 0) return "0.0E+0";
		else if(val < 0) return "-" + write_num_exp2(fmt, -val);
		var period = fmt.indexOf("."); if(period === -1) period=fmt.indexOf('E');
		var ee = Math.floor(Math.log(val)*Math.LOG10E)%period;
		if(ee < 0) ee += period;
		o = (val/Math.pow(10,ee)).toPrecision(idx+1+(period+ee)%period);
		if(!o.match(/[Ee]/)) {
			var fakee = Math.floor(Math.log(val)*Math.LOG10E);
			if(o.indexOf(".") === -1) o = o.charAt(0) + "." + o.substr(1) + "E+" + (fakee - o.length+ee);
			else o += "E+" + (fakee - ee);
			o = o.replace(/\+-/,"-");
		}
		o = o.replace(/^([+-]?)(\d*)\.(\d*)[Ee]/,function($$,$1,$2,$3) { return $1 + $2 + $3.substr(0,(period+ee)%period) + "." + $3.substr(ee) + "E"; });
	} else o = val.toExponential(idx);
	if(fmt.match(/E\+00$/) && o.match(/e[+-]\d$/)) o = o.substr(0,o.length-1) + "0" + o.charAt(o.length-1);
	if(fmt.match(/E\-/) && o.match(/e\+/)) o = o.replace(/e\+/,"e");
	return o.replace("e","E");
}
function write_num_int(type/*:string*/, fmt/*:string*/, val/*:number*/)/*:string*/ {
	if(type.charCodeAt(0) === 40 && !fmt.match(closeparen)) {
		var ffmt = fmt.replace(/\( */,"").replace(/ \)/,"").replace(/\)/,"");
		if(val >= 0) return write_num_int('n', ffmt, val);
		return '(' + write_num_int('n', ffmt, -val) + ')';
	}
	if(fmt.charCodeAt(fmt.length - 1) === 44) return write_num_cm2(type, fmt, val);
	if(fmt.indexOf('%') !== -1) return write_num_pct2(type, fmt, val);
	if(fmt.indexOf('E') !== -1) return write_num_exp2(fmt, val);
	if(fmt.charCodeAt(0) === 36) return "$"+write_num_int(type,fmt.substr(fmt.charAt(1)==' '?2:1),val);
	var o;
	var r/*:?Array<string>*/, ri, ff, aval = Math.abs(val), sign = val < 0 ? "-" : "";
	if(fmt.match(/^00+$/)) return sign + pad0(aval,fmt.length);
	if(fmt.match(/^[#?]+$/)) {
		o = (""+val); if(val === 0) o = "";
		return o.length > fmt.length ? o : hashq(fmt.substr(0,fmt.length-o.length)) + o;
	}
	if((r = fmt.match(frac1))) return write_num_f2(r, aval, sign);
	if(fmt.match(/^#+0+$/)) return sign + pad0(aval,fmt.length - fmt.indexOf("0"));
	if((r = fmt.match(dec1))) {
		/*:: if(!Array.isArray(r)) throw new Error("unreachable"); */
		o = (""+val).replace(/^([^\.]+)$/,"$1."+hashq(r[1])).replace(/\.$/,"."+hashq(r[1]));
		o = o.replace(/\.(\d*)$/,function($$, $1) {
		/*:: if(!Array.isArray(r)) throw new Error("unreachable"); */
			return "." + $1 + fill("0", hashq(r[1]).length-$1.length); });
		return fmt.indexOf("0.") !== -1 ? o : o.replace(/^0\./,".");
	}
	fmt = fmt.replace(/^#+([0.])/, "$1");
	if((r = fmt.match(/^(0*)\.(#*)$/))) {
		return sign + (""+aval).replace(/\.(\d*[1-9])0*$/,".$1").replace(/^(-?\d*)$/,"$1.").replace(/^0\./,r[1].length?"0.":".");
	}
	if((r = fmt.match(/^#{1,3},##0(\.?)$/))) return sign + commaify((""+aval));
	if((r = fmt.match(/^#,##0\.([#0]*0)$/))) {
		return val < 0 ? "-" + write_num_int(type, fmt, -val) : commaify((""+val)) + "." + fill('0',r[1].length);
	}
	if((r = fmt.match(/^#,#*,#0/))) return write_num_int(type,fmt.replace(/^#,#*,/,""),val);
	if((r = fmt.match(/^([0#]+)(\\?-([0#]+))+$/))) {
		o = _strrev(write_num_int(type, fmt.replace(/[\\-]/g,""), val));
		ri = 0;
		return _strrev(_strrev(fmt.replace(/\\/g,"")).replace(/[0#]/g,function(x){return ri<o.length?o.charAt(ri++):x==='0'?'0':"";}));
	}
	if(fmt.match(phone)) {
		o = write_num_int(type, "##########", val);
		return "(" + o.substr(0,3) + ") " + o.substr(3, 3) + "-" + o.substr(6);
	}
	var oa = "";
	if((r = fmt.match(/^([#0?]+)( ?)\/( ?)([#0?]+)/))) {
		ri = Math.min(/*::String(*/r[4]/*::)*/.length,7);
		ff = SSF_frac(aval, Math.pow(10,ri)-1, false);
		o = "" + sign;
		oa = write_num("n", /*::String(*/r[1]/*::)*/, ff[1]);
		if(oa.charAt(oa.length-1) == " ") oa = oa.substr(0,oa.length-1) + "0";
		o += oa + /*::String(*/r[2]/*::)*/ + "/" + /*::String(*/r[3]/*::)*/;
		oa = rpad_(ff[2],ri);
		if(oa.length < r[4].length) oa = hashq(r[4].substr(r[4].length-oa.length)) + oa;
		o += oa;
		return o;
	}
	if((r = fmt.match(/^# ([#0?]+)( ?)\/( ?)([#0?]+)/))) {
		ri = Math.min(Math.max(r[1].length, r[4].length),7);
		ff = SSF_frac(aval, Math.pow(10,ri)-1, true);
		return sign + (ff[0]||(ff[1] ? "" : "0")) + " " + (ff[1] ? pad_(ff[1],ri) + r[2] + "/" + r[3] + rpad_(ff[2],ri): fill(" ", 2*ri+1 + r[2].length + r[3].length));
	}
	if((r = fmt.match(/^[#0?]+$/))) {
		o = "" + val;
		if(fmt.length <= o.length) return o;
		return hashq(fmt.substr(0,fmt.length-o.length)) + o;
	}
	if((r = fmt.match(/^([#0]+)\.([#0]+)$/))) {
		o = "" + val.toFixed(Math.min(r[2].length,10)).replace(/([^0])0+$/,"$1");
		ri = o.indexOf(".");
		var lres = fmt.indexOf(".") - ri, rres = fmt.length - o.length - lres;
		return hashq(fmt.substr(0,lres) + o + fmt.substr(fmt.length-rres));
	}
	if((r = fmt.match(/^00,000\.([#0]*0)$/))) {
		return val < 0 ? "-" + write_num_int(type, fmt, -val) : commaify(""+val).replace(/^\d,\d{3}$/,"0$&").replace(/^\d*$/,function($$) { return "00," + ($$.length < 3 ? pad0(0,3-$$.length) : "") + $$; }) + "." + pad0(0,r[1].length);
	}
	switch(fmt) {
		case "###,###":
		case "##,###":
		case "#,###": var x = commaify(""+aval); return x !== "0" ? sign + x : "";
		default:
			if(fmt.match(/\.[0#?]*$/)) return write_num_int(type, fmt.slice(0,fmt.lastIndexOf(".")), val) + hashq(fmt.slice(fmt.lastIndexOf(".")));
	}
	throw new Error("unsupported format |" + fmt + "|");
}
function write_num(type/*:string*/, fmt/*:string*/, val/*:number*/)/*:string*/ {
	return (val|0) === val ? write_num_int(type, fmt, val) : write_num_flt(type, fmt, val);
}
function SSF_split_fmt(fmt/*:string*/)/*:Array<string>*/ {
	var out/*:Array<string>*/ = [];
	var in_str = false/*, cc*/;
	for(var i = 0, j = 0; i < fmt.length; ++i) switch((/*cc=*/fmt.charCodeAt(i))) {
		case 34: /* '"' */
			in_str = !in_str; break;
		case 95: case 42: case 92: /* '_' '*' '\\' */
			++i; break;
		case 59: /* ';' */
			out[out.length] = fmt.substr(j,i-j);
			j = i+1;
	}
	out[out.length] = fmt.substr(j);
	if(in_str === true) throw new Error("Format |" + fmt + "| unterminated string ");
	return out;
}

var SSF_abstime = /\[[HhMmSs\u0E0A\u0E19\u0E17]*\]/;
function fmt_is_date(fmt/*:string*/)/*:boolean*/ {
	var i = 0, /*cc = 0,*/ c = "", o = "";
	while(i < fmt.length) {
		switch((c = fmt.charAt(i))) {
			case 'G': if(SSF_isgeneral(fmt, i)) i+= 6; i++; break;
			case '"': for(;(/*cc=*/fmt.charCodeAt(++i)) !== 34 && i < fmt.length;){/*empty*/} ++i; break;
			case '\\': i+=2; break;
			case '_': i+=2; break;
			case '@': ++i; break;
			case 'B': case 'b':
				if(fmt.charAt(i+1) === "1" || fmt.charAt(i+1) === "2") return true;
				/* falls through */
			case 'M': case 'D': case 'Y': case 'H': case 'S': case 'E':
				/* falls through */
			case 'm': case 'd': case 'y': case 'h': case 's': case 'e': case 'g': return true;
			case 'A': case 'a': case '上':
				if(fmt.substr(i, 3).toUpperCase() === "A/P") return true;
				if(fmt.substr(i, 5).toUpperCase() === "AM/PM") return true;
				if(fmt.substr(i, 5).toUpperCase() === "上午/下午") return true;
				++i; break;
			case '[':
				o = c;
				while(fmt.charAt(i++) !== ']' && i < fmt.length) o += fmt.charAt(i);
				if(o.match(SSF_abstime)) return true;
				break;
			case '.':
				/* falls through */
			case '0': case '#':
				while(i < fmt.length && ("0#?.,E+-%".indexOf(c=fmt.charAt(++i)) > -1 || (c=='\\' && fmt.charAt(i+1) == "-" && "0#".indexOf(fmt.charAt(i+2))>-1))){/* empty */}
				break;
			case '?': while(fmt.charAt(++i) === c){/* empty */} break;
			case '*': ++i; if(fmt.charAt(i) == ' ' || fmt.charAt(i) == '*') ++i; break;
			case '(': case ')': ++i; break;
			case '1': case '2': case '3': case '4': case '5': case '6': case '7': case '8': case '9':
				while(i < fmt.length && "0123456789".indexOf(fmt.charAt(++i)) > -1){/* empty */} break;
			case ' ': ++i; break;
			default: ++i; break;
		}
	}
	return false;
}

function eval_fmt(fmt/*:string*/, v/*:any*/, opts/*:any*/, flen/*:number*/) {
	var out = [], o = "", i = 0, c = "", lst='t', dt, j, cc;
	var hr='H';
	/* Tokenize */
	while(i < fmt.length) {
		switch((c = fmt.charAt(i))) {
			case 'G': /* General */
				if(!SSF_isgeneral(fmt, i)) throw new Error('unrecognized character ' + c + ' in ' +fmt);
				out[out.length] = {t:'G', v:'General'}; i+=7; break;
			case '"': /* Literal text */
				for(o="";(cc=fmt.charCodeAt(++i)) !== 34 && i < fmt.length;) o += String.fromCharCode(cc);
				out[out.length] = {t:'t', v:o}; ++i; break;
			case '\\': var w = fmt.charAt(++i), t = (w === "(" || w === ")") ? w : 't';
				out[out.length] = {t:t, v:w}; ++i; break;
			case '_': out[out.length] = {t:'t', v:" "}; i+=2; break;
			case '@': /* Text Placeholder */
				out[out.length] = {t:'T', v:v}; ++i; break;
			case 'B': case 'b':
				if(fmt.charAt(i+1) === "1" || fmt.charAt(i+1) === "2") {
					if(dt==null) { dt=SSF_parse_date_code(v, opts, fmt.charAt(i+1) === "2"); if(dt==null) return ""; }
					out[out.length] = {t:'X', v:fmt.substr(i,2)}; lst = c; i+=2; break;
				}
				/* falls through */
			case 'M': case 'D': case 'Y': case 'H': case 'S': case 'E':
				c = c.toLowerCase();
				/* falls through */
			case 'm': case 'd': case 'y': case 'h': case 's': case 'e': case 'g':
				if(v < 0) return "";
				if(dt==null) { dt=SSF_parse_date_code(v, opts); if(dt==null) return ""; }
				o = c; while(++i < fmt.length && fmt.charAt(i).toLowerCase() === c) o+=c;
				if(c === 'm' && lst.toLowerCase() === 'h') c = 'M';
				if(c === 'h') c = hr;
				out[out.length] = {t:c, v:o}; lst = c; break;
			case 'A': case 'a': case '上':
				var q={t:c, v:c};
				if(dt==null) dt=SSF_parse_date_code(v, opts);
				if(fmt.substr(i, 3).toUpperCase() === "A/P") { if(dt!=null) q.v = dt.H >= 12 ? "P" : "A"; q.t = 'T'; hr='h';i+=3;}
				else if(fmt.substr(i,5).toUpperCase() === "AM/PM") { if(dt!=null) q.v = dt.H >= 12 ? "PM" : "AM"; q.t = 'T'; i+=5; hr='h'; }
				else if(fmt.substr(i,5).toUpperCase() === "上午/下午") { if(dt!=null) q.v = dt.H >= 12 ? "下午" : "上午"; q.t = 'T'; i+=5; hr='h'; }
				else { q.t = "t"; ++i; }
				if(dt==null && q.t === 'T') return "";
				out[out.length] = q; lst = c; break;
			case '[':
				o = c;
				while(fmt.charAt(i++) !== ']' && i < fmt.length) o += fmt.charAt(i);
				if(o.slice(-1) !== ']') throw 'unterminated "[" block: |' + o + '|';
				if(o.match(SSF_abstime)) {
					if(dt==null) { dt=SSF_parse_date_code(v, opts); if(dt==null) return ""; }
					out[out.length] = {t:'Z', v:o.toLowerCase()};
					lst = o.charAt(1);
				} else if(o.indexOf("$") > -1) {
					o = (o.match(/\$([^-\[\]]*)/)||[])[1]||"$";
					if(!fmt_is_date(fmt)) out[out.length] = {t:'t',v:o};
				}
				break;
			/* Numbers */
			case '.':
				if(dt != null) {
					o = c; while(++i < fmt.length && (c=fmt.charAt(i)) === "0") o += c;
					out[out.length] = {t:'s', v:o}; break;
				}
				/* falls through */
			case '0': case '#':
				o = c; while(++i < fmt.length && "0#?.,E+-%".indexOf(c=fmt.charAt(i)) > -1) o += c;
				out[out.length] = {t:'n', v:o}; break;
			case '?':
				o = c; while(fmt.charAt(++i) === c) o+=c;
				out[out.length] = {t:c, v:o}; lst = c; break;
			case '*': ++i; if(fmt.charAt(i) == ' ' || fmt.charAt(i) == '*') ++i; break; // **
			case '(': case ')': out[out.length] = {t:(flen===1?'t':c), v:c}; ++i; break;
			case '1': case '2': case '3': case '4': case '5': case '6': case '7': case '8': case '9':
				o = c; while(i < fmt.length && "0123456789".indexOf(fmt.charAt(++i)) > -1) o+=fmt.charAt(i);
				out[out.length] = {t:'D', v:o}; break;
			case ' ': out[out.length] = {t:c, v:c}; ++i; break;
			case '$': out[out.length] = {t:'t', v:'$'}; ++i; break;
			default:
				if(",$-+/():!^&'~{}<>=€acfijklopqrtuvwxzP".indexOf(c) === -1) throw new Error('unrecognized character ' + c + ' in ' + fmt);
				out[out.length] = {t:'t', v:c}; ++i; break;
		}
	}

	/* Scan for date/time parts */
	var bt = 0, ss0 = 0, ssm;
	for(i=out.length-1, lst='t'; i >= 0; --i) {
		switch(out[i].t) {
			case 'h': case 'H': out[i].t = hr; lst='h'; if(bt < 1) bt = 1; break;
			case 's':
				if((ssm=out[i].v.match(/\.0+$/))) ss0=Math.max(ss0,ssm[0].length-1);
				if(bt < 3) bt = 3;
			/* falls through */
			case 'd': case 'y': case 'M': case 'e': lst=out[i].t; break;
			case 'm': if(lst === 's') { out[i].t = 'M'; if(bt < 2) bt = 2; } break;
			case 'X': /*if(out[i].v === "B2");*/
				break;
			case 'Z':
				if(bt < 1 && out[i].v.match(/[Hh]/)) bt = 1;
				if(bt < 2 && out[i].v.match(/[Mm]/)) bt = 2;
				if(bt < 3 && out[i].v.match(/[Ss]/)) bt = 3;
		}
	}
	/* time rounding depends on presence of minute / second / usec fields */
	switch(bt) {
		case 0: break;
		case 1:
			/*::if(!dt) break;*/
			if(dt.u >= 0.5) { dt.u = 0; ++dt.S; }
			if(dt.S >=  60) { dt.S = 0; ++dt.M; }
			if(dt.M >=  60) { dt.M = 0; ++dt.H; }
			break;
		case 2:
			/*::if(!dt) break;*/
			if(dt.u >= 0.5) { dt.u = 0; ++dt.S; }
			if(dt.S >=  60) { dt.S = 0; ++dt.M; }
			break;
	}

	/* replace fields */
	var nstr = "", jj;
	for(i=0; i < out.length; ++i) {
		switch(out[i].t) {
			case 't': case 'T': case ' ': case 'D': break;
			case 'X': out[i].v = ""; out[i].t = ";"; break;
			case 'd': case 'm': case 'y': case 'h': case 'H': case 'M': case 's': case 'e': case 'b': case 'Z':
				/*::if(!dt) throw "unreachable"; */
				out[i].v = SSF_write_date(out[i].t.charCodeAt(0), out[i].v, dt, ss0);
				out[i].t = 't'; break;
			case 'n': case '?':
				jj = i+1;
				while(out[jj] != null && (
					(c=out[jj].t) === "?" || c === "D" ||
					((c === " " || c === "t") && out[jj+1] != null && (out[jj+1].t === '?' || out[jj+1].t === "t" && out[jj+1].v === '/')) ||
					(out[i].t === '(' && (c === ' ' || c === 'n' || c === ')')) ||
					(c === 't' && (out[jj].v === '/' || out[jj].v === ' ' && out[jj+1] != null && out[jj+1].t == '?'))
				)) {
					out[i].v += out[jj].v;
					out[jj] = {v:"", t:";"}; ++jj;
				}
				nstr += out[i].v;
				i = jj-1; break;
			case 'G': out[i].t = 't'; out[i].v = SSF_general(v,opts); break;
		}
	}
	var vv = "", myv, ostr;
	if(nstr.length > 0) {
		if(nstr.charCodeAt(0) == 40) /* '(' */ {
			myv = (v<0&&nstr.charCodeAt(0) === 45 ? -v : v);
			ostr = write_num('n', nstr, myv);
		} else {
			myv = (v<0 && flen > 1 ? -v : v);
			ostr = write_num('n', nstr, myv);
			if(myv < 0 && out[0] && out[0].t == 't') {
				ostr = ostr.substr(1);
				out[0].v = "-" + out[0].v;
			}
		}
		jj=ostr.length-1;
		var decpt = out.length;
		for(i=0; i < out.length; ++i) if(out[i] != null && out[i].t != 't' && out[i].v.indexOf(".") > -1) { decpt = i; break; }
		var lasti=out.length;
		if(decpt === out.length && ostr.indexOf("E") === -1) {
			for(i=out.length-1; i>= 0;--i) {
				if(out[i] == null || 'n?'.indexOf(out[i].t) === -1) continue;
				if(jj>=out[i].v.length-1) { jj -= out[i].v.length; out[i].v = ostr.substr(jj+1, out[i].v.length); }
				else if(jj < 0) out[i].v = "";
				else { out[i].v = ostr.substr(0, jj+1); jj = -1; }
				out[i].t = 't';
				lasti = i;
			}
			if(jj>=0 && lasti<out.length) out[lasti].v = ostr.substr(0,jj+1) + out[lasti].v;
		}
		else if(decpt !== out.length && ostr.indexOf("E") === -1) {
			jj = ostr.indexOf(".")-1;
			for(i=decpt; i>= 0; --i) {
				if(out[i] == null || 'n?'.indexOf(out[i].t) === -1) continue;
				j=out[i].v.indexOf(".")>-1&&i===decpt?out[i].v.indexOf(".")-1:out[i].v.length-1;
				vv = out[i].v.substr(j+1);
				for(; j>=0; --j) {
					if(jj>=0 && (out[i].v.charAt(j) === "0" || out[i].v.charAt(j) === "#")) vv = ostr.charAt(jj--) + vv;
				}
				out[i].v = vv;
				out[i].t = 't';
				lasti = i;
			}
			if(jj>=0 && lasti<out.length) out[lasti].v = ostr.substr(0,jj+1) + out[lasti].v;
			jj = ostr.indexOf(".")+1;
			for(i=decpt; i<out.length; ++i) {
				if(out[i] == null || ('n?('.indexOf(out[i].t) === -1 && i !== decpt)) continue;
				j=out[i].v.indexOf(".")>-1&&i===decpt?out[i].v.indexOf(".")+1:0;
				vv = out[i].v.substr(0,j);
				for(; j<out[i].v.length; ++j) {
					if(jj<ostr.length) vv += ostr.charAt(jj++);
				}
				out[i].v = vv;
				out[i].t = 't';
				lasti = i;
			}
		}
	}
	for(i=0; i<out.length; ++i) if(out[i] != null && 'n?'.indexOf(out[i].t)>-1) {
		myv = (flen >1 && v < 0 && i>0 && out[i-1].v === "-" ? -v:v);
		out[i].v = write_num(out[i].t, out[i].v, myv);
		out[i].t = 't';
	}
	var retval = "";
	for(i=0; i !== out.length; ++i) if(out[i] != null) retval += out[i].v;
	return retval;
}

var cfregex2 = /\[(=|>[=]?|<[>=]?)(-?\d+(?:\.\d*)?)\]/;
function chkcond(v, rr) {
	if(rr == null) return false;
	var thresh = parseFloat(rr[2]);
	switch(rr[1]) {
		case "=":  if(v == thresh) return true; break;
		case ">":  if(v >  thresh) return true; break;
		case "<":  if(v <  thresh) return true; break;
		case "<>": if(v != thresh) return true; break;
		case ">=": if(v >= thresh) return true; break;
		case "<=": if(v <= thresh) return true; break;
	}
	return false;
}
function choose_fmt(f/*:string*/, v/*:any*/) {
	var fmt = SSF_split_fmt(f);
	var l = fmt.length, lat = fmt[l-1].indexOf("@");
	if(l<4 && lat>-1) --l;
	if(fmt.length > 4) throw new Error("cannot find right format for |" + fmt.join("|") + "|");
	if(typeof v !== "number") return [4, fmt.length === 4 || lat>-1?fmt[fmt.length-1]:"@"];
	switch(fmt.length) {
		case 1: fmt = lat>-1 ? ["General", "General", "General", fmt[0]] : [fmt[0], fmt[0], fmt[0], "@"]; break;
		case 2: fmt = lat>-1 ? [fmt[0], fmt[0], fmt[0], fmt[1]] : [fmt[0], fmt[1], fmt[0], "@"]; break;
		case 3: fmt = lat>-1 ? [fmt[0], fmt[1], fmt[0], fmt[2]] : [fmt[0], fmt[1], fmt[2], "@"]; break;
		case 4: break;
	}
	var ff = v > 0 ? fmt[0] : v < 0 ? fmt[1] : fmt[2];
	if(fmt[0].indexOf("[") === -1 && fmt[1].indexOf("[") === -1) return [l, ff];
	if(fmt[0].match(/\[[=<>]/) != null || fmt[1].match(/\[[=<>]/) != null) {
		var m1 = fmt[0].match(cfregex2);
		var m2 = fmt[1].match(cfregex2);
		return chkcond(v, m1) ? [l, fmt[0]] : chkcond(v, m2) ? [l, fmt[1]] : [l, fmt[m1 != null && m2 != null ? 2 : 1]];
	}
	return [l, ff];
}
function SSF_format(fmt/*:string|number*/,v/*:any*/,o/*:?any*/) {
	if(o == null) o = {};
	var sfmt = "";
	switch(typeof fmt) {
		case "string":
			if(fmt == "m/d/yy" && o.dateNF) sfmt = o.dateNF;
			else sfmt = fmt;
			break;
		case "number":
			if(fmt == 14 && o.dateNF) sfmt = o.dateNF;
			else sfmt = (o.table != null ? (o.table/*:any*/) : table_fmt)[fmt];
			if(sfmt == null) sfmt = (o.table && o.table[SSF_default_map[fmt]]) || table_fmt[SSF_default_map[fmt]];
			if(sfmt == null) sfmt = SSF_default_str[fmt] || "General";
			break;
	}
	if(SSF_isgeneral(sfmt,0)) return SSF_general(v, o);
	if(v instanceof Date) v = datenum_local(v, o.date1904);
	var f = choose_fmt(sfmt, v);
	if(SSF_isgeneral(f[1])) return SSF_general(v, o);
	if(v === true) v = "TRUE"; else if(v === false) v = "FALSE";
	else if(v === "" || v == null) return "";
	return eval_fmt(f[1], v, o, f[0]);
}
function SSF_load(fmt/*:string*/, idx/*:?number*/)/*:number*/ {
	if(typeof idx != 'number') {
		idx = +idx || -1;
/*::if(typeof idx != 'number') return 0x188; */
		for(var i = 0; i < 0x0188; ++i) {
/*::if(typeof idx != 'number') return 0x188; */
			if(table_fmt[i] == undefined) { if(idx < 0) idx = i; continue; }
			if(table_fmt[i] == fmt) { idx = i; break; }
		}
/*::if(typeof idx != 'number') return 0x188; */
		if(idx < 0) idx = 0x187;
	}
/*::if(typeof idx != 'number') return 0x188; */
	table_fmt[idx] = fmt;
	return idx;
}
function SSF_load_table(tbl/*:SSFTable*/)/*:void*/ {
	for(var i=0; i!=0x0188; ++i)
		if(tbl[i] !== undefined) SSF_load(tbl[i], i);
}

function make_ssf() {
	table_fmt = SSF_init_table();
}

var SSF = {
	format: SSF_format,
	load: SSF_load,
	_table: table_fmt,
	load_table: SSF_load_table,
	parse_date_code: SSF_parse_date_code,
	is_date: fmt_is_date,
	get_table: function get_table() { return SSF._table = table_fmt; }
};

var SSFImplicit/*{[number]:string}*/ = ({
	"5": '"$"#,##0_);\\("$"#,##0\\)',
	"6": '"$"#,##0_);[Red]\\("$"#,##0\\)',
	"7": '"$"#,##0.00_);\\("$"#,##0.00\\)',
	"8": '"$"#,##0.00_);[Red]\\("$"#,##0.00\\)',
	"23": 'General', "24": 'General', "25": 'General', "26": 'General',
	"27": 'm/d/yy', "28": 'm/d/yy', "29": 'm/d/yy', "30": 'm/d/yy', "31": 'm/d/yy',
	"32": 'h:mm:ss', "33": 'h:mm:ss', "34": 'h:mm:ss', "35": 'h:mm:ss',
	"36": 'm/d/yy',
	"41": '_(* #,##0_);_(* \(#,##0\);_(* "-"_);_(@_)',
	"42": '_("$"* #,##0_);_("$"* \(#,##0\);_("$"* "-"_);_(@_)',
	"43": '_(* #,##0.00_);_(* \(#,##0.00\);_(* "-"??_);_(@_)',
	"44": '_("$"* #,##0.00_);_("$"* \(#,##0.00\);_("$"* "-"??_);_(@_)',
	"50": 'm/d/yy', "51": 'm/d/yy', "52": 'm/d/yy', "53": 'm/d/yy', "54": 'm/d/yy',
	"55": 'm/d/yy', "56": 'm/d/yy', "57": 'm/d/yy', "58": 'm/d/yy',
	"59": '0',
	"60": '0.00',
	"61": '#,##0',
	"62": '#,##0.00',
	"63": '"$"#,##0_);\\("$"#,##0\\)',
	"64": '"$"#,##0_);[Red]\\("$"#,##0\\)',
	"65": '"$"#,##0.00_);\\("$"#,##0.00\\)',
	"66": '"$"#,##0.00_);[Red]\\("$"#,##0.00\\)',
	"67": '0%',
	"68": '0.00%',
	"69": '# ?/?',
	"70": '# ??/??',
	"71": 'm/d/yy',
	"72": 'm/d/yy',
	"73": 'd-mmm-yy',
	"74": 'd-mmm',
	"75": 'mmm-yy',
	"76": 'h:mm',
	"77": 'h:mm:ss',
	"78": 'm/d/yy h:mm',
	"79": 'mm:ss',
	"80": '[h]:mm:ss',
	"81": 'mmss.0'
}/*:any*/);

/* dateNF parse TODO: move to SSF */
var dateNFregex = /[dD]+|[mM]+|[yYeE]+|[Hh]+|[Ss]+/g;
function dateNF_regex(dateNF/*:string|number*/)/*:RegExp*/ {
	var fmt = typeof dateNF == "number" ? table_fmt[dateNF] : dateNF;
	fmt = fmt.replace(dateNFregex, "(\\d+)");
	return new RegExp("^" + fmt + "$");
}
function dateNF_fix(str/*:string*/, dateNF/*:string*/, match/*:Array<string>*/)/*:string*/ {
	var Y = -1, m = -1, d = -1, H = -1, M = -1, S = -1;
	(dateNF.match(dateNFregex)||[]).forEach(function(n, i) {
		var v = parseInt(match[i+1], 10);
		switch(n.toLowerCase().charAt(0)) {
			case 'y': Y = v; break; case 'd': d = v; break;
			case 'h': H = v; break; case 's': S = v; break;
			case 'm': if(H >= 0) M = v; else m = v; break;
		}
	});
	if(S >= 0 && M == -1 && m >= 0) { M = m; m = -1; }
	var datestr = (("" + (Y>=0?Y: new Date().getFullYear())).slice(-4) + "-" + ("00" + (m>=1?m:1)).slice(-2) + "-" + ("00" + (d>=1?d:1)).slice(-2));
	if(datestr.length == 7) datestr = "0" + datestr;
	if(datestr.length == 8) datestr = "20" + datestr;
	var timestr = (("00" + (H>=0?H:0)).slice(-2) + ":" + ("00" + (M>=0?M:0)).slice(-2) + ":" + ("00" + (S>=0?S:0)).slice(-2));
	if(H == -1 && M == -1 && S == -1) return datestr;
	if(Y == -1 && m == -1 && d == -1) return timestr;
	return datestr + "T" + timestr;
}

/*::
declare var ReadShift:any;
declare var CheckField:any;
declare var prep_blob:any;
declare var __readUInt32LE:any;
declare var __readInt32LE:any;
declare var __toBuffer:any;
declare var __utf16le:any;
declare var bconcat:any;
declare var s2a:any;
declare var chr0:any;
declare var chr1:any;
declare var has_buf:boolean;
declare var new_buf:any;
declare var new_raw_buf:any;
declare var new_unsafe_buf:any;
declare var Buffer_from:any;
*/
/* cfb.js (C) 2013-present SheetJS -- http://sheetjs.com */
/* vim: set ts=2: */
/*jshint eqnull:true */
/*exported CFB */
/*global Uint8Array:false, Uint16Array:false */

/*::
type SectorEntry = {
	name?:string;
	nodes?:Array<number>;
	data:RawBytes;
};
type SectorList = {
	[k:string|number]:SectorEntry;
	name:?string;
	fat_addrs:Array<number>;
	ssz:number;
}
type CFBFiles = {[n:string]:CFBEntry};
*/
/* crc32.js (C) 2014-present SheetJS -- http://sheetjs.com */
/* vim: set ts=2: */
/*exported CRC32 */
var CRC32 = /*#__PURE__*/(function() {
var CRC32 = {};
CRC32.version = '1.2.0';
/* see perf/crc32table.js */
/*global Int32Array */
function signed_crc_table()/*:any*/ {
	var c = 0, table/*:Array<number>*/ = new Array(256);

	for(var n =0; n != 256; ++n){
		c = n;
		c = ((c&1) ? (-306674912 ^ (c >>> 1)) : (c >>> 1));
		c = ((c&1) ? (-306674912 ^ (c >>> 1)) : (c >>> 1));
		c = ((c&1) ? (-306674912 ^ (c >>> 1)) : (c >>> 1));
		c = ((c&1) ? (-306674912 ^ (c >>> 1)) : (c >>> 1));
		c = ((c&1) ? (-306674912 ^ (c >>> 1)) : (c >>> 1));
		c = ((c&1) ? (-306674912 ^ (c >>> 1)) : (c >>> 1));
		c = ((c&1) ? (-306674912 ^ (c >>> 1)) : (c >>> 1));
		c = ((c&1) ? (-306674912 ^ (c >>> 1)) : (c >>> 1));
		table[n] = c;
	}

	return typeof Int32Array !== 'undefined' ? new Int32Array(table) : table;
}

var T0 = signed_crc_table();
function slice_by_16_tables(T) {
	var c = 0, v = 0, n = 0, table/*:Array<number>*/ = typeof Int32Array !== 'undefined' ? new Int32Array(4096) : new Array(4096) ;

	for(n = 0; n != 256; ++n) table[n] = T[n];
	for(n = 0; n != 256; ++n) {
		v = T[n];
		for(c = 256 + n; c < 4096; c += 256) v = table[c] = (v >>> 8) ^ T[v & 0xFF];
	}
	var out = [];
	for(n = 1; n != 16; ++n) out[n - 1] = typeof Int32Array !== 'undefined' ? table.subarray(n * 256, n * 256 + 256) : table.slice(n * 256, n * 256 + 256);
	return out;
}
var TT = slice_by_16_tables(T0);
var T1 = TT[0],  T2 = TT[1],  T3 = TT[2],  T4 = TT[3],  T5 = TT[4];
var T6 = TT[5],  T7 = TT[6],  T8 = TT[7],  T9 = TT[8],  Ta = TT[9];
var Tb = TT[10], Tc = TT[11], Td = TT[12], Te = TT[13], Tf = TT[14];
function crc32_bstr(bstr/*:string*/, seed/*:number*/)/*:number*/ {
	var C = seed/*:: ? 0 : 0 */ ^ -1;
	for(var i = 0, L = bstr.length; i < L;) C = (C>>>8) ^ T0[(C^bstr.charCodeAt(i++))&0xFF];
	return ~C;
}

function crc32_buf(B/*:Uint8Array|Array<number>*/, seed/*:number*/)/*:number*/ {
	var C = seed/*:: ? 0 : 0 */ ^ -1, L = B.length - 15, i = 0;
	for(; i < L;) C =
		Tf[B[i++] ^ (C & 255)] ^
		Te[B[i++] ^ ((C >> 8) & 255)] ^
		Td[B[i++] ^ ((C >> 16) & 255)] ^
		Tc[B[i++] ^ (C >>> 24)] ^
		Tb[B[i++]] ^ Ta[B[i++]] ^ T9[B[i++]] ^ T8[B[i++]] ^
		T7[B[i++]] ^ T6[B[i++]] ^ T5[B[i++]] ^ T4[B[i++]] ^
		T3[B[i++]] ^ T2[B[i++]] ^ T1[B[i++]] ^ T0[B[i++]];
	L += 15;
	while(i < L) C = (C>>>8) ^ T0[(C^B[i++])&0xFF];
	return ~C;
}

function crc32_str(str/*:string*/, seed/*:number*/)/*:number*/ {
	var C = seed ^ -1;
	for(var i = 0, L = str.length, c = 0, d = 0; i < L;) {
		c = str.charCodeAt(i++);
		if(c < 0x80) {
			C = (C>>>8) ^ T0[(C^c)&0xFF];
		} else if(c < 0x800) {
			C = (C>>>8) ^ T0[(C ^ (192|((c>>6)&31)))&0xFF];
			C = (C>>>8) ^ T0[(C ^ (128|(c&63)))&0xFF];
		} else if(c >= 0xD800 && c < 0xE000) {
			c = (c&1023)+64; d = str.charCodeAt(i++)&1023;
			C = (C>>>8) ^ T0[(C ^ (240|((c>>8)&7)))&0xFF];
			C = (C>>>8) ^ T0[(C ^ (128|((c>>2)&63)))&0xFF];
			C = (C>>>8) ^ T0[(C ^ (128|((d>>6)&15)|((c&3)<<4)))&0xFF];
			C = (C>>>8) ^ T0[(C ^ (128|(d&63)))&0xFF];
		} else {
			C = (C>>>8) ^ T0[(C ^ (224|((c>>12)&15)))&0xFF];
			C = (C>>>8) ^ T0[(C ^ (128|((c>>6)&63)))&0xFF];
			C = (C>>>8) ^ T0[(C ^ (128|(c&63)))&0xFF];
		}
	}
	return ~C;
}
CRC32.table = T0;
CRC32.bstr = crc32_bstr;
CRC32.buf = crc32_buf;
CRC32.str = crc32_str;
return CRC32;
})();
/* [MS-CFB] v20171201 */
var CFB = /*#__PURE__*/(function _CFB(){
var exports = {};
exports.version = '1.2.1';
/* [MS-CFB] 2.6.4 */
function namecmp(l/*:string*/, r/*:string*/)/*:number*/ {
	var L = l.split("/"), R = r.split("/");
	for(var i = 0, c = 0, Z = Math.min(L.length, R.length); i < Z; ++i) {
		if((c = L[i].length - R[i].length)) return c;
		if(L[i] != R[i]) return L[i] < R[i] ? -1 : 1;
	}
	return L.length - R.length;
}
function dirname(p/*:string*/)/*:string*/ {
	if(p.charAt(p.length - 1) == "/") return (p.slice(0,-1).indexOf("/") === -1) ? p : dirname(p.slice(0, -1));
	var c = p.lastIndexOf("/");
	return (c === -1) ? p : p.slice(0, c+1);
}

function filename(p/*:string*/)/*:string*/ {
	if(p.charAt(p.length - 1) == "/") return filename(p.slice(0, -1));
	var c = p.lastIndexOf("/");
	return (c === -1) ? p : p.slice(c+1);
}
/* -------------------------------------------------------------------------- */
/* DOS Date format:
   high|YYYYYYYm.mmmddddd.HHHHHMMM.MMMSSSSS|low
   add 1980 to stored year
   stored second should be doubled
*/

/* write JS date to buf as a DOS date */
function write_dos_date(buf/*:CFBlob*/, date/*:Date|string*/) {
	if(typeof date === "string") date = new Date(date);
	var hms/*:number*/ = date.getHours();
	hms = hms << 6 | date.getMinutes();
	hms = hms << 5 | (date.getSeconds()>>>1);
	buf.write_shift(2, hms);
	var ymd/*:number*/ = (date.getFullYear() - 1980);
	ymd = ymd << 4 | (date.getMonth()+1);
	ymd = ymd << 5 | date.getDate();
	buf.write_shift(2, ymd);
}

/* read four bytes from buf and interpret as a DOS date */
function parse_dos_date(buf/*:CFBlob*/)/*:Date*/ {
	var hms = buf.read_shift(2) & 0xFFFF;
	var ymd = buf.read_shift(2) & 0xFFFF;
	var val = new Date();
	var d = ymd & 0x1F; ymd >>>= 5;
	var m = ymd & 0x0F; ymd >>>= 4;
	val.setMilliseconds(0);
	val.setFullYear(ymd + 1980);
	val.setMonth(m-1);
	val.setDate(d);
	var S = hms & 0x1F; hms >>>= 5;
	var M = hms & 0x3F; hms >>>= 6;
	val.setHours(hms);
	val.setMinutes(M);
	val.setSeconds(S<<1);
	return val;
}
function parse_extra_field(blob/*:CFBlob*/)/*:any*/ {
	prep_blob(blob, 0);
	var o = /*::(*/{}/*:: :any)*/;
	var flags = 0;
	while(blob.l <= blob.length - 4) {
		var type = blob.read_shift(2);
		var sz = blob.read_shift(2), tgt = blob.l + sz;
		var p = {};
		switch(type) {
			/* UNIX-style Timestamps */
			case 0x5455: {
				flags = blob.read_shift(1);
				if(flags & 1) p.mtime = blob.read_shift(4);
				/* for some reason, CD flag corresponds to LFH */
				if(sz > 5) {
					if(flags & 2) p.atime = blob.read_shift(4);
					if(flags & 4) p.ctime = blob.read_shift(4);
				}
				if(p.mtime) p.mt = new Date(p.mtime*1000);
			}
			break;
		}
		blob.l = tgt;
		o[type] = p;
	}
	return o;
}
var fs/*:: = require('fs'); */;
function get_fs() { return fs || (fs = {}); }
function parse(file/*:RawBytes*/, options/*:CFBReadOpts*/)/*:CFBContainer*/ {
if(file[0] == 0x50 && file[1] == 0x4b) return parse_zip(file, options);
if((file[0] | 0x20) == 0x6d && (file[1]|0x20) == 0x69) return parse_mad(file, options);
if(file.length < 512) throw new Error("CFB file size " + file.length + " < 512");
var mver = 3;
var ssz = 512;
var nmfs = 0; // number of mini FAT sectors
var difat_sec_cnt = 0;
var dir_start = 0;
var minifat_start = 0;
var difat_start = 0;

var fat_addrs/*:Array<number>*/ = []; // locations of FAT sectors

/* [MS-CFB] 2.2 Compound File Header */
var blob/*:CFBlob*/ = /*::(*/file.slice(0,512)/*:: :any)*/;
prep_blob(blob, 0);

/* major version */
var mv = check_get_mver(blob);
mver = mv[0];
switch(mver) {
	case 3: ssz = 512; break; case 4: ssz = 4096; break;
	case 0: if(mv[1] == 0) return parse_zip(file, options);
	/* falls through */
	default: throw new Error("Major Version: Expected 3 or 4 saw " + mver);
}

/* reprocess header */
if(ssz !== 512) { blob = /*::(*/file.slice(0,ssz)/*:: :any)*/; prep_blob(blob, 28 /* blob.l */); }
/* Save header for final object */
var header/*:RawBytes*/ = file.slice(0,ssz);

check_shifts(blob, mver);

// Number of Directory Sectors
var dir_cnt/*:number*/ = blob.read_shift(4, 'i');
if(mver === 3 && dir_cnt !== 0) throw new Error('# Directory Sectors: Expected 0 saw ' + dir_cnt);

// Number of FAT Sectors
blob.l += 4;

// First Directory Sector Location
dir_start = blob.read_shift(4, 'i');

// Transaction Signature
blob.l += 4;

// Mini Stream Cutoff Size
blob.chk('00100000', 'Mini Stream Cutoff Size: ');

// First Mini FAT Sector Location
minifat_start = blob.read_shift(4, 'i');

// Number of Mini FAT Sectors
nmfs = blob.read_shift(4, 'i');

// First DIFAT sector location
difat_start = blob.read_shift(4, 'i');

// Number of DIFAT Sectors
difat_sec_cnt = blob.read_shift(4, 'i');

// Grab FAT Sector Locations
for(var q = -1, j = 0; j < 109; ++j) { /* 109 = (512 - blob.l)>>>2; */
	q = blob.read_shift(4, 'i');
	if(q<0) break;
	fat_addrs[j] = q;
}

/** Break the file up into sectors */
var sectors/*:Array<RawBytes>*/ = sectorify(file, ssz);

sleuth_fat(difat_start, difat_sec_cnt, sectors, ssz, fat_addrs);

/** Chains */
var sector_list/*:SectorList*/ = make_sector_list(sectors, dir_start, fat_addrs, ssz);

sector_list[dir_start].name = "!Directory";
if(nmfs > 0 && minifat_start !== ENDOFCHAIN) sector_list[minifat_start].name = "!MiniFAT";
sector_list[fat_addrs[0]].name = "!FAT";
sector_list.fat_addrs = fat_addrs;
sector_list.ssz = ssz;

/* [MS-CFB] 2.6.1 Compound File Directory Entry */
var files/*:CFBFiles*/ = {}, Paths/*:Array<string>*/ = [], FileIndex/*:CFBFileIndex*/ = [], FullPaths/*:Array<string>*/ = [];
read_directory(dir_start, sector_list, sectors, Paths, nmfs, files, FileIndex, minifat_start);

build_full_paths(FileIndex, FullPaths, Paths);
Paths.shift();

var o = {
	FileIndex: FileIndex,
	FullPaths: FullPaths
};

// $FlowIgnore
if(options && options.raw) o.raw = {header: header, sectors: sectors};
return o;
} // parse

/* [MS-CFB] 2.2 Compound File Header -- read up to major version */
function check_get_mver(blob/*:CFBlob*/)/*:[number, number]*/ {
	if(blob[blob.l] == 0x50 && blob[blob.l + 1] == 0x4b) return [0, 0];
	// header signature 8
	blob.chk(HEADER_SIGNATURE, 'Header Signature: ');

	// clsid 16
	//blob.chk(HEADER_CLSID, 'CLSID: ');
	blob.l += 16;

	// minor version 2
	var mver/*:number*/ = blob.read_shift(2, 'u');

	return [blob.read_shift(2,'u'), mver];
}
function check_shifts(blob/*:CFBlob*/, mver/*:number*/)/*:void*/ {
	var shift = 0x09;

	// Byte Order
	//blob.chk('feff', 'Byte Order: '); // note: some writers put 0xffff
	blob.l += 2;

	// Sector Shift
	switch((shift = blob.read_shift(2))) {
		case 0x09: if(mver != 3) throw new Error('Sector Shift: Expected 9 saw ' + shift); break;
		case 0x0c: if(mver != 4) throw new Error('Sector Shift: Expected 12 saw ' + shift); break;
		default: throw new Error('Sector Shift: Expected 9 or 12 saw ' + shift);
	}

	// Mini Sector Shift
	blob.chk('0600', 'Mini Sector Shift: ');

	// Reserved
	blob.chk('000000000000', 'Reserved: ');
}

/** Break the file up into sectors */
function sectorify(file/*:RawBytes*/, ssz/*:number*/)/*:Array<RawBytes>*/ {
	var nsectors = Math.ceil(file.length/ssz)-1;
	var sectors/*:Array<RawBytes>*/ = [];
	for(var i=1; i < nsectors; ++i) sectors[i-1] = file.slice(i*ssz,(i+1)*ssz);
	sectors[nsectors-1] = file.slice(nsectors*ssz);
	return sectors;
}

/* [MS-CFB] 2.6.4 Red-Black Tree */
function build_full_paths(FI/*:CFBFileIndex*/, FP/*:Array<string>*/, Paths/*:Array<string>*/)/*:void*/ {
	var i = 0, L = 0, R = 0, C = 0, j = 0, pl = Paths.length;
	var dad/*:Array<number>*/ = [], q/*:Array<number>*/ = [];

	for(; i < pl; ++i) { dad[i]=q[i]=i; FP[i]=Paths[i]; }

	for(; j < q.length; ++j) {
		i = q[j];
		L = FI[i].L; R = FI[i].R; C = FI[i].C;
		if(dad[i] === i) {
			if(L !== -1 /*NOSTREAM*/ && dad[L] !== L) dad[i] = dad[L];
			if(R !== -1 && dad[R] !== R) dad[i] = dad[R];
		}
		if(C !== -1 /*NOSTREAM*/) dad[C] = i;
		if(L !== -1 && i != dad[i]) { dad[L] = dad[i]; if(q.lastIndexOf(L) < j) q.push(L); }
		if(R !== -1 && i != dad[i]) { dad[R] = dad[i]; if(q.lastIndexOf(R) < j) q.push(R); }
	}
	for(i=1; i < pl; ++i) if(dad[i] === i) {
		if(R !== -1 /*NOSTREAM*/ && dad[R] !== R) dad[i] = dad[R];
		else if(L !== -1 && dad[L] !== L) dad[i] = dad[L];
	}

	for(i=1; i < pl; ++i) {
		if(FI[i].type === 0 /* unknown */) continue;
		j = i;
		if(j != dad[j]) do {
			j = dad[j];
			FP[i] = FP[j] + "/" + FP[i];
		} while (j !== 0 && -1 !== dad[j] && j != dad[j]);
		dad[i] = -1;
	}

	FP[0] += "/";
	for(i=1; i < pl; ++i) {
		if(FI[i].type !== 2 /* stream */) FP[i] += "/";
	}
}

function get_mfat_entry(entry/*:CFBEntry*/, payload/*:RawBytes*/, mini/*:?RawBytes*/)/*:CFBlob*/ {
	var start = entry.start, size = entry.size;
	//return (payload.slice(start*MSSZ, start*MSSZ + size)/*:any*/);
	var o = [];
	var idx = start;
	while(mini && size > 0 && idx >= 0) {
		o.push(payload.slice(idx * MSSZ, idx * MSSZ + MSSZ));
		size -= MSSZ;
		idx = __readInt32LE(mini, idx * 4);
	}
	if(o.length === 0) return (new_buf(0)/*:any*/);
	return (bconcat(o).slice(0, entry.size)/*:any*/);
}

/** Chase down the rest of the DIFAT chain to build a comprehensive list
    DIFAT chains by storing the next sector number as the last 32 bits */
function sleuth_fat(idx/*:number*/, cnt/*:number*/, sectors/*:Array<RawBytes>*/, ssz/*:number*/, fat_addrs)/*:void*/ {
	var q/*:number*/ = ENDOFCHAIN;
	if(idx === ENDOFCHAIN) {
		if(cnt !== 0) throw new Error("DIFAT chain shorter than expected");
	} else if(idx !== -1 /*FREESECT*/) {
		var sector = sectors[idx], m = (ssz>>>2)-1;
		if(!sector) return;
		for(var i = 0; i < m; ++i) {
			if((q = __readInt32LE(sector,i*4)) === ENDOFCHAIN) break;
			fat_addrs.push(q);
		}
		sleuth_fat(__readInt32LE(sector,ssz-4),cnt - 1, sectors, ssz, fat_addrs);
	}
}

/** Follow the linked list of sectors for a given starting point */
function get_sector_list(sectors/*:Array<RawBytes>*/, start/*:number*/, fat_addrs/*:Array<number>*/, ssz/*:number*/, chkd/*:?Array<boolean>*/)/*:SectorEntry*/ {
	var buf/*:Array<number>*/ = [], buf_chain/*:Array<any>*/ = [];
	if(!chkd) chkd = [];
	var modulus = ssz - 1, j = 0, jj = 0;
	for(j=start; j>=0;) {
		chkd[j] = true;
		buf[buf.length] = j;
		buf_chain.push(sectors[j]);
		var addr = fat_addrs[Math.floor(j*4/ssz)];
		jj = ((j*4) & modulus);
		if(ssz < 4 + jj) throw new Error("FAT boundary crossed: " + j + " 4 "+ssz);
		if(!sectors[addr]) break;
		j = __readInt32LE(sectors[addr], jj);
	}
	return {nodes: buf, data:__toBuffer([buf_chain])};
}

/** Chase down the sector linked lists */
function make_sector_list(sectors/*:Array<RawBytes>*/, dir_start/*:number*/, fat_addrs/*:Array<number>*/, ssz/*:number*/)/*:SectorList*/ {
	var sl = sectors.length, sector_list/*:SectorList*/ = ([]/*:any*/);
	var chkd/*:Array<boolean>*/ = [], buf/*:Array<number>*/ = [], buf_chain/*:Array<RawBytes>*/ = [];
	var modulus = ssz - 1, i=0, j=0, k=0, jj=0;
	for(i=0; i < sl; ++i) {
		buf = ([]/*:Array<number>*/);
		k = (i + dir_start); if(k >= sl) k-=sl;
		if(chkd[k]) continue;
		buf_chain = [];
		var seen = [];
		for(j=k; j>=0;) {
			seen[j] = true;
			chkd[j] = true;
			buf[buf.length] = j;
			buf_chain.push(sectors[j]);
			var addr/*:number*/ = fat_addrs[Math.floor(j*4/ssz)];
			jj = ((j*4) & modulus);
			if(ssz < 4 + jj) throw new Error("FAT boundary crossed: " + j + " 4 "+ssz);
			if(!sectors[addr]) break;
			j = __readInt32LE(sectors[addr], jj);
			if(seen[j]) break;
		}
		sector_list[k] = ({nodes: buf, data:__toBuffer([buf_chain])}/*:SectorEntry*/);
	}
	return sector_list;
}

/* [MS-CFB] 2.6.1 Compound File Directory Entry */
function read_directory(dir_start/*:number*/, sector_list/*:SectorList*/, sectors/*:Array<RawBytes>*/, Paths/*:Array<string>*/, nmfs, files, FileIndex, mini) {
	var minifat_store = 0, pl = (Paths.length?2:0);
	var sector = sector_list[dir_start].data;
	var i = 0, namelen = 0, name;
	for(; i < sector.length; i+= 128) {
		var blob/*:CFBlob*/ = /*::(*/sector.slice(i, i+128)/*:: :any)*/;
		prep_blob(blob, 64);
		namelen = blob.read_shift(2);
		name = __utf16le(blob,0,namelen-pl);
		Paths.push(name);
		var o/*:CFBEntry*/ = ({
			name:  name,
			type:  blob.read_shift(1),
			color: blob.read_shift(1),
			L:     blob.read_shift(4, 'i'),
			R:     blob.read_shift(4, 'i'),
			C:     blob.read_shift(4, 'i'),
			clsid: blob.read_shift(16),
			state: blob.read_shift(4, 'i'),
			start: 0,
			size: 0
		});
		var ctime/*:number*/ = blob.read_shift(2) + blob.read_shift(2) + blob.read_shift(2) + blob.read_shift(2);
		if(ctime !== 0) o.ct = read_date(blob, blob.l-8);
		var mtime/*:number*/ = blob.read_shift(2) + blob.read_shift(2) + blob.read_shift(2) + blob.read_shift(2);
		if(mtime !== 0) o.mt = read_date(blob, blob.l-8);
		o.start = blob.read_shift(4, 'i');
		o.size = blob.read_shift(4, 'i');
		if(o.size < 0 && o.start < 0) { o.size = o.type = 0; o.start = ENDOFCHAIN; o.name = ""; }
		if(o.type === 5) { /* root */
			minifat_store = o.start;
			if(nmfs > 0 && minifat_store !== ENDOFCHAIN) sector_list[minifat_store].name = "!StreamData";
			/*minifat_size = o.size;*/
		} else if(o.size >= 4096 /* MSCSZ */) {
			o.storage = 'fat';
			if(sector_list[o.start] === undefined) sector_list[o.start] = get_sector_list(sectors, o.start, sector_list.fat_addrs, sector_list.ssz);
			sector_list[o.start].name = o.name;
			o.content = (sector_list[o.start].data.slice(0,o.size)/*:any*/);
		} else {
			o.storage = 'minifat';
			if(o.size < 0) o.size = 0;
			else if(minifat_store !== ENDOFCHAIN && o.start !== ENDOFCHAIN && sector_list[minifat_store]) {
				o.content = get_mfat_entry(o, sector_list[minifat_store].data, (sector_list[mini]||{}).data);
			}
		}
		if(o.content) prep_blob(o.content, 0);
		files[name] = o;
		FileIndex.push(o);
	}
}

function read_date(blob/*:RawBytes|CFBlob*/, offset/*:number*/)/*:Date*/ {
	return new Date(( ( (__readUInt32LE(blob,offset+4)/1e7)*Math.pow(2,32)+__readUInt32LE(blob,offset)/1e7 ) - 11644473600)*1000);
}

function read_file(filename/*:string*/, options/*:CFBReadOpts*/) {
	get_fs();
	return parse(fs.readFileSync(filename), options);
}

function read(blob/*:RawBytes|string*/, options/*:CFBReadOpts*/) {
	var type = options && options.type;
	if(!type) {
		if(has_buf && Buffer.isBuffer(blob)) type = "buffer";
	}
	switch(type || "base64") {
		case "file": /*:: if(typeof blob !== 'string') throw "Must pass a filename when type='file'"; */return read_file(blob, options);
		case "base64": /*:: if(typeof blob !== 'string') throw "Must pass a base64-encoded binary string when type='file'"; */return parse(s2a(Base64_decode(blob)), options);
		case "binary": /*:: if(typeof blob !== 'string') throw "Must pass a binary string when type='file'"; */return parse(s2a(blob), options);
	}
	return parse(/*::typeof blob == 'string' ? new Buffer(blob, 'utf-8') : */blob, options);
}

function init_cfb(cfb/*:CFBContainer*/, opts/*:?any*/)/*:void*/ {
	var o = opts || {}, root = o.root || "Root Entry";
	if(!cfb.FullPaths) cfb.FullPaths = [];
	if(!cfb.FileIndex) cfb.FileIndex = [];
	if(cfb.FullPaths.length !== cfb.FileIndex.length) throw new Error("inconsistent CFB structure");
	if(cfb.FullPaths.length === 0) {
		cfb.FullPaths[0] = root + "/";
		cfb.FileIndex[0] = ({ name: root, type: 5 }/*:any*/);
	}
	if(o.CLSID) cfb.FileIndex[0].clsid = o.CLSID;
	seed_cfb(cfb);
}
function seed_cfb(cfb/*:CFBContainer*/)/*:void*/ {
	var nm = "\u0001Sh33tJ5";
	if(CFB.find(cfb, "/" + nm)) return;
	var p = new_buf(4); p[0] = 55; p[1] = p[3] = 50; p[2] = 54;
	cfb.FileIndex.push(({ name: nm, type: 2, content:p, size:4, L:69, R:69, C:69 }/*:any*/));
	cfb.FullPaths.push(cfb.FullPaths[0] + nm);
	rebuild_cfb(cfb);
}
function rebuild_cfb(cfb/*:CFBContainer*/, f/*:?boolean*/)/*:void*/ {
	init_cfb(cfb);
	var gc = false, s = false;
	for(var i = cfb.FullPaths.length - 1; i >= 0; --i) {
		var _file = cfb.FileIndex[i];
		switch(_file.type) {
			case 0:
				if(s) gc = true;
				else { cfb.FileIndex.pop(); cfb.FullPaths.pop(); }
				break;
			case 1: case 2: case 5:
				s = true;
				if(isNaN(_file.R * _file.L * _file.C)) gc = true;
				if(_file.R > -1 && _file.L > -1 && _file.R == _file.L) gc = true;
				break;
			default: gc = true; break;
		}
	}
	if(!gc && !f) return;

	var now = new Date(1987, 1, 19), j = 0;
	// Track which names exist
	var fullPaths = Object.create ? Object.create(null) : {};
	var data/*:Array<[string, CFBEntry]>*/ = [];
	for(i = 0; i < cfb.FullPaths.length; ++i) {
		fullPaths[cfb.FullPaths[i]] = true;
		if(cfb.FileIndex[i].type === 0) continue;
		data.push([cfb.FullPaths[i], cfb.FileIndex[i]]);
	}
	for(i = 0; i < data.length; ++i) {
		var dad = dirname(data[i][0]);
		s = fullPaths[dad];
		if(!s) {
			data.push([dad, ({
				name: filename(dad).replace("/",""),
				type: 1,
				clsid: HEADER_CLSID,
				ct: now, mt: now,
				content: null
			}/*:any*/)]);
			// Add name to set
			fullPaths[dad] = true;
		}
	}

	data.sort(function(x,y) { return namecmp(x[0], y[0]); });
	cfb.FullPaths = []; cfb.FileIndex = [];
	for(i = 0; i < data.length; ++i) { cfb.FullPaths[i] = data[i][0]; cfb.FileIndex[i] = data[i][1]; }
	for(i = 0; i < data.length; ++i) {
		var elt = cfb.FileIndex[i];
		var nm = cfb.FullPaths[i];

		elt.name =  filename(nm).replace("/","");
		elt.L = elt.R = elt.C = -(elt.color = 1);
		elt.size = elt.content ? elt.content.length : 0;
		elt.start = 0;
		elt.clsid = (elt.clsid || HEADER_CLSID);
		if(i === 0) {
			elt.C = data.length > 1 ? 1 : -1;
			elt.size = 0;
			elt.type = 5;
		} else if(nm.slice(-1) == "/") {
			for(j=i+1;j < data.length; ++j) if(dirname(cfb.FullPaths[j])==nm) break;
			elt.C = j >= data.length ? -1 : j;
			for(j=i+1;j < data.length; ++j) if(dirname(cfb.FullPaths[j])==dirname(nm)) break;
			elt.R = j >= data.length ? -1 : j;
			elt.type = 1;
		} else {
			if(dirname(cfb.FullPaths[i+1]||"") == dirname(nm)) elt.R = i + 1;
			elt.type = 2;
		}
	}

}

function _write(cfb/*:CFBContainer*/, options/*:CFBWriteOpts*/)/*:RawBytes|string*/ {
	var _opts = options || {};
	/* MAD is order-sensitive, skip rebuild and sort */
	if(_opts.fileType == 'mad') return write_mad(cfb, _opts);
	rebuild_cfb(cfb);
	switch(_opts.fileType) {
		case 'zip': return write_zip(cfb, _opts);
		//case 'mad': return write_mad(cfb, _opts);
	}
	var L = (function(cfb/*:CFBContainer*/)/*:Array<number>*/{
		var mini_size = 0, fat_size = 0;
		for(var i = 0; i < cfb.FileIndex.length; ++i) {
			var file = cfb.FileIndex[i];
			if(!file.content) continue;
			/*:: if(file.content == null) throw new Error("unreachable"); */
			var flen = file.content.length;
			if(flen > 0){
				if(flen < 0x1000) mini_size += (flen + 0x3F) >> 6;
				else fat_size += (flen + 0x01FF) >> 9;
			}
		}
		var dir_cnt = (cfb.FullPaths.length +3) >> 2;
		var mini_cnt = (mini_size + 7) >> 3;
		var mfat_cnt = (mini_size + 0x7F) >> 7;
		var fat_base = mini_cnt + fat_size + dir_cnt + mfat_cnt;
		var fat_cnt = (fat_base + 0x7F) >> 7;
		var difat_cnt = fat_cnt <= 109 ? 0 : Math.ceil((fat_cnt-109)/0x7F);
		while(((fat_base + fat_cnt + difat_cnt + 0x7F) >> 7) > fat_cnt) difat_cnt = ++fat_cnt <= 109 ? 0 : Math.ceil((fat_cnt-109)/0x7F);
		var L =  [1, difat_cnt, fat_cnt, mfat_cnt, dir_cnt, fat_size, mini_size, 0];
		cfb.FileIndex[0].size = mini_size << 6;
		L[7] = (cfb.FileIndex[0].start=L[0]+L[1]+L[2]+L[3]+L[4]+L[5])+((L[6]+7) >> 3);
		return L;
	})(cfb);
	var o = new_buf(L[7] << 9);
	var i = 0, T = 0;
	{
		for(i = 0; i < 8; ++i) o.write_shift(1, HEADER_SIG[i]);
		for(i = 0; i < 8; ++i) o.write_shift(2, 0);
		o.write_shift(2, 0x003E);
		o.write_shift(2, 0x0003);
		o.write_shift(2, 0xFFFE);
		o.write_shift(2, 0x0009);
		o.write_shift(2, 0x0006);
		for(i = 0; i < 3; ++i) o.write_shift(2, 0);
		o.write_shift(4, 0);
		o.write_shift(4, L[2]);
		o.write_shift(4, L[0] + L[1] + L[2] + L[3] - 1);
		o.write_shift(4, 0);
		o.write_shift(4, 1<<12);
		o.write_shift(4, L[3] ? L[0] + L[1] + L[2] - 1: ENDOFCHAIN);
		o.write_shift(4, L[3]);
		o.write_shift(-4, L[1] ? L[0] - 1: ENDOFCHAIN);
		o.write_shift(4, L[1]);
		for(i = 0; i < 109; ++i) o.write_shift(-4, i < L[2] ? L[1] + i : -1);
	}
	if(L[1]) {
		for(T = 0; T < L[1]; ++T) {
			for(; i < 236 + T * 127; ++i) o.write_shift(-4, i < L[2] ? L[1] + i : -1);
			o.write_shift(-4, T === L[1] - 1 ? ENDOFCHAIN : T + 1);
		}
	}
	var chainit = function(w/*:number*/)/*:void*/ {
		for(T += w; i<T-1; ++i) o.write_shift(-4, i+1);
		if(w) { ++i; o.write_shift(-4, ENDOFCHAIN); }
	};
	T = i = 0;
	for(T+=L[1]; i<T; ++i) o.write_shift(-4, consts.DIFSECT);
	for(T+=L[2]; i<T; ++i) o.write_shift(-4, consts.FATSECT);
	chainit(L[3]);
	chainit(L[4]);
	var j/*:number*/ = 0, flen/*:number*/ = 0;
	var file/*:CFBEntry*/ = cfb.FileIndex[0];
	for(; j < cfb.FileIndex.length; ++j) {
		file = cfb.FileIndex[j];
		if(!file.content) continue;
		/*:: if(file.content == null) throw new Error("unreachable"); */
		flen = file.content.length;
		if(flen < 0x1000) continue;
		file.start = T;
		chainit((flen + 0x01FF) >> 9);
	}
	chainit((L[6] + 7) >> 3);
	while(o.l & 0x1FF) o.write_shift(-4, consts.ENDOFCHAIN);
	T = i = 0;
	for(j = 0; j < cfb.FileIndex.length; ++j) {
		file = cfb.FileIndex[j];
		if(!file.content) continue;
		/*:: if(file.content == null) throw new Error("unreachable"); */
		flen = file.content.length;
		if(!flen || flen >= 0x1000) continue;
		file.start = T;
		chainit((flen + 0x3F) >> 6);
	}
	while(o.l & 0x1FF) o.write_shift(-4, consts.ENDOFCHAIN);
	for(i = 0; i < L[4]<<2; ++i) {
		var nm = cfb.FullPaths[i];
		if(!nm || nm.length === 0) {
			for(j = 0; j < 17; ++j) o.write_shift(4, 0);
			for(j = 0; j < 3; ++j) o.write_shift(4, -1);
			for(j = 0; j < 12; ++j) o.write_shift(4, 0);
			continue;
		}
		file = cfb.FileIndex[i];
		if(i === 0) file.start = file.size ? file.start - 1 : ENDOFCHAIN;
		var _nm/*:string*/ = (i === 0 && _opts.root) || file.name;
		flen = 2*(_nm.length+1);
		o.write_shift(64, _nm, "utf16le");
		o.write_shift(2, flen);
		o.write_shift(1, file.type);
		o.write_shift(1, file.color);
		o.write_shift(-4, file.L);
		o.write_shift(-4, file.R);
		o.write_shift(-4, file.C);
		if(!file.clsid) for(j = 0; j < 4; ++j) o.write_shift(4, 0);
		else o.write_shift(16, file.clsid, "hex");
		o.write_shift(4, file.state || 0);
		o.write_shift(4, 0); o.write_shift(4, 0);
		o.write_shift(4, 0); o.write_shift(4, 0);
		o.write_shift(4, file.start);
		o.write_shift(4, file.size); o.write_shift(4, 0);
	}
	for(i = 1; i < cfb.FileIndex.length; ++i) {
		file = cfb.FileIndex[i];
		/*:: if(!file.content) throw new Error("unreachable"); */
		if(file.size >= 0x1000) {
			o.l = (file.start+1) << 9;
			if (has_buf && Buffer.isBuffer(file.content)) {
				file.content.copy(o, o.l, 0, file.size);
				// o is a 0-filled Buffer so just set next offset
				o.l += (file.size + 511) & -512;
			} else {
				for(j = 0; j < file.size; ++j) o.write_shift(1, file.content[j]);
				for(; j & 0x1FF; ++j) o.write_shift(1, 0);
			}
		}
	}
	for(i = 1; i < cfb.FileIndex.length; ++i) {
		file = cfb.FileIndex[i];
		/*:: if(!file.content) throw new Error("unreachable"); */
		if(file.size > 0 && file.size < 0x1000) {
			if (has_buf && Buffer.isBuffer(file.content)) {
				file.content.copy(o, o.l, 0, file.size);
				// o is a 0-filled Buffer so just set next offset
				o.l += (file.size + 63) & -64;
			} else {
				for(j = 0; j < file.size; ++j) o.write_shift(1, file.content[j]);
				for(; j & 0x3F; ++j) o.write_shift(1, 0);
			}
		}
	}
	if (has_buf) {
		o.l = o.length;
	} else {
		// When using Buffer, already 0-filled
		while(o.l < o.length) o.write_shift(1, 0);
	}
	return o;
}
/* [MS-CFB] 2.6.4 (Unicode 3.0.1 case conversion) */
function find(cfb/*:CFBContainer*/, path/*:string*/)/*:?CFBEntry*/ {
	var UCFullPaths/*:Array<string>*/ = cfb.FullPaths.map(function(x) { return x.toUpperCase(); });
	var UCPaths/*:Array<string>*/ = UCFullPaths.map(function(x) { var y = x.split("/"); return y[y.length - (x.slice(-1) == "/" ? 2 : 1)]; });
	var k/*:boolean*/ = false;
	if(path.charCodeAt(0) === 47 /* "/" */) { k = true; path = UCFullPaths[0].slice(0, -1) + path; }
	else k = path.indexOf("/") !== -1;
	var UCPath/*:string*/ = path.toUpperCase();
	var w/*:number*/ = k === true ? UCFullPaths.indexOf(UCPath) : UCPaths.indexOf(UCPath);
	if(w !== -1) return cfb.FileIndex[w];

	var m = !UCPath.match(chr1);
	UCPath = UCPath.replace(chr0,'');
	if(m) UCPath = UCPath.replace(chr1,'!');
	for(w = 0; w < UCFullPaths.length; ++w) {
		if((m ? UCFullPaths[w].replace(chr1,'!') : UCFullPaths[w]).replace(chr0,'') == UCPath) return cfb.FileIndex[w];
		if((m ? UCPaths[w].replace(chr1,'!') : UCPaths[w]).replace(chr0,'') == UCPath) return cfb.FileIndex[w];
	}
	return null;
}
/** CFB Constants */
var MSSZ = 64; /* Mini Sector Size = 1<<6 */
//var MSCSZ = 4096; /* Mini Stream Cutoff Size */
/* 2.1 Compound File Sector Numbers and Types */
var ENDOFCHAIN = -2;
/* 2.2 Compound File Header */
var HEADER_SIGNATURE = 'd0cf11e0a1b11ae1';
var HEADER_SIG = [0xD0, 0xCF, 0x11, 0xE0, 0xA1, 0xB1, 0x1A, 0xE1];
var HEADER_CLSID = '00000000000000000000000000000000';
var consts = {
	/* 2.1 Compund File Sector Numbers and Types */
	MAXREGSECT: -6,
	DIFSECT: -4,
	FATSECT: -3,
	ENDOFCHAIN: ENDOFCHAIN,
	FREESECT: -1,
	/* 2.2 Compound File Header */
	HEADER_SIGNATURE: HEADER_SIGNATURE,
	HEADER_MINOR_VERSION: '3e00',
	MAXREGSID: -6,
	NOSTREAM: -1,
	HEADER_CLSID: HEADER_CLSID,
	/* 2.6.1 Compound File Directory Entry */
	EntryTypes: ['unknown','storage','stream','lockbytes','property','root']
};

function write_file(cfb/*:CFBContainer*/, filename/*:string*/, options/*:CFBWriteOpts*/)/*:void*/ {
	get_fs();
	var o = _write(cfb, options);
	/*:: if(typeof Buffer == 'undefined' || !Buffer.isBuffer(o) || !(o instanceof Buffer)) throw new Error("unreachable"); */
	fs.writeFileSync(filename, o);
}

function a2s(o/*:RawBytes*/)/*:string*/ {
	var out = new Array(o.length);
	for(var i = 0; i < o.length; ++i) out[i] = String.fromCharCode(o[i]);
	return out.join("");
}

function write(cfb/*:CFBContainer*/, options/*:CFBWriteOpts*/)/*:RawBytes|string*/ {
	var o = _write(cfb, options);
	switch(options && options.type || "buffer") {
		case "file": get_fs(); fs.writeFileSync(options.filename, (o/*:any*/)); return o;
		case "binary": return typeof o == "string" ? o : a2s(o);
		case "base64": return Base64_encode(typeof o == "string" ? o : a2s(o));
		case "buffer": if(has_buf) return Buffer.isBuffer(o) ? o : Buffer_from(o);
			/* falls through */
		case "array": return typeof o == "string" ? s2a(o) : o;
	}
	return o;
}
/* node < 8.1 zlib does not expose bytesRead, so default to pure JS */
var _zlib;
function use_zlib(zlib) { try {
	var InflateRaw = zlib.InflateRaw;
	var InflRaw = new InflateRaw();
	InflRaw._processChunk(new Uint8Array([3, 0]), InflRaw._finishFlushFlag);
	if(InflRaw.bytesRead) _zlib = zlib;
	else throw new Error("zlib does not expose bytesRead");
} catch(e) {console.error("cannot use native zlib: " + (e.message || e)); } }

function _inflateRawSync(payload, usz) {
	if(!_zlib) return _inflate(payload, usz);
	var InflateRaw = _zlib.InflateRaw;
	var InflRaw = new InflateRaw();
	var out = InflRaw._processChunk(payload.slice(payload.l), InflRaw._finishFlushFlag);
	payload.l += InflRaw.bytesRead;
	return out;
}

function _deflateRawSync(payload) {
	return _zlib ? _zlib.deflateRawSync(payload) : _deflate(payload);
}
var CLEN_ORDER = [ 16, 17, 18, 0, 8, 7, 9, 6, 10, 5, 11, 4, 12, 3, 13, 2, 14, 1, 15 ];

/*  LEN_ID = [ 257, 258, 259, 260, 261, 262, 263, 264, 265, 266, 267, 268, 269, 270, 271, 272, 273, 274, 275, 276, 277, 278, 279, 280, 281, 282, 283, 284, 285 ]; */
var LEN_LN = [   3,   4,   5,   6,   7,   8,   9,  10,  11,  13 , 15,  17,  19,  23,  27,  31,  35,  43,  51,  59,  67,  83,  99, 115, 131, 163, 195, 227, 258 ];

/*  DST_ID = [  0,  1,  2,  3,  4,  5,  6,  7,  8,  9, 10, 11, 12, 13,  14,  15,  16,  17,  18,  19,   20,   21,   22,   23,   24,   25,   26,    27,    28,    29 ]; */
var DST_LN = [  1,  2,  3,  4,  5,  7,  9, 13, 17, 25, 33, 49, 65, 97, 129, 193, 257, 385, 513, 769, 1025, 1537, 2049, 3073, 4097, 6145, 8193, 12289, 16385, 24577 ];

function bit_swap_8(n) { var t = (((((n<<1)|(n<<11)) & 0x22110) | (((n<<5)|(n<<15)) & 0x88440))); return ((t>>16) | (t>>8) |t)&0xFF; }

var use_typed_arrays = typeof Uint8Array !== 'undefined';

var bitswap8 = use_typed_arrays ? new Uint8Array(1<<8) : [];
for(var q = 0; q < (1<<8); ++q) bitswap8[q] = bit_swap_8(q);

function bit_swap_n(n, b) {
	var rev = bitswap8[n & 0xFF];
	if(b <= 8) return rev >>> (8-b);
	rev = (rev << 8) | bitswap8[(n>>8)&0xFF];
	if(b <= 16) return rev >>> (16-b);
	rev = (rev << 8) | bitswap8[(n>>16)&0xFF];
	return rev >>> (24-b);
}

/* helpers for unaligned bit reads */
function read_bits_2(buf, bl) { var w = (bl&7), h = (bl>>>3); return ((buf[h]|(w <= 6 ? 0 : buf[h+1]<<8))>>>w)& 0x03; }
function read_bits_3(buf, bl) { var w = (bl&7), h = (bl>>>3); return ((buf[h]|(w <= 5 ? 0 : buf[h+1]<<8))>>>w)& 0x07; }
function read_bits_4(buf, bl) { var w = (bl&7), h = (bl>>>3); return ((buf[h]|(w <= 4 ? 0 : buf[h+1]<<8))>>>w)& 0x0F; }
function read_bits_5(buf, bl) { var w = (bl&7), h = (bl>>>3); return ((buf[h]|(w <= 3 ? 0 : buf[h+1]<<8))>>>w)& 0x1F; }
function read_bits_7(buf, bl) { var w = (bl&7), h = (bl>>>3); return ((buf[h]|(w <= 1 ? 0 : buf[h+1]<<8))>>>w)& 0x7F; }

/* works up to n = 3 * 8 + 1 = 25 */
function read_bits_n(buf, bl, n) {
	var w = (bl&7), h = (bl>>>3), f = ((1<<n)-1);
	var v = buf[h] >>> w;
	if(n < 8 - w) return v & f;
	v |= buf[h+1]<<(8-w);
	if(n < 16 - w) return v & f;
	v |= buf[h+2]<<(16-w);
	if(n < 24 - w) return v & f;
	v |= buf[h+3]<<(24-w);
	return v & f;
}

/* helpers for unaligned bit writes */
function write_bits_3(buf, bl, v) { var w = bl & 7, h = bl >>> 3;
	if(w <= 5) buf[h] |= (v & 7) << w;
	else {
		buf[h] |= (v << w) & 0xFF;
		buf[h+1] = (v&7) >> (8-w);
	}
	return bl + 3;
}

function write_bits_1(buf, bl, v) {
	var w = bl & 7, h = bl >>> 3;
	v = (v&1) << w;
	buf[h] |= v;
	return bl + 1;
}
function write_bits_8(buf, bl, v) {
	var w = bl & 7, h = bl >>> 3;
	v <<= w;
	buf[h] |=  v & 0xFF; v >>>= 8;
	buf[h+1] = v;
	return bl + 8;
}
function write_bits_16(buf, bl, v) {
	var w = bl & 7, h = bl >>> 3;
	v <<= w;
	buf[h] |=  v & 0xFF; v >>>= 8;
	buf[h+1] = v & 0xFF;
	buf[h+2] = v >>> 8;
	return bl + 16;
}

/* until ArrayBuffer#realloc is a thing, fake a realloc */
function realloc(b, sz/*:number*/) {
	var L = b.length, M = 2*L > sz ? 2*L : sz + 5, i = 0;
	if(L >= sz) return b;
	if(has_buf) {
		var o = new_unsafe_buf(M);
		// $FlowIgnore
		if(b.copy) b.copy(o);
		else for(; i < b.length; ++i) o[i] = b[i];
		return o;
	} else if(use_typed_arrays) {
		var a = new Uint8Array(M);
		if(a.set) a.set(b);
		else for(; i < L; ++i) a[i] = b[i];
		return a;
	}
	b.length = M;
	return b;
}

/* zero-filled arrays for older browsers */
function zero_fill_array(n) {
	var o = new Array(n);
	for(var i = 0; i < n; ++i) o[i] = 0;
	return o;
}

/* build tree (used for literals and lengths) */
function build_tree(clens, cmap, MAX/*:number*/)/*:number*/ {
	var maxlen = 1, w = 0, i = 0, j = 0, ccode = 0, L = clens.length;

	var bl_count  = use_typed_arrays ? new Uint16Array(32) : zero_fill_array(32);
	for(i = 0; i < 32; ++i) bl_count[i] = 0;

	for(i = L; i < MAX; ++i) clens[i] = 0;
	L = clens.length;

	var ctree = use_typed_arrays ? new Uint16Array(L) : zero_fill_array(L); // []

	/* build code tree */
	for(i = 0; i < L; ++i) {
		bl_count[(w = clens[i])]++;
		if(maxlen < w) maxlen = w;
		ctree[i] = 0;
	}
	bl_count[0] = 0;
	for(i = 1; i <= maxlen; ++i) bl_count[i+16] = (ccode = (ccode + bl_count[i-1])<<1);
	for(i = 0; i < L; ++i) {
		ccode = clens[i];
		if(ccode != 0) ctree[i] = bl_count[ccode+16]++;
	}

	/* cmap[maxlen + 4 bits] = (off&15) + (lit<<4) reverse mapping */
	var cleni = 0;
	for(i = 0; i < L; ++i) {
		cleni = clens[i];
		if(cleni != 0) {
			ccode = bit_swap_n(ctree[i], maxlen)>>(maxlen-cleni);
			for(j = (1<<(maxlen + 4 - cleni)) - 1; j>=0; --j)
				cmap[ccode|(j<<cleni)] = (cleni&15) | (i<<4);
		}
	}
	return maxlen;
}

/* Fixed Huffman */
var fix_lmap = use_typed_arrays ? new Uint16Array(512) : zero_fill_array(512);
var fix_dmap = use_typed_arrays ? new Uint16Array(32)  : zero_fill_array(32);
if(!use_typed_arrays) {
	for(var i = 0; i < 512; ++i) fix_lmap[i] = 0;
	for(i = 0; i < 32; ++i) fix_dmap[i] = 0;
}
(function() {
	var dlens/*:Array<number>*/ = [];
	var i = 0;
	for(;i<32; i++) dlens.push(5);
	build_tree(dlens, fix_dmap, 32);

	var clens/*:Array<number>*/ = [];
	i = 0;
	for(; i<=143; i++) clens.push(8);
	for(; i<=255; i++) clens.push(9);
	for(; i<=279; i++) clens.push(7);
	for(; i<=287; i++) clens.push(8);
	build_tree(clens, fix_lmap, 288);
})();var _deflateRaw = /*#__PURE__*/(function _deflateRawIIFE() {
	var DST_LN_RE = use_typed_arrays ? new Uint8Array(0x8000) : [];
	var j = 0, k = 0;
	for(; j < DST_LN.length - 1; ++j) {
		for(; k < DST_LN[j+1]; ++k) DST_LN_RE[k] = j;
	}
	for(;k < 32768; ++k) DST_LN_RE[k] = 29;

	var LEN_LN_RE = use_typed_arrays ? new Uint8Array(0x103) : [];
	for(j = 0, k = 0; j < LEN_LN.length - 1; ++j) {
		for(; k < LEN_LN[j+1]; ++k) LEN_LN_RE[k] = j;
	}

	function write_stored(data, out) {
		var boff = 0;
		while(boff < data.length) {
			var L = Math.min(0xFFFF, data.length - boff);
			var h = boff + L == data.length;
			out.write_shift(1, +h);
			out.write_shift(2, L);
			out.write_shift(2, (~L) & 0xFFFF);
			while(L-- > 0) out[out.l++] = data[boff++];
		}
		return out.l;
	}

	/* Fixed Huffman */
	function write_huff_fixed(data, out) {
		var bl = 0;
		var boff = 0;
		var addrs = use_typed_arrays ? new Uint16Array(0x8000) : [];
		while(boff < data.length) {
			var L = /* data.length - boff; */ Math.min(0xFFFF, data.length - boff);

			/* write a stored block for short data */
			if(L < 10) {
				bl = write_bits_3(out, bl, +!!(boff + L == data.length)); // jshint ignore:line
				if(bl & 7) bl += 8 - (bl & 7);
				out.l = (bl / 8) | 0;
				out.write_shift(2, L);
				out.write_shift(2, (~L) & 0xFFFF);
				while(L-- > 0) out[out.l++] = data[boff++];
				bl = out.l * 8;
				continue;
			}

			bl = write_bits_3(out, bl, +!!(boff + L == data.length) + 2); // jshint ignore:line
			var hash = 0;
			while(L-- > 0) {
				var d = data[boff];
				hash = ((hash << 5) ^ d) & 0x7FFF;

				var match = -1, mlen = 0;

				if((match = addrs[hash])) {
					match |= boff & ~0x7FFF;
					if(match > boff) match -= 0x8000;
					if(match < boff) while(data[match + mlen] == data[boff + mlen] && mlen < 250) ++mlen;
				}

				if(mlen > 2) {
					/* Copy Token  */
					d = LEN_LN_RE[mlen];
					if(d <= 22) bl = write_bits_8(out, bl, bitswap8[d+1]>>1) - 1;
					else {
						write_bits_8(out, bl, 3);
						bl += 5;
						write_bits_8(out, bl, bitswap8[d-23]>>5);
						bl += 3;
					}
					var len_eb = (d < 8) ? 0 : ((d - 4)>>2);
					if(len_eb > 0) {
						write_bits_16(out, bl, mlen - LEN_LN[d]);
						bl += len_eb;
					}

					d = DST_LN_RE[boff - match];
					bl = write_bits_8(out, bl, bitswap8[d]>>3);
					bl -= 3;

					var dst_eb = d < 4 ? 0 : (d-2)>>1;
					if(dst_eb > 0) {
						write_bits_16(out, bl, boff - match - DST_LN[d]);
						bl += dst_eb;
					}
					for(var q = 0; q < mlen; ++q) {
						addrs[hash] = boff & 0x7FFF;
						hash = ((hash << 5) ^ data[boff]) & 0x7FFF;
						++boff;
					}
					L-= mlen - 1;
				} else {
					/* Literal Token */
					if(d <= 143) d = d + 48;
					else bl = write_bits_1(out, bl, 1);
					bl = write_bits_8(out, bl, bitswap8[d]);
					addrs[hash] = boff & 0x7FFF;
					++boff;
				}
			}

			bl = write_bits_8(out, bl, 0) - 1;
		}
		out.l = ((bl + 7)/8)|0;
		return out.l;
	}
	return function _deflateRaw(data, out) {
		if(data.length < 8) return write_stored(data, out);
		return write_huff_fixed(data, out);
	};
})();

function _deflate(data) {
	var buf = new_buf(50+Math.floor(data.length*1.1));
	var off = _deflateRaw(data, buf);
	return buf.slice(0, off);
}
/* modified inflate function also moves original read head */

var dyn_lmap = use_typed_arrays ? new Uint16Array(32768) : zero_fill_array(32768);
var dyn_dmap = use_typed_arrays ? new Uint16Array(32768) : zero_fill_array(32768);
var dyn_cmap = use_typed_arrays ? new Uint16Array(128)   : zero_fill_array(128);
var dyn_len_1 = 1, dyn_len_2 = 1;

/* 5.5.3 Expanding Huffman Codes */
function dyn(data, boff/*:number*/) {
	/* nomenclature from RFC1951 refers to bit values; these are offset by the implicit constant */
	var _HLIT = read_bits_5(data, boff) + 257; boff += 5;
	var _HDIST = read_bits_5(data, boff) + 1; boff += 5;
	var _HCLEN = read_bits_4(data, boff) + 4; boff += 4;
	var w = 0;

	/* grab and store code lengths */
	var clens = use_typed_arrays ? new Uint8Array(19) : zero_fill_array(19);
	var ctree = [ 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0 ];
	var maxlen = 1;
	var bl_count =  use_typed_arrays ? new Uint8Array(8) : zero_fill_array(8);
	var next_code = use_typed_arrays ? new Uint8Array(8) : zero_fill_array(8);
	var L = clens.length; /* 19 */
	for(var i = 0; i < _HCLEN; ++i) {
		clens[CLEN_ORDER[i]] = w = read_bits_3(data, boff);
		if(maxlen < w) maxlen = w;
		bl_count[w]++;
		boff += 3;
	}

	/* build code tree */
	var ccode = 0;
	bl_count[0] = 0;
	for(i = 1; i <= maxlen; ++i) next_code[i] = ccode = (ccode + bl_count[i-1])<<1;
	for(i = 0; i < L; ++i) if((ccode = clens[i]) != 0) ctree[i] = next_code[ccode]++;
	/* cmap[7 bits from stream] = (off&7) + (lit<<3) */
	var cleni = 0;
	for(i = 0; i < L; ++i) {
		cleni = clens[i];
		if(cleni != 0) {
			ccode = bitswap8[ctree[i]]>>(8-cleni);
			for(var j = (1<<(7-cleni))-1; j>=0; --j) dyn_cmap[ccode|(j<<cleni)] = (cleni&7) | (i<<3);
		}
	}

	/* read literal and dist codes at once */
	var hcodes/*:Array<number>*/ = [];
	maxlen = 1;
	for(; hcodes.length < _HLIT + _HDIST;) {
		ccode = dyn_cmap[read_bits_7(data, boff)];
		boff += ccode & 7;
		switch((ccode >>>= 3)) {
			case 16:
				w = 3 + read_bits_2(data, boff); boff += 2;
				ccode = hcodes[hcodes.length - 1];
				while(w-- > 0) hcodes.push(ccode);
				break;
			case 17:
				w = 3 + read_bits_3(data, boff); boff += 3;
				while(w-- > 0) hcodes.push(0);
				break;
			case 18:
				w = 11 + read_bits_7(data, boff); boff += 7;
				while(w -- > 0) hcodes.push(0);
				break;
			default:
				hcodes.push(ccode);
				if(maxlen < ccode) maxlen = ccode;
				break;
		}
	}

	/* build literal / length trees */
	var h1 = hcodes.slice(0, _HLIT), h2 = hcodes.slice(_HLIT);
	for(i = _HLIT; i < 286; ++i) h1[i] = 0;
	for(i = _HDIST; i < 30; ++i) h2[i] = 0;
	dyn_len_1 = build_tree(h1, dyn_lmap, 286);
	dyn_len_2 = build_tree(h2, dyn_dmap, 30);
	return boff;
}

/* return [ data, bytesRead ] */
function inflate(data, usz/*:number*/) {
	/* shortcircuit for empty buffer [0x03, 0x00] */
	if(data[0] == 3 && !(data[1] & 0x3)) { return [new_raw_buf(usz), 2]; }

	/* bit offset */
	var boff = 0;

	/* header includes final bit and type bits */
	var header = 0;

	var outbuf = new_unsafe_buf(usz ? usz : (1<<18));
	var woff = 0;
	var OL = outbuf.length>>>0;
	var max_len_1 = 0, max_len_2 = 0;

	while((header&1) == 0) {
		header = read_bits_3(data, boff); boff += 3;
		if((header >>> 1) == 0) {
			/* Stored block */
			if(boff & 7) boff += 8 - (boff&7);
			/* 2 bytes sz, 2 bytes bit inverse */
			var sz = data[boff>>>3] | data[(boff>>>3)+1]<<8;
			boff += 32;
			/* push sz bytes */
			if(sz > 0) {
				if(!usz && OL < woff + sz) { outbuf = realloc(outbuf, woff + sz); OL = outbuf.length; }
				while(sz-- > 0) { outbuf[woff++] = data[boff>>>3]; boff += 8; }
			}
			continue;
		} else if((header >> 1) == 1) {
			/* Fixed Huffman */
			max_len_1 = 9; max_len_2 = 5;
		} else {
			/* Dynamic Huffman */
			boff = dyn(data, boff);
			max_len_1 = dyn_len_1; max_len_2 = dyn_len_2;
		}
		for(;;) { // while(true) is apparently out of vogue in modern JS circles
			if(!usz && (OL < woff + 32767)) { outbuf = realloc(outbuf, woff + 32767); OL = outbuf.length; }
			/* ingest code and move read head */
			var bits = read_bits_n(data, boff, max_len_1);
			var code = (header>>>1) == 1 ? fix_lmap[bits] : dyn_lmap[bits];
			boff += code & 15; code >>>= 4;
			/* 0-255 are literals, 256 is end of block token, 257+ are copy tokens */
			if(((code>>>8)&0xFF) === 0) outbuf[woff++] = code;
			else if(code == 256) break;
			else {
				code -= 257;
				var len_eb = (code < 8) ? 0 : ((code-4)>>2); if(len_eb > 5) len_eb = 0;
				var tgt = woff + LEN_LN[code];
				/* length extra bits */
				if(len_eb > 0) {
					tgt += read_bits_n(data, boff, len_eb);
					boff += len_eb;
				}

				/* dist code */
				bits = read_bits_n(data, boff, max_len_2);
				code = (header>>>1) == 1 ? fix_dmap[bits] : dyn_dmap[bits];
				boff += code & 15; code >>>= 4;
				var dst_eb = (code < 4 ? 0 : (code-2)>>1);
				var dst = DST_LN[code];
				/* dist extra bits */
				if(dst_eb > 0) {
					dst += read_bits_n(data, boff, dst_eb);
					boff += dst_eb;
				}

				/* in the common case, manual byte copy is faster than TA set / Buffer copy */
				if(!usz && OL < tgt) { outbuf = realloc(outbuf, tgt + 100); OL = outbuf.length; }
				while(woff < tgt) { outbuf[woff] = outbuf[woff - dst]; ++woff; }
			}
		}
	}
	if(usz) return [outbuf, (boff+7)>>>3];
	return [outbuf.slice(0, woff), (boff+7)>>>3];
}

function _inflate(payload, usz) {
	var data = payload.slice(payload.l||0);
	var out = inflate(data, usz);
	payload.l += out[1];
	return out[0];
}

function warn_or_throw(wrn, msg) {
	if(wrn) { if(typeof console !== 'undefined') console.error(msg); }
	else throw new Error(msg);
}

function parse_zip(file/*:RawBytes*/, options/*:CFBReadOpts*/)/*:CFBContainer*/ {
	var blob/*:CFBlob*/ = /*::(*/file/*:: :any)*/;
	prep_blob(blob, 0);

	var FileIndex/*:CFBFileIndex*/ = [], FullPaths/*:Array<string>*/ = [];
	var o = {
		FileIndex: FileIndex,
		FullPaths: FullPaths
	};
	init_cfb(o, { root: options.root });

	/* find end of central directory, start just after signature */
	var i = blob.length - 4;
	while((blob[i] != 0x50 || blob[i+1] != 0x4b || blob[i+2] != 0x05 || blob[i+3] != 0x06) && i >= 0) --i;
	blob.l = i + 4;

	/* parse end of central directory */
	blob.l += 4;
	var fcnt = blob.read_shift(2);
	blob.l += 6;
	var start_cd = blob.read_shift(4);

	/* parse central directory */
	blob.l = start_cd;

	for(i = 0; i < fcnt; ++i) {
		/* trust local file header instead of CD entry */
		blob.l += 20;
		var csz = blob.read_shift(4);
		var usz = blob.read_shift(4);
		var namelen = blob.read_shift(2);
		var efsz = blob.read_shift(2);
		var fcsz = blob.read_shift(2);
		blob.l += 8;
		var offset = blob.read_shift(4);
		var EF = parse_extra_field(/*::(*/blob.slice(blob.l+namelen, blob.l+namelen+efsz)/*:: :any)*/);
		blob.l += namelen + efsz + fcsz;

		var L = blob.l;
		blob.l = offset + 4;
		parse_local_file(blob, csz, usz, o, EF);
		blob.l = L;
	}
	return o;
}


/* head starts just after local file header signature */
function parse_local_file(blob/*:CFBlob*/, csz/*:number*/, usz/*:number*/, o/*:CFBContainer*/, EF) {
	/* [local file header] */
	blob.l += 2;
	var flags = blob.read_shift(2);
	var meth = blob.read_shift(2);
	var date = parse_dos_date(blob);

	if(flags & 0x2041) throw new Error("Unsupported ZIP encryption");
	var crc32 = blob.read_shift(4);
	var _csz = blob.read_shift(4);
	var _usz = blob.read_shift(4);

	var namelen = blob.read_shift(2);
	var efsz = blob.read_shift(2);

	// TODO: flags & (1<<11) // UTF8
	var name = ""; for(var i = 0; i < namelen; ++i) name += String.fromCharCode(blob[blob.l++]);
	if(efsz) {
		var ef = parse_extra_field(/*::(*/blob.slice(blob.l, blob.l + efsz)/*:: :any)*/);
		if((ef[0x5455]||{}).mt) date = ef[0x5455].mt;
		if(((EF||{})[0x5455]||{}).mt) date = EF[0x5455].mt;
	}
	blob.l += efsz;

	/* [encryption header] */

	/* [file data] */
	var data = blob.slice(blob.l, blob.l + _csz);
	switch(meth) {
		case 8: data = _inflateRawSync(blob, _usz); break;
		case 0: break; // TODO: scan for magic number
		default: throw new Error("Unsupported ZIP Compression method " + meth);
	}

	/* [data descriptor] */
	var wrn = false;
	if(flags & 8) {
		crc32 = blob.read_shift(4);
		if(crc32 == 0x08074b50) { crc32 = blob.read_shift(4); wrn = true; }
		_csz = blob.read_shift(4);
		_usz = blob.read_shift(4);
	}

	if(_csz != csz) warn_or_throw(wrn, "Bad compressed size: " + csz + " != " + _csz);
	if(_usz != usz) warn_or_throw(wrn, "Bad uncompressed size: " + usz + " != " + _usz);
	//var _crc32 = CRC32.buf(data, 0);
	//if((crc32>>0) != (_crc32>>0)) warn_or_throw(wrn, "Bad CRC32 checksum: " + crc32 + " != " + _crc32);
	cfb_add(o, name, data, {unsafe: true, mt: date});
}
function write_zip(cfb/*:CFBContainer*/, options/*:CFBWriteOpts*/)/*:RawBytes*/ {
	var _opts = options || {};
	var out = [], cdirs = [];
	var o/*:CFBlob*/ = new_buf(1);
	var method = (_opts.compression ? 8 : 0), flags = 0;
	var desc = false;
	if(desc) flags |= 8;
	var i = 0, j = 0;

	var start_cd = 0, fcnt = 0;
	var root = cfb.FullPaths[0], fp = root, fi = cfb.FileIndex[0];
	var crcs = [];
	var sz_cd = 0;

	for(i = 1; i < cfb.FullPaths.length; ++i) {
		fp = cfb.FullPaths[i].slice(root.length); fi = cfb.FileIndex[i];
		if(!fi.size || !fi.content || fp == "\u0001Sh33tJ5") continue;
		var start = start_cd;

		/* TODO: CP437 filename */
		var namebuf = new_buf(fp.length);
		for(j = 0; j < fp.length; ++j) namebuf.write_shift(1, fp.charCodeAt(j) & 0x7F);
		namebuf = namebuf.slice(0, namebuf.l);
		crcs[fcnt] = CRC32.buf(/*::((*/fi.content/*::||[]):any)*/, 0);

		var outbuf = fi.content/*::||[]*/;
		if(method == 8) outbuf = _deflateRawSync(outbuf);

		/* local file header */
		o = new_buf(30);
		o.write_shift(4, 0x04034b50);
		o.write_shift(2, 20);
		o.write_shift(2, flags);
		o.write_shift(2, method);
		/* TODO: last mod file time/date */
		if(fi.mt) write_dos_date(o, fi.mt);
		else o.write_shift(4, 0);
		o.write_shift(-4, (flags & 8) ? 0 : crcs[fcnt]);
		o.write_shift(4,  (flags & 8) ? 0 : outbuf.length);
		o.write_shift(4,  (flags & 8) ? 0 : /*::(*/fi.content/*::||[])*/.length);
		o.write_shift(2, namebuf.length);
		o.write_shift(2, 0);

		start_cd += o.length;
		out.push(o);
		start_cd += namebuf.length;
		out.push(namebuf);

		/* TODO: extra fields? */

		/* TODO: encryption header ? */

		start_cd += outbuf.length;
		out.push(outbuf);

		/* data descriptor */
		if(flags & 8) {
			o = new_buf(12);
			o.write_shift(-4, crcs[fcnt]);
			o.write_shift(4, outbuf.length);
			o.write_shift(4, /*::(*/fi.content/*::||[])*/.length);
			start_cd += o.l;
			out.push(o);
		}

		/* central directory */
		o = new_buf(46);
		o.write_shift(4, 0x02014b50);
		o.write_shift(2, 0);
		o.write_shift(2, 20);
		o.write_shift(2, flags);
		o.write_shift(2, method);
		o.write_shift(4, 0); /* TODO: last mod file time/date */
		o.write_shift(-4, crcs[fcnt]);

		o.write_shift(4, outbuf.length);
		o.write_shift(4, /*::(*/fi.content/*::||[])*/.length);
		o.write_shift(2, namebuf.length);
		o.write_shift(2, 0);
		o.write_shift(2, 0);
		o.write_shift(2, 0);
		o.write_shift(2, 0);
		o.write_shift(4, 0);
		o.write_shift(4, start);

		sz_cd += o.l;
		cdirs.push(o);
		sz_cd += namebuf.length;
		cdirs.push(namebuf);
		++fcnt;
	}

	/* end of central directory */
	o = new_buf(22);
	o.write_shift(4, 0x06054b50);
	o.write_shift(2, 0);
	o.write_shift(2, 0);
	o.write_shift(2, fcnt);
	o.write_shift(2, fcnt);
	o.write_shift(4, sz_cd);
	o.write_shift(4, start_cd);
	o.write_shift(2, 0);

	return bconcat(([bconcat((out/*:any*/)), bconcat(cdirs), o]/*:any*/));
}
var ContentTypeMap = ({
	"htm": "text/html",
	"xml": "text/xml",

	"gif": "image/gif",
	"jpg": "image/jpeg",
	"png": "image/png",

	"mso": "application/x-mso",
	"thmx": "application/vnd.ms-officetheme",
	"sh33tj5": "application/octet-stream"
}/*:any*/);

function get_content_type(fi/*:CFBEntry*/, fp/*:string*/)/*:string*/ {
	if(fi.ctype) return fi.ctype;

	var ext = fi.name || "", m = ext.match(/\.([^\.]+)$/);
	if(m && ContentTypeMap[m[1]]) return ContentTypeMap[m[1]];

	if(fp) {
		m = (ext = fp).match(/[\.\\]([^\.\\])+$/);
		if(m && ContentTypeMap[m[1]]) return ContentTypeMap[m[1]];
	}

	return "application/octet-stream";
}

/* 76 character chunks TODO: intertwine encoding */
function write_base64_76(bstr/*:string*/)/*:string*/ {
	var data = Base64_encode(bstr);
	var o = [];
	for(var i = 0; i < data.length; i+= 76) o.push(data.slice(i, i+76));
	return o.join("\r\n") + "\r\n";
}

/*
Rules for QP:
	- escape =## applies for all non-display characters and literal "="
	- space or tab at end of line must be encoded
	- \r\n newlines can be preserved, but bare \r and \n must be escaped
	- lines must not exceed 76 characters, use soft breaks =\r\n

TODO: Some files from word appear to write line extensions with bare equals:

```
<table class=3DMsoTableGrid border=3D1 cellspacing=3D0 cellpadding=3D0 width=
="70%"
```
*/
function write_quoted_printable(text/*:string*/)/*:string*/ {
	var encoded = text.replace(/[\x00-\x08\x0B\x0C\x0E-\x1F\x7E-\xFF=]/g, function(c) {
		var w = c.charCodeAt(0).toString(16).toUpperCase();
		return "=" + (w.length == 1 ? "0" + w : w);
	});

	encoded = encoded.replace(/ $/mg, "=20").replace(/\t$/mg, "=09");

	if(encoded.charAt(0) == "\n") encoded = "=0D" + encoded.slice(1);
	encoded = encoded.replace(/\r(?!\n)/mg, "=0D").replace(/\n\n/mg, "\n=0A").replace(/([^\r\n])\n/mg, "$1=0A");

	var o/*:Array<string>*/ = [], split = encoded.split("\r\n");
	for(var si = 0; si < split.length; ++si) {
		var str = split[si];
		if(str.length == 0) { o.push(""); continue; }
		for(var i = 0; i < str.length;) {
			var end = 76;
			var tmp = str.slice(i, i + end);
			if(tmp.charAt(end - 1) == "=") end --;
			else if(tmp.charAt(end - 2) == "=") end -= 2;
			else if(tmp.charAt(end - 3) == "=") end -= 3;
			tmp = str.slice(i, i + end);
			i += end;
			if(i < str.length) tmp += "=";
			o.push(tmp);
		}
	}

	return o.join("\r\n");
}
function parse_quoted_printable(data/*:Array<string>*/)/*:RawBytes*/ {
	var o = [];

	/* unify long lines */
	for(var di = 0; di < data.length; ++di) {
		var line = data[di];
		while(di <= data.length && line.charAt(line.length - 1) == "=") line = line.slice(0, line.length - 1) + data[++di];
		o.push(line);
	}

	/* decode */
	for(var oi = 0; oi < o.length; ++oi) o[oi] = o[oi].replace(/[=][0-9A-Fa-f]{2}/g, function($$) { return String.fromCharCode(parseInt($$.slice(1), 16)); });
	return s2a(o.join("\r\n"));
}


function parse_mime(cfb/*:CFBContainer*/, data/*:Array<string>*/, root/*:string*/)/*:void*/ {
	var fname = "", cte = "", ctype = "", fdata;
	var di = 0;
	for(;di < 10; ++di) {
		var line = data[di];
		if(!line || line.match(/^\s*$/)) break;
		var m = line.match(/^(.*?):\s*([^\s].*)$/);
		if(m) switch(m[1].toLowerCase()) {
			case "content-location": fname = m[2].trim(); break;
			case "content-type": ctype = m[2].trim(); break;
			case "content-transfer-encoding": cte = m[2].trim(); break;
		}
	}
	++di;
	switch(cte.toLowerCase()) {
		case 'base64': fdata = s2a(Base64_decode(data.slice(di).join(""))); break;
		case 'quoted-printable': fdata = parse_quoted_printable(data.slice(di)); break;
		default: throw new Error("Unsupported Content-Transfer-Encoding " + cte);
	}
	var file = cfb_add(cfb, fname.slice(root.length), fdata, {unsafe: true});
	if(ctype) file.ctype = ctype;
}

function parse_mad(file/*:RawBytes*/, options/*:CFBReadOpts*/)/*:CFBContainer*/ {
	if(a2s(file.slice(0,13)).toLowerCase() != "mime-version:") throw new Error("Unsupported MAD header");
	var root = (options && options.root || "");
	// $FlowIgnore
	var data = (has_buf && Buffer.isBuffer(file) ? file.toString("binary") : a2s(file)).split("\r\n");
	var di = 0, row = "";

	/* if root is not specified, scan for the common prefix */
	for(di = 0; di < data.length; ++di) {
		row = data[di];
		if(!/^Content-Location:/i.test(row)) continue;
		row = row.slice(row.indexOf("file"));
		if(!root) root = row.slice(0, row.lastIndexOf("/") + 1);
		if(row.slice(0, root.length) == root) continue;
		while(root.length > 0) {
			root = root.slice(0, root.length - 1);
			root = root.slice(0, root.lastIndexOf("/") + 1);
			if(row.slice(0,root.length) == root) break;
		}
	}

	var mboundary = (data[1] || "").match(/boundary="(.*?)"/);
	if(!mboundary) throw new Error("MAD cannot find boundary");
	var boundary = "--" + (mboundary[1] || "");

	var FileIndex/*:CFBFileIndex*/ = [], FullPaths/*:Array<string>*/ = [];
	var o = {
		FileIndex: FileIndex,
		FullPaths: FullPaths
	};
	init_cfb(o);
	var start_di, fcnt = 0;
	for(di = 0; di < data.length; ++di) {
		var line = data[di];
		if(line !== boundary && line !== boundary + "--") continue;
		if(fcnt++) parse_mime(o, data.slice(start_di, di), root);
		start_di = di;
	}
	return o;
}

function write_mad(cfb/*:CFBContainer*/, options/*:CFBWriteOpts*/)/*:string*/ {
	var opts = options || {};
	var boundary = opts.boundary || "SheetJS";
	boundary = '------=' + boundary;

	var out = [
		'MIME-Version: 1.0',
		'Content-Type: multipart/related; boundary="' + boundary.slice(2) + '"',
		'',
		'',
		''
	];

	var root = cfb.FullPaths[0], fp = root, fi = cfb.FileIndex[0];
	for(var i = 1; i < cfb.FullPaths.length; ++i) {
		fp = cfb.FullPaths[i].slice(root.length);
		fi = cfb.FileIndex[i];
		if(!fi.size || !fi.content || fp == "\u0001Sh33tJ5") continue;

		/* Normalize filename */
		fp = fp.replace(/[\x00-\x08\x0B\x0C\x0E-\x1F\x7E-\xFF]/g, function(c) {
			return "_x" + c.charCodeAt(0).toString(16) + "_";
		}).replace(/[\u0080-\uFFFF]/g, function(u) {
			return "_u" + u.charCodeAt(0).toString(16) + "_";
		});

		/* Extract content as binary string */
		var ca = fi.content;
		// $FlowIgnore
		var cstr = has_buf && Buffer.isBuffer(ca) ? ca.toString("binary") : a2s(ca);

		/* 4/5 of first 1024 chars ascii -> quoted printable, else base64 */
		var dispcnt = 0, L = Math.min(1024, cstr.length), cc = 0;
		for(var csl = 0; csl <= L; ++csl) if((cc=cstr.charCodeAt(csl)) >= 0x20 && cc < 0x80) ++dispcnt;
		var qp = dispcnt >= L * 4 / 5;

		out.push(boundary);
		out.push('Content-Location: ' + (opts.root || 'file:///C:/SheetJS/') + fp);
		out.push('Content-Transfer-Encoding: ' + (qp ? 'quoted-printable' : 'base64'));
		out.push('Content-Type: ' + get_content_type(fi, fp));
		out.push('');

		out.push(qp ? write_quoted_printable(cstr) : write_base64_76(cstr));
	}
	out.push(boundary + '--\r\n');
	return out.join("\r\n");
}
function cfb_new(opts/*:?any*/)/*:CFBContainer*/ {
	var o/*:CFBContainer*/ = ({}/*:any*/);
	init_cfb(o, opts);
	return o;
}

function cfb_add(cfb/*:CFBContainer*/, name/*:string*/, content/*:?RawBytes*/, opts/*:?any*/)/*:CFBEntry*/ {
	var unsafe = opts && opts.unsafe;
	if(!unsafe) init_cfb(cfb);
	var file = !unsafe && CFB.find(cfb, name);
	if(!file) {
		var fpath/*:string*/ = cfb.FullPaths[0];
		if(name.slice(0, fpath.length) == fpath) fpath = name;
		else {
			if(fpath.slice(-1) != "/") fpath += "/";
			fpath = (fpath + name).replace("//","/");
		}
		file = ({name: filename(name), type: 2}/*:any*/);
		cfb.FileIndex.push(file);
		cfb.FullPaths.push(fpath);
		if(!unsafe) CFB.utils.cfb_gc(cfb);
	}
	/*:: if(!file) throw new Error("unreachable"); */
	file.content = (content/*:any*/);
	file.size = content ? content.length : 0;
	if(opts) {
		if(opts.CLSID) file.clsid = opts.CLSID;
		if(opts.mt) file.mt = opts.mt;
		if(opts.ct) file.ct = opts.ct;
	}
	return file;
}

function cfb_del(cfb/*:CFBContainer*/, name/*:string*/)/*:boolean*/ {
	init_cfb(cfb);
	var file = CFB.find(cfb, name);
	if(file) for(var j = 0; j < cfb.FileIndex.length; ++j) if(cfb.FileIndex[j] == file) {
		cfb.FileIndex.splice(j, 1);
		cfb.FullPaths.splice(j, 1);
		return true;
	}
	return false;
}

function cfb_mov(cfb/*:CFBContainer*/, old_name/*:string*/, new_name/*:string*/)/*:boolean*/ {
	init_cfb(cfb);
	var file = CFB.find(cfb, old_name);
	if(file) for(var j = 0; j < cfb.FileIndex.length; ++j) if(cfb.FileIndex[j] == file) {
		cfb.FileIndex[j].name = filename(new_name);
		cfb.FullPaths[j] = new_name;
		return true;
	}
	return false;
}

function cfb_gc(cfb/*:CFBContainer*/)/*:void*/ { rebuild_cfb(cfb, true); }

exports.find = find;
exports.read = read;
exports.parse = parse;
exports.write = write;
exports.writeFile = write_file;
exports.utils = {
	cfb_new: cfb_new,
	cfb_add: cfb_add,
	cfb_del: cfb_del,
	cfb_mov: cfb_mov,
	cfb_gc: cfb_gc,
	ReadShift: ReadShift,
	CheckField: CheckField,
	prep_blob: prep_blob,
	bconcat: bconcat,
	use_zlib: use_zlib,
	_deflateRaw: _deflate,
	_inflateRaw: _inflate,
	consts: consts
};

return exports;
})();

let _fs = void 0;
function set_fs(fs) { _fs = fs; }


/* normalize data for blob ctor */
function blobify(data) {
	if(typeof data === "string") return s2ab(data);
	if(Array.isArray(data)) return a2u(data);
	return data;
}
/* write or download file */
function write_dl(fname/*:string*/, payload/*:any*/, enc/*:?string*/) {
	/*global IE_SaveFile, Blob, navigator, saveAs, document, File, chrome */
	if(typeof _fs !== 'undefined' && _fs.writeFileSync) return enc ? _fs.writeFileSync(fname, payload, enc) : _fs.writeFileSync(fname, payload);
	if(typeof Deno !== 'undefined') {
		/* in this spot, it's safe to assume typed arrays and TextEncoder/TextDecoder exist */
		if(enc && typeof payload == "string") switch(enc) {
			case "utf8": payload = new TextEncoder(enc).encode(payload); break;
			case "binary": payload = s2ab(payload); break;
			/* TODO: binary equivalent */
			default: throw new Error("Unsupported encoding " + enc);
		}
		return Deno.writeFileSync(fname, payload);
	}
	var data = (enc == "utf8") ? utf8write(payload) : payload;
	/*:: declare var IE_SaveFile: any; */
	if(typeof IE_SaveFile !== 'undefined') return IE_SaveFile(data, fname);
	if(typeof Blob !== 'undefined') {
		var blob = new Blob([blobify(data)], {type:"application/octet-stream"});
		/*:: declare var navigator: any; */
		if(typeof navigator !== 'undefined' && navigator.msSaveBlob) return navigator.msSaveBlob(blob, fname);
		/*:: declare var saveAs: any; */
		if(typeof saveAs !== 'undefined') return saveAs(blob, fname);
		if(typeof URL !== 'undefined' && typeof document !== 'undefined' && document.createElement && URL.createObjectURL) {
			var url = URL.createObjectURL(blob);
			/*:: declare var chrome: any; */
			if(typeof chrome === 'object' && typeof (chrome.downloads||{}).download == "function") {
				if(URL.revokeObjectURL && typeof setTimeout !== 'undefined') setTimeout(function() { URL.revokeObjectURL(url); }, 60000);
				return chrome.downloads.download({ url: url, filename: fname, saveAs: true});
			}
			var a = document.createElement("a");
			if(a.download != null) {
				/*:: if(document.body == null) throw new Error("unreachable"); */
				a.download = fname; a.href = url; document.body.appendChild(a); a.click();
				/*:: if(document.body == null) throw new Error("unreachable"); */ document.body.removeChild(a);
				if(URL.revokeObjectURL && typeof setTimeout !== 'undefined') setTimeout(function() { URL.revokeObjectURL(url); }, 60000);
				return url;
			}
		}
	}
	// $FlowIgnore
	if(typeof $ !== 'undefined' && typeof File !== 'undefined' && typeof Folder !== 'undefined') try { // extendscript
		// $FlowIgnore
		var out = File(fname); out.open("w"); out.encoding = "binary";
		if(Array.isArray(payload)) payload = a2s(payload);
		out.write(payload); out.close(); return payload;
	} catch(e) { if(!e.message || !e.message.match(/onstruct/)) throw e; }
	throw new Error("cannot save file " + fname);
}

/* read binary data from file */
function read_binary(path/*:string*/) {
	if(typeof _fs !== 'undefined') return _fs.readFileSync(path);
	if(typeof Deno !== 'undefined') return Deno.readFileSync(path);
	// $FlowIgnore
	if(typeof $ !== 'undefined' && typeof File !== 'undefined' && typeof Folder !== 'undefined') try { // extendscript
		// $FlowIgnore
		var infile = File(path); infile.open("r"); infile.encoding = "binary";
		var data = infile.read(); infile.close();
		return data;
	} catch(e) { if(!e.message || !e.message.match(/onstruct/)) throw e; }
	throw new Error("Cannot access file " + path);
}
function keys(o/*:any*/)/*:Array<any>*/ {
	var ks = Object.keys(o), o2 = [];
	for(var i = 0; i < ks.length; ++i) if(Object.prototype.hasOwnProperty.call(o, ks[i])) o2.push(ks[i]);
	return o2;
}

function evert_key(obj/*:any*/, key/*:string*/)/*:EvertType*/ {
	var o = ([]/*:any*/), K = keys(obj);
	for(var i = 0; i !== K.length; ++i) if(o[obj[K[i]][key]] == null) o[obj[K[i]][key]] = K[i];
	return o;
}

function evert(obj/*:any*/)/*:EvertType*/ {
	var o = ([]/*:any*/), K = keys(obj);
	for(var i = 0; i !== K.length; ++i) o[obj[K[i]]] = K[i];
	return o;
}

function evert_num(obj/*:any*/)/*:EvertNumType*/ {
	var o = ([]/*:any*/), K = keys(obj);
	for(var i = 0; i !== K.length; ++i) o[obj[K[i]]] = parseInt(K[i],10);
	return o;
}

function evert_arr(obj/*:any*/)/*:EvertArrType*/ {
	var o/*:EvertArrType*/ = ([]/*:any*/), K = keys(obj);
	for(var i = 0; i !== K.length; ++i) {
		if(o[obj[K[i]]] == null) o[obj[K[i]]] = [];
		o[obj[K[i]]].push(K[i]);
	}
	return o;
}

var basedate = /*#__PURE__*/new Date(1899, 11, 30, 0, 0, 0); // 2209161600000
function datenum(v/*:Date*/, date1904/*:?boolean*/)/*:number*/ {
	var epoch = /*#__PURE__*/v.getTime();
	if(date1904) epoch -= 1462*24*60*60*1000;
	var dnthresh = /*#__PURE__*/basedate.getTime() + (/*#__PURE__*/v.getTimezoneOffset() - /*#__PURE__*/basedate.getTimezoneOffset()) * 60000;
	return (epoch - dnthresh) / (24 * 60 * 60 * 1000);
}
var refdate = /*#__PURE__*/new Date();
var dnthresh = /*#__PURE__*/basedate.getTime() + (/*#__PURE__*/refdate.getTimezoneOffset() - /*#__PURE__*/basedate.getTimezoneOffset()) * 60000;
var refoffset = /*#__PURE__*/refdate.getTimezoneOffset();
function numdate(v/*:number*/)/*:Date*/ {
	var out = new Date();
	out.setTime(v * 24 * 60 * 60 * 1000 + dnthresh);
	if (out.getTimezoneOffset() !== refoffset) {
		out.setTime(out.getTime() + (out.getTimezoneOffset() - refoffset) * 60000);
	}
	return out;
}

/* ISO 8601 Duration */
function parse_isodur(s) {
	var sec = 0, mt = 0, time = false;
	var m = s.match(/P([0-9\.]+Y)?([0-9\.]+M)?([0-9\.]+D)?T([0-9\.]+H)?([0-9\.]+M)?([0-9\.]+S)?/);
	if(!m) throw new Error("|" + s + "| is not an ISO8601 Duration");
	for(var i = 1; i != m.length; ++i) {
		if(!m[i]) continue;
		mt = 1;
		if(i > 3) time = true;
		switch(m[i].slice(m[i].length-1)) {
			case 'Y':
				throw new Error("Unsupported ISO Duration Field: " + m[i].slice(m[i].length-1));
			case 'D': mt *= 24;
				/* falls through */
			case 'H': mt *= 60;
				/* falls through */
			case 'M':
				if(!time) throw new Error("Unsupported ISO Duration Field: M");
				else mt *= 60;
				/* falls through */
			case 'S': break;
		}
		sec += mt * parseInt(m[i], 10);
	}
	return sec;
}

var good_pd_date_1 = /*#__PURE__*/new Date('2017-02-19T19:06:09.000Z');
var good_pd_date = /*#__PURE__*/isNaN(/*#__PURE__*/good_pd_date_1.getFullYear()) ? /*#__PURE__*/new Date('2/19/17') : good_pd_date_1;
var good_pd = /*#__PURE__*/good_pd_date.getFullYear() == 2017;
/* parses a date as a local date */
function parseDate(str/*:string|Date*/, fixdate/*:?number*/)/*:Date*/ {
	var d = new Date(str);
	if(good_pd) {
		/*:: if(fixdate == null) fixdate = 0; */
		if(fixdate > 0) d.setTime(d.getTime() + d.getTimezoneOffset() * 60 * 1000);
		else if(fixdate < 0) d.setTime(d.getTime() - d.getTimezoneOffset() * 60 * 1000);
		return d;
	}
	if(str instanceof Date) return str;
	if(good_pd_date.getFullYear() == 1917 && !isNaN(d.getFullYear())) {
		var s = d.getFullYear();
		if(str.indexOf("" + s) > -1) return d;
		d.setFullYear(d.getFullYear() + 100); return d;
	}
	var n = str.match(/\d+/g)||["2017","2","19","0","0","0"];
	var out = new Date(+n[0], +n[1] - 1, +n[2], (+n[3]||0), (+n[4]||0), (+n[5]||0));
	if(str.indexOf("Z") > -1) out = new Date(out.getTime() - out.getTimezoneOffset() * 60 * 1000);
	return out;
}

function cc2str(arr/*:Array<number>*/, debomit)/*:string*/ {
	if(has_buf && Buffer.isBuffer(arr)) {
		if(debomit) {
			if(arr[0] == 0xFF && arr[1] == 0xFE) return utf8write(arr.slice(2).toString("utf16le"));
			if(arr[1] == 0xFE && arr[2] == 0xFF) return utf8write(utf16beread(arr.slice(2).toString("binary")));
		}
		return arr.toString("binary");
	}

	if(typeof TextDecoder !== "undefined") try {
		if(debomit) {
			if(arr[0] == 0xFF && arr[1] == 0xFE) return utf8write(new TextDecoder("utf-16le").decode(arr.slice(2)));
			if(arr[0] == 0xFE && arr[1] == 0xFF) return utf8write(new TextDecoder("utf-16be").decode(arr.slice(2)));
		}
		var rev = {
			"\u20ac": "\x80", "\u201a": "\x82", "\u0192": "\x83", "\u201e": "\x84",
			"\u2026": "\x85", "\u2020": "\x86", "\u2021": "\x87", "\u02c6": "\x88",
			"\u2030": "\x89", "\u0160": "\x8a", "\u2039": "\x8b", "\u0152": "\x8c",
			"\u017d": "\x8e", "\u2018": "\x91", "\u2019": "\x92", "\u201c": "\x93",
			"\u201d": "\x94", "\u2022": "\x95", "\u2013": "\x96", "\u2014": "\x97",
			"\u02dc": "\x98", "\u2122": "\x99", "\u0161": "\x9a", "\u203a": "\x9b",
			"\u0153": "\x9c", "\u017e": "\x9e", "\u0178": "\x9f"
		};
		if(Array.isArray(arr)) arr = new Uint8Array(arr);
		return new TextDecoder("latin1").decode(arr).replace(/[€‚ƒ„…†‡ˆ‰Š‹ŒŽ‘’“”•–—˜™š›œžŸ]/g, function(c) { return rev[c] || c; });
	} catch(e) {}

	var o = [];
	for(var i = 0; i != arr.length; ++i) o.push(String.fromCharCode(arr[i]));
	return o.join("");
}

function dup(o/*:any*/)/*:any*/ {
	if(typeof JSON != 'undefined' && !Array.isArray(o)) return JSON.parse(JSON.stringify(o));
	if(typeof o != 'object' || o == null) return o;
	if(o instanceof Date) return new Date(o.getTime());
	var out = {};
	for(var k in o) if(Object.prototype.hasOwnProperty.call(o, k)) out[k] = dup(o[k]);
	return out;
}

function fill(c/*:string*/,l/*:number*/)/*:string*/ { var o = ""; while(o.length < l) o+=c; return o; }

/* TODO: stress test */
function fuzzynum(s/*:string*/)/*:number*/ {
	var v/*:number*/ = Number(s);
	if(!isNaN(v)) return isFinite(v) ? v : NaN;
	if(!/\d/.test(s)) return v;
	var wt = 1;
	var ss = s.replace(/([\d]),([\d])/g,"$1$2").replace(/[$]/g,"").replace(/[%]/g, function() { wt *= 100; return "";});
	if(!isNaN(v = Number(ss))) return v / wt;
	ss = ss.replace(/[(](.*)[)]/,function($$, $1) { wt = -wt; return $1;});
	if(!isNaN(v = Number(ss))) return v / wt;
	return v;
}
var lower_months = ['january', 'february', 'march', 'april', 'may', 'june', 'july', 'august', 'september', 'october', 'november', 'december'];
function fuzzydate(s/*:string*/)/*:Date*/ {
	var o = new Date(s), n = new Date(NaN);
	var y = o.getYear(), m = o.getMonth(), d = o.getDate();
	if(isNaN(d)) return n;
	var lower = s.toLowerCase();
	if(lower.match(/jan|feb|mar|apr|may|jun|jul|aug|sep|oct|nov|dec/)) {
		lower = lower.replace(/[^a-z]/g,"").replace(/([^a-z]|^)[ap]m?([^a-z]|$)/,"");
		if(lower.length > 3 && lower_months.indexOf(lower) == -1) return n;
	} else if(lower.match(/[a-z]/)) return n;
	if(y < 0 || y > 8099) return n;
	if((m > 0 || d > 1) && y != 101) return o;
	if(s.match(/[^-0-9:,\/\\]/)) return n;
	return o;
}

var split_regex = /*#__PURE__*/(/* unused pure expression or super */ null && ((function() {
	var safe_split_regex = "abacaba".split(/(:?b)/i).length == 5;
	return function split_regex(str/*:string*/, re, def/*:string*/)/*:Array<string>*/ {
		if(safe_split_regex || typeof re == "string") return str.split(re);
		var p = str.split(re), o = [p[0]];
		for(var i = 1; i < p.length; ++i) { o.push(def); o.push(p[i]); }
		return o;
	};
})()));
function getdatastr(data)/*:?string*/ {
	if(!data) return null;
	if(data.content && data.type) return cc2str(data.content, true);
	if(data.data) return debom(data.data);
	if(data.asNodeBuffer && has_buf) return debom(data.asNodeBuffer().toString('binary'));
	if(data.asBinary) return debom(data.asBinary());
	if(data._data && data._data.getContent) return debom(cc2str(Array.prototype.slice.call(data._data.getContent(),0)));
	return null;
}

function getdatabin(data) {
	if(!data) return null;
	if(data.data) return char_codes(data.data);
	if(data.asNodeBuffer && has_buf) return data.asNodeBuffer();
	if(data._data && data._data.getContent) {
		var o = data._data.getContent();
		if(typeof o == "string") return char_codes(o);
		return Array.prototype.slice.call(o);
	}
	if(data.content && data.type) return data.content;
	return null;
}

function getdata(data) { return (data && data.name.slice(-4) === ".bin") ? getdatabin(data) : getdatastr(data); }

/* Part 2 Section 10.1.2 "Mapping Content Types" Names are case-insensitive */
/* OASIS does not comment on filename case sensitivity */
function safegetzipfile(zip, file/*:string*/) {
	var k = zip.FullPaths || keys(zip.files);
	var f = file.toLowerCase().replace(/[\/]/g, '\\'), g = f.replace(/\\/g,'\/');
	for(var i=0; i<k.length; ++i) {
		var n = k[i].replace(/^Root Entry[\/]/,"").toLowerCase();
		if(f == n || g == n) return zip.files ? zip.files[k[i]] : zip.FileIndex[i];
	}
	return null;
}

function getzipfile(zip, file/*:string*/) {
	var o = safegetzipfile(zip, file);
	if(o == null) throw new Error("Cannot find file " + file + " in zip");
	return o;
}

function getzipdata(zip, file/*:string*/, safe/*:?boolean*/)/*:any*/ {
	if(!safe) return getdata(getzipfile(zip, file));
	if(!file) return null;
	try { return getzipdata(zip, file); } catch(e) { return null; }
}

function getzipstr(zip, file/*:string*/, safe/*:?boolean*/)/*:?string*/ {
	if(!safe) return getdatastr(getzipfile(zip, file));
	if(!file) return null;
	try { return getzipstr(zip, file); } catch(e) { return null; }
}

function getzipbin(zip, file/*:string*/, safe/*:?boolean*/)/*:any*/ {
	if(!safe) return getdatabin(getzipfile(zip, file));
	if(!file) return null;
	try { return getzipbin(zip, file); } catch(e) { return null; }
}

function zipentries(zip) {
	var k = zip.FullPaths || keys(zip.files), o = [];
	for(var i = 0; i < k.length; ++i) if(k[i].slice(-1) != '/') o.push(k[i].replace(/^Root Entry[\/]/, ""));
	return o.sort();
}

function zip_add_file(zip, path, content) {
	if(zip.FullPaths) {
		if(typeof content == "string") {
			var res;
			if(has_buf) res = Buffer_from(content);
			/* TODO: investigate performance in Edge 13 */
			//else if(typeof TextEncoder !== "undefined") res = new TextEncoder().encode(content);
			else res = utf8decode(content);
			return CFB.utils.cfb_add(zip, path, res);
		}
		CFB.utils.cfb_add(zip, path, content);
	}
	else zip.file(path, content);
}

function zip_new() { return CFB.utils.cfb_new(); }

function zip_read(d, o) {
	switch(o.type) {
		case "base64": return CFB.read(d, { type: "base64" });
		case "binary": return CFB.read(d, { type: "binary" });
		case "buffer": case "array": return CFB.read(d, { type: "buffer" });
	}
	throw new Error("Unrecognized type " + o.type);
}

function resolve_path(path/*:string*/, base/*:string*/)/*:string*/ {
	if(path.charAt(0) == "/") return path.slice(1);
	var result = base.split('/');
	if(base.slice(-1) != "/") result.pop(); // folder path
	var target = path.split('/');
	while (target.length !== 0) {
		var step = target.shift();
		if (step === '..') result.pop();
		else if (step !== '.') result.push(step);
	}
	return result.join('/');
}
var XML_HEADER = '<?xml version="1.0" encoding="UTF-8" standalone="yes"?>\r\n';
var attregexg=/([^"\s?>\/]+)\s*=\s*((?:")([^"]*)(?:")|(?:')([^']*)(?:')|([^'">\s]+))/g;
var tagregex1=/<[\/\?]?[a-zA-Z0-9:_-]+(?:\s+[^"\s?>\/]+\s*=\s*(?:"[^"]*"|'[^']*'|[^'">\s=]+))*\s*[\/\?]?>/mg, tagregex2 = /<[^>]*>/g;
var tagregex = /*#__PURE__*/XML_HEADER.match(tagregex1) ? tagregex1 : tagregex2;
var nsregex=/<\w*:/, nsregex2 = /<(\/?)\w+:/;
function parsexmltag(tag/*:string*/, skip_root/*:?boolean*/, skip_LC/*:?boolean*/)/*:any*/ {
	var z = ({}/*:any*/);
	var eq = 0, c = 0;
	for(; eq !== tag.length; ++eq) if((c = tag.charCodeAt(eq)) === 32 || c === 10 || c === 13) break;
	if(!skip_root) z[0] = tag.slice(0, eq);
	if(eq === tag.length) return z;
	var m = tag.match(attregexg), j=0, v="", i=0, q="", cc="", quot = 1;
	if(m) for(i = 0; i != m.length; ++i) {
		cc = m[i];
		for(c=0; c != cc.length; ++c) if(cc.charCodeAt(c) === 61) break;
		q = cc.slice(0,c).trim();
		while(cc.charCodeAt(c+1) == 32) ++c;
		quot = ((eq=cc.charCodeAt(c+1)) == 34 || eq == 39) ? 1 : 0;
		v = cc.slice(c+1+quot, cc.length-quot);
		for(j=0;j!=q.length;++j) if(q.charCodeAt(j) === 58) break;
		if(j===q.length) {
			if(q.indexOf("_") > 0) q = q.slice(0, q.indexOf("_")); // from ods
			z[q] = v;
			if(!skip_LC) z[q.toLowerCase()] = v;
		}
		else {
			var k = (j===5 && q.slice(0,5)==="xmlns"?"xmlns":"")+q.slice(j+1);
			if(z[k] && q.slice(j-3,j) == "ext") continue; // from ods
			z[k] = v;
			if(!skip_LC) z[k.toLowerCase()] = v;
		}
	}
	return z;
}
function strip_ns(x/*:string*/)/*:string*/ { return x.replace(nsregex2, "<$1"); }

var encodings = {
	'&quot;': '"',
	'&apos;': "'",
	'&gt;': '>',
	'&lt;': '<',
	'&amp;': '&'
};
var rencoding = /*#__PURE__*/evert(encodings);
//var rencstr = "&<>'\"".split("");

// TODO: CP remap (need to read file version to determine OS)
var unescapexml/*:StringConv*/ = /*#__PURE__*/(/* unused pure expression or super */ null && ((function() {
	/* 22.4.2.4 bstr (Basic String) */
	var encregex = /&(?:quot|apos|gt|lt|amp|#x?([\da-fA-F]+));/ig, coderegex = /_x([\da-fA-F]{4})_/ig;
	return function unescapexml(text/*:string*/)/*:string*/ {
		var s = text + '', i = s.indexOf("<![CDATA[");
		if(i == -1) return s.replace(encregex, function($$, $1) { return encodings[$$]||String.fromCharCode(parseInt($1,$$.indexOf("x")>-1?16:10))||$$; }).replace(coderegex,function(m,c) {return String.fromCharCode(parseInt(c,16));});
		var j = s.indexOf("]]>");
		return unescapexml(s.slice(0, i)) + s.slice(i+9,j) + unescapexml(s.slice(j+3));
	};
})()));

var decregex=/[&<>'"]/g, charegex = /[\u0000-\u0008\u000b-\u001f]/g;
function escapexml(text/*:string*/)/*:string*/{
	var s = text + '';
	return s.replace(decregex, function(y) { return rencoding[y]; }).replace(charegex,function(s) { return "_x" + ("000"+s.charCodeAt(0).toString(16)).slice(-4) + "_";});
}
function escapexmltag(text/*:string*/)/*:string*/{ return escapexml(text).replace(/ /g,"_x0020_"); }

var htmlcharegex = /[\u0000-\u001f]/g;
function escapehtml(text/*:string*/)/*:string*/{
	var s = text + '';
	return s.replace(decregex, function(y) { return rencoding[y]; }).replace(/\n/g, "<br/>").replace(htmlcharegex,function(s) { return "&#x" + ("000"+s.charCodeAt(0).toString(16)).slice(-4) + ";"; });
}

function escapexlml(text/*:string*/)/*:string*/{
	var s = text + '';
	return s.replace(decregex, function(y) { return rencoding[y]; }).replace(htmlcharegex,function(s) { return "&#x" + (s.charCodeAt(0).toString(16)).toUpperCase() + ";"; });
}

/* TODO: handle codepages */
var xlml_fixstr/*:StringConv*/ = /*#__PURE__*/(/* unused pure expression or super */ null && ((function() {
	var entregex = /&#(\d+);/g;
	function entrepl($$/*:string*/,$1/*:string*/)/*:string*/ { return String.fromCharCode(parseInt($1,10)); }
	return function xlml_fixstr(str/*:string*/)/*:string*/ { return str.replace(entregex,entrepl); };
})()));
function xlml_unfixstr(str/*:string*/)/*:string*/ { return str.replace(/(\r\n|[\r\n])/g,"\&#10;"); }

function parsexmlbool(value/*:any*/)/*:boolean*/ {
	switch(value) {
		case 1: case true: case '1': case 'true': case 'TRUE': return true;
		/* case '0': case 'false': case 'FALSE':*/
		default: return false;
	}
}

function utf8reada(orig/*:string*/)/*:string*/ {
	var out = "", i = 0, c = 0, d = 0, e = 0, f = 0, w = 0;
	while (i < orig.length) {
		c = orig.charCodeAt(i++);
		if (c < 128) { out += String.fromCharCode(c); continue; }
		d = orig.charCodeAt(i++);
		if (c>191 && c<224) { f = ((c & 31) << 6); f |= (d & 63); out += String.fromCharCode(f); continue; }
		e = orig.charCodeAt(i++);
		if (c < 240) { out += String.fromCharCode(((c & 15) << 12) | ((d & 63) << 6) | (e & 63)); continue; }
		f = orig.charCodeAt(i++);
		w = (((c & 7) << 18) | ((d & 63) << 12) | ((e & 63) << 6) | (f & 63))-65536;
		out += String.fromCharCode(0xD800 + ((w>>>10)&1023));
		out += String.fromCharCode(0xDC00 + (w&1023));
	}
	return out;
}

function utf8readb(data) {
	var out = new_raw_buf(2*data.length), w, i, j = 1, k = 0, ww=0, c;
	for(i = 0; i < data.length; i+=j) {
		j = 1;
		if((c=data.charCodeAt(i)) < 128) w = c;
		else if(c < 224) { w = (c&31)*64+(data.charCodeAt(i+1)&63); j=2; }
		else if(c < 240) { w=(c&15)*4096+(data.charCodeAt(i+1)&63)*64+(data.charCodeAt(i+2)&63); j=3; }
		else { j = 4;
			w = (c & 7)*262144+(data.charCodeAt(i+1)&63)*4096+(data.charCodeAt(i+2)&63)*64+(data.charCodeAt(i+3)&63);
			w -= 65536; ww = 0xD800 + ((w>>>10)&1023); w = 0xDC00 + (w&1023);
		}
		if(ww !== 0) { out[k++] = ww&255; out[k++] = ww>>>8; ww = 0; }
		out[k++] = w%256; out[k++] = w>>>8;
	}
	return out.slice(0,k).toString('ucs2');
}

function utf8readc(data) { return Buffer_from(data, 'binary').toString('utf8'); }

var utf8corpus = "foo bar baz\u00e2\u0098\u0083\u00f0\u009f\u008d\u00a3";
var utf8read = has_buf && (/*#__PURE__*/utf8readc(utf8corpus) == /*#__PURE__*/utf8reada(utf8corpus) && utf8readc || /*#__PURE__*/utf8readb(utf8corpus) == /*#__PURE__*/utf8reada(utf8corpus) && utf8readb) || utf8reada;

var utf8write/*:StringConv*/ = has_buf ? function(data) { return Buffer_from(data, 'utf8').toString("binary"); } : function(orig/*:string*/)/*:string*/ {
	var out/*:Array<string>*/ = [], i = 0, c = 0, d = 0;
	while(i < orig.length) {
		c = orig.charCodeAt(i++);
		switch(true) {
			case c < 128: out.push(String.fromCharCode(c)); break;
			case c < 2048:
				out.push(String.fromCharCode(192 + (c >> 6)));
				out.push(String.fromCharCode(128 + (c & 63)));
				break;
			case c >= 55296 && c < 57344:
				c -= 55296; d = orig.charCodeAt(i++) - 56320 + (c<<10);
				out.push(String.fromCharCode(240 + ((d >>18) & 7)));
				out.push(String.fromCharCode(144 + ((d >>12) & 63)));
				out.push(String.fromCharCode(128 + ((d >> 6) & 63)));
				out.push(String.fromCharCode(128 + (d & 63)));
				break;
			default:
				out.push(String.fromCharCode(224 + (c >> 12)));
				out.push(String.fromCharCode(128 + ((c >> 6) & 63)));
				out.push(String.fromCharCode(128 + (c & 63)));
		}
	}
	return out.join("");
};

// matches <foo>...</foo> extracts content
var matchtag = /*#__PURE__*/(/* unused pure expression or super */ null && ((function() {
	var mtcache/*:{[k:string]:RegExp}*/ = ({}/*:any*/);
	return function matchtag(f/*:string*/,g/*:?string*/)/*:RegExp*/ {
		var t = f+"|"+(g||"");
		if(mtcache[t]) return mtcache[t];
		return (mtcache[t] = new RegExp('<(?:\\w+:)?'+f+'(?: xml:space="preserve")?(?:[^>]*)>([\\s\\S]*?)</(?:\\w+:)?'+f+'>',((g||"")/*:any*/)));
	};
})()));

var htmldecode/*:{(s:string):string}*/ = /*#__PURE__*/(function() {
	var entities/*:Array<[RegExp, string]>*/ = [
		['nbsp', ' '], ['middot', '·'],
		['quot', '"'], ['apos', "'"], ['gt',   '>'], ['lt',   '<'], ['amp',  '&']
	].map(function(x/*:[string, string]*/) { return [new RegExp('&' + x[0] + ';', "ig"), x[1]]; });
	return function htmldecode(str/*:string*/)/*:string*/ {
		var o = str
				// Remove new lines and spaces from start of content
				.replace(/^[\t\n\r ]+/, "")
				// Remove new lines and spaces from end of content
				.replace(/[\t\n\r ]+$/,"")
				// Added line which removes any white space characters after and before html tags
				.replace(/>\s+/g,">").replace(/\s+</g,"<")
				// Replace remaining new lines and spaces with space
				.replace(/[\t\n\r ]+/g, " ")
				// Replace <br> tags with new lines
				.replace(/<\s*[bB][rR]\s*\/?>/g,"\n")
				// Strip HTML elements
				.replace(/<[^>]*>/g,"");
		for(var i = 0; i < entities.length; ++i) o = o.replace(entities[i][0], entities[i][1]);
		return o;
	};
})();

var vtregex = /*#__PURE__*/(/* unused pure expression or super */ null && ((function(){ var vt_cache = {};
	return function vt_regex(bt) {
		if(vt_cache[bt] !== undefined) return vt_cache[bt];
		return (vt_cache[bt] = new RegExp("<(?:vt:)?" + bt + ">([\\s\\S]*?)</(?:vt:)?" + bt + ">", 'g') );
};})()));
var vtvregex = /<\/?(?:vt:)?variant>/g, vtmregex = /<(?:vt:)([^>]*)>([\s\S]*)</;
function parseVector(data/*:string*/, opts)/*:Array<{v:string,t:string}>*/ {
	var h = parsexmltag(data);

	var matches/*:Array<string>*/ = data.match(vtregex(h.baseType))||[];
	var res/*:Array<any>*/ = [];
	if(matches.length != h.size) {
		if(opts.WTF) throw new Error("unexpected vector length " + matches.length + " != " + h.size);
		return res;
	}
	matches.forEach(function(x/*:string*/) {
		var v = x.replace(vtvregex,"").match(vtmregex);
		if(v) res.push({v:utf8read(v[2]), t:v[1]});
	});
	return res;
}

var wtregex = /(^\s|\s$|\n)/;
function writetag(f/*:string*/,g/*:string*/)/*:string*/ { return '<' + f + (g.match(wtregex)?' xml:space="preserve"' : "") + '>' + g + '</' + f + '>'; }

function wxt_helper(h)/*:string*/ { return keys(h).map(function(k) { return " " + k + '="' + h[k] + '"';}).join(""); }
function writextag(f/*:string*/,g/*:?string*/,h) { return '<' + f + ((h != null) ? wxt_helper(h) : "") + ((g != null) ? (g.match(wtregex)?' xml:space="preserve"' : "") + '>' + g + '</' + f : "/") + '>';}

function write_w3cdtf(d/*:Date*/, t/*:?boolean*/)/*:string*/ { try { return d.toISOString().replace(/\.\d*/,""); } catch(e) { if(t) throw e; } return ""; }

function write_vt(s, xlsx/*:?boolean*/)/*:string*/ {
	switch(typeof s) {
		case 'string':
			var o = writextag('vt:lpwstr', escapexml(s));
			if(xlsx) o = o.replace(/&quot;/g, "_x0022_");
			return o;
		case 'number': return writextag((s|0)==s?'vt:i4':'vt:r8', escapexml(String(s)));
		case 'boolean': return writextag('vt:bool',s?'true':'false');
	}
	if(s instanceof Date) return writextag('vt:filetime', write_w3cdtf(s));
	throw new Error("Unable to serialize " + s);
}

function xlml_normalize(d)/*:string*/ {
	if(has_buf &&/*::typeof Buffer !== "undefined" && d != null && d instanceof Buffer &&*/ Buffer.isBuffer(d)) return d.toString('utf8');
	if(typeof d === 'string') return d;
	/* duktape */
	if(typeof Uint8Array !== 'undefined' && d instanceof Uint8Array) return utf8read(a2s(ab2a(d)));
	throw new Error("Bad input format: expected Buffer or string");
}
/* UOS uses CJK in tags */
var xlmlregex = /<(\/?)([^\s?><!\/:]*:|)([^\s?<>:\/]+)(?:[\s?:\/][^>]*)?>/mg;
//var xlmlregex = /<(\/?)([a-z0-9]*:|)(\w+)[^>]*>/mg;

var XMLNS = ({
	CORE_PROPS: 'http://schemas.openxmlformats.org/package/2006/metadata/core-properties',
	CUST_PROPS: "http://schemas.openxmlformats.org/officeDocument/2006/custom-properties",
	EXT_PROPS: "http://schemas.openxmlformats.org/officeDocument/2006/extended-properties",
	CT: 'http://schemas.openxmlformats.org/package/2006/content-types',
	RELS: 'http://schemas.openxmlformats.org/package/2006/relationships',
	TCMNT: 'http://schemas.microsoft.com/office/spreadsheetml/2018/threadedcomments',
	'dc': 'http://purl.org/dc/elements/1.1/',
	'dcterms': 'http://purl.org/dc/terms/',
	'dcmitype': 'http://purl.org/dc/dcmitype/',
	'mx': 'http://schemas.microsoft.com/office/mac/excel/2008/main',
	'r': 'http://schemas.openxmlformats.org/officeDocument/2006/relationships',
	'sjs': 'http://schemas.openxmlformats.org/package/2006/sheetjs/core-properties',
	'vt': 'http://schemas.openxmlformats.org/officeDocument/2006/docPropsVTypes',
	'xsi': 'http://www.w3.org/2001/XMLSchema-instance',
	'xsd': 'http://www.w3.org/2001/XMLSchema'
}/*:any*/);

var XMLNS_main = [
	'http://schemas.openxmlformats.org/spreadsheetml/2006/main',
	'http://purl.oclc.org/ooxml/spreadsheetml/main',
	'http://schemas.microsoft.com/office/excel/2006/main',
	'http://schemas.microsoft.com/office/excel/2006/2'
];

var XLMLNS = ({
	'o':    'urn:schemas-microsoft-com:office:office',
	'x':    'urn:schemas-microsoft-com:office:excel',
	'ss':   'urn:schemas-microsoft-com:office:spreadsheet',
	'dt':   'uuid:C2F41010-65B3-11d1-A29F-00AA00C14882',
	'mv':   'http://macVmlSchemaUri',
	'v':    'urn:schemas-microsoft-com:vml',
	'html': 'http://www.w3.org/TR/REC-html40'
}/*:any*/);
function read_double_le(b/*:RawBytes|CFBlob*/, idx/*:number*/)/*:number*/ {
	var s = 1 - 2 * (b[idx + 7] >>> 7);
	var e = ((b[idx + 7] & 0x7f) << 4) + ((b[idx + 6] >>> 4) & 0x0f);
	var m = (b[idx+6]&0x0f);
	for(var i = 5; i >= 0; --i) m = m * 256 + b[idx + i];
	if(e == 0x7ff) return m == 0 ? (s * Infinity) : NaN;
	if(e == 0) e = -1022;
	else { e -= 1023; m += Math.pow(2,52); }
	return s * Math.pow(2, e - 52) * m;
}

function write_double_le(b/*:RawBytes|CFBlob*/, v/*:number*/, idx/*:number*/) {
	var bs = ((((v < 0) || (1/v == -Infinity)) ? 1 : 0) << 7), e = 0, m = 0;
	var av = bs ? (-v) : v;
	if(!isFinite(av)) { e = 0x7ff; m = isNaN(v) ? 0x6969 : 0; }
	else if(av == 0) e = m = 0;
	else {
		e = Math.floor(Math.log(av) / Math.LN2);
		m = av * Math.pow(2, 52 - e);
		if((e <= -1023) && (!isFinite(m) || (m < Math.pow(2,52)))) { e = -1022; }
		else { m -= Math.pow(2,52); e+=1023; }
	}
	for(var i = 0; i <= 5; ++i, m/=256) b[idx + i] = m & 0xff;
	b[idx + 6] = ((e & 0x0f) << 4) | (m & 0xf);
	b[idx + 7] = (e >> 4) | bs;
}

var ___toBuffer = function(bufs/*:Array<Array<RawBytes> >*/)/*:RawBytes*/ { var x=[],w=10240; for(var i=0;i<bufs[0].length;++i) if(bufs[0][i]) for(var j=0,L=bufs[0][i].length;j<L;j+=w) x.push.apply(x, bufs[0][i].slice(j,j+w)); return x; };
var __toBuffer = has_buf ? function(bufs) { return (bufs[0].length > 0 && Buffer.isBuffer(bufs[0][0])) ? Buffer.concat(bufs[0].map(function(x) { return Buffer.isBuffer(x) ? x : Buffer_from(x); })) : ___toBuffer(bufs);} : ___toBuffer;

var ___utf16le = function(b/*:RawBytes|CFBlob*/,s/*:number*/,e/*:number*/)/*:string*/ { var ss/*:Array<string>*/=[]; for(var i=s; i<e; i+=2) ss.push(String.fromCharCode(__readUInt16LE(b,i))); return ss.join("").replace(chr0,''); };
var __utf16le = has_buf ? function(b/*:RawBytes|CFBlob*/,s/*:number*/,e/*:number*/)/*:string*/ { if(!Buffer.isBuffer(b)/*:: || !(b instanceof Buffer)*/) return ___utf16le(b,s,e); return b.toString('utf16le',s,e).replace(chr0,'')/*.replace(chr1,'!')*/; } : ___utf16le;

var ___hexlify = function(b/*:RawBytes|CFBlob*/,s/*:number*/,l/*:number*/)/*:string*/ { var ss/*:Array<string>*/=[]; for(var i=s; i<s+l; ++i) ss.push(("0" + b[i].toString(16)).slice(-2)); return ss.join(""); };
var __hexlify = has_buf ? function(b/*:RawBytes|CFBlob*/,s/*:number*/,l/*:number*/)/*:string*/ { return Buffer.isBuffer(b)/*:: && b instanceof Buffer*/ ? b.toString('hex',s,s+l) : ___hexlify(b,s,l); } : ___hexlify;

var ___utf8 = function(b/*:RawBytes|CFBlob*/,s/*:number*/,e/*:number*/) { var ss=[]; for(var i=s; i<e; i++) ss.push(String.fromCharCode(__readUInt8(b,i))); return ss.join(""); };
var __utf8 = has_buf ? function utf8_b(b/*:RawBytes|CFBlob*/, s/*:number*/, e/*:number*/) { return (Buffer.isBuffer(b)/*:: && (b instanceof Buffer)*/) ? b.toString('utf8',s,e) : ___utf8(b,s,e); } : ___utf8;

var ___lpstr = function(b/*:RawBytes|CFBlob*/,i/*:number*/) { var len = __readUInt32LE(b,i); return len > 0 ? __utf8(b, i+4,i+4+len-1) : "";};
var __lpstr = ___lpstr;

var ___cpstr = function(b/*:RawBytes|CFBlob*/,i/*:number*/) { var len = __readUInt32LE(b,i); return len > 0 ? __utf8(b, i+4,i+4+len-1) : "";};
var __cpstr = ___cpstr;

var ___lpwstr = function(b/*:RawBytes|CFBlob*/,i/*:number*/) { var len = 2*__readUInt32LE(b,i); return len > 0 ? __utf8(b, i+4,i+4+len-1) : "";};
var __lpwstr = ___lpwstr;

var ___lpp4 = function lpp4_(b/*:RawBytes|CFBlob*/,i/*:number*/) { var len = __readUInt32LE(b,i); return len > 0 ? __utf16le(b, i+4,i+4+len) : "";};
var __lpp4 = ___lpp4;

var ___8lpp4 = function(b/*:RawBytes|CFBlob*/,i/*:number*/) { var len = __readUInt32LE(b,i); return len > 0 ? __utf8(b, i+4,i+4+len) : "";};
var __8lpp4 = ___8lpp4;

var ___double = function(b/*:RawBytes|CFBlob*/, idx/*:number*/) { return read_double_le(b, idx);};
var __double = ___double;

var is_buf = function is_buf_a(a) { return Array.isArray(a) || (typeof Uint8Array !== "undefined" && a instanceof Uint8Array); };

if(has_buf/*:: && typeof Buffer !== 'undefined'*/) {
	__lpstr = function lpstr_b(b/*:RawBytes|CFBlob*/, i/*:number*/) { if(!Buffer.isBuffer(b)/*:: || !(b instanceof Buffer)*/) return ___lpstr(b, i); var len = b.readUInt32LE(i); return len > 0 ? b.toString('utf8',i+4,i+4+len-1) : "";};
	__cpstr = function cpstr_b(b/*:RawBytes|CFBlob*/, i/*:number*/) { if(!Buffer.isBuffer(b)/*:: || !(b instanceof Buffer)*/) return ___cpstr(b, i); var len = b.readUInt32LE(i); return len > 0 ? b.toString('utf8',i+4,i+4+len-1) : "";};
	__lpwstr = function lpwstr_b(b/*:RawBytes|CFBlob*/, i/*:number*/) { if(!Buffer.isBuffer(b)/*:: || !(b instanceof Buffer)*/) return ___lpwstr(b, i); var len = 2*b.readUInt32LE(i); return b.toString('utf16le',i+4,i+4+len-1);};
	__lpp4 = function lpp4_b(b/*:RawBytes|CFBlob*/, i/*:number*/) { if(!Buffer.isBuffer(b)/*:: || !(b instanceof Buffer)*/) return ___lpp4(b, i); var len = b.readUInt32LE(i); return b.toString('utf16le',i+4,i+4+len);};
	__8lpp4 = function lpp4_8b(b/*:RawBytes|CFBlob*/, i/*:number*/) { if(!Buffer.isBuffer(b)/*:: || !(b instanceof Buffer)*/) return ___8lpp4(b, i); var len = b.readUInt32LE(i); return b.toString('utf8',i+4,i+4+len);};
	__double = function double_(b/*:RawBytes|CFBlob*/, i/*:number*/) { if(Buffer.isBuffer(b)/*::&& b instanceof Buffer*/) return b.readDoubleLE(i); return ___double(b,i); };
	is_buf = function is_buf_b(a) { return Buffer.isBuffer(a) || Array.isArray(a) || (typeof Uint8Array !== "undefined" && a instanceof Uint8Array); };
}

/* from js-xls */
function cpdoit() {
	__utf16le = function(b/*:RawBytes|CFBlob*/,s/*:number*/,e/*:number*/) { return $cptable.utils.decode(1200, b.slice(s,e)).replace(chr0, ''); };
	__utf8 = function(b/*:RawBytes|CFBlob*/,s/*:number*/,e/*:number*/) { return $cptable.utils.decode(65001, b.slice(s,e)); };
	__lpstr = function(b/*:RawBytes|CFBlob*/,i/*:number*/) { var len = __readUInt32LE(b,i); return len > 0 ? $cptable.utils.decode(current_ansi, b.slice(i+4, i+4+len-1)) : "";};
	__cpstr = function(b/*:RawBytes|CFBlob*/,i/*:number*/) { var len = __readUInt32LE(b,i); return len > 0 ? $cptable.utils.decode(current_codepage, b.slice(i+4, i+4+len-1)) : "";};
	__lpwstr = function(b/*:RawBytes|CFBlob*/,i/*:number*/) { var len = 2*__readUInt32LE(b,i); return len > 0 ? $cptable.utils.decode(1200, b.slice(i+4,i+4+len-1)) : "";};
	__lpp4 = function(b/*:RawBytes|CFBlob*/,i/*:number*/) { var len = __readUInt32LE(b,i); return len > 0 ? $cptable.utils.decode(1200, b.slice(i+4,i+4+len)) : "";};
	__8lpp4 = function(b/*:RawBytes|CFBlob*/,i/*:number*/) { var len = __readUInt32LE(b,i); return len > 0 ? $cptable.utils.decode(65001, b.slice(i+4,i+4+len)) : "";};
}
if(typeof $cptable !== 'undefined') cpdoit();

var __readUInt8 = function(b/*:RawBytes|CFBlob*/, idx/*:number*/)/*:number*/ { return b[idx]; };
var __readUInt16LE = function(b/*:RawBytes|CFBlob*/, idx/*:number*/)/*:number*/ { return (b[idx+1]*(1<<8))+b[idx]; };
var __readInt16LE = function(b/*:RawBytes|CFBlob*/, idx/*:number*/)/*:number*/ { var u = (b[idx+1]*(1<<8))+b[idx]; return (u < 0x8000) ? u : ((0xffff - u + 1) * -1); };
var __readUInt32LE = function(b/*:RawBytes|CFBlob*/, idx/*:number*/)/*:number*/ { return b[idx+3]*(1<<24)+(b[idx+2]<<16)+(b[idx+1]<<8)+b[idx]; };
var __readInt32LE = function(b/*:RawBytes|CFBlob*/, idx/*:number*/)/*:number*/ { return (b[idx+3]<<24)|(b[idx+2]<<16)|(b[idx+1]<<8)|b[idx]; };
var __readInt32BE = function(b/*:RawBytes|CFBlob*/, idx/*:number*/)/*:number*/ { return (b[idx]<<24)|(b[idx+1]<<16)|(b[idx+2]<<8)|b[idx+3]; };

function ReadShift(size/*:number*/, t/*:?string*/)/*:number|string*/ {
	var o="", oI/*:: :number = 0*/, oR, oo=[], w, vv, i, loc;
	switch(t) {
		case 'dbcs':
			loc = this.l;
			if(has_buf && Buffer.isBuffer(this)) o = this.slice(this.l, this.l+2*size).toString("utf16le");
			else for(i = 0; i < size; ++i) { o+=String.fromCharCode(__readUInt16LE(this, loc)); loc+=2; }
			size *= 2;
			break;

		case 'utf8': o = __utf8(this, this.l, this.l + size); break;
		case 'utf16le': size *= 2; o = __utf16le(this, this.l, this.l + size); break;

		case 'wstr':
			if(typeof $cptable !== 'undefined') o = $cptable.utils.decode(current_codepage, this.slice(this.l, this.l+2*size));
			else return ReadShift.call(this, size, 'dbcs');
			size = 2 * size; break;

		/* [MS-OLEDS] 2.1.4 LengthPrefixedAnsiString */
		case 'lpstr-ansi': o = __lpstr(this, this.l); size = 4 + __readUInt32LE(this, this.l); break;
		case 'lpstr-cp': o = __cpstr(this, this.l); size = 4 + __readUInt32LE(this, this.l); break;
		/* [MS-OLEDS] 2.1.5 LengthPrefixedUnicodeString */
		case 'lpwstr': o = __lpwstr(this, this.l); size = 4 + 2 * __readUInt32LE(this, this.l); break;
		/* [MS-OFFCRYPTO] 2.1.2 Length-Prefixed Padded Unicode String (UNICODE-LP-P4) */
		case 'lpp4': size = 4 +  __readUInt32LE(this, this.l); o = __lpp4(this, this.l); if(size & 0x02) size += 2; break;
		/* [MS-OFFCRYPTO] 2.1.3 Length-Prefixed UTF-8 String (UTF-8-LP-P4) */
		case '8lpp4': size = 4 +  __readUInt32LE(this, this.l); o = __8lpp4(this, this.l); if(size & 0x03) size += 4 - (size & 0x03); break;

		case 'cstr': size = 0; o = "";
			while((w=__readUInt8(this, this.l + size++))!==0) oo.push(_getchar(w));
			o = oo.join(""); break;
		case '_wstr': size = 0; o = "";
			while((w=__readUInt16LE(this,this.l +size))!==0){oo.push(_getchar(w));size+=2;}
			size+=2; o = oo.join(""); break;

		/* sbcs and dbcs support continue records in the SST way TODO codepages */
		case 'dbcs-cont': o = ""; loc = this.l;
			for(i = 0; i < size; ++i) {
				if(this.lens && this.lens.indexOf(loc) !== -1) {
					w = __readUInt8(this, loc);
					this.l = loc + 1;
					vv = ReadShift.call(this, size-i, w ? 'dbcs-cont' : 'sbcs-cont');
					return oo.join("") + vv;
				}
				oo.push(_getchar(__readUInt16LE(this, loc)));
				loc+=2;
			} o = oo.join(""); size *= 2; break;

		case 'cpstr':
			if(typeof $cptable !== 'undefined') {
				o = $cptable.utils.decode(current_codepage, this.slice(this.l, this.l + size));
				break;
			}
		/* falls through */
		case 'sbcs-cont': o = ""; loc = this.l;
			for(i = 0; i != size; ++i) {
				if(this.lens && this.lens.indexOf(loc) !== -1) {
					w = __readUInt8(this, loc);
					this.l = loc + 1;
					vv = ReadShift.call(this, size-i, w ? 'dbcs-cont' : 'sbcs-cont');
					return oo.join("") + vv;
				}
				oo.push(_getchar(__readUInt8(this, loc)));
				loc+=1;
			} o = oo.join(""); break;

		default:
	switch(size) {
		case 1: oI = __readUInt8(this, this.l); this.l++; return oI;
		case 2: oI = (t === 'i' ? __readInt16LE : __readUInt16LE)(this, this.l); this.l += 2; return oI;
		case 4: case -4:
			if(t === 'i' || ((this[this.l+3] & 0x80)===0)) { oI = ((size > 0) ? __readInt32LE : __readInt32BE)(this, this.l); this.l += 4; return oI; }
			else { oR = __readUInt32LE(this, this.l); this.l += 4; } return oR;
		case 8: case -8:
			if(t === 'f') {
				if(size == 8) oR = __double(this, this.l);
				else oR = __double([this[this.l+7],this[this.l+6],this[this.l+5],this[this.l+4],this[this.l+3],this[this.l+2],this[this.l+1],this[this.l+0]], 0);
				this.l += 8; return oR;
			} else size = 8;
		/* falls through */
		case 16: o = __hexlify(this, this.l, size); break;
	}}
	this.l+=size; return o;
}

var __writeUInt32LE = function(b/*:RawBytes|CFBlob*/, val/*:number*/, idx/*:number*/)/*:void*/ { b[idx] = (val & 0xFF); b[idx+1] = ((val >>> 8) & 0xFF); b[idx+2] = ((val >>> 16) & 0xFF); b[idx+3] = ((val >>> 24) & 0xFF); };
var __writeInt32LE  = function(b/*:RawBytes|CFBlob*/, val/*:number*/, idx/*:number*/)/*:void*/ { b[idx] = (val & 0xFF); b[idx+1] = ((val >> 8) & 0xFF); b[idx+2] = ((val >> 16) & 0xFF); b[idx+3] = ((val >> 24) & 0xFF); };
var __writeUInt16LE = function(b/*:RawBytes|CFBlob*/, val/*:number*/, idx/*:number*/)/*:void*/ { b[idx] = (val & 0xFF); b[idx+1] = ((val >>> 8) & 0xFF); };

function WriteShift(t/*:number*/, val/*:string|number*/, f/*:?string*/)/*:any*/ {
	var size = 0, i = 0;
	if(f === 'dbcs') {
		/*:: if(typeof val !== 'string') throw new Error("unreachable"); */
		for(i = 0; i != val.length; ++i) __writeUInt16LE(this, val.charCodeAt(i), this.l + 2 * i);
		size = 2 * val.length;
	} else if(f === 'sbcs') {
		if(typeof $cptable !== 'undefined' && current_ansi == 874) {
			/* TODO: use tables directly, don't encode */
			/*:: if(typeof val !== "string") throw new Error("unreachable"); */
			for(i = 0; i != val.length; ++i) {
				var cppayload = $cptable.utils.encode(current_ansi, val.charAt(i));
				this[this.l + i] = cppayload[0];
			}
		} else {
			/*:: if(typeof val !== 'string') throw new Error("unreachable"); */
			val = val.replace(/[^\x00-\x7F]/g, "_");
			/*:: if(typeof val !== 'string') throw new Error("unreachable"); */
			for(i = 0; i != val.length; ++i) this[this.l + i] = (val.charCodeAt(i) & 0xFF);
		}
		size = val.length;
	} else if(f === 'hex') {
		for(; i < t; ++i) {
			/*:: if(typeof val !== "string") throw new Error("unreachable"); */
			this[this.l++] = (parseInt(val.slice(2*i, 2*i+2), 16)||0);
		} return this;
	} else if(f === 'utf16le') {
			/*:: if(typeof val !== "string") throw new Error("unreachable"); */
			var end/*:number*/ = Math.min(this.l + t, this.length);
			for(i = 0; i < Math.min(val.length, t); ++i) {
				var cc = val.charCodeAt(i);
				this[this.l++] = (cc & 0xff);
				this[this.l++] = (cc >> 8);
			}
			while(this.l < end) this[this.l++] = 0;
			return this;
	} else /*:: if(typeof val === 'number') */ switch(t) {
		case  1: size = 1; this[this.l] = val&0xFF; break;
		case  2: size = 2; this[this.l] = val&0xFF; val >>>= 8; this[this.l+1] = val&0xFF; break;
		case  3: size = 3; this[this.l] = val&0xFF; val >>>= 8; this[this.l+1] = val&0xFF; val >>>= 8; this[this.l+2] = val&0xFF; break;
		case  4: size = 4; __writeUInt32LE(this, val, this.l); break;
		case  8: size = 8; if(f === 'f') { write_double_le(this, val, this.l); break; }
		/* falls through */
		case 16: break;
		case -4: size = 4; __writeInt32LE(this, val, this.l); break;
	}
	this.l += size; return this;
}

function CheckField(hexstr/*:string*/, fld/*:string*/)/*:void*/ {
	var m = __hexlify(this,this.l,hexstr.length>>1);
	if(m !== hexstr) throw new Error(fld + 'Expected ' + hexstr + ' saw ' + m);
	this.l += hexstr.length>>1;
}

function prep_blob(blob, pos/*:number*/)/*:void*/ {
	blob.l = pos;
	blob.read_shift = /*::(*/ReadShift/*:: :any)*/;
	blob.chk = CheckField;
	blob.write_shift = WriteShift;
}

function parsenoop(blob, length/*:: :number, opts?:any */) { blob.l += length; }

function new_buf(sz/*:number*/)/*:Block*/ {
	var o = new_raw_buf(sz);
	prep_blob(o, 0);
	return o;
}

/* [MS-XLSB] 2.1.4 Record */
function recordhopper(data, cb/*:RecordHopperCB*/, opts/*:?any*/) {
	if(!data) return;
	var tmpbyte, cntbyte, length;
	prep_blob(data, data.l || 0);
	var L = data.length, RT = 0, tgt = 0;
	while(data.l < L) {
		RT = data.read_shift(1);
		if(RT & 0x80) RT = (RT & 0x7F) + ((data.read_shift(1) & 0x7F)<<7);
		var R = XLSBRecordEnum[RT] || XLSBRecordEnum[0xFFFF];
		tmpbyte = data.read_shift(1);
		length = tmpbyte & 0x7F;
		for(cntbyte = 1; cntbyte <4 && (tmpbyte & 0x80); ++cntbyte) length += ((tmpbyte = data.read_shift(1)) & 0x7F)<<(7*cntbyte);
		tgt = data.l + length;
		var d = R.f && R.f(data, length, opts);
		data.l = tgt;
		if(cb(d, R, RT)) return;
	}
}

/* control buffer usage for fixed-length buffers */
function buf_array()/*:BufArray*/ {
	var bufs/*:Array<Block>*/ = [], blksz = has_buf ? 256 : 2048;
	var newblk = function ba_newblk(sz/*:number*/)/*:Block*/ {
		var o/*:Block*/ = (new_buf(sz)/*:any*/);
		prep_blob(o, 0);
		return o;
	};

	var curbuf/*:Block*/ = newblk(blksz);

	var endbuf = function ba_endbuf() {
		if(!curbuf) return;
		if(curbuf.length > curbuf.l) { curbuf = curbuf.slice(0, curbuf.l); curbuf.l = curbuf.length; }
		if(curbuf.length > 0) bufs.push(curbuf);
		curbuf = null;
	};

	var next = function ba_next(sz/*:number*/)/*:Block*/ {
		if(curbuf && (sz < (curbuf.length - curbuf.l))) return curbuf;
		endbuf();
		return (curbuf = newblk(Math.max(sz+1, blksz)));
	};

	var end = function ba_end() {
		endbuf();
		return bconcat(bufs);
	};

	var push = function ba_push(buf) { endbuf(); curbuf = buf; if(curbuf.l == null) curbuf.l = curbuf.length; next(blksz); };

	return ({ next:next, push:push, end:end, _bufs:bufs }/*:any*/);
}

function write_record(ba/*:BufArray*/, type/*:number*/, payload, length/*:?number*/) {
	var t/*:number*/ = +type, l;
	if(isNaN(t)) return; // TODO: throw something here?
	if(!length) length = XLSBRecordEnum[t].p || (payload||[]).length || 0;
	l = 1 + (t >= 0x80 ? 1 : 0) + 1/* + length*/;
	if(length >= 0x80) ++l; if(length >= 0x4000) ++l; if(length >= 0x200000) ++l;
	var o = ba.next(l);
	if(t <= 0x7F) o.write_shift(1, t);
	else {
		o.write_shift(1, (t & 0x7F) + 0x80);
		o.write_shift(1, (t >> 7));
	}
	for(var i = 0; i != 4; ++i) {
		if(length >= 0x80) { o.write_shift(1, (length & 0x7F)+0x80); length >>= 7; }
		else { o.write_shift(1, length); break; }
	}
	if(/*:: length != null &&*/length > 0 && is_buf(payload)) ba.push(payload);
}
/* XLS ranges enforced */
function shift_cell_xls(cell/*:CellAddress*/, tgt/*:any*/, opts/*:?any*/)/*:CellAddress*/ {
	var out = dup(cell);
	if(tgt.s) {
		if(out.cRel) out.c += tgt.s.c;
		if(out.rRel) out.r += tgt.s.r;
	} else {
		if(out.cRel) out.c += tgt.c;
		if(out.rRel) out.r += tgt.r;
	}
	if(!opts || opts.biff < 12) {
		while(out.c >= 0x100) out.c -= 0x100;
		while(out.r >= 0x10000) out.r -= 0x10000;
	}
	return out;
}

function shift_range_xls(cell, range, opts) {
	var out = dup(cell);
	out.s = shift_cell_xls(out.s, range.s, opts);
	out.e = shift_cell_xls(out.e, range.s, opts);
	return out;
}

function encode_cell_xls(c/*:CellAddress*/, biff/*:number*/)/*:string*/ {
	if(c.cRel && c.c < 0) { c = dup(c); while(c.c < 0) c.c += (biff > 8) ? 0x4000 : 0x100; }
	if(c.rRel && c.r < 0) { c = dup(c); while(c.r < 0) c.r += (biff > 8) ? 0x100000 : ((biff > 5) ? 0x10000 : 0x4000); }
	var s = encode_cell(c);
	if(!c.cRel && c.cRel != null) s = fix_col(s);
	if(!c.rRel && c.rRel != null) s = fix_row(s);
	return s;
}

function encode_range_xls(r, opts)/*:string*/ {
	if(r.s.r == 0 && !r.s.rRel) {
		if(r.e.r == (opts.biff >= 12 ? 0xFFFFF : (opts.biff >= 8 ? 0x10000 : 0x4000)) && !r.e.rRel) {
			return (r.s.cRel ? "" : "$") + encode_col(r.s.c) + ":" + (r.e.cRel ? "" : "$") + encode_col(r.e.c);
		}
	}
	if(r.s.c == 0 && !r.s.cRel) {
		if(r.e.c == (opts.biff >= 12 ? 0x3FFF : 0xFF) && !r.e.cRel) {
			return (r.s.rRel ? "" : "$") + encode_row(r.s.r) + ":" + (r.e.rRel ? "" : "$") + encode_row(r.e.r);
		}
	}
	return encode_cell_xls(r.s, opts.biff) + ":" + encode_cell_xls(r.e, opts.biff);
}
function decode_row(rowstr/*:string*/)/*:number*/ { return parseInt(unfix_row(rowstr),10) - 1; }
function encode_row(row/*:number*/)/*:string*/ { return "" + (row + 1); }
function fix_row(cstr/*:string*/)/*:string*/ { return cstr.replace(/([A-Z]|^)(\d+)$/,"$1$$$2"); }
function unfix_row(cstr/*:string*/)/*:string*/ { return cstr.replace(/\$(\d+)$/,"$1"); }

function decode_col(colstr/*:string*/)/*:number*/ { var c = unfix_col(colstr), d = 0, i = 0; for(; i !== c.length; ++i) d = 26*d + c.charCodeAt(i) - 64; return d - 1; }
function encode_col(col/*:number*/)/*:string*/ { if(col < 0) throw new Error("invalid column " + col); var s=""; for(++col; col; col=Math.floor((col-1)/26)) s = String.fromCharCode(((col-1)%26) + 65) + s; return s; }
function fix_col(cstr/*:string*/)/*:string*/ { return cstr.replace(/^([A-Z])/,"$$$1"); }
function unfix_col(cstr/*:string*/)/*:string*/ { return cstr.replace(/^\$([A-Z])/,"$1"); }

function split_cell(cstr/*:string*/)/*:Array<string>*/ { return cstr.replace(/(\$?[A-Z]*)(\$?\d*)/,"$1,$2").split(","); }
//function decode_cell(cstr/*:string*/)/*:CellAddress*/ { var splt = split_cell(cstr); return { c:decode_col(splt[0]), r:decode_row(splt[1]) }; }
function decode_cell(cstr/*:string*/)/*:CellAddress*/ {
	var R = 0, C = 0;
	for(var i = 0; i < cstr.length; ++i) {
		var cc = cstr.charCodeAt(i);
		if(cc >= 48 && cc <= 57) R = 10 * R + (cc - 48);
		else if(cc >= 65 && cc <= 90) C = 26 * C + (cc - 64);
	}
	return { c: C - 1, r:R - 1 };
}
//function encode_cell(cell/*:CellAddress*/)/*:string*/ { return encode_col(cell.c) + encode_row(cell.r); }
function encode_cell(cell/*:CellAddress*/)/*:string*/ {
	var col = cell.c + 1;
	var s="";
	for(; col; col=((col-1)/26)|0) s = String.fromCharCode(((col-1)%26) + 65) + s;
	return s + (cell.r + 1);
}
function decode_range(range/*:string*/)/*:Range*/ {
	var idx = range.indexOf(":");
	if(idx == -1) return { s: decode_cell(range), e: decode_cell(range) };
	return { s: decode_cell(range.slice(0, idx)), e: decode_cell(range.slice(idx + 1)) };
}
/*# if only one arg, it is assumed to be a Range.  If 2 args, both are cell addresses */
function encode_range(cs/*:CellAddrSpec|Range*/,ce/*:?CellAddrSpec*/)/*:string*/ {
	if(typeof ce === 'undefined' || typeof ce === 'number') {
/*:: if(!(cs instanceof Range)) throw "unreachable"; */
		return encode_range(cs.s, cs.e);
	}
/*:: if((cs instanceof Range)) throw "unreachable"; */
	if(typeof cs !== 'string') cs = encode_cell((cs/*:any*/));
	if(typeof ce !== 'string') ce = encode_cell((ce/*:any*/));
/*:: if(typeof cs !== 'string') throw "unreachable"; */
/*:: if(typeof ce !== 'string') throw "unreachable"; */
	return cs == ce ? cs : cs + ":" + ce;
}

function safe_decode_range(range/*:string*/)/*:Range*/ {
	var o = {s:{c:0,r:0},e:{c:0,r:0}};
	var idx = 0, i = 0, cc = 0;
	var len = range.length;
	for(idx = 0; i < len; ++i) {
		if((cc=range.charCodeAt(i)-64) < 1 || cc > 26) break;
		idx = 26*idx + cc;
	}
	o.s.c = --idx;

	for(idx = 0; i < len; ++i) {
		if((cc=range.charCodeAt(i)-48) < 0 || cc > 9) break;
		idx = 10*idx + cc;
	}
	o.s.r = --idx;

	if(i === len || cc != 10) { o.e.c=o.s.c; o.e.r=o.s.r; return o; }
	++i;

	for(idx = 0; i != len; ++i) {
		if((cc=range.charCodeAt(i)-64) < 1 || cc > 26) break;
		idx = 26*idx + cc;
	}
	o.e.c = --idx;

	for(idx = 0; i != len; ++i) {
		if((cc=range.charCodeAt(i)-48) < 0 || cc > 9) break;
		idx = 10*idx + cc;
	}
	o.e.r = --idx;
	return o;
}

function safe_format_cell(cell/*:Cell*/, v/*:any*/) {
	var q = (cell.t == 'd' && v instanceof Date);
	if(cell.z != null) try { return (cell.w = SSF_format(cell.z, q ? datenum(v) : v)); } catch(e) { }
	try { return (cell.w = SSF_format((cell.XF||{}).numFmtId||(q ? 14 : 0),  q ? datenum(v) : v)); } catch(e) { return ''+v; }
}

function format_cell(cell/*:Cell*/, v/*:any*/, o/*:any*/) {
	if(cell == null || cell.t == null || cell.t == 'z') return "";
	if(cell.w !== undefined) return cell.w;
	if(cell.t == 'd' && !cell.z && o && o.dateNF) cell.z = o.dateNF;
	if(cell.t == "e") return BErr[cell.v] || cell.v;
	if(v == undefined) return safe_format_cell(cell, cell.v);
	return safe_format_cell(cell, v);
}

function sheet_to_workbook(sheet/*:Worksheet*/, opts)/*:Workbook*/ {
	var n = opts && opts.sheet ? opts.sheet : "Sheet1";
	var sheets = {}; sheets[n] = sheet;
	return { SheetNames: [n], Sheets: sheets };
}

function sheet_add_aoa(_ws/*:?Worksheet*/, data/*:AOA*/, opts/*:?any*/)/*:Worksheet*/ {
	var o = opts || {};
	var dense = _ws ? Array.isArray(_ws) : o.dense;
	if(DENSE != null && dense == null) dense = DENSE;
	var ws/*:Worksheet*/ = _ws || (dense ? ([]/*:any*/) : ({}/*:any*/));
	var _R = 0, _C = 0;
	if(ws && o.origin != null) {
		if(typeof o.origin == 'number') _R = o.origin;
		else {
			var _origin/*:CellAddress*/ = typeof o.origin == "string" ? decode_cell(o.origin) : o.origin;
			_R = _origin.r; _C = _origin.c;
		}
		if(!ws["!ref"]) ws["!ref"] = "A1:A1";
	}
	var range/*:Range*/ = ({s: {c:10000000, r:10000000}, e: {c:0, r:0}}/*:any*/);
	if(ws['!ref']) {
		var _range = safe_decode_range(ws['!ref']);
		range.s.c = _range.s.c;
		range.s.r = _range.s.r;
		range.e.c = Math.max(range.e.c, _range.e.c);
		range.e.r = Math.max(range.e.r, _range.e.r);
		if(_R == -1) range.e.r = _R = _range.e.r + 1;
	}
	for(var R = 0; R != data.length; ++R) {
		if(!data[R]) continue;
		if(!Array.isArray(data[R])) throw new Error("aoa_to_sheet expects an array of arrays");
		for(var C = 0; C != data[R].length; ++C) {
			if(typeof data[R][C] === 'undefined') continue;
			var cell/*:Cell*/ = ({v: data[R][C] }/*:any*/);
			var __R = _R + R, __C = _C + C;
			if(range.s.r > __R) range.s.r = __R;
			if(range.s.c > __C) range.s.c = __C;
			if(range.e.r < __R) range.e.r = __R;
			if(range.e.c < __C) range.e.c = __C;
			if(data[R][C] && typeof data[R][C] === 'object' && !Array.isArray(data[R][C]) && !(data[R][C] instanceof Date)) cell = data[R][C];
			else {
				if(Array.isArray(cell.v)) { cell.f = data[R][C][1]; cell.v = cell.v[0]; }
				if(cell.v === null) {
					if(cell.f) cell.t = 'n';
					else if(o.nullError) { cell.t = 'e'; cell.v = 0; }
					else if(!o.sheetStubs) continue;
					else cell.t = 'z';
				}
				else if(typeof cell.v === 'number') cell.t = 'n';
				else if(typeof cell.v === 'boolean') cell.t = 'b';
				else if(cell.v instanceof Date) {
					cell.z = o.dateNF || table_fmt[14];
					if(o.cellDates) { cell.t = 'd'; cell.w = SSF_format(cell.z, datenum(cell.v)); }
					else { cell.t = 'n'; cell.v = datenum(cell.v); cell.w = SSF_format(cell.z, cell.v); }
				}
				else cell.t = 's';
			}
			if(dense) {
				if(!ws[__R]) ws[__R] = [];
				if(ws[__R][__C] && ws[__R][__C].z) cell.z = ws[__R][__C].z;
				ws[__R][__C] = cell;
			} else {
				var cell_ref = encode_cell(({c:__C,r:__R}/*:any*/));
				if(ws[cell_ref] && ws[cell_ref].z) cell.z = ws[cell_ref].z;
				ws[cell_ref] = cell;
			}
		}
	}
	if(range.s.c < 10000000) ws['!ref'] = encode_range(range);
	return ws;
}
function aoa_to_sheet(data/*:AOA*/, opts/*:?any*/)/*:Worksheet*/ { return sheet_add_aoa(null, data, opts); }

function parse_Int32LE(data) {
	return data.read_shift(4, 'i');
}
function write_UInt32LE(x/*:number*/, o) {
	if (!o) o = new_buf(4);
	o.write_shift(4, x);
	return o;
}

/* [MS-XLSB] 2.5.168 */
function parse_XLWideString(data/*::, length*/)/*:string*/ {
	var cchCharacters = data.read_shift(4);
	return cchCharacters === 0 ? "" : data.read_shift(cchCharacters, 'dbcs');
}
function write_XLWideString(data/*:string*/, o) {
	var _null = false; if (o == null) { _null = true; o = new_buf(4 + 2 * data.length); }
	o.write_shift(4, data.length);
	if (data.length > 0) o.write_shift(0, data, 'dbcs');
	return _null ? o.slice(0, o.l) : o;
}

/* [MS-XLSB] 2.5.91 */
//function parse_LPWideString(data/*::, length*/)/*:string*/ {
//	var cchCharacters = data.read_shift(2);
//	return cchCharacters === 0 ? "" : data.read_shift(cchCharacters, "utf16le");
//}

/* [MS-XLSB] 2.5.143 */
function parse_StrRun(data) {
	return { ich: data.read_shift(2), ifnt: data.read_shift(2) };
}
function write_StrRun(run, o) {
	if (!o) o = new_buf(4);
	o.write_shift(2, run.ich || 0);
	o.write_shift(2, run.ifnt || 0);
	return o;
}

/* [MS-XLSB] 2.5.121 */
function parse_RichStr(data, length/*:number*/)/*:XLString*/ {
	var start = data.l;
	var flags = data.read_shift(1);
	var str = parse_XLWideString(data);
	var rgsStrRun = [];
	var z = ({ t: str, h: str }/*:any*/);
	if ((flags & 1) !== 0) { /* fRichStr */
		/* TODO: formatted string */
		var dwSizeStrRun = data.read_shift(4);
		for (var i = 0; i != dwSizeStrRun; ++i) rgsStrRun.push(parse_StrRun(data));
		z.r = rgsStrRun;
	}
	else z.r = [{ ich: 0, ifnt: 0 }];
	//if((flags & 2) !== 0) { /* fExtStr */
	//	/* TODO: phonetic string */
	//}
	data.l = start + length;
	return z;
}
function write_RichStr(str/*:XLString*/, o/*:?Block*/)/*:Block*/ {
	/* TODO: formatted string */
	var _null = false; if (o == null) { _null = true; o = new_buf(15 + 4 * str.t.length); }
	o.write_shift(1, 0);
	write_XLWideString(str.t, o);
	return _null ? o.slice(0, o.l) : o;
}
/* [MS-XLSB] 2.4.328 BrtCommentText (RichStr w/1 run) */
var parse_BrtCommentText = parse_RichStr;
function write_BrtCommentText(str/*:XLString*/, o/*:?Block*/)/*:Block*/ {
	/* TODO: formatted string */
	var _null = false; if (o == null) { _null = true; o = new_buf(23 + 4 * str.t.length); }
	o.write_shift(1, 1);
	write_XLWideString(str.t, o);
	o.write_shift(4, 1);
	write_StrRun({ ich: 0, ifnt: 0 }, o);
	return _null ? o.slice(0, o.l) : o;
}

/* [MS-XLSB] 2.5.9 */
function parse_XLSBCell(data)/*:any*/ {
	var col = data.read_shift(4);
	var iStyleRef = data.read_shift(2);
	iStyleRef += data.read_shift(1) << 16;
	data.l++; //var fPhShow = data.read_shift(1);
	return { c: col, iStyleRef: iStyleRef };
}
function write_XLSBCell(cell/*:any*/, o/*:?Block*/) {
	if (o == null) o = new_buf(8);
	o.write_shift(-4, cell.c);
	o.write_shift(3, cell.iStyleRef || cell.s);
	o.write_shift(1, 0); /* fPhShow */
	return o;
}

/* Short XLSB Cell does not include column */
function parse_XLSBShortCell(data)/*:any*/ {
	var iStyleRef = data.read_shift(2);
	iStyleRef += data.read_shift(1) <<16;
	data.l++; //var fPhShow = data.read_shift(1);
	return { c:-1, iStyleRef: iStyleRef };
}
function write_XLSBShortCell(cell/*:any*/, o/*:?Block*/) {
	if(o == null) o = new_buf(4);
	o.write_shift(3, cell.iStyleRef || cell.s);
	o.write_shift(1, 0); /* fPhShow */
	return o;
}

/* [MS-XLSB] 2.5.21 */
var parse_XLSBCodeName = parse_XLWideString;
var write_XLSBCodeName = write_XLWideString;

/* [MS-XLSB] 2.5.166 */
function parse_XLNullableWideString(data/*::, length*/)/*:string*/ {
	var cchCharacters = data.read_shift(4);
	return cchCharacters === 0 || cchCharacters === 0xFFFFFFFF ? "" : data.read_shift(cchCharacters, 'dbcs');
}
function write_XLNullableWideString(data/*:string*/, o) {
	var _null = false; if (o == null) { _null = true; o = new_buf(127); }
	o.write_shift(4, data.length > 0 ? data.length : 0xFFFFFFFF);
	if (data.length > 0) o.write_shift(0, data, 'dbcs');
	return _null ? o.slice(0, o.l) : o;
}

/* [MS-XLSB] 2.5.165 */
var parse_XLNameWideString = parse_XLWideString;
//var write_XLNameWideString = write_XLWideString;

/* [MS-XLSB] 2.5.114 */
var parse_RelID = parse_XLNullableWideString;
var write_RelID = write_XLNullableWideString;


/* [MS-XLS] 2.5.217 ; [MS-XLSB] 2.5.122 */
function parse_RkNumber(data)/*:number*/ {
	var b = data.slice(data.l, data.l + 4);
	var fX100 = (b[0] & 1), fInt = (b[0] & 2);
	data.l += 4;
	var RK = fInt === 0 ? __double([0, 0, 0, 0, (b[0] & 0xFC), b[1], b[2], b[3]], 0) : __readInt32LE(b, 0) >> 2;
	return fX100 ? (RK / 100) : RK;
}
function write_RkNumber(data/*:number*/, o) {
	if (o == null) o = new_buf(4);
	var fX100 = 0, fInt = 0, d100 = data * 100;
	if ((data == (data | 0)) && (data >= -(1 << 29)) && (data < (1 << 29))) { fInt = 1; }
	else if ((d100 == (d100 | 0)) && (d100 >= -(1 << 29)) && (d100 < (1 << 29))) { fInt = 1; fX100 = 1; }
	if (fInt) o.write_shift(-4, ((fX100 ? d100 : data) << 2) + (fX100 + 2));
	else throw new Error("unsupported RkNumber " + data); // TODO
}


/* [MS-XLSB] 2.5.117 RfX */
function parse_RfX(data /*::, length*/)/*:Range*/ {
	var cell/*:Range*/ = ({ s: {}, e: {} }/*:any*/);
	cell.s.r = data.read_shift(4);
	cell.e.r = data.read_shift(4);
	cell.s.c = data.read_shift(4);
	cell.e.c = data.read_shift(4);
	return cell;
}
function write_RfX(r/*:Range*/, o) {
	if (!o) o = new_buf(16);
	o.write_shift(4, r.s.r);
	o.write_shift(4, r.e.r);
	o.write_shift(4, r.s.c);
	o.write_shift(4, r.e.c);
	return o;
}

/* [MS-XLSB] 2.5.153 UncheckedRfX */
var parse_UncheckedRfX = parse_RfX;
var write_UncheckedRfX = write_RfX;

/* [MS-XLSB] 2.5.155 UncheckedSqRfX */
//function parse_UncheckedSqRfX(data) {
//	var cnt = data.read_shift(4);
//	var out = [];
//	for(var i = 0; i < cnt; ++i) {
//		var rng = parse_UncheckedRfX(data);
//		out.push(encode_range(rng));
//	}
//	return out.join(",");
//}
//function write_UncheckedSqRfX(sqrfx/*:string*/) {
//	var parts = sqrfx.split(/\s*,\s*/);
//	var o = new_buf(4); o.write_shift(4, parts.length);
//	var out = [o];
//	parts.forEach(function(rng) {
//		out.push(write_UncheckedRfX(safe_decode_range(rng)));
//	});
//	return bconcat(out);
//}

/* [MS-XLS] 2.5.342 ; [MS-XLSB] 2.5.171 */
/* TODO: error checking, NaN and Infinity values are not valid Xnum */
function parse_Xnum(data/*::, length*/) {
	if(data.length - data.l < 8) throw "XLS Xnum Buffer underflow";
	return data.read_shift(8, 'f');
}
function write_Xnum(data, o) { return (o || new_buf(8)).write_shift(8, data, 'f'); }

/* [MS-XLSB] 2.4.324 BrtColor */
function parse_BrtColor(data/*::, length*/) {
	var out = {};
	var d = data.read_shift(1);

	//var fValidRGB = d & 1;
	var xColorType = d >>> 1;

	var index = data.read_shift(1);
	var nTS = data.read_shift(2, 'i');
	var bR = data.read_shift(1);
	var bG = data.read_shift(1);
	var bB = data.read_shift(1);
	data.l++; //var bAlpha = data.read_shift(1);

	switch (xColorType) {
		case 0: out.auto = 1; break;
		case 1:
			out.index = index;
			var icv = XLSIcv[index];
			/* automatic pseudo index 81 */
			if (icv) out.rgb = rgb2Hex(icv);
			break;
		case 2:
			/* if(!fValidRGB) throw new Error("invalid"); */
			out.rgb = rgb2Hex([bR, bG, bB]);
			break;
		case 3: out.theme = index; break;
	}
	if (nTS != 0) out.tint = nTS > 0 ? nTS / 32767 : nTS / 32768;

	return out;
}
function write_BrtColor(color, o) {
	if (!o) o = new_buf(8);
	if (!color || color.auto) { o.write_shift(4, 0); o.write_shift(4, 0); return o; }
	if (color.index != null) {
		o.write_shift(1, 0x02);
		o.write_shift(1, color.index);
	} else if (color.theme != null) {
		o.write_shift(1, 0x06);
		o.write_shift(1, color.theme);
	} else {
		o.write_shift(1, 0x05);
		o.write_shift(1, 0);
	}
	var nTS = color.tint || 0;
	if (nTS > 0) nTS *= 32767;
	else if (nTS < 0) nTS *= 32768;
	o.write_shift(2, nTS);
	if (!color.rgb || color.theme != null) {
		o.write_shift(2, 0);
		o.write_shift(1, 0);
		o.write_shift(1, 0);
	} else {
		var rgb = (color.rgb || 'FFFFFF');
		if (typeof rgb == 'number') rgb = ("000000" + rgb.toString(16)).slice(-6);
		o.write_shift(1, parseInt(rgb.slice(0, 2), 16));
		o.write_shift(1, parseInt(rgb.slice(2, 4), 16));
		o.write_shift(1, parseInt(rgb.slice(4, 6), 16));
		o.write_shift(1, 0xFF);
	}
	return o;
}

/* [MS-XLSB] 2.5.52 */
function parse_FontFlags(data/*::, length, opts*/) {
	var d = data.read_shift(1);
	data.l++;
	var out = {
		fBold: d & 0x01,
		fItalic: d & 0x02,
		fUnderline: d & 0x04,
		fStrikeout: d & 0x08,
		fOutline: d & 0x10,
		fShadow: d & 0x20,
		fCondense: d & 0x40,
		fExtend: d & 0x80
	};
	return out;
}
function write_FontFlags(font, o) {
	if (!o) o = new_buf(2);
	var grbit =
		(font.italic ? 0x02 : 0) |
		(font.strike ? 0x08 : 0) |
		(font.outline ? 0x10 : 0) |
		(font.shadow ? 0x20 : 0) |
		(font.condense ? 0x40 : 0) |
		(font.extend ? 0x80 : 0);
	o.write_shift(1, grbit);
	o.write_shift(1, 0);
	return o;
}

/* [MS-OLEDS] 2.3.1 and 2.3.2 */
function parse_ClipboardFormatOrString(o, w/*:number*/)/*:string*/ {
	// $FlowIgnore
	var ClipFmt = { 2: "BITMAP", 3: "METAFILEPICT", 8: "DIB", 14: "ENHMETAFILE" };
	var m/*:number*/ = o.read_shift(4);
	switch (m) {
		case 0x00000000: return "";
		case 0xffffffff: case 0xfffffffe: return ClipFmt[o.read_shift(4)] || "";
	}
	if (m > 0x190) throw new Error("Unsupported Clipboard: " + m.toString(16));
	o.l -= 4;
	return o.read_shift(0, w == 1 ? "lpstr" : "lpwstr");
}
function parse_ClipboardFormatOrAnsiString(o) { return parse_ClipboardFormatOrString(o, 1); }
function parse_ClipboardFormatOrUnicodeString(o) { return parse_ClipboardFormatOrString(o, 2); }

/* [MS-OLEPS] 2.2 PropertyType */
// Note: some tree shakers cannot handle VT_VECTOR | $CONST, hence extra vars
//var VT_EMPTY    = 0x0000;
//var VT_NULL     = 0x0001;
var VT_I2       = 0x0002;
var VT_I4       = 0x0003;
//var VT_R4       = 0x0004;
//var VT_R8       = 0x0005;
//var VT_CY       = 0x0006;
//var VT_DATE     = 0x0007;
//var VT_BSTR     = 0x0008;
//var VT_ERROR    = 0x000A;
var VT_BOOL     = 0x000B;
var VT_VARIANT  = 0x000C;
//var VT_DECIMAL  = 0x000E;
//var VT_I1       = 0x0010;
//var VT_UI1      = 0x0011;
//var VT_UI2      = 0x0012;
var VT_UI4      = 0x0013;
//var VT_I8       = 0x0014;
//var VT_UI8      = 0x0015;
//var VT_INT      = 0x0016;
//var VT_UINT     = 0x0017;
var VT_LPSTR    = 0x001E;
//var VT_LPWSTR   = 0x001F;
var VT_FILETIME = 0x0040;
var VT_BLOB     = 0x0041;
//var VT_STREAM   = 0x0042;
//var VT_STORAGE  = 0x0043;
//var VT_STREAMED_Object  = 0x0044;
//var VT_STORED_Object    = 0x0045;
//var VT_BLOB_Object      = 0x0046;
var VT_CF       = 0x0047;
//var VT_CLSID    = 0x0048;
//var VT_VERSIONED_STREAM = 0x0049;
var VT_VECTOR   = 0x1000;
var VT_VECTOR_VARIANT = 0x100C;
var VT_VECTOR_LPSTR   = 0x101E;
//var VT_ARRAY    = 0x2000;

var VT_STRING   = 0x0050; // 2.3.3.1.11 VtString
var VT_USTR     = 0x0051; // 2.3.3.1.12 VtUnalignedString
var VT_CUSTOM   = [VT_STRING, VT_USTR];

/* [MS-OSHARED] 2.3.3.2.2.1 Document Summary Information PIDDSI */
var DocSummaryPIDDSI = {
	/*::[*/0x01/*::]*/: { n: 'CodePage', t: VT_I2 },
	/*::[*/0x02/*::]*/: { n: 'Category', t: VT_STRING },
	/*::[*/0x03/*::]*/: { n: 'PresentationFormat', t: VT_STRING },
	/*::[*/0x04/*::]*/: { n: 'ByteCount', t: VT_I4 },
	/*::[*/0x05/*::]*/: { n: 'LineCount', t: VT_I4 },
	/*::[*/0x06/*::]*/: { n: 'ParagraphCount', t: VT_I4 },
	/*::[*/0x07/*::]*/: { n: 'SlideCount', t: VT_I4 },
	/*::[*/0x08/*::]*/: { n: 'NoteCount', t: VT_I4 },
	/*::[*/0x09/*::]*/: { n: 'HiddenCount', t: VT_I4 },
	/*::[*/0x0a/*::]*/: { n: 'MultimediaClipCount', t: VT_I4 },
	/*::[*/0x0b/*::]*/: { n: 'ScaleCrop', t: VT_BOOL },
	/*::[*/0x0c/*::]*/: { n: 'HeadingPairs', t: VT_VECTOR_VARIANT /* VT_VECTOR | VT_VARIANT */ },
	/*::[*/0x0d/*::]*/: { n: 'TitlesOfParts', t: VT_VECTOR_LPSTR /* VT_VECTOR | VT_LPSTR */ },
	/*::[*/0x0e/*::]*/: { n: 'Manager', t: VT_STRING },
	/*::[*/0x0f/*::]*/: { n: 'Company', t: VT_STRING },
	/*::[*/0x10/*::]*/: { n: 'LinksUpToDate', t: VT_BOOL },
	/*::[*/0x11/*::]*/: { n: 'CharacterCount', t: VT_I4 },
	/*::[*/0x13/*::]*/: { n: 'SharedDoc', t: VT_BOOL },
	/*::[*/0x16/*::]*/: { n: 'HyperlinksChanged', t: VT_BOOL },
	/*::[*/0x17/*::]*/: { n: 'AppVersion', t: VT_I4, p: 'version' },
	/*::[*/0x18/*::]*/: { n: 'DigSig', t: VT_BLOB },
	/*::[*/0x1A/*::]*/: { n: 'ContentType', t: VT_STRING },
	/*::[*/0x1B/*::]*/: { n: 'ContentStatus', t: VT_STRING },
	/*::[*/0x1C/*::]*/: { n: 'Language', t: VT_STRING },
	/*::[*/0x1D/*::]*/: { n: 'Version', t: VT_STRING },
	/*::[*/0xFF/*::]*/: {},
	/* [MS-OLEPS] 2.18 */
	/*::[*/0x80000000/*::]*/: { n: 'Locale', t: VT_UI4 },
	/*::[*/0x80000003/*::]*/: { n: 'Behavior', t: VT_UI4 },
	/*::[*/0x72627262/*::]*/: {}
};

/* [MS-OSHARED] 2.3.3.2.1.1 Summary Information Property Set PIDSI */
var SummaryPIDSI = {
	/*::[*/0x01/*::]*/: { n: 'CodePage', t: VT_I2 },
	/*::[*/0x02/*::]*/: { n: 'Title', t: VT_STRING },
	/*::[*/0x03/*::]*/: { n: 'Subject', t: VT_STRING },
	/*::[*/0x04/*::]*/: { n: 'Author', t: VT_STRING },
	/*::[*/0x05/*::]*/: { n: 'Keywords', t: VT_STRING },
	/*::[*/0x06/*::]*/: { n: 'Comments', t: VT_STRING },
	/*::[*/0x07/*::]*/: { n: 'Template', t: VT_STRING },
	/*::[*/0x08/*::]*/: { n: 'LastAuthor', t: VT_STRING },
	/*::[*/0x09/*::]*/: { n: 'RevNumber', t: VT_STRING },
	/*::[*/0x0A/*::]*/: { n: 'EditTime', t: VT_FILETIME },
	/*::[*/0x0B/*::]*/: { n: 'LastPrinted', t: VT_FILETIME },
	/*::[*/0x0C/*::]*/: { n: 'CreatedDate', t: VT_FILETIME },
	/*::[*/0x0D/*::]*/: { n: 'ModifiedDate', t: VT_FILETIME },
	/*::[*/0x0E/*::]*/: { n: 'PageCount', t: VT_I4 },
	/*::[*/0x0F/*::]*/: { n: 'WordCount', t: VT_I4 },
	/*::[*/0x10/*::]*/: { n: 'CharCount', t: VT_I4 },
	/*::[*/0x11/*::]*/: { n: 'Thumbnail', t: VT_CF },
	/*::[*/0x12/*::]*/: { n: 'Application', t: VT_STRING },
	/*::[*/0x13/*::]*/: { n: 'DocSecurity', t: VT_I4 },
	/*::[*/0xFF/*::]*/: {},
	/* [MS-OLEPS] 2.18 */
	/*::[*/0x80000000/*::]*/: { n: 'Locale', t: VT_UI4 },
	/*::[*/0x80000003/*::]*/: { n: 'Behavior', t: VT_UI4 },
	/*::[*/0x72627262/*::]*/: {}
};

/* [MS-XLS] 2.4.63 Country/Region codes */
var CountryEnum = {
	/*::[*/0x0001/*::]*/: "US", // United States
	/*::[*/0x0002/*::]*/: "CA", // Canada
	/*::[*/0x0003/*::]*/: "", // Latin America (except Brazil)
	/*::[*/0x0007/*::]*/: "RU", // Russia
	/*::[*/0x0014/*::]*/: "EG", // Egypt
	/*::[*/0x001E/*::]*/: "GR", // Greece
	/*::[*/0x001F/*::]*/: "NL", // Netherlands
	/*::[*/0x0020/*::]*/: "BE", // Belgium
	/*::[*/0x0021/*::]*/: "FR", // France
	/*::[*/0x0022/*::]*/: "ES", // Spain
	/*::[*/0x0024/*::]*/: "HU", // Hungary
	/*::[*/0x0027/*::]*/: "IT", // Italy
	/*::[*/0x0029/*::]*/: "CH", // Switzerland
	/*::[*/0x002B/*::]*/: "AT", // Austria
	/*::[*/0x002C/*::]*/: "GB", // United Kingdom
	/*::[*/0x002D/*::]*/: "DK", // Denmark
	/*::[*/0x002E/*::]*/: "SE", // Sweden
	/*::[*/0x002F/*::]*/: "NO", // Norway
	/*::[*/0x0030/*::]*/: "PL", // Poland
	/*::[*/0x0031/*::]*/: "DE", // Germany
	/*::[*/0x0034/*::]*/: "MX", // Mexico
	/*::[*/0x0037/*::]*/: "BR", // Brazil
	/*::[*/0x003d/*::]*/: "AU", // Australia
	/*::[*/0x0040/*::]*/: "NZ", // New Zealand
	/*::[*/0x0042/*::]*/: "TH", // Thailand
	/*::[*/0x0051/*::]*/: "JP", // Japan
	/*::[*/0x0052/*::]*/: "KR", // Korea
	/*::[*/0x0054/*::]*/: "VN", // Viet Nam
	/*::[*/0x0056/*::]*/: "CN", // China
	/*::[*/0x005A/*::]*/: "TR", // Turkey
	/*::[*/0x0069/*::]*/: "JS", // Ramastan
	/*::[*/0x00D5/*::]*/: "DZ", // Algeria
	/*::[*/0x00D8/*::]*/: "MA", // Morocco
	/*::[*/0x00DA/*::]*/: "LY", // Libya
	/*::[*/0x015F/*::]*/: "PT", // Portugal
	/*::[*/0x0162/*::]*/: "IS", // Iceland
	/*::[*/0x0166/*::]*/: "FI", // Finland
	/*::[*/0x01A4/*::]*/: "CZ", // Czech Republic
	/*::[*/0x0376/*::]*/: "TW", // Taiwan
	/*::[*/0x03C1/*::]*/: "LB", // Lebanon
	/*::[*/0x03C2/*::]*/: "JO", // Jordan
	/*::[*/0x03C3/*::]*/: "SY", // Syria
	/*::[*/0x03C4/*::]*/: "IQ", // Iraq
	/*::[*/0x03C5/*::]*/: "KW", // Kuwait
	/*::[*/0x03C6/*::]*/: "SA", // Saudi Arabia
	/*::[*/0x03CB/*::]*/: "AE", // United Arab Emirates
	/*::[*/0x03CC/*::]*/: "IL", // Israel
	/*::[*/0x03CE/*::]*/: "QA", // Qatar
	/*::[*/0x03D5/*::]*/: "IR", // Iran
	/*::[*/0xFFFF/*::]*/: "US"  // United States
};

/* [MS-XLS] 2.5.127 */
var XLSFillPattern = [
	null,
	'solid',
	'mediumGray',
	'darkGray',
	'lightGray',
	'darkHorizontal',
	'darkVertical',
	'darkDown',
	'darkUp',
	'darkGrid',
	'darkTrellis',
	'lightHorizontal',
	'lightVertical',
	'lightDown',
	'lightUp',
	'lightGrid',
	'lightTrellis',
	'gray125',
	'gray0625'
];

function rgbify(arr/*:Array<number>*/)/*:Array<[number, number, number]>*/ { return arr.map(function(x) { return [(x>>16)&255,(x>>8)&255,x&255]; }); }

/* [MS-XLS] 2.5.161 */
/* [MS-XLSB] 2.5.75 Icv */
var _XLSIcv = /*#__PURE__*/ rgbify([
	/* Color Constants */
	0x000000,
	0xFFFFFF,
	0xFF0000,
	0x00FF00,
	0x0000FF,
	0xFFFF00,
	0xFF00FF,
	0x00FFFF,

	/* Overridable Defaults */
	0x000000,
	0xFFFFFF,
	0xFF0000,
	0x00FF00,
	0x0000FF,
	0xFFFF00,
	0xFF00FF,
	0x00FFFF,

	0x800000,
	0x008000,
	0x000080,
	0x808000,
	0x800080,
	0x008080,
	0xC0C0C0,
	0x808080,
	0x9999FF,
	0x993366,
	0xFFFFCC,
	0xCCFFFF,
	0x660066,
	0xFF8080,
	0x0066CC,
	0xCCCCFF,

	0x000080,
	0xFF00FF,
	0xFFFF00,
	0x00FFFF,
	0x800080,
	0x800000,
	0x008080,
	0x0000FF,
	0x00CCFF,
	0xCCFFFF,
	0xCCFFCC,
	0xFFFF99,
	0x99CCFF,
	0xFF99CC,
	0xCC99FF,
	0xFFCC99,

	0x3366FF,
	0x33CCCC,
	0x99CC00,
	0xFFCC00,
	0xFF9900,
	0xFF6600,
	0x666699,
	0x969696,
	0x003366,
	0x339966,
	0x003300,
	0x333300,
	0x993300,
	0x993366,
	0x333399,
	0x333333,

	/* Other entries to appease BIFF8/12 */
	0xFFFFFF, /* 0x40 icvForeground ?? */
	0x000000, /* 0x41 icvBackground ?? */
	0x000000, /* 0x42 icvFrame ?? */
	0x000000, /* 0x43 icv3D ?? */
	0x000000, /* 0x44 icv3DText ?? */
	0x000000, /* 0x45 icv3DHilite ?? */
	0x000000, /* 0x46 icv3DShadow ?? */
	0x000000, /* 0x47 icvHilite ?? */
	0x000000, /* 0x48 icvCtlText ?? */
	0x000000, /* 0x49 icvCtlScrl ?? */
	0x000000, /* 0x4A icvCtlInv ?? */
	0x000000, /* 0x4B icvCtlBody ?? */
	0x000000, /* 0x4C icvCtlFrame ?? */
	0x000000, /* 0x4D icvCtlFore ?? */
	0x000000, /* 0x4E icvCtlBack ?? */
	0x000000, /* 0x4F icvCtlNeutral */
	0x000000, /* 0x50 icvInfoBk ?? */
	0x000000 /* 0x51 icvInfoText ?? */
]);
var XLSIcv = /*#__PURE__*/dup(_XLSIcv);

/* [MS-XLSB] 2.5.97.2 */
var BErr = {
	/*::[*/0x00/*::]*/: "#NULL!",
	/*::[*/0x07/*::]*/: "#DIV/0!",
	/*::[*/0x0F/*::]*/: "#VALUE!",
	/*::[*/0x17/*::]*/: "#REF!",
	/*::[*/0x1D/*::]*/: "#NAME?",
	/*::[*/0x24/*::]*/: "#NUM!",
	/*::[*/0x2A/*::]*/: "#N/A",
	/*::[*/0x2B/*::]*/: "#GETTING_DATA",
	/*::[*/0xFF/*::]*/: "#WTF?"
};
//var RBErr = evert_num(BErr);
var RBErr = {
	"#NULL!":        0x00,
	"#DIV/0!":       0x07,
	"#VALUE!":       0x0F,
	"#REF!":         0x17,
	"#NAME?":        0x1D,
	"#NUM!":         0x24,
	"#N/A":          0x2A,
	"#GETTING_DATA": 0x2B,
	"#WTF?":         0xFF
};

/* Parts enumerated in OPC spec, MS-XLSB and MS-XLSX */
/* 12.3 Part Summary <SpreadsheetML> */
/* 14.2 Part Summary <DrawingML> */
/* [MS-XLSX] 2.1 Part Enumerations ; [MS-XLSB] 2.1.7 Part Enumeration */
var ct2type/*{[string]:string}*/ = ({
	/* Workbook */
	"application/vnd.openxmlformats-officedocument.spreadsheetml.sheet.main+xml": "workbooks",
	"application/vnd.ms-excel.sheet.macroEnabled.main+xml": "workbooks",
	"application/vnd.ms-excel.sheet.binary.macroEnabled.main": "workbooks",
	"application/vnd.ms-excel.addin.macroEnabled.main+xml": "workbooks",
	"application/vnd.openxmlformats-officedocument.spreadsheetml.template.main+xml": "workbooks",

	/* Worksheet */
	"application/vnd.openxmlformats-officedocument.spreadsheetml.worksheet+xml": "sheets",
	"application/vnd.ms-excel.worksheet": "sheets",
	"application/vnd.ms-excel.binIndexWs": "TODO", /* Binary Index */

	/* Chartsheet */
	"application/vnd.openxmlformats-officedocument.spreadsheetml.chartsheet+xml": "charts",
	"application/vnd.ms-excel.chartsheet": "charts",

	/* Macrosheet */
	"application/vnd.ms-excel.macrosheet+xml": "macros",
	"application/vnd.ms-excel.macrosheet": "macros",
	"application/vnd.ms-excel.intlmacrosheet": "TODO",
	"application/vnd.ms-excel.binIndexMs": "TODO", /* Binary Index */

	/* Dialogsheet */
	"application/vnd.openxmlformats-officedocument.spreadsheetml.dialogsheet+xml": "dialogs",
	"application/vnd.ms-excel.dialogsheet": "dialogs",

	/* Shared Strings */
	"application/vnd.openxmlformats-officedocument.spreadsheetml.sharedStrings+xml": "strs",
	"application/vnd.ms-excel.sharedStrings": "strs",

	/* Styles */
	"application/vnd.openxmlformats-officedocument.spreadsheetml.styles+xml": "styles",
	"application/vnd.ms-excel.styles": "styles",

	/* File Properties */
	"application/vnd.openxmlformats-package.core-properties+xml": "coreprops",
	"application/vnd.openxmlformats-officedocument.custom-properties+xml": "custprops",
	"application/vnd.openxmlformats-officedocument.extended-properties+xml": "extprops",

	/* Custom Data Properties */
	"application/vnd.openxmlformats-officedocument.customXmlProperties+xml": "TODO",
	"application/vnd.openxmlformats-officedocument.spreadsheetml.customProperty": "TODO",

	/* Comments */
	"application/vnd.openxmlformats-officedocument.spreadsheetml.comments+xml": "comments",
	"application/vnd.ms-excel.comments": "comments",
	"application/vnd.ms-excel.threadedcomments+xml": "threadedcomments",
	"application/vnd.ms-excel.person+xml": "people",

	/* Metadata (Stock/Geography and Dynamic Array) */
	"application/vnd.openxmlformats-officedocument.spreadsheetml.sheetMetadata+xml": "metadata",
	"application/vnd.ms-excel.sheetMetadata": "metadata",

	/* PivotTable */
	"application/vnd.ms-excel.pivotTable": "TODO",
	"application/vnd.openxmlformats-officedocument.spreadsheetml.pivotTable+xml": "TODO",

	/* Chart Objects */
	"application/vnd.openxmlformats-officedocument.drawingml.chart+xml": "TODO",

	/* Chart Colors */
	"application/vnd.ms-office.chartcolorstyle+xml": "TODO",

	/* Chart Style */
	"application/vnd.ms-office.chartstyle+xml": "TODO",

	/* Chart Advanced */
	"application/vnd.ms-office.chartex+xml": "TODO",

	/* Calculation Chain */
	"application/vnd.ms-excel.calcChain": "calcchains",
	"application/vnd.openxmlformats-officedocument.spreadsheetml.calcChain+xml": "calcchains",

	/* Printer Settings */
	"application/vnd.openxmlformats-officedocument.spreadsheetml.printerSettings": "TODO",

	/* ActiveX */
	"application/vnd.ms-office.activeX": "TODO",
	"application/vnd.ms-office.activeX+xml": "TODO",

	/* Custom Toolbars */
	"application/vnd.ms-excel.attachedToolbars": "TODO",

	/* External Data Connections */
	"application/vnd.ms-excel.connections": "TODO",
	"application/vnd.openxmlformats-officedocument.spreadsheetml.connections+xml": "TODO",

	/* External Links */
	"application/vnd.ms-excel.externalLink": "links",
	"application/vnd.openxmlformats-officedocument.spreadsheetml.externalLink+xml": "links",

	/* PivotCache */
	"application/vnd.ms-excel.pivotCacheDefinition": "TODO",
	"application/vnd.ms-excel.pivotCacheRecords": "TODO",
	"application/vnd.openxmlformats-officedocument.spreadsheetml.pivotCacheDefinition+xml": "TODO",
	"application/vnd.openxmlformats-officedocument.spreadsheetml.pivotCacheRecords+xml": "TODO",

	/* Query Table */
	"application/vnd.ms-excel.queryTable": "TODO",
	"application/vnd.openxmlformats-officedocument.spreadsheetml.queryTable+xml": "TODO",

	/* Shared Workbook */
	"application/vnd.ms-excel.userNames": "TODO",
	"application/vnd.ms-excel.revisionHeaders": "TODO",
	"application/vnd.ms-excel.revisionLog": "TODO",
	"application/vnd.openxmlformats-officedocument.spreadsheetml.revisionHeaders+xml": "TODO",
	"application/vnd.openxmlformats-officedocument.spreadsheetml.revisionLog+xml": "TODO",
	"application/vnd.openxmlformats-officedocument.spreadsheetml.userNames+xml": "TODO",

	/* Single Cell Table */
	"application/vnd.ms-excel.tableSingleCells": "TODO",
	"application/vnd.openxmlformats-officedocument.spreadsheetml.tableSingleCells+xml": "TODO",

	/* Slicer */
	"application/vnd.ms-excel.slicer": "TODO",
	"application/vnd.ms-excel.slicerCache": "TODO",
	"application/vnd.ms-excel.slicer+xml": "TODO",
	"application/vnd.ms-excel.slicerCache+xml": "TODO",

	/* Sort Map */
	"application/vnd.ms-excel.wsSortMap": "TODO",

	/* Table */
	"application/vnd.ms-excel.table": "TODO",
	"application/vnd.openxmlformats-officedocument.spreadsheetml.table+xml": "TODO",

	/* Themes */
	"application/vnd.openxmlformats-officedocument.theme+xml": "themes",

	/* Theme Override */
	"application/vnd.openxmlformats-officedocument.themeOverride+xml": "TODO",

	/* Timeline */
	"application/vnd.ms-excel.Timeline+xml": "TODO", /* verify */
	"application/vnd.ms-excel.TimelineCache+xml": "TODO", /* verify */

	/* VBA */
	"application/vnd.ms-office.vbaProject": "vba",
	"application/vnd.ms-office.vbaProjectSignature": "TODO",

	/* Volatile Dependencies */
	"application/vnd.ms-office.volatileDependencies": "TODO",
	"application/vnd.openxmlformats-officedocument.spreadsheetml.volatileDependencies+xml": "TODO",

	/* Control Properties */
	"application/vnd.ms-excel.controlproperties+xml": "TODO",

	/* Data Model */
	"application/vnd.openxmlformats-officedocument.model+data": "TODO",

	/* Survey */
	"application/vnd.ms-excel.Survey+xml": "TODO",

	/* Drawing */
	"application/vnd.openxmlformats-officedocument.drawing+xml": "drawings",
	"application/vnd.openxmlformats-officedocument.drawingml.chartshapes+xml": "TODO",
	"application/vnd.openxmlformats-officedocument.drawingml.diagramColors+xml": "TODO",
	"application/vnd.openxmlformats-officedocument.drawingml.diagramData+xml": "TODO",
	"application/vnd.openxmlformats-officedocument.drawingml.diagramLayout+xml": "TODO",
	"application/vnd.openxmlformats-officedocument.drawingml.diagramStyle+xml": "TODO",

	/* VML */
	"application/vnd.openxmlformats-officedocument.vmlDrawing": "TODO",

	"application/vnd.openxmlformats-package.relationships+xml": "rels",
	"application/vnd.openxmlformats-officedocument.oleObject": "TODO",

	/* Image */
	"image/png": "TODO",

	"sheet": "js"
}/*:any*/);

var CT_LIST = {
		workbooks: {
			xlsx: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet.main+xml",
			xlsm: "application/vnd.ms-excel.sheet.macroEnabled.main+xml",
			xlsb: "application/vnd.ms-excel.sheet.binary.macroEnabled.main",
			xlam: "application/vnd.ms-excel.addin.macroEnabled.main+xml",
			xltx: "application/vnd.openxmlformats-officedocument.spreadsheetml.template.main+xml"
		},
		strs: { /* Shared Strings */
			xlsx: "application/vnd.openxmlformats-officedocument.spreadsheetml.sharedStrings+xml",
			xlsb: "application/vnd.ms-excel.sharedStrings"
		},
		comments: { /* Comments */
			xlsx: "application/vnd.openxmlformats-officedocument.spreadsheetml.comments+xml",
			xlsb: "application/vnd.ms-excel.comments"
		},
		sheets: { /* Worksheet */
			xlsx: "application/vnd.openxmlformats-officedocument.spreadsheetml.worksheet+xml",
			xlsb: "application/vnd.ms-excel.worksheet"
		},
		charts: { /* Chartsheet */
			xlsx: "application/vnd.openxmlformats-officedocument.spreadsheetml.chartsheet+xml",
			xlsb: "application/vnd.ms-excel.chartsheet"
		},
		dialogs: { /* Dialogsheet */
			xlsx: "application/vnd.openxmlformats-officedocument.spreadsheetml.dialogsheet+xml",
			xlsb: "application/vnd.ms-excel.dialogsheet"
		},
		macros: { /* Macrosheet (Excel 4.0 Macros) */
			xlsx: "application/vnd.ms-excel.macrosheet+xml",
			xlsb: "application/vnd.ms-excel.macrosheet"
		},
		metadata: { /* Metadata (Stock/Geography and Dynamic Array) */
			xlsx: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheetMetadata+xml",
			xlsb: "application/vnd.ms-excel.sheetMetadata"
		},
		styles: { /* Styles */
			xlsx: "application/vnd.openxmlformats-officedocument.spreadsheetml.styles+xml",
			xlsb: "application/vnd.ms-excel.styles"
		}
};

function new_ct()/*:any*/ {
	return ({
		workbooks:[], sheets:[], charts:[], dialogs:[], macros:[],
		rels:[], strs:[], comments:[], threadedcomments:[], links:[],
		coreprops:[], extprops:[], custprops:[], themes:[], styles:[],
		calcchains:[], vba: [], drawings: [], metadata: [], people:[],
		TODO:[], xmlns: "" }/*:any*/);
}

function parse_ct(data/*:?string*/) {
	var ct = new_ct();
	if(!data || !data.match) return ct;
	var ctext = {};
	(data.match(tagregex)||[]).forEach(function(x) {
		var y = parsexmltag(x);
		switch(y[0].replace(nsregex,"<")) {
			case '<?xml': break;
			case '<Types': ct.xmlns = y['xmlns' + (y[0].match(/<(\w+):/)||["",""])[1] ]; break;
			case '<Default': ctext[y.Extension] = y.ContentType; break;
			case '<Override':
				if(ct[ct2type[y.ContentType]] !== undefined) ct[ct2type[y.ContentType]].push(y.PartName);
				break;
		}
	});
	if(ct.xmlns !== XMLNS.CT) throw new Error("Unknown Namespace: " + ct.xmlns);
	ct.calcchain = ct.calcchains.length > 0 ? ct.calcchains[0] : "";
	ct.sst = ct.strs.length > 0 ? ct.strs[0] : "";
	ct.style = ct.styles.length > 0 ? ct.styles[0] : "";
	ct.defaults = ctext;
	delete ct.calcchains;
	return ct;
}

function write_ct(ct, opts)/*:string*/ {
	var type2ct/*{[string]:Array<string>}*/ = evert_arr(ct2type);

	var o/*:Array<string>*/ = [], v;
	o[o.length] = (XML_HEADER);
	o[o.length] = writextag('Types', null, {
		'xmlns': XMLNS.CT,
		'xmlns:xsd': XMLNS.xsd,
		'xmlns:xsi': XMLNS.xsi
	});

	o = o.concat([
		['xml', 'application/xml'],
		['bin', 'application/vnd.ms-excel.sheet.binary.macroEnabled.main'],
		['vml', 'application/vnd.openxmlformats-officedocument.vmlDrawing'],
		['data', 'application/vnd.openxmlformats-officedocument.model+data'],
		/* from test files */
		['bmp', 'image/bmp'],
		['png', 'image/png'],
		['gif', 'image/gif'],
		['emf', 'image/x-emf'],
		['wmf', 'image/x-wmf'],
		['jpg', 'image/jpeg'], ['jpeg', 'image/jpeg'],
		['tif', 'image/tiff'], ['tiff', 'image/tiff'],
		['pdf', 'application/pdf'],
		['rels', 'application/vnd.openxmlformats-package.relationships+xml']
	].map(function(x) {
		return writextag('Default', null, {'Extension':x[0], 'ContentType': x[1]});
	}));

	/* only write first instance */
	var f1 = function(w) {
		if(ct[w] && ct[w].length > 0) {
			v = ct[w][0];
			o[o.length] = (writextag('Override', null, {
				'PartName': (v[0] == '/' ? "":"/") + v,
				'ContentType': CT_LIST[w][opts.bookType] || CT_LIST[w]['xlsx']
			}));
		}
	};

	/* book type-specific */
	var f2 = function(w) {
		(ct[w]||[]).forEach(function(v) {
			o[o.length] = (writextag('Override', null, {
				'PartName': (v[0] == '/' ? "":"/") + v,
				'ContentType': CT_LIST[w][opts.bookType] || CT_LIST[w]['xlsx']
			}));
		});
	};

	/* standard type */
	var f3 = function(t) {
		(ct[t]||[]).forEach(function(v) {
			o[o.length] = (writextag('Override', null, {
				'PartName': (v[0] == '/' ? "":"/") + v,
				'ContentType': type2ct[t][0]
			}));
		});
	};

	f1('workbooks');
	f2('sheets');
	f2('charts');
	f3('themes');
	['strs', 'styles'].forEach(f1);
	['coreprops', 'extprops', 'custprops'].forEach(f3);
	f3('vba');
	f3('comments');
	f3('threadedcomments');
	f3('drawings');
	f2('metadata');
	f3('people');
	if(o.length>2){ o[o.length] = ('</Types>'); o[1]=o[1].replace("/>",">"); }
	return o.join("");
}
/* 9.3 Relationships */
var RELS = ({
	WB: "http://schemas.openxmlformats.org/officeDocument/2006/relationships/officeDocument",
	SHEET: "http://sheetjs.openxmlformats.org/officeDocument/2006/relationships/officeDocument",
	HLINK: "http://schemas.openxmlformats.org/officeDocument/2006/relationships/hyperlink",
	VML: "http://schemas.openxmlformats.org/officeDocument/2006/relationships/vmlDrawing",
	XPATH: "http://schemas.openxmlformats.org/officeDocument/2006/relationships/externalLinkPath",
	XMISS: "http://schemas.microsoft.com/office/2006/relationships/xlExternalLinkPath/xlPathMissing",
	XLINK: "http://schemas.openxmlformats.org/officeDocument/2006/relationships/externalLink",
	CXML: "http://schemas.openxmlformats.org/officeDocument/2006/relationships/customXml",
	CXMLP: "http://schemas.openxmlformats.org/officeDocument/2006/relationships/customXmlProps",
	CMNT: "http://schemas.openxmlformats.org/officeDocument/2006/relationships/comments",
	CORE_PROPS: "http://schemas.openxmlformats.org/package/2006/relationships/metadata/core-properties",
	EXT_PROPS: 'http://schemas.openxmlformats.org/officeDocument/2006/relationships/extended-properties',
	CUST_PROPS: 'http://schemas.openxmlformats.org/officeDocument/2006/relationships/custom-properties',
	SST: "http://schemas.openxmlformats.org/officeDocument/2006/relationships/sharedStrings",
	STY: "http://schemas.openxmlformats.org/officeDocument/2006/relationships/styles",
	THEME: "http://schemas.openxmlformats.org/officeDocument/2006/relationships/theme",
	CHART: "http://schemas.openxmlformats.org/officeDocument/2006/relationships/chart",
	CHARTEX: "http://schemas.microsoft.com/office/2014/relationships/chartEx",
	CS: "http://schemas.openxmlformats.org/officeDocument/2006/relationships/chartsheet",
	WS: [
		"http://schemas.openxmlformats.org/officeDocument/2006/relationships/worksheet",
		"http://purl.oclc.org/ooxml/officeDocument/relationships/worksheet"
	],
	DS: "http://schemas.openxmlformats.org/officeDocument/2006/relationships/dialogsheet",
	MS: "http://schemas.microsoft.com/office/2006/relationships/xlMacrosheet",
	IMG: "http://schemas.openxmlformats.org/officeDocument/2006/relationships/image",
	DRAW: "http://schemas.openxmlformats.org/officeDocument/2006/relationships/drawing",
	XLMETA: "http://schemas.openxmlformats.org/officeDocument/2006/relationships/sheetMetadata",
	TCMNT: "http://schemas.microsoft.com/office/2017/10/relationships/threadedComment",
	PEOPLE: "http://schemas.microsoft.com/office/2017/10/relationships/person",
	VBA: "http://schemas.microsoft.com/office/2006/relationships/vbaProject"
}/*:any*/);


/* 9.3.3 Representing Relationships */
function get_rels_path(file/*:string*/)/*:string*/ {
	var n = file.lastIndexOf("/");
	return file.slice(0,n+1) + '_rels/' + file.slice(n+1) + ".rels";
}

function parse_rels(data/*:?string*/, currentFilePath/*:string*/) {
	var rels = {"!id":{}};
	if (!data) return rels;
	if (currentFilePath.charAt(0) !== '/') {
		currentFilePath = '/'+currentFilePath;
	}
	var hash = {};

	(data.match(tagregex)||[]).forEach(function(x) {
		var y = parsexmltag(x);
		/* 9.3.2.2 OPC_Relationships */
		if (y[0] === '<Relationship') {
			var rel = {}; rel.Type = y.Type; rel.Target = y.Target; rel.Id = y.Id; if(y.TargetMode) rel.TargetMode = y.TargetMode;
			var canonictarget = y.TargetMode === 'External' ? y.Target : resolve_path(y.Target, currentFilePath);
			rels[canonictarget] = rel;
			hash[y.Id] = rel;
		}
	});
	rels["!id"] = hash;
	return rels;
}


/* TODO */
function write_rels(rels)/*:string*/ {
	var o = [XML_HEADER, writextag('Relationships', null, {
		//'xmlns:ns0': XMLNS.RELS,
		'xmlns': XMLNS.RELS
	})];
	keys(rels['!id']).forEach(function(rid) {
		o[o.length] = (writextag('Relationship', null, rels['!id'][rid]));
	});
	if(o.length>2){ o[o.length] = ('</Relationships>'); o[1]=o[1].replace("/>",">"); }
	return o.join("");
}

function add_rels(rels, rId/*:number*/, f, type, relobj, targetmode/*:?string*/)/*:number*/ {
	if(!relobj) relobj = {};
	if(!rels['!id']) rels['!id'] = {};
	if(!rels['!idx']) rels['!idx'] = 1;
	if(rId < 0) for(rId = rels['!idx']; rels['!id']['rId' + rId]; ++rId){/* empty */}
	rels['!idx'] = rId + 1;
	relobj.Id = 'rId' + rId;
	relobj.Type = type;
	relobj.Target = f;
	if(targetmode) relobj.TargetMode = targetmode;
	else if([RELS.HLINK, RELS.XPATH, RELS.XMISS].indexOf(relobj.Type) > -1) relobj.TargetMode = "External";
	if(rels['!id'][relobj.Id]) throw new Error("Cannot rewrite rId " + rId);
	rels['!id'][relobj.Id] = relobj;
	rels[('/' + relobj.Target).replace("//","/")] = relobj;
	return rId;
}
/* Open Document Format for Office Applications (OpenDocument) Version 1.2 */
/* Part 3 Section 4 Manifest File */
var CT_ODS = "application/vnd.oasis.opendocument.spreadsheet";
function parse_manifest(d, opts) {
	var str = xlml_normalize(d);
	var Rn;
	var FEtag;
	while((Rn = xlmlregex.exec(str))) switch(Rn[3]) {
		case 'manifest': break; // 4.2 <manifest:manifest>
		case 'file-entry': // 4.3 <manifest:file-entry>
			FEtag = parsexmltag(Rn[0], false);
			if(FEtag.path == '/' && FEtag.type !== CT_ODS) throw new Error("This OpenDocument is not a spreadsheet");
			break;
		case 'encryption-data': // 4.4 <manifest:encryption-data>
		case 'algorithm': // 4.5 <manifest:algorithm>
		case 'start-key-generation': // 4.6 <manifest:start-key-generation>
		case 'key-derivation': // 4.7 <manifest:key-derivation>
			throw new Error("Unsupported ODS Encryption");
		default: if(opts && opts.WTF) throw Rn;
	}
}

function write_manifest(manifest/*:Array<Array<string> >*/)/*:string*/ {
	var o = [XML_HEADER];
	o.push('<manifest:manifest xmlns:manifest="urn:oasis:names:tc:opendocument:xmlns:manifest:1.0" manifest:version="1.2">\n');
	o.push('  <manifest:file-entry manifest:full-path="/" manifest:version="1.2" manifest:media-type="application/vnd.oasis.opendocument.spreadsheet"/>\n');
	for(var i = 0; i < manifest.length; ++i) o.push('  <manifest:file-entry manifest:full-path="' + manifest[i][0] + '" manifest:media-type="' + manifest[i][1] + '"/>\n');
	o.push('</manifest:manifest>');
	return o.join("");
}

/* Part 3 Section 6 Metadata Manifest File */
function write_rdf_type(file/*:string*/, res/*:string*/, tag/*:?string*/) {
	return [
		'  <rdf:Description rdf:about="' + file + '">\n',
		'    <rdf:type rdf:resource="http://docs.oasis-open.org/ns/office/1.2/meta/' + (tag || "odf") + '#' + res + '"/>\n',
		'  </rdf:Description>\n'
	].join("");
}
function write_rdf_has(base/*:string*/, file/*:string*/) {
	return [
		'  <rdf:Description rdf:about="' + base + '">\n',
		'    <ns0:hasPart xmlns:ns0="http://docs.oasis-open.org/ns/office/1.2/meta/pkg#" rdf:resource="' + file + '"/>\n',
		'  </rdf:Description>\n'
	].join("");
}
function write_rdf(rdf) {
	var o = [XML_HEADER];
	o.push('<rdf:RDF xmlns:rdf="http://www.w3.org/1999/02/22-rdf-syntax-ns#">\n');
	for(var i = 0; i != rdf.length; ++i) {
		o.push(write_rdf_type(rdf[i][0], rdf[i][1]));
		o.push(write_rdf_has("",rdf[i][0]));
	}
	o.push(write_rdf_type("","Document", "pkg"));
	o.push('</rdf:RDF>');
	return o.join("");
}
/* TODO: pull properties */
function write_meta_ods(/*:: wb: Workbook, opts: any*/)/*:string*/ {
	return '<office:document-meta xmlns:office="urn:oasis:names:tc:opendocument:xmlns:office:1.0" xmlns:meta="urn:oasis:names:tc:opendocument:xmlns:meta:1.0" xmlns:dc="http://purl.org/dc/elements/1.1/" xmlns:xlink="http://www.w3.org/1999/xlink" office:version="1.2"><office:meta><meta:generator>Sheet' + 'JS ' + XLSX.version + '</meta:generator></office:meta></office:document-meta>';
}

/* ECMA-376 Part II 11.1 Core Properties Part */
/* [MS-OSHARED] 2.3.3.2.[1-2].1 (PIDSI/PIDDSI) */
var CORE_PROPS/*:Array<Array<string> >*/ = [
	["cp:category", "Category"],
	["cp:contentStatus", "ContentStatus"],
	["cp:keywords", "Keywords"],
	["cp:lastModifiedBy", "LastAuthor"],
	["cp:lastPrinted", "LastPrinted"],
	["cp:revision", "RevNumber"],
	["cp:version", "Version"],
	["dc:creator", "Author"],
	["dc:description", "Comments"],
	["dc:identifier", "Identifier"],
	["dc:language", "Language"],
	["dc:subject", "Subject"],
	["dc:title", "Title"],
	["dcterms:created", "CreatedDate", 'date'],
	["dcterms:modified", "ModifiedDate", 'date']
];

var CORE_PROPS_REGEX/*:Array<RegExp>*/ = /*#__PURE__*/(/* unused pure expression or super */ null && ((function() {
	var r = new Array(CORE_PROPS.length);
	for(var i = 0; i < CORE_PROPS.length; ++i) {
		var f = CORE_PROPS[i];
		var g = "(?:"+ f[0].slice(0,f[0].indexOf(":")) +":)"+ f[0].slice(f[0].indexOf(":")+1);
		r[i] = new RegExp("<" + g + "[^>]*>([\\s\\S]*?)<\/" + g + ">");
	}
	return r;
})()));

function parse_core_props(data) {
	var p = {};
	data = utf8read(data);

	for(var i = 0; i < CORE_PROPS.length; ++i) {
		var f = CORE_PROPS[i], cur = data.match(CORE_PROPS_REGEX[i]);
		if(cur != null && cur.length > 0) p[f[1]] = unescapexml(cur[1]);
		if(f[2] === 'date' && p[f[1]]) p[f[1]] = parseDate(p[f[1]]);
	}

	return p;
}

function cp_doit(f, g, h, o, p) {
	if(p[f] != null || g == null || g === "") return;
	p[f] = g;
	g = escapexml(g);
	o[o.length] = (h ? writextag(f,g,h) : writetag(f,g));
}

function write_core_props(cp, _opts) {
	var opts = _opts || {};
	var o = [XML_HEADER, writextag('cp:coreProperties', null, {
		//'xmlns': XMLNS.CORE_PROPS,
		'xmlns:cp': XMLNS.CORE_PROPS,
		'xmlns:dc': XMLNS.dc,
		'xmlns:dcterms': XMLNS.dcterms,
		'xmlns:dcmitype': XMLNS.dcmitype,
		'xmlns:xsi': XMLNS.xsi
	})], p = {};
	if(!cp && !opts.Props) return o.join("");

	if(cp) {
		if(cp.CreatedDate != null) cp_doit("dcterms:created", typeof cp.CreatedDate === "string" ? cp.CreatedDate : write_w3cdtf(cp.CreatedDate, opts.WTF), {"xsi:type":"dcterms:W3CDTF"}, o, p);
		if(cp.ModifiedDate != null) cp_doit("dcterms:modified", typeof cp.ModifiedDate === "string" ? cp.ModifiedDate : write_w3cdtf(cp.ModifiedDate, opts.WTF), {"xsi:type":"dcterms:W3CDTF"}, o, p);
	}

	for(var i = 0; i != CORE_PROPS.length; ++i) {
		var f = CORE_PROPS[i];
		var v = opts.Props && opts.Props[f[1]] != null ? opts.Props[f[1]] : cp ? cp[f[1]] : null;
		if(v === true) v = "1";
		else if(v === false) v = "0";
		else if(typeof v == "number") v = String(v);
		if(v != null) cp_doit(f[0], v, null, o, p);
	}
	if(o.length>2){ o[o.length] = ('</cp:coreProperties>'); o[1]=o[1].replace("/>",">"); }
	return o.join("");
}
/* 15.2.12.3 Extended File Properties Part */
/* [MS-OSHARED] 2.3.3.2.[1-2].1 (PIDSI/PIDDSI) */
var EXT_PROPS/*:Array<Array<string> >*/ = [
	["Application", "Application", "string"],
	["AppVersion", "AppVersion", "string"],
	["Company", "Company", "string"],
	["DocSecurity", "DocSecurity", "string"],
	["Manager", "Manager", "string"],
	["HyperlinksChanged", "HyperlinksChanged", "bool"],
	["SharedDoc", "SharedDoc", "bool"],
	["LinksUpToDate", "LinksUpToDate", "bool"],
	["ScaleCrop", "ScaleCrop", "bool"],
	["HeadingPairs", "HeadingPairs", "raw"],
	["TitlesOfParts", "TitlesOfParts", "raw"]
];

var PseudoPropsPairs = [
	"Worksheets",  "SheetNames",
	"NamedRanges", "DefinedNames",
	"Chartsheets", "ChartNames"
];
function load_props_pairs(HP/*:string|Array<Array<any>>*/, TOP, props, opts) {
	var v = [];
	if(typeof HP == "string") v = parseVector(HP, opts);
	else for(var j = 0; j < HP.length; ++j) v = v.concat(HP[j].map(function(hp) { return {v:hp}; }));
	var parts = (typeof TOP == "string") ? parseVector(TOP, opts).map(function (x) { return x.v; }) : TOP;
	var idx = 0, len = 0;
	if(parts.length > 0) for(var i = 0; i !== v.length; i += 2) {
		len = +(v[i+1].v);
		switch(v[i].v) {
			case "Worksheets":
			case "工作表":
			case "Листы":
			case "أوراق العمل":
			case "ワークシート":
			case "גליונות עבודה":
			case "Arbeitsblätter":
			case "Çalışma Sayfaları":
			case "Feuilles de calcul":
			case "Fogli di lavoro":
			case "Folhas de cálculo":
			case "Planilhas":
			case "Regneark":
			case "Hojas de cálculo":
			case "Werkbladen":
				props.Worksheets = len;
				props.SheetNames = parts.slice(idx, idx + len);
				break;

			case "Named Ranges":
			case "Rangos con nombre":
			case "名前付き一覧":
			case "Benannte Bereiche":
			case "Navngivne områder":
				props.NamedRanges = len;
				props.DefinedNames = parts.slice(idx, idx + len);
				break;

			case "Charts":
			case "Diagramme":
				props.Chartsheets = len;
				props.ChartNames = parts.slice(idx, idx + len);
				break;
		}
		idx += len;
	}
}

function parse_ext_props(data, p, opts) {
	var q = {}; if(!p) p = {};
	data = utf8read(data);

	EXT_PROPS.forEach(function(f) {
		var xml = (data.match(matchtag(f[0]))||[])[1];
		switch(f[2]) {
			case "string": if(xml) p[f[1]] = unescapexml(xml); break;
			case "bool": p[f[1]] = xml === "true"; break;
			case "raw":
				var cur = data.match(new RegExp("<" + f[0] + "[^>]*>([\\s\\S]*?)<\/" + f[0] + ">"));
				if(cur && cur.length > 0) q[f[1]] = cur[1];
				break;
		}
	});

	if(q.HeadingPairs && q.TitlesOfParts) load_props_pairs(q.HeadingPairs, q.TitlesOfParts, p, opts);

	return p;
}

function write_ext_props(cp/*::, opts*/)/*:string*/ {
	var o/*:Array<string>*/ = [], W = writextag;
	if(!cp) cp = {};
	cp.Application = "SheetJS";
	o[o.length] = (XML_HEADER);
	o[o.length] = (writextag('Properties', null, {
		'xmlns': XMLNS.EXT_PROPS,
		'xmlns:vt': XMLNS.vt
	}));

	EXT_PROPS.forEach(function(f) {
		if(cp[f[1]] === undefined) return;
		var v;
		switch(f[2]) {
			case 'string': v = escapexml(String(cp[f[1]])); break;
			case 'bool': v = cp[f[1]] ? 'true' : 'false'; break;
		}
		if(v !== undefined) o[o.length] = (W(f[0], v));
	});

	/* TODO: HeadingPairs, TitlesOfParts */
	o[o.length] = (W('HeadingPairs', W('vt:vector', W('vt:variant', '<vt:lpstr>Worksheets</vt:lpstr>')+W('vt:variant', W('vt:i4', String(cp.Worksheets))), {size:2, baseType:"variant"})));
	o[o.length] = (W('TitlesOfParts', W('vt:vector', cp.SheetNames.map(function(s) { return "<vt:lpstr>" + escapexml(s) + "</vt:lpstr>"; }).join(""), {size: cp.Worksheets, baseType:"lpstr"})));
	if(o.length>2){ o[o.length] = ('</Properties>'); o[1]=o[1].replace("/>",">"); }
	return o.join("");
}
/* 15.2.12.2 Custom File Properties Part */
var custregex = /<[^>]+>[^<]*/g;
function parse_cust_props(data/*:string*/, opts) {
	var p = {}, name = "";
	var m = data.match(custregex);
	if(m) for(var i = 0; i != m.length; ++i) {
		var x = m[i], y = parsexmltag(x);
		switch(y[0]) {
			case '<?xml': break;
			case '<Properties': break;
			case '<property': name = unescapexml(y.name); break;
			case '</property>': name = null; break;
			default: if (x.indexOf('<vt:') === 0) {
				var toks = x.split('>');
				var type = toks[0].slice(4), text = toks[1];
				/* 22.4.2.32 (CT_Variant). Omit the binary types from 22.4 (Variant Types) */
				switch(type) {
					case 'lpstr': case 'bstr': case 'lpwstr':
						p[name] = unescapexml(text);
						break;
					case 'bool':
						p[name] = parsexmlbool(text);
						break;
					case 'i1': case 'i2': case 'i4': case 'i8': case 'int': case 'uint':
						p[name] = parseInt(text, 10);
						break;
					case 'r4': case 'r8': case 'decimal':
						p[name] = parseFloat(text);
						break;
					case 'filetime': case 'date':
						p[name] = parseDate(text);
						break;
					case 'cy': case 'error':
						p[name] = unescapexml(text);
						break;
					default:
						if(type.slice(-1) == '/') break;
						if(opts.WTF && typeof console !== 'undefined') console.warn('Unexpected', x, type, toks);
				}
			} else if(x.slice(0,2) === "</") {/* empty */
			} else if(opts.WTF) throw new Error(x);
		}
	}
	return p;
}

function write_cust_props(cp/*::, opts*/)/*:string*/ {
	var o = [XML_HEADER, writextag('Properties', null, {
		'xmlns': XMLNS.CUST_PROPS,
		'xmlns:vt': XMLNS.vt
	})];
	if(!cp) return o.join("");
	var pid = 1;
	keys(cp).forEach(function custprop(k) { ++pid;
		o[o.length] = (writextag('property', write_vt(cp[k], true), {
			'fmtid': '{D5CDD505-2E9C-101B-9397-08002B2CF9AE}',
			'pid': pid,
			'name': escapexml(k)
		}));
	});
	if(o.length>2){ o[o.length] = '</Properties>'; o[1]=o[1].replace("/>",">"); }
	return o.join("");
}
/* Common Name -> XLML Name */
var XLMLDocPropsMap = {
	Title: 'Title',
	Subject: 'Subject',
	Author: 'Author',
	Keywords: 'Keywords',
	Comments: 'Description',
	LastAuthor: 'LastAuthor',
	RevNumber: 'Revision',
	Application: 'AppName',
	/* TotalTime: 'TotalTime', */
	LastPrinted: 'LastPrinted',
	CreatedDate: 'Created',
	ModifiedDate: 'LastSaved',
	/* Pages */
	/* Words */
	/* Characters */
	Category: 'Category',
	/* PresentationFormat */
	Manager: 'Manager',
	Company: 'Company',
	/* Guid */
	/* HyperlinkBase */
	/* Bytes */
	/* Lines */
	/* Paragraphs */
	/* CharactersWithSpaces */
	AppVersion: 'Version',

	ContentStatus: 'ContentStatus', /* NOTE: missing from schema */
	Identifier: 'Identifier', /* NOTE: missing from schema */
	Language: 'Language' /* NOTE: missing from schema */
};
var evert_XLMLDPM;

function xlml_set_prop(Props, tag/*:string*/, val) {
	if(!evert_XLMLDPM) evert_XLMLDPM = evert(XLMLDocPropsMap);
	tag = evert_XLMLDPM[tag] || tag;
	Props[tag] = val;
}

function xlml_write_docprops(Props, opts) {
	var o/*:Array<string>*/ = [];
	keys(XLMLDocPropsMap).map(function(m) {
		for(var i = 0; i < CORE_PROPS.length; ++i) if(CORE_PROPS[i][1] == m) return CORE_PROPS[i];
		for(i = 0; i < EXT_PROPS.length; ++i) if(EXT_PROPS[i][1] == m) return EXT_PROPS[i];
		throw m;
	}).forEach(function(p) {
		if(Props[p[1]] == null) return;
		var m = opts && opts.Props && opts.Props[p[1]] != null ? opts.Props[p[1]] : Props[p[1]];
		switch(p[2]) {
			case 'date': m = new Date(m).toISOString().replace(/\.\d*Z/,"Z"); break;
		}
		if(typeof m == 'number') m = String(m);
		else if(m === true || m === false) { m = m ? "1" : "0"; }
		else if(m instanceof Date) m = new Date(m).toISOString().replace(/\.\d*Z/,"");
		o.push(writetag(XLMLDocPropsMap[p[1]] || p[1], m));
	});
	return writextag('DocumentProperties', o.join(""), {xmlns:XLMLNS.o });
}
function xlml_write_custprops(Props, Custprops/*::, opts*/) {
	var BLACKLIST = ["Worksheets","SheetNames"];
	var T = 'CustomDocumentProperties';
	var o/*:Array<string>*/ = [];
	if(Props) keys(Props).forEach(function(k) {
		/*:: if(!Props) return; */
		if(!Object.prototype.hasOwnProperty.call(Props, k)) return;
		for(var i = 0; i < CORE_PROPS.length; ++i) if(k == CORE_PROPS[i][1]) return;
		for(i = 0; i < EXT_PROPS.length; ++i) if(k == EXT_PROPS[i][1]) return;
		for(i = 0; i < BLACKLIST.length; ++i) if(k == BLACKLIST[i]) return;

		var m = Props[k];
		var t = "string";
		if(typeof m == 'number') { t = "float"; m = String(m); }
		else if(m === true || m === false) { t = "boolean"; m = m ? "1" : "0"; }
		else m = String(m);
		o.push(writextag(escapexmltag(k), m, {"dt:dt":t}));
	});
	if(Custprops) keys(Custprops).forEach(function(k) {
		/*:: if(!Custprops) return; */
		if(!Object.prototype.hasOwnProperty.call(Custprops, k)) return;
		if(Props && Object.prototype.hasOwnProperty.call(Props, k)) return;
		var m = Custprops[k];
		var t = "string";
		if(typeof m == 'number') { t = "float"; m = String(m); }
		else if(m === true || m === false) { t = "boolean"; m = m ? "1" : "0"; }
		else if(m instanceof Date) { t = "dateTime.tz"; m = m.toISOString(); }
		else m = String(m);
		o.push(writextag(escapexmltag(k), m, {"dt:dt":t}));
	});
	return '<' + T + ' xmlns="' + XLMLNS.o + '">' + o.join("") + '</' + T + '>';
}
/* [MS-DTYP] 2.3.3 FILETIME */
/* [MS-OLEDS] 2.1.3 FILETIME (Packet Version) */
/* [MS-OLEPS] 2.8 FILETIME (Packet Version) */
function parse_FILETIME(blob) {
	var dwLowDateTime = blob.read_shift(4), dwHighDateTime = blob.read_shift(4);
	return new Date(((dwHighDateTime/1e7*Math.pow(2,32) + dwLowDateTime/1e7) - 11644473600)*1000).toISOString().replace(/\.000/,"");
}
function write_FILETIME(time/*:string|Date*/) {
	var date = (typeof time == "string") ? new Date(Date.parse(time)) : time;
	var t = date.getTime() / 1000 + 11644473600;
	var l = t % Math.pow(2,32), h = (t - l) / Math.pow(2,32);
	l *= 1e7; h *= 1e7;
	var w = (l / Math.pow(2,32)) | 0;
	if(w > 0) { l = l % Math.pow(2,32); h += w; }
	var o = new_buf(8); o.write_shift(4, l); o.write_shift(4, h); return o;
}

/* [MS-OSHARED] 2.3.3.1.4 Lpstr */
function parse_lpstr(blob, type, pad/*:?number*/) {
	var start = blob.l;
	var str = blob.read_shift(0, 'lpstr-cp');
	if(pad) while((blob.l - start) & 3) ++blob.l;
	return str;
}

/* [MS-OSHARED] 2.3.3.1.6 Lpwstr */
function parse_lpwstr(blob, type, pad) {
	var str = blob.read_shift(0, 'lpwstr');
	if(pad) blob.l += (4 - ((str.length+1) & 3)) & 3;
	return str;
}


/* [MS-OSHARED] 2.3.3.1.11 VtString */
/* [MS-OSHARED] 2.3.3.1.12 VtUnalignedString */
function parse_VtStringBase(blob, stringType, pad) {
	if(stringType === 0x1F /*VT_LPWSTR*/) return parse_lpwstr(blob);
	return parse_lpstr(blob, stringType, pad);
}

function parse_VtString(blob, t/*:number*/, pad/*:?boolean*/) { return parse_VtStringBase(blob, t, pad === false ? 0: 4); }
function parse_VtUnalignedString(blob, t/*:number*/) { if(!t) throw new Error("VtUnalignedString must have positive length"); return parse_VtStringBase(blob, t, 0); }

/* [MS-OSHARED] 2.3.3.1.7 VtVecLpwstrValue */
function parse_VtVecLpwstrValue(blob)/*:Array<string>*/ {
	var length = blob.read_shift(4);
	var ret/*:Array<string>*/ = [];
	for(var i = 0; i != length; ++i) {
		var start = blob.l;
		ret[i] = blob.read_shift(0, 'lpwstr').replace(chr0,'');
		if((blob.l - start) & 0x02) blob.l += 2;
	}
	return ret;
}

/* [MS-OSHARED] 2.3.3.1.9 VtVecUnalignedLpstrValue */
function parse_VtVecUnalignedLpstrValue(blob)/*:Array<string>*/ {
	var length = blob.read_shift(4);
	var ret/*:Array<string>*/ = [];
	for(var i = 0; i != length; ++i) ret[i] = blob.read_shift(0, 'lpstr-cp').replace(chr0,'');
	return ret;
}


/* [MS-OSHARED] 2.3.3.1.13 VtHeadingPair */
function parse_VtHeadingPair(blob) {
	var start = blob.l;
	var headingString = parse_TypedPropertyValue(blob, VT_USTR);
	if(blob[blob.l] == 0x00 && blob[blob.l+1] == 0x00 && ((blob.l - start) & 0x02)) blob.l += 2;
	var headerParts = parse_TypedPropertyValue(blob, VT_I4);
	return [headingString, headerParts];
}

/* [MS-OSHARED] 2.3.3.1.14 VtVecHeadingPairValue */
function parse_VtVecHeadingPairValue(blob) {
	var cElements = blob.read_shift(4);
	var out = [];
	for(var i = 0; i < cElements / 2; ++i) out.push(parse_VtHeadingPair(blob));
	return out;
}

/* [MS-OLEPS] 2.18.1 Dictionary (uses 2.17, 2.16) */
function parse_dictionary(blob,CodePage) {
	var cnt = blob.read_shift(4);
	var dict/*:{[number]:string}*/ = ({}/*:any*/);
	for(var j = 0; j != cnt; ++j) {
		var pid = blob.read_shift(4);
		var len = blob.read_shift(4);
		dict[pid] = blob.read_shift(len, (CodePage === 0x4B0 ?'utf16le':'utf8')).replace(chr0,'').replace(chr1,'!');
		if(CodePage === 0x4B0 && (len % 2)) blob.l += 2;
	}
	if(blob.l & 3) blob.l = (blob.l>>2+1)<<2;
	return dict;
}

/* [MS-OLEPS] 2.9 BLOB */
function parse_BLOB(blob) {
	var size = blob.read_shift(4);
	var bytes = blob.slice(blob.l,blob.l+size);
	blob.l += size;
	if((size & 3) > 0) blob.l += (4 - (size & 3)) & 3;
	return bytes;
}

/* [MS-OLEPS] 2.11 ClipboardData */
function parse_ClipboardData(blob) {
	// TODO
	var o = {};
	o.Size = blob.read_shift(4);
	//o.Format = blob.read_shift(4);
	blob.l += o.Size + 3 - (o.Size - 1) % 4;
	return o;
}

/* [MS-OLEPS] 2.15 TypedPropertyValue */
function parse_TypedPropertyValue(blob, type/*:number*/, _opts)/*:any*/ {
	var t = blob.read_shift(2), ret, opts = _opts||{};
	blob.l += 2;
	if(type !== VT_VARIANT)
	if(t !== type && VT_CUSTOM.indexOf(type)===-1 && !((type & 0xFFFE) == 0x101E && (t & 0xFFFE) == 0x101E)) throw new Error('Expected type ' + type + ' saw ' + t);
	switch(type === VT_VARIANT ? t : type) {
		case 0x02 /*VT_I2*/: ret = blob.read_shift(2, 'i'); if(!opts.raw) blob.l += 2; return ret;
		case 0x03 /*VT_I4*/: ret = blob.read_shift(4, 'i'); return ret;
		case 0x0B /*VT_BOOL*/: return blob.read_shift(4) !== 0x0;
		case 0x13 /*VT_UI4*/: ret = blob.read_shift(4); return ret;
		case 0x1E /*VT_LPSTR*/: return parse_lpstr(blob, t, 4).replace(chr0,'');
		case 0x1F /*VT_LPWSTR*/: return parse_lpwstr(blob);
		case 0x40 /*VT_FILETIME*/: return parse_FILETIME(blob);
		case 0x41 /*VT_BLOB*/: return parse_BLOB(blob);
		case 0x47 /*VT_CF*/: return parse_ClipboardData(blob);
		case 0x50 /*VT_STRING*/: return parse_VtString(blob, t, !opts.raw).replace(chr0,'');
		case 0x51 /*VT_USTR*/: return parse_VtUnalignedString(blob, t/*, 4*/).replace(chr0,'');
		case 0x100C /*VT_VECTOR|VT_VARIANT*/: return parse_VtVecHeadingPairValue(blob);
		case 0x101E /*VT_VECTOR|VT_LPSTR*/:
		case 0x101F /*VT_VECTOR|VT_LPWSTR*/:
			return t == 0x101F ? parse_VtVecLpwstrValue(blob) : parse_VtVecUnalignedLpstrValue(blob);
		default: throw new Error("TypedPropertyValue unrecognized type " + type + " " + t);
	}
}
function write_TypedPropertyValue(type/*:number*/, value) {
	var o = new_buf(4), p = new_buf(4);
	o.write_shift(4, type == 0x50 ? 0x1F : type);
	switch(type) {
		case 0x03 /*VT_I4*/: p.write_shift(-4, value); break;
		case 0x05 /*VT_I4*/: p = new_buf(8); p.write_shift(8, value, 'f'); break;
		case 0x0B /*VT_BOOL*/: p.write_shift(4, value ? 0x01 : 0x00); break;
		case 0x40 /*VT_FILETIME*/: /*:: if(typeof value !== "string" && !(value instanceof Date)) throw "unreachable"; */ p = write_FILETIME(value); break;
		case 0x1F /*VT_LPWSTR*/:
		case 0x50 /*VT_STRING*/:
			/*:: if(typeof value !== "string") throw "unreachable"; */
			p = new_buf(4 + 2 * (value.length + 1) + (value.length % 2 ? 0 : 2));
			p.write_shift(4, value.length + 1);
			p.write_shift(0, value, "dbcs");
			while(p.l != p.length) p.write_shift(1, 0);
			break;
		default: throw new Error("TypedPropertyValue unrecognized type " + type + " " + value);
	}
	return bconcat([o, p]);
}

/* [MS-OLEPS] 2.20 PropertySet */
function parse_PropertySet(blob, PIDSI) {
	var start_addr = blob.l;
	var size = blob.read_shift(4);
	var NumProps = blob.read_shift(4);
	var Props = [], i = 0;
	var CodePage = 0;
	var Dictionary = -1, DictObj/*:{[number]:string}*/ = ({}/*:any*/);
	for(i = 0; i != NumProps; ++i) {
		var PropID = blob.read_shift(4);
		var Offset = blob.read_shift(4);
		Props[i] = [PropID, Offset + start_addr];
	}
	Props.sort(function(x,y) { return x[1] - y[1]; });
	var PropH = {};
	for(i = 0; i != NumProps; ++i) {
		if(blob.l !== Props[i][1]) {
			var fail = true;
			if(i>0 && PIDSI) switch(PIDSI[Props[i-1][0]].t) {
				case 0x02 /*VT_I2*/: if(blob.l+2 === Props[i][1]) { blob.l+=2; fail = false; } break;
				case 0x50 /*VT_STRING*/: if(blob.l <= Props[i][1]) { blob.l=Props[i][1]; fail = false; } break;
				case 0x100C /*VT_VECTOR|VT_VARIANT*/: if(blob.l <= Props[i][1]) { blob.l=Props[i][1]; fail = false; } break;
			}
			if((!PIDSI||i==0) && blob.l <= Props[i][1]) { fail=false; blob.l = Props[i][1]; }
			if(fail) throw new Error("Read Error: Expected address " + Props[i][1] + ' at ' + blob.l + ' :' + i);
		}
		if(PIDSI) {
			var piddsi = PIDSI[Props[i][0]];
			PropH[piddsi.n] = parse_TypedPropertyValue(blob, piddsi.t, {raw:true});
			if(piddsi.p === 'version') PropH[piddsi.n] = String(PropH[piddsi.n] >> 16) + "." + ("0000" + String(PropH[piddsi.n] & 0xFFFF)).slice(-4);
			if(piddsi.n == "CodePage") switch(PropH[piddsi.n]) {
				case 0: PropH[piddsi.n] = 1252;
					/* falls through */
				case 874:
				case 932:
				case 936:
				case 949:
				case 950:
				case 1250:
				case 1251:
				case 1253:
				case 1254:
				case 1255:
				case 1256:
				case 1257:
				case 1258:
				case 10000:
				case 1200:
				case 1201:
				case 1252:
				case 65000: case -536:
				case 65001: case -535:
					set_cp(CodePage = (PropH[piddsi.n]>>>0) & 0xFFFF); break;
				default: throw new Error("Unsupported CodePage: " + PropH[piddsi.n]);
			}
		} else {
			if(Props[i][0] === 0x1) {
				CodePage = PropH.CodePage = (parse_TypedPropertyValue(blob, VT_I2)/*:number*/);
				set_cp(CodePage);
				if(Dictionary !== -1) {
					var oldpos = blob.l;
					blob.l = Props[Dictionary][1];
					DictObj = parse_dictionary(blob,CodePage);
					blob.l = oldpos;
				}
			} else if(Props[i][0] === 0) {
				if(CodePage === 0) { Dictionary = i; blob.l = Props[i+1][1]; continue; }
				DictObj = parse_dictionary(blob,CodePage);
			} else {
				var name = DictObj[Props[i][0]];
				var val;
				/* [MS-OSHARED] 2.3.3.2.3.1.2 + PROPVARIANT */
				switch(blob[blob.l]) {
					case 0x41 /*VT_BLOB*/: blob.l += 4; val = parse_BLOB(blob); break;
					case 0x1E /*VT_LPSTR*/: blob.l += 4; val = parse_VtString(blob, blob[blob.l-4]).replace(/\u0000+$/,""); break;
					case 0x1F /*VT_LPWSTR*/: blob.l += 4; val = parse_VtString(blob, blob[blob.l-4]).replace(/\u0000+$/,""); break;
					case 0x03 /*VT_I4*/: blob.l += 4; val = blob.read_shift(4, 'i'); break;
					case 0x13 /*VT_UI4*/: blob.l += 4; val = blob.read_shift(4); break;
					case 0x05 /*VT_R8*/: blob.l += 4; val = blob.read_shift(8, 'f'); break;
					case 0x0B /*VT_BOOL*/: blob.l += 4; val = parsebool(blob, 4); break;
					case 0x40 /*VT_FILETIME*/: blob.l += 4; val = parseDate(parse_FILETIME(blob)); break;
					default: throw new Error("unparsed value: " + blob[blob.l]);
				}
				PropH[name] = val;
			}
		}
	}
	blob.l = start_addr + size; /* step ahead to skip padding */
	return PropH;
}
var XLSPSSkip = [ "CodePage", "Thumbnail", "_PID_LINKBASE", "_PID_HLINKS", "SystemIdentifier", "FMTID" ]; //.concat(PseudoPropsPairs);
function guess_property_type(val/*:any*/)/*:number*/ {
	switch(typeof val) {
		case "boolean": return 0x0B;
		case "number": return ((val|0)==val) ? 0x03 : 0x05;
		case "string": return 0x1F;
		case "object": if(val instanceof Date) return 0x40; break;
	}
	return -1;
}
function write_PropertySet(entries, RE, PIDSI) {
	var hdr = new_buf(8), piao = [], prop = [];
	var sz = 8, i = 0;

	var pr = new_buf(8), pio = new_buf(8);
	pr.write_shift(4, 0x0002);
	pr.write_shift(4, 0x04B0);
	pio.write_shift(4, 0x0001);
	prop.push(pr); piao.push(pio);
	sz += 8 + pr.length;

	if(!RE) {
		pio = new_buf(8);
		pio.write_shift(4, 0);
		piao.unshift(pio);

		var bufs = [new_buf(4)];
		bufs[0].write_shift(4, entries.length);
		for(i = 0; i < entries.length; ++i) {
			var value = entries[i][0];
			pr = new_buf(4 + 4 + 2 * (value.length + 1) + (value.length % 2 ? 0 : 2));
			pr.write_shift(4, i+2);
			pr.write_shift(4, value.length + 1);
			pr.write_shift(0, value, "dbcs");
			while(pr.l != pr.length) pr.write_shift(1, 0);
			bufs.push(pr);
		}
		pr = bconcat(bufs);
		prop.unshift(pr);
		sz += 8 + pr.length;
	}

	for(i = 0; i < entries.length; ++i) {
		if(RE && !RE[entries[i][0]]) continue;
		if(XLSPSSkip.indexOf(entries[i][0]) > -1 || PseudoPropsPairs.indexOf(entries[i][0]) > -1) continue;
		if(entries[i][1] == null) continue;

		var val = entries[i][1], idx = 0;
		if(RE) {
			idx = +RE[entries[i][0]];
			var pinfo = (PIDSI/*:: || {}*/)[idx]/*:: || {} */;
			if(pinfo.p == "version" && typeof val == "string") {
				/*:: if(typeof val !== "string") throw "unreachable"; */
				var arr = val.split(".");
				val = ((+arr[0])<<16) + ((+arr[1])||0);
			}
			pr = write_TypedPropertyValue(pinfo.t, val);
		} else {
			var T = guess_property_type(val);
			if(T == -1) { T = 0x1F; val = String(val); }
			pr = write_TypedPropertyValue(T, val);
		}
		prop.push(pr);

		pio = new_buf(8);
		pio.write_shift(4, !RE ? 2+i : idx);
		piao.push(pio);

		sz += 8 + pr.length;
	}

	var w = 8 * (prop.length + 1);
	for(i = 0; i < prop.length; ++i) { piao[i].write_shift(4, w); w += prop[i].length; }
	hdr.write_shift(4, sz);
	hdr.write_shift(4, prop.length);
	return bconcat([hdr].concat(piao).concat(prop));
}

/* [MS-OLEPS] 2.21 PropertySetStream */
function parse_PropertySetStream(file, PIDSI, clsid) {
	var blob = file.content;
	if(!blob) return ({}/*:any*/);
	prep_blob(blob, 0);

	var NumSets, FMTID0, FMTID1, Offset0, Offset1 = 0;
	blob.chk('feff', 'Byte Order: ');

	/*var vers = */blob.read_shift(2); // TODO: check version
	var SystemIdentifier = blob.read_shift(4);
	var CLSID = blob.read_shift(16);
	if(CLSID !== CFB.utils.consts.HEADER_CLSID && CLSID !== clsid) throw new Error("Bad PropertySet CLSID " + CLSID);
	NumSets = blob.read_shift(4);
	if(NumSets !== 1 && NumSets !== 2) throw new Error("Unrecognized #Sets: " + NumSets);
	FMTID0 = blob.read_shift(16); Offset0 = blob.read_shift(4);

	if(NumSets === 1 && Offset0 !== blob.l) throw new Error("Length mismatch: " + Offset0 + " !== " + blob.l);
	else if(NumSets === 2) { FMTID1 = blob.read_shift(16); Offset1 = blob.read_shift(4); }
	var PSet0 = parse_PropertySet(blob, PIDSI);

	var rval = ({ SystemIdentifier: SystemIdentifier }/*:any*/);
	for(var y in PSet0) rval[y] = PSet0[y];
	//rval.blob = blob;
	rval.FMTID = FMTID0;
	//rval.PSet0 = PSet0;
	if(NumSets === 1) return rval;
	if(Offset1 - blob.l == 2) blob.l += 2;
	if(blob.l !== Offset1) throw new Error("Length mismatch 2: " + blob.l + " !== " + Offset1);
	var PSet1;
	try { PSet1 = parse_PropertySet(blob, null); } catch(e) {/* empty */}
	for(y in PSet1) rval[y] = PSet1[y];
	rval.FMTID = [FMTID0, FMTID1]; // TODO: verify FMTID0/1
	return rval;
}
function write_PropertySetStream(entries, clsid, RE, PIDSI/*:{[key:string|number]:any}*/, entries2/*:?any*/, clsid2/*:?any*/) {
	var hdr = new_buf(entries2 ? 68 : 48);
	var bufs = [hdr];
	hdr.write_shift(2, 0xFFFE);
	hdr.write_shift(2, 0x0000); /* TODO: type 1 props */
	hdr.write_shift(4, 0x32363237);
	hdr.write_shift(16, CFB.utils.consts.HEADER_CLSID, "hex");
	hdr.write_shift(4, (entries2 ? 2 : 1));
	hdr.write_shift(16, clsid, "hex");
	hdr.write_shift(4, (entries2 ? 68 : 48));
	var ps0 = write_PropertySet(entries, RE, PIDSI);
	bufs.push(ps0);

	if(entries2) {
		var ps1 = write_PropertySet(entries2, null, null);
		hdr.write_shift(16, clsid2, "hex");
		hdr.write_shift(4, 68 + ps0.length);
		bufs.push(ps1);
	}
	return bconcat(bufs);
}

function parsenoop2(blob, length) { blob.read_shift(length); return null; }
function writezeroes(n, o) { if(!o) o=new_buf(n); for(var j=0; j<n; ++j) o.write_shift(1, 0); return o; }

function parslurp(blob, length, cb) {
	var arr = [], target = blob.l + length;
	while(blob.l < target) arr.push(cb(blob, target - blob.l));
	if(target !== blob.l) throw new Error("Slurp error");
	return arr;
}

function parsebool(blob, length/*:number*/) { return blob.read_shift(length) === 0x1; }
function writebool(v/*:any*/, o) { if(!o) o=new_buf(2); o.write_shift(2, +!!v); return o; }

function parseuint16(blob/*::, length:?number, opts:?any*/) { return blob.read_shift(2, 'u'); }
function writeuint16(v/*:number*/, o) { if(!o) o=new_buf(2); o.write_shift(2, v); return o; }
function parseuint16a(blob, length/*:: :?number, opts:?any*/) { return parslurp(blob,length,parseuint16);}

/* --- 2.5 Structures --- */

/* [MS-XLS] 2.5.10 Bes (boolean or error) */
function parse_Bes(blob/*::, length*/) {
	var v = blob.read_shift(1), t = blob.read_shift(1);
	return t === 0x01 ? v : v === 0x01;
}
function write_Bes(v, t/*:string*/, o) {
	if(!o) o = new_buf(2);
	o.write_shift(1, ((t == 'e') ? +v : +!!v));
	o.write_shift(1, ((t == 'e') ? 1 : 0));
	return o;
}

/* [MS-XLS] 2.5.240 ShortXLUnicodeString */
function parse_ShortXLUnicodeString(blob, length, opts) {
	var cch = blob.read_shift(opts && opts.biff >= 12 ? 2 : 1);
	var encoding = 'sbcs-cont';
	var cp = current_codepage;
	if(opts && opts.biff >= 8) current_codepage = 1200;
	if(!opts || opts.biff == 8 ) {
		var fHighByte = blob.read_shift(1);
		if(fHighByte) { encoding = 'dbcs-cont'; }
	} else if(opts.biff == 12) {
		encoding = 'wstr';
	}
	if(opts.biff >= 2 && opts.biff <= 5) encoding = 'cpstr';
	var o = cch ? blob.read_shift(cch, encoding) : "";
	current_codepage = cp;
	return o;
}

/* 2.5.293 XLUnicodeRichExtendedString */
function parse_XLUnicodeRichExtendedString(blob) {
	var cp = current_codepage;
	current_codepage = 1200;
	var cch = blob.read_shift(2), flags = blob.read_shift(1);
	var /*fHighByte = flags & 0x1,*/ fExtSt = flags & 0x4, fRichSt = flags & 0x8;
	var width = 1 + (flags & 0x1); // 0x0 -> utf8, 0x1 -> dbcs
	var cRun = 0, cbExtRst;
	var z = {};
	if(fRichSt) cRun = blob.read_shift(2);
	if(fExtSt) cbExtRst = blob.read_shift(4);
	var encoding = width == 2 ? 'dbcs-cont' : 'sbcs-cont';
	var msg = cch === 0 ? "" : blob.read_shift(cch, encoding);
	if(fRichSt) blob.l += 4 * cRun; //TODO: parse this
	if(fExtSt) blob.l += cbExtRst; //TODO: parse this
	z.t = msg;
	if(!fRichSt) { z.raw = "<t>" + z.t + "</t>"; z.r = z.t; }
	current_codepage = cp;
	return z;
}
function write_XLUnicodeRichExtendedString(xlstr/*:: :XLString, opts*/) {
	var str = (xlstr.t||""), nfmts = 1;

	var hdr = new_buf(3 + (nfmts > 1 ? 2 : 0));
	hdr.write_shift(2, str.length);
	hdr.write_shift(1, (nfmts > 1 ? 0x08 : 0x00) | 0x01);
	if(nfmts > 1) hdr.write_shift(2, nfmts);

	var otext = new_buf(2 * str.length);
	otext.write_shift(2 * str.length, str, 'utf16le');

	var out = [hdr, otext];

	return bconcat(out);
}

/* 2.5.296 XLUnicodeStringNoCch */
function parse_XLUnicodeStringNoCch(blob, cch, opts) {
	var retval;
	if(opts) {
		if(opts.biff >= 2 && opts.biff <= 5) return blob.read_shift(cch, 'cpstr');
		if(opts.biff >= 12) return blob.read_shift(cch, 'dbcs-cont');
	}
	var fHighByte = blob.read_shift(1);
	if(fHighByte===0) { retval = blob.read_shift(cch, 'sbcs-cont'); }
	else { retval = blob.read_shift(cch, 'dbcs-cont'); }
	return retval;
}

/* 2.5.294 XLUnicodeString */
function parse_XLUnicodeString(blob, length, opts) {
	var cch = blob.read_shift(opts && opts.biff == 2 ? 1 : 2);
	if(cch === 0) { blob.l++; return ""; }
	return parse_XLUnicodeStringNoCch(blob, cch, opts);
}
/* BIFF5 override */
function parse_XLUnicodeString2(blob, length, opts) {
	if(opts.biff > 5) return parse_XLUnicodeString(blob, length, opts);
	var cch = blob.read_shift(1);
	if(cch === 0) { blob.l++; return ""; }
	return blob.read_shift(cch, (opts.biff <= 4 || !blob.lens ) ? 'cpstr' : 'sbcs-cont');
}
/* TODO: BIFF5 and lower, codepage awareness */
function write_XLUnicodeString(str, opts, o) {
	if(!o) o = new_buf(3 + 2 * str.length);
	o.write_shift(2, str.length);
	o.write_shift(1, 1);
	o.write_shift(31, str, 'utf16le');
	return o;
}

/* [MS-XLS] 2.5.61 ControlInfo */
function parse_ControlInfo(blob/*::, length, opts*/) {
	var flags = blob.read_shift(1);
	blob.l++;
	var accel = blob.read_shift(2);
	blob.l += 2;
	return [flags, accel];
}

/* [MS-OSHARED] 2.3.7.6 URLMoniker TODO: flags */
function parse_URLMoniker(blob/*::, length, opts*/) {
	var len = blob.read_shift(4), start = blob.l;
	var extra = false;
	if(len > 24) {
		/* look ahead */
		blob.l += len - 24;
		if(blob.read_shift(16) === "795881f43b1d7f48af2c825dc4852763") extra = true;
		blob.l = start;
	}
	var url = blob.read_shift((extra?len-24:len)>>1, 'utf16le').replace(chr0,"");
	if(extra) blob.l += 24;
	return url;
}

/* [MS-OSHARED] 2.3.7.8 FileMoniker TODO: all fields */
function parse_FileMoniker(blob/*::, length*/) {
	var cAnti = blob.read_shift(2);
	var preamble = ""; while(cAnti-- > 0) preamble += "../";
	var ansiPath = blob.read_shift(0, 'lpstr-ansi');
	blob.l += 2; //var endServer = blob.read_shift(2);
	if(blob.read_shift(2) != 0xDEAD) throw new Error("Bad FileMoniker");
	var sz = blob.read_shift(4);
	if(sz === 0) return preamble + ansiPath.replace(/\\/g,"/");
	var bytes = blob.read_shift(4);
	if(blob.read_shift(2) != 3) throw new Error("Bad FileMoniker");
	var unicodePath = blob.read_shift(bytes>>1, 'utf16le').replace(chr0,"");
	return preamble + unicodePath;
}

/* [MS-OSHARED] 2.3.7.2 HyperlinkMoniker TODO: all the monikers */
function parse_HyperlinkMoniker(blob, length) {
	var clsid = blob.read_shift(16); length -= 16;
	switch(clsid) {
		case "e0c9ea79f9bace118c8200aa004ba90b": return parse_URLMoniker(blob, length);
		case "0303000000000000c000000000000046": return parse_FileMoniker(blob, length);
		default: throw new Error("Unsupported Moniker " + clsid);
	}
}

/* [MS-OSHARED] 2.3.7.9 HyperlinkString */
function parse_HyperlinkString(blob/*::, length*/) {
	var len = blob.read_shift(4);
	var o = len > 0 ? blob.read_shift(len, 'utf16le').replace(chr0, "") : "";
	return o;
}
function write_HyperlinkString(str/*:string*/, o) {
	if(!o) o = new_buf(6 + str.length * 2);
	o.write_shift(4, 1 + str.length);
	for(var i = 0; i < str.length; ++i) o.write_shift(2, str.charCodeAt(i));
	o.write_shift(2, 0);
	return o;
}

/* [MS-OSHARED] 2.3.7.1 Hyperlink Object */
function parse_Hyperlink(blob, length)/*:Hyperlink*/ {
	var end = blob.l + length;
	var sVer = blob.read_shift(4);
	if(sVer !== 2) throw new Error("Unrecognized streamVersion: " + sVer);
	var flags = blob.read_shift(2);
	blob.l += 2;
	var displayName, targetFrameName, moniker, oleMoniker, Loc="", guid, fileTime;
	if(flags & 0x0010) displayName = parse_HyperlinkString(blob, end - blob.l);
	if(flags & 0x0080) targetFrameName = parse_HyperlinkString(blob, end - blob.l);
	if((flags & 0x0101) === 0x0101) moniker = parse_HyperlinkString(blob, end - blob.l);
	if((flags & 0x0101) === 0x0001) oleMoniker = parse_HyperlinkMoniker(blob, end - blob.l);
	if(flags & 0x0008) Loc = parse_HyperlinkString(blob, end - blob.l);
	if(flags & 0x0020) guid = blob.read_shift(16);
	if(flags & 0x0040) fileTime = parse_FILETIME(blob/*, 8*/);
	blob.l = end;
	var target = targetFrameName||moniker||oleMoniker||"";
	if(target && Loc) target+="#"+Loc;
	if(!target) target = "#" + Loc;
	if((flags & 0x0002) && target.charAt(0) == "/" && target.charAt(1) != "/") target = "file://" + target;
	var out = ({Target:target}/*:any*/);
	if(guid) out.guid = guid;
	if(fileTime) out.time = fileTime;
	if(displayName) out.Tooltip = displayName;
	return out;
}
function write_Hyperlink(hl) {
	var out = new_buf(512), i = 0;
	var Target = hl.Target;
	if(Target.slice(0,7) == "file://") Target = Target.slice(7);
	var hashidx = Target.indexOf("#");
	var F = hashidx > -1 ? 0x1f : 0x17;
	switch(Target.charAt(0)) { case "#": F=0x1c; break; case ".": F&=~2; break; }
	out.write_shift(4,2); out.write_shift(4, F);
	var data = [8,6815827,6619237,4849780,83]; for(i = 0; i < data.length; ++i) out.write_shift(4, data[i]);
	if(F == 0x1C) {
		Target = Target.slice(1);
		write_HyperlinkString(Target, out);
	} else if(F & 0x02) {
		data = "e0 c9 ea 79 f9 ba ce 11 8c 82 00 aa 00 4b a9 0b".split(" ");
		for(i = 0; i < data.length; ++i) out.write_shift(1, parseInt(data[i], 16));
		var Pretarget = hashidx > -1 ? Target.slice(0, hashidx) : Target;
		out.write_shift(4, 2*(Pretarget.length + 1));
		for(i = 0; i < Pretarget.length; ++i) out.write_shift(2, Pretarget.charCodeAt(i));
		out.write_shift(2, 0);
		if(F & 0x08) write_HyperlinkString(hashidx > -1 ? Target.slice(hashidx+1): "", out);
	} else {
		data = "03 03 00 00 00 00 00 00 c0 00 00 00 00 00 00 46".split(" ");
		for(i = 0; i < data.length; ++i) out.write_shift(1, parseInt(data[i], 16));
		var P = 0;
		while(Target.slice(P*3,P*3+3)=="../"||Target.slice(P*3,P*3+3)=="..\\") ++P;
		out.write_shift(2, P);
		out.write_shift(4, Target.length - 3 * P + 1);
		for(i = 0; i < Target.length - 3 * P; ++i) out.write_shift(1, Target.charCodeAt(i + 3 * P) & 0xFF);
		out.write_shift(1, 0);
		out.write_shift(2, 0xFFFF);
		out.write_shift(2, 0xDEAD);
		for(i = 0; i < 6; ++i) out.write_shift(4, 0);
	}
	return out.slice(0, out.l);
}

/* 2.5.178 LongRGBA */
function parse_LongRGBA(blob/*::, length*/) { var r = blob.read_shift(1), g = blob.read_shift(1), b = blob.read_shift(1), a = blob.read_shift(1); return [r,g,b,a]; }

/* 2.5.177 LongRGB */
function parse_LongRGB(blob, length) { var x = parse_LongRGBA(blob, length); x[3] = 0; return x; }


/* [MS-XLS] 2.5.19 */
function parse_XLSCell(blob/*::, length*/)/*:Cell*/ {
	var rw = blob.read_shift(2); // 0-indexed
	var col = blob.read_shift(2);
	var ixfe = blob.read_shift(2);
	return ({r:rw, c:col, ixfe:ixfe}/*:any*/);
}
function write_XLSCell(R/*:number*/, C/*:number*/, ixfe/*:?number*/, o) {
	if(!o) o = new_buf(6);
	o.write_shift(2, R);
	o.write_shift(2, C);
	o.write_shift(2, ixfe||0);
	return o;
}

/* [MS-XLS] 2.5.134 */
function parse_frtHeader(blob) {
	var rt = blob.read_shift(2);
	var flags = blob.read_shift(2); // TODO: parse these flags
	blob.l += 8;
	return {type: rt, flags: flags};
}



function parse_OptXLUnicodeString(blob, length, opts) { return length === 0 ? "" : parse_XLUnicodeString2(blob, length, opts); }

/* [MS-XLS] 2.5.344 */
function parse_XTI(blob, length, opts) {
	var w = opts.biff > 8 ? 4 : 2;
	var iSupBook = blob.read_shift(w), itabFirst = blob.read_shift(w,'i'), itabLast = blob.read_shift(w,'i');
	return [iSupBook, itabFirst, itabLast];
}

/* [MS-XLS] 2.5.218 */
function parse_RkRec(blob) {
	var ixfe = blob.read_shift(2);
	var RK = parse_RkNumber(blob);
	return [ixfe, RK];
}

/* [MS-XLS] 2.5.1 */
function parse_AddinUdf(blob, length, opts) {
	blob.l += 4; length -= 4;
	var l = blob.l + length;
	var udfName = parse_ShortXLUnicodeString(blob, length, opts);
	var cb = blob.read_shift(2);
	l -= blob.l;
	if(cb !== l) throw new Error("Malformed AddinUdf: padding = " + l + " != " + cb);
	blob.l += cb;
	return udfName;
}

/* [MS-XLS] 2.5.209 TODO: Check sizes */
function parse_Ref8U(blob/*::, length*/) {
	var rwFirst = blob.read_shift(2);
	var rwLast = blob.read_shift(2);
	var colFirst = blob.read_shift(2);
	var colLast = blob.read_shift(2);
	return {s:{c:colFirst, r:rwFirst}, e:{c:colLast,r:rwLast}};
}
function write_Ref8U(r/*:Range*/, o) {
	if(!o) o = new_buf(8);
	o.write_shift(2, r.s.r);
	o.write_shift(2, r.e.r);
	o.write_shift(2, r.s.c);
	o.write_shift(2, r.e.c);
	return o;
}

/* [MS-XLS] 2.5.211 */
function parse_RefU(blob/*::, length*/) {
	var rwFirst = blob.read_shift(2);
	var rwLast = blob.read_shift(2);
	var colFirst = blob.read_shift(1);
	var colLast = blob.read_shift(1);
	return {s:{c:colFirst, r:rwFirst}, e:{c:colLast,r:rwLast}};
}

/* [MS-XLS] 2.5.207 */
var parse_Ref = parse_RefU;

/* [MS-XLS] 2.5.143 */
function parse_FtCmo(blob/*::, length*/) {
	blob.l += 4;
	var ot = blob.read_shift(2);
	var id = blob.read_shift(2);
	var flags = blob.read_shift(2);
	blob.l+=12;
	return [id, ot, flags];
}

/* [MS-XLS] 2.5.149 */
function parse_FtNts(blob) {
	var out = {};
	blob.l += 4;
	blob.l += 16; // GUID TODO
	out.fSharedNote = blob.read_shift(2);
	blob.l += 4;
	return out;
}

/* [MS-XLS] 2.5.142 */
function parse_FtCf(blob) {
	var out = {};
	blob.l += 4;
	blob.cf = blob.read_shift(2);
	return out;
}

/* [MS-XLS] 2.5.140 - 2.5.154 and friends */
function parse_FtSkip(blob) { blob.l += 2; blob.l += blob.read_shift(2); }
var FtTab = {
	/*::[*/0x00/*::]*/: parse_FtSkip,      /* FtEnd */
	/*::[*/0x04/*::]*/: parse_FtSkip,      /* FtMacro */
	/*::[*/0x05/*::]*/: parse_FtSkip,      /* FtButton */
	/*::[*/0x06/*::]*/: parse_FtSkip,      /* FtGmo */
	/*::[*/0x07/*::]*/: parse_FtCf,        /* FtCf */
	/*::[*/0x08/*::]*/: parse_FtSkip,      /* FtPioGrbit */
	/*::[*/0x09/*::]*/: parse_FtSkip,      /* FtPictFmla */
	/*::[*/0x0A/*::]*/: parse_FtSkip,      /* FtCbls */
	/*::[*/0x0B/*::]*/: parse_FtSkip,      /* FtRbo */
	/*::[*/0x0C/*::]*/: parse_FtSkip,      /* FtSbs */
	/*::[*/0x0D/*::]*/: parse_FtNts,       /* FtNts */
	/*::[*/0x0E/*::]*/: parse_FtSkip,      /* FtSbsFmla */
	/*::[*/0x0F/*::]*/: parse_FtSkip,      /* FtGboData */
	/*::[*/0x10/*::]*/: parse_FtSkip,      /* FtEdoData */
	/*::[*/0x11/*::]*/: parse_FtSkip,      /* FtRboData */
	/*::[*/0x12/*::]*/: parse_FtSkip,      /* FtCblsData */
	/*::[*/0x13/*::]*/: parse_FtSkip,      /* FtLbsData */
	/*::[*/0x14/*::]*/: parse_FtSkip,      /* FtCblsFmla */
	/*::[*/0x15/*::]*/: parse_FtCmo
};
function parse_FtArray(blob, length/*::, ot*/) {
	var tgt = blob.l + length;
	var fts = [];
	while(blob.l < tgt) {
		var ft = blob.read_shift(2);
		blob.l-=2;
		try {
			fts.push(FtTab[ft](blob, tgt - blob.l));
		} catch(e) { blob.l = tgt; return fts; }
	}
	if(blob.l != tgt) blob.l = tgt; //throw new Error("bad Object Ft-sequence");
	return fts;
}

/* --- 2.4 Records --- */

/* [MS-XLS] 2.4.21 */
function parse_BOF(blob, length) {
	var o = {BIFFVer:0, dt:0};
	o.BIFFVer = blob.read_shift(2); length -= 2;
	if(length >= 2) { o.dt = blob.read_shift(2); blob.l -= 2; }
	switch(o.BIFFVer) {
		case 0x0600: /* BIFF8 */
		case 0x0500: /* BIFF5 */
		case 0x0400: /* BIFF4 */
		case 0x0300: /* BIFF3 */
		case 0x0200: /* BIFF2 */
		case 0x0002: case 0x0007: /* BIFF2 */
			break;
		default: if(length > 6) throw new Error("Unexpected BIFF Ver " + o.BIFFVer);
	}

	blob.read_shift(length);
	return o;
}
function write_BOF(wb/*:Workbook*/, t/*:number*/, o) {
	var h = 0x0600, w = 16;
	switch(o.bookType) {
		case 'biff8': break;
		case 'biff5': h = 0x0500; w = 8; break;
		case 'biff4': h = 0x0004; w = 6; break;
		case 'biff3': h = 0x0003; w = 6; break;
		case 'biff2': h = 0x0002; w = 4; break;
		case 'xla': break;
		default: throw new Error("unsupported BIFF version");
	}
	var out = new_buf(w);
	out.write_shift(2, h);
	out.write_shift(2, t);
	if(w > 4) out.write_shift(2, 0x7262);
	if(w > 6) out.write_shift(2, 0x07CD);
	if(w > 8) {
		out.write_shift(2, 0xC009);
		out.write_shift(2, 0x0001);
		out.write_shift(2, 0x0706);
		out.write_shift(2, 0x0000);
	}
	return out;
}


/* [MS-XLS] 2.4.146 */
function parse_InterfaceHdr(blob, length) {
	if(length === 0) return 0x04b0;
	if((blob.read_shift(2))!==0x04b0){/* empty */}
	return 0x04b0;
}


/* [MS-XLS] 2.4.349 */
function parse_WriteAccess(blob, length, opts) {
	if(opts.enc) { blob.l += length; return ""; }
	var l = blob.l;
	// TODO: make sure XLUnicodeString doesnt overrun
	var UserName = parse_XLUnicodeString2(blob, 0, opts);
	blob.read_shift(length + l - blob.l);
	return UserName;
}
function write_WriteAccess(s/*:string*/, opts) {
	var b8 = !opts || opts.biff == 8;
	var o = new_buf(b8 ? 112 : 54);
	o.write_shift(opts.biff == 8 ? 2 : 1, 7);
	if(b8) o.write_shift(1, 0);
	o.write_shift(4, 0x33336853);
	o.write_shift(4, (0x00534A74 | (b8 ? 0 : 0x20000000)));
	while(o.l < o.length) o.write_shift(1, (b8 ? 0 : 32));
	return o;
}

/* [MS-XLS] 2.4.351 */
function parse_WsBool(blob, length, opts) {
	var flags = opts && opts.biff == 8 || length == 2 ? blob.read_shift(2) : (blob.l += length, 0);
	return { fDialog: flags & 0x10, fBelow: flags & 0x40, fRight: flags & 0x80 };
}

/* [MS-XLS] 2.4.28 */
function parse_BoundSheet8(blob, length, opts) {
	var pos = blob.read_shift(4);
	var hidden = blob.read_shift(1) & 0x03;
	var dt = blob.read_shift(1);
	switch(dt) {
		case 0: dt = 'Worksheet'; break;
		case 1: dt = 'Macrosheet'; break;
		case 2: dt = 'Chartsheet'; break;
		case 6: dt = 'VBAModule'; break;
	}
	var name = parse_ShortXLUnicodeString(blob, 0, opts);
	if(name.length === 0) name = "Sheet1";
	return { pos:pos, hs:hidden, dt:dt, name:name };
}
function write_BoundSheet8(data, opts) {
	var w = (!opts || opts.biff >= 8 ? 2 : 1);
	var o = new_buf(8 + w * data.name.length);
	o.write_shift(4, data.pos);
	o.write_shift(1, data.hs || 0);
	o.write_shift(1, data.dt);
	o.write_shift(1, data.name.length);
	if(opts.biff >= 8) o.write_shift(1, 1);
	o.write_shift(w * data.name.length, data.name, opts.biff < 8 ? 'sbcs' : 'utf16le');
	var out = o.slice(0, o.l);
	out.l = o.l; return out;
}

/* [MS-XLS] 2.4.265 TODO */
function parse_SST(blob, length)/*:SST*/ {
	var end = blob.l + length;
	var cnt = blob.read_shift(4);
	var ucnt = blob.read_shift(4);
	var strs/*:SST*/ = ([]/*:any*/);
	for(var i = 0; i != ucnt && blob.l < end; ++i) {
		strs.push(parse_XLUnicodeRichExtendedString(blob));
	}
	strs.Count = cnt; strs.Unique = ucnt;
	return strs;
}
function write_SST(sst, opts) {
	var header = new_buf(8);
	header.write_shift(4, sst.Count);
	header.write_shift(4, sst.Unique);
	var strs = [];
	for(var j = 0; j < sst.length; ++j) strs[j] = write_XLUnicodeRichExtendedString(sst[j], opts);
	var o = bconcat([header].concat(strs));
	/*::(*/o/*:: :any)*/.parts = [header.length].concat(strs.map(function(str) { return str.length; }));
	return o;
}

/* [MS-XLS] 2.4.107 */
function parse_ExtSST(blob, length) {
	var extsst = {};
	extsst.dsst = blob.read_shift(2);
	blob.l += length-2;
	return extsst;
}


/* [MS-XLS] 2.4.221 TODO: check BIFF2-4 */
function parse_Row(blob) {
	var z = ({}/*:any*/);
	z.r = blob.read_shift(2);
	z.c = blob.read_shift(2);
	z.cnt = blob.read_shift(2) - z.c;
	var miyRw = blob.read_shift(2);
	blob.l += 4; // reserved(2), unused(2)
	var flags = blob.read_shift(1); // various flags
	blob.l += 3; // reserved(8), ixfe(12), flags(4)
	if(flags & 0x07) z.level = flags & 0x07;
	// collapsed: flags & 0x10
	if(flags & 0x20) z.hidden = true;
	if(flags & 0x40) z.hpt = miyRw / 20;
	return z;
}


/* [MS-XLS] 2.4.125 */
function parse_ForceFullCalculation(blob) {
	var header = parse_frtHeader(blob);
	if(header.type != 0x08A3) throw new Error("Invalid Future Record " + header.type);
	var fullcalc = blob.read_shift(4);
	return fullcalc !== 0x0;
}





/* [MS-XLS] 2.4.215 rt */
function parse_RecalcId(blob) {
	blob.read_shift(2);
	return blob.read_shift(4);
}

/* [MS-XLS] 2.4.87 */
function parse_DefaultRowHeight(blob, length, opts) {
	var f = 0;
	if(!(opts && opts.biff == 2)) {
		f = blob.read_shift(2);
	}
	var miyRw = blob.read_shift(2);
	if((opts && opts.biff == 2)) {
		f = 1 - (miyRw >> 15); miyRw &= 0x7fff;
	}
	var fl = {Unsynced:f&1,DyZero:(f&2)>>1,ExAsc:(f&4)>>2,ExDsc:(f&8)>>3};
	return [fl, miyRw];
}

/* [MS-XLS] 2.4.345 TODO */
function parse_Window1(blob) {
	var xWn = blob.read_shift(2), yWn = blob.read_shift(2), dxWn = blob.read_shift(2), dyWn = blob.read_shift(2);
	var flags = blob.read_shift(2), iTabCur = blob.read_shift(2), iTabFirst = blob.read_shift(2);
	var ctabSel = blob.read_shift(2), wTabRatio = blob.read_shift(2);
	return { Pos: [xWn, yWn], Dim: [dxWn, dyWn], Flags: flags, CurTab: iTabCur,
		FirstTab: iTabFirst, Selected: ctabSel, TabRatio: wTabRatio };
}
function write_Window1(/*::opts*/) {
	var o = new_buf(18);
	o.write_shift(2, 0);
	o.write_shift(2, 0);
	o.write_shift(2, 0x7260);
	o.write_shift(2, 0x44c0);
	o.write_shift(2, 0x38);
	o.write_shift(2, 0);
	o.write_shift(2, 0);
	o.write_shift(2, 1);
	o.write_shift(2, 0x01f4);
	return o;
}
/* [MS-XLS] 2.4.346 TODO */
function parse_Window2(blob, length, opts) {
	if(opts && opts.biff >= 2 && opts.biff < 5) return {};
	var f = blob.read_shift(2);
	return { RTL: f & 0x40 };
}
function write_Window2(view) {
	var o = new_buf(18), f = 0x6b6;
	if(view && view.RTL) f |= 0x40;
	o.write_shift(2, f);
	o.write_shift(4, 0);
	o.write_shift(4, 64);
	o.write_shift(4, 0);
	o.write_shift(4, 0);
	return o;
}

/* [MS-XLS] 2.4.189 TODO */
function parse_Pane(/*blob, length, opts*/) {
}

/* [MS-XLS] 2.4.122 TODO */
function parse_Font(blob, length, opts) {
	var o/*:any*/ = {
		dyHeight: blob.read_shift(2),
		fl: blob.read_shift(2)
	};
	switch((opts && opts.biff) || 8) {
		case 2: break;
		case 3: case 4: blob.l += 2; break;
		default: blob.l += 10; break;
	}
	o.name = parse_ShortXLUnicodeString(blob, 0, opts);
	return o;
}
function write_Font(data, opts) {
	var name = data.name || "Arial";
	var b5 = (opts && (opts.biff == 5)), w = (b5 ? (15 + name.length) : (16 + 2 * name.length));
	var o = new_buf(w);
	o.write_shift(2, (data.sz || 12) * 20);
	o.write_shift(4, 0);
	o.write_shift(2, 400);
	o.write_shift(4, 0);
	o.write_shift(2, 0);
	o.write_shift(1, name.length);
	if(!b5) o.write_shift(1, 1);
	o.write_shift((b5 ? 1 : 2) * name.length, name, (b5 ? "sbcs" : "utf16le"));
	return o;
}

/* [MS-XLS] 2.4.149 */
function parse_LabelSst(blob) {
	var cell = parse_XLSCell(blob);
	cell.isst = blob.read_shift(4);
	return cell;
}
function write_LabelSst(R/*:number*/, C/*:number*/, v/*:number*/, os/*:number*/ /*::, opts*/) {
	var o = new_buf(10);
	write_XLSCell(R, C, os, o);
	o.write_shift(4, v);
	return o;
}

/* [MS-XLS] 2.4.148 */
function parse_Label(blob, length, opts) {
	if(opts.biffguess && opts.biff == 2) opts.biff = 5;
	var target = blob.l + length;
	var cell = parse_XLSCell(blob, 6);
	if(opts.biff == 2) blob.l++;
	var str = parse_XLUnicodeString(blob, target - blob.l, opts);
	cell.val = str;
	return cell;
}
function write_Label(R/*:number*/, C/*:number*/, v/*:string*/, os/*:number*/, opts) {
	var b8 = !opts || opts.biff == 8;
	var o = new_buf(6 + 2 + (+b8) + (1 + b8) * v.length);
	write_XLSCell(R, C, os, o);
	o.write_shift(2, v.length);
	if(b8) o.write_shift(1, 1);
	o.write_shift((1 + b8) * v.length, v, b8 ? 'utf16le' : 'sbcs');
	return o;
}


/* [MS-XLS] 2.4.126 Number Formats */
function parse_Format(blob, length, opts) {
	var numFmtId = blob.read_shift(2);
	var fmtstr = parse_XLUnicodeString2(blob, 0, opts);
	return [numFmtId, fmtstr];
}
function write_Format(i/*:number*/, f/*:string*/, opts, o) {
	var b5 = (opts && (opts.biff == 5));
	if(!o) o = new_buf(b5 ? (3 + f.length) : (5 + 2 * f.length));
	o.write_shift(2, i);
	o.write_shift((b5 ? 1 : 2), f.length);
	if(!b5) o.write_shift(1, 1);
	o.write_shift((b5 ? 1 : 2) * f.length, f, (b5 ? 'sbcs' : 'utf16le'));
	var out = (o.length > o.l) ? o.slice(0, o.l) : o;
	if(out.l == null) out.l = out.length;
	return out;
}
var parse_BIFF2Format = parse_XLUnicodeString2;

/* [MS-XLS] 2.4.90 */
function parse_Dimensions(blob, length, opts) {
	var end = blob.l + length;
	var w = opts.biff == 8 || !opts.biff ? 4 : 2;
	var r = blob.read_shift(w), R = blob.read_shift(w);
	var c = blob.read_shift(2), C = blob.read_shift(2);
	blob.l = end;
	return {s: {r:r, c:c}, e: {r:R, c:C}};
}
function write_Dimensions(range, opts) {
	var w = opts.biff == 8 || !opts.biff ? 4 : 2;
	var o = new_buf(2*w + 6);
	o.write_shift(w, range.s.r);
	o.write_shift(w, range.e.r + 1);
	o.write_shift(2, range.s.c);
	o.write_shift(2, range.e.c + 1);
	o.write_shift(2, 0);
	return o;
}

/* [MS-XLS] 2.4.220 */
function parse_RK(blob) {
	var rw = blob.read_shift(2), col = blob.read_shift(2);
	var rkrec = parse_RkRec(blob);
	return {r:rw, c:col, ixfe:rkrec[0], rknum:rkrec[1]};
}

/* [MS-XLS] 2.4.175 */
function parse_MulRk(blob, length) {
	var target = blob.l + length - 2;
	var rw = blob.read_shift(2), col = blob.read_shift(2);
	var rkrecs = [];
	while(blob.l < target) rkrecs.push(parse_RkRec(blob));
	if(blob.l !== target) throw new Error("MulRK read error");
	var lastcol = blob.read_shift(2);
	if(rkrecs.length != lastcol - col + 1) throw new Error("MulRK length mismatch");
	return {r:rw, c:col, C:lastcol, rkrec:rkrecs};
}
/* [MS-XLS] 2.4.174 */
function parse_MulBlank(blob, length) {
	var target = blob.l + length - 2;
	var rw = blob.read_shift(2), col = blob.read_shift(2);
	var ixfes = [];
	while(blob.l < target) ixfes.push(blob.read_shift(2));
	if(blob.l !== target) throw new Error("MulBlank read error");
	var lastcol = blob.read_shift(2);
	if(ixfes.length != lastcol - col + 1) throw new Error("MulBlank length mismatch");
	return {r:rw, c:col, C:lastcol, ixfe:ixfes};
}

/* [MS-XLS] 2.5.20 2.5.249 TODO: interpret values here */
function parse_CellStyleXF(blob, length, style, opts) {
	var o = {};
	var a = blob.read_shift(4), b = blob.read_shift(4);
	var c = blob.read_shift(4), d = blob.read_shift(2);
	o.patternType = XLSFillPattern[c >> 26];

	if(!opts.cellStyles) return o;
	o.alc = a & 0x07;
	o.fWrap = (a >> 3) & 0x01;
	o.alcV = (a >> 4) & 0x07;
	o.fJustLast = (a >> 7) & 0x01;
	o.trot = (a >> 8) & 0xFF;
	o.cIndent = (a >> 16) & 0x0F;
	o.fShrinkToFit = (a >> 20) & 0x01;
	o.iReadOrder = (a >> 22) & 0x02;
	o.fAtrNum = (a >> 26) & 0x01;
	o.fAtrFnt = (a >> 27) & 0x01;
	o.fAtrAlc = (a >> 28) & 0x01;
	o.fAtrBdr = (a >> 29) & 0x01;
	o.fAtrPat = (a >> 30) & 0x01;
	o.fAtrProt = (a >> 31) & 0x01;

	o.dgLeft = b & 0x0F;
	o.dgRight = (b >> 4) & 0x0F;
	o.dgTop = (b >> 8) & 0x0F;
	o.dgBottom = (b >> 12) & 0x0F;
	o.icvLeft = (b >> 16) & 0x7F;
	o.icvRight = (b >> 23) & 0x7F;
	o.grbitDiag = (b >> 30) & 0x03;

	o.icvTop = c & 0x7F;
	o.icvBottom = (c >> 7) & 0x7F;
	o.icvDiag = (c >> 14) & 0x7F;
	o.dgDiag = (c >> 21) & 0x0F;

	o.icvFore = d & 0x7F;
	o.icvBack = (d >> 7) & 0x7F;
	o.fsxButton = (d >> 14) & 0x01;
	return o;
}
//function parse_CellXF(blob, length, opts) {return parse_CellStyleXF(blob,length,0, opts);}
//function parse_StyleXF(blob, length, opts) {return parse_CellStyleXF(blob,length,1, opts);}

/* [MS-XLS] 2.4.353 TODO: actually do this right */
function parse_XF(blob, length, opts) {
	var o = {};
	o.ifnt = blob.read_shift(2); o.numFmtId = blob.read_shift(2); o.flags = blob.read_shift(2);
	o.fStyle = (o.flags >> 2) & 0x01;
	length -= 6;
	o.data = parse_CellStyleXF(blob, length, o.fStyle, opts);
	return o;
}
function write_XF(data, ixfeP, opts, o) {
	var b5 = (opts && (opts.biff == 5));
	if(!o) o = new_buf(b5 ? 16 : 20);
	o.write_shift(2, 0);
	if(data.style) {
		o.write_shift(2, (data.numFmtId||0));
		o.write_shift(2, 0xFFF4);
	} else {
		o.write_shift(2, (data.numFmtId||0));
		o.write_shift(2, (ixfeP<<4));
	}
	var f = 0;
	if(data.numFmtId > 0 && b5) f |= 0x0400;
	o.write_shift(4, f);
	o.write_shift(4, 0);
	if(!b5) o.write_shift(4, 0);
	o.write_shift(2, 0);
	return o;
}

/* [MS-XLS] 2.4.134 */
function parse_Guts(blob) {
	blob.l += 4;
	var out = [blob.read_shift(2), blob.read_shift(2)];
	if(out[0] !== 0) out[0]--;
	if(out[1] !== 0) out[1]--;
	if(out[0] > 7 || out[1] > 7) throw new Error("Bad Gutters: " + out.join("|"));
	return out;
}
function write_Guts(guts/*:Array<number>*/) {
	var o = new_buf(8);
	o.write_shift(4, 0);
	o.write_shift(2, guts[0] ? guts[0] + 1 : 0);
	o.write_shift(2, guts[1] ? guts[1] + 1 : 0);
	return o;
}

/* [MS-XLS] 2.4.24 */
function parse_BoolErr(blob, length, opts) {
	var cell = parse_XLSCell(blob, 6);
	if(opts.biff == 2 || length == 9) ++blob.l;
	var val = parse_Bes(blob, 2);
	cell.val = val;
	cell.t = (val === true || val === false) ? 'b' : 'e';
	return cell;
}
function write_BoolErr(R/*:number*/, C/*:number*/, v, os/*:number*/, opts, t/*:string*/) {
	var o = new_buf(8);
	write_XLSCell(R, C, os, o);
	write_Bes(v, t, o);
	return o;
}

/* [MS-XLS] 2.4.180 Number */
function parse_Number(blob, length, opts) {
	if(opts.biffguess && opts.biff == 2) opts.biff = 5;
	var cell = parse_XLSCell(blob, 6);
	var xnum = parse_Xnum(blob, 8);
	cell.val = xnum;
	return cell;
}
function write_Number(R/*:number*/, C/*:number*/, v, os/*:: :number, opts*/) {
	var o = new_buf(14);
	write_XLSCell(R, C, os, o);
	write_Xnum(v, o);
	return o;
}

var parse_XLHeaderFooter = parse_OptXLUnicodeString; // TODO: parse 2.4.136

/* [MS-XLS] 2.4.271 */
function parse_SupBook(blob, length, opts) {
	var end = blob.l + length;
	var ctab = blob.read_shift(2);
	var cch = blob.read_shift(2);
	opts.sbcch = cch;
	if(cch == 0x0401 || cch == 0x3A01) return [cch, ctab];
	if(cch < 0x01 || cch >0xff) throw new Error("Unexpected SupBook type: "+cch);
	var virtPath = parse_XLUnicodeStringNoCch(blob, cch);
	/* TODO: 2.5.277 Virtual Path */
	var rgst = [];
	while(end > blob.l) rgst.push(parse_XLUnicodeString(blob));
	return [cch, ctab, virtPath, rgst];
}

/* [MS-XLS] 2.4.105 TODO */
function parse_ExternName(blob, length, opts) {
	var flags = blob.read_shift(2);
	var body;
	var o = ({
		fBuiltIn: flags & 0x01,
		fWantAdvise: (flags >>> 1) & 0x01,
		fWantPict: (flags >>> 2) & 0x01,
		fOle: (flags >>> 3) & 0x01,
		fOleLink: (flags >>> 4) & 0x01,
		cf: (flags >>> 5) & 0x3FF,
		fIcon: flags >>> 15 & 0x01
	}/*:any*/);
	if(opts.sbcch === 0x3A01) body = parse_AddinUdf(blob, length-2, opts);
	//else throw new Error("unsupported SupBook cch: " + opts.sbcch);
	o.body = body || blob.read_shift(length-2);
	if(typeof body === "string") o.Name = body;
	return o;
}

/* [MS-XLS] 2.4.150 TODO */
var XLSLblBuiltIn = [
	"_xlnm.Consolidate_Area",
	"_xlnm.Auto_Open",
	"_xlnm.Auto_Close",
	"_xlnm.Extract",
	"_xlnm.Database",
	"_xlnm.Criteria",
	"_xlnm.Print_Area",
	"_xlnm.Print_Titles",
	"_xlnm.Recorder",
	"_xlnm.Data_Form",
	"_xlnm.Auto_Activate",
	"_xlnm.Auto_Deactivate",
	"_xlnm.Sheet_Title",
	"_xlnm._FilterDatabase"
];
function parse_Lbl(blob, length, opts) {
	var target = blob.l + length;
	var flags = blob.read_shift(2);
	var chKey = blob.read_shift(1);
	var cch = blob.read_shift(1);
	var cce = blob.read_shift(opts && opts.biff == 2 ? 1 : 2);
	var itab = 0;
	if(!opts || opts.biff >= 5) {
		if(opts.biff != 5) blob.l += 2;
		itab = blob.read_shift(2);
		if(opts.biff == 5) blob.l += 2;
		blob.l += 4;
	}
	var name = parse_XLUnicodeStringNoCch(blob, cch, opts);
	if(flags & 0x20) name = XLSLblBuiltIn[name.charCodeAt(0)];
	var npflen = target - blob.l; if(opts && opts.biff == 2) --npflen;
	/*jshint -W018 */
	var rgce = (target == blob.l || cce === 0 || !(npflen > 0)) ? [] : parse_NameParsedFormula(blob, npflen, opts, cce);
	/*jshint +W018 */
	return {
		chKey: chKey,
		Name: name,
		itab: itab,
		rgce: rgce
	};
}

/* [MS-XLS] 2.4.106 TODO: verify filename encoding */
function parse_ExternSheet(blob, length, opts) {
	if(opts.biff < 8) return parse_BIFF5ExternSheet(blob, length, opts);
	var o = [], target = blob.l + length, len = blob.read_shift(opts.biff > 8 ? 4 : 2);
	while(len-- !== 0) o.push(parse_XTI(blob, opts.biff > 8 ? 12 : 6, opts));
		// [iSupBook, itabFirst, itabLast];
	if(blob.l != target) throw new Error("Bad ExternSheet: " + blob.l + " != " + target);
	return o;
}
function parse_BIFF5ExternSheet(blob, length, opts) {
	if(blob[blob.l + 1] == 0x03) blob[blob.l]++;
	var o = parse_ShortXLUnicodeString(blob, length, opts);
	return o.charCodeAt(0) == 0x03 ? o.slice(1) : o;
}

/* [MS-XLS] 2.4.176 TODO: check older biff */
function parse_NameCmt(blob, length, opts) {
	if(opts.biff < 8) { blob.l += length; return; }
	var cchName = blob.read_shift(2);
	var cchComment = blob.read_shift(2);
	var name = parse_XLUnicodeStringNoCch(blob, cchName, opts);
	var comment = parse_XLUnicodeStringNoCch(blob, cchComment, opts);
	return [name, comment];
}

/* [MS-XLS] 2.4.260 */
function parse_ShrFmla(blob, length, opts) {
	var ref = parse_RefU(blob, 6);
	blob.l++;
	var cUse = blob.read_shift(1);
	length -= 8;
	return [parse_SharedParsedFormula(blob, length, opts), cUse, ref];
}

/* [MS-XLS] 2.4.4 TODO */
function parse_Array(blob, length, opts) {
	var ref = parse_Ref(blob, 6);
	/* TODO: fAlwaysCalc */
	switch(opts.biff) {
		case 2: blob.l ++; length -= 7; break;
		case 3: case 4: blob.l += 2; length -= 8; break;
		default: blob.l += 6; length -= 12;
	}
	return [ref, parse_ArrayParsedFormula(blob, length, opts, ref)];
}

/* [MS-XLS] 2.4.173 */
function parse_MTRSettings(blob) {
	var fMTREnabled = blob.read_shift(4) !== 0x00;
	var fUserSetThreadCount = blob.read_shift(4) !== 0x00;
	var cUserThreadCount = blob.read_shift(4);
	return [fMTREnabled, fUserSetThreadCount, cUserThreadCount];
}

/* [MS-XLS] 2.5.186 TODO: BIFF5 */
function parse_NoteSh(blob, length, opts) {
	if(opts.biff < 8) return;
	var row = blob.read_shift(2), col = blob.read_shift(2);
	var flags = blob.read_shift(2), idObj = blob.read_shift(2);
	var stAuthor = parse_XLUnicodeString2(blob, 0, opts);
	if(opts.biff < 8) blob.read_shift(1);
	return [{r:row,c:col}, stAuthor, idObj, flags];
}

/* [MS-XLS] 2.4.179 */
function parse_Note(blob, length, opts) {
	/* TODO: Support revisions */
	return parse_NoteSh(blob, length, opts);
}

/* [MS-XLS] 2.4.168 */
function parse_MergeCells(blob, length)/*:Array<Range>*/ {
	var merges/*:Array<Range>*/ = [];
	var cmcs = blob.read_shift(2);
	while (cmcs--) merges.push(parse_Ref8U(blob,length));
	return merges;
}
function write_MergeCells(merges/*:Array<Range>*/) {
	var o = new_buf(2 + merges.length * 8);
	o.write_shift(2, merges.length);
	for(var i = 0; i < merges.length; ++i) write_Ref8U(merges[i], o);
	return o;
}

/* [MS-XLS] 2.4.181 TODO: parse all the things! */
function parse_Obj(blob, length, opts) {
	if(opts && opts.biff < 8) return parse_BIFF5Obj(blob, length, opts);
	var cmo = parse_FtCmo(blob, 22); // id, ot, flags
	var fts = parse_FtArray(blob, length-22, cmo[1]);
	return { cmo: cmo, ft:fts };
}
/* from older spec */
var parse_BIFF5OT = {
0x08: function(blob, length) {
	var tgt = blob.l + length;
	blob.l += 10; // todo
	var cf = blob.read_shift(2);
	blob.l += 4;
	blob.l += 2; //var cbPictFmla = blob.read_shift(2);
	blob.l += 2;
	blob.l += 2; //var grbit = blob.read_shift(2);
	blob.l += 4;
	var cchName = blob.read_shift(1);
	blob.l += cchName; // TODO: stName
	blob.l = tgt; // TODO: fmla
	return { fmt:cf };
}
};

function parse_BIFF5Obj(blob, length, opts) {
	blob.l += 4; //var cnt = blob.read_shift(4);
	var ot = blob.read_shift(2);
	var id = blob.read_shift(2);
	var grbit = blob.read_shift(2);
	blob.l += 2; //var colL = blob.read_shift(2);
	blob.l += 2; //var dxL = blob.read_shift(2);
	blob.l += 2; //var rwT = blob.read_shift(2);
	blob.l += 2; //var dyT = blob.read_shift(2);
	blob.l += 2; //var colR = blob.read_shift(2);
	blob.l += 2; //var dxR = blob.read_shift(2);
	blob.l += 2; //var rwB = blob.read_shift(2);
	blob.l += 2; //var dyB = blob.read_shift(2);
	blob.l += 2; //var cbMacro = blob.read_shift(2);
	blob.l += 6;
	length -= 36;
	var fts = [];
	fts.push((parse_BIFF5OT[ot]||parsenoop)(blob, length, opts));
	return { cmo: [id, ot, grbit], ft:fts };
}

/* [MS-XLS] 2.4.329 TODO: parse properly */
function parse_TxO(blob, length, opts) {
	var s = blob.l;
	var texts = "";
try {
	blob.l += 4;
	var ot = (opts.lastobj||{cmo:[0,0]}).cmo[1];
	var controlInfo; // eslint-disable-line no-unused-vars
	if([0,5,7,11,12,14].indexOf(ot) == -1) blob.l += 6;
	else controlInfo = parse_ControlInfo(blob, 6, opts); // eslint-disable-line no-unused-vars
	var cchText = blob.read_shift(2);
	/*var cbRuns = */blob.read_shift(2);
	/*var ifntEmpty = */parseuint16(blob, 2);
	var len = blob.read_shift(2);
	blob.l += len;
	//var fmla = parse_ObjFmla(blob, s + length - blob.l);

	for(var i = 1; i < blob.lens.length-1; ++i) {
		if(blob.l-s != blob.lens[i]) throw new Error("TxO: bad continue record");
		var hdr = blob[blob.l];
		var t = parse_XLUnicodeStringNoCch(blob, blob.lens[i+1]-blob.lens[i]-1);
		texts += t;
		if(texts.length >= (hdr ? cchText : 2*cchText)) break;
	}
	if(texts.length !== cchText && texts.length !== cchText*2) {
		throw new Error("cchText: " + cchText + " != " + texts.length);
	}

	blob.l = s + length;
	/* [MS-XLS] 2.5.272 TxORuns */
//	var rgTxoRuns = [];
//	for(var j = 0; j != cbRuns/8-1; ++j) blob.l += 8;
//	var cchText2 = blob.read_shift(2);
//	if(cchText2 !== cchText) throw new Error("TxOLastRun mismatch: " + cchText2 + " " + cchText);
//	blob.l += 6;
//	if(s + length != blob.l) throw new Error("TxO " + (s + length) + ", at " + blob.l);
	return { t: texts };
} catch(e) { blob.l = s + length; return { t: texts }; }
}

/* [MS-XLS] 2.4.140 */
function parse_HLink(blob, length) {
	var ref = parse_Ref8U(blob, 8);
	blob.l += 16; /* CLSID */
	var hlink = parse_Hyperlink(blob, length-24);
	return [ref, hlink];
}
function write_HLink(hl) {
	var O = new_buf(24);
	var ref = decode_cell(hl[0]);
	O.write_shift(2, ref.r); O.write_shift(2, ref.r);
	O.write_shift(2, ref.c); O.write_shift(2, ref.c);
	var clsid = "d0 c9 ea 79 f9 ba ce 11 8c 82 00 aa 00 4b a9 0b".split(" ");
	for(var i = 0; i < 16; ++i) O.write_shift(1, parseInt(clsid[i], 16));
	return bconcat([O, write_Hyperlink(hl[1])]);
}


/* [MS-XLS] 2.4.141 */
function parse_HLinkTooltip(blob, length) {
	blob.read_shift(2);
	var ref = parse_Ref8U(blob, 8);
	var wzTooltip = blob.read_shift((length-10)/2, 'dbcs-cont');
	wzTooltip = wzTooltip.replace(chr0,"");
	return [ref, wzTooltip];
}
function write_HLinkTooltip(hl) {
	var TT = hl[1].Tooltip;
	var O = new_buf(10 + 2 * (TT.length + 1));
	O.write_shift(2, 0x0800);
	var ref = decode_cell(hl[0]);
	O.write_shift(2, ref.r); O.write_shift(2, ref.r);
	O.write_shift(2, ref.c); O.write_shift(2, ref.c);
	for(var i = 0; i < TT.length; ++i) O.write_shift(2, TT.charCodeAt(i));
	O.write_shift(2, 0);
	return O;
}

/* [MS-XLS] 2.4.63 */
function parse_Country(blob)/*:[string|number, string|number]*/ {
	var o = [0,0], d;
	d = blob.read_shift(2); o[0] = CountryEnum[d] || d;
	d = blob.read_shift(2); o[1] = CountryEnum[d] || d;
	return o;
}
function write_Country(o) {
	if(!o) o = new_buf(4);
	o.write_shift(2, 0x01);
	o.write_shift(2, 0x01);
	return o;
}

/* [MS-XLS] 2.4.50 ClrtClient */
function parse_ClrtClient(blob) {
	var ccv = blob.read_shift(2);
	var o = [];
	while(ccv-->0) o.push(parse_LongRGB(blob, 8));
	return o;
}

/* [MS-XLS] 2.4.188 */
function parse_Palette(blob) {
	var ccv = blob.read_shift(2);
	var o = [];
	while(ccv-->0) o.push(parse_LongRGB(blob, 8));
	return o;
}

/* [MS-XLS] 2.4.354 */
function parse_XFCRC(blob) {
	blob.l += 2;
	var o = {cxfs:0, crc:0};
	o.cxfs = blob.read_shift(2);
	o.crc = blob.read_shift(4);
	return o;
}

/* [MS-XLS] 2.4.53 TODO: parse flags */
/* [MS-XLSB] 2.4.323 TODO: parse flags */
function parse_ColInfo(blob, length, opts) {
	if(!opts.cellStyles) return parsenoop(blob, length);
	var w = opts && opts.biff >= 12 ? 4 : 2;
	var colFirst = blob.read_shift(w);
	var colLast = blob.read_shift(w);
	var coldx = blob.read_shift(w);
	var ixfe = blob.read_shift(w);
	var flags = blob.read_shift(2);
	if(w == 2) blob.l += 2;
	var o = ({s:colFirst, e:colLast, w:coldx, ixfe:ixfe, flags:flags}/*:any*/);
	if(opts.biff >= 5 || !opts.biff) o.level = (flags >> 8) & 0x7;
	return o;
}
function write_ColInfo(col, idx) {
	var o = new_buf(12);
	o.write_shift(2, idx);
	o.write_shift(2, idx);
	o.write_shift(2, col.width * 256);
	o.write_shift(2, 0);
	var f = 0;
	if(col.hidden) f |= 1;
	o.write_shift(1, f);
	f = col.level || 0;
	o.write_shift(1, f);
	o.write_shift(2, 0);
	return o;
}

/* [MS-XLS] 2.4.257 */
function parse_Setup(blob, length) {
	var o = {};
	if(length < 32) return o;
	blob.l += 16;
	o.header = parse_Xnum(blob, 8);
	o.footer = parse_Xnum(blob, 8);
	blob.l += 2;
	return o;
}

/* [MS-XLS] 2.4.261 */
function parse_ShtProps(blob, length, opts) {
	var def = {area:false};
	if(opts.biff != 5) { blob.l += length; return def; }
	var d = blob.read_shift(1); blob.l += 3;
	if((d & 0x10)) def.area = true;
	return def;
}

/* [MS-XLS] 2.4.241 */
function write_RRTabId(n/*:number*/) {
	var out = new_buf(2 * n);
	for(var i = 0; i < n; ++i) out.write_shift(2, i+1);
	return out;
}

var parse_Blank = parse_XLSCell; /* [MS-XLS] 2.4.20 Just the cell */
var parse_Scl = parseuint16a; /* [MS-XLS] 2.4.247 num, den */
var parse_String = parse_XLUnicodeString; /* [MS-XLS] 2.4.268 */

/* --- Specific to versions before BIFF8 --- */
function parse_ImData(blob) {
	var cf = blob.read_shift(2);
	var env = blob.read_shift(2);
	var lcb = blob.read_shift(4);
	var o = {fmt:cf, env:env, len:lcb, data:blob.slice(blob.l,blob.l+lcb)};
	blob.l += lcb;
	return o;
}

/* BIFF2_??? where ??? is the name from [XLS] */
function parse_BIFF2STR(blob, length, opts) {
	if(opts.biffguess && opts.biff == 5) opts.biff = 2;
	var cell = parse_XLSCell(blob, 6);
	++blob.l;
	var str = parse_XLUnicodeString2(blob, length-7, opts);
	cell.t = 'str';
	cell.val = str;
	return cell;
}

function parse_BIFF2NUM(blob/*::, length*/) {
	var cell = parse_XLSCell(blob, 6);
	++blob.l;
	var num = parse_Xnum(blob, 8);
	cell.t = 'n';
	cell.val = num;
	return cell;
}
function write_BIFF2NUM(r/*:number*/, c/*:number*/, val/*:number*/) {
	var out = new_buf(15);
	write_BIFF2Cell(out, r, c);
	out.write_shift(8, val, 'f');
	return out;
}

function parse_BIFF2INT(blob) {
	var cell = parse_XLSCell(blob, 6);
	++blob.l;
	var num = blob.read_shift(2);
	cell.t = 'n';
	cell.val = num;
	return cell;
}
function write_BIFF2INT(r/*:number*/, c/*:number*/, val/*:number*/) {
	var out = new_buf(9);
	write_BIFF2Cell(out, r, c);
	out.write_shift(2, val);
	return out;
}

function parse_BIFF2STRING(blob) {
	var cch = blob.read_shift(1);
	if(cch === 0) { blob.l++; return ""; }
	return blob.read_shift(cch, 'sbcs-cont');
}

/* TODO: convert to BIFF8 font struct */
function parse_BIFF2FONTXTRA(blob, length) {
	blob.l += 6; // unknown
	blob.l += 2; // font weight "bls"
	blob.l += 1; // charset
	blob.l += 3; // unknown
	blob.l += 1; // font family
	blob.l += length - 13;
}

/* TODO: parse rich text runs */
function parse_RString(blob, length, opts) {
	var end = blob.l + length;
	var cell = parse_XLSCell(blob, 6);
	var cch = blob.read_shift(2);
	var str = parse_XLUnicodeStringNoCch(blob, cch, opts);
	blob.l = end;
	cell.t = 'str';
	cell.val = str;
	return cell;
}
/* from js-harb (C) 2014-present  SheetJS */
var DBF_SUPPORTED_VERSIONS = (/* unused pure expression or super */ null && ([0x02, 0x03, 0x30, 0x31, 0x83, 0x8B, 0x8C, 0xF5]));
var DBF = /*#__PURE__*/(function() {
var dbf_codepage_map = {
	/* Code Pages Supported by Visual FoxPro */
	/*::[*/0x01/*::]*/:   437,           /*::[*/0x02/*::]*/:   850,
	/*::[*/0x03/*::]*/:  1252,           /*::[*/0x04/*::]*/: 10000,
	/*::[*/0x64/*::]*/:   852,           /*::[*/0x65/*::]*/:   866,
	/*::[*/0x66/*::]*/:   865,           /*::[*/0x67/*::]*/:   861,
	/*::[*/0x68/*::]*/:   895,           /*::[*/0x69/*::]*/:   620,
	/*::[*/0x6A/*::]*/:   737,           /*::[*/0x6B/*::]*/:   857,
	/*::[*/0x78/*::]*/:   950,           /*::[*/0x79/*::]*/:   949,
	/*::[*/0x7A/*::]*/:   936,           /*::[*/0x7B/*::]*/:   932,
	/*::[*/0x7C/*::]*/:   874,           /*::[*/0x7D/*::]*/:  1255,
	/*::[*/0x7E/*::]*/:  1256,           /*::[*/0x96/*::]*/: 10007,
	/*::[*/0x97/*::]*/: 10029,           /*::[*/0x98/*::]*/: 10006,
	/*::[*/0xC8/*::]*/:  1250,           /*::[*/0xC9/*::]*/:  1251,
	/*::[*/0xCA/*::]*/:  1254,           /*::[*/0xCB/*::]*/:  1253,

	/* shapefile DBF extension */
	/*::[*/0x00/*::]*/: 20127,           /*::[*/0x08/*::]*/:   865,
	/*::[*/0x09/*::]*/:   437,           /*::[*/0x0A/*::]*/:   850,
	/*::[*/0x0B/*::]*/:   437,           /*::[*/0x0D/*::]*/:   437,
	/*::[*/0x0E/*::]*/:   850,           /*::[*/0x0F/*::]*/:   437,
	/*::[*/0x10/*::]*/:   850,           /*::[*/0x11/*::]*/:   437,
	/*::[*/0x12/*::]*/:   850,           /*::[*/0x13/*::]*/:   932,
	/*::[*/0x14/*::]*/:   850,           /*::[*/0x15/*::]*/:   437,
	/*::[*/0x16/*::]*/:   850,           /*::[*/0x17/*::]*/:   865,
	/*::[*/0x18/*::]*/:   437,           /*::[*/0x19/*::]*/:   437,
	/*::[*/0x1A/*::]*/:   850,           /*::[*/0x1B/*::]*/:   437,
	/*::[*/0x1C/*::]*/:   863,           /*::[*/0x1D/*::]*/:   850,
	/*::[*/0x1F/*::]*/:   852,           /*::[*/0x22/*::]*/:   852,
	/*::[*/0x23/*::]*/:   852,           /*::[*/0x24/*::]*/:   860,
	/*::[*/0x25/*::]*/:   850,           /*::[*/0x26/*::]*/:   866,
	/*::[*/0x37/*::]*/:   850,           /*::[*/0x40/*::]*/:   852,
	/*::[*/0x4D/*::]*/:   936,           /*::[*/0x4E/*::]*/:   949,
	/*::[*/0x4F/*::]*/:   950,           /*::[*/0x50/*::]*/:   874,
	/*::[*/0x57/*::]*/:  1252,           /*::[*/0x58/*::]*/:  1252,
	/*::[*/0x59/*::]*/:  1252,           /*::[*/0x6C/*::]*/:   863,
	/*::[*/0x86/*::]*/:   737,           /*::[*/0x87/*::]*/:   852,
	/*::[*/0x88/*::]*/:   857,           /*::[*/0xCC/*::]*/:  1257,

	/*::[*/0xFF/*::]*/: 16969
};
var dbf_reverse_map = evert({
	/*::[*/0x01/*::]*/:   437,           /*::[*/0x02/*::]*/:   850,
	/*::[*/0x03/*::]*/:  1252,           /*::[*/0x04/*::]*/: 10000,
	/*::[*/0x64/*::]*/:   852,           /*::[*/0x65/*::]*/:   866,
	/*::[*/0x66/*::]*/:   865,           /*::[*/0x67/*::]*/:   861,
	/*::[*/0x68/*::]*/:   895,           /*::[*/0x69/*::]*/:   620,
	/*::[*/0x6A/*::]*/:   737,           /*::[*/0x6B/*::]*/:   857,
	/*::[*/0x78/*::]*/:   950,           /*::[*/0x79/*::]*/:   949,
	/*::[*/0x7A/*::]*/:   936,           /*::[*/0x7B/*::]*/:   932,
	/*::[*/0x7C/*::]*/:   874,           /*::[*/0x7D/*::]*/:  1255,
	/*::[*/0x7E/*::]*/:  1256,           /*::[*/0x96/*::]*/: 10007,
	/*::[*/0x97/*::]*/: 10029,           /*::[*/0x98/*::]*/: 10006,
	/*::[*/0xC8/*::]*/:  1250,           /*::[*/0xC9/*::]*/:  1251,
	/*::[*/0xCA/*::]*/:  1254,           /*::[*/0xCB/*::]*/:  1253,
	/*::[*/0x00/*::]*/: 20127
});
/* TODO: find an actual specification */
function dbf_to_aoa(buf, opts)/*:AOA*/ {
	var out/*:AOA*/ = [];
	var d/*:Block*/ = (new_raw_buf(1)/*:any*/);
	switch(opts.type) {
		case 'base64': d = s2a(Base64_decode(buf)); break;
		case 'binary': d = s2a(buf); break;
		case 'buffer':
		case 'array': d = buf; break;
	}
	prep_blob(d, 0);

	/* header */
	var ft = d.read_shift(1);
	var memo = !!(ft & 0x88);
	var vfp = false, l7 = false;
	switch(ft) {
		case 0x02: break; // dBASE II
		case 0x03: break; // dBASE III
		case 0x30: vfp = true; memo = true; break; // VFP
		case 0x31: vfp = true; memo = true; break; // VFP with autoincrement
		// 0x43 dBASE IV SQL table files
		// 0x63 dBASE IV SQL system files
		case 0x83: break; // dBASE III with memo
		case 0x8B: break; // dBASE IV with memo
		case 0x8C: l7 = true; break; // dBASE Level 7 with memo
		// case 0xCB dBASE IV SQL table files with memo
		case 0xF5: break; // FoxPro 2.x with memo
		// case 0xFB FoxBASE
		default: throw new Error("DBF Unsupported Version: " + ft.toString(16));
	}

	var nrow = 0, fpos = 0x0209;
	if(ft == 0x02) nrow = d.read_shift(2);
	d.l += 3; // dBASE II stores DDMMYY date, others use YYMMDD
	if(ft != 0x02) nrow = d.read_shift(4);
	if(nrow > 1048576) nrow = 1e6;

	if(ft != 0x02) fpos = d.read_shift(2); // header length
	var rlen = d.read_shift(2); // record length

	var /*flags = 0,*/ current_cp = opts.codepage || 1252;
	if(ft != 0x02) { // 20 reserved bytes
		d.l+=16;
		/*flags = */d.read_shift(1);
		//if(memo && ((flags & 0x02) === 0)) throw new Error("DBF Flags " + flags.toString(16) + " ft " + ft.toString(16));

		/* codepage present in FoxPro and dBASE Level 7 */
		if(d[d.l] !== 0) current_cp = dbf_codepage_map[d[d.l]];
		d.l+=1;

		d.l+=2;
	}
	if(l7) d.l += 36; // Level 7: 32 byte "Language driver name", 4 byte reserved

/*:: type DBFField = { name:string; len:number; type:string; } */
	var fields/*:Array<DBFField>*/ = [], field/*:DBFField*/ = ({}/*:any*/);
	var hend = Math.min(d.length, (ft == 0x02 ? 0x209 : (fpos - 10 - (vfp ? 264 : 0))));
	var ww = l7 ? 32 : 11;
	while(d.l < hend && d[d.l] != 0x0d) {
		field = ({}/*:any*/);
		field.name = $cptable.utils.decode(current_cp, d.slice(d.l, d.l+ww)).replace(/[\u0000\r\n].*$/g,"");
		d.l += ww;
		field.type = String.fromCharCode(d.read_shift(1));
		if(ft != 0x02 && !l7) field.offset = d.read_shift(4);
		field.len = d.read_shift(1);
		if(ft == 0x02) field.offset = d.read_shift(2);
		field.dec = d.read_shift(1);
		if(field.name.length) fields.push(field);
		if(ft != 0x02) d.l += l7 ? 13 : 14;
		switch(field.type) {
			case 'B': // Double (VFP) / Binary (dBASE L7)
				if((!vfp || field.len != 8) && opts.WTF) console.log('Skipping ' + field.name + ':' + field.type);
				break;
			case 'G': // General (FoxPro and dBASE L7)
			case 'P': // Picture (FoxPro and dBASE L7)
				if(opts.WTF) console.log('Skipping ' + field.name + ':' + field.type);
				break;
			case '+': // Autoincrement (dBASE L7 only)
			case '0': // _NullFlags (VFP only)
			case '@': // Timestamp (dBASE L7 only)
			case 'C': // Character (dBASE II)
			case 'D': // Date (dBASE III)
			case 'F': // Float (dBASE IV)
			case 'I': // Long (VFP and dBASE L7)
			case 'L': // Logical (dBASE II)
			case 'M': // Memo (dBASE III)
			case 'N': // Number (dBASE II)
			case 'O': // Double (dBASE L7 only)
			case 'T': // Datetime (VFP only)
			case 'Y': // Currency (VFP only)
				break;
			default: throw new Error('Unknown Field Type: ' + field.type);
		}
	}

	if(d[d.l] !== 0x0D) d.l = fpos-1;
	if(d.read_shift(1) !== 0x0D) throw new Error("DBF Terminator not found " + d.l + " " + d[d.l]);
	d.l = fpos;

	/* data */
	var R = 0, C = 0;
	out[0] = [];
	for(C = 0; C != fields.length; ++C) out[0][C] = fields[C].name;
	while(nrow-- > 0) {
		if(d[d.l] === 0x2A) {
			// TODO: record marked as deleted -- create a hidden row?
			d.l+=rlen;
			continue;
		}
		++d.l;
		out[++R] = []; C = 0;
		for(C = 0; C != fields.length; ++C) {
			var dd = d.slice(d.l, d.l+fields[C].len); d.l+=fields[C].len;
			prep_blob(dd, 0);
			var s = $cptable.utils.decode(current_cp, dd);
			switch(fields[C].type) {
				case 'C':
					// NOTE: it is conventional to write '  /  /  ' for empty dates
					if(s.trim().length) out[R][C] = s.replace(/\s+$/,"");
					break;
				case 'D':
					if(s.length === 8) out[R][C] = new Date(+s.slice(0,4), +s.slice(4,6)-1, +s.slice(6,8));
					else out[R][C] = s;
					break;
				case 'F': out[R][C] = parseFloat(s.trim()); break;
				case '+': case 'I': out[R][C] = l7 ? dd.read_shift(-4, 'i') ^ 0x80000000 : dd.read_shift(4, 'i'); break;
				case 'L': switch(s.trim().toUpperCase()) {
					case 'Y': case 'T': out[R][C] = true; break;
					case 'N': case 'F': out[R][C] = false; break;
					case '': case '?': break;
					default: throw new Error("DBF Unrecognized L:|" + s + "|");
					} break;
				case 'M': /* TODO: handle memo files */
					if(!memo) throw new Error("DBF Unexpected MEMO for type " + ft.toString(16));
					out[R][C] = "##MEMO##" + (l7 ? parseInt(s.trim(), 10): dd.read_shift(4));
					break;
				case 'N':
					s = s.replace(/\u0000/g,"").trim();
					// NOTE: dBASE II interprets "  .  " as 0
					if(s && s != ".") out[R][C] = +s || 0; break;
				case '@':
					// NOTE: dBASE specs appear to be incorrect
					out[R][C] = new Date(dd.read_shift(-8, 'f') - 0x388317533400);
					break;
				case 'T': out[R][C] = new Date((dd.read_shift(4) - 0x253D8C) * 0x5265C00 + dd.read_shift(4)); break;
				case 'Y': out[R][C] = dd.read_shift(4,'i')/1e4 + (dd.read_shift(4, 'i')/1e4)*Math.pow(2,32); break;
				case 'O': out[R][C] = -dd.read_shift(-8, 'f'); break;
				case 'B': if(vfp && fields[C].len == 8) { out[R][C] = dd.read_shift(8,'f'); break; }
					/* falls through */
				case 'G': case 'P': dd.l += fields[C].len; break;
				case '0':
					if(fields[C].name === '_NullFlags') break;
					/* falls through */
				default: throw new Error("DBF Unsupported data type " + fields[C].type);
			}
		}
	}
	if(ft != 0x02) if(d.l < d.length && d[d.l++] != 0x1A) throw new Error("DBF EOF Marker missing " + (d.l-1) + " of " + d.length + " " + d[d.l-1].toString(16));
	if(opts && opts.sheetRows) out = out.slice(0, opts.sheetRows);
	opts.DBF = fields;
	return out;
}

function dbf_to_sheet(buf, opts)/*:Worksheet*/ {
	var o = opts || {};
	if(!o.dateNF) o.dateNF = "yyyymmdd";
	var ws = aoa_to_sheet(dbf_to_aoa(buf, o), o);
	ws["!cols"] = o.DBF.map(function(field) { return {
		wch: field.len,
		DBF: field
	};});
	delete o.DBF;
	return ws;
}

function dbf_to_workbook(buf, opts)/*:Workbook*/ {
	try { return sheet_to_workbook(dbf_to_sheet(buf, opts), opts); }
	catch(e) { if(opts && opts.WTF) throw e; }
	return ({SheetNames:[],Sheets:{}});
}

var _RLEN = { 'B': 8, 'C': 250, 'L': 1, 'D': 8, '?': 0, '': 0 };
function sheet_to_dbf(ws/*:Worksheet*/, opts/*:WriteOpts*/) {
	var o = opts || {};
	if(+o.codepage >= 0) set_cp(+o.codepage);
	if(o.type == "string") throw new Error("Cannot write DBF to JS string");
	var ba = buf_array();
	var aoa/*:AOA*/ = sheet_to_json(ws, {header:1, raw:true, cellDates:true});
	var headers = aoa[0], data = aoa.slice(1), cols = ws["!cols"] || [];
	var i = 0, j = 0, hcnt = 0, rlen = 1;
	for(i = 0; i < headers.length; ++i) {
		if(((cols[i]||{}).DBF||{}).name) { headers[i] = cols[i].DBF.name; ++hcnt; continue; }
		if(headers[i] == null) continue;
		++hcnt;
		if(typeof headers[i] === 'number') headers[i] = headers[i].toString(10);
		if(typeof headers[i] !== 'string') throw new Error("DBF Invalid column name " + headers[i] + " |" + (typeof headers[i]) + "|");
		if(headers.indexOf(headers[i]) !== i) for(j=0; j<1024;++j)
			if(headers.indexOf(headers[i] + "_" + j) == -1) { headers[i] += "_" + j; break; }
	}
	var range = safe_decode_range(ws['!ref']);
	var coltypes/*:Array<string>*/ = [];
	var colwidths/*:Array<number>*/ = [];
	var coldecimals/*:Array<number>*/ = [];
	for(i = 0; i <= range.e.c - range.s.c; ++i) {
		var guess = '', _guess = '', maxlen = 0;
		var col/*:Array<any>*/ = [];
		for(j=0; j < data.length; ++j) {
			if(data[j][i] != null) col.push(data[j][i]);
		}
		if(col.length == 0 || headers[i] == null) { coltypes[i] = '?'; continue; }
		for(j = 0; j < col.length; ++j) {
			switch(typeof col[j]) {
				/* TODO: check if L2 compat is desired */
				case 'number': _guess = 'B'; break;
				case 'string': _guess = 'C'; break;
				case 'boolean': _guess = 'L'; break;
				case 'object': _guess = col[j] instanceof Date ? 'D' : 'C'; break;
				default: _guess = 'C';
			}
			maxlen = Math.max(maxlen, String(col[j]).length);
			guess = guess && guess != _guess ? 'C' : _guess;
			//if(guess == 'C') break;
		}
		if(maxlen > 250) maxlen = 250;
		_guess = ((cols[i]||{}).DBF||{}).type;
		/* TODO: more fine grained control over DBF type resolution */
		if(_guess == 'C') {
			if(cols[i].DBF.len > maxlen) maxlen = cols[i].DBF.len;
		}
		if(guess == 'B' && _guess == 'N') {
			guess = 'N';
			coldecimals[i] = cols[i].DBF.dec;
			maxlen = cols[i].DBF.len;
		}
		colwidths[i] = guess == 'C' || _guess == 'N' ? maxlen : (_RLEN[guess] || 0);
		rlen += colwidths[i];
		coltypes[i] = guess;
	}

	var h = ba.next(32);
	h.write_shift(4, 0x13021130);
	h.write_shift(4, data.length);
	h.write_shift(2, 296 + 32 * hcnt);
	h.write_shift(2, rlen);
	for(i=0; i < 4; ++i) h.write_shift(4, 0);
	h.write_shift(4, 0x00000000 | ((+dbf_reverse_map[/*::String(*/current_ansi/*::)*/] || 0x03)<<8));

	for(i = 0, j = 0; i < headers.length; ++i) {
		if(headers[i] == null) continue;
		var hf = ba.next(32);
		var _f = (headers[i].slice(-10) + "\x00\x00\x00\x00\x00\x00\x00\x00\x00\x00\x00").slice(0, 11);
		hf.write_shift(1, _f, "sbcs");
		hf.write_shift(1, coltypes[i] == '?' ? 'C' : coltypes[i], "sbcs");
		hf.write_shift(4, j);
		hf.write_shift(1, colwidths[i] || _RLEN[coltypes[i]] || 0);
		hf.write_shift(1, coldecimals[i] || 0);
		hf.write_shift(1, 0x02);
		hf.write_shift(4, 0);
		hf.write_shift(1, 0);
		hf.write_shift(4, 0);
		hf.write_shift(4, 0);
		j += (colwidths[i] || _RLEN[coltypes[i]] || 0);
	}

	var hb = ba.next(264);
	hb.write_shift(4, 0x0000000D);
	for(i=0; i < 65;++i) hb.write_shift(4, 0x00000000);
	for(i=0; i < data.length; ++i) {
		var rout = ba.next(rlen);
		rout.write_shift(1, 0);
		for(j=0; j<headers.length; ++j) {
			if(headers[j] == null) continue;
			switch(coltypes[j]) {
				case 'L': rout.write_shift(1, data[i][j] == null ? 0x3F : data[i][j] ? 0x54 : 0x46); break;
				case 'B': rout.write_shift(8, data[i][j]||0, 'f'); break;
				case 'N':
					var _n = "0";
					if(typeof data[i][j] == "number") _n = data[i][j].toFixed(coldecimals[j]||0);
					for(hcnt=0; hcnt < colwidths[j]-_n.length; ++hcnt) rout.write_shift(1, 0x20);
					rout.write_shift(1, _n, "sbcs");
					break;
				case 'D':
					if(!data[i][j]) rout.write_shift(8, "00000000", "sbcs");
					else {
						rout.write_shift(4, ("0000"+data[i][j].getFullYear()).slice(-4), "sbcs");
						rout.write_shift(2, ("00"+(data[i][j].getMonth()+1)).slice(-2), "sbcs");
						rout.write_shift(2, ("00"+data[i][j].getDate()).slice(-2), "sbcs");
					} break;
				case 'C':
					var _s = String(data[i][j] != null ? data[i][j] : "").slice(0, colwidths[j]);
					rout.write_shift(1, _s, "sbcs");
					for(hcnt=0; hcnt < colwidths[j]-_s.length; ++hcnt) rout.write_shift(1, 0x20); break;
			}
		}
		// data
	}
	ba.next(1).write_shift(1, 0x1A);
	return ba.end();
}
	return {
		to_workbook: dbf_to_workbook,
		to_sheet: dbf_to_sheet,
		from_sheet: sheet_to_dbf
	};
})();

var SYLK = /*#__PURE__*/(function() {
	/* TODO: stress test sequences */
	var sylk_escapes = ({
		AA:'À', BA:'Á', CA:'Â', DA:195, HA:'Ä', JA:197,
		AE:'È', BE:'É', CE:'Ê',         HE:'Ë',
		AI:'Ì', BI:'Í', CI:'Î',         HI:'Ï',
		AO:'Ò', BO:'Ó', CO:'Ô', DO:213, HO:'Ö',
		AU:'Ù', BU:'Ú', CU:'Û',         HU:'Ü',
		Aa:'à', Ba:'á', Ca:'â', Da:227, Ha:'ä', Ja:229,
		Ae:'è', Be:'é', Ce:'ê',         He:'ë',
		Ai:'ì', Bi:'í', Ci:'î',         Hi:'ï',
		Ao:'ò', Bo:'ó', Co:'ô', Do:245, Ho:'ö',
		Au:'ù', Bu:'ú', Cu:'û',         Hu:'ü',
		KC:'Ç', Kc:'ç', q:'æ',  z:'œ',  a:'Æ',  j:'Œ',
		DN:209, Dn:241, Hy:255,
		S:169,  c:170,  R:174,  "B ":180,
		/*::[*/0/*::]*/:176,    /*::[*/1/*::]*/:177,  /*::[*/2/*::]*/:178,
		/*::[*/3/*::]*/:179,    /*::[*/5/*::]*/:181,  /*::[*/6/*::]*/:182,
		/*::[*/7/*::]*/:183,    Q:185,  k:186,  b:208,  i:216,  l:222,  s:240,  y:248,
		"!":161, '"':162, "#":163, "(":164, "%":165, "'":167, "H ":168,
		"+":171, ";":187, "<":188, "=":189, ">":190, "?":191, "{":223
	}/*:any*/);
	var sylk_char_regex = new RegExp("\u001BN(" + keys(sylk_escapes).join("|").replace(/\|\|\|/, "|\\||").replace(/([?()+])/g,"\\$1") + "|\\|)", "gm");
	var sylk_char_fn = function(_, $1){ var o = sylk_escapes[$1]; return typeof o == "number" ? _getansi(o) : o; };
	var decode_sylk_char = function($$, $1, $2) { var newcc = (($1.charCodeAt(0) - 0x20)<<4) | ($2.charCodeAt(0) - 0x30); return newcc == 59 ? $$ : _getansi(newcc); };
	sylk_escapes["|"] = 254;
	/* TODO: find an actual specification */
	function sylk_to_aoa(d/*:RawData*/, opts)/*:[AOA, Worksheet]*/ {
		switch(opts.type) {
			case 'base64': return sylk_to_aoa_str(Base64_decode(d), opts);
			case 'binary': return sylk_to_aoa_str(d, opts);
			case 'buffer': return sylk_to_aoa_str(has_buf && Buffer.isBuffer(d) ? d.toString('binary') : a2s(d), opts);
			case 'array': return sylk_to_aoa_str(cc2str(d), opts);
		}
		throw new Error("Unrecognized type " + opts.type);
	}
	function sylk_to_aoa_str(str/*:string*/, opts)/*:[AOA, Worksheet]*/ {
		var records = str.split(/[\n\r]+/), R = -1, C = -1, ri = 0, rj = 0, arr/*:AOA*/ = [];
		var formats/*:Array<string>*/ = [];
		var next_cell_format/*:string|null*/ = null;
		var sht = {}, rowinfo/*:Array<RowInfo>*/ = [], colinfo/*:Array<ColInfo>*/ = [], cw/*:Array<string>*/ = [];
		var Mval = 0, j;
		if(+opts.codepage >= 0) set_cp(+opts.codepage);
		for (; ri !== records.length; ++ri) {
			Mval = 0;
			var rstr=records[ri].trim().replace(/\x1B([\x20-\x2F])([\x30-\x3F])/g, decode_sylk_char).replace(sylk_char_regex, sylk_char_fn);
			var record=rstr.replace(/;;/g, "\u0000").split(";").map(function(x) { return x.replace(/\u0000/g, ";"); });
			var RT=record[0], val;
			if(rstr.length > 0) switch(RT) {
			case 'ID': break; /* header */
			case 'E': break; /* EOF */
			case 'B': break; /* dimensions */
			case 'O': break; /* options? */
			case 'W': break; /* window? */
			case 'P':
				if(record[1].charAt(0) == 'P')
					formats.push(rstr.slice(3).replace(/;;/g, ";"));
				break;
			case 'C':
			var C_seen_K = false, C_seen_X = false, C_seen_S = false, C_seen_E = false, _R = -1, _C = -1;
			for(rj=1; rj<record.length; ++rj) switch(record[rj].charAt(0)) {
				case 'A': break; // TODO: comment
				case 'X': C = parseInt(record[rj].slice(1))-1; C_seen_X = true; break;
				case 'Y':
					R = parseInt(record[rj].slice(1))-1; if(!C_seen_X) C = 0;
					for(j = arr.length; j <= R; ++j) arr[j] = [];
					break;
				case 'K':
					val = record[rj].slice(1);
					if(val.charAt(0) === '"') val = val.slice(1,val.length - 1);
					else if(val === 'TRUE') val = true;
					else if(val === 'FALSE') val = false;
					else if(!isNaN(fuzzynum(val))) {
						val = fuzzynum(val);
						if(next_cell_format !== null && fmt_is_date(next_cell_format)) val = numdate(val);
					} else if(!isNaN(fuzzydate(val).getDate())) {
						val = parseDate(val);
					}
					if(typeof $cptable !== 'undefined' && typeof val == "string" && ((opts||{}).type != "string") && (opts||{}).codepage) val = $cptable.utils.decode(opts.codepage, val);
					C_seen_K = true;
					break;
				case 'E':
					C_seen_E = true;
					var formula = rc_to_a1(record[rj].slice(1), {r:R,c:C});
					arr[R][C] = [arr[R][C], formula];
					break;
				case 'S':
					C_seen_S = true;
					arr[R][C] = [arr[R][C], "S5S"];
					break;
				case 'G': break; // unknown
				case 'R': _R = parseInt(record[rj].slice(1))-1; break;
				case 'C': _C = parseInt(record[rj].slice(1))-1; break;
				default: if(opts && opts.WTF) throw new Error("SYLK bad record " + rstr);
			}
			if(C_seen_K) {
				if(arr[R][C] && arr[R][C].length == 2) arr[R][C][0] = val;
				else arr[R][C] = val;
				next_cell_format = null;
			}
			if(C_seen_S) {
				if(C_seen_E) throw new Error("SYLK shared formula cannot have own formula");
				var shrbase = _R > -1 && arr[_R][_C];
				if(!shrbase || !shrbase[1]) throw new Error("SYLK shared formula cannot find base");
				arr[R][C][1] = shift_formula_str(shrbase[1], {r: R - _R, c: C - _C});
			}
			break;
			case 'F':
			var F_seen = 0;
			for(rj=1; rj<record.length; ++rj) switch(record[rj].charAt(0)) {
				case 'X': C = parseInt(record[rj].slice(1))-1; ++F_seen; break;
				case 'Y':
					R = parseInt(record[rj].slice(1))-1; /*C = 0;*/
					for(j = arr.length; j <= R; ++j) arr[j] = [];
					break;
				case 'M': Mval = parseInt(record[rj].slice(1)) / 20; break;
				case 'F': break; /* ??? */
				case 'G': break; /* hide grid */
				case 'P':
					next_cell_format = formats[parseInt(record[rj].slice(1))];
					break;
				case 'S': break; /* cell style */
				case 'D': break; /* column */
				case 'N': break; /* font */
				case 'W':
					cw = record[rj].slice(1).split(" ");
					for(j = parseInt(cw[0], 10); j <= parseInt(cw[1], 10); ++j) {
						Mval = parseInt(cw[2], 10);
						colinfo[j-1] = Mval === 0 ? {hidden:true}: {wch:Mval}; process_col(colinfo[j-1]);
					} break;
				case 'C': /* default column format */
					C = parseInt(record[rj].slice(1))-1;
					if(!colinfo[C]) colinfo[C] = {};
					break;
				case 'R': /* row properties */
					R = parseInt(record[rj].slice(1))-1;
					if(!rowinfo[R]) rowinfo[R] = {};
					if(Mval > 0) { rowinfo[R].hpt = Mval; rowinfo[R].hpx = pt2px(Mval); }
					else if(Mval === 0) rowinfo[R].hidden = true;
					break;
				default: if(opts && opts.WTF) throw new Error("SYLK bad record " + rstr);
			}
			if(F_seen < 1) next_cell_format = null; break;
			default: if(opts && opts.WTF) throw new Error("SYLK bad record " + rstr);
			}
		}
		if(rowinfo.length > 0) sht['!rows'] = rowinfo;
		if(colinfo.length > 0) sht['!cols'] = colinfo;
		if(opts && opts.sheetRows) arr = arr.slice(0, opts.sheetRows);
		return [arr, sht];
	}

	function sylk_to_sheet(d/*:RawData*/, opts)/*:Worksheet*/ {
		var aoasht = sylk_to_aoa(d, opts);
		var aoa = aoasht[0], ws = aoasht[1];
		var o = aoa_to_sheet(aoa, opts);
		keys(ws).forEach(function(k) { o[k] = ws[k]; });
		return o;
	}

	function sylk_to_workbook(d/*:RawData*/, opts)/*:Workbook*/ { return sheet_to_workbook(sylk_to_sheet(d, opts), opts); }

	function write_ws_cell_sylk(cell/*:Cell*/, ws/*:Worksheet*/, R/*:number*/, C/*:number*//*::, opts*/)/*:string*/ {
		var o = "C;Y" + (R+1) + ";X" + (C+1) + ";K";
		switch(cell.t) {
			case 'n':
				o += (cell.v||0);
				if(cell.f && !cell.F) o += ";E" + a1_to_rc(cell.f, {r:R, c:C}); break;
			case 'b': o += cell.v ? "TRUE" : "FALSE"; break;
			case 'e': o += cell.w || cell.v; break;
			case 'd': o += '"' + (cell.w || cell.v) + '"'; break;
			case 's': o += '"' + cell.v.replace(/"/g,"").replace(/;/g, ";;") + '"'; break;
		}
		return o;
	}

	function write_ws_cols_sylk(out, cols) {
		cols.forEach(function(col, i) {
			var rec = "F;W" + (i+1) + " " + (i+1) + " ";
			if(col.hidden) rec += "0";
			else {
				if(typeof col.width == 'number' && !col.wpx) col.wpx = width2px(col.width);
				if(typeof col.wpx == 'number' && !col.wch) col.wch = px2char(col.wpx);
				if(typeof col.wch == 'number') rec += Math.round(col.wch);
			}
			if(rec.charAt(rec.length - 1) != " ") out.push(rec);
		});
	}

	function write_ws_rows_sylk(out/*:Array<string>*/, rows/*:Array<RowInfo>*/) {
		rows.forEach(function(row, i) {
			var rec = "F;";
			if(row.hidden) rec += "M0;";
			else if(row.hpt) rec += "M" + 20 * row.hpt + ";";
			else if(row.hpx) rec += "M" + 20 * px2pt(row.hpx) + ";";
			if(rec.length > 2) out.push(rec + "R" + (i+1));
		});
	}

	function sheet_to_sylk(ws/*:Worksheet*/, opts/*:?any*/)/*:string*/ {
		var preamble/*:Array<string>*/ = ["ID;PWXL;N;E"], o/*:Array<string>*/ = [];
		var r = safe_decode_range(ws['!ref']), cell/*:Cell*/;
		var dense = Array.isArray(ws);
		var RS = "\r\n";

		preamble.push("P;PGeneral");
		preamble.push("F;P0;DG0G8;M255");
		if(ws['!cols']) write_ws_cols_sylk(preamble, ws['!cols']);
		if(ws['!rows']) write_ws_rows_sylk(preamble, ws['!rows']);

		preamble.push("B;Y" + (r.e.r - r.s.r + 1) + ";X" + (r.e.c - r.s.c + 1) + ";D" + [r.s.c,r.s.r,r.e.c,r.e.r].join(" "));
		for(var R = r.s.r; R <= r.e.r; ++R) {
			for(var C = r.s.c; C <= r.e.c; ++C) {
				var coord = encode_cell({r:R,c:C});
				cell = dense ? (ws[R]||[])[C]: ws[coord];
				if(!cell || (cell.v == null && (!cell.f || cell.F))) continue;
				o.push(write_ws_cell_sylk(cell, ws, R, C, opts));
			}
		}
		return preamble.join(RS) + RS + o.join(RS) + RS + "E" + RS;
	}

	return {
		to_workbook: sylk_to_workbook,
		to_sheet: sylk_to_sheet,
		from_sheet: sheet_to_sylk
	};
})();

var DIF = /*#__PURE__*/(function() {
	function dif_to_aoa(d/*:RawData*/, opts)/*:AOA*/ {
		switch(opts.type) {
			case 'base64': return dif_to_aoa_str(Base64_decode(d), opts);
			case 'binary': return dif_to_aoa_str(d, opts);
			case 'buffer': return dif_to_aoa_str(has_buf && Buffer.isBuffer(d) ? d.toString('binary') : a2s(d), opts);
			case 'array': return dif_to_aoa_str(cc2str(d), opts);
		}
		throw new Error("Unrecognized type " + opts.type);
	}
	function dif_to_aoa_str(str/*:string*/, opts)/*:AOA*/ {
		var records = str.split('\n'), R = -1, C = -1, ri = 0, arr/*:AOA*/ = [];
		for (; ri !== records.length; ++ri) {
			if (records[ri].trim() === 'BOT') { arr[++R] = []; C = 0; continue; }
			if (R < 0) continue;
			var metadata = records[ri].trim().split(",");
			var type = metadata[0], value = metadata[1];
			++ri;
			var data = records[ri] || "";
			while(((data.match(/["]/g)||[]).length & 1) && ri < records.length - 1) data += "\n" + records[++ri];
			data = data.trim();
			switch (+type) {
				case -1:
					if (data === 'BOT') { arr[++R] = []; C = 0; continue; }
					else if (data !== 'EOD') throw new Error("Unrecognized DIF special command " + data);
					break;
				case 0:
					if(data === 'TRUE') arr[R][C] = true;
					else if(data === 'FALSE') arr[R][C] = false;
					else if(!isNaN(fuzzynum(value))) arr[R][C] = fuzzynum(value);
					else if(!isNaN(fuzzydate(value).getDate())) arr[R][C] = parseDate(value);
					else arr[R][C] = value;
					++C; break;
				case 1:
					data = data.slice(1,data.length-1);
					data = data.replace(/""/g, '"');
					if(DIF_XL && data && data.match(/^=".*"$/)) data = data.slice(2, -1);
					arr[R][C++] = data !== '' ? data : null;
					break;
			}
			if (data === 'EOD') break;
		}
		if(opts && opts.sheetRows) arr = arr.slice(0, opts.sheetRows);
		return arr;
	}

	function dif_to_sheet(str/*:string*/, opts)/*:Worksheet*/ { return aoa_to_sheet(dif_to_aoa(str, opts), opts); }
	function dif_to_workbook(str/*:string*/, opts)/*:Workbook*/ { return sheet_to_workbook(dif_to_sheet(str, opts), opts); }

	var sheet_to_dif = /*#__PURE__*/(function() {
		var push_field = function pf(o/*:Array<string>*/, topic/*:string*/, v/*:number*/, n/*:number*/, s/*:string*/) {
			o.push(topic);
			o.push(v + "," + n);
			o.push('"' + s.replace(/"/g,'""') + '"');
		};
		var push_value = function po(o/*:Array<string>*/, type/*:number*/, v/*:any*/, s/*:string*/) {
			o.push(type + "," + v);
			o.push(type == 1 ? '"' + s.replace(/"/g,'""') + '"' : s);
		};
		return function sheet_to_dif(ws/*:Worksheet*//*::, opts:?any*/)/*:string*/ {
			var o/*:Array<string>*/ = [];
			var r = safe_decode_range(ws['!ref']), cell/*:Cell*/;
			var dense = Array.isArray(ws);
			push_field(o, "TABLE", 0, 1, "sheetjs");
			push_field(o, "VECTORS", 0, r.e.r - r.s.r + 1,"");
			push_field(o, "TUPLES", 0, r.e.c - r.s.c + 1,"");
			push_field(o, "DATA", 0, 0,"");
			for(var R = r.s.r; R <= r.e.r; ++R) {
				push_value(o, -1, 0, "BOT");
				for(var C = r.s.c; C <= r.e.c; ++C) {
					var coord = encode_cell({r:R,c:C});
					cell = dense ? (ws[R]||[])[C] : ws[coord];
					if(!cell) { push_value(o, 1, 0, ""); continue;}
					switch(cell.t) {
						case 'n':
							var val = DIF_XL ? cell.w : cell.v;
							if(!val && cell.v != null) val = cell.v;
							if(val == null) {
								if(DIF_XL && cell.f && !cell.F) push_value(o, 1, 0, "=" + cell.f);
								else push_value(o, 1, 0, "");
							}
							else push_value(o, 0, val, "V");
							break;
						case 'b':
							push_value(o, 0, cell.v ? 1 : 0, cell.v ? "TRUE" : "FALSE");
							break;
						case 's':
							push_value(o, 1, 0, (!DIF_XL || isNaN(cell.v)) ? cell.v : '="' + cell.v + '"');
							break;
						case 'd':
							if(!cell.w) cell.w = SSF_format(cell.z || table_fmt[14], datenum(parseDate(cell.v)));
							if(DIF_XL) push_value(o, 0, cell.w, "V");
							else push_value(o, 1, 0, cell.w);
							break;
						default: push_value(o, 1, 0, "");
					}
				}
			}
			push_value(o, -1, 0, "EOD");
			var RS = "\r\n";
			var oo = o.join(RS);
			//while((oo.length & 0x7F) != 0) oo += "\0";
			return oo;
		};
	})();
	return {
		to_workbook: dif_to_workbook,
		to_sheet: dif_to_sheet,
		from_sheet: sheet_to_dif
	};
})();

var ETH = /*#__PURE__*/(function() {
	function decode(s/*:string*/)/*:string*/ { return s.replace(/\\b/g,"\\").replace(/\\c/g,":").replace(/\\n/g,"\n"); }
	function encode(s/*:string*/)/*:string*/ { return s.replace(/\\/g, "\\b").replace(/:/g, "\\c").replace(/\n/g,"\\n"); }

	function eth_to_aoa(str/*:string*/, opts)/*:AOA*/ {
		var records = str.split('\n'), R = -1, C = -1, ri = 0, arr/*:AOA*/ = [];
		for (; ri !== records.length; ++ri) {
			var record = records[ri].trim().split(":");
			if(record[0] !== 'cell') continue;
			var addr = decode_cell(record[1]);
			if(arr.length <= addr.r) for(R = arr.length; R <= addr.r; ++R) if(!arr[R]) arr[R] = [];
			R = addr.r; C = addr.c;
			switch(record[2]) {
				case 't': arr[R][C] = decode(record[3]); break;
				case 'v': arr[R][C] = +record[3]; break;
				case 'vtf': var _f = record[record.length - 1];
					/* falls through */
				case 'vtc':
					switch(record[3]) {
						case 'nl': arr[R][C] = +record[4] ? true : false; break;
						default: arr[R][C] = +record[4]; break;
					}
					if(record[2] == 'vtf') arr[R][C] = [arr[R][C], _f];
			}
		}
		if(opts && opts.sheetRows) arr = arr.slice(0, opts.sheetRows);
		return arr;
	}

	function eth_to_sheet(d/*:string*/, opts)/*:Worksheet*/ { return aoa_to_sheet(eth_to_aoa(d, opts), opts); }
	function eth_to_workbook(d/*:string*/, opts)/*:Workbook*/ { return sheet_to_workbook(eth_to_sheet(d, opts), opts); }

	var header = [
		"socialcalc:version:1.5",
		"MIME-Version: 1.0",
		"Content-Type: multipart/mixed; boundary=SocialCalcSpreadsheetControlSave"
	].join("\n");

	var sep = [
		"--SocialCalcSpreadsheetControlSave",
		"Content-type: text/plain; charset=UTF-8"
	].join("\n") + "\n";

	/* TODO: the other parts */
	var meta = [
		"# SocialCalc Spreadsheet Control Save",
		"part:sheet"
	].join("\n");

	var end = "--SocialCalcSpreadsheetControlSave--";

	function sheet_to_eth_data(ws/*:Worksheet*/)/*:string*/ {
		if(!ws || !ws['!ref']) return "";
		var o/*:Array<string>*/ = [], oo/*:Array<string>*/ = [], cell, coord = "";
		var r = decode_range(ws['!ref']);
		var dense = Array.isArray(ws);
		for(var R = r.s.r; R <= r.e.r; ++R) {
			for(var C = r.s.c; C <= r.e.c; ++C) {
				coord = encode_cell({r:R,c:C});
				cell = dense ? (ws[R]||[])[C] : ws[coord];
				if(!cell || cell.v == null || cell.t === 'z') continue;
				oo = ["cell", coord, 't'];
				switch(cell.t) {
					case 's': case 'str': oo.push(encode(cell.v)); break;
					case 'n':
						if(!cell.f) { oo[2]='v'; oo[3]=cell.v; }
						else { oo[2]='vtf'; oo[3]='n'; oo[4]=cell.v; oo[5]=encode(cell.f); }
						break;
					case 'b':
						oo[2] = 'vt'+(cell.f?'f':'c'); oo[3]='nl'; oo[4]=cell.v?"1":"0";
						oo[5] = encode(cell.f||(cell.v?'TRUE':'FALSE'));
						break;
					case 'd':
						var t = datenum(parseDate(cell.v));
						oo[2] = 'vtc'; oo[3] = 'nd'; oo[4] = ""+t;
						oo[5] = cell.w || SSF_format(cell.z || table_fmt[14], t);
						break;
					case 'e': continue;
				}
				o.push(oo.join(":"));
			}
		}
		o.push("sheet:c:" + (r.e.c-r.s.c+1) + ":r:" + (r.e.r-r.s.r+1) + ":tvf:1");
		o.push("valueformat:1:text-wiki");
		//o.push("copiedfrom:" + ws['!ref']); // clipboard only
		return o.join("\n");
	}

	function sheet_to_eth(ws/*:Worksheet*//*::, opts:?any*/)/*:string*/ {
		return [header, sep, meta, sep, sheet_to_eth_data(ws), end].join("\n");
		// return ["version:1.5", sheet_to_eth_data(ws)].join("\n"); // clipboard form
	}

	return {
		to_workbook: eth_to_workbook,
		to_sheet: eth_to_sheet,
		from_sheet: sheet_to_eth
	};
})();

var PRN = /*#__PURE__*/(function() {
	function set_text_arr(data/*:string*/, arr/*:AOA*/, R/*:number*/, C/*:number*/, o/*:any*/) {
		if(o.raw) arr[R][C] = data;
		else if(data === ""){/* empty */}
		else if(data === 'TRUE') arr[R][C] = true;
		else if(data === 'FALSE') arr[R][C] = false;
		else if(!isNaN(fuzzynum(data))) arr[R][C] = fuzzynum(data);
		else if(!isNaN(fuzzydate(data).getDate())) arr[R][C] = parseDate(data);
		else arr[R][C] = data;
	}

	function prn_to_aoa_str(f/*:string*/, opts)/*:AOA*/ {
		var o = opts || {};
		var arr/*:AOA*/ = ([]/*:any*/);
		if(!f || f.length === 0) return arr;
		var lines = f.split(/[\r\n]/);
		var L = lines.length - 1;
		while(L >= 0 && lines[L].length === 0) --L;
		var start = 10, idx = 0;
		var R = 0;
		for(; R <= L; ++R) {
			idx = lines[R].indexOf(" ");
			if(idx == -1) idx = lines[R].length; else idx++;
			start = Math.max(start, idx);
		}
		for(R = 0; R <= L; ++R) {
			arr[R] = [];
			/* TODO: confirm that widths are always 10 */
			var C = 0;
			set_text_arr(lines[R].slice(0, start).trim(), arr, R, C, o);
			for(C = 1; C <= (lines[R].length - start)/10 + 1; ++C)
				set_text_arr(lines[R].slice(start+(C-1)*10,start+C*10).trim(),arr,R,C,o);
		}
		if(o.sheetRows) arr = arr.slice(0, o.sheetRows);
		return arr;
	}

	// List of accepted CSV separators
	var guess_seps = {
		/*::[*/0x2C/*::]*/: ',',
		/*::[*/0x09/*::]*/: "\t",
		/*::[*/0x3B/*::]*/: ';',
		/*::[*/0x7C/*::]*/: '|'
	};

	// CSV separator weights to be used in case of equal numbers
	var guess_sep_weights = {
		/*::[*/0x2C/*::]*/: 3,
		/*::[*/0x09/*::]*/: 2,
		/*::[*/0x3B/*::]*/: 1,
		/*::[*/0x7C/*::]*/: 0
	};

	function guess_sep(str) {
		var cnt = {}, instr = false, end = 0, cc = 0;
		for(;end < str.length;++end) {
			if((cc=str.charCodeAt(end)) == 0x22) instr = !instr;
			else if(!instr && cc in guess_seps) cnt[cc] = (cnt[cc]||0)+1;
		}

		cc = [];
		for(end in cnt) if ( Object.prototype.hasOwnProperty.call(cnt, end) ) {
			cc.push([ cnt[end], end ]);
		}

		if ( !cc.length ) {
			cnt = guess_sep_weights;
			for(end in cnt) if ( Object.prototype.hasOwnProperty.call(cnt, end) ) {
				cc.push([ cnt[end], end ]);
			}
		}

		cc.sort(function(a, b) { return a[0] - b[0] || guess_sep_weights[a[1]] - guess_sep_weights[b[1]]; });

		return guess_seps[cc.pop()[1]] || 0x2C;
	}

	function dsv_to_sheet_str(str/*:string*/, opts)/*:Worksheet*/ {
		var o = opts || {};
		var sep = "";
		if(DENSE != null && o.dense == null) o.dense = DENSE;
		var ws/*:Worksheet*/ = o.dense ? ([]/*:any*/) : ({}/*:any*/);
		var range/*:Range*/ = ({s: {c:0, r:0}, e: {c:0, r:0}}/*:any*/);

		if(str.slice(0,4) == "sep=") {
			// If the line ends in \r\n
			if(str.charCodeAt(5) == 13 && str.charCodeAt(6) == 10 ) {
				sep = str.charAt(4); str = str.slice(7);
			}
			// If line ends in \r OR \n
			else if(str.charCodeAt(5) == 13 || str.charCodeAt(5) == 10 ) {
				sep = str.charAt(4); str = str.slice(6);
			}
			else sep = guess_sep(str.slice(0,1024));
		}
		else if(o && o.FS) sep = o.FS;
		else sep = guess_sep(str.slice(0,1024));
		var R = 0, C = 0, v = 0;
		var start = 0, end = 0, sepcc = sep.charCodeAt(0), instr = false, cc=0, startcc=str.charCodeAt(0);
		str = str.replace(/\r\n/mg, "\n");
		var _re/*:?RegExp*/ = o.dateNF != null ? dateNF_regex(o.dateNF) : null;
		function finish_cell() {
			var s = str.slice(start, end);
			var cell = ({}/*:any*/);
			if(s.charAt(0) == '"' && s.charAt(s.length - 1) == '"') s = s.slice(1,-1).replace(/""/g,'"');
			if(s.length === 0) cell.t = 'z';
			else if(o.raw) { cell.t = 's'; cell.v = s; }
			else if(s.trim().length === 0) { cell.t = 's'; cell.v = s; }
			else if(s.charCodeAt(0) == 0x3D) {
				if(s.charCodeAt(1) == 0x22 && s.charCodeAt(s.length - 1) == 0x22) { cell.t = 's'; cell.v = s.slice(2,-1).replace(/""/g,'"'); }
				else if(fuzzyfmla(s)) { cell.t = 'n'; cell.f = s.slice(1); }
				else { cell.t = 's'; cell.v = s; } }
			else if(s == "TRUE") { cell.t = 'b'; cell.v = true; }
			else if(s == "FALSE") { cell.t = 'b'; cell.v = false; }
			else if(!isNaN(v = fuzzynum(s))) { cell.t = 'n'; if(o.cellText !== false) cell.w = s; cell.v = v; }
			else if(!isNaN(fuzzydate(s).getDate()) || _re && s.match(_re)) {
				cell.z = o.dateNF || table_fmt[14];
				var k = 0;
				if(_re && s.match(_re)){ s=dateNF_fix(s, o.dateNF, (s.match(_re)||[])); k=1; }
				if(o.cellDates) { cell.t = 'd'; cell.v = parseDate(s, k); }
				else { cell.t = 'n'; cell.v = datenum(parseDate(s, k)); }
				if(o.cellText !== false) cell.w = SSF_format(cell.z, cell.v instanceof Date ? datenum(cell.v):cell.v);
				if(!o.cellNF) delete cell.z;
			} else {
				cell.t = 's';
				cell.v = s;
			}
			if(cell.t == 'z'){}
			else if(o.dense) { if(!ws[R]) ws[R] = []; ws[R][C] = cell; }
			else ws[encode_cell({c:C,r:R})] = cell;
			start = end+1; startcc = str.charCodeAt(start);
			if(range.e.c < C) range.e.c = C;
			if(range.e.r < R) range.e.r = R;
			if(cc == sepcc) ++C; else { C = 0; ++R; if(o.sheetRows && o.sheetRows <= R) return true; }
		}
		outer: for(;end < str.length;++end) switch((cc=str.charCodeAt(end))) {
			case 0x22: if(startcc === 0x22) instr = !instr; break;
			case sepcc: case 0x0a: case 0x0d: if(!instr && finish_cell()) break outer; break;
			default: break;
		}
		if(end - start > 0) finish_cell();

		ws['!ref'] = encode_range(range);
		return ws;
	}

	function prn_to_sheet_str(str/*:string*/, opts)/*:Worksheet*/ {
		if(!(opts && opts.PRN)) return dsv_to_sheet_str(str, opts);
		if(opts.FS) return dsv_to_sheet_str(str, opts);
		if(str.slice(0,4) == "sep=") return dsv_to_sheet_str(str, opts);
		if(str.indexOf("\t") >= 0 || str.indexOf(",") >= 0 || str.indexOf(";") >= 0) return dsv_to_sheet_str(str, opts);
		return aoa_to_sheet(prn_to_aoa_str(str, opts), opts);
	}

	function prn_to_sheet(d/*:RawData*/, opts)/*:Worksheet*/ {
		var str = "", bytes = opts.type == 'string' ? [0,0,0,0] : firstbyte(d, opts);
		switch(opts.type) {
			case 'base64': str = Base64_decode(d); break;
			case 'binary': str = d; break;
			case 'buffer':
				if(opts.codepage == 65001) str = d.toString('utf8'); // TODO: test if buf
				else if(opts.codepage && typeof $cptable !== 'undefined') str = $cptable.utils.decode(opts.codepage, d);
				else str = has_buf && Buffer.isBuffer(d) ? d.toString('binary') : a2s(d);
				break;
			case 'array': str = cc2str(d); break;
			case 'string': str = d; break;
			default: throw new Error("Unrecognized type " + opts.type);
		}
		if(bytes[0] == 0xEF && bytes[1] == 0xBB && bytes[2] == 0xBF) str = utf8read(str.slice(3));
		else if(opts.type != 'string' && opts.type != 'buffer' && opts.codepage == 65001) str = utf8read(str);
		else if((opts.type == 'binary') && typeof $cptable !== 'undefined' && opts.codepage)  str = $cptable.utils.decode(opts.codepage, $cptable.utils.encode(28591,str));
		if(str.slice(0,19) == "socialcalc:version:") return ETH.to_sheet(opts.type == 'string' ? str : utf8read(str), opts);
		return prn_to_sheet_str(str, opts);
	}

	function prn_to_workbook(d/*:RawData*/, opts)/*:Workbook*/ { return sheet_to_workbook(prn_to_sheet(d, opts), opts); }

	function sheet_to_prn(ws/*:Worksheet*//*::, opts:?any*/)/*:string*/ {
		var o/*:Array<string>*/ = [];
		var r = safe_decode_range(ws['!ref']), cell/*:Cell*/;
		var dense = Array.isArray(ws);
		for(var R = r.s.r; R <= r.e.r; ++R) {
			var oo/*:Array<string>*/ = [];
			for(var C = r.s.c; C <= r.e.c; ++C) {
				var coord = encode_cell({r:R,c:C});
				cell = dense ? (ws[R]||[])[C] : ws[coord];
				if(!cell || cell.v == null) { oo.push("          "); continue; }
				var w = (cell.w || (format_cell(cell), cell.w) || "").slice(0,10);
				while(w.length < 10) w += " ";
				oo.push(w + (C === 0 ? " " : ""));
			}
			o.push(oo.join(""));
		}
		return o.join("\n");
	}

	return {
		to_workbook: prn_to_workbook,
		to_sheet: prn_to_sheet,
		from_sheet: sheet_to_prn
	};
})();

/* Excel defaults to SYLK but warns if data is not valid */
function read_wb_ID(d, opts) {
	var o = opts || {}, OLD_WTF = !!o.WTF; o.WTF = true;
	try {
		var out = SYLK.to_workbook(d, o);
		o.WTF = OLD_WTF;
		return out;
	} catch(e) {
		o.WTF = OLD_WTF;
		if(!e.message.match(/SYLK bad record ID/) && OLD_WTF) throw e;
		return PRN.to_workbook(d, opts);
	}
}

var WK_ = /*#__PURE__*/(function() {
	function lotushopper(data, cb/*:RecordHopperCB*/, opts/*:any*/) {
		if(!data) return;
		prep_blob(data, data.l || 0);
		var Enum = opts.Enum || WK1Enum;
		while(data.l < data.length) {
			var RT = data.read_shift(2);
			var R = Enum[RT] || Enum[0xFFFF];
			var length = data.read_shift(2);
			var tgt = data.l + length;
			var d = R.f && R.f(data, length, opts);
			data.l = tgt;
			if(cb(d, R, RT)) return;
		}
	}

	function lotus_to_workbook(d/*:RawData*/, opts) {
		switch(opts.type) {
			case 'base64': return lotus_to_workbook_buf(s2a(Base64_decode(d)), opts);
			case 'binary': return lotus_to_workbook_buf(s2a(d), opts);
			case 'buffer':
			case 'array': return lotus_to_workbook_buf(d, opts);
		}
		throw "Unsupported type " + opts.type;
	}

	function lotus_to_workbook_buf(d, opts)/*:Workbook*/ {
		if(!d) return d;
		var o = opts || {};
		if(DENSE != null && o.dense == null) o.dense = DENSE;
		var s/*:Worksheet*/ = ((o.dense ? [] : {})/*:any*/), n = "Sheet1", next_n = "", sidx = 0;
		var sheets = {}, snames = [], realnames = [];

		var refguess = {s: {r:0, c:0}, e: {r:0, c:0} };
		var sheetRows = o.sheetRows || 0;

		if(d[2] == 0x00) {
			if(d[3] == 0x08 || d[3] == 0x09) {
				if(d.length >= 16 && d[14] == 0x05 && d[15] === 0x6c) throw new Error("Unsupported Works 3 for Mac file");
			}
		}

		if(d[2] == 0x02) {
			o.Enum = WK1Enum;
			lotushopper(d, function(val, R, RT) { switch(RT) {
				case 0x00: /* BOF */
					o.vers = val;
					if(val >= 0x1000) o.qpro = true;
					break;
				case 0x06: refguess = val; break; /* RANGE */
				case 0xCC: if(val) next_n = val; break; /* SHEETNAMECS */
				case 0xDE: next_n = val; break; /* SHEETNAMELP */
				case 0x0F: /* LABEL */
				case 0x33: /* STRING */
					if(!o.qpro) val[1].v = val[1].v.slice(1);
					/* falls through */
				case 0x0D: /* INTEGER */
				case 0x0E: /* NUMBER */
				case 0x10: /* FORMULA */
					/* TODO: actual translation of the format code */
					if(RT == 0x0E && (val[2] & 0x70) == 0x70 && (val[2] & 0x0F) > 1 && (val[2] & 0x0F) < 15) {
						val[1].z = o.dateNF || table_fmt[14];
						if(o.cellDates) { val[1].t = 'd'; val[1].v = numdate(val[1].v); }
					}

					if(o.qpro) {
						if(val[3] > sidx) {
							s["!ref"] = encode_range(refguess);
							sheets[n] = s;
							snames.push(n);
							s = (o.dense ? [] : {});
							refguess = {s: {r:0, c:0}, e: {r:0, c:0} };
							sidx = val[3]; n = next_n || "Sheet" + (sidx + 1); next_n = "";
						}
					}

					var tmpcell = o.dense ? (s[val[0].r]||[])[val[0].c] : s[encode_cell(val[0])];
					if(tmpcell) {
						tmpcell.t = val[1].t; tmpcell.v = val[1].v;
						if(val[1].z != null) tmpcell.z = val[1].z;
						if(val[1].f != null) tmpcell.f = val[1].f;
						break;
					}
					if(o.dense) {
						if(!s[val[0].r]) s[val[0].r] = [];
						s[val[0].r][val[0].c] = val[1];
					} else s[encode_cell(val[0])] = val[1];
					break;
				default:
			}}, o);
		} else if(d[2] == 0x1A || d[2] == 0x0E) {
			o.Enum = WK3Enum;
			if(d[2] == 0x0E) { o.qpro = true; d.l = 0; }
			lotushopper(d, function(val, R, RT) { switch(RT) {
				case 0xCC: n = val; break; /* SHEETNAMECS */
				case 0x16: /* LABEL16 */
					val[1].v = val[1].v.slice(1);
					/* falls through */
				case 0x17: /* NUMBER17 */
				case 0x18: /* NUMBER18 */
				case 0x19: /* FORMULA19 */
				case 0x25: /* NUMBER25 */
				case 0x27: /* NUMBER27 */
				case 0x28: /* FORMULA28 */
					if(val[3] > sidx) {
						s["!ref"] = encode_range(refguess);
						sheets[n] = s;
						snames.push(n);
						s = (o.dense ? [] : {});
						refguess = {s: {r:0, c:0}, e: {r:0, c:0} };
						sidx = val[3]; n = "Sheet" + (sidx + 1);
					}
					if(sheetRows > 0 && val[0].r >= sheetRows) break;
					if(o.dense) {
						if(!s[val[0].r]) s[val[0].r] = [];
						s[val[0].r][val[0].c] = val[1];
					} else s[encode_cell(val[0])] = val[1];
					if(refguess.e.c < val[0].c) refguess.e.c = val[0].c;
					if(refguess.e.r < val[0].r) refguess.e.r = val[0].r;
					break;
				case 0x1B: /* XFORMAT */
					if(val[0x36b0]) realnames[val[0x36b0][0]] = val[0x36b0][1];
					break;
				case 0x0601: /* SHEETINFOQP */
					realnames[val[0]] = val[1]; if(val[0] == sidx) n = val[1]; break;
				default: break;
			}}, o);
		} else throw new Error("Unrecognized LOTUS BOF " + d[2]);
		s["!ref"] = encode_range(refguess);
		sheets[next_n || n] = s;
		snames.push(next_n || n);
		if(!realnames.length) return { SheetNames: snames, Sheets: sheets };
		var osheets = {}, rnames = [];
		/* TODO: verify no collisions */
		for(var i = 0; i < realnames.length; ++i) if(sheets[snames[i]]) {
			rnames.push(realnames[i] || snames[i]);
			osheets[realnames[i]] = sheets[realnames[i]] || sheets[snames[i]];
		} else {
			rnames.push(realnames[i]);
			osheets[realnames[i]] = ({ "!ref": "A1" });
		}
		return { SheetNames: rnames, Sheets: osheets };
	}

	function sheet_to_wk1(ws/*:Worksheet*/, opts/*:WriteOpts*/) {
		var o = opts || {};
		if(+o.codepage >= 0) set_cp(+o.codepage);
		if(o.type == "string") throw new Error("Cannot write WK1 to JS string");
		var ba = buf_array();
		var range = safe_decode_range(ws["!ref"]);
		var dense = Array.isArray(ws);
		var cols = [];

		write_biff_rec(ba, 0x00, write_BOF_WK1(0x0406));
		write_biff_rec(ba, 0x06, write_RANGE(range));
		var max_R = Math.min(range.e.r, 8191);
		for(var R = range.s.r; R <= max_R; ++R) {
			var rr = encode_row(R);
			for(var C = range.s.c; C <= range.e.c; ++C) {
				if(R === range.s.r) cols[C] = encode_col(C);
				var ref = cols[C] + rr;
				var cell = dense ? (ws[R]||[])[C] : ws[ref];
				if(!cell || cell.t == "z") continue;
				/* TODO: formula records */
				if(cell.t == "n") {
					if((cell.v|0)==cell.v && cell.v >= -32768 && cell.v <= 32767) write_biff_rec(ba, 0x0d, write_INTEGER(R, C, cell.v));
					else write_biff_rec(ba, 0x0e, write_NUMBER(R, C, cell.v));
				} else {
					var str = format_cell(cell);
					write_biff_rec(ba, 0x0F, write_LABEL(R, C, str.slice(0, 239)));
				}
			}
		}

		write_biff_rec(ba, 0x01);
		return ba.end();
	}

	function book_to_wk3(wb/*:Workbook*/, opts/*:WriteOpts*/) {
		var o = opts || {};
		if(+o.codepage >= 0) set_cp(+o.codepage);
		if(o.type == "string") throw new Error("Cannot write WK3 to JS string");
		var ba = buf_array();

		write_biff_rec(ba, 0x00, write_BOF_WK3(wb));

		for(var i = 0, cnt = 0; i < wb.SheetNames.length; ++i) if((wb.Sheets[wb.SheetNames[i]] || {})["!ref"]) write_biff_rec(ba, 0x1b, write_XFORMAT_SHEETNAME(wb.SheetNames[i], cnt++));

		var wsidx = 0;
		for(i = 0; i < wb.SheetNames.length; ++i) {
			var ws = wb.Sheets[wb.SheetNames[i]];
			if(!ws || !ws["!ref"]) continue;
			var range = safe_decode_range(ws["!ref"]);
			var dense = Array.isArray(ws);
			var cols = [];
			var max_R = Math.min(range.e.r, 8191);
			for(var R = range.s.r; R <= max_R; ++R) {
				var rr = encode_row(R);
				for(var C = range.s.c; C <= range.e.c; ++C) {
					if(R === range.s.r) cols[C] = encode_col(C);
					var ref = cols[C] + rr;
					var cell = dense ? (ws[R]||[])[C] : ws[ref];
					if(!cell || cell.t == "z") continue;
					/* TODO: FORMULA19 NUMBER18 records */
					if(cell.t == "n") {
						write_biff_rec(ba, 0x17, write_NUMBER_17(R, C, wsidx, cell.v));
					} else {
						var str = format_cell(cell);
						/* TODO: max len? */
						write_biff_rec(ba, 0x16, write_LABEL_16(R, C, wsidx, str.slice(0, 239)));
					}
				}
			}
			++wsidx;
		}

		write_biff_rec(ba, 0x01);
		return ba.end();
	}


	function write_BOF_WK1(v/*:number*/) {
		var out = new_buf(2);
		out.write_shift(2, v);
		return out;
	}

	function write_BOF_WK3(wb/*:Workbook*/) {
		var out = new_buf(26);
		out.write_shift(2, 0x1000);
		out.write_shift(2, 0x0004);
		out.write_shift(4, 0x0000);
		var rows = 0, cols = 0, wscnt = 0;
		for(var i = 0; i < wb.SheetNames.length; ++i) {
			var name = wb.SheetNames[i];
			var ws = wb.Sheets[name];
			if(!ws || !ws["!ref"]) continue;
			++wscnt;
			var range = decode_range(ws["!ref"]);
			if(rows < range.e.r) rows = range.e.r;
			if(cols < range.e.c) cols = range.e.c;
		}
		if(rows > 8191) rows = 8191;
		out.write_shift(2, rows);
		out.write_shift(1, wscnt);
		out.write_shift(1, cols);
		out.write_shift(2, 0x00);
		out.write_shift(2, 0x00);
		out.write_shift(1, 0x01);
		out.write_shift(1, 0x02);
		out.write_shift(4, 0);
		out.write_shift(4, 0);
		return out;
	}

	function parse_RANGE(blob, length, opts) {
		var o = {s:{c:0,r:0},e:{c:0,r:0}};
		if(length == 8 && opts.qpro) {
			o.s.c = blob.read_shift(1);
			blob.l++;
			o.s.r = blob.read_shift(2);
			o.e.c = blob.read_shift(1);
			blob.l++;
			o.e.r = blob.read_shift(2);
			return o;
		}
		o.s.c = blob.read_shift(2);
		o.s.r = blob.read_shift(2);
		if(length == 12 && opts.qpro) blob.l += 2;
		o.e.c = blob.read_shift(2);
		o.e.r = blob.read_shift(2);
		if(length == 12 && opts.qpro) blob.l += 2;
		if(o.s.c == 0xFFFF) o.s.c = o.e.c = o.s.r = o.e.r = 0;
		return o;
	}
	function write_RANGE(range) {
		var out = new_buf(8);
		out.write_shift(2, range.s.c);
		out.write_shift(2, range.s.r);
		out.write_shift(2, range.e.c);
		out.write_shift(2, range.e.r);
		return out;
	}

	function parse_cell(blob, length, opts) {
		var o = [{c:0,r:0}, {t:'n',v:0}, 0, 0];
		if(opts.qpro && opts.vers != 0x5120) {
			o[0].c = blob.read_shift(1);
			o[3] = blob.read_shift(1);
			o[0].r = blob.read_shift(2);
			blob.l+=2;
		} else {
			o[2] = blob.read_shift(1);
			o[0].c = blob.read_shift(2); o[0].r = blob.read_shift(2);
		}
		return o;
	}

	function parse_LABEL(blob, length, opts) {
		var tgt = blob.l + length;
		var o = parse_cell(blob, length, opts);
		o[1].t = 's';
		if(opts.vers == 0x5120) {
			blob.l++;
			var len = blob.read_shift(1);
			o[1].v = blob.read_shift(len, 'utf8');
			return o;
		}
		if(opts.qpro) blob.l++;
		o[1].v = blob.read_shift(tgt - blob.l, 'cstr');
		return o;
	}
	function write_LABEL(R, C, s) {
		/* TODO: encoding */
		var o = new_buf(7 + s.length);
		o.write_shift(1, 0xFF);
		o.write_shift(2, C);
		o.write_shift(2, R);
		o.write_shift(1, 0x27); // ??
		for(var i = 0; i < o.length; ++i) {
			var cc = s.charCodeAt(i);
			o.write_shift(1, cc >= 0x80 ? 0x5F : cc);
		}
		o.write_shift(1, 0);
		return o;
	}

	function parse_INTEGER(blob, length, opts) {
		var o = parse_cell(blob, length, opts);
		o[1].v = blob.read_shift(2, 'i');
		return o;
	}
	function write_INTEGER(R, C, v) {
		var o = new_buf(7);
		o.write_shift(1, 0xFF);
		o.write_shift(2, C);
		o.write_shift(2, R);
		o.write_shift(2, v, 'i');
		return o;
	}

	function parse_NUMBER(blob, length, opts) {
		var o = parse_cell(blob, length, opts);
		o[1].v = blob.read_shift(8, 'f');
		return o;
	}
	function write_NUMBER(R, C, v) {
		var o = new_buf(13);
		o.write_shift(1, 0xFF);
		o.write_shift(2, C);
		o.write_shift(2, R);
		o.write_shift(8, v, 'f');
		return o;
	}

	function parse_FORMULA(blob, length, opts) {
		var tgt = blob.l + length;
		var o = parse_cell(blob, length, opts);
		/* TODO: formula */
		o[1].v = blob.read_shift(8, 'f');
		if(opts.qpro) blob.l = tgt;
		else {
			var flen = blob.read_shift(2);
			wk1_fmla_to_csf(blob.slice(blob.l, blob.l + flen), o);
			blob.l += flen;
		}
		return o;
	}

	function wk1_parse_rc(B, V, col) {
		var rel = V & 0x8000;
		V &= ~0x8000;
		V = (rel ? B : 0) + ((V >= 0x2000) ? V - 0x4000 : V);
		return (rel ? "" : "$") + (col ? encode_col(V) : encode_row(V));
	}
	/* var oprec = [
		8, 8, 8, 8, 8, 8, 8, 8, 6, 4, 4, 5, 5, 7, 3, 3,
		3, 3, 3, 3, 1, 1, 2, 6, 8, 8, 8, 8, 8, 8, 8, 8
	]; */
	/* TODO: flesh out */
	var FuncTab = {
		0x33: ["FALSE", 0],
		0x34: ["TRUE", 0],
		0x46: ["LEN", 1],
		0x50: ["SUM", 69],
		0x51: ["AVERAGEA", 69],
		0x52: ["COUNTA", 69],
		0x53: ["MINA", 69],
		0x54: ["MAXA", 69],
		0x6F: ["T", 1]
	};
	var BinOpTab = [
		  "",   "",   "",   "",   "",   "",   "",   "", // eslint-disable-line no-mixed-spaces-and-tabs
		  "",  "+",  "-",  "*",  "/",  "^",  "=", "<>", // eslint-disable-line no-mixed-spaces-and-tabs
		"<=", ">=",  "<",  ">",   "",   "",   "",   "", // eslint-disable-line no-mixed-spaces-and-tabs
		 "&",   "",   "",   "",   "",   "",   "",   ""  // eslint-disable-line no-mixed-spaces-and-tabs
	];

	function wk1_fmla_to_csf(blob, o) {
		prep_blob(blob, 0);
		var out = [], argc = 0, R = "", C = "", argL = "", argR = "";
		while(blob.l < blob.length) {
			var cc = blob[blob.l++];
			switch(cc) {
				case 0x00: out.push(blob.read_shift(8, 'f')); break;
				case 0x01: {
					C = wk1_parse_rc(o[0].c, blob.read_shift(2), true);
					R = wk1_parse_rc(o[0].r, blob.read_shift(2), false);
					out.push(C + R);
				} break;
				case 0x02: {
					var c = wk1_parse_rc(o[0].c, blob.read_shift(2), true);
					var r = wk1_parse_rc(o[0].r, blob.read_shift(2), false);
					C = wk1_parse_rc(o[0].c, blob.read_shift(2), true);
					R = wk1_parse_rc(o[0].r, blob.read_shift(2), false);
					out.push(c + r + ":" + C + R);
				} break;
				case 0x03:
					if(blob.l < blob.length) { console.error("WK1 premature formula end"); return; }
					break;
				case 0x04: out.push("(" + out.pop() + ")"); break;
				case 0x05: out.push(blob.read_shift(2)); break;
				case 0x06: {
					/* TODO: text encoding */
					var Z = ""; while((cc = blob[blob.l++])) Z += String.fromCharCode(cc);
					out.push('"' + Z.replace(/"/g, '""') + '"');
				} break;

				case 0x08: out.push("-" + out.pop()); break;
				case 0x17: out.push("+" + out.pop()); break;
				case 0x16: out.push("NOT(" + out.pop() + ")"); break;

				case 0x14: case 0x15: {
					argR = out.pop(); argL = out.pop();
					out.push(["AND", "OR"][cc - 0x14] + "(" + argL + "," + argR + ")");
				} break;

				default:
					if(cc < 0x20 && BinOpTab[cc]) {
						argR = out.pop(); argL = out.pop();
						out.push(argL + BinOpTab[cc] + argR);
					} else if(FuncTab[cc]) {
						argc = FuncTab[cc][1];
						if(argc == 69) argc = blob[blob.l++];
						if(argc > out.length) { console.error("WK1 bad formula parse 0x" + cc.toString(16) + ":|" + out.join("|") + "|"); return; }
						var args = out.slice(-argc);
						out.length -= argc;
						out.push(FuncTab[cc][0] + "(" + args.join(",") + ")");
					}
					else if(cc <= 0x07) return console.error("WK1 invalid opcode " + cc.toString(16));
					else if(cc <= 0x18) return console.error("WK1 unsupported op " + cc.toString(16));
					else if(cc <= 0x1E) return console.error("WK1 invalid opcode " + cc.toString(16));
					else if(cc <= 0x73) return console.error("WK1 unsupported function opcode " + cc.toString(16));
					// possible future functions ??
					else return console.error("WK1 unrecognized opcode " + cc.toString(16));
			}
		}
		if(out.length == 1) o[1].f = "" + out[0];
		else console.error("WK1 bad formula parse |" + out.join("|") + "|");
	}


	function parse_cell_3(blob/*::, length*/) {
		var o = [{c:0,r:0}, {t:'n',v:0}, 0];
		o[0].r = blob.read_shift(2); o[3] = blob[blob.l++]; o[0].c = blob[blob.l++];
		return o;
	}

	function parse_LABEL_16(blob, length) {
		var o = parse_cell_3(blob, length);
		o[1].t = 's';
		o[1].v = blob.read_shift(length - 4, 'cstr');
		return o;
	}
	function write_LABEL_16(R, C, wsidx, s) {
		/* TODO: encoding */
		var o = new_buf(6 + s.length);
		o.write_shift(2, R);
		o.write_shift(1, wsidx);
		o.write_shift(1, C);
		o.write_shift(1, 0x27);
		for(var i = 0; i < s.length; ++i) {
			var cc = s.charCodeAt(i);
			o.write_shift(1, cc >= 0x80 ? 0x5F : cc);
		}
		o.write_shift(1, 0);
		return o;
	}

	function parse_NUMBER_18(blob, length) {
		var o = parse_cell_3(blob, length);
		o[1].v = blob.read_shift(2);
		var v = o[1].v >> 1;
		if(o[1].v & 0x1) {
			switch(v & 0x07) {
				case 0: v = (v >> 3) * 5000; break;
				case 1: v = (v >> 3) * 500; break;
				case 2: v = (v >> 3) / 20; break;
				case 3: v = (v >> 3) / 200; break;
				case 4: v = (v >> 3) / 2000; break;
				case 5: v = (v >> 3) / 20000; break;
				case 6: v = (v >> 3) / 16; break;
				case 7: v = (v >> 3) / 64; break;
			}
		}
		o[1].v = v;
		return o;
	}

	function parse_NUMBER_17(blob, length) {
		var o = parse_cell_3(blob, length);
		var v1 = blob.read_shift(4);
		var v2 = blob.read_shift(4);
		var e = blob.read_shift(2);
		if(e == 0xFFFF) {
			if(v1 === 0 && v2 === 0xC0000000) { o[1].t = "e"; o[1].v = 0x0F; } // ERR -> #VALUE!
			else if(v1 === 0 && v2 === 0xD0000000) { o[1].t = "e"; o[1].v = 0x2A; } // NA -> #N/A
			else o[1].v = 0;
			return o;
		}
		var s = e & 0x8000; e = (e&0x7FFF) - 16446;
		o[1].v = (1 - s*2) * (v2 * Math.pow(2, e+32) + v1 * Math.pow(2, e));
		return o;
	}
	function write_NUMBER_17(R, C, wsidx, v) {
		var o = new_buf(14);
		o.write_shift(2, R);
		o.write_shift(1, wsidx);
		o.write_shift(1, C);
		if(v == 0) {
			o.write_shift(4, 0);
			o.write_shift(4, 0);
			o.write_shift(2, 0xFFFF);
			return o;
		}
		var s = 0, e = 0, v1 = 0, v2 = 0;
		if(v < 0) { s = 1; v = -v; }
		e = Math.log2(v) | 0;
		v /= Math.pow(2, e-31);
		v2 = (v)>>>0;
		if((v2&0x80000000) == 0) { v/=2; ++e; v2 = v >>> 0; }
		v -= v2;
		v2 |= 0x80000000;
		v2 >>>= 0;
		v *= Math.pow(2, 32);
		v1 = v>>>0;
		o.write_shift(4, v1);
		o.write_shift(4, v2);
		e += 0x3FFF + (s ? 0x8000 : 0);
		o.write_shift(2, e);
		return o;
	}

	function parse_FORMULA_19(blob, length) {
		var o = parse_NUMBER_17(blob, 14);
		blob.l += length - 14; /* TODO: WK3 formula */
		return o;
	}

	function parse_NUMBER_25(blob, length) {
		var o = parse_cell_3(blob, length);
		var v1 = blob.read_shift(4);
		o[1].v = v1 >> 6;
		return o;
	}

	function parse_NUMBER_27(blob, length) {
		var o = parse_cell_3(blob, length);
		var v1 = blob.read_shift(8,'f');
		o[1].v = v1;
		return o;
	}

	function parse_FORMULA_28(blob, length) {
		var o = parse_NUMBER_27(blob, 14);
		blob.l += length - 10; /* TODO: formula */
		return o;
	}

	function parse_SHEETNAMECS(blob, length) {
		return blob[blob.l + length - 1] == 0 ? blob.read_shift(length, 'cstr') : "";
	}

	function parse_SHEETNAMELP(blob, length) {
		var len = blob[blob.l++];
		if(len > length - 1) len = length - 1;
		var o = ""; while(o.length < len) o += String.fromCharCode(blob[blob.l++]);
		return o;
	}

	function parse_SHEETINFOQP(blob, length, opts) {
		if(!opts.qpro || length < 21) return;
		var id = blob.read_shift(1);
		blob.l += 17;
		blob.l += 1; //var len = blob.read_shift(1);
		blob.l += 2;
		var nm = blob.read_shift(length - 21, 'cstr');
		return [id, nm];
	}

	function parse_XFORMAT(blob, length) {
		var o = {}, tgt = blob.l + length;
		while(blob.l < tgt) {
			var dt = blob.read_shift(2);
			if(dt == 0x36b0) {
				o[dt] = [0, ""];
				o[dt][0] = blob.read_shift(2);
				while(blob[blob.l]) { o[dt][1] += String.fromCharCode(blob[blob.l]); blob.l++; } blob.l++;
			}
			// TODO: 0x3a99 ??
		}
		return o;
	}
	function write_XFORMAT_SHEETNAME(name, wsidx) {
		var out = new_buf(5 + name.length);
		out.write_shift(2, 0x36b0);
		out.write_shift(2, wsidx);
		for(var i = 0; i < name.length; ++i) {
			var cc = name.charCodeAt(i);
			out[out.l++] = cc > 0x7F ? 0x5F : cc;
		}
		out[out.l++] = 0;
		return out;
	}

	var WK1Enum = {
		/*::[*/0x0000/*::]*/: { n:"BOF", f:parseuint16 },
		/*::[*/0x0001/*::]*/: { n:"EOF" },
		/*::[*/0x0002/*::]*/: { n:"CALCMODE" },
		/*::[*/0x0003/*::]*/: { n:"CALCORDER" },
		/*::[*/0x0004/*::]*/: { n:"SPLIT" },
		/*::[*/0x0005/*::]*/: { n:"SYNC" },
		/*::[*/0x0006/*::]*/: { n:"RANGE", f:parse_RANGE },
		/*::[*/0x0007/*::]*/: { n:"WINDOW1" },
		/*::[*/0x0008/*::]*/: { n:"COLW1" },
		/*::[*/0x0009/*::]*/: { n:"WINTWO" },
		/*::[*/0x000A/*::]*/: { n:"COLW2" },
		/*::[*/0x000B/*::]*/: { n:"NAME" },
		/*::[*/0x000C/*::]*/: { n:"BLANK" },
		/*::[*/0x000D/*::]*/: { n:"INTEGER", f:parse_INTEGER },
		/*::[*/0x000E/*::]*/: { n:"NUMBER", f:parse_NUMBER },
		/*::[*/0x000F/*::]*/: { n:"LABEL", f:parse_LABEL },
		/*::[*/0x0010/*::]*/: { n:"FORMULA", f:parse_FORMULA },
		/*::[*/0x0018/*::]*/: { n:"TABLE" },
		/*::[*/0x0019/*::]*/: { n:"ORANGE" },
		/*::[*/0x001A/*::]*/: { n:"PRANGE" },
		/*::[*/0x001B/*::]*/: { n:"SRANGE" },
		/*::[*/0x001C/*::]*/: { n:"FRANGE" },
		/*::[*/0x001D/*::]*/: { n:"KRANGE1" },
		/*::[*/0x0020/*::]*/: { n:"HRANGE" },
		/*::[*/0x0023/*::]*/: { n:"KRANGE2" },
		/*::[*/0x0024/*::]*/: { n:"PROTEC" },
		/*::[*/0x0025/*::]*/: { n:"FOOTER" },
		/*::[*/0x0026/*::]*/: { n:"HEADER" },
		/*::[*/0x0027/*::]*/: { n:"SETUP" },
		/*::[*/0x0028/*::]*/: { n:"MARGINS" },
		/*::[*/0x0029/*::]*/: { n:"LABELFMT" },
		/*::[*/0x002A/*::]*/: { n:"TITLES" },
		/*::[*/0x002B/*::]*/: { n:"SHEETJS" },
		/*::[*/0x002D/*::]*/: { n:"GRAPH" },
		/*::[*/0x002E/*::]*/: { n:"NGRAPH" },
		/*::[*/0x002F/*::]*/: { n:"CALCCOUNT" },
		/*::[*/0x0030/*::]*/: { n:"UNFORMATTED" },
		/*::[*/0x0031/*::]*/: { n:"CURSORW12" },
		/*::[*/0x0032/*::]*/: { n:"WINDOW" },
		/*::[*/0x0033/*::]*/: { n:"STRING", f:parse_LABEL },
		/*::[*/0x0037/*::]*/: { n:"PASSWORD" },
		/*::[*/0x0038/*::]*/: { n:"LOCKED" },
		/*::[*/0x003C/*::]*/: { n:"QUERY" },
		/*::[*/0x003D/*::]*/: { n:"QUERYNAME" },
		/*::[*/0x003E/*::]*/: { n:"PRINT" },
		/*::[*/0x003F/*::]*/: { n:"PRINTNAME" },
		/*::[*/0x0040/*::]*/: { n:"GRAPH2" },
		/*::[*/0x0041/*::]*/: { n:"GRAPHNAME" },
		/*::[*/0x0042/*::]*/: { n:"ZOOM" },
		/*::[*/0x0043/*::]*/: { n:"SYMSPLIT" },
		/*::[*/0x0044/*::]*/: { n:"NSROWS" },
		/*::[*/0x0045/*::]*/: { n:"NSCOLS" },
		/*::[*/0x0046/*::]*/: { n:"RULER" },
		/*::[*/0x0047/*::]*/: { n:"NNAME" },
		/*::[*/0x0048/*::]*/: { n:"ACOMM" },
		/*::[*/0x0049/*::]*/: { n:"AMACRO" },
		/*::[*/0x004A/*::]*/: { n:"PARSE" },
		/*::[*/0x0066/*::]*/: { n:"PRANGES??" },
		/*::[*/0x0067/*::]*/: { n:"RRANGES??" },
		/*::[*/0x0068/*::]*/: { n:"FNAME??" },
		/*::[*/0x0069/*::]*/: { n:"MRANGES??" },
		/*::[*/0x00CC/*::]*/: { n:"SHEETNAMECS", f:parse_SHEETNAMECS },
		/*::[*/0x00DE/*::]*/: { n:"SHEETNAMELP", f:parse_SHEETNAMELP },
		/*::[*/0xFFFF/*::]*/: { n:"" }
	};

	var WK3Enum = {
		/*::[*/0x0000/*::]*/: { n:"BOF" },
		/*::[*/0x0001/*::]*/: { n:"EOF" },
		/*::[*/0x0002/*::]*/: { n:"PASSWORD" },
		/*::[*/0x0003/*::]*/: { n:"CALCSET" },
		/*::[*/0x0004/*::]*/: { n:"WINDOWSET" },
		/*::[*/0x0005/*::]*/: { n:"SHEETCELLPTR" },
		/*::[*/0x0006/*::]*/: { n:"SHEETLAYOUT" },
		/*::[*/0x0007/*::]*/: { n:"COLUMNWIDTH" },
		/*::[*/0x0008/*::]*/: { n:"HIDDENCOLUMN" },
		/*::[*/0x0009/*::]*/: { n:"USERRANGE" },
		/*::[*/0x000A/*::]*/: { n:"SYSTEMRANGE" },
		/*::[*/0x000B/*::]*/: { n:"ZEROFORCE" },
		/*::[*/0x000C/*::]*/: { n:"SORTKEYDIR" },
		/*::[*/0x000D/*::]*/: { n:"FILESEAL" },
		/*::[*/0x000E/*::]*/: { n:"DATAFILLNUMS" },
		/*::[*/0x000F/*::]*/: { n:"PRINTMAIN" },
		/*::[*/0x0010/*::]*/: { n:"PRINTSTRING" },
		/*::[*/0x0011/*::]*/: { n:"GRAPHMAIN" },
		/*::[*/0x0012/*::]*/: { n:"GRAPHSTRING" },
		/*::[*/0x0013/*::]*/: { n:"??" },
		/*::[*/0x0014/*::]*/: { n:"ERRCELL" },
		/*::[*/0x0015/*::]*/: { n:"NACELL" },
		/*::[*/0x0016/*::]*/: { n:"LABEL16", f:parse_LABEL_16},
		/*::[*/0x0017/*::]*/: { n:"NUMBER17", f:parse_NUMBER_17 },
		/*::[*/0x0018/*::]*/: { n:"NUMBER18", f:parse_NUMBER_18 },
		/*::[*/0x0019/*::]*/: { n:"FORMULA19", f:parse_FORMULA_19},
		/*::[*/0x001A/*::]*/: { n:"FORMULA1A" },
		/*::[*/0x001B/*::]*/: { n:"XFORMAT", f:parse_XFORMAT },
		/*::[*/0x001C/*::]*/: { n:"DTLABELMISC" },
		/*::[*/0x001D/*::]*/: { n:"DTLABELCELL" },
		/*::[*/0x001E/*::]*/: { n:"GRAPHWINDOW" },
		/*::[*/0x001F/*::]*/: { n:"CPA" },
		/*::[*/0x0020/*::]*/: { n:"LPLAUTO" },
		/*::[*/0x0021/*::]*/: { n:"QUERY" },
		/*::[*/0x0022/*::]*/: { n:"HIDDENSHEET" },
		/*::[*/0x0023/*::]*/: { n:"??" },
		/*::[*/0x0025/*::]*/: { n:"NUMBER25", f:parse_NUMBER_25 },
		/*::[*/0x0026/*::]*/: { n:"??" },
		/*::[*/0x0027/*::]*/: { n:"NUMBER27", f:parse_NUMBER_27 },
		/*::[*/0x0028/*::]*/: { n:"FORMULA28", f:parse_FORMULA_28 },
		/*::[*/0x008E/*::]*/: { n:"??" },
		/*::[*/0x0093/*::]*/: { n:"??" },
		/*::[*/0x0096/*::]*/: { n:"??" },
		/*::[*/0x0097/*::]*/: { n:"??" },
		/*::[*/0x0098/*::]*/: { n:"??" },
		/*::[*/0x0099/*::]*/: { n:"??" },
		/*::[*/0x009A/*::]*/: { n:"??" },
		/*::[*/0x009B/*::]*/: { n:"??" },
		/*::[*/0x009C/*::]*/: { n:"??" },
		/*::[*/0x00A3/*::]*/: { n:"??" },
		/*::[*/0x00AE/*::]*/: { n:"??" },
		/*::[*/0x00AF/*::]*/: { n:"??" },
		/*::[*/0x00B0/*::]*/: { n:"??" },
		/*::[*/0x00B1/*::]*/: { n:"??" },
		/*::[*/0x00B8/*::]*/: { n:"??" },
		/*::[*/0x00B9/*::]*/: { n:"??" },
		/*::[*/0x00BA/*::]*/: { n:"??" },
		/*::[*/0x00BB/*::]*/: { n:"??" },
		/*::[*/0x00BC/*::]*/: { n:"??" },
		/*::[*/0x00C3/*::]*/: { n:"??" },
		/*::[*/0x00C9/*::]*/: { n:"??" },
		/*::[*/0x00CC/*::]*/: { n:"SHEETNAMECS", f:parse_SHEETNAMECS },
		/*::[*/0x00CD/*::]*/: { n:"??" },
		/*::[*/0x00CE/*::]*/: { n:"??" },
		/*::[*/0x00CF/*::]*/: { n:"??" },
		/*::[*/0x00D0/*::]*/: { n:"??" },
		/*::[*/0x0100/*::]*/: { n:"??" },
		/*::[*/0x0103/*::]*/: { n:"??" },
		/*::[*/0x0104/*::]*/: { n:"??" },
		/*::[*/0x0105/*::]*/: { n:"??" },
		/*::[*/0x0106/*::]*/: { n:"??" },
		/*::[*/0x0107/*::]*/: { n:"??" },
		/*::[*/0x0109/*::]*/: { n:"??" },
		/*::[*/0x010A/*::]*/: { n:"??" },
		/*::[*/0x010B/*::]*/: { n:"??" },
		/*::[*/0x010C/*::]*/: { n:"??" },
		/*::[*/0x010E/*::]*/: { n:"??" },
		/*::[*/0x010F/*::]*/: { n:"??" },
		/*::[*/0x0180/*::]*/: { n:"??" },
		/*::[*/0x0185/*::]*/: { n:"??" },
		/*::[*/0x0186/*::]*/: { n:"??" },
		/*::[*/0x0189/*::]*/: { n:"??" },
		/*::[*/0x018C/*::]*/: { n:"??" },
		/*::[*/0x0200/*::]*/: { n:"??" },
		/*::[*/0x0202/*::]*/: { n:"??" },
		/*::[*/0x0201/*::]*/: { n:"??" },
		/*::[*/0x0204/*::]*/: { n:"??" },
		/*::[*/0x0205/*::]*/: { n:"??" },
		/*::[*/0x0280/*::]*/: { n:"??" },
		/*::[*/0x0281/*::]*/: { n:"??" },
		/*::[*/0x0282/*::]*/: { n:"??" },
		/*::[*/0x0283/*::]*/: { n:"??" },
		/*::[*/0x0284/*::]*/: { n:"??" },
		/*::[*/0x0285/*::]*/: { n:"??" },
		/*::[*/0x0286/*::]*/: { n:"??" },
		/*::[*/0x0287/*::]*/: { n:"??" },
		/*::[*/0x0288/*::]*/: { n:"??" },
		/*::[*/0x0292/*::]*/: { n:"??" },
		/*::[*/0x0293/*::]*/: { n:"??" },
		/*::[*/0x0294/*::]*/: { n:"??" },
		/*::[*/0x0295/*::]*/: { n:"??" },
		/*::[*/0x0296/*::]*/: { n:"??" },
		/*::[*/0x0299/*::]*/: { n:"??" },
		/*::[*/0x029A/*::]*/: { n:"??" },
		/*::[*/0x0300/*::]*/: { n:"??" },
		/*::[*/0x0304/*::]*/: { n:"??" },
		/*::[*/0x0601/*::]*/: { n:"SHEETINFOQP", f:parse_SHEETINFOQP },
		/*::[*/0x0640/*::]*/: { n:"??" },
		/*::[*/0x0642/*::]*/: { n:"??" },
		/*::[*/0x0701/*::]*/: { n:"??" },
		/*::[*/0x0702/*::]*/: { n:"??" },
		/*::[*/0x0703/*::]*/: { n:"??" },
		/*::[*/0x0704/*::]*/: { n:"??" },
		/*::[*/0x0780/*::]*/: { n:"??" },
		/*::[*/0x0800/*::]*/: { n:"??" },
		/*::[*/0x0801/*::]*/: { n:"??" },
		/*::[*/0x0804/*::]*/: { n:"??" },
		/*::[*/0x0A80/*::]*/: { n:"??" },
		/*::[*/0x2AF6/*::]*/: { n:"??" },
		/*::[*/0x3231/*::]*/: { n:"??" },
		/*::[*/0x6E49/*::]*/: { n:"??" },
		/*::[*/0x6F44/*::]*/: { n:"??" },
		/*::[*/0xFFFF/*::]*/: { n:"" }
	};
	return {
		sheet_to_wk1: sheet_to_wk1,
		book_to_wk3: book_to_wk3,
		to_workbook: lotus_to_workbook
	};
})();
/* 18.4.7 rPr CT_RPrElt */
function parse_rpr(rpr) {
	var font = {}, m = rpr.match(tagregex), i = 0;
	var pass = false;
	if(m) for(;i!=m.length; ++i) {
		var y = parsexmltag(m[i]);
		switch(y[0].replace(/\w*:/g,"")) {
			/* 18.8.12 condense CT_BooleanProperty */
			/* ** not required . */
			case '<condense': break;
			/* 18.8.17 extend CT_BooleanProperty */
			/* ** not required . */
			case '<extend': break;
			/* 18.8.36 shadow CT_BooleanProperty */
			/* ** not required . */
			case '<shadow':
				if(!y.val) break;
				/* falls through */
			case '<shadow>':
			case '<shadow/>': font.shadow = 1; break;
			case '</shadow>': break;

			/* 18.4.1 charset CT_IntProperty TODO */
			case '<charset':
				if(y.val == '1') break;
				font.cp = CS2CP[parseInt(y.val, 10)];
				break;

			/* 18.4.2 outline CT_BooleanProperty TODO */
			case '<outline':
				if(!y.val) break;
				/* falls through */
			case '<outline>':
			case '<outline/>': font.outline = 1; break;
			case '</outline>': break;

			/* 18.4.5 rFont CT_FontName */
			case '<rFont': font.name = y.val; break;

			/* 18.4.11 sz CT_FontSize */
			case '<sz': font.sz = y.val; break;

			/* 18.4.10 strike CT_BooleanProperty */
			case '<strike':
				if(!y.val) break;
				/* falls through */
			case '<strike>':
			case '<strike/>': font.strike = 1; break;
			case '</strike>': break;

			/* 18.4.13 u CT_UnderlineProperty */
			case '<u':
				if(!y.val) break;
				switch(y.val) {
					case 'double': font.uval = "double"; break;
					case 'singleAccounting': font.uval = "single-accounting"; break;
					case 'doubleAccounting': font.uval = "double-accounting"; break;
				}
				/* falls through */
			case '<u>':
			case '<u/>': font.u = 1; break;
			case '</u>': break;

			/* 18.8.2 b */
			case '<b':
				if(y.val == '0') break;
				/* falls through */
			case '<b>':
			case '<b/>': font.b = 1; break;
			case '</b>': break;

			/* 18.8.26 i */
			case '<i':
				if(y.val == '0') break;
				/* falls through */
			case '<i>':
			case '<i/>': font.i = 1; break;
			case '</i>': break;

			/* 18.3.1.15 color CT_Color TODO: tint, theme, auto, indexed */
			case '<color':
				if(y.rgb) font.color = y.rgb.slice(2,8);
				break;
			case '<color>': case '<color/>': case '</color>': break;

			/* 18.8.18 family ST_FontFamily */
			case '<family': font.family = y.val; break;
			case '<family>': case '<family/>': case '</family>': break;

			/* 18.4.14 vertAlign CT_VerticalAlignFontProperty TODO */
			case '<vertAlign': font.valign = y.val; break;
			case '<vertAlign>': case '<vertAlign/>': case '</vertAlign>': break;

			/* 18.8.35 scheme CT_FontScheme TODO */
			case '<scheme': break;
			case '<scheme>': case '<scheme/>': case '</scheme>': break;

			/* 18.2.10 extLst CT_ExtensionList ? */
			case '<extLst': case '<extLst>': case '</extLst>': break;
			case '<ext': pass = true; break;
			case '</ext>': pass = false; break;
			default:
				if(y[0].charCodeAt(1) !== 47 && !pass) throw new Error('Unrecognized rich format ' + y[0]);
		}
	}
	return font;
}

var parse_rs = /*#__PURE__*/(/* unused pure expression or super */ null && ((function() {
	var tregex = matchtag("t"), rpregex = matchtag("rPr");
	/* 18.4.4 r CT_RElt */
	function parse_r(r) {
		/* 18.4.12 t ST_Xstring */
		var t = r.match(tregex)/*, cp = 65001*/;
		if(!t) return {t:"s", v:""};

		var o/*:Cell*/ = ({t:'s', v:unescapexml(t[1])}/*:any*/);
		var rpr = r.match(rpregex);
		if(rpr) o.s = parse_rpr(rpr[1]);
		return o;
	}
	var rregex = /<(?:\w+:)?r>/g, rend = /<\/(?:\w+:)?r>/;
	return function parse_rs(rs) {
		return rs.replace(rregex,"").split(rend).map(parse_r).filter(function(r) { return r.v; });
	};
})()));


/* Parse a list of <r> tags */
var rs_to_html = /*#__PURE__*/(/* unused pure expression or super */ null && ((function parse_rs_factory() {
	var nlregex = /(\r\n|\n)/g;
	function parse_rpr2(font, intro, outro) {
		var style/*:Array<string>*/ = [];

		if(font.u) style.push("text-decoration: underline;");
		if(font.uval) style.push("text-underline-style:" + font.uval + ";");
		if(font.sz) style.push("font-size:" + font.sz + "pt;");
		if(font.outline) style.push("text-effect: outline;");
		if(font.shadow) style.push("text-shadow: auto;");
		intro.push('<span style="' + style.join("") + '">');

		if(font.b) { intro.push("<b>"); outro.push("</b>"); }
		if(font.i) { intro.push("<i>"); outro.push("</i>"); }
		if(font.strike) { intro.push("<s>"); outro.push("</s>"); }

		var align = font.valign || "";
		if(align == "superscript" || align == "super") align = "sup";
		else if(align == "subscript") align = "sub";
		if(align != "") { intro.push("<" + align + ">"); outro.push("</" + align + ">"); }

		outro.push("</span>");
		return font;
	}

	/* 18.4.4 r CT_RElt */
	function r_to_html(r) {
		var terms/*:[Array<string>, string, Array<string>]*/ = [[],r.v,[]];
		if(!r.v) return "";

		if(r.s) parse_rpr2(r.s, terms[0], terms[2]);

		return terms[0].join("") + terms[1].replace(nlregex,'<br/>') + terms[2].join("");
	}

	return function parse_rs(rs) {
		return rs.map(r_to_html).join("");
	};
})()));

/* 18.4.8 si CT_Rst */
var sitregex = /<(?:\w+:)?t[^>]*>([^<]*)<\/(?:\w+:)?t>/g, sirregex = /<(?:\w+:)?r>/;
var sirphregex = /<(?:\w+:)?rPh.*?>([\s\S]*?)<\/(?:\w+:)?rPh>/g;
function parse_si(x, opts) {
	var html = opts ? opts.cellHTML : true;
	var z = {};
	if(!x) return { t: "" };
	//var y;
	/* 18.4.12 t ST_Xstring (Plaintext String) */
	// TODO: is whitespace actually valid here?
	if(x.match(/^\s*<(?:\w+:)?t[^>]*>/)) {
		z.t = unescapexml(utf8read(x.slice(x.indexOf(">")+1).split(/<\/(?:\w+:)?t>/)[0]||""));
		z.r = utf8read(x);
		if(html) z.h = escapehtml(z.t);
	}
	/* 18.4.4 r CT_RElt (Rich Text Run) */
	else if((/*y = */x.match(sirregex))) {
		z.r = utf8read(x);
		z.t = unescapexml(utf8read((x.replace(sirphregex, '').match(sitregex)||[]).join("").replace(tagregex,"")));
		if(html) z.h = rs_to_html(parse_rs(z.r));
	}
	/* 18.4.3 phoneticPr CT_PhoneticPr (TODO: needed for Asian support) */
	/* 18.4.6 rPh CT_PhoneticRun (TODO: needed for Asian support) */
	return z;
}

/* 18.4 Shared String Table */
var sstr0 = /<(?:\w+:)?sst([^>]*)>([\s\S]*)<\/(?:\w+:)?sst>/;
var sstr1 = /<(?:\w+:)?(?:si|sstItem)>/g;
var sstr2 = /<\/(?:\w+:)?(?:si|sstItem)>/;
function parse_sst_xml(data/*:string*/, opts)/*:SST*/ {
	var s/*:SST*/ = ([]/*:any*/), ss = "";
	if(!data) return s;
	/* 18.4.9 sst CT_Sst */
	var sst = data.match(sstr0);
	if(sst) {
		ss = sst[2].replace(sstr1,"").split(sstr2);
		for(var i = 0; i != ss.length; ++i) {
			var o = parse_si(ss[i].trim(), opts);
			if(o != null) s[s.length] = o;
		}
		sst = parsexmltag(sst[1]); s.Count = sst.count; s.Unique = sst.uniqueCount;
	}
	return s;
}

var straywsregex = /^\s|\s$|[\t\n\r]/;
function write_sst_xml(sst/*:SST*/, opts)/*:string*/ {
	if(!opts.bookSST) return "";
	var o = [XML_HEADER];
	o[o.length] = (writextag('sst', null, {
		xmlns: XMLNS_main[0],
		count: sst.Count,
		uniqueCount: sst.Unique
	}));
	for(var i = 0; i != sst.length; ++i) { if(sst[i] == null) continue;
		var s/*:XLString*/ = sst[i];
		var sitag = "<si>";
		if(s.r) sitag += s.r;
		else {
			sitag += "<t";
			if(!s.t) s.t = "";
			if(s.t.match(straywsregex)) sitag += ' xml:space="preserve"';
			sitag += ">" + escapexml(s.t) + "</t>";
		}
		sitag += "</si>";
		o[o.length] = (sitag);
	}
	if(o.length>2){ o[o.length] = ('</sst>'); o[1]=o[1].replace("/>",">"); }
	return o.join("");
}
/* [MS-XLSB] 2.4.221 BrtBeginSst */
function parse_BrtBeginSst(data) {
	return [data.read_shift(4), data.read_shift(4)];
}

/* [MS-XLSB] 2.1.7.45 Shared Strings */
function parse_sst_bin(data, opts)/*:SST*/ {
	var s/*:SST*/ = ([]/*:any*/);
	var pass = false;
	recordhopper(data, function hopper_sst(val, R, RT) {
		switch(RT) {
			case 0x009F: /* BrtBeginSst */
				s.Count = val[0]; s.Unique = val[1]; break;
			case 0x0013: /* BrtSSTItem */
				s.push(val); break;
			case 0x00A0: /* BrtEndSst */
				return true;

			case 0x0023: /* BrtFRTBegin */
				pass = true; break;
			case 0x0024: /* BrtFRTEnd */
				pass = false; break;

			default:
				if(R.T){}
				if(!pass || opts.WTF) throw new Error("Unexpected record 0x" + RT.toString(16));
		}
	});
	return s;
}

function write_BrtBeginSst(sst, o) {
	if(!o) o = new_buf(8);
	o.write_shift(4, sst.Count);
	o.write_shift(4, sst.Unique);
	return o;
}

var write_BrtSSTItem = write_RichStr;

function write_sst_bin(sst/*::, opts*/) {
	var ba = buf_array();
	write_record(ba, 0x009F /* BrtBeginSst */, write_BrtBeginSst(sst));
	for(var i = 0; i < sst.length; ++i) write_record(ba, 0x0013 /* BrtSSTItem */, write_BrtSSTItem(sst[i]));
	/* FRTSST */
	write_record(ba, 0x00A0 /* BrtEndSst */);
	return ba.end();
}
function _JS2ANSI(str/*:string*/)/*:Array<number>*/ {
	if(typeof $cptable !== 'undefined') return $cptable.utils.encode(current_ansi, str);
	var o/*:Array<number>*/ = [], oo = str.split("");
	for(var i = 0; i < oo.length; ++i) o[i] = oo[i].charCodeAt(0);
	return o;
}

/* [MS-OFFCRYPTO] 2.1.4 Version */
function parse_CRYPTOVersion(blob, length/*:?number*/) {
	var o/*:any*/ = {};
	o.Major = blob.read_shift(2);
	o.Minor = blob.read_shift(2);
	/*:: if(length == null) return o; */
	if(length >= 4) blob.l += length - 4;
	return o;
}

/* [MS-OFFCRYPTO] 2.1.5 DataSpaceVersionInfo */
function parse_DataSpaceVersionInfo(blob) {
	var o = {};
	o.id = blob.read_shift(0, 'lpp4');
	o.R = parse_CRYPTOVersion(blob, 4);
	o.U = parse_CRYPTOVersion(blob, 4);
	o.W = parse_CRYPTOVersion(blob, 4);
	return o;
}

/* [MS-OFFCRYPTO] 2.1.6.1 DataSpaceMapEntry Structure */
function parse_DataSpaceMapEntry(blob) {
	var len = blob.read_shift(4);
	var end = blob.l + len - 4;
	var o = {};
	var cnt = blob.read_shift(4);
	var comps/*:Array<{t:number, v:string}>*/ = [];
	/* [MS-OFFCRYPTO] 2.1.6.2 DataSpaceReferenceComponent Structure */
	while(cnt-- > 0) comps.push({ t: blob.read_shift(4), v: blob.read_shift(0, 'lpp4') });
	o.name = blob.read_shift(0, 'lpp4');
	o.comps = comps;
	if(blob.l != end) throw new Error("Bad DataSpaceMapEntry: " + blob.l + " != " + end);
	return o;
}

/* [MS-OFFCRYPTO] 2.1.6 DataSpaceMap */
function parse_DataSpaceMap(blob) {
	var o = [];
	blob.l += 4; // must be 0x8
	var cnt = blob.read_shift(4);
	while(cnt-- > 0) o.push(parse_DataSpaceMapEntry(blob));
	return o;
}

/* [MS-OFFCRYPTO] 2.1.7 DataSpaceDefinition */
function parse_DataSpaceDefinition(blob)/*:Array<string>*/ {
	var o/*:Array<string>*/ = [];
	blob.l += 4; // must be 0x8
	var cnt = blob.read_shift(4);
	while(cnt-- > 0) o.push(blob.read_shift(0, 'lpp4'));
	return o;
}

/* [MS-OFFCRYPTO] 2.1.8 DataSpaceDefinition */
function parse_TransformInfoHeader(blob) {
	var o = {};
	/*var len = */blob.read_shift(4);
	blob.l += 4; // must be 0x1
	o.id = blob.read_shift(0, 'lpp4');
	o.name = blob.read_shift(0, 'lpp4');
	o.R = parse_CRYPTOVersion(blob, 4);
	o.U = parse_CRYPTOVersion(blob, 4);
	o.W = parse_CRYPTOVersion(blob, 4);
	return o;
}

function parse_Primary(blob) {
	/* [MS-OFFCRYPTO] 2.2.6 IRMDSTransformInfo */
	var hdr = parse_TransformInfoHeader(blob);
	/* [MS-OFFCRYPTO] 2.1.9 EncryptionTransformInfo */
	hdr.ename = blob.read_shift(0, '8lpp4');
	hdr.blksz = blob.read_shift(4);
	hdr.cmode = blob.read_shift(4);
	if(blob.read_shift(4) != 0x04) throw new Error("Bad !Primary record");
	return hdr;
}

/* [MS-OFFCRYPTO] 2.3.2 Encryption Header */
function parse_EncryptionHeader(blob, length/*:number*/) {
	var tgt = blob.l + length;
	var o = {};
	o.Flags = (blob.read_shift(4) & 0x3F);
	blob.l += 4;
	o.AlgID = blob.read_shift(4);
	var valid = false;
	switch(o.AlgID) {
		case 0x660E: case 0x660F: case 0x6610: valid = (o.Flags == 0x24); break;
		case 0x6801: valid = (o.Flags == 0x04); break;
		case 0: valid = (o.Flags == 0x10 || o.Flags == 0x04 || o.Flags == 0x24); break;
		default: throw 'Unrecognized encryption algorithm: ' + o.AlgID;
	}
	if(!valid) throw new Error("Encryption Flags/AlgID mismatch");
	o.AlgIDHash = blob.read_shift(4);
	o.KeySize = blob.read_shift(4);
	o.ProviderType = blob.read_shift(4);
	blob.l += 8;
	o.CSPName = blob.read_shift((tgt-blob.l)>>1, 'utf16le');
	blob.l = tgt;
	return o;
}

/* [MS-OFFCRYPTO] 2.3.3 Encryption Verifier */
function parse_EncryptionVerifier(blob, length/*:number*/) {
	var o = {}, tgt = blob.l + length;
	blob.l += 4; // SaltSize must be 0x10
	o.Salt = blob.slice(blob.l, blob.l+16); blob.l += 16;
	o.Verifier = blob.slice(blob.l, blob.l+16); blob.l += 16;
	/*var sz = */blob.read_shift(4);
	o.VerifierHash = blob.slice(blob.l, tgt); blob.l = tgt;
	return o;
}

/* [MS-OFFCRYPTO] 2.3.4.* EncryptionInfo Stream */
function parse_EncryptionInfo(blob) {
	var vers = parse_CRYPTOVersion(blob);
	switch(vers.Minor) {
		case 0x02: return [vers.Minor, parse_EncInfoStd(blob, vers)];
		case 0x03: return [vers.Minor, parse_EncInfoExt(blob, vers)];
		case 0x04: return [vers.Minor, parse_EncInfoAgl(blob, vers)];
	}
	throw new Error("ECMA-376 Encrypted file unrecognized Version: " + vers.Minor);
}

/* [MS-OFFCRYPTO] 2.3.4.5  EncryptionInfo Stream (Standard Encryption) */
function parse_EncInfoStd(blob/*::, vers*/) {
	var flags = blob.read_shift(4);
	if((flags & 0x3F) != 0x24) throw new Error("EncryptionInfo mismatch");
	var sz = blob.read_shift(4);
	//var tgt = blob.l + sz;
	var hdr = parse_EncryptionHeader(blob, sz);
	var verifier = parse_EncryptionVerifier(blob, blob.length - blob.l);
	return { t:"Std", h:hdr, v:verifier };
}
/* [MS-OFFCRYPTO] 2.3.4.6  EncryptionInfo Stream (Extensible Encryption) */
function parse_EncInfoExt(/*::blob, vers*/) { throw new Error("File is password-protected: ECMA-376 Extensible"); }
/* [MS-OFFCRYPTO] 2.3.4.10 EncryptionInfo Stream (Agile Encryption) */
function parse_EncInfoAgl(blob/*::, vers*/) {
	var KeyData = ["saltSize","blockSize","keyBits","hashSize","cipherAlgorithm","cipherChaining","hashAlgorithm","saltValue"];
	blob.l+=4;
	var xml = blob.read_shift(blob.length - blob.l, 'utf8');
	var o = {};
	xml.replace(tagregex, function xml_agile(x) {
		var y/*:any*/ = parsexmltag(x);
		switch(strip_ns(y[0])) {
			case '<?xml': break;
			case '<encryption': case '</encryption>': break;
			case '<keyData': KeyData.forEach(function(k) { o[k] = y[k]; }); break;
			case '<dataIntegrity': o.encryptedHmacKey = y.encryptedHmacKey; o.encryptedHmacValue = y.encryptedHmacValue; break;
			case '<keyEncryptors>': case '<keyEncryptors': o.encs = []; break;
			case '</keyEncryptors>': break;

			case '<keyEncryptor': o.uri = y.uri; break;
			case '</keyEncryptor>': break;
			case '<encryptedKey': o.encs.push(y); break;
			default: throw y[0];
		}
	});
	return o;
}

/* [MS-OFFCRYPTO] 2.3.5.1 RC4 CryptoAPI Encryption Header */
function parse_RC4CryptoHeader(blob, length/*:number*/) {
	var o = {};
	var vers = o.EncryptionVersionInfo = parse_CRYPTOVersion(blob, 4); length -= 4;
	if(vers.Minor != 2) throw new Error('unrecognized minor version code: ' + vers.Minor);
	if(vers.Major > 4 || vers.Major < 2) throw new Error('unrecognized major version code: ' + vers.Major);
	o.Flags = blob.read_shift(4); length -= 4;
	var sz = blob.read_shift(4); length -= 4;
	o.EncryptionHeader = parse_EncryptionHeader(blob, sz); length -= sz;
	o.EncryptionVerifier = parse_EncryptionVerifier(blob, length);
	return o;
}
/* [MS-OFFCRYPTO] 2.3.6.1 RC4 Encryption Header */
function parse_RC4Header(blob/*::, length*/) {
	var o = {};
	var vers = o.EncryptionVersionInfo = parse_CRYPTOVersion(blob, 4);
	if(vers.Major != 1 || vers.Minor != 1) throw 'unrecognized version code ' + vers.Major + ' : ' + vers.Minor;
	o.Salt = blob.read_shift(16);
	o.EncryptedVerifier = blob.read_shift(16);
	o.EncryptedVerifierHash = blob.read_shift(16);
	return o;
}

/* [MS-OFFCRYPTO] 2.3.7.1 Binary Document Password Verifier Derivation */
function crypto_CreatePasswordVerifier_Method1(Password/*:string*/) {
	var Verifier = 0x0000, PasswordArray;
	var PasswordDecoded = _JS2ANSI(Password);
	var len = PasswordDecoded.length + 1, i, PasswordByte;
	var Intermediate1, Intermediate2, Intermediate3;
	PasswordArray = new_raw_buf(len);
	PasswordArray[0] = PasswordDecoded.length;
	for(i = 1; i != len; ++i) PasswordArray[i] = PasswordDecoded[i-1];
	for(i = len-1; i >= 0; --i) {
		PasswordByte = PasswordArray[i];
		Intermediate1 = ((Verifier & 0x4000) === 0x0000) ? 0 : 1;
		Intermediate2 = (Verifier << 1) & 0x7FFF;
		Intermediate3 = Intermediate1 | Intermediate2;
		Verifier = Intermediate3 ^ PasswordByte;
	}
	return Verifier ^ 0xCE4B;
}

/* [MS-OFFCRYPTO] 2.3.7.2 Binary Document XOR Array Initialization */
var crypto_CreateXorArray_Method1 = /*#__PURE__*/(function() {
	var PadArray = [0xBB, 0xFF, 0xFF, 0xBA, 0xFF, 0xFF, 0xB9, 0x80, 0x00, 0xBE, 0x0F, 0x00, 0xBF, 0x0F, 0x00];
	var InitialCode = [0xE1F0, 0x1D0F, 0xCC9C, 0x84C0, 0x110C, 0x0E10, 0xF1CE, 0x313E, 0x1872, 0xE139, 0xD40F, 0x84F9, 0x280C, 0xA96A, 0x4EC3];
	var XorMatrix = [0xAEFC, 0x4DD9, 0x9BB2, 0x2745, 0x4E8A, 0x9D14, 0x2A09, 0x7B61, 0xF6C2, 0xFDA5, 0xEB6B, 0xC6F7, 0x9DCF, 0x2BBF, 0x4563, 0x8AC6, 0x05AD, 0x0B5A, 0x16B4, 0x2D68, 0x5AD0, 0x0375, 0x06EA, 0x0DD4, 0x1BA8, 0x3750, 0x6EA0, 0xDD40, 0xD849, 0xA0B3, 0x5147, 0xA28E, 0x553D, 0xAA7A, 0x44D5, 0x6F45, 0xDE8A, 0xAD35, 0x4A4B, 0x9496, 0x390D, 0x721A, 0xEB23, 0xC667, 0x9CEF, 0x29FF, 0x53FE, 0xA7FC, 0x5FD9, 0x47D3, 0x8FA6, 0x0F6D, 0x1EDA, 0x3DB4, 0x7B68, 0xF6D0, 0xB861, 0x60E3, 0xC1C6, 0x93AD, 0x377B, 0x6EF6, 0xDDEC, 0x45A0, 0x8B40, 0x06A1, 0x0D42, 0x1A84, 0x3508, 0x6A10, 0xAA51, 0x4483, 0x8906, 0x022D, 0x045A, 0x08B4, 0x1168, 0x76B4, 0xED68, 0xCAF1, 0x85C3, 0x1BA7, 0x374E, 0x6E9C, 0x3730, 0x6E60, 0xDCC0, 0xA9A1, 0x4363, 0x86C6, 0x1DAD, 0x3331, 0x6662, 0xCCC4, 0x89A9, 0x0373, 0x06E6, 0x0DCC, 0x1021, 0x2042, 0x4084, 0x8108, 0x1231, 0x2462, 0x48C4];
	var Ror = function(Byte) { return ((Byte/2) | (Byte*128)) & 0xFF; };
	var XorRor = function(byte1, byte2) { return Ror(byte1 ^ byte2); };
	var CreateXorKey_Method1 = function(Password) {
		var XorKey = InitialCode[Password.length - 1];
		var CurrentElement = 0x68;
		for(var i = Password.length-1; i >= 0; --i) {
			var Char = Password[i];
			for(var j = 0; j != 7; ++j) {
				if(Char & 0x40) XorKey ^= XorMatrix[CurrentElement];
				Char *= 2; --CurrentElement;
			}
		}
		return XorKey;
	};
	return function(password/*:string*/) {
		var Password = _JS2ANSI(password);
		var XorKey = CreateXorKey_Method1(Password);
		var Index = Password.length;
		var ObfuscationArray = new_raw_buf(16);
		for(var i = 0; i != 16; ++i) ObfuscationArray[i] = 0x00;
		var Temp, PasswordLastChar, PadIndex;
		if((Index & 1) === 1) {
			Temp = XorKey >> 8;
			ObfuscationArray[Index] = XorRor(PadArray[0], Temp);
			--Index;
			Temp = XorKey & 0xFF;
			PasswordLastChar = Password[Password.length - 1];
			ObfuscationArray[Index] = XorRor(PasswordLastChar, Temp);
		}
		while(Index > 0) {
			--Index;
			Temp = XorKey >> 8;
			ObfuscationArray[Index] = XorRor(Password[Index], Temp);
			--Index;
			Temp = XorKey & 0xFF;
			ObfuscationArray[Index] = XorRor(Password[Index], Temp);
		}
		Index = 15;
		PadIndex = 15 - Password.length;
		while(PadIndex > 0) {
			Temp = XorKey >> 8;
			ObfuscationArray[Index] = XorRor(PadArray[PadIndex], Temp);
			--Index;
			--PadIndex;
			Temp = XorKey & 0xFF;
			ObfuscationArray[Index] = XorRor(Password[Index], Temp);
			--Index;
			--PadIndex;
		}
		return ObfuscationArray;
	};
})();

/* [MS-OFFCRYPTO] 2.3.7.3 Binary Document XOR Data Transformation Method 1 */
var crypto_DecryptData_Method1 = function(password/*:string*/, Data, XorArrayIndex, XorArray, O) {
	/* If XorArray is set, use it; if O is not set, make changes in-place */
	if(!O) O = Data;
	if(!XorArray) XorArray = crypto_CreateXorArray_Method1(password);
	var Index, Value;
	for(Index = 0; Index != Data.length; ++Index) {
		Value = Data[Index];
		Value ^= XorArray[XorArrayIndex];
		Value = ((Value>>5) | (Value<<3)) & 0xFF;
		O[Index] = Value;
		++XorArrayIndex;
	}
	return [O, XorArrayIndex, XorArray];
};

var crypto_MakeXorDecryptor = function(password/*:string*/) {
	var XorArrayIndex = 0, XorArray = crypto_CreateXorArray_Method1(password);
	return function(Data) {
		var O = crypto_DecryptData_Method1("", Data, XorArrayIndex, XorArray);
		XorArrayIndex = O[1];
		return O[0];
	};
};

/* 2.5.343 */
function parse_XORObfuscation(blob, length, opts, out) {
	var o = ({ key: parseuint16(blob), verificationBytes: parseuint16(blob) }/*:any*/);
	if(opts.password) o.verifier = crypto_CreatePasswordVerifier_Method1(opts.password);
	out.valid = o.verificationBytes === o.verifier;
	if(out.valid) out.insitu = crypto_MakeXorDecryptor(opts.password);
	return o;
}

/* 2.4.117 */
function parse_FilePassHeader(blob, length/*:number*/, oo) {
	var o = oo || {}; o.Info = blob.read_shift(2); blob.l -= 2;
	if(o.Info === 1) o.Data = parse_RC4Header(blob, length);
	else o.Data = parse_RC4CryptoHeader(blob, length);
	return o;
}
function parse_FilePass(blob, length/*:number*/, opts) {
	var o = ({ Type: opts.biff >= 8 ? blob.read_shift(2) : 0 }/*:any*/); /* wEncryptionType */
	if(o.Type) parse_FilePassHeader(blob, length-2, o);
	else parse_XORObfuscation(blob, opts.biff >= 8 ? length : length - 2, opts, o);
	return o;
}


var RTF = /*#__PURE__*/(function() {
	function rtf_to_sheet(d/*:RawData*/, opts)/*:Worksheet*/ {
		switch(opts.type) {
			case 'base64': return rtf_to_sheet_str(Base64_decode(d), opts);
			case 'binary': return rtf_to_sheet_str(d, opts);
			case 'buffer': return rtf_to_sheet_str(has_buf && Buffer.isBuffer(d) ? d.toString('binary') : a2s(d), opts);
			case 'array':  return rtf_to_sheet_str(cc2str(d), opts);
		}
		throw new Error("Unrecognized type " + opts.type);
	}

	/* TODO: this is a stub */
	function rtf_to_sheet_str(str/*:string*/, opts)/*:Worksheet*/ {
		var o = opts || {};
		var ws/*:Worksheet*/ = o.dense ? ([]/*:any*/) : ({}/*:any*/);

		var rows = str.match(/\\trowd.*?\\row\b/g);
		if(!rows.length) throw new Error("RTF missing table");
		var range/*:Range*/ = ({s: {c:0, r:0}, e: {c:0, r:rows.length - 1}}/*:any*/);
		rows.forEach(function(rowtf, R) {
			if(Array.isArray(ws)) ws[R] = [];
			var rtfre = /\\\w+\b/g;
			var last_index = 0;
			var res;
			var C = -1;
			while((res = rtfre.exec(rowtf))) {
				switch(res[0]) {
					case "\\cell":
						var data = rowtf.slice(last_index, rtfre.lastIndex - res[0].length);
						if(data[0] == " ") data = data.slice(1);
						++C;
						if(data.length) {
							// TODO: value parsing, including codepage adjustments
							var cell = {v: data, t:"s"};
							if(Array.isArray(ws)) ws[R][C] = cell;
							else ws[encode_cell({r:R, c:C})] = cell;
						}
						break;
				}
				last_index = rtfre.lastIndex;
			}
			if(C > range.e.c) range.e.c = C;
		});
		ws['!ref'] = encode_range(range);
		return ws;
	}

	function rtf_to_workbook(d/*:RawData*/, opts)/*:Workbook*/ { return sheet_to_workbook(rtf_to_sheet(d, opts), opts); }

	/* TODO: this is a stub */
	function sheet_to_rtf(ws/*:Worksheet*//*::, opts*/)/*:string*/ {
		var o = ["{\\rtf1\\ansi"];
		var r = safe_decode_range(ws['!ref']), cell/*:Cell*/;
		var dense = Array.isArray(ws);
		for(var R = r.s.r; R <= r.e.r; ++R) {
			o.push("\\trowd\\trautofit1");
			for(var C = r.s.c; C <= r.e.c; ++C) o.push("\\cellx" + (C+1));
			o.push("\\pard\\intbl");
			for(C = r.s.c; C <= r.e.c; ++C) {
				var coord = encode_cell({r:R,c:C});
				cell = dense ? (ws[R]||[])[C]: ws[coord];
				if(!cell || cell.v == null && (!cell.f || cell.F)) continue;
				o.push(" " + (cell.w || (format_cell(cell), cell.w)));
				o.push("\\cell");
			}
			o.push("\\pard\\intbl\\row");
		}
		return o.join("") + "}";
	}

	return {
		to_workbook: rtf_to_workbook,
		to_sheet: rtf_to_sheet,
		from_sheet: sheet_to_rtf
	};
})();
function hex2RGB(h) {
	var o = h.slice(h[0]==="#"?1:0).slice(0,6);
	return [parseInt(o.slice(0,2),16),parseInt(o.slice(2,4),16),parseInt(o.slice(4,6),16)];
}
function rgb2Hex(rgb) {
	for(var i=0,o=1; i!=3; ++i) o = o*256 + (rgb[i]>255?255:rgb[i]<0?0:rgb[i]);
	return o.toString(16).toUpperCase().slice(1);
}

function rgb2HSL(rgb) {
	var R = rgb[0]/255, G = rgb[1]/255, B=rgb[2]/255;
	var M = Math.max(R, G, B), m = Math.min(R, G, B), C = M - m;
	if(C === 0) return [0, 0, R];

	var H6 = 0, S = 0, L2 = (M + m);
	S = C / (L2 > 1 ? 2 - L2 : L2);
	switch(M){
		case R: H6 = ((G - B) / C + 6)%6; break;
		case G: H6 = ((B - R) / C + 2); break;
		case B: H6 = ((R - G) / C + 4); break;
	}
	return [H6 / 6, S, L2 / 2];
}

function hsl2RGB(hsl){
	var H = hsl[0], S = hsl[1], L = hsl[2];
	var C = S * 2 * (L < 0.5 ? L : 1 - L), m = L - C/2;
	var rgb = [m,m,m], h6 = 6*H;

	var X;
	if(S !== 0) switch(h6|0) {
		case 0: case 6: X = C * h6; rgb[0] += C; rgb[1] += X; break;
		case 1: X = C * (2 - h6);   rgb[0] += X; rgb[1] += C; break;
		case 2: X = C * (h6 - 2);   rgb[1] += C; rgb[2] += X; break;
		case 3: X = C * (4 - h6);   rgb[1] += X; rgb[2] += C; break;
		case 4: X = C * (h6 - 4);   rgb[2] += C; rgb[0] += X; break;
		case 5: X = C * (6 - h6);   rgb[2] += X; rgb[0] += C; break;
	}
	for(var i = 0; i != 3; ++i) rgb[i] = Math.round(rgb[i]*255);
	return rgb;
}

/* 18.8.3 bgColor tint algorithm */
function rgb_tint(hex, tint) {
	if(tint === 0) return hex;
	var hsl = rgb2HSL(hex2RGB(hex));
	if (tint < 0) hsl[2] = hsl[2] * (1 + tint);
	else hsl[2] = 1 - (1 - hsl[2]) * (1 - tint);
	return rgb2Hex(hsl2RGB(hsl));
}

/* 18.3.1.13 width calculations */
/* [MS-OI29500] 2.1.595 Column Width & Formatting */
var DEF_MDW = 6, MAX_MDW = 15, MIN_MDW = 1, MDW = DEF_MDW;
function width2px(width) { return Math.floor(( width + (Math.round(128/MDW))/256 )* MDW ); }
function px2char(px) { return (Math.floor((px - 5)/MDW * 100 + 0.5))/100; }
function char2width(chr) { return (Math.round((chr * MDW + 5)/MDW*256))/256; }
//function px2char_(px) { return (((px - 5)/MDW * 100 + 0.5))/100; }
//function char2width_(chr) { return (((chr * MDW + 5)/MDW*256))/256; }
function cycle_width(collw) { return char2width(px2char(width2px(collw))); }
/* XLSX/XLSB/XLS specify width in units of MDW */
function find_mdw_colw(collw) {
	var delta = Math.abs(collw - cycle_width(collw)), _MDW = MDW;
	if(delta > 0.005) for(MDW=MIN_MDW; MDW<MAX_MDW; ++MDW) if(Math.abs(collw - cycle_width(collw)) <= delta) { delta = Math.abs(collw - cycle_width(collw)); _MDW = MDW; }
	MDW = _MDW;
}
/* XLML specifies width in terms of pixels */
/*function find_mdw_wpx(wpx) {
	var delta = Infinity, guess = 0, _MDW = MIN_MDW;
	for(MDW=MIN_MDW; MDW<MAX_MDW; ++MDW) {
		guess = char2width_(px2char_(wpx))*256;
		guess = (guess) % 1;
		if(guess > 0.5) guess--;
		if(Math.abs(guess) < delta) { delta = Math.abs(guess); _MDW = MDW; }
	}
	MDW = _MDW;
}*/

function process_col(coll/*:ColInfo*/) {
	if(coll.width) {
		coll.wpx = width2px(coll.width);
		coll.wch = px2char(coll.wpx);
		coll.MDW = MDW;
	} else if(coll.wpx) {
		coll.wch = px2char(coll.wpx);
		coll.width = char2width(coll.wch);
		coll.MDW = MDW;
	} else if(typeof coll.wch == 'number') {
		coll.width = char2width(coll.wch);
		coll.wpx = width2px(coll.width);
		coll.MDW = MDW;
	}
	if(coll.customWidth) delete coll.customWidth;
}

var DEF_PPI = 96, PPI = DEF_PPI;
function px2pt(px) { return px * 96 / PPI; }
function pt2px(pt) { return pt * PPI / 96; }

/* [MS-EXSPXML3] 2.4.54 ST_enmPattern */
var XLMLPatternTypeMap = {
	"None": "none",
	"Solid": "solid",
	"Gray50": "mediumGray",
	"Gray75": "darkGray",
	"Gray25": "lightGray",
	"HorzStripe": "darkHorizontal",
	"VertStripe": "darkVertical",
	"ReverseDiagStripe": "darkDown",
	"DiagStripe": "darkUp",
	"DiagCross": "darkGrid",
	"ThickDiagCross": "darkTrellis",
	"ThinHorzStripe": "lightHorizontal",
	"ThinVertStripe": "lightVertical",
	"ThinReverseDiagStripe": "lightDown",
	"ThinHorzCross": "lightGrid"
};

/* 18.8.5 borders CT_Borders */
function parse_borders(t, styles, themes, opts) {
	styles.Borders = [];
	var border = {};
	var pass = false;
	(t[0].match(tagregex)||[]).forEach(function(x) {
		var y = parsexmltag(x);
		switch(strip_ns(y[0])) {
			case '<borders': case '<borders>': case '</borders>': break;

			/* 18.8.4 border CT_Border */
			case '<border': case '<border>': case '<border/>':
				border = /*::(*/{}/*:: :any)*/;
				if(y.diagonalUp) border.diagonalUp = parsexmlbool(y.diagonalUp);
				if(y.diagonalDown) border.diagonalDown = parsexmlbool(y.diagonalDown);
				styles.Borders.push(border);
				break;
			case '</border>': break;

			/* note: not in spec, appears to be CT_BorderPr */
			case '<left/>': break;
			case '<left': case '<left>': break;
			case '</left>': break;

			/* note: not in spec, appears to be CT_BorderPr */
			case '<right/>': break;
			case '<right': case '<right>': break;
			case '</right>': break;

			/* 18.8.43 top CT_BorderPr */
			case '<top/>': break;
			case '<top': case '<top>': break;
			case '</top>': break;

			/* 18.8.6 bottom CT_BorderPr */
			case '<bottom/>': break;
			case '<bottom': case '<bottom>': break;
			case '</bottom>': break;

			/* 18.8.13 diagonal CT_BorderPr */
			case '<diagonal': case '<diagonal>': case '<diagonal/>': break;
			case '</diagonal>': break;

			/* 18.8.25 horizontal CT_BorderPr */
			case '<horizontal': case '<horizontal>': case '<horizontal/>': break;
			case '</horizontal>': break;

			/* 18.8.44 vertical CT_BorderPr */
			case '<vertical': case '<vertical>': case '<vertical/>': break;
			case '</vertical>': break;

			/* 18.8.37 start CT_BorderPr */
			case '<start': case '<start>': case '<start/>': break;
			case '</start>': break;

			/* 18.8.16 end CT_BorderPr */
			case '<end': case '<end>': case '<end/>': break;
			case '</end>': break;

			/* 18.8.? color CT_Color */
			case '<color': case '<color>':
				break;
			case '<color/>': case '</color>': break;

			/* 18.2.10 extLst CT_ExtensionList ? */
			case '<extLst': case '<extLst>': case '</extLst>': break;
			case '<ext': pass = true; break;
			case '</ext>': pass = false; break;
			default: if(opts && opts.WTF) {
				if(!pass) throw new Error('unrecognized ' + y[0] + ' in borders');
			}
		}
	});
}

/* 18.8.21 fills CT_Fills */
function parse_fills(t, styles, themes, opts) {
	styles.Fills = [];
	var fill = {};
	var pass = false;
	(t[0].match(tagregex)||[]).forEach(function(x) {
		var y = parsexmltag(x);
		switch(strip_ns(y[0])) {
			case '<fills': case '<fills>': case '</fills>': break;

			/* 18.8.20 fill CT_Fill */
			case '<fill>': case '<fill': case '<fill/>':
				fill = {}; styles.Fills.push(fill); break;
			case '</fill>': break;

			/* 18.8.24 gradientFill CT_GradientFill */
			case '<gradientFill>': break;
			case '<gradientFill':
			case '</gradientFill>': styles.Fills.push(fill); fill = {}; break;

			/* 18.8.32 patternFill CT_PatternFill */
			case '<patternFill': case '<patternFill>':
				if(y.patternType) fill.patternType = y.patternType;
				break;
			case '<patternFill/>': case '</patternFill>': break;

			/* 18.8.3 bgColor CT_Color */
			case '<bgColor':
				if(!fill.bgColor) fill.bgColor = {};
				if(y.indexed) fill.bgColor.indexed = parseInt(y.indexed, 10);
				if(y.theme) fill.bgColor.theme = parseInt(y.theme, 10);
				if(y.tint) fill.bgColor.tint = parseFloat(y.tint);
				/* Excel uses ARGB strings */
				if(y.rgb) fill.bgColor.rgb = y.rgb.slice(-6);
				break;
			case '<bgColor/>': case '</bgColor>': break;

			/* 18.8.19 fgColor CT_Color */
			case '<fgColor':
				if(!fill.fgColor) fill.fgColor = {};
				if(y.theme) fill.fgColor.theme = parseInt(y.theme, 10);
				if(y.tint) fill.fgColor.tint = parseFloat(y.tint);
				/* Excel uses ARGB strings */
				if(y.rgb != null) fill.fgColor.rgb = y.rgb.slice(-6);
				break;
			case '<fgColor/>': case '</fgColor>': break;

			/* 18.8.38 stop CT_GradientStop */
			case '<stop': case '<stop/>': break;
			case '</stop>': break;

			/* 18.8.? color CT_Color */
			case '<color': case '<color/>': break;
			case '</color>': break;

			/* 18.2.10 extLst CT_ExtensionList ? */
			case '<extLst': case '<extLst>': case '</extLst>': break;
			case '<ext': pass = true; break;
			case '</ext>': pass = false; break;
			default: if(opts && opts.WTF) {
				if(!pass) throw new Error('unrecognized ' + y[0] + ' in fills');
			}
		}
	});
}

/* 18.8.23 fonts CT_Fonts */
function parse_fonts(t, styles, themes, opts) {
	styles.Fonts = [];
	var font = {};
	var pass = false;
	(t[0].match(tagregex)||[]).forEach(function(x) {
		var y = parsexmltag(x);
		switch(strip_ns(y[0])) {
			case '<fonts': case '<fonts>': case '</fonts>': break;

			/* 18.8.22 font CT_Font */
			case '<font': case '<font>': break;
			case '</font>': case '<font/>':
				styles.Fonts.push(font);
				font = {};
				break;

			/* 18.8.29 name CT_FontName */
			case '<name': if(y.val) font.name = utf8read(y.val); break;
			case '<name/>': case '</name>': break;

			/* 18.8.2  b CT_BooleanProperty */
			case '<b': font.bold = y.val ? parsexmlbool(y.val) : 1; break;
			case '<b/>': font.bold = 1; break;

			/* 18.8.26 i CT_BooleanProperty */
			case '<i': font.italic = y.val ? parsexmlbool(y.val) : 1; break;
			case '<i/>': font.italic = 1; break;

			/* 18.4.13 u CT_UnderlineProperty */
			case '<u':
				switch(y.val) {
					case "none": font.underline = 0x00; break;
					case "single": font.underline = 0x01; break;
					case "double": font.underline = 0x02; break;
					case "singleAccounting": font.underline = 0x21; break;
					case "doubleAccounting": font.underline = 0x22; break;
				} break;
			case '<u/>': font.underline = 1; break;

			/* 18.4.10 strike CT_BooleanProperty */
			case '<strike': font.strike = y.val ? parsexmlbool(y.val) : 1; break;
			case '<strike/>': font.strike = 1; break;

			/* 18.4.2  outline CT_BooleanProperty */
			case '<outline': font.outline = y.val ? parsexmlbool(y.val) : 1; break;
			case '<outline/>': font.outline = 1; break;

			/* 18.8.36 shadow CT_BooleanProperty */
			case '<shadow': font.shadow = y.val ? parsexmlbool(y.val) : 1; break;
			case '<shadow/>': font.shadow = 1; break;

			/* 18.8.12 condense CT_BooleanProperty */
			case '<condense': font.condense = y.val ? parsexmlbool(y.val) : 1; break;
			case '<condense/>': font.condense = 1; break;

			/* 18.8.17 extend CT_BooleanProperty */
			case '<extend': font.extend = y.val ? parsexmlbool(y.val) : 1; break;
			case '<extend/>': font.extend = 1; break;

			/* 18.4.11 sz CT_FontSize */
			case '<sz': if(y.val) font.sz = +y.val; break;
			case '<sz/>': case '</sz>': break;

			/* 18.4.14 vertAlign CT_VerticalAlignFontProperty */
			case '<vertAlign': if(y.val) font.vertAlign = y.val; break;
			case '<vertAlign/>': case '</vertAlign>': break;

			/* 18.8.18 family CT_FontFamily */
			case '<family': if(y.val) font.family = parseInt(y.val,10); break;
			case '<family/>': case '</family>': break;

			/* 18.8.35 scheme CT_FontScheme */
			case '<scheme': if(y.val) font.scheme = y.val; break;
			case '<scheme/>': case '</scheme>': break;

			/* 18.4.1 charset CT_IntProperty */
			case '<charset':
				if(y.val == '1') break;
				y.codepage = CS2CP[parseInt(y.val, 10)];
				break;

			/* 18.?.? color CT_Color */
			case '<color':
				if(!font.color) font.color = {};
				if(y.auto) font.color.auto = parsexmlbool(y.auto);

				if(y.rgb) font.color.rgb = y.rgb.slice(-6);
				else if(y.indexed) {
					font.color.index = parseInt(y.indexed, 10);
					var icv = XLSIcv[font.color.index];
					if(font.color.index == 81) icv = XLSIcv[1];
					if(!icv) icv = XLSIcv[1]; //throw new Error(x); // note: 206 is valid
					font.color.rgb = icv[0].toString(16) + icv[1].toString(16) + icv[2].toString(16);
				} else if(y.theme) {
					font.color.theme = parseInt(y.theme, 10);
					if(y.tint) font.color.tint = parseFloat(y.tint);
					if(y.theme && themes.themeElements && themes.themeElements.clrScheme) {
						font.color.rgb = rgb_tint(themes.themeElements.clrScheme[font.color.theme].rgb, font.color.tint || 0);
					}
				}

				break;
			case '<color/>': case '</color>': break;

			/* note: sometimes mc:AlternateContent appears bare */
			case '<AlternateContent': pass = true; break;
			case '</AlternateContent>': pass = false; break;

			/* 18.2.10 extLst CT_ExtensionList ? */
			case '<extLst': case '<extLst>': case '</extLst>': break;
			case '<ext': pass = true; break;
			case '</ext>': pass = false; break;
			default: if(opts && opts.WTF) {
				if(!pass) throw new Error('unrecognized ' + y[0] + ' in fonts');
			}
		}
	});
}

/* 18.8.31 numFmts CT_NumFmts */
function parse_numFmts(t, styles, opts) {
	styles.NumberFmt = [];
	var k/*Array<number>*/ = (keys(table_fmt)/*:any*/);
	for(var i=0; i < k.length; ++i) styles.NumberFmt[k[i]] = table_fmt[k[i]];
	var m = t[0].match(tagregex);
	if(!m) return;
	for(i=0; i < m.length; ++i) {
		var y = parsexmltag(m[i]);
		switch(strip_ns(y[0])) {
			case '<numFmts': case '</numFmts>': case '<numFmts/>': case '<numFmts>': break;
			case '<numFmt': {
				var f=unescapexml(utf8read(y.formatCode)), j=parseInt(y.numFmtId,10);
				styles.NumberFmt[j] = f;
				if(j>0) {
					if(j > 0x188) {
						for(j = 0x188; j > 0x3c; --j) if(styles.NumberFmt[j] == null) break;
						styles.NumberFmt[j] = f;
					}
					SSF_load(f,j);
				}
			} break;
			case '</numFmt>': break;
			default: if(opts.WTF) throw new Error('unrecognized ' + y[0] + ' in numFmts');
		}
	}
}

function write_numFmts(NF/*:{[n:number|string]:string}*//*::, opts*/) {
	var o = ["<numFmts>"];
	[[5,8],[23,26],[41,44],[/*63*/50,/*66],[164,*/392]].forEach(function(r) {
		for(var i = r[0]; i <= r[1]; ++i) if(NF[i] != null) o[o.length] = (writextag('numFmt',null,{numFmtId:i,formatCode:escapexml(NF[i])}));
	});
	if(o.length === 1) return "";
	o[o.length] = ("</numFmts>");
	o[0] = writextag('numFmts', null, { count:o.length-2 }).replace("/>", ">");
	return o.join("");
}

/* 18.8.10 cellXfs CT_CellXfs */
var cellXF_uint = (/* unused pure expression or super */ null && ([ "numFmtId", "fillId", "fontId", "borderId", "xfId" ]));
var cellXF_bool = (/* unused pure expression or super */ null && ([ "applyAlignment", "applyBorder", "applyFill", "applyFont", "applyNumberFormat", "applyProtection", "pivotButton", "quotePrefix" ]));
function parse_cellXfs(t, styles, opts) {
	styles.CellXf = [];
	var xf;
	var pass = false;
	(t[0].match(tagregex)||[]).forEach(function(x) {
		var y = parsexmltag(x), i = 0;
		switch(strip_ns(y[0])) {
			case '<cellXfs': case '<cellXfs>': case '<cellXfs/>': case '</cellXfs>': break;

			/* 18.8.45 xf CT_Xf */
			case '<xf': case '<xf/>':
				xf = y;
				delete xf[0];
				for(i = 0; i < cellXF_uint.length; ++i) if(xf[cellXF_uint[i]])
					xf[cellXF_uint[i]] = parseInt(xf[cellXF_uint[i]], 10);
				for(i = 0; i < cellXF_bool.length; ++i) if(xf[cellXF_bool[i]])
					xf[cellXF_bool[i]] = parsexmlbool(xf[cellXF_bool[i]]);
				if(styles.NumberFmt && xf.numFmtId > 0x188) {
					for(i = 0x188; i > 0x3c; --i) if(styles.NumberFmt[xf.numFmtId] == styles.NumberFmt[i]) { xf.numFmtId = i; break; }
				}
				styles.CellXf.push(xf); break;
			case '</xf>': break;

			/* 18.8.1 alignment CT_CellAlignment */
			case '<alignment': case '<alignment/>':
				var alignment = {};
				if(y.vertical) alignment.vertical = y.vertical;
				if(y.horizontal) alignment.horizontal = y.horizontal;
				if(y.textRotation != null) alignment.textRotation = y.textRotation;
				if(y.indent) alignment.indent = y.indent;
				if(y.wrapText) alignment.wrapText = parsexmlbool(y.wrapText);
				xf.alignment = alignment;
				break;
			case '</alignment>': break;

			/* 18.8.33 protection CT_CellProtection */
			case '<protection':
				break;
			case '</protection>': case '<protection/>': break;

			/* note: sometimes mc:AlternateContent appears bare */
			case '<AlternateContent': pass = true; break;
			case '</AlternateContent>': pass = false; break;

			/* 18.2.10 extLst CT_ExtensionList ? */
			case '<extLst': case '<extLst>': case '</extLst>': break;
			case '<ext': pass = true; break;
			case '</ext>': pass = false; break;
			default: if(opts && opts.WTF) {
				if(!pass) throw new Error('unrecognized ' + y[0] + ' in cellXfs');
			}
		}
	});
}

function write_cellXfs(cellXfs)/*:string*/ {
	var o/*:Array<string>*/ = [];
	o[o.length] = (writextag('cellXfs',null));
	cellXfs.forEach(function(c) {
		o[o.length] = (writextag('xf', null, c));
	});
	o[o.length] = ("</cellXfs>");
	if(o.length === 2) return "";
	o[0] = writextag('cellXfs',null, {count:o.length-2}).replace("/>",">");
	return o.join("");
}

/* 18.8 Styles CT_Stylesheet*/
var parse_sty_xml= /*#__PURE__*/(/* unused pure expression or super */ null && ((function make_pstyx() {
var numFmtRegex = /<(?:\w+:)?numFmts([^>]*)>[\S\s]*?<\/(?:\w+:)?numFmts>/;
var cellXfRegex = /<(?:\w+:)?cellXfs([^>]*)>[\S\s]*?<\/(?:\w+:)?cellXfs>/;
var fillsRegex = /<(?:\w+:)?fills([^>]*)>[\S\s]*?<\/(?:\w+:)?fills>/;
var fontsRegex = /<(?:\w+:)?fonts([^>]*)>[\S\s]*?<\/(?:\w+:)?fonts>/;
var bordersRegex = /<(?:\w+:)?borders([^>]*)>[\S\s]*?<\/(?:\w+:)?borders>/;

return function parse_sty_xml(data, themes, opts) {
	var styles = {};
	if(!data) return styles;
	data = data.replace(/<!--([\s\S]*?)-->/mg,"").replace(/<!DOCTYPE[^\[]*\[[^\]]*\]>/gm,"");
	/* 18.8.39 styleSheet CT_Stylesheet */
	var t;

	/* 18.8.31 numFmts CT_NumFmts ? */
	if((t=data.match(numFmtRegex))) parse_numFmts(t, styles, opts);

	/* 18.8.23 fonts CT_Fonts ? */
	if((t=data.match(fontsRegex))) parse_fonts(t, styles, themes, opts);

	/* 18.8.21 fills CT_Fills ? */
	if((t=data.match(fillsRegex))) parse_fills(t, styles, themes, opts);

	/* 18.8.5  borders CT_Borders ? */
	if((t=data.match(bordersRegex))) parse_borders(t, styles, themes, opts);

	/* 18.8.9  cellStyleXfs CT_CellStyleXfs ? */
	/* 18.8.8  cellStyles CT_CellStyles ? */

	/* 18.8.10 cellXfs CT_CellXfs ? */
	if((t=data.match(cellXfRegex))) parse_cellXfs(t, styles, opts);

	/* 18.8.15 dxfs CT_Dxfs ? */
	/* 18.8.42 tableStyles CT_TableStyles ? */
	/* 18.8.11 colors CT_Colors ? */
	/* 18.2.10 extLst CT_ExtensionList ? */

	return styles;
};
})()));

function write_sty_xml(wb/*:Workbook*/, opts)/*:string*/ {
	var o = [XML_HEADER, writextag('styleSheet', null, {
		'xmlns': XMLNS_main[0],
		'xmlns:vt': XMLNS.vt
	})], w;
	if(wb.SSF && (w = write_numFmts(wb.SSF)) != null) o[o.length] = w;
	o[o.length] = ('<fonts count="1"><font><sz val="12"/><color theme="1"/><name val="Calibri"/><family val="2"/><scheme val="minor"/></font></fonts>');
	o[o.length] = ('<fills count="2"><fill><patternFill patternType="none"/></fill><fill><patternFill patternType="gray125"/></fill></fills>');
	o[o.length] = ('<borders count="1"><border><left/><right/><top/><bottom/><diagonal/></border></borders>');
	o[o.length] = ('<cellStyleXfs count="1"><xf numFmtId="0" fontId="0" fillId="0" borderId="0"/></cellStyleXfs>');
	if((w = write_cellXfs(opts.cellXfs))) o[o.length] = (w);
	o[o.length] = ('<cellStyles count="1"><cellStyle name="Normal" xfId="0" builtinId="0"/></cellStyles>');
	o[o.length] = ('<dxfs count="0"/>');
	o[o.length] = ('<tableStyles count="0" defaultTableStyle="TableStyleMedium9" defaultPivotStyle="PivotStyleMedium4"/>');

	if(o.length>2){ o[o.length] = ('</styleSheet>'); o[1]=o[1].replace("/>",">"); }
	return o.join("");
}
/* [MS-XLSB] 2.4.657 BrtFmt */
function parse_BrtFmt(data, length/*:number*/) {
	var numFmtId = data.read_shift(2);
	var stFmtCode = parse_XLWideString(data,length-2);
	return [numFmtId, stFmtCode];
}
function write_BrtFmt(i/*:number*/, f/*:string*/, o) {
	if(!o) o = new_buf(6 + 4 * f.length);
	o.write_shift(2, i);
	write_XLWideString(f, o);
	var out = (o.length > o.l) ? o.slice(0, o.l) : o;
	if(o.l == null) o.l = o.length;
	return out;
}

/* [MS-XLSB] 2.4.659 BrtFont TODO */
function parse_BrtFont(data, length/*:number*/, opts) {
	var out = ({}/*:any*/);

	out.sz = data.read_shift(2) / 20;

	var grbit = parse_FontFlags(data, 2, opts);
	if(grbit.fItalic) out.italic = 1;
	if(grbit.fCondense) out.condense = 1;
	if(grbit.fExtend) out.extend = 1;
	if(grbit.fShadow) out.shadow = 1;
	if(grbit.fOutline) out.outline = 1;
	if(grbit.fStrikeout) out.strike = 1;

	var bls = data.read_shift(2);
	if(bls === 0x02BC) out.bold = 1;

	switch(data.read_shift(2)) {
		/* case 0: out.vertAlign = "baseline"; break; */
		case 1: out.vertAlign = "superscript"; break;
		case 2: out.vertAlign = "subscript"; break;
	}

	var underline = data.read_shift(1);
	if(underline != 0) out.underline = underline;

	var family = data.read_shift(1);
	if(family > 0) out.family = family;

	var bCharSet = data.read_shift(1);
	if(bCharSet > 0) out.charset = bCharSet;

	data.l++;
	out.color = parse_BrtColor(data, 8);

	switch(data.read_shift(1)) {
		/* case 0: out.scheme = "none": break; */
		case 1: out.scheme = "major"; break;
		case 2: out.scheme = "minor"; break;
	}

	out.name = parse_XLWideString(data, length - 21);

	return out;
}
function write_BrtFont(font/*:any*/, o) {
	if(!o) o = new_buf(25+4*32);
	o.write_shift(2, font.sz * 20);
	write_FontFlags(font, o);
	o.write_shift(2, font.bold ? 0x02BC : 0x0190);
	var sss = 0;
	if(font.vertAlign == "superscript") sss = 1;
	else if(font.vertAlign == "subscript") sss = 2;
	o.write_shift(2, sss);
	o.write_shift(1, font.underline || 0);
	o.write_shift(1, font.family || 0);
	o.write_shift(1, font.charset || 0);
	o.write_shift(1, 0);
	write_BrtColor(font.color, o);
	var scheme = 0;
	if(font.scheme == "major") scheme = 1;
	if(font.scheme == "minor") scheme = 2;
	o.write_shift(1, scheme);
	write_XLWideString(font.name, o);
	return o.length > o.l ? o.slice(0, o.l) : o;
}

/* [MS-XLSB] 2.4.650 BrtFill */
var XLSBFillPTNames = [
	"none",
	"solid",
	"mediumGray",
	"darkGray",
	"lightGray",
	"darkHorizontal",
	"darkVertical",
	"darkDown",
	"darkUp",
	"darkGrid",
	"darkTrellis",
	"lightHorizontal",
	"lightVertical",
	"lightDown",
	"lightUp",
	"lightGrid",
	"lightTrellis",
	"gray125",
	"gray0625"
];
var rev_XLSBFillPTNames/*:EvertNumType*/;
/* TODO: gradient fill representation */
var parse_BrtFill = parsenoop;
function write_BrtFill(fill, o) {
	if(!o) o = new_buf(4*3 + 8*7 + 16*1);
	if(!rev_XLSBFillPTNames) rev_XLSBFillPTNames = (evert(XLSBFillPTNames)/*:any*/);
	var fls/*:number*/ = rev_XLSBFillPTNames[fill.patternType];
	if(fls == null) fls = 0x28;
	o.write_shift(4, fls);
	var j = 0;
	if(fls != 0x28) {
		/* TODO: custom FG Color */
		write_BrtColor({auto:1}, o);
		/* TODO: custom BG Color */
		write_BrtColor({auto:1}, o);

		for(; j < 12; ++j) o.write_shift(4, 0);
	} else {
		for(; j < 4; ++j) o.write_shift(4, 0);

		for(; j < 12; ++j) o.write_shift(4, 0); /* TODO */
		/* iGradientType */
		/* xnumDegree */
		/* xnumFillToLeft */
		/* xnumFillToRight */
		/* xnumFillToTop */
		/* xnumFillToBottom */
		/* cNumStop */
		/* xfillGradientStop */
	}
	return o.length > o.l ? o.slice(0, o.l) : o;
}

/* [MS-XLSB] 2.4.824 BrtXF */
function parse_BrtXF(data, length/*:number*/) {
	var tgt = data.l + length;
	var ixfeParent = data.read_shift(2);
	var ifmt = data.read_shift(2);
	data.l = tgt;
	return {ixfe:ixfeParent, numFmtId:ifmt };
}
function write_BrtXF(data, ixfeP, o) {
	if(!o) o = new_buf(16);
	o.write_shift(2, ixfeP||0);
	o.write_shift(2, data.numFmtId||0);
	o.write_shift(2, 0); /* iFont */
	o.write_shift(2, 0); /* iFill */
	o.write_shift(2, 0); /* ixBorder */
	o.write_shift(1, 0); /* trot */
	o.write_shift(1, 0); /* indent */
	var flow = 0;
	o.write_shift(1, flow); /* flags */
	o.write_shift(1, 0); /* flags */
	o.write_shift(1, 0); /* xfGrbitAtr */
	o.write_shift(1, 0);
	return o;
}

/* [MS-XLSB] 2.5.4 Blxf TODO */
function write_Blxf(data, o) {
	if(!o) o = new_buf(10);
	o.write_shift(1, 0); /* dg */
	o.write_shift(1, 0);
	o.write_shift(4, 0); /* color */
	o.write_shift(4, 0); /* color */
	return o;
}
/* [MS-XLSB] 2.4.302 BrtBorder TODO */
var parse_BrtBorder = parsenoop;
function write_BrtBorder(border, o) {
	if(!o) o = new_buf(51);
	o.write_shift(1, 0); /* diagonal */
	write_Blxf(null, o); /* top */
	write_Blxf(null, o); /* bottom */
	write_Blxf(null, o); /* left */
	write_Blxf(null, o); /* right */
	write_Blxf(null, o); /* diag */
	return o.length > o.l ? o.slice(0, o.l) : o;
}

/* [MS-XLSB] 2.4.763 BrtStyle TODO */
function write_BrtStyle(style, o) {
	if(!o) o = new_buf(12+4*10);
	o.write_shift(4, style.xfId);
	o.write_shift(2, 1);
	o.write_shift(1, +style.builtinId);
	o.write_shift(1, 0); /* iLevel */
	write_XLNullableWideString(style.name || "", o);
	return o.length > o.l ? o.slice(0, o.l) : o;
}

/* [MS-XLSB] 2.4.272 BrtBeginTableStyles */
function write_BrtBeginTableStyles(cnt, defTableStyle, defPivotStyle) {
	var o = new_buf(4+256*2*4);
	o.write_shift(4, cnt);
	write_XLNullableWideString(defTableStyle, o);
	write_XLNullableWideString(defPivotStyle, o);
	return o.length > o.l ? o.slice(0, o.l) : o;
}

/* [MS-XLSB] 2.1.7.50 Styles */
function parse_sty_bin(data, themes, opts) {
	var styles = {};
	styles.NumberFmt = ([]/*:any*/);
	for(var y in table_fmt) styles.NumberFmt[y] = table_fmt[y];

	styles.CellXf = [];
	styles.Fonts = [];
	var state/*:Array<string>*/ = [];
	var pass = false;
	recordhopper(data, function hopper_sty(val, R, RT) {
		switch(RT) {
			case 0x002C: /* BrtFmt */
				styles.NumberFmt[val[0]] = val[1]; SSF_load(val[1], val[0]);
				break;
			case 0x002B: /* BrtFont */
				styles.Fonts.push(val);
				if(val.color.theme != null && themes && themes.themeElements && themes.themeElements.clrScheme) {
					val.color.rgb = rgb_tint(themes.themeElements.clrScheme[val.color.theme].rgb, val.color.tint || 0);
				}
				break;
			case 0x0401: /* BrtKnownFonts */ break;
			case 0x002D: /* BrtFill */
				break;
			case 0x002E: /* BrtBorder */
				break;
			case 0x002F: /* BrtXF */
				if(state[state.length - 1] == 0x0269 /* BrtBeginCellXFs */) {
					styles.CellXf.push(val);
				}
				break;
			case 0x0030: /* BrtStyle */
			case 0x01FB: /* BrtDXF */
			case 0x023C: /* BrtMRUColor */
			case 0x01DB: /* BrtIndexedColor */
				break;

			case 0x0493: /* BrtDXF14 */
			case 0x0836: /* BrtDXF15 */
			case 0x046A: /* BrtSlicerStyleElement */
			case 0x0200: /* BrtTableStyleElement */
			case 0x082F: /* BrtTimelineStyleElement */
			case 0x0C00: /* BrtUid */
				break;

			case 0x0023: /* BrtFRTBegin */
				pass = true; break;
			case 0x0024: /* BrtFRTEnd */
				pass = false; break;
			case 0x0025: /* BrtACBegin */
				state.push(RT); pass = true; break;
			case 0x0026: /* BrtACEnd */
				state.pop(); pass = false; break;

			default:
				if(R.T > 0) state.push(RT);
				else if(R.T < 0) state.pop();
				else if(!pass || (opts.WTF && state[state.length-1] != 0x0025 /* BrtACBegin */)) throw new Error("Unexpected record 0x" + RT.toString(16));
		}
	});
	return styles;
}

function write_FMTS_bin(ba, NF/*:?SSFTable*/) {
	if(!NF) return;
	var cnt = 0;
	[[5,8],[23,26],[41,44],[/*63*/50,/*66],[164,*/392]].forEach(function(r) {
		/*:: if(!NF) return; */
		for(var i = r[0]; i <= r[1]; ++i) if(NF[i] != null) ++cnt;
	});

	if(cnt == 0) return;
	write_record(ba, 0x0267 /* BrtBeginFmts */, write_UInt32LE(cnt));
	[[5,8],[23,26],[41,44],[/*63*/50,/*66],[164,*/392]].forEach(function(r) {
		/*:: if(!NF) return; */
		for(var i = r[0]; i <= r[1]; ++i) if(NF[i] != null) write_record(ba, 0x002C /* BrtFmt */, write_BrtFmt(i, NF[i]));
	});
	write_record(ba, 0x0268 /* BrtEndFmts */);
}

function write_FONTS_bin(ba/*::, data*/) {
	var cnt = 1;

	if(cnt == 0) return;
	write_record(ba, 0x0263 /* BrtBeginFonts */, write_UInt32LE(cnt));
	write_record(ba, 0x002B /* BrtFont */, write_BrtFont({
		sz:12,
		color: {theme:1},
		name: "Calibri",
		family: 2,
		scheme: "minor"
	}));
	/* 1*65491BrtFont [ACFONTS] */
	write_record(ba, 0x0264 /* BrtEndFonts */);
}

function write_FILLS_bin(ba/*::, data*/) {
	var cnt = 2;

	if(cnt == 0) return;
	write_record(ba, 0x025B /* BrtBeginFills */, write_UInt32LE(cnt));
	write_record(ba, 0x002D /* BrtFill */, write_BrtFill({patternType:"none"}));
	write_record(ba, 0x002D /* BrtFill */, write_BrtFill({patternType:"gray125"}));
	/* 1*65431BrtFill */
	write_record(ba, 0x025C /* BrtEndFills */);
}

function write_BORDERS_bin(ba/*::, data*/) {
	var cnt = 1;

	if(cnt == 0) return;
	write_record(ba, 0x0265 /* BrtBeginBorders */, write_UInt32LE(cnt));
	write_record(ba, 0x002E /* BrtBorder */, write_BrtBorder({}));
	/* 1*65430BrtBorder */
	write_record(ba, 0x0266 /* BrtEndBorders */);
}

function write_CELLSTYLEXFS_bin(ba/*::, data*/) {
	var cnt = 1;
	write_record(ba, 0x0272 /* BrtBeginCellStyleXFs */, write_UInt32LE(cnt));
	write_record(ba, 0x002F /* BrtXF */, write_BrtXF({
		numFmtId: 0,
		fontId:   0,
		fillId:   0,
		borderId: 0
	}, 0xFFFF));
	/* 1*65430(BrtXF *FRT) */
	write_record(ba, 0x0273 /* BrtEndCellStyleXFs */);
}

function write_CELLXFS_bin(ba, data) {
	write_record(ba, 0x0269 /* BrtBeginCellXFs */, write_UInt32LE(data.length));
	data.forEach(function(c) { write_record(ba, 0x002F /* BrtXF */, write_BrtXF(c,0)); });
	/* 1*65430(BrtXF *FRT) */
	write_record(ba, 0x026A /* BrtEndCellXFs */);
}

function write_STYLES_bin(ba/*::, data*/) {
	var cnt = 1;

	write_record(ba, 0x026B /* BrtBeginStyles */, write_UInt32LE(cnt));
	write_record(ba, 0x0030 /* BrtStyle */, write_BrtStyle({
		xfId:0,
		builtinId:0,
		name:"Normal"
	}));
	/* 1*65430(BrtStyle *FRT) */
	write_record(ba, 0x026C /* BrtEndStyles */);
}

function write_DXFS_bin(ba/*::, data*/) {
	var cnt = 0;

	write_record(ba, 0x01F9 /* BrtBeginDXFs */, write_UInt32LE(cnt));
	/* *2147483647(BrtDXF *FRT) */
	write_record(ba, 0x01FA /* BrtEndDXFs */);
}

function write_TABLESTYLES_bin(ba/*::, data*/) {
	var cnt = 0;

	write_record(ba, 0x01FC /* BrtBeginTableStyles */, write_BrtBeginTableStyles(cnt, "TableStyleMedium9", "PivotStyleMedium4"));
	/* *TABLESTYLE */
	write_record(ba, 0x01FD /* BrtEndTableStyles */);
}

function write_COLORPALETTE_bin(/*::ba, data*/) {
	return;
	/* BrtBeginColorPalette [INDEXEDCOLORS] [MRUCOLORS] BrtEndColorPalette */
}

/* [MS-XLSB] 2.1.7.50 Styles */
function write_sty_bin(wb, opts) {
	var ba = buf_array();
	write_record(ba, 0x0116 /* BrtBeginStyleSheet */);
	write_FMTS_bin(ba, wb.SSF);
	write_FONTS_bin(ba, wb);
	write_FILLS_bin(ba, wb);
	write_BORDERS_bin(ba, wb);
	write_CELLSTYLEXFS_bin(ba, wb);
	write_CELLXFS_bin(ba, opts.cellXfs);
	write_STYLES_bin(ba, wb);
	write_DXFS_bin(ba, wb);
	write_TABLESTYLES_bin(ba, wb);
	write_COLORPALETTE_bin(ba, wb);
	/* FRTSTYLESHEET*/
	write_record(ba, 0x0117 /* BrtEndStyleSheet */);
	return ba.end();
}
/* Even though theme layout is dk1 lt1 dk2 lt2, true order is lt1 dk1 lt2 dk2 */
var XLSXThemeClrScheme = [
	'</a:lt1>', '</a:dk1>', '</a:lt2>', '</a:dk2>',
	'</a:accent1>', '</a:accent2>', '</a:accent3>',
	'</a:accent4>', '</a:accent5>', '</a:accent6>',
	'</a:hlink>', '</a:folHlink>'
];
/* 20.1.6.2 clrScheme CT_ColorScheme */
function parse_clrScheme(t, themes, opts) {
	themes.themeElements.clrScheme = [];
	var color = {};
	(t[0].match(tagregex)||[]).forEach(function(x) {
		var y = parsexmltag(x);
		switch(y[0]) {
			/* 20.1.6.2 clrScheme (Color Scheme) CT_ColorScheme */
			case '<a:clrScheme': case '</a:clrScheme>': break;

			/* 20.1.2.3.32 srgbClr CT_SRgbColor */
			case '<a:srgbClr':
				color.rgb = y.val; break;

			/* 20.1.2.3.33 sysClr CT_SystemColor */
			case '<a:sysClr':
				color.rgb = y.lastClr; break;

			/* 20.1.4.1.1 accent1 (Accent 1) */
			/* 20.1.4.1.2 accent2 (Accent 2) */
			/* 20.1.4.1.3 accent3 (Accent 3) */
			/* 20.1.4.1.4 accent4 (Accent 4) */
			/* 20.1.4.1.5 accent5 (Accent 5) */
			/* 20.1.4.1.6 accent6 (Accent 6) */
			/* 20.1.4.1.9 dk1 (Dark 1) */
			/* 20.1.4.1.10 dk2 (Dark 2) */
			/* 20.1.4.1.15 folHlink (Followed Hyperlink) */
			/* 20.1.4.1.19 hlink (Hyperlink) */
			/* 20.1.4.1.22 lt1 (Light 1) */
			/* 20.1.4.1.23 lt2 (Light 2) */
			case '<a:dk1>': case '</a:dk1>':
			case '<a:lt1>': case '</a:lt1>':
			case '<a:dk2>': case '</a:dk2>':
			case '<a:lt2>': case '</a:lt2>':
			case '<a:accent1>': case '</a:accent1>':
			case '<a:accent2>': case '</a:accent2>':
			case '<a:accent3>': case '</a:accent3>':
			case '<a:accent4>': case '</a:accent4>':
			case '<a:accent5>': case '</a:accent5>':
			case '<a:accent6>': case '</a:accent6>':
			case '<a:hlink>': case '</a:hlink>':
			case '<a:folHlink>': case '</a:folHlink>':
				if (y[0].charAt(1) === '/') {
					themes.themeElements.clrScheme[XLSXThemeClrScheme.indexOf(y[0])] = color;
					color = {};
				} else {
					color.name = y[0].slice(3, y[0].length - 1);
				}
				break;

			default: if(opts && opts.WTF) throw new Error('Unrecognized ' + y[0] + ' in clrScheme');
		}
	});
}

/* 20.1.4.1.18 fontScheme CT_FontScheme */
function parse_fontScheme(/*::t, themes, opts*/) { }

/* 20.1.4.1.15 fmtScheme CT_StyleMatrix */
function parse_fmtScheme(/*::t, themes, opts*/) { }

var clrsregex = /<a:clrScheme([^>]*)>[\s\S]*<\/a:clrScheme>/;
var fntsregex = /<a:fontScheme([^>]*)>[\s\S]*<\/a:fontScheme>/;
var fmtsregex = /<a:fmtScheme([^>]*)>[\s\S]*<\/a:fmtScheme>/;

/* 20.1.6.10 themeElements CT_BaseStyles */
function parse_themeElements(data, themes, opts) {
	themes.themeElements = {};

	var t;

	[
		/* clrScheme CT_ColorScheme */
		['clrScheme', clrsregex, parse_clrScheme],
		/* fontScheme CT_FontScheme */
		['fontScheme', fntsregex, parse_fontScheme],
		/* fmtScheme CT_StyleMatrix */
		['fmtScheme', fmtsregex, parse_fmtScheme]
	].forEach(function(m) {
		if(!(t=data.match(m[1]))) throw new Error(m[0] + ' not found in themeElements');
		m[2](t, themes, opts);
	});
}

var themeltregex = /<a:themeElements([^>]*)>[\s\S]*<\/a:themeElements>/;

/* 14.2.7 Theme Part */
function parse_theme_xml(data/*:string*/, opts) {
	/* 20.1.6.9 theme CT_OfficeStyleSheet */
	if(!data || data.length === 0) data = write_theme();

	var t;
	var themes = {};

	/* themeElements CT_BaseStyles */
	if(!(t=data.match(themeltregex))) throw new Error('themeElements not found in theme');
	parse_themeElements(t[0], themes, opts);
	themes.raw = data;
	return themes;
}

function write_theme(Themes, opts)/*:string*/ {
	if(opts && opts.themeXLSX) return opts.themeXLSX;
	if(Themes && typeof Themes.raw == "string") return Themes.raw;
	var o = [XML_HEADER];
	o[o.length] = '<a:theme xmlns:a="http://schemas.openxmlformats.org/drawingml/2006/main" name="Office Theme">';
	o[o.length] =  '<a:themeElements>';

	o[o.length] =   '<a:clrScheme name="Office">';
	o[o.length] =    '<a:dk1><a:sysClr val="windowText" lastClr="000000"/></a:dk1>';
	o[o.length] =    '<a:lt1><a:sysClr val="window" lastClr="FFFFFF"/></a:lt1>';
	o[o.length] =    '<a:dk2><a:srgbClr val="1F497D"/></a:dk2>';
	o[o.length] =    '<a:lt2><a:srgbClr val="EEECE1"/></a:lt2>';
	o[o.length] =    '<a:accent1><a:srgbClr val="4F81BD"/></a:accent1>';
	o[o.length] =    '<a:accent2><a:srgbClr val="C0504D"/></a:accent2>';
	o[o.length] =    '<a:accent3><a:srgbClr val="9BBB59"/></a:accent3>';
	o[o.length] =    '<a:accent4><a:srgbClr val="8064A2"/></a:accent4>';
	o[o.length] =    '<a:accent5><a:srgbClr val="4BACC6"/></a:accent5>';
	o[o.length] =    '<a:accent6><a:srgbClr val="F79646"/></a:accent6>';
	o[o.length] =    '<a:hlink><a:srgbClr val="0000FF"/></a:hlink>';
	o[o.length] =    '<a:folHlink><a:srgbClr val="800080"/></a:folHlink>';
	o[o.length] =   '</a:clrScheme>';

	o[o.length] =   '<a:fontScheme name="Office">';
	o[o.length] =    '<a:majorFont>';
	o[o.length] =     '<a:latin typeface="Cambria"/>';
	o[o.length] =     '<a:ea typeface=""/>';
	o[o.length] =     '<a:cs typeface=""/>';
	o[o.length] =     '<a:font script="Jpan" typeface="ＭＳ Ｐゴシック"/>';
	o[o.length] =     '<a:font script="Hang" typeface="맑은 고딕"/>';
	o[o.length] =     '<a:font script="Hans" typeface="宋体"/>';
	o[o.length] =     '<a:font script="Hant" typeface="新細明體"/>';
	o[o.length] =     '<a:font script="Arab" typeface="Times New Roman"/>';
	o[o.length] =     '<a:font script="Hebr" typeface="Times New Roman"/>';
	o[o.length] =     '<a:font script="Thai" typeface="Tahoma"/>';
	o[o.length] =     '<a:font script="Ethi" typeface="Nyala"/>';
	o[o.length] =     '<a:font script="Beng" typeface="Vrinda"/>';
	o[o.length] =     '<a:font script="Gujr" typeface="Shruti"/>';
	o[o.length] =     '<a:font script="Khmr" typeface="MoolBoran"/>';
	o[o.length] =     '<a:font script="Knda" typeface="Tunga"/>';
	o[o.length] =     '<a:font script="Guru" typeface="Raavi"/>';
	o[o.length] =     '<a:font script="Cans" typeface="Euphemia"/>';
	o[o.length] =     '<a:font script="Cher" typeface="Plantagenet Cherokee"/>';
	o[o.length] =     '<a:font script="Yiii" typeface="Microsoft Yi Baiti"/>';
	o[o.length] =     '<a:font script="Tibt" typeface="Microsoft Himalaya"/>';
	o[o.length] =     '<a:font script="Thaa" typeface="MV Boli"/>';
	o[o.length] =     '<a:font script="Deva" typeface="Mangal"/>';
	o[o.length] =     '<a:font script="Telu" typeface="Gautami"/>';
	o[o.length] =     '<a:font script="Taml" typeface="Latha"/>';
	o[o.length] =     '<a:font script="Syrc" typeface="Estrangelo Edessa"/>';
	o[o.length] =     '<a:font script="Orya" typeface="Kalinga"/>';
	o[o.length] =     '<a:font script="Mlym" typeface="Kartika"/>';
	o[o.length] =     '<a:font script="Laoo" typeface="DokChampa"/>';
	o[o.length] =     '<a:font script="Sinh" typeface="Iskoola Pota"/>';
	o[o.length] =     '<a:font script="Mong" typeface="Mongolian Baiti"/>';
	o[o.length] =     '<a:font script="Viet" typeface="Times New Roman"/>';
	o[o.length] =     '<a:font script="Uigh" typeface="Microsoft Uighur"/>';
	o[o.length] =     '<a:font script="Geor" typeface="Sylfaen"/>';
	o[o.length] =    '</a:majorFont>';
	o[o.length] =    '<a:minorFont>';
	o[o.length] =     '<a:latin typeface="Calibri"/>';
	o[o.length] =     '<a:ea typeface=""/>';
	o[o.length] =     '<a:cs typeface=""/>';
	o[o.length] =     '<a:font script="Jpan" typeface="ＭＳ Ｐゴシック"/>';
	o[o.length] =     '<a:font script="Hang" typeface="맑은 고딕"/>';
	o[o.length] =     '<a:font script="Hans" typeface="宋体"/>';
	o[o.length] =     '<a:font script="Hant" typeface="新細明體"/>';
	o[o.length] =     '<a:font script="Arab" typeface="Arial"/>';
	o[o.length] =     '<a:font script="Hebr" typeface="Arial"/>';
	o[o.length] =     '<a:font script="Thai" typeface="Tahoma"/>';
	o[o.length] =     '<a:font script="Ethi" typeface="Nyala"/>';
	o[o.length] =     '<a:font script="Beng" typeface="Vrinda"/>';
	o[o.length] =     '<a:font script="Gujr" typeface="Shruti"/>';
	o[o.length] =     '<a:font script="Khmr" typeface="DaunPenh"/>';
	o[o.length] =     '<a:font script="Knda" typeface="Tunga"/>';
	o[o.length] =     '<a:font script="Guru" typeface="Raavi"/>';
	o[o.length] =     '<a:font script="Cans" typeface="Euphemia"/>';
	o[o.length] =     '<a:font script="Cher" typeface="Plantagenet Cherokee"/>';
	o[o.length] =     '<a:font script="Yiii" typeface="Microsoft Yi Baiti"/>';
	o[o.length] =     '<a:font script="Tibt" typeface="Microsoft Himalaya"/>';
	o[o.length] =     '<a:font script="Thaa" typeface="MV Boli"/>';
	o[o.length] =     '<a:font script="Deva" typeface="Mangal"/>';
	o[o.length] =     '<a:font script="Telu" typeface="Gautami"/>';
	o[o.length] =     '<a:font script="Taml" typeface="Latha"/>';
	o[o.length] =     '<a:font script="Syrc" typeface="Estrangelo Edessa"/>';
	o[o.length] =     '<a:font script="Orya" typeface="Kalinga"/>';
	o[o.length] =     '<a:font script="Mlym" typeface="Kartika"/>';
	o[o.length] =     '<a:font script="Laoo" typeface="DokChampa"/>';
	o[o.length] =     '<a:font script="Sinh" typeface="Iskoola Pota"/>';
	o[o.length] =     '<a:font script="Mong" typeface="Mongolian Baiti"/>';
	o[o.length] =     '<a:font script="Viet" typeface="Arial"/>';
	o[o.length] =     '<a:font script="Uigh" typeface="Microsoft Uighur"/>';
	o[o.length] =     '<a:font script="Geor" typeface="Sylfaen"/>';
	o[o.length] =    '</a:minorFont>';
	o[o.length] =   '</a:fontScheme>';

	o[o.length] =   '<a:fmtScheme name="Office">';
	o[o.length] =    '<a:fillStyleLst>';
	o[o.length] =     '<a:solidFill><a:schemeClr val="phClr"/></a:solidFill>';
	o[o.length] =     '<a:gradFill rotWithShape="1">';
	o[o.length] =      '<a:gsLst>';
	o[o.length] =       '<a:gs pos="0"><a:schemeClr val="phClr"><a:tint val="50000"/><a:satMod val="300000"/></a:schemeClr></a:gs>';
	o[o.length] =       '<a:gs pos="35000"><a:schemeClr val="phClr"><a:tint val="37000"/><a:satMod val="300000"/></a:schemeClr></a:gs>';
	o[o.length] =       '<a:gs pos="100000"><a:schemeClr val="phClr"><a:tint val="15000"/><a:satMod val="350000"/></a:schemeClr></a:gs>';
	o[o.length] =      '</a:gsLst>';
	o[o.length] =      '<a:lin ang="16200000" scaled="1"/>';
	o[o.length] =     '</a:gradFill>';
	o[o.length] =     '<a:gradFill rotWithShape="1">';
	o[o.length] =      '<a:gsLst>';
	o[o.length] =       '<a:gs pos="0"><a:schemeClr val="phClr"><a:tint val="100000"/><a:shade val="100000"/><a:satMod val="130000"/></a:schemeClr></a:gs>';
	o[o.length] =       '<a:gs pos="100000"><a:schemeClr val="phClr"><a:tint val="50000"/><a:shade val="100000"/><a:satMod val="350000"/></a:schemeClr></a:gs>';
	o[o.length] =      '</a:gsLst>';
	o[o.length] =      '<a:lin ang="16200000" scaled="0"/>';
	o[o.length] =     '</a:gradFill>';
	o[o.length] =    '</a:fillStyleLst>';
	o[o.length] =    '<a:lnStyleLst>';
	o[o.length] =     '<a:ln w="9525" cap="flat" cmpd="sng" algn="ctr"><a:solidFill><a:schemeClr val="phClr"><a:shade val="95000"/><a:satMod val="105000"/></a:schemeClr></a:solidFill><a:prstDash val="solid"/></a:ln>';
	o[o.length] =     '<a:ln w="25400" cap="flat" cmpd="sng" algn="ctr"><a:solidFill><a:schemeClr val="phClr"/></a:solidFill><a:prstDash val="solid"/></a:ln>';
	o[o.length] =     '<a:ln w="38100" cap="flat" cmpd="sng" algn="ctr"><a:solidFill><a:schemeClr val="phClr"/></a:solidFill><a:prstDash val="solid"/></a:ln>';
	o[o.length] =    '</a:lnStyleLst>';
	o[o.length] =    '<a:effectStyleLst>';
	o[o.length] =     '<a:effectStyle>';
	o[o.length] =      '<a:effectLst>';
	o[o.length] =       '<a:outerShdw blurRad="40000" dist="20000" dir="5400000" rotWithShape="0"><a:srgbClr val="000000"><a:alpha val="38000"/></a:srgbClr></a:outerShdw>';
	o[o.length] =      '</a:effectLst>';
	o[o.length] =     '</a:effectStyle>';
	o[o.length] =     '<a:effectStyle>';
	o[o.length] =      '<a:effectLst>';
	o[o.length] =       '<a:outerShdw blurRad="40000" dist="23000" dir="5400000" rotWithShape="0"><a:srgbClr val="000000"><a:alpha val="35000"/></a:srgbClr></a:outerShdw>';
	o[o.length] =      '</a:effectLst>';
	o[o.length] =     '</a:effectStyle>';
	o[o.length] =     '<a:effectStyle>';
	o[o.length] =      '<a:effectLst>';
	o[o.length] =       '<a:outerShdw blurRad="40000" dist="23000" dir="5400000" rotWithShape="0"><a:srgbClr val="000000"><a:alpha val="35000"/></a:srgbClr></a:outerShdw>';
	o[o.length] =      '</a:effectLst>';
	o[o.length] =      '<a:scene3d><a:camera prst="orthographicFront"><a:rot lat="0" lon="0" rev="0"/></a:camera><a:lightRig rig="threePt" dir="t"><a:rot lat="0" lon="0" rev="1200000"/></a:lightRig></a:scene3d>';
	o[o.length] =      '<a:sp3d><a:bevelT w="63500" h="25400"/></a:sp3d>';
	o[o.length] =     '</a:effectStyle>';
	o[o.length] =    '</a:effectStyleLst>';
	o[o.length] =    '<a:bgFillStyleLst>';
	o[o.length] =     '<a:solidFill><a:schemeClr val="phClr"/></a:solidFill>';
	o[o.length] =     '<a:gradFill rotWithShape="1">';
	o[o.length] =      '<a:gsLst>';
	o[o.length] =       '<a:gs pos="0"><a:schemeClr val="phClr"><a:tint val="40000"/><a:satMod val="350000"/></a:schemeClr></a:gs>';
	o[o.length] =       '<a:gs pos="40000"><a:schemeClr val="phClr"><a:tint val="45000"/><a:shade val="99000"/><a:satMod val="350000"/></a:schemeClr></a:gs>';
	o[o.length] =       '<a:gs pos="100000"><a:schemeClr val="phClr"><a:shade val="20000"/><a:satMod val="255000"/></a:schemeClr></a:gs>';
	o[o.length] =      '</a:gsLst>';
	o[o.length] =      '<a:path path="circle"><a:fillToRect l="50000" t="-80000" r="50000" b="180000"/></a:path>';
	o[o.length] =     '</a:gradFill>';
	o[o.length] =     '<a:gradFill rotWithShape="1">';
	o[o.length] =      '<a:gsLst>';
	o[o.length] =       '<a:gs pos="0"><a:schemeClr val="phClr"><a:tint val="80000"/><a:satMod val="300000"/></a:schemeClr></a:gs>';
	o[o.length] =       '<a:gs pos="100000"><a:schemeClr val="phClr"><a:shade val="30000"/><a:satMod val="200000"/></a:schemeClr></a:gs>';
	o[o.length] =      '</a:gsLst>';
	o[o.length] =      '<a:path path="circle"><a:fillToRect l="50000" t="50000" r="50000" b="50000"/></a:path>';
	o[o.length] =     '</a:gradFill>';
	o[o.length] =    '</a:bgFillStyleLst>';
	o[o.length] =   '</a:fmtScheme>';
	o[o.length] =  '</a:themeElements>';

	o[o.length] =  '<a:objectDefaults>';
	o[o.length] =   '<a:spDef>';
	o[o.length] =    '<a:spPr/><a:bodyPr/><a:lstStyle/><a:style><a:lnRef idx="1"><a:schemeClr val="accent1"/></a:lnRef><a:fillRef idx="3"><a:schemeClr val="accent1"/></a:fillRef><a:effectRef idx="2"><a:schemeClr val="accent1"/></a:effectRef><a:fontRef idx="minor"><a:schemeClr val="lt1"/></a:fontRef></a:style>';
	o[o.length] =   '</a:spDef>';
	o[o.length] =   '<a:lnDef>';
	o[o.length] =    '<a:spPr/><a:bodyPr/><a:lstStyle/><a:style><a:lnRef idx="2"><a:schemeClr val="accent1"/></a:lnRef><a:fillRef idx="0"><a:schemeClr val="accent1"/></a:fillRef><a:effectRef idx="1"><a:schemeClr val="accent1"/></a:effectRef><a:fontRef idx="minor"><a:schemeClr val="tx1"/></a:fontRef></a:style>';
	o[o.length] =   '</a:lnDef>';
	o[o.length] =  '</a:objectDefaults>';
	o[o.length] =  '<a:extraClrSchemeLst/>';
	o[o.length] = '</a:theme>';
	return o.join("");
}
/* [MS-XLS] 2.4.326 TODO: payload is a zip file */
function parse_Theme(blob, length, opts) {
	var end = blob.l + length;
	var dwThemeVersion = blob.read_shift(4);
	if(dwThemeVersion === 124226) return;
	if(!opts.cellStyles) { blob.l = end; return; }
	var data = blob.slice(blob.l);
	blob.l = end;
	var zip; try { zip = zip_read(data, {type: "array"}); } catch(e) { return; }
	var themeXML = getzipstr(zip, "theme/theme/theme1.xml", true);
	if(!themeXML) return;
	return parse_theme_xml(themeXML, opts);
}

/* 2.5.49 */
function parse_ColorTheme(blob/*::, length*/) { return blob.read_shift(4); }

/* 2.5.155 */
function parse_FullColorExt(blob/*::, length*/) {
	var o = {};
	o.xclrType = blob.read_shift(2);
	o.nTintShade = blob.read_shift(2);
	switch(o.xclrType) {
		case 0: blob.l += 4; break;
		case 1: o.xclrValue = parse_IcvXF(blob, 4); break;
		case 2: o.xclrValue = parse_LongRGBA(blob, 4); break;
		case 3: o.xclrValue = parse_ColorTheme(blob, 4); break;
		case 4: blob.l += 4; break;
	}
	blob.l += 8;
	return o;
}

/* 2.5.164 TODO: read 7 bits*/
function parse_IcvXF(blob, length) {
	return parsenoop(blob, length);
}

/* 2.5.280 */
function parse_XFExtGradient(blob, length) {
	return parsenoop(blob, length);
}

/* [MS-XLS] 2.5.108 */
function parse_ExtProp(blob/*::, length*/)/*:Array<any>*/ {
	var extType = blob.read_shift(2);
	var cb = blob.read_shift(2) - 4;
	var o = [extType];
	switch(extType) {
		case 0x04: case 0x05: case 0x07: case 0x08:
		case 0x09: case 0x0A: case 0x0B: case 0x0D:
			o[1] = parse_FullColorExt(blob, cb); break;
		case 0x06: o[1] = parse_XFExtGradient(blob, cb); break;
		case 0x0E: case 0x0F: o[1] = blob.read_shift(cb === 1 ? 1 : 2); break;
		default: throw new Error("Unrecognized ExtProp type: " + extType + " " + cb);
	}
	return o;
}

/* 2.4.355 */
function parse_XFExt(blob, length) {
	var end = blob.l + length;
	blob.l += 2;
	var ixfe = blob.read_shift(2);
	blob.l += 2;
	var cexts = blob.read_shift(2);
	var ext/*:AOA*/ = [];
	while(cexts-- > 0) ext.push(parse_ExtProp(blob, end-blob.l));
	return {ixfe:ixfe, ext:ext};
}

/* xf is an XF, see parse_XFExt for xfext */
function update_xfext(xf, xfext) {
	xfext.forEach(function(xfe) {
		switch(xfe[0]) { /* 2.5.108 extPropData */
			case 0x04: break; /* foreground color */
			case 0x05: break; /* background color */
			case 0x06: break; /* gradient fill */
			case 0x07: break; /* top cell border color */
			case 0x08: break; /* bottom cell border color */
			case 0x09: break; /* left cell border color */
			case 0x0a: break; /* right cell border color */
			case 0x0b: break; /* diagonal cell border color */
			case 0x0d: /* text color */
				break;
			case 0x0e: break; /* font scheme */
			case 0x0f: break; /* indentation level */
		}
	});
}

function parse_BrtMdtinfo(data, length) {
  return {
    flags: data.read_shift(4),
    version: data.read_shift(4),
    name: parse_XLWideString(data, length - 8)
  };
}
function write_BrtMdtinfo(data) {
  var o = new_buf(12 + 2 * data.name.length);
  o.write_shift(4, data.flags);
  o.write_shift(4, data.version);
  write_XLWideString(data.name, o);
  return o.slice(0, o.l);
}
function parse_BrtMdb(data) {
  var out = [];
  var cnt = data.read_shift(4);
  while (cnt-- > 0)
    out.push([data.read_shift(4), data.read_shift(4)]);
  return out;
}
function write_BrtMdb(mdb) {
  var o = new_buf(4 + 8 * mdb.length);
  o.write_shift(4, mdb.length);
  for (var i = 0; i < mdb.length; ++i) {
    o.write_shift(4, mdb[i][0]);
    o.write_shift(4, mdb[i][1]);
  }
  return o;
}
function write_BrtBeginEsfmd(cnt, name) {
  var o = new_buf(8 + 2 * name.length);
  o.write_shift(4, cnt);
  write_XLWideString(name, o);
  return o.slice(0, o.l);
}
function parse_BrtBeginEsmdb(data) {
  data.l += 4;
  return data.read_shift(4) != 0;
}
function write_BrtBeginEsmdb(cnt, cm) {
  var o = new_buf(8);
  o.write_shift(4, cnt);
  o.write_shift(4, cm ? 1 : 0);
  return o;
}
function parse_xlmeta_bin(data, name, _opts) {
  var out = { Types: [], Cell: [], Value: [] };
  var opts = _opts || {};
  var state = [];
  var pass = false;
  var metatype = 2;
  recordhopper(data, function(val, R, RT) {
    switch (RT) {
      case 335:
        out.Types.push({ name: val.name });
        break;
      case 51:
        val.forEach(function(r) {
          if (metatype == 1)
            out.Cell.push({ type: out.Types[r[0] - 1].name, index: r[1] });
          else if (metatype == 0)
            out.Value.push({ type: out.Types[r[0] - 1].name, index: r[1] });
        });
        break;
      case 337:
        metatype = val ? 1 : 0;
        break;
      case 338:
        metatype = 2;
        break;
      case 35:
        state.push(RT);
        pass = true;
        break;
      case 36:
        state.pop();
        pass = false;
        break;
      default:
        if (R.T) {
        } else if (!pass || opts.WTF && state[state.length - 1] != 35)
          throw new Error("Unexpected record 0x" + RT.toString(16));
    }
  });
  return out;
}
function write_xlmeta_bin() {
  var ba = buf_array();
  write_record(ba, 332);
  write_record(ba, 334, write_UInt32LE(1));
  write_record(ba, 335, write_BrtMdtinfo({
    name: "XLDAPR",
    version: 12e4,
    flags: 3496657072
  }));
  write_record(ba, 336);
  write_record(ba, 339, write_BrtBeginEsfmd(1, "XLDAPR"));
  write_record(ba, 52);
  write_record(ba, 35, write_UInt32LE(514));
  write_record(ba, 4096, write_UInt32LE(0));
  write_record(ba, 4097, writeuint16(1));
  write_record(ba, 36);
  write_record(ba, 53);
  write_record(ba, 340);
  write_record(ba, 337, write_BrtBeginEsmdb(1, true));
  write_record(ba, 51, write_BrtMdb([[1, 0]]));
  write_record(ba, 338);
  write_record(ba, 333);
  return ba.end();
}
function parse_xlmeta_xml(data, name, opts) {
  var out = { Types: [], Cell: [], Value: [] };
  if (!data)
    return out;
  var pass = false;
  var metatype = 2;
  var lastmeta;
  data.replace(tagregex, function(x) {
    var y = parsexmltag(x);
    switch (strip_ns(y[0])) {
      case "<?xml":
        break;
      case "<metadata":
      case "</metadata>":
        break;
      case "<metadataTypes":
      case "</metadataTypes>":
        break;
      case "<metadataType":
        out.Types.push({ name: y.name });
        break;
      case "</metadataType>":
        break;
      case "<futureMetadata":
        for (var j = 0; j < out.Types.length; ++j)
          if (out.Types[j].name == y.name)
            lastmeta = out.Types[j];
        break;
      case "</futureMetadata>":
        break;
      case "<bk>":
        break;
      case "</bk>":
        break;
      case "<rc":
        if (metatype == 1)
          out.Cell.push({ type: out.Types[y.t - 1].name, index: +y.v });
        else if (metatype == 0)
          out.Value.push({ type: out.Types[y.t - 1].name, index: +y.v });
        break;
      case "</rc>":
        break;
      case "<cellMetadata":
        metatype = 1;
        break;
      case "</cellMetadata>":
        metatype = 2;
        break;
      case "<valueMetadata":
        metatype = 0;
        break;
      case "</valueMetadata>":
        metatype = 2;
        break;
      case "<extLst":
      case "<extLst>":
      case "</extLst>":
      case "<extLst/>":
        break;
      case "<ext":
        pass = true;
        break;
      case "</ext>":
        pass = false;
        break;
      case "<rvb":
        if (!lastmeta)
          break;
        if (!lastmeta.offsets)
          lastmeta.offsets = [];
        lastmeta.offsets.push(+y.i);
        break;
      default:
        if (!pass && opts.WTF)
          throw new Error("unrecognized " + y[0] + " in metadata");
    }
    return x;
  });
  return out;
}
function write_xlmeta_xml() {
  var o = [XML_HEADER];
  o.push('<metadata xmlns="http://schemas.openxmlformats.org/spreadsheetml/2006/main" xmlns:xlrd="http://schemas.microsoft.com/office/spreadsheetml/2017/richdata" xmlns:xda="http://schemas.microsoft.com/office/spreadsheetml/2017/dynamicarray">\n  <metadataTypes count="1">\n    <metadataType name="XLDAPR" minSupportedVersion="120000" copy="1" pasteAll="1" pasteValues="1" merge="1" splitFirst="1" rowColShift="1" clearFormats="1" clearComments="1" assign="1" coerce="1" cellMeta="1"/>\n  </metadataTypes>\n  <futureMetadata name="XLDAPR" count="1">\n    <bk>\n      <extLst>\n        <ext uri="{bdbb8cdc-fa1e-496e-a857-3c3f30c029c3}">\n          <xda:dynamicArrayProperties fDynamic="1" fCollapsed="0"/>\n        </ext>\n      </extLst>\n    </bk>\n  </futureMetadata>\n  <cellMetadata count="1">\n    <bk>\n      <rc t="1" v="0"/>\n    </bk>\n  </cellMetadata>\n</metadata>');
  return o.join("");
}
/* 18.6 Calculation Chain */
function parse_cc_xml(data/*::, name, opts*/)/*:Array<any>*/ {
	var d = [];
	if(!data) return d;
	var i = 1;
	(data.match(tagregex)||[]).forEach(function(x) {
		var y = parsexmltag(x);
		switch(y[0]) {
			case '<?xml': break;
			/* 18.6.2  calcChain CT_CalcChain 1 */
			case '<calcChain': case '<calcChain>': case '</calcChain>': break;
			/* 18.6.1  c CT_CalcCell 1 */
			case '<c': delete y[0]; if(y.i) i = y.i; else y.i = i; d.push(y); break;
		}
	});
	return d;
}

//function write_cc_xml(data, opts) { }

/* [MS-XLSB] 2.6.4.1 */
function parse_BrtCalcChainItem$(data) {
	var out = {};
	out.i = data.read_shift(4);
	var cell = {};
	cell.r = data.read_shift(4);
	cell.c = data.read_shift(4);
	out.r = encode_cell(cell);
	var flags = data.read_shift(1);
	if(flags & 0x2) out.l = '1';
	if(flags & 0x8) out.a = '1';
	return out;
}

/* 18.6 Calculation Chain */
function parse_cc_bin(data, name, opts) {
	var out = [];
	var pass = false;
	recordhopper(data, function hopper_cc(val, R, RT) {
		switch(RT) {
			case 0x003F: /* 'BrtCalcChainItem$' */
				out.push(val); break;

			default:
				if(R.T){/* empty */}
				else if(!pass || opts.WTF) throw new Error("Unexpected record 0x" + RT.toString(16));
		}
	});
	return out;
}

//function write_cc_bin(data, opts) { }
/* 18.14 Supplementary Workbook Data */
function parse_xlink_xml(/*::data, rel, name:string, _opts*/) {
	//var opts = _opts || {};
	//if(opts.WTF) throw "XLSX External Link";
}

/* [MS-XLSB] 2.1.7.25 External Link */
function parse_xlink_bin(data, rel, name/*:string*/, _opts) {
	if(!data) return data;
	var opts = _opts || {};

	var pass = false, end = false;

	recordhopper(data, function xlink_parse(val, R, RT) {
		if(end) return;
		switch(RT) {
			case 0x0167: /* 'BrtSupTabs' */
			case 0x016B: /* 'BrtExternTableStart' */
			case 0x016C: /* 'BrtExternTableEnd' */
			case 0x016E: /* 'BrtExternRowHdr' */
			case 0x016F: /* 'BrtExternCellBlank' */
			case 0x0170: /* 'BrtExternCellReal' */
			case 0x0171: /* 'BrtExternCellBool' */
			case 0x0172: /* 'BrtExternCellError' */
			case 0x0173: /* 'BrtExternCellString' */
			case 0x01D8: /* 'BrtExternValueMeta' */
			case 0x0241: /* 'BrtSupNameStart' */
			case 0x0242: /* 'BrtSupNameValueStart' */
			case 0x0243: /* 'BrtSupNameValueEnd' */
			case 0x0244: /* 'BrtSupNameNum' */
			case 0x0245: /* 'BrtSupNameErr' */
			case 0x0246: /* 'BrtSupNameSt' */
			case 0x0247: /* 'BrtSupNameNil' */
			case 0x0248: /* 'BrtSupNameBool' */
			case 0x0249: /* 'BrtSupNameFmla' */
			case 0x024A: /* 'BrtSupNameBits' */
			case 0x024B: /* 'BrtSupNameEnd' */
				break;

			case 0x0023: /* 'BrtFRTBegin' */
				pass = true; break;
			case 0x0024: /* 'BrtFRTEnd' */
				pass = false; break;

			default:
				if(R.T){/* empty */}
				else if(!pass || opts.WTF) throw new Error("Unexpected record 0x" + RT.toString(16));
		}
	}, opts);
}
/* 20.5 DrawingML - SpreadsheetML Drawing */
/* 20.5.2.35 wsDr CT_Drawing */
function parse_drawing(data, rels/*:any*/) {
	if(!data) return "??";
	/*
	  Chartsheet Drawing:
	   - 20.5.2.35 wsDr CT_Drawing
	    - 20.5.2.1  absoluteAnchor CT_AbsoluteAnchor
	     - 20.5.2.16 graphicFrame CT_GraphicalObjectFrame
	      - 20.1.2.2.16 graphic CT_GraphicalObject
	       - 20.1.2.2.17 graphicData CT_GraphicalObjectData
          - chart reference
	   the actual type is based on the URI of the graphicData
		TODO: handle embedded charts and other types of graphics
	*/
	var id = (data.match(/<c:chart [^>]*r:id="([^"]*)"/)||["",""])[1];

	return rels['!id'][id].Target;
}

/* L.5.5.2 SpreadsheetML Comments + VML Schema */
var _shapeid = 1024;
function write_comments_vml(rId/*:number*/, comments) {
	var csize = [21600, 21600];
	/* L.5.2.1.2 Path Attribute */
	var bbox = ["m0,0l0",csize[1],csize[0],csize[1],csize[0],"0xe"].join(",");
	var o = [
		writextag("xml", null, { 'xmlns:v': XLMLNS.v, 'xmlns:o': XLMLNS.o, 'xmlns:x': XLMLNS.x, 'xmlns:mv': XLMLNS.mv }).replace(/\/>/,">"),
		writextag("o:shapelayout", writextag("o:idmap", null, {'v:ext':"edit", 'data':rId}), {'v:ext':"edit"}),
		writextag("v:shapetype", [
			writextag("v:stroke", null, {joinstyle:"miter"}),
			writextag("v:path", null, {gradientshapeok:"t", 'o:connecttype':"rect"})
		].join(""), {id:"_x0000_t202", 'o:spt':202, coordsize:csize.join(","),path:bbox})
	];
	while(_shapeid < rId * 1000) _shapeid += 1000;

	comments.forEach(function(x) {
	var c = decode_cell(x[0]);
	var fillopts = /*::(*/{'color2':"#BEFF82", 'type':"gradient"}/*:: :any)*/;
	if(fillopts.type == "gradient") fillopts.angle = "-180";
	var fillparm = fillopts.type == "gradient" ? writextag("o:fill", null, {type:"gradientUnscaled", 'v:ext':"view"}) : null;
	var fillxml = writextag('v:fill', fillparm, fillopts);

	var shadata = ({on:"t", 'obscured':"t"}/*:any*/);
	++_shapeid;

	o = o.concat([
	'<v:shape' + wxt_helper({
		id:'_x0000_s' + _shapeid,
		type:"#_x0000_t202",
		style:"position:absolute; margin-left:80pt;margin-top:5pt;width:104pt;height:64pt;z-index:10" + (x[1].hidden ? ";visibility:hidden" : "") ,
		fillcolor:"#ECFAD4",
		strokecolor:"#edeaa1"
	}) + '>',
		fillxml,
		writextag("v:shadow", null, shadata),
		writextag("v:path", null, {'o:connecttype':"none"}),
		'<v:textbox><div style="text-align:left"></div></v:textbox>',
		'<x:ClientData ObjectType="Note">',
			'<x:MoveWithCells/>',
			'<x:SizeWithCells/>',
			/* Part 4 19.4.2.3 Anchor (Anchor) */
			writetag('x:Anchor', [c.c+1, 0, c.r+1, 0, c.c+3, 20, c.r+5, 20].join(",")),
			writetag('x:AutoFill', "False"),
			writetag('x:Row', String(c.r)),
			writetag('x:Column', String(c.c)),
			x[1].hidden ? '' : '<x:Visible/>',
		'</x:ClientData>',
	'</v:shape>'
	]); });
	o.push('</xml>');
	return o.join("");
}
function sheet_insert_comments(sheet, comments/*:Array<RawComment>*/, threaded/*:boolean*/, people/*:?Array<any>*/) {
	var dense = Array.isArray(sheet);
	var cell/*:Cell*/;
	comments.forEach(function(comment) {
		var r = decode_cell(comment.ref);
		if(dense) {
			if(!sheet[r.r]) sheet[r.r] = [];
			cell = sheet[r.r][r.c];
		} else cell = sheet[comment.ref];
		if (!cell) {
			cell = ({t:"z"}/*:any*/);
			if(dense) sheet[r.r][r.c] = cell;
			else sheet[comment.ref] = cell;
			var range = safe_decode_range(sheet["!ref"]||"BDWGO1000001:A1");
			if(range.s.r > r.r) range.s.r = r.r;
			if(range.e.r < r.r) range.e.r = r.r;
			if(range.s.c > r.c) range.s.c = r.c;
			if(range.e.c < r.c) range.e.c = r.c;
			var encoded = encode_range(range);
			if (encoded !== sheet["!ref"]) sheet["!ref"] = encoded;
		}

		if (!cell.c) cell.c = [];
		var o/*:Comment*/ = ({a: comment.author, t: comment.t, r: comment.r, T: threaded});
		if(comment.h) o.h = comment.h;

		/* threaded comments always override */
		for(var i = cell.c.length - 1; i >= 0; --i) {
			if(!threaded && cell.c[i].T) return;
			if(threaded && !cell.c[i].T) cell.c.splice(i, 1);
		}
		if(threaded && people) for(i = 0; i < people.length; ++i) {
			if(o.a == people[i].id) { o.a = people[i].name || o.a; break; }
		}
		cell.c.push(o);
	});
}

/* 18.7 Comments */
function parse_comments_xml(data/*:string*/, opts)/*:Array<RawComment>*/ {
	/* 18.7.6 CT_Comments */
	if(data.match(/<(?:\w+:)?comments *\/>/)) return [];
	var authors/*:Array<string>*/ = [];
	var commentList/*:Array<RawComment>*/ = [];
	var authtag = data.match(/<(?:\w+:)?authors>([\s\S]*)<\/(?:\w+:)?authors>/);
	if(authtag && authtag[1]) authtag[1].split(/<\/\w*:?author>/).forEach(function(x) {
		if(x === "" || x.trim() === "") return;
		var a = x.match(/<(?:\w+:)?author[^>]*>(.*)/);
		if(a) authors.push(a[1]);
	});
	var cmnttag = data.match(/<(?:\w+:)?commentList>([\s\S]*)<\/(?:\w+:)?commentList>/);
	if(cmnttag && cmnttag[1]) cmnttag[1].split(/<\/\w*:?comment>/).forEach(function(x) {
		if(x === "" || x.trim() === "") return;
		var cm = x.match(/<(?:\w+:)?comment[^>]*>/);
		if(!cm) return;
		var y = parsexmltag(cm[0]);
		var comment/*:RawComment*/ = ({ author: y.authorId && authors[y.authorId] || "sheetjsghost", ref: y.ref, guid: y.guid }/*:any*/);
		var cell = decode_cell(y.ref);
		if(opts.sheetRows && opts.sheetRows <= cell.r) return;
		var textMatch = x.match(/<(?:\w+:)?text>([\s\S]*)<\/(?:\w+:)?text>/);
		var rt = !!textMatch && !!textMatch[1] && parse_si(textMatch[1]) || {r:"",t:"",h:""};
		comment.r = rt.r;
		if(rt.r == "<t></t>") rt.t = rt.h = "";
		comment.t = (rt.t||"").replace(/\r\n/g,"\n").replace(/\r/g,"\n");
		if(opts.cellHTML) comment.h = rt.h;
		commentList.push(comment);
	});
	return commentList;
}

function write_comments_xml(data/*::, opts*/) {
	var o = [XML_HEADER, writextag('comments', null, { 'xmlns': XMLNS_main[0] })];

	var iauthor/*:Array<string>*/ = [];
	o.push("<authors>");
	data.forEach(function(x) { x[1].forEach(function(w) { var a = escapexml(w.a);
		if(iauthor.indexOf(a) == -1) {
			iauthor.push(a);
			o.push("<author>" + a + "</author>");
		}
		if(w.T && w.ID && iauthor.indexOf("tc=" + w.ID) == -1) {
			iauthor.push("tc=" + w.ID);
			o.push("<author>" + "tc=" + w.ID + "</author>");
		}
	}); });
	if(iauthor.length == 0) { iauthor.push("SheetJ5"); o.push("<author>SheetJ5</author>"); }
	o.push("</authors>");
	o.push("<commentList>");
	data.forEach(function(d) {
		/* 18.7.3 CT_Comment */
		var lastauthor = 0, ts = [];
		if(d[1][0] && d[1][0].T && d[1][0].ID) lastauthor = iauthor.indexOf("tc=" + d[1][0].ID);
		else d[1].forEach(function(c) {
			if(c.a) lastauthor = iauthor.indexOf(escapexml(c.a));
			ts.push(c.t||"");
		});
		o.push('<comment ref="' + d[0] + '" authorId="' + lastauthor + '"><text>');
		if(ts.length <= 1) o.push(writetag("t", escapexml(ts[0]||"")));
		else {
			/* based on Threaded Comments -> Comments projection */
			var t = "Comment:\n    " + (ts[0]) + "\n";
			for(var i = 1; i < ts.length; ++i) t += "Reply:\n    " + ts[i] + "\n";
			o.push(writetag("t", escapexml(t)));
		}
		o.push('</text></comment>');
	});
	o.push("</commentList>");
	if(o.length>2) { o[o.length] = ('</comments>'); o[1]=o[1].replace("/>",">"); }
	return o.join("");
}

/* [MS-XLSX] 2.1.17 */
function parse_tcmnt_xml(data/*:string*/, opts)/*:Array<RawComment>*/ {
	var out = [];
	var pass = false, comment = {}, tidx = 0;
	data.replace(tagregex, function xml_tcmnt(x, idx) {
		var y/*:any*/ = parsexmltag(x);
		switch(strip_ns(y[0])) {
			case '<?xml': break;

			/* 2.6.207 ThreadedComments CT_ThreadedComments */
			case '<ThreadedComments': break;
			case '</ThreadedComments>': break;

			/* 2.6.205 threadedComment CT_ThreadedComment */
			case '<threadedComment': comment = {author: y.personId, guid: y.id, ref: y.ref, T: 1}; break;
			case '</threadedComment>': if(comment.t != null) out.push(comment); break;

			case '<text>': case '<text': tidx = idx + x.length; break;
			case '</text>': comment.t = data.slice(tidx, idx).replace(/\r\n/g, "\n").replace(/\r/g, "\n"); break;

			/* 2.6.206 mentions CT_ThreadedCommentMentions TODO */
			case '<mentions': case '<mentions>': pass = true; break;
			case '</mentions>': pass = false; break;

			/* 2.6.202 mention CT_Mention TODO */

			/* 18.2.10 extLst CT_ExtensionList ? */
			case '<extLst': case '<extLst>': case '</extLst>': case '<extLst/>': break;
			/* 18.2.7  ext CT_Extension + */
			case '<ext': pass=true; break;
			case '</ext>': pass=false; break;

			default: if(!pass && opts.WTF) throw new Error('unrecognized ' + y[0] + ' in threaded comments');
		}
		return x;
	});
	return out;
}

function write_tcmnt_xml(comments, people, opts) {
	var o = [XML_HEADER, writextag('ThreadedComments', null, { 'xmlns': XMLNS.TCMNT }).replace(/[\/]>/, ">")];
	comments.forEach(function(carr) {
		var rootid = "";
		(carr[1] || []).forEach(function(c, idx) {
			if(!c.T) { delete c.ID; return; }
			if(c.a && people.indexOf(c.a) == -1) people.push(c.a);
			var tcopts = {
				ref: carr[0],
				id: "{54EE7951-7262-4200-6969-" + ("000000000000" + opts.tcid++).slice(-12) + "}"
			};
			if(idx == 0) rootid = tcopts.id;
			else tcopts.parentId = rootid;
			c.ID = tcopts.id;
			if(c.a) tcopts.personId = "{54EE7950-7262-4200-6969-" + ("000000000000" + people.indexOf(c.a)).slice(-12) + "}";
			o.push(writextag('threadedComment', writetag('text', c.t||""), tcopts));
		});
	});
	o.push('</ThreadedComments>');
	return o.join("");
}

/* [MS-XLSX] 2.1.18 */
function parse_people_xml(data/*:string*/, opts) {
	var out = [];
	var pass = false;
	data.replace(tagregex, function xml_tcmnt(x) {
		var y/*:any*/ = parsexmltag(x);
		switch(strip_ns(y[0])) {
			case '<?xml': break;

			/* 2.4.85 personList CT_PersonList */
			case '<personList': break;
			case '</personList>': break;

			/* 2.6.203 person CT_Person TODO: providers */
			case '<person': out.push({name: y.displayname, id: y.id }); break;
			case '</person>': break;

			/* 18.2.10 extLst CT_ExtensionList ? */
			case '<extLst': case '<extLst>': case '</extLst>': case '<extLst/>': break;
			/* 18.2.7  ext CT_Extension + */
			case '<ext': pass=true; break;
			case '</ext>': pass=false; break;

			default: if(!pass && opts.WTF) throw new Error('unrecognized ' + y[0] + ' in threaded comments');
		}
		return x;
	});
	return out;
}
function write_people_xml(people/*, opts*/) {
	var o = [XML_HEADER, writextag('personList', null, {
		'xmlns': XMLNS.TCMNT,
		'xmlns:x': XMLNS_main[0]
	}).replace(/[\/]>/, ">")];
	people.forEach(function(person, idx) {
		o.push(writextag('person', null, {
			displayName: person,
			id: "{54EE7950-7262-4200-6969-" + ("000000000000" + idx).slice(-12) + "}",
			userId: person,
			providerId: "None"
		}));
	});
	o.push("</personList>");
	return o.join("");
}
/* [MS-XLSB] 2.4.28 BrtBeginComment */
function parse_BrtBeginComment(data) {
	var out = {};
	out.iauthor = data.read_shift(4);
	var rfx = parse_UncheckedRfX(data, 16);
	out.rfx = rfx.s;
	out.ref = encode_cell(rfx.s);
	data.l += 16; /*var guid = parse_GUID(data); */
	return out;
}
function write_BrtBeginComment(data, o) {
	if(o == null) o = new_buf(36);
	o.write_shift(4, data[1].iauthor);
	write_UncheckedRfX((data[0]/*:any*/), o);
	o.write_shift(4, 0);
	o.write_shift(4, 0);
	o.write_shift(4, 0);
	o.write_shift(4, 0);
	return o;
}

/* [MS-XLSB] 2.4.327 BrtCommentAuthor */
var parse_BrtCommentAuthor = parse_XLWideString;
function write_BrtCommentAuthor(data) { return write_XLWideString(data.slice(0, 54)); }

/* [MS-XLSB] 2.1.7.8 Comments */
function parse_comments_bin(data, opts)/*:Array<RawComment>*/ {
	var out/*:Array<RawComment>*/ = [];
	var authors/*:Array<string>*/ = [];
	var c = {};
	var pass = false;
	recordhopper(data, function hopper_cmnt(val, R, RT) {
		switch(RT) {
			case 0x0278: /* 'BrtCommentAuthor' */
				authors.push(val); break;
			case 0x027B: /* 'BrtBeginComment' */
				c = val; break;
			case 0x027D: /* 'BrtCommentText' */
				c.t = val.t; c.h = val.h; c.r = val.r; break;
			case 0x027C: /* 'BrtEndComment' */
				c.author = authors[c.iauthor];
				delete (c/*:any*/).iauthor;
				if(opts.sheetRows && c.rfx && opts.sheetRows <= c.rfx.r) break;
				if(!c.t) c.t = "";
				delete c.rfx; out.push(c); break;

			case 0x0C00: /* 'BrtUid' */
				break;

			case 0x0023: /* 'BrtFRTBegin' */
				pass = true; break;
			case 0x0024: /* 'BrtFRTEnd' */
				pass = false; break;
			case 0x0025: /* 'BrtACBegin' */ break;
			case 0x0026: /* 'BrtACEnd' */ break;


			default:
				if(R.T){/* empty */}
				else if(!pass || opts.WTF) throw new Error("Unexpected record 0x" + RT.toString(16));
		}
	});
	return out;
}

function write_comments_bin(data/*::, opts*/) {
	var ba = buf_array();
	var iauthor/*:Array<string>*/ = [];
	write_record(ba, 0x0274 /* BrtBeginComments */);

	write_record(ba, 0x0276 /* BrtBeginCommentAuthors */);
	data.forEach(function(comment) {
		comment[1].forEach(function(c) {
			if(iauthor.indexOf(c.a) > -1) return;
			iauthor.push(c.a.slice(0,54));
			write_record(ba, 0x0278 /* BrtCommentAuthor */, write_BrtCommentAuthor(c.a));
		});
	});
	write_record(ba, 0x0277 /* BrtEndCommentAuthors */);

	write_record(ba, 0x0279 /* BrtBeginCommentList */);
	data.forEach(function(comment) {
		comment[1].forEach(function(c) {
			c.iauthor = iauthor.indexOf(c.a);
			var range = {s:decode_cell(comment[0]),e:decode_cell(comment[0])};
			write_record(ba, 0x027B /* BrtBeginComment */, write_BrtBeginComment([range, c]));
			if(c.t && c.t.length > 0) write_record(ba, 0x027D /* BrtCommentText */, write_BrtCommentText(c));
			write_record(ba, 0x027C /* BrtEndComment */);
			delete c.iauthor;
		});
	});
	write_record(ba, 0x027A /* BrtEndCommentList */);

	write_record(ba, 0x0275 /* BrtEndComments */);
	return ba.end();
}
var CT_VBA = "application/vnd.ms-office.vbaProject";
function make_vba_xls(cfb) {
  var newcfb = CFB.utils.cfb_new({ root: "R" });
  cfb.FullPaths.forEach(function(p, i) {
    if (p.slice(-1) === "/" || !p.match(/_VBA_PROJECT_CUR/))
      return;
    var newpath = p.replace(/^[^\/]*/, "R").replace(/\/_VBA_PROJECT_CUR\u0000*/, "");
    CFB.utils.cfb_add(newcfb, newpath, cfb.FileIndex[i].content);
  });
  return CFB.write(newcfb);
}
function fill_vba_xls(cfb, vba) {
  vba.FullPaths.forEach(function(p, i) {
    if (i == 0)
      return;
    var newpath = p.replace(/[^\/]*[\/]/, "/_VBA_PROJECT_CUR/");
    if (newpath.slice(-1) !== "/")
      CFB.utils.cfb_add(cfb, newpath, vba.FileIndex[i].content);
  });
}
var VBAFMTS = ["xlsb", "xlsm", "xlam", "biff8", "xla"];
/* macro and dialog sheet stubs */
function parse_ds_bin(/*::data:any, opts, idx:number, rels, wb, themes, styles*/)/*:Worksheet*/ { return {'!type':'dialog'}; }
function parse_ds_xml(/*::data:any, opts, idx:number, rels, wb, themes, styles*/)/*:Worksheet*/ { return {'!type':'dialog'}; }
function parse_ms_bin(/*::data:any, opts, idx:number, rels, wb, themes, styles*/)/*:Worksheet*/ { return {'!type':'macro'}; }
function parse_ms_xml(/*::data:any, opts, idx:number, rels, wb, themes, styles*/)/*:Worksheet*/ { return {'!type':'macro'}; }
/* TODO: it will be useful to parse the function str */
var rc_to_a1 = /*#__PURE__*/(function(){
	var rcregex = /(^|[^A-Za-z_])R(\[?-?\d+\]|[1-9]\d*|)C(\[?-?\d+\]|[1-9]\d*|)(?![A-Za-z0-9_])/g;
	var rcbase/*:Cell*/ = ({r:0,c:0}/*:any*/);
	function rcfunc($$,$1,$2,$3) {
		var cRel = false, rRel = false;

		if($2.length == 0) rRel = true;
		else if($2.charAt(0) == "[") { rRel = true; $2 = $2.slice(1, -1); }

		if($3.length == 0) cRel = true;
		else if($3.charAt(0) == "[") { cRel = true; $3 = $3.slice(1, -1); }

		var R = $2.length>0?parseInt($2,10)|0:0, C = $3.length>0?parseInt($3,10)|0:0;

		if(cRel) C += rcbase.c; else --C;
		if(rRel) R += rcbase.r; else --R;
		return $1 + (cRel ? "" : "$") + encode_col(C) + (rRel ? "" : "$") + encode_row(R);
	}
	return function rc_to_a1(fstr/*:string*/, base/*:Cell*/)/*:string*/ {
		rcbase = base;
		return fstr.replace(rcregex, rcfunc);
	};
})();

var crefregex = /(^|[^._A-Z0-9])([$]?)([A-Z]{1,2}|[A-W][A-Z]{2}|X[A-E][A-Z]|XF[A-D])([$]?)(10[0-3]\d{4}|104[0-7]\d{3}|1048[0-4]\d{2}|10485[0-6]\d|104857[0-6]|[1-9]\d{0,5})(?![_.\(A-Za-z0-9])/g;
var a1_to_rc = /*#__PURE__*/(function(){
	return function a1_to_rc(fstr/*:string*/, base/*:CellAddress*/) {
		return fstr.replace(crefregex, function($0, $1, $2, $3, $4, $5) {
			var c = decode_col($3) - ($2 ? 0 : base.c);
			var r = decode_row($5) - ($4 ? 0 : base.r);
			var R = (r == 0 ? "" : !$4 ? "[" + r + "]" : (r+1));
			var C = (c == 0 ? "" : !$2 ? "[" + c + "]" : (c+1));
			return $1 + "R" + R + "C" + C;
		});
	};
})();

/* no defined name can collide with a valid cell address A1:XFD1048576 ... except LOG10! */
function shift_formula_str(f/*:string*/, delta/*:Cell*/)/*:string*/ {
	return f.replace(crefregex, function($0, $1, $2, $3, $4, $5) {
		return $1+($2=="$" ? $2+$3 : encode_col(decode_col($3)+delta.c))+($4=="$" ? $4+$5 : encode_row(decode_row($5) + delta.r));
	});
}

function shift_formula_xlsx(f/*:string*/, range/*:string*/, cell/*:string*/)/*:string*/ {
	var r = decode_range(range), s = r.s, c = decode_cell(cell);
	var delta = {r:c.r - s.r, c:c.c - s.c};
	return shift_formula_str(f, delta);
}

/* TODO: parse formula */
function fuzzyfmla(f/*:string*/)/*:boolean*/ {
	if(f.length == 1) return false;
	return true;
}

function _xlfn(f/*:string*/)/*:string*/ {
	return f.replace(/_xlfn\./g,"");
}
function parseread1(blob) { blob.l+=1; return; }

/* [MS-XLS] 2.5.51 */
function parse_ColRelU(blob, length) {
	var c = blob.read_shift(length == 1 ? 1 : 2);
	return [c & 0x3FFF, (c >> 14) & 1, (c >> 15) & 1];
}

/* [MS-XLS] 2.5.198.105 ; [MS-XLSB] 2.5.97.89 */
function parse_RgceArea(blob, length, opts) {
	var w = 2;
	if(opts) {
		if(opts.biff >= 2 && opts.biff <= 5) return parse_RgceArea_BIFF2(blob, length, opts);
		else if(opts.biff == 12) w = 4;
	}
	var r=blob.read_shift(w), R=blob.read_shift(w);
	var c=parse_ColRelU(blob, 2);
	var C=parse_ColRelU(blob, 2);
	return { s:{r:r, c:c[0], cRel:c[1], rRel:c[2]}, e:{r:R, c:C[0], cRel:C[1], rRel:C[2]} };
}
/* BIFF 2-5 encodes flags in the row field */
function parse_RgceArea_BIFF2(blob/*::, length, opts*/) {
	var r=parse_ColRelU(blob, 2), R=parse_ColRelU(blob, 2);
	var c=blob.read_shift(1);
	var C=blob.read_shift(1);
	return { s:{r:r[0], c:c, cRel:r[1], rRel:r[2]}, e:{r:R[0], c:C, cRel:R[1], rRel:R[2]} };
}

/* [MS-XLS] 2.5.198.105 ; [MS-XLSB] 2.5.97.90 */
function parse_RgceAreaRel(blob, length, opts) {
	if(opts.biff < 8) return parse_RgceArea_BIFF2(blob, length, opts);
	var r=blob.read_shift(opts.biff == 12 ? 4 : 2), R=blob.read_shift(opts.biff == 12 ? 4 : 2);
	var c=parse_ColRelU(blob, 2);
	var C=parse_ColRelU(blob, 2);
	return { s:{r:r, c:c[0], cRel:c[1], rRel:c[2]}, e:{r:R, c:C[0], cRel:C[1], rRel:C[2]} };
}

/* [MS-XLS] 2.5.198.109 ; [MS-XLSB] 2.5.97.91 */
function parse_RgceLoc(blob, length, opts) {
	if(opts && opts.biff >= 2 && opts.biff <= 5) return parse_RgceLoc_BIFF2(blob, length, opts);
	var r = blob.read_shift(opts && opts.biff == 12 ? 4 : 2);
	var c = parse_ColRelU(blob, 2);
	return {r:r, c:c[0], cRel:c[1], rRel:c[2]};
}
function parse_RgceLoc_BIFF2(blob/*::, length, opts*/) {
	var r = parse_ColRelU(blob, 2);
	var c = blob.read_shift(1);
	return {r:r[0], c:c, cRel:r[1], rRel:r[2]};
}

/* [MS-XLS] 2.5.198.107, 2.5.47 */
function parse_RgceElfLoc(blob/*::, length, opts*/) {
	var r = blob.read_shift(2);
	var c = blob.read_shift(2);
	return {r:r, c:c & 0xFF, fQuoted:!!(c & 0x4000), cRel:c>>15, rRel:c>>15 };
}

/* [MS-XLS] 2.5.198.111 ; [MS-XLSB] 2.5.97.92 TODO */
function parse_RgceLocRel(blob, length, opts) {
	var biff = opts && opts.biff ? opts.biff : 8;
	if(biff >= 2 && biff <= 5) return parse_RgceLocRel_BIFF2(blob, length, opts);
	var r = blob.read_shift(biff >= 12 ? 4 : 2);
	var cl = blob.read_shift(2);
	var cRel = (cl & 0x4000) >> 14, rRel = (cl & 0x8000) >> 15;
	cl &= 0x3FFF;
	if(rRel == 1) while(r > 0x7FFFF) r -= 0x100000;
	if(cRel == 1) while(cl > 0x1FFF) cl = cl - 0x4000;
	return {r:r,c:cl,cRel:cRel,rRel:rRel};
}
function parse_RgceLocRel_BIFF2(blob/*::, length:number, opts*/) {
	var rl = blob.read_shift(2);
	var c = blob.read_shift(1);
	var rRel = (rl & 0x8000) >> 15, cRel = (rl & 0x4000) >> 14;
	rl &= 0x3FFF;
	if(rRel == 1 && rl >= 0x2000) rl = rl - 0x4000;
	if(cRel == 1 && c >= 0x80) c = c - 0x100;
	return {r:rl,c:c,cRel:cRel,rRel:rRel};
}

/* [MS-XLS] 2.5.198.27 ; [MS-XLSB] 2.5.97.18 */
function parse_PtgArea(blob, length, opts) {
	var type = (blob[blob.l++] & 0x60) >> 5;
	var area = parse_RgceArea(blob, opts.biff >= 2 && opts.biff <= 5 ? 6 : 8, opts);
	return [type, area];
}

/* [MS-XLS] 2.5.198.28 ; [MS-XLSB] 2.5.97.19 */
function parse_PtgArea3d(blob, length, opts) {
	var type = (blob[blob.l++] & 0x60) >> 5;
	var ixti = blob.read_shift(2, 'i');
	var w = 8;
	if(opts) switch(opts.biff) {
		case 5: blob.l += 12; w = 6; break;
		case 12: w = 12; break;
	}
	var area = parse_RgceArea(blob, w, opts);
	return [type, ixti, area];
}

/* [MS-XLS] 2.5.198.29 ; [MS-XLSB] 2.5.97.20 */
function parse_PtgAreaErr(blob, length, opts) {
	var type = (blob[blob.l++] & 0x60) >> 5;
	blob.l += opts && (opts.biff > 8) ? 12 : (opts.biff < 8 ? 6 : 8);
	return [type];
}
/* [MS-XLS] 2.5.198.30 ; [MS-XLSB] 2.5.97.21 */
function parse_PtgAreaErr3d(blob, length, opts) {
	var type = (blob[blob.l++] & 0x60) >> 5;
	var ixti = blob.read_shift(2);
	var w = 8;
	if(opts) switch(opts.biff) {
		case 5: blob.l += 12; w = 6; break;
		case 12: w = 12; break;
	}
	blob.l += w;
	return [type, ixti];
}

/* [MS-XLS] 2.5.198.31 ; [MS-XLSB] 2.5.97.22 */
function parse_PtgAreaN(blob, length, opts) {
	var type = (blob[blob.l++] & 0x60) >> 5;
	var area = parse_RgceAreaRel(blob, length - 1, opts);
	return [type, area];
}

/* [MS-XLS] 2.5.198.32 ; [MS-XLSB] 2.5.97.23 */
function parse_PtgArray(blob, length, opts) {
	var type = (blob[blob.l++] & 0x60) >> 5;
	blob.l += opts.biff == 2 ? 6 : opts.biff == 12 ? 14 : 7;
	return [type];
}

/* [MS-XLS] 2.5.198.33 ; [MS-XLSB] 2.5.97.24 */
function parse_PtgAttrBaxcel(blob) {
	var bitSemi = blob[blob.l+1] & 0x01; /* 1 = volatile */
	var bitBaxcel = 1;
	blob.l += 4;
	return [bitSemi, bitBaxcel];
}

/* [MS-XLS] 2.5.198.34 ; [MS-XLSB] 2.5.97.25 */
function parse_PtgAttrChoose(blob, length, opts)/*:Array<number>*/ {
	blob.l +=2;
	var offset = blob.read_shift(opts && opts.biff == 2 ? 1 : 2);
	var o/*:Array<number>*/ = [];
	/* offset is 1 less than the number of elements */
	for(var i = 0; i <= offset; ++i) o.push(blob.read_shift(opts && opts.biff == 2 ? 1 : 2));
	return o;
}

/* [MS-XLS] 2.5.198.35 ; [MS-XLSB] 2.5.97.26 */
function parse_PtgAttrGoto(blob, length, opts) {
	var bitGoto = (blob[blob.l+1] & 0xFF) ? 1 : 0;
	blob.l += 2;
	return [bitGoto, blob.read_shift(opts && opts.biff == 2 ? 1 : 2)];
}

/* [MS-XLS] 2.5.198.36 ; [MS-XLSB] 2.5.97.27 */
function parse_PtgAttrIf(blob, length, opts) {
	var bitIf = (blob[blob.l+1] & 0xFF) ? 1 : 0;
	blob.l += 2;
	return [bitIf, blob.read_shift(opts && opts.biff == 2 ? 1 : 2)];
}

/* [MS-XLSB] 2.5.97.28 */
function parse_PtgAttrIfError(blob) {
	var bitIf = (blob[blob.l+1] & 0xFF) ? 1 : 0;
	blob.l += 2;
	return [bitIf, blob.read_shift(2)];
}

/* [MS-XLS] 2.5.198.37 ; [MS-XLSB] 2.5.97.29 */
function parse_PtgAttrSemi(blob, length, opts) {
	var bitSemi = (blob[blob.l+1] & 0xFF) ? 1 : 0;
	blob.l += opts && opts.biff == 2 ? 3 : 4;
	return [bitSemi];
}

/* [MS-XLS] 2.5.198.40 ; [MS-XLSB] 2.5.97.32 */
function parse_PtgAttrSpaceType(blob/*::, length*/) {
	var type = blob.read_shift(1), cch = blob.read_shift(1);
	return [type, cch];
}

/* [MS-XLS] 2.5.198.38 ; [MS-XLSB] 2.5.97.30 */
function parse_PtgAttrSpace(blob) {
	blob.read_shift(2);
	return parse_PtgAttrSpaceType(blob, 2);
}

/* [MS-XLS] 2.5.198.39 ; [MS-XLSB] 2.5.97.31 */
function parse_PtgAttrSpaceSemi(blob) {
	blob.read_shift(2);
	return parse_PtgAttrSpaceType(blob, 2);
}

/* [MS-XLS] 2.5.198.84 ; [MS-XLSB] 2.5.97.68 TODO */
function parse_PtgRef(blob, length, opts) {
	//var ptg = blob[blob.l] & 0x1F;
	var type = (blob[blob.l] & 0x60)>>5;
	blob.l += 1;
	var loc = parse_RgceLoc(blob, 0, opts);
	return [type, loc];
}

/* [MS-XLS] 2.5.198.88 ; [MS-XLSB] 2.5.97.72 TODO */
function parse_PtgRefN(blob, length, opts) {
	var type = (blob[blob.l] & 0x60)>>5;
	blob.l += 1;
	var loc = parse_RgceLocRel(blob, 0, opts);
	return [type, loc];
}

/* [MS-XLS] 2.5.198.85 ; [MS-XLSB] 2.5.97.69 TODO */
function parse_PtgRef3d(blob, length, opts) {
	var type = (blob[blob.l] & 0x60)>>5;
	blob.l += 1;
	var ixti = blob.read_shift(2); // XtiIndex
	if(opts && opts.biff == 5) blob.l += 12;
	var loc = parse_RgceLoc(blob, 0, opts); // TODO: or RgceLocRel
	return [type, ixti, loc];
}


/* [MS-XLS] 2.5.198.62 ; [MS-XLSB] 2.5.97.45 TODO */
function parse_PtgFunc(blob, length, opts) {
	//var ptg = blob[blob.l] & 0x1F;
	var type = (blob[blob.l] & 0x60)>>5;
	blob.l += 1;
	var iftab = blob.read_shift(opts && opts.biff <= 3 ? 1 : 2);
	return [FtabArgc[iftab], Ftab[iftab], type];
}
/* [MS-XLS] 2.5.198.63 ; [MS-XLSB] 2.5.97.46 TODO */
function parse_PtgFuncVar(blob, length, opts) {
	var type = blob[blob.l++];
	var cparams = blob.read_shift(1), tab = opts && opts.biff <= 3 ? [(type == 0x58 ? -1 : 0), blob.read_shift(1)]: parsetab(blob);
	return [cparams, (tab[0] === 0 ? Ftab : Cetab)[tab[1]]];
}

function parsetab(blob) {
	return [blob[blob.l+1]>>7, blob.read_shift(2) & 0x7FFF];
}

/* [MS-XLS] 2.5.198.41 ; [MS-XLSB] 2.5.97.33 */
function parse_PtgAttrSum(blob, length, opts) {
	blob.l += opts && opts.biff == 2 ? 3 : 4; return;
}

/* [MS-XLS] 2.5.198.58 ; [MS-XLSB] 2.5.97.40 */
function parse_PtgExp(blob, length, opts) {
	blob.l++;
	if(opts && opts.biff == 12) return [blob.read_shift(4, 'i'), 0];
	var row = blob.read_shift(2);
	var col = blob.read_shift(opts && opts.biff == 2 ? 1 : 2);
	return [row, col];
}

/* [MS-XLS] 2.5.198.57 ; [MS-XLSB] 2.5.97.39 */
function parse_PtgErr(blob) { blob.l++; return BErr[blob.read_shift(1)]; }

/* [MS-XLS] 2.5.198.66 ; [MS-XLSB] 2.5.97.49 */
function parse_PtgInt(blob) { blob.l++; return blob.read_shift(2); }

/* [MS-XLS] 2.5.198.42 ; [MS-XLSB] 2.5.97.34 */
function parse_PtgBool(blob) { blob.l++; return blob.read_shift(1)!==0;}

/* [MS-XLS] 2.5.198.79 ; [MS-XLSB] 2.5.97.63 */
function parse_PtgNum(blob) { blob.l++; return parse_Xnum(blob, 8); }

/* [MS-XLS] 2.5.198.89 ; [MS-XLSB] 2.5.97.74 */
function parse_PtgStr(blob, length, opts) { blob.l++; return parse_ShortXLUnicodeString(blob, length-1, opts); }

/* [MS-XLS] 2.5.192.112 + 2.5.192.11{3,4,5,6,7} */
/* [MS-XLSB] 2.5.97.93 + 2.5.97.9{4,5,6,7} */
function parse_SerAr(blob, biff/*:number*/) {
	var val = [blob.read_shift(1)];
	if(biff == 12) switch(val[0]) {
		case 0x02: val[0] = 0x04; break; /* SerBool */
		case 0x04: val[0] = 0x10; break; /* SerErr */
		case 0x00: val[0] = 0x01; break; /* SerNum */
		case 0x01: val[0] = 0x02; break; /* SerStr */
	}
	switch(val[0]) {
		case 0x04: /* SerBool -- boolean */
			val[1] = parsebool(blob, 1) ? 'TRUE' : 'FALSE';
			if(biff != 12) blob.l += 7; break;
		case 0x25: /* appears to be an alias */
		case 0x10: /* SerErr -- error */
			val[1] = BErr[blob[blob.l]];
			blob.l += ((biff == 12) ? 4 : 8); break;
		case 0x00: /* SerNil -- honestly, I'm not sure how to reproduce this */
			blob.l += 8; break;
		case 0x01: /* SerNum -- Xnum */
			val[1] = parse_Xnum(blob, 8); break;
		case 0x02: /* SerStr -- XLUnicodeString (<256 chars) */
			val[1] = parse_XLUnicodeString2(blob, 0, {biff:biff > 0 && biff < 8 ? 2 : biff}); break;
		default: throw new Error("Bad SerAr: " + val[0]); /* Unreachable */
	}
	return val;
}

/* [MS-XLS] 2.5.198.61 ; [MS-XLSB] 2.5.97.44 */
function parse_PtgExtraMem(blob, cce, opts) {
	var count = blob.read_shift((opts.biff == 12) ? 4 : 2);
	var out/*:Array<Range>*/ = [];
	for(var i = 0; i != count; ++i) out.push(((opts.biff == 12) ? parse_UncheckedRfX : parse_Ref8U)(blob, 8));
	return out;
}

/* [MS-XLS] 2.5.198.59 ; [MS-XLSB] 2.5.97.41 */
function parse_PtgExtraArray(blob, length, opts) {
	var rows = 0, cols = 0;
	if(opts.biff == 12) {
		rows = blob.read_shift(4); // DRw
		cols = blob.read_shift(4); // DCol
	} else {
		cols = 1 + blob.read_shift(1); //DColByteU
		rows = 1 + blob.read_shift(2); //DRw
	}
	if(opts.biff >= 2 && opts.biff < 8) { --rows; if(--cols == 0) cols = 0x100; }
	// $FlowIgnore
	for(var i = 0, o/*:Array<Array<any>>*/ = []; i != rows && (o[i] = []); ++i)
		for(var j = 0; j != cols; ++j) o[i][j] = parse_SerAr(blob, opts.biff);
	return o;
}

/* [MS-XLS] 2.5.198.76 ; [MS-XLSB] 2.5.97.60 */
function parse_PtgName(blob, length, opts) {
	var type = (blob.read_shift(1) >>> 5) & 0x03;
	var w = (!opts || (opts.biff >= 8)) ? 4 : 2;
	var nameindex = blob.read_shift(w);
	switch(opts.biff) {
		case 2: blob.l += 5; break;
		case 3: case 4: blob.l += 8; break;
		case 5: blob.l += 12; break;
	}
	return [type, 0, nameindex];
}

/* [MS-XLS] 2.5.198.77 ; [MS-XLSB] 2.5.97.61 */
function parse_PtgNameX(blob, length, opts) {
	if(opts.biff == 5) return parse_PtgNameX_BIFF5(blob, length, opts);
	var type = (blob.read_shift(1) >>> 5) & 0x03;
	var ixti = blob.read_shift(2); // XtiIndex
	var nameindex = blob.read_shift(4);
	return [type, ixti, nameindex];
}
function parse_PtgNameX_BIFF5(blob/*::, length, opts*/) {
	var type = (blob.read_shift(1) >>> 5) & 0x03;
	var ixti = blob.read_shift(2, 'i'); // XtiIndex
	blob.l += 8;
	var nameindex = blob.read_shift(2);
	blob.l += 12;
	return [type, ixti, nameindex];
}

/* [MS-XLS] 2.5.198.70 ; [MS-XLSB] 2.5.97.54 */
function parse_PtgMemArea(blob, length, opts) {
	var type = (blob.read_shift(1) >>> 5) & 0x03;
	blob.l += (opts && opts.biff == 2 ? 3 : 4);
	var cce = blob.read_shift(opts && opts.biff == 2 ? 1 : 2);
	return [type, cce];
}

/* [MS-XLS] 2.5.198.72 ; [MS-XLSB] 2.5.97.56 */
function parse_PtgMemFunc(blob, length, opts) {
	var type = (blob.read_shift(1) >>> 5) & 0x03;
	var cce = blob.read_shift(opts && opts.biff == 2 ? 1 : 2);
	return [type, cce];
}


/* [MS-XLS] 2.5.198.86 ; [MS-XLSB] 2.5.97.69 */
function parse_PtgRefErr(blob, length, opts) {
	var type = (blob.read_shift(1) >>> 5) & 0x03;
	blob.l += 4;
	if(opts.biff < 8) blob.l--;
	if(opts.biff == 12) blob.l += 2;
	return [type];
}

/* [MS-XLS] 2.5.198.87 ; [MS-XLSB] 2.5.97.71 */
function parse_PtgRefErr3d(blob, length, opts) {
	var type = (blob[blob.l++] & 0x60) >> 5;
	var ixti = blob.read_shift(2);
	var w = 4;
	if(opts) switch(opts.biff) {
		case 5: w = 15; break;
		case 12: w = 6; break;
	}
	blob.l += w;
	return [type, ixti];
}

/* [MS-XLS] 2.5.198.71 ; [MS-XLSB] 2.5.97.55 */
var parse_PtgMemErr = parsenoop;
/* [MS-XLS] 2.5.198.73  ; [MS-XLSB] 2.5.97.57 */
var parse_PtgMemNoMem = parsenoop;
/* [MS-XLS] 2.5.198.92 */
var parse_PtgTbl = parsenoop;

function parse_PtgElfLoc(blob, length, opts) {
	blob.l += 2;
	return [parse_RgceElfLoc(blob, 4, opts)];
}
function parse_PtgElfNoop(blob/*::, length, opts*/) {
	blob.l += 6;
	return [];
}
/* [MS-XLS] 2.5.198.46 */
var parse_PtgElfCol = parse_PtgElfLoc;
/* [MS-XLS] 2.5.198.47 */
var parse_PtgElfColS = parse_PtgElfNoop;
/* [MS-XLS] 2.5.198.48 */
var parse_PtgElfColSV = parse_PtgElfNoop;
/* [MS-XLS] 2.5.198.49 */
var parse_PtgElfColV = parse_PtgElfLoc;
/* [MS-XLS] 2.5.198.50 */
function parse_PtgElfLel(blob/*::, length, opts*/) {
	blob.l += 2;
	return [parseuint16(blob), blob.read_shift(2) & 0x01];
}
/* [MS-XLS] 2.5.198.51 */
var parse_PtgElfRadical = parse_PtgElfLoc;
/* [MS-XLS] 2.5.198.52 */
var parse_PtgElfRadicalLel = parse_PtgElfLel;
/* [MS-XLS] 2.5.198.53 */
var parse_PtgElfRadicalS = parse_PtgElfNoop;
/* [MS-XLS] 2.5.198.54 */
var parse_PtgElfRw = parse_PtgElfLoc;
/* [MS-XLS] 2.5.198.55 */
var parse_PtgElfRwV = parse_PtgElfLoc;

/* [MS-XLSB] 2.5.97.52 TODO */
var PtgListRT = [
	"Data",
	"All",
	"Headers",
	"??",
	"?Data2",
	"??",
	"?DataHeaders",
	"??",
	"Totals",
	"??",
	"??",
	"??",
	"?DataTotals",
	"??",
	"??",
	"??",
	"?Current"
];
function parse_PtgList(blob/*::, length, opts*/) {
	blob.l += 2;
	var ixti = blob.read_shift(2);
	var flags = blob.read_shift(2);
	var idx = blob.read_shift(4);
	var c = blob.read_shift(2);
	var C = blob.read_shift(2);
	var rt = PtgListRT[(flags >> 2) & 0x1F];
	return {ixti: ixti, coltype:(flags&0x3), rt:rt, idx:idx, c:c, C:C};
}
/* [MS-XLS] 2.5.198.91 ; [MS-XLSB] 2.5.97.76 */
function parse_PtgSxName(blob/*::, length, opts*/) {
	blob.l += 2;
	return [blob.read_shift(4)];
}

/* [XLS] old spec */
function parse_PtgSheet(blob, length, opts) {
	blob.l += 5;
	blob.l += 2;
	blob.l += (opts.biff == 2 ? 1 : 4);
	return ["PTGSHEET"];
}
function parse_PtgEndSheet(blob, length, opts) {
	blob.l += (opts.biff == 2 ? 4 : 5);
	return ["PTGENDSHEET"];
}
function parse_PtgMemAreaN(blob/*::, length, opts*/) {
	var type = (blob.read_shift(1) >>> 5) & 0x03;
	var cce = blob.read_shift(2);
	return [type, cce];
}
function parse_PtgMemNoMemN(blob/*::, length, opts*/) {
	var type = (blob.read_shift(1) >>> 5) & 0x03;
	var cce = blob.read_shift(2);
	return [type, cce];
}
function parse_PtgAttrNoop(blob/*::, length, opts*/) {
	blob.l += 4;
	return [0, 0];
}

/* [MS-XLS] 2.5.198.25 ; [MS-XLSB] 2.5.97.16 */
var PtgTypes = {
	/*::[*/0x01/*::]*/: { n:'PtgExp', f:parse_PtgExp },
	/*::[*/0x02/*::]*/: { n:'PtgTbl', f:parse_PtgTbl },
	/*::[*/0x03/*::]*/: { n:'PtgAdd', f:parseread1 },
	/*::[*/0x04/*::]*/: { n:'PtgSub', f:parseread1 },
	/*::[*/0x05/*::]*/: { n:'PtgMul', f:parseread1 },
	/*::[*/0x06/*::]*/: { n:'PtgDiv', f:parseread1 },
	/*::[*/0x07/*::]*/: { n:'PtgPower', f:parseread1 },
	/*::[*/0x08/*::]*/: { n:'PtgConcat', f:parseread1 },
	/*::[*/0x09/*::]*/: { n:'PtgLt', f:parseread1 },
	/*::[*/0x0A/*::]*/: { n:'PtgLe', f:parseread1 },
	/*::[*/0x0B/*::]*/: { n:'PtgEq', f:parseread1 },
	/*::[*/0x0C/*::]*/: { n:'PtgGe', f:parseread1 },
	/*::[*/0x0D/*::]*/: { n:'PtgGt', f:parseread1 },
	/*::[*/0x0E/*::]*/: { n:'PtgNe', f:parseread1 },
	/*::[*/0x0F/*::]*/: { n:'PtgIsect', f:parseread1 },
	/*::[*/0x10/*::]*/: { n:'PtgUnion', f:parseread1 },
	/*::[*/0x11/*::]*/: { n:'PtgRange', f:parseread1 },
	/*::[*/0x12/*::]*/: { n:'PtgUplus', f:parseread1 },
	/*::[*/0x13/*::]*/: { n:'PtgUminus', f:parseread1 },
	/*::[*/0x14/*::]*/: { n:'PtgPercent', f:parseread1 },
	/*::[*/0x15/*::]*/: { n:'PtgParen', f:parseread1 },
	/*::[*/0x16/*::]*/: { n:'PtgMissArg', f:parseread1 },
	/*::[*/0x17/*::]*/: { n:'PtgStr', f:parse_PtgStr },
	/*::[*/0x1A/*::]*/: { n:'PtgSheet', f:parse_PtgSheet },
	/*::[*/0x1B/*::]*/: { n:'PtgEndSheet', f:parse_PtgEndSheet },
	/*::[*/0x1C/*::]*/: { n:'PtgErr', f:parse_PtgErr },
	/*::[*/0x1D/*::]*/: { n:'PtgBool', f:parse_PtgBool },
	/*::[*/0x1E/*::]*/: { n:'PtgInt', f:parse_PtgInt },
	/*::[*/0x1F/*::]*/: { n:'PtgNum', f:parse_PtgNum },
	/*::[*/0x20/*::]*/: { n:'PtgArray', f:parse_PtgArray },
	/*::[*/0x21/*::]*/: { n:'PtgFunc', f:parse_PtgFunc },
	/*::[*/0x22/*::]*/: { n:'PtgFuncVar', f:parse_PtgFuncVar },
	/*::[*/0x23/*::]*/: { n:'PtgName', f:parse_PtgName },
	/*::[*/0x24/*::]*/: { n:'PtgRef', f:parse_PtgRef },
	/*::[*/0x25/*::]*/: { n:'PtgArea', f:parse_PtgArea },
	/*::[*/0x26/*::]*/: { n:'PtgMemArea', f:parse_PtgMemArea },
	/*::[*/0x27/*::]*/: { n:'PtgMemErr', f:parse_PtgMemErr },
	/*::[*/0x28/*::]*/: { n:'PtgMemNoMem', f:parse_PtgMemNoMem },
	/*::[*/0x29/*::]*/: { n:'PtgMemFunc', f:parse_PtgMemFunc },
	/*::[*/0x2A/*::]*/: { n:'PtgRefErr', f:parse_PtgRefErr },
	/*::[*/0x2B/*::]*/: { n:'PtgAreaErr', f:parse_PtgAreaErr },
	/*::[*/0x2C/*::]*/: { n:'PtgRefN', f:parse_PtgRefN },
	/*::[*/0x2D/*::]*/: { n:'PtgAreaN', f:parse_PtgAreaN },
	/*::[*/0x2E/*::]*/: { n:'PtgMemAreaN', f:parse_PtgMemAreaN },
	/*::[*/0x2F/*::]*/: { n:'PtgMemNoMemN', f:parse_PtgMemNoMemN },
	/*::[*/0x39/*::]*/: { n:'PtgNameX', f:parse_PtgNameX },
	/*::[*/0x3A/*::]*/: { n:'PtgRef3d', f:parse_PtgRef3d },
	/*::[*/0x3B/*::]*/: { n:'PtgArea3d', f:parse_PtgArea3d },
	/*::[*/0x3C/*::]*/: { n:'PtgRefErr3d', f:parse_PtgRefErr3d },
	/*::[*/0x3D/*::]*/: { n:'PtgAreaErr3d', f:parse_PtgAreaErr3d },
	/*::[*/0xFF/*::]*/: {}
};
/* These are duplicated in the PtgTypes table */
var PtgDupes = {
	/*::[*/0x40/*::]*/: 0x20, /*::[*/0x60/*::]*/: 0x20,
	/*::[*/0x41/*::]*/: 0x21, /*::[*/0x61/*::]*/: 0x21,
	/*::[*/0x42/*::]*/: 0x22, /*::[*/0x62/*::]*/: 0x22,
	/*::[*/0x43/*::]*/: 0x23, /*::[*/0x63/*::]*/: 0x23,
	/*::[*/0x44/*::]*/: 0x24, /*::[*/0x64/*::]*/: 0x24,
	/*::[*/0x45/*::]*/: 0x25, /*::[*/0x65/*::]*/: 0x25,
	/*::[*/0x46/*::]*/: 0x26, /*::[*/0x66/*::]*/: 0x26,
	/*::[*/0x47/*::]*/: 0x27, /*::[*/0x67/*::]*/: 0x27,
	/*::[*/0x48/*::]*/: 0x28, /*::[*/0x68/*::]*/: 0x28,
	/*::[*/0x49/*::]*/: 0x29, /*::[*/0x69/*::]*/: 0x29,
	/*::[*/0x4A/*::]*/: 0x2A, /*::[*/0x6A/*::]*/: 0x2A,
	/*::[*/0x4B/*::]*/: 0x2B, /*::[*/0x6B/*::]*/: 0x2B,
	/*::[*/0x4C/*::]*/: 0x2C, /*::[*/0x6C/*::]*/: 0x2C,
	/*::[*/0x4D/*::]*/: 0x2D, /*::[*/0x6D/*::]*/: 0x2D,
	/*::[*/0x4E/*::]*/: 0x2E, /*::[*/0x6E/*::]*/: 0x2E,
	/*::[*/0x4F/*::]*/: 0x2F, /*::[*/0x6F/*::]*/: 0x2F,
	/*::[*/0x58/*::]*/: 0x22, /*::[*/0x78/*::]*/: 0x22,
	/*::[*/0x59/*::]*/: 0x39, /*::[*/0x79/*::]*/: 0x39,
	/*::[*/0x5A/*::]*/: 0x3A, /*::[*/0x7A/*::]*/: 0x3A,
	/*::[*/0x5B/*::]*/: 0x3B, /*::[*/0x7B/*::]*/: 0x3B,
	/*::[*/0x5C/*::]*/: 0x3C, /*::[*/0x7C/*::]*/: 0x3C,
	/*::[*/0x5D/*::]*/: 0x3D, /*::[*/0x7D/*::]*/: 0x3D
};

var Ptg18 = {
	/*::[*/0x01/*::]*/: { n:'PtgElfLel', f:parse_PtgElfLel },
	/*::[*/0x02/*::]*/: { n:'PtgElfRw', f:parse_PtgElfRw },
	/*::[*/0x03/*::]*/: { n:'PtgElfCol', f:parse_PtgElfCol },
	/*::[*/0x06/*::]*/: { n:'PtgElfRwV', f:parse_PtgElfRwV },
	/*::[*/0x07/*::]*/: { n:'PtgElfColV', f:parse_PtgElfColV },
	/*::[*/0x0A/*::]*/: { n:'PtgElfRadical', f:parse_PtgElfRadical },
	/*::[*/0x0B/*::]*/: { n:'PtgElfRadicalS', f:parse_PtgElfRadicalS },
	/*::[*/0x0D/*::]*/: { n:'PtgElfColS', f:parse_PtgElfColS },
	/*::[*/0x0F/*::]*/: { n:'PtgElfColSV', f:parse_PtgElfColSV },
	/*::[*/0x10/*::]*/: { n:'PtgElfRadicalLel', f:parse_PtgElfRadicalLel },
	/*::[*/0x19/*::]*/: { n:'PtgList', f:parse_PtgList },
	/*::[*/0x1D/*::]*/: { n:'PtgSxName', f:parse_PtgSxName },
	/*::[*/0xFF/*::]*/: {}
};
var Ptg19 = {
	/*::[*/0x00/*::]*/: { n:'PtgAttrNoop', f:parse_PtgAttrNoop },
	/*::[*/0x01/*::]*/: { n:'PtgAttrSemi', f:parse_PtgAttrSemi },
	/*::[*/0x02/*::]*/: { n:'PtgAttrIf', f:parse_PtgAttrIf },
	/*::[*/0x04/*::]*/: { n:'PtgAttrChoose', f:parse_PtgAttrChoose },
	/*::[*/0x08/*::]*/: { n:'PtgAttrGoto', f:parse_PtgAttrGoto },
	/*::[*/0x10/*::]*/: { n:'PtgAttrSum', f:parse_PtgAttrSum },
	/*::[*/0x20/*::]*/: { n:'PtgAttrBaxcel', f:parse_PtgAttrBaxcel },
	/*::[*/0x21/*::]*/: { n:'PtgAttrBaxcel', f:parse_PtgAttrBaxcel },
	/*::[*/0x40/*::]*/: { n:'PtgAttrSpace', f:parse_PtgAttrSpace },
	/*::[*/0x41/*::]*/: { n:'PtgAttrSpaceSemi', f:parse_PtgAttrSpaceSemi },
	/*::[*/0x80/*::]*/: { n:'PtgAttrIfError', f:parse_PtgAttrIfError },
	/*::[*/0xFF/*::]*/: {}
};

/* [MS-XLS] 2.5.198.103 ; [MS-XLSB] 2.5.97.87 */
function parse_RgbExtra(blob, length, rgce, opts) {
	if(opts.biff < 8) return parsenoop(blob, length);
	var target = blob.l + length;
	var o = [];
	for(var i = 0; i !== rgce.length; ++i) {
		switch(rgce[i][0]) {
			case 'PtgArray': /* PtgArray -> PtgExtraArray */
				rgce[i][1] = parse_PtgExtraArray(blob, 0, opts);
				o.push(rgce[i][1]);
				break;
			case 'PtgMemArea': /* PtgMemArea -> PtgExtraMem */
				rgce[i][2] = parse_PtgExtraMem(blob, rgce[i][1], opts);
				o.push(rgce[i][2]);
				break;
			case 'PtgExp': /* PtgExp -> PtgExtraCol */
				if(opts && opts.biff == 12) {
					rgce[i][1][1] = blob.read_shift(4);
					o.push(rgce[i][1]);
				} break;
			case 'PtgList': /* TODO: PtgList -> PtgExtraList */
			case 'PtgElfRadicalS': /* TODO: PtgElfRadicalS -> PtgExtraElf */
			case 'PtgElfColS': /* TODO: PtgElfColS -> PtgExtraElf */
			case 'PtgElfColSV': /* TODO: PtgElfColSV -> PtgExtraElf */
				throw "Unsupported " + rgce[i][0];
			default: break;
		}
	}
	length = target - blob.l;
	/* note: this is technically an error but Excel disregards */
	//if(target !== blob.l && blob.l !== target - length) throw new Error(target + " != " + blob.l);
	if(length !== 0) o.push(parsenoop(blob, length));
	return o;
}

/* [MS-XLS] 2.5.198.104 ; [MS-XLSB] 2.5.97.88 */
function parse_Rgce(blob, length, opts) {
	var target = blob.l + length;
	var R, id, ptgs = [];
	while(target != blob.l) {
		length = target - blob.l;
		id = blob[blob.l];
		R = PtgTypes[id] || PtgTypes[PtgDupes[id]];
		if(id === 0x18 || id === 0x19) R = (id === 0x18 ? Ptg18 : Ptg19)[blob[blob.l + 1]];
		if(!R || !R.f) { /*ptgs.push*/(parsenoop(blob, length)); }
		else { ptgs.push([R.n, R.f(blob, length, opts)]); }
	}
	return ptgs;
}

function stringify_array(f/*:Array<Array<string>>*/)/*:string*/ {
	var o/*:Array<string>*/ = [];
	for(var i = 0; i < f.length; ++i) {
		var x = f[i], r/*:Array<string>*/ = [];
		for(var j = 0; j < x.length; ++j) {
			var y = x[j];
			if(y) switch(y[0]) {
				// TODO: handle embedded quotes
				case 0x02:
					/*:: if(typeof y[1] != 'string') throw "unreachable"; */
					r.push('"' + y[1].replace(/"/g,'""') + '"'); break;
				default: r.push(y[1]);
			} else r.push("");
		}
		o.push(r.join(","));
	}
	return o.join(";");
}

/* [MS-XLS] 2.2.2 ; [MS-XLSB] 2.2.2 TODO */
var PtgBinOp = {
	PtgAdd: "+",
	PtgConcat: "&",
	PtgDiv: "/",
	PtgEq: "=",
	PtgGe: ">=",
	PtgGt: ">",
	PtgLe: "<=",
	PtgLt: "<",
	PtgMul: "*",
	PtgNe: "<>",
	PtgPower: "^",
	PtgSub: "-"
};

// List of invalid characters needs to be tested further
function formula_quote_sheet_name(sname/*:string*/, opts)/*:string*/ {
	if(!sname && !(opts && opts.biff <= 5 && opts.biff >= 2)) throw new Error("empty sheet name");
	if (/[^\w\u4E00-\u9FFF\u3040-\u30FF]/.test(sname)) return "'" + sname + "'";
	return sname;
}
function get_ixti_raw(supbooks, ixti/*:number*/, opts)/*:string*/ {
	if(!supbooks) return "SH33TJSERR0";
	if(opts.biff > 8 && (!supbooks.XTI || !supbooks.XTI[ixti])) return supbooks.SheetNames[ixti];
	if(!supbooks.XTI) return "SH33TJSERR6";
	var XTI = supbooks.XTI[ixti];
	if(opts.biff < 8) {
		if(ixti > 10000) ixti-= 65536;
		if(ixti < 0) ixti = -ixti;
		return ixti == 0 ? "" : supbooks.XTI[ixti - 1];
	}
	if(!XTI) return "SH33TJSERR1";
	var o = "";
	if(opts.biff > 8) switch(supbooks[XTI[0]][0]) {
		case 0x0165: /* 'BrtSupSelf' */
			o = XTI[1] == -1 ? "#REF" : supbooks.SheetNames[XTI[1]];
			return XTI[1] == XTI[2] ? o : o + ":" + supbooks.SheetNames[XTI[2]];
		case 0x0166: /* 'BrtSupSame' */
			if(opts.SID != null) return supbooks.SheetNames[opts.SID];
			return "SH33TJSSAME" + supbooks[XTI[0]][0];
		case 0x0163: /* 'BrtSupBookSrc' */
			/* falls through */
		default: return "SH33TJSSRC" + supbooks[XTI[0]][0];
	}
	switch(supbooks[XTI[0]][0][0]) {
		case 0x0401:
			o = XTI[1] == -1 ? "#REF" : (supbooks.SheetNames[XTI[1]] || "SH33TJSERR3");
			return XTI[1] == XTI[2] ? o : o + ":" + supbooks.SheetNames[XTI[2]];
		case 0x3A01: return supbooks[XTI[0]].slice(1).map(function(name) { return name.Name; }).join(";;"); //return "SH33TJSERR8";
		default:
			if(!supbooks[XTI[0]][0][3]) return "SH33TJSERR2";
			o = XTI[1] == -1 ? "#REF" : (supbooks[XTI[0]][0][3][XTI[1]] || "SH33TJSERR4");
			return XTI[1] == XTI[2] ? o : o + ":" + supbooks[XTI[0]][0][3][XTI[2]];
	}
}
function get_ixti(supbooks, ixti/*:number*/, opts)/*:string*/ {
	var ixtiraw = get_ixti_raw(supbooks, ixti, opts);
	return ixtiraw == "#REF" ? ixtiraw : formula_quote_sheet_name(ixtiraw, opts);
}
function stringify_formula(formula/*Array<any>*/, range, cell/*:any*/, supbooks, opts)/*:string*/ {
	var biff = (opts && opts.biff) || 8;
	var _range = /*range != null ? range :*/ {s:{c:0, r:0},e:{c:0, r:0}};
	var stack/*:Array<string>*/ = [], e1, e2, /*::type,*/ c/*:CellAddress*/, ixti=0, nameidx=0, r, sname="";
	if(!formula[0] || !formula[0][0]) return "";
	var last_sp = -1, sp = "";
	for(var ff = 0, fflen = formula[0].length; ff < fflen; ++ff) {
		var f = formula[0][ff];
		switch(f[0]) {
			case 'PtgUminus': /* [MS-XLS] 2.5.198.93 */
				stack.push("-" + stack.pop()); break;
			case 'PtgUplus': /* [MS-XLS] 2.5.198.95 */
				stack.push("+" + stack.pop()); break;
			case 'PtgPercent': /* [MS-XLS] 2.5.198.81 */
				stack.push(stack.pop() + "%"); break;

			case 'PtgAdd':    /* [MS-XLS] 2.5.198.26 */
			case 'PtgConcat': /* [MS-XLS] 2.5.198.43 */
			case 'PtgDiv':    /* [MS-XLS] 2.5.198.45 */
			case 'PtgEq':     /* [MS-XLS] 2.5.198.56 */
			case 'PtgGe':     /* [MS-XLS] 2.5.198.64 */
			case 'PtgGt':     /* [MS-XLS] 2.5.198.65 */
			case 'PtgLe':     /* [MS-XLS] 2.5.198.68 */
			case 'PtgLt':     /* [MS-XLS] 2.5.198.69 */
			case 'PtgMul':    /* [MS-XLS] 2.5.198.75 */
			case 'PtgNe':     /* [MS-XLS] 2.5.198.78 */
			case 'PtgPower':  /* [MS-XLS] 2.5.198.82 */
			case 'PtgSub':    /* [MS-XLS] 2.5.198.90 */
				e1 = stack.pop(); e2 = stack.pop();
				if(last_sp >= 0) {
					switch(formula[0][last_sp][1][0]) {
						case 0:
							// $FlowIgnore
							sp = fill(" ", formula[0][last_sp][1][1]); break;
						case 1:
							// $FlowIgnore
							sp = fill("\r", formula[0][last_sp][1][1]); break;
						default:
							sp = "";
							// $FlowIgnore
							if(opts.WTF) throw new Error("Unexpected PtgAttrSpaceType " + formula[0][last_sp][1][0]);
					}
					e2 = e2 + sp;
					last_sp = -1;
				}
				stack.push(e2+PtgBinOp[f[0]]+e1);
				break;

			case 'PtgIsect': /* [MS-XLS] 2.5.198.67 */
				e1 = stack.pop(); e2 = stack.pop();
				stack.push(e2+" "+e1);
				break;
			case 'PtgUnion': /* [MS-XLS] 2.5.198.94 */
				e1 = stack.pop(); e2 = stack.pop();
				stack.push(e2+","+e1);
				break;
			case 'PtgRange': /* [MS-XLS] 2.5.198.83 */
				e1 = stack.pop(); e2 = stack.pop();
				stack.push(e2+":"+e1);
				break;

			case 'PtgAttrChoose': /* [MS-XLS] 2.5.198.34 */
				break;
			case 'PtgAttrGoto': /* [MS-XLS] 2.5.198.35 */
				break;
			case 'PtgAttrIf': /* [MS-XLS] 2.5.198.36 */
				break;
			case 'PtgAttrIfError': /* [MS-XLSB] 2.5.97.28 */
				break;


			case 'PtgRef': /* [MS-XLS] 2.5.198.84 */
				/*::type = f[1][0]; */c = shift_cell_xls((f[1][1]/*:any*/), _range, opts);
				stack.push(encode_cell_xls(c, biff));
				break;
			case 'PtgRefN': /* [MS-XLS] 2.5.198.88 */
				/*::type = f[1][0]; */c = cell ? shift_cell_xls((f[1][1]/*:any*/), cell, opts) : (f[1][1]/*:any*/);
				stack.push(encode_cell_xls(c, biff));
				break;
			case 'PtgRef3d': /* [MS-XLS] 2.5.198.85 */
				/*::type = f[1][0]; */ixti = /*::Number(*/f[1][1]/*::)*/; c = shift_cell_xls((f[1][2]/*:any*/), _range, opts);
				sname = get_ixti(supbooks, ixti, opts);
				var w = sname; /* IE9 fails on defined names */ // eslint-disable-line no-unused-vars
				stack.push(sname + "!" + encode_cell_xls(c, biff));
				break;

			case 'PtgFunc': /* [MS-XLS] 2.5.198.62 */
			case 'PtgFuncVar': /* [MS-XLS] 2.5.198.63 */
				/* f[1] = [argc, func, type] */
				var argc/*:number*/ = (f[1][0]/*:any*/), func/*:string*/ = (f[1][1]/*:any*/);
				if(!argc) argc = 0;
				argc &= 0x7F;
				var args = argc == 0 ? [] : stack.slice(-argc);
				stack.length -= argc;
				if(func === 'User') func = args.shift();
				stack.push(func + "(" + args.join(",") + ")");
				break;

			case 'PtgBool': /* [MS-XLS] 2.5.198.42 */
				stack.push(f[1] ? "TRUE" : "FALSE"); break;
			case 'PtgInt': /* [MS-XLS] 2.5.198.66 */
				stack.push(/*::String(*/f[1]/*::)*/); break;
			case 'PtgNum': /* [MS-XLS] 2.5.198.79 TODO: precision? */
				stack.push(String(f[1])); break;
			case 'PtgStr': /* [MS-XLS] 2.5.198.89 */
				// $FlowIgnore
				stack.push('"' + f[1].replace(/"/g, '""') + '"'); break;
			case 'PtgErr': /* [MS-XLS] 2.5.198.57 */
				stack.push(/*::String(*/f[1]/*::)*/); break;
			case 'PtgAreaN': /* [MS-XLS] 2.5.198.31 TODO */
				/*::type = f[1][0]; */r = shift_range_xls(f[1][1], cell ? {s:cell} : _range, opts);
				stack.push(encode_range_xls((r/*:any*/), opts));
				break;
			case 'PtgArea': /* [MS-XLS] 2.5.198.27 TODO: fixed points */
				/*::type = f[1][0]; */r = shift_range_xls(f[1][1], _range, opts);
				stack.push(encode_range_xls((r/*:any*/), opts));
				break;
			case 'PtgArea3d': /* [MS-XLS] 2.5.198.28 TODO */
				/*::type = f[1][0]; */ixti = /*::Number(*/f[1][1]/*::)*/; r = f[1][2];
				sname = get_ixti(supbooks, ixti, opts);
				stack.push(sname + "!" + encode_range_xls((r/*:any*/), opts));
				break;
			case 'PtgAttrSum': /* [MS-XLS] 2.5.198.41 */
				stack.push("SUM(" + stack.pop() + ")");
				break;

			case 'PtgAttrBaxcel': /* [MS-XLS] 2.5.198.33 */
			case 'PtgAttrSemi': /* [MS-XLS] 2.5.198.37 */
				break;

			case 'PtgName': /* [MS-XLS] 2.5.198.76 ; [MS-XLSB] 2.5.97.60 TODO: revisions */
				/* f[1] = type, 0, nameindex */
				nameidx = (f[1][2]/*:any*/);
				var lbl = (supbooks.names||[])[nameidx-1] || (supbooks[0]||[])[nameidx];
				var name = lbl ? lbl.Name : "SH33TJSNAME" + String(nameidx);
				/* [MS-XLSB] 2.5.97.10 Ftab -- last verified 20220204 */
				if(name && name.slice(0,6) == "_xlfn." && !opts.xlfn) name = name.slice(6);
				stack.push(name);
				break;

			case 'PtgNameX': /* [MS-XLS] 2.5.198.77 ; [MS-XLSB] 2.5.97.61 TODO: revisions */
				/* f[1] = type, ixti, nameindex */
				var bookidx/*:number*/ = (f[1][1]/*:any*/); nameidx = (f[1][2]/*:any*/); var externbook;
				/* TODO: Properly handle missing values -- this should be using get_ixti_raw primarily */
				if(opts.biff <= 5) {
					if(bookidx < 0) bookidx = -bookidx;
					if(supbooks[bookidx]) externbook = supbooks[bookidx][nameidx];
				} else {
					var o = "";
					if(((supbooks[bookidx]||[])[0]||[])[0] == 0x3A01){/* empty */}
					else if(((supbooks[bookidx]||[])[0]||[])[0] == 0x0401){
						if(supbooks[bookidx][nameidx] && supbooks[bookidx][nameidx].itab > 0) {
							o = supbooks.SheetNames[supbooks[bookidx][nameidx].itab-1] + "!";
						}
					}
					else o = supbooks.SheetNames[nameidx-1]+ "!";
					if(supbooks[bookidx] && supbooks[bookidx][nameidx]) o += supbooks[bookidx][nameidx].Name;
					else if(supbooks[0] && supbooks[0][nameidx]) o += supbooks[0][nameidx].Name;
					else {
						var ixtidata = (get_ixti_raw(supbooks, bookidx, opts)||"").split(";;");
						if(ixtidata[nameidx - 1]) o = ixtidata[nameidx - 1]; // TODO: confirm this is correct
						else o += "SH33TJSERRX";
					}
					stack.push(o);
					break;
				}
				if(!externbook) externbook = {Name: "SH33TJSERRY"};
				stack.push(externbook.Name);
				break;

			case 'PtgParen': /* [MS-XLS] 2.5.198.80 */
				var lp = '(', rp = ')';
				if(last_sp >= 0) {
					sp = "";
					switch(formula[0][last_sp][1][0]) {
						// $FlowIgnore
						case 2: lp = fill(" ", formula[0][last_sp][1][1]) + lp; break;
						// $FlowIgnore
						case 3: lp = fill("\r", formula[0][last_sp][1][1]) + lp; break;
						// $FlowIgnore
						case 4: rp = fill(" ", formula[0][last_sp][1][1]) + rp; break;
						// $FlowIgnore
						case 5: rp = fill("\r", formula[0][last_sp][1][1]) + rp; break;
						default:
							// $FlowIgnore
							if(opts.WTF) throw new Error("Unexpected PtgAttrSpaceType " + formula[0][last_sp][1][0]);
					}
					last_sp = -1;
				}
				stack.push(lp + stack.pop() + rp); break;

			case 'PtgRefErr': /* [MS-XLS] 2.5.198.86 */
				stack.push('#REF!'); break;

			case 'PtgRefErr3d': /* [MS-XLS] 2.5.198.87 */
				stack.push('#REF!'); break;

			case 'PtgExp': /* [MS-XLS] 2.5.198.58 TODO */
				c = {c:(f[1][1]/*:any*/),r:(f[1][0]/*:any*/)};
				var q = ({c: cell.c, r:cell.r}/*:any*/);
				if(supbooks.sharedf[encode_cell(c)]) {
					var parsedf = (supbooks.sharedf[encode_cell(c)]);
					stack.push(stringify_formula(parsedf, _range, q, supbooks, opts));
				} else {
					var fnd = false;
					for(e1=0;e1!=supbooks.arrayf.length; ++e1) {
						/* TODO: should be something like range_has */
						e2 = supbooks.arrayf[e1];
						if(c.c < e2[0].s.c || c.c > e2[0].e.c) continue;
						if(c.r < e2[0].s.r || c.r > e2[0].e.r) continue;
						stack.push(stringify_formula(e2[1], _range, q, supbooks, opts));
						fnd = true;
						break;
					}
					if(!fnd) stack.push(/*::String(*/f[1]/*::)*/);
				}
				break;

			case 'PtgArray': /* [MS-XLS] 2.5.198.32 TODO */
				stack.push("{" + stringify_array(/*::(*/f[1]/*:: :any)*/) + "}");
				break;

			case 'PtgMemArea': /* [MS-XLS] 2.5.198.70 TODO: confirm this is a non-display */
				//stack.push("(" + f[2].map(encode_range).join(",") + ")");
				break;

			case 'PtgAttrSpace': /* [MS-XLS] 2.5.198.38 */
			case 'PtgAttrSpaceSemi': /* [MS-XLS] 2.5.198.39 */
				last_sp = ff;
				break;

			case 'PtgTbl': /* [MS-XLS] 2.5.198.92 TODO */
				break;

			case 'PtgMemErr': /* [MS-XLS] 2.5.198.71 */
				break;

			case 'PtgMissArg': /* [MS-XLS] 2.5.198.74 */
				stack.push("");
				break;

			case 'PtgAreaErr': /* [MS-XLS] 2.5.198.29 */
				stack.push("#REF!"); break;

			case 'PtgAreaErr3d': /* [MS-XLS] 2.5.198.30 */
				stack.push("#REF!"); break;

			case 'PtgList': /* [MS-XLSB] 2.5.97.52 */
				// $FlowIgnore
				stack.push("Table" + f[1].idx + "[#" + f[1].rt + "]");
				break;

			case 'PtgMemAreaN':
			case 'PtgMemNoMemN':
			case 'PtgAttrNoop':
			case 'PtgSheet':
			case 'PtgEndSheet':
				break;

			case 'PtgMemFunc': /* [MS-XLS] 2.5.198.72 TODO */
				break;
			case 'PtgMemNoMem': /* [MS-XLS] 2.5.198.73 TODO */
				break;

			case 'PtgElfCol': /* [MS-XLS] 2.5.198.46 */
			case 'PtgElfColS': /* [MS-XLS] 2.5.198.47 */
			case 'PtgElfColSV': /* [MS-XLS] 2.5.198.48 */
			case 'PtgElfColV': /* [MS-XLS] 2.5.198.49 */
			case 'PtgElfLel': /* [MS-XLS] 2.5.198.50 */
			case 'PtgElfRadical': /* [MS-XLS] 2.5.198.51 */
			case 'PtgElfRadicalLel': /* [MS-XLS] 2.5.198.52 */
			case 'PtgElfRadicalS': /* [MS-XLS] 2.5.198.53 */
			case 'PtgElfRw': /* [MS-XLS] 2.5.198.54 */
			case 'PtgElfRwV': /* [MS-XLS] 2.5.198.55 */
				throw new Error("Unsupported ELFs");

			case 'PtgSxName': /* [MS-XLS] 2.5.198.91 TODO -- find a test case */
				throw new Error('Unrecognized Formula Token: ' + String(f));
			default: throw new Error('Unrecognized Formula Token: ' + String(f));
		}
		var PtgNonDisp = ['PtgAttrSpace', 'PtgAttrSpaceSemi', 'PtgAttrGoto'];
		if(opts.biff != 3) if(last_sp >= 0 && PtgNonDisp.indexOf(formula[0][ff][0]) == -1) {
			f = formula[0][last_sp];
			var _left = true;
			switch(f[1][0]) {
				/* note: some bad XLSB files omit the PtgParen */
				case 4: _left = false;
				/* falls through */
				case 0:
					// $FlowIgnore
					sp = fill(" ", f[1][1]); break;
				case 5: _left = false;
				/* falls through */
				case 1:
					// $FlowIgnore
					sp = fill("\r", f[1][1]); break;
				default:
					sp = "";
					// $FlowIgnore
					if(opts.WTF) throw new Error("Unexpected PtgAttrSpaceType " + f[1][0]);
			}
			stack.push((_left ? sp : "") + stack.pop() + (_left ? "" : sp));
			last_sp = -1;
		}
	}
	if(stack.length > 1 && opts.WTF) throw new Error("bad formula stack");
	return stack[0];
}

/* [MS-XLS] 2.5.198.1 TODO */
function parse_ArrayParsedFormula(blob, length, opts/*::, ref*/) {
	var target = blob.l + length, len = opts.biff == 2 ? 1 : 2;
	var rgcb, cce = blob.read_shift(len); // length of rgce
	if(cce == 0xFFFF) return [[],parsenoop(blob, length-2)];
	var rgce = parse_Rgce(blob, cce, opts);
	if(length !== cce + len) rgcb = parse_RgbExtra(blob, length - cce - len, rgce, opts);
	blob.l = target;
	return [rgce, rgcb];
}

/* [MS-XLS] 2.5.198.3 TODO */
function parse_XLSCellParsedFormula(blob, length, opts) {
	var target = blob.l + length, len = opts.biff == 2 ? 1 : 2;
	var rgcb, cce = blob.read_shift(len); // length of rgce
	if(cce == 0xFFFF) return [[],parsenoop(blob, length-2)];
	var rgce = parse_Rgce(blob, cce, opts);
	if(length !== cce + len) rgcb = parse_RgbExtra(blob, length - cce - len, rgce, opts);
	blob.l = target;
	return [rgce, rgcb];
}

/* [MS-XLS] 2.5.198.21 */
function parse_NameParsedFormula(blob, length, opts, cce) {
	var target = blob.l + length;
	var rgce = parse_Rgce(blob, cce, opts);
	var rgcb;
	if(target !== blob.l) rgcb = parse_RgbExtra(blob, target - blob.l, rgce, opts);
	return [rgce, rgcb];
}

/* [MS-XLS] 2.5.198.118 TODO */
function parse_SharedParsedFormula(blob, length, opts) {
	var target = blob.l + length;
	var rgcb, cce = blob.read_shift(2); // length of rgce
	var rgce = parse_Rgce(blob, cce, opts);
	if(cce == 0xFFFF) return [[],parsenoop(blob, length-2)];
	if(length !== cce + 2) rgcb = parse_RgbExtra(blob, target - cce - 2, rgce, opts);
	return [rgce, rgcb];
}

/* [MS-XLS] 2.5.133 TODO: how to emit empty strings? */
function parse_FormulaValue(blob/*::, length*/) {
	var b;
	if(__readUInt16LE(blob,blob.l + 6) !== 0xFFFF) return [parse_Xnum(blob),'n'];
	switch(blob[blob.l]) {
		case 0x00: blob.l += 8; return ["String", 's'];
		case 0x01: b = blob[blob.l+2] === 0x1; blob.l += 8; return [b,'b'];
		case 0x02: b = blob[blob.l+2]; blob.l += 8; return [b,'e'];
		case 0x03: blob.l += 8; return ["",'s'];
	}
	return [];
}
function write_FormulaValue(value) {
	if(value == null) {
		// Blank String Value
		var o = new_buf(8);
		o.write_shift(1, 0x03);
		o.write_shift(1, 0);
		o.write_shift(2, 0);
		o.write_shift(2, 0);
		o.write_shift(2, 0xFFFF);
		return o;
	} else if(typeof value == "number") return write_Xnum(value);
	return write_Xnum(0);
}

/* [MS-XLS] 2.4.127 TODO */
function parse_Formula(blob, length, opts) {
	var end = blob.l + length;
	var cell = parse_XLSCell(blob, 6);
	if(opts.biff == 2) ++blob.l;
	var val = parse_FormulaValue(blob,8);
	var flags = blob.read_shift(1);
	if(opts.biff != 2) {
		blob.read_shift(1);
		if(opts.biff >= 5) {
			/*var chn = */blob.read_shift(4);
		}
	}
	var cbf = parse_XLSCellParsedFormula(blob, end - blob.l, opts);
	return {cell:cell, val:val[0], formula:cbf, shared: (flags >> 3) & 1, tt:val[1]};
}
function write_Formula(cell/*:Cell*/, R/*:number*/, C/*:number*/, opts, os/*:number*/) {
	// Cell
	var o1 = write_XLSCell(R, C, os);

	// FormulaValue
	var o2 = write_FormulaValue(cell.v);

	// flags + cache
	var o3 = new_buf(6);
	var flags = 0x01 | 0x20;
	o3.write_shift(2, flags);
	o3.write_shift(4, 0);

	// CellParsedFormula
	var bf = new_buf(cell.bf.length);
	for(var i = 0; i < cell.bf.length; ++i) bf[i] = cell.bf[i];

	var out = bconcat([o1, o2, o3, bf]);
	return out;
}


/* XLSB Parsed Formula records have the same shape */
function parse_XLSBParsedFormula(data, length, opts) {
	var cce = data.read_shift(4);
	var rgce = parse_Rgce(data, cce, opts);
	var cb = data.read_shift(4);
	var rgcb = cb > 0 ? parse_RgbExtra(data, cb, rgce, opts) : null;
	return [rgce, rgcb];
}

/* [MS-XLSB] 2.5.97.1 ArrayParsedFormula */
var parse_XLSBArrayParsedFormula = parse_XLSBParsedFormula;
/* [MS-XLSB] 2.5.97.4 CellParsedFormula */
var parse_XLSBCellParsedFormula = parse_XLSBParsedFormula;
/* [MS-XLSB] 2.5.97.8 DVParsedFormula */
//var parse_XLSBDVParsedFormula = parse_XLSBParsedFormula;
/* [MS-XLSB] 2.5.97.9 FRTParsedFormula */
//var parse_XLSBFRTParsedFormula = parse_XLSBParsedFormula2;
/* [MS-XLSB] 2.5.97.12 NameParsedFormula */
var parse_XLSBNameParsedFormula = parse_XLSBParsedFormula;
/* [MS-XLSB] 2.5.97.98 SharedParsedFormula */
var parse_XLSBSharedParsedFormula = parse_XLSBParsedFormula;
var Cetab = {
  0: "BEEP",
  1: "OPEN",
  2: "OPEN.LINKS",
  3: "CLOSE.ALL",
  4: "SAVE",
  5: "SAVE.AS",
  6: "FILE.DELETE",
  7: "PAGE.SETUP",
  8: "PRINT",
  9: "PRINTER.SETUP",
  10: "QUIT",
  11: "NEW.WINDOW",
  12: "ARRANGE.ALL",
  13: "WINDOW.SIZE",
  14: "WINDOW.MOVE",
  15: "FULL",
  16: "CLOSE",
  17: "RUN",
  22: "SET.PRINT.AREA",
  23: "SET.PRINT.TITLES",
  24: "SET.PAGE.BREAK",
  25: "REMOVE.PAGE.BREAK",
  26: "FONT",
  27: "DISPLAY",
  28: "PROTECT.DOCUMENT",
  29: "PRECISION",
  30: "A1.R1C1",
  31: "CALCULATE.NOW",
  32: "CALCULATION",
  34: "DATA.FIND",
  35: "EXTRACT",
  36: "DATA.DELETE",
  37: "SET.DATABASE",
  38: "SET.CRITERIA",
  39: "SORT",
  40: "DATA.SERIES",
  41: "TABLE",
  42: "FORMAT.NUMBER",
  43: "ALIGNMENT",
  44: "STYLE",
  45: "BORDER",
  46: "CELL.PROTECTION",
  47: "COLUMN.WIDTH",
  48: "UNDO",
  49: "CUT",
  50: "COPY",
  51: "PASTE",
  52: "CLEAR",
  53: "PASTE.SPECIAL",
  54: "EDIT.DELETE",
  55: "INSERT",
  56: "FILL.RIGHT",
  57: "FILL.DOWN",
  61: "DEFINE.NAME",
  62: "CREATE.NAMES",
  63: "FORMULA.GOTO",
  64: "FORMULA.FIND",
  65: "SELECT.LAST.CELL",
  66: "SHOW.ACTIVE.CELL",
  67: "GALLERY.AREA",
  68: "GALLERY.BAR",
  69: "GALLERY.COLUMN",
  70: "GALLERY.LINE",
  71: "GALLERY.PIE",
  72: "GALLERY.SCATTER",
  73: "COMBINATION",
  74: "PREFERRED",
  75: "ADD.OVERLAY",
  76: "GRIDLINES",
  77: "SET.PREFERRED",
  78: "AXES",
  79: "LEGEND",
  80: "ATTACH.TEXT",
  81: "ADD.ARROW",
  82: "SELECT.CHART",
  83: "SELECT.PLOT.AREA",
  84: "PATTERNS",
  85: "MAIN.CHART",
  86: "OVERLAY",
  87: "SCALE",
  88: "FORMAT.LEGEND",
  89: "FORMAT.TEXT",
  90: "EDIT.REPEAT",
  91: "PARSE",
  92: "JUSTIFY",
  93: "HIDE",
  94: "UNHIDE",
  95: "WORKSPACE",
  96: "FORMULA",
  97: "FORMULA.FILL",
  98: "FORMULA.ARRAY",
  99: "DATA.FIND.NEXT",
  100: "DATA.FIND.PREV",
  101: "FORMULA.FIND.NEXT",
  102: "FORMULA.FIND.PREV",
  103: "ACTIVATE",
  104: "ACTIVATE.NEXT",
  105: "ACTIVATE.PREV",
  106: "UNLOCKED.NEXT",
  107: "UNLOCKED.PREV",
  108: "COPY.PICTURE",
  109: "SELECT",
  110: "DELETE.NAME",
  111: "DELETE.FORMAT",
  112: "VLINE",
  113: "HLINE",
  114: "VPAGE",
  115: "HPAGE",
  116: "VSCROLL",
  117: "HSCROLL",
  118: "ALERT",
  119: "NEW",
  120: "CANCEL.COPY",
  121: "SHOW.CLIPBOARD",
  122: "MESSAGE",
  124: "PASTE.LINK",
  125: "APP.ACTIVATE",
  126: "DELETE.ARROW",
  127: "ROW.HEIGHT",
  128: "FORMAT.MOVE",
  129: "FORMAT.SIZE",
  130: "FORMULA.REPLACE",
  131: "SEND.KEYS",
  132: "SELECT.SPECIAL",
  133: "APPLY.NAMES",
  134: "REPLACE.FONT",
  135: "FREEZE.PANES",
  136: "SHOW.INFO",
  137: "SPLIT",
  138: "ON.WINDOW",
  139: "ON.DATA",
  140: "DISABLE.INPUT",
  142: "OUTLINE",
  143: "LIST.NAMES",
  144: "FILE.CLOSE",
  145: "SAVE.WORKBOOK",
  146: "DATA.FORM",
  147: "COPY.CHART",
  148: "ON.TIME",
  149: "WAIT",
  150: "FORMAT.FONT",
  151: "FILL.UP",
  152: "FILL.LEFT",
  153: "DELETE.OVERLAY",
  155: "SHORT.MENUS",
  159: "SET.UPDATE.STATUS",
  161: "COLOR.PALETTE",
  162: "DELETE.STYLE",
  163: "WINDOW.RESTORE",
  164: "WINDOW.MAXIMIZE",
  166: "CHANGE.LINK",
  167: "CALCULATE.DOCUMENT",
  168: "ON.KEY",
  169: "APP.RESTORE",
  170: "APP.MOVE",
  171: "APP.SIZE",
  172: "APP.MINIMIZE",
  173: "APP.MAXIMIZE",
  174: "BRING.TO.FRONT",
  175: "SEND.TO.BACK",
  185: "MAIN.CHART.TYPE",
  186: "OVERLAY.CHART.TYPE",
  187: "SELECT.END",
  188: "OPEN.MAIL",
  189: "SEND.MAIL",
  190: "STANDARD.FONT",
  191: "CONSOLIDATE",
  192: "SORT.SPECIAL",
  193: "GALLERY.3D.AREA",
  194: "GALLERY.3D.COLUMN",
  195: "GALLERY.3D.LINE",
  196: "GALLERY.3D.PIE",
  197: "VIEW.3D",
  198: "GOAL.SEEK",
  199: "WORKGROUP",
  200: "FILL.GROUP",
  201: "UPDATE.LINK",
  202: "PROMOTE",
  203: "DEMOTE",
  204: "SHOW.DETAIL",
  206: "UNGROUP",
  207: "OBJECT.PROPERTIES",
  208: "SAVE.NEW.OBJECT",
  209: "SHARE",
  210: "SHARE.NAME",
  211: "DUPLICATE",
  212: "APPLY.STYLE",
  213: "ASSIGN.TO.OBJECT",
  214: "OBJECT.PROTECTION",
  215: "HIDE.OBJECT",
  216: "SET.EXTRACT",
  217: "CREATE.PUBLISHER",
  218: "SUBSCRIBE.TO",
  219: "ATTRIBUTES",
  220: "SHOW.TOOLBAR",
  222: "PRINT.PREVIEW",
  223: "EDIT.COLOR",
  224: "SHOW.LEVELS",
  225: "FORMAT.MAIN",
  226: "FORMAT.OVERLAY",
  227: "ON.RECALC",
  228: "EDIT.SERIES",
  229: "DEFINE.STYLE",
  240: "LINE.PRINT",
  243: "ENTER.DATA",
  249: "GALLERY.RADAR",
  250: "MERGE.STYLES",
  251: "EDITION.OPTIONS",
  252: "PASTE.PICTURE",
  253: "PASTE.PICTURE.LINK",
  254: "SPELLING",
  256: "ZOOM",
  259: "INSERT.OBJECT",
  260: "WINDOW.MINIMIZE",
  265: "SOUND.NOTE",
  266: "SOUND.PLAY",
  267: "FORMAT.SHAPE",
  268: "EXTEND.POLYGON",
  269: "FORMAT.AUTO",
  272: "GALLERY.3D.BAR",
  273: "GALLERY.3D.SURFACE",
  274: "FILL.AUTO",
  276: "CUSTOMIZE.TOOLBAR",
  277: "ADD.TOOL",
  278: "EDIT.OBJECT",
  279: "ON.DOUBLECLICK",
  280: "ON.ENTRY",
  281: "WORKBOOK.ADD",
  282: "WORKBOOK.MOVE",
  283: "WORKBOOK.COPY",
  284: "WORKBOOK.OPTIONS",
  285: "SAVE.WORKSPACE",
  288: "CHART.WIZARD",
  289: "DELETE.TOOL",
  290: "MOVE.TOOL",
  291: "WORKBOOK.SELECT",
  292: "WORKBOOK.ACTIVATE",
  293: "ASSIGN.TO.TOOL",
  295: "COPY.TOOL",
  296: "RESET.TOOL",
  297: "CONSTRAIN.NUMERIC",
  298: "PASTE.TOOL",
  302: "WORKBOOK.NEW",
  305: "SCENARIO.CELLS",
  306: "SCENARIO.DELETE",
  307: "SCENARIO.ADD",
  308: "SCENARIO.EDIT",
  309: "SCENARIO.SHOW",
  310: "SCENARIO.SHOW.NEXT",
  311: "SCENARIO.SUMMARY",
  312: "PIVOT.TABLE.WIZARD",
  313: "PIVOT.FIELD.PROPERTIES",
  314: "PIVOT.FIELD",
  315: "PIVOT.ITEM",
  316: "PIVOT.ADD.FIELDS",
  318: "OPTIONS.CALCULATION",
  319: "OPTIONS.EDIT",
  320: "OPTIONS.VIEW",
  321: "ADDIN.MANAGER",
  322: "MENU.EDITOR",
  323: "ATTACH.TOOLBARS",
  324: "VBAActivate",
  325: "OPTIONS.CHART",
  328: "VBA.INSERT.FILE",
  330: "VBA.PROCEDURE.DEFINITION",
  336: "ROUTING.SLIP",
  338: "ROUTE.DOCUMENT",
  339: "MAIL.LOGON",
  342: "INSERT.PICTURE",
  343: "EDIT.TOOL",
  344: "GALLERY.DOUGHNUT",
  350: "CHART.TREND",
  352: "PIVOT.ITEM.PROPERTIES",
  354: "WORKBOOK.INSERT",
  355: "OPTIONS.TRANSITION",
  356: "OPTIONS.GENERAL",
  370: "FILTER.ADVANCED",
  373: "MAIL.ADD.MAILER",
  374: "MAIL.DELETE.MAILER",
  375: "MAIL.REPLY",
  376: "MAIL.REPLY.ALL",
  377: "MAIL.FORWARD",
  378: "MAIL.NEXT.LETTER",
  379: "DATA.LABEL",
  380: "INSERT.TITLE",
  381: "FONT.PROPERTIES",
  382: "MACRO.OPTIONS",
  383: "WORKBOOK.HIDE",
  384: "WORKBOOK.UNHIDE",
  385: "WORKBOOK.DELETE",
  386: "WORKBOOK.NAME",
  388: "GALLERY.CUSTOM",
  390: "ADD.CHART.AUTOFORMAT",
  391: "DELETE.CHART.AUTOFORMAT",
  392: "CHART.ADD.DATA",
  393: "AUTO.OUTLINE",
  394: "TAB.ORDER",
  395: "SHOW.DIALOG",
  396: "SELECT.ALL",
  397: "UNGROUP.SHEETS",
  398: "SUBTOTAL.CREATE",
  399: "SUBTOTAL.REMOVE",
  400: "RENAME.OBJECT",
  412: "WORKBOOK.SCROLL",
  413: "WORKBOOK.NEXT",
  414: "WORKBOOK.PREV",
  415: "WORKBOOK.TAB.SPLIT",
  416: "FULL.SCREEN",
  417: "WORKBOOK.PROTECT",
  420: "SCROLLBAR.PROPERTIES",
  421: "PIVOT.SHOW.PAGES",
  422: "TEXT.TO.COLUMNS",
  423: "FORMAT.CHARTTYPE",
  424: "LINK.FORMAT",
  425: "TRACER.DISPLAY",
  430: "TRACER.NAVIGATE",
  431: "TRACER.CLEAR",
  432: "TRACER.ERROR",
  433: "PIVOT.FIELD.GROUP",
  434: "PIVOT.FIELD.UNGROUP",
  435: "CHECKBOX.PROPERTIES",
  436: "LABEL.PROPERTIES",
  437: "LISTBOX.PROPERTIES",
  438: "EDITBOX.PROPERTIES",
  439: "PIVOT.REFRESH",
  440: "LINK.COMBO",
  441: "OPEN.TEXT",
  442: "HIDE.DIALOG",
  443: "SET.DIALOG.FOCUS",
  444: "ENABLE.OBJECT",
  445: "PUSHBUTTON.PROPERTIES",
  446: "SET.DIALOG.DEFAULT",
  447: "FILTER",
  448: "FILTER.SHOW.ALL",
  449: "CLEAR.OUTLINE",
  450: "FUNCTION.WIZARD",
  451: "ADD.LIST.ITEM",
  452: "SET.LIST.ITEM",
  453: "REMOVE.LIST.ITEM",
  454: "SELECT.LIST.ITEM",
  455: "SET.CONTROL.VALUE",
  456: "SAVE.COPY.AS",
  458: "OPTIONS.LISTS.ADD",
  459: "OPTIONS.LISTS.DELETE",
  460: "SERIES.AXES",
  461: "SERIES.X",
  462: "SERIES.Y",
  463: "ERRORBAR.X",
  464: "ERRORBAR.Y",
  465: "FORMAT.CHART",
  466: "SERIES.ORDER",
  467: "MAIL.LOGOFF",
  468: "CLEAR.ROUTING.SLIP",
  469: "APP.ACTIVATE.MICROSOFT",
  470: "MAIL.EDIT.MAILER",
  471: "ON.SHEET",
  472: "STANDARD.WIDTH",
  473: "SCENARIO.MERGE",
  474: "SUMMARY.INFO",
  475: "FIND.FILE",
  476: "ACTIVE.CELL.FONT",
  477: "ENABLE.TIPWIZARD",
  478: "VBA.MAKE.ADDIN",
  480: "INSERTDATATABLE",
  481: "WORKGROUP.OPTIONS",
  482: "MAIL.SEND.MAILER",
  485: "AUTOCORRECT",
  489: "POST.DOCUMENT",
  491: "PICKLIST",
  493: "VIEW.SHOW",
  494: "VIEW.DEFINE",
  495: "VIEW.DELETE",
  509: "SHEET.BACKGROUND",
  510: "INSERT.MAP.OBJECT",
  511: "OPTIONS.MENONO",
  517: "MSOCHECKS",
  518: "NORMAL",
  519: "LAYOUT",
  520: "RM.PRINT.AREA",
  521: "CLEAR.PRINT.AREA",
  522: "ADD.PRINT.AREA",
  523: "MOVE.BRK",
  545: "HIDECURR.NOTE",
  546: "HIDEALL.NOTES",
  547: "DELETE.NOTE",
  548: "TRAVERSE.NOTES",
  549: "ACTIVATE.NOTES",
  620: "PROTECT.REVISIONS",
  621: "UNPROTECT.REVISIONS",
  647: "OPTIONS.ME",
  653: "WEB.PUBLISH",
  667: "NEWWEBQUERY",
  673: "PIVOT.TABLE.CHART",
  753: "OPTIONS.SAVE",
  755: "OPTIONS.SPELL",
  808: "HIDEALL.INKANNOTS"
};
var Ftab = {
  0: "COUNT",
  1: "IF",
  2: "ISNA",
  3: "ISERROR",
  4: "SUM",
  5: "AVERAGE",
  6: "MIN",
  7: "MAX",
  8: "ROW",
  9: "COLUMN",
  10: "NA",
  11: "NPV",
  12: "STDEV",
  13: "DOLLAR",
  14: "FIXED",
  15: "SIN",
  16: "COS",
  17: "TAN",
  18: "ATAN",
  19: "PI",
  20: "SQRT",
  21: "EXP",
  22: "LN",
  23: "LOG10",
  24: "ABS",
  25: "INT",
  26: "SIGN",
  27: "ROUND",
  28: "LOOKUP",
  29: "INDEX",
  30: "REPT",
  31: "MID",
  32: "LEN",
  33: "VALUE",
  34: "TRUE",
  35: "FALSE",
  36: "AND",
  37: "OR",
  38: "NOT",
  39: "MOD",
  40: "DCOUNT",
  41: "DSUM",
  42: "DAVERAGE",
  43: "DMIN",
  44: "DMAX",
  45: "DSTDEV",
  46: "VAR",
  47: "DVAR",
  48: "TEXT",
  49: "LINEST",
  50: "TREND",
  51: "LOGEST",
  52: "GROWTH",
  53: "GOTO",
  54: "HALT",
  55: "RETURN",
  56: "PV",
  57: "FV",
  58: "NPER",
  59: "PMT",
  60: "RATE",
  61: "MIRR",
  62: "IRR",
  63: "RAND",
  64: "MATCH",
  65: "DATE",
  66: "TIME",
  67: "DAY",
  68: "MONTH",
  69: "YEAR",
  70: "WEEKDAY",
  71: "HOUR",
  72: "MINUTE",
  73: "SECOND",
  74: "NOW",
  75: "AREAS",
  76: "ROWS",
  77: "COLUMNS",
  78: "OFFSET",
  79: "ABSREF",
  80: "RELREF",
  81: "ARGUMENT",
  82: "SEARCH",
  83: "TRANSPOSE",
  84: "ERROR",
  85: "STEP",
  86: "TYPE",
  87: "ECHO",
  88: "SET.NAME",
  89: "CALLER",
  90: "DEREF",
  91: "WINDOWS",
  92: "SERIES",
  93: "DOCUMENTS",
  94: "ACTIVE.CELL",
  95: "SELECTION",
  96: "RESULT",
  97: "ATAN2",
  98: "ASIN",
  99: "ACOS",
  100: "CHOOSE",
  101: "HLOOKUP",
  102: "VLOOKUP",
  103: "LINKS",
  104: "INPUT",
  105: "ISREF",
  106: "GET.FORMULA",
  107: "GET.NAME",
  108: "SET.VALUE",
  109: "LOG",
  110: "EXEC",
  111: "CHAR",
  112: "LOWER",
  113: "UPPER",
  114: "PROPER",
  115: "LEFT",
  116: "RIGHT",
  117: "EXACT",
  118: "TRIM",
  119: "REPLACE",
  120: "SUBSTITUTE",
  121: "CODE",
  122: "NAMES",
  123: "DIRECTORY",
  124: "FIND",
  125: "CELL",
  126: "ISERR",
  127: "ISTEXT",
  128: "ISNUMBER",
  129: "ISBLANK",
  130: "T",
  131: "N",
  132: "FOPEN",
  133: "FCLOSE",
  134: "FSIZE",
  135: "FREADLN",
  136: "FREAD",
  137: "FWRITELN",
  138: "FWRITE",
  139: "FPOS",
  140: "DATEVALUE",
  141: "TIMEVALUE",
  142: "SLN",
  143: "SYD",
  144: "DDB",
  145: "GET.DEF",
  146: "REFTEXT",
  147: "TEXTREF",
  148: "INDIRECT",
  149: "REGISTER",
  150: "CALL",
  151: "ADD.BAR",
  152: "ADD.MENU",
  153: "ADD.COMMAND",
  154: "ENABLE.COMMAND",
  155: "CHECK.COMMAND",
  156: "RENAME.COMMAND",
  157: "SHOW.BAR",
  158: "DELETE.MENU",
  159: "DELETE.COMMAND",
  160: "GET.CHART.ITEM",
  161: "DIALOG.BOX",
  162: "CLEAN",
  163: "MDETERM",
  164: "MINVERSE",
  165: "MMULT",
  166: "FILES",
  167: "IPMT",
  168: "PPMT",
  169: "COUNTA",
  170: "CANCEL.KEY",
  171: "FOR",
  172: "WHILE",
  173: "BREAK",
  174: "NEXT",
  175: "INITIATE",
  176: "REQUEST",
  177: "POKE",
  178: "EXECUTE",
  179: "TERMINATE",
  180: "RESTART",
  181: "HELP",
  182: "GET.BAR",
  183: "PRODUCT",
  184: "FACT",
  185: "GET.CELL",
  186: "GET.WORKSPACE",
  187: "GET.WINDOW",
  188: "GET.DOCUMENT",
  189: "DPRODUCT",
  190: "ISNONTEXT",
  191: "GET.NOTE",
  192: "NOTE",
  193: "STDEVP",
  194: "VARP",
  195: "DSTDEVP",
  196: "DVARP",
  197: "TRUNC",
  198: "ISLOGICAL",
  199: "DCOUNTA",
  200: "DELETE.BAR",
  201: "UNREGISTER",
  204: "USDOLLAR",
  205: "FINDB",
  206: "SEARCHB",
  207: "REPLACEB",
  208: "LEFTB",
  209: "RIGHTB",
  210: "MIDB",
  211: "LENB",
  212: "ROUNDUP",
  213: "ROUNDDOWN",
  214: "ASC",
  215: "DBCS",
  216: "RANK",
  219: "ADDRESS",
  220: "DAYS360",
  221: "TODAY",
  222: "VDB",
  223: "ELSE",
  224: "ELSE.IF",
  225: "END.IF",
  226: "FOR.CELL",
  227: "MEDIAN",
  228: "SUMPRODUCT",
  229: "SINH",
  230: "COSH",
  231: "TANH",
  232: "ASINH",
  233: "ACOSH",
  234: "ATANH",
  235: "DGET",
  236: "CREATE.OBJECT",
  237: "VOLATILE",
  238: "LAST.ERROR",
  239: "CUSTOM.UNDO",
  240: "CUSTOM.REPEAT",
  241: "FORMULA.CONVERT",
  242: "GET.LINK.INFO",
  243: "TEXT.BOX",
  244: "INFO",
  245: "GROUP",
  246: "GET.OBJECT",
  247: "DB",
  248: "PAUSE",
  251: "RESUME",
  252: "FREQUENCY",
  253: "ADD.TOOLBAR",
  254: "DELETE.TOOLBAR",
  255: "User",
  256: "RESET.TOOLBAR",
  257: "EVALUATE",
  258: "GET.TOOLBAR",
  259: "GET.TOOL",
  260: "SPELLING.CHECK",
  261: "ERROR.TYPE",
  262: "APP.TITLE",
  263: "WINDOW.TITLE",
  264: "SAVE.TOOLBAR",
  265: "ENABLE.TOOL",
  266: "PRESS.TOOL",
  267: "REGISTER.ID",
  268: "GET.WORKBOOK",
  269: "AVEDEV",
  270: "BETADIST",
  271: "GAMMALN",
  272: "BETAINV",
  273: "BINOMDIST",
  274: "CHIDIST",
  275: "CHIINV",
  276: "COMBIN",
  277: "CONFIDENCE",
  278: "CRITBINOM",
  279: "EVEN",
  280: "EXPONDIST",
  281: "FDIST",
  282: "FINV",
  283: "FISHER",
  284: "FISHERINV",
  285: "FLOOR",
  286: "GAMMADIST",
  287: "GAMMAINV",
  288: "CEILING",
  289: "HYPGEOMDIST",
  290: "LOGNORMDIST",
  291: "LOGINV",
  292: "NEGBINOMDIST",
  293: "NORMDIST",
  294: "NORMSDIST",
  295: "NORMINV",
  296: "NORMSINV",
  297: "STANDARDIZE",
  298: "ODD",
  299: "PERMUT",
  300: "POISSON",
  301: "TDIST",
  302: "WEIBULL",
  303: "SUMXMY2",
  304: "SUMX2MY2",
  305: "SUMX2PY2",
  306: "CHITEST",
  307: "CORREL",
  308: "COVAR",
  309: "FORECAST",
  310: "FTEST",
  311: "INTERCEPT",
  312: "PEARSON",
  313: "RSQ",
  314: "STEYX",
  315: "SLOPE",
  316: "TTEST",
  317: "PROB",
  318: "DEVSQ",
  319: "GEOMEAN",
  320: "HARMEAN",
  321: "SUMSQ",
  322: "KURT",
  323: "SKEW",
  324: "ZTEST",
  325: "LARGE",
  326: "SMALL",
  327: "QUARTILE",
  328: "PERCENTILE",
  329: "PERCENTRANK",
  330: "MODE",
  331: "TRIMMEAN",
  332: "TINV",
  334: "MOVIE.COMMAND",
  335: "GET.MOVIE",
  336: "CONCATENATE",
  337: "POWER",
  338: "PIVOT.ADD.DATA",
  339: "GET.PIVOT.TABLE",
  340: "GET.PIVOT.FIELD",
  341: "GET.PIVOT.ITEM",
  342: "RADIANS",
  343: "DEGREES",
  344: "SUBTOTAL",
  345: "SUMIF",
  346: "COUNTIF",
  347: "COUNTBLANK",
  348: "SCENARIO.GET",
  349: "OPTIONS.LISTS.GET",
  350: "ISPMT",
  351: "DATEDIF",
  352: "DATESTRING",
  353: "NUMBERSTRING",
  354: "ROMAN",
  355: "OPEN.DIALOG",
  356: "SAVE.DIALOG",
  357: "VIEW.GET",
  358: "GETPIVOTDATA",
  359: "HYPERLINK",
  360: "PHONETIC",
  361: "AVERAGEA",
  362: "MAXA",
  363: "MINA",
  364: "STDEVPA",
  365: "VARPA",
  366: "STDEVA",
  367: "VARA",
  368: "BAHTTEXT",
  369: "THAIDAYOFWEEK",
  370: "THAIDIGIT",
  371: "THAIMONTHOFYEAR",
  372: "THAINUMSOUND",
  373: "THAINUMSTRING",
  374: "THAISTRINGLENGTH",
  375: "ISTHAIDIGIT",
  376: "ROUNDBAHTDOWN",
  377: "ROUNDBAHTUP",
  378: "THAIYEAR",
  379: "RTD",
  380: "CUBEVALUE",
  381: "CUBEMEMBER",
  382: "CUBEMEMBERPROPERTY",
  383: "CUBERANKEDMEMBER",
  384: "HEX2BIN",
  385: "HEX2DEC",
  386: "HEX2OCT",
  387: "DEC2BIN",
  388: "DEC2HEX",
  389: "DEC2OCT",
  390: "OCT2BIN",
  391: "OCT2HEX",
  392: "OCT2DEC",
  393: "BIN2DEC",
  394: "BIN2OCT",
  395: "BIN2HEX",
  396: "IMSUB",
  397: "IMDIV",
  398: "IMPOWER",
  399: "IMABS",
  400: "IMSQRT",
  401: "IMLN",
  402: "IMLOG2",
  403: "IMLOG10",
  404: "IMSIN",
  405: "IMCOS",
  406: "IMEXP",
  407: "IMARGUMENT",
  408: "IMCONJUGATE",
  409: "IMAGINARY",
  410: "IMREAL",
  411: "COMPLEX",
  412: "IMSUM",
  413: "IMPRODUCT",
  414: "SERIESSUM",
  415: "FACTDOUBLE",
  416: "SQRTPI",
  417: "QUOTIENT",
  418: "DELTA",
  419: "GESTEP",
  420: "ISEVEN",
  421: "ISODD",
  422: "MROUND",
  423: "ERF",
  424: "ERFC",
  425: "BESSELJ",
  426: "BESSELK",
  427: "BESSELY",
  428: "BESSELI",
  429: "XIRR",
  430: "XNPV",
  431: "PRICEMAT",
  432: "YIELDMAT",
  433: "INTRATE",
  434: "RECEIVED",
  435: "DISC",
  436: "PRICEDISC",
  437: "YIELDDISC",
  438: "TBILLEQ",
  439: "TBILLPRICE",
  440: "TBILLYIELD",
  441: "PRICE",
  442: "YIELD",
  443: "DOLLARDE",
  444: "DOLLARFR",
  445: "NOMINAL",
  446: "EFFECT",
  447: "CUMPRINC",
  448: "CUMIPMT",
  449: "EDATE",
  450: "EOMONTH",
  451: "YEARFRAC",
  452: "COUPDAYBS",
  453: "COUPDAYS",
  454: "COUPDAYSNC",
  455: "COUPNCD",
  456: "COUPNUM",
  457: "COUPPCD",
  458: "DURATION",
  459: "MDURATION",
  460: "ODDLPRICE",
  461: "ODDLYIELD",
  462: "ODDFPRICE",
  463: "ODDFYIELD",
  464: "RANDBETWEEN",
  465: "WEEKNUM",
  466: "AMORDEGRC",
  467: "AMORLINC",
  468: "CONVERT",
  724: "SHEETJS",
  469: "ACCRINT",
  470: "ACCRINTM",
  471: "WORKDAY",
  472: "NETWORKDAYS",
  473: "GCD",
  474: "MULTINOMIAL",
  475: "LCM",
  476: "FVSCHEDULE",
  477: "CUBEKPIMEMBER",
  478: "CUBESET",
  479: "CUBESETCOUNT",
  480: "IFERROR",
  481: "COUNTIFS",
  482: "SUMIFS",
  483: "AVERAGEIF",
  484: "AVERAGEIFS"
};
var FtabArgc = {
  2: 1,
  3: 1,
  10: 0,
  15: 1,
  16: 1,
  17: 1,
  18: 1,
  19: 0,
  20: 1,
  21: 1,
  22: 1,
  23: 1,
  24: 1,
  25: 1,
  26: 1,
  27: 2,
  30: 2,
  31: 3,
  32: 1,
  33: 1,
  34: 0,
  35: 0,
  38: 1,
  39: 2,
  40: 3,
  41: 3,
  42: 3,
  43: 3,
  44: 3,
  45: 3,
  47: 3,
  48: 2,
  53: 1,
  61: 3,
  63: 0,
  65: 3,
  66: 3,
  67: 1,
  68: 1,
  69: 1,
  70: 1,
  71: 1,
  72: 1,
  73: 1,
  74: 0,
  75: 1,
  76: 1,
  77: 1,
  79: 2,
  80: 2,
  83: 1,
  85: 0,
  86: 1,
  89: 0,
  90: 1,
  94: 0,
  95: 0,
  97: 2,
  98: 1,
  99: 1,
  101: 3,
  102: 3,
  105: 1,
  106: 1,
  108: 2,
  111: 1,
  112: 1,
  113: 1,
  114: 1,
  117: 2,
  118: 1,
  119: 4,
  121: 1,
  126: 1,
  127: 1,
  128: 1,
  129: 1,
  130: 1,
  131: 1,
  133: 1,
  134: 1,
  135: 1,
  136: 2,
  137: 2,
  138: 2,
  140: 1,
  141: 1,
  142: 3,
  143: 4,
  144: 4,
  161: 1,
  162: 1,
  163: 1,
  164: 1,
  165: 2,
  172: 1,
  175: 2,
  176: 2,
  177: 3,
  178: 2,
  179: 1,
  184: 1,
  186: 1,
  189: 3,
  190: 1,
  195: 3,
  196: 3,
  197: 1,
  198: 1,
  199: 3,
  201: 1,
  207: 4,
  210: 3,
  211: 1,
  212: 2,
  213: 2,
  214: 1,
  215: 1,
  225: 0,
  229: 1,
  230: 1,
  231: 1,
  232: 1,
  233: 1,
  234: 1,
  235: 3,
  244: 1,
  247: 4,
  252: 2,
  257: 1,
  261: 1,
  271: 1,
  273: 4,
  274: 2,
  275: 2,
  276: 2,
  277: 3,
  278: 3,
  279: 1,
  280: 3,
  281: 3,
  282: 3,
  283: 1,
  284: 1,
  285: 2,
  286: 4,
  287: 3,
  288: 2,
  289: 4,
  290: 3,
  291: 3,
  292: 3,
  293: 4,
  294: 1,
  295: 3,
  296: 1,
  297: 3,
  298: 1,
  299: 2,
  300: 3,
  301: 3,
  302: 4,
  303: 2,
  304: 2,
  305: 2,
  306: 2,
  307: 2,
  308: 2,
  309: 3,
  310: 2,
  311: 2,
  312: 2,
  313: 2,
  314: 2,
  315: 2,
  316: 4,
  325: 2,
  326: 2,
  327: 2,
  328: 2,
  331: 2,
  332: 2,
  337: 2,
  342: 1,
  343: 1,
  346: 2,
  347: 1,
  350: 4,
  351: 3,
  352: 1,
  353: 2,
  360: 1,
  368: 1,
  369: 1,
  370: 1,
  371: 1,
  372: 1,
  373: 1,
  374: 1,
  375: 1,
  376: 1,
  377: 1,
  378: 1,
  382: 3,
  385: 1,
  392: 1,
  393: 1,
  396: 2,
  397: 2,
  398: 2,
  399: 1,
  400: 1,
  401: 1,
  402: 1,
  403: 1,
  404: 1,
  405: 1,
  406: 1,
  407: 1,
  408: 1,
  409: 1,
  410: 1,
  414: 4,
  415: 1,
  416: 1,
  417: 2,
  420: 1,
  421: 1,
  422: 2,
  424: 1,
  425: 2,
  426: 2,
  427: 2,
  428: 2,
  430: 3,
  438: 3,
  439: 3,
  440: 3,
  443: 2,
  444: 2,
  445: 2,
  446: 2,
  447: 6,
  448: 6,
  449: 2,
  450: 2,
  464: 2,
  468: 3,
  476: 2,
  479: 1,
  480: 2,
  65535: 0
};
/* Part 3 TODO: actually parse formulae */
function ods_to_csf_formula(f/*:string*/)/*:string*/ {
	if(f.slice(0,3) == "of:") f = f.slice(3);
	/* 5.2 Basic Expressions */
	if(f.charCodeAt(0) == 61) {
		f = f.slice(1);
		if(f.charCodeAt(0) == 61) f = f.slice(1);
	}
	f = f.replace(/COM\.MICROSOFT\./g, "");
	/* Part 3 Section 5.8 References */
	f = f.replace(/\[((?:\.[A-Z]+[0-9]+)(?::\.[A-Z]+[0-9]+)?)\]/g, function($$, $1) { return $1.replace(/\./g,""); });
	/* TODO: something other than this */
	f = f.replace(/\[.(#[A-Z]*[?!])\]/g, "$1");
	return f.replace(/[;~]/g,",").replace(/\|/g,";");
}

function csf_to_ods_formula(f/*:string*/)/*:string*/ {
	var o = "of:=" + f.replace(crefregex, "$1[.$2$3$4$5]").replace(/\]:\[/g,":");
	/* TODO: something other than this */
	return o.replace(/;/g, "|").replace(/,/g,";");
}

function ods_to_csf_3D(r/*:string*/)/*:[string, string]*/ {
	var a = r.split(":");
	var s = a[0].split(".")[0];
	return [s, a[0].split(".")[1] + (a.length > 1 ? (":" + (a[1].split(".")[1] || a[1].split(".")[0])) : "")];
}

function csf_to_ods_3D(r/*:string*/)/*:string*/ {
	return r.replace(/\./,"!");
}

var strs = {}; // shared strings
var _ssfopts = {}; // spreadsheet formatting options


/*global Map */
var browser_has_Map = typeof Map !== 'undefined';

function get_sst_id(sst/*:SST*/, str/*:string*/, rev)/*:number*/ {
	var i = 0, len = sst.length;
	if(rev) {
		if(browser_has_Map ? rev.has(str) : Object.prototype.hasOwnProperty.call(rev, str)) {
			var revarr = browser_has_Map ? rev.get(str) : rev[str];
			for(; i < revarr.length; ++i) {
				if(sst[revarr[i]].t === str) { sst.Count ++; return revarr[i]; }
			}
		}
	} else for(; i < len; ++i) {
		if(sst[i].t === str) { sst.Count ++; return i; }
	}
	sst[len] = ({t:str}/*:any*/); sst.Count ++; sst.Unique ++;
	if(rev) {
		if(browser_has_Map) {
			if(!rev.has(str)) rev.set(str, []);
			rev.get(str).push(len);
		} else {
			if(!Object.prototype.hasOwnProperty.call(rev, str)) rev[str] = [];
			rev[str].push(len);
		}
	}
	return len;
}

function col_obj_w(C/*:number*/, col) {
	var p = ({min:C+1,max:C+1}/*:any*/);
	/* wch (chars), wpx (pixels) */
	var wch = -1;
	if(col.MDW) MDW = col.MDW;
	if(col.width != null) p.customWidth = 1;
	else if(col.wpx != null) wch = px2char(col.wpx);
	else if(col.wch != null) wch = col.wch;
	if(wch > -1) { p.width = char2width(wch); p.customWidth = 1; }
	else if(col.width != null) p.width = col.width;
	if(col.hidden) p.hidden = true;
	if(col.level != null) { p.outlineLevel = p.level = col.level; }
	return p;
}

function default_margins(margins/*:Margins*/, mode/*:?string*/) {
	if(!margins) return;
	var defs = [0.7, 0.7, 0.75, 0.75, 0.3, 0.3];
	if(mode == 'xlml') defs = [1, 1, 1, 1, 0.5, 0.5];
	if(margins.left   == null) margins.left   = defs[0];
	if(margins.right  == null) margins.right  = defs[1];
	if(margins.top    == null) margins.top    = defs[2];
	if(margins.bottom == null) margins.bottom = defs[3];
	if(margins.header == null) margins.header = defs[4];
	if(margins.footer == null) margins.footer = defs[5];
}

function get_cell_style(styles/*:Array<any>*/, cell/*:Cell*/, opts) {
	var z = opts.revssf[cell.z != null ? cell.z : "General"];
	var i = 0x3c, len = styles.length;
	if(z == null && opts.ssf) {
		for(; i < 0x188; ++i) if(opts.ssf[i] == null) {
			SSF_load(cell.z, i);
			// $FlowIgnore
			opts.ssf[i] = cell.z;
			opts.revssf[cell.z] = z = i;
			break;
		}
	}
	for(i = 0; i != len; ++i) if(styles[i].numFmtId === z) return i;
	styles[len] = {
		numFmtId:z,
		fontId:0,
		fillId:0,
		borderId:0,
		xfId:0,
		applyNumberFormat:1
	};
	return len;
}

function safe_format(p/*:Cell*/, fmtid/*:number*/, fillid/*:?number*/, opts, themes, styles) {
	try {
		if(opts.cellNF) p.z = table_fmt[fmtid];
	} catch(e) { if(opts.WTF) throw e; }
	if(p.t === 'z' && !opts.cellStyles) return;
	if(p.t === 'd' && typeof p.v === 'string') p.v = parseDate(p.v);
	if((!opts || opts.cellText !== false) && p.t !== 'z') try {
		if(table_fmt[fmtid] == null) SSF_load(SSFImplicit[fmtid] || "General", fmtid);
		if(p.t === 'e') p.w = p.w || BErr[p.v];
		else if(fmtid === 0) {
			if(p.t === 'n') {
				if((p.v|0) === p.v) p.w = p.v.toString(10);
				else p.w = SSF_general_num(p.v);
			}
			else if(p.t === 'd') {
				var dd = datenum(p.v);
				if((dd|0) === dd) p.w = dd.toString(10);
				else p.w = SSF_general_num(dd);
			}
			else if(p.v === undefined) return "";
			else p.w = SSF_general(p.v,_ssfopts);
		}
		else if(p.t === 'd') p.w = SSF_format(fmtid,datenum(p.v),_ssfopts);
		else p.w = SSF_format(fmtid,p.v,_ssfopts);
	} catch(e) { if(opts.WTF) throw e; }
	if(!opts.cellStyles) return;
	if(fillid != null) try {
		p.s = styles.Fills[fillid];
		if (p.s.fgColor && p.s.fgColor.theme && !p.s.fgColor.rgb) {
			p.s.fgColor.rgb = rgb_tint(themes.themeElements.clrScheme[p.s.fgColor.theme].rgb, p.s.fgColor.tint || 0);
			if(opts.WTF) p.s.fgColor.raw_rgb = themes.themeElements.clrScheme[p.s.fgColor.theme].rgb;
		}
		if (p.s.bgColor && p.s.bgColor.theme) {
			p.s.bgColor.rgb = rgb_tint(themes.themeElements.clrScheme[p.s.bgColor.theme].rgb, p.s.bgColor.tint || 0);
			if(opts.WTF) p.s.bgColor.raw_rgb = themes.themeElements.clrScheme[p.s.bgColor.theme].rgb;
		}
	} catch(e) { if(opts.WTF && styles.Fills) throw e; }
}

function check_ws(ws/*:Worksheet*/, sname/*:string*/, i/*:number*/) {
	if(ws && ws['!ref']) {
		var range = safe_decode_range(ws['!ref']);
		if(range.e.c < range.s.c || range.e.r < range.s.r) throw new Error("Bad range (" + i + "): " + ws['!ref']);
	}
}
function parse_ws_xml_dim(ws/*:Worksheet*/, s/*:string*/) {
	var d = safe_decode_range(s);
	if(d.s.r<=d.e.r && d.s.c<=d.e.c && d.s.r>=0 && d.s.c>=0) ws["!ref"] = encode_range(d);
}
var mergecregex = /<(?:\w:)?mergeCell ref="[A-Z0-9:]+"\s*[\/]?>/g;
var sheetdataregex = /<(?:\w+:)?sheetData[^>]*>([\s\S]*)<\/(?:\w+:)?sheetData>/;
var hlinkregex = /<(?:\w:)?hyperlink [^>]*>/mg;
var dimregex = /"(\w*:\w*)"/;
var colregex = /<(?:\w:)?col\b[^>]*[\/]?>/g;
var afregex = /<(?:\w:)?autoFilter[^>]*([\/]|>([\s\S]*)<\/(?:\w:)?autoFilter)>/g;
var marginregex= /<(?:\w:)?pageMargins[^>]*\/>/g;
var sheetprregex = /<(?:\w:)?sheetPr\b(?:[^>a-z][^>]*)?\/>/;
var sheetprregex2= /<(?:\w:)?sheetPr[^>]*(?:[\/]|>([\s\S]*)<\/(?:\w:)?sheetPr)>/;
var svsregex = /<(?:\w:)?sheetViews[^>]*(?:[\/]|>([\s\S]*)<\/(?:\w:)?sheetViews)>/;

/* 18.3 Worksheets */
function parse_ws_xml(data/*:?string*/, opts, idx/*:number*/, rels, wb/*:WBWBProps*/, themes, styles)/*:Worksheet*/ {
	if(!data) return data;
	if(!rels) rels = {'!id':{}};
	if(DENSE != null && opts.dense == null) opts.dense = DENSE;

	/* 18.3.1.99 worksheet CT_Worksheet */
	var s = opts.dense ? ([]/*:any*/) : ({}/*:any*/);
	var refguess/*:Range*/ = ({s: {r:2000000, c:2000000}, e: {r:0, c:0} }/*:any*/);

	var data1 = "", data2 = "";
	var mtch/*:?any*/ = data.match(sheetdataregex);
	if(mtch) {
		data1 = data.slice(0, mtch.index);
		data2 = data.slice(mtch.index + mtch[0].length);
	} else data1 = data2 = data;

	/* 18.3.1.82 sheetPr CT_SheetPr */
	var sheetPr = data1.match(sheetprregex);
	if(sheetPr) parse_ws_xml_sheetpr(sheetPr[0], s, wb, idx);
	else if((sheetPr = data1.match(sheetprregex2))) parse_ws_xml_sheetpr2(sheetPr[0], sheetPr[1]||"", s, wb, idx, styles, themes);

	/* 18.3.1.35 dimension CT_SheetDimension */
	var ridx = (data1.match(/<(?:\w*:)?dimension/)||{index:-1}).index;
	if(ridx > 0) {
		var ref = data1.slice(ridx,ridx+50).match(dimregex);
		if(ref) parse_ws_xml_dim(s, ref[1]);
	}

	/* 18.3.1.88 sheetViews CT_SheetViews */
	var svs = data1.match(svsregex);
	if(svs && svs[1]) parse_ws_xml_sheetviews(svs[1], wb);

	/* 18.3.1.17 cols CT_Cols */
	var columns/*:Array<ColInfo>*/ = [];
	if(opts.cellStyles) {
		/* 18.3.1.13 col CT_Col */
		var cols = data1.match(colregex);
		if(cols) parse_ws_xml_cols(columns, cols);
	}

	/* 18.3.1.80 sheetData CT_SheetData ? */
	if(mtch) parse_ws_xml_data(mtch[1], s, opts, refguess, themes, styles);

	/* 18.3.1.2  autoFilter CT_AutoFilter */
	var afilter = data2.match(afregex);
	if(afilter) s['!autofilter'] = parse_ws_xml_autofilter(afilter[0]);

	/* 18.3.1.55 mergeCells CT_MergeCells */
	var merges/*:Array<Range>*/ = [];
	var _merge = data2.match(mergecregex);
	if(_merge) for(ridx = 0; ridx != _merge.length; ++ridx)
		merges[ridx] = safe_decode_range(_merge[ridx].slice(_merge[ridx].indexOf("\"")+1));

	/* 18.3.1.48 hyperlinks CT_Hyperlinks */
	var hlink = data2.match(hlinkregex);
	if(hlink) parse_ws_xml_hlinks(s, hlink, rels);

	/* 18.3.1.62 pageMargins CT_PageMargins */
	var margins = data2.match(marginregex);
	if(margins) s['!margins'] = parse_ws_xml_margins(parsexmltag(margins[0]));

	if(!s["!ref"] && refguess.e.c >= refguess.s.c && refguess.e.r >= refguess.s.r) s["!ref"] = encode_range(refguess);
	if(opts.sheetRows > 0 && s["!ref"]) {
		var tmpref = safe_decode_range(s["!ref"]);
		if(opts.sheetRows <= +tmpref.e.r) {
			tmpref.e.r = opts.sheetRows - 1;
			if(tmpref.e.r > refguess.e.r) tmpref.e.r = refguess.e.r;
			if(tmpref.e.r < tmpref.s.r) tmpref.s.r = tmpref.e.r;
			if(tmpref.e.c > refguess.e.c) tmpref.e.c = refguess.e.c;
			if(tmpref.e.c < tmpref.s.c) tmpref.s.c = tmpref.e.c;
			s["!fullref"] = s["!ref"];
			s["!ref"] = encode_range(tmpref);
		}
	}
	if(columns.length > 0) s["!cols"] = columns;
	if(merges.length > 0) s["!merges"] = merges;
	return s;
}

function write_ws_xml_merges(merges/*:Array<Range>*/)/*:string*/ {
	if(merges.length === 0) return "";
	var o = '<mergeCells count="' + merges.length + '">';
	for(var i = 0; i != merges.length; ++i) o += '<mergeCell ref="' + encode_range(merges[i]) + '"/>';
	return o + '</mergeCells>';
}

/* 18.3.1.82-3 sheetPr CT_ChartsheetPr / CT_SheetPr */
function parse_ws_xml_sheetpr(sheetPr/*:string*/, s, wb/*:WBWBProps*/, idx/*:number*/) {
	var data = parsexmltag(sheetPr);
	if(!wb.Sheets[idx]) wb.Sheets[idx] = {};
	if(data.codeName) wb.Sheets[idx].CodeName = unescapexml(utf8read(data.codeName));
}
function parse_ws_xml_sheetpr2(sheetPr/*:string*/, body/*:string*/, s, wb/*:WBWBProps*/, idx/*:number*/) {
	parse_ws_xml_sheetpr(sheetPr.slice(0, sheetPr.indexOf(">")), s, wb, idx);
}
function write_ws_xml_sheetpr(ws, wb, idx, opts, o) {
	var needed = false;
	var props = {}, payload = null;
	if(opts.bookType !== 'xlsx' && wb.vbaraw) {
		var cname = wb.SheetNames[idx];
		try { if(wb.Workbook) cname = wb.Workbook.Sheets[idx].CodeName || cname; } catch(e) {}
		needed = true;
		props.codeName = utf8write(escapexml(cname));
	}

	if(ws && ws["!outline"]) {
		var outlineprops = {summaryBelow:1, summaryRight:1};
		if(ws["!outline"].above) outlineprops.summaryBelow = 0;
		if(ws["!outline"].left) outlineprops.summaryRight = 0;
		payload = (payload||"") + writextag('outlinePr', null, outlineprops);
	}

	if(!needed && !payload) return;
	o[o.length] = (writextag('sheetPr', payload, props));
}

/* 18.3.1.85 sheetProtection CT_SheetProtection */
var sheetprot_deffalse = ["objects", "scenarios", "selectLockedCells", "selectUnlockedCells"];
var sheetprot_deftrue = [
	"formatColumns", "formatRows", "formatCells",
	"insertColumns", "insertRows", "insertHyperlinks",
	"deleteColumns", "deleteRows",
	"sort", "autoFilter", "pivotTables"
];
function write_ws_xml_protection(sp)/*:string*/ {
	// algorithmName, hashValue, saltValue, spinCount
	var o = ({sheet:1}/*:any*/);
	sheetprot_deffalse.forEach(function(n) { if(sp[n] != null && sp[n]) o[n] = "1"; });
	sheetprot_deftrue.forEach(function(n) { if(sp[n] != null && !sp[n]) o[n] = "0"; });
	/* TODO: algorithm */
	if(sp.password) o.password = crypto_CreatePasswordVerifier_Method1(sp.password).toString(16).toUpperCase();
	return writextag('sheetProtection', null, o);
}

function parse_ws_xml_hlinks(s, data/*:Array<string>*/, rels) {
	var dense = Array.isArray(s);
	for(var i = 0; i != data.length; ++i) {
		var val = parsexmltag(utf8read(data[i]), true);
		if(!val.ref) return;
		var rel = ((rels || {})['!id']||[])[val.id];
		if(rel) {
			val.Target = rel.Target;
			if(val.location) val.Target += "#"+unescapexml(val.location);
		} else {
			val.Target = "#" + unescapexml(val.location);
			rel = {Target: val.Target, TargetMode: 'Internal'};
		}
		val.Rel = rel;
		if(val.tooltip) { val.Tooltip = val.tooltip; delete val.tooltip; }
		var rng = safe_decode_range(val.ref);
		for(var R=rng.s.r;R<=rng.e.r;++R) for(var C=rng.s.c;C<=rng.e.c;++C) {
			var addr = encode_cell({c:C,r:R});
			if(dense) {
				if(!s[R]) s[R] = [];
				if(!s[R][C]) s[R][C] = {t:"z",v:undefined};
				s[R][C].l = val;
			} else {
				if(!s[addr]) s[addr] = {t:"z",v:undefined};
				s[addr].l = val;
			}
		}
	}
}

function parse_ws_xml_margins(margin) {
	var o = {};
	["left", "right", "top", "bottom", "header", "footer"].forEach(function(k) {
		if(margin[k]) o[k] = parseFloat(margin[k]);
	});
	return o;
}
function write_ws_xml_margins(margin)/*:string*/ {
	default_margins(margin);
	return writextag('pageMargins', null, margin);
}

function parse_ws_xml_cols(columns, cols) {
	var seencol = false;
	for(var coli = 0; coli != cols.length; ++coli) {
		var coll = parsexmltag(cols[coli], true);
		if(coll.hidden) coll.hidden = parsexmlbool(coll.hidden);
		var colm=parseInt(coll.min, 10)-1, colM=parseInt(coll.max,10)-1;
		if(coll.outlineLevel) coll.level = (+coll.outlineLevel || 0);
		delete coll.min; delete coll.max; coll.width = +coll.width;
		if(!seencol && coll.width) { seencol = true; find_mdw_colw(coll.width); }
		process_col(coll);
		while(colm <= colM) columns[colm++] = dup(coll);
	}
}
function write_ws_xml_cols(ws, cols)/*:string*/ {
	var o = ["<cols>"], col;
	for(var i = 0; i != cols.length; ++i) {
		if(!(col = cols[i])) continue;
		o[o.length] = (writextag('col', null, col_obj_w(i, col)));
	}
	o[o.length] = "</cols>";
	return o.join("");
}

function parse_ws_xml_autofilter(data/*:string*/) {
	var o = { ref: (data.match(/ref="([^"]*)"/)||[])[1]};
	return o;
}
function write_ws_xml_autofilter(data, ws, wb, idx)/*:string*/ {
	var ref = typeof data.ref == "string" ? data.ref : encode_range(data.ref);
	if(!wb.Workbook) wb.Workbook = ({Sheets:[]}/*:any*/);
	if(!wb.Workbook.Names) wb.Workbook.Names = [];
	var names/*: Array<any> */ = wb.Workbook.Names;
	var range = decode_range(ref);
	if(range.s.r == range.e.r) { range.e.r = decode_range(ws["!ref"]).e.r; ref = encode_range(range); }
	for(var i = 0; i < names.length; ++i) {
		var name = names[i];
		if(name.Name != '_xlnm._FilterDatabase') continue;
		if(name.Sheet != idx) continue;
		name.Ref = "'" + wb.SheetNames[idx] + "'!" + ref; break;
	}
	if(i == names.length) names.push({ Name: '_xlnm._FilterDatabase', Sheet: idx, Ref: "'" + wb.SheetNames[idx] + "'!" + ref  });
	return writextag("autoFilter", null, {ref:ref});
}

/* 18.3.1.88 sheetViews CT_SheetViews */
/* 18.3.1.87 sheetView CT_SheetView */
var sviewregex = /<(?:\w:)?sheetView(?:[^>a-z][^>]*)?\/?>/;
function parse_ws_xml_sheetviews(data, wb/*:WBWBProps*/) {
	if(!wb.Views) wb.Views = [{}];
	(data.match(sviewregex)||[]).forEach(function(r/*:string*/, i/*:number*/) {
		var tag = parsexmltag(r);
		// $FlowIgnore
		if(!wb.Views[i]) wb.Views[i] = {};
		// $FlowIgnore
		if(+tag.zoomScale) wb.Views[i].zoom = +tag.zoomScale;
		// $FlowIgnore
		if(parsexmlbool(tag.rightToLeft)) wb.Views[i].RTL = true;
	});
}
function write_ws_xml_sheetviews(ws, opts, idx, wb)/*:string*/ {
	var sview = ({workbookViewId:"0"}/*:any*/);
	// $FlowIgnore
	if((((wb||{}).Workbook||{}).Views||[])[0]) sview.rightToLeft = wb.Workbook.Views[0].RTL ? "1" : "0";
	return writextag("sheetViews", writextag("sheetView", null, sview), {});
}

function write_ws_xml_cell(cell/*:Cell*/, ref, ws, opts/*::, idx, wb*/)/*:string*/ {
	if(cell.c) ws['!comments'].push([ref, cell.c]);
	if(cell.v === undefined && typeof cell.f !== "string" || cell.t === 'z' && !cell.f) return "";
	var vv = "";
	var oldt = cell.t, oldv = cell.v;
	if(cell.t !== "z") switch(cell.t) {
		case 'b': vv = cell.v ? "1" : "0"; break;
		case 'n': vv = ''+cell.v; break;
		case 'e': vv = BErr[cell.v]; break;
		case 'd':
			if(opts && opts.cellDates) vv = parseDate(cell.v, -1).toISOString();
			else {
				cell = dup(cell);
				cell.t = 'n';
				vv = ''+(cell.v = datenum(parseDate(cell.v)));
			}
			if(typeof cell.z === 'undefined') cell.z = table_fmt[14];
			break;
		default: vv = cell.v; break;
	}
	var v = writetag('v', escapexml(vv)), o = ({r:ref}/*:any*/);
	/* TODO: cell style */
	var os = get_cell_style(opts.cellXfs, cell, opts);
	if(os !== 0) o.s = os;
	switch(cell.t) {
		case 'n': break;
		case 'd': o.t = "d"; break;
		case 'b': o.t = "b"; break;
		case 'e': o.t = "e"; break;
		case 'z': break;
		default: if(cell.v == null) { delete cell.t; break; }
			if(cell.v.length > 32767) throw new Error("Text length must not exceed 32767 characters");
			if(opts && opts.bookSST) {
				v = writetag('v', ''+get_sst_id(opts.Strings, cell.v, opts.revStrings));
				o.t = "s"; break;
			}
			o.t = "str"; break;
	}
	if(cell.t != oldt) { cell.t = oldt; cell.v = oldv; }
	if(typeof cell.f == "string" && cell.f) {
		var ff = cell.F && cell.F.slice(0, ref.length) == ref ? {t:"array", ref:cell.F} : null;
		v = writextag('f', escapexml(cell.f), ff) + (cell.v != null ? v : "");
	}
	if(cell.l) ws['!links'].push([ref, cell.l]);
	if(cell.D) o.cm = 1;
	return writextag('c', v, o);
}

var parse_ws_xml_data = /*#__PURE__*/(/* unused pure expression or super */ null && ((function() {
	var cellregex = /<(?:\w+:)?c[ \/>]/, rowregex = /<\/(?:\w+:)?row>/;
	var rregex = /r=["']([^"']*)["']/, isregex = /<(?:\w+:)?is>([\S\s]*?)<\/(?:\w+:)?is>/;
	var refregex = /ref=["']([^"']*)["']/;
	var match_v = matchtag("v"), match_f = matchtag("f");

return function parse_ws_xml_data(sdata/*:string*/, s, opts, guess/*:Range*/, themes, styles) {
	var ri = 0, x = "", cells/*:Array<string>*/ = [], cref/*:?Array<string>*/ = [], idx=0, i=0, cc=0, d="", p/*:any*/;
	var tag, tagr = 0, tagc = 0;
	var sstr, ftag;
	var fmtid = 0, fillid = 0;
	var do_format = Array.isArray(styles.CellXf), cf;
	var arrayf/*:Array<[Range, string]>*/ = [];
	var sharedf = [];
	var dense = Array.isArray(s);
	var rows/*:Array<RowInfo>*/ = [], rowobj = {}, rowrite = false;
	var sheetStubs = !!opts.sheetStubs;
	for(var marr = sdata.split(rowregex), mt = 0, marrlen = marr.length; mt != marrlen; ++mt) {
		x = marr[mt].trim();
		var xlen = x.length;
		if(xlen === 0) continue;

		/* 18.3.1.73 row CT_Row */
		var rstarti = 0;
		outa: for(ri = 0; ri < xlen; ++ri) switch(/*x.charCodeAt(ri)*/x[ri]) {
			case ">" /*62*/:
				if(/*x.charCodeAt(ri-1) != 47*/x[ri-1] != "/") { ++ri; break outa; }
				if(opts && opts.cellStyles) {
					// TODO: avoid duplication
					tag = parsexmltag(x.slice(rstarti,ri), true);
					tagr = tag.r != null ? parseInt(tag.r, 10) : tagr+1; tagc = -1;
					if(opts.sheetRows && opts.sheetRows < tagr) continue;
					rowobj = {}; rowrite = false;
					if(tag.ht) { rowrite = true; rowobj.hpt = parseFloat(tag.ht); rowobj.hpx = pt2px(rowobj.hpt); }
					if(tag.hidden == "1") { rowrite = true; rowobj.hidden = true; }
					if(tag.outlineLevel != null) { rowrite = true; rowobj.level = +tag.outlineLevel; }
					if(rowrite) rows[tagr-1] = rowobj;
				}
				break;
			case "<" /*60*/: rstarti = ri; break;
		}
		if(rstarti >= ri) break;
		tag = parsexmltag(x.slice(rstarti,ri), true);
		tagr = tag.r != null ? parseInt(tag.r, 10) : tagr+1; tagc = -1;
		if(opts.sheetRows && opts.sheetRows < tagr) continue;
		if(guess.s.r > tagr - 1) guess.s.r = tagr - 1;
		if(guess.e.r < tagr - 1) guess.e.r = tagr - 1;

		if(opts && opts.cellStyles) {
			rowobj = {}; rowrite = false;
			if(tag.ht) { rowrite = true; rowobj.hpt = parseFloat(tag.ht); rowobj.hpx = pt2px(rowobj.hpt); }
			if(tag.hidden == "1") { rowrite = true; rowobj.hidden = true; }
			if(tag.outlineLevel != null) { rowrite = true; rowobj.level = +tag.outlineLevel; }
			if(rowrite) rows[tagr-1] = rowobj;
		}

		/* 18.3.1.4 c CT_Cell */
		cells = x.slice(ri).split(cellregex);
		for(var rslice = 0; rslice != cells.length; ++rslice) if(cells[rslice].trim().charAt(0) != "<") break;
		cells = cells.slice(rslice);
		for(ri = 0; ri != cells.length; ++ri) {
			x = cells[ri].trim();
			if(x.length === 0) continue;
			cref = x.match(rregex); idx = ri; i=0; cc=0;
			x = "<c " + (x.slice(0,1)=="<"?">":"") + x;
			if(cref != null && cref.length === 2) {
				idx = 0; d=cref[1];
				for(i=0; i != d.length; ++i) {
					if((cc=d.charCodeAt(i)-64) < 1 || cc > 26) break;
					idx = 26*idx + cc;
				}
				--idx;
				tagc = idx;
			} else ++tagc;
			for(i = 0; i != x.length; ++i) if(x.charCodeAt(i) === 62) break; ++i;
			tag = parsexmltag(x.slice(0,i), true);
			if(!tag.r) tag.r = encode_cell({r:tagr-1, c:tagc});
			d = x.slice(i);
			p = ({t:""}/*:any*/);

			if((cref=d.match(match_v))!= null && /*::cref != null && */cref[1] !== '') p.v=unescapexml(cref[1]);
			if(opts.cellFormula) {
				if((cref=d.match(match_f))!= null && /*::cref != null && */cref[1] !== '') {
					/* TODO: match against XLSXFutureFunctions */
					p.f=unescapexml(utf8read(cref[1])).replace(/\r\n/g, "\n");
					if(!opts.xlfn) p.f = _xlfn(p.f);
					if(/*::cref != null && cref[0] != null && */cref[0].indexOf('t="array"') > -1) {
						p.F = (d.match(refregex)||[])[1];
						if(p.F.indexOf(":") > -1) arrayf.push([safe_decode_range(p.F), p.F]);
					} else if(/*::cref != null && cref[0] != null && */cref[0].indexOf('t="shared"') > -1) {
						// TODO: parse formula
						ftag = parsexmltag(cref[0]);
						var ___f = unescapexml(utf8read(cref[1]));
						if(!opts.xlfn) ___f = _xlfn(___f);
						sharedf[parseInt(ftag.si, 10)] = [ftag, ___f, tag.r];
					}
				} else if((cref=d.match(/<f[^>]*\/>/))) {
					ftag = parsexmltag(cref[0]);
					if(sharedf[ftag.si]) p.f = shift_formula_xlsx(sharedf[ftag.si][1], sharedf[ftag.si][2]/*[0].ref*/, tag.r);
				}
				/* TODO: factor out contains logic */
				var _tag = decode_cell(tag.r);
				for(i = 0; i < arrayf.length; ++i)
					if(_tag.r >= arrayf[i][0].s.r && _tag.r <= arrayf[i][0].e.r)
						if(_tag.c >= arrayf[i][0].s.c && _tag.c <= arrayf[i][0].e.c)
							p.F = arrayf[i][1];
			}

			if(tag.t == null && p.v === undefined) {
				if(p.f || p.F) {
					p.v = 0; p.t = "n";
				} else if(!sheetStubs) continue;
				else p.t = "z";
			}
			else p.t = tag.t || "n";
			if(guess.s.c > tagc) guess.s.c = tagc;
			if(guess.e.c < tagc) guess.e.c = tagc;
			/* 18.18.11 t ST_CellType */
			switch(p.t) {
				case 'n':
					if(p.v == "" || p.v == null) {
						if(!sheetStubs) continue;
						p.t = 'z';
					} else p.v = parseFloat(p.v);
					break;
				case 's':
					if(typeof p.v == 'undefined') {
						if(!sheetStubs) continue;
						p.t = 'z';
					} else {
						sstr = strs[parseInt(p.v, 10)];
						p.v = sstr.t;
						p.r = sstr.r;
						if(opts.cellHTML) p.h = sstr.h;
					}
					break;
				case 'str':
					p.t = "s";
					p.v = (p.v!=null) ? utf8read(p.v) : '';
					if(opts.cellHTML) p.h = escapehtml(p.v);
					break;
				case 'inlineStr':
					cref = d.match(isregex);
					p.t = 's';
					if(cref != null && (sstr = parse_si(cref[1]))) {
						p.v = sstr.t;
						if(opts.cellHTML) p.h = sstr.h;
					} else p.v = "";
					break;
				case 'b': p.v = parsexmlbool(p.v); break;
				case 'd':
					if(opts.cellDates) p.v = parseDate(p.v, 1);
					else { p.v = datenum(parseDate(p.v, 1)); p.t = 'n'; }
					break;
				/* error string in .w, number in .v */
				case 'e':
					if(!opts || opts.cellText !== false) p.w = p.v;
					p.v = RBErr[p.v]; break;
			}
			/* formatting */
			fmtid = fillid = 0;
			cf = null;
			if(do_format && tag.s !== undefined) {
				cf = styles.CellXf[tag.s];
				if(cf != null) {
					if(cf.numFmtId != null) fmtid = cf.numFmtId;
					if(opts.cellStyles) {
						if(cf.fillId != null) fillid = cf.fillId;
					}
				}
			}
			safe_format(p, fmtid, fillid, opts, themes, styles);
			if(opts.cellDates && do_format && p.t == 'n' && fmt_is_date(table_fmt[fmtid])) { p.t = 'd'; p.v = numdate(p.v); }
			if(tag.cm && opts.xlmeta) {
				var cm = (opts.xlmeta.Cell||[])[+tag.cm-1];
				if(cm && cm.type == 'XLDAPR') p.D = true;
			}
			if(dense) {
				var _r = decode_cell(tag.r);
				if(!s[_r.r]) s[_r.r] = [];
				s[_r.r][_r.c] = p;
			} else s[tag.r] = p;
		}
	}
	if(rows.length > 0) s['!rows'] = rows;
}; })()));

function write_ws_xml_data(ws/*:Worksheet*/, opts, idx/*:number*/, wb/*:Workbook*//*::, rels*/)/*:string*/ {
	var o/*:Array<string>*/ = [], r/*:Array<string>*/ = [], range = safe_decode_range(ws['!ref']), cell="", ref, rr = "", cols/*:Array<string>*/ = [], R=0, C=0, rows = ws['!rows'];
	var dense = Array.isArray(ws);
	var params = ({r:rr}/*:any*/), row/*:RowInfo*/, height = -1;
	for(C = range.s.c; C <= range.e.c; ++C) cols[C] = encode_col(C);
	for(R = range.s.r; R <= range.e.r; ++R) {
		r = [];
		rr = encode_row(R);
		for(C = range.s.c; C <= range.e.c; ++C) {
			ref = cols[C] + rr;
			var _cell = dense ? (ws[R]||[])[C]: ws[ref];
			if(_cell === undefined) continue;
			if((cell = write_ws_xml_cell(_cell, ref, ws, opts, idx, wb)) != null) r.push(cell);
		}
		if(r.length > 0 || (rows && rows[R])) {
			params = ({r:rr}/*:any*/);
			if(rows && rows[R]) {
				row = rows[R];
				if(row.hidden) params.hidden = 1;
				height = -1;
				if(row.hpx) height = px2pt(row.hpx);
				else if(row.hpt) height = row.hpt;
				if(height > -1) { params.ht = height; params.customHeight = 1; }
				if(row.level) { params.outlineLevel = row.level; }
			}
			o[o.length] = (writextag('row', r.join(""), params));
		}
	}
	if(rows) for(; R < rows.length; ++R) {
		if(rows && rows[R]) {
			params = ({r:R+1}/*:any*/);
			row = rows[R];
			if(row.hidden) params.hidden = 1;
			height = -1;
			if (row.hpx) height = px2pt(row.hpx);
			else if (row.hpt) height = row.hpt;
			if (height > -1) { params.ht = height; params.customHeight = 1; }
			if (row.level) { params.outlineLevel = row.level; }
			o[o.length] = (writextag('row', "", params));
		}
	}
	return o.join("");
}

function write_ws_xml(idx/*:number*/, opts, wb/*:Workbook*/, rels)/*:string*/ {
	var o = [XML_HEADER, writextag('worksheet', null, {
		'xmlns': XMLNS_main[0],
		'xmlns:r': XMLNS.r
	})];
	var s = wb.SheetNames[idx], sidx = 0, rdata = "";
	var ws = wb.Sheets[s];
	if(ws == null) ws = {};
	var ref = ws['!ref'] || 'A1';
	var range = safe_decode_range(ref);
	if(range.e.c > 0x3FFF || range.e.r > 0xFFFFF) {
		if(opts.WTF) throw new Error("Range " + ref + " exceeds format limit A1:XFD1048576");
		range.e.c = Math.min(range.e.c, 0x3FFF);
		range.e.r = Math.min(range.e.c, 0xFFFFF);
		ref = encode_range(range);
	}
	if(!rels) rels = {};
	ws['!comments'] = [];
	var _drawing = [];

	write_ws_xml_sheetpr(ws, wb, idx, opts, o);

	o[o.length] = (writextag('dimension', null, {'ref': ref}));

	o[o.length] = write_ws_xml_sheetviews(ws, opts, idx, wb);

	/* TODO: store in WB, process styles */
	if(opts.sheetFormat) o[o.length] = (writextag('sheetFormatPr', null, {
		defaultRowHeight:opts.sheetFormat.defaultRowHeight||'16',
		baseColWidth:opts.sheetFormat.baseColWidth||'10',
		outlineLevelRow:opts.sheetFormat.outlineLevelRow||'7'
	}));

	if(ws['!cols'] != null && ws['!cols'].length > 0) o[o.length] = (write_ws_xml_cols(ws, ws['!cols']));

	o[sidx = o.length] = '<sheetData/>';
	ws['!links'] = [];
	if(ws['!ref'] != null) {
		rdata = write_ws_xml_data(ws, opts, idx, wb, rels);
		if(rdata.length > 0) o[o.length] = (rdata);
	}
	if(o.length>sidx+1) { o[o.length] = ('</sheetData>'); o[sidx]=o[sidx].replace("/>",">"); }

	/* sheetCalcPr */

	if(ws['!protect']) o[o.length] = write_ws_xml_protection(ws['!protect']);

	/* protectedRanges */
	/* scenarios */

	if(ws['!autofilter'] != null) o[o.length] = write_ws_xml_autofilter(ws['!autofilter'], ws, wb, idx);

	/* sortState */
	/* dataConsolidate */
	/* customSheetViews */

	if(ws['!merges'] != null && ws['!merges'].length > 0) o[o.length] = (write_ws_xml_merges(ws['!merges']));

	/* phoneticPr */
	/* conditionalFormatting */
	/* dataValidations */

	var relc = -1, rel, rId = -1;
	if(/*::(*/ws['!links']/*::||[])*/.length > 0) {
		o[o.length] = "<hyperlinks>";
		/*::(*/ws['!links']/*::||[])*/.forEach(function(l) {
			if(!l[1].Target) return;
			rel = ({"ref":l[0]}/*:any*/);
			if(l[1].Target.charAt(0) != "#") {
				rId = add_rels(rels, -1, escapexml(l[1].Target).replace(/#.*$/, ""), RELS.HLINK);
				rel["r:id"] = "rId"+rId;
			}
			if((relc = l[1].Target.indexOf("#")) > -1) rel.location = escapexml(l[1].Target.slice(relc+1));
			if(l[1].Tooltip) rel.tooltip = escapexml(l[1].Tooltip);
			o[o.length] = writextag("hyperlink",null,rel);
		});
		o[o.length] = "</hyperlinks>";
	}
	delete ws['!links'];

	/* printOptions */

	if(ws['!margins'] != null) o[o.length] =  write_ws_xml_margins(ws['!margins']);

	/* pageSetup */
	/* headerFooter */
	/* rowBreaks */
	/* colBreaks */
	/* customProperties */
	/* cellWatches */

	if(!opts || opts.ignoreEC || (opts.ignoreEC == (void 0))) o[o.length] = writetag("ignoredErrors", writextag("ignoredError", null, {numberStoredAsText:1, sqref:ref}));

	/* smartTags */

	if(_drawing.length > 0) {
		rId = add_rels(rels, -1, "../drawings/drawing" + (idx+1) + ".xml", RELS.DRAW);
		o[o.length] = writextag("drawing", null, {"r:id":"rId" + rId});
		ws['!drawing'] = _drawing;
	}

	if(ws['!comments'].length > 0) {
		rId = add_rels(rels, -1, "../drawings/vmlDrawing" + (idx+1) + ".vml", RELS.VML);
		o[o.length] = writextag("legacyDrawing", null, {"r:id":"rId" + rId});
		ws['!legacy'] = rId;
	}

	/* legacyDrawingHF */
	/* picture */
	/* oleObjects */
	/* controls */
	/* webPublishItems */
	/* tableParts */
	/* extLst */

	if(o.length>1) { o[o.length] = ('</worksheet>'); o[1]=o[1].replace("/>",">"); }
	return o.join("");
}

/* [MS-XLSB] 2.4.726 BrtRowHdr */
function parse_BrtRowHdr(data, length) {
	var z = ({}/*:any*/);
	var tgt = data.l + length;
	z.r = data.read_shift(4);
	data.l += 4; // TODO: ixfe
	var miyRw = data.read_shift(2);
	data.l += 1; // TODO: top/bot padding
	var flags = data.read_shift(1);
	data.l = tgt;
	if(flags & 0x07) z.level = flags & 0x07;
	if(flags & 0x10) z.hidden = true;
	if(flags & 0x20) z.hpt = miyRw / 20;
	return z;
}
function write_BrtRowHdr(R/*:number*/, range, ws) {
	var o = new_buf(17+8*16);
	var row = (ws['!rows']||[])[R]||{};
	o.write_shift(4, R);

	o.write_shift(4, 0); /* TODO: ixfe */

	var miyRw = 0x0140;
	if(row.hpx) miyRw = px2pt(row.hpx) * 20;
	else if(row.hpt) miyRw = row.hpt * 20;
	o.write_shift(2, miyRw);

	o.write_shift(1, 0); /* top/bot padding */

	var flags = 0x0;
	if(row.level) flags |= row.level;
	if(row.hidden) flags |= 0x10;
	if(row.hpx || row.hpt) flags |= 0x20;
	o.write_shift(1, flags);

	o.write_shift(1, 0); /* phonetic guide */

	/* [MS-XLSB] 2.5.8 BrtColSpan explains the mechanism */
	var ncolspan = 0, lcs = o.l;
	o.l += 4;

	var caddr = {r:R, c:0};
	for(var i = 0; i < 16; ++i) {
		if((range.s.c > ((i+1) << 10)) || (range.e.c < (i << 10))) continue;
		var first = -1, last = -1;
		for(var j = (i<<10); j < ((i+1)<<10); ++j) {
			caddr.c = j;
			var cell = Array.isArray(ws) ? (ws[caddr.r]||[])[caddr.c] : ws[encode_cell(caddr)];
			if(cell) { if(first < 0) first = j; last = j; }
		}
		if(first < 0) continue;
		++ncolspan;
		o.write_shift(4, first);
		o.write_shift(4, last);
	}

	var l = o.l;
	o.l = lcs;
	o.write_shift(4, ncolspan);
	o.l = l;

	return o.length > o.l ? o.slice(0, o.l) : o;
}
function write_row_header(ba, ws, range, R) {
	var o = write_BrtRowHdr(R, range, ws);
	if((o.length > 17) || (ws['!rows']||[])[R]) write_record(ba, 0x0000 /* BrtRowHdr */, o);
}

/* [MS-XLSB] 2.4.820 BrtWsDim */
var parse_BrtWsDim = parse_UncheckedRfX;
var write_BrtWsDim = write_UncheckedRfX;

/* [MS-XLSB] 2.4.821 BrtWsFmtInfo */
function parse_BrtWsFmtInfo(/*::data, length*/) {
}
//function write_BrtWsFmtInfo(ws, o) { }

/* [MS-XLSB] 2.4.823 BrtWsProp */
function parse_BrtWsProp(data, length) {
	var z = {};
	var f = data[data.l]; ++data.l;
	z.above = !(f & 0x40);
	z.left  = !(f & 0x80);
	/* TODO: pull flags */
	data.l += 18;
	z.name = parse_XLSBCodeName(data, length - 19);
	return z;
}
function write_BrtWsProp(str, outl, o) {
	if(o == null) o = new_buf(84+4*str.length);
	var f = 0xC0;
	if(outl) {
		if(outl.above) f &= ~0x40;
		if(outl.left)  f &= ~0x80;
	}
	o.write_shift(1, f);
	for(var i = 1; i < 3; ++i) o.write_shift(1,0);
	write_BrtColor({auto:1}, o);
	o.write_shift(-4,-1);
	o.write_shift(-4,-1);
	write_XLSBCodeName(str, o);
	return o.slice(0, o.l);
}

/* [MS-XLSB] 2.4.306 BrtCellBlank */
function parse_BrtCellBlank(data) {
	var cell = parse_XLSBCell(data);
	return [cell];
}
function write_BrtCellBlank(cell, ncell, o) {
	if(o == null) o = new_buf(8);
	return write_XLSBCell(ncell, o);
}
function parse_BrtShortBlank(data) {
	var cell = parse_XLSBShortCell(data);
	return [cell];
}
function write_BrtShortBlank(cell, ncell, o) {
	if(o == null) o = new_buf(4);
	return write_XLSBShortCell(ncell, o);
}

/* [MS-XLSB] 2.4.307 BrtCellBool */
function parse_BrtCellBool(data) {
	var cell = parse_XLSBCell(data);
	var fBool = data.read_shift(1);
	return [cell, fBool, 'b'];
}
function write_BrtCellBool(cell, ncell, o) {
	if(o == null) o = new_buf(9);
	write_XLSBCell(ncell, o);
	o.write_shift(1, cell.v ? 1 : 0);
	return o;
}
function parse_BrtShortBool(data) {
	var cell = parse_XLSBShortCell(data);
	var fBool = data.read_shift(1);
	return [cell, fBool, 'b'];
}
function write_BrtShortBool(cell, ncell, o) {
	if(o == null) o = new_buf(5);
	write_XLSBShortCell(ncell, o);
	o.write_shift(1, cell.v ? 1 : 0);
	return o;
}

/* [MS-XLSB] 2.4.308 BrtCellError */
function parse_BrtCellError(data) {
	var cell = parse_XLSBCell(data);
	var bError = data.read_shift(1);
	return [cell, bError, 'e'];
}
function write_BrtCellError(cell, ncell, o) {
	if(o == null) o = new_buf(9);
	write_XLSBCell(ncell, o);
	o.write_shift(1, cell.v);
	return o;
}
function parse_BrtShortError(data) {
	var cell = parse_XLSBShortCell(data);
	var bError = data.read_shift(1);
	return [cell, bError, 'e'];
}
function write_BrtShortError(cell, ncell, o) {
	if(o == null) o = new_buf(8);
	write_XLSBShortCell(ncell, o);
	o.write_shift(1, cell.v);
	o.write_shift(2, 0);
	o.write_shift(1, 0);
	return o;
}


/* [MS-XLSB] 2.4.311 BrtCellIsst */
function parse_BrtCellIsst(data) {
	var cell = parse_XLSBCell(data);
	var isst = data.read_shift(4);
	return [cell, isst, 's'];
}
function write_BrtCellIsst(cell, ncell, o) {
	if(o == null) o = new_buf(12);
	write_XLSBCell(ncell, o);
	o.write_shift(4, ncell.v);
	return o;
}
function parse_BrtShortIsst(data) {
	var cell = parse_XLSBShortCell(data);
	var isst = data.read_shift(4);
	return [cell, isst, 's'];
}
function write_BrtShortIsst(cell, ncell, o) {
	if(o == null) o = new_buf(8);
	write_XLSBShortCell(ncell, o);
	o.write_shift(4, ncell.v);
	return o;
}

/* [MS-XLSB] 2.4.313 BrtCellReal */
function parse_BrtCellReal(data) {
	var cell = parse_XLSBCell(data);
	var value = parse_Xnum(data);
	return [cell, value, 'n'];
}
function write_BrtCellReal(cell, ncell, o) {
	if(o == null) o = new_buf(16);
	write_XLSBCell(ncell, o);
	write_Xnum(cell.v, o);
	return o;
}
function parse_BrtShortReal(data) {
	var cell = parse_XLSBShortCell(data);
	var value = parse_Xnum(data);
	return [cell, value, 'n'];
}
function write_BrtShortReal(cell, ncell, o) {
	if(o == null) o = new_buf(12);
	write_XLSBShortCell(ncell, o);
	write_Xnum(cell.v, o);
	return o;
}

/* [MS-XLSB] 2.4.314 BrtCellRk */
function parse_BrtCellRk(data) {
	var cell = parse_XLSBCell(data);
	var value = parse_RkNumber(data);
	return [cell, value, 'n'];
}
function write_BrtCellRk(cell, ncell, o) {
	if(o == null) o = new_buf(12);
	write_XLSBCell(ncell, o);
	write_RkNumber(cell.v, o);
	return o;
}
function parse_BrtShortRk(data) {
	var cell = parse_XLSBShortCell(data);
	var value = parse_RkNumber(data);
	return [cell, value, 'n'];
}
function write_BrtShortRk(cell, ncell, o) {
	if(o == null) o = new_buf(8);
	write_XLSBShortCell(ncell, o);
	write_RkNumber(cell.v, o);
	return o;
}

/* [MS-XLSB] 2.4.323 BrtCellRString */
function parse_BrtCellRString(data) {
	var cell = parse_XLSBCell(data);
	var value = parse_RichStr(data);
	return [cell, value, 'is'];
}

/* [MS-XLSB] 2.4.317 BrtCellSt */
function parse_BrtCellSt(data) {
	var cell = parse_XLSBCell(data);
	var value = parse_XLWideString(data);
	return [cell, value, 'str'];
}
function write_BrtCellSt(cell, ncell, o) {
	if(o == null) o = new_buf(12 + 4 * cell.v.length);
	write_XLSBCell(ncell, o);
	write_XLWideString(cell.v, o);
	return o.length > o.l ? o.slice(0, o.l) : o;
}
function parse_BrtShortSt(data) {
	var cell = parse_XLSBShortCell(data);
	var value = parse_XLWideString(data);
	return [cell, value, 'str'];
}
function write_BrtShortSt(cell, ncell, o) {
	if(o == null) o = new_buf(8 + 4 * cell.v.length);
	write_XLSBShortCell(ncell, o);
	write_XLWideString(cell.v, o);
	return o.length > o.l ? o.slice(0, o.l) : o;
}

/* [MS-XLSB] 2.4.653 BrtFmlaBool */
function parse_BrtFmlaBool(data, length, opts) {
	var end = data.l + length;
	var cell = parse_XLSBCell(data);
	cell.r = opts['!row'];
	var value = data.read_shift(1);
	var o = [cell, value, 'b'];
	if(opts.cellFormula) {
		data.l += 2;
		var formula = parse_XLSBCellParsedFormula(data, end - data.l, opts);
		o[3] = stringify_formula(formula, null/*range*/, cell, opts.supbooks, opts);/* TODO */
	}
	else data.l = end;
	return o;
}

/* [MS-XLSB] 2.4.654 BrtFmlaError */
function parse_BrtFmlaError(data, length, opts) {
	var end = data.l + length;
	var cell = parse_XLSBCell(data);
	cell.r = opts['!row'];
	var value = data.read_shift(1);
	var o = [cell, value, 'e'];
	if(opts.cellFormula) {
		data.l += 2;
		var formula = parse_XLSBCellParsedFormula(data, end - data.l, opts);
		o[3] = stringify_formula(formula, null/*range*/, cell, opts.supbooks, opts);/* TODO */
	}
	else data.l = end;
	return o;
}

/* [MS-XLSB] 2.4.655 BrtFmlaNum */
function parse_BrtFmlaNum(data, length, opts) {
	var end = data.l + length;
	var cell = parse_XLSBCell(data);
	cell.r = opts['!row'];
	var value = parse_Xnum(data);
	var o = [cell, value, 'n'];
	if(opts.cellFormula) {
		data.l += 2;
		var formula = parse_XLSBCellParsedFormula(data, end - data.l, opts);
		o[3] = stringify_formula(formula, null/*range*/, cell, opts.supbooks, opts);/* TODO */
	}
	else data.l = end;
	return o;
}

/* [MS-XLSB] 2.4.656 BrtFmlaString */
function parse_BrtFmlaString(data, length, opts) {
	var end = data.l + length;
	var cell = parse_XLSBCell(data);
	cell.r = opts['!row'];
	var value = parse_XLWideString(data);
	var o = [cell, value, 'str'];
	if(opts.cellFormula) {
		data.l += 2;
		var formula = parse_XLSBCellParsedFormula(data, end - data.l, opts);
		o[3] = stringify_formula(formula, null/*range*/, cell, opts.supbooks, opts);/* TODO */
	}
	else data.l = end;
	return o;
}

/* [MS-XLSB] 2.4.682 BrtMergeCell */
var parse_BrtMergeCell = parse_UncheckedRfX;
var write_BrtMergeCell = write_UncheckedRfX;
/* [MS-XLSB] 2.4.107 BrtBeginMergeCells */
function write_BrtBeginMergeCells(cnt, o) {
	if(o == null) o = new_buf(4);
	o.write_shift(4, cnt);
	return o;
}

/* [MS-XLSB] 2.4.662 BrtHLink */
function parse_BrtHLink(data, length/*::, opts*/) {
	var end = data.l + length;
	var rfx = parse_UncheckedRfX(data, 16);
	var relId = parse_XLNullableWideString(data);
	var loc = parse_XLWideString(data);
	var tooltip = parse_XLWideString(data);
	var display = parse_XLWideString(data);
	data.l = end;
	var o = ({rfx:rfx, relId:relId, loc:loc, display:display}/*:any*/);
	if(tooltip) o.Tooltip = tooltip;
	return o;
}
function write_BrtHLink(l, rId) {
	var o = new_buf(50+4*(l[1].Target.length + (l[1].Tooltip || "").length));
	write_UncheckedRfX({s:decode_cell(l[0]), e:decode_cell(l[0])}, o);
	write_RelID("rId" + rId, o);
	var locidx = l[1].Target.indexOf("#");
	var loc = locidx == -1 ? "" : l[1].Target.slice(locidx+1);
	write_XLWideString(loc || "", o);
	write_XLWideString(l[1].Tooltip || "", o);
	write_XLWideString("", o);
	return o.slice(0, o.l);
}

/* [MS-XLSB] 2.4.692 BrtPane */
function parse_BrtPane(/*data, length, opts*/) {
}

/* [MS-XLSB] 2.4.6 BrtArrFmla */
function parse_BrtArrFmla(data, length, opts) {
	var end = data.l + length;
	var rfx = parse_RfX(data, 16);
	var fAlwaysCalc = data.read_shift(1);
	var o = [rfx]; o[2] = fAlwaysCalc;
	if(opts.cellFormula) {
		var formula = parse_XLSBArrayParsedFormula(data, end - data.l, opts);
		o[1] = formula;
	} else data.l = end;
	return o;
}

/* [MS-XLSB] 2.4.750 BrtShrFmla */
function parse_BrtShrFmla(data, length, opts) {
	var end = data.l + length;
	var rfx = parse_UncheckedRfX(data, 16);
	var o = [rfx];
	if(opts.cellFormula) {
		var formula = parse_XLSBSharedParsedFormula(data, end - data.l, opts);
		o[1] = formula;
		data.l = end;
	} else data.l = end;
	return o;
}

/* [MS-XLSB] 2.4.323 BrtColInfo */
/* TODO: once XLS ColInfo is set, combine the functions */
function write_BrtColInfo(C/*:number*/, col, o) {
	if(o == null) o = new_buf(18);
	var p = col_obj_w(C, col);
	o.write_shift(-4, C);
	o.write_shift(-4, C);
	o.write_shift(4, (p.width || 10) * 256);
	o.write_shift(4, 0/*ixfe*/); // style
	var flags = 0;
	if(col.hidden) flags |= 0x01;
	if(typeof p.width == 'number') flags |= 0x02;
	if(col.level) flags |= (col.level << 8);
	o.write_shift(2, flags); // bit flag
	return o;
}

/* [MS-XLSB] 2.4.678 BrtMargins */
var BrtMarginKeys = ["left","right","top","bottom","header","footer"];
function parse_BrtMargins(data/*::, length, opts*/)/*:Margins*/ {
	var margins = ({}/*:any*/);
	BrtMarginKeys.forEach(function(k) { margins[k] = parse_Xnum(data, 8); });
	return margins;
}
function write_BrtMargins(margins/*:Margins*/, o) {
	if(o == null) o = new_buf(6*8);
	default_margins(margins);
	BrtMarginKeys.forEach(function(k) { write_Xnum((margins/*:any*/)[k], o); });
	return o;
}

/* [MS-XLSB] 2.4.299 BrtBeginWsView */
function parse_BrtBeginWsView(data/*::, length, opts*/) {
	var f = data.read_shift(2);
	data.l += 28;
	return { RTL: f & 0x20 };
}
function write_BrtBeginWsView(ws, Workbook, o) {
	if(o == null) o = new_buf(30);
	var f = 0x39c;
	if((((Workbook||{}).Views||[])[0]||{}).RTL) f |= 0x20;
	o.write_shift(2, f); // bit flag
	o.write_shift(4, 0);
	o.write_shift(4, 0); // view first row
	o.write_shift(4, 0); // view first col
	o.write_shift(1, 0); // gridline color ICV
	o.write_shift(1, 0);
	o.write_shift(2, 0);
	o.write_shift(2, 100); // zoom scale
	o.write_shift(2, 0);
	o.write_shift(2, 0);
	o.write_shift(2, 0);
	o.write_shift(4, 0); // workbook view id
	return o;
}

/* [MS-XLSB] 2.4.309 BrtCellIgnoreEC */
function write_BrtCellIgnoreEC(ref) {
	var o = new_buf(24);
	o.write_shift(4, 4);
	o.write_shift(4, 1);
	write_UncheckedRfX(ref, o);
	return o;
}

/* [MS-XLSB] 2.4.748 BrtSheetProtection */
function write_BrtSheetProtection(sp, o) {
	if(o == null) o = new_buf(16*4+2);
	o.write_shift(2, sp.password ? crypto_CreatePasswordVerifier_Method1(sp.password) : 0);
	o.write_shift(4, 1); // this record should not be written if no protection
	[
		["objects",             false], // fObjects
		["scenarios",           false], // fScenarios
		["formatCells",          true], // fFormatCells
		["formatColumns",        true], // fFormatColumns
		["formatRows",           true], // fFormatRows
		["insertColumns",        true], // fInsertColumns
		["insertRows",           true], // fInsertRows
		["insertHyperlinks",     true], // fInsertHyperlinks
		["deleteColumns",        true], // fDeleteColumns
		["deleteRows",           true], // fDeleteRows
		["selectLockedCells",   false], // fSelLockedCells
		["sort",                 true], // fSort
		["autoFilter",           true], // fAutoFilter
		["pivotTables",          true], // fPivotTables
		["selectUnlockedCells", false]  // fSelUnlockedCells
	].forEach(function(n) {
		/*:: if(o == null) throw "unreachable"; */
		if(n[1]) o.write_shift(4, sp[n[0]] != null && !sp[n[0]] ? 1 : 0);
		else      o.write_shift(4, sp[n[0]] != null && sp[n[0]] ? 0 : 1);
	});
	return o;
}

function parse_BrtDVal(/*data, length, opts*/) {
}
function parse_BrtDVal14(/*data, length, opts*/) {
}
/* [MS-XLSB] 2.1.7.61 Worksheet */
function parse_ws_bin(data, _opts, idx, rels, wb/*:WBWBProps*/, themes, styles)/*:Worksheet*/ {
	if(!data) return data;
	var opts = _opts || {};
	if(!rels) rels = {'!id':{}};
	if(DENSE != null && opts.dense == null) opts.dense = DENSE;
	var s/*:Worksheet*/ = (opts.dense ? [] : {});

	var ref;
	var refguess = {s: {r:2000000, c:2000000}, e: {r:0, c:0} };

	var state/*:Array<string>*/ = [];
	var pass = false, end = false;
	var row, p, cf, R, C, addr, sstr, rr, cell/*:Cell*/;
	var merges/*:Array<Range>*/ = [];
	opts.biff = 12;
	opts['!row'] = 0;

	var ai = 0, af = false;

	var arrayf/*:Array<[Range, string]>*/ = [];
	var sharedf = {};
	var supbooks = opts.supbooks || /*::(*/wb/*:: :any)*/.supbooks || ([[]]/*:any*/);
	supbooks.sharedf = sharedf;
	supbooks.arrayf = arrayf;
	supbooks.SheetNames = wb.SheetNames || wb.Sheets.map(function(x) { return x.name; });
	if(!opts.supbooks) {
		opts.supbooks = supbooks;
		if(wb.Names) for(var i = 0; i < wb.Names.length; ++i) supbooks[0][i+1] = wb.Names[i];
	}

	var colinfo/*:Array<ColInfo>*/ = [], rowinfo/*:Array<RowInfo>*/ = [];
	var seencol = false;

	XLSBRecordEnum[0x0010] = { n:"BrtShortReal", f:parse_BrtShortReal };

	var cm, vm;

	recordhopper(data, function ws_parse(val, RR, RT) {
		if(end) return;
		switch(RT) {
			case 0x0094: /* 'BrtWsDim' */
				ref = val; break;
			case 0x0000: /* 'BrtRowHdr' */
				row = val;
				if(opts.sheetRows && opts.sheetRows <= row.r) end=true;
				rr = encode_row(R = row.r);
				opts['!row'] = row.r;
				if(val.hidden || val.hpt || val.level != null) {
					if(val.hpt) val.hpx = pt2px(val.hpt);
					rowinfo[val.r] = val;
				}
				break;

			case 0x0002: /* 'BrtCellRk' */
			case 0x0003: /* 'BrtCellError' */
			case 0x0004: /* 'BrtCellBool' */
			case 0x0005: /* 'BrtCellReal' */
			case 0x0006: /* 'BrtCellSt' */
			case 0x0007: /* 'BrtCellIsst' */
			case 0x0008: /* 'BrtFmlaString' */
			case 0x0009: /* 'BrtFmlaNum' */
			case 0x000A: /* 'BrtFmlaBool' */
			case 0x000B: /* 'BrtFmlaError' */
			case 0x000D: /* 'BrtShortRk' */
			case 0x000E: /* 'BrtShortError' */
			case 0x000F: /* 'BrtShortBool' */
			case 0x0010: /* 'BrtShortReal' */
			case 0x0011: /* 'BrtShortSt' */
			case 0x0012: /* 'BrtShortIsst' */
			case 0x003E: /* 'BrtCellRString' */
				p = ({t:val[2]}/*:any*/);
				switch(val[2]) {
					case 'n': p.v = val[1]; break;
					case 's': sstr = strs[val[1]]; p.v = sstr.t; p.r = sstr.r; break;
					case 'b': p.v = val[1] ? true : false; break;
					case 'e': p.v = val[1]; if(opts.cellText !== false) p.w = BErr[p.v]; break;
					case 'str': p.t = 's'; p.v = val[1]; break;
					case 'is': p.t = 's'; p.v = val[1].t; break;
				}
				if((cf = styles.CellXf[val[0].iStyleRef])) safe_format(p,cf.numFmtId,null,opts, themes, styles);
				C = val[0].c == -1 ? C + 1 : val[0].c;
				if(opts.dense) { if(!s[R]) s[R] = []; s[R][C] = p; }
				else s[encode_col(C) + rr] = p;
				if(opts.cellFormula) {
					af = false;
					for(ai = 0; ai < arrayf.length; ++ai) {
						var aii = arrayf[ai];
						if(row.r >= aii[0].s.r && row.r <= aii[0].e.r)
							if(C >= aii[0].s.c && C <= aii[0].e.c) {
								p.F = encode_range(aii[0]); af = true;
							}
					}
					if(!af && val.length > 3) p.f = val[3];
				}

				if(refguess.s.r > row.r) refguess.s.r = row.r;
				if(refguess.s.c > C) refguess.s.c = C;
				if(refguess.e.r < row.r) refguess.e.r = row.r;
				if(refguess.e.c < C) refguess.e.c = C;
				if(opts.cellDates && cf && p.t == 'n' && fmt_is_date(table_fmt[cf.numFmtId])) {
					var _d = SSF_parse_date_code(p.v); if(_d) { p.t = 'd'; p.v = new Date(_d.y, _d.m-1,_d.d,_d.H,_d.M,_d.S,_d.u); }
				}
				if(cm) {
					if(cm.type == 'XLDAPR') p.D = true;
					cm = void 0;
				}
				if(vm) vm = void 0;
				break;

			case 0x0001: /* 'BrtCellBlank' */
			case 0x000C: /* 'BrtShortBlank' */
				if(!opts.sheetStubs || pass) break;
				p = ({t:'z',v:void 0}/*:any*/);
				C = val[0].c == -1 ? C + 1 : val[0].c;
				if(opts.dense) { if(!s[R]) s[R] = []; s[R][C] = p; }
				else s[encode_col(C) + rr] = p;
				if(refguess.s.r > row.r) refguess.s.r = row.r;
				if(refguess.s.c > C) refguess.s.c = C;
				if(refguess.e.r < row.r) refguess.e.r = row.r;
				if(refguess.e.c < C) refguess.e.c = C;
				if(cm) {
					if(cm.type == 'XLDAPR') p.D = true;
					cm = void 0;
				}
				if(vm) vm = void 0;
				break;

			case 0x00B0: /* 'BrtMergeCell' */
				merges.push(val); break;

			case 0x0031: { /* 'BrtCellMeta' */
				cm = ((opts.xlmeta||{}).Cell||[])[val-1];
			} break;

			case 0x01EE: /* 'BrtHLink' */
				var rel = rels['!id'][val.relId];
				if(rel) {
					val.Target = rel.Target;
					if(val.loc) val.Target += "#"+val.loc;
					val.Rel = rel;
				} else if(val.relId == '') {
					val.Target = "#" + val.loc;
				}
				for(R=val.rfx.s.r;R<=val.rfx.e.r;++R) for(C=val.rfx.s.c;C<=val.rfx.e.c;++C) {
					if(opts.dense) {
						if(!s[R]) s[R] = [];
						if(!s[R][C]) s[R][C] = {t:'z',v:undefined};
						s[R][C].l = val;
					} else {
						addr = encode_cell({c:C,r:R});
						if(!s[addr]) s[addr] = {t:'z',v:undefined};
						s[addr].l = val;
					}
				}
				break;

			case 0x01AA: /* 'BrtArrFmla' */
				if(!opts.cellFormula) break;
				arrayf.push(val);
				cell = ((opts.dense ? s[R][C] : s[encode_col(C) + rr])/*:any*/);
				cell.f = stringify_formula(val[1], refguess, {r:row.r, c:C}, supbooks, opts);
				cell.F = encode_range(val[0]);
				break;
			case 0x01AB: /* 'BrtShrFmla' */
				if(!opts.cellFormula) break;
				sharedf[encode_cell(val[0].s)] = val[1];
				cell = (opts.dense ? s[R][C] : s[encode_col(C) + rr]);
				cell.f = stringify_formula(val[1], refguess, {r:row.r, c:C}, supbooks, opts);
				break;

			/* identical to 'ColInfo' in XLS */
			case 0x003C: /* 'BrtColInfo' */
				if(!opts.cellStyles) break;
				while(val.e >= val.s) {
					colinfo[val.e--] = { width: val.w/256, hidden: !!(val.flags & 0x01), level: val.level };
					if(!seencol) { seencol = true; find_mdw_colw(val.w/256); }
					process_col(colinfo[val.e+1]);
				}
				break;

			case 0x00A1: /* 'BrtBeginAFilter' */
				s['!autofilter'] = { ref:encode_range(val) };
				break;

			case 0x01DC: /* 'BrtMargins' */
				s['!margins'] = val;
				break;

			case 0x0093: /* 'BrtWsProp' */
				if(!wb.Sheets[idx]) wb.Sheets[idx] = {};
				if(val.name) wb.Sheets[idx].CodeName = val.name;
				if(val.above || val.left) s['!outline'] = { above: val.above, left: val.left };
				break;

			case 0x0089: /* 'BrtBeginWsView' */
				if(!wb.Views) wb.Views = [{}];
				if(!wb.Views[0]) wb.Views[0] = {};
				if(val.RTL) wb.Views[0].RTL = true;
				break;

			case 0x01E5: /* 'BrtWsFmtInfo' */
				break;

			case 0x0040: /* 'BrtDVal' */
			case 0x041D: /* 'BrtDVal14' */
				break;

			case 0x0097: /* 'BrtPane' */
				break;
			case 0x0098: /* 'BrtSel' */
			case 0x00AF: /* 'BrtAFilterDateGroupItem' */
			case 0x0284: /* 'BrtActiveX' */
			case 0x0271: /* 'BrtBigName' */
			case 0x0232: /* 'BrtBkHim' */
			case 0x018C: /* 'BrtBrk' */
			case 0x0458: /* 'BrtCFIcon' */
			case 0x047A: /* 'BrtCFRuleExt' */
			case 0x01D7: /* 'BrtCFVO' */
			case 0x041A: /* 'BrtCFVO14' */
			case 0x0289: /* 'BrtCellIgnoreEC' */
			case 0x0451: /* 'BrtCellIgnoreEC14' */
			case 0x024D: /* 'BrtCellSmartTagProperty' */
			case 0x025F: /* 'BrtCellWatch' */
			case 0x0234: /* 'BrtColor' */
			case 0x041F: /* 'BrtColor14' */
			case 0x00A8: /* 'BrtColorFilter' */
			case 0x00AE: /* 'BrtCustomFilter' */
			case 0x049C: /* 'BrtCustomFilter14' */
			case 0x01F3: /* 'BrtDRef' */
			case 0x01FB: /* 'BrtDXF' */
			case 0x0226: /* 'BrtDrawing' */
			case 0x00AB: /* 'BrtDynamicFilter' */
			case 0x00A7: /* 'BrtFilter' */
			case 0x0499: /* 'BrtFilter14' */
			case 0x00A9: /* 'BrtIconFilter' */
			case 0x049D: /* 'BrtIconFilter14' */
			case 0x0227: /* 'BrtLegacyDrawing' */
			case 0x0228: /* 'BrtLegacyDrawingHF' */
			case 0x0295: /* 'BrtListPart' */
			case 0x027F: /* 'BrtOleObject' */
			case 0x01DE: /* 'BrtPageSetup' */
			case 0x0219: /* 'BrtPhoneticInfo' */
			case 0x01DD: /* 'BrtPrintOptions' */
			case 0x0218: /* 'BrtRangeProtection' */
			case 0x044F: /* 'BrtRangeProtection14' */
			case 0x02A8: /* 'BrtRangeProtectionIso' */
			case 0x0450: /* 'BrtRangeProtectionIso14' */
			case 0x0400: /* 'BrtRwDescent' */
			case 0x0297: /* 'BrtSheetCalcProp' */
			case 0x0217: /* 'BrtSheetProtection' */
			case 0x02A6: /* 'BrtSheetProtectionIso' */
			case 0x01F8: /* 'BrtSlc' */
			case 0x0413: /* 'BrtSparkline' */
			case 0x01AC: /* 'BrtTable' */
			case 0x00AA: /* 'BrtTop10Filter' */
			case 0x0C00: /* 'BrtUid' */
			case 0x0032: /* 'BrtValueMeta' */
			case 0x0816: /* 'BrtWebExtension' */
			case 0x0415: /* 'BrtWsFmtInfoEx14' */
				break;

			case 0x0023: /* 'BrtFRTBegin' */
				pass = true; break;
			case 0x0024: /* 'BrtFRTEnd' */
				pass = false; break;
			case 0x0025: /* 'BrtACBegin' */
				state.push(RT); pass = true; break;
			case 0x0026: /* 'BrtACEnd' */
				state.pop(); pass = false; break;

			default:
				if(RR.T){/* empty */}
				else if(!pass || opts.WTF) throw new Error("Unexpected record 0x" + RT.toString(16));
		}
	}, opts);

	delete opts.supbooks;
	delete opts['!row'];

	if(!s["!ref"] && (refguess.s.r < 2000000 || ref && (ref.e.r > 0 || ref.e.c > 0 || ref.s.r > 0 || ref.s.c > 0))) s["!ref"] = encode_range(ref || refguess);
	if(opts.sheetRows && s["!ref"]) {
		var tmpref = safe_decode_range(s["!ref"]);
		if(opts.sheetRows <= +tmpref.e.r) {
			tmpref.e.r = opts.sheetRows - 1;
			if(tmpref.e.r > refguess.e.r) tmpref.e.r = refguess.e.r;
			if(tmpref.e.r < tmpref.s.r) tmpref.s.r = tmpref.e.r;
			if(tmpref.e.c > refguess.e.c) tmpref.e.c = refguess.e.c;
			if(tmpref.e.c < tmpref.s.c) tmpref.s.c = tmpref.e.c;
			s["!fullref"] = s["!ref"];
			s["!ref"] = encode_range(tmpref);
		}
	}
	if(merges.length > 0) s["!merges"] = merges;
	if(colinfo.length > 0) s["!cols"] = colinfo;
	if(rowinfo.length > 0) s["!rows"] = rowinfo;
	return s;
}

/* TODO: something useful -- this is a stub */
function write_ws_bin_cell(ba/*:BufArray*/, cell/*:Cell*/, R/*:number*/, C/*:number*/, opts, ws/*:Worksheet*/, last_seen/*:boolean*/)/*:boolean*/ {
	if(cell.v === undefined) return false;
	var vv = "";
	switch(cell.t) {
		case 'b': vv = cell.v ? "1" : "0"; break;
		case 'd': // no BrtCellDate :(
			cell = dup(cell);
			cell.z = cell.z || table_fmt[14];
			cell.v = datenum(parseDate(cell.v)); cell.t = 'n';
			break;
		/* falls through */
		case 'n': case 'e': vv = ''+cell.v; break;
		default: vv = cell.v; break;
	}
	var o/*:any*/ = ({r:R, c:C}/*:any*/);
	/* TODO: cell style */
	o.s = get_cell_style(opts.cellXfs, cell, opts);
	if(cell.l) ws['!links'].push([encode_cell(o), cell.l]);
	if(cell.c) ws['!comments'].push([encode_cell(o), cell.c]);
	switch(cell.t) {
		case 's': case 'str':
			if(opts.bookSST) {
				vv = get_sst_id(opts.Strings, (cell.v/*:any*/), opts.revStrings);
				o.t = "s"; o.v = vv;
				if(last_seen) write_record(ba, 0x0012 /* BrtShortIsst */, write_BrtShortIsst(cell, o));
				else write_record(ba, 0x0007 /* BrtCellIsst */, write_BrtCellIsst(cell, o));
			} else {
				o.t = "str";
				if(last_seen) write_record(ba, 0x0011 /* BrtShortSt */, write_BrtShortSt(cell, o));
				else write_record(ba, 0x0006 /* BrtCellSt */, write_BrtCellSt(cell, o));
			}
			return true;
		case 'n':
			/* TODO: determine threshold for Real vs RK */
			if(cell.v == (cell.v | 0) && cell.v > -1000 && cell.v < 1000) {
				if(last_seen) write_record(ba, 0x000D /* BrtShortRk */, write_BrtShortRk(cell, o));
				else write_record(ba, 0x0002 /* BrtCellRk */, write_BrtCellRk(cell, o));
			} else {
				if(last_seen) write_record(ba, 0x0010 /* BrtShortReal */, write_BrtShortReal(cell, o));
				else write_record(ba, 0x0005 /* BrtCellReal */, write_BrtCellReal(cell, o));
			} return true;
		case 'b':
			o.t = "b";
			if(last_seen) write_record(ba, 0x000F /* BrtShortBool */, write_BrtShortBool(cell, o));
			else write_record(ba, 0x0004 /* BrtCellBool */, write_BrtCellBool(cell, o));
			return true;
		case 'e':
			o.t = "e";
			if(last_seen) write_record(ba, 0x000E /* BrtShortError */, write_BrtShortError(cell, o));
			else write_record(ba, 0x0003 /* BrtCellError */, write_BrtCellError(cell, o));
			return true;
	}
	if(last_seen) write_record(ba, 0x000C /* BrtShortBlank */, write_BrtShortBlank(cell, o));
	else write_record(ba, 0x0001 /* BrtCellBlank */, write_BrtCellBlank(cell, o));
	return true;
}

function write_CELLTABLE(ba, ws/*:Worksheet*/, idx/*:number*/, opts/*::, wb:Workbook*/) {
	var range = safe_decode_range(ws['!ref'] || "A1"), ref, rr = "", cols/*:Array<string>*/ = [];
	write_record(ba, 0x0091 /* BrtBeginSheetData */);
	var dense = Array.isArray(ws);
	var cap = range.e.r;
	if(ws['!rows']) cap = Math.max(range.e.r, ws['!rows'].length - 1);
	for(var R = range.s.r; R <= cap; ++R) {
		rr = encode_row(R);
		/* [ACCELLTABLE] */
		/* BrtRowHdr */
		write_row_header(ba, ws, range, R);
		var last_seen = false;
		if(R <= range.e.r) for(var C = range.s.c; C <= range.e.c; ++C) {
			/* *16384CELL */
			if(R === range.s.r) cols[C] = encode_col(C);
			ref = cols[C] + rr;
			var cell = dense ? (ws[R]||[])[C] : ws[ref];
			if(!cell) { last_seen = false; continue; }
			/* write cell */
			last_seen = write_ws_bin_cell(ba, cell, R, C, opts, ws, last_seen);
		}
	}
	write_record(ba, 0x0092 /* BrtEndSheetData */);
}

function write_MERGECELLS(ba, ws/*:Worksheet*/) {
	if(!ws || !ws['!merges']) return;
	write_record(ba, 0x00B1 /* BrtBeginMergeCells */, write_BrtBeginMergeCells(ws['!merges'].length));
	ws['!merges'].forEach(function(m) { write_record(ba, 0x00B0 /* BrtMergeCell */, write_BrtMergeCell(m)); });
	write_record(ba, 0x00B2 /* BrtEndMergeCells */);
}

function write_COLINFOS(ba, ws/*:Worksheet*//*::, idx:number, opts, wb:Workbook*/) {
	if(!ws || !ws['!cols']) return;
	write_record(ba, 0x0186 /* BrtBeginColInfos */);
	ws['!cols'].forEach(function(m, i) { if(m) write_record(ba, 0x003C /* 'BrtColInfo' */, write_BrtColInfo(i, m)); });
	write_record(ba, 0x0187 /* BrtEndColInfos */);
}

function write_IGNOREECS(ba, ws/*:Worksheet*/) {
	if(!ws || !ws['!ref']) return;
	write_record(ba, 0x0288 /* BrtBeginCellIgnoreECs */);
	write_record(ba, 0x0289 /* BrtCellIgnoreEC */, write_BrtCellIgnoreEC(safe_decode_range(ws['!ref'])));
	write_record(ba, 0x028A /* BrtEndCellIgnoreECs */);
}

function write_HLINKS(ba, ws/*:Worksheet*/, rels) {
	/* *BrtHLink */
	ws['!links'].forEach(function(l) {
		if(!l[1].Target) return;
		var rId = add_rels(rels, -1, l[1].Target.replace(/#.*$/, ""), RELS.HLINK);
		write_record(ba, 0x01EE /* BrtHLink */, write_BrtHLink(l, rId));
	});
	delete ws['!links'];
}
function write_LEGACYDRAWING(ba, ws/*:Worksheet*/, idx/*:number*/, rels) {
	/* [BrtLegacyDrawing] */
	if(ws['!comments'].length > 0) {
		var rId = add_rels(rels, -1, "../drawings/vmlDrawing" + (idx+1) + ".vml", RELS.VML);
		write_record(ba, 0x0227 /* BrtLegacyDrawing */, write_RelID("rId" + rId));
		ws['!legacy'] = rId;
	}
}

function write_AUTOFILTER(ba, ws, wb, idx) {
	if(!ws['!autofilter']) return;
	var data = ws['!autofilter'];
	var ref = typeof data.ref === "string" ? data.ref : encode_range(data.ref);

	/* Update FilterDatabase defined name for the worksheet */
	if(!wb.Workbook) wb.Workbook = ({Sheets:[]}/*:any*/);
	if(!wb.Workbook.Names) wb.Workbook.Names = [];
	var names/*: Array<any> */ = wb.Workbook.Names;
	var range = decode_range(ref);
	if(range.s.r == range.e.r) { range.e.r = decode_range(ws["!ref"]).e.r; ref = encode_range(range); }
	for(var i = 0; i < names.length; ++i) {
		var name = names[i];
		if(name.Name != '_xlnm._FilterDatabase') continue;
		if(name.Sheet != idx) continue;
		name.Ref = "'" + wb.SheetNames[idx] + "'!" + ref; break;
	}
	if(i == names.length) names.push({ Name: '_xlnm._FilterDatabase', Sheet: idx, Ref: "'" + wb.SheetNames[idx] + "'!" + ref  });

	write_record(ba, 0x00A1 /* BrtBeginAFilter */, write_UncheckedRfX(safe_decode_range(ref)));
	/* *FILTERCOLUMN */
	/* [SORTSTATE] */
	/* BrtEndAFilter */
	write_record(ba, 0x00A2 /* BrtEndAFilter */);
}

function write_WSVIEWS2(ba, ws, Workbook) {
	write_record(ba, 0x0085 /* BrtBeginWsViews */);
	{ /* 1*WSVIEW2 */
		/* [ACUID] */
		write_record(ba, 0x0089 /* BrtBeginWsView */, write_BrtBeginWsView(ws, Workbook));
		/* [BrtPane] */
		/* *4BrtSel */
		/* *4SXSELECT */
		/* *FRT */
		write_record(ba, 0x008A /* BrtEndWsView */);
	}
	/* *FRT */
	write_record(ba, 0x0086 /* BrtEndWsViews */);
}

function write_WSFMTINFO(/*::ba, ws*/) {
	/* [ACWSFMTINFO] */
	// write_record(ba, 0x01E5 /* BrtWsFmtInfo */, write_BrtWsFmtInfo(ws));
}

function write_SHEETPROTECT(ba, ws) {
	if(!ws['!protect']) return;
	/* [BrtSheetProtectionIso] */
	write_record(ba, 0x0217 /* BrtSheetProtection */, write_BrtSheetProtection(ws['!protect']));
}

function write_ws_bin(idx/*:number*/, opts, wb/*:Workbook*/, rels) {
	var ba = buf_array();
	var s = wb.SheetNames[idx], ws = wb.Sheets[s] || {};
	var c/*:string*/ = s; try { if(wb && wb.Workbook) c = wb.Workbook.Sheets[idx].CodeName || c; } catch(e) {}
	var r = safe_decode_range(ws['!ref'] || "A1");
	if(r.e.c > 0x3FFF || r.e.r > 0xFFFFF) {
		if(opts.WTF) throw new Error("Range " + (ws['!ref'] || "A1") + " exceeds format limit A1:XFD1048576");
		r.e.c = Math.min(r.e.c, 0x3FFF);
		r.e.r = Math.min(r.e.c, 0xFFFFF);
	}
	ws['!links'] = [];
	/* passed back to write_zip and removed there */
	ws['!comments'] = [];
	write_record(ba, 0x0081 /* BrtBeginSheet */);
	if(wb.vbaraw || ws['!outline']) write_record(ba, 0x0093 /* BrtWsProp */, write_BrtWsProp(c, ws['!outline']));
	write_record(ba, 0x0094 /* BrtWsDim */, write_BrtWsDim(r));
	write_WSVIEWS2(ba, ws, wb.Workbook);
	write_WSFMTINFO(ba, ws);
	write_COLINFOS(ba, ws, idx, opts, wb);
	write_CELLTABLE(ba, ws, idx, opts, wb);
	/* [BrtSheetCalcProp] */
	write_SHEETPROTECT(ba, ws);
	/* *([BrtRangeProtectionIso] BrtRangeProtection) */
	/* [SCENMAN] */
	write_AUTOFILTER(ba, ws, wb, idx);
	/* [SORTSTATE] */
	/* [DCON] */
	/* [USERSHVIEWS] */
	write_MERGECELLS(ba, ws);
	/* [BrtPhoneticInfo] */
	/* *CONDITIONALFORMATTING */
	/* [DVALS] */
	write_HLINKS(ba, ws, rels);
	/* [BrtPrintOptions] */
	if(ws['!margins']) write_record(ba, 0x01DC /* BrtMargins */, write_BrtMargins(ws['!margins']));
	/* [BrtPageSetup] */
	/* [HEADERFOOTER] */
	/* [RWBRK] */
	/* [COLBRK] */
	/* *BrtBigName */
	/* [CELLWATCHES] */
	if(!opts || opts.ignoreEC || (opts.ignoreEC == (void 0))) write_IGNOREECS(ba, ws);
	/* [SMARTTAGS] */
	/* [BrtDrawing] */
	write_LEGACYDRAWING(ba, ws, idx, rels);
	/* [BrtLegacyDrawingHF] */
	/* [BrtBkHim] */
	/* [OLEOBJECTS] */
	/* [ACTIVEXCONTROLS] */
	/* [WEBPUBITEMS] */
	/* [LISTPARTS] */
	/* FRTWORKSHEET */
	write_record(ba, 0x0082 /* BrtEndSheet */);
	return ba.end();
}
function parse_Cache(data/*:string*/)/*:[Array<number|string>, string, ?string]*/ {
	var col/*:Array<number|string>*/ = [];
	var num = data.match(/^<c:numCache>/);
	var f;

	/* 21.2.2.150 pt CT_NumVal */
	(data.match(/<c:pt idx="(\d*)">(.*?)<\/c:pt>/mg)||[]).forEach(function(pt) {
		var q = pt.match(/<c:pt idx="(\d*?)"><c:v>(.*)<\/c:v><\/c:pt>/);
		if(!q) return;
		col[+q[1]] = num ? +q[2] : q[2];
	});

	/* 21.2.2.71 formatCode CT_Xstring */
	var nf = unescapexml((data.match(/<c:formatCode>([\s\S]*?)<\/c:formatCode>/) || ["","General"])[1]);

	(data.match(/<c:f>(.*?)<\/c:f>/mg)||[]).forEach(function(F) { f = F.replace(/<.*?>/g,""); });

	return [col, nf, f];
}

/* 21.2 DrawingML - Charts */
function parse_chart(data/*:?string*/, name/*:string*/, opts, rels, wb, csheet) {
	var cs/*:Worksheet*/ = ((csheet || {"!type":"chart"})/*:any*/);
	if(!data) return csheet;
	/* 21.2.2.27 chart CT_Chart */

	var C = 0, R = 0, col = "A";
	var refguess = {s: {r:2000000, c:2000000}, e: {r:0, c:0} };

	/* 21.2.2.120 numCache CT_NumData */
	(data.match(/<c:numCache>[\s\S]*?<\/c:numCache>/gm)||[]).forEach(function(nc) {
		var cache = parse_Cache(nc);
		refguess.s.r = refguess.s.c = 0;
		refguess.e.c = C;
		col = encode_col(C);
		cache[0].forEach(function(n,i) {
			cs[col + encode_row(i)] = {t:'n', v:n, z:cache[1] };
			R = i;
		});
		if(refguess.e.r < R) refguess.e.r = R;
		++C;
	});
	if(C > 0) cs["!ref"] = encode_range(refguess);
	return cs;
}
/* 18.3 Worksheets also covers Chartsheets */
function parse_cs_xml(data/*:?string*/, opts, idx/*:number*/, rels, wb/*::, themes, styles*/)/*:Worksheet*/ {
	if(!data) return data;
	/* 18.3.1.12 chartsheet CT_ChartSheet */
	if(!rels) rels = {'!id':{}};
	var s = ({'!type':"chart", '!drawel':null, '!rel':""}/*:any*/);
	var m;

	/* 18.3.1.83 sheetPr CT_ChartsheetPr */
	var sheetPr = data.match(sheetprregex);
	if(sheetPr) parse_ws_xml_sheetpr(sheetPr[0], s, wb, idx);

	/* 18.3.1.36 drawing CT_Drawing */
	if((m = data.match(/drawing r:id="(.*?)"/))) s['!rel'] = m[1];

	if(rels['!id'][s['!rel']]) s['!drawel'] = rels['!id'][s['!rel']];
	return s;
}
function write_cs_xml(idx/*:number*/, opts, wb/*:Workbook*/, rels)/*:string*/ {
	var o = [XML_HEADER, writextag('chartsheet', null, {
		'xmlns': XMLNS_main[0],
		'xmlns:r': XMLNS.r
	})];
	o[o.length] = writextag("drawing", null, {"r:id": "rId1"});
	add_rels(rels, -1, "../drawings/drawing" + (idx+1) + ".xml", RELS.DRAW);
	if(o.length>2) { o[o.length] = ('</chartsheet>'); o[1]=o[1].replace("/>",">"); }
	return o.join("");
}

/* [MS-XLSB] 2.4.331 BrtCsProp */
function parse_BrtCsProp(data, length/*:number*/) {
	data.l += 10;
	var name = parse_XLWideString(data, length - 10);
	return { name: name };
}

/* [MS-XLSB] 2.1.7.7 Chart Sheet */
function parse_cs_bin(data, opts, idx/*:number*/, rels, wb/*::, themes, styles*/)/*:Worksheet*/ {
	if(!data) return data;
	if(!rels) rels = {'!id':{}};
	var s = {'!type':"chart", '!drawel':null, '!rel':""};
	var state/*:Array<string>*/ = [];
	var pass = false;
	recordhopper(data, function cs_parse(val, R, RT) {
		switch(RT) {

			case 0x0226: /* 'BrtDrawing' */
				s['!rel'] = val; break;

			case 0x028B: /* 'BrtCsProp' */
				if(!wb.Sheets[idx]) wb.Sheets[idx] = {};
				if(val.name) wb.Sheets[idx].CodeName = val.name;
				break;

			case 0x0232: /* 'BrtBkHim' */
			case 0x028C: /* 'BrtCsPageSetup' */
			case 0x029D: /* 'BrtCsProtection' */
			case 0x02A7: /* 'BrtCsProtectionIso' */
			case 0x0227: /* 'BrtLegacyDrawing' */
			case 0x0228: /* 'BrtLegacyDrawingHF' */
			case 0x01DC: /* 'BrtMargins' */
			case 0x0C00: /* 'BrtUid' */
				break;

			case 0x0023: /* 'BrtFRTBegin' */
				pass = true; break;
			case 0x0024: /* 'BrtFRTEnd' */
				pass = false; break;
			case 0x0025: /* 'BrtACBegin' */
				state.push(RT); break;
			case 0x0026: /* 'BrtACEnd' */
				state.pop(); break;

			default:
				if(R.T > 0) state.push(RT);
				else if(R.T < 0) state.pop();
				else if(!pass || opts.WTF) throw new Error("Unexpected record 0x" + RT.toString(16));
		}
	}, opts);

	if(rels['!id'][s['!rel']]) s['!drawel'] = rels['!id'][s['!rel']];
	return s;
}
function write_cs_bin(/*::idx:number, opts, wb:Workbook, rels*/) {
	var ba = buf_array();
	write_record(ba, 0x0081 /* BrtBeginSheet */);
	/* [BrtCsProp] */
	/* CSVIEWS */
	/* [[BrtCsProtectionIso] BrtCsProtection] */
	/* [USERCSVIEWS] */
	/* [BrtMargins] */
	/* [BrtCsPageSetup] */
	/* [HEADERFOOTER] */
	/* BrtDrawing */
	/* [BrtLegacyDrawing] */
	/* [BrtLegacyDrawingHF] */
	/* [BrtBkHim] */
	/* [WEBPUBITEMS] */
	/* FRTCHARTSHEET */
	write_record(ba, 0x0082 /* BrtEndSheet */);
	return ba.end();
}
/* 18.2.28 (CT_WorkbookProtection) Defaults */
var WBPropsDef = [
	['allowRefreshQuery',           false, "bool"],
	['autoCompressPictures',        true,  "bool"],
	['backupFile',                  false, "bool"],
	['checkCompatibility',          false, "bool"],
	['CodeName',                    ''],
	['date1904',                    false, "bool"],
	['defaultThemeVersion',         0,      "int"],
	['filterPrivacy',               false, "bool"],
	['hidePivotFieldList',          false, "bool"],
	['promptedSolutions',           false, "bool"],
	['publishItems',                false, "bool"],
	['refreshAllConnections',       false, "bool"],
	['saveExternalLinkValues',      true,  "bool"],
	['showBorderUnselectedTables',  true,  "bool"],
	['showInkAnnotation',           true,  "bool"],
	['showObjects',                 'all'],
	['showPivotChartFilter',        false, "bool"],
	['updateLinks', 'userSet']
];

/* 18.2.30 (CT_BookView) Defaults */
var WBViewDef = (/* unused pure expression or super */ null && ([
	['activeTab',                   0,      "int"],
	['autoFilterDateGrouping',      true,  "bool"],
	['firstSheet',                  0,      "int"],
	['minimized',                   false, "bool"],
	['showHorizontalScroll',        true,  "bool"],
	['showSheetTabs',               true,  "bool"],
	['showVerticalScroll',          true,  "bool"],
	['tabRatio',                    600,    "int"],
	['visibility',                  'visible']
	//window{Height,Width}, {x,y}Window
]));

/* 18.2.19 (CT_Sheet) Defaults */
var SheetDef = (/* unused pure expression or super */ null && ([
	//['state', 'visible']
]));

/* 18.2.2  (CT_CalcPr) Defaults */
var CalcPrDef = (/* unused pure expression or super */ null && ([
	['calcCompleted', 'true'],
	['calcMode', 'auto'],
	['calcOnSave', 'true'],
	['concurrentCalc', 'true'],
	['fullCalcOnLoad', 'false'],
	['fullPrecision', 'true'],
	['iterate', 'false'],
	['iterateCount', '100'],
	['iterateDelta', '0.001'],
	['refMode', 'A1']
]));

/* 18.2.3 (CT_CustomWorkbookView) Defaults */
/*var CustomWBViewDef = [
	['autoUpdate', 'false'],
	['changesSavedWin', 'false'],
	['includeHiddenRowCol', 'true'],
	['includePrintSettings', 'true'],
	['maximized', 'false'],
	['minimized', 'false'],
	['onlySync', 'false'],
	['personalView', 'false'],
	['showComments', 'commIndicator'],
	['showFormulaBar', 'true'],
	['showHorizontalScroll', 'true'],
	['showObjects', 'all'],
	['showSheetTabs', 'true'],
	['showStatusbar', 'true'],
	['showVerticalScroll', 'true'],
	['tabRatio', '600'],
	['xWindow', '0'],
	['yWindow', '0']
];*/

function push_defaults_array(target, defaults) {
	for(var j = 0; j != target.length; ++j) { var w = target[j];
		for(var i=0; i != defaults.length; ++i) { var z = defaults[i];
			if(w[z[0]] == null) w[z[0]] = z[1];
			else switch(z[2]) {
			case "bool": if(typeof w[z[0]] == "string") w[z[0]] = parsexmlbool(w[z[0]]); break;
			case "int": if(typeof w[z[0]] == "string") w[z[0]] = parseInt(w[z[0]], 10); break;
			}
		}
	}
}
function push_defaults(target, defaults) {
	for(var i = 0; i != defaults.length; ++i) { var z = defaults[i];
		if(target[z[0]] == null) target[z[0]] = z[1];
		else switch(z[2]) {
			case "bool": if(typeof target[z[0]] == "string") target[z[0]] = parsexmlbool(target[z[0]]); break;
			case "int": if(typeof target[z[0]] == "string") target[z[0]] = parseInt(target[z[0]], 10); break;
		}
	}
}

function parse_wb_defaults(wb) {
	push_defaults(wb.WBProps, WBPropsDef);
	push_defaults(wb.CalcPr, CalcPrDef);

	push_defaults_array(wb.WBView, WBViewDef);
	push_defaults_array(wb.Sheets, SheetDef);

	_ssfopts.date1904 = parsexmlbool(wb.WBProps.date1904);
}

function safe1904(wb/*:Workbook*/)/*:string*/ {
	/* TODO: store date1904 somewhere else */
	if(!wb.Workbook) return "false";
	if(!wb.Workbook.WBProps) return "false";
	return parsexmlbool(wb.Workbook.WBProps.date1904) ? "true" : "false";
}

var badchars = /*#__PURE__*/"][*?\/\\".split("");
function check_ws_name(n/*:string*/, safe/*:?boolean*/)/*:boolean*/ {
	if(n.length > 31) { if(safe) return false; throw new Error("Sheet names cannot exceed 31 chars"); }
	var _good = true;
	badchars.forEach(function(c) {
		if(n.indexOf(c) == -1) return;
		if(!safe) throw new Error("Sheet name cannot contain : \\ / ? * [ ]");
		_good = false;
	});
	return _good;
}
function check_wb_names(N, S, codes) {
	N.forEach(function(n,i) {
		check_ws_name(n);
		for(var j = 0; j < i; ++j) if(n == N[j]) throw new Error("Duplicate Sheet Name: " + n);
		if(codes) {
			var cn = (S && S[i] && S[i].CodeName) || n;
			if(cn.charCodeAt(0) == 95 && cn.length > 22) throw new Error("Bad Code Name: Worksheet" + cn);
		}
	});
}
function check_wb(wb) {
	if(!wb || !wb.SheetNames || !wb.Sheets) throw new Error("Invalid Workbook");
	if(!wb.SheetNames.length) throw new Error("Workbook is empty");
	var Sheets = (wb.Workbook && wb.Workbook.Sheets) || [];
	check_wb_names(wb.SheetNames, Sheets, !!wb.vbaraw);
	for(var i = 0; i < wb.SheetNames.length; ++i) check_ws(wb.Sheets[wb.SheetNames[i]], wb.SheetNames[i], i);
	/* TODO: validate workbook */
}
/* 18.2 Workbook */
var wbnsregex = /<\w+:workbook/;
function parse_wb_xml(data, opts)/*:WorkbookFile*/ {
	if(!data) throw new Error("Could not find file");
	var wb = /*::(*/{ AppVersion:{}, WBProps:{}, WBView:[], Sheets:[], CalcPr:{}, Names:[], xmlns: "" }/*::)*/;
	var pass = false, xmlns = "xmlns";
	var dname = {}, dnstart = 0;
	data.replace(tagregex, function xml_wb(x, idx) {
		var y/*:any*/ = parsexmltag(x);
		switch(strip_ns(y[0])) {
			case '<?xml': break;

			/* 18.2.27 workbook CT_Workbook 1 */
			case '<workbook':
				if(x.match(wbnsregex)) xmlns = "xmlns" + x.match(/<(\w+):/)[1];
				wb.xmlns = y[xmlns];
				break;
			case '</workbook>': break;

			/* 18.2.13 fileVersion CT_FileVersion ? */
			case '<fileVersion': delete y[0]; wb.AppVersion = y; break;
			case '<fileVersion/>': case '</fileVersion>': break;

			/* 18.2.12 fileSharing CT_FileSharing ? */
			case '<fileSharing':
				break;
			case '<fileSharing/>': break;

			/* 18.2.28 workbookPr CT_WorkbookPr ? */
			case '<workbookPr':
			case '<workbookPr/>':
				WBPropsDef.forEach(function(w) {
					if(y[w[0]] == null) return;
					switch(w[2]) {
						case "bool": wb.WBProps[w[0]] = parsexmlbool(y[w[0]]); break;
						case "int": wb.WBProps[w[0]] = parseInt(y[w[0]], 10); break;
						default: wb.WBProps[w[0]] = y[w[0]];
					}
				});
				if(y.codeName) wb.WBProps.CodeName = utf8read(y.codeName);
				break;
			case '</workbookPr>': break;

			/* 18.2.29 workbookProtection CT_WorkbookProtection ? */
			case '<workbookProtection':
				break;
			case '<workbookProtection/>': break;

			/* 18.2.1  bookViews CT_BookViews ? */
			case '<bookViews': case '<bookViews>': case '</bookViews>': break;
			/* 18.2.30   workbookView CT_BookView + */
			case '<workbookView': case '<workbookView/>': delete y[0]; wb.WBView.push(y); break;
			case '</workbookView>': break;

			/* 18.2.20 sheets CT_Sheets 1 */
			case '<sheets': case '<sheets>': case '</sheets>': break; // aggregate sheet
			/* 18.2.19   sheet CT_Sheet + */
			case '<sheet':
				switch(y.state) {
					case "hidden": y.Hidden = 1; break;
					case "veryHidden": y.Hidden = 2; break;
					default: y.Hidden = 0;
				}
				delete y.state;
				y.name = unescapexml(utf8read(y.name));
				delete y[0]; wb.Sheets.push(y); break;
			case '</sheet>': break;

			/* 18.2.15 functionGroups CT_FunctionGroups ? */
			case '<functionGroups': case '<functionGroups/>': break;
			/* 18.2.14   functionGroup CT_FunctionGroup + */
			case '<functionGroup': break;

			/* 18.2.9  externalReferences CT_ExternalReferences ? */
			case '<externalReferences': case '</externalReferences>': case '<externalReferences>': break;
			/* 18.2.8    externalReference CT_ExternalReference + */
			case '<externalReference': break;

			/* 18.2.6  definedNames CT_DefinedNames ? */
			case '<definedNames/>': break;
			case '<definedNames>': case '<definedNames': pass=true; break;
			case '</definedNames>': pass=false; break;
			/* 18.2.5    definedName CT_DefinedName + */
			case '<definedName': {
				dname = {};
				dname.Name = utf8read(y.name);
				if(y.comment) dname.Comment = y.comment;
				if(y.localSheetId) dname.Sheet = +y.localSheetId;
				if(parsexmlbool(y.hidden||"0")) dname.Hidden = true;
				dnstart = idx + x.length;
			}	break;
			case '</definedName>': {
				dname.Ref = unescapexml(utf8read(data.slice(dnstart, idx)));
				wb.Names.push(dname);
			} break;
			case '<definedName/>': break;

			/* 18.2.2  calcPr CT_CalcPr ? */
			case '<calcPr': delete y[0]; wb.CalcPr = y; break;
			case '<calcPr/>': delete y[0]; wb.CalcPr = y; break;
			case '</calcPr>': break;

			/* 18.2.16 oleSize CT_OleSize ? (ref required) */
			case '<oleSize': break;

			/* 18.2.4  customWorkbookViews CT_CustomWorkbookViews ? */
			case '<customWorkbookViews>': case '</customWorkbookViews>': case '<customWorkbookViews': break;
			/* 18.2.3  customWorkbookView CT_CustomWorkbookView + */
			case '<customWorkbookView': case '</customWorkbookView>': break;

			/* 18.2.18 pivotCaches CT_PivotCaches ? */
			case '<pivotCaches>': case '</pivotCaches>': case '<pivotCaches': break;
			/* 18.2.17 pivotCache CT_PivotCache ? */
			case '<pivotCache': break;

			/* 18.2.21 smartTagPr CT_SmartTagPr ? */
			case '<smartTagPr': case '<smartTagPr/>': break;

			/* 18.2.23 smartTagTypes CT_SmartTagTypes ? */
			case '<smartTagTypes': case '<smartTagTypes>': case '</smartTagTypes>': break;
			/* 18.2.22 smartTagType CT_SmartTagType ? */
			case '<smartTagType': break;

			/* 18.2.24 webPublishing CT_WebPublishing ? */
			case '<webPublishing': case '<webPublishing/>': break;

			/* 18.2.11 fileRecoveryPr CT_FileRecoveryPr ? */
			case '<fileRecoveryPr': case '<fileRecoveryPr/>': break;

			/* 18.2.26 webPublishObjects CT_WebPublishObjects ? */
			case '<webPublishObjects>': case '<webPublishObjects': case '</webPublishObjects>': break;
			/* 18.2.25 webPublishObject CT_WebPublishObject ? */
			case '<webPublishObject': break;

			/* 18.2.10 extLst CT_ExtensionList ? */
			case '<extLst': case '<extLst>': case '</extLst>': case '<extLst/>': break;
			/* 18.2.7  ext CT_Extension + */
			case '<ext': pass=true; break; //TODO: check with versions of excel
			case '</ext>': pass=false; break;

			/* Others */
			case '<ArchID': break;
			case '<AlternateContent':
			case '<AlternateContent>': pass=true; break;
			case '</AlternateContent>': pass=false; break;

			/* TODO */
			case '<revisionPtr': break;

			default: if(!pass && opts.WTF) throw new Error('unrecognized ' + y[0] + ' in workbook');
		}
		return x;
	});
	if(XMLNS_main.indexOf(wb.xmlns) === -1) throw new Error("Unknown Namespace: " + wb.xmlns);

	parse_wb_defaults(wb);

	return wb;
}

function write_wb_xml(wb/*:Workbook*//*::, opts:?WriteOpts*/)/*:string*/ {
	var o = [XML_HEADER];
	o[o.length] = writextag('workbook', null, {
		'xmlns': XMLNS_main[0],
		//'xmlns:mx': XMLNS.mx,
		//'xmlns:s': XMLNS_main[0],
		'xmlns:r': XMLNS.r
	});

	var write_names = (wb.Workbook && (wb.Workbook.Names||[]).length > 0);

	/* fileVersion */
	/* fileSharing */

	var workbookPr/*:any*/ = ({codeName:"ThisWorkbook"}/*:any*/);
	if(wb.Workbook && wb.Workbook.WBProps) {
		WBPropsDef.forEach(function(x) {
			/*:: if(!wb.Workbook || !wb.Workbook.WBProps) throw "unreachable"; */
			if((wb.Workbook.WBProps[x[0]]/*:any*/) == null) return;
			if((wb.Workbook.WBProps[x[0]]/*:any*/) == x[1]) return;
			workbookPr[x[0]] = (wb.Workbook.WBProps[x[0]]/*:any*/);
		});
		/*:: if(!wb.Workbook || !wb.Workbook.WBProps) throw "unreachable"; */
		if(wb.Workbook.WBProps.CodeName) { workbookPr.codeName = wb.Workbook.WBProps.CodeName; delete workbookPr.CodeName; }
	}
	o[o.length] = (writextag('workbookPr', null, workbookPr));

	/* workbookProtection */

	var sheets = wb.Workbook && wb.Workbook.Sheets || [];
	var i = 0;

	/* bookViews only written if first worksheet is hidden */
	if(sheets && sheets[0] && !!sheets[0].Hidden) {
		o[o.length] = "<bookViews>";
		for(i = 0; i != wb.SheetNames.length; ++i) {
			if(!sheets[i]) break;
			if(!sheets[i].Hidden) break;
		}
		if(i == wb.SheetNames.length) i = 0;
		o[o.length] = '<workbookView firstSheet="' + i + '" activeTab="' + i + '"/>';
		o[o.length] = "</bookViews>";
	}

	o[o.length] = "<sheets>";
	for(i = 0; i != wb.SheetNames.length; ++i) {
		var sht = ({name:escapexml(wb.SheetNames[i].slice(0,31))}/*:any*/);
		sht.sheetId = ""+(i+1);
		sht["r:id"] = "rId"+(i+1);
		if(sheets[i]) switch(sheets[i].Hidden) {
			case 1: sht.state = "hidden"; break;
			case 2: sht.state = "veryHidden"; break;
		}
		o[o.length] = (writextag('sheet',null,sht));
	}
	o[o.length] = "</sheets>";

	/* functionGroups */
	/* externalReferences */

	if(write_names) {
		o[o.length] = "<definedNames>";
		if(wb.Workbook && wb.Workbook.Names) wb.Workbook.Names.forEach(function(n) {
			var d/*:any*/ = {name:n.Name};
			if(n.Comment) d.comment = n.Comment;
			if(n.Sheet != null) d.localSheetId = ""+n.Sheet;
			if(n.Hidden) d.hidden = "1";
			if(!n.Ref) return;
			o[o.length] = writextag('definedName', escapexml(n.Ref), d);
		});
		o[o.length] = "</definedNames>";
	}

	/* calcPr */
	/* oleSize */
	/* customWorkbookViews */
	/* pivotCaches */
	/* smartTagPr */
	/* smartTagTypes */
	/* webPublishing */
	/* fileRecoveryPr */
	/* webPublishObjects */
	/* extLst */

	if(o.length>2){ o[o.length] = '</workbook>'; o[1]=o[1].replace("/>",">"); }
	return o.join("");
}
/* [MS-XLSB] 2.4.304 BrtBundleSh */
function parse_BrtBundleSh(data, length/*:number*/) {
	var z = {};
	z.Hidden = data.read_shift(4); //hsState ST_SheetState
	z.iTabID = data.read_shift(4);
	z.strRelID = parse_RelID(data,length-8);
	z.name = parse_XLWideString(data);
	return z;
}
function write_BrtBundleSh(data, o) {
	if(!o) o = new_buf(127);
	o.write_shift(4, data.Hidden);
	o.write_shift(4, data.iTabID);
	write_RelID(data.strRelID, o);
	write_XLWideString(data.name.slice(0,31), o);
	return o.length > o.l ? o.slice(0, o.l) : o;
}

/* [MS-XLSB] 2.4.815 BrtWbProp */
function parse_BrtWbProp(data, length)/*:WBProps*/ {
	var o/*:WBProps*/ = ({}/*:any*/);
	var flags = data.read_shift(4);
	o.defaultThemeVersion = data.read_shift(4);
	var strName = (length > 8) ? parse_XLWideString(data) : "";
	if(strName.length > 0) o.CodeName = strName;
	o.autoCompressPictures = !!(flags & 0x10000);
	o.backupFile = !!(flags & 0x40);
	o.checkCompatibility = !!(flags & 0x1000);
	o.date1904 = !!(flags & 0x01);
	o.filterPrivacy = !!(flags & 0x08);
	o.hidePivotFieldList = !!(flags & 0x400);
	o.promptedSolutions = !!(flags & 0x10);
	o.publishItems = !!(flags & 0x800);
	o.refreshAllConnections = !!(flags & 0x40000);
	o.saveExternalLinkValues = !!(flags & 0x80);
	o.showBorderUnselectedTables = !!(flags & 0x04);
	o.showInkAnnotation = !!(flags & 0x20);
	o.showObjects = ["all", "placeholders", "none"][(flags >> 13) & 0x03];
	o.showPivotChartFilter = !!(flags & 0x8000);
	o.updateLinks = ["userSet", "never", "always"][(flags >> 8) & 0x03];
	return o;
}
function write_BrtWbProp(data/*:?WBProps*/, o) {
	if(!o) o = new_buf(72);
	var flags = 0;
	if(data) {
		/* TODO: mirror parse_BrtWbProp fields */
		if(data.filterPrivacy) flags |= 0x08;
	}
	o.write_shift(4, flags);
	o.write_shift(4, 0);
	write_XLSBCodeName(data && data.CodeName || "ThisWorkbook", o);
	return o.slice(0, o.l);
}

function parse_BrtFRTArchID$(data, length) {
	var o = {};
	data.read_shift(4);
	o.ArchID = data.read_shift(4);
	data.l += length - 8;
	return o;
}

/* [MS-XLSB] 2.4.687 BrtName */
function parse_BrtName(data, length, opts) {
	var end = data.l + length;
	data.l += 4; //var flags = data.read_shift(4);
	data.l += 1; //var chKey = data.read_shift(1);
	var itab = data.read_shift(4);
	var name = parse_XLNameWideString(data);
	var formula = parse_XLSBNameParsedFormula(data, 0, opts);
	var comment = parse_XLNullableWideString(data);
	//if(0 /* fProc */) {
		// unusedstring1: XLNullableWideString
		// description: XLNullableWideString
		// helpTopic: XLNullableWideString
		// unusedstring2: XLNullableWideString
	//}
	data.l = end;
	var out = ({Name:name, Ptg:formula}/*:any*/);
	if(itab < 0xFFFFFFF) out.Sheet = itab;
	if(comment) out.Comment = comment;
	return out;
}

/* [MS-XLSB] 2.1.7.61 Workbook */
function parse_wb_bin(data, opts)/*:WorkbookFile*/ {
	var wb = { AppVersion:{}, WBProps:{}, WBView:[], Sheets:[], CalcPr:{}, xmlns: "" };
	var state/*:Array<string>*/ = [];
	var pass = false;

	if(!opts) opts = {};
	opts.biff = 12;

	var Names = [];
	var supbooks = ([[]]/*:any*/);
	supbooks.SheetNames = [];
	supbooks.XTI = [];

	XLSBRecordEnum[0x0010] = { n:"BrtFRTArchID$", f:parse_BrtFRTArchID$ };

	recordhopper(data, function hopper_wb(val, R, RT) {
		switch(RT) {
			case 0x009C: /* 'BrtBundleSh' */
				supbooks.SheetNames.push(val.name);
				wb.Sheets.push(val); break;

			case 0x0099: /* 'BrtWbProp' */
				wb.WBProps = val; break;

			case 0x0027: /* 'BrtName' */
				if(val.Sheet != null) opts.SID = val.Sheet;
				val.Ref = stringify_formula(val.Ptg, null, null, supbooks, opts);
				delete opts.SID;
				delete val.Ptg;
				Names.push(val);
				break;
			case 0x040C: /* 'BrtNameExt' */ break;

			case 0x0165: /* 'BrtSupSelf' */
			case 0x0166: /* 'BrtSupSame' */
			case 0x0163: /* 'BrtSupBookSrc' */
			case 0x029B: /* 'BrtSupAddin' */
				if(!supbooks[0].length) supbooks[0] = [RT, val];
				else supbooks.push([RT, val]);
				supbooks[supbooks.length - 1].XTI = [];
				break;
			case 0x016A: /* 'BrtExternSheet' */
				if(supbooks.length === 0) { supbooks[0] = []; supbooks[0].XTI = []; }
				supbooks[supbooks.length - 1].XTI = supbooks[supbooks.length - 1].XTI.concat(val);
				supbooks.XTI = supbooks.XTI.concat(val);
				break;
			case 0x0169: /* 'BrtPlaceholderName' */
				break;

			case 0x0817: /* 'BrtAbsPath15' */
			case 0x009E: /* 'BrtBookView' */
			case 0x008F: /* 'BrtBeginBundleShs' */
			case 0x0298: /* 'BrtBeginFnGroup' */
			case 0x0161: /* 'BrtBeginExternals' */
				break;

			/* case 'BrtModelTimeGroupingCalcCol' */
			case 0x0C00: /* 'BrtUid' */
			case 0x0C01: /* 'BrtRevisionPtr' */
			case 0x0216: /* 'BrtBookProtection' */
			case 0x02A5: /* 'BrtBookProtectionIso' */
			case 0x009D: /* 'BrtCalcProp' */
			case 0x0262: /* 'BrtCrashRecErr' */
			case 0x0802: /* 'BrtDecoupledPivotCacheID' */
			case 0x009B: /* 'BrtFileRecover' */
			case 0x0224: /* 'BrtFileSharing' */
			case 0x02A4: /* 'BrtFileSharingIso' */
			case 0x0080: /* 'BrtFileVersion' */
			case 0x0299: /* 'BrtFnGroup' */
			case 0x0850: /* 'BrtModelRelationship' */
			case 0x084D: /* 'BrtModelTable' */
			case 0x0225: /* 'BrtOleSize' */
			case 0x0805: /* 'BrtPivotTableRef' */
			case 0x0254: /* 'BrtSmartTagType' */
			case 0x081C: /* 'BrtTableSlicerCacheID' */
			case 0x081B: /* 'BrtTableSlicerCacheIDs' */
			case 0x0822: /* 'BrtTimelineCachePivotCacheID' */
			case 0x018D: /* 'BrtUserBookView' */
			case 0x009A: /* 'BrtWbFactoid' */
			case 0x045D: /* 'BrtWbProp14' */
			case 0x0229: /* 'BrtWebOpt' */
			case 0x082B: /* 'BrtWorkBookPr15' */
				break;

			case 0x0023: /* 'BrtFRTBegin' */
				state.push(RT); pass = true; break;
			case 0x0024: /* 'BrtFRTEnd' */
				state.pop(); pass = false; break;
			case 0x0025: /* 'BrtACBegin' */
				state.push(RT); pass = true; break;
			case 0x0026: /* 'BrtACEnd' */
				state.pop(); pass = false; break;

			case 0x0010: /* 'BrtFRTArchID$' */ break;

			default:
				if(R.T){/* empty */}
				else if(!pass || (opts.WTF && state[state.length-1] != 0x0025 /* BrtACBegin */ && state[state.length-1] != 0x0023 /* BrtFRTBegin */)) throw new Error("Unexpected record 0x" + RT.toString(16));
		}
	}, opts);

	parse_wb_defaults(wb);

	// $FlowIgnore
	wb.Names = Names;

	(wb/*:any*/).supbooks = supbooks;
	return wb;
}

function write_BUNDLESHS(ba, wb/*::, opts*/) {
	write_record(ba, 0x008F /* BrtBeginBundleShs */);
	for(var idx = 0; idx != wb.SheetNames.length; ++idx) {
		var viz = wb.Workbook && wb.Workbook.Sheets && wb.Workbook.Sheets[idx] && wb.Workbook.Sheets[idx].Hidden || 0;
		var d = { Hidden: viz, iTabID: idx+1, strRelID: 'rId' + (idx+1), name: wb.SheetNames[idx] };
		write_record(ba, 0x009C /* BrtBundleSh */, write_BrtBundleSh(d));
	}
	write_record(ba, 0x0090 /* BrtEndBundleShs */);
}

/* [MS-XLSB] 2.4.649 BrtFileVersion */
function write_BrtFileVersion(data, o) {
	if(!o) o = new_buf(127);
	for(var i = 0; i != 4; ++i) o.write_shift(4, 0);
	write_XLWideString("SheetJS", o);
	write_XLWideString(XLSX.version, o);
	write_XLWideString(XLSX.version, o);
	write_XLWideString("7262", o);
	return o.length > o.l ? o.slice(0, o.l) : o;
}

/* [MS-XLSB] 2.4.301 BrtBookView */
function write_BrtBookView(idx, o) {
	if(!o) o = new_buf(29);
	o.write_shift(-4, 0);
	o.write_shift(-4, 460);
	o.write_shift(4,  28800);
	o.write_shift(4,  17600);
	o.write_shift(4,  500);
	o.write_shift(4,  idx);
	o.write_shift(4,  idx);
	var flags = 0x78;
	o.write_shift(1,  flags);
	return o.length > o.l ? o.slice(0, o.l) : o;
}

function write_BOOKVIEWS(ba, wb/*::, opts*/) {
	/* required if hidden tab appears before visible tab */
	if(!wb.Workbook || !wb.Workbook.Sheets) return;
	var sheets = wb.Workbook.Sheets;
	var i = 0, vistab = -1, hidden = -1;
	for(; i < sheets.length; ++i) {
		if(!sheets[i] || !sheets[i].Hidden && vistab == -1) vistab = i;
		else if(sheets[i].Hidden == 1 && hidden == -1) hidden = i;
	}
	if(hidden > vistab) return;
	write_record(ba, 0x0087 /* BrtBeginBookViews */);
	write_record(ba, 0x009E /* BrtBookView */, write_BrtBookView(vistab));
	/* 1*(BrtBookView *FRT) */
	write_record(ba, 0x0088 /* BrtEndBookViews */);
}

/* [MS-XLSB] 2.4.305 BrtCalcProp */
/*function write_BrtCalcProp(data, o) {
	if(!o) o = new_buf(26);
	o.write_shift(4,0); // force recalc
	o.write_shift(4,1);
	o.write_shift(4,0);
	write_Xnum(0, o);
	o.write_shift(-4, 1023);
	o.write_shift(1, 0x33);
	o.write_shift(1, 0x00);
	return o;
}*/

/* [MS-XLSB] 2.4.646 BrtFileRecover */
/*function write_BrtFileRecover(data, o) {
	if(!o) o = new_buf(1);
	o.write_shift(1,0);
	return o;
}*/

/* [MS-XLSB] 2.1.7.61 Workbook */
function write_wb_bin(wb, opts) {
	var ba = buf_array();
	write_record(ba, 0x0083 /* BrtBeginBook */);
	write_record(ba, 0x0080 /* BrtFileVersion */, write_BrtFileVersion());
	/* [[BrtFileSharingIso] BrtFileSharing] */
	write_record(ba, 0x0099 /* BrtWbProp */, write_BrtWbProp(wb.Workbook && wb.Workbook.WBProps || null));
	/* [ACABSPATH] */
	/* [[BrtBookProtectionIso] BrtBookProtection] */
	write_BOOKVIEWS(ba, wb, opts);
	write_BUNDLESHS(ba, wb, opts);
	/* [FNGROUP] */
	/* [EXTERNALS] */
	/* *BrtName */
	/* write_record(ba, 0x009D BrtCalcProp, write_BrtCalcProp()); */
	/* [BrtOleSize] */
	/* *(BrtUserBookView *FRT) */
	/* [PIVOTCACHEIDS] */
	/* [BrtWbFactoid] */
	/* [SMARTTAGTYPES] */
	/* [BrtWebOpt] */
	/* write_record(ba, 0x009B BrtFileRecover, write_BrtFileRecover()); */
	/* [WEBPUBITEMS] */
	/* [CRERRS] */
	/* FRTWORKBOOK */
	write_record(ba, 0x0084 /* BrtEndBook */);

	return ba.end();
}
function parse_wb(data, name/*:string*/, opts)/*:WorkbookFile*/ {
	if(name.slice(-4)===".bin") return parse_wb_bin((data/*:any*/), opts);
	return parse_wb_xml((data/*:any*/), opts);
}

function parse_ws(data, name/*:string*/, idx/*:number*/, opts, rels, wb, themes, styles)/*:Worksheet*/ {
	if(name.slice(-4)===".bin") return parse_ws_bin((data/*:any*/), opts, idx, rels, wb, themes, styles);
	return parse_ws_xml((data/*:any*/), opts, idx, rels, wb, themes, styles);
}

function parse_cs(data, name/*:string*/, idx/*:number*/, opts, rels, wb, themes, styles)/*:Worksheet*/ {
	if(name.slice(-4)===".bin") return parse_cs_bin((data/*:any*/), opts, idx, rels, wb, themes, styles);
	return parse_cs_xml((data/*:any*/), opts, idx, rels, wb, themes, styles);
}

function parse_ms(data, name/*:string*/, idx/*:number*/, opts, rels, wb, themes, styles)/*:Worksheet*/ {
	if(name.slice(-4)===".bin") return parse_ms_bin((data/*:any*/), opts, idx, rels, wb, themes, styles);
	return parse_ms_xml((data/*:any*/), opts, idx, rels, wb, themes, styles);
}

function parse_ds(data, name/*:string*/, idx/*:number*/, opts, rels, wb, themes, styles)/*:Worksheet*/ {
	if(name.slice(-4)===".bin") return parse_ds_bin((data/*:any*/), opts, idx, rels, wb, themes, styles);
	return parse_ds_xml((data/*:any*/), opts, idx, rels, wb, themes, styles);
}

function parse_sty(data, name/*:string*/, themes, opts) {
	if(name.slice(-4)===".bin") return parse_sty_bin((data/*:any*/), themes, opts);
	return parse_sty_xml((data/*:any*/), themes, opts);
}

function parse_theme(data/*:string*/, name/*:string*/, opts) {
	return parse_theme_xml(data, opts);
}

function parse_sst(data, name/*:string*/, opts)/*:SST*/ {
	if(name.slice(-4)===".bin") return parse_sst_bin((data/*:any*/), opts);
	return parse_sst_xml((data/*:any*/), opts);
}

function parse_cmnt(data, name/*:string*/, opts)/*:Array<RawComment>*/ {
	if(name.slice(-4)===".bin") return parse_comments_bin((data/*:any*/), opts);
	return parse_comments_xml((data/*:any*/), opts);
}

function parse_cc(data, name/*:string*/, opts) {
	if(name.slice(-4)===".bin") return parse_cc_bin((data/*:any*/), name, opts);
	return parse_cc_xml((data/*:any*/), name, opts);
}

function parse_xlink(data, rel, name/*:string*/, opts) {
	if(name.slice(-4)===".bin") return parse_xlink_bin((data/*:any*/), rel, name, opts);
	return parse_xlink_xml((data/*:any*/), rel, name, opts);
}

function parse_xlmeta(data, name/*:string*/, opts) {
	if(name.slice(-4)===".bin") return parse_xlmeta_bin((data/*:any*/), name, opts);
	return parse_xlmeta_xml((data/*:any*/), name, opts);
}

function write_wb(wb, name/*:string*/, opts) {
	return (name.slice(-4)===".bin" ? write_wb_bin : write_wb_xml)(wb, opts);
}

function write_ws(data/*:number*/, name/*:string*/, opts, wb/*:Workbook*/, rels) {
	return (name.slice(-4)===".bin" ? write_ws_bin : write_ws_xml)(data, opts, wb, rels);
}

// eslint-disable-next-line no-unused-vars
function write_cs(data/*:number*/, name/*:string*/, opts, wb/*:Workbook*/, rels) {
	return (name.slice(-4)===".bin" ? write_cs_bin : write_cs_xml)(data, opts, wb, rels);
}

function write_sty(data, name/*:string*/, opts) {
	return (name.slice(-4)===".bin" ? write_sty_bin : write_sty_xml)(data, opts);
}

function write_sst(data/*:SST*/, name/*:string*/, opts) {
	return (name.slice(-4)===".bin" ? write_sst_bin : write_sst_xml)(data, opts);
}

function write_cmnt(data/*:Array<any>*/, name/*:string*/, opts) {
	return (name.slice(-4)===".bin" ? write_comments_bin : write_comments_xml)(data, opts);
}
/*
function write_cc(data, name:string, opts) {
	return (name.slice(-4)===".bin" ? write_cc_bin : write_cc_xml)(data, opts);
}
*/

function write_xlmeta(name/*:string*/) {
	return (name.slice(-4)===".bin" ? write_xlmeta_bin : write_xlmeta_xml)();
}
var attregexg2=/([\w:]+)=((?:")([^"]*)(?:")|(?:')([^']*)(?:'))/g;
var attregex2=/([\w:]+)=((?:")(?:[^"]*)(?:")|(?:')(?:[^']*)(?:'))/;
function xlml_parsexmltag(tag/*:string*/, skip_root/*:?boolean*/) {
	var words = tag.split(/\s+/);
	var z/*:any*/ = ([]/*:any*/); if(!skip_root) z[0] = words[0];
	if(words.length === 1) return z;
	var m = tag.match(attregexg2), y, j, w, i;
	if(m) for(i = 0; i != m.length; ++i) {
		y = m[i].match(attregex2);
/*:: if(!y || !y[2]) continue; */
		if((j=y[1].indexOf(":")) === -1) z[y[1]] = y[2].slice(1,y[2].length-1);
		else {
			if(y[1].slice(0,6) === "xmlns:") w = "xmlns"+y[1].slice(6);
			else w = y[1].slice(j+1);
			z[w] = y[2].slice(1,y[2].length-1);
		}
	}
	return z;
}
function xlml_parsexmltagobj(tag/*:string*/) {
	var words = tag.split(/\s+/);
	var z = {};
	if(words.length === 1) return z;
	var m = tag.match(attregexg2), y, j, w, i;
	if(m) for(i = 0; i != m.length; ++i) {
		y = m[i].match(attregex2);
/*:: if(!y || !y[2]) continue; */
		if((j=y[1].indexOf(":")) === -1) z[y[1]] = y[2].slice(1,y[2].length-1);
		else {
			if(y[1].slice(0,6) === "xmlns:") w = "xmlns"+y[1].slice(6);
			else w = y[1].slice(j+1);
			z[w] = y[2].slice(1,y[2].length-1);
		}
	}
	return z;
}

// ----

/* map from xlml named formats to SSF TODO: localize */
var XLMLFormatMap/*: {[string]:string}*/;

function xlml_format(format, value)/*:string*/ {
	var fmt = XLMLFormatMap[format] || unescapexml(format);
	if(fmt === "General") return SSF_general(value);
	return SSF_format(fmt, value);
}

function xlml_set_custprop(Custprops, key, cp, val/*:string*/) {
	var oval/*:any*/ = val;
	switch((cp[0].match(/dt:dt="([\w.]+)"/)||["",""])[1]) {
		case "boolean": oval = parsexmlbool(val); break;
		case "i2": case "int": oval = parseInt(val, 10); break;
		case "r4": case "float": oval = parseFloat(val); break;
		case "date": case "dateTime.tz": oval = parseDate(val); break;
		case "i8": case "string": case "fixed": case "uuid": case "bin.base64": break;
		default: throw new Error("bad custprop:" + cp[0]);
	}
	Custprops[unescapexml(key)] = oval;
}

function safe_format_xlml(cell/*:Cell*/, nf, o) {
	if(cell.t === 'z') return;
	if(!o || o.cellText !== false) try {
		if(cell.t === 'e') { cell.w = cell.w || BErr[cell.v]; }
		else if(nf === "General") {
			if(cell.t === 'n') {
				if((cell.v|0) === cell.v) cell.w = cell.v.toString(10);
				else cell.w = SSF_general_num(cell.v);
			}
			else cell.w = SSF_general(cell.v);
		}
		else cell.w = xlml_format(nf||"General", cell.v);
	} catch(e) { if(o.WTF) throw e; }
	try {
		var z = XLMLFormatMap[nf]||nf||"General";
		if(o.cellNF) cell.z = z;
		if(o.cellDates && cell.t == 'n' && fmt_is_date(z)) {
			var _d = SSF_parse_date_code(cell.v); if(_d) { cell.t = 'd'; cell.v = new Date(_d.y, _d.m-1,_d.d,_d.H,_d.M,_d.S,_d.u); }
		}
	} catch(e) { if(o.WTF) throw e; }
}

function process_style_xlml(styles, stag, opts) {
	if(opts.cellStyles) {
		if(stag.Interior) {
			var I = stag.Interior;
			if(I.Pattern) I.patternType = XLMLPatternTypeMap[I.Pattern] || I.Pattern;
		}
	}
	styles[stag.ID] = stag;
}

/* TODO: there must exist some form of OSP-blessed spec */
function parse_xlml_data(xml, ss, data, cell/*:any*/, base, styles, csty, row, arrayf, o) {
	var nf = "General", sid = cell.StyleID, S = {}; o = o || {};
	var interiors = [];
	var i = 0;
	if(sid === undefined && row) sid = row.StyleID;
	if(sid === undefined && csty) sid = csty.StyleID;
	while(styles[sid] !== undefined) {
		if(styles[sid].nf) nf = styles[sid].nf;
		if(styles[sid].Interior) interiors.push(styles[sid].Interior);
		if(!styles[sid].Parent) break;
		sid = styles[sid].Parent;
	}
	switch(data.Type) {
		case 'Boolean':
			cell.t = 'b';
			cell.v = parsexmlbool(xml);
			break;
		case 'String':
			cell.t = 's'; cell.r = xlml_fixstr(unescapexml(xml));
			cell.v = (xml.indexOf("<") > -1 ? unescapexml(ss||xml).replace(/<.*?>/g, "") : cell.r); // todo: BR etc
			break;
		case 'DateTime':
			if(xml.slice(-1) != "Z") xml += "Z";
			cell.v = (parseDate(xml) - new Date(Date.UTC(1899, 11, 30))) / (24 * 60 * 60 * 1000);
			if(cell.v !== cell.v) cell.v = unescapexml(xml);
			else if(cell.v<60) cell.v = cell.v -1;
			if(!nf || nf == "General") nf = "yyyy-mm-dd";
			/* falls through */
		case 'Number':
			if(cell.v === undefined) cell.v=+xml;
			if(!cell.t) cell.t = 'n';
			break;
		case 'Error': cell.t = 'e'; cell.v = RBErr[xml]; if(o.cellText !== false) cell.w = xml; break;
		default:
			if(xml == "" && ss == "") { cell.t = 'z'; }
			else { cell.t = 's'; cell.v = xlml_fixstr(ss||xml); }
			break;
	}
	safe_format_xlml(cell, nf, o);
	if(o.cellFormula !== false) {
		if(cell.Formula) {
			var fstr = unescapexml(cell.Formula);
			/* strictly speaking, the leading = is required but some writers omit */
			if(fstr.charCodeAt(0) == 61 /* = */) fstr = fstr.slice(1);
			cell.f = rc_to_a1(fstr, base);
			delete cell.Formula;
			if(cell.ArrayRange == "RC") cell.F = rc_to_a1("RC:RC", base);
			else if(cell.ArrayRange) {
				cell.F = rc_to_a1(cell.ArrayRange, base);
				arrayf.push([safe_decode_range(cell.F), cell.F]);
			}
		} else {
			for(i = 0; i < arrayf.length; ++i)
				if(base.r >= arrayf[i][0].s.r && base.r <= arrayf[i][0].e.r)
					if(base.c >= arrayf[i][0].s.c && base.c <= arrayf[i][0].e.c)
						cell.F = arrayf[i][1];
		}
	}
	if(o.cellStyles) {
		interiors.forEach(function(x) {
			if(!S.patternType && x.patternType) S.patternType = x.patternType;
		});
		cell.s = S;
	}
	if(cell.StyleID !== undefined) cell.ixfe = cell.StyleID;
}

function xlml_clean_comment(comment/*:any*/) {
	comment.t = comment.v || "";
	comment.t = comment.t.replace(/\r\n/g,"\n").replace(/\r/g,"\n");
	comment.v = comment.w = comment.ixfe = undefined;
}

/* TODO: Everything */
function parse_xlml_xml(d, _opts)/*:Workbook*/ {
	var opts = _opts || {};
	make_ssf();
	var str = debom(xlml_normalize(d));
	if(opts.type == 'binary' || opts.type == 'array' || opts.type == 'base64') {
		if(typeof $cptable !== 'undefined') str = $cptable.utils.decode(65001, char_codes(str));
		else str = utf8read(str);
	}
	var opening = str.slice(0, 1024).toLowerCase(), ishtml = false;
	opening = opening.replace(/".*?"/g, "");
	if((opening.indexOf(">") & 1023) > Math.min((opening.indexOf(",") & 1023), (opening.indexOf(";")&1023))) { var _o = dup(opts); _o.type = "string"; return PRN.to_workbook(str, _o); }
	if(opening.indexOf("<?xml") == -1) ["html", "table", "head", "meta", "script", "style", "div"].forEach(function(tag) { if(opening.indexOf("<" + tag) >= 0) ishtml = true; });
	if(ishtml) return html_to_workbook(str, opts);

	XLMLFormatMap = ({
		"General Number": "General",
		"General Date": table_fmt[22],
		"Long Date": "dddd, mmmm dd, yyyy",
		"Medium Date": table_fmt[15],
		"Short Date": table_fmt[14],
		"Long Time": table_fmt[19],
		"Medium Time": table_fmt[18],
		"Short Time": table_fmt[20],
		"Currency": '"$"#,##0.00_);[Red]\\("$"#,##0.00\\)',
		"Fixed": table_fmt[2],
		"Standard": table_fmt[4],
		"Percent": table_fmt[10],
		"Scientific": table_fmt[11],
		"Yes/No": '"Yes";"Yes";"No";@',
		"True/False": '"True";"True";"False";@',
		"On/Off": '"Yes";"Yes";"No";@'
	}/*:any*/);


	var Rn;
	var state = [], tmp;
	if(DENSE != null && opts.dense == null) opts.dense = DENSE;
	var sheets = {}, sheetnames/*:Array<string>*/ = [], cursheet/*:Worksheet*/ = (opts.dense ? [] : {}), sheetname = "";
	var cell = ({}/*:any*/), row = {};// eslint-disable-line no-unused-vars
	var dtag = xlml_parsexmltag('<Data ss:Type="String">'), didx = 0;
	var c = 0, r = 0;
	var refguess/*:Range*/ = {s: {r:2000000, c:2000000}, e: {r:0, c:0} };
	var styles = {}, stag = {};
	var ss = "", fidx = 0;
	var merges/*:Array<Range>*/ = [];
	var Props = {}, Custprops = {}, pidx = 0, cp = [];
	var comments/*:Array<Comment>*/ = [], comment/*:Comment*/ = ({}/*:any*/);
	var cstys = [], csty, seencol = false;
	var arrayf/*:Array<[Range, string]>*/ = [];
	var rowinfo/*:Array<RowInfo>*/ = [], rowobj = {}, cc = 0, rr = 0;
	var Workbook/*:WBWBProps*/ = ({ Sheets:[], WBProps:{date1904:false} }/*:any*/), wsprops = {};
	xlmlregex.lastIndex = 0;
	str = str.replace(/<!--([\s\S]*?)-->/mg,"");
	var raw_Rn3 = "";
	while((Rn = xlmlregex.exec(str))) switch((Rn[3] = (raw_Rn3 = Rn[3]).toLowerCase())) {
		case 'data' /*case 'Data'*/:
			if(raw_Rn3 == "data") {
				if(Rn[1]==='/'){if((tmp=state.pop())[0]!==Rn[3]) throw new Error("Bad state: "+tmp.join("|"));}
				else if(Rn[0].charAt(Rn[0].length-2) !== '/') state.push([Rn[3], true]);
				break;
			}
			if(state[state.length-1][1]) break;
			if(Rn[1]==='/') parse_xlml_data(str.slice(didx, Rn.index), ss, dtag, state[state.length-1][0]==/*"Comment"*/"comment"?comment:cell, {c:c,r:r}, styles, cstys[c], row, arrayf, opts);
			else { ss = ""; dtag = xlml_parsexmltag(Rn[0]); didx = Rn.index + Rn[0].length; }
			break;
		case 'cell' /*case 'Cell'*/:
			if(Rn[1]==='/'){
				if(comments.length > 0) cell.c = comments;
				if((!opts.sheetRows || opts.sheetRows > r) && cell.v !== undefined) {
					if(opts.dense) {
						if(!cursheet[r]) cursheet[r] = [];
						cursheet[r][c] = cell;
					} else cursheet[encode_col(c) + encode_row(r)] = cell;
				}
				if(cell.HRef) {
					cell.l = ({Target:unescapexml(cell.HRef)}/*:any*/);
					if(cell.HRefScreenTip) cell.l.Tooltip = cell.HRefScreenTip;
					delete cell.HRef; delete cell.HRefScreenTip;
				}
				if(cell.MergeAcross || cell.MergeDown) {
					cc = c + (parseInt(cell.MergeAcross,10)|0);
					rr = r + (parseInt(cell.MergeDown,10)|0);
					merges.push({s:{c:c,r:r},e:{c:cc,r:rr}});
				}
				if(!opts.sheetStubs) { if(cell.MergeAcross) c = cc + 1; else ++c; }
				else if(cell.MergeAcross || cell.MergeDown) {
					/*:: if(!cc) cc = 0; if(!rr) rr = 0; */
					for(var cma = c; cma <= cc; ++cma) {
						for(var cmd = r; cmd <= rr; ++cmd) {
							if(cma > c || cmd > r) {
								if(opts.dense) {
									if(!cursheet[cmd]) cursheet[cmd] = [];
									cursheet[cmd][cma] = {t:'z'};
								} else cursheet[encode_col(cma) + encode_row(cmd)] = {t:'z'};
							}
						}
					}
					c = cc + 1;
				}
				else ++c;
			} else {
				cell = xlml_parsexmltagobj(Rn[0]);
				if(cell.Index) c = +cell.Index - 1;
				if(c < refguess.s.c) refguess.s.c = c;
				if(c > refguess.e.c) refguess.e.c = c;
				if(Rn[0].slice(-2) === "/>") ++c;
				comments = [];
			}
			break;
		case 'row' /*case 'Row'*/:
			if(Rn[1]==='/' || Rn[0].slice(-2) === "/>") {
				if(r < refguess.s.r) refguess.s.r = r;
				if(r > refguess.e.r) refguess.e.r = r;
				if(Rn[0].slice(-2) === "/>") {
					row = xlml_parsexmltag(Rn[0]);
					if(row.Index) r = +row.Index - 1;
				}
				c = 0; ++r;
			} else {
				row = xlml_parsexmltag(Rn[0]);
				if(row.Index) r = +row.Index - 1;
				rowobj = {};
				if(row.AutoFitHeight == "0" || row.Height) {
					rowobj.hpx = parseInt(row.Height, 10); rowobj.hpt = px2pt(rowobj.hpx);
					rowinfo[r] = rowobj;
				}
				if(row.Hidden == "1") { rowobj.hidden = true; rowinfo[r] = rowobj; }
			}
			break;
		case 'worksheet' /*case 'Worksheet'*/: /* TODO: read range from FullRows/FullColumns */
			if(Rn[1]==='/'){
				if((tmp=state.pop())[0]!==Rn[3]) throw new Error("Bad state: "+tmp.join("|"));
				sheetnames.push(sheetname);
				if(refguess.s.r <= refguess.e.r && refguess.s.c <= refguess.e.c) {
					cursheet["!ref"] = encode_range(refguess);
					if(opts.sheetRows && opts.sheetRows <= refguess.e.r) {
						cursheet["!fullref"] = cursheet["!ref"];
						refguess.e.r = opts.sheetRows - 1;
						cursheet["!ref"] = encode_range(refguess);
					}
				}
				if(merges.length) cursheet["!merges"] = merges;
				if(cstys.length > 0) cursheet["!cols"] = cstys;
				if(rowinfo.length > 0) cursheet["!rows"] = rowinfo;
				sheets[sheetname] = cursheet;
			} else {
				refguess = {s: {r:2000000, c:2000000}, e: {r:0, c:0} };
				r = c = 0;
				state.push([Rn[3], false]);
				tmp = xlml_parsexmltag(Rn[0]);
				sheetname = unescapexml(tmp.Name);
				cursheet = (opts.dense ? [] : {});
				merges = [];
				arrayf = [];
				rowinfo = [];
				wsprops = {name:sheetname, Hidden:0};
				Workbook.Sheets.push(wsprops);
			}
			break;
		case 'table' /*case 'Table'*/:
			if(Rn[1]==='/'){if((tmp=state.pop())[0]!==Rn[3]) throw new Error("Bad state: "+tmp.join("|"));}
			else if(Rn[0].slice(-2) == "/>") break;
			else {
				state.push([Rn[3], false]);
				cstys = []; seencol = false;
			}
			break;

		case 'style' /*case 'Style'*/:
			if(Rn[1]==='/') process_style_xlml(styles, stag, opts);
			else stag = xlml_parsexmltag(Rn[0]);
			break;

		case 'numberformat' /*case 'NumberFormat'*/:
			stag.nf = unescapexml(xlml_parsexmltag(Rn[0]).Format || "General");
			if(XLMLFormatMap[stag.nf]) stag.nf = XLMLFormatMap[stag.nf];
			for(var ssfidx = 0; ssfidx != 0x188; ++ssfidx) if(table_fmt[ssfidx] == stag.nf) break;
			if(ssfidx == 0x188) for(ssfidx = 0x39; ssfidx != 0x188; ++ssfidx) if(table_fmt[ssfidx] == null) { SSF_load(stag.nf, ssfidx); break; }
			break;

		case 'column' /*case 'Column'*/:
			if(state[state.length-1][0] !== /*'Table'*/'table') break;
			csty = xlml_parsexmltag(Rn[0]);
			if(csty.Hidden) { csty.hidden = true; delete csty.Hidden; }
			if(csty.Width) csty.wpx = parseInt(csty.Width, 10);
			if(!seencol && csty.wpx > 10) {
				seencol = true; MDW = DEF_MDW; //find_mdw_wpx(csty.wpx);
				for(var _col = 0; _col < cstys.length; ++_col) if(cstys[_col]) process_col(cstys[_col]);
			}
			if(seencol) process_col(csty);
			cstys[(csty.Index-1||cstys.length)] = csty;
			for(var i = 0; i < +csty.Span; ++i) cstys[cstys.length] = dup(csty);
			break;

		case 'namedrange' /*case 'NamedRange'*/:
			if(Rn[1]==='/') break;
			if(!Workbook.Names) Workbook.Names = [];
			var _NamedRange = parsexmltag(Rn[0]);
			var _DefinedName/*:DefinedName*/ = ({
				Name: _NamedRange.Name,
				Ref: rc_to_a1(_NamedRange.RefersTo.slice(1), {r:0, c:0})
			}/*:any*/);
			if(Workbook.Sheets.length>0) _DefinedName.Sheet=Workbook.Sheets.length-1;
			/*:: if(Workbook.Names) */Workbook.Names.push(_DefinedName);
			break;

		case 'namedcell' /*case 'NamedCell'*/: break;
		case 'b' /*case 'B'*/: break;
		case 'i' /*case 'I'*/: break;
		case 'u' /*case 'U'*/: break;
		case 's' /*case 'S'*/: break;
		case 'em' /*case 'EM'*/: break;
		case 'h2' /*case 'H2'*/: break;
		case 'h3' /*case 'H3'*/: break;
		case 'sub' /*case 'Sub'*/: break;
		case 'sup' /*case 'Sup'*/: break;
		case 'span' /*case 'Span'*/: break;
		case 'alignment' /*case 'Alignment'*/:
			break;
		case 'borders' /*case 'Borders'*/: break;
		case 'border' /*case 'Border'*/: break;
		case 'font' /*case 'Font'*/:
			if(Rn[0].slice(-2) === "/>") break;
			else if(Rn[1]==="/") ss += str.slice(fidx, Rn.index);
			else fidx = Rn.index + Rn[0].length;
			break;
		case 'interior' /*case 'Interior'*/:
			if(!opts.cellStyles) break;
			stag.Interior = xlml_parsexmltag(Rn[0]);
			break;
		case 'protection' /*case 'Protection'*/: break;

		case 'author' /*case 'Author'*/:
		case 'title' /*case 'Title'*/:
		case 'description' /*case 'Description'*/:
		case 'created' /*case 'Created'*/:
		case 'keywords' /*case 'Keywords'*/:
		case 'subject' /*case 'Subject'*/:
		case 'category' /*case 'Category'*/:
		case 'company' /*case 'Company'*/:
		case 'lastauthor' /*case 'LastAuthor'*/:
		case 'lastsaved' /*case 'LastSaved'*/:
		case 'lastprinted' /*case 'LastPrinted'*/:
		case 'version' /*case 'Version'*/:
		case 'revision' /*case 'Revision'*/:
		case 'totaltime' /*case 'TotalTime'*/:
		case 'hyperlinkbase' /*case 'HyperlinkBase'*/:
		case 'manager' /*case 'Manager'*/:
		case 'contentstatus' /*case 'ContentStatus'*/:
		case 'identifier' /*case 'Identifier'*/:
		case 'language' /*case 'Language'*/:
		case 'appname' /*case 'AppName'*/:
			if(Rn[0].slice(-2) === "/>") break;
			else if(Rn[1]==="/") xlml_set_prop(Props, raw_Rn3, str.slice(pidx, Rn.index));
			else pidx = Rn.index + Rn[0].length;
			break;
		case 'paragraphs' /*case 'Paragraphs'*/: break;

		case 'styles' /*case 'Styles'*/:
		case 'workbook' /*case 'Workbook'*/:
			if(Rn[1]==='/'){if((tmp=state.pop())[0]!==Rn[3]) throw new Error("Bad state: "+tmp.join("|"));}
			else state.push([Rn[3], false]);
			break;

		case 'comment' /*case 'Comment'*/:
			if(Rn[1]==='/'){
				if((tmp=state.pop())[0]!==Rn[3]) throw new Error("Bad state: "+tmp.join("|"));
				xlml_clean_comment(comment);
				comments.push(comment);
			} else {
				state.push([Rn[3], false]);
				tmp = xlml_parsexmltag(Rn[0]);
				comment = ({a:tmp.Author}/*:any*/);
			}
			break;

		case 'autofilter' /*case 'AutoFilter'*/:
			if(Rn[1]==='/'){if((tmp=state.pop())[0]!==Rn[3]) throw new Error("Bad state: "+tmp.join("|"));}
			else if(Rn[0].charAt(Rn[0].length-2) !== '/') {
				var AutoFilter = xlml_parsexmltag(Rn[0]);
				cursheet['!autofilter'] = { ref:rc_to_a1(AutoFilter.Range).replace(/\$/g,"") };
				state.push([Rn[3], true]);
			}
			break;

		case 'name' /*case 'Name'*/: break;

		case 'datavalidation' /*case 'DataValidation'*/:
			if(Rn[1]==='/'){
				if((tmp=state.pop())[0]!==Rn[3]) throw new Error("Bad state: "+tmp.join("|"));
			} else {
				if(Rn[0].charAt(Rn[0].length-2) !== '/') state.push([Rn[3], true]);
			}
			break;

		case 'pixelsperinch' /*case 'PixelsPerInch'*/:
			break;
		case 'componentoptions' /*case 'ComponentOptions'*/:
		case 'documentproperties' /*case 'DocumentProperties'*/:
		case 'customdocumentproperties' /*case 'CustomDocumentProperties'*/:
		case 'officedocumentsettings' /*case 'OfficeDocumentSettings'*/:
		case 'pivottable' /*case 'PivotTable'*/:
		case 'pivotcache' /*case 'PivotCache'*/:
		case 'names' /*case 'Names'*/:
		case 'mapinfo' /*case 'MapInfo'*/:
		case 'pagebreaks' /*case 'PageBreaks'*/:
		case 'querytable' /*case 'QueryTable'*/:
		case 'sorting' /*case 'Sorting'*/:
		case 'schema' /*case 'Schema'*/: //case 'data' /*case 'data'*/:
		case 'conditionalformatting' /*case 'ConditionalFormatting'*/:
		case 'smarttagtype' /*case 'SmartTagType'*/:
		case 'smarttags' /*case 'SmartTags'*/:
		case 'excelworkbook' /*case 'ExcelWorkbook'*/:
		case 'workbookoptions' /*case 'WorkbookOptions'*/:
		case 'worksheetoptions' /*case 'WorksheetOptions'*/:
			if(Rn[1]==='/'){if((tmp=state.pop())[0]!==Rn[3]) throw new Error("Bad state: "+tmp.join("|"));}
			else if(Rn[0].charAt(Rn[0].length-2) !== '/') state.push([Rn[3], true]);
			break;

		case 'null' /*case 'Null'*/: break;

		default:
			/* FODS file root is <office:document> */
			if(state.length == 0 && Rn[3] == "document") return parse_fods(str, opts);
			/* UOS file root is <uof:UOF> */
			if(state.length == 0 && Rn[3] == "uof"/*"UOF"*/) return parse_fods(str, opts);

			var seen = true;
			switch(state[state.length-1][0]) {
				/* OfficeDocumentSettings */
				case 'officedocumentsettings' /*case 'OfficeDocumentSettings'*/: switch(Rn[3]) {
					case 'allowpng' /*case 'AllowPNG'*/: break;
					case 'removepersonalinformation' /*case 'RemovePersonalInformation'*/: break;
					case 'downloadcomponents' /*case 'DownloadComponents'*/: break;
					case 'locationofcomponents' /*case 'LocationOfComponents'*/: break;
					case 'colors' /*case 'Colors'*/: break;
					case 'color' /*case 'Color'*/: break;
					case 'index' /*case 'Index'*/: break;
					case 'rgb' /*case 'RGB'*/: break;
					case 'targetscreensize' /*case 'TargetScreenSize'*/: break;
					case 'readonlyrecommended' /*case 'ReadOnlyRecommended'*/: break;
					default: seen = false;
				} break;

				/* ComponentOptions */
				case 'componentoptions' /*case 'ComponentOptions'*/: switch(Rn[3]) {
					case 'toolbar' /*case 'Toolbar'*/: break;
					case 'hideofficelogo' /*case 'HideOfficeLogo'*/: break;
					case 'spreadsheetautofit' /*case 'SpreadsheetAutoFit'*/: break;
					case 'label' /*case 'Label'*/: break;
					case 'caption' /*case 'Caption'*/: break;
					case 'maxheight' /*case 'MaxHeight'*/: break;
					case 'maxwidth' /*case 'MaxWidth'*/: break;
					case 'nextsheetnumber' /*case 'NextSheetNumber'*/: break;
					default: seen = false;
				} break;

				/* ExcelWorkbook */
				case 'excelworkbook' /*case 'ExcelWorkbook'*/: switch(Rn[3]) {
					case 'date1904' /*case 'Date1904'*/:
						/*:: if(!Workbook.WBProps) Workbook.WBProps = {}; */
						Workbook.WBProps.date1904 = true;
						break;
					case 'windowheight' /*case 'WindowHeight'*/: break;
					case 'windowwidth' /*case 'WindowWidth'*/: break;
					case 'windowtopx' /*case 'WindowTopX'*/: break;
					case 'windowtopy' /*case 'WindowTopY'*/: break;
					case 'tabratio' /*case 'TabRatio'*/: break;
					case 'protectstructure' /*case 'ProtectStructure'*/: break;
					case 'protectwindow' /*case 'ProtectWindow'*/: break;
					case 'protectwindows' /*case 'ProtectWindows'*/: break;
					case 'activesheet' /*case 'ActiveSheet'*/: break;
					case 'displayinknotes' /*case 'DisplayInkNotes'*/: break;
					case 'firstvisiblesheet' /*case 'FirstVisibleSheet'*/: break;
					case 'supbook' /*case 'SupBook'*/: break;
					case 'sheetname' /*case 'SheetName'*/: break;
					case 'sheetindex' /*case 'SheetIndex'*/: break;
					case 'sheetindexfirst' /*case 'SheetIndexFirst'*/: break;
					case 'sheetindexlast' /*case 'SheetIndexLast'*/: break;
					case 'dll' /*case 'Dll'*/: break;
					case 'acceptlabelsinformulas' /*case 'AcceptLabelsInFormulas'*/: break;
					case 'donotsavelinkvalues' /*case 'DoNotSaveLinkValues'*/: break;
					case 'iteration' /*case 'Iteration'*/: break;
					case 'maxiterations' /*case 'MaxIterations'*/: break;
					case 'maxchange' /*case 'MaxChange'*/: break;
					case 'path' /*case 'Path'*/: break;
					case 'xct' /*case 'Xct'*/: break;
					case 'count' /*case 'Count'*/: break;
					case 'selectedsheets' /*case 'SelectedSheets'*/: break;
					case 'calculation' /*case 'Calculation'*/: break;
					case 'uncalced' /*case 'Uncalced'*/: break;
					case 'startupprompt' /*case 'StartupPrompt'*/: break;
					case 'crn' /*case 'Crn'*/: break;
					case 'externname' /*case 'ExternName'*/: break;
					case 'formula' /*case 'Formula'*/: break;
					case 'colfirst' /*case 'ColFirst'*/: break;
					case 'collast' /*case 'ColLast'*/: break;
					case 'wantadvise' /*case 'WantAdvise'*/: break;
					case 'boolean' /*case 'Boolean'*/: break;
					case 'error' /*case 'Error'*/: break;
					case 'text' /*case 'Text'*/: break;
					case 'ole' /*case 'OLE'*/: break;
					case 'noautorecover' /*case 'NoAutoRecover'*/: break;
					case 'publishobjects' /*case 'PublishObjects'*/: break;
					case 'donotcalculatebeforesave' /*case 'DoNotCalculateBeforeSave'*/: break;
					case 'number' /*case 'Number'*/: break;
					case 'refmoder1c1' /*case 'RefModeR1C1'*/: break;
					case 'embedsavesmarttags' /*case 'EmbedSaveSmartTags'*/: break;
					default: seen = false;
				} break;

				/* WorkbookOptions */
				case 'workbookoptions' /*case 'WorkbookOptions'*/: switch(Rn[3]) {
					case 'owcversion' /*case 'OWCVersion'*/: break;
					case 'height' /*case 'Height'*/: break;
					case 'width' /*case 'Width'*/: break;
					default: seen = false;
				} break;

				/* WorksheetOptions */
				case 'worksheetoptions' /*case 'WorksheetOptions'*/: switch(Rn[3]) {
					case 'visible' /*case 'Visible'*/:
						if(Rn[0].slice(-2) === "/>"){/* empty */}
						else if(Rn[1]==="/") switch(str.slice(pidx, Rn.index)) {
							case "SheetHidden": wsprops.Hidden = 1; break;
							case "SheetVeryHidden": wsprops.Hidden = 2; break;
						}
						else pidx = Rn.index + Rn[0].length;
						break;
					case 'header' /*case 'Header'*/:
						if(!cursheet['!margins']) default_margins(cursheet['!margins']={}, 'xlml');
						if(!isNaN(+parsexmltag(Rn[0]).Margin)) cursheet['!margins'].header = +parsexmltag(Rn[0]).Margin;
						break;
					case 'footer' /*case 'Footer'*/:
						if(!cursheet['!margins']) default_margins(cursheet['!margins']={}, 'xlml');
						if(!isNaN(+parsexmltag(Rn[0]).Margin)) cursheet['!margins'].footer = +parsexmltag(Rn[0]).Margin;
						break;
					case 'pagemargins' /*case 'PageMargins'*/:
						var pagemargins = parsexmltag(Rn[0]);
						if(!cursheet['!margins']) default_margins(cursheet['!margins']={},'xlml');
						if(!isNaN(+pagemargins.Top)) cursheet['!margins'].top = +pagemargins.Top;
						if(!isNaN(+pagemargins.Left)) cursheet['!margins'].left = +pagemargins.Left;
						if(!isNaN(+pagemargins.Right)) cursheet['!margins'].right = +pagemargins.Right;
						if(!isNaN(+pagemargins.Bottom)) cursheet['!margins'].bottom = +pagemargins.Bottom;
						break;
					case 'displayrighttoleft' /*case 'DisplayRightToLeft'*/:
						if(!Workbook.Views) Workbook.Views = [];
						if(!Workbook.Views[0]) Workbook.Views[0] = {};
						Workbook.Views[0].RTL = true;
						break;

					case 'freezepanes' /*case 'FreezePanes'*/: break;
					case 'frozennosplit' /*case 'FrozenNoSplit'*/: break;

					case 'splithorizontal' /*case 'SplitHorizontal'*/:
					case 'splitvertical' /*case 'SplitVertical'*/:
						break;

					case 'donotdisplaygridlines' /*case 'DoNotDisplayGridlines'*/:
						break;

					case 'activerow' /*case 'ActiveRow'*/: break;
					case 'activecol' /*case 'ActiveCol'*/: break;
					case 'toprowbottompane' /*case 'TopRowBottomPane'*/: break;
					case 'leftcolumnrightpane' /*case 'LeftColumnRightPane'*/: break;

					case 'unsynced' /*case 'Unsynced'*/: break;
					case 'print' /*case 'Print'*/: break;
					case 'printerrors' /*case 'PrintErrors'*/: break;
					case 'panes' /*case 'Panes'*/: break;
					case 'scale' /*case 'Scale'*/: break;
					case 'pane' /*case 'Pane'*/: break;
					case 'number' /*case 'Number'*/: break;
					case 'layout' /*case 'Layout'*/: break;
					case 'pagesetup' /*case 'PageSetup'*/: break;
					case 'selected' /*case 'Selected'*/: break;
					case 'protectobjects' /*case 'ProtectObjects'*/: break;
					case 'enableselection' /*case 'EnableSelection'*/: break;
					case 'protectscenarios' /*case 'ProtectScenarios'*/: break;
					case 'validprinterinfo' /*case 'ValidPrinterInfo'*/: break;
					case 'horizontalresolution' /*case 'HorizontalResolution'*/: break;
					case 'verticalresolution' /*case 'VerticalResolution'*/: break;
					case 'numberofcopies' /*case 'NumberofCopies'*/: break;
					case 'activepane' /*case 'ActivePane'*/: break;
					case 'toprowvisible' /*case 'TopRowVisible'*/: break;
					case 'leftcolumnvisible' /*case 'LeftColumnVisible'*/: break;
					case 'fittopage' /*case 'FitToPage'*/: break;
					case 'rangeselection' /*case 'RangeSelection'*/: break;
					case 'papersizeindex' /*case 'PaperSizeIndex'*/: break;
					case 'pagelayoutzoom' /*case 'PageLayoutZoom'*/: break;
					case 'pagebreakzoom' /*case 'PageBreakZoom'*/: break;
					case 'filteron' /*case 'FilterOn'*/: break;
					case 'fitwidth' /*case 'FitWidth'*/: break;
					case 'fitheight' /*case 'FitHeight'*/: break;
					case 'commentslayout' /*case 'CommentsLayout'*/: break;
					case 'zoom' /*case 'Zoom'*/: break;
					case 'lefttoright' /*case 'LeftToRight'*/: break;
					case 'gridlines' /*case 'Gridlines'*/: break;
					case 'allowsort' /*case 'AllowSort'*/: break;
					case 'allowfilter' /*case 'AllowFilter'*/: break;
					case 'allowinsertrows' /*case 'AllowInsertRows'*/: break;
					case 'allowdeleterows' /*case 'AllowDeleteRows'*/: break;
					case 'allowinsertcols' /*case 'AllowInsertCols'*/: break;
					case 'allowdeletecols' /*case 'AllowDeleteCols'*/: break;
					case 'allowinserthyperlinks' /*case 'AllowInsertHyperlinks'*/: break;
					case 'allowformatcells' /*case 'AllowFormatCells'*/: break;
					case 'allowsizecols' /*case 'AllowSizeCols'*/: break;
					case 'allowsizerows' /*case 'AllowSizeRows'*/: break;
					case 'nosummaryrowsbelowdetail' /*case 'NoSummaryRowsBelowDetail'*/:
						if(!cursheet["!outline"]) cursheet["!outline"] = {};
						cursheet["!outline"].above = true;
						break;
					case 'tabcolorindex' /*case 'TabColorIndex'*/: break;
					case 'donotdisplayheadings' /*case 'DoNotDisplayHeadings'*/: break;
					case 'showpagelayoutzoom' /*case 'ShowPageLayoutZoom'*/: break;
					case 'nosummarycolumnsrightdetail' /*case 'NoSummaryColumnsRightDetail'*/:
						if(!cursheet["!outline"]) cursheet["!outline"] = {};
						cursheet["!outline"].left = true;
						break;
					case 'blackandwhite' /*case 'BlackAndWhite'*/: break;
					case 'donotdisplayzeros' /*case 'DoNotDisplayZeros'*/: break;
					case 'displaypagebreak' /*case 'DisplayPageBreak'*/: break;
					case 'rowcolheadings' /*case 'RowColHeadings'*/: break;
					case 'donotdisplayoutline' /*case 'DoNotDisplayOutline'*/: break;
					case 'noorientation' /*case 'NoOrientation'*/: break;
					case 'allowusepivottables' /*case 'AllowUsePivotTables'*/: break;
					case 'zeroheight' /*case 'ZeroHeight'*/: break;
					case 'viewablerange' /*case 'ViewableRange'*/: break;
					case 'selection' /*case 'Selection'*/: break;
					case 'protectcontents' /*case 'ProtectContents'*/: break;
					default: seen = false;
				} break;

				/* PivotTable */
				case 'pivottable' /*case 'PivotTable'*/: case 'pivotcache' /*case 'PivotCache'*/: switch(Rn[3]) {
					case 'immediateitemsondrop' /*case 'ImmediateItemsOnDrop'*/: break;
					case 'showpagemultipleitemlabel' /*case 'ShowPageMultipleItemLabel'*/: break;
					case 'compactrowindent' /*case 'CompactRowIndent'*/: break;
					case 'location' /*case 'Location'*/: break;
					case 'pivotfield' /*case 'PivotField'*/: break;
					case 'orientation' /*case 'Orientation'*/: break;
					case 'layoutform' /*case 'LayoutForm'*/: break;
					case 'layoutsubtotallocation' /*case 'LayoutSubtotalLocation'*/: break;
					case 'layoutcompactrow' /*case 'LayoutCompactRow'*/: break;
					case 'position' /*case 'Position'*/: break;
					case 'pivotitem' /*case 'PivotItem'*/: break;
					case 'datatype' /*case 'DataType'*/: break;
					case 'datafield' /*case 'DataField'*/: break;
					case 'sourcename' /*case 'SourceName'*/: break;
					case 'parentfield' /*case 'ParentField'*/: break;
					case 'ptlineitems' /*case 'PTLineItems'*/: break;
					case 'ptlineitem' /*case 'PTLineItem'*/: break;
					case 'countofsameitems' /*case 'CountOfSameItems'*/: break;
					case 'item' /*case 'Item'*/: break;
					case 'itemtype' /*case 'ItemType'*/: break;
					case 'ptsource' /*case 'PTSource'*/: break;
					case 'cacheindex' /*case 'CacheIndex'*/: break;
					case 'consolidationreference' /*case 'ConsolidationReference'*/: break;
					case 'filename' /*case 'FileName'*/: break;
					case 'reference' /*case 'Reference'*/: break;
					case 'nocolumngrand' /*case 'NoColumnGrand'*/: break;
					case 'norowgrand' /*case 'NoRowGrand'*/: break;
					case 'blanklineafteritems' /*case 'BlankLineAfterItems'*/: break;
					case 'hidden' /*case 'Hidden'*/: break;
					case 'subtotal' /*case 'Subtotal'*/: break;
					case 'basefield' /*case 'BaseField'*/: break;
					case 'mapchilditems' /*case 'MapChildItems'*/: break;
					case 'function' /*case 'Function'*/: break;
					case 'refreshonfileopen' /*case 'RefreshOnFileOpen'*/: break;
					case 'printsettitles' /*case 'PrintSetTitles'*/: break;
					case 'mergelabels' /*case 'MergeLabels'*/: break;
					case 'defaultversion' /*case 'DefaultVersion'*/: break;
					case 'refreshname' /*case 'RefreshName'*/: break;
					case 'refreshdate' /*case 'RefreshDate'*/: break;
					case 'refreshdatecopy' /*case 'RefreshDateCopy'*/: break;
					case 'versionlastrefresh' /*case 'VersionLastRefresh'*/: break;
					case 'versionlastupdate' /*case 'VersionLastUpdate'*/: break;
					case 'versionupdateablemin' /*case 'VersionUpdateableMin'*/: break;
					case 'versionrefreshablemin' /*case 'VersionRefreshableMin'*/: break;
					case 'calculation' /*case 'Calculation'*/: break;
					default: seen = false;
				} break;

				/* PageBreaks */
				case 'pagebreaks' /*case 'PageBreaks'*/: switch(Rn[3]) {
					case 'colbreaks' /*case 'ColBreaks'*/: break;
					case 'colbreak' /*case 'ColBreak'*/: break;
					case 'rowbreaks' /*case 'RowBreaks'*/: break;
					case 'rowbreak' /*case 'RowBreak'*/: break;
					case 'colstart' /*case 'ColStart'*/: break;
					case 'colend' /*case 'ColEnd'*/: break;
					case 'rowend' /*case 'RowEnd'*/: break;
					default: seen = false;
				} break;

				/* AutoFilter */
				case 'autofilter' /*case 'AutoFilter'*/: switch(Rn[3]) {
					case 'autofiltercolumn' /*case 'AutoFilterColumn'*/: break;
					case 'autofiltercondition' /*case 'AutoFilterCondition'*/: break;
					case 'autofilterand' /*case 'AutoFilterAnd'*/: break;
					case 'autofilteror' /*case 'AutoFilterOr'*/: break;
					default: seen = false;
				} break;

				/* QueryTable */
				case 'querytable' /*case 'QueryTable'*/: switch(Rn[3]) {
					case 'id' /*case 'Id'*/: break;
					case 'autoformatfont' /*case 'AutoFormatFont'*/: break;
					case 'autoformatpattern' /*case 'AutoFormatPattern'*/: break;
					case 'querysource' /*case 'QuerySource'*/: break;
					case 'querytype' /*case 'QueryType'*/: break;
					case 'enableredirections' /*case 'EnableRedirections'*/: break;
					case 'refreshedinxl9' /*case 'RefreshedInXl9'*/: break;
					case 'urlstring' /*case 'URLString'*/: break;
					case 'htmltables' /*case 'HTMLTables'*/: break;
					case 'connection' /*case 'Connection'*/: break;
					case 'commandtext' /*case 'CommandText'*/: break;
					case 'refreshinfo' /*case 'RefreshInfo'*/: break;
					case 'notitles' /*case 'NoTitles'*/: break;
					case 'nextid' /*case 'NextId'*/: break;
					case 'columninfo' /*case 'ColumnInfo'*/: break;
					case 'overwritecells' /*case 'OverwriteCells'*/: break;
					case 'donotpromptforfile' /*case 'DoNotPromptForFile'*/: break;
					case 'textwizardsettings' /*case 'TextWizardSettings'*/: break;
					case 'source' /*case 'Source'*/: break;
					case 'number' /*case 'Number'*/: break;
					case 'decimal' /*case 'Decimal'*/: break;
					case 'thousandseparator' /*case 'ThousandSeparator'*/: break;
					case 'trailingminusnumbers' /*case 'TrailingMinusNumbers'*/: break;
					case 'formatsettings' /*case 'FormatSettings'*/: break;
					case 'fieldtype' /*case 'FieldType'*/: break;
					case 'delimiters' /*case 'Delimiters'*/: break;
					case 'tab' /*case 'Tab'*/: break;
					case 'comma' /*case 'Comma'*/: break;
					case 'autoformatname' /*case 'AutoFormatName'*/: break;
					case 'versionlastedit' /*case 'VersionLastEdit'*/: break;
					case 'versionlastrefresh' /*case 'VersionLastRefresh'*/: break;
					default: seen = false;
				} break;

				case 'datavalidation' /*case 'DataValidation'*/:
				switch(Rn[3]) {
					case 'range' /*case 'Range'*/: break;

					case 'type' /*case 'Type'*/: break;
					case 'min' /*case 'Min'*/: break;
					case 'max' /*case 'Max'*/: break;
					case 'sort' /*case 'Sort'*/: break;
					case 'descending' /*case 'Descending'*/: break;
					case 'order' /*case 'Order'*/: break;
					case 'casesensitive' /*case 'CaseSensitive'*/: break;
					case 'value' /*case 'Value'*/: break;
					case 'errorstyle' /*case 'ErrorStyle'*/: break;
					case 'errormessage' /*case 'ErrorMessage'*/: break;
					case 'errortitle' /*case 'ErrorTitle'*/: break;
					case 'inputmessage' /*case 'InputMessage'*/: break;
					case 'inputtitle' /*case 'InputTitle'*/: break;
					case 'combohide' /*case 'ComboHide'*/: break;
					case 'inputhide' /*case 'InputHide'*/: break;
					case 'condition' /*case 'Condition'*/: break;
					case 'qualifier' /*case 'Qualifier'*/: break;
					case 'useblank' /*case 'UseBlank'*/: break;
					case 'value1' /*case 'Value1'*/: break;
					case 'value2' /*case 'Value2'*/: break;
					case 'format' /*case 'Format'*/: break;

					case 'cellrangelist' /*case 'CellRangeList'*/: break;
					default: seen = false;
				} break;

				case 'sorting' /*case 'Sorting'*/:
				case 'conditionalformatting' /*case 'ConditionalFormatting'*/:
				switch(Rn[3]) {
					case 'range' /*case 'Range'*/: break;
					case 'type' /*case 'Type'*/: break;
					case 'min' /*case 'Min'*/: break;
					case 'max' /*case 'Max'*/: break;
					case 'sort' /*case 'Sort'*/: break;
					case 'descending' /*case 'Descending'*/: break;
					case 'order' /*case 'Order'*/: break;
					case 'casesensitive' /*case 'CaseSensitive'*/: break;
					case 'value' /*case 'Value'*/: break;
					case 'errorstyle' /*case 'ErrorStyle'*/: break;
					case 'errormessage' /*case 'ErrorMessage'*/: break;
					case 'errortitle' /*case 'ErrorTitle'*/: break;
					case 'cellrangelist' /*case 'CellRangeList'*/: break;
					case 'inputmessage' /*case 'InputMessage'*/: break;
					case 'inputtitle' /*case 'InputTitle'*/: break;
					case 'combohide' /*case 'ComboHide'*/: break;
					case 'inputhide' /*case 'InputHide'*/: break;
					case 'condition' /*case 'Condition'*/: break;
					case 'qualifier' /*case 'Qualifier'*/: break;
					case 'useblank' /*case 'UseBlank'*/: break;
					case 'value1' /*case 'Value1'*/: break;
					case 'value2' /*case 'Value2'*/: break;
					case 'format' /*case 'Format'*/: break;
					default: seen = false;
				} break;

				/* MapInfo (schema) */
				case 'mapinfo' /*case 'MapInfo'*/: case 'schema' /*case 'Schema'*/: case 'data' /*case 'data'*/: switch(Rn[3]) {
					case 'map' /*case 'Map'*/: break;
					case 'entry' /*case 'Entry'*/: break;
					case 'range' /*case 'Range'*/: break;
					case 'xpath' /*case 'XPath'*/: break;
					case 'field' /*case 'Field'*/: break;
					case 'xsdtype' /*case 'XSDType'*/: break;
					case 'filteron' /*case 'FilterOn'*/: break;
					case 'aggregate' /*case 'Aggregate'*/: break;
					case 'elementtype' /*case 'ElementType'*/: break;
					case 'attributetype' /*case 'AttributeType'*/: break;
				/* These are from xsd (XML Schema Definition) */
					case 'schema' /*case 'schema'*/:
					case 'element' /*case 'element'*/:
					case 'complextype' /*case 'complexType'*/:
					case 'datatype' /*case 'datatype'*/:
					case 'all' /*case 'all'*/:
					case 'attribute' /*case 'attribute'*/:
					case 'extends' /*case 'extends'*/: break;

					case 'row' /*case 'row'*/: break;
					default: seen = false;
				} break;

				/* SmartTags (can be anything) */
				case 'smarttags' /*case 'SmartTags'*/: break;

				default: seen = false; break;
			}
			if(seen) break;
			/* CustomDocumentProperties */
			if(Rn[3].match(/!\[CDATA/)) break;
			if(!state[state.length-1][1]) throw 'Unrecognized tag: ' + Rn[3] + "|" + state.join("|");
			if(state[state.length-1][0]===/*'CustomDocumentProperties'*/'customdocumentproperties') {
				if(Rn[0].slice(-2) === "/>") break;
				else if(Rn[1]==="/") xlml_set_custprop(Custprops, raw_Rn3, cp, str.slice(pidx, Rn.index));
				else { cp = Rn; pidx = Rn.index + Rn[0].length; }
				break;
			}
			if(opts.WTF) throw 'Unrecognized tag: ' + Rn[3] + "|" + state.join("|");
	}
	var out = ({}/*:any*/);
	if(!opts.bookSheets && !opts.bookProps) out.Sheets = sheets;
	out.SheetNames = sheetnames;
	out.Workbook = Workbook;
	out.SSF = dup(table_fmt);
	out.Props = Props;
	out.Custprops = Custprops;
	return out;
}

function parse_xlml(data/*:RawBytes|string*/, opts)/*:Workbook*/ {
	fix_read_opts(opts=opts||{});
	switch(opts.type||"base64") {
		case "base64": return parse_xlml_xml(Base64_decode(data), opts);
		case "binary": case "buffer": case "file": return parse_xlml_xml(data, opts);
		case "array": return parse_xlml_xml(a2s(data), opts);
	}
	/*:: throw new Error("unsupported type " + opts.type); */
}

/* TODO */
function write_props_xlml(wb/*:Workbook*/, opts)/*:string*/ {
	var o/*:Array<string>*/ = [];
	/* DocumentProperties */
	if(wb.Props) o.push(xlml_write_docprops(wb.Props, opts));
	/* CustomDocumentProperties */
	if(wb.Custprops) o.push(xlml_write_custprops(wb.Props, wb.Custprops, opts));
	return o.join("");
}
/* TODO */
function write_wb_xlml(/*::wb, opts*/)/*:string*/ {
	/* OfficeDocumentSettings */
	/* ExcelWorkbook */
	return "";
}
/* TODO */
function write_sty_xlml(wb, opts)/*:string*/ {
	/* Styles */
	var styles/*:Array<string>*/ = ['<Style ss:ID="Default" ss:Name="Normal"><NumberFormat/></Style>'];
	opts.cellXfs.forEach(function(xf, id) {
		var payload/*:Array<string>*/ = [];
		payload.push(writextag('NumberFormat', null, {"ss:Format": escapexml(table_fmt[xf.numFmtId])}));

		var o = /*::(*/{"ss:ID": "s" + (21+id)}/*:: :any)*/;
		styles.push(writextag('Style', payload.join(""), o));
	});
	return writextag("Styles", styles.join(""));
}
function write_name_xlml(n) { return writextag("NamedRange", null, {"ss:Name": n.Name, "ss:RefersTo":"=" + a1_to_rc(n.Ref, {r:0,c:0})}); }
function write_names_xlml(wb/*::, opts*/)/*:string*/ {
	if(!((wb||{}).Workbook||{}).Names) return "";
	/*:: if(!wb || !wb.Workbook || !wb.Workbook.Names) throw new Error("unreachable"); */
	var names/*:Array<any>*/ = wb.Workbook.Names;
	var out/*:Array<string>*/ = [];
	for(var i = 0; i < names.length; ++i) {
		var n = names[i];
		if(n.Sheet != null) continue;
		if(n.Name.match(/^_xlfn\./)) continue;
		out.push(write_name_xlml(n));
	}
	return writextag("Names", out.join(""));
}
function write_ws_xlml_names(ws/*:Worksheet*/, opts, idx/*:number*/, wb/*:Workbook*/)/*:string*/ {
	if(!ws) return "";
	if(!((wb||{}).Workbook||{}).Names) return "";
	/*:: if(!wb || !wb.Workbook || !wb.Workbook.Names) throw new Error("unreachable"); */
	var names/*:Array<any>*/ = wb.Workbook.Names;
	var out/*:Array<string>*/ = [];
	for(var i = 0; i < names.length; ++i) {
		var n = names[i];
		if(n.Sheet != idx) continue;
		/*switch(n.Name) {
			case "_": continue;
		}*/
		if(n.Name.match(/^_xlfn\./)) continue;
		out.push(write_name_xlml(n));
	}
	return out.join("");
}
/* WorksheetOptions */
function write_ws_xlml_wsopts(ws/*:Worksheet*/, opts, idx/*:number*/, wb/*:Workbook*/)/*:string*/ {
	if(!ws) return "";
	var o/*:Array<string>*/ = [];
	/* NOTE: spec technically allows any order, but stick with implied order */

	/* FitToPage */
	/* DoNotDisplayColHeaders */
	/* DoNotDisplayRowHeaders */
	/* ViewableRange */
	/* Selection */
	/* GridlineColor */
	/* Name */
	/* ExcelWorksheetType */
	/* IntlMacro */
	/* Unsynced */
	/* Selected */
	/* CodeName */

	if(ws['!margins']) {
		o.push("<PageSetup>");
		if(ws['!margins'].header) o.push(writextag("Header", null, {'x:Margin':ws['!margins'].header}));
		if(ws['!margins'].footer) o.push(writextag("Footer", null, {'x:Margin':ws['!margins'].footer}));
		o.push(writextag("PageMargins", null, {
			'x:Bottom': ws['!margins'].bottom || "0.75",
			'x:Left': ws['!margins'].left || "0.7",
			'x:Right': ws['!margins'].right || "0.7",
			'x:Top': ws['!margins'].top || "0.75"
		}));
		o.push("</PageSetup>");
	}

	/* PageSetup */
	/* DisplayPageBreak */
	/* TransitionExpressionEvaluation */
	/* TransitionFormulaEntry */
	/* Print */
	/* Zoom */
	/* PageLayoutZoom */
	/* PageBreakZoom */
	/* ShowPageBreakZoom */
	/* DefaultRowHeight */
	/* DefaultColumnWidth */
	/* StandardWidth */

	if(wb && wb.Workbook && wb.Workbook.Sheets && wb.Workbook.Sheets[idx]) {
		/* Visible */
		if(wb.Workbook.Sheets[idx].Hidden) o.push(writextag("Visible", (wb.Workbook.Sheets[idx].Hidden == 1 ? "SheetHidden" : "SheetVeryHidden"), {}));
		else {
			/* Selected */
			for(var i = 0; i < idx; ++i) if(wb.Workbook.Sheets[i] && !wb.Workbook.Sheets[i].Hidden) break;
			if(i == idx) o.push("<Selected/>");
		}
	}

	/* LeftColumnVisible */

	if(((((wb||{}).Workbook||{}).Views||[])[0]||{}).RTL) o.push("<DisplayRightToLeft/>");

	/* GridlineColorIndex */
	/* DisplayFormulas */
	/* DoNotDisplayGridlines */
	/* DoNotDisplayHeadings */
	/* DoNotDisplayOutline */
	/* ApplyAutomaticOutlineStyles */
	/* NoSummaryRowsBelowDetail */
	/* NoSummaryColumnsRightDetail */
	/* DoNotDisplayZeros */
	/* ActiveRow */
	/* ActiveColumn */
	/* FilterOn */
	/* RangeSelection */
	/* TopRowVisible */
	/* TopRowBottomPane */
	/* LeftColumnRightPane */
	/* ActivePane */
	/* SplitHorizontal */
	/* SplitVertical */
	/* FreezePanes */
	/* FrozenNoSplit */
	/* TabColorIndex */
	/* Panes */

	/* NOTE: Password not supported in XLML Format */
	if(ws['!protect']) {
		o.push(writetag("ProtectContents", "True"));
		if(ws['!protect'].objects) o.push(writetag("ProtectObjects", "True"));
		if(ws['!protect'].scenarios) o.push(writetag("ProtectScenarios", "True"));
		if(ws['!protect'].selectLockedCells != null && !ws['!protect'].selectLockedCells) o.push(writetag("EnableSelection", "NoSelection"));
		else if(ws['!protect'].selectUnlockedCells != null && !ws['!protect'].selectUnlockedCells) o.push(writetag("EnableSelection", "UnlockedCells"));
	[
		[ "formatCells", "AllowFormatCells" ],
		[ "formatColumns", "AllowSizeCols" ],
		[ "formatRows", "AllowSizeRows" ],
		[ "insertColumns", "AllowInsertCols" ],
		[ "insertRows", "AllowInsertRows" ],
		[ "insertHyperlinks", "AllowInsertHyperlinks" ],
		[ "deleteColumns", "AllowDeleteCols" ],
		[ "deleteRows", "AllowDeleteRows" ],
		[ "sort", "AllowSort" ],
		[ "autoFilter", "AllowFilter" ],
		[ "pivotTables", "AllowUsePivotTables" ]
	].forEach(function(x) { if(ws['!protect'][x[0]]) o.push("<"+x[1]+"/>"); });
	}

	if(o.length == 0) return "";
	return writextag("WorksheetOptions", o.join(""), {xmlns:XLMLNS.x});
}
function write_ws_xlml_comment(comments/*:Array<any>*/)/*:string*/ {
	return comments.map(function(c) {
		// TODO: formatted text
		var t = xlml_unfixstr(c.t||"");
		var d =writextag("ss:Data", t, {"xmlns":"http://www.w3.org/TR/REC-html40"});
		return writextag("Comment", d, {"ss:Author":c.a});
	}).join("");
}
function write_ws_xlml_cell(cell, ref/*:string*/, ws, opts, idx/*:number*/, wb, addr)/*:string*/{
	if(!cell || (cell.v == undefined && cell.f == undefined)) return "";

	var attr = {};
	if(cell.f) attr["ss:Formula"] = "=" + escapexml(a1_to_rc(cell.f, addr));
	if(cell.F && cell.F.slice(0, ref.length) == ref) {
		var end = decode_cell(cell.F.slice(ref.length + 1));
		attr["ss:ArrayRange"] = "RC:R" + (end.r == addr.r ? "" : "[" + (end.r - addr.r) + "]") + "C" + (end.c == addr.c ? "" : "[" + (end.c - addr.c) + "]");
	}

	if(cell.l && cell.l.Target) {
		attr["ss:HRef"] = escapexml(cell.l.Target);
		if(cell.l.Tooltip) attr["x:HRefScreenTip"] = escapexml(cell.l.Tooltip);
	}

	if(ws['!merges']) {
		var marr = ws['!merges'];
		for(var mi = 0; mi != marr.length; ++mi) {
			if(marr[mi].s.c != addr.c || marr[mi].s.r != addr.r) continue;
			if(marr[mi].e.c > marr[mi].s.c) attr['ss:MergeAcross'] = marr[mi].e.c - marr[mi].s.c;
			if(marr[mi].e.r > marr[mi].s.r) attr['ss:MergeDown'] = marr[mi].e.r - marr[mi].s.r;
		}
	}

	var t = "", p = "";
	switch(cell.t) {
		case 'z': if(!opts.sheetStubs) return ""; break;
		case 'n': t = 'Number'; p = String(cell.v); break;
		case 'b': t = 'Boolean'; p = (cell.v ? "1" : "0"); break;
		case 'e': t = 'Error'; p = BErr[cell.v]; break;
		case 'd': t = 'DateTime'; p = new Date(cell.v).toISOString(); if(cell.z == null) cell.z = cell.z || table_fmt[14]; break;
		case 's': t = 'String'; p = escapexlml(cell.v||""); break;
	}
	/* TODO: cell style */
	var os = get_cell_style(opts.cellXfs, cell, opts);
	attr["ss:StyleID"] = "s" + (21+os);
	attr["ss:Index"] = addr.c + 1;
	var _v = (cell.v != null ? p : "");
	var m = cell.t == 'z' ? "" : ('<Data ss:Type="' + t + '">' + _v + '</Data>');

	if((cell.c||[]).length > 0) m += write_ws_xlml_comment(cell.c);

	return writextag("Cell", m, attr);
}
function write_ws_xlml_row(R/*:number*/, row)/*:string*/ {
	var o = '<Row ss:Index="' + (R+1) + '"';
	if(row) {
		if(row.hpt && !row.hpx) row.hpx = pt2px(row.hpt);
		if(row.hpx) o += ' ss:AutoFitHeight="0" ss:Height="' + row.hpx + '"';
		if(row.hidden) o += ' ss:Hidden="1"';
	}
	return o + '>';
}
/* TODO */
function write_ws_xlml_table(ws/*:Worksheet*/, opts, idx/*:number*/, wb/*:Workbook*/)/*:string*/ {
	if(!ws['!ref']) return "";
	var range/*:Range*/ = safe_decode_range(ws['!ref']);
	var marr/*:Array<Range>*/ = ws['!merges'] || [], mi = 0;
	var o/*:Array<string>*/ = [];
	if(ws['!cols']) ws['!cols'].forEach(function(n, i) {
		process_col(n);
		var w = !!n.width;
		var p = col_obj_w(i, n);
		var k/*:any*/ = {"ss:Index":i+1};
		if(w) k['ss:Width'] = width2px(p.width);
		if(n.hidden) k['ss:Hidden']="1";
		o.push(writextag("Column",null,k));
	});
	var dense = Array.isArray(ws);
	for(var R = range.s.r; R <= range.e.r; ++R) {
		var row = [write_ws_xlml_row(R, (ws['!rows']||[])[R])];
		for(var C = range.s.c; C <= range.e.c; ++C) {
			var skip = false;
			for(mi = 0; mi != marr.length; ++mi) {
				if(marr[mi].s.c > C) continue;
				if(marr[mi].s.r > R) continue;
				if(marr[mi].e.c < C) continue;
				if(marr[mi].e.r < R) continue;
				if(marr[mi].s.c != C || marr[mi].s.r != R) skip = true;
				break;
			}
			if(skip) continue;
			var addr = {r:R,c:C};
			var ref = encode_cell(addr), cell = dense ? (ws[R]||[])[C] : ws[ref];
			row.push(write_ws_xlml_cell(cell, ref, ws, opts, idx, wb, addr));
		}
		row.push("</Row>");
		if(row.length > 2) o.push(row.join(""));
	}
	return o.join("");
}
function write_ws_xlml(idx/*:number*/, opts, wb/*:Workbook*/)/*:string*/ {
	var o/*:Array<string>*/ = [];
	var s = wb.SheetNames[idx];
	var ws = wb.Sheets[s];

	var t/*:string*/ = ws ? write_ws_xlml_names(ws, opts, idx, wb) : "";
	if(t.length > 0) o.push("<Names>" + t + "</Names>");

	/* Table */
	t = ws ? write_ws_xlml_table(ws, opts, idx, wb) : "";
	if(t.length > 0) o.push("<Table>" + t + "</Table>");

	/* WorksheetOptions */
	o.push(write_ws_xlml_wsopts(ws, opts, idx, wb));

	return o.join("");
}
function write_xlml(wb, opts)/*:string*/ {
	if(!opts) opts = {};
	if(!wb.SSF) wb.SSF = dup(table_fmt);
	if(wb.SSF) {
		make_ssf(); SSF_load_table(wb.SSF);
		// $FlowIgnore
		opts.revssf = evert_num(wb.SSF); opts.revssf[wb.SSF[65535]] = 0;
		opts.ssf = wb.SSF;
		opts.cellXfs = [];
		get_cell_style(opts.cellXfs, {}, {revssf:{"General":0}});
	}
	var d/*:Array<string>*/ = [];
	d.push(write_props_xlml(wb, opts));
	d.push(write_wb_xlml(wb, opts));
	d.push("");
	d.push("");
	for(var i = 0; i < wb.SheetNames.length; ++i)
		d.push(writextag("Worksheet", write_ws_xlml(i, opts, wb), {"ss:Name":escapexml(wb.SheetNames[i])}));
	d[2] = write_sty_xlml(wb, opts);
	d[3] = write_names_xlml(wb, opts);
	return XML_HEADER + writextag("Workbook", d.join(""), {
		'xmlns':      XLMLNS.ss,
		'xmlns:o':    XLMLNS.o,
		'xmlns:x':    XLMLNS.x,
		'xmlns:ss':   XLMLNS.ss,
		'xmlns:dt':   XLMLNS.dt,
		'xmlns:html': XLMLNS.html
	});
}
/* [MS-OLEDS] 2.3.8 CompObjStream */
function parse_compobj(obj/*:CFBEntry*/) {
	var v = {};
	var o = obj.content;
	/*:: if(o == null) return; */

	/* [MS-OLEDS] 2.3.7 CompObjHeader -- All fields MUST be ignored */
	o.l = 28;

	v.AnsiUserType = o.read_shift(0, "lpstr-ansi");
	v.AnsiClipboardFormat = parse_ClipboardFormatOrAnsiString(o);

	if(o.length - o.l <= 4) return v;

	var m/*:number*/ = o.read_shift(4);
	if(m == 0 || m > 40) return v;
	o.l-=4; v.Reserved1 = o.read_shift(0, "lpstr-ansi");

	if(o.length - o.l <= 4) return v;
	m = o.read_shift(4);
	if(m !== 0x71b239f4) return v;
	v.UnicodeClipboardFormat = parse_ClipboardFormatOrUnicodeString(o);

	m = o.read_shift(4);
	if(m == 0 || m > 40) return v;
	o.l-=4; v.Reserved2 = o.read_shift(0, "lpwstr");
}

/*
	Continue logic for:
	- 2.4.58 Continue          0x003c
	- 2.4.59 ContinueBigName   0x043c
	- 2.4.60 ContinueFrt       0x0812
	- 2.4.61 ContinueFrt11     0x0875
	- 2.4.62 ContinueFrt12     0x087f
*/
var CONTINUE_RT = (/* unused pure expression or super */ null && ([ 0x003c, 0x043c, 0x0812, 0x0875, 0x087f ]));
function slurp(RecordType, R, blob, length/*:number*/, opts)/*:any*/ {
	var l = length;
	var bufs = [];
	var d = blob.slice(blob.l,blob.l+l);
	if(opts && opts.enc && opts.enc.insitu && d.length > 0) switch(RecordType) {
	case 0x0009: case 0x0209: case 0x0409: case 0x0809/* BOF */: case 0x002f /* FilePass */: case 0x0195 /* FileLock */: case 0x00e1 /* InterfaceHdr */: case 0x0196 /* RRDInfo */: case 0x0138 /* RRDHead */: case 0x0194 /* UsrExcl */: case 0x000a /* EOF */:
		break;
	case 0x0085 /* BoundSheet8 */:
		break;
	default:
		opts.enc.insitu(d);
	}
	bufs.push(d);
	blob.l += l;
	var nextrt = __readUInt16LE(blob,blob.l), next = XLSRecordEnum[nextrt];
	var start = 0;
	while(next != null && CONTINUE_RT.indexOf(nextrt) > -1) {
		l = __readUInt16LE(blob,blob.l+2);
		start = blob.l + 4;
		if(nextrt == 0x0812 /* ContinueFrt */) start += 4;
		else if(nextrt == 0x0875 || nextrt == 0x087f) {
			start += 12;
		}
		d = blob.slice(start,blob.l+4+l);
		bufs.push(d);
		blob.l += 4+l;
		next = (XLSRecordEnum[nextrt = __readUInt16LE(blob, blob.l)]);
	}
	var b = (bconcat(bufs)/*:any*/);
	prep_blob(b, 0);
	var ll = 0; b.lens = [];
	for(var j = 0; j < bufs.length; ++j) { b.lens.push(ll); ll += bufs[j].length; }
	if(b.length < length) throw "XLS Record 0x" + RecordType.toString(16) + " Truncated: " + b.length + " < " + length;
	return R.f(b, b.length, opts);
}

function safe_format_xf(p/*:any*/, opts/*:ParseOpts*/, date1904/*:?boolean*/) {
	if(p.t === 'z') return;
	if(!p.XF) return;
	var fmtid = 0;
	try {
		fmtid = p.z || p.XF.numFmtId || 0;
		if(opts.cellNF) p.z = table_fmt[fmtid];
	} catch(e) { if(opts.WTF) throw e; }
	if(!opts || opts.cellText !== false) try {
		if(p.t === 'e') { p.w = p.w || BErr[p.v]; }
		else if(fmtid === 0 || fmtid == "General") {
			if(p.t === 'n') {
				if((p.v|0) === p.v) p.w = p.v.toString(10);
				else p.w = SSF_general_num(p.v);
			}
			else p.w = SSF_general(p.v);
		}
		else p.w = SSF_format(fmtid,p.v, {date1904:!!date1904, dateNF: opts && opts.dateNF});
	} catch(e) { if(opts.WTF) throw e; }
	if(opts.cellDates && fmtid && p.t == 'n' && fmt_is_date(table_fmt[fmtid] || String(fmtid))) {
		var _d = SSF_parse_date_code(p.v); if(_d) { p.t = 'd'; p.v = new Date(_d.y, _d.m-1,_d.d,_d.H,_d.M,_d.S,_d.u); }
	}
}

function make_cell(val, ixfe, t)/*:Cell*/ {
	return ({v:val, ixfe:ixfe, t:t}/*:any*/);
}

// 2.3.2
function parse_workbook(blob, options/*:ParseOpts*/)/*:Workbook*/ {
	var wb = ({opts:{}}/*:any*/);
	var Sheets = {};
	if(DENSE != null && options.dense == null) options.dense = DENSE;
	var out/*:Worksheet*/ = ((options.dense ? [] : {})/*:any*/);
	var Directory = {};
	var range/*:Range*/ = ({}/*:any*/);
	var last_formula = null;
	var sst/*:SST*/ = ([]/*:any*/);
	var cur_sheet = "";
	var Preamble = {};
	var lastcell, last_cell = "", cc/*:Cell*/, cmnt, rngC, rngR;
	var sharedf = {};
	var arrayf/*:Array<[Range, string]>*/ = [];
	var temp_val/*:Cell*/;
	var country;
	var XFs = []; /* XF records */
	var palette/*:Array<[number, number, number]>*/ = [];
	var Workbook/*:WBWBProps*/ = ({ Sheets:[], WBProps:{date1904:false}, Views:[{}] }/*:any*/), wsprops = {};
	var get_rgb = function getrgb(icv/*:number*/)/*:[number, number, number]*/ {
		if(icv < 8) return XLSIcv[icv];
		if(icv < 64) return palette[icv-8] || XLSIcv[icv];
		return XLSIcv[icv];
	};
	var process_cell_style = function pcs(cell, line/*:any*/, options) {
		var xfd = line.XF.data;
		if(!xfd || !xfd.patternType || !options || !options.cellStyles) return;
		line.s = ({}/*:any*/);
		line.s.patternType = xfd.patternType;
		var t;
		if((t = rgb2Hex(get_rgb(xfd.icvFore)))) { line.s.fgColor = {rgb:t}; }
		if((t = rgb2Hex(get_rgb(xfd.icvBack)))) { line.s.bgColor = {rgb:t}; }
	};
	var addcell = function addcell(cell/*:any*/, line/*:any*/, options/*:any*/) {
		if(file_depth > 1) return;
		if(options.sheetRows && cell.r >= options.sheetRows) return;
		if(options.cellStyles && line.XF && line.XF.data) process_cell_style(cell, line, options);
		delete line.ixfe; delete line.XF;
		lastcell = cell;
		last_cell = encode_cell(cell);
		if(!range || !range.s || !range.e) range = {s:{r:0,c:0},e:{r:0,c:0}};
		if(cell.r < range.s.r) range.s.r = cell.r;
		if(cell.c < range.s.c) range.s.c = cell.c;
		if(cell.r + 1 > range.e.r) range.e.r = cell.r + 1;
		if(cell.c + 1 > range.e.c) range.e.c = cell.c + 1;
		if(options.cellFormula && line.f) {
			for(var afi = 0; afi < arrayf.length; ++afi) {
				if(arrayf[afi][0].s.c > cell.c || arrayf[afi][0].s.r > cell.r) continue;
				if(arrayf[afi][0].e.c < cell.c || arrayf[afi][0].e.r < cell.r) continue;
				line.F = encode_range(arrayf[afi][0]);
				if(arrayf[afi][0].s.c != cell.c || arrayf[afi][0].s.r != cell.r) delete line.f;
				if(line.f) line.f = "" + stringify_formula(arrayf[afi][1], range, cell, supbooks, opts);
				break;
			}
		}
		{
			if(options.dense) {
				if(!out[cell.r]) out[cell.r] = [];
				out[cell.r][cell.c] = line;
			} else out[last_cell] = line;
		}
	};
	var opts = ({
		enc: false, // encrypted
		sbcch: 0, // cch in the preceding SupBook
		snames: [], // sheetnames
		sharedf: sharedf, // shared formulae by address
		arrayf: arrayf, // array formulae array
		rrtabid: [], // RRTabId
		lastuser: "", // Last User from WriteAccess
		biff: 8, // BIFF version
		codepage: 0, // CP from CodePage record
		winlocked: 0, // fLockWn from WinProtect
		cellStyles: !!options && !!options.cellStyles,
		WTF: !!options && !!options.wtf
	}/*:any*/);
	if(options.password) opts.password = options.password;
	var themes;
	var merges/*:Array<Range>*/ = [];
	var objects = [];
	var colinfo/*:Array<ColInfo>*/ = [], rowinfo/*:Array<RowInfo>*/ = [];
	var seencol = false;
	var supbooks = ([]/*:any*/); // 1-indexed, will hold extern names
	supbooks.SheetNames = opts.snames;
	supbooks.sharedf = opts.sharedf;
	supbooks.arrayf = opts.arrayf;
	supbooks.names = [];
	supbooks.XTI = [];
	var last_RT = 0;
	var file_depth = 0; /* TODO: make a real stack */
	var BIFF2Fmt = 0, BIFF2FmtTable/*:Array<string>*/ = [];
	var FilterDatabases = []; /* TODO: sort out supbooks and process elsewhere */
	var last_lbl/*:?DefinedName*/;

	/* explicit override for some broken writers */
	opts.codepage = 1200;
	set_cp(1200);
	var seen_codepage = false;
	while(blob.l < blob.length - 1) {
		var s = blob.l;
		var RecordType = blob.read_shift(2);
		if(RecordType === 0 && last_RT === 0x000a /* EOF */) break;
		var length = (blob.l === blob.length ? 0 : blob.read_shift(2));
		var R = XLSRecordEnum[RecordType];
		//console.log(RecordType.toString(16), RecordType, R, blob.l, length, blob.length);
		//if(!R) console.log(blob.slice(blob.l, blob.l + length));
		if(R && R.f) {
			if(options.bookSheets) {
				if(last_RT === 0x0085 /* BoundSheet8 */ && RecordType !== 0x0085 /* R.n !== 'BoundSheet8' */) break;
			}
			last_RT = RecordType;
			if(R.r === 2 || R.r == 12) {
				var rt = blob.read_shift(2); length -= 2;
				if(!opts.enc && rt !== RecordType && (((rt&0xFF)<<8)|(rt>>8)) !== RecordType) throw new Error("rt mismatch: " + rt + "!=" + RecordType);
				if(R.r == 12){
					blob.l += 10; length -= 10;
				} // skip FRT
			}
			//console.error(R,blob.l,length,blob.length);
			var val/*:any*/ = ({}/*:any*/);
			if(RecordType === 0x000a /* EOF */) val = /*::(*/R.f(blob, length, opts)/*:: :any)*/;
			else val = /*::(*/slurp(RecordType, R, blob, length, opts)/*:: :any)*/;
			/*:: val = (val:any); */
			if(file_depth == 0 && [0x0009, 0x0209, 0x0409, 0x0809].indexOf(last_RT) === -1 /* 'BOF' */) continue;
			switch(RecordType) {
				case 0x0022 /* Date1904 */:
					/*:: if(!Workbook.WBProps) Workbook.WBProps = {}; */
					wb.opts.Date1904 = Workbook.WBProps.date1904 = val; break;
				case 0x0086 /* WriteProtect */: wb.opts.WriteProtect = true; break;
				case 0x002f /* FilePass */:
					if(!opts.enc) blob.l = 0;
					opts.enc = val;
					if(!options.password) throw new Error("File is password-protected");
					if(val.valid == null) throw new Error("Encryption scheme unsupported");
					if(!val.valid) throw new Error("Password is incorrect");
					break;
				case 0x005c /* WriteAccess */: opts.lastuser = val; break;
				case 0x0042 /* CodePage */:
					var cpval = Number(val);
					/* overrides based on test cases */
					switch(cpval) {
						case 0x5212: cpval =  1200; break;
						case 0x8000: cpval = 10000; break;
						case 0x8001: cpval =  1252; break;
					}
					set_cp(opts.codepage = cpval);
					seen_codepage = true;
					break;
				case 0x013d /* RRTabId */: opts.rrtabid = val; break;
				case 0x0019 /* WinProtect */: opts.winlocked = val; break;
				case 0x01b7 /* RefreshAll */: wb.opts["RefreshAll"] = val; break;
				case 0x000c /* CalcCount */: wb.opts["CalcCount"] = val; break;
				case 0x0010 /* CalcDelta */: wb.opts["CalcDelta"] = val; break;
				case 0x0011 /* CalcIter */: wb.opts["CalcIter"] = val; break;
				case 0x000d /* CalcMode */: wb.opts["CalcMode"] = val; break;
				case 0x000e /* CalcPrecision */: wb.opts["CalcPrecision"] = val; break;
				case 0x005f /* CalcSaveRecalc */: wb.opts["CalcSaveRecalc"] = val; break;
				case 0x000f /* CalcRefMode */: opts.CalcRefMode = val; break; // TODO: implement R1C1
				case 0x08a3 /* ForceFullCalculation */: wb.opts.FullCalc = val; break;
				case 0x0081 /* WsBool */:
					if(val.fDialog) out["!type"] = "dialog";
					if(!val.fBelow) (out["!outline"] || (out["!outline"] = {})).above = true;
					if(!val.fRight) (out["!outline"] || (out["!outline"] = {})).left = true;
					break; // TODO
				case 0x00e0 /* XF */:
					XFs.push(val); break;
				case 0x01ae /* SupBook */:
					supbooks.push([val]);
					supbooks[supbooks.length-1].XTI = [];
					break;
				case 0x0023: case 0x0223 /* ExternName */:
					supbooks[supbooks.length-1].push(val);
					break;
				case 0x0018: case 0x0218 /* Lbl */:
					last_lbl = ({
						Name: val.Name,
						Ref: stringify_formula(val.rgce,range,null,supbooks,opts)
					}/*:DefinedName*/);
					if(val.itab > 0) last_lbl.Sheet = val.itab - 1;
					supbooks.names.push(last_lbl);
					if(!supbooks[0]) { supbooks[0] = []; supbooks[0].XTI = []; }
					supbooks[supbooks.length-1].push(val);
					if(val.Name == "_xlnm._FilterDatabase" && val.itab > 0)
						if(val.rgce && val.rgce[0] && val.rgce[0][0] && val.rgce[0][0][0] == 'PtgArea3d')
							FilterDatabases[val.itab - 1] = { ref: encode_range(val.rgce[0][0][1][2]) };
					break;
				case 0x0016 /* ExternCount */: opts.ExternCount = val; break;
				case 0x0017 /* ExternSheet */:
					if(supbooks.length == 0) { supbooks[0] = []; supbooks[0].XTI = []; }
					supbooks[supbooks.length - 1].XTI = supbooks[supbooks.length - 1].XTI.concat(val); supbooks.XTI = supbooks.XTI.concat(val); break;
				case 0x0894 /* NameCmt */:
					/* TODO: search for correct name */
					if(opts.biff < 8) break;
					if(last_lbl != null) last_lbl.Comment = val[1];
					break;
				case 0x0012 /* Protect */: out["!protect"] = val; break; /* for sheet or book */
				case 0x0013 /* Password */: if(val !== 0 && opts.WTF) console.error("Password verifier: " + val); break;
				case 0x0085 /* BoundSheet8 */: {
					Directory[val.pos] = val;
					opts.snames.push(val.name);
				} break;
				case 0x000a /* EOF */: {
					if(--file_depth) break;
					if(range.e) {
						if(range.e.r > 0 && range.e.c > 0) {
							range.e.r--; range.e.c--;
							out["!ref"] = encode_range(range);
							if(options.sheetRows && options.sheetRows <= range.e.r) {
								var tmpri = range.e.r;
								range.e.r = options.sheetRows - 1;
								out["!fullref"] = out["!ref"];
								out["!ref"] = encode_range(range);
								range.e.r = tmpri;
							}
							range.e.r++; range.e.c++;
						}
						if(merges.length > 0) out["!merges"] = merges;
						if(objects.length > 0) out["!objects"] = objects;
						if(colinfo.length > 0) out["!cols"] = colinfo;
						if(rowinfo.length > 0) out["!rows"] = rowinfo;
						Workbook.Sheets.push(wsprops);
					}
					if(cur_sheet === "") Preamble = out; else Sheets[cur_sheet] = out;
					out = ((options.dense ? [] : {})/*:any*/);
				} break;
				case 0x0009: case 0x0209: case 0x0409: case 0x0809 /* BOF */: {
					if(opts.biff === 8) opts.biff = {
						/*::[*/0x0009/*::]*/:2,
						/*::[*/0x0209/*::]*/:3,
						/*::[*/0x0409/*::]*/:4
					}[RecordType] || {
						/*::[*/0x0200/*::]*/:2,
						/*::[*/0x0300/*::]*/:3,
						/*::[*/0x0400/*::]*/:4,
						/*::[*/0x0500/*::]*/:5,
						/*::[*/0x0600/*::]*/:8,
						/*::[*/0x0002/*::]*/:2,
						/*::[*/0x0007/*::]*/:2
					}[val.BIFFVer] || 8;
					opts.biffguess = val.BIFFVer == 0;
					if(val.BIFFVer == 0 && val.dt == 0x1000) { opts.biff = 5; seen_codepage = true; set_cp(opts.codepage = 28591); }
					if(opts.biff == 8 && val.BIFFVer == 0 && val.dt == 16) opts.biff = 2;
					if(file_depth++) break;
					out = ((options.dense ? [] : {})/*:any*/);

					if(opts.biff < 8 && !seen_codepage) { seen_codepage = true; set_cp(opts.codepage = options.codepage || 1252); }

					if(opts.biff < 5 || val.BIFFVer == 0 && val.dt == 0x1000) {
						if(cur_sheet === "") cur_sheet = "Sheet1";
						range = {s:{r:0,c:0},e:{r:0,c:0}};
						/* fake BoundSheet8 */
						var fakebs8 = {pos: blob.l - length, name:cur_sheet};
						Directory[fakebs8.pos] = fakebs8;
						opts.snames.push(cur_sheet);
					}
					else cur_sheet = (Directory[s] || {name:""}).name;
					if(val.dt == 0x20) out["!type"] = "chart";
					if(val.dt == 0x40) out["!type"] = "macro";
					merges = [];
					objects = [];
					opts.arrayf = arrayf = [];
					colinfo = []; rowinfo = [];
					seencol = false;
					wsprops = {Hidden:(Directory[s]||{hs:0}).hs, name:cur_sheet };
				} break;
				case 0x0203 /* Number */: case 0x0003 /* BIFF2NUM */: case 0x0002 /* BIFF2INT */: {
					if(out["!type"] == "chart") if(options.dense ? (out[val.r]||[])[val.c]: out[encode_cell({c:val.c, r:val.r})]) ++val.c;
					temp_val = ({ixfe: val.ixfe, XF: XFs[val.ixfe]||{}, v:val.val, t:'n'}/*:any*/);
					if(BIFF2Fmt > 0) temp_val.z = BIFF2FmtTable[(temp_val.ixfe>>8) & 0x3F];
					safe_format_xf(temp_val, options, wb.opts.Date1904);
					addcell({c:val.c, r:val.r}, temp_val, options);
				} break;
				case 0x0005: case 0x0205 /* BoolErr */: {
					temp_val = ({ixfe: val.ixfe, XF: XFs[val.ixfe], v:val.val, t:val.t}/*:any*/);
					if(BIFF2Fmt > 0) temp_val.z = BIFF2FmtTable[(temp_val.ixfe>>8) & 0x3F];
					safe_format_xf(temp_val, options, wb.opts.Date1904);
					addcell({c:val.c, r:val.r}, temp_val, options);
				} break;
				case 0x027e /* RK */: {
					temp_val = ({ixfe: val.ixfe, XF: XFs[val.ixfe], v:val.rknum, t:'n'}/*:any*/);
					if(BIFF2Fmt > 0) temp_val.z = BIFF2FmtTable[(temp_val.ixfe>>8) & 0x3F];
					safe_format_xf(temp_val, options, wb.opts.Date1904);
					addcell({c:val.c, r:val.r}, temp_val, options);
				} break;
				case 0x00bd /* MulRk */: {
					for(var j = val.c; j <= val.C; ++j) {
						var ixfe = val.rkrec[j-val.c][0];
						temp_val= ({ixfe:ixfe, XF:XFs[ixfe], v:val.rkrec[j-val.c][1], t:'n'}/*:any*/);
						if(BIFF2Fmt > 0) temp_val.z = BIFF2FmtTable[(temp_val.ixfe>>8) & 0x3F];
						safe_format_xf(temp_val, options, wb.opts.Date1904);
						addcell({c:j, r:val.r}, temp_val, options);
					}
				} break;
				case 0x0006: case 0x0206: case 0x0406 /* Formula */: {
					if(val.val == 'String') { last_formula = val; break; }
					temp_val = make_cell(val.val, val.cell.ixfe, val.tt);
					temp_val.XF = XFs[temp_val.ixfe];
					if(options.cellFormula) {
						var _f = val.formula;
						if(_f && _f[0] && _f[0][0] && _f[0][0][0] == 'PtgExp') {
							var _fr = _f[0][0][1][0], _fc = _f[0][0][1][1];
							var _fe = encode_cell({r:_fr, c:_fc});
							if(sharedf[_fe]) temp_val.f = ""+stringify_formula(val.formula,range,val.cell,supbooks, opts);
							else temp_val.F = ((options.dense ? (out[_fr]||[])[_fc]: out[_fe]) || {}).F;
						} else temp_val.f = ""+stringify_formula(val.formula,range,val.cell,supbooks, opts);
					}
					if(BIFF2Fmt > 0) temp_val.z = BIFF2FmtTable[(temp_val.ixfe>>8) & 0x3F];
					safe_format_xf(temp_val, options, wb.opts.Date1904);
					addcell(val.cell, temp_val, options);
					last_formula = val;
				} break;
				case 0x0007: case 0x0207 /* String */: {
					if(last_formula) { /* technically always true */
						last_formula.val = val;
						temp_val = make_cell(val, last_formula.cell.ixfe, 's');
						temp_val.XF = XFs[temp_val.ixfe];
						if(options.cellFormula) {
							temp_val.f = ""+stringify_formula(last_formula.formula, range, last_formula.cell, supbooks, opts);
						}
						if(BIFF2Fmt > 0) temp_val.z = BIFF2FmtTable[(temp_val.ixfe>>8) & 0x3F];
						safe_format_xf(temp_val, options, wb.opts.Date1904);
						addcell(last_formula.cell, temp_val, options);
						last_formula = null;
					} else throw new Error("String record expects Formula");
				} break;
				case 0x0021: case 0x0221 /* Array */: {
					arrayf.push(val);
					var _arraystart = encode_cell(val[0].s);
					cc = options.dense ? (out[val[0].s.r]||[])[val[0].s.c] : out[_arraystart];
					if(options.cellFormula && cc) {
						if(!last_formula) break; /* technically unreachable */
						if(!_arraystart || !cc) break;
						cc.f = ""+stringify_formula(val[1], range, val[0], supbooks, opts);
						cc.F = encode_range(val[0]);
					}
				} break;
				case 0x04bc /* ShrFmla */: {
					if(!options.cellFormula) break;
					if(last_cell) {
						/* TODO: capture range */
						if(!last_formula) break; /* technically unreachable */
						sharedf[encode_cell(last_formula.cell)]= val[0];
						cc = options.dense ? (out[last_formula.cell.r]||[])[last_formula.cell.c] : out[encode_cell(last_formula.cell)];
						(cc||{}).f = ""+stringify_formula(val[0], range, lastcell, supbooks, opts);
					}
				} break;
				case 0x00fd /* LabelSst */:
					temp_val=make_cell(sst[val.isst].t, val.ixfe, 's');
					if(sst[val.isst].h) temp_val.h = sst[val.isst].h;
					temp_val.XF = XFs[temp_val.ixfe];
					if(BIFF2Fmt > 0) temp_val.z = BIFF2FmtTable[(temp_val.ixfe>>8) & 0x3F];
					safe_format_xf(temp_val, options, wb.opts.Date1904);
					addcell({c:val.c, r:val.r}, temp_val, options);
					break;
				case 0x0201 /* Blank */: if(options.sheetStubs) {
					temp_val = ({ixfe: val.ixfe, XF: XFs[val.ixfe], t:'z'}/*:any*/);
					if(BIFF2Fmt > 0) temp_val.z = BIFF2FmtTable[(temp_val.ixfe>>8) & 0x3F];
					safe_format_xf(temp_val, options, wb.opts.Date1904);
					addcell({c:val.c, r:val.r}, temp_val, options);
				} break;
				case 0x00be /* MulBlank */: if(options.sheetStubs) {
					for(var _j = val.c; _j <= val.C; ++_j) {
						var _ixfe = val.ixfe[_j-val.c];
						temp_val= ({ixfe:_ixfe, XF:XFs[_ixfe], t:'z'}/*:any*/);
						if(BIFF2Fmt > 0) temp_val.z = BIFF2FmtTable[(temp_val.ixfe>>8) & 0x3F];
						safe_format_xf(temp_val, options, wb.opts.Date1904);
						addcell({c:_j, r:val.r}, temp_val, options);
					}
				} break;
				case 0x00d6 /* RString */:
				case 0x0204 /* Label */: case 0x0004 /* BIFF2STR */:
					temp_val=make_cell(val.val, val.ixfe, 's');
					temp_val.XF = XFs[temp_val.ixfe];
					if(BIFF2Fmt > 0) temp_val.z = BIFF2FmtTable[(temp_val.ixfe>>8) & 0x3F];
					safe_format_xf(temp_val, options, wb.opts.Date1904);
					addcell({c:val.c, r:val.r}, temp_val, options);
					break;

				case 0x0000: case 0x0200 /* Dimensions */: {
					if(file_depth === 1) range = val; /* TODO: stack */
				} break;
				case 0x00fc /* SST */: {
					sst = val;
				} break;
				case 0x041e /* Format */: { /* val = [id, fmt] */
					if(opts.biff == 4) {
						BIFF2FmtTable[BIFF2Fmt++] = val[1];
						for(var b4idx = 0; b4idx < BIFF2Fmt + 163; ++b4idx) if(table_fmt[b4idx] == val[1]) break;
						if(b4idx >= 163) SSF_load(val[1], BIFF2Fmt + 163);
					}
					else SSF_load(val[1], val[0]);
				} break;
				case 0x001e /* BIFF2FORMAT */: {
					BIFF2FmtTable[BIFF2Fmt++] = val;
					for(var b2idx = 0; b2idx < BIFF2Fmt + 163; ++b2idx) if(table_fmt[b2idx] == val) break;
					if(b2idx >= 163) SSF_load(val, BIFF2Fmt + 163);
				} break;

				case 0x00e5 /* MergeCells */: merges = merges.concat(val); break;

				case 0x005d /* Obj */: objects[val.cmo[0]] = opts.lastobj = val; break;
				case 0x01b6 /* TxO */: opts.lastobj.TxO = val; break;
				case 0x007f /* ImData */: opts.lastobj.ImData = val; break;

				case 0x01b8 /* HLink */: {
					for(rngR = val[0].s.r; rngR <= val[0].e.r; ++rngR)
						for(rngC = val[0].s.c; rngC <= val[0].e.c; ++rngC) {
							cc = options.dense ? (out[rngR]||[])[rngC] : out[encode_cell({c:rngC,r:rngR})];
							if(cc) cc.l = val[1];
						}
				} break;
				case 0x0800 /* HLinkTooltip */: {
					for(rngR = val[0].s.r; rngR <= val[0].e.r; ++rngR)
						for(rngC = val[0].s.c; rngC <= val[0].e.c; ++rngC) {
							cc = options.dense ? (out[rngR]||[])[rngC] : out[encode_cell({c:rngC,r:rngR})];
							if(cc && cc.l) cc.l.Tooltip = val[1];
							}
				} break;
				case 0x001c /* Note */: {
					if(opts.biff <= 5 && opts.biff >= 2) break; /* TODO: BIFF5 */
					cc = options.dense ? (out[val[0].r]||[])[val[0].c] : out[encode_cell(val[0])];
					var noteobj = objects[val[2]];
					if(!cc) {
						if(options.dense) {
							if(!out[val[0].r]) out[val[0].r] = [];
							cc = out[val[0].r][val[0].c] = ({t:"z"}/*:any*/);
						} else {
							cc = out[encode_cell(val[0])] = ({t:"z"}/*:any*/);
						}
						range.e.r = Math.max(range.e.r, val[0].r);
						range.s.r = Math.min(range.s.r, val[0].r);
						range.e.c = Math.max(range.e.c, val[0].c);
						range.s.c = Math.min(range.s.c, val[0].c);
					}
					if(!cc.c) cc.c = [];
					cmnt = {a:val[1],t:noteobj.TxO.t};
					cc.c.push(cmnt);
				} break;
				case 0x087d /* XFExt */: update_xfext(XFs[val.ixfe], val.ext); break;
				case 0x007d /* ColInfo */: {
					if(!opts.cellStyles) break;
					while(val.e >= val.s) {
						colinfo[val.e--] = { width: val.w/256, level: (val.level || 0), hidden: !!(val.flags & 1) };
						if(!seencol) { seencol = true; find_mdw_colw(val.w/256); }
						process_col(colinfo[val.e+1]);
					}
				} break;
				case 0x0208 /* Row */: {
					var rowobj = {};
					if(val.level != null) { rowinfo[val.r] = rowobj; rowobj.level = val.level; }
					if(val.hidden) { rowinfo[val.r] = rowobj; rowobj.hidden = true; }
					if(val.hpt) {
						rowinfo[val.r] = rowobj;
						rowobj.hpt = val.hpt; rowobj.hpx = pt2px(val.hpt);
					}
				} break;
				case 0x0026 /* LeftMargin */:
				case 0x0027 /* RightMargin */:
				case 0x0028 /* TopMargin */:
				case 0x0029 /* BottomMargin */:
					if(!out['!margins']) default_margins(out['!margins'] = {});
					out['!margins'][({0x26: "left", 0x27:"right", 0x28:"top", 0x29:"bottom"})[RecordType]] = val;
					break;
				case 0x00a1 /* Setup */: // TODO
					if(!out['!margins']) default_margins(out['!margins'] = {});
					out['!margins'].header = val.header;
					out['!margins'].footer = val.footer;
					break;
				case 0x023e /* Window2 */: // TODO
					// $FlowIgnore
					if(val.RTL) Workbook.Views[0].RTL = true;
					break;
				case 0x0092 /* Palette */: palette = val; break;
				case 0x0896 /* Theme */: themes = val; break;
				case 0x008c /* Country */: country = val; break;
				case 0x01ba /* CodeName */: {
					/*:: if(!Workbook.WBProps) Workbook.WBProps = {}; */
					if(!cur_sheet) Workbook.WBProps.CodeName = val || "ThisWorkbook";
					else wsprops.CodeName = val || wsprops.name;
				} break;
			}
		} else {
			if(!R) console.error("Missing Info for XLS Record 0x" + RecordType.toString(16));
			blob.l += length;
		}
	}
	wb.SheetNames=keys(Directory).sort(function(a,b) { return Number(a) - Number(b); }).map(function(x){return Directory[x].name;});
	if(!options.bookSheets) wb.Sheets=Sheets;
	if(!wb.SheetNames.length && Preamble["!ref"]) {
		wb.SheetNames.push("Sheet1");
		/*jshint -W069 */
		if(wb.Sheets) wb.Sheets["Sheet1"] = Preamble;
		/*jshint +W069 */
	} else wb.Preamble=Preamble;
	if(wb.Sheets) FilterDatabases.forEach(function(r,i) { wb.Sheets[wb.SheetNames[i]]['!autofilter'] = r; });
	wb.Strings = sst;
	wb.SSF = dup(table_fmt);
	if(opts.enc) wb.Encryption = opts.enc;
	if(themes) wb.Themes = themes;
	wb.Metadata = {};
	if(country !== undefined) wb.Metadata.Country = country;
	if(supbooks.names.length > 0) Workbook.Names = supbooks.names;
	wb.Workbook = Workbook;
	return wb;
}

/* TODO: split props*/
var PSCLSID = {
	SI: "e0859ff2f94f6810ab9108002b27b3d9",
	DSI: "02d5cdd59c2e1b10939708002b2cf9ae",
	UDI: "05d5cdd59c2e1b10939708002b2cf9ae"
};
function parse_xls_props(cfb/*:CFBContainer*/, props, o) {
	/* [MS-OSHARED] 2.3.3.2.2 Document Summary Information Property Set */
	var DSI = CFB.find(cfb, '/!DocumentSummaryInformation');
	if(DSI && DSI.size > 0) try {
		var DocSummary = parse_PropertySetStream(DSI, DocSummaryPIDDSI, PSCLSID.DSI);
		for(var d in DocSummary) props[d] = DocSummary[d];
	} catch(e) {if(o.WTF) throw e;/* empty */}

	/* [MS-OSHARED] 2.3.3.2.1 Summary Information Property Set*/
	var SI = CFB.find(cfb, '/!SummaryInformation');
	if(SI && SI.size > 0) try {
		var Summary = parse_PropertySetStream(SI, SummaryPIDSI, PSCLSID.SI);
		for(var s in Summary) if(props[s] == null) props[s] = Summary[s];
	} catch(e) {if(o.WTF) throw e;/* empty */}

	if(props.HeadingPairs && props.TitlesOfParts) {
		load_props_pairs(props.HeadingPairs, props.TitlesOfParts, props, o);
		delete props.HeadingPairs; delete props.TitlesOfParts;
	}
}
function write_xls_props(wb/*:Workbook*/, cfb/*:CFBContainer*/) {
	var DSEntries = [], SEntries = [], CEntries = [];
	var i = 0, Keys;
	var DocSummaryRE/*:{[key:string]:string}*/ = evert_key(DocSummaryPIDDSI, "n");
	var SummaryRE/*:{[key:string]:string}*/ = evert_key(SummaryPIDSI, "n");
	if(wb.Props) {
		Keys = keys(wb.Props);
		// $FlowIgnore
		for(i = 0; i < Keys.length; ++i) (Object.prototype.hasOwnProperty.call(DocSummaryRE, Keys[i]) ? DSEntries : Object.prototype.hasOwnProperty.call(SummaryRE, Keys[i]) ? SEntries : CEntries).push([Keys[i], wb.Props[Keys[i]]]);
	}
	if(wb.Custprops) {
		Keys = keys(wb.Custprops);
		// $FlowIgnore
		for(i = 0; i < Keys.length; ++i) if(!Object.prototype.hasOwnProperty.call((wb.Props||{}), Keys[i])) (Object.prototype.hasOwnProperty.call(DocSummaryRE, Keys[i]) ? DSEntries : Object.prototype.hasOwnProperty.call(SummaryRE, Keys[i]) ? SEntries : CEntries).push([Keys[i], wb.Custprops[Keys[i]]]);
	}
	var CEntries2 = [];
	for(i = 0; i < CEntries.length; ++i) {
		if(XLSPSSkip.indexOf(CEntries[i][0]) > -1 || PseudoPropsPairs.indexOf(CEntries[i][0]) > -1) continue;
		if(CEntries[i][1] == null) continue;
		CEntries2.push(CEntries[i]);
	}
	if(SEntries.length) CFB.utils.cfb_add(cfb, "/\u0005SummaryInformation", write_PropertySetStream(SEntries, PSCLSID.SI, SummaryRE, SummaryPIDSI));
	if(DSEntries.length || CEntries2.length) CFB.utils.cfb_add(cfb, "/\u0005DocumentSummaryInformation", write_PropertySetStream(DSEntries, PSCLSID.DSI, DocSummaryRE, DocSummaryPIDDSI, CEntries2.length ? CEntries2 : null, PSCLSID.UDI));
}

function parse_xlscfb(cfb/*:any*/, options/*:?ParseOpts*/)/*:Workbook*/ {
if(!options) options = {};
fix_read_opts(options);
reset_cp();
if(options.codepage) set_ansi(options.codepage);
var CompObj/*:?CFBEntry*/, WB/*:?any*/;
if(cfb.FullPaths) {
	if(CFB.find(cfb, '/encryption')) throw new Error("File is password-protected");
	CompObj = CFB.find(cfb, '!CompObj');
	WB = CFB.find(cfb, '/Workbook') || CFB.find(cfb, '/Book');
} else {
	switch(options.type) {
		case 'base64': cfb = s2a(Base64_decode(cfb)); break;
		case 'binary': cfb = s2a(cfb); break;
		case 'buffer': break;
		case 'array': if(!Array.isArray(cfb)) cfb = Array.prototype.slice.call(cfb); break;
	}
	prep_blob(cfb, 0);
	WB = ({content: cfb}/*:any*/);
}
var /*::CompObjP, */WorkbookP/*:: :Workbook = XLSX.utils.book_new(); */;

var _data/*:?any*/;
if(CompObj) /*::CompObjP = */parse_compobj(CompObj);
if(options.bookProps && !options.bookSheets) WorkbookP = ({}/*:any*/);
else/*:: if(cfb instanceof CFBContainer) */ {
	var T = has_buf ? 'buffer' : 'array';
	if(WB && WB.content) WorkbookP = parse_workbook(WB.content, options);
	/* Quattro Pro 7-8 */
	else if((_data=CFB.find(cfb, 'PerfectOffice_MAIN')) && _data.content) WorkbookP = WK_.to_workbook(_data.content, (options.type = T, options));
	/* Quattro Pro 9 */
	else if((_data=CFB.find(cfb, 'NativeContent_MAIN')) && _data.content) WorkbookP = WK_.to_workbook(_data.content, (options.type = T, options));
	/* Works 4 for Mac */
	else if((_data=CFB.find(cfb, 'MN0')) && _data.content) throw new Error("Unsupported Works 4 for Mac file");
	else throw new Error("Cannot find Workbook stream");
	if(options.bookVBA && cfb.FullPaths && CFB.find(cfb, '/_VBA_PROJECT_CUR/VBA/dir')) WorkbookP.vbaraw = make_vba_xls(cfb);
}

var props = {};
if(cfb.FullPaths) parse_xls_props(/*::((*/cfb/*:: :any):CFBContainer)*/, props, options);

WorkbookP.Props = WorkbookP.Custprops = props; /* TODO: split up properties */
if(options.bookFiles) WorkbookP.cfb = cfb;
/*WorkbookP.CompObjP = CompObjP; // TODO: storage? */
return WorkbookP;
}


function write_xlscfb(wb/*:Workbook*/, opts/*:WriteOpts*/)/*:CFBContainer*/ {
	var o = opts || {};
	var cfb = CFB.utils.cfb_new({root:"R"});
	var wbpath = "/Workbook";
	switch(o.bookType || "xls") {
		case "xls": o.bookType = "biff8";
		/* falls through */
		case "xla": if(!o.bookType) o.bookType = "xla";
		/* falls through */
		case "biff8": wbpath = "/Workbook"; o.biff = 8; break;
		case "biff5": wbpath = "/Book"; o.biff = 5; break;
		default: throw new Error("invalid type " + o.bookType + " for XLS CFB");
	}
	CFB.utils.cfb_add(cfb, wbpath, write_biff_buf(wb, o));
	if(o.biff == 8 && (wb.Props || wb.Custprops)) write_xls_props(wb, cfb);
	// TODO: SI, DSI, CO
	if(o.biff == 8 && wb.vbaraw) fill_vba_xls(cfb, CFB.read(wb.vbaraw, {type: typeof wb.vbaraw == "string" ? "binary" : "buffer"}));
	return cfb;
}
/* [MS-XLSB] 2.3 Record Enumeration */
var XLSBRecordEnum = {
	/*::[*/0x0000/*::]*/: { /* n:"BrtRowHdr", */ f:parse_BrtRowHdr },
	/*::[*/0x0001/*::]*/: { /* n:"BrtCellBlank", */ f:parse_BrtCellBlank },
	/*::[*/0x0002/*::]*/: { /* n:"BrtCellRk", */ f:parse_BrtCellRk },
	/*::[*/0x0003/*::]*/: { /* n:"BrtCellError", */ f:parse_BrtCellError },
	/*::[*/0x0004/*::]*/: { /* n:"BrtCellBool", */ f:parse_BrtCellBool },
	/*::[*/0x0005/*::]*/: { /* n:"BrtCellReal", */ f:parse_BrtCellReal },
	/*::[*/0x0006/*::]*/: { /* n:"BrtCellSt", */ f:parse_BrtCellSt },
	/*::[*/0x0007/*::]*/: { /* n:"BrtCellIsst", */ f:parse_BrtCellIsst },
	/*::[*/0x0008/*::]*/: { /* n:"BrtFmlaString", */ f:parse_BrtFmlaString },
	/*::[*/0x0009/*::]*/: { /* n:"BrtFmlaNum", */ f:parse_BrtFmlaNum },
	/*::[*/0x000A/*::]*/: { /* n:"BrtFmlaBool", */ f:parse_BrtFmlaBool },
	/*::[*/0x000B/*::]*/: { /* n:"BrtFmlaError", */ f:parse_BrtFmlaError },
	/*::[*/0x000C/*::]*/: { /* n:"BrtShortBlank", */ f:parse_BrtShortBlank },
	/*::[*/0x000D/*::]*/: { /* n:"BrtShortRk", */ f:parse_BrtShortRk },
	/*::[*/0x000E/*::]*/: { /* n:"BrtShortError", */ f:parse_BrtShortError },
	/*::[*/0x000F/*::]*/: { /* n:"BrtShortBool", */ f:parse_BrtShortBool },
	/*::[*/0x0010/*::]*/: { /* n:"BrtShortReal", */ f:parse_BrtShortReal },
	/*::[*/0x0011/*::]*/: { /* n:"BrtShortSt", */ f:parse_BrtShortSt },
	/*::[*/0x0012/*::]*/: { /* n:"BrtShortIsst", */ f:parse_BrtShortIsst },
	/*::[*/0x0013/*::]*/: { /* n:"BrtSSTItem", */ f:parse_RichStr },
	/*::[*/0x0014/*::]*/: { /* n:"BrtPCDIMissing" */ },
	/*::[*/0x0015/*::]*/: { /* n:"BrtPCDINumber" */ },
	/*::[*/0x0016/*::]*/: { /* n:"BrtPCDIBoolean" */ },
	/*::[*/0x0017/*::]*/: { /* n:"BrtPCDIError" */ },
	/*::[*/0x0018/*::]*/: { /* n:"BrtPCDIString" */ },
	/*::[*/0x0019/*::]*/: { /* n:"BrtPCDIDatetime" */ },
	/*::[*/0x001A/*::]*/: { /* n:"BrtPCDIIndex" */ },
	/*::[*/0x001B/*::]*/: { /* n:"BrtPCDIAMissing" */ },
	/*::[*/0x001C/*::]*/: { /* n:"BrtPCDIANumber" */ },
	/*::[*/0x001D/*::]*/: { /* n:"BrtPCDIABoolean" */ },
	/*::[*/0x001E/*::]*/: { /* n:"BrtPCDIAError" */ },
	/*::[*/0x001F/*::]*/: { /* n:"BrtPCDIAString" */ },
	/*::[*/0x0020/*::]*/: { /* n:"BrtPCDIADatetime" */ },
	/*::[*/0x0021/*::]*/: { /* n:"BrtPCRRecord" */ },
	/*::[*/0x0022/*::]*/: { /* n:"BrtPCRRecordDt" */ },
	/*::[*/0x0023/*::]*/: { /* n:"BrtFRTBegin", */ T:1 },
	/*::[*/0x0024/*::]*/: { /* n:"BrtFRTEnd", */ T:-1 },
	/*::[*/0x0025/*::]*/: { /* n:"BrtACBegin", */ T:1 },
	/*::[*/0x0026/*::]*/: { /* n:"BrtACEnd", */ T:-1 },
	/*::[*/0x0027/*::]*/: { /* n:"BrtName", */ f:parse_BrtName },
	/*::[*/0x0028/*::]*/: { /* n:"BrtIndexRowBlock" */ },
	/*::[*/0x002A/*::]*/: { /* n:"BrtIndexBlock" */ },
	/*::[*/0x002B/*::]*/: { /* n:"BrtFont", */ f:parse_BrtFont },
	/*::[*/0x002C/*::]*/: { /* n:"BrtFmt", */ f:parse_BrtFmt },
	/*::[*/0x002D/*::]*/: { /* n:"BrtFill", */ f:parse_BrtFill },
	/*::[*/0x002E/*::]*/: { /* n:"BrtBorder", */ f:parse_BrtBorder },
	/*::[*/0x002F/*::]*/: { /* n:"BrtXF", */ f:parse_BrtXF },
	/*::[*/0x0030/*::]*/: { /* n:"BrtStyle" */ },
	/*::[*/0x0031/*::]*/: { /* n:"BrtCellMeta", */ f:parse_Int32LE },
	/*::[*/0x0032/*::]*/: { /* n:"BrtValueMeta" */ },
	/*::[*/0x0033/*::]*/: { /* n:"BrtMdb" */ f:parse_BrtMdb },
	/*::[*/0x0034/*::]*/: { /* n:"BrtBeginFmd", */ T:1 },
	/*::[*/0x0035/*::]*/: { /* n:"BrtEndFmd", */ T:-1 },
	/*::[*/0x0036/*::]*/: { /* n:"BrtBeginMdx", */ T:1 },
	/*::[*/0x0037/*::]*/: { /* n:"BrtEndMdx", */ T:-1 },
	/*::[*/0x0038/*::]*/: { /* n:"BrtBeginMdxTuple", */ T:1 },
	/*::[*/0x0039/*::]*/: { /* n:"BrtEndMdxTuple", */ T:-1 },
	/*::[*/0x003A/*::]*/: { /* n:"BrtMdxMbrIstr" */ },
	/*::[*/0x003B/*::]*/: { /* n:"BrtStr" */ },
	/*::[*/0x003C/*::]*/: { /* n:"BrtColInfo", */ f:parse_ColInfo },
	/*::[*/0x003E/*::]*/: { /* n:"BrtCellRString", */ f:parse_BrtCellRString },
	/*::[*/0x003F/*::]*/: { /* n:"BrtCalcChainItem$", */ f:parse_BrtCalcChainItem$ },
	/*::[*/0x0040/*::]*/: { /* n:"BrtDVal", */ f:parse_BrtDVal },
	/*::[*/0x0041/*::]*/: { /* n:"BrtSxvcellNum" */ },
	/*::[*/0x0042/*::]*/: { /* n:"BrtSxvcellStr" */ },
	/*::[*/0x0043/*::]*/: { /* n:"BrtSxvcellBool" */ },
	/*::[*/0x0044/*::]*/: { /* n:"BrtSxvcellErr" */ },
	/*::[*/0x0045/*::]*/: { /* n:"BrtSxvcellDate" */ },
	/*::[*/0x0046/*::]*/: { /* n:"BrtSxvcellNil" */ },
	/*::[*/0x0080/*::]*/: { /* n:"BrtFileVersion" */ },
	/*::[*/0x0081/*::]*/: { /* n:"BrtBeginSheet", */ T:1 },
	/*::[*/0x0082/*::]*/: { /* n:"BrtEndSheet", */ T:-1 },
	/*::[*/0x0083/*::]*/: { /* n:"BrtBeginBook", */ T:1, f:parsenoop, p:0 },
	/*::[*/0x0084/*::]*/: { /* n:"BrtEndBook", */ T:-1 },
	/*::[*/0x0085/*::]*/: { /* n:"BrtBeginWsViews", */ T:1 },
	/*::[*/0x0086/*::]*/: { /* n:"BrtEndWsViews", */ T:-1 },
	/*::[*/0x0087/*::]*/: { /* n:"BrtBeginBookViews", */ T:1 },
	/*::[*/0x0088/*::]*/: { /* n:"BrtEndBookViews", */ T:-1 },
	/*::[*/0x0089/*::]*/: { /* n:"BrtBeginWsView", */ T:1, f:parse_BrtBeginWsView },
	/*::[*/0x008A/*::]*/: { /* n:"BrtEndWsView", */ T:-1 },
	/*::[*/0x008B/*::]*/: { /* n:"BrtBeginCsViews", */ T:1 },
	/*::[*/0x008C/*::]*/: { /* n:"BrtEndCsViews", */ T:-1 },
	/*::[*/0x008D/*::]*/: { /* n:"BrtBeginCsView", */ T:1 },
	/*::[*/0x008E/*::]*/: { /* n:"BrtEndCsView", */ T:-1 },
	/*::[*/0x008F/*::]*/: { /* n:"BrtBeginBundleShs", */ T:1 },
	/*::[*/0x0090/*::]*/: { /* n:"BrtEndBundleShs", */ T:-1 },
	/*::[*/0x0091/*::]*/: { /* n:"BrtBeginSheetData", */ T:1 },
	/*::[*/0x0092/*::]*/: { /* n:"BrtEndSheetData", */ T:-1 },
	/*::[*/0x0093/*::]*/: { /* n:"BrtWsProp", */ f:parse_BrtWsProp },
	/*::[*/0x0094/*::]*/: { /* n:"BrtWsDim", */ f:parse_BrtWsDim, p:16 },
	/*::[*/0x0097/*::]*/: { /* n:"BrtPane", */ f:parse_BrtPane },
	/*::[*/0x0098/*::]*/: { /* n:"BrtSel" */ },
	/*::[*/0x0099/*::]*/: { /* n:"BrtWbProp", */ f:parse_BrtWbProp },
	/*::[*/0x009A/*::]*/: { /* n:"BrtWbFactoid" */ },
	/*::[*/0x009B/*::]*/: { /* n:"BrtFileRecover" */ },
	/*::[*/0x009C/*::]*/: { /* n:"BrtBundleSh", */ f:parse_BrtBundleSh },
	/*::[*/0x009D/*::]*/: { /* n:"BrtCalcProp" */ },
	/*::[*/0x009E/*::]*/: { /* n:"BrtBookView" */ },
	/*::[*/0x009F/*::]*/: { /* n:"BrtBeginSst", */ T:1, f:parse_BrtBeginSst },
	/*::[*/0x00A0/*::]*/: { /* n:"BrtEndSst", */ T:-1 },
	/*::[*/0x00A1/*::]*/: { /* n:"BrtBeginAFilter", */ T:1, f:parse_UncheckedRfX },
	/*::[*/0x00A2/*::]*/: { /* n:"BrtEndAFilter", */ T:-1 },
	/*::[*/0x00A3/*::]*/: { /* n:"BrtBeginFilterColumn", */ T:1 },
	/*::[*/0x00A4/*::]*/: { /* n:"BrtEndFilterColumn", */ T:-1 },
	/*::[*/0x00A5/*::]*/: { /* n:"BrtBeginFilters", */ T:1 },
	/*::[*/0x00A6/*::]*/: { /* n:"BrtEndFilters", */ T:-1 },
	/*::[*/0x00A7/*::]*/: { /* n:"BrtFilter" */ },
	/*::[*/0x00A8/*::]*/: { /* n:"BrtColorFilter" */ },
	/*::[*/0x00A9/*::]*/: { /* n:"BrtIconFilter" */ },
	/*::[*/0x00AA/*::]*/: { /* n:"BrtTop10Filter" */ },
	/*::[*/0x00AB/*::]*/: { /* n:"BrtDynamicFilter" */ },
	/*::[*/0x00AC/*::]*/: { /* n:"BrtBeginCustomFilters", */ T:1 },
	/*::[*/0x00AD/*::]*/: { /* n:"BrtEndCustomFilters", */ T:-1 },
	/*::[*/0x00AE/*::]*/: { /* n:"BrtCustomFilter" */ },
	/*::[*/0x00AF/*::]*/: { /* n:"BrtAFilterDateGroupItem" */ },
	/*::[*/0x00B0/*::]*/: { /* n:"BrtMergeCell", */ f:parse_BrtMergeCell },
	/*::[*/0x00B1/*::]*/: { /* n:"BrtBeginMergeCells", */ T:1 },
	/*::[*/0x00B2/*::]*/: { /* n:"BrtEndMergeCells", */ T:-1 },
	/*::[*/0x00B3/*::]*/: { /* n:"BrtBeginPivotCacheDef", */ T:1 },
	/*::[*/0x00B4/*::]*/: { /* n:"BrtEndPivotCacheDef", */ T:-1 },
	/*::[*/0x00B5/*::]*/: { /* n:"BrtBeginPCDFields", */ T:1 },
	/*::[*/0x00B6/*::]*/: { /* n:"BrtEndPCDFields", */ T:-1 },
	/*::[*/0x00B7/*::]*/: { /* n:"BrtBeginPCDField", */ T:1 },
	/*::[*/0x00B8/*::]*/: { /* n:"BrtEndPCDField", */ T:-1 },
	/*::[*/0x00B9/*::]*/: { /* n:"BrtBeginPCDSource", */ T:1 },
	/*::[*/0x00BA/*::]*/: { /* n:"BrtEndPCDSource", */ T:-1 },
	/*::[*/0x00BB/*::]*/: { /* n:"BrtBeginPCDSRange", */ T:1 },
	/*::[*/0x00BC/*::]*/: { /* n:"BrtEndPCDSRange", */ T:-1 },
	/*::[*/0x00BD/*::]*/: { /* n:"BrtBeginPCDFAtbl", */ T:1 },
	/*::[*/0x00BE/*::]*/: { /* n:"BrtEndPCDFAtbl", */ T:-1 },
	/*::[*/0x00BF/*::]*/: { /* n:"BrtBeginPCDIRun", */ T:1 },
	/*::[*/0x00C0/*::]*/: { /* n:"BrtEndPCDIRun", */ T:-1 },
	/*::[*/0x00C1/*::]*/: { /* n:"BrtBeginPivotCacheRecords", */ T:1 },
	/*::[*/0x00C2/*::]*/: { /* n:"BrtEndPivotCacheRecords", */ T:-1 },
	/*::[*/0x00C3/*::]*/: { /* n:"BrtBeginPCDHierarchies", */ T:1 },
	/*::[*/0x00C4/*::]*/: { /* n:"BrtEndPCDHierarchies", */ T:-1 },
	/*::[*/0x00C5/*::]*/: { /* n:"BrtBeginPCDHierarchy", */ T:1 },
	/*::[*/0x00C6/*::]*/: { /* n:"BrtEndPCDHierarchy", */ T:-1 },
	/*::[*/0x00C7/*::]*/: { /* n:"BrtBeginPCDHFieldsUsage", */ T:1 },
	/*::[*/0x00C8/*::]*/: { /* n:"BrtEndPCDHFieldsUsage", */ T:-1 },
	/*::[*/0x00C9/*::]*/: { /* n:"BrtBeginExtConnection", */ T:1 },
	/*::[*/0x00CA/*::]*/: { /* n:"BrtEndExtConnection", */ T:-1 },
	/*::[*/0x00CB/*::]*/: { /* n:"BrtBeginECDbProps", */ T:1 },
	/*::[*/0x00CC/*::]*/: { /* n:"BrtEndECDbProps", */ T:-1 },
	/*::[*/0x00CD/*::]*/: { /* n:"BrtBeginECOlapProps", */ T:1 },
	/*::[*/0x00CE/*::]*/: { /* n:"BrtEndECOlapProps", */ T:-1 },
	/*::[*/0x00CF/*::]*/: { /* n:"BrtBeginPCDSConsol", */ T:1 },
	/*::[*/0x00D0/*::]*/: { /* n:"BrtEndPCDSConsol", */ T:-1 },
	/*::[*/0x00D1/*::]*/: { /* n:"BrtBeginPCDSCPages", */ T:1 },
	/*::[*/0x00D2/*::]*/: { /* n:"BrtEndPCDSCPages", */ T:-1 },
	/*::[*/0x00D3/*::]*/: { /* n:"BrtBeginPCDSCPage", */ T:1 },
	/*::[*/0x00D4/*::]*/: { /* n:"BrtEndPCDSCPage", */ T:-1 },
	/*::[*/0x00D5/*::]*/: { /* n:"BrtBeginPCDSCPItem", */ T:1 },
	/*::[*/0x00D6/*::]*/: { /* n:"BrtEndPCDSCPItem", */ T:-1 },
	/*::[*/0x00D7/*::]*/: { /* n:"BrtBeginPCDSCSets", */ T:1 },
	/*::[*/0x00D8/*::]*/: { /* n:"BrtEndPCDSCSets", */ T:-1 },
	/*::[*/0x00D9/*::]*/: { /* n:"BrtBeginPCDSCSet", */ T:1 },
	/*::[*/0x00DA/*::]*/: { /* n:"BrtEndPCDSCSet", */ T:-1 },
	/*::[*/0x00DB/*::]*/: { /* n:"BrtBeginPCDFGroup", */ T:1 },
	/*::[*/0x00DC/*::]*/: { /* n:"BrtEndPCDFGroup", */ T:-1 },
	/*::[*/0x00DD/*::]*/: { /* n:"BrtBeginPCDFGItems", */ T:1 },
	/*::[*/0x00DE/*::]*/: { /* n:"BrtEndPCDFGItems", */ T:-1 },
	/*::[*/0x00DF/*::]*/: { /* n:"BrtBeginPCDFGRange", */ T:1 },
	/*::[*/0x00E0/*::]*/: { /* n:"BrtEndPCDFGRange", */ T:-1 },
	/*::[*/0x00E1/*::]*/: { /* n:"BrtBeginPCDFGDiscrete", */ T:1 },
	/*::[*/0x00E2/*::]*/: { /* n:"BrtEndPCDFGDiscrete", */ T:-1 },
	/*::[*/0x00E3/*::]*/: { /* n:"BrtBeginPCDSDTupleCache", */ T:1 },
	/*::[*/0x00E4/*::]*/: { /* n:"BrtEndPCDSDTupleCache", */ T:-1 },
	/*::[*/0x00E5/*::]*/: { /* n:"BrtBeginPCDSDTCEntries", */ T:1 },
	/*::[*/0x00E6/*::]*/: { /* n:"BrtEndPCDSDTCEntries", */ T:-1 },
	/*::[*/0x00E7/*::]*/: { /* n:"BrtBeginPCDSDTCEMembers", */ T:1 },
	/*::[*/0x00E8/*::]*/: { /* n:"BrtEndPCDSDTCEMembers", */ T:-1 },
	/*::[*/0x00E9/*::]*/: { /* n:"BrtBeginPCDSDTCEMember", */ T:1 },
	/*::[*/0x00EA/*::]*/: { /* n:"BrtEndPCDSDTCEMember", */ T:-1 },
	/*::[*/0x00EB/*::]*/: { /* n:"BrtBeginPCDSDTCQueries", */ T:1 },
	/*::[*/0x00EC/*::]*/: { /* n:"BrtEndPCDSDTCQueries", */ T:-1 },
	/*::[*/0x00ED/*::]*/: { /* n:"BrtBeginPCDSDTCQuery", */ T:1 },
	/*::[*/0x00EE/*::]*/: { /* n:"BrtEndPCDSDTCQuery", */ T:-1 },
	/*::[*/0x00EF/*::]*/: { /* n:"BrtBeginPCDSDTCSets", */ T:1 },
	/*::[*/0x00F0/*::]*/: { /* n:"BrtEndPCDSDTCSets", */ T:-1 },
	/*::[*/0x00F1/*::]*/: { /* n:"BrtBeginPCDSDTCSet", */ T:1 },
	/*::[*/0x00F2/*::]*/: { /* n:"BrtEndPCDSDTCSet", */ T:-1 },
	/*::[*/0x00F3/*::]*/: { /* n:"BrtBeginPCDCalcItems", */ T:1 },
	/*::[*/0x00F4/*::]*/: { /* n:"BrtEndPCDCalcItems", */ T:-1 },
	/*::[*/0x00F5/*::]*/: { /* n:"BrtBeginPCDCalcItem", */ T:1 },
	/*::[*/0x00F6/*::]*/: { /* n:"BrtEndPCDCalcItem", */ T:-1 },
	/*::[*/0x00F7/*::]*/: { /* n:"BrtBeginPRule", */ T:1 },
	/*::[*/0x00F8/*::]*/: { /* n:"BrtEndPRule", */ T:-1 },
	/*::[*/0x00F9/*::]*/: { /* n:"BrtBeginPRFilters", */ T:1 },
	/*::[*/0x00FA/*::]*/: { /* n:"BrtEndPRFilters", */ T:-1 },
	/*::[*/0x00FB/*::]*/: { /* n:"BrtBeginPRFilter", */ T:1 },
	/*::[*/0x00FC/*::]*/: { /* n:"BrtEndPRFilter", */ T:-1 },
	/*::[*/0x00FD/*::]*/: { /* n:"BrtBeginPNames", */ T:1 },
	/*::[*/0x00FE/*::]*/: { /* n:"BrtEndPNames", */ T:-1 },
	/*::[*/0x00FF/*::]*/: { /* n:"BrtBeginPName", */ T:1 },
	/*::[*/0x0100/*::]*/: { /* n:"BrtEndPName", */ T:-1 },
	/*::[*/0x0101/*::]*/: { /* n:"BrtBeginPNPairs", */ T:1 },
	/*::[*/0x0102/*::]*/: { /* n:"BrtEndPNPairs", */ T:-1 },
	/*::[*/0x0103/*::]*/: { /* n:"BrtBeginPNPair", */ T:1 },
	/*::[*/0x0104/*::]*/: { /* n:"BrtEndPNPair", */ T:-1 },
	/*::[*/0x0105/*::]*/: { /* n:"BrtBeginECWebProps", */ T:1 },
	/*::[*/0x0106/*::]*/: { /* n:"BrtEndECWebProps", */ T:-1 },
	/*::[*/0x0107/*::]*/: { /* n:"BrtBeginEcWpTables", */ T:1 },
	/*::[*/0x0108/*::]*/: { /* n:"BrtEndECWPTables", */ T:-1 },
	/*::[*/0x0109/*::]*/: { /* n:"BrtBeginECParams", */ T:1 },
	/*::[*/0x010A/*::]*/: { /* n:"BrtEndECParams", */ T:-1 },
	/*::[*/0x010B/*::]*/: { /* n:"BrtBeginECParam", */ T:1 },
	/*::[*/0x010C/*::]*/: { /* n:"BrtEndECParam", */ T:-1 },
	/*::[*/0x010D/*::]*/: { /* n:"BrtBeginPCDKPIs", */ T:1 },
	/*::[*/0x010E/*::]*/: { /* n:"BrtEndPCDKPIs", */ T:-1 },
	/*::[*/0x010F/*::]*/: { /* n:"BrtBeginPCDKPI", */ T:1 },
	/*::[*/0x0110/*::]*/: { /* n:"BrtEndPCDKPI", */ T:-1 },
	/*::[*/0x0111/*::]*/: { /* n:"BrtBeginDims", */ T:1 },
	/*::[*/0x0112/*::]*/: { /* n:"BrtEndDims", */ T:-1 },
	/*::[*/0x0113/*::]*/: { /* n:"BrtBeginDim", */ T:1 },
	/*::[*/0x0114/*::]*/: { /* n:"BrtEndDim", */ T:-1 },
	/*::[*/0x0115/*::]*/: { /* n:"BrtIndexPartEnd" */ },
	/*::[*/0x0116/*::]*/: { /* n:"BrtBeginStyleSheet", */ T:1 },
	/*::[*/0x0117/*::]*/: { /* n:"BrtEndStyleSheet", */ T:-1 },
	/*::[*/0x0118/*::]*/: { /* n:"BrtBeginSXView", */ T:1 },
	/*::[*/0x0119/*::]*/: { /* n:"BrtEndSXVI", */ T:-1 },
	/*::[*/0x011A/*::]*/: { /* n:"BrtBeginSXVI", */ T:1 },
	/*::[*/0x011B/*::]*/: { /* n:"BrtBeginSXVIs", */ T:1 },
	/*::[*/0x011C/*::]*/: { /* n:"BrtEndSXVIs", */ T:-1 },
	/*::[*/0x011D/*::]*/: { /* n:"BrtBeginSXVD", */ T:1 },
	/*::[*/0x011E/*::]*/: { /* n:"BrtEndSXVD", */ T:-1 },
	/*::[*/0x011F/*::]*/: { /* n:"BrtBeginSXVDs", */ T:1 },
	/*::[*/0x0120/*::]*/: { /* n:"BrtEndSXVDs", */ T:-1 },
	/*::[*/0x0121/*::]*/: { /* n:"BrtBeginSXPI", */ T:1 },
	/*::[*/0x0122/*::]*/: { /* n:"BrtEndSXPI", */ T:-1 },
	/*::[*/0x0123/*::]*/: { /* n:"BrtBeginSXPIs", */ T:1 },
	/*::[*/0x0124/*::]*/: { /* n:"BrtEndSXPIs", */ T:-1 },
	/*::[*/0x0125/*::]*/: { /* n:"BrtBeginSXDI", */ T:1 },
	/*::[*/0x0126/*::]*/: { /* n:"BrtEndSXDI", */ T:-1 },
	/*::[*/0x0127/*::]*/: { /* n:"BrtBeginSXDIs", */ T:1 },
	/*::[*/0x0128/*::]*/: { /* n:"BrtEndSXDIs", */ T:-1 },
	/*::[*/0x0129/*::]*/: { /* n:"BrtBeginSXLI", */ T:1 },
	/*::[*/0x012A/*::]*/: { /* n:"BrtEndSXLI", */ T:-1 },
	/*::[*/0x012B/*::]*/: { /* n:"BrtBeginSXLIRws", */ T:1 },
	/*::[*/0x012C/*::]*/: { /* n:"BrtEndSXLIRws", */ T:-1 },
	/*::[*/0x012D/*::]*/: { /* n:"BrtBeginSXLICols", */ T:1 },
	/*::[*/0x012E/*::]*/: { /* n:"BrtEndSXLICols", */ T:-1 },
	/*::[*/0x012F/*::]*/: { /* n:"BrtBeginSXFormat", */ T:1 },
	/*::[*/0x0130/*::]*/: { /* n:"BrtEndSXFormat", */ T:-1 },
	/*::[*/0x0131/*::]*/: { /* n:"BrtBeginSXFormats", */ T:1 },
	/*::[*/0x0132/*::]*/: { /* n:"BrtEndSxFormats", */ T:-1 },
	/*::[*/0x0133/*::]*/: { /* n:"BrtBeginSxSelect", */ T:1 },
	/*::[*/0x0134/*::]*/: { /* n:"BrtEndSxSelect", */ T:-1 },
	/*::[*/0x0135/*::]*/: { /* n:"BrtBeginISXVDRws", */ T:1 },
	/*::[*/0x0136/*::]*/: { /* n:"BrtEndISXVDRws", */ T:-1 },
	/*::[*/0x0137/*::]*/: { /* n:"BrtBeginISXVDCols", */ T:1 },
	/*::[*/0x0138/*::]*/: { /* n:"BrtEndISXVDCols", */ T:-1 },
	/*::[*/0x0139/*::]*/: { /* n:"BrtEndSXLocation", */ T:-1 },
	/*::[*/0x013A/*::]*/: { /* n:"BrtBeginSXLocation", */ T:1 },
	/*::[*/0x013B/*::]*/: { /* n:"BrtEndSXView", */ T:-1 },
	/*::[*/0x013C/*::]*/: { /* n:"BrtBeginSXTHs", */ T:1 },
	/*::[*/0x013D/*::]*/: { /* n:"BrtEndSXTHs", */ T:-1 },
	/*::[*/0x013E/*::]*/: { /* n:"BrtBeginSXTH", */ T:1 },
	/*::[*/0x013F/*::]*/: { /* n:"BrtEndSXTH", */ T:-1 },
	/*::[*/0x0140/*::]*/: { /* n:"BrtBeginISXTHRws", */ T:1 },
	/*::[*/0x0141/*::]*/: { /* n:"BrtEndISXTHRws", */ T:-1 },
	/*::[*/0x0142/*::]*/: { /* n:"BrtBeginISXTHCols", */ T:1 },
	/*::[*/0x0143/*::]*/: { /* n:"BrtEndISXTHCols", */ T:-1 },
	/*::[*/0x0144/*::]*/: { /* n:"BrtBeginSXTDMPS", */ T:1 },
	/*::[*/0x0145/*::]*/: { /* n:"BrtEndSXTDMPs", */ T:-1 },
	/*::[*/0x0146/*::]*/: { /* n:"BrtBeginSXTDMP", */ T:1 },
	/*::[*/0x0147/*::]*/: { /* n:"BrtEndSXTDMP", */ T:-1 },
	/*::[*/0x0148/*::]*/: { /* n:"BrtBeginSXTHItems", */ T:1 },
	/*::[*/0x0149/*::]*/: { /* n:"BrtEndSXTHItems", */ T:-1 },
	/*::[*/0x014A/*::]*/: { /* n:"BrtBeginSXTHItem", */ T:1 },
	/*::[*/0x014B/*::]*/: { /* n:"BrtEndSXTHItem", */ T:-1 },
	/*::[*/0x014C/*::]*/: { /* n:"BrtBeginMetadata", */ T:1 },
	/*::[*/0x014D/*::]*/: { /* n:"BrtEndMetadata", */ T:-1 },
	/*::[*/0x014E/*::]*/: { /* n:"BrtBeginEsmdtinfo", */ T:1 },
	/*::[*/0x014F/*::]*/: { /* n:"BrtMdtinfo", */ f:parse_BrtMdtinfo },
	/*::[*/0x0150/*::]*/: { /* n:"BrtEndEsmdtinfo", */ T:-1 },
	/*::[*/0x0151/*::]*/: { /* n:"BrtBeginEsmdb", */ f:parse_BrtBeginEsmdb, T:1 },
	/*::[*/0x0152/*::]*/: { /* n:"BrtEndEsmdb", */ T:-1 },
	/*::[*/0x0153/*::]*/: { /* n:"BrtBeginEsfmd", */ T:1 },
	/*::[*/0x0154/*::]*/: { /* n:"BrtEndEsfmd", */ T:-1 },
	/*::[*/0x0155/*::]*/: { /* n:"BrtBeginSingleCells", */ T:1 },
	/*::[*/0x0156/*::]*/: { /* n:"BrtEndSingleCells", */ T:-1 },
	/*::[*/0x0157/*::]*/: { /* n:"BrtBeginList", */ T:1 },
	/*::[*/0x0158/*::]*/: { /* n:"BrtEndList", */ T:-1 },
	/*::[*/0x0159/*::]*/: { /* n:"BrtBeginListCols", */ T:1 },
	/*::[*/0x015A/*::]*/: { /* n:"BrtEndListCols", */ T:-1 },
	/*::[*/0x015B/*::]*/: { /* n:"BrtBeginListCol", */ T:1 },
	/*::[*/0x015C/*::]*/: { /* n:"BrtEndListCol", */ T:-1 },
	/*::[*/0x015D/*::]*/: { /* n:"BrtBeginListXmlCPr", */ T:1 },
	/*::[*/0x015E/*::]*/: { /* n:"BrtEndListXmlCPr", */ T:-1 },
	/*::[*/0x015F/*::]*/: { /* n:"BrtListCCFmla" */ },
	/*::[*/0x0160/*::]*/: { /* n:"BrtListTrFmla" */ },
	/*::[*/0x0161/*::]*/: { /* n:"BrtBeginExternals", */ T:1 },
	/*::[*/0x0162/*::]*/: { /* n:"BrtEndExternals", */ T:-1 },
	/*::[*/0x0163/*::]*/: { /* n:"BrtSupBookSrc", */ f:parse_RelID},
	/*::[*/0x0165/*::]*/: { /* n:"BrtSupSelf" */ },
	/*::[*/0x0166/*::]*/: { /* n:"BrtSupSame" */ },
	/*::[*/0x0167/*::]*/: { /* n:"BrtSupTabs" */ },
	/*::[*/0x0168/*::]*/: { /* n:"BrtBeginSupBook", */ T:1 },
	/*::[*/0x0169/*::]*/: { /* n:"BrtPlaceholderName" */ },
	/*::[*/0x016A/*::]*/: { /* n:"BrtExternSheet", */ f:parse_ExternSheet },
	/*::[*/0x016B/*::]*/: { /* n:"BrtExternTableStart" */ },
	/*::[*/0x016C/*::]*/: { /* n:"BrtExternTableEnd" */ },
	/*::[*/0x016E/*::]*/: { /* n:"BrtExternRowHdr" */ },
	/*::[*/0x016F/*::]*/: { /* n:"BrtExternCellBlank" */ },
	/*::[*/0x0170/*::]*/: { /* n:"BrtExternCellReal" */ },
	/*::[*/0x0171/*::]*/: { /* n:"BrtExternCellBool" */ },
	/*::[*/0x0172/*::]*/: { /* n:"BrtExternCellError" */ },
	/*::[*/0x0173/*::]*/: { /* n:"BrtExternCellString" */ },
	/*::[*/0x0174/*::]*/: { /* n:"BrtBeginEsmdx", */ T:1 },
	/*::[*/0x0175/*::]*/: { /* n:"BrtEndEsmdx", */ T:-1 },
	/*::[*/0x0176/*::]*/: { /* n:"BrtBeginMdxSet", */ T:1 },
	/*::[*/0x0177/*::]*/: { /* n:"BrtEndMdxSet", */ T:-1 },
	/*::[*/0x0178/*::]*/: { /* n:"BrtBeginMdxMbrProp", */ T:1 },
	/*::[*/0x0179/*::]*/: { /* n:"BrtEndMdxMbrProp", */ T:-1 },
	/*::[*/0x017A/*::]*/: { /* n:"BrtBeginMdxKPI", */ T:1 },
	/*::[*/0x017B/*::]*/: { /* n:"BrtEndMdxKPI", */ T:-1 },
	/*::[*/0x017C/*::]*/: { /* n:"BrtBeginEsstr", */ T:1 },
	/*::[*/0x017D/*::]*/: { /* n:"BrtEndEsstr", */ T:-1 },
	/*::[*/0x017E/*::]*/: { /* n:"BrtBeginPRFItem", */ T:1 },
	/*::[*/0x017F/*::]*/: { /* n:"BrtEndPRFItem", */ T:-1 },
	/*::[*/0x0180/*::]*/: { /* n:"BrtBeginPivotCacheIDs", */ T:1 },
	/*::[*/0x0181/*::]*/: { /* n:"BrtEndPivotCacheIDs", */ T:-1 },
	/*::[*/0x0182/*::]*/: { /* n:"BrtBeginPivotCacheID", */ T:1 },
	/*::[*/0x0183/*::]*/: { /* n:"BrtEndPivotCacheID", */ T:-1 },
	/*::[*/0x0184/*::]*/: { /* n:"BrtBeginISXVIs", */ T:1 },
	/*::[*/0x0185/*::]*/: { /* n:"BrtEndISXVIs", */ T:-1 },
	/*::[*/0x0186/*::]*/: { /* n:"BrtBeginColInfos", */ T:1 },
	/*::[*/0x0187/*::]*/: { /* n:"BrtEndColInfos", */ T:-1 },
	/*::[*/0x0188/*::]*/: { /* n:"BrtBeginRwBrk", */ T:1 },
	/*::[*/0x0189/*::]*/: { /* n:"BrtEndRwBrk", */ T:-1 },
	/*::[*/0x018A/*::]*/: { /* n:"BrtBeginColBrk", */ T:1 },
	/*::[*/0x018B/*::]*/: { /* n:"BrtEndColBrk", */ T:-1 },
	/*::[*/0x018C/*::]*/: { /* n:"BrtBrk" */ },
	/*::[*/0x018D/*::]*/: { /* n:"BrtUserBookView" */ },
	/*::[*/0x018E/*::]*/: { /* n:"BrtInfo" */ },
	/*::[*/0x018F/*::]*/: { /* n:"BrtCUsr" */ },
	/*::[*/0x0190/*::]*/: { /* n:"BrtUsr" */ },
	/*::[*/0x0191/*::]*/: { /* n:"BrtBeginUsers", */ T:1 },
	/*::[*/0x0193/*::]*/: { /* n:"BrtEOF" */ },
	/*::[*/0x0194/*::]*/: { /* n:"BrtUCR" */ },
	/*::[*/0x0195/*::]*/: { /* n:"BrtRRInsDel" */ },
	/*::[*/0x0196/*::]*/: { /* n:"BrtRREndInsDel" */ },
	/*::[*/0x0197/*::]*/: { /* n:"BrtRRMove" */ },
	/*::[*/0x0198/*::]*/: { /* n:"BrtRREndMove" */ },
	/*::[*/0x0199/*::]*/: { /* n:"BrtRRChgCell" */ },
	/*::[*/0x019A/*::]*/: { /* n:"BrtRREndChgCell" */ },
	/*::[*/0x019B/*::]*/: { /* n:"BrtRRHeader" */ },
	/*::[*/0x019C/*::]*/: { /* n:"BrtRRUserView" */ },
	/*::[*/0x019D/*::]*/: { /* n:"BrtRRRenSheet" */ },
	/*::[*/0x019E/*::]*/: { /* n:"BrtRRInsertSh" */ },
	/*::[*/0x019F/*::]*/: { /* n:"BrtRRDefName" */ },
	/*::[*/0x01A0/*::]*/: { /* n:"BrtRRNote" */ },
	/*::[*/0x01A1/*::]*/: { /* n:"BrtRRConflict" */ },
	/*::[*/0x01A2/*::]*/: { /* n:"BrtRRTQSIF" */ },
	/*::[*/0x01A3/*::]*/: { /* n:"BrtRRFormat" */ },
	/*::[*/0x01A4/*::]*/: { /* n:"BrtRREndFormat" */ },
	/*::[*/0x01A5/*::]*/: { /* n:"BrtRRAutoFmt" */ },
	/*::[*/0x01A6/*::]*/: { /* n:"BrtBeginUserShViews", */ T:1 },
	/*::[*/0x01A7/*::]*/: { /* n:"BrtBeginUserShView", */ T:1 },
	/*::[*/0x01A8/*::]*/: { /* n:"BrtEndUserShView", */ T:-1 },
	/*::[*/0x01A9/*::]*/: { /* n:"BrtEndUserShViews", */ T:-1 },
	/*::[*/0x01AA/*::]*/: { /* n:"BrtArrFmla", */ f:parse_BrtArrFmla },
	/*::[*/0x01AB/*::]*/: { /* n:"BrtShrFmla", */ f:parse_BrtShrFmla },
	/*::[*/0x01AC/*::]*/: { /* n:"BrtTable" */ },
	/*::[*/0x01AD/*::]*/: { /* n:"BrtBeginExtConnections", */ T:1 },
	/*::[*/0x01AE/*::]*/: { /* n:"BrtEndExtConnections", */ T:-1 },
	/*::[*/0x01AF/*::]*/: { /* n:"BrtBeginPCDCalcMems", */ T:1 },
	/*::[*/0x01B0/*::]*/: { /* n:"BrtEndPCDCalcMems", */ T:-1 },
	/*::[*/0x01B1/*::]*/: { /* n:"BrtBeginPCDCalcMem", */ T:1 },
	/*::[*/0x01B2/*::]*/: { /* n:"BrtEndPCDCalcMem", */ T:-1 },
	/*::[*/0x01B3/*::]*/: { /* n:"BrtBeginPCDHGLevels", */ T:1 },
	/*::[*/0x01B4/*::]*/: { /* n:"BrtEndPCDHGLevels", */ T:-1 },
	/*::[*/0x01B5/*::]*/: { /* n:"BrtBeginPCDHGLevel", */ T:1 },
	/*::[*/0x01B6/*::]*/: { /* n:"BrtEndPCDHGLevel", */ T:-1 },
	/*::[*/0x01B7/*::]*/: { /* n:"BrtBeginPCDHGLGroups", */ T:1 },
	/*::[*/0x01B8/*::]*/: { /* n:"BrtEndPCDHGLGroups", */ T:-1 },
	/*::[*/0x01B9/*::]*/: { /* n:"BrtBeginPCDHGLGroup", */ T:1 },
	/*::[*/0x01BA/*::]*/: { /* n:"BrtEndPCDHGLGroup", */ T:-1 },
	/*::[*/0x01BB/*::]*/: { /* n:"BrtBeginPCDHGLGMembers", */ T:1 },
	/*::[*/0x01BC/*::]*/: { /* n:"BrtEndPCDHGLGMembers", */ T:-1 },
	/*::[*/0x01BD/*::]*/: { /* n:"BrtBeginPCDHGLGMember", */ T:1 },
	/*::[*/0x01BE/*::]*/: { /* n:"BrtEndPCDHGLGMember", */ T:-1 },
	/*::[*/0x01BF/*::]*/: { /* n:"BrtBeginQSI", */ T:1 },
	/*::[*/0x01C0/*::]*/: { /* n:"BrtEndQSI", */ T:-1 },
	/*::[*/0x01C1/*::]*/: { /* n:"BrtBeginQSIR", */ T:1 },
	/*::[*/0x01C2/*::]*/: { /* n:"BrtEndQSIR", */ T:-1 },
	/*::[*/0x01C3/*::]*/: { /* n:"BrtBeginDeletedNames", */ T:1 },
	/*::[*/0x01C4/*::]*/: { /* n:"BrtEndDeletedNames", */ T:-1 },
	/*::[*/0x01C5/*::]*/: { /* n:"BrtBeginDeletedName", */ T:1 },
	/*::[*/0x01C6/*::]*/: { /* n:"BrtEndDeletedName", */ T:-1 },
	/*::[*/0x01C7/*::]*/: { /* n:"BrtBeginQSIFs", */ T:1 },
	/*::[*/0x01C8/*::]*/: { /* n:"BrtEndQSIFs", */ T:-1 },
	/*::[*/0x01C9/*::]*/: { /* n:"BrtBeginQSIF", */ T:1 },
	/*::[*/0x01CA/*::]*/: { /* n:"BrtEndQSIF", */ T:-1 },
	/*::[*/0x01CB/*::]*/: { /* n:"BrtBeginAutoSortScope", */ T:1 },
	/*::[*/0x01CC/*::]*/: { /* n:"BrtEndAutoSortScope", */ T:-1 },
	/*::[*/0x01CD/*::]*/: { /* n:"BrtBeginConditionalFormatting", */ T:1 },
	/*::[*/0x01CE/*::]*/: { /* n:"BrtEndConditionalFormatting", */ T:-1 },
	/*::[*/0x01CF/*::]*/: { /* n:"BrtBeginCFRule", */ T:1 },
	/*::[*/0x01D0/*::]*/: { /* n:"BrtEndCFRule", */ T:-1 },
	/*::[*/0x01D1/*::]*/: { /* n:"BrtBeginIconSet", */ T:1 },
	/*::[*/0x01D2/*::]*/: { /* n:"BrtEndIconSet", */ T:-1 },
	/*::[*/0x01D3/*::]*/: { /* n:"BrtBeginDatabar", */ T:1 },
	/*::[*/0x01D4/*::]*/: { /* n:"BrtEndDatabar", */ T:-1 },
	/*::[*/0x01D5/*::]*/: { /* n:"BrtBeginColorScale", */ T:1 },
	/*::[*/0x01D6/*::]*/: { /* n:"BrtEndColorScale", */ T:-1 },
	/*::[*/0x01D7/*::]*/: { /* n:"BrtCFVO" */ },
	/*::[*/0x01D8/*::]*/: { /* n:"BrtExternValueMeta" */ },
	/*::[*/0x01D9/*::]*/: { /* n:"BrtBeginColorPalette", */ T:1 },
	/*::[*/0x01DA/*::]*/: { /* n:"BrtEndColorPalette", */ T:-1 },
	/*::[*/0x01DB/*::]*/: { /* n:"BrtIndexedColor" */ },
	/*::[*/0x01DC/*::]*/: { /* n:"BrtMargins", */ f:parse_BrtMargins },
	/*::[*/0x01DD/*::]*/: { /* n:"BrtPrintOptions" */ },
	/*::[*/0x01DE/*::]*/: { /* n:"BrtPageSetup" */ },
	/*::[*/0x01DF/*::]*/: { /* n:"BrtBeginHeaderFooter", */ T:1 },
	/*::[*/0x01E0/*::]*/: { /* n:"BrtEndHeaderFooter", */ T:-1 },
	/*::[*/0x01E1/*::]*/: { /* n:"BrtBeginSXCrtFormat", */ T:1 },
	/*::[*/0x01E2/*::]*/: { /* n:"BrtEndSXCrtFormat", */ T:-1 },
	/*::[*/0x01E3/*::]*/: { /* n:"BrtBeginSXCrtFormats", */ T:1 },
	/*::[*/0x01E4/*::]*/: { /* n:"BrtEndSXCrtFormats", */ T:-1 },
	/*::[*/0x01E5/*::]*/: { /* n:"BrtWsFmtInfo", */ f:parse_BrtWsFmtInfo },
	/*::[*/0x01E6/*::]*/: { /* n:"BrtBeginMgs", */ T:1 },
	/*::[*/0x01E7/*::]*/: { /* n:"BrtEndMGs", */ T:-1 },
	/*::[*/0x01E8/*::]*/: { /* n:"BrtBeginMGMaps", */ T:1 },
	/*::[*/0x01E9/*::]*/: { /* n:"BrtEndMGMaps", */ T:-1 },
	/*::[*/0x01EA/*::]*/: { /* n:"BrtBeginMG", */ T:1 },
	/*::[*/0x01EB/*::]*/: { /* n:"BrtEndMG", */ T:-1 },
	/*::[*/0x01EC/*::]*/: { /* n:"BrtBeginMap", */ T:1 },
	/*::[*/0x01ED/*::]*/: { /* n:"BrtEndMap", */ T:-1 },
	/*::[*/0x01EE/*::]*/: { /* n:"BrtHLink", */ f:parse_BrtHLink },
	/*::[*/0x01EF/*::]*/: { /* n:"BrtBeginDCon", */ T:1 },
	/*::[*/0x01F0/*::]*/: { /* n:"BrtEndDCon", */ T:-1 },
	/*::[*/0x01F1/*::]*/: { /* n:"BrtBeginDRefs", */ T:1 },
	/*::[*/0x01F2/*::]*/: { /* n:"BrtEndDRefs", */ T:-1 },
	/*::[*/0x01F3/*::]*/: { /* n:"BrtDRef" */ },
	/*::[*/0x01F4/*::]*/: { /* n:"BrtBeginScenMan", */ T:1 },
	/*::[*/0x01F5/*::]*/: { /* n:"BrtEndScenMan", */ T:-1 },
	/*::[*/0x01F6/*::]*/: { /* n:"BrtBeginSct", */ T:1 },
	/*::[*/0x01F7/*::]*/: { /* n:"BrtEndSct", */ T:-1 },
	/*::[*/0x01F8/*::]*/: { /* n:"BrtSlc" */ },
	/*::[*/0x01F9/*::]*/: { /* n:"BrtBeginDXFs", */ T:1 },
	/*::[*/0x01FA/*::]*/: { /* n:"BrtEndDXFs", */ T:-1 },
	/*::[*/0x01FB/*::]*/: { /* n:"BrtDXF" */ },
	/*::[*/0x01FC/*::]*/: { /* n:"BrtBeginTableStyles", */ T:1 },
	/*::[*/0x01FD/*::]*/: { /* n:"BrtEndTableStyles", */ T:-1 },
	/*::[*/0x01FE/*::]*/: { /* n:"BrtBeginTableStyle", */ T:1 },
	/*::[*/0x01FF/*::]*/: { /* n:"BrtEndTableStyle", */ T:-1 },
	/*::[*/0x0200/*::]*/: { /* n:"BrtTableStyleElement" */ },
	/*::[*/0x0201/*::]*/: { /* n:"BrtTableStyleClient" */ },
	/*::[*/0x0202/*::]*/: { /* n:"BrtBeginVolDeps", */ T:1 },
	/*::[*/0x0203/*::]*/: { /* n:"BrtEndVolDeps", */ T:-1 },
	/*::[*/0x0204/*::]*/: { /* n:"BrtBeginVolType", */ T:1 },
	/*::[*/0x0205/*::]*/: { /* n:"BrtEndVolType", */ T:-1 },
	/*::[*/0x0206/*::]*/: { /* n:"BrtBeginVolMain", */ T:1 },
	/*::[*/0x0207/*::]*/: { /* n:"BrtEndVolMain", */ T:-1 },
	/*::[*/0x0208/*::]*/: { /* n:"BrtBeginVolTopic", */ T:1 },
	/*::[*/0x0209/*::]*/: { /* n:"BrtEndVolTopic", */ T:-1 },
	/*::[*/0x020A/*::]*/: { /* n:"BrtVolSubtopic" */ },
	/*::[*/0x020B/*::]*/: { /* n:"BrtVolRef" */ },
	/*::[*/0x020C/*::]*/: { /* n:"BrtVolNum" */ },
	/*::[*/0x020D/*::]*/: { /* n:"BrtVolErr" */ },
	/*::[*/0x020E/*::]*/: { /* n:"BrtVolStr" */ },
	/*::[*/0x020F/*::]*/: { /* n:"BrtVolBool" */ },
	/*::[*/0x0210/*::]*/: { /* n:"BrtBeginCalcChain$", */ T:1 },
	/*::[*/0x0211/*::]*/: { /* n:"BrtEndCalcChain$", */ T:-1 },
	/*::[*/0x0212/*::]*/: { /* n:"BrtBeginSortState", */ T:1 },
	/*::[*/0x0213/*::]*/: { /* n:"BrtEndSortState", */ T:-1 },
	/*::[*/0x0214/*::]*/: { /* n:"BrtBeginSortCond", */ T:1 },
	/*::[*/0x0215/*::]*/: { /* n:"BrtEndSortCond", */ T:-1 },
	/*::[*/0x0216/*::]*/: { /* n:"BrtBookProtection" */ },
	/*::[*/0x0217/*::]*/: { /* n:"BrtSheetProtection" */ },
	/*::[*/0x0218/*::]*/: { /* n:"BrtRangeProtection" */ },
	/*::[*/0x0219/*::]*/: { /* n:"BrtPhoneticInfo" */ },
	/*::[*/0x021A/*::]*/: { /* n:"BrtBeginECTxtWiz", */ T:1 },
	/*::[*/0x021B/*::]*/: { /* n:"BrtEndECTxtWiz", */ T:-1 },
	/*::[*/0x021C/*::]*/: { /* n:"BrtBeginECTWFldInfoLst", */ T:1 },
	/*::[*/0x021D/*::]*/: { /* n:"BrtEndECTWFldInfoLst", */ T:-1 },
	/*::[*/0x021E/*::]*/: { /* n:"BrtBeginECTwFldInfo", */ T:1 },
	/*::[*/0x0224/*::]*/: { /* n:"BrtFileSharing" */ },
	/*::[*/0x0225/*::]*/: { /* n:"BrtOleSize" */ },
	/*::[*/0x0226/*::]*/: { /* n:"BrtDrawing", */ f:parse_RelID },
	/*::[*/0x0227/*::]*/: { /* n:"BrtLegacyDrawing" */ },
	/*::[*/0x0228/*::]*/: { /* n:"BrtLegacyDrawingHF" */ },
	/*::[*/0x0229/*::]*/: { /* n:"BrtWebOpt" */ },
	/*::[*/0x022A/*::]*/: { /* n:"BrtBeginWebPubItems", */ T:1 },
	/*::[*/0x022B/*::]*/: { /* n:"BrtEndWebPubItems", */ T:-1 },
	/*::[*/0x022C/*::]*/: { /* n:"BrtBeginWebPubItem", */ T:1 },
	/*::[*/0x022D/*::]*/: { /* n:"BrtEndWebPubItem", */ T:-1 },
	/*::[*/0x022E/*::]*/: { /* n:"BrtBeginSXCondFmt", */ T:1 },
	/*::[*/0x022F/*::]*/: { /* n:"BrtEndSXCondFmt", */ T:-1 },
	/*::[*/0x0230/*::]*/: { /* n:"BrtBeginSXCondFmts", */ T:1 },
	/*::[*/0x0231/*::]*/: { /* n:"BrtEndSXCondFmts", */ T:-1 },
	/*::[*/0x0232/*::]*/: { /* n:"BrtBkHim" */ },
	/*::[*/0x0234/*::]*/: { /* n:"BrtColor" */ },
	/*::[*/0x0235/*::]*/: { /* n:"BrtBeginIndexedColors", */ T:1 },
	/*::[*/0x0236/*::]*/: { /* n:"BrtEndIndexedColors", */ T:-1 },
	/*::[*/0x0239/*::]*/: { /* n:"BrtBeginMRUColors", */ T:1 },
	/*::[*/0x023A/*::]*/: { /* n:"BrtEndMRUColors", */ T:-1 },
	/*::[*/0x023C/*::]*/: { /* n:"BrtMRUColor" */ },
	/*::[*/0x023D/*::]*/: { /* n:"BrtBeginDVals", */ T:1 },
	/*::[*/0x023E/*::]*/: { /* n:"BrtEndDVals", */ T:-1 },
	/*::[*/0x0241/*::]*/: { /* n:"BrtSupNameStart" */ },
	/*::[*/0x0242/*::]*/: { /* n:"BrtSupNameValueStart" */ },
	/*::[*/0x0243/*::]*/: { /* n:"BrtSupNameValueEnd" */ },
	/*::[*/0x0244/*::]*/: { /* n:"BrtSupNameNum" */ },
	/*::[*/0x0245/*::]*/: { /* n:"BrtSupNameErr" */ },
	/*::[*/0x0246/*::]*/: { /* n:"BrtSupNameSt" */ },
	/*::[*/0x0247/*::]*/: { /* n:"BrtSupNameNil" */ },
	/*::[*/0x0248/*::]*/: { /* n:"BrtSupNameBool" */ },
	/*::[*/0x0249/*::]*/: { /* n:"BrtSupNameFmla" */ },
	/*::[*/0x024A/*::]*/: { /* n:"BrtSupNameBits" */ },
	/*::[*/0x024B/*::]*/: { /* n:"BrtSupNameEnd" */ },
	/*::[*/0x024C/*::]*/: { /* n:"BrtEndSupBook", */ T:-1 },
	/*::[*/0x024D/*::]*/: { /* n:"BrtCellSmartTagProperty" */ },
	/*::[*/0x024E/*::]*/: { /* n:"BrtBeginCellSmartTag", */ T:1 },
	/*::[*/0x024F/*::]*/: { /* n:"BrtEndCellSmartTag", */ T:-1 },
	/*::[*/0x0250/*::]*/: { /* n:"BrtBeginCellSmartTags", */ T:1 },
	/*::[*/0x0251/*::]*/: { /* n:"BrtEndCellSmartTags", */ T:-1 },
	/*::[*/0x0252/*::]*/: { /* n:"BrtBeginSmartTags", */ T:1 },
	/*::[*/0x0253/*::]*/: { /* n:"BrtEndSmartTags", */ T:-1 },
	/*::[*/0x0254/*::]*/: { /* n:"BrtSmartTagType" */ },
	/*::[*/0x0255/*::]*/: { /* n:"BrtBeginSmartTagTypes", */ T:1 },
	/*::[*/0x0256/*::]*/: { /* n:"BrtEndSmartTagTypes", */ T:-1 },
	/*::[*/0x0257/*::]*/: { /* n:"BrtBeginSXFilters", */ T:1 },
	/*::[*/0x0258/*::]*/: { /* n:"BrtEndSXFilters", */ T:-1 },
	/*::[*/0x0259/*::]*/: { /* n:"BrtBeginSXFILTER", */ T:1 },
	/*::[*/0x025A/*::]*/: { /* n:"BrtEndSXFilter", */ T:-1 },
	/*::[*/0x025B/*::]*/: { /* n:"BrtBeginFills", */ T:1 },
	/*::[*/0x025C/*::]*/: { /* n:"BrtEndFills", */ T:-1 },
	/*::[*/0x025D/*::]*/: { /* n:"BrtBeginCellWatches", */ T:1 },
	/*::[*/0x025E/*::]*/: { /* n:"BrtEndCellWatches", */ T:-1 },
	/*::[*/0x025F/*::]*/: { /* n:"BrtCellWatch" */ },
	/*::[*/0x0260/*::]*/: { /* n:"BrtBeginCRErrs", */ T:1 },
	/*::[*/0x0261/*::]*/: { /* n:"BrtEndCRErrs", */ T:-1 },
	/*::[*/0x0262/*::]*/: { /* n:"BrtCrashRecErr" */ },
	/*::[*/0x0263/*::]*/: { /* n:"BrtBeginFonts", */ T:1 },
	/*::[*/0x0264/*::]*/: { /* n:"BrtEndFonts", */ T:-1 },
	/*::[*/0x0265/*::]*/: { /* n:"BrtBeginBorders", */ T:1 },
	/*::[*/0x0266/*::]*/: { /* n:"BrtEndBorders", */ T:-1 },
	/*::[*/0x0267/*::]*/: { /* n:"BrtBeginFmts", */ T:1 },
	/*::[*/0x0268/*::]*/: { /* n:"BrtEndFmts", */ T:-1 },
	/*::[*/0x0269/*::]*/: { /* n:"BrtBeginCellXFs", */ T:1 },
	/*::[*/0x026A/*::]*/: { /* n:"BrtEndCellXFs", */ T:-1 },
	/*::[*/0x026B/*::]*/: { /* n:"BrtBeginStyles", */ T:1 },
	/*::[*/0x026C/*::]*/: { /* n:"BrtEndStyles", */ T:-1 },
	/*::[*/0x0271/*::]*/: { /* n:"BrtBigName" */ },
	/*::[*/0x0272/*::]*/: { /* n:"BrtBeginCellStyleXFs", */ T:1 },
	/*::[*/0x0273/*::]*/: { /* n:"BrtEndCellStyleXFs", */ T:-1 },
	/*::[*/0x0274/*::]*/: { /* n:"BrtBeginComments", */ T:1 },
	/*::[*/0x0275/*::]*/: { /* n:"BrtEndComments", */ T:-1 },
	/*::[*/0x0276/*::]*/: { /* n:"BrtBeginCommentAuthors", */ T:1 },
	/*::[*/0x0277/*::]*/: { /* n:"BrtEndCommentAuthors", */ T:-1 },
	/*::[*/0x0278/*::]*/: { /* n:"BrtCommentAuthor", */ f:parse_BrtCommentAuthor },
	/*::[*/0x0279/*::]*/: { /* n:"BrtBeginCommentList", */ T:1 },
	/*::[*/0x027A/*::]*/: { /* n:"BrtEndCommentList", */ T:-1 },
	/*::[*/0x027B/*::]*/: { /* n:"BrtBeginComment", */ T:1, f:parse_BrtBeginComment},
	/*::[*/0x027C/*::]*/: { /* n:"BrtEndComment", */ T:-1 },
	/*::[*/0x027D/*::]*/: { /* n:"BrtCommentText", */ f:parse_BrtCommentText },
	/*::[*/0x027E/*::]*/: { /* n:"BrtBeginOleObjects", */ T:1 },
	/*::[*/0x027F/*::]*/: { /* n:"BrtOleObject" */ },
	/*::[*/0x0280/*::]*/: { /* n:"BrtEndOleObjects", */ T:-1 },
	/*::[*/0x0281/*::]*/: { /* n:"BrtBeginSxrules", */ T:1 },
	/*::[*/0x0282/*::]*/: { /* n:"BrtEndSxRules", */ T:-1 },
	/*::[*/0x0283/*::]*/: { /* n:"BrtBeginActiveXControls", */ T:1 },
	/*::[*/0x0284/*::]*/: { /* n:"BrtActiveX" */ },
	/*::[*/0x0285/*::]*/: { /* n:"BrtEndActiveXControls", */ T:-1 },
	/*::[*/0x0286/*::]*/: { /* n:"BrtBeginPCDSDTCEMembersSortBy", */ T:1 },
	/*::[*/0x0288/*::]*/: { /* n:"BrtBeginCellIgnoreECs", */ T:1 },
	/*::[*/0x0289/*::]*/: { /* n:"BrtCellIgnoreEC" */ },
	/*::[*/0x028A/*::]*/: { /* n:"BrtEndCellIgnoreECs", */ T:-1 },
	/*::[*/0x028B/*::]*/: { /* n:"BrtCsProp", */ f:parse_BrtCsProp },
	/*::[*/0x028C/*::]*/: { /* n:"BrtCsPageSetup" */ },
	/*::[*/0x028D/*::]*/: { /* n:"BrtBeginUserCsViews", */ T:1 },
	/*::[*/0x028E/*::]*/: { /* n:"BrtEndUserCsViews", */ T:-1 },
	/*::[*/0x028F/*::]*/: { /* n:"BrtBeginUserCsView", */ T:1 },
	/*::[*/0x0290/*::]*/: { /* n:"BrtEndUserCsView", */ T:-1 },
	/*::[*/0x0291/*::]*/: { /* n:"BrtBeginPcdSFCIEntries", */ T:1 },
	/*::[*/0x0292/*::]*/: { /* n:"BrtEndPCDSFCIEntries", */ T:-1 },
	/*::[*/0x0293/*::]*/: { /* n:"BrtPCDSFCIEntry" */ },
	/*::[*/0x0294/*::]*/: { /* n:"BrtBeginListParts", */ T:1 },
	/*::[*/0x0295/*::]*/: { /* n:"BrtListPart" */ },
	/*::[*/0x0296/*::]*/: { /* n:"BrtEndListParts", */ T:-1 },
	/*::[*/0x0297/*::]*/: { /* n:"BrtSheetCalcProp" */ },
	/*::[*/0x0298/*::]*/: { /* n:"BrtBeginFnGroup", */ T:1 },
	/*::[*/0x0299/*::]*/: { /* n:"BrtFnGroup" */ },
	/*::[*/0x029A/*::]*/: { /* n:"BrtEndFnGroup", */ T:-1 },
	/*::[*/0x029B/*::]*/: { /* n:"BrtSupAddin" */ },
	/*::[*/0x029C/*::]*/: { /* n:"BrtSXTDMPOrder" */ },
	/*::[*/0x029D/*::]*/: { /* n:"BrtCsProtection" */ },
	/*::[*/0x029F/*::]*/: { /* n:"BrtBeginWsSortMap", */ T:1 },
	/*::[*/0x02A0/*::]*/: { /* n:"BrtEndWsSortMap", */ T:-1 },
	/*::[*/0x02A1/*::]*/: { /* n:"BrtBeginRRSort", */ T:1 },
	/*::[*/0x02A2/*::]*/: { /* n:"BrtEndRRSort", */ T:-1 },
	/*::[*/0x02A3/*::]*/: { /* n:"BrtRRSortItem" */ },
	/*::[*/0x02A4/*::]*/: { /* n:"BrtFileSharingIso" */ },
	/*::[*/0x02A5/*::]*/: { /* n:"BrtBookProtectionIso" */ },
	/*::[*/0x02A6/*::]*/: { /* n:"BrtSheetProtectionIso" */ },
	/*::[*/0x02A7/*::]*/: { /* n:"BrtCsProtectionIso" */ },
	/*::[*/0x02A8/*::]*/: { /* n:"BrtRangeProtectionIso" */ },
	/*::[*/0x02A9/*::]*/: { /* n:"BrtDValList" */ },
	/*::[*/0x0400/*::]*/: { /* n:"BrtRwDescent" */ },
	/*::[*/0x0401/*::]*/: { /* n:"BrtKnownFonts" */ },
	/*::[*/0x0402/*::]*/: { /* n:"BrtBeginSXTupleSet", */ T:1 },
	/*::[*/0x0403/*::]*/: { /* n:"BrtEndSXTupleSet", */ T:-1 },
	/*::[*/0x0404/*::]*/: { /* n:"BrtBeginSXTupleSetHeader", */ T:1 },
	/*::[*/0x0405/*::]*/: { /* n:"BrtEndSXTupleSetHeader", */ T:-1 },
	/*::[*/0x0406/*::]*/: { /* n:"BrtSXTupleSetHeaderItem" */ },
	/*::[*/0x0407/*::]*/: { /* n:"BrtBeginSXTupleSetData", */ T:1 },
	/*::[*/0x0408/*::]*/: { /* n:"BrtEndSXTupleSetData", */ T:-1 },
	/*::[*/0x0409/*::]*/: { /* n:"BrtBeginSXTupleSetRow", */ T:1 },
	/*::[*/0x040A/*::]*/: { /* n:"BrtEndSXTupleSetRow", */ T:-1 },
	/*::[*/0x040B/*::]*/: { /* n:"BrtSXTupleSetRowItem" */ },
	/*::[*/0x040C/*::]*/: { /* n:"BrtNameExt" */ },
	/*::[*/0x040D/*::]*/: { /* n:"BrtPCDH14" */ },
	/*::[*/0x040E/*::]*/: { /* n:"BrtBeginPCDCalcMem14", */ T:1 },
	/*::[*/0x040F/*::]*/: { /* n:"BrtEndPCDCalcMem14", */ T:-1 },
	/*::[*/0x0410/*::]*/: { /* n:"BrtSXTH14" */ },
	/*::[*/0x0411/*::]*/: { /* n:"BrtBeginSparklineGroup", */ T:1 },
	/*::[*/0x0412/*::]*/: { /* n:"BrtEndSparklineGroup", */ T:-1 },
	/*::[*/0x0413/*::]*/: { /* n:"BrtSparkline" */ },
	/*::[*/0x0414/*::]*/: { /* n:"BrtSXDI14" */ },
	/*::[*/0x0415/*::]*/: { /* n:"BrtWsFmtInfoEx14" */ },
	/*::[*/0x0416/*::]*/: { /* n:"BrtBeginConditionalFormatting14", */ T:1 },
	/*::[*/0x0417/*::]*/: { /* n:"BrtEndConditionalFormatting14", */ T:-1 },
	/*::[*/0x0418/*::]*/: { /* n:"BrtBeginCFRule14", */ T:1 },
	/*::[*/0x0419/*::]*/: { /* n:"BrtEndCFRule14", */ T:-1 },
	/*::[*/0x041A/*::]*/: { /* n:"BrtCFVO14" */ },
	/*::[*/0x041B/*::]*/: { /* n:"BrtBeginDatabar14", */ T:1 },
	/*::[*/0x041C/*::]*/: { /* n:"BrtBeginIconSet14", */ T:1 },
	/*::[*/0x041D/*::]*/: { /* n:"BrtDVal14", */ f: parse_BrtDVal14 },
	/*::[*/0x041E/*::]*/: { /* n:"BrtBeginDVals14", */ T:1 },
	/*::[*/0x041F/*::]*/: { /* n:"BrtColor14" */ },
	/*::[*/0x0420/*::]*/: { /* n:"BrtBeginSparklines", */ T:1 },
	/*::[*/0x0421/*::]*/: { /* n:"BrtEndSparklines", */ T:-1 },
	/*::[*/0x0422/*::]*/: { /* n:"BrtBeginSparklineGroups", */ T:1 },
	/*::[*/0x0423/*::]*/: { /* n:"BrtEndSparklineGroups", */ T:-1 },
	/*::[*/0x0425/*::]*/: { /* n:"BrtSXVD14" */ },
	/*::[*/0x0426/*::]*/: { /* n:"BrtBeginSXView14", */ T:1 },
	/*::[*/0x0427/*::]*/: { /* n:"BrtEndSXView14", */ T:-1 },
	/*::[*/0x0428/*::]*/: { /* n:"BrtBeginSXView16", */ T:1 },
	/*::[*/0x0429/*::]*/: { /* n:"BrtEndSXView16", */ T:-1 },
	/*::[*/0x042A/*::]*/: { /* n:"BrtBeginPCD14", */ T:1 },
	/*::[*/0x042B/*::]*/: { /* n:"BrtEndPCD14", */ T:-1 },
	/*::[*/0x042C/*::]*/: { /* n:"BrtBeginExtConn14", */ T:1 },
	/*::[*/0x042D/*::]*/: { /* n:"BrtEndExtConn14", */ T:-1 },
	/*::[*/0x042E/*::]*/: { /* n:"BrtBeginSlicerCacheIDs", */ T:1 },
	/*::[*/0x042F/*::]*/: { /* n:"BrtEndSlicerCacheIDs", */ T:-1 },
	/*::[*/0x0430/*::]*/: { /* n:"BrtBeginSlicerCacheID", */ T:1 },
	/*::[*/0x0431/*::]*/: { /* n:"BrtEndSlicerCacheID", */ T:-1 },
	/*::[*/0x0433/*::]*/: { /* n:"BrtBeginSlicerCache", */ T:1 },
	/*::[*/0x0434/*::]*/: { /* n:"BrtEndSlicerCache", */ T:-1 },
	/*::[*/0x0435/*::]*/: { /* n:"BrtBeginSlicerCacheDef", */ T:1 },
	/*::[*/0x0436/*::]*/: { /* n:"BrtEndSlicerCacheDef", */ T:-1 },
	/*::[*/0x0437/*::]*/: { /* n:"BrtBeginSlicersEx", */ T:1 },
	/*::[*/0x0438/*::]*/: { /* n:"BrtEndSlicersEx", */ T:-1 },
	/*::[*/0x0439/*::]*/: { /* n:"BrtBeginSlicerEx", */ T:1 },
	/*::[*/0x043A/*::]*/: { /* n:"BrtEndSlicerEx", */ T:-1 },
	/*::[*/0x043B/*::]*/: { /* n:"BrtBeginSlicer", */ T:1 },
	/*::[*/0x043C/*::]*/: { /* n:"BrtEndSlicer", */ T:-1 },
	/*::[*/0x043D/*::]*/: { /* n:"BrtSlicerCachePivotTables" */ },
	/*::[*/0x043E/*::]*/: { /* n:"BrtBeginSlicerCacheOlapImpl", */ T:1 },
	/*::[*/0x043F/*::]*/: { /* n:"BrtEndSlicerCacheOlapImpl", */ T:-1 },
	/*::[*/0x0440/*::]*/: { /* n:"BrtBeginSlicerCacheLevelsData", */ T:1 },
	/*::[*/0x0441/*::]*/: { /* n:"BrtEndSlicerCacheLevelsData", */ T:-1 },
	/*::[*/0x0442/*::]*/: { /* n:"BrtBeginSlicerCacheLevelData", */ T:1 },
	/*::[*/0x0443/*::]*/: { /* n:"BrtEndSlicerCacheLevelData", */ T:-1 },
	/*::[*/0x0444/*::]*/: { /* n:"BrtBeginSlicerCacheSiRanges", */ T:1 },
	/*::[*/0x0445/*::]*/: { /* n:"BrtEndSlicerCacheSiRanges", */ T:-1 },
	/*::[*/0x0446/*::]*/: { /* n:"BrtBeginSlicerCacheSiRange", */ T:1 },
	/*::[*/0x0447/*::]*/: { /* n:"BrtEndSlicerCacheSiRange", */ T:-1 },
	/*::[*/0x0448/*::]*/: { /* n:"BrtSlicerCacheOlapItem" */ },
	/*::[*/0x0449/*::]*/: { /* n:"BrtBeginSlicerCacheSelections", */ T:1 },
	/*::[*/0x044A/*::]*/: { /* n:"BrtSlicerCacheSelection" */ },
	/*::[*/0x044B/*::]*/: { /* n:"BrtEndSlicerCacheSelections", */ T:-1 },
	/*::[*/0x044C/*::]*/: { /* n:"BrtBeginSlicerCacheNative", */ T:1 },
	/*::[*/0x044D/*::]*/: { /* n:"BrtEndSlicerCacheNative", */ T:-1 },
	/*::[*/0x044E/*::]*/: { /* n:"BrtSlicerCacheNativeItem" */ },
	/*::[*/0x044F/*::]*/: { /* n:"BrtRangeProtection14" */ },
	/*::[*/0x0450/*::]*/: { /* n:"BrtRangeProtectionIso14" */ },
	/*::[*/0x0451/*::]*/: { /* n:"BrtCellIgnoreEC14" */ },
	/*::[*/0x0457/*::]*/: { /* n:"BrtList14" */ },
	/*::[*/0x0458/*::]*/: { /* n:"BrtCFIcon" */ },
	/*::[*/0x0459/*::]*/: { /* n:"BrtBeginSlicerCachesPivotCacheIDs", */ T:1 },
	/*::[*/0x045A/*::]*/: { /* n:"BrtEndSlicerCachesPivotCacheIDs", */ T:-1 },
	/*::[*/0x045B/*::]*/: { /* n:"BrtBeginSlicers", */ T:1 },
	/*::[*/0x045C/*::]*/: { /* n:"BrtEndSlicers", */ T:-1 },
	/*::[*/0x045D/*::]*/: { /* n:"BrtWbProp14" */ },
	/*::[*/0x045E/*::]*/: { /* n:"BrtBeginSXEdit", */ T:1 },
	/*::[*/0x045F/*::]*/: { /* n:"BrtEndSXEdit", */ T:-1 },
	/*::[*/0x0460/*::]*/: { /* n:"BrtBeginSXEdits", */ T:1 },
	/*::[*/0x0461/*::]*/: { /* n:"BrtEndSXEdits", */ T:-1 },
	/*::[*/0x0462/*::]*/: { /* n:"BrtBeginSXChange", */ T:1 },
	/*::[*/0x0463/*::]*/: { /* n:"BrtEndSXChange", */ T:-1 },
	/*::[*/0x0464/*::]*/: { /* n:"BrtBeginSXChanges", */ T:1 },
	/*::[*/0x0465/*::]*/: { /* n:"BrtEndSXChanges", */ T:-1 },
	/*::[*/0x0466/*::]*/: { /* n:"BrtSXTupleItems" */ },
	/*::[*/0x0468/*::]*/: { /* n:"BrtBeginSlicerStyle", */ T:1 },
	/*::[*/0x0469/*::]*/: { /* n:"BrtEndSlicerStyle", */ T:-1 },
	/*::[*/0x046A/*::]*/: { /* n:"BrtSlicerStyleElement" */ },
	/*::[*/0x046B/*::]*/: { /* n:"BrtBeginStyleSheetExt14", */ T:1 },
	/*::[*/0x046C/*::]*/: { /* n:"BrtEndStyleSheetExt14", */ T:-1 },
	/*::[*/0x046D/*::]*/: { /* n:"BrtBeginSlicerCachesPivotCacheID", */ T:1 },
	/*::[*/0x046E/*::]*/: { /* n:"BrtEndSlicerCachesPivotCacheID", */ T:-1 },
	/*::[*/0x046F/*::]*/: { /* n:"BrtBeginConditionalFormattings", */ T:1 },
	/*::[*/0x0470/*::]*/: { /* n:"BrtEndConditionalFormattings", */ T:-1 },
	/*::[*/0x0471/*::]*/: { /* n:"BrtBeginPCDCalcMemExt", */ T:1 },
	/*::[*/0x0472/*::]*/: { /* n:"BrtEndPCDCalcMemExt", */ T:-1 },
	/*::[*/0x0473/*::]*/: { /* n:"BrtBeginPCDCalcMemsExt", */ T:1 },
	/*::[*/0x0474/*::]*/: { /* n:"BrtEndPCDCalcMemsExt", */ T:-1 },
	/*::[*/0x0475/*::]*/: { /* n:"BrtPCDField14" */ },
	/*::[*/0x0476/*::]*/: { /* n:"BrtBeginSlicerStyles", */ T:1 },
	/*::[*/0x0477/*::]*/: { /* n:"BrtEndSlicerStyles", */ T:-1 },
	/*::[*/0x0478/*::]*/: { /* n:"BrtBeginSlicerStyleElements", */ T:1 },
	/*::[*/0x0479/*::]*/: { /* n:"BrtEndSlicerStyleElements", */ T:-1 },
	/*::[*/0x047A/*::]*/: { /* n:"BrtCFRuleExt" */ },
	/*::[*/0x047B/*::]*/: { /* n:"BrtBeginSXCondFmt14", */ T:1 },
	/*::[*/0x047C/*::]*/: { /* n:"BrtEndSXCondFmt14", */ T:-1 },
	/*::[*/0x047D/*::]*/: { /* n:"BrtBeginSXCondFmts14", */ T:1 },
	/*::[*/0x047E/*::]*/: { /* n:"BrtEndSXCondFmts14", */ T:-1 },
	/*::[*/0x0480/*::]*/: { /* n:"BrtBeginSortCond14", */ T:1 },
	/*::[*/0x0481/*::]*/: { /* n:"BrtEndSortCond14", */ T:-1 },
	/*::[*/0x0482/*::]*/: { /* n:"BrtEndDVals14", */ T:-1 },
	/*::[*/0x0483/*::]*/: { /* n:"BrtEndIconSet14", */ T:-1 },
	/*::[*/0x0484/*::]*/: { /* n:"BrtEndDatabar14", */ T:-1 },
	/*::[*/0x0485/*::]*/: { /* n:"BrtBeginColorScale14", */ T:1 },
	/*::[*/0x0486/*::]*/: { /* n:"BrtEndColorScale14", */ T:-1 },
	/*::[*/0x0487/*::]*/: { /* n:"BrtBeginSxrules14", */ T:1 },
	/*::[*/0x0488/*::]*/: { /* n:"BrtEndSxrules14", */ T:-1 },
	/*::[*/0x0489/*::]*/: { /* n:"BrtBeginPRule14", */ T:1 },
	/*::[*/0x048A/*::]*/: { /* n:"BrtEndPRule14", */ T:-1 },
	/*::[*/0x048B/*::]*/: { /* n:"BrtBeginPRFilters14", */ T:1 },
	/*::[*/0x048C/*::]*/: { /* n:"BrtEndPRFilters14", */ T:-1 },
	/*::[*/0x048D/*::]*/: { /* n:"BrtBeginPRFilter14", */ T:1 },
	/*::[*/0x048E/*::]*/: { /* n:"BrtEndPRFilter14", */ T:-1 },
	/*::[*/0x048F/*::]*/: { /* n:"BrtBeginPRFItem14", */ T:1 },
	/*::[*/0x0490/*::]*/: { /* n:"BrtEndPRFItem14", */ T:-1 },
	/*::[*/0x0491/*::]*/: { /* n:"BrtBeginCellIgnoreECs14", */ T:1 },
	/*::[*/0x0492/*::]*/: { /* n:"BrtEndCellIgnoreECs14", */ T:-1 },
	/*::[*/0x0493/*::]*/: { /* n:"BrtDxf14" */ },
	/*::[*/0x0494/*::]*/: { /* n:"BrtBeginDxF14s", */ T:1 },
	/*::[*/0x0495/*::]*/: { /* n:"BrtEndDxf14s", */ T:-1 },
	/*::[*/0x0499/*::]*/: { /* n:"BrtFilter14" */ },
	/*::[*/0x049A/*::]*/: { /* n:"BrtBeginCustomFilters14", */ T:1 },
	/*::[*/0x049C/*::]*/: { /* n:"BrtCustomFilter14" */ },
	/*::[*/0x049D/*::]*/: { /* n:"BrtIconFilter14" */ },
	/*::[*/0x049E/*::]*/: { /* n:"BrtPivotCacheConnectionName" */ },
	/*::[*/0x0800/*::]*/: { /* n:"BrtBeginDecoupledPivotCacheIDs", */ T:1 },
	/*::[*/0x0801/*::]*/: { /* n:"BrtEndDecoupledPivotCacheIDs", */ T:-1 },
	/*::[*/0x0802/*::]*/: { /* n:"BrtDecoupledPivotCacheID" */ },
	/*::[*/0x0803/*::]*/: { /* n:"BrtBeginPivotTableRefs", */ T:1 },
	/*::[*/0x0804/*::]*/: { /* n:"BrtEndPivotTableRefs", */ T:-1 },
	/*::[*/0x0805/*::]*/: { /* n:"BrtPivotTableRef" */ },
	/*::[*/0x0806/*::]*/: { /* n:"BrtSlicerCacheBookPivotTables" */ },
	/*::[*/0x0807/*::]*/: { /* n:"BrtBeginSxvcells", */ T:1 },
	/*::[*/0x0808/*::]*/: { /* n:"BrtEndSxvcells", */ T:-1 },
	/*::[*/0x0809/*::]*/: { /* n:"BrtBeginSxRow", */ T:1 },
	/*::[*/0x080A/*::]*/: { /* n:"BrtEndSxRow", */ T:-1 },
	/*::[*/0x080C/*::]*/: { /* n:"BrtPcdCalcMem15" */ },
	/*::[*/0x0813/*::]*/: { /* n:"BrtQsi15" */ },
	/*::[*/0x0814/*::]*/: { /* n:"BrtBeginWebExtensions", */ T:1 },
	/*::[*/0x0815/*::]*/: { /* n:"BrtEndWebExtensions", */ T:-1 },
	/*::[*/0x0816/*::]*/: { /* n:"BrtWebExtension" */ },
	/*::[*/0x0817/*::]*/: { /* n:"BrtAbsPath15" */ },
	/*::[*/0x0818/*::]*/: { /* n:"BrtBeginPivotTableUISettings", */ T:1 },
	/*::[*/0x0819/*::]*/: { /* n:"BrtEndPivotTableUISettings", */ T:-1 },
	/*::[*/0x081B/*::]*/: { /* n:"BrtTableSlicerCacheIDs" */ },
	/*::[*/0x081C/*::]*/: { /* n:"BrtTableSlicerCacheID" */ },
	/*::[*/0x081D/*::]*/: { /* n:"BrtBeginTableSlicerCache", */ T:1 },
	/*::[*/0x081E/*::]*/: { /* n:"BrtEndTableSlicerCache", */ T:-1 },
	/*::[*/0x081F/*::]*/: { /* n:"BrtSxFilter15" */ },
	/*::[*/0x0820/*::]*/: { /* n:"BrtBeginTimelineCachePivotCacheIDs", */ T:1 },
	/*::[*/0x0821/*::]*/: { /* n:"BrtEndTimelineCachePivotCacheIDs", */ T:-1 },
	/*::[*/0x0822/*::]*/: { /* n:"BrtTimelineCachePivotCacheID" */ },
	/*::[*/0x0823/*::]*/: { /* n:"BrtBeginTimelineCacheIDs", */ T:1 },
	/*::[*/0x0824/*::]*/: { /* n:"BrtEndTimelineCacheIDs", */ T:-1 },
	/*::[*/0x0825/*::]*/: { /* n:"BrtBeginTimelineCacheID", */ T:1 },
	/*::[*/0x0826/*::]*/: { /* n:"BrtEndTimelineCacheID", */ T:-1 },
	/*::[*/0x0827/*::]*/: { /* n:"BrtBeginTimelinesEx", */ T:1 },
	/*::[*/0x0828/*::]*/: { /* n:"BrtEndTimelinesEx", */ T:-1 },
	/*::[*/0x0829/*::]*/: { /* n:"BrtBeginTimelineEx", */ T:1 },
	/*::[*/0x082A/*::]*/: { /* n:"BrtEndTimelineEx", */ T:-1 },
	/*::[*/0x082B/*::]*/: { /* n:"BrtWorkBookPr15" */ },
	/*::[*/0x082C/*::]*/: { /* n:"BrtPCDH15" */ },
	/*::[*/0x082D/*::]*/: { /* n:"BrtBeginTimelineStyle", */ T:1 },
	/*::[*/0x082E/*::]*/: { /* n:"BrtEndTimelineStyle", */ T:-1 },
	/*::[*/0x082F/*::]*/: { /* n:"BrtTimelineStyleElement" */ },
	/*::[*/0x0830/*::]*/: { /* n:"BrtBeginTimelineStylesheetExt15", */ T:1 },
	/*::[*/0x0831/*::]*/: { /* n:"BrtEndTimelineStylesheetExt15", */ T:-1 },
	/*::[*/0x0832/*::]*/: { /* n:"BrtBeginTimelineStyles", */ T:1 },
	/*::[*/0x0833/*::]*/: { /* n:"BrtEndTimelineStyles", */ T:-1 },
	/*::[*/0x0834/*::]*/: { /* n:"BrtBeginTimelineStyleElements", */ T:1 },
	/*::[*/0x0835/*::]*/: { /* n:"BrtEndTimelineStyleElements", */ T:-1 },
	/*::[*/0x0836/*::]*/: { /* n:"BrtDxf15" */ },
	/*::[*/0x0837/*::]*/: { /* n:"BrtBeginDxfs15", */ T:1 },
	/*::[*/0x0838/*::]*/: { /* n:"BrtEndDxfs15", */ T:-1 },
	/*::[*/0x0839/*::]*/: { /* n:"BrtSlicerCacheHideItemsWithNoData" */ },
	/*::[*/0x083A/*::]*/: { /* n:"BrtBeginItemUniqueNames", */ T:1 },
	/*::[*/0x083B/*::]*/: { /* n:"BrtEndItemUniqueNames", */ T:-1 },
	/*::[*/0x083C/*::]*/: { /* n:"BrtItemUniqueName" */ },
	/*::[*/0x083D/*::]*/: { /* n:"BrtBeginExtConn15", */ T:1 },
	/*::[*/0x083E/*::]*/: { /* n:"BrtEndExtConn15", */ T:-1 },
	/*::[*/0x083F/*::]*/: { /* n:"BrtBeginOledbPr15", */ T:1 },
	/*::[*/0x0840/*::]*/: { /* n:"BrtEndOledbPr15", */ T:-1 },
	/*::[*/0x0841/*::]*/: { /* n:"BrtBeginDataFeedPr15", */ T:1 },
	/*::[*/0x0842/*::]*/: { /* n:"BrtEndDataFeedPr15", */ T:-1 },
	/*::[*/0x0843/*::]*/: { /* n:"BrtTextPr15" */ },
	/*::[*/0x0844/*::]*/: { /* n:"BrtRangePr15" */ },
	/*::[*/0x0845/*::]*/: { /* n:"BrtDbCommand15" */ },
	/*::[*/0x0846/*::]*/: { /* n:"BrtBeginDbTables15", */ T:1 },
	/*::[*/0x0847/*::]*/: { /* n:"BrtEndDbTables15", */ T:-1 },
	/*::[*/0x0848/*::]*/: { /* n:"BrtDbTable15" */ },
	/*::[*/0x0849/*::]*/: { /* n:"BrtBeginDataModel", */ T:1 },
	/*::[*/0x084A/*::]*/: { /* n:"BrtEndDataModel", */ T:-1 },
	/*::[*/0x084B/*::]*/: { /* n:"BrtBeginModelTables", */ T:1 },
	/*::[*/0x084C/*::]*/: { /* n:"BrtEndModelTables", */ T:-1 },
	/*::[*/0x084D/*::]*/: { /* n:"BrtModelTable" */ },
	/*::[*/0x084E/*::]*/: { /* n:"BrtBeginModelRelationships", */ T:1 },
	/*::[*/0x084F/*::]*/: { /* n:"BrtEndModelRelationships", */ T:-1 },
	/*::[*/0x0850/*::]*/: { /* n:"BrtModelRelationship" */ },
	/*::[*/0x0851/*::]*/: { /* n:"BrtBeginECTxtWiz15", */ T:1 },
	/*::[*/0x0852/*::]*/: { /* n:"BrtEndECTxtWiz15", */ T:-1 },
	/*::[*/0x0853/*::]*/: { /* n:"BrtBeginECTWFldInfoLst15", */ T:1 },
	/*::[*/0x0854/*::]*/: { /* n:"BrtEndECTWFldInfoLst15", */ T:-1 },
	/*::[*/0x0855/*::]*/: { /* n:"BrtBeginECTWFldInfo15", */ T:1 },
	/*::[*/0x0856/*::]*/: { /* n:"BrtFieldListActiveItem" */ },
	/*::[*/0x0857/*::]*/: { /* n:"BrtPivotCacheIdVersion" */ },
	/*::[*/0x0858/*::]*/: { /* n:"BrtSXDI15" */ },
	/*::[*/0x0859/*::]*/: { /* n:"BrtBeginModelTimeGroupings", */ T:1 },
	/*::[*/0x085A/*::]*/: { /* n:"BrtEndModelTimeGroupings", */ T:-1 },
	/*::[*/0x085B/*::]*/: { /* n:"BrtBeginModelTimeGrouping", */ T:1 },
	/*::[*/0x085C/*::]*/: { /* n:"BrtEndModelTimeGrouping", */ T:-1 },
	/*::[*/0x085D/*::]*/: { /* n:"BrtModelTimeGroupingCalcCol" */ },
	/*::[*/0x0C00/*::]*/: { /* n:"BrtUid" */ },
	/*::[*/0x0C01/*::]*/: { /* n:"BrtRevisionPtr" */ },
	/*::[*/0x1000/*::]*/: { /* n:"BrtBeginDynamicArrayPr", */ T:1 },
	/*::[*/0x1001/*::]*/: { /* n:"BrtEndDynamicArrayPr", */ T:-1 },
	/*::[*/0x138A/*::]*/: { /* n:"BrtBeginRichValueBlock", */ T:1 },
	/*::[*/0x138B/*::]*/: { /* n:"BrtEndRichValueBlock", */ T:-1 },
	/*::[*/0x13D9/*::]*/: { /* n:"BrtBeginRichFilters", */ T:1 },
	/*::[*/0x13DA/*::]*/: { /* n:"BrtEndRichFilters", */ T:-1 },
	/*::[*/0x13DB/*::]*/: { /* n:"BrtRichFilter" */ },
	/*::[*/0x13DC/*::]*/: { /* n:"BrtBeginRichFilterColumn", */ T:1 },
	/*::[*/0x13DD/*::]*/: { /* n:"BrtEndRichFilterColumn", */ T:-1 },
	/*::[*/0x13DE/*::]*/: { /* n:"BrtBeginCustomRichFilters", */ T:1 },
	/*::[*/0x13DF/*::]*/: { /* n:"BrtEndCustomRichFilters", */ T:-1 },
	/*::[*/0x13E0/*::]*/: { /* n:"BrtCustomRichFilter" */ },
	/*::[*/0x13E1/*::]*/: { /* n:"BrtTop10RichFilter" */ },
	/*::[*/0x13E2/*::]*/: { /* n:"BrtDynamicRichFilter" */ },
	/*::[*/0x13E4/*::]*/: { /* n:"BrtBeginRichSortCondition", */ T:1 },
	/*::[*/0x13E5/*::]*/: { /* n:"BrtEndRichSortCondition", */ T:-1 },
	/*::[*/0x13E6/*::]*/: { /* n:"BrtRichFilterDateGroupItem" */ },
	/*::[*/0x13E7/*::]*/: { /* n:"BrtBeginCalcFeatures", */ T:1 },
	/*::[*/0x13E8/*::]*/: { /* n:"BrtEndCalcFeatures", */ T:-1 },
	/*::[*/0x13E9/*::]*/: { /* n:"BrtCalcFeature" */ },
	/*::[*/0x13EB/*::]*/: { /* n:"BrtExternalLinksPr" */ },
	/*::[*/0xFFFF/*::]*/: { n:"" }
};

/* [MS-XLS] 2.3 Record Enumeration (and other sources) */
var XLSRecordEnum = {
	/* [MS-XLS] 2.3 Record Enumeration 2021-08-17 */
	/*::[*/0x0006/*::]*/: { /* n:"Formula", */ f:parse_Formula },
	/*::[*/0x000a/*::]*/: { /* n:"EOF", */ f:parsenoop2 },
	/*::[*/0x000c/*::]*/: { /* n:"CalcCount", */ f:parseuint16 }, //
	/*::[*/0x000d/*::]*/: { /* n:"CalcMode", */ f:parseuint16 }, //
	/*::[*/0x000e/*::]*/: { /* n:"CalcPrecision", */ f:parsebool }, //
	/*::[*/0x000f/*::]*/: { /* n:"CalcRefMode", */ f:parsebool }, //
	/*::[*/0x0010/*::]*/: { /* n:"CalcDelta", */ f:parse_Xnum }, //
	/*::[*/0x0011/*::]*/: { /* n:"CalcIter", */ f:parsebool }, //
	/*::[*/0x0012/*::]*/: { /* n:"Protect", */ f:parsebool },
	/*::[*/0x0013/*::]*/: { /* n:"Password", */ f:parseuint16 },
	/*::[*/0x0014/*::]*/: { /* n:"Header", */ f:parse_XLHeaderFooter },
	/*::[*/0x0015/*::]*/: { /* n:"Footer", */ f:parse_XLHeaderFooter },
	/*::[*/0x0017/*::]*/: { /* n:"ExternSheet", */ f:parse_ExternSheet },
	/*::[*/0x0018/*::]*/: { /* n:"Lbl", */ f:parse_Lbl },
	/*::[*/0x0019/*::]*/: { /* n:"WinProtect", */ f:parsebool },
	/*::[*/0x001a/*::]*/: { /* n:"VerticalPageBreaks", */ },
	/*::[*/0x001b/*::]*/: { /* n:"HorizontalPageBreaks", */ },
	/*::[*/0x001c/*::]*/: { /* n:"Note", */ f:parse_Note },
	/*::[*/0x001d/*::]*/: { /* n:"Selection", */ },
	/*::[*/0x0022/*::]*/: { /* n:"Date1904", */ f:parsebool },
	/*::[*/0x0023/*::]*/: { /* n:"ExternName", */ f:parse_ExternName },
	/*::[*/0x0026/*::]*/: { /* n:"LeftMargin", */ f:parse_Xnum }, // *
	/*::[*/0x0027/*::]*/: { /* n:"RightMargin", */ f:parse_Xnum }, // *
	/*::[*/0x0028/*::]*/: { /* n:"TopMargin", */ f:parse_Xnum }, // *
	/*::[*/0x0029/*::]*/: { /* n:"BottomMargin", */ f:parse_Xnum }, // *
	/*::[*/0x002a/*::]*/: { /* n:"PrintRowCol", */ f:parsebool },
	/*::[*/0x002b/*::]*/: { /* n:"PrintGrid", */ f:parsebool },
	/*::[*/0x002f/*::]*/: { /* n:"FilePass", */ f:parse_FilePass },
	/*::[*/0x0031/*::]*/: { /* n:"Font", */ f:parse_Font },
	/*::[*/0x0033/*::]*/: { /* n:"PrintSize", */ f:parseuint16 },
	/*::[*/0x003c/*::]*/: { /* n:"Continue", */ },
	/*::[*/0x003d/*::]*/: { /* n:"Window1", */ f:parse_Window1 },
	/*::[*/0x0040/*::]*/: { /* n:"Backup", */ f:parsebool },
	/*::[*/0x0041/*::]*/: { /* n:"Pane", */ f:parse_Pane },
	/*::[*/0x0042/*::]*/: { /* n:"CodePage", */ f:parseuint16 },
	/*::[*/0x004d/*::]*/: { /* n:"Pls", */ },
	/*::[*/0x0050/*::]*/: { /* n:"DCon", */ },
	/*::[*/0x0051/*::]*/: { /* n:"DConRef", */ },
	/*::[*/0x0052/*::]*/: { /* n:"DConName", */ },
	/*::[*/0x0055/*::]*/: { /* n:"DefColWidth", */ f:parseuint16 },
	/*::[*/0x0059/*::]*/: { /* n:"XCT", */ },
	/*::[*/0x005a/*::]*/: { /* n:"CRN", */ },
	/*::[*/0x005b/*::]*/: { /* n:"FileSharing", */ },
	/*::[*/0x005c/*::]*/: { /* n:"WriteAccess", */ f:parse_WriteAccess },
	/*::[*/0x005d/*::]*/: { /* n:"Obj", */ f:parse_Obj },
	/*::[*/0x005e/*::]*/: { /* n:"Uncalced", */ },
	/*::[*/0x005f/*::]*/: { /* n:"CalcSaveRecalc", */ f:parsebool }, //
	/*::[*/0x0060/*::]*/: { /* n:"Template", */ },
	/*::[*/0x0061/*::]*/: { /* n:"Intl", */ },
	/*::[*/0x0063/*::]*/: { /* n:"ObjProtect", */ f:parsebool },
	/*::[*/0x007d/*::]*/: { /* n:"ColInfo", */ f:parse_ColInfo },
	/*::[*/0x0080/*::]*/: { /* n:"Guts", */ f:parse_Guts },
	/*::[*/0x0081/*::]*/: { /* n:"WsBool", */ f:parse_WsBool },
	/*::[*/0x0082/*::]*/: { /* n:"GridSet", */ f:parseuint16 },
	/*::[*/0x0083/*::]*/: { /* n:"HCenter", */ f:parsebool },
	/*::[*/0x0084/*::]*/: { /* n:"VCenter", */ f:parsebool },
	/*::[*/0x0085/*::]*/: { /* n:"BoundSheet8", */ f:parse_BoundSheet8 },
	/*::[*/0x0086/*::]*/: { /* n:"WriteProtect", */ },
	/*::[*/0x008c/*::]*/: { /* n:"Country", */ f:parse_Country },
	/*::[*/0x008d/*::]*/: { /* n:"HideObj", */ f:parseuint16 },
	/*::[*/0x0090/*::]*/: { /* n:"Sort", */ },
	/*::[*/0x0092/*::]*/: { /* n:"Palette", */ f:parse_Palette },
	/*::[*/0x0097/*::]*/: { /* n:"Sync", */ },
	/*::[*/0x0098/*::]*/: { /* n:"LPr", */ },
	/*::[*/0x0099/*::]*/: { /* n:"DxGCol", */ },
	/*::[*/0x009a/*::]*/: { /* n:"FnGroupName", */ },
	/*::[*/0x009b/*::]*/: { /* n:"FilterMode", */ },
	/*::[*/0x009c/*::]*/: { /* n:"BuiltInFnGroupCount", */ f:parseuint16 },
	/*::[*/0x009d/*::]*/: { /* n:"AutoFilterInfo", */ },
	/*::[*/0x009e/*::]*/: { /* n:"AutoFilter", */ },
	/*::[*/0x00a0/*::]*/: { /* n:"Scl", */ f:parse_Scl },
	/*::[*/0x00a1/*::]*/: { /* n:"Setup", */ f:parse_Setup },
	/*::[*/0x00ae/*::]*/: { /* n:"ScenMan", */ },
	/*::[*/0x00af/*::]*/: { /* n:"SCENARIO", */ },
	/*::[*/0x00b0/*::]*/: { /* n:"SxView", */ },
	/*::[*/0x00b1/*::]*/: { /* n:"Sxvd", */ },
	/*::[*/0x00b2/*::]*/: { /* n:"SXVI", */ },
	/*::[*/0x00b4/*::]*/: { /* n:"SxIvd", */ },
	/*::[*/0x00b5/*::]*/: { /* n:"SXLI", */ },
	/*::[*/0x00b6/*::]*/: { /* n:"SXPI", */ },
	/*::[*/0x00b8/*::]*/: { /* n:"DocRoute", */ },
	/*::[*/0x00b9/*::]*/: { /* n:"RecipName", */ },
	/*::[*/0x00bd/*::]*/: { /* n:"MulRk", */ f:parse_MulRk },
	/*::[*/0x00be/*::]*/: { /* n:"MulBlank", */ f:parse_MulBlank },
	/*::[*/0x00c1/*::]*/: { /* n:"Mms", */ f:parsenoop2 },
	/*::[*/0x00c5/*::]*/: { /* n:"SXDI", */ },
	/*::[*/0x00c6/*::]*/: { /* n:"SXDB", */ },
	/*::[*/0x00c7/*::]*/: { /* n:"SXFDB", */ },
	/*::[*/0x00c8/*::]*/: { /* n:"SXDBB", */ },
	/*::[*/0x00c9/*::]*/: { /* n:"SXNum", */ },
	/*::[*/0x00ca/*::]*/: { /* n:"SxBool", */ f:parsebool },
	/*::[*/0x00cb/*::]*/: { /* n:"SxErr", */ },
	/*::[*/0x00cc/*::]*/: { /* n:"SXInt", */ },
	/*::[*/0x00cd/*::]*/: { /* n:"SXString", */ },
	/*::[*/0x00ce/*::]*/: { /* n:"SXDtr", */ },
	/*::[*/0x00cf/*::]*/: { /* n:"SxNil", */ },
	/*::[*/0x00d0/*::]*/: { /* n:"SXTbl", */ },
	/*::[*/0x00d1/*::]*/: { /* n:"SXTBRGIITM", */ },
	/*::[*/0x00d2/*::]*/: { /* n:"SxTbpg", */ },
	/*::[*/0x00d3/*::]*/: { /* n:"ObProj", */ },
	/*::[*/0x00d5/*::]*/: { /* n:"SXStreamID", */ },
	/*::[*/0x00d7/*::]*/: { /* n:"DBCell", */ },
	/*::[*/0x00d8/*::]*/: { /* n:"SXRng", */ },
	/*::[*/0x00d9/*::]*/: { /* n:"SxIsxoper", */ },
	/*::[*/0x00da/*::]*/: { /* n:"BookBool", */ f:parseuint16 },
	/*::[*/0x00dc/*::]*/: { /* n:"DbOrParamQry", */ },
	/*::[*/0x00dd/*::]*/: { /* n:"ScenarioProtect", */ f:parsebool },
	/*::[*/0x00de/*::]*/: { /* n:"OleObjectSize", */ },
	/*::[*/0x00e0/*::]*/: { /* n:"XF", */ f:parse_XF },
	/*::[*/0x00e1/*::]*/: { /* n:"InterfaceHdr", */ f:parse_InterfaceHdr },
	/*::[*/0x00e2/*::]*/: { /* n:"InterfaceEnd", */ f:parsenoop2 },
	/*::[*/0x00e3/*::]*/: { /* n:"SXVS", */ },
	/*::[*/0x00e5/*::]*/: { /* n:"MergeCells", */ f:parse_MergeCells },
	/*::[*/0x00e9/*::]*/: { /* n:"BkHim", */ },
	/*::[*/0x00eb/*::]*/: { /* n:"MsoDrawingGroup", */ },
	/*::[*/0x00ec/*::]*/: { /* n:"MsoDrawing", */ },
	/*::[*/0x00ed/*::]*/: { /* n:"MsoDrawingSelection", */ },
	/*::[*/0x00ef/*::]*/: { /* n:"PhoneticInfo", */ },
	/*::[*/0x00f0/*::]*/: { /* n:"SxRule", */ },
	/*::[*/0x00f1/*::]*/: { /* n:"SXEx", */ },
	/*::[*/0x00f2/*::]*/: { /* n:"SxFilt", */ },
	/*::[*/0x00f4/*::]*/: { /* n:"SxDXF", */ },
	/*::[*/0x00f5/*::]*/: { /* n:"SxItm", */ },
	/*::[*/0x00f6/*::]*/: { /* n:"SxName", */ },
	/*::[*/0x00f7/*::]*/: { /* n:"SxSelect", */ },
	/*::[*/0x00f8/*::]*/: { /* n:"SXPair", */ },
	/*::[*/0x00f9/*::]*/: { /* n:"SxFmla", */ },
	/*::[*/0x00fb/*::]*/: { /* n:"SxFormat", */ },
	/*::[*/0x00fc/*::]*/: { /* n:"SST", */ f:parse_SST },
	/*::[*/0x00fd/*::]*/: { /* n:"LabelSst", */ f:parse_LabelSst },
	/*::[*/0x00ff/*::]*/: { /* n:"ExtSST", */ f:parse_ExtSST },
	/*::[*/0x0100/*::]*/: { /* n:"SXVDEx", */ },
	/*::[*/0x0103/*::]*/: { /* n:"SXFormula", */ },
	/*::[*/0x0122/*::]*/: { /* n:"SXDBEx", */ },
	/*::[*/0x0137/*::]*/: { /* n:"RRDInsDel", */ },
	/*::[*/0x0138/*::]*/: { /* n:"RRDHead", */ },
	/*::[*/0x013b/*::]*/: { /* n:"RRDChgCell", */ },
	/*::[*/0x013d/*::]*/: { /* n:"RRTabId", */ f:parseuint16a },
	/*::[*/0x013e/*::]*/: { /* n:"RRDRenSheet", */ },
	/*::[*/0x013f/*::]*/: { /* n:"RRSort", */ },
	/*::[*/0x0140/*::]*/: { /* n:"RRDMove", */ },
	/*::[*/0x014a/*::]*/: { /* n:"RRFormat", */ },
	/*::[*/0x014b/*::]*/: { /* n:"RRAutoFmt", */ },
	/*::[*/0x014d/*::]*/: { /* n:"RRInsertSh", */ },
	/*::[*/0x014e/*::]*/: { /* n:"RRDMoveBegin", */ },
	/*::[*/0x014f/*::]*/: { /* n:"RRDMoveEnd", */ },
	/*::[*/0x0150/*::]*/: { /* n:"RRDInsDelBegin", */ },
	/*::[*/0x0151/*::]*/: { /* n:"RRDInsDelEnd", */ },
	/*::[*/0x0152/*::]*/: { /* n:"RRDConflict", */ },
	/*::[*/0x0153/*::]*/: { /* n:"RRDDefName", */ },
	/*::[*/0x0154/*::]*/: { /* n:"RRDRstEtxp", */ },
	/*::[*/0x015f/*::]*/: { /* n:"LRng", */ },
	/*::[*/0x0160/*::]*/: { /* n:"UsesELFs", */ f:parsebool },
	/*::[*/0x0161/*::]*/: { /* n:"DSF", */ f:parsenoop2 },
	/*::[*/0x0191/*::]*/: { /* n:"CUsr", */ },
	/*::[*/0x0192/*::]*/: { /* n:"CbUsr", */ },
	/*::[*/0x0193/*::]*/: { /* n:"UsrInfo", */ },
	/*::[*/0x0194/*::]*/: { /* n:"UsrExcl", */ },
	/*::[*/0x0195/*::]*/: { /* n:"FileLock", */ },
	/*::[*/0x0196/*::]*/: { /* n:"RRDInfo", */ },
	/*::[*/0x0197/*::]*/: { /* n:"BCUsrs", */ },
	/*::[*/0x0198/*::]*/: { /* n:"UsrChk", */ },
	/*::[*/0x01a9/*::]*/: { /* n:"UserBView", */ },
	/*::[*/0x01aa/*::]*/: { /* n:"UserSViewBegin", */ },
	/*::[*/0x01ab/*::]*/: { /* n:"UserSViewEnd", */ },
	/*::[*/0x01ac/*::]*/: { /* n:"RRDUserView", */ },
	/*::[*/0x01ad/*::]*/: { /* n:"Qsi", */ },
	/*::[*/0x01ae/*::]*/: { /* n:"SupBook", */ f:parse_SupBook },
	/*::[*/0x01af/*::]*/: { /* n:"Prot4Rev", */ f:parsebool },
	/*::[*/0x01b0/*::]*/: { /* n:"CondFmt", */ },
	/*::[*/0x01b1/*::]*/: { /* n:"CF", */ },
	/*::[*/0x01b2/*::]*/: { /* n:"DVal", */ },
	/*::[*/0x01b5/*::]*/: { /* n:"DConBin", */ },
	/*::[*/0x01b6/*::]*/: { /* n:"TxO", */ f:parse_TxO },
	/*::[*/0x01b7/*::]*/: { /* n:"RefreshAll", */ f:parsebool }, //
	/*::[*/0x01b8/*::]*/: { /* n:"HLink", */ f:parse_HLink },
	/*::[*/0x01b9/*::]*/: { /* n:"Lel", */ },
	/*::[*/0x01ba/*::]*/: { /* n:"CodeName", */ f:parse_XLUnicodeString },
	/*::[*/0x01bb/*::]*/: { /* n:"SXFDBType", */ },
	/*::[*/0x01bc/*::]*/: { /* n:"Prot4RevPass", */ f:parseuint16 },
	/*::[*/0x01bd/*::]*/: { /* n:"ObNoMacros", */ },
	/*::[*/0x01be/*::]*/: { /* n:"Dv", */ },
	/*::[*/0x01c0/*::]*/: { /* n:"Excel9File", */ f:parsenoop2 },
	/*::[*/0x01c1/*::]*/: { /* n:"RecalcId", */ f:parse_RecalcId, r:2},
	/*::[*/0x01c2/*::]*/: { /* n:"EntExU2", */ f:parsenoop2 },
	/*::[*/0x0200/*::]*/: { /* n:"Dimensions", */ f:parse_Dimensions },
	/*::[*/0x0201/*::]*/: { /* n:"Blank", */ f:parse_Blank },
	/*::[*/0x0203/*::]*/: { /* n:"Number", */ f:parse_Number },
	/*::[*/0x0204/*::]*/: { /* n:"Label", */ f:parse_Label },
	/*::[*/0x0205/*::]*/: { /* n:"BoolErr", */ f:parse_BoolErr },
	/*::[*/0x0207/*::]*/: { /* n:"String", */ f:parse_String },
	/*::[*/0x0208/*::]*/: { /* n:"Row", */ f:parse_Row },
	/*::[*/0x020b/*::]*/: { /* n:"Index", */ },
	/*::[*/0x0221/*::]*/: { /* n:"Array", */ f:parse_Array },
	/*::[*/0x0225/*::]*/: { /* n:"DefaultRowHeight", */ f:parse_DefaultRowHeight },
	/*::[*/0x0236/*::]*/: { /* n:"Table", */ },
	/*::[*/0x023e/*::]*/: { /* n:"Window2", */ f:parse_Window2 },
	/*::[*/0x027e/*::]*/: { /* n:"RK", */ f:parse_RK },
	/*::[*/0x0293/*::]*/: { /* n:"Style", */ },
	/*::[*/0x0418/*::]*/: { /* n:"BigName", */ },
	/*::[*/0x041e/*::]*/: { /* n:"Format", */ f:parse_Format },
	/*::[*/0x043c/*::]*/: { /* n:"ContinueBigName", */ },
	/*::[*/0x04bc/*::]*/: { /* n:"ShrFmla", */ f:parse_ShrFmla },
	/*::[*/0x0800/*::]*/: { /* n:"HLinkTooltip", */ f:parse_HLinkTooltip },
	/*::[*/0x0801/*::]*/: { /* n:"WebPub", */ },
	/*::[*/0x0802/*::]*/: { /* n:"QsiSXTag", */ },
	/*::[*/0x0803/*::]*/: { /* n:"DBQueryExt", */ },
	/*::[*/0x0804/*::]*/: { /* n:"ExtString", */ },
	/*::[*/0x0805/*::]*/: { /* n:"TxtQry", */ },
	/*::[*/0x0806/*::]*/: { /* n:"Qsir", */ },
	/*::[*/0x0807/*::]*/: { /* n:"Qsif", */ },
	/*::[*/0x0808/*::]*/: { /* n:"RRDTQSIF", */ },
	/*::[*/0x0809/*::]*/: { /* n:"BOF", */ f:parse_BOF },
	/*::[*/0x080a/*::]*/: { /* n:"OleDbConn", */ },
	/*::[*/0x080b/*::]*/: { /* n:"WOpt", */ },
	/*::[*/0x080c/*::]*/: { /* n:"SXViewEx", */ },
	/*::[*/0x080d/*::]*/: { /* n:"SXTH", */ },
	/*::[*/0x080e/*::]*/: { /* n:"SXPIEx", */ },
	/*::[*/0x080f/*::]*/: { /* n:"SXVDTEx", */ },
	/*::[*/0x0810/*::]*/: { /* n:"SXViewEx9", */ },
	/*::[*/0x0812/*::]*/: { /* n:"ContinueFrt", */ },
	/*::[*/0x0813/*::]*/: { /* n:"RealTimeData", */ },
	/*::[*/0x0850/*::]*/: { /* n:"ChartFrtInfo", */ },
	/*::[*/0x0851/*::]*/: { /* n:"FrtWrapper", */ },
	/*::[*/0x0852/*::]*/: { /* n:"StartBlock", */ },
	/*::[*/0x0853/*::]*/: { /* n:"EndBlock", */ },
	/*::[*/0x0854/*::]*/: { /* n:"StartObject", */ },
	/*::[*/0x0855/*::]*/: { /* n:"EndObject", */ },
	/*::[*/0x0856/*::]*/: { /* n:"CatLab", */ },
	/*::[*/0x0857/*::]*/: { /* n:"YMult", */ },
	/*::[*/0x0858/*::]*/: { /* n:"SXViewLink", */ },
	/*::[*/0x0859/*::]*/: { /* n:"PivotChartBits", */ },
	/*::[*/0x085a/*::]*/: { /* n:"FrtFontList", */ },
	/*::[*/0x0862/*::]*/: { /* n:"SheetExt", */ },
	/*::[*/0x0863/*::]*/: { /* n:"BookExt", */ r:12},
	/*::[*/0x0864/*::]*/: { /* n:"SXAddl", */ },
	/*::[*/0x0865/*::]*/: { /* n:"CrErr", */ },
	/*::[*/0x0866/*::]*/: { /* n:"HFPicture", */ },
	/*::[*/0x0867/*::]*/: { /* n:"FeatHdr", */ f:parsenoop2 },
	/*::[*/0x0868/*::]*/: { /* n:"Feat", */ },
	/*::[*/0x086a/*::]*/: { /* n:"DataLabExt", */ },
	/*::[*/0x086b/*::]*/: { /* n:"DataLabExtContents", */ },
	/*::[*/0x086c/*::]*/: { /* n:"CellWatch", */ },
	/*::[*/0x0871/*::]*/: { /* n:"FeatHdr11", */ },
	/*::[*/0x0872/*::]*/: { /* n:"Feature11", */ },
	/*::[*/0x0874/*::]*/: { /* n:"DropDownObjIds", */ },
	/*::[*/0x0875/*::]*/: { /* n:"ContinueFrt11", */ },
	/*::[*/0x0876/*::]*/: { /* n:"DConn", */ },
	/*::[*/0x0877/*::]*/: { /* n:"List12", */ },
	/*::[*/0x0878/*::]*/: { /* n:"Feature12", */ },
	/*::[*/0x0879/*::]*/: { /* n:"CondFmt12", */ },
	/*::[*/0x087a/*::]*/: { /* n:"CF12", */ },
	/*::[*/0x087b/*::]*/: { /* n:"CFEx", */ },
	/*::[*/0x087c/*::]*/: { /* n:"XFCRC", */ f:parse_XFCRC, r:12 },
	/*::[*/0x087d/*::]*/: { /* n:"XFExt", */ f:parse_XFExt, r:12 },
	/*::[*/0x087e/*::]*/: { /* n:"AutoFilter12", */ },
	/*::[*/0x087f/*::]*/: { /* n:"ContinueFrt12", */ },
	/*::[*/0x0884/*::]*/: { /* n:"MDTInfo", */ },
	/*::[*/0x0885/*::]*/: { /* n:"MDXStr", */ },
	/*::[*/0x0886/*::]*/: { /* n:"MDXTuple", */ },
	/*::[*/0x0887/*::]*/: { /* n:"MDXSet", */ },
	/*::[*/0x0888/*::]*/: { /* n:"MDXProp", */ },
	/*::[*/0x0889/*::]*/: { /* n:"MDXKPI", */ },
	/*::[*/0x088a/*::]*/: { /* n:"MDB", */ },
	/*::[*/0x088b/*::]*/: { /* n:"PLV", */ },
	/*::[*/0x088c/*::]*/: { /* n:"Compat12", */ f:parsebool, r:12 },
	/*::[*/0x088d/*::]*/: { /* n:"DXF", */ },
	/*::[*/0x088e/*::]*/: { /* n:"TableStyles", */ r:12 },
	/*::[*/0x088f/*::]*/: { /* n:"TableStyle", */ },
	/*::[*/0x0890/*::]*/: { /* n:"TableStyleElement", */ },
	/*::[*/0x0892/*::]*/: { /* n:"StyleExt", */ },
	/*::[*/0x0893/*::]*/: { /* n:"NamePublish", */ },
	/*::[*/0x0894/*::]*/: { /* n:"NameCmt", */ f:parse_NameCmt, r:12 },
	/*::[*/0x0895/*::]*/: { /* n:"SortData", */ },
	/*::[*/0x0896/*::]*/: { /* n:"Theme", */ f:parse_Theme, r:12 },
	/*::[*/0x0897/*::]*/: { /* n:"GUIDTypeLib", */ },
	/*::[*/0x0898/*::]*/: { /* n:"FnGrp12", */ },
	/*::[*/0x0899/*::]*/: { /* n:"NameFnGrp12", */ },
	/*::[*/0x089a/*::]*/: { /* n:"MTRSettings", */ f:parse_MTRSettings, r:12 },
	/*::[*/0x089b/*::]*/: { /* n:"CompressPictures", */ f:parsenoop2 },
	/*::[*/0x089c/*::]*/: { /* n:"HeaderFooter", */ },
	/*::[*/0x089d/*::]*/: { /* n:"CrtLayout12", */ },
	/*::[*/0x089e/*::]*/: { /* n:"CrtMlFrt", */ },
	/*::[*/0x089f/*::]*/: { /* n:"CrtMlFrtContinue", */ },
	/*::[*/0x08a3/*::]*/: { /* n:"ForceFullCalculation", */ f:parse_ForceFullCalculation },
	/*::[*/0x08a4/*::]*/: { /* n:"ShapePropsStream", */ },
	/*::[*/0x08a5/*::]*/: { /* n:"TextPropsStream", */ },
	/*::[*/0x08a6/*::]*/: { /* n:"RichTextStream", */ },
	/*::[*/0x08a7/*::]*/: { /* n:"CrtLayout12A", */ },
	/*::[*/0x1001/*::]*/: { /* n:"Units", */ },
	/*::[*/0x1002/*::]*/: { /* n:"Chart", */ },
	/*::[*/0x1003/*::]*/: { /* n:"Series", */ },
	/*::[*/0x1006/*::]*/: { /* n:"DataFormat", */ },
	/*::[*/0x1007/*::]*/: { /* n:"LineFormat", */ },
	/*::[*/0x1009/*::]*/: { /* n:"MarkerFormat", */ },
	/*::[*/0x100a/*::]*/: { /* n:"AreaFormat", */ },
	/*::[*/0x100b/*::]*/: { /* n:"PieFormat", */ },
	/*::[*/0x100c/*::]*/: { /* n:"AttachedLabel", */ },
	/*::[*/0x100d/*::]*/: { /* n:"SeriesText", */ },
	/*::[*/0x1014/*::]*/: { /* n:"ChartFormat", */ },
	/*::[*/0x1015/*::]*/: { /* n:"Legend", */ },
	/*::[*/0x1016/*::]*/: { /* n:"SeriesList", */ },
	/*::[*/0x1017/*::]*/: { /* n:"Bar", */ },
	/*::[*/0x1018/*::]*/: { /* n:"Line", */ },
	/*::[*/0x1019/*::]*/: { /* n:"Pie", */ },
	/*::[*/0x101a/*::]*/: { /* n:"Area", */ },
	/*::[*/0x101b/*::]*/: { /* n:"Scatter", */ },
	/*::[*/0x101c/*::]*/: { /* n:"CrtLine", */ },
	/*::[*/0x101d/*::]*/: { /* n:"Axis", */ },
	/*::[*/0x101e/*::]*/: { /* n:"Tick", */ },
	/*::[*/0x101f/*::]*/: { /* n:"ValueRange", */ },
	/*::[*/0x1020/*::]*/: { /* n:"CatSerRange", */ },
	/*::[*/0x1021/*::]*/: { /* n:"AxisLine", */ },
	/*::[*/0x1022/*::]*/: { /* n:"CrtLink", */ },
	/*::[*/0x1024/*::]*/: { /* n:"DefaultText", */ },
	/*::[*/0x1025/*::]*/: { /* n:"Text", */ },
	/*::[*/0x1026/*::]*/: { /* n:"FontX", */ f:parseuint16 },
	/*::[*/0x1027/*::]*/: { /* n:"ObjectLink", */ },
	/*::[*/0x1032/*::]*/: { /* n:"Frame", */ },
	/*::[*/0x1033/*::]*/: { /* n:"Begin", */ },
	/*::[*/0x1034/*::]*/: { /* n:"End", */ },
	/*::[*/0x1035/*::]*/: { /* n:"PlotArea", */ },
	/*::[*/0x103a/*::]*/: { /* n:"Chart3d", */ },
	/*::[*/0x103c/*::]*/: { /* n:"PicF", */ },
	/*::[*/0x103d/*::]*/: { /* n:"DropBar", */ },
	/*::[*/0x103e/*::]*/: { /* n:"Radar", */ },
	/*::[*/0x103f/*::]*/: { /* n:"Surf", */ },
	/*::[*/0x1040/*::]*/: { /* n:"RadarArea", */ },
	/*::[*/0x1041/*::]*/: { /* n:"AxisParent", */ },
	/*::[*/0x1043/*::]*/: { /* n:"LegendException", */ },
	/*::[*/0x1044/*::]*/: { /* n:"ShtProps", */ f:parse_ShtProps },
	/*::[*/0x1045/*::]*/: { /* n:"SerToCrt", */ },
	/*::[*/0x1046/*::]*/: { /* n:"AxesUsed", */ },
	/*::[*/0x1048/*::]*/: { /* n:"SBaseRef", */ },
	/*::[*/0x104a/*::]*/: { /* n:"SerParent", */ },
	/*::[*/0x104b/*::]*/: { /* n:"SerAuxTrend", */ },
	/*::[*/0x104e/*::]*/: { /* n:"IFmtRecord", */ },
	/*::[*/0x104f/*::]*/: { /* n:"Pos", */ },
	/*::[*/0x1050/*::]*/: { /* n:"AlRuns", */ },
	/*::[*/0x1051/*::]*/: { /* n:"BRAI", */ },
	/*::[*/0x105b/*::]*/: { /* n:"SerAuxErrBar", */ },
	/*::[*/0x105c/*::]*/: { /* n:"ClrtClient", */ f:parse_ClrtClient },
	/*::[*/0x105d/*::]*/: { /* n:"SerFmt", */ },
	/*::[*/0x105f/*::]*/: { /* n:"Chart3DBarShape", */ },
	/*::[*/0x1060/*::]*/: { /* n:"Fbi", */ },
	/*::[*/0x1061/*::]*/: { /* n:"BopPop", */ },
	/*::[*/0x1062/*::]*/: { /* n:"AxcExt", */ },
	/*::[*/0x1063/*::]*/: { /* n:"Dat", */ },
	/*::[*/0x1064/*::]*/: { /* n:"PlotGrowth", */ },
	/*::[*/0x1065/*::]*/: { /* n:"SIIndex", */ },
	/*::[*/0x1066/*::]*/: { /* n:"GelFrame", */ },
	/*::[*/0x1067/*::]*/: { /* n:"BopPopCustom", */ },
	/*::[*/0x1068/*::]*/: { /* n:"Fbi2", */ },

	/*::[*/0x0000/*::]*/: { /* n:"Dimensions", */ f:parse_Dimensions },
	/*::[*/0x0001/*::]*/: { /* n:"BIFF2BLANK", */ },
	/*::[*/0x0002/*::]*/: { /* n:"BIFF2INT", */ f:parse_BIFF2INT },
	/*::[*/0x0003/*::]*/: { /* n:"BIFF2NUM", */ f:parse_BIFF2NUM },
	/*::[*/0x0004/*::]*/: { /* n:"BIFF2STR", */ f:parse_BIFF2STR },
	/*::[*/0x0005/*::]*/: { /* n:"BoolErr", */ f:parse_BoolErr },
	/*::[*/0x0007/*::]*/: { /* n:"String", */ f:parse_BIFF2STRING },
	/*::[*/0x0008/*::]*/: { /* n:"BIFF2ROW", */ },
	/*::[*/0x0009/*::]*/: { /* n:"BOF", */ f:parse_BOF },
	/*::[*/0x000b/*::]*/: { /* n:"Index", */ },
	/*::[*/0x0016/*::]*/: { /* n:"ExternCount", */ f:parseuint16 },
	/*::[*/0x001e/*::]*/: { /* n:"BIFF2FORMAT", */ f:parse_BIFF2Format },
	/*::[*/0x001f/*::]*/: { /* n:"BIFF2FMTCNT", */ }, /* 16-bit cnt of BIFF2FORMAT records */
	/*::[*/0x0020/*::]*/: { /* n:"BIFF2COLINFO", */ },
	/*::[*/0x0021/*::]*/: { /* n:"Array", */ f:parse_Array },
	/*::[*/0x0024/*::]*/: { /* n:"COLWIDTH", */ },
	/*::[*/0x0025/*::]*/: { /* n:"DefaultRowHeight", */ f:parse_DefaultRowHeight },
	// 0x2c ??
	// 0x2d ??
	// 0x2e ??
	// 0x30 FONTCOUNT: number of fonts
	/*::[*/0x0032/*::]*/: { /* n:"BIFF2FONTXTRA", */ f:parse_BIFF2FONTXTRA },
	// 0x35: INFOOPTS
	// 0x36: TABLE (BIFF2 only)
	// 0x37: TABLE2 (BIFF2 only)
	// 0x38: WNDESK
	// 0x39 ??
	// 0x3a: BEGINPREF
	// 0x3b: ENDPREF
	/*::[*/0x003e/*::]*/: { /* n:"BIFF2WINDOW2", */ },
	// 0x3f ??
	// 0x46: SHOWSCROLL
	// 0x47: SHOWFORMULA
	// 0x48: STATUSBAR
	// 0x49: SHORTMENUS
	// 0x4A:
	// 0x4B:
	// 0x4C:
	// 0x4E:
	// 0x4F:
	// 0x58: TOOLBAR (BIFF3)

	/* - - - */
	/*::[*/0x0034/*::]*/: { /* n:"DDEObjName", */ },
	/*::[*/0x0043/*::]*/: { /* n:"BIFF2XF", */ },
	/*::[*/0x0044/*::]*/: { /* n:"BIFF2XFINDEX", */ f:parseuint16 },
	/*::[*/0x0045/*::]*/: { /* n:"BIFF2FONTCLR", */ },
	/*::[*/0x0056/*::]*/: { /* n:"BIFF4FMTCNT", */ }, /* 16-bit cnt, similar to BIFF2 */
	/*::[*/0x007e/*::]*/: { /* n:"RK", */ }, /* Not necessarily same as 0x027e */
	/*::[*/0x007f/*::]*/: { /* n:"ImData", */ f:parse_ImData },
	/*::[*/0x0087/*::]*/: { /* n:"Addin", */ },
	/*::[*/0x0088/*::]*/: { /* n:"Edg", */ },
	/*::[*/0x0089/*::]*/: { /* n:"Pub", */ },
	// 0x8A
	// 0x8B LH: alternate menu key flag (BIFF3/4)
	// 0x8E
	// 0x8F
	/*::[*/0x0091/*::]*/: { /* n:"Sub", */ },
	// 0x93 STYLE
	/*::[*/0x0094/*::]*/: { /* n:"LHRecord", */ },
	/*::[*/0x0095/*::]*/: { /* n:"LHNGraph", */ },
	/*::[*/0x0096/*::]*/: { /* n:"Sound", */ },
	// 0xA2 FNPROTO: function prototypes (BIFF4)
	// 0xA3
	// 0xA8
	/*::[*/0x00a9/*::]*/: { /* n:"CoordList", */ },
	/*::[*/0x00ab/*::]*/: { /* n:"GCW", */ },
	/*::[*/0x00bc/*::]*/: { /* n:"ShrFmla", */ }, /* Not necessarily same as 0x04bc */
	/*::[*/0x00bf/*::]*/: { /* n:"ToolbarHdr", */ },
	/*::[*/0x00c0/*::]*/: { /* n:"ToolbarEnd", */ },
	/*::[*/0x00c2/*::]*/: { /* n:"AddMenu", */ },
	/*::[*/0x00c3/*::]*/: { /* n:"DelMenu", */ },
	/*::[*/0x00d6/*::]*/: { /* n:"RString", */ f:parse_RString },
	/*::[*/0x00df/*::]*/: { /* n:"UDDesc", */ },
	/*::[*/0x00ea/*::]*/: { /* n:"TabIdConf", */ },
	/*::[*/0x0162/*::]*/: { /* n:"XL5Modify", */ },
	/*::[*/0x01a5/*::]*/: { /* n:"FileSharing2", */ },
	/*::[*/0x0206/*::]*/: { /* n:"Formula", */ f:parse_Formula },
	/*::[*/0x0209/*::]*/: { /* n:"BOF", */ f:parse_BOF },
	/*::[*/0x0218/*::]*/: { /* n:"Lbl", */ f:parse_Lbl },
	/*::[*/0x0223/*::]*/: { /* n:"ExternName", */ f:parse_ExternName },
	/*::[*/0x0231/*::]*/: { /* n:"Font", */ },
	/*::[*/0x0243/*::]*/: { /* n:"BIFF3XF", */ },
	/*::[*/0x0406/*::]*/: { /* n:"Formula", */ f:parse_Formula },
	/*::[*/0x0409/*::]*/: { /* n:"BOF", */ f:parse_BOF },
	/*::[*/0x0443/*::]*/: { /* n:"BIFF4XF", */ },
	/*::[*/0x086d/*::]*/: { /* n:"FeatInfo", */ },
	/*::[*/0x0873/*::]*/: { /* n:"FeatInfo11", */ },
	/*::[*/0x0881/*::]*/: { /* n:"SXAddl12", */ },
	/*::[*/0x08c0/*::]*/: { /* n:"AutoWebPub", */ },
	/*::[*/0x08c1/*::]*/: { /* n:"ListObj", */ },
	/*::[*/0x08c2/*::]*/: { /* n:"ListField", */ },
	/*::[*/0x08c3/*::]*/: { /* n:"ListDV", */ },
	/*::[*/0x08c4/*::]*/: { /* n:"ListCondFmt", */ },
	/*::[*/0x08c5/*::]*/: { /* n:"ListCF", */ },
	/*::[*/0x08c6/*::]*/: { /* n:"FMQry", */ },
	/*::[*/0x08c7/*::]*/: { /* n:"FMSQry", */ },
	/*::[*/0x08c8/*::]*/: { /* n:"PLV", */ },
	/*::[*/0x08c9/*::]*/: { /* n:"LnExt", */ },
	/*::[*/0x08ca/*::]*/: { /* n:"MkrExt", */ },
	/*::[*/0x08cb/*::]*/: { /* n:"CrtCoopt", */ },
	/*::[*/0x08d6/*::]*/: { /* n:"FRTArchId$", */ r:12 },

	/*::[*/0x7262/*::]*/: {}
};

function write_biff_rec(ba/*:BufArray*/, type/*:number*/, payload, length/*:?number*/)/*:void*/ {
	var t/*:number*/ = type;
	if(isNaN(t)) return;
	var len = length || (payload||[]).length || 0;
	var o = ba.next(4);
	o.write_shift(2, t);
	o.write_shift(2, len);
	if(/*:: len != null &&*/len > 0 && is_buf(payload)) ba.push(payload);
}

function write_biff_continue(ba/*:BufArray*/, type/*:number*/, payload, length/*:?number*/)/*:void*/ {
	var len = length || (payload||[]).length || 0;
	if(len <= 8224) return write_biff_rec(ba, type, payload, len);
	var t = type;
	if(isNaN(t)) return;
	var parts = payload.parts || [], sidx = 0;
	var i = 0, w = 0;
	while(w + (parts[sidx] || 8224) <= 8224) { w+= (parts[sidx] || 8224); sidx++; }
	var o = ba.next(4);
	o.write_shift(2, t);
	o.write_shift(2, w);
	ba.push(payload.slice(i, i + w));
	i += w;
	while(i < len) {
		o = ba.next(4);
		o.write_shift(2, 0x3c); // TODO: figure out correct continue type
		w = 0;
		while(w + (parts[sidx] || 8224) <= 8224) { w+= (parts[sidx] || 8224); sidx++; }
		o.write_shift(2, w);
		ba.push(payload.slice(i, i+w)); i+= w;
	}
}

function write_BIFF2Cell(out, r/*:number*/, c/*:number*/) {
	if(!out) out = new_buf(7);
	out.write_shift(2, r);
	out.write_shift(2, c);
	out.write_shift(2, 0);
	out.write_shift(1, 0);
	return out;
}

function write_BIFF2BERR(r/*:number*/, c/*:number*/, val, t/*:?string*/) {
	var out = new_buf(9);
	write_BIFF2Cell(out, r, c);
	write_Bes(val, t || 'b', out);
	return out;
}

/* TODO: codepage, large strings */
function write_BIFF2LABEL(r/*:number*/, c/*:number*/, val) {
	var out = new_buf(8 + 2*val.length);
	write_BIFF2Cell(out, r, c);
	out.write_shift(1, val.length);
	out.write_shift(val.length, val, 'sbcs');
	return out.l < out.length ? out.slice(0, out.l) : out;
}

function write_ws_biff2_cell(ba/*:BufArray*/, cell/*:Cell*/, R/*:number*/, C/*:number*//*::, opts*/) {
	if(cell.v != null) switch(cell.t) {
		case 'd': case 'n':
			var v = cell.t == 'd' ? datenum(parseDate(cell.v)) : cell.v;
			if((v == (v|0)) && (v >= 0) && (v < 65536))
				write_biff_rec(ba, 0x0002, write_BIFF2INT(R, C, v));
			else
				write_biff_rec(ba, 0x0003, write_BIFF2NUM(R,C, v));
			return;
		case 'b': case 'e': write_biff_rec(ba, 0x0005, write_BIFF2BERR(R, C, cell.v, cell.t)); return;
		/* TODO: codepage, sst */
		case 's': case 'str':
			write_biff_rec(ba, 0x0004, write_BIFF2LABEL(R, C, (cell.v||"").slice(0,255)));
			return;
	}
	write_biff_rec(ba, 0x0001, write_BIFF2Cell(null, R, C));
}

function write_ws_biff2(ba/*:BufArray*/, ws/*:Worksheet*/, idx/*:number*/, opts/*::, wb:Workbook*/) {
	var dense = Array.isArray(ws);
	var range = safe_decode_range(ws['!ref'] || "A1"), ref/*:string*/, rr = "", cols/*:Array<string>*/ = [];
	if(range.e.c > 0xFF || range.e.r > 0x3FFF) {
		if(opts.WTF) throw new Error("Range " + (ws['!ref'] || "A1") + " exceeds format limit A1:IV16384");
		range.e.c = Math.min(range.e.c, 0xFF);
		range.e.r = Math.min(range.e.c, 0x3FFF);
		ref = encode_range(range);
	}
	for(var R = range.s.r; R <= range.e.r; ++R) {
		rr = encode_row(R);
		for(var C = range.s.c; C <= range.e.c; ++C) {
			if(R === range.s.r) cols[C] = encode_col(C);
			ref = cols[C] + rr;
			var cell = dense ? (ws[R]||[])[C] : ws[ref];
			if(!cell) continue;
			/* write cell */
			write_ws_biff2_cell(ba, cell, R, C, opts);
		}
	}
}

/* Based on test files */
function write_biff2_buf(wb/*:Workbook*/, opts/*:WriteOpts*/) {
	var o = opts || {};
	if(DENSE != null && o.dense == null) o.dense = DENSE;
	var ba = buf_array();
	var idx = 0;
	for(var i=0;i<wb.SheetNames.length;++i) if(wb.SheetNames[i] == o.sheet) idx=i;
	if(idx == 0 && !!o.sheet && wb.SheetNames[0] != o.sheet) throw new Error("Sheet not found: " + o.sheet);
	write_biff_rec(ba, (o.biff == 4 ? 0x0409 : (o.biff == 3 ? 0x0209 : 0x0009)), write_BOF(wb, 0x10, o));
	/* ... */
	write_ws_biff2(ba, wb.Sheets[wb.SheetNames[idx]], idx, o, wb);
	/* ... */
	write_biff_rec(ba, 0x000A);
	return ba.end();
}

function write_FONTS_biff8(ba, data, opts) {
	write_biff_rec(ba, 0x0031 /* Font */, write_Font({
		sz:12,
		color: {theme:1},
		name: "Arial",
		family: 2,
		scheme: "minor"
	}, opts));
}


function write_FMTS_biff8(ba, NF/*:?SSFTable*/, opts) {
	if(!NF) return;
	[[5,8],[23,26],[41,44],[/*63*/50,/*66],[164,*/392]].forEach(function(r) {
		/*:: if(!NF) return; */
		for(var i = r[0]; i <= r[1]; ++i) if(NF[i] != null) write_biff_rec(ba, 0x041E /* Format */, write_Format(i, NF[i], opts));
	});
}

function write_FEAT(ba, ws) {
	/* [MS-XLS] 2.4.112 */
	var o = new_buf(19);
	o.write_shift(4, 0x867); o.write_shift(4, 0); o.write_shift(4, 0);
	o.write_shift(2, 3); o.write_shift(1, 1); o.write_shift(4, 0);
	write_biff_rec(ba, 0x0867 /* FeatHdr */, o);
	/* [MS-XLS] 2.4.111 */
	o = new_buf(39);
	o.write_shift(4, 0x868); o.write_shift(4, 0); o.write_shift(4, 0);
	o.write_shift(2, 3); o.write_shift(1, 0); o.write_shift(4, 0);
	o.write_shift(2, 1); o.write_shift(4, 4); o.write_shift(2, 0);
	write_Ref8U(safe_decode_range(ws['!ref']||"A1"), o);
	o.write_shift(4, 4);
	write_biff_rec(ba, 0x0868 /* Feat */, o);
}

function write_CELLXFS_biff8(ba, opts) {
	for(var i = 0; i < 16; ++i) write_biff_rec(ba, 0x00e0 /* XF */, write_XF({numFmtId:0, style:true}, 0, opts));
	opts.cellXfs.forEach(function(c) {
		write_biff_rec(ba, 0x00e0 /* XF */, write_XF(c, 0, opts));
	});
}

function write_ws_biff8_hlinks(ba/*:BufArray*/, ws) {
	for(var R=0; R<ws['!links'].length; ++R) {
		var HL = ws['!links'][R];
		write_biff_rec(ba, 0x01b8 /* HLink */, write_HLink(HL));
		if(HL[1].Tooltip) write_biff_rec(ba, 0x0800 /* HLinkTooltip */, write_HLinkTooltip(HL));
	}
	delete ws['!links'];
}

function write_ws_cols_biff8(ba, cols) {
	if(!cols) return;
	var cnt = 0;
	cols.forEach(function(col, idx) {
		if(++cnt <= 256 && col) {
			write_biff_rec(ba, 0x007d /* ColInfo */, write_ColInfo(col_obj_w(idx, col), idx));
		}
	});
}

function write_ws_biff8_cell(ba/*:BufArray*/, cell/*:Cell*/, R/*:number*/, C/*:number*/, opts) {
	var os = 16 + get_cell_style(opts.cellXfs, cell, opts);
	if(cell.v == null && !cell.bf) {
		write_biff_rec(ba, 0x0201 /* Blank */, write_XLSCell(R, C, os));
		return;
	}
	if(cell.bf) write_biff_rec(ba, 0x0006 /* Formula */, write_Formula(cell, R, C, opts, os));
	else switch(cell.t) {
		case 'd': case 'n':
			var v = cell.t == 'd' ? datenum(parseDate(cell.v)) : cell.v;
			/* TODO: emit RK as appropriate */
			write_biff_rec(ba, 0x0203 /* Number */, write_Number(R, C, v, os, opts));
			break;
		case 'b': case 'e':
			write_biff_rec(ba, 0x0205 /* BoolErr */, write_BoolErr(R, C, cell.v, os, opts, cell.t));
			break;
		/* TODO: codepage, sst */
		case 's': case 'str':
			if(opts.bookSST) {
				var isst = get_sst_id(opts.Strings, cell.v, opts.revStrings);
				write_biff_rec(ba, 0x00fd /* LabelSst */, write_LabelSst(R, C, isst, os, opts));
			} else write_biff_rec(ba, 0x0204 /* Label */, write_Label(R, C, (cell.v||"").slice(0,255), os, opts));
			break;
		default:
			write_biff_rec(ba, 0x0201 /* Blank */, write_XLSCell(R, C, os));
	}
}

/* [MS-XLS] 2.1.7.20.5 */
function write_ws_biff8(idx/*:number*/, opts, wb/*:Workbook*/) {
	var ba = buf_array();
	var s = wb.SheetNames[idx], ws = wb.Sheets[s] || {};
	var _WB/*:WBWBProps*/ = ((wb||{}).Workbook||{}/*:any*/);
	var _sheet/*:WBWSProp*/ = ((_WB.Sheets||[])[idx]||{}/*:any*/);
	var dense = Array.isArray(ws);
	var b8 = opts.biff == 8;
	var ref/*:string*/, rr = "", cols/*:Array<string>*/ = [];
	var range = safe_decode_range(ws['!ref'] || "A1");
	var MAX_ROWS = b8 ? 65536 : 16384;
	if(range.e.c > 0xFF || range.e.r >= MAX_ROWS) {
		if(opts.WTF) throw new Error("Range " + (ws['!ref'] || "A1") + " exceeds format limit A1:IV16384");
		range.e.c = Math.min(range.e.c, 0xFF);
		range.e.r = Math.min(range.e.c, MAX_ROWS-1);
	}

	write_biff_rec(ba, 0x0809, write_BOF(wb, 0x10, opts));
	/* [Uncalced] Index */
	write_biff_rec(ba, 0x000d /* CalcMode */, writeuint16(1));
	write_biff_rec(ba, 0x000c /* CalcCount */, writeuint16(100));
	write_biff_rec(ba, 0x000f /* CalcRefMode */, writebool(true));
	write_biff_rec(ba, 0x0011 /* CalcIter */, writebool(false));
	write_biff_rec(ba, 0x0010 /* CalcDelta */, write_Xnum(0.001));
	write_biff_rec(ba, 0x005f /* CalcSaveRecalc */, writebool(true));
	write_biff_rec(ba, 0x002a /* PrintRowCol */, writebool(false));
	write_biff_rec(ba, 0x002b /* PrintGrid */, writebool(false));
	write_biff_rec(ba, 0x0082 /* GridSet */, writeuint16(1));
	write_biff_rec(ba, 0x0080 /* Guts */, write_Guts([0,0]));
	/* DefaultRowHeight WsBool [Sync] [LPr] [HorizontalPageBreaks] [VerticalPageBreaks] */
	/* Header (string) */
	/* Footer (string) */
	write_biff_rec(ba, 0x0083 /* HCenter */, writebool(false));
	write_biff_rec(ba, 0x0084 /* VCenter */, writebool(false));
	/* ... */
	if(b8) write_ws_cols_biff8(ba, ws["!cols"]);
	/* ... */
	write_biff_rec(ba, 0x200, write_Dimensions(range, opts));
	/* ... */

	if(b8) ws['!links'] = [];
	for(var R = range.s.r; R <= range.e.r; ++R) {
		rr = encode_row(R);
		for(var C = range.s.c; C <= range.e.c; ++C) {
			if(R === range.s.r) cols[C] = encode_col(C);
			ref = cols[C] + rr;
			var cell = dense ? (ws[R]||[])[C] : ws[ref];
			if(!cell) continue;
			/* write cell */
			write_ws_biff8_cell(ba, cell, R, C, opts);
			if(b8 && cell.l) ws['!links'].push([ref, cell.l]);
		}
	}
	var cname/*:string*/ = _sheet.CodeName || _sheet.name || s;
	/* ... */
	if(b8) write_biff_rec(ba, 0x023e /* Window2 */, write_Window2((_WB.Views||[])[0]));
	/* ... */
	if(b8 && (ws['!merges']||[]).length) write_biff_rec(ba, 0x00e5 /* MergeCells */, write_MergeCells(ws['!merges']));
	/* [LRng] *QUERYTABLE [PHONETICINFO] CONDFMTS */
	if(b8) write_ws_biff8_hlinks(ba, ws);
	/* [DVAL] */
	write_biff_rec(ba, 0x01ba /* CodeName */, write_XLUnicodeString(cname, opts));
	/* *WebPub *CellWatch [SheetExt] */
	if(b8) write_FEAT(ba, ws);
	/* *FEAT11 *RECORD12 */
	write_biff_rec(ba, 0x000a /* EOF */);
	return ba.end();
}

/* [MS-XLS] 2.1.7.20.3 */
function write_biff8_global(wb/*:Workbook*/, bufs, opts/*:WriteOpts*/) {
	var A = buf_array();
	var _WB/*:WBWBProps*/ = ((wb||{}).Workbook||{}/*:any*/);
	var _sheets/*:Array<WBWSProp>*/ = (_WB.Sheets||[]);
	var _wb/*:WBProps*/ = /*::((*/_WB.WBProps||{/*::CodeName:"ThisWorkbook"*/}/*:: ):any)*/;
	var b8 = opts.biff == 8, b5 = opts.biff == 5;
	write_biff_rec(A, 0x0809, write_BOF(wb, 0x05, opts));
	if(opts.bookType == "xla") write_biff_rec(A, 0x0087 /* Addin */);
	write_biff_rec(A, 0x00e1 /* InterfaceHdr */, b8 ? writeuint16(0x04b0) : null);
	write_biff_rec(A, 0x00c1 /* Mms */, writezeroes(2));
	if(b5) write_biff_rec(A, 0x00bf /* ToolbarHdr */);
	if(b5) write_biff_rec(A, 0x00c0 /* ToolbarEnd */);
	write_biff_rec(A, 0x00e2 /* InterfaceEnd */);
	write_biff_rec(A, 0x005c /* WriteAccess */, write_WriteAccess("SheetJS", opts));
	/* [FileSharing] */
	write_biff_rec(A, 0x0042 /* CodePage */, writeuint16(b8 ? 0x04b0 : 0x04E4));
	/* *2047 Lel */
	if(b8) write_biff_rec(A, 0x0161 /* DSF */, writeuint16(0));
	if(b8) write_biff_rec(A, 0x01c0 /* Excel9File */);
	write_biff_rec(A, 0x013d /* RRTabId */, write_RRTabId(wb.SheetNames.length));
	if(b8 && wb.vbaraw) write_biff_rec(A, 0x00d3 /* ObProj */);
	/* [ObNoMacros] */
	if(b8 && wb.vbaraw) {
		var cname/*:string*/ = _wb.CodeName || "ThisWorkbook";
		write_biff_rec(A, 0x01ba /* CodeName */, write_XLUnicodeString(cname, opts));
	}
	write_biff_rec(A, 0x009c /* BuiltInFnGroupCount */, writeuint16(0x11));
	/* *FnGroupName *FnGrp12 */
	/* *Lbl */
	/* [OleObjectSize] */
	write_biff_rec(A, 0x0019 /* WinProtect */, writebool(false));
	write_biff_rec(A, 0x0012 /* Protect */, writebool(false));
	write_biff_rec(A, 0x0013 /* Password */, writeuint16(0));
	if(b8) write_biff_rec(A, 0x01af /* Prot4Rev */, writebool(false));
	if(b8) write_biff_rec(A, 0x01bc /* Prot4RevPass */, writeuint16(0));
	write_biff_rec(A, 0x003d /* Window1 */, write_Window1(opts));
	write_biff_rec(A, 0x0040 /* Backup */, writebool(false));
	write_biff_rec(A, 0x008d /* HideObj */, writeuint16(0));
	write_biff_rec(A, 0x0022 /* Date1904 */, writebool(safe1904(wb)=="true"));
	write_biff_rec(A, 0x000e /* CalcPrecision */, writebool(true));
	if(b8) write_biff_rec(A, 0x01b7 /* RefreshAll */, writebool(false));
	write_biff_rec(A, 0x00DA /* BookBool */, writeuint16(0));
	/* ... */
	write_FONTS_biff8(A, wb, opts);
	write_FMTS_biff8(A, wb.SSF, opts);
	write_CELLXFS_biff8(A, opts);
	/* ... */
	if(b8) write_biff_rec(A, 0x0160 /* UsesELFs */, writebool(false));
	var a = A.end();

	var C = buf_array();
	/* METADATA [MTRSettings] [ForceFullCalculation] */
	if(b8) write_biff_rec(C, 0x008C, write_Country());
	/* *SUPBOOK *LBL *RTD [RecalcId] *HFPicture *MSODRAWINGGROUP */

	/* BIFF8: [SST *Continue] ExtSST */
	if(b8 && opts.Strings) write_biff_continue(C, 0x00FC, write_SST(opts.Strings, opts));

	/* *WebPub [WOpt] [CrErr] [BookExt] *FeatHdr *DConn [THEME] [CompressPictures] [Compat12] [GUIDTypeLib] */
	write_biff_rec(C, 0x000A /* EOF */);
	var c = C.end();

	var B = buf_array();
	var blen = 0, j = 0;
	for(j = 0; j < wb.SheetNames.length; ++j) blen += (b8 ? 12 : 11) + (b8 ? 2 : 1) * wb.SheetNames[j].length;
	var start = a.length + blen + c.length;
	for(j = 0; j < wb.SheetNames.length; ++j) {
		var _sheet/*:WBWSProp*/ = _sheets[j] || ({}/*:any*/);
		write_biff_rec(B, 0x0085 /* BoundSheet8 */, write_BoundSheet8({pos:start, hs:_sheet.Hidden||0, dt:0, name:wb.SheetNames[j]}, opts));
		start += bufs[j].length;
	}
	/* 1*BoundSheet8 */
	var b = B.end();
	if(blen != b.length) throw new Error("BS8 " + blen + " != " + b.length);

	var out = [];
	if(a.length) out.push(a);
	if(b.length) out.push(b);
	if(c.length) out.push(c);
	return bconcat(out);
}

/* [MS-XLS] 2.1.7.20 Workbook Stream */
function write_biff8_buf(wb/*:Workbook*/, opts/*:WriteOpts*/) {
	var o = opts || {};
	var bufs = [];

	if(wb && !wb.SSF) {
		wb.SSF = dup(table_fmt);
	}
	if(wb && wb.SSF) {
		make_ssf(); SSF_load_table(wb.SSF);
		// $FlowIgnore
		o.revssf = evert_num(wb.SSF); o.revssf[wb.SSF[65535]] = 0;
		o.ssf = wb.SSF;
	}

	o.Strings = /*::((*/[]/*:: :any):SST)*/; o.Strings.Count = 0; o.Strings.Unique = 0;
	fix_write_opts(o);

	o.cellXfs = [];
	get_cell_style(o.cellXfs, {}, {revssf:{"General":0}});

	if(!wb.Props) wb.Props = {};

	for(var i = 0; i < wb.SheetNames.length; ++i) bufs[bufs.length] = write_ws_biff8(i, o, wb);
	bufs.unshift(write_biff8_global(wb, bufs, o));
	return bconcat(bufs);
}

function write_biff_buf(wb/*:Workbook*/, opts/*:WriteOpts*/) {
	for(var i = 0; i <= wb.SheetNames.length; ++i) {
		var ws = wb.Sheets[wb.SheetNames[i]];
		if(!ws || !ws["!ref"]) continue;
		var range = decode_range(ws["!ref"]);
		if(range.e.c > 255) { // note: 255 is IV
		if(typeof console != "undefined" && console.error) console.error("Worksheet '" + wb.SheetNames[i] + "' extends beyond column IV (255).  Data may be lost.");
		}
	}

	var o = opts || {};
	switch(o.biff || 2) {
		case 8: case 5: return write_biff8_buf(wb, opts);
		case 4: case 3: case 2: return write_biff2_buf(wb, opts);
	}
	throw new Error("invalid type " + o.bookType + " for BIFF");
}
/* note: browser DOM element cannot see mso- style attrs, must parse */
function html_to_sheet(str/*:string*/, _opts)/*:Workbook*/ {
	var opts = _opts || {};
	if(DENSE != null && opts.dense == null) opts.dense = DENSE;
	var ws/*:Worksheet*/ = opts.dense ? ([]/*:any*/) : ({}/*:any*/);
	str = str.replace(/<!--.*?-->/g, "");
	var mtch/*:any*/ = str.match(/<table/i);
	if(!mtch) throw new Error("Invalid HTML: could not find <table>");
	var mtch2/*:any*/ = str.match(/<\/table/i);
	var i/*:number*/ = mtch.index, j/*:number*/ = mtch2 && mtch2.index || str.length;
	var rows = split_regex(str.slice(i, j), /(:?<tr[^>]*>)/i, "<tr>");
	var R = -1, C = 0, RS = 0, CS = 0;
	var range/*:Range*/ = {s:{r:10000000, c:10000000},e:{r:0,c:0}};
	var merges/*:Array<Range>*/ = [];
	for(i = 0; i < rows.length; ++i) {
		var row = rows[i].trim();
		var hd = row.slice(0,3).toLowerCase();
		if(hd == "<tr") { ++R; if(opts.sheetRows && opts.sheetRows <= R) { --R; break; } C = 0; continue; }
		if(hd != "<td" && hd != "<th") continue;
		var cells = row.split(/<\/t[dh]>/i);
		for(j = 0; j < cells.length; ++j) {
			var cell = cells[j].trim();
			if(!cell.match(/<t[dh]/i)) continue;
			var m = cell, cc = 0;
			/* TODO: parse styles etc */
			while(m.charAt(0) == "<" && (cc = m.indexOf(">")) > -1) m = m.slice(cc+1);
			for(var midx = 0; midx < merges.length; ++midx) {
				var _merge/*:Range*/ = merges[midx];
				if(_merge.s.c == C && _merge.s.r < R && R <= _merge.e.r) { C = _merge.e.c + 1; midx = -1; }
			}
			var tag = parsexmltag(cell.slice(0, cell.indexOf(">")));
			CS = tag.colspan ? +tag.colspan : 1;
			if((RS = +tag.rowspan)>1 || CS>1) merges.push({s:{r:R,c:C},e:{r:R + (RS||1) - 1, c:C + CS - 1}});
			var _t/*:string*/ = tag.t || tag["data-t"] || "";
			/* TODO: generate stub cells */
			if(!m.length) { C += CS; continue; }
			m = htmldecode(m);
			if(range.s.r > R) range.s.r = R; if(range.e.r < R) range.e.r = R;
			if(range.s.c > C) range.s.c = C; if(range.e.c < C) range.e.c = C;
			if(!m.length) { C += CS; continue; }
			var o/*:Cell*/ = {t:'s', v:m};
			if(opts.raw || !m.trim().length || _t == 's'){}
			else if(m === 'TRUE') o = {t:'b', v:true};
			else if(m === 'FALSE') o = {t:'b', v:false};
			else if(!isNaN(fuzzynum(m))) o = {t:'n', v:fuzzynum(m)};
			else if(!isNaN(fuzzydate(m).getDate())) {
				o = ({t:'d', v:parseDate(m)}/*:any*/);
				if(!opts.cellDates) o = ({t:'n', v:datenum(o.v)}/*:any*/);
				o.z = opts.dateNF || table_fmt[14];
			}
			if(opts.dense) { if(!ws[R]) ws[R] = []; ws[R][C] = o; }
			else ws[encode_cell({r:R, c:C})] = o;
			C += CS;
		}
	}
	ws['!ref'] = encode_range(range);
	if(merges.length) ws["!merges"] = merges;
	return ws;
}
function make_html_row(ws/*:Worksheet*/, r/*:Range*/, R/*:number*/, o/*:Sheet2HTMLOpts*/)/*:string*/ {
	var M/*:Array<Range>*/ = (ws['!merges'] ||[]);
	var oo/*:Array<string>*/ = [];
	for(var C = r.s.c; C <= r.e.c; ++C) {
		var RS = 0, CS = 0;
		for(var j = 0; j < M.length; ++j) {
			if(M[j].s.r > R || M[j].s.c > C) continue;
			if(M[j].e.r < R || M[j].e.c < C) continue;
			if(M[j].s.r < R || M[j].s.c < C) { RS = -1; break; }
			RS = M[j].e.r - M[j].s.r + 1; CS = M[j].e.c - M[j].s.c + 1; break;
		}
		if(RS < 0) continue;
		var coord = encode_cell({r:R,c:C});
		var cell = o.dense ? (ws[R]||[])[C] : ws[coord];
		/* TODO: html entities */
		var w = (cell && cell.v != null) && (cell.h || escapehtml(cell.w || (format_cell(cell), cell.w) || "")) || "";
		var sp = ({}/*:any*/);
		if(RS > 1) sp.rowspan = RS;
		if(CS > 1) sp.colspan = CS;
		if(o.editable) w = '<span contenteditable="true">' + w + '</span>';
		else if(cell) {
			sp["data-t"] = cell && cell.t || 'z';
			if(cell.v != null) sp["data-v"] = cell.v;
			if(cell.z != null) sp["data-z"] = cell.z;
			if(cell.l && (cell.l.Target || "#").charAt(0) != "#") w = '<a href="' + cell.l.Target +'">' + w + '</a>';
		}
		sp.id = (o.id || "sjs") + "-" + coord;
		oo.push(writextag('td', w, sp));
	}
	var preamble = "<tr>";
	return preamble + oo.join("") + "</tr>";
}

var HTML_BEGIN = '<html><head><meta charset="utf-8"/><title>SheetJS Table Export</title></head><body>';
var HTML_END = '</body></html>';

function html_to_workbook(str/*:string*/, opts)/*:Workbook*/ {
	var mtch = str.match(/<table[\s\S]*?>[\s\S]*?<\/table>/gi);
	if(!mtch || mtch.length == 0) throw new Error("Invalid HTML: could not find <table>");
	if(mtch.length == 1) return sheet_to_workbook(html_to_sheet(mtch[0], opts), opts);
	var wb = book_new();
	mtch.forEach(function(s, idx) { book_append_sheet(wb, html_to_sheet(s, opts), "Sheet" + (idx+1)); });
	return wb;
}

function make_html_preamble(ws/*:Worksheet*/, R/*:Range*/, o/*:Sheet2HTMLOpts*/)/*:string*/ {
	var out/*:Array<string>*/ = [];
	return out.join("") + '<table' + (o && o.id ? ' id="' + o.id + '"' : "") + '>';
}

function sheet_to_html(ws/*:Worksheet*/, opts/*:?Sheet2HTMLOpts*//*, wb:?Workbook*/)/*:string*/ {
	var o = opts || {};
	var header = o.header != null ? o.header : HTML_BEGIN;
	var footer = o.footer != null ? o.footer : HTML_END;
	var out/*:Array<string>*/ = [header];
	var r = decode_range(ws['!ref']);
	o.dense = Array.isArray(ws);
	out.push(make_html_preamble(ws, r, o));
	for(var R = r.s.r; R <= r.e.r; ++R) out.push(make_html_row(ws, r, R, o));
	out.push("</table>" + footer);
	return out.join("");
}

function sheet_add_dom(ws/*:Worksheet*/, table/*:HTMLElement*/, _opts/*:?any*/)/*:Worksheet*/ {
	var opts = _opts || {};
	if(DENSE != null) opts.dense = DENSE;
	var or_R = 0, or_C = 0;
	if(opts.origin != null) {
		if(typeof opts.origin == 'number') or_R = opts.origin;
		else {
			var _origin/*:CellAddress*/ = typeof opts.origin == "string" ? decode_cell(opts.origin) : opts.origin;
			or_R = _origin.r; or_C = _origin.c;
		}
	}

	var rows/*:HTMLCollection<HTMLTableRowElement>*/ = table.getElementsByTagName('tr');
	var sheetRows = Math.min(opts.sheetRows||10000000, rows.length);
	var range/*:Range*/ = {s:{r:0,c:0},e:{r:or_R,c:or_C}};
	if(ws["!ref"]) {
		var _range/*:Range*/ = decode_range(ws["!ref"]);
		range.s.r = Math.min(range.s.r, _range.s.r);
		range.s.c = Math.min(range.s.c, _range.s.c);
		range.e.r = Math.max(range.e.r, _range.e.r);
		range.e.c = Math.max(range.e.c, _range.e.c);
		if(or_R == -1) range.e.r = or_R = _range.e.r + 1;
	}
	var merges/*:Array<Range>*/ = [], midx = 0;
	var rowinfo/*:Array<RowInfo>*/ = ws["!rows"] || (ws["!rows"] = []);
	var _R = 0, R = 0, _C = 0, C = 0, RS = 0, CS = 0;
	if(!ws["!cols"]) ws['!cols'] = [];
	for(; _R < rows.length && R < sheetRows; ++_R) {
		var row/*:HTMLTableRowElement*/ = rows[_R];
		if (is_dom_element_hidden(row)) {
			if (opts.display) continue;
			rowinfo[R] = {hidden: true};
		}
		var elts/*:HTMLCollection<HTMLTableCellElement>*/ = (row.children/*:any*/);
		for(_C = C = 0; _C < elts.length; ++_C) {
			var elt/*:HTMLTableCellElement*/ = elts[_C];
			if (opts.display && is_dom_element_hidden(elt)) continue;
			var v/*:?string*/ = elt.hasAttribute('data-v') ? elt.getAttribute('data-v') : elt.hasAttribute('v') ? elt.getAttribute('v') : htmldecode(elt.innerHTML);
			var z/*:?string*/ = elt.getAttribute('data-z') || elt.getAttribute('z');
			for(midx = 0; midx < merges.length; ++midx) {
				var m/*:Range*/ = merges[midx];
				if(m.s.c == C + or_C && m.s.r < R + or_R && R + or_R <= m.e.r) { C = m.e.c+1 - or_C; midx = -1; }
			}
			/* TODO: figure out how to extract nonstandard mso- style */
			CS = +elt.getAttribute("colspan") || 1;
			if( ((RS = (+elt.getAttribute("rowspan") || 1)))>1 || CS>1) merges.push({s:{r:R + or_R,c:C + or_C},e:{r:R + or_R + (RS||1) - 1, c:C + or_C + (CS||1) - 1}});
			var o/*:Cell*/ = {t:'s', v:v};
			var _t/*:string*/ = elt.getAttribute("data-t") || elt.getAttribute("t") || "";
			if(v != null) {
				if(v.length == 0) o.t = _t || 'z';
				else if(opts.raw || v.trim().length == 0 || _t == "s"){}
				else if(v === 'TRUE') o = {t:'b', v:true};
				else if(v === 'FALSE') o = {t:'b', v:false};
				else if(!isNaN(fuzzynum(v))) o = {t:'n', v:fuzzynum(v)};
				else if(!isNaN(fuzzydate(v).getDate())) {
					o = ({t:'d', v:parseDate(v)}/*:any*/);
					if(!opts.cellDates) o = ({t:'n', v:datenum(o.v)}/*:any*/);
					o.z = opts.dateNF || table_fmt[14];
				}
			}
			if(o.z === undefined && z != null) o.z = z;
			/* The first link is used.  Links are assumed to be fully specified.
			 * TODO: The right way to process relative links is to make a new <a> */
			var l = "", Aelts = elt.getElementsByTagName("A");
			if(Aelts && Aelts.length) for(var Aelti = 0; Aelti < Aelts.length; ++Aelti)	if(Aelts[Aelti].hasAttribute("href")) {
				l = Aelts[Aelti].getAttribute("href"); if(l.charAt(0) != "#") break;
			}
			if(l && l.charAt(0) != "#") o.l = ({ Target: l });
			if(opts.dense) { if(!ws[R + or_R]) ws[R + or_R] = []; ws[R + or_R][C + or_C] = o; }
			else ws[encode_cell({c:C + or_C, r:R + or_R})] = o;
			if(range.e.c < C + or_C) range.e.c = C + or_C;
			C += CS;
		}
		++R;
	}
	if(merges.length) ws['!merges'] = (ws["!merges"] || []).concat(merges);
	range.e.r = Math.max(range.e.r, R - 1 + or_R);
	ws['!ref'] = encode_range(range);
	if(R >= sheetRows) ws['!fullref'] = encode_range((range.e.r = rows.length-_R+R-1 + or_R,range)); // We can count the real number of rows to parse but we don't to improve the performance
	return ws;
}

function parse_dom_table(table/*:HTMLElement*/, _opts/*:?any*/)/*:Worksheet*/ {
	var opts = _opts || {};
	var ws/*:Worksheet*/ = opts.dense ? ([]/*:any*/) : ({}/*:any*/);
	return sheet_add_dom(ws, table, _opts);
}

function table_to_book(table/*:HTMLElement*/, opts/*:?any*/)/*:Workbook*/ {
	return sheet_to_workbook(parse_dom_table(table, opts), opts);
}

function is_dom_element_hidden(element/*:HTMLElement*/)/*:boolean*/ {
	var display/*:string*/ = '';
	var get_computed_style/*:?function*/ = get_get_computed_style_function(element);
	if(get_computed_style) display = get_computed_style(element).getPropertyValue('display');
	if(!display) display = element.style && element.style.display;
	return display === 'none';
}

/* global getComputedStyle */
function get_get_computed_style_function(element/*:HTMLElement*/)/*:?function*/ {
	// The proper getComputedStyle implementation is the one defined in the element window
	if(element.ownerDocument.defaultView && typeof element.ownerDocument.defaultView.getComputedStyle === 'function') return element.ownerDocument.defaultView.getComputedStyle;
	// If it is not available, try to get one from the global namespace
	if(typeof getComputedStyle === 'function') return getComputedStyle;
	return null;
}
/* OpenDocument */
function parse_text_p(text/*:string*//*::, tag*/)/*:Array<any>*/ {
	/* 6.1.2 White Space Characters */
	var fixed = text
		.replace(/[\t\r\n]/g, " ").trim().replace(/ +/g, " ")
		.replace(/<text:s\/>/g," ")
		.replace(/<text:s text:c="(\d+)"\/>/g, function($$,$1) { return Array(parseInt($1,10)+1).join(" "); })
		.replace(/<text:tab[^>]*\/>/g,"\t")
		.replace(/<text:line-break\/>/g,"\n");
	var v = unescapexml(fixed.replace(/<[^>]*>/g,""));

	return [v];
}

var number_formats_ods = {
	/* ods name: [short ssf fmt, long ssf fmt] */
	day:           ["d",   "dd"],
	month:         ["m",   "mm"],
	year:          ["y",   "yy"],
	hours:         ["h",   "hh"],
	minutes:       ["m",   "mm"],
	seconds:       ["s",   "ss"],
	"am-pm":       ["A/P", "AM/PM"],
	"day-of-week": ["ddd", "dddd"],
	era:           ["e",   "ee"],
	/* there is no native representation of LO "Q" format */
	quarter:       ["\\Qm", "m\\\"th quarter\""]
};


function parse_content_xml(d/*:string*/, _opts)/*:Workbook*/ {
		var opts = _opts || {};
		if(DENSE != null && opts.dense == null) opts.dense = DENSE;
		var str = xlml_normalize(d);
		var state/*:Array<any>*/ = [], tmp;
		var tag/*:: = {}*/;
		var NFtag = {name:""}, NF = "", pidx = 0;
		var sheetag/*:: = {name:"", '名称':""}*/;
		var rowtag/*:: = {'行号':""}*/;
		var Sheets = {}, SheetNames/*:Array<string>*/ = [];
		var ws = opts.dense ? ([]/*:any*/) : ({}/*:any*/);
		var Rn, q/*:: :any = ({t:"", v:null, z:null, w:"",c:[],}:any)*/;
		var ctag = ({value:""}/*:any*/);
		var textp = "", textpidx = 0, textptag/*:: = {}*/;
		var textR = [];
		var R = -1, C = -1, range = {s: {r:1000000,c:10000000}, e: {r:0, c:0}};
		var row_ol = 0;
		var number_format_map = {};
		var merges/*:Array<Range>*/ = [], mrange = {}, mR = 0, mC = 0;
		var rowinfo/*:Array<RowInfo>*/ = [], rowpeat = 1, colpeat = 1;
		var arrayf/*:Array<[Range, string]>*/ = [];
		var WB = {Names:[]};
		var atag = ({}/*:any*/);
		var _Ref/*:[string, string]*/ = ["", ""];
		var comments/*:Array<Comment>*/ = [], comment/*:Comment*/ = ({}/*:any*/);
		var creator = "", creatoridx = 0;
		var isstub = false, intable = false;
		var i = 0;
		xlmlregex.lastIndex = 0;
		str = str.replace(/<!--([\s\S]*?)-->/mg,"").replace(/<!DOCTYPE[^\[]*\[[^\]]*\]>/gm,"");
		while((Rn = xlmlregex.exec(str))) switch((Rn[3]=Rn[3].replace(/_.*$/,""))) {

			case 'table': case '工作表': // 9.1.2 <table:table>
				if(Rn[1]==='/') {
					if(range.e.c >= range.s.c && range.e.r >= range.s.r) ws['!ref'] = encode_range(range);
					else ws['!ref'] = "A1:A1";
					if(opts.sheetRows > 0 && opts.sheetRows <= range.e.r) {
						ws['!fullref'] = ws['!ref'];
						range.e.r = opts.sheetRows - 1;
						ws['!ref'] = encode_range(range);
					}
					if(merges.length) ws['!merges'] = merges;
					if(rowinfo.length) ws["!rows"] = rowinfo;
					sheetag.name = sheetag['名称'] || sheetag.name;
					if(typeof JSON !== 'undefined') JSON.stringify(sheetag);
					SheetNames.push(sheetag.name);
					Sheets[sheetag.name] = ws;
					intable = false;
				}
				else if(Rn[0].charAt(Rn[0].length-2) !== '/') {
					sheetag = parsexmltag(Rn[0], false);
					R = C = -1;
					range.s.r = range.s.c = 10000000; range.e.r = range.e.c = 0;
					ws = opts.dense ? ([]/*:any*/) : ({}/*:any*/); merges = [];
					rowinfo = [];
					intable = true;
				}
				break;

			case 'table-row-group': // 9.1.9 <table:table-row-group>
				if(Rn[1] === "/") --row_ol; else ++row_ol;
				break;
			case 'table-row': case '行': // 9.1.3 <table:table-row>
				if(Rn[1] === '/') { R+=rowpeat; rowpeat = 1; break; }
				rowtag = parsexmltag(Rn[0], false);
				if(rowtag['行号']) R = rowtag['行号'] - 1; else if(R == -1) R = 0;
				rowpeat = +rowtag['number-rows-repeated'] || 1;
				/* TODO: remove magic */
				if(rowpeat < 10) for(i = 0; i < rowpeat; ++i) if(row_ol > 0) rowinfo[R + i] = {level: row_ol};
				C = -1; break;
			case 'covered-table-cell': // 9.1.5 <table:covered-table-cell>
				if(Rn[1] !== '/') ++C;
				if(opts.sheetStubs) {
					if(opts.dense) { if(!ws[R]) ws[R] = []; ws[R][C] = {t:'z'}; }
					else ws[encode_cell({r:R,c:C})] = {t:'z'};
				}
				textp = ""; textR = [];
				break; /* stub */
			case 'table-cell': case '数据':
				if(Rn[0].charAt(Rn[0].length-2) === '/') {
					++C;
					ctag = parsexmltag(Rn[0], false);
					colpeat = parseInt(ctag['number-columns-repeated']||"1", 10);
					q = ({t:'z', v:null/*:: , z:null, w:"",c:[]*/}/*:any*/);
					if(ctag.formula && opts.cellFormula != false) q.f = ods_to_csf_formula(unescapexml(ctag.formula));
					if((ctag['数据类型'] || ctag['value-type']) == "string") {
						q.t = "s"; q.v = unescapexml(ctag['string-value'] || "");
						if(opts.dense) {
							if(!ws[R]) ws[R] = [];
							ws[R][C] = q;
						} else {
							ws[encode_cell({r:R,c:C})] = q;
						}
					}
					C+= colpeat-1;
				} else if(Rn[1]!=='/') {
					++C;
					textp = ""; textpidx = 0; textR = [];
					colpeat = 1;
					var rptR = rowpeat ? R + rowpeat - 1 : R;
					if(C > range.e.c) range.e.c = C;
					if(C < range.s.c) range.s.c = C;
					if(R < range.s.r) range.s.r = R;
					if(rptR > range.e.r) range.e.r = rptR;
					ctag = parsexmltag(Rn[0], false);
					comments = []; comment = ({}/*:any*/);
					q = ({t:ctag['数据类型'] || ctag['value-type'], v:null/*:: , z:null, w:"",c:[]*/}/*:any*/);
					if(opts.cellFormula) {
						if(ctag.formula) ctag.formula = unescapexml(ctag.formula);
						if(ctag['number-matrix-columns-spanned'] && ctag['number-matrix-rows-spanned']) {
							mR = parseInt(ctag['number-matrix-rows-spanned'],10) || 0;
							mC = parseInt(ctag['number-matrix-columns-spanned'],10) || 0;
							mrange = {s: {r:R,c:C}, e:{r:R + mR-1,c:C + mC-1}};
							q.F = encode_range(mrange);
							arrayf.push([mrange, q.F]);
						}
						if(ctag.formula) q.f = ods_to_csf_formula(ctag.formula);
						else for(i = 0; i < arrayf.length; ++i)
							if(R >= arrayf[i][0].s.r && R <= arrayf[i][0].e.r)
								if(C >= arrayf[i][0].s.c && C <= arrayf[i][0].e.c)
									q.F = arrayf[i][1];
					}
					if(ctag['number-columns-spanned'] || ctag['number-rows-spanned']) {
						mR = parseInt(ctag['number-rows-spanned'],10) || 0;
						mC = parseInt(ctag['number-columns-spanned'],10) || 0;
						mrange = {s: {r:R,c:C}, e:{r:R + mR-1,c:C + mC-1}};
						merges.push(mrange);
					}

					/* 19.675.2 table:number-columns-repeated */
					if(ctag['number-columns-repeated']) colpeat = parseInt(ctag['number-columns-repeated'], 10);

					/* 19.385 office:value-type */
					switch(q.t) {
						case 'boolean': q.t = 'b'; q.v = parsexmlbool(ctag['boolean-value']); break;
						case 'float': q.t = 'n'; q.v = parseFloat(ctag.value); break;
						case 'percentage': q.t = 'n'; q.v = parseFloat(ctag.value); break;
						case 'currency': q.t = 'n'; q.v = parseFloat(ctag.value); break;
						case 'date': q.t = 'd'; q.v = parseDate(ctag['date-value']);
							if(!opts.cellDates) { q.t = 'n'; q.v = datenum(q.v); }
							q.z = 'm/d/yy'; break;
						case 'time': q.t = 'n'; q.v = parse_isodur(ctag['time-value'])/86400;
							if(opts.cellDates) { q.t = 'd'; q.v = numdate(q.v); }
							q.z = 'HH:MM:SS'; break;
						case 'number': q.t = 'n'; q.v = parseFloat(ctag['数据数值']); break;
						default:
							if(q.t === 'string' || q.t === 'text' || !q.t) {
								q.t = 's';
								if(ctag['string-value'] != null) { textp = unescapexml(ctag['string-value']); textR = []; }
							} else throw new Error('Unsupported value type ' + q.t);
					}
				} else {
					isstub = false;
					if(q.t === 's') {
						q.v = textp || '';
						if(textR.length) q.R = textR;
						isstub = textpidx == 0;
					}
					if(atag.Target) q.l = atag;
					if(comments.length > 0) { q.c = comments; comments = []; }
					if(textp && opts.cellText !== false) q.w = textp;
					if(isstub) { q.t = "z"; delete q.v; }
					if(!isstub || opts.sheetStubs) {
						if(!(opts.sheetRows && opts.sheetRows <= R)) {
							for(var rpt = 0; rpt < rowpeat; ++rpt) {
								colpeat = parseInt(ctag['number-columns-repeated']||"1", 10);
								if(opts.dense) {
									if(!ws[R + rpt]) ws[R + rpt] = [];
									ws[R + rpt][C] = rpt == 0 ? q : dup(q);
									while(--colpeat > 0) ws[R + rpt][C + colpeat] = dup(q);
								} else {
									ws[encode_cell({r:R + rpt,c:C})] = q;
									while(--colpeat > 0) ws[encode_cell({r:R + rpt,c:C + colpeat})] = dup(q);
								}
								if(range.e.c <= C) range.e.c = C;
							}
						}
					}
					colpeat = parseInt(ctag['number-columns-repeated']||"1", 10);
					C += colpeat-1; colpeat = 0;
					q = {/*:: t:"", v:null, z:null, w:"",c:[]*/};
					textp = ""; textR = [];
				}
				atag = ({}/*:any*/);
				break; // 9.1.4 <table:table-cell>

			/* pure state */
			case 'document': // TODO: <office:document> is the root for FODS
			case 'document-content': case '电子表格文档': // 3.1.3.2 <office:document-content>
			case 'spreadsheet': case '主体': // 3.7 <office:spreadsheet>
			case 'scripts': // 3.12 <office:scripts>
			case 'styles': // TODO <office:styles>
			case 'font-face-decls': // 3.14 <office:font-face-decls>
			case 'master-styles': // 3.15.4 <office:master-styles> -- relevant for FODS
				if(Rn[1]==='/'){if((tmp=state.pop())[0]!==Rn[3]) throw "Bad state: "+tmp;}
				else if(Rn[0].charAt(Rn[0].length-2) !== '/') state.push([Rn[3], true]);
				break;

			case 'annotation': // 14.1 <office:annotation>
				if(Rn[1]==='/'){
					if((tmp=state.pop())[0]!==Rn[3]) throw "Bad state: "+tmp;
					comment.t = textp;
					if(textR.length) /*::(*/comment/*:: :any)*/.R = textR;
					comment.a = creator;
					comments.push(comment);
				}
				else if(Rn[0].charAt(Rn[0].length-2) !== '/') {state.push([Rn[3], false]);}
				creator = ""; creatoridx = 0;
				textp = ""; textpidx = 0; textR = [];
				break;

			case 'creator': // 4.3.2.7 <dc:creator>
				if(Rn[1]==='/') { creator = str.slice(creatoridx,Rn.index); }
				else creatoridx = Rn.index + Rn[0].length;
				break;

			/* ignore state */
			case 'meta': case '元数据': // TODO: <office:meta> <uof:元数据> FODS/UOF
			case 'settings': // TODO: <office:settings>
			case 'config-item-set': // TODO: <office:config-item-set>
			case 'config-item-map-indexed': // TODO: <office:config-item-map-indexed>
			case 'config-item-map-entry': // TODO: <office:config-item-map-entry>
			case 'config-item-map-named': // TODO: <office:config-item-map-entry>
			case 'shapes': // 9.2.8 <table:shapes>
			case 'frame': // 10.4.2 <draw:frame>
			case 'text-box': // 10.4.3 <draw:text-box>
			case 'image': // 10.4.4 <draw:image>
			case 'data-pilot-tables': // 9.6.2 <table:data-pilot-tables>
			case 'list-style': // 16.30 <text:list-style>
			case 'form': // 13.13 <form:form>
			case 'dde-links': // 9.8 <table:dde-links>
			case 'event-listeners': // TODO
			case 'chart': // TODO
				if(Rn[1]==='/'){if((tmp=state.pop())[0]!==Rn[3]) throw "Bad state: "+tmp;}
				else if(Rn[0].charAt(Rn[0].length-2) !== '/') state.push([Rn[3], false]);
				textp = ""; textpidx = 0; textR = [];
				break;

			case 'scientific-number': // TODO: <number:scientific-number>
				break;
			case 'currency-symbol': // TODO: <number:currency-symbol>
				break;
			case 'currency-style': // TODO: <number:currency-style>
				break;
			case 'number-style': // 16.27.2 <number:number-style>
			case 'percentage-style': // 16.27.9 <number:percentage-style>
			case 'date-style': // 16.27.10 <number:date-style>
			case 'time-style': // 16.27.18 <number:time-style>
				if(Rn[1]==='/'){
					number_format_map[NFtag.name] = NF;
					if((tmp=state.pop())[0]!==Rn[3]) throw "Bad state: "+tmp;
				} else if(Rn[0].charAt(Rn[0].length-2) !== '/') {
					NF = "";
					NFtag = parsexmltag(Rn[0], false);
					state.push([Rn[3], true]);
				} break;

			case 'script': break; // 3.13 <office:script>
			case 'libraries': break; // TODO: <ooo:libraries>
			case 'automatic-styles': break; // 3.15.3 <office:automatic-styles>

			case 'default-style': // TODO: <style:default-style>
			case 'page-layout': break; // TODO: <style:page-layout>
			case 'style': // 16.2 <style:style>
				break;
			case 'map': break; // 16.3 <style:map>
			case 'font-face': break; // 16.21 <style:font-face>

			case 'paragraph-properties': break; // 17.6 <style:paragraph-properties>
			case 'table-properties': break; // 17.15 <style:table-properties>
			case 'table-column-properties': break; // 17.16 <style:table-column-properties>
			case 'table-row-properties': break; // 17.17 <style:table-row-properties>
			case 'table-cell-properties': break; // 17.18 <style:table-cell-properties>

			case 'number': // 16.27.3 <number:number>
				switch(state[state.length-1][0]) {
					case 'time-style':
					case 'date-style':
						tag = parsexmltag(Rn[0], false);
						NF += number_formats_ods[Rn[3]][tag.style==='long'?1:0]; break;
				} break;

			case 'fraction': break; // TODO 16.27.6 <number:fraction>

			case 'day': // 16.27.11 <number:day>
			case 'month': // 16.27.12 <number:month>
			case 'year': // 16.27.13 <number:year>
			case 'era': // 16.27.14 <number:era>
			case 'day-of-week': // 16.27.15 <number:day-of-week>
			case 'week-of-year': // 16.27.16 <number:week-of-year>
			case 'quarter': // 16.27.17 <number:quarter>
			case 'hours': // 16.27.19 <number:hours>
			case 'minutes': // 16.27.20 <number:minutes>
			case 'seconds': // 16.27.21 <number:seconds>
			case 'am-pm': // 16.27.22 <number:am-pm>
				switch(state[state.length-1][0]) {
					case 'time-style':
					case 'date-style':
						tag = parsexmltag(Rn[0], false);
						NF += number_formats_ods[Rn[3]][tag.style==='long'?1:0]; break;
				} break;

			case 'boolean-style': break; // 16.27.23 <number:boolean-style>
			case 'boolean': break; // 16.27.24 <number:boolean>
			case 'text-style': break; // 16.27.25 <number:text-style>
			case 'text': // 16.27.26 <number:text>
				if(Rn[0].slice(-2) === "/>") break;
				else if(Rn[1]==="/") switch(state[state.length-1][0]) {
					case 'number-style':
					case 'date-style':
					case 'time-style':
						NF += str.slice(pidx, Rn.index);
						break;
				}
				else pidx = Rn.index + Rn[0].length;
				break;

			case 'named-range': // 9.4.12 <table:named-range>
				tag = parsexmltag(Rn[0], false);
				_Ref = ods_to_csf_3D(tag['cell-range-address']);
				var nrange = ({Name:tag.name, Ref:_Ref[0] + '!' + _Ref[1]}/*:any*/);
				if(intable) nrange.Sheet = SheetNames.length;
				WB.Names.push(nrange);
				break;

			case 'text-content': break; // 16.27.27 <number:text-content>
			case 'text-properties': break; // 16.27.27 <style:text-properties>
			case 'embedded-text': break; // 16.27.4 <number:embedded-text>

			case 'body': case '电子表格': break; // 3.3 16.9.6 19.726.3

			case 'forms': break; // 12.25.2 13.2
			case 'table-column': break; // 9.1.6 <table:table-column>
			case 'table-header-rows': break; // 9.1.7 <table:table-header-rows>
			case 'table-rows': break; // 9.1.12 <table:table-rows>
			/* TODO: outline levels */
			case 'table-column-group': break; // 9.1.10 <table:table-column-group>
			case 'table-header-columns': break; // 9.1.11 <table:table-header-columns>
			case 'table-columns': break; // 9.1.12 <table:table-columns>

			case 'null-date': break; // 9.4.2 <table:null-date> TODO: date1904

			case 'graphic-properties': break; // 17.21 <style:graphic-properties>
			case 'calculation-settings': break; // 9.4.1 <table:calculation-settings>
			case 'named-expressions': break; // 9.4.11 <table:named-expressions>
			case 'label-range': break; // 9.4.9 <table:label-range>
			case 'label-ranges': break; // 9.4.10 <table:label-ranges>
			case 'named-expression': break; // 9.4.13 <table:named-expression>
			case 'sort': break; // 9.4.19 <table:sort>
			case 'sort-by': break; // 9.4.20 <table:sort-by>
			case 'sort-groups': break; // 9.4.22 <table:sort-groups>

			case 'tab': break; // 6.1.4 <text:tab>
			case 'line-break': break; // 6.1.5 <text:line-break>
			case 'span': break; // 6.1.7 <text:span>
			case 'p': case '文本串': // 5.1.3 <text:p>
				if(['master-styles'].indexOf(state[state.length-1][0]) > -1) break;
				if(Rn[1]==='/' && (!ctag || !ctag['string-value'])) {
					var ptp = parse_text_p(str.slice(textpidx,Rn.index), textptag);
					textp = (textp.length > 0 ? textp + "\n" : "") + ptp[0];
				} else { textptag = parsexmltag(Rn[0], false); textpidx = Rn.index + Rn[0].length; }
				break; // <text:p>
			case 's': break; // <text:s>

			case 'database-range': // 9.4.15 <table:database-range>
				if(Rn[1]==='/') break;
				try {
					_Ref = ods_to_csf_3D(parsexmltag(Rn[0])['target-range-address']);
					Sheets[_Ref[0]]['!autofilter'] = { ref:_Ref[1] };
				} catch(e) {/* empty */}
				break;

			case 'date': break; // <*:date>

			case 'object': break; // 10.4.6.2 <draw:object>
			case 'title': case '标题': break; // <*:title> OR <uof:标题>
			case 'desc': break; // <*:desc>
			case 'binary-data': break; // 10.4.5 TODO: b64 blob

			/* 9.2 Advanced Tables */
			case 'table-source': break; // 9.2.6
			case 'scenario': break; // 9.2.6

			case 'iteration': break; // 9.4.3 <table:iteration>
			case 'content-validations': break; // 9.4.4 <table:
			case 'content-validation': break; // 9.4.5 <table:
			case 'help-message': break; // 9.4.6 <table:
			case 'error-message': break; // 9.4.7 <table:
			case 'database-ranges': break; // 9.4.14 <table:database-ranges>
			case 'filter': break; // 9.5.2 <table:filter>
			case 'filter-and': break; // 9.5.3 <table:filter-and>
			case 'filter-or': break; // 9.5.4 <table:filter-or>
			case 'filter-condition': break; // 9.5.5 <table:filter-condition>

			case 'list-level-style-bullet': break; // 16.31 <text:
			case 'list-level-style-number': break; // 16.32 <text:
			case 'list-level-properties': break; // 17.19 <style:

			/* 7.3 Document Fields */
			case 'sender-firstname': // 7.3.6.2
			case 'sender-lastname': // 7.3.6.3
			case 'sender-initials': // 7.3.6.4
			case 'sender-title': // 7.3.6.5
			case 'sender-position': // 7.3.6.6
			case 'sender-email': // 7.3.6.7
			case 'sender-phone-private': // 7.3.6.8
			case 'sender-fax': // 7.3.6.9
			case 'sender-company': // 7.3.6.10
			case 'sender-phone-work': // 7.3.6.11
			case 'sender-street': // 7.3.6.12
			case 'sender-city': // 7.3.6.13
			case 'sender-postal-code': // 7.3.6.14
			case 'sender-country': // 7.3.6.15
			case 'sender-state-or-province': // 7.3.6.16
			case 'author-name': // 7.3.7.1
			case 'author-initials': // 7.3.7.2
			case 'chapter': // 7.3.8
			case 'file-name': // 7.3.9
			case 'template-name': // 7.3.9
			case 'sheet-name': // 7.3.9
				break;

			case 'event-listener':
				break;
			/* TODO: FODS Properties */
			case 'initial-creator':
			case 'creation-date':
			case 'print-date':
			case 'generator':
			case 'document-statistic':
			case 'user-defined':
			case 'editing-duration':
			case 'editing-cycles':
				break;

			/* TODO: FODS Config */
			case 'config-item':
				break;

			/* TODO: style tokens */
			case 'page-number': break; // TODO <text:page-number>
			case 'page-count': break; // TODO <text:page-count>
			case 'time': break; // TODO <text:time>

			/* 9.3 Advanced Table Cells */
			case 'cell-range-source': break; // 9.3.1 <table:
			case 'detective': break; // 9.3.2 <table:
			case 'operation': break; // 9.3.3 <table:
			case 'highlighted-range': break; // 9.3.4 <table:

			/* 9.6 Data Pilot Tables <table: */
			case 'data-pilot-table': // 9.6.3
			case 'source-cell-range': // 9.6.5
			case 'source-service': // 9.6.6
			case 'data-pilot-field': // 9.6.7
			case 'data-pilot-level': // 9.6.8
			case 'data-pilot-subtotals': // 9.6.9
			case 'data-pilot-subtotal': // 9.6.10
			case 'data-pilot-members': // 9.6.11
			case 'data-pilot-member': // 9.6.12
			case 'data-pilot-display-info': // 9.6.13
			case 'data-pilot-sort-info': // 9.6.14
			case 'data-pilot-layout-info': // 9.6.15
			case 'data-pilot-field-reference': // 9.6.16
			case 'data-pilot-groups': // 9.6.17
			case 'data-pilot-group': // 9.6.18
			case 'data-pilot-group-member': // 9.6.19
				break;

			/* 10.3 Drawing Shapes */
			case 'rect': // 10.3.2
				break;

			/* 14.6 DDE Connections */
			case 'dde-connection-decls': // 14.6.2 <text:
			case 'dde-connection-decl': // 14.6.3 <text:
			case 'dde-link': // 14.6.4 <table:
			case 'dde-source': // 14.6.5 <office:
				break;

			case 'properties': break; // 13.7 <form:properties>
			case 'property': break; // 13.8 <form:property>

			case 'a': // 6.1.8 hyperlink
				if(Rn[1]!== '/') {
					atag = parsexmltag(Rn[0], false);
					if(!atag.href) break;
					atag.Target = unescapexml(atag.href); delete atag.href;
					if(atag.Target.charAt(0) == "#" && atag.Target.indexOf(".") > -1) {
						_Ref = ods_to_csf_3D(atag.Target.slice(1));
						atag.Target = "#" + _Ref[0] + "!" + _Ref[1];
					} else if(atag.Target.match(/^\.\.[\\\/]/)) atag.Target = atag.Target.slice(3);
				}
				break;

			/* non-standard */
			case 'table-protection': break;
			case 'data-pilot-grand-total': break; // <table:
			case 'office-document-common-attrs': break; // bare
			default: switch(Rn[2]) {
				case 'dc:':       // TODO: properties
				case 'calcext:':  // ignore undocumented extensions
				case 'loext:':    // ignore undocumented extensions
				case 'ooo:':      // ignore undocumented extensions
				case 'chartooo:': // ignore undocumented extensions
				case 'draw:':     // TODO: drawing
				case 'style:':    // TODO: styles
				case 'chart:':    // TODO: charts
				case 'form:':     // TODO: forms
				case 'uof:':      // TODO: uof
				case '表:':       // TODO: uof
				case '字:':       // TODO: uof
					break;
				default: if(opts.WTF) throw new Error(Rn);
			}
		}
		var out/*:Workbook*/ = ({
			Sheets: Sheets,
			SheetNames: SheetNames,
			Workbook: WB
		}/*:any*/);
		if(opts.bookSheets) delete /*::(*/out/*:: :any)*/.Sheets;
		return out;
}

function parse_ods(zip/*:ZIPFile*/, opts/*:?ParseOpts*/)/*:Workbook*/ {
	opts = opts || ({}/*:any*/);
	if(safegetzipfile(zip, 'META-INF/manifest.xml')) parse_manifest(getzipdata(zip, 'META-INF/manifest.xml'), opts);
	var content = getzipstr(zip, 'content.xml');
	if(!content) throw new Error("Missing content.xml in ODS / UOF file");
	var wb = parse_content_xml(utf8read(content), opts);
	if(safegetzipfile(zip, 'meta.xml')) wb.Props = parse_core_props(getzipdata(zip, 'meta.xml'));
	return wb;
}
function parse_fods(data/*:string*/, opts/*:?ParseOpts*/)/*:Workbook*/ {
	return parse_content_xml(data, opts);
}

/* OpenDocument */
var write_styles_ods/*:{(wb:any, opts:any):string}*/ = /* @__PURE__ */(function() {
	var master_styles = [
		'<office:master-styles>',
			'<style:master-page style:name="mp1" style:page-layout-name="mp1">',
				'<style:header/>',
				'<style:header-left style:display="false"/>',
				'<style:footer/>',
				'<style:footer-left style:display="false"/>',
			'</style:master-page>',
		'</office:master-styles>'
	].join("");

	var payload = '<office:document-styles ' + wxt_helper({
		'xmlns:office':   "urn:oasis:names:tc:opendocument:xmlns:office:1.0",
		'xmlns:table':    "urn:oasis:names:tc:opendocument:xmlns:table:1.0",
		'xmlns:style':    "urn:oasis:names:tc:opendocument:xmlns:style:1.0",
		'xmlns:text':     "urn:oasis:names:tc:opendocument:xmlns:text:1.0",
		'xmlns:draw':     "urn:oasis:names:tc:opendocument:xmlns:drawing:1.0",
		'xmlns:fo':       "urn:oasis:names:tc:opendocument:xmlns:xsl-fo-compatible:1.0",
		'xmlns:xlink':    "http://www.w3.org/1999/xlink",
		'xmlns:dc':       "http://purl.org/dc/elements/1.1/",
		'xmlns:number':   "urn:oasis:names:tc:opendocument:xmlns:datastyle:1.0",
		'xmlns:svg':      "urn:oasis:names:tc:opendocument:xmlns:svg-compatible:1.0",
		'xmlns:of':       "urn:oasis:names:tc:opendocument:xmlns:of:1.2",
		'office:version': "1.2"
	}) + '>' + master_styles + '</office:document-styles>';

	return function wso(/*::wb, opts*/) {
		return XML_HEADER + payload;
	};
})();
var write_content_ods/*:{(wb:any, opts:any):string}*/ = /* @__PURE__ */(function() {
	/* 6.1.2 White Space Characters */
	var write_text_p = function(text/*:string*/)/*:string*/ {
		return escapexml(text)
			.replace(/  +/g, function($$){return '<text:s text:c="'+$$.length+'"/>';})
			.replace(/\t/g, "<text:tab/>")
			.replace(/\n/g, "</text:p><text:p>")
			.replace(/^ /, "<text:s/>").replace(/ $/, "<text:s/>");
	};

	var null_cell_xml = '          <table:table-cell />\n';
	var covered_cell_xml = '          <table:covered-table-cell/>\n';
	var write_ws = function(ws, wb/*:Workbook*/, i/*:number*//*::, opts*/)/*:string*/ {
		/* Section 9 Tables */
		var o/*:Array<string>*/ = [];
		o.push('      <table:table table:name="' + escapexml(wb.SheetNames[i]) + '" table:style-name="ta1">\n');
		var R=0,C=0, range = decode_range(ws['!ref']||"A1");
		var marr/*:Array<Range>*/ = ws['!merges'] || [], mi = 0;
		var dense = Array.isArray(ws);
		if(ws["!cols"]) {
			for(C = 0; C <= range.e.c; ++C) o.push('        <table:table-column' + (ws["!cols"][C] ? ' table:style-name="co' + ws["!cols"][C].ods + '"' : '') + '></table:table-column>\n');
		}
		var H = "", ROWS = ws["!rows"]||[];
		for(R = 0; R < range.s.r; ++R) {
			H = ROWS[R] ? ' table:style-name="ro' + ROWS[R].ods + '"' : "";
			o.push('        <table:table-row' + H + '></table:table-row>\n');
		}
		for(; R <= range.e.r; ++R) {
			H = ROWS[R] ? ' table:style-name="ro' + ROWS[R].ods + '"' : "";
			o.push('        <table:table-row' + H + '>\n');
			for(C=0; C < range.s.c; ++C) o.push(null_cell_xml);
			for(; C <= range.e.c; ++C) {
				var skip = false, ct = {}, textp = "";
				for(mi = 0; mi != marr.length; ++mi) {
					if(marr[mi].s.c > C) continue;
					if(marr[mi].s.r > R) continue;
					if(marr[mi].e.c < C) continue;
					if(marr[mi].e.r < R) continue;
					if(marr[mi].s.c != C || marr[mi].s.r != R) skip = true;
					ct['table:number-columns-spanned'] = (marr[mi].e.c - marr[mi].s.c + 1);
					ct['table:number-rows-spanned'] =    (marr[mi].e.r - marr[mi].s.r + 1);
					break;
				}
				if(skip) { o.push(covered_cell_xml); continue; }
				var ref = encode_cell({r:R, c:C}), cell = dense ? (ws[R]||[])[C]: ws[ref];
				if(cell && cell.f) {
					ct['table:formula'] = escapexml(csf_to_ods_formula(cell.f));
					if(cell.F) {
						if(cell.F.slice(0, ref.length) == ref) {
							var _Fref = decode_range(cell.F);
							ct['table:number-matrix-columns-spanned'] = (_Fref.e.c - _Fref.s.c + 1);
							ct['table:number-matrix-rows-spanned'] =    (_Fref.e.r - _Fref.s.r + 1);
						}
					}
				}
				if(!cell) { o.push(null_cell_xml); continue; }
				switch(cell.t) {
					case 'b':
						textp = (cell.v ? 'TRUE' : 'FALSE');
						ct['office:value-type'] = "boolean";
						ct['office:boolean-value'] = (cell.v ? 'true' : 'false');
						break;
					case 'n':
						textp = (cell.w||String(cell.v||0));
						ct['office:value-type'] = "float";
						ct['office:value'] = (cell.v||0);
						break;
					case 's': case 'str':
						textp = cell.v == null ? "" : cell.v;
						ct['office:value-type'] = "string";
						break;
					case 'd':
						textp = (cell.w||(parseDate(cell.v).toISOString()));
						ct['office:value-type'] = "date";
						ct['office:date-value'] = (parseDate(cell.v).toISOString());
						ct['table:style-name'] = "ce1";
						break;
					//case 'e':
					default: o.push(null_cell_xml); continue;
				}
				var text_p = write_text_p(textp);
				if(cell.l && cell.l.Target) {
					var _tgt = cell.l.Target;
					_tgt = _tgt.charAt(0) == "#" ? "#" + csf_to_ods_3D(_tgt.slice(1)) : _tgt;
					// TODO: choose correct parent path format based on link delimiters
					if(_tgt.charAt(0) != "#" && !_tgt.match(/^\w+:/)) _tgt = '../' + _tgt;
					text_p = writextag('text:a', text_p, {'xlink:href': _tgt.replace(/&/g, "&amp;")});
				}
				o.push('          ' + writextag('table:table-cell', writextag('text:p', text_p, {}), ct) + '\n');
			}
			o.push('        </table:table-row>\n');
		}
		o.push('      </table:table>\n');
		return o.join("");
	};

	var write_automatic_styles_ods = function(o/*:Array<string>*/, wb) {
		o.push(' <office:automatic-styles>\n');

		o.push('  <number:date-style style:name="N37" number:automatic-order="true">\n');
		o.push('   <number:month number:style="long"/>\n');
		o.push('   <number:text>/</number:text>\n');
		o.push('   <number:day number:style="long"/>\n');
		o.push('   <number:text>/</number:text>\n');
		o.push('   <number:year/>\n');
		o.push('  </number:date-style>\n');

		/* column styles */
		var cidx = 0;
		wb.SheetNames.map(function(n) { return wb.Sheets[n]; }).forEach(function(ws) {
			if(!ws) return;
			if(ws["!cols"]) {
				for(var C = 0; C < ws["!cols"].length; ++C) if(ws["!cols"][C]) {
					var colobj = ws["!cols"][C];
					if(colobj.width == null && colobj.wpx == null && colobj.wch == null) continue;
					process_col(colobj);
					colobj.ods = cidx;
					var w = ws["!cols"][C].wpx + "px";
					o.push('  <style:style style:name="co' + cidx + '" style:family="table-column">\n');
					o.push('   <style:table-column-properties fo:break-before="auto" style:column-width="' + w + '"/>\n');
					o.push('  </style:style>\n');
					++cidx;
				}
			}
		});

		/* row styles */
		var ridx = 0;
		wb.SheetNames.map(function(n) { return wb.Sheets[n]; }).forEach(function(ws) {
			if(!ws) return;
			if(ws["!rows"]) {
				for(var R = 0; R < ws["!rows"].length; ++R) if(ws["!rows"][R]) {
					ws["!rows"][R].ods = ridx;
					var h = ws["!rows"][R].hpx + "px";
					o.push('  <style:style style:name="ro' + ridx + '" style:family="table-row">\n');
					o.push('   <style:table-row-properties fo:break-before="auto" style:row-height="' + h + '"/>\n');
					o.push('  </style:style>\n');
					++ridx;
				}
			}
		});

		/* table */
		o.push('  <style:style style:name="ta1" style:family="table" style:master-page-name="mp1">\n');
		o.push('   <style:table-properties table:display="true" style:writing-mode="lr-tb"/>\n');
		o.push('  </style:style>\n');

		/* table cells, text */
		o.push('  <style:style style:name="ce1" style:family="table-cell" style:parent-style-name="Default" style:data-style-name="N37"/>\n');

		/* page-layout */

		o.push(' </office:automatic-styles>\n');
	};

	return function wcx(wb, opts) {
		var o = [XML_HEADER];
		/* 3.1.3.2 */
		var attr = wxt_helper({
			'xmlns:office':       "urn:oasis:names:tc:opendocument:xmlns:office:1.0",
			'xmlns:table':        "urn:oasis:names:tc:opendocument:xmlns:table:1.0",
			'xmlns:style':        "urn:oasis:names:tc:opendocument:xmlns:style:1.0",
			'xmlns:text':         "urn:oasis:names:tc:opendocument:xmlns:text:1.0",
			'xmlns:draw':         "urn:oasis:names:tc:opendocument:xmlns:drawing:1.0",
			'xmlns:fo':           "urn:oasis:names:tc:opendocument:xmlns:xsl-fo-compatible:1.0",
			'xmlns:xlink':        "http://www.w3.org/1999/xlink",
			'xmlns:dc':           "http://purl.org/dc/elements/1.1/",
			'xmlns:meta':         "urn:oasis:names:tc:opendocument:xmlns:meta:1.0",
			'xmlns:number':       "urn:oasis:names:tc:opendocument:xmlns:datastyle:1.0",
			'xmlns:presentation': "urn:oasis:names:tc:opendocument:xmlns:presentation:1.0",
			'xmlns:svg':          "urn:oasis:names:tc:opendocument:xmlns:svg-compatible:1.0",
			'xmlns:chart':        "urn:oasis:names:tc:opendocument:xmlns:chart:1.0",
			'xmlns:dr3d':         "urn:oasis:names:tc:opendocument:xmlns:dr3d:1.0",
			'xmlns:math':         "http://www.w3.org/1998/Math/MathML",
			'xmlns:form':         "urn:oasis:names:tc:opendocument:xmlns:form:1.0",
			'xmlns:script':       "urn:oasis:names:tc:opendocument:xmlns:script:1.0",
			'xmlns:ooo':          "http://openoffice.org/2004/office",
			'xmlns:ooow':         "http://openoffice.org/2004/writer",
			'xmlns:oooc':         "http://openoffice.org/2004/calc",
			'xmlns:dom':          "http://www.w3.org/2001/xml-events",
			'xmlns:xforms':       "http://www.w3.org/2002/xforms",
			'xmlns:xsd':          "http://www.w3.org/2001/XMLSchema",
			'xmlns:xsi':          "http://www.w3.org/2001/XMLSchema-instance",
			'xmlns:sheet':        "urn:oasis:names:tc:opendocument:sh33tjs:1.0",
			'xmlns:rpt':          "http://openoffice.org/2005/report",
			'xmlns:of':           "urn:oasis:names:tc:opendocument:xmlns:of:1.2",
			'xmlns:xhtml':        "http://www.w3.org/1999/xhtml",
			'xmlns:grddl':        "http://www.w3.org/2003/g/data-view#",
			'xmlns:tableooo':     "http://openoffice.org/2009/table",
			'xmlns:drawooo':      "http://openoffice.org/2010/draw",
			'xmlns:calcext':      "urn:org:documentfoundation:names:experimental:calc:xmlns:calcext:1.0",
			'xmlns:loext':        "urn:org:documentfoundation:names:experimental:office:xmlns:loext:1.0",
			'xmlns:field':        "urn:openoffice:names:experimental:ooo-ms-interop:xmlns:field:1.0",
			'xmlns:formx':        "urn:openoffice:names:experimental:ooxml-odf-interop:xmlns:form:1.0",
			'xmlns:css3t':        "http://www.w3.org/TR/css3-text/",
			'office:version':     "1.2"
		});

		var fods = wxt_helper({
			'xmlns:config':    "urn:oasis:names:tc:opendocument:xmlns:config:1.0",
			'office:mimetype': "application/vnd.oasis.opendocument.spreadsheet"
		});

		if(opts.bookType == "fods") {
			o.push('<office:document' + attr + fods + '>\n');
			o.push(write_meta_ods().replace(/office:document-meta/g, "office:meta"));
			// TODO: settings (equiv of settings.xml for ODS)
		} else o.push('<office:document-content' + attr  + '>\n');
		// o.push('  <office:scripts/>\n');
		write_automatic_styles_ods(o, wb);
		o.push('  <office:body>\n');
		o.push('    <office:spreadsheet>\n');
		for(var i = 0; i != wb.SheetNames.length; ++i) o.push(write_ws(wb.Sheets[wb.SheetNames[i]], wb, i, opts));
		o.push('    </office:spreadsheet>\n');
		o.push('  </office:body>\n');
		if(opts.bookType == "fods") o.push('</office:document>');
		else o.push('</office:document-content>');
		return o.join("");
	};
})();

function write_ods(wb/*:any*/, opts/*:any*/) {
	if(opts.bookType == "fods") return write_content_ods(wb, opts);

	var zip = zip_new();
	var f = "";

	var manifest/*:Array<Array<string> >*/ = [];
	var rdf/*:Array<[string, string]>*/ = [];

	/* Part 3 Section 3.3 MIME Media Type */
	f = "mimetype";
	zip_add_file(zip, f, "application/vnd.oasis.opendocument.spreadsheet");

	/* Part 1 Section 2.2 Documents */
	f = "content.xml";
	zip_add_file(zip, f, write_content_ods(wb, opts));
	manifest.push([f, "text/xml"]);
	rdf.push([f, "ContentFile"]);

	/* TODO: these are hard-coded styles to satiate excel */
	f = "styles.xml";
	zip_add_file(zip, f, write_styles_ods(wb, opts));
	manifest.push([f, "text/xml"]);
	rdf.push([f, "StylesFile"]);

	/* TODO: this is hard-coded to satiate excel */
	f = "meta.xml";
	zip_add_file(zip, f, XML_HEADER + write_meta_ods(/*::wb, opts*/));
	manifest.push([f, "text/xml"]);
	rdf.push([f, "MetadataFile"]);

	/* Part 3 Section 6 Metadata Manifest File */
	f = "manifest.rdf";
	zip_add_file(zip, f, write_rdf(rdf/*, opts*/));
	manifest.push([f, "application/rdf+xml"]);

	/* Part 3 Section 4 Manifest File */
	f = "META-INF/manifest.xml";
	zip_add_file(zip, f, write_manifest(manifest/*, opts*/));

	return zip;
}

/*! sheetjs (C) 2013-present SheetJS -- http://sheetjs.com */
function u8_to_dataview(array) {
  return new DataView(array.buffer, array.byteOffset, array.byteLength);
}
function u8str(u8) {
  return typeof TextDecoder != "undefined" ? new TextDecoder().decode(u8) : utf8read(a2s(u8));
}
function stru8(str) {
  return typeof TextEncoder != "undefined" ? new TextEncoder().encode(str) : s2a(utf8write(str));
}
function u8contains(body, search) {
  outer:
    for (var L = 0; L <= body.length - search.length; ++L) {
      for (var j = 0; j < search.length; ++j)
        if (body[L + j] != search[j])
          continue outer;
      return true;
    }
  return false;
}
function u8concat(u8a) {
  var len = u8a.reduce(function(acc, x) {
    return acc + x.length;
  }, 0);
  var out = new Uint8Array(len);
  var off = 0;
  u8a.forEach(function(u8) {
    out.set(u8, off);
    off += u8.length;
  });
  return out;
}
function popcnt(x) {
  x -= x >> 1 & 1431655765;
  x = (x & 858993459) + (x >> 2 & 858993459);
  return (x + (x >> 4) & 252645135) * 16843009 >>> 24;
}
function readDecimal128LE(buf, offset) {
  var exp = (buf[offset + 15] & 127) << 7 | buf[offset + 14] >> 1;
  var mantissa = buf[offset + 14] & 1;
  for (var j = offset + 13; j >= offset; --j)
    mantissa = mantissa * 256 + buf[j];
  return (buf[offset + 15] & 128 ? -mantissa : mantissa) * Math.pow(10, exp - 6176);
}
function writeDecimal128LE(buf, offset, value) {
  var exp = Math.floor(value == 0 ? 0 : Math.LOG10E * Math.log(Math.abs(value))) + 6176 - 20;
  var mantissa = value / Math.pow(10, exp - 6176);
  buf[offset + 15] |= exp >> 7;
  buf[offset + 14] |= (exp & 127) << 1;
  for (var i = 0; mantissa >= 1; ++i, mantissa /= 256)
    buf[offset + i] = mantissa & 255;
  buf[offset + 15] |= value >= 0 ? 0 : 128;
}
function parse_varint49(buf, ptr) {
  var l = ptr ? ptr[0] : 0;
  var usz = buf[l] & 127;
  varint:
    if (buf[l++] >= 128) {
      usz |= (buf[l] & 127) << 7;
      if (buf[l++] < 128)
        break varint;
      usz |= (buf[l] & 127) << 14;
      if (buf[l++] < 128)
        break varint;
      usz |= (buf[l] & 127) << 21;
      if (buf[l++] < 128)
        break varint;
      usz += (buf[l] & 127) * Math.pow(2, 28);
      ++l;
      if (buf[l++] < 128)
        break varint;
      usz += (buf[l] & 127) * Math.pow(2, 35);
      ++l;
      if (buf[l++] < 128)
        break varint;
      usz += (buf[l] & 127) * Math.pow(2, 42);
      ++l;
      if (buf[l++] < 128)
        break varint;
    }
  if (ptr)
    ptr[0] = l;
  return usz;
}
function write_varint49(v) {
  var usz = new Uint8Array(7);
  usz[0] = v & 127;
  var L = 1;
  sz:
    if (v > 127) {
      usz[L - 1] |= 128;
      usz[L] = v >> 7 & 127;
      ++L;
      if (v <= 16383)
        break sz;
      usz[L - 1] |= 128;
      usz[L] = v >> 14 & 127;
      ++L;
      if (v <= 2097151)
        break sz;
      usz[L - 1] |= 128;
      usz[L] = v >> 21 & 127;
      ++L;
      if (v <= 268435455)
        break sz;
      usz[L - 1] |= 128;
      usz[L] = v / 256 >>> 21 & 127;
      ++L;
      if (v <= 34359738367)
        break sz;
      usz[L - 1] |= 128;
      usz[L] = v / 65536 >>> 21 & 127;
      ++L;
      if (v <= 4398046511103)
        break sz;
      usz[L - 1] |= 128;
      usz[L] = v / 16777216 >>> 21 & 127;
      ++L;
    }
  return usz.slice(0, L);
}
function varint_to_i32(buf) {
  var l = 0, i32 = buf[l] & 127;
  varint:
    if (buf[l++] >= 128) {
      i32 |= (buf[l] & 127) << 7;
      if (buf[l++] < 128)
        break varint;
      i32 |= (buf[l] & 127) << 14;
      if (buf[l++] < 128)
        break varint;
      i32 |= (buf[l] & 127) << 21;
      if (buf[l++] < 128)
        break varint;
      i32 |= (buf[l] & 127) << 28;
    }
  return i32;
}
function parse_shallow(buf) {
  var out = [], ptr = [0];
  while (ptr[0] < buf.length) {
    var off = ptr[0];
    var num = parse_varint49(buf, ptr);
    var type = num & 7;
    num = Math.floor(num / 8);
    var len = 0;
    var res;
    if (num == 0)
      break;
    switch (type) {
      case 0:
        {
          var l = ptr[0];
          while (buf[ptr[0]++] >= 128)
            ;
          res = buf.slice(l, ptr[0]);
        }
        break;
      case 5:
        len = 4;
        res = buf.slice(ptr[0], ptr[0] + len);
        ptr[0] += len;
        break;
      case 1:
        len = 8;
        res = buf.slice(ptr[0], ptr[0] + len);
        ptr[0] += len;
        break;
      case 2:
        len = parse_varint49(buf, ptr);
        res = buf.slice(ptr[0], ptr[0] + len);
        ptr[0] += len;
        break;
      case 3:
      case 4:
      default:
        throw new Error("PB Type ".concat(type, " for Field ").concat(num, " at offset ").concat(off));
    }
    var v = { data: res, type: type };
    if (out[num] == null)
      out[num] = [v];
    else
      out[num].push(v);
  }
  return out;
}
function write_shallow(proto) {
  var out = [];
  proto.forEach(function(field, idx) {
    field.forEach(function(item) {
      if (!item.data)
        return;
      out.push(write_varint49(idx * 8 + item.type));
      if (item.type == 2)
        out.push(write_varint49(item.data.length));
      out.push(item.data);
    });
  });
  return u8concat(out);
}
function mappa(data, cb) {
  return (data == null ? void 0 : data.map(function(d) {
    return cb(d.data);
  })) || [];
}
function parse_iwa_file(buf) {
  var _a;
  var out = [], ptr = [0];
  while (ptr[0] < buf.length) {
    var len = parse_varint49(buf, ptr);
    var ai = parse_shallow(buf.slice(ptr[0], ptr[0] + len));
    ptr[0] += len;
    var res = {
      id: varint_to_i32(ai[1][0].data),
      messages: []
    };
    ai[2].forEach(function(b) {
      var mi = parse_shallow(b.data);
      var fl = varint_to_i32(mi[3][0].data);
      res.messages.push({
        meta: mi,
        data: buf.slice(ptr[0], ptr[0] + fl)
      });
      ptr[0] += fl;
    });
    if ((_a = ai[3]) == null ? void 0 : _a[0])
      res.merge = varint_to_i32(ai[3][0].data) >>> 0 > 0;
    out.push(res);
  }
  return out;
}
function write_iwa_file(ias) {
  var bufs = [];
  ias.forEach(function(ia) {
    var ai = [];
    ai[1] = [{ data: write_varint49(ia.id), type: 0 }];
    ai[2] = [];
    if (ia.merge != null)
      ai[3] = [{ data: write_varint49(+!!ia.merge), type: 0 }];
    var midata = [];
    ia.messages.forEach(function(mi) {
      midata.push(mi.data);
      mi.meta[3] = [{ type: 0, data: write_varint49(mi.data.length) }];
      ai[2].push({ data: write_shallow(mi.meta), type: 2 });
    });
    var aipayload = write_shallow(ai);
    bufs.push(write_varint49(aipayload.length));
    bufs.push(aipayload);
    midata.forEach(function(mid) {
      return bufs.push(mid);
    });
  });
  return u8concat(bufs);
}
function parse_snappy_chunk(type, buf) {
  if (type != 0)
    throw new Error("Unexpected Snappy chunk type ".concat(type));
  var ptr = [0];
  var usz = parse_varint49(buf, ptr);
  var chunks = [];
  while (ptr[0] < buf.length) {
    var tag = buf[ptr[0]] & 3;
    if (tag == 0) {
      var len = buf[ptr[0]++] >> 2;
      if (len < 60)
        ++len;
      else {
        var c = len - 59;
        len = buf[ptr[0]];
        if (c > 1)
          len |= buf[ptr[0] + 1] << 8;
        if (c > 2)
          len |= buf[ptr[0] + 2] << 16;
        if (c > 3)
          len |= buf[ptr[0] + 3] << 24;
        len >>>= 0;
        len++;
        ptr[0] += c;
      }
      chunks.push(buf.slice(ptr[0], ptr[0] + len));
      ptr[0] += len;
      continue;
    } else {
      var offset = 0, length = 0;
      if (tag == 1) {
        length = (buf[ptr[0]] >> 2 & 7) + 4;
        offset = (buf[ptr[0]++] & 224) << 3;
        offset |= buf[ptr[0]++];
      } else {
        length = (buf[ptr[0]++] >> 2) + 1;
        if (tag == 2) {
          offset = buf[ptr[0]] | buf[ptr[0] + 1] << 8;
          ptr[0] += 2;
        } else {
          offset = (buf[ptr[0]] | buf[ptr[0] + 1] << 8 | buf[ptr[0] + 2] << 16 | buf[ptr[0] + 3] << 24) >>> 0;
          ptr[0] += 4;
        }
      }
      chunks = [u8concat(chunks)];
      if (offset == 0)
        throw new Error("Invalid offset 0");
      if (offset > chunks[0].length)
        throw new Error("Invalid offset beyond length");
      if (length >= offset) {
        chunks.push(chunks[0].slice(-offset));
        length -= offset;
        while (length >= chunks[chunks.length - 1].length) {
          chunks.push(chunks[chunks.length - 1]);
          length -= chunks[chunks.length - 1].length;
        }
      }
      chunks.push(chunks[0].slice(-offset, -offset + length));
    }
  }
  var o = u8concat(chunks);
  if (o.length != usz)
    throw new Error("Unexpected length: ".concat(o.length, " != ").concat(usz));
  return o;
}
function decompress_iwa_file(buf) {
  var out = [];
  var l = 0;
  while (l < buf.length) {
    var t = buf[l++];
    var len = buf[l] | buf[l + 1] << 8 | buf[l + 2] << 16;
    l += 3;
    out.push(parse_snappy_chunk(t, buf.slice(l, l + len)));
    l += len;
  }
  if (l !== buf.length)
    throw new Error("data is not a valid framed stream!");
  return u8concat(out);
}
function compress_iwa_file(buf) {
  var out = [];
  var l = 0;
  while (l < buf.length) {
    var c = Math.min(buf.length - l, 268435455);
    var frame = new Uint8Array(4);
    out.push(frame);
    var usz = write_varint49(c);
    var L = usz.length;
    out.push(usz);
    if (c <= 60) {
      L++;
      out.push(new Uint8Array([c - 1 << 2]));
    } else if (c <= 256) {
      L += 2;
      out.push(new Uint8Array([240, c - 1 & 255]));
    } else if (c <= 65536) {
      L += 3;
      out.push(new Uint8Array([244, c - 1 & 255, c - 1 >> 8 & 255]));
    } else if (c <= 16777216) {
      L += 4;
      out.push(new Uint8Array([248, c - 1 & 255, c - 1 >> 8 & 255, c - 1 >> 16 & 255]));
    } else if (c <= 4294967296) {
      L += 5;
      out.push(new Uint8Array([252, c - 1 & 255, c - 1 >> 8 & 255, c - 1 >> 16 & 255, c - 1 >>> 24 & 255]));
    }
    out.push(buf.slice(l, l + c));
    L += c;
    frame[0] = 0;
    frame[1] = L & 255;
    frame[2] = L >> 8 & 255;
    frame[3] = L >> 16 & 255;
    l += c;
  }
  return u8concat(out);
}
function parse_old_storage(buf, sst, rsst, v) {
  var dv = u8_to_dataview(buf);
  var flags = dv.getUint32(4, true);
  var data_offset = (v > 1 ? 12 : 8) + popcnt(flags & (v > 1 ? 3470 : 398)) * 4;
  var ridx = -1, sidx = -1, ieee = NaN, dt = new Date(2001, 0, 1);
  if (flags & 512) {
    ridx = dv.getUint32(data_offset, true);
    data_offset += 4;
  }
  data_offset += popcnt(flags & (v > 1 ? 12288 : 4096)) * 4;
  if (flags & 16) {
    sidx = dv.getUint32(data_offset, true);
    data_offset += 4;
  }
  if (flags & 32) {
    ieee = dv.getFloat64(data_offset, true);
    data_offset += 8;
  }
  if (flags & 64) {
    dt.setTime(dt.getTime() + dv.getFloat64(data_offset, true) * 1e3);
    data_offset += 8;
  }
  var ret;
  switch (buf[2]) {
    case 0:
      break;
    case 2:
      ret = { t: "n", v: ieee };
      break;
    case 3:
      ret = { t: "s", v: sst[sidx] };
      break;
    case 5:
      ret = { t: "d", v: dt };
      break;
    case 6:
      ret = { t: "b", v: ieee > 0 };
      break;
    case 7:
      ret = { t: "n", v: ieee / 86400 };
      break;
    case 8:
      ret = { t: "e", v: 0 };
      break;
    case 9:
      {
        if (ridx > -1)
          ret = { t: "s", v: rsst[ridx] };
        else if (sidx > -1)
          ret = { t: "s", v: sst[sidx] };
        else if (!isNaN(ieee))
          ret = { t: "n", v: ieee };
        else
          throw new Error("Unsupported cell type ".concat(buf.slice(0, 4)));
      }
      break;
    default:
      throw new Error("Unsupported cell type ".concat(buf.slice(0, 4)));
  }
  return ret;
}
function parse_new_storage(buf, sst, rsst) {
  var dv = u8_to_dataview(buf);
  var flags = dv.getUint32(8, true);
  var data_offset = 12;
  var ridx = -1, sidx = -1, d128 = NaN, ieee = NaN, dt = new Date(2001, 0, 1);
  if (flags & 1) {
    d128 = readDecimal128LE(buf, data_offset);
    data_offset += 16;
  }
  if (flags & 2) {
    ieee = dv.getFloat64(data_offset, true);
    data_offset += 8;
  }
  if (flags & 4) {
    dt.setTime(dt.getTime() + dv.getFloat64(data_offset, true) * 1e3);
    data_offset += 8;
  }
  if (flags & 8) {
    sidx = dv.getUint32(data_offset, true);
    data_offset += 4;
  }
  if (flags & 16) {
    ridx = dv.getUint32(data_offset, true);
    data_offset += 4;
  }
  var ret;
  switch (buf[1]) {
    case 0:
      break;
    case 2:
      ret = { t: "n", v: d128 };
      break;
    case 3:
      ret = { t: "s", v: sst[sidx] };
      break;
    case 5:
      ret = { t: "d", v: dt };
      break;
    case 6:
      ret = { t: "b", v: ieee > 0 };
      break;
    case 7:
      ret = { t: "n", v: ieee / 86400 };
      break;
    case 8:
      ret = { t: "e", v: 0 };
      break;
    case 9:
      {
        if (ridx > -1)
          ret = { t: "s", v: rsst[ridx] };
        else
          throw new Error("Unsupported cell type ".concat(buf[1], " : ").concat(flags & 31, " : ").concat(buf.slice(0, 4)));
      }
      break;
    case 10:
      ret = { t: "n", v: d128 };
      break;
    default:
      throw new Error("Unsupported cell type ".concat(buf[1], " : ").concat(flags & 31, " : ").concat(buf.slice(0, 4)));
  }
  return ret;
}
function write_new_storage(cell, sst) {
  var out = new Uint8Array(32), dv = u8_to_dataview(out), l = 12, flags = 0;
  out[0] = 5;
  switch (cell.t) {
    case "n":
      out[1] = 2;
      writeDecimal128LE(out, l, cell.v);
      flags |= 1;
      l += 16;
      break;
    case "b":
      out[1] = 6;
      dv.setFloat64(l, cell.v ? 1 : 0, true);
      flags |= 2;
      l += 8;
      break;
    case "s":
      if (sst.indexOf(cell.v) == -1)
        throw new Error("Value ".concat(cell.v, " missing from SST!"));
      out[1] = 3;
      dv.setUint32(l, sst.indexOf(cell.v), true);
      flags |= 8;
      l += 4;
      break;
    default:
      throw "unsupported cell type " + cell.t;
  }
  dv.setUint32(8, flags, true);
  return out.slice(0, l);
}
function write_old_storage(cell, sst) {
  var out = new Uint8Array(32), dv = u8_to_dataview(out), l = 12, flags = 0;
  out[0] = 3;
  switch (cell.t) {
    case "n":
      out[2] = 2;
      dv.setFloat64(l, cell.v, true);
      flags |= 32;
      l += 8;
      break;
    case "b":
      out[2] = 6;
      dv.setFloat64(l, cell.v ? 1 : 0, true);
      flags |= 32;
      l += 8;
      break;
    case "s":
      if (sst.indexOf(cell.v) == -1)
        throw new Error("Value ".concat(cell.v, " missing from SST!"));
      out[2] = 3;
      dv.setUint32(l, sst.indexOf(cell.v), true);
      flags |= 16;
      l += 4;
      break;
    default:
      throw "unsupported cell type " + cell.t;
  }
  dv.setUint32(4, flags, true);
  return out.slice(0, l);
}
function parse_cell_storage(buf, sst, rsst) {
  switch (buf[0]) {
    case 0:
    case 1:
    case 2:
    case 3:
      return parse_old_storage(buf, sst, rsst, buf[0]);
    case 5:
      return parse_new_storage(buf, sst, rsst);
    default:
      throw new Error("Unsupported payload version ".concat(buf[0]));
  }
}
function parse_TSP_Reference(buf) {
  var pb = parse_shallow(buf);
  return parse_varint49(pb[1][0].data);
}
function write_TSP_Reference(idx) {
  var out = [];
  out[1] = [{ type: 0, data: write_varint49(idx) }];
  return write_shallow(out);
}
function parse_TST_TableDataList(M, root) {
  var pb = parse_shallow(root.data);
  var type = varint_to_i32(pb[1][0].data);
  var entries = pb[3];
  var data = [];
  (entries || []).forEach(function(entry) {
    var le = parse_shallow(entry.data);
    var key = varint_to_i32(le[1][0].data) >>> 0;
    switch (type) {
      case 1:
        data[key] = u8str(le[3][0].data);
        break;
      case 8:
        {
          var rt = M[parse_TSP_Reference(le[9][0].data)][0];
          var rtp = parse_shallow(rt.data);
          var rtpref = M[parse_TSP_Reference(rtp[1][0].data)][0];
          var mtype = varint_to_i32(rtpref.meta[1][0].data);
          if (mtype != 2001)
            throw new Error("2000 unexpected reference to ".concat(mtype));
          var tswpsa = parse_shallow(rtpref.data);
          data[key] = tswpsa[3].map(function(x) {
            return u8str(x.data);
          }).join("");
        }
        break;
    }
  });
  return data;
}
function parse_TST_TileRowInfo(u8, type) {
  var _a, _b, _c, _d, _e, _f, _g, _h, _i, _j, _k, _l, _m, _n;
  var pb = parse_shallow(u8);
  var R = varint_to_i32(pb[1][0].data) >>> 0;
  var cnt = varint_to_i32(pb[2][0].data) >>> 0;
  var wide_offsets = ((_b = (_a = pb[8]) == null ? void 0 : _a[0]) == null ? void 0 : _b.data) && varint_to_i32(pb[8][0].data) > 0 || false;
  var used_storage_u8, used_storage;
  if (((_d = (_c = pb[7]) == null ? void 0 : _c[0]) == null ? void 0 : _d.data) && type != 0) {
    used_storage_u8 = (_f = (_e = pb[7]) == null ? void 0 : _e[0]) == null ? void 0 : _f.data;
    used_storage = (_h = (_g = pb[6]) == null ? void 0 : _g[0]) == null ? void 0 : _h.data;
  } else if (((_j = (_i = pb[4]) == null ? void 0 : _i[0]) == null ? void 0 : _j.data) && type != 1) {
    used_storage_u8 = (_l = (_k = pb[4]) == null ? void 0 : _k[0]) == null ? void 0 : _l.data;
    used_storage = (_n = (_m = pb[3]) == null ? void 0 : _m[0]) == null ? void 0 : _n.data;
  } else
    throw "NUMBERS Tile missing ".concat(type, " cell storage");
  var width = wide_offsets ? 4 : 1;
  var used_storage_offsets = u8_to_dataview(used_storage_u8);
  var offsets = [];
  for (var C = 0; C < used_storage_u8.length / 2; ++C) {
    var off = used_storage_offsets.getUint16(C * 2, true);
    if (off < 65535)
      offsets.push([C, off]);
  }
  if (offsets.length != cnt)
    throw "Expected ".concat(cnt, " cells, found ").concat(offsets.length);
  var cells = [];
  for (C = 0; C < offsets.length - 1; ++C)
    cells[offsets[C][0]] = used_storage.subarray(offsets[C][1] * width, offsets[C + 1][1] * width);
  if (offsets.length >= 1)
    cells[offsets[offsets.length - 1][0]] = used_storage.subarray(offsets[offsets.length - 1][1] * width);
  return { R: R, cells: cells };
}
function parse_TST_Tile(M, root) {
  var _a;
  var pb = parse_shallow(root.data);
  var storage = ((_a = pb == null ? void 0 : pb[7]) == null ? void 0 : _a[0]) ? varint_to_i32(pb[7][0].data) >>> 0 > 0 ? 1 : 0 : -1;
  var ri = mappa(pb[5], function(u8) {
    return parse_TST_TileRowInfo(u8, storage);
  });
  return {
    nrows: varint_to_i32(pb[4][0].data) >>> 0,
    data: ri.reduce(function(acc, x) {
      if (!acc[x.R])
        acc[x.R] = [];
      x.cells.forEach(function(cell, C) {
        if (acc[x.R][C])
          throw new Error("Duplicate cell r=".concat(x.R, " c=").concat(C));
        acc[x.R][C] = cell;
      });
      return acc;
    }, [])
  };
}
function parse_TST_TableModelArchive(M, root, ws) {
  var _a;
  var pb = parse_shallow(root.data);
  var range = { s: { r: 0, c: 0 }, e: { r: 0, c: 0 } };
  range.e.r = (varint_to_i32(pb[6][0].data) >>> 0) - 1;
  if (range.e.r < 0)
    throw new Error("Invalid row varint ".concat(pb[6][0].data));
  range.e.c = (varint_to_i32(pb[7][0].data) >>> 0) - 1;
  if (range.e.c < 0)
    throw new Error("Invalid col varint ".concat(pb[7][0].data));
  ws["!ref"] = encode_range(range);
  var store = parse_shallow(pb[4][0].data);
  var sst = parse_TST_TableDataList(M, M[parse_TSP_Reference(store[4][0].data)][0]);
  var rsst = ((_a = store[17]) == null ? void 0 : _a[0]) ? parse_TST_TableDataList(M, M[parse_TSP_Reference(store[17][0].data)][0]) : [];
  var tile = parse_shallow(store[3][0].data);
  var _R = 0;
  tile[1].forEach(function(t) {
    var tl = parse_shallow(t.data);
    var ref = M[parse_TSP_Reference(tl[2][0].data)][0];
    var mtype = varint_to_i32(ref.meta[1][0].data);
    if (mtype != 6002)
      throw new Error("6001 unexpected reference to ".concat(mtype));
    var _tile = parse_TST_Tile(M, ref);
    _tile.data.forEach(function(row, R) {
      row.forEach(function(buf, C) {
        var addr = encode_cell({ r: _R + R, c: C });
        var res = parse_cell_storage(buf, sst, rsst);
        if (res)
          ws[addr] = res;
      });
    });
    _R += _tile.nrows;
  });
}
function parse_TST_TableInfoArchive(M, root) {
  var pb = parse_shallow(root.data);
  var out = { "!ref": "A1" };
  var tableref = M[parse_TSP_Reference(pb[2][0].data)];
  var mtype = varint_to_i32(tableref[0].meta[1][0].data);
  if (mtype != 6001)
    throw new Error("6000 unexpected reference to ".concat(mtype));
  parse_TST_TableModelArchive(M, tableref[0], out);
  return out;
}
function parse_TN_SheetArchive(M, root) {
  var _a;
  var pb = parse_shallow(root.data);
  var out = {
    name: ((_a = pb[1]) == null ? void 0 : _a[0]) ? u8str(pb[1][0].data) : "",
    sheets: []
  };
  var shapeoffs = mappa(pb[2], parse_TSP_Reference);
  shapeoffs.forEach(function(off) {
    M[off].forEach(function(m) {
      var mtype = varint_to_i32(m.meta[1][0].data);
      if (mtype == 6e3)
        out.sheets.push(parse_TST_TableInfoArchive(M, m));
    });
  });
  return out;
}
function parse_TN_DocumentArchive(M, root) {
  var out = book_new();
  var pb = parse_shallow(root.data);
  var sheetoffs = mappa(pb[1], parse_TSP_Reference);
  sheetoffs.forEach(function(off) {
    M[off].forEach(function(m) {
      var mtype = varint_to_i32(m.meta[1][0].data);
      if (mtype == 2) {
        var root2 = parse_TN_SheetArchive(M, m);
        root2.sheets.forEach(function(sheet, idx) {
          book_append_sheet(out, sheet, idx == 0 ? root2.name : root2.name + "_" + idx, true);
        });
      }
    });
  });
  if (out.SheetNames.length == 0)
    throw new Error("Empty NUMBERS file");
  return out;
}
function parse_numbers_iwa(cfb) {
  var _a, _b, _c, _d;
  var M = {}, indices = [];
  cfb.FullPaths.forEach(function(p) {
    if (p.match(/\.iwpv2/))
      throw new Error("Unsupported password protection");
  });
  cfb.FileIndex.forEach(function(s) {
    if (!s.name.match(/\.iwa$/))
      return;
    var o;
    try {
      o = decompress_iwa_file(s.content);
    } catch (e) {
      return console.log("?? " + s.content.length + " " + (e.message || e));
    }
    var packets;
    try {
      packets = parse_iwa_file(o);
    } catch (e) {
      return console.log("## " + (e.message || e));
    }
    packets.forEach(function(packet) {
      M[packet.id] = packet.messages;
      indices.push(packet.id);
    });
  });
  if (!indices.length)
    throw new Error("File has no messages");
  var docroot = ((_d = (_c = (_b = (_a = M == null ? void 0 : M[1]) == null ? void 0 : _a[0]) == null ? void 0 : _b.meta) == null ? void 0 : _c[1]) == null ? void 0 : _d[0].data) && varint_to_i32(M[1][0].meta[1][0].data) == 1 && M[1][0];
  if (!docroot)
    indices.forEach(function(idx) {
      M[idx].forEach(function(iwam) {
        var mtype = varint_to_i32(iwam.meta[1][0].data) >>> 0;
        if (mtype == 1) {
          if (!docroot)
            docroot = iwam;
          else
            throw new Error("Document has multiple roots");
        }
      });
    });
  if (!docroot)
    throw new Error("Cannot find Document root");
  return parse_TN_DocumentArchive(M, docroot);
}
function write_tile_row(tri, data, SST) {
  var _a, _b, _c, _d;
  if (!((_a = tri[6]) == null ? void 0 : _a[0]) || !((_b = tri[7]) == null ? void 0 : _b[0]))
    throw "Mutation only works on post-BNC storages!";
  var wide_offsets = ((_d = (_c = tri[8]) == null ? void 0 : _c[0]) == null ? void 0 : _d.data) && varint_to_i32(tri[8][0].data) > 0 || false;
  if (wide_offsets)
    throw "Math only works with normal offsets";
  var cnt = 0;
  var dv = u8_to_dataview(tri[7][0].data), last_offset = 0, cell_storage = [];
  var _dv = u8_to_dataview(tri[4][0].data), _last_offset = 0, _cell_storage = [];
  for (var C = 0; C < data.length; ++C) {
    if (data[C] == null) {
      dv.setUint16(C * 2, 65535, true);
      _dv.setUint16(C * 2, 65535);
      continue;
    }
    dv.setUint16(C * 2, last_offset, true);
    _dv.setUint16(C * 2, _last_offset, true);
    var celload, _celload;
    switch (typeof data[C]) {
      case "string":
        celload = write_new_storage({ t: "s", v: data[C] }, SST);
        _celload = write_old_storage({ t: "s", v: data[C] }, SST);
        break;
      case "number":
        celload = write_new_storage({ t: "n", v: data[C] }, SST);
        _celload = write_old_storage({ t: "n", v: data[C] }, SST);
        break;
      case "boolean":
        celload = write_new_storage({ t: "b", v: data[C] }, SST);
        _celload = write_old_storage({ t: "b", v: data[C] }, SST);
        break;
      default:
        throw new Error("Unsupported value " + data[C]);
    }
    cell_storage.push(celload);
    last_offset += celload.length;
    _cell_storage.push(_celload);
    _last_offset += _celload.length;
    ++cnt;
  }
  tri[2][0].data = write_varint49(cnt);
  for (; C < tri[7][0].data.length / 2; ++C) {
    dv.setUint16(C * 2, 65535, true);
    _dv.setUint16(C * 2, 65535, true);
  }
  tri[6][0].data = u8concat(cell_storage);
  tri[3][0].data = u8concat(_cell_storage);
  return cnt;
}
function write_numbers_iwa(wb, opts) {
  if (!opts || !opts.numbers)
    throw new Error("Must pass a `numbers` option -- check the README");
  var ws = wb.Sheets[wb.SheetNames[0]];
  if (wb.SheetNames.length > 1)
    console.error("The Numbers writer currently writes only the first table");
  var range = decode_range(ws["!ref"]);
  range.s.r = range.s.c = 0;
  var trunc = false;
  if (range.e.c > 9) {
    trunc = true;
    range.e.c = 9;
  }
  if (range.e.r > 49) {
    trunc = true;
    range.e.r = 49;
  }
  if (trunc)
    console.error("The Numbers writer is currently limited to ".concat(encode_range(range)));
  var data = sheet_to_json(ws, { range: range, header: 1 });
  var SST = ["~Sh33tJ5~"];
  data.forEach(function(row) {
    return row.forEach(function(cell) {
      if (typeof cell == "string")
        SST.push(cell);
    });
  });
  var dependents = {};
  var indices = [];
  var cfb = CFB.read(opts.numbers, { type: "base64" });
  cfb.FileIndex.map(function(fi, idx) {
    return [fi, cfb.FullPaths[idx]];
  }).forEach(function(row) {
    var fi = row[0], fp = row[1];
    if (fi.type != 2)
      return;
    if (!fi.name.match(/\.iwa/))
      return;
    var old_content = fi.content;
    var raw1 = decompress_iwa_file(old_content);
    var x2 = parse_iwa_file(raw1);
    x2.forEach(function(packet2) {
      indices.push(packet2.id);
      dependents[packet2.id] = { deps: [], location: fp, type: varint_to_i32(packet2.messages[0].meta[1][0].data) };
    });
  });
  indices.sort(function(x2, y2) {
    return x2 - y2;
  });
  var indices_varint = indices.filter(function(x2) {
    return x2 > 1;
  }).map(function(x2) {
    return [x2, write_varint49(x2)];
  });
  cfb.FileIndex.map(function(fi, idx) {
    return [fi, cfb.FullPaths[idx]];
  }).forEach(function(row) {
    var fi = row[0], fp = row[1];
    if (!fi.name.match(/\.iwa/))
      return;
    var x2 = parse_iwa_file(decompress_iwa_file(fi.content));
    x2.forEach(function(ia) {
      ia.messages.forEach(function(m) {
        indices_varint.forEach(function(ivi) {
          if (ia.messages.some(function(mess) {
            return varint_to_i32(mess.meta[1][0].data) != 11006 && u8contains(mess.data, ivi[1]);
          })) {
            dependents[ivi[0]].deps.push(ia.id);
          }
        });
      });
    });
  });
  function get_unique_msgid() {
    for (var i = 927262; i < 2e6; ++i)
      if (!dependents[i])
        return i;
    throw new Error("Too many messages");
  }
  var entry = CFB.find(cfb, dependents[1].location);
  var x = parse_iwa_file(decompress_iwa_file(entry.content));
  var docroot;
  for (var xi = 0; xi < x.length; ++xi) {
    var packet = x[xi];
    if (packet.id == 1)
      docroot = packet;
  }
  var sheetrootref = parse_TSP_Reference(parse_shallow(docroot.messages[0].data)[1][0].data);
  entry = CFB.find(cfb, dependents[sheetrootref].location);
  x = parse_iwa_file(decompress_iwa_file(entry.content));
  for (xi = 0; xi < x.length; ++xi) {
    packet = x[xi];
    if (packet.id == sheetrootref)
      docroot = packet;
  }
  sheetrootref = parse_TSP_Reference(parse_shallow(docroot.messages[0].data)[2][0].data);
  entry = CFB.find(cfb, dependents[sheetrootref].location);
  x = parse_iwa_file(decompress_iwa_file(entry.content));
  for (xi = 0; xi < x.length; ++xi) {
    packet = x[xi];
    if (packet.id == sheetrootref)
      docroot = packet;
  }
  sheetrootref = parse_TSP_Reference(parse_shallow(docroot.messages[0].data)[2][0].data);
  entry = CFB.find(cfb, dependents[sheetrootref].location);
  x = parse_iwa_file(decompress_iwa_file(entry.content));
  for (xi = 0; xi < x.length; ++xi) {
    packet = x[xi];
    if (packet.id == sheetrootref)
      docroot = packet;
  }
  var pb = parse_shallow(docroot.messages[0].data);
  {
    pb[6][0].data = write_varint49(range.e.r + 1);
    pb[7][0].data = write_varint49(range.e.c + 1);
    var cruidsref = parse_TSP_Reference(pb[46][0].data);
    var oldbucket = CFB.find(cfb, dependents[cruidsref].location);
    var _x = parse_iwa_file(decompress_iwa_file(oldbucket.content));
    {
      for (var j = 0; j < _x.length; ++j) {
        if (_x[j].id == cruidsref)
          break;
      }
      if (_x[j].id != cruidsref)
        throw "Bad ColumnRowUIDMapArchive";
      var cruids = parse_shallow(_x[j].messages[0].data);
      cruids[1] = [];
      cruids[2] = [], cruids[3] = [];
      for (var C = 0; C <= range.e.c; ++C) {
        var uuid = [];
        uuid[1] = uuid[2] = [{ type: 0, data: write_varint49(C + 420690) }];
        cruids[1].push({ type: 2, data: write_shallow(uuid) });
        cruids[2].push({ type: 0, data: write_varint49(C) });
        cruids[3].push({ type: 0, data: write_varint49(C) });
      }
      cruids[4] = [];
      cruids[5] = [], cruids[6] = [];
      for (var R = 0; R <= range.e.r; ++R) {
        uuid = [];
        uuid[1] = uuid[2] = [{ type: 0, data: write_varint49(R + 726270) }];
        cruids[4].push({ type: 2, data: write_shallow(uuid) });
        cruids[5].push({ type: 0, data: write_varint49(R) });
        cruids[6].push({ type: 0, data: write_varint49(R) });
      }
      _x[j].messages[0].data = write_shallow(cruids);
    }
    oldbucket.content = compress_iwa_file(write_iwa_file(_x));
    oldbucket.size = oldbucket.content.length;
    delete pb[46];
    var store = parse_shallow(pb[4][0].data);
    {
      store[7][0].data = write_varint49(range.e.r + 1);
      var row_headers = parse_shallow(store[1][0].data);
      var row_header_ref = parse_TSP_Reference(row_headers[2][0].data);
      oldbucket = CFB.find(cfb, dependents[row_header_ref].location);
      _x = parse_iwa_file(decompress_iwa_file(oldbucket.content));
      {
        if (_x[0].id != row_header_ref)
          throw "Bad HeaderStorageBucket";
        var base_bucket = parse_shallow(_x[0].messages[0].data);
        for (R = 0; R < data.length; ++R) {
          var _bucket = parse_shallow(base_bucket[2][0].data);
          _bucket[1][0].data = write_varint49(R);
          _bucket[4][0].data = write_varint49(data[R].length);
          base_bucket[2][R] = { type: base_bucket[2][0].type, data: write_shallow(_bucket) };
        }
        _x[0].messages[0].data = write_shallow(base_bucket);
      }
      oldbucket.content = compress_iwa_file(write_iwa_file(_x));
      oldbucket.size = oldbucket.content.length;
      var col_header_ref = parse_TSP_Reference(store[2][0].data);
      oldbucket = CFB.find(cfb, dependents[col_header_ref].location);
      _x = parse_iwa_file(decompress_iwa_file(oldbucket.content));
      {
        if (_x[0].id != col_header_ref)
          throw "Bad HeaderStorageBucket";
        base_bucket = parse_shallow(_x[0].messages[0].data);
        for (C = 0; C <= range.e.c; ++C) {
          _bucket = parse_shallow(base_bucket[2][0].data);
          _bucket[1][0].data = write_varint49(C);
          _bucket[4][0].data = write_varint49(range.e.r + 1);
          base_bucket[2][C] = { type: base_bucket[2][0].type, data: write_shallow(_bucket) };
        }
        _x[0].messages[0].data = write_shallow(base_bucket);
      }
      oldbucket.content = compress_iwa_file(write_iwa_file(_x));
      oldbucket.size = oldbucket.content.length;
      var sstref = parse_TSP_Reference(store[4][0].data);
      (function() {
        var sentry = CFB.find(cfb, dependents[sstref].location);
        var sx = parse_iwa_file(decompress_iwa_file(sentry.content));
        var sstroot;
        for (var sxi = 0; sxi < sx.length; ++sxi) {
          var packet2 = sx[sxi];
          if (packet2.id == sstref)
            sstroot = packet2;
        }
        var sstdata = parse_shallow(sstroot.messages[0].data);
        {
          sstdata[3] = [];
          var newsst = [];
          SST.forEach(function(str, i) {
            newsst[1] = [{ type: 0, data: write_varint49(i) }];
            newsst[2] = [{ type: 0, data: write_varint49(1) }];
            newsst[3] = [{ type: 2, data: stru8(str) }];
            sstdata[3].push({ type: 2, data: write_shallow(newsst) });
          });
        }
        sstroot.messages[0].data = write_shallow(sstdata);
        var sy = write_iwa_file(sx);
        var raw32 = compress_iwa_file(sy);
        sentry.content = raw32;
        sentry.size = sentry.content.length;
      })();
      var tile = parse_shallow(store[3][0].data);
      {
        var t = tile[1][0];
        delete tile[2];
        var tl = parse_shallow(t.data);
        {
          var tileref = parse_TSP_Reference(tl[2][0].data);
          (function() {
            var tentry = CFB.find(cfb, dependents[tileref].location);
            var tx = parse_iwa_file(decompress_iwa_file(tentry.content));
            var tileroot;
            for (var sxi = 0; sxi < tx.length; ++sxi) {
              var packet2 = tx[sxi];
              if (packet2.id == tileref)
                tileroot = packet2;
            }
            var tiledata = parse_shallow(tileroot.messages[0].data);
            {
              delete tiledata[6];
              delete tile[7];
              var rowload = new Uint8Array(tiledata[5][0].data);
              tiledata[5] = [];
              var cnt = 0;
              for (var R2 = 0; R2 <= range.e.r; ++R2) {
                var tilerow = parse_shallow(rowload);
                cnt += write_tile_row(tilerow, data[R2], SST);
                tilerow[1][0].data = write_varint49(R2);
                tiledata[5].push({ data: write_shallow(tilerow), type: 2 });
              }
              tiledata[1] = [{ type: 0, data: write_varint49(range.e.c + 1) }];
              tiledata[2] = [{ type: 0, data: write_varint49(range.e.r + 1) }];
              tiledata[3] = [{ type: 0, data: write_varint49(cnt) }];
              tiledata[4] = [{ type: 0, data: write_varint49(range.e.r + 1) }];
            }
            tileroot.messages[0].data = write_shallow(tiledata);
            var ty = write_iwa_file(tx);
            var raw32 = compress_iwa_file(ty);
            tentry.content = raw32;
            tentry.size = tentry.content.length;
          })();
        }
        t.data = write_shallow(tl);
      }
      store[3][0].data = write_shallow(tile);
    }
    pb[4][0].data = write_shallow(store);
  }
  docroot.messages[0].data = write_shallow(pb);
  var y = write_iwa_file(x);
  var raw3 = compress_iwa_file(y);
  entry.content = raw3;
  entry.size = entry.content.length;
  return cfb;
}
function fix_opts_func(defaults/*:Array<Array<any> >*/)/*:{(o:any):void}*/ {
	return function fix_opts(opts) {
		for(var i = 0; i != defaults.length; ++i) {
			var d = defaults[i];
			if(opts[d[0]] === undefined) opts[d[0]] = d[1];
			if(d[2] === 'n') opts[d[0]] = Number(opts[d[0]]);
		}
	};
}

function fix_read_opts(opts) {
fix_opts_func([
	['cellNF', false], /* emit cell number format string as .z */
	['cellHTML', true], /* emit html string as .h */
	['cellFormula', true], /* emit formulae as .f */
	['cellStyles', false], /* emits style/theme as .s */
	['cellText', true], /* emit formatted text as .w */
	['cellDates', false], /* emit date cells with type `d` */

	['sheetStubs', false], /* emit empty cells */
	['sheetRows', 0, 'n'], /* read n rows (0 = read all rows) */

	['bookDeps', false], /* parse calculation chains */
	['bookSheets', false], /* only try to get sheet names (no Sheets) */
	['bookProps', false], /* only try to get properties (no Sheets) */
	['bookFiles', false], /* include raw file structure (keys, files, cfb) */
	['bookVBA', false], /* include vba raw data (vbaraw) */

	['password',''], /* password */
	['WTF', false] /* WTF mode (throws errors) */
])(opts);
}

function fix_write_opts(opts) {
fix_opts_func([
	['cellDates', false], /* write date cells with type `d` */

	['bookSST', false], /* Generate Shared String Table */

	['bookType', 'xlsx'], /* Type of workbook (xlsx/m/b) */

	['compression', false], /* Use file compression */

	['WTF', false] /* WTF mode (throws errors) */
])(opts);
}
function get_sheet_type(n/*:string*/)/*:string*/ {
	if(RELS.WS.indexOf(n) > -1) return "sheet";
	if(RELS.CS && n == RELS.CS) return "chart";
	if(RELS.DS && n == RELS.DS) return "dialog";
	if(RELS.MS && n == RELS.MS) return "macro";
	return (n && n.length) ? n : "sheet";
}
function safe_parse_wbrels(wbrels, sheets) {
	if(!wbrels) return 0;
	try {
		wbrels = sheets.map(function pwbr(w) { if(!w.id) w.id = w.strRelID; return [w.name, wbrels['!id'][w.id].Target, get_sheet_type(wbrels['!id'][w.id].Type)]; });
	} catch(e) { return null; }
	return !wbrels || wbrels.length === 0 ? null : wbrels;
}

function safe_parse_sheet(zip, path/*:string*/, relsPath/*:string*/, sheet, idx/*:number*/, sheetRels, sheets, stype/*:string*/, opts, wb, themes, styles) {
	try {
		sheetRels[sheet]=parse_rels(getzipstr(zip, relsPath, true), path);
		var data = getzipdata(zip, path);
		var _ws;
		switch(stype) {
			case 'sheet':  _ws = parse_ws(data, path, idx, opts, sheetRels[sheet], wb, themes, styles); break;
			case 'chart':  _ws = parse_cs(data, path, idx, opts, sheetRels[sheet], wb, themes, styles);
				if(!_ws || !_ws['!drawel']) break;
				var dfile = resolve_path(_ws['!drawel'].Target, path);
				var drelsp = get_rels_path(dfile);
				var draw = parse_drawing(getzipstr(zip, dfile, true), parse_rels(getzipstr(zip, drelsp, true), dfile));
				var chartp = resolve_path(draw, dfile);
				var crelsp = get_rels_path(chartp);
				_ws = parse_chart(getzipstr(zip, chartp, true), chartp, opts, parse_rels(getzipstr(zip, crelsp, true), chartp), wb, _ws);
				break;
			case 'macro':  _ws = parse_ms(data, path, idx, opts, sheetRels[sheet], wb, themes, styles); break;
			case 'dialog': _ws = parse_ds(data, path, idx, opts, sheetRels[sheet], wb, themes, styles); break;
			default: throw new Error("Unrecognized sheet type " + stype);
		}
		sheets[sheet] = _ws;

		/* scan rels for comments and threaded comments */
		var tcomments = [];
		if(sheetRels && sheetRels[sheet]) keys(sheetRels[sheet]).forEach(function(n) {
			var dfile = "";
			if(sheetRels[sheet][n].Type == RELS.CMNT) {
				dfile = resolve_path(sheetRels[sheet][n].Target, path);
				var comments = parse_cmnt(getzipdata(zip, dfile, true), dfile, opts);
				if(!comments || !comments.length) return;
				sheet_insert_comments(_ws, comments, false);
			}
			if(sheetRels[sheet][n].Type == RELS.TCMNT) {
				dfile = resolve_path(sheetRels[sheet][n].Target, path);
				tcomments = tcomments.concat(parse_tcmnt_xml(getzipdata(zip, dfile, true), opts));
			}
		});
		if(tcomments && tcomments.length) sheet_insert_comments(_ws, tcomments, true, opts.people || []);
	} catch(e) { if(opts.WTF) throw e; }
}

function strip_front_slash(x/*:string*/)/*:string*/ { return x.charAt(0) == '/' ? x.slice(1) : x; }

function parse_zip(zip/*:ZIP*/, opts/*:?ParseOpts*/)/*:Workbook*/ {
	make_ssf();
	opts = opts || {};
	fix_read_opts(opts);

	/* OpenDocument Part 3 Section 2.2.1 OpenDocument Package */
	if(safegetzipfile(zip, 'META-INF/manifest.xml')) return parse_ods(zip, opts);
	/* UOC */
	if(safegetzipfile(zip, 'objectdata.xml')) return parse_ods(zip, opts);
	/* Numbers */
	if(safegetzipfile(zip, 'Index/Document.iwa')) {
		if(typeof Uint8Array == "undefined") throw new Error('NUMBERS file parsing requires Uint8Array support');
		if(typeof parse_numbers_iwa != "undefined") {
			if(zip.FileIndex) return parse_numbers_iwa(zip);
			var _zip = CFB.utils.cfb_new();
			zipentries(zip).forEach(function(e) { zip_add_file(_zip, e, getzipbin(zip, e)); });
			return parse_numbers_iwa(_zip);
		}
		throw new Error('Unsupported NUMBERS file');
	}
	if(!safegetzipfile(zip, '[Content_Types].xml')) {
		if(safegetzipfile(zip, 'index.xml.gz')) throw new Error('Unsupported NUMBERS 08 file');
		if(safegetzipfile(zip, 'index.xml')) throw new Error('Unsupported NUMBERS 09 file');
		throw new Error('Unsupported ZIP file');
	}

	var entries = zipentries(zip);
	var dir = parse_ct((getzipstr(zip, '[Content_Types].xml')/*:?any*/));
	var xlsb = false;
	var sheets, binname;
	if(dir.workbooks.length === 0) {
		binname = "xl/workbook.xml";
		if(getzipdata(zip,binname, true)) dir.workbooks.push(binname);
	}
	if(dir.workbooks.length === 0) {
		binname = "xl/workbook.bin";
		if(!getzipdata(zip,binname,true)) throw new Error("Could not find workbook");
		dir.workbooks.push(binname);
		xlsb = true;
	}
	if(dir.workbooks[0].slice(-3) == "bin") xlsb = true;

	var themes = ({}/*:any*/);
	var styles = ({}/*:any*/);
	if(!opts.bookSheets && !opts.bookProps) {
		strs = [];
		if(dir.sst) try { strs=parse_sst(getzipdata(zip, strip_front_slash(dir.sst)), dir.sst, opts); } catch(e) { if(opts.WTF) throw e; }

		if(opts.cellStyles && dir.themes.length) themes = parse_theme(getzipstr(zip, dir.themes[0].replace(/^\//,''), true)||"",dir.themes[0], opts);

		if(dir.style) styles = parse_sty(getzipdata(zip, strip_front_slash(dir.style)), dir.style, themes, opts);
	}

	/*var externbooks = */dir.links.map(function(link) {
		try {
			var rels = parse_rels(getzipstr(zip, get_rels_path(strip_front_slash(link))), link);
			return parse_xlink(getzipdata(zip, strip_front_slash(link)), rels, link, opts);
		} catch(e) {}
	});

	var wb = parse_wb(getzipdata(zip, strip_front_slash(dir.workbooks[0])), dir.workbooks[0], opts);

	var props = {}, propdata = "";

	if(dir.coreprops.length) {
		propdata = getzipdata(zip, strip_front_slash(dir.coreprops[0]), true);
		if(propdata) props = parse_core_props(propdata);
		if(dir.extprops.length !== 0) {
			propdata = getzipdata(zip, strip_front_slash(dir.extprops[0]), true);
			if(propdata) parse_ext_props(propdata, props, opts);
		}
	}

	var custprops = {};
	if(!opts.bookSheets || opts.bookProps) {
		if (dir.custprops.length !== 0) {
			propdata = getzipstr(zip, strip_front_slash(dir.custprops[0]), true);
			if(propdata) custprops = parse_cust_props(propdata, opts);
		}
	}

	var out = ({}/*:any*/);
	if(opts.bookSheets || opts.bookProps) {
		if(wb.Sheets) sheets = wb.Sheets.map(function pluck(x){ return x.name; });
		else if(props.Worksheets && props.SheetNames.length > 0) sheets=props.SheetNames;
		if(opts.bookProps) { out.Props = props; out.Custprops = custprops; }
		if(opts.bookSheets && typeof sheets !== 'undefined') out.SheetNames = sheets;
		if(opts.bookSheets ? out.SheetNames : opts.bookProps) return out;
	}
	sheets = {};

	var deps = {};
	if(opts.bookDeps && dir.calcchain) deps=parse_cc(getzipdata(zip, strip_front_slash(dir.calcchain)),dir.calcchain,opts);

	var i=0;
	var sheetRels = ({}/*:any*/);
	var path, relsPath;

	{
		var wbsheets = wb.Sheets;
		props.Worksheets = wbsheets.length;
		props.SheetNames = [];
		for(var j = 0; j != wbsheets.length; ++j) {
			props.SheetNames[j] = wbsheets[j].name;
		}
	}

	var wbext = xlsb ? "bin" : "xml";
	var wbrelsi = dir.workbooks[0].lastIndexOf("/");
	var wbrelsfile = (dir.workbooks[0].slice(0, wbrelsi+1) + "_rels/" + dir.workbooks[0].slice(wbrelsi+1) + ".rels").replace(/^\//,"");
	if(!safegetzipfile(zip, wbrelsfile)) wbrelsfile = 'xl/_rels/workbook.' + wbext + '.rels';
	var wbrels = parse_rels(getzipstr(zip, wbrelsfile, true), wbrelsfile.replace(/_rels.*/, "s5s"));

	if((dir.metadata || []).length >= 1) {
		/* TODO: MDX and other types of metadata */
		opts.xlmeta = parse_xlmeta(getzipdata(zip, strip_front_slash(dir.metadata[0])),dir.metadata[0],opts);
	}

	if((dir.people || []).length >= 1) {
		opts.people = parse_people_xml(getzipdata(zip, strip_front_slash(dir.people[0])),opts);
	}

	if(wbrels) wbrels = safe_parse_wbrels(wbrels, wb.Sheets);

	/* Numbers iOS hack */
	var nmode = (getzipdata(zip,"xl/worksheets/sheet.xml",true))?1:0;
	wsloop: for(i = 0; i != props.Worksheets; ++i) {
		var stype = "sheet";
		if(wbrels && wbrels[i]) {
			path = 'xl/' + (wbrels[i][1]).replace(/[\/]?xl\//, "");
			if(!safegetzipfile(zip, path)) path = wbrels[i][1];
			if(!safegetzipfile(zip, path)) path = wbrelsfile.replace(/_rels\/.*$/,"") + wbrels[i][1];
			stype = wbrels[i][2];
		} else {
			path = 'xl/worksheets/sheet'+(i+1-nmode)+"." + wbext;
			path = path.replace(/sheet0\./,"sheet.");
		}
		relsPath = path.replace(/^(.*)(\/)([^\/]*)$/, "$1/_rels/$3.rels");
		if(opts && opts.sheets != null) switch(typeof opts.sheets) {
			case "number": if(i != opts.sheets) continue wsloop; break;
			case "string": if(props.SheetNames[i].toLowerCase() != opts.sheets.toLowerCase()) continue wsloop; break;
			default: if(Array.isArray && Array.isArray(opts.sheets)) {
				var snjseen = false;
				for(var snj = 0; snj != opts.sheets.length; ++snj) {
					if(typeof opts.sheets[snj] == "number" && opts.sheets[snj] == i) snjseen=1;
					if(typeof opts.sheets[snj] == "string" && opts.sheets[snj].toLowerCase() == props.SheetNames[i].toLowerCase()) snjseen = 1;
				}
				if(!snjseen) continue wsloop;
			}
		}
		safe_parse_sheet(zip, path, relsPath, props.SheetNames[i], i, sheetRels, sheets, stype, opts, wb, themes, styles);
	}

	out = ({
		Directory: dir,
		Workbook: wb,
		Props: props,
		Custprops: custprops,
		Deps: deps,
		Sheets: sheets,
		SheetNames: props.SheetNames,
		Strings: strs,
		Styles: styles,
		Themes: themes,
		SSF: dup(table_fmt)
	}/*:any*/);
	if(opts && opts.bookFiles) {
		if(zip.files) {
			out.keys = entries;
			out.files = zip.files;
		} else {
			out.keys = [];
			out.files = {};
			zip.FullPaths.forEach(function(p, idx) {
				p = p.replace(/^Root Entry[\/]/, "");
				out.keys.push(p);
				out.files[p] = zip.FileIndex[idx];
			});
		}
	}
	if(opts && opts.bookVBA) {
		if(dir.vba.length > 0) out.vbaraw = getzipdata(zip,strip_front_slash(dir.vba[0]),true);
		else if(dir.defaults && dir.defaults.bin === CT_VBA) out.vbaraw = getzipdata(zip, 'xl/vbaProject.bin',true);
	}
	return out;
}

/* [MS-OFFCRYPTO] 2.1.1 */
function parse_xlsxcfb(cfb, _opts/*:?ParseOpts*/)/*:Workbook*/ {
	var opts = _opts || {};
	var f = 'Workbook', data = CFB.find(cfb, f);
	try {
	f = '/!DataSpaces/Version';
	data = CFB.find(cfb, f); if(!data || !data.content) throw new Error("ECMA-376 Encrypted file missing " + f);
	/*var version = */parse_DataSpaceVersionInfo(data.content);

	/* 2.3.4.1 */
	f = '/!DataSpaces/DataSpaceMap';
	data = CFB.find(cfb, f); if(!data || !data.content) throw new Error("ECMA-376 Encrypted file missing " + f);
	var dsm = parse_DataSpaceMap(data.content);
	if(dsm.length !== 1 || dsm[0].comps.length !== 1 || dsm[0].comps[0].t !== 0 || dsm[0].name !== "StrongEncryptionDataSpace" || dsm[0].comps[0].v !== "EncryptedPackage")
		throw new Error("ECMA-376 Encrypted file bad " + f);

	/* 2.3.4.2 */
	f = '/!DataSpaces/DataSpaceInfo/StrongEncryptionDataSpace';
	data = CFB.find(cfb, f); if(!data || !data.content) throw new Error("ECMA-376 Encrypted file missing " + f);
	var seds = parse_DataSpaceDefinition(data.content);
	if(seds.length != 1 || seds[0] != "StrongEncryptionTransform")
		throw new Error("ECMA-376 Encrypted file bad " + f);

	/* 2.3.4.3 */
	f = '/!DataSpaces/TransformInfo/StrongEncryptionTransform/!Primary';
	data = CFB.find(cfb, f); if(!data || !data.content) throw new Error("ECMA-376 Encrypted file missing " + f);
	/*var hdr = */parse_Primary(data.content);
	} catch(e) {}

	f = '/EncryptionInfo';
	data = CFB.find(cfb, f); if(!data || !data.content) throw new Error("ECMA-376 Encrypted file missing " + f);
	var einfo = parse_EncryptionInfo(data.content);

	/* 2.3.4.4 */
	f = '/EncryptedPackage';
	data = CFB.find(cfb, f); if(!data || !data.content) throw new Error("ECMA-376 Encrypted file missing " + f);

/*global decrypt_agile */
/*:: declare var decrypt_agile:any; */
	if(einfo[0] == 0x04 && typeof decrypt_agile !== 'undefined') return decrypt_agile(einfo[1], data.content, opts.password || "", opts);
/*global decrypt_std76 */
/*:: declare var decrypt_std76:any; */
	if(einfo[0] == 0x02 && typeof decrypt_std76 !== 'undefined') return decrypt_std76(einfo[1], data.content, opts.password || "", opts);
	throw new Error("File is password-protected");
}

function write_zip(wb/*:Workbook*/, opts/*:WriteOpts*/)/*:ZIP*/ {
	if(opts.bookType == "ods") return write_ods(wb, opts);
	if(opts.bookType == "numbers") return write_numbers_iwa(wb, opts);
	if(opts.bookType == "xlsb") return write_zip_xlsxb(wb, opts);
	return write_zip_xlsx(wb, opts);
}

/* XLSX and XLSB writing are very similar.  Originally they were unified in one
   export function.  This is horrible for tree shaking in the common case (most
   applications need to export files in one format) so this function supports
   both formats while write_zip_xlsx only handles XLSX */
function write_zip_xlsxb(wb/*:Workbook*/, opts/*:WriteOpts*/)/*:ZIP*/ {
	_shapeid = 1024;
	if(wb && !wb.SSF) {
		wb.SSF = dup(table_fmt);
	}
	if(wb && wb.SSF) {
		make_ssf(); SSF_load_table(wb.SSF);
		// $FlowIgnore
		opts.revssf = evert_num(wb.SSF); opts.revssf[wb.SSF[65535]] = 0;
		opts.ssf = wb.SSF;
	}
	opts.rels = {}; opts.wbrels = {};
	opts.Strings = /*::((*/[]/*:: :any):SST)*/; opts.Strings.Count = 0; opts.Strings.Unique = 0;
	if(browser_has_Map) opts.revStrings = new Map();
	else { opts.revStrings = {}; opts.revStrings.foo = []; delete opts.revStrings.foo; }
	var wbext = opts.bookType == "xlsb" ? "bin" : "xml";
	var vbafmt = VBAFMTS.indexOf(opts.bookType) > -1;
	var ct = new_ct();
	fix_write_opts(opts = opts || {});
	var zip = zip_new();
	var f = "", rId = 0;

	opts.cellXfs = [];
	get_cell_style(opts.cellXfs, {}, {revssf:{"General":0}});

	if(!wb.Props) wb.Props = {};

	f = "docProps/core.xml";
	zip_add_file(zip, f, write_core_props(wb.Props, opts));
	ct.coreprops.push(f);
	add_rels(opts.rels, 2, f, RELS.CORE_PROPS);

	/*::if(!wb.Props) throw "unreachable"; */
	f = "docProps/app.xml";
	if(wb.Props && wb.Props.SheetNames){/* empty */}
	else if(!wb.Workbook || !wb.Workbook.Sheets) wb.Props.SheetNames = wb.SheetNames;
	else {
		var _sn = [];
		for(var _i = 0; _i < wb.SheetNames.length; ++_i)
			if((wb.Workbook.Sheets[_i]||{}).Hidden != 2) _sn.push(wb.SheetNames[_i]);
		wb.Props.SheetNames = _sn;
	}
	wb.Props.Worksheets = wb.Props.SheetNames.length;
	zip_add_file(zip, f, write_ext_props(wb.Props, opts));
	ct.extprops.push(f);
	add_rels(opts.rels, 3, f, RELS.EXT_PROPS);

	if(wb.Custprops !== wb.Props && keys(wb.Custprops||{}).length > 0) {
		f = "docProps/custom.xml";
		zip_add_file(zip, f, write_cust_props(wb.Custprops, opts));
		ct.custprops.push(f);
		add_rels(opts.rels, 4, f, RELS.CUST_PROPS);
	}

	for(rId=1;rId <= wb.SheetNames.length; ++rId) {
		var wsrels = {'!id':{}};
		var ws = wb.Sheets[wb.SheetNames[rId-1]];
		var _type = (ws || {})["!type"] || "sheet";
		switch(_type) {
		case "chart":
			/* falls through */
		default:
			f = "xl/worksheets/sheet" + rId + "." + wbext;
			zip_add_file(zip, f, write_ws(rId-1, f, opts, wb, wsrels));
			ct.sheets.push(f);
			add_rels(opts.wbrels, -1, "worksheets/sheet" + rId + "." + wbext, RELS.WS[0]);
		}

		if(ws) {
			var comments = ws['!comments'];
			var need_vml = false;
			var cf = "";
			if(comments && comments.length > 0) {
				cf = "xl/comments" + rId + "." + wbext;
				zip_add_file(zip, cf, write_cmnt(comments, cf, opts));
				ct.comments.push(cf);
				add_rels(wsrels, -1, "../comments" + rId + "." + wbext, RELS.CMNT);
				need_vml = true;
			}
			if(ws['!legacy']) {
				if(need_vml) zip_add_file(zip, "xl/drawings/vmlDrawing" + (rId) + ".vml", write_comments_vml(rId, ws['!comments']));
			}
			delete ws['!comments'];
			delete ws['!legacy'];
		}

		if(wsrels['!id'].rId1) zip_add_file(zip, get_rels_path(f), write_rels(wsrels));
	}

	if(opts.Strings != null && opts.Strings.length > 0) {
		f = "xl/sharedStrings." + wbext;
		zip_add_file(zip, f, write_sst(opts.Strings, f, opts));
		ct.strs.push(f);
		add_rels(opts.wbrels, -1, "sharedStrings." + wbext, RELS.SST);
	}

	f = "xl/workbook." + wbext;
	zip_add_file(zip, f, write_wb(wb, f, opts));
	ct.workbooks.push(f);
	add_rels(opts.rels, 1, f, RELS.WB);

	/* TODO: something more intelligent with themes */

	f = "xl/theme/theme1.xml";
	zip_add_file(zip, f, write_theme(wb.Themes, opts));
	ct.themes.push(f);
	add_rels(opts.wbrels, -1, "theme/theme1.xml", RELS.THEME);

	/* TODO: something more intelligent with styles */

	f = "xl/styles." + wbext;
	zip_add_file(zip, f, write_sty(wb, f, opts));
	ct.styles.push(f);
	add_rels(opts.wbrels, -1, "styles." + wbext, RELS.STY);

	if(wb.vbaraw && vbafmt) {
		f = "xl/vbaProject.bin";
		zip_add_file(zip, f, wb.vbaraw);
		ct.vba.push(f);
		add_rels(opts.wbrels, -1, "vbaProject.bin", RELS.VBA);
	}

	f = "xl/metadata." + wbext;
	zip_add_file(zip, f, write_xlmeta(f));
	ct.metadata.push(f);
	add_rels(opts.wbrels, -1, "metadata." + wbext, RELS.XLMETA);

	zip_add_file(zip, "[Content_Types].xml", write_ct(ct, opts));
	zip_add_file(zip, '_rels/.rels', write_rels(opts.rels));
	zip_add_file(zip, 'xl/_rels/workbook.' + wbext + '.rels', write_rels(opts.wbrels));

	delete opts.revssf; delete opts.ssf;
	return zip;
}

function write_zip_xlsx(wb/*:Workbook*/, opts/*:WriteOpts*/)/*:ZIP*/ {
	_shapeid = 1024;
	if(wb && !wb.SSF) {
		wb.SSF = dup(table_fmt);
	}
	if(wb && wb.SSF) {
		make_ssf(); SSF_load_table(wb.SSF);
		// $FlowIgnore
		opts.revssf = evert_num(wb.SSF); opts.revssf[wb.SSF[65535]] = 0;
		opts.ssf = wb.SSF;
	}
	opts.rels = {}; opts.wbrels = {};
	opts.Strings = /*::((*/[]/*:: :any):SST)*/; opts.Strings.Count = 0; opts.Strings.Unique = 0;
	if(browser_has_Map) opts.revStrings = new Map();
	else { opts.revStrings = {}; opts.revStrings.foo = []; delete opts.revStrings.foo; }
	var wbext = "xml";
	var vbafmt = VBAFMTS.indexOf(opts.bookType) > -1;
	var ct = new_ct();
	fix_write_opts(opts = opts || {});
	var zip = zip_new();
	var f = "", rId = 0;

	opts.cellXfs = [];
	get_cell_style(opts.cellXfs, {}, {revssf:{"General":0}});

	if(!wb.Props) wb.Props = {};

	f = "docProps/core.xml";
	zip_add_file(zip, f, write_core_props(wb.Props, opts));
	ct.coreprops.push(f);
	add_rels(opts.rels, 2, f, RELS.CORE_PROPS);

	/*::if(!wb.Props) throw "unreachable"; */
	f = "docProps/app.xml";
	if(wb.Props && wb.Props.SheetNames){/* empty */}
	else if(!wb.Workbook || !wb.Workbook.Sheets) wb.Props.SheetNames = wb.SheetNames;
	else {
		var _sn = [];
		for(var _i = 0; _i < wb.SheetNames.length; ++_i)
			if((wb.Workbook.Sheets[_i]||{}).Hidden != 2) _sn.push(wb.SheetNames[_i]);
		wb.Props.SheetNames = _sn;
	}
	wb.Props.Worksheets = wb.Props.SheetNames.length;
	zip_add_file(zip, f, write_ext_props(wb.Props, opts));
	ct.extprops.push(f);
	add_rels(opts.rels, 3, f, RELS.EXT_PROPS);

	if(wb.Custprops !== wb.Props && keys(wb.Custprops||{}).length > 0) {
		f = "docProps/custom.xml";
		zip_add_file(zip, f, write_cust_props(wb.Custprops, opts));
		ct.custprops.push(f);
		add_rels(opts.rels, 4, f, RELS.CUST_PROPS);
	}

	var people = ["SheetJ5"];
	opts.tcid = 0;

	for(rId=1;rId <= wb.SheetNames.length; ++rId) {
		var wsrels = {'!id':{}};
		var ws = wb.Sheets[wb.SheetNames[rId-1]];
		var _type = (ws || {})["!type"] || "sheet";
		switch(_type) {
		case "chart":
			/* falls through */
		default:
			f = "xl/worksheets/sheet" + rId + "." + wbext;
			zip_add_file(zip, f, write_ws_xml(rId-1, opts, wb, wsrels));
			ct.sheets.push(f);
			add_rels(opts.wbrels, -1, "worksheets/sheet" + rId + "." + wbext, RELS.WS[0]);
		}

		if(ws) {
			var comments = ws['!comments'];
			var need_vml = false;
			var cf = "";
			if(comments && comments.length > 0) {
				var needtc = false;
				comments.forEach(function(carr) {
					carr[1].forEach(function(c) { if(c.T == true) needtc = true; });
				});
				if(needtc) {
					cf = "xl/threadedComments/threadedComment" + rId + "." + wbext;
					zip_add_file(zip, cf, write_tcmnt_xml(comments, people, opts));
					ct.threadedcomments.push(cf);
					add_rels(wsrels, -1, "../threadedComments/threadedComment" + rId + "." + wbext, RELS.TCMNT);
				}

				cf = "xl/comments" + rId + "." + wbext;
				zip_add_file(zip, cf, write_comments_xml(comments, opts));
				ct.comments.push(cf);
				add_rels(wsrels, -1, "../comments" + rId + "." + wbext, RELS.CMNT);
				need_vml = true;
			}
			if(ws['!legacy']) {
				if(need_vml) zip_add_file(zip, "xl/drawings/vmlDrawing" + (rId) + ".vml", write_comments_vml(rId, ws['!comments']));
			}
			delete ws['!comments'];
			delete ws['!legacy'];
		}

		if(wsrels['!id'].rId1) zip_add_file(zip, get_rels_path(f), write_rels(wsrels));
	}

	if(opts.Strings != null && opts.Strings.length > 0) {
		f = "xl/sharedStrings." + wbext;
		zip_add_file(zip, f, write_sst_xml(opts.Strings, opts));
		ct.strs.push(f);
		add_rels(opts.wbrels, -1, "sharedStrings." + wbext, RELS.SST);
	}

	f = "xl/workbook." + wbext;
	zip_add_file(zip, f, write_wb_xml(wb, opts));
	ct.workbooks.push(f);
	add_rels(opts.rels, 1, f, RELS.WB);

	/* TODO: something more intelligent with themes */

	f = "xl/theme/theme1.xml";
	zip_add_file(zip, f, write_theme(wb.Themes, opts));
	ct.themes.push(f);
	add_rels(opts.wbrels, -1, "theme/theme1.xml", RELS.THEME);

	/* TODO: something more intelligent with styles */

	f = "xl/styles." + wbext;
	zip_add_file(zip, f, write_sty_xml(wb, opts));
	ct.styles.push(f);
	add_rels(opts.wbrels, -1, "styles." + wbext, RELS.STY);

	if(wb.vbaraw && vbafmt) {
		f = "xl/vbaProject.bin";
		zip_add_file(zip, f, wb.vbaraw);
		ct.vba.push(f);
		add_rels(opts.wbrels, -1, "vbaProject.bin", RELS.VBA);
	}

	f = "xl/metadata." + wbext;
	zip_add_file(zip, f, write_xlmeta_xml());
	ct.metadata.push(f);
	add_rels(opts.wbrels, -1, "metadata." + wbext, RELS.XLMETA);

	if(people.length > 1) {
		f = "xl/persons/person.xml";
		zip_add_file(zip, f, write_people_xml(people, opts));
		ct.people.push(f);
		add_rels(opts.wbrels, -1, "persons/person.xml", RELS.PEOPLE);
	}

	zip_add_file(zip, "[Content_Types].xml", write_ct(ct, opts));
	zip_add_file(zip, '_rels/.rels', write_rels(opts.rels));
	zip_add_file(zip, 'xl/_rels/workbook.' + wbext + '.rels', write_rels(opts.wbrels));

	delete opts.revssf; delete opts.ssf;
	return zip;
}

function firstbyte(f/*:RawData*/,o/*:?TypeOpts*/)/*:Array<number>*/ {
	var x = "";
	switch((o||{}).type || "base64") {
		case 'buffer': return [f[0], f[1], f[2], f[3], f[4], f[5], f[6], f[7]];
		case 'base64': x = Base64_decode(f.slice(0,12)); break;
		case 'binary': x = f; break;
		case 'array':  return [f[0], f[1], f[2], f[3], f[4], f[5], f[6], f[7]];
		default: throw new Error("Unrecognized type " + (o && o.type || "undefined"));
	}
	return [x.charCodeAt(0), x.charCodeAt(1), x.charCodeAt(2), x.charCodeAt(3), x.charCodeAt(4), x.charCodeAt(5), x.charCodeAt(6), x.charCodeAt(7)];
}

function read_cfb(cfb/*:CFBContainer*/, opts/*:?ParseOpts*/)/*:Workbook*/ {
	if(CFB.find(cfb, "EncryptedPackage")) return parse_xlsxcfb(cfb, opts);
	return parse_xlscfb(cfb, opts);
}

function read_zip(data/*:RawData*/, opts/*:?ParseOpts*/)/*:Workbook*/ {
	var zip, d = data;
	var o = opts||{};
	if(!o.type) o.type = (has_buf && Buffer.isBuffer(data)) ? "buffer" : "base64";
	zip = zip_read(d, o);
	return parse_zip(zip, o);
}

function read_plaintext(data/*:string*/, o/*:ParseOpts*/)/*:Workbook*/ {
	var i = 0;
	main: while(i < data.length) switch(data.charCodeAt(i)) {
		case 0x0A: case 0x0D: case 0x20: ++i; break;
		case 0x3C: return parse_xlml(data.slice(i),o);
		default: break main;
	}
	return PRN.to_workbook(data, o);
}

function read_plaintext_raw(data/*:RawData*/, o/*:ParseOpts*/)/*:Workbook*/ {
	var str = "", bytes = firstbyte(data, o);
	switch(o.type) {
		case 'base64': str = Base64_decode(data); break;
		case 'binary': str = data; break;
		case 'buffer': str = data.toString('binary'); break;
		case 'array': str = cc2str(data); break;
		default: throw new Error("Unrecognized type " + o.type);
	}
	if(bytes[0] == 0xEF && bytes[1] == 0xBB && bytes[2] == 0xBF) str = utf8read(str);
	o.type = "binary";
	return read_plaintext(str, o);
}

function read_utf16(data/*:RawData*/, o/*:ParseOpts*/)/*:Workbook*/ {
	var d = data;
	if(o.type == 'base64') d = Base64_decode(d);
	d = $cptable.utils.decode(1200, d.slice(2), 'str');
	o.type = "binary";
	return read_plaintext(d, o);
}

function bstrify(data/*:string*/)/*:string*/ {
	return !data.match(/[^\x00-\x7F]/) ? data : utf8write(data);
}

function read_prn(data, d, o, str) {
	if(str) { o.type = "string"; return PRN.to_workbook(data, o); }
	return PRN.to_workbook(d, o);
}

function readSync(data/*:RawData*/, opts/*:?ParseOpts*/)/*:Workbook*/ {
	reset_cp();
	var o = opts||{};
	if(typeof ArrayBuffer !== 'undefined' && data instanceof ArrayBuffer) return readSync(new Uint8Array(data), (o = dup(o), o.type = "array", o));
	if(typeof Uint8Array !== 'undefined' && data instanceof Uint8Array && !o.type) o.type = typeof Deno !== "undefined" ? "buffer" : "array";
	var d = data, n = [0,0,0,0], str = false;
	if(o.cellStyles) { o.cellNF = true; o.sheetStubs = true; }
	_ssfopts = {};
	if(o.dateNF) _ssfopts.dateNF = o.dateNF;
	if(!o.type) o.type = (has_buf && Buffer.isBuffer(data)) ? "buffer" : "base64";
	if(o.type == "file") { o.type = has_buf ? "buffer" : "binary"; d = read_binary(data); if(typeof Uint8Array !== 'undefined' && !has_buf) o.type = "array"; }
	if(o.type == "string") { str = true; o.type = "binary"; o.codepage = 65001; d = bstrify(data); }
	if(o.type == 'array' && typeof Uint8Array !== 'undefined' && data instanceof Uint8Array && typeof ArrayBuffer !== 'undefined') {
		// $FlowIgnore
		var ab=new ArrayBuffer(3), vu=new Uint8Array(ab); vu.foo="bar";
		// $FlowIgnore
		if(!vu.foo) {o=dup(o); o.type='array'; return readSync(ab2a(d), o);}
	}
	switch((n = firstbyte(d, o))[0]) {
		case 0xD0: if(n[1] === 0xCF && n[2] === 0x11 && n[3] === 0xE0 && n[4] === 0xA1 && n[5] === 0xB1 && n[6] === 0x1A && n[7] === 0xE1) return read_cfb(CFB.read(d, o), o); break;
		case 0x09: if(n[1] <= 0x08) return parse_xlscfb(d, o); break;
		case 0x3C: return parse_xlml(d, o);
		case 0x49:
			if(n[1] === 0x49 && n[2] === 0x2a && n[3] === 0x00) throw new Error("TIFF Image File is not a spreadsheet");
			if(n[1] === 0x44) return read_wb_ID(d, o);
			break;
		case 0x54: if(n[1] === 0x41 && n[2] === 0x42 && n[3] === 0x4C) return DIF.to_workbook(d, o); break;
		case 0x50: return (n[1] === 0x4B && n[2] < 0x09 && n[3] < 0x09) ? read_zip(d, o) : read_prn(data, d, o, str);
		case 0xEF: return n[3] === 0x3C ? parse_xlml(d, o) : read_prn(data, d, o, str);
		case 0xFF:
			if(n[1] === 0xFE) { return read_utf16(d, o); }
			else if(n[1] === 0x00 && n[2] === 0x02 && n[3] === 0x00) return WK_.to_workbook(d, o);
			break;
		case 0x00:
			if(n[1] === 0x00) {
				if(n[2] >= 0x02 && n[3] === 0x00) return WK_.to_workbook(d, o);
				if(n[2] === 0x00 && (n[3] === 0x08 || n[3] === 0x09)) return WK_.to_workbook(d, o);
			}
			break;
		case 0x03: case 0x83: case 0x8B: case 0x8C: return DBF.to_workbook(d, o);
		case 0x7B: if(n[1] === 0x5C && n[2] === 0x72 && n[3] === 0x74) return RTF.to_workbook(d, o); break;
		case 0x0A: case 0x0D: case 0x20: return read_plaintext_raw(d, o);
		case 0x89: if(n[1] === 0x50 && n[2] === 0x4E && n[3] === 0x47) throw new Error("PNG Image File is not a spreadsheet"); break;
	}
	if(DBF_SUPPORTED_VERSIONS.indexOf(n[0]) > -1 && n[2] <= 12 && n[3] <= 31) return DBF.to_workbook(d, o);
	return read_prn(data, d, o, str);
}

function readFileSync(filename/*:string*/, opts/*:?ParseOpts*/)/*:Workbook*/ {
	var o = opts||{}; o.type = 'file';
	return readSync(filename, o);
}
function write_cfb_ctr(cfb/*:CFBContainer*/, o/*:WriteOpts*/)/*:any*/ {
	switch(o.type) {
		case "base64": case "binary": break;
		case "buffer": case "array": o.type = ""; break;
		case "file": return write_dl(o.file, CFB.write(cfb, {type:has_buf ? 'buffer' : ""}));
		case "string": throw new Error("'string' output type invalid for '" + o.bookType + "' files");
		default: throw new Error("Unrecognized type " + o.type);
	}
	return CFB.write(cfb, o);
}

/*:: declare var encrypt_agile:any; */
function write_zip_type(wb/*:Workbook*/, opts/*:?WriteOpts*/)/*:any*/ {
	var o = dup(opts||{});
	var z = write_zip(wb, o);
	return write_zip_denouement(z, o);
}
function write_zip_typeXLSX(wb/*:Workbook*/, opts/*:?WriteOpts*/)/*:any*/ {
	var o = dup(opts||{});
	var z = write_zip_xlsx(wb, o);
	return write_zip_denouement(z, o);
}
function write_zip_denouement(z/*:any*/, o/*:?WriteOpts*/)/*:any*/ {
	var oopts = {};
	var ftype = has_buf ? "nodebuffer" : (typeof Uint8Array !== "undefined" ? "array" : "string");
	if(o.compression) oopts.compression = 'DEFLATE';
	if(o.password) oopts.type = ftype;
	else switch(o.type) {
		case "base64": oopts.type = "base64"; break;
		case "binary": oopts.type = "string"; break;
		case "string": throw new Error("'string' output type invalid for '" + o.bookType + "' files");
		case "buffer":
		case "file": oopts.type = ftype; break;
		default: throw new Error("Unrecognized type " + o.type);
	}
	var out = z.FullPaths ? CFB.write(z, {fileType:"zip", type: /*::(*/{"nodebuffer": "buffer", "string": "binary"}/*:: :any)*/[oopts.type] || oopts.type, compression: !!o.compression}) : z.generate(oopts);
	if(typeof Deno !== "undefined") {
		if(typeof out == "string") {
			if(o.type == "binary" || o.type == "base64") return out;
			out = new Uint8Array(s2ab(out));
		}
	}
/*jshint -W083 */
	if(o.password && typeof encrypt_agile !== 'undefined') return write_cfb_ctr(encrypt_agile(out, o.password), o); // eslint-disable-line no-undef
/*jshint +W083 */
	if(o.type === "file") return write_dl(o.file, out);
	return o.type == "string" ? utf8read(/*::(*/out/*:: :any)*/) : out;
}

function write_cfb_type(wb/*:Workbook*/, opts/*:?WriteOpts*/)/*:any*/ {
	var o = opts||{};
	var cfb/*:CFBContainer*/ = write_xlscfb(wb, o);
	return write_cfb_ctr(cfb, o);
}

function write_string_type(out/*:string*/, opts/*:WriteOpts*/, bom/*:?string*/)/*:any*/ {
	if(!bom) bom = "";
	var o = bom + out;
	switch(opts.type) {
		case "base64": return Base64_encode(utf8write(o));
		case "binary": return utf8write(o);
		case "string": return out;
		case "file": return write_dl(opts.file, o, 'utf8');
		case "buffer": {
			if(has_buf) return Buffer_from(o, 'utf8');
			else if(typeof TextEncoder !== "undefined") return new TextEncoder().encode(o);
			else return write_string_type(o, {type:'binary'}).split("").map(function(c) { return c.charCodeAt(0); });
		}
	}
	throw new Error("Unrecognized type " + opts.type);
}

function write_stxt_type(out/*:string*/, opts/*:WriteOpts*/)/*:any*/ {
	switch(opts.type) {
		case "base64": return Base64_encode(out);
		case "binary": return out;
		case "string": return out; /* override in sheet_to_txt */
		case "file": return write_dl(opts.file, out, 'binary');
		case "buffer": {
			if(has_buf) return Buffer_from(out, 'binary');
			else return out.split("").map(function(c) { return c.charCodeAt(0); });
		}
	}
	throw new Error("Unrecognized type " + opts.type);
}

/* TODO: test consistency */
function write_binary_type(out, opts/*:WriteOpts*/)/*:any*/ {
	switch(opts.type) {
		case "string":
		case "base64":
		case "binary":
			var bstr = "";
			// $FlowIgnore
			for(var i = 0; i < out.length; ++i) bstr += String.fromCharCode(out[i]);
			return opts.type == 'base64' ? Base64_encode(bstr) : opts.type == 'string' ? utf8read(bstr) : bstr;
		case "file": return write_dl(opts.file, out);
		case "buffer": return out;
		default: throw new Error("Unrecognized type " + opts.type);
	}
}

function writeSyncXLSX(wb/*:Workbook*/, opts/*:?WriteOpts*/) {
	reset_cp();
	check_wb(wb);
	var o = dup(opts||{});
	if(o.cellStyles) { o.cellNF = true; o.sheetStubs = true; }
	if(o.type == "array") { o.type = "binary"; var out/*:string*/ = (writeSyncXLSX(wb, o)/*:any*/); o.type = "array"; return s2ab(out); }
	return write_zip_typeXLSX(wb, o);
}

function writeSync(wb/*:Workbook*/, opts/*:?WriteOpts*/) {
	reset_cp();
	check_wb(wb);
	var o = dup(opts||{});
	if(o.cellStyles) { o.cellNF = true; o.sheetStubs = true; }
	if(o.type == "array") { o.type = "binary"; var out/*:string*/ = (writeSync(wb, o)/*:any*/); o.type = "array"; return s2ab(out); }
	var idx = 0;
	if(o.sheet) {
		if(typeof o.sheet == "number") idx = o.sheet;
		else idx = wb.SheetNames.indexOf(o.sheet);
		if(!wb.SheetNames[idx]) throw new Error("Sheet not found: " + o.sheet + " : " + (typeof o.sheet));
	}
	switch(o.bookType || 'xlsb') {
		case 'xml':
		case 'xlml': return write_string_type(write_xlml(wb, o), o);
		case 'slk':
		case 'sylk': return write_string_type(SYLK.from_sheet(wb.Sheets[wb.SheetNames[idx]], o), o);
		case 'htm':
		case 'html': return write_string_type(sheet_to_html(wb.Sheets[wb.SheetNames[idx]], o), o);
		case 'txt': return write_stxt_type(sheet_to_txt(wb.Sheets[wb.SheetNames[idx]], o), o);
		case 'csv': return write_string_type(sheet_to_csv(wb.Sheets[wb.SheetNames[idx]], o), o, "\ufeff");
		case 'dif': return write_string_type(DIF.from_sheet(wb.Sheets[wb.SheetNames[idx]], o), o);
		case 'dbf': return write_binary_type(DBF.from_sheet(wb.Sheets[wb.SheetNames[idx]], o), o);
		case 'prn': return write_string_type(PRN.from_sheet(wb.Sheets[wb.SheetNames[idx]], o), o);
		case 'rtf': return write_string_type(RTF.from_sheet(wb.Sheets[wb.SheetNames[idx]], o), o);
		case 'eth': return write_string_type(ETH.from_sheet(wb.Sheets[wb.SheetNames[idx]], o), o);
		case 'fods': return write_string_type(write_ods(wb, o), o);
		case 'wk1': return write_binary_type(WK_.sheet_to_wk1(wb.Sheets[wb.SheetNames[idx]], o), o);
		case 'wk3': return write_binary_type(WK_.book_to_wk3(wb, o), o);
		case 'biff2': if(!o.biff) o.biff = 2; /* falls through */
		case 'biff3': if(!o.biff) o.biff = 3; /* falls through */
		case 'biff4': if(!o.biff) o.biff = 4; return write_binary_type(write_biff_buf(wb, o), o);
		case 'biff5': if(!o.biff) o.biff = 5; /* falls through */
		case 'biff8':
		case 'xla':
		case 'xls': if(!o.biff) o.biff = 8; return write_cfb_type(wb, o);
		case 'xlsx':
		case 'xlsm':
		case 'xlam':
		case 'xlsb':
		case 'numbers':
		case 'ods': return write_zip_type(wb, o);
		default: throw new Error ("Unrecognized bookType |" + o.bookType + "|");
	}
}

function resolve_book_type(o/*:WriteFileOpts*/) {
	if(o.bookType) return;
	var _BT = {
		"xls": "biff8",
		"htm": "html",
		"slk": "sylk",
		"socialcalc": "eth",
		"Sh33tJS": "WTF"
	};
	var ext = o.file.slice(o.file.lastIndexOf(".")).toLowerCase();
	if(ext.match(/^\.[a-z]+$/)) o.bookType = ext.slice(1);
	o.bookType = _BT[o.bookType] || o.bookType;
}

function writeFileSync(wb/*:Workbook*/, filename/*:string*/, opts/*:?WriteFileOpts*/) {
	var o = opts||{}; o.type = 'file';
	o.file = filename;
	resolve_book_type(o);
	return writeSync(wb, o);
}

function writeFileSyncXLSX(wb/*:Workbook*/, filename/*:string*/, opts/*:?WriteFileOpts*/) {
	var o = opts||{}; o.type = 'file';
	o.file = filename;
	resolve_book_type(o);
	return writeSyncXLSX(wb, o);
}


function writeFileAsync(filename/*:string*/, wb/*:Workbook*/, opts/*:?WriteFileOpts*/, cb/*:?(e?:ErrnoError)=>void*/) {
	var o = opts||{}; o.type = 'file';
	o.file = filename;
	resolve_book_type(o);
	o.type = 'buffer';
	var _cb = cb; if(!(_cb instanceof Function)) _cb = (opts/*:any*/);
	return _fs.writeFile(filename, writeSync(wb, o), _cb);
}
/*::
type MJRObject = {
	row: any;
	isempty: boolean;
};
*/
function make_json_row(sheet/*:Worksheet*/, r/*:Range*/, R/*:number*/, cols/*:Array<string>*/, header/*:number*/, hdr/*:Array<any>*/, dense/*:boolean*/, o/*:Sheet2JSONOpts*/)/*:MJRObject*/ {
	var rr = encode_row(R);
	var defval = o.defval, raw = o.raw || !Object.prototype.hasOwnProperty.call(o, "raw");
	var isempty = true;
	var row/*:any*/ = (header === 1) ? [] : {};
	if(header !== 1) {
		if(Object.defineProperty) try { Object.defineProperty(row, '__rowNum__', {value:R, enumerable:false}); } catch(e) { row.__rowNum__ = R; }
		else row.__rowNum__ = R;
	}
	if(!dense || sheet[R]) for (var C = r.s.c; C <= r.e.c; ++C) {
		var val = dense ? sheet[R][C] : sheet[cols[C] + rr];
		if(val === undefined || val.t === undefined) {
			if(defval === undefined) continue;
			if(hdr[C] != null) { row[hdr[C]] = defval; }
			continue;
		}
		var v = val.v;
		switch(val.t){
			case 'z': if(v == null) break; continue;
			case 'e': v = (v == 0 ? null : void 0); break;
			case 's': case 'd': case 'b': case 'n': break;
			default: throw new Error('unrecognized type ' + val.t);
		}
		if(hdr[C] != null) {
			if(v == null) {
				if(val.t == "e" && v === null) row[hdr[C]] = null;
				else if(defval !== undefined) row[hdr[C]] = defval;
				else if(raw && v === null) row[hdr[C]] = null;
				else continue;
			} else {
				row[hdr[C]] = raw && (val.t !== "n" || (val.t === "n" && o.rawNumbers !== false)) ? v : format_cell(val,v,o);
			}
			if(v != null) isempty = false;
		}
	}
	return { row: row, isempty: isempty };
}


function sheet_to_json(sheet/*:Worksheet*/, opts/*:?Sheet2JSONOpts*/) {
	if(sheet == null || sheet["!ref"] == null) return [];
	var val = {t:'n',v:0}, header = 0, offset = 1, hdr/*:Array<any>*/ = [], v=0, vv="";
	var r = {s:{r:0,c:0},e:{r:0,c:0}};
	var o = opts || {};
	var range = o.range != null ? o.range : sheet["!ref"];
	if(o.header === 1) header = 1;
	else if(o.header === "A") header = 2;
	else if(Array.isArray(o.header)) header = 3;
	else if(o.header == null) header = 0;
	switch(typeof range) {
		case 'string': r = safe_decode_range(range); break;
		case 'number': r = safe_decode_range(sheet["!ref"]); r.s.r = range; break;
		default: r = range;
	}
	if(header > 0) offset = 0;
	var rr = encode_row(r.s.r);
	var cols/*:Array<string>*/ = [];
	var out/*:Array<any>*/ = [];
	var outi = 0, counter = 0;
	var dense = Array.isArray(sheet);
	var R = r.s.r, C = 0;
	var header_cnt = {};
	if(dense && !sheet[R]) sheet[R] = [];
	var colinfo/*:Array<ColInfo>*/ = o.skipHidden && sheet["!cols"] || [];
	var rowinfo/*:Array<ColInfo>*/ = o.skipHidden && sheet["!rows"] || [];
	for(C = r.s.c; C <= r.e.c; ++C) {
		if(((colinfo[C]||{}).hidden)) continue;
		cols[C] = encode_col(C);
		val = dense ? sheet[R][C] : sheet[cols[C] + rr];
		switch(header) {
			case 1: hdr[C] = C - r.s.c; break;
			case 2: hdr[C] = cols[C]; break;
			case 3: hdr[C] = o.header[C - r.s.c]; break;
			default:
				if(val == null) val = {w: "__EMPTY", t: "s"};
				vv = v = format_cell(val, null, o);
				counter = header_cnt[v] || 0;
				if(!counter) header_cnt[v] = 1;
				else {
					do { vv = v + "_" + (counter++); } while(header_cnt[vv]); header_cnt[v] = counter;
					header_cnt[vv] = 1;
				}
				hdr[C] = vv;
		}
	}
	for (R = r.s.r + offset; R <= r.e.r; ++R) {
		if ((rowinfo[R]||{}).hidden) continue;
		var row = make_json_row(sheet, r, R, cols, header, hdr, dense, o);
		if((row.isempty === false) || (header === 1 ? o.blankrows !== false : !!o.blankrows)) out[outi++] = row.row;
	}
	out.length = outi;
	return out;
}

var qreg = /"/g;
function make_csv_row(sheet/*:Worksheet*/, r/*:Range*/, R/*:number*/, cols/*:Array<string>*/, fs/*:number*/, rs/*:number*/, FS/*:string*/, o/*:Sheet2CSVOpts*/)/*:?string*/ {
	var isempty = true;
	var row/*:Array<string>*/ = [], txt = "", rr = encode_row(R);
	for(var C = r.s.c; C <= r.e.c; ++C) {
		if (!cols[C]) continue;
		var val = o.dense ? (sheet[R]||[])[C]: sheet[cols[C] + rr];
		if(val == null) txt = "";
		else if(val.v != null) {
			isempty = false;
			txt = ''+(o.rawNumbers && val.t == "n" ? val.v : format_cell(val, null, o));
			for(var i = 0, cc = 0; i !== txt.length; ++i) if((cc = txt.charCodeAt(i)) === fs || cc === rs || cc === 34 || o.forceQuotes) {txt = "\"" + txt.replace(qreg, '""') + "\""; break; }
			if(txt == "ID") txt = '"ID"';
		} else if(val.f != null && !val.F) {
			isempty = false;
			txt = '=' + val.f; if(txt.indexOf(",") >= 0) txt = '"' + txt.replace(qreg, '""') + '"';
		} else txt = "";
		/* NOTE: Excel CSV does not support array formulae */
		row.push(txt);
	}
	if(o.blankrows === false && isempty) return null;
	return row.join(FS);
}

function sheet_to_csv(sheet/*:Worksheet*/, opts/*:?Sheet2CSVOpts*/)/*:string*/ {
	var out/*:Array<string>*/ = [];
	var o = opts == null ? {} : opts;
	if(sheet == null || sheet["!ref"] == null) return "";
	var r = safe_decode_range(sheet["!ref"]);
	var FS = o.FS !== undefined ? o.FS : ",", fs = FS.charCodeAt(0);
	var RS = o.RS !== undefined ? o.RS : "\n", rs = RS.charCodeAt(0);
	var endregex = new RegExp((FS=="|" ? "\\|" : FS)+"+$");
	var row = "", cols/*:Array<string>*/ = [];
	o.dense = Array.isArray(sheet);
	var colinfo/*:Array<ColInfo>*/ = o.skipHidden && sheet["!cols"] || [];
	var rowinfo/*:Array<ColInfo>*/ = o.skipHidden && sheet["!rows"] || [];
	for(var C = r.s.c; C <= r.e.c; ++C) if (!((colinfo[C]||{}).hidden)) cols[C] = encode_col(C);
	var w = 0;
	for(var R = r.s.r; R <= r.e.r; ++R) {
		if ((rowinfo[R]||{}).hidden) continue;
		row = make_csv_row(sheet, r, R, cols, fs, rs, FS, o);
		if(row == null) { continue; }
		if(o.strip) row = row.replace(endregex,"");
		if(row || (o.blankrows !== false)) out.push((w++ ? RS : "") + row);
	}
	delete o.dense;
	return out.join("");
}

function sheet_to_txt(sheet/*:Worksheet*/, opts/*:?Sheet2CSVOpts*/) {
	if(!opts) opts = {}; opts.FS = "\t"; opts.RS = "\n";
	var s = sheet_to_csv(sheet, opts);
	if(typeof $cptable == 'undefined' || opts.type == 'string') return s;
	var o = $cptable.utils.encode(1200, s, 'str');
	return String.fromCharCode(255) + String.fromCharCode(254) + o;
}

function sheet_to_formulae(sheet/*:Worksheet*/)/*:Array<string>*/ {
	var y = "", x, val="";
	if(sheet == null || sheet["!ref"] == null) return [];
	var r = safe_decode_range(sheet['!ref']), rr = "", cols/*:Array<string>*/ = [], C;
	var cmds/*:Array<string>*/ = [];
	var dense = Array.isArray(sheet);
	for(C = r.s.c; C <= r.e.c; ++C) cols[C] = encode_col(C);
	for(var R = r.s.r; R <= r.e.r; ++R) {
		rr = encode_row(R);
		for(C = r.s.c; C <= r.e.c; ++C) {
			y = cols[C] + rr;
			x = dense ? (sheet[R]||[])[C] : sheet[y];
			val = "";
			if(x === undefined) continue;
			else if(x.F != null) {
				y = x.F;
				if(!x.f) continue;
				val = x.f;
				if(y.indexOf(":") == -1) y = y + ":" + y;
			}
			if(x.f != null) val = x.f;
			else if(x.t == 'z') continue;
			else if(x.t == 'n' && x.v != null) val = "" + x.v;
			else if(x.t == 'b') val = x.v ? "TRUE" : "FALSE";
			else if(x.w !== undefined) val = "'" + x.w;
			else if(x.v === undefined) continue;
			else if(x.t == 's') val = "'" + x.v;
			else val = ""+x.v;
			cmds[cmds.length] = y + "=" + val;
		}
	}
	return cmds;
}

function sheet_add_json(_ws/*:?Worksheet*/, js/*:Array<any>*/, opts)/*:Worksheet*/ {
	var o = opts || {};
	var offset = +!o.skipHeader;
	var ws/*:Worksheet*/ = _ws || ({}/*:any*/);
	var _R = 0, _C = 0;
	if(ws && o.origin != null) {
		if(typeof o.origin == 'number') _R = o.origin;
		else {
			var _origin/*:CellAddress*/ = typeof o.origin == "string" ? decode_cell(o.origin) : o.origin;
			_R = _origin.r; _C = _origin.c;
		}
	}
	var cell/*:Cell*/;
	var range/*:Range*/ = ({s: {c:0, r:0}, e: {c:_C, r:_R + js.length - 1 + offset}}/*:any*/);
	if(ws['!ref']) {
		var _range = safe_decode_range(ws['!ref']);
		range.e.c = Math.max(range.e.c, _range.e.c);
		range.e.r = Math.max(range.e.r, _range.e.r);
		if(_R == -1) { _R = _range.e.r + 1; range.e.r = _R + js.length - 1 + offset; }
	} else {
		if(_R == -1) { _R = 0; range.e.r = js.length - 1 + offset; }
	}
	var hdr/*:Array<string>*/ = o.header || [], C = 0;

	js.forEach(function (JS, R/*:number*/) {
		keys(JS).forEach(function(k) {
			if((C=hdr.indexOf(k)) == -1) hdr[C=hdr.length] = k;
			var v = JS[k];
			var t = 'z';
			var z = "";
			var ref = encode_cell({c:_C + C,r:_R + R + offset});
			cell = ws_get_cell_stub(ws, ref);
			if(v && typeof v === 'object' && !(v instanceof Date)){
				ws[ref] = v;
			} else {
				if(typeof v == 'number') t = 'n';
				else if(typeof v == 'boolean') t = 'b';
				else if(typeof v == 'string') t = 's';
				else if(v instanceof Date) {
					t = 'd';
					if(!o.cellDates) { t = 'n'; v = datenum(v); }
					z = (o.dateNF || table_fmt[14]);
				}
				else if(v === null && o.nullError) { t = 'e'; v = 0; }
				if(!cell) ws[ref] = cell = ({t:t, v:v}/*:any*/);
				else {
					cell.t = t; cell.v = v;
					delete cell.w; delete cell.R;
					if(z) cell.z = z;
				}
				if(z) cell.z = z;
			}
		});
	});
	range.e.c = Math.max(range.e.c, _C + hdr.length - 1);
	var __R = encode_row(_R);
	if(offset) for(C = 0; C < hdr.length; ++C) ws[encode_col(C + _C) + __R] = {t:'s', v:hdr[C]};
	ws['!ref'] = encode_range(range);
	return ws;
}
function json_to_sheet(js/*:Array<any>*/, opts)/*:Worksheet*/ { return sheet_add_json(null, js, opts); }

/* get cell, creating a stub if necessary */
function ws_get_cell_stub(ws/*:Worksheet*/, R, C/*:?number*/)/*:Cell*/ {
	/* A1 cell address */
	if(typeof R == "string") {
		/* dense */
		if(Array.isArray(ws)) {
			var RC = decode_cell(R);
			if(!ws[RC.r]) ws[RC.r] = [];
			return ws[RC.r][RC.c] || (ws[RC.r][RC.c] = {t:'z'});
		}
		return ws[R] || (ws[R] = {t:'z'});
	}
	/* cell address object */
	if(typeof R != "number") return ws_get_cell_stub(ws, encode_cell(R));
	/* R and C are 0-based indices */
	return ws_get_cell_stub(ws, encode_cell({r:R,c:C||0}));
}

/* find sheet index for given name / validate index */
function wb_sheet_idx(wb/*:Workbook*/, sh/*:number|string*/) {
	if(typeof sh == "number") {
		if(sh >= 0 && wb.SheetNames.length > sh) return sh;
		throw new Error("Cannot find sheet # " + sh);
	} else if(typeof sh == "string") {
		var idx = wb.SheetNames.indexOf(sh);
		if(idx > -1) return idx;
		throw new Error("Cannot find sheet name |" + sh + "|");
	} else throw new Error("Cannot find sheet |" + sh + "|");
}

/* simple blank workbook object */
function book_new()/*:Workbook*/ {
	return { SheetNames: [], Sheets: {} };
}

/* add a worksheet to the end of a given workbook */
function book_append_sheet(wb/*:Workbook*/, ws/*:Worksheet*/, name/*:?string*/, roll/*:?boolean*/)/*:string*/ {
	var i = 1;
	if(!name) for(; i <= 0xFFFF; ++i, name = undefined) if(wb.SheetNames.indexOf(name = "Sheet" + i) == -1) break;
	if(!name || wb.SheetNames.length >= 0xFFFF) throw new Error("Too many worksheets");
	if(roll && wb.SheetNames.indexOf(name) >= 0) {
		var m = name.match(/(^.*?)(\d+)$/);
		i = m && +m[2] || 0;
		var root = m && m[1] || name;
		for(++i; i <= 0xFFFF; ++i) if(wb.SheetNames.indexOf(name = root + i) == -1) break;
	}
	check_ws_name(name);
	if(wb.SheetNames.indexOf(name) >= 0) throw new Error("Worksheet with name |" + name + "| already exists!");

	wb.SheetNames.push(name);
	wb.Sheets[name] = ws;
	return name;
}

/* set sheet visibility (visible/hidden/very hidden) */
function book_set_sheet_visibility(wb/*:Workbook*/, sh/*:number|string*/, vis/*:number*/) {
	if(!wb.Workbook) wb.Workbook = {};
	if(!wb.Workbook.Sheets) wb.Workbook.Sheets = [];

	var idx = wb_sheet_idx(wb, sh);
	// $FlowIgnore
	if(!wb.Workbook.Sheets[idx]) wb.Workbook.Sheets[idx] = {};

	switch(vis) {
		case 0: case 1: case 2: break;
		default: throw new Error("Bad sheet visibility setting " + vis);
	}
	// $FlowIgnore
	wb.Workbook.Sheets[idx].Hidden = vis;
}

/* set number format */
function cell_set_number_format(cell/*:Cell*/, fmt/*:string|number*/) {
	cell.z = fmt;
	return cell;
}

/* set cell hyperlink */
function cell_set_hyperlink(cell/*:Cell*/, target/*:string*/, tooltip/*:?string*/) {
	if(!target) {
		delete cell.l;
	} else {
		cell.l = ({ Target: target }/*:Hyperlink*/);
		if(tooltip) cell.l.Tooltip = tooltip;
	}
	return cell;
}
function cell_set_internal_link(cell/*:Cell*/, range/*:string*/, tooltip/*:?string*/) { return cell_set_hyperlink(cell, "#" + range, tooltip); }

/* add to cell comments */
function cell_add_comment(cell/*:Cell*/, text/*:string*/, author/*:?string*/) {
	if(!cell.c) cell.c = [];
	cell.c.push({t:text, a:author||"SheetJS"});
}

/* set array formula and flush related cells */
function sheet_set_array_formula(ws/*:Worksheet*/, range, formula/*:string*/, dynamic/*:boolean*/) {
	var rng = typeof range != "string" ? range : safe_decode_range(range);
	var rngstr = typeof range == "string" ? range : encode_range(range);
	for(var R = rng.s.r; R <= rng.e.r; ++R) for(var C = rng.s.c; C <= rng.e.c; ++C) {
		var cell = ws_get_cell_stub(ws, R, C);
		cell.t = 'n';
		cell.F = rngstr;
		delete cell.v;
		if(R == rng.s.r && C == rng.s.c) {
			cell.f = formula;
			if(dynamic) cell.D = true;
		}
	}
	return ws;
}

var utils/*:any*/ = {
	encode_col: encode_col,
	encode_row: encode_row,
	encode_cell: encode_cell,
	encode_range: encode_range,
	decode_col: decode_col,
	decode_row: decode_row,
	split_cell: split_cell,
	decode_cell: decode_cell,
	decode_range: decode_range,
	format_cell: format_cell,
	sheet_add_aoa: sheet_add_aoa,
	sheet_add_json: sheet_add_json,
	sheet_add_dom: sheet_add_dom,
	aoa_to_sheet: aoa_to_sheet,
	json_to_sheet: json_to_sheet,
	table_to_sheet: parse_dom_table,
	table_to_book: table_to_book,
	sheet_to_csv: sheet_to_csv,
	sheet_to_txt: sheet_to_txt,
	sheet_to_json: sheet_to_json,
	sheet_to_html: sheet_to_html,
	sheet_to_formulae: sheet_to_formulae,
	sheet_to_row_object_array: sheet_to_json,
	sheet_get_cell: ws_get_cell_stub,
	book_new: book_new,
	book_append_sheet: book_append_sheet,
	book_set_sheet_visibility: book_set_sheet_visibility,
	cell_set_number_format: cell_set_number_format,
	cell_set_hyperlink: cell_set_hyperlink,
	cell_set_internal_link: cell_set_internal_link,
	cell_add_comment: cell_add_comment,
	sheet_set_array_formula: sheet_set_array_formula,
	consts: {
		SHEET_VISIBLE: 0,
		SHEET_HIDDEN: 1,
		SHEET_VERY_HIDDEN: 2
	}
};

var _Readable;
function set_readable(R) { _Readable = R; }

function write_csv_stream(sheet/*:Worksheet*/, opts/*:?Sheet2CSVOpts*/) {
	var stream = _Readable();
	var o = opts == null ? {} : opts;
	if(sheet == null || sheet["!ref"] == null) { stream.push(null); return stream; }
	var r = safe_decode_range(sheet["!ref"]);
	var FS = o.FS !== undefined ? o.FS : ",", fs = FS.charCodeAt(0);
	var RS = o.RS !== undefined ? o.RS : "\n", rs = RS.charCodeAt(0);
	var endregex = new RegExp((FS=="|" ? "\\|" : FS)+"+$");
	var row/*:?string*/ = "", cols/*:Array<string>*/ = [];
	o.dense = Array.isArray(sheet);
	var colinfo/*:Array<ColInfo>*/ = o.skipHidden && sheet["!cols"] || [];
	var rowinfo/*:Array<RowInfo>*/ = o.skipHidden && sheet["!rows"] || [];
	for(var C = r.s.c; C <= r.e.c; ++C) if (!((colinfo[C]||{}).hidden)) cols[C] = encode_col(C);
	var R = r.s.r;
	var BOM = false, w = 0;
	stream._read = function() {
		if(!BOM) { BOM = true; return stream.push("\uFEFF"); }
		while(R <= r.e.r) {
			++R;
			if ((rowinfo[R-1]||{}).hidden) continue;
			row = make_csv_row(sheet, r, R-1, cols, fs, rs, FS, o);
			if(row != null) {
				if(o.strip) row = row.replace(endregex,"");
				if(row || (o.blankrows !== false)) return stream.push((w++ ? RS : "") + row);
			}
		}
		return stream.push(null);
	};
	return stream;
}

function write_html_stream(ws/*:Worksheet*/, opts/*:?Sheet2HTMLOpts*/) {
	var stream = _Readable();

	var o = opts || {};
	var header = o.header != null ? o.header : HTML_BEGIN;
	var footer = o.footer != null ? o.footer : HTML_END;
	stream.push(header);
	var r = decode_range(ws['!ref']);
	o.dense = Array.isArray(ws);
	stream.push(make_html_preamble(ws, r, o));
	var R = r.s.r;
	var end = false;
	stream._read = function() {
		if(R > r.e.r) {
			if(!end) { end = true; stream.push("</table>" + footer); }
			return stream.push(null);
		}
		while(R <= r.e.r) {
			stream.push(make_html_row(ws, r, R, o));
			++R;
			break;
		}
	};
	return stream;
}

function write_json_stream(sheet/*:Worksheet*/, opts/*:?Sheet2CSVOpts*/) {
	var stream = _Readable({objectMode:true});

	if(sheet == null || sheet["!ref"] == null) { stream.push(null); return stream; }
	var val = {t:'n',v:0}, header = 0, offset = 1, hdr/*:Array<any>*/ = [], v=0, vv="";
	var r = {s:{r:0,c:0},e:{r:0,c:0}};
	var o = opts || {};
	var range = o.range != null ? o.range : sheet["!ref"];
	if(o.header === 1) header = 1;
	else if(o.header === "A") header = 2;
	else if(Array.isArray(o.header)) header = 3;
	switch(typeof range) {
		case 'string': r = safe_decode_range(range); break;
		case 'number': r = safe_decode_range(sheet["!ref"]); r.s.r = range; break;
		default: r = range;
	}
	if(header > 0) offset = 0;
	var rr = encode_row(r.s.r);
	var cols/*:Array<string>*/ = [];
	var counter = 0;
	var dense = Array.isArray(sheet);
	var R = r.s.r, C = 0;
	var header_cnt = {};
	if(dense && !sheet[R]) sheet[R] = [];
	var colinfo/*:Array<ColInfo>*/ = o.skipHidden && sheet["!cols"] || [];
	var rowinfo/*:Array<RowInfo>*/ = o.skipHidden && sheet["!rows"] || [];
	for(C = r.s.c; C <= r.e.c; ++C) {
		if(((colinfo[C]||{}).hidden)) continue;
		cols[C] = encode_col(C);
		val = dense ? sheet[R][C] : sheet[cols[C] + rr];
		switch(header) {
			case 1: hdr[C] = C - r.s.c; break;
			case 2: hdr[C] = cols[C]; break;
			case 3: hdr[C] = o.header[C - r.s.c]; break;
			default:
				if(val == null) val = {w: "__EMPTY", t: "s"};
				vv = v = format_cell(val, null, o);
				counter = header_cnt[v] || 0;
				if(!counter) header_cnt[v] = 1;
				else {
					do { vv = v + "_" + (counter++); } while(header_cnt[vv]); header_cnt[v] = counter;
					header_cnt[vv] = 1;
				}
				hdr[C] = vv;
		}
	}
	R = r.s.r + offset;
	stream._read = function() {
		while(R <= r.e.r) {
			if ((rowinfo[R-1]||{}).hidden) continue;
			var row = make_json_row(sheet, r, R, cols, header, hdr, dense, o);
			++R;
			if((row.isempty === false) || (header === 1 ? o.blankrows !== false : !!o.blankrows)) {
				stream.push(row.row);
				return;
			}
		}
		return stream.push(null);
	};
	return stream;
}

var __stream = {
	to_json: write_json_stream,
	to_html: write_html_stream,
	to_csv: write_csv_stream,
  set_readable: set_readable
};
const version = XLSX.version;


;// CONCATENATED MODULE: ./app/containers/users/normal-user/component/card/CardDetail.tsx












const CardItem = (param)=>{
    let { card , key  } = param;
    const { t  } = (0,esm/* useTranslation */.$G)();
    const { themeApp  } = (0,react.useContext)(context_AppContext/* AppContext */.I);
    const [copyCode, setCopyCode] = (0,react.useState)(false);
    const [copySerial, setCopySerial] = (0,react.useState)(false);
    const CopyCode = (code)=>{
        if (!copyCode) {
            navigator.clipboard.writeText(code);
            setCopyCode(true);
        }
    };
    const CopySerial = (serial)=>{
        if (!copySerial) {
            navigator.clipboard.writeText(serial);
            setCopySerial(true);
        }
    };
    (0,react.useEffect)(()=>{
        if (copySerial) {
            setTimeout(()=>{
                setCopySerial(false);
            }, 2000);
        }
        if (copyCode) {
            setTimeout(()=>{
                setCopyCode(false);
            }, 2000);
        }
        return ()=>{
            clearTimeout(setTimeout(()=>{
                setCopyCode(false);
            }, 2000));
            clearTimeout(setTimeout(()=>{
                setCopySerial(false);
            }, 2000));
        };
    }, [
        copyCode,
        copySerial
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "border-b-[1px] border-[#0000001A] dark:border-white border-dashed pt-[17px] first:pt-0 last:border-0",
        children: [
            card.card_code && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "flex justify-between mb-2",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        className: "text-[14px] text-neutral-05 dark:text-neutral-08",
                        children: t("store.card_code")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                        onClick: ()=>CopyCode(card.card_code),
                        className: "text-[#757575] text-[14px] flex items-center gap-2 cursor-pointer",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                className: "border-r border-[#e5e5e5] pr-[5px] text-bg-01 dark:text-main-white",
                                children: card.card_code
                            }),
                            !card.is_used && /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                                children: copyCode ? /*#__PURE__*/ (0,jsx_runtime.jsx)(IconCopied/* IconCopied */.i, {}) : /*#__PURE__*/ (0,jsx_runtime.jsx)(IconNonCopy/* IconNonCopy */.x, {})
                            })
                        ]
                    })
                ]
            }),
            card.card_serial && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "flex justify-between mb-2",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        className: "text-[14px] text-neutral-05 dark:text-neutral-08",
                        children: t("store.serial_code")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                        onClick: ()=>CopySerial(card.card_serial),
                        className: "text-neutral-05 dark:text-neutral-08 cursor-pointer\n            text-[14px] flex items-center gap-2",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                className: "border-r border-[#e5e5e5] pr-[5px] dark:text-main-white text-bg-01",
                                children: card.card_serial
                            }),
                            !card.is_used && /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                                children: copySerial ? /*#__PURE__*/ (0,jsx_runtime.jsx)(IconCopied/* IconCopied */.i, {}) : /*#__PURE__*/ (0,jsx_runtime.jsx)(IconNonCopy/* IconNonCopy */.x, {})
                            })
                        ]
                    })
                ]
            }),
            card.expired && !(card === null || card === void 0 ? void 0 : card.is_used) && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "flex justify-between mb-[16px]",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        className: "text-[14px] text-neutral-05 dark:text-neutral-08",
                        children: t("store.expired_date")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        className: "cursor-pointer text-[14px] flex items-center gap-2 dark:text-main-white text-bg-01",
                        children: moment_default()(card === null || card === void 0 ? void 0 : card.expired).format(configs/* DATE_FORMAT */.zT)
                    })
                ]
            }),
            !!(card === null || card === void 0 ? void 0 : card.is_used) && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "flex justify-between mb-[16px]",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        className: "text-[14px]",
                        children: t("reward.status")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                        className: "Nunito-600 text-xs text-bg-01 dark:text-white text-[14px] flex items-center gap-2 bg-[#F5F5F5] dark:bg-white/10 px-[10px] py-[2px] rounded-[8px]",
                        children: t("reward.used")
                    })
                ]
            })
        ]
    }, key);
};
const CardDetail = (param)=>{
    let { dataSelected , setDataSelected  } = param;
    var _dataSelected_items, _dataSelected_items_, _dataSelected_items1, _dataSelected_items_1;
    const { t  } = (0,esm/* useTranslation */.$G)();
    const router = (0,next_router.useRouter)();
    const [dataMethod, setDataMethod] = (0,react.useState)();
    const [copyTransaction, setCopyTransaction] = (0,react.useState)(false);
    const GAEventTracker = (0,useGAEventsTracker/* default */.Z)("OrderHistory");
    const onCopyTransaction = ()=>{
        if (!copyTransaction) {
            navigator.clipboard.writeText(dataSelected === null || dataSelected === void 0 ? void 0 : dataSelected.transaction_id);
            setCopyTransaction(true);
        }
    };
    (0,react.useEffect)(()=>{
        if (copyTransaction) {
            setTimeout(()=>{
                setCopyTransaction(false);
            }, 2000);
        }
        return ()=>{
            clearTimeout(setTimeout(()=>{
                setCopyTransaction(false);
            }, 2000));
        };
    }, [
        copyTransaction
    ]);
    const onBack = ()=>{
        router.back();
        setDataSelected("");
    };
    const getDataMethod = async (item)=>{
        try {
            var _data_data;
            const { data  } = await StoreServices/* default.getListItemDetail */.Z.getListItemDetail(item.item_code);
            setDataMethod(data === null || data === void 0 ? void 0 : (_data_data = data.data) === null || _data_data === void 0 ? void 0 : _data_data.methods.find((item)=>item.method === dataSelected.payment_method));
        } catch (e) {}
    };
    const exportFile = ()=>{
        var _dataSelected_items;
        if (!!(dataSelected === null || dataSelected === void 0 ? void 0 : (_dataSelected_items = dataSelected.items) === null || _dataSelected_items === void 0 ? void 0 : _dataSelected_items.length)) {
            var _dataSelected_items1;
            const result = dataSelected === null || dataSelected === void 0 ? void 0 : (_dataSelected_items1 = dataSelected.items) === null || _dataSelected_items1 === void 0 ? void 0 : _dataSelected_items1.map((param)=>{
                let { is_used , ...rest } = param;
                return rest;
            });
            GAEventTracker("Export_log");
            const worksheet = utils.json_to_sheet(result);
            const workbook = utils.book_new();
            utils.book_append_sheet(workbook, worksheet, "Sheet1");
            //let buffer = write(workbook, { bookType: "xlsx", type: "buffer" });
            //write(workbook, { bookType: "xlsx", type: "binary" });
            writeFileSync(workbook, "export_card.xlsx");
        }
    };
    (0,react.useEffect)(()=>{
        if (dataSelected === null || dataSelected === void 0 ? void 0 : dataSelected.item_code) {
            getDataMethod(dataSelected);
        }
    }, [
        dataSelected
    ]);
    const renderOrderDetail = ()=>{
        var _dataSelected_items, _dataSelected_items1, _dataSelected_amount;
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "pb-[24px] before:mb-4 border-b border-dashed",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "flex items-center mb-4 gap-[12px] xs:justify-between",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "bg-bg-button dark:bg-white/10 px-[10px] rounded-[8px] flex h-[26px] items-center gap-[10px]",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                    className: "text-bg-01 dark:text-white text-[12px] Nunito-500 ",
                                    children: [
                                        t("profile.item_code_summary"),
                                        ":\xa0",
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                            className: "Nunito-700",
                                            children: dataSelected === null || dataSelected === void 0 ? void 0 : dataSelected.transaction_id
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "w-[1px] h-[17px] bg-neutral-08"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    className: "cursor-pointer",
                                    onClick: onCopyTransaction,
                                    children: copyTransaction ? /*#__PURE__*/ (0,jsx_runtime.jsx)(IconCopied/* IconCopied */.i, {}) : /*#__PURE__*/ (0,jsx_runtime.jsx)(IconNonCopy/* IconNonCopy */.x, {})
                                })
                            ]
                        }),
                        !(dataSelected === null || dataSelected === void 0 ? void 0 : (_dataSelected_items = dataSelected.items) === null || _dataSelected_items === void 0 ? void 0 : _dataSelected_items.length) ? /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                            className: "text-label-02 bg-bg-button dark:bg-white/10 text-[12px] Nunito-600 px-[10px] rounded-[8px] flex h-[24px] items-center",
                            children: t("store.wait_export_card")
                        }) : (dataSelected === null || dataSelected === void 0 ? void 0 : (_dataSelected_items1 = dataSelected.items) === null || _dataSelected_items1 === void 0 ? void 0 : _dataSelected_items1.every((item)=>{
                            return !(item === null || item === void 0 ? void 0 : item.is_used);
                        })) ? /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                            className: "text-label-02 bg-bg-button dark:bg-white/10 text-[12px] Nunito-600 px-[10px] rounded-[8px] flex h-[24px] items-center",
                            children: t("common.available")
                        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                            className: "text-label-02 bg-bg-button dark:bg-white/10 text-[12px] Nunito-600 px-[10px] rounded-[8px] flex h-[24px] items-center",
                            children: t("reward.used")
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "flex items-center gap-[16px]",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                            src: dataSelected === null || dataSelected === void 0 ? void 0 : dataSelected.item_icon,
                            alt: dataSelected === null || dataSelected === void 0 ? void 0 : dataSelected.item_name,
                            className: "min-w-[48px] w-[48px] h-[48px] rounded-[12px] object-cover border border-black/10"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "flex justify-between w-full",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "flex flex-col",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                            className: "text-[14px] Nunito-600 text-bg-01 dark:text-white",
                                            children: dataSelected === null || dataSelected === void 0 ? void 0 : dataSelected.item_name
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                            className: "text-[12px] Nunito-400 text-text-grey-03 dark:text-neutral-08",
                                            children: [
                                                t("store.buy_date"),
                                                " ",
                                                moment_default().unix(dataSelected === null || dataSelected === void 0 ? void 0 : dataSelected.created_at).format(configs/* DATE_FORMAT_FULL */.Ob)
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                    className: "ml-auto mr-0 text-main-01 text-[16px] Nunito-600 dark:text-main-01",
                                    children: [
                                        dataSelected === null || dataSelected === void 0 ? void 0 : (_dataSelected_amount = dataSelected.amount) === null || _dataSelected_amount === void 0 ? void 0 : _dataSelected_amount.toLocaleString(),
                                        " đ"
                                    ]
                                })
                            ]
                        })
                    ]
                })
            ]
        });
    };
    const renderOrderInfo = ()=>{
        var _dataSelected_items, _dataSelected_items1, _dataSelected_items2;
        return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "pt-[24px] border-b border-dashed",
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "rounded-[5px]",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "flex items-center justify-between",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                className: "text-base text-bg-01 dark:text-white Nunito-700",
                                children: t("store.order_infor")
                            }),
                            !!(dataSelected === null || dataSelected === void 0 ? void 0 : (_dataSelected_items = dataSelected.items) === null || _dataSelected_items === void 0 ? void 0 : _dataSelected_items.length) && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "flex items-center bg-button dark:bg-white/10 text-main-01 gap-[5px] rounded-[30px] px-[10px] py-[2px] cursor-pointer",
                                onClick: exportFile,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
                                        width: "17",
                                        height: "17",
                                        viewBox: "0 0 17 17",
                                        fill: "none",
                                        xmlns: "http://www.w3.org/2000/svg",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                d: "M6.60156 8.27344L8.4149 10.0868L10.2282 8.27344",
                                                stroke: "#7673E5",
                                                strokeWidth: "1.5",
                                                strokeLinecap: "round",
                                                strokeLinejoin: "round"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                d: "M8.41504 2.83398V10.0377",
                                                stroke: "#7673E5",
                                                strokeWidth: "1.5",
                                                strokeLinecap: "round",
                                                strokeLinejoin: "round"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                d: "M14.1668 8.62695C14.1668 11.7578 12.0418 14.2936 8.50016 14.2936C4.9585 14.2936 2.8335 11.7578 2.8335 8.62695",
                                                stroke: "#7673E5",
                                                strokeWidth: "1.5",
                                                strokeLinecap: "round",
                                                strokeLinejoin: "round"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        className: "text-xs NunitoSans-600 dark:text-white",
                                        children: "Xuất file"
                                    })
                                ]
                            })
                        ]
                    }),
                    (dataSelected === null || dataSelected === void 0 ? void 0 : (_dataSelected_items1 = dataSelected.items) === null || _dataSelected_items1 === void 0 ? void 0 : _dataSelected_items1.length) ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "mt-[16px]",
                        children: dataSelected === null || dataSelected === void 0 ? void 0 : (_dataSelected_items2 = dataSelected.items) === null || _dataSelected_items2 === void 0 ? void 0 : _dataSelected_items2.map((card, index)=>{
                            return /*#__PURE__*/ (0,jsx_runtime.jsx)(CardItem, {
                                card: card
                            }, index);
                        })
                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        className: "py-[8px] text-neutral dark:text-white text-[14px]",
                        children: t("store.pending_text")
                    })
                ]
            })
        });
    };
    const _amountBeforeFee = (dataSelected === null || dataSelected === void 0 ? void 0 : (_dataSelected_items = dataSelected.items) === null || _dataSelected_items === void 0 ? void 0 : (_dataSelected_items_ = _dataSelected_items[0]) === null || _dataSelected_items_ === void 0 ? void 0 : _dataSelected_items_.amount) * (dataSelected === null || dataSelected === void 0 ? void 0 : dataSelected.item_quantity) - (dataSelected === null || dataSelected === void 0 ? void 0 : (_dataSelected_items1 = dataSelected.items) === null || _dataSelected_items1 === void 0 ? void 0 : (_dataSelected_items_1 = _dataSelected_items1[0]) === null || _dataSelected_items_1 === void 0 ? void 0 : _dataSelected_items_1.amount) * (dataSelected === null || dataSelected === void 0 ? void 0 : dataSelected.item_quantity) * (dataSelected === null || dataSelected === void 0 ? void 0 : dataSelected.item_sale_off) / 100;
    const amount = _amountBeforeFee + _amountBeforeFee * ((dataMethod === null || dataMethod === void 0 ? void 0 : dataMethod.fee) || 0) / 100;
    const renderOrderAmount = ()=>{
        var _dataSelected_items, _ref, _dataSelected_items1, _dataSelected_items_, _ref1, _ref2, _dataSelected_items2, _dataSelected_items_1, _ref3;
        return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "mb-[64px] md:mb-4 py-[24px] rounded-[5px]",
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "w-full md:items-right ml-auto flex flex-col gap-[12px]",
                children: [
                    !!(dataSelected === null || dataSelected === void 0 ? void 0 : (_dataSelected_items = dataSelected.items) === null || _dataSelected_items === void 0 ? void 0 : _dataSelected_items.length) && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "flex justify-between",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                        className: "text-[14px] text-neutral-05 dark:text-neutral-08",
                                        children: t("store.total_amount")
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                        className: "text-base text-bg-01 dark:text-white Nunito-600",
                                        children: [
                                            "đ",
                                            " ",
                                            (_ref = (dataSelected === null || dataSelected === void 0 ? void 0 : (_dataSelected_items1 = dataSelected.items) === null || _dataSelected_items1 === void 0 ? void 0 : (_dataSelected_items_ = _dataSelected_items1[0]) === null || _dataSelected_items_ === void 0 ? void 0 : _dataSelected_items_.amount) * (dataSelected === null || dataSelected === void 0 ? void 0 : dataSelected.item_quantity)) === null || _ref === void 0 ? void 0 : _ref.toLocaleString()
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "flex justify-between",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                        className: "text-[14px] text-neutral-05 dark:text-neutral-08",
                                        children: t("store.fee")
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                        className: "text-base text-bg-01 dark:text-white Nunito-600",
                                        children: [
                                            "đ",
                                            " ",
                                            (_ref1 = _amountBeforeFee * ((dataMethod === null || dataMethod === void 0 ? void 0 : dataMethod.fee) || 0) / 100) === null || _ref1 === void 0 ? void 0 : _ref1.toLocaleString()
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "flex justify-between",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                        className: "text-[14px] text-neutral-05 dark:text-neutral-08",
                                        children: t("store.sale_off")
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                        className: "text-base text-bg-01 dark:text-white Nunito-600",
                                        children: [
                                            "đ",
                                            " ",
                                            (_ref2 = ((_dataSelected_items2 = dataSelected.items) === null || _dataSelected_items2 === void 0 ? void 0 : (_dataSelected_items_1 = _dataSelected_items2[0]) === null || _dataSelected_items_1 === void 0 ? void 0 : _dataSelected_items_1.amount) * (dataSelected === null || dataSelected === void 0 ? void 0 : dataSelected.item_quantity) * (dataSelected === null || dataSelected === void 0 ? void 0 : dataSelected.item_sale_off) / 100) === null || _ref2 === void 0 ? void 0 : _ref2.toLocaleString()
                                        ]
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "flex justify-between",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                className: "text-[14px] text-neutral-05 dark:text-neutral-08",
                                children: t("store.payment_method")
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                className: "text-base text-bg-01 dark:text-white Nunito-600",
                                children: dataMethod === null || dataMethod === void 0 ? void 0 : dataMethod.name
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "flex justify-between",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                className: "text-[14px] text-neutral-05 dark:text-neutral-08",
                                children: t("store.total")
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                className: "text-[18px] text-main-01 Nunito-700 ",
                                children: [
                                    "đ ",
                                    (_ref3 = amount || (dataSelected === null || dataSelected === void 0 ? void 0 : dataSelected.amount)) === null || _ref3 === void 0 ? void 0 : _ref3.toLocaleString()
                                ]
                            })
                        ]
                    })
                ]
            })
        });
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "w-full m-auto",
        children: [
            renderOrderDetail(),
            renderOrderInfo(),
            renderOrderAmount()
        ]
    });
};

;// CONCATENATED MODULE: ./app/containers/users/normal-user/component/topup/ItemTopupTransaction.tsx





const ItemTopupTransaction = (param)=>{
    let { item , onSelecteData  } = param;
    var _item_amount;
    const { t  } = (0,esm/* useTranslation */.$G)();
    const router = (0,next_router.useRouter)();
    const onNavigateToDetail = ()=>{
        var _router_query, _router_query1, _router_query2;
        const type = String(router === null || router === void 0 ? void 0 : (_router_query = router.query) === null || _router_query === void 0 ? void 0 : _router_query.type);
        onSelecteData(item);
        router.push({
            pathname: router.pathname,
            query: {
                id: router === null || router === void 0 ? void 0 : (_router_query1 = router.query) === null || _router_query1 === void 0 ? void 0 : _router_query1.id,
                tab: router === null || router === void 0 ? void 0 : (_router_query2 = router.query) === null || _router_query2 === void 0 ? void 0 : _router_query2.tab,
                type: "".concat(type === null || type === void 0 ? void 0 : type.replace("-all", ""), "-detail")
            }
        });
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "p-[12px] bg-white dark:bg-white/10 border rounded-[12px] cursor-pointer border-black/10 hover:border-main-01 dark:border-0 space-y-[12px]",
        onClick: onNavigateToDetail,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                className: "text-[12px] Nunito-400 text-neutral-06 dark:text-neutral-08",
                children: moment_default().unix(item === null || item === void 0 ? void 0 : item.created_at).format(configs/* DATE_FORMAT_FULL */.Ob)
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "gap-1 flex-row rounded-[8px]",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "flex",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                            src: item === null || item === void 0 ? void 0 : item.game_icon,
                            alt: item === null || item === void 0 ? void 0 : item.game_name,
                            className: "w-[55px] h-[55px] rounded-[8px] mr-[13px] object-cover"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "flex-1",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "flex items-center justify-between",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                        className: "text-[14px] Nunito-600 dark:text-white",
                                        children: item === null || item === void 0 ? void 0 : item.game_name
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                    className: "text-[12px] Nunito-400 text-neutral-06 dark:text-neutral-08 line-clamp-1",
                                    children: [
                                        t("profile.item_code_summary"),
                                        ": ",
                                        item === null || item === void 0 ? void 0 : item.transaction_id
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                    className: "text-[12px] Nunito-400 text-neutral-06 dark:text-neutral-08 line-clamp-1",
                                    children: [
                                        t("topup.name_role"),
                                        ": ",
                                        item === null || item === void 0 ? void 0 : item.role_name
                                    ]
                                })
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "pt-[12px] border-t-[1px] border-dashed border-[rgba(0, 0, 0, 0.10)] flex flex-col gap-[8px]",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "flex items-center justify-between gap-2",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                            className: "text-xs text-neutral-06 dark:text-neutral-08",
                            children: [
                                t("store.total"),
                                ":"
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                            className: "text-sm text-main-01 Nunito-700 dark:text-main-red-02",
                            children: [
                                item === null || item === void 0 ? void 0 : (_item_amount = item.amount) === null || _item_amount === void 0 ? void 0 : _item_amount.toLocaleString(),
                                "\xa0",
                                (item === null || item === void 0 ? void 0 : item.method_key) === configs/* XSOLLA_METHOD */._W ? item === null || item === void 0 ? void 0 : item.currency : "đ"
                            ]
                        })
                    ]
                })
            })
        ]
    });
};

;// CONCATENATED MODULE: ./app/containers/users/normal-user/component/topup/TopupTransaction.tsx








const TopupTransaction_LIMIT_CAROUSEL = 8;
const TopupTransaction = (param)=>{
    let { prevRef , nextRef , onSelecteData  } = param;
    var _transactions_pages_flat, _transactions_pages, _transactions_pages_flat1, _transactions_pages1;
    const { t  } = (0,esm/* useTranslation */.$G)();
    const router = (0,next_router.useRouter)();
    const userId = (0,react.useMemo)(()=>{
        var _router_query;
        return router === null || router === void 0 ? void 0 : (_router_query = router.query) === null || _router_query === void 0 ? void 0 : _router_query.id;
    }, [
        router
    ]);
    const type = (0,react.useMemo)(()=>{
        var _router_query;
        return router === null || router === void 0 ? void 0 : (_router_query = router.query) === null || _router_query === void 0 ? void 0 : _router_query.type;
    }, [
        router
    ]);
    const { data: transactions  } = useQueryGetTopupTransaction({}, String(userId), String(type));
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "relative flex",
            children: ((_transactions_pages_flat = transactions === null || transactions === void 0 ? void 0 : (_transactions_pages = transactions.pages) === null || _transactions_pages === void 0 ? void 0 : _transactions_pages.flat()) === null || _transactions_pages_flat === void 0 ? void 0 : _transactions_pages_flat.length) ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(carousel/* Carousel */.lr, {
                className: "w-full",
                opts: {
                    align: "start"
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "overflow-auto",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(carousel/* CarouselContent */.KI, {
                            className: "-ml-0 md:-ml-[24px] min-h-[159px]",
                            children: (_transactions_pages_flat1 = transactions === null || transactions === void 0 ? void 0 : (_transactions_pages1 = transactions.pages) === null || _transactions_pages1 === void 0 ? void 0 : _transactions_pages1.flat()) === null || _transactions_pages_flat1 === void 0 ? void 0 : _transactions_pages_flat1.slice(0, TopupTransaction_LIMIT_CAROUSEL).map((item, i)=>{
                                return /*#__PURE__*/ (0,jsx_runtime.jsx)(carousel/* CarouselItem */.d$, {
                                    className: "md:min-w-0 ".concat(i === 0 ? "basis-4/5 pl-0" : "pl-[8px]", " md:basis-1/2 lg:basis-1/3 2xl:basis-1/3 md:pl-[24px]"),
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ItemTopupTransaction, {
                                        item: item,
                                        onSelecteData: onSelecteData
                                    }, i)
                                }, i);
                            })
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(carousel/* CarouselNext */.Pz, {
                        ref: nextRef,
                        className: "hidden"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(carousel/* CarouselPrevious */.am, {
                        ref: prevRef,
                        className: "hidden"
                    })
                ]
            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "w-full min-h-[160px] flex items-center justify-center",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(data_empty/* DataEmpty */.$, {
                    title: t("profile.no_data")
                })
            })
        })
    });
};

;// CONCATENATED MODULE: ./app/containers/users/normal-user/component/merchandise/ItemMerchandiseTransaction.tsx








const ItemMerchandiseTransaction = (param)=>{
    let { item , onSelecteData  } = param;
    var _item_list_item_, _item_list_item_1, _item_list_item_2, _item_list_item_3, _item_total_amount;
    const { t  } = (0,esm/* useTranslation */.$G)();
    const router = (0,next_router.useRouter)();
    const status = {
        pending: {
            label: t("profile.pending_confirm"),
            value: "pending"
        },
        confirmed: {
            label: t("profile.transaction_confirmed"),
            value: "confirmed"
        },
        transfer: {
            label: t("profile.transaction_transfer"),
            value: "transfer"
        },
        done: {
            label: t("profile.transaction_done"),
            value: "done"
        },
        rejected: {
            label: t("profile.transaction_cancel"),
            value: "rejected"
        },
        cancel: {
            label: t("profile.transaction_cancel"),
            value: "cancel"
        },
        destroy: {
            label: t("profile.transaction_cancel"),
            value: "destroy"
        },
        refund: {
            label: t("profile.transaction_cancel"),
            value: "refund"
        }
    };
    const onNavigateToDetail = ()=>{
        var _router_query, _router_query1, _router_query2;
        const type = String(router === null || router === void 0 ? void 0 : (_router_query = router.query) === null || _router_query === void 0 ? void 0 : _router_query.type);
        onSelecteData(item);
        router.push({
            pathname: router.pathname,
            query: {
                id: router === null || router === void 0 ? void 0 : (_router_query1 = router.query) === null || _router_query1 === void 0 ? void 0 : _router_query1.id,
                tab: router === null || router === void 0 ? void 0 : (_router_query2 = router.query) === null || _router_query2 === void 0 ? void 0 : _router_query2.tab,
                type: type === "undefined" ? enumViewDetailTransaction.CARD_DETAIL : "".concat(type === null || type === void 0 ? void 0 : type.replace("-all", ""), "-detail")
            }
        });
    };
    const totalItem = (0,react.useCallback)(()=>{
        var _item_list_item;
        if (!(item === null || item === void 0 ? void 0 : (_item_list_item = item.list_item) === null || _item_list_item === void 0 ? void 0 : _item_list_item.length)) return 0;
        const list = item === null || item === void 0 ? void 0 : item.list_item;
        const total = list === null || list === void 0 ? void 0 : list.reduce((total, current)=>{
            return total + Number(current === null || current === void 0 ? void 0 : current.quantity);
        }, 0);
        return total !== null && total !== void 0 ? total : 0;
    }, [
        item
    ]);
    const renderStatusTransaction = ()=>{
        switch(item.status){
            case "cancel":
                {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        className: "text-[12px] Nunito-600 rounded-[8px] line-clamp-1 text-label-02 flex items-center min-w-fit",
                        children: t("profile.transaction_cancel")
                    });
                }
            case "pending":
                {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        className: "text-[12px] Nunito-600 rounded-[8px] line-clamp-1 flex text-label-02 items-center min-w-fit",
                        children: t("profile.transaction_pending")
                    });
                }
            default:
                {
                    var _status_item_list_item__status, _item_list_item_;
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        className: "text-[12px] text-label-02 Nunito-600 line-clamp-1 rounded-[8px] flex items-center",
                        children: (item === null || item === void 0 ? void 0 : item.ghtk_status) === -1 ? status.cancel.label : (_status_item_list_item__status = status[(_item_list_item_ = item === null || item === void 0 ? void 0 : item.list_item[0]) === null || _item_list_item_ === void 0 ? void 0 : _item_list_item_.status]) === null || _status_item_list_item__status === void 0 ? void 0 : _status_item_list_item__status.label
                    });
                }
        }
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "p-[12px] space-y-[12px] bg-white dark:bg-white/10 rounded-[16px] w-full cursor-pointer border border-black/10 hover:border-main-01 dark:border-0",
        onClick: onNavigateToDetail,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "flex justify-between items-center",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        className: "text-xs text-neutral-06 dark:text-neutral-08",
                        children: moment_default().unix(item === null || item === void 0 ? void 0 : item.created_at).format(configs/* DATE_FORMAT_FULL */.Ob)
                    }),
                    renderStatusTransaction()
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "flex gap-1 sm:flex-row rounded-[8px] w-full",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                        src: (_item_list_item_ = item === null || item === void 0 ? void 0 : item.list_item[0]) === null || _item_list_item_ === void 0 ? void 0 : _item_list_item_.images[0],
                        alt: (_item_list_item_1 = item === null || item === void 0 ? void 0 : item.list_item[0]) === null || _item_list_item_1 === void 0 ? void 0 : _item_list_item_1.item_name,
                        className: "w-[55px] h-[55px] rounded-[8px] mr-[13px] object-cover"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "flex-1",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "flex items-center justify-between gap-2 mb-1",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                    className: "text-[14px] Nunito-600 line-clamp-1",
                                    children: (_item_list_item_2 = item === null || item === void 0 ? void 0 : item.list_item[0]) === null || _item_list_item_2 === void 0 ? void 0 : _item_list_item_2.item_name
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                className: "text-xs break-all Nunito-400 text-neutral-06 dark:text-neutral-08 line-clamp-1",
                                children: [
                                    t("profile.item_code_summary"),
                                    ": ",
                                    item === null || item === void 0 ? void 0 : item.transaction_id
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "flex items-center justify-between w-full gap-3",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                        className: "text-[12px] dark:text-neutral-08",
                                        children: [
                                            "x",
                                            (_item_list_item_3 = item === null || item === void 0 ? void 0 : item.list_item[0]) === null || _item_list_item_3 === void 0 ? void 0 : _item_list_item_3.quantity
                                        ]
                                    }),
                                    totalItem() > 1 && /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                        className: "flex items-center text-xs text-main-01 Nunito-400",
                                        children: [
                                            totalItem(),
                                            "\xa0",
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                className: "lowercase",
                                                children: t("merchandise.product")
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
                                                    width: "24",
                                                    height: "24",
                                                    viewBox: "0 0 24 24",
                                                    fill: "none",
                                                    xmlns: "http://www.w3.org/2000/svg",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                        d: "M10 7L14 12L10 17",
                                                        stroke: "#7673E6",
                                                        strokeWidth: "1.5",
                                                        strokeLinecap: "round",
                                                        strokeLinejoin: "round"
                                                    })
                                                })
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "border-t-[1px] border-dashed border-[rgba(0, 0, 0, 0.10)] flex flex-col gap-[8px] pt-[12px]",
                children: item.status === "pending" && (Number(item === null || item === void 0 ? void 0 : item.created_at) + configs/* _15M_TIME_STAMP */.Ax) * 1000 > Number(moment_default()().unix()) * 1000 ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "flex justify-between items-center",
                    children: [
                        (Number(item === null || item === void 0 ? void 0 : item.created_at) + configs/* _15M_TIME_STAMP */.Ax) * 1000 > Number(moment_default()().unix()) * 1000 && /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                            className: "text-xs text-main-red-02 Nunito-400",
                            children: t("profile.remind_pending_status", {
                                time: moment_default()((Number(item === null || item === void 0 ? void 0 : item.created_at) + configs/* _15M_TIME_STAMP */.Ax) * 1000).format(configs/* DATE_FORMAT_FULL */.Ob)
                            })
                        }),
                        (item === null || item === void 0 ? void 0 : item.payment_link) && (Number(item === null || item === void 0 ? void 0 : item.created_at) + configs/* _15M_TIME_STAMP */.Ax) * 1000 > Number(moment_default()().unix()) * 1000 && /*#__PURE__*/ (0,jsx_runtime.jsx)(ui_button/* Button */.z, {
                            variant: "main",
                            className: "text-[12px] Nunito-500 h-[24px] lg:w-fit px-[8px] rounded-[8px]",
                            onClick: (e)=>{
                                e.stopPropagation();
                                window.location.href = item === null || item === void 0 ? void 0 : item.payment_link;
                            },
                            children: t("store.pay")
                        })
                    ]
                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "flex items-center justify-between gap-2",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                className: "text-xs text-neutral-06 dark:text-neutral-08",
                                children: [
                                    t("store.total"),
                                    ":"
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                className: "text-sm text-main-01 Nunito-700 dark:text-main-red-02",
                                children: [
                                    item === null || item === void 0 ? void 0 : (_item_total_amount = item.total_amount) === null || _item_total_amount === void 0 ? void 0 : _item_total_amount.toLocaleString(),
                                    "\xa0đ"
                                ]
                            })
                        ]
                    })
                })
            })
        ]
    });
};

;// CONCATENATED MODULE: ./app/containers/users/normal-user/component/merchandise/MerchandiseTransaction.tsx








const MerchandiseTransaction_LIMIT_CAROUSEL = 8;
const MerchandiseTransaction = (param)=>{
    let { prevRef , nextRef , onSelecteData  } = param;
    var _merchandises_pages_flat, _merchandises_pages, _merchandises_pages_flat1, _merchandises_pages1;
    const { t  } = (0,esm/* useTranslation */.$G)();
    const router = (0,next_router.useRouter)();
    const userId = (0,react.useMemo)(()=>{
        var _router_query;
        return router === null || router === void 0 ? void 0 : (_router_query = router.query) === null || _router_query === void 0 ? void 0 : _router_query.id;
    }, [
        router
    ]);
    const type = (0,react.useMemo)(()=>{
        var _router_query;
        return router === null || router === void 0 ? void 0 : (_router_query = router.query) === null || _router_query === void 0 ? void 0 : _router_query.type;
    }, [
        router
    ]);
    const { data: merchandises  } = useQueryGetUserMerchandiseHistory({}, String(userId), String(type));
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "relative flex",
            children: ((_merchandises_pages_flat = merchandises === null || merchandises === void 0 ? void 0 : (_merchandises_pages = merchandises.pages) === null || _merchandises_pages === void 0 ? void 0 : _merchandises_pages.flat()) === null || _merchandises_pages_flat === void 0 ? void 0 : _merchandises_pages_flat.length) ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(carousel/* Carousel */.lr, {
                className: "w-full",
                opts: {
                    align: "start"
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "overflow-auto",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(carousel/* CarouselContent */.KI, {
                            className: "-ml-0 md:-ml-[24px] min-h-[159px]",
                            children: (_merchandises_pages_flat1 = merchandises === null || merchandises === void 0 ? void 0 : (_merchandises_pages1 = merchandises.pages) === null || _merchandises_pages1 === void 0 ? void 0 : _merchandises_pages1.flat()) === null || _merchandises_pages_flat1 === void 0 ? void 0 : _merchandises_pages_flat1.slice(0, MerchandiseTransaction_LIMIT_CAROUSEL).map((item, i)=>{
                                return /*#__PURE__*/ (0,jsx_runtime.jsx)(carousel/* CarouselItem */.d$, {
                                    className: "md:min-w-0 ".concat(i === 0 ? "basis-4/5 pl-0" : "pl-[8px]", " md:basis-1/2 lg:basis-1/3 2xl:basis-1/3 md:pl-[24px] flex"),
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ItemMerchandiseTransaction, {
                                        item: item,
                                        onSelecteData: onSelecteData
                                    }, i)
                                }, i);
                            })
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(carousel/* CarouselNext */.Pz, {
                        ref: nextRef,
                        className: "hidden"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(carousel/* CarouselPrevious */.am, {
                        ref: prevRef,
                        className: "hidden"
                    })
                ]
            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "w-full min-h-[160px] flex items-center justify-center",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(data_empty/* DataEmpty */.$, {
                    title: t("profile.no_data")
                })
            })
        })
    });
};

// EXTERNAL MODULE: ./app/lib/utils.ts + 1 modules
var lib_utils = __webpack_require__(73848);
;// CONCATENATED MODULE: ./app/containers/users/normal-user/component/card/AllCardTransaction.tsx











const AllCardTransaction = (param)=>{
    let { onSelecteData  } = param;
    var _transactions_pages_flat, _transactions_pages, _transactions_pages_flat1, _transactions_pages1;
    const { t  } = (0,esm/* useTranslation */.$G)();
    const router = (0,next_router.useRouter)();
    const { ref , inView  } = (0,react_intersection_observer/* useInView */.YD)();
    const userId = (0,react.useMemo)(()=>{
        var _router_query;
        return router === null || router === void 0 ? void 0 : (_router_query = router.query) === null || _router_query === void 0 ? void 0 : _router_query.id;
    }, [
        router
    ]);
    const type = (0,react.useMemo)(()=>{
        var _router_query;
        return router === null || router === void 0 ? void 0 : (_router_query = router.query) === null || _router_query === void 0 ? void 0 : _router_query.type;
    }, [
        router
    ]);
    const { watch  } = (0,index_esm/* useFormContext */.Gc)();
    const watchKeyword = watch("keyword", "");
    const watchStartTime = watch("start_date", undefined);
    const watchEndTime = watch("end_date", undefined);
    const { data: transactions , fetchNextPage  } = useQueryGetCardTransaction((0,lib_utils/* removeNullKeyObject */.t2)({
        keyword: watchKeyword,
        start_date: !!watchStartTime ? moment_default()(watchStartTime).format("YYYY-MM-DD") : undefined,
        end_date: !!watchEndTime ? moment_default()(watchEndTime).format("YYYY-MM-DD") : undefined
    }), String(userId), String(type));
    react.useEffect(()=>{
        if (inView) {
            fetchNextPage();
        }
    }, [
        fetchNextPage,
        inView
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "w-full relative pb-[40px]",
        children: !!((_transactions_pages_flat = transactions === null || transactions === void 0 ? void 0 : (_transactions_pages = transactions.pages) === null || _transactions_pages === void 0 ? void 0 : _transactions_pages.flat()) === null || _transactions_pages_flat === void 0 ? void 0 : _transactions_pages_flat.length) ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "grid grid-cols-1 md:grid-cols-2 sd:grid-cols-3 gap-[24px]",
                    children: (_transactions_pages_flat1 = transactions === null || transactions === void 0 ? void 0 : (_transactions_pages1 = transactions.pages) === null || _transactions_pages1 === void 0 ? void 0 : _transactions_pages1.flat()) === null || _transactions_pages_flat1 === void 0 ? void 0 : _transactions_pages_flat1.map((item, i)=>{
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(ItemCardTransaction, {
                            item: item,
                            onSelecteData: onSelecteData
                        }, i);
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                    ref: ref,
                    className: "opacity-0",
                    children: "Load more"
                })
            ]
        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "w-full min-h-[160px] flex items-center justify-center",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(data_empty/* DataEmpty */.$, {
                title: t("profile.no_data")
            })
        })
    });
};

;// CONCATENATED MODULE: ./app/containers/users/normal-user/component/topup/AllTopupTransaction.tsx











const AllTopupTransaction = (param)=>{
    let { onSelecteData  } = param;
    var _transactions_pages_flat, _transactions_pages, _transactions_pages_flat1, _transactions_pages1;
    const { t  } = (0,esm/* useTranslation */.$G)();
    const router = (0,next_router.useRouter)();
    const { ref , inView  } = (0,react_intersection_observer/* useInView */.YD)();
    const userId = (0,react.useMemo)(()=>{
        var _router_query;
        return router === null || router === void 0 ? void 0 : (_router_query = router.query) === null || _router_query === void 0 ? void 0 : _router_query.id;
    }, [
        router
    ]);
    const type = (0,react.useMemo)(()=>{
        var _router_query;
        return router === null || router === void 0 ? void 0 : (_router_query = router.query) === null || _router_query === void 0 ? void 0 : _router_query.type;
    }, [
        router
    ]);
    const { watch  } = (0,index_esm/* useFormContext */.Gc)();
    const watchKeyword = watch("keyword", "");
    const watchStartTime = watch("start_date", undefined);
    const watchEndTime = watch("end_date", undefined);
    const { data: transactions , fetchNextPage  } = useQueryGetTopupTransaction((0,lib_utils/* removeNullKeyObject */.t2)({
        keyword: watchKeyword,
        start_date: !!watchStartTime ? moment_default()(watchStartTime).format("YYYY-MM-DD") : undefined,
        end_date: !!watchEndTime ? moment_default()(watchEndTime).format("YYYY-MM-DD") : undefined
    }), String(userId), String(type));
    react.useEffect(()=>{
        if (inView) {
            fetchNextPage();
        }
    }, [
        fetchNextPage,
        inView
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "w-full relative pb-[40px]",
        children: !!((_transactions_pages_flat = transactions === null || transactions === void 0 ? void 0 : (_transactions_pages = transactions.pages) === null || _transactions_pages === void 0 ? void 0 : _transactions_pages.flat()) === null || _transactions_pages_flat === void 0 ? void 0 : _transactions_pages_flat.length) ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "grid grid-cols-1 md:grid-cols-2 sd:grid-cols-3 gap-[24px]",
                    children: (_transactions_pages_flat1 = transactions === null || transactions === void 0 ? void 0 : (_transactions_pages1 = transactions.pages) === null || _transactions_pages1 === void 0 ? void 0 : _transactions_pages1.flat()) === null || _transactions_pages_flat1 === void 0 ? void 0 : _transactions_pages_flat1.map((item, i)=>{
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(ItemTopupTransaction, {
                            item: item,
                            onSelecteData: onSelecteData
                        }, i);
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                    ref: ref,
                    className: "opacity-0",
                    children: "Load more"
                })
            ]
        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "w-full min-h-[160px] flex items-center justify-center",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(data_empty/* DataEmpty */.$, {
                title: t("profile.no_data")
            })
        })
    });
};

;// CONCATENATED MODULE: ./app/containers/users/normal-user/component/topup/TopupDetail.tsx








const TopupDetail = (param)=>{
    let { dataSelected , setDataSelected  } = param;
    const { t  } = (0,esm/* useTranslation */.$G)();
    const router = (0,next_router.useRouter)();
    const onBack = ()=>{
        router.back();
        setDataSelected("");
    };
    const [transactionCopy, setTransactionCopy] = (0,react.useState)(null);
    const onCopyTransaction = (transaction_id)=>(e)=>{
            e.stopPropagation();
            navigator.clipboard.writeText("".concat(transaction_id));
            setTransactionCopy(transaction_id);
        };
    const renderGameInfo = ()=>{
        var _dataSelected_amount;
        return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "pb-[24px] rounded-[5px] border-b border-dashed",
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "flex items-center mt-[18px]",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                        src: dataSelected === null || dataSelected === void 0 ? void 0 : dataSelected.game_icon,
                        alt: dataSelected === null || dataSelected === void 0 ? void 0 : dataSelected.game_name,
                        className: "w-[48px] h-[48px] rounded-[12px] mr-[13px] object-cover border border-[rgba(0, 0, 0, 0.10)]"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                className: "text-[14px] Nunito-600",
                                children: dataSelected === null || dataSelected === void 0 ? void 0 : dataSelected.game_name
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                className: "text-[12px] Nunito-400 text-text-grey-03 dark:text-neutral-08",
                                children: [
                                    t("store.buy_date"),
                                    " ",
                                    moment_default().unix(dataSelected === null || dataSelected === void 0 ? void 0 : dataSelected.created_at).format(configs/* DATE_FORMAT_FULL */.Ob)
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                        className: "ml-auto mr-0 text-main-01 text-[16px] Nunito-600 dark:text-main-01",
                        children: [
                            dataSelected === null || dataSelected === void 0 ? void 0 : (_dataSelected_amount = dataSelected.amount) === null || _dataSelected_amount === void 0 ? void 0 : _dataSelected_amount.toLocaleString(),
                            " ",
                            (dataSelected === null || dataSelected === void 0 ? void 0 : dataSelected.method_key) === configs/* XSOLLA_METHOD */._W ? dataSelected === null || dataSelected === void 0 ? void 0 : dataSelected.currency : "đ"
                        ]
                    })
                ]
            })
        });
    };
    const renderOrderDetail = ()=>{
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "py-[24px] border-b border-dashed rounded-[5px]",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                    className: "text-bg-01 Nunito-600 text-base mb-[22px] dark:text-white",
                    children: t("store.order_infor")
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "flex items-center justify-between mb-[12px]",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                            className: "text-sm Nunito-400 text-neutral-05 dark:text-neutral-08",
                            children: t("topup.title_transaction")
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "flex items-center gap-[10px] cursor-pointer",
                            onClick: onCopyTransaction(dataSelected === null || dataSelected === void 0 ? void 0 : dataSelected.transaction_id),
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                    className: "text-sm Nunito-600 text-bg-01 dark:text-white",
                                    children: dataSelected === null || dataSelected === void 0 ? void 0 : dataSelected.transaction_id
                                }),
                                " ",
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    className: "text-black/[.1] dark:text-white",
                                    children: "|"
                                }),
                                transactionCopy === (dataSelected === null || dataSelected === void 0 ? void 0 : dataSelected.transaction_id) ? /*#__PURE__*/ (0,jsx_runtime.jsx)(IconCopied/* IconCopied */.i, {}) : /*#__PURE__*/ (0,jsx_runtime.jsx)(IconNonCopy/* IconNonCopy */.x, {})
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "flex items-center justify-between mb-[12px]",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                            className: "text-sm Nunito-400 text-neutral-05 dark:text-neutral-08",
                            children: t("topup.server")
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                            className: "text-sm Nunito-600 text-bg-01 dark:text-white",
                            children: dataSelected === null || dataSelected === void 0 ? void 0 : dataSelected.server_name
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "flex items-center justify-between ",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                            className: "text-sm Nunito-400 text-neutral-05 dark:text-neutral-08",
                            children: t("topup.name_role")
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                            className: "text-sm Nunito-600 text-bg-01 dark:text-white",
                            children: dataSelected === null || dataSelected === void 0 ? void 0 : dataSelected.role_name
                        })
                    ]
                })
            ]
        });
    };
    const renderOrderAmount = ()=>{
        var _dataSelected_amount;
        return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "mb-[64px] md:mb-4 rounded-[5px] py-[24px]",
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "ml-auto flex flex-col gap-[12px]",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "flex justify-between",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                className: "text-neutral-05 dark:text-neutral-08 text-[14px]",
                                children: t("store.payment_method")
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                className: "text-base text-bg-01 dark:text-main-white Nunito-600",
                                children: dataSelected === null || dataSelected === void 0 ? void 0 : dataSelected.method
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "flex justify-between",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                className: "text-neutral-05 dark:text-neutral-08 text-[14px]",
                                children: t("store.total")
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                className: "text-[18px] text-main-01 Nunito-700",
                                children: [
                                    dataSelected === null || dataSelected === void 0 ? void 0 : (_dataSelected_amount = dataSelected.amount) === null || _dataSelected_amount === void 0 ? void 0 : _dataSelected_amount.toLocaleString(),
                                    "\xa0",
                                    (dataSelected === null || dataSelected === void 0 ? void 0 : dataSelected.method_key) === configs/* XSOLLA_METHOD */._W ? dataSelected === null || dataSelected === void 0 ? void 0 : dataSelected.currency : "đ"
                                ]
                            })
                        ]
                    })
                ]
            })
        });
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "w-full m-auto",
        children: [
            renderGameInfo(),
            renderOrderDetail(),
            renderOrderAmount()
        ]
    });
};

;// CONCATENATED MODULE: ./app/containers/users/normal-user/component/merchandise/AllMerchandiseTransaction.tsx











const AllMerchandiseTransaction = (param)=>{
    let { onSelecteData  } = param;
    var _merchandises_pages_flat, _merchandises_pages, _merchandises_pages_flat1, _merchandises_pages1;
    const { t  } = (0,esm/* useTranslation */.$G)();
    const router = (0,next_router.useRouter)();
    const { ref , inView  } = (0,react_intersection_observer/* useInView */.YD)();
    const userId = (0,react.useMemo)(()=>{
        var _router_query;
        return router === null || router === void 0 ? void 0 : (_router_query = router.query) === null || _router_query === void 0 ? void 0 : _router_query.id;
    }, [
        router
    ]);
    const type = (0,react.useMemo)(()=>{
        var _router_query;
        return router === null || router === void 0 ? void 0 : (_router_query = router.query) === null || _router_query === void 0 ? void 0 : _router_query.type;
    }, [
        router
    ]);
    const { watch  } = (0,index_esm/* useFormContext */.Gc)();
    const watchKeyword = watch("keyword", "");
    const watchStartTime = watch("start_date", undefined);
    const watchEndTime = watch("end_date", undefined);
    const { data: merchandises , fetchNextPage  } = useQueryGetUserMerchandiseHistory((0,lib_utils/* removeNullKeyObject */.t2)({
        keyword: watchKeyword,
        start_date: !!watchStartTime ? moment_default()(watchStartTime).format("YYYY-MM-DD") : undefined,
        end_date: !!watchEndTime ? moment_default()(watchEndTime).format("YYYY-MM-DD") : undefined
    }), String(userId), String(type));
    react.useEffect(()=>{
        if (inView) {
            fetchNextPage();
        }
    }, [
        fetchNextPage,
        inView
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "w-full relative pb-[40px]",
        children: !!((_merchandises_pages_flat = merchandises === null || merchandises === void 0 ? void 0 : (_merchandises_pages = merchandises.pages) === null || _merchandises_pages === void 0 ? void 0 : _merchandises_pages.flat()) === null || _merchandises_pages_flat === void 0 ? void 0 : _merchandises_pages_flat.length) ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "grid grid-cols-1 md:grid-cols-2 sd:grid-cols-3 gap-[24px]",
                    children: (_merchandises_pages_flat1 = merchandises === null || merchandises === void 0 ? void 0 : (_merchandises_pages1 = merchandises.pages) === null || _merchandises_pages1 === void 0 ? void 0 : _merchandises_pages1.flat()) === null || _merchandises_pages_flat1 === void 0 ? void 0 : _merchandises_pages_flat1.map((item, i)=>{
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(ItemMerchandiseTransaction, {
                            item: item,
                            onSelecteData: onSelecteData
                        }, i);
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                    ref: ref,
                    className: "opacity-0",
                    children: "Load more"
                })
            ]
        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "w-full min-h-[160px] flex items-center justify-center",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(data_empty/* DataEmpty */.$, {
                title: t("profile.no_data")
            })
        })
    });
};

;// CONCATENATED MODULE: ./app/containers/users/normal-user/component/merchandise/ItemDetailMerchandise.tsx



const ItemDetailMerchandiseWeb = (param)=>{
    let { dataSelected , item  } = param;
    var _item_images, _item_color, _item_color1, _item_color2, _item_item_price, _ref, _Number;
    const { t  } = (0,esm/* useTranslation */.$G)();
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "hidden grid-cols-12 md:grid",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "flex gap-[16px] items-center col-span-5",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                        src: item === null || item === void 0 ? void 0 : (_item_images = item.images) === null || _item_images === void 0 ? void 0 : _item_images[0],
                        alt: item === null || item === void 0 ? void 0 : item.item_name,
                        className: "w-[48px] h-[48px] rounded-[12px] object-cover border border-[rgba(0, 0, 0, 0.10)] dark:border-border-light"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "flex flex-col",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                className: "text-[14px] Nunito-600",
                                children: item === null || item === void 0 ? void 0 : item.item_name
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                className: "text-[12px] Nunito-400 text-text-grey-03 dark:text-neutral-08",
                                children: [
                                    item === null || item === void 0 ? void 0 : (_item_color = item.color) === null || _item_color === void 0 ? void 0 : _item_color.name,
                                    (item === null || item === void 0 ? void 0 : item.size) && ", ".concat(item === null || item === void 0 ? void 0 : item.size)
                                ]
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "flex items-center col-span-2",
                children: !!(item === null || item === void 0 ? void 0 : (_item_color1 = item.color) === null || _item_color1 === void 0 ? void 0 : _item_color1.length) ? item === null || item === void 0 ? void 0 : (_item_color2 = item.color) === null || _item_color2 === void 0 ? void 0 : _item_color2.join(",") : ""
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "flex items-center col-span-2",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                    className: "text-[14px] text-bg-01 Nunito-600 dark:text-white",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            children: item === null || item === void 0 ? void 0 : item.quantity
                        }),
                        " ",
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            className: "text-neutral-06 Nunito-600 dark:text-white",
                            children: "x"
                        }),
                        " ",
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            children: "".concat(item === null || item === void 0 ? void 0 : (_item_item_price = item.item_price) === null || _item_item_price === void 0 ? void 0 : _item_item_price.toLocaleString(), " đ")
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "flex items-center justify-end col-span-3 gap-2",
                children: [
                    !!(item === null || item === void 0 ? void 0 : item.sale_percent) && /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        className: "text-[14px] line-through text-neutral-05 Nunito-400",
                        children: "".concat((_ref = Number(item === null || item === void 0 ? void 0 : item.item_price) * Number(item === null || item === void 0 ? void 0 : item.quantity)) === null || _ref === void 0 ? void 0 : _ref.toLocaleString(), " đ")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        className: "text-[14px] text-main-01 Nunito-600",
                        children: "".concat((_Number = Number(item === null || item === void 0 ? void 0 : item.amount)) === null || _Number === void 0 ? void 0 : _Number.toLocaleString(), " đ")
                    })
                ]
            })
        ]
    });
};
const ItemDetailMerchandiseMobile = (param)=>{
    let { dataSelected , item  } = param;
    var _item_images, _item_color, _item_color1, _item_color2, _ref, _Number;
    const { t  } = (0,esm/* useTranslation */.$G)();
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "flex md:hidden items-center gap-[12px]",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                src: item === null || item === void 0 ? void 0 : (_item_images = item.images) === null || _item_images === void 0 ? void 0 : _item_images[0],
                alt: item === null || item === void 0 ? void 0 : item.item_name,
                className: "w-[65px] h-[65px] rounded-[12px] object-cover border border-[rgba(0, 0, 0, 0.10)] dark:border-border-light"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "flex flex-col flex-1",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        className: "text-[14px] Nunito-600",
                        children: item === null || item === void 0 ? void 0 : item.item_name
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        className: "",
                        children: !!(item === null || item === void 0 ? void 0 : (_item_color = item.color) === null || _item_color === void 0 ? void 0 : _item_color.length) ? item === null || item === void 0 ? void 0 : (_item_color1 = item.color) === null || _item_color1 === void 0 ? void 0 : _item_color1.join(",") : ""
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "flex items-center justify-between w-full",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                className: "text-[12px] text-neutral-05 Nunito-600 dark:text-white",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "text-[12px] Nunito-400 text-neutral-05 Nunito-600 dark:text-white",
                                        children: [
                                            item === null || item === void 0 ? void 0 : (_item_color2 = item.color) === null || _item_color2 === void 0 ? void 0 : _item_color2.name,
                                            (item === null || item === void 0 ? void 0 : item.size) && ", ".concat(item === null || item === void 0 ? void 0 : item.size)
                                        ]
                                    }),
                                    "x",
                                    item === null || item === void 0 ? void 0 : item.quantity
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "flex items-center gap-2",
                                children: [
                                    Number(item === null || item === void 0 ? void 0 : item.item_price) * Number(item === null || item === void 0 ? void 0 : item.quantity) !== Number(item === null || item === void 0 ? void 0 : item.amount) && /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                        className: "text-[14px] line-through text-neutral-05 Nunito-400",
                                        children: "".concat((_ref = Number(item === null || item === void 0 ? void 0 : item.item_price) * Number(item === null || item === void 0 ? void 0 : item.quantity)) === null || _ref === void 0 ? void 0 : _ref.toLocaleString(), " đ")
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                        className: "text-[14px] text-main-01 Nunito-600",
                                        children: "".concat((_Number = Number(item === null || item === void 0 ? void 0 : item.amount)) === null || _Number === void 0 ? void 0 : _Number.toLocaleString(), " đ")
                                    })
                                ]
                            })
                        ]
                    })
                ]
            })
        ]
    });
};

// EXTERNAL MODULE: ./app/components/icon-tsx/IconClose.tsx
var IconClose = __webpack_require__(51337);
// EXTERNAL MODULE: ./app/components/loading-btn/index.tsx + 2 modules
var loading_btn = __webpack_require__(25327);
// EXTERNAL MODULE: ./app/components/ui/dialog.tsx
var dialog = __webpack_require__(76500);
// EXTERNAL MODULE: ./app/components/ui/radio-group.tsx + 1 modules
var radio_group = __webpack_require__(63645);
// EXTERNAL MODULE: ./app/components/ui/textarea.tsx
var ui_textarea = __webpack_require__(61397);
// EXTERNAL MODULE: ./app/services/query-fn/merchandise/merchandise-mutation.ts
var merchandise_mutation = __webpack_require__(213);
// EXTERNAL MODULE: ./node_modules/@tanstack/react-query/build/modern/QueryClientProvider.js
var QueryClientProvider = __webpack_require__(30202);
;// CONCATENATED MODULE: ./app/containers/users/normal-user/component/merchandise/ModalCancelMerchandise.tsx












const ModalCancelMerchandise = (param)=>{
    let { open , onOpenChange , dataSelected  } = param;
    const { t  } = (0,esm/* useTranslation */.$G)();
    const [value, setValue] = (0,react.useState)("");
    const router = (0,next_router.useRouter)();
    const queryClient = (0,QueryClientProvider/* useQueryClient */.NL)();
    const userId = (0,react.useMemo)(()=>{
        var _router_query;
        return router === null || router === void 0 ? void 0 : (_router_query = router.query) === null || _router_query === void 0 ? void 0 : _router_query.id;
    }, [
        router
    ]);
    const type = (0,react.useMemo)(()=>{
        var _router_query;
        return router === null || router === void 0 ? void 0 : (_router_query = router.query) === null || _router_query === void 0 ? void 0 : _router_query.type;
    }, [
        router
    ]);
    const listReason = [
        {
            label: t("profile.change_address_reason"),
            value: "Muốn thay đổi địa chỉ giao h\xe0ng"
        },
        {
            label: t("profile.change_voucher"),
            value: "Muốn nhập/thay đổi m\xe3 Voucher"
        },
        {
            label: t("profile.change_product"),
            value: "Muốn thay đổi sản phẩm trong sản phẩm (size, m\xe0u sắc, số lượng,...)"
        },
        {
            label: t("profile.payment_trouble"),
            value: "Thủ tục thanh to\xe1n qu\xe1 rắc rối"
        },
        {
            label: t("profile.chip_other"),
            value: "T\xecm thấy gi\xe1 rẻ hơn ở chỗ kh\xe1c"
        },
        {
            label: t("profile.dont_want_to_by"),
            value: "Đổi \xfd, kh\xf4ng muốn mua nữa"
        }
    ];
    const { mutate: destroyOrder , isPending  } = (0,merchandise_mutation/* useMutationDestroyOrder */.Ye)();
    const [selected, setSelected] = (0,react.useState)(listReason[0]);
    const onDestroy = ()=>{
        destroyOrder({
            transaction_id: dataSelected === null || dataSelected === void 0 ? void 0 : dataSelected.transaction_id,
            reason: selected === null || selected === void 0 ? void 0 : selected.value
        }, {
            onSuccess: ()=>{
                router.push({
                    pathname: router.pathname,
                    query: {
                        ...router.query,
                        type: "merchandise"
                    }
                });
                queryClient.clear();
                onOpenChange();
            }
        });
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(dialog/* Dialog */.Vq, {
        open: open,
        onOpenChange: ()=>{
            onOpenChange();
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(dialog/* DialogTrigger */.hg, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(dialog/* DialogContent */.cZ, {
                className: "sm:rounded-[16px] rounded-[16px] max-w-[90vw] md:max-w-[480px] border-0 focus-visible:outline-none py-[20px] px-0 dark:bg-bg-02 space-y-[16px] gap-0",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "flex justify-between items-center pb-[16px] border-b-[1px] border-black/10 dark:border-white/10 px-[24px]",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                className: "text-[16px] Nunito-700",
                                children: t("profile.pick_reason")
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "w-[24px] h-[24px] rounded-[8px] cursor-pointer",
                                onClick: ()=>{
                                    onOpenChange();
                                },
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(IconClose/* IconClose */.b, {})
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        className: "text-[14px] Nunito-500 text-main-01 px-[24px]",
                        children: t("profile.pick_reason_desc")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(radio_group/* RadioGroup */.E, {
                        value: "r".concat(selected === null || selected === void 0 ? void 0 : selected.label),
                        defaultValue: "r".concat(selected === null || selected === void 0 ? void 0 : selected.label),
                        className: "gap-[16px] px-[24px]",
                        children: [
                            listReason.map((reason, index)=>{
                                return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "flex space-x-[12px] items-center",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(radio_group/* RadioGroupItem */.m, {
                                            value: "r".concat(reason.label),
                                            id: "r".concat(reason.label),
                                            onClick: ()=>setSelected(reason)
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            onClick: ()=>setSelected(reason),
                                            className: "cursor-pointer w-full flex-1",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                className: "text-[14px] Nunito-600",
                                                children: reason.label
                                            })
                                        })
                                    ]
                                }, "r".concat(reason.label));
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "flex space-x-[12px]",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(radio_group/* RadioGroupItem */.m, {
                                        value: "r".concat(t("reward.tab_other")),
                                        id: "r".concat(t("reward.tab_other")),
                                        onClick: ()=>setSelected({
                                                label: t("reward.tab_other"),
                                                value: value
                                            })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        onClick: ()=>{
                                            setSelected({
                                                label: t("reward.tab_other"),
                                                value: value
                                            });
                                        },
                                        className: "cursor-pointer w-full flex-1",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                className: "text-neutral-06 dark:text-main-white text-[14px] Nunito-600 leading-[18px]",
                                                children: t("reward.tab_other")
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(ui_textarea/* Textarea */.g, {
                                                placeholder: t("profile.other_reason"),
                                                className: "mt-2 text-[14px]",
                                                disabled: (selected === null || selected === void 0 ? void 0 : selected.label) !== t("reward.tab_other"),
                                                value: value,
                                                onChange: (e)=>{
                                                    setValue(e.target.value);
                                                    setSelected({
                                                        label: t("reward.tab_other"),
                                                        value: e.target.value
                                                    });
                                                }
                                            })
                                        ]
                                    })
                                ]
                            }, "r".concat(t("reward.tab_other")))
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ui_button/* Button */.z, {
                        variant: "main",
                        className: "w-fit mx-auto px-[24px] text-[14px]",
                        disabled: (selected === null || selected === void 0 ? void 0 : selected.label) === t("reward.tab_other") && !value,
                        onClick: onDestroy,
                        children: isPending ? /*#__PURE__*/ (0,jsx_runtime.jsx)(loading_btn/* LoadingBtnComponent */.n, {}) : t("profile.cancel_merchandise")
                    })
                ]
            })
        ]
    });
};

// EXTERNAL MODULE: ./app/services/query-fn/merchandise/merchandise-query.ts
var merchandise_query = __webpack_require__(29519);
;// CONCATENATED MODULE: ./app/containers/users/normal-user/component/merchandise/MerchandiseDetail.tsx












const LIMIT_LENGTH = 2;
const MerchandiseDetail = (param)=>{
    let { dataSelected , setDataSelected  } = param;
    var _dataSelected_list_item;
    const { t  } = (0,esm/* useTranslation */.$G)();
    const router = (0,next_router.useRouter)();
    const [copyTransaction, setCopyTransaction] = (0,react.useState)(false);
    const [visible, setVisible] = (0,react.useState)(false);
    const { data  } = (0,merchandise_query/* useQueryGetMerchandisePaymentTransaction */.x7)({
        transaction_id: dataSelected === null || dataSelected === void 0 ? void 0 : dataSelected.transaction_id
    });
    const [expand, setExpand] = (0,react.useState)(false);
    const [listHook, setListHook] = (0,react.useState)([]);
    const onCopyTransaction = ()=>{
        if (!copyTransaction) {
            navigator.clipboard.writeText(dataSelected === null || dataSelected === void 0 ? void 0 : dataSelected.transaction_id);
            setCopyTransaction(true);
        }
    };
    (0,react.useEffect)(()=>{
        if (copyTransaction) {
            setTimeout(()=>{
                setCopyTransaction(false);
            }, 2000);
        }
        return ()=>{
            clearTimeout(setTimeout(()=>{
                setCopyTransaction(false);
            }, 2000));
        };
    }, [
        copyTransaction
    ]);
    (0,react.useEffect)(()=>{
        var _data_data, _data_data_ghtk_hook_data;
        if ((data === null || data === void 0 ? void 0 : (_data_data = data.data) === null || _data_data === void 0 ? void 0 : (_data_data_ghtk_hook_data = _data_data.ghtk_hook_data) === null || _data_data_ghtk_hook_data === void 0 ? void 0 : _data_data_ghtk_hook_data.length) > 0) {
            var _data_data1;
            setListHook(data === null || data === void 0 ? void 0 : (_data_data1 = data.data) === null || _data_data1 === void 0 ? void 0 : _data_data1.ghtk_hook_data);
        }
    }, [
        data
    ]);
    const status = {
        pending: {
            label: t("profile.pending_confirm"),
            value: "pending",
            bgColor: "#F28585",
            color: "#FAF8FF"
        },
        confirmed: {
            label: t("profile.transaction_confirmed"),
            value: "confirmed",
            bgColor: "#83ACEA",
            color: "#FAF8FF"
        },
        transfer: {
            label: t("profile.transaction_transfer"),
            value: "transfer",
            bgColor: "#FFB763",
            color: "#FAF8FF"
        },
        done: {
            label: t("profile.transaction_done"),
            value: "done",
            bgColor: "#ECECEE",
            color: "#28253E"
        },
        rejected: {
            label: t("profile.transaction_cancel"),
            value: "rejected",
            bgColor: "#E2526F",
            color: "#FAF8FF"
        },
        cancel: {
            label: t("profile.transaction_cancel"),
            value: "cancel",
            bgColor: "#E2526F",
            color: "#FAF8FF"
        },
        destroy: {
            label: t("profile.transaction_cancel"),
            value: "destroy"
        },
        refund: {
            label: t("profile.transaction_cancel"),
            value: "refund"
        }
    };
    const renderItemInfo = (item)=>{
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(ItemDetailMerchandiseWeb, {
                    dataSelected: dataSelected,
                    item: item
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(ItemDetailMerchandiseMobile, {
                    dataSelected: dataSelected,
                    item: item
                })
            ]
        });
    };
    const renderOrderAmount = ()=>{
        var _dataSelected_amount, _dataSelected_fee_ship, _Number, _Number1;
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "rounded-[5px] py-[24px]",
            children: [
                (dataSelected === null || dataSelected === void 0 ? void 0 : dataSelected.status) === "pending" && (Number(dataSelected === null || dataSelected === void 0 ? void 0 : dataSelected.created_at) + configs/* _15M_TIME_STAMP */.Ax) * 1000 > Number(moment_default()().unix()) * 1000 && /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                    className: "text-sm Nunito-500 text-main-red-02 Nunito-400 mb-[24px]",
                    children: t("profile.remind_pending_status", {
                        time: moment_default()((Number(dataSelected === null || dataSelected === void 0 ? void 0 : dataSelected.created_at) + configs/* _15M_TIME_STAMP */.Ax) * 1000).format(configs/* DATE_FORMAT_FULL */.Ob)
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "ml-auto flex flex-col gap-[12px]",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "flex justify-between",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                    className: "text-neutral-05 dark:text-neutral-08 text-[14px]",
                                    children: t("store.total_amount")
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                    className: "text-[14px] text-bg-01 dark:text-main-white Nunito-600",
                                    children: [
                                        dataSelected === null || dataSelected === void 0 ? void 0 : (_dataSelected_amount = dataSelected.amount) === null || _dataSelected_amount === void 0 ? void 0 : _dataSelected_amount.toLocaleString(),
                                        " đ"
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "flex justify-between",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                    className: "text-neutral-05 dark:text-neutral-08 text-[14px]",
                                    children: t("merchandise.shipping_fee_title")
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                    className: "text-[14px] text-bg-01 dark:text-main-white Nunito-600",
                                    children: [
                                        dataSelected === null || dataSelected === void 0 ? void 0 : (_dataSelected_fee_ship = dataSelected.fee_ship) === null || _dataSelected_fee_ship === void 0 ? void 0 : _dataSelected_fee_ship.toLocaleString(),
                                        " đ"
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "flex justify-between",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                    className: "text-neutral-05 dark:text-neutral-08 text-[14px]",
                                    children: t("store.sale_off")
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                    className: "text-[14px] text-bg-01 dark:text-main-white Nunito-600",
                                    children: [
                                        (_Number = Number((dataSelected === null || dataSelected === void 0 ? void 0 : dataSelected.discount_voucher_amount) + (dataSelected === null || dataSelected === void 0 ? void 0 : dataSelected.free_ship_voucher_amount) + (dataSelected === null || dataSelected === void 0 ? void 0 : dataSelected.voucher_amount))) === null || _Number === void 0 ? void 0 : _Number.toLocaleString(),
                                        "\xa0đ"
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "flex justify-between",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                    className: "text-neutral-05 dark:text-neutral-08 text-[14px]",
                                    children: t("store.payment_method")
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                    className: "text-[14px] text-bg-01 dark:text-main-white Nunito-600",
                                    children: dataSelected === null || dataSelected === void 0 ? void 0 : dataSelected.method
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "flex justify-between",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                    className: "text-neutral-05 dark:text-neutral-08 text-[14px]",
                                    children: t("store.total")
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                    className: "text-[16px] text-main-01 Nunito-700",
                                    children: [
                                        (_Number1 = Number(dataSelected === null || dataSelected === void 0 ? void 0 : dataSelected.total_amount)) === null || _Number1 === void 0 ? void 0 : _Number1.toLocaleString(),
                                        "\xa0đ"
                                    ]
                                })
                            ]
                        })
                    ]
                })
            ]
        });
    };
    const renderStatusTransaction = ()=>{
        switch(dataSelected === null || dataSelected === void 0 ? void 0 : dataSelected.status){
            case "cancel":
                {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        className: "text-[12px] Nunito-600 px-[10px] py-[2px] rounded-[8px] line-clamp-1 text-label-02 bg-bg-button dark:bg-white/10 h-[24px]",
                        children: t("profile.transaction_cancel")
                    });
                }
            case "pending":
                {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        className: "text-[12px] Nunito-600 px-[10px] py-[2px] rounded-[8px] line-clamp-1 text-label-02 bg-bg-button dark:bg-white/10 h-[24px]",
                        children: t("profile.transaction_pending")
                    });
                }
            default:
                {
                    var _status_dataSelected_list_item__status, _dataSelected_list_item, _dataSelected_list_item_;
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        className: "text-[12px] Nunito-600 px-[10px] py-[2px] rounded-[8px] w-fit text-label-02 bg-bg-button dark:bg-white/10 h-[24px]",
                        children: (dataSelected === null || dataSelected === void 0 ? void 0 : dataSelected.ghtk_status) === -1 ? status.cancel.label : (_status_dataSelected_list_item__status = status[dataSelected === null || dataSelected === void 0 ? void 0 : (_dataSelected_list_item = dataSelected.list_item) === null || _dataSelected_list_item === void 0 ? void 0 : (_dataSelected_list_item_ = _dataSelected_list_item[0]) === null || _dataSelected_list_item_ === void 0 ? void 0 : _dataSelected_list_item_.status]) === null || _status_dataSelected_list_item__status === void 0 ? void 0 : _status_dataSelected_list_item__status.label
                    });
                }
        }
    };
    const renderAction = ()=>{
        var _dataSelected_list_item, _dataSelected_list_item_;
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "flex justify-end gap-4 !mb-[64px]",
            children: [
                ((dataSelected === null || dataSelected === void 0 ? void 0 : dataSelected.status) === "pending" || (dataSelected === null || dataSelected === void 0 ? void 0 : (_dataSelected_list_item = dataSelected.list_item) === null || _dataSelected_list_item === void 0 ? void 0 : (_dataSelected_list_item_ = _dataSelected_list_item[0]) === null || _dataSelected_list_item_ === void 0 ? void 0 : _dataSelected_list_item_.status) === "pending") && /*#__PURE__*/ (0,jsx_runtime.jsx)(ui_button/* Button */.z, {
                    variant: "grey",
                    className: "text-[14px] px-[20px] text-neutral-03 dark:text-main-white",
                    onClick: ()=>{
                        setVisible(true);
                    },
                    children: t("profile.cancel_merchandise")
                }),
                (dataSelected === null || dataSelected === void 0 ? void 0 : dataSelected.status) === "pending" && (dataSelected === null || dataSelected === void 0 ? void 0 : dataSelected.payment_link) && (Number(dataSelected === null || dataSelected === void 0 ? void 0 : dataSelected.created_at) + configs/* _15M_TIME_STAMP */.Ax) * 1000 > Number(moment_default()().unix()) * 1000 && /*#__PURE__*/ (0,jsx_runtime.jsx)(ui_button/* Button */.z, {
                    variant: "main",
                    className: "text-[14px] px-[20px]",
                    onClick: ()=>{
                        window.location.href = dataSelected === null || dataSelected === void 0 ? void 0 : dataSelected.payment_link;
                    },
                    children: t("merchandise.payment_now")
                })
            ]
        });
    };
    const renderDeliveryStatus = ()=>{
        var _data_data, _data_data1, _data_data_receiver_address, _data_data2, _data_data_receiver_address1, _data_data3, _data_data_receiver_address2, _data_data4, _data_data_receiver_address3, _data_data5, _data_data_receiver_address4, _data_data6, _data_data_receiver_address5, _data_data7, _data_data8, _data_data9, _data_data10, _data_data11, _data_data_ghtk_hook_data, _data_data_ghtk_hook_data_, _ref;
        return (data === null || data === void 0 ? void 0 : (_data_data = data.data) === null || _data_data === void 0 ? void 0 : _data_data.ghtk_status_message) ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "flex gap-[24px] pb-[24px] border-b border-dashed mb-[24px] md:flex-row flex-col",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: " md:w-[30%] space-y-[24px]",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "flex gap-[8px]",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
                                    xmlns: "http://www.w3.org/2000/svg",
                                    width: "16",
                                    height: "18",
                                    viewBox: "0 0 16 18",
                                    fill: "none",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("g", {
                                            opacity: "0.4",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                d: "M15.5 8.0744C15.5 12.1654 10.8125 17.3337 8 17.3337C5.1875 17.3337 0.5 12.1654 0.5 8.0744C0.5 3.9834 3.85786 0.666992 8 0.666992C12.1421 0.666992 15.5 3.9834 15.5 8.0744Z",
                                                fill: "#7673E6"
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("ellipse", {
                                            cx: "8",
                                            cy: "8.16699",
                                            rx: "2.5",
                                            ry: "2.5",
                                            fill: "#7673E6"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                            className: "text-[14px] Nunito-600 pb-[12px]",
                                            children: t("merchandise.merchandise_address")
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                            className: "text-neutral-04 text-[12px] dark:text-neutral-08",
                                            children: data === null || data === void 0 ? void 0 : (_data_data1 = data.data) === null || _data_data1 === void 0 ? void 0 : (_data_data_receiver_address = _data_data1.receiver_address) === null || _data_data_receiver_address === void 0 ? void 0 : _data_data_receiver_address.fullname
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                            className: "text-neutral-04 text-[12px] dark:text-neutral-08",
                                            children: data === null || data === void 0 ? void 0 : (_data_data2 = data.data) === null || _data_data2 === void 0 ? void 0 : (_data_data_receiver_address1 = _data_data2.receiver_address) === null || _data_data_receiver_address1 === void 0 ? void 0 : _data_data_receiver_address1.phone
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                            className: "text-neutral-04 text-[12px] dark:text-neutral-08",
                                            children: [
                                                data === null || data === void 0 ? void 0 : (_data_data3 = data.data) === null || _data_data3 === void 0 ? void 0 : (_data_data_receiver_address2 = _data_data3.receiver_address) === null || _data_data_receiver_address2 === void 0 ? void 0 : _data_data_receiver_address2.address,
                                                ",",
                                                " ",
                                                data === null || data === void 0 ? void 0 : (_data_data4 = data.data) === null || _data_data4 === void 0 ? void 0 : (_data_data_receiver_address3 = _data_data4.receiver_address) === null || _data_data_receiver_address3 === void 0 ? void 0 : _data_data_receiver_address3.ward,
                                                ",",
                                                " ",
                                                data === null || data === void 0 ? void 0 : (_data_data5 = data.data) === null || _data_data5 === void 0 ? void 0 : (_data_data_receiver_address4 = _data_data5.receiver_address) === null || _data_data_receiver_address4 === void 0 ? void 0 : _data_data_receiver_address4.district,
                                                ",",
                                                " ",
                                                data === null || data === void 0 ? void 0 : (_data_data6 = data.data) === null || _data_data6 === void 0 ? void 0 : (_data_data_receiver_address5 = _data_data6.receiver_address) === null || _data_data_receiver_address5 === void 0 ? void 0 : _data_data_receiver_address5.city
                                            ]
                                        })
                                    ]
                                })
                            ]
                        }),
                        (data === null || data === void 0 ? void 0 : (_data_data7 = data.data) === null || _data_data7 === void 0 ? void 0 : _data_data7.ghtk_status) !== -1 && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "flex gap-[8px]",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
                                    xmlns: "http://www.w3.org/2000/svg",
                                    width: "18",
                                    height: "18",
                                    viewBox: "0 0 18 18",
                                    fill: "none",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("circle", {
                                            opacity: "0.4",
                                            cx: "9.0013",
                                            cy: "9.00033",
                                            r: "8.33333",
                                            fill: "#7673E6"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                            fillRule: "evenodd",
                                            clipRule: "evenodd",
                                            d: "M8.76562 5.06055C9.1108 5.06055 9.39062 5.34037 9.39062 5.68555V9.40174L11.4633 10.0926C11.7907 10.2018 11.9677 10.5557 11.8586 10.8832C11.7494 11.2107 11.3954 11.3876 11.068 11.2785L8.56798 10.4451C8.31277 10.3601 8.14062 10.1212 8.14062 9.85221V5.68555C8.14062 5.34037 8.42045 5.06055 8.76562 5.06055Z",
                                            fill: "#7673E6"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                            className: "text-[14px] Nunito-600",
                                            children: t("merchandise.estimate_delivery")
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                            className: "pt-1 text-main-01 Nunito-500 text-[14px]",
                                            children: data === null || data === void 0 ? void 0 : (_data_data8 = data.data) === null || _data_data8 === void 0 ? void 0 : _data_data8.estimated_deliver_time
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "flex-1 w-full",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "flex gap-[8px] ".concat((data === null || data === void 0 ? void 0 : (_data_data9 = data.data) === null || _data_data9 === void 0 ? void 0 : _data_data9.ghtk_status) === -1 && "mb-4"),
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
                                    xmlns: "http://www.w3.org/2000/svg",
                                    width: "18",
                                    height: "16",
                                    viewBox: "0 0 18 16",
                                    fill: "none",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                            opacity: "0.4",
                                            d: "M7.33464 0.5H4.0013C2.16035 0.5 0.667969 1.99238 0.667969 3.83333V10.5C0.667969 12.0544 1.73186 13.3602 3.17117 13.7291C3.22496 12.8572 3.94915 12.1667 4.83464 12.1667C5.75511 12.1667 6.5013 12.9129 6.5013 13.8333H10.668V3.83333C10.668 1.99238 9.17558 0.5 7.33464 0.5Z",
                                            fill: "#7673E6"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                            d: "M10.668 13.833V3.83301H13.3422C13.7657 3.83301 14.1732 3.99418 14.4821 4.28378L16.8079 6.46417C17.144 6.77924 17.3346 7.21938 17.3346 7.68006V12.1663C17.3346 13.0868 16.5884 13.833 15.668 13.833H10.668Z",
                                            fill: "#7673E6"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                            d: "M6.91667 13.8333C6.91667 14.9839 5.98393 15.9167 4.83333 15.9167C3.68274 15.9167 2.75 14.9839 2.75 13.8333C2.75 13.7896 2.75135 13.7462 2.754 13.7031C2.82123 12.6132 3.72648 11.75 4.83333 11.75C5.98393 11.75 6.91667 12.6827 6.91667 13.8333Z",
                                            fill: "#7673E6"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                            opacity: "0.4",
                                            d: "M16.0808 13.8333C16.0808 14.9839 15.1481 15.9167 13.9975 15.9167C12.8469 15.9167 11.9141 14.9839 11.9141 13.8333C11.9141 13.7896 11.9155 13.7462 11.9181 13.7031C11.9854 12.6132 12.8906 11.75 13.9975 11.75C15.1481 11.75 16.0808 12.6827 16.0808 13.8333Z",
                                            fill: "#7673E6"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "flex flex-1 sd:flex-row flex-col sd:mb-0",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                            className: "text-[14px] Nunito-600",
                                            children: t("merchandise.shipping_infomation")
                                        }),
                                        (data === null || data === void 0 ? void 0 : (_data_data10 = data.data) === null || _data_data10 === void 0 ? void 0 : _data_data10.ghtk_status) !== -1 && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: "sd:ml-auto mr-0 text-neutral-04 dark:text-neutral-08 text-[12px]",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                    children: "Giao h\xe0ng tiết kiệm"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                    children: data === null || data === void 0 ? void 0 : (_data_data11 = data.data) === null || _data_data11 === void 0 ? void 0 : (_data_data_ghtk_hook_data = _data_data11.ghtk_hook_data) === null || _data_data_ghtk_hook_data === void 0 ? void 0 : (_data_data_ghtk_hook_data_ = _data_data_ghtk_hook_data[0]) === null || _data_data_ghtk_hook_data_ === void 0 ? void 0 : _data_data_ghtk_hook_data_.label_id
                                                })
                                            ]
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "pl-[26px] sd:pl-0",
                            children: (_ref = [
                                ...listHook,
                                {
                                    action_time: dataSelected === null || dataSelected === void 0 ? void 0 : dataSelected.created_at,
                                    ghtk_status_message: t("profile.order_successful"),
                                    type: -33
                                }
                            ]) === null || _ref === void 0 ? void 0 : _ref.slice(0, expand ? 100 : LIMIT_LENGTH).map((item, index)=>{
                                var _moment_unix, _moment_utc;
                                return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "flex gap-[12px] sd:gap-[20px] pb-[18px]",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
                                            xmlns: "http://www.w3.org/2000/svg",
                                            width: "6",
                                            height: "7",
                                            viewBox: "0 0 6 7",
                                            fill: "none",
                                            className: "mt-[5px]",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("circle", {
                                                cx: "3",
                                                cy: "3.5",
                                                r: "3",
                                                fill: index === 0 ? "#27908C" : "#878693"
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                            className: "text-[14px] Nunito-500 leading-[19px] ".concat((listHook === null || listHook === void 0 ? void 0 : listHook.length) > 2 && index > 0 && !expand && "text-neutral-06"),
                                            children: item.type === -33 ? (_moment_unix = moment_default().unix(item === null || item === void 0 ? void 0 : item.action_time)) === null || _moment_unix === void 0 ? void 0 : _moment_unix.format(configs/* DATE_FORMAT_3 */.Ly) : (_moment_utc = moment_default().utc(item === null || item === void 0 ? void 0 : item.action_time)) === null || _moment_utc === void 0 ? void 0 : _moment_utc.format(configs/* DATE_FORMAT_3 */.Ly)
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                    className: "leading-[19px] text-[14px] Nunito-500 ".concat(index === 0 && "text-main-green", " ").concat((listHook === null || listHook === void 0 ? void 0 : listHook.length) > 2 && index > 0 && !expand && "text-neutral-06"),
                                                    children: item === null || item === void 0 ? void 0 : item.ghtk_status_message
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                    className: "leading-[19px] text-[14px] text-neutral-04 ".concat((listHook === null || listHook === void 0 ? void 0 : listHook.length) > 2 && index > 0 && !expand && "text-neutral-08"),
                                                    children: item === null || item === void 0 ? void 0 : item.reason
                                                })
                                            ]
                                        })
                                    ]
                                }, index);
                            })
                        }),
                        (listHook === null || listHook === void 0 ? void 0 : listHook.length) > 1 && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "text-main-01 cursor-pointer text-[12px] Nunito-500 md:pl-[24px]",
                            onClick: ()=>{
                                setExpand(!expand);
                            },
                            children: expand ? t("common.view_less") : t("common.view_all")
                        })
                    ]
                })
            ]
        }) : null;
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "w-full m-auto space-y-[12px] md:space-y-0",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "w-full pb-[24px] border-b border-dashed",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "flex items-center mb-4 gap-[10px] flex-wrap xs:justify-between",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "bg-bg-button dark:bg-white/10 px-[10px] rounded-[8px] flex h-[26px] items-center gap-[10px]",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                        className: "text-bg-01 dark:text-white text-[12px] Nunito-500 ",
                                        children: [
                                            t("profile.item_code_summary"),
                                            ":\xa0",
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                className: "Nunito-700",
                                                children: dataSelected === null || dataSelected === void 0 ? void 0 : dataSelected.transaction_id
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "w-[1px] h-[17px] bg-neutral-08"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        className: "cursor-pointer",
                                        onClick: onCopyTransaction,
                                        children: copyTransaction ? /*#__PURE__*/ (0,jsx_runtime.jsx)(IconCopied/* IconCopied */.i, {}) : /*#__PURE__*/ (0,jsx_runtime.jsx)(IconNonCopy/* IconNonCopy */.x, {})
                                    })
                                ]
                            }),
                            renderStatusTransaction()
                        ]
                    }),
                    renderDeliveryStatus(),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "w-full space-y-[12px] md:space-y-[10px]",
                        children: dataSelected === null || dataSelected === void 0 ? void 0 : (_dataSelected_list_item = dataSelected.list_item) === null || _dataSelected_list_item === void 0 ? void 0 : _dataSelected_list_item.map((item, index)=>renderItemInfo(item))
                    })
                ]
            }),
            renderOrderAmount(),
            renderAction(),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ModalCancelMerchandise, {
                open: visible,
                onOpenChange: ()=>setVisible(false),
                dataSelected: dataSelected
            })
        ]
    });
};

;// CONCATENATED MODULE: ./app/containers/users/normal-user/component/main-purchase/PurchaseContent.tsx













const PurchaseContent = (param)=>{
    let { prevRef , nextRef , dataSelected , setDataSelected , onSelecteData  } = param;
    var _router_query, _router_query1, _router_query2, _router_query3, _router_query4, _router_query5, _router_query6, _router_query7, _router_query8;
    const router = (0,next_router.useRouter)();
    (0,react.useEffect)(()=>{
        var _router_query;
        if (String(router === null || router === void 0 ? void 0 : (_router_query = router.query) === null || _router_query === void 0 ? void 0 : _router_query.type).includes("detail")) {
            var _router_query1;
            !dataSelected && router.push({
                pathname: router.pathname,
                query: {
                    ...router.query,
                    type: String(router === null || router === void 0 ? void 0 : (_router_query1 = router.query) === null || _router_query1 === void 0 ? void 0 : _router_query1.type).replace("-detail", "")
                }
            });
        }
    }, [
        dataSelected,
        router
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "w-full",
        children: [
            [
                "undefined",
                String(enumTypeTransaction.CARD)
            ].includes(String(router === null || router === void 0 ? void 0 : (_router_query = router.query) === null || _router_query === void 0 ? void 0 : _router_query.type)) && /*#__PURE__*/ (0,jsx_runtime.jsx)(CardTransaction, {
                prevRef: prevRef,
                nextRef: nextRef,
                onSelecteData: onSelecteData
            }),
            String(enumTypeViewAll.CARD_ALL) === String(router === null || router === void 0 ? void 0 : (_router_query1 = router.query) === null || _router_query1 === void 0 ? void 0 : _router_query1.type) && /*#__PURE__*/ (0,jsx_runtime.jsx)(AllCardTransaction, {
                onSelecteData: onSelecteData
            }),
            [
                String(enumViewDetailTransaction.CARD_DETAIL)
            ].includes(String(router === null || router === void 0 ? void 0 : (_router_query2 = router.query) === null || _router_query2 === void 0 ? void 0 : _router_query2.type)) && /*#__PURE__*/ (0,jsx_runtime.jsx)(CardDetail, {
                dataSelected: dataSelected,
                setDataSelected: setDataSelected
            }),
            String(enumTypeTransaction.TOPUP) === String(router === null || router === void 0 ? void 0 : (_router_query3 = router.query) === null || _router_query3 === void 0 ? void 0 : _router_query3.type) && /*#__PURE__*/ (0,jsx_runtime.jsx)(TopupTransaction, {
                prevRef: prevRef,
                nextRef: nextRef,
                onSelecteData: onSelecteData
            }),
            String(enumTypeViewAll.TOPUP_ALL) === String(router === null || router === void 0 ? void 0 : (_router_query4 = router.query) === null || _router_query4 === void 0 ? void 0 : _router_query4.type) && /*#__PURE__*/ (0,jsx_runtime.jsx)(AllTopupTransaction, {
                onSelecteData: onSelecteData
            }),
            [
                String(enumViewDetailTransaction.TOPUP_DETAIL)
            ].includes(String(router === null || router === void 0 ? void 0 : (_router_query5 = router.query) === null || _router_query5 === void 0 ? void 0 : _router_query5.type)) && /*#__PURE__*/ (0,jsx_runtime.jsx)(TopupDetail, {
                dataSelected: dataSelected,
                setDataSelected: setDataSelected
            }),
            String(enumTypeTransaction.MERCHANDISE) === String(router === null || router === void 0 ? void 0 : (_router_query6 = router.query) === null || _router_query6 === void 0 ? void 0 : _router_query6.type) && /*#__PURE__*/ (0,jsx_runtime.jsx)(MerchandiseTransaction, {
                prevRef: prevRef,
                nextRef: nextRef,
                onSelecteData: onSelecteData
            }),
            String(enumTypeViewAll.MERCHANDISE_ALL) === String(router === null || router === void 0 ? void 0 : (_router_query7 = router.query) === null || _router_query7 === void 0 ? void 0 : _router_query7.type) && /*#__PURE__*/ (0,jsx_runtime.jsx)(AllMerchandiseTransaction, {
                onSelecteData: onSelecteData
            }),
            [
                String(enumViewDetailTransaction.MERCHANDISE_DETAIL)
            ].includes(String(router === null || router === void 0 ? void 0 : (_router_query8 = router.query) === null || _router_query8 === void 0 ? void 0 : _router_query8.type)) && /*#__PURE__*/ (0,jsx_runtime.jsx)(MerchandiseDetail, {
                dataSelected: dataSelected,
                setDataSelected: setDataSelected
            })
        ]
    });
};

;// CONCATENATED MODULE: ./app/containers/users/normal-user/component/main-purchase/PurchaseTransaction.tsx










const initialFilter = {
    keyword: "",
    start_date: undefined,
    end_date: undefined
};
const PurchaseTransaction = ()=>{
    var _router_query, _router_query1;
    const { t  } = (0,esm/* useTranslation */.$G)();
    const router = (0,next_router.useRouter)();
    const prevRef = (0,react.useRef)();
    const nextRef = (0,react.useRef)();
    const [dataSelected, setDataSelected] = (0,react.useState)();
    const GAEventsTracker = (0,useGAEventsTracker/* default */.Z)("Profile");
    const methods = (0,index_esm/* useForm */.cI)({
        defaultValues: initialFilter
    });
    const onSelecteData = (item)=>{
        setDataSelected(item);
    };
    const handleChangeTab = (value)=>{
        var _router_query, _router_query_type, _router_query1, _router_query2, _router_query3, _router_query4, _router_query5, _router_query6;
        if (value === enumTypeTransaction.CARD) {
            GAEventsTracker("View_order_card");
        }
        if (value === enumTypeTransaction.TOPUP) {
            GAEventsTracker("View_order_topup");
        }
        if (value === enumTypeTransaction.MERCHANDISE) {
            GAEventsTracker("View_order_merchandise");
        }
        if (router === null || router === void 0 ? void 0 : (_router_query = router.query) === null || _router_query === void 0 ? void 0 : (_router_query_type = _router_query.type) === null || _router_query_type === void 0 ? void 0 : _router_query_type.includes("all")) {
            var _router_query7, _router_query8;
            router.push({
                pathname: router.pathname,
                query: {
                    id: router === null || router === void 0 ? void 0 : (_router_query7 = router.query) === null || _router_query7 === void 0 ? void 0 : _router_query7.id,
                    tab: router === null || router === void 0 ? void 0 : (_router_query8 = router.query) === null || _router_query8 === void 0 ? void 0 : _router_query8.tab,
                    type: "".concat(value, "-all")
                }
            });
        } else router.push({
            pathname: router.pathname,
            query: (router === null || router === void 0 ? void 0 : (_router_query1 = router.query) === null || _router_query1 === void 0 ? void 0 : _router_query1.gold) ? {
                id: router === null || router === void 0 ? void 0 : (_router_query2 = router.query) === null || _router_query2 === void 0 ? void 0 : _router_query2.id,
                tab: router === null || router === void 0 ? void 0 : (_router_query3 = router.query) === null || _router_query3 === void 0 ? void 0 : _router_query3.tab,
                gold: router === null || router === void 0 ? void 0 : (_router_query4 = router.query) === null || _router_query4 === void 0 ? void 0 : _router_query4.gold,
                type: value
            } : {
                id: router === null || router === void 0 ? void 0 : (_router_query5 = router.query) === null || _router_query5 === void 0 ? void 0 : _router_query5.id,
                tab: router === null || router === void 0 ? void 0 : (_router_query6 = router.query) === null || _router_query6 === void 0 ? void 0 : _router_query6.tab,
                type: value
            }
        });
    };
    const handleViewAll = ()=>{
        var _router_query, _router_query1, _router_query2;
        const momentType = String(router === null || router === void 0 ? void 0 : (_router_query = router.query) === null || _router_query === void 0 ? void 0 : _router_query.type);
        router.push({
            pathname: router.pathname,
            query: {
                id: router === null || router === void 0 ? void 0 : (_router_query1 = router.query) === null || _router_query1 === void 0 ? void 0 : _router_query1.id,
                tab: router === null || router === void 0 ? void 0 : (_router_query2 = router.query) === null || _router_query2 === void 0 ? void 0 : _router_query2.tab,
                type: momentType === "undefined" ? enumTypeViewAll.CARD_ALL : "".concat(momentType, "-all")
            }
        });
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "px-0 lg:px-[24px] w-full space-y-[16px]",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_esm/* FormProvider */.RV, {
                ...methods,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(PurchaseHeader, {
                        prevRef: prevRef,
                        nextRef: nextRef,
                        handleChangeTab: handleChangeTab
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(PurchaseContent, {
                        prevRef: prevRef,
                        nextRef: nextRef,
                        dataSelected: dataSelected,
                        setDataSelected: setDataSelected,
                        onSelecteData: onSelecteData
                    })
                ]
            }),
            !String(router === null || router === void 0 ? void 0 : (_router_query = router.query) === null || _router_query === void 0 ? void 0 : _router_query.type).includes("all") && !String(router === null || router === void 0 ? void 0 : (_router_query1 = router.query) === null || _router_query1 === void 0 ? void 0 : _router_query1.type).includes("detail") && /*#__PURE__*/ (0,jsx_runtime.jsxs)(ui_button/* Button */.z, {
                variant: "none",
                className: "h-auto p-0 text-sm opacity-100 active:opacity-70 text-main-01 Nunito-700 ",
                onClick: handleViewAll,
                children: [
                    t("profile.view_all"),
                    "\xa0",
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
                        width: "24",
                        height: "24",
                        viewBox: "0 0 24 24",
                        fill: "none",
                        xmlns: "http://www.w3.org/2000/svg",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                            fillRule: "evenodd",
                            clipRule: "evenodd",
                            d: "M18.5303 12.5303C18.8232 12.2374 18.8232 11.7626 18.5303 11.4697L14.5303 7.46967C14.2374 7.17678 13.7626 7.17678 13.4697 7.46967C13.1768 7.76256 13.1768 8.23744 13.4697 8.53033L16.1893 11.25H6C5.58579 11.25 5.25 11.5858 5.25 12C5.25 12.4142 5.58579 12.75 6 12.75H16.1893L13.4697 15.4697C13.1768 15.7626 13.1768 16.2374 13.4697 16.5303C13.7626 16.8232 14.2374 16.8232 14.5303 16.5303L18.5303 12.5303Z",
                            fill: "#7673E6"
                        })
                    })
                ]
            })
        ]
    });
};

// EXTERNAL MODULE: ./app/components/ui/table.tsx
var table = __webpack_require__(1045);
// EXTERNAL MODULE: ./app/components/ui/select.tsx + 3 modules
var ui_select = __webpack_require__(80522);
;// CONCATENATED MODULE: ./app/containers/users/normal-user/component/filter-all/FilterGold.tsx









const FilterGold = ()=>{
    var _listFilter_find;
    const { setValue , watch  } = (0,index_esm/* useFormContext */.Gc)();
    const { t  } = (0,esm/* useTranslation */.$G)();
    const [openFilter, setOpenFilter] = (0,react.useState)(false);
    const [openStartTime, setOpenStartTime] = (0,react.useState)(false);
    const selectedSource = watch("source", "");
    const selectedStartTime = watch("start_date", undefined);
    const selectedEndTime = watch("end_date", undefined);
    const onChangeStartTime = ()=>{
        setOpenStartTime(!openStartTime);
    };
    const [openEndTime, setOpenEndTime] = (0,react.useState)(false);
    const onChangeEndTime = ()=>{
        setOpenEndTime(!openEndTime);
    };
    const listFilter = [
        {
            value: "task",
            label: "Nhiệm vụ"
        },
        {
            value: "spin",
            label: "V\xf2ng quay"
        },
        {
            value: "shop",
            label: "Cửa h\xe0ng"
        }
    ];
    const clearFilter = ()=>{
        setValue("start_date", undefined);
        setValue("end_date", undefined);
        setValue("source", "");
        setOpenFilter(false);
    };
    const onChangeType = (value)=>{
        setValue("source", value);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "flex items-center justify-between",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(dropdown_menu/* DropdownMenu */.h_, {
            open: openFilter,
            onOpenChange: ()=>setOpenFilter(false),
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(dropdown_menu/* DropdownMenuTrigger */.$F, {
                    asChild: true,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(ui_button/* Button */.z, {
                        variant: "none",
                        className: "flex items-center gap-[8px] bg-button dark:bg-white/10 text-main-01 outline-0",
                        onClick: ()=>setOpenFilter(true),
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                className: "hidden md:block",
                                children: [
                                    t("profile.filter_by"),
                                    "\xa0"
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
                                    width: "20",
                                    height: "20",
                                    viewBox: "0 0 20 20",
                                    fill: "none",
                                    xmlns: "http://www.w3.org/2000/svg",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                        d: "M10 5H17.5M10 10H15M10 15H12.5M2.5 13.0208L3.75432 14.4319C4.4173 15.1778 5.5827 15.1778 6.24568 14.4319L7.5 13.0208M5 15V5",
                                        stroke: "#7673E6",
                                        strokeWidth: "1.5",
                                        strokeLinecap: "round"
                                    })
                                })
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(dropdown_menu/* DropdownMenuContent */.AW, {
                    align: "end",
                    className: "min-w-[343px] rounded-[24px] px-[16px] py-[24px] overflow-visible dark:bg-[#30303A]",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "w-full bg-white dark:bg-[#30303A]",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "mb-[24px]",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                        className: "text-base Nunito-600 text-neutral-03 dark:text-white",
                                        children: "Loại ti\xeau ph\xed"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(ui_select/* Select */.Ph, {
                                        onValueChange: (value)=>onChangeType(value),
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(ui_select/* SelectTrigger */.i4, {
                                                className: "w-full rounded-none border-0 border-b-[1px] border-black/10 dark:border-neutral-03 text-sm Nunito-500 text-neutral-05 dark:text-white dark:bg-transparent dark:backdrop-blur-[20px] text-left",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ui_select/* SelectValue */.ki, {
                                                    placeholder: !!selectedSource ? (_listFilter_find = listFilter.find((item)=>item.value === selectedSource)) === null || _listFilter_find === void 0 ? void 0 : _listFilter_find.label : t("reward.choose_game_title")
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(ui_select/* SelectContent */.Bw, {
                                                className: "p-1 rounded-[16px]",
                                                children: listFilter.map((item)=>{
                                                    /*#__PURE__*/ return (0,jsx_runtime.jsx)(ui_select/* SelectItem */.Ql, {
                                                        value: item === null || item === void 0 ? void 0 : item.value,
                                                        className: "p-3 rounded-[8px] hover:!bg-bg-disable hover:!text-main-01 text-sm Nunito-600 focus:bg-bg-disable focus:text-main-01 dark:hover:!bg-[#F1F1FC]/[.1] dark:focus:!bg-[#F1F1FC]/[.1]",
                                                        children: item === null || item === void 0 ? void 0 : item.label
                                                    }, item === null || item === void 0 ? void 0 : item.value);
                                                })
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                        className: "text-base Nunito-600 text-neutral-03 dark:text-white",
                                        children: t("profile.time_title")
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "flex items-center gap-[12px]",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(StartTime/* StartTimeFilter */.M, {
                                                open: openStartTime,
                                                onChange: onChangeStartTime
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                children: "-"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(EndTime/* EndTimeFilter */.o, {
                                                open: openEndTime,
                                                onChange: onChangeEndTime
                                            })
                                        ]
                                    }),
                                    selectedStartTime >= selectedEndTime && /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                        className: "mt-2 text-xs text-main-red-02",
                                        children: t("profile.invalid_date")
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "w-full flex items-center justify-end gap-[16px] mt-[24px]",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ui_button/* Button */.z, {
                                        variant: "none",
                                        className: "text-base bg-bg-button text-neutral Nunito-700 h-[30px] py-[6px] px-[24px] rounded-[12px]",
                                        autoFocus: false,
                                        onClick: clearFilter,
                                        children: t("merchandise.cancel")
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ui_button/* Button */.z, {
                                        variant: "none",
                                        className: "text-base text-white bg-main-01 h-[30px] Nunito-700 py-[6px] px-[24px] rounded-[12px]",
                                        onClick: ()=>setOpenFilter(false),
                                        children: t("profile.filter")
                                    })
                                ]
                            })
                        ]
                    })
                })
            ]
        })
    });
};

;// CONCATENATED MODULE: ./public/img/gold_icon.png
/* harmony default export */ var gold_icon = ({"src":"/_next/static/media/gold_icon.a4da7dd8.png","height":24,"width":24,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAICAYAAADED76LAAAA/0lEQVR42i2Py0rDQBiF/7mQ2obamJK2Uzei76CPUKrgwp0i+FjivugTlNKlgu66ERfiDbEx3tIaSJPYyZ+OM+hZng8O5yPpwz4DgKK8sdeQ/sX2AmNY8sRQd2+x/8IIGBqedJPxeU9+37kKCLBqM6p4rQONBlSpkUiC0WkWDFxq15GWa/jzfuPMPoJeSbQavAivOnJy71jeJs4zyUmRASUUMf5yk/HrDgezaUIpcILAlusglYIF5qCJoszb6lsra1MZXnNq2YgyxzyNuOWIyG6L4f/J427iX57NJ7c1M8ir3rTSbB+akyR9PPrTXN8VWrOjipiUxGpfd5+z5yf2C7CscT7Km7yFAAAAAElFTkSuQmCC","blurWidth":8,"blurHeight":8});
;// CONCATENATED MODULE: ./app/containers/users/normal-user/component/main-gold/GoldTransaction.tsx
















const LIMIT_CELL = 4;
const GoldTransaction_initialFilter = {
    source: "",
    start_date: undefined,
    end_date: undefined
};
const GoldTransaction = ()=>{
    var _router_query, _String, _router_query1, _router_query2, _router_query3, _router_query4, _String1, _router_query5, _String2, _router_query6;
    const router = (0,next_router.useRouter)();
    const { userInfo  } = (0,react.useContext)(context/* AppContext */.Il);
    const { t  } = (0,esm/* useTranslation */.$G)();
    const tabRef = (0,react.useRef)(null);
    const { ref , inView  } = (0,react_intersection_observer/* useInView */.YD)();
    const methods = (0,index_esm/* useForm */.cI)({
        defaultValues: GoldTransaction_initialFilter
    });
    const watchSource = methods.watch("source", "");
    const watchStartTime = methods.watch("start_date", "");
    const watchEndTime = methods.watch("end_date", "");
    const { data: gold , fetchNextPage  } = useQueryGetUserPointHistory({
        type: String(router === null || router === void 0 ? void 0 : (_router_query = router.query) === null || _router_query === void 0 ? void 0 : _router_query.gold) !== "undefined" ? (_String = String(router === null || router === void 0 ? void 0 : (_router_query1 = router.query) === null || _router_query1 === void 0 ? void 0 : _router_query1.gold)) === null || _String === void 0 ? void 0 : _String.replace("-all", "") : "spent",
        source: watchSource,
        start_date: !!watchStartTime ? moment_default()(watchStartTime).format("YYYY-MM-DD") : "",
        end_date: !!watchEndTime ? moment_default()(watchEndTime).format("YYYY-MM-DD") : ""
    }, userInfo === null || userInfo === void 0 ? void 0 : userInfo.userid);
    const listGold = (0,react.useMemo)(()=>{
        var _router_query, _router_query_gold, _gold_pages_flat, _gold_pages;
        return String(router === null || router === void 0 ? void 0 : (_router_query = router.query) === null || _router_query === void 0 ? void 0 : (_router_query_gold = _router_query.gold) === null || _router_query_gold === void 0 ? void 0 : _router_query_gold.includes("all")) ? gold === null || gold === void 0 ? void 0 : gold.pages.flat() : (_gold_pages_flat = gold === null || gold === void 0 ? void 0 : (_gold_pages = gold.pages) === null || _gold_pages === void 0 ? void 0 : _gold_pages.flat()) === null || _gold_pages_flat === void 0 ? void 0 : _gold_pages_flat.slice(0, LIMIT_CELL);
    }, [
        router,
        gold
    ]);
    react.useEffect(()=>{
        var _router_query;
        if (inView && String(router === null || router === void 0 ? void 0 : (_router_query = router.query) === null || _router_query === void 0 ? void 0 : _router_query.gold).includes("all")) {
            fetchNextPage();
        }
    }, [
        fetchNextPage,
        inView,
        router
    ]);
    const handleChangeTab = (value)=>{
        var _router_query, _router_query_gold, _router_query1, _router_query2, _router_query3, _router_query4, _router_query5, _router_query6;
        if (router === null || router === void 0 ? void 0 : (_router_query = router.query) === null || _router_query === void 0 ? void 0 : (_router_query_gold = _router_query.gold) === null || _router_query_gold === void 0 ? void 0 : _router_query_gold.includes("all")) {
            var _router_query7, _router_query8, _router_query9;
            router.push({
                pathname: router.pathname,
                query: {
                    id: router === null || router === void 0 ? void 0 : (_router_query7 = router.query) === null || _router_query7 === void 0 ? void 0 : _router_query7.id,
                    tab: router === null || router === void 0 ? void 0 : (_router_query8 = router.query) === null || _router_query8 === void 0 ? void 0 : _router_query8.tab,
                    gold: String(router === null || router === void 0 ? void 0 : (_router_query9 = router.query) === null || _router_query9 === void 0 ? void 0 : _router_query9.gold) === enumTypeGoldViewAll.SPENT_ALL ? enumTypeGoldViewAll.EARN_ALL : enumTypeGoldViewAll.SPENT_ALL
                }
            });
        } else router.push({
            pathname: router.pathname,
            query: (router === null || router === void 0 ? void 0 : (_router_query1 = router.query) === null || _router_query1 === void 0 ? void 0 : _router_query1.type) ? {
                id: router === null || router === void 0 ? void 0 : (_router_query2 = router.query) === null || _router_query2 === void 0 ? void 0 : _router_query2.id,
                tab: router === null || router === void 0 ? void 0 : (_router_query3 = router.query) === null || _router_query3 === void 0 ? void 0 : _router_query3.tab,
                type: router === null || router === void 0 ? void 0 : (_router_query4 = router.query) === null || _router_query4 === void 0 ? void 0 : _router_query4.type,
                gold: value
            } : {
                id: router === null || router === void 0 ? void 0 : (_router_query5 = router.query) === null || _router_query5 === void 0 ? void 0 : _router_query5.id,
                tab: router === null || router === void 0 ? void 0 : (_router_query6 = router.query) === null || _router_query6 === void 0 ? void 0 : _router_query6.tab,
                gold: value
            }
        });
    };
    const handleViewAll = ()=>{
        var _router_query, _router_query1, _router_query2;
        const momentType = String(router === null || router === void 0 ? void 0 : (_router_query = router.query) === null || _router_query === void 0 ? void 0 : _router_query.gold);
        router.push({
            pathname: router.pathname,
            query: {
                id: router === null || router === void 0 ? void 0 : (_router_query1 = router.query) === null || _router_query1 === void 0 ? void 0 : _router_query1.id,
                tab: router === null || router === void 0 ? void 0 : (_router_query2 = router.query) === null || _router_query2 === void 0 ? void 0 : _router_query2.tab,
                gold: momentType === "undefined" ? enumTypeGoldViewAll.SPENT_ALL : "".concat(momentType, "-all")
            }
        });
    };
    const onNavigateToStoreItem = ()=>{
        router.push("/reward-center?tab=gold-shop");
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "px-0 lg:px-[24px] w-full pb-[80px] md:pb-0 ",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "flex gap-[32px] items-center",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        className: "text-base Nunito-700 text-bg-01 dark:text-white",
                        children: "Playee Gold"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "flex items-center gap-2 opacity-100 cursor-pointer active:opacity-70",
                        onClick: onNavigateToStoreItem,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                className: "text-sm text-main-01 Nunito-500",
                                children: t("store.exchange_item")
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
                                width: "14",
                                height: "10",
                                viewBox: "0 0 14 10",
                                fill: "none",
                                xmlns: "http://www.w3.org/2000/svg",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                    fillRule: "evenodd",
                                    clipRule: "evenodd",
                                    d: "M13.5303 5.53033C13.8232 5.23744 13.8232 4.76256 13.5303 4.46967L9.53033 0.46967C9.23744 0.176777 8.76256 0.176777 8.46967 0.46967C8.17678 0.762563 8.17678 1.23744 8.46967 1.53033L11.1893 4.25H1C0.585787 4.25 0.25 4.58579 0.25 5C0.25 5.41421 0.585787 5.75 1 5.75H11.1893L8.46967 8.46967C8.17678 8.76256 8.17678 9.23744 8.46967 9.53033C8.76256 9.82322 9.23744 9.82322 9.53033 9.53033L13.5303 5.53033Z",
                                    fill: "#7673E6"
                                })
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "flex items-center justify-between w-full mt-[16px]",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "flex items-cente gap-[8px]",
                        ref: tabRef,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(ui_button/* Button */.z, {
                                variant: "none",
                                className: "px-[16px] py-1 border rounded-[8px] Nunito-400 text-sm h-[29px] ".concat([
                                    "undefined",
                                    String(enumTypeGold.SPENT_GOLD),
                                    String(enumTypeGoldViewAll.SPENT_ALL)
                                ].includes(String(router === null || router === void 0 ? void 0 : (_router_query2 = router.query) === null || _router_query2 === void 0 ? void 0 : _router_query2.gold)) ? "text-main-01 border-main-01" : "border-black/10 text-neutral-03 dark:border-neutral-08 dark:text-neutral-07"),
                                onClick: ()=>handleChangeTab(enumTypeGold.SPENT_GOLD),
                                children: t("reward.top_spent")
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(ui_button/* Button */.z, {
                                variant: "none",
                                className: "px-[16px] py-1 border rounded-[8px] Nunito-400 text-sm h-[29px] ".concat([
                                    String(enumTypeGold.EARN_GOLD),
                                    String(enumTypeGoldViewAll.EARN_ALL)
                                ].includes(String(router === null || router === void 0 ? void 0 : (_router_query3 = router.query) === null || _router_query3 === void 0 ? void 0 : _router_query3.gold)) ? "text-main-01 border-main-01" : "border-black/10 text-neutral-03 dark:border-neutral-08 dark:text-neutral-07"),
                                onClick: ()=>handleChangeTab(enumTypeGold.EARN_GOLD),
                                children: t("reward.top_earned")
                            })
                        ]
                    }),
                    String(router === null || router === void 0 ? void 0 : (_router_query4 = router.query) === null || _router_query4 === void 0 ? void 0 : _router_query4.gold).includes("all") && /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* FormProvider */.RV, {
                        ...methods,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(FilterGold, {})
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "min-w-full mt-[16px] ".concat(((_String1 = String(router === null || router === void 0 ? void 0 : (_router_query5 = router.query) === null || _router_query5 === void 0 ? void 0 : _router_query5.gold)) === null || _String1 === void 0 ? void 0 : _String1.includes("all")) ? "pb-[40px]" : ""),
                children: (listGold === null || listGold === void 0 ? void 0 : listGold.length) ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(table/* Table */.iA, {
                    className: "w-max lg:w-full",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(table/* TableHeader */.xD, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(table/* TableRow */.SC, {
                                className: "pt-[8px] pb-[16px]",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(table/* TableHead */.ss, {
                                        className: "text-sm w-fit text-bg-01 Nunito-600",
                                        children: t("profile.time")
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(table/* TableHead */.ss, {
                                        className: "min-w-full text-sm md:min-w-1/2 text-bg-01 Nunito-600",
                                        children: t("profile.activate")
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(table/* TableHead */.ss, {
                                        className: "text-sm text-right text-bg-01 Nunito-600",
                                        children: "Gold"
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(table/* TableBody */.RM, {
                            children: [
                                listGold === null || listGold === void 0 ? void 0 : listGold.map((item, index)=>{
                                    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(table/* TableRow */.SC, {
                                        className: "last:border-0",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(table/* TableCell */.pj, {
                                                className: "font-medium",
                                                children: moment_default().unix(item === null || item === void 0 ? void 0 : item.created_at).format(configs/* DATE_FORMAT_3 */.Ly)
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(table/* TableCell */.pj, {
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                    className: "pb-1 dark:text-text-color-1",
                                                    dangerouslySetInnerHTML: {
                                                        __html: item.source_info.message || ""
                                                    }
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(table/* TableCell */.pj, {
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                    className: "flex items-end justify-end w-full gap-2",
                                                    children: [
                                                        (item === null || item === void 0 ? void 0 : item.source) === "shop" ? Number(item.point) : "+".concat(Number(item.point)),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                            src: gold_icon.src,
                                                            className: "w-[24px] h-[24px]"
                                                        })
                                                    ]
                                                })
                                            })
                                        ]
                                    }, index);
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                    ref: ref,
                                    className: "opacity-0",
                                    children: "Load more"
                                })
                            ]
                        })
                    ]
                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "w-full flex items-center justify-center h-[200px]",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(data_empty/* DataEmpty */.$, {
                        title: t("profile.no_data")
                    })
                })
            }),
            !((_String2 = String(router === null || router === void 0 ? void 0 : (_router_query6 = router.query) === null || _router_query6 === void 0 ? void 0 : _router_query6.gold)) === null || _String2 === void 0 ? void 0 : _String2.includes("all")) && /*#__PURE__*/ (0,jsx_runtime.jsxs)(ui_button/* Button */.z, {
                variant: "none",
                className: "text-main-01 Nunito-700 text-sm pb-[40px] h-auto p-0 m-0 opacity-100 active:opacity-70",
                onClick: handleViewAll,
                children: [
                    t("profile.view_all"),
                    "\xa0",
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
                        width: "24",
                        height: "24",
                        viewBox: "0 0 24 24",
                        fill: "none",
                        xmlns: "http://www.w3.org/2000/svg",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                            fillRule: "evenodd",
                            clipRule: "evenodd",
                            d: "M18.5303 12.5303C18.8232 12.2374 18.8232 11.7626 18.5303 11.4697L14.5303 7.46967C14.2374 7.17678 13.7626 7.17678 13.4697 7.46967C13.1768 7.76256 13.1768 8.23744 13.4697 8.53033L16.1893 11.25H6C5.58579 11.25 5.25 11.5858 5.25 12C5.25 12.4142 5.58579 12.75 6 12.75H16.1893L13.4697 15.4697C13.1768 15.7626 13.1768 16.2374 13.4697 16.5303C13.7626 16.8232 14.2374 16.8232 14.5303 16.5303L18.5303 12.5303Z",
                            fill: "#7673E6"
                        })
                    })
                ]
            })
        ]
    });
};

// EXTERNAL MODULE: ./node_modules/@react-spring/web/dist/react-spring_web.modern.mjs + 3 modules
var react_spring_web_modern = __webpack_require__(66005);
;// CONCATENATED MODULE: ./app/containers/users/normal-user/tab/TransactionManager.tsx






var enumTypeTransaction;
(function(enumTypeTransaction) {
    enumTypeTransaction["CARD"] = "card";
    enumTypeTransaction["TOPUP"] = "topup";
    enumTypeTransaction["MERCHANDISE"] = "merchandise";
})(enumTypeTransaction || (enumTypeTransaction = {}));
var enumTypeViewAll;
(function(enumTypeViewAll) {
    enumTypeViewAll["CARD_ALL"] = "card-all";
    enumTypeViewAll["TOPUP_ALL"] = "topup-all";
    enumTypeViewAll["MERCHANDISE_ALL"] = "merchandise-all";
})(enumTypeViewAll || (enumTypeViewAll = {}));
var enumTypeGold;
(function(enumTypeGold) {
    enumTypeGold["EARN_GOLD"] = "earn";
    enumTypeGold["SPENT_GOLD"] = "spent";
})(enumTypeGold || (enumTypeGold = {}));
var enumTypeGoldViewAll;
(function(enumTypeGoldViewAll) {
    enumTypeGoldViewAll["EARN_ALL"] = "earn-all";
    enumTypeGoldViewAll["SPENT_ALL"] = "spent-all";
})(enumTypeGoldViewAll || (enumTypeGoldViewAll = {}));
var enumViewDetailTransaction;
(function(enumViewDetailTransaction) {
    enumViewDetailTransaction["CARD_DETAIL"] = "card-detail";
    enumViewDetailTransaction["TOPUP_DETAIL"] = "topup-detail";
    enumViewDetailTransaction["MERCHANDISE_DETAIL"] = "merchandise-detail";
})(enumViewDetailTransaction || (enumViewDetailTransaction = {}));
const TransactionManager = ()=>{
    var _String, _router_query, _String1, _router_query1, _String2, _router_query2, _String3, _router_query3, _String4, _router_query4, _String5, _router_query5, _String6, _router_query6;
    const router = (0,next_router.useRouter)();
    const fadePurchase = (0,react_spring_web_modern/* useSpring */.q_)({
        opacity: !((_String = String(router === null || router === void 0 ? void 0 : (_router_query = router.query) === null || _router_query === void 0 ? void 0 : _router_query.gold)) === null || _String === void 0 ? void 0 : _String.includes("all")) ? 1 : 0,
        from: {
            opacity: !((_String1 = String(router === null || router === void 0 ? void 0 : (_router_query1 = router.query) === null || _router_query1 === void 0 ? void 0 : _router_query1.gold)) === null || _String1 === void 0 ? void 0 : _String1.includes("all")) ? 0 : 1
        },
        delay: 100
    });
    const fadeGold = (0,react_spring_web_modern/* useSpring */.q_)({
        opacity: !((_String2 = String(router === null || router === void 0 ? void 0 : (_router_query2 = router.query) === null || _router_query2 === void 0 ? void 0 : _router_query2.type)) === null || _String2 === void 0 ? void 0 : _String2.includes("all")) ? 1 : 0,
        from: {
            opacity: !((_String3 = String(router === null || router === void 0 ? void 0 : (_router_query3 = router.query) === null || _router_query3 === void 0 ? void 0 : _router_query3.type)) === null || _String3 === void 0 ? void 0 : _String3.includes("all")) ? 0 : 1
        },
        delay: 100
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "mt-[16px] lg:mt-[24px] space-y-[24px] lg:space-y-[40px]",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(react_spring_web_modern/* animated.div */.q.div, {
                style: fadePurchase,
                children: !((_String4 = String(router === null || router === void 0 ? void 0 : (_router_query4 = router.query) === null || _router_query4 === void 0 ? void 0 : _router_query4.gold)) === null || _String4 === void 0 ? void 0 : _String4.includes("all")) && /*#__PURE__*/ (0,jsx_runtime.jsx)(PurchaseTransaction, {})
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(react_spring_web_modern/* animated.div */.q.div, {
                style: fadeGold,
                children: !((_String5 = String(router === null || router === void 0 ? void 0 : (_router_query5 = router.query) === null || _router_query5 === void 0 ? void 0 : _router_query5.type)) === null || _String5 === void 0 ? void 0 : _String5.includes("all")) && !((_String6 = String(router === null || router === void 0 ? void 0 : (_router_query6 = router.query) === null || _router_query6 === void 0 ? void 0 : _router_query6.type)) === null || _String6 === void 0 ? void 0 : _String6.includes("detail")) && /*#__PURE__*/ (0,jsx_runtime.jsx)(GoldTransaction, {})
            })
        ]
    });
};

;// CONCATENATED MODULE: ./app/containers/users/normal-user/tab/index.ts






/***/ }),

/***/ 28911:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "n": function() { return /* binding */ ENUM_PARTNER_TAB; },
  "t": function() { return /* binding */ PartnerTab; }
});

// EXTERNAL MODULE: ./node_modules/next/dist/compiled/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(41844);
// EXTERNAL MODULE: ./app/components/ui/tabs.tsx + 1 modules
var tabs = __webpack_require__(98241);
// EXTERNAL MODULE: ./node_modules/next-i18next/dist/esm/index.js + 41 modules
var esm = __webpack_require__(93378);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/react/index.js
var react = __webpack_require__(55784);
;// CONCATENATED MODULE: ./node_modules/@kurkle/color/dist/color.esm.js
/*!
 * @kurkle/color v0.3.2
 * https://github.com/kurkle/color#readme
 * (c) 2023 Jukka Kurkela
 * Released under the MIT License
 */
function round(v) {
  return v + 0.5 | 0;
}
const lim = (v, l, h) => Math.max(Math.min(v, h), l);
function p2b(v) {
  return lim(round(v * 2.55), 0, 255);
}
function b2p(v) {
  return lim(round(v / 2.55), 0, 100);
}
function n2b(v) {
  return lim(round(v * 255), 0, 255);
}
function b2n(v) {
  return lim(round(v / 2.55) / 100, 0, 1);
}
function n2p(v) {
  return lim(round(v * 100), 0, 100);
}

const map$1 = {0: 0, 1: 1, 2: 2, 3: 3, 4: 4, 5: 5, 6: 6, 7: 7, 8: 8, 9: 9, A: 10, B: 11, C: 12, D: 13, E: 14, F: 15, a: 10, b: 11, c: 12, d: 13, e: 14, f: 15};
const hex = [...'0123456789ABCDEF'];
const h1 = b => hex[b & 0xF];
const h2 = b => hex[(b & 0xF0) >> 4] + hex[b & 0xF];
const eq = b => ((b & 0xF0) >> 4) === (b & 0xF);
const isShort = v => eq(v.r) && eq(v.g) && eq(v.b) && eq(v.a);
function hexParse(str) {
  var len = str.length;
  var ret;
  if (str[0] === '#') {
    if (len === 4 || len === 5) {
      ret = {
        r: 255 & map$1[str[1]] * 17,
        g: 255 & map$1[str[2]] * 17,
        b: 255 & map$1[str[3]] * 17,
        a: len === 5 ? map$1[str[4]] * 17 : 255
      };
    } else if (len === 7 || len === 9) {
      ret = {
        r: map$1[str[1]] << 4 | map$1[str[2]],
        g: map$1[str[3]] << 4 | map$1[str[4]],
        b: map$1[str[5]] << 4 | map$1[str[6]],
        a: len === 9 ? (map$1[str[7]] << 4 | map$1[str[8]]) : 255
      };
    }
  }
  return ret;
}
const alpha = (a, f) => a < 255 ? f(a) : '';
function hexString(v) {
  var f = isShort(v) ? h1 : h2;
  return v
    ? '#' + f(v.r) + f(v.g) + f(v.b) + alpha(v.a, f)
    : undefined;
}

const HUE_RE = /^(hsla?|hwb|hsv)\(\s*([-+.e\d]+)(?:deg)?[\s,]+([-+.e\d]+)%[\s,]+([-+.e\d]+)%(?:[\s,]+([-+.e\d]+)(%)?)?\s*\)$/;
function hsl2rgbn(h, s, l) {
  const a = s * Math.min(l, 1 - l);
  const f = (n, k = (n + h / 30) % 12) => l - a * Math.max(Math.min(k - 3, 9 - k, 1), -1);
  return [f(0), f(8), f(4)];
}
function hsv2rgbn(h, s, v) {
  const f = (n, k = (n + h / 60) % 6) => v - v * s * Math.max(Math.min(k, 4 - k, 1), 0);
  return [f(5), f(3), f(1)];
}
function hwb2rgbn(h, w, b) {
  const rgb = hsl2rgbn(h, 1, 0.5);
  let i;
  if (w + b > 1) {
    i = 1 / (w + b);
    w *= i;
    b *= i;
  }
  for (i = 0; i < 3; i++) {
    rgb[i] *= 1 - w - b;
    rgb[i] += w;
  }
  return rgb;
}
function hueValue(r, g, b, d, max) {
  if (r === max) {
    return ((g - b) / d) + (g < b ? 6 : 0);
  }
  if (g === max) {
    return (b - r) / d + 2;
  }
  return (r - g) / d + 4;
}
function rgb2hsl(v) {
  const range = 255;
  const r = v.r / range;
  const g = v.g / range;
  const b = v.b / range;
  const max = Math.max(r, g, b);
  const min = Math.min(r, g, b);
  const l = (max + min) / 2;
  let h, s, d;
  if (max !== min) {
    d = max - min;
    s = l > 0.5 ? d / (2 - max - min) : d / (max + min);
    h = hueValue(r, g, b, d, max);
    h = h * 60 + 0.5;
  }
  return [h | 0, s || 0, l];
}
function calln(f, a, b, c) {
  return (
    Array.isArray(a)
      ? f(a[0], a[1], a[2])
      : f(a, b, c)
  ).map(n2b);
}
function hsl2rgb(h, s, l) {
  return calln(hsl2rgbn, h, s, l);
}
function hwb2rgb(h, w, b) {
  return calln(hwb2rgbn, h, w, b);
}
function hsv2rgb(h, s, v) {
  return calln(hsv2rgbn, h, s, v);
}
function hue(h) {
  return (h % 360 + 360) % 360;
}
function hueParse(str) {
  const m = HUE_RE.exec(str);
  let a = 255;
  let v;
  if (!m) {
    return;
  }
  if (m[5] !== v) {
    a = m[6] ? p2b(+m[5]) : n2b(+m[5]);
  }
  const h = hue(+m[2]);
  const p1 = +m[3] / 100;
  const p2 = +m[4] / 100;
  if (m[1] === 'hwb') {
    v = hwb2rgb(h, p1, p2);
  } else if (m[1] === 'hsv') {
    v = hsv2rgb(h, p1, p2);
  } else {
    v = hsl2rgb(h, p1, p2);
  }
  return {
    r: v[0],
    g: v[1],
    b: v[2],
    a: a
  };
}
function rotate(v, deg) {
  var h = rgb2hsl(v);
  h[0] = hue(h[0] + deg);
  h = hsl2rgb(h);
  v.r = h[0];
  v.g = h[1];
  v.b = h[2];
}
function hslString(v) {
  if (!v) {
    return;
  }
  const a = rgb2hsl(v);
  const h = a[0];
  const s = n2p(a[1]);
  const l = n2p(a[2]);
  return v.a < 255
    ? `hsla(${h}, ${s}%, ${l}%, ${b2n(v.a)})`
    : `hsl(${h}, ${s}%, ${l}%)`;
}

const map = {
  x: 'dark',
  Z: 'light',
  Y: 're',
  X: 'blu',
  W: 'gr',
  V: 'medium',
  U: 'slate',
  A: 'ee',
  T: 'ol',
  S: 'or',
  B: 'ra',
  C: 'lateg',
  D: 'ights',
  R: 'in',
  Q: 'turquois',
  E: 'hi',
  P: 'ro',
  O: 'al',
  N: 'le',
  M: 'de',
  L: 'yello',
  F: 'en',
  K: 'ch',
  G: 'arks',
  H: 'ea',
  I: 'ightg',
  J: 'wh'
};
const names$1 = {
  OiceXe: 'f0f8ff',
  antiquewEte: 'faebd7',
  aqua: 'ffff',
  aquamarRe: '7fffd4',
  azuY: 'f0ffff',
  beige: 'f5f5dc',
  bisque: 'ffe4c4',
  black: '0',
  blanKedOmond: 'ffebcd',
  Xe: 'ff',
  XeviTet: '8a2be2',
  bPwn: 'a52a2a',
  burlywood: 'deb887',
  caMtXe: '5f9ea0',
  KartYuse: '7fff00',
  KocTate: 'd2691e',
  cSO: 'ff7f50',
  cSnflowerXe: '6495ed',
  cSnsilk: 'fff8dc',
  crimson: 'dc143c',
  cyan: 'ffff',
  xXe: '8b',
  xcyan: '8b8b',
  xgTMnPd: 'b8860b',
  xWay: 'a9a9a9',
  xgYF: '6400',
  xgYy: 'a9a9a9',
  xkhaki: 'bdb76b',
  xmagFta: '8b008b',
  xTivegYF: '556b2f',
  xSange: 'ff8c00',
  xScEd: '9932cc',
  xYd: '8b0000',
  xsOmon: 'e9967a',
  xsHgYF: '8fbc8f',
  xUXe: '483d8b',
  xUWay: '2f4f4f',
  xUgYy: '2f4f4f',
  xQe: 'ced1',
  xviTet: '9400d3',
  dAppRk: 'ff1493',
  dApskyXe: 'bfff',
  dimWay: '696969',
  dimgYy: '696969',
  dodgerXe: '1e90ff',
  fiYbrick: 'b22222',
  flSOwEte: 'fffaf0',
  foYstWAn: '228b22',
  fuKsia: 'ff00ff',
  gaRsbSo: 'dcdcdc',
  ghostwEte: 'f8f8ff',
  gTd: 'ffd700',
  gTMnPd: 'daa520',
  Way: '808080',
  gYF: '8000',
  gYFLw: 'adff2f',
  gYy: '808080',
  honeyMw: 'f0fff0',
  hotpRk: 'ff69b4',
  RdianYd: 'cd5c5c',
  Rdigo: '4b0082',
  ivSy: 'fffff0',
  khaki: 'f0e68c',
  lavFMr: 'e6e6fa',
  lavFMrXsh: 'fff0f5',
  lawngYF: '7cfc00',
  NmoncEffon: 'fffacd',
  ZXe: 'add8e6',
  ZcSO: 'f08080',
  Zcyan: 'e0ffff',
  ZgTMnPdLw: 'fafad2',
  ZWay: 'd3d3d3',
  ZgYF: '90ee90',
  ZgYy: 'd3d3d3',
  ZpRk: 'ffb6c1',
  ZsOmon: 'ffa07a',
  ZsHgYF: '20b2aa',
  ZskyXe: '87cefa',
  ZUWay: '778899',
  ZUgYy: '778899',
  ZstAlXe: 'b0c4de',
  ZLw: 'ffffe0',
  lime: 'ff00',
  limegYF: '32cd32',
  lRF: 'faf0e6',
  magFta: 'ff00ff',
  maPon: '800000',
  VaquamarRe: '66cdaa',
  VXe: 'cd',
  VScEd: 'ba55d3',
  VpurpN: '9370db',
  VsHgYF: '3cb371',
  VUXe: '7b68ee',
  VsprRggYF: 'fa9a',
  VQe: '48d1cc',
  VviTetYd: 'c71585',
  midnightXe: '191970',
  mRtcYam: 'f5fffa',
  mistyPse: 'ffe4e1',
  moccasR: 'ffe4b5',
  navajowEte: 'ffdead',
  navy: '80',
  Tdlace: 'fdf5e6',
  Tive: '808000',
  TivedBb: '6b8e23',
  Sange: 'ffa500',
  SangeYd: 'ff4500',
  ScEd: 'da70d6',
  pOegTMnPd: 'eee8aa',
  pOegYF: '98fb98',
  pOeQe: 'afeeee',
  pOeviTetYd: 'db7093',
  papayawEp: 'ffefd5',
  pHKpuff: 'ffdab9',
  peru: 'cd853f',
  pRk: 'ffc0cb',
  plum: 'dda0dd',
  powMrXe: 'b0e0e6',
  purpN: '800080',
  YbeccapurpN: '663399',
  Yd: 'ff0000',
  Psybrown: 'bc8f8f',
  PyOXe: '4169e1',
  saddNbPwn: '8b4513',
  sOmon: 'fa8072',
  sandybPwn: 'f4a460',
  sHgYF: '2e8b57',
  sHshell: 'fff5ee',
  siFna: 'a0522d',
  silver: 'c0c0c0',
  skyXe: '87ceeb',
  UXe: '6a5acd',
  UWay: '708090',
  UgYy: '708090',
  snow: 'fffafa',
  sprRggYF: 'ff7f',
  stAlXe: '4682b4',
  tan: 'd2b48c',
  teO: '8080',
  tEstN: 'd8bfd8',
  tomato: 'ff6347',
  Qe: '40e0d0',
  viTet: 'ee82ee',
  JHt: 'f5deb3',
  wEte: 'ffffff',
  wEtesmoke: 'f5f5f5',
  Lw: 'ffff00',
  LwgYF: '9acd32'
};
function unpack() {
  const unpacked = {};
  const keys = Object.keys(names$1);
  const tkeys = Object.keys(map);
  let i, j, k, ok, nk;
  for (i = 0; i < keys.length; i++) {
    ok = nk = keys[i];
    for (j = 0; j < tkeys.length; j++) {
      k = tkeys[j];
      nk = nk.replace(k, map[k]);
    }
    k = parseInt(names$1[ok], 16);
    unpacked[nk] = [k >> 16 & 0xFF, k >> 8 & 0xFF, k & 0xFF];
  }
  return unpacked;
}

let names;
function nameParse(str) {
  if (!names) {
    names = unpack();
    names.transparent = [0, 0, 0, 0];
  }
  const a = names[str.toLowerCase()];
  return a && {
    r: a[0],
    g: a[1],
    b: a[2],
    a: a.length === 4 ? a[3] : 255
  };
}

const RGB_RE = /^rgba?\(\s*([-+.\d]+)(%)?[\s,]+([-+.e\d]+)(%)?[\s,]+([-+.e\d]+)(%)?(?:[\s,/]+([-+.e\d]+)(%)?)?\s*\)$/;
function rgbParse(str) {
  const m = RGB_RE.exec(str);
  let a = 255;
  let r, g, b;
  if (!m) {
    return;
  }
  if (m[7] !== r) {
    const v = +m[7];
    a = m[8] ? p2b(v) : lim(v * 255, 0, 255);
  }
  r = +m[1];
  g = +m[3];
  b = +m[5];
  r = 255 & (m[2] ? p2b(r) : lim(r, 0, 255));
  g = 255 & (m[4] ? p2b(g) : lim(g, 0, 255));
  b = 255 & (m[6] ? p2b(b) : lim(b, 0, 255));
  return {
    r: r,
    g: g,
    b: b,
    a: a
  };
}
function rgbString(v) {
  return v && (
    v.a < 255
      ? `rgba(${v.r}, ${v.g}, ${v.b}, ${b2n(v.a)})`
      : `rgb(${v.r}, ${v.g}, ${v.b})`
  );
}

const to = v => v <= 0.0031308 ? v * 12.92 : Math.pow(v, 1.0 / 2.4) * 1.055 - 0.055;
const from = v => v <= 0.04045 ? v / 12.92 : Math.pow((v + 0.055) / 1.055, 2.4);
function interpolate(rgb1, rgb2, t) {
  const r = from(b2n(rgb1.r));
  const g = from(b2n(rgb1.g));
  const b = from(b2n(rgb1.b));
  return {
    r: n2b(to(r + t * (from(b2n(rgb2.r)) - r))),
    g: n2b(to(g + t * (from(b2n(rgb2.g)) - g))),
    b: n2b(to(b + t * (from(b2n(rgb2.b)) - b))),
    a: rgb1.a + t * (rgb2.a - rgb1.a)
  };
}

function modHSL(v, i, ratio) {
  if (v) {
    let tmp = rgb2hsl(v);
    tmp[i] = Math.max(0, Math.min(tmp[i] + tmp[i] * ratio, i === 0 ? 360 : 1));
    tmp = hsl2rgb(tmp);
    v.r = tmp[0];
    v.g = tmp[1];
    v.b = tmp[2];
  }
}
function clone(v, proto) {
  return v ? Object.assign(proto || {}, v) : v;
}
function fromObject(input) {
  var v = {r: 0, g: 0, b: 0, a: 255};
  if (Array.isArray(input)) {
    if (input.length >= 3) {
      v = {r: input[0], g: input[1], b: input[2], a: 255};
      if (input.length > 3) {
        v.a = n2b(input[3]);
      }
    }
  } else {
    v = clone(input, {r: 0, g: 0, b: 0, a: 1});
    v.a = n2b(v.a);
  }
  return v;
}
function functionParse(str) {
  if (str.charAt(0) === 'r') {
    return rgbParse(str);
  }
  return hueParse(str);
}
class Color {
  constructor(input) {
    if (input instanceof Color) {
      return input;
    }
    const type = typeof input;
    let v;
    if (type === 'object') {
      v = fromObject(input);
    } else if (type === 'string') {
      v = hexParse(input) || nameParse(input) || functionParse(input);
    }
    this._rgb = v;
    this._valid = !!v;
  }
  get valid() {
    return this._valid;
  }
  get rgb() {
    var v = clone(this._rgb);
    if (v) {
      v.a = b2n(v.a);
    }
    return v;
  }
  set rgb(obj) {
    this._rgb = fromObject(obj);
  }
  rgbString() {
    return this._valid ? rgbString(this._rgb) : undefined;
  }
  hexString() {
    return this._valid ? hexString(this._rgb) : undefined;
  }
  hslString() {
    return this._valid ? hslString(this._rgb) : undefined;
  }
  mix(color, weight) {
    if (color) {
      const c1 = this.rgb;
      const c2 = color.rgb;
      let w2;
      const p = weight === w2 ? 0.5 : weight;
      const w = 2 * p - 1;
      const a = c1.a - c2.a;
      const w1 = ((w * a === -1 ? w : (w + a) / (1 + w * a)) + 1) / 2.0;
      w2 = 1 - w1;
      c1.r = 0xFF & w1 * c1.r + w2 * c2.r + 0.5;
      c1.g = 0xFF & w1 * c1.g + w2 * c2.g + 0.5;
      c1.b = 0xFF & w1 * c1.b + w2 * c2.b + 0.5;
      c1.a = p * c1.a + (1 - p) * c2.a;
      this.rgb = c1;
    }
    return this;
  }
  interpolate(color, t) {
    if (color) {
      this._rgb = interpolate(this._rgb, color._rgb, t);
    }
    return this;
  }
  clone() {
    return new Color(this.rgb);
  }
  alpha(a) {
    this._rgb.a = n2b(a);
    return this;
  }
  clearer(ratio) {
    const rgb = this._rgb;
    rgb.a *= 1 - ratio;
    return this;
  }
  greyscale() {
    const rgb = this._rgb;
    const val = round(rgb.r * 0.3 + rgb.g * 0.59 + rgb.b * 0.11);
    rgb.r = rgb.g = rgb.b = val;
    return this;
  }
  opaquer(ratio) {
    const rgb = this._rgb;
    rgb.a *= 1 + ratio;
    return this;
  }
  negate() {
    const v = this._rgb;
    v.r = 255 - v.r;
    v.g = 255 - v.g;
    v.b = 255 - v.b;
    return this;
  }
  lighten(ratio) {
    modHSL(this._rgb, 2, ratio);
    return this;
  }
  darken(ratio) {
    modHSL(this._rgb, 2, -ratio);
    return this;
  }
  saturate(ratio) {
    modHSL(this._rgb, 1, ratio);
    return this;
  }
  desaturate(ratio) {
    modHSL(this._rgb, 1, -ratio);
    return this;
  }
  rotate(deg) {
    rotate(this._rgb, deg);
    return this;
  }
}

function index_esm(input) {
  return new Color(input);
}



;// CONCATENATED MODULE: ./node_modules/chart.js/dist/chunks/helpers.segment.js
/*!
 * Chart.js v4.4.2
 * https://www.chartjs.org
 * (c) 2024 Chart.js Contributors
 * Released under the MIT License
 */


/**
 * @namespace Chart.helpers
 */ /**
 * An empty function that can be used, for example, for optional callback.
 */ function noop() {
/* noop */ }
/**
 * Returns a unique id, sequentially generated from a global variable.
 */ const uid = (()=>{
    let id = 0;
    return ()=>id++;
})();
/**
 * Returns true if `value` is neither null nor undefined, else returns false.
 * @param value - The value to test.
 * @since 2.7.0
 */ function isNullOrUndef(value) {
    return value === null || typeof value === 'undefined';
}
/**
 * Returns true if `value` is an array (including typed arrays), else returns false.
 * @param value - The value to test.
 * @function
 */ function isArray(value) {
    if (Array.isArray && Array.isArray(value)) {
        return true;
    }
    const type = Object.prototype.toString.call(value);
    if (type.slice(0, 7) === '[object' && type.slice(-6) === 'Array]') {
        return true;
    }
    return false;
}
/**
 * Returns true if `value` is an object (excluding null), else returns false.
 * @param value - The value to test.
 * @since 2.7.0
 */ function isObject(value) {
    return value !== null && Object.prototype.toString.call(value) === '[object Object]';
}
/**
 * Returns true if `value` is a finite number, else returns false
 * @param value  - The value to test.
 */ function isNumberFinite(value) {
    return (typeof value === 'number' || value instanceof Number) && isFinite(+value);
}
/**
 * Returns `value` if finite, else returns `defaultValue`.
 * @param value - The value to return if defined.
 * @param defaultValue - The value to return if `value` is not finite.
 */ function finiteOrDefault(value, defaultValue) {
    return isNumberFinite(value) ? value : defaultValue;
}
/**
 * Returns `value` if defined, else returns `defaultValue`.
 * @param value - The value to return if defined.
 * @param defaultValue - The value to return if `value` is undefined.
 */ function valueOrDefault(value, defaultValue) {
    return typeof value === 'undefined' ? defaultValue : value;
}
const toPercentage = (value, dimension)=>typeof value === 'string' && value.endsWith('%') ? parseFloat(value) / 100 : +value / dimension;
const toDimension = (value, dimension)=>typeof value === 'string' && value.endsWith('%') ? parseFloat(value) / 100 * dimension : +value;
/**
 * Calls `fn` with the given `args` in the scope defined by `thisArg` and returns the
 * value returned by `fn`. If `fn` is not a function, this method returns undefined.
 * @param fn - The function to call.
 * @param args - The arguments with which `fn` should be called.
 * @param [thisArg] - The value of `this` provided for the call to `fn`.
 */ function callback(fn, args, thisArg) {
    if (fn && typeof fn.call === 'function') {
        return fn.apply(thisArg, args);
    }
}
function each(loopable, fn, thisArg, reverse) {
    let i, len, keys;
    if (isArray(loopable)) {
        len = loopable.length;
        if (reverse) {
            for(i = len - 1; i >= 0; i--){
                fn.call(thisArg, loopable[i], i);
            }
        } else {
            for(i = 0; i < len; i++){
                fn.call(thisArg, loopable[i], i);
            }
        }
    } else if (isObject(loopable)) {
        keys = Object.keys(loopable);
        len = keys.length;
        for(i = 0; i < len; i++){
            fn.call(thisArg, loopable[keys[i]], keys[i]);
        }
    }
}
/**
 * Returns true if the `a0` and `a1` arrays have the same content, else returns false.
 * @param a0 - The array to compare
 * @param a1 - The array to compare
 * @private
 */ function _elementsEqual(a0, a1) {
    let i, ilen, v0, v1;
    if (!a0 || !a1 || a0.length !== a1.length) {
        return false;
    }
    for(i = 0, ilen = a0.length; i < ilen; ++i){
        v0 = a0[i];
        v1 = a1[i];
        if (v0.datasetIndex !== v1.datasetIndex || v0.index !== v1.index) {
            return false;
        }
    }
    return true;
}
/**
 * Returns a deep copy of `source` without keeping references on objects and arrays.
 * @param source - The value to clone.
 */ function helpers_segment_clone(source) {
    if (isArray(source)) {
        return source.map(helpers_segment_clone);
    }
    if (isObject(source)) {
        const target = Object.create(null);
        const keys = Object.keys(source);
        const klen = keys.length;
        let k = 0;
        for(; k < klen; ++k){
            target[keys[k]] = helpers_segment_clone(source[keys[k]]);
        }
        return target;
    }
    return source;
}
function isValidKey(key) {
    return [
        '__proto__',
        'prototype',
        'constructor'
    ].indexOf(key) === -1;
}
/**
 * The default merger when Chart.helpers.merge is called without merger option.
 * Note(SB): also used by mergeConfig and mergeScaleConfig as fallback.
 * @private
 */ function _merger(key, target, source, options) {
    if (!isValidKey(key)) {
        return;
    }
    const tval = target[key];
    const sval = source[key];
    if (isObject(tval) && isObject(sval)) {
        // eslint-disable-next-line @typescript-eslint/no-use-before-define
        merge(tval, sval, options);
    } else {
        target[key] = helpers_segment_clone(sval);
    }
}
function merge(target, source, options) {
    const sources = isArray(source) ? source : [
        source
    ];
    const ilen = sources.length;
    if (!isObject(target)) {
        return target;
    }
    options = options || {};
    const merger = options.merger || _merger;
    let current;
    for(let i = 0; i < ilen; ++i){
        current = sources[i];
        if (!isObject(current)) {
            continue;
        }
        const keys = Object.keys(current);
        for(let k = 0, klen = keys.length; k < klen; ++k){
            merger(keys[k], target, current, options);
        }
    }
    return target;
}
function mergeIf(target, source) {
    // eslint-disable-next-line @typescript-eslint/no-use-before-define
    return merge(target, source, {
        merger: _mergerIf
    });
}
/**
 * Merges source[key] in target[key] only if target[key] is undefined.
 * @private
 */ function _mergerIf(key, target, source) {
    if (!isValidKey(key)) {
        return;
    }
    const tval = target[key];
    const sval = source[key];
    if (isObject(tval) && isObject(sval)) {
        mergeIf(tval, sval);
    } else if (!Object.prototype.hasOwnProperty.call(target, key)) {
        target[key] = helpers_segment_clone(sval);
    }
}
/**
 * @private
 */ function _deprecated(scope, value, previous, current) {
    if (value !== undefined) {
        console.warn(scope + ': "' + previous + '" is deprecated. Please use "' + current + '" instead');
    }
}
// resolveObjectKey resolver cache
const keyResolvers = {
    // Chart.helpers.core resolveObjectKey should resolve empty key to root object
    '': (v)=>v,
    // default resolvers
    x: (o)=>o.x,
    y: (o)=>o.y
};
/**
 * @private
 */ function _splitKey(key) {
    const parts = key.split('.');
    const keys = [];
    let tmp = '';
    for (const part of parts){
        tmp += part;
        if (tmp.endsWith('\\')) {
            tmp = tmp.slice(0, -1) + '.';
        } else {
            keys.push(tmp);
            tmp = '';
        }
    }
    return keys;
}
function _getKeyResolver(key) {
    const keys = _splitKey(key);
    return (obj)=>{
        for (const k of keys){
            if (k === '') {
                break;
            }
            obj = obj && obj[k];
        }
        return obj;
    };
}
function resolveObjectKey(obj, key) {
    const resolver = keyResolvers[key] || (keyResolvers[key] = _getKeyResolver(key));
    return resolver(obj);
}
/**
 * @private
 */ function _capitalize(str) {
    return str.charAt(0).toUpperCase() + str.slice(1);
}
const defined = (value)=>typeof value !== 'undefined';
const isFunction = (value)=>typeof value === 'function';
// Adapted from https://stackoverflow.com/questions/31128855/comparing-ecma6-sets-for-equality#31129384
const setsEqual = (a, b)=>{
    if (a.size !== b.size) {
        return false;
    }
    for (const item of a){
        if (!b.has(item)) {
            return false;
        }
    }
    return true;
};
/**
 * @param e - The event
 * @private
 */ function _isClickEvent(e) {
    return e.type === 'mouseup' || e.type === 'click' || e.type === 'contextmenu';
}

/**
 * @alias Chart.helpers.math
 * @namespace
 */ const PI = Math.PI;
const TAU = 2 * PI;
const PITAU = TAU + PI;
const INFINITY = Number.POSITIVE_INFINITY;
const RAD_PER_DEG = PI / 180;
const HALF_PI = PI / 2;
const QUARTER_PI = PI / 4;
const TWO_THIRDS_PI = PI * 2 / 3;
const log10 = Math.log10;
const sign = Math.sign;
function almostEquals(x, y, epsilon) {
    return Math.abs(x - y) < epsilon;
}
/**
 * Implementation of the nice number algorithm used in determining where axis labels will go
 */ function niceNum(range) {
    const roundedRange = Math.round(range);
    range = almostEquals(range, roundedRange, range / 1000) ? roundedRange : range;
    const niceRange = Math.pow(10, Math.floor(log10(range)));
    const fraction = range / niceRange;
    const niceFraction = fraction <= 1 ? 1 : fraction <= 2 ? 2 : fraction <= 5 ? 5 : 10;
    return niceFraction * niceRange;
}
/**
 * Returns an array of factors sorted from 1 to sqrt(value)
 * @private
 */ function _factorize(value) {
    const result = [];
    const sqrt = Math.sqrt(value);
    let i;
    for(i = 1; i < sqrt; i++){
        if (value % i === 0) {
            result.push(i);
            result.push(value / i);
        }
    }
    if (sqrt === (sqrt | 0)) {
        result.push(sqrt);
    }
    result.sort((a, b)=>a - b).pop();
    return result;
}
function isNumber(n) {
    return !isNaN(parseFloat(n)) && isFinite(n);
}
function almostWhole(x, epsilon) {
    const rounded = Math.round(x);
    return rounded - epsilon <= x && rounded + epsilon >= x;
}
/**
 * @private
 */ function _setMinAndMaxByKey(array, target, property) {
    let i, ilen, value;
    for(i = 0, ilen = array.length; i < ilen; i++){
        value = array[i][property];
        if (!isNaN(value)) {
            target.min = Math.min(target.min, value);
            target.max = Math.max(target.max, value);
        }
    }
}
function toRadians(degrees) {
    return degrees * (PI / 180);
}
function toDegrees(radians) {
    return radians * (180 / PI);
}
/**
 * Returns the number of decimal places
 * i.e. the number of digits after the decimal point, of the value of this Number.
 * @param x - A number.
 * @returns The number of decimal places.
 * @private
 */ function _decimalPlaces(x) {
    if (!isNumberFinite(x)) {
        return;
    }
    let e = 1;
    let p = 0;
    while(Math.round(x * e) / e !== x){
        e *= 10;
        p++;
    }
    return p;
}
// Gets the angle from vertical upright to the point about a centre.
function getAngleFromPoint(centrePoint, anglePoint) {
    const distanceFromXCenter = anglePoint.x - centrePoint.x;
    const distanceFromYCenter = anglePoint.y - centrePoint.y;
    const radialDistanceFromCenter = Math.sqrt(distanceFromXCenter * distanceFromXCenter + distanceFromYCenter * distanceFromYCenter);
    let angle = Math.atan2(distanceFromYCenter, distanceFromXCenter);
    if (angle < -0.5 * PI) {
        angle += TAU; // make sure the returned angle is in the range of (-PI/2, 3PI/2]
    }
    return {
        angle,
        distance: radialDistanceFromCenter
    };
}
function distanceBetweenPoints(pt1, pt2) {
    return Math.sqrt(Math.pow(pt2.x - pt1.x, 2) + Math.pow(pt2.y - pt1.y, 2));
}
/**
 * Shortest distance between angles, in either direction.
 * @private
 */ function _angleDiff(a, b) {
    return (a - b + PITAU) % TAU - PI;
}
/**
 * Normalize angle to be between 0 and 2*PI
 * @private
 */ function _normalizeAngle(a) {
    return (a % TAU + TAU) % TAU;
}
/**
 * @private
 */ function _angleBetween(angle, start, end, sameAngleIsFullCircle) {
    const a = _normalizeAngle(angle);
    const s = _normalizeAngle(start);
    const e = _normalizeAngle(end);
    const angleToStart = _normalizeAngle(s - a);
    const angleToEnd = _normalizeAngle(e - a);
    const startToAngle = _normalizeAngle(a - s);
    const endToAngle = _normalizeAngle(a - e);
    return a === s || a === e || sameAngleIsFullCircle && s === e || angleToStart > angleToEnd && startToAngle < endToAngle;
}
/**
 * Limit `value` between `min` and `max`
 * @param value
 * @param min
 * @param max
 * @private
 */ function _limitValue(value, min, max) {
    return Math.max(min, Math.min(max, value));
}
/**
 * @param {number} value
 * @private
 */ function _int16Range(value) {
    return _limitValue(value, -32768, 32767);
}
/**
 * @param value
 * @param start
 * @param end
 * @param [epsilon]
 * @private
 */ function _isBetween(value, start, end, epsilon = 1e-6) {
    return value >= Math.min(start, end) - epsilon && value <= Math.max(start, end) + epsilon;
}

function _lookup(table, value, cmp) {
    cmp = cmp || ((index)=>table[index] < value);
    let hi = table.length - 1;
    let lo = 0;
    let mid;
    while(hi - lo > 1){
        mid = lo + hi >> 1;
        if (cmp(mid)) {
            lo = mid;
        } else {
            hi = mid;
        }
    }
    return {
        lo,
        hi
    };
}
/**
 * Binary search
 * @param table - the table search. must be sorted!
 * @param key - property name for the value in each entry
 * @param value - value to find
 * @param last - lookup last index
 * @private
 */ const _lookupByKey = (table, key, value, last)=>_lookup(table, value, last ? (index)=>{
        const ti = table[index][key];
        return ti < value || ti === value && table[index + 1][key] === value;
    } : (index)=>table[index][key] < value);
/**
 * Reverse binary search
 * @param table - the table search. must be sorted!
 * @param key - property name for the value in each entry
 * @param value - value to find
 * @private
 */ const _rlookupByKey = (table, key, value)=>_lookup(table, value, (index)=>table[index][key] >= value);
/**
 * Return subset of `values` between `min` and `max` inclusive.
 * Values are assumed to be in sorted order.
 * @param values - sorted array of values
 * @param min - min value
 * @param max - max value
 */ function _filterBetween(values, min, max) {
    let start = 0;
    let end = values.length;
    while(start < end && values[start] < min){
        start++;
    }
    while(end > start && values[end - 1] > max){
        end--;
    }
    return start > 0 || end < values.length ? values.slice(start, end) : values;
}
const arrayEvents = [
    'push',
    'pop',
    'shift',
    'splice',
    'unshift'
];
function listenArrayEvents(array, listener) {
    if (array._chartjs) {
        array._chartjs.listeners.push(listener);
        return;
    }
    Object.defineProperty(array, '_chartjs', {
        configurable: true,
        enumerable: false,
        value: {
            listeners: [
                listener
            ]
        }
    });
    arrayEvents.forEach((key)=>{
        const method = '_onData' + _capitalize(key);
        const base = array[key];
        Object.defineProperty(array, key, {
            configurable: true,
            enumerable: false,
            value (...args) {
                const res = base.apply(this, args);
                array._chartjs.listeners.forEach((object)=>{
                    if (typeof object[method] === 'function') {
                        object[method](...args);
                    }
                });
                return res;
            }
        });
    });
}
function unlistenArrayEvents(array, listener) {
    const stub = array._chartjs;
    if (!stub) {
        return;
    }
    const listeners = stub.listeners;
    const index = listeners.indexOf(listener);
    if (index !== -1) {
        listeners.splice(index, 1);
    }
    if (listeners.length > 0) {
        return;
    }
    arrayEvents.forEach((key)=>{
        delete array[key];
    });
    delete array._chartjs;
}
/**
 * @param items
 */ function _arrayUnique(items) {
    const set = new Set(items);
    if (set.size === items.length) {
        return items;
    }
    return Array.from(set);
}

function fontString(pixelSize, fontStyle, fontFamily) {
    return fontStyle + ' ' + pixelSize + 'px ' + fontFamily;
}
/**
* Request animation polyfill
*/ const requestAnimFrame = function() {
    if (typeof window === 'undefined') {
        return function(callback) {
            return callback();
        };
    }
    return window.requestAnimationFrame;
}();
/**
 * Throttles calling `fn` once per animation frame
 * Latest arguments are used on the actual call
 */ function throttled(fn, thisArg) {
    let argsToUse = [];
    let ticking = false;
    return function(...args) {
        // Save the args for use later
        argsToUse = args;
        if (!ticking) {
            ticking = true;
            requestAnimFrame.call(window, ()=>{
                ticking = false;
                fn.apply(thisArg, argsToUse);
            });
        }
    };
}
/**
 * Debounces calling `fn` for `delay` ms
 */ function debounce(fn, delay) {
    let timeout;
    return function(...args) {
        if (delay) {
            clearTimeout(timeout);
            timeout = setTimeout(fn, delay, args);
        } else {
            fn.apply(this, args);
        }
        return delay;
    };
}
/**
 * Converts 'start' to 'left', 'end' to 'right' and others to 'center'
 * @private
 */ const _toLeftRightCenter = (align)=>align === 'start' ? 'left' : align === 'end' ? 'right' : 'center';
/**
 * Returns `start`, `end` or `(start + end) / 2` depending on `align`. Defaults to `center`
 * @private
 */ const _alignStartEnd = (align, start, end)=>align === 'start' ? start : align === 'end' ? end : (start + end) / 2;
/**
 * Returns `left`, `right` or `(left + right) / 2` depending on `align`. Defaults to `left`
 * @private
 */ const _textX = (align, left, right, rtl)=>{
    const check = rtl ? 'left' : 'right';
    return align === check ? right : align === 'center' ? (left + right) / 2 : left;
};
/**
 * Return start and count of visible points.
 * @private
 */ function _getStartAndCountOfVisiblePoints(meta, points, animationsDisabled) {
    const pointCount = points.length;
    let start = 0;
    let count = pointCount;
    if (meta._sorted) {
        const { iScale , _parsed  } = meta;
        const axis = iScale.axis;
        const { min , max , minDefined , maxDefined  } = iScale.getUserBounds();
        if (minDefined) {
            start = _limitValue(Math.min(// @ts-expect-error Need to type _parsed
            _lookupByKey(_parsed, axis, min).lo, // @ts-expect-error Need to fix types on _lookupByKey
            animationsDisabled ? pointCount : _lookupByKey(points, axis, iScale.getPixelForValue(min)).lo), 0, pointCount - 1);
        }
        if (maxDefined) {
            count = _limitValue(Math.max(// @ts-expect-error Need to type _parsed
            _lookupByKey(_parsed, iScale.axis, max, true).hi + 1, // @ts-expect-error Need to fix types on _lookupByKey
            animationsDisabled ? 0 : _lookupByKey(points, axis, iScale.getPixelForValue(max), true).hi + 1), start, pointCount) - start;
        } else {
            count = pointCount - start;
        }
    }
    return {
        start,
        count
    };
}
/**
 * Checks if the scale ranges have changed.
 * @param {object} meta - dataset meta.
 * @returns {boolean}
 * @private
 */ function _scaleRangesChanged(meta) {
    const { xScale , yScale , _scaleRanges  } = meta;
    const newRanges = {
        xmin: xScale.min,
        xmax: xScale.max,
        ymin: yScale.min,
        ymax: yScale.max
    };
    if (!_scaleRanges) {
        meta._scaleRanges = newRanges;
        return true;
    }
    const changed = _scaleRanges.xmin !== xScale.min || _scaleRanges.xmax !== xScale.max || _scaleRanges.ymin !== yScale.min || _scaleRanges.ymax !== yScale.max;
    Object.assign(_scaleRanges, newRanges);
    return changed;
}

const atEdge = (t)=>t === 0 || t === 1;
const elasticIn = (t, s, p)=>-(Math.pow(2, 10 * (t -= 1)) * Math.sin((t - s) * TAU / p));
const elasticOut = (t, s, p)=>Math.pow(2, -10 * t) * Math.sin((t - s) * TAU / p) + 1;
/**
 * Easing functions adapted from Robert Penner's easing equations.
 * @namespace Chart.helpers.easing.effects
 * @see http://www.robertpenner.com/easing/
 */ const effects = {
    linear: (t)=>t,
    easeInQuad: (t)=>t * t,
    easeOutQuad: (t)=>-t * (t - 2),
    easeInOutQuad: (t)=>(t /= 0.5) < 1 ? 0.5 * t * t : -0.5 * (--t * (t - 2) - 1),
    easeInCubic: (t)=>t * t * t,
    easeOutCubic: (t)=>(t -= 1) * t * t + 1,
    easeInOutCubic: (t)=>(t /= 0.5) < 1 ? 0.5 * t * t * t : 0.5 * ((t -= 2) * t * t + 2),
    easeInQuart: (t)=>t * t * t * t,
    easeOutQuart: (t)=>-((t -= 1) * t * t * t - 1),
    easeInOutQuart: (t)=>(t /= 0.5) < 1 ? 0.5 * t * t * t * t : -0.5 * ((t -= 2) * t * t * t - 2),
    easeInQuint: (t)=>t * t * t * t * t,
    easeOutQuint: (t)=>(t -= 1) * t * t * t * t + 1,
    easeInOutQuint: (t)=>(t /= 0.5) < 1 ? 0.5 * t * t * t * t * t : 0.5 * ((t -= 2) * t * t * t * t + 2),
    easeInSine: (t)=>-Math.cos(t * HALF_PI) + 1,
    easeOutSine: (t)=>Math.sin(t * HALF_PI),
    easeInOutSine: (t)=>-0.5 * (Math.cos(PI * t) - 1),
    easeInExpo: (t)=>t === 0 ? 0 : Math.pow(2, 10 * (t - 1)),
    easeOutExpo: (t)=>t === 1 ? 1 : -Math.pow(2, -10 * t) + 1,
    easeInOutExpo: (t)=>atEdge(t) ? t : t < 0.5 ? 0.5 * Math.pow(2, 10 * (t * 2 - 1)) : 0.5 * (-Math.pow(2, -10 * (t * 2 - 1)) + 2),
    easeInCirc: (t)=>t >= 1 ? t : -(Math.sqrt(1 - t * t) - 1),
    easeOutCirc: (t)=>Math.sqrt(1 - (t -= 1) * t),
    easeInOutCirc: (t)=>(t /= 0.5) < 1 ? -0.5 * (Math.sqrt(1 - t * t) - 1) : 0.5 * (Math.sqrt(1 - (t -= 2) * t) + 1),
    easeInElastic: (t)=>atEdge(t) ? t : elasticIn(t, 0.075, 0.3),
    easeOutElastic: (t)=>atEdge(t) ? t : elasticOut(t, 0.075, 0.3),
    easeInOutElastic (t) {
        const s = 0.1125;
        const p = 0.45;
        return atEdge(t) ? t : t < 0.5 ? 0.5 * elasticIn(t * 2, s, p) : 0.5 + 0.5 * elasticOut(t * 2 - 1, s, p);
    },
    easeInBack (t) {
        const s = 1.70158;
        return t * t * ((s + 1) * t - s);
    },
    easeOutBack (t) {
        const s = 1.70158;
        return (t -= 1) * t * ((s + 1) * t + s) + 1;
    },
    easeInOutBack (t) {
        let s = 1.70158;
        if ((t /= 0.5) < 1) {
            return 0.5 * (t * t * (((s *= 1.525) + 1) * t - s));
        }
        return 0.5 * ((t -= 2) * t * (((s *= 1.525) + 1) * t + s) + 2);
    },
    easeInBounce: (t)=>1 - effects.easeOutBounce(1 - t),
    easeOutBounce (t) {
        const m = 7.5625;
        const d = 2.75;
        if (t < 1 / d) {
            return m * t * t;
        }
        if (t < 2 / d) {
            return m * (t -= 1.5 / d) * t + 0.75;
        }
        if (t < 2.5 / d) {
            return m * (t -= 2.25 / d) * t + 0.9375;
        }
        return m * (t -= 2.625 / d) * t + 0.984375;
    },
    easeInOutBounce: (t)=>t < 0.5 ? effects.easeInBounce(t * 2) * 0.5 : effects.easeOutBounce(t * 2 - 1) * 0.5 + 0.5
};

function isPatternOrGradient(value) {
    if (value && typeof value === 'object') {
        const type = value.toString();
        return type === '[object CanvasPattern]' || type === '[object CanvasGradient]';
    }
    return false;
}
function color(value) {
    return isPatternOrGradient(value) ? value : new Color(value);
}
function getHoverColor(value) {
    return isPatternOrGradient(value) ? value : new Color(value).saturate(0.5).darken(0.1).hexString();
}

const numbers = [
    'x',
    'y',
    'borderWidth',
    'radius',
    'tension'
];
const colors = [
    'color',
    'borderColor',
    'backgroundColor'
];
function applyAnimationsDefaults(defaults) {
    defaults.set('animation', {
        delay: undefined,
        duration: 1000,
        easing: 'easeOutQuart',
        fn: undefined,
        from: undefined,
        loop: undefined,
        to: undefined,
        type: undefined
    });
    defaults.describe('animation', {
        _fallback: false,
        _indexable: false,
        _scriptable: (name)=>name !== 'onProgress' && name !== 'onComplete' && name !== 'fn'
    });
    defaults.set('animations', {
        colors: {
            type: 'color',
            properties: colors
        },
        numbers: {
            type: 'number',
            properties: numbers
        }
    });
    defaults.describe('animations', {
        _fallback: 'animation'
    });
    defaults.set('transitions', {
        active: {
            animation: {
                duration: 400
            }
        },
        resize: {
            animation: {
                duration: 0
            }
        },
        show: {
            animations: {
                colors: {
                    from: 'transparent'
                },
                visible: {
                    type: 'boolean',
                    duration: 0
                }
            }
        },
        hide: {
            animations: {
                colors: {
                    to: 'transparent'
                },
                visible: {
                    type: 'boolean',
                    easing: 'linear',
                    fn: (v)=>v | 0
                }
            }
        }
    });
}

function applyLayoutsDefaults(defaults) {
    defaults.set('layout', {
        autoPadding: true,
        padding: {
            top: 0,
            right: 0,
            bottom: 0,
            left: 0
        }
    });
}

const intlCache = new Map();
function getNumberFormat(locale, options) {
    options = options || {};
    const cacheKey = locale + JSON.stringify(options);
    let formatter = intlCache.get(cacheKey);
    if (!formatter) {
        formatter = new Intl.NumberFormat(locale, options);
        intlCache.set(cacheKey, formatter);
    }
    return formatter;
}
function formatNumber(num, locale, options) {
    return getNumberFormat(locale, options).format(num);
}

const formatters = {
 values (value) {
        return isArray(value) ?  value : '' + value;
    },
 numeric (tickValue, index, ticks) {
        if (tickValue === 0) {
            return '0';
        }
        const locale = this.chart.options.locale;
        let notation;
        let delta = tickValue;
        if (ticks.length > 1) {
            const maxTick = Math.max(Math.abs(ticks[0].value), Math.abs(ticks[ticks.length - 1].value));
            if (maxTick < 1e-4 || maxTick > 1e+15) {
                notation = 'scientific';
            }
            delta = calculateDelta(tickValue, ticks);
        }
        const logDelta = log10(Math.abs(delta));
        const numDecimal = isNaN(logDelta) ? 1 : Math.max(Math.min(-1 * Math.floor(logDelta), 20), 0);
        const options = {
            notation,
            minimumFractionDigits: numDecimal,
            maximumFractionDigits: numDecimal
        };
        Object.assign(options, this.options.ticks.format);
        return formatNumber(tickValue, locale, options);
    },
 logarithmic (tickValue, index, ticks) {
        if (tickValue === 0) {
            return '0';
        }
        const remain = ticks[index].significand || tickValue / Math.pow(10, Math.floor(log10(tickValue)));
        if ([
            1,
            2,
            3,
            5,
            10,
            15
        ].includes(remain) || index > 0.8 * ticks.length) {
            return formatters.numeric.call(this, tickValue, index, ticks);
        }
        return '';
    }
};
function calculateDelta(tickValue, ticks) {
    let delta = ticks.length > 3 ? ticks[2].value - ticks[1].value : ticks[1].value - ticks[0].value;
    if (Math.abs(delta) >= 1 && tickValue !== Math.floor(tickValue)) {
        delta = tickValue - Math.floor(tickValue);
    }
    return delta;
}
 var Ticks = {
    formatters
};

function applyScaleDefaults(defaults) {
    defaults.set('scale', {
        display: true,
        offset: false,
        reverse: false,
        beginAtZero: false,
 bounds: 'ticks',
        clip: true,
 grace: 0,
        grid: {
            display: true,
            lineWidth: 1,
            drawOnChartArea: true,
            drawTicks: true,
            tickLength: 8,
            tickWidth: (_ctx, options)=>options.lineWidth,
            tickColor: (_ctx, options)=>options.color,
            offset: false
        },
        border: {
            display: true,
            dash: [],
            dashOffset: 0.0,
            width: 1
        },
        title: {
            display: false,
            text: '',
            padding: {
                top: 4,
                bottom: 4
            }
        },
        ticks: {
            minRotation: 0,
            maxRotation: 50,
            mirror: false,
            textStrokeWidth: 0,
            textStrokeColor: '',
            padding: 3,
            display: true,
            autoSkip: true,
            autoSkipPadding: 3,
            labelOffset: 0,
            callback: Ticks.formatters.values,
            minor: {},
            major: {},
            align: 'center',
            crossAlign: 'near',
            showLabelBackdrop: false,
            backdropColor: 'rgba(255, 255, 255, 0.75)',
            backdropPadding: 2
        }
    });
    defaults.route('scale.ticks', 'color', '', 'color');
    defaults.route('scale.grid', 'color', '', 'borderColor');
    defaults.route('scale.border', 'color', '', 'borderColor');
    defaults.route('scale.title', 'color', '', 'color');
    defaults.describe('scale', {
        _fallback: false,
        _scriptable: (name)=>!name.startsWith('before') && !name.startsWith('after') && name !== 'callback' && name !== 'parser',
        _indexable: (name)=>name !== 'borderDash' && name !== 'tickBorderDash' && name !== 'dash'
    });
    defaults.describe('scales', {
        _fallback: 'scale'
    });
    defaults.describe('scale.ticks', {
        _scriptable: (name)=>name !== 'backdropPadding' && name !== 'callback',
        _indexable: (name)=>name !== 'backdropPadding'
    });
}

const overrides = Object.create(null);
const descriptors = Object.create(null);
 function getScope$1(node, key) {
    if (!key) {
        return node;
    }
    const keys = key.split('.');
    for(let i = 0, n = keys.length; i < n; ++i){
        const k = keys[i];
        node = node[k] || (node[k] = Object.create(null));
    }
    return node;
}
function set(root, scope, values) {
    if (typeof scope === 'string') {
        return merge(getScope$1(root, scope), values);
    }
    return merge(getScope$1(root, ''), scope);
}
 class Defaults {
    constructor(_descriptors, _appliers){
        this.animation = undefined;
        this.backgroundColor = 'rgba(0,0,0,0.1)';
        this.borderColor = 'rgba(0,0,0,0.1)';
        this.color = '#666';
        this.datasets = {};
        this.devicePixelRatio = (context)=>context.chart.platform.getDevicePixelRatio();
        this.elements = {};
        this.events = [
            'mousemove',
            'mouseout',
            'click',
            'touchstart',
            'touchmove'
        ];
        this.font = {
            family: "'Helvetica Neue', 'Helvetica', 'Arial', sans-serif",
            size: 12,
            style: 'normal',
            lineHeight: 1.2,
            weight: null
        };
        this.hover = {};
        this.hoverBackgroundColor = (ctx, options)=>getHoverColor(options.backgroundColor);
        this.hoverBorderColor = (ctx, options)=>getHoverColor(options.borderColor);
        this.hoverColor = (ctx, options)=>getHoverColor(options.color);
        this.indexAxis = 'x';
        this.interaction = {
            mode: 'nearest',
            intersect: true,
            includeInvisible: false
        };
        this.maintainAspectRatio = true;
        this.onHover = null;
        this.onClick = null;
        this.parsing = true;
        this.plugins = {};
        this.responsive = true;
        this.scale = undefined;
        this.scales = {};
        this.showLine = true;
        this.drawActiveElementsOnTop = true;
        this.describe(_descriptors);
        this.apply(_appliers);
    }
 set(scope, values) {
        return set(this, scope, values);
    }
 get(scope) {
        return getScope$1(this, scope);
    }
 describe(scope, values) {
        return set(descriptors, scope, values);
    }
    override(scope, values) {
        return set(overrides, scope, values);
    }
 route(scope, name, targetScope, targetName) {
        const scopeObject = getScope$1(this, scope);
        const targetScopeObject = getScope$1(this, targetScope);
        const privateName = '_' + name;
        Object.defineProperties(scopeObject, {
            [privateName]: {
                value: scopeObject[name],
                writable: true
            },
            [name]: {
                enumerable: true,
                get () {
                    const local = this[privateName];
                    const target = targetScopeObject[targetName];
                    if (isObject(local)) {
                        return Object.assign({}, target, local);
                    }
                    return valueOrDefault(local, target);
                },
                set (value) {
                    this[privateName] = value;
                }
            }
        });
    }
    apply(appliers) {
        appliers.forEach((apply)=>apply(this));
    }
}
var defaults = /* #__PURE__ */ new Defaults({
    _scriptable: (name)=>!name.startsWith('on'),
    _indexable: (name)=>name !== 'events',
    hover: {
        _fallback: 'interaction'
    },
    interaction: {
        _scriptable: false,
        _indexable: false
    }
}, [
    applyAnimationsDefaults,
    applyLayoutsDefaults,
    applyScaleDefaults
]);

/**
 * Converts the given font object into a CSS font string.
 * @param font - A font object.
 * @return The CSS font string. See https://developer.mozilla.org/en-US/docs/Web/CSS/font
 * @private
 */ function toFontString(font) {
    if (!font || isNullOrUndef(font.size) || isNullOrUndef(font.family)) {
        return null;
    }
    return (font.style ? font.style + ' ' : '') + (font.weight ? font.weight + ' ' : '') + font.size + 'px ' + font.family;
}
/**
 * @private
 */ function _measureText(ctx, data, gc, longest, string) {
    let textWidth = data[string];
    if (!textWidth) {
        textWidth = data[string] = ctx.measureText(string).width;
        gc.push(string);
    }
    if (textWidth > longest) {
        longest = textWidth;
    }
    return longest;
}
/**
 * @private
 */ // eslint-disable-next-line complexity
function _longestText(ctx, font, arrayOfThings, cache) {
    cache = cache || {};
    let data = cache.data = cache.data || {};
    let gc = cache.garbageCollect = cache.garbageCollect || [];
    if (cache.font !== font) {
        data = cache.data = {};
        gc = cache.garbageCollect = [];
        cache.font = font;
    }
    ctx.save();
    ctx.font = font;
    let longest = 0;
    const ilen = arrayOfThings.length;
    let i, j, jlen, thing, nestedThing;
    for(i = 0; i < ilen; i++){
        thing = arrayOfThings[i];
        // Undefined strings and arrays should not be measured
        if (thing !== undefined && thing !== null && !isArray(thing)) {
            longest = _measureText(ctx, data, gc, longest, thing);
        } else if (isArray(thing)) {
            // if it is an array lets measure each element
            // to do maybe simplify this function a bit so we can do this more recursively?
            for(j = 0, jlen = thing.length; j < jlen; j++){
                nestedThing = thing[j];
                // Undefined strings and arrays should not be measured
                if (nestedThing !== undefined && nestedThing !== null && !isArray(nestedThing)) {
                    longest = _measureText(ctx, data, gc, longest, nestedThing);
                }
            }
        }
    }
    ctx.restore();
    const gcLen = gc.length / 2;
    if (gcLen > arrayOfThings.length) {
        for(i = 0; i < gcLen; i++){
            delete data[gc[i]];
        }
        gc.splice(0, gcLen);
    }
    return longest;
}
/**
 * Returns the aligned pixel value to avoid anti-aliasing blur
 * @param chart - The chart instance.
 * @param pixel - A pixel value.
 * @param width - The width of the element.
 * @returns The aligned pixel value.
 * @private
 */ function _alignPixel(chart, pixel, width) {
    const devicePixelRatio = chart.currentDevicePixelRatio;
    const halfWidth = width !== 0 ? Math.max(width / 2, 0.5) : 0;
    return Math.round((pixel - halfWidth) * devicePixelRatio) / devicePixelRatio + halfWidth;
}
/**
 * Clears the entire canvas.
 */ function clearCanvas(canvas, ctx) {
    ctx = ctx || canvas.getContext('2d');
    ctx.save();
    // canvas.width and canvas.height do not consider the canvas transform,
    // while clearRect does
    ctx.resetTransform();
    ctx.clearRect(0, 0, canvas.width, canvas.height);
    ctx.restore();
}
function drawPoint(ctx, options, x, y) {
    // eslint-disable-next-line @typescript-eslint/no-use-before-define
    drawPointLegend(ctx, options, x, y, null);
}
// eslint-disable-next-line complexity
function drawPointLegend(ctx, options, x, y, w) {
    let type, xOffset, yOffset, size, cornerRadius, width, xOffsetW, yOffsetW;
    const style = options.pointStyle;
    const rotation = options.rotation;
    const radius = options.radius;
    let rad = (rotation || 0) * RAD_PER_DEG;
    if (style && typeof style === 'object') {
        type = style.toString();
        if (type === '[object HTMLImageElement]' || type === '[object HTMLCanvasElement]') {
            ctx.save();
            ctx.translate(x, y);
            ctx.rotate(rad);
            ctx.drawImage(style, -style.width / 2, -style.height / 2, style.width, style.height);
            ctx.restore();
            return;
        }
    }
    if (isNaN(radius) || radius <= 0) {
        return;
    }
    ctx.beginPath();
    switch(style){
        // Default includes circle
        default:
            if (w) {
                ctx.ellipse(x, y, w / 2, radius, 0, 0, TAU);
            } else {
                ctx.arc(x, y, radius, 0, TAU);
            }
            ctx.closePath();
            break;
        case 'triangle':
            width = w ? w / 2 : radius;
            ctx.moveTo(x + Math.sin(rad) * width, y - Math.cos(rad) * radius);
            rad += TWO_THIRDS_PI;
            ctx.lineTo(x + Math.sin(rad) * width, y - Math.cos(rad) * radius);
            rad += TWO_THIRDS_PI;
            ctx.lineTo(x + Math.sin(rad) * width, y - Math.cos(rad) * radius);
            ctx.closePath();
            break;
        case 'rectRounded':
            // NOTE: the rounded rect implementation changed to use `arc` instead of
            // `quadraticCurveTo` since it generates better results when rect is
            // almost a circle. 0.516 (instead of 0.5) produces results with visually
            // closer proportion to the previous impl and it is inscribed in the
            // circle with `radius`. For more details, see the following PRs:
            // https://github.com/chartjs/Chart.js/issues/5597
            // https://github.com/chartjs/Chart.js/issues/5858
            cornerRadius = radius * 0.516;
            size = radius - cornerRadius;
            xOffset = Math.cos(rad + QUARTER_PI) * size;
            xOffsetW = Math.cos(rad + QUARTER_PI) * (w ? w / 2 - cornerRadius : size);
            yOffset = Math.sin(rad + QUARTER_PI) * size;
            yOffsetW = Math.sin(rad + QUARTER_PI) * (w ? w / 2 - cornerRadius : size);
            ctx.arc(x - xOffsetW, y - yOffset, cornerRadius, rad - PI, rad - HALF_PI);
            ctx.arc(x + yOffsetW, y - xOffset, cornerRadius, rad - HALF_PI, rad);
            ctx.arc(x + xOffsetW, y + yOffset, cornerRadius, rad, rad + HALF_PI);
            ctx.arc(x - yOffsetW, y + xOffset, cornerRadius, rad + HALF_PI, rad + PI);
            ctx.closePath();
            break;
        case 'rect':
            if (!rotation) {
                size = Math.SQRT1_2 * radius;
                width = w ? w / 2 : size;
                ctx.rect(x - width, y - size, 2 * width, 2 * size);
                break;
            }
            rad += QUARTER_PI;
        /* falls through */ case 'rectRot':
            xOffsetW = Math.cos(rad) * (w ? w / 2 : radius);
            xOffset = Math.cos(rad) * radius;
            yOffset = Math.sin(rad) * radius;
            yOffsetW = Math.sin(rad) * (w ? w / 2 : radius);
            ctx.moveTo(x - xOffsetW, y - yOffset);
            ctx.lineTo(x + yOffsetW, y - xOffset);
            ctx.lineTo(x + xOffsetW, y + yOffset);
            ctx.lineTo(x - yOffsetW, y + xOffset);
            ctx.closePath();
            break;
        case 'crossRot':
            rad += QUARTER_PI;
        /* falls through */ case 'cross':
            xOffsetW = Math.cos(rad) * (w ? w / 2 : radius);
            xOffset = Math.cos(rad) * radius;
            yOffset = Math.sin(rad) * radius;
            yOffsetW = Math.sin(rad) * (w ? w / 2 : radius);
            ctx.moveTo(x - xOffsetW, y - yOffset);
            ctx.lineTo(x + xOffsetW, y + yOffset);
            ctx.moveTo(x + yOffsetW, y - xOffset);
            ctx.lineTo(x - yOffsetW, y + xOffset);
            break;
        case 'star':
            xOffsetW = Math.cos(rad) * (w ? w / 2 : radius);
            xOffset = Math.cos(rad) * radius;
            yOffset = Math.sin(rad) * radius;
            yOffsetW = Math.sin(rad) * (w ? w / 2 : radius);
            ctx.moveTo(x - xOffsetW, y - yOffset);
            ctx.lineTo(x + xOffsetW, y + yOffset);
            ctx.moveTo(x + yOffsetW, y - xOffset);
            ctx.lineTo(x - yOffsetW, y + xOffset);
            rad += QUARTER_PI;
            xOffsetW = Math.cos(rad) * (w ? w / 2 : radius);
            xOffset = Math.cos(rad) * radius;
            yOffset = Math.sin(rad) * radius;
            yOffsetW = Math.sin(rad) * (w ? w / 2 : radius);
            ctx.moveTo(x - xOffsetW, y - yOffset);
            ctx.lineTo(x + xOffsetW, y + yOffset);
            ctx.moveTo(x + yOffsetW, y - xOffset);
            ctx.lineTo(x - yOffsetW, y + xOffset);
            break;
        case 'line':
            xOffset = w ? w / 2 : Math.cos(rad) * radius;
            yOffset = Math.sin(rad) * radius;
            ctx.moveTo(x - xOffset, y - yOffset);
            ctx.lineTo(x + xOffset, y + yOffset);
            break;
        case 'dash':
            ctx.moveTo(x, y);
            ctx.lineTo(x + Math.cos(rad) * (w ? w / 2 : radius), y + Math.sin(rad) * radius);
            break;
        case false:
            ctx.closePath();
            break;
    }
    ctx.fill();
    if (options.borderWidth > 0) {
        ctx.stroke();
    }
}
/**
 * Returns true if the point is inside the rectangle
 * @param point - The point to test
 * @param area - The rectangle
 * @param margin - allowed margin
 * @private
 */ function _isPointInArea(point, area, margin) {
    margin = margin || 0.5; // margin - default is to match rounded decimals
    return !area || point && point.x > area.left - margin && point.x < area.right + margin && point.y > area.top - margin && point.y < area.bottom + margin;
}
function clipArea(ctx, area) {
    ctx.save();
    ctx.beginPath();
    ctx.rect(area.left, area.top, area.right - area.left, area.bottom - area.top);
    ctx.clip();
}
function unclipArea(ctx) {
    ctx.restore();
}
/**
 * @private
 */ function _steppedLineTo(ctx, previous, target, flip, mode) {
    if (!previous) {
        return ctx.lineTo(target.x, target.y);
    }
    if (mode === 'middle') {
        const midpoint = (previous.x + target.x) / 2.0;
        ctx.lineTo(midpoint, previous.y);
        ctx.lineTo(midpoint, target.y);
    } else if (mode === 'after' !== !!flip) {
        ctx.lineTo(previous.x, target.y);
    } else {
        ctx.lineTo(target.x, previous.y);
    }
    ctx.lineTo(target.x, target.y);
}
/**
 * @private
 */ function _bezierCurveTo(ctx, previous, target, flip) {
    if (!previous) {
        return ctx.lineTo(target.x, target.y);
    }
    ctx.bezierCurveTo(flip ? previous.cp1x : previous.cp2x, flip ? previous.cp1y : previous.cp2y, flip ? target.cp2x : target.cp1x, flip ? target.cp2y : target.cp1y, target.x, target.y);
}
function setRenderOpts(ctx, opts) {
    if (opts.translation) {
        ctx.translate(opts.translation[0], opts.translation[1]);
    }
    if (!isNullOrUndef(opts.rotation)) {
        ctx.rotate(opts.rotation);
    }
    if (opts.color) {
        ctx.fillStyle = opts.color;
    }
    if (opts.textAlign) {
        ctx.textAlign = opts.textAlign;
    }
    if (opts.textBaseline) {
        ctx.textBaseline = opts.textBaseline;
    }
}
function decorateText(ctx, x, y, line, opts) {
    if (opts.strikethrough || opts.underline) {
        /**
     * Now that IE11 support has been dropped, we can use more
     * of the TextMetrics object. The actual bounding boxes
     * are unflagged in Chrome, Firefox, Edge, and Safari so they
     * can be safely used.
     * See https://developer.mozilla.org/en-US/docs/Web/API/TextMetrics#Browser_compatibility
     */ const metrics = ctx.measureText(line);
        const left = x - metrics.actualBoundingBoxLeft;
        const right = x + metrics.actualBoundingBoxRight;
        const top = y - metrics.actualBoundingBoxAscent;
        const bottom = y + metrics.actualBoundingBoxDescent;
        const yDecoration = opts.strikethrough ? (top + bottom) / 2 : bottom;
        ctx.strokeStyle = ctx.fillStyle;
        ctx.beginPath();
        ctx.lineWidth = opts.decorationWidth || 2;
        ctx.moveTo(left, yDecoration);
        ctx.lineTo(right, yDecoration);
        ctx.stroke();
    }
}
function drawBackdrop(ctx, opts) {
    const oldColor = ctx.fillStyle;
    ctx.fillStyle = opts.color;
    ctx.fillRect(opts.left, opts.top, opts.width, opts.height);
    ctx.fillStyle = oldColor;
}
/**
 * Render text onto the canvas
 */ function renderText(ctx, text, x, y, font, opts = {}) {
    const lines = isArray(text) ? text : [
        text
    ];
    const stroke = opts.strokeWidth > 0 && opts.strokeColor !== '';
    let i, line;
    ctx.save();
    ctx.font = font.string;
    setRenderOpts(ctx, opts);
    for(i = 0; i < lines.length; ++i){
        line = lines[i];
        if (opts.backdrop) {
            drawBackdrop(ctx, opts.backdrop);
        }
        if (stroke) {
            if (opts.strokeColor) {
                ctx.strokeStyle = opts.strokeColor;
            }
            if (!isNullOrUndef(opts.strokeWidth)) {
                ctx.lineWidth = opts.strokeWidth;
            }
            ctx.strokeText(line, x, y, opts.maxWidth);
        }
        ctx.fillText(line, x, y, opts.maxWidth);
        decorateText(ctx, x, y, line, opts);
        y += Number(font.lineHeight);
    }
    ctx.restore();
}
/**
 * Add a path of a rectangle with rounded corners to the current sub-path
 * @param ctx - Context
 * @param rect - Bounding rect
 */ function addRoundedRectPath(ctx, rect) {
    const { x , y , w , h , radius  } = rect;
    // top left arc
    ctx.arc(x + radius.topLeft, y + radius.topLeft, radius.topLeft, 1.5 * PI, PI, true);
    // line from top left to bottom left
    ctx.lineTo(x, y + h - radius.bottomLeft);
    // bottom left arc
    ctx.arc(x + radius.bottomLeft, y + h - radius.bottomLeft, radius.bottomLeft, PI, HALF_PI, true);
    // line from bottom left to bottom right
    ctx.lineTo(x + w - radius.bottomRight, y + h);
    // bottom right arc
    ctx.arc(x + w - radius.bottomRight, y + h - radius.bottomRight, radius.bottomRight, HALF_PI, 0, true);
    // line from bottom right to top right
    ctx.lineTo(x + w, y + radius.topRight);
    // top right arc
    ctx.arc(x + w - radius.topRight, y + radius.topRight, radius.topRight, 0, -HALF_PI, true);
    // line from top right to top left
    ctx.lineTo(x + radius.topLeft, y);
}

const LINE_HEIGHT = /^(normal|(\d+(?:\.\d+)?)(px|em|%)?)$/;
const FONT_STYLE = /^(normal|italic|initial|inherit|unset|(oblique( -?[0-9]?[0-9]deg)?))$/;
/**
 * @alias Chart.helpers.options
 * @namespace
 */ /**
 * Converts the given line height `value` in pixels for a specific font `size`.
 * @param value - The lineHeight to parse (eg. 1.6, '14px', '75%', '1.6em').
 * @param size - The font size (in pixels) used to resolve relative `value`.
 * @returns The effective line height in pixels (size * 1.2 if value is invalid).
 * @see https://developer.mozilla.org/en-US/docs/Web/CSS/line-height
 * @since 2.7.0
 */ function toLineHeight(value, size) {
    const matches = ('' + value).match(LINE_HEIGHT);
    if (!matches || matches[1] === 'normal') {
        return size * 1.2;
    }
    value = +matches[2];
    switch(matches[3]){
        case 'px':
            return value;
        case '%':
            value /= 100;
            break;
    }
    return size * value;
}
const numberOrZero = (v)=>+v || 0;
function _readValueToProps(value, props) {
    const ret = {};
    const objProps = isObject(props);
    const keys = objProps ? Object.keys(props) : props;
    const read = isObject(value) ? objProps ? (prop)=>valueOrDefault(value[prop], value[props[prop]]) : (prop)=>value[prop] : ()=>value;
    for (const prop of keys){
        ret[prop] = numberOrZero(read(prop));
    }
    return ret;
}
/**
 * Converts the given value into a TRBL object.
 * @param value - If a number, set the value to all TRBL component,
 *  else, if an object, use defined properties and sets undefined ones to 0.
 *  x / y are shorthands for same value for left/right and top/bottom.
 * @returns The padding values (top, right, bottom, left)
 * @since 3.0.0
 */ function toTRBL(value) {
    return _readValueToProps(value, {
        top: 'y',
        right: 'x',
        bottom: 'y',
        left: 'x'
    });
}
/**
 * Converts the given value into a TRBL corners object (similar with css border-radius).
 * @param value - If a number, set the value to all TRBL corner components,
 *  else, if an object, use defined properties and sets undefined ones to 0.
 * @returns The TRBL corner values (topLeft, topRight, bottomLeft, bottomRight)
 * @since 3.0.0
 */ function toTRBLCorners(value) {
    return _readValueToProps(value, [
        'topLeft',
        'topRight',
        'bottomLeft',
        'bottomRight'
    ]);
}
/**
 * Converts the given value into a padding object with pre-computed width/height.
 * @param value - If a number, set the value to all TRBL component,
 *  else, if an object, use defined properties and sets undefined ones to 0.
 *  x / y are shorthands for same value for left/right and top/bottom.
 * @returns The padding values (top, right, bottom, left, width, height)
 * @since 2.7.0
 */ function toPadding(value) {
    const obj = toTRBL(value);
    obj.width = obj.left + obj.right;
    obj.height = obj.top + obj.bottom;
    return obj;
}
/**
 * Parses font options and returns the font object.
 * @param options - A object that contains font options to be parsed.
 * @param fallback - A object that contains fallback font options.
 * @return The font object.
 * @private
 */ function toFont(options, fallback) {
    options = options || {};
    fallback = fallback || defaults.font;
    let size = valueOrDefault(options.size, fallback.size);
    if (typeof size === 'string') {
        size = parseInt(size, 10);
    }
    let style = valueOrDefault(options.style, fallback.style);
    if (style && !('' + style).match(FONT_STYLE)) {
        console.warn('Invalid font style specified: "' + style + '"');
        style = undefined;
    }
    const font = {
        family: valueOrDefault(options.family, fallback.family),
        lineHeight: toLineHeight(valueOrDefault(options.lineHeight, fallback.lineHeight), size),
        size,
        style,
        weight: valueOrDefault(options.weight, fallback.weight),
        string: ''
    };
    font.string = toFontString(font);
    return font;
}
/**
 * Evaluates the given `inputs` sequentially and returns the first defined value.
 * @param inputs - An array of values, falling back to the last value.
 * @param context - If defined and the current value is a function, the value
 * is called with `context` as first argument and the result becomes the new input.
 * @param index - If defined and the current value is an array, the value
 * at `index` become the new input.
 * @param info - object to return information about resolution in
 * @param info.cacheable - Will be set to `false` if option is not cacheable.
 * @since 2.7.0
 */ function resolve(inputs, context, index, info) {
    let cacheable = true;
    let i, ilen, value;
    for(i = 0, ilen = inputs.length; i < ilen; ++i){
        value = inputs[i];
        if (value === undefined) {
            continue;
        }
        if (context !== undefined && typeof value === 'function') {
            value = value(context);
            cacheable = false;
        }
        if (index !== undefined && isArray(value)) {
            value = value[index % value.length];
            cacheable = false;
        }
        if (value !== undefined) {
            if (info && !cacheable) {
                info.cacheable = false;
            }
            return value;
        }
    }
}
/**
 * @param minmax
 * @param grace
 * @param beginAtZero
 * @private
 */ function _addGrace(minmax, grace, beginAtZero) {
    const { min , max  } = minmax;
    const change = toDimension(grace, (max - min) / 2);
    const keepZero = (value, add)=>beginAtZero && value === 0 ? 0 : value + add;
    return {
        min: keepZero(min, -Math.abs(change)),
        max: keepZero(max, change)
    };
}
function createContext(parentContext, context) {
    return Object.assign(Object.create(parentContext), context);
}

/**
 * Creates a Proxy for resolving raw values for options.
 * @param scopes - The option scopes to look for values, in resolution order
 * @param prefixes - The prefixes for values, in resolution order.
 * @param rootScopes - The root option scopes
 * @param fallback - Parent scopes fallback
 * @param getTarget - callback for getting the target for changed values
 * @returns Proxy
 * @private
 */ function _createResolver(scopes, prefixes = [
    ''
], rootScopes, fallback, getTarget = ()=>scopes[0]) {
    const finalRootScopes = rootScopes || scopes;
    if (typeof fallback === 'undefined') {
        fallback = _resolve('_fallback', scopes);
    }
    const cache = {
        [Symbol.toStringTag]: 'Object',
        _cacheable: true,
        _scopes: scopes,
        _rootScopes: finalRootScopes,
        _fallback: fallback,
        _getTarget: getTarget,
        override: (scope)=>_createResolver([
                scope,
                ...scopes
            ], prefixes, finalRootScopes, fallback)
    };
    return new Proxy(cache, {
        /**
     * A trap for the delete operator.
     */ deleteProperty (target, prop) {
            delete target[prop]; // remove from cache
            delete target._keys; // remove cached keys
            delete scopes[0][prop]; // remove from top level scope
            return true;
        },
        /**
     * A trap for getting property values.
     */ get (target, prop) {
            return _cached(target, prop, ()=>_resolveWithPrefixes(prop, prefixes, scopes, target));
        },
        /**
     * A trap for Object.getOwnPropertyDescriptor.
     * Also used by Object.hasOwnProperty.
     */ getOwnPropertyDescriptor (target, prop) {
            return Reflect.getOwnPropertyDescriptor(target._scopes[0], prop);
        },
        /**
     * A trap for Object.getPrototypeOf.
     */ getPrototypeOf () {
            return Reflect.getPrototypeOf(scopes[0]);
        },
        /**
     * A trap for the in operator.
     */ has (target, prop) {
            return getKeysFromAllScopes(target).includes(prop);
        },
        /**
     * A trap for Object.getOwnPropertyNames and Object.getOwnPropertySymbols.
     */ ownKeys (target) {
            return getKeysFromAllScopes(target);
        },
        /**
     * A trap for setting property values.
     */ set (target, prop, value) {
            const storage = target._storage || (target._storage = getTarget());
            target[prop] = storage[prop] = value; // set to top level scope + cache
            delete target._keys; // remove cached keys
            return true;
        }
    });
}
/**
 * Returns an Proxy for resolving option values with context.
 * @param proxy - The Proxy returned by `_createResolver`
 * @param context - Context object for scriptable/indexable options
 * @param subProxy - The proxy provided for scriptable options
 * @param descriptorDefaults - Defaults for descriptors
 * @private
 */ function _attachContext(proxy, context, subProxy, descriptorDefaults) {
    const cache = {
        _cacheable: false,
        _proxy: proxy,
        _context: context,
        _subProxy: subProxy,
        _stack: new Set(),
        _descriptors: _descriptors(proxy, descriptorDefaults),
        setContext: (ctx)=>_attachContext(proxy, ctx, subProxy, descriptorDefaults),
        override: (scope)=>_attachContext(proxy.override(scope), context, subProxy, descriptorDefaults)
    };
    return new Proxy(cache, {
        /**
     * A trap for the delete operator.
     */ deleteProperty (target, prop) {
            delete target[prop]; // remove from cache
            delete proxy[prop]; // remove from proxy
            return true;
        },
        /**
     * A trap for getting property values.
     */ get (target, prop, receiver) {
            return _cached(target, prop, ()=>_resolveWithContext(target, prop, receiver));
        },
        /**
     * A trap for Object.getOwnPropertyDescriptor.
     * Also used by Object.hasOwnProperty.
     */ getOwnPropertyDescriptor (target, prop) {
            return target._descriptors.allKeys ? Reflect.has(proxy, prop) ? {
                enumerable: true,
                configurable: true
            } : undefined : Reflect.getOwnPropertyDescriptor(proxy, prop);
        },
        /**
     * A trap for Object.getPrototypeOf.
     */ getPrototypeOf () {
            return Reflect.getPrototypeOf(proxy);
        },
        /**
     * A trap for the in operator.
     */ has (target, prop) {
            return Reflect.has(proxy, prop);
        },
        /**
     * A trap for Object.getOwnPropertyNames and Object.getOwnPropertySymbols.
     */ ownKeys () {
            return Reflect.ownKeys(proxy);
        },
        /**
     * A trap for setting property values.
     */ set (target, prop, value) {
            proxy[prop] = value; // set to proxy
            delete target[prop]; // remove from cache
            return true;
        }
    });
}
/**
 * @private
 */ function _descriptors(proxy, defaults = {
    scriptable: true,
    indexable: true
}) {
    const { _scriptable =defaults.scriptable , _indexable =defaults.indexable , _allKeys =defaults.allKeys  } = proxy;
    return {
        allKeys: _allKeys,
        scriptable: _scriptable,
        indexable: _indexable,
        isScriptable: isFunction(_scriptable) ? _scriptable : ()=>_scriptable,
        isIndexable: isFunction(_indexable) ? _indexable : ()=>_indexable
    };
}
const readKey = (prefix, name)=>prefix ? prefix + _capitalize(name) : name;
const needsSubResolver = (prop, value)=>isObject(value) && prop !== 'adapters' && (Object.getPrototypeOf(value) === null || value.constructor === Object);
function _cached(target, prop, resolve) {
    if (Object.prototype.hasOwnProperty.call(target, prop)) {
        return target[prop];
    }
    const value = resolve();
    // cache the resolved value
    target[prop] = value;
    return value;
}
function _resolveWithContext(target, prop, receiver) {
    const { _proxy , _context , _subProxy , _descriptors: descriptors  } = target;
    let value = _proxy[prop]; // resolve from proxy
    // resolve with context
    if (isFunction(value) && descriptors.isScriptable(prop)) {
        value = _resolveScriptable(prop, value, target, receiver);
    }
    if (isArray(value) && value.length) {
        value = _resolveArray(prop, value, target, descriptors.isIndexable);
    }
    if (needsSubResolver(prop, value)) {
        // if the resolved value is an object, create a sub resolver for it
        value = _attachContext(value, _context, _subProxy && _subProxy[prop], descriptors);
    }
    return value;
}
function _resolveScriptable(prop, getValue, target, receiver) {
    const { _proxy , _context , _subProxy , _stack  } = target;
    if (_stack.has(prop)) {
        throw new Error('Recursion detected: ' + Array.from(_stack).join('->') + '->' + prop);
    }
    _stack.add(prop);
    let value = getValue(_context, _subProxy || receiver);
    _stack.delete(prop);
    if (needsSubResolver(prop, value)) {
        // When scriptable option returns an object, create a resolver on that.
        value = createSubResolver(_proxy._scopes, _proxy, prop, value);
    }
    return value;
}
function _resolveArray(prop, value, target, isIndexable) {
    const { _proxy , _context , _subProxy , _descriptors: descriptors  } = target;
    if (typeof _context.index !== 'undefined' && isIndexable(prop)) {
        return value[_context.index % value.length];
    } else if (isObject(value[0])) {
        // Array of objects, return array or resolvers
        const arr = value;
        const scopes = _proxy._scopes.filter((s)=>s !== arr);
        value = [];
        for (const item of arr){
            const resolver = createSubResolver(scopes, _proxy, prop, item);
            value.push(_attachContext(resolver, _context, _subProxy && _subProxy[prop], descriptors));
        }
    }
    return value;
}
function resolveFallback(fallback, prop, value) {
    return isFunction(fallback) ? fallback(prop, value) : fallback;
}
const getScope = (key, parent)=>key === true ? parent : typeof key === 'string' ? resolveObjectKey(parent, key) : undefined;
function addScopes(set, parentScopes, key, parentFallback, value) {
    for (const parent of parentScopes){
        const scope = getScope(key, parent);
        if (scope) {
            set.add(scope);
            const fallback = resolveFallback(scope._fallback, key, value);
            if (typeof fallback !== 'undefined' && fallback !== key && fallback !== parentFallback) {
                // When we reach the descriptor that defines a new _fallback, return that.
                // The fallback will resume to that new scope.
                return fallback;
            }
        } else if (scope === false && typeof parentFallback !== 'undefined' && key !== parentFallback) {
            // Fallback to `false` results to `false`, when falling back to different key.
            // For example `interaction` from `hover` or `plugins.tooltip` and `animation` from `animations`
            return null;
        }
    }
    return false;
}
function createSubResolver(parentScopes, resolver, prop, value) {
    const rootScopes = resolver._rootScopes;
    const fallback = resolveFallback(resolver._fallback, prop, value);
    const allScopes = [
        ...parentScopes,
        ...rootScopes
    ];
    const set = new Set();
    set.add(value);
    let key = addScopesFromKey(set, allScopes, prop, fallback || prop, value);
    if (key === null) {
        return false;
    }
    if (typeof fallback !== 'undefined' && fallback !== prop) {
        key = addScopesFromKey(set, allScopes, fallback, key, value);
        if (key === null) {
            return false;
        }
    }
    return _createResolver(Array.from(set), [
        ''
    ], rootScopes, fallback, ()=>subGetTarget(resolver, prop, value));
}
function addScopesFromKey(set, allScopes, key, fallback, item) {
    while(key){
        key = addScopes(set, allScopes, key, fallback, item);
    }
    return key;
}
function subGetTarget(resolver, prop, value) {
    const parent = resolver._getTarget();
    if (!(prop in parent)) {
        parent[prop] = {};
    }
    const target = parent[prop];
    if (isArray(target) && isObject(value)) {
        // For array of objects, the object is used to store updated values
        return value;
    }
    return target || {};
}
function _resolveWithPrefixes(prop, prefixes, scopes, proxy) {
    let value;
    for (const prefix of prefixes){
        value = _resolve(readKey(prefix, prop), scopes);
        if (typeof value !== 'undefined') {
            return needsSubResolver(prop, value) ? createSubResolver(scopes, proxy, prop, value) : value;
        }
    }
}
function _resolve(key, scopes) {
    for (const scope of scopes){
        if (!scope) {
            continue;
        }
        const value = scope[key];
        if (typeof value !== 'undefined') {
            return value;
        }
    }
}
function getKeysFromAllScopes(target) {
    let keys = target._keys;
    if (!keys) {
        keys = target._keys = resolveKeysFromAllScopes(target._scopes);
    }
    return keys;
}
function resolveKeysFromAllScopes(scopes) {
    const set = new Set();
    for (const scope of scopes){
        for (const key of Object.keys(scope).filter((k)=>!k.startsWith('_'))){
            set.add(key);
        }
    }
    return Array.from(set);
}
function _parseObjectDataRadialScale(meta, data, start, count) {
    const { iScale  } = meta;
    const { key ='r'  } = this._parsing;
    const parsed = new Array(count);
    let i, ilen, index, item;
    for(i = 0, ilen = count; i < ilen; ++i){
        index = i + start;
        item = data[index];
        parsed[i] = {
            r: iScale.parse(resolveObjectKey(item, key), index)
        };
    }
    return parsed;
}

const EPSILON = Number.EPSILON || 1e-14;
const getPoint = (points, i)=>i < points.length && !points[i].skip && points[i];
const getValueAxis = (indexAxis)=>indexAxis === 'x' ? 'y' : 'x';
function splineCurve(firstPoint, middlePoint, afterPoint, t) {
    // Props to Rob Spencer at scaled innovation for his post on splining between points
    // http://scaledinnovation.com/analytics/splines/aboutSplines.html
    // This function must also respect "skipped" points
    const previous = firstPoint.skip ? middlePoint : firstPoint;
    const current = middlePoint;
    const next = afterPoint.skip ? middlePoint : afterPoint;
    const d01 = distanceBetweenPoints(current, previous);
    const d12 = distanceBetweenPoints(next, current);
    let s01 = d01 / (d01 + d12);
    let s12 = d12 / (d01 + d12);
    // If all points are the same, s01 & s02 will be inf
    s01 = isNaN(s01) ? 0 : s01;
    s12 = isNaN(s12) ? 0 : s12;
    const fa = t * s01; // scaling factor for triangle Ta
    const fb = t * s12;
    return {
        previous: {
            x: current.x - fa * (next.x - previous.x),
            y: current.y - fa * (next.y - previous.y)
        },
        next: {
            x: current.x + fb * (next.x - previous.x),
            y: current.y + fb * (next.y - previous.y)
        }
    };
}
/**
 * Adjust tangents to ensure monotonic properties
 */ function monotoneAdjust(points, deltaK, mK) {
    const pointsLen = points.length;
    let alphaK, betaK, tauK, squaredMagnitude, pointCurrent;
    let pointAfter = getPoint(points, 0);
    for(let i = 0; i < pointsLen - 1; ++i){
        pointCurrent = pointAfter;
        pointAfter = getPoint(points, i + 1);
        if (!pointCurrent || !pointAfter) {
            continue;
        }
        if (almostEquals(deltaK[i], 0, EPSILON)) {
            mK[i] = mK[i + 1] = 0;
            continue;
        }
        alphaK = mK[i] / deltaK[i];
        betaK = mK[i + 1] / deltaK[i];
        squaredMagnitude = Math.pow(alphaK, 2) + Math.pow(betaK, 2);
        if (squaredMagnitude <= 9) {
            continue;
        }
        tauK = 3 / Math.sqrt(squaredMagnitude);
        mK[i] = alphaK * tauK * deltaK[i];
        mK[i + 1] = betaK * tauK * deltaK[i];
    }
}
function monotoneCompute(points, mK, indexAxis = 'x') {
    const valueAxis = getValueAxis(indexAxis);
    const pointsLen = points.length;
    let delta, pointBefore, pointCurrent;
    let pointAfter = getPoint(points, 0);
    for(let i = 0; i < pointsLen; ++i){
        pointBefore = pointCurrent;
        pointCurrent = pointAfter;
        pointAfter = getPoint(points, i + 1);
        if (!pointCurrent) {
            continue;
        }
        const iPixel = pointCurrent[indexAxis];
        const vPixel = pointCurrent[valueAxis];
        if (pointBefore) {
            delta = (iPixel - pointBefore[indexAxis]) / 3;
            pointCurrent[`cp1${indexAxis}`] = iPixel - delta;
            pointCurrent[`cp1${valueAxis}`] = vPixel - delta * mK[i];
        }
        if (pointAfter) {
            delta = (pointAfter[indexAxis] - iPixel) / 3;
            pointCurrent[`cp2${indexAxis}`] = iPixel + delta;
            pointCurrent[`cp2${valueAxis}`] = vPixel + delta * mK[i];
        }
    }
}
/**
 * This function calculates Bézier control points in a similar way than |splineCurve|,
 * but preserves monotonicity of the provided data and ensures no local extremums are added
 * between the dataset discrete points due to the interpolation.
 * See : https://en.wikipedia.org/wiki/Monotone_cubic_interpolation
 */ function splineCurveMonotone(points, indexAxis = 'x') {
    const valueAxis = getValueAxis(indexAxis);
    const pointsLen = points.length;
    const deltaK = Array(pointsLen).fill(0);
    const mK = Array(pointsLen);
    // Calculate slopes (deltaK) and initialize tangents (mK)
    let i, pointBefore, pointCurrent;
    let pointAfter = getPoint(points, 0);
    for(i = 0; i < pointsLen; ++i){
        pointBefore = pointCurrent;
        pointCurrent = pointAfter;
        pointAfter = getPoint(points, i + 1);
        if (!pointCurrent) {
            continue;
        }
        if (pointAfter) {
            const slopeDelta = pointAfter[indexAxis] - pointCurrent[indexAxis];
            // In the case of two points that appear at the same x pixel, slopeDeltaX is 0
            deltaK[i] = slopeDelta !== 0 ? (pointAfter[valueAxis] - pointCurrent[valueAxis]) / slopeDelta : 0;
        }
        mK[i] = !pointBefore ? deltaK[i] : !pointAfter ? deltaK[i - 1] : sign(deltaK[i - 1]) !== sign(deltaK[i]) ? 0 : (deltaK[i - 1] + deltaK[i]) / 2;
    }
    monotoneAdjust(points, deltaK, mK);
    monotoneCompute(points, mK, indexAxis);
}
function capControlPoint(pt, min, max) {
    return Math.max(Math.min(pt, max), min);
}
function capBezierPoints(points, area) {
    let i, ilen, point, inArea, inAreaPrev;
    let inAreaNext = _isPointInArea(points[0], area);
    for(i = 0, ilen = points.length; i < ilen; ++i){
        inAreaPrev = inArea;
        inArea = inAreaNext;
        inAreaNext = i < ilen - 1 && _isPointInArea(points[i + 1], area);
        if (!inArea) {
            continue;
        }
        point = points[i];
        if (inAreaPrev) {
            point.cp1x = capControlPoint(point.cp1x, area.left, area.right);
            point.cp1y = capControlPoint(point.cp1y, area.top, area.bottom);
        }
        if (inAreaNext) {
            point.cp2x = capControlPoint(point.cp2x, area.left, area.right);
            point.cp2y = capControlPoint(point.cp2y, area.top, area.bottom);
        }
    }
}
/**
 * @private
 */ function _updateBezierControlPoints(points, options, area, loop, indexAxis) {
    let i, ilen, point, controlPoints;
    // Only consider points that are drawn in case the spanGaps option is used
    if (options.spanGaps) {
        points = points.filter((pt)=>!pt.skip);
    }
    if (options.cubicInterpolationMode === 'monotone') {
        splineCurveMonotone(points, indexAxis);
    } else {
        let prev = loop ? points[points.length - 1] : points[0];
        for(i = 0, ilen = points.length; i < ilen; ++i){
            point = points[i];
            controlPoints = splineCurve(prev, point, points[Math.min(i + 1, ilen - (loop ? 0 : 1)) % ilen], options.tension);
            point.cp1x = controlPoints.previous.x;
            point.cp1y = controlPoints.previous.y;
            point.cp2x = controlPoints.next.x;
            point.cp2y = controlPoints.next.y;
            prev = point;
        }
    }
    if (options.capBezierPoints) {
        capBezierPoints(points, area);
    }
}

/**
 * Note: typedefs are auto-exported, so use a made-up `dom` namespace where
 * necessary to avoid duplicates with `export * from './helpers`; see
 * https://github.com/microsoft/TypeScript/issues/46011
 * @typedef { import('../core/core.controller.js').default } dom.Chart
 * @typedef { import('../../types').ChartEvent } ChartEvent
 */ /**
 * @private
 */ function _isDomSupported() {
    return typeof window !== 'undefined' && typeof document !== 'undefined';
}
/**
 * @private
 */ function _getParentNode(domNode) {
    let parent = domNode.parentNode;
    if (parent && parent.toString() === '[object ShadowRoot]') {
        parent = parent.host;
    }
    return parent;
}
/**
 * convert max-width/max-height values that may be percentages into a number
 * @private
 */ function parseMaxStyle(styleValue, node, parentProperty) {
    let valueInPixels;
    if (typeof styleValue === 'string') {
        valueInPixels = parseInt(styleValue, 10);
        if (styleValue.indexOf('%') !== -1) {
            // percentage * size in dimension
            valueInPixels = valueInPixels / 100 * node.parentNode[parentProperty];
        }
    } else {
        valueInPixels = styleValue;
    }
    return valueInPixels;
}
const getComputedStyle = (element)=>element.ownerDocument.defaultView.getComputedStyle(element, null);
function getStyle(el, property) {
    return getComputedStyle(el).getPropertyValue(property);
}
const positions = [
    'top',
    'right',
    'bottom',
    'left'
];
function getPositionedStyle(styles, style, suffix) {
    const result = {};
    suffix = suffix ? '-' + suffix : '';
    for(let i = 0; i < 4; i++){
        const pos = positions[i];
        result[pos] = parseFloat(styles[style + '-' + pos + suffix]) || 0;
    }
    result.width = result.left + result.right;
    result.height = result.top + result.bottom;
    return result;
}
const useOffsetPos = (x, y, target)=>(x > 0 || y > 0) && (!target || !target.shadowRoot);
/**
 * @param e
 * @param canvas
 * @returns Canvas position
 */ function getCanvasPosition(e, canvas) {
    const touches = e.touches;
    const source = touches && touches.length ? touches[0] : e;
    const { offsetX , offsetY  } = source;
    let box = false;
    let x, y;
    if (useOffsetPos(offsetX, offsetY, e.target)) {
        x = offsetX;
        y = offsetY;
    } else {
        const rect = canvas.getBoundingClientRect();
        x = source.clientX - rect.left;
        y = source.clientY - rect.top;
        box = true;
    }
    return {
        x,
        y,
        box
    };
}
/**
 * Gets an event's x, y coordinates, relative to the chart area
 * @param event
 * @param chart
 * @returns x and y coordinates of the event
 */ function getRelativePosition(event, chart) {
    if ('native' in event) {
        return event;
    }
    const { canvas , currentDevicePixelRatio  } = chart;
    const style = getComputedStyle(canvas);
    const borderBox = style.boxSizing === 'border-box';
    const paddings = getPositionedStyle(style, 'padding');
    const borders = getPositionedStyle(style, 'border', 'width');
    const { x , y , box  } = getCanvasPosition(event, canvas);
    const xOffset = paddings.left + (box && borders.left);
    const yOffset = paddings.top + (box && borders.top);
    let { width , height  } = chart;
    if (borderBox) {
        width -= paddings.width + borders.width;
        height -= paddings.height + borders.height;
    }
    return {
        x: Math.round((x - xOffset) / width * canvas.width / currentDevicePixelRatio),
        y: Math.round((y - yOffset) / height * canvas.height / currentDevicePixelRatio)
    };
}
function getContainerSize(canvas, width, height) {
    let maxWidth, maxHeight;
    if (width === undefined || height === undefined) {
        const container = _getParentNode(canvas);
        if (!container) {
            width = canvas.clientWidth;
            height = canvas.clientHeight;
        } else {
            const rect = container.getBoundingClientRect(); // this is the border box of the container
            const containerStyle = getComputedStyle(container);
            const containerBorder = getPositionedStyle(containerStyle, 'border', 'width');
            const containerPadding = getPositionedStyle(containerStyle, 'padding');
            width = rect.width - containerPadding.width - containerBorder.width;
            height = rect.height - containerPadding.height - containerBorder.height;
            maxWidth = parseMaxStyle(containerStyle.maxWidth, container, 'clientWidth');
            maxHeight = parseMaxStyle(containerStyle.maxHeight, container, 'clientHeight');
        }
    }
    return {
        width,
        height,
        maxWidth: maxWidth || INFINITY,
        maxHeight: maxHeight || INFINITY
    };
}
const round1 = (v)=>Math.round(v * 10) / 10;
// eslint-disable-next-line complexity
function getMaximumSize(canvas, bbWidth, bbHeight, aspectRatio) {
    const style = getComputedStyle(canvas);
    const margins = getPositionedStyle(style, 'margin');
    const maxWidth = parseMaxStyle(style.maxWidth, canvas, 'clientWidth') || INFINITY;
    const maxHeight = parseMaxStyle(style.maxHeight, canvas, 'clientHeight') || INFINITY;
    const containerSize = getContainerSize(canvas, bbWidth, bbHeight);
    let { width , height  } = containerSize;
    if (style.boxSizing === 'content-box') {
        const borders = getPositionedStyle(style, 'border', 'width');
        const paddings = getPositionedStyle(style, 'padding');
        width -= paddings.width + borders.width;
        height -= paddings.height + borders.height;
    }
    width = Math.max(0, width - margins.width);
    height = Math.max(0, aspectRatio ? width / aspectRatio : height - margins.height);
    width = round1(Math.min(width, maxWidth, containerSize.maxWidth));
    height = round1(Math.min(height, maxHeight, containerSize.maxHeight));
    if (width && !height) {
        // https://github.com/chartjs/Chart.js/issues/4659
        // If the canvas has width, but no height, default to aspectRatio of 2 (canvas default)
        height = round1(width / 2);
    }
    const maintainHeight = bbWidth !== undefined || bbHeight !== undefined;
    if (maintainHeight && aspectRatio && containerSize.height && height > containerSize.height) {
        height = containerSize.height;
        width = round1(Math.floor(height * aspectRatio));
    }
    return {
        width,
        height
    };
}
/**
 * @param chart
 * @param forceRatio
 * @param forceStyle
 * @returns True if the canvas context size or transformation has changed.
 */ function retinaScale(chart, forceRatio, forceStyle) {
    const pixelRatio = forceRatio || 1;
    const deviceHeight = Math.floor(chart.height * pixelRatio);
    const deviceWidth = Math.floor(chart.width * pixelRatio);
    chart.height = Math.floor(chart.height);
    chart.width = Math.floor(chart.width);
    const canvas = chart.canvas;
    // If no style has been set on the canvas, the render size is used as display size,
    // making the chart visually bigger, so let's enforce it to the "correct" values.
    // See https://github.com/chartjs/Chart.js/issues/3575
    if (canvas.style && (forceStyle || !canvas.style.height && !canvas.style.width)) {
        canvas.style.height = `${chart.height}px`;
        canvas.style.width = `${chart.width}px`;
    }
    if (chart.currentDevicePixelRatio !== pixelRatio || canvas.height !== deviceHeight || canvas.width !== deviceWidth) {
        chart.currentDevicePixelRatio = pixelRatio;
        canvas.height = deviceHeight;
        canvas.width = deviceWidth;
        chart.ctx.setTransform(pixelRatio, 0, 0, pixelRatio, 0, 0);
        return true;
    }
    return false;
}
/**
 * Detects support for options object argument in addEventListener.
 * https://developer.mozilla.org/en-US/docs/Web/API/EventTarget/addEventListener#Safely_detecting_option_support
 * @private
 */ const supportsEventListenerOptions = function() {
    let passiveSupported = false;
    try {
        const options = {
            get passive () {
                passiveSupported = true;
                return false;
            }
        };
        if (_isDomSupported()) {
            window.addEventListener('test', null, options);
            window.removeEventListener('test', null, options);
        }
    } catch (e) {
    // continue regardless of error
    }
    return passiveSupported;
}();
/**
 * The "used" size is the final value of a dimension property after all calculations have
 * been performed. This method uses the computed style of `element` but returns undefined
 * if the computed style is not expressed in pixels. That can happen in some cases where
 * `element` has a size relative to its parent and this last one is not yet displayed,
 * for example because of `display: none` on a parent node.
 * @see https://developer.mozilla.org/en-US/docs/Web/CSS/used_value
 * @returns Size in pixels or undefined if unknown.
 */ function readUsedSize(element, property) {
    const value = getStyle(element, property);
    const matches = value && value.match(/^(\d+)(\.\d+)?px$/);
    return matches ? +matches[1] : undefined;
}

/**
 * @private
 */ function _pointInLine(p1, p2, t, mode) {
    return {
        x: p1.x + t * (p2.x - p1.x),
        y: p1.y + t * (p2.y - p1.y)
    };
}
/**
 * @private
 */ function _steppedInterpolation(p1, p2, t, mode) {
    return {
        x: p1.x + t * (p2.x - p1.x),
        y: mode === 'middle' ? t < 0.5 ? p1.y : p2.y : mode === 'after' ? t < 1 ? p1.y : p2.y : t > 0 ? p2.y : p1.y
    };
}
/**
 * @private
 */ function _bezierInterpolation(p1, p2, t, mode) {
    const cp1 = {
        x: p1.cp2x,
        y: p1.cp2y
    };
    const cp2 = {
        x: p2.cp1x,
        y: p2.cp1y
    };
    const a = _pointInLine(p1, cp1, t);
    const b = _pointInLine(cp1, cp2, t);
    const c = _pointInLine(cp2, p2, t);
    const d = _pointInLine(a, b, t);
    const e = _pointInLine(b, c, t);
    return _pointInLine(d, e, t);
}

const getRightToLeftAdapter = function(rectX, width) {
    return {
        x (x) {
            return rectX + rectX + width - x;
        },
        setWidth (w) {
            width = w;
        },
        textAlign (align) {
            if (align === 'center') {
                return align;
            }
            return align === 'right' ? 'left' : 'right';
        },
        xPlus (x, value) {
            return x - value;
        },
        leftForLtr (x, itemWidth) {
            return x - itemWidth;
        }
    };
};
const getLeftToRightAdapter = function() {
    return {
        x (x) {
            return x;
        },
        setWidth (w) {},
        textAlign (align) {
            return align;
        },
        xPlus (x, value) {
            return x + value;
        },
        leftForLtr (x, _itemWidth) {
            return x;
        }
    };
};
function getRtlAdapter(rtl, rectX, width) {
    return rtl ? getRightToLeftAdapter(rectX, width) : getLeftToRightAdapter();
}
function overrideTextDirection(ctx, direction) {
    let style, original;
    if (direction === 'ltr' || direction === 'rtl') {
        style = ctx.canvas.style;
        original = [
            style.getPropertyValue('direction'),
            style.getPropertyPriority('direction')
        ];
        style.setProperty('direction', direction, 'important');
        ctx.prevTextDirection = original;
    }
}
function restoreTextDirection(ctx, original) {
    if (original !== undefined) {
        delete ctx.prevTextDirection;
        ctx.canvas.style.setProperty('direction', original[0], original[1]);
    }
}

function propertyFn(property) {
    if (property === 'angle') {
        return {
            between: _angleBetween,
            compare: _angleDiff,
            normalize: _normalizeAngle
        };
    }
    return {
        between: _isBetween,
        compare: (a, b)=>a - b,
        normalize: (x)=>x
    };
}
function normalizeSegment({ start , end , count , loop , style  }) {
    return {
        start: start % count,
        end: end % count,
        loop: loop && (end - start + 1) % count === 0,
        style
    };
}
function getSegment(segment, points, bounds) {
    const { property , start: startBound , end: endBound  } = bounds;
    const { between , normalize  } = propertyFn(property);
    const count = points.length;
    let { start , end , loop  } = segment;
    let i, ilen;
    if (loop) {
        start += count;
        end += count;
        for(i = 0, ilen = count; i < ilen; ++i){
            if (!between(normalize(points[start % count][property]), startBound, endBound)) {
                break;
            }
            start--;
            end--;
        }
        start %= count;
        end %= count;
    }
    if (end < start) {
        end += count;
    }
    return {
        start,
        end,
        loop,
        style: segment.style
    };
}
 function _boundSegment(segment, points, bounds) {
    if (!bounds) {
        return [
            segment
        ];
    }
    const { property , start: startBound , end: endBound  } = bounds;
    const count = points.length;
    const { compare , between , normalize  } = propertyFn(property);
    const { start , end , loop , style  } = getSegment(segment, points, bounds);
    const result = [];
    let inside = false;
    let subStart = null;
    let value, point, prevValue;
    const startIsBefore = ()=>between(startBound, prevValue, value) && compare(startBound, prevValue) !== 0;
    const endIsBefore = ()=>compare(endBound, value) === 0 || between(endBound, prevValue, value);
    const shouldStart = ()=>inside || startIsBefore();
    const shouldStop = ()=>!inside || endIsBefore();
    for(let i = start, prev = start; i <= end; ++i){
        point = points[i % count];
        if (point.skip) {
            continue;
        }
        value = normalize(point[property]);
        if (value === prevValue) {
            continue;
        }
        inside = between(value, startBound, endBound);
        if (subStart === null && shouldStart()) {
            subStart = compare(value, startBound) === 0 ? i : prev;
        }
        if (subStart !== null && shouldStop()) {
            result.push(normalizeSegment({
                start: subStart,
                end: i,
                loop,
                count,
                style
            }));
            subStart = null;
        }
        prev = i;
        prevValue = value;
    }
    if (subStart !== null) {
        result.push(normalizeSegment({
            start: subStart,
            end,
            loop,
            count,
            style
        }));
    }
    return result;
}
 function _boundSegments(line, bounds) {
    const result = [];
    const segments = line.segments;
    for(let i = 0; i < segments.length; i++){
        const sub = _boundSegment(segments[i], line.points, bounds);
        if (sub.length) {
            result.push(...sub);
        }
    }
    return result;
}
 function findStartAndEnd(points, count, loop, spanGaps) {
    let start = 0;
    let end = count - 1;
    if (loop && !spanGaps) {
        while(start < count && !points[start].skip){
            start++;
        }
    }
    while(start < count && points[start].skip){
        start++;
    }
    start %= count;
    if (loop) {
        end += start;
    }
    while(end > start && points[end % count].skip){
        end--;
    }
    end %= count;
    return {
        start,
        end
    };
}
 function solidSegments(points, start, max, loop) {
    const count = points.length;
    const result = [];
    let last = start;
    let prev = points[start];
    let end;
    for(end = start + 1; end <= max; ++end){
        const cur = points[end % count];
        if (cur.skip || cur.stop) {
            if (!prev.skip) {
                loop = false;
                result.push({
                    start: start % count,
                    end: (end - 1) % count,
                    loop
                });
                start = last = cur.stop ? end : null;
            }
        } else {
            last = end;
            if (prev.skip) {
                start = end;
            }
        }
        prev = cur;
    }
    if (last !== null) {
        result.push({
            start: start % count,
            end: last % count,
            loop
        });
    }
    return result;
}
 function _computeSegments(line, segmentOptions) {
    const points = line.points;
    const spanGaps = line.options.spanGaps;
    const count = points.length;
    if (!count) {
        return [];
    }
    const loop = !!line._loop;
    const { start , end  } = findStartAndEnd(points, count, loop, spanGaps);
    if (spanGaps === true) {
        return splitByStyles(line, [
            {
                start,
                end,
                loop
            }
        ], points, segmentOptions);
    }
    const max = end < start ? end + count : end;
    const completeLoop = !!line._fullLoop && start === 0 && end === count - 1;
    return splitByStyles(line, solidSegments(points, start, max, completeLoop), points, segmentOptions);
}
 function splitByStyles(line, segments, points, segmentOptions) {
    if (!segmentOptions || !segmentOptions.setContext || !points) {
        return segments;
    }
    return doSplitByStyles(line, segments, points, segmentOptions);
}
 function doSplitByStyles(line, segments, points, segmentOptions) {
    const chartContext = line._chart.getContext();
    const baseStyle = readStyle(line.options);
    const { _datasetIndex: datasetIndex , options: { spanGaps  }  } = line;
    const count = points.length;
    const result = [];
    let prevStyle = baseStyle;
    let start = segments[0].start;
    let i = start;
    function addStyle(s, e, l, st) {
        const dir = spanGaps ? -1 : 1;
        if (s === e) {
            return;
        }
        s += count;
        while(points[s % count].skip){
            s -= dir;
        }
        while(points[e % count].skip){
            e += dir;
        }
        if (s % count !== e % count) {
            result.push({
                start: s % count,
                end: e % count,
                loop: l,
                style: st
            });
            prevStyle = st;
            start = e % count;
        }
    }
    for (const segment of segments){
        start = spanGaps ? start : segment.start;
        let prev = points[start % count];
        let style;
        for(i = start + 1; i <= segment.end; i++){
            const pt = points[i % count];
            style = readStyle(segmentOptions.setContext(createContext(chartContext, {
                type: 'segment',
                p0: prev,
                p1: pt,
                p0DataIndex: (i - 1) % count,
                p1DataIndex: i % count,
                datasetIndex
            })));
            if (styleChanged(style, prevStyle)) {
                addStyle(start, i - 1, segment.loop, prevStyle);
            }
            prev = pt;
            prevStyle = style;
        }
        if (start < i - 1) {
            addStyle(start, i - 1, segment.loop, prevStyle);
        }
    }
    return result;
}
function readStyle(options) {
    return {
        backgroundColor: options.backgroundColor,
        borderCapStyle: options.borderCapStyle,
        borderDash: options.borderDash,
        borderDashOffset: options.borderDashOffset,
        borderJoinStyle: options.borderJoinStyle,
        borderWidth: options.borderWidth,
        borderColor: options.borderColor
    };
}
function styleChanged(style, prevStyle) {
    if (!prevStyle) {
        return false;
    }
    const cache = [];
    const replacer = function(key, value) {
        if (!isPatternOrGradient(value)) {
            return value;
        }
        if (!cache.includes(value)) {
            cache.push(value);
        }
        return cache.indexOf(value);
    };
    return JSON.stringify(style, replacer) !== JSON.stringify(prevStyle, replacer);
}


//# sourceMappingURL=helpers.segment.js.map

;// CONCATENATED MODULE: ./node_modules/chart.js/dist/chart.js
/*!
 * Chart.js v4.4.2
 * https://www.chartjs.org
 * (c) 2024 Chart.js Contributors
 * Released under the MIT License
 */



class Animator {
    constructor(){
        this._request = null;
        this._charts = new Map();
        this._running = false;
        this._lastDate = undefined;
    }
 _notify(chart, anims, date, type) {
        const callbacks = anims.listeners[type];
        const numSteps = anims.duration;
        callbacks.forEach((fn)=>fn({
                chart,
                initial: anims.initial,
                numSteps,
                currentStep: Math.min(date - anims.start, numSteps)
            }));
    }
 _refresh() {
        if (this._request) {
            return;
        }
        this._running = true;
        this._request = requestAnimFrame.call(window, ()=>{
            this._update();
            this._request = null;
            if (this._running) {
                this._refresh();
            }
        });
    }
 _update(date = Date.now()) {
        let remaining = 0;
        this._charts.forEach((anims, chart)=>{
            if (!anims.running || !anims.items.length) {
                return;
            }
            const items = anims.items;
            let i = items.length - 1;
            let draw = false;
            let item;
            for(; i >= 0; --i){
                item = items[i];
                if (item._active) {
                    if (item._total > anims.duration) {
                        anims.duration = item._total;
                    }
                    item.tick(date);
                    draw = true;
                } else {
                    items[i] = items[items.length - 1];
                    items.pop();
                }
            }
            if (draw) {
                chart.draw();
                this._notify(chart, anims, date, 'progress');
            }
            if (!items.length) {
                anims.running = false;
                this._notify(chart, anims, date, 'complete');
                anims.initial = false;
            }
            remaining += items.length;
        });
        this._lastDate = date;
        if (remaining === 0) {
            this._running = false;
        }
    }
 _getAnims(chart) {
        const charts = this._charts;
        let anims = charts.get(chart);
        if (!anims) {
            anims = {
                running: false,
                initial: true,
                items: [],
                listeners: {
                    complete: [],
                    progress: []
                }
            };
            charts.set(chart, anims);
        }
        return anims;
    }
 listen(chart, event, cb) {
        this._getAnims(chart).listeners[event].push(cb);
    }
 add(chart, items) {
        if (!items || !items.length) {
            return;
        }
        this._getAnims(chart).items.push(...items);
    }
 has(chart) {
        return this._getAnims(chart).items.length > 0;
    }
 start(chart) {
        const anims = this._charts.get(chart);
        if (!anims) {
            return;
        }
        anims.running = true;
        anims.start = Date.now();
        anims.duration = anims.items.reduce((acc, cur)=>Math.max(acc, cur._duration), 0);
        this._refresh();
    }
    running(chart) {
        if (!this._running) {
            return false;
        }
        const anims = this._charts.get(chart);
        if (!anims || !anims.running || !anims.items.length) {
            return false;
        }
        return true;
    }
 stop(chart) {
        const anims = this._charts.get(chart);
        if (!anims || !anims.items.length) {
            return;
        }
        const items = anims.items;
        let i = items.length - 1;
        for(; i >= 0; --i){
            items[i].cancel();
        }
        anims.items = [];
        this._notify(chart, anims, Date.now(), 'complete');
    }
 remove(chart) {
        return this._charts.delete(chart);
    }
}
var animator = /* #__PURE__ */ new Animator();

const transparent = 'transparent';
const interpolators = {
    boolean (from, to, factor) {
        return factor > 0.5 ? to : from;
    },
 color (from, to, factor) {
        const c0 = color(from || transparent);
        const c1 = c0.valid && color(to || transparent);
        return c1 && c1.valid ? c1.mix(c0, factor).hexString() : to;
    },
    number (from, to, factor) {
        return from + (to - from) * factor;
    }
};
class Animation {
    constructor(cfg, target, prop, to){
        const currentValue = target[prop];
        to = resolve([
            cfg.to,
            to,
            currentValue,
            cfg.from
        ]);
        const from = resolve([
            cfg.from,
            currentValue,
            to
        ]);
        this._active = true;
        this._fn = cfg.fn || interpolators[cfg.type || typeof from];
        this._easing = effects[cfg.easing] || effects.linear;
        this._start = Math.floor(Date.now() + (cfg.delay || 0));
        this._duration = this._total = Math.floor(cfg.duration);
        this._loop = !!cfg.loop;
        this._target = target;
        this._prop = prop;
        this._from = from;
        this._to = to;
        this._promises = undefined;
    }
    active() {
        return this._active;
    }
    update(cfg, to, date) {
        if (this._active) {
            this._notify(false);
            const currentValue = this._target[this._prop];
            const elapsed = date - this._start;
            const remain = this._duration - elapsed;
            this._start = date;
            this._duration = Math.floor(Math.max(remain, cfg.duration));
            this._total += elapsed;
            this._loop = !!cfg.loop;
            this._to = resolve([
                cfg.to,
                to,
                currentValue,
                cfg.from
            ]);
            this._from = resolve([
                cfg.from,
                currentValue,
                to
            ]);
        }
    }
    cancel() {
        if (this._active) {
            this.tick(Date.now());
            this._active = false;
            this._notify(false);
        }
    }
    tick(date) {
        const elapsed = date - this._start;
        const duration = this._duration;
        const prop = this._prop;
        const from = this._from;
        const loop = this._loop;
        const to = this._to;
        let factor;
        this._active = from !== to && (loop || elapsed < duration);
        if (!this._active) {
            this._target[prop] = to;
            this._notify(true);
            return;
        }
        if (elapsed < 0) {
            this._target[prop] = from;
            return;
        }
        factor = elapsed / duration % 2;
        factor = loop && factor > 1 ? 2 - factor : factor;
        factor = this._easing(Math.min(1, Math.max(0, factor)));
        this._target[prop] = this._fn(from, to, factor);
    }
    wait() {
        const promises = this._promises || (this._promises = []);
        return new Promise((res, rej)=>{
            promises.push({
                res,
                rej
            });
        });
    }
    _notify(resolved) {
        const method = resolved ? 'res' : 'rej';
        const promises = this._promises || [];
        for(let i = 0; i < promises.length; i++){
            promises[i][method]();
        }
    }
}

class Animations {
    constructor(chart, config){
        this._chart = chart;
        this._properties = new Map();
        this.configure(config);
    }
    configure(config) {
        if (!isObject(config)) {
            return;
        }
        const animationOptions = Object.keys(defaults.animation);
        const animatedProps = this._properties;
        Object.getOwnPropertyNames(config).forEach((key)=>{
            const cfg = config[key];
            if (!isObject(cfg)) {
                return;
            }
            const resolved = {};
            for (const option of animationOptions){
                resolved[option] = cfg[option];
            }
            (isArray(cfg.properties) && cfg.properties || [
                key
            ]).forEach((prop)=>{
                if (prop === key || !animatedProps.has(prop)) {
                    animatedProps.set(prop, resolved);
                }
            });
        });
    }
 _animateOptions(target, values) {
        const newOptions = values.options;
        const options = resolveTargetOptions(target, newOptions);
        if (!options) {
            return [];
        }
        const animations = this._createAnimations(options, newOptions);
        if (newOptions.$shared) {
            awaitAll(target.options.$animations, newOptions).then(()=>{
                target.options = newOptions;
            }, ()=>{
            });
        }
        return animations;
    }
 _createAnimations(target, values) {
        const animatedProps = this._properties;
        const animations = [];
        const running = target.$animations || (target.$animations = {});
        const props = Object.keys(values);
        const date = Date.now();
        let i;
        for(i = props.length - 1; i >= 0; --i){
            const prop = props[i];
            if (prop.charAt(0) === '$') {
                continue;
            }
            if (prop === 'options') {
                animations.push(...this._animateOptions(target, values));
                continue;
            }
            const value = values[prop];
            let animation = running[prop];
            const cfg = animatedProps.get(prop);
            if (animation) {
                if (cfg && animation.active()) {
                    animation.update(cfg, value, date);
                    continue;
                } else {
                    animation.cancel();
                }
            }
            if (!cfg || !cfg.duration) {
                target[prop] = value;
                continue;
            }
            running[prop] = animation = new Animation(cfg, target, prop, value);
            animations.push(animation);
        }
        return animations;
    }
 update(target, values) {
        if (this._properties.size === 0) {
            Object.assign(target, values);
            return;
        }
        const animations = this._createAnimations(target, values);
        if (animations.length) {
            animator.add(this._chart, animations);
            return true;
        }
    }
}
function awaitAll(animations, properties) {
    const running = [];
    const keys = Object.keys(properties);
    for(let i = 0; i < keys.length; i++){
        const anim = animations[keys[i]];
        if (anim && anim.active()) {
            running.push(anim.wait());
        }
    }
    return Promise.all(running);
}
function resolveTargetOptions(target, newOptions) {
    if (!newOptions) {
        return;
    }
    let options = target.options;
    if (!options) {
        target.options = newOptions;
        return;
    }
    if (options.$shared) {
        target.options = options = Object.assign({}, options, {
            $shared: false,
            $animations: {}
        });
    }
    return options;
}

function scaleClip(scale, allowedOverflow) {
    const opts = scale && scale.options || {};
    const reverse = opts.reverse;
    const min = opts.min === undefined ? allowedOverflow : 0;
    const max = opts.max === undefined ? allowedOverflow : 0;
    return {
        start: reverse ? max : min,
        end: reverse ? min : max
    };
}
function defaultClip(xScale, yScale, allowedOverflow) {
    if (allowedOverflow === false) {
        return false;
    }
    const x = scaleClip(xScale, allowedOverflow);
    const y = scaleClip(yScale, allowedOverflow);
    return {
        top: y.end,
        right: x.end,
        bottom: y.start,
        left: x.start
    };
}
function toClip(value) {
    let t, r, b, l;
    if (isObject(value)) {
        t = value.top;
        r = value.right;
        b = value.bottom;
        l = value.left;
    } else {
        t = r = b = l = value;
    }
    return {
        top: t,
        right: r,
        bottom: b,
        left: l,
        disabled: value === false
    };
}
function getSortedDatasetIndices(chart, filterVisible) {
    const keys = [];
    const metasets = chart._getSortedDatasetMetas(filterVisible);
    let i, ilen;
    for(i = 0, ilen = metasets.length; i < ilen; ++i){
        keys.push(metasets[i].index);
    }
    return keys;
}
function applyStack(stack, value, dsIndex, options = {}) {
    const keys = stack.keys;
    const singleMode = options.mode === 'single';
    let i, ilen, datasetIndex, otherValue;
    if (value === null) {
        return;
    }
    for(i = 0, ilen = keys.length; i < ilen; ++i){
        datasetIndex = +keys[i];
        if (datasetIndex === dsIndex) {
            if (options.all) {
                continue;
            }
            break;
        }
        otherValue = stack.values[datasetIndex];
        if (isNumberFinite(otherValue) && (singleMode || value === 0 || sign(value) === sign(otherValue))) {
            value += otherValue;
        }
    }
    return value;
}
function convertObjectDataToArray(data) {
    const keys = Object.keys(data);
    const adata = new Array(keys.length);
    let i, ilen, key;
    for(i = 0, ilen = keys.length; i < ilen; ++i){
        key = keys[i];
        adata[i] = {
            x: key,
            y: data[key]
        };
    }
    return adata;
}
function isStacked(scale, meta) {
    const stacked = scale && scale.options.stacked;
    return stacked || stacked === undefined && meta.stack !== undefined;
}
function getStackKey(indexScale, valueScale, meta) {
    return `${indexScale.id}.${valueScale.id}.${meta.stack || meta.type}`;
}
function getUserBounds(scale) {
    const { min , max , minDefined , maxDefined  } = scale.getUserBounds();
    return {
        min: minDefined ? min : Number.NEGATIVE_INFINITY,
        max: maxDefined ? max : Number.POSITIVE_INFINITY
    };
}
function getOrCreateStack(stacks, stackKey, indexValue) {
    const subStack = stacks[stackKey] || (stacks[stackKey] = {});
    return subStack[indexValue] || (subStack[indexValue] = {});
}
function getLastIndexInStack(stack, vScale, positive, type) {
    for (const meta of vScale.getMatchingVisibleMetas(type).reverse()){
        const value = stack[meta.index];
        if (positive && value > 0 || !positive && value < 0) {
            return meta.index;
        }
    }
    return null;
}
function updateStacks(controller, parsed) {
    const { chart , _cachedMeta: meta  } = controller;
    const stacks = chart._stacks || (chart._stacks = {});
    const { iScale , vScale , index: datasetIndex  } = meta;
    const iAxis = iScale.axis;
    const vAxis = vScale.axis;
    const key = getStackKey(iScale, vScale, meta);
    const ilen = parsed.length;
    let stack;
    for(let i = 0; i < ilen; ++i){
        const item = parsed[i];
        const { [iAxis]: index , [vAxis]: value  } = item;
        const itemStacks = item._stacks || (item._stacks = {});
        stack = itemStacks[vAxis] = getOrCreateStack(stacks, key, index);
        stack[datasetIndex] = value;
        stack._top = getLastIndexInStack(stack, vScale, true, meta.type);
        stack._bottom = getLastIndexInStack(stack, vScale, false, meta.type);
        const visualValues = stack._visualValues || (stack._visualValues = {});
        visualValues[datasetIndex] = value;
    }
}
function getFirstScaleId(chart, axis) {
    const scales = chart.scales;
    return Object.keys(scales).filter((key)=>scales[key].axis === axis).shift();
}
function createDatasetContext(parent, index) {
    return createContext(parent, {
        active: false,
        dataset: undefined,
        datasetIndex: index,
        index,
        mode: 'default',
        type: 'dataset'
    });
}
function createDataContext(parent, index, element) {
    return createContext(parent, {
        active: false,
        dataIndex: index,
        parsed: undefined,
        raw: undefined,
        element,
        index,
        mode: 'default',
        type: 'data'
    });
}
function clearStacks(meta, items) {
    const datasetIndex = meta.controller.index;
    const axis = meta.vScale && meta.vScale.axis;
    if (!axis) {
        return;
    }
    items = items || meta._parsed;
    for (const parsed of items){
        const stacks = parsed._stacks;
        if (!stacks || stacks[axis] === undefined || stacks[axis][datasetIndex] === undefined) {
            return;
        }
        delete stacks[axis][datasetIndex];
        if (stacks[axis]._visualValues !== undefined && stacks[axis]._visualValues[datasetIndex] !== undefined) {
            delete stacks[axis]._visualValues[datasetIndex];
        }
    }
}
const isDirectUpdateMode = (mode)=>mode === 'reset' || mode === 'none';
const cloneIfNotShared = (cached, shared)=>shared ? cached : Object.assign({}, cached);
const createStack = (canStack, meta, chart)=>canStack && !meta.hidden && meta._stacked && {
        keys: getSortedDatasetIndices(chart, true),
        values: null
    };
class DatasetController {
 static defaults = {};
 static datasetElementType = null;
 static dataElementType = null;
 constructor(chart, datasetIndex){
        this.chart = chart;
        this._ctx = chart.ctx;
        this.index = datasetIndex;
        this._cachedDataOpts = {};
        this._cachedMeta = this.getMeta();
        this._type = this._cachedMeta.type;
        this.options = undefined;
         this._parsing = false;
        this._data = undefined;
        this._objectData = undefined;
        this._sharedOptions = undefined;
        this._drawStart = undefined;
        this._drawCount = undefined;
        this.enableOptionSharing = false;
        this.supportsDecimation = false;
        this.$context = undefined;
        this._syncList = [];
        this.datasetElementType = new.target.datasetElementType;
        this.dataElementType = new.target.dataElementType;
        this.initialize();
    }
    initialize() {
        const meta = this._cachedMeta;
        this.configure();
        this.linkScales();
        meta._stacked = isStacked(meta.vScale, meta);
        this.addElements();
        if (this.options.fill && !this.chart.isPluginEnabled('filler')) {
            console.warn("Tried to use the 'fill' option without the 'Filler' plugin enabled. Please import and register the 'Filler' plugin and make sure it is not disabled in the options");
        }
    }
    updateIndex(datasetIndex) {
        if (this.index !== datasetIndex) {
            clearStacks(this._cachedMeta);
        }
        this.index = datasetIndex;
    }
    linkScales() {
        const chart = this.chart;
        const meta = this._cachedMeta;
        const dataset = this.getDataset();
        const chooseId = (axis, x, y, r)=>axis === 'x' ? x : axis === 'r' ? r : y;
        const xid = meta.xAxisID = valueOrDefault(dataset.xAxisID, getFirstScaleId(chart, 'x'));
        const yid = meta.yAxisID = valueOrDefault(dataset.yAxisID, getFirstScaleId(chart, 'y'));
        const rid = meta.rAxisID = valueOrDefault(dataset.rAxisID, getFirstScaleId(chart, 'r'));
        const indexAxis = meta.indexAxis;
        const iid = meta.iAxisID = chooseId(indexAxis, xid, yid, rid);
        const vid = meta.vAxisID = chooseId(indexAxis, yid, xid, rid);
        meta.xScale = this.getScaleForId(xid);
        meta.yScale = this.getScaleForId(yid);
        meta.rScale = this.getScaleForId(rid);
        meta.iScale = this.getScaleForId(iid);
        meta.vScale = this.getScaleForId(vid);
    }
    getDataset() {
        return this.chart.data.datasets[this.index];
    }
    getMeta() {
        return this.chart.getDatasetMeta(this.index);
    }
 getScaleForId(scaleID) {
        return this.chart.scales[scaleID];
    }
 _getOtherScale(scale) {
        const meta = this._cachedMeta;
        return scale === meta.iScale ? meta.vScale : meta.iScale;
    }
    reset() {
        this._update('reset');
    }
 _destroy() {
        const meta = this._cachedMeta;
        if (this._data) {
            unlistenArrayEvents(this._data, this);
        }
        if (meta._stacked) {
            clearStacks(meta);
        }
    }
 _dataCheck() {
        const dataset = this.getDataset();
        const data = dataset.data || (dataset.data = []);
        const _data = this._data;
        if (isObject(data)) {
            this._data = convertObjectDataToArray(data);
        } else if (_data !== data) {
            if (_data) {
                unlistenArrayEvents(_data, this);
                const meta = this._cachedMeta;
                clearStacks(meta);
                meta._parsed = [];
            }
            if (data && Object.isExtensible(data)) {
                listenArrayEvents(data, this);
            }
            this._syncList = [];
            this._data = data;
        }
    }
    addElements() {
        const meta = this._cachedMeta;
        this._dataCheck();
        if (this.datasetElementType) {
            meta.dataset = new this.datasetElementType();
        }
    }
    buildOrUpdateElements(resetNewElements) {
        const meta = this._cachedMeta;
        const dataset = this.getDataset();
        let stackChanged = false;
        this._dataCheck();
        const oldStacked = meta._stacked;
        meta._stacked = isStacked(meta.vScale, meta);
        if (meta.stack !== dataset.stack) {
            stackChanged = true;
            clearStacks(meta);
            meta.stack = dataset.stack;
        }
        this._resyncElements(resetNewElements);
        if (stackChanged || oldStacked !== meta._stacked) {
            updateStacks(this, meta._parsed);
        }
    }
 configure() {
        const config = this.chart.config;
        const scopeKeys = config.datasetScopeKeys(this._type);
        const scopes = config.getOptionScopes(this.getDataset(), scopeKeys, true);
        this.options = config.createResolver(scopes, this.getContext());
        this._parsing = this.options.parsing;
        this._cachedDataOpts = {};
    }
 parse(start, count) {
        const { _cachedMeta: meta , _data: data  } = this;
        const { iScale , _stacked  } = meta;
        const iAxis = iScale.axis;
        let sorted = start === 0 && count === data.length ? true : meta._sorted;
        let prev = start > 0 && meta._parsed[start - 1];
        let i, cur, parsed;
        if (this._parsing === false) {
            meta._parsed = data;
            meta._sorted = true;
            parsed = data;
        } else {
            if (isArray(data[start])) {
                parsed = this.parseArrayData(meta, data, start, count);
            } else if (isObject(data[start])) {
                parsed = this.parseObjectData(meta, data, start, count);
            } else {
                parsed = this.parsePrimitiveData(meta, data, start, count);
            }
            const isNotInOrderComparedToPrev = ()=>cur[iAxis] === null || prev && cur[iAxis] < prev[iAxis];
            for(i = 0; i < count; ++i){
                meta._parsed[i + start] = cur = parsed[i];
                if (sorted) {
                    if (isNotInOrderComparedToPrev()) {
                        sorted = false;
                    }
                    prev = cur;
                }
            }
            meta._sorted = sorted;
        }
        if (_stacked) {
            updateStacks(this, parsed);
        }
    }
 parsePrimitiveData(meta, data, start, count) {
        const { iScale , vScale  } = meta;
        const iAxis = iScale.axis;
        const vAxis = vScale.axis;
        const labels = iScale.getLabels();
        const singleScale = iScale === vScale;
        const parsed = new Array(count);
        let i, ilen, index;
        for(i = 0, ilen = count; i < ilen; ++i){
            index = i + start;
            parsed[i] = {
                [iAxis]: singleScale || iScale.parse(labels[index], index),
                [vAxis]: vScale.parse(data[index], index)
            };
        }
        return parsed;
    }
 parseArrayData(meta, data, start, count) {
        const { xScale , yScale  } = meta;
        const parsed = new Array(count);
        let i, ilen, index, item;
        for(i = 0, ilen = count; i < ilen; ++i){
            index = i + start;
            item = data[index];
            parsed[i] = {
                x: xScale.parse(item[0], index),
                y: yScale.parse(item[1], index)
            };
        }
        return parsed;
    }
 parseObjectData(meta, data, start, count) {
        const { xScale , yScale  } = meta;
        const { xAxisKey ='x' , yAxisKey ='y'  } = this._parsing;
        const parsed = new Array(count);
        let i, ilen, index, item;
        for(i = 0, ilen = count; i < ilen; ++i){
            index = i + start;
            item = data[index];
            parsed[i] = {
                x: xScale.parse(resolveObjectKey(item, xAxisKey), index),
                y: yScale.parse(resolveObjectKey(item, yAxisKey), index)
            };
        }
        return parsed;
    }
 getParsed(index) {
        return this._cachedMeta._parsed[index];
    }
 getDataElement(index) {
        return this._cachedMeta.data[index];
    }
 applyStack(scale, parsed, mode) {
        const chart = this.chart;
        const meta = this._cachedMeta;
        const value = parsed[scale.axis];
        const stack = {
            keys: getSortedDatasetIndices(chart, true),
            values: parsed._stacks[scale.axis]._visualValues
        };
        return applyStack(stack, value, meta.index, {
            mode
        });
    }
 updateRangeFromParsed(range, scale, parsed, stack) {
        const parsedValue = parsed[scale.axis];
        let value = parsedValue === null ? NaN : parsedValue;
        const values = stack && parsed._stacks[scale.axis];
        if (stack && values) {
            stack.values = values;
            value = applyStack(stack, parsedValue, this._cachedMeta.index);
        }
        range.min = Math.min(range.min, value);
        range.max = Math.max(range.max, value);
    }
 getMinMax(scale, canStack) {
        const meta = this._cachedMeta;
        const _parsed = meta._parsed;
        const sorted = meta._sorted && scale === meta.iScale;
        const ilen = _parsed.length;
        const otherScale = this._getOtherScale(scale);
        const stack = createStack(canStack, meta, this.chart);
        const range = {
            min: Number.POSITIVE_INFINITY,
            max: Number.NEGATIVE_INFINITY
        };
        const { min: otherMin , max: otherMax  } = getUserBounds(otherScale);
        let i, parsed;
        function _skip() {
            parsed = _parsed[i];
            const otherValue = parsed[otherScale.axis];
            return !isNumberFinite(parsed[scale.axis]) || otherMin > otherValue || otherMax < otherValue;
        }
        for(i = 0; i < ilen; ++i){
            if (_skip()) {
                continue;
            }
            this.updateRangeFromParsed(range, scale, parsed, stack);
            if (sorted) {
                break;
            }
        }
        if (sorted) {
            for(i = ilen - 1; i >= 0; --i){
                if (_skip()) {
                    continue;
                }
                this.updateRangeFromParsed(range, scale, parsed, stack);
                break;
            }
        }
        return range;
    }
    getAllParsedValues(scale) {
        const parsed = this._cachedMeta._parsed;
        const values = [];
        let i, ilen, value;
        for(i = 0, ilen = parsed.length; i < ilen; ++i){
            value = parsed[i][scale.axis];
            if (isNumberFinite(value)) {
                values.push(value);
            }
        }
        return values;
    }
 getMaxOverflow() {
        return false;
    }
 getLabelAndValue(index) {
        const meta = this._cachedMeta;
        const iScale = meta.iScale;
        const vScale = meta.vScale;
        const parsed = this.getParsed(index);
        return {
            label: iScale ? '' + iScale.getLabelForValue(parsed[iScale.axis]) : '',
            value: vScale ? '' + vScale.getLabelForValue(parsed[vScale.axis]) : ''
        };
    }
 _update(mode) {
        const meta = this._cachedMeta;
        this.update(mode || 'default');
        meta._clip = toClip(valueOrDefault(this.options.clip, defaultClip(meta.xScale, meta.yScale, this.getMaxOverflow())));
    }
 update(mode) {}
    draw() {
        const ctx = this._ctx;
        const chart = this.chart;
        const meta = this._cachedMeta;
        const elements = meta.data || [];
        const area = chart.chartArea;
        const active = [];
        const start = this._drawStart || 0;
        const count = this._drawCount || elements.length - start;
        const drawActiveElementsOnTop = this.options.drawActiveElementsOnTop;
        let i;
        if (meta.dataset) {
            meta.dataset.draw(ctx, area, start, count);
        }
        for(i = start; i < start + count; ++i){
            const element = elements[i];
            if (element.hidden) {
                continue;
            }
            if (element.active && drawActiveElementsOnTop) {
                active.push(element);
            } else {
                element.draw(ctx, area);
            }
        }
        for(i = 0; i < active.length; ++i){
            active[i].draw(ctx, area);
        }
    }
 getStyle(index, active) {
        const mode = active ? 'active' : 'default';
        return index === undefined && this._cachedMeta.dataset ? this.resolveDatasetElementOptions(mode) : this.resolveDataElementOptions(index || 0, mode);
    }
 getContext(index, active, mode) {
        const dataset = this.getDataset();
        let context;
        if (index >= 0 && index < this._cachedMeta.data.length) {
            const element = this._cachedMeta.data[index];
            context = element.$context || (element.$context = createDataContext(this.getContext(), index, element));
            context.parsed = this.getParsed(index);
            context.raw = dataset.data[index];
            context.index = context.dataIndex = index;
        } else {
            context = this.$context || (this.$context = createDatasetContext(this.chart.getContext(), this.index));
            context.dataset = dataset;
            context.index = context.datasetIndex = this.index;
        }
        context.active = !!active;
        context.mode = mode;
        return context;
    }
 resolveDatasetElementOptions(mode) {
        return this._resolveElementOptions(this.datasetElementType.id, mode);
    }
 resolveDataElementOptions(index, mode) {
        return this._resolveElementOptions(this.dataElementType.id, mode, index);
    }
 _resolveElementOptions(elementType, mode = 'default', index) {
        const active = mode === 'active';
        const cache = this._cachedDataOpts;
        const cacheKey = elementType + '-' + mode;
        const cached = cache[cacheKey];
        const sharing = this.enableOptionSharing && defined(index);
        if (cached) {
            return cloneIfNotShared(cached, sharing);
        }
        const config = this.chart.config;
        const scopeKeys = config.datasetElementScopeKeys(this._type, elementType);
        const prefixes = active ? [
            `${elementType}Hover`,
            'hover',
            elementType,
            ''
        ] : [
            elementType,
            ''
        ];
        const scopes = config.getOptionScopes(this.getDataset(), scopeKeys);
        const names = Object.keys(defaults.elements[elementType]);
        const context = ()=>this.getContext(index, active, mode);
        const values = config.resolveNamedOptions(scopes, names, context, prefixes);
        if (values.$shared) {
            values.$shared = sharing;
            cache[cacheKey] = Object.freeze(cloneIfNotShared(values, sharing));
        }
        return values;
    }
 _resolveAnimations(index, transition, active) {
        const chart = this.chart;
        const cache = this._cachedDataOpts;
        const cacheKey = `animation-${transition}`;
        const cached = cache[cacheKey];
        if (cached) {
            return cached;
        }
        let options;
        if (chart.options.animation !== false) {
            const config = this.chart.config;
            const scopeKeys = config.datasetAnimationScopeKeys(this._type, transition);
            const scopes = config.getOptionScopes(this.getDataset(), scopeKeys);
            options = config.createResolver(scopes, this.getContext(index, active, transition));
        }
        const animations = new Animations(chart, options && options.animations);
        if (options && options._cacheable) {
            cache[cacheKey] = Object.freeze(animations);
        }
        return animations;
    }
 getSharedOptions(options) {
        if (!options.$shared) {
            return;
        }
        return this._sharedOptions || (this._sharedOptions = Object.assign({}, options));
    }
 includeOptions(mode, sharedOptions) {
        return !sharedOptions || isDirectUpdateMode(mode) || this.chart._animationsDisabled;
    }
 _getSharedOptions(start, mode) {
        const firstOpts = this.resolveDataElementOptions(start, mode);
        const previouslySharedOptions = this._sharedOptions;
        const sharedOptions = this.getSharedOptions(firstOpts);
        const includeOptions = this.includeOptions(mode, sharedOptions) || sharedOptions !== previouslySharedOptions;
        this.updateSharedOptions(sharedOptions, mode, firstOpts);
        return {
            sharedOptions,
            includeOptions
        };
    }
 updateElement(element, index, properties, mode) {
        if (isDirectUpdateMode(mode)) {
            Object.assign(element, properties);
        } else {
            this._resolveAnimations(index, mode).update(element, properties);
        }
    }
 updateSharedOptions(sharedOptions, mode, newOptions) {
        if (sharedOptions && !isDirectUpdateMode(mode)) {
            this._resolveAnimations(undefined, mode).update(sharedOptions, newOptions);
        }
    }
 _setStyle(element, index, mode, active) {
        element.active = active;
        const options = this.getStyle(index, active);
        this._resolveAnimations(index, mode, active).update(element, {
            options: !active && this.getSharedOptions(options) || options
        });
    }
    removeHoverStyle(element, datasetIndex, index) {
        this._setStyle(element, index, 'active', false);
    }
    setHoverStyle(element, datasetIndex, index) {
        this._setStyle(element, index, 'active', true);
    }
 _removeDatasetHoverStyle() {
        const element = this._cachedMeta.dataset;
        if (element) {
            this._setStyle(element, undefined, 'active', false);
        }
    }
 _setDatasetHoverStyle() {
        const element = this._cachedMeta.dataset;
        if (element) {
            this._setStyle(element, undefined, 'active', true);
        }
    }
 _resyncElements(resetNewElements) {
        const data = this._data;
        const elements = this._cachedMeta.data;
        for (const [method, arg1, arg2] of this._syncList){
            this[method](arg1, arg2);
        }
        this._syncList = [];
        const numMeta = elements.length;
        const numData = data.length;
        const count = Math.min(numData, numMeta);
        if (count) {
            this.parse(0, count);
        }
        if (numData > numMeta) {
            this._insertElements(numMeta, numData - numMeta, resetNewElements);
        } else if (numData < numMeta) {
            this._removeElements(numData, numMeta - numData);
        }
    }
 _insertElements(start, count, resetNewElements = true) {
        const meta = this._cachedMeta;
        const data = meta.data;
        const end = start + count;
        let i;
        const move = (arr)=>{
            arr.length += count;
            for(i = arr.length - 1; i >= end; i--){
                arr[i] = arr[i - count];
            }
        };
        move(data);
        for(i = start; i < end; ++i){
            data[i] = new this.dataElementType();
        }
        if (this._parsing) {
            move(meta._parsed);
        }
        this.parse(start, count);
        if (resetNewElements) {
            this.updateElements(data, start, count, 'reset');
        }
    }
    updateElements(element, start, count, mode) {}
 _removeElements(start, count) {
        const meta = this._cachedMeta;
        if (this._parsing) {
            const removed = meta._parsed.splice(start, count);
            if (meta._stacked) {
                clearStacks(meta, removed);
            }
        }
        meta.data.splice(start, count);
    }
 _sync(args) {
        if (this._parsing) {
            this._syncList.push(args);
        } else {
            const [method, arg1, arg2] = args;
            this[method](arg1, arg2);
        }
        this.chart._dataChanges.push([
            this.index,
            ...args
        ]);
    }
    _onDataPush() {
        const count = arguments.length;
        this._sync([
            '_insertElements',
            this.getDataset().data.length - count,
            count
        ]);
    }
    _onDataPop() {
        this._sync([
            '_removeElements',
            this._cachedMeta.data.length - 1,
            1
        ]);
    }
    _onDataShift() {
        this._sync([
            '_removeElements',
            0,
            1
        ]);
    }
    _onDataSplice(start, count) {
        if (count) {
            this._sync([
                '_removeElements',
                start,
                count
            ]);
        }
        const newCount = arguments.length - 2;
        if (newCount) {
            this._sync([
                '_insertElements',
                start,
                newCount
            ]);
        }
    }
    _onDataUnshift() {
        this._sync([
            '_insertElements',
            0,
            arguments.length
        ]);
    }
}

function getAllScaleValues(scale, type) {
    if (!scale._cache.$bar) {
        const visibleMetas = scale.getMatchingVisibleMetas(type);
        let values = [];
        for(let i = 0, ilen = visibleMetas.length; i < ilen; i++){
            values = values.concat(visibleMetas[i].controller.getAllParsedValues(scale));
        }
        scale._cache.$bar = _arrayUnique(values.sort((a, b)=>a - b));
    }
    return scale._cache.$bar;
}
 function computeMinSampleSize(meta) {
    const scale = meta.iScale;
    const values = getAllScaleValues(scale, meta.type);
    let min = scale._length;
    let i, ilen, curr, prev;
    const updateMinAndPrev = ()=>{
        if (curr === 32767 || curr === -32768) {
            return;
        }
        if (defined(prev)) {
            min = Math.min(min, Math.abs(curr - prev) || min);
        }
        prev = curr;
    };
    for(i = 0, ilen = values.length; i < ilen; ++i){
        curr = scale.getPixelForValue(values[i]);
        updateMinAndPrev();
    }
    prev = undefined;
    for(i = 0, ilen = scale.ticks.length; i < ilen; ++i){
        curr = scale.getPixelForTick(i);
        updateMinAndPrev();
    }
    return min;
}
 function computeFitCategoryTraits(index, ruler, options, stackCount) {
    const thickness = options.barThickness;
    let size, ratio;
    if (isNullOrUndef(thickness)) {
        size = ruler.min * options.categoryPercentage;
        ratio = options.barPercentage;
    } else {
        size = thickness * stackCount;
        ratio = 1;
    }
    return {
        chunk: size / stackCount,
        ratio,
        start: ruler.pixels[index] - size / 2
    };
}
 function computeFlexCategoryTraits(index, ruler, options, stackCount) {
    const pixels = ruler.pixels;
    const curr = pixels[index];
    let prev = index > 0 ? pixels[index - 1] : null;
    let next = index < pixels.length - 1 ? pixels[index + 1] : null;
    const percent = options.categoryPercentage;
    if (prev === null) {
        prev = curr - (next === null ? ruler.end - ruler.start : next - curr);
    }
    if (next === null) {
        next = curr + curr - prev;
    }
    const start = curr - (curr - Math.min(prev, next)) / 2 * percent;
    const size = Math.abs(next - prev) / 2 * percent;
    return {
        chunk: size / stackCount,
        ratio: options.barPercentage,
        start
    };
}
function parseFloatBar(entry, item, vScale, i) {
    const startValue = vScale.parse(entry[0], i);
    const endValue = vScale.parse(entry[1], i);
    const min = Math.min(startValue, endValue);
    const max = Math.max(startValue, endValue);
    let barStart = min;
    let barEnd = max;
    if (Math.abs(min) > Math.abs(max)) {
        barStart = max;
        barEnd = min;
    }
    item[vScale.axis] = barEnd;
    item._custom = {
        barStart,
        barEnd,
        start: startValue,
        end: endValue,
        min,
        max
    };
}
function parseValue(entry, item, vScale, i) {
    if (isArray(entry)) {
        parseFloatBar(entry, item, vScale, i);
    } else {
        item[vScale.axis] = vScale.parse(entry, i);
    }
    return item;
}
function parseArrayOrPrimitive(meta, data, start, count) {
    const iScale = meta.iScale;
    const vScale = meta.vScale;
    const labels = iScale.getLabels();
    const singleScale = iScale === vScale;
    const parsed = [];
    let i, ilen, item, entry;
    for(i = start, ilen = start + count; i < ilen; ++i){
        entry = data[i];
        item = {};
        item[iScale.axis] = singleScale || iScale.parse(labels[i], i);
        parsed.push(parseValue(entry, item, vScale, i));
    }
    return parsed;
}
function isFloatBar(custom) {
    return custom && custom.barStart !== undefined && custom.barEnd !== undefined;
}
function barSign(size, vScale, actualBase) {
    if (size !== 0) {
        return sign(size);
    }
    return (vScale.isHorizontal() ? 1 : -1) * (vScale.min >= actualBase ? 1 : -1);
}
function borderProps(properties) {
    let reverse, start, end, top, bottom;
    if (properties.horizontal) {
        reverse = properties.base > properties.x;
        start = 'left';
        end = 'right';
    } else {
        reverse = properties.base < properties.y;
        start = 'bottom';
        end = 'top';
    }
    if (reverse) {
        top = 'end';
        bottom = 'start';
    } else {
        top = 'start';
        bottom = 'end';
    }
    return {
        start,
        end,
        reverse,
        top,
        bottom
    };
}
function setBorderSkipped(properties, options, stack, index) {
    let edge = options.borderSkipped;
    const res = {};
    if (!edge) {
        properties.borderSkipped = res;
        return;
    }
    if (edge === true) {
        properties.borderSkipped = {
            top: true,
            right: true,
            bottom: true,
            left: true
        };
        return;
    }
    const { start , end , reverse , top , bottom  } = borderProps(properties);
    if (edge === 'middle' && stack) {
        properties.enableBorderRadius = true;
        if ((stack._top || 0) === index) {
            edge = top;
        } else if ((stack._bottom || 0) === index) {
            edge = bottom;
        } else {
            res[parseEdge(bottom, start, end, reverse)] = true;
            edge = top;
        }
    }
    res[parseEdge(edge, start, end, reverse)] = true;
    properties.borderSkipped = res;
}
function parseEdge(edge, a, b, reverse) {
    if (reverse) {
        edge = swap(edge, a, b);
        edge = startEnd(edge, b, a);
    } else {
        edge = startEnd(edge, a, b);
    }
    return edge;
}
function swap(orig, v1, v2) {
    return orig === v1 ? v2 : orig === v2 ? v1 : orig;
}
function startEnd(v, start, end) {
    return v === 'start' ? start : v === 'end' ? end : v;
}
function setInflateAmount(properties, { inflateAmount  }, ratio) {
    properties.inflateAmount = inflateAmount === 'auto' ? ratio === 1 ? 0.33 : 0 : inflateAmount;
}
class BarController extends DatasetController {
    static id = 'bar';
 static defaults = {
        datasetElementType: false,
        dataElementType: 'bar',
        categoryPercentage: 0.8,
        barPercentage: 0.9,
        grouped: true,
        animations: {
            numbers: {
                type: 'number',
                properties: [
                    'x',
                    'y',
                    'base',
                    'width',
                    'height'
                ]
            }
        }
    };
 static overrides = {
        scales: {
            _index_: {
                type: 'category',
                offset: true,
                grid: {
                    offset: true
                }
            },
            _value_: {
                type: 'linear',
                beginAtZero: true
            }
        }
    };
 parsePrimitiveData(meta, data, start, count) {
        return parseArrayOrPrimitive(meta, data, start, count);
    }
 parseArrayData(meta, data, start, count) {
        return parseArrayOrPrimitive(meta, data, start, count);
    }
 parseObjectData(meta, data, start, count) {
        const { iScale , vScale  } = meta;
        const { xAxisKey ='x' , yAxisKey ='y'  } = this._parsing;
        const iAxisKey = iScale.axis === 'x' ? xAxisKey : yAxisKey;
        const vAxisKey = vScale.axis === 'x' ? xAxisKey : yAxisKey;
        const parsed = [];
        let i, ilen, item, obj;
        for(i = start, ilen = start + count; i < ilen; ++i){
            obj = data[i];
            item = {};
            item[iScale.axis] = iScale.parse(resolveObjectKey(obj, iAxisKey), i);
            parsed.push(parseValue(resolveObjectKey(obj, vAxisKey), item, vScale, i));
        }
        return parsed;
    }
 updateRangeFromParsed(range, scale, parsed, stack) {
        super.updateRangeFromParsed(range, scale, parsed, stack);
        const custom = parsed._custom;
        if (custom && scale === this._cachedMeta.vScale) {
            range.min = Math.min(range.min, custom.min);
            range.max = Math.max(range.max, custom.max);
        }
    }
 getMaxOverflow() {
        return 0;
    }
 getLabelAndValue(index) {
        const meta = this._cachedMeta;
        const { iScale , vScale  } = meta;
        const parsed = this.getParsed(index);
        const custom = parsed._custom;
        const value = isFloatBar(custom) ? '[' + custom.start + ', ' + custom.end + ']' : '' + vScale.getLabelForValue(parsed[vScale.axis]);
        return {
            label: '' + iScale.getLabelForValue(parsed[iScale.axis]),
            value
        };
    }
    initialize() {
        this.enableOptionSharing = true;
        super.initialize();
        const meta = this._cachedMeta;
        meta.stack = this.getDataset().stack;
    }
    update(mode) {
        const meta = this._cachedMeta;
        this.updateElements(meta.data, 0, meta.data.length, mode);
    }
    updateElements(bars, start, count, mode) {
        const reset = mode === 'reset';
        const { index , _cachedMeta: { vScale  }  } = this;
        const base = vScale.getBasePixel();
        const horizontal = vScale.isHorizontal();
        const ruler = this._getRuler();
        const { sharedOptions , includeOptions  } = this._getSharedOptions(start, mode);
        for(let i = start; i < start + count; i++){
            const parsed = this.getParsed(i);
            const vpixels = reset || isNullOrUndef(parsed[vScale.axis]) ? {
                base,
                head: base
            } : this._calculateBarValuePixels(i);
            const ipixels = this._calculateBarIndexPixels(i, ruler);
            const stack = (parsed._stacks || {})[vScale.axis];
            const properties = {
                horizontal,
                base: vpixels.base,
                enableBorderRadius: !stack || isFloatBar(parsed._custom) || index === stack._top || index === stack._bottom,
                x: horizontal ? vpixels.head : ipixels.center,
                y: horizontal ? ipixels.center : vpixels.head,
                height: horizontal ? ipixels.size : Math.abs(vpixels.size),
                width: horizontal ? Math.abs(vpixels.size) : ipixels.size
            };
            if (includeOptions) {
                properties.options = sharedOptions || this.resolveDataElementOptions(i, bars[i].active ? 'active' : mode);
            }
            const options = properties.options || bars[i].options;
            setBorderSkipped(properties, options, stack, index);
            setInflateAmount(properties, options, ruler.ratio);
            this.updateElement(bars[i], i, properties, mode);
        }
    }
 _getStacks(last, dataIndex) {
        const { iScale  } = this._cachedMeta;
        const metasets = iScale.getMatchingVisibleMetas(this._type).filter((meta)=>meta.controller.options.grouped);
        const stacked = iScale.options.stacked;
        const stacks = [];
        const skipNull = (meta)=>{
            const parsed = meta.controller.getParsed(dataIndex);
            const val = parsed && parsed[meta.vScale.axis];
            if (isNullOrUndef(val) || isNaN(val)) {
                return true;
            }
        };
        for (const meta of metasets){
            if (dataIndex !== undefined && skipNull(meta)) {
                continue;
            }
            if (stacked === false || stacks.indexOf(meta.stack) === -1 || stacked === undefined && meta.stack === undefined) {
                stacks.push(meta.stack);
            }
            if (meta.index === last) {
                break;
            }
        }
        if (!stacks.length) {
            stacks.push(undefined);
        }
        return stacks;
    }
 _getStackCount(index) {
        return this._getStacks(undefined, index).length;
    }
 _getStackIndex(datasetIndex, name, dataIndex) {
        const stacks = this._getStacks(datasetIndex, dataIndex);
        const index = name !== undefined ? stacks.indexOf(name) : -1;
        return index === -1 ? stacks.length - 1 : index;
    }
 _getRuler() {
        const opts = this.options;
        const meta = this._cachedMeta;
        const iScale = meta.iScale;
        const pixels = [];
        let i, ilen;
        for(i = 0, ilen = meta.data.length; i < ilen; ++i){
            pixels.push(iScale.getPixelForValue(this.getParsed(i)[iScale.axis], i));
        }
        const barThickness = opts.barThickness;
        const min = barThickness || computeMinSampleSize(meta);
        return {
            min,
            pixels,
            start: iScale._startPixel,
            end: iScale._endPixel,
            stackCount: this._getStackCount(),
            scale: iScale,
            grouped: opts.grouped,
            ratio: barThickness ? 1 : opts.categoryPercentage * opts.barPercentage
        };
    }
 _calculateBarValuePixels(index) {
        const { _cachedMeta: { vScale , _stacked , index: datasetIndex  } , options: { base: baseValue , minBarLength  }  } = this;
        const actualBase = baseValue || 0;
        const parsed = this.getParsed(index);
        const custom = parsed._custom;
        const floating = isFloatBar(custom);
        let value = parsed[vScale.axis];
        let start = 0;
        let length = _stacked ? this.applyStack(vScale, parsed, _stacked) : value;
        let head, size;
        if (length !== value) {
            start = length - value;
            length = value;
        }
        if (floating) {
            value = custom.barStart;
            length = custom.barEnd - custom.barStart;
            if (value !== 0 && sign(value) !== sign(custom.barEnd)) {
                start = 0;
            }
            start += value;
        }
        const startValue = !isNullOrUndef(baseValue) && !floating ? baseValue : start;
        let base = vScale.getPixelForValue(startValue);
        if (this.chart.getDataVisibility(index)) {
            head = vScale.getPixelForValue(start + length);
        } else {
            head = base;
        }
        size = head - base;
        if (Math.abs(size) < minBarLength) {
            size = barSign(size, vScale, actualBase) * minBarLength;
            if (value === actualBase) {
                base -= size / 2;
            }
            const startPixel = vScale.getPixelForDecimal(0);
            const endPixel = vScale.getPixelForDecimal(1);
            const min = Math.min(startPixel, endPixel);
            const max = Math.max(startPixel, endPixel);
            base = Math.max(Math.min(base, max), min);
            head = base + size;
            if (_stacked && !floating) {
                parsed._stacks[vScale.axis]._visualValues[datasetIndex] = vScale.getValueForPixel(head) - vScale.getValueForPixel(base);
            }
        }
        if (base === vScale.getPixelForValue(actualBase)) {
            const halfGrid = sign(size) * vScale.getLineWidthForValue(actualBase) / 2;
            base += halfGrid;
            size -= halfGrid;
        }
        return {
            size,
            base,
            head,
            center: head + size / 2
        };
    }
 _calculateBarIndexPixels(index, ruler) {
        const scale = ruler.scale;
        const options = this.options;
        const skipNull = options.skipNull;
        const maxBarThickness = valueOrDefault(options.maxBarThickness, Infinity);
        let center, size;
        if (ruler.grouped) {
            const stackCount = skipNull ? this._getStackCount(index) : ruler.stackCount;
            const range = options.barThickness === 'flex' ? computeFlexCategoryTraits(index, ruler, options, stackCount) : computeFitCategoryTraits(index, ruler, options, stackCount);
            const stackIndex = this._getStackIndex(this.index, this._cachedMeta.stack, skipNull ? index : undefined);
            center = range.start + range.chunk * stackIndex + range.chunk / 2;
            size = Math.min(maxBarThickness, range.chunk * range.ratio);
        } else {
            center = scale.getPixelForValue(this.getParsed(index)[scale.axis], index);
            size = Math.min(maxBarThickness, ruler.min * ruler.ratio);
        }
        return {
            base: center - size / 2,
            head: center + size / 2,
            center,
            size
        };
    }
    draw() {
        const meta = this._cachedMeta;
        const vScale = meta.vScale;
        const rects = meta.data;
        const ilen = rects.length;
        let i = 0;
        for(; i < ilen; ++i){
            if (this.getParsed(i)[vScale.axis] !== null) {
                rects[i].draw(this._ctx);
            }
        }
    }
}

class chart_BubbleController extends DatasetController {
    static id = 'bubble';
 static defaults = {
        datasetElementType: false,
        dataElementType: 'point',
        animations: {
            numbers: {
                type: 'number',
                properties: [
                    'x',
                    'y',
                    'borderWidth',
                    'radius'
                ]
            }
        }
    };
 static overrides = {
        scales: {
            x: {
                type: 'linear'
            },
            y: {
                type: 'linear'
            }
        }
    };
    initialize() {
        this.enableOptionSharing = true;
        super.initialize();
    }
 parsePrimitiveData(meta, data, start, count) {
        const parsed = super.parsePrimitiveData(meta, data, start, count);
        for(let i = 0; i < parsed.length; i++){
            parsed[i]._custom = this.resolveDataElementOptions(i + start).radius;
        }
        return parsed;
    }
 parseArrayData(meta, data, start, count) {
        const parsed = super.parseArrayData(meta, data, start, count);
        for(let i = 0; i < parsed.length; i++){
            const item = data[start + i];
            parsed[i]._custom = valueOrDefault(item[2], this.resolveDataElementOptions(i + start).radius);
        }
        return parsed;
    }
 parseObjectData(meta, data, start, count) {
        const parsed = super.parseObjectData(meta, data, start, count);
        for(let i = 0; i < parsed.length; i++){
            const item = data[start + i];
            parsed[i]._custom = valueOrDefault(item && item.r && +item.r, this.resolveDataElementOptions(i + start).radius);
        }
        return parsed;
    }
 getMaxOverflow() {
        const data = this._cachedMeta.data;
        let max = 0;
        for(let i = data.length - 1; i >= 0; --i){
            max = Math.max(max, data[i].size(this.resolveDataElementOptions(i)) / 2);
        }
        return max > 0 && max;
    }
 getLabelAndValue(index) {
        const meta = this._cachedMeta;
        const labels = this.chart.data.labels || [];
        const { xScale , yScale  } = meta;
        const parsed = this.getParsed(index);
        const x = xScale.getLabelForValue(parsed.x);
        const y = yScale.getLabelForValue(parsed.y);
        const r = parsed._custom;
        return {
            label: labels[index] || '',
            value: '(' + x + ', ' + y + (r ? ', ' + r : '') + ')'
        };
    }
    update(mode) {
        const points = this._cachedMeta.data;
        this.updateElements(points, 0, points.length, mode);
    }
    updateElements(points, start, count, mode) {
        const reset = mode === 'reset';
        const { iScale , vScale  } = this._cachedMeta;
        const { sharedOptions , includeOptions  } = this._getSharedOptions(start, mode);
        const iAxis = iScale.axis;
        const vAxis = vScale.axis;
        for(let i = start; i < start + count; i++){
            const point = points[i];
            const parsed = !reset && this.getParsed(i);
            const properties = {};
            const iPixel = properties[iAxis] = reset ? iScale.getPixelForDecimal(0.5) : iScale.getPixelForValue(parsed[iAxis]);
            const vPixel = properties[vAxis] = reset ? vScale.getBasePixel() : vScale.getPixelForValue(parsed[vAxis]);
            properties.skip = isNaN(iPixel) || isNaN(vPixel);
            if (includeOptions) {
                properties.options = sharedOptions || this.resolveDataElementOptions(i, point.active ? 'active' : mode);
                if (reset) {
                    properties.options.radius = 0;
                }
            }
            this.updateElement(point, i, properties, mode);
        }
    }
 resolveDataElementOptions(index, mode) {
        const parsed = this.getParsed(index);
        let values = super.resolveDataElementOptions(index, mode);
        if (values.$shared) {
            values = Object.assign({}, values, {
                $shared: false
            });
        }
        const radius = values.radius;
        if (mode !== 'active') {
            values.radius = 0;
        }
        values.radius += valueOrDefault(parsed && parsed._custom, radius);
        return values;
    }
}

function getRatioAndOffset(rotation, circumference, cutout) {
    let ratioX = 1;
    let ratioY = 1;
    let offsetX = 0;
    let offsetY = 0;
    if (circumference < TAU) {
        const startAngle = rotation;
        const endAngle = startAngle + circumference;
        const startX = Math.cos(startAngle);
        const startY = Math.sin(startAngle);
        const endX = Math.cos(endAngle);
        const endY = Math.sin(endAngle);
        const calcMax = (angle, a, b)=>_angleBetween(angle, startAngle, endAngle, true) ? 1 : Math.max(a, a * cutout, b, b * cutout);
        const calcMin = (angle, a, b)=>_angleBetween(angle, startAngle, endAngle, true) ? -1 : Math.min(a, a * cutout, b, b * cutout);
        const maxX = calcMax(0, startX, endX);
        const maxY = calcMax(HALF_PI, startY, endY);
        const minX = calcMin(PI, startX, endX);
        const minY = calcMin(PI + HALF_PI, startY, endY);
        ratioX = (maxX - minX) / 2;
        ratioY = (maxY - minY) / 2;
        offsetX = -(maxX + minX) / 2;
        offsetY = -(maxY + minY) / 2;
    }
    return {
        ratioX,
        ratioY,
        offsetX,
        offsetY
    };
}
class chart_DoughnutController extends DatasetController {
    static id = 'doughnut';
 static defaults = {
        datasetElementType: false,
        dataElementType: 'arc',
        animation: {
            animateRotate: true,
            animateScale: false
        },
        animations: {
            numbers: {
                type: 'number',
                properties: [
                    'circumference',
                    'endAngle',
                    'innerRadius',
                    'outerRadius',
                    'startAngle',
                    'x',
                    'y',
                    'offset',
                    'borderWidth',
                    'spacing'
                ]
            }
        },
        cutout: '50%',
        rotation: 0,
        circumference: 360,
        radius: '100%',
        spacing: 0,
        indexAxis: 'r'
    };
    static descriptors = {
        _scriptable: (name)=>name !== 'spacing',
        _indexable: (name)=>name !== 'spacing' && !name.startsWith('borderDash') && !name.startsWith('hoverBorderDash')
    };
 static overrides = {
        aspectRatio: 1,
        plugins: {
            legend: {
                labels: {
                    generateLabels (chart) {
                        const data = chart.data;
                        if (data.labels.length && data.datasets.length) {
                            const { labels: { pointStyle , color  }  } = chart.legend.options;
                            return data.labels.map((label, i)=>{
                                const meta = chart.getDatasetMeta(0);
                                const style = meta.controller.getStyle(i);
                                return {
                                    text: label,
                                    fillStyle: style.backgroundColor,
                                    strokeStyle: style.borderColor,
                                    fontColor: color,
                                    lineWidth: style.borderWidth,
                                    pointStyle: pointStyle,
                                    hidden: !chart.getDataVisibility(i),
                                    index: i
                                };
                            });
                        }
                        return [];
                    }
                },
                onClick (e, legendItem, legend) {
                    legend.chart.toggleDataVisibility(legendItem.index);
                    legend.chart.update();
                }
            }
        }
    };
    constructor(chart, datasetIndex){
        super(chart, datasetIndex);
        this.enableOptionSharing = true;
        this.innerRadius = undefined;
        this.outerRadius = undefined;
        this.offsetX = undefined;
        this.offsetY = undefined;
    }
    linkScales() {}
 parse(start, count) {
        const data = this.getDataset().data;
        const meta = this._cachedMeta;
        if (this._parsing === false) {
            meta._parsed = data;
        } else {
            let getter = (i)=>+data[i];
            if (isObject(data[start])) {
                const { key ='value'  } = this._parsing;
                getter = (i)=>+resolveObjectKey(data[i], key);
            }
            let i, ilen;
            for(i = start, ilen = start + count; i < ilen; ++i){
                meta._parsed[i] = getter(i);
            }
        }
    }
 _getRotation() {
        return toRadians(this.options.rotation - 90);
    }
 _getCircumference() {
        return toRadians(this.options.circumference);
    }
 _getRotationExtents() {
        let min = TAU;
        let max = -TAU;
        for(let i = 0; i < this.chart.data.datasets.length; ++i){
            if (this.chart.isDatasetVisible(i) && this.chart.getDatasetMeta(i).type === this._type) {
                const controller = this.chart.getDatasetMeta(i).controller;
                const rotation = controller._getRotation();
                const circumference = controller._getCircumference();
                min = Math.min(min, rotation);
                max = Math.max(max, rotation + circumference);
            }
        }
        return {
            rotation: min,
            circumference: max - min
        };
    }
 update(mode) {
        const chart = this.chart;
        const { chartArea  } = chart;
        const meta = this._cachedMeta;
        const arcs = meta.data;
        const spacing = this.getMaxBorderWidth() + this.getMaxOffset(arcs) + this.options.spacing;
        const maxSize = Math.max((Math.min(chartArea.width, chartArea.height) - spacing) / 2, 0);
        const cutout = Math.min(toPercentage(this.options.cutout, maxSize), 1);
        const chartWeight = this._getRingWeight(this.index);
        const { circumference , rotation  } = this._getRotationExtents();
        const { ratioX , ratioY , offsetX , offsetY  } = getRatioAndOffset(rotation, circumference, cutout);
        const maxWidth = (chartArea.width - spacing) / ratioX;
        const maxHeight = (chartArea.height - spacing) / ratioY;
        const maxRadius = Math.max(Math.min(maxWidth, maxHeight) / 2, 0);
        const outerRadius = toDimension(this.options.radius, maxRadius);
        const innerRadius = Math.max(outerRadius * cutout, 0);
        const radiusLength = (outerRadius - innerRadius) / this._getVisibleDatasetWeightTotal();
        this.offsetX = offsetX * outerRadius;
        this.offsetY = offsetY * outerRadius;
        meta.total = this.calculateTotal();
        this.outerRadius = outerRadius - radiusLength * this._getRingWeightOffset(this.index);
        this.innerRadius = Math.max(this.outerRadius - radiusLength * chartWeight, 0);
        this.updateElements(arcs, 0, arcs.length, mode);
    }
 _circumference(i, reset) {
        const opts = this.options;
        const meta = this._cachedMeta;
        const circumference = this._getCircumference();
        if (reset && opts.animation.animateRotate || !this.chart.getDataVisibility(i) || meta._parsed[i] === null || meta.data[i].hidden) {
            return 0;
        }
        return this.calculateCircumference(meta._parsed[i] * circumference / TAU);
    }
    updateElements(arcs, start, count, mode) {
        const reset = mode === 'reset';
        const chart = this.chart;
        const chartArea = chart.chartArea;
        const opts = chart.options;
        const animationOpts = opts.animation;
        const centerX = (chartArea.left + chartArea.right) / 2;
        const centerY = (chartArea.top + chartArea.bottom) / 2;
        const animateScale = reset && animationOpts.animateScale;
        const innerRadius = animateScale ? 0 : this.innerRadius;
        const outerRadius = animateScale ? 0 : this.outerRadius;
        const { sharedOptions , includeOptions  } = this._getSharedOptions(start, mode);
        let startAngle = this._getRotation();
        let i;
        for(i = 0; i < start; ++i){
            startAngle += this._circumference(i, reset);
        }
        for(i = start; i < start + count; ++i){
            const circumference = this._circumference(i, reset);
            const arc = arcs[i];
            const properties = {
                x: centerX + this.offsetX,
                y: centerY + this.offsetY,
                startAngle,
                endAngle: startAngle + circumference,
                circumference,
                outerRadius,
                innerRadius
            };
            if (includeOptions) {
                properties.options = sharedOptions || this.resolveDataElementOptions(i, arc.active ? 'active' : mode);
            }
            startAngle += circumference;
            this.updateElement(arc, i, properties, mode);
        }
    }
    calculateTotal() {
        const meta = this._cachedMeta;
        const metaData = meta.data;
        let total = 0;
        let i;
        for(i = 0; i < metaData.length; i++){
            const value = meta._parsed[i];
            if (value !== null && !isNaN(value) && this.chart.getDataVisibility(i) && !metaData[i].hidden) {
                total += Math.abs(value);
            }
        }
        return total;
    }
    calculateCircumference(value) {
        const total = this._cachedMeta.total;
        if (total > 0 && !isNaN(value)) {
            return TAU * (Math.abs(value) / total);
        }
        return 0;
    }
    getLabelAndValue(index) {
        const meta = this._cachedMeta;
        const chart = this.chart;
        const labels = chart.data.labels || [];
        const value = formatNumber(meta._parsed[index], chart.options.locale);
        return {
            label: labels[index] || '',
            value
        };
    }
    getMaxBorderWidth(arcs) {
        let max = 0;
        const chart = this.chart;
        let i, ilen, meta, controller, options;
        if (!arcs) {
            for(i = 0, ilen = chart.data.datasets.length; i < ilen; ++i){
                if (chart.isDatasetVisible(i)) {
                    meta = chart.getDatasetMeta(i);
                    arcs = meta.data;
                    controller = meta.controller;
                    break;
                }
            }
        }
        if (!arcs) {
            return 0;
        }
        for(i = 0, ilen = arcs.length; i < ilen; ++i){
            options = controller.resolveDataElementOptions(i);
            if (options.borderAlign !== 'inner') {
                max = Math.max(max, options.borderWidth || 0, options.hoverBorderWidth || 0);
            }
        }
        return max;
    }
    getMaxOffset(arcs) {
        let max = 0;
        for(let i = 0, ilen = arcs.length; i < ilen; ++i){
            const options = this.resolveDataElementOptions(i);
            max = Math.max(max, options.offset || 0, options.hoverOffset || 0);
        }
        return max;
    }
 _getRingWeightOffset(datasetIndex) {
        let ringWeightOffset = 0;
        for(let i = 0; i < datasetIndex; ++i){
            if (this.chart.isDatasetVisible(i)) {
                ringWeightOffset += this._getRingWeight(i);
            }
        }
        return ringWeightOffset;
    }
 _getRingWeight(datasetIndex) {
        return Math.max(valueOrDefault(this.chart.data.datasets[datasetIndex].weight, 1), 0);
    }
 _getVisibleDatasetWeightTotal() {
        return this._getRingWeightOffset(this.chart.data.datasets.length) || 1;
    }
}

class chart_LineController extends DatasetController {
    static id = 'line';
 static defaults = {
        datasetElementType: 'line',
        dataElementType: 'point',
        showLine: true,
        spanGaps: false
    };
 static overrides = {
        scales: {
            _index_: {
                type: 'category'
            },
            _value_: {
                type: 'linear'
            }
        }
    };
    initialize() {
        this.enableOptionSharing = true;
        this.supportsDecimation = true;
        super.initialize();
    }
    update(mode) {
        const meta = this._cachedMeta;
        const { dataset: line , data: points = [] , _dataset  } = meta;
        const animationsDisabled = this.chart._animationsDisabled;
        let { start , count  } = _getStartAndCountOfVisiblePoints(meta, points, animationsDisabled);
        this._drawStart = start;
        this._drawCount = count;
        if (_scaleRangesChanged(meta)) {
            start = 0;
            count = points.length;
        }
        line._chart = this.chart;
        line._datasetIndex = this.index;
        line._decimated = !!_dataset._decimated;
        line.points = points;
        const options = this.resolveDatasetElementOptions(mode);
        if (!this.options.showLine) {
            options.borderWidth = 0;
        }
        options.segment = this.options.segment;
        this.updateElement(line, undefined, {
            animated: !animationsDisabled,
            options
        }, mode);
        this.updateElements(points, start, count, mode);
    }
    updateElements(points, start, count, mode) {
        const reset = mode === 'reset';
        const { iScale , vScale , _stacked , _dataset  } = this._cachedMeta;
        const { sharedOptions , includeOptions  } = this._getSharedOptions(start, mode);
        const iAxis = iScale.axis;
        const vAxis = vScale.axis;
        const { spanGaps , segment  } = this.options;
        const maxGapLength = isNumber(spanGaps) ? spanGaps : Number.POSITIVE_INFINITY;
        const directUpdate = this.chart._animationsDisabled || reset || mode === 'none';
        const end = start + count;
        const pointsCount = points.length;
        let prevParsed = start > 0 && this.getParsed(start - 1);
        for(let i = 0; i < pointsCount; ++i){
            const point = points[i];
            const properties = directUpdate ? point : {};
            if (i < start || i >= end) {
                properties.skip = true;
                continue;
            }
            const parsed = this.getParsed(i);
            const nullData = isNullOrUndef(parsed[vAxis]);
            const iPixel = properties[iAxis] = iScale.getPixelForValue(parsed[iAxis], i);
            const vPixel = properties[vAxis] = reset || nullData ? vScale.getBasePixel() : vScale.getPixelForValue(_stacked ? this.applyStack(vScale, parsed, _stacked) : parsed[vAxis], i);
            properties.skip = isNaN(iPixel) || isNaN(vPixel) || nullData;
            properties.stop = i > 0 && Math.abs(parsed[iAxis] - prevParsed[iAxis]) > maxGapLength;
            if (segment) {
                properties.parsed = parsed;
                properties.raw = _dataset.data[i];
            }
            if (includeOptions) {
                properties.options = sharedOptions || this.resolveDataElementOptions(i, point.active ? 'active' : mode);
            }
            if (!directUpdate) {
                this.updateElement(point, i, properties, mode);
            }
            prevParsed = parsed;
        }
    }
 getMaxOverflow() {
        const meta = this._cachedMeta;
        const dataset = meta.dataset;
        const border = dataset.options && dataset.options.borderWidth || 0;
        const data = meta.data || [];
        if (!data.length) {
            return border;
        }
        const firstPoint = data[0].size(this.resolveDataElementOptions(0));
        const lastPoint = data[data.length - 1].size(this.resolveDataElementOptions(data.length - 1));
        return Math.max(border, firstPoint, lastPoint) / 2;
    }
    draw() {
        const meta = this._cachedMeta;
        meta.dataset.updateControlPoints(this.chart.chartArea, meta.iScale.axis);
        super.draw();
    }
}

class chart_PolarAreaController extends DatasetController {
    static id = 'polarArea';
 static defaults = {
        dataElementType: 'arc',
        animation: {
            animateRotate: true,
            animateScale: true
        },
        animations: {
            numbers: {
                type: 'number',
                properties: [
                    'x',
                    'y',
                    'startAngle',
                    'endAngle',
                    'innerRadius',
                    'outerRadius'
                ]
            }
        },
        indexAxis: 'r',
        startAngle: 0
    };
 static overrides = {
        aspectRatio: 1,
        plugins: {
            legend: {
                labels: {
                    generateLabels (chart) {
                        const data = chart.data;
                        if (data.labels.length && data.datasets.length) {
                            const { labels: { pointStyle , color  }  } = chart.legend.options;
                            return data.labels.map((label, i)=>{
                                const meta = chart.getDatasetMeta(0);
                                const style = meta.controller.getStyle(i);
                                return {
                                    text: label,
                                    fillStyle: style.backgroundColor,
                                    strokeStyle: style.borderColor,
                                    fontColor: color,
                                    lineWidth: style.borderWidth,
                                    pointStyle: pointStyle,
                                    hidden: !chart.getDataVisibility(i),
                                    index: i
                                };
                            });
                        }
                        return [];
                    }
                },
                onClick (e, legendItem, legend) {
                    legend.chart.toggleDataVisibility(legendItem.index);
                    legend.chart.update();
                }
            }
        },
        scales: {
            r: {
                type: 'radialLinear',
                angleLines: {
                    display: false
                },
                beginAtZero: true,
                grid: {
                    circular: true
                },
                pointLabels: {
                    display: false
                },
                startAngle: 0
            }
        }
    };
    constructor(chart, datasetIndex){
        super(chart, datasetIndex);
        this.innerRadius = undefined;
        this.outerRadius = undefined;
    }
    getLabelAndValue(index) {
        const meta = this._cachedMeta;
        const chart = this.chart;
        const labels = chart.data.labels || [];
        const value = formatNumber(meta._parsed[index].r, chart.options.locale);
        return {
            label: labels[index] || '',
            value
        };
    }
    parseObjectData(meta, data, start, count) {
        return _parseObjectDataRadialScale.bind(this)(meta, data, start, count);
    }
    update(mode) {
        const arcs = this._cachedMeta.data;
        this._updateRadius();
        this.updateElements(arcs, 0, arcs.length, mode);
    }
 getMinMax() {
        const meta = this._cachedMeta;
        const range = {
            min: Number.POSITIVE_INFINITY,
            max: Number.NEGATIVE_INFINITY
        };
        meta.data.forEach((element, index)=>{
            const parsed = this.getParsed(index).r;
            if (!isNaN(parsed) && this.chart.getDataVisibility(index)) {
                if (parsed < range.min) {
                    range.min = parsed;
                }
                if (parsed > range.max) {
                    range.max = parsed;
                }
            }
        });
        return range;
    }
 _updateRadius() {
        const chart = this.chart;
        const chartArea = chart.chartArea;
        const opts = chart.options;
        const minSize = Math.min(chartArea.right - chartArea.left, chartArea.bottom - chartArea.top);
        const outerRadius = Math.max(minSize / 2, 0);
        const innerRadius = Math.max(opts.cutoutPercentage ? outerRadius / 100 * opts.cutoutPercentage : 1, 0);
        const radiusLength = (outerRadius - innerRadius) / chart.getVisibleDatasetCount();
        this.outerRadius = outerRadius - radiusLength * this.index;
        this.innerRadius = this.outerRadius - radiusLength;
    }
    updateElements(arcs, start, count, mode) {
        const reset = mode === 'reset';
        const chart = this.chart;
        const opts = chart.options;
        const animationOpts = opts.animation;
        const scale = this._cachedMeta.rScale;
        const centerX = scale.xCenter;
        const centerY = scale.yCenter;
        const datasetStartAngle = scale.getIndexAngle(0) - 0.5 * PI;
        let angle = datasetStartAngle;
        let i;
        const defaultAngle = 360 / this.countVisibleElements();
        for(i = 0; i < start; ++i){
            angle += this._computeAngle(i, mode, defaultAngle);
        }
        for(i = start; i < start + count; i++){
            const arc = arcs[i];
            let startAngle = angle;
            let endAngle = angle + this._computeAngle(i, mode, defaultAngle);
            let outerRadius = chart.getDataVisibility(i) ? scale.getDistanceFromCenterForValue(this.getParsed(i).r) : 0;
            angle = endAngle;
            if (reset) {
                if (animationOpts.animateScale) {
                    outerRadius = 0;
                }
                if (animationOpts.animateRotate) {
                    startAngle = endAngle = datasetStartAngle;
                }
            }
            const properties = {
                x: centerX,
                y: centerY,
                innerRadius: 0,
                outerRadius,
                startAngle,
                endAngle,
                options: this.resolveDataElementOptions(i, arc.active ? 'active' : mode)
            };
            this.updateElement(arc, i, properties, mode);
        }
    }
    countVisibleElements() {
        const meta = this._cachedMeta;
        let count = 0;
        meta.data.forEach((element, index)=>{
            if (!isNaN(this.getParsed(index).r) && this.chart.getDataVisibility(index)) {
                count++;
            }
        });
        return count;
    }
 _computeAngle(index, mode, defaultAngle) {
        return this.chart.getDataVisibility(index) ? toRadians(this.resolveDataElementOptions(index, mode).angle || defaultAngle) : 0;
    }
}

class chart_PieController extends chart_DoughnutController {
    static id = 'pie';
 static defaults = {
        cutout: 0,
        rotation: 0,
        circumference: 360,
        radius: '100%'
    };
}

class chart_RadarController extends DatasetController {
    static id = 'radar';
 static defaults = {
        datasetElementType: 'line',
        dataElementType: 'point',
        indexAxis: 'r',
        showLine: true,
        elements: {
            line: {
                fill: 'start'
            }
        }
    };
 static overrides = {
        aspectRatio: 1,
        scales: {
            r: {
                type: 'radialLinear'
            }
        }
    };
 getLabelAndValue(index) {
        const vScale = this._cachedMeta.vScale;
        const parsed = this.getParsed(index);
        return {
            label: vScale.getLabels()[index],
            value: '' + vScale.getLabelForValue(parsed[vScale.axis])
        };
    }
    parseObjectData(meta, data, start, count) {
        return _parseObjectDataRadialScale.bind(this)(meta, data, start, count);
    }
    update(mode) {
        const meta = this._cachedMeta;
        const line = meta.dataset;
        const points = meta.data || [];
        const labels = meta.iScale.getLabels();
        line.points = points;
        if (mode !== 'resize') {
            const options = this.resolveDatasetElementOptions(mode);
            if (!this.options.showLine) {
                options.borderWidth = 0;
            }
            const properties = {
                _loop: true,
                _fullLoop: labels.length === points.length,
                options
            };
            this.updateElement(line, undefined, properties, mode);
        }
        this.updateElements(points, 0, points.length, mode);
    }
    updateElements(points, start, count, mode) {
        const scale = this._cachedMeta.rScale;
        const reset = mode === 'reset';
        for(let i = start; i < start + count; i++){
            const point = points[i];
            const options = this.resolveDataElementOptions(i, point.active ? 'active' : mode);
            const pointPosition = scale.getPointPositionForValue(i, this.getParsed(i).r);
            const x = reset ? scale.xCenter : pointPosition.x;
            const y = reset ? scale.yCenter : pointPosition.y;
            const properties = {
                x,
                y,
                angle: pointPosition.angle,
                skip: isNaN(x) || isNaN(y),
                options
            };
            this.updateElement(point, i, properties, mode);
        }
    }
}

class chart_ScatterController extends DatasetController {
    static id = 'scatter';
 static defaults = {
        datasetElementType: false,
        dataElementType: 'point',
        showLine: false,
        fill: false
    };
 static overrides = {
        interaction: {
            mode: 'point'
        },
        scales: {
            x: {
                type: 'linear'
            },
            y: {
                type: 'linear'
            }
        }
    };
 getLabelAndValue(index) {
        const meta = this._cachedMeta;
        const labels = this.chart.data.labels || [];
        const { xScale , yScale  } = meta;
        const parsed = this.getParsed(index);
        const x = xScale.getLabelForValue(parsed.x);
        const y = yScale.getLabelForValue(parsed.y);
        return {
            label: labels[index] || '',
            value: '(' + x + ', ' + y + ')'
        };
    }
    update(mode) {
        const meta = this._cachedMeta;
        const { data: points = []  } = meta;
        const animationsDisabled = this.chart._animationsDisabled;
        let { start , count  } = _getStartAndCountOfVisiblePoints(meta, points, animationsDisabled);
        this._drawStart = start;
        this._drawCount = count;
        if (_scaleRangesChanged(meta)) {
            start = 0;
            count = points.length;
        }
        if (this.options.showLine) {
            if (!this.datasetElementType) {
                this.addElements();
            }
            const { dataset: line , _dataset  } = meta;
            line._chart = this.chart;
            line._datasetIndex = this.index;
            line._decimated = !!_dataset._decimated;
            line.points = points;
            const options = this.resolveDatasetElementOptions(mode);
            options.segment = this.options.segment;
            this.updateElement(line, undefined, {
                animated: !animationsDisabled,
                options
            }, mode);
        } else if (this.datasetElementType) {
            delete meta.dataset;
            this.datasetElementType = false;
        }
        this.updateElements(points, start, count, mode);
    }
    addElements() {
        const { showLine  } = this.options;
        if (!this.datasetElementType && showLine) {
            this.datasetElementType = this.chart.registry.getElement('line');
        }
        super.addElements();
    }
    updateElements(points, start, count, mode) {
        const reset = mode === 'reset';
        const { iScale , vScale , _stacked , _dataset  } = this._cachedMeta;
        const firstOpts = this.resolveDataElementOptions(start, mode);
        const sharedOptions = this.getSharedOptions(firstOpts);
        const includeOptions = this.includeOptions(mode, sharedOptions);
        const iAxis = iScale.axis;
        const vAxis = vScale.axis;
        const { spanGaps , segment  } = this.options;
        const maxGapLength = isNumber(spanGaps) ? spanGaps : Number.POSITIVE_INFINITY;
        const directUpdate = this.chart._animationsDisabled || reset || mode === 'none';
        let prevParsed = start > 0 && this.getParsed(start - 1);
        for(let i = start; i < start + count; ++i){
            const point = points[i];
            const parsed = this.getParsed(i);
            const properties = directUpdate ? point : {};
            const nullData = isNullOrUndef(parsed[vAxis]);
            const iPixel = properties[iAxis] = iScale.getPixelForValue(parsed[iAxis], i);
            const vPixel = properties[vAxis] = reset || nullData ? vScale.getBasePixel() : vScale.getPixelForValue(_stacked ? this.applyStack(vScale, parsed, _stacked) : parsed[vAxis], i);
            properties.skip = isNaN(iPixel) || isNaN(vPixel) || nullData;
            properties.stop = i > 0 && Math.abs(parsed[iAxis] - prevParsed[iAxis]) > maxGapLength;
            if (segment) {
                properties.parsed = parsed;
                properties.raw = _dataset.data[i];
            }
            if (includeOptions) {
                properties.options = sharedOptions || this.resolveDataElementOptions(i, point.active ? 'active' : mode);
            }
            if (!directUpdate) {
                this.updateElement(point, i, properties, mode);
            }
            prevParsed = parsed;
        }
        this.updateSharedOptions(sharedOptions, mode, firstOpts);
    }
 getMaxOverflow() {
        const meta = this._cachedMeta;
        const data = meta.data || [];
        if (!this.options.showLine) {
            let max = 0;
            for(let i = data.length - 1; i >= 0; --i){
                max = Math.max(max, data[i].size(this.resolveDataElementOptions(i)) / 2);
            }
            return max > 0 && max;
        }
        const dataset = meta.dataset;
        const border = dataset.options && dataset.options.borderWidth || 0;
        if (!data.length) {
            return border;
        }
        const firstPoint = data[0].size(this.resolveDataElementOptions(0));
        const lastPoint = data[data.length - 1].size(this.resolveDataElementOptions(data.length - 1));
        return Math.max(border, firstPoint, lastPoint) / 2;
    }
}

var controllers = /*#__PURE__*/Object.freeze({
__proto__: null,
BarController: BarController,
BubbleController: chart_BubbleController,
DoughnutController: chart_DoughnutController,
LineController: chart_LineController,
PieController: chart_PieController,
PolarAreaController: chart_PolarAreaController,
RadarController: chart_RadarController,
ScatterController: chart_ScatterController
});

/**
 * @namespace Chart._adapters
 * @since 2.8.0
 * @private
 */ function chart_abstract() {
    throw new Error('This method is not implemented: Check that a complete date adapter is provided.');
}
/**
 * Date adapter (current used by the time scale)
 * @namespace Chart._adapters._date
 * @memberof Chart._adapters
 * @private
 */ class DateAdapterBase {
    /**
   * Override default date adapter methods.
   * Accepts type parameter to define options type.
   * @example
   * Chart._adapters._date.override<{myAdapterOption: string}>({
   *   init() {
   *     console.log(this.options.myAdapterOption);
   *   }
   * })
   */ static override(members) {
        Object.assign(DateAdapterBase.prototype, members);
    }
    options;
    constructor(options){
        this.options = options || {};
    }
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    init() {}
    formats() {
        return chart_abstract();
    }
    parse() {
        return chart_abstract();
    }
    format() {
        return chart_abstract();
    }
    add() {
        return chart_abstract();
    }
    diff() {
        return chart_abstract();
    }
    startOf() {
        return chart_abstract();
    }
    endOf() {
        return chart_abstract();
    }
}
var adapters = {
    _date: DateAdapterBase
};

function binarySearch(metaset, axis, value, intersect) {
    const { controller , data , _sorted  } = metaset;
    const iScale = controller._cachedMeta.iScale;
    if (iScale && axis === iScale.axis && axis !== 'r' && _sorted && data.length) {
        const lookupMethod = iScale._reversePixels ? _rlookupByKey : _lookupByKey;
        if (!intersect) {
            return lookupMethod(data, axis, value);
        } else if (controller._sharedOptions) {
            const el = data[0];
            const range = typeof el.getRange === 'function' && el.getRange(axis);
            if (range) {
                const start = lookupMethod(data, axis, value - range);
                const end = lookupMethod(data, axis, value + range);
                return {
                    lo: start.lo,
                    hi: end.hi
                };
            }
        }
    }
    return {
        lo: 0,
        hi: data.length - 1
    };
}
 function evaluateInteractionItems(chart, axis, position, handler, intersect) {
    const metasets = chart.getSortedVisibleDatasetMetas();
    const value = position[axis];
    for(let i = 0, ilen = metasets.length; i < ilen; ++i){
        const { index , data  } = metasets[i];
        const { lo , hi  } = binarySearch(metasets[i], axis, value, intersect);
        for(let j = lo; j <= hi; ++j){
            const element = data[j];
            if (!element.skip) {
                handler(element, index, j);
            }
        }
    }
}
 function getDistanceMetricForAxis(axis) {
    const useX = axis.indexOf('x') !== -1;
    const useY = axis.indexOf('y') !== -1;
    return function(pt1, pt2) {
        const deltaX = useX ? Math.abs(pt1.x - pt2.x) : 0;
        const deltaY = useY ? Math.abs(pt1.y - pt2.y) : 0;
        return Math.sqrt(Math.pow(deltaX, 2) + Math.pow(deltaY, 2));
    };
}
 function getIntersectItems(chart, position, axis, useFinalPosition, includeInvisible) {
    const items = [];
    if (!includeInvisible && !chart.isPointInArea(position)) {
        return items;
    }
    const evaluationFunc = function(element, datasetIndex, index) {
        if (!includeInvisible && !_isPointInArea(element, chart.chartArea, 0)) {
            return;
        }
        if (element.inRange(position.x, position.y, useFinalPosition)) {
            items.push({
                element,
                datasetIndex,
                index
            });
        }
    };
    evaluateInteractionItems(chart, axis, position, evaluationFunc, true);
    return items;
}
 function getNearestRadialItems(chart, position, axis, useFinalPosition) {
    let items = [];
    function evaluationFunc(element, datasetIndex, index) {
        const { startAngle , endAngle  } = element.getProps([
            'startAngle',
            'endAngle'
        ], useFinalPosition);
        const { angle  } = getAngleFromPoint(element, {
            x: position.x,
            y: position.y
        });
        if (_angleBetween(angle, startAngle, endAngle)) {
            items.push({
                element,
                datasetIndex,
                index
            });
        }
    }
    evaluateInteractionItems(chart, axis, position, evaluationFunc);
    return items;
}
 function getNearestCartesianItems(chart, position, axis, intersect, useFinalPosition, includeInvisible) {
    let items = [];
    const distanceMetric = getDistanceMetricForAxis(axis);
    let minDistance = Number.POSITIVE_INFINITY;
    function evaluationFunc(element, datasetIndex, index) {
        const inRange = element.inRange(position.x, position.y, useFinalPosition);
        if (intersect && !inRange) {
            return;
        }
        const center = element.getCenterPoint(useFinalPosition);
        const pointInArea = !!includeInvisible || chart.isPointInArea(center);
        if (!pointInArea && !inRange) {
            return;
        }
        const distance = distanceMetric(position, center);
        if (distance < minDistance) {
            items = [
                {
                    element,
                    datasetIndex,
                    index
                }
            ];
            minDistance = distance;
        } else if (distance === minDistance) {
            items.push({
                element,
                datasetIndex,
                index
            });
        }
    }
    evaluateInteractionItems(chart, axis, position, evaluationFunc);
    return items;
}
 function getNearestItems(chart, position, axis, intersect, useFinalPosition, includeInvisible) {
    if (!includeInvisible && !chart.isPointInArea(position)) {
        return [];
    }
    return axis === 'r' && !intersect ? getNearestRadialItems(chart, position, axis, useFinalPosition) : getNearestCartesianItems(chart, position, axis, intersect, useFinalPosition, includeInvisible);
}
 function getAxisItems(chart, position, axis, intersect, useFinalPosition) {
    const items = [];
    const rangeMethod = axis === 'x' ? 'inXRange' : 'inYRange';
    let intersectsItem = false;
    evaluateInteractionItems(chart, axis, position, (element, datasetIndex, index)=>{
        if (element[rangeMethod](position[axis], useFinalPosition)) {
            items.push({
                element,
                datasetIndex,
                index
            });
            intersectsItem = intersectsItem || element.inRange(position.x, position.y, useFinalPosition);
        }
    });
    if (intersect && !intersectsItem) {
        return [];
    }
    return items;
}
 var Interaction = {
    evaluateInteractionItems,
    modes: {
 index (chart, e, options, useFinalPosition) {
            const position = getRelativePosition(e, chart);
            const axis = options.axis || 'x';
            const includeInvisible = options.includeInvisible || false;
            const items = options.intersect ? getIntersectItems(chart, position, axis, useFinalPosition, includeInvisible) : getNearestItems(chart, position, axis, false, useFinalPosition, includeInvisible);
            const elements = [];
            if (!items.length) {
                return [];
            }
            chart.getSortedVisibleDatasetMetas().forEach((meta)=>{
                const index = items[0].index;
                const element = meta.data[index];
                if (element && !element.skip) {
                    elements.push({
                        element,
                        datasetIndex: meta.index,
                        index
                    });
                }
            });
            return elements;
        },
 dataset (chart, e, options, useFinalPosition) {
            const position = getRelativePosition(e, chart);
            const axis = options.axis || 'xy';
            const includeInvisible = options.includeInvisible || false;
            let items = options.intersect ? getIntersectItems(chart, position, axis, useFinalPosition, includeInvisible) : getNearestItems(chart, position, axis, false, useFinalPosition, includeInvisible);
            if (items.length > 0) {
                const datasetIndex = items[0].datasetIndex;
                const data = chart.getDatasetMeta(datasetIndex).data;
                items = [];
                for(let i = 0; i < data.length; ++i){
                    items.push({
                        element: data[i],
                        datasetIndex,
                        index: i
                    });
                }
            }
            return items;
        },
 point (chart, e, options, useFinalPosition) {
            const position = getRelativePosition(e, chart);
            const axis = options.axis || 'xy';
            const includeInvisible = options.includeInvisible || false;
            return getIntersectItems(chart, position, axis, useFinalPosition, includeInvisible);
        },
 nearest (chart, e, options, useFinalPosition) {
            const position = getRelativePosition(e, chart);
            const axis = options.axis || 'xy';
            const includeInvisible = options.includeInvisible || false;
            return getNearestItems(chart, position, axis, options.intersect, useFinalPosition, includeInvisible);
        },
 x (chart, e, options, useFinalPosition) {
            const position = getRelativePosition(e, chart);
            return getAxisItems(chart, position, 'x', options.intersect, useFinalPosition);
        },
 y (chart, e, options, useFinalPosition) {
            const position = getRelativePosition(e, chart);
            return getAxisItems(chart, position, 'y', options.intersect, useFinalPosition);
        }
    }
};

const STATIC_POSITIONS = [
    'left',
    'top',
    'right',
    'bottom'
];
function filterByPosition(array, position) {
    return array.filter((v)=>v.pos === position);
}
function filterDynamicPositionByAxis(array, axis) {
    return array.filter((v)=>STATIC_POSITIONS.indexOf(v.pos) === -1 && v.box.axis === axis);
}
function sortByWeight(array, reverse) {
    return array.sort((a, b)=>{
        const v0 = reverse ? b : a;
        const v1 = reverse ? a : b;
        return v0.weight === v1.weight ? v0.index - v1.index : v0.weight - v1.weight;
    });
}
function wrapBoxes(boxes) {
    const layoutBoxes = [];
    let i, ilen, box, pos, stack, stackWeight;
    for(i = 0, ilen = (boxes || []).length; i < ilen; ++i){
        box = boxes[i];
        ({ position: pos , options: { stack , stackWeight =1  }  } = box);
        layoutBoxes.push({
            index: i,
            box,
            pos,
            horizontal: box.isHorizontal(),
            weight: box.weight,
            stack: stack && pos + stack,
            stackWeight
        });
    }
    return layoutBoxes;
}
function buildStacks(layouts) {
    const stacks = {};
    for (const wrap of layouts){
        const { stack , pos , stackWeight  } = wrap;
        if (!stack || !STATIC_POSITIONS.includes(pos)) {
            continue;
        }
        const _stack = stacks[stack] || (stacks[stack] = {
            count: 0,
            placed: 0,
            weight: 0,
            size: 0
        });
        _stack.count++;
        _stack.weight += stackWeight;
    }
    return stacks;
}
 function setLayoutDims(layouts, params) {
    const stacks = buildStacks(layouts);
    const { vBoxMaxWidth , hBoxMaxHeight  } = params;
    let i, ilen, layout;
    for(i = 0, ilen = layouts.length; i < ilen; ++i){
        layout = layouts[i];
        const { fullSize  } = layout.box;
        const stack = stacks[layout.stack];
        const factor = stack && layout.stackWeight / stack.weight;
        if (layout.horizontal) {
            layout.width = factor ? factor * vBoxMaxWidth : fullSize && params.availableWidth;
            layout.height = hBoxMaxHeight;
        } else {
            layout.width = vBoxMaxWidth;
            layout.height = factor ? factor * hBoxMaxHeight : fullSize && params.availableHeight;
        }
    }
    return stacks;
}
function buildLayoutBoxes(boxes) {
    const layoutBoxes = wrapBoxes(boxes);
    const fullSize = sortByWeight(layoutBoxes.filter((wrap)=>wrap.box.fullSize), true);
    const left = sortByWeight(filterByPosition(layoutBoxes, 'left'), true);
    const right = sortByWeight(filterByPosition(layoutBoxes, 'right'));
    const top = sortByWeight(filterByPosition(layoutBoxes, 'top'), true);
    const bottom = sortByWeight(filterByPosition(layoutBoxes, 'bottom'));
    const centerHorizontal = filterDynamicPositionByAxis(layoutBoxes, 'x');
    const centerVertical = filterDynamicPositionByAxis(layoutBoxes, 'y');
    return {
        fullSize,
        leftAndTop: left.concat(top),
        rightAndBottom: right.concat(centerVertical).concat(bottom).concat(centerHorizontal),
        chartArea: filterByPosition(layoutBoxes, 'chartArea'),
        vertical: left.concat(right).concat(centerVertical),
        horizontal: top.concat(bottom).concat(centerHorizontal)
    };
}
function getCombinedMax(maxPadding, chartArea, a, b) {
    return Math.max(maxPadding[a], chartArea[a]) + Math.max(maxPadding[b], chartArea[b]);
}
function updateMaxPadding(maxPadding, boxPadding) {
    maxPadding.top = Math.max(maxPadding.top, boxPadding.top);
    maxPadding.left = Math.max(maxPadding.left, boxPadding.left);
    maxPadding.bottom = Math.max(maxPadding.bottom, boxPadding.bottom);
    maxPadding.right = Math.max(maxPadding.right, boxPadding.right);
}
function updateDims(chartArea, params, layout, stacks) {
    const { pos , box  } = layout;
    const maxPadding = chartArea.maxPadding;
    if (!isObject(pos)) {
        if (layout.size) {
            chartArea[pos] -= layout.size;
        }
        const stack = stacks[layout.stack] || {
            size: 0,
            count: 1
        };
        stack.size = Math.max(stack.size, layout.horizontal ? box.height : box.width);
        layout.size = stack.size / stack.count;
        chartArea[pos] += layout.size;
    }
    if (box.getPadding) {
        updateMaxPadding(maxPadding, box.getPadding());
    }
    const newWidth = Math.max(0, params.outerWidth - getCombinedMax(maxPadding, chartArea, 'left', 'right'));
    const newHeight = Math.max(0, params.outerHeight - getCombinedMax(maxPadding, chartArea, 'top', 'bottom'));
    const widthChanged = newWidth !== chartArea.w;
    const heightChanged = newHeight !== chartArea.h;
    chartArea.w = newWidth;
    chartArea.h = newHeight;
    return layout.horizontal ? {
        same: widthChanged,
        other: heightChanged
    } : {
        same: heightChanged,
        other: widthChanged
    };
}
function handleMaxPadding(chartArea) {
    const maxPadding = chartArea.maxPadding;
    function updatePos(pos) {
        const change = Math.max(maxPadding[pos] - chartArea[pos], 0);
        chartArea[pos] += change;
        return change;
    }
    chartArea.y += updatePos('top');
    chartArea.x += updatePos('left');
    updatePos('right');
    updatePos('bottom');
}
function getMargins(horizontal, chartArea) {
    const maxPadding = chartArea.maxPadding;
    function marginForPositions(positions) {
        const margin = {
            left: 0,
            top: 0,
            right: 0,
            bottom: 0
        };
        positions.forEach((pos)=>{
            margin[pos] = Math.max(chartArea[pos], maxPadding[pos]);
        });
        return margin;
    }
    return horizontal ? marginForPositions([
        'left',
        'right'
    ]) : marginForPositions([
        'top',
        'bottom'
    ]);
}
function fitBoxes(boxes, chartArea, params, stacks) {
    const refitBoxes = [];
    let i, ilen, layout, box, refit, changed;
    for(i = 0, ilen = boxes.length, refit = 0; i < ilen; ++i){
        layout = boxes[i];
        box = layout.box;
        box.update(layout.width || chartArea.w, layout.height || chartArea.h, getMargins(layout.horizontal, chartArea));
        const { same , other  } = updateDims(chartArea, params, layout, stacks);
        refit |= same && refitBoxes.length;
        changed = changed || other;
        if (!box.fullSize) {
            refitBoxes.push(layout);
        }
    }
    return refit && fitBoxes(refitBoxes, chartArea, params, stacks) || changed;
}
function setBoxDims(box, left, top, width, height) {
    box.top = top;
    box.left = left;
    box.right = left + width;
    box.bottom = top + height;
    box.width = width;
    box.height = height;
}
function placeBoxes(boxes, chartArea, params, stacks) {
    const userPadding = params.padding;
    let { x , y  } = chartArea;
    for (const layout of boxes){
        const box = layout.box;
        const stack = stacks[layout.stack] || {
            count: 1,
            placed: 0,
            weight: 1
        };
        const weight = layout.stackWeight / stack.weight || 1;
        if (layout.horizontal) {
            const width = chartArea.w * weight;
            const height = stack.size || box.height;
            if (defined(stack.start)) {
                y = stack.start;
            }
            if (box.fullSize) {
                setBoxDims(box, userPadding.left, y, params.outerWidth - userPadding.right - userPadding.left, height);
            } else {
                setBoxDims(box, chartArea.left + stack.placed, y, width, height);
            }
            stack.start = y;
            stack.placed += width;
            y = box.bottom;
        } else {
            const height = chartArea.h * weight;
            const width = stack.size || box.width;
            if (defined(stack.start)) {
                x = stack.start;
            }
            if (box.fullSize) {
                setBoxDims(box, x, userPadding.top, width, params.outerHeight - userPadding.bottom - userPadding.top);
            } else {
                setBoxDims(box, x, chartArea.top + stack.placed, width, height);
            }
            stack.start = x;
            stack.placed += height;
            x = box.right;
        }
    }
    chartArea.x = x;
    chartArea.y = y;
}
var layouts = {
 addBox (chart, item) {
        if (!chart.boxes) {
            chart.boxes = [];
        }
        item.fullSize = item.fullSize || false;
        item.position = item.position || 'top';
        item.weight = item.weight || 0;
        item._layers = item._layers || function() {
            return [
                {
                    z: 0,
                    draw (chartArea) {
                        item.draw(chartArea);
                    }
                }
            ];
        };
        chart.boxes.push(item);
    },
 removeBox (chart, layoutItem) {
        const index = chart.boxes ? chart.boxes.indexOf(layoutItem) : -1;
        if (index !== -1) {
            chart.boxes.splice(index, 1);
        }
    },
 configure (chart, item, options) {
        item.fullSize = options.fullSize;
        item.position = options.position;
        item.weight = options.weight;
    },
 update (chart, width, height, minPadding) {
        if (!chart) {
            return;
        }
        const padding = toPadding(chart.options.layout.padding);
        const availableWidth = Math.max(width - padding.width, 0);
        const availableHeight = Math.max(height - padding.height, 0);
        const boxes = buildLayoutBoxes(chart.boxes);
        const verticalBoxes = boxes.vertical;
        const horizontalBoxes = boxes.horizontal;
        each(chart.boxes, (box)=>{
            if (typeof box.beforeLayout === 'function') {
                box.beforeLayout();
            }
        });
        const visibleVerticalBoxCount = verticalBoxes.reduce((total, wrap)=>wrap.box.options && wrap.box.options.display === false ? total : total + 1, 0) || 1;
        const params = Object.freeze({
            outerWidth: width,
            outerHeight: height,
            padding,
            availableWidth,
            availableHeight,
            vBoxMaxWidth: availableWidth / 2 / visibleVerticalBoxCount,
            hBoxMaxHeight: availableHeight / 2
        });
        const maxPadding = Object.assign({}, padding);
        updateMaxPadding(maxPadding, toPadding(minPadding));
        const chartArea = Object.assign({
            maxPadding,
            w: availableWidth,
            h: availableHeight,
            x: padding.left,
            y: padding.top
        }, padding);
        const stacks = setLayoutDims(verticalBoxes.concat(horizontalBoxes), params);
        fitBoxes(boxes.fullSize, chartArea, params, stacks);
        fitBoxes(verticalBoxes, chartArea, params, stacks);
        if (fitBoxes(horizontalBoxes, chartArea, params, stacks)) {
            fitBoxes(verticalBoxes, chartArea, params, stacks);
        }
        handleMaxPadding(chartArea);
        placeBoxes(boxes.leftAndTop, chartArea, params, stacks);
        chartArea.x += chartArea.w;
        chartArea.y += chartArea.h;
        placeBoxes(boxes.rightAndBottom, chartArea, params, stacks);
        chart.chartArea = {
            left: chartArea.left,
            top: chartArea.top,
            right: chartArea.left + chartArea.w,
            bottom: chartArea.top + chartArea.h,
            height: chartArea.h,
            width: chartArea.w
        };
        each(boxes.chartArea, (layout)=>{
            const box = layout.box;
            Object.assign(box, chart.chartArea);
            box.update(chartArea.w, chartArea.h, {
                left: 0,
                top: 0,
                right: 0,
                bottom: 0
            });
        });
    }
};

class BasePlatform {
 acquireContext(canvas, aspectRatio) {}
 releaseContext(context) {
        return false;
    }
 addEventListener(chart, type, listener) {}
 removeEventListener(chart, type, listener) {}
 getDevicePixelRatio() {
        return 1;
    }
 getMaximumSize(element, width, height, aspectRatio) {
        width = Math.max(0, width || element.width);
        height = height || element.height;
        return {
            width,
            height: Math.max(0, aspectRatio ? Math.floor(width / aspectRatio) : height)
        };
    }
 isAttached(canvas) {
        return true;
    }
 updateConfig(config) {
    }
}

class BasicPlatform extends BasePlatform {
    acquireContext(item) {
        return item && item.getContext && item.getContext('2d') || null;
    }
    updateConfig(config) {
        config.options.animation = false;
    }
}

const EXPANDO_KEY = '$chartjs';
 const EVENT_TYPES = {
    touchstart: 'mousedown',
    touchmove: 'mousemove',
    touchend: 'mouseup',
    pointerenter: 'mouseenter',
    pointerdown: 'mousedown',
    pointermove: 'mousemove',
    pointerup: 'mouseup',
    pointerleave: 'mouseout',
    pointerout: 'mouseout'
};
const isNullOrEmpty = (value)=>value === null || value === '';
 function initCanvas(canvas, aspectRatio) {
    const style = canvas.style;
    const renderHeight = canvas.getAttribute('height');
    const renderWidth = canvas.getAttribute('width');
    canvas[EXPANDO_KEY] = {
        initial: {
            height: renderHeight,
            width: renderWidth,
            style: {
                display: style.display,
                height: style.height,
                width: style.width
            }
        }
    };
    style.display = style.display || 'block';
    style.boxSizing = style.boxSizing || 'border-box';
    if (isNullOrEmpty(renderWidth)) {
        const displayWidth = readUsedSize(canvas, 'width');
        if (displayWidth !== undefined) {
            canvas.width = displayWidth;
        }
    }
    if (isNullOrEmpty(renderHeight)) {
        if (canvas.style.height === '') {
            canvas.height = canvas.width / (aspectRatio || 2);
        } else {
            const displayHeight = readUsedSize(canvas, 'height');
            if (displayHeight !== undefined) {
                canvas.height = displayHeight;
            }
        }
    }
    return canvas;
}
const eventListenerOptions = supportsEventListenerOptions ? {
    passive: true
} : false;
function addListener(node, type, listener) {
    if (node) {
        node.addEventListener(type, listener, eventListenerOptions);
    }
}
function removeListener(chart, type, listener) {
    if (chart && chart.canvas) {
        chart.canvas.removeEventListener(type, listener, eventListenerOptions);
    }
}
function fromNativeEvent(event, chart) {
    const type = EVENT_TYPES[event.type] || event.type;
    const { x , y  } = getRelativePosition(event, chart);
    return {
        type,
        chart,
        native: event,
        x: x !== undefined ? x : null,
        y: y !== undefined ? y : null
    };
}
function nodeListContains(nodeList, canvas) {
    for (const node of nodeList){
        if (node === canvas || node.contains(canvas)) {
            return true;
        }
    }
}
function createAttachObserver(chart, type, listener) {
    const canvas = chart.canvas;
    const observer = new MutationObserver((entries)=>{
        let trigger = false;
        for (const entry of entries){
            trigger = trigger || nodeListContains(entry.addedNodes, canvas);
            trigger = trigger && !nodeListContains(entry.removedNodes, canvas);
        }
        if (trigger) {
            listener();
        }
    });
    observer.observe(document, {
        childList: true,
        subtree: true
    });
    return observer;
}
function createDetachObserver(chart, type, listener) {
    const canvas = chart.canvas;
    const observer = new MutationObserver((entries)=>{
        let trigger = false;
        for (const entry of entries){
            trigger = trigger || nodeListContains(entry.removedNodes, canvas);
            trigger = trigger && !nodeListContains(entry.addedNodes, canvas);
        }
        if (trigger) {
            listener();
        }
    });
    observer.observe(document, {
        childList: true,
        subtree: true
    });
    return observer;
}
const drpListeningCharts = new Map();
let oldDevicePixelRatio = 0;
function onWindowResize() {
    const dpr = window.devicePixelRatio;
    if (dpr === oldDevicePixelRatio) {
        return;
    }
    oldDevicePixelRatio = dpr;
    drpListeningCharts.forEach((resize, chart)=>{
        if (chart.currentDevicePixelRatio !== dpr) {
            resize();
        }
    });
}
function listenDevicePixelRatioChanges(chart, resize) {
    if (!drpListeningCharts.size) {
        window.addEventListener('resize', onWindowResize);
    }
    drpListeningCharts.set(chart, resize);
}
function unlistenDevicePixelRatioChanges(chart) {
    drpListeningCharts.delete(chart);
    if (!drpListeningCharts.size) {
        window.removeEventListener('resize', onWindowResize);
    }
}
function createResizeObserver(chart, type, listener) {
    const canvas = chart.canvas;
    const container = canvas && _getParentNode(canvas);
    if (!container) {
        return;
    }
    const resize = throttled((width, height)=>{
        const w = container.clientWidth;
        listener(width, height);
        if (w < container.clientWidth) {
            listener();
        }
    }, window);
    const observer = new ResizeObserver((entries)=>{
        const entry = entries[0];
        const width = entry.contentRect.width;
        const height = entry.contentRect.height;
        if (width === 0 && height === 0) {
            return;
        }
        resize(width, height);
    });
    observer.observe(container);
    listenDevicePixelRatioChanges(chart, resize);
    return observer;
}
function releaseObserver(chart, type, observer) {
    if (observer) {
        observer.disconnect();
    }
    if (type === 'resize') {
        unlistenDevicePixelRatioChanges(chart);
    }
}
function createProxyAndListen(chart, type, listener) {
    const canvas = chart.canvas;
    const proxy = throttled((event)=>{
        if (chart.ctx !== null) {
            listener(fromNativeEvent(event, chart));
        }
    }, chart);
    addListener(canvas, type, proxy);
    return proxy;
}
 class DomPlatform extends BasePlatform {
 acquireContext(canvas, aspectRatio) {
        const context = canvas && canvas.getContext && canvas.getContext('2d');
        if (context && context.canvas === canvas) {
            initCanvas(canvas, aspectRatio);
            return context;
        }
        return null;
    }
 releaseContext(context) {
        const canvas = context.canvas;
        if (!canvas[EXPANDO_KEY]) {
            return false;
        }
        const initial = canvas[EXPANDO_KEY].initial;
        [
            'height',
            'width'
        ].forEach((prop)=>{
            const value = initial[prop];
            if (isNullOrUndef(value)) {
                canvas.removeAttribute(prop);
            } else {
                canvas.setAttribute(prop, value);
            }
        });
        const style = initial.style || {};
        Object.keys(style).forEach((key)=>{
            canvas.style[key] = style[key];
        });
        canvas.width = canvas.width;
        delete canvas[EXPANDO_KEY];
        return true;
    }
 addEventListener(chart, type, listener) {
        this.removeEventListener(chart, type);
        const proxies = chart.$proxies || (chart.$proxies = {});
        const handlers = {
            attach: createAttachObserver,
            detach: createDetachObserver,
            resize: createResizeObserver
        };
        const handler = handlers[type] || createProxyAndListen;
        proxies[type] = handler(chart, type, listener);
    }
 removeEventListener(chart, type) {
        const proxies = chart.$proxies || (chart.$proxies = {});
        const proxy = proxies[type];
        if (!proxy) {
            return;
        }
        const handlers = {
            attach: releaseObserver,
            detach: releaseObserver,
            resize: releaseObserver
        };
        const handler = handlers[type] || removeListener;
        handler(chart, type, proxy);
        proxies[type] = undefined;
    }
    getDevicePixelRatio() {
        return window.devicePixelRatio;
    }
 getMaximumSize(canvas, width, height, aspectRatio) {
        return getMaximumSize(canvas, width, height, aspectRatio);
    }
 isAttached(canvas) {
        const container = _getParentNode(canvas);
        return !!(container && container.isConnected);
    }
}

function _detectPlatform(canvas) {
    if (!_isDomSupported() || typeof OffscreenCanvas !== 'undefined' && canvas instanceof OffscreenCanvas) {
        return BasicPlatform;
    }
    return DomPlatform;
}

class Element {
    static defaults = {};
    static defaultRoutes = undefined;
    x;
    y;
    active = false;
    options;
    $animations;
    tooltipPosition(useFinalPosition) {
        const { x , y  } = this.getProps([
            'x',
            'y'
        ], useFinalPosition);
        return {
            x,
            y
        };
    }
    hasValue() {
        return isNumber(this.x) && isNumber(this.y);
    }
    getProps(props, final) {
        const anims = this.$animations;
        if (!final || !anims) {
            // let's not create an object, if not needed
            return this;
        }
        const ret = {};
        props.forEach((prop)=>{
            ret[prop] = anims[prop] && anims[prop].active() ? anims[prop]._to : this[prop];
        });
        return ret;
    }
}

function autoSkip(scale, ticks) {
    const tickOpts = scale.options.ticks;
    const determinedMaxTicks = determineMaxTicks(scale);
    const ticksLimit = Math.min(tickOpts.maxTicksLimit || determinedMaxTicks, determinedMaxTicks);
    const majorIndices = tickOpts.major.enabled ? getMajorIndices(ticks) : [];
    const numMajorIndices = majorIndices.length;
    const first = majorIndices[0];
    const last = majorIndices[numMajorIndices - 1];
    const newTicks = [];
    if (numMajorIndices > ticksLimit) {
        skipMajors(ticks, newTicks, majorIndices, numMajorIndices / ticksLimit);
        return newTicks;
    }
    const spacing = calculateSpacing(majorIndices, ticks, ticksLimit);
    if (numMajorIndices > 0) {
        let i, ilen;
        const avgMajorSpacing = numMajorIndices > 1 ? Math.round((last - first) / (numMajorIndices - 1)) : null;
        skip(ticks, newTicks, spacing, isNullOrUndef(avgMajorSpacing) ? 0 : first - avgMajorSpacing, first);
        for(i = 0, ilen = numMajorIndices - 1; i < ilen; i++){
            skip(ticks, newTicks, spacing, majorIndices[i], majorIndices[i + 1]);
        }
        skip(ticks, newTicks, spacing, last, isNullOrUndef(avgMajorSpacing) ? ticks.length : last + avgMajorSpacing);
        return newTicks;
    }
    skip(ticks, newTicks, spacing);
    return newTicks;
}
function determineMaxTicks(scale) {
    const offset = scale.options.offset;
    const tickLength = scale._tickSize();
    const maxScale = scale._length / tickLength + (offset ? 0 : 1);
    const maxChart = scale._maxLength / tickLength;
    return Math.floor(Math.min(maxScale, maxChart));
}
 function calculateSpacing(majorIndices, ticks, ticksLimit) {
    const evenMajorSpacing = getEvenSpacing(majorIndices);
    const spacing = ticks.length / ticksLimit;
    if (!evenMajorSpacing) {
        return Math.max(spacing, 1);
    }
    const factors = _factorize(evenMajorSpacing);
    for(let i = 0, ilen = factors.length - 1; i < ilen; i++){
        const factor = factors[i];
        if (factor > spacing) {
            return factor;
        }
    }
    return Math.max(spacing, 1);
}
 function getMajorIndices(ticks) {
    const result = [];
    let i, ilen;
    for(i = 0, ilen = ticks.length; i < ilen; i++){
        if (ticks[i].major) {
            result.push(i);
        }
    }
    return result;
}
 function skipMajors(ticks, newTicks, majorIndices, spacing) {
    let count = 0;
    let next = majorIndices[0];
    let i;
    spacing = Math.ceil(spacing);
    for(i = 0; i < ticks.length; i++){
        if (i === next) {
            newTicks.push(ticks[i]);
            count++;
            next = majorIndices[count * spacing];
        }
    }
}
 function skip(ticks, newTicks, spacing, majorStart, majorEnd) {
    const start = valueOrDefault(majorStart, 0);
    const end = Math.min(valueOrDefault(majorEnd, ticks.length), ticks.length);
    let count = 0;
    let length, i, next;
    spacing = Math.ceil(spacing);
    if (majorEnd) {
        length = majorEnd - majorStart;
        spacing = length / Math.floor(length / spacing);
    }
    next = start;
    while(next < 0){
        count++;
        next = Math.round(start + count * spacing);
    }
    for(i = Math.max(start, 0); i < end; i++){
        if (i === next) {
            newTicks.push(ticks[i]);
            count++;
            next = Math.round(start + count * spacing);
        }
    }
}
 function getEvenSpacing(arr) {
    const len = arr.length;
    let i, diff;
    if (len < 2) {
        return false;
    }
    for(diff = arr[0], i = 1; i < len; ++i){
        if (arr[i] - arr[i - 1] !== diff) {
            return false;
        }
    }
    return diff;
}

const reverseAlign = (align)=>align === 'left' ? 'right' : align === 'right' ? 'left' : align;
const offsetFromEdge = (scale, edge, offset)=>edge === 'top' || edge === 'left' ? scale[edge] + offset : scale[edge] - offset;
const getTicksLimit = (ticksLength, maxTicksLimit)=>Math.min(maxTicksLimit || ticksLength, ticksLength);
 function sample(arr, numItems) {
    const result = [];
    const increment = arr.length / numItems;
    const len = arr.length;
    let i = 0;
    for(; i < len; i += increment){
        result.push(arr[Math.floor(i)]);
    }
    return result;
}
 function getPixelForGridLine(scale, index, offsetGridLines) {
    const length = scale.ticks.length;
    const validIndex = Math.min(index, length - 1);
    const start = scale._startPixel;
    const end = scale._endPixel;
    const epsilon = 1e-6;
    let lineValue = scale.getPixelForTick(validIndex);
    let offset;
    if (offsetGridLines) {
        if (length === 1) {
            offset = Math.max(lineValue - start, end - lineValue);
        } else if (index === 0) {
            offset = (scale.getPixelForTick(1) - lineValue) / 2;
        } else {
            offset = (lineValue - scale.getPixelForTick(validIndex - 1)) / 2;
        }
        lineValue += validIndex < index ? offset : -offset;
        if (lineValue < start - epsilon || lineValue > end + epsilon) {
            return;
        }
    }
    return lineValue;
}
 function garbageCollect(caches, length) {
    each(caches, (cache)=>{
        const gc = cache.gc;
        const gcLen = gc.length / 2;
        let i;
        if (gcLen > length) {
            for(i = 0; i < gcLen; ++i){
                delete cache.data[gc[i]];
            }
            gc.splice(0, gcLen);
        }
    });
}
 function getTickMarkLength(options) {
    return options.drawTicks ? options.tickLength : 0;
}
 function getTitleHeight(options, fallback) {
    if (!options.display) {
        return 0;
    }
    const font = toFont(options.font, fallback);
    const padding = toPadding(options.padding);
    const lines = isArray(options.text) ? options.text.length : 1;
    return lines * font.lineHeight + padding.height;
}
function createScaleContext(parent, scale) {
    return createContext(parent, {
        scale,
        type: 'scale'
    });
}
function createTickContext(parent, index, tick) {
    return createContext(parent, {
        tick,
        index,
        type: 'tick'
    });
}
function titleAlign(align, position, reverse) {
     let ret = _toLeftRightCenter(align);
    if (reverse && position !== 'right' || !reverse && position === 'right') {
        ret = reverseAlign(ret);
    }
    return ret;
}
function titleArgs(scale, offset, position, align) {
    const { top , left , bottom , right , chart  } = scale;
    const { chartArea , scales  } = chart;
    let rotation = 0;
    let maxWidth, titleX, titleY;
    const height = bottom - top;
    const width = right - left;
    if (scale.isHorizontal()) {
        titleX = _alignStartEnd(align, left, right);
        if (isObject(position)) {
            const positionAxisID = Object.keys(position)[0];
            const value = position[positionAxisID];
            titleY = scales[positionAxisID].getPixelForValue(value) + height - offset;
        } else if (position === 'center') {
            titleY = (chartArea.bottom + chartArea.top) / 2 + height - offset;
        } else {
            titleY = offsetFromEdge(scale, position, offset);
        }
        maxWidth = right - left;
    } else {
        if (isObject(position)) {
            const positionAxisID = Object.keys(position)[0];
            const value = position[positionAxisID];
            titleX = scales[positionAxisID].getPixelForValue(value) - width + offset;
        } else if (position === 'center') {
            titleX = (chartArea.left + chartArea.right) / 2 - width + offset;
        } else {
            titleX = offsetFromEdge(scale, position, offset);
        }
        titleY = _alignStartEnd(align, bottom, top);
        rotation = position === 'left' ? -HALF_PI : HALF_PI;
    }
    return {
        titleX,
        titleY,
        maxWidth,
        rotation
    };
}
class Scale extends Element {
    constructor(cfg){
        super();
         this.id = cfg.id;
         this.type = cfg.type;
         this.options = undefined;
         this.ctx = cfg.ctx;
         this.chart = cfg.chart;
         this.top = undefined;
         this.bottom = undefined;
         this.left = undefined;
         this.right = undefined;
         this.width = undefined;
         this.height = undefined;
        this._margins = {
            left: 0,
            right: 0,
            top: 0,
            bottom: 0
        };
         this.maxWidth = undefined;
         this.maxHeight = undefined;
         this.paddingTop = undefined;
         this.paddingBottom = undefined;
         this.paddingLeft = undefined;
         this.paddingRight = undefined;
         this.axis = undefined;
         this.labelRotation = undefined;
        this.min = undefined;
        this.max = undefined;
        this._range = undefined;
         this.ticks = [];
         this._gridLineItems = null;
         this._labelItems = null;
         this._labelSizes = null;
        this._length = 0;
        this._maxLength = 0;
        this._longestTextCache = {};
         this._startPixel = undefined;
         this._endPixel = undefined;
        this._reversePixels = false;
        this._userMax = undefined;
        this._userMin = undefined;
        this._suggestedMax = undefined;
        this._suggestedMin = undefined;
        this._ticksLength = 0;
        this._borderValue = 0;
        this._cache = {};
        this._dataLimitsCached = false;
        this.$context = undefined;
    }
 init(options) {
        this.options = options.setContext(this.getContext());
        this.axis = options.axis;
        this._userMin = this.parse(options.min);
        this._userMax = this.parse(options.max);
        this._suggestedMin = this.parse(options.suggestedMin);
        this._suggestedMax = this.parse(options.suggestedMax);
    }
 parse(raw, index) {
        return raw;
    }
 getUserBounds() {
        let { _userMin , _userMax , _suggestedMin , _suggestedMax  } = this;
        _userMin = finiteOrDefault(_userMin, Number.POSITIVE_INFINITY);
        _userMax = finiteOrDefault(_userMax, Number.NEGATIVE_INFINITY);
        _suggestedMin = finiteOrDefault(_suggestedMin, Number.POSITIVE_INFINITY);
        _suggestedMax = finiteOrDefault(_suggestedMax, Number.NEGATIVE_INFINITY);
        return {
            min: finiteOrDefault(_userMin, _suggestedMin),
            max: finiteOrDefault(_userMax, _suggestedMax),
            minDefined: isNumberFinite(_userMin),
            maxDefined: isNumberFinite(_userMax)
        };
    }
 getMinMax(canStack) {
        let { min , max , minDefined , maxDefined  } = this.getUserBounds();
        let range;
        if (minDefined && maxDefined) {
            return {
                min,
                max
            };
        }
        const metas = this.getMatchingVisibleMetas();
        for(let i = 0, ilen = metas.length; i < ilen; ++i){
            range = metas[i].controller.getMinMax(this, canStack);
            if (!minDefined) {
                min = Math.min(min, range.min);
            }
            if (!maxDefined) {
                max = Math.max(max, range.max);
            }
        }
        min = maxDefined && min > max ? max : min;
        max = minDefined && min > max ? min : max;
        return {
            min: finiteOrDefault(min, finiteOrDefault(max, min)),
            max: finiteOrDefault(max, finiteOrDefault(min, max))
        };
    }
 getPadding() {
        return {
            left: this.paddingLeft || 0,
            top: this.paddingTop || 0,
            right: this.paddingRight || 0,
            bottom: this.paddingBottom || 0
        };
    }
 getTicks() {
        return this.ticks;
    }
 getLabels() {
        const data = this.chart.data;
        return this.options.labels || (this.isHorizontal() ? data.xLabels : data.yLabels) || data.labels || [];
    }
 getLabelItems(chartArea = this.chart.chartArea) {
        const items = this._labelItems || (this._labelItems = this._computeLabelItems(chartArea));
        return items;
    }
    beforeLayout() {
        this._cache = {};
        this._dataLimitsCached = false;
    }
    beforeUpdate() {
        callback(this.options.beforeUpdate, [
            this
        ]);
    }
 update(maxWidth, maxHeight, margins) {
        const { beginAtZero , grace , ticks: tickOpts  } = this.options;
        const sampleSize = tickOpts.sampleSize;
        this.beforeUpdate();
        this.maxWidth = maxWidth;
        this.maxHeight = maxHeight;
        this._margins = margins = Object.assign({
            left: 0,
            right: 0,
            top: 0,
            bottom: 0
        }, margins);
        this.ticks = null;
        this._labelSizes = null;
        this._gridLineItems = null;
        this._labelItems = null;
        this.beforeSetDimensions();
        this.setDimensions();
        this.afterSetDimensions();
        this._maxLength = this.isHorizontal() ? this.width + margins.left + margins.right : this.height + margins.top + margins.bottom;
        if (!this._dataLimitsCached) {
            this.beforeDataLimits();
            this.determineDataLimits();
            this.afterDataLimits();
            this._range = _addGrace(this, grace, beginAtZero);
            this._dataLimitsCached = true;
        }
        this.beforeBuildTicks();
        this.ticks = this.buildTicks() || [];
        this.afterBuildTicks();
        const samplingEnabled = sampleSize < this.ticks.length;
        this._convertTicksToLabels(samplingEnabled ? sample(this.ticks, sampleSize) : this.ticks);
        this.configure();
        this.beforeCalculateLabelRotation();
        this.calculateLabelRotation();
        this.afterCalculateLabelRotation();
        if (tickOpts.display && (tickOpts.autoSkip || tickOpts.source === 'auto')) {
            this.ticks = autoSkip(this, this.ticks);
            this._labelSizes = null;
            this.afterAutoSkip();
        }
        if (samplingEnabled) {
            this._convertTicksToLabels(this.ticks);
        }
        this.beforeFit();
        this.fit();
        this.afterFit();
        this.afterUpdate();
    }
 configure() {
        let reversePixels = this.options.reverse;
        let startPixel, endPixel;
        if (this.isHorizontal()) {
            startPixel = this.left;
            endPixel = this.right;
        } else {
            startPixel = this.top;
            endPixel = this.bottom;
            reversePixels = !reversePixels;
        }
        this._startPixel = startPixel;
        this._endPixel = endPixel;
        this._reversePixels = reversePixels;
        this._length = endPixel - startPixel;
        this._alignToPixels = this.options.alignToPixels;
    }
    afterUpdate() {
        callback(this.options.afterUpdate, [
            this
        ]);
    }
    beforeSetDimensions() {
        callback(this.options.beforeSetDimensions, [
            this
        ]);
    }
    setDimensions() {
        if (this.isHorizontal()) {
            this.width = this.maxWidth;
            this.left = 0;
            this.right = this.width;
        } else {
            this.height = this.maxHeight;
            this.top = 0;
            this.bottom = this.height;
        }
        this.paddingLeft = 0;
        this.paddingTop = 0;
        this.paddingRight = 0;
        this.paddingBottom = 0;
    }
    afterSetDimensions() {
        callback(this.options.afterSetDimensions, [
            this
        ]);
    }
    _callHooks(name) {
        this.chart.notifyPlugins(name, this.getContext());
        callback(this.options[name], [
            this
        ]);
    }
    beforeDataLimits() {
        this._callHooks('beforeDataLimits');
    }
    determineDataLimits() {}
    afterDataLimits() {
        this._callHooks('afterDataLimits');
    }
    beforeBuildTicks() {
        this._callHooks('beforeBuildTicks');
    }
 buildTicks() {
        return [];
    }
    afterBuildTicks() {
        this._callHooks('afterBuildTicks');
    }
    beforeTickToLabelConversion() {
        callback(this.options.beforeTickToLabelConversion, [
            this
        ]);
    }
 generateTickLabels(ticks) {
        const tickOpts = this.options.ticks;
        let i, ilen, tick;
        for(i = 0, ilen = ticks.length; i < ilen; i++){
            tick = ticks[i];
            tick.label = callback(tickOpts.callback, [
                tick.value,
                i,
                ticks
            ], this);
        }
    }
    afterTickToLabelConversion() {
        callback(this.options.afterTickToLabelConversion, [
            this
        ]);
    }
    beforeCalculateLabelRotation() {
        callback(this.options.beforeCalculateLabelRotation, [
            this
        ]);
    }
    calculateLabelRotation() {
        const options = this.options;
        const tickOpts = options.ticks;
        const numTicks = getTicksLimit(this.ticks.length, options.ticks.maxTicksLimit);
        const minRotation = tickOpts.minRotation || 0;
        const maxRotation = tickOpts.maxRotation;
        let labelRotation = minRotation;
        let tickWidth, maxHeight, maxLabelDiagonal;
        if (!this._isVisible() || !tickOpts.display || minRotation >= maxRotation || numTicks <= 1 || !this.isHorizontal()) {
            this.labelRotation = minRotation;
            return;
        }
        const labelSizes = this._getLabelSizes();
        const maxLabelWidth = labelSizes.widest.width;
        const maxLabelHeight = labelSizes.highest.height;
        const maxWidth = _limitValue(this.chart.width - maxLabelWidth, 0, this.maxWidth);
        tickWidth = options.offset ? this.maxWidth / numTicks : maxWidth / (numTicks - 1);
        if (maxLabelWidth + 6 > tickWidth) {
            tickWidth = maxWidth / (numTicks - (options.offset ? 0.5 : 1));
            maxHeight = this.maxHeight - getTickMarkLength(options.grid) - tickOpts.padding - getTitleHeight(options.title, this.chart.options.font);
            maxLabelDiagonal = Math.sqrt(maxLabelWidth * maxLabelWidth + maxLabelHeight * maxLabelHeight);
            labelRotation = toDegrees(Math.min(Math.asin(_limitValue((labelSizes.highest.height + 6) / tickWidth, -1, 1)), Math.asin(_limitValue(maxHeight / maxLabelDiagonal, -1, 1)) - Math.asin(_limitValue(maxLabelHeight / maxLabelDiagonal, -1, 1))));
            labelRotation = Math.max(minRotation, Math.min(maxRotation, labelRotation));
        }
        this.labelRotation = labelRotation;
    }
    afterCalculateLabelRotation() {
        callback(this.options.afterCalculateLabelRotation, [
            this
        ]);
    }
    afterAutoSkip() {}
    beforeFit() {
        callback(this.options.beforeFit, [
            this
        ]);
    }
    fit() {
        const minSize = {
            width: 0,
            height: 0
        };
        const { chart , options: { ticks: tickOpts , title: titleOpts , grid: gridOpts  }  } = this;
        const display = this._isVisible();
        const isHorizontal = this.isHorizontal();
        if (display) {
            const titleHeight = getTitleHeight(titleOpts, chart.options.font);
            if (isHorizontal) {
                minSize.width = this.maxWidth;
                minSize.height = getTickMarkLength(gridOpts) + titleHeight;
            } else {
                minSize.height = this.maxHeight;
                minSize.width = getTickMarkLength(gridOpts) + titleHeight;
            }
            if (tickOpts.display && this.ticks.length) {
                const { first , last , widest , highest  } = this._getLabelSizes();
                const tickPadding = tickOpts.padding * 2;
                const angleRadians = toRadians(this.labelRotation);
                const cos = Math.cos(angleRadians);
                const sin = Math.sin(angleRadians);
                if (isHorizontal) {
                    const labelHeight = tickOpts.mirror ? 0 : sin * widest.width + cos * highest.height;
                    minSize.height = Math.min(this.maxHeight, minSize.height + labelHeight + tickPadding);
                } else {
                    const labelWidth = tickOpts.mirror ? 0 : cos * widest.width + sin * highest.height;
                    minSize.width = Math.min(this.maxWidth, minSize.width + labelWidth + tickPadding);
                }
                this._calculatePadding(first, last, sin, cos);
            }
        }
        this._handleMargins();
        if (isHorizontal) {
            this.width = this._length = chart.width - this._margins.left - this._margins.right;
            this.height = minSize.height;
        } else {
            this.width = minSize.width;
            this.height = this._length = chart.height - this._margins.top - this._margins.bottom;
        }
    }
    _calculatePadding(first, last, sin, cos) {
        const { ticks: { align , padding  } , position  } = this.options;
        const isRotated = this.labelRotation !== 0;
        const labelsBelowTicks = position !== 'top' && this.axis === 'x';
        if (this.isHorizontal()) {
            const offsetLeft = this.getPixelForTick(0) - this.left;
            const offsetRight = this.right - this.getPixelForTick(this.ticks.length - 1);
            let paddingLeft = 0;
            let paddingRight = 0;
            if (isRotated) {
                if (labelsBelowTicks) {
                    paddingLeft = cos * first.width;
                    paddingRight = sin * last.height;
                } else {
                    paddingLeft = sin * first.height;
                    paddingRight = cos * last.width;
                }
            } else if (align === 'start') {
                paddingRight = last.width;
            } else if (align === 'end') {
                paddingLeft = first.width;
            } else if (align !== 'inner') {
                paddingLeft = first.width / 2;
                paddingRight = last.width / 2;
            }
            this.paddingLeft = Math.max((paddingLeft - offsetLeft + padding) * this.width / (this.width - offsetLeft), 0);
            this.paddingRight = Math.max((paddingRight - offsetRight + padding) * this.width / (this.width - offsetRight), 0);
        } else {
            let paddingTop = last.height / 2;
            let paddingBottom = first.height / 2;
            if (align === 'start') {
                paddingTop = 0;
                paddingBottom = first.height;
            } else if (align === 'end') {
                paddingTop = last.height;
                paddingBottom = 0;
            }
            this.paddingTop = paddingTop + padding;
            this.paddingBottom = paddingBottom + padding;
        }
    }
 _handleMargins() {
        if (this._margins) {
            this._margins.left = Math.max(this.paddingLeft, this._margins.left);
            this._margins.top = Math.max(this.paddingTop, this._margins.top);
            this._margins.right = Math.max(this.paddingRight, this._margins.right);
            this._margins.bottom = Math.max(this.paddingBottom, this._margins.bottom);
        }
    }
    afterFit() {
        callback(this.options.afterFit, [
            this
        ]);
    }
 isHorizontal() {
        const { axis , position  } = this.options;
        return position === 'top' || position === 'bottom' || axis === 'x';
    }
 isFullSize() {
        return this.options.fullSize;
    }
 _convertTicksToLabels(ticks) {
        this.beforeTickToLabelConversion();
        this.generateTickLabels(ticks);
        let i, ilen;
        for(i = 0, ilen = ticks.length; i < ilen; i++){
            if (isNullOrUndef(ticks[i].label)) {
                ticks.splice(i, 1);
                ilen--;
                i--;
            }
        }
        this.afterTickToLabelConversion();
    }
 _getLabelSizes() {
        let labelSizes = this._labelSizes;
        if (!labelSizes) {
            const sampleSize = this.options.ticks.sampleSize;
            let ticks = this.ticks;
            if (sampleSize < ticks.length) {
                ticks = sample(ticks, sampleSize);
            }
            this._labelSizes = labelSizes = this._computeLabelSizes(ticks, ticks.length, this.options.ticks.maxTicksLimit);
        }
        return labelSizes;
    }
 _computeLabelSizes(ticks, length, maxTicksLimit) {
        const { ctx , _longestTextCache: caches  } = this;
        const widths = [];
        const heights = [];
        const increment = Math.floor(length / getTicksLimit(length, maxTicksLimit));
        let widestLabelSize = 0;
        let highestLabelSize = 0;
        let i, j, jlen, label, tickFont, fontString, cache, lineHeight, width, height, nestedLabel;
        for(i = 0; i < length; i += increment){
            label = ticks[i].label;
            tickFont = this._resolveTickFontOptions(i);
            ctx.font = fontString = tickFont.string;
            cache = caches[fontString] = caches[fontString] || {
                data: {},
                gc: []
            };
            lineHeight = tickFont.lineHeight;
            width = height = 0;
            if (!isNullOrUndef(label) && !isArray(label)) {
                width = _measureText(ctx, cache.data, cache.gc, width, label);
                height = lineHeight;
            } else if (isArray(label)) {
                for(j = 0, jlen = label.length; j < jlen; ++j){
                    nestedLabel =  label[j];
                    if (!isNullOrUndef(nestedLabel) && !isArray(nestedLabel)) {
                        width = _measureText(ctx, cache.data, cache.gc, width, nestedLabel);
                        height += lineHeight;
                    }
                }
            }
            widths.push(width);
            heights.push(height);
            widestLabelSize = Math.max(width, widestLabelSize);
            highestLabelSize = Math.max(height, highestLabelSize);
        }
        garbageCollect(caches, length);
        const widest = widths.indexOf(widestLabelSize);
        const highest = heights.indexOf(highestLabelSize);
        const valueAt = (idx)=>({
                width: widths[idx] || 0,
                height: heights[idx] || 0
            });
        return {
            first: valueAt(0),
            last: valueAt(length - 1),
            widest: valueAt(widest),
            highest: valueAt(highest),
            widths,
            heights
        };
    }
 getLabelForValue(value) {
        return value;
    }
 getPixelForValue(value, index) {
        return NaN;
    }
 getValueForPixel(pixel) {}
 getPixelForTick(index) {
        const ticks = this.ticks;
        if (index < 0 || index > ticks.length - 1) {
            return null;
        }
        return this.getPixelForValue(ticks[index].value);
    }
 getPixelForDecimal(decimal) {
        if (this._reversePixels) {
            decimal = 1 - decimal;
        }
        const pixel = this._startPixel + decimal * this._length;
        return _int16Range(this._alignToPixels ? _alignPixel(this.chart, pixel, 0) : pixel);
    }
 getDecimalForPixel(pixel) {
        const decimal = (pixel - this._startPixel) / this._length;
        return this._reversePixels ? 1 - decimal : decimal;
    }
 getBasePixel() {
        return this.getPixelForValue(this.getBaseValue());
    }
 getBaseValue() {
        const { min , max  } = this;
        return min < 0 && max < 0 ? max : min > 0 && max > 0 ? min : 0;
    }
 getContext(index) {
        const ticks = this.ticks || [];
        if (index >= 0 && index < ticks.length) {
            const tick = ticks[index];
            return tick.$context || (tick.$context = createTickContext(this.getContext(), index, tick));
        }
        return this.$context || (this.$context = createScaleContext(this.chart.getContext(), this));
    }
 _tickSize() {
        const optionTicks = this.options.ticks;
        const rot = toRadians(this.labelRotation);
        const cos = Math.abs(Math.cos(rot));
        const sin = Math.abs(Math.sin(rot));
        const labelSizes = this._getLabelSizes();
        const padding = optionTicks.autoSkipPadding || 0;
        const w = labelSizes ? labelSizes.widest.width + padding : 0;
        const h = labelSizes ? labelSizes.highest.height + padding : 0;
        return this.isHorizontal() ? h * cos > w * sin ? w / cos : h / sin : h * sin < w * cos ? h / cos : w / sin;
    }
 _isVisible() {
        const display = this.options.display;
        if (display !== 'auto') {
            return !!display;
        }
        return this.getMatchingVisibleMetas().length > 0;
    }
 _computeGridLineItems(chartArea) {
        const axis = this.axis;
        const chart = this.chart;
        const options = this.options;
        const { grid , position , border  } = options;
        const offset = grid.offset;
        const isHorizontal = this.isHorizontal();
        const ticks = this.ticks;
        const ticksLength = ticks.length + (offset ? 1 : 0);
        const tl = getTickMarkLength(grid);
        const items = [];
        const borderOpts = border.setContext(this.getContext());
        const axisWidth = borderOpts.display ? borderOpts.width : 0;
        const axisHalfWidth = axisWidth / 2;
        const alignBorderValue = function(pixel) {
            return _alignPixel(chart, pixel, axisWidth);
        };
        let borderValue, i, lineValue, alignedLineValue;
        let tx1, ty1, tx2, ty2, x1, y1, x2, y2;
        if (position === 'top') {
            borderValue = alignBorderValue(this.bottom);
            ty1 = this.bottom - tl;
            ty2 = borderValue - axisHalfWidth;
            y1 = alignBorderValue(chartArea.top) + axisHalfWidth;
            y2 = chartArea.bottom;
        } else if (position === 'bottom') {
            borderValue = alignBorderValue(this.top);
            y1 = chartArea.top;
            y2 = alignBorderValue(chartArea.bottom) - axisHalfWidth;
            ty1 = borderValue + axisHalfWidth;
            ty2 = this.top + tl;
        } else if (position === 'left') {
            borderValue = alignBorderValue(this.right);
            tx1 = this.right - tl;
            tx2 = borderValue - axisHalfWidth;
            x1 = alignBorderValue(chartArea.left) + axisHalfWidth;
            x2 = chartArea.right;
        } else if (position === 'right') {
            borderValue = alignBorderValue(this.left);
            x1 = chartArea.left;
            x2 = alignBorderValue(chartArea.right) - axisHalfWidth;
            tx1 = borderValue + axisHalfWidth;
            tx2 = this.left + tl;
        } else if (axis === 'x') {
            if (position === 'center') {
                borderValue = alignBorderValue((chartArea.top + chartArea.bottom) / 2 + 0.5);
            } else if (isObject(position)) {
                const positionAxisID = Object.keys(position)[0];
                const value = position[positionAxisID];
                borderValue = alignBorderValue(this.chart.scales[positionAxisID].getPixelForValue(value));
            }
            y1 = chartArea.top;
            y2 = chartArea.bottom;
            ty1 = borderValue + axisHalfWidth;
            ty2 = ty1 + tl;
        } else if (axis === 'y') {
            if (position === 'center') {
                borderValue = alignBorderValue((chartArea.left + chartArea.right) / 2);
            } else if (isObject(position)) {
                const positionAxisID = Object.keys(position)[0];
                const value = position[positionAxisID];
                borderValue = alignBorderValue(this.chart.scales[positionAxisID].getPixelForValue(value));
            }
            tx1 = borderValue - axisHalfWidth;
            tx2 = tx1 - tl;
            x1 = chartArea.left;
            x2 = chartArea.right;
        }
        const limit = valueOrDefault(options.ticks.maxTicksLimit, ticksLength);
        const step = Math.max(1, Math.ceil(ticksLength / limit));
        for(i = 0; i < ticksLength; i += step){
            const context = this.getContext(i);
            const optsAtIndex = grid.setContext(context);
            const optsAtIndexBorder = border.setContext(context);
            const lineWidth = optsAtIndex.lineWidth;
            const lineColor = optsAtIndex.color;
            const borderDash = optsAtIndexBorder.dash || [];
            const borderDashOffset = optsAtIndexBorder.dashOffset;
            const tickWidth = optsAtIndex.tickWidth;
            const tickColor = optsAtIndex.tickColor;
            const tickBorderDash = optsAtIndex.tickBorderDash || [];
            const tickBorderDashOffset = optsAtIndex.tickBorderDashOffset;
            lineValue = getPixelForGridLine(this, i, offset);
            if (lineValue === undefined) {
                continue;
            }
            alignedLineValue = _alignPixel(chart, lineValue, lineWidth);
            if (isHorizontal) {
                tx1 = tx2 = x1 = x2 = alignedLineValue;
            } else {
                ty1 = ty2 = y1 = y2 = alignedLineValue;
            }
            items.push({
                tx1,
                ty1,
                tx2,
                ty2,
                x1,
                y1,
                x2,
                y2,
                width: lineWidth,
                color: lineColor,
                borderDash,
                borderDashOffset,
                tickWidth,
                tickColor,
                tickBorderDash,
                tickBorderDashOffset
            });
        }
        this._ticksLength = ticksLength;
        this._borderValue = borderValue;
        return items;
    }
 _computeLabelItems(chartArea) {
        const axis = this.axis;
        const options = this.options;
        const { position , ticks: optionTicks  } = options;
        const isHorizontal = this.isHorizontal();
        const ticks = this.ticks;
        const { align , crossAlign , padding , mirror  } = optionTicks;
        const tl = getTickMarkLength(options.grid);
        const tickAndPadding = tl + padding;
        const hTickAndPadding = mirror ? -padding : tickAndPadding;
        const rotation = -toRadians(this.labelRotation);
        const items = [];
        let i, ilen, tick, label, x, y, textAlign, pixel, font, lineHeight, lineCount, textOffset;
        let textBaseline = 'middle';
        if (position === 'top') {
            y = this.bottom - hTickAndPadding;
            textAlign = this._getXAxisLabelAlignment();
        } else if (position === 'bottom') {
            y = this.top + hTickAndPadding;
            textAlign = this._getXAxisLabelAlignment();
        } else if (position === 'left') {
            const ret = this._getYAxisLabelAlignment(tl);
            textAlign = ret.textAlign;
            x = ret.x;
        } else if (position === 'right') {
            const ret = this._getYAxisLabelAlignment(tl);
            textAlign = ret.textAlign;
            x = ret.x;
        } else if (axis === 'x') {
            if (position === 'center') {
                y = (chartArea.top + chartArea.bottom) / 2 + tickAndPadding;
            } else if (isObject(position)) {
                const positionAxisID = Object.keys(position)[0];
                const value = position[positionAxisID];
                y = this.chart.scales[positionAxisID].getPixelForValue(value) + tickAndPadding;
            }
            textAlign = this._getXAxisLabelAlignment();
        } else if (axis === 'y') {
            if (position === 'center') {
                x = (chartArea.left + chartArea.right) / 2 - tickAndPadding;
            } else if (isObject(position)) {
                const positionAxisID = Object.keys(position)[0];
                const value = position[positionAxisID];
                x = this.chart.scales[positionAxisID].getPixelForValue(value);
            }
            textAlign = this._getYAxisLabelAlignment(tl).textAlign;
        }
        if (axis === 'y') {
            if (align === 'start') {
                textBaseline = 'top';
            } else if (align === 'end') {
                textBaseline = 'bottom';
            }
        }
        const labelSizes = this._getLabelSizes();
        for(i = 0, ilen = ticks.length; i < ilen; ++i){
            tick = ticks[i];
            label = tick.label;
            const optsAtIndex = optionTicks.setContext(this.getContext(i));
            pixel = this.getPixelForTick(i) + optionTicks.labelOffset;
            font = this._resolveTickFontOptions(i);
            lineHeight = font.lineHeight;
            lineCount = isArray(label) ? label.length : 1;
            const halfCount = lineCount / 2;
            const color = optsAtIndex.color;
            const strokeColor = optsAtIndex.textStrokeColor;
            const strokeWidth = optsAtIndex.textStrokeWidth;
            let tickTextAlign = textAlign;
            if (isHorizontal) {
                x = pixel;
                if (textAlign === 'inner') {
                    if (i === ilen - 1) {
                        tickTextAlign = !this.options.reverse ? 'right' : 'left';
                    } else if (i === 0) {
                        tickTextAlign = !this.options.reverse ? 'left' : 'right';
                    } else {
                        tickTextAlign = 'center';
                    }
                }
                if (position === 'top') {
                    if (crossAlign === 'near' || rotation !== 0) {
                        textOffset = -lineCount * lineHeight + lineHeight / 2;
                    } else if (crossAlign === 'center') {
                        textOffset = -labelSizes.highest.height / 2 - halfCount * lineHeight + lineHeight;
                    } else {
                        textOffset = -labelSizes.highest.height + lineHeight / 2;
                    }
                } else {
                    if (crossAlign === 'near' || rotation !== 0) {
                        textOffset = lineHeight / 2;
                    } else if (crossAlign === 'center') {
                        textOffset = labelSizes.highest.height / 2 - halfCount * lineHeight;
                    } else {
                        textOffset = labelSizes.highest.height - lineCount * lineHeight;
                    }
                }
                if (mirror) {
                    textOffset *= -1;
                }
                if (rotation !== 0 && !optsAtIndex.showLabelBackdrop) {
                    x += lineHeight / 2 * Math.sin(rotation);
                }
            } else {
                y = pixel;
                textOffset = (1 - lineCount) * lineHeight / 2;
            }
            let backdrop;
            if (optsAtIndex.showLabelBackdrop) {
                const labelPadding = toPadding(optsAtIndex.backdropPadding);
                const height = labelSizes.heights[i];
                const width = labelSizes.widths[i];
                let top = textOffset - labelPadding.top;
                let left = 0 - labelPadding.left;
                switch(textBaseline){
                    case 'middle':
                        top -= height / 2;
                        break;
                    case 'bottom':
                        top -= height;
                        break;
                }
                switch(textAlign){
                    case 'center':
                        left -= width / 2;
                        break;
                    case 'right':
                        left -= width;
                        break;
                    case 'inner':
                        if (i === ilen - 1) {
                            left -= width;
                        } else if (i > 0) {
                            left -= width / 2;
                        }
                        break;
                }
                backdrop = {
                    left,
                    top,
                    width: width + labelPadding.width,
                    height: height + labelPadding.height,
                    color: optsAtIndex.backdropColor
                };
            }
            items.push({
                label,
                font,
                textOffset,
                options: {
                    rotation,
                    color,
                    strokeColor,
                    strokeWidth,
                    textAlign: tickTextAlign,
                    textBaseline,
                    translation: [
                        x,
                        y
                    ],
                    backdrop
                }
            });
        }
        return items;
    }
    _getXAxisLabelAlignment() {
        const { position , ticks  } = this.options;
        const rotation = -toRadians(this.labelRotation);
        if (rotation) {
            return position === 'top' ? 'left' : 'right';
        }
        let align = 'center';
        if (ticks.align === 'start') {
            align = 'left';
        } else if (ticks.align === 'end') {
            align = 'right';
        } else if (ticks.align === 'inner') {
            align = 'inner';
        }
        return align;
    }
    _getYAxisLabelAlignment(tl) {
        const { position , ticks: { crossAlign , mirror , padding  }  } = this.options;
        const labelSizes = this._getLabelSizes();
        const tickAndPadding = tl + padding;
        const widest = labelSizes.widest.width;
        let textAlign;
        let x;
        if (position === 'left') {
            if (mirror) {
                x = this.right + padding;
                if (crossAlign === 'near') {
                    textAlign = 'left';
                } else if (crossAlign === 'center') {
                    textAlign = 'center';
                    x += widest / 2;
                } else {
                    textAlign = 'right';
                    x += widest;
                }
            } else {
                x = this.right - tickAndPadding;
                if (crossAlign === 'near') {
                    textAlign = 'right';
                } else if (crossAlign === 'center') {
                    textAlign = 'center';
                    x -= widest / 2;
                } else {
                    textAlign = 'left';
                    x = this.left;
                }
            }
        } else if (position === 'right') {
            if (mirror) {
                x = this.left + padding;
                if (crossAlign === 'near') {
                    textAlign = 'right';
                } else if (crossAlign === 'center') {
                    textAlign = 'center';
                    x -= widest / 2;
                } else {
                    textAlign = 'left';
                    x -= widest;
                }
            } else {
                x = this.left + tickAndPadding;
                if (crossAlign === 'near') {
                    textAlign = 'left';
                } else if (crossAlign === 'center') {
                    textAlign = 'center';
                    x += widest / 2;
                } else {
                    textAlign = 'right';
                    x = this.right;
                }
            }
        } else {
            textAlign = 'right';
        }
        return {
            textAlign,
            x
        };
    }
 _computeLabelArea() {
        if (this.options.ticks.mirror) {
            return;
        }
        const chart = this.chart;
        const position = this.options.position;
        if (position === 'left' || position === 'right') {
            return {
                top: 0,
                left: this.left,
                bottom: chart.height,
                right: this.right
            };
        }
        if (position === 'top' || position === 'bottom') {
            return {
                top: this.top,
                left: 0,
                bottom: this.bottom,
                right: chart.width
            };
        }
    }
 drawBackground() {
        const { ctx , options: { backgroundColor  } , left , top , width , height  } = this;
        if (backgroundColor) {
            ctx.save();
            ctx.fillStyle = backgroundColor;
            ctx.fillRect(left, top, width, height);
            ctx.restore();
        }
    }
    getLineWidthForValue(value) {
        const grid = this.options.grid;
        if (!this._isVisible() || !grid.display) {
            return 0;
        }
        const ticks = this.ticks;
        const index = ticks.findIndex((t)=>t.value === value);
        if (index >= 0) {
            const opts = grid.setContext(this.getContext(index));
            return opts.lineWidth;
        }
        return 0;
    }
 drawGrid(chartArea) {
        const grid = this.options.grid;
        const ctx = this.ctx;
        const items = this._gridLineItems || (this._gridLineItems = this._computeGridLineItems(chartArea));
        let i, ilen;
        const drawLine = (p1, p2, style)=>{
            if (!style.width || !style.color) {
                return;
            }
            ctx.save();
            ctx.lineWidth = style.width;
            ctx.strokeStyle = style.color;
            ctx.setLineDash(style.borderDash || []);
            ctx.lineDashOffset = style.borderDashOffset;
            ctx.beginPath();
            ctx.moveTo(p1.x, p1.y);
            ctx.lineTo(p2.x, p2.y);
            ctx.stroke();
            ctx.restore();
        };
        if (grid.display) {
            for(i = 0, ilen = items.length; i < ilen; ++i){
                const item = items[i];
                if (grid.drawOnChartArea) {
                    drawLine({
                        x: item.x1,
                        y: item.y1
                    }, {
                        x: item.x2,
                        y: item.y2
                    }, item);
                }
                if (grid.drawTicks) {
                    drawLine({
                        x: item.tx1,
                        y: item.ty1
                    }, {
                        x: item.tx2,
                        y: item.ty2
                    }, {
                        color: item.tickColor,
                        width: item.tickWidth,
                        borderDash: item.tickBorderDash,
                        borderDashOffset: item.tickBorderDashOffset
                    });
                }
            }
        }
    }
 drawBorder() {
        const { chart , ctx , options: { border , grid  }  } = this;
        const borderOpts = border.setContext(this.getContext());
        const axisWidth = border.display ? borderOpts.width : 0;
        if (!axisWidth) {
            return;
        }
        const lastLineWidth = grid.setContext(this.getContext(0)).lineWidth;
        const borderValue = this._borderValue;
        let x1, x2, y1, y2;
        if (this.isHorizontal()) {
            x1 = _alignPixel(chart, this.left, axisWidth) - axisWidth / 2;
            x2 = _alignPixel(chart, this.right, lastLineWidth) + lastLineWidth / 2;
            y1 = y2 = borderValue;
        } else {
            y1 = _alignPixel(chart, this.top, axisWidth) - axisWidth / 2;
            y2 = _alignPixel(chart, this.bottom, lastLineWidth) + lastLineWidth / 2;
            x1 = x2 = borderValue;
        }
        ctx.save();
        ctx.lineWidth = borderOpts.width;
        ctx.strokeStyle = borderOpts.color;
        ctx.beginPath();
        ctx.moveTo(x1, y1);
        ctx.lineTo(x2, y2);
        ctx.stroke();
        ctx.restore();
    }
 drawLabels(chartArea) {
        const optionTicks = this.options.ticks;
        if (!optionTicks.display) {
            return;
        }
        const ctx = this.ctx;
        const area = this._computeLabelArea();
        if (area) {
            clipArea(ctx, area);
        }
        const items = this.getLabelItems(chartArea);
        for (const item of items){
            const renderTextOptions = item.options;
            const tickFont = item.font;
            const label = item.label;
            const y = item.textOffset;
            renderText(ctx, label, 0, y, tickFont, renderTextOptions);
        }
        if (area) {
            unclipArea(ctx);
        }
    }
 drawTitle() {
        const { ctx , options: { position , title , reverse  }  } = this;
        if (!title.display) {
            return;
        }
        const font = toFont(title.font);
        const padding = toPadding(title.padding);
        const align = title.align;
        let offset = font.lineHeight / 2;
        if (position === 'bottom' || position === 'center' || isObject(position)) {
            offset += padding.bottom;
            if (isArray(title.text)) {
                offset += font.lineHeight * (title.text.length - 1);
            }
        } else {
            offset += padding.top;
        }
        const { titleX , titleY , maxWidth , rotation  } = titleArgs(this, offset, position, align);
        renderText(ctx, title.text, 0, 0, font, {
            color: title.color,
            maxWidth,
            rotation,
            textAlign: titleAlign(align, position, reverse),
            textBaseline: 'middle',
            translation: [
                titleX,
                titleY
            ]
        });
    }
    draw(chartArea) {
        if (!this._isVisible()) {
            return;
        }
        this.drawBackground();
        this.drawGrid(chartArea);
        this.drawBorder();
        this.drawTitle();
        this.drawLabels(chartArea);
    }
 _layers() {
        const opts = this.options;
        const tz = opts.ticks && opts.ticks.z || 0;
        const gz = valueOrDefault(opts.grid && opts.grid.z, -1);
        const bz = valueOrDefault(opts.border && opts.border.z, 0);
        if (!this._isVisible() || this.draw !== Scale.prototype.draw) {
            return [
                {
                    z: tz,
                    draw: (chartArea)=>{
                        this.draw(chartArea);
                    }
                }
            ];
        }
        return [
            {
                z: gz,
                draw: (chartArea)=>{
                    this.drawBackground();
                    this.drawGrid(chartArea);
                    this.drawTitle();
                }
            },
            {
                z: bz,
                draw: ()=>{
                    this.drawBorder();
                }
            },
            {
                z: tz,
                draw: (chartArea)=>{
                    this.drawLabels(chartArea);
                }
            }
        ];
    }
 getMatchingVisibleMetas(type) {
        const metas = this.chart.getSortedVisibleDatasetMetas();
        const axisID = this.axis + 'AxisID';
        const result = [];
        let i, ilen;
        for(i = 0, ilen = metas.length; i < ilen; ++i){
            const meta = metas[i];
            if (meta[axisID] === this.id && (!type || meta.type === type)) {
                result.push(meta);
            }
        }
        return result;
    }
 _resolveTickFontOptions(index) {
        const opts = this.options.ticks.setContext(this.getContext(index));
        return toFont(opts.font);
    }
 _maxDigits() {
        const fontSize = this._resolveTickFontOptions(0).lineHeight;
        return (this.isHorizontal() ? this.width : this.height) / fontSize;
    }
}

class TypedRegistry {
    constructor(type, scope, override){
        this.type = type;
        this.scope = scope;
        this.override = override;
        this.items = Object.create(null);
    }
    isForType(type) {
        return Object.prototype.isPrototypeOf.call(this.type.prototype, type.prototype);
    }
 register(item) {
        const proto = Object.getPrototypeOf(item);
        let parentScope;
        if (isIChartComponent(proto)) {
            parentScope = this.register(proto);
        }
        const items = this.items;
        const id = item.id;
        const scope = this.scope + '.' + id;
        if (!id) {
            throw new Error('class does not have id: ' + item);
        }
        if (id in items) {
            return scope;
        }
        items[id] = item;
        registerDefaults(item, scope, parentScope);
        if (this.override) {
            defaults.override(item.id, item.overrides);
        }
        return scope;
    }
 get(id) {
        return this.items[id];
    }
 unregister(item) {
        const items = this.items;
        const id = item.id;
        const scope = this.scope;
        if (id in items) {
            delete items[id];
        }
        if (scope && id in defaults[scope]) {
            delete defaults[scope][id];
            if (this.override) {
                delete overrides[id];
            }
        }
    }
}
function registerDefaults(item, scope, parentScope) {
    const itemDefaults = merge(Object.create(null), [
        parentScope ? defaults.get(parentScope) : {},
        defaults.get(scope),
        item.defaults
    ]);
    defaults.set(scope, itemDefaults);
    if (item.defaultRoutes) {
        routeDefaults(scope, item.defaultRoutes);
    }
    if (item.descriptors) {
        defaults.describe(scope, item.descriptors);
    }
}
function routeDefaults(scope, routes) {
    Object.keys(routes).forEach((property)=>{
        const propertyParts = property.split('.');
        const sourceName = propertyParts.pop();
        const sourceScope = [
            scope
        ].concat(propertyParts).join('.');
        const parts = routes[property].split('.');
        const targetName = parts.pop();
        const targetScope = parts.join('.');
        defaults.route(sourceScope, sourceName, targetScope, targetName);
    });
}
function isIChartComponent(proto) {
    return 'id' in proto && 'defaults' in proto;
}

class Registry {
    constructor(){
        this.controllers = new TypedRegistry(DatasetController, 'datasets', true);
        this.elements = new TypedRegistry(Element, 'elements');
        this.plugins = new TypedRegistry(Object, 'plugins');
        this.scales = new TypedRegistry(Scale, 'scales');
        this._typedRegistries = [
            this.controllers,
            this.scales,
            this.elements
        ];
    }
 add(...args) {
        this._each('register', args);
    }
    remove(...args) {
        this._each('unregister', args);
    }
 addControllers(...args) {
        this._each('register', args, this.controllers);
    }
 addElements(...args) {
        this._each('register', args, this.elements);
    }
 addPlugins(...args) {
        this._each('register', args, this.plugins);
    }
 addScales(...args) {
        this._each('register', args, this.scales);
    }
 getController(id) {
        return this._get(id, this.controllers, 'controller');
    }
 getElement(id) {
        return this._get(id, this.elements, 'element');
    }
 getPlugin(id) {
        return this._get(id, this.plugins, 'plugin');
    }
 getScale(id) {
        return this._get(id, this.scales, 'scale');
    }
 removeControllers(...args) {
        this._each('unregister', args, this.controllers);
    }
 removeElements(...args) {
        this._each('unregister', args, this.elements);
    }
 removePlugins(...args) {
        this._each('unregister', args, this.plugins);
    }
 removeScales(...args) {
        this._each('unregister', args, this.scales);
    }
 _each(method, args, typedRegistry) {
        [
            ...args
        ].forEach((arg)=>{
            const reg = typedRegistry || this._getRegistryForType(arg);
            if (typedRegistry || reg.isForType(arg) || reg === this.plugins && arg.id) {
                this._exec(method, reg, arg);
            } else {
                each(arg, (item)=>{
                    const itemReg = typedRegistry || this._getRegistryForType(item);
                    this._exec(method, itemReg, item);
                });
            }
        });
    }
 _exec(method, registry, component) {
        const camelMethod = _capitalize(method);
        callback(component['before' + camelMethod], [], component);
        registry[method](component);
        callback(component['after' + camelMethod], [], component);
    }
 _getRegistryForType(type) {
        for(let i = 0; i < this._typedRegistries.length; i++){
            const reg = this._typedRegistries[i];
            if (reg.isForType(type)) {
                return reg;
            }
        }
        return this.plugins;
    }
 _get(id, typedRegistry, type) {
        const item = typedRegistry.get(id);
        if (item === undefined) {
            throw new Error('"' + id + '" is not a registered ' + type + '.');
        }
        return item;
    }
}
var registry = /* #__PURE__ */ new Registry();

class PluginService {
    constructor(){
        this._init = [];
    }
 notify(chart, hook, args, filter) {
        if (hook === 'beforeInit') {
            this._init = this._createDescriptors(chart, true);
            this._notify(this._init, chart, 'install');
        }
        const descriptors = filter ? this._descriptors(chart).filter(filter) : this._descriptors(chart);
        const result = this._notify(descriptors, chart, hook, args);
        if (hook === 'afterDestroy') {
            this._notify(descriptors, chart, 'stop');
            this._notify(this._init, chart, 'uninstall');
        }
        return result;
    }
 _notify(descriptors, chart, hook, args) {
        args = args || {};
        for (const descriptor of descriptors){
            const plugin = descriptor.plugin;
            const method = plugin[hook];
            const params = [
                chart,
                args,
                descriptor.options
            ];
            if (callback(method, params, plugin) === false && args.cancelable) {
                return false;
            }
        }
        return true;
    }
    invalidate() {
        if (!isNullOrUndef(this._cache)) {
            this._oldCache = this._cache;
            this._cache = undefined;
        }
    }
 _descriptors(chart) {
        if (this._cache) {
            return this._cache;
        }
        const descriptors = this._cache = this._createDescriptors(chart);
        this._notifyStateChanges(chart);
        return descriptors;
    }
    _createDescriptors(chart, all) {
        const config = chart && chart.config;
        const options = valueOrDefault(config.options && config.options.plugins, {});
        const plugins = allPlugins(config);
        return options === false && !all ? [] : createDescriptors(chart, plugins, options, all);
    }
 _notifyStateChanges(chart) {
        const previousDescriptors = this._oldCache || [];
        const descriptors = this._cache;
        const diff = (a, b)=>a.filter((x)=>!b.some((y)=>x.plugin.id === y.plugin.id));
        this._notify(diff(previousDescriptors, descriptors), chart, 'stop');
        this._notify(diff(descriptors, previousDescriptors), chart, 'start');
    }
}
 function allPlugins(config) {
    const localIds = {};
    const plugins = [];
    const keys = Object.keys(registry.plugins.items);
    for(let i = 0; i < keys.length; i++){
        plugins.push(registry.getPlugin(keys[i]));
    }
    const local = config.plugins || [];
    for(let i = 0; i < local.length; i++){
        const plugin = local[i];
        if (plugins.indexOf(plugin) === -1) {
            plugins.push(plugin);
            localIds[plugin.id] = true;
        }
    }
    return {
        plugins,
        localIds
    };
}
function getOpts(options, all) {
    if (!all && options === false) {
        return null;
    }
    if (options === true) {
        return {};
    }
    return options;
}
function createDescriptors(chart, { plugins , localIds  }, options, all) {
    const result = [];
    const context = chart.getContext();
    for (const plugin of plugins){
        const id = plugin.id;
        const opts = getOpts(options[id], all);
        if (opts === null) {
            continue;
        }
        result.push({
            plugin,
            options: pluginOpts(chart.config, {
                plugin,
                local: localIds[id]
            }, opts, context)
        });
    }
    return result;
}
function pluginOpts(config, { plugin , local  }, opts, context) {
    const keys = config.pluginScopeKeys(plugin);
    const scopes = config.getOptionScopes(opts, keys);
    if (local && plugin.defaults) {
        scopes.push(plugin.defaults);
    }
    return config.createResolver(scopes, context, [
        ''
    ], {
        scriptable: false,
        indexable: false,
        allKeys: true
    });
}

function getIndexAxis(type, options) {
    const datasetDefaults = defaults.datasets[type] || {};
    const datasetOptions = (options.datasets || {})[type] || {};
    return datasetOptions.indexAxis || options.indexAxis || datasetDefaults.indexAxis || 'x';
}
function getAxisFromDefaultScaleID(id, indexAxis) {
    let axis = id;
    if (id === '_index_') {
        axis = indexAxis;
    } else if (id === '_value_') {
        axis = indexAxis === 'x' ? 'y' : 'x';
    }
    return axis;
}
function getDefaultScaleIDFromAxis(axis, indexAxis) {
    return axis === indexAxis ? '_index_' : '_value_';
}
function idMatchesAxis(id) {
    if (id === 'x' || id === 'y' || id === 'r') {
        return id;
    }
}
function axisFromPosition(position) {
    if (position === 'top' || position === 'bottom') {
        return 'x';
    }
    if (position === 'left' || position === 'right') {
        return 'y';
    }
}
function determineAxis(id, ...scaleOptions) {
    if (idMatchesAxis(id)) {
        return id;
    }
    for (const opts of scaleOptions){
        const axis = opts.axis || axisFromPosition(opts.position) || id.length > 1 && idMatchesAxis(id[0].toLowerCase());
        if (axis) {
            return axis;
        }
    }
    throw new Error(`Cannot determine type of '${id}' axis. Please provide 'axis' or 'position' option.`);
}
function getAxisFromDataset(id, axis, dataset) {
    if (dataset[axis + 'AxisID'] === id) {
        return {
            axis
        };
    }
}
function retrieveAxisFromDatasets(id, config) {
    if (config.data && config.data.datasets) {
        const boundDs = config.data.datasets.filter((d)=>d.xAxisID === id || d.yAxisID === id);
        if (boundDs.length) {
            return getAxisFromDataset(id, 'x', boundDs[0]) || getAxisFromDataset(id, 'y', boundDs[0]);
        }
    }
    return {};
}
function mergeScaleConfig(config, options) {
    const chartDefaults = overrides[config.type] || {
        scales: {}
    };
    const configScales = options.scales || {};
    const chartIndexAxis = getIndexAxis(config.type, options);
    const scales = Object.create(null);
    Object.keys(configScales).forEach((id)=>{
        const scaleConf = configScales[id];
        if (!isObject(scaleConf)) {
            return console.error(`Invalid scale configuration for scale: ${id}`);
        }
        if (scaleConf._proxy) {
            return console.warn(`Ignoring resolver passed as options for scale: ${id}`);
        }
        const axis = determineAxis(id, scaleConf, retrieveAxisFromDatasets(id, config), defaults.scales[scaleConf.type]);
        const defaultId = getDefaultScaleIDFromAxis(axis, chartIndexAxis);
        const defaultScaleOptions = chartDefaults.scales || {};
        scales[id] = mergeIf(Object.create(null), [
            {
                axis
            },
            scaleConf,
            defaultScaleOptions[axis],
            defaultScaleOptions[defaultId]
        ]);
    });
    config.data.datasets.forEach((dataset)=>{
        const type = dataset.type || config.type;
        const indexAxis = dataset.indexAxis || getIndexAxis(type, options);
        const datasetDefaults = overrides[type] || {};
        const defaultScaleOptions = datasetDefaults.scales || {};
        Object.keys(defaultScaleOptions).forEach((defaultID)=>{
            const axis = getAxisFromDefaultScaleID(defaultID, indexAxis);
            const id = dataset[axis + 'AxisID'] || axis;
            scales[id] = scales[id] || Object.create(null);
            mergeIf(scales[id], [
                {
                    axis
                },
                configScales[id],
                defaultScaleOptions[defaultID]
            ]);
        });
    });
    Object.keys(scales).forEach((key)=>{
        const scale = scales[key];
        mergeIf(scale, [
            defaults.scales[scale.type],
            defaults.scale
        ]);
    });
    return scales;
}
function initOptions(config) {
    const options = config.options || (config.options = {});
    options.plugins = valueOrDefault(options.plugins, {});
    options.scales = mergeScaleConfig(config, options);
}
function initData(data) {
    data = data || {};
    data.datasets = data.datasets || [];
    data.labels = data.labels || [];
    return data;
}
function initConfig(config) {
    config = config || {};
    config.data = initData(config.data);
    initOptions(config);
    return config;
}
const keyCache = new Map();
const keysCached = new Set();
function cachedKeys(cacheKey, generate) {
    let keys = keyCache.get(cacheKey);
    if (!keys) {
        keys = generate();
        keyCache.set(cacheKey, keys);
        keysCached.add(keys);
    }
    return keys;
}
const addIfFound = (set, obj, key)=>{
    const opts = resolveObjectKey(obj, key);
    if (opts !== undefined) {
        set.add(opts);
    }
};
class Config {
    constructor(config){
        this._config = initConfig(config);
        this._scopeCache = new Map();
        this._resolverCache = new Map();
    }
    get platform() {
        return this._config.platform;
    }
    get type() {
        return this._config.type;
    }
    set type(type) {
        this._config.type = type;
    }
    get data() {
        return this._config.data;
    }
    set data(data) {
        this._config.data = initData(data);
    }
    get options() {
        return this._config.options;
    }
    set options(options) {
        this._config.options = options;
    }
    get plugins() {
        return this._config.plugins;
    }
    update() {
        const config = this._config;
        this.clearCache();
        initOptions(config);
    }
    clearCache() {
        this._scopeCache.clear();
        this._resolverCache.clear();
    }
 datasetScopeKeys(datasetType) {
        return cachedKeys(datasetType, ()=>[
                [
                    `datasets.${datasetType}`,
                    ''
                ]
            ]);
    }
 datasetAnimationScopeKeys(datasetType, transition) {
        return cachedKeys(`${datasetType}.transition.${transition}`, ()=>[
                [
                    `datasets.${datasetType}.transitions.${transition}`,
                    `transitions.${transition}`
                ],
                [
                    `datasets.${datasetType}`,
                    ''
                ]
            ]);
    }
 datasetElementScopeKeys(datasetType, elementType) {
        return cachedKeys(`${datasetType}-${elementType}`, ()=>[
                [
                    `datasets.${datasetType}.elements.${elementType}`,
                    `datasets.${datasetType}`,
                    `elements.${elementType}`,
                    ''
                ]
            ]);
    }
 pluginScopeKeys(plugin) {
        const id = plugin.id;
        const type = this.type;
        return cachedKeys(`${type}-plugin-${id}`, ()=>[
                [
                    `plugins.${id}`,
                    ...plugin.additionalOptionScopes || []
                ]
            ]);
    }
 _cachedScopes(mainScope, resetCache) {
        const _scopeCache = this._scopeCache;
        let cache = _scopeCache.get(mainScope);
        if (!cache || resetCache) {
            cache = new Map();
            _scopeCache.set(mainScope, cache);
        }
        return cache;
    }
 getOptionScopes(mainScope, keyLists, resetCache) {
        const { options , type  } = this;
        const cache = this._cachedScopes(mainScope, resetCache);
        const cached = cache.get(keyLists);
        if (cached) {
            return cached;
        }
        const scopes = new Set();
        keyLists.forEach((keys)=>{
            if (mainScope) {
                scopes.add(mainScope);
                keys.forEach((key)=>addIfFound(scopes, mainScope, key));
            }
            keys.forEach((key)=>addIfFound(scopes, options, key));
            keys.forEach((key)=>addIfFound(scopes, overrides[type] || {}, key));
            keys.forEach((key)=>addIfFound(scopes, defaults, key));
            keys.forEach((key)=>addIfFound(scopes, descriptors, key));
        });
        const array = Array.from(scopes);
        if (array.length === 0) {
            array.push(Object.create(null));
        }
        if (keysCached.has(keyLists)) {
            cache.set(keyLists, array);
        }
        return array;
    }
 chartOptionScopes() {
        const { options , type  } = this;
        return [
            options,
            overrides[type] || {},
            defaults.datasets[type] || {},
            {
                type
            },
            defaults,
            descriptors
        ];
    }
 resolveNamedOptions(scopes, names, context, prefixes = [
        ''
    ]) {
        const result = {
            $shared: true
        };
        const { resolver , subPrefixes  } = getResolver(this._resolverCache, scopes, prefixes);
        let options = resolver;
        if (needContext(resolver, names)) {
            result.$shared = false;
            context = isFunction(context) ? context() : context;
            const subResolver = this.createResolver(scopes, context, subPrefixes);
            options = _attachContext(resolver, context, subResolver);
        }
        for (const prop of names){
            result[prop] = options[prop];
        }
        return result;
    }
 createResolver(scopes, context, prefixes = [
        ''
    ], descriptorDefaults) {
        const { resolver  } = getResolver(this._resolverCache, scopes, prefixes);
        return isObject(context) ? _attachContext(resolver, context, undefined, descriptorDefaults) : resolver;
    }
}
function getResolver(resolverCache, scopes, prefixes) {
    let cache = resolverCache.get(scopes);
    if (!cache) {
        cache = new Map();
        resolverCache.set(scopes, cache);
    }
    const cacheKey = prefixes.join();
    let cached = cache.get(cacheKey);
    if (!cached) {
        const resolver = _createResolver(scopes, prefixes);
        cached = {
            resolver,
            subPrefixes: prefixes.filter((p)=>!p.toLowerCase().includes('hover'))
        };
        cache.set(cacheKey, cached);
    }
    return cached;
}
const hasFunction = (value)=>isObject(value) && Object.getOwnPropertyNames(value).some((key)=>isFunction(value[key]));
function needContext(proxy, names) {
    const { isScriptable , isIndexable  } = _descriptors(proxy);
    for (const prop of names){
        const scriptable = isScriptable(prop);
        const indexable = isIndexable(prop);
        const value = (indexable || scriptable) && proxy[prop];
        if (scriptable && (isFunction(value) || hasFunction(value)) || indexable && isArray(value)) {
            return true;
        }
    }
    return false;
}

var version = "4.4.2";

const KNOWN_POSITIONS = [
    'top',
    'bottom',
    'left',
    'right',
    'chartArea'
];
function positionIsHorizontal(position, axis) {
    return position === 'top' || position === 'bottom' || KNOWN_POSITIONS.indexOf(position) === -1 && axis === 'x';
}
function compare2Level(l1, l2) {
    return function(a, b) {
        return a[l1] === b[l1] ? a[l2] - b[l2] : a[l1] - b[l1];
    };
}
function onAnimationsComplete(context) {
    const chart = context.chart;
    const animationOptions = chart.options.animation;
    chart.notifyPlugins('afterRender');
    callback(animationOptions && animationOptions.onComplete, [
        context
    ], chart);
}
function onAnimationProgress(context) {
    const chart = context.chart;
    const animationOptions = chart.options.animation;
    callback(animationOptions && animationOptions.onProgress, [
        context
    ], chart);
}
 function getCanvas(item) {
    if (_isDomSupported() && typeof item === 'string') {
        item = document.getElementById(item);
    } else if (item && item.length) {
        item = item[0];
    }
    if (item && item.canvas) {
        item = item.canvas;
    }
    return item;
}
const instances = {};
const getChart = (key)=>{
    const canvas = getCanvas(key);
    return Object.values(instances).filter((c)=>c.canvas === canvas).pop();
};
function moveNumericKeys(obj, start, move) {
    const keys = Object.keys(obj);
    for (const key of keys){
        const intKey = +key;
        if (intKey >= start) {
            const value = obj[key];
            delete obj[key];
            if (move > 0 || intKey > start) {
                obj[intKey + move] = value;
            }
        }
    }
}
 function determineLastEvent(e, lastEvent, inChartArea, isClick) {
    if (!inChartArea || e.type === 'mouseout') {
        return null;
    }
    if (isClick) {
        return lastEvent;
    }
    return e;
}
function getSizeForArea(scale, chartArea, field) {
    return scale.options.clip ? scale[field] : chartArea[field];
}
function getDatasetArea(meta, chartArea) {
    const { xScale , yScale  } = meta;
    if (xScale && yScale) {
        return {
            left: getSizeForArea(xScale, chartArea, 'left'),
            right: getSizeForArea(xScale, chartArea, 'right'),
            top: getSizeForArea(yScale, chartArea, 'top'),
            bottom: getSizeForArea(yScale, chartArea, 'bottom')
        };
    }
    return chartArea;
}
class Chart {
    static defaults = defaults;
    static instances = instances;
    static overrides = overrides;
    static registry = registry;
    static version = version;
    static getChart = getChart;
    static register(...items) {
        registry.add(...items);
        invalidatePlugins();
    }
    static unregister(...items) {
        registry.remove(...items);
        invalidatePlugins();
    }
    constructor(item, userConfig){
        const config = this.config = new Config(userConfig);
        const initialCanvas = getCanvas(item);
        const existingChart = getChart(initialCanvas);
        if (existingChart) {
            throw new Error('Canvas is already in use. Chart with ID \'' + existingChart.id + '\'' + ' must be destroyed before the canvas with ID \'' + existingChart.canvas.id + '\' can be reused.');
        }
        const options = config.createResolver(config.chartOptionScopes(), this.getContext());
        this.platform = new (config.platform || _detectPlatform(initialCanvas))();
        this.platform.updateConfig(config);
        const context = this.platform.acquireContext(initialCanvas, options.aspectRatio);
        const canvas = context && context.canvas;
        const height = canvas && canvas.height;
        const width = canvas && canvas.width;
        this.id = uid();
        this.ctx = context;
        this.canvas = canvas;
        this.width = width;
        this.height = height;
        this._options = options;
        this._aspectRatio = this.aspectRatio;
        this._layers = [];
        this._metasets = [];
        this._stacks = undefined;
        this.boxes = [];
        this.currentDevicePixelRatio = undefined;
        this.chartArea = undefined;
        this._active = [];
        this._lastEvent = undefined;
        this._listeners = {};
         this._responsiveListeners = undefined;
        this._sortedMetasets = [];
        this.scales = {};
        this._plugins = new PluginService();
        this.$proxies = {};
        this._hiddenIndices = {};
        this.attached = false;
        this._animationsDisabled = undefined;
        this.$context = undefined;
        this._doResize = debounce((mode)=>this.update(mode), options.resizeDelay || 0);
        this._dataChanges = [];
        instances[this.id] = this;
        if (!context || !canvas) {
            console.error("Failed to create chart: can't acquire context from the given item");
            return;
        }
        animator.listen(this, 'complete', onAnimationsComplete);
        animator.listen(this, 'progress', onAnimationProgress);
        this._initialize();
        if (this.attached) {
            this.update();
        }
    }
    get aspectRatio() {
        const { options: { aspectRatio , maintainAspectRatio  } , width , height , _aspectRatio  } = this;
        if (!isNullOrUndef(aspectRatio)) {
            return aspectRatio;
        }
        if (maintainAspectRatio && _aspectRatio) {
            return _aspectRatio;
        }
        return height ? width / height : null;
    }
    get data() {
        return this.config.data;
    }
    set data(data) {
        this.config.data = data;
    }
    get options() {
        return this._options;
    }
    set options(options) {
        this.config.options = options;
    }
    get registry() {
        return registry;
    }
 _initialize() {
        this.notifyPlugins('beforeInit');
        if (this.options.responsive) {
            this.resize();
        } else {
            retinaScale(this, this.options.devicePixelRatio);
        }
        this.bindEvents();
        this.notifyPlugins('afterInit');
        return this;
    }
    clear() {
        clearCanvas(this.canvas, this.ctx);
        return this;
    }
    stop() {
        animator.stop(this);
        return this;
    }
 resize(width, height) {
        if (!animator.running(this)) {
            this._resize(width, height);
        } else {
            this._resizeBeforeDraw = {
                width,
                height
            };
        }
    }
    _resize(width, height) {
        const options = this.options;
        const canvas = this.canvas;
        const aspectRatio = options.maintainAspectRatio && this.aspectRatio;
        const newSize = this.platform.getMaximumSize(canvas, width, height, aspectRatio);
        const newRatio = options.devicePixelRatio || this.platform.getDevicePixelRatio();
        const mode = this.width ? 'resize' : 'attach';
        this.width = newSize.width;
        this.height = newSize.height;
        this._aspectRatio = this.aspectRatio;
        if (!retinaScale(this, newRatio, true)) {
            return;
        }
        this.notifyPlugins('resize', {
            size: newSize
        });
        callback(options.onResize, [
            this,
            newSize
        ], this);
        if (this.attached) {
            if (this._doResize(mode)) {
                this.render();
            }
        }
    }
    ensureScalesHaveIDs() {
        const options = this.options;
        const scalesOptions = options.scales || {};
        each(scalesOptions, (axisOptions, axisID)=>{
            axisOptions.id = axisID;
        });
    }
 buildOrUpdateScales() {
        const options = this.options;
        const scaleOpts = options.scales;
        const scales = this.scales;
        const updated = Object.keys(scales).reduce((obj, id)=>{
            obj[id] = false;
            return obj;
        }, {});
        let items = [];
        if (scaleOpts) {
            items = items.concat(Object.keys(scaleOpts).map((id)=>{
                const scaleOptions = scaleOpts[id];
                const axis = determineAxis(id, scaleOptions);
                const isRadial = axis === 'r';
                const isHorizontal = axis === 'x';
                return {
                    options: scaleOptions,
                    dposition: isRadial ? 'chartArea' : isHorizontal ? 'bottom' : 'left',
                    dtype: isRadial ? 'radialLinear' : isHorizontal ? 'category' : 'linear'
                };
            }));
        }
        each(items, (item)=>{
            const scaleOptions = item.options;
            const id = scaleOptions.id;
            const axis = determineAxis(id, scaleOptions);
            const scaleType = valueOrDefault(scaleOptions.type, item.dtype);
            if (scaleOptions.position === undefined || positionIsHorizontal(scaleOptions.position, axis) !== positionIsHorizontal(item.dposition)) {
                scaleOptions.position = item.dposition;
            }
            updated[id] = true;
            let scale = null;
            if (id in scales && scales[id].type === scaleType) {
                scale = scales[id];
            } else {
                const scaleClass = registry.getScale(scaleType);
                scale = new scaleClass({
                    id,
                    type: scaleType,
                    ctx: this.ctx,
                    chart: this
                });
                scales[scale.id] = scale;
            }
            scale.init(scaleOptions, options);
        });
        each(updated, (hasUpdated, id)=>{
            if (!hasUpdated) {
                delete scales[id];
            }
        });
        each(scales, (scale)=>{
            layouts.configure(this, scale, scale.options);
            layouts.addBox(this, scale);
        });
    }
 _updateMetasets() {
        const metasets = this._metasets;
        const numData = this.data.datasets.length;
        const numMeta = metasets.length;
        metasets.sort((a, b)=>a.index - b.index);
        if (numMeta > numData) {
            for(let i = numData; i < numMeta; ++i){
                this._destroyDatasetMeta(i);
            }
            metasets.splice(numData, numMeta - numData);
        }
        this._sortedMetasets = metasets.slice(0).sort(compare2Level('order', 'index'));
    }
 _removeUnreferencedMetasets() {
        const { _metasets: metasets , data: { datasets  }  } = this;
        if (metasets.length > datasets.length) {
            delete this._stacks;
        }
        metasets.forEach((meta, index)=>{
            if (datasets.filter((x)=>x === meta._dataset).length === 0) {
                this._destroyDatasetMeta(index);
            }
        });
    }
    buildOrUpdateControllers() {
        const newControllers = [];
        const datasets = this.data.datasets;
        let i, ilen;
        this._removeUnreferencedMetasets();
        for(i = 0, ilen = datasets.length; i < ilen; i++){
            const dataset = datasets[i];
            let meta = this.getDatasetMeta(i);
            const type = dataset.type || this.config.type;
            if (meta.type && meta.type !== type) {
                this._destroyDatasetMeta(i);
                meta = this.getDatasetMeta(i);
            }
            meta.type = type;
            meta.indexAxis = dataset.indexAxis || getIndexAxis(type, this.options);
            meta.order = dataset.order || 0;
            meta.index = i;
            meta.label = '' + dataset.label;
            meta.visible = this.isDatasetVisible(i);
            if (meta.controller) {
                meta.controller.updateIndex(i);
                meta.controller.linkScales();
            } else {
                const ControllerClass = registry.getController(type);
                const { datasetElementType , dataElementType  } = defaults.datasets[type];
                Object.assign(ControllerClass, {
                    dataElementType: registry.getElement(dataElementType),
                    datasetElementType: datasetElementType && registry.getElement(datasetElementType)
                });
                meta.controller = new ControllerClass(this, i);
                newControllers.push(meta.controller);
            }
        }
        this._updateMetasets();
        return newControllers;
    }
 _resetElements() {
        each(this.data.datasets, (dataset, datasetIndex)=>{
            this.getDatasetMeta(datasetIndex).controller.reset();
        }, this);
    }
 reset() {
        this._resetElements();
        this.notifyPlugins('reset');
    }
    update(mode) {
        const config = this.config;
        config.update();
        const options = this._options = config.createResolver(config.chartOptionScopes(), this.getContext());
        const animsDisabled = this._animationsDisabled = !options.animation;
        this._updateScales();
        this._checkEventBindings();
        this._updateHiddenIndices();
        this._plugins.invalidate();
        if (this.notifyPlugins('beforeUpdate', {
            mode,
            cancelable: true
        }) === false) {
            return;
        }
        const newControllers = this.buildOrUpdateControllers();
        this.notifyPlugins('beforeElementsUpdate');
        let minPadding = 0;
        for(let i = 0, ilen = this.data.datasets.length; i < ilen; i++){
            const { controller  } = this.getDatasetMeta(i);
            const reset = !animsDisabled && newControllers.indexOf(controller) === -1;
            controller.buildOrUpdateElements(reset);
            minPadding = Math.max(+controller.getMaxOverflow(), minPadding);
        }
        minPadding = this._minPadding = options.layout.autoPadding ? minPadding : 0;
        this._updateLayout(minPadding);
        if (!animsDisabled) {
            each(newControllers, (controller)=>{
                controller.reset();
            });
        }
        this._updateDatasets(mode);
        this.notifyPlugins('afterUpdate', {
            mode
        });
        this._layers.sort(compare2Level('z', '_idx'));
        const { _active , _lastEvent  } = this;
        if (_lastEvent) {
            this._eventHandler(_lastEvent, true);
        } else if (_active.length) {
            this._updateHoverStyles(_active, _active, true);
        }
        this.render();
    }
 _updateScales() {
        each(this.scales, (scale)=>{
            layouts.removeBox(this, scale);
        });
        this.ensureScalesHaveIDs();
        this.buildOrUpdateScales();
    }
 _checkEventBindings() {
        const options = this.options;
        const existingEvents = new Set(Object.keys(this._listeners));
        const newEvents = new Set(options.events);
        if (!setsEqual(existingEvents, newEvents) || !!this._responsiveListeners !== options.responsive) {
            this.unbindEvents();
            this.bindEvents();
        }
    }
 _updateHiddenIndices() {
        const { _hiddenIndices  } = this;
        const changes = this._getUniformDataChanges() || [];
        for (const { method , start , count  } of changes){
            const move = method === '_removeElements' ? -count : count;
            moveNumericKeys(_hiddenIndices, start, move);
        }
    }
 _getUniformDataChanges() {
        const _dataChanges = this._dataChanges;
        if (!_dataChanges || !_dataChanges.length) {
            return;
        }
        this._dataChanges = [];
        const datasetCount = this.data.datasets.length;
        const makeSet = (idx)=>new Set(_dataChanges.filter((c)=>c[0] === idx).map((c, i)=>i + ',' + c.splice(1).join(',')));
        const changeSet = makeSet(0);
        for(let i = 1; i < datasetCount; i++){
            if (!setsEqual(changeSet, makeSet(i))) {
                return;
            }
        }
        return Array.from(changeSet).map((c)=>c.split(',')).map((a)=>({
                method: a[1],
                start: +a[2],
                count: +a[3]
            }));
    }
 _updateLayout(minPadding) {
        if (this.notifyPlugins('beforeLayout', {
            cancelable: true
        }) === false) {
            return;
        }
        layouts.update(this, this.width, this.height, minPadding);
        const area = this.chartArea;
        const noArea = area.width <= 0 || area.height <= 0;
        this._layers = [];
        each(this.boxes, (box)=>{
            if (noArea && box.position === 'chartArea') {
                return;
            }
            if (box.configure) {
                box.configure();
            }
            this._layers.push(...box._layers());
        }, this);
        this._layers.forEach((item, index)=>{
            item._idx = index;
        });
        this.notifyPlugins('afterLayout');
    }
 _updateDatasets(mode) {
        if (this.notifyPlugins('beforeDatasetsUpdate', {
            mode,
            cancelable: true
        }) === false) {
            return;
        }
        for(let i = 0, ilen = this.data.datasets.length; i < ilen; ++i){
            this.getDatasetMeta(i).controller.configure();
        }
        for(let i = 0, ilen = this.data.datasets.length; i < ilen; ++i){
            this._updateDataset(i, isFunction(mode) ? mode({
                datasetIndex: i
            }) : mode);
        }
        this.notifyPlugins('afterDatasetsUpdate', {
            mode
        });
    }
 _updateDataset(index, mode) {
        const meta = this.getDatasetMeta(index);
        const args = {
            meta,
            index,
            mode,
            cancelable: true
        };
        if (this.notifyPlugins('beforeDatasetUpdate', args) === false) {
            return;
        }
        meta.controller._update(mode);
        args.cancelable = false;
        this.notifyPlugins('afterDatasetUpdate', args);
    }
    render() {
        if (this.notifyPlugins('beforeRender', {
            cancelable: true
        }) === false) {
            return;
        }
        if (animator.has(this)) {
            if (this.attached && !animator.running(this)) {
                animator.start(this);
            }
        } else {
            this.draw();
            onAnimationsComplete({
                chart: this
            });
        }
    }
    draw() {
        let i;
        if (this._resizeBeforeDraw) {
            const { width , height  } = this._resizeBeforeDraw;
            this._resize(width, height);
            this._resizeBeforeDraw = null;
        }
        this.clear();
        if (this.width <= 0 || this.height <= 0) {
            return;
        }
        if (this.notifyPlugins('beforeDraw', {
            cancelable: true
        }) === false) {
            return;
        }
        const layers = this._layers;
        for(i = 0; i < layers.length && layers[i].z <= 0; ++i){
            layers[i].draw(this.chartArea);
        }
        this._drawDatasets();
        for(; i < layers.length; ++i){
            layers[i].draw(this.chartArea);
        }
        this.notifyPlugins('afterDraw');
    }
 _getSortedDatasetMetas(filterVisible) {
        const metasets = this._sortedMetasets;
        const result = [];
        let i, ilen;
        for(i = 0, ilen = metasets.length; i < ilen; ++i){
            const meta = metasets[i];
            if (!filterVisible || meta.visible) {
                result.push(meta);
            }
        }
        return result;
    }
 getSortedVisibleDatasetMetas() {
        return this._getSortedDatasetMetas(true);
    }
 _drawDatasets() {
        if (this.notifyPlugins('beforeDatasetsDraw', {
            cancelable: true
        }) === false) {
            return;
        }
        const metasets = this.getSortedVisibleDatasetMetas();
        for(let i = metasets.length - 1; i >= 0; --i){
            this._drawDataset(metasets[i]);
        }
        this.notifyPlugins('afterDatasetsDraw');
    }
 _drawDataset(meta) {
        const ctx = this.ctx;
        const clip = meta._clip;
        const useClip = !clip.disabled;
        const area = getDatasetArea(meta, this.chartArea);
        const args = {
            meta,
            index: meta.index,
            cancelable: true
        };
        if (this.notifyPlugins('beforeDatasetDraw', args) === false) {
            return;
        }
        if (useClip) {
            clipArea(ctx, {
                left: clip.left === false ? 0 : area.left - clip.left,
                right: clip.right === false ? this.width : area.right + clip.right,
                top: clip.top === false ? 0 : area.top - clip.top,
                bottom: clip.bottom === false ? this.height : area.bottom + clip.bottom
            });
        }
        meta.controller.draw();
        if (useClip) {
            unclipArea(ctx);
        }
        args.cancelable = false;
        this.notifyPlugins('afterDatasetDraw', args);
    }
 isPointInArea(point) {
        return _isPointInArea(point, this.chartArea, this._minPadding);
    }
    getElementsAtEventForMode(e, mode, options, useFinalPosition) {
        const method = Interaction.modes[mode];
        if (typeof method === 'function') {
            return method(this, e, options, useFinalPosition);
        }
        return [];
    }
    getDatasetMeta(datasetIndex) {
        const dataset = this.data.datasets[datasetIndex];
        const metasets = this._metasets;
        let meta = metasets.filter((x)=>x && x._dataset === dataset).pop();
        if (!meta) {
            meta = {
                type: null,
                data: [],
                dataset: null,
                controller: null,
                hidden: null,
                xAxisID: null,
                yAxisID: null,
                order: dataset && dataset.order || 0,
                index: datasetIndex,
                _dataset: dataset,
                _parsed: [],
                _sorted: false
            };
            metasets.push(meta);
        }
        return meta;
    }
    getContext() {
        return this.$context || (this.$context = createContext(null, {
            chart: this,
            type: 'chart'
        }));
    }
    getVisibleDatasetCount() {
        return this.getSortedVisibleDatasetMetas().length;
    }
    isDatasetVisible(datasetIndex) {
        const dataset = this.data.datasets[datasetIndex];
        if (!dataset) {
            return false;
        }
        const meta = this.getDatasetMeta(datasetIndex);
        return typeof meta.hidden === 'boolean' ? !meta.hidden : !dataset.hidden;
    }
    setDatasetVisibility(datasetIndex, visible) {
        const meta = this.getDatasetMeta(datasetIndex);
        meta.hidden = !visible;
    }
    toggleDataVisibility(index) {
        this._hiddenIndices[index] = !this._hiddenIndices[index];
    }
    getDataVisibility(index) {
        return !this._hiddenIndices[index];
    }
 _updateVisibility(datasetIndex, dataIndex, visible) {
        const mode = visible ? 'show' : 'hide';
        const meta = this.getDatasetMeta(datasetIndex);
        const anims = meta.controller._resolveAnimations(undefined, mode);
        if (defined(dataIndex)) {
            meta.data[dataIndex].hidden = !visible;
            this.update();
        } else {
            this.setDatasetVisibility(datasetIndex, visible);
            anims.update(meta, {
                visible
            });
            this.update((ctx)=>ctx.datasetIndex === datasetIndex ? mode : undefined);
        }
    }
    hide(datasetIndex, dataIndex) {
        this._updateVisibility(datasetIndex, dataIndex, false);
    }
    show(datasetIndex, dataIndex) {
        this._updateVisibility(datasetIndex, dataIndex, true);
    }
 _destroyDatasetMeta(datasetIndex) {
        const meta = this._metasets[datasetIndex];
        if (meta && meta.controller) {
            meta.controller._destroy();
        }
        delete this._metasets[datasetIndex];
    }
    _stop() {
        let i, ilen;
        this.stop();
        animator.remove(this);
        for(i = 0, ilen = this.data.datasets.length; i < ilen; ++i){
            this._destroyDatasetMeta(i);
        }
    }
    destroy() {
        this.notifyPlugins('beforeDestroy');
        const { canvas , ctx  } = this;
        this._stop();
        this.config.clearCache();
        if (canvas) {
            this.unbindEvents();
            clearCanvas(canvas, ctx);
            this.platform.releaseContext(ctx);
            this.canvas = null;
            this.ctx = null;
        }
        delete instances[this.id];
        this.notifyPlugins('afterDestroy');
    }
    toBase64Image(...args) {
        return this.canvas.toDataURL(...args);
    }
 bindEvents() {
        this.bindUserEvents();
        if (this.options.responsive) {
            this.bindResponsiveEvents();
        } else {
            this.attached = true;
        }
    }
 bindUserEvents() {
        const listeners = this._listeners;
        const platform = this.platform;
        const _add = (type, listener)=>{
            platform.addEventListener(this, type, listener);
            listeners[type] = listener;
        };
        const listener = (e, x, y)=>{
            e.offsetX = x;
            e.offsetY = y;
            this._eventHandler(e);
        };
        each(this.options.events, (type)=>_add(type, listener));
    }
 bindResponsiveEvents() {
        if (!this._responsiveListeners) {
            this._responsiveListeners = {};
        }
        const listeners = this._responsiveListeners;
        const platform = this.platform;
        const _add = (type, listener)=>{
            platform.addEventListener(this, type, listener);
            listeners[type] = listener;
        };
        const _remove = (type, listener)=>{
            if (listeners[type]) {
                platform.removeEventListener(this, type, listener);
                delete listeners[type];
            }
        };
        const listener = (width, height)=>{
            if (this.canvas) {
                this.resize(width, height);
            }
        };
        let detached;
        const attached = ()=>{
            _remove('attach', attached);
            this.attached = true;
            this.resize();
            _add('resize', listener);
            _add('detach', detached);
        };
        detached = ()=>{
            this.attached = false;
            _remove('resize', listener);
            this._stop();
            this._resize(0, 0);
            _add('attach', attached);
        };
        if (platform.isAttached(this.canvas)) {
            attached();
        } else {
            detached();
        }
    }
 unbindEvents() {
        each(this._listeners, (listener, type)=>{
            this.platform.removeEventListener(this, type, listener);
        });
        this._listeners = {};
        each(this._responsiveListeners, (listener, type)=>{
            this.platform.removeEventListener(this, type, listener);
        });
        this._responsiveListeners = undefined;
    }
    updateHoverStyle(items, mode, enabled) {
        const prefix = enabled ? 'set' : 'remove';
        let meta, item, i, ilen;
        if (mode === 'dataset') {
            meta = this.getDatasetMeta(items[0].datasetIndex);
            meta.controller['_' + prefix + 'DatasetHoverStyle']();
        }
        for(i = 0, ilen = items.length; i < ilen; ++i){
            item = items[i];
            const controller = item && this.getDatasetMeta(item.datasetIndex).controller;
            if (controller) {
                controller[prefix + 'HoverStyle'](item.element, item.datasetIndex, item.index);
            }
        }
    }
 getActiveElements() {
        return this._active || [];
    }
 setActiveElements(activeElements) {
        const lastActive = this._active || [];
        const active = activeElements.map(({ datasetIndex , index  })=>{
            const meta = this.getDatasetMeta(datasetIndex);
            if (!meta) {
                throw new Error('No dataset found at index ' + datasetIndex);
            }
            return {
                datasetIndex,
                element: meta.data[index],
                index
            };
        });
        const changed = !_elementsEqual(active, lastActive);
        if (changed) {
            this._active = active;
            this._lastEvent = null;
            this._updateHoverStyles(active, lastActive);
        }
    }
 notifyPlugins(hook, args, filter) {
        return this._plugins.notify(this, hook, args, filter);
    }
 isPluginEnabled(pluginId) {
        return this._plugins._cache.filter((p)=>p.plugin.id === pluginId).length === 1;
    }
 _updateHoverStyles(active, lastActive, replay) {
        const hoverOptions = this.options.hover;
        const diff = (a, b)=>a.filter((x)=>!b.some((y)=>x.datasetIndex === y.datasetIndex && x.index === y.index));
        const deactivated = diff(lastActive, active);
        const activated = replay ? active : diff(active, lastActive);
        if (deactivated.length) {
            this.updateHoverStyle(deactivated, hoverOptions.mode, false);
        }
        if (activated.length && hoverOptions.mode) {
            this.updateHoverStyle(activated, hoverOptions.mode, true);
        }
    }
 _eventHandler(e, replay) {
        const args = {
            event: e,
            replay,
            cancelable: true,
            inChartArea: this.isPointInArea(e)
        };
        const eventFilter = (plugin)=>(plugin.options.events || this.options.events).includes(e.native.type);
        if (this.notifyPlugins('beforeEvent', args, eventFilter) === false) {
            return;
        }
        const changed = this._handleEvent(e, replay, args.inChartArea);
        args.cancelable = false;
        this.notifyPlugins('afterEvent', args, eventFilter);
        if (changed || args.changed) {
            this.render();
        }
        return this;
    }
 _handleEvent(e, replay, inChartArea) {
        const { _active: lastActive = [] , options  } = this;
        const useFinalPosition = replay;
        const active = this._getActiveElements(e, lastActive, inChartArea, useFinalPosition);
        const isClick = _isClickEvent(e);
        const lastEvent = determineLastEvent(e, this._lastEvent, inChartArea, isClick);
        if (inChartArea) {
            this._lastEvent = null;
            callback(options.onHover, [
                e,
                active,
                this
            ], this);
            if (isClick) {
                callback(options.onClick, [
                    e,
                    active,
                    this
                ], this);
            }
        }
        const changed = !_elementsEqual(active, lastActive);
        if (changed || replay) {
            this._active = active;
            this._updateHoverStyles(active, lastActive, replay);
        }
        this._lastEvent = lastEvent;
        return changed;
    }
 _getActiveElements(e, lastActive, inChartArea, useFinalPosition) {
        if (e.type === 'mouseout') {
            return [];
        }
        if (!inChartArea) {
            return lastActive;
        }
        const hoverOptions = this.options.hover;
        return this.getElementsAtEventForMode(e, hoverOptions.mode, hoverOptions, useFinalPosition);
    }
}
function invalidatePlugins() {
    return each(Chart.instances, (chart)=>chart._plugins.invalidate());
}

function clipArc(ctx, element, endAngle) {
    const { startAngle , pixelMargin , x , y , outerRadius , innerRadius  } = element;
    let angleMargin = pixelMargin / outerRadius;
    // Draw an inner border by clipping the arc and drawing a double-width border
    // Enlarge the clipping arc by 0.33 pixels to eliminate glitches between borders
    ctx.beginPath();
    ctx.arc(x, y, outerRadius, startAngle - angleMargin, endAngle + angleMargin);
    if (innerRadius > pixelMargin) {
        angleMargin = pixelMargin / innerRadius;
        ctx.arc(x, y, innerRadius, endAngle + angleMargin, startAngle - angleMargin, true);
    } else {
        ctx.arc(x, y, pixelMargin, endAngle + HALF_PI, startAngle - HALF_PI);
    }
    ctx.closePath();
    ctx.clip();
}
function toRadiusCorners(value) {
    return _readValueToProps(value, [
        'outerStart',
        'outerEnd',
        'innerStart',
        'innerEnd'
    ]);
}
/**
 * Parse border radius from the provided options
 */ function parseBorderRadius$1(arc, innerRadius, outerRadius, angleDelta) {
    const o = toRadiusCorners(arc.options.borderRadius);
    const halfThickness = (outerRadius - innerRadius) / 2;
    const innerLimit = Math.min(halfThickness, angleDelta * innerRadius / 2);
    // Outer limits are complicated. We want to compute the available angular distance at
    // a radius of outerRadius - borderRadius because for small angular distances, this term limits.
    // We compute at r = outerRadius - borderRadius because this circle defines the center of the border corners.
    //
    // If the borderRadius is large, that value can become negative.
    // This causes the outer borders to lose their radius entirely, which is rather unexpected. To solve that, if borderRadius > outerRadius
    // we know that the thickness term will dominate and compute the limits at that point
    const computeOuterLimit = (val)=>{
        const outerArcLimit = (outerRadius - Math.min(halfThickness, val)) * angleDelta / 2;
        return _limitValue(val, 0, Math.min(halfThickness, outerArcLimit));
    };
    return {
        outerStart: computeOuterLimit(o.outerStart),
        outerEnd: computeOuterLimit(o.outerEnd),
        innerStart: _limitValue(o.innerStart, 0, innerLimit),
        innerEnd: _limitValue(o.innerEnd, 0, innerLimit)
    };
}
/**
 * Convert (r, 𝜃) to (x, y)
 */ function rThetaToXY(r, theta, x, y) {
    return {
        x: x + r * Math.cos(theta),
        y: y + r * Math.sin(theta)
    };
}
/**
 * Path the arc, respecting border radius by separating into left and right halves.
 *
 *   Start      End
 *
 *    1--->a--->2    Outer
 *   /           \
 *   8           3
 *   |           |
 *   |           |
 *   7           4
 *   \           /
 *    6<---b<---5    Inner
 */ function pathArc(ctx, element, offset, spacing, end, circular) {
    const { x , y , startAngle: start , pixelMargin , innerRadius: innerR  } = element;
    const outerRadius = Math.max(element.outerRadius + spacing + offset - pixelMargin, 0);
    const innerRadius = innerR > 0 ? innerR + spacing + offset + pixelMargin : 0;
    let spacingOffset = 0;
    const alpha = end - start;
    if (spacing) {
        // When spacing is present, it is the same for all items
        // So we adjust the start and end angle of the arc such that
        // the distance is the same as it would be without the spacing
        const noSpacingInnerRadius = innerR > 0 ? innerR - spacing : 0;
        const noSpacingOuterRadius = outerRadius > 0 ? outerRadius - spacing : 0;
        const avNogSpacingRadius = (noSpacingInnerRadius + noSpacingOuterRadius) / 2;
        const adjustedAngle = avNogSpacingRadius !== 0 ? alpha * avNogSpacingRadius / (avNogSpacingRadius + spacing) : alpha;
        spacingOffset = (alpha - adjustedAngle) / 2;
    }
    const beta = Math.max(0.001, alpha * outerRadius - offset / PI) / outerRadius;
    const angleOffset = (alpha - beta) / 2;
    const startAngle = start + angleOffset + spacingOffset;
    const endAngle = end - angleOffset - spacingOffset;
    const { outerStart , outerEnd , innerStart , innerEnd  } = parseBorderRadius$1(element, innerRadius, outerRadius, endAngle - startAngle);
    const outerStartAdjustedRadius = outerRadius - outerStart;
    const outerEndAdjustedRadius = outerRadius - outerEnd;
    const outerStartAdjustedAngle = startAngle + outerStart / outerStartAdjustedRadius;
    const outerEndAdjustedAngle = endAngle - outerEnd / outerEndAdjustedRadius;
    const innerStartAdjustedRadius = innerRadius + innerStart;
    const innerEndAdjustedRadius = innerRadius + innerEnd;
    const innerStartAdjustedAngle = startAngle + innerStart / innerStartAdjustedRadius;
    const innerEndAdjustedAngle = endAngle - innerEnd / innerEndAdjustedRadius;
    ctx.beginPath();
    if (circular) {
        // The first arc segments from point 1 to point a to point 2
        const outerMidAdjustedAngle = (outerStartAdjustedAngle + outerEndAdjustedAngle) / 2;
        ctx.arc(x, y, outerRadius, outerStartAdjustedAngle, outerMidAdjustedAngle);
        ctx.arc(x, y, outerRadius, outerMidAdjustedAngle, outerEndAdjustedAngle);
        // The corner segment from point 2 to point 3
        if (outerEnd > 0) {
            const pCenter = rThetaToXY(outerEndAdjustedRadius, outerEndAdjustedAngle, x, y);
            ctx.arc(pCenter.x, pCenter.y, outerEnd, outerEndAdjustedAngle, endAngle + HALF_PI);
        }
        // The line from point 3 to point 4
        const p4 = rThetaToXY(innerEndAdjustedRadius, endAngle, x, y);
        ctx.lineTo(p4.x, p4.y);
        // The corner segment from point 4 to point 5
        if (innerEnd > 0) {
            const pCenter = rThetaToXY(innerEndAdjustedRadius, innerEndAdjustedAngle, x, y);
            ctx.arc(pCenter.x, pCenter.y, innerEnd, endAngle + HALF_PI, innerEndAdjustedAngle + Math.PI);
        }
        // The inner arc from point 5 to point b to point 6
        const innerMidAdjustedAngle = (endAngle - innerEnd / innerRadius + (startAngle + innerStart / innerRadius)) / 2;
        ctx.arc(x, y, innerRadius, endAngle - innerEnd / innerRadius, innerMidAdjustedAngle, true);
        ctx.arc(x, y, innerRadius, innerMidAdjustedAngle, startAngle + innerStart / innerRadius, true);
        // The corner segment from point 6 to point 7
        if (innerStart > 0) {
            const pCenter = rThetaToXY(innerStartAdjustedRadius, innerStartAdjustedAngle, x, y);
            ctx.arc(pCenter.x, pCenter.y, innerStart, innerStartAdjustedAngle + Math.PI, startAngle - HALF_PI);
        }
        // The line from point 7 to point 8
        const p8 = rThetaToXY(outerStartAdjustedRadius, startAngle, x, y);
        ctx.lineTo(p8.x, p8.y);
        // The corner segment from point 8 to point 1
        if (outerStart > 0) {
            const pCenter = rThetaToXY(outerStartAdjustedRadius, outerStartAdjustedAngle, x, y);
            ctx.arc(pCenter.x, pCenter.y, outerStart, startAngle - HALF_PI, outerStartAdjustedAngle);
        }
    } else {
        ctx.moveTo(x, y);
        const outerStartX = Math.cos(outerStartAdjustedAngle) * outerRadius + x;
        const outerStartY = Math.sin(outerStartAdjustedAngle) * outerRadius + y;
        ctx.lineTo(outerStartX, outerStartY);
        const outerEndX = Math.cos(outerEndAdjustedAngle) * outerRadius + x;
        const outerEndY = Math.sin(outerEndAdjustedAngle) * outerRadius + y;
        ctx.lineTo(outerEndX, outerEndY);
    }
    ctx.closePath();
}
function drawArc(ctx, element, offset, spacing, circular) {
    const { fullCircles , startAngle , circumference  } = element;
    let endAngle = element.endAngle;
    if (fullCircles) {
        pathArc(ctx, element, offset, spacing, endAngle, circular);
        for(let i = 0; i < fullCircles; ++i){
            ctx.fill();
        }
        if (!isNaN(circumference)) {
            endAngle = startAngle + (circumference % TAU || TAU);
        }
    }
    pathArc(ctx, element, offset, spacing, endAngle, circular);
    ctx.fill();
    return endAngle;
}
function drawBorder(ctx, element, offset, spacing, circular) {
    const { fullCircles , startAngle , circumference , options  } = element;
    const { borderWidth , borderJoinStyle , borderDash , borderDashOffset  } = options;
    const inner = options.borderAlign === 'inner';
    if (!borderWidth) {
        return;
    }
    ctx.setLineDash(borderDash || []);
    ctx.lineDashOffset = borderDashOffset;
    if (inner) {
        ctx.lineWidth = borderWidth * 2;
        ctx.lineJoin = borderJoinStyle || 'round';
    } else {
        ctx.lineWidth = borderWidth;
        ctx.lineJoin = borderJoinStyle || 'bevel';
    }
    let endAngle = element.endAngle;
    if (fullCircles) {
        pathArc(ctx, element, offset, spacing, endAngle, circular);
        for(let i = 0; i < fullCircles; ++i){
            ctx.stroke();
        }
        if (!isNaN(circumference)) {
            endAngle = startAngle + (circumference % TAU || TAU);
        }
    }
    if (inner) {
        clipArc(ctx, element, endAngle);
    }
    if (!fullCircles) {
        pathArc(ctx, element, offset, spacing, endAngle, circular);
        ctx.stroke();
    }
}
class ArcElement extends Element {
    static id = 'arc';
    static defaults = {
        borderAlign: 'center',
        borderColor: '#fff',
        borderDash: [],
        borderDashOffset: 0,
        borderJoinStyle: undefined,
        borderRadius: 0,
        borderWidth: 2,
        offset: 0,
        spacing: 0,
        angle: undefined,
        circular: true
    };
    static defaultRoutes = {
        backgroundColor: 'backgroundColor'
    };
    static descriptors = {
        _scriptable: true,
        _indexable: (name)=>name !== 'borderDash'
    };
    circumference;
    endAngle;
    fullCircles;
    innerRadius;
    outerRadius;
    pixelMargin;
    startAngle;
    constructor(cfg){
        super();
        this.options = undefined;
        this.circumference = undefined;
        this.startAngle = undefined;
        this.endAngle = undefined;
        this.innerRadius = undefined;
        this.outerRadius = undefined;
        this.pixelMargin = 0;
        this.fullCircles = 0;
        if (cfg) {
            Object.assign(this, cfg);
        }
    }
    inRange(chartX, chartY, useFinalPosition) {
        const point = this.getProps([
            'x',
            'y'
        ], useFinalPosition);
        const { angle , distance  } = getAngleFromPoint(point, {
            x: chartX,
            y: chartY
        });
        const { startAngle , endAngle , innerRadius , outerRadius , circumference  } = this.getProps([
            'startAngle',
            'endAngle',
            'innerRadius',
            'outerRadius',
            'circumference'
        ], useFinalPosition);
        const rAdjust = (this.options.spacing + this.options.borderWidth) / 2;
        const _circumference = valueOrDefault(circumference, endAngle - startAngle);
        const betweenAngles = _circumference >= TAU || _angleBetween(angle, startAngle, endAngle);
        const withinRadius = _isBetween(distance, innerRadius + rAdjust, outerRadius + rAdjust);
        return betweenAngles && withinRadius;
    }
    getCenterPoint(useFinalPosition) {
        const { x , y , startAngle , endAngle , innerRadius , outerRadius  } = this.getProps([
            'x',
            'y',
            'startAngle',
            'endAngle',
            'innerRadius',
            'outerRadius'
        ], useFinalPosition);
        const { offset , spacing  } = this.options;
        const halfAngle = (startAngle + endAngle) / 2;
        const halfRadius = (innerRadius + outerRadius + spacing + offset) / 2;
        return {
            x: x + Math.cos(halfAngle) * halfRadius,
            y: y + Math.sin(halfAngle) * halfRadius
        };
    }
    tooltipPosition(useFinalPosition) {
        return this.getCenterPoint(useFinalPosition);
    }
    draw(ctx) {
        const { options , circumference  } = this;
        const offset = (options.offset || 0) / 4;
        const spacing = (options.spacing || 0) / 2;
        const circular = options.circular;
        this.pixelMargin = options.borderAlign === 'inner' ? 0.33 : 0;
        this.fullCircles = circumference > TAU ? Math.floor(circumference / TAU) : 0;
        if (circumference === 0 || this.innerRadius < 0 || this.outerRadius < 0) {
            return;
        }
        ctx.save();
        const halfAngle = (this.startAngle + this.endAngle) / 2;
        ctx.translate(Math.cos(halfAngle) * offset, Math.sin(halfAngle) * offset);
        const fix = 1 - Math.sin(Math.min(PI, circumference || 0));
        const radiusOffset = offset * fix;
        ctx.fillStyle = options.backgroundColor;
        ctx.strokeStyle = options.borderColor;
        drawArc(ctx, this, radiusOffset, spacing, circular);
        drawBorder(ctx, this, radiusOffset, spacing, circular);
        ctx.restore();
    }
}

function setStyle(ctx, options, style = options) {
    ctx.lineCap = valueOrDefault(style.borderCapStyle, options.borderCapStyle);
    ctx.setLineDash(valueOrDefault(style.borderDash, options.borderDash));
    ctx.lineDashOffset = valueOrDefault(style.borderDashOffset, options.borderDashOffset);
    ctx.lineJoin = valueOrDefault(style.borderJoinStyle, options.borderJoinStyle);
    ctx.lineWidth = valueOrDefault(style.borderWidth, options.borderWidth);
    ctx.strokeStyle = valueOrDefault(style.borderColor, options.borderColor);
}
function lineTo(ctx, previous, target) {
    ctx.lineTo(target.x, target.y);
}
 function getLineMethod(options) {
    if (options.stepped) {
        return _steppedLineTo;
    }
    if (options.tension || options.cubicInterpolationMode === 'monotone') {
        return _bezierCurveTo;
    }
    return lineTo;
}
function pathVars(points, segment, params = {}) {
    const count = points.length;
    const { start: paramsStart = 0 , end: paramsEnd = count - 1  } = params;
    const { start: segmentStart , end: segmentEnd  } = segment;
    const start = Math.max(paramsStart, segmentStart);
    const end = Math.min(paramsEnd, segmentEnd);
    const outside = paramsStart < segmentStart && paramsEnd < segmentStart || paramsStart > segmentEnd && paramsEnd > segmentEnd;
    return {
        count,
        start,
        loop: segment.loop,
        ilen: end < start && !outside ? count + end - start : end - start
    };
}
 function pathSegment(ctx, line, segment, params) {
    const { points , options  } = line;
    const { count , start , loop , ilen  } = pathVars(points, segment, params);
    const lineMethod = getLineMethod(options);
    let { move =true , reverse  } = params || {};
    let i, point, prev;
    for(i = 0; i <= ilen; ++i){
        point = points[(start + (reverse ? ilen - i : i)) % count];
        if (point.skip) {
            continue;
        } else if (move) {
            ctx.moveTo(point.x, point.y);
            move = false;
        } else {
            lineMethod(ctx, prev, point, reverse, options.stepped);
        }
        prev = point;
    }
    if (loop) {
        point = points[(start + (reverse ? ilen : 0)) % count];
        lineMethod(ctx, prev, point, reverse, options.stepped);
    }
    return !!loop;
}
 function fastPathSegment(ctx, line, segment, params) {
    const points = line.points;
    const { count , start , ilen  } = pathVars(points, segment, params);
    const { move =true , reverse  } = params || {};
    let avgX = 0;
    let countX = 0;
    let i, point, prevX, minY, maxY, lastY;
    const pointIndex = (index)=>(start + (reverse ? ilen - index : index)) % count;
    const drawX = ()=>{
        if (minY !== maxY) {
            ctx.lineTo(avgX, maxY);
            ctx.lineTo(avgX, minY);
            ctx.lineTo(avgX, lastY);
        }
    };
    if (move) {
        point = points[pointIndex(0)];
        ctx.moveTo(point.x, point.y);
    }
    for(i = 0; i <= ilen; ++i){
        point = points[pointIndex(i)];
        if (point.skip) {
            continue;
        }
        const x = point.x;
        const y = point.y;
        const truncX = x | 0;
        if (truncX === prevX) {
            if (y < minY) {
                minY = y;
            } else if (y > maxY) {
                maxY = y;
            }
            avgX = (countX * avgX + x) / ++countX;
        } else {
            drawX();
            ctx.lineTo(x, y);
            prevX = truncX;
            countX = 0;
            minY = maxY = y;
        }
        lastY = y;
    }
    drawX();
}
 function _getSegmentMethod(line) {
    const opts = line.options;
    const borderDash = opts.borderDash && opts.borderDash.length;
    const useFastPath = !line._decimated && !line._loop && !opts.tension && opts.cubicInterpolationMode !== 'monotone' && !opts.stepped && !borderDash;
    return useFastPath ? fastPathSegment : pathSegment;
}
 function _getInterpolationMethod(options) {
    if (options.stepped) {
        return _steppedInterpolation;
    }
    if (options.tension || options.cubicInterpolationMode === 'monotone') {
        return _bezierInterpolation;
    }
    return _pointInLine;
}
function strokePathWithCache(ctx, line, start, count) {
    let path = line._path;
    if (!path) {
        path = line._path = new Path2D();
        if (line.path(path, start, count)) {
            path.closePath();
        }
    }
    setStyle(ctx, line.options);
    ctx.stroke(path);
}
function strokePathDirect(ctx, line, start, count) {
    const { segments , options  } = line;
    const segmentMethod = _getSegmentMethod(line);
    for (const segment of segments){
        setStyle(ctx, options, segment.style);
        ctx.beginPath();
        if (segmentMethod(ctx, line, segment, {
            start,
            end: start + count - 1
        })) {
            ctx.closePath();
        }
        ctx.stroke();
    }
}
const usePath2D = typeof Path2D === 'function';
function draw(ctx, line, start, count) {
    if (usePath2D && !line.options.segment) {
        strokePathWithCache(ctx, line, start, count);
    } else {
        strokePathDirect(ctx, line, start, count);
    }
}
class LineElement extends Element {
    static id = 'line';
 static defaults = {
        borderCapStyle: 'butt',
        borderDash: [],
        borderDashOffset: 0,
        borderJoinStyle: 'miter',
        borderWidth: 3,
        capBezierPoints: true,
        cubicInterpolationMode: 'default',
        fill: false,
        spanGaps: false,
        stepped: false,
        tension: 0
    };
 static defaultRoutes = {
        backgroundColor: 'backgroundColor',
        borderColor: 'borderColor'
    };
    static descriptors = {
        _scriptable: true,
        _indexable: (name)=>name !== 'borderDash' && name !== 'fill'
    };
    constructor(cfg){
        super();
        this.animated = true;
        this.options = undefined;
        this._chart = undefined;
        this._loop = undefined;
        this._fullLoop = undefined;
        this._path = undefined;
        this._points = undefined;
        this._segments = undefined;
        this._decimated = false;
        this._pointsUpdated = false;
        this._datasetIndex = undefined;
        if (cfg) {
            Object.assign(this, cfg);
        }
    }
    updateControlPoints(chartArea, indexAxis) {
        const options = this.options;
        if ((options.tension || options.cubicInterpolationMode === 'monotone') && !options.stepped && !this._pointsUpdated) {
            const loop = options.spanGaps ? this._loop : this._fullLoop;
            _updateBezierControlPoints(this._points, options, chartArea, loop, indexAxis);
            this._pointsUpdated = true;
        }
    }
    set points(points) {
        this._points = points;
        delete this._segments;
        delete this._path;
        this._pointsUpdated = false;
    }
    get points() {
        return this._points;
    }
    get segments() {
        return this._segments || (this._segments = _computeSegments(this, this.options.segment));
    }
 first() {
        const segments = this.segments;
        const points = this.points;
        return segments.length && points[segments[0].start];
    }
 last() {
        const segments = this.segments;
        const points = this.points;
        const count = segments.length;
        return count && points[segments[count - 1].end];
    }
 interpolate(point, property) {
        const options = this.options;
        const value = point[property];
        const points = this.points;
        const segments = _boundSegments(this, {
            property,
            start: value,
            end: value
        });
        if (!segments.length) {
            return;
        }
        const result = [];
        const _interpolate = _getInterpolationMethod(options);
        let i, ilen;
        for(i = 0, ilen = segments.length; i < ilen; ++i){
            const { start , end  } = segments[i];
            const p1 = points[start];
            const p2 = points[end];
            if (p1 === p2) {
                result.push(p1);
                continue;
            }
            const t = Math.abs((value - p1[property]) / (p2[property] - p1[property]));
            const interpolated = _interpolate(p1, p2, t, options.stepped);
            interpolated[property] = point[property];
            result.push(interpolated);
        }
        return result.length === 1 ? result[0] : result;
    }
 pathSegment(ctx, segment, params) {
        const segmentMethod = _getSegmentMethod(this);
        return segmentMethod(ctx, this, segment, params);
    }
 path(ctx, start, count) {
        const segments = this.segments;
        const segmentMethod = _getSegmentMethod(this);
        let loop = this._loop;
        start = start || 0;
        count = count || this.points.length - start;
        for (const segment of segments){
            loop &= segmentMethod(ctx, this, segment, {
                start,
                end: start + count - 1
            });
        }
        return !!loop;
    }
 draw(ctx, chartArea, start, count) {
        const options = this.options || {};
        const points = this.points || [];
        if (points.length && options.borderWidth) {
            ctx.save();
            draw(ctx, this, start, count);
            ctx.restore();
        }
        if (this.animated) {
            this._pointsUpdated = false;
            this._path = undefined;
        }
    }
}

function inRange$1(el, pos, axis, useFinalPosition) {
    const options = el.options;
    const { [axis]: value  } = el.getProps([
        axis
    ], useFinalPosition);
    return Math.abs(pos - value) < options.radius + options.hitRadius;
}
class PointElement extends Element {
    static id = 'point';
    parsed;
    skip;
    stop;
    /**
   * @type {any}
   */ static defaults = {
        borderWidth: 1,
        hitRadius: 1,
        hoverBorderWidth: 1,
        hoverRadius: 4,
        pointStyle: 'circle',
        radius: 3,
        rotation: 0
    };
    /**
   * @type {any}
   */ static defaultRoutes = {
        backgroundColor: 'backgroundColor',
        borderColor: 'borderColor'
    };
    constructor(cfg){
        super();
        this.options = undefined;
        this.parsed = undefined;
        this.skip = undefined;
        this.stop = undefined;
        if (cfg) {
            Object.assign(this, cfg);
        }
    }
    inRange(mouseX, mouseY, useFinalPosition) {
        const options = this.options;
        const { x , y  } = this.getProps([
            'x',
            'y'
        ], useFinalPosition);
        return Math.pow(mouseX - x, 2) + Math.pow(mouseY - y, 2) < Math.pow(options.hitRadius + options.radius, 2);
    }
    inXRange(mouseX, useFinalPosition) {
        return inRange$1(this, mouseX, 'x', useFinalPosition);
    }
    inYRange(mouseY, useFinalPosition) {
        return inRange$1(this, mouseY, 'y', useFinalPosition);
    }
    getCenterPoint(useFinalPosition) {
        const { x , y  } = this.getProps([
            'x',
            'y'
        ], useFinalPosition);
        return {
            x,
            y
        };
    }
    size(options) {
        options = options || this.options || {};
        let radius = options.radius || 0;
        radius = Math.max(radius, radius && options.hoverRadius || 0);
        const borderWidth = radius && options.borderWidth || 0;
        return (radius + borderWidth) * 2;
    }
    draw(ctx, area) {
        const options = this.options;
        if (this.skip || options.radius < 0.1 || !_isPointInArea(this, area, this.size(options) / 2)) {
            return;
        }
        ctx.strokeStyle = options.borderColor;
        ctx.lineWidth = options.borderWidth;
        ctx.fillStyle = options.backgroundColor;
        drawPoint(ctx, options, this.x, this.y);
    }
    getRange() {
        const options = this.options || {};
        // @ts-expect-error Fallbacks should never be hit in practice
        return options.radius + options.hitRadius;
    }
}

function getBarBounds(bar, useFinalPosition) {
    const { x , y , base , width , height  } =  bar.getProps([
        'x',
        'y',
        'base',
        'width',
        'height'
    ], useFinalPosition);
    let left, right, top, bottom, half;
    if (bar.horizontal) {
        half = height / 2;
        left = Math.min(x, base);
        right = Math.max(x, base);
        top = y - half;
        bottom = y + half;
    } else {
        half = width / 2;
        left = x - half;
        right = x + half;
        top = Math.min(y, base);
        bottom = Math.max(y, base);
    }
    return {
        left,
        top,
        right,
        bottom
    };
}
function skipOrLimit(skip, value, min, max) {
    return skip ? 0 : _limitValue(value, min, max);
}
function parseBorderWidth(bar, maxW, maxH) {
    const value = bar.options.borderWidth;
    const skip = bar.borderSkipped;
    const o = toTRBL(value);
    return {
        t: skipOrLimit(skip.top, o.top, 0, maxH),
        r: skipOrLimit(skip.right, o.right, 0, maxW),
        b: skipOrLimit(skip.bottom, o.bottom, 0, maxH),
        l: skipOrLimit(skip.left, o.left, 0, maxW)
    };
}
function parseBorderRadius(bar, maxW, maxH) {
    const { enableBorderRadius  } = bar.getProps([
        'enableBorderRadius'
    ]);
    const value = bar.options.borderRadius;
    const o = toTRBLCorners(value);
    const maxR = Math.min(maxW, maxH);
    const skip = bar.borderSkipped;
    const enableBorder = enableBorderRadius || isObject(value);
    return {
        topLeft: skipOrLimit(!enableBorder || skip.top || skip.left, o.topLeft, 0, maxR),
        topRight: skipOrLimit(!enableBorder || skip.top || skip.right, o.topRight, 0, maxR),
        bottomLeft: skipOrLimit(!enableBorder || skip.bottom || skip.left, o.bottomLeft, 0, maxR),
        bottomRight: skipOrLimit(!enableBorder || skip.bottom || skip.right, o.bottomRight, 0, maxR)
    };
}
function boundingRects(bar) {
    const bounds = getBarBounds(bar);
    const width = bounds.right - bounds.left;
    const height = bounds.bottom - bounds.top;
    const border = parseBorderWidth(bar, width / 2, height / 2);
    const radius = parseBorderRadius(bar, width / 2, height / 2);
    return {
        outer: {
            x: bounds.left,
            y: bounds.top,
            w: width,
            h: height,
            radius
        },
        inner: {
            x: bounds.left + border.l,
            y: bounds.top + border.t,
            w: width - border.l - border.r,
            h: height - border.t - border.b,
            radius: {
                topLeft: Math.max(0, radius.topLeft - Math.max(border.t, border.l)),
                topRight: Math.max(0, radius.topRight - Math.max(border.t, border.r)),
                bottomLeft: Math.max(0, radius.bottomLeft - Math.max(border.b, border.l)),
                bottomRight: Math.max(0, radius.bottomRight - Math.max(border.b, border.r))
            }
        }
    };
}
function inRange(bar, x, y, useFinalPosition) {
    const skipX = x === null;
    const skipY = y === null;
    const skipBoth = skipX && skipY;
    const bounds = bar && !skipBoth && getBarBounds(bar, useFinalPosition);
    return bounds && (skipX || _isBetween(x, bounds.left, bounds.right)) && (skipY || _isBetween(y, bounds.top, bounds.bottom));
}
function hasRadius(radius) {
    return radius.topLeft || radius.topRight || radius.bottomLeft || radius.bottomRight;
}
 function addNormalRectPath(ctx, rect) {
    ctx.rect(rect.x, rect.y, rect.w, rect.h);
}
function inflateRect(rect, amount, refRect = {}) {
    const x = rect.x !== refRect.x ? -amount : 0;
    const y = rect.y !== refRect.y ? -amount : 0;
    const w = (rect.x + rect.w !== refRect.x + refRect.w ? amount : 0) - x;
    const h = (rect.y + rect.h !== refRect.y + refRect.h ? amount : 0) - y;
    return {
        x: rect.x + x,
        y: rect.y + y,
        w: rect.w + w,
        h: rect.h + h,
        radius: rect.radius
    };
}
class BarElement extends Element {
    static id = 'bar';
 static defaults = {
        borderSkipped: 'start',
        borderWidth: 0,
        borderRadius: 0,
        inflateAmount: 'auto',
        pointStyle: undefined
    };
 static defaultRoutes = {
        backgroundColor: 'backgroundColor',
        borderColor: 'borderColor'
    };
    constructor(cfg){
        super();
        this.options = undefined;
        this.horizontal = undefined;
        this.base = undefined;
        this.width = undefined;
        this.height = undefined;
        this.inflateAmount = undefined;
        if (cfg) {
            Object.assign(this, cfg);
        }
    }
    draw(ctx) {
        const { inflateAmount , options: { borderColor , backgroundColor  }  } = this;
        const { inner , outer  } = boundingRects(this);
        const addRectPath = hasRadius(outer.radius) ? addRoundedRectPath : addNormalRectPath;
        ctx.save();
        if (outer.w !== inner.w || outer.h !== inner.h) {
            ctx.beginPath();
            addRectPath(ctx, inflateRect(outer, inflateAmount, inner));
            ctx.clip();
            addRectPath(ctx, inflateRect(inner, -inflateAmount, outer));
            ctx.fillStyle = borderColor;
            ctx.fill('evenodd');
        }
        ctx.beginPath();
        addRectPath(ctx, inflateRect(inner, inflateAmount));
        ctx.fillStyle = backgroundColor;
        ctx.fill();
        ctx.restore();
    }
    inRange(mouseX, mouseY, useFinalPosition) {
        return inRange(this, mouseX, mouseY, useFinalPosition);
    }
    inXRange(mouseX, useFinalPosition) {
        return inRange(this, mouseX, null, useFinalPosition);
    }
    inYRange(mouseY, useFinalPosition) {
        return inRange(this, null, mouseY, useFinalPosition);
    }
    getCenterPoint(useFinalPosition) {
        const { x , y , base , horizontal  } =  this.getProps([
            'x',
            'y',
            'base',
            'horizontal'
        ], useFinalPosition);
        return {
            x: horizontal ? (x + base) / 2 : x,
            y: horizontal ? y : (y + base) / 2
        };
    }
    getRange(axis) {
        return axis === 'x' ? this.width / 2 : this.height / 2;
    }
}

var chart_elements = /*#__PURE__*/Object.freeze({
__proto__: null,
ArcElement: ArcElement,
BarElement: BarElement,
LineElement: LineElement,
PointElement: PointElement
});

const BORDER_COLORS = [
    'rgb(54, 162, 235)',
    'rgb(255, 99, 132)',
    'rgb(255, 159, 64)',
    'rgb(255, 205, 86)',
    'rgb(75, 192, 192)',
    'rgb(153, 102, 255)',
    'rgb(201, 203, 207)' // grey
];
// Border colors with 50% transparency
const BACKGROUND_COLORS = /* #__PURE__ */ BORDER_COLORS.map((color)=>color.replace('rgb(', 'rgba(').replace(')', ', 0.5)'));
function getBorderColor(i) {
    return BORDER_COLORS[i % BORDER_COLORS.length];
}
function getBackgroundColor(i) {
    return BACKGROUND_COLORS[i % BACKGROUND_COLORS.length];
}
function colorizeDefaultDataset(dataset, i) {
    dataset.borderColor = getBorderColor(i);
    dataset.backgroundColor = getBackgroundColor(i);
    return ++i;
}
function colorizeDoughnutDataset(dataset, i) {
    dataset.backgroundColor = dataset.data.map(()=>getBorderColor(i++));
    return i;
}
function colorizePolarAreaDataset(dataset, i) {
    dataset.backgroundColor = dataset.data.map(()=>getBackgroundColor(i++));
    return i;
}
function getColorizer(chart) {
    let i = 0;
    return (dataset, datasetIndex)=>{
        const controller = chart.getDatasetMeta(datasetIndex).controller;
        if (controller instanceof chart_DoughnutController) {
            i = colorizeDoughnutDataset(dataset, i);
        } else if (controller instanceof chart_PolarAreaController) {
            i = colorizePolarAreaDataset(dataset, i);
        } else if (controller) {
            i = colorizeDefaultDataset(dataset, i);
        }
    };
}
function containsColorsDefinitions(descriptors) {
    let k;
    for(k in descriptors){
        if (descriptors[k].borderColor || descriptors[k].backgroundColor) {
            return true;
        }
    }
    return false;
}
function containsColorsDefinition(descriptor) {
    return descriptor && (descriptor.borderColor || descriptor.backgroundColor);
}
var plugin_colors = {
    id: 'colors',
    defaults: {
        enabled: true,
        forceOverride: false
    },
    beforeLayout (chart, _args, options) {
        if (!options.enabled) {
            return;
        }
        const { data: { datasets  } , options: chartOptions  } = chart.config;
        const { elements  } = chartOptions;
        if (!options.forceOverride && (containsColorsDefinitions(datasets) || containsColorsDefinition(chartOptions) || elements && containsColorsDefinitions(elements))) {
            return;
        }
        const colorizer = getColorizer(chart);
        datasets.forEach(colorizer);
    }
};

function lttbDecimation(data, start, count, availableWidth, options) {
 const samples = options.samples || availableWidth;
    if (samples >= count) {
        return data.slice(start, start + count);
    }
    const decimated = [];
    const bucketWidth = (count - 2) / (samples - 2);
    let sampledIndex = 0;
    const endIndex = start + count - 1;
    let a = start;
    let i, maxAreaPoint, maxArea, area, nextA;
    decimated[sampledIndex++] = data[a];
    for(i = 0; i < samples - 2; i++){
        let avgX = 0;
        let avgY = 0;
        let j;
        const avgRangeStart = Math.floor((i + 1) * bucketWidth) + 1 + start;
        const avgRangeEnd = Math.min(Math.floor((i + 2) * bucketWidth) + 1, count) + start;
        const avgRangeLength = avgRangeEnd - avgRangeStart;
        for(j = avgRangeStart; j < avgRangeEnd; j++){
            avgX += data[j].x;
            avgY += data[j].y;
        }
        avgX /= avgRangeLength;
        avgY /= avgRangeLength;
        const rangeOffs = Math.floor(i * bucketWidth) + 1 + start;
        const rangeTo = Math.min(Math.floor((i + 1) * bucketWidth) + 1, count) + start;
        const { x: pointAx , y: pointAy  } = data[a];
        maxArea = area = -1;
        for(j = rangeOffs; j < rangeTo; j++){
            area = 0.5 * Math.abs((pointAx - avgX) * (data[j].y - pointAy) - (pointAx - data[j].x) * (avgY - pointAy));
            if (area > maxArea) {
                maxArea = area;
                maxAreaPoint = data[j];
                nextA = j;
            }
        }
        decimated[sampledIndex++] = maxAreaPoint;
        a = nextA;
    }
    decimated[sampledIndex++] = data[endIndex];
    return decimated;
}
function minMaxDecimation(data, start, count, availableWidth) {
    let avgX = 0;
    let countX = 0;
    let i, point, x, y, prevX, minIndex, maxIndex, startIndex, minY, maxY;
    const decimated = [];
    const endIndex = start + count - 1;
    const xMin = data[start].x;
    const xMax = data[endIndex].x;
    const dx = xMax - xMin;
    for(i = start; i < start + count; ++i){
        point = data[i];
        x = (point.x - xMin) / dx * availableWidth;
        y = point.y;
        const truncX = x | 0;
        if (truncX === prevX) {
            if (y < minY) {
                minY = y;
                minIndex = i;
            } else if (y > maxY) {
                maxY = y;
                maxIndex = i;
            }
            avgX = (countX * avgX + point.x) / ++countX;
        } else {
            const lastIndex = i - 1;
            if (!isNullOrUndef(minIndex) && !isNullOrUndef(maxIndex)) {
                const intermediateIndex1 = Math.min(minIndex, maxIndex);
                const intermediateIndex2 = Math.max(minIndex, maxIndex);
                if (intermediateIndex1 !== startIndex && intermediateIndex1 !== lastIndex) {
                    decimated.push({
                        ...data[intermediateIndex1],
                        x: avgX
                    });
                }
                if (intermediateIndex2 !== startIndex && intermediateIndex2 !== lastIndex) {
                    decimated.push({
                        ...data[intermediateIndex2],
                        x: avgX
                    });
                }
            }
            if (i > 0 && lastIndex !== startIndex) {
                decimated.push(data[lastIndex]);
            }
            decimated.push(point);
            prevX = truncX;
            countX = 0;
            minY = maxY = y;
            minIndex = maxIndex = startIndex = i;
        }
    }
    return decimated;
}
function cleanDecimatedDataset(dataset) {
    if (dataset._decimated) {
        const data = dataset._data;
        delete dataset._decimated;
        delete dataset._data;
        Object.defineProperty(dataset, 'data', {
            configurable: true,
            enumerable: true,
            writable: true,
            value: data
        });
    }
}
function cleanDecimatedData(chart) {
    chart.data.datasets.forEach((dataset)=>{
        cleanDecimatedDataset(dataset);
    });
}
function getStartAndCountOfVisiblePointsSimplified(meta, points) {
    const pointCount = points.length;
    let start = 0;
    let count;
    const { iScale  } = meta;
    const { min , max , minDefined , maxDefined  } = iScale.getUserBounds();
    if (minDefined) {
        start = _limitValue(_lookupByKey(points, iScale.axis, min).lo, 0, pointCount - 1);
    }
    if (maxDefined) {
        count = _limitValue(_lookupByKey(points, iScale.axis, max).hi + 1, start, pointCount) - start;
    } else {
        count = pointCount - start;
    }
    return {
        start,
        count
    };
}
var plugin_decimation = {
    id: 'decimation',
    defaults: {
        algorithm: 'min-max',
        enabled: false
    },
    beforeElementsUpdate: (chart, args, options)=>{
        if (!options.enabled) {
            cleanDecimatedData(chart);
            return;
        }
        const availableWidth = chart.width;
        chart.data.datasets.forEach((dataset, datasetIndex)=>{
            const { _data , indexAxis  } = dataset;
            const meta = chart.getDatasetMeta(datasetIndex);
            const data = _data || dataset.data;
            if (resolve([
                indexAxis,
                chart.options.indexAxis
            ]) === 'y') {
                return;
            }
            if (!meta.controller.supportsDecimation) {
                return;
            }
            const xAxis = chart.scales[meta.xAxisID];
            if (xAxis.type !== 'linear' && xAxis.type !== 'time') {
                return;
            }
            if (chart.options.parsing) {
                return;
            }
            let { start , count  } = getStartAndCountOfVisiblePointsSimplified(meta, data);
            const threshold = options.threshold || 4 * availableWidth;
            if (count <= threshold) {
                cleanDecimatedDataset(dataset);
                return;
            }
            if (isNullOrUndef(_data)) {
                dataset._data = data;
                delete dataset.data;
                Object.defineProperty(dataset, 'data', {
                    configurable: true,
                    enumerable: true,
                    get: function() {
                        return this._decimated;
                    },
                    set: function(d) {
                        this._data = d;
                    }
                });
            }
            let decimated;
            switch(options.algorithm){
                case 'lttb':
                    decimated = lttbDecimation(data, start, count, availableWidth, options);
                    break;
                case 'min-max':
                    decimated = minMaxDecimation(data, start, count, availableWidth);
                    break;
                default:
                    throw new Error(`Unsupported decimation algorithm '${options.algorithm}'`);
            }
            dataset._decimated = decimated;
        });
    },
    destroy (chart) {
        cleanDecimatedData(chart);
    }
};

function _segments(line, target, property) {
    const segments = line.segments;
    const points = line.points;
    const tpoints = target.points;
    const parts = [];
    for (const segment of segments){
        let { start , end  } = segment;
        end = _findSegmentEnd(start, end, points);
        const bounds = _getBounds(property, points[start], points[end], segment.loop);
        if (!target.segments) {
            parts.push({
                source: segment,
                target: bounds,
                start: points[start],
                end: points[end]
            });
            continue;
        }
        const targetSegments = _boundSegments(target, bounds);
        for (const tgt of targetSegments){
            const subBounds = _getBounds(property, tpoints[tgt.start], tpoints[tgt.end], tgt.loop);
            const fillSources = _boundSegment(segment, points, subBounds);
            for (const fillSource of fillSources){
                parts.push({
                    source: fillSource,
                    target: tgt,
                    start: {
                        [property]: _getEdge(bounds, subBounds, 'start', Math.max)
                    },
                    end: {
                        [property]: _getEdge(bounds, subBounds, 'end', Math.min)
                    }
                });
            }
        }
    }
    return parts;
}
function _getBounds(property, first, last, loop) {
    if (loop) {
        return;
    }
    let start = first[property];
    let end = last[property];
    if (property === 'angle') {
        start = _normalizeAngle(start);
        end = _normalizeAngle(end);
    }
    return {
        property,
        start,
        end
    };
}
function _pointsFromSegments(boundary, line) {
    const { x =null , y =null  } = boundary || {};
    const linePoints = line.points;
    const points = [];
    line.segments.forEach(({ start , end  })=>{
        end = _findSegmentEnd(start, end, linePoints);
        const first = linePoints[start];
        const last = linePoints[end];
        if (y !== null) {
            points.push({
                x: first.x,
                y
            });
            points.push({
                x: last.x,
                y
            });
        } else if (x !== null) {
            points.push({
                x,
                y: first.y
            });
            points.push({
                x,
                y: last.y
            });
        }
    });
    return points;
}
function _findSegmentEnd(start, end, points) {
    for(; end > start; end--){
        const point = points[end];
        if (!isNaN(point.x) && !isNaN(point.y)) {
            break;
        }
    }
    return end;
}
function _getEdge(a, b, prop, fn) {
    if (a && b) {
        return fn(a[prop], b[prop]);
    }
    return a ? a[prop] : b ? b[prop] : 0;
}

function _createBoundaryLine(boundary, line) {
    let points = [];
    let _loop = false;
    if (isArray(boundary)) {
        _loop = true;
        points = boundary;
    } else {
        points = _pointsFromSegments(boundary, line);
    }
    return points.length ? new LineElement({
        points,
        options: {
            tension: 0
        },
        _loop,
        _fullLoop: _loop
    }) : null;
}
function _shouldApplyFill(source) {
    return source && source.fill !== false;
}

function _resolveTarget(sources, index, propagate) {
    const source = sources[index];
    let fill = source.fill;
    const visited = [
        index
    ];
    let target;
    if (!propagate) {
        return fill;
    }
    while(fill !== false && visited.indexOf(fill) === -1){
        if (!isNumberFinite(fill)) {
            return fill;
        }
        target = sources[fill];
        if (!target) {
            return false;
        }
        if (target.visible) {
            return fill;
        }
        visited.push(fill);
        fill = target.fill;
    }
    return false;
}
 function _decodeFill(line, index, count) {
     const fill = parseFillOption(line);
    if (isObject(fill)) {
        return isNaN(fill.value) ? false : fill;
    }
    let target = parseFloat(fill);
    if (isNumberFinite(target) && Math.floor(target) === target) {
        return decodeTargetIndex(fill[0], index, target, count);
    }
    return [
        'origin',
        'start',
        'end',
        'stack',
        'shape'
    ].indexOf(fill) >= 0 && fill;
}
function decodeTargetIndex(firstCh, index, target, count) {
    if (firstCh === '-' || firstCh === '+') {
        target = index + target;
    }
    if (target === index || target < 0 || target >= count) {
        return false;
    }
    return target;
}
 function _getTargetPixel(fill, scale) {
    let pixel = null;
    if (fill === 'start') {
        pixel = scale.bottom;
    } else if (fill === 'end') {
        pixel = scale.top;
    } else if (isObject(fill)) {
        pixel = scale.getPixelForValue(fill.value);
    } else if (scale.getBasePixel) {
        pixel = scale.getBasePixel();
    }
    return pixel;
}
 function _getTargetValue(fill, scale, startValue) {
    let value;
    if (fill === 'start') {
        value = startValue;
    } else if (fill === 'end') {
        value = scale.options.reverse ? scale.min : scale.max;
    } else if (isObject(fill)) {
        value = fill.value;
    } else {
        value = scale.getBaseValue();
    }
    return value;
}
 function parseFillOption(line) {
    const options = line.options;
    const fillOption = options.fill;
    let fill = valueOrDefault(fillOption && fillOption.target, fillOption);
    if (fill === undefined) {
        fill = !!options.backgroundColor;
    }
    if (fill === false || fill === null) {
        return false;
    }
    if (fill === true) {
        return 'origin';
    }
    return fill;
}

function _buildStackLine(source) {
    const { scale , index , line  } = source;
    const points = [];
    const segments = line.segments;
    const sourcePoints = line.points;
    const linesBelow = getLinesBelow(scale, index);
    linesBelow.push(_createBoundaryLine({
        x: null,
        y: scale.bottom
    }, line));
    for(let i = 0; i < segments.length; i++){
        const segment = segments[i];
        for(let j = segment.start; j <= segment.end; j++){
            addPointsBelow(points, sourcePoints[j], linesBelow);
        }
    }
    return new LineElement({
        points,
        options: {}
    });
}
 function getLinesBelow(scale, index) {
    const below = [];
    const metas = scale.getMatchingVisibleMetas('line');
    for(let i = 0; i < metas.length; i++){
        const meta = metas[i];
        if (meta.index === index) {
            break;
        }
        if (!meta.hidden) {
            below.unshift(meta.dataset);
        }
    }
    return below;
}
 function addPointsBelow(points, sourcePoint, linesBelow) {
    const postponed = [];
    for(let j = 0; j < linesBelow.length; j++){
        const line = linesBelow[j];
        const { first , last , point  } = findPoint(line, sourcePoint, 'x');
        if (!point || first && last) {
            continue;
        }
        if (first) {
            postponed.unshift(point);
        } else {
            points.push(point);
            if (!last) {
                break;
            }
        }
    }
    points.push(...postponed);
}
 function findPoint(line, sourcePoint, property) {
    const point = line.interpolate(sourcePoint, property);
    if (!point) {
        return {};
    }
    const pointValue = point[property];
    const segments = line.segments;
    const linePoints = line.points;
    let first = false;
    let last = false;
    for(let i = 0; i < segments.length; i++){
        const segment = segments[i];
        const firstValue = linePoints[segment.start][property];
        const lastValue = linePoints[segment.end][property];
        if (_isBetween(pointValue, firstValue, lastValue)) {
            first = pointValue === firstValue;
            last = pointValue === lastValue;
            break;
        }
    }
    return {
        first,
        last,
        point
    };
}

class simpleArc {
    constructor(opts){
        this.x = opts.x;
        this.y = opts.y;
        this.radius = opts.radius;
    }
    pathSegment(ctx, bounds, opts) {
        const { x , y , radius  } = this;
        bounds = bounds || {
            start: 0,
            end: TAU
        };
        ctx.arc(x, y, radius, bounds.end, bounds.start, true);
        return !opts.bounds;
    }
    interpolate(point) {
        const { x , y , radius  } = this;
        const angle = point.angle;
        return {
            x: x + Math.cos(angle) * radius,
            y: y + Math.sin(angle) * radius,
            angle
        };
    }
}

function _getTarget(source) {
    const { chart , fill , line  } = source;
    if (isNumberFinite(fill)) {
        return getLineByIndex(chart, fill);
    }
    if (fill === 'stack') {
        return _buildStackLine(source);
    }
    if (fill === 'shape') {
        return true;
    }
    const boundary = computeBoundary(source);
    if (boundary instanceof simpleArc) {
        return boundary;
    }
    return _createBoundaryLine(boundary, line);
}
 function getLineByIndex(chart, index) {
    const meta = chart.getDatasetMeta(index);
    const visible = meta && chart.isDatasetVisible(index);
    return visible ? meta.dataset : null;
}
function computeBoundary(source) {
    const scale = source.scale || {};
    if (scale.getPointPositionForValue) {
        return computeCircularBoundary(source);
    }
    return computeLinearBoundary(source);
}
function computeLinearBoundary(source) {
    const { scale ={} , fill  } = source;
    const pixel = _getTargetPixel(fill, scale);
    if (isNumberFinite(pixel)) {
        const horizontal = scale.isHorizontal();
        return {
            x: horizontal ? pixel : null,
            y: horizontal ? null : pixel
        };
    }
    return null;
}
function computeCircularBoundary(source) {
    const { scale , fill  } = source;
    const options = scale.options;
    const length = scale.getLabels().length;
    const start = options.reverse ? scale.max : scale.min;
    const value = _getTargetValue(fill, scale, start);
    const target = [];
    if (options.grid.circular) {
        const center = scale.getPointPositionForValue(0, start);
        return new simpleArc({
            x: center.x,
            y: center.y,
            radius: scale.getDistanceFromCenterForValue(value)
        });
    }
    for(let i = 0; i < length; ++i){
        target.push(scale.getPointPositionForValue(i, value));
    }
    return target;
}

function _drawfill(ctx, source, area) {
    const target = _getTarget(source);
    const { line , scale , axis  } = source;
    const lineOpts = line.options;
    const fillOption = lineOpts.fill;
    const color = lineOpts.backgroundColor;
    const { above =color , below =color  } = fillOption || {};
    if (target && line.points.length) {
        clipArea(ctx, area);
        doFill(ctx, {
            line,
            target,
            above,
            below,
            area,
            scale,
            axis
        });
        unclipArea(ctx);
    }
}
function doFill(ctx, cfg) {
    const { line , target , above , below , area , scale  } = cfg;
    const property = line._loop ? 'angle' : cfg.axis;
    ctx.save();
    if (property === 'x' && below !== above) {
        clipVertical(ctx, target, area.top);
        fill(ctx, {
            line,
            target,
            color: above,
            scale,
            property
        });
        ctx.restore();
        ctx.save();
        clipVertical(ctx, target, area.bottom);
    }
    fill(ctx, {
        line,
        target,
        color: below,
        scale,
        property
    });
    ctx.restore();
}
function clipVertical(ctx, target, clipY) {
    const { segments , points  } = target;
    let first = true;
    let lineLoop = false;
    ctx.beginPath();
    for (const segment of segments){
        const { start , end  } = segment;
        const firstPoint = points[start];
        const lastPoint = points[_findSegmentEnd(start, end, points)];
        if (first) {
            ctx.moveTo(firstPoint.x, firstPoint.y);
            first = false;
        } else {
            ctx.lineTo(firstPoint.x, clipY);
            ctx.lineTo(firstPoint.x, firstPoint.y);
        }
        lineLoop = !!target.pathSegment(ctx, segment, {
            move: lineLoop
        });
        if (lineLoop) {
            ctx.closePath();
        } else {
            ctx.lineTo(lastPoint.x, clipY);
        }
    }
    ctx.lineTo(target.first().x, clipY);
    ctx.closePath();
    ctx.clip();
}
function fill(ctx, cfg) {
    const { line , target , property , color , scale  } = cfg;
    const segments = _segments(line, target, property);
    for (const { source: src , target: tgt , start , end  } of segments){
        const { style: { backgroundColor =color  } = {}  } = src;
        const notShape = target !== true;
        ctx.save();
        ctx.fillStyle = backgroundColor;
        clipBounds(ctx, scale, notShape && _getBounds(property, start, end));
        ctx.beginPath();
        const lineLoop = !!line.pathSegment(ctx, src);
        let loop;
        if (notShape) {
            if (lineLoop) {
                ctx.closePath();
            } else {
                interpolatedLineTo(ctx, target, end, property);
            }
            const targetLoop = !!target.pathSegment(ctx, tgt, {
                move: lineLoop,
                reverse: true
            });
            loop = lineLoop && targetLoop;
            if (!loop) {
                interpolatedLineTo(ctx, target, start, property);
            }
        }
        ctx.closePath();
        ctx.fill(loop ? 'evenodd' : 'nonzero');
        ctx.restore();
    }
}
function clipBounds(ctx, scale, bounds) {
    const { top , bottom  } = scale.chart.chartArea;
    const { property , start , end  } = bounds || {};
    if (property === 'x') {
        ctx.beginPath();
        ctx.rect(start, top, end - start, bottom - top);
        ctx.clip();
    }
}
function interpolatedLineTo(ctx, target, point, property) {
    const interpolatedPoint = target.interpolate(point, property);
    if (interpolatedPoint) {
        ctx.lineTo(interpolatedPoint.x, interpolatedPoint.y);
    }
}

var index = {
    id: 'filler',
    afterDatasetsUpdate (chart, _args, options) {
        const count = (chart.data.datasets || []).length;
        const sources = [];
        let meta, i, line, source;
        for(i = 0; i < count; ++i){
            meta = chart.getDatasetMeta(i);
            line = meta.dataset;
            source = null;
            if (line && line.options && line instanceof LineElement) {
                source = {
                    visible: chart.isDatasetVisible(i),
                    index: i,
                    fill: _decodeFill(line, i, count),
                    chart,
                    axis: meta.controller.options.indexAxis,
                    scale: meta.vScale,
                    line
                };
            }
            meta.$filler = source;
            sources.push(source);
        }
        for(i = 0; i < count; ++i){
            source = sources[i];
            if (!source || source.fill === false) {
                continue;
            }
            source.fill = _resolveTarget(sources, i, options.propagate);
        }
    },
    beforeDraw (chart, _args, options) {
        const draw = options.drawTime === 'beforeDraw';
        const metasets = chart.getSortedVisibleDatasetMetas();
        const area = chart.chartArea;
        for(let i = metasets.length - 1; i >= 0; --i){
            const source = metasets[i].$filler;
            if (!source) {
                continue;
            }
            source.line.updateControlPoints(area, source.axis);
            if (draw && source.fill) {
                _drawfill(chart.ctx, source, area);
            }
        }
    },
    beforeDatasetsDraw (chart, _args, options) {
        if (options.drawTime !== 'beforeDatasetsDraw') {
            return;
        }
        const metasets = chart.getSortedVisibleDatasetMetas();
        for(let i = metasets.length - 1; i >= 0; --i){
            const source = metasets[i].$filler;
            if (_shouldApplyFill(source)) {
                _drawfill(chart.ctx, source, chart.chartArea);
            }
        }
    },
    beforeDatasetDraw (chart, args, options) {
        const source = args.meta.$filler;
        if (!_shouldApplyFill(source) || options.drawTime !== 'beforeDatasetDraw') {
            return;
        }
        _drawfill(chart.ctx, source, chart.chartArea);
    },
    defaults: {
        propagate: true,
        drawTime: 'beforeDatasetDraw'
    }
};

const getBoxSize = (labelOpts, fontSize)=>{
    let { boxHeight =fontSize , boxWidth =fontSize  } = labelOpts;
    if (labelOpts.usePointStyle) {
        boxHeight = Math.min(boxHeight, fontSize);
        boxWidth = labelOpts.pointStyleWidth || Math.min(boxWidth, fontSize);
    }
    return {
        boxWidth,
        boxHeight,
        itemHeight: Math.max(fontSize, boxHeight)
    };
};
const itemsEqual = (a, b)=>a !== null && b !== null && a.datasetIndex === b.datasetIndex && a.index === b.index;
class Legend extends Element {
 constructor(config){
        super();
        this._added = false;
        this.legendHitBoxes = [];
 this._hoveredItem = null;
        this.doughnutMode = false;
        this.chart = config.chart;
        this.options = config.options;
        this.ctx = config.ctx;
        this.legendItems = undefined;
        this.columnSizes = undefined;
        this.lineWidths = undefined;
        this.maxHeight = undefined;
        this.maxWidth = undefined;
        this.top = undefined;
        this.bottom = undefined;
        this.left = undefined;
        this.right = undefined;
        this.height = undefined;
        this.width = undefined;
        this._margins = undefined;
        this.position = undefined;
        this.weight = undefined;
        this.fullSize = undefined;
    }
    update(maxWidth, maxHeight, margins) {
        this.maxWidth = maxWidth;
        this.maxHeight = maxHeight;
        this._margins = margins;
        this.setDimensions();
        this.buildLabels();
        this.fit();
    }
    setDimensions() {
        if (this.isHorizontal()) {
            this.width = this.maxWidth;
            this.left = this._margins.left;
            this.right = this.width;
        } else {
            this.height = this.maxHeight;
            this.top = this._margins.top;
            this.bottom = this.height;
        }
    }
    buildLabels() {
        const labelOpts = this.options.labels || {};
        let legendItems = callback(labelOpts.generateLabels, [
            this.chart
        ], this) || [];
        if (labelOpts.filter) {
            legendItems = legendItems.filter((item)=>labelOpts.filter(item, this.chart.data));
        }
        if (labelOpts.sort) {
            legendItems = legendItems.sort((a, b)=>labelOpts.sort(a, b, this.chart.data));
        }
        if (this.options.reverse) {
            legendItems.reverse();
        }
        this.legendItems = legendItems;
    }
    fit() {
        const { options , ctx  } = this;
        if (!options.display) {
            this.width = this.height = 0;
            return;
        }
        const labelOpts = options.labels;
        const labelFont = toFont(labelOpts.font);
        const fontSize = labelFont.size;
        const titleHeight = this._computeTitleHeight();
        const { boxWidth , itemHeight  } = getBoxSize(labelOpts, fontSize);
        let width, height;
        ctx.font = labelFont.string;
        if (this.isHorizontal()) {
            width = this.maxWidth;
            height = this._fitRows(titleHeight, fontSize, boxWidth, itemHeight) + 10;
        } else {
            height = this.maxHeight;
            width = this._fitCols(titleHeight, labelFont, boxWidth, itemHeight) + 10;
        }
        this.width = Math.min(width, options.maxWidth || this.maxWidth);
        this.height = Math.min(height, options.maxHeight || this.maxHeight);
    }
 _fitRows(titleHeight, fontSize, boxWidth, itemHeight) {
        const { ctx , maxWidth , options: { labels: { padding  }  }  } = this;
        const hitboxes = this.legendHitBoxes = [];
        const lineWidths = this.lineWidths = [
            0
        ];
        const lineHeight = itemHeight + padding;
        let totalHeight = titleHeight;
        ctx.textAlign = 'left';
        ctx.textBaseline = 'middle';
        let row = -1;
        let top = -lineHeight;
        this.legendItems.forEach((legendItem, i)=>{
            const itemWidth = boxWidth + fontSize / 2 + ctx.measureText(legendItem.text).width;
            if (i === 0 || lineWidths[lineWidths.length - 1] + itemWidth + 2 * padding > maxWidth) {
                totalHeight += lineHeight;
                lineWidths[lineWidths.length - (i > 0 ? 0 : 1)] = 0;
                top += lineHeight;
                row++;
            }
            hitboxes[i] = {
                left: 0,
                top,
                row,
                width: itemWidth,
                height: itemHeight
            };
            lineWidths[lineWidths.length - 1] += itemWidth + padding;
        });
        return totalHeight;
    }
    _fitCols(titleHeight, labelFont, boxWidth, _itemHeight) {
        const { ctx , maxHeight , options: { labels: { padding  }  }  } = this;
        const hitboxes = this.legendHitBoxes = [];
        const columnSizes = this.columnSizes = [];
        const heightLimit = maxHeight - titleHeight;
        let totalWidth = padding;
        let currentColWidth = 0;
        let currentColHeight = 0;
        let left = 0;
        let col = 0;
        this.legendItems.forEach((legendItem, i)=>{
            const { itemWidth , itemHeight  } = calculateItemSize(boxWidth, labelFont, ctx, legendItem, _itemHeight);
            if (i > 0 && currentColHeight + itemHeight + 2 * padding > heightLimit) {
                totalWidth += currentColWidth + padding;
                columnSizes.push({
                    width: currentColWidth,
                    height: currentColHeight
                });
                left += currentColWidth + padding;
                col++;
                currentColWidth = currentColHeight = 0;
            }
            hitboxes[i] = {
                left,
                top: currentColHeight,
                col,
                width: itemWidth,
                height: itemHeight
            };
            currentColWidth = Math.max(currentColWidth, itemWidth);
            currentColHeight += itemHeight + padding;
        });
        totalWidth += currentColWidth;
        columnSizes.push({
            width: currentColWidth,
            height: currentColHeight
        });
        return totalWidth;
    }
    adjustHitBoxes() {
        if (!this.options.display) {
            return;
        }
        const titleHeight = this._computeTitleHeight();
        const { legendHitBoxes: hitboxes , options: { align , labels: { padding  } , rtl  }  } = this;
        const rtlHelper = getRtlAdapter(rtl, this.left, this.width);
        if (this.isHorizontal()) {
            let row = 0;
            let left = _alignStartEnd(align, this.left + padding, this.right - this.lineWidths[row]);
            for (const hitbox of hitboxes){
                if (row !== hitbox.row) {
                    row = hitbox.row;
                    left = _alignStartEnd(align, this.left + padding, this.right - this.lineWidths[row]);
                }
                hitbox.top += this.top + titleHeight + padding;
                hitbox.left = rtlHelper.leftForLtr(rtlHelper.x(left), hitbox.width);
                left += hitbox.width + padding;
            }
        } else {
            let col = 0;
            let top = _alignStartEnd(align, this.top + titleHeight + padding, this.bottom - this.columnSizes[col].height);
            for (const hitbox of hitboxes){
                if (hitbox.col !== col) {
                    col = hitbox.col;
                    top = _alignStartEnd(align, this.top + titleHeight + padding, this.bottom - this.columnSizes[col].height);
                }
                hitbox.top = top;
                hitbox.left += this.left + padding;
                hitbox.left = rtlHelper.leftForLtr(rtlHelper.x(hitbox.left), hitbox.width);
                top += hitbox.height + padding;
            }
        }
    }
    isHorizontal() {
        return this.options.position === 'top' || this.options.position === 'bottom';
    }
    draw() {
        if (this.options.display) {
            const ctx = this.ctx;
            clipArea(ctx, this);
            this._draw();
            unclipArea(ctx);
        }
    }
 _draw() {
        const { options: opts , columnSizes , lineWidths , ctx  } = this;
        const { align , labels: labelOpts  } = opts;
        const defaultColor = defaults.color;
        const rtlHelper = getRtlAdapter(opts.rtl, this.left, this.width);
        const labelFont = toFont(labelOpts.font);
        const { padding  } = labelOpts;
        const fontSize = labelFont.size;
        const halfFontSize = fontSize / 2;
        let cursor;
        this.drawTitle();
        ctx.textAlign = rtlHelper.textAlign('left');
        ctx.textBaseline = 'middle';
        ctx.lineWidth = 0.5;
        ctx.font = labelFont.string;
        const { boxWidth , boxHeight , itemHeight  } = getBoxSize(labelOpts, fontSize);
        const drawLegendBox = function(x, y, legendItem) {
            if (isNaN(boxWidth) || boxWidth <= 0 || isNaN(boxHeight) || boxHeight < 0) {
                return;
            }
            ctx.save();
            const lineWidth = valueOrDefault(legendItem.lineWidth, 1);
            ctx.fillStyle = valueOrDefault(legendItem.fillStyle, defaultColor);
            ctx.lineCap = valueOrDefault(legendItem.lineCap, 'butt');
            ctx.lineDashOffset = valueOrDefault(legendItem.lineDashOffset, 0);
            ctx.lineJoin = valueOrDefault(legendItem.lineJoin, 'miter');
            ctx.lineWidth = lineWidth;
            ctx.strokeStyle = valueOrDefault(legendItem.strokeStyle, defaultColor);
            ctx.setLineDash(valueOrDefault(legendItem.lineDash, []));
            if (labelOpts.usePointStyle) {
                const drawOptions = {
                    radius: boxHeight * Math.SQRT2 / 2,
                    pointStyle: legendItem.pointStyle,
                    rotation: legendItem.rotation,
                    borderWidth: lineWidth
                };
                const centerX = rtlHelper.xPlus(x, boxWidth / 2);
                const centerY = y + halfFontSize;
                drawPointLegend(ctx, drawOptions, centerX, centerY, labelOpts.pointStyleWidth && boxWidth);
            } else {
                const yBoxTop = y + Math.max((fontSize - boxHeight) / 2, 0);
                const xBoxLeft = rtlHelper.leftForLtr(x, boxWidth);
                const borderRadius = toTRBLCorners(legendItem.borderRadius);
                ctx.beginPath();
                if (Object.values(borderRadius).some((v)=>v !== 0)) {
                    addRoundedRectPath(ctx, {
                        x: xBoxLeft,
                        y: yBoxTop,
                        w: boxWidth,
                        h: boxHeight,
                        radius: borderRadius
                    });
                } else {
                    ctx.rect(xBoxLeft, yBoxTop, boxWidth, boxHeight);
                }
                ctx.fill();
                if (lineWidth !== 0) {
                    ctx.stroke();
                }
            }
            ctx.restore();
        };
        const fillText = function(x, y, legendItem) {
            renderText(ctx, legendItem.text, x, y + itemHeight / 2, labelFont, {
                strikethrough: legendItem.hidden,
                textAlign: rtlHelper.textAlign(legendItem.textAlign)
            });
        };
        const isHorizontal = this.isHorizontal();
        const titleHeight = this._computeTitleHeight();
        if (isHorizontal) {
            cursor = {
                x: _alignStartEnd(align, this.left + padding, this.right - lineWidths[0]),
                y: this.top + padding + titleHeight,
                line: 0
            };
        } else {
            cursor = {
                x: this.left + padding,
                y: _alignStartEnd(align, this.top + titleHeight + padding, this.bottom - columnSizes[0].height),
                line: 0
            };
        }
        overrideTextDirection(this.ctx, opts.textDirection);
        const lineHeight = itemHeight + padding;
        this.legendItems.forEach((legendItem, i)=>{
            ctx.strokeStyle = legendItem.fontColor;
            ctx.fillStyle = legendItem.fontColor;
            const textWidth = ctx.measureText(legendItem.text).width;
            const textAlign = rtlHelper.textAlign(legendItem.textAlign || (legendItem.textAlign = labelOpts.textAlign));
            const width = boxWidth + halfFontSize + textWidth;
            let x = cursor.x;
            let y = cursor.y;
            rtlHelper.setWidth(this.width);
            if (isHorizontal) {
                if (i > 0 && x + width + padding > this.right) {
                    y = cursor.y += lineHeight;
                    cursor.line++;
                    x = cursor.x = _alignStartEnd(align, this.left + padding, this.right - lineWidths[cursor.line]);
                }
            } else if (i > 0 && y + lineHeight > this.bottom) {
                x = cursor.x = x + columnSizes[cursor.line].width + padding;
                cursor.line++;
                y = cursor.y = _alignStartEnd(align, this.top + titleHeight + padding, this.bottom - columnSizes[cursor.line].height);
            }
            const realX = rtlHelper.x(x);
            drawLegendBox(realX, y, legendItem);
            x = _textX(textAlign, x + boxWidth + halfFontSize, isHorizontal ? x + width : this.right, opts.rtl);
            fillText(rtlHelper.x(x), y, legendItem);
            if (isHorizontal) {
                cursor.x += width + padding;
            } else if (typeof legendItem.text !== 'string') {
                const fontLineHeight = labelFont.lineHeight;
                cursor.y += calculateLegendItemHeight(legendItem, fontLineHeight) + padding;
            } else {
                cursor.y += lineHeight;
            }
        });
        restoreTextDirection(this.ctx, opts.textDirection);
    }
 drawTitle() {
        const opts = this.options;
        const titleOpts = opts.title;
        const titleFont = toFont(titleOpts.font);
        const titlePadding = toPadding(titleOpts.padding);
        if (!titleOpts.display) {
            return;
        }
        const rtlHelper = getRtlAdapter(opts.rtl, this.left, this.width);
        const ctx = this.ctx;
        const position = titleOpts.position;
        const halfFontSize = titleFont.size / 2;
        const topPaddingPlusHalfFontSize = titlePadding.top + halfFontSize;
        let y;
        let left = this.left;
        let maxWidth = this.width;
        if (this.isHorizontal()) {
            maxWidth = Math.max(...this.lineWidths);
            y = this.top + topPaddingPlusHalfFontSize;
            left = _alignStartEnd(opts.align, left, this.right - maxWidth);
        } else {
            const maxHeight = this.columnSizes.reduce((acc, size)=>Math.max(acc, size.height), 0);
            y = topPaddingPlusHalfFontSize + _alignStartEnd(opts.align, this.top, this.bottom - maxHeight - opts.labels.padding - this._computeTitleHeight());
        }
        const x = _alignStartEnd(position, left, left + maxWidth);
        ctx.textAlign = rtlHelper.textAlign(_toLeftRightCenter(position));
        ctx.textBaseline = 'middle';
        ctx.strokeStyle = titleOpts.color;
        ctx.fillStyle = titleOpts.color;
        ctx.font = titleFont.string;
        renderText(ctx, titleOpts.text, x, y, titleFont);
    }
 _computeTitleHeight() {
        const titleOpts = this.options.title;
        const titleFont = toFont(titleOpts.font);
        const titlePadding = toPadding(titleOpts.padding);
        return titleOpts.display ? titleFont.lineHeight + titlePadding.height : 0;
    }
 _getLegendItemAt(x, y) {
        let i, hitBox, lh;
        if (_isBetween(x, this.left, this.right) && _isBetween(y, this.top, this.bottom)) {
            lh = this.legendHitBoxes;
            for(i = 0; i < lh.length; ++i){
                hitBox = lh[i];
                if (_isBetween(x, hitBox.left, hitBox.left + hitBox.width) && _isBetween(y, hitBox.top, hitBox.top + hitBox.height)) {
                    return this.legendItems[i];
                }
            }
        }
        return null;
    }
 handleEvent(e) {
        const opts = this.options;
        if (!isListened(e.type, opts)) {
            return;
        }
        const hoveredItem = this._getLegendItemAt(e.x, e.y);
        if (e.type === 'mousemove' || e.type === 'mouseout') {
            const previous = this._hoveredItem;
            const sameItem = itemsEqual(previous, hoveredItem);
            if (previous && !sameItem) {
                callback(opts.onLeave, [
                    e,
                    previous,
                    this
                ], this);
            }
            this._hoveredItem = hoveredItem;
            if (hoveredItem && !sameItem) {
                callback(opts.onHover, [
                    e,
                    hoveredItem,
                    this
                ], this);
            }
        } else if (hoveredItem) {
            callback(opts.onClick, [
                e,
                hoveredItem,
                this
            ], this);
        }
    }
}
function calculateItemSize(boxWidth, labelFont, ctx, legendItem, _itemHeight) {
    const itemWidth = calculateItemWidth(legendItem, boxWidth, labelFont, ctx);
    const itemHeight = calculateItemHeight(_itemHeight, legendItem, labelFont.lineHeight);
    return {
        itemWidth,
        itemHeight
    };
}
function calculateItemWidth(legendItem, boxWidth, labelFont, ctx) {
    let legendItemText = legendItem.text;
    if (legendItemText && typeof legendItemText !== 'string') {
        legendItemText = legendItemText.reduce((a, b)=>a.length > b.length ? a : b);
    }
    return boxWidth + labelFont.size / 2 + ctx.measureText(legendItemText).width;
}
function calculateItemHeight(_itemHeight, legendItem, fontLineHeight) {
    let itemHeight = _itemHeight;
    if (typeof legendItem.text !== 'string') {
        itemHeight = calculateLegendItemHeight(legendItem, fontLineHeight);
    }
    return itemHeight;
}
function calculateLegendItemHeight(legendItem, fontLineHeight) {
    const labelHeight = legendItem.text ? legendItem.text.length : 0;
    return fontLineHeight * labelHeight;
}
function isListened(type, opts) {
    if ((type === 'mousemove' || type === 'mouseout') && (opts.onHover || opts.onLeave)) {
        return true;
    }
    if (opts.onClick && (type === 'click' || type === 'mouseup')) {
        return true;
    }
    return false;
}
var plugin_legend = {
    id: 'legend',
 _element: Legend,
    start (chart, _args, options) {
        const legend = chart.legend = new Legend({
            ctx: chart.ctx,
            options,
            chart
        });
        layouts.configure(chart, legend, options);
        layouts.addBox(chart, legend);
    },
    stop (chart) {
        layouts.removeBox(chart, chart.legend);
        delete chart.legend;
    },
    beforeUpdate (chart, _args, options) {
        const legend = chart.legend;
        layouts.configure(chart, legend, options);
        legend.options = options;
    },
    afterUpdate (chart) {
        const legend = chart.legend;
        legend.buildLabels();
        legend.adjustHitBoxes();
    },
    afterEvent (chart, args) {
        if (!args.replay) {
            chart.legend.handleEvent(args.event);
        }
    },
    defaults: {
        display: true,
        position: 'top',
        align: 'center',
        fullSize: true,
        reverse: false,
        weight: 1000,
        onClick (e, legendItem, legend) {
            const index = legendItem.datasetIndex;
            const ci = legend.chart;
            if (ci.isDatasetVisible(index)) {
                ci.hide(index);
                legendItem.hidden = true;
            } else {
                ci.show(index);
                legendItem.hidden = false;
            }
        },
        onHover: null,
        onLeave: null,
        labels: {
            color: (ctx)=>ctx.chart.options.color,
            boxWidth: 40,
            padding: 10,
            generateLabels (chart) {
                const datasets = chart.data.datasets;
                const { labels: { usePointStyle , pointStyle , textAlign , color , useBorderRadius , borderRadius  }  } = chart.legend.options;
                return chart._getSortedDatasetMetas().map((meta)=>{
                    const style = meta.controller.getStyle(usePointStyle ? 0 : undefined);
                    const borderWidth = toPadding(style.borderWidth);
                    return {
                        text: datasets[meta.index].label,
                        fillStyle: style.backgroundColor,
                        fontColor: color,
                        hidden: !meta.visible,
                        lineCap: style.borderCapStyle,
                        lineDash: style.borderDash,
                        lineDashOffset: style.borderDashOffset,
                        lineJoin: style.borderJoinStyle,
                        lineWidth: (borderWidth.width + borderWidth.height) / 4,
                        strokeStyle: style.borderColor,
                        pointStyle: pointStyle || style.pointStyle,
                        rotation: style.rotation,
                        textAlign: textAlign || style.textAlign,
                        borderRadius: useBorderRadius && (borderRadius || style.borderRadius),
                        datasetIndex: meta.index
                    };
                }, this);
            }
        },
        title: {
            color: (ctx)=>ctx.chart.options.color,
            display: false,
            position: 'center',
            text: ''
        }
    },
    descriptors: {
        _scriptable: (name)=>!name.startsWith('on'),
        labels: {
            _scriptable: (name)=>![
                    'generateLabels',
                    'filter',
                    'sort'
                ].includes(name)
        }
    }
};

class Title extends Element {
 constructor(config){
        super();
        this.chart = config.chart;
        this.options = config.options;
        this.ctx = config.ctx;
        this._padding = undefined;
        this.top = undefined;
        this.bottom = undefined;
        this.left = undefined;
        this.right = undefined;
        this.width = undefined;
        this.height = undefined;
        this.position = undefined;
        this.weight = undefined;
        this.fullSize = undefined;
    }
    update(maxWidth, maxHeight) {
        const opts = this.options;
        this.left = 0;
        this.top = 0;
        if (!opts.display) {
            this.width = this.height = this.right = this.bottom = 0;
            return;
        }
        this.width = this.right = maxWidth;
        this.height = this.bottom = maxHeight;
        const lineCount = isArray(opts.text) ? opts.text.length : 1;
        this._padding = toPadding(opts.padding);
        const textSize = lineCount * toFont(opts.font).lineHeight + this._padding.height;
        if (this.isHorizontal()) {
            this.height = textSize;
        } else {
            this.width = textSize;
        }
    }
    isHorizontal() {
        const pos = this.options.position;
        return pos === 'top' || pos === 'bottom';
    }
    _drawArgs(offset) {
        const { top , left , bottom , right , options  } = this;
        const align = options.align;
        let rotation = 0;
        let maxWidth, titleX, titleY;
        if (this.isHorizontal()) {
            titleX = _alignStartEnd(align, left, right);
            titleY = top + offset;
            maxWidth = right - left;
        } else {
            if (options.position === 'left') {
                titleX = left + offset;
                titleY = _alignStartEnd(align, bottom, top);
                rotation = PI * -0.5;
            } else {
                titleX = right - offset;
                titleY = _alignStartEnd(align, top, bottom);
                rotation = PI * 0.5;
            }
            maxWidth = bottom - top;
        }
        return {
            titleX,
            titleY,
            maxWidth,
            rotation
        };
    }
    draw() {
        const ctx = this.ctx;
        const opts = this.options;
        if (!opts.display) {
            return;
        }
        const fontOpts = toFont(opts.font);
        const lineHeight = fontOpts.lineHeight;
        const offset = lineHeight / 2 + this._padding.top;
        const { titleX , titleY , maxWidth , rotation  } = this._drawArgs(offset);
        renderText(ctx, opts.text, 0, 0, fontOpts, {
            color: opts.color,
            maxWidth,
            rotation,
            textAlign: _toLeftRightCenter(opts.align),
            textBaseline: 'middle',
            translation: [
                titleX,
                titleY
            ]
        });
    }
}
function createTitle(chart, titleOpts) {
    const title = new Title({
        ctx: chart.ctx,
        options: titleOpts,
        chart
    });
    layouts.configure(chart, title, titleOpts);
    layouts.addBox(chart, title);
    chart.titleBlock = title;
}
var plugin_title = {
    id: 'title',
 _element: Title,
    start (chart, _args, options) {
        createTitle(chart, options);
    },
    stop (chart) {
        const titleBlock = chart.titleBlock;
        layouts.removeBox(chart, titleBlock);
        delete chart.titleBlock;
    },
    beforeUpdate (chart, _args, options) {
        const title = chart.titleBlock;
        layouts.configure(chart, title, options);
        title.options = options;
    },
    defaults: {
        align: 'center',
        display: false,
        font: {
            weight: 'bold'
        },
        fullSize: true,
        padding: 10,
        position: 'top',
        text: '',
        weight: 2000
    },
    defaultRoutes: {
        color: 'color'
    },
    descriptors: {
        _scriptable: true,
        _indexable: false
    }
};

const chart_map = new WeakMap();
var plugin_subtitle = {
    id: 'subtitle',
    start (chart, _args, options) {
        const title = new Title({
            ctx: chart.ctx,
            options,
            chart
        });
        layouts.configure(chart, title, options);
        layouts.addBox(chart, title);
        chart_map.set(chart, title);
    },
    stop (chart) {
        layouts.removeBox(chart, chart_map.get(chart));
        chart_map.delete(chart);
    },
    beforeUpdate (chart, _args, options) {
        const title = chart_map.get(chart);
        layouts.configure(chart, title, options);
        title.options = options;
    },
    defaults: {
        align: 'center',
        display: false,
        font: {
            weight: 'normal'
        },
        fullSize: true,
        padding: 0,
        position: 'top',
        text: '',
        weight: 1500
    },
    defaultRoutes: {
        color: 'color'
    },
    descriptors: {
        _scriptable: true,
        _indexable: false
    }
};

const positioners = {
 average (items) {
        if (!items.length) {
            return false;
        }
        let i, len;
        let xSet = new Set();
        let y = 0;
        let count = 0;
        for(i = 0, len = items.length; i < len; ++i){
            const el = items[i].element;
            if (el && el.hasValue()) {
                const pos = el.tooltipPosition();
                xSet.add(pos.x);
                y += pos.y;
                ++count;
            }
        }
        const xAverage = [
            ...xSet
        ].reduce((a, b)=>a + b) / xSet.size;
        return {
            x: xAverage,
            y: y / count
        };
    },
 nearest (items, eventPosition) {
        if (!items.length) {
            return false;
        }
        let x = eventPosition.x;
        let y = eventPosition.y;
        let minDistance = Number.POSITIVE_INFINITY;
        let i, len, nearestElement;
        for(i = 0, len = items.length; i < len; ++i){
            const el = items[i].element;
            if (el && el.hasValue()) {
                const center = el.getCenterPoint();
                const d = distanceBetweenPoints(eventPosition, center);
                if (d < minDistance) {
                    minDistance = d;
                    nearestElement = el;
                }
            }
        }
        if (nearestElement) {
            const tp = nearestElement.tooltipPosition();
            x = tp.x;
            y = tp.y;
        }
        return {
            x,
            y
        };
    }
};
function pushOrConcat(base, toPush) {
    if (toPush) {
        if (isArray(toPush)) {
            Array.prototype.push.apply(base, toPush);
        } else {
            base.push(toPush);
        }
    }
    return base;
}
 function splitNewlines(str) {
    if ((typeof str === 'string' || str instanceof String) && str.indexOf('\n') > -1) {
        return str.split('\n');
    }
    return str;
}
 function createTooltipItem(chart, item) {
    const { element , datasetIndex , index  } = item;
    const controller = chart.getDatasetMeta(datasetIndex).controller;
    const { label , value  } = controller.getLabelAndValue(index);
    return {
        chart,
        label,
        parsed: controller.getParsed(index),
        raw: chart.data.datasets[datasetIndex].data[index],
        formattedValue: value,
        dataset: controller.getDataset(),
        dataIndex: index,
        datasetIndex,
        element
    };
}
 function getTooltipSize(tooltip, options) {
    const ctx = tooltip.chart.ctx;
    const { body , footer , title  } = tooltip;
    const { boxWidth , boxHeight  } = options;
    const bodyFont = toFont(options.bodyFont);
    const titleFont = toFont(options.titleFont);
    const footerFont = toFont(options.footerFont);
    const titleLineCount = title.length;
    const footerLineCount = footer.length;
    const bodyLineItemCount = body.length;
    const padding = toPadding(options.padding);
    let height = padding.height;
    let width = 0;
    let combinedBodyLength = body.reduce((count, bodyItem)=>count + bodyItem.before.length + bodyItem.lines.length + bodyItem.after.length, 0);
    combinedBodyLength += tooltip.beforeBody.length + tooltip.afterBody.length;
    if (titleLineCount) {
        height += titleLineCount * titleFont.lineHeight + (titleLineCount - 1) * options.titleSpacing + options.titleMarginBottom;
    }
    if (combinedBodyLength) {
        const bodyLineHeight = options.displayColors ? Math.max(boxHeight, bodyFont.lineHeight) : bodyFont.lineHeight;
        height += bodyLineItemCount * bodyLineHeight + (combinedBodyLength - bodyLineItemCount) * bodyFont.lineHeight + (combinedBodyLength - 1) * options.bodySpacing;
    }
    if (footerLineCount) {
        height += options.footerMarginTop + footerLineCount * footerFont.lineHeight + (footerLineCount - 1) * options.footerSpacing;
    }
    let widthPadding = 0;
    const maxLineWidth = function(line) {
        width = Math.max(width, ctx.measureText(line).width + widthPadding);
    };
    ctx.save();
    ctx.font = titleFont.string;
    each(tooltip.title, maxLineWidth);
    ctx.font = bodyFont.string;
    each(tooltip.beforeBody.concat(tooltip.afterBody), maxLineWidth);
    widthPadding = options.displayColors ? boxWidth + 2 + options.boxPadding : 0;
    each(body, (bodyItem)=>{
        each(bodyItem.before, maxLineWidth);
        each(bodyItem.lines, maxLineWidth);
        each(bodyItem.after, maxLineWidth);
    });
    widthPadding = 0;
    ctx.font = footerFont.string;
    each(tooltip.footer, maxLineWidth);
    ctx.restore();
    width += padding.width;
    return {
        width,
        height
    };
}
function determineYAlign(chart, size) {
    const { y , height  } = size;
    if (y < height / 2) {
        return 'top';
    } else if (y > chart.height - height / 2) {
        return 'bottom';
    }
    return 'center';
}
function doesNotFitWithAlign(xAlign, chart, options, size) {
    const { x , width  } = size;
    const caret = options.caretSize + options.caretPadding;
    if (xAlign === 'left' && x + width + caret > chart.width) {
        return true;
    }
    if (xAlign === 'right' && x - width - caret < 0) {
        return true;
    }
}
function determineXAlign(chart, options, size, yAlign) {
    const { x , width  } = size;
    const { width: chartWidth , chartArea: { left , right  }  } = chart;
    let xAlign = 'center';
    if (yAlign === 'center') {
        xAlign = x <= (left + right) / 2 ? 'left' : 'right';
    } else if (x <= width / 2) {
        xAlign = 'left';
    } else if (x >= chartWidth - width / 2) {
        xAlign = 'right';
    }
    if (doesNotFitWithAlign(xAlign, chart, options, size)) {
        xAlign = 'center';
    }
    return xAlign;
}
 function determineAlignment(chart, options, size) {
    const yAlign = size.yAlign || options.yAlign || determineYAlign(chart, size);
    return {
        xAlign: size.xAlign || options.xAlign || determineXAlign(chart, options, size, yAlign),
        yAlign
    };
}
function alignX(size, xAlign) {
    let { x , width  } = size;
    if (xAlign === 'right') {
        x -= width;
    } else if (xAlign === 'center') {
        x -= width / 2;
    }
    return x;
}
function alignY(size, yAlign, paddingAndSize) {
    let { y , height  } = size;
    if (yAlign === 'top') {
        y += paddingAndSize;
    } else if (yAlign === 'bottom') {
        y -= height + paddingAndSize;
    } else {
        y -= height / 2;
    }
    return y;
}
 function getBackgroundPoint(options, size, alignment, chart) {
    const { caretSize , caretPadding , cornerRadius  } = options;
    const { xAlign , yAlign  } = alignment;
    const paddingAndSize = caretSize + caretPadding;
    const { topLeft , topRight , bottomLeft , bottomRight  } = toTRBLCorners(cornerRadius);
    let x = alignX(size, xAlign);
    const y = alignY(size, yAlign, paddingAndSize);
    if (yAlign === 'center') {
        if (xAlign === 'left') {
            x += paddingAndSize;
        } else if (xAlign === 'right') {
            x -= paddingAndSize;
        }
    } else if (xAlign === 'left') {
        x -= Math.max(topLeft, bottomLeft) + caretSize;
    } else if (xAlign === 'right') {
        x += Math.max(topRight, bottomRight) + caretSize;
    }
    return {
        x: _limitValue(x, 0, chart.width - size.width),
        y: _limitValue(y, 0, chart.height - size.height)
    };
}
function getAlignedX(tooltip, align, options) {
    const padding = toPadding(options.padding);
    return align === 'center' ? tooltip.x + tooltip.width / 2 : align === 'right' ? tooltip.x + tooltip.width - padding.right : tooltip.x + padding.left;
}
 function getBeforeAfterBodyLines(callback) {
    return pushOrConcat([], splitNewlines(callback));
}
function createTooltipContext(parent, tooltip, tooltipItems) {
    return createContext(parent, {
        tooltip,
        tooltipItems,
        type: 'tooltip'
    });
}
function overrideCallbacks(callbacks, context) {
    const override = context && context.dataset && context.dataset.tooltip && context.dataset.tooltip.callbacks;
    return override ? callbacks.override(override) : callbacks;
}
const defaultCallbacks = {
    beforeTitle: noop,
    title (tooltipItems) {
        if (tooltipItems.length > 0) {
            const item = tooltipItems[0];
            const labels = item.chart.data.labels;
            const labelCount = labels ? labels.length : 0;
            if (this && this.options && this.options.mode === 'dataset') {
                return item.dataset.label || '';
            } else if (item.label) {
                return item.label;
            } else if (labelCount > 0 && item.dataIndex < labelCount) {
                return labels[item.dataIndex];
            }
        }
        return '';
    },
    afterTitle: noop,
    beforeBody: noop,
    beforeLabel: noop,
    label (tooltipItem) {
        if (this && this.options && this.options.mode === 'dataset') {
            return tooltipItem.label + ': ' + tooltipItem.formattedValue || tooltipItem.formattedValue;
        }
        let label = tooltipItem.dataset.label || '';
        if (label) {
            label += ': ';
        }
        const value = tooltipItem.formattedValue;
        if (!isNullOrUndef(value)) {
            label += value;
        }
        return label;
    },
    labelColor (tooltipItem) {
        const meta = tooltipItem.chart.getDatasetMeta(tooltipItem.datasetIndex);
        const options = meta.controller.getStyle(tooltipItem.dataIndex);
        return {
            borderColor: options.borderColor,
            backgroundColor: options.backgroundColor,
            borderWidth: options.borderWidth,
            borderDash: options.borderDash,
            borderDashOffset: options.borderDashOffset,
            borderRadius: 0
        };
    },
    labelTextColor () {
        return this.options.bodyColor;
    },
    labelPointStyle (tooltipItem) {
        const meta = tooltipItem.chart.getDatasetMeta(tooltipItem.datasetIndex);
        const options = meta.controller.getStyle(tooltipItem.dataIndex);
        return {
            pointStyle: options.pointStyle,
            rotation: options.rotation
        };
    },
    afterLabel: noop,
    afterBody: noop,
    beforeFooter: noop,
    footer: noop,
    afterFooter: noop
};
 function invokeCallbackWithFallback(callbacks, name, ctx, arg) {
    const result = callbacks[name].call(ctx, arg);
    if (typeof result === 'undefined') {
        return defaultCallbacks[name].call(ctx, arg);
    }
    return result;
}
class Tooltip extends Element {
 static positioners = positioners;
    constructor(config){
        super();
        this.opacity = 0;
        this._active = [];
        this._eventPosition = undefined;
        this._size = undefined;
        this._cachedAnimations = undefined;
        this._tooltipItems = [];
        this.$animations = undefined;
        this.$context = undefined;
        this.chart = config.chart;
        this.options = config.options;
        this.dataPoints = undefined;
        this.title = undefined;
        this.beforeBody = undefined;
        this.body = undefined;
        this.afterBody = undefined;
        this.footer = undefined;
        this.xAlign = undefined;
        this.yAlign = undefined;
        this.x = undefined;
        this.y = undefined;
        this.height = undefined;
        this.width = undefined;
        this.caretX = undefined;
        this.caretY = undefined;
        this.labelColors = undefined;
        this.labelPointStyles = undefined;
        this.labelTextColors = undefined;
    }
    initialize(options) {
        this.options = options;
        this._cachedAnimations = undefined;
        this.$context = undefined;
    }
 _resolveAnimations() {
        const cached = this._cachedAnimations;
        if (cached) {
            return cached;
        }
        const chart = this.chart;
        const options = this.options.setContext(this.getContext());
        const opts = options.enabled && chart.options.animation && options.animations;
        const animations = new Animations(this.chart, opts);
        if (opts._cacheable) {
            this._cachedAnimations = Object.freeze(animations);
        }
        return animations;
    }
 getContext() {
        return this.$context || (this.$context = createTooltipContext(this.chart.getContext(), this, this._tooltipItems));
    }
    getTitle(context, options) {
        const { callbacks  } = options;
        const beforeTitle = invokeCallbackWithFallback(callbacks, 'beforeTitle', this, context);
        const title = invokeCallbackWithFallback(callbacks, 'title', this, context);
        const afterTitle = invokeCallbackWithFallback(callbacks, 'afterTitle', this, context);
        let lines = [];
        lines = pushOrConcat(lines, splitNewlines(beforeTitle));
        lines = pushOrConcat(lines, splitNewlines(title));
        lines = pushOrConcat(lines, splitNewlines(afterTitle));
        return lines;
    }
    getBeforeBody(tooltipItems, options) {
        return getBeforeAfterBodyLines(invokeCallbackWithFallback(options.callbacks, 'beforeBody', this, tooltipItems));
    }
    getBody(tooltipItems, options) {
        const { callbacks  } = options;
        const bodyItems = [];
        each(tooltipItems, (context)=>{
            const bodyItem = {
                before: [],
                lines: [],
                after: []
            };
            const scoped = overrideCallbacks(callbacks, context);
            pushOrConcat(bodyItem.before, splitNewlines(invokeCallbackWithFallback(scoped, 'beforeLabel', this, context)));
            pushOrConcat(bodyItem.lines, invokeCallbackWithFallback(scoped, 'label', this, context));
            pushOrConcat(bodyItem.after, splitNewlines(invokeCallbackWithFallback(scoped, 'afterLabel', this, context)));
            bodyItems.push(bodyItem);
        });
        return bodyItems;
    }
    getAfterBody(tooltipItems, options) {
        return getBeforeAfterBodyLines(invokeCallbackWithFallback(options.callbacks, 'afterBody', this, tooltipItems));
    }
    getFooter(tooltipItems, options) {
        const { callbacks  } = options;
        const beforeFooter = invokeCallbackWithFallback(callbacks, 'beforeFooter', this, tooltipItems);
        const footer = invokeCallbackWithFallback(callbacks, 'footer', this, tooltipItems);
        const afterFooter = invokeCallbackWithFallback(callbacks, 'afterFooter', this, tooltipItems);
        let lines = [];
        lines = pushOrConcat(lines, splitNewlines(beforeFooter));
        lines = pushOrConcat(lines, splitNewlines(footer));
        lines = pushOrConcat(lines, splitNewlines(afterFooter));
        return lines;
    }
 _createItems(options) {
        const active = this._active;
        const data = this.chart.data;
        const labelColors = [];
        const labelPointStyles = [];
        const labelTextColors = [];
        let tooltipItems = [];
        let i, len;
        for(i = 0, len = active.length; i < len; ++i){
            tooltipItems.push(createTooltipItem(this.chart, active[i]));
        }
        if (options.filter) {
            tooltipItems = tooltipItems.filter((element, index, array)=>options.filter(element, index, array, data));
        }
        if (options.itemSort) {
            tooltipItems = tooltipItems.sort((a, b)=>options.itemSort(a, b, data));
        }
        each(tooltipItems, (context)=>{
            const scoped = overrideCallbacks(options.callbacks, context);
            labelColors.push(invokeCallbackWithFallback(scoped, 'labelColor', this, context));
            labelPointStyles.push(invokeCallbackWithFallback(scoped, 'labelPointStyle', this, context));
            labelTextColors.push(invokeCallbackWithFallback(scoped, 'labelTextColor', this, context));
        });
        this.labelColors = labelColors;
        this.labelPointStyles = labelPointStyles;
        this.labelTextColors = labelTextColors;
        this.dataPoints = tooltipItems;
        return tooltipItems;
    }
    update(changed, replay) {
        const options = this.options.setContext(this.getContext());
        const active = this._active;
        let properties;
        let tooltipItems = [];
        if (!active.length) {
            if (this.opacity !== 0) {
                properties = {
                    opacity: 0
                };
            }
        } else {
            const position = positioners[options.position].call(this, active, this._eventPosition);
            tooltipItems = this._createItems(options);
            this.title = this.getTitle(tooltipItems, options);
            this.beforeBody = this.getBeforeBody(tooltipItems, options);
            this.body = this.getBody(tooltipItems, options);
            this.afterBody = this.getAfterBody(tooltipItems, options);
            this.footer = this.getFooter(tooltipItems, options);
            const size = this._size = getTooltipSize(this, options);
            const positionAndSize = Object.assign({}, position, size);
            const alignment = determineAlignment(this.chart, options, positionAndSize);
            const backgroundPoint = getBackgroundPoint(options, positionAndSize, alignment, this.chart);
            this.xAlign = alignment.xAlign;
            this.yAlign = alignment.yAlign;
            properties = {
                opacity: 1,
                x: backgroundPoint.x,
                y: backgroundPoint.y,
                width: size.width,
                height: size.height,
                caretX: position.x,
                caretY: position.y
            };
        }
        this._tooltipItems = tooltipItems;
        this.$context = undefined;
        if (properties) {
            this._resolveAnimations().update(this, properties);
        }
        if (changed && options.external) {
            options.external.call(this, {
                chart: this.chart,
                tooltip: this,
                replay
            });
        }
    }
    drawCaret(tooltipPoint, ctx, size, options) {
        const caretPosition = this.getCaretPosition(tooltipPoint, size, options);
        ctx.lineTo(caretPosition.x1, caretPosition.y1);
        ctx.lineTo(caretPosition.x2, caretPosition.y2);
        ctx.lineTo(caretPosition.x3, caretPosition.y3);
    }
    getCaretPosition(tooltipPoint, size, options) {
        const { xAlign , yAlign  } = this;
        const { caretSize , cornerRadius  } = options;
        const { topLeft , topRight , bottomLeft , bottomRight  } = toTRBLCorners(cornerRadius);
        const { x: ptX , y: ptY  } = tooltipPoint;
        const { width , height  } = size;
        let x1, x2, x3, y1, y2, y3;
        if (yAlign === 'center') {
            y2 = ptY + height / 2;
            if (xAlign === 'left') {
                x1 = ptX;
                x2 = x1 - caretSize;
                y1 = y2 + caretSize;
                y3 = y2 - caretSize;
            } else {
                x1 = ptX + width;
                x2 = x1 + caretSize;
                y1 = y2 - caretSize;
                y3 = y2 + caretSize;
            }
            x3 = x1;
        } else {
            if (xAlign === 'left') {
                x2 = ptX + Math.max(topLeft, bottomLeft) + caretSize;
            } else if (xAlign === 'right') {
                x2 = ptX + width - Math.max(topRight, bottomRight) - caretSize;
            } else {
                x2 = this.caretX;
            }
            if (yAlign === 'top') {
                y1 = ptY;
                y2 = y1 - caretSize;
                x1 = x2 - caretSize;
                x3 = x2 + caretSize;
            } else {
                y1 = ptY + height;
                y2 = y1 + caretSize;
                x1 = x2 + caretSize;
                x3 = x2 - caretSize;
            }
            y3 = y1;
        }
        return {
            x1,
            x2,
            x3,
            y1,
            y2,
            y3
        };
    }
    drawTitle(pt, ctx, options) {
        const title = this.title;
        const length = title.length;
        let titleFont, titleSpacing, i;
        if (length) {
            const rtlHelper = getRtlAdapter(options.rtl, this.x, this.width);
            pt.x = getAlignedX(this, options.titleAlign, options);
            ctx.textAlign = rtlHelper.textAlign(options.titleAlign);
            ctx.textBaseline = 'middle';
            titleFont = toFont(options.titleFont);
            titleSpacing = options.titleSpacing;
            ctx.fillStyle = options.titleColor;
            ctx.font = titleFont.string;
            for(i = 0; i < length; ++i){
                ctx.fillText(title[i], rtlHelper.x(pt.x), pt.y + titleFont.lineHeight / 2);
                pt.y += titleFont.lineHeight + titleSpacing;
                if (i + 1 === length) {
                    pt.y += options.titleMarginBottom - titleSpacing;
                }
            }
        }
    }
 _drawColorBox(ctx, pt, i, rtlHelper, options) {
        const labelColor = this.labelColors[i];
        const labelPointStyle = this.labelPointStyles[i];
        const { boxHeight , boxWidth  } = options;
        const bodyFont = toFont(options.bodyFont);
        const colorX = getAlignedX(this, 'left', options);
        const rtlColorX = rtlHelper.x(colorX);
        const yOffSet = boxHeight < bodyFont.lineHeight ? (bodyFont.lineHeight - boxHeight) / 2 : 0;
        const colorY = pt.y + yOffSet;
        if (options.usePointStyle) {
            const drawOptions = {
                radius: Math.min(boxWidth, boxHeight) / 2,
                pointStyle: labelPointStyle.pointStyle,
                rotation: labelPointStyle.rotation,
                borderWidth: 1
            };
            const centerX = rtlHelper.leftForLtr(rtlColorX, boxWidth) + boxWidth / 2;
            const centerY = colorY + boxHeight / 2;
            ctx.strokeStyle = options.multiKeyBackground;
            ctx.fillStyle = options.multiKeyBackground;
            drawPoint(ctx, drawOptions, centerX, centerY);
            ctx.strokeStyle = labelColor.borderColor;
            ctx.fillStyle = labelColor.backgroundColor;
            drawPoint(ctx, drawOptions, centerX, centerY);
        } else {
            ctx.lineWidth = isObject(labelColor.borderWidth) ? Math.max(...Object.values(labelColor.borderWidth)) : labelColor.borderWidth || 1;
            ctx.strokeStyle = labelColor.borderColor;
            ctx.setLineDash(labelColor.borderDash || []);
            ctx.lineDashOffset = labelColor.borderDashOffset || 0;
            const outerX = rtlHelper.leftForLtr(rtlColorX, boxWidth);
            const innerX = rtlHelper.leftForLtr(rtlHelper.xPlus(rtlColorX, 1), boxWidth - 2);
            const borderRadius = toTRBLCorners(labelColor.borderRadius);
            if (Object.values(borderRadius).some((v)=>v !== 0)) {
                ctx.beginPath();
                ctx.fillStyle = options.multiKeyBackground;
                addRoundedRectPath(ctx, {
                    x: outerX,
                    y: colorY,
                    w: boxWidth,
                    h: boxHeight,
                    radius: borderRadius
                });
                ctx.fill();
                ctx.stroke();
                ctx.fillStyle = labelColor.backgroundColor;
                ctx.beginPath();
                addRoundedRectPath(ctx, {
                    x: innerX,
                    y: colorY + 1,
                    w: boxWidth - 2,
                    h: boxHeight - 2,
                    radius: borderRadius
                });
                ctx.fill();
            } else {
                ctx.fillStyle = options.multiKeyBackground;
                ctx.fillRect(outerX, colorY, boxWidth, boxHeight);
                ctx.strokeRect(outerX, colorY, boxWidth, boxHeight);
                ctx.fillStyle = labelColor.backgroundColor;
                ctx.fillRect(innerX, colorY + 1, boxWidth - 2, boxHeight - 2);
            }
        }
        ctx.fillStyle = this.labelTextColors[i];
    }
    drawBody(pt, ctx, options) {
        const { body  } = this;
        const { bodySpacing , bodyAlign , displayColors , boxHeight , boxWidth , boxPadding  } = options;
        const bodyFont = toFont(options.bodyFont);
        let bodyLineHeight = bodyFont.lineHeight;
        let xLinePadding = 0;
        const rtlHelper = getRtlAdapter(options.rtl, this.x, this.width);
        const fillLineOfText = function(line) {
            ctx.fillText(line, rtlHelper.x(pt.x + xLinePadding), pt.y + bodyLineHeight / 2);
            pt.y += bodyLineHeight + bodySpacing;
        };
        const bodyAlignForCalculation = rtlHelper.textAlign(bodyAlign);
        let bodyItem, textColor, lines, i, j, ilen, jlen;
        ctx.textAlign = bodyAlign;
        ctx.textBaseline = 'middle';
        ctx.font = bodyFont.string;
        pt.x = getAlignedX(this, bodyAlignForCalculation, options);
        ctx.fillStyle = options.bodyColor;
        each(this.beforeBody, fillLineOfText);
        xLinePadding = displayColors && bodyAlignForCalculation !== 'right' ? bodyAlign === 'center' ? boxWidth / 2 + boxPadding : boxWidth + 2 + boxPadding : 0;
        for(i = 0, ilen = body.length; i < ilen; ++i){
            bodyItem = body[i];
            textColor = this.labelTextColors[i];
            ctx.fillStyle = textColor;
            each(bodyItem.before, fillLineOfText);
            lines = bodyItem.lines;
            if (displayColors && lines.length) {
                this._drawColorBox(ctx, pt, i, rtlHelper, options);
                bodyLineHeight = Math.max(bodyFont.lineHeight, boxHeight);
            }
            for(j = 0, jlen = lines.length; j < jlen; ++j){
                fillLineOfText(lines[j]);
                bodyLineHeight = bodyFont.lineHeight;
            }
            each(bodyItem.after, fillLineOfText);
        }
        xLinePadding = 0;
        bodyLineHeight = bodyFont.lineHeight;
        each(this.afterBody, fillLineOfText);
        pt.y -= bodySpacing;
    }
    drawFooter(pt, ctx, options) {
        const footer = this.footer;
        const length = footer.length;
        let footerFont, i;
        if (length) {
            const rtlHelper = getRtlAdapter(options.rtl, this.x, this.width);
            pt.x = getAlignedX(this, options.footerAlign, options);
            pt.y += options.footerMarginTop;
            ctx.textAlign = rtlHelper.textAlign(options.footerAlign);
            ctx.textBaseline = 'middle';
            footerFont = toFont(options.footerFont);
            ctx.fillStyle = options.footerColor;
            ctx.font = footerFont.string;
            for(i = 0; i < length; ++i){
                ctx.fillText(footer[i], rtlHelper.x(pt.x), pt.y + footerFont.lineHeight / 2);
                pt.y += footerFont.lineHeight + options.footerSpacing;
            }
        }
    }
    drawBackground(pt, ctx, tooltipSize, options) {
        const { xAlign , yAlign  } = this;
        const { x , y  } = pt;
        const { width , height  } = tooltipSize;
        const { topLeft , topRight , bottomLeft , bottomRight  } = toTRBLCorners(options.cornerRadius);
        ctx.fillStyle = options.backgroundColor;
        ctx.strokeStyle = options.borderColor;
        ctx.lineWidth = options.borderWidth;
        ctx.beginPath();
        ctx.moveTo(x + topLeft, y);
        if (yAlign === 'top') {
            this.drawCaret(pt, ctx, tooltipSize, options);
        }
        ctx.lineTo(x + width - topRight, y);
        ctx.quadraticCurveTo(x + width, y, x + width, y + topRight);
        if (yAlign === 'center' && xAlign === 'right') {
            this.drawCaret(pt, ctx, tooltipSize, options);
        }
        ctx.lineTo(x + width, y + height - bottomRight);
        ctx.quadraticCurveTo(x + width, y + height, x + width - bottomRight, y + height);
        if (yAlign === 'bottom') {
            this.drawCaret(pt, ctx, tooltipSize, options);
        }
        ctx.lineTo(x + bottomLeft, y + height);
        ctx.quadraticCurveTo(x, y + height, x, y + height - bottomLeft);
        if (yAlign === 'center' && xAlign === 'left') {
            this.drawCaret(pt, ctx, tooltipSize, options);
        }
        ctx.lineTo(x, y + topLeft);
        ctx.quadraticCurveTo(x, y, x + topLeft, y);
        ctx.closePath();
        ctx.fill();
        if (options.borderWidth > 0) {
            ctx.stroke();
        }
    }
 _updateAnimationTarget(options) {
        const chart = this.chart;
        const anims = this.$animations;
        const animX = anims && anims.x;
        const animY = anims && anims.y;
        if (animX || animY) {
            const position = positioners[options.position].call(this, this._active, this._eventPosition);
            if (!position) {
                return;
            }
            const size = this._size = getTooltipSize(this, options);
            const positionAndSize = Object.assign({}, position, this._size);
            const alignment = determineAlignment(chart, options, positionAndSize);
            const point = getBackgroundPoint(options, positionAndSize, alignment, chart);
            if (animX._to !== point.x || animY._to !== point.y) {
                this.xAlign = alignment.xAlign;
                this.yAlign = alignment.yAlign;
                this.width = size.width;
                this.height = size.height;
                this.caretX = position.x;
                this.caretY = position.y;
                this._resolveAnimations().update(this, point);
            }
        }
    }
 _willRender() {
        return !!this.opacity;
    }
    draw(ctx) {
        const options = this.options.setContext(this.getContext());
        let opacity = this.opacity;
        if (!opacity) {
            return;
        }
        this._updateAnimationTarget(options);
        const tooltipSize = {
            width: this.width,
            height: this.height
        };
        const pt = {
            x: this.x,
            y: this.y
        };
        opacity = Math.abs(opacity) < 1e-3 ? 0 : opacity;
        const padding = toPadding(options.padding);
        const hasTooltipContent = this.title.length || this.beforeBody.length || this.body.length || this.afterBody.length || this.footer.length;
        if (options.enabled && hasTooltipContent) {
            ctx.save();
            ctx.globalAlpha = opacity;
            this.drawBackground(pt, ctx, tooltipSize, options);
            overrideTextDirection(ctx, options.textDirection);
            pt.y += padding.top;
            this.drawTitle(pt, ctx, options);
            this.drawBody(pt, ctx, options);
            this.drawFooter(pt, ctx, options);
            restoreTextDirection(ctx, options.textDirection);
            ctx.restore();
        }
    }
 getActiveElements() {
        return this._active || [];
    }
 setActiveElements(activeElements, eventPosition) {
        const lastActive = this._active;
        const active = activeElements.map(({ datasetIndex , index  })=>{
            const meta = this.chart.getDatasetMeta(datasetIndex);
            if (!meta) {
                throw new Error('Cannot find a dataset at index ' + datasetIndex);
            }
            return {
                datasetIndex,
                element: meta.data[index],
                index
            };
        });
        const changed = !_elementsEqual(lastActive, active);
        const positionChanged = this._positionChanged(active, eventPosition);
        if (changed || positionChanged) {
            this._active = active;
            this._eventPosition = eventPosition;
            this._ignoreReplayEvents = true;
            this.update(true);
        }
    }
 handleEvent(e, replay, inChartArea = true) {
        if (replay && this._ignoreReplayEvents) {
            return false;
        }
        this._ignoreReplayEvents = false;
        const options = this.options;
        const lastActive = this._active || [];
        const active = this._getActiveElements(e, lastActive, replay, inChartArea);
        const positionChanged = this._positionChanged(active, e);
        const changed = replay || !_elementsEqual(active, lastActive) || positionChanged;
        if (changed) {
            this._active = active;
            if (options.enabled || options.external) {
                this._eventPosition = {
                    x: e.x,
                    y: e.y
                };
                this.update(true, replay);
            }
        }
        return changed;
    }
 _getActiveElements(e, lastActive, replay, inChartArea) {
        const options = this.options;
        if (e.type === 'mouseout') {
            return [];
        }
        if (!inChartArea) {
            return lastActive.filter((i)=>this.chart.data.datasets[i.datasetIndex] && this.chart.getDatasetMeta(i.datasetIndex).controller.getParsed(i.index) !== undefined);
        }
        const active = this.chart.getElementsAtEventForMode(e, options.mode, options, replay);
        if (options.reverse) {
            active.reverse();
        }
        return active;
    }
 _positionChanged(active, e) {
        const { caretX , caretY , options  } = this;
        const position = positioners[options.position].call(this, active, e);
        return position !== false && (caretX !== position.x || caretY !== position.y);
    }
}
var plugin_tooltip = {
    id: 'tooltip',
    _element: Tooltip,
    positioners,
    afterInit (chart, _args, options) {
        if (options) {
            chart.tooltip = new Tooltip({
                chart,
                options
            });
        }
    },
    beforeUpdate (chart, _args, options) {
        if (chart.tooltip) {
            chart.tooltip.initialize(options);
        }
    },
    reset (chart, _args, options) {
        if (chart.tooltip) {
            chart.tooltip.initialize(options);
        }
    },
    afterDraw (chart) {
        const tooltip = chart.tooltip;
        if (tooltip && tooltip._willRender()) {
            const args = {
                tooltip
            };
            if (chart.notifyPlugins('beforeTooltipDraw', {
                ...args,
                cancelable: true
            }) === false) {
                return;
            }
            tooltip.draw(chart.ctx);
            chart.notifyPlugins('afterTooltipDraw', args);
        }
    },
    afterEvent (chart, args) {
        if (chart.tooltip) {
            const useFinalPosition = args.replay;
            if (chart.tooltip.handleEvent(args.event, useFinalPosition, args.inChartArea)) {
                args.changed = true;
            }
        }
    },
    defaults: {
        enabled: true,
        external: null,
        position: 'average',
        backgroundColor: 'rgba(0,0,0,0.8)',
        titleColor: '#fff',
        titleFont: {
            weight: 'bold'
        },
        titleSpacing: 2,
        titleMarginBottom: 6,
        titleAlign: 'left',
        bodyColor: '#fff',
        bodySpacing: 2,
        bodyFont: {},
        bodyAlign: 'left',
        footerColor: '#fff',
        footerSpacing: 2,
        footerMarginTop: 6,
        footerFont: {
            weight: 'bold'
        },
        footerAlign: 'left',
        padding: 6,
        caretPadding: 2,
        caretSize: 5,
        cornerRadius: 6,
        boxHeight: (ctx, opts)=>opts.bodyFont.size,
        boxWidth: (ctx, opts)=>opts.bodyFont.size,
        multiKeyBackground: '#fff',
        displayColors: true,
        boxPadding: 0,
        borderColor: 'rgba(0,0,0,0)',
        borderWidth: 0,
        animation: {
            duration: 400,
            easing: 'easeOutQuart'
        },
        animations: {
            numbers: {
                type: 'number',
                properties: [
                    'x',
                    'y',
                    'width',
                    'height',
                    'caretX',
                    'caretY'
                ]
            },
            opacity: {
                easing: 'linear',
                duration: 200
            }
        },
        callbacks: defaultCallbacks
    },
    defaultRoutes: {
        bodyFont: 'font',
        footerFont: 'font',
        titleFont: 'font'
    },
    descriptors: {
        _scriptable: (name)=>name !== 'filter' && name !== 'itemSort' && name !== 'external',
        _indexable: false,
        callbacks: {
            _scriptable: false,
            _indexable: false
        },
        animation: {
            _fallback: false
        },
        animations: {
            _fallback: 'animation'
        }
    },
    additionalOptionScopes: [
        'interaction'
    ]
};

var plugins = /*#__PURE__*/Object.freeze({
__proto__: null,
Colors: plugin_colors,
Decimation: plugin_decimation,
Filler: index,
Legend: plugin_legend,
SubTitle: plugin_subtitle,
Title: plugin_title,
Tooltip: plugin_tooltip
});

const addIfString = (labels, raw, index, addedLabels)=>{
    if (typeof raw === 'string') {
        index = labels.push(raw) - 1;
        addedLabels.unshift({
            index,
            label: raw
        });
    } else if (isNaN(raw)) {
        index = null;
    }
    return index;
};
function findOrAddLabel(labels, raw, index, addedLabels) {
    const first = labels.indexOf(raw);
    if (first === -1) {
        return addIfString(labels, raw, index, addedLabels);
    }
    const last = labels.lastIndexOf(raw);
    return first !== last ? index : first;
}
const validIndex = (index, max)=>index === null ? null : _limitValue(Math.round(index), 0, max);
function _getLabelForValue(value) {
    const labels = this.getLabels();
    if (value >= 0 && value < labels.length) {
        return labels[value];
    }
    return value;
}
class CategoryScale extends Scale {
    static id = 'category';
 static defaults = {
        ticks: {
            callback: _getLabelForValue
        }
    };
    constructor(cfg){
        super(cfg);
         this._startValue = undefined;
        this._valueRange = 0;
        this._addedLabels = [];
    }
    init(scaleOptions) {
        const added = this._addedLabels;
        if (added.length) {
            const labels = this.getLabels();
            for (const { index , label  } of added){
                if (labels[index] === label) {
                    labels.splice(index, 1);
                }
            }
            this._addedLabels = [];
        }
        super.init(scaleOptions);
    }
    parse(raw, index) {
        if (isNullOrUndef(raw)) {
            return null;
        }
        const labels = this.getLabels();
        index = isFinite(index) && labels[index] === raw ? index : findOrAddLabel(labels, raw, valueOrDefault(index, raw), this._addedLabels);
        return validIndex(index, labels.length - 1);
    }
    determineDataLimits() {
        const { minDefined , maxDefined  } = this.getUserBounds();
        let { min , max  } = this.getMinMax(true);
        if (this.options.bounds === 'ticks') {
            if (!minDefined) {
                min = 0;
            }
            if (!maxDefined) {
                max = this.getLabels().length - 1;
            }
        }
        this.min = min;
        this.max = max;
    }
    buildTicks() {
        const min = this.min;
        const max = this.max;
        const offset = this.options.offset;
        const ticks = [];
        let labels = this.getLabels();
        labels = min === 0 && max === labels.length - 1 ? labels : labels.slice(min, max + 1);
        this._valueRange = Math.max(labels.length - (offset ? 0 : 1), 1);
        this._startValue = this.min - (offset ? 0.5 : 0);
        for(let value = min; value <= max; value++){
            ticks.push({
                value
            });
        }
        return ticks;
    }
    getLabelForValue(value) {
        return _getLabelForValue.call(this, value);
    }
 configure() {
        super.configure();
        if (!this.isHorizontal()) {
            this._reversePixels = !this._reversePixels;
        }
    }
    getPixelForValue(value) {
        if (typeof value !== 'number') {
            value = this.parse(value);
        }
        return value === null ? NaN : this.getPixelForDecimal((value - this._startValue) / this._valueRange);
    }
    getPixelForTick(index) {
        const ticks = this.ticks;
        if (index < 0 || index > ticks.length - 1) {
            return null;
        }
        return this.getPixelForValue(ticks[index].value);
    }
    getValueForPixel(pixel) {
        return Math.round(this._startValue + this.getDecimalForPixel(pixel) * this._valueRange);
    }
    getBasePixel() {
        return this.bottom;
    }
}

function generateTicks$1(generationOptions, dataRange) {
    const ticks = [];
    const MIN_SPACING = 1e-14;
    const { bounds , step , min , max , precision , count , maxTicks , maxDigits , includeBounds  } = generationOptions;
    const unit = step || 1;
    const maxSpaces = maxTicks - 1;
    const { min: rmin , max: rmax  } = dataRange;
    const minDefined = !isNullOrUndef(min);
    const maxDefined = !isNullOrUndef(max);
    const countDefined = !isNullOrUndef(count);
    const minSpacing = (rmax - rmin) / (maxDigits + 1);
    let spacing = niceNum((rmax - rmin) / maxSpaces / unit) * unit;
    let factor, niceMin, niceMax, numSpaces;
    if (spacing < MIN_SPACING && !minDefined && !maxDefined) {
        return [
            {
                value: rmin
            },
            {
                value: rmax
            }
        ];
    }
    numSpaces = Math.ceil(rmax / spacing) - Math.floor(rmin / spacing);
    if (numSpaces > maxSpaces) {
        spacing = niceNum(numSpaces * spacing / maxSpaces / unit) * unit;
    }
    if (!isNullOrUndef(precision)) {
        factor = Math.pow(10, precision);
        spacing = Math.ceil(spacing * factor) / factor;
    }
    if (bounds === 'ticks') {
        niceMin = Math.floor(rmin / spacing) * spacing;
        niceMax = Math.ceil(rmax / spacing) * spacing;
    } else {
        niceMin = rmin;
        niceMax = rmax;
    }
    if (minDefined && maxDefined && step && almostWhole((max - min) / step, spacing / 1000)) {
        numSpaces = Math.round(Math.min((max - min) / spacing, maxTicks));
        spacing = (max - min) / numSpaces;
        niceMin = min;
        niceMax = max;
    } else if (countDefined) {
        niceMin = minDefined ? min : niceMin;
        niceMax = maxDefined ? max : niceMax;
        numSpaces = count - 1;
        spacing = (niceMax - niceMin) / numSpaces;
    } else {
        numSpaces = (niceMax - niceMin) / spacing;
        if (almostEquals(numSpaces, Math.round(numSpaces), spacing / 1000)) {
            numSpaces = Math.round(numSpaces);
        } else {
            numSpaces = Math.ceil(numSpaces);
        }
    }
    const decimalPlaces = Math.max(_decimalPlaces(spacing), _decimalPlaces(niceMin));
    factor = Math.pow(10, isNullOrUndef(precision) ? decimalPlaces : precision);
    niceMin = Math.round(niceMin * factor) / factor;
    niceMax = Math.round(niceMax * factor) / factor;
    let j = 0;
    if (minDefined) {
        if (includeBounds && niceMin !== min) {
            ticks.push({
                value: min
            });
            if (niceMin < min) {
                j++;
            }
            if (almostEquals(Math.round((niceMin + j * spacing) * factor) / factor, min, relativeLabelSize(min, minSpacing, generationOptions))) {
                j++;
            }
        } else if (niceMin < min) {
            j++;
        }
    }
    for(; j < numSpaces; ++j){
        const tickValue = Math.round((niceMin + j * spacing) * factor) / factor;
        if (maxDefined && tickValue > max) {
            break;
        }
        ticks.push({
            value: tickValue
        });
    }
    if (maxDefined && includeBounds && niceMax !== max) {
        if (ticks.length && almostEquals(ticks[ticks.length - 1].value, max, relativeLabelSize(max, minSpacing, generationOptions))) {
            ticks[ticks.length - 1].value = max;
        } else {
            ticks.push({
                value: max
            });
        }
    } else if (!maxDefined || niceMax === max) {
        ticks.push({
            value: niceMax
        });
    }
    return ticks;
}
function relativeLabelSize(value, minSpacing, { horizontal , minRotation  }) {
    const rad = toRadians(minRotation);
    const ratio = (horizontal ? Math.sin(rad) : Math.cos(rad)) || 0.001;
    const length = 0.75 * minSpacing * ('' + value).length;
    return Math.min(minSpacing / ratio, length);
}
class LinearScaleBase extends Scale {
    constructor(cfg){
        super(cfg);
         this.start = undefined;
         this.end = undefined;
         this._startValue = undefined;
         this._endValue = undefined;
        this._valueRange = 0;
    }
    parse(raw, index) {
        if (isNullOrUndef(raw)) {
            return null;
        }
        if ((typeof raw === 'number' || raw instanceof Number) && !isFinite(+raw)) {
            return null;
        }
        return +raw;
    }
    handleTickRangeOptions() {
        const { beginAtZero  } = this.options;
        const { minDefined , maxDefined  } = this.getUserBounds();
        let { min , max  } = this;
        const setMin = (v)=>min = minDefined ? min : v;
        const setMax = (v)=>max = maxDefined ? max : v;
        if (beginAtZero) {
            const minSign = sign(min);
            const maxSign = sign(max);
            if (minSign < 0 && maxSign < 0) {
                setMax(0);
            } else if (minSign > 0 && maxSign > 0) {
                setMin(0);
            }
        }
        if (min === max) {
            let offset = max === 0 ? 1 : Math.abs(max * 0.05);
            setMax(max + offset);
            if (!beginAtZero) {
                setMin(min - offset);
            }
        }
        this.min = min;
        this.max = max;
    }
    getTickLimit() {
        const tickOpts = this.options.ticks;
        let { maxTicksLimit , stepSize  } = tickOpts;
        let maxTicks;
        if (stepSize) {
            maxTicks = Math.ceil(this.max / stepSize) - Math.floor(this.min / stepSize) + 1;
            if (maxTicks > 1000) {
                console.warn(`scales.${this.id}.ticks.stepSize: ${stepSize} would result generating up to ${maxTicks} ticks. Limiting to 1000.`);
                maxTicks = 1000;
            }
        } else {
            maxTicks = this.computeTickLimit();
            maxTicksLimit = maxTicksLimit || 11;
        }
        if (maxTicksLimit) {
            maxTicks = Math.min(maxTicksLimit, maxTicks);
        }
        return maxTicks;
    }
 computeTickLimit() {
        return Number.POSITIVE_INFINITY;
    }
    buildTicks() {
        const opts = this.options;
        const tickOpts = opts.ticks;
        let maxTicks = this.getTickLimit();
        maxTicks = Math.max(2, maxTicks);
        const numericGeneratorOptions = {
            maxTicks,
            bounds: opts.bounds,
            min: opts.min,
            max: opts.max,
            precision: tickOpts.precision,
            step: tickOpts.stepSize,
            count: tickOpts.count,
            maxDigits: this._maxDigits(),
            horizontal: this.isHorizontal(),
            minRotation: tickOpts.minRotation || 0,
            includeBounds: tickOpts.includeBounds !== false
        };
        const dataRange = this._range || this;
        const ticks = generateTicks$1(numericGeneratorOptions, dataRange);
        if (opts.bounds === 'ticks') {
            _setMinAndMaxByKey(ticks, this, 'value');
        }
        if (opts.reverse) {
            ticks.reverse();
            this.start = this.max;
            this.end = this.min;
        } else {
            this.start = this.min;
            this.end = this.max;
        }
        return ticks;
    }
 configure() {
        const ticks = this.ticks;
        let start = this.min;
        let end = this.max;
        super.configure();
        if (this.options.offset && ticks.length) {
            const offset = (end - start) / Math.max(ticks.length - 1, 1) / 2;
            start -= offset;
            end += offset;
        }
        this._startValue = start;
        this._endValue = end;
        this._valueRange = end - start;
    }
    getLabelForValue(value) {
        return formatNumber(value, this.chart.options.locale, this.options.ticks.format);
    }
}

class LinearScale extends LinearScaleBase {
    static id = 'linear';
 static defaults = {
        ticks: {
            callback: Ticks.formatters.numeric
        }
    };
    determineDataLimits() {
        const { min , max  } = this.getMinMax(true);
        this.min = isNumberFinite(min) ? min : 0;
        this.max = isNumberFinite(max) ? max : 1;
        this.handleTickRangeOptions();
    }
 computeTickLimit() {
        const horizontal = this.isHorizontal();
        const length = horizontal ? this.width : this.height;
        const minRotation = toRadians(this.options.ticks.minRotation);
        const ratio = (horizontal ? Math.sin(minRotation) : Math.cos(minRotation)) || 0.001;
        const tickFont = this._resolveTickFontOptions(0);
        return Math.ceil(length / Math.min(40, tickFont.lineHeight / ratio));
    }
    getPixelForValue(value) {
        return value === null ? NaN : this.getPixelForDecimal((value - this._startValue) / this._valueRange);
    }
    getValueForPixel(pixel) {
        return this._startValue + this.getDecimalForPixel(pixel) * this._valueRange;
    }
}

const log10Floor = (v)=>Math.floor(log10(v));
const changeExponent = (v, m)=>Math.pow(10, log10Floor(v) + m);
function isMajor(tickVal) {
    const remain = tickVal / Math.pow(10, log10Floor(tickVal));
    return remain === 1;
}
function steps(min, max, rangeExp) {
    const rangeStep = Math.pow(10, rangeExp);
    const start = Math.floor(min / rangeStep);
    const end = Math.ceil(max / rangeStep);
    return end - start;
}
function startExp(min, max) {
    const range = max - min;
    let rangeExp = log10Floor(range);
    while(steps(min, max, rangeExp) > 10){
        rangeExp++;
    }
    while(steps(min, max, rangeExp) < 10){
        rangeExp--;
    }
    return Math.min(rangeExp, log10Floor(min));
}
 function generateTicks(generationOptions, { min , max  }) {
    min = finiteOrDefault(generationOptions.min, min);
    const ticks = [];
    const minExp = log10Floor(min);
    let exp = startExp(min, max);
    let precision = exp < 0 ? Math.pow(10, Math.abs(exp)) : 1;
    const stepSize = Math.pow(10, exp);
    const base = minExp > exp ? Math.pow(10, minExp) : 0;
    const start = Math.round((min - base) * precision) / precision;
    const offset = Math.floor((min - base) / stepSize / 10) * stepSize * 10;
    let significand = Math.floor((start - offset) / Math.pow(10, exp));
    let value = finiteOrDefault(generationOptions.min, Math.round((base + offset + significand * Math.pow(10, exp)) * precision) / precision);
    while(value < max){
        ticks.push({
            value,
            major: isMajor(value),
            significand
        });
        if (significand >= 10) {
            significand = significand < 15 ? 15 : 20;
        } else {
            significand++;
        }
        if (significand >= 20) {
            exp++;
            significand = 2;
            precision = exp >= 0 ? 1 : precision;
        }
        value = Math.round((base + offset + significand * Math.pow(10, exp)) * precision) / precision;
    }
    const lastTick = finiteOrDefault(generationOptions.max, value);
    ticks.push({
        value: lastTick,
        major: isMajor(lastTick),
        significand
    });
    return ticks;
}
class LogarithmicScale extends Scale {
    static id = 'logarithmic';
 static defaults = {
        ticks: {
            callback: Ticks.formatters.logarithmic,
            major: {
                enabled: true
            }
        }
    };
    constructor(cfg){
        super(cfg);
         this.start = undefined;
         this.end = undefined;
         this._startValue = undefined;
        this._valueRange = 0;
    }
    parse(raw, index) {
        const value = LinearScaleBase.prototype.parse.apply(this, [
            raw,
            index
        ]);
        if (value === 0) {
            this._zero = true;
            return undefined;
        }
        return isNumberFinite(value) && value > 0 ? value : null;
    }
    determineDataLimits() {
        const { min , max  } = this.getMinMax(true);
        this.min = isNumberFinite(min) ? Math.max(0, min) : null;
        this.max = isNumberFinite(max) ? Math.max(0, max) : null;
        if (this.options.beginAtZero) {
            this._zero = true;
        }
        if (this._zero && this.min !== this._suggestedMin && !isNumberFinite(this._userMin)) {
            this.min = min === changeExponent(this.min, 0) ? changeExponent(this.min, -1) : changeExponent(this.min, 0);
        }
        this.handleTickRangeOptions();
    }
    handleTickRangeOptions() {
        const { minDefined , maxDefined  } = this.getUserBounds();
        let min = this.min;
        let max = this.max;
        const setMin = (v)=>min = minDefined ? min : v;
        const setMax = (v)=>max = maxDefined ? max : v;
        if (min === max) {
            if (min <= 0) {
                setMin(1);
                setMax(10);
            } else {
                setMin(changeExponent(min, -1));
                setMax(changeExponent(max, +1));
            }
        }
        if (min <= 0) {
            setMin(changeExponent(max, -1));
        }
        if (max <= 0) {
            setMax(changeExponent(min, +1));
        }
        this.min = min;
        this.max = max;
    }
    buildTicks() {
        const opts = this.options;
        const generationOptions = {
            min: this._userMin,
            max: this._userMax
        };
        const ticks = generateTicks(generationOptions, this);
        if (opts.bounds === 'ticks') {
            _setMinAndMaxByKey(ticks, this, 'value');
        }
        if (opts.reverse) {
            ticks.reverse();
            this.start = this.max;
            this.end = this.min;
        } else {
            this.start = this.min;
            this.end = this.max;
        }
        return ticks;
    }
 getLabelForValue(value) {
        return value === undefined ? '0' : formatNumber(value, this.chart.options.locale, this.options.ticks.format);
    }
 configure() {
        const start = this.min;
        super.configure();
        this._startValue = log10(start);
        this._valueRange = log10(this.max) - log10(start);
    }
    getPixelForValue(value) {
        if (value === undefined || value === 0) {
            value = this.min;
        }
        if (value === null || isNaN(value)) {
            return NaN;
        }
        return this.getPixelForDecimal(value === this.min ? 0 : (log10(value) - this._startValue) / this._valueRange);
    }
    getValueForPixel(pixel) {
        const decimal = this.getDecimalForPixel(pixel);
        return Math.pow(10, this._startValue + decimal * this._valueRange);
    }
}

function getTickBackdropHeight(opts) {
    const tickOpts = opts.ticks;
    if (tickOpts.display && opts.display) {
        const padding = toPadding(tickOpts.backdropPadding);
        return valueOrDefault(tickOpts.font && tickOpts.font.size, defaults.font.size) + padding.height;
    }
    return 0;
}
function measureLabelSize(ctx, font, label) {
    label = isArray(label) ? label : [
        label
    ];
    return {
        w: _longestText(ctx, font.string, label),
        h: label.length * font.lineHeight
    };
}
function determineLimits(angle, pos, size, min, max) {
    if (angle === min || angle === max) {
        return {
            start: pos - size / 2,
            end: pos + size / 2
        };
    } else if (angle < min || angle > max) {
        return {
            start: pos - size,
            end: pos
        };
    }
    return {
        start: pos,
        end: pos + size
    };
}
 function fitWithPointLabels(scale) {
    const orig = {
        l: scale.left + scale._padding.left,
        r: scale.right - scale._padding.right,
        t: scale.top + scale._padding.top,
        b: scale.bottom - scale._padding.bottom
    };
    const limits = Object.assign({}, orig);
    const labelSizes = [];
    const padding = [];
    const valueCount = scale._pointLabels.length;
    const pointLabelOpts = scale.options.pointLabels;
    const additionalAngle = pointLabelOpts.centerPointLabels ? PI / valueCount : 0;
    for(let i = 0; i < valueCount; i++){
        const opts = pointLabelOpts.setContext(scale.getPointLabelContext(i));
        padding[i] = opts.padding;
        const pointPosition = scale.getPointPosition(i, scale.drawingArea + padding[i], additionalAngle);
        const plFont = toFont(opts.font);
        const textSize = measureLabelSize(scale.ctx, plFont, scale._pointLabels[i]);
        labelSizes[i] = textSize;
        const angleRadians = _normalizeAngle(scale.getIndexAngle(i) + additionalAngle);
        const angle = Math.round(toDegrees(angleRadians));
        const hLimits = determineLimits(angle, pointPosition.x, textSize.w, 0, 180);
        const vLimits = determineLimits(angle, pointPosition.y, textSize.h, 90, 270);
        updateLimits(limits, orig, angleRadians, hLimits, vLimits);
    }
    scale.setCenterPoint(orig.l - limits.l, limits.r - orig.r, orig.t - limits.t, limits.b - orig.b);
    scale._pointLabelItems = buildPointLabelItems(scale, labelSizes, padding);
}
function updateLimits(limits, orig, angle, hLimits, vLimits) {
    const sin = Math.abs(Math.sin(angle));
    const cos = Math.abs(Math.cos(angle));
    let x = 0;
    let y = 0;
    if (hLimits.start < orig.l) {
        x = (orig.l - hLimits.start) / sin;
        limits.l = Math.min(limits.l, orig.l - x);
    } else if (hLimits.end > orig.r) {
        x = (hLimits.end - orig.r) / sin;
        limits.r = Math.max(limits.r, orig.r + x);
    }
    if (vLimits.start < orig.t) {
        y = (orig.t - vLimits.start) / cos;
        limits.t = Math.min(limits.t, orig.t - y);
    } else if (vLimits.end > orig.b) {
        y = (vLimits.end - orig.b) / cos;
        limits.b = Math.max(limits.b, orig.b + y);
    }
}
function createPointLabelItem(scale, index, itemOpts) {
    const outerDistance = scale.drawingArea;
    const { extra , additionalAngle , padding , size  } = itemOpts;
    const pointLabelPosition = scale.getPointPosition(index, outerDistance + extra + padding, additionalAngle);
    const angle = Math.round(toDegrees(_normalizeAngle(pointLabelPosition.angle + HALF_PI)));
    const y = yForAngle(pointLabelPosition.y, size.h, angle);
    const textAlign = getTextAlignForAngle(angle);
    const left = leftForTextAlign(pointLabelPosition.x, size.w, textAlign);
    return {
        visible: true,
        x: pointLabelPosition.x,
        y,
        textAlign,
        left,
        top: y,
        right: left + size.w,
        bottom: y + size.h
    };
}
function isNotOverlapped(item, area) {
    if (!area) {
        return true;
    }
    const { left , top , right , bottom  } = item;
    const apexesInArea = _isPointInArea({
        x: left,
        y: top
    }, area) || _isPointInArea({
        x: left,
        y: bottom
    }, area) || _isPointInArea({
        x: right,
        y: top
    }, area) || _isPointInArea({
        x: right,
        y: bottom
    }, area);
    return !apexesInArea;
}
function buildPointLabelItems(scale, labelSizes, padding) {
    const items = [];
    const valueCount = scale._pointLabels.length;
    const opts = scale.options;
    const { centerPointLabels , display  } = opts.pointLabels;
    const itemOpts = {
        extra: getTickBackdropHeight(opts) / 2,
        additionalAngle: centerPointLabels ? PI / valueCount : 0
    };
    let area;
    for(let i = 0; i < valueCount; i++){
        itemOpts.padding = padding[i];
        itemOpts.size = labelSizes[i];
        const item = createPointLabelItem(scale, i, itemOpts);
        items.push(item);
        if (display === 'auto') {
            item.visible = isNotOverlapped(item, area);
            if (item.visible) {
                area = item;
            }
        }
    }
    return items;
}
function getTextAlignForAngle(angle) {
    if (angle === 0 || angle === 180) {
        return 'center';
    } else if (angle < 180) {
        return 'left';
    }
    return 'right';
}
function leftForTextAlign(x, w, align) {
    if (align === 'right') {
        x -= w;
    } else if (align === 'center') {
        x -= w / 2;
    }
    return x;
}
function yForAngle(y, h, angle) {
    if (angle === 90 || angle === 270) {
        y -= h / 2;
    } else if (angle > 270 || angle < 90) {
        y -= h;
    }
    return y;
}
function drawPointLabelBox(ctx, opts, item) {
    const { left , top , right , bottom  } = item;
    const { backdropColor  } = opts;
    if (!isNullOrUndef(backdropColor)) {
        const borderRadius = toTRBLCorners(opts.borderRadius);
        const padding = toPadding(opts.backdropPadding);
        ctx.fillStyle = backdropColor;
        const backdropLeft = left - padding.left;
        const backdropTop = top - padding.top;
        const backdropWidth = right - left + padding.width;
        const backdropHeight = bottom - top + padding.height;
        if (Object.values(borderRadius).some((v)=>v !== 0)) {
            ctx.beginPath();
            addRoundedRectPath(ctx, {
                x: backdropLeft,
                y: backdropTop,
                w: backdropWidth,
                h: backdropHeight,
                radius: borderRadius
            });
            ctx.fill();
        } else {
            ctx.fillRect(backdropLeft, backdropTop, backdropWidth, backdropHeight);
        }
    }
}
function drawPointLabels(scale, labelCount) {
    const { ctx , options: { pointLabels  }  } = scale;
    for(let i = labelCount - 1; i >= 0; i--){
        const item = scale._pointLabelItems[i];
        if (!item.visible) {
            continue;
        }
        const optsAtIndex = pointLabels.setContext(scale.getPointLabelContext(i));
        drawPointLabelBox(ctx, optsAtIndex, item);
        const plFont = toFont(optsAtIndex.font);
        const { x , y , textAlign  } = item;
        renderText(ctx, scale._pointLabels[i], x, y + plFont.lineHeight / 2, plFont, {
            color: optsAtIndex.color,
            textAlign: textAlign,
            textBaseline: 'middle'
        });
    }
}
function pathRadiusLine(scale, radius, circular, labelCount) {
    const { ctx  } = scale;
    if (circular) {
        ctx.arc(scale.xCenter, scale.yCenter, radius, 0, TAU);
    } else {
        let pointPosition = scale.getPointPosition(0, radius);
        ctx.moveTo(pointPosition.x, pointPosition.y);
        for(let i = 1; i < labelCount; i++){
            pointPosition = scale.getPointPosition(i, radius);
            ctx.lineTo(pointPosition.x, pointPosition.y);
        }
    }
}
function drawRadiusLine(scale, gridLineOpts, radius, labelCount, borderOpts) {
    const ctx = scale.ctx;
    const circular = gridLineOpts.circular;
    const { color , lineWidth  } = gridLineOpts;
    if (!circular && !labelCount || !color || !lineWidth || radius < 0) {
        return;
    }
    ctx.save();
    ctx.strokeStyle = color;
    ctx.lineWidth = lineWidth;
    ctx.setLineDash(borderOpts.dash);
    ctx.lineDashOffset = borderOpts.dashOffset;
    ctx.beginPath();
    pathRadiusLine(scale, radius, circular, labelCount);
    ctx.closePath();
    ctx.stroke();
    ctx.restore();
}
function createPointLabelContext(parent, index, label) {
    return createContext(parent, {
        label,
        index,
        type: 'pointLabel'
    });
}
class RadialLinearScale extends LinearScaleBase {
    static id = 'radialLinear';
 static defaults = {
        display: true,
        animate: true,
        position: 'chartArea',
        angleLines: {
            display: true,
            lineWidth: 1,
            borderDash: [],
            borderDashOffset: 0.0
        },
        grid: {
            circular: false
        },
        startAngle: 0,
        ticks: {
            showLabelBackdrop: true,
            callback: Ticks.formatters.numeric
        },
        pointLabels: {
            backdropColor: undefined,
            backdropPadding: 2,
            display: true,
            font: {
                size: 10
            },
            callback (label) {
                return label;
            },
            padding: 5,
            centerPointLabels: false
        }
    };
    static defaultRoutes = {
        'angleLines.color': 'borderColor',
        'pointLabels.color': 'color',
        'ticks.color': 'color'
    };
    static descriptors = {
        angleLines: {
            _fallback: 'grid'
        }
    };
    constructor(cfg){
        super(cfg);
         this.xCenter = undefined;
         this.yCenter = undefined;
         this.drawingArea = undefined;
         this._pointLabels = [];
        this._pointLabelItems = [];
    }
    setDimensions() {
        const padding = this._padding = toPadding(getTickBackdropHeight(this.options) / 2);
        const w = this.width = this.maxWidth - padding.width;
        const h = this.height = this.maxHeight - padding.height;
        this.xCenter = Math.floor(this.left + w / 2 + padding.left);
        this.yCenter = Math.floor(this.top + h / 2 + padding.top);
        this.drawingArea = Math.floor(Math.min(w, h) / 2);
    }
    determineDataLimits() {
        const { min , max  } = this.getMinMax(false);
        this.min = isNumberFinite(min) && !isNaN(min) ? min : 0;
        this.max = isNumberFinite(max) && !isNaN(max) ? max : 0;
        this.handleTickRangeOptions();
    }
 computeTickLimit() {
        return Math.ceil(this.drawingArea / getTickBackdropHeight(this.options));
    }
    generateTickLabels(ticks) {
        LinearScaleBase.prototype.generateTickLabels.call(this, ticks);
        this._pointLabels = this.getLabels().map((value, index)=>{
            const label = callback(this.options.pointLabels.callback, [
                value,
                index
            ], this);
            return label || label === 0 ? label : '';
        }).filter((v, i)=>this.chart.getDataVisibility(i));
    }
    fit() {
        const opts = this.options;
        if (opts.display && opts.pointLabels.display) {
            fitWithPointLabels(this);
        } else {
            this.setCenterPoint(0, 0, 0, 0);
        }
    }
    setCenterPoint(leftMovement, rightMovement, topMovement, bottomMovement) {
        this.xCenter += Math.floor((leftMovement - rightMovement) / 2);
        this.yCenter += Math.floor((topMovement - bottomMovement) / 2);
        this.drawingArea -= Math.min(this.drawingArea / 2, Math.max(leftMovement, rightMovement, topMovement, bottomMovement));
    }
    getIndexAngle(index) {
        const angleMultiplier = TAU / (this._pointLabels.length || 1);
        const startAngle = this.options.startAngle || 0;
        return _normalizeAngle(index * angleMultiplier + toRadians(startAngle));
    }
    getDistanceFromCenterForValue(value) {
        if (isNullOrUndef(value)) {
            return NaN;
        }
        const scalingFactor = this.drawingArea / (this.max - this.min);
        if (this.options.reverse) {
            return (this.max - value) * scalingFactor;
        }
        return (value - this.min) * scalingFactor;
    }
    getValueForDistanceFromCenter(distance) {
        if (isNullOrUndef(distance)) {
            return NaN;
        }
        const scaledDistance = distance / (this.drawingArea / (this.max - this.min));
        return this.options.reverse ? this.max - scaledDistance : this.min + scaledDistance;
    }
    getPointLabelContext(index) {
        const pointLabels = this._pointLabels || [];
        if (index >= 0 && index < pointLabels.length) {
            const pointLabel = pointLabels[index];
            return createPointLabelContext(this.getContext(), index, pointLabel);
        }
    }
    getPointPosition(index, distanceFromCenter, additionalAngle = 0) {
        const angle = this.getIndexAngle(index) - HALF_PI + additionalAngle;
        return {
            x: Math.cos(angle) * distanceFromCenter + this.xCenter,
            y: Math.sin(angle) * distanceFromCenter + this.yCenter,
            angle
        };
    }
    getPointPositionForValue(index, value) {
        return this.getPointPosition(index, this.getDistanceFromCenterForValue(value));
    }
    getBasePosition(index) {
        return this.getPointPositionForValue(index || 0, this.getBaseValue());
    }
    getPointLabelPosition(index) {
        const { left , top , right , bottom  } = this._pointLabelItems[index];
        return {
            left,
            top,
            right,
            bottom
        };
    }
 drawBackground() {
        const { backgroundColor , grid: { circular  }  } = this.options;
        if (backgroundColor) {
            const ctx = this.ctx;
            ctx.save();
            ctx.beginPath();
            pathRadiusLine(this, this.getDistanceFromCenterForValue(this._endValue), circular, this._pointLabels.length);
            ctx.closePath();
            ctx.fillStyle = backgroundColor;
            ctx.fill();
            ctx.restore();
        }
    }
 drawGrid() {
        const ctx = this.ctx;
        const opts = this.options;
        const { angleLines , grid , border  } = opts;
        const labelCount = this._pointLabels.length;
        let i, offset, position;
        if (opts.pointLabels.display) {
            drawPointLabels(this, labelCount);
        }
        if (grid.display) {
            this.ticks.forEach((tick, index)=>{
                if (index !== 0 || index === 0 && this.min < 0) {
                    offset = this.getDistanceFromCenterForValue(tick.value);
                    const context = this.getContext(index);
                    const optsAtIndex = grid.setContext(context);
                    const optsAtIndexBorder = border.setContext(context);
                    drawRadiusLine(this, optsAtIndex, offset, labelCount, optsAtIndexBorder);
                }
            });
        }
        if (angleLines.display) {
            ctx.save();
            for(i = labelCount - 1; i >= 0; i--){
                const optsAtIndex = angleLines.setContext(this.getPointLabelContext(i));
                const { color , lineWidth  } = optsAtIndex;
                if (!lineWidth || !color) {
                    continue;
                }
                ctx.lineWidth = lineWidth;
                ctx.strokeStyle = color;
                ctx.setLineDash(optsAtIndex.borderDash);
                ctx.lineDashOffset = optsAtIndex.borderDashOffset;
                offset = this.getDistanceFromCenterForValue(opts.ticks.reverse ? this.min : this.max);
                position = this.getPointPosition(i, offset);
                ctx.beginPath();
                ctx.moveTo(this.xCenter, this.yCenter);
                ctx.lineTo(position.x, position.y);
                ctx.stroke();
            }
            ctx.restore();
        }
    }
 drawBorder() {}
 drawLabels() {
        const ctx = this.ctx;
        const opts = this.options;
        const tickOpts = opts.ticks;
        if (!tickOpts.display) {
            return;
        }
        const startAngle = this.getIndexAngle(0);
        let offset, width;
        ctx.save();
        ctx.translate(this.xCenter, this.yCenter);
        ctx.rotate(startAngle);
        ctx.textAlign = 'center';
        ctx.textBaseline = 'middle';
        this.ticks.forEach((tick, index)=>{
            if (index === 0 && this.min >= 0 && !opts.reverse) {
                return;
            }
            const optsAtIndex = tickOpts.setContext(this.getContext(index));
            const tickFont = toFont(optsAtIndex.font);
            offset = this.getDistanceFromCenterForValue(this.ticks[index].value);
            if (optsAtIndex.showLabelBackdrop) {
                ctx.font = tickFont.string;
                width = ctx.measureText(tick.label).width;
                ctx.fillStyle = optsAtIndex.backdropColor;
                const padding = toPadding(optsAtIndex.backdropPadding);
                ctx.fillRect(-width / 2 - padding.left, -offset - tickFont.size / 2 - padding.top, width + padding.width, tickFont.size + padding.height);
            }
            renderText(ctx, tick.label, 0, -offset, tickFont, {
                color: optsAtIndex.color,
                strokeColor: optsAtIndex.textStrokeColor,
                strokeWidth: optsAtIndex.textStrokeWidth
            });
        });
        ctx.restore();
    }
 drawTitle() {}
}

const INTERVALS = {
    millisecond: {
        common: true,
        size: 1,
        steps: 1000
    },
    second: {
        common: true,
        size: 1000,
        steps: 60
    },
    minute: {
        common: true,
        size: 60000,
        steps: 60
    },
    hour: {
        common: true,
        size: 3600000,
        steps: 24
    },
    day: {
        common: true,
        size: 86400000,
        steps: 30
    },
    week: {
        common: false,
        size: 604800000,
        steps: 4
    },
    month: {
        common: true,
        size: 2.628e9,
        steps: 12
    },
    quarter: {
        common: false,
        size: 7.884e9,
        steps: 4
    },
    year: {
        common: true,
        size: 3.154e10
    }
};
 const UNITS =  /* #__PURE__ */ Object.keys(INTERVALS);
 function sorter(a, b) {
    return a - b;
}
 function parse(scale, input) {
    if (isNullOrUndef(input)) {
        return null;
    }
    const adapter = scale._adapter;
    const { parser , round , isoWeekday  } = scale._parseOpts;
    let value = input;
    if (typeof parser === 'function') {
        value = parser(value);
    }
    if (!isNumberFinite(value)) {
        value = typeof parser === 'string' ? adapter.parse(value,  parser) : adapter.parse(value);
    }
    if (value === null) {
        return null;
    }
    if (round) {
        value = round === 'week' && (isNumber(isoWeekday) || isoWeekday === true) ? adapter.startOf(value, 'isoWeek', isoWeekday) : adapter.startOf(value, round);
    }
    return +value;
}
 function determineUnitForAutoTicks(minUnit, min, max, capacity) {
    const ilen = UNITS.length;
    for(let i = UNITS.indexOf(minUnit); i < ilen - 1; ++i){
        const interval = INTERVALS[UNITS[i]];
        const factor = interval.steps ? interval.steps : Number.MAX_SAFE_INTEGER;
        if (interval.common && Math.ceil((max - min) / (factor * interval.size)) <= capacity) {
            return UNITS[i];
        }
    }
    return UNITS[ilen - 1];
}
 function determineUnitForFormatting(scale, numTicks, minUnit, min, max) {
    for(let i = UNITS.length - 1; i >= UNITS.indexOf(minUnit); i--){
        const unit = UNITS[i];
        if (INTERVALS[unit].common && scale._adapter.diff(max, min, unit) >= numTicks - 1) {
            return unit;
        }
    }
    return UNITS[minUnit ? UNITS.indexOf(minUnit) : 0];
}
 function determineMajorUnit(unit) {
    for(let i = UNITS.indexOf(unit) + 1, ilen = UNITS.length; i < ilen; ++i){
        if (INTERVALS[UNITS[i]].common) {
            return UNITS[i];
        }
    }
}
 function addTick(ticks, time, timestamps) {
    if (!timestamps) {
        ticks[time] = true;
    } else if (timestamps.length) {
        const { lo , hi  } = _lookup(timestamps, time);
        const timestamp = timestamps[lo] >= time ? timestamps[lo] : timestamps[hi];
        ticks[timestamp] = true;
    }
}
 function setMajorTicks(scale, ticks, map, majorUnit) {
    const adapter = scale._adapter;
    const first = +adapter.startOf(ticks[0].value, majorUnit);
    const last = ticks[ticks.length - 1].value;
    let major, index;
    for(major = first; major <= last; major = +adapter.add(major, 1, majorUnit)){
        index = map[major];
        if (index >= 0) {
            ticks[index].major = true;
        }
    }
    return ticks;
}
 function ticksFromTimestamps(scale, values, majorUnit) {
    const ticks = [];
     const map = {};
    const ilen = values.length;
    let i, value;
    for(i = 0; i < ilen; ++i){
        value = values[i];
        map[value] = i;
        ticks.push({
            value,
            major: false
        });
    }
    return ilen === 0 || !majorUnit ? ticks : setMajorTicks(scale, ticks, map, majorUnit);
}
class TimeScale extends Scale {
    static id = 'time';
 static defaults = {
 bounds: 'data',
        adapters: {},
        time: {
            parser: false,
            unit: false,
            round: false,
            isoWeekday: false,
            minUnit: 'millisecond',
            displayFormats: {}
        },
        ticks: {
 source: 'auto',
            callback: false,
            major: {
                enabled: false
            }
        }
    };
 constructor(props){
        super(props);
         this._cache = {
            data: [],
            labels: [],
            all: []
        };
         this._unit = 'day';
         this._majorUnit = undefined;
        this._offsets = {};
        this._normalized = false;
        this._parseOpts = undefined;
    }
    init(scaleOpts, opts = {}) {
        const time = scaleOpts.time || (scaleOpts.time = {});
         const adapter = this._adapter = new adapters._date(scaleOpts.adapters.date);
        adapter.init(opts);
        mergeIf(time.displayFormats, adapter.formats());
        this._parseOpts = {
            parser: time.parser,
            round: time.round,
            isoWeekday: time.isoWeekday
        };
        super.init(scaleOpts);
        this._normalized = opts.normalized;
    }
 parse(raw, index) {
        if (raw === undefined) {
            return null;
        }
        return parse(this, raw);
    }
    beforeLayout() {
        super.beforeLayout();
        this._cache = {
            data: [],
            labels: [],
            all: []
        };
    }
    determineDataLimits() {
        const options = this.options;
        const adapter = this._adapter;
        const unit = options.time.unit || 'day';
        let { min , max , minDefined , maxDefined  } = this.getUserBounds();
 function _applyBounds(bounds) {
            if (!minDefined && !isNaN(bounds.min)) {
                min = Math.min(min, bounds.min);
            }
            if (!maxDefined && !isNaN(bounds.max)) {
                max = Math.max(max, bounds.max);
            }
        }
        if (!minDefined || !maxDefined) {
            _applyBounds(this._getLabelBounds());
            if (options.bounds !== 'ticks' || options.ticks.source !== 'labels') {
                _applyBounds(this.getMinMax(false));
            }
        }
        min = isNumberFinite(min) && !isNaN(min) ? min : +adapter.startOf(Date.now(), unit);
        max = isNumberFinite(max) && !isNaN(max) ? max : +adapter.endOf(Date.now(), unit) + 1;
        this.min = Math.min(min, max - 1);
        this.max = Math.max(min + 1, max);
    }
 _getLabelBounds() {
        const arr = this.getLabelTimestamps();
        let min = Number.POSITIVE_INFINITY;
        let max = Number.NEGATIVE_INFINITY;
        if (arr.length) {
            min = arr[0];
            max = arr[arr.length - 1];
        }
        return {
            min,
            max
        };
    }
 buildTicks() {
        const options = this.options;
        const timeOpts = options.time;
        const tickOpts = options.ticks;
        const timestamps = tickOpts.source === 'labels' ? this.getLabelTimestamps() : this._generate();
        if (options.bounds === 'ticks' && timestamps.length) {
            this.min = this._userMin || timestamps[0];
            this.max = this._userMax || timestamps[timestamps.length - 1];
        }
        const min = this.min;
        const max = this.max;
        const ticks = _filterBetween(timestamps, min, max);
        this._unit = timeOpts.unit || (tickOpts.autoSkip ? determineUnitForAutoTicks(timeOpts.minUnit, this.min, this.max, this._getLabelCapacity(min)) : determineUnitForFormatting(this, ticks.length, timeOpts.minUnit, this.min, this.max));
        this._majorUnit = !tickOpts.major.enabled || this._unit === 'year' ? undefined : determineMajorUnit(this._unit);
        this.initOffsets(timestamps);
        if (options.reverse) {
            ticks.reverse();
        }
        return ticksFromTimestamps(this, ticks, this._majorUnit);
    }
    afterAutoSkip() {
        if (this.options.offsetAfterAutoskip) {
            this.initOffsets(this.ticks.map((tick)=>+tick.value));
        }
    }
 initOffsets(timestamps = []) {
        let start = 0;
        let end = 0;
        let first, last;
        if (this.options.offset && timestamps.length) {
            first = this.getDecimalForValue(timestamps[0]);
            if (timestamps.length === 1) {
                start = 1 - first;
            } else {
                start = (this.getDecimalForValue(timestamps[1]) - first) / 2;
            }
            last = this.getDecimalForValue(timestamps[timestamps.length - 1]);
            if (timestamps.length === 1) {
                end = last;
            } else {
                end = (last - this.getDecimalForValue(timestamps[timestamps.length - 2])) / 2;
            }
        }
        const limit = timestamps.length < 3 ? 0.5 : 0.25;
        start = _limitValue(start, 0, limit);
        end = _limitValue(end, 0, limit);
        this._offsets = {
            start,
            end,
            factor: 1 / (start + 1 + end)
        };
    }
 _generate() {
        const adapter = this._adapter;
        const min = this.min;
        const max = this.max;
        const options = this.options;
        const timeOpts = options.time;
        const minor = timeOpts.unit || determineUnitForAutoTicks(timeOpts.minUnit, min, max, this._getLabelCapacity(min));
        const stepSize = valueOrDefault(options.ticks.stepSize, 1);
        const weekday = minor === 'week' ? timeOpts.isoWeekday : false;
        const hasWeekday = isNumber(weekday) || weekday === true;
        const ticks = {};
        let first = min;
        let time, count;
        if (hasWeekday) {
            first = +adapter.startOf(first, 'isoWeek', weekday);
        }
        first = +adapter.startOf(first, hasWeekday ? 'day' : minor);
        if (adapter.diff(max, min, minor) > 100000 * stepSize) {
            throw new Error(min + ' and ' + max + ' are too far apart with stepSize of ' + stepSize + ' ' + minor);
        }
        const timestamps = options.ticks.source === 'data' && this.getDataTimestamps();
        for(time = first, count = 0; time < max; time = +adapter.add(time, stepSize, minor), count++){
            addTick(ticks, time, timestamps);
        }
        if (time === max || options.bounds === 'ticks' || count === 1) {
            addTick(ticks, time, timestamps);
        }
        return Object.keys(ticks).sort(sorter).map((x)=>+x);
    }
 getLabelForValue(value) {
        const adapter = this._adapter;
        const timeOpts = this.options.time;
        if (timeOpts.tooltipFormat) {
            return adapter.format(value, timeOpts.tooltipFormat);
        }
        return adapter.format(value, timeOpts.displayFormats.datetime);
    }
 format(value, format) {
        const options = this.options;
        const formats = options.time.displayFormats;
        const unit = this._unit;
        const fmt = format || formats[unit];
        return this._adapter.format(value, fmt);
    }
 _tickFormatFunction(time, index, ticks, format) {
        const options = this.options;
        const formatter = options.ticks.callback;
        if (formatter) {
            return callback(formatter, [
                time,
                index,
                ticks
            ], this);
        }
        const formats = options.time.displayFormats;
        const unit = this._unit;
        const majorUnit = this._majorUnit;
        const minorFormat = unit && formats[unit];
        const majorFormat = majorUnit && formats[majorUnit];
        const tick = ticks[index];
        const major = majorUnit && majorFormat && tick && tick.major;
        return this._adapter.format(time, format || (major ? majorFormat : minorFormat));
    }
 generateTickLabels(ticks) {
        let i, ilen, tick;
        for(i = 0, ilen = ticks.length; i < ilen; ++i){
            tick = ticks[i];
            tick.label = this._tickFormatFunction(tick.value, i, ticks);
        }
    }
 getDecimalForValue(value) {
        return value === null ? NaN : (value - this.min) / (this.max - this.min);
    }
 getPixelForValue(value) {
        const offsets = this._offsets;
        const pos = this.getDecimalForValue(value);
        return this.getPixelForDecimal((offsets.start + pos) * offsets.factor);
    }
 getValueForPixel(pixel) {
        const offsets = this._offsets;
        const pos = this.getDecimalForPixel(pixel) / offsets.factor - offsets.end;
        return this.min + pos * (this.max - this.min);
    }
 _getLabelSize(label) {
        const ticksOpts = this.options.ticks;
        const tickLabelWidth = this.ctx.measureText(label).width;
        const angle = toRadians(this.isHorizontal() ? ticksOpts.maxRotation : ticksOpts.minRotation);
        const cosRotation = Math.cos(angle);
        const sinRotation = Math.sin(angle);
        const tickFontSize = this._resolveTickFontOptions(0).size;
        return {
            w: tickLabelWidth * cosRotation + tickFontSize * sinRotation,
            h: tickLabelWidth * sinRotation + tickFontSize * cosRotation
        };
    }
 _getLabelCapacity(exampleTime) {
        const timeOpts = this.options.time;
        const displayFormats = timeOpts.displayFormats;
        const format = displayFormats[timeOpts.unit] || displayFormats.millisecond;
        const exampleLabel = this._tickFormatFunction(exampleTime, 0, ticksFromTimestamps(this, [
            exampleTime
        ], this._majorUnit), format);
        const size = this._getLabelSize(exampleLabel);
        const capacity = Math.floor(this.isHorizontal() ? this.width / size.w : this.height / size.h) - 1;
        return capacity > 0 ? capacity : 1;
    }
 getDataTimestamps() {
        let timestamps = this._cache.data || [];
        let i, ilen;
        if (timestamps.length) {
            return timestamps;
        }
        const metas = this.getMatchingVisibleMetas();
        if (this._normalized && metas.length) {
            return this._cache.data = metas[0].controller.getAllParsedValues(this);
        }
        for(i = 0, ilen = metas.length; i < ilen; ++i){
            timestamps = timestamps.concat(metas[i].controller.getAllParsedValues(this));
        }
        return this._cache.data = this.normalize(timestamps);
    }
 getLabelTimestamps() {
        const timestamps = this._cache.labels || [];
        let i, ilen;
        if (timestamps.length) {
            return timestamps;
        }
        const labels = this.getLabels();
        for(i = 0, ilen = labels.length; i < ilen; ++i){
            timestamps.push(parse(this, labels[i]));
        }
        return this._cache.labels = this._normalized ? timestamps : this.normalize(timestamps);
    }
 normalize(values) {
        return _arrayUnique(values.sort(sorter));
    }
}

function chart_interpolate(table, val, reverse) {
    let lo = 0;
    let hi = table.length - 1;
    let prevSource, nextSource, prevTarget, nextTarget;
    if (reverse) {
        if (val >= table[lo].pos && val <= table[hi].pos) {
            ({ lo , hi  } = _lookupByKey(table, 'pos', val));
        }
        ({ pos: prevSource , time: prevTarget  } = table[lo]);
        ({ pos: nextSource , time: nextTarget  } = table[hi]);
    } else {
        if (val >= table[lo].time && val <= table[hi].time) {
            ({ lo , hi  } = _lookupByKey(table, 'time', val));
        }
        ({ time: prevSource , pos: prevTarget  } = table[lo]);
        ({ time: nextSource , pos: nextTarget  } = table[hi]);
    }
    const span = nextSource - prevSource;
    return span ? prevTarget + (nextTarget - prevTarget) * (val - prevSource) / span : prevTarget;
}
class TimeSeriesScale extends TimeScale {
    static id = 'timeseries';
 static defaults = TimeScale.defaults;
 constructor(props){
        super(props);
         this._table = [];
         this._minPos = undefined;
         this._tableRange = undefined;
    }
 initOffsets() {
        const timestamps = this._getTimestampsForTable();
        const table = this._table = this.buildLookupTable(timestamps);
        this._minPos = chart_interpolate(table, this.min);
        this._tableRange = chart_interpolate(table, this.max) - this._minPos;
        super.initOffsets(timestamps);
    }
 buildLookupTable(timestamps) {
        const { min , max  } = this;
        const items = [];
        const table = [];
        let i, ilen, prev, curr, next;
        for(i = 0, ilen = timestamps.length; i < ilen; ++i){
            curr = timestamps[i];
            if (curr >= min && curr <= max) {
                items.push(curr);
            }
        }
        if (items.length < 2) {
            return [
                {
                    time: min,
                    pos: 0
                },
                {
                    time: max,
                    pos: 1
                }
            ];
        }
        for(i = 0, ilen = items.length; i < ilen; ++i){
            next = items[i + 1];
            prev = items[i - 1];
            curr = items[i];
            if (Math.round((next + prev) / 2) !== curr) {
                table.push({
                    time: curr,
                    pos: i / (ilen - 1)
                });
            }
        }
        return table;
    }
 _generate() {
        const min = this.min;
        const max = this.max;
        let timestamps = super.getDataTimestamps();
        if (!timestamps.includes(min) || !timestamps.length) {
            timestamps.splice(0, 0, min);
        }
        if (!timestamps.includes(max) || timestamps.length === 1) {
            timestamps.push(max);
        }
        return timestamps.sort((a, b)=>a - b);
    }
 _getTimestampsForTable() {
        let timestamps = this._cache.all || [];
        if (timestamps.length) {
            return timestamps;
        }
        const data = this.getDataTimestamps();
        const label = this.getLabelTimestamps();
        if (data.length && label.length) {
            timestamps = this.normalize(data.concat(label));
        } else {
            timestamps = data.length ? data : label;
        }
        timestamps = this._cache.all = timestamps;
        return timestamps;
    }
 getDecimalForValue(value) {
        return (chart_interpolate(this._table, value) - this._minPos) / this._tableRange;
    }
 getValueForPixel(pixel) {
        const offsets = this._offsets;
        const decimal = this.getDecimalForPixel(pixel) / offsets.factor - offsets.end;
        return chart_interpolate(this._table, decimal * this._tableRange + this._minPos, true);
    }
}

var scales = /*#__PURE__*/Object.freeze({
__proto__: null,
CategoryScale: CategoryScale,
LinearScale: LinearScale,
LogarithmicScale: LogarithmicScale,
RadialLinearScale: RadialLinearScale,
TimeScale: TimeScale,
TimeSeriesScale: TimeSeriesScale
});

const registerables = [
    controllers,
    chart_elements,
    plugins,
    scales
];


//# sourceMappingURL=chart.js.map

;// CONCATENATED MODULE: ./node_modules/react-chartjs-2/dist/index.js



const defaultDatasetIdKey = "label";
function reforwardRef(ref, value) {
    if (typeof ref === "function") {
        ref(value);
    } else if (ref) {
        ref.current = value;
    }
}
function setOptions(chart, nextOptions) {
    const options = chart.options;
    if (options && nextOptions) {
        Object.assign(options, nextOptions);
    }
}
function setLabels(currentData, nextLabels) {
    currentData.labels = nextLabels;
}
function setDatasets(currentData, nextDatasets) {
    let datasetIdKey = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : defaultDatasetIdKey;
    const addedDatasets = [];
    currentData.datasets = nextDatasets.map((nextDataset)=>{
        // given the new set, find it's current match
        const currentDataset = currentData.datasets.find((dataset)=>dataset[datasetIdKey] === nextDataset[datasetIdKey]);
        // There is no original to update, so simply add new one
        if (!currentDataset || !nextDataset.data || addedDatasets.includes(currentDataset)) {
            return {
                ...nextDataset
            };
        }
        addedDatasets.push(currentDataset);
        Object.assign(currentDataset, nextDataset);
        return currentDataset;
    });
}
function cloneData(data) {
    let datasetIdKey = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : defaultDatasetIdKey;
    const nextData = {
        labels: [],
        datasets: []
    };
    setLabels(nextData, data.labels);
    setDatasets(nextData, data.datasets, datasetIdKey);
    return nextData;
}
/**
 * Get dataset from mouse click event
 * @param chart - Chart.js instance
 * @param event - Mouse click event
 * @returns Dataset
 */ function getDatasetAtEvent(chart, event) {
    return chart.getElementsAtEventForMode(event.nativeEvent, "dataset", {
        intersect: true
    }, false);
}
/**
 * Get single dataset element from mouse click event
 * @param chart - Chart.js instance
 * @param event - Mouse click event
 * @returns Dataset
 */ function getElementAtEvent(chart, event) {
    return chart.getElementsAtEventForMode(event.nativeEvent, "nearest", {
        intersect: true
    }, false);
}
/**
 * Get all dataset elements from mouse click event
 * @param chart - Chart.js instance
 * @param event - Mouse click event
 * @returns Dataset
 */ function getElementsAtEvent(chart, event) {
    return chart.getElementsAtEventForMode(event.nativeEvent, "index", {
        intersect: true
    }, false);
}

function ChartComponent(props, ref) {
    const { height =150 , width =300 , redraw =false , datasetIdKey , type , data , options , plugins =[] , fallbackContent , updateMode , ...canvasProps } = props;
    const canvasRef = (0,react.useRef)(null);
    const chartRef = (0,react.useRef)();
    const renderChart = ()=>{
        if (!canvasRef.current) return;
        chartRef.current = new Chart(canvasRef.current, {
            type,
            data: cloneData(data, datasetIdKey),
            options: options && {
                ...options
            },
            plugins
        });
        reforwardRef(ref, chartRef.current);
    };
    const destroyChart = ()=>{
        reforwardRef(ref, null);
        if (chartRef.current) {
            chartRef.current.destroy();
            chartRef.current = null;
        }
    };
    (0,react.useEffect)(()=>{
        if (!redraw && chartRef.current && options) {
            setOptions(chartRef.current, options);
        }
    }, [
        redraw,
        options
    ]);
    (0,react.useEffect)(()=>{
        if (!redraw && chartRef.current) {
            setLabels(chartRef.current.config.data, data.labels);
        }
    }, [
        redraw,
        data.labels
    ]);
    (0,react.useEffect)(()=>{
        if (!redraw && chartRef.current && data.datasets) {
            setDatasets(chartRef.current.config.data, data.datasets, datasetIdKey);
        }
    }, [
        redraw,
        data.datasets
    ]);
    (0,react.useEffect)(()=>{
        if (!chartRef.current) return;
        if (redraw) {
            destroyChart();
            setTimeout(renderChart);
        } else {
            chartRef.current.update(updateMode);
        }
    }, [
        redraw,
        options,
        data.labels,
        data.datasets,
        updateMode
    ]);
    (0,react.useEffect)(()=>{
        if (!chartRef.current) return;
        destroyChart();
        setTimeout(renderChart);
    }, [
        type
    ]);
    (0,react.useEffect)(()=>{
        renderChart();
        return ()=>destroyChart();
    }, []);
    return /*#__PURE__*/ react.createElement("canvas", Object.assign({
        ref: canvasRef,
        role: "img",
        height: height,
        width: width
    }, canvasProps), fallbackContent);
}
const dist_Chart = /*#__PURE__*/ (0,react.forwardRef)(ChartComponent);

function createTypedChart(type, registerables) {
    Chart.register(registerables);
    return /*#__PURE__*/ (0,react.forwardRef)((props, ref)=>/*#__PURE__*/ react.createElement(dist_Chart, Object.assign({}, props, {
            ref: ref,
            type: type
        })));
}
const Line = /* #__PURE__ */ (/* unused pure expression or super */ null && (createTypedChart("line", LineController)));
const Bar = /* #__PURE__ */ createTypedChart("bar", BarController);
const Radar = /* #__PURE__ */ (/* unused pure expression or super */ null && (createTypedChart("radar", RadarController)));
const Doughnut = /* #__PURE__ */ (/* unused pure expression or super */ null && (createTypedChart("doughnut", DoughnutController)));
const PolarArea = /* #__PURE__ */ (/* unused pure expression or super */ null && (createTypedChart("polarArea", PolarAreaController)));
const Bubble = /* #__PURE__ */ (/* unused pure expression or super */ null && (createTypedChart("bubble", BubbleController)));
const Pie = /* #__PURE__ */ (/* unused pure expression or super */ null && (createTypedChart("pie", PieController)));
const Scatter = /* #__PURE__ */ (/* unused pure expression or super */ null && (createTypedChart("scatter", ScatterController)));


//# sourceMappingURL=index.js.map

// EXTERNAL MODULE: ./app/components/ui/select.tsx + 3 modules
var ui_select = __webpack_require__(80522);
// EXTERNAL MODULE: ./app/configs/index.ts + 3 modules
var configs = __webpack_require__(54254);
// EXTERNAL MODULE: ./app/context/index.ts + 2 modules
var context = __webpack_require__(17986);
// EXTERNAL MODULE: ./node_modules/@tanstack/react-query/build/modern/useQuery.js
var modern_useQuery = __webpack_require__(78551);
// EXTERNAL MODULE: ./node_modules/@tanstack/react-query/build/modern/useInfiniteQuery.js + 1 modules
var modern_useInfiniteQuery = __webpack_require__(29726);
// EXTERNAL MODULE: ./app/api/index.ts
var api = __webpack_require__(34224);
;// CONCATENATED MODULE: ./app/services/services/AnalyticServices.ts

const resource = "/v2/analytics";
class AnalyticServices_AnalyticService {
    static getTotalNews(params) {
        return api/* http.get */.d.get("".concat(resource, "/totalNews"), {
            params
        });
    }
    static getTotalLikeNews(params) {
        return api/* http.get */.d.get("".concat(resource, "/totalLike"), {
            params
        });
    }
    static getTotalCommentNews(params) {
        return api/* http.get */.d.get("".concat(resource, "/totalComment"), {
            params
        });
    }
    static getTotalEvent(params) {
        return api/* http.get */.d.get("".concat(resource, "/totalEvents"), {
            params
        });
    }
    static getTotalUserJoinedEvent(params) {
        return api/* http.get */.d.get("".concat(resource, "/totalUserJoinedEvent"), {
            params
        });
    }
    static getTotalUserFollowPartner(params) {
        return api/* http.get */.d.get("".concat(resource, "/totalUserFollowPartner"), {
            params
        });
    }
    static getListDataEvent(params) {
        return api/* http.get */.d.get("".concat(resource, "/dataEvents"), {
            params
        });
    }
    static getListDataNews(params) {
        return api/* http.get */.d.get("".concat(resource, "/dataNews"), {
            params
        });
    }
    static getChartData(params) {
        return api/* http.get */.d.get("".concat(resource, "/chartData"), {
            params
        });
    }
}

;// CONCATENATED MODULE: ./app/services/query-fn/user/user-analytic-query.ts



const useQueryGetTotalLikeNews = (param)=>{
    return (0,modern_useQuery/* useQuery */.a)({
        queryKey: [
            configs/* QUERY_KEY.ANALYTIC_GET_TOTAL_LIKE_NEWS */.lP.ANALYTIC_GET_TOTAL_LIKE_NEWS,
            param
        ],
        queryFn: async ()=>{
            var _res_data;
            const res = await AnalyticServices_AnalyticService.getTotalLikeNews(param);
            return res === null || res === void 0 ? void 0 : (_res_data = res.data) === null || _res_data === void 0 ? void 0 : _res_data.total;
        },
        refetchOnMount: "always"
    });
};
const useQueryGetTotalCommentNews = (param)=>{
    return (0,modern_useQuery/* useQuery */.a)({
        queryKey: [
            configs/* QUERY_KEY.ANALYTIC_GET_TOTAL_COMMENT_NEWS */.lP.ANALYTIC_GET_TOTAL_COMMENT_NEWS,
            param
        ],
        queryFn: async ()=>{
            var _res_data;
            const res = await AnalyticServices_AnalyticService.getTotalCommentNews(param);
            return res === null || res === void 0 ? void 0 : (_res_data = res.data) === null || _res_data === void 0 ? void 0 : _res_data.total;
        },
        refetchOnMount: "always"
    });
};
const useQueryGetTotalNews = (param)=>{
    return (0,modern_useQuery/* useQuery */.a)({
        queryKey: [
            configs/* QUERY_KEY.ANALYTIC_GET_TOTAL_NEWS */.lP.ANALYTIC_GET_TOTAL_NEWS,
            param
        ],
        queryFn: async ()=>{
            var _res_data;
            const res = await AnalyticServices_AnalyticService.getTotalNews(param);
            return res === null || res === void 0 ? void 0 : (_res_data = res.data) === null || _res_data === void 0 ? void 0 : _res_data.total;
        },
        refetchOnMount: "always"
    });
};
const useQueryGetTotalEvent = (param)=>{
    return useQuery({
        queryKey: [
            QUERY_KEY.ANALYTIC_GET_TOTAL_EVENT,
            param
        ],
        queryFn: async ()=>{
            var _res_data;
            const res = await AnalyticService.getTotalEvent(param);
            return res === null || res === void 0 ? void 0 : (_res_data = res.data) === null || _res_data === void 0 ? void 0 : _res_data.total;
        },
        refetchOnMount: "always"
    });
};
const useQueryGetTotalUserFollowPartner = (param)=>{
    return useQuery({
        queryKey: [
            QUERY_KEY.ANALYTIC_GET_TOTAL_USER_FOLLOW_PARTNER,
            param
        ],
        queryFn: async ()=>{
            var _res_data;
            const res = await AnalyticService.getTotalUserFollowPartner(param);
            return res === null || res === void 0 ? void 0 : (_res_data = res.data) === null || _res_data === void 0 ? void 0 : _res_data.total;
        },
        refetchOnMount: "always"
    });
};
const useQueryGetTotalUserJoinedEvent = (param)=>{
    return (0,modern_useQuery/* useQuery */.a)({
        queryKey: [
            configs/* QUERY_KEY.ANALYTIC_GET_TOTAL_USER_JOINED_EVENT */.lP.ANALYTIC_GET_TOTAL_USER_JOINED_EVENT,
            param
        ],
        queryFn: async ()=>{
            var _res_data;
            const res = await AnalyticServices_AnalyticService.getTotalUserJoinedEvent(param);
            return res === null || res === void 0 ? void 0 : (_res_data = res.data) === null || _res_data === void 0 ? void 0 : _res_data.total;
        },
        refetchOnMount: "always"
    });
};
const useQueryGetListDataNews = (params)=>{
    const { type , ...param } = params;
    return (0,modern_useInfiniteQuery/* useInfiniteQuery */.N)({
        queryKey: [
            configs/* QUERY_KEY.ANALYTIC_NEWS */.lP.ANALYTIC_NEWS,
            param
        ],
        queryFn: async (param)=>{
            let { pageParam  } = param;
            var _res_data;
            const res = await AnalyticServices_AnalyticService.getListDataNews({
                ...params,
                page: pageParam
            });
            return res === null || res === void 0 ? void 0 : (_res_data = res.data) === null || _res_data === void 0 ? void 0 : _res_data.data;
        },
        initialPageParam: 1,
        getNextPageParam: (lastPage, pages)=>{
            return (lastPage === null || lastPage === void 0 ? void 0 : lastPage.length) > 9 ? (pages === null || pages === void 0 ? void 0 : pages.length) + 1 : undefined;
        },
        enabled: type === "news",
        refetchOnMount: "always"
    });
};
const useQueryGetListDataEvent = (params)=>{
    const { type , ...param } = params;
    return useInfiniteQuery({
        queryKey: [
            QUERY_KEY.ANALYTIC_EVENT,
            param
        ],
        queryFn: async (param)=>{
            let { pageParam  } = param;
            var _res_data;
            const res = await AnalyticService.getListDataEvent({
                ...params,
                page: pageParam
            });
            return res === null || res === void 0 ? void 0 : (_res_data = res.data) === null || _res_data === void 0 ? void 0 : _res_data.data;
        },
        initialPageParam: 1,
        getNextPageParam: (lastPage, pages)=>{
            return (lastPage === null || lastPage === void 0 ? void 0 : lastPage.length) > 9 ? (pages === null || pages === void 0 ? void 0 : pages.length) + 1 : undefined;
        },
        enabled: type === "event",
        refetchOnMount: "always"
    });
};
const useQueryGetChartData = (param)=>{
    return (0,modern_useQuery/* useQuery */.a)({
        queryKey: [
            configs/* QUERY_KEY.ANALYTIC_CHART_DATA */.lP.ANALYTIC_CHART_DATA,
            param
        ],
        queryFn: async ()=>{
            var _res_data;
            const res = await AnalyticServices_AnalyticService.getChartData(param);
            return res === null || res === void 0 ? void 0 : (_res_data = res.data) === null || _res_data === void 0 ? void 0 : _res_data.data;
        },
        refetchOnMount: "always"
    });
};

// EXTERNAL MODULE: ./app/helpers/function.ts + 23 modules
var helpers_function = __webpack_require__(4203);
// EXTERNAL MODULE: ./app/utils/index.tsx
var utils = __webpack_require__(90752);
// EXTERNAL MODULE: ./node_modules/moment/moment.js
var moment = __webpack_require__(30381);
var moment_default = /*#__PURE__*/__webpack_require__.n(moment);
;// CONCATENATED MODULE: ./app/containers/users/partner/tab/analytic/AnalyticChart.tsx












Chart.register(CategoryScale, LinearScale, BarElement, plugin_title, plugin_tooltip);
const MAX_BAR = 7;
const AnalyticChart = ()=>{
    var _tranformData, _tranformData_total;
    const { t  } = (0,esm/* useTranslation */.$G)();
    const chartRef = (0,react.useRef)();
    const boxRef = (0,react.useRef)(null);
    const { themeApp  } = (0,react.useContext)(context/* AppContext */.Il);
    const { isMobile  } = (0,react.useContext)(context/* MobileContext */.zw);
    const [time, setTime] = (0,react.useState)("7 days");
    const timeFilter = (0,react.useMemo)(()=>{
        return (0,helpers_function/* getTimeBySubtract */.z$)(time);
    }, [
        time
    ]);
    const FilterTime = [
        {
            label: t("profile.seven_days"),
            value: "7 days"
        },
        {
            label: t("profile._30_days"),
            value: "30 days"
        },
        {
            label: t("profile._45_days"),
            value: "45 days"
        },
        {
            label: t("profile._60_days"),
            value: "60 days"
        },
        {
            label: t("profile._90_days"),
            value: "90 days"
        }
    ];
    const comon = {
        plugins: {
            legend: {
                display: false
            },
            tooltip: {}
        },
        maintainAspectRatio: false
    };
    const optionsMain = {
        ...comon,
        layout: {
            padding: {
                top: 10,
                bottom: 10
            }
        },
        scales: {
            y: {
                boder: {
                    display: false
                },
                beginAtZero: true,
                ticks: {
                    display: false
                },
                grid: {
                    display: true,
                    drawBorder: false,
                    drawTick: false,
                    color: themeApp === "dark" ? "#706E7E" : "rgba(0, 0, 0, 0.1)",
                    drawTicks: false
                }
            },
            x: {
                ticks: {
                    display: true,
                    fontColor: themeApp === "dark" ? "#fff" : "#000",
                    padding: 10
                },
                grid: {
                    display: false,
                    drawBorder: false,
                    drawTicks: false
                }
            }
        }
    };
    const option2 = {
        ...comon,
        layout: {
            padding: {
                bottom: 20
            }
        },
        scales: {
            y: {
                beginAtZero: true,
                afterFit: (ctx)=>{
                    ctx.width = 50;
                },
                ticks: {
                    fontColor: "#736B8A",
                    beginAtZero: true,
                    stepSize: 200
                },
                grid: {
                    display: false,
                    drawBorder: false
                }
            },
            x: {
                ticks: {
                    display: false
                },
                grid: {
                    display: false,
                    drawBorder: false
                }
            }
        }
    };
    const { data: chartData , isLoading  } = useQueryGetChartData({
        ...timeFilter
    });
    const onValueChange = (value)=>{
        setTime(value);
    };
    const getTotal = (array)=>{
        const total = array.reduce((acc, currentValue)=>{
            return acc + (Number(currentValue === null || currentValue === void 0 ? void 0 : currentValue.total_like) + Number(currentValue === null || currentValue === void 0 ? void 0 : currentValue.total_comment) + Number(currentValue === null || currentValue === void 0 ? void 0 : currentValue.total_join_event));
        }, 0);
        return total;
    };
    const tranformData = (0,react.useCallback)(()=>{
        if (!!chartData) {
            const chartDataArray = (0,utils/* convertObjectToArray */.HS)(chartData);
            moment_default().locale("en");
            return {
                labels: chartDataArray.map((data)=>moment_default()(data.day).format("DD")),
                datasets: [
                    {
                        data: chartDataArray.map((data)=>{
                            return Number(data === null || data === void 0 ? void 0 : data.total_like) + Number(data === null || data === void 0 ? void 0 : data.total_comment) + Number(data === null || data === void 0 ? void 0 : data.total_join_event);
                        }),
                        backgroundColor: [
                            "#DAD9FE"
                        ],
                        borderRadius: 10,
                        borderSkipped: false,
                        margin: 10,
                        fill: true,
                        barPercentage: 1,
                        maxBarThickness: 40
                    }
                ],
                total: getTotal(chartDataArray)
            };
        } else return {};
    }, [
        chartData,
        time
    ]);
    (0,react.useEffect)(()=>{
        if (configs/* isClient */.C5 && (chartRef === null || chartRef === void 0 ? void 0 : chartRef.current) && (boxRef === null || boxRef === void 0 ? void 0 : boxRef.current)) {
            var _chartRef_current_data_labels_length;
            const barLength = (_chartRef_current_data_labels_length = chartRef.current.data.labels.length) !== null && _chartRef_current_data_labels_length !== void 0 ? _chartRef_current_data_labels_length : 0;
            if (barLength > MAX_BAR) {
                const chartWidth = 530 + (barLength - MAX_BAR) * 40;
                if (isMobile) {
                    boxRef.current.style.width = "".concat(chartWidth, "px");
                } else boxRef.current.style.width = "60vw";
            }
        }
    }, [
        chartRef,
        boxRef,
        isMobile,
        tranformData,
        time
    ]);
    var _tranformData_total_toLocaleString;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "bg-white dark:bg-white/10 py-[16px] px-[12px] lg:px-[24px] rounded-[16px] min-h-[332px] col-span-12 md:col-span-7 lg:col-span-8",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "border-b border-main-01",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        className: "text-neutral-05 text-sm Nunito-400 leading-5 mb-[12px] dark:text-neutral-08",
                        children: t("profile.total_view")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "flex justify-between items-end pb-[12px]",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                className: "text-[32px] text-bg-01 Nunito-700 leading-10 dark:text-white",
                                children: (_tranformData_total_toLocaleString = (_tranformData = tranformData()) === null || _tranformData === void 0 ? void 0 : (_tranformData_total = _tranformData.total) === null || _tranformData_total === void 0 ? void 0 : _tranformData_total.toLocaleString()) !== null && _tranformData_total_toLocaleString !== void 0 ? _tranformData_total_toLocaleString : 0
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(ui_select/* Select */.Ph, {
                                    onValueChange: onValueChange,
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(ui_select/* SelectTrigger */.i4, {
                                            className: "w-full max-w-[130px] max-h-[28px] file:m-0 text-xs Nunito-400 text-main-01 dark:text-white dark:bg-white/10 dark:backdrop-blur-[20px] border-0 bg-bg-disable text-left",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ui_select/* SelectValue */.ki, {
                                                placeholder: t("profile.seven_days"),
                                                defaultValue: t("profile.seven_days")
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(ui_select/* SelectContent */.Bw, {
                                            className: "p-1 rounded-[16px]",
                                            align: "end",
                                            children: FilterTime.map((item)=>{
                                                /*#__PURE__*/ return (0,jsx_runtime.jsx)(ui_select/* SelectItem */.Ql, {
                                                    value: item === null || item === void 0 ? void 0 : item.value,
                                                    className: "py-3 px-4 rounded-[8px] hover:!bg-bg-disable hover:!text-main-01 text-base Nunito-600 focus:bg-bg-disable focus:text-main-01 dark:hover:!bg-[#F1F1FC]/[.1] dark:focus:!bg-[#F1F1FC]/[.1]",
                                                    children: item === null || item === void 0 ? void 0 : item.label
                                                }, item === null || item === void 0 ? void 0 : item.value);
                                            })
                                        })
                                    ]
                                })
                            })
                        ]
                    })
                ]
            }),
            !isLoading && !!tranformData() && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "container-chart w-full max-w-full flex h-[185px] mt-[40px]",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "w-[50px] h-full",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Bar, {
                            options: option2,
                            data: tranformData()
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "w-full max-w-full overflow-x-auto overflow-y-visible",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            ref: boxRef,
                            className: "h-[185px] w-[calc(100%-50px)]",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Bar, {
                                ref: chartRef,
                                options: optionsMain,
                                data: tranformData(),
                                className: "w-full"
                            })
                        })
                    })
                ]
            })
        ]
    });
};

;// CONCATENATED MODULE: ./app/containers/users/partner/tab/analytic/Statistical.tsx






const Statistical = ()=>{
    const { t  } = (0,esm/* useTranslation */.$G)();
    const FilterTime = [
        {
            label: t("profile.seven_days"),
            value: "7 days"
        },
        {
            label: t("profile._30_days"),
            value: "30 days"
        },
        {
            label: t("profile._45_days"),
            value: "45 days"
        },
        {
            label: t("profile._60_days"),
            value: "60 days"
        },
        {
            label: t("profile._90_days"),
            value: "90 days"
        }
    ];
    const [time, setTime] = (0,react.useState)("7 days");
    const timeFilter = (0,react.useMemo)(()=>{
        return (0,helpers_function/* getTimeBySubtract */.z$)(time);
    }, [
        time
    ]);
    const { data: totalNews  } = useQueryGetTotalNews({
        ...timeFilter
    });
    const { data: totalLikeNews  } = useQueryGetTotalLikeNews({
        ...timeFilter
    });
    const { data: totalCommentNews  } = useQueryGetTotalCommentNews({
        ...timeFilter
    });
    // const { data: totalEvent } = useQueryGetTotalEvent({ ...timeFilter })
    const { data: totalUserJoinedEvent  } = useQueryGetTotalUserJoinedEvent({
        ...timeFilter
    });
    const onValueChange = (value)=>{
        setTime(value);
    };
    const formatNumber = (num)=>{
        return Intl.NumberFormat("en-US", {
            notation: "compact",
            maximumFractionDigits: 1
        }).format(num);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "p-[16px] bg-white dark:bg-white/10 min-h-[332px] col-span-12 md:col-span-5 lg:col-span-4 rounded-[16px] space-y-[24px]",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        className: "border-neutral-05 text-sm Nunito-400 leading-5 mb-[12px] opacity-0 dark:text-neutral-08",
                        children: t("profile.total_view")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "flex justify-between items-center border-b border-main-01 pb-[12px]",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                className: "text-[16px] text-bg-01 Nunito-600 leading-10 dark:text-white",
                                children: t("profile.statistical")
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(ui_select/* Select */.Ph, {
                                    onValueChange: onValueChange,
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(ui_select/* SelectTrigger */.i4, {
                                            className: "w-full max-w-[130px] max-h-[28px] file:m-0 text-xs Nunito-400 text-main-01 dark:text-white dark:bg-white/10 dark:backdrop-blur-[20px] border-0 bg-bg-disable text-left",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ui_select/* SelectValue */.ki, {
                                                placeholder: t("profile.seven_days"),
                                                defaultValue: t("profile.seven_days")
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(ui_select/* SelectContent */.Bw, {
                                            className: "p-1 rounded-[16px]",
                                            align: "end",
                                            children: FilterTime.map((item)=>{
                                                /*#__PURE__*/ return (0,jsx_runtime.jsx)(ui_select/* SelectItem */.Ql, {
                                                    value: item === null || item === void 0 ? void 0 : item.value,
                                                    className: "py-3 px-4 rounded-[8px] hover:!bg-bg-disable hover:!text-main-01 text-base Nunito-600 focus:bg-bg-disable focus:text-main-01 dark:hover:!bg-[#F1F1FC]/[.1] dark:focus:!bg-[#F1F1FC]/[.1]",
                                                    children: item === null || item === void 0 ? void 0 : item.label
                                                }, item === null || item === void 0 ? void 0 : item.value);
                                            })
                                        })
                                    ]
                                })
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "w-full grid grid-cols-1 gap-[8px] p-[8px]",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "flex justify-between items-center pb-[20px] border-b border-black/10 dark:border-neutral-05",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "flex gap-[16px] items-center flex-1",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "w-[24px] h-[24px] rounded-[8px] bg-bg-button flex items-center justify-center",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
                                            width: "16",
                                            height: "16",
                                            viewBox: "0 0 16 16",
                                            fill: "none",
                                            xmlns: "http://www.w3.org/2000/svg",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                d: "M11.334 4.33353C12.0703 4.33353 12.6673 4.93049 12.6673 5.66687M8.00065 3.80189L8.45736 3.33354C9.87797 1.87668 12.1812 1.87668 13.6019 3.33353C14.9843 4.75127 15.0268 7.03607 13.698 8.50681L9.88046 12.7323C8.86628 13.8549 7.13501 13.8549 6.12082 12.7323L2.30327 8.50683C0.974506 7.03609 1.01698 4.75128 2.39945 3.33354C3.82007 1.87668 6.12334 1.87669 7.54396 3.33355L8.00065 3.80189Z",
                                                stroke: "#585669",
                                                strokeWidth: "1.5",
                                                strokeLinecap: "round",
                                                strokeLinejoin: "round"
                                            })
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                        className: "text-sm text-neutral Nunito-400 dark:text-neutral-08",
                                        children: t("profile.total_like")
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                className: "text-base text-bg-01 Nunito-600 dark:text-main-white",
                                children: formatNumber(Number(totalLikeNews !== null && totalLikeNews !== void 0 ? totalLikeNews : 0))
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "flex justify-between items-center py-[20px] border-b border-black/10 dark:border-neutral-05",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "flex gap-[16px] items-center flex-1",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "w-[24px] h-[24px] rounded-[8px] bg-bg-button flex items-center justify-center",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
                                            width: "16",
                                            height: "16",
                                            viewBox: "0 0 16 16",
                                            fill: "none",
                                            xmlns: "http://www.w3.org/2000/svg",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                    d: "M8.66732 2H7.33398C4.02028 2 1.33398 4.68629 1.33398 8V11.3333C1.33398 12.8061 2.52789 14 4.00065 14H8.66732C11.981 14 14.6673 11.3137 14.6673 8C14.6673 4.68629 11.981 2 8.66732 2Z",
                                                    stroke: "#585669",
                                                    strokeWidth: "1.5",
                                                    strokeLinejoin: "round"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("circle", {
                                                    cx: "8.00065",
                                                    cy: "8.00004",
                                                    r: "0.666667",
                                                    fill: "#585669"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("ellipse", {
                                                    cx: "10.6667",
                                                    cy: "8.00004",
                                                    rx: "0.666667",
                                                    ry: "0.666667",
                                                    fill: "#585669"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("circle", {
                                                    cx: "5.33268",
                                                    cy: "8.00004",
                                                    r: "0.666667",
                                                    fill: "#585669"
                                                })
                                            ]
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                        className: "text-sm text-neutral Nunito-400 dark:text-neutral-08",
                                        children: t("profile.total_comment")
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                className: "text-base text-bg-01 Nunito-600 dark:text-main-white",
                                children: formatNumber(Number(totalCommentNews !== null && totalCommentNews !== void 0 ? totalCommentNews : 0))
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "flex justify-between items-center py-[20px]",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "flex gap-[16px] items-center flex-1",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "w-[24px] h-[24px] rounded-[8px] bg-bg-button flex items-center justify-center",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
                                            width: "16",
                                            height: "16",
                                            viewBox: "0 0 16 16",
                                            fill: "none",
                                            xmlns: "http://www.w3.org/2000/svg",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("g", {
                                                    clipPath: "url(#clip0_9890_62737)",
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                                                            x: "1.33398",
                                                            y: "1.33334",
                                                            width: "13.3333",
                                                            height: "13.3333",
                                                            rx: "4",
                                                            stroke: "#585669",
                                                            strokeWidth: "1.5"
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                            d: "M5.33398 1.33334H10.6673V5.5858C10.6673 6.4767 9.59018 6.92287 8.96021 6.2929L8.70776 6.04045C8.31723 5.64993 7.68407 5.64993 7.29354 6.04045L7.04109 6.2929C6.41113 6.92287 5.33398 6.4767 5.33398 5.5858V1.33334Z",
                                                            stroke: "#585669",
                                                            strokeWidth: "1.5",
                                                            strokeLinejoin: "round"
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("defs", {
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("clipPath", {
                                                        id: "clip0_9890_62737",
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                                                            width: "16",
                                                            height: "16",
                                                            fill: "white"
                                                        })
                                                    })
                                                })
                                            ]
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                        className: "text-sm text-neutral Nunito-400 dark:text-neutral-08",
                                        children: t("profile.total_news")
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                className: "text-base text-bg-01 Nunito-600 dark:text-main-white",
                                children: formatNumber(Number(totalNews !== null && totalNews !== void 0 ? totalNews : 0))
                            })
                        ]
                    })
                ]
            })
        ]
    });
};

;// CONCATENATED MODULE: ./app/containers/users/partner/tab/analytic/ItemDetailStatistical.tsx




const ItemDetailStatistical = (param)=>{
    let { detail , activeTab  } = param;
    const router = (0,next_router.useRouter)();
    const onNavigateToDetail = ()=>{
        router.push("/detail/".concat(activeTab, "/").concat((0,helpers_function/* createSlugNameDetail */.ti)(detail === null || detail === void 0 ? void 0 : detail.title, detail === null || detail === void 0 ? void 0 : detail.id)));
    };
    var _detail_thumbnail;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "flex flex-col justify-between w-full overflow-auto md:flex-row",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "flex items-start gap-[16px] cursor-pointer",
                onClick: onNavigateToDetail,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                        className: "rounded-[12px] w-[120px] aspect-video object-cover",
                        src: (_detail_thumbnail = detail === null || detail === void 0 ? void 0 : detail.thumbnail) !== null && _detail_thumbnail !== void 0 ? _detail_thumbnail : "",
                        alt: detail === null || detail === void 0 ? void 0 : detail.title,
                        title: detail === null || detail === void 0 ? void 0 : detail.title
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "flex flex-col flex-1 max-w-full lg:max-w-1/2",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                className: "text-xs Nunito-400 text-neutral dark:tex-neutral-08",
                                children: (0,helpers_function/* timeFormatter */.g6)((detail === null || detail === void 0 ? void 0 : detail.created_at) * 1000)
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                className: "text-bg-01 Nunito-600 text-base mt-[8px] dark:text-main-white",
                                children: detail === null || detail === void 0 ? void 0 : detail.title
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "flex items-center gap-[24px] justify-evenly md:justify-end min-w-[200px] mt-[16px] pb-[24px] md:mt-0 md:pb-0 border-b border-b/10 md:border-0 dark:border-neutral-03",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "flex flex-col items-center justify-center gap-[8px]",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                    className: "text-xs text-neutral Nunito-400 dark:text-neutral-08",
                                    children: "Lượt th\xedch"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                    className: "text-base text-bg-01 Nunito-700 dark:text-main-white",
                                    children: detail === null || detail === void 0 ? void 0 : detail.total_like
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "h-[30px] w-[0.6px] bg-black/10 "
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "flex flex-col items-center justify-center gap-[8px]",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                    className: "text-xs text-neutral Nunito-400 dark:text-neutral-08",
                                    children: "Lượt b\xecnh luận"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                    className: "text-base text-bg-01 Nunito-700 dark:text-main-white",
                                    children: detail === null || detail === void 0 ? void 0 : detail.total_comment
                                })
                            ]
                        })
                    ]
                })
            })
        ]
    });
};

// EXTERNAL MODULE: ./app/components/data-empty/index.tsx + 1 modules
var data_empty = __webpack_require__(98269);
// EXTERNAL MODULE: ./node_modules/react-intersection-observer/index.mjs
var react_intersection_observer = __webpack_require__(42708);
;// CONCATENATED MODULE: ./app/containers/users/partner/tab/analytic/DetailStatistical.tsx









const DetailStatistical = ()=>{
    var _listNews_pages_flat, _listNews_pages, _listNews_pages_flat1, _listNews_pages1;
    const { t  } = (0,esm/* useTranslation */.$G)();
    const { ref , inView  } = (0,react_intersection_observer/* useInView */.YD)();
    const [tab, setTab] = (0,react.useState)("news");
    const [time, setTime] = (0,react.useState)("7 days");
    const timeFilter = (0,react.useMemo)(()=>{
        return (0,helpers_function/* getTimeBySubtract */.z$)(time);
    }, [
        time
    ]);
    const FilterTime = [
        {
            label: t("profile.seven_days"),
            value: "7 days"
        },
        {
            label: t("profile._30_days"),
            value: "30 days"
        },
        {
            label: t("profile._45_days"),
            value: "45 days"
        },
        {
            label: t("profile._60_days"),
            value: "60 days"
        },
        {
            label: t("profile._90_days"),
            value: "90 days"
        }
    ];
    const { data: listNews , fetchNextPage: fetchNextPageNews  } = useQueryGetListDataNews({
        ...timeFilter,
        type: tab
    });
    const onValueChange = (value)=>{
        setTime(value);
    };
    (0,react.useEffect)(()=>{
        if (inView) {
            fetchNextPageNews();
        }
    }, [
        fetchNextPageNews,
        inView,
        tab
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "col-span-12",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "flex items-center justify-between pt-[8px] pb-[16px] border-b border-black/10 dark:border-neutral-03",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "flex w-full items-center gap-[24px] flex-col lg:flex-row",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                            className: "text-bg-01 Nunito-700 text-[18px] hidden lg:block dark:text-main-white",
                            children: t("profile.detail_stat_title")
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(ui_select/* Select */.Ph, {
                        onValueChange: onValueChange,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(ui_select/* SelectTrigger */.i4, {
                                className: "w-full max-w-[130px] max-h-[28px] file:m-0 text-xs Nunito-400 text-main-01 dark:text-white dark:bg-white/10 dark:backdrop-blur-[20px] border-0 bg-bg-disable text-left",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ui_select/* SelectValue */.ki, {
                                    placeholder: t("profile.seven_days"),
                                    defaultValue: t("profile.seven_days")
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(ui_select/* SelectContent */.Bw, {
                                className: "p-1 rounded-[16px]",
                                align: "end",
                                children: FilterTime.map((item)=>{
                                    /*#__PURE__*/ return (0,jsx_runtime.jsx)(ui_select/* SelectItem */.Ql, {
                                        value: item === null || item === void 0 ? void 0 : item.value,
                                        className: "py-3 px-4 rounded-[8px] hover:!bg-bg-disable hover:!text-main-01 text-base Nunito-600 focus:bg-bg-disable focus:text-main-01 dark:hover:!bg-[#F1F1FC]/[.1] dark:focus:!bg-[#F1F1FC]/[.1]",
                                        children: item === null || item === void 0 ? void 0 : item.label
                                    }, item === null || item === void 0 ? void 0 : item.value);
                                })
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "space-y-[20px] mt-[16px]",
                children: !!((_listNews_pages_flat = listNews === null || listNews === void 0 ? void 0 : (_listNews_pages = listNews.pages) === null || _listNews_pages === void 0 ? void 0 : _listNews_pages.flat()) === null || _listNews_pages_flat === void 0 ? void 0 : _listNews_pages_flat.length) ? (_listNews_pages_flat1 = listNews === null || listNews === void 0 ? void 0 : (_listNews_pages1 = listNews.pages) === null || _listNews_pages1 === void 0 ? void 0 : _listNews_pages1.flat()) === null || _listNews_pages_flat1 === void 0 ? void 0 : _listNews_pages_flat1.map((item, index)=>/*#__PURE__*/ (0,jsx_runtime.jsx)(ItemDetailStatistical, {
                        detail: item,
                        activeTab: tab
                    }, index)) : /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "w-full flex items-center justify-center h-[200px]",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(data_empty/* DataEmpty */.$, {
                        title: t("profile.no_data")
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                ref: ref,
                className: "opacity-0",
                children: "Load more"
            })
        ]
    });
};

;// CONCATENATED MODULE: ./app/containers/users/partner/tab/analytic/PartnerAnalytic.tsx





const PartnerAnalytic = ()=>{
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "grid grid-cols-12 w-full mt-[32px] gap-[24px] lg:gap-[32px] pb-[40px]",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(AnalyticChart, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Statistical, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(DetailStatistical, {})
        ]
    });
};

// EXTERNAL MODULE: ./app/components/icon-tsx/index.ts + 11 modules
var icon_tsx = __webpack_require__(61552);
// EXTERNAL MODULE: ./app/components/post-event/PostEvent.tsx
var post_event_PostEvent = __webpack_require__(78121);
// EXTERNAL MODULE: ./app/services/query-fn/event/index.ts + 1 modules
var query_fn_event = __webpack_require__(54583);
// EXTERNAL MODULE: ./app/containers/users/common/index.ts + 12 modules
var common = __webpack_require__(75025);
// EXTERNAL MODULE: ./app/hooks/useDebounceEffect.tsx
var hooks_useDebounceEffect = __webpack_require__(45724);
// EXTERNAL MODULE: ./app/services/query-fn/event/event-detail-mutation.ts
var event_detail_mutation = __webpack_require__(95035);
;// CONCATENATED MODULE: ./app/containers/users/partner/tab/post-event/PartnerEvent.tsx
















const initialFilterEvent = {
    keyword: "",
    sort: -1
};
// eslint-disable-next-line react/display-name
const PartnerEvent = ()=>{
    var _listEvent_pages_flat, _listEvent_pages, _listEvent_pages_flat1, _listEvent_pages1;
    const { t  } = useTranslation();
    const { themeApp  } = useContext(AppContext);
    const [tempSearch, setTempSearch] = useState("");
    const methods = useForm({
        defaultValues: initialFilterEvent
    });
    const watchKeyword = methods.watch("keyword", undefined);
    const watchSort = methods.watch("sort", -1);
    const { data: listEvent , fetchNextPage  } = useQueryGetMyEventByFilter(removeNullKeyObject({
        keyword: watchKeyword,
        sort: watchSort,
        limit: LIMIT_PAGE_POST
    }));
    const onChange = (e)=>{
        var _e_target;
        setTempSearch(e === null || e === void 0 ? void 0 : (_e_target = e.target) === null || _e_target === void 0 ? void 0 : _e_target.value);
    };
    useDebounceEffect(()=>methods.setValue("keyword", tempSearch), 300, [
        tempSearch
    ]);
    const queryClient = useQueryClient();
    const { mutate: mutateJoinEvent  } = useMutationJoinEvent();
    const onJoinEvent = (id)=>{
        mutateJoinEvent({
            id
        }, {
            onSuccess (data, variables, context) {
                var _data_data;
                if ((data === null || data === void 0 ? void 0 : (_data_data = data.data) === null || _data_data === void 0 ? void 0 : _data_data.errorCode) === 0) {
                    queryClient.invalidateQueries({
                        queryKey: [
                            QUERY_KEY.LIST_EVENT_BY_TYPE,
                            "all__"
                        ],
                        refetchType: "active"
                    });
                    queryClient.invalidateQueries({
                        queryKey: [
                            QUERY_KEY.LIST_EVENT,
                            ""
                        ],
                        refetchType: "active"
                    });
                    queryClient.invalidateQueries({
                        queryKey: [
                            QUERY_KEY.LIST_EVENT_BY_TYPE,
                            "joined_1"
                        ],
                        refetchType: "active"
                    });
                    queryClient.invalidateQueries({
                        queryKey: [
                            QUERY_KEY.LIST_EVENT_BY_TYPE,
                            "joined_-1"
                        ],
                        refetchType: "active"
                    });
                    queryClient.invalidateQueries({
                        queryKey: [
                            QUERY_KEY.EVENT_DETAIL,
                            id
                        ],
                        refetchType: "active"
                    });
                    queryClient.invalidateQueries({
                        queryKey: [
                            QUERY_KEY.MY_EVENT_BY_FILTER,
                            Object.values(removeNullKeyObject({
                                keyword: watchKeyword,
                                sort: watchSort,
                                limit: LIMIT_PAGE_POST
                            })).join("-")
                        ]
                    });
                }
            },
            onError (error, variables, context) {}
        });
    };
    const { ref , inView  } = useInView();
    React.useEffect(()=>{
        if (inView) {
            fetchNextPage();
        }
    }, [
        fetchNextPage,
        inView
    ]);
    return /*#__PURE__*/ _jsxs("div", {
        className: "mt-4 md:mt-[32px] relative z-10",
        children: [
            /*#__PURE__*/ _jsx("div", {
                className: "flex items-center justify-between w-full",
                children: /*#__PURE__*/ _jsxs(FormProvider, {
                    ...methods,
                    children: [
                        /*#__PURE__*/ _jsx("div", {
                            className: "max-w-full flex-1 md:max-w-[320px]",
                            children: /*#__PURE__*/ _jsxs("div", {
                                className: "flex items-center justify-between border-b-[1px] dark:border-neutral-04 gap-4 py-3",
                                children: [
                                    /*#__PURE__*/ _jsx(IconSearch, {
                                        fill: themeApp === "dark" ? "#7673E5" : "#100D28",
                                        className: "w-[20px] h-[20px]"
                                    }),
                                    /*#__PURE__*/ _jsx("input", {
                                        type: "text",
                                        value: tempSearch,
                                        className: "flex-1 text-sm bg-transparent border-0 outline-none",
                                        placeholder: t("profile.find_event_placeholder"),
                                        onChange: onChange
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ _jsx(FilterPostEvent, {})
                    ]
                })
            }),
            !!listEvent && !!((_listEvent_pages_flat = listEvent === null || listEvent === void 0 ? void 0 : (_listEvent_pages = listEvent.pages) === null || _listEvent_pages === void 0 ? void 0 : _listEvent_pages.flat()) === null || _listEvent_pages_flat === void 0 ? void 0 : _listEvent_pages_flat.length) ? /*#__PURE__*/ _jsx("div", {
                className: "w-full mt-[24px]",
                children: React.Children.toArray((_listEvent_pages_flat1 = listEvent === null || listEvent === void 0 ? void 0 : (_listEvent_pages1 = listEvent.pages) === null || _listEvent_pages1 === void 0 ? void 0 : _listEvent_pages1.flat()) === null || _listEvent_pages_flat1 === void 0 ? void 0 : _listEvent_pages_flat1.map((item)=>/*#__PURE__*/ _jsx(PostEvent, {
                        event: item,
                        onJoinEvent: onJoinEvent
                    })))
            }) : /*#__PURE__*/ _jsx("div", {
                className: "w-full flex items-center justify-center h-[200px]",
                children: /*#__PURE__*/ _jsx(DataEmpty, {
                    title: t("profile.partner_empty_data")
                })
            }),
            /*#__PURE__*/ _jsx("button", {
                ref: ref,
                className: "opacity-0",
                children: "Load more"
            })
        ]
    });
};

// EXTERNAL MODULE: ./app/components/PostCard/index.tsx
var PostCard = __webpack_require__(4547);
// EXTERNAL MODULE: ./app/services/query-fn/news/index.ts + 4 modules
var news = __webpack_require__(31033);
// EXTERNAL MODULE: ./node_modules/react-hook-form/dist/index.esm.mjs
var dist_index_esm = __webpack_require__(87536);
// EXTERNAL MODULE: ./app/lib/utils.ts + 1 modules
var lib_utils = __webpack_require__(73848);
;// CONCATENATED MODULE: ./app/containers/users/partner/tab/post-event/PartnerPost.tsx














const initialFilterPost = {
    keyword: "",
    sort: -1
};
// eslint-disable-next-line react/display-name
const PartnerPost = ()=>{
    var _listNews_pages_flat, _listNews_pages, _listNews_pages_flat1, _listNews_pages1;
    const { t  } = (0,esm/* useTranslation */.$G)();
    const { themeApp  } = (0,react.useContext)(context/* AppContext */.Il);
    const methods = (0,dist_index_esm/* useForm */.cI)({
        defaultValues: initialFilterPost
    });
    const watchKeyword = methods.watch("keyword", undefined);
    const watchSort = methods.watch("sort", -1);
    const [tempSearch, setTempSearch] = (0,react.useState)("");
    const { data: listNewsWithoutSearch , fetchNextPage: fetchNextPageWithoutSearch  } = (0,news/* useQueryGetListNewsByUser */.DV)(watchKeyword, watchSort);
    const { data: listNewsWithSearch , fetchNextPage: fetchNextPageWithSearch  } = (0,news/* useQueryGetMyNewsByFilter */.vc)((0,lib_utils/* removeNullKeyObject */.t2)({
        keyword: watchKeyword,
        sort: watchSort,
        limit: configs/* LIMIT_PAGE_POST */.gS
    }));
    const listNews = !!watchKeyword ? listNewsWithSearch : listNewsWithoutSearch;
    const { ref , inView  } = (0,react_intersection_observer/* useInView */.YD)();
    const onChange = (e)=>{
        var _e_target;
        setTempSearch(e === null || e === void 0 ? void 0 : (_e_target = e.target) === null || _e_target === void 0 ? void 0 : _e_target.value);
    };
    (0,hooks_useDebounceEffect/* useDebounceEffect */.s)(()=>methods.setValue("keyword", tempSearch), 300, [
        tempSearch
    ]);
    react.useEffect(()=>{
        if (inView) {
            if (!watchKeyword) {
                fetchNextPageWithoutSearch();
            } else fetchNextPageWithSearch();
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        fetchNextPageWithoutSearch,
        fetchNextPageWithSearch,
        inView
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "mt-4 md:mt-[32px] relative z-10 w-full",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "flex items-center justify-between w-full",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(dist_index_esm/* FormProvider */.RV, {
                    ...methods,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "max-w-full flex-1 md:max-w-[320px]",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "flex items-center justify-between border-b-[1px] dark:border-neutral-04 gap-4 py-3",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(icon_tsx/* IconSearch */.jV, {
                                        fill: themeApp === "dark" ? "#7673E5" : "#100D28",
                                        className: "w-[20px] h-[20px]"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                        type: "text",
                                        value: tempSearch,
                                        className: "flex-1 text-sm bg-transparent border-0 outline-none",
                                        placeholder: t("profile.find_news_placeholder"),
                                        onChange: onChange
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(common/* FilterPostEvent */.nm, {})
                    ]
                })
            }),
            !!listNews && !!((_listNews_pages_flat = listNews === null || listNews === void 0 ? void 0 : (_listNews_pages = listNews.pages) === null || _listNews_pages === void 0 ? void 0 : _listNews_pages.flat()) === null || _listNews_pages_flat === void 0 ? void 0 : _listNews_pages_flat.length) ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "w-full mt-[24px] space-y-[24px]",
                children: react.Children.toArray((_listNews_pages_flat1 = listNews === null || listNews === void 0 ? void 0 : (_listNews_pages1 = listNews.pages) === null || _listNews_pages1 === void 0 ? void 0 : _listNews_pages1.flat()) === null || _listNews_pages_flat1 === void 0 ? void 0 : _listNews_pages_flat1.map((item)=>/*#__PURE__*/ (0,jsx_runtime.jsx)(PostCard/* PostCard */.y, {
                        postcard: item,
                        isCheckHashtag: true
                    })))
            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "w-full flex items-center justify-center h-[200px]",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(data_empty/* DataEmpty */.$, {
                    title: t("profile.partner_empty_data")
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                ref: ref,
                className: "opacity-0",
                children: "Load more"
            })
        ]
    });
};

;// CONCATENATED MODULE: ./app/containers/users/partner/tab/setting/PartnerSetting.tsx



const PartnerSetting = ()=>{
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "w-full",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(common/* SettingUserInfomation */.d_, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(common/* SettingWeb */.wd, {})
        ]
    });
};

;// CONCATENATED MODULE: ./app/containers/users/partner/tab/setting/index.ts


;// CONCATENATED MODULE: ./app/containers/users/partner/tab/index.ts





// EXTERNAL MODULE: ./app/containers/users/normal-user/tab/index.ts + 27 modules
var tab = __webpack_require__(66351);
;// CONCATENATED MODULE: ./app/containers/users/partner/tab/transaction-manager/ParterTransactionManager.tsx



const ParterTransactionManager = ()=>{
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(tab/* TransactionManager */.wt, {});
};

;// CONCATENATED MODULE: ./app/containers/users/partner/tab/transaction-manager/index.ts


// EXTERNAL MODULE: ./app/hooks/useGAEventsTracker.ts
var useGAEventsTracker = __webpack_require__(64800);
;// CONCATENATED MODULE: ./app/containers/users/partner/PartnerTab.tsx








var ENUM_PARTNER_TAB;
(function(ENUM_PARTNER_TAB) {
    ENUM_PARTNER_TAB["PARTNER_POST"] = "partner-post";
    ENUM_PARTNER_TAB["PARTNER_EVENT"] = "partner-event";
    ENUM_PARTNER_TAB["PARTNER_ANALYTIC"] = "partner-analytic";
    ENUM_PARTNER_TAB["PARTNER_SETTING"] = "partner-setting";
    ENUM_PARTNER_TAB["TRANSACTION_MANAGER"] = "transaction-manager";
})(ENUM_PARTNER_TAB || (ENUM_PARTNER_TAB = {}));
const PartnerTab = ()=>{
    const { t  } = (0,esm/* useTranslation */.$G)();
    const router = (0,next_router.useRouter)();
    const activeTab = (0,react.useMemo)(()=>router.query.tab, [
        router
    ]);
    const GAEventsTracker = (0,useGAEventsTracker/* default */.Z)("Profile");
    const handleChangeTab = (value)=>{
        var _router_query;
        if (value === ENUM_PARTNER_TAB.PARTNER_SETTING) GAEventsTracker("Profile_setting");
        if (value === ENUM_PARTNER_TAB.PARTNER_ANALYTIC) GAEventsTracker("Profile_data");
        router.push({
            pathname: router.pathname,
            query: {
                id: router === null || router === void 0 ? void 0 : (_router_query = router.query) === null || _router_query === void 0 ? void 0 : _router_query.id,
                tab: value
            }
        });
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "w-full",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(tabs/* Tabs */.mQ, {
            value: [
                "undefined",
                ENUM_PARTNER_TAB.PARTNER_POST
            ].includes(String(activeTab)) ? ENUM_PARTNER_TAB.PARTNER_POST : String(activeTab),
            className: "relative w-full",
            style: {
                zIndex: 2
            },
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "max-w-full overflow-auto",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(tabs/* TabsList */.dr, {
                        className: "flex px-0 border-0 w-fit",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(tabs/* TabsTrigger */.SP, {
                                value: ENUM_PARTNER_TAB.PARTNER_POST,
                                className: "flex items-center gap-[10px] text-neutral-05 dark:text-main-01 dark:data-[state=active]:text-main-01 dark:data-[state=active]:border-main-01 dark:data-[state=inactive]:text-neutral-05 w-fit",
                                onClick: ()=>handleChangeTab(ENUM_PARTNER_TAB.PARTNER_POST),
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    children: t("profile.tab_partner_post")
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(tabs/* TabsTrigger */.SP, {
                                value: ENUM_PARTNER_TAB.PARTNER_ANALYTIC,
                                className: "flex items-center gap-[10px] text-neutral-05 dark:text-main-01 dark:data-[state=active]:text-main-01 dark:data-[state=active]:border-main-01 dark:data-[state=inactive]:text-neutral-05 w-fit",
                                onClick: ()=>handleChangeTab(ENUM_PARTNER_TAB.PARTNER_ANALYTIC),
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    children: t("profile.tab_partner_data")
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(tabs/* TabsTrigger */.SP, {
                                value: ENUM_PARTNER_TAB.TRANSACTION_MANAGER,
                                className: "flex items-center gap-[10px] text-neutral-05 dark:text-main-01 dark:data-[state=active]:text-main-01 dark:data-[state=active]:border-main-01 dark:data-[state=inactive]:text-neutral-05 w-fit",
                                onClick: ()=>handleChangeTab(ENUM_PARTNER_TAB.TRANSACTION_MANAGER),
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    children: t("profile.tab_transaction")
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(tabs/* TabsTrigger */.SP, {
                                value: ENUM_PARTNER_TAB.PARTNER_SETTING,
                                className: "flex items-center gap-[10px] text-neutral-05 dark:text-main-01 dark:data-[state=active]:text-main-01 dark:data-[state=active]:border-main-01 dark:data-[state=inactive]:text-neutral-05 w-fit",
                                onClick: ()=>handleChangeTab(ENUM_PARTNER_TAB.PARTNER_SETTING),
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    children: t("profile.tab_setting")
                                })
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "mt-0 border-t-[1px] border-[#000]/[.1] w-full dark:border-[#706E7E]",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(tabs/* TabsContent */.nU, {
                            value: ENUM_PARTNER_TAB.PARTNER_POST,
                            className: "lg:[927px] 2xl:w-[1075px]",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(PartnerPost, {})
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(tabs/* TabsContent */.nU, {
                            value: ENUM_PARTNER_TAB.PARTNER_ANALYTIC,
                            className: "lg:[927px] 2xl:w-[1075px]",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(PartnerAnalytic, {})
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(tabs/* TabsContent */.nU, {
                            value: ENUM_PARTNER_TAB.TRANSACTION_MANAGER,
                            className: "w-full lg:[927px] 2xl:w-[1075px]",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ParterTransactionManager, {})
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(tabs/* TabsContent */.nU, {
                            value: ENUM_PARTNER_TAB.PARTNER_SETTING,
                            className: "lg:[927px] 2xl:w-[1075px]",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(PartnerSetting, {})
                        })
                    ]
                })
            ]
        })
    });
};


/***/ }),

/***/ 95513:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "I": function() { return /* binding */ AppContext; },
/* harmony export */   "w": function() { return /* binding */ AppProvider; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(41844);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(55784);


const AppContext = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_1__.createContext)({
    themeApp: "light",
    setThemeApp: ()=>{},
    userInfo: {},
    setUserInfo: ()=>{},
    unReadCount: 0,
    setUnReadCount: ()=>{},
    openModal: null,
    setOpenModal: ()=>{},
    visibleGiftcodeDetail: false,
    setVisibleGiftcodeDetail: ()=>{},
    visibleUseGiftcode: false,
    setVisibleUseGiftcode: ()=>{},
    selectedGiftcode: {},
    setSelectedGiftcode: ()=>{}
});
const AppProvider = (param)=>{
    let { children  } = param;
    const [theme, setTheme] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)("light");
    const [unReadCount, setUnReadCount] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(0);
    const [userInfo, setUserInfo] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)({});
    const [openModal, setOpenModal] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(null);
    const [visibleGiftcodeDetail, setVisibleGiftcodeDetail] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false);
    const [visibleUseGiftcode, setVisibleUseGiftcode] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false);
    const [selectedGiftcode, setSelectedGiftcode] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)({});
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(AppContext.Provider, {
        value: {
            themeApp: theme,
            setThemeApp: setTheme,
            userInfo,
            setUserInfo,
            unReadCount,
            setUnReadCount,
            openModal,
            setOpenModal,
            visibleGiftcodeDetail,
            setVisibleGiftcodeDetail,
            selectedGiftcode,
            setSelectedGiftcode,
            visibleUseGiftcode,
            setVisibleUseGiftcode
        },
        children: children
    });
};


/***/ }),

/***/ 61983:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "M": function() { return /* binding */ PackageContext; },
/* harmony export */   "q": function() { return /* binding */ PackageProvider; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(41844);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(55784);


const PackageContext = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_1__.createContext)({
    preview: {
        src: "",
        open: false
    },
    visible: {
        avatarSuccess: false,
        view: false,
        appotaDetail: false,
        confirmGiftcode: false,
        iewGiftcode: false,
        viewSticker: false,
        viewFriend: false,
        sendSuccess: false
    },
    setVisible: ()=>{},
    setPreview: ()=>{},
    setDataSelected: ()=>{},
    dataSelected: undefined,
    selectedFriend: undefined,
    setSelectedFriend: ()=>{}
});
const PackageProvider = (param)=>{
    let { children  } = param;
    const [preview, setPreview] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)({
        src: "",
        open: false
    });
    const [visible, setVisible] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)({
        avatarSuccess: false,
        view: false,
        appotaDetail: false,
        confirmGiftcode: false,
        viewGiftcode: false,
        viewSticker: false,
        viewFriend: false,
        sendSuccess: false
    });
    const [dataSelected, setDataSelected] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)();
    const [selectedFriend, setSelectedFriend] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)();
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(PackageContext.Provider, {
        value: {
            dataSelected: dataSelected,
            setDataSelected: setDataSelected,
            visible,
            setVisible,
            preview,
            setPreview,
            selectedFriend,
            setSelectedFriend
        },
        children: children
    });
};


/***/ }),

/***/ 9378:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "l": function() { return /* binding */ RewardProvider; },
/* harmony export */   "w": function() { return /* binding */ RewardContext; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(41844);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(55784);
/* harmony import */ var _services_services__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(27020);
/* harmony import */ var _configs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(54254);




const RewardContext = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_1__.createContext)({
    pointReward: 0,
    setPointReward: ()=>{},
    getPoint: ()=>{}
});
const RewardProvider = (param)=>{
    let { children  } = param;
    const [pointReward, setPointReward] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(0);
    const accessToken = _configs__WEBPACK_IMPORTED_MODULE_3__/* .isClient */ .C5 ? window.localStorage.getItem("token") : null;
    const getData = async ()=>{
        await _services_services__WEBPACK_IMPORTED_MODULE_2__/* .UserService.getUserPoint */ .K.getUserPoint().then((resp)=>{
            setPointReward(resp.data.data.point);
        }).catch((e)=>console.log(e));
    };
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(()=>{
        if (accessToken) {
            getData();
        }
    }, [
        accessToken
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(RewardContext.Provider, {
        value: {
            pointReward: pointReward,
            setPointReward: setPointReward,
            getPoint: getData
        },
        children: children
    });
};


/***/ }),

/***/ 17986:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Il": function() { return /* reexport */ AppContext/* AppContext */.I; },
  "wI": function() { return /* reexport */ AppContext/* AppProvider */.w; },
  "zw": function() { return /* reexport */ MobileContext; },
  "eP": function() { return /* reexport */ MobileProvider; },
  "f6": function() { return /* reexport */ ThemeProvider; }
});

// EXTERNAL MODULE: ./node_modules/next/dist/compiled/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(41844);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/react/index.js
var react = __webpack_require__(55784);
;// CONCATENATED MODULE: ./app/context/MobileContext.tsx


const MobileContext = /*#__PURE__*/ (0,react.createContext)({
    isMobile: false,
    mobileOS: null,
    isHorizontalIpad: false,
    setIsHorizontalIpad: ()=>{}
});
const MobileProvider = (param)=>{
    let { children  } = param;
    const [isMobile, setIsMobile] = (0,react.useState)(false);
    const [mobileOS, setmobileOS] = (0,react.useState)(null);
    const [isHorizontalIpad, setIsHorizontalIpad] = (0,react.useState)(false);
    (0,react.useEffect)(()=>{
        const userAgent = navigator.userAgent;
        setIsMobile(/iPhone|iPad|iPod|Android/i.test(userAgent));
        setmobileOS(getmobileOS(userAgent));
    }, []);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(MobileContext.Provider, {
        value: {
            isMobile,
            mobileOS,
            isHorizontalIpad,
            setIsHorizontalIpad
        },
        children: children
    });
};
const getmobileOS = (userAgent)=>{
    if (/Android/i.test(userAgent)) {
        return "Android";
    }
    if (/iPhone|iPad|iPod/i.test(userAgent)) {
        return "iOS";
    }
    return "PC";
};

// EXTERNAL MODULE: ./app/context/AppContext.tsx
var AppContext = __webpack_require__(95513);
// EXTERNAL MODULE: ./node_modules/next-themes/dist/index.module.js
var index_module = __webpack_require__(82010);
;// CONCATENATED MODULE: ./app/context/ThemeProvider.tsx



function ThemeProvider(param) {
    let { children , ...props } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(index_module/* ThemeProvider */.f, {
        ...props,
        children: children
    });
}

;// CONCATENATED MODULE: ./app/context/index.ts





/***/ }),

/***/ 4203:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "mr": function() { return /* binding */ checkImage; },
  "ti": function() { return /* binding */ createSlugNameDetail; },
  "oc": function() { return /* binding */ extractText; },
  "uf": function() { return /* binding */ formatNumber; },
  "y3": function() { return /* binding */ getBase64; },
  "ZZ": function() { return /* binding */ getCdnImage; },
  "z$": function() { return /* binding */ getTimeBySubtract; },
  "qz": function() { return /* binding */ modifiedStyleLinkDecoration; },
  "K2": function() { return /* binding */ removeInlineStylesAndClasses; },
  "jo": function() { return /* binding */ removeStyle; },
  "CQ": function() { return /* binding */ removeVietnameseTones; },
  "g6": function() { return /* binding */ timeFormatter; }
});

// UNUSED EXPORTS: dateTimeFormatter, removeAttributes, timeAgoFormatter

// EXTERNAL MODULE: ./node_modules/moment/moment.js
var moment = __webpack_require__(30381);
var moment_default = /*#__PURE__*/__webpack_require__.n(moment);
// EXTERNAL MODULE: ./node_modules/moment/locale/vi.js
var vi = __webpack_require__(65666);
// EXTERNAL MODULE: ./node_modules/next-i18next/dist/esm/index.js + 41 modules
var esm = __webpack_require__(93378);
;// CONCATENATED MODULE: ./node_modules/entities/lib/esm/generated/decode-data-html.js
// Generated using scripts/write-decode-map.ts
/* harmony default export */ var decode_data_html = (new Uint16Array(
// prettier-ignore
"\u1d41<\xd5\u0131\u028a\u049d\u057b\u05d0\u0675\u06de\u07a2\u07d6\u080f\u0a4a\u0a91\u0da1\u0e6d\u0f09\u0f26\u10ca\u1228\u12e1\u1415\u149d\u14c3\u14df\u1525\0\0\0\0\0\0\u156b\u16cd\u198d\u1c12\u1ddd\u1f7e\u2060\u21b0\u228d\u23c0\u23fb\u2442\u2824\u2912\u2d08\u2e48\u2fce\u3016\u32ba\u3639\u37ac\u38fe\u3a28\u3a71\u3ae0\u3b2e\u0800EMabcfglmnoprstu\\bfms\x7f\x84\x8b\x90\x95\x98\xa6\xb3\xb9\xc8\xcflig\u803b\xc6\u40c6P\u803b&\u4026cute\u803b\xc1\u40c1reve;\u4102\u0100iyx}rc\u803b\xc2\u40c2;\u4410r;\uc000\ud835\udd04rave\u803b\xc0\u40c0pha;\u4391acr;\u4100d;\u6a53\u0100gp\x9d\xa1on;\u4104f;\uc000\ud835\udd38plyFunction;\u6061ing\u803b\xc5\u40c5\u0100cs\xbe\xc3r;\uc000\ud835\udc9cign;\u6254ilde\u803b\xc3\u40c3ml\u803b\xc4\u40c4\u0400aceforsu\xe5\xfb\xfe\u0117\u011c\u0122\u0127\u012a\u0100cr\xea\xf2kslash;\u6216\u0176\xf6\xf8;\u6ae7ed;\u6306y;\u4411\u0180crt\u0105\u010b\u0114ause;\u6235noullis;\u612ca;\u4392r;\uc000\ud835\udd05pf;\uc000\ud835\udd39eve;\u42d8c\xf2\u0113mpeq;\u624e\u0700HOacdefhilorsu\u014d\u0151\u0156\u0180\u019e\u01a2\u01b5\u01b7\u01ba\u01dc\u0215\u0273\u0278\u027ecy;\u4427PY\u803b\xa9\u40a9\u0180cpy\u015d\u0162\u017aute;\u4106\u0100;i\u0167\u0168\u62d2talDifferentialD;\u6145leys;\u612d\u0200aeio\u0189\u018e\u0194\u0198ron;\u410cdil\u803b\xc7\u40c7rc;\u4108nint;\u6230ot;\u410a\u0100dn\u01a7\u01adilla;\u40b8terDot;\u40b7\xf2\u017fi;\u43a7rcle\u0200DMPT\u01c7\u01cb\u01d1\u01d6ot;\u6299inus;\u6296lus;\u6295imes;\u6297o\u0100cs\u01e2\u01f8kwiseContourIntegral;\u6232eCurly\u0100DQ\u0203\u020foubleQuote;\u601duote;\u6019\u0200lnpu\u021e\u0228\u0247\u0255on\u0100;e\u0225\u0226\u6237;\u6a74\u0180git\u022f\u0236\u023aruent;\u6261nt;\u622fourIntegral;\u622e\u0100fr\u024c\u024e;\u6102oduct;\u6210nterClockwiseContourIntegral;\u6233oss;\u6a2fcr;\uc000\ud835\udc9ep\u0100;C\u0284\u0285\u62d3ap;\u624d\u0580DJSZacefios\u02a0\u02ac\u02b0\u02b4\u02b8\u02cb\u02d7\u02e1\u02e6\u0333\u048d\u0100;o\u0179\u02a5trahd;\u6911cy;\u4402cy;\u4405cy;\u440f\u0180grs\u02bf\u02c4\u02c7ger;\u6021r;\u61a1hv;\u6ae4\u0100ay\u02d0\u02d5ron;\u410e;\u4414l\u0100;t\u02dd\u02de\u6207a;\u4394r;\uc000\ud835\udd07\u0100af\u02eb\u0327\u0100cm\u02f0\u0322ritical\u0200ADGT\u0300\u0306\u0316\u031ccute;\u40b4o\u0174\u030b\u030d;\u42d9bleAcute;\u42ddrave;\u4060ilde;\u42dcond;\u62c4ferentialD;\u6146\u0470\u033d\0\0\0\u0342\u0354\0\u0405f;\uc000\ud835\udd3b\u0180;DE\u0348\u0349\u034d\u40a8ot;\u60dcqual;\u6250ble\u0300CDLRUV\u0363\u0372\u0382\u03cf\u03e2\u03f8ontourIntegra\xec\u0239o\u0274\u0379\0\0\u037b\xbb\u0349nArrow;\u61d3\u0100eo\u0387\u03a4ft\u0180ART\u0390\u0396\u03a1rrow;\u61d0ightArrow;\u61d4e\xe5\u02cang\u0100LR\u03ab\u03c4eft\u0100AR\u03b3\u03b9rrow;\u67f8ightArrow;\u67faightArrow;\u67f9ight\u0100AT\u03d8\u03derrow;\u61d2ee;\u62a8p\u0241\u03e9\0\0\u03efrrow;\u61d1ownArrow;\u61d5erticalBar;\u6225n\u0300ABLRTa\u0412\u042a\u0430\u045e\u047f\u037crrow\u0180;BU\u041d\u041e\u0422\u6193ar;\u6913pArrow;\u61f5reve;\u4311eft\u02d2\u043a\0\u0446\0\u0450ightVector;\u6950eeVector;\u695eector\u0100;B\u0459\u045a\u61bdar;\u6956ight\u01d4\u0467\0\u0471eeVector;\u695fector\u0100;B\u047a\u047b\u61c1ar;\u6957ee\u0100;A\u0486\u0487\u62a4rrow;\u61a7\u0100ct\u0492\u0497r;\uc000\ud835\udc9frok;\u4110\u0800NTacdfglmopqstux\u04bd\u04c0\u04c4\u04cb\u04de\u04e2\u04e7\u04ee\u04f5\u0521\u052f\u0536\u0552\u055d\u0560\u0565G;\u414aH\u803b\xd0\u40d0cute\u803b\xc9\u40c9\u0180aiy\u04d2\u04d7\u04dcron;\u411arc\u803b\xca\u40ca;\u442dot;\u4116r;\uc000\ud835\udd08rave\u803b\xc8\u40c8ement;\u6208\u0100ap\u04fa\u04fecr;\u4112ty\u0253\u0506\0\0\u0512mallSquare;\u65fberySmallSquare;\u65ab\u0100gp\u0526\u052aon;\u4118f;\uc000\ud835\udd3csilon;\u4395u\u0100ai\u053c\u0549l\u0100;T\u0542\u0543\u6a75ilde;\u6242librium;\u61cc\u0100ci\u0557\u055ar;\u6130m;\u6a73a;\u4397ml\u803b\xcb\u40cb\u0100ip\u056a\u056fsts;\u6203onentialE;\u6147\u0280cfios\u0585\u0588\u058d\u05b2\u05ccy;\u4424r;\uc000\ud835\udd09lled\u0253\u0597\0\0\u05a3mallSquare;\u65fcerySmallSquare;\u65aa\u0370\u05ba\0\u05bf\0\0\u05c4f;\uc000\ud835\udd3dAll;\u6200riertrf;\u6131c\xf2\u05cb\u0600JTabcdfgorst\u05e8\u05ec\u05ef\u05fa\u0600\u0612\u0616\u061b\u061d\u0623\u066c\u0672cy;\u4403\u803b>\u403emma\u0100;d\u05f7\u05f8\u4393;\u43dcreve;\u411e\u0180eiy\u0607\u060c\u0610dil;\u4122rc;\u411c;\u4413ot;\u4120r;\uc000\ud835\udd0a;\u62d9pf;\uc000\ud835\udd3eeater\u0300EFGLST\u0635\u0644\u064e\u0656\u065b\u0666qual\u0100;L\u063e\u063f\u6265ess;\u62dbullEqual;\u6267reater;\u6aa2ess;\u6277lantEqual;\u6a7eilde;\u6273cr;\uc000\ud835\udca2;\u626b\u0400Aacfiosu\u0685\u068b\u0696\u069b\u069e\u06aa\u06be\u06caRDcy;\u442a\u0100ct\u0690\u0694ek;\u42c7;\u405eirc;\u4124r;\u610clbertSpace;\u610b\u01f0\u06af\0\u06b2f;\u610dizontalLine;\u6500\u0100ct\u06c3\u06c5\xf2\u06a9rok;\u4126mp\u0144\u06d0\u06d8ownHum\xf0\u012fqual;\u624f\u0700EJOacdfgmnostu\u06fa\u06fe\u0703\u0707\u070e\u071a\u071e\u0721\u0728\u0744\u0778\u078b\u078f\u0795cy;\u4415lig;\u4132cy;\u4401cute\u803b\xcd\u40cd\u0100iy\u0713\u0718rc\u803b\xce\u40ce;\u4418ot;\u4130r;\u6111rave\u803b\xcc\u40cc\u0180;ap\u0720\u072f\u073f\u0100cg\u0734\u0737r;\u412ainaryI;\u6148lie\xf3\u03dd\u01f4\u0749\0\u0762\u0100;e\u074d\u074e\u622c\u0100gr\u0753\u0758ral;\u622bsection;\u62c2isible\u0100CT\u076c\u0772omma;\u6063imes;\u6062\u0180gpt\u077f\u0783\u0788on;\u412ef;\uc000\ud835\udd40a;\u4399cr;\u6110ilde;\u4128\u01eb\u079a\0\u079ecy;\u4406l\u803b\xcf\u40cf\u0280cfosu\u07ac\u07b7\u07bc\u07c2\u07d0\u0100iy\u07b1\u07b5rc;\u4134;\u4419r;\uc000\ud835\udd0dpf;\uc000\ud835\udd41\u01e3\u07c7\0\u07ccr;\uc000\ud835\udca5rcy;\u4408kcy;\u4404\u0380HJacfos\u07e4\u07e8\u07ec\u07f1\u07fd\u0802\u0808cy;\u4425cy;\u440cppa;\u439a\u0100ey\u07f6\u07fbdil;\u4136;\u441ar;\uc000\ud835\udd0epf;\uc000\ud835\udd42cr;\uc000\ud835\udca6\u0580JTaceflmost\u0825\u0829\u082c\u0850\u0863\u09b3\u09b8\u09c7\u09cd\u0a37\u0a47cy;\u4409\u803b<\u403c\u0280cmnpr\u0837\u083c\u0841\u0844\u084dute;\u4139bda;\u439bg;\u67ealacetrf;\u6112r;\u619e\u0180aey\u0857\u085c\u0861ron;\u413ddil;\u413b;\u441b\u0100fs\u0868\u0970t\u0500ACDFRTUVar\u087e\u08a9\u08b1\u08e0\u08e6\u08fc\u092f\u095b\u0390\u096a\u0100nr\u0883\u088fgleBracket;\u67e8row\u0180;BR\u0899\u089a\u089e\u6190ar;\u61e4ightArrow;\u61c6eiling;\u6308o\u01f5\u08b7\0\u08c3bleBracket;\u67e6n\u01d4\u08c8\0\u08d2eeVector;\u6961ector\u0100;B\u08db\u08dc\u61c3ar;\u6959loor;\u630aight\u0100AV\u08ef\u08f5rrow;\u6194ector;\u694e\u0100er\u0901\u0917e\u0180;AV\u0909\u090a\u0910\u62a3rrow;\u61a4ector;\u695aiangle\u0180;BE\u0924\u0925\u0929\u62b2ar;\u69cfqual;\u62b4p\u0180DTV\u0937\u0942\u094cownVector;\u6951eeVector;\u6960ector\u0100;B\u0956\u0957\u61bfar;\u6958ector\u0100;B\u0965\u0966\u61bcar;\u6952ight\xe1\u039cs\u0300EFGLST\u097e\u098b\u0995\u099d\u09a2\u09adqualGreater;\u62daullEqual;\u6266reater;\u6276ess;\u6aa1lantEqual;\u6a7dilde;\u6272r;\uc000\ud835\udd0f\u0100;e\u09bd\u09be\u62d8ftarrow;\u61daidot;\u413f\u0180npw\u09d4\u0a16\u0a1bg\u0200LRlr\u09de\u09f7\u0a02\u0a10eft\u0100AR\u09e6\u09ecrrow;\u67f5ightArrow;\u67f7ightArrow;\u67f6eft\u0100ar\u03b3\u0a0aight\xe1\u03bfight\xe1\u03caf;\uc000\ud835\udd43er\u0100LR\u0a22\u0a2ceftArrow;\u6199ightArrow;\u6198\u0180cht\u0a3e\u0a40\u0a42\xf2\u084c;\u61b0rok;\u4141;\u626a\u0400acefiosu\u0a5a\u0a5d\u0a60\u0a77\u0a7c\u0a85\u0a8b\u0a8ep;\u6905y;\u441c\u0100dl\u0a65\u0a6fiumSpace;\u605flintrf;\u6133r;\uc000\ud835\udd10nusPlus;\u6213pf;\uc000\ud835\udd44c\xf2\u0a76;\u439c\u0480Jacefostu\u0aa3\u0aa7\u0aad\u0ac0\u0b14\u0b19\u0d91\u0d97\u0d9ecy;\u440acute;\u4143\u0180aey\u0ab4\u0ab9\u0aberon;\u4147dil;\u4145;\u441d\u0180gsw\u0ac7\u0af0\u0b0eative\u0180MTV\u0ad3\u0adf\u0ae8ediumSpace;\u600bhi\u0100cn\u0ae6\u0ad8\xeb\u0ad9eryThi\xee\u0ad9ted\u0100GL\u0af8\u0b06reaterGreate\xf2\u0673essLes\xf3\u0a48Line;\u400ar;\uc000\ud835\udd11\u0200Bnpt\u0b22\u0b28\u0b37\u0b3areak;\u6060BreakingSpace;\u40a0f;\u6115\u0680;CDEGHLNPRSTV\u0b55\u0b56\u0b6a\u0b7c\u0ba1\u0beb\u0c04\u0c5e\u0c84\u0ca6\u0cd8\u0d61\u0d85\u6aec\u0100ou\u0b5b\u0b64ngruent;\u6262pCap;\u626doubleVerticalBar;\u6226\u0180lqx\u0b83\u0b8a\u0b9bement;\u6209ual\u0100;T\u0b92\u0b93\u6260ilde;\uc000\u2242\u0338ists;\u6204reater\u0380;EFGLST\u0bb6\u0bb7\u0bbd\u0bc9\u0bd3\u0bd8\u0be5\u626fqual;\u6271ullEqual;\uc000\u2267\u0338reater;\uc000\u226b\u0338ess;\u6279lantEqual;\uc000\u2a7e\u0338ilde;\u6275ump\u0144\u0bf2\u0bfdownHump;\uc000\u224e\u0338qual;\uc000\u224f\u0338e\u0100fs\u0c0a\u0c27tTriangle\u0180;BE\u0c1a\u0c1b\u0c21\u62eaar;\uc000\u29cf\u0338qual;\u62ecs\u0300;EGLST\u0c35\u0c36\u0c3c\u0c44\u0c4b\u0c58\u626equal;\u6270reater;\u6278ess;\uc000\u226a\u0338lantEqual;\uc000\u2a7d\u0338ilde;\u6274ested\u0100GL\u0c68\u0c79reaterGreater;\uc000\u2aa2\u0338essLess;\uc000\u2aa1\u0338recedes\u0180;ES\u0c92\u0c93\u0c9b\u6280qual;\uc000\u2aaf\u0338lantEqual;\u62e0\u0100ei\u0cab\u0cb9verseElement;\u620cghtTriangle\u0180;BE\u0ccb\u0ccc\u0cd2\u62ebar;\uc000\u29d0\u0338qual;\u62ed\u0100qu\u0cdd\u0d0cuareSu\u0100bp\u0ce8\u0cf9set\u0100;E\u0cf0\u0cf3\uc000\u228f\u0338qual;\u62e2erset\u0100;E\u0d03\u0d06\uc000\u2290\u0338qual;\u62e3\u0180bcp\u0d13\u0d24\u0d4eset\u0100;E\u0d1b\u0d1e\uc000\u2282\u20d2qual;\u6288ceeds\u0200;EST\u0d32\u0d33\u0d3b\u0d46\u6281qual;\uc000\u2ab0\u0338lantEqual;\u62e1ilde;\uc000\u227f\u0338erset\u0100;E\u0d58\u0d5b\uc000\u2283\u20d2qual;\u6289ilde\u0200;EFT\u0d6e\u0d6f\u0d75\u0d7f\u6241qual;\u6244ullEqual;\u6247ilde;\u6249erticalBar;\u6224cr;\uc000\ud835\udca9ilde\u803b\xd1\u40d1;\u439d\u0700Eacdfgmoprstuv\u0dbd\u0dc2\u0dc9\u0dd5\u0ddb\u0de0\u0de7\u0dfc\u0e02\u0e20\u0e22\u0e32\u0e3f\u0e44lig;\u4152cute\u803b\xd3\u40d3\u0100iy\u0dce\u0dd3rc\u803b\xd4\u40d4;\u441eblac;\u4150r;\uc000\ud835\udd12rave\u803b\xd2\u40d2\u0180aei\u0dee\u0df2\u0df6cr;\u414cga;\u43a9cron;\u439fpf;\uc000\ud835\udd46enCurly\u0100DQ\u0e0e\u0e1aoubleQuote;\u601cuote;\u6018;\u6a54\u0100cl\u0e27\u0e2cr;\uc000\ud835\udcaaash\u803b\xd8\u40d8i\u016c\u0e37\u0e3cde\u803b\xd5\u40d5es;\u6a37ml\u803b\xd6\u40d6er\u0100BP\u0e4b\u0e60\u0100ar\u0e50\u0e53r;\u603eac\u0100ek\u0e5a\u0e5c;\u63deet;\u63b4arenthesis;\u63dc\u0480acfhilors\u0e7f\u0e87\u0e8a\u0e8f\u0e92\u0e94\u0e9d\u0eb0\u0efcrtialD;\u6202y;\u441fr;\uc000\ud835\udd13i;\u43a6;\u43a0usMinus;\u40b1\u0100ip\u0ea2\u0eadncareplan\xe5\u069df;\u6119\u0200;eio\u0eb9\u0eba\u0ee0\u0ee4\u6abbcedes\u0200;EST\u0ec8\u0ec9\u0ecf\u0eda\u627aqual;\u6aaflantEqual;\u627cilde;\u627eme;\u6033\u0100dp\u0ee9\u0eeeuct;\u620fortion\u0100;a\u0225\u0ef9l;\u621d\u0100ci\u0f01\u0f06r;\uc000\ud835\udcab;\u43a8\u0200Ufos\u0f11\u0f16\u0f1b\u0f1fOT\u803b\"\u4022r;\uc000\ud835\udd14pf;\u611acr;\uc000\ud835\udcac\u0600BEacefhiorsu\u0f3e\u0f43\u0f47\u0f60\u0f73\u0fa7\u0faa\u0fad\u1096\u10a9\u10b4\u10bearr;\u6910G\u803b\xae\u40ae\u0180cnr\u0f4e\u0f53\u0f56ute;\u4154g;\u67ebr\u0100;t\u0f5c\u0f5d\u61a0l;\u6916\u0180aey\u0f67\u0f6c\u0f71ron;\u4158dil;\u4156;\u4420\u0100;v\u0f78\u0f79\u611cerse\u0100EU\u0f82\u0f99\u0100lq\u0f87\u0f8eement;\u620builibrium;\u61cbpEquilibrium;\u696fr\xbb\u0f79o;\u43a1ght\u0400ACDFTUVa\u0fc1\u0feb\u0ff3\u1022\u1028\u105b\u1087\u03d8\u0100nr\u0fc6\u0fd2gleBracket;\u67e9row\u0180;BL\u0fdc\u0fdd\u0fe1\u6192ar;\u61e5eftArrow;\u61c4eiling;\u6309o\u01f5\u0ff9\0\u1005bleBracket;\u67e7n\u01d4\u100a\0\u1014eeVector;\u695dector\u0100;B\u101d\u101e\u61c2ar;\u6955loor;\u630b\u0100er\u102d\u1043e\u0180;AV\u1035\u1036\u103c\u62a2rrow;\u61a6ector;\u695biangle\u0180;BE\u1050\u1051\u1055\u62b3ar;\u69d0qual;\u62b5p\u0180DTV\u1063\u106e\u1078ownVector;\u694feeVector;\u695cector\u0100;B\u1082\u1083\u61bear;\u6954ector\u0100;B\u1091\u1092\u61c0ar;\u6953\u0100pu\u109b\u109ef;\u611dndImplies;\u6970ightarrow;\u61db\u0100ch\u10b9\u10bcr;\u611b;\u61b1leDelayed;\u69f4\u0680HOacfhimoqstu\u10e4\u10f1\u10f7\u10fd\u1119\u111e\u1151\u1156\u1161\u1167\u11b5\u11bb\u11bf\u0100Cc\u10e9\u10eeHcy;\u4429y;\u4428FTcy;\u442ccute;\u415a\u0280;aeiy\u1108\u1109\u110e\u1113\u1117\u6abcron;\u4160dil;\u415erc;\u415c;\u4421r;\uc000\ud835\udd16ort\u0200DLRU\u112a\u1134\u113e\u1149ownArrow\xbb\u041eeftArrow\xbb\u089aightArrow\xbb\u0fddpArrow;\u6191gma;\u43a3allCircle;\u6218pf;\uc000\ud835\udd4a\u0272\u116d\0\0\u1170t;\u621aare\u0200;ISU\u117b\u117c\u1189\u11af\u65a1ntersection;\u6293u\u0100bp\u118f\u119eset\u0100;E\u1197\u1198\u628fqual;\u6291erset\u0100;E\u11a8\u11a9\u6290qual;\u6292nion;\u6294cr;\uc000\ud835\udcaear;\u62c6\u0200bcmp\u11c8\u11db\u1209\u120b\u0100;s\u11cd\u11ce\u62d0et\u0100;E\u11cd\u11d5qual;\u6286\u0100ch\u11e0\u1205eeds\u0200;EST\u11ed\u11ee\u11f4\u11ff\u627bqual;\u6ab0lantEqual;\u627dilde;\u627fTh\xe1\u0f8c;\u6211\u0180;es\u1212\u1213\u1223\u62d1rset\u0100;E\u121c\u121d\u6283qual;\u6287et\xbb\u1213\u0580HRSacfhiors\u123e\u1244\u1249\u1255\u125e\u1271\u1276\u129f\u12c2\u12c8\u12d1ORN\u803b\xde\u40deADE;\u6122\u0100Hc\u124e\u1252cy;\u440by;\u4426\u0100bu\u125a\u125c;\u4009;\u43a4\u0180aey\u1265\u126a\u126fron;\u4164dil;\u4162;\u4422r;\uc000\ud835\udd17\u0100ei\u127b\u1289\u01f2\u1280\0\u1287efore;\u6234a;\u4398\u0100cn\u128e\u1298kSpace;\uc000\u205f\u200aSpace;\u6009lde\u0200;EFT\u12ab\u12ac\u12b2\u12bc\u623cqual;\u6243ullEqual;\u6245ilde;\u6248pf;\uc000\ud835\udd4bipleDot;\u60db\u0100ct\u12d6\u12dbr;\uc000\ud835\udcafrok;\u4166\u0ae1\u12f7\u130e\u131a\u1326\0\u132c\u1331\0\0\0\0\0\u1338\u133d\u1377\u1385\0\u13ff\u1404\u140a\u1410\u0100cr\u12fb\u1301ute\u803b\xda\u40dar\u0100;o\u1307\u1308\u619fcir;\u6949r\u01e3\u1313\0\u1316y;\u440eve;\u416c\u0100iy\u131e\u1323rc\u803b\xdb\u40db;\u4423blac;\u4170r;\uc000\ud835\udd18rave\u803b\xd9\u40d9acr;\u416a\u0100di\u1341\u1369er\u0100BP\u1348\u135d\u0100ar\u134d\u1350r;\u405fac\u0100ek\u1357\u1359;\u63dfet;\u63b5arenthesis;\u63ddon\u0100;P\u1370\u1371\u62c3lus;\u628e\u0100gp\u137b\u137fon;\u4172f;\uc000\ud835\udd4c\u0400ADETadps\u1395\u13ae\u13b8\u13c4\u03e8\u13d2\u13d7\u13f3rrow\u0180;BD\u1150\u13a0\u13a4ar;\u6912ownArrow;\u61c5ownArrow;\u6195quilibrium;\u696eee\u0100;A\u13cb\u13cc\u62a5rrow;\u61a5own\xe1\u03f3er\u0100LR\u13de\u13e8eftArrow;\u6196ightArrow;\u6197i\u0100;l\u13f9\u13fa\u43d2on;\u43a5ing;\u416ecr;\uc000\ud835\udcb0ilde;\u4168ml\u803b\xdc\u40dc\u0480Dbcdefosv\u1427\u142c\u1430\u1433\u143e\u1485\u148a\u1490\u1496ash;\u62abar;\u6aeby;\u4412ash\u0100;l\u143b\u143c\u62a9;\u6ae6\u0100er\u1443\u1445;\u62c1\u0180bty\u144c\u1450\u147aar;\u6016\u0100;i\u144f\u1455cal\u0200BLST\u1461\u1465\u146a\u1474ar;\u6223ine;\u407ceparator;\u6758ilde;\u6240ThinSpace;\u600ar;\uc000\ud835\udd19pf;\uc000\ud835\udd4dcr;\uc000\ud835\udcb1dash;\u62aa\u0280cefos\u14a7\u14ac\u14b1\u14b6\u14bcirc;\u4174dge;\u62c0r;\uc000\ud835\udd1apf;\uc000\ud835\udd4ecr;\uc000\ud835\udcb2\u0200fios\u14cb\u14d0\u14d2\u14d8r;\uc000\ud835\udd1b;\u439epf;\uc000\ud835\udd4fcr;\uc000\ud835\udcb3\u0480AIUacfosu\u14f1\u14f5\u14f9\u14fd\u1504\u150f\u1514\u151a\u1520cy;\u442fcy;\u4407cy;\u442ecute\u803b\xdd\u40dd\u0100iy\u1509\u150drc;\u4176;\u442br;\uc000\ud835\udd1cpf;\uc000\ud835\udd50cr;\uc000\ud835\udcb4ml;\u4178\u0400Hacdefos\u1535\u1539\u153f\u154b\u154f\u155d\u1560\u1564cy;\u4416cute;\u4179\u0100ay\u1544\u1549ron;\u417d;\u4417ot;\u417b\u01f2\u1554\0\u155boWidt\xe8\u0ad9a;\u4396r;\u6128pf;\u6124cr;\uc000\ud835\udcb5\u0be1\u1583\u158a\u1590\0\u15b0\u15b6\u15bf\0\0\0\0\u15c6\u15db\u15eb\u165f\u166d\0\u1695\u169b\u16b2\u16b9\0\u16becute\u803b\xe1\u40e1reve;\u4103\u0300;Ediuy\u159c\u159d\u15a1\u15a3\u15a8\u15ad\u623e;\uc000\u223e\u0333;\u623frc\u803b\xe2\u40e2te\u80bb\xb4\u0306;\u4430lig\u803b\xe6\u40e6\u0100;r\xb2\u15ba;\uc000\ud835\udd1erave\u803b\xe0\u40e0\u0100ep\u15ca\u15d6\u0100fp\u15cf\u15d4sym;\u6135\xe8\u15d3ha;\u43b1\u0100ap\u15dfc\u0100cl\u15e4\u15e7r;\u4101g;\u6a3f\u0264\u15f0\0\0\u160a\u0280;adsv\u15fa\u15fb\u15ff\u1601\u1607\u6227nd;\u6a55;\u6a5clope;\u6a58;\u6a5a\u0380;elmrsz\u1618\u1619\u161b\u161e\u163f\u164f\u1659\u6220;\u69a4e\xbb\u1619sd\u0100;a\u1625\u1626\u6221\u0461\u1630\u1632\u1634\u1636\u1638\u163a\u163c\u163e;\u69a8;\u69a9;\u69aa;\u69ab;\u69ac;\u69ad;\u69ae;\u69aft\u0100;v\u1645\u1646\u621fb\u0100;d\u164c\u164d\u62be;\u699d\u0100pt\u1654\u1657h;\u6222\xbb\xb9arr;\u637c\u0100gp\u1663\u1667on;\u4105f;\uc000\ud835\udd52\u0380;Eaeiop\u12c1\u167b\u167d\u1682\u1684\u1687\u168a;\u6a70cir;\u6a6f;\u624ad;\u624bs;\u4027rox\u0100;e\u12c1\u1692\xf1\u1683ing\u803b\xe5\u40e5\u0180cty\u16a1\u16a6\u16a8r;\uc000\ud835\udcb6;\u402amp\u0100;e\u12c1\u16af\xf1\u0288ilde\u803b\xe3\u40e3ml\u803b\xe4\u40e4\u0100ci\u16c2\u16c8onin\xf4\u0272nt;\u6a11\u0800Nabcdefiklnoprsu\u16ed\u16f1\u1730\u173c\u1743\u1748\u1778\u177d\u17e0\u17e6\u1839\u1850\u170d\u193d\u1948\u1970ot;\u6aed\u0100cr\u16f6\u171ek\u0200ceps\u1700\u1705\u170d\u1713ong;\u624cpsilon;\u43f6rime;\u6035im\u0100;e\u171a\u171b\u623dq;\u62cd\u0176\u1722\u1726ee;\u62bded\u0100;g\u172c\u172d\u6305e\xbb\u172drk\u0100;t\u135c\u1737brk;\u63b6\u0100oy\u1701\u1741;\u4431quo;\u601e\u0280cmprt\u1753\u175b\u1761\u1764\u1768aus\u0100;e\u010a\u0109ptyv;\u69b0s\xe9\u170cno\xf5\u0113\u0180ahw\u176f\u1771\u1773;\u43b2;\u6136een;\u626cr;\uc000\ud835\udd1fg\u0380costuvw\u178d\u179d\u17b3\u17c1\u17d5\u17db\u17de\u0180aiu\u1794\u1796\u179a\xf0\u0760rc;\u65efp\xbb\u1371\u0180dpt\u17a4\u17a8\u17adot;\u6a00lus;\u6a01imes;\u6a02\u0271\u17b9\0\0\u17becup;\u6a06ar;\u6605riangle\u0100du\u17cd\u17d2own;\u65bdp;\u65b3plus;\u6a04e\xe5\u1444\xe5\u14adarow;\u690d\u0180ako\u17ed\u1826\u1835\u0100cn\u17f2\u1823k\u0180lst\u17fa\u05ab\u1802ozenge;\u69ebriangle\u0200;dlr\u1812\u1813\u1818\u181d\u65b4own;\u65beeft;\u65c2ight;\u65b8k;\u6423\u01b1\u182b\0\u1833\u01b2\u182f\0\u1831;\u6592;\u65914;\u6593ck;\u6588\u0100eo\u183e\u184d\u0100;q\u1843\u1846\uc000=\u20e5uiv;\uc000\u2261\u20e5t;\u6310\u0200ptwx\u1859\u185e\u1867\u186cf;\uc000\ud835\udd53\u0100;t\u13cb\u1863om\xbb\u13cctie;\u62c8\u0600DHUVbdhmptuv\u1885\u1896\u18aa\u18bb\u18d7\u18db\u18ec\u18ff\u1905\u190a\u1910\u1921\u0200LRlr\u188e\u1890\u1892\u1894;\u6557;\u6554;\u6556;\u6553\u0280;DUdu\u18a1\u18a2\u18a4\u18a6\u18a8\u6550;\u6566;\u6569;\u6564;\u6567\u0200LRlr\u18b3\u18b5\u18b7\u18b9;\u655d;\u655a;\u655c;\u6559\u0380;HLRhlr\u18ca\u18cb\u18cd\u18cf\u18d1\u18d3\u18d5\u6551;\u656c;\u6563;\u6560;\u656b;\u6562;\u655fox;\u69c9\u0200LRlr\u18e4\u18e6\u18e8\u18ea;\u6555;\u6552;\u6510;\u650c\u0280;DUdu\u06bd\u18f7\u18f9\u18fb\u18fd;\u6565;\u6568;\u652c;\u6534inus;\u629flus;\u629eimes;\u62a0\u0200LRlr\u1919\u191b\u191d\u191f;\u655b;\u6558;\u6518;\u6514\u0380;HLRhlr\u1930\u1931\u1933\u1935\u1937\u1939\u193b\u6502;\u656a;\u6561;\u655e;\u653c;\u6524;\u651c\u0100ev\u0123\u1942bar\u803b\xa6\u40a6\u0200ceio\u1951\u1956\u195a\u1960r;\uc000\ud835\udcb7mi;\u604fm\u0100;e\u171a\u171cl\u0180;bh\u1968\u1969\u196b\u405c;\u69c5sub;\u67c8\u016c\u1974\u197el\u0100;e\u1979\u197a\u6022t\xbb\u197ap\u0180;Ee\u012f\u1985\u1987;\u6aae\u0100;q\u06dc\u06db\u0ce1\u19a7\0\u19e8\u1a11\u1a15\u1a32\0\u1a37\u1a50\0\0\u1ab4\0\0\u1ac1\0\0\u1b21\u1b2e\u1b4d\u1b52\0\u1bfd\0\u1c0c\u0180cpr\u19ad\u19b2\u19ddute;\u4107\u0300;abcds\u19bf\u19c0\u19c4\u19ca\u19d5\u19d9\u6229nd;\u6a44rcup;\u6a49\u0100au\u19cf\u19d2p;\u6a4bp;\u6a47ot;\u6a40;\uc000\u2229\ufe00\u0100eo\u19e2\u19e5t;\u6041\xee\u0693\u0200aeiu\u19f0\u19fb\u1a01\u1a05\u01f0\u19f5\0\u19f8s;\u6a4don;\u410ddil\u803b\xe7\u40e7rc;\u4109ps\u0100;s\u1a0c\u1a0d\u6a4cm;\u6a50ot;\u410b\u0180dmn\u1a1b\u1a20\u1a26il\u80bb\xb8\u01adptyv;\u69b2t\u8100\xa2;e\u1a2d\u1a2e\u40a2r\xe4\u01b2r;\uc000\ud835\udd20\u0180cei\u1a3d\u1a40\u1a4dy;\u4447ck\u0100;m\u1a47\u1a48\u6713ark\xbb\u1a48;\u43c7r\u0380;Ecefms\u1a5f\u1a60\u1a62\u1a6b\u1aa4\u1aaa\u1aae\u65cb;\u69c3\u0180;el\u1a69\u1a6a\u1a6d\u42c6q;\u6257e\u0261\u1a74\0\0\u1a88rrow\u0100lr\u1a7c\u1a81eft;\u61baight;\u61bb\u0280RSacd\u1a92\u1a94\u1a96\u1a9a\u1a9f\xbb\u0f47;\u64c8st;\u629birc;\u629aash;\u629dnint;\u6a10id;\u6aefcir;\u69c2ubs\u0100;u\u1abb\u1abc\u6663it\xbb\u1abc\u02ec\u1ac7\u1ad4\u1afa\0\u1b0aon\u0100;e\u1acd\u1ace\u403a\u0100;q\xc7\xc6\u026d\u1ad9\0\0\u1ae2a\u0100;t\u1ade\u1adf\u402c;\u4040\u0180;fl\u1ae8\u1ae9\u1aeb\u6201\xee\u1160e\u0100mx\u1af1\u1af6ent\xbb\u1ae9e\xf3\u024d\u01e7\u1afe\0\u1b07\u0100;d\u12bb\u1b02ot;\u6a6dn\xf4\u0246\u0180fry\u1b10\u1b14\u1b17;\uc000\ud835\udd54o\xe4\u0254\u8100\xa9;s\u0155\u1b1dr;\u6117\u0100ao\u1b25\u1b29rr;\u61b5ss;\u6717\u0100cu\u1b32\u1b37r;\uc000\ud835\udcb8\u0100bp\u1b3c\u1b44\u0100;e\u1b41\u1b42\u6acf;\u6ad1\u0100;e\u1b49\u1b4a\u6ad0;\u6ad2dot;\u62ef\u0380delprvw\u1b60\u1b6c\u1b77\u1b82\u1bac\u1bd4\u1bf9arr\u0100lr\u1b68\u1b6a;\u6938;\u6935\u0270\u1b72\0\0\u1b75r;\u62dec;\u62dfarr\u0100;p\u1b7f\u1b80\u61b6;\u693d\u0300;bcdos\u1b8f\u1b90\u1b96\u1ba1\u1ba5\u1ba8\u622arcap;\u6a48\u0100au\u1b9b\u1b9ep;\u6a46p;\u6a4aot;\u628dr;\u6a45;\uc000\u222a\ufe00\u0200alrv\u1bb5\u1bbf\u1bde\u1be3rr\u0100;m\u1bbc\u1bbd\u61b7;\u693cy\u0180evw\u1bc7\u1bd4\u1bd8q\u0270\u1bce\0\0\u1bd2re\xe3\u1b73u\xe3\u1b75ee;\u62ceedge;\u62cfen\u803b\xa4\u40a4earrow\u0100lr\u1bee\u1bf3eft\xbb\u1b80ight\xbb\u1bbde\xe4\u1bdd\u0100ci\u1c01\u1c07onin\xf4\u01f7nt;\u6231lcty;\u632d\u0980AHabcdefhijlorstuwz\u1c38\u1c3b\u1c3f\u1c5d\u1c69\u1c75\u1c8a\u1c9e\u1cac\u1cb7\u1cfb\u1cff\u1d0d\u1d7b\u1d91\u1dab\u1dbb\u1dc6\u1dcdr\xf2\u0381ar;\u6965\u0200glrs\u1c48\u1c4d\u1c52\u1c54ger;\u6020eth;\u6138\xf2\u1133h\u0100;v\u1c5a\u1c5b\u6010\xbb\u090a\u016b\u1c61\u1c67arow;\u690fa\xe3\u0315\u0100ay\u1c6e\u1c73ron;\u410f;\u4434\u0180;ao\u0332\u1c7c\u1c84\u0100gr\u02bf\u1c81r;\u61catseq;\u6a77\u0180glm\u1c91\u1c94\u1c98\u803b\xb0\u40b0ta;\u43b4ptyv;\u69b1\u0100ir\u1ca3\u1ca8sht;\u697f;\uc000\ud835\udd21ar\u0100lr\u1cb3\u1cb5\xbb\u08dc\xbb\u101e\u0280aegsv\u1cc2\u0378\u1cd6\u1cdc\u1ce0m\u0180;os\u0326\u1cca\u1cd4nd\u0100;s\u0326\u1cd1uit;\u6666amma;\u43ddin;\u62f2\u0180;io\u1ce7\u1ce8\u1cf8\u40f7de\u8100\xf7;o\u1ce7\u1cf0ntimes;\u62c7n\xf8\u1cf7cy;\u4452c\u026f\u1d06\0\0\u1d0arn;\u631eop;\u630d\u0280lptuw\u1d18\u1d1d\u1d22\u1d49\u1d55lar;\u4024f;\uc000\ud835\udd55\u0280;emps\u030b\u1d2d\u1d37\u1d3d\u1d42q\u0100;d\u0352\u1d33ot;\u6251inus;\u6238lus;\u6214quare;\u62a1blebarwedg\xe5\xfan\u0180adh\u112e\u1d5d\u1d67ownarrow\xf3\u1c83arpoon\u0100lr\u1d72\u1d76ef\xf4\u1cb4igh\xf4\u1cb6\u0162\u1d7f\u1d85karo\xf7\u0f42\u026f\u1d8a\0\0\u1d8ern;\u631fop;\u630c\u0180cot\u1d98\u1da3\u1da6\u0100ry\u1d9d\u1da1;\uc000\ud835\udcb9;\u4455l;\u69f6rok;\u4111\u0100dr\u1db0\u1db4ot;\u62f1i\u0100;f\u1dba\u1816\u65bf\u0100ah\u1dc0\u1dc3r\xf2\u0429a\xf2\u0fa6angle;\u69a6\u0100ci\u1dd2\u1dd5y;\u445fgrarr;\u67ff\u0900Dacdefglmnopqrstux\u1e01\u1e09\u1e19\u1e38\u0578\u1e3c\u1e49\u1e61\u1e7e\u1ea5\u1eaf\u1ebd\u1ee1\u1f2a\u1f37\u1f44\u1f4e\u1f5a\u0100Do\u1e06\u1d34o\xf4\u1c89\u0100cs\u1e0e\u1e14ute\u803b\xe9\u40e9ter;\u6a6e\u0200aioy\u1e22\u1e27\u1e31\u1e36ron;\u411br\u0100;c\u1e2d\u1e2e\u6256\u803b\xea\u40ealon;\u6255;\u444dot;\u4117\u0100Dr\u1e41\u1e45ot;\u6252;\uc000\ud835\udd22\u0180;rs\u1e50\u1e51\u1e57\u6a9aave\u803b\xe8\u40e8\u0100;d\u1e5c\u1e5d\u6a96ot;\u6a98\u0200;ils\u1e6a\u1e6b\u1e72\u1e74\u6a99nters;\u63e7;\u6113\u0100;d\u1e79\u1e7a\u6a95ot;\u6a97\u0180aps\u1e85\u1e89\u1e97cr;\u4113ty\u0180;sv\u1e92\u1e93\u1e95\u6205et\xbb\u1e93p\u01001;\u1e9d\u1ea4\u0133\u1ea1\u1ea3;\u6004;\u6005\u6003\u0100gs\u1eaa\u1eac;\u414bp;\u6002\u0100gp\u1eb4\u1eb8on;\u4119f;\uc000\ud835\udd56\u0180als\u1ec4\u1ece\u1ed2r\u0100;s\u1eca\u1ecb\u62d5l;\u69e3us;\u6a71i\u0180;lv\u1eda\u1edb\u1edf\u43b5on\xbb\u1edb;\u43f5\u0200csuv\u1eea\u1ef3\u1f0b\u1f23\u0100io\u1eef\u1e31rc\xbb\u1e2e\u0269\u1ef9\0\0\u1efb\xed\u0548ant\u0100gl\u1f02\u1f06tr\xbb\u1e5dess\xbb\u1e7a\u0180aei\u1f12\u1f16\u1f1als;\u403dst;\u625fv\u0100;D\u0235\u1f20D;\u6a78parsl;\u69e5\u0100Da\u1f2f\u1f33ot;\u6253rr;\u6971\u0180cdi\u1f3e\u1f41\u1ef8r;\u612fo\xf4\u0352\u0100ah\u1f49\u1f4b;\u43b7\u803b\xf0\u40f0\u0100mr\u1f53\u1f57l\u803b\xeb\u40ebo;\u60ac\u0180cip\u1f61\u1f64\u1f67l;\u4021s\xf4\u056e\u0100eo\u1f6c\u1f74ctatio\xee\u0559nential\xe5\u0579\u09e1\u1f92\0\u1f9e\0\u1fa1\u1fa7\0\0\u1fc6\u1fcc\0\u1fd3\0\u1fe6\u1fea\u2000\0\u2008\u205allingdotse\xf1\u1e44y;\u4444male;\u6640\u0180ilr\u1fad\u1fb3\u1fc1lig;\u8000\ufb03\u0269\u1fb9\0\0\u1fbdg;\u8000\ufb00ig;\u8000\ufb04;\uc000\ud835\udd23lig;\u8000\ufb01lig;\uc000fj\u0180alt\u1fd9\u1fdc\u1fe1t;\u666dig;\u8000\ufb02ns;\u65b1of;\u4192\u01f0\u1fee\0\u1ff3f;\uc000\ud835\udd57\u0100ak\u05bf\u1ff7\u0100;v\u1ffc\u1ffd\u62d4;\u6ad9artint;\u6a0d\u0100ao\u200c\u2055\u0100cs\u2011\u2052\u03b1\u201a\u2030\u2038\u2045\u2048\0\u2050\u03b2\u2022\u2025\u2027\u202a\u202c\0\u202e\u803b\xbd\u40bd;\u6153\u803b\xbc\u40bc;\u6155;\u6159;\u615b\u01b3\u2034\0\u2036;\u6154;\u6156\u02b4\u203e\u2041\0\0\u2043\u803b\xbe\u40be;\u6157;\u615c5;\u6158\u01b6\u204c\0\u204e;\u615a;\u615d8;\u615el;\u6044wn;\u6322cr;\uc000\ud835\udcbb\u0880Eabcdefgijlnorstv\u2082\u2089\u209f\u20a5\u20b0\u20b4\u20f0\u20f5\u20fa\u20ff\u2103\u2112\u2138\u0317\u213e\u2152\u219e\u0100;l\u064d\u2087;\u6a8c\u0180cmp\u2090\u2095\u209dute;\u41f5ma\u0100;d\u209c\u1cda\u43b3;\u6a86reve;\u411f\u0100iy\u20aa\u20aerc;\u411d;\u4433ot;\u4121\u0200;lqs\u063e\u0642\u20bd\u20c9\u0180;qs\u063e\u064c\u20c4lan\xf4\u0665\u0200;cdl\u0665\u20d2\u20d5\u20e5c;\u6aa9ot\u0100;o\u20dc\u20dd\u6a80\u0100;l\u20e2\u20e3\u6a82;\u6a84\u0100;e\u20ea\u20ed\uc000\u22db\ufe00s;\u6a94r;\uc000\ud835\udd24\u0100;g\u0673\u061bmel;\u6137cy;\u4453\u0200;Eaj\u065a\u210c\u210e\u2110;\u6a92;\u6aa5;\u6aa4\u0200Eaes\u211b\u211d\u2129\u2134;\u6269p\u0100;p\u2123\u2124\u6a8arox\xbb\u2124\u0100;q\u212e\u212f\u6a88\u0100;q\u212e\u211bim;\u62e7pf;\uc000\ud835\udd58\u0100ci\u2143\u2146r;\u610am\u0180;el\u066b\u214e\u2150;\u6a8e;\u6a90\u8300>;cdlqr\u05ee\u2160\u216a\u216e\u2173\u2179\u0100ci\u2165\u2167;\u6aa7r;\u6a7aot;\u62d7Par;\u6995uest;\u6a7c\u0280adels\u2184\u216a\u2190\u0656\u219b\u01f0\u2189\0\u218epro\xf8\u209er;\u6978q\u0100lq\u063f\u2196les\xf3\u2088i\xed\u066b\u0100en\u21a3\u21adrtneqq;\uc000\u2269\ufe00\xc5\u21aa\u0500Aabcefkosy\u21c4\u21c7\u21f1\u21f5\u21fa\u2218\u221d\u222f\u2268\u227dr\xf2\u03a0\u0200ilmr\u21d0\u21d4\u21d7\u21dbrs\xf0\u1484f\xbb\u2024il\xf4\u06a9\u0100dr\u21e0\u21e4cy;\u444a\u0180;cw\u08f4\u21eb\u21efir;\u6948;\u61adar;\u610firc;\u4125\u0180alr\u2201\u220e\u2213rts\u0100;u\u2209\u220a\u6665it\xbb\u220alip;\u6026con;\u62b9r;\uc000\ud835\udd25s\u0100ew\u2223\u2229arow;\u6925arow;\u6926\u0280amopr\u223a\u223e\u2243\u225e\u2263rr;\u61fftht;\u623bk\u0100lr\u2249\u2253eftarrow;\u61a9ightarrow;\u61aaf;\uc000\ud835\udd59bar;\u6015\u0180clt\u226f\u2274\u2278r;\uc000\ud835\udcbdas\xe8\u21f4rok;\u4127\u0100bp\u2282\u2287ull;\u6043hen\xbb\u1c5b\u0ae1\u22a3\0\u22aa\0\u22b8\u22c5\u22ce\0\u22d5\u22f3\0\0\u22f8\u2322\u2367\u2362\u237f\0\u2386\u23aa\u23b4cute\u803b\xed\u40ed\u0180;iy\u0771\u22b0\u22b5rc\u803b\xee\u40ee;\u4438\u0100cx\u22bc\u22bfy;\u4435cl\u803b\xa1\u40a1\u0100fr\u039f\u22c9;\uc000\ud835\udd26rave\u803b\xec\u40ec\u0200;ino\u073e\u22dd\u22e9\u22ee\u0100in\u22e2\u22e6nt;\u6a0ct;\u622dfin;\u69dcta;\u6129lig;\u4133\u0180aop\u22fe\u231a\u231d\u0180cgt\u2305\u2308\u2317r;\u412b\u0180elp\u071f\u230f\u2313in\xe5\u078ear\xf4\u0720h;\u4131f;\u62b7ed;\u41b5\u0280;cfot\u04f4\u232c\u2331\u233d\u2341are;\u6105in\u0100;t\u2338\u2339\u621eie;\u69dddo\xf4\u2319\u0280;celp\u0757\u234c\u2350\u235b\u2361al;\u62ba\u0100gr\u2355\u2359er\xf3\u1563\xe3\u234darhk;\u6a17rod;\u6a3c\u0200cgpt\u236f\u2372\u2376\u237by;\u4451on;\u412ff;\uc000\ud835\udd5aa;\u43b9uest\u803b\xbf\u40bf\u0100ci\u238a\u238fr;\uc000\ud835\udcben\u0280;Edsv\u04f4\u239b\u239d\u23a1\u04f3;\u62f9ot;\u62f5\u0100;v\u23a6\u23a7\u62f4;\u62f3\u0100;i\u0777\u23aelde;\u4129\u01eb\u23b8\0\u23bccy;\u4456l\u803b\xef\u40ef\u0300cfmosu\u23cc\u23d7\u23dc\u23e1\u23e7\u23f5\u0100iy\u23d1\u23d5rc;\u4135;\u4439r;\uc000\ud835\udd27ath;\u4237pf;\uc000\ud835\udd5b\u01e3\u23ec\0\u23f1r;\uc000\ud835\udcbfrcy;\u4458kcy;\u4454\u0400acfghjos\u240b\u2416\u2422\u2427\u242d\u2431\u2435\u243bppa\u0100;v\u2413\u2414\u43ba;\u43f0\u0100ey\u241b\u2420dil;\u4137;\u443ar;\uc000\ud835\udd28reen;\u4138cy;\u4445cy;\u445cpf;\uc000\ud835\udd5ccr;\uc000\ud835\udcc0\u0b80ABEHabcdefghjlmnoprstuv\u2470\u2481\u2486\u248d\u2491\u250e\u253d\u255a\u2580\u264e\u265e\u2665\u2679\u267d\u269a\u26b2\u26d8\u275d\u2768\u278b\u27c0\u2801\u2812\u0180art\u2477\u247a\u247cr\xf2\u09c6\xf2\u0395ail;\u691barr;\u690e\u0100;g\u0994\u248b;\u6a8bar;\u6962\u0963\u24a5\0\u24aa\0\u24b1\0\0\0\0\0\u24b5\u24ba\0\u24c6\u24c8\u24cd\0\u24f9ute;\u413amptyv;\u69b4ra\xee\u084cbda;\u43bbg\u0180;dl\u088e\u24c1\u24c3;\u6991\xe5\u088e;\u6a85uo\u803b\xab\u40abr\u0400;bfhlpst\u0899\u24de\u24e6\u24e9\u24eb\u24ee\u24f1\u24f5\u0100;f\u089d\u24e3s;\u691fs;\u691d\xeb\u2252p;\u61abl;\u6939im;\u6973l;\u61a2\u0180;ae\u24ff\u2500\u2504\u6aabil;\u6919\u0100;s\u2509\u250a\u6aad;\uc000\u2aad\ufe00\u0180abr\u2515\u2519\u251drr;\u690crk;\u6772\u0100ak\u2522\u252cc\u0100ek\u2528\u252a;\u407b;\u405b\u0100es\u2531\u2533;\u698bl\u0100du\u2539\u253b;\u698f;\u698d\u0200aeuy\u2546\u254b\u2556\u2558ron;\u413e\u0100di\u2550\u2554il;\u413c\xec\u08b0\xe2\u2529;\u443b\u0200cqrs\u2563\u2566\u256d\u257da;\u6936uo\u0100;r\u0e19\u1746\u0100du\u2572\u2577har;\u6967shar;\u694bh;\u61b2\u0280;fgqs\u258b\u258c\u0989\u25f3\u25ff\u6264t\u0280ahlrt\u2598\u25a4\u25b7\u25c2\u25e8rrow\u0100;t\u0899\u25a1a\xe9\u24f6arpoon\u0100du\u25af\u25b4own\xbb\u045ap\xbb\u0966eftarrows;\u61c7ight\u0180ahs\u25cd\u25d6\u25derrow\u0100;s\u08f4\u08a7arpoon\xf3\u0f98quigarro\xf7\u21f0hreetimes;\u62cb\u0180;qs\u258b\u0993\u25falan\xf4\u09ac\u0280;cdgs\u09ac\u260a\u260d\u261d\u2628c;\u6aa8ot\u0100;o\u2614\u2615\u6a7f\u0100;r\u261a\u261b\u6a81;\u6a83\u0100;e\u2622\u2625\uc000\u22da\ufe00s;\u6a93\u0280adegs\u2633\u2639\u263d\u2649\u264bppro\xf8\u24c6ot;\u62d6q\u0100gq\u2643\u2645\xf4\u0989gt\xf2\u248c\xf4\u099bi\xed\u09b2\u0180ilr\u2655\u08e1\u265asht;\u697c;\uc000\ud835\udd29\u0100;E\u099c\u2663;\u6a91\u0161\u2669\u2676r\u0100du\u25b2\u266e\u0100;l\u0965\u2673;\u696alk;\u6584cy;\u4459\u0280;acht\u0a48\u2688\u268b\u2691\u2696r\xf2\u25c1orne\xf2\u1d08ard;\u696bri;\u65fa\u0100io\u269f\u26a4dot;\u4140ust\u0100;a\u26ac\u26ad\u63b0che\xbb\u26ad\u0200Eaes\u26bb\u26bd\u26c9\u26d4;\u6268p\u0100;p\u26c3\u26c4\u6a89rox\xbb\u26c4\u0100;q\u26ce\u26cf\u6a87\u0100;q\u26ce\u26bbim;\u62e6\u0400abnoptwz\u26e9\u26f4\u26f7\u271a\u272f\u2741\u2747\u2750\u0100nr\u26ee\u26f1g;\u67ecr;\u61fdr\xeb\u08c1g\u0180lmr\u26ff\u270d\u2714eft\u0100ar\u09e6\u2707ight\xe1\u09f2apsto;\u67fcight\xe1\u09fdparrow\u0100lr\u2725\u2729ef\xf4\u24edight;\u61ac\u0180afl\u2736\u2739\u273dr;\u6985;\uc000\ud835\udd5dus;\u6a2dimes;\u6a34\u0161\u274b\u274fst;\u6217\xe1\u134e\u0180;ef\u2757\u2758\u1800\u65cange\xbb\u2758ar\u0100;l\u2764\u2765\u4028t;\u6993\u0280achmt\u2773\u2776\u277c\u2785\u2787r\xf2\u08a8orne\xf2\u1d8car\u0100;d\u0f98\u2783;\u696d;\u600eri;\u62bf\u0300achiqt\u2798\u279d\u0a40\u27a2\u27ae\u27bbquo;\u6039r;\uc000\ud835\udcc1m\u0180;eg\u09b2\u27aa\u27ac;\u6a8d;\u6a8f\u0100bu\u252a\u27b3o\u0100;r\u0e1f\u27b9;\u601arok;\u4142\u8400<;cdhilqr\u082b\u27d2\u2639\u27dc\u27e0\u27e5\u27ea\u27f0\u0100ci\u27d7\u27d9;\u6aa6r;\u6a79re\xe5\u25f2mes;\u62c9arr;\u6976uest;\u6a7b\u0100Pi\u27f5\u27f9ar;\u6996\u0180;ef\u2800\u092d\u181b\u65c3r\u0100du\u2807\u280dshar;\u694ahar;\u6966\u0100en\u2817\u2821rtneqq;\uc000\u2268\ufe00\xc5\u281e\u0700Dacdefhilnopsu\u2840\u2845\u2882\u288e\u2893\u28a0\u28a5\u28a8\u28da\u28e2\u28e4\u0a83\u28f3\u2902Dot;\u623a\u0200clpr\u284e\u2852\u2863\u287dr\u803b\xaf\u40af\u0100et\u2857\u2859;\u6642\u0100;e\u285e\u285f\u6720se\xbb\u285f\u0100;s\u103b\u2868to\u0200;dlu\u103b\u2873\u2877\u287bow\xee\u048cef\xf4\u090f\xf0\u13d1ker;\u65ae\u0100oy\u2887\u288cmma;\u6a29;\u443cash;\u6014asuredangle\xbb\u1626r;\uc000\ud835\udd2ao;\u6127\u0180cdn\u28af\u28b4\u28c9ro\u803b\xb5\u40b5\u0200;acd\u1464\u28bd\u28c0\u28c4s\xf4\u16a7ir;\u6af0ot\u80bb\xb7\u01b5us\u0180;bd\u28d2\u1903\u28d3\u6212\u0100;u\u1d3c\u28d8;\u6a2a\u0163\u28de\u28e1p;\u6adb\xf2\u2212\xf0\u0a81\u0100dp\u28e9\u28eeels;\u62a7f;\uc000\ud835\udd5e\u0100ct\u28f8\u28fdr;\uc000\ud835\udcc2pos\xbb\u159d\u0180;lm\u2909\u290a\u290d\u43bctimap;\u62b8\u0c00GLRVabcdefghijlmoprstuvw\u2942\u2953\u297e\u2989\u2998\u29da\u29e9\u2a15\u2a1a\u2a58\u2a5d\u2a83\u2a95\u2aa4\u2aa8\u2b04\u2b07\u2b44\u2b7f\u2bae\u2c34\u2c67\u2c7c\u2ce9\u0100gt\u2947\u294b;\uc000\u22d9\u0338\u0100;v\u2950\u0bcf\uc000\u226b\u20d2\u0180elt\u295a\u2972\u2976ft\u0100ar\u2961\u2967rrow;\u61cdightarrow;\u61ce;\uc000\u22d8\u0338\u0100;v\u297b\u0c47\uc000\u226a\u20d2ightarrow;\u61cf\u0100Dd\u298e\u2993ash;\u62afash;\u62ae\u0280bcnpt\u29a3\u29a7\u29ac\u29b1\u29ccla\xbb\u02deute;\u4144g;\uc000\u2220\u20d2\u0280;Eiop\u0d84\u29bc\u29c0\u29c5\u29c8;\uc000\u2a70\u0338d;\uc000\u224b\u0338s;\u4149ro\xf8\u0d84ur\u0100;a\u29d3\u29d4\u666el\u0100;s\u29d3\u0b38\u01f3\u29df\0\u29e3p\u80bb\xa0\u0b37mp\u0100;e\u0bf9\u0c00\u0280aeouy\u29f4\u29fe\u2a03\u2a10\u2a13\u01f0\u29f9\0\u29fb;\u6a43on;\u4148dil;\u4146ng\u0100;d\u0d7e\u2a0aot;\uc000\u2a6d\u0338p;\u6a42;\u443dash;\u6013\u0380;Aadqsx\u0b92\u2a29\u2a2d\u2a3b\u2a41\u2a45\u2a50rr;\u61d7r\u0100hr\u2a33\u2a36k;\u6924\u0100;o\u13f2\u13f0ot;\uc000\u2250\u0338ui\xf6\u0b63\u0100ei\u2a4a\u2a4ear;\u6928\xed\u0b98ist\u0100;s\u0ba0\u0b9fr;\uc000\ud835\udd2b\u0200Eest\u0bc5\u2a66\u2a79\u2a7c\u0180;qs\u0bbc\u2a6d\u0be1\u0180;qs\u0bbc\u0bc5\u2a74lan\xf4\u0be2i\xed\u0bea\u0100;r\u0bb6\u2a81\xbb\u0bb7\u0180Aap\u2a8a\u2a8d\u2a91r\xf2\u2971rr;\u61aear;\u6af2\u0180;sv\u0f8d\u2a9c\u0f8c\u0100;d\u2aa1\u2aa2\u62fc;\u62facy;\u445a\u0380AEadest\u2ab7\u2aba\u2abe\u2ac2\u2ac5\u2af6\u2af9r\xf2\u2966;\uc000\u2266\u0338rr;\u619ar;\u6025\u0200;fqs\u0c3b\u2ace\u2ae3\u2aeft\u0100ar\u2ad4\u2ad9rro\xf7\u2ac1ightarro\xf7\u2a90\u0180;qs\u0c3b\u2aba\u2aealan\xf4\u0c55\u0100;s\u0c55\u2af4\xbb\u0c36i\xed\u0c5d\u0100;r\u0c35\u2afei\u0100;e\u0c1a\u0c25i\xe4\u0d90\u0100pt\u2b0c\u2b11f;\uc000\ud835\udd5f\u8180\xac;in\u2b19\u2b1a\u2b36\u40acn\u0200;Edv\u0b89\u2b24\u2b28\u2b2e;\uc000\u22f9\u0338ot;\uc000\u22f5\u0338\u01e1\u0b89\u2b33\u2b35;\u62f7;\u62f6i\u0100;v\u0cb8\u2b3c\u01e1\u0cb8\u2b41\u2b43;\u62fe;\u62fd\u0180aor\u2b4b\u2b63\u2b69r\u0200;ast\u0b7b\u2b55\u2b5a\u2b5flle\xec\u0b7bl;\uc000\u2afd\u20e5;\uc000\u2202\u0338lint;\u6a14\u0180;ce\u0c92\u2b70\u2b73u\xe5\u0ca5\u0100;c\u0c98\u2b78\u0100;e\u0c92\u2b7d\xf1\u0c98\u0200Aait\u2b88\u2b8b\u2b9d\u2ba7r\xf2\u2988rr\u0180;cw\u2b94\u2b95\u2b99\u619b;\uc000\u2933\u0338;\uc000\u219d\u0338ghtarrow\xbb\u2b95ri\u0100;e\u0ccb\u0cd6\u0380chimpqu\u2bbd\u2bcd\u2bd9\u2b04\u0b78\u2be4\u2bef\u0200;cer\u0d32\u2bc6\u0d37\u2bc9u\xe5\u0d45;\uc000\ud835\udcc3ort\u026d\u2b05\0\0\u2bd6ar\xe1\u2b56m\u0100;e\u0d6e\u2bdf\u0100;q\u0d74\u0d73su\u0100bp\u2beb\u2bed\xe5\u0cf8\xe5\u0d0b\u0180bcp\u2bf6\u2c11\u2c19\u0200;Ees\u2bff\u2c00\u0d22\u2c04\u6284;\uc000\u2ac5\u0338et\u0100;e\u0d1b\u2c0bq\u0100;q\u0d23\u2c00c\u0100;e\u0d32\u2c17\xf1\u0d38\u0200;Ees\u2c22\u2c23\u0d5f\u2c27\u6285;\uc000\u2ac6\u0338et\u0100;e\u0d58\u2c2eq\u0100;q\u0d60\u2c23\u0200gilr\u2c3d\u2c3f\u2c45\u2c47\xec\u0bd7lde\u803b\xf1\u40f1\xe7\u0c43iangle\u0100lr\u2c52\u2c5ceft\u0100;e\u0c1a\u2c5a\xf1\u0c26ight\u0100;e\u0ccb\u2c65\xf1\u0cd7\u0100;m\u2c6c\u2c6d\u43bd\u0180;es\u2c74\u2c75\u2c79\u4023ro;\u6116p;\u6007\u0480DHadgilrs\u2c8f\u2c94\u2c99\u2c9e\u2ca3\u2cb0\u2cb6\u2cd3\u2ce3ash;\u62adarr;\u6904p;\uc000\u224d\u20d2ash;\u62ac\u0100et\u2ca8\u2cac;\uc000\u2265\u20d2;\uc000>\u20d2nfin;\u69de\u0180Aet\u2cbd\u2cc1\u2cc5rr;\u6902;\uc000\u2264\u20d2\u0100;r\u2cca\u2ccd\uc000<\u20d2ie;\uc000\u22b4\u20d2\u0100At\u2cd8\u2cdcrr;\u6903rie;\uc000\u22b5\u20d2im;\uc000\u223c\u20d2\u0180Aan\u2cf0\u2cf4\u2d02rr;\u61d6r\u0100hr\u2cfa\u2cfdk;\u6923\u0100;o\u13e7\u13e5ear;\u6927\u1253\u1a95\0\0\0\0\0\0\0\0\0\0\0\0\0\u2d2d\0\u2d38\u2d48\u2d60\u2d65\u2d72\u2d84\u1b07\0\0\u2d8d\u2dab\0\u2dc8\u2dce\0\u2ddc\u2e19\u2e2b\u2e3e\u2e43\u0100cs\u2d31\u1a97ute\u803b\xf3\u40f3\u0100iy\u2d3c\u2d45r\u0100;c\u1a9e\u2d42\u803b\xf4\u40f4;\u443e\u0280abios\u1aa0\u2d52\u2d57\u01c8\u2d5alac;\u4151v;\u6a38old;\u69bclig;\u4153\u0100cr\u2d69\u2d6dir;\u69bf;\uc000\ud835\udd2c\u036f\u2d79\0\0\u2d7c\0\u2d82n;\u42dbave\u803b\xf2\u40f2;\u69c1\u0100bm\u2d88\u0df4ar;\u69b5\u0200acit\u2d95\u2d98\u2da5\u2da8r\xf2\u1a80\u0100ir\u2d9d\u2da0r;\u69beoss;\u69bbn\xe5\u0e52;\u69c0\u0180aei\u2db1\u2db5\u2db9cr;\u414dga;\u43c9\u0180cdn\u2dc0\u2dc5\u01cdron;\u43bf;\u69b6pf;\uc000\ud835\udd60\u0180ael\u2dd4\u2dd7\u01d2r;\u69b7rp;\u69b9\u0380;adiosv\u2dea\u2deb\u2dee\u2e08\u2e0d\u2e10\u2e16\u6228r\xf2\u1a86\u0200;efm\u2df7\u2df8\u2e02\u2e05\u6a5dr\u0100;o\u2dfe\u2dff\u6134f\xbb\u2dff\u803b\xaa\u40aa\u803b\xba\u40bagof;\u62b6r;\u6a56lope;\u6a57;\u6a5b\u0180clo\u2e1f\u2e21\u2e27\xf2\u2e01ash\u803b\xf8\u40f8l;\u6298i\u016c\u2e2f\u2e34de\u803b\xf5\u40f5es\u0100;a\u01db\u2e3as;\u6a36ml\u803b\xf6\u40f6bar;\u633d\u0ae1\u2e5e\0\u2e7d\0\u2e80\u2e9d\0\u2ea2\u2eb9\0\0\u2ecb\u0e9c\0\u2f13\0\0\u2f2b\u2fbc\0\u2fc8r\u0200;ast\u0403\u2e67\u2e72\u0e85\u8100\xb6;l\u2e6d\u2e6e\u40b6le\xec\u0403\u0269\u2e78\0\0\u2e7bm;\u6af3;\u6afdy;\u443fr\u0280cimpt\u2e8b\u2e8f\u2e93\u1865\u2e97nt;\u4025od;\u402eil;\u6030enk;\u6031r;\uc000\ud835\udd2d\u0180imo\u2ea8\u2eb0\u2eb4\u0100;v\u2ead\u2eae\u43c6;\u43d5ma\xf4\u0a76ne;\u660e\u0180;tv\u2ebf\u2ec0\u2ec8\u43c0chfork\xbb\u1ffd;\u43d6\u0100au\u2ecf\u2edfn\u0100ck\u2ed5\u2eddk\u0100;h\u21f4\u2edb;\u610e\xf6\u21f4s\u0480;abcdemst\u2ef3\u2ef4\u1908\u2ef9\u2efd\u2f04\u2f06\u2f0a\u2f0e\u402bcir;\u6a23ir;\u6a22\u0100ou\u1d40\u2f02;\u6a25;\u6a72n\u80bb\xb1\u0e9dim;\u6a26wo;\u6a27\u0180ipu\u2f19\u2f20\u2f25ntint;\u6a15f;\uc000\ud835\udd61nd\u803b\xa3\u40a3\u0500;Eaceinosu\u0ec8\u2f3f\u2f41\u2f44\u2f47\u2f81\u2f89\u2f92\u2f7e\u2fb6;\u6ab3p;\u6ab7u\xe5\u0ed9\u0100;c\u0ece\u2f4c\u0300;acens\u0ec8\u2f59\u2f5f\u2f66\u2f68\u2f7eppro\xf8\u2f43urlye\xf1\u0ed9\xf1\u0ece\u0180aes\u2f6f\u2f76\u2f7approx;\u6ab9qq;\u6ab5im;\u62e8i\xed\u0edfme\u0100;s\u2f88\u0eae\u6032\u0180Eas\u2f78\u2f90\u2f7a\xf0\u2f75\u0180dfp\u0eec\u2f99\u2faf\u0180als\u2fa0\u2fa5\u2faalar;\u632eine;\u6312urf;\u6313\u0100;t\u0efb\u2fb4\xef\u0efbrel;\u62b0\u0100ci\u2fc0\u2fc5r;\uc000\ud835\udcc5;\u43c8ncsp;\u6008\u0300fiopsu\u2fda\u22e2\u2fdf\u2fe5\u2feb\u2ff1r;\uc000\ud835\udd2epf;\uc000\ud835\udd62rime;\u6057cr;\uc000\ud835\udcc6\u0180aeo\u2ff8\u3009\u3013t\u0100ei\u2ffe\u3005rnion\xf3\u06b0nt;\u6a16st\u0100;e\u3010\u3011\u403f\xf1\u1f19\xf4\u0f14\u0a80ABHabcdefhilmnoprstux\u3040\u3051\u3055\u3059\u30e0\u310e\u312b\u3147\u3162\u3172\u318e\u3206\u3215\u3224\u3229\u3258\u326e\u3272\u3290\u32b0\u32b7\u0180art\u3047\u304a\u304cr\xf2\u10b3\xf2\u03ddail;\u691car\xf2\u1c65ar;\u6964\u0380cdenqrt\u3068\u3075\u3078\u307f\u308f\u3094\u30cc\u0100eu\u306d\u3071;\uc000\u223d\u0331te;\u4155i\xe3\u116emptyv;\u69b3g\u0200;del\u0fd1\u3089\u308b\u308d;\u6992;\u69a5\xe5\u0fd1uo\u803b\xbb\u40bbr\u0580;abcfhlpstw\u0fdc\u30ac\u30af\u30b7\u30b9\u30bc\u30be\u30c0\u30c3\u30c7\u30cap;\u6975\u0100;f\u0fe0\u30b4s;\u6920;\u6933s;\u691e\xeb\u225d\xf0\u272el;\u6945im;\u6974l;\u61a3;\u619d\u0100ai\u30d1\u30d5il;\u691ao\u0100;n\u30db\u30dc\u6236al\xf3\u0f1e\u0180abr\u30e7\u30ea\u30eer\xf2\u17e5rk;\u6773\u0100ak\u30f3\u30fdc\u0100ek\u30f9\u30fb;\u407d;\u405d\u0100es\u3102\u3104;\u698cl\u0100du\u310a\u310c;\u698e;\u6990\u0200aeuy\u3117\u311c\u3127\u3129ron;\u4159\u0100di\u3121\u3125il;\u4157\xec\u0ff2\xe2\u30fa;\u4440\u0200clqs\u3134\u3137\u313d\u3144a;\u6937dhar;\u6969uo\u0100;r\u020e\u020dh;\u61b3\u0180acg\u314e\u315f\u0f44l\u0200;ips\u0f78\u3158\u315b\u109cn\xe5\u10bbar\xf4\u0fa9t;\u65ad\u0180ilr\u3169\u1023\u316esht;\u697d;\uc000\ud835\udd2f\u0100ao\u3177\u3186r\u0100du\u317d\u317f\xbb\u047b\u0100;l\u1091\u3184;\u696c\u0100;v\u318b\u318c\u43c1;\u43f1\u0180gns\u3195\u31f9\u31fcht\u0300ahlrst\u31a4\u31b0\u31c2\u31d8\u31e4\u31eerrow\u0100;t\u0fdc\u31ada\xe9\u30c8arpoon\u0100du\u31bb\u31bfow\xee\u317ep\xbb\u1092eft\u0100ah\u31ca\u31d0rrow\xf3\u0feaarpoon\xf3\u0551ightarrows;\u61c9quigarro\xf7\u30cbhreetimes;\u62ccg;\u42daingdotse\xf1\u1f32\u0180ahm\u320d\u3210\u3213r\xf2\u0feaa\xf2\u0551;\u600foust\u0100;a\u321e\u321f\u63b1che\xbb\u321fmid;\u6aee\u0200abpt\u3232\u323d\u3240\u3252\u0100nr\u3237\u323ag;\u67edr;\u61fer\xeb\u1003\u0180afl\u3247\u324a\u324er;\u6986;\uc000\ud835\udd63us;\u6a2eimes;\u6a35\u0100ap\u325d\u3267r\u0100;g\u3263\u3264\u4029t;\u6994olint;\u6a12ar\xf2\u31e3\u0200achq\u327b\u3280\u10bc\u3285quo;\u603ar;\uc000\ud835\udcc7\u0100bu\u30fb\u328ao\u0100;r\u0214\u0213\u0180hir\u3297\u329b\u32a0re\xe5\u31f8mes;\u62cai\u0200;efl\u32aa\u1059\u1821\u32ab\u65b9tri;\u69celuhar;\u6968;\u611e\u0d61\u32d5\u32db\u32df\u332c\u3338\u3371\0\u337a\u33a4\0\0\u33ec\u33f0\0\u3428\u3448\u345a\u34ad\u34b1\u34ca\u34f1\0\u3616\0\0\u3633cute;\u415bqu\xef\u27ba\u0500;Eaceinpsy\u11ed\u32f3\u32f5\u32ff\u3302\u330b\u330f\u331f\u3326\u3329;\u6ab4\u01f0\u32fa\0\u32fc;\u6ab8on;\u4161u\xe5\u11fe\u0100;d\u11f3\u3307il;\u415frc;\u415d\u0180Eas\u3316\u3318\u331b;\u6ab6p;\u6abaim;\u62e9olint;\u6a13i\xed\u1204;\u4441ot\u0180;be\u3334\u1d47\u3335\u62c5;\u6a66\u0380Aacmstx\u3346\u334a\u3357\u335b\u335e\u3363\u336drr;\u61d8r\u0100hr\u3350\u3352\xeb\u2228\u0100;o\u0a36\u0a34t\u803b\xa7\u40a7i;\u403bwar;\u6929m\u0100in\u3369\xf0nu\xf3\xf1t;\u6736r\u0100;o\u3376\u2055\uc000\ud835\udd30\u0200acoy\u3382\u3386\u3391\u33a0rp;\u666f\u0100hy\u338b\u338fcy;\u4449;\u4448rt\u026d\u3399\0\0\u339ci\xe4\u1464ara\xec\u2e6f\u803b\xad\u40ad\u0100gm\u33a8\u33b4ma\u0180;fv\u33b1\u33b2\u33b2\u43c3;\u43c2\u0400;deglnpr\u12ab\u33c5\u33c9\u33ce\u33d6\u33de\u33e1\u33e6ot;\u6a6a\u0100;q\u12b1\u12b0\u0100;E\u33d3\u33d4\u6a9e;\u6aa0\u0100;E\u33db\u33dc\u6a9d;\u6a9fe;\u6246lus;\u6a24arr;\u6972ar\xf2\u113d\u0200aeit\u33f8\u3408\u340f\u3417\u0100ls\u33fd\u3404lsetm\xe9\u336ahp;\u6a33parsl;\u69e4\u0100dl\u1463\u3414e;\u6323\u0100;e\u341c\u341d\u6aaa\u0100;s\u3422\u3423\u6aac;\uc000\u2aac\ufe00\u0180flp\u342e\u3433\u3442tcy;\u444c\u0100;b\u3438\u3439\u402f\u0100;a\u343e\u343f\u69c4r;\u633ff;\uc000\ud835\udd64a\u0100dr\u344d\u0402es\u0100;u\u3454\u3455\u6660it\xbb\u3455\u0180csu\u3460\u3479\u349f\u0100au\u3465\u346fp\u0100;s\u1188\u346b;\uc000\u2293\ufe00p\u0100;s\u11b4\u3475;\uc000\u2294\ufe00u\u0100bp\u347f\u348f\u0180;es\u1197\u119c\u3486et\u0100;e\u1197\u348d\xf1\u119d\u0180;es\u11a8\u11ad\u3496et\u0100;e\u11a8\u349d\xf1\u11ae\u0180;af\u117b\u34a6\u05b0r\u0165\u34ab\u05b1\xbb\u117car\xf2\u1148\u0200cemt\u34b9\u34be\u34c2\u34c5r;\uc000\ud835\udcc8tm\xee\xf1i\xec\u3415ar\xe6\u11be\u0100ar\u34ce\u34d5r\u0100;f\u34d4\u17bf\u6606\u0100an\u34da\u34edight\u0100ep\u34e3\u34eapsilo\xee\u1ee0h\xe9\u2eafs\xbb\u2852\u0280bcmnp\u34fb\u355e\u1209\u358b\u358e\u0480;Edemnprs\u350e\u350f\u3511\u3515\u351e\u3523\u352c\u3531\u3536\u6282;\u6ac5ot;\u6abd\u0100;d\u11da\u351aot;\u6ac3ult;\u6ac1\u0100Ee\u3528\u352a;\u6acb;\u628alus;\u6abfarr;\u6979\u0180eiu\u353d\u3552\u3555t\u0180;en\u350e\u3545\u354bq\u0100;q\u11da\u350feq\u0100;q\u352b\u3528m;\u6ac7\u0100bp\u355a\u355c;\u6ad5;\u6ad3c\u0300;acens\u11ed\u356c\u3572\u3579\u357b\u3326ppro\xf8\u32faurlye\xf1\u11fe\xf1\u11f3\u0180aes\u3582\u3588\u331bppro\xf8\u331aq\xf1\u3317g;\u666a\u0680123;Edehlmnps\u35a9\u35ac\u35af\u121c\u35b2\u35b4\u35c0\u35c9\u35d5\u35da\u35df\u35e8\u35ed\u803b\xb9\u40b9\u803b\xb2\u40b2\u803b\xb3\u40b3;\u6ac6\u0100os\u35b9\u35bct;\u6abeub;\u6ad8\u0100;d\u1222\u35c5ot;\u6ac4s\u0100ou\u35cf\u35d2l;\u67c9b;\u6ad7arr;\u697bult;\u6ac2\u0100Ee\u35e4\u35e6;\u6acc;\u628blus;\u6ac0\u0180eiu\u35f4\u3609\u360ct\u0180;en\u121c\u35fc\u3602q\u0100;q\u1222\u35b2eq\u0100;q\u35e7\u35e4m;\u6ac8\u0100bp\u3611\u3613;\u6ad4;\u6ad6\u0180Aan\u361c\u3620\u362drr;\u61d9r\u0100hr\u3626\u3628\xeb\u222e\u0100;o\u0a2b\u0a29war;\u692alig\u803b\xdf\u40df\u0be1\u3651\u365d\u3660\u12ce\u3673\u3679\0\u367e\u36c2\0\0\0\0\0\u36db\u3703\0\u3709\u376c\0\0\0\u3787\u0272\u3656\0\0\u365bget;\u6316;\u43c4r\xeb\u0e5f\u0180aey\u3666\u366b\u3670ron;\u4165dil;\u4163;\u4442lrec;\u6315r;\uc000\ud835\udd31\u0200eiko\u3686\u369d\u36b5\u36bc\u01f2\u368b\0\u3691e\u01004f\u1284\u1281a\u0180;sv\u3698\u3699\u369b\u43b8ym;\u43d1\u0100cn\u36a2\u36b2k\u0100as\u36a8\u36aeppro\xf8\u12c1im\xbb\u12acs\xf0\u129e\u0100as\u36ba\u36ae\xf0\u12c1rn\u803b\xfe\u40fe\u01ec\u031f\u36c6\u22e7es\u8180\xd7;bd\u36cf\u36d0\u36d8\u40d7\u0100;a\u190f\u36d5r;\u6a31;\u6a30\u0180eps\u36e1\u36e3\u3700\xe1\u2a4d\u0200;bcf\u0486\u36ec\u36f0\u36f4ot;\u6336ir;\u6af1\u0100;o\u36f9\u36fc\uc000\ud835\udd65rk;\u6ada\xe1\u3362rime;\u6034\u0180aip\u370f\u3712\u3764d\xe5\u1248\u0380adempst\u3721\u374d\u3740\u3751\u3757\u375c\u375fngle\u0280;dlqr\u3730\u3731\u3736\u3740\u3742\u65b5own\xbb\u1dbbeft\u0100;e\u2800\u373e\xf1\u092e;\u625cight\u0100;e\u32aa\u374b\xf1\u105aot;\u65ecinus;\u6a3alus;\u6a39b;\u69cdime;\u6a3bezium;\u63e2\u0180cht\u3772\u377d\u3781\u0100ry\u3777\u377b;\uc000\ud835\udcc9;\u4446cy;\u445brok;\u4167\u0100io\u378b\u378ex\xf4\u1777head\u0100lr\u3797\u37a0eftarro\xf7\u084fightarrow\xbb\u0f5d\u0900AHabcdfghlmoprstuw\u37d0\u37d3\u37d7\u37e4\u37f0\u37fc\u380e\u381c\u3823\u3834\u3851\u385d\u386b\u38a9\u38cc\u38d2\u38ea\u38f6r\xf2\u03edar;\u6963\u0100cr\u37dc\u37e2ute\u803b\xfa\u40fa\xf2\u1150r\u01e3\u37ea\0\u37edy;\u445eve;\u416d\u0100iy\u37f5\u37farc\u803b\xfb\u40fb;\u4443\u0180abh\u3803\u3806\u380br\xf2\u13adlac;\u4171a\xf2\u13c3\u0100ir\u3813\u3818sht;\u697e;\uc000\ud835\udd32rave\u803b\xf9\u40f9\u0161\u3827\u3831r\u0100lr\u382c\u382e\xbb\u0957\xbb\u1083lk;\u6580\u0100ct\u3839\u384d\u026f\u383f\0\0\u384arn\u0100;e\u3845\u3846\u631cr\xbb\u3846op;\u630fri;\u65f8\u0100al\u3856\u385acr;\u416b\u80bb\xa8\u0349\u0100gp\u3862\u3866on;\u4173f;\uc000\ud835\udd66\u0300adhlsu\u114b\u3878\u387d\u1372\u3891\u38a0own\xe1\u13b3arpoon\u0100lr\u3888\u388cef\xf4\u382digh\xf4\u382fi\u0180;hl\u3899\u389a\u389c\u43c5\xbb\u13faon\xbb\u389aparrows;\u61c8\u0180cit\u38b0\u38c4\u38c8\u026f\u38b6\0\0\u38c1rn\u0100;e\u38bc\u38bd\u631dr\xbb\u38bdop;\u630eng;\u416fri;\u65f9cr;\uc000\ud835\udcca\u0180dir\u38d9\u38dd\u38e2ot;\u62f0lde;\u4169i\u0100;f\u3730\u38e8\xbb\u1813\u0100am\u38ef\u38f2r\xf2\u38a8l\u803b\xfc\u40fcangle;\u69a7\u0780ABDacdeflnoprsz\u391c\u391f\u3929\u392d\u39b5\u39b8\u39bd\u39df\u39e4\u39e8\u39f3\u39f9\u39fd\u3a01\u3a20r\xf2\u03f7ar\u0100;v\u3926\u3927\u6ae8;\u6ae9as\xe8\u03e1\u0100nr\u3932\u3937grt;\u699c\u0380eknprst\u34e3\u3946\u394b\u3952\u395d\u3964\u3996app\xe1\u2415othin\xe7\u1e96\u0180hir\u34eb\u2ec8\u3959op\xf4\u2fb5\u0100;h\u13b7\u3962\xef\u318d\u0100iu\u3969\u396dgm\xe1\u33b3\u0100bp\u3972\u3984setneq\u0100;q\u397d\u3980\uc000\u228a\ufe00;\uc000\u2acb\ufe00setneq\u0100;q\u398f\u3992\uc000\u228b\ufe00;\uc000\u2acc\ufe00\u0100hr\u399b\u399fet\xe1\u369ciangle\u0100lr\u39aa\u39afeft\xbb\u0925ight\xbb\u1051y;\u4432ash\xbb\u1036\u0180elr\u39c4\u39d2\u39d7\u0180;be\u2dea\u39cb\u39cfar;\u62bbq;\u625alip;\u62ee\u0100bt\u39dc\u1468a\xf2\u1469r;\uc000\ud835\udd33tr\xe9\u39aesu\u0100bp\u39ef\u39f1\xbb\u0d1c\xbb\u0d59pf;\uc000\ud835\udd67ro\xf0\u0efbtr\xe9\u39b4\u0100cu\u3a06\u3a0br;\uc000\ud835\udccb\u0100bp\u3a10\u3a18n\u0100Ee\u3980\u3a16\xbb\u397en\u0100Ee\u3992\u3a1e\xbb\u3990igzag;\u699a\u0380cefoprs\u3a36\u3a3b\u3a56\u3a5b\u3a54\u3a61\u3a6airc;\u4175\u0100di\u3a40\u3a51\u0100bg\u3a45\u3a49ar;\u6a5fe\u0100;q\u15fa\u3a4f;\u6259erp;\u6118r;\uc000\ud835\udd34pf;\uc000\ud835\udd68\u0100;e\u1479\u3a66at\xe8\u1479cr;\uc000\ud835\udccc\u0ae3\u178e\u3a87\0\u3a8b\0\u3a90\u3a9b\0\0\u3a9d\u3aa8\u3aab\u3aaf\0\0\u3ac3\u3ace\0\u3ad8\u17dc\u17dftr\xe9\u17d1r;\uc000\ud835\udd35\u0100Aa\u3a94\u3a97r\xf2\u03c3r\xf2\u09f6;\u43be\u0100Aa\u3aa1\u3aa4r\xf2\u03b8r\xf2\u09eba\xf0\u2713is;\u62fb\u0180dpt\u17a4\u3ab5\u3abe\u0100fl\u3aba\u17a9;\uc000\ud835\udd69im\xe5\u17b2\u0100Aa\u3ac7\u3acar\xf2\u03cer\xf2\u0a01\u0100cq\u3ad2\u17b8r;\uc000\ud835\udccd\u0100pt\u17d6\u3adcr\xe9\u17d4\u0400acefiosu\u3af0\u3afd\u3b08\u3b0c\u3b11\u3b15\u3b1b\u3b21c\u0100uy\u3af6\u3afbte\u803b\xfd\u40fd;\u444f\u0100iy\u3b02\u3b06rc;\u4177;\u444bn\u803b\xa5\u40a5r;\uc000\ud835\udd36cy;\u4457pf;\uc000\ud835\udd6acr;\uc000\ud835\udcce\u0100cm\u3b26\u3b29y;\u444el\u803b\xff\u40ff\u0500acdefhiosw\u3b42\u3b48\u3b54\u3b58\u3b64\u3b69\u3b6d\u3b74\u3b7a\u3b80cute;\u417a\u0100ay\u3b4d\u3b52ron;\u417e;\u4437ot;\u417c\u0100et\u3b5d\u3b61tr\xe6\u155fa;\u43b6r;\uc000\ud835\udd37cy;\u4436grarr;\u61ddpf;\uc000\ud835\udd6bcr;\uc000\ud835\udccf\u0100jn\u3b85\u3b87;\u600dj;\u600c"
    .split("")
    .map((c) => c.charCodeAt(0))));
//# sourceMappingURL=decode-data-html.js.map
;// CONCATENATED MODULE: ./node_modules/entities/lib/esm/generated/decode-data-xml.js
// Generated using scripts/write-decode-map.ts
/* harmony default export */ var decode_data_xml = (new Uint16Array(
// prettier-ignore
"\u0200aglq\t\x15\x18\x1b\u026d\x0f\0\0\x12p;\u4026os;\u4027t;\u403et;\u403cuot;\u4022"
    .split("")
    .map((c) => c.charCodeAt(0))));
//# sourceMappingURL=decode-data-xml.js.map
;// CONCATENATED MODULE: ./node_modules/entities/lib/esm/decode_codepoint.js
// Adapted from https://github.com/mathiasbynens/he/blob/36afe179392226cf1b6ccdb16ebbb7a5a844d93a/src/he.js#L106-L134
var _a;
const decodeMap = new Map([
    [0, 65533],
    // C1 Unicode control character reference replacements
    [128, 8364],
    [130, 8218],
    [131, 402],
    [132, 8222],
    [133, 8230],
    [134, 8224],
    [135, 8225],
    [136, 710],
    [137, 8240],
    [138, 352],
    [139, 8249],
    [140, 338],
    [142, 381],
    [145, 8216],
    [146, 8217],
    [147, 8220],
    [148, 8221],
    [149, 8226],
    [150, 8211],
    [151, 8212],
    [152, 732],
    [153, 8482],
    [154, 353],
    [155, 8250],
    [156, 339],
    [158, 382],
    [159, 376],
]);
/**
 * Polyfill for `String.fromCodePoint`. It is used to create a string from a Unicode code point.
 */
const fromCodePoint = 
// eslint-disable-next-line @typescript-eslint/no-unnecessary-condition, node/no-unsupported-features/es-builtins
(_a = String.fromCodePoint) !== null && _a !== void 0 ? _a : function (codePoint) {
    let output = "";
    if (codePoint > 0xffff) {
        codePoint -= 0x10000;
        output += String.fromCharCode(((codePoint >>> 10) & 0x3ff) | 0xd800);
        codePoint = 0xdc00 | (codePoint & 0x3ff);
    }
    output += String.fromCharCode(codePoint);
    return output;
};
/**
 * Replace the given code point with a replacement character if it is a
 * surrogate or is outside the valid range. Otherwise return the code
 * point unchanged.
 */
function replaceCodePoint(codePoint) {
    var _a;
    if ((codePoint >= 0xd800 && codePoint <= 0xdfff) || codePoint > 0x10ffff) {
        return 0xfffd;
    }
    return (_a = decodeMap.get(codePoint)) !== null && _a !== void 0 ? _a : codePoint;
}
/**
 * Replace the code point if relevant, then convert it to a string.
 *
 * @deprecated Use `fromCodePoint(replaceCodePoint(codePoint))` instead.
 * @param codePoint The code point to decode.
 * @returns The decoded code point.
 */
function decodeCodePoint(codePoint) {
    return fromCodePoint(replaceCodePoint(codePoint));
}
//# sourceMappingURL=decode_codepoint.js.map
;// CONCATENATED MODULE: ./node_modules/entities/lib/esm/decode.js



// Re-export for use by eg. htmlparser2


var CharCodes;
(function (CharCodes) {
    CharCodes[CharCodes["NUM"] = 35] = "NUM";
    CharCodes[CharCodes["SEMI"] = 59] = "SEMI";
    CharCodes[CharCodes["EQUALS"] = 61] = "EQUALS";
    CharCodes[CharCodes["ZERO"] = 48] = "ZERO";
    CharCodes[CharCodes["NINE"] = 57] = "NINE";
    CharCodes[CharCodes["LOWER_A"] = 97] = "LOWER_A";
    CharCodes[CharCodes["LOWER_F"] = 102] = "LOWER_F";
    CharCodes[CharCodes["LOWER_X"] = 120] = "LOWER_X";
    CharCodes[CharCodes["LOWER_Z"] = 122] = "LOWER_Z";
    CharCodes[CharCodes["UPPER_A"] = 65] = "UPPER_A";
    CharCodes[CharCodes["UPPER_F"] = 70] = "UPPER_F";
    CharCodes[CharCodes["UPPER_Z"] = 90] = "UPPER_Z";
})(CharCodes || (CharCodes = {}));
/** Bit that needs to be set to convert an upper case ASCII character to lower case */
const TO_LOWER_BIT = 0b100000;
var BinTrieFlags;
(function (BinTrieFlags) {
    BinTrieFlags[BinTrieFlags["VALUE_LENGTH"] = 49152] = "VALUE_LENGTH";
    BinTrieFlags[BinTrieFlags["BRANCH_LENGTH"] = 16256] = "BRANCH_LENGTH";
    BinTrieFlags[BinTrieFlags["JUMP_TABLE"] = 127] = "JUMP_TABLE";
})(BinTrieFlags || (BinTrieFlags = {}));
function isNumber(code) {
    return code >= CharCodes.ZERO && code <= CharCodes.NINE;
}
function isHexadecimalCharacter(code) {
    return ((code >= CharCodes.UPPER_A && code <= CharCodes.UPPER_F) ||
        (code >= CharCodes.LOWER_A && code <= CharCodes.LOWER_F));
}
function isAsciiAlphaNumeric(code) {
    return ((code >= CharCodes.UPPER_A && code <= CharCodes.UPPER_Z) ||
        (code >= CharCodes.LOWER_A && code <= CharCodes.LOWER_Z) ||
        isNumber(code));
}
/**
 * Checks if the given character is a valid end character for an entity in an attribute.
 *
 * Attribute values that aren't terminated properly aren't parsed, and shouldn't lead to a parser error.
 * See the example in https://html.spec.whatwg.org/multipage/parsing.html#named-character-reference-state
 */
function isEntityInAttributeInvalidEnd(code) {
    return code === CharCodes.EQUALS || isAsciiAlphaNumeric(code);
}
var EntityDecoderState;
(function (EntityDecoderState) {
    EntityDecoderState[EntityDecoderState["EntityStart"] = 0] = "EntityStart";
    EntityDecoderState[EntityDecoderState["NumericStart"] = 1] = "NumericStart";
    EntityDecoderState[EntityDecoderState["NumericDecimal"] = 2] = "NumericDecimal";
    EntityDecoderState[EntityDecoderState["NumericHex"] = 3] = "NumericHex";
    EntityDecoderState[EntityDecoderState["NamedEntity"] = 4] = "NamedEntity";
})(EntityDecoderState || (EntityDecoderState = {}));
var decode_DecodingMode;
(function (DecodingMode) {
    /** Entities in text nodes that can end with any character. */
    DecodingMode[DecodingMode["Legacy"] = 0] = "Legacy";
    /** Only allow entities terminated with a semicolon. */
    DecodingMode[DecodingMode["Strict"] = 1] = "Strict";
    /** Entities in attributes have limitations on ending characters. */
    DecodingMode[DecodingMode["Attribute"] = 2] = "Attribute";
})(decode_DecodingMode || (decode_DecodingMode = {}));
/**
 * Token decoder with support of writing partial entities.
 */
class EntityDecoder {
    constructor(
    /** The tree used to decode entities. */
    decodeTree, 
    /**
     * The function that is called when a codepoint is decoded.
     *
     * For multi-byte named entities, this will be called multiple times,
     * with the second codepoint, and the same `consumed` value.
     *
     * @param codepoint The decoded codepoint.
     * @param consumed The number of bytes consumed by the decoder.
     */
    emitCodePoint, 
    /** An object that is used to produce errors. */
    errors) {
        this.decodeTree = decodeTree;
        this.emitCodePoint = emitCodePoint;
        this.errors = errors;
        /** The current state of the decoder. */
        this.state = EntityDecoderState.EntityStart;
        /** Characters that were consumed while parsing an entity. */
        this.consumed = 1;
        /**
         * The result of the entity.
         *
         * Either the result index of a numeric entity, or the codepoint of a
         * numeric entity.
         */
        this.result = 0;
        /** The current index in the decode tree. */
        this.treeIndex = 0;
        /** The number of characters that were consumed in excess. */
        this.excess = 1;
        /** The mode in which the decoder is operating. */
        this.decodeMode = decode_DecodingMode.Strict;
    }
    /** Resets the instance to make it reusable. */
    startEntity(decodeMode) {
        this.decodeMode = decodeMode;
        this.state = EntityDecoderState.EntityStart;
        this.result = 0;
        this.treeIndex = 0;
        this.excess = 1;
        this.consumed = 1;
    }
    /**
     * Write an entity to the decoder. This can be called multiple times with partial entities.
     * If the entity is incomplete, the decoder will return -1.
     *
     * Mirrors the implementation of `getDecoder`, but with the ability to stop decoding if the
     * entity is incomplete, and resume when the next string is written.
     *
     * @param string The string containing the entity (or a continuation of the entity).
     * @param offset The offset at which the entity begins. Should be 0 if this is not the first call.
     * @returns The number of characters that were consumed, or -1 if the entity is incomplete.
     */
    write(str, offset) {
        switch (this.state) {
            case EntityDecoderState.EntityStart: {
                if (str.charCodeAt(offset) === CharCodes.NUM) {
                    this.state = EntityDecoderState.NumericStart;
                    this.consumed += 1;
                    return this.stateNumericStart(str, offset + 1);
                }
                this.state = EntityDecoderState.NamedEntity;
                return this.stateNamedEntity(str, offset);
            }
            case EntityDecoderState.NumericStart: {
                return this.stateNumericStart(str, offset);
            }
            case EntityDecoderState.NumericDecimal: {
                return this.stateNumericDecimal(str, offset);
            }
            case EntityDecoderState.NumericHex: {
                return this.stateNumericHex(str, offset);
            }
            case EntityDecoderState.NamedEntity: {
                return this.stateNamedEntity(str, offset);
            }
        }
    }
    /**
     * Switches between the numeric decimal and hexadecimal states.
     *
     * Equivalent to the `Numeric character reference state` in the HTML spec.
     *
     * @param str The string containing the entity (or a continuation of the entity).
     * @param offset The current offset.
     * @returns The number of characters that were consumed, or -1 if the entity is incomplete.
     */
    stateNumericStart(str, offset) {
        if (offset >= str.length) {
            return -1;
        }
        if ((str.charCodeAt(offset) | TO_LOWER_BIT) === CharCodes.LOWER_X) {
            this.state = EntityDecoderState.NumericHex;
            this.consumed += 1;
            return this.stateNumericHex(str, offset + 1);
        }
        this.state = EntityDecoderState.NumericDecimal;
        return this.stateNumericDecimal(str, offset);
    }
    addToNumericResult(str, start, end, base) {
        if (start !== end) {
            const digitCount = end - start;
            this.result =
                this.result * Math.pow(base, digitCount) +
                    parseInt(str.substr(start, digitCount), base);
            this.consumed += digitCount;
        }
    }
    /**
     * Parses a hexadecimal numeric entity.
     *
     * Equivalent to the `Hexademical character reference state` in the HTML spec.
     *
     * @param str The string containing the entity (or a continuation of the entity).
     * @param offset The current offset.
     * @returns The number of characters that were consumed, or -1 if the entity is incomplete.
     */
    stateNumericHex(str, offset) {
        const startIdx = offset;
        while (offset < str.length) {
            const char = str.charCodeAt(offset);
            if (isNumber(char) || isHexadecimalCharacter(char)) {
                offset += 1;
            }
            else {
                this.addToNumericResult(str, startIdx, offset, 16);
                return this.emitNumericEntity(char, 3);
            }
        }
        this.addToNumericResult(str, startIdx, offset, 16);
        return -1;
    }
    /**
     * Parses a decimal numeric entity.
     *
     * Equivalent to the `Decimal character reference state` in the HTML spec.
     *
     * @param str The string containing the entity (or a continuation of the entity).
     * @param offset The current offset.
     * @returns The number of characters that were consumed, or -1 if the entity is incomplete.
     */
    stateNumericDecimal(str, offset) {
        const startIdx = offset;
        while (offset < str.length) {
            const char = str.charCodeAt(offset);
            if (isNumber(char)) {
                offset += 1;
            }
            else {
                this.addToNumericResult(str, startIdx, offset, 10);
                return this.emitNumericEntity(char, 2);
            }
        }
        this.addToNumericResult(str, startIdx, offset, 10);
        return -1;
    }
    /**
     * Validate and emit a numeric entity.
     *
     * Implements the logic from the `Hexademical character reference start
     * state` and `Numeric character reference end state` in the HTML spec.
     *
     * @param lastCp The last code point of the entity. Used to see if the
     *               entity was terminated with a semicolon.
     * @param expectedLength The minimum number of characters that should be
     *                       consumed. Used to validate that at least one digit
     *                       was consumed.
     * @returns The number of characters that were consumed.
     */
    emitNumericEntity(lastCp, expectedLength) {
        var _a;
        // Ensure we consumed at least one digit.
        if (this.consumed <= expectedLength) {
            (_a = this.errors) === null || _a === void 0 ? void 0 : _a.absenceOfDigitsInNumericCharacterReference(this.consumed);
            return 0;
        }
        // Figure out if this is a legit end of the entity
        if (lastCp === CharCodes.SEMI) {
            this.consumed += 1;
        }
        else if (this.decodeMode === decode_DecodingMode.Strict) {
            return 0;
        }
        this.emitCodePoint(replaceCodePoint(this.result), this.consumed);
        if (this.errors) {
            if (lastCp !== CharCodes.SEMI) {
                this.errors.missingSemicolonAfterCharacterReference();
            }
            this.errors.validateNumericCharacterReference(this.result);
        }
        return this.consumed;
    }
    /**
     * Parses a named entity.
     *
     * Equivalent to the `Named character reference state` in the HTML spec.
     *
     * @param str The string containing the entity (or a continuation of the entity).
     * @param offset The current offset.
     * @returns The number of characters that were consumed, or -1 if the entity is incomplete.
     */
    stateNamedEntity(str, offset) {
        const { decodeTree } = this;
        let current = decodeTree[this.treeIndex];
        // The mask is the number of bytes of the value, including the current byte.
        let valueLength = (current & BinTrieFlags.VALUE_LENGTH) >> 14;
        for (; offset < str.length; offset++, this.excess++) {
            const char = str.charCodeAt(offset);
            this.treeIndex = determineBranch(decodeTree, current, this.treeIndex + Math.max(1, valueLength), char);
            if (this.treeIndex < 0) {
                return this.result === 0 ||
                    // If we are parsing an attribute
                    (this.decodeMode === decode_DecodingMode.Attribute &&
                        // We shouldn't have consumed any characters after the entity,
                        (valueLength === 0 ||
                            // And there should be no invalid characters.
                            isEntityInAttributeInvalidEnd(char)))
                    ? 0
                    : this.emitNotTerminatedNamedEntity();
            }
            current = decodeTree[this.treeIndex];
            valueLength = (current & BinTrieFlags.VALUE_LENGTH) >> 14;
            // If the branch is a value, store it and continue
            if (valueLength !== 0) {
                // If the entity is terminated by a semicolon, we are done.
                if (char === CharCodes.SEMI) {
                    return this.emitNamedEntityData(this.treeIndex, valueLength, this.consumed + this.excess);
                }
                // If we encounter a non-terminated (legacy) entity while parsing strictly, then ignore it.
                if (this.decodeMode !== decode_DecodingMode.Strict) {
                    this.result = this.treeIndex;
                    this.consumed += this.excess;
                    this.excess = 0;
                }
            }
        }
        return -1;
    }
    /**
     * Emit a named entity that was not terminated with a semicolon.
     *
     * @returns The number of characters consumed.
     */
    emitNotTerminatedNamedEntity() {
        var _a;
        const { result, decodeTree } = this;
        const valueLength = (decodeTree[result] & BinTrieFlags.VALUE_LENGTH) >> 14;
        this.emitNamedEntityData(result, valueLength, this.consumed);
        (_a = this.errors) === null || _a === void 0 ? void 0 : _a.missingSemicolonAfterCharacterReference();
        return this.consumed;
    }
    /**
     * Emit a named entity.
     *
     * @param result The index of the entity in the decode tree.
     * @param valueLength The number of bytes in the entity.
     * @param consumed The number of characters consumed.
     *
     * @returns The number of characters consumed.
     */
    emitNamedEntityData(result, valueLength, consumed) {
        const { decodeTree } = this;
        this.emitCodePoint(valueLength === 1
            ? decodeTree[result] & ~BinTrieFlags.VALUE_LENGTH
            : decodeTree[result + 1], consumed);
        if (valueLength === 3) {
            // For multi-byte values, we need to emit the second byte.
            this.emitCodePoint(decodeTree[result + 2], consumed);
        }
        return consumed;
    }
    /**
     * Signal to the parser that the end of the input was reached.
     *
     * Remaining data will be emitted and relevant errors will be produced.
     *
     * @returns The number of characters consumed.
     */
    end() {
        var _a;
        switch (this.state) {
            case EntityDecoderState.NamedEntity: {
                // Emit a named entity if we have one.
                return this.result !== 0 &&
                    (this.decodeMode !== decode_DecodingMode.Attribute ||
                        this.result === this.treeIndex)
                    ? this.emitNotTerminatedNamedEntity()
                    : 0;
            }
            // Otherwise, emit a numeric entity if we have one.
            case EntityDecoderState.NumericDecimal: {
                return this.emitNumericEntity(0, 2);
            }
            case EntityDecoderState.NumericHex: {
                return this.emitNumericEntity(0, 3);
            }
            case EntityDecoderState.NumericStart: {
                (_a = this.errors) === null || _a === void 0 ? void 0 : _a.absenceOfDigitsInNumericCharacterReference(this.consumed);
                return 0;
            }
            case EntityDecoderState.EntityStart: {
                // Return 0 if we have no entity.
                return 0;
            }
        }
    }
}
/**
 * Creates a function that decodes entities in a string.
 *
 * @param decodeTree The decode tree.
 * @returns A function that decodes entities in a string.
 */
function getDecoder(decodeTree) {
    let ret = "";
    const decoder = new EntityDecoder(decodeTree, (str) => (ret += fromCodePoint(str)));
    return function decodeWithTrie(str, decodeMode) {
        let lastIndex = 0;
        let offset = 0;
        while ((offset = str.indexOf("&", offset)) >= 0) {
            ret += str.slice(lastIndex, offset);
            decoder.startEntity(decodeMode);
            const len = decoder.write(str, 
            // Skip the "&"
            offset + 1);
            if (len < 0) {
                lastIndex = offset + decoder.end();
                break;
            }
            lastIndex = offset + len;
            // If `len` is 0, skip the current `&` and continue.
            offset = len === 0 ? lastIndex + 1 : lastIndex;
        }
        const result = ret + str.slice(lastIndex);
        // Make sure we don't keep a reference to the final string.
        ret = "";
        return result;
    };
}
/**
 * Determines the branch of the current node that is taken given the current
 * character. This function is used to traverse the trie.
 *
 * @param decodeTree The trie.
 * @param current The current node.
 * @param nodeIdx The index right after the current node and its value.
 * @param char The current character.
 * @returns The index of the next node, or -1 if no branch is taken.
 */
function determineBranch(decodeTree, current, nodeIdx, char) {
    const branchCount = (current & BinTrieFlags.BRANCH_LENGTH) >> 7;
    const jumpOffset = current & BinTrieFlags.JUMP_TABLE;
    // Case 1: Single branch encoded in jump offset
    if (branchCount === 0) {
        return jumpOffset !== 0 && char === jumpOffset ? nodeIdx : -1;
    }
    // Case 2: Multiple branches encoded in jump table
    if (jumpOffset) {
        const value = char - jumpOffset;
        return value < 0 || value >= branchCount
            ? -1
            : decodeTree[nodeIdx + value] - 1;
    }
    // Case 3: Multiple branches encoded in dictionary
    // Binary search for the character.
    let lo = nodeIdx;
    let hi = lo + branchCount - 1;
    while (lo <= hi) {
        const mid = (lo + hi) >>> 1;
        const midVal = decodeTree[mid];
        if (midVal < char) {
            lo = mid + 1;
        }
        else if (midVal > char) {
            hi = mid - 1;
        }
        else {
            return decodeTree[mid + branchCount];
        }
    }
    return -1;
}
const htmlDecoder = getDecoder(decode_data_html);
const xmlDecoder = getDecoder(decode_data_xml);
/**
 * Decodes an HTML string.
 *
 * @param str The string to decode.
 * @param mode The decoding mode.
 * @returns The decoded string.
 */
function decode_decodeHTML(str, mode = decode_DecodingMode.Legacy) {
    return htmlDecoder(str, mode);
}
/**
 * Decodes an HTML string in an attribute.
 *
 * @param str The string to decode.
 * @returns The decoded string.
 */
function decodeHTMLAttribute(str) {
    return htmlDecoder(str, decode_DecodingMode.Attribute);
}
/**
 * Decodes an HTML string, requiring all entities to be terminated by a semicolon.
 *
 * @param str The string to decode.
 * @returns The decoded string.
 */
function decodeHTMLStrict(str) {
    return htmlDecoder(str, decode_DecodingMode.Strict);
}
/**
 * Decodes an XML string, requiring all entities to be terminated by a semicolon.
 *
 * @param str The string to decode.
 * @returns The decoded string.
 */
function decode_decodeXML(str) {
    return xmlDecoder(str, decode_DecodingMode.Strict);
}
//# sourceMappingURL=decode.js.map
;// CONCATENATED MODULE: ./node_modules/htmlparser2/lib/esm/Tokenizer.js

var Tokenizer_CharCodes;
(function (CharCodes) {
    CharCodes[CharCodes["Tab"] = 9] = "Tab";
    CharCodes[CharCodes["NewLine"] = 10] = "NewLine";
    CharCodes[CharCodes["FormFeed"] = 12] = "FormFeed";
    CharCodes[CharCodes["CarriageReturn"] = 13] = "CarriageReturn";
    CharCodes[CharCodes["Space"] = 32] = "Space";
    CharCodes[CharCodes["ExclamationMark"] = 33] = "ExclamationMark";
    CharCodes[CharCodes["Number"] = 35] = "Number";
    CharCodes[CharCodes["Amp"] = 38] = "Amp";
    CharCodes[CharCodes["SingleQuote"] = 39] = "SingleQuote";
    CharCodes[CharCodes["DoubleQuote"] = 34] = "DoubleQuote";
    CharCodes[CharCodes["Dash"] = 45] = "Dash";
    CharCodes[CharCodes["Slash"] = 47] = "Slash";
    CharCodes[CharCodes["Zero"] = 48] = "Zero";
    CharCodes[CharCodes["Nine"] = 57] = "Nine";
    CharCodes[CharCodes["Semi"] = 59] = "Semi";
    CharCodes[CharCodes["Lt"] = 60] = "Lt";
    CharCodes[CharCodes["Eq"] = 61] = "Eq";
    CharCodes[CharCodes["Gt"] = 62] = "Gt";
    CharCodes[CharCodes["Questionmark"] = 63] = "Questionmark";
    CharCodes[CharCodes["UpperA"] = 65] = "UpperA";
    CharCodes[CharCodes["LowerA"] = 97] = "LowerA";
    CharCodes[CharCodes["UpperF"] = 70] = "UpperF";
    CharCodes[CharCodes["LowerF"] = 102] = "LowerF";
    CharCodes[CharCodes["UpperZ"] = 90] = "UpperZ";
    CharCodes[CharCodes["LowerZ"] = 122] = "LowerZ";
    CharCodes[CharCodes["LowerX"] = 120] = "LowerX";
    CharCodes[CharCodes["OpeningSquareBracket"] = 91] = "OpeningSquareBracket";
})(Tokenizer_CharCodes || (Tokenizer_CharCodes = {}));
/** All the states the tokenizer can be in. */
var State;
(function (State) {
    State[State["Text"] = 1] = "Text";
    State[State["BeforeTagName"] = 2] = "BeforeTagName";
    State[State["InTagName"] = 3] = "InTagName";
    State[State["InSelfClosingTag"] = 4] = "InSelfClosingTag";
    State[State["BeforeClosingTagName"] = 5] = "BeforeClosingTagName";
    State[State["InClosingTagName"] = 6] = "InClosingTagName";
    State[State["AfterClosingTagName"] = 7] = "AfterClosingTagName";
    // Attributes
    State[State["BeforeAttributeName"] = 8] = "BeforeAttributeName";
    State[State["InAttributeName"] = 9] = "InAttributeName";
    State[State["AfterAttributeName"] = 10] = "AfterAttributeName";
    State[State["BeforeAttributeValue"] = 11] = "BeforeAttributeValue";
    State[State["InAttributeValueDq"] = 12] = "InAttributeValueDq";
    State[State["InAttributeValueSq"] = 13] = "InAttributeValueSq";
    State[State["InAttributeValueNq"] = 14] = "InAttributeValueNq";
    // Declarations
    State[State["BeforeDeclaration"] = 15] = "BeforeDeclaration";
    State[State["InDeclaration"] = 16] = "InDeclaration";
    // Processing instructions
    State[State["InProcessingInstruction"] = 17] = "InProcessingInstruction";
    // Comments & CDATA
    State[State["BeforeComment"] = 18] = "BeforeComment";
    State[State["CDATASequence"] = 19] = "CDATASequence";
    State[State["InSpecialComment"] = 20] = "InSpecialComment";
    State[State["InCommentLike"] = 21] = "InCommentLike";
    // Special tags
    State[State["BeforeSpecialS"] = 22] = "BeforeSpecialS";
    State[State["BeforeSpecialT"] = 23] = "BeforeSpecialT";
    State[State["SpecialStartSequence"] = 24] = "SpecialStartSequence";
    State[State["InSpecialTag"] = 25] = "InSpecialTag";
    State[State["InEntity"] = 26] = "InEntity";
})(State || (State = {}));
function isWhitespace(c) {
    return (c === Tokenizer_CharCodes.Space ||
        c === Tokenizer_CharCodes.NewLine ||
        c === Tokenizer_CharCodes.Tab ||
        c === Tokenizer_CharCodes.FormFeed ||
        c === Tokenizer_CharCodes.CarriageReturn);
}
function isEndOfTagSection(c) {
    return c === Tokenizer_CharCodes.Slash || c === Tokenizer_CharCodes.Gt || isWhitespace(c);
}
function isASCIIAlpha(c) {
    return ((c >= Tokenizer_CharCodes.LowerA && c <= Tokenizer_CharCodes.LowerZ) ||
        (c >= Tokenizer_CharCodes.UpperA && c <= Tokenizer_CharCodes.UpperZ));
}
var QuoteType;
(function (QuoteType) {
    QuoteType[QuoteType["NoValue"] = 0] = "NoValue";
    QuoteType[QuoteType["Unquoted"] = 1] = "Unquoted";
    QuoteType[QuoteType["Single"] = 2] = "Single";
    QuoteType[QuoteType["Double"] = 3] = "Double";
})(QuoteType || (QuoteType = {}));
/**
 * Sequences used to match longer strings.
 *
 * We don't have `Script`, `Style`, or `Title` here. Instead, we re-use the *End
 * sequences with an increased offset.
 */
const Sequences = {
    Cdata: new Uint8Array([0x43, 0x44, 0x41, 0x54, 0x41, 0x5b]), // CDATA[
    CdataEnd: new Uint8Array([0x5d, 0x5d, 0x3e]), // ]]>
    CommentEnd: new Uint8Array([0x2d, 0x2d, 0x3e]), // `-->`
    ScriptEnd: new Uint8Array([0x3c, 0x2f, 0x73, 0x63, 0x72, 0x69, 0x70, 0x74]), // `</script`
    StyleEnd: new Uint8Array([0x3c, 0x2f, 0x73, 0x74, 0x79, 0x6c, 0x65]), // `</style`
    TitleEnd: new Uint8Array([0x3c, 0x2f, 0x74, 0x69, 0x74, 0x6c, 0x65]), // `</title`
    TextareaEnd: new Uint8Array([
        0x3c, 0x2f, 0x74, 0x65, 0x78, 0x74, 0x61, 0x72, 0x65, 0x61,
    ]), // `</textarea`
};
class Tokenizer {
    constructor({ xmlMode = false, decodeEntities = true, }, cbs) {
        this.cbs = cbs;
        /** The current state the tokenizer is in. */
        this.state = State.Text;
        /** The read buffer. */
        this.buffer = "";
        /** The beginning of the section that is currently being read. */
        this.sectionStart = 0;
        /** The index within the buffer that we are currently looking at. */
        this.index = 0;
        /** The start of the last entity. */
        this.entityStart = 0;
        /** Some behavior, eg. when decoding entities, is done while we are in another state. This keeps track of the other state type. */
        this.baseState = State.Text;
        /** For special parsing behavior inside of script and style tags. */
        this.isSpecial = false;
        /** Indicates whether the tokenizer has been paused. */
        this.running = true;
        /** The offset of the current buffer. */
        this.offset = 0;
        this.currentSequence = undefined;
        this.sequenceIndex = 0;
        this.xmlMode = xmlMode;
        this.decodeEntities = decodeEntities;
        this.entityDecoder = new EntityDecoder(xmlMode ? decode_data_xml : decode_data_html, (cp, consumed) => this.emitCodePoint(cp, consumed));
    }
    reset() {
        this.state = State.Text;
        this.buffer = "";
        this.sectionStart = 0;
        this.index = 0;
        this.baseState = State.Text;
        this.currentSequence = undefined;
        this.running = true;
        this.offset = 0;
    }
    write(chunk) {
        this.offset += this.buffer.length;
        this.buffer = chunk;
        this.parse();
    }
    end() {
        if (this.running)
            this.finish();
    }
    pause() {
        this.running = false;
    }
    resume() {
        this.running = true;
        if (this.index < this.buffer.length + this.offset) {
            this.parse();
        }
    }
    stateText(c) {
        if (c === Tokenizer_CharCodes.Lt ||
            (!this.decodeEntities && this.fastForwardTo(Tokenizer_CharCodes.Lt))) {
            if (this.index > this.sectionStart) {
                this.cbs.ontext(this.sectionStart, this.index);
            }
            this.state = State.BeforeTagName;
            this.sectionStart = this.index;
        }
        else if (this.decodeEntities && c === Tokenizer_CharCodes.Amp) {
            this.startEntity();
        }
    }
    stateSpecialStartSequence(c) {
        const isEnd = this.sequenceIndex === this.currentSequence.length;
        const isMatch = isEnd
            ? // If we are at the end of the sequence, make sure the tag name has ended
                isEndOfTagSection(c)
            : // Otherwise, do a case-insensitive comparison
                (c | 0x20) === this.currentSequence[this.sequenceIndex];
        if (!isMatch) {
            this.isSpecial = false;
        }
        else if (!isEnd) {
            this.sequenceIndex++;
            return;
        }
        this.sequenceIndex = 0;
        this.state = State.InTagName;
        this.stateInTagName(c);
    }
    /** Look for an end tag. For <title> tags, also decode entities. */
    stateInSpecialTag(c) {
        if (this.sequenceIndex === this.currentSequence.length) {
            if (c === Tokenizer_CharCodes.Gt || isWhitespace(c)) {
                const endOfText = this.index - this.currentSequence.length;
                if (this.sectionStart < endOfText) {
                    // Spoof the index so that reported locations match up.
                    const actualIndex = this.index;
                    this.index = endOfText;
                    this.cbs.ontext(this.sectionStart, endOfText);
                    this.index = actualIndex;
                }
                this.isSpecial = false;
                this.sectionStart = endOfText + 2; // Skip over the `</`
                this.stateInClosingTagName(c);
                return; // We are done; skip the rest of the function.
            }
            this.sequenceIndex = 0;
        }
        if ((c | 0x20) === this.currentSequence[this.sequenceIndex]) {
            this.sequenceIndex += 1;
        }
        else if (this.sequenceIndex === 0) {
            if (this.currentSequence === Sequences.TitleEnd) {
                // We have to parse entities in <title> tags.
                if (this.decodeEntities && c === Tokenizer_CharCodes.Amp) {
                    this.startEntity();
                }
            }
            else if (this.fastForwardTo(Tokenizer_CharCodes.Lt)) {
                // Outside of <title> tags, we can fast-forward.
                this.sequenceIndex = 1;
            }
        }
        else {
            // If we see a `<`, set the sequence index to 1; useful for eg. `<</script>`.
            this.sequenceIndex = Number(c === Tokenizer_CharCodes.Lt);
        }
    }
    stateCDATASequence(c) {
        if (c === Sequences.Cdata[this.sequenceIndex]) {
            if (++this.sequenceIndex === Sequences.Cdata.length) {
                this.state = State.InCommentLike;
                this.currentSequence = Sequences.CdataEnd;
                this.sequenceIndex = 0;
                this.sectionStart = this.index + 1;
            }
        }
        else {
            this.sequenceIndex = 0;
            this.state = State.InDeclaration;
            this.stateInDeclaration(c); // Reconsume the character
        }
    }
    /**
     * When we wait for one specific character, we can speed things up
     * by skipping through the buffer until we find it.
     *
     * @returns Whether the character was found.
     */
    fastForwardTo(c) {
        while (++this.index < this.buffer.length + this.offset) {
            if (this.buffer.charCodeAt(this.index - this.offset) === c) {
                return true;
            }
        }
        /*
         * We increment the index at the end of the `parse` loop,
         * so set it to `buffer.length - 1` here.
         *
         * TODO: Refactor `parse` to increment index before calling states.
         */
        this.index = this.buffer.length + this.offset - 1;
        return false;
    }
    /**
     * Comments and CDATA end with `-->` and `]]>`.
     *
     * Their common qualities are:
     * - Their end sequences have a distinct character they start with.
     * - That character is then repeated, so we have to check multiple repeats.
     * - All characters but the start character of the sequence can be skipped.
     */
    stateInCommentLike(c) {
        if (c === this.currentSequence[this.sequenceIndex]) {
            if (++this.sequenceIndex === this.currentSequence.length) {
                if (this.currentSequence === Sequences.CdataEnd) {
                    this.cbs.oncdata(this.sectionStart, this.index, 2);
                }
                else {
                    this.cbs.oncomment(this.sectionStart, this.index, 2);
                }
                this.sequenceIndex = 0;
                this.sectionStart = this.index + 1;
                this.state = State.Text;
            }
        }
        else if (this.sequenceIndex === 0) {
            // Fast-forward to the first character of the sequence
            if (this.fastForwardTo(this.currentSequence[0])) {
                this.sequenceIndex = 1;
            }
        }
        else if (c !== this.currentSequence[this.sequenceIndex - 1]) {
            // Allow long sequences, eg. --->, ]]]>
            this.sequenceIndex = 0;
        }
    }
    /**
     * HTML only allows ASCII alpha characters (a-z and A-Z) at the beginning of a tag name.
     *
     * XML allows a lot more characters here (@see https://www.w3.org/TR/REC-xml/#NT-NameStartChar).
     * We allow anything that wouldn't end the tag.
     */
    isTagStartChar(c) {
        return this.xmlMode ? !isEndOfTagSection(c) : isASCIIAlpha(c);
    }
    startSpecial(sequence, offset) {
        this.isSpecial = true;
        this.currentSequence = sequence;
        this.sequenceIndex = offset;
        this.state = State.SpecialStartSequence;
    }
    stateBeforeTagName(c) {
        if (c === Tokenizer_CharCodes.ExclamationMark) {
            this.state = State.BeforeDeclaration;
            this.sectionStart = this.index + 1;
        }
        else if (c === Tokenizer_CharCodes.Questionmark) {
            this.state = State.InProcessingInstruction;
            this.sectionStart = this.index + 1;
        }
        else if (this.isTagStartChar(c)) {
            const lower = c | 0x20;
            this.sectionStart = this.index;
            if (this.xmlMode) {
                this.state = State.InTagName;
            }
            else if (lower === Sequences.ScriptEnd[2]) {
                this.state = State.BeforeSpecialS;
            }
            else if (lower === Sequences.TitleEnd[2]) {
                this.state = State.BeforeSpecialT;
            }
            else {
                this.state = State.InTagName;
            }
        }
        else if (c === Tokenizer_CharCodes.Slash) {
            this.state = State.BeforeClosingTagName;
        }
        else {
            this.state = State.Text;
            this.stateText(c);
        }
    }
    stateInTagName(c) {
        if (isEndOfTagSection(c)) {
            this.cbs.onopentagname(this.sectionStart, this.index);
            this.sectionStart = -1;
            this.state = State.BeforeAttributeName;
            this.stateBeforeAttributeName(c);
        }
    }
    stateBeforeClosingTagName(c) {
        if (isWhitespace(c)) {
            // Ignore
        }
        else if (c === Tokenizer_CharCodes.Gt) {
            this.state = State.Text;
        }
        else {
            this.state = this.isTagStartChar(c)
                ? State.InClosingTagName
                : State.InSpecialComment;
            this.sectionStart = this.index;
        }
    }
    stateInClosingTagName(c) {
        if (c === Tokenizer_CharCodes.Gt || isWhitespace(c)) {
            this.cbs.onclosetag(this.sectionStart, this.index);
            this.sectionStart = -1;
            this.state = State.AfterClosingTagName;
            this.stateAfterClosingTagName(c);
        }
    }
    stateAfterClosingTagName(c) {
        // Skip everything until ">"
        if (c === Tokenizer_CharCodes.Gt || this.fastForwardTo(Tokenizer_CharCodes.Gt)) {
            this.state = State.Text;
            this.sectionStart = this.index + 1;
        }
    }
    stateBeforeAttributeName(c) {
        if (c === Tokenizer_CharCodes.Gt) {
            this.cbs.onopentagend(this.index);
            if (this.isSpecial) {
                this.state = State.InSpecialTag;
                this.sequenceIndex = 0;
            }
            else {
                this.state = State.Text;
            }
            this.sectionStart = this.index + 1;
        }
        else if (c === Tokenizer_CharCodes.Slash) {
            this.state = State.InSelfClosingTag;
        }
        else if (!isWhitespace(c)) {
            this.state = State.InAttributeName;
            this.sectionStart = this.index;
        }
    }
    stateInSelfClosingTag(c) {
        if (c === Tokenizer_CharCodes.Gt) {
            this.cbs.onselfclosingtag(this.index);
            this.state = State.Text;
            this.sectionStart = this.index + 1;
            this.isSpecial = false; // Reset special state, in case of self-closing special tags
        }
        else if (!isWhitespace(c)) {
            this.state = State.BeforeAttributeName;
            this.stateBeforeAttributeName(c);
        }
    }
    stateInAttributeName(c) {
        if (c === Tokenizer_CharCodes.Eq || isEndOfTagSection(c)) {
            this.cbs.onattribname(this.sectionStart, this.index);
            this.sectionStart = this.index;
            this.state = State.AfterAttributeName;
            this.stateAfterAttributeName(c);
        }
    }
    stateAfterAttributeName(c) {
        if (c === Tokenizer_CharCodes.Eq) {
            this.state = State.BeforeAttributeValue;
        }
        else if (c === Tokenizer_CharCodes.Slash || c === Tokenizer_CharCodes.Gt) {
            this.cbs.onattribend(QuoteType.NoValue, this.sectionStart);
            this.sectionStart = -1;
            this.state = State.BeforeAttributeName;
            this.stateBeforeAttributeName(c);
        }
        else if (!isWhitespace(c)) {
            this.cbs.onattribend(QuoteType.NoValue, this.sectionStart);
            this.state = State.InAttributeName;
            this.sectionStart = this.index;
        }
    }
    stateBeforeAttributeValue(c) {
        if (c === Tokenizer_CharCodes.DoubleQuote) {
            this.state = State.InAttributeValueDq;
            this.sectionStart = this.index + 1;
        }
        else if (c === Tokenizer_CharCodes.SingleQuote) {
            this.state = State.InAttributeValueSq;
            this.sectionStart = this.index + 1;
        }
        else if (!isWhitespace(c)) {
            this.sectionStart = this.index;
            this.state = State.InAttributeValueNq;
            this.stateInAttributeValueNoQuotes(c); // Reconsume token
        }
    }
    handleInAttributeValue(c, quote) {
        if (c === quote ||
            (!this.decodeEntities && this.fastForwardTo(quote))) {
            this.cbs.onattribdata(this.sectionStart, this.index);
            this.sectionStart = -1;
            this.cbs.onattribend(quote === Tokenizer_CharCodes.DoubleQuote
                ? QuoteType.Double
                : QuoteType.Single, this.index + 1);
            this.state = State.BeforeAttributeName;
        }
        else if (this.decodeEntities && c === Tokenizer_CharCodes.Amp) {
            this.startEntity();
        }
    }
    stateInAttributeValueDoubleQuotes(c) {
        this.handleInAttributeValue(c, Tokenizer_CharCodes.DoubleQuote);
    }
    stateInAttributeValueSingleQuotes(c) {
        this.handleInAttributeValue(c, Tokenizer_CharCodes.SingleQuote);
    }
    stateInAttributeValueNoQuotes(c) {
        if (isWhitespace(c) || c === Tokenizer_CharCodes.Gt) {
            this.cbs.onattribdata(this.sectionStart, this.index);
            this.sectionStart = -1;
            this.cbs.onattribend(QuoteType.Unquoted, this.index);
            this.state = State.BeforeAttributeName;
            this.stateBeforeAttributeName(c);
        }
        else if (this.decodeEntities && c === Tokenizer_CharCodes.Amp) {
            this.startEntity();
        }
    }
    stateBeforeDeclaration(c) {
        if (c === Tokenizer_CharCodes.OpeningSquareBracket) {
            this.state = State.CDATASequence;
            this.sequenceIndex = 0;
        }
        else {
            this.state =
                c === Tokenizer_CharCodes.Dash
                    ? State.BeforeComment
                    : State.InDeclaration;
        }
    }
    stateInDeclaration(c) {
        if (c === Tokenizer_CharCodes.Gt || this.fastForwardTo(Tokenizer_CharCodes.Gt)) {
            this.cbs.ondeclaration(this.sectionStart, this.index);
            this.state = State.Text;
            this.sectionStart = this.index + 1;
        }
    }
    stateInProcessingInstruction(c) {
        if (c === Tokenizer_CharCodes.Gt || this.fastForwardTo(Tokenizer_CharCodes.Gt)) {
            this.cbs.onprocessinginstruction(this.sectionStart, this.index);
            this.state = State.Text;
            this.sectionStart = this.index + 1;
        }
    }
    stateBeforeComment(c) {
        if (c === Tokenizer_CharCodes.Dash) {
            this.state = State.InCommentLike;
            this.currentSequence = Sequences.CommentEnd;
            // Allow short comments (eg. <!-->)
            this.sequenceIndex = 2;
            this.sectionStart = this.index + 1;
        }
        else {
            this.state = State.InDeclaration;
        }
    }
    stateInSpecialComment(c) {
        if (c === Tokenizer_CharCodes.Gt || this.fastForwardTo(Tokenizer_CharCodes.Gt)) {
            this.cbs.oncomment(this.sectionStart, this.index, 0);
            this.state = State.Text;
            this.sectionStart = this.index + 1;
        }
    }
    stateBeforeSpecialS(c) {
        const lower = c | 0x20;
        if (lower === Sequences.ScriptEnd[3]) {
            this.startSpecial(Sequences.ScriptEnd, 4);
        }
        else if (lower === Sequences.StyleEnd[3]) {
            this.startSpecial(Sequences.StyleEnd, 4);
        }
        else {
            this.state = State.InTagName;
            this.stateInTagName(c); // Consume the token again
        }
    }
    stateBeforeSpecialT(c) {
        const lower = c | 0x20;
        if (lower === Sequences.TitleEnd[3]) {
            this.startSpecial(Sequences.TitleEnd, 4);
        }
        else if (lower === Sequences.TextareaEnd[3]) {
            this.startSpecial(Sequences.TextareaEnd, 4);
        }
        else {
            this.state = State.InTagName;
            this.stateInTagName(c); // Consume the token again
        }
    }
    startEntity() {
        this.baseState = this.state;
        this.state = State.InEntity;
        this.entityStart = this.index;
        this.entityDecoder.startEntity(this.xmlMode
            ? decode_DecodingMode.Strict
            : this.baseState === State.Text ||
                this.baseState === State.InSpecialTag
                ? decode_DecodingMode.Legacy
                : decode_DecodingMode.Attribute);
    }
    stateInEntity() {
        const length = this.entityDecoder.write(this.buffer, this.index - this.offset);
        // If `length` is positive, we are done with the entity.
        if (length >= 0) {
            this.state = this.baseState;
            if (length === 0) {
                this.index = this.entityStart;
            }
        }
        else {
            // Mark buffer as consumed.
            this.index = this.offset + this.buffer.length - 1;
        }
    }
    /**
     * Remove data that has already been consumed from the buffer.
     */
    cleanup() {
        // If we are inside of text or attributes, emit what we already have.
        if (this.running && this.sectionStart !== this.index) {
            if (this.state === State.Text ||
                (this.state === State.InSpecialTag && this.sequenceIndex === 0)) {
                this.cbs.ontext(this.sectionStart, this.index);
                this.sectionStart = this.index;
            }
            else if (this.state === State.InAttributeValueDq ||
                this.state === State.InAttributeValueSq ||
                this.state === State.InAttributeValueNq) {
                this.cbs.onattribdata(this.sectionStart, this.index);
                this.sectionStart = this.index;
            }
        }
    }
    shouldContinue() {
        return this.index < this.buffer.length + this.offset && this.running;
    }
    /**
     * Iterates through the buffer, calling the function corresponding to the current state.
     *
     * States that are more likely to be hit are higher up, as a performance improvement.
     */
    parse() {
        while (this.shouldContinue()) {
            const c = this.buffer.charCodeAt(this.index - this.offset);
            switch (this.state) {
                case State.Text: {
                    this.stateText(c);
                    break;
                }
                case State.SpecialStartSequence: {
                    this.stateSpecialStartSequence(c);
                    break;
                }
                case State.InSpecialTag: {
                    this.stateInSpecialTag(c);
                    break;
                }
                case State.CDATASequence: {
                    this.stateCDATASequence(c);
                    break;
                }
                case State.InAttributeValueDq: {
                    this.stateInAttributeValueDoubleQuotes(c);
                    break;
                }
                case State.InAttributeName: {
                    this.stateInAttributeName(c);
                    break;
                }
                case State.InCommentLike: {
                    this.stateInCommentLike(c);
                    break;
                }
                case State.InSpecialComment: {
                    this.stateInSpecialComment(c);
                    break;
                }
                case State.BeforeAttributeName: {
                    this.stateBeforeAttributeName(c);
                    break;
                }
                case State.InTagName: {
                    this.stateInTagName(c);
                    break;
                }
                case State.InClosingTagName: {
                    this.stateInClosingTagName(c);
                    break;
                }
                case State.BeforeTagName: {
                    this.stateBeforeTagName(c);
                    break;
                }
                case State.AfterAttributeName: {
                    this.stateAfterAttributeName(c);
                    break;
                }
                case State.InAttributeValueSq: {
                    this.stateInAttributeValueSingleQuotes(c);
                    break;
                }
                case State.BeforeAttributeValue: {
                    this.stateBeforeAttributeValue(c);
                    break;
                }
                case State.BeforeClosingTagName: {
                    this.stateBeforeClosingTagName(c);
                    break;
                }
                case State.AfterClosingTagName: {
                    this.stateAfterClosingTagName(c);
                    break;
                }
                case State.BeforeSpecialS: {
                    this.stateBeforeSpecialS(c);
                    break;
                }
                case State.BeforeSpecialT: {
                    this.stateBeforeSpecialT(c);
                    break;
                }
                case State.InAttributeValueNq: {
                    this.stateInAttributeValueNoQuotes(c);
                    break;
                }
                case State.InSelfClosingTag: {
                    this.stateInSelfClosingTag(c);
                    break;
                }
                case State.InDeclaration: {
                    this.stateInDeclaration(c);
                    break;
                }
                case State.BeforeDeclaration: {
                    this.stateBeforeDeclaration(c);
                    break;
                }
                case State.BeforeComment: {
                    this.stateBeforeComment(c);
                    break;
                }
                case State.InProcessingInstruction: {
                    this.stateInProcessingInstruction(c);
                    break;
                }
                case State.InEntity: {
                    this.stateInEntity();
                    break;
                }
            }
            this.index++;
        }
        this.cleanup();
    }
    finish() {
        if (this.state === State.InEntity) {
            this.entityDecoder.end();
            this.state = this.baseState;
        }
        this.handleTrailingData();
        this.cbs.onend();
    }
    /** Handle any trailing data. */
    handleTrailingData() {
        const endIndex = this.buffer.length + this.offset;
        // If there is no remaining data, we are done.
        if (this.sectionStart >= endIndex) {
            return;
        }
        if (this.state === State.InCommentLike) {
            if (this.currentSequence === Sequences.CdataEnd) {
                this.cbs.oncdata(this.sectionStart, endIndex, 0);
            }
            else {
                this.cbs.oncomment(this.sectionStart, endIndex, 0);
            }
        }
        else if (this.state === State.InTagName ||
            this.state === State.BeforeAttributeName ||
            this.state === State.BeforeAttributeValue ||
            this.state === State.AfterAttributeName ||
            this.state === State.InAttributeName ||
            this.state === State.InAttributeValueSq ||
            this.state === State.InAttributeValueDq ||
            this.state === State.InAttributeValueNq ||
            this.state === State.InClosingTagName) {
            /*
             * If we are currently in an opening or closing tag, us not calling the
             * respective callback signals that the tag should be ignored.
             */
        }
        else {
            this.cbs.ontext(this.sectionStart, endIndex);
        }
    }
    emitCodePoint(cp, consumed) {
        if (this.baseState !== State.Text &&
            this.baseState !== State.InSpecialTag) {
            if (this.sectionStart < this.entityStart) {
                this.cbs.onattribdata(this.sectionStart, this.entityStart);
            }
            this.sectionStart = this.entityStart + consumed;
            this.index = this.sectionStart - 1;
            this.cbs.onattribentity(cp);
        }
        else {
            if (this.sectionStart < this.entityStart) {
                this.cbs.ontext(this.sectionStart, this.entityStart);
            }
            this.sectionStart = this.entityStart + consumed;
            this.index = this.sectionStart - 1;
            this.cbs.ontextentity(cp, this.sectionStart);
        }
    }
}
//# sourceMappingURL=Tokenizer.js.map
;// CONCATENATED MODULE: ./node_modules/htmlparser2/lib/esm/Parser.js


const formTags = new Set([
    "input",
    "option",
    "optgroup",
    "select",
    "button",
    "datalist",
    "textarea",
]);
const pTag = new Set(["p"]);
const tableSectionTags = new Set(["thead", "tbody"]);
const ddtTags = new Set(["dd", "dt"]);
const rtpTags = new Set(["rt", "rp"]);
const openImpliesClose = new Map([
    ["tr", new Set(["tr", "th", "td"])],
    ["th", new Set(["th"])],
    ["td", new Set(["thead", "th", "td"])],
    ["body", new Set(["head", "link", "script"])],
    ["li", new Set(["li"])],
    ["p", pTag],
    ["h1", pTag],
    ["h2", pTag],
    ["h3", pTag],
    ["h4", pTag],
    ["h5", pTag],
    ["h6", pTag],
    ["select", formTags],
    ["input", formTags],
    ["output", formTags],
    ["button", formTags],
    ["datalist", formTags],
    ["textarea", formTags],
    ["option", new Set(["option"])],
    ["optgroup", new Set(["optgroup", "option"])],
    ["dd", ddtTags],
    ["dt", ddtTags],
    ["address", pTag],
    ["article", pTag],
    ["aside", pTag],
    ["blockquote", pTag],
    ["details", pTag],
    ["div", pTag],
    ["dl", pTag],
    ["fieldset", pTag],
    ["figcaption", pTag],
    ["figure", pTag],
    ["footer", pTag],
    ["form", pTag],
    ["header", pTag],
    ["hr", pTag],
    ["main", pTag],
    ["nav", pTag],
    ["ol", pTag],
    ["pre", pTag],
    ["section", pTag],
    ["table", pTag],
    ["ul", pTag],
    ["rt", rtpTags],
    ["rp", rtpTags],
    ["tbody", tableSectionTags],
    ["tfoot", tableSectionTags],
]);
const voidElements = new Set([
    "area",
    "base",
    "basefont",
    "br",
    "col",
    "command",
    "embed",
    "frame",
    "hr",
    "img",
    "input",
    "isindex",
    "keygen",
    "link",
    "meta",
    "param",
    "source",
    "track",
    "wbr",
]);
const foreignContextElements = new Set(["math", "svg"]);
const htmlIntegrationElements = new Set([
    "mi",
    "mo",
    "mn",
    "ms",
    "mtext",
    "annotation-xml",
    "foreignobject",
    "desc",
    "title",
]);
const reNameEnd = /\s|\//;
class Parser_Parser {
    constructor(cbs, options = {}) {
        var _a, _b, _c, _d, _e, _f;
        this.options = options;
        /** The start index of the last event. */
        this.startIndex = 0;
        /** The end index of the last event. */
        this.endIndex = 0;
        /**
         * Store the start index of the current open tag,
         * so we can update the start index for attributes.
         */
        this.openTagStart = 0;
        this.tagname = "";
        this.attribname = "";
        this.attribvalue = "";
        this.attribs = null;
        this.stack = [];
        this.buffers = [];
        this.bufferOffset = 0;
        /** The index of the last written buffer. Used when resuming after a `pause()`. */
        this.writeIndex = 0;
        /** Indicates whether the parser has finished running / `.end` has been called. */
        this.ended = false;
        this.cbs = cbs !== null && cbs !== void 0 ? cbs : {};
        this.htmlMode = !this.options.xmlMode;
        this.lowerCaseTagNames = (_a = options.lowerCaseTags) !== null && _a !== void 0 ? _a : this.htmlMode;
        this.lowerCaseAttributeNames =
            (_b = options.lowerCaseAttributeNames) !== null && _b !== void 0 ? _b : this.htmlMode;
        this.recognizeSelfClosing =
            (_c = options.recognizeSelfClosing) !== null && _c !== void 0 ? _c : !this.htmlMode;
        this.tokenizer = new ((_d = options.Tokenizer) !== null && _d !== void 0 ? _d : Tokenizer)(this.options, this);
        this.foreignContext = [!this.htmlMode];
        (_f = (_e = this.cbs).onparserinit) === null || _f === void 0 ? void 0 : _f.call(_e, this);
    }
    // Tokenizer event handlers
    /** @internal */
    ontext(start, endIndex) {
        var _a, _b;
        const data = this.getSlice(start, endIndex);
        this.endIndex = endIndex - 1;
        (_b = (_a = this.cbs).ontext) === null || _b === void 0 ? void 0 : _b.call(_a, data);
        this.startIndex = endIndex;
    }
    /** @internal */
    ontextentity(cp, endIndex) {
        var _a, _b;
        this.endIndex = endIndex - 1;
        (_b = (_a = this.cbs).ontext) === null || _b === void 0 ? void 0 : _b.call(_a, fromCodePoint(cp));
        this.startIndex = endIndex;
    }
    /**
     * Checks if the current tag is a void element. Override this if you want
     * to specify your own additional void elements.
     */
    isVoidElement(name) {
        return this.htmlMode && voidElements.has(name);
    }
    /** @internal */
    onopentagname(start, endIndex) {
        this.endIndex = endIndex;
        let name = this.getSlice(start, endIndex);
        if (this.lowerCaseTagNames) {
            name = name.toLowerCase();
        }
        this.emitOpenTag(name);
    }
    emitOpenTag(name) {
        var _a, _b, _c, _d;
        this.openTagStart = this.startIndex;
        this.tagname = name;
        const impliesClose = this.htmlMode && openImpliesClose.get(name);
        if (impliesClose) {
            while (this.stack.length > 0 && impliesClose.has(this.stack[0])) {
                const element = this.stack.shift();
                (_b = (_a = this.cbs).onclosetag) === null || _b === void 0 ? void 0 : _b.call(_a, element, true);
            }
        }
        if (!this.isVoidElement(name)) {
            this.stack.unshift(name);
            if (this.htmlMode) {
                if (foreignContextElements.has(name)) {
                    this.foreignContext.unshift(true);
                }
                else if (htmlIntegrationElements.has(name)) {
                    this.foreignContext.unshift(false);
                }
            }
        }
        (_d = (_c = this.cbs).onopentagname) === null || _d === void 0 ? void 0 : _d.call(_c, name);
        if (this.cbs.onopentag)
            this.attribs = {};
    }
    endOpenTag(isImplied) {
        var _a, _b;
        this.startIndex = this.openTagStart;
        if (this.attribs) {
            (_b = (_a = this.cbs).onopentag) === null || _b === void 0 ? void 0 : _b.call(_a, this.tagname, this.attribs, isImplied);
            this.attribs = null;
        }
        if (this.cbs.onclosetag && this.isVoidElement(this.tagname)) {
            this.cbs.onclosetag(this.tagname, true);
        }
        this.tagname = "";
    }
    /** @internal */
    onopentagend(endIndex) {
        this.endIndex = endIndex;
        this.endOpenTag(false);
        // Set `startIndex` for next node
        this.startIndex = endIndex + 1;
    }
    /** @internal */
    onclosetag(start, endIndex) {
        var _a, _b, _c, _d, _e, _f, _g, _h;
        this.endIndex = endIndex;
        let name = this.getSlice(start, endIndex);
        if (this.lowerCaseTagNames) {
            name = name.toLowerCase();
        }
        if (this.htmlMode &&
            (foreignContextElements.has(name) ||
                htmlIntegrationElements.has(name))) {
            this.foreignContext.shift();
        }
        if (!this.isVoidElement(name)) {
            const pos = this.stack.indexOf(name);
            if (pos !== -1) {
                for (let index = 0; index <= pos; index++) {
                    const element = this.stack.shift();
                    // We know the stack has sufficient elements.
                    (_b = (_a = this.cbs).onclosetag) === null || _b === void 0 ? void 0 : _b.call(_a, element, index !== pos);
                }
            }
            else if (this.htmlMode && name === "p") {
                // Implicit open before close
                this.emitOpenTag("p");
                this.closeCurrentTag(true);
            }
        }
        else if (this.htmlMode && name === "br") {
            // We can't use `emitOpenTag` for implicit open, as `br` would be implicitly closed.
            (_d = (_c = this.cbs).onopentagname) === null || _d === void 0 ? void 0 : _d.call(_c, "br");
            (_f = (_e = this.cbs).onopentag) === null || _f === void 0 ? void 0 : _f.call(_e, "br", {}, true);
            (_h = (_g = this.cbs).onclosetag) === null || _h === void 0 ? void 0 : _h.call(_g, "br", false);
        }
        // Set `startIndex` for next node
        this.startIndex = endIndex + 1;
    }
    /** @internal */
    onselfclosingtag(endIndex) {
        this.endIndex = endIndex;
        if (this.recognizeSelfClosing || this.foreignContext[0]) {
            this.closeCurrentTag(false);
            // Set `startIndex` for next node
            this.startIndex = endIndex + 1;
        }
        else {
            // Ignore the fact that the tag is self-closing.
            this.onopentagend(endIndex);
        }
    }
    closeCurrentTag(isOpenImplied) {
        var _a, _b;
        const name = this.tagname;
        this.endOpenTag(isOpenImplied);
        // Self-closing tags will be on the top of the stack
        if (this.stack[0] === name) {
            // If the opening tag isn't implied, the closing tag has to be implied.
            (_b = (_a = this.cbs).onclosetag) === null || _b === void 0 ? void 0 : _b.call(_a, name, !isOpenImplied);
            this.stack.shift();
        }
    }
    /** @internal */
    onattribname(start, endIndex) {
        this.startIndex = start;
        const name = this.getSlice(start, endIndex);
        this.attribname = this.lowerCaseAttributeNames
            ? name.toLowerCase()
            : name;
    }
    /** @internal */
    onattribdata(start, endIndex) {
        this.attribvalue += this.getSlice(start, endIndex);
    }
    /** @internal */
    onattribentity(cp) {
        this.attribvalue += fromCodePoint(cp);
    }
    /** @internal */
    onattribend(quote, endIndex) {
        var _a, _b;
        this.endIndex = endIndex;
        (_b = (_a = this.cbs).onattribute) === null || _b === void 0 ? void 0 : _b.call(_a, this.attribname, this.attribvalue, quote === QuoteType.Double
            ? '"'
            : quote === QuoteType.Single
                ? "'"
                : quote === QuoteType.NoValue
                    ? undefined
                    : null);
        if (this.attribs &&
            !Object.prototype.hasOwnProperty.call(this.attribs, this.attribname)) {
            this.attribs[this.attribname] = this.attribvalue;
        }
        this.attribvalue = "";
    }
    getInstructionName(value) {
        const index = value.search(reNameEnd);
        let name = index < 0 ? value : value.substr(0, index);
        if (this.lowerCaseTagNames) {
            name = name.toLowerCase();
        }
        return name;
    }
    /** @internal */
    ondeclaration(start, endIndex) {
        this.endIndex = endIndex;
        const value = this.getSlice(start, endIndex);
        if (this.cbs.onprocessinginstruction) {
            const name = this.getInstructionName(value);
            this.cbs.onprocessinginstruction(`!${name}`, `!${value}`);
        }
        // Set `startIndex` for next node
        this.startIndex = endIndex + 1;
    }
    /** @internal */
    onprocessinginstruction(start, endIndex) {
        this.endIndex = endIndex;
        const value = this.getSlice(start, endIndex);
        if (this.cbs.onprocessinginstruction) {
            const name = this.getInstructionName(value);
            this.cbs.onprocessinginstruction(`?${name}`, `?${value}`);
        }
        // Set `startIndex` for next node
        this.startIndex = endIndex + 1;
    }
    /** @internal */
    oncomment(start, endIndex, offset) {
        var _a, _b, _c, _d;
        this.endIndex = endIndex;
        (_b = (_a = this.cbs).oncomment) === null || _b === void 0 ? void 0 : _b.call(_a, this.getSlice(start, endIndex - offset));
        (_d = (_c = this.cbs).oncommentend) === null || _d === void 0 ? void 0 : _d.call(_c);
        // Set `startIndex` for next node
        this.startIndex = endIndex + 1;
    }
    /** @internal */
    oncdata(start, endIndex, offset) {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k;
        this.endIndex = endIndex;
        const value = this.getSlice(start, endIndex - offset);
        if (!this.htmlMode || this.options.recognizeCDATA) {
            (_b = (_a = this.cbs).oncdatastart) === null || _b === void 0 ? void 0 : _b.call(_a);
            (_d = (_c = this.cbs).ontext) === null || _d === void 0 ? void 0 : _d.call(_c, value);
            (_f = (_e = this.cbs).oncdataend) === null || _f === void 0 ? void 0 : _f.call(_e);
        }
        else {
            (_h = (_g = this.cbs).oncomment) === null || _h === void 0 ? void 0 : _h.call(_g, `[CDATA[${value}]]`);
            (_k = (_j = this.cbs).oncommentend) === null || _k === void 0 ? void 0 : _k.call(_j);
        }
        // Set `startIndex` for next node
        this.startIndex = endIndex + 1;
    }
    /** @internal */
    onend() {
        var _a, _b;
        if (this.cbs.onclosetag) {
            // Set the end index for all remaining tags
            this.endIndex = this.startIndex;
            for (let index = 0; index < this.stack.length; index++) {
                this.cbs.onclosetag(this.stack[index], true);
            }
        }
        (_b = (_a = this.cbs).onend) === null || _b === void 0 ? void 0 : _b.call(_a);
    }
    /**
     * Resets the parser to a blank state, ready to parse a new HTML document
     */
    reset() {
        var _a, _b, _c, _d;
        (_b = (_a = this.cbs).onreset) === null || _b === void 0 ? void 0 : _b.call(_a);
        this.tokenizer.reset();
        this.tagname = "";
        this.attribname = "";
        this.attribs = null;
        this.stack.length = 0;
        this.startIndex = 0;
        this.endIndex = 0;
        (_d = (_c = this.cbs).onparserinit) === null || _d === void 0 ? void 0 : _d.call(_c, this);
        this.buffers.length = 0;
        this.foreignContext.length = 0;
        this.foreignContext.unshift(!this.htmlMode);
        this.bufferOffset = 0;
        this.writeIndex = 0;
        this.ended = false;
    }
    /**
     * Resets the parser, then parses a complete document and
     * pushes it to the handler.
     *
     * @param data Document to parse.
     */
    parseComplete(data) {
        this.reset();
        this.end(data);
    }
    getSlice(start, end) {
        while (start - this.bufferOffset >= this.buffers[0].length) {
            this.shiftBuffer();
        }
        let slice = this.buffers[0].slice(start - this.bufferOffset, end - this.bufferOffset);
        while (end - this.bufferOffset > this.buffers[0].length) {
            this.shiftBuffer();
            slice += this.buffers[0].slice(0, end - this.bufferOffset);
        }
        return slice;
    }
    shiftBuffer() {
        this.bufferOffset += this.buffers[0].length;
        this.writeIndex--;
        this.buffers.shift();
    }
    /**
     * Parses a chunk of data and calls the corresponding callbacks.
     *
     * @param chunk Chunk to parse.
     */
    write(chunk) {
        var _a, _b;
        if (this.ended) {
            (_b = (_a = this.cbs).onerror) === null || _b === void 0 ? void 0 : _b.call(_a, new Error(".write() after done!"));
            return;
        }
        this.buffers.push(chunk);
        if (this.tokenizer.running) {
            this.tokenizer.write(chunk);
            this.writeIndex++;
        }
    }
    /**
     * Parses the end of the buffer and clears the stack, calls onend.
     *
     * @param chunk Optional final chunk to parse.
     */
    end(chunk) {
        var _a, _b;
        if (this.ended) {
            (_b = (_a = this.cbs).onerror) === null || _b === void 0 ? void 0 : _b.call(_a, new Error(".end() after done!"));
            return;
        }
        if (chunk)
            this.write(chunk);
        this.ended = true;
        this.tokenizer.end();
    }
    /**
     * Pauses parsing. The parser won't emit events until `resume` is called.
     */
    pause() {
        this.tokenizer.pause();
    }
    /**
     * Resumes parsing after `pause` was called.
     */
    resume() {
        this.tokenizer.resume();
        while (this.tokenizer.running &&
            this.writeIndex < this.buffers.length) {
            this.tokenizer.write(this.buffers[this.writeIndex++]);
        }
        if (this.ended)
            this.tokenizer.end();
    }
    /**
     * Alias of `write`, for backwards compatibility.
     *
     * @param chunk Chunk to parse.
     * @deprecated
     */
    parseChunk(chunk) {
        this.write(chunk);
    }
    /**
     * Alias of `end`, for backwards compatibility.
     *
     * @param chunk Optional final chunk to parse.
     * @deprecated
     */
    done(chunk) {
        this.end(chunk);
    }
}
//# sourceMappingURL=Parser.js.map
;// CONCATENATED MODULE: ./node_modules/domelementtype/lib/esm/index.js
/** Types of elements found in htmlparser2's DOM */
var esm_ElementType;
(function (ElementType) {
    /** Type for the root element of a document */
    ElementType["Root"] = "root";
    /** Type for Text */
    ElementType["Text"] = "text";
    /** Type for <? ... ?> */
    ElementType["Directive"] = "directive";
    /** Type for <!-- ... --> */
    ElementType["Comment"] = "comment";
    /** Type for <script> tags */
    ElementType["Script"] = "script";
    /** Type for <style> tags */
    ElementType["Style"] = "style";
    /** Type for Any tag */
    ElementType["Tag"] = "tag";
    /** Type for <![CDATA[ ... ]]> */
    ElementType["CDATA"] = "cdata";
    /** Type for <!doctype ...> */
    ElementType["Doctype"] = "doctype";
})(esm_ElementType || (esm_ElementType = {}));
/**
 * Tests whether an element is a tag or not.
 *
 * @param elem Element to test
 */
function esm_isTag(elem) {
    return (elem.type === esm_ElementType.Tag ||
        elem.type === esm_ElementType.Script ||
        elem.type === esm_ElementType.Style);
}
// Exports for backwards compatibility
/** Type for the root element of a document */
const Root = esm_ElementType.Root;
/** Type for Text */
const esm_Text = esm_ElementType.Text;
/** Type for <? ... ?> */
const Directive = esm_ElementType.Directive;
/** Type for <!-- ... --> */
const esm_Comment = esm_ElementType.Comment;
/** Type for <script> tags */
const Script = esm_ElementType.Script;
/** Type for <style> tags */
const Style = esm_ElementType.Style;
/** Type for Any tag */
const Tag = esm_ElementType.Tag;
/** Type for <![CDATA[ ... ]]> */
const esm_CDATA = esm_ElementType.CDATA;
/** Type for <!doctype ...> */
const Doctype = esm_ElementType.Doctype;

;// CONCATENATED MODULE: ./node_modules/domhandler/lib/esm/node.js

/**
 * This object will be used as the prototype for Nodes when creating a
 * DOM-Level-1-compliant structure.
 */
class Node {
    constructor() {
        /** Parent of the node */
        this.parent = null;
        /** Previous sibling */
        this.prev = null;
        /** Next sibling */
        this.next = null;
        /** The start index of the node. Requires `withStartIndices` on the handler to be `true. */
        this.startIndex = null;
        /** The end index of the node. Requires `withEndIndices` on the handler to be `true. */
        this.endIndex = null;
    }
    // Read-write aliases for properties
    /**
     * Same as {@link parent}.
     * [DOM spec](https://dom.spec.whatwg.org)-compatible alias.
     */
    get parentNode() {
        return this.parent;
    }
    set parentNode(parent) {
        this.parent = parent;
    }
    /**
     * Same as {@link prev}.
     * [DOM spec](https://dom.spec.whatwg.org)-compatible alias.
     */
    get previousSibling() {
        return this.prev;
    }
    set previousSibling(prev) {
        this.prev = prev;
    }
    /**
     * Same as {@link next}.
     * [DOM spec](https://dom.spec.whatwg.org)-compatible alias.
     */
    get nextSibling() {
        return this.next;
    }
    set nextSibling(next) {
        this.next = next;
    }
    /**
     * Clone this node, and optionally its children.
     *
     * @param recursive Clone child nodes as well.
     * @returns A clone of the node.
     */
    cloneNode(recursive = false) {
        return cloneNode(this, recursive);
    }
}
/**
 * A node that contains some data.
 */
class DataNode extends (/* unused pure expression or super */ null && (Node)) {
    /**
     * @param data The content of the data node
     */
    constructor(data) {
        super();
        this.data = data;
    }
    /**
     * Same as {@link data}.
     * [DOM spec](https://dom.spec.whatwg.org)-compatible alias.
     */
    get nodeValue() {
        return this.data;
    }
    set nodeValue(data) {
        this.data = data;
    }
}
/**
 * Text within the document.
 */
class node_Text extends (/* unused pure expression or super */ null && (DataNode)) {
    constructor() {
        super(...arguments);
        this.type = ElementType.Text;
    }
    get nodeType() {
        return 3;
    }
}
/**
 * Comments within the document.
 */
class node_Comment extends (/* unused pure expression or super */ null && (DataNode)) {
    constructor() {
        super(...arguments);
        this.type = ElementType.Comment;
    }
    get nodeType() {
        return 8;
    }
}
/**
 * Processing instructions, including doc types.
 */
class node_ProcessingInstruction extends (/* unused pure expression or super */ null && (DataNode)) {
    constructor(name, data) {
        super(data);
        this.name = name;
        this.type = ElementType.Directive;
    }
    get nodeType() {
        return 1;
    }
}
/**
 * A `Node` that can have children.
 */
class NodeWithChildren extends (/* unused pure expression or super */ null && (Node)) {
    /**
     * @param children Children of the node. Only certain node types can have children.
     */
    constructor(children) {
        super();
        this.children = children;
    }
    // Aliases
    /** First child of the node. */
    get firstChild() {
        var _a;
        return (_a = this.children[0]) !== null && _a !== void 0 ? _a : null;
    }
    /** Last child of the node. */
    get lastChild() {
        return this.children.length > 0
            ? this.children[this.children.length - 1]
            : null;
    }
    /**
     * Same as {@link children}.
     * [DOM spec](https://dom.spec.whatwg.org)-compatible alias.
     */
    get childNodes() {
        return this.children;
    }
    set childNodes(children) {
        this.children = children;
    }
}
class node_CDATA extends (/* unused pure expression or super */ null && (NodeWithChildren)) {
    constructor() {
        super(...arguments);
        this.type = ElementType.CDATA;
    }
    get nodeType() {
        return 4;
    }
}
/**
 * The root node of the document.
 */
class node_Document extends (/* unused pure expression or super */ null && (NodeWithChildren)) {
    constructor() {
        super(...arguments);
        this.type = ElementType.Root;
    }
    get nodeType() {
        return 9;
    }
}
/**
 * An element within the DOM.
 */
class node_Element extends (/* unused pure expression or super */ null && (NodeWithChildren)) {
    /**
     * @param name Name of the tag, eg. `div`, `span`.
     * @param attribs Object mapping attribute names to attribute values.
     * @param children Children of the node.
     */
    constructor(name, attribs, children = [], type = name === "script"
        ? ElementType.Script
        : name === "style"
            ? ElementType.Style
            : ElementType.Tag) {
        super(children);
        this.name = name;
        this.attribs = attribs;
        this.type = type;
    }
    get nodeType() {
        return 1;
    }
    // DOM Level 1 aliases
    /**
     * Same as {@link name}.
     * [DOM spec](https://dom.spec.whatwg.org)-compatible alias.
     */
    get tagName() {
        return this.name;
    }
    set tagName(name) {
        this.name = name;
    }
    get attributes() {
        return Object.keys(this.attribs).map((name) => {
            var _a, _b;
            return ({
                name,
                value: this.attribs[name],
                namespace: (_a = this["x-attribsNamespace"]) === null || _a === void 0 ? void 0 : _a[name],
                prefix: (_b = this["x-attribsPrefix"]) === null || _b === void 0 ? void 0 : _b[name],
            });
        });
    }
}
/**
 * @param node Node to check.
 * @returns `true` if the node is a `Element`, `false` otherwise.
 */
function node_isTag(node) {
    return esm_isTag(node);
}
/**
 * @param node Node to check.
 * @returns `true` if the node has the type `CDATA`, `false` otherwise.
 */
function node_isCDATA(node) {
    return node.type === ElementType.CDATA;
}
/**
 * @param node Node to check.
 * @returns `true` if the node has the type `Text`, `false` otherwise.
 */
function node_isText(node) {
    return node.type === esm_ElementType.Text;
}
/**
 * @param node Node to check.
 * @returns `true` if the node has the type `Comment`, `false` otherwise.
 */
function node_isComment(node) {
    return node.type === ElementType.Comment;
}
/**
 * @param node Node to check.
 * @returns `true` if the node has the type `ProcessingInstruction`, `false` otherwise.
 */
function isDirective(node) {
    return node.type === ElementType.Directive;
}
/**
 * @param node Node to check.
 * @returns `true` if the node has the type `ProcessingInstruction`, `false` otherwise.
 */
function isDocument(node) {
    return node.type === ElementType.Root;
}
/**
 * @param node Node to check.
 * @returns `true` if the node has children, `false` otherwise.
 */
function node_hasChildren(node) {
    return Object.prototype.hasOwnProperty.call(node, "children");
}
/**
 * Clone a node, and optionally its children.
 *
 * @param recursive Clone child nodes as well.
 * @returns A clone of the node.
 */
function cloneNode(node, recursive = false) {
    let result;
    if (node_isText(node)) {
        result = new node_Text(node.data);
    }
    else if (node_isComment(node)) {
        result = new node_Comment(node.data);
    }
    else if (node_isTag(node)) {
        const children = recursive ? cloneChildren(node.children) : [];
        const clone = new node_Element(node.name, { ...node.attribs }, children);
        children.forEach((child) => (child.parent = clone));
        if (node.namespace != null) {
            clone.namespace = node.namespace;
        }
        if (node["x-attribsNamespace"]) {
            clone["x-attribsNamespace"] = { ...node["x-attribsNamespace"] };
        }
        if (node["x-attribsPrefix"]) {
            clone["x-attribsPrefix"] = { ...node["x-attribsPrefix"] };
        }
        result = clone;
    }
    else if (node_isCDATA(node)) {
        const children = recursive ? cloneChildren(node.children) : [];
        const clone = new node_CDATA(children);
        children.forEach((child) => (child.parent = clone));
        result = clone;
    }
    else if (isDocument(node)) {
        const children = recursive ? cloneChildren(node.children) : [];
        const clone = new node_Document(children);
        children.forEach((child) => (child.parent = clone));
        if (node["x-mode"]) {
            clone["x-mode"] = node["x-mode"];
        }
        result = clone;
    }
    else if (isDirective(node)) {
        const instruction = new node_ProcessingInstruction(node.name, node.data);
        if (node["x-name"] != null) {
            instruction["x-name"] = node["x-name"];
            instruction["x-publicId"] = node["x-publicId"];
            instruction["x-systemId"] = node["x-systemId"];
        }
        result = instruction;
    }
    else {
        throw new Error(`Not implemented yet: ${node.type}`);
    }
    result.startIndex = node.startIndex;
    result.endIndex = node.endIndex;
    if (node.sourceCodeLocation != null) {
        result.sourceCodeLocation = node.sourceCodeLocation;
    }
    return result;
}
function cloneChildren(childs) {
    const children = childs.map((child) => cloneNode(child, true));
    for (let i = 1; i < children.length; i++) {
        children[i].prev = children[i - 1];
        children[i - 1].next = children[i];
    }
    return children;
}

;// CONCATENATED MODULE: ./node_modules/domhandler/lib/esm/index.js



// Default options
const defaultOpts = {
    withStartIndices: false,
    withEndIndices: false,
    xmlMode: false,
};
class esm_DomHandler {
    /**
     * @param callback Called once parsing has completed.
     * @param options Settings for the handler.
     * @param elementCB Callback whenever a tag is closed.
     */
    constructor(callback, options, elementCB) {
        /** The elements of the DOM */
        this.dom = [];
        /** The root element for the DOM */
        this.root = new Document(this.dom);
        /** Indicated whether parsing has been completed. */
        this.done = false;
        /** Stack of open tags. */
        this.tagStack = [this.root];
        /** A data node that is still being written to. */
        this.lastNode = null;
        /** Reference to the parser instance. Used for location information. */
        this.parser = null;
        // Make it possible to skip arguments, for backwards-compatibility
        if (typeof options === "function") {
            elementCB = options;
            options = defaultOpts;
        }
        if (typeof callback === "object") {
            options = callback;
            callback = undefined;
        }
        this.callback = callback !== null && callback !== void 0 ? callback : null;
        this.options = options !== null && options !== void 0 ? options : defaultOpts;
        this.elementCB = elementCB !== null && elementCB !== void 0 ? elementCB : null;
    }
    onparserinit(parser) {
        this.parser = parser;
    }
    // Resets the handler back to starting state
    onreset() {
        this.dom = [];
        this.root = new Document(this.dom);
        this.done = false;
        this.tagStack = [this.root];
        this.lastNode = null;
        this.parser = null;
    }
    // Signals the handler that parsing is done
    onend() {
        if (this.done)
            return;
        this.done = true;
        this.parser = null;
        this.handleCallback(null);
    }
    onerror(error) {
        this.handleCallback(error);
    }
    onclosetag() {
        this.lastNode = null;
        const elem = this.tagStack.pop();
        if (this.options.withEndIndices) {
            elem.endIndex = this.parser.endIndex;
        }
        if (this.elementCB)
            this.elementCB(elem);
    }
    onopentag(name, attribs) {
        const type = this.options.xmlMode ? ElementType.Tag : undefined;
        const element = new Element(name, attribs, undefined, type);
        this.addNode(element);
        this.tagStack.push(element);
    }
    ontext(data) {
        const { lastNode } = this;
        if (lastNode && lastNode.type === ElementType.Text) {
            lastNode.data += data;
            if (this.options.withEndIndices) {
                lastNode.endIndex = this.parser.endIndex;
            }
        }
        else {
            const node = new Text(data);
            this.addNode(node);
            this.lastNode = node;
        }
    }
    oncomment(data) {
        if (this.lastNode && this.lastNode.type === ElementType.Comment) {
            this.lastNode.data += data;
            return;
        }
        const node = new Comment(data);
        this.addNode(node);
        this.lastNode = node;
    }
    oncommentend() {
        this.lastNode = null;
    }
    oncdatastart() {
        const text = new Text("");
        const node = new CDATA([text]);
        this.addNode(node);
        text.parent = node;
        this.lastNode = text;
    }
    oncdataend() {
        this.lastNode = null;
    }
    onprocessinginstruction(name, data) {
        const node = new ProcessingInstruction(name, data);
        this.addNode(node);
    }
    handleCallback(error) {
        if (typeof this.callback === "function") {
            this.callback(error, this.dom);
        }
        else if (error) {
            throw error;
        }
    }
    addNode(node) {
        const parent = this.tagStack[this.tagStack.length - 1];
        const previousSibling = parent.children[parent.children.length - 1];
        if (this.options.withStartIndices) {
            node.startIndex = this.parser.startIndex;
        }
        if (this.options.withEndIndices) {
            node.endIndex = this.parser.endIndex;
        }
        parent.children.push(node);
        if (previousSibling) {
            node.prev = previousSibling;
            previousSibling.next = node;
        }
        node.parent = parent;
        this.lastNode = null;
    }
}
/* harmony default export */ var lib_esm = ((/* unused pure expression or super */ null && (esm_DomHandler)));

;// CONCATENATED MODULE: ./node_modules/entities/lib/esm/generated/encode-html.js
// Generated using scripts/write-encode-map.ts
function restoreDiff(arr) {
    for (let i = 1; i < arr.length; i++) {
        arr[i][0] += arr[i - 1][0] + 1;
    }
    return arr;
}
// prettier-ignore
/* harmony default export */ var encode_html = (new Map(/* #__PURE__ */ restoreDiff([[9, "&Tab;"], [0, "&NewLine;"], [22, "&excl;"], [0, "&quot;"], [0, "&num;"], [0, "&dollar;"], [0, "&percnt;"], [0, "&amp;"], [0, "&apos;"], [0, "&lpar;"], [0, "&rpar;"], [0, "&ast;"], [0, "&plus;"], [0, "&comma;"], [1, "&period;"], [0, "&sol;"], [10, "&colon;"], [0, "&semi;"], [0, { v: "&lt;", n: 8402, o: "&nvlt;" }], [0, { v: "&equals;", n: 8421, o: "&bne;" }], [0, { v: "&gt;", n: 8402, o: "&nvgt;" }], [0, "&quest;"], [0, "&commat;"], [26, "&lbrack;"], [0, "&bsol;"], [0, "&rbrack;"], [0, "&Hat;"], [0, "&lowbar;"], [0, "&DiacriticalGrave;"], [5, { n: 106, o: "&fjlig;" }], [20, "&lbrace;"], [0, "&verbar;"], [0, "&rbrace;"], [34, "&nbsp;"], [0, "&iexcl;"], [0, "&cent;"], [0, "&pound;"], [0, "&curren;"], [0, "&yen;"], [0, "&brvbar;"], [0, "&sect;"], [0, "&die;"], [0, "&copy;"], [0, "&ordf;"], [0, "&laquo;"], [0, "&not;"], [0, "&shy;"], [0, "&circledR;"], [0, "&macr;"], [0, "&deg;"], [0, "&PlusMinus;"], [0, "&sup2;"], [0, "&sup3;"], [0, "&acute;"], [0, "&micro;"], [0, "&para;"], [0, "&centerdot;"], [0, "&cedil;"], [0, "&sup1;"], [0, "&ordm;"], [0, "&raquo;"], [0, "&frac14;"], [0, "&frac12;"], [0, "&frac34;"], [0, "&iquest;"], [0, "&Agrave;"], [0, "&Aacute;"], [0, "&Acirc;"], [0, "&Atilde;"], [0, "&Auml;"], [0, "&angst;"], [0, "&AElig;"], [0, "&Ccedil;"], [0, "&Egrave;"], [0, "&Eacute;"], [0, "&Ecirc;"], [0, "&Euml;"], [0, "&Igrave;"], [0, "&Iacute;"], [0, "&Icirc;"], [0, "&Iuml;"], [0, "&ETH;"], [0, "&Ntilde;"], [0, "&Ograve;"], [0, "&Oacute;"], [0, "&Ocirc;"], [0, "&Otilde;"], [0, "&Ouml;"], [0, "&times;"], [0, "&Oslash;"], [0, "&Ugrave;"], [0, "&Uacute;"], [0, "&Ucirc;"], [0, "&Uuml;"], [0, "&Yacute;"], [0, "&THORN;"], [0, "&szlig;"], [0, "&agrave;"], [0, "&aacute;"], [0, "&acirc;"], [0, "&atilde;"], [0, "&auml;"], [0, "&aring;"], [0, "&aelig;"], [0, "&ccedil;"], [0, "&egrave;"], [0, "&eacute;"], [0, "&ecirc;"], [0, "&euml;"], [0, "&igrave;"], [0, "&iacute;"], [0, "&icirc;"], [0, "&iuml;"], [0, "&eth;"], [0, "&ntilde;"], [0, "&ograve;"], [0, "&oacute;"], [0, "&ocirc;"], [0, "&otilde;"], [0, "&ouml;"], [0, "&div;"], [0, "&oslash;"], [0, "&ugrave;"], [0, "&uacute;"], [0, "&ucirc;"], [0, "&uuml;"], [0, "&yacute;"], [0, "&thorn;"], [0, "&yuml;"], [0, "&Amacr;"], [0, "&amacr;"], [0, "&Abreve;"], [0, "&abreve;"], [0, "&Aogon;"], [0, "&aogon;"], [0, "&Cacute;"], [0, "&cacute;"], [0, "&Ccirc;"], [0, "&ccirc;"], [0, "&Cdot;"], [0, "&cdot;"], [0, "&Ccaron;"], [0, "&ccaron;"], [0, "&Dcaron;"], [0, "&dcaron;"], [0, "&Dstrok;"], [0, "&dstrok;"], [0, "&Emacr;"], [0, "&emacr;"], [2, "&Edot;"], [0, "&edot;"], [0, "&Eogon;"], [0, "&eogon;"], [0, "&Ecaron;"], [0, "&ecaron;"], [0, "&Gcirc;"], [0, "&gcirc;"], [0, "&Gbreve;"], [0, "&gbreve;"], [0, "&Gdot;"], [0, "&gdot;"], [0, "&Gcedil;"], [1, "&Hcirc;"], [0, "&hcirc;"], [0, "&Hstrok;"], [0, "&hstrok;"], [0, "&Itilde;"], [0, "&itilde;"], [0, "&Imacr;"], [0, "&imacr;"], [2, "&Iogon;"], [0, "&iogon;"], [0, "&Idot;"], [0, "&imath;"], [0, "&IJlig;"], [0, "&ijlig;"], [0, "&Jcirc;"], [0, "&jcirc;"], [0, "&Kcedil;"], [0, "&kcedil;"], [0, "&kgreen;"], [0, "&Lacute;"], [0, "&lacute;"], [0, "&Lcedil;"], [0, "&lcedil;"], [0, "&Lcaron;"], [0, "&lcaron;"], [0, "&Lmidot;"], [0, "&lmidot;"], [0, "&Lstrok;"], [0, "&lstrok;"], [0, "&Nacute;"], [0, "&nacute;"], [0, "&Ncedil;"], [0, "&ncedil;"], [0, "&Ncaron;"], [0, "&ncaron;"], [0, "&napos;"], [0, "&ENG;"], [0, "&eng;"], [0, "&Omacr;"], [0, "&omacr;"], [2, "&Odblac;"], [0, "&odblac;"], [0, "&OElig;"], [0, "&oelig;"], [0, "&Racute;"], [0, "&racute;"], [0, "&Rcedil;"], [0, "&rcedil;"], [0, "&Rcaron;"], [0, "&rcaron;"], [0, "&Sacute;"], [0, "&sacute;"], [0, "&Scirc;"], [0, "&scirc;"], [0, "&Scedil;"], [0, "&scedil;"], [0, "&Scaron;"], [0, "&scaron;"], [0, "&Tcedil;"], [0, "&tcedil;"], [0, "&Tcaron;"], [0, "&tcaron;"], [0, "&Tstrok;"], [0, "&tstrok;"], [0, "&Utilde;"], [0, "&utilde;"], [0, "&Umacr;"], [0, "&umacr;"], [0, "&Ubreve;"], [0, "&ubreve;"], [0, "&Uring;"], [0, "&uring;"], [0, "&Udblac;"], [0, "&udblac;"], [0, "&Uogon;"], [0, "&uogon;"], [0, "&Wcirc;"], [0, "&wcirc;"], [0, "&Ycirc;"], [0, "&ycirc;"], [0, "&Yuml;"], [0, "&Zacute;"], [0, "&zacute;"], [0, "&Zdot;"], [0, "&zdot;"], [0, "&Zcaron;"], [0, "&zcaron;"], [19, "&fnof;"], [34, "&imped;"], [63, "&gacute;"], [65, "&jmath;"], [142, "&circ;"], [0, "&caron;"], [16, "&breve;"], [0, "&DiacriticalDot;"], [0, "&ring;"], [0, "&ogon;"], [0, "&DiacriticalTilde;"], [0, "&dblac;"], [51, "&DownBreve;"], [127, "&Alpha;"], [0, "&Beta;"], [0, "&Gamma;"], [0, "&Delta;"], [0, "&Epsilon;"], [0, "&Zeta;"], [0, "&Eta;"], [0, "&Theta;"], [0, "&Iota;"], [0, "&Kappa;"], [0, "&Lambda;"], [0, "&Mu;"], [0, "&Nu;"], [0, "&Xi;"], [0, "&Omicron;"], [0, "&Pi;"], [0, "&Rho;"], [1, "&Sigma;"], [0, "&Tau;"], [0, "&Upsilon;"], [0, "&Phi;"], [0, "&Chi;"], [0, "&Psi;"], [0, "&ohm;"], [7, "&alpha;"], [0, "&beta;"], [0, "&gamma;"], [0, "&delta;"], [0, "&epsi;"], [0, "&zeta;"], [0, "&eta;"], [0, "&theta;"], [0, "&iota;"], [0, "&kappa;"], [0, "&lambda;"], [0, "&mu;"], [0, "&nu;"], [0, "&xi;"], [0, "&omicron;"], [0, "&pi;"], [0, "&rho;"], [0, "&sigmaf;"], [0, "&sigma;"], [0, "&tau;"], [0, "&upsi;"], [0, "&phi;"], [0, "&chi;"], [0, "&psi;"], [0, "&omega;"], [7, "&thetasym;"], [0, "&Upsi;"], [2, "&phiv;"], [0, "&piv;"], [5, "&Gammad;"], [0, "&digamma;"], [18, "&kappav;"], [0, "&rhov;"], [3, "&epsiv;"], [0, "&backepsilon;"], [10, "&IOcy;"], [0, "&DJcy;"], [0, "&GJcy;"], [0, "&Jukcy;"], [0, "&DScy;"], [0, "&Iukcy;"], [0, "&YIcy;"], [0, "&Jsercy;"], [0, "&LJcy;"], [0, "&NJcy;"], [0, "&TSHcy;"], [0, "&KJcy;"], [1, "&Ubrcy;"], [0, "&DZcy;"], [0, "&Acy;"], [0, "&Bcy;"], [0, "&Vcy;"], [0, "&Gcy;"], [0, "&Dcy;"], [0, "&IEcy;"], [0, "&ZHcy;"], [0, "&Zcy;"], [0, "&Icy;"], [0, "&Jcy;"], [0, "&Kcy;"], [0, "&Lcy;"], [0, "&Mcy;"], [0, "&Ncy;"], [0, "&Ocy;"], [0, "&Pcy;"], [0, "&Rcy;"], [0, "&Scy;"], [0, "&Tcy;"], [0, "&Ucy;"], [0, "&Fcy;"], [0, "&KHcy;"], [0, "&TScy;"], [0, "&CHcy;"], [0, "&SHcy;"], [0, "&SHCHcy;"], [0, "&HARDcy;"], [0, "&Ycy;"], [0, "&SOFTcy;"], [0, "&Ecy;"], [0, "&YUcy;"], [0, "&YAcy;"], [0, "&acy;"], [0, "&bcy;"], [0, "&vcy;"], [0, "&gcy;"], [0, "&dcy;"], [0, "&iecy;"], [0, "&zhcy;"], [0, "&zcy;"], [0, "&icy;"], [0, "&jcy;"], [0, "&kcy;"], [0, "&lcy;"], [0, "&mcy;"], [0, "&ncy;"], [0, "&ocy;"], [0, "&pcy;"], [0, "&rcy;"], [0, "&scy;"], [0, "&tcy;"], [0, "&ucy;"], [0, "&fcy;"], [0, "&khcy;"], [0, "&tscy;"], [0, "&chcy;"], [0, "&shcy;"], [0, "&shchcy;"], [0, "&hardcy;"], [0, "&ycy;"], [0, "&softcy;"], [0, "&ecy;"], [0, "&yucy;"], [0, "&yacy;"], [1, "&iocy;"], [0, "&djcy;"], [0, "&gjcy;"], [0, "&jukcy;"], [0, "&dscy;"], [0, "&iukcy;"], [0, "&yicy;"], [0, "&jsercy;"], [0, "&ljcy;"], [0, "&njcy;"], [0, "&tshcy;"], [0, "&kjcy;"], [1, "&ubrcy;"], [0, "&dzcy;"], [7074, "&ensp;"], [0, "&emsp;"], [0, "&emsp13;"], [0, "&emsp14;"], [1, "&numsp;"], [0, "&puncsp;"], [0, "&ThinSpace;"], [0, "&hairsp;"], [0, "&NegativeMediumSpace;"], [0, "&zwnj;"], [0, "&zwj;"], [0, "&lrm;"], [0, "&rlm;"], [0, "&dash;"], [2, "&ndash;"], [0, "&mdash;"], [0, "&horbar;"], [0, "&Verbar;"], [1, "&lsquo;"], [0, "&CloseCurlyQuote;"], [0, "&lsquor;"], [1, "&ldquo;"], [0, "&CloseCurlyDoubleQuote;"], [0, "&bdquo;"], [1, "&dagger;"], [0, "&Dagger;"], [0, "&bull;"], [2, "&nldr;"], [0, "&hellip;"], [9, "&permil;"], [0, "&pertenk;"], [0, "&prime;"], [0, "&Prime;"], [0, "&tprime;"], [0, "&backprime;"], [3, "&lsaquo;"], [0, "&rsaquo;"], [3, "&oline;"], [2, "&caret;"], [1, "&hybull;"], [0, "&frasl;"], [10, "&bsemi;"], [7, "&qprime;"], [7, { v: "&MediumSpace;", n: 8202, o: "&ThickSpace;" }], [0, "&NoBreak;"], [0, "&af;"], [0, "&InvisibleTimes;"], [0, "&ic;"], [72, "&euro;"], [46, "&tdot;"], [0, "&DotDot;"], [37, "&complexes;"], [2, "&incare;"], [4, "&gscr;"], [0, "&hamilt;"], [0, "&Hfr;"], [0, "&Hopf;"], [0, "&planckh;"], [0, "&hbar;"], [0, "&imagline;"], [0, "&Ifr;"], [0, "&lagran;"], [0, "&ell;"], [1, "&naturals;"], [0, "&numero;"], [0, "&copysr;"], [0, "&weierp;"], [0, "&Popf;"], [0, "&Qopf;"], [0, "&realine;"], [0, "&real;"], [0, "&reals;"], [0, "&rx;"], [3, "&trade;"], [1, "&integers;"], [2, "&mho;"], [0, "&zeetrf;"], [0, "&iiota;"], [2, "&bernou;"], [0, "&Cayleys;"], [1, "&escr;"], [0, "&Escr;"], [0, "&Fouriertrf;"], [1, "&Mellintrf;"], [0, "&order;"], [0, "&alefsym;"], [0, "&beth;"], [0, "&gimel;"], [0, "&daleth;"], [12, "&CapitalDifferentialD;"], [0, "&dd;"], [0, "&ee;"], [0, "&ii;"], [10, "&frac13;"], [0, "&frac23;"], [0, "&frac15;"], [0, "&frac25;"], [0, "&frac35;"], [0, "&frac45;"], [0, "&frac16;"], [0, "&frac56;"], [0, "&frac18;"], [0, "&frac38;"], [0, "&frac58;"], [0, "&frac78;"], [49, "&larr;"], [0, "&ShortUpArrow;"], [0, "&rarr;"], [0, "&darr;"], [0, "&harr;"], [0, "&updownarrow;"], [0, "&nwarr;"], [0, "&nearr;"], [0, "&LowerRightArrow;"], [0, "&LowerLeftArrow;"], [0, "&nlarr;"], [0, "&nrarr;"], [1, { v: "&rarrw;", n: 824, o: "&nrarrw;" }], [0, "&Larr;"], [0, "&Uarr;"], [0, "&Rarr;"], [0, "&Darr;"], [0, "&larrtl;"], [0, "&rarrtl;"], [0, "&LeftTeeArrow;"], [0, "&mapstoup;"], [0, "&map;"], [0, "&DownTeeArrow;"], [1, "&hookleftarrow;"], [0, "&hookrightarrow;"], [0, "&larrlp;"], [0, "&looparrowright;"], [0, "&harrw;"], [0, "&nharr;"], [1, "&lsh;"], [0, "&rsh;"], [0, "&ldsh;"], [0, "&rdsh;"], [1, "&crarr;"], [0, "&cularr;"], [0, "&curarr;"], [2, "&circlearrowleft;"], [0, "&circlearrowright;"], [0, "&leftharpoonup;"], [0, "&DownLeftVector;"], [0, "&RightUpVector;"], [0, "&LeftUpVector;"], [0, "&rharu;"], [0, "&DownRightVector;"], [0, "&dharr;"], [0, "&dharl;"], [0, "&RightArrowLeftArrow;"], [0, "&udarr;"], [0, "&LeftArrowRightArrow;"], [0, "&leftleftarrows;"], [0, "&upuparrows;"], [0, "&rightrightarrows;"], [0, "&ddarr;"], [0, "&leftrightharpoons;"], [0, "&Equilibrium;"], [0, "&nlArr;"], [0, "&nhArr;"], [0, "&nrArr;"], [0, "&DoubleLeftArrow;"], [0, "&DoubleUpArrow;"], [0, "&DoubleRightArrow;"], [0, "&dArr;"], [0, "&DoubleLeftRightArrow;"], [0, "&DoubleUpDownArrow;"], [0, "&nwArr;"], [0, "&neArr;"], [0, "&seArr;"], [0, "&swArr;"], [0, "&lAarr;"], [0, "&rAarr;"], [1, "&zigrarr;"], [6, "&larrb;"], [0, "&rarrb;"], [15, "&DownArrowUpArrow;"], [7, "&loarr;"], [0, "&roarr;"], [0, "&hoarr;"], [0, "&forall;"], [0, "&comp;"], [0, { v: "&part;", n: 824, o: "&npart;" }], [0, "&exist;"], [0, "&nexist;"], [0, "&empty;"], [1, "&Del;"], [0, "&Element;"], [0, "&NotElement;"], [1, "&ni;"], [0, "&notni;"], [2, "&prod;"], [0, "&coprod;"], [0, "&sum;"], [0, "&minus;"], [0, "&MinusPlus;"], [0, "&dotplus;"], [1, "&Backslash;"], [0, "&lowast;"], [0, "&compfn;"], [1, "&radic;"], [2, "&prop;"], [0, "&infin;"], [0, "&angrt;"], [0, { v: "&ang;", n: 8402, o: "&nang;" }], [0, "&angmsd;"], [0, "&angsph;"], [0, "&mid;"], [0, "&nmid;"], [0, "&DoubleVerticalBar;"], [0, "&NotDoubleVerticalBar;"], [0, "&and;"], [0, "&or;"], [0, { v: "&cap;", n: 65024, o: "&caps;" }], [0, { v: "&cup;", n: 65024, o: "&cups;" }], [0, "&int;"], [0, "&Int;"], [0, "&iiint;"], [0, "&conint;"], [0, "&Conint;"], [0, "&Cconint;"], [0, "&cwint;"], [0, "&ClockwiseContourIntegral;"], [0, "&awconint;"], [0, "&there4;"], [0, "&becaus;"], [0, "&ratio;"], [0, "&Colon;"], [0, "&dotminus;"], [1, "&mDDot;"], [0, "&homtht;"], [0, { v: "&sim;", n: 8402, o: "&nvsim;" }], [0, { v: "&backsim;", n: 817, o: "&race;" }], [0, { v: "&ac;", n: 819, o: "&acE;" }], [0, "&acd;"], [0, "&VerticalTilde;"], [0, "&NotTilde;"], [0, { v: "&eqsim;", n: 824, o: "&nesim;" }], [0, "&sime;"], [0, "&NotTildeEqual;"], [0, "&cong;"], [0, "&simne;"], [0, "&ncong;"], [0, "&ap;"], [0, "&nap;"], [0, "&ape;"], [0, { v: "&apid;", n: 824, o: "&napid;" }], [0, "&backcong;"], [0, { v: "&asympeq;", n: 8402, o: "&nvap;" }], [0, { v: "&bump;", n: 824, o: "&nbump;" }], [0, { v: "&bumpe;", n: 824, o: "&nbumpe;" }], [0, { v: "&doteq;", n: 824, o: "&nedot;" }], [0, "&doteqdot;"], [0, "&efDot;"], [0, "&erDot;"], [0, "&Assign;"], [0, "&ecolon;"], [0, "&ecir;"], [0, "&circeq;"], [1, "&wedgeq;"], [0, "&veeeq;"], [1, "&triangleq;"], [2, "&equest;"], [0, "&ne;"], [0, { v: "&Congruent;", n: 8421, o: "&bnequiv;" }], [0, "&nequiv;"], [1, { v: "&le;", n: 8402, o: "&nvle;" }], [0, { v: "&ge;", n: 8402, o: "&nvge;" }], [0, { v: "&lE;", n: 824, o: "&nlE;" }], [0, { v: "&gE;", n: 824, o: "&ngE;" }], [0, { v: "&lnE;", n: 65024, o: "&lvertneqq;" }], [0, { v: "&gnE;", n: 65024, o: "&gvertneqq;" }], [0, { v: "&ll;", n: new Map(/* #__PURE__ */ restoreDiff([[824, "&nLtv;"], [7577, "&nLt;"]])) }], [0, { v: "&gg;", n: new Map(/* #__PURE__ */ restoreDiff([[824, "&nGtv;"], [7577, "&nGt;"]])) }], [0, "&between;"], [0, "&NotCupCap;"], [0, "&nless;"], [0, "&ngt;"], [0, "&nle;"], [0, "&nge;"], [0, "&lesssim;"], [0, "&GreaterTilde;"], [0, "&nlsim;"], [0, "&ngsim;"], [0, "&LessGreater;"], [0, "&gl;"], [0, "&NotLessGreater;"], [0, "&NotGreaterLess;"], [0, "&pr;"], [0, "&sc;"], [0, "&prcue;"], [0, "&sccue;"], [0, "&PrecedesTilde;"], [0, { v: "&scsim;", n: 824, o: "&NotSucceedsTilde;" }], [0, "&NotPrecedes;"], [0, "&NotSucceeds;"], [0, { v: "&sub;", n: 8402, o: "&NotSubset;" }], [0, { v: "&sup;", n: 8402, o: "&NotSuperset;" }], [0, "&nsub;"], [0, "&nsup;"], [0, "&sube;"], [0, "&supe;"], [0, "&NotSubsetEqual;"], [0, "&NotSupersetEqual;"], [0, { v: "&subne;", n: 65024, o: "&varsubsetneq;" }], [0, { v: "&supne;", n: 65024, o: "&varsupsetneq;" }], [1, "&cupdot;"], [0, "&UnionPlus;"], [0, { v: "&sqsub;", n: 824, o: "&NotSquareSubset;" }], [0, { v: "&sqsup;", n: 824, o: "&NotSquareSuperset;" }], [0, "&sqsube;"], [0, "&sqsupe;"], [0, { v: "&sqcap;", n: 65024, o: "&sqcaps;" }], [0, { v: "&sqcup;", n: 65024, o: "&sqcups;" }], [0, "&CirclePlus;"], [0, "&CircleMinus;"], [0, "&CircleTimes;"], [0, "&osol;"], [0, "&CircleDot;"], [0, "&circledcirc;"], [0, "&circledast;"], [1, "&circleddash;"], [0, "&boxplus;"], [0, "&boxminus;"], [0, "&boxtimes;"], [0, "&dotsquare;"], [0, "&RightTee;"], [0, "&dashv;"], [0, "&DownTee;"], [0, "&bot;"], [1, "&models;"], [0, "&DoubleRightTee;"], [0, "&Vdash;"], [0, "&Vvdash;"], [0, "&VDash;"], [0, "&nvdash;"], [0, "&nvDash;"], [0, "&nVdash;"], [0, "&nVDash;"], [0, "&prurel;"], [1, "&LeftTriangle;"], [0, "&RightTriangle;"], [0, { v: "&LeftTriangleEqual;", n: 8402, o: "&nvltrie;" }], [0, { v: "&RightTriangleEqual;", n: 8402, o: "&nvrtrie;" }], [0, "&origof;"], [0, "&imof;"], [0, "&multimap;"], [0, "&hercon;"], [0, "&intcal;"], [0, "&veebar;"], [1, "&barvee;"], [0, "&angrtvb;"], [0, "&lrtri;"], [0, "&bigwedge;"], [0, "&bigvee;"], [0, "&bigcap;"], [0, "&bigcup;"], [0, "&diam;"], [0, "&sdot;"], [0, "&sstarf;"], [0, "&divideontimes;"], [0, "&bowtie;"], [0, "&ltimes;"], [0, "&rtimes;"], [0, "&leftthreetimes;"], [0, "&rightthreetimes;"], [0, "&backsimeq;"], [0, "&curlyvee;"], [0, "&curlywedge;"], [0, "&Sub;"], [0, "&Sup;"], [0, "&Cap;"], [0, "&Cup;"], [0, "&fork;"], [0, "&epar;"], [0, "&lessdot;"], [0, "&gtdot;"], [0, { v: "&Ll;", n: 824, o: "&nLl;" }], [0, { v: "&Gg;", n: 824, o: "&nGg;" }], [0, { v: "&leg;", n: 65024, o: "&lesg;" }], [0, { v: "&gel;", n: 65024, o: "&gesl;" }], [2, "&cuepr;"], [0, "&cuesc;"], [0, "&NotPrecedesSlantEqual;"], [0, "&NotSucceedsSlantEqual;"], [0, "&NotSquareSubsetEqual;"], [0, "&NotSquareSupersetEqual;"], [2, "&lnsim;"], [0, "&gnsim;"], [0, "&precnsim;"], [0, "&scnsim;"], [0, "&nltri;"], [0, "&NotRightTriangle;"], [0, "&nltrie;"], [0, "&NotRightTriangleEqual;"], [0, "&vellip;"], [0, "&ctdot;"], [0, "&utdot;"], [0, "&dtdot;"], [0, "&disin;"], [0, "&isinsv;"], [0, "&isins;"], [0, { v: "&isindot;", n: 824, o: "&notindot;" }], [0, "&notinvc;"], [0, "&notinvb;"], [1, { v: "&isinE;", n: 824, o: "&notinE;" }], [0, "&nisd;"], [0, "&xnis;"], [0, "&nis;"], [0, "&notnivc;"], [0, "&notnivb;"], [6, "&barwed;"], [0, "&Barwed;"], [1, "&lceil;"], [0, "&rceil;"], [0, "&LeftFloor;"], [0, "&rfloor;"], [0, "&drcrop;"], [0, "&dlcrop;"], [0, "&urcrop;"], [0, "&ulcrop;"], [0, "&bnot;"], [1, "&profline;"], [0, "&profsurf;"], [1, "&telrec;"], [0, "&target;"], [5, "&ulcorn;"], [0, "&urcorn;"], [0, "&dlcorn;"], [0, "&drcorn;"], [2, "&frown;"], [0, "&smile;"], [9, "&cylcty;"], [0, "&profalar;"], [7, "&topbot;"], [6, "&ovbar;"], [1, "&solbar;"], [60, "&angzarr;"], [51, "&lmoustache;"], [0, "&rmoustache;"], [2, "&OverBracket;"], [0, "&bbrk;"], [0, "&bbrktbrk;"], [37, "&OverParenthesis;"], [0, "&UnderParenthesis;"], [0, "&OverBrace;"], [0, "&UnderBrace;"], [2, "&trpezium;"], [4, "&elinters;"], [59, "&blank;"], [164, "&circledS;"], [55, "&boxh;"], [1, "&boxv;"], [9, "&boxdr;"], [3, "&boxdl;"], [3, "&boxur;"], [3, "&boxul;"], [3, "&boxvr;"], [7, "&boxvl;"], [7, "&boxhd;"], [7, "&boxhu;"], [7, "&boxvh;"], [19, "&boxH;"], [0, "&boxV;"], [0, "&boxdR;"], [0, "&boxDr;"], [0, "&boxDR;"], [0, "&boxdL;"], [0, "&boxDl;"], [0, "&boxDL;"], [0, "&boxuR;"], [0, "&boxUr;"], [0, "&boxUR;"], [0, "&boxuL;"], [0, "&boxUl;"], [0, "&boxUL;"], [0, "&boxvR;"], [0, "&boxVr;"], [0, "&boxVR;"], [0, "&boxvL;"], [0, "&boxVl;"], [0, "&boxVL;"], [0, "&boxHd;"], [0, "&boxhD;"], [0, "&boxHD;"], [0, "&boxHu;"], [0, "&boxhU;"], [0, "&boxHU;"], [0, "&boxvH;"], [0, "&boxVh;"], [0, "&boxVH;"], [19, "&uhblk;"], [3, "&lhblk;"], [3, "&block;"], [8, "&blk14;"], [0, "&blk12;"], [0, "&blk34;"], [13, "&square;"], [8, "&blacksquare;"], [0, "&EmptyVerySmallSquare;"], [1, "&rect;"], [0, "&marker;"], [2, "&fltns;"], [1, "&bigtriangleup;"], [0, "&blacktriangle;"], [0, "&triangle;"], [2, "&blacktriangleright;"], [0, "&rtri;"], [3, "&bigtriangledown;"], [0, "&blacktriangledown;"], [0, "&dtri;"], [2, "&blacktriangleleft;"], [0, "&ltri;"], [6, "&loz;"], [0, "&cir;"], [32, "&tridot;"], [2, "&bigcirc;"], [8, "&ultri;"], [0, "&urtri;"], [0, "&lltri;"], [0, "&EmptySmallSquare;"], [0, "&FilledSmallSquare;"], [8, "&bigstar;"], [0, "&star;"], [7, "&phone;"], [49, "&female;"], [1, "&male;"], [29, "&spades;"], [2, "&clubs;"], [1, "&hearts;"], [0, "&diamondsuit;"], [3, "&sung;"], [2, "&flat;"], [0, "&natural;"], [0, "&sharp;"], [163, "&check;"], [3, "&cross;"], [8, "&malt;"], [21, "&sext;"], [33, "&VerticalSeparator;"], [25, "&lbbrk;"], [0, "&rbbrk;"], [84, "&bsolhsub;"], [0, "&suphsol;"], [28, "&LeftDoubleBracket;"], [0, "&RightDoubleBracket;"], [0, "&lang;"], [0, "&rang;"], [0, "&Lang;"], [0, "&Rang;"], [0, "&loang;"], [0, "&roang;"], [7, "&longleftarrow;"], [0, "&longrightarrow;"], [0, "&longleftrightarrow;"], [0, "&DoubleLongLeftArrow;"], [0, "&DoubleLongRightArrow;"], [0, "&DoubleLongLeftRightArrow;"], [1, "&longmapsto;"], [2, "&dzigrarr;"], [258, "&nvlArr;"], [0, "&nvrArr;"], [0, "&nvHarr;"], [0, "&Map;"], [6, "&lbarr;"], [0, "&bkarow;"], [0, "&lBarr;"], [0, "&dbkarow;"], [0, "&drbkarow;"], [0, "&DDotrahd;"], [0, "&UpArrowBar;"], [0, "&DownArrowBar;"], [2, "&Rarrtl;"], [2, "&latail;"], [0, "&ratail;"], [0, "&lAtail;"], [0, "&rAtail;"], [0, "&larrfs;"], [0, "&rarrfs;"], [0, "&larrbfs;"], [0, "&rarrbfs;"], [2, "&nwarhk;"], [0, "&nearhk;"], [0, "&hksearow;"], [0, "&hkswarow;"], [0, "&nwnear;"], [0, "&nesear;"], [0, "&seswar;"], [0, "&swnwar;"], [8, { v: "&rarrc;", n: 824, o: "&nrarrc;" }], [1, "&cudarrr;"], [0, "&ldca;"], [0, "&rdca;"], [0, "&cudarrl;"], [0, "&larrpl;"], [2, "&curarrm;"], [0, "&cularrp;"], [7, "&rarrpl;"], [2, "&harrcir;"], [0, "&Uarrocir;"], [0, "&lurdshar;"], [0, "&ldrushar;"], [2, "&LeftRightVector;"], [0, "&RightUpDownVector;"], [0, "&DownLeftRightVector;"], [0, "&LeftUpDownVector;"], [0, "&LeftVectorBar;"], [0, "&RightVectorBar;"], [0, "&RightUpVectorBar;"], [0, "&RightDownVectorBar;"], [0, "&DownLeftVectorBar;"], [0, "&DownRightVectorBar;"], [0, "&LeftUpVectorBar;"], [0, "&LeftDownVectorBar;"], [0, "&LeftTeeVector;"], [0, "&RightTeeVector;"], [0, "&RightUpTeeVector;"], [0, "&RightDownTeeVector;"], [0, "&DownLeftTeeVector;"], [0, "&DownRightTeeVector;"], [0, "&LeftUpTeeVector;"], [0, "&LeftDownTeeVector;"], [0, "&lHar;"], [0, "&uHar;"], [0, "&rHar;"], [0, "&dHar;"], [0, "&luruhar;"], [0, "&ldrdhar;"], [0, "&ruluhar;"], [0, "&rdldhar;"], [0, "&lharul;"], [0, "&llhard;"], [0, "&rharul;"], [0, "&lrhard;"], [0, "&udhar;"], [0, "&duhar;"], [0, "&RoundImplies;"], [0, "&erarr;"], [0, "&simrarr;"], [0, "&larrsim;"], [0, "&rarrsim;"], [0, "&rarrap;"], [0, "&ltlarr;"], [1, "&gtrarr;"], [0, "&subrarr;"], [1, "&suplarr;"], [0, "&lfisht;"], [0, "&rfisht;"], [0, "&ufisht;"], [0, "&dfisht;"], [5, "&lopar;"], [0, "&ropar;"], [4, "&lbrke;"], [0, "&rbrke;"], [0, "&lbrkslu;"], [0, "&rbrksld;"], [0, "&lbrksld;"], [0, "&rbrkslu;"], [0, "&langd;"], [0, "&rangd;"], [0, "&lparlt;"], [0, "&rpargt;"], [0, "&gtlPar;"], [0, "&ltrPar;"], [3, "&vzigzag;"], [1, "&vangrt;"], [0, "&angrtvbd;"], [6, "&ange;"], [0, "&range;"], [0, "&dwangle;"], [0, "&uwangle;"], [0, "&angmsdaa;"], [0, "&angmsdab;"], [0, "&angmsdac;"], [0, "&angmsdad;"], [0, "&angmsdae;"], [0, "&angmsdaf;"], [0, "&angmsdag;"], [0, "&angmsdah;"], [0, "&bemptyv;"], [0, "&demptyv;"], [0, "&cemptyv;"], [0, "&raemptyv;"], [0, "&laemptyv;"], [0, "&ohbar;"], [0, "&omid;"], [0, "&opar;"], [1, "&operp;"], [1, "&olcross;"], [0, "&odsold;"], [1, "&olcir;"], [0, "&ofcir;"], [0, "&olt;"], [0, "&ogt;"], [0, "&cirscir;"], [0, "&cirE;"], [0, "&solb;"], [0, "&bsolb;"], [3, "&boxbox;"], [3, "&trisb;"], [0, "&rtriltri;"], [0, { v: "&LeftTriangleBar;", n: 824, o: "&NotLeftTriangleBar;" }], [0, { v: "&RightTriangleBar;", n: 824, o: "&NotRightTriangleBar;" }], [11, "&iinfin;"], [0, "&infintie;"], [0, "&nvinfin;"], [4, "&eparsl;"], [0, "&smeparsl;"], [0, "&eqvparsl;"], [5, "&blacklozenge;"], [8, "&RuleDelayed;"], [1, "&dsol;"], [9, "&bigodot;"], [0, "&bigoplus;"], [0, "&bigotimes;"], [1, "&biguplus;"], [1, "&bigsqcup;"], [5, "&iiiint;"], [0, "&fpartint;"], [2, "&cirfnint;"], [0, "&awint;"], [0, "&rppolint;"], [0, "&scpolint;"], [0, "&npolint;"], [0, "&pointint;"], [0, "&quatint;"], [0, "&intlarhk;"], [10, "&pluscir;"], [0, "&plusacir;"], [0, "&simplus;"], [0, "&plusdu;"], [0, "&plussim;"], [0, "&plustwo;"], [1, "&mcomma;"], [0, "&minusdu;"], [2, "&loplus;"], [0, "&roplus;"], [0, "&Cross;"], [0, "&timesd;"], [0, "&timesbar;"], [1, "&smashp;"], [0, "&lotimes;"], [0, "&rotimes;"], [0, "&otimesas;"], [0, "&Otimes;"], [0, "&odiv;"], [0, "&triplus;"], [0, "&triminus;"], [0, "&tritime;"], [0, "&intprod;"], [2, "&amalg;"], [0, "&capdot;"], [1, "&ncup;"], [0, "&ncap;"], [0, "&capand;"], [0, "&cupor;"], [0, "&cupcap;"], [0, "&capcup;"], [0, "&cupbrcap;"], [0, "&capbrcup;"], [0, "&cupcup;"], [0, "&capcap;"], [0, "&ccups;"], [0, "&ccaps;"], [2, "&ccupssm;"], [2, "&And;"], [0, "&Or;"], [0, "&andand;"], [0, "&oror;"], [0, "&orslope;"], [0, "&andslope;"], [1, "&andv;"], [0, "&orv;"], [0, "&andd;"], [0, "&ord;"], [1, "&wedbar;"], [6, "&sdote;"], [3, "&simdot;"], [2, { v: "&congdot;", n: 824, o: "&ncongdot;" }], [0, "&easter;"], [0, "&apacir;"], [0, { v: "&apE;", n: 824, o: "&napE;" }], [0, "&eplus;"], [0, "&pluse;"], [0, "&Esim;"], [0, "&Colone;"], [0, "&Equal;"], [1, "&ddotseq;"], [0, "&equivDD;"], [0, "&ltcir;"], [0, "&gtcir;"], [0, "&ltquest;"], [0, "&gtquest;"], [0, { v: "&leqslant;", n: 824, o: "&nleqslant;" }], [0, { v: "&geqslant;", n: 824, o: "&ngeqslant;" }], [0, "&lesdot;"], [0, "&gesdot;"], [0, "&lesdoto;"], [0, "&gesdoto;"], [0, "&lesdotor;"], [0, "&gesdotol;"], [0, "&lap;"], [0, "&gap;"], [0, "&lne;"], [0, "&gne;"], [0, "&lnap;"], [0, "&gnap;"], [0, "&lEg;"], [0, "&gEl;"], [0, "&lsime;"], [0, "&gsime;"], [0, "&lsimg;"], [0, "&gsiml;"], [0, "&lgE;"], [0, "&glE;"], [0, "&lesges;"], [0, "&gesles;"], [0, "&els;"], [0, "&egs;"], [0, "&elsdot;"], [0, "&egsdot;"], [0, "&el;"], [0, "&eg;"], [2, "&siml;"], [0, "&simg;"], [0, "&simlE;"], [0, "&simgE;"], [0, { v: "&LessLess;", n: 824, o: "&NotNestedLessLess;" }], [0, { v: "&GreaterGreater;", n: 824, o: "&NotNestedGreaterGreater;" }], [1, "&glj;"], [0, "&gla;"], [0, "&ltcc;"], [0, "&gtcc;"], [0, "&lescc;"], [0, "&gescc;"], [0, "&smt;"], [0, "&lat;"], [0, { v: "&smte;", n: 65024, o: "&smtes;" }], [0, { v: "&late;", n: 65024, o: "&lates;" }], [0, "&bumpE;"], [0, { v: "&PrecedesEqual;", n: 824, o: "&NotPrecedesEqual;" }], [0, { v: "&sce;", n: 824, o: "&NotSucceedsEqual;" }], [2, "&prE;"], [0, "&scE;"], [0, "&precneqq;"], [0, "&scnE;"], [0, "&prap;"], [0, "&scap;"], [0, "&precnapprox;"], [0, "&scnap;"], [0, "&Pr;"], [0, "&Sc;"], [0, "&subdot;"], [0, "&supdot;"], [0, "&subplus;"], [0, "&supplus;"], [0, "&submult;"], [0, "&supmult;"], [0, "&subedot;"], [0, "&supedot;"], [0, { v: "&subE;", n: 824, o: "&nsubE;" }], [0, { v: "&supE;", n: 824, o: "&nsupE;" }], [0, "&subsim;"], [0, "&supsim;"], [2, { v: "&subnE;", n: 65024, o: "&varsubsetneqq;" }], [0, { v: "&supnE;", n: 65024, o: "&varsupsetneqq;" }], [2, "&csub;"], [0, "&csup;"], [0, "&csube;"], [0, "&csupe;"], [0, "&subsup;"], [0, "&supsub;"], [0, "&subsub;"], [0, "&supsup;"], [0, "&suphsub;"], [0, "&supdsub;"], [0, "&forkv;"], [0, "&topfork;"], [0, "&mlcp;"], [8, "&Dashv;"], [1, "&Vdashl;"], [0, "&Barv;"], [0, "&vBar;"], [0, "&vBarv;"], [1, "&Vbar;"], [0, "&Not;"], [0, "&bNot;"], [0, "&rnmid;"], [0, "&cirmid;"], [0, "&midcir;"], [0, "&topcir;"], [0, "&nhpar;"], [0, "&parsim;"], [9, { v: "&parsl;", n: 8421, o: "&nparsl;" }], [44343, { n: new Map(/* #__PURE__ */ restoreDiff([[56476, "&Ascr;"], [1, "&Cscr;"], [0, "&Dscr;"], [2, "&Gscr;"], [2, "&Jscr;"], [0, "&Kscr;"], [2, "&Nscr;"], [0, "&Oscr;"], [0, "&Pscr;"], [0, "&Qscr;"], [1, "&Sscr;"], [0, "&Tscr;"], [0, "&Uscr;"], [0, "&Vscr;"], [0, "&Wscr;"], [0, "&Xscr;"], [0, "&Yscr;"], [0, "&Zscr;"], [0, "&ascr;"], [0, "&bscr;"], [0, "&cscr;"], [0, "&dscr;"], [1, "&fscr;"], [1, "&hscr;"], [0, "&iscr;"], [0, "&jscr;"], [0, "&kscr;"], [0, "&lscr;"], [0, "&mscr;"], [0, "&nscr;"], [1, "&pscr;"], [0, "&qscr;"], [0, "&rscr;"], [0, "&sscr;"], [0, "&tscr;"], [0, "&uscr;"], [0, "&vscr;"], [0, "&wscr;"], [0, "&xscr;"], [0, "&yscr;"], [0, "&zscr;"], [52, "&Afr;"], [0, "&Bfr;"], [1, "&Dfr;"], [0, "&Efr;"], [0, "&Ffr;"], [0, "&Gfr;"], [2, "&Jfr;"], [0, "&Kfr;"], [0, "&Lfr;"], [0, "&Mfr;"], [0, "&Nfr;"], [0, "&Ofr;"], [0, "&Pfr;"], [0, "&Qfr;"], [1, "&Sfr;"], [0, "&Tfr;"], [0, "&Ufr;"], [0, "&Vfr;"], [0, "&Wfr;"], [0, "&Xfr;"], [0, "&Yfr;"], [1, "&afr;"], [0, "&bfr;"], [0, "&cfr;"], [0, "&dfr;"], [0, "&efr;"], [0, "&ffr;"], [0, "&gfr;"], [0, "&hfr;"], [0, "&ifr;"], [0, "&jfr;"], [0, "&kfr;"], [0, "&lfr;"], [0, "&mfr;"], [0, "&nfr;"], [0, "&ofr;"], [0, "&pfr;"], [0, "&qfr;"], [0, "&rfr;"], [0, "&sfr;"], [0, "&tfr;"], [0, "&ufr;"], [0, "&vfr;"], [0, "&wfr;"], [0, "&xfr;"], [0, "&yfr;"], [0, "&zfr;"], [0, "&Aopf;"], [0, "&Bopf;"], [1, "&Dopf;"], [0, "&Eopf;"], [0, "&Fopf;"], [0, "&Gopf;"], [1, "&Iopf;"], [0, "&Jopf;"], [0, "&Kopf;"], [0, "&Lopf;"], [0, "&Mopf;"], [1, "&Oopf;"], [3, "&Sopf;"], [0, "&Topf;"], [0, "&Uopf;"], [0, "&Vopf;"], [0, "&Wopf;"], [0, "&Xopf;"], [0, "&Yopf;"], [1, "&aopf;"], [0, "&bopf;"], [0, "&copf;"], [0, "&dopf;"], [0, "&eopf;"], [0, "&fopf;"], [0, "&gopf;"], [0, "&hopf;"], [0, "&iopf;"], [0, "&jopf;"], [0, "&kopf;"], [0, "&lopf;"], [0, "&mopf;"], [0, "&nopf;"], [0, "&oopf;"], [0, "&popf;"], [0, "&qopf;"], [0, "&ropf;"], [0, "&sopf;"], [0, "&topf;"], [0, "&uopf;"], [0, "&vopf;"], [0, "&wopf;"], [0, "&xopf;"], [0, "&yopf;"], [0, "&zopf;"]])) }], [8906, "&fflig;"], [0, "&filig;"], [0, "&fllig;"], [0, "&ffilig;"], [0, "&ffllig;"]])));
//# sourceMappingURL=encode-html.js.map
;// CONCATENATED MODULE: ./node_modules/entities/lib/esm/escape.js
const escape_xmlReplacer = /["&'<>$\x80-\uFFFF]/g;
const xmlCodeMap = new Map([
    [34, "&quot;"],
    [38, "&amp;"],
    [39, "&apos;"],
    [60, "&lt;"],
    [62, "&gt;"],
]);
// For compatibility with node < 4, we wrap `codePointAt`
const escape_getCodePoint = 
// eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
String.prototype.codePointAt != null
    ? (str, index) => str.codePointAt(index)
    : // http://mathiasbynens.be/notes/javascript-encoding#surrogate-formulae
        (c, index) => (c.charCodeAt(index) & 0xfc00) === 0xd800
            ? (c.charCodeAt(index) - 0xd800) * 0x400 +
                c.charCodeAt(index + 1) -
                0xdc00 +
                0x10000
            : c.charCodeAt(index);
/**
 * Encodes all non-ASCII characters, as well as characters not valid in XML
 * documents using XML entities.
 *
 * If a character has no equivalent entity, a
 * numeric hexadecimal reference (eg. `&#xfc;`) will be used.
 */
function escape_encodeXML(str) {
    let ret = "";
    let lastIdx = 0;
    let match;
    while ((match = escape_xmlReplacer.exec(str)) !== null) {
        const i = match.index;
        const char = str.charCodeAt(i);
        const next = xmlCodeMap.get(char);
        if (next !== undefined) {
            ret += str.substring(lastIdx, i) + next;
            lastIdx = i + 1;
        }
        else {
            ret += `${str.substring(lastIdx, i)}&#x${escape_getCodePoint(str, i).toString(16)};`;
            // Increase by 1 if we have a surrogate pair
            lastIdx = escape_xmlReplacer.lastIndex += Number((char & 0xfc00) === 0xd800);
        }
    }
    return ret + str.substr(lastIdx);
}
/**
 * Encodes all non-ASCII characters, as well as characters not valid in XML
 * documents using numeric hexadecimal reference (eg. `&#xfc;`).
 *
 * Have a look at `escapeUTF8` if you want a more concise output at the expense
 * of reduced transportability.
 *
 * @param data String to escape.
 */
const escape_escape = (/* unused pure expression or super */ null && (escape_encodeXML));
/**
 * Creates a function that escapes all characters matched by the given regular
 * expression using the given map of characters to escape to their entities.
 *
 * @param regex Regular expression to match characters to escape.
 * @param map Map of characters to escape to their entities.
 *
 * @returns Function that escapes all characters matched by the given regular
 * expression using the given map of characters to escape to their entities.
 */
function getEscaper(regex, map) {
    return function escape(data) {
        let match;
        let lastIdx = 0;
        let result = "";
        while ((match = regex.exec(data))) {
            if (lastIdx !== match.index) {
                result += data.substring(lastIdx, match.index);
            }
            // We know that this character will be in the map.
            result += map.get(match[0].charCodeAt(0));
            // Every match will be of length 1
            lastIdx = match.index + 1;
        }
        return result + data.substring(lastIdx);
    };
}
/**
 * Encodes all characters not valid in XML documents using XML entities.
 *
 * Note that the output will be character-set dependent.
 *
 * @param data String to escape.
 */
const escape_escapeUTF8 = getEscaper(/[&<>'"]/g, xmlCodeMap);
/**
 * Encodes all characters that have to be escaped in HTML attributes,
 * following {@link https://html.spec.whatwg.org/multipage/parsing.html#escapingString}.
 *
 * @param data String to escape.
 */
const escape_escapeAttribute = getEscaper(/["&\u00A0]/g, new Map([
    [34, "&quot;"],
    [38, "&amp;"],
    [160, "&nbsp;"],
]));
/**
 * Encodes all characters that have to be escaped in HTML text,
 * following {@link https://html.spec.whatwg.org/multipage/parsing.html#escapingString}.
 *
 * @param data String to escape.
 */
const escape_escapeText = getEscaper(/[&<>\u00A0]/g, new Map([
    [38, "&amp;"],
    [60, "&lt;"],
    [62, "&gt;"],
    [160, "&nbsp;"],
]));
//# sourceMappingURL=escape.js.map
;// CONCATENATED MODULE: ./node_modules/entities/lib/esm/encode.js


const htmlReplacer = /[\t\n!-,./:-@[-`\f{-}$\x80-\uFFFF]/g;
/**
 * Encodes all characters in the input using HTML entities. This includes
 * characters that are valid ASCII characters in HTML documents, such as `#`.
 *
 * To get a more compact output, consider using the `encodeNonAsciiHTML`
 * function, which will only encode characters that are not valid in HTML
 * documents, as well as non-ASCII characters.
 *
 * If a character has no equivalent entity, a numeric hexadecimal reference
 * (eg. `&#xfc;`) will be used.
 */
function encode_encodeHTML(data) {
    return encodeHTMLTrieRe(htmlReplacer, data);
}
/**
 * Encodes all non-ASCII characters, as well as characters not valid in HTML
 * documents using HTML entities. This function will not encode characters that
 * are valid in HTML documents, such as `#`.
 *
 * If a character has no equivalent entity, a numeric hexadecimal reference
 * (eg. `&#xfc;`) will be used.
 */
function encode_encodeNonAsciiHTML(data) {
    return encodeHTMLTrieRe(xmlReplacer, data);
}
function encodeHTMLTrieRe(regExp, str) {
    let ret = "";
    let lastIdx = 0;
    let match;
    while ((match = regExp.exec(str)) !== null) {
        const i = match.index;
        ret += str.substring(lastIdx, i);
        const char = str.charCodeAt(i);
        let next = htmlTrie.get(char);
        if (typeof next === "object") {
            // We are in a branch. Try to match the next char.
            if (i + 1 < str.length) {
                const nextChar = str.charCodeAt(i + 1);
                const value = typeof next.n === "number"
                    ? next.n === nextChar
                        ? next.o
                        : undefined
                    : next.n.get(nextChar);
                if (value !== undefined) {
                    ret += value;
                    lastIdx = regExp.lastIndex += 1;
                    continue;
                }
            }
            next = next.v;
        }
        // We might have a tree node without a value; skip and use a numeric entity.
        if (next !== undefined) {
            ret += next;
            lastIdx = i + 1;
        }
        else {
            const cp = getCodePoint(str, i);
            ret += `&#x${cp.toString(16)};`;
            // Increase by 1 if we have a surrogate pair
            lastIdx = regExp.lastIndex += Number(cp !== char);
        }
    }
    return ret + str.substr(lastIdx);
}
//# sourceMappingURL=encode.js.map
;// CONCATENATED MODULE: ./node_modules/entities/lib/esm/index.js



/** The level of entities to support. */
var EntityLevel;
(function (EntityLevel) {
    /** Support only XML entities. */
    EntityLevel[EntityLevel["XML"] = 0] = "XML";
    /** Support HTML entities, which are a superset of XML entities. */
    EntityLevel[EntityLevel["HTML"] = 1] = "HTML";
})(EntityLevel || (EntityLevel = {}));
var EncodingMode;
(function (EncodingMode) {
    /**
     * The output is UTF-8 encoded. Only characters that need escaping within
     * XML will be escaped.
     */
    EncodingMode[EncodingMode["UTF8"] = 0] = "UTF8";
    /**
     * The output consists only of ASCII characters. Characters that need
     * escaping within HTML, and characters that aren't ASCII characters will
     * be escaped.
     */
    EncodingMode[EncodingMode["ASCII"] = 1] = "ASCII";
    /**
     * Encode all characters that have an equivalent entity, as well as all
     * characters that are not ASCII characters.
     */
    EncodingMode[EncodingMode["Extensive"] = 2] = "Extensive";
    /**
     * Encode all characters that have to be escaped in HTML attributes,
     * following {@link https://html.spec.whatwg.org/multipage/parsing.html#escapingString}.
     */
    EncodingMode[EncodingMode["Attribute"] = 3] = "Attribute";
    /**
     * Encode all characters that have to be escaped in HTML text,
     * following {@link https://html.spec.whatwg.org/multipage/parsing.html#escapingString}.
     */
    EncodingMode[EncodingMode["Text"] = 4] = "Text";
})(EncodingMode || (EncodingMode = {}));
/**
 * Decodes a string with entities.
 *
 * @param data String to decode.
 * @param options Decoding options.
 */
function decode(data, options = EntityLevel.XML) {
    const level = typeof options === "number" ? options : options.level;
    if (level === EntityLevel.HTML) {
        const mode = typeof options === "object" ? options.mode : undefined;
        return decodeHTML(data, mode);
    }
    return decodeXML(data);
}
/**
 * Decodes a string with entities. Does not allow missing trailing semicolons for entities.
 *
 * @param data String to decode.
 * @param options Decoding options.
 * @deprecated Use `decode` with the `mode` set to `Strict`.
 */
function decodeStrict(data, options = EntityLevel.XML) {
    var _a;
    const opts = typeof options === "number" ? { level: options } : options;
    (_a = opts.mode) !== null && _a !== void 0 ? _a : (opts.mode = DecodingMode.Strict);
    return decode(data, opts);
}
/**
 * Encodes a string with entities.
 *
 * @param data String to encode.
 * @param options Encoding options.
 */
function encode(data, options = EntityLevel.XML) {
    const opts = typeof options === "number" ? { level: options } : options;
    // Mode `UTF8` just escapes XML entities
    if (opts.mode === EncodingMode.UTF8)
        return escapeUTF8(data);
    if (opts.mode === EncodingMode.Attribute)
        return escapeAttribute(data);
    if (opts.mode === EncodingMode.Text)
        return escapeText(data);
    if (opts.level === EntityLevel.HTML) {
        if (opts.mode === EncodingMode.ASCII) {
            return encodeNonAsciiHTML(data);
        }
        return encodeHTML(data);
    }
    // ASCII and Extensive are equivalent
    return encodeXML(data);
}



//# sourceMappingURL=index.js.map
;// CONCATENATED MODULE: ./node_modules/dom-serializer/lib/esm/foreignNames.js
const foreignNames_elementNames = new Map([
    "altGlyph",
    "altGlyphDef",
    "altGlyphItem",
    "animateColor",
    "animateMotion",
    "animateTransform",
    "clipPath",
    "feBlend",
    "feColorMatrix",
    "feComponentTransfer",
    "feComposite",
    "feConvolveMatrix",
    "feDiffuseLighting",
    "feDisplacementMap",
    "feDistantLight",
    "feDropShadow",
    "feFlood",
    "feFuncA",
    "feFuncB",
    "feFuncG",
    "feFuncR",
    "feGaussianBlur",
    "feImage",
    "feMerge",
    "feMergeNode",
    "feMorphology",
    "feOffset",
    "fePointLight",
    "feSpecularLighting",
    "feSpotLight",
    "feTile",
    "feTurbulence",
    "foreignObject",
    "glyphRef",
    "linearGradient",
    "radialGradient",
    "textPath",
].map((val) => [val.toLowerCase(), val]));
const foreignNames_attributeNames = new Map([
    "definitionURL",
    "attributeName",
    "attributeType",
    "baseFrequency",
    "baseProfile",
    "calcMode",
    "clipPathUnits",
    "diffuseConstant",
    "edgeMode",
    "filterUnits",
    "glyphRef",
    "gradientTransform",
    "gradientUnits",
    "kernelMatrix",
    "kernelUnitLength",
    "keyPoints",
    "keySplines",
    "keyTimes",
    "lengthAdjust",
    "limitingConeAngle",
    "markerHeight",
    "markerUnits",
    "markerWidth",
    "maskContentUnits",
    "maskUnits",
    "numOctaves",
    "pathLength",
    "patternContentUnits",
    "patternTransform",
    "patternUnits",
    "pointsAtX",
    "pointsAtY",
    "pointsAtZ",
    "preserveAlpha",
    "preserveAspectRatio",
    "primitiveUnits",
    "refX",
    "refY",
    "repeatCount",
    "repeatDur",
    "requiredExtensions",
    "requiredFeatures",
    "specularConstant",
    "specularExponent",
    "spreadMethod",
    "startOffset",
    "stdDeviation",
    "stitchTiles",
    "surfaceScale",
    "systemLanguage",
    "tableValues",
    "targetX",
    "targetY",
    "textLength",
    "viewBox",
    "viewTarget",
    "xChannelSelector",
    "yChannelSelector",
    "zoomAndPan",
].map((val) => [val.toLowerCase(), val]));

;// CONCATENATED MODULE: ./node_modules/dom-serializer/lib/esm/index.js
/*
 * Module dependencies
 */


/**
 * Mixed-case SVG and MathML tags & attributes
 * recognized by the HTML parser.
 *
 * @see https://html.spec.whatwg.org/multipage/parsing.html#parsing-main-inforeign
 */

const unencodedElements = new Set([
    "style",
    "script",
    "xmp",
    "iframe",
    "noembed",
    "noframes",
    "plaintext",
    "noscript",
]);
function replaceQuotes(value) {
    return value.replace(/"/g, "&quot;");
}
/**
 * Format attributes
 */
function formatAttributes(attributes, opts) {
    var _a;
    if (!attributes)
        return;
    const encode = ((_a = opts.encodeEntities) !== null && _a !== void 0 ? _a : opts.decodeEntities) === false
        ? replaceQuotes
        : opts.xmlMode || opts.encodeEntities !== "utf8"
            ? encodeXML
            : escapeAttribute;
    return Object.keys(attributes)
        .map((key) => {
        var _a, _b;
        const value = (_a = attributes[key]) !== null && _a !== void 0 ? _a : "";
        if (opts.xmlMode === "foreign") {
            /* Fix up mixed-case attribute names */
            key = (_b = attributeNames.get(key)) !== null && _b !== void 0 ? _b : key;
        }
        if (!opts.emptyAttrs && !opts.xmlMode && value === "") {
            return key;
        }
        return `${key}="${encode(value)}"`;
    })
        .join(" ");
}
/**
 * Self-enclosing tags
 */
const singleTag = new Set([
    "area",
    "base",
    "basefont",
    "br",
    "col",
    "command",
    "embed",
    "frame",
    "hr",
    "img",
    "input",
    "isindex",
    "keygen",
    "link",
    "meta",
    "param",
    "source",
    "track",
    "wbr",
]);
/**
 * Renders a DOM node or an array of DOM nodes to a string.
 *
 * Can be thought of as the equivalent of the `outerHTML` of the passed node(s).
 *
 * @param node Node to be rendered.
 * @param options Changes serialization behavior
 */
function render(node, options = {}) {
    const nodes = "length" in node ? node : [node];
    let output = "";
    for (let i = 0; i < nodes.length; i++) {
        output += renderNode(nodes[i], options);
    }
    return output;
}
/* harmony default export */ var dom_serializer_lib_esm = ((/* unused pure expression or super */ null && (render)));
function renderNode(node, options) {
    switch (node.type) {
        case ElementType.Root:
            return render(node.children, options);
        // @ts-expect-error We don't use `Doctype` yet
        case ElementType.Doctype:
        case ElementType.Directive:
            return renderDirective(node);
        case ElementType.Comment:
            return renderComment(node);
        case ElementType.CDATA:
            return renderCdata(node);
        case ElementType.Script:
        case ElementType.Style:
        case ElementType.Tag:
            return renderTag(node, options);
        case ElementType.Text:
            return renderText(node, options);
    }
}
const foreignModeIntegrationPoints = new Set([
    "mi",
    "mo",
    "mn",
    "ms",
    "mtext",
    "annotation-xml",
    "foreignObject",
    "desc",
    "title",
]);
const foreignElements = new Set(["svg", "math"]);
function renderTag(elem, opts) {
    var _a;
    // Handle SVG / MathML in HTML
    if (opts.xmlMode === "foreign") {
        /* Fix up mixed-case element names */
        elem.name = (_a = elementNames.get(elem.name)) !== null && _a !== void 0 ? _a : elem.name;
        /* Exit foreign mode at integration points */
        if (elem.parent &&
            foreignModeIntegrationPoints.has(elem.parent.name)) {
            opts = { ...opts, xmlMode: false };
        }
    }
    if (!opts.xmlMode && foreignElements.has(elem.name)) {
        opts = { ...opts, xmlMode: "foreign" };
    }
    let tag = `<${elem.name}`;
    const attribs = formatAttributes(elem.attribs, opts);
    if (attribs) {
        tag += ` ${attribs}`;
    }
    if (elem.children.length === 0 &&
        (opts.xmlMode
            ? // In XML mode or foreign mode, and user hasn't explicitly turned off self-closing tags
                opts.selfClosingTags !== false
            : // User explicitly asked for self-closing tags, even in HTML mode
                opts.selfClosingTags && singleTag.has(elem.name))) {
        if (!opts.xmlMode)
            tag += " ";
        tag += "/>";
    }
    else {
        tag += ">";
        if (elem.children.length > 0) {
            tag += render(elem.children, opts);
        }
        if (opts.xmlMode || !singleTag.has(elem.name)) {
            tag += `</${elem.name}>`;
        }
    }
    return tag;
}
function renderDirective(elem) {
    return `<${elem.data}>`;
}
function renderText(elem, opts) {
    var _a;
    let data = elem.data || "";
    // If entities weren't decoded, no need to encode them back
    if (((_a = opts.encodeEntities) !== null && _a !== void 0 ? _a : opts.decodeEntities) !== false &&
        !(!opts.xmlMode &&
            elem.parent &&
            unencodedElements.has(elem.parent.name))) {
        data =
            opts.xmlMode || opts.encodeEntities !== "utf8"
                ? encodeXML(data)
                : escapeText(data);
    }
    return data;
}
function renderCdata(elem) {
    return `<![CDATA[${elem.children[0].data}]]>`;
}
function renderComment(elem) {
    return `<!--${elem.data}-->`;
}

;// CONCATENATED MODULE: ./node_modules/domutils/lib/esm/stringify.js



/**
 * @category Stringify
 * @deprecated Use the `dom-serializer` module directly.
 * @param node Node to get the outer HTML of.
 * @param options Options for serialization.
 * @returns `node`'s outer HTML.
 */
function getOuterHTML(node, options) {
    return renderHTML(node, options);
}
/**
 * @category Stringify
 * @deprecated Use the `dom-serializer` module directly.
 * @param node Node to get the inner HTML of.
 * @param options Options for serialization.
 * @returns `node`'s inner HTML.
 */
function getInnerHTML(node, options) {
    return hasChildren(node)
        ? node.children.map((node) => getOuterHTML(node, options)).join("")
        : "";
}
/**
 * Get a node's inner text. Same as `textContent`, but inserts newlines for `<br>` tags. Ignores comments.
 *
 * @category Stringify
 * @deprecated Use `textContent` instead.
 * @param node Node to get the inner text of.
 * @returns `node`'s inner text.
 */
function getText(node) {
    if (Array.isArray(node))
        return node.map(getText).join("");
    if (isTag(node))
        return node.name === "br" ? "\n" : getText(node.children);
    if (isCDATA(node))
        return getText(node.children);
    if (isText(node))
        return node.data;
    return "";
}
/**
 * Get a node's text content. Ignores comments.
 *
 * @category Stringify
 * @param node Node to get the text content of.
 * @returns `node`'s text content.
 * @see {@link https://developer.mozilla.org/en-US/docs/Web/API/Node/textContent}
 */
function stringify_textContent(node) {
    if (Array.isArray(node))
        return node.map(stringify_textContent).join("");
    if (hasChildren(node) && !isComment(node)) {
        return stringify_textContent(node.children);
    }
    if (isText(node))
        return node.data;
    return "";
}
/**
 * Get a node's inner text, ignoring `<script>` and `<style>` tags. Ignores comments.
 *
 * @category Stringify
 * @param node Node to get the inner text of.
 * @returns `node`'s inner text.
 * @see {@link https://developer.mozilla.org/en-US/docs/Web/API/Node/innerText}
 */
function innerText(node) {
    if (Array.isArray(node))
        return node.map(innerText).join("");
    if (hasChildren(node) && (node.type === ElementType.Tag || isCDATA(node))) {
        return innerText(node.children);
    }
    if (isText(node))
        return node.data;
    return "";
}
//# sourceMappingURL=stringify.js.map
;// CONCATENATED MODULE: ./node_modules/domutils/lib/esm/traversal.js

/**
 * Get a node's children.
 *
 * @category Traversal
 * @param elem Node to get the children of.
 * @returns `elem`'s children, or an empty array.
 */
function getChildren(elem) {
    return hasChildren(elem) ? elem.children : [];
}
/**
 * Get a node's parent.
 *
 * @category Traversal
 * @param elem Node to get the parent of.
 * @returns `elem`'s parent node, or `null` if `elem` is a root node.
 */
function getParent(elem) {
    return elem.parent || null;
}
/**
 * Gets an elements siblings, including the element itself.
 *
 * Attempts to get the children through the element's parent first. If we don't
 * have a parent (the element is a root node), we walk the element's `prev` &
 * `next` to get all remaining nodes.
 *
 * @category Traversal
 * @param elem Element to get the siblings of.
 * @returns `elem`'s siblings, including `elem`.
 */
function getSiblings(elem) {
    const parent = getParent(elem);
    if (parent != null)
        return getChildren(parent);
    const siblings = [elem];
    let { prev, next } = elem;
    while (prev != null) {
        siblings.unshift(prev);
        ({ prev } = prev);
    }
    while (next != null) {
        siblings.push(next);
        ({ next } = next);
    }
    return siblings;
}
/**
 * Gets an attribute from an element.
 *
 * @category Traversal
 * @param elem Element to check.
 * @param name Attribute name to retrieve.
 * @returns The element's attribute value, or `undefined`.
 */
function getAttributeValue(elem, name) {
    var _a;
    return (_a = elem.attribs) === null || _a === void 0 ? void 0 : _a[name];
}
/**
 * Checks whether an element has an attribute.
 *
 * @category Traversal
 * @param elem Element to check.
 * @param name Attribute name to look for.
 * @returns Returns whether `elem` has the attribute `name`.
 */
function hasAttrib(elem, name) {
    return (elem.attribs != null &&
        Object.prototype.hasOwnProperty.call(elem.attribs, name) &&
        elem.attribs[name] != null);
}
/**
 * Get the tag name of an element.
 *
 * @category Traversal
 * @param elem The element to get the name for.
 * @returns The tag name of `elem`.
 */
function getName(elem) {
    return elem.name;
}
/**
 * Returns the next element sibling of a node.
 *
 * @category Traversal
 * @param elem The element to get the next sibling of.
 * @returns `elem`'s next sibling that is a tag, or `null` if there is no next
 * sibling.
 */
function nextElementSibling(elem) {
    let { next } = elem;
    while (next !== null && !isTag(next))
        ({ next } = next);
    return next;
}
/**
 * Returns the previous element sibling of a node.
 *
 * @category Traversal
 * @param elem The element to get the previous sibling of.
 * @returns `elem`'s previous sibling that is a tag, or `null` if there is no
 * previous sibling.
 */
function prevElementSibling(elem) {
    let { prev } = elem;
    while (prev !== null && !isTag(prev))
        ({ prev } = prev);
    return prev;
}
//# sourceMappingURL=traversal.js.map
;// CONCATENATED MODULE: ./node_modules/domutils/lib/esm/querying.js

/**
 * Search a node and its children for nodes passing a test function. If `node` is not an array, it will be wrapped in one.
 *
 * @category Querying
 * @param test Function to test nodes on.
 * @param node Node to search. Will be included in the result set if it matches.
 * @param recurse Also consider child nodes.
 * @param limit Maximum number of nodes to return.
 * @returns All nodes passing `test`.
 */
function querying_filter(test, node, recurse = true, limit = Infinity) {
    return find(test, Array.isArray(node) ? node : [node], recurse, limit);
}
/**
 * Search an array of nodes and their children for nodes passing a test function.
 *
 * @category Querying
 * @param test Function to test nodes on.
 * @param nodes Array of nodes to search.
 * @param recurse Also consider child nodes.
 * @param limit Maximum number of nodes to return.
 * @returns All nodes passing `test`.
 */
function find(test, nodes, recurse, limit) {
    const result = [];
    /** Stack of the arrays we are looking at. */
    const nodeStack = [nodes];
    /** Stack of the indices within the arrays. */
    const indexStack = [0];
    for (;;) {
        // First, check if the current array has any more elements to look at.
        if (indexStack[0] >= nodeStack[0].length) {
            // If we have no more arrays to look at, we are done.
            if (indexStack.length === 1) {
                return result;
            }
            // Otherwise, remove the current array from the stack.
            nodeStack.shift();
            indexStack.shift();
            // Loop back to the start to continue with the next array.
            continue;
        }
        const elem = nodeStack[0][indexStack[0]++];
        if (test(elem)) {
            result.push(elem);
            if (--limit <= 0)
                return result;
        }
        if (recurse && hasChildren(elem) && elem.children.length > 0) {
            /*
             * Add the children to the stack. We are depth-first, so this is
             * the next array we look at.
             */
            indexStack.unshift(0);
            nodeStack.unshift(elem.children);
        }
    }
}
/**
 * Finds the first element inside of an array that matches a test function. This is an alias for `Array.prototype.find`.
 *
 * @category Querying
 * @param test Function to test nodes on.
 * @param nodes Array of nodes to search.
 * @returns The first node in the array that passes `test`.
 * @deprecated Use `Array.prototype.find` directly.
 */
function findOneChild(test, nodes) {
    return nodes.find(test);
}
/**
 * Finds one element in a tree that passes a test.
 *
 * @category Querying
 * @param test Function to test nodes on.
 * @param nodes Node or array of nodes to search.
 * @param recurse Also consider child nodes.
 * @returns The first node that passes `test`.
 */
function querying_findOne(test, nodes, recurse = true) {
    let elem = null;
    for (let i = 0; i < nodes.length && !elem; i++) {
        const node = nodes[i];
        if (!isTag(node)) {
            continue;
        }
        else if (test(node)) {
            elem = node;
        }
        else if (recurse && node.children.length > 0) {
            elem = querying_findOne(test, node.children, true);
        }
    }
    return elem;
}
/**
 * Checks if a tree of nodes contains at least one node passing a test.
 *
 * @category Querying
 * @param test Function to test nodes on.
 * @param nodes Array of nodes to search.
 * @returns Whether a tree of nodes contains at least one node passing the test.
 */
function existsOne(test, nodes) {
    return nodes.some((checked) => isTag(checked) &&
        (test(checked) || existsOne(test, checked.children)));
}
/**
 * Search an array of nodes and their children for elements passing a test function.
 *
 * Same as `find`, but limited to elements and with less options, leading to reduced complexity.
 *
 * @category Querying
 * @param test Function to test nodes on.
 * @param nodes Array of nodes to search.
 * @returns All nodes passing `test`.
 */
function findAll(test, nodes) {
    const result = [];
    const nodeStack = [nodes];
    const indexStack = [0];
    for (;;) {
        if (indexStack[0] >= nodeStack[0].length) {
            if (nodeStack.length === 1) {
                return result;
            }
            // Otherwise, remove the current array from the stack.
            nodeStack.shift();
            indexStack.shift();
            // Loop back to the start to continue with the next array.
            continue;
        }
        const elem = nodeStack[0][indexStack[0]++];
        if (!isTag(elem))
            continue;
        if (test(elem))
            result.push(elem);
        if (elem.children.length > 0) {
            indexStack.unshift(0);
            nodeStack.unshift(elem.children);
        }
    }
}
//# sourceMappingURL=querying.js.map
;// CONCATENATED MODULE: ./node_modules/domutils/lib/esm/legacy.js


/**
 * A map of functions to check nodes against.
 */
const Checks = {
    tag_name(name) {
        if (typeof name === "function") {
            return (elem) => node_isTag(elem) && name(elem.name);
        }
        else if (name === "*") {
            return node_isTag;
        }
        return (elem) => node_isTag(elem) && elem.name === name;
    },
    tag_type(type) {
        if (typeof type === "function") {
            return (elem) => type(elem.type);
        }
        return (elem) => elem.type === type;
    },
    tag_contains(data) {
        if (typeof data === "function") {
            return (elem) => node_isText(elem) && data(elem.data);
        }
        return (elem) => node_isText(elem) && elem.data === data;
    },
};
/**
 * Returns a function to check whether a node has an attribute with a particular
 * value.
 *
 * @param attrib Attribute to check.
 * @param value Attribute value to look for.
 * @returns A function to check whether the a node has an attribute with a
 *   particular value.
 */
function getAttribCheck(attrib, value) {
    if (typeof value === "function") {
        return (elem) => isTag(elem) && value(elem.attribs[attrib]);
    }
    return (elem) => isTag(elem) && elem.attribs[attrib] === value;
}
/**
 * Returns a function that returns `true` if either of the input functions
 * returns `true` for a node.
 *
 * @param a First function to combine.
 * @param b Second function to combine.
 * @returns A function taking a node and returning `true` if either of the input
 *   functions returns `true` for the node.
 */
function combineFuncs(a, b) {
    return (elem) => a(elem) || b(elem);
}
/**
 * Returns a function that executes all checks in `options` and returns `true`
 * if any of them match a node.
 *
 * @param options An object describing nodes to look for.
 * @returns A function that executes all checks in `options` and returns `true`
 *   if any of them match a node.
 */
function compileTest(options) {
    const funcs = Object.keys(options).map((key) => {
        const value = options[key];
        return Object.prototype.hasOwnProperty.call(Checks, key)
            ? Checks[key](value)
            : getAttribCheck(key, value);
    });
    return funcs.length === 0 ? null : funcs.reduce(combineFuncs);
}
/**
 * Checks whether a node matches the description in `options`.
 *
 * @category Legacy Query Functions
 * @param options An object describing nodes to look for.
 * @param node The element to test.
 * @returns Whether the element matches the description in `options`.
 */
function testElement(options, node) {
    const test = compileTest(options);
    return test ? test(node) : true;
}
/**
 * Returns all nodes that match `options`.
 *
 * @category Legacy Query Functions
 * @param options An object describing nodes to look for.
 * @param nodes Nodes to search through.
 * @param recurse Also consider child nodes.
 * @param limit Maximum number of nodes to return.
 * @returns All nodes that match `options`.
 */
function getElements(options, nodes, recurse, limit = Infinity) {
    const test = compileTest(options);
    return test ? filter(test, nodes, recurse, limit) : [];
}
/**
 * Returns the node with the supplied ID.
 *
 * @category Legacy Query Functions
 * @param id The unique ID attribute value to look for.
 * @param nodes Nodes to search through.
 * @param recurse Also consider child nodes.
 * @returns The node with the supplied ID.
 */
function getElementById(id, nodes, recurse = true) {
    if (!Array.isArray(nodes))
        nodes = [nodes];
    return findOne(getAttribCheck("id", id), nodes, recurse);
}
/**
 * Returns all nodes with the supplied `tagName`.
 *
 * @category Legacy Query Functions
 * @param tagName Tag name to search for.
 * @param nodes Nodes to search through.
 * @param recurse Also consider child nodes.
 * @param limit Maximum number of nodes to return.
 * @returns All nodes with the supplied `tagName`.
 */
function legacy_getElementsByTagName(tagName, nodes, recurse = true, limit = Infinity) {
    return filter(Checks["tag_name"](tagName), nodes, recurse, limit);
}
/**
 * Returns all nodes with the supplied `type`.
 *
 * @category Legacy Query Functions
 * @param type Element type to look for.
 * @param nodes Nodes to search through.
 * @param recurse Also consider child nodes.
 * @param limit Maximum number of nodes to return.
 * @returns All nodes with the supplied `type`.
 */
function getElementsByTagType(type, nodes, recurse = true, limit = Infinity) {
    return filter(Checks["tag_type"](type), nodes, recurse, limit);
}
//# sourceMappingURL=legacy.js.map
;// CONCATENATED MODULE: ./node_modules/domutils/lib/esm/helpers.js

/**
 * Given an array of nodes, remove any member that is contained by another
 * member.
 *
 * @category Helpers
 * @param nodes Nodes to filter.
 * @returns Remaining nodes that aren't contained by other nodes.
 */
function removeSubsets(nodes) {
    let idx = nodes.length;
    /*
     * Check if each node (or one of its ancestors) is already contained in the
     * array.
     */
    while (--idx >= 0) {
        const node = nodes[idx];
        /*
         * Remove the node if it is not unique.
         * We are going through the array from the end, so we only
         * have to check nodes that preceed the node under consideration in the array.
         */
        if (idx > 0 && nodes.lastIndexOf(node, idx - 1) >= 0) {
            nodes.splice(idx, 1);
            continue;
        }
        for (let ancestor = node.parent; ancestor; ancestor = ancestor.parent) {
            if (nodes.includes(ancestor)) {
                nodes.splice(idx, 1);
                break;
            }
        }
    }
    return nodes;
}
/**
 * @category Helpers
 * @see {@link http://dom.spec.whatwg.org/#dom-node-comparedocumentposition}
 */
var DocumentPosition;
(function (DocumentPosition) {
    DocumentPosition[DocumentPosition["DISCONNECTED"] = 1] = "DISCONNECTED";
    DocumentPosition[DocumentPosition["PRECEDING"] = 2] = "PRECEDING";
    DocumentPosition[DocumentPosition["FOLLOWING"] = 4] = "FOLLOWING";
    DocumentPosition[DocumentPosition["CONTAINS"] = 8] = "CONTAINS";
    DocumentPosition[DocumentPosition["CONTAINED_BY"] = 16] = "CONTAINED_BY";
})(DocumentPosition || (DocumentPosition = {}));
/**
 * Compare the position of one node against another node in any other document,
 * returning a bitmask with the values from {@link DocumentPosition}.
 *
 * Document order:
 * > There is an ordering, document order, defined on all the nodes in the
 * > document corresponding to the order in which the first character of the
 * > XML representation of each node occurs in the XML representation of the
 * > document after expansion of general entities. Thus, the document element
 * > node will be the first node. Element nodes occur before their children.
 * > Thus, document order orders element nodes in order of the occurrence of
 * > their start-tag in the XML (after expansion of entities). The attribute
 * > nodes of an element occur after the element and before its children. The
 * > relative order of attribute nodes is implementation-dependent.
 *
 * Source:
 * http://www.w3.org/TR/DOM-Level-3-Core/glossary.html#dt-document-order
 *
 * @category Helpers
 * @param nodeA The first node to use in the comparison
 * @param nodeB The second node to use in the comparison
 * @returns A bitmask describing the input nodes' relative position.
 *
 * See http://dom.spec.whatwg.org/#dom-node-comparedocumentposition for
 * a description of these values.
 */
function compareDocumentPosition(nodeA, nodeB) {
    const aParents = [];
    const bParents = [];
    if (nodeA === nodeB) {
        return 0;
    }
    let current = hasChildren(nodeA) ? nodeA : nodeA.parent;
    while (current) {
        aParents.unshift(current);
        current = current.parent;
    }
    current = hasChildren(nodeB) ? nodeB : nodeB.parent;
    while (current) {
        bParents.unshift(current);
        current = current.parent;
    }
    const maxIdx = Math.min(aParents.length, bParents.length);
    let idx = 0;
    while (idx < maxIdx && aParents[idx] === bParents[idx]) {
        idx++;
    }
    if (idx === 0) {
        return DocumentPosition.DISCONNECTED;
    }
    const sharedParent = aParents[idx - 1];
    const siblings = sharedParent.children;
    const aSibling = aParents[idx];
    const bSibling = bParents[idx];
    if (siblings.indexOf(aSibling) > siblings.indexOf(bSibling)) {
        if (sharedParent === nodeB) {
            return DocumentPosition.FOLLOWING | DocumentPosition.CONTAINED_BY;
        }
        return DocumentPosition.FOLLOWING;
    }
    if (sharedParent === nodeA) {
        return DocumentPosition.PRECEDING | DocumentPosition.CONTAINS;
    }
    return DocumentPosition.PRECEDING;
}
/**
 * Sort an array of nodes based on their relative position in the document,
 * removing any duplicate nodes. If the array contains nodes that do not belong
 * to the same document, sort order is unspecified.
 *
 * @category Helpers
 * @param nodes Array of DOM nodes.
 * @returns Collection of unique nodes, sorted in document order.
 */
function uniqueSort(nodes) {
    nodes = nodes.filter((node, i, arr) => !arr.includes(node, i + 1));
    nodes.sort((a, b) => {
        const relative = compareDocumentPosition(a, b);
        if (relative & DocumentPosition.PRECEDING) {
            return -1;
        }
        else if (relative & DocumentPosition.FOLLOWING) {
            return 1;
        }
        return 0;
    });
    return nodes;
}
//# sourceMappingURL=helpers.js.map
;// CONCATENATED MODULE: ./node_modules/domutils/lib/esm/feeds.js


/**
 * Get the feed object from the root of a DOM tree.
 *
 * @category Feeds
 * @param doc - The DOM to to extract the feed from.
 * @returns The feed.
 */
function feeds_getFeed(doc) {
    const feedRoot = getOneElement(isValidFeed, doc);
    return !feedRoot
        ? null
        : feedRoot.name === "feed"
            ? getAtomFeed(feedRoot)
            : getRssFeed(feedRoot);
}
/**
 * Parse an Atom feed.
 *
 * @param feedRoot The root of the feed.
 * @returns The parsed feed.
 */
function getAtomFeed(feedRoot) {
    var _a;
    const childs = feedRoot.children;
    const feed = {
        type: "atom",
        items: getElementsByTagName("entry", childs).map((item) => {
            var _a;
            const { children } = item;
            const entry = { media: getMediaElements(children) };
            addConditionally(entry, "id", "id", children);
            addConditionally(entry, "title", "title", children);
            const href = (_a = getOneElement("link", children)) === null || _a === void 0 ? void 0 : _a.attribs["href"];
            if (href) {
                entry.link = href;
            }
            const description = fetch("summary", children) || fetch("content", children);
            if (description) {
                entry.description = description;
            }
            const pubDate = fetch("updated", children);
            if (pubDate) {
                entry.pubDate = new Date(pubDate);
            }
            return entry;
        }),
    };
    addConditionally(feed, "id", "id", childs);
    addConditionally(feed, "title", "title", childs);
    const href = (_a = getOneElement("link", childs)) === null || _a === void 0 ? void 0 : _a.attribs["href"];
    if (href) {
        feed.link = href;
    }
    addConditionally(feed, "description", "subtitle", childs);
    const updated = fetch("updated", childs);
    if (updated) {
        feed.updated = new Date(updated);
    }
    addConditionally(feed, "author", "email", childs, true);
    return feed;
}
/**
 * Parse a RSS feed.
 *
 * @param feedRoot The root of the feed.
 * @returns The parsed feed.
 */
function getRssFeed(feedRoot) {
    var _a, _b;
    const childs = (_b = (_a = getOneElement("channel", feedRoot.children)) === null || _a === void 0 ? void 0 : _a.children) !== null && _b !== void 0 ? _b : [];
    const feed = {
        type: feedRoot.name.substr(0, 3),
        id: "",
        items: getElementsByTagName("item", feedRoot.children).map((item) => {
            const { children } = item;
            const entry = { media: getMediaElements(children) };
            addConditionally(entry, "id", "guid", children);
            addConditionally(entry, "title", "title", children);
            addConditionally(entry, "link", "link", children);
            addConditionally(entry, "description", "description", children);
            const pubDate = fetch("pubDate", children) || fetch("dc:date", children);
            if (pubDate)
                entry.pubDate = new Date(pubDate);
            return entry;
        }),
    };
    addConditionally(feed, "title", "title", childs);
    addConditionally(feed, "link", "link", childs);
    addConditionally(feed, "description", "description", childs);
    const updated = fetch("lastBuildDate", childs);
    if (updated) {
        feed.updated = new Date(updated);
    }
    addConditionally(feed, "author", "managingEditor", childs, true);
    return feed;
}
const MEDIA_KEYS_STRING = (/* unused pure expression or super */ null && (["url", "type", "lang"]));
const MEDIA_KEYS_INT = (/* unused pure expression or super */ null && ([
    "fileSize",
    "bitrate",
    "framerate",
    "samplingrate",
    "channels",
    "duration",
    "height",
    "width",
]));
/**
 * Get all media elements of a feed item.
 *
 * @param where Nodes to search in.
 * @returns Media elements.
 */
function getMediaElements(where) {
    return getElementsByTagName("media:content", where).map((elem) => {
        const { attribs } = elem;
        const media = {
            medium: attribs["medium"],
            isDefault: !!attribs["isDefault"],
        };
        for (const attrib of MEDIA_KEYS_STRING) {
            if (attribs[attrib]) {
                media[attrib] = attribs[attrib];
            }
        }
        for (const attrib of MEDIA_KEYS_INT) {
            if (attribs[attrib]) {
                media[attrib] = parseInt(attribs[attrib], 10);
            }
        }
        if (attribs["expression"]) {
            media.expression = attribs["expression"];
        }
        return media;
    });
}
/**
 * Get one element by tag name.
 *
 * @param tagName Tag name to look for
 * @param node Node to search in
 * @returns The element or null
 */
function getOneElement(tagName, node) {
    return getElementsByTagName(tagName, node, true, 1)[0];
}
/**
 * Get the text content of an element with a certain tag name.
 *
 * @param tagName Tag name to look for.
 * @param where Node to search in.
 * @param recurse Whether to recurse into child nodes.
 * @returns The text content of the element.
 */
function fetch(tagName, where, recurse = false) {
    return textContent(getElementsByTagName(tagName, where, recurse, 1)).trim();
}
/**
 * Adds a property to an object if it has a value.
 *
 * @param obj Object to be extended
 * @param prop Property name
 * @param tagName Tag name that contains the conditionally added property
 * @param where Element to search for the property
 * @param recurse Whether to recurse into child nodes.
 */
function addConditionally(obj, prop, tagName, where, recurse = false) {
    const val = fetch(tagName, where, recurse);
    if (val)
        obj[prop] = val;
}
/**
 * Checks if an element is a feed root node.
 *
 * @param value The name of the element to check.
 * @returns Whether an element is a feed root node.
 */
function isValidFeed(value) {
    return value === "rss" || value === "feed" || value === "rdf:RDF";
}
//# sourceMappingURL=feeds.js.map
;// CONCATENATED MODULE: ./node_modules/domutils/lib/esm/index.js







/** @deprecated Use these methods from `domhandler` directly. */

//# sourceMappingURL=index.js.map
;// CONCATENATED MODULE: ./node_modules/htmlparser2/lib/esm/index.js




// Helper methods
/**
 * Parses the data, returns the resulting document.
 *
 * @param data The data that should be parsed.
 * @param options Optional options for the parser and DOM handler.
 */
function parseDocument(data, options) {
    const handler = new DomHandler(undefined, options);
    new Parser(handler, options).end(data);
    return handler.root;
}
/**
 * Parses data, returns an array of the root nodes.
 *
 * Note that the root nodes still have a `Document` node as their parent.
 * Use `parseDocument` to get the `Document` node instead.
 *
 * @param data The data that should be parsed.
 * @param options Optional options for the parser and DOM handler.
 * @deprecated Use `parseDocument` instead.
 */
function parseDOM(data, options) {
    return parseDocument(data, options).children;
}
/**
 * Creates a parser instance, with an attached DOM handler.
 *
 * @param callback A callback that will be called once parsing has been completed, with the resulting document.
 * @param options Optional options for the parser and DOM handler.
 * @param elementCallback An optional callback that will be called every time a tag has been completed inside of the DOM.
 */
function createDocumentStream(callback, options, elementCallback) {
    const handler = new DomHandler((error) => callback(error, handler.root), options, elementCallback);
    return new Parser(handler, options);
}
/**
 * Creates a parser instance, with an attached DOM handler.
 *
 * @param callback A callback that will be called once parsing has been completed, with an array of root nodes.
 * @param options Optional options for the parser and DOM handler.
 * @param elementCallback An optional callback that will be called every time a tag has been completed inside of the DOM.
 * @deprecated Use `createDocumentStream` instead.
 */
function createDomStream(callback, options, elementCallback) {
    const handler = new DomHandler(callback, options, elementCallback);
    return new Parser(handler, options);
}

/*
 * All of the following exports exist for backwards-compatibility.
 * They should probably be removed eventually.
 */



const parseFeedDefaultOptions = { xmlMode: true };
/**
 * Parse a feed.
 *
 * @param feed The feed that should be parsed, as a string.
 * @param options Optionally, options for parsing. When using this, you should set `xmlMode` to `true`.
 */
function parseFeed(feed, options = parseFeedDefaultOptions) {
    return getFeed(parseDOM(feed, options));
}

//# sourceMappingURL=index.js.map
// EXTERNAL MODULE: ./app/configs/index.ts + 3 modules
var configs = __webpack_require__(54254);
;// CONCATENATED MODULE: ./app/helpers/function.ts





const CONTENT_LENGTH = 70;
const removeAttributes = (element)=>{
    const attributesToRemove = [];
    for (const attribute of element.attributes){
        attributesToRemove.push(attribute.name);
    }
    attributesToRemove.forEach((attributeName)=>{
        element.removeAttribute(attributeName);
    });
    return element;
};
const removeStyle = (htmlString, showAll, length)=>{
    if (true) {
        const div = document.createElement("div");
        div.innerHTML = htmlString;
        const _length = length || CONTENT_LENGTH;
        const elements = div.getElementsByTagName("*");
        for(let i = 0; i < elements.length; i++){
            elements[i].removeAttribute("style");
            elements[i].removeAttribute("data-sheets-value");
            elements[i].removeAttribute("data-sheets-userformat");
            elements[i].removeAttribute("data-sheets-textstyleruns");
        }
        const links = div.getElementsByTagName("a");
        for(let i1 = 0; i1 < links.length; i1++){
            links[i1].setAttribute("style", "color: #7673E5;");
        }
        const uls = div.getElementsByTagName("ul");
        for(let i2 = 0; i2 < uls.length; i2++){
            uls[i2].setAttribute("style", "list-style: disc !important;padding-left: 20px; margin-left: 0;");
        }
        const ols = div.getElementsByTagName("ol");
        for(let i3 = 0; i3 < ols.length; i3++){
            ols[i3].setAttribute("style", "list-style: auto !important; padding-left: 20px; margin-left: 0;");
        }
        const words = div.innerHTML.split(" ");
        if (words.length > _length && !showAll) {
            return words.slice(0, _length).join(" ") + "<span>...</span>";
        } else {
            return div.innerHTML;
        }
    }
};
const modifiedStyleLinkDecoration = (html)=>{
    if (true) {
        const tempDiv = document.createElement("div");
        tempDiv.innerHTML = html;
        const links = tempDiv.getElementsByTagName("a");
        for(let i = 0; i < links.length; i++){
            const link = links[i];
            link.removeAttribute("style");
            link.style.textDecoration = "underline";
            link.style.color = "#B8631D";
        }
        return tempDiv.innerHTML;
    }
};
const removeInlineStylesAndClasses = (htmlContent)=>{
    if (true) {
        const div = document.createElement("div");
        div.innerHTML = htmlContent;
        const allElements = div.querySelectorAll("*");
        allElements.forEach((element)=>{
            removeAttributes(element);
        });
        // xóa các element trống của string
        const elementsToRemove = [];
        // Lặp qua tất cả các thẻ và kiểm tra nếu chúng trống
        div.querySelectorAll("*").forEach((element)=>{
            if (element.textContent.trim() === "" && element.querySelectorAll("img").length === 0 && !element.getAttribute("src")) {
                elementsToRemove.push(element);
            }
        });
        // Xóa các thẻ trống
        elementsToRemove.forEach((element)=>{
            element.parentNode.removeChild(element);
        });
        const modifiedHtml = div.outerHTML;
        return modifiedHtml;
    }
};
const formatNumber = (_num)=>{
    const num = Number(_num);
    const absNum = Math.abs(num);
    if (absNum >= 1e12) {
        return (num / 1e12).toFixed(1) + "t";
    } else if (absNum >= 1e9) {
        return (num / 1e9).toFixed(1) + "b";
    } else if (absNum >= 1e6) {
        return (num / 1e6).toFixed(1) + "m";
    } else if (absNum >= 1e3) {
        return (num / 1e3).toFixed(1) + "k";
    } else {
        return num.toString();
    }
};
const dateTimeFormatter = function(value) {
    let inputFormat = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : null, outputFormat = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : "DD/MM/YYYY HH:mm";
    if (!inputFormat) {
        return moment_default()(value).format(outputFormat);
    } else {
        if (moment_default()(value, inputFormat).isValid()) {
            return moment_default()(value, inputFormat).format(outputFormat);
        } else {
            return value;
        }
    }
};
const timeAgoFormatter = function(value) {
    let timeAgoAmount = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 30, timeAgoType = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : "days", inputFormat = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : null;
    moment_default().updateLocale("vi", {
        relativeTime: {
            future: "trong %s",
            past: "%s trước",
            s: "v\xe0i gi\xe2y",
            ss: "%d gi\xe2y",
            m: "1 ph\xfat",
            mm: "%d ph\xfat",
            h: "1 giờ",
            hh: "%d giờ",
            d: "1 ng\xe0y",
            dd: "%d ng\xe0y",
            M: "1 th\xe1ng",
            MM: "%d th\xe1ng",
            y: "1 năm",
            yy: "%d năm" // Sử dụng số
        }
    });
    moment_default().updateLocale("en", {
        relativeTime: {
            future: "in %s",
            past: "%s ago",
            s: "a few seconds",
            ss: "%d seconds",
            m: "1 minute",
            mm: "%d minutes",
            h: "1 hour",
            hh: "%d hours",
            d: "1 day",
            dd: "%d days",
            M: "1 month",
            MM: "%d months",
            y: "1 year",
            yy: "%d years" // Luôn hiển thị số
        }
    });
    const begin = moment_default()().subtract(timeAgoAmount, timeAgoType).startOf("day");
    if (moment_default()(value).isBefore(begin)) {
        return dateTimeFormatter(value, inputFormat);
    }
    if (!inputFormat) {
        return moment_default()(value).locale((esm/* i18n */.ag === null || esm/* i18n */.ag === void 0 ? void 0 : esm/* i18n.language */.ag.language) || "en").fromNow();
    } else {
        if (moment_default()(value, inputFormat).isValid()) {
            return moment_default()(value, inputFormat).locale((esm/* i18n */.ag === null || esm/* i18n */.ag === void 0 ? void 0 : esm/* i18n.language */.ag.language) || "en").fromNow();
        } else {
            return value;
        }
    }
};
const timeFormatter = function(value) {
    let outputFormat = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : configs/* DATE_FORMAT_2 */.G;
    const currentTimestamp = moment_default()();
    const oneDayAgo = moment_default()().subtract(1, "days");
    const temp = moment_default()(value).isBetween(oneDayAgo, currentTimestamp, null, "[]");
    if (!!temp) {
        return timeAgoFormatter(value);
    } else return dateTimeFormatter(value, null, outputFormat);
};
const extractText = (htmlString)=>{
    let modifiedHtml = "";
    const parser = new Parser_Parser({
        onopentag: (name)=>{
            if (name === "br" || name === "p") {
                modifiedHtml += " ";
            }
        },
        ontext: (text)=>{
            // Append text content
            modifiedHtml += text;
        }
    });
    parser.write(htmlString);
    parser.end();
    return modifiedHtml === null || modifiedHtml === void 0 ? void 0 : modifiedHtml.trim();
};
const getBase64 = (file, cb, toFile, type)=>{
    return new Promise((resolve, reject)=>{
        let reader = new FileReader();
        if (file.type.match("image") || type === "image") {
            reader.readAsDataURL(file);
            reader.onload = async function() {
                await cb(reader.result);
                if (!toFile) {
                    var _reader_result;
                    resolve((_reader_result = reader.result) === null || _reader_result === void 0 ? void 0 : _reader_result.toString());
                } else {}
            };
        } else {
            reader.onload = function() {
                var blob = new Blob([
                    reader.result
                ], {
                    type: file.type || "video/mp4"
                });
                var url = URL.createObjectURL(blob);
                var video = document.createElement("video");
                var timeupdate = function() {
                    if (snapImage()) {
                        video.removeEventListener("timeupdate", timeupdate);
                        video.pause();
                    }
                };
                video.addEventListener("loadeddata", function() {
                    if (snapImage()) {
                        video.removeEventListener("timeupdate", timeupdate);
                    }
                });
                var snapImage = function() {
                    var canvas = document.createElement("canvas");
                    canvas.width = video.videoWidth;
                    canvas.height = video.videoHeight;
                    canvas.getContext("2d").drawImage(video, 0, 0, canvas.width, canvas.height);
                    var image = canvas.toDataURL();
                    var success = image.length > 100000;
                    if (success && !toFile) {
                        URL.revokeObjectURL(url);
                        cb(reader.result);
                        resolve(image);
                    }
                    if (toFile) {
                        canvas.toBlob((blob)=>{
                            if (!blob) {
                                console.error("Canvas is empty");
                                return;
                            }
                            resolve(blob);
                        }, "image/jpeg");
                    }
                    return success;
                };
                video.addEventListener("timeupdate", timeupdate);
                video.preload = "metadata";
                video.src = url;
                // Load video in Safari / IE11
                video.muted = true;
                video.playsInline = true;
                video.play();
            };
            reader.readAsArrayBuffer(file);
        }
        reader.onerror = function(error) {
            reject(error);
        };
    });
};
const checkImage = (file)=>{
    var _file_file, _file_file1, _file_file_name;
    const _list = typeof file.file === "string" ? (_file_file = file.file) === null || _file_file === void 0 ? void 0 : _file_file.split("-") : file === null || file === void 0 ? void 0 : (_file_file1 = file.file) === null || _file_file1 === void 0 ? void 0 : (_file_file_name = _file_file1.name) === null || _file_file_name === void 0 ? void 0 : _file_file_name.split(".");
    if (typeof file === "string") {
        const type = (_list === null || _list === void 0 ? void 0 : _list.includes("image")) ? "image" : "video";
        return type;
    }
    const type1 = configs/* LIST_FILE_TYPE_IMAGE.includes */.Fy.includes(_list === null || _list === void 0 ? void 0 : _list[_list.length - 1]) ? "image" : "video";
    return type1;
};
const removeVietnameseTones = (str)=>{
    str = str.replace(/à|á|ạ|ả|ã|â|ầ|ấ|ậ|ẩ|ẫ|ă|ằ|ắ|ặ|ẳ|ẵ/g, "a");
    str = str.replace(/è|é|ẹ|ẻ|ẽ|ê|ề|ế|ệ|ể|ễ/g, "e");
    str = str.replace(/ì|í|ị|ỉ|ĩ/g, "i");
    str = str.replace(/ò|ó|ọ|ỏ|õ|ô|ồ|ố|ộ|ổ|ỗ|ơ|ờ|ớ|ợ|ở|ỡ/g, "o");
    str = str.replace(/ù|ú|ụ|ủ|ũ|ư|ừ|ứ|ự|ử|ữ/g, "u");
    str = str.replace(/ỳ|ý|ỵ|ỷ|ỹ/g, "y");
    str = str.replace(/đ/g, "d");
    str = str.replace(/À|Á|Ạ|Ả|Ã|Â|Ầ|Ấ|Ậ|Ẩ|Ẫ|Ă|Ằ|Ắ|Ặ|Ẳ|Ẵ/g, "A");
    str = str.replace(/È|É|Ẹ|Ẻ|Ẽ|Ê|Ề|Ế|Ệ|Ể|Ễ/g, "E");
    str = str.replace(/Ì|Í|Ị|Ỉ|Ĩ/g, "I");
    str = str.replace(/Ò|Ó|Ọ|Ỏ|Õ|Ô|Ồ|Ố|Ộ|Ổ|Ỗ|Ơ|Ờ|Ớ|Ợ|Ở|Ỡ/g, "O");
    str = str.replace(/Ù|Ú|Ụ|Ủ|Ũ|Ư|Ừ|Ứ|Ự|Ử|Ữ/g, "U");
    str = str.replace(/Ỳ|Ý|Ỵ|Ỷ|Ỹ/g, "Y");
    str = str.replace(/Đ/g, "D");
    // Some system encode vietnamese combining accent as individual utf-8 characters
    // Một vài bộ encode coi các dấu mũ, dấu chữ như một kí tự riêng biệt nên thêm hai dòng này
    str = str.replace(/\u0300|\u0301|\u0303|\u0309|\u0323/g, "") // ̀ ́ ̃ ̉ ̣  huyền, sắc, ngã, hỏi, nặng
    ;
    str = str.replace(/\u02C6|\u0306|\u031B/g, "") // ˆ ̆ ̛  Â, Ê, Ă, Ơ, Ư
    ;
    // Remove extra spaces
    // Bỏ các khoảng trắng liền nhau
    str = str.replace(/ + /g, " ");
    str = str.trim();
    // Remove punctuations
    // Bỏ dấu câu, kí tự đặc biệt
    str = str.replace(/!|@|%|\^|\*|\(|\)|\+|\=|\<|\>|\?|\/|,|\.|\:|\;|\'|\"|\&|\#|\[|\]|~|\$|_|`|-|{|}|\||\\/g, " ");
    return str;
};
const getTimeBySubtract = (subtract)=>{
    const endDate = moment_default()(moment_default()().format(configs/* DATE_FORMAT_2_REVERT */.V7), configs/* DATE_FORMAT_2_REVERT */.V7);
    let startDate = null;
    switch(subtract){
        case "7 days":
            {
                startDate = endDate.subtract(7, "days").format(configs/* DATE_FORMAT_2_REVERT */.V7);
                break;
            }
        case "30 days":
            {
                startDate = endDate.subtract(30, "days").format(configs/* DATE_FORMAT_2_REVERT */.V7);
                break;
            }
        case "45 days":
            {
                startDate = endDate.subtract(45, "days").format(configs/* DATE_FORMAT_2_REVERT */.V7);
                break;
            }
        case "60 days":
            {
                startDate = endDate.subtract(60, "days").format(configs/* DATE_FORMAT_2_REVERT */.V7);
                break;
            }
        case "90 days":
            {
                startDate = endDate.subtract(90, "days").format(configs/* DATE_FORMAT_2_REVERT */.V7);
                break;
            }
        case "1 month":
            {
                startDate = endDate.subtract(1, "months").format(configs/* DATE_FORMAT_2_REVERT */.V7);
                break;
            }
        case "6 months":
            {
                startDate = endDate.subtract(6, "months").format(configs/* DATE_FORMAT_2_REVERT */.V7);
                break;
            }
        case "1 year":
            {
                startDate = endDate.subtract(1, "years").format(configs/* DATE_FORMAT_2_REVERT */.V7);
                break;
            }
        default:
            {
                startDate = endDate.subtract(1, "weeks").format(configs/* DATE_FORMAT_2_REVERT */.V7);
                break;
            }
    }
    return {
        start_time: startDate,
        end_time: moment_default()().format(configs/* DATE_FORMAT_2_REVERT */.V7)
    };
};
const createSlugNameDetail = (title, id)=>{
    var _removeVietnameseTones_replaceAll, _removeVietnameseTones;
    const slugTitle = !!title ? (_removeVietnameseTones_replaceAll = (_removeVietnameseTones = removeVietnameseTones(title)) === null || _removeVietnameseTones === void 0 ? void 0 : _removeVietnameseTones.replaceAll(" ", "-")) === null || _removeVietnameseTones_replaceAll === void 0 ? void 0 : _removeVietnameseTones_replaceAll.replaceAll("%", "-") : "";
    return "".concat(slugTitle, "-").concat(id).toLowerCase();
};
const getCdnImage = (url, percent)=>{
    const _cdnFilterLink = "https://cdn-thumb.playee.net/fast/filters:quality(".concat(percent ? percent : 60, "):format(webp)/");
    const _fullFilterLink = _cdnFilterLink + url.replace("https://", "");
    return _fullFilterLink;
} // export function convertYoutubeLink(str: string) {
 //   const urls = str?.match(
 //     /(https?:\/\/(?:www\.)?youtube\.com\/embed\/[a-zA-Z0-9_-]?([\w\-\.\/%&=]*))?/gi
 //   )
 //   const removeSameUrls = Array.from(new Set(urls))
 //   const _list = removeSameUrls.filter((link: string) => {
 //     return (
 //       link.startsWith("https") ||
 //       link.startsWith("http") ||
 //       link.startsWith("ftp")
 //     )
 //   })
 //   if (_list) {
 //     _list.forEach(function (url) {
 //       let replaceUrl =
 //         '<iframe target="_blank" src="' +
 //         url +
 //         '" class="w-full h-[500px] mt-4">' +
 //         url +
 //         "</iframe>"
 //       str = str
 //     })
 //   }
 //   return str?.replace("(", "<br/>(")
 // }
 // export function convertLinkToHtml(str: string) {
 //   const regex =
 //     /((ftp|https?):\/\/)?(([\w\-]+\.)+(?!jpg|jpeg|png|gif)[\w]{2,})+([\w\-\.\/%&@?=]*)?/gi
 //   let match
 //   const links = []
 //   while ((match = regex.exec(str)) !== null) {
 //     if (
 //       !/^https?:\/\/.*\.(jpg|jpeg|png|gif|svg|bmp|ico)$/i.test(match[0]) &&
 //       !/^https?:\/\/.*\.(mp3|wav|ogg|aac)$/i.test(match[0]) &&
 //       !/^https?:\/\/.*\.(mp4|avi|wmv|mov|flv|webm)$/i.test(match[0]) &&
 //       str?.[match.index - 1] !== "" &&
 //       (match[0].startsWith("https") ||
 //         match[0].startsWith("http") ||
 //         match[0].startsWith("ftp"))
 //     ) {
 //       links.push({
 //         link: match[0],
 //         index: match.index
 //       })
 //     }
 //   }
 //   let sum = 0
 //   if (links) {
 //     links.forEach(function (url, index) {
 //       let replaceUrl =
 //         '<a rel="nofollow" target="_blank" href="' +
 //         url.link.replace("&nbsp", "") +
 //         '" class="text-text-color-1">' +
 //         url.link +
 //         "</a>"
 //       str =
 //         str.substring(0, url.index + sum) +
 //         replaceUrl +
 //         str.substring(url.index + url.link.length + sum)
 //       if (index !== url.link.length - 1) {
 //         sum = sum + replaceUrl.length - url.link.length
 //       }
 //     })
 //   }
 //   return str
 // }
;


/***/ }),

/***/ 2993:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "cn": function() { return /* reexport */ doNothing; },
  "ez": function() { return /* reexport */ lazyImport; }
});

// UNUSED EXPORTS: pathToUrl

// EXTERNAL MODULE: ./node_modules/next/dist/compiled/react/index.js
var react = __webpack_require__(55784);
;// CONCATENATED MODULE: ./app/helpers/lazy-import.ts

// named imports for React.lazy: https://github.com/facebook/react/issues/14603#issuecomment-726551598
function lazyImport(factory, name) {
    return Object.create({
        [name]: react.lazy(()=>factory().then((module)=>({
                    default: module[name]
                })))
    });
} // Usage
 // const { Home } = lazyImport(() => import("./Home"), "Home");

;// CONCATENATED MODULE: ./app/helpers/do-nothing.ts
const doNothing = ()=>{};

;// CONCATENATED MODULE: ./app/helpers/index.ts





/***/ }),

/***/ 38609:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "i": function() { return /* binding */ useWindowSize; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(55784);

const useWindowSize = ()=>{
    const [size, setSize] = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)([
        0,
        0
    ]);
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(()=>{
        function updateSize() {
            setSize([
                window.innerWidth,
                window.innerHeight
            ]);
        }
        window.addEventListener("resize", updateSize);
        updateSize();
        return ()=>window.removeEventListener("resize", updateSize);
    }, []);
    return size;
};


/***/ }),

/***/ 45724:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "s": function() { return /* binding */ useDebounceEffect; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(55784);

function useDebounceEffect(fn, waitTime, deps) {
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(()=>{
        const t = setTimeout(()=>{
            fn.apply(undefined, deps);
        }, waitTime);
        return ()=>{
            clearTimeout(t);
        };
    }, [
        deps
    ]);
}


/***/ }),

/***/ 70125:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "t": function() { return /* binding */ useFacebookPixel; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(55784);
/* harmony import */ var react_use_facebook_pixel__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(18390);
/* harmony import */ var react_use_facebook_pixel__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(react_use_facebook_pixel__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _configs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(54254);



const useFacebookPixel = ()=>{
    const [facebookPixel, setFacebookPixel] = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(null);
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(()=>{
        const initializeFacebookPixel = async ()=>{
            const pixel = new react_use_facebook_pixel__WEBPACK_IMPORTED_MODULE_1__.FacebookPixel({
                pixelID: _configs__WEBPACK_IMPORTED_MODULE_2__/* .FACEBOOK_PIXEL_ID */ .aL,
                pageViewOnInit: false
            });
            pixel.init({});
            setFacebookPixel(pixel);
        };
        initializeFacebookPixel();
    }, []);
    return facebookPixel;
};


/***/ }),

/***/ 64800:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_ga4__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(49089);
/* harmony import */ var _lib_utils__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(73848);


const useGAEventsTracker = function() {
    let category = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "Event Category";
    const trackEvent = function() {
        let action = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "action", label = arguments.length > 1 ? arguments[1] : void 0, value = arguments.length > 2 ? arguments[2] : void 0;
        react_ga4__WEBPACK_IMPORTED_MODULE_0__/* ["default"].event */ .ZP.event((0,_lib_utils__WEBPACK_IMPORTED_MODULE_1__/* .removeNullKeyObject */ .t2)({
            category,
            action,
            label,
            value
        }));
    };
    return trackEvent;
};
/* harmony default export */ __webpack_exports__["Z"] = (useGAEventsTracker);


/***/ }),

/***/ 71722:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "s": function() { return /* binding */ useSocket; }
});

// NAMESPACE OBJECT: ./node_modules/socket.io-parser/build/esm/index.js
var socket_io_parser_build_esm_namespaceObject = {};
__webpack_require__.r(socket_io_parser_build_esm_namespaceObject);
__webpack_require__.d(socket_io_parser_build_esm_namespaceObject, {
  "Decoder": function() { return Decoder; },
  "Encoder": function() { return Encoder; },
  "PacketType": function() { return PacketType; },
  "protocol": function() { return build_esm_protocol; }
});

// EXTERNAL MODULE: ./node_modules/next/dist/compiled/react/index.js
var react = __webpack_require__(55784);
;// CONCATENATED MODULE: ./node_modules/engine.io-parser/build/esm/commons.js
const PACKET_TYPES = Object.create(null); // no Map = no polyfill
PACKET_TYPES["open"] = "0";
PACKET_TYPES["close"] = "1";
PACKET_TYPES["ping"] = "2";
PACKET_TYPES["pong"] = "3";
PACKET_TYPES["message"] = "4";
PACKET_TYPES["upgrade"] = "5";
PACKET_TYPES["noop"] = "6";
const PACKET_TYPES_REVERSE = Object.create(null);
Object.keys(PACKET_TYPES).forEach(key => {
    PACKET_TYPES_REVERSE[PACKET_TYPES[key]] = key;
});
const ERROR_PACKET = { type: "error", data: "parser error" };


;// CONCATENATED MODULE: ./node_modules/engine.io-parser/build/esm/encodePacket.browser.js

const withNativeBlob = typeof Blob === "function" ||
    (typeof Blob !== "undefined" &&
        Object.prototype.toString.call(Blob) === "[object BlobConstructor]");
const withNativeArrayBuffer = typeof ArrayBuffer === "function";
// ArrayBuffer.isView method is not defined in IE10
const isView = obj => {
    return typeof ArrayBuffer.isView === "function"
        ? ArrayBuffer.isView(obj)
        : obj && obj.buffer instanceof ArrayBuffer;
};
const encodePacket = ({ type, data }, supportsBinary, callback) => {
    if (withNativeBlob && data instanceof Blob) {
        if (supportsBinary) {
            return callback(data);
        }
        else {
            return encodeBlobAsBase64(data, callback);
        }
    }
    else if (withNativeArrayBuffer &&
        (data instanceof ArrayBuffer || isView(data))) {
        if (supportsBinary) {
            return callback(data);
        }
        else {
            return encodeBlobAsBase64(new Blob([data]), callback);
        }
    }
    // plain string
    return callback(PACKET_TYPES[type] + (data || ""));
};
const encodeBlobAsBase64 = (data, callback) => {
    const fileReader = new FileReader();
    fileReader.onload = function () {
        const content = fileReader.result.split(",")[1];
        callback("b" + (content || ""));
    };
    return fileReader.readAsDataURL(data);
};
/* harmony default export */ var encodePacket_browser = (encodePacket);

;// CONCATENATED MODULE: ./node_modules/engine.io-parser/build/esm/contrib/base64-arraybuffer.js
// imported from https://github.com/socketio/base64-arraybuffer
const chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/';
// Use a lookup table to find the index.
const lookup = typeof Uint8Array === 'undefined' ? [] : new Uint8Array(256);
for (let i = 0; i < chars.length; i++) {
    lookup[chars.charCodeAt(i)] = i;
}
const encode = (arraybuffer) => {
    let bytes = new Uint8Array(arraybuffer), i, len = bytes.length, base64 = '';
    for (i = 0; i < len; i += 3) {
        base64 += chars[bytes[i] >> 2];
        base64 += chars[((bytes[i] & 3) << 4) | (bytes[i + 1] >> 4)];
        base64 += chars[((bytes[i + 1] & 15) << 2) | (bytes[i + 2] >> 6)];
        base64 += chars[bytes[i + 2] & 63];
    }
    if (len % 3 === 2) {
        base64 = base64.substring(0, base64.length - 1) + '=';
    }
    else if (len % 3 === 1) {
        base64 = base64.substring(0, base64.length - 2) + '==';
    }
    return base64;
};
const decode = (base64) => {
    let bufferLength = base64.length * 0.75, len = base64.length, i, p = 0, encoded1, encoded2, encoded3, encoded4;
    if (base64[base64.length - 1] === '=') {
        bufferLength--;
        if (base64[base64.length - 2] === '=') {
            bufferLength--;
        }
    }
    const arraybuffer = new ArrayBuffer(bufferLength), bytes = new Uint8Array(arraybuffer);
    for (i = 0; i < len; i += 4) {
        encoded1 = lookup[base64.charCodeAt(i)];
        encoded2 = lookup[base64.charCodeAt(i + 1)];
        encoded3 = lookup[base64.charCodeAt(i + 2)];
        encoded4 = lookup[base64.charCodeAt(i + 3)];
        bytes[p++] = (encoded1 << 2) | (encoded2 >> 4);
        bytes[p++] = ((encoded2 & 15) << 4) | (encoded3 >> 2);
        bytes[p++] = ((encoded3 & 3) << 6) | (encoded4 & 63);
    }
    return arraybuffer;
};

;// CONCATENATED MODULE: ./node_modules/engine.io-parser/build/esm/decodePacket.browser.js


const decodePacket_browser_withNativeArrayBuffer = typeof ArrayBuffer === "function";
const decodePacket = (encodedPacket, binaryType) => {
    if (typeof encodedPacket !== "string") {
        return {
            type: "message",
            data: mapBinary(encodedPacket, binaryType)
        };
    }
    const type = encodedPacket.charAt(0);
    if (type === "b") {
        return {
            type: "message",
            data: decodeBase64Packet(encodedPacket.substring(1), binaryType)
        };
    }
    const packetType = PACKET_TYPES_REVERSE[type];
    if (!packetType) {
        return ERROR_PACKET;
    }
    return encodedPacket.length > 1
        ? {
            type: PACKET_TYPES_REVERSE[type],
            data: encodedPacket.substring(1)
        }
        : {
            type: PACKET_TYPES_REVERSE[type]
        };
};
const decodeBase64Packet = (data, binaryType) => {
    if (decodePacket_browser_withNativeArrayBuffer) {
        const decoded = decode(data);
        return mapBinary(decoded, binaryType);
    }
    else {
        return { base64: true, data }; // fallback for old browsers
    }
};
const mapBinary = (data, binaryType) => {
    switch (binaryType) {
        case "blob":
            return data instanceof ArrayBuffer ? new Blob([data]) : data;
        case "arraybuffer":
        default:
            return data; // assuming the data is already an ArrayBuffer
    }
};
/* harmony default export */ var decodePacket_browser = (decodePacket);

;// CONCATENATED MODULE: ./node_modules/engine.io-parser/build/esm/index.js


const SEPARATOR = String.fromCharCode(30); // see https://en.wikipedia.org/wiki/Delimiter#ASCII_delimited_text
const encodePayload = (packets, callback) => {
    // some packets may be added to the array while encoding, so the initial length must be saved
    const length = packets.length;
    const encodedPackets = new Array(length);
    let count = 0;
    packets.forEach((packet, i) => {
        // force base64 encoding for binary packets
        encodePacket_browser(packet, false, encodedPacket => {
            encodedPackets[i] = encodedPacket;
            if (++count === length) {
                callback(encodedPackets.join(SEPARATOR));
            }
        });
    });
};
const decodePayload = (encodedPayload, binaryType) => {
    const encodedPackets = encodedPayload.split(SEPARATOR);
    const packets = [];
    for (let i = 0; i < encodedPackets.length; i++) {
        const decodedPacket = decodePacket_browser(encodedPackets[i], binaryType);
        packets.push(decodedPacket);
        if (decodedPacket.type === "error") {
            break;
        }
    }
    return packets;
};
const protocol = 4;


;// CONCATENATED MODULE: ./node_modules/@socket.io/component-emitter/index.mjs
/**
 * Initialize a new `Emitter`.
 *
 * @api public
 */

function Emitter(obj) {
  if (obj) return mixin(obj);
}

/**
 * Mixin the emitter properties.
 *
 * @param {Object} obj
 * @return {Object}
 * @api private
 */

function mixin(obj) {
  for (var key in Emitter.prototype) {
    obj[key] = Emitter.prototype[key];
  }
  return obj;
}

/**
 * Listen on the given `event` with `fn`.
 *
 * @param {String} event
 * @param {Function} fn
 * @return {Emitter}
 * @api public
 */

Emitter.prototype.on =
Emitter.prototype.addEventListener = function(event, fn){
  this._callbacks = this._callbacks || {};
  (this._callbacks['$' + event] = this._callbacks['$' + event] || [])
    .push(fn);
  return this;
};

/**
 * Adds an `event` listener that will be invoked a single
 * time then automatically removed.
 *
 * @param {String} event
 * @param {Function} fn
 * @return {Emitter}
 * @api public
 */

Emitter.prototype.once = function(event, fn){
  function on() {
    this.off(event, on);
    fn.apply(this, arguments);
  }

  on.fn = fn;
  this.on(event, on);
  return this;
};

/**
 * Remove the given callback for `event` or all
 * registered callbacks.
 *
 * @param {String} event
 * @param {Function} fn
 * @return {Emitter}
 * @api public
 */

Emitter.prototype.off =
Emitter.prototype.removeListener =
Emitter.prototype.removeAllListeners =
Emitter.prototype.removeEventListener = function(event, fn){
  this._callbacks = this._callbacks || {};

  // all
  if (0 == arguments.length) {
    this._callbacks = {};
    return this;
  }

  // specific event
  var callbacks = this._callbacks['$' + event];
  if (!callbacks) return this;

  // remove all handlers
  if (1 == arguments.length) {
    delete this._callbacks['$' + event];
    return this;
  }

  // remove specific handler
  var cb;
  for (var i = 0; i < callbacks.length; i++) {
    cb = callbacks[i];
    if (cb === fn || cb.fn === fn) {
      callbacks.splice(i, 1);
      break;
    }
  }

  // Remove event specific arrays for event types that no
  // one is subscribed for to avoid memory leak.
  if (callbacks.length === 0) {
    delete this._callbacks['$' + event];
  }

  return this;
};

/**
 * Emit `event` with the given args.
 *
 * @param {String} event
 * @param {Mixed} ...
 * @return {Emitter}
 */

Emitter.prototype.emit = function(event){
  this._callbacks = this._callbacks || {};

  var args = new Array(arguments.length - 1)
    , callbacks = this._callbacks['$' + event];

  for (var i = 1; i < arguments.length; i++) {
    args[i - 1] = arguments[i];
  }

  if (callbacks) {
    callbacks = callbacks.slice(0);
    for (var i = 0, len = callbacks.length; i < len; ++i) {
      callbacks[i].apply(this, args);
    }
  }

  return this;
};

// alias used for reserved events (protected method)
Emitter.prototype.emitReserved = Emitter.prototype.emit;

/**
 * Return array of callbacks for `event`.
 *
 * @param {String} event
 * @return {Array}
 * @api public
 */

Emitter.prototype.listeners = function(event){
  this._callbacks = this._callbacks || {};
  return this._callbacks['$' + event] || [];
};

/**
 * Check if this emitter has `event` handlers.
 *
 * @param {String} event
 * @return {Boolean}
 * @api public
 */

Emitter.prototype.hasListeners = function(event){
  return !! this.listeners(event).length;
};

;// CONCATENATED MODULE: ./node_modules/engine.io-client/build/esm/globalThis.browser.js
const globalThisShim = (() => {
    if (typeof self !== "undefined") {
        return self;
    }
    else if (typeof window !== "undefined") {
        return window;
    }
    else {
        return Function("return this")();
    }
})();

;// CONCATENATED MODULE: ./node_modules/engine.io-client/build/esm/util.js

function pick(obj, ...attr) {
    return attr.reduce((acc, k) => {
        if (obj.hasOwnProperty(k)) {
            acc[k] = obj[k];
        }
        return acc;
    }, {});
}
// Keep a reference to the real timeout functions so they can be used when overridden
const NATIVE_SET_TIMEOUT = globalThisShim.setTimeout;
const NATIVE_CLEAR_TIMEOUT = globalThisShim.clearTimeout;
function installTimerFunctions(obj, opts) {
    if (opts.useNativeTimers) {
        obj.setTimeoutFn = NATIVE_SET_TIMEOUT.bind(globalThisShim);
        obj.clearTimeoutFn = NATIVE_CLEAR_TIMEOUT.bind(globalThisShim);
    }
    else {
        obj.setTimeoutFn = globalThisShim.setTimeout.bind(globalThisShim);
        obj.clearTimeoutFn = globalThisShim.clearTimeout.bind(globalThisShim);
    }
}
// base64 encoded buffers are about 33% bigger (https://en.wikipedia.org/wiki/Base64)
const BASE64_OVERHEAD = 1.33;
// we could also have used `new Blob([obj]).size`, but it isn't supported in IE9
function byteLength(obj) {
    if (typeof obj === "string") {
        return utf8Length(obj);
    }
    // arraybuffer or blob
    return Math.ceil((obj.byteLength || obj.size) * BASE64_OVERHEAD);
}
function utf8Length(str) {
    let c = 0, length = 0;
    for (let i = 0, l = str.length; i < l; i++) {
        c = str.charCodeAt(i);
        if (c < 0x80) {
            length += 1;
        }
        else if (c < 0x800) {
            length += 2;
        }
        else if (c < 0xd800 || c >= 0xe000) {
            length += 3;
        }
        else {
            i++;
            length += 4;
        }
    }
    return length;
}

;// CONCATENATED MODULE: ./node_modules/engine.io-client/build/esm/transport.js



class TransportError extends Error {
    constructor(reason, description, context) {
        super(reason);
        this.description = description;
        this.context = context;
        this.type = "TransportError";
    }
}
class Transport extends Emitter {
    /**
     * Transport abstract constructor.
     *
     * @param {Object} opts - options
     * @protected
     */
    constructor(opts) {
        super();
        this.writable = false;
        installTimerFunctions(this, opts);
        this.opts = opts;
        this.query = opts.query;
        this.socket = opts.socket;
    }
    /**
     * Emits an error.
     *
     * @param {String} reason
     * @param description
     * @param context - the error context
     * @return {Transport} for chaining
     * @protected
     */
    onError(reason, description, context) {
        super.emitReserved("error", new TransportError(reason, description, context));
        return this;
    }
    /**
     * Opens the transport.
     */
    open() {
        this.readyState = "opening";
        this.doOpen();
        return this;
    }
    /**
     * Closes the transport.
     */
    close() {
        if (this.readyState === "opening" || this.readyState === "open") {
            this.doClose();
            this.onClose();
        }
        return this;
    }
    /**
     * Sends multiple packets.
     *
     * @param {Array} packets
     */
    send(packets) {
        if (this.readyState === "open") {
            this.write(packets);
        }
        else {
            // this might happen if the transport was silently closed in the beforeunload event handler
        }
    }
    /**
     * Called upon open
     *
     * @protected
     */
    onOpen() {
        this.readyState = "open";
        this.writable = true;
        super.emitReserved("open");
    }
    /**
     * Called with data.
     *
     * @param {String} data
     * @protected
     */
    onData(data) {
        const packet = decodePacket_browser(data, this.socket.binaryType);
        this.onPacket(packet);
    }
    /**
     * Called with a decoded packet.
     *
     * @protected
     */
    onPacket(packet) {
        super.emitReserved("packet", packet);
    }
    /**
     * Called upon close.
     *
     * @protected
     */
    onClose(details) {
        this.readyState = "closed";
        super.emitReserved("close", details);
    }
    /**
     * Pauses the transport, in order not to lose packets during an upgrade.
     *
     * @param onPause
     */
    pause(onPause) { }
}

;// CONCATENATED MODULE: ./node_modules/engine.io-client/build/esm/contrib/yeast.js
// imported from https://github.com/unshiftio/yeast

const alphabet = '0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz-_'.split(''), yeast_length = 64, map = {};
let seed = 0, i = 0, prev;
/**
 * Return a string representing the specified number.
 *
 * @param {Number} num The number to convert.
 * @returns {String} The string representation of the number.
 * @api public
 */
function yeast_encode(num) {
    let encoded = '';
    do {
        encoded = alphabet[num % yeast_length] + encoded;
        num = Math.floor(num / yeast_length);
    } while (num > 0);
    return encoded;
}
/**
 * Return the integer value specified by the given string.
 *
 * @param {String} str The string to convert.
 * @returns {Number} The integer value represented by the string.
 * @api public
 */
function yeast_decode(str) {
    let decoded = 0;
    for (i = 0; i < str.length; i++) {
        decoded = decoded * yeast_length + map[str.charAt(i)];
    }
    return decoded;
}
/**
 * Yeast: A tiny growing id generator.
 *
 * @returns {String} A unique id.
 * @api public
 */
function yeast() {
    const now = yeast_encode(+new Date());
    if (now !== prev)
        return seed = 0, prev = now;
    return now + '.' + yeast_encode(seed++);
}
//
// Map each character to its index.
//
for (; i < yeast_length; i++)
    map[alphabet[i]] = i;

;// CONCATENATED MODULE: ./node_modules/engine.io-client/build/esm/contrib/parseqs.js
// imported from https://github.com/galkn/querystring
/**
 * Compiles a querystring
 * Returns string representation of the object
 *
 * @param {Object}
 * @api private
 */
function parseqs_encode(obj) {
    let str = '';
    for (let i in obj) {
        if (obj.hasOwnProperty(i)) {
            if (str.length)
                str += '&';
            str += encodeURIComponent(i) + '=' + encodeURIComponent(obj[i]);
        }
    }
    return str;
}
/**
 * Parses a simple querystring into an object
 *
 * @param {String} qs
 * @api private
 */
function parseqs_decode(qs) {
    let qry = {};
    let pairs = qs.split('&');
    for (let i = 0, l = pairs.length; i < l; i++) {
        let pair = pairs[i].split('=');
        qry[decodeURIComponent(pair[0])] = decodeURIComponent(pair[1]);
    }
    return qry;
}

;// CONCATENATED MODULE: ./node_modules/engine.io-client/build/esm/contrib/has-cors.js
// imported from https://github.com/component/has-cors
let value = false;
try {
    value = typeof XMLHttpRequest !== 'undefined' &&
        'withCredentials' in new XMLHttpRequest();
}
catch (err) {
    // if XMLHttp support is disabled in IE then it will throw
    // when trying to create
}
const hasCORS = value;

;// CONCATENATED MODULE: ./node_modules/engine.io-client/build/esm/transports/xmlhttprequest.browser.js
// browser shim for xmlhttprequest module


function XHR(opts) {
    const xdomain = opts.xdomain;
    // XMLHttpRequest can be disabled on IE
    try {
        if ("undefined" !== typeof XMLHttpRequest && (!xdomain || hasCORS)) {
            return new XMLHttpRequest();
        }
    }
    catch (e) { }
    if (!xdomain) {
        try {
            return new globalThisShim[["Active"].concat("Object").join("X")]("Microsoft.XMLHTTP");
        }
        catch (e) { }
    }
}

;// CONCATENATED MODULE: ./node_modules/engine.io-client/build/esm/transports/polling.js








function empty() { }
const hasXHR2 = (function () {
    const xhr = new XHR({
        xdomain: false,
    });
    return null != xhr.responseType;
})();
class Polling extends Transport {
    /**
     * XHR Polling constructor.
     *
     * @param {Object} opts
     * @package
     */
    constructor(opts) {
        super(opts);
        this.polling = false;
        if (typeof location !== "undefined") {
            const isSSL = "https:" === location.protocol;
            let port = location.port;
            // some user agents have empty `location.port`
            if (!port) {
                port = isSSL ? "443" : "80";
            }
            this.xd =
                (typeof location !== "undefined" &&
                    opts.hostname !== location.hostname) ||
                    port !== opts.port;
            this.xs = opts.secure !== isSSL;
        }
        /**
         * XHR supports binary
         */
        const forceBase64 = opts && opts.forceBase64;
        this.supportsBinary = hasXHR2 && !forceBase64;
    }
    get name() {
        return "polling";
    }
    /**
     * Opens the socket (triggers polling). We write a PING message to determine
     * when the transport is open.
     *
     * @protected
     */
    doOpen() {
        this.poll();
    }
    /**
     * Pauses polling.
     *
     * @param {Function} onPause - callback upon buffers are flushed and transport is paused
     * @package
     */
    pause(onPause) {
        this.readyState = "pausing";
        const pause = () => {
            this.readyState = "paused";
            onPause();
        };
        if (this.polling || !this.writable) {
            let total = 0;
            if (this.polling) {
                total++;
                this.once("pollComplete", function () {
                    --total || pause();
                });
            }
            if (!this.writable) {
                total++;
                this.once("drain", function () {
                    --total || pause();
                });
            }
        }
        else {
            pause();
        }
    }
    /**
     * Starts polling cycle.
     *
     * @private
     */
    poll() {
        this.polling = true;
        this.doPoll();
        this.emitReserved("poll");
    }
    /**
     * Overloads onData to detect payloads.
     *
     * @protected
     */
    onData(data) {
        const callback = (packet) => {
            // if its the first message we consider the transport open
            if ("opening" === this.readyState && packet.type === "open") {
                this.onOpen();
            }
            // if its a close packet, we close the ongoing requests
            if ("close" === packet.type) {
                this.onClose({ description: "transport closed by the server" });
                return false;
            }
            // otherwise bypass onData and handle the message
            this.onPacket(packet);
        };
        // decode payload
        decodePayload(data, this.socket.binaryType).forEach(callback);
        // if an event did not trigger closing
        if ("closed" !== this.readyState) {
            // if we got data we're not polling
            this.polling = false;
            this.emitReserved("pollComplete");
            if ("open" === this.readyState) {
                this.poll();
            }
            else {
            }
        }
    }
    /**
     * For polling, send a close packet.
     *
     * @protected
     */
    doClose() {
        const close = () => {
            this.write([{ type: "close" }]);
        };
        if ("open" === this.readyState) {
            close();
        }
        else {
            // in case we're trying to close while
            // handshaking is in progress (GH-164)
            this.once("open", close);
        }
    }
    /**
     * Writes a packets payload.
     *
     * @param {Array} packets - data packets
     * @protected
     */
    write(packets) {
        this.writable = false;
        encodePayload(packets, (data) => {
            this.doWrite(data, () => {
                this.writable = true;
                this.emitReserved("drain");
            });
        });
    }
    /**
     * Generates uri for connection.
     *
     * @private
     */
    uri() {
        let query = this.query || {};
        const schema = this.opts.secure ? "https" : "http";
        let port = "";
        // cache busting is forced
        if (false !== this.opts.timestampRequests) {
            query[this.opts.timestampParam] = yeast();
        }
        if (!this.supportsBinary && !query.sid) {
            query.b64 = 1;
        }
        // avoid port if default for schema
        if (this.opts.port &&
            (("https" === schema && Number(this.opts.port) !== 443) ||
                ("http" === schema && Number(this.opts.port) !== 80))) {
            port = ":" + this.opts.port;
        }
        const encodedQuery = parseqs_encode(query);
        const ipv6 = this.opts.hostname.indexOf(":") !== -1;
        return (schema +
            "://" +
            (ipv6 ? "[" + this.opts.hostname + "]" : this.opts.hostname) +
            port +
            this.opts.path +
            (encodedQuery.length ? "?" + encodedQuery : ""));
    }
    /**
     * Creates a request.
     *
     * @param {String} method
     * @private
     */
    request(opts = {}) {
        Object.assign(opts, { xd: this.xd, xs: this.xs }, this.opts);
        return new Request(this.uri(), opts);
    }
    /**
     * Sends data.
     *
     * @param {String} data to send.
     * @param {Function} called upon flush.
     * @private
     */
    doWrite(data, fn) {
        const req = this.request({
            method: "POST",
            data: data,
        });
        req.on("success", fn);
        req.on("error", (xhrStatus, context) => {
            this.onError("xhr post error", xhrStatus, context);
        });
    }
    /**
     * Starts a poll cycle.
     *
     * @private
     */
    doPoll() {
        const req = this.request();
        req.on("data", this.onData.bind(this));
        req.on("error", (xhrStatus, context) => {
            this.onError("xhr poll error", xhrStatus, context);
        });
        this.pollXhr = req;
    }
}
class Request extends Emitter {
    /**
     * Request constructor
     *
     * @param {Object} options
     * @package
     */
    constructor(uri, opts) {
        super();
        installTimerFunctions(this, opts);
        this.opts = opts;
        this.method = opts.method || "GET";
        this.uri = uri;
        this.async = false !== opts.async;
        this.data = undefined !== opts.data ? opts.data : null;
        this.create();
    }
    /**
     * Creates the XHR object and sends the request.
     *
     * @private
     */
    create() {
        const opts = pick(this.opts, "agent", "pfx", "key", "passphrase", "cert", "ca", "ciphers", "rejectUnauthorized", "autoUnref");
        opts.xdomain = !!this.opts.xd;
        opts.xscheme = !!this.opts.xs;
        const xhr = (this.xhr = new XHR(opts));
        try {
            xhr.open(this.method, this.uri, this.async);
            try {
                if (this.opts.extraHeaders) {
                    xhr.setDisableHeaderCheck && xhr.setDisableHeaderCheck(true);
                    for (let i in this.opts.extraHeaders) {
                        if (this.opts.extraHeaders.hasOwnProperty(i)) {
                            xhr.setRequestHeader(i, this.opts.extraHeaders[i]);
                        }
                    }
                }
            }
            catch (e) { }
            if ("POST" === this.method) {
                try {
                    xhr.setRequestHeader("Content-type", "text/plain;charset=UTF-8");
                }
                catch (e) { }
            }
            try {
                xhr.setRequestHeader("Accept", "*/*");
            }
            catch (e) { }
            // ie6 check
            if ("withCredentials" in xhr) {
                xhr.withCredentials = this.opts.withCredentials;
            }
            if (this.opts.requestTimeout) {
                xhr.timeout = this.opts.requestTimeout;
            }
            xhr.onreadystatechange = () => {
                if (4 !== xhr.readyState)
                    return;
                if (200 === xhr.status || 1223 === xhr.status) {
                    this.onLoad();
                }
                else {
                    // make sure the `error` event handler that's user-set
                    // does not throw in the same tick and gets caught here
                    this.setTimeoutFn(() => {
                        this.onError(typeof xhr.status === "number" ? xhr.status : 0);
                    }, 0);
                }
            };
            xhr.send(this.data);
        }
        catch (e) {
            // Need to defer since .create() is called directly from the constructor
            // and thus the 'error' event can only be only bound *after* this exception
            // occurs.  Therefore, also, we cannot throw here at all.
            this.setTimeoutFn(() => {
                this.onError(e);
            }, 0);
            return;
        }
        if (typeof document !== "undefined") {
            this.index = Request.requestsCount++;
            Request.requests[this.index] = this;
        }
    }
    /**
     * Called upon error.
     *
     * @private
     */
    onError(err) {
        this.emitReserved("error", err, this.xhr);
        this.cleanup(true);
    }
    /**
     * Cleans up house.
     *
     * @private
     */
    cleanup(fromError) {
        if ("undefined" === typeof this.xhr || null === this.xhr) {
            return;
        }
        this.xhr.onreadystatechange = empty;
        if (fromError) {
            try {
                this.xhr.abort();
            }
            catch (e) { }
        }
        if (typeof document !== "undefined") {
            delete Request.requests[this.index];
        }
        this.xhr = null;
    }
    /**
     * Called upon load.
     *
     * @private
     */
    onLoad() {
        const data = this.xhr.responseText;
        if (data !== null) {
            this.emitReserved("data", data);
            this.emitReserved("success");
            this.cleanup();
        }
    }
    /**
     * Aborts the request.
     *
     * @package
     */
    abort() {
        this.cleanup();
    }
}
Request.requestsCount = 0;
Request.requests = {};
/**
 * Aborts pending requests when unloading the window. This is needed to prevent
 * memory leaks (e.g. when using IE) and to ensure that no spurious error is
 * emitted.
 */
if (typeof document !== "undefined") {
    // @ts-ignore
    if (typeof attachEvent === "function") {
        // @ts-ignore
        attachEvent("onunload", unloadHandler);
    }
    else if (typeof addEventListener === "function") {
        const terminationEvent = "onpagehide" in globalThisShim ? "pagehide" : "unload";
        addEventListener(terminationEvent, unloadHandler, false);
    }
}
function unloadHandler() {
    for (let i in Request.requests) {
        if (Request.requests.hasOwnProperty(i)) {
            Request.requests[i].abort();
        }
    }
}

;// CONCATENATED MODULE: ./node_modules/engine.io-client/build/esm/transports/websocket-constructor.browser.js

const nextTick = (() => {
    const isPromiseAvailable = typeof Promise === "function" && typeof Promise.resolve === "function";
    if (isPromiseAvailable) {
        return (cb) => Promise.resolve().then(cb);
    }
    else {
        return (cb, setTimeoutFn) => setTimeoutFn(cb, 0);
    }
})();
const WebSocket = globalThisShim.WebSocket || globalThisShim.MozWebSocket;
const usingBrowserWebSocket = true;
const defaultBinaryType = "arraybuffer";

;// CONCATENATED MODULE: ./node_modules/engine.io-client/build/esm/transports/websocket.js
/* provided dependency */ var Buffer = __webpack_require__(21876)["Buffer"];






// detect ReactNative environment
const isReactNative = typeof navigator !== "undefined" &&
    typeof navigator.product === "string" &&
    navigator.product.toLowerCase() === "reactnative";
class WS extends Transport {
    /**
     * WebSocket transport constructor.
     *
     * @param {Object} opts - connection options
     * @protected
     */
    constructor(opts) {
        super(opts);
        this.supportsBinary = !opts.forceBase64;
    }
    get name() {
        return "websocket";
    }
    doOpen() {
        if (!this.check()) {
            // let probe timeout
            return;
        }
        const uri = this.uri();
        const protocols = this.opts.protocols;
        // React Native only supports the 'headers' option, and will print a warning if anything else is passed
        const opts = isReactNative
            ? {}
            : pick(this.opts, "agent", "perMessageDeflate", "pfx", "key", "passphrase", "cert", "ca", "ciphers", "rejectUnauthorized", "localAddress", "protocolVersion", "origin", "maxPayload", "family", "checkServerIdentity");
        if (this.opts.extraHeaders) {
            opts.headers = this.opts.extraHeaders;
        }
        try {
            this.ws =
                usingBrowserWebSocket && !isReactNative
                    ? protocols
                        ? new WebSocket(uri, protocols)
                        : new WebSocket(uri)
                    : new WebSocket(uri, protocols, opts);
        }
        catch (err) {
            return this.emitReserved("error", err);
        }
        this.ws.binaryType = this.socket.binaryType || defaultBinaryType;
        this.addEventListeners();
    }
    /**
     * Adds event listeners to the socket
     *
     * @private
     */
    addEventListeners() {
        this.ws.onopen = () => {
            if (this.opts.autoUnref) {
                this.ws._socket.unref();
            }
            this.onOpen();
        };
        this.ws.onclose = (closeEvent) => this.onClose({
            description: "websocket connection closed",
            context: closeEvent,
        });
        this.ws.onmessage = (ev) => this.onData(ev.data);
        this.ws.onerror = (e) => this.onError("websocket error", e);
    }
    write(packets) {
        this.writable = false;
        // encodePacket efficient as it uses WS framing
        // no need for encodePayload
        for (let i = 0; i < packets.length; i++) {
            const packet = packets[i];
            const lastPacket = i === packets.length - 1;
            encodePacket_browser(packet, this.supportsBinary, (data) => {
                // always create a new object (GH-437)
                const opts = {};
                if (!usingBrowserWebSocket) {
                    if (packet.options) {
                        opts.compress = packet.options.compress;
                    }
                    if (this.opts.perMessageDeflate) {
                        const len = 
                        // @ts-ignore
                        "string" === typeof data ? Buffer.byteLength(data) : data.length;
                        if (len < this.opts.perMessageDeflate.threshold) {
                            opts.compress = false;
                        }
                    }
                }
                // Sometimes the websocket has already been closed but the browser didn't
                // have a chance of informing us about it yet, in that case send will
                // throw an error
                try {
                    if (usingBrowserWebSocket) {
                        // TypeError is thrown when passing the second argument on Safari
                        this.ws.send(data);
                    }
                    else {
                        this.ws.send(data, opts);
                    }
                }
                catch (e) {
                }
                if (lastPacket) {
                    // fake drain
                    // defer to next tick to allow Socket to clear writeBuffer
                    nextTick(() => {
                        this.writable = true;
                        this.emitReserved("drain");
                    }, this.setTimeoutFn);
                }
            });
        }
    }
    doClose() {
        if (typeof this.ws !== "undefined") {
            this.ws.close();
            this.ws = null;
        }
    }
    /**
     * Generates uri for connection.
     *
     * @private
     */
    uri() {
        let query = this.query || {};
        const schema = this.opts.secure ? "wss" : "ws";
        let port = "";
        // avoid port if default for schema
        if (this.opts.port &&
            (("wss" === schema && Number(this.opts.port) !== 443) ||
                ("ws" === schema && Number(this.opts.port) !== 80))) {
            port = ":" + this.opts.port;
        }
        // append timestamp to URI
        if (this.opts.timestampRequests) {
            query[this.opts.timestampParam] = yeast();
        }
        // communicate binary support capabilities
        if (!this.supportsBinary) {
            query.b64 = 1;
        }
        const encodedQuery = parseqs_encode(query);
        const ipv6 = this.opts.hostname.indexOf(":") !== -1;
        return (schema +
            "://" +
            (ipv6 ? "[" + this.opts.hostname + "]" : this.opts.hostname) +
            port +
            this.opts.path +
            (encodedQuery.length ? "?" + encodedQuery : ""));
    }
    /**
     * Feature detection for WebSocket.
     *
     * @return {Boolean} whether this transport is available.
     * @private
     */
    check() {
        return !!WebSocket;
    }
}

;// CONCATENATED MODULE: ./node_modules/engine.io-client/build/esm/transports/index.js


const transports = {
    websocket: WS,
    polling: Polling,
};

;// CONCATENATED MODULE: ./node_modules/engine.io-client/build/esm/contrib/parseuri.js
// imported from https://github.com/galkn/parseuri
/**
 * Parses a URI
 *
 * Note: we could also have used the built-in URL object, but it isn't supported on all platforms.
 *
 * See:
 * - https://developer.mozilla.org/en-US/docs/Web/API/URL
 * - https://caniuse.com/url
 * - https://www.rfc-editor.org/rfc/rfc3986#appendix-B
 *
 * History of the parse() method:
 * - first commit: https://github.com/socketio/socket.io-client/commit/4ee1d5d94b3906a9c052b459f1a818b15f38f91c
 * - export into its own module: https://github.com/socketio/engine.io-client/commit/de2c561e4564efeb78f1bdb1ba39ef81b2822cb3
 * - reimport: https://github.com/socketio/engine.io-client/commit/df32277c3f6d622eec5ed09f493cae3f3391d242
 *
 * @author Steven Levithan <stevenlevithan.com> (MIT license)
 * @api private
 */
const re = /^(?:(?![^:@\/?#]+:[^:@\/]*@)(http|https|ws|wss):\/\/)?((?:(([^:@\/?#]*)(?::([^:@\/?#]*))?)?@)?((?:[a-f0-9]{0,4}:){2,7}[a-f0-9]{0,4}|[^:\/?#]*)(?::(\d*))?)(((\/(?:[^?#](?![^?#\/]*\.[^?#\/.]+(?:[?#]|$)))*\/?)?([^?#\/]*))(?:\?([^#]*))?(?:#(.*))?)/;
const parts = [
    'source', 'protocol', 'authority', 'userInfo', 'user', 'password', 'host', 'port', 'relative', 'path', 'directory', 'file', 'query', 'anchor'
];
function parse(str) {
    const src = str, b = str.indexOf('['), e = str.indexOf(']');
    if (b != -1 && e != -1) {
        str = str.substring(0, b) + str.substring(b, e).replace(/:/g, ';') + str.substring(e, str.length);
    }
    let m = re.exec(str || ''), uri = {}, i = 14;
    while (i--) {
        uri[parts[i]] = m[i] || '';
    }
    if (b != -1 && e != -1) {
        uri.source = src;
        uri.host = uri.host.substring(1, uri.host.length - 1).replace(/;/g, ':');
        uri.authority = uri.authority.replace('[', '').replace(']', '').replace(/;/g, ':');
        uri.ipv6uri = true;
    }
    uri.pathNames = pathNames(uri, uri['path']);
    uri.queryKey = queryKey(uri, uri['query']);
    return uri;
}
function pathNames(obj, path) {
    const regx = /\/{2,9}/g, names = path.replace(regx, "/").split("/");
    if (path.slice(0, 1) == '/' || path.length === 0) {
        names.splice(0, 1);
    }
    if (path.slice(-1) == '/') {
        names.splice(names.length - 1, 1);
    }
    return names;
}
function queryKey(uri, query) {
    const data = {};
    query.replace(/(?:^|&)([^&=]*)=?([^&]*)/g, function ($0, $1, $2) {
        if ($1) {
            data[$1] = $2;
        }
    });
    return data;
}

;// CONCATENATED MODULE: ./node_modules/engine.io-client/build/esm/socket.js






class Socket extends Emitter {
    /**
     * Socket constructor.
     *
     * @param {String|Object} uri - uri or options
     * @param {Object} opts - options
     */
    constructor(uri, opts = {}) {
        super();
        this.writeBuffer = [];
        if (uri && "object" === typeof uri) {
            opts = uri;
            uri = null;
        }
        if (uri) {
            uri = parse(uri);
            opts.hostname = uri.host;
            opts.secure = uri.protocol === "https" || uri.protocol === "wss";
            opts.port = uri.port;
            if (uri.query)
                opts.query = uri.query;
        }
        else if (opts.host) {
            opts.hostname = parse(opts.host).host;
        }
        installTimerFunctions(this, opts);
        this.secure =
            null != opts.secure
                ? opts.secure
                : typeof location !== "undefined" && "https:" === location.protocol;
        if (opts.hostname && !opts.port) {
            // if no port is specified manually, use the protocol default
            opts.port = this.secure ? "443" : "80";
        }
        this.hostname =
            opts.hostname ||
                (typeof location !== "undefined" ? location.hostname : "localhost");
        this.port =
            opts.port ||
                (typeof location !== "undefined" && location.port
                    ? location.port
                    : this.secure
                        ? "443"
                        : "80");
        this.transports = opts.transports || ["polling", "websocket"];
        this.writeBuffer = [];
        this.prevBufferLen = 0;
        this.opts = Object.assign({
            path: "/engine.io",
            agent: false,
            withCredentials: false,
            upgrade: true,
            timestampParam: "t",
            rememberUpgrade: false,
            addTrailingSlash: true,
            rejectUnauthorized: true,
            perMessageDeflate: {
                threshold: 1024,
            },
            transportOptions: {},
            closeOnBeforeunload: true,
        }, opts);
        this.opts.path =
            this.opts.path.replace(/\/$/, "") +
                (this.opts.addTrailingSlash ? "/" : "");
        if (typeof this.opts.query === "string") {
            this.opts.query = parseqs_decode(this.opts.query);
        }
        // set on handshake
        this.id = null;
        this.upgrades = null;
        this.pingInterval = null;
        this.pingTimeout = null;
        // set on heartbeat
        this.pingTimeoutTimer = null;
        if (typeof addEventListener === "function") {
            if (this.opts.closeOnBeforeunload) {
                // Firefox closes the connection when the "beforeunload" event is emitted but not Chrome. This event listener
                // ensures every browser behaves the same (no "disconnect" event at the Socket.IO level when the page is
                // closed/reloaded)
                this.beforeunloadEventListener = () => {
                    if (this.transport) {
                        // silently close the transport
                        this.transport.removeAllListeners();
                        this.transport.close();
                    }
                };
                addEventListener("beforeunload", this.beforeunloadEventListener, false);
            }
            if (this.hostname !== "localhost") {
                this.offlineEventListener = () => {
                    this.onClose("transport close", {
                        description: "network connection lost",
                    });
                };
                addEventListener("offline", this.offlineEventListener, false);
            }
        }
        this.open();
    }
    /**
     * Creates transport of the given type.
     *
     * @param {String} name - transport name
     * @return {Transport}
     * @private
     */
    createTransport(name) {
        const query = Object.assign({}, this.opts.query);
        // append engine.io protocol identifier
        query.EIO = protocol;
        // transport name
        query.transport = name;
        // session id if we already have one
        if (this.id)
            query.sid = this.id;
        const opts = Object.assign({}, this.opts.transportOptions[name], this.opts, {
            query,
            socket: this,
            hostname: this.hostname,
            secure: this.secure,
            port: this.port,
        });
        return new transports[name](opts);
    }
    /**
     * Initializes transport to use and starts probe.
     *
     * @private
     */
    open() {
        let transport;
        if (this.opts.rememberUpgrade &&
            Socket.priorWebsocketSuccess &&
            this.transports.indexOf("websocket") !== -1) {
            transport = "websocket";
        }
        else if (0 === this.transports.length) {
            // Emit error on next tick so it can be listened to
            this.setTimeoutFn(() => {
                this.emitReserved("error", "No transports available");
            }, 0);
            return;
        }
        else {
            transport = this.transports[0];
        }
        this.readyState = "opening";
        // Retry with the next transport if the transport is disabled (jsonp: false)
        try {
            transport = this.createTransport(transport);
        }
        catch (e) {
            this.transports.shift();
            this.open();
            return;
        }
        transport.open();
        this.setTransport(transport);
    }
    /**
     * Sets the current transport. Disables the existing one (if any).
     *
     * @private
     */
    setTransport(transport) {
        if (this.transport) {
            this.transport.removeAllListeners();
        }
        // set up transport
        this.transport = transport;
        // set up transport listeners
        transport
            .on("drain", this.onDrain.bind(this))
            .on("packet", this.onPacket.bind(this))
            .on("error", this.onError.bind(this))
            .on("close", (reason) => this.onClose("transport close", reason));
    }
    /**
     * Probes a transport.
     *
     * @param {String} name - transport name
     * @private
     */
    probe(name) {
        let transport = this.createTransport(name);
        let failed = false;
        Socket.priorWebsocketSuccess = false;
        const onTransportOpen = () => {
            if (failed)
                return;
            transport.send([{ type: "ping", data: "probe" }]);
            transport.once("packet", (msg) => {
                if (failed)
                    return;
                if ("pong" === msg.type && "probe" === msg.data) {
                    this.upgrading = true;
                    this.emitReserved("upgrading", transport);
                    if (!transport)
                        return;
                    Socket.priorWebsocketSuccess = "websocket" === transport.name;
                    this.transport.pause(() => {
                        if (failed)
                            return;
                        if ("closed" === this.readyState)
                            return;
                        cleanup();
                        this.setTransport(transport);
                        transport.send([{ type: "upgrade" }]);
                        this.emitReserved("upgrade", transport);
                        transport = null;
                        this.upgrading = false;
                        this.flush();
                    });
                }
                else {
                    const err = new Error("probe error");
                    // @ts-ignore
                    err.transport = transport.name;
                    this.emitReserved("upgradeError", err);
                }
            });
        };
        function freezeTransport() {
            if (failed)
                return;
            // Any callback called by transport should be ignored since now
            failed = true;
            cleanup();
            transport.close();
            transport = null;
        }
        // Handle any error that happens while probing
        const onerror = (err) => {
            const error = new Error("probe error: " + err);
            // @ts-ignore
            error.transport = transport.name;
            freezeTransport();
            this.emitReserved("upgradeError", error);
        };
        function onTransportClose() {
            onerror("transport closed");
        }
        // When the socket is closed while we're probing
        function onclose() {
            onerror("socket closed");
        }
        // When the socket is upgraded while we're probing
        function onupgrade(to) {
            if (transport && to.name !== transport.name) {
                freezeTransport();
            }
        }
        // Remove all listeners on the transport and on self
        const cleanup = () => {
            transport.removeListener("open", onTransportOpen);
            transport.removeListener("error", onerror);
            transport.removeListener("close", onTransportClose);
            this.off("close", onclose);
            this.off("upgrading", onupgrade);
        };
        transport.once("open", onTransportOpen);
        transport.once("error", onerror);
        transport.once("close", onTransportClose);
        this.once("close", onclose);
        this.once("upgrading", onupgrade);
        transport.open();
    }
    /**
     * Called when connection is deemed open.
     *
     * @private
     */
    onOpen() {
        this.readyState = "open";
        Socket.priorWebsocketSuccess = "websocket" === this.transport.name;
        this.emitReserved("open");
        this.flush();
        // we check for `readyState` in case an `open`
        // listener already closed the socket
        if ("open" === this.readyState && this.opts.upgrade) {
            let i = 0;
            const l = this.upgrades.length;
            for (; i < l; i++) {
                this.probe(this.upgrades[i]);
            }
        }
    }
    /**
     * Handles a packet.
     *
     * @private
     */
    onPacket(packet) {
        if ("opening" === this.readyState ||
            "open" === this.readyState ||
            "closing" === this.readyState) {
            this.emitReserved("packet", packet);
            // Socket is live - any packet counts
            this.emitReserved("heartbeat");
            switch (packet.type) {
                case "open":
                    this.onHandshake(JSON.parse(packet.data));
                    break;
                case "ping":
                    this.resetPingTimeout();
                    this.sendPacket("pong");
                    this.emitReserved("ping");
                    this.emitReserved("pong");
                    break;
                case "error":
                    const err = new Error("server error");
                    // @ts-ignore
                    err.code = packet.data;
                    this.onError(err);
                    break;
                case "message":
                    this.emitReserved("data", packet.data);
                    this.emitReserved("message", packet.data);
                    break;
            }
        }
        else {
        }
    }
    /**
     * Called upon handshake completion.
     *
     * @param {Object} data - handshake obj
     * @private
     */
    onHandshake(data) {
        this.emitReserved("handshake", data);
        this.id = data.sid;
        this.transport.query.sid = data.sid;
        this.upgrades = this.filterUpgrades(data.upgrades);
        this.pingInterval = data.pingInterval;
        this.pingTimeout = data.pingTimeout;
        this.maxPayload = data.maxPayload;
        this.onOpen();
        // In case open handler closes socket
        if ("closed" === this.readyState)
            return;
        this.resetPingTimeout();
    }
    /**
     * Sets and resets ping timeout timer based on server pings.
     *
     * @private
     */
    resetPingTimeout() {
        this.clearTimeoutFn(this.pingTimeoutTimer);
        this.pingTimeoutTimer = this.setTimeoutFn(() => {
            this.onClose("ping timeout");
        }, this.pingInterval + this.pingTimeout);
        if (this.opts.autoUnref) {
            this.pingTimeoutTimer.unref();
        }
    }
    /**
     * Called on `drain` event
     *
     * @private
     */
    onDrain() {
        this.writeBuffer.splice(0, this.prevBufferLen);
        // setting prevBufferLen = 0 is very important
        // for example, when upgrading, upgrade packet is sent over,
        // and a nonzero prevBufferLen could cause problems on `drain`
        this.prevBufferLen = 0;
        if (0 === this.writeBuffer.length) {
            this.emitReserved("drain");
        }
        else {
            this.flush();
        }
    }
    /**
     * Flush write buffers.
     *
     * @private
     */
    flush() {
        if ("closed" !== this.readyState &&
            this.transport.writable &&
            !this.upgrading &&
            this.writeBuffer.length) {
            const packets = this.getWritablePackets();
            this.transport.send(packets);
            // keep track of current length of writeBuffer
            // splice writeBuffer and callbackBuffer on `drain`
            this.prevBufferLen = packets.length;
            this.emitReserved("flush");
        }
    }
    /**
     * Ensure the encoded size of the writeBuffer is below the maxPayload value sent by the server (only for HTTP
     * long-polling)
     *
     * @private
     */
    getWritablePackets() {
        const shouldCheckPayloadSize = this.maxPayload &&
            this.transport.name === "polling" &&
            this.writeBuffer.length > 1;
        if (!shouldCheckPayloadSize) {
            return this.writeBuffer;
        }
        let payloadSize = 1; // first packet type
        for (let i = 0; i < this.writeBuffer.length; i++) {
            const data = this.writeBuffer[i].data;
            if (data) {
                payloadSize += byteLength(data);
            }
            if (i > 0 && payloadSize > this.maxPayload) {
                return this.writeBuffer.slice(0, i);
            }
            payloadSize += 2; // separator + packet type
        }
        return this.writeBuffer;
    }
    /**
     * Sends a message.
     *
     * @param {String} msg - message.
     * @param {Object} options.
     * @param {Function} callback function.
     * @return {Socket} for chaining.
     */
    write(msg, options, fn) {
        this.sendPacket("message", msg, options, fn);
        return this;
    }
    send(msg, options, fn) {
        this.sendPacket("message", msg, options, fn);
        return this;
    }
    /**
     * Sends a packet.
     *
     * @param {String} type: packet type.
     * @param {String} data.
     * @param {Object} options.
     * @param {Function} fn - callback function.
     * @private
     */
    sendPacket(type, data, options, fn) {
        if ("function" === typeof data) {
            fn = data;
            data = undefined;
        }
        if ("function" === typeof options) {
            fn = options;
            options = null;
        }
        if ("closing" === this.readyState || "closed" === this.readyState) {
            return;
        }
        options = options || {};
        options.compress = false !== options.compress;
        const packet = {
            type: type,
            data: data,
            options: options,
        };
        this.emitReserved("packetCreate", packet);
        this.writeBuffer.push(packet);
        if (fn)
            this.once("flush", fn);
        this.flush();
    }
    /**
     * Closes the connection.
     */
    close() {
        const close = () => {
            this.onClose("forced close");
            this.transport.close();
        };
        const cleanupAndClose = () => {
            this.off("upgrade", cleanupAndClose);
            this.off("upgradeError", cleanupAndClose);
            close();
        };
        const waitForUpgrade = () => {
            // wait for upgrade to finish since we can't send packets while pausing a transport
            this.once("upgrade", cleanupAndClose);
            this.once("upgradeError", cleanupAndClose);
        };
        if ("opening" === this.readyState || "open" === this.readyState) {
            this.readyState = "closing";
            if (this.writeBuffer.length) {
                this.once("drain", () => {
                    if (this.upgrading) {
                        waitForUpgrade();
                    }
                    else {
                        close();
                    }
                });
            }
            else if (this.upgrading) {
                waitForUpgrade();
            }
            else {
                close();
            }
        }
        return this;
    }
    /**
     * Called upon transport error
     *
     * @private
     */
    onError(err) {
        Socket.priorWebsocketSuccess = false;
        this.emitReserved("error", err);
        this.onClose("transport error", err);
    }
    /**
     * Called upon transport close.
     *
     * @private
     */
    onClose(reason, description) {
        if ("opening" === this.readyState ||
            "open" === this.readyState ||
            "closing" === this.readyState) {
            // clear timers
            this.clearTimeoutFn(this.pingTimeoutTimer);
            // stop event from firing again for transport
            this.transport.removeAllListeners("close");
            // ensure transport won't stay open
            this.transport.close();
            // ignore further transport communication
            this.transport.removeAllListeners();
            if (typeof removeEventListener === "function") {
                removeEventListener("beforeunload", this.beforeunloadEventListener, false);
                removeEventListener("offline", this.offlineEventListener, false);
            }
            // set ready state
            this.readyState = "closed";
            // clear session id
            this.id = null;
            // emit close event
            this.emitReserved("close", reason, description);
            // clean buffers after, so users can still
            // grab the buffers on `close` event
            this.writeBuffer = [];
            this.prevBufferLen = 0;
        }
    }
    /**
     * Filters upgrades, returning only those matching client transports.
     *
     * @param {Array} upgrades - server upgrades
     * @private
     */
    filterUpgrades(upgrades) {
        const filteredUpgrades = [];
        let i = 0;
        const j = upgrades.length;
        for (; i < j; i++) {
            if (~this.transports.indexOf(upgrades[i]))
                filteredUpgrades.push(upgrades[i]);
        }
        return filteredUpgrades;
    }
}
Socket.protocol = protocol;

;// CONCATENATED MODULE: ./node_modules/engine.io-client/build/esm/index.js


const esm_protocol = Socket.protocol;






;// CONCATENATED MODULE: ./node_modules/socket.io-client/build/esm/url.js

/**
 * URL parser.
 *
 * @param uri - url
 * @param path - the request path of the connection
 * @param loc - An object meant to mimic window.location.
 *        Defaults to window.location.
 * @public
 */
function url(uri, path = "", loc) {
    let obj = uri;
    // default to window.location
    loc = loc || (typeof location !== "undefined" && location);
    if (null == uri)
        uri = loc.protocol + "//" + loc.host;
    // relative path support
    if (typeof uri === "string") {
        if ("/" === uri.charAt(0)) {
            if ("/" === uri.charAt(1)) {
                uri = loc.protocol + uri;
            }
            else {
                uri = loc.host + uri;
            }
        }
        if (!/^(https?|wss?):\/\//.test(uri)) {
            if ("undefined" !== typeof loc) {
                uri = loc.protocol + "//" + uri;
            }
            else {
                uri = "https://" + uri;
            }
        }
        // parse
        obj = parse(uri);
    }
    // make sure we treat `localhost:80` and `localhost` equally
    if (!obj.port) {
        if (/^(http|ws)$/.test(obj.protocol)) {
            obj.port = "80";
        }
        else if (/^(http|ws)s$/.test(obj.protocol)) {
            obj.port = "443";
        }
    }
    obj.path = obj.path || "/";
    const ipv6 = obj.host.indexOf(":") !== -1;
    const host = ipv6 ? "[" + obj.host + "]" : obj.host;
    // define unique id
    obj.id = obj.protocol + "://" + host + ":" + obj.port + path;
    // define href
    obj.href =
        obj.protocol +
            "://" +
            host +
            (loc && loc.port === obj.port ? "" : ":" + obj.port);
    return obj;
}

;// CONCATENATED MODULE: ./node_modules/socket.io-parser/build/esm/is-binary.js
const is_binary_withNativeArrayBuffer = typeof ArrayBuffer === "function";
const is_binary_isView = (obj) => {
    return typeof ArrayBuffer.isView === "function"
        ? ArrayBuffer.isView(obj)
        : obj.buffer instanceof ArrayBuffer;
};
const is_binary_toString = Object.prototype.toString;
const is_binary_withNativeBlob = typeof Blob === "function" ||
    (typeof Blob !== "undefined" &&
        is_binary_toString.call(Blob) === "[object BlobConstructor]");
const withNativeFile = typeof File === "function" ||
    (typeof File !== "undefined" &&
        is_binary_toString.call(File) === "[object FileConstructor]");
/**
 * Returns true if obj is a Buffer, an ArrayBuffer, a Blob or a File.
 *
 * @private
 */
function isBinary(obj) {
    return ((is_binary_withNativeArrayBuffer && (obj instanceof ArrayBuffer || is_binary_isView(obj))) ||
        (is_binary_withNativeBlob && obj instanceof Blob) ||
        (withNativeFile && obj instanceof File));
}
function hasBinary(obj, toJSON) {
    if (!obj || typeof obj !== "object") {
        return false;
    }
    if (Array.isArray(obj)) {
        for (let i = 0, l = obj.length; i < l; i++) {
            if (hasBinary(obj[i])) {
                return true;
            }
        }
        return false;
    }
    if (isBinary(obj)) {
        return true;
    }
    if (obj.toJSON &&
        typeof obj.toJSON === "function" &&
        arguments.length === 1) {
        return hasBinary(obj.toJSON(), true);
    }
    for (const key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key) && hasBinary(obj[key])) {
            return true;
        }
    }
    return false;
}

;// CONCATENATED MODULE: ./node_modules/socket.io-parser/build/esm/binary.js

/**
 * Replaces every Buffer | ArrayBuffer | Blob | File in packet with a numbered placeholder.
 *
 * @param {Object} packet - socket.io event packet
 * @return {Object} with deconstructed packet and list of buffers
 * @public
 */
function deconstructPacket(packet) {
    const buffers = [];
    const packetData = packet.data;
    const pack = packet;
    pack.data = _deconstructPacket(packetData, buffers);
    pack.attachments = buffers.length; // number of binary 'attachments'
    return { packet: pack, buffers: buffers };
}
function _deconstructPacket(data, buffers) {
    if (!data)
        return data;
    if (isBinary(data)) {
        const placeholder = { _placeholder: true, num: buffers.length };
        buffers.push(data);
        return placeholder;
    }
    else if (Array.isArray(data)) {
        const newData = new Array(data.length);
        for (let i = 0; i < data.length; i++) {
            newData[i] = _deconstructPacket(data[i], buffers);
        }
        return newData;
    }
    else if (typeof data === "object" && !(data instanceof Date)) {
        const newData = {};
        for (const key in data) {
            if (Object.prototype.hasOwnProperty.call(data, key)) {
                newData[key] = _deconstructPacket(data[key], buffers);
            }
        }
        return newData;
    }
    return data;
}
/**
 * Reconstructs a binary packet from its placeholder packet and buffers
 *
 * @param {Object} packet - event packet with placeholders
 * @param {Array} buffers - binary buffers to put in placeholder positions
 * @return {Object} reconstructed packet
 * @public
 */
function reconstructPacket(packet, buffers) {
    packet.data = _reconstructPacket(packet.data, buffers);
    delete packet.attachments; // no longer useful
    return packet;
}
function _reconstructPacket(data, buffers) {
    if (!data)
        return data;
    if (data && data._placeholder === true) {
        const isIndexValid = typeof data.num === "number" &&
            data.num >= 0 &&
            data.num < buffers.length;
        if (isIndexValid) {
            return buffers[data.num]; // appropriate buffer (should be natural order anyway)
        }
        else {
            throw new Error("illegal attachments");
        }
    }
    else if (Array.isArray(data)) {
        for (let i = 0; i < data.length; i++) {
            data[i] = _reconstructPacket(data[i], buffers);
        }
    }
    else if (typeof data === "object") {
        for (const key in data) {
            if (Object.prototype.hasOwnProperty.call(data, key)) {
                data[key] = _reconstructPacket(data[key], buffers);
            }
        }
    }
    return data;
}

;// CONCATENATED MODULE: ./node_modules/socket.io-parser/build/esm/index.js



/**
 * These strings must not be used as event names, as they have a special meaning.
 */
const RESERVED_EVENTS = [
    "connect",
    "connect_error",
    "disconnect",
    "disconnecting",
    "newListener",
    "removeListener", // used by the Node.js EventEmitter
];
/**
 * Protocol version.
 *
 * @public
 */
const build_esm_protocol = 5;
var PacketType;
(function (PacketType) {
    PacketType[PacketType["CONNECT"] = 0] = "CONNECT";
    PacketType[PacketType["DISCONNECT"] = 1] = "DISCONNECT";
    PacketType[PacketType["EVENT"] = 2] = "EVENT";
    PacketType[PacketType["ACK"] = 3] = "ACK";
    PacketType[PacketType["CONNECT_ERROR"] = 4] = "CONNECT_ERROR";
    PacketType[PacketType["BINARY_EVENT"] = 5] = "BINARY_EVENT";
    PacketType[PacketType["BINARY_ACK"] = 6] = "BINARY_ACK";
})(PacketType || (PacketType = {}));
/**
 * A socket.io Encoder instance
 */
class Encoder {
    /**
     * Encoder constructor
     *
     * @param {function} replacer - custom replacer to pass down to JSON.parse
     */
    constructor(replacer) {
        this.replacer = replacer;
    }
    /**
     * Encode a packet as a single string if non-binary, or as a
     * buffer sequence, depending on packet type.
     *
     * @param {Object} obj - packet object
     */
    encode(obj) {
        if (obj.type === PacketType.EVENT || obj.type === PacketType.ACK) {
            if (hasBinary(obj)) {
                return this.encodeAsBinary({
                    type: obj.type === PacketType.EVENT
                        ? PacketType.BINARY_EVENT
                        : PacketType.BINARY_ACK,
                    nsp: obj.nsp,
                    data: obj.data,
                    id: obj.id,
                });
            }
        }
        return [this.encodeAsString(obj)];
    }
    /**
     * Encode packet as string.
     */
    encodeAsString(obj) {
        // first is type
        let str = "" + obj.type;
        // attachments if we have them
        if (obj.type === PacketType.BINARY_EVENT ||
            obj.type === PacketType.BINARY_ACK) {
            str += obj.attachments + "-";
        }
        // if we have a namespace other than `/`
        // we append it followed by a comma `,`
        if (obj.nsp && "/" !== obj.nsp) {
            str += obj.nsp + ",";
        }
        // immediately followed by the id
        if (null != obj.id) {
            str += obj.id;
        }
        // json data
        if (null != obj.data) {
            str += JSON.stringify(obj.data, this.replacer);
        }
        return str;
    }
    /**
     * Encode packet as 'buffer sequence' by removing blobs, and
     * deconstructing packet into object with placeholders and
     * a list of buffers.
     */
    encodeAsBinary(obj) {
        const deconstruction = deconstructPacket(obj);
        const pack = this.encodeAsString(deconstruction.packet);
        const buffers = deconstruction.buffers;
        buffers.unshift(pack); // add packet info to beginning of data list
        return buffers; // write all the buffers
    }
}
// see https://stackoverflow.com/questions/8511281/check-if-a-value-is-an-object-in-javascript
function isObject(value) {
    return Object.prototype.toString.call(value) === "[object Object]";
}
/**
 * A socket.io Decoder instance
 *
 * @return {Object} decoder
 */
class Decoder extends Emitter {
    /**
     * Decoder constructor
     *
     * @param {function} reviver - custom reviver to pass down to JSON.stringify
     */
    constructor(reviver) {
        super();
        this.reviver = reviver;
    }
    /**
     * Decodes an encoded packet string into packet JSON.
     *
     * @param {String} obj - encoded packet
     */
    add(obj) {
        let packet;
        if (typeof obj === "string") {
            if (this.reconstructor) {
                throw new Error("got plaintext data when reconstructing a packet");
            }
            packet = this.decodeString(obj);
            const isBinaryEvent = packet.type === PacketType.BINARY_EVENT;
            if (isBinaryEvent || packet.type === PacketType.BINARY_ACK) {
                packet.type = isBinaryEvent ? PacketType.EVENT : PacketType.ACK;
                // binary packet's json
                this.reconstructor = new BinaryReconstructor(packet);
                // no attachments, labeled binary but no binary data to follow
                if (packet.attachments === 0) {
                    super.emitReserved("decoded", packet);
                }
            }
            else {
                // non-binary full packet
                super.emitReserved("decoded", packet);
            }
        }
        else if (isBinary(obj) || obj.base64) {
            // raw binary data
            if (!this.reconstructor) {
                throw new Error("got binary data when not reconstructing a packet");
            }
            else {
                packet = this.reconstructor.takeBinaryData(obj);
                if (packet) {
                    // received final buffer
                    this.reconstructor = null;
                    super.emitReserved("decoded", packet);
                }
            }
        }
        else {
            throw new Error("Unknown type: " + obj);
        }
    }
    /**
     * Decode a packet String (JSON data)
     *
     * @param {String} str
     * @return {Object} packet
     */
    decodeString(str) {
        let i = 0;
        // look up type
        const p = {
            type: Number(str.charAt(0)),
        };
        if (PacketType[p.type] === undefined) {
            throw new Error("unknown packet type " + p.type);
        }
        // look up attachments if type binary
        if (p.type === PacketType.BINARY_EVENT ||
            p.type === PacketType.BINARY_ACK) {
            const start = i + 1;
            while (str.charAt(++i) !== "-" && i != str.length) { }
            const buf = str.substring(start, i);
            if (buf != Number(buf) || str.charAt(i) !== "-") {
                throw new Error("Illegal attachments");
            }
            p.attachments = Number(buf);
        }
        // look up namespace (if any)
        if ("/" === str.charAt(i + 1)) {
            const start = i + 1;
            while (++i) {
                const c = str.charAt(i);
                if ("," === c)
                    break;
                if (i === str.length)
                    break;
            }
            p.nsp = str.substring(start, i);
        }
        else {
            p.nsp = "/";
        }
        // look up id
        const next = str.charAt(i + 1);
        if ("" !== next && Number(next) == next) {
            const start = i + 1;
            while (++i) {
                const c = str.charAt(i);
                if (null == c || Number(c) != c) {
                    --i;
                    break;
                }
                if (i === str.length)
                    break;
            }
            p.id = Number(str.substring(start, i + 1));
        }
        // look up json data
        if (str.charAt(++i)) {
            const payload = this.tryParse(str.substr(i));
            if (Decoder.isPayloadValid(p.type, payload)) {
                p.data = payload;
            }
            else {
                throw new Error("invalid payload");
            }
        }
        return p;
    }
    tryParse(str) {
        try {
            return JSON.parse(str, this.reviver);
        }
        catch (e) {
            return false;
        }
    }
    static isPayloadValid(type, payload) {
        switch (type) {
            case PacketType.CONNECT:
                return isObject(payload);
            case PacketType.DISCONNECT:
                return payload === undefined;
            case PacketType.CONNECT_ERROR:
                return typeof payload === "string" || isObject(payload);
            case PacketType.EVENT:
            case PacketType.BINARY_EVENT:
                return (Array.isArray(payload) &&
                    (typeof payload[0] === "number" ||
                        (typeof payload[0] === "string" &&
                            RESERVED_EVENTS.indexOf(payload[0]) === -1)));
            case PacketType.ACK:
            case PacketType.BINARY_ACK:
                return Array.isArray(payload);
        }
    }
    /**
     * Deallocates a parser's resources
     */
    destroy() {
        if (this.reconstructor) {
            this.reconstructor.finishedReconstruction();
            this.reconstructor = null;
        }
    }
}
/**
 * A manager of a binary event's 'buffer sequence'. Should
 * be constructed whenever a packet of type BINARY_EVENT is
 * decoded.
 *
 * @param {Object} packet
 * @return {BinaryReconstructor} initialized reconstructor
 */
class BinaryReconstructor {
    constructor(packet) {
        this.packet = packet;
        this.buffers = [];
        this.reconPack = packet;
    }
    /**
     * Method to be called when binary data received from connection
     * after a BINARY_EVENT packet.
     *
     * @param {Buffer | ArrayBuffer} binData - the raw binary data received
     * @return {null | Object} returns null if more binary data is expected or
     *   a reconstructed packet object if all buffers have been received.
     */
    takeBinaryData(binData) {
        this.buffers.push(binData);
        if (this.buffers.length === this.reconPack.attachments) {
            // done with buffer list
            const packet = reconstructPacket(this.reconPack, this.buffers);
            this.finishedReconstruction();
            return packet;
        }
        return null;
    }
    /**
     * Cleans up binary packet reconstruction variables.
     */
    finishedReconstruction() {
        this.reconPack = null;
        this.buffers = [];
    }
}

;// CONCATENATED MODULE: ./node_modules/socket.io-client/build/esm/on.js
function on(obj, ev, fn) {
    obj.on(ev, fn);
    return function subDestroy() {
        obj.off(ev, fn);
    };
}

;// CONCATENATED MODULE: ./node_modules/socket.io-client/build/esm/socket.js



/**
 * Internal events.
 * These events can't be emitted by the user.
 */
const socket_RESERVED_EVENTS = Object.freeze({
    connect: 1,
    connect_error: 1,
    disconnect: 1,
    disconnecting: 1,
    // EventEmitter reserved events: https://nodejs.org/api/events.html#events_event_newlistener
    newListener: 1,
    removeListener: 1,
});
/**
 * A Socket is the fundamental class for interacting with the server.
 *
 * A Socket belongs to a certain Namespace (by default /) and uses an underlying {@link Manager} to communicate.
 *
 * @example
 * const socket = io();
 *
 * socket.on("connect", () => {
 *   console.log("connected");
 * });
 *
 * // send an event to the server
 * socket.emit("foo", "bar");
 *
 * socket.on("foobar", () => {
 *   // an event was received from the server
 * });
 *
 * // upon disconnection
 * socket.on("disconnect", (reason) => {
 *   console.log(`disconnected due to ${reason}`);
 * });
 */
class socket_Socket extends Emitter {
    /**
     * `Socket` constructor.
     */
    constructor(io, nsp, opts) {
        super();
        /**
         * Whether the socket is currently connected to the server.
         *
         * @example
         * const socket = io();
         *
         * socket.on("connect", () => {
         *   console.log(socket.connected); // true
         * });
         *
         * socket.on("disconnect", () => {
         *   console.log(socket.connected); // false
         * });
         */
        this.connected = false;
        /**
         * Whether the connection state was recovered after a temporary disconnection. In that case, any missed packets will
         * be transmitted by the server.
         */
        this.recovered = false;
        /**
         * Buffer for packets received before the CONNECT packet
         */
        this.receiveBuffer = [];
        /**
         * Buffer for packets that will be sent once the socket is connected
         */
        this.sendBuffer = [];
        /**
         * The queue of packets to be sent with retry in case of failure.
         *
         * Packets are sent one by one, each waiting for the server acknowledgement, in order to guarantee the delivery order.
         * @private
         */
        this._queue = [];
        /**
         * A sequence to generate the ID of the {@link QueuedPacket}.
         * @private
         */
        this._queueSeq = 0;
        this.ids = 0;
        this.acks = {};
        this.flags = {};
        this.io = io;
        this.nsp = nsp;
        if (opts && opts.auth) {
            this.auth = opts.auth;
        }
        this._opts = Object.assign({}, opts);
        if (this.io._autoConnect)
            this.open();
    }
    /**
     * Whether the socket is currently disconnected
     *
     * @example
     * const socket = io();
     *
     * socket.on("connect", () => {
     *   console.log(socket.disconnected); // false
     * });
     *
     * socket.on("disconnect", () => {
     *   console.log(socket.disconnected); // true
     * });
     */
    get disconnected() {
        return !this.connected;
    }
    /**
     * Subscribe to open, close and packet events
     *
     * @private
     */
    subEvents() {
        if (this.subs)
            return;
        const io = this.io;
        this.subs = [
            on(io, "open", this.onopen.bind(this)),
            on(io, "packet", this.onpacket.bind(this)),
            on(io, "error", this.onerror.bind(this)),
            on(io, "close", this.onclose.bind(this)),
        ];
    }
    /**
     * Whether the Socket will try to reconnect when its Manager connects or reconnects.
     *
     * @example
     * const socket = io();
     *
     * console.log(socket.active); // true
     *
     * socket.on("disconnect", (reason) => {
     *   if (reason === "io server disconnect") {
     *     // the disconnection was initiated by the server, you need to manually reconnect
     *     console.log(socket.active); // false
     *   }
     *   // else the socket will automatically try to reconnect
     *   console.log(socket.active); // true
     * });
     */
    get active() {
        return !!this.subs;
    }
    /**
     * "Opens" the socket.
     *
     * @example
     * const socket = io({
     *   autoConnect: false
     * });
     *
     * socket.connect();
     */
    connect() {
        if (this.connected)
            return this;
        this.subEvents();
        if (!this.io["_reconnecting"])
            this.io.open(); // ensure open
        if ("open" === this.io._readyState)
            this.onopen();
        return this;
    }
    /**
     * Alias for {@link connect()}.
     */
    open() {
        return this.connect();
    }
    /**
     * Sends a `message` event.
     *
     * This method mimics the WebSocket.send() method.
     *
     * @see https://developer.mozilla.org/en-US/docs/Web/API/WebSocket/send
     *
     * @example
     * socket.send("hello");
     *
     * // this is equivalent to
     * socket.emit("message", "hello");
     *
     * @return self
     */
    send(...args) {
        args.unshift("message");
        this.emit.apply(this, args);
        return this;
    }
    /**
     * Override `emit`.
     * If the event is in `events`, it's emitted normally.
     *
     * @example
     * socket.emit("hello", "world");
     *
     * // all serializable datastructures are supported (no need to call JSON.stringify)
     * socket.emit("hello", 1, "2", { 3: ["4"], 5: Uint8Array.from([6]) });
     *
     * // with an acknowledgement from the server
     * socket.emit("hello", "world", (val) => {
     *   // ...
     * });
     *
     * @return self
     */
    emit(ev, ...args) {
        if (socket_RESERVED_EVENTS.hasOwnProperty(ev)) {
            throw new Error('"' + ev.toString() + '" is a reserved event name');
        }
        args.unshift(ev);
        if (this._opts.retries && !this.flags.fromQueue && !this.flags.volatile) {
            this._addToQueue(args);
            return this;
        }
        const packet = {
            type: PacketType.EVENT,
            data: args,
        };
        packet.options = {};
        packet.options.compress = this.flags.compress !== false;
        // event ack callback
        if ("function" === typeof args[args.length - 1]) {
            const id = this.ids++;
            const ack = args.pop();
            this._registerAckCallback(id, ack);
            packet.id = id;
        }
        const isTransportWritable = this.io.engine &&
            this.io.engine.transport &&
            this.io.engine.transport.writable;
        const discardPacket = this.flags.volatile && (!isTransportWritable || !this.connected);
        if (discardPacket) {
        }
        else if (this.connected) {
            this.notifyOutgoingListeners(packet);
            this.packet(packet);
        }
        else {
            this.sendBuffer.push(packet);
        }
        this.flags = {};
        return this;
    }
    /**
     * @private
     */
    _registerAckCallback(id, ack) {
        var _a;
        const timeout = (_a = this.flags.timeout) !== null && _a !== void 0 ? _a : this._opts.ackTimeout;
        if (timeout === undefined) {
            this.acks[id] = ack;
            return;
        }
        // @ts-ignore
        const timer = this.io.setTimeoutFn(() => {
            delete this.acks[id];
            for (let i = 0; i < this.sendBuffer.length; i++) {
                if (this.sendBuffer[i].id === id) {
                    this.sendBuffer.splice(i, 1);
                }
            }
            ack.call(this, new Error("operation has timed out"));
        }, timeout);
        this.acks[id] = (...args) => {
            // @ts-ignore
            this.io.clearTimeoutFn(timer);
            ack.apply(this, [null, ...args]);
        };
    }
    /**
     * Emits an event and waits for an acknowledgement
     *
     * @example
     * // without timeout
     * const response = await socket.emitWithAck("hello", "world");
     *
     * // with a specific timeout
     * try {
     *   const response = await socket.timeout(1000).emitWithAck("hello", "world");
     * } catch (err) {
     *   // the server did not acknowledge the event in the given delay
     * }
     *
     * @return a Promise that will be fulfilled when the server acknowledges the event
     */
    emitWithAck(ev, ...args) {
        // the timeout flag is optional
        const withErr = this.flags.timeout !== undefined || this._opts.ackTimeout !== undefined;
        return new Promise((resolve, reject) => {
            args.push((arg1, arg2) => {
                if (withErr) {
                    return arg1 ? reject(arg1) : resolve(arg2);
                }
                else {
                    return resolve(arg1);
                }
            });
            this.emit(ev, ...args);
        });
    }
    /**
     * Add the packet to the queue.
     * @param args
     * @private
     */
    _addToQueue(args) {
        let ack;
        if (typeof args[args.length - 1] === "function") {
            ack = args.pop();
        }
        const packet = {
            id: this._queueSeq++,
            tryCount: 0,
            pending: false,
            args,
            flags: Object.assign({ fromQueue: true }, this.flags),
        };
        args.push((err, ...responseArgs) => {
            if (packet !== this._queue[0]) {
                // the packet has already been acknowledged
                return;
            }
            const hasError = err !== null;
            if (hasError) {
                if (packet.tryCount > this._opts.retries) {
                    this._queue.shift();
                    if (ack) {
                        ack(err);
                    }
                }
            }
            else {
                this._queue.shift();
                if (ack) {
                    ack(null, ...responseArgs);
                }
            }
            packet.pending = false;
            return this._drainQueue();
        });
        this._queue.push(packet);
        this._drainQueue();
    }
    /**
     * Send the first packet of the queue, and wait for an acknowledgement from the server.
     * @param force - whether to resend a packet that has not been acknowledged yet
     *
     * @private
     */
    _drainQueue(force = false) {
        if (!this.connected || this._queue.length === 0) {
            return;
        }
        const packet = this._queue[0];
        if (packet.pending && !force) {
            return;
        }
        packet.pending = true;
        packet.tryCount++;
        this.flags = packet.flags;
        this.emit.apply(this, packet.args);
    }
    /**
     * Sends a packet.
     *
     * @param packet
     * @private
     */
    packet(packet) {
        packet.nsp = this.nsp;
        this.io._packet(packet);
    }
    /**
     * Called upon engine `open`.
     *
     * @private
     */
    onopen() {
        if (typeof this.auth == "function") {
            this.auth((data) => {
                this._sendConnectPacket(data);
            });
        }
        else {
            this._sendConnectPacket(this.auth);
        }
    }
    /**
     * Sends a CONNECT packet to initiate the Socket.IO session.
     *
     * @param data
     * @private
     */
    _sendConnectPacket(data) {
        this.packet({
            type: PacketType.CONNECT,
            data: this._pid
                ? Object.assign({ pid: this._pid, offset: this._lastOffset }, data)
                : data,
        });
    }
    /**
     * Called upon engine or manager `error`.
     *
     * @param err
     * @private
     */
    onerror(err) {
        if (!this.connected) {
            this.emitReserved("connect_error", err);
        }
    }
    /**
     * Called upon engine `close`.
     *
     * @param reason
     * @param description
     * @private
     */
    onclose(reason, description) {
        this.connected = false;
        delete this.id;
        this.emitReserved("disconnect", reason, description);
    }
    /**
     * Called with socket packet.
     *
     * @param packet
     * @private
     */
    onpacket(packet) {
        const sameNamespace = packet.nsp === this.nsp;
        if (!sameNamespace)
            return;
        switch (packet.type) {
            case PacketType.CONNECT:
                if (packet.data && packet.data.sid) {
                    this.onconnect(packet.data.sid, packet.data.pid);
                }
                else {
                    this.emitReserved("connect_error", new Error("It seems you are trying to reach a Socket.IO server in v2.x with a v3.x client, but they are not compatible (more information here: https://socket.io/docs/v3/migrating-from-2-x-to-3-0/)"));
                }
                break;
            case PacketType.EVENT:
            case PacketType.BINARY_EVENT:
                this.onevent(packet);
                break;
            case PacketType.ACK:
            case PacketType.BINARY_ACK:
                this.onack(packet);
                break;
            case PacketType.DISCONNECT:
                this.ondisconnect();
                break;
            case PacketType.CONNECT_ERROR:
                this.destroy();
                const err = new Error(packet.data.message);
                // @ts-ignore
                err.data = packet.data.data;
                this.emitReserved("connect_error", err);
                break;
        }
    }
    /**
     * Called upon a server event.
     *
     * @param packet
     * @private
     */
    onevent(packet) {
        const args = packet.data || [];
        if (null != packet.id) {
            args.push(this.ack(packet.id));
        }
        if (this.connected) {
            this.emitEvent(args);
        }
        else {
            this.receiveBuffer.push(Object.freeze(args));
        }
    }
    emitEvent(args) {
        if (this._anyListeners && this._anyListeners.length) {
            const listeners = this._anyListeners.slice();
            for (const listener of listeners) {
                listener.apply(this, args);
            }
        }
        super.emit.apply(this, args);
        if (this._pid && args.length && typeof args[args.length - 1] === "string") {
            this._lastOffset = args[args.length - 1];
        }
    }
    /**
     * Produces an ack callback to emit with an event.
     *
     * @private
     */
    ack(id) {
        const self = this;
        let sent = false;
        return function (...args) {
            // prevent double callbacks
            if (sent)
                return;
            sent = true;
            self.packet({
                type: PacketType.ACK,
                id: id,
                data: args,
            });
        };
    }
    /**
     * Called upon a server acknowlegement.
     *
     * @param packet
     * @private
     */
    onack(packet) {
        const ack = this.acks[packet.id];
        if ("function" === typeof ack) {
            ack.apply(this, packet.data);
            delete this.acks[packet.id];
        }
        else {
        }
    }
    /**
     * Called upon server connect.
     *
     * @private
     */
    onconnect(id, pid) {
        this.id = id;
        this.recovered = pid && this._pid === pid;
        this._pid = pid; // defined only if connection state recovery is enabled
        this.connected = true;
        this.emitBuffered();
        this.emitReserved("connect");
        this._drainQueue(true);
    }
    /**
     * Emit buffered events (received and emitted).
     *
     * @private
     */
    emitBuffered() {
        this.receiveBuffer.forEach((args) => this.emitEvent(args));
        this.receiveBuffer = [];
        this.sendBuffer.forEach((packet) => {
            this.notifyOutgoingListeners(packet);
            this.packet(packet);
        });
        this.sendBuffer = [];
    }
    /**
     * Called upon server disconnect.
     *
     * @private
     */
    ondisconnect() {
        this.destroy();
        this.onclose("io server disconnect");
    }
    /**
     * Called upon forced client/server side disconnections,
     * this method ensures the manager stops tracking us and
     * that reconnections don't get triggered for this.
     *
     * @private
     */
    destroy() {
        if (this.subs) {
            // clean subscriptions to avoid reconnections
            this.subs.forEach((subDestroy) => subDestroy());
            this.subs = undefined;
        }
        this.io["_destroy"](this);
    }
    /**
     * Disconnects the socket manually. In that case, the socket will not try to reconnect.
     *
     * If this is the last active Socket instance of the {@link Manager}, the low-level connection will be closed.
     *
     * @example
     * const socket = io();
     *
     * socket.on("disconnect", (reason) => {
     *   // console.log(reason); prints "io client disconnect"
     * });
     *
     * socket.disconnect();
     *
     * @return self
     */
    disconnect() {
        if (this.connected) {
            this.packet({ type: PacketType.DISCONNECT });
        }
        // remove socket from pool
        this.destroy();
        if (this.connected) {
            // fire events
            this.onclose("io client disconnect");
        }
        return this;
    }
    /**
     * Alias for {@link disconnect()}.
     *
     * @return self
     */
    close() {
        return this.disconnect();
    }
    /**
     * Sets the compress flag.
     *
     * @example
     * socket.compress(false).emit("hello");
     *
     * @param compress - if `true`, compresses the sending data
     * @return self
     */
    compress(compress) {
        this.flags.compress = compress;
        return this;
    }
    /**
     * Sets a modifier for a subsequent event emission that the event message will be dropped when this socket is not
     * ready to send messages.
     *
     * @example
     * socket.volatile.emit("hello"); // the server may or may not receive it
     *
     * @returns self
     */
    get volatile() {
        this.flags.volatile = true;
        return this;
    }
    /**
     * Sets a modifier for a subsequent event emission that the callback will be called with an error when the
     * given number of milliseconds have elapsed without an acknowledgement from the server:
     *
     * @example
     * socket.timeout(5000).emit("my-event", (err) => {
     *   if (err) {
     *     // the server did not acknowledge the event in the given delay
     *   }
     * });
     *
     * @returns self
     */
    timeout(timeout) {
        this.flags.timeout = timeout;
        return this;
    }
    /**
     * Adds a listener that will be fired when any event is emitted. The event name is passed as the first argument to the
     * callback.
     *
     * @example
     * socket.onAny((event, ...args) => {
     *   console.log(`got ${event}`);
     * });
     *
     * @param listener
     */
    onAny(listener) {
        this._anyListeners = this._anyListeners || [];
        this._anyListeners.push(listener);
        return this;
    }
    /**
     * Adds a listener that will be fired when any event is emitted. The event name is passed as the first argument to the
     * callback. The listener is added to the beginning of the listeners array.
     *
     * @example
     * socket.prependAny((event, ...args) => {
     *   console.log(`got event ${event}`);
     * });
     *
     * @param listener
     */
    prependAny(listener) {
        this._anyListeners = this._anyListeners || [];
        this._anyListeners.unshift(listener);
        return this;
    }
    /**
     * Removes the listener that will be fired when any event is emitted.
     *
     * @example
     * const catchAllListener = (event, ...args) => {
     *   console.log(`got event ${event}`);
     * }
     *
     * socket.onAny(catchAllListener);
     *
     * // remove a specific listener
     * socket.offAny(catchAllListener);
     *
     * // or remove all listeners
     * socket.offAny();
     *
     * @param listener
     */
    offAny(listener) {
        if (!this._anyListeners) {
            return this;
        }
        if (listener) {
            const listeners = this._anyListeners;
            for (let i = 0; i < listeners.length; i++) {
                if (listener === listeners[i]) {
                    listeners.splice(i, 1);
                    return this;
                }
            }
        }
        else {
            this._anyListeners = [];
        }
        return this;
    }
    /**
     * Returns an array of listeners that are listening for any event that is specified. This array can be manipulated,
     * e.g. to remove listeners.
     */
    listenersAny() {
        return this._anyListeners || [];
    }
    /**
     * Adds a listener that will be fired when any event is emitted. The event name is passed as the first argument to the
     * callback.
     *
     * Note: acknowledgements sent to the server are not included.
     *
     * @example
     * socket.onAnyOutgoing((event, ...args) => {
     *   console.log(`sent event ${event}`);
     * });
     *
     * @param listener
     */
    onAnyOutgoing(listener) {
        this._anyOutgoingListeners = this._anyOutgoingListeners || [];
        this._anyOutgoingListeners.push(listener);
        return this;
    }
    /**
     * Adds a listener that will be fired when any event is emitted. The event name is passed as the first argument to the
     * callback. The listener is added to the beginning of the listeners array.
     *
     * Note: acknowledgements sent to the server are not included.
     *
     * @example
     * socket.prependAnyOutgoing((event, ...args) => {
     *   console.log(`sent event ${event}`);
     * });
     *
     * @param listener
     */
    prependAnyOutgoing(listener) {
        this._anyOutgoingListeners = this._anyOutgoingListeners || [];
        this._anyOutgoingListeners.unshift(listener);
        return this;
    }
    /**
     * Removes the listener that will be fired when any event is emitted.
     *
     * @example
     * const catchAllListener = (event, ...args) => {
     *   console.log(`sent event ${event}`);
     * }
     *
     * socket.onAnyOutgoing(catchAllListener);
     *
     * // remove a specific listener
     * socket.offAnyOutgoing(catchAllListener);
     *
     * // or remove all listeners
     * socket.offAnyOutgoing();
     *
     * @param [listener] - the catch-all listener (optional)
     */
    offAnyOutgoing(listener) {
        if (!this._anyOutgoingListeners) {
            return this;
        }
        if (listener) {
            const listeners = this._anyOutgoingListeners;
            for (let i = 0; i < listeners.length; i++) {
                if (listener === listeners[i]) {
                    listeners.splice(i, 1);
                    return this;
                }
            }
        }
        else {
            this._anyOutgoingListeners = [];
        }
        return this;
    }
    /**
     * Returns an array of listeners that are listening for any event that is specified. This array can be manipulated,
     * e.g. to remove listeners.
     */
    listenersAnyOutgoing() {
        return this._anyOutgoingListeners || [];
    }
    /**
     * Notify the listeners for each packet sent
     *
     * @param packet
     *
     * @private
     */
    notifyOutgoingListeners(packet) {
        if (this._anyOutgoingListeners && this._anyOutgoingListeners.length) {
            const listeners = this._anyOutgoingListeners.slice();
            for (const listener of listeners) {
                listener.apply(this, packet.data);
            }
        }
    }
}

;// CONCATENATED MODULE: ./node_modules/socket.io-client/build/esm/contrib/backo2.js
/**
 * Initialize backoff timer with `opts`.
 *
 * - `min` initial timeout in milliseconds [100]
 * - `max` max timeout [10000]
 * - `jitter` [0]
 * - `factor` [2]
 *
 * @param {Object} opts
 * @api public
 */
function Backoff(opts) {
    opts = opts || {};
    this.ms = opts.min || 100;
    this.max = opts.max || 10000;
    this.factor = opts.factor || 2;
    this.jitter = opts.jitter > 0 && opts.jitter <= 1 ? opts.jitter : 0;
    this.attempts = 0;
}
/**
 * Return the backoff duration.
 *
 * @return {Number}
 * @api public
 */
Backoff.prototype.duration = function () {
    var ms = this.ms * Math.pow(this.factor, this.attempts++);
    if (this.jitter) {
        var rand = Math.random();
        var deviation = Math.floor(rand * this.jitter * ms);
        ms = (Math.floor(rand * 10) & 1) == 0 ? ms - deviation : ms + deviation;
    }
    return Math.min(ms, this.max) | 0;
};
/**
 * Reset the number of attempts.
 *
 * @api public
 */
Backoff.prototype.reset = function () {
    this.attempts = 0;
};
/**
 * Set the minimum duration
 *
 * @api public
 */
Backoff.prototype.setMin = function (min) {
    this.ms = min;
};
/**
 * Set the maximum duration
 *
 * @api public
 */
Backoff.prototype.setMax = function (max) {
    this.max = max;
};
/**
 * Set the jitter
 *
 * @api public
 */
Backoff.prototype.setJitter = function (jitter) {
    this.jitter = jitter;
};

;// CONCATENATED MODULE: ./node_modules/socket.io-client/build/esm/manager.js






class Manager extends Emitter {
    constructor(uri, opts) {
        var _a;
        super();
        this.nsps = {};
        this.subs = [];
        if (uri && "object" === typeof uri) {
            opts = uri;
            uri = undefined;
        }
        opts = opts || {};
        opts.path = opts.path || "/socket.io";
        this.opts = opts;
        installTimerFunctions(this, opts);
        this.reconnection(opts.reconnection !== false);
        this.reconnectionAttempts(opts.reconnectionAttempts || Infinity);
        this.reconnectionDelay(opts.reconnectionDelay || 1000);
        this.reconnectionDelayMax(opts.reconnectionDelayMax || 5000);
        this.randomizationFactor((_a = opts.randomizationFactor) !== null && _a !== void 0 ? _a : 0.5);
        this.backoff = new Backoff({
            min: this.reconnectionDelay(),
            max: this.reconnectionDelayMax(),
            jitter: this.randomizationFactor(),
        });
        this.timeout(null == opts.timeout ? 20000 : opts.timeout);
        this._readyState = "closed";
        this.uri = uri;
        const _parser = opts.parser || socket_io_parser_build_esm_namespaceObject;
        this.encoder = new _parser.Encoder();
        this.decoder = new _parser.Decoder();
        this._autoConnect = opts.autoConnect !== false;
        if (this._autoConnect)
            this.open();
    }
    reconnection(v) {
        if (!arguments.length)
            return this._reconnection;
        this._reconnection = !!v;
        return this;
    }
    reconnectionAttempts(v) {
        if (v === undefined)
            return this._reconnectionAttempts;
        this._reconnectionAttempts = v;
        return this;
    }
    reconnectionDelay(v) {
        var _a;
        if (v === undefined)
            return this._reconnectionDelay;
        this._reconnectionDelay = v;
        (_a = this.backoff) === null || _a === void 0 ? void 0 : _a.setMin(v);
        return this;
    }
    randomizationFactor(v) {
        var _a;
        if (v === undefined)
            return this._randomizationFactor;
        this._randomizationFactor = v;
        (_a = this.backoff) === null || _a === void 0 ? void 0 : _a.setJitter(v);
        return this;
    }
    reconnectionDelayMax(v) {
        var _a;
        if (v === undefined)
            return this._reconnectionDelayMax;
        this._reconnectionDelayMax = v;
        (_a = this.backoff) === null || _a === void 0 ? void 0 : _a.setMax(v);
        return this;
    }
    timeout(v) {
        if (!arguments.length)
            return this._timeout;
        this._timeout = v;
        return this;
    }
    /**
     * Starts trying to reconnect if reconnection is enabled and we have not
     * started reconnecting yet
     *
     * @private
     */
    maybeReconnectOnOpen() {
        // Only try to reconnect if it's the first time we're connecting
        if (!this._reconnecting &&
            this._reconnection &&
            this.backoff.attempts === 0) {
            // keeps reconnection from firing twice for the same reconnection loop
            this.reconnect();
        }
    }
    /**
     * Sets the current transport `socket`.
     *
     * @param {Function} fn - optional, callback
     * @return self
     * @public
     */
    open(fn) {
        if (~this._readyState.indexOf("open"))
            return this;
        this.engine = new Socket(this.uri, this.opts);
        const socket = this.engine;
        const self = this;
        this._readyState = "opening";
        this.skipReconnect = false;
        // emit `open`
        const openSubDestroy = on(socket, "open", function () {
            self.onopen();
            fn && fn();
        });
        // emit `error`
        const errorSub = on(socket, "error", (err) => {
            self.cleanup();
            self._readyState = "closed";
            this.emitReserved("error", err);
            if (fn) {
                fn(err);
            }
            else {
                // Only do this if there is no fn to handle the error
                self.maybeReconnectOnOpen();
            }
        });
        if (false !== this._timeout) {
            const timeout = this._timeout;
            if (timeout === 0) {
                openSubDestroy(); // prevents a race condition with the 'open' event
            }
            // set timer
            const timer = this.setTimeoutFn(() => {
                openSubDestroy();
                socket.close();
                // @ts-ignore
                socket.emit("error", new Error("timeout"));
            }, timeout);
            if (this.opts.autoUnref) {
                timer.unref();
            }
            this.subs.push(function subDestroy() {
                clearTimeout(timer);
            });
        }
        this.subs.push(openSubDestroy);
        this.subs.push(errorSub);
        return this;
    }
    /**
     * Alias for open()
     *
     * @return self
     * @public
     */
    connect(fn) {
        return this.open(fn);
    }
    /**
     * Called upon transport open.
     *
     * @private
     */
    onopen() {
        // clear old subs
        this.cleanup();
        // mark as open
        this._readyState = "open";
        this.emitReserved("open");
        // add new subs
        const socket = this.engine;
        this.subs.push(on(socket, "ping", this.onping.bind(this)), on(socket, "data", this.ondata.bind(this)), on(socket, "error", this.onerror.bind(this)), on(socket, "close", this.onclose.bind(this)), on(this.decoder, "decoded", this.ondecoded.bind(this)));
    }
    /**
     * Called upon a ping.
     *
     * @private
     */
    onping() {
        this.emitReserved("ping");
    }
    /**
     * Called with data.
     *
     * @private
     */
    ondata(data) {
        try {
            this.decoder.add(data);
        }
        catch (e) {
            this.onclose("parse error", e);
        }
    }
    /**
     * Called when parser fully decodes a packet.
     *
     * @private
     */
    ondecoded(packet) {
        // the nextTick call prevents an exception in a user-provided event listener from triggering a disconnection due to a "parse error"
        nextTick(() => {
            this.emitReserved("packet", packet);
        }, this.setTimeoutFn);
    }
    /**
     * Called upon socket error.
     *
     * @private
     */
    onerror(err) {
        this.emitReserved("error", err);
    }
    /**
     * Creates a new socket for the given `nsp`.
     *
     * @return {Socket}
     * @public
     */
    socket(nsp, opts) {
        let socket = this.nsps[nsp];
        if (!socket) {
            socket = new socket_Socket(this, nsp, opts);
            this.nsps[nsp] = socket;
        }
        else if (this._autoConnect && !socket.active) {
            socket.connect();
        }
        return socket;
    }
    /**
     * Called upon a socket close.
     *
     * @param socket
     * @private
     */
    _destroy(socket) {
        const nsps = Object.keys(this.nsps);
        for (const nsp of nsps) {
            const socket = this.nsps[nsp];
            if (socket.active) {
                return;
            }
        }
        this._close();
    }
    /**
     * Writes a packet.
     *
     * @param packet
     * @private
     */
    _packet(packet) {
        const encodedPackets = this.encoder.encode(packet);
        for (let i = 0; i < encodedPackets.length; i++) {
            this.engine.write(encodedPackets[i], packet.options);
        }
    }
    /**
     * Clean up transport subscriptions and packet buffer.
     *
     * @private
     */
    cleanup() {
        this.subs.forEach((subDestroy) => subDestroy());
        this.subs.length = 0;
        this.decoder.destroy();
    }
    /**
     * Close the current socket.
     *
     * @private
     */
    _close() {
        this.skipReconnect = true;
        this._reconnecting = false;
        this.onclose("forced close");
        if (this.engine)
            this.engine.close();
    }
    /**
     * Alias for close()
     *
     * @private
     */
    disconnect() {
        return this._close();
    }
    /**
     * Called upon engine close.
     *
     * @private
     */
    onclose(reason, description) {
        this.cleanup();
        this.backoff.reset();
        this._readyState = "closed";
        this.emitReserved("close", reason, description);
        if (this._reconnection && !this.skipReconnect) {
            this.reconnect();
        }
    }
    /**
     * Attempt a reconnection.
     *
     * @private
     */
    reconnect() {
        if (this._reconnecting || this.skipReconnect)
            return this;
        const self = this;
        if (this.backoff.attempts >= this._reconnectionAttempts) {
            this.backoff.reset();
            this.emitReserved("reconnect_failed");
            this._reconnecting = false;
        }
        else {
            const delay = this.backoff.duration();
            this._reconnecting = true;
            const timer = this.setTimeoutFn(() => {
                if (self.skipReconnect)
                    return;
                this.emitReserved("reconnect_attempt", self.backoff.attempts);
                // check again for the case socket closed in above events
                if (self.skipReconnect)
                    return;
                self.open((err) => {
                    if (err) {
                        self._reconnecting = false;
                        self.reconnect();
                        this.emitReserved("reconnect_error", err);
                    }
                    else {
                        self.onreconnect();
                    }
                });
            }, delay);
            if (this.opts.autoUnref) {
                timer.unref();
            }
            this.subs.push(function subDestroy() {
                clearTimeout(timer);
            });
        }
    }
    /**
     * Called upon successful reconnect.
     *
     * @private
     */
    onreconnect() {
        const attempt = this.backoff.attempts;
        this._reconnecting = false;
        this.backoff.reset();
        this.emitReserved("reconnect", attempt);
    }
}

;// CONCATENATED MODULE: ./node_modules/socket.io-client/build/esm/index.js



/**
 * Managers cache.
 */
const cache = {};
function esm_lookup(uri, opts) {
    if (typeof uri === "object") {
        opts = uri;
        uri = undefined;
    }
    opts = opts || {};
    const parsed = url(uri, opts.path || "/socket.io");
    const source = parsed.source;
    const id = parsed.id;
    const path = parsed.path;
    const sameNamespace = cache[id] && path in cache[id]["nsps"];
    const newConnection = opts.forceNew ||
        opts["force new connection"] ||
        false === opts.multiplex ||
        sameNamespace;
    let io;
    if (newConnection) {
        io = new Manager(source, opts);
    }
    else {
        if (!cache[id]) {
            cache[id] = new Manager(source, opts);
        }
        io = cache[id];
    }
    if (parsed.query && !opts.query) {
        opts.query = parsed.queryKey;
    }
    return io.socket(parsed.path, opts);
}
// so that "lookup" can be used both as a function (e.g. `io(...)`) and as a
// namespace (e.g. `io.connect(...)`), for backward compatibility
Object.assign(esm_lookup, {
    Manager: Manager,
    Socket: socket_Socket,
    io: esm_lookup,
    connect: esm_lookup,
});
/**
 * Protocol version.
 *
 * @public
 */

/**
 * Expose constructors for standalone build.
 *
 * @public
 */


;// CONCATENATED MODULE: ./app/services/Socket.ts

class Socket_Socket {
    constructor(){
        this.getInstance = (param)=>{
            let { name , path , token  } = param;
            const publicBaseSocketURL = "https://socket.playee.net";
            if (this.socketIo == null) {
                this.socketIo = esm_lookup(publicBaseSocketURL, {
                    path: "/socket.io",
                    secure: true,
                    reconnection: true,
                    rejectUnauthorized: false,
                    transports: [
                        "websocket"
                    ],
                    query: {
                        token
                    }
                });
                this.socketIo.on("connect", ()=>{
                // console.log("connect=", "connect", this.socketIo)
                });
                this.socketIo.on("disconnect", ()=>{
                // console.log("------------disconnect-socket------------")
                });
            }
            return this.socketIo;
        };
        this.removeInstance = ()=>{
            this.socketIo = null;
        };
    }
}


// EXTERNAL MODULE: ./app/configs/index.ts + 3 modules
var configs = __webpack_require__(54254);
;// CONCATENATED MODULE: ./app/hooks/useSocket.ts



const useSocket = (param)=>{
    let { event , handleEvent , dependences , nonAuthen , name , path , type ="listen" , handleEventNotification  } = param;
    const token = configs/* isClient */.C5 ? window.localStorage.getItem("token") || "" : "";
    (0,react.useEffect)(()=>{
        const socketIo = new Socket_Socket();
        const socketInstance = socketIo.getInstance({
            name,
            path,
            token
        });
        if (token || nonAuthen) {
            if (typeof event === "string") {
                if (type === "listen") {
                    socketInstance.on(event, (msg)=>{
                        handleEvent(msg);
                        if (event === "connection" && !!token) {
                            socketInstance.emit("login", token);
                            socketInstance.on("login", (msg)=>{
                            // console.log("login", msg)
                            });
                            socketInstance.on("notification", (data)=>{
                                handleEventNotification && !!data && handleEventNotification(data);
                            });
                            socketInstance.on("inbox", (res)=>{
                            // console.log("res", res)
                            });
                        }
                    });
                } else {
                    if (Array.isArray(handleEvent)) {
                        socketInstance.emit(event, ...handleEvent);
                    } else socketInstance.emit(event, handleEvent);
                }
            }
        }
        return ()=>{
            if (token || nonAuthen) {
                if (typeof event === "string") {
                    socketInstance.off(event, handleEvent);
                    socketInstance.off("notification", (data)=>{
                        handleEventNotification && !!data && handleEventNotification(data);
                    });
                    socketInstance.off("inbox", (res)=>{
                    // console.log("res", res)
                    });
                    socketInstance.off("login", (msg)=>{
                    // console.log("login", msg)
                    });
                // socketInstance.off("login")
                }
            }
        };
    }, [
        token,
        ...dependences || []
    ]);
};


/***/ }),

/***/ 73848:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "cn": function() { return /* binding */ cn; },
  "fC": function() { return /* binding */ compareValues; },
  "hj": function() { return /* binding */ utils_isNumber; },
  "t2": function() { return /* binding */ removeNullKeyObject; }
});

// EXTERNAL MODULE: ./node_modules/clsx/dist/clsx.mjs
var clsx = __webpack_require__(90512);
;// CONCATENATED MODULE: ./node_modules/tailwind-merge/dist/bundle-mjs.mjs
const CLASS_PART_SEPARATOR = '-';
function createClassUtils(config) {
  const classMap = createClassMap(config);
  const {
    conflictingClassGroups,
    conflictingClassGroupModifiers
  } = config;
  function getClassGroupId(className) {
    const classParts = className.split(CLASS_PART_SEPARATOR);
    // Classes like `-inset-1` produce an empty string as first classPart. We assume that classes for negative values are used correctly and remove it from classParts.
    if (classParts[0] === '' && classParts.length !== 1) {
      classParts.shift();
    }
    return getGroupRecursive(classParts, classMap) || getGroupIdForArbitraryProperty(className);
  }
  function getConflictingClassGroupIds(classGroupId, hasPostfixModifier) {
    const conflicts = conflictingClassGroups[classGroupId] || [];
    if (hasPostfixModifier && conflictingClassGroupModifiers[classGroupId]) {
      return [...conflicts, ...conflictingClassGroupModifiers[classGroupId]];
    }
    return conflicts;
  }
  return {
    getClassGroupId,
    getConflictingClassGroupIds
  };
}
function getGroupRecursive(classParts, classPartObject) {
  if (classParts.length === 0) {
    return classPartObject.classGroupId;
  }
  const currentClassPart = classParts[0];
  const nextClassPartObject = classPartObject.nextPart.get(currentClassPart);
  const classGroupFromNextClassPart = nextClassPartObject ? getGroupRecursive(classParts.slice(1), nextClassPartObject) : undefined;
  if (classGroupFromNextClassPart) {
    return classGroupFromNextClassPart;
  }
  if (classPartObject.validators.length === 0) {
    return undefined;
  }
  const classRest = classParts.join(CLASS_PART_SEPARATOR);
  return classPartObject.validators.find(({
    validator
  }) => validator(classRest))?.classGroupId;
}
const arbitraryPropertyRegex = /^\[(.+)\]$/;
function getGroupIdForArbitraryProperty(className) {
  if (arbitraryPropertyRegex.test(className)) {
    const arbitraryPropertyClassName = arbitraryPropertyRegex.exec(className)[1];
    const property = arbitraryPropertyClassName?.substring(0, arbitraryPropertyClassName.indexOf(':'));
    if (property) {
      // I use two dots here because one dot is used as prefix for class groups in plugins
      return 'arbitrary..' + property;
    }
  }
}
/**
 * Exported for testing only
 */
function createClassMap(config) {
  const {
    theme,
    prefix
  } = config;
  const classMap = {
    nextPart: new Map(),
    validators: []
  };
  const prefixedClassGroupEntries = getPrefixedClassGroupEntries(Object.entries(config.classGroups), prefix);
  prefixedClassGroupEntries.forEach(([classGroupId, classGroup]) => {
    processClassesRecursively(classGroup, classMap, classGroupId, theme);
  });
  return classMap;
}
function processClassesRecursively(classGroup, classPartObject, classGroupId, theme) {
  classGroup.forEach(classDefinition => {
    if (typeof classDefinition === 'string') {
      const classPartObjectToEdit = classDefinition === '' ? classPartObject : getPart(classPartObject, classDefinition);
      classPartObjectToEdit.classGroupId = classGroupId;
      return;
    }
    if (typeof classDefinition === 'function') {
      if (isThemeGetter(classDefinition)) {
        processClassesRecursively(classDefinition(theme), classPartObject, classGroupId, theme);
        return;
      }
      classPartObject.validators.push({
        validator: classDefinition,
        classGroupId
      });
      return;
    }
    Object.entries(classDefinition).forEach(([key, classGroup]) => {
      processClassesRecursively(classGroup, getPart(classPartObject, key), classGroupId, theme);
    });
  });
}
function getPart(classPartObject, path) {
  let currentClassPartObject = classPartObject;
  path.split(CLASS_PART_SEPARATOR).forEach(pathPart => {
    if (!currentClassPartObject.nextPart.has(pathPart)) {
      currentClassPartObject.nextPart.set(pathPart, {
        nextPart: new Map(),
        validators: []
      });
    }
    currentClassPartObject = currentClassPartObject.nextPart.get(pathPart);
  });
  return currentClassPartObject;
}
function isThemeGetter(func) {
  return func.isThemeGetter;
}
function getPrefixedClassGroupEntries(classGroupEntries, prefix) {
  if (!prefix) {
    return classGroupEntries;
  }
  return classGroupEntries.map(([classGroupId, classGroup]) => {
    const prefixedClassGroup = classGroup.map(classDefinition => {
      if (typeof classDefinition === 'string') {
        return prefix + classDefinition;
      }
      if (typeof classDefinition === 'object') {
        return Object.fromEntries(Object.entries(classDefinition).map(([key, value]) => [prefix + key, value]));
      }
      return classDefinition;
    });
    return [classGroupId, prefixedClassGroup];
  });
}

// LRU cache inspired from hashlru (https://github.com/dominictarr/hashlru/blob/v1.0.4/index.js) but object replaced with Map to improve performance
function createLruCache(maxCacheSize) {
  if (maxCacheSize < 1) {
    return {
      get: () => undefined,
      set: () => {}
    };
  }
  let cacheSize = 0;
  let cache = new Map();
  let previousCache = new Map();
  function update(key, value) {
    cache.set(key, value);
    cacheSize++;
    if (cacheSize > maxCacheSize) {
      cacheSize = 0;
      previousCache = cache;
      cache = new Map();
    }
  }
  return {
    get(key) {
      let value = cache.get(key);
      if (value !== undefined) {
        return value;
      }
      if ((value = previousCache.get(key)) !== undefined) {
        update(key, value);
        return value;
      }
    },
    set(key, value) {
      if (cache.has(key)) {
        cache.set(key, value);
      } else {
        update(key, value);
      }
    }
  };
}
const IMPORTANT_MODIFIER = '!';
function createSplitModifiers(config) {
  const separator = config.separator;
  const isSeparatorSingleCharacter = separator.length === 1;
  const firstSeparatorCharacter = separator[0];
  const separatorLength = separator.length;
  // splitModifiers inspired by https://github.com/tailwindlabs/tailwindcss/blob/v3.2.2/src/util/splitAtTopLevelOnly.js
  return function splitModifiers(className) {
    const modifiers = [];
    let bracketDepth = 0;
    let modifierStart = 0;
    let postfixModifierPosition;
    for (let index = 0; index < className.length; index++) {
      let currentCharacter = className[index];
      if (bracketDepth === 0) {
        if (currentCharacter === firstSeparatorCharacter && (isSeparatorSingleCharacter || className.slice(index, index + separatorLength) === separator)) {
          modifiers.push(className.slice(modifierStart, index));
          modifierStart = index + separatorLength;
          continue;
        }
        if (currentCharacter === '/') {
          postfixModifierPosition = index;
          continue;
        }
      }
      if (currentCharacter === '[') {
        bracketDepth++;
      } else if (currentCharacter === ']') {
        bracketDepth--;
      }
    }
    const baseClassNameWithImportantModifier = modifiers.length === 0 ? className : className.substring(modifierStart);
    const hasImportantModifier = baseClassNameWithImportantModifier.startsWith(IMPORTANT_MODIFIER);
    const baseClassName = hasImportantModifier ? baseClassNameWithImportantModifier.substring(1) : baseClassNameWithImportantModifier;
    const maybePostfixModifierPosition = postfixModifierPosition && postfixModifierPosition > modifierStart ? postfixModifierPosition - modifierStart : undefined;
    return {
      modifiers,
      hasImportantModifier,
      baseClassName,
      maybePostfixModifierPosition
    };
  };
}
/**
 * Sorts modifiers according to following schema:
 * - Predefined modifiers are sorted alphabetically
 * - When an arbitrary variant appears, it must be preserved which modifiers are before and after it
 */
function sortModifiers(modifiers) {
  if (modifiers.length <= 1) {
    return modifiers;
  }
  const sortedModifiers = [];
  let unsortedModifiers = [];
  modifiers.forEach(modifier => {
    const isArbitraryVariant = modifier[0] === '[';
    if (isArbitraryVariant) {
      sortedModifiers.push(...unsortedModifiers.sort(), modifier);
      unsortedModifiers = [];
    } else {
      unsortedModifiers.push(modifier);
    }
  });
  sortedModifiers.push(...unsortedModifiers.sort());
  return sortedModifiers;
}
function createConfigUtils(config) {
  return {
    cache: createLruCache(config.cacheSize),
    splitModifiers: createSplitModifiers(config),
    ...createClassUtils(config)
  };
}
const SPLIT_CLASSES_REGEX = /\s+/;
function mergeClassList(classList, configUtils) {
  const {
    splitModifiers,
    getClassGroupId,
    getConflictingClassGroupIds
  } = configUtils;
  /**
   * Set of classGroupIds in following format:
   * `{importantModifier}{variantModifiers}{classGroupId}`
   * @example 'float'
   * @example 'hover:focus:bg-color'
   * @example 'md:!pr'
   */
  const classGroupsInConflict = new Set();
  return classList.trim().split(SPLIT_CLASSES_REGEX).map(originalClassName => {
    const {
      modifiers,
      hasImportantModifier,
      baseClassName,
      maybePostfixModifierPosition
    } = splitModifiers(originalClassName);
    let classGroupId = getClassGroupId(maybePostfixModifierPosition ? baseClassName.substring(0, maybePostfixModifierPosition) : baseClassName);
    let hasPostfixModifier = Boolean(maybePostfixModifierPosition);
    if (!classGroupId) {
      if (!maybePostfixModifierPosition) {
        return {
          isTailwindClass: false,
          originalClassName
        };
      }
      classGroupId = getClassGroupId(baseClassName);
      if (!classGroupId) {
        return {
          isTailwindClass: false,
          originalClassName
        };
      }
      hasPostfixModifier = false;
    }
    const variantModifier = sortModifiers(modifiers).join(':');
    const modifierId = hasImportantModifier ? variantModifier + IMPORTANT_MODIFIER : variantModifier;
    return {
      isTailwindClass: true,
      modifierId,
      classGroupId,
      originalClassName,
      hasPostfixModifier
    };
  }).reverse()
  // Last class in conflict wins, so we need to filter conflicting classes in reverse order.
  .filter(parsed => {
    if (!parsed.isTailwindClass) {
      return true;
    }
    const {
      modifierId,
      classGroupId,
      hasPostfixModifier
    } = parsed;
    const classId = modifierId + classGroupId;
    if (classGroupsInConflict.has(classId)) {
      return false;
    }
    classGroupsInConflict.add(classId);
    getConflictingClassGroupIds(classGroupId, hasPostfixModifier).forEach(group => classGroupsInConflict.add(modifierId + group));
    return true;
  }).reverse().map(parsed => parsed.originalClassName).join(' ');
}

/**
 * The code in this file is copied from https://github.com/lukeed/clsx and modified to suit the needs of tailwind-merge better.
 *
 * Specifically:
 * - Runtime code from https://github.com/lukeed/clsx/blob/v1.2.1/src/index.js
 * - TypeScript types from https://github.com/lukeed/clsx/blob/v1.2.1/clsx.d.ts
 *
 * Original code has MIT license: Copyright (c) Luke Edwards <luke.edwards05@gmail.com> (lukeed.com)
 */
function twJoin() {
  let index = 0;
  let argument;
  let resolvedValue;
  let string = '';
  while (index < arguments.length) {
    if (argument = arguments[index++]) {
      if (resolvedValue = toValue(argument)) {
        string && (string += ' ');
        string += resolvedValue;
      }
    }
  }
  return string;
}
function toValue(mix) {
  if (typeof mix === 'string') {
    return mix;
  }
  let resolvedValue;
  let string = '';
  for (let k = 0; k < mix.length; k++) {
    if (mix[k]) {
      if (resolvedValue = toValue(mix[k])) {
        string && (string += ' ');
        string += resolvedValue;
      }
    }
  }
  return string;
}
function createTailwindMerge(createConfigFirst, ...createConfigRest) {
  let configUtils;
  let cacheGet;
  let cacheSet;
  let functionToCall = initTailwindMerge;
  function initTailwindMerge(classList) {
    const config = createConfigRest.reduce((previousConfig, createConfigCurrent) => createConfigCurrent(previousConfig), createConfigFirst());
    configUtils = createConfigUtils(config);
    cacheGet = configUtils.cache.get;
    cacheSet = configUtils.cache.set;
    functionToCall = tailwindMerge;
    return tailwindMerge(classList);
  }
  function tailwindMerge(classList) {
    const cachedResult = cacheGet(classList);
    if (cachedResult) {
      return cachedResult;
    }
    const result = mergeClassList(classList, configUtils);
    cacheSet(classList, result);
    return result;
  }
  return function callTailwindMerge() {
    return functionToCall(twJoin.apply(null, arguments));
  };
}
function fromTheme(key) {
  const themeGetter = theme => theme[key] || [];
  themeGetter.isThemeGetter = true;
  return themeGetter;
}
const arbitraryValueRegex = /^\[(?:([a-z-]+):)?(.+)\]$/i;
const fractionRegex = /^\d+\/\d+$/;
const stringLengths = /*#__PURE__*/new Set(['px', 'full', 'screen']);
const tshirtUnitRegex = /^(\d+(\.\d+)?)?(xs|sm|md|lg|xl)$/;
const lengthUnitRegex = /\d+(%|px|r?em|[sdl]?v([hwib]|min|max)|pt|pc|in|cm|mm|cap|ch|ex|r?lh|cq(w|h|i|b|min|max))|\b(calc|min|max|clamp)\(.+\)|^0$/;
// Shadow always begins with x and y offset separated by underscore
const shadowRegex = /^-?((\d+)?\.?(\d+)[a-z]+|0)_-?((\d+)?\.?(\d+)[a-z]+|0)/;
const imageRegex = /^(url|image|image-set|cross-fade|element|(repeating-)?(linear|radial|conic)-gradient)\(.+\)$/;
function isLength(value) {
  return isNumber(value) || stringLengths.has(value) || fractionRegex.test(value);
}
function isArbitraryLength(value) {
  return getIsArbitraryValue(value, 'length', isLengthOnly);
}
function isNumber(value) {
  return Boolean(value) && !Number.isNaN(Number(value));
}
function isArbitraryNumber(value) {
  return getIsArbitraryValue(value, 'number', isNumber);
}
function isInteger(value) {
  return Boolean(value) && Number.isInteger(Number(value));
}
function isPercent(value) {
  return value.endsWith('%') && isNumber(value.slice(0, -1));
}
function isArbitraryValue(value) {
  return arbitraryValueRegex.test(value);
}
function isTshirtSize(value) {
  return tshirtUnitRegex.test(value);
}
const sizeLabels = /*#__PURE__*/new Set(['length', 'size', 'percentage']);
function isArbitrarySize(value) {
  return getIsArbitraryValue(value, sizeLabels, isNever);
}
function isArbitraryPosition(value) {
  return getIsArbitraryValue(value, 'position', isNever);
}
const imageLabels = /*#__PURE__*/new Set(['image', 'url']);
function isArbitraryImage(value) {
  return getIsArbitraryValue(value, imageLabels, isImage);
}
function isArbitraryShadow(value) {
  return getIsArbitraryValue(value, '', isShadow);
}
function isAny() {
  return true;
}
function getIsArbitraryValue(value, label, testValue) {
  const result = arbitraryValueRegex.exec(value);
  if (result) {
    if (result[1]) {
      return typeof label === 'string' ? result[1] === label : label.has(result[1]);
    }
    return testValue(result[2]);
  }
  return false;
}
function isLengthOnly(value) {
  return lengthUnitRegex.test(value);
}
function isNever() {
  return false;
}
function isShadow(value) {
  return shadowRegex.test(value);
}
function isImage(value) {
  return imageRegex.test(value);
}
const validators = /*#__PURE__*/Object.defineProperty({
  __proto__: null,
  isAny,
  isArbitraryImage,
  isArbitraryLength,
  isArbitraryNumber,
  isArbitraryPosition,
  isArbitraryShadow,
  isArbitrarySize,
  isArbitraryValue,
  isInteger,
  isLength,
  isNumber,
  isPercent,
  isTshirtSize
}, Symbol.toStringTag, {
  value: 'Module'
});
function getDefaultConfig() {
  const colors = fromTheme('colors');
  const spacing = fromTheme('spacing');
  const blur = fromTheme('blur');
  const brightness = fromTheme('brightness');
  const borderColor = fromTheme('borderColor');
  const borderRadius = fromTheme('borderRadius');
  const borderSpacing = fromTheme('borderSpacing');
  const borderWidth = fromTheme('borderWidth');
  const contrast = fromTheme('contrast');
  const grayscale = fromTheme('grayscale');
  const hueRotate = fromTheme('hueRotate');
  const invert = fromTheme('invert');
  const gap = fromTheme('gap');
  const gradientColorStops = fromTheme('gradientColorStops');
  const gradientColorStopPositions = fromTheme('gradientColorStopPositions');
  const inset = fromTheme('inset');
  const margin = fromTheme('margin');
  const opacity = fromTheme('opacity');
  const padding = fromTheme('padding');
  const saturate = fromTheme('saturate');
  const scale = fromTheme('scale');
  const sepia = fromTheme('sepia');
  const skew = fromTheme('skew');
  const space = fromTheme('space');
  const translate = fromTheme('translate');
  const getOverscroll = () => ['auto', 'contain', 'none'];
  const getOverflow = () => ['auto', 'hidden', 'clip', 'visible', 'scroll'];
  const getSpacingWithAutoAndArbitrary = () => ['auto', isArbitraryValue, spacing];
  const getSpacingWithArbitrary = () => [isArbitraryValue, spacing];
  const getLengthWithEmptyAndArbitrary = () => ['', isLength, isArbitraryLength];
  const getNumberWithAutoAndArbitrary = () => ['auto', isNumber, isArbitraryValue];
  const getPositions = () => ['bottom', 'center', 'left', 'left-bottom', 'left-top', 'right', 'right-bottom', 'right-top', 'top'];
  const getLineStyles = () => ['solid', 'dashed', 'dotted', 'double', 'none'];
  const getBlendModes = () => ['normal', 'multiply', 'screen', 'overlay', 'darken', 'lighten', 'color-dodge', 'color-burn', 'hard-light', 'soft-light', 'difference', 'exclusion', 'hue', 'saturation', 'color', 'luminosity', 'plus-lighter'];
  const getAlign = () => ['start', 'end', 'center', 'between', 'around', 'evenly', 'stretch'];
  const getZeroAndEmpty = () => ['', '0', isArbitraryValue];
  const getBreaks = () => ['auto', 'avoid', 'all', 'avoid-page', 'page', 'left', 'right', 'column'];
  const getNumber = () => [isNumber, isArbitraryNumber];
  const getNumberAndArbitrary = () => [isNumber, isArbitraryValue];
  return {
    cacheSize: 500,
    separator: ':',
    theme: {
      colors: [isAny],
      spacing: [isLength, isArbitraryLength],
      blur: ['none', '', isTshirtSize, isArbitraryValue],
      brightness: getNumber(),
      borderColor: [colors],
      borderRadius: ['none', '', 'full', isTshirtSize, isArbitraryValue],
      borderSpacing: getSpacingWithArbitrary(),
      borderWidth: getLengthWithEmptyAndArbitrary(),
      contrast: getNumber(),
      grayscale: getZeroAndEmpty(),
      hueRotate: getNumberAndArbitrary(),
      invert: getZeroAndEmpty(),
      gap: getSpacingWithArbitrary(),
      gradientColorStops: [colors],
      gradientColorStopPositions: [isPercent, isArbitraryLength],
      inset: getSpacingWithAutoAndArbitrary(),
      margin: getSpacingWithAutoAndArbitrary(),
      opacity: getNumber(),
      padding: getSpacingWithArbitrary(),
      saturate: getNumber(),
      scale: getNumber(),
      sepia: getZeroAndEmpty(),
      skew: getNumberAndArbitrary(),
      space: getSpacingWithArbitrary(),
      translate: getSpacingWithArbitrary()
    },
    classGroups: {
      // Layout
      /**
       * Aspect Ratio
       * @see https://tailwindcss.com/docs/aspect-ratio
       */
      aspect: [{
        aspect: ['auto', 'square', 'video', isArbitraryValue]
      }],
      /**
       * Container
       * @see https://tailwindcss.com/docs/container
       */
      container: ['container'],
      /**
       * Columns
       * @see https://tailwindcss.com/docs/columns
       */
      columns: [{
        columns: [isTshirtSize]
      }],
      /**
       * Break After
       * @see https://tailwindcss.com/docs/break-after
       */
      'break-after': [{
        'break-after': getBreaks()
      }],
      /**
       * Break Before
       * @see https://tailwindcss.com/docs/break-before
       */
      'break-before': [{
        'break-before': getBreaks()
      }],
      /**
       * Break Inside
       * @see https://tailwindcss.com/docs/break-inside
       */
      'break-inside': [{
        'break-inside': ['auto', 'avoid', 'avoid-page', 'avoid-column']
      }],
      /**
       * Box Decoration Break
       * @see https://tailwindcss.com/docs/box-decoration-break
       */
      'box-decoration': [{
        'box-decoration': ['slice', 'clone']
      }],
      /**
       * Box Sizing
       * @see https://tailwindcss.com/docs/box-sizing
       */
      box: [{
        box: ['border', 'content']
      }],
      /**
       * Display
       * @see https://tailwindcss.com/docs/display
       */
      display: ['block', 'inline-block', 'inline', 'flex', 'inline-flex', 'table', 'inline-table', 'table-caption', 'table-cell', 'table-column', 'table-column-group', 'table-footer-group', 'table-header-group', 'table-row-group', 'table-row', 'flow-root', 'grid', 'inline-grid', 'contents', 'list-item', 'hidden'],
      /**
       * Floats
       * @see https://tailwindcss.com/docs/float
       */
      float: [{
        float: ['right', 'left', 'none', 'start', 'end']
      }],
      /**
       * Clear
       * @see https://tailwindcss.com/docs/clear
       */
      clear: [{
        clear: ['left', 'right', 'both', 'none', 'start', 'end']
      }],
      /**
       * Isolation
       * @see https://tailwindcss.com/docs/isolation
       */
      isolation: ['isolate', 'isolation-auto'],
      /**
       * Object Fit
       * @see https://tailwindcss.com/docs/object-fit
       */
      'object-fit': [{
        object: ['contain', 'cover', 'fill', 'none', 'scale-down']
      }],
      /**
       * Object Position
       * @see https://tailwindcss.com/docs/object-position
       */
      'object-position': [{
        object: [...getPositions(), isArbitraryValue]
      }],
      /**
       * Overflow
       * @see https://tailwindcss.com/docs/overflow
       */
      overflow: [{
        overflow: getOverflow()
      }],
      /**
       * Overflow X
       * @see https://tailwindcss.com/docs/overflow
       */
      'overflow-x': [{
        'overflow-x': getOverflow()
      }],
      /**
       * Overflow Y
       * @see https://tailwindcss.com/docs/overflow
       */
      'overflow-y': [{
        'overflow-y': getOverflow()
      }],
      /**
       * Overscroll Behavior
       * @see https://tailwindcss.com/docs/overscroll-behavior
       */
      overscroll: [{
        overscroll: getOverscroll()
      }],
      /**
       * Overscroll Behavior X
       * @see https://tailwindcss.com/docs/overscroll-behavior
       */
      'overscroll-x': [{
        'overscroll-x': getOverscroll()
      }],
      /**
       * Overscroll Behavior Y
       * @see https://tailwindcss.com/docs/overscroll-behavior
       */
      'overscroll-y': [{
        'overscroll-y': getOverscroll()
      }],
      /**
       * Position
       * @see https://tailwindcss.com/docs/position
       */
      position: ['static', 'fixed', 'absolute', 'relative', 'sticky'],
      /**
       * Top / Right / Bottom / Left
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      inset: [{
        inset: [inset]
      }],
      /**
       * Right / Left
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      'inset-x': [{
        'inset-x': [inset]
      }],
      /**
       * Top / Bottom
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      'inset-y': [{
        'inset-y': [inset]
      }],
      /**
       * Start
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      start: [{
        start: [inset]
      }],
      /**
       * End
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      end: [{
        end: [inset]
      }],
      /**
       * Top
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      top: [{
        top: [inset]
      }],
      /**
       * Right
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      right: [{
        right: [inset]
      }],
      /**
       * Bottom
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      bottom: [{
        bottom: [inset]
      }],
      /**
       * Left
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      left: [{
        left: [inset]
      }],
      /**
       * Visibility
       * @see https://tailwindcss.com/docs/visibility
       */
      visibility: ['visible', 'invisible', 'collapse'],
      /**
       * Z-Index
       * @see https://tailwindcss.com/docs/z-index
       */
      z: [{
        z: ['auto', isInteger, isArbitraryValue]
      }],
      // Flexbox and Grid
      /**
       * Flex Basis
       * @see https://tailwindcss.com/docs/flex-basis
       */
      basis: [{
        basis: getSpacingWithAutoAndArbitrary()
      }],
      /**
       * Flex Direction
       * @see https://tailwindcss.com/docs/flex-direction
       */
      'flex-direction': [{
        flex: ['row', 'row-reverse', 'col', 'col-reverse']
      }],
      /**
       * Flex Wrap
       * @see https://tailwindcss.com/docs/flex-wrap
       */
      'flex-wrap': [{
        flex: ['wrap', 'wrap-reverse', 'nowrap']
      }],
      /**
       * Flex
       * @see https://tailwindcss.com/docs/flex
       */
      flex: [{
        flex: ['1', 'auto', 'initial', 'none', isArbitraryValue]
      }],
      /**
       * Flex Grow
       * @see https://tailwindcss.com/docs/flex-grow
       */
      grow: [{
        grow: getZeroAndEmpty()
      }],
      /**
       * Flex Shrink
       * @see https://tailwindcss.com/docs/flex-shrink
       */
      shrink: [{
        shrink: getZeroAndEmpty()
      }],
      /**
       * Order
       * @see https://tailwindcss.com/docs/order
       */
      order: [{
        order: ['first', 'last', 'none', isInteger, isArbitraryValue]
      }],
      /**
       * Grid Template Columns
       * @see https://tailwindcss.com/docs/grid-template-columns
       */
      'grid-cols': [{
        'grid-cols': [isAny]
      }],
      /**
       * Grid Column Start / End
       * @see https://tailwindcss.com/docs/grid-column
       */
      'col-start-end': [{
        col: ['auto', {
          span: ['full', isInteger, isArbitraryValue]
        }, isArbitraryValue]
      }],
      /**
       * Grid Column Start
       * @see https://tailwindcss.com/docs/grid-column
       */
      'col-start': [{
        'col-start': getNumberWithAutoAndArbitrary()
      }],
      /**
       * Grid Column End
       * @see https://tailwindcss.com/docs/grid-column
       */
      'col-end': [{
        'col-end': getNumberWithAutoAndArbitrary()
      }],
      /**
       * Grid Template Rows
       * @see https://tailwindcss.com/docs/grid-template-rows
       */
      'grid-rows': [{
        'grid-rows': [isAny]
      }],
      /**
       * Grid Row Start / End
       * @see https://tailwindcss.com/docs/grid-row
       */
      'row-start-end': [{
        row: ['auto', {
          span: [isInteger, isArbitraryValue]
        }, isArbitraryValue]
      }],
      /**
       * Grid Row Start
       * @see https://tailwindcss.com/docs/grid-row
       */
      'row-start': [{
        'row-start': getNumberWithAutoAndArbitrary()
      }],
      /**
       * Grid Row End
       * @see https://tailwindcss.com/docs/grid-row
       */
      'row-end': [{
        'row-end': getNumberWithAutoAndArbitrary()
      }],
      /**
       * Grid Auto Flow
       * @see https://tailwindcss.com/docs/grid-auto-flow
       */
      'grid-flow': [{
        'grid-flow': ['row', 'col', 'dense', 'row-dense', 'col-dense']
      }],
      /**
       * Grid Auto Columns
       * @see https://tailwindcss.com/docs/grid-auto-columns
       */
      'auto-cols': [{
        'auto-cols': ['auto', 'min', 'max', 'fr', isArbitraryValue]
      }],
      /**
       * Grid Auto Rows
       * @see https://tailwindcss.com/docs/grid-auto-rows
       */
      'auto-rows': [{
        'auto-rows': ['auto', 'min', 'max', 'fr', isArbitraryValue]
      }],
      /**
       * Gap
       * @see https://tailwindcss.com/docs/gap
       */
      gap: [{
        gap: [gap]
      }],
      /**
       * Gap X
       * @see https://tailwindcss.com/docs/gap
       */
      'gap-x': [{
        'gap-x': [gap]
      }],
      /**
       * Gap Y
       * @see https://tailwindcss.com/docs/gap
       */
      'gap-y': [{
        'gap-y': [gap]
      }],
      /**
       * Justify Content
       * @see https://tailwindcss.com/docs/justify-content
       */
      'justify-content': [{
        justify: ['normal', ...getAlign()]
      }],
      /**
       * Justify Items
       * @see https://tailwindcss.com/docs/justify-items
       */
      'justify-items': [{
        'justify-items': ['start', 'end', 'center', 'stretch']
      }],
      /**
       * Justify Self
       * @see https://tailwindcss.com/docs/justify-self
       */
      'justify-self': [{
        'justify-self': ['auto', 'start', 'end', 'center', 'stretch']
      }],
      /**
       * Align Content
       * @see https://tailwindcss.com/docs/align-content
       */
      'align-content': [{
        content: ['normal', ...getAlign(), 'baseline']
      }],
      /**
       * Align Items
       * @see https://tailwindcss.com/docs/align-items
       */
      'align-items': [{
        items: ['start', 'end', 'center', 'baseline', 'stretch']
      }],
      /**
       * Align Self
       * @see https://tailwindcss.com/docs/align-self
       */
      'align-self': [{
        self: ['auto', 'start', 'end', 'center', 'stretch', 'baseline']
      }],
      /**
       * Place Content
       * @see https://tailwindcss.com/docs/place-content
       */
      'place-content': [{
        'place-content': [...getAlign(), 'baseline']
      }],
      /**
       * Place Items
       * @see https://tailwindcss.com/docs/place-items
       */
      'place-items': [{
        'place-items': ['start', 'end', 'center', 'baseline', 'stretch']
      }],
      /**
       * Place Self
       * @see https://tailwindcss.com/docs/place-self
       */
      'place-self': [{
        'place-self': ['auto', 'start', 'end', 'center', 'stretch']
      }],
      // Spacing
      /**
       * Padding
       * @see https://tailwindcss.com/docs/padding
       */
      p: [{
        p: [padding]
      }],
      /**
       * Padding X
       * @see https://tailwindcss.com/docs/padding
       */
      px: [{
        px: [padding]
      }],
      /**
       * Padding Y
       * @see https://tailwindcss.com/docs/padding
       */
      py: [{
        py: [padding]
      }],
      /**
       * Padding Start
       * @see https://tailwindcss.com/docs/padding
       */
      ps: [{
        ps: [padding]
      }],
      /**
       * Padding End
       * @see https://tailwindcss.com/docs/padding
       */
      pe: [{
        pe: [padding]
      }],
      /**
       * Padding Top
       * @see https://tailwindcss.com/docs/padding
       */
      pt: [{
        pt: [padding]
      }],
      /**
       * Padding Right
       * @see https://tailwindcss.com/docs/padding
       */
      pr: [{
        pr: [padding]
      }],
      /**
       * Padding Bottom
       * @see https://tailwindcss.com/docs/padding
       */
      pb: [{
        pb: [padding]
      }],
      /**
       * Padding Left
       * @see https://tailwindcss.com/docs/padding
       */
      pl: [{
        pl: [padding]
      }],
      /**
       * Margin
       * @see https://tailwindcss.com/docs/margin
       */
      m: [{
        m: [margin]
      }],
      /**
       * Margin X
       * @see https://tailwindcss.com/docs/margin
       */
      mx: [{
        mx: [margin]
      }],
      /**
       * Margin Y
       * @see https://tailwindcss.com/docs/margin
       */
      my: [{
        my: [margin]
      }],
      /**
       * Margin Start
       * @see https://tailwindcss.com/docs/margin
       */
      ms: [{
        ms: [margin]
      }],
      /**
       * Margin End
       * @see https://tailwindcss.com/docs/margin
       */
      me: [{
        me: [margin]
      }],
      /**
       * Margin Top
       * @see https://tailwindcss.com/docs/margin
       */
      mt: [{
        mt: [margin]
      }],
      /**
       * Margin Right
       * @see https://tailwindcss.com/docs/margin
       */
      mr: [{
        mr: [margin]
      }],
      /**
       * Margin Bottom
       * @see https://tailwindcss.com/docs/margin
       */
      mb: [{
        mb: [margin]
      }],
      /**
       * Margin Left
       * @see https://tailwindcss.com/docs/margin
       */
      ml: [{
        ml: [margin]
      }],
      /**
       * Space Between X
       * @see https://tailwindcss.com/docs/space
       */
      'space-x': [{
        'space-x': [space]
      }],
      /**
       * Space Between X Reverse
       * @see https://tailwindcss.com/docs/space
       */
      'space-x-reverse': ['space-x-reverse'],
      /**
       * Space Between Y
       * @see https://tailwindcss.com/docs/space
       */
      'space-y': [{
        'space-y': [space]
      }],
      /**
       * Space Between Y Reverse
       * @see https://tailwindcss.com/docs/space
       */
      'space-y-reverse': ['space-y-reverse'],
      // Sizing
      /**
       * Width
       * @see https://tailwindcss.com/docs/width
       */
      w: [{
        w: ['auto', 'min', 'max', 'fit', 'svw', 'lvw', 'dvw', isArbitraryValue, spacing]
      }],
      /**
       * Min-Width
       * @see https://tailwindcss.com/docs/min-width
       */
      'min-w': [{
        'min-w': [isArbitraryValue, spacing, 'min', 'max', 'fit']
      }],
      /**
       * Max-Width
       * @see https://tailwindcss.com/docs/max-width
       */
      'max-w': [{
        'max-w': [isArbitraryValue, spacing, 'none', 'full', 'min', 'max', 'fit', 'prose', {
          screen: [isTshirtSize]
        }, isTshirtSize]
      }],
      /**
       * Height
       * @see https://tailwindcss.com/docs/height
       */
      h: [{
        h: [isArbitraryValue, spacing, 'auto', 'min', 'max', 'fit', 'svh', 'lvh', 'dvh']
      }],
      /**
       * Min-Height
       * @see https://tailwindcss.com/docs/min-height
       */
      'min-h': [{
        'min-h': [isArbitraryValue, spacing, 'min', 'max', 'fit', 'svh', 'lvh', 'dvh']
      }],
      /**
       * Max-Height
       * @see https://tailwindcss.com/docs/max-height
       */
      'max-h': [{
        'max-h': [isArbitraryValue, spacing, 'min', 'max', 'fit', 'svh', 'lvh', 'dvh']
      }],
      /**
       * Size
       * @see https://tailwindcss.com/docs/size
       */
      size: [{
        size: [isArbitraryValue, spacing, 'auto', 'min', 'max', 'fit']
      }],
      // Typography
      /**
       * Font Size
       * @see https://tailwindcss.com/docs/font-size
       */
      'font-size': [{
        text: ['base', isTshirtSize, isArbitraryLength]
      }],
      /**
       * Font Smoothing
       * @see https://tailwindcss.com/docs/font-smoothing
       */
      'font-smoothing': ['antialiased', 'subpixel-antialiased'],
      /**
       * Font Style
       * @see https://tailwindcss.com/docs/font-style
       */
      'font-style': ['italic', 'not-italic'],
      /**
       * Font Weight
       * @see https://tailwindcss.com/docs/font-weight
       */
      'font-weight': [{
        font: ['thin', 'extralight', 'light', 'normal', 'medium', 'semibold', 'bold', 'extrabold', 'black', isArbitraryNumber]
      }],
      /**
       * Font Family
       * @see https://tailwindcss.com/docs/font-family
       */
      'font-family': [{
        font: [isAny]
      }],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      'fvn-normal': ['normal-nums'],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      'fvn-ordinal': ['ordinal'],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      'fvn-slashed-zero': ['slashed-zero'],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      'fvn-figure': ['lining-nums', 'oldstyle-nums'],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      'fvn-spacing': ['proportional-nums', 'tabular-nums'],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      'fvn-fraction': ['diagonal-fractions', 'stacked-fractons'],
      /**
       * Letter Spacing
       * @see https://tailwindcss.com/docs/letter-spacing
       */
      tracking: [{
        tracking: ['tighter', 'tight', 'normal', 'wide', 'wider', 'widest', isArbitraryValue]
      }],
      /**
       * Line Clamp
       * @see https://tailwindcss.com/docs/line-clamp
       */
      'line-clamp': [{
        'line-clamp': ['none', isNumber, isArbitraryNumber]
      }],
      /**
       * Line Height
       * @see https://tailwindcss.com/docs/line-height
       */
      leading: [{
        leading: ['none', 'tight', 'snug', 'normal', 'relaxed', 'loose', isLength, isArbitraryValue]
      }],
      /**
       * List Style Image
       * @see https://tailwindcss.com/docs/list-style-image
       */
      'list-image': [{
        'list-image': ['none', isArbitraryValue]
      }],
      /**
       * List Style Type
       * @see https://tailwindcss.com/docs/list-style-type
       */
      'list-style-type': [{
        list: ['none', 'disc', 'decimal', isArbitraryValue]
      }],
      /**
       * List Style Position
       * @see https://tailwindcss.com/docs/list-style-position
       */
      'list-style-position': [{
        list: ['inside', 'outside']
      }],
      /**
       * Placeholder Color
       * @deprecated since Tailwind CSS v3.0.0
       * @see https://tailwindcss.com/docs/placeholder-color
       */
      'placeholder-color': [{
        placeholder: [colors]
      }],
      /**
       * Placeholder Opacity
       * @see https://tailwindcss.com/docs/placeholder-opacity
       */
      'placeholder-opacity': [{
        'placeholder-opacity': [opacity]
      }],
      /**
       * Text Alignment
       * @see https://tailwindcss.com/docs/text-align
       */
      'text-alignment': [{
        text: ['left', 'center', 'right', 'justify', 'start', 'end']
      }],
      /**
       * Text Color
       * @see https://tailwindcss.com/docs/text-color
       */
      'text-color': [{
        text: [colors]
      }],
      /**
       * Text Opacity
       * @see https://tailwindcss.com/docs/text-opacity
       */
      'text-opacity': [{
        'text-opacity': [opacity]
      }],
      /**
       * Text Decoration
       * @see https://tailwindcss.com/docs/text-decoration
       */
      'text-decoration': ['underline', 'overline', 'line-through', 'no-underline'],
      /**
       * Text Decoration Style
       * @see https://tailwindcss.com/docs/text-decoration-style
       */
      'text-decoration-style': [{
        decoration: [...getLineStyles(), 'wavy']
      }],
      /**
       * Text Decoration Thickness
       * @see https://tailwindcss.com/docs/text-decoration-thickness
       */
      'text-decoration-thickness': [{
        decoration: ['auto', 'from-font', isLength, isArbitraryLength]
      }],
      /**
       * Text Underline Offset
       * @see https://tailwindcss.com/docs/text-underline-offset
       */
      'underline-offset': [{
        'underline-offset': ['auto', isLength, isArbitraryValue]
      }],
      /**
       * Text Decoration Color
       * @see https://tailwindcss.com/docs/text-decoration-color
       */
      'text-decoration-color': [{
        decoration: [colors]
      }],
      /**
       * Text Transform
       * @see https://tailwindcss.com/docs/text-transform
       */
      'text-transform': ['uppercase', 'lowercase', 'capitalize', 'normal-case'],
      /**
       * Text Overflow
       * @see https://tailwindcss.com/docs/text-overflow
       */
      'text-overflow': ['truncate', 'text-ellipsis', 'text-clip'],
      /**
       * Text Wrap
       * @see https://tailwindcss.com/docs/text-wrap
       */
      'text-wrap': [{
        text: ['wrap', 'nowrap', 'balance', 'pretty']
      }],
      /**
       * Text Indent
       * @see https://tailwindcss.com/docs/text-indent
       */
      indent: [{
        indent: getSpacingWithArbitrary()
      }],
      /**
       * Vertical Alignment
       * @see https://tailwindcss.com/docs/vertical-align
       */
      'vertical-align': [{
        align: ['baseline', 'top', 'middle', 'bottom', 'text-top', 'text-bottom', 'sub', 'super', isArbitraryValue]
      }],
      /**
       * Whitespace
       * @see https://tailwindcss.com/docs/whitespace
       */
      whitespace: [{
        whitespace: ['normal', 'nowrap', 'pre', 'pre-line', 'pre-wrap', 'break-spaces']
      }],
      /**
       * Word Break
       * @see https://tailwindcss.com/docs/word-break
       */
      break: [{
        break: ['normal', 'words', 'all', 'keep']
      }],
      /**
       * Hyphens
       * @see https://tailwindcss.com/docs/hyphens
       */
      hyphens: [{
        hyphens: ['none', 'manual', 'auto']
      }],
      /**
       * Content
       * @see https://tailwindcss.com/docs/content
       */
      content: [{
        content: ['none', isArbitraryValue]
      }],
      // Backgrounds
      /**
       * Background Attachment
       * @see https://tailwindcss.com/docs/background-attachment
       */
      'bg-attachment': [{
        bg: ['fixed', 'local', 'scroll']
      }],
      /**
       * Background Clip
       * @see https://tailwindcss.com/docs/background-clip
       */
      'bg-clip': [{
        'bg-clip': ['border', 'padding', 'content', 'text']
      }],
      /**
       * Background Opacity
       * @deprecated since Tailwind CSS v3.0.0
       * @see https://tailwindcss.com/docs/background-opacity
       */
      'bg-opacity': [{
        'bg-opacity': [opacity]
      }],
      /**
       * Background Origin
       * @see https://tailwindcss.com/docs/background-origin
       */
      'bg-origin': [{
        'bg-origin': ['border', 'padding', 'content']
      }],
      /**
       * Background Position
       * @see https://tailwindcss.com/docs/background-position
       */
      'bg-position': [{
        bg: [...getPositions(), isArbitraryPosition]
      }],
      /**
       * Background Repeat
       * @see https://tailwindcss.com/docs/background-repeat
       */
      'bg-repeat': [{
        bg: ['no-repeat', {
          repeat: ['', 'x', 'y', 'round', 'space']
        }]
      }],
      /**
       * Background Size
       * @see https://tailwindcss.com/docs/background-size
       */
      'bg-size': [{
        bg: ['auto', 'cover', 'contain', isArbitrarySize]
      }],
      /**
       * Background Image
       * @see https://tailwindcss.com/docs/background-image
       */
      'bg-image': [{
        bg: ['none', {
          'gradient-to': ['t', 'tr', 'r', 'br', 'b', 'bl', 'l', 'tl']
        }, isArbitraryImage]
      }],
      /**
       * Background Color
       * @see https://tailwindcss.com/docs/background-color
       */
      'bg-color': [{
        bg: [colors]
      }],
      /**
       * Gradient Color Stops From Position
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      'gradient-from-pos': [{
        from: [gradientColorStopPositions]
      }],
      /**
       * Gradient Color Stops Via Position
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      'gradient-via-pos': [{
        via: [gradientColorStopPositions]
      }],
      /**
       * Gradient Color Stops To Position
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      'gradient-to-pos': [{
        to: [gradientColorStopPositions]
      }],
      /**
       * Gradient Color Stops From
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      'gradient-from': [{
        from: [gradientColorStops]
      }],
      /**
       * Gradient Color Stops Via
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      'gradient-via': [{
        via: [gradientColorStops]
      }],
      /**
       * Gradient Color Stops To
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      'gradient-to': [{
        to: [gradientColorStops]
      }],
      // Borders
      /**
       * Border Radius
       * @see https://tailwindcss.com/docs/border-radius
       */
      rounded: [{
        rounded: [borderRadius]
      }],
      /**
       * Border Radius Start
       * @see https://tailwindcss.com/docs/border-radius
       */
      'rounded-s': [{
        'rounded-s': [borderRadius]
      }],
      /**
       * Border Radius End
       * @see https://tailwindcss.com/docs/border-radius
       */
      'rounded-e': [{
        'rounded-e': [borderRadius]
      }],
      /**
       * Border Radius Top
       * @see https://tailwindcss.com/docs/border-radius
       */
      'rounded-t': [{
        'rounded-t': [borderRadius]
      }],
      /**
       * Border Radius Right
       * @see https://tailwindcss.com/docs/border-radius
       */
      'rounded-r': [{
        'rounded-r': [borderRadius]
      }],
      /**
       * Border Radius Bottom
       * @see https://tailwindcss.com/docs/border-radius
       */
      'rounded-b': [{
        'rounded-b': [borderRadius]
      }],
      /**
       * Border Radius Left
       * @see https://tailwindcss.com/docs/border-radius
       */
      'rounded-l': [{
        'rounded-l': [borderRadius]
      }],
      /**
       * Border Radius Start Start
       * @see https://tailwindcss.com/docs/border-radius
       */
      'rounded-ss': [{
        'rounded-ss': [borderRadius]
      }],
      /**
       * Border Radius Start End
       * @see https://tailwindcss.com/docs/border-radius
       */
      'rounded-se': [{
        'rounded-se': [borderRadius]
      }],
      /**
       * Border Radius End End
       * @see https://tailwindcss.com/docs/border-radius
       */
      'rounded-ee': [{
        'rounded-ee': [borderRadius]
      }],
      /**
       * Border Radius End Start
       * @see https://tailwindcss.com/docs/border-radius
       */
      'rounded-es': [{
        'rounded-es': [borderRadius]
      }],
      /**
       * Border Radius Top Left
       * @see https://tailwindcss.com/docs/border-radius
       */
      'rounded-tl': [{
        'rounded-tl': [borderRadius]
      }],
      /**
       * Border Radius Top Right
       * @see https://tailwindcss.com/docs/border-radius
       */
      'rounded-tr': [{
        'rounded-tr': [borderRadius]
      }],
      /**
       * Border Radius Bottom Right
       * @see https://tailwindcss.com/docs/border-radius
       */
      'rounded-br': [{
        'rounded-br': [borderRadius]
      }],
      /**
       * Border Radius Bottom Left
       * @see https://tailwindcss.com/docs/border-radius
       */
      'rounded-bl': [{
        'rounded-bl': [borderRadius]
      }],
      /**
       * Border Width
       * @see https://tailwindcss.com/docs/border-width
       */
      'border-w': [{
        border: [borderWidth]
      }],
      /**
       * Border Width X
       * @see https://tailwindcss.com/docs/border-width
       */
      'border-w-x': [{
        'border-x': [borderWidth]
      }],
      /**
       * Border Width Y
       * @see https://tailwindcss.com/docs/border-width
       */
      'border-w-y': [{
        'border-y': [borderWidth]
      }],
      /**
       * Border Width Start
       * @see https://tailwindcss.com/docs/border-width
       */
      'border-w-s': [{
        'border-s': [borderWidth]
      }],
      /**
       * Border Width End
       * @see https://tailwindcss.com/docs/border-width
       */
      'border-w-e': [{
        'border-e': [borderWidth]
      }],
      /**
       * Border Width Top
       * @see https://tailwindcss.com/docs/border-width
       */
      'border-w-t': [{
        'border-t': [borderWidth]
      }],
      /**
       * Border Width Right
       * @see https://tailwindcss.com/docs/border-width
       */
      'border-w-r': [{
        'border-r': [borderWidth]
      }],
      /**
       * Border Width Bottom
       * @see https://tailwindcss.com/docs/border-width
       */
      'border-w-b': [{
        'border-b': [borderWidth]
      }],
      /**
       * Border Width Left
       * @see https://tailwindcss.com/docs/border-width
       */
      'border-w-l': [{
        'border-l': [borderWidth]
      }],
      /**
       * Border Opacity
       * @see https://tailwindcss.com/docs/border-opacity
       */
      'border-opacity': [{
        'border-opacity': [opacity]
      }],
      /**
       * Border Style
       * @see https://tailwindcss.com/docs/border-style
       */
      'border-style': [{
        border: [...getLineStyles(), 'hidden']
      }],
      /**
       * Divide Width X
       * @see https://tailwindcss.com/docs/divide-width
       */
      'divide-x': [{
        'divide-x': [borderWidth]
      }],
      /**
       * Divide Width X Reverse
       * @see https://tailwindcss.com/docs/divide-width
       */
      'divide-x-reverse': ['divide-x-reverse'],
      /**
       * Divide Width Y
       * @see https://tailwindcss.com/docs/divide-width
       */
      'divide-y': [{
        'divide-y': [borderWidth]
      }],
      /**
       * Divide Width Y Reverse
       * @see https://tailwindcss.com/docs/divide-width
       */
      'divide-y-reverse': ['divide-y-reverse'],
      /**
       * Divide Opacity
       * @see https://tailwindcss.com/docs/divide-opacity
       */
      'divide-opacity': [{
        'divide-opacity': [opacity]
      }],
      /**
       * Divide Style
       * @see https://tailwindcss.com/docs/divide-style
       */
      'divide-style': [{
        divide: getLineStyles()
      }],
      /**
       * Border Color
       * @see https://tailwindcss.com/docs/border-color
       */
      'border-color': [{
        border: [borderColor]
      }],
      /**
       * Border Color X
       * @see https://tailwindcss.com/docs/border-color
       */
      'border-color-x': [{
        'border-x': [borderColor]
      }],
      /**
       * Border Color Y
       * @see https://tailwindcss.com/docs/border-color
       */
      'border-color-y': [{
        'border-y': [borderColor]
      }],
      /**
       * Border Color Top
       * @see https://tailwindcss.com/docs/border-color
       */
      'border-color-t': [{
        'border-t': [borderColor]
      }],
      /**
       * Border Color Right
       * @see https://tailwindcss.com/docs/border-color
       */
      'border-color-r': [{
        'border-r': [borderColor]
      }],
      /**
       * Border Color Bottom
       * @see https://tailwindcss.com/docs/border-color
       */
      'border-color-b': [{
        'border-b': [borderColor]
      }],
      /**
       * Border Color Left
       * @see https://tailwindcss.com/docs/border-color
       */
      'border-color-l': [{
        'border-l': [borderColor]
      }],
      /**
       * Divide Color
       * @see https://tailwindcss.com/docs/divide-color
       */
      'divide-color': [{
        divide: [borderColor]
      }],
      /**
       * Outline Style
       * @see https://tailwindcss.com/docs/outline-style
       */
      'outline-style': [{
        outline: ['', ...getLineStyles()]
      }],
      /**
       * Outline Offset
       * @see https://tailwindcss.com/docs/outline-offset
       */
      'outline-offset': [{
        'outline-offset': [isLength, isArbitraryValue]
      }],
      /**
       * Outline Width
       * @see https://tailwindcss.com/docs/outline-width
       */
      'outline-w': [{
        outline: [isLength, isArbitraryLength]
      }],
      /**
       * Outline Color
       * @see https://tailwindcss.com/docs/outline-color
       */
      'outline-color': [{
        outline: [colors]
      }],
      /**
       * Ring Width
       * @see https://tailwindcss.com/docs/ring-width
       */
      'ring-w': [{
        ring: getLengthWithEmptyAndArbitrary()
      }],
      /**
       * Ring Width Inset
       * @see https://tailwindcss.com/docs/ring-width
       */
      'ring-w-inset': ['ring-inset'],
      /**
       * Ring Color
       * @see https://tailwindcss.com/docs/ring-color
       */
      'ring-color': [{
        ring: [colors]
      }],
      /**
       * Ring Opacity
       * @see https://tailwindcss.com/docs/ring-opacity
       */
      'ring-opacity': [{
        'ring-opacity': [opacity]
      }],
      /**
       * Ring Offset Width
       * @see https://tailwindcss.com/docs/ring-offset-width
       */
      'ring-offset-w': [{
        'ring-offset': [isLength, isArbitraryLength]
      }],
      /**
       * Ring Offset Color
       * @see https://tailwindcss.com/docs/ring-offset-color
       */
      'ring-offset-color': [{
        'ring-offset': [colors]
      }],
      // Effects
      /**
       * Box Shadow
       * @see https://tailwindcss.com/docs/box-shadow
       */
      shadow: [{
        shadow: ['', 'inner', 'none', isTshirtSize, isArbitraryShadow]
      }],
      /**
       * Box Shadow Color
       * @see https://tailwindcss.com/docs/box-shadow-color
       */
      'shadow-color': [{
        shadow: [isAny]
      }],
      /**
       * Opacity
       * @see https://tailwindcss.com/docs/opacity
       */
      opacity: [{
        opacity: [opacity]
      }],
      /**
       * Mix Blend Mode
       * @see https://tailwindcss.com/docs/mix-blend-mode
       */
      'mix-blend': [{
        'mix-blend': getBlendModes()
      }],
      /**
       * Background Blend Mode
       * @see https://tailwindcss.com/docs/background-blend-mode
       */
      'bg-blend': [{
        'bg-blend': getBlendModes()
      }],
      // Filters
      /**
       * Filter
       * @deprecated since Tailwind CSS v3.0.0
       * @see https://tailwindcss.com/docs/filter
       */
      filter: [{
        filter: ['', 'none']
      }],
      /**
       * Blur
       * @see https://tailwindcss.com/docs/blur
       */
      blur: [{
        blur: [blur]
      }],
      /**
       * Brightness
       * @see https://tailwindcss.com/docs/brightness
       */
      brightness: [{
        brightness: [brightness]
      }],
      /**
       * Contrast
       * @see https://tailwindcss.com/docs/contrast
       */
      contrast: [{
        contrast: [contrast]
      }],
      /**
       * Drop Shadow
       * @see https://tailwindcss.com/docs/drop-shadow
       */
      'drop-shadow': [{
        'drop-shadow': ['', 'none', isTshirtSize, isArbitraryValue]
      }],
      /**
       * Grayscale
       * @see https://tailwindcss.com/docs/grayscale
       */
      grayscale: [{
        grayscale: [grayscale]
      }],
      /**
       * Hue Rotate
       * @see https://tailwindcss.com/docs/hue-rotate
       */
      'hue-rotate': [{
        'hue-rotate': [hueRotate]
      }],
      /**
       * Invert
       * @see https://tailwindcss.com/docs/invert
       */
      invert: [{
        invert: [invert]
      }],
      /**
       * Saturate
       * @see https://tailwindcss.com/docs/saturate
       */
      saturate: [{
        saturate: [saturate]
      }],
      /**
       * Sepia
       * @see https://tailwindcss.com/docs/sepia
       */
      sepia: [{
        sepia: [sepia]
      }],
      /**
       * Backdrop Filter
       * @deprecated since Tailwind CSS v3.0.0
       * @see https://tailwindcss.com/docs/backdrop-filter
       */
      'backdrop-filter': [{
        'backdrop-filter': ['', 'none']
      }],
      /**
       * Backdrop Blur
       * @see https://tailwindcss.com/docs/backdrop-blur
       */
      'backdrop-blur': [{
        'backdrop-blur': [blur]
      }],
      /**
       * Backdrop Brightness
       * @see https://tailwindcss.com/docs/backdrop-brightness
       */
      'backdrop-brightness': [{
        'backdrop-brightness': [brightness]
      }],
      /**
       * Backdrop Contrast
       * @see https://tailwindcss.com/docs/backdrop-contrast
       */
      'backdrop-contrast': [{
        'backdrop-contrast': [contrast]
      }],
      /**
       * Backdrop Grayscale
       * @see https://tailwindcss.com/docs/backdrop-grayscale
       */
      'backdrop-grayscale': [{
        'backdrop-grayscale': [grayscale]
      }],
      /**
       * Backdrop Hue Rotate
       * @see https://tailwindcss.com/docs/backdrop-hue-rotate
       */
      'backdrop-hue-rotate': [{
        'backdrop-hue-rotate': [hueRotate]
      }],
      /**
       * Backdrop Invert
       * @see https://tailwindcss.com/docs/backdrop-invert
       */
      'backdrop-invert': [{
        'backdrop-invert': [invert]
      }],
      /**
       * Backdrop Opacity
       * @see https://tailwindcss.com/docs/backdrop-opacity
       */
      'backdrop-opacity': [{
        'backdrop-opacity': [opacity]
      }],
      /**
       * Backdrop Saturate
       * @see https://tailwindcss.com/docs/backdrop-saturate
       */
      'backdrop-saturate': [{
        'backdrop-saturate': [saturate]
      }],
      /**
       * Backdrop Sepia
       * @see https://tailwindcss.com/docs/backdrop-sepia
       */
      'backdrop-sepia': [{
        'backdrop-sepia': [sepia]
      }],
      // Tables
      /**
       * Border Collapse
       * @see https://tailwindcss.com/docs/border-collapse
       */
      'border-collapse': [{
        border: ['collapse', 'separate']
      }],
      /**
       * Border Spacing
       * @see https://tailwindcss.com/docs/border-spacing
       */
      'border-spacing': [{
        'border-spacing': [borderSpacing]
      }],
      /**
       * Border Spacing X
       * @see https://tailwindcss.com/docs/border-spacing
       */
      'border-spacing-x': [{
        'border-spacing-x': [borderSpacing]
      }],
      /**
       * Border Spacing Y
       * @see https://tailwindcss.com/docs/border-spacing
       */
      'border-spacing-y': [{
        'border-spacing-y': [borderSpacing]
      }],
      /**
       * Table Layout
       * @see https://tailwindcss.com/docs/table-layout
       */
      'table-layout': [{
        table: ['auto', 'fixed']
      }],
      /**
       * Caption Side
       * @see https://tailwindcss.com/docs/caption-side
       */
      caption: [{
        caption: ['top', 'bottom']
      }],
      // Transitions and Animation
      /**
       * Tranisition Property
       * @see https://tailwindcss.com/docs/transition-property
       */
      transition: [{
        transition: ['none', 'all', '', 'colors', 'opacity', 'shadow', 'transform', isArbitraryValue]
      }],
      /**
       * Transition Duration
       * @see https://tailwindcss.com/docs/transition-duration
       */
      duration: [{
        duration: getNumberAndArbitrary()
      }],
      /**
       * Transition Timing Function
       * @see https://tailwindcss.com/docs/transition-timing-function
       */
      ease: [{
        ease: ['linear', 'in', 'out', 'in-out', isArbitraryValue]
      }],
      /**
       * Transition Delay
       * @see https://tailwindcss.com/docs/transition-delay
       */
      delay: [{
        delay: getNumberAndArbitrary()
      }],
      /**
       * Animation
       * @see https://tailwindcss.com/docs/animation
       */
      animate: [{
        animate: ['none', 'spin', 'ping', 'pulse', 'bounce', isArbitraryValue]
      }],
      // Transforms
      /**
       * Transform
       * @see https://tailwindcss.com/docs/transform
       */
      transform: [{
        transform: ['', 'gpu', 'none']
      }],
      /**
       * Scale
       * @see https://tailwindcss.com/docs/scale
       */
      scale: [{
        scale: [scale]
      }],
      /**
       * Scale X
       * @see https://tailwindcss.com/docs/scale
       */
      'scale-x': [{
        'scale-x': [scale]
      }],
      /**
       * Scale Y
       * @see https://tailwindcss.com/docs/scale
       */
      'scale-y': [{
        'scale-y': [scale]
      }],
      /**
       * Rotate
       * @see https://tailwindcss.com/docs/rotate
       */
      rotate: [{
        rotate: [isInteger, isArbitraryValue]
      }],
      /**
       * Translate X
       * @see https://tailwindcss.com/docs/translate
       */
      'translate-x': [{
        'translate-x': [translate]
      }],
      /**
       * Translate Y
       * @see https://tailwindcss.com/docs/translate
       */
      'translate-y': [{
        'translate-y': [translate]
      }],
      /**
       * Skew X
       * @see https://tailwindcss.com/docs/skew
       */
      'skew-x': [{
        'skew-x': [skew]
      }],
      /**
       * Skew Y
       * @see https://tailwindcss.com/docs/skew
       */
      'skew-y': [{
        'skew-y': [skew]
      }],
      /**
       * Transform Origin
       * @see https://tailwindcss.com/docs/transform-origin
       */
      'transform-origin': [{
        origin: ['center', 'top', 'top-right', 'right', 'bottom-right', 'bottom', 'bottom-left', 'left', 'top-left', isArbitraryValue]
      }],
      // Interactivity
      /**
       * Accent Color
       * @see https://tailwindcss.com/docs/accent-color
       */
      accent: [{
        accent: ['auto', colors]
      }],
      /**
       * Appearance
       * @see https://tailwindcss.com/docs/appearance
       */
      appearance: [{
        appearance: ['none', 'auto']
      }],
      /**
       * Cursor
       * @see https://tailwindcss.com/docs/cursor
       */
      cursor: [{
        cursor: ['auto', 'default', 'pointer', 'wait', 'text', 'move', 'help', 'not-allowed', 'none', 'context-menu', 'progress', 'cell', 'crosshair', 'vertical-text', 'alias', 'copy', 'no-drop', 'grab', 'grabbing', 'all-scroll', 'col-resize', 'row-resize', 'n-resize', 'e-resize', 's-resize', 'w-resize', 'ne-resize', 'nw-resize', 'se-resize', 'sw-resize', 'ew-resize', 'ns-resize', 'nesw-resize', 'nwse-resize', 'zoom-in', 'zoom-out', isArbitraryValue]
      }],
      /**
       * Caret Color
       * @see https://tailwindcss.com/docs/just-in-time-mode#caret-color-utilities
       */
      'caret-color': [{
        caret: [colors]
      }],
      /**
       * Pointer Events
       * @see https://tailwindcss.com/docs/pointer-events
       */
      'pointer-events': [{
        'pointer-events': ['none', 'auto']
      }],
      /**
       * Resize
       * @see https://tailwindcss.com/docs/resize
       */
      resize: [{
        resize: ['none', 'y', 'x', '']
      }],
      /**
       * Scroll Behavior
       * @see https://tailwindcss.com/docs/scroll-behavior
       */
      'scroll-behavior': [{
        scroll: ['auto', 'smooth']
      }],
      /**
       * Scroll Margin
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      'scroll-m': [{
        'scroll-m': getSpacingWithArbitrary()
      }],
      /**
       * Scroll Margin X
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      'scroll-mx': [{
        'scroll-mx': getSpacingWithArbitrary()
      }],
      /**
       * Scroll Margin Y
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      'scroll-my': [{
        'scroll-my': getSpacingWithArbitrary()
      }],
      /**
       * Scroll Margin Start
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      'scroll-ms': [{
        'scroll-ms': getSpacingWithArbitrary()
      }],
      /**
       * Scroll Margin End
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      'scroll-me': [{
        'scroll-me': getSpacingWithArbitrary()
      }],
      /**
       * Scroll Margin Top
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      'scroll-mt': [{
        'scroll-mt': getSpacingWithArbitrary()
      }],
      /**
       * Scroll Margin Right
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      'scroll-mr': [{
        'scroll-mr': getSpacingWithArbitrary()
      }],
      /**
       * Scroll Margin Bottom
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      'scroll-mb': [{
        'scroll-mb': getSpacingWithArbitrary()
      }],
      /**
       * Scroll Margin Left
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      'scroll-ml': [{
        'scroll-ml': getSpacingWithArbitrary()
      }],
      /**
       * Scroll Padding
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      'scroll-p': [{
        'scroll-p': getSpacingWithArbitrary()
      }],
      /**
       * Scroll Padding X
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      'scroll-px': [{
        'scroll-px': getSpacingWithArbitrary()
      }],
      /**
       * Scroll Padding Y
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      'scroll-py': [{
        'scroll-py': getSpacingWithArbitrary()
      }],
      /**
       * Scroll Padding Start
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      'scroll-ps': [{
        'scroll-ps': getSpacingWithArbitrary()
      }],
      /**
       * Scroll Padding End
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      'scroll-pe': [{
        'scroll-pe': getSpacingWithArbitrary()
      }],
      /**
       * Scroll Padding Top
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      'scroll-pt': [{
        'scroll-pt': getSpacingWithArbitrary()
      }],
      /**
       * Scroll Padding Right
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      'scroll-pr': [{
        'scroll-pr': getSpacingWithArbitrary()
      }],
      /**
       * Scroll Padding Bottom
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      'scroll-pb': [{
        'scroll-pb': getSpacingWithArbitrary()
      }],
      /**
       * Scroll Padding Left
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      'scroll-pl': [{
        'scroll-pl': getSpacingWithArbitrary()
      }],
      /**
       * Scroll Snap Align
       * @see https://tailwindcss.com/docs/scroll-snap-align
       */
      'snap-align': [{
        snap: ['start', 'end', 'center', 'align-none']
      }],
      /**
       * Scroll Snap Stop
       * @see https://tailwindcss.com/docs/scroll-snap-stop
       */
      'snap-stop': [{
        snap: ['normal', 'always']
      }],
      /**
       * Scroll Snap Type
       * @see https://tailwindcss.com/docs/scroll-snap-type
       */
      'snap-type': [{
        snap: ['none', 'x', 'y', 'both']
      }],
      /**
       * Scroll Snap Type Strictness
       * @see https://tailwindcss.com/docs/scroll-snap-type
       */
      'snap-strictness': [{
        snap: ['mandatory', 'proximity']
      }],
      /**
       * Touch Action
       * @see https://tailwindcss.com/docs/touch-action
       */
      touch: [{
        touch: ['auto', 'none', 'manipulation']
      }],
      /**
       * Touch Action X
       * @see https://tailwindcss.com/docs/touch-action
       */
      'touch-x': [{
        'touch-pan': ['x', 'left', 'right']
      }],
      /**
       * Touch Action Y
       * @see https://tailwindcss.com/docs/touch-action
       */
      'touch-y': [{
        'touch-pan': ['y', 'up', 'down']
      }],
      /**
       * Touch Action Pinch Zoom
       * @see https://tailwindcss.com/docs/touch-action
       */
      'touch-pz': ['touch-pinch-zoom'],
      /**
       * User Select
       * @see https://tailwindcss.com/docs/user-select
       */
      select: [{
        select: ['none', 'text', 'all', 'auto']
      }],
      /**
       * Will Change
       * @see https://tailwindcss.com/docs/will-change
       */
      'will-change': [{
        'will-change': ['auto', 'scroll', 'contents', 'transform', isArbitraryValue]
      }],
      // SVG
      /**
       * Fill
       * @see https://tailwindcss.com/docs/fill
       */
      fill: [{
        fill: [colors, 'none']
      }],
      /**
       * Stroke Width
       * @see https://tailwindcss.com/docs/stroke-width
       */
      'stroke-w': [{
        stroke: [isLength, isArbitraryLength, isArbitraryNumber]
      }],
      /**
       * Stroke
       * @see https://tailwindcss.com/docs/stroke
       */
      stroke: [{
        stroke: [colors, 'none']
      }],
      // Accessibility
      /**
       * Screen Readers
       * @see https://tailwindcss.com/docs/screen-readers
       */
      sr: ['sr-only', 'not-sr-only'],
      /**
       * Forced Color Adjust
       * @see https://tailwindcss.com/docs/forced-color-adjust
       */
      'forced-color-adjust': [{
        'forced-color-adjust': ['auto', 'none']
      }]
    },
    conflictingClassGroups: {
      overflow: ['overflow-x', 'overflow-y'],
      overscroll: ['overscroll-x', 'overscroll-y'],
      inset: ['inset-x', 'inset-y', 'start', 'end', 'top', 'right', 'bottom', 'left'],
      'inset-x': ['right', 'left'],
      'inset-y': ['top', 'bottom'],
      flex: ['basis', 'grow', 'shrink'],
      gap: ['gap-x', 'gap-y'],
      p: ['px', 'py', 'ps', 'pe', 'pt', 'pr', 'pb', 'pl'],
      px: ['pr', 'pl'],
      py: ['pt', 'pb'],
      m: ['mx', 'my', 'ms', 'me', 'mt', 'mr', 'mb', 'ml'],
      mx: ['mr', 'ml'],
      my: ['mt', 'mb'],
      size: ['w', 'h'],
      'font-size': ['leading'],
      'fvn-normal': ['fvn-ordinal', 'fvn-slashed-zero', 'fvn-figure', 'fvn-spacing', 'fvn-fraction'],
      'fvn-ordinal': ['fvn-normal'],
      'fvn-slashed-zero': ['fvn-normal'],
      'fvn-figure': ['fvn-normal'],
      'fvn-spacing': ['fvn-normal'],
      'fvn-fraction': ['fvn-normal'],
      'line-clamp': ['display', 'overflow'],
      rounded: ['rounded-s', 'rounded-e', 'rounded-t', 'rounded-r', 'rounded-b', 'rounded-l', 'rounded-ss', 'rounded-se', 'rounded-ee', 'rounded-es', 'rounded-tl', 'rounded-tr', 'rounded-br', 'rounded-bl'],
      'rounded-s': ['rounded-ss', 'rounded-es'],
      'rounded-e': ['rounded-se', 'rounded-ee'],
      'rounded-t': ['rounded-tl', 'rounded-tr'],
      'rounded-r': ['rounded-tr', 'rounded-br'],
      'rounded-b': ['rounded-br', 'rounded-bl'],
      'rounded-l': ['rounded-tl', 'rounded-bl'],
      'border-spacing': ['border-spacing-x', 'border-spacing-y'],
      'border-w': ['border-w-s', 'border-w-e', 'border-w-t', 'border-w-r', 'border-w-b', 'border-w-l'],
      'border-w-x': ['border-w-r', 'border-w-l'],
      'border-w-y': ['border-w-t', 'border-w-b'],
      'border-color': ['border-color-t', 'border-color-r', 'border-color-b', 'border-color-l'],
      'border-color-x': ['border-color-r', 'border-color-l'],
      'border-color-y': ['border-color-t', 'border-color-b'],
      'scroll-m': ['scroll-mx', 'scroll-my', 'scroll-ms', 'scroll-me', 'scroll-mt', 'scroll-mr', 'scroll-mb', 'scroll-ml'],
      'scroll-mx': ['scroll-mr', 'scroll-ml'],
      'scroll-my': ['scroll-mt', 'scroll-mb'],
      'scroll-p': ['scroll-px', 'scroll-py', 'scroll-ps', 'scroll-pe', 'scroll-pt', 'scroll-pr', 'scroll-pb', 'scroll-pl'],
      'scroll-px': ['scroll-pr', 'scroll-pl'],
      'scroll-py': ['scroll-pt', 'scroll-pb'],
      touch: ['touch-x', 'touch-y', 'touch-pz'],
      'touch-x': ['touch'],
      'touch-y': ['touch'],
      'touch-pz': ['touch']
    },
    conflictingClassGroupModifiers: {
      'font-size': ['leading']
    }
  };
}

/**
 * @param baseConfig Config where other config will be merged into. This object will be mutated.
 * @param configExtension Partial config to merge into the `baseConfig`.
 */
function mergeConfigs(baseConfig, {
  cacheSize,
  prefix,
  separator,
  extend = {},
  override = {}
}) {
  overrideProperty(baseConfig, 'cacheSize', cacheSize);
  overrideProperty(baseConfig, 'prefix', prefix);
  overrideProperty(baseConfig, 'separator', separator);
  for (const configKey in override) {
    overrideConfigProperties(baseConfig[configKey], override[configKey]);
  }
  for (const key in extend) {
    mergeConfigProperties(baseConfig[key], extend[key]);
  }
  return baseConfig;
}
function overrideProperty(baseObject, overrideKey, overrideValue) {
  if (overrideValue !== undefined) {
    baseObject[overrideKey] = overrideValue;
  }
}
function overrideConfigProperties(baseObject, overrideObject) {
  if (overrideObject) {
    for (const key in overrideObject) {
      overrideProperty(baseObject, key, overrideObject[key]);
    }
  }
}
function mergeConfigProperties(baseObject, mergeObject) {
  if (mergeObject) {
    for (const key in mergeObject) {
      const mergeValue = mergeObject[key];
      if (mergeValue !== undefined) {
        baseObject[key] = (baseObject[key] || []).concat(mergeValue);
      }
    }
  }
}
function extendTailwindMerge(configExtension, ...createConfig) {
  return typeof configExtension === 'function' ? createTailwindMerge(getDefaultConfig, configExtension, ...createConfig) : createTailwindMerge(() => mergeConfigs(getDefaultConfig(), configExtension), ...createConfig);
}
const twMerge = /*#__PURE__*/createTailwindMerge(getDefaultConfig);

//# sourceMappingURL=bundle-mjs.mjs.map

;// CONCATENATED MODULE: ./app/lib/utils.ts


function cn() {
    for(var _len = arguments.length, inputs = new Array(_len), _key = 0; _key < _len; _key++){
        inputs[_key] = arguments[_key];
    }
    return twMerge((0,clsx/* clsx */.W)(inputs));
}
function utils_isNumber(value) {
    return typeof value === "number" && isFinite(value);
}
const removeNullKeyObject = (obj)=>{
    const newObj = {};
    for(const key in obj){
        if (obj.hasOwnProperty(key) && obj[key] !== undefined && obj[key] !== null && obj[key] !== "") {
            newObj[key] = obj[key];
        }
    }
    return newObj;
};
function compareValues(key) {
    let order = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "asc";
    return function(a, b) {
        if (!a.hasOwnProperty(key) || !b.hasOwnProperty(key)) {
            // nếu không tồn tại
            return 0;
        }
        const varA = typeof a[key] === "string" ? a[key].toUpperCase() : a[key];
        const varB = typeof b[key] === "string" ? b[key].toUpperCase() : b[key];
        let comparison = 0;
        if (varA > varB) {
            comparison = 1;
        } else if (varA <= varB) {
            comparison = -1;
        }
        return order == "desc" ? comparison * -1 : comparison;
    };
}


/***/ }),

/***/ 95035:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "M2": function() { return /* binding */ useMutationJoinEvent; },
/* harmony export */   "Y_": function() { return /* binding */ useMutationDeleteEvent; },
/* harmony export */   "r0": function() { return /* binding */ useMutationRegNotificationEvent; }
/* harmony export */ });
/* harmony import */ var _tanstack_react_query__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(98029);
/* harmony import */ var _services_EventServices__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(89174);
/* harmony import */ var _app_configs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(54254);



const deleteEvent = async (id)=>{
    return _services_EventServices__WEBPACK_IMPORTED_MODULE_0__/* .EventService.deleteEvent */ .P.deleteEvent(id);
};
const joinEvent = (param)=>{
    let { id  } = param;
    return _services_EventServices__WEBPACK_IMPORTED_MODULE_0__/* .EventService.joinEvent */ .P.joinEvent(id);
};
const regNotificationEvent = (param)=>{
    let { id  } = param;
    return _services_EventServices__WEBPACK_IMPORTED_MODULE_0__/* .EventService.regNotificationEvent */ .P.regNotificationEvent(id);
};
const useMutationDeleteEvent = ()=>{
    return (0,_tanstack_react_query__WEBPACK_IMPORTED_MODULE_2__/* .useMutation */ .D)({
        mutationKey: [
            _app_configs__WEBPACK_IMPORTED_MODULE_1__/* .QUERY_KEY.DELETE_EVENT */ .lP.DELETE_EVENT
        ],
        mutationFn: deleteEvent
    });
};
const useMutationJoinEvent = ()=>{
    return (0,_tanstack_react_query__WEBPACK_IMPORTED_MODULE_2__/* .useMutation */ .D)({
        mutationKey: [
            _app_configs__WEBPACK_IMPORTED_MODULE_1__/* .QUERY_KEY.JOIN_EVENT */ .lP.JOIN_EVENT
        ],
        mutationFn: joinEvent
    });
};
const useMutationRegNotificationEvent = ()=>{
    return (0,_tanstack_react_query__WEBPACK_IMPORTED_MODULE_2__/* .useMutation */ .D)({
        mutationKey: [
            _app_configs__WEBPACK_IMPORTED_MODULE_1__/* .QUERY_KEY.REG_NOTIFICATION_EVENT */ .lP.REG_NOTIFICATION_EVENT
        ],
        mutationFn: regNotificationEvent
    });
};


/***/ }),

/***/ 82416:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "q": function() { return /* binding */ useQueryGetEventDetail; },
/* harmony export */   "w": function() { return /* binding */ useQueryGetEventDetailForEdit; }
/* harmony export */ });
/* harmony import */ var _tanstack_react_query__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(78551);
/* harmony import */ var _app_configs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(54254);
/* harmony import */ var _services_EventServices__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(89174);



const getEventDetail = async (id)=>{
    var _data_data;
    const data = await _services_EventServices__WEBPACK_IMPORTED_MODULE_1__/* .EventService.getEventDetail */ .P.getEventDetail(id);
    return data === null || data === void 0 ? void 0 : (_data_data = data.data) === null || _data_data === void 0 ? void 0 : _data_data.data;
};
const getEventDetailForEdit = async (id)=>{
    var _data_data;
    const data = await _services_EventServices__WEBPACK_IMPORTED_MODULE_1__/* .EventService.getEventDetailForEdit */ .P.getEventDetailForEdit(id);
    return data === null || data === void 0 ? void 0 : (_data_data = data.data) === null || _data_data === void 0 ? void 0 : _data_data.data;
};
const useQueryGetEventDetail = (id, type)=>{
    return (0,_tanstack_react_query__WEBPACK_IMPORTED_MODULE_2__/* .useQuery */ .a)({
        queryKey: [
            _app_configs__WEBPACK_IMPORTED_MODULE_0__/* .QUERY_KEY.EVENT_DETAIL */ .lP.EVENT_DETAIL,
            id
        ],
        queryFn: ()=>getEventDetail(id),
        enabled: !!id && id !== "undefined" && type === "event"
    });
};
const useQueryGetEventDetailForEdit = (id, type)=>{
    return (0,_tanstack_react_query__WEBPACK_IMPORTED_MODULE_2__/* .useQuery */ .a)({
        queryKey: [
            _app_configs__WEBPACK_IMPORTED_MODULE_0__/* .QUERY_KEY.EVENT_DETAIL_FOR_EDIT */ .lP.EVENT_DETAIL_FOR_EDIT,
            id
        ],
        queryFn: ()=>getEventDetailForEdit(id),
        enabled: !!id && id !== "undefined" && type === "event"
    });
};


/***/ }),

/***/ 54583:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Fu": function() { return /* reexport */ useQueryCheckDraftEvent; },
  "TP": function() { return /* reexport */ useQueryGetAllEventByHashtag; },
  "qd": function() { return /* reexport */ useQueryGetListRelatedEvent; }
});

// UNUSED EXPORTS: useQueryGetListEvent, useQueryGetListEventByType, useQueryGetListRelatedEventsByGame, useQueryGetMyEventByFilter, useQueryGetOtherEventByFilter

// EXTERNAL MODULE: ./node_modules/@tanstack/react-query/build/modern/useInfiniteQuery.js + 1 modules
var modern_useInfiniteQuery = __webpack_require__(29726);
// EXTERNAL MODULE: ./node_modules/@tanstack/react-query/build/modern/useQuery.js
var useQuery = __webpack_require__(78551);
// EXTERNAL MODULE: ./app/configs/index.ts + 3 modules
var configs = __webpack_require__(54254);
// EXTERNAL MODULE: ./app/services/services/EventServices.tsx
var EventServices = __webpack_require__(89174);
;// CONCATENATED MODULE: ./app/services/query-fn/event/list-event-query.ts



const getEventsFn = async (pageParam, keyword)=>{
    const data = await EventService.getAllEvent(pageParam, keyword);
    return data.data.data;
};
const checkDraftFn = async ()=>{
    var _res_data;
    const res = await EventServices/* EventService.checkDraft */.P.checkDraft();
    return res === null || res === void 0 ? void 0 : (_res_data = res.data) === null || _res_data === void 0 ? void 0 : _res_data.data;
};
const getListEventByTypeFn = async (params)=>{
    var _res_data;
    const res = await EventService.getListEventsByType(params);
    return res === null || res === void 0 ? void 0 : (_res_data = res.data) === null || _res_data === void 0 ? void 0 : _res_data.data;
};
const getRelatedEventByGame = async (params)=>{
    var _res_data;
    const res = await EventService.relatedEventByGame(params);
    return res === null || res === void 0 ? void 0 : (_res_data = res.data) === null || _res_data === void 0 ? void 0 : _res_data.data;
};
const getRelatedEvent = async (params)=>{
    var _res_data;
    const res = await EventServices/* EventService.relatedEvent */.P.relatedEvent(params);
    return res === null || res === void 0 ? void 0 : (_res_data = res.data) === null || _res_data === void 0 ? void 0 : _res_data.data;
};
const getMyEvent = async (param, pageParam)=>{
    var _res_data;
    const res = await EventService.getMyEvent(param, pageParam);
    return res === null || res === void 0 ? void 0 : (_res_data = res.data) === null || _res_data === void 0 ? void 0 : _res_data.data;
};
const getAllEventByHashtag = async (keyword, pageParam)=>{
    var _res_data;
    const res = await EventServices/* EventService.getAllEventByHashtag */.P.getAllEventByHashtag(keyword, pageParam);
    return res === null || res === void 0 ? void 0 : (_res_data = res.data) === null || _res_data === void 0 ? void 0 : _res_data.data;
};
const getOtherUserEvent = async (param, pageParam)=>{
    var _res_data;
    const res = await EventService.getOtherUserEvent(param, pageParam);
    return res === null || res === void 0 ? void 0 : (_res_data = res.data) === null || _res_data === void 0 ? void 0 : _res_data.data;
};
const useQueryGetAllEventByHashtag = (keyword, enabled)=>{
    return (0,modern_useInfiniteQuery/* useInfiniteQuery */.N)({
        queryKey: [
            configs/* QUERY_KEY.LIST_EVENT_BY_HASHTAG */.lP.LIST_EVENT_BY_HASHTAG,
            keyword
        ],
        queryFn: (param)=>{
            let { pageParam  } = param;
            return getAllEventByHashtag(keyword, pageParam);
        },
        initialPageParam: 1,
        getNextPageParam: (lastPage, pages)=>{
            return (lastPage === null || lastPage === void 0 ? void 0 : lastPage.length) > 9 ? (pages === null || pages === void 0 ? void 0 : pages.length) + 1 : undefined;
        },
        enabled: !!keyword && !!enabled,
        refetchOnMount: "always"
    });
};
const useQueryGetMyEventByFilter = (param)=>{
    return useInfiniteQuery({
        queryKey: [
            QUERY_KEY.MY_EVENT_BY_FILTER,
            Object.values(param).join("-")
        ],
        queryFn: (param1)=>{
            let { pageParam  } = param1;
            return getMyEvent(param, pageParam);
        },
        initialPageParam: 1,
        getNextPageParam: (lastPage, pages)=>{
            return (lastPage === null || lastPage === void 0 ? void 0 : lastPage.length) > 9 ? (pages === null || pages === void 0 ? void 0 : pages.length) + 1 : undefined;
        },
        refetchOnMount: "always"
    });
};
const useQueryGetOtherEventByFilter = (param, enabled)=>{
    return useInfiniteQuery({
        queryKey: [
            QUERY_KEY.OTHER_USER_EVENT_BY_FILTER,
            Object.values(param).join("-")
        ],
        queryFn: (param1)=>{
            let { pageParam  } = param1;
            return getOtherUserEvent(param, pageParam);
        },
        initialPageParam: 1,
        getNextPageParam: (lastPage, pages)=>{
            return (lastPage === null || lastPage === void 0 ? void 0 : lastPage.length) > 9 ? (pages === null || pages === void 0 ? void 0 : pages.length) + 1 : undefined;
        },
        enabled: !!enabled,
        refetchOnMount: "always"
    });
};
const useQueryGetListRelatedEvent = (param)=>{
    let { id , limit , type  } = param;
    return (0,useQuery/* useQuery */.a)({
        queryKey: [
            configs/* QUERY_KEY.LIST_RELATED_EVENT */.lP.LIST_RELATED_EVENT,
            id
        ],
        queryFn: ()=>getRelatedEvent({
                pageParam: 1,
                id,
                limit
            }),
        enabled: !!id && id !== "undefined" && type !== "undefined" && type === "event",
        refetchOnMount: "always"
    });
};
const useQueryGetListEvent = (enabled, keyword)=>{
    return useInfiniteQuery({
        queryKey: [
            QUERY_KEY.LIST_EVENT,
            keyword
        ],
        queryFn: (param)=>{
            let { pageParam  } = param;
            return getEventsFn(pageParam, keyword);
        },
        initialPageParam: 1,
        getNextPageParam: (lastPage, pages)=>{
            return (lastPage === null || lastPage === void 0 ? void 0 : lastPage.length) > 9 ? (pages === null || pages === void 0 ? void 0 : pages.length) + 1 : undefined;
        },
        enabled: !!enabled,
        refetchOnMount: "always"
    });
};
const useQueryCheckDraftEvent = (type)=>{
    return (0,useQuery/* useQuery */.a)({
        queryKey: [
            configs/* QUERY_KEY.CHECK_DRAFT_EVENT */.lP.CHECK_DRAFT_EVENT
        ],
        queryFn: ()=>checkDraftFn(),
        enabled: !!type && type === String(configs/* CreateType.CREATE_EVENT */.q0.CREATE_EVENT)
    });
};
const useQueryGetListEventByType = (params, enabled)=>{
    return useInfiniteQuery({
        queryKey: [
            QUERY_KEY.LIST_EVENT_BY_TYPE,
            Object.values(params).join("_")
        ],
        queryFn: (param)=>{
            let { pageParam  } = param;
            return getListEventByTypeFn({
                ...params,
                page: pageParam
            });
        },
        initialPageParam: 1,
        getNextPageParam: (lastPage, pages)=>{
            return (lastPage === null || lastPage === void 0 ? void 0 : lastPage.length) > 9 ? (pages === null || pages === void 0 ? void 0 : pages.length) + 1 : undefined;
        },
        enabled: !!enabled,
        refetchOnMount: "always"
    });
};
const useQueryGetListRelatedEventsByGame = (param)=>{
    let { game_id , limit  } = param;
    return useInfiniteQuery({
        queryKey: [
            QUERY_KEY.LIST_RELATED_EVENT_BY_GAME,
            game_id
        ],
        queryFn: (param)=>{
            let { pageParam  } = param;
            return getRelatedEventByGame({
                pageParam: pageParam,
                game_id,
                limit
            });
        },
        initialPageParam: 1,
        getNextPageParam: (lastPage, pages)=>{
            return (lastPage === null || lastPage === void 0 ? void 0 : lastPage.length) > 9 ? (pages === null || pages === void 0 ? void 0 : pages.length) + 1 : undefined;
        },
        enabled: !!game_id && game_id !== "undefined",
        refetchOnMount: "always"
    });
};

;// CONCATENATED MODULE: ./app/services/query-fn/event/index.ts



/***/ }),

/***/ 84953:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Jv": function() { return /* binding */ useMutationDeleteReplyReview; },
/* harmony export */   "Ml": function() { return /* binding */ useMutationDeleteReview; },
/* harmony export */   "Y5": function() { return /* binding */ useMutationRegisterGame; },
/* harmony export */   "cM": function() { return /* binding */ useMutationRateGame; },
/* harmony export */   "dV": function() { return /* binding */ useMutationFollowGame; },
/* harmony export */   "qN": function() { return /* binding */ useMutationLikeReview; },
/* harmony export */   "t2": function() { return /* binding */ useMutationReplyReview; }
/* harmony export */ });
/* harmony import */ var _app_configs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(54254);
/* harmony import */ var _tanstack_react_query__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(30202);
/* harmony import */ var _tanstack_react_query__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(98029);
/* harmony import */ var _services_GameServices__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(54309);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(55784);
/* harmony import */ var _app_context__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(17986);






const followGameFn = (body)=>{
    return _services_GameServices__WEBPACK_IMPORTED_MODULE_1__/* .GameServices.followGame */ .o.followGame(body);
};
const registerGameFn = (body)=>{
    return _services_GameServices__WEBPACK_IMPORTED_MODULE_1__/* .GameServices.registerGame */ .o.registerGame(body);
};
const likeReviewFn = (body)=>{
    return _services_GameServices__WEBPACK_IMPORTED_MODULE_1__/* .GameServices.likeReviewGame */ .o.likeReviewGame(body);
};
const rateGameFn = (body)=>{
    return _services_GameServices__WEBPACK_IMPORTED_MODULE_1__/* .GameServices.rateGame */ .o.rateGame(body);
};
const replyReviewFn = (body)=>{
    return _services_GameServices__WEBPACK_IMPORTED_MODULE_1__/* .GameServices.replyReviewGame */ .o.replyReviewGame(body);
};
const deleteReplyReviewFn = (body)=>{
    return _services_GameServices__WEBPACK_IMPORTED_MODULE_1__/* .GameServices.deleteReplyReviewGame */ .o.deleteReplyReviewGame(body);
};
const deleteReviewFn = (body)=>{
    return _services_GameServices__WEBPACK_IMPORTED_MODULE_1__/* .GameServices.deleteReviewGame */ .o.deleteReviewGame(body);
};
const useMutationFollowGame = ()=>{
    const queryClient = (0,_tanstack_react_query__WEBPACK_IMPORTED_MODULE_5__/* .useQueryClient */ .NL)();
    const router = (0,next_router__WEBPACK_IMPORTED_MODULE_2__.useRouter)();
    return (0,_tanstack_react_query__WEBPACK_IMPORTED_MODULE_6__/* .useMutation */ .D)({
        mutationKey: [
            _app_configs__WEBPACK_IMPORTED_MODULE_0__/* .QUERY_KEY.FOLLOW_GAME */ .lP.FOLLOW_GAME
        ],
        mutationFn: followGameFn,
        onSuccess: (data, variables)=>{
            queryClient.invalidateQueries({
                queryKey: [
                    _app_configs__WEBPACK_IMPORTED_MODULE_0__/* .QUERY_KEY.LIST_GAME_FOLLOW */ .lP.LIST_GAME_FOLLOW
                ],
                refetchType: "active"
            });
            queryClient.setQueryData([
                _app_configs__WEBPACK_IMPORTED_MODULE_0__/* .QUERY_KEY.GAME_DETAIL */ .lP.GAME_DETAIL,
                {
                    game_id: router.query.id
                }
            ], (oldData)=>{
                return {
                    ...oldData,
                    followed: !oldData.followed
                };
            });
        }
    });
};
const useMutationRegisterGame = ()=>{
    const queryClient = (0,_tanstack_react_query__WEBPACK_IMPORTED_MODULE_5__/* .useQueryClient */ .NL)();
    const router = (0,next_router__WEBPACK_IMPORTED_MODULE_2__.useRouter)();
    return (0,_tanstack_react_query__WEBPACK_IMPORTED_MODULE_6__/* .useMutation */ .D)({
        mutationKey: [
            _app_configs__WEBPACK_IMPORTED_MODULE_0__/* .QUERY_KEY.REGISTER_GAME */ .lP.REGISTER_GAME
        ],
        mutationFn: registerGameFn,
        onSuccess: (data, variables)=>{
            queryClient.invalidateQueries({
                queryKey: [
                    _app_configs__WEBPACK_IMPORTED_MODULE_0__/* .QUERY_KEY.LIST_GAME_FOLLOW */ .lP.LIST_GAME_FOLLOW
                ],
                refetchType: "active"
            });
            queryClient.invalidateQueries({
                queryKey: [
                    _app_configs__WEBPACK_IMPORTED_MODULE_0__/* .QUERY_KEY.GAME_DETAIL */ .lP.GAME_DETAIL,
                    {
                        game_id: router.query.id
                    }
                ],
                refetchType: "active"
            });
        }
    });
};
const useMutationLikeReview = ()=>{
    const queryClient = (0,_tanstack_react_query__WEBPACK_IMPORTED_MODULE_5__/* .useQueryClient */ .NL)();
    return (0,_tanstack_react_query__WEBPACK_IMPORTED_MODULE_6__/* .useMutation */ .D)({
        mutationKey: [
            _app_configs__WEBPACK_IMPORTED_MODULE_0__/* .QUERY_KEY.LIKE_REVIEW */ .lP.LIKE_REVIEW
        ],
        mutationFn: likeReviewFn,
        onSuccess: (data, variables)=>{
            queryClient.setQueryData([
                _app_configs__WEBPACK_IMPORTED_MODULE_0__/* .QUERY_KEY.GAME_REVIEW_LIST */ .lP.GAME_REVIEW_LIST,
                {
                    game_id: variables.game_id
                }
            ], (oldData)=>{
                const updatedArray = oldData.pages.map((innerArray)=>{
                    // Duyệt qua các phần tử trong mảng con
                    return innerArray.map((item)=>{
                        // Kiểm tra xem item có ID trùng khớp với targetId hay không
                        if (item.review.id === variables.review_id) {
                            // Nếu trùng khớp, chỉnh sửa trạng thái liked
                            return {
                                ...item,
                                review: {
                                    ...item.review,
                                    liked: !item.review.liked,
                                    total_like: item.review.liked ? item.review.total_like - 1 : item.review.total_like + 1
                                }
                            };
                        }
                        // Nếu không trùng khớp, giữ nguyên item
                        return item;
                    });
                });
                return {
                    ...oldData,
                    pages: updatedArray
                };
            });
        }
    });
};
const useMutationDeleteReview = ()=>{
    const queryClient = (0,_tanstack_react_query__WEBPACK_IMPORTED_MODULE_5__/* .useQueryClient */ .NL)();
    const { userInfo  } = (0,react__WEBPACK_IMPORTED_MODULE_3__.useContext)(_app_context__WEBPACK_IMPORTED_MODULE_4__/* .AppContext */ .Il);
    return (0,_tanstack_react_query__WEBPACK_IMPORTED_MODULE_6__/* .useMutation */ .D)({
        mutationKey: [
            _app_configs__WEBPACK_IMPORTED_MODULE_0__/* .QUERY_KEY.DELETE_REVIEW_GAME */ .lP.DELETE_REVIEW_GAME
        ],
        mutationFn: deleteReviewFn,
        onSuccess: (data, variables)=>{
            queryClient.setQueryData([
                _app_configs__WEBPACK_IMPORTED_MODULE_0__/* .QUERY_KEY.GAME_REVIEW_LIST */ .lP.GAME_REVIEW_LIST,
                {
                    game_id: variables.game_id
                }
            ], (oldData)=>{
                const updatedArray = oldData.pages.map((innerArray)=>{
                    // Duyệt qua các phần tử trong mảng con
                    return innerArray.filter((item)=>{
                        var _item_author;
                        return (item === null || item === void 0 ? void 0 : (_item_author = item.author) === null || _item_author === void 0 ? void 0 : _item_author.id) !== (userInfo === null || userInfo === void 0 ? void 0 : userInfo.userid);
                    });
                });
                return {
                    ...oldData,
                    pages: updatedArray
                };
            });
        }
    });
};
const useMutationReplyReview = ()=>{
    const queryClient = (0,_tanstack_react_query__WEBPACK_IMPORTED_MODULE_5__/* .useQueryClient */ .NL)();
    const { userInfo  } = (0,react__WEBPACK_IMPORTED_MODULE_3__.useContext)(_app_context__WEBPACK_IMPORTED_MODULE_4__/* .AppContext */ .Il);
    return (0,_tanstack_react_query__WEBPACK_IMPORTED_MODULE_6__/* .useMutation */ .D)({
        mutationKey: [
            _app_configs__WEBPACK_IMPORTED_MODULE_0__/* .QUERY_KEY.REPLY_REVIEW_GAME */ .lP.REPLY_REVIEW_GAME
        ],
        mutationFn: replyReviewFn,
        onSuccess: (data, variables)=>{
            queryClient.invalidateQueries({
                queryKey: [
                    _app_configs__WEBPACK_IMPORTED_MODULE_0__/* .QUERY_KEY.GAME_REVIEW_LIST */ .lP.GAME_REVIEW_LIST,
                    {
                        game_id: variables.game_id
                    }
                ],
                type: "active",
                exact: true
            });
        }
    });
};
const useMutationDeleteReplyReview = ()=>{
    const queryClient = (0,_tanstack_react_query__WEBPACK_IMPORTED_MODULE_5__/* .useQueryClient */ .NL)();
    return (0,_tanstack_react_query__WEBPACK_IMPORTED_MODULE_6__/* .useMutation */ .D)({
        mutationKey: [
            _app_configs__WEBPACK_IMPORTED_MODULE_0__/* .QUERY_KEY.DELETE_REPLY_REVIEW_GAME */ .lP.DELETE_REPLY_REVIEW_GAME
        ],
        mutationFn: deleteReplyReviewFn,
        onSuccess: (data, variables)=>{}
    });
};
const useMutationRateGame = ()=>{
    const queryClient = (0,_tanstack_react_query__WEBPACK_IMPORTED_MODULE_5__/* .useQueryClient */ .NL)();
    const router = (0,next_router__WEBPACK_IMPORTED_MODULE_2__.useRouter)();
    return (0,_tanstack_react_query__WEBPACK_IMPORTED_MODULE_6__/* .useMutation */ .D)({
        mutationKey: [
            _app_configs__WEBPACK_IMPORTED_MODULE_0__/* .QUERY_KEY.RATE_GAME */ .lP.RATE_GAME
        ],
        mutationFn: rateGameFn,
        onSuccess: (data, variables)=>{
            queryClient.invalidateQueries({
                queryKey: [
                    _app_configs__WEBPACK_IMPORTED_MODULE_0__/* .QUERY_KEY.GAME_DETAIL */ .lP.GAME_DETAIL,
                    {
                        game_id: router.query.id
                    }
                ]
            });
            queryClient.invalidateQueries({
                queryKey: [
                    _app_configs__WEBPACK_IMPORTED_MODULE_0__/* .QUERY_KEY.GAME_REVIEW_LIST */ .lP.GAME_REVIEW_LIST,
                    {
                        game_id: variables.game_id
                    }
                ],
                type: "active",
                exact: true
            });
        }
    });
};


/***/ }),

/***/ 88542:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Q5": function() { return /* binding */ useQueryGetListSuggestFriendByGame; },
/* harmony export */   "fc": function() { return /* binding */ useQueryGetListReviewGame; },
/* harmony export */   "gW": function() { return /* binding */ useQueryGetDetailGame; }
/* harmony export */ });
/* unused harmony export getGameReviewFn */
/* harmony import */ var _app_configs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(54254);
/* harmony import */ var _tanstack_react_query__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(29726);
/* harmony import */ var _tanstack_react_query__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(78551);
/* harmony import */ var _services_GameServices__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(54309);
/* harmony import */ var _services__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(27020);




const getGameDetailFn = async (params)=>{
    const data = await _services_GameServices__WEBPACK_IMPORTED_MODULE_1__/* .GameServices.getGameDetail */ .o.getGameDetail(params);
    return data.data.data;
};
const getGameReviewFn = async (params)=>{
    const data = await _services_GameServices__WEBPACK_IMPORTED_MODULE_1__/* .GameServices.getReviewByGame */ .o.getReviewByGame(params);
    return data.data.data;
};
const getListSuggestFriendByGame = async (game_id, pageParam)=>{
    var _data_data;
    const data = await _services__WEBPACK_IMPORTED_MODULE_2__/* .UserService.getListSuggestByGame */ .K.getListSuggestByGame(game_id, pageParam);
    return data === null || data === void 0 ? void 0 : (_data_data = data.data) === null || _data_data === void 0 ? void 0 : _data_data.data;
};
const useQueryGetListSuggestFriendByGame = (game_id)=>{
    return (0,_tanstack_react_query__WEBPACK_IMPORTED_MODULE_3__/* .useInfiniteQuery */ .N)({
        queryKey: [
            _app_configs__WEBPACK_IMPORTED_MODULE_0__/* .QUERY_KEY.LIST_SUGGEST_FRIEND_BY_GAME */ .lP.LIST_SUGGEST_FRIEND_BY_GAME,
            game_id
        ],
        queryFn: (param)=>{
            let { pageParam  } = param;
            return getListSuggestFriendByGame(game_id, pageParam);
        },
        initialPageParam: 1,
        getNextPageParam: (lastPage, pages)=>{
            return (lastPage === null || lastPage === void 0 ? void 0 : lastPage.length) > 9 ? (pages === null || pages === void 0 ? void 0 : pages.length) + 1 : undefined;
        },
        enabled: !!game_id
    });
};
const useQueryGetDetailGame = (params)=>{
    return (0,_tanstack_react_query__WEBPACK_IMPORTED_MODULE_4__/* .useQuery */ .a)({
        queryKey: [
            _app_configs__WEBPACK_IMPORTED_MODULE_0__/* .QUERY_KEY.GAME_DETAIL */ .lP.GAME_DETAIL,
            params
        ],
        queryFn: ()=>getGameDetailFn(params),
        enabled: !!params
    });
};
const useQueryGetListReviewGame = (game_id)=>{
    return (0,_tanstack_react_query__WEBPACK_IMPORTED_MODULE_3__/* .useInfiniteQuery */ .N)({
        queryKey: [
            _app_configs__WEBPACK_IMPORTED_MODULE_0__/* .QUERY_KEY.GAME_REVIEW_LIST */ .lP.GAME_REVIEW_LIST,
            {
                game_id: game_id
            }
        ],
        queryFn: (param)=>{
            let { pageParam  } = param;
            return getGameReviewFn({
                game_id: game_id,
                page: pageParam,
                limit: _app_configs__WEBPACK_IMPORTED_MODULE_0__/* .REPLY_LIMIT_SIZE */ .bn
            });
        },
        initialPageParam: 1,
        getNextPageParam: (lastPage, pages)=>{
            return (lastPage === null || lastPage === void 0 ? void 0 : lastPage.length) >= _app_configs__WEBPACK_IMPORTED_MODULE_0__/* .REPLY_LIMIT_SIZE */ .bn ? (pages === null || pages === void 0 ? void 0 : pages.length) + 1 : 0;
        }
    });
};


/***/ }),

/***/ 82190:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "b$": function() { return /* reexport */ useInfiniteGetListGame; },
  "dV": function() { return /* reexport */ game_detail_mutation/* useMutationFollowGame */.dV; },
  "$": function() { return /* reexport */ useQueryGetAllCategory; },
  "Bu": function() { return /* reexport */ useQueryGetListGame; },
  "LI": function() { return /* reexport */ useQueryGetListGameBanner; },
  "Q5": function() { return /* reexport */ game_detail_query/* useQueryGetListSuggestFriendByGame */.Q5; }
});

// UNUSED EXPORTS: getGameReviewFn, useMutationDeleteReplyReview, useMutationDeleteReview, useMutationLikeReview, useMutationRateGame, useMutationRegisterGame, useMutationReplyReview, useQueryGetDetailGame, useQueryGetListReviewGame

// EXTERNAL MODULE: ./node_modules/@tanstack/react-query/build/modern/useQuery.js
var useQuery = __webpack_require__(78551);
// EXTERNAL MODULE: ./node_modules/@tanstack/react-query/build/modern/useInfiniteQuery.js + 1 modules
var useInfiniteQuery = __webpack_require__(29726);
// EXTERNAL MODULE: ./app/services/services/GameServices.tsx
var GameServices = __webpack_require__(54309);
// EXTERNAL MODULE: ./app/configs/index.ts + 3 modules
var configs = __webpack_require__(54254);
;// CONCATENATED MODULE: ./app/services/query-fn/game/game-home-query.ts



const getListGameFn = async (params)=>{
    const data = await GameServices/* GameServices.getAllGames */.o.getAllGames(params);
    return data.data.data;
};
const getListCategoryFn = async ()=>{
    const data = await GameServices/* GameServices.getAllCategories */.o.getAllCategories();
    return data.data.data;
};
const getListBannerFn = async (params)=>{
    const data = await GameServices/* GameServices.getListBanner */.o.getListBanner(params);
    return data.data.data;
};
const useQueryGetListGame = (params)=>{
    return (0,useQuery/* useQuery */.a)({
        queryKey: [
            configs/* QUERY_KEY.LIST_GAME */.lP.LIST_GAME,
            params
        ],
        queryFn: ()=>getListGameFn(params),
        enabled: !!params,
        refetchOnWindowFocus: false,
        retry: 0
    });
};
const useQueryGetAllCategory = ()=>{
    return (0,useQuery/* useQuery */.a)({
        queryKey: [
            configs/* QUERY_KEY.LIST_CATEGORY */.lP.LIST_CATEGORY
        ],
        queryFn: getListCategoryFn,
        refetchOnWindowFocus: false,
        retry: 0
    });
};
const useQueryGetListGameBanner = (params)=>{
    return (0,useQuery/* useQuery */.a)({
        queryKey: [
            configs/* QUERY_KEY.LIST_GAME_BANNER */.lP.LIST_GAME_BANNER,
            params
        ],
        queryFn: ()=>getListBannerFn(params),
        enabled: !!params,
        refetchOnWindowFocus: false,
        retry: 0
    });
};
const useInfiniteGetListGame = (params)=>{
    return (0,useInfiniteQuery/* useInfiniteQuery */.N)({
        queryKey: [
            configs/* QUERY_KEY.LIST_GAME_INFINITE */.lP.LIST_GAME_INFINITE,
            params
        ],
        queryFn: (param)=>{
            let { pageParam  } = param;
            return getListGameFn({
                ...params,
                page: pageParam
            });
        },
        initialPageParam: 1,
        getNextPageParam: (lastPage, pages)=>{
            return (lastPage === null || lastPage === void 0 ? void 0 : lastPage.length) > 9 ? (pages === null || pages === void 0 ? void 0 : pages.length) + 1 : undefined;
        }
    });
};

// EXTERNAL MODULE: ./app/services/query-fn/game/game-detail-mutation.ts
var game_detail_mutation = __webpack_require__(84953);
// EXTERNAL MODULE: ./app/services/query-fn/game/game-detail-query.ts
var game_detail_query = __webpack_require__(88542);
;// CONCATENATED MODULE: ./app/services/query-fn/game/index.ts





/***/ }),

/***/ 32674:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Bp": function() { return /* binding */ useQueryGetListGiftcode; },
/* harmony export */   "DV": function() { return /* binding */ useQueryGetGiftcodeDetail; },
/* harmony export */   "Jn": function() { return /* binding */ useQueryGetListServerGiftcode; },
/* harmony export */   "dr": function() { return /* binding */ useQueryGetListGameGiftcode; },
/* harmony export */   "nv": function() { return /* binding */ useQueryGetListRoleGiftcode; },
/* harmony export */   "s2": function() { return /* binding */ useQueryGetGiftcodeInfo; }
/* harmony export */ });
/* harmony import */ var _services_Giftcode__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(56427);
/* harmony import */ var _tanstack_react_query__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(78551);
/* harmony import */ var _app_configs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(54254);
/* harmony import */ var _app_lib_utils__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(73848);




const getListGiftcode = async (params)=>{
    const data = await _services_Giftcode__WEBPACK_IMPORTED_MODULE_0__/* .GiftcodeServices.getAllGiftcode */ .t.getAllGiftcode(params);
    return data.data.data;
};
const getListGameGiftcode = async ()=>{
    const data = await _services_Giftcode__WEBPACK_IMPORTED_MODULE_0__/* .GiftcodeServices.getGameGiftcode */ .t.getGameGiftcode();
    return data.data.data;
};
const getListServerGiftcode = async (body)=>{
    const data = await _services_Giftcode__WEBPACK_IMPORTED_MODULE_0__/* .GiftcodeServices.getServerGiftcode */ .t.getServerGiftcode(body);
    return data.data;
};
const getListRoleGiftcode = async (body)=>{
    const data = await _services_Giftcode__WEBPACK_IMPORTED_MODULE_0__/* .GiftcodeServices.getRoleGiftcode */ .t.getRoleGiftcode(body);
    return data.data;
};
const getGiftcodeDetail = async (param)=>{
    let { event_id  } = param;
    const data = await _services_Giftcode__WEBPACK_IMPORTED_MODULE_0__/* .GiftcodeServices.getGiftcodeDetail */ .t.getGiftcodeDetail({
        event_id
    });
    return data.data.data;
};
const getGiftcodeInfo = async (param)=>{
    let { event_id  } = param;
    const data = await _services_Giftcode__WEBPACK_IMPORTED_MODULE_0__/* .GiftcodeServices.getGiftcodeInfo */ .t.getGiftcodeInfo({
        event_id
    });
    return data.data.data;
};
const useQueryGetListGiftcode = (params)=>{
    const _params = (0,_app_lib_utils__WEBPACK_IMPORTED_MODULE_2__/* .removeNullKeyObject */ .t2)(params);
    return (0,_tanstack_react_query__WEBPACK_IMPORTED_MODULE_3__/* .useQuery */ .a)({
        queryKey: [
            _app_configs__WEBPACK_IMPORTED_MODULE_1__/* .QUERY_KEY.LIST_GIFTCODE */ .lP.LIST_GIFTCODE,
            _params
        ],
        queryFn: ()=>getListGiftcode(_params),
        enabled: !!_params,
        refetchOnWindowFocus: false,
        retry: 0
    });
};
const useQueryGetGiftcodeDetail = (param)=>{
    let { event_id  } = param;
    return (0,_tanstack_react_query__WEBPACK_IMPORTED_MODULE_3__/* .useQuery */ .a)({
        queryKey: [
            _app_configs__WEBPACK_IMPORTED_MODULE_1__/* .QUERY_KEY.GIFTCODE_DETAIL */ .lP.GIFTCODE_DETAIL,
            {
                event_id
            }
        ],
        queryFn: ()=>getGiftcodeDetail({
                event_id
            }),
        enabled: !!event_id,
        refetchOnWindowFocus: false,
        retry: 0
    });
};
const useQueryGetGiftcodeInfo = (param)=>{
    let { event_id  } = param;
    return (0,_tanstack_react_query__WEBPACK_IMPORTED_MODULE_3__/* .useQuery */ .a)({
        queryKey: [
            _app_configs__WEBPACK_IMPORTED_MODULE_1__/* .QUERY_KEY.GIFTCODE_INFO */ .lP.GIFTCODE_INFO,
            {
                event_id
            }
        ],
        queryFn: ()=>getGiftcodeInfo({
                event_id
            }),
        enabled: !!event_id,
        refetchOnWindowFocus: false,
        retry: 0
    });
};
const useQueryGetListGameGiftcode = ()=>{
    const token = _app_configs__WEBPACK_IMPORTED_MODULE_1__/* .isClient */ .C5 ? window.localStorage.getItem("token") : null;
    return (0,_tanstack_react_query__WEBPACK_IMPORTED_MODULE_3__/* .useQuery */ .a)({
        queryKey: [
            _app_configs__WEBPACK_IMPORTED_MODULE_1__/* .QUERY_KEY.LIST_GAME_GIFTCODE */ .lP.LIST_GAME_GIFTCODE
        ],
        queryFn: ()=>getListGameGiftcode(),
        // enabled: !!token,
        refetchOnWindowFocus: false,
        retry: 0
    });
};
const useQueryGetListServerGiftcode = (params)=>{
    return (0,_tanstack_react_query__WEBPACK_IMPORTED_MODULE_3__/* .useQuery */ .a)({
        queryKey: [
            _app_configs__WEBPACK_IMPORTED_MODULE_1__/* .QUERY_KEY.LIST_SERVER_GIFTCODE */ .lP.LIST_SERVER_GIFTCODE,
            params
        ],
        enabled: !!(params === null || params === void 0 ? void 0 : params.game_id) && !!(params === null || params === void 0 ? void 0 : params.user_id),
        queryFn: ()=>getListServerGiftcode(params),
        refetchOnWindowFocus: false,
        retry: 0
    });
};
const useQueryGetListRoleGiftcode = (params)=>{
    return (0,_tanstack_react_query__WEBPACK_IMPORTED_MODULE_3__/* .useQuery */ .a)({
        queryKey: [
            _app_configs__WEBPACK_IMPORTED_MODULE_1__/* .QUERY_KEY.LIST_ROLE_GIFTCODE */ .lP.LIST_ROLE_GIFTCODE,
            params
        ],
        enabled: !!(params === null || params === void 0 ? void 0 : params.server_id) && !!(params === null || params === void 0 ? void 0 : params.user_id),
        queryFn: ()=>getListRoleGiftcode(params),
        refetchOnWindowFocus: false,
        retry: 0
    });
};


/***/ }),

/***/ 58512:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Vj": function() { return /* reexport */ useMutationFollowPartner; },
  "eN": function() { return /* reexport */ useMutationNormalLogin; },
  "dZ": function() { return /* reexport */ useQueryGetGameFollow; },
  "i9": function() { return /* reexport */ useQueryGetHotTopic; },
  "Po": function() { return /* reexport */ useQueryGetMyFollowing; },
  "bK": function() { return /* reexport */ useQueryGetProfileById; },
  "p$": function() { return /* reexport */ useQueryGetUrlLoginFacebook; },
  "Zr": function() { return /* reexport */ useQueryGetUrlLoginGoogle; },
  "oo": function() { return /* reexport */ useQueryLoginFacebook; },
  "kY": function() { return /* reexport */ useQueryLoginGoogle; },
  "LK": function() { return /* reexport */ useQueryProfileInfo; }
});

// EXTERNAL MODULE: ./app/services/services/index.ts + 2 modules
var services = __webpack_require__(27020);
// EXTERNAL MODULE: ./node_modules/@tanstack/react-query/build/modern/useMutation.js + 1 modules
var useMutation = __webpack_require__(98029);
// EXTERNAL MODULE: ./app/configs/index.ts + 3 modules
var configs = __webpack_require__(54254);
;// CONCATENATED MODULE: ./app/services/query-fn/auth/login-normal-mutation.ts



const loginFn = (body)=>{
    return services/* UserService.login */.K.login(body);
};
const useMutationNormalLogin = ()=>{
    return (0,useMutation/* useMutation */.D)({
        mutationKey: [
            configs/* QUERY_KEY.LOGIN_NORMAL */.lP.LOGIN_NORMAL
        ],
        mutationFn: loginFn
    });
};

// EXTERNAL MODULE: ./node_modules/@tanstack/react-query/build/modern/useQuery.js
var useQuery = __webpack_require__(78551);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
;// CONCATENATED MODULE: ./app/services/query-fn/auth/login-google-query.ts




const loginGoogleFn = (code)=>{
    return services/* UserService.loginByGoogle */.K.loginByGoogle(code);
};
const useQueryLoginGoogle = (code)=>{
    return (0,useQuery/* useQuery */.a)({
        queryKey: [
            configs/* QUERY_KEY.LOGIN_GOOGLE */.lP.LOGIN_GOOGLE,
            code
        ],
        queryFn: ()=>loginGoogleFn(code),
        enabled: !!code,
        refetchOnWindowFocus: false,
        retry: 0
    });
};
const useQueryGetUrlLoginGoogle = ()=>{
    const router = (0,next_router.useRouter)();
    const token = configs/* isClient */.C5 ? window.localStorage.getItem("token") : "";
    return (0,useQuery/* useQuery */.a)({
        queryKey: [
            configs/* QUERY_KEY.GET_URL_LOGIN_GOOGLE */.lP.GET_URL_LOGIN_GOOGLE
        ],
        queryFn: ()=>loginGoogleFn(),
        enabled: !token,
        refetchOnWindowFocus: false
    });
};

;// CONCATENATED MODULE: ./app/services/query-fn/auth/login-facebook-query.ts




const getUrlFacebookFn = ()=>{
    return services/* UserService.getUrlFacebook */.K.getUrlFacebook();
};
const loginFacebookFn = (params)=>{
    return services/* UserService.loginByFacebook */.K.loginByFacebook(params);
};
const useQueryLoginFacebook = (params)=>{
    return (0,useQuery/* useQuery */.a)({
        queryKey: [
            configs/* QUERY_KEY.LOGIN_FACEBOOK */.lP.LOGIN_FACEBOOK,
            params
        ],
        queryFn: ()=>loginFacebookFn(params),
        enabled: !!params,
        refetchOnWindowFocus: false,
        retry: 0
    });
};
const useQueryGetUrlLoginFacebook = ()=>{
    const router = (0,next_router.useRouter)();
    const token = configs/* isClient */.C5 ? window.localStorage.getItem("token") : "";
    return (0,useQuery/* useQuery */.a)({
        queryKey: [
            configs/* QUERY_KEY.GET_URL_LOGIN_FACEBOOK */.lP.GET_URL_LOGIN_FACEBOOK
        ],
        queryFn: ()=>getUrlFacebookFn(),
        enabled: !token,
        refetchOnWindowFocus: false
    });
};

;// CONCATENATED MODULE: ./app/services/query-fn/auth/index.ts




// EXTERNAL MODULE: ./node_modules/@tanstack/react-query/build/modern/useInfiniteQuery.js + 1 modules
var useInfiniteQuery = __webpack_require__(29726);
// EXTERNAL MODULE: ./app/services/services/GameServices.tsx
var GameServices = __webpack_require__(54309);
;// CONCATENATED MODULE: ./app/services/query-fn/user/user-info-query.ts




const getReloadProfileInfoFn = ()=>{
    return UserService.getReloadProfile();
};
const getProfileInfoFn = ()=>{
    return services/* UserService.getProfile */.K.getProfile();
};
const getHotTopicListFn = async ()=>{
    var _res_data;
    const res = await services/* UserService.getListHashtag */.K.getListHashtag({});
    return res === null || res === void 0 ? void 0 : (_res_data = res.data) === null || _res_data === void 0 ? void 0 : _res_data.data;
};
const getListGameFollow = async (other_userid)=>{
    var _res_data, _res_data1;
    const res = await GameServices/* GameServices.getListFollowGame */.o.getListFollowGame(other_userid);
    return {
        game: res === null || res === void 0 ? void 0 : (_res_data = res.data) === null || _res_data === void 0 ? void 0 : _res_data.data,
        totalFollow: res === null || res === void 0 ? void 0 : (_res_data1 = res.data) === null || _res_data1 === void 0 ? void 0 : _res_data1.totalFollow
    };
};
const followPartnerFn = (follower_id)=>{
    return services/* UserService.followUser */.K.followUser(follower_id);
};
const getListFollowFn = async (pageParam, query)=>{
    var _res_data;
    const res = await services/* UserService.getListFollow */.K.getListFollow(pageParam, query);
    return res === null || res === void 0 ? void 0 : (_res_data = res.data) === null || _res_data === void 0 ? void 0 : _res_data.data;
};
const useQueryGetMyFollowing = (userid, enable, query)=>{
    return (0,useInfiniteQuery/* useInfiniteQuery */.N)({
        queryKey: [
            configs/* QUERY_KEY.LIST_FOLLOWING */.lP.LIST_FOLLOWING,
            userid,
            query
        ],
        queryFn: (param)=>{
            let { pageParam  } = param;
            return getListFollowFn(pageParam, query);
        },
        initialPageParam: 1,
        getNextPageParam: (lastPage, pages)=>{
            return (lastPage === null || lastPage === void 0 ? void 0 : lastPage.length) > 9 ? (pages === null || pages === void 0 ? void 0 : pages.length) + 1 : undefined;
        },
        refetchOnMount: "always",
        enabled: !!enable
    });
};
const useMutationFollowPartner = ()=>{
    return (0,useMutation/* useMutation */.D)({
        mutationKey: [
            configs/* QUERY_KEY.FOLLOW_PARTNER */.lP.FOLLOW_PARTNER
        ],
        mutationFn: followPartnerFn
    });
};
const useQueryGetProfileById = (id)=>{
    return (0,useQuery/* useQuery */.a)({
        queryFn: async ()=>{
            var _res_data;
            const res = await services/* UserService.getProfileInfoById */.K.getProfileInfoById(String(id));
            return res === null || res === void 0 ? void 0 : (_res_data = res.data) === null || _res_data === void 0 ? void 0 : _res_data.data;
        },
        queryKey: [
            configs/* QUERY_KEY.GET_PROFILE_BY_ID */.lP.GET_PROFILE_BY_ID,
            id
        ],
        enabled: !!id,
        refetchOnMount: "always"
    });
};
const useQueryGetGameFollow = (enable, other_userid)=>{
    return (0,useQuery/* useQuery */.a)({
        queryFn: ()=>getListGameFollow(other_userid),
        queryKey: [
            configs/* QUERY_KEY.LIST_GAME_FOLLOW */.lP.LIST_GAME_FOLLOW
        ],
        enabled: !!enable
    });
};
const useQueryProfileInfo = ()=>{
    const token = configs/* isClient */.C5 ? window.localStorage.getItem("token") : null;
    return {
        ...(0,useQuery/* useQuery */.a)({
            queryFn: getProfileInfoFn,
            queryKey: [
                configs/* QUERY_KEY.PROFILE_INFO */.lP.PROFILE_INFO
            ],
            enabled: !!token,
            refetchOnMount: "always",
            refetchOnReconnect: "always"
        })
    };
};
const useQueryGetHotTopic = ()=>{
    return {
        ...(0,useQuery/* useQuery */.a)({
            queryFn: getHotTopicListFn,
            queryKey: [
                configs/* QUERY_KEY.HOT_TOPIC */.lP.HOT_TOPIC
            ]
        })
    };
};

;// CONCATENATED MODULE: ./app/services/query-fn/user/index.ts


;// CONCATENATED MODULE: ./app/services/query-fn/index.ts




/***/ }),

/***/ 213:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Ic": function() { return /* binding */ useMutationCreateAddress; },
/* harmony export */   "J": function() { return /* binding */ useMutationDeleteAddress; },
/* harmony export */   "Jj": function() { return /* binding */ useMutationCreatePaymentMerchandise; },
/* harmony export */   "N3": function() { return /* binding */ useMutationAddToCart; },
/* harmony export */   "PX": function() { return /* binding */ useMutationCreateQuickPaymentMerchandise; },
/* harmony export */   "RM": function() { return /* binding */ useMutationDeleteCart; },
/* harmony export */   "Ry": function() { return /* binding */ useMutationUpdateCart; },
/* harmony export */   "Ye": function() { return /* binding */ useMutationDestroyOrder; },
/* harmony export */   "hd": function() { return /* binding */ useMutationGetMerchandisePaymentFeeShip; },
/* harmony export */   "jY": function() { return /* binding */ useMutationUpdateAddress; },
/* harmony export */   "kt": function() { return /* binding */ useMutationBuyNowMerchandise; },
/* harmony export */   "rH": function() { return /* binding */ useMutationUpdateQuickCart; }
/* harmony export */ });
/* harmony import */ var _services_MerchandiseService__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(82303);
/* harmony import */ var _tanstack_react_query__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(98029);
/* harmony import */ var _app_configs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(54254);
/* harmony import */ var _app_lib_utils__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(73848);




const createAddress = (body)=>{
    return _services_MerchandiseService__WEBPACK_IMPORTED_MODULE_0__/* .MerchandiseService.createAddress */ .f.createAddress(body);
};
const addToCartFn = (body)=>{
    return _services_MerchandiseService__WEBPACK_IMPORTED_MODULE_0__/* .MerchandiseService.addToCart */ .f.addToCart(body);
};
const buyNowFn = (body)=>{
    return _services_MerchandiseService__WEBPACK_IMPORTED_MODULE_0__/* .MerchandiseService.buyNow */ .f.buyNow(body);
};
const updateCartFn = (body)=>{
    return _services_MerchandiseService__WEBPACK_IMPORTED_MODULE_0__/* .MerchandiseService.updateCart */ .f.updateCart(body);
};
const updateQuickCartFn = (body)=>{
    return _services_MerchandiseService__WEBPACK_IMPORTED_MODULE_0__/* .MerchandiseService.updateQuickCart */ .f.updateQuickCart(body);
};
const deleteCartFn = (param)=>{
    let { id  } = param;
    return _services_MerchandiseService__WEBPACK_IMPORTED_MODULE_0__/* .MerchandiseService.deleteCart */ .f.deleteCart(id);
};
const destroyOrderFn = (body)=>{
    return _services_MerchandiseService__WEBPACK_IMPORTED_MODULE_0__/* .MerchandiseService.destroyOrder */ .f.destroyOrder(body);
};
const deleteAddressFn = (param)=>{
    let { id  } = param;
    return _services_MerchandiseService__WEBPACK_IMPORTED_MODULE_0__/* .MerchandiseService.deleteAddress */ .f.deleteAddress(id);
};
const updateAddressFn = (body)=>{
    return _services_MerchandiseService__WEBPACK_IMPORTED_MODULE_0__/* .MerchandiseService.updateAddress */ .f.updateAddress(body);
};
const createPaymentFn = (body)=>{
    const _body = (0,_app_lib_utils__WEBPACK_IMPORTED_MODULE_2__/* .removeNullKeyObject */ .t2)(body);
    return _services_MerchandiseService__WEBPACK_IMPORTED_MODULE_0__/* .MerchandiseService.createPaymentMerchandise */ .f.createPaymentMerchandise(_body);
};
const createQuickPaymentFn = (body)=>{
    const _body = (0,_app_lib_utils__WEBPACK_IMPORTED_MODULE_2__/* .removeNullKeyObject */ .t2)(body);
    return _services_MerchandiseService__WEBPACK_IMPORTED_MODULE_0__/* .MerchandiseService.createQuickPaymentMerchandise */ .f.createQuickPaymentMerchandise(_body);
};
const getMerchandisePaymentFeeShip = async (body)=>{
    const data = await _services_MerchandiseService__WEBPACK_IMPORTED_MODULE_0__/* .MerchandiseService.getPaymentFeeShip */ .f.getPaymentFeeShip(body);
    return data.data;
};
const useMutationGetMerchandisePaymentFeeShip = ()=>{
    return (0,_tanstack_react_query__WEBPACK_IMPORTED_MODULE_3__/* .useMutation */ .D)({
        mutationKey: [
            _app_configs__WEBPACK_IMPORTED_MODULE_1__/* .QUERY_KEY.MERCHANDISE_PAYMENT_FEE_SHIP */ .lP.MERCHANDISE_PAYMENT_FEE_SHIP
        ],
        mutationFn: getMerchandisePaymentFeeShip
    });
};
const useMutationCreateAddress = ()=>{
    return (0,_tanstack_react_query__WEBPACK_IMPORTED_MODULE_3__/* .useMutation */ .D)({
        mutationKey: [
            _app_configs__WEBPACK_IMPORTED_MODULE_1__/* .QUERY_KEY.CREATE_ADDRESS */ .lP.CREATE_ADDRESS
        ],
        mutationFn: createAddress
    });
};
const useMutationAddToCart = ()=>{
    return (0,_tanstack_react_query__WEBPACK_IMPORTED_MODULE_3__/* .useMutation */ .D)({
        mutationKey: [
            _app_configs__WEBPACK_IMPORTED_MODULE_1__/* .QUERY_KEY.ADD_TO_CART_MERCHANDISE */ .lP.ADD_TO_CART_MERCHANDISE
        ],
        mutationFn: addToCartFn
    });
};
const useMutationBuyNowMerchandise = ()=>{
    return (0,_tanstack_react_query__WEBPACK_IMPORTED_MODULE_3__/* .useMutation */ .D)({
        mutationKey: [
            _app_configs__WEBPACK_IMPORTED_MODULE_1__/* .QUERY_KEY.BUY_NOW_MERCHANDISE */ .lP.BUY_NOW_MERCHANDISE
        ],
        mutationFn: buyNowFn
    });
};
const useMutationCreateQuickPaymentMerchandise = ()=>{
    return (0,_tanstack_react_query__WEBPACK_IMPORTED_MODULE_3__/* .useMutation */ .D)({
        mutationKey: [
            _app_configs__WEBPACK_IMPORTED_MODULE_1__/* .QUERY_KEY.CREATE_NOW_PAYMENT_MERCHANDISE */ .lP.CREATE_NOW_PAYMENT_MERCHANDISE
        ],
        mutationFn: createQuickPaymentFn
    });
};
const useMutationUpdateQuickCart = ()=>{
    return (0,_tanstack_react_query__WEBPACK_IMPORTED_MODULE_3__/* .useMutation */ .D)({
        mutationKey: [
            _app_configs__WEBPACK_IMPORTED_MODULE_1__/* .QUERY_KEY.UPDATE_QUICK_CART_MERCHANDISE */ .lP.UPDATE_QUICK_CART_MERCHANDISE
        ],
        mutationFn: updateQuickCartFn
    });
};
const useMutationUpdateCart = ()=>{
    return (0,_tanstack_react_query__WEBPACK_IMPORTED_MODULE_3__/* .useMutation */ .D)({
        mutationKey: [
            _app_configs__WEBPACK_IMPORTED_MODULE_1__/* .QUERY_KEY.UPDATE_CART_MERCHANDISE */ .lP.UPDATE_CART_MERCHANDISE
        ],
        mutationFn: updateCartFn
    });
};
const useMutationDeleteCart = ()=>{
    return (0,_tanstack_react_query__WEBPACK_IMPORTED_MODULE_3__/* .useMutation */ .D)({
        mutationKey: [
            _app_configs__WEBPACK_IMPORTED_MODULE_1__/* .QUERY_KEY.DELETE_CART_MERCHANDISE */ .lP.DELETE_CART_MERCHANDISE
        ],
        mutationFn: deleteCartFn
    });
};
const useMutationDestroyOrder = ()=>{
    return (0,_tanstack_react_query__WEBPACK_IMPORTED_MODULE_3__/* .useMutation */ .D)({
        mutationKey: [
            _app_configs__WEBPACK_IMPORTED_MODULE_1__/* .QUERY_KEY.DESTROY_ORDER */ .lP.DESTROY_ORDER
        ],
        mutationFn: destroyOrderFn
    });
};
const useMutationUpdateAddress = ()=>{
    return (0,_tanstack_react_query__WEBPACK_IMPORTED_MODULE_3__/* .useMutation */ .D)({
        mutationKey: [
            _app_configs__WEBPACK_IMPORTED_MODULE_1__/* .QUERY_KEY.UPDATE_ADDRESS_MERCHANDISE */ .lP.UPDATE_ADDRESS_MERCHANDISE
        ],
        mutationFn: updateAddressFn
    });
};
const useMutationDeleteAddress = ()=>{
    return (0,_tanstack_react_query__WEBPACK_IMPORTED_MODULE_3__/* .useMutation */ .D)({
        mutationKey: [
            _app_configs__WEBPACK_IMPORTED_MODULE_1__/* .QUERY_KEY.DELETE_ADDRESS_MERCHANDISE */ .lP.DELETE_ADDRESS_MERCHANDISE
        ],
        mutationFn: deleteAddressFn
    });
};
const useMutationCreatePaymentMerchandise = ()=>{
    return (0,_tanstack_react_query__WEBPACK_IMPORTED_MODULE_3__/* .useMutation */ .D)({
        mutationKey: [
            _app_configs__WEBPACK_IMPORTED_MODULE_1__/* .QUERY_KEY.CREATE_PAYMENT_MERCHANDISE */ .lP.CREATE_PAYMENT_MERCHANDISE
        ],
        mutationFn: createPaymentFn
    });
};


/***/ }),

/***/ 29519:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "AY": function() { return /* binding */ useQueryGetListMerchandiseMethod; },
/* harmony export */   "F0": function() { return /* binding */ useQueryGetListMerchandiseDetail; },
/* harmony export */   "G1": function() { return /* binding */ useQueryGetMerchandiseOnepayCallBack; },
/* harmony export */   "KT": function() { return /* binding */ useQueryGetListGameMechandise; },
/* harmony export */   "V3": function() { return /* binding */ useQueryGetListMerchandise; },
/* harmony export */   "VC": function() { return /* binding */ useQueryGetListMerchandiseCart; },
/* harmony export */   "fc": function() { return /* binding */ useQueryGetListMerchandiseAddress; },
/* harmony export */   "j": function() { return /* binding */ useQueryGetListCategory; },
/* harmony export */   "nJ": function() { return /* binding */ useQueryGetMerchandisePaymentCallBack; },
/* harmony export */   "x7": function() { return /* binding */ useQueryGetMerchandisePaymentTransaction; }
/* harmony export */ });
/* harmony import */ var _app_configs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(54254);
/* harmony import */ var _tanstack_react_query__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(78551);
/* harmony import */ var _services_MerchandiseService__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(82303);



const getListMerchandiseFn = async (params)=>{
    const data = await _services_MerchandiseService__WEBPACK_IMPORTED_MODULE_1__/* .MerchandiseService.getListMerchandise */ .f.getListMerchandise(params);
    return data.data;
};
const getListCategoryFn = async ()=>{
    const data = await _services_MerchandiseService__WEBPACK_IMPORTED_MODULE_1__/* .MerchandiseService.getListCategory */ .f.getListCategory();
    return data.data.data;
};
const getListGameMerchandiseFn = async ()=>{
    const data = await _services_MerchandiseService__WEBPACK_IMPORTED_MODULE_1__/* .MerchandiseService.getListGame */ .f.getListGame();
    return data.data.data;
};
const getListMerchandiseCartFn = async ()=>{
    const data = await _services_MerchandiseService__WEBPACK_IMPORTED_MODULE_1__/* .MerchandiseService.getListCart */ .f.getListCart();
    return data.data.data;
};
const getListMerchandiseDetailFn = async (id)=>{
    const data = await _services_MerchandiseService__WEBPACK_IMPORTED_MODULE_1__/* .MerchandiseService.getMerchandiseDetail */ .f.getMerchandiseDetail(id);
    return data.data.data;
};
const getListMerchandiseMethodFn = async ()=>{
    const data = await _services_MerchandiseService__WEBPACK_IMPORTED_MODULE_1__/* .MerchandiseService.getMerchandiseMethod */ .f.getMerchandiseMethod();
    return data.data.data;
};
const getListMerchandiseAddressFn = async ()=>{
    const data = await _services_MerchandiseService__WEBPACK_IMPORTED_MODULE_1__/* .MerchandiseService.getMerchandiseListAddress */ .f.getMerchandiseListAddress();
    return data.data.data;
};
const getMerchandisePaymentCallbackFn = async (body)=>{
    const data = await _services_MerchandiseService__WEBPACK_IMPORTED_MODULE_1__/* .MerchandiseService.getPaymentMerchandiseCallback */ .f.getPaymentMerchandiseCallback(body);
    return data.data;
};
const getMerchandiseOnepayCallbackFn = async (body)=>{
    const data = await _services_MerchandiseService__WEBPACK_IMPORTED_MODULE_1__/* .MerchandiseService.getPaymentMerchandiseOnepayCallback */ .f.getPaymentMerchandiseOnepayCallback(body);
    return data.data;
};
const getMerchandisePaymentTransaction = async (param)=>{
    let { transaction_id  } = param;
    const data = await _services_MerchandiseService__WEBPACK_IMPORTED_MODULE_1__/* .MerchandiseService.getPaymentMerchandiseTransaction */ .f.getPaymentMerchandiseTransaction({
        transaction_id
    });
    return data.data;
};
const useQueryGetMerchandisePaymentTransaction = (param)=>{
    let { transaction_id  } = param;
    return (0,_tanstack_react_query__WEBPACK_IMPORTED_MODULE_2__/* .useQuery */ .a)({
        queryKey: [
            _app_configs__WEBPACK_IMPORTED_MODULE_0__/* .QUERY_KEY.PAYMENT_TRANSACTION_MERCHANDISE */ .lP.PAYMENT_TRANSACTION_MERCHANDISE,
            {
                transaction_id
            }
        ],
        queryFn: ()=>getMerchandisePaymentTransaction({
                transaction_id
            }),
        enabled: !!transaction_id,
        refetchOnWindowFocus: false,
        retry: 0
    });
};
const useQueryGetMerchandiseOnepayCallBack = (params)=>{
    return (0,_tanstack_react_query__WEBPACK_IMPORTED_MODULE_2__/* .useQuery */ .a)({
        queryKey: [
            _app_configs__WEBPACK_IMPORTED_MODULE_0__/* .QUERY_KEY.CALLBACK_ONEPAY_MERCHANDISE */ .lP.CALLBACK_ONEPAY_MERCHANDISE,
            params
        ],
        queryFn: ()=>getMerchandiseOnepayCallbackFn(params),
        refetchOnWindowFocus: false,
        retry: 0
    });
};
const useQueryGetMerchandisePaymentCallBack = (params)=>{
    return (0,_tanstack_react_query__WEBPACK_IMPORTED_MODULE_2__/* .useQuery */ .a)({
        queryKey: [
            _app_configs__WEBPACK_IMPORTED_MODULE_0__/* .QUERY_KEY.CALLBACK_PAYMENT_MERCHANDISE */ .lP.CALLBACK_PAYMENT_MERCHANDISE,
            params
        ],
        queryFn: ()=>getMerchandisePaymentCallbackFn(params),
        refetchOnWindowFocus: false,
        retry: 0
    });
};
const useQueryGetListMerchandiseAddress = ()=>{
    return (0,_tanstack_react_query__WEBPACK_IMPORTED_MODULE_2__/* .useQuery */ .a)({
        queryKey: [
            _app_configs__WEBPACK_IMPORTED_MODULE_0__/* .QUERY_KEY.MERCHANDISE_ADDRESS */ .lP.MERCHANDISE_ADDRESS
        ],
        queryFn: ()=>getListMerchandiseAddressFn(),
        refetchOnWindowFocus: false,
        retry: 0
    });
};
const useQueryGetListMerchandise = (params)=>{
    return (0,_tanstack_react_query__WEBPACK_IMPORTED_MODULE_2__/* .useQuery */ .a)({
        queryKey: [
            _app_configs__WEBPACK_IMPORTED_MODULE_0__/* .QUERY_KEY.MERCHANDISE_LIST */ .lP.MERCHANDISE_LIST,
            params
        ],
        queryFn: ()=>getListMerchandiseFn(params),
        enabled: !!params,
        refetchOnWindowFocus: false,
        retry: 0
    });
};
const useQueryGetListCategory = ()=>{
    return (0,_tanstack_react_query__WEBPACK_IMPORTED_MODULE_2__/* .useQuery */ .a)({
        queryKey: [
            _app_configs__WEBPACK_IMPORTED_MODULE_0__/* .QUERY_KEY.MERCHANDISE_CATEGORY_LIST */ .lP.MERCHANDISE_CATEGORY_LIST
        ],
        queryFn: ()=>getListCategoryFn(),
        refetchOnWindowFocus: false,
        retry: 0
    });
};
const useQueryGetListGameMechandise = ()=>{
    return (0,_tanstack_react_query__WEBPACK_IMPORTED_MODULE_2__/* .useQuery */ .a)({
        queryKey: [
            _app_configs__WEBPACK_IMPORTED_MODULE_0__/* .QUERY_KEY.MERCHANDISE_GAME_LIST */ .lP.MERCHANDISE_GAME_LIST
        ],
        queryFn: ()=>getListGameMerchandiseFn(),
        refetchOnWindowFocus: false,
        retry: 0
    });
};
const useQueryGetListMerchandiseCart = ()=>{
    const token = _app_configs__WEBPACK_IMPORTED_MODULE_0__/* .isClient */ .C5 ? window.localStorage.getItem("token") : null;
    return (0,_tanstack_react_query__WEBPACK_IMPORTED_MODULE_2__/* .useQuery */ .a)({
        queryKey: [
            _app_configs__WEBPACK_IMPORTED_MODULE_0__/* .QUERY_KEY.MERCHANDISE_CART */ .lP.MERCHANDISE_CART
        ],
        queryFn: ()=>getListMerchandiseCartFn(),
        refetchOnWindowFocus: false,
        retry: 0,
        enabled: !!token
    });
};
const useQueryGetListMerchandiseDetail = (id)=>{
    return (0,_tanstack_react_query__WEBPACK_IMPORTED_MODULE_2__/* .useQuery */ .a)({
        queryKey: [
            _app_configs__WEBPACK_IMPORTED_MODULE_0__/* .QUERY_KEY.MERCHANDISE_DETAIL */ .lP.MERCHANDISE_DETAIL,
            {
                id
            }
        ],
        queryFn: ()=>getListMerchandiseDetailFn(id),
        refetchOnWindowFocus: false,
        retry: 0
    });
};
const useQueryGetListMerchandiseMethod = ()=>{
    return (0,_tanstack_react_query__WEBPACK_IMPORTED_MODULE_2__/* .useQuery */ .a)({
        queryKey: [
            _app_configs__WEBPACK_IMPORTED_MODULE_0__/* .QUERY_KEY.MERCHANDISE_METHOD */ .lP.MERCHANDISE_METHOD
        ],
        queryFn: ()=>getListMerchandiseMethodFn(),
        refetchOnWindowFocus: false,
        retry: 0
    });
};


/***/ }),

/***/ 31033:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "dt": function() { return /* reexport */ useMutationCommentToPostFn; },
  "Qk": function() { return /* reexport */ useMutationCreateNews; },
  "Ed": function() { return /* reexport */ useMutationDeleteComment; },
  "fG": function() { return /* reexport */ useMutationDeleteDraft; },
  "GD": function() { return /* reexport */ useMutationDeleteNews; },
  "XF": function() { return /* reexport */ useMutationEditNews; },
  "LV": function() { return /* reexport */ useMutationLikeComment; },
  "q5": function() { return /* reexport */ useMutationLikePost; },
  "VD": function() { return /* reexport */ useMutationRemoveStoreNews; },
  "hA": function() { return /* reexport */ useMutationReplyToComment; },
  "Wy": function() { return /* reexport */ useMutationSaveDraft; },
  "wT": function() { return /* reexport */ useMutationStoreNews; },
  "Dq": function() { return /* reexport */ useMutationUpdateComment; },
  "x2": function() { return /* reexport */ useMutationUploadMedia; },
  "wN": function() { return /* reexport */ useQueryCheckDraft; },
  "KD": function() { return /* reexport */ useQueryGetListComments; },
  "gG": function() { return /* reexport */ useQueryGetListForYou; },
  "uK": function() { return /* reexport */ useQueryGetListHotNews; },
  "PP": function() { return /* reexport */ useQueryGetListNewsByOtherUserId; },
  "DV": function() { return /* reexport */ useQueryGetListNewsByUser; },
  "b9": function() { return /* reexport */ useQueryGetListNewsLatest; },
  "L5": function() { return /* reexport */ useQueryGetListRelatedNews; },
  "rH": function() { return /* reexport */ useQueryGetListRelatedNewsByGame; },
  "Ys": function() { return /* reexport */ useQueryGetListReplies; },
  "Fy": function() { return /* reexport */ useQueryGetListStoredNews; },
  "vc": function() { return /* reexport */ useQueryGetMyNewsByFilter; },
  "FW": function() { return /* reexport */ useQueryGetNewsByHashtag; },
  "sd": function() { return /* reexport */ useQueryGetNewsDetail; },
  "mM": function() { return /* reexport */ useQueryGetNewsDetailForEdit; },
  "o2": function() { return /* reexport */ useQueryGetOtherUserNewsByFilter; },
  "Oo": function() { return /* reexport */ useQueryGetStickerUser; }
});

// UNUSED EXPORTS: useQueryGetListNews

// EXTERNAL MODULE: ./node_modules/@tanstack/react-query/build/modern/useInfiniteQuery.js + 1 modules
var modern_useInfiniteQuery = __webpack_require__(29726);
// EXTERNAL MODULE: ./node_modules/@tanstack/react-query/build/modern/useQuery.js
var useQuery = __webpack_require__(78551);
// EXTERNAL MODULE: ./app/configs/index.ts + 3 modules
var configs = __webpack_require__(54254);
// EXTERNAL MODULE: ./app/services/services/index.ts + 2 modules
var services = __webpack_require__(27020);
;// CONCATENATED MODULE: ./app/services/query-fn/news/list-news-query.ts



const getNewsFn = async (pageParam)=>{
    const data = await NewsService.getAllNews(pageParam);
    return data.data.data;
};
const getListStoreNewsFn = async (pageParam, keyword, sort)=>{
    const data = await services/* NewsService.getListStoreNews */.Y.getListStoreNews(pageParam, keyword, sort);
    return data.data.data;
};
const getLatestNewsFn = async (params)=>{
    const data = await services/* NewsService.getLatestNews */.Y.getLatestNews(params);
    return data.data.data;
};
const checkDraftFn = async ()=>{
    var _res_data;
    const res = await services/* NewsService.checkDraft */.Y.checkDraft();
    return res === null || res === void 0 ? void 0 : (_res_data = res.data) === null || _res_data === void 0 ? void 0 : _res_data.data;
};
const getNewsByTypeFn = async (type, limit)=>{
    var _data_data;
    const data = await services/* NewsService.getNewsByType */.Y.getNewsByType({
        type,
        limit
    });
    return data === null || data === void 0 ? void 0 : (_data_data = data.data) === null || _data_data === void 0 ? void 0 : _data_data.data;
};
const getRelatedNews = async (params)=>{
    var _res_data;
    const res = await services/* NewsService.relatedNews */.Y.relatedNews(params);
    return res === null || res === void 0 ? void 0 : (_res_data = res.data) === null || _res_data === void 0 ? void 0 : _res_data.data;
};
const getRelatedNewsByGame = async (params)=>{
    var _res_data;
    const res = await services/* NewsService.relatedNewsByGame */.Y.relatedNewsByGame(params);
    return res === null || res === void 0 ? void 0 : (_res_data = res.data) === null || _res_data === void 0 ? void 0 : _res_data.data;
};
const getAllNewsByUser = async (pageParam, sort)=>{
    var _res_data;
    const res = await services/* NewsService.getAllNewsByUser */.Y.getAllNewsByUser(pageParam, sort);
    return res === null || res === void 0 ? void 0 : (_res_data = res.data) === null || _res_data === void 0 ? void 0 : _res_data.data;
};
const getAllNewsByOtherUser = async (pageParam, sort, other_userid)=>{
    var _res_data;
    const res = await services/* NewsService.getAllNewsByOtherUser */.Y.getAllNewsByOtherUser(pageParam, sort, other_userid);
    return res === null || res === void 0 ? void 0 : (_res_data = res.data) === null || _res_data === void 0 ? void 0 : _res_data.data;
};
const getMyNewsByFilter = async (param, pageParam)=>{
    var _res_data;
    const res = await services/* NewsService.getMyNewsByFilter */.Y.getMyNewsByFilter(param, pageParam);
    return res === null || res === void 0 ? void 0 : (_res_data = res.data) === null || _res_data === void 0 ? void 0 : _res_data.data;
};
const getOtherUserNewsByFilter = async (param, pageParam)=>{
    var _res_data;
    const res = await services/* NewsService.getOtherUserNewsByFilter */.Y.getOtherUserNewsByFilter(param, pageParam);
    return res === null || res === void 0 ? void 0 : (_res_data = res.data) === null || _res_data === void 0 ? void 0 : _res_data.data;
};
const getListNewsByHashtag = async (keyword, pageParam)=>{
    var _res_data;
    const res = await services/* NewsService.getAllNewsByHashtag */.Y.getAllNewsByHashtag(keyword, pageParam);
    return res === null || res === void 0 ? void 0 : (_res_data = res.data) === null || _res_data === void 0 ? void 0 : _res_data.data;
};
const useQueryGetNewsByHashtag = (keyword, enabled)=>{
    return (0,modern_useInfiniteQuery/* useInfiniteQuery */.N)({
        queryKey: [
            configs/* QUERY_KEY.LIST_NEWS_BY_HASHTAG */.lP.LIST_NEWS_BY_HASHTAG,
            keyword
        ],
        queryFn: (param)=>{
            let { pageParam  } = param;
            return getListNewsByHashtag(keyword, pageParam);
        },
        initialPageParam: 1,
        getNextPageParam: (lastPage, pages)=>{
            return (lastPage === null || lastPage === void 0 ? void 0 : lastPage.length) > 9 ? (pages === null || pages === void 0 ? void 0 : pages.length) + 1 : undefined;
        },
        enabled: !!keyword && !!enabled,
        refetchOnMount: "always"
    });
};
const useQueryGetMyNewsByFilter = (param)=>{
    return (0,modern_useInfiniteQuery/* useInfiniteQuery */.N)({
        queryKey: [
            configs/* QUERY_KEY.MY_NEWS_BY_FILTER */.lP.MY_NEWS_BY_FILTER,
            Object.values(param).join("-")
        ],
        queryFn: (param1)=>{
            let { pageParam  } = param1;
            return getMyNewsByFilter(param, pageParam);
        },
        initialPageParam: 1,
        getNextPageParam: (lastPage, pages)=>{
            return (lastPage === null || lastPage === void 0 ? void 0 : lastPage.length) > 9 ? (pages === null || pages === void 0 ? void 0 : pages.length) + 1 : undefined;
        },
        enabled: !!(param === null || param === void 0 ? void 0 : param.keyword),
        refetchOnMount: "always"
    });
};
const useQueryGetOtherUserNewsByFilter = (param)=>{
    return (0,modern_useInfiniteQuery/* useInfiniteQuery */.N)({
        queryKey: [
            configs/* QUERY_KEY.OTHER_USER_NEWS_BY_FILTER */.lP.OTHER_USER_NEWS_BY_FILTER,
            Object.values(param).join("-")
        ],
        queryFn: (param1)=>{
            let { pageParam  } = param1;
            return getOtherUserNewsByFilter(param, pageParam);
        },
        initialPageParam: 1,
        getNextPageParam: (lastPage, pages)=>{
            return (lastPage === null || lastPage === void 0 ? void 0 : lastPage.length) > 9 ? (pages === null || pages === void 0 ? void 0 : pages.length) + 1 : undefined;
        },
        enabled: (!!(param === null || param === void 0 ? void 0 : param.keyword) || !!param.end_date || !!param.start_date) && param.other_userid !== "undefined",
        refetchOnMount: "always"
    });
};
const useQueryGetListNewsByUser = (search, sort)=>{
    return (0,modern_useInfiniteQuery/* useInfiniteQuery */.N)({
        queryKey: [
            configs/* QUERY_KEY.LIST_NEWS_BY_USER */.lP.LIST_NEWS_BY_USER,
            sort
        ],
        queryFn: (param)=>{
            let { pageParam  } = param;
            return getAllNewsByUser(pageParam, sort);
        },
        initialPageParam: 1,
        getNextPageParam: (lastPage, pages)=>{
            return (lastPage === null || lastPage === void 0 ? void 0 : lastPage.length) > 9 ? (pages === null || pages === void 0 ? void 0 : pages.length) + 1 : undefined;
        },
        enabled: !search,
        refetchOnMount: "always",
        staleTime: 0,
        refetchOnWindowFocus: "always",
        notifyOnChangeProps: [
            "data"
        ]
    });
};
const useQueryGetListNewsByOtherUserId = (search, sort, other_userid)=>{
    return (0,modern_useInfiniteQuery/* useInfiniteQuery */.N)({
        queryKey: [
            configs/* QUERY_KEY.LIST_NEWS_BY_OTHER_USER */.lP.LIST_NEWS_BY_OTHER_USER,
            sort,
            other_userid
        ],
        queryFn: (param)=>{
            let { pageParam  } = param;
            return getAllNewsByOtherUser(pageParam, sort, other_userid);
        },
        initialPageParam: 1,
        getNextPageParam: (lastPage, pages)=>{
            return (lastPage === null || lastPage === void 0 ? void 0 : lastPage.length) > 9 ? (pages === null || pages === void 0 ? void 0 : pages.length) + 1 : undefined;
        },
        enabled: !search && other_userid !== "undefined",
        refetchOnMount: "always"
    });
};
const useQueryGetListNews = ()=>{
    return useInfiniteQuery({
        queryKey: [
            QUERY_KEY.LIST_NEWS
        ],
        queryFn: (param)=>{
            let { pageParam  } = param;
            return getNewsFn(pageParam);
        },
        initialPageParam: 1,
        getNextPageParam: (lastPage, pages)=>{
            return (lastPage === null || lastPage === void 0 ? void 0 : lastPage.length) > 9 ? (pages === null || pages === void 0 ? void 0 : pages.length) + 1 : undefined;
        }
    });
};
const useQueryGetListStoredNews = (keyword, sort)=>{
    return (0,modern_useInfiniteQuery/* useInfiniteQuery */.N)({
        queryKey: [
            configs/* QUERY_KEY.LIST_STORED_NEWS */.lP.LIST_STORED_NEWS,
            keyword,
            sort
        ],
        queryFn: (param)=>{
            let { pageParam  } = param;
            return getListStoreNewsFn(pageParam, keyword, sort);
        },
        initialPageParam: 1,
        getNextPageParam: (lastPage, pages)=>{
            return (lastPage === null || lastPage === void 0 ? void 0 : lastPage.length) > 9 ? (pages === null || pages === void 0 ? void 0 : pages.length) + 1 : undefined;
        },
        refetchOnMount: "always"
    });
};
const useQueryGetListRelatedNews = (param)=>{
    let { id , limit , type  } = param;
    return (0,useQuery/* useQuery */.a)({
        queryKey: [
            configs/* QUERY_KEY.LIST_RELATED_NEWS */.lP.LIST_RELATED_NEWS,
            id
        ],
        queryFn: ()=>getRelatedNews({
                pageParam: 1,
                id,
                limit
            }),
        enabled: !!id && id !== "undefined" && type !== "undefined" && type === "news"
    });
};
const useQueryGetListRelatedNewsByGame = (param)=>{
    let { game_id , limit =10  } = param;
    return (0,modern_useInfiniteQuery/* useInfiniteQuery */.N)({
        queryKey: [
            configs/* QUERY_KEY.LIST_RELATED_NEWS_BY_GAME */.lP.LIST_RELATED_NEWS_BY_GAME,
            game_id
        ],
        queryFn: (param)=>{
            let { pageParam  } = param;
            return getRelatedNewsByGame({
                pageParam: pageParam,
                game_id,
                limit
            });
        },
        initialPageParam: 1,
        getNextPageParam: (lastPage, pages)=>{
            return (lastPage === null || lastPage === void 0 ? void 0 : lastPage.length) > limit - 1 ? (pages === null || pages === void 0 ? void 0 : pages.length) + 1 : undefined;
        },
        enabled: !!game_id && game_id !== "undefined"
    });
};
const useQueryCheckDraft = (type)=>{
    return (0,useQuery/* useQuery */.a)({
        queryKey: [
            configs/* QUERY_KEY.CHECK_DRAFT */.lP.CHECK_DRAFT
        ],
        queryFn: ()=>checkDraftFn(),
        enabled: !!type && type === String(configs/* CreateType.CREATE_POST */.q0.CREATE_POST)
    });
};
const useQueryGetListHotNews = (type, limit)=>{
    return (0,useQuery/* useQuery */.a)({
        queryKey: [
            configs/* QUERY_KEY.LIST_HOT */.lP.LIST_HOT,
            type,
            limit
        ],
        queryFn: ()=>getNewsByTypeFn(type, limit)
    });
};
const useQueryGetListForYou = (type, limit)=>{
    return (0,useQuery/* useQuery */.a)({
        queryKey: [
            configs/* QUERY_KEY.NEWS_FOR_YOU */.lP.NEWS_FOR_YOU,
            type,
            limit
        ],
        queryFn: ()=>getNewsByTypeFn(type, limit)
    });
};
const useQueryGetListNewsLatest = (params)=>{
    return (0,modern_useInfiniteQuery/* useInfiniteQuery */.N)({
        queryKey: [
            configs/* QUERY_KEY.LIST_NEWS_LATEST */.lP.LIST_NEWS_LATEST,
            Object.values(params).join("_")
        ],
        queryFn: (param)=>{
            let { pageParam  } = param;
            return getLatestNewsFn({
                ...params,
                page: pageParam
            });
        },
        initialPageParam: 1,
        getNextPageParam: (lastPage, pages)=>{
            return (lastPage === null || lastPage === void 0 ? void 0 : lastPage.length) > 9 ? (pages === null || pages === void 0 ? void 0 : pages.length) + 1 : undefined;
        }
    });
};

;// CONCATENATED MODULE: ./app/services/query-fn/news/news-detail-query.ts



const getCommentsFn = async (postId, pageParam)=>{
    const data = await services/* NewsService.getCommentByNewsId */.Y.getCommentByNewsId(postId, pageParam);
    return data.data.data;
};
const getNewsDetail = async (id)=>{
    var _data_data;
    const data = await services/* NewsService.getNewsDetail */.Y.getNewsDetail(id);
    return data === null || data === void 0 ? void 0 : (_data_data = data.data) === null || _data_data === void 0 ? void 0 : _data_data.data;
};
const getNewsDetailForEdit = async (id)=>{
    var _data_data;
    const data = await services/* NewsService.getNewsDetailForEdit */.Y.getNewsDetailForEdit(id);
    return data === null || data === void 0 ? void 0 : (_data_data = data.data) === null || _data_data === void 0 ? void 0 : _data_data.data;
};
const getListRepliesByIdFn = async (body, pageParam)=>{
    var _data_data;
    const data = await services/* NewsService.getListReplies */.Y.getListReplies({
        ...body,
        page: String(pageParam)
    });
    return data === null || data === void 0 ? void 0 : (_data_data = data.data) === null || _data_data === void 0 ? void 0 : _data_data.data;
};
const getStickersByUser = async ()=>{
    var _data_data;
    const data = await services/* NewsService.getStickersByUser */.Y.getStickersByUser();
    return data === null || data === void 0 ? void 0 : (_data_data = data.data) === null || _data_data === void 0 ? void 0 : _data_data.data;
};
const useQueryGetNewsDetail = (id, type)=>{
    return (0,useQuery/* useQuery */.a)({
        queryKey: [
            configs/* QUERY_KEY.NEWS_DETAIL */.lP.NEWS_DETAIL,
            id
        ],
        queryFn: ()=>getNewsDetail(id),
        enabled: !!id && id !== "undefined" && type === "news"
    });
};
const useQueryGetNewsDetailForEdit = (id, type)=>{
    return (0,useQuery/* useQuery */.a)({
        queryKey: [
            configs/* QUERY_KEY.NEWS_DETAIL_FOR_EDIT */.lP.NEWS_DETAIL_FOR_EDIT,
            id
        ],
        queryFn: ()=>getNewsDetailForEdit(id),
        enabled: !!id && id !== "undefined" && type === "news"
    });
};
const useQueryGetListComments = (postId)=>{
    return (0,modern_useInfiniteQuery/* useInfiniteQuery */.N)({
        queryKey: [
            configs/* QUERY_KEY.LIST_COMMENT */.lP.LIST_COMMENT,
            postId
        ],
        queryFn: (param)=>{
            let { pageParam  } = param;
            return getCommentsFn(postId, pageParam);
        },
        initialPageParam: 1,
        getNextPageParam: (lastPage, pages)=>{
            return (lastPage === null || lastPage === void 0 ? void 0 : lastPage.length) >= configs/* COMMENT_LIMIT_SIZE */.au ? (pages === null || pages === void 0 ? void 0 : pages.length) + 1 : 0;
        },
        enabled: !!postId
    });
};
const useQueryGetListReplies = (body, isShow)=>{
    return (0,modern_useInfiniteQuery/* useInfiniteQuery */.N)({
        queryKey: [
            configs/* QUERY_KEY.LIST_REPLY */.lP.LIST_REPLY,
            {
                id: body.id,
                comment_id: body.comment_id
            }
        ],
        queryFn: (param)=>{
            let { pageParam  } = param;
            return getListRepliesByIdFn(body, pageParam);
        },
        initialPageParam: 1,
        getNextPageParam: (lastPage, pages)=>{
            return (lastPage === null || lastPage === void 0 ? void 0 : lastPage.length) >= configs/* REPLY_LIMIT_SIZE */.bn ? (pages === null || pages === void 0 ? void 0 : pages.length) + 1 : 0;
        },
        enabled: !!body.id && !!body.comment_id && isShow
    });
};
const useQueryGetStickerUser = ()=>{
    return (0,useQuery/* useQuery */.a)({
        queryKey: [
            configs/* QUERY_KEY.GET_STICKER_USER */.lP.GET_STICKER_USER
        ],
        queryFn: getStickersByUser
    });
};

// EXTERNAL MODULE: ./node_modules/@tanstack/react-query/build/modern/useMutation.js + 1 modules
var useMutation = __webpack_require__(98029);
;// CONCATENATED MODULE: ./app/services/query-fn/news/create-news-mutation.ts



const addNewsFn = (body)=>{
    return services/* NewsService.addnews */.Y.addnews(body);
};
const saveDraftFn = (body)=>{
    return services/* NewsService.saveDraft */.Y.saveDraft(body);
};
const deletaDraftFn = (body)=>{
    return services/* NewsService.deleteDraft */.Y.deleteDraft(body);
};
const uploadMediaFn = (formData)=>{
    return services/* NewsService.uploadMedia */.Y.uploadMedia(formData);
};
const editNewsFn = (body)=>{
    return services/* NewsService.editNews */.Y.editNews(body);
};
const useMutationUploadMedia = ()=>{
    return (0,useMutation/* useMutation */.D)({
        mutationKey: [
            configs/* QUERY_KEY.UPLOAD_MEDIA */.lP.UPLOAD_MEDIA
        ],
        mutationFn: uploadMediaFn
    });
};
const useMutationCreateNews = ()=>{
    return (0,useMutation/* useMutation */.D)({
        mutationKey: [
            configs/* QUERY_KEY.CREATE_NEWS */.lP.CREATE_NEWS
        ],
        mutationFn: addNewsFn
    });
};
const useMutationEditNews = ()=>{
    return (0,useMutation/* useMutation */.D)({
        mutationKey: [
            configs/* QUERY_KEY.EDIT_NEWS */.lP.EDIT_NEWS
        ],
        mutationFn: editNewsFn
    });
};
const useMutationSaveDraft = ()=>{
    return (0,useMutation/* useMutation */.D)({
        mutationKey: [
            configs/* QUERY_KEY.SAVE_DRAFT */.lP.SAVE_DRAFT
        ],
        mutationFn: saveDraftFn
    });
};
const useMutationDeleteDraft = ()=>{
    return (0,useMutation/* useMutation */.D)({
        mutationKey: [
            configs/* QUERY_KEY.DELETE_DRAFT */.lP.DELETE_DRAFT
        ],
        mutationFn: deletaDraftFn
    });
};

;// CONCATENATED MODULE: ./app/services/query-fn/news/news-detail-mutation.ts



const commentToPostFn = async (formData)=>{
    return services/* NewsService.commentToPost */.Y.commentToPost(formData);
};
const likePostFn = async (body)=>services/* NewsService.likePost */.Y.likePost(body);
const likeCommentFn = async (body)=>services/* NewsService.likeComment */.Y.likeComment(body);
const replyToCommentFn = async (formData)=>{
    return services/* NewsService.replyToComment */.Y.replyToComment(formData);
};
const deleteCommentFn = async (body)=>{
    return services/* NewsService.deleteComment */.Y.deleteComment(body);
};
const updateCommentFn = async (formData)=>{
    return services/* NewsService.updateComment */.Y.updateComment(formData);
};
const deleteNews = async (id)=>{
    return services/* NewsService.deleteNews */.Y.deleteNews(id);
};
const storeNews = async (id)=>{
    return services/* NewsService.storeNews */.Y.storeNews(id);
};
const removeStoreNews = async (id)=>{
    return services/* NewsService.removeStoreNews */.Y.removeStoreNews(id);
};
const useMutationStoreNews = ()=>{
    return (0,useMutation/* useMutation */.D)({
        mutationKey: [
            configs/* QUERY_KEY.STORE_NEWS */.lP.STORE_NEWS
        ],
        mutationFn: storeNews
    });
};
const useMutationRemoveStoreNews = ()=>{
    return (0,useMutation/* useMutation */.D)({
        mutationKey: [
            configs/* QUERY_KEY.REMOVE_STORE_NEWS */.lP.REMOVE_STORE_NEWS
        ],
        mutationFn: removeStoreNews
    });
};
const useMutationDeleteNews = ()=>{
    return (0,useMutation/* useMutation */.D)({
        mutationKey: [
            configs/* QUERY_KEY.DELETE_NEWS */.lP.DELETE_NEWS
        ],
        mutationFn: deleteNews
    });
};
const useMutationCommentToPostFn = ()=>{
    return (0,useMutation/* useMutation */.D)({
        mutationKey: [
            configs/* QUERY_KEY.ADD_COMMENT */.lP.ADD_COMMENT
        ],
        mutationFn: commentToPostFn
    });
};
const useMutationReplyToComment = ()=>{
    return (0,useMutation/* useMutation */.D)({
        mutationKey: [
            configs/* QUERY_KEY.REPLY_COMMENT */.lP.REPLY_COMMENT
        ],
        mutationFn: replyToCommentFn
    });
};
const useMutationLikePost = ()=>{
    return (0,useMutation/* useMutation */.D)({
        mutationKey: [
            configs/* QUERY_KEY.LIKE_POST */.lP.LIKE_POST
        ],
        mutationFn: likePostFn
    });
};
const useMutationLikeComment = ()=>{
    return (0,useMutation/* useMutation */.D)({
        mutationKey: [
            configs/* QUERY_KEY.LIKE_COMMENT */.lP.LIKE_COMMENT
        ],
        mutationFn: likeCommentFn
    });
};
const useMutationDeleteComment = ()=>{
    return (0,useMutation/* useMutation */.D)({
        mutationKey: [
            configs/* QUERY_KEY.DELETE_COMMENT */.lP.DELETE_COMMENT
        ],
        mutationFn: deleteCommentFn
    });
};
const useMutationUpdateComment = ()=>{
    return (0,useMutation/* useMutation */.D)({
        mutationKey: [
            configs/* QUERY_KEY.UPDATE_COMMENT */.lP.UPDATE_COMMENT
        ],
        mutationFn: updateCommentFn
    });
};

;// CONCATENATED MODULE: ./app/services/query-fn/news/index.ts






/***/ }),

/***/ 76767:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "H": function() { return /* binding */ useQueryGetListNotification; }
});

// UNUSED EXPORTS: getListNotificationFn

// EXTERNAL MODULE: ./app/configs/index.ts + 3 modules
var configs = __webpack_require__(54254);
// EXTERNAL MODULE: ./node_modules/@tanstack/react-query/build/modern/useInfiniteQuery.js + 1 modules
var useInfiniteQuery = __webpack_require__(29726);
// EXTERNAL MODULE: ./app/api/index.ts
var api = __webpack_require__(34224);
// EXTERNAL MODULE: ./app/lib/utils.ts + 1 modules
var utils = __webpack_require__(73848);
;// CONCATENATED MODULE: ./app/services/services/NotificationService.ts


const resource = "/api/notification";
class NotificationService {
    static getNotices(page, noticeType) {
        const params = (0,utils/* removeNullKeyObject */.t2)({
            page: page,
            is_read: noticeType === "all" ? "" : 0
        });
        return api/* http.get */.d.get("".concat(resource, "/inbox"), {
            params: params
        });
    }
}


// EXTERNAL MODULE: ./node_modules/next/dist/compiled/react/index.js
var react = __webpack_require__(55784);
// EXTERNAL MODULE: ./app/context/index.ts + 2 modules
var context = __webpack_require__(17986);
;// CONCATENATED MODULE: ./app/services/query-fn/notification/notification-query.ts





const getListNotificationFn = async (pageParam, setUnReadCount, noticeType)=>{
    var _data_data_data, _data_data_data1;
    const data = await NotificationService.getNotices(pageParam, noticeType);
    setUnReadCount((_data_data_data = data.data.data) === null || _data_data_data === void 0 ? void 0 : _data_data_data.unreadCount);
    return (_data_data_data1 = data.data.data) === null || _data_data_data1 === void 0 ? void 0 : _data_data_data1.items;
};
const useQueryGetListNotification = (setUnReadCount, noticeType)=>{
    const { userInfo  } = (0,react.useContext)(context/* AppContext */.Il);
    return (0,useInfiniteQuery/* useInfiniteQuery */.N)({
        queryKey: [
            configs/* QUERY_KEY.NOTIFICATION_LIST */.lP.NOTIFICATION_LIST,
            {
                noticeType
            }
        ],
        queryFn: (param)=>{
            let { pageParam  } = param;
            return getListNotificationFn(pageParam, setUnReadCount, noticeType);
        },
        initialPageParam: 1,
        enabled: !!(userInfo === null || userInfo === void 0 ? void 0 : userInfo.userid),
        getNextPageParam: (lastPage, pages)=>{
            return (lastPage === null || lastPage === void 0 ? void 0 : lastPage.length) >= configs/* REPLY_LIMIT_SIZE */.bn ? (pages === null || pages === void 0 ? void 0 : pages.length) + 1 : 0;
        }
    });
};


/***/ }),

/***/ 88663:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$6": function() { return /* binding */ useMutationUploadAvatar; },
/* harmony export */   "E2": function() { return /* binding */ useMutationUpdateInviteCode; },
/* harmony export */   "Re": function() { return /* binding */ useMutationUpdateProfile; },
/* harmony export */   "bh": function() { return /* binding */ useMutationUpdateInterestTopic; },
/* harmony export */   "h4": function() { return /* binding */ useMutationUpdateLanguage; }
/* harmony export */ });
/* harmony import */ var _tanstack_react_query__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(98029);
/* harmony import */ var _services__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(27020);
/* harmony import */ var _app_configs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(54254);



const updateLanguageFn = (body)=>{
    return _services__WEBPACK_IMPORTED_MODULE_0__/* .UserService.updateLanguage */ .K.updateLanguage(body);
};
const updateAvatarFn = (body)=>{
    return _services__WEBPACK_IMPORTED_MODULE_0__/* .UserService.uploadImage */ .K.uploadImage(body);
};
const updateProfileFn = (body)=>{
    return _services__WEBPACK_IMPORTED_MODULE_0__/* .UserService.updateProfile */ .K.updateProfile(body);
};
const updateInterestTopicFn = (body)=>{
    return _services__WEBPACK_IMPORTED_MODULE_0__/* .UserService.updateInterestTopic */ .K.updateInterestTopic(body);
};
const updateInviteCodeFn = (body)=>{
    return _services__WEBPACK_IMPORTED_MODULE_0__/* .UserService.updateInviteCode */ .K.updateInviteCode(body);
};
const useMutationUpdateProfile = ()=>{
    return (0,_tanstack_react_query__WEBPACK_IMPORTED_MODULE_2__/* .useMutation */ .D)({
        mutationKey: [
            _app_configs__WEBPACK_IMPORTED_MODULE_1__/* .QUERY_KEY.UPDATE_PROFILE */ .lP.UPDATE_PROFILE
        ],
        mutationFn: updateProfileFn
    });
};
const useMutationUploadAvatar = ()=>{
    return (0,_tanstack_react_query__WEBPACK_IMPORTED_MODULE_2__/* .useMutation */ .D)({
        mutationKey: [
            _app_configs__WEBPACK_IMPORTED_MODULE_1__/* .QUERY_KEY.UPLOAD_AVATAR */ .lP.UPLOAD_AVATAR
        ],
        mutationFn: updateAvatarFn
    });
};
const useMutationUpdateLanguage = ()=>{
    return (0,_tanstack_react_query__WEBPACK_IMPORTED_MODULE_2__/* .useMutation */ .D)({
        mutationKey: [
            _app_configs__WEBPACK_IMPORTED_MODULE_1__/* .QUERY_KEY.UPDATE_LANGUAGE */ .lP.UPDATE_LANGUAGE
        ],
        mutationFn: updateLanguageFn
    });
};
const useMutationUpdateInterestTopic = ()=>{
    return (0,_tanstack_react_query__WEBPACK_IMPORTED_MODULE_2__/* .useMutation */ .D)({
        mutationKey: [
            _app_configs__WEBPACK_IMPORTED_MODULE_1__/* .QUERY_KEY.UPDATE_INTEREST_TOPIC */ .lP.UPDATE_INTEREST_TOPIC
        ],
        mutationFn: updateInterestTopicFn
    });
};
const useMutationUpdateInviteCode = ()=>{
    return (0,_tanstack_react_query__WEBPACK_IMPORTED_MODULE_2__/* .useMutation */ .D)({
        mutationFn: updateInviteCodeFn,
        mutationKey: [
            _app_configs__WEBPACK_IMPORTED_MODULE_1__/* .QUERY_KEY.UPDATE_INVITE_CODE */ .lP.UPDATE_INVITE_CODE
        ]
    });
};


/***/ }),

/***/ 3201:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "CH": function() { return /* binding */ useMutatonDoActionRequestFriend; },
/* harmony export */   "OX": function() { return /* binding */ useMutatonUnFriend; },
/* harmony export */   "TY": function() { return /* binding */ useMutatonAddFriend; },
/* harmony export */   "aK": function() { return /* binding */ useMutatonSendGift; },
/* harmony export */   "er": function() { return /* binding */ useMutatonCancelSendingRequestFn; }
/* harmony export */ });
/* harmony import */ var _tanstack_react_query__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(98029);
/* harmony import */ var _services_FriendSerivces__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(29951);
/* harmony import */ var _app_configs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(54254);
/* harmony import */ var _services__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(27020);




const addFriendFn = (body)=>{
    return _services_FriendSerivces__WEBPACK_IMPORTED_MODULE_0__/* .FriendService.addFriend */ .W.addFriend(body);
};
const unFriendFn = (body)=>{
    return _services_FriendSerivces__WEBPACK_IMPORTED_MODULE_0__/* .FriendService.unFriend */ .W.unFriend(body);
};
const sendGiftFriendFn = (body)=>{
    return _services__WEBPACK_IMPORTED_MODULE_2__/* .UserService.sendGift */ .K.sendGift(body.user_id, body.item_id);
};
const actionRequestFriendFn = (body)=>_services_FriendSerivces__WEBPACK_IMPORTED_MODULE_0__/* .FriendService.actionRequestFriend */ .W.actionRequestFriend(body);
const cancelSendingRequestFn = (body)=>_services_FriendSerivces__WEBPACK_IMPORTED_MODULE_0__/* .FriendService.cancelSendingRequest */ .W.cancelSendingRequest(body);
const useMutatonSendGift = ()=>{
    return (0,_tanstack_react_query__WEBPACK_IMPORTED_MODULE_3__/* .useMutation */ .D)({
        mutationKey: [
            _app_configs__WEBPACK_IMPORTED_MODULE_1__/* .QUERY_KEY.SEND_FRIEND */ .lP.SEND_FRIEND
        ],
        mutationFn: sendGiftFriendFn
    });
};
const useMutatonAddFriend = ()=>{
    return (0,_tanstack_react_query__WEBPACK_IMPORTED_MODULE_3__/* .useMutation */ .D)({
        mutationKey: [
            _app_configs__WEBPACK_IMPORTED_MODULE_1__/* .QUERY_KEY.ADD_FRIEND */ .lP.ADD_FRIEND
        ],
        mutationFn: addFriendFn
    });
};
const useMutatonUnFriend = ()=>{
    return (0,_tanstack_react_query__WEBPACK_IMPORTED_MODULE_3__/* .useMutation */ .D)({
        mutationKey: [
            _app_configs__WEBPACK_IMPORTED_MODULE_1__/* .QUERY_KEY.UN_FRIEND */ .lP.UN_FRIEND
        ],
        mutationFn: unFriendFn
    });
};
const useMutatonDoActionRequestFriend = ()=>{
    return (0,_tanstack_react_query__WEBPACK_IMPORTED_MODULE_3__/* .useMutation */ .D)({
        mutationKey: [
            _app_configs__WEBPACK_IMPORTED_MODULE_1__/* .QUERY_KEY.ACTION_REQUEST_FRIEND */ .lP.ACTION_REQUEST_FRIEND
        ],
        mutationFn: actionRequestFriendFn
    });
};
const useMutatonCancelSendingRequestFn = ()=>{
    return (0,_tanstack_react_query__WEBPACK_IMPORTED_MODULE_3__/* .useMutation */ .D)({
        mutationKey: [
            _app_configs__WEBPACK_IMPORTED_MODULE_1__/* .QUERY_KEY.CANCEL_SENDING_REQUEST */ .lP.CANCEL_SENDING_REQUEST
        ],
        mutationFn: cancelSendingRequestFn
    });
};


/***/ }),

/***/ 74799:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Cm": function() { return /* binding */ useQueryGetRequestFriend; },
/* harmony export */   "Ue": function() { return /* binding */ useQueryGetListFriendWithSearch; },
/* harmony export */   "Z6": function() { return /* binding */ useQueryGetSuggestFriend; },
/* harmony export */   "tf": function() { return /* binding */ useQueryGetListFriend; }
/* harmony export */ });
/* harmony import */ var _app_configs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(54254);
/* harmony import */ var _tanstack_react_query__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(29726);
/* harmony import */ var _services_FriendSerivces__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(29951);



const useQueryGetListFriend = (enable, keyword)=>{
    return (0,_tanstack_react_query__WEBPACK_IMPORTED_MODULE_2__/* .useInfiniteQuery */ .N)({
        queryKey: [
            _app_configs__WEBPACK_IMPORTED_MODULE_0__/* .QUERY_KEY.LIST_FRIEND */ .lP.LIST_FRIEND
        ],
        queryFn: async (param)=>{
            let { pageParam  } = param;
            var _res_data;
            const res = await _services_FriendSerivces__WEBPACK_IMPORTED_MODULE_1__/* .FriendService.getListFriend */ .W.getListFriend(pageParam);
            return res === null || res === void 0 ? void 0 : (_res_data = res.data) === null || _res_data === void 0 ? void 0 : _res_data.data;
        },
        initialPageParam: 1,
        getNextPageParam: (lastPage, pages)=>{
            return (lastPage === null || lastPage === void 0 ? void 0 : lastPage.length) > 9 ? (pages === null || pages === void 0 ? void 0 : pages.length) + 1 : undefined;
        },
        enabled: !!enable && !keyword
    });
};
const useQueryGetListFriendWithSearch = (enable, keyword)=>{
    return (0,_tanstack_react_query__WEBPACK_IMPORTED_MODULE_2__/* .useInfiniteQuery */ .N)({
        queryKey: [
            _app_configs__WEBPACK_IMPORTED_MODULE_0__/* .QUERY_KEY.LIST_FRIEND_WITH_SEARCH */ .lP.LIST_FRIEND_WITH_SEARCH,
            keyword
        ],
        queryFn: async (param)=>{
            let { pageParam  } = param;
            var _res_data;
            const res = await _services_FriendSerivces__WEBPACK_IMPORTED_MODULE_1__/* .FriendService.getListSearchFriend */ .W.getListSearchFriend(pageParam, keyword);
            return res === null || res === void 0 ? void 0 : (_res_data = res.data) === null || _res_data === void 0 ? void 0 : _res_data.data;
        },
        initialPageParam: 1,
        getNextPageParam: (lastPage, pages)=>{
            return (lastPage === null || lastPage === void 0 ? void 0 : lastPage.length) > 9 ? (pages === null || pages === void 0 ? void 0 : pages.length) + 1 : undefined;
        },
        enabled: !!enable && !!keyword
    });
};
const useQueryGetSuggestFriend = (enable)=>{
    return (0,_tanstack_react_query__WEBPACK_IMPORTED_MODULE_2__/* .useInfiniteQuery */ .N)({
        queryKey: [
            _app_configs__WEBPACK_IMPORTED_MODULE_0__/* .QUERY_KEY.LIST_SUGGEST_FRIEND */ .lP.LIST_SUGGEST_FRIEND
        ],
        queryFn: async (param)=>{
            let { pageParam  } = param;
            var _res_data;
            const res = await _services_FriendSerivces__WEBPACK_IMPORTED_MODULE_1__/* .FriendService.getListSuggestFriend */ .W.getListSuggestFriend(pageParam);
            return res === null || res === void 0 ? void 0 : (_res_data = res.data) === null || _res_data === void 0 ? void 0 : _res_data.data;
        },
        initialPageParam: 1,
        getNextPageParam: (lastPage, pages)=>{
            return (lastPage === null || lastPage === void 0 ? void 0 : lastPage.length) > 9 ? (pages === null || pages === void 0 ? void 0 : pages.length) + 1 : undefined;
        },
        enabled: !!enable
    });
};
const useQueryGetRequestFriend = (enable)=>{
    return (0,_tanstack_react_query__WEBPACK_IMPORTED_MODULE_2__/* .useInfiniteQuery */ .N)({
        queryKey: [
            _app_configs__WEBPACK_IMPORTED_MODULE_0__/* .QUERY_KEY.LIST_REQUEST_FRIEND */ .lP.LIST_REQUEST_FRIEND
        ],
        queryFn: async (param)=>{
            let { pageParam  } = param;
            var _res_data;
            const res = await _services_FriendSerivces__WEBPACK_IMPORTED_MODULE_1__/* .FriendService.getListRequestFriend */ .W.getListRequestFriend(pageParam);
            return res === null || res === void 0 ? void 0 : (_res_data = res.data) === null || _res_data === void 0 ? void 0 : _res_data.data;
        },
        initialPageParam: 1,
        getNextPageParam: (lastPage, pages)=>{
            return (lastPage === null || lastPage === void 0 ? void 0 : lastPage.length) > 9 ? (pages === null || pages === void 0 ? void 0 : pages.length) + 1 : undefined;
        },
        enabled: !!enable
    });
};


/***/ }),

/***/ 89174:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "P": function() { return /* binding */ EventService; }
/* harmony export */ });
/* harmony import */ var _app_api__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(34224);
/* harmony import */ var _app_lib_utils__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(73848);


const resource = "/v2/events";
class EventService {
    static getAllEvent(pageParam, keyword) {
        return _app_api__WEBPACK_IMPORTED_MODULE_0__/* .http.get */ .d.get("".concat(resource, "/list"), {
            params: !!keyword ? {
                page: pageParam,
                keyword
            } : {
                page: pageParam
            }
        });
    }
    static getDetailEvent(event_id) {
        return _app_api__WEBPACK_IMPORTED_MODULE_0__/* .http.get */ .d.get("/api/events/detail", {
            params: {
                event_id
            }
        });
    }
    static getRankEvent(event_id) {
        return _app_api__WEBPACK_IMPORTED_MODULE_0__/* .http.get */ .d.get("/api/events/rank", {
            params: {
                event_id
            }
        });
    }
    static getAllEventByHashtag(keyword, pageParam) {
        return _app_api__WEBPACK_IMPORTED_MODULE_0__/* .http.get */ .d.get("".concat(resource, "/hashtag"), {
            params: {
                page: pageParam,
                keyword
            }
        });
    }
    static getEventDetail(postId) {
        return _app_api__WEBPACK_IMPORTED_MODULE_0__/* .http.get */ .d.get("".concat(resource, "/view"), {
            params: {
                id: postId
            }
        });
    }
    static getEventDetailForEdit(postId) {
        return _app_api__WEBPACK_IMPORTED_MODULE_0__/* .http.get */ .d.get("".concat(resource, "/detail"), {
            params: {
                id: postId
            }
        });
    }
    static addEvent(body) {
        return _app_api__WEBPACK_IMPORTED_MODULE_0__/* .http.post */ .d.post("".concat(resource, "/add"), body);
    }
    static editEvent(body) {
        return _app_api__WEBPACK_IMPORTED_MODULE_0__/* .http.post */ .d.post("".concat(resource, "/edit"), body);
    }
    static uploadMedia(formData) {
        return _app_api__WEBPACK_IMPORTED_MODULE_0__/* .http.post */ .d.post("v2/upload/media", formData, {
            headers: {
                "Content-Type": "multipart/form-data"
            }
        });
    }
    static deleteEvent(id) {
        return _app_api__WEBPACK_IMPORTED_MODULE_0__/* .http.post */ .d.post("".concat(resource, "/delete"), {
            id
        });
    }
    static joinEvent(id) {
        return _app_api__WEBPACK_IMPORTED_MODULE_0__/* .http.post */ .d.post("".concat(resource, "/join"), {
            id
        });
    }
    static regNotificationEvent(id) {
        return _app_api__WEBPACK_IMPORTED_MODULE_0__/* .http.post */ .d.post("".concat(resource, "/regNoti"), {
            id
        });
    }
    static checkDraft() {
        return _app_api__WEBPACK_IMPORTED_MODULE_0__/* .http.post */ .d.post("".concat(resource, "/draf"));
    }
    static saveDraft(body) {
        return _app_api__WEBPACK_IMPORTED_MODULE_0__/* .http.post */ .d.post("".concat(resource, "/saveDraf"), body);
    }
    static deleteDraft(body) {
        return _app_api__WEBPACK_IMPORTED_MODULE_0__/* .http.post */ .d.post("".concat(resource, "/delete"), body);
    }
    static getListEventsByType(param) {
        const result = (0,_app_lib_utils__WEBPACK_IMPORTED_MODULE_1__/* .removeNullKeyObject */ .t2)(param);
        return _app_api__WEBPACK_IMPORTED_MODULE_0__/* .http.get */ .d.get("".concat(resource, "/search"), {
            params: {
                ...result
            }
        });
    }
    static relatedEvent(params) {
        return _app_api__WEBPACK_IMPORTED_MODULE_0__/* .http.get */ .d.get("".concat(resource, "/related"), {
            params: {
                page: String(params.pageParam),
                id: params.id,
                limit: String(params.limit)
            }
        });
    }
    static relatedEventByGame(params) {
        return _app_api__WEBPACK_IMPORTED_MODULE_0__/* .http.get */ .d.get("".concat(resource, "/listByGame"), {
            params: {
                page: String(params.pageParam),
                game_id: params.game_id,
                limit: String(params.limit)
            }
        });
    }
    static getMyEvent(param, pageParam) {
        return _app_api__WEBPACK_IMPORTED_MODULE_0__/* .http.get */ .d.get("".concat(resource, "/listByUser"), {
            params: {
                ...param,
                page: pageParam
            }
        });
    }
    static getOtherUserEvent(param, pageParam) {
        return _app_api__WEBPACK_IMPORTED_MODULE_0__/* .http.get */ .d.get("".concat(resource, "/listByUser"), {
            params: {
                ...param,
                page: pageParam
            }
        });
    }
}


/***/ }),

/***/ 29951:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "W": function() { return /* binding */ FriendService; }
/* harmony export */ });
/* harmony import */ var _app_api__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(34224);

const resource = "/api/users";
class FriendService {
    static getListFriend(page) {
        return _app_api__WEBPACK_IMPORTED_MODULE_0__/* .http.get */ .d.get("".concat(resource, "/listFriend"), {
            params: {
                page
            }
        });
    }
    static getListSearchFriend(page, keyword) {
        return _app_api__WEBPACK_IMPORTED_MODULE_0__/* .http.get */ .d.get("".concat(resource, "/searchFriend"), {
            params: {
                page,
                keyword
            }
        });
    }
    static getListSuggestFriend(page) {
        return _app_api__WEBPACK_IMPORTED_MODULE_0__/* .http.get */ .d.get("".concat(resource, "/suggestFriend"), {
            params: {
                page
            }
        });
    }
    static getListRequestFriend(page) {
        return _app_api__WEBPACK_IMPORTED_MODULE_0__/* .http.get */ .d.get("".concat(resource, "/listRequestFriend"), {
            params: {
                page
            }
        });
    }
    static addFriend(body) {
        return _app_api__WEBPACK_IMPORTED_MODULE_0__/* .http.post */ .d.post("".concat(resource, "/addFriend"), body);
    }
    static unFriend(body) {
        return _app_api__WEBPACK_IMPORTED_MODULE_0__/* .http.post */ .d.post("".concat(resource, "/unFriend"), body);
    }
    static actionRequestFriend(body) {
        return _app_api__WEBPACK_IMPORTED_MODULE_0__/* .http.post */ .d.post("".concat(resource, "/acceptRequestFriend"), body);
    }
    static cancelSendingRequest(body) {
        return _app_api__WEBPACK_IMPORTED_MODULE_0__/* .http.post */ .d.post("".concat(resource, "/removeRequestFriend"), body);
    }
}


/***/ }),

/***/ 54309:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "o": function() { return /* binding */ GameServices; }
/* harmony export */ });
/* harmony import */ var _app_api__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(34224);

const resource = "/api/games";
class GameServices {
    static getAllGames(params) {
        return _app_api__WEBPACK_IMPORTED_MODULE_0__/* .http.get */ .d.get("".concat(resource, "/list"), {
            params
        });
    }
    static getAllCategories() {
        return _app_api__WEBPACK_IMPORTED_MODULE_0__/* .http.get */ .d.get("".concat(resource, "/category"));
    }
    //game detail
    static getGameDetail(params) {
        return _app_api__WEBPACK_IMPORTED_MODULE_0__/* .http.get */ .d.get("".concat(resource, "/view"), {
            params: {
                id: params.game_id
            }
        });
    }
    static followGame(params) {
        return _app_api__WEBPACK_IMPORTED_MODULE_0__/* .http.post */ .d.post("".concat(resource, "/follow"), {
            game_id: params.game_id
        });
    }
    static registerGame(params) {
        return _app_api__WEBPACK_IMPORTED_MODULE_0__/* .http.post */ .d.post("".concat(resource, "/preRegister"), {
            game_id: params.game_id
        });
    }
    static getReviewByGame(params) {
        return _app_api__WEBPACK_IMPORTED_MODULE_0__/* .http.get */ .d.get("".concat(resource, "/listReview"), {
            params
        });
    }
    static rateGame(params) {
        return _app_api__WEBPACK_IMPORTED_MODULE_0__/* .http.post */ .d.post("".concat(resource, "/rate"), {
            ...params
        });
    }
    static likeReviewGame(params) {
        return _app_api__WEBPACK_IMPORTED_MODULE_0__/* .http.post */ .d.post("".concat(resource, "/likeReview"), {
            ...params
        });
    }
    static replyReviewGame(params) {
        return _app_api__WEBPACK_IMPORTED_MODULE_0__/* .http.post */ .d.post("".concat(resource, "/replyReview"), {
            ...params
        });
    }
    static deleteReviewGame(params) {
        return _app_api__WEBPACK_IMPORTED_MODULE_0__/* .http.post */ .d.post("".concat(resource, "/deleteRate"), {
            ...params
        });
    }
    static deleteReplyReviewGame(params) {
        return _app_api__WEBPACK_IMPORTED_MODULE_0__/* .http.post */ .d.post("".concat(resource, "/deleteReply"), {
            ...params
        });
    }
    static getListBanner(params) {
        return _app_api__WEBPACK_IMPORTED_MODULE_0__/* .http.get */ .d.get("/api/banner/list", {
            params
        });
    }
    static getListFollowGame(other_userid) {
        return _app_api__WEBPACK_IMPORTED_MODULE_0__/* .http.get */ .d.get("".concat(resource, "/listFollow"), {
            params: {
                other_userid
            }
        });
    }
}


/***/ }),

/***/ 56427:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "t": function() { return /* binding */ GiftcodeServices; }
/* harmony export */ });
/* harmony import */ var _app_api__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(34224);

const resource = "/gc";
class GiftcodeServices {
    static getAllGiftcode(params) {
        return _app_api__WEBPACK_IMPORTED_MODULE_0__/* .http.get */ .d.get("".concat(resource, "/events"), {
            params
        });
    }
    static getGiftcodeDetail(param) {
        let { event_id  } = param;
        return _app_api__WEBPACK_IMPORTED_MODULE_0__/* .http.get */ .d.get("".concat(resource, "/events/detail/").concat(event_id), {
            params: {
                event_id
            }
        });
    }
    static getGiftcodeInfo(param) {
        let { event_id  } = param;
        return _app_api__WEBPACK_IMPORTED_MODULE_0__/* .http.get */ .d.get("".concat(resource, "/events/getGiftcode/").concat(event_id), {
            params: {
                event_id
            }
        });
    }
    static getGameGiftcode() {
        return _app_api__WEBPACK_IMPORTED_MODULE_0__/* .http.get */ .d.get("".concat(resource, "/games/list"));
    }
    static getServerGiftcode(params) {
        return _app_api__WEBPACK_IMPORTED_MODULE_0__/* .http.get */ .d.get("".concat(resource, "/games/server/").concat(params === null || params === void 0 ? void 0 : params.game_id), {
            params
        });
    }
    static getRoleGiftcode(params) {
        return _app_api__WEBPACK_IMPORTED_MODULE_0__/* .http.get */ .d.get("".concat(resource, "/games/role/").concat(params === null || params === void 0 ? void 0 : params.game_id), {
            params
        });
    }
    static useGiftcode(params) {
        return _app_api__WEBPACK_IMPORTED_MODULE_0__/* .http.post */ .d.post("".concat(resource, "/games/useGiftcode/").concat(params === null || params === void 0 ? void 0 : params.game_id), params);
    }
}


/***/ }),

/***/ 82303:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "f": function() { return /* binding */ MerchandiseService; }
/* harmony export */ });
/* harmony import */ var _app_api__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(34224);
/* harmony import */ var _app_lib_utils__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(73848);


const resource = "/shops";
class MerchandiseService {
    static createAddress(body) {
        return _app_api__WEBPACK_IMPORTED_MODULE_0__/* .http.post */ .d.post("".concat(resource, "/payment/address/create"), body);
    }
    static deleteAddress(id) {
        return _app_api__WEBPACK_IMPORTED_MODULE_0__/* .http.post */ .d.post("".concat(resource, "/payment/address/delete"), {
            id
        });
    }
    static updateAddress(body) {
        const _body = (0,_app_lib_utils__WEBPACK_IMPORTED_MODULE_1__/* .removeNullKeyObject */ .t2)(body);
        return _app_api__WEBPACK_IMPORTED_MODULE_0__/* .http.post */ .d.post("".concat(resource, "/payment/address/update"), _body);
    }
    static getListMerchandise(params) {
        return _app_api__WEBPACK_IMPORTED_MODULE_0__/* .http.get */ .d.get("".concat(resource, "/items/list"), {
            params
        });
    }
    static getListCategory() {
        return _app_api__WEBPACK_IMPORTED_MODULE_0__/* .http.get */ .d.get("".concat(resource, "/items/category"));
    }
    static getListGame() {
        return _app_api__WEBPACK_IMPORTED_MODULE_0__/* .http.get */ .d.get("".concat(resource, "/items/games"));
    }
    static getListCart() {
        return _app_api__WEBPACK_IMPORTED_MODULE_0__/* .http.get */ .d.get("".concat(resource, "/items/listCards"));
    }
    static getMerchandiseDetail(id) {
        return _app_api__WEBPACK_IMPORTED_MODULE_0__/* .http.get */ .d.get("".concat(resource, "/items/detail"), {
            params: {
                id
            }
        });
    }
    static addToCart(body) {
        const _body = (0,_app_lib_utils__WEBPACK_IMPORTED_MODULE_1__/* .removeNullKeyObject */ .t2)(body);
        return _app_api__WEBPACK_IMPORTED_MODULE_0__/* .http.post */ .d.post("".concat(resource, "/items/addCards"), _body);
    }
    static buyNow(body) {
        const _body = (0,_app_lib_utils__WEBPACK_IMPORTED_MODULE_1__/* .removeNullKeyObject */ .t2)(body);
        return _app_api__WEBPACK_IMPORTED_MODULE_0__/* .http.post */ .d.post("".concat(resource, "/items/quickBuy"), _body);
    }
    static updateCart(body) {
        const _body = (0,_app_lib_utils__WEBPACK_IMPORTED_MODULE_1__/* .removeNullKeyObject */ .t2)(body);
        return _app_api__WEBPACK_IMPORTED_MODULE_0__/* .http.post */ .d.post("".concat(resource, "/items/updateCards"), _body);
    }
    static updateQuickCart(body) {
        const _body = (0,_app_lib_utils__WEBPACK_IMPORTED_MODULE_1__/* .removeNullKeyObject */ .t2)(body);
        return _app_api__WEBPACK_IMPORTED_MODULE_0__/* .http.post */ .d.post("".concat(resource, "/items/updateQuickBuyInfo"), _body);
    }
    static deleteCart(id) {
        return _app_api__WEBPACK_IMPORTED_MODULE_0__/* .http.post */ .d.post("".concat(resource, "/items/deleteCards"), {
            id
        });
    }
    static getMerchandiseMethod() {
        return _app_api__WEBPACK_IMPORTED_MODULE_0__/* .http.get */ .d.get("".concat(resource, "/items/methods"));
    }
    static getMerchandiseListAddress() {
        return _app_api__WEBPACK_IMPORTED_MODULE_0__/* .http.get */ .d.get("".concat(resource, "/payment/address"));
    }
    static createPaymentMerchandise(body) {
        return _app_api__WEBPACK_IMPORTED_MODULE_0__/* .http.post */ .d.post("".concat(resource, "/payment/createPayment"), body);
    }
    static createQuickPaymentMerchandise(body) {
        return _app_api__WEBPACK_IMPORTED_MODULE_0__/* .http.post */ .d.post("".concat(resource, "/payment/buyNow"), body);
    }
    static getPaymentMerchandiseCallback(params) {
        return _app_api__WEBPACK_IMPORTED_MODULE_0__/* .http.get */ .d.get("".concat(resource, "/payment/callback"), {
            params
        });
    }
    static getPaymentMerchandiseOnepayCallback(params) {
        return _app_api__WEBPACK_IMPORTED_MODULE_0__/* .http.get */ .d.get("".concat(resource, "/payment/onePayCallback"), {
            params
        });
    }
    static getPaymentMerchandiseHistory(params) {
        return _app_api__WEBPACK_IMPORTED_MODULE_0__/* .http.get */ .d.get("".concat(resource, "/payment/history"), {
            params
        });
    }
    static getPaymentMerchandiseTransaction(param) {
        let { transaction_id  } = param;
        return _app_api__WEBPACK_IMPORTED_MODULE_0__/* .http.get */ .d.get("".concat(resource, "/payment/history/").concat(transaction_id), {
            params: {
                transaction_id
            }
        });
    }
    static getPaymentFeeShip(params) {
        return _app_api__WEBPACK_IMPORTED_MODULE_0__/* .http.post */ .d.post("".concat(resource, "/payment/getFeeShip"), params);
    }
    static destroyOrder(params) {
        return _app_api__WEBPACK_IMPORTED_MODULE_0__/* .http.post */ .d.post("".concat(resource, "/payment/destroyOrder"), params);
    }
    static getListVoucherMerchandise(param) {
        let { item_id  } = param;
        return _app_api__WEBPACK_IMPORTED_MODULE_0__/* .http.get */ .d.get("".concat(resource, "/vouchers/listByItem"), {
            params: {
                item_id
            }
        });
    }
    static checkoutVoucherMerchandiseInfo(params) {
        const _param = (0,_app_lib_utils__WEBPACK_IMPORTED_MODULE_1__/* .removeNullKeyObject */ .t2)(params);
        return _app_api__WEBPACK_IMPORTED_MODULE_0__/* .http.post */ .d.post("".concat(resource, "/vouchers/check"), _param);
    }
}


/***/ }),

/***/ 97393:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ RewardService; }
/* harmony export */ });
/* harmony import */ var _app_api__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(34224);

const resource = "/api/task";
const resourceUser = "/api/bag";
const resourceSpin = "/api/spin";
const resourceShop = "/api/shop";
class RewardService {
    static getListTask() {
        return _app_api__WEBPACK_IMPORTED_MODULE_0__/* .http.get */ .d.get("".concat(resource, "/list"), {
            params: {
                limit: 20
            }
        });
    }
    static confirmTask(task_id) {
        return _app_api__WEBPACK_IMPORTED_MODULE_0__/* .http.post */ .d.post("".concat(resource, "/confirm"), {
            task_id
        });
    }
    // verify account task
    static verifyAccountTask(params) {
        return _app_api__WEBPACK_IMPORTED_MODULE_0__/* .http.post */ .d.post("".concat(resource, "/verifyAccount"), params);
    }
    static confirmVerifyAccountCode(params) {
        return _app_api__WEBPACK_IMPORTED_MODULE_0__/* .http.post */ .d.post("".concat(resource, "/verifyAccount/confirm-code"), params);
    }
    static resendVerifyAccountCode() {
        return _app_api__WEBPACK_IMPORTED_MODULE_0__/* .http.post */ .d.post("".concat(resource, "/verifyAccount/resend-code"));
    }
    static getPackage(params) {
        return _app_api__WEBPACK_IMPORTED_MODULE_0__/* .http.get */ .d.get("".concat(resourceUser, "/items"), {
            params: params
        });
    }
    static getGameByGiftcode(params) {
        return _app_api__WEBPACK_IMPORTED_MODULE_0__/* .http.get */ .d.get("".concat(resourceUser, "/listGameByItem"), {
            params: params
        });
    }
    static getItemBag(params) {
        return _app_api__WEBPACK_IMPORTED_MODULE_0__/* .http.post */ .d.post("".concat(resourceUser, "/useItem"), params);
    }
    static getListSpin() {
        return _app_api__WEBPACK_IMPORTED_MODULE_0__/* .http.get */ .d.get("".concat(resourceSpin, "/items"));
    }
    static getDetailSpin(spin_id) {
        return _app_api__WEBPACK_IMPORTED_MODULE_0__/* .http.get */ .d.get("".concat(resourceSpin, "/items/").concat(spin_id));
    }
    static doSpin(spin_id) {
        return _app_api__WEBPACK_IMPORTED_MODULE_0__/* .http.post */ .d.post("".concat(resourceSpin, "/doSpin"), {
            spin_id
        });
    }
    static getLeaderboard(query) {
        return _app_api__WEBPACK_IMPORTED_MODULE_0__/* .http.get */ .d.get("".concat(resource, "/rank"), {
            params: {
                filter: query
            }
        });
    }
    static historySpin(page) {
        return _app_api__WEBPACK_IMPORTED_MODULE_0__/* .http.get */ .d.get("".concat(resourceSpin, "/history"), {
            params: {
                page
            }
        });
    }
    static historyDetailSpin(spin_id, page) {
        return _app_api__WEBPACK_IMPORTED_MODULE_0__/* .http.get */ .d.get("".concat(resourceSpin, "/history/").concat(spin_id), {
            params: {
                page
            }
        });
    }
    static getLastSpin() {
        return _app_api__WEBPACK_IMPORTED_MODULE_0__/* .http.get */ .d.get("".concat(resourceSpin, "/lastHistory"));
    }
    //shop
    static getListShop(params) {
        return _app_api__WEBPACK_IMPORTED_MODULE_0__/* .http.get */ .d.get("".concat(resourceShop, "/items"), {
            params: params
        });
    }
    static buyItem(params) {
        return _app_api__WEBPACK_IMPORTED_MODULE_0__/* .http.post */ .d.post("".concat(resourceShop, "/buyItem"), params);
    }
    static getStickersByUser() {
        return _app_api__WEBPACK_IMPORTED_MODULE_0__/* .http.get */ .d.get("".concat(resourceUser, "/stickersByUser"));
    }
}



/***/ }),

/***/ 50803:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ StoreService; },
/* harmony export */   "e": function() { return /* binding */ $httpStore; }
/* harmony export */ });
/* harmony import */ var _app_lib_utils__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(73848);
/* harmony import */ var _api_interceptor__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(76711);
/* harmony import */ var axios__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(70594);



const BASE_API_URL = "https://api.playee.net";
const $httpStore = axios__WEBPACK_IMPORTED_MODULE_1__/* ["default"].create */ .Z.create({
    baseURL: "".concat(BASE_API_URL),
    headers: {
        "Content-type": "application/json"
    }
});
(0,_api_interceptor__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)($httpStore);
const resource = "/store";
class StoreService {
    static getListProduct() {
        let page = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "1", limit = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "100";
        return $httpStore.get("".concat(resource, "/items/product"), {
            params: {
                page,
                limit
            }
        });
    }
    static getListItem(product_code) {
        let page = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "1", limit = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : "100";
        return $httpStore.get("".concat(resource, "/items/list"), {
            params: {
                page,
                limit,
                product_code
            }
        });
    }
    static getListItemDetail(item_code) {
        return $httpStore.get("".concat(resource, "/items/detail"), {
            params: {
                item_code
            }
        });
    }
    static getbyTransactionId(transaction_id) {
        return $httpStore.get("".concat(resource, "/payment/vaTransaction"), {
            params: {
                transaction_id
            }
        });
    }
    static createPaymentLink(method, item_code, quantity, voucher_code) {
        const _param = (0,_app_lib_utils__WEBPACK_IMPORTED_MODULE_2__/* .removeNullKeyObject */ .t2)({
            method,
            item_code,
            quantity,
            voucher_code
        });
        return $httpStore.post("".concat(resource, "/payment/createPayment"), _param);
    }
    // static getPaymentCallback(params: any): Promise<AxiosResponse<IApiResponse>> {
    //   return $httpStore.get(`${resource}/payment/callback`, {
    //     params
    //   })
    // }
    static getPaymentCallback(params) {
        return $httpStore.get("".concat(resource, "/payment/callbackV2"), {
            params
        });
    }
    static getOnepayPaymentCallback(params) {
        return $httpStore.get("".concat(resource, "/payment/onePayCallback"), {
            params
        });
    }
    static getPaymentHistory(params) {
        return $httpStore.get("".concat(resource, "/payment/history"), {
            params: params
        });
    }
    static suggestPaymentMethod(method_request) {
        return $httpStore.post("".concat(resource, "/payment/methodSugget"), {
            method_request
        });
    }
    // voucher
    static getListVoucherByProduct(item_code) {
        let page = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "1", limit = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : "100";
        return $httpStore.get("".concat(resource, "/vouchers/listByItem"), {
            params: {
                page,
                limit,
                item_code
            }
        });
    }
    static checkoutVoucherInfo(item_code, code) {
        return $httpStore.post("".concat(resource, "/vouchers/check"), {
            item_code,
            code
        });
    }
}



/***/ }),

/***/ 74617:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ TopupService; }
/* harmony export */ });
/* harmony import */ var _api_interceptor__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(76711);
/* harmony import */ var _StoreServices__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(50803);


(0,_api_interceptor__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(_StoreServices__WEBPACK_IMPORTED_MODULE_1__/* .$httpStore */ .e);
const resource = "/game/topup";
class TopupService {
    static getListGame() {
        return _StoreServices__WEBPACK_IMPORTED_MODULE_1__/* .$httpStore.get */ .e.get("".concat(resource, "/listGame"));
    }
    static getLaTransaction(transaction_id) {
        return _StoreServices__WEBPACK_IMPORTED_MODULE_1__/* .$httpStore.get */ .e.get("".concat(resource, "/laTransaction"), {
            params: {
                transaction_id
            }
        });
    }
    static checkPin() {
        return _StoreServices__WEBPACK_IMPORTED_MODULE_1__/* .$httpStore.get */ .e.get("".concat(resource, "/laTransaction/checkPin"));
    }
    static doLaCharge(param) {
        return _StoreServices__WEBPACK_IMPORTED_MODULE_1__/* .$httpStore.post */ .e.post("".concat(resource, "/laTransaction/doCharging"), param);
    }
    static getInfoGameDetail(slug_name) {
        return _StoreServices__WEBPACK_IMPORTED_MODULE_1__/* .$httpStore.get */ .e.get("".concat(resource, "/detailGame/").concat(slug_name));
    }
    static getServerUserAndPlatformByUserId(params) {
        return _StoreServices__WEBPACK_IMPORTED_MODULE_1__/* .$httpStore.get */ .e.get("".concat(resource, "/searchServer/").concat(params === null || params === void 0 ? void 0 : params.slug_name), {
            params
        });
    }
    static getSourcePackageAndTab(params) {
        return _StoreServices__WEBPACK_IMPORTED_MODULE_1__/* .$httpStore.get */ .e.get("".concat(resource, "/searchPackage/").concat(params === null || params === void 0 ? void 0 : params.slug_name), {
            params
        });
    }
    static getSourcePackageAndTabInOpenGlobal(params) {
        return _StoreServices__WEBPACK_IMPORTED_MODULE_1__/* .$httpStore.get */ .e.get("".concat(resource, "/xsollaPackage/").concat(params === null || params === void 0 ? void 0 : params.slug_name), {
            params
        });
    }
    static getMethodByPackageId(params) {
        return _StoreServices__WEBPACK_IMPORTED_MODULE_1__/* .$httpStore.get */ .e.get("".concat(resource, "/searchMethod/").concat(params.slug_name), {
            params
        });
    }
    static getRoleByServerAndUserId(params) {
        return _StoreServices__WEBPACK_IMPORTED_MODULE_1__/* .$httpStore.get */ .e.get("".concat(resource, "/searchRole/").concat(params.slug_name), {
            params
        });
    }
    static submitDoTopup(body) {
        const { slug_name , ...res } = body;
        return _StoreServices__WEBPACK_IMPORTED_MODULE_1__/* .$httpStore.post */ .e.post("".concat(resource, "/doTopup/").concat(slug_name), res);
    }
    static submitDoTopupGlobal(body) {
        const { slug_name , ...res } = body;
        return _StoreServices__WEBPACK_IMPORTED_MODULE_1__/* .$httpStore.post */ .e.post("".concat(resource, "/xsollaTopup/").concat(slug_name), res);
    }
    static getTopupCallback(params) {
        return _StoreServices__WEBPACK_IMPORTED_MODULE_1__/* .$httpStore.get */ .e.get("".concat(resource, "/callback"), {
            params
        });
    }
    static getbyTransactionId(transaction_id) {
        return _StoreServices__WEBPACK_IMPORTED_MODULE_1__/* .$httpStore.get */ .e.get("".concat(resource, "/vaTransaction"), {
            params: {
                transaction_id
            }
        });
    }
    static getStoreBag(params) {
        return _StoreServices__WEBPACK_IMPORTED_MODULE_1__/* .$httpStore.get */ .e.get("".concat(resource, "/storeBag"), {
            params
        });
    }
    static getPaymentHistory(params) {
        return _StoreServices__WEBPACK_IMPORTED_MODULE_1__/* .$httpStore.get */ .e.get("".concat(resource, "/history"), {
            params: params
        });
    }
}



/***/ }),

/***/ 27020:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Y": function() { return /* reexport */ NewsService; },
  "K": function() { return /* reexport */ UserService; }
});

// EXTERNAL MODULE: ./app/api/index.ts
var api = __webpack_require__(34224);
;// CONCATENATED MODULE: ./app/services/services/UserService.ts

const resource = "/api/users";
class UserService {
    static login(body) {
        return api/* http.post */.d.post("".concat(resource, "/login"), body);
    }
    static getReloadProfile() {
        return api/* http.get */.d.get("".concat(resource, "/reload"));
    }
    static getProfile() {
        return api/* http.get */.d.get("".concat(resource, "/me"));
    }
    static loginByGoogle(code) {
        const params = {};
        if (code) {
            Object.assign(params, {
                code
            });
        }
        return api/* http.get */.d.get("".concat(resource, "/loginGoogle"), {
            params
        });
    }
    static getUrlFacebook() {
        return api/* http.get */.d.get("".concat(resource, "/loginFacebook"));
    }
    static loginByFacebook(params) {
        return api/* http.get */.d.get("".concat(resource, "/loginFacebook/auth"), {
            params
        });
    }
    static updateLanguage(params) {
        return api/* http.post */.d.post("".concat(resource, "/updateLanguage"), params);
    }
    static uploadImage(params) {
        return api/* http.post */.d.post("".concat(resource, "/updateAvatar"), params, {
            headers: {
                "Content-Type": "multipart/form-data"
            }
        });
    }
    static updateProfile(params) {
        return api/* http.post */.d.post("".concat(resource, "/updateProfile"), params);
    }
    static getListHashtag(params) {
        return api/* http.get */.d.get("".concat(resource, "/hashtags"), {
            params: params
        });
    }
    static updateInterestTopic(params) {
        return api/* http.post */.d.post("".concat(resource, "/updateInterest"), params);
    }
    static getUserPointHistory(params) {
        return api/* http.get */.d.get("".concat(resource, "/pointHistory"), {
            params: params
        });
    }
    static updateInviteCode(params) {
        return api/* http.post */.d.post("".concat(resource, "/updateInviteCode"), params);
    }
    static getUserPoint() {
        return api/* http.get */.d.get("".concat(resource, "/point"));
    }
    static getUserInviteHistory(params) {
        return api/* http.get */.d.get("".concat(resource, "/inviteHistory"), {
            params: params
        });
    }
    static getProfileInfoById(id) {
        return api/* http.get */.d.get("".concat(resource, "/profile"), {
            params: {
                id
            }
        });
    }
    static getListSuggestByGame(game_id, pageParam) {
        return api/* http.get */.d.get("".concat(resource, "/suggestFriendByGame"), {
            params: {
                game_id,
                page: pageParam
            }
        });
    }
    static followUser(follower_id) {
        return api/* http.post */.d.post("".concat(resource, "/follow"), {
            follower_id: follower_id
        });
    }
    static sendGift(user_id, item_id) {
        return api/* http.post */.d.post("/api/bag/sendGift", {
            user_id,
            item_id
        });
    }
    static getListFollow(pageParam, query) {
        return api/* http.get */.d.get("".concat(resource, "/listFollowMe"), {
            params: {
                keyword: query,
                page: pageParam
            }
        });
    }
}

// EXTERNAL MODULE: ./app/configs/index.ts + 3 modules
var configs = __webpack_require__(54254);
;// CONCATENATED MODULE: ./app/services/services/NewsServices.tsx


const NewsServices_resource = "/v2/news";
class NewsService {
    static getAllNews(pageParam) {
        return api/* http.get */.d.get("".concat(NewsServices_resource, "/list"), {
            params: {
                page: pageParam
            }
        });
    }
    static getAllNewsByHashtag(keyword, pageParam) {
        return api/* http.get */.d.get("".concat(NewsServices_resource, "/hashtag"), {
            params: {
                keyword,
                page: pageParam
            }
        });
    }
    static getListStoreNews(pageParam, keyword, sort) {
        return api/* http.get */.d.get("".concat(NewsServices_resource, "/listStore"), {
            params: keyword ? {
                page: pageParam,
                keyword,
                sort
            } : {
                page: pageParam,
                sort
            }
        });
    }
    static getNewsDetail(postId) {
        return api/* http.get */.d.get("".concat(NewsServices_resource, "/view"), {
            params: {
                id: postId
            }
        });
    }
    static getNewsDetailForEdit(postId) {
        return api/* http.get */.d.get("".concat(NewsServices_resource, "/detail"), {
            params: {
                id: postId
            }
        });
    }
    static getCommentByNewsId(postId, pageParam) {
        return api/* http.post */.d.post("".concat(NewsServices_resource, "/comment/list"), {
            id: postId,
            page: String(pageParam),
            limit: configs/* COMMENT_LIMIT_SIZE */.au
        });
    }
    static deleteNews(id) {
        return api/* http.post */.d.post("".concat(NewsServices_resource, "/delete"), {
            id
        });
    }
    static addnews(body) {
        return api/* http.post */.d.post("".concat(NewsServices_resource, "/add"), body);
    }
    static editNews(body) {
        return api/* http.post */.d.post("".concat(NewsServices_resource, "/edit"), body);
    }
    static checkDraft() {
        return api/* http.post */.d.post("".concat(NewsServices_resource, "/draf"));
    }
    static saveDraft(body) {
        return api/* http.post */.d.post("".concat(NewsServices_resource, "/saveDraf"), body);
    }
    static deleteDraft(body) {
        return api/* http.post */.d.post("".concat(NewsServices_resource, "/delete"), body);
    }
    static getCommentByPostId(postId, page) {
        let limit = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 2;
        return api/* http.post */.d.post("".concat(NewsServices_resource, "/comment/list"), {
            id: postId,
            page,
            limit
        });
    }
    static commentToPost(body) {
        return api/* http.post */.d.post("".concat(NewsServices_resource, "/comment"), body, {
            headers: {
                "Content-Type": "multipart/form-data"
            }
        });
    }
    static likePost(body) {
        return api/* http.post */.d.post("".concat(NewsServices_resource, "/like"), body);
    }
    static likeComment(body) {
        return api/* http.post */.d.post("".concat(NewsServices_resource, "/like/comment"), body);
    }
    static replyToComment(body) {
        return api/* http.post */.d.post("".concat(NewsServices_resource, "/comment/reply"), body, {
            headers: {
                "Content-Type": "multipart/form-data"
            }
        });
    }
    static getListReplies(body) {
        return api/* http.post */.d.post("".concat(NewsServices_resource, "/comment/listReplies"), body);
    }
    static deleteComment(body) {
        return api/* http.post */.d.post("".concat(NewsServices_resource, "/comment/delete"), body);
    }
    static updateComment(formData) {
        return api/* http.post */.d.post("".concat(NewsServices_resource, "/comment/update"), formData, {
            headers: {
                "Content-Type": "multipart/form-data"
            }
        });
    }
    static getStickersByUser() {
        return api/* http.get */.d.get("/api/bag/stickersByUser");
    }
    static uploadMedia(formData) {
        return api/* http.post */.d.post("v2/upload/media", formData, {
            headers: {
                "Content-Type": "multipart/form-data"
            }
        });
    }
    static relatedNews(params) {
        return api/* http.get */.d.get("".concat(NewsServices_resource, "/related"), {
            params: {
                page: String(params.pageParam),
                id: params.id,
                limit: String(params.limit)
            }
        });
    }
    static getNewsByType(param) {
        let { type , limit  } = param;
        return api/* http.get */.d.get("".concat(NewsServices_resource, "/search"), {
            params: {
                type,
                limit
            }
        });
    }
    static getMyNewsByFilter(param, pageParam) {
        return api/* http.get */.d.get("".concat(NewsServices_resource, "/search"), {
            params: {
                type: "my_posts",
                ...param,
                page: pageParam
            }
        });
    }
    static getOtherUserNewsByFilter(param, pageParam) {
        return api/* http.get */.d.get("".concat(NewsServices_resource, "/search"), {
            params: {
                type: "other_user_posts",
                ...param,
                page: pageParam,
                other_userid: param.other_userid
            }
        });
    }
    static getLatestNews(param) {
        return api/* http.get */.d.get("".concat(NewsServices_resource, "/search"), {
            params: param
        });
    }
    static relatedNewsByGame(params) {
        return api/* http.get */.d.get("".concat(NewsServices_resource, "/listByGame"), {
            params: {
                page: String(params.pageParam),
                game_id: params.game_id,
                limit: String(params.limit)
            }
        });
    }
    static storeNews(id) {
        return api/* http.post */.d.post("".concat(NewsServices_resource, "/store"), {
            id
        });
    }
    static removeStoreNews(id) {
        return api/* http.post */.d.post("".concat(NewsServices_resource, "/store/delete"), {
            id
        });
    }
    static getAllNewsByUser(pageParam, sort) {
        return api/* http.get */.d.get("".concat(NewsServices_resource, "/listByUser"), {
            params: {
                page: pageParam,
                sort
            }
        });
    }
    static getAllNewsByOtherUser(pageParam, sort, other_userid) {
        return api/* http.get */.d.get("".concat(NewsServices_resource, "/listByUser"), {
            params: {
                page: pageParam,
                other_userid,
                sort
            }
        });
    }
}

;// CONCATENATED MODULE: ./app/services/services/index.ts




/***/ }),

/***/ 90752:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "HS": function() { return /* binding */ convertObjectToArray; },
/* harmony export */   "Nf": function() { return /* binding */ convertNameString; },
/* harmony export */   "fg": function() { return /* binding */ getNumberList; },
/* harmony export */   "p9": function() { return /* binding */ getEmptyListByNumber; }
/* harmony export */ });
/* unused harmony export customRound */
const getNumberList = (total, numberPerCol)=>{
    if (total % numberPerCol === 0) {
        return Math.floor(total / numberPerCol);
    } else {
        return Math.floor(total / numberPerCol) + 1;
    }
};
const getEmptyListByNumber = (length)=>{
    let list = [];
    for(let i = 0; i < length; i++){
        list.push(i);
    }
    return list;
};
const convertNameString = (fullname)=>{
    const words = fullname.split(" ");
    const initials = words.map((word)=>word.charAt(0));
    const result = initials.join("");
    return result.substring(0, 2).toUpperCase();
};
function customRound(number) {
    const roundedNumber = +number.toFixed(1) // Làm tròn đến 2 chữ số sau dấu phẩy và chuyển thành số
    ;
    // Kiểm tra xem số đó có là số tròn hoặc chỉ có một số sau dấu thập phân không
    if (roundedNumber % 1 === 0) {
        return Math.round(roundedNumber) // Làm tròn số nguyên
        ;
    } else {
        return roundedNumber // Giữ nguyên số đã làm tròn
        ;
    }
}
const convertObjectToArray = (obj)=>Object.entries(obj).map((param)=>{
        let [key, value] = param;
        return {
            key,
            ...value
        };
    });


/***/ }),

/***/ 89959:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
exports.getDomainLocale = getDomainLocale;
const basePath =  false || "";
function getDomainLocale(path, locale, locales, domainLocales) {
    if (true) {
        const normalizeLocalePath = (__webpack_require__(5766).normalizeLocalePath);
        const detectDomainLocale = (__webpack_require__(38832).detectDomainLocale);
        const target = locale || normalizeLocalePath(path, locales).detectedLocale;
        const domain = detectDomainLocale(domainLocales, undefined, target);
        if (domain) {
            const proto = "http".concat(domain.http ? "" : "s", "://");
            const finalLocale = target === domain.defaultLocale ? "" : "/".concat(target);
            return "".concat(proto).concat(domain.domain).concat(basePath).concat(finalLocale).concat(path);
        }
        return false;
    } else {}
}
if ((typeof exports.default === "function" || typeof exports.default === "object" && exports.default !== null) && typeof exports.default.__esModule === "undefined") {
    Object.defineProperty(exports.default, "__esModule", {
        value: true
    });
    Object.assign(exports.default, exports);
    module.exports = exports.default;
} //# sourceMappingURL=get-domain-locale.js.map


/***/ }),

/***/ 20030:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
exports["default"] = Image;
var _extends = (__webpack_require__(6495)/* ["default"] */ .Z);
var _interop_require_default = (__webpack_require__(92648)/* ["default"] */ .Z);
var _interop_require_wildcard = (__webpack_require__(91598)/* ["default"] */ .Z);
var _object_without_properties_loose = (__webpack_require__(17273)/* ["default"] */ .Z);
var _react = _interop_require_wildcard(__webpack_require__(55784));
var _head = _interop_require_default(__webpack_require__(55322));
var _imageBlurSvg = __webpack_require__(59642);
var _imageConfig = __webpack_require__(931);
var _imageConfigContext = __webpack_require__(50601);
var _warnOnce = __webpack_require__(72437);
var _imageLoader = _interop_require_default(__webpack_require__(47112));
function Image(_param) {
    var { src , sizes , unoptimized =false , priority =false , loading , className , quality , width , height , fill , style , onLoad , onLoadingComplete , placeholder ="empty" , blurDataURL , layout , objectFit , objectPosition , lazyBoundary , lazyRoot  } = _param, all = _object_without_properties_loose(_param, [
        "src",
        "sizes",
        "unoptimized",
        "priority",
        "loading",
        "className",
        "quality",
        "width",
        "height",
        "fill",
        "style",
        "onLoad",
        "onLoadingComplete",
        "placeholder",
        "blurDataURL",
        "layout",
        "objectFit",
        "objectPosition",
        "lazyBoundary",
        "lazyRoot"
    ]);
    const configContext = (0, _react).useContext(_imageConfigContext.ImageConfigContext);
    const config = (0, _react).useMemo(()=>{
        const c = configEnv || configContext || _imageConfig.imageConfigDefault;
        const allSizes = [
            ...c.deviceSizes,
            ...c.imageSizes
        ].sort((a, b)=>a - b);
        const deviceSizes = c.deviceSizes.sort((a, b)=>a - b);
        return _extends({}, c, {
            allSizes,
            deviceSizes
        });
    }, [
        configContext
    ]);
    let rest = all;
    let loader = rest.loader || _imageLoader.default;
    // Remove property so it's not spread on <img> element
    delete rest.loader;
    if ("__next_img_default" in loader) {
        // This special value indicates that the user
        // didn't define a "loader" prop or config.
        if (config.loader === "custom") {
            throw new Error('Image with src "'.concat(src, '" is missing "loader" prop.') + "\nRead more: https://nextjs.org/docs/messages/next-image-missing-loader");
        }
    } else {
        // The user defined a "loader" prop or config.
        // Since the config object is internal only, we
        // must not pass it to the user-defined "loader".
        const customImageLoader = loader;
        var _tmp;
        _tmp = (obj)=>{
            const { config: _  } = obj, opts = _object_without_properties_loose(obj, [
                "config"
            ]);
            return customImageLoader(opts);
        }, loader = _tmp, _tmp;
    }
    if (layout) {
        if (layout === "fill") {
            fill = true;
        }
        const layoutToStyle = {
            intrinsic: {
                maxWidth: "100%",
                height: "auto"
            },
            responsive: {
                width: "100%",
                height: "auto"
            }
        };
        const layoutToSizes = {
            responsive: "100vw",
            fill: "100vw"
        };
        const layoutStyle = layoutToStyle[layout];
        if (layoutStyle) {
            style = _extends({}, style, layoutStyle);
        }
        const layoutSizes = layoutToSizes[layout];
        if (layoutSizes && !sizes) {
            sizes = layoutSizes;
        }
    }
    let staticSrc = "";
    let widthInt = getInt(width);
    let heightInt = getInt(height);
    let blurWidth;
    let blurHeight;
    if (isStaticImport(src)) {
        const staticImageData = isStaticRequire(src) ? src.default : src;
        if (!staticImageData.src) {
            throw new Error("An object should only be passed to the image component src parameter if it comes from a static image import. It must include src. Received ".concat(JSON.stringify(staticImageData)));
        }
        if (!staticImageData.height || !staticImageData.width) {
            throw new Error("An object should only be passed to the image component src parameter if it comes from a static image import. It must include height and width. Received ".concat(JSON.stringify(staticImageData)));
        }
        blurWidth = staticImageData.blurWidth;
        blurHeight = staticImageData.blurHeight;
        blurDataURL = blurDataURL || staticImageData.blurDataURL;
        staticSrc = staticImageData.src;
        if (!fill) {
            if (!widthInt && !heightInt) {
                widthInt = staticImageData.width;
                heightInt = staticImageData.height;
            } else if (widthInt && !heightInt) {
                const ratio = widthInt / staticImageData.width;
                heightInt = Math.round(staticImageData.height * ratio);
            } else if (!widthInt && heightInt) {
                const ratio1 = heightInt / staticImageData.height;
                widthInt = Math.round(staticImageData.width * ratio1);
            }
        }
    }
    src = typeof src === "string" ? src : staticSrc;
    let isLazy = !priority && (loading === "lazy" || typeof loading === "undefined");
    if (src.startsWith("data:") || src.startsWith("blob:")) {
        // https://developer.mozilla.org/en-US/docs/Web/HTTP/Basics_of_HTTP/Data_URIs
        unoptimized = true;
        isLazy = false;
    }
    if (config.unoptimized) {
        unoptimized = true;
    }
    const [blurComplete, setBlurComplete] = (0, _react).useState(false);
    const [showAltText, setShowAltText] = (0, _react).useState(false);
    const qualityInt = getInt(quality);
    if (false) {}
    const imgStyle = Object.assign(fill ? {
        position: "absolute",
        height: "100%",
        width: "100%",
        left: 0,
        top: 0,
        right: 0,
        bottom: 0,
        objectFit,
        objectPosition
    } : {}, showAltText ? {} : {
        color: "transparent"
    }, style);
    const blurStyle = placeholder === "blur" && blurDataURL && !blurComplete ? {
        backgroundSize: imgStyle.objectFit || "cover",
        backgroundPosition: imgStyle.objectPosition || "50% 50%",
        backgroundRepeat: "no-repeat",
        backgroundImage: 'url("data:image/svg+xml;charset=utf-8,'.concat((0, _imageBlurSvg).getImageBlurSvg({
            widthInt,
            heightInt,
            blurWidth,
            blurHeight,
            blurDataURL
        }), '")')
    } : {};
    if (false) {}
    const imgAttributes = generateImgAttrs({
        config,
        src,
        unoptimized,
        width: widthInt,
        quality: qualityInt,
        sizes,
        loader
    });
    let srcString = src;
    if (false) {}
    const linkProps = {
        // @ts-expect-error upgrade react types to react 18
        imageSrcSet: imgAttributes.srcSet,
        imageSizes: imgAttributes.sizes,
        crossOrigin: rest.crossOrigin
    };
    const onLoadRef = (0, _react).useRef(onLoad);
    (0, _react).useEffect(()=>{
        onLoadRef.current = onLoad;
    }, [
        onLoad
    ]);
    const onLoadingCompleteRef = (0, _react).useRef(onLoadingComplete);
    (0, _react).useEffect(()=>{
        onLoadingCompleteRef.current = onLoadingComplete;
    }, [
        onLoadingComplete
    ]);
    const imgElementArgs = _extends({
        isLazy,
        imgAttributes,
        heightInt,
        widthInt,
        qualityInt,
        className,
        imgStyle,
        blurStyle,
        loading,
        config,
        fill,
        unoptimized,
        placeholder,
        loader,
        srcString,
        onLoadRef,
        onLoadingCompleteRef,
        setBlurComplete,
        setShowAltText
    }, rest);
    return /*#__PURE__*/ _react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/ _react.default.createElement(ImageElement, Object.assign({}, imgElementArgs)), priority ? // for browsers that do not support `imagesrcset`, and in those cases
    // it would likely cause the incorrect image to be preloaded.
    //
    // https://html.spec.whatwg.org/multipage/semantics.html#attr-link-imagesrcset
    /*#__PURE__*/ _react.default.createElement(_head.default, null, /*#__PURE__*/ _react.default.createElement("link", Object.assign({
        key: "__nimg-" + imgAttributes.src + imgAttributes.srcSet + imgAttributes.sizes,
        rel: "preload",
        as: "image",
        href: imgAttributes.srcSet ? undefined : imgAttributes.src
    }, linkProps))) : null);
}
"use client";
const configEnv = {"deviceSizes":[640,750,828,1080,1200,1920,2048,3840],"imageSizes":[16,32,48,64,96,128,256,384],"path":"/_next/image","loader":"default","dangerouslyAllowSVG":false,"unoptimized":false};
const allImgs = new Map();
let perfObserver;
if (false) {}
const VALID_LOADING_VALUES = (/* unused pure expression or super */ null && ([
    "lazy",
    "eager",
    undefined
]));
function isStaticRequire(src) {
    return src.default !== undefined;
}
function isStaticImageData(src) {
    return src.src !== undefined;
}
function isStaticImport(src) {
    return typeof src === "object" && (isStaticRequire(src) || isStaticImageData(src));
}
function getWidths(param, width, sizes) {
    let { deviceSizes , allSizes  } = param;
    if (sizes) {
        // Find all the "vw" percent sizes used in the sizes prop
        const viewportWidthRe = /(^|\s)(1?\d?\d)vw/g;
        const percentSizes = [];
        for(let match; match = viewportWidthRe.exec(sizes); match){
            percentSizes.push(parseInt(match[2]));
        }
        if (percentSizes.length) {
            const smallestRatio = Math.min(...percentSizes) * 0.01;
            return {
                widths: allSizes.filter((s)=>s >= deviceSizes[0] * smallestRatio),
                kind: "w"
            };
        }
        return {
            widths: allSizes,
            kind: "w"
        };
    }
    if (typeof width !== "number") {
        return {
            widths: deviceSizes,
            kind: "w"
        };
    }
    const widths = [
        ...new Set(// > are actually 3x in the green color, but only 1.5x in the red and
        // > blue colors. Showing a 3x resolution image in the app vs a 2x
        // > resolution image will be visually the same, though the 3x image
        // > takes significantly more data. Even true 3x resolution screens are
        // > wasteful as the human eye cannot see that level of detail without
        // > something like a magnifying glass.
        // https://blog.twitter.com/engineering/en_us/topics/infrastructure/2019/capping-image-fidelity-on-ultra-high-resolution-devices.html
        [
            width,
            width * 2 /*, width * 3*/ 
        ].map((w)=>allSizes.find((p)=>p >= w) || allSizes[allSizes.length - 1]))
    ];
    return {
        widths,
        kind: "x"
    };
}
function generateImgAttrs(param) {
    let { config , src , unoptimized , width , quality , sizes , loader  } = param;
    if (unoptimized) {
        return {
            src,
            srcSet: undefined,
            sizes: undefined
        };
    }
    const { widths , kind  } = getWidths(config, width, sizes);
    const last = widths.length - 1;
    return {
        sizes: !sizes && kind === "w" ? "100vw" : sizes,
        srcSet: widths.map((w, i)=>"".concat(loader({
                config,
                src,
                quality,
                width: w
            }), " ").concat(kind === "w" ? w : i + 1).concat(kind)).join(", "),
        // It's intended to keep `src` the last attribute because React updates
        // attributes in order. If we keep `src` the first one, Safari will
        // immediately start to fetch `src`, before `sizes` and `srcSet` are even
        // updated by React. That causes multiple unnecessary requests if `srcSet`
        // and `sizes` are defined.
        // This bug cannot be reproduced in Chrome or Firefox.
        src: loader({
            config,
            src,
            quality,
            width: widths[last]
        })
    };
}
function getInt(x) {
    if (typeof x === "number" || typeof x === "undefined") {
        return x;
    }
    if (typeof x === "string" && /^[0-9]+$/.test(x)) {
        return parseInt(x, 10);
    }
    return NaN;
}
// See https://stackoverflow.com/q/39777833/266535 for why we use this ref
// handler instead of the img's onLoad attribute.
function handleLoading(img, src, placeholder, onLoadRef, onLoadingCompleteRef, setBlurComplete, unoptimized) {
    if (!img || img["data-loaded-src"] === src) {
        return;
    }
    img["data-loaded-src"] = src;
    const p = "decode" in img ? img.decode() : Promise.resolve();
    p.catch(()=>{}).then(()=>{
        if (!img.parentNode) {
            // Exit early in case of race condition:
            // - onload() is called
            // - decode() is called but incomplete
            // - unmount is called
            // - decode() completes
            return;
        }
        if (placeholder === "blur") {
            setBlurComplete(true);
        }
        if (onLoadRef == null ? void 0 : onLoadRef.current) {
            // Since we don't have the SyntheticEvent here,
            // we must create one with the same shape.
            // See https://reactjs.org/docs/events.html
            const event = new Event("load");
            Object.defineProperty(event, "target", {
                writable: false,
                value: img
            });
            let prevented = false;
            let stopped = false;
            onLoadRef.current(_extends({}, event, {
                nativeEvent: event,
                currentTarget: img,
                target: img,
                isDefaultPrevented: ()=>prevented,
                isPropagationStopped: ()=>stopped,
                persist: ()=>{},
                preventDefault: ()=>{
                    prevented = true;
                    event.preventDefault();
                },
                stopPropagation: ()=>{
                    stopped = true;
                    event.stopPropagation();
                }
            }));
        }
        if (onLoadingCompleteRef == null ? void 0 : onLoadingCompleteRef.current) {
            onLoadingCompleteRef.current(img);
        }
        if (false) {}
    });
}
const ImageElement = (_param)=>{
    var { imgAttributes , heightInt , widthInt , qualityInt , className , imgStyle , blurStyle , isLazy , fill , placeholder , loading , srcString , config , unoptimized , loader , onLoadRef , onLoadingCompleteRef , setBlurComplete , setShowAltText , onLoad , onError  } = _param, rest = _object_without_properties_loose(_param, [
        "imgAttributes",
        "heightInt",
        "widthInt",
        "qualityInt",
        "className",
        "imgStyle",
        "blurStyle",
        "isLazy",
        "fill",
        "placeholder",
        "loading",
        "srcString",
        "config",
        "unoptimized",
        "loader",
        "onLoadRef",
        "onLoadingCompleteRef",
        "setBlurComplete",
        "setShowAltText",
        "onLoad",
        "onError"
    ]);
    loading = isLazy ? "lazy" : loading;
    return /*#__PURE__*/ _react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/ _react.default.createElement("img", Object.assign({}, rest, imgAttributes, {
        width: widthInt,
        height: heightInt,
        decoding: "async",
        "data-nimg": fill ? "fill" : "1",
        className: className,
        // @ts-ignore - TODO: upgrade to `@types/react@17`
        loading: loading,
        style: _extends({}, imgStyle, blurStyle),
        ref: (0, _react).useCallback((img)=>{
            if (!img) {
                return;
            }
            if (onError) {
                // If the image has an error before react hydrates, then the error is lost.
                // The workaround is to wait until the image is mounted which is after hydration,
                // then we set the src again to trigger the error handler (if there was an error).
                // eslint-disable-next-line no-self-assign
                img.src = img.src;
            }
            if (false) {}
            if (img.complete) {
                handleLoading(img, srcString, placeholder, onLoadRef, onLoadingCompleteRef, setBlurComplete, unoptimized);
            }
        }, [
            srcString,
            placeholder,
            onLoadRef,
            onLoadingCompleteRef,
            setBlurComplete,
            onError,
            unoptimized
        ]),
        onLoad: (event)=>{
            const img = event.currentTarget;
            handleLoading(img, srcString, placeholder, onLoadRef, onLoadingCompleteRef, setBlurComplete, unoptimized);
        },
        onError: (event)=>{
            // if the real image fails to load, this will ensure "alt" is visible
            setShowAltText(true);
            if (placeholder === "blur") {
                // If the real image fails to load, this will still remove the placeholder.
                setBlurComplete(true);
            }
            if (onError) {
                onError(event);
            }
        }
    })));
};
if ((typeof exports.default === "function" || typeof exports.default === "object" && exports.default !== null) && typeof exports.default.__esModule === "undefined") {
    Object.defineProperty(exports.default, "__esModule", {
        value: true
    });
    Object.assign(exports.default, exports);
    module.exports = exports.default;
} //# sourceMappingURL=image.js.map


/***/ }),

/***/ 4090:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
exports["default"] = void 0;
var _interop_require_default = (__webpack_require__(92648)/* ["default"] */ .Z);
var _object_without_properties_loose = (__webpack_require__(17273)/* ["default"] */ .Z);
var _react = _interop_require_default(__webpack_require__(55784));
var _router = __webpack_require__(53777);
var _formatUrl = __webpack_require__(2962);
var _addLocale = __webpack_require__(5463);
var _routerContext = __webpack_require__(14825);
var _appRouterContext = __webpack_require__(12568);
var _useIntersection = __webpack_require__(2127);
var _getDomainLocale = __webpack_require__(89959);
var _addBasePath = __webpack_require__(43795);
"use client";
const prefetched = new Set();
function prefetch(router, href, as, options) {
    if (false) {}
    if (!(0, _router).isLocalURL(href)) {
        return;
    }
    // We should only dedupe requests when experimental.optimisticClientCache is
    // disabled.
    if (!options.bypassPrefetchedCheck) {
        const locale = typeof options.locale !== "undefined" ? options.locale : "locale" in router ? router.locale : undefined;
        const prefetchedKey = href + "%" + as + "%" + locale;
        // If we've already fetched the key, then don't prefetch it again!
        if (prefetched.has(prefetchedKey)) {
            return;
        }
        // Mark this URL as prefetched.
        prefetched.add(prefetchedKey);
    }
    // Prefetch the JSON page if asked (only in the client)
    // We need to handle a prefetch error here since we may be
    // loading with priority which can reject but we don't
    // want to force navigation since this is only a prefetch
    Promise.resolve(router.prefetch(href, as, options)).catch((err)=>{
        if (false) {}
    });
}
function isModifiedEvent(event) {
    const { target  } = event.currentTarget;
    return target && target !== "_self" || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey || event.nativeEvent && event.nativeEvent.which === 2;
}
function linkClicked(e, router, href, as, replace, shallow, scroll, locale, isAppRouter, prefetchEnabled) {
    const { nodeName  } = e.currentTarget;
    // anchors inside an svg have a lowercase nodeName
    const isAnchorNodeName = nodeName.toUpperCase() === "A";
    if (isAnchorNodeName && (isModifiedEvent(e) || !(0, _router).isLocalURL(href))) {
        // ignore click for browser’s default behavior
        return;
    }
    e.preventDefault();
    const navigate = ()=>{
        // If the router is an NextRouter instance it will have `beforePopState`
        if ("beforePopState" in router) {
            router[replace ? "replace" : "push"](href, as, {
                shallow,
                locale,
                scroll
            });
        } else {
            router[replace ? "replace" : "push"](as || href, {
                forceOptimisticNavigation: !prefetchEnabled
            });
        }
    };
    if (isAppRouter) {
        // @ts-expect-error startTransition exists.
        _react.default.startTransition(navigate);
    } else {
        navigate();
    }
}
function formatStringOrUrl(urlObjOrString) {
    if (typeof urlObjOrString === "string") {
        return urlObjOrString;
    }
    return (0, _formatUrl).formatUrl(urlObjOrString);
}
/**
 * React Component that enables client-side transitions between routes.
 */ const Link = /*#__PURE__*/ _react.default.forwardRef(function LinkComponent(props, forwardedRef) {
    if (false) {}
    let children;
    const { href: hrefProp , as: asProp , children: childrenProp , prefetch: prefetchProp , passHref , replace , shallow , scroll , locale , onClick , onMouseEnter: onMouseEnterProp , onTouchStart: onTouchStartProp , legacyBehavior =Boolean(true) !== true  } = props, restProps = _object_without_properties_loose(props, [
        "href",
        "as",
        "children",
        "prefetch",
        "passHref",
        "replace",
        "shallow",
        "scroll",
        "locale",
        "onClick",
        "onMouseEnter",
        "onTouchStart",
        "legacyBehavior"
    ]);
    children = childrenProp;
    if (legacyBehavior && (typeof children === "string" || typeof children === "number")) {
        children = /*#__PURE__*/ _react.default.createElement("a", null, children);
    }
    const prefetchEnabled = prefetchProp !== false;
    const pagesRouter = _react.default.useContext(_routerContext.RouterContext);
    const appRouter = _react.default.useContext(_appRouterContext.AppRouterContext);
    const router = pagesRouter != null ? pagesRouter : appRouter;
    // We're in the app directory if there is no pages router.
    const isAppRouter = !pagesRouter;
    const { href , as  } = _react.default.useMemo(()=>{
        if (!pagesRouter) {
            const resolvedHref = formatStringOrUrl(hrefProp);
            return {
                href: resolvedHref,
                as: asProp ? formatStringOrUrl(asProp) : resolvedHref
            };
        }
        const [resolvedHref1, resolvedAs] = (0, _router).resolveHref(pagesRouter, hrefProp, true);
        return {
            href: resolvedHref1,
            as: asProp ? (0, _router).resolveHref(pagesRouter, asProp) : resolvedAs || resolvedHref1
        };
    }, [
        pagesRouter,
        hrefProp,
        asProp
    ]);
    const previousHref = _react.default.useRef(href);
    const previousAs = _react.default.useRef(as);
    // This will return the first child, if multiple are provided it will throw an error
    let child;
    if (legacyBehavior) {
        if (false) {} else {
            child = _react.default.Children.only(children);
        }
    } else {
        if (false) { var ref; }
    }
    const childRef = legacyBehavior ? child && typeof child === "object" && child.ref : forwardedRef;
    const [setIntersectionRef, isVisible, resetVisible] = (0, _useIntersection).useIntersection({
        rootMargin: "200px"
    });
    const setRef = _react.default.useCallback((el)=>{
        // Before the link getting observed, check if visible state need to be reset
        if (previousAs.current !== as || previousHref.current !== href) {
            resetVisible();
            previousAs.current = as;
            previousHref.current = href;
        }
        setIntersectionRef(el);
        if (childRef) {
            if (typeof childRef === "function") childRef(el);
            else if (typeof childRef === "object") {
                childRef.current = el;
            }
        }
    }, [
        as,
        childRef,
        href,
        resetVisible,
        setIntersectionRef
    ]);
    // Prefetch the URL if we haven't already and it's visible.
    _react.default.useEffect(()=>{
        if (!router) {
            return;
        }
        // If we don't need to prefetch the URL, don't do prefetch.
        if (!isVisible || !prefetchEnabled) {
            return;
        }
        // Prefetch the URL.
        prefetch(router, href, as, {
            locale
        });
    }, [
        as,
        href,
        isVisible,
        locale,
        prefetchEnabled,
        pagesRouter == null ? void 0 : pagesRouter.locale,
        router
    ]);
    const childProps = {
        ref: setRef,
        onClick (e) {
            if (false) {}
            if (!legacyBehavior && typeof onClick === "function") {
                onClick(e);
            }
            if (legacyBehavior && child.props && typeof child.props.onClick === "function") {
                child.props.onClick(e);
            }
            if (!router) {
                return;
            }
            if (e.defaultPrevented) {
                return;
            }
            linkClicked(e, router, href, as, replace, shallow, scroll, locale, isAppRouter, prefetchEnabled);
        },
        onMouseEnter (e) {
            if (!legacyBehavior && typeof onMouseEnterProp === "function") {
                onMouseEnterProp(e);
            }
            if (legacyBehavior && child.props && typeof child.props.onMouseEnter === "function") {
                child.props.onMouseEnter(e);
            }
            if (!router) {
                return;
            }
            if (!prefetchEnabled && isAppRouter) {
                return;
            }
            prefetch(router, href, as, {
                locale,
                priority: true,
                // @see {https://github.com/vercel/next.js/discussions/40268?sort=top#discussioncomment-3572642}
                bypassPrefetchedCheck: true
            });
        },
        onTouchStart (e) {
            if (!legacyBehavior && typeof onTouchStartProp === "function") {
                onTouchStartProp(e);
            }
            if (legacyBehavior && child.props && typeof child.props.onTouchStart === "function") {
                child.props.onTouchStart(e);
            }
            if (!router) {
                return;
            }
            if (!prefetchEnabled && isAppRouter) {
                return;
            }
            prefetch(router, href, as, {
                locale,
                priority: true,
                // @see {https://github.com/vercel/next.js/discussions/40268?sort=top#discussioncomment-3572642}
                bypassPrefetchedCheck: true
            });
        }
    };
    // If child is an <a> tag and doesn't have a href attribute, or if the 'passHref' property is
    // defined, we specify the current 'href', so that repetition is not needed by the user
    if (!legacyBehavior || passHref || child.type === "a" && !("href" in child.props)) {
        const curLocale = typeof locale !== "undefined" ? locale : pagesRouter == null ? void 0 : pagesRouter.locale;
        // we only render domain locales if we are currently on a domain locale
        // so that locale links are still visitable in development/preview envs
        const localeDomain = (pagesRouter == null ? void 0 : pagesRouter.isLocaleDomain) && (0, _getDomainLocale).getDomainLocale(as, curLocale, pagesRouter == null ? void 0 : pagesRouter.locales, pagesRouter == null ? void 0 : pagesRouter.domainLocales);
        childProps.href = localeDomain || (0, _addBasePath).addBasePath((0, _addLocale).addLocale(as, curLocale, pagesRouter == null ? void 0 : pagesRouter.defaultLocale));
    }
    return legacyBehavior ? /*#__PURE__*/ _react.default.cloneElement(child, childProps) : /*#__PURE__*/ _react.default.createElement("a", Object.assign({}, restProps, childProps), children);
});
var _default = Link;
exports["default"] = _default;
if ((typeof exports.default === "function" || typeof exports.default === "object" && exports.default !== null) && typeof exports.default.__esModule === "undefined") {
    Object.defineProperty(exports.default, "__esModule", {
        value: true
    });
    Object.assign(exports.default, exports);
    module.exports = exports.default;
} //# sourceMappingURL=link.js.map


/***/ }),

/***/ 5766:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
exports.normalizeLocalePath = void 0;
const normalizeLocalePath = (pathname, locales)=>{
    if (true) {
        return (__webpack_require__(22340).normalizeLocalePath)(pathname, locales);
    }
    return {
        pathname,
        detectedLocale: undefined
    };
};
exports.normalizeLocalePath = normalizeLocalePath;
if ((typeof exports.default === "function" || typeof exports.default === "object" && exports.default !== null) && typeof exports.default.__esModule === "undefined") {
    Object.defineProperty(exports.default, "__esModule", {
        value: true
    });
    Object.assign(exports.default, exports);
    module.exports = exports.default;
} //# sourceMappingURL=normalize-locale-path.js.map


/***/ }),

/***/ 2127:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
exports.useIntersection = useIntersection;
var _react = __webpack_require__(55784);
var _requestIdleCallback = __webpack_require__(20672);
const hasIntersectionObserver = typeof IntersectionObserver === "function";
const observers = new Map();
const idList = [];
function createObserver(options) {
    const id = {
        root: options.root || null,
        margin: options.rootMargin || ""
    };
    const existing = idList.find((obj)=>obj.root === id.root && obj.margin === id.margin);
    let instance;
    if (existing) {
        instance = observers.get(existing);
        if (instance) {
            return instance;
        }
    }
    const elements = new Map();
    const observer = new IntersectionObserver((entries)=>{
        entries.forEach((entry)=>{
            const callback = elements.get(entry.target);
            const isVisible = entry.isIntersecting || entry.intersectionRatio > 0;
            if (callback && isVisible) {
                callback(isVisible);
            }
        });
    }, options);
    instance = {
        id,
        observer,
        elements
    };
    idList.push(id);
    observers.set(id, instance);
    return instance;
}
function observe(element, callback, options) {
    const { id , observer , elements  } = createObserver(options);
    elements.set(element, callback);
    observer.observe(element);
    return function unobserve() {
        elements.delete(element);
        observer.unobserve(element);
        // Destroy observer when there's nothing left to watch:
        if (elements.size === 0) {
            observer.disconnect();
            observers.delete(id);
            const index = idList.findIndex((obj)=>obj.root === id.root && obj.margin === id.margin);
            if (index > -1) {
                idList.splice(index, 1);
            }
        }
    };
}
function useIntersection(param) {
    let { rootRef , rootMargin , disabled  } = param;
    const isDisabled = disabled || !hasIntersectionObserver;
    const [visible, setVisible] = (0, _react).useState(false);
    const [element, setElement] = (0, _react).useState(null);
    (0, _react).useEffect(()=>{
        if (hasIntersectionObserver) {
            if (isDisabled || visible) return;
            if (element && element.tagName) {
                const unobserve = observe(element, (isVisible)=>isVisible && setVisible(isVisible), {
                    root: rootRef == null ? void 0 : rootRef.current,
                    rootMargin
                });
                return unobserve;
            }
        } else {
            if (!visible) {
                const idleCallback = (0, _requestIdleCallback).requestIdleCallback(()=>setVisible(true));
                return ()=>(0, _requestIdleCallback).cancelIdleCallback(idleCallback);
            }
        }
    }, [
        element,
        isDisabled,
        rootMargin,
        rootRef,
        visible
    ]);
    const resetVisible = (0, _react).useCallback(()=>{
        setVisible(false);
    }, []);
    return [
        setElement,
        visible,
        resetVisible
    ];
}
if ((typeof exports.default === "function" || typeof exports.default === "object" && exports.default !== null) && typeof exports.default.__esModule === "undefined") {
    Object.defineProperty(exports.default, "__esModule", {
        value: true
    });
    Object.assign(exports.default, exports);
    module.exports = exports.default;
} //# sourceMappingURL=use-intersection.js.map


/***/ }),

/***/ 77062:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
exports["default"] = dynamic;
exports.noSSR = noSSR;
var _extends = (__webpack_require__(6495)/* ["default"] */ .Z);
var _interop_require_default = (__webpack_require__(92648)/* ["default"] */ .Z);
var _react = _interop_require_default(__webpack_require__(55784));
var _loadable = _interop_require_default(__webpack_require__(34654));
function dynamic(dynamicOptions, options) {
    let loadableFn = _loadable.default;
    let loadableOptions = (options == null ? void 0 : options.suspense) ? {} : {
        // A loading component is not required, so we default it
        loading: (param)=>{
            let { error , isLoading , pastDelay  } = param;
            if (!pastDelay) return null;
            if (false) {}
            return null;
        }
    };
    // Support for direct import(), eg: dynamic(import('../hello-world'))
    // Note that this is only kept for the edge case where someone is passing in a promise as first argument
    // The react-loadable babel plugin will turn dynamic(import('../hello-world')) into dynamic(() => import('../hello-world'))
    // To make sure we don't execute the import without rendering first
    if (dynamicOptions instanceof Promise) {
        loadableOptions.loader = ()=>dynamicOptions;
    // Support for having import as a function, eg: dynamic(() => import('../hello-world'))
    } else if (typeof dynamicOptions === "function") {
        loadableOptions.loader = dynamicOptions;
    // Support for having first argument being options, eg: dynamic({loader: import('../hello-world')})
    } else if (typeof dynamicOptions === "object") {
        loadableOptions = _extends({}, loadableOptions, dynamicOptions);
    }
    // Support for passing options, eg: dynamic(import('../hello-world'), {loading: () => <p>Loading something</p>})
    loadableOptions = _extends({}, loadableOptions, options);
    if (loadableOptions.suspense) {
        if (false) {}
        delete loadableOptions.ssr;
        delete loadableOptions.loading;
    }
    // coming from build/babel/plugins/react-loadable-plugin.js
    if (loadableOptions.loadableGenerated) {
        loadableOptions = _extends({}, loadableOptions, loadableOptions.loadableGenerated);
        delete loadableOptions.loadableGenerated;
    }
    // support for disabling server side rendering, eg: dynamic(import('../hello-world'), {ssr: false}).
    // skip `ssr` for suspense mode and opt-in React.lazy directly
    if (typeof loadableOptions.ssr === "boolean" && !loadableOptions.suspense) {
        if (!loadableOptions.ssr) {
            delete loadableOptions.ssr;
            return noSSR(loadableFn, loadableOptions);
        }
        delete loadableOptions.ssr;
    }
    return loadableFn(loadableOptions);
}
const isServerSide = "object" === "undefined";
function noSSR(LoadableInitializer, loadableOptions) {
    // Removing webpack and modules means react-loadable won't try preloading
    delete loadableOptions.webpack;
    delete loadableOptions.modules;
    // This check is necessary to prevent react-loadable from initializing on the server
    if (!isServerSide) {
        return LoadableInitializer(loadableOptions);
    }
    const Loading = loadableOptions.loading;
    // This will only be rendered on the server side
    return ()=>/*#__PURE__*/ _react.default.createElement(Loading, {
            error: null,
            isLoading: true,
            pastDelay: false,
            timedOut: false
        });
}
if ((typeof exports.default === "function" || typeof exports.default === "object" && exports.default !== null) && typeof exports.default.__esModule === "undefined") {
    Object.defineProperty(exports.default, "__esModule", {
        value: true
    });
    Object.assign(exports.default, exports);
    module.exports = exports.default;
} //# sourceMappingURL=dynamic.js.map


/***/ }),

/***/ 59642:
/***/ (function(__unused_webpack_module, exports) {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
exports.getImageBlurSvg = getImageBlurSvg;
function getImageBlurSvg(param) {
    let { widthInt , heightInt , blurWidth , blurHeight , blurDataURL  } = param;
    const std = blurWidth && blurHeight ? "1" : "20";
    const svgWidth = blurWidth || widthInt;
    const svgHeight = blurHeight || heightInt;
    const feComponentTransfer = blurDataURL.startsWith("data:image/jpeg") ? "%3CfeComponentTransfer%3E%3CfeFuncA type='discrete' tableValues='1 1'/%3E%3C/feComponentTransfer%3E%" : "";
    if (svgWidth && svgHeight) {
        return "%3Csvg xmlns='http%3A//www.w3.org/2000/svg' viewBox='0 0 ".concat(svgWidth, " ").concat(svgHeight, "'%3E%3Cfilter id='b' color-interpolation-filters='sRGB'%3E%3CfeGaussianBlur stdDeviation='").concat(std, "'/%3E").concat(feComponentTransfer, "%3C/filter%3E%3Cimage preserveAspectRatio='none' filter='url(%23b)' x='0' y='0' height='100%25' width='100%25' href='").concat(blurDataURL, "'/%3E%3C/svg%3E");
    }
    return "%3Csvg xmlns='http%3A//www.w3.org/2000/svg'%3E%3Cimage style='filter:blur(20px)' x='0' y='0' height='100%25' width='100%25' href='".concat(blurDataURL, "'/%3E%3C/svg%3E");
} //# sourceMappingURL=image-blur-svg.js.map


/***/ }),

/***/ 47112:
/***/ (function(__unused_webpack_module, exports) {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
exports["default"] = void 0;
function defaultLoader(param) {
    let { config , src , width , quality  } = param;
    if (false) {}
    if (src.endsWith(".svg") && !config.dangerouslyAllowSVG) {
        // Special case to make svg serve as-is to avoid proxying
        // through the built-in Image Optimization API.
        return src;
    }
    return "".concat(config.path, "?url=").concat(encodeURIComponent(src), "&w=").concat(width, "&q=").concat(quality || 75);
}
// We use this to determine if the import is the default loader
// or a custom loader defined by the user in next.config.js
defaultLoader.__next_img_default = true;
var _default = defaultLoader;
exports["default"] = _default; //# sourceMappingURL=image-loader.js.map


/***/ }),

/***/ 699:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
exports.LoadableContext = void 0;
var _interop_require_default = (__webpack_require__(92648)/* ["default"] */ .Z);
var _react = _interop_require_default(__webpack_require__(55784));
const LoadableContext = _react.default.createContext(null);
exports.LoadableContext = LoadableContext;
if (false) {} //# sourceMappingURL=loadable-context.js.map


/***/ }),

/***/ 34654:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
exports["default"] = void 0;
var _extends = (__webpack_require__(6495)/* ["default"] */ .Z);
var _interop_require_wildcard = (__webpack_require__(91598)/* ["default"] */ .Z);
var _react = _interop_require_wildcard(__webpack_require__(55784));
var _loadableContext = __webpack_require__(699);
const ALL_INITIALIZERS = [];
const READY_INITIALIZERS = [];
let initialized = false;
function load(loader) {
    let promise = loader();
    let state = {
        loading: true,
        loaded: null,
        error: null
    };
    state.promise = promise.then((loaded)=>{
        state.loading = false;
        state.loaded = loaded;
        return loaded;
    }).catch((err)=>{
        state.loading = false;
        state.error = err;
        throw err;
    });
    return state;
}
function resolve(obj) {
    return obj && obj.__esModule ? obj.default : obj;
}
function createLoadableComponent(loadFn, options) {
    let opts = Object.assign({
        loader: null,
        loading: null,
        delay: 200,
        timeout: null,
        webpack: null,
        modules: null,
        suspense: false
    }, options);
    if (opts.suspense) {
        opts.lazy = _react.default.lazy(opts.loader);
    }
    /** @type LoadableSubscription */ let subscription = null;
    function init() {
        if (!subscription) {
            const sub = new LoadableSubscription(loadFn, opts);
            subscription = {
                getCurrentValue: sub.getCurrentValue.bind(sub),
                subscribe: sub.subscribe.bind(sub),
                retry: sub.retry.bind(sub),
                promise: sub.promise.bind(sub)
            };
        }
        return subscription.promise();
    }
    // Server only
    if (false) {}
    // Client only
    if (!initialized && "object" !== "undefined") {
        // require.resolveWeak check is needed for environments that don't have it available like Jest
        const moduleIds = opts.webpack && "function" === "function" ? opts.webpack() : opts.modules;
        if (moduleIds) {
            READY_INITIALIZERS.push((ids)=>{
                for (const moduleId of moduleIds){
                    if (ids.indexOf(moduleId) !== -1) {
                        return init();
                    }
                }
            });
        }
    }
    function useLoadableModule() {
        init();
        const context = _react.default.useContext(_loadableContext.LoadableContext);
        if (context && Array.isArray(opts.modules)) {
            opts.modules.forEach((moduleName)=>{
                context(moduleName);
            });
        }
    }
    function LoadableImpl(props, ref) {
        useLoadableModule();
        const state = (0, _react).useSyncExternalStore(subscription.subscribe, subscription.getCurrentValue, subscription.getCurrentValue);
        _react.default.useImperativeHandle(ref, ()=>({
                retry: subscription.retry
            }), []);
        return _react.default.useMemo(()=>{
            if (state.loading || state.error) {
                return _react.default.createElement(opts.loading, {
                    isLoading: state.loading,
                    pastDelay: state.pastDelay,
                    timedOut: state.timedOut,
                    error: state.error,
                    retry: subscription.retry
                });
            } else if (state.loaded) {
                return _react.default.createElement(resolve(state.loaded), props);
            } else {
                return null;
            }
        }, [
            props,
            state
        ]);
    }
    function LazyImpl(props, ref) {
        useLoadableModule();
        return _react.default.createElement(opts.lazy, _extends({}, props, {
            ref
        }));
    }
    const LoadableComponent = opts.suspense ? LazyImpl : LoadableImpl;
    LoadableComponent.preload = ()=>init();
    LoadableComponent.displayName = "LoadableComponent";
    return _react.default.forwardRef(LoadableComponent);
}
class LoadableSubscription {
    promise() {
        return this._res.promise;
    }
    retry() {
        this._clearTimeouts();
        this._res = this._loadFn(this._opts.loader);
        this._state = {
            pastDelay: false,
            timedOut: false
        };
        const { _res: res , _opts: opts  } = this;
        if (res.loading) {
            if (typeof opts.delay === "number") {
                if (opts.delay === 0) {
                    this._state.pastDelay = true;
                } else {
                    this._delay = setTimeout(()=>{
                        this._update({
                            pastDelay: true
                        });
                    }, opts.delay);
                }
            }
            if (typeof opts.timeout === "number") {
                this._timeout = setTimeout(()=>{
                    this._update({
                        timedOut: true
                    });
                }, opts.timeout);
            }
        }
        this._res.promise.then(()=>{
            this._update({});
            this._clearTimeouts();
        }).catch((_err)=>{
            this._update({});
            this._clearTimeouts();
        });
        this._update({});
    }
    _update(partial) {
        this._state = _extends({}, this._state, {
            error: this._res.error,
            loaded: this._res.loaded,
            loading: this._res.loading
        }, partial);
        this._callbacks.forEach((callback)=>callback());
    }
    _clearTimeouts() {
        clearTimeout(this._delay);
        clearTimeout(this._timeout);
    }
    getCurrentValue() {
        return this._state;
    }
    subscribe(callback) {
        this._callbacks.add(callback);
        return ()=>{
            this._callbacks.delete(callback);
        };
    }
    constructor(loadFn, opts){
        this._loadFn = loadFn;
        this._opts = opts;
        this._callbacks = new Set();
        this._delay = null;
        this._timeout = null;
        this.retry();
    }
}
function Loadable(opts) {
    return createLoadableComponent(load, opts);
}
function flushInitializers(initializers, ids) {
    let promises = [];
    while(initializers.length){
        let init = initializers.pop();
        promises.push(init(ids));
    }
    return Promise.all(promises).then(()=>{
        if (initializers.length) {
            return flushInitializers(initializers, ids);
        }
    });
}
Loadable.preloadAll = ()=>{
    return new Promise((resolveInitializers, reject)=>{
        flushInitializers(ALL_INITIALIZERS).then(resolveInitializers, reject);
    });
};
Loadable.preloadReady = function() {
    let ids = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [];
    return new Promise((resolvePreload)=>{
        const res = ()=>{
            initialized = true;
            return resolvePreload();
        };
        // We always will resolve, errors should be handled within loading UIs.
        flushInitializers(READY_INITIALIZERS, ids).then(res, res);
    });
};
if (true) {
    window.__NEXT_PRELOADREADY = Loadable.preloadReady;
}
var _default = Loadable;
exports["default"] = _default; //# sourceMappingURL=loadable.js.map


/***/ }),

/***/ 17649:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

var __webpack_unused_export__;
/* provided dependency */ var process = __webpack_require__(83454);
__webpack_require__(2350);
var React = __webpack_require__(55784);
function _interopDefaultLegacy(e) {
    return e && typeof e === "object" && "default" in e ? e : {
        "default": e
    };
}
var React__default = /*#__PURE__*/ _interopDefaultLegacy(React);
/*
Based on Glamor's sheet
https://github.com/threepointone/glamor/blob/667b480d31b3721a905021b26e1290ce92ca2879/src/sheet.js
*/ function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function _createClass(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
}
var isProd = typeof process !== "undefined" && process.env && "production" === "production";
var isString = function(o) {
    return Object.prototype.toString.call(o) === "[object String]";
};
var StyleSheet = /*#__PURE__*/ function() {
    function StyleSheet(param) {
        var ref = param === void 0 ? {} : param, _name = ref.name, name = _name === void 0 ? "stylesheet" : _name, _optimizeForSpeed = ref.optimizeForSpeed, optimizeForSpeed = _optimizeForSpeed === void 0 ? isProd : _optimizeForSpeed;
        invariant$1(isString(name), "`name` must be a string");
        this._name = name;
        this._deletedRulePlaceholder = "#" + name + "-deleted-rule____{}";
        invariant$1(typeof optimizeForSpeed === "boolean", "`optimizeForSpeed` must be a boolean");
        this._optimizeForSpeed = optimizeForSpeed;
        this._serverSheet = undefined;
        this._tags = [];
        this._injected = false;
        this._rulesCount = 0;
        var node =  true && document.querySelector('meta[property="csp-nonce"]');
        this._nonce = node ? node.getAttribute("content") : null;
    }
    var _proto = StyleSheet.prototype;
    _proto.setOptimizeForSpeed = function setOptimizeForSpeed(bool) {
        invariant$1(typeof bool === "boolean", "`setOptimizeForSpeed` accepts a boolean");
        invariant$1(this._rulesCount === 0, "optimizeForSpeed cannot be when rules have already been inserted");
        this.flush();
        this._optimizeForSpeed = bool;
        this.inject();
    };
    _proto.isOptimizeForSpeed = function isOptimizeForSpeed() {
        return this._optimizeForSpeed;
    };
    _proto.inject = function inject() {
        var _this = this;
        invariant$1(!this._injected, "sheet already injected");
        this._injected = true;
        if ( true && this._optimizeForSpeed) {
            this._tags[0] = this.makeStyleTag(this._name);
            this._optimizeForSpeed = "insertRule" in this.getSheet();
            if (!this._optimizeForSpeed) {
                if (!isProd) {
                    console.warn("StyleSheet: optimizeForSpeed mode not supported falling back to standard mode.");
                }
                this.flush();
                this._injected = true;
            }
            return;
        }
        this._serverSheet = {
            cssRules: [],
            insertRule: function(rule, index) {
                if (typeof index === "number") {
                    _this._serverSheet.cssRules[index] = {
                        cssText: rule
                    };
                } else {
                    _this._serverSheet.cssRules.push({
                        cssText: rule
                    });
                }
                return index;
            },
            deleteRule: function(index) {
                _this._serverSheet.cssRules[index] = null;
            }
        };
    };
    _proto.getSheetForTag = function getSheetForTag(tag) {
        if (tag.sheet) {
            return tag.sheet;
        }
        // this weirdness brought to you by firefox
        for(var i = 0; i < document.styleSheets.length; i++){
            if (document.styleSheets[i].ownerNode === tag) {
                return document.styleSheets[i];
            }
        }
    };
    _proto.getSheet = function getSheet() {
        return this.getSheetForTag(this._tags[this._tags.length - 1]);
    };
    _proto.insertRule = function insertRule(rule, index) {
        invariant$1(isString(rule), "`insertRule` accepts only strings");
        if (false) {}
        if (this._optimizeForSpeed) {
            var sheet = this.getSheet();
            if (typeof index !== "number") {
                index = sheet.cssRules.length;
            }
            // this weirdness for perf, and chrome's weird bug
            // https://stackoverflow.com/questions/20007992/chrome-suddenly-stopped-accepting-insertrule
            try {
                sheet.insertRule(rule, index);
            } catch (error) {
                if (!isProd) {
                    console.warn("StyleSheet: illegal rule: \n\n" + rule + "\n\nSee https://stackoverflow.com/q/20007992 for more info");
                }
                return -1;
            }
        } else {
            var insertionPoint = this._tags[index];
            this._tags.push(this.makeStyleTag(this._name, rule, insertionPoint));
        }
        return this._rulesCount++;
    };
    _proto.replaceRule = function replaceRule(index, rule) {
        if (this._optimizeForSpeed || "object" === "undefined") {
            var sheet =  true ? this.getSheet() : 0;
            if (!rule.trim()) {
                rule = this._deletedRulePlaceholder;
            }
            if (!sheet.cssRules[index]) {
                // @TBD Should we throw an error?
                return index;
            }
            sheet.deleteRule(index);
            try {
                sheet.insertRule(rule, index);
            } catch (error) {
                if (!isProd) {
                    console.warn("StyleSheet: illegal rule: \n\n" + rule + "\n\nSee https://stackoverflow.com/q/20007992 for more info");
                }
                // In order to preserve the indices we insert a deleteRulePlaceholder
                sheet.insertRule(this._deletedRulePlaceholder, index);
            }
        } else {
            var tag = this._tags[index];
            invariant$1(tag, "old rule at index `" + index + "` not found");
            tag.textContent = rule;
        }
        return index;
    };
    _proto.deleteRule = function deleteRule(index) {
        if (false) {}
        if (this._optimizeForSpeed) {
            this.replaceRule(index, "");
        } else {
            var tag = this._tags[index];
            invariant$1(tag, "rule at index `" + index + "` not found");
            tag.parentNode.removeChild(tag);
            this._tags[index] = null;
        }
    };
    _proto.flush = function flush() {
        this._injected = false;
        this._rulesCount = 0;
        if (true) {
            this._tags.forEach(function(tag) {
                return tag && tag.parentNode.removeChild(tag);
            });
            this._tags = [];
        } else {}
    };
    _proto.cssRules = function cssRules() {
        var _this = this;
        if (false) {}
        return this._tags.reduce(function(rules, tag) {
            if (tag) {
                rules = rules.concat(Array.prototype.map.call(_this.getSheetForTag(tag).cssRules, function(rule) {
                    return rule.cssText === _this._deletedRulePlaceholder ? null : rule;
                }));
            } else {
                rules.push(null);
            }
            return rules;
        }, []);
    };
    _proto.makeStyleTag = function makeStyleTag(name, cssString, relativeToTag) {
        if (cssString) {
            invariant$1(isString(cssString), "makeStyleTag accepts only strings as second parameter");
        }
        var tag = document.createElement("style");
        if (this._nonce) tag.setAttribute("nonce", this._nonce);
        tag.type = "text/css";
        tag.setAttribute("data-" + name, "");
        if (cssString) {
            tag.appendChild(document.createTextNode(cssString));
        }
        var head = document.head || document.getElementsByTagName("head")[0];
        if (relativeToTag) {
            head.insertBefore(tag, relativeToTag);
        } else {
            head.appendChild(tag);
        }
        return tag;
    };
    _createClass(StyleSheet, [
        {
            key: "length",
            get: function get() {
                return this._rulesCount;
            }
        }
    ]);
    return StyleSheet;
}();
function invariant$1(condition, message) {
    if (!condition) {
        throw new Error("StyleSheet: " + message + ".");
    }
}
function hash(str) {
    var _$hash = 5381, i = str.length;
    while(i){
        _$hash = _$hash * 33 ^ str.charCodeAt(--i);
    }
    /* JavaScript does bitwise operations (like XOR, above) on 32-bit signed
   * integers. Since we want the results to be always positive, convert the
   * signed int to an unsigned by doing an unsigned bitshift. */ return _$hash >>> 0;
}
var stringHash = hash;
var sanitize = function(rule) {
    return rule.replace(/\/style/gi, "\\/style");
};
var cache = {};
/**
 * computeId
 *
 * Compute and memoize a jsx id from a basedId and optionally props.
 */ function computeId(baseId, props) {
    if (!props) {
        return "jsx-" + baseId;
    }
    var propsToString = String(props);
    var key = baseId + propsToString;
    if (!cache[key]) {
        cache[key] = "jsx-" + stringHash(baseId + "-" + propsToString);
    }
    return cache[key];
}
/**
 * computeSelector
 *
 * Compute and memoize dynamic selectors.
 */ function computeSelector(id, css) {
    var selectoPlaceholderRegexp = /__jsx-style-dynamic-selector/g;
    // Sanitize SSR-ed CSS.
    // Client side code doesn't need to be sanitized since we use
    // document.createTextNode (dev) and the CSSOM api sheet.insertRule (prod).
    if (false) {}
    var idcss = id + css;
    if (!cache[idcss]) {
        cache[idcss] = css.replace(selectoPlaceholderRegexp, id);
    }
    return cache[idcss];
}
function mapRulesToStyle(cssRules, options) {
    if (options === void 0) options = {};
    return cssRules.map(function(args) {
        var id = args[0];
        var css = args[1];
        return /*#__PURE__*/ React__default["default"].createElement("style", {
            id: "__" + id,
            // Avoid warnings upon render with a key
            key: "__" + id,
            nonce: options.nonce ? options.nonce : undefined,
            dangerouslySetInnerHTML: {
                __html: css
            }
        });
    });
}
var StyleSheetRegistry = /*#__PURE__*/ function() {
    function StyleSheetRegistry(param) {
        var ref = param === void 0 ? {} : param, _styleSheet = ref.styleSheet, styleSheet = _styleSheet === void 0 ? null : _styleSheet, _optimizeForSpeed = ref.optimizeForSpeed, optimizeForSpeed = _optimizeForSpeed === void 0 ? false : _optimizeForSpeed;
        this._sheet = styleSheet || new StyleSheet({
            name: "styled-jsx",
            optimizeForSpeed: optimizeForSpeed
        });
        this._sheet.inject();
        if (styleSheet && typeof optimizeForSpeed === "boolean") {
            this._sheet.setOptimizeForSpeed(optimizeForSpeed);
            this._optimizeForSpeed = this._sheet.isOptimizeForSpeed();
        }
        this._fromServer = undefined;
        this._indices = {};
        this._instancesCounts = {};
    }
    var _proto = StyleSheetRegistry.prototype;
    _proto.add = function add(props) {
        var _this = this;
        if (undefined === this._optimizeForSpeed) {
            this._optimizeForSpeed = Array.isArray(props.children);
            this._sheet.setOptimizeForSpeed(this._optimizeForSpeed);
            this._optimizeForSpeed = this._sheet.isOptimizeForSpeed();
        }
        if ( true && !this._fromServer) {
            this._fromServer = this.selectFromServer();
            this._instancesCounts = Object.keys(this._fromServer).reduce(function(acc, tagName) {
                acc[tagName] = 0;
                return acc;
            }, {});
        }
        var ref = this.getIdAndRules(props), styleId = ref.styleId, rules = ref.rules;
        // Deduping: just increase the instances count.
        if (styleId in this._instancesCounts) {
            this._instancesCounts[styleId] += 1;
            return;
        }
        var indices = rules.map(function(rule) {
            return _this._sheet.insertRule(rule);
        }) // Filter out invalid rules
        .filter(function(index) {
            return index !== -1;
        });
        this._indices[styleId] = indices;
        this._instancesCounts[styleId] = 1;
    };
    _proto.remove = function remove(props) {
        var _this = this;
        var styleId = this.getIdAndRules(props).styleId;
        invariant(styleId in this._instancesCounts, "styleId: `" + styleId + "` not found");
        this._instancesCounts[styleId] -= 1;
        if (this._instancesCounts[styleId] < 1) {
            var tagFromServer = this._fromServer && this._fromServer[styleId];
            if (tagFromServer) {
                tagFromServer.parentNode.removeChild(tagFromServer);
                delete this._fromServer[styleId];
            } else {
                this._indices[styleId].forEach(function(index) {
                    return _this._sheet.deleteRule(index);
                });
                delete this._indices[styleId];
            }
            delete this._instancesCounts[styleId];
        }
    };
    _proto.update = function update(props, nextProps) {
        this.add(nextProps);
        this.remove(props);
    };
    _proto.flush = function flush() {
        this._sheet.flush();
        this._sheet.inject();
        this._fromServer = undefined;
        this._indices = {};
        this._instancesCounts = {};
    };
    _proto.cssRules = function cssRules() {
        var _this = this;
        var fromServer = this._fromServer ? Object.keys(this._fromServer).map(function(styleId) {
            return [
                styleId,
                _this._fromServer[styleId]
            ];
        }) : [];
        var cssRules = this._sheet.cssRules();
        return fromServer.concat(Object.keys(this._indices).map(function(styleId) {
            return [
                styleId,
                _this._indices[styleId].map(function(index) {
                    return cssRules[index].cssText;
                }).join(_this._optimizeForSpeed ? "" : "\n")
            ];
        }) // filter out empty rules
        .filter(function(rule) {
            return Boolean(rule[1]);
        }));
    };
    _proto.styles = function styles(options) {
        return mapRulesToStyle(this.cssRules(), options);
    };
    _proto.getIdAndRules = function getIdAndRules(props) {
        var css = props.children, dynamic = props.dynamic, id = props.id;
        if (dynamic) {
            var styleId = computeId(id, dynamic);
            return {
                styleId: styleId,
                rules: Array.isArray(css) ? css.map(function(rule) {
                    return computeSelector(styleId, rule);
                }) : [
                    computeSelector(styleId, css)
                ]
            };
        }
        return {
            styleId: computeId(id),
            rules: Array.isArray(css) ? css : [
                css
            ]
        };
    };
    /**
   * selectFromServer
   *
   * Collects style tags from the document with id __jsx-XXX
   */ _proto.selectFromServer = function selectFromServer() {
        var elements = Array.prototype.slice.call(document.querySelectorAll('[id^="__jsx-"]'));
        return elements.reduce(function(acc, element) {
            var id = element.id.slice(2);
            acc[id] = element;
            return acc;
        }, {});
    };
    return StyleSheetRegistry;
}();
function invariant(condition, message) {
    if (!condition) {
        throw new Error("StyleSheetRegistry: " + message + ".");
    }
}
var StyleSheetContext = /*#__PURE__*/ React.createContext(null);
StyleSheetContext.displayName = "StyleSheetContext";
function createStyleRegistry() {
    return new StyleSheetRegistry();
}
function StyleRegistry(param) {
    var configuredRegistry = param.registry, children = param.children;
    var rootRegistry = React.useContext(StyleSheetContext);
    var ref = React.useState(function() {
        return rootRegistry || configuredRegistry || createStyleRegistry();
    }), registry = ref[0];
    return /*#__PURE__*/ React__default["default"].createElement(StyleSheetContext.Provider, {
        value: registry
    }, children);
}
function useStyleRegistry() {
    return React.useContext(StyleSheetContext);
}
// Opt-into the new `useInsertionEffect` API in React 18, fallback to `useLayoutEffect`.
// https://github.com/reactwg/react-18/discussions/110
var useInsertionEffect = React__default["default"].useInsertionEffect || React__default["default"].useLayoutEffect;
var defaultRegistry =  true ? createStyleRegistry() : 0;
function JSXStyle(props) {
    var registry = defaultRegistry ? defaultRegistry : useStyleRegistry();
    // If `registry` does not exist, we do nothing here.
    if (!registry) {
        return null;
    }
    if (false) {}
    useInsertionEffect(function() {
        registry.add(props);
        return function() {
            registry.remove(props);
        };
    // props.children can be string[], will be striped since id is identical
    }, [
        props.id,
        String(props.dynamic)
    ]);
    return null;
}
JSXStyle.dynamic = function(info) {
    return info.map(function(tagInfo) {
        var baseId = tagInfo[0];
        var props = tagInfo[1];
        return computeId(baseId, props);
    }).join(" ");
};
__webpack_unused_export__ = StyleRegistry;
__webpack_unused_export__ = createStyleRegistry;
exports.style = JSXStyle;
__webpack_unused_export__ = useStyleRegistry;


/***/ }),

/***/ 7928:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

module.exports = __webpack_require__(17649).style;


/***/ }),

/***/ 89418:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ _app; }
});

// EXTERNAL MODULE: ./node_modules/next/dist/compiled/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(41844);
// EXTERNAL MODULE: ./app/configs/index.ts + 3 modules
var configs = __webpack_require__(54254);
// EXTERNAL MODULE: ./app/context/index.ts + 2 modules
var context = __webpack_require__(17986);
// EXTERNAL MODULE: ./app/services/query-fn/index.ts + 6 modules
var query_fn = __webpack_require__(58512);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/react/index.js
var react = __webpack_require__(55784);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__(87462);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/react-dom/index.js
var react_dom = __webpack_require__(18369);
// EXTERNAL MODULE: ./node_modules/@radix-ui/primitive/dist/index.mjs
var dist = __webpack_require__(36206);
// EXTERNAL MODULE: ./node_modules/@radix-ui/react-compose-refs/dist/index.mjs
var react_compose_refs_dist = __webpack_require__(28771);
// EXTERNAL MODULE: ./node_modules/@radix-ui/react-collection/dist/index.mjs
var react_collection_dist = __webpack_require__(65936);
// EXTERNAL MODULE: ./node_modules/@radix-ui/react-context/dist/index.mjs
var react_context_dist = __webpack_require__(25360);
// EXTERNAL MODULE: ./node_modules/@radix-ui/react-dismissable-layer/dist/index.mjs + 1 modules
var react_dismissable_layer_dist = __webpack_require__(46063);
// EXTERNAL MODULE: ./node_modules/@radix-ui/react-portal/dist/index.mjs
var react_portal_dist = __webpack_require__(42651);
// EXTERNAL MODULE: ./node_modules/@radix-ui/react-presence/dist/index.mjs
var react_presence_dist = __webpack_require__(29115);
// EXTERNAL MODULE: ./node_modules/@radix-ui/react-primitive/dist/index.mjs
var react_primitive_dist = __webpack_require__(75320);
// EXTERNAL MODULE: ./node_modules/@radix-ui/react-use-callback-ref/dist/index.mjs
var react_use_callback_ref_dist = __webpack_require__(79698);
// EXTERNAL MODULE: ./node_modules/@radix-ui/react-use-controllable-state/dist/index.mjs
var react_use_controllable_state_dist = __webpack_require__(77342);
// EXTERNAL MODULE: ./node_modules/@radix-ui/react-use-layout-effect/dist/index.mjs
var react_use_layout_effect_dist = __webpack_require__(9981);
// EXTERNAL MODULE: ./node_modules/@radix-ui/react-visually-hidden/dist/index.mjs
var react_visually_hidden_dist = __webpack_require__(96219);
;// CONCATENATED MODULE: ./node_modules/@radix-ui/react-toast/dist/index.mjs































/* -------------------------------------------------------------------------------------------------
 * ToastProvider
 * -----------------------------------------------------------------------------------------------*/ const $054eb8030ebde76e$var$PROVIDER_NAME = 'ToastProvider';
const [$054eb8030ebde76e$var$Collection, $054eb8030ebde76e$var$useCollection, $054eb8030ebde76e$var$createCollectionScope] = (0,react_collection_dist/* createCollection */.B)('Toast');
const [$054eb8030ebde76e$var$createToastContext, $054eb8030ebde76e$export$8a359da18fbc9073] = (0,react_context_dist/* createContextScope */.b)('Toast', [
    $054eb8030ebde76e$var$createCollectionScope
]);
const [$054eb8030ebde76e$var$ToastProviderProvider, $054eb8030ebde76e$var$useToastProviderContext] = $054eb8030ebde76e$var$createToastContext($054eb8030ebde76e$var$PROVIDER_NAME);
const $054eb8030ebde76e$export$f5d03d415824e0e = (props)=>{
    const { __scopeToast: __scopeToast , label: label = 'Notification' , duration: duration = 5000 , swipeDirection: swipeDirection = 'right' , swipeThreshold: swipeThreshold = 50 , children: children  } = props;
    const [viewport, setViewport] = (0,react.useState)(null);
    const [toastCount, setToastCount] = (0,react.useState)(0);
    const isFocusedToastEscapeKeyDownRef = (0,react.useRef)(false);
    const isClosePausedRef = (0,react.useRef)(false);
    return /*#__PURE__*/ (0,react.createElement)($054eb8030ebde76e$var$Collection.Provider, {
        scope: __scopeToast
    }, /*#__PURE__*/ (0,react.createElement)($054eb8030ebde76e$var$ToastProviderProvider, {
        scope: __scopeToast,
        label: label,
        duration: duration,
        swipeDirection: swipeDirection,
        swipeThreshold: swipeThreshold,
        toastCount: toastCount,
        viewport: viewport,
        onViewportChange: setViewport,
        onToastAdd: (0,react.useCallback)(()=>setToastCount((prevCount)=>prevCount + 1
            )
        , []),
        onToastRemove: (0,react.useCallback)(()=>setToastCount((prevCount)=>prevCount - 1
            )
        , []),
        isFocusedToastEscapeKeyDownRef: isFocusedToastEscapeKeyDownRef,
        isClosePausedRef: isClosePausedRef
    }, children));
};
$054eb8030ebde76e$export$f5d03d415824e0e.propTypes = {
    label (props) {
        if (props.label && typeof props.label === 'string' && !props.label.trim()) {
            const error = `Invalid prop \`label\` supplied to \`${$054eb8030ebde76e$var$PROVIDER_NAME}\`. Expected non-empty \`string\`.`;
            return new Error(error);
        }
        return null;
    }
};
/*#__PURE__*/ Object.assign($054eb8030ebde76e$export$f5d03d415824e0e, {
    displayName: $054eb8030ebde76e$var$PROVIDER_NAME
});
/* -------------------------------------------------------------------------------------------------
 * ToastViewport
 * -----------------------------------------------------------------------------------------------*/ const $054eb8030ebde76e$var$VIEWPORT_NAME = 'ToastViewport';
const $054eb8030ebde76e$var$VIEWPORT_DEFAULT_HOTKEY = [
    'F8'
];
const $054eb8030ebde76e$var$VIEWPORT_PAUSE = 'toast.viewportPause';
const $054eb8030ebde76e$var$VIEWPORT_RESUME = 'toast.viewportResume';
const $054eb8030ebde76e$export$6192c2425ecfd989 = /*#__PURE__*/ (0,react.forwardRef)((props, forwardedRef)=>{
    const { __scopeToast: __scopeToast , hotkey: hotkey = $054eb8030ebde76e$var$VIEWPORT_DEFAULT_HOTKEY , label: label = 'Notifications ({hotkey})' , ...viewportProps } = props;
    const context = $054eb8030ebde76e$var$useToastProviderContext($054eb8030ebde76e$var$VIEWPORT_NAME, __scopeToast);
    const getItems = $054eb8030ebde76e$var$useCollection(__scopeToast);
    const wrapperRef = (0,react.useRef)(null);
    const headFocusProxyRef = (0,react.useRef)(null);
    const tailFocusProxyRef = (0,react.useRef)(null);
    const ref = (0,react.useRef)(null);
    const composedRefs = (0,react_compose_refs_dist/* useComposedRefs */.e)(forwardedRef, ref, context.onViewportChange);
    const hotkeyLabel = hotkey.join('+').replace(/Key/g, '').replace(/Digit/g, '');
    const hasToasts = context.toastCount > 0;
    (0,react.useEffect)(()=>{
        const handleKeyDown = (event)=>{
            var _ref$current;
            // we use `event.code` as it is consistent regardless of meta keys that were pressed.
            // for example, `event.key` for `Control+Alt+t` is `†` and `t !== †`
            const isHotkeyPressed = hotkey.every((key)=>event[key] || event.code === key
            );
            if (isHotkeyPressed) (_ref$current = ref.current) === null || _ref$current === void 0 || _ref$current.focus();
        };
        document.addEventListener('keydown', handleKeyDown);
        return ()=>document.removeEventListener('keydown', handleKeyDown)
        ;
    }, [
        hotkey
    ]);
    (0,react.useEffect)(()=>{
        const wrapper = wrapperRef.current;
        const viewport = ref.current;
        if (hasToasts && wrapper && viewport) {
            const handlePause = ()=>{
                if (!context.isClosePausedRef.current) {
                    const pauseEvent = new CustomEvent($054eb8030ebde76e$var$VIEWPORT_PAUSE);
                    viewport.dispatchEvent(pauseEvent);
                    context.isClosePausedRef.current = true;
                }
            };
            const handleResume = ()=>{
                if (context.isClosePausedRef.current) {
                    const resumeEvent = new CustomEvent($054eb8030ebde76e$var$VIEWPORT_RESUME);
                    viewport.dispatchEvent(resumeEvent);
                    context.isClosePausedRef.current = false;
                }
            };
            const handleFocusOutResume = (event)=>{
                const isFocusMovingOutside = !wrapper.contains(event.relatedTarget);
                if (isFocusMovingOutside) handleResume();
            };
            const handlePointerLeaveResume = ()=>{
                const isFocusInside = wrapper.contains(document.activeElement);
                if (!isFocusInside) handleResume();
            }; // Toasts are not in the viewport React tree so we need to bind DOM events
            wrapper.addEventListener('focusin', handlePause);
            wrapper.addEventListener('focusout', handleFocusOutResume);
            wrapper.addEventListener('pointermove', handlePause);
            wrapper.addEventListener('pointerleave', handlePointerLeaveResume);
            window.addEventListener('blur', handlePause);
            window.addEventListener('focus', handleResume);
            return ()=>{
                wrapper.removeEventListener('focusin', handlePause);
                wrapper.removeEventListener('focusout', handleFocusOutResume);
                wrapper.removeEventListener('pointermove', handlePause);
                wrapper.removeEventListener('pointerleave', handlePointerLeaveResume);
                window.removeEventListener('blur', handlePause);
                window.removeEventListener('focus', handleResume);
            };
        }
    }, [
        hasToasts,
        context.isClosePausedRef
    ]);
    const getSortedTabbableCandidates = (0,react.useCallback)(({ tabbingDirection: tabbingDirection  })=>{
        const toastItems = getItems();
        const tabbableCandidates = toastItems.map((toastItem)=>{
            const toastNode = toastItem.ref.current;
            const toastTabbableCandidates = [
                toastNode,
                ...$054eb8030ebde76e$var$getTabbableCandidates(toastNode)
            ];
            return tabbingDirection === 'forwards' ? toastTabbableCandidates : toastTabbableCandidates.reverse();
        });
        return (tabbingDirection === 'forwards' ? tabbableCandidates.reverse() : tabbableCandidates).flat();
    }, [
        getItems
    ]);
    (0,react.useEffect)(()=>{
        const viewport = ref.current; // We programmatically manage tabbing as we are unable to influence
        // the source order with portals, this allows us to reverse the
        // tab order so that it runs from most recent toast to least
        if (viewport) {
            const handleKeyDown = (event)=>{
                const isMetaKey = event.altKey || event.ctrlKey || event.metaKey;
                const isTabKey = event.key === 'Tab' && !isMetaKey;
                if (isTabKey) {
                    const focusedElement = document.activeElement;
                    const isTabbingBackwards = event.shiftKey;
                    const targetIsViewport = event.target === viewport; // If we're back tabbing after jumping to the viewport then we simply
                    // proxy focus out to the preceding document
                    if (targetIsViewport && isTabbingBackwards) {
                        var _headFocusProxyRef$cu;
                        (_headFocusProxyRef$cu = headFocusProxyRef.current) === null || _headFocusProxyRef$cu === void 0 || _headFocusProxyRef$cu.focus();
                        return;
                    }
                    const tabbingDirection = isTabbingBackwards ? 'backwards' : 'forwards';
                    const sortedCandidates = getSortedTabbableCandidates({
                        tabbingDirection: tabbingDirection
                    });
                    const index = sortedCandidates.findIndex((candidate)=>candidate === focusedElement
                    );
                    if ($054eb8030ebde76e$var$focusFirst(sortedCandidates.slice(index + 1))) event.preventDefault();
                    else {
                        var _headFocusProxyRef$cu2, _tailFocusProxyRef$cu;
                        // If we can't focus that means we're at the edges so we
                        // proxy to the corresponding exit point and let the browser handle
                        // tab/shift+tab keypress and implicitly pass focus to the next valid element in the document
                        isTabbingBackwards ? (_headFocusProxyRef$cu2 = headFocusProxyRef.current) === null || _headFocusProxyRef$cu2 === void 0 || _headFocusProxyRef$cu2.focus() : (_tailFocusProxyRef$cu = tailFocusProxyRef.current) === null || _tailFocusProxyRef$cu === void 0 || _tailFocusProxyRef$cu.focus();
                    }
                }
            }; // Toasts are not in the viewport React tree so we need to bind DOM events
            viewport.addEventListener('keydown', handleKeyDown);
            return ()=>viewport.removeEventListener('keydown', handleKeyDown)
            ;
        }
    }, [
        getItems,
        getSortedTabbableCandidates
    ]);
    return /*#__PURE__*/ (0,react.createElement)(react_dismissable_layer_dist/* Branch */.I0, {
        ref: wrapperRef,
        role: "region",
        "aria-label": label.replace('{hotkey}', hotkeyLabel) // Ensure virtual cursor from landmarks menus triggers focus/blur for pause/resume
        ,
        tabIndex: -1 // incase list has size when empty (e.g. padding), we remove pointer events so
        ,
        style: {
            pointerEvents: hasToasts ? undefined : 'none'
        }
    }, hasToasts && /*#__PURE__*/ (0,react.createElement)($054eb8030ebde76e$var$FocusProxy, {
        ref: headFocusProxyRef,
        onFocusFromOutsideViewport: ()=>{
            const tabbableCandidates = getSortedTabbableCandidates({
                tabbingDirection: 'forwards'
            });
            $054eb8030ebde76e$var$focusFirst(tabbableCandidates);
        }
    }), /*#__PURE__*/ (0,react.createElement)($054eb8030ebde76e$var$Collection.Slot, {
        scope: __scopeToast
    }, /*#__PURE__*/ (0,react.createElement)(react_primitive_dist/* Primitive.ol */.WV.ol, (0,esm_extends/* default */.Z)({
        tabIndex: -1
    }, viewportProps, {
        ref: composedRefs
    }))), hasToasts && /*#__PURE__*/ (0,react.createElement)($054eb8030ebde76e$var$FocusProxy, {
        ref: tailFocusProxyRef,
        onFocusFromOutsideViewport: ()=>{
            const tabbableCandidates = getSortedTabbableCandidates({
                tabbingDirection: 'backwards'
            });
            $054eb8030ebde76e$var$focusFirst(tabbableCandidates);
        }
    }));
});
/*#__PURE__*/ Object.assign($054eb8030ebde76e$export$6192c2425ecfd989, {
    displayName: $054eb8030ebde76e$var$VIEWPORT_NAME
});
/* -----------------------------------------------------------------------------------------------*/ const $054eb8030ebde76e$var$FOCUS_PROXY_NAME = 'ToastFocusProxy';
const $054eb8030ebde76e$var$FocusProxy = /*#__PURE__*/ (0,react.forwardRef)((props, forwardedRef)=>{
    const { __scopeToast: __scopeToast , onFocusFromOutsideViewport: onFocusFromOutsideViewport , ...proxyProps } = props;
    const context = $054eb8030ebde76e$var$useToastProviderContext($054eb8030ebde76e$var$FOCUS_PROXY_NAME, __scopeToast);
    return /*#__PURE__*/ (0,react.createElement)(react_visually_hidden_dist/* VisuallyHidden */.T, (0,esm_extends/* default */.Z)({
        "aria-hidden": true,
        tabIndex: 0
    }, proxyProps, {
        ref: forwardedRef // Avoid page scrolling when focus is on the focus proxy
        ,
        style: {
            position: 'fixed'
        },
        onFocus: (event)=>{
            var _context$viewport;
            const prevFocusedElement = event.relatedTarget;
            const isFocusFromOutsideViewport = !((_context$viewport = context.viewport) !== null && _context$viewport !== void 0 && _context$viewport.contains(prevFocusedElement));
            if (isFocusFromOutsideViewport) onFocusFromOutsideViewport();
        }
    }));
});
/*#__PURE__*/ Object.assign($054eb8030ebde76e$var$FocusProxy, {
    displayName: $054eb8030ebde76e$var$FOCUS_PROXY_NAME
});
/* -------------------------------------------------------------------------------------------------
 * Toast
 * -----------------------------------------------------------------------------------------------*/ const $054eb8030ebde76e$var$TOAST_NAME = 'Toast';
const $054eb8030ebde76e$var$TOAST_SWIPE_START = 'toast.swipeStart';
const $054eb8030ebde76e$var$TOAST_SWIPE_MOVE = 'toast.swipeMove';
const $054eb8030ebde76e$var$TOAST_SWIPE_CANCEL = 'toast.swipeCancel';
const $054eb8030ebde76e$var$TOAST_SWIPE_END = 'toast.swipeEnd';
const $054eb8030ebde76e$export$8d8dc7d5f743331b = /*#__PURE__*/ (0,react.forwardRef)((props, forwardedRef)=>{
    const { forceMount: forceMount , open: openProp , defaultOpen: defaultOpen , onOpenChange: onOpenChange , ...toastProps } = props;
    const [open = true, setOpen] = (0,react_use_controllable_state_dist/* useControllableState */.T)({
        prop: openProp,
        defaultProp: defaultOpen,
        onChange: onOpenChange
    });
    return /*#__PURE__*/ (0,react.createElement)(react_presence_dist/* Presence */.z, {
        present: forceMount || open
    }, /*#__PURE__*/ (0,react.createElement)($054eb8030ebde76e$var$ToastImpl, (0,esm_extends/* default */.Z)({
        open: open
    }, toastProps, {
        ref: forwardedRef,
        onClose: ()=>setOpen(false)
        ,
        onPause: (0,react_use_callback_ref_dist/* useCallbackRef */.W)(props.onPause),
        onResume: (0,react_use_callback_ref_dist/* useCallbackRef */.W)(props.onResume),
        onSwipeStart: (0,dist/* composeEventHandlers */.M)(props.onSwipeStart, (event)=>{
            event.currentTarget.setAttribute('data-swipe', 'start');
        }),
        onSwipeMove: (0,dist/* composeEventHandlers */.M)(props.onSwipeMove, (event)=>{
            const { x: x , y: y  } = event.detail.delta;
            event.currentTarget.setAttribute('data-swipe', 'move');
            event.currentTarget.style.setProperty('--radix-toast-swipe-move-x', `${x}px`);
            event.currentTarget.style.setProperty('--radix-toast-swipe-move-y', `${y}px`);
        }),
        onSwipeCancel: (0,dist/* composeEventHandlers */.M)(props.onSwipeCancel, (event)=>{
            event.currentTarget.setAttribute('data-swipe', 'cancel');
            event.currentTarget.style.removeProperty('--radix-toast-swipe-move-x');
            event.currentTarget.style.removeProperty('--radix-toast-swipe-move-y');
            event.currentTarget.style.removeProperty('--radix-toast-swipe-end-x');
            event.currentTarget.style.removeProperty('--radix-toast-swipe-end-y');
        }),
        onSwipeEnd: (0,dist/* composeEventHandlers */.M)(props.onSwipeEnd, (event)=>{
            const { x: x , y: y  } = event.detail.delta;
            event.currentTarget.setAttribute('data-swipe', 'end');
            event.currentTarget.style.removeProperty('--radix-toast-swipe-move-x');
            event.currentTarget.style.removeProperty('--radix-toast-swipe-move-y');
            event.currentTarget.style.setProperty('--radix-toast-swipe-end-x', `${x}px`);
            event.currentTarget.style.setProperty('--radix-toast-swipe-end-y', `${y}px`);
            setOpen(false);
        })
    })));
});
/*#__PURE__*/ Object.assign($054eb8030ebde76e$export$8d8dc7d5f743331b, {
    displayName: $054eb8030ebde76e$var$TOAST_NAME
});
/* -----------------------------------------------------------------------------------------------*/ const [$054eb8030ebde76e$var$ToastInteractiveProvider, $054eb8030ebde76e$var$useToastInteractiveContext] = $054eb8030ebde76e$var$createToastContext($054eb8030ebde76e$var$TOAST_NAME, {
    onClose () {}
});
const $054eb8030ebde76e$var$ToastImpl = /*#__PURE__*/ (0,react.forwardRef)((props, forwardedRef)=>{
    const { __scopeToast: __scopeToast , type: type = 'foreground' , duration: durationProp , open: open , onClose: onClose , onEscapeKeyDown: onEscapeKeyDown , onPause: onPause , onResume: onResume , onSwipeStart: onSwipeStart , onSwipeMove: onSwipeMove , onSwipeCancel: onSwipeCancel , onSwipeEnd: onSwipeEnd , ...toastProps } = props;
    const context = $054eb8030ebde76e$var$useToastProviderContext($054eb8030ebde76e$var$TOAST_NAME, __scopeToast);
    const [node1, setNode] = (0,react.useState)(null);
    const composedRefs = (0,react_compose_refs_dist/* useComposedRefs */.e)(forwardedRef, (node)=>setNode(node)
    );
    const pointerStartRef = (0,react.useRef)(null);
    const swipeDeltaRef = (0,react.useRef)(null);
    const duration1 = durationProp || context.duration;
    const closeTimerStartTimeRef = (0,react.useRef)(0);
    const closeTimerRemainingTimeRef = (0,react.useRef)(duration1);
    const closeTimerRef = (0,react.useRef)(0);
    const { onToastAdd: onToastAdd , onToastRemove: onToastRemove  } = context;
    const handleClose = (0,react_use_callback_ref_dist/* useCallbackRef */.W)(()=>{
        var _context$viewport2;
        // focus viewport if focus is within toast to read the remaining toast
        // count to SR users and ensure focus isn't lost
        const isFocusInToast = node1 === null || node1 === void 0 ? void 0 : node1.contains(document.activeElement);
        if (isFocusInToast) (_context$viewport2 = context.viewport) === null || _context$viewport2 === void 0 || _context$viewport2.focus();
        onClose();
    });
    const startTimer = (0,react.useCallback)((duration)=>{
        if (!duration || duration === Infinity) return;
        window.clearTimeout(closeTimerRef.current);
        closeTimerStartTimeRef.current = new Date().getTime();
        closeTimerRef.current = window.setTimeout(handleClose, duration);
    }, [
        handleClose
    ]);
    (0,react.useEffect)(()=>{
        const viewport = context.viewport;
        if (viewport) {
            const handleResume = ()=>{
                startTimer(closeTimerRemainingTimeRef.current);
                onResume === null || onResume === void 0 || onResume();
            };
            const handlePause = ()=>{
                const elapsedTime = new Date().getTime() - closeTimerStartTimeRef.current;
                closeTimerRemainingTimeRef.current = closeTimerRemainingTimeRef.current - elapsedTime;
                window.clearTimeout(closeTimerRef.current);
                onPause === null || onPause === void 0 || onPause();
            };
            viewport.addEventListener($054eb8030ebde76e$var$VIEWPORT_PAUSE, handlePause);
            viewport.addEventListener($054eb8030ebde76e$var$VIEWPORT_RESUME, handleResume);
            return ()=>{
                viewport.removeEventListener($054eb8030ebde76e$var$VIEWPORT_PAUSE, handlePause);
                viewport.removeEventListener($054eb8030ebde76e$var$VIEWPORT_RESUME, handleResume);
            };
        }
    }, [
        context.viewport,
        duration1,
        onPause,
        onResume,
        startTimer
    ]); // start timer when toast opens or duration changes.
    // we include `open` in deps because closed !== unmounted when animating
    // so it could reopen before being completely unmounted
    (0,react.useEffect)(()=>{
        if (open && !context.isClosePausedRef.current) startTimer(duration1);
    }, [
        open,
        duration1,
        context.isClosePausedRef,
        startTimer
    ]);
    (0,react.useEffect)(()=>{
        onToastAdd();
        return ()=>onToastRemove()
        ;
    }, [
        onToastAdd,
        onToastRemove
    ]);
    const announceTextContent = (0,react.useMemo)(()=>{
        return node1 ? $054eb8030ebde76e$var$getAnnounceTextContent(node1) : null;
    }, [
        node1
    ]);
    if (!context.viewport) return null;
    return /*#__PURE__*/ (0,react.createElement)(react.Fragment, null, announceTextContent && /*#__PURE__*/ (0,react.createElement)($054eb8030ebde76e$var$ToastAnnounce, {
        __scopeToast: __scopeToast // Toasts are always role=status to avoid stuttering issues with role=alert in SRs.
        ,
        role: "status",
        "aria-live": type === 'foreground' ? 'assertive' : 'polite',
        "aria-atomic": true
    }, announceTextContent), /*#__PURE__*/ (0,react.createElement)($054eb8030ebde76e$var$ToastInteractiveProvider, {
        scope: __scopeToast,
        onClose: handleClose
    }, /*#__PURE__*/ (0,react_dom.createPortal)(/*#__PURE__*/ (0,react.createElement)($054eb8030ebde76e$var$Collection.ItemSlot, {
        scope: __scopeToast
    }, /*#__PURE__*/ (0,react.createElement)(react_dismissable_layer_dist/* Root */.fC, {
        asChild: true,
        onEscapeKeyDown: (0,dist/* composeEventHandlers */.M)(onEscapeKeyDown, ()=>{
            if (!context.isFocusedToastEscapeKeyDownRef.current) handleClose();
            context.isFocusedToastEscapeKeyDownRef.current = false;
        })
    }, /*#__PURE__*/ (0,react.createElement)(react_primitive_dist/* Primitive.li */.WV.li, (0,esm_extends/* default */.Z)({
        // Ensure toasts are announced as status list or status when focused
        role: "status",
        "aria-live": "off",
        "aria-atomic": true,
        tabIndex: 0,
        "data-state": open ? 'open' : 'closed',
        "data-swipe-direction": context.swipeDirection
    }, toastProps, {
        ref: composedRefs,
        style: {
            userSelect: 'none',
            touchAction: 'none',
            ...props.style
        },
        onKeyDown: (0,dist/* composeEventHandlers */.M)(props.onKeyDown, (event)=>{
            if (event.key !== 'Escape') return;
            onEscapeKeyDown === null || onEscapeKeyDown === void 0 || onEscapeKeyDown(event.nativeEvent);
            if (!event.nativeEvent.defaultPrevented) {
                context.isFocusedToastEscapeKeyDownRef.current = true;
                handleClose();
            }
        }),
        onPointerDown: (0,dist/* composeEventHandlers */.M)(props.onPointerDown, (event)=>{
            if (event.button !== 0) return;
            pointerStartRef.current = {
                x: event.clientX,
                y: event.clientY
            };
        }),
        onPointerMove: (0,dist/* composeEventHandlers */.M)(props.onPointerMove, (event)=>{
            if (!pointerStartRef.current) return;
            const x = event.clientX - pointerStartRef.current.x;
            const y = event.clientY - pointerStartRef.current.y;
            const hasSwipeMoveStarted = Boolean(swipeDeltaRef.current);
            const isHorizontalSwipe = [
                'left',
                'right'
            ].includes(context.swipeDirection);
            const clamp = [
                'left',
                'up'
            ].includes(context.swipeDirection) ? Math.min : Math.max;
            const clampedX = isHorizontalSwipe ? clamp(0, x) : 0;
            const clampedY = !isHorizontalSwipe ? clamp(0, y) : 0;
            const moveStartBuffer = event.pointerType === 'touch' ? 10 : 2;
            const delta = {
                x: clampedX,
                y: clampedY
            };
            const eventDetail = {
                originalEvent: event,
                delta: delta
            };
            if (hasSwipeMoveStarted) {
                swipeDeltaRef.current = delta;
                $054eb8030ebde76e$var$handleAndDispatchCustomEvent($054eb8030ebde76e$var$TOAST_SWIPE_MOVE, onSwipeMove, eventDetail, {
                    discrete: false
                });
            } else if ($054eb8030ebde76e$var$isDeltaInDirection(delta, context.swipeDirection, moveStartBuffer)) {
                swipeDeltaRef.current = delta;
                $054eb8030ebde76e$var$handleAndDispatchCustomEvent($054eb8030ebde76e$var$TOAST_SWIPE_START, onSwipeStart, eventDetail, {
                    discrete: false
                });
                event.target.setPointerCapture(event.pointerId);
            } else if (Math.abs(x) > moveStartBuffer || Math.abs(y) > moveStartBuffer) // User is swiping in wrong direction so we disable swipe gesture
            // for the current pointer down interaction
            pointerStartRef.current = null;
        }),
        onPointerUp: (0,dist/* composeEventHandlers */.M)(props.onPointerUp, (event1)=>{
            const delta = swipeDeltaRef.current;
            const target = event1.target;
            if (target.hasPointerCapture(event1.pointerId)) target.releasePointerCapture(event1.pointerId);
            swipeDeltaRef.current = null;
            pointerStartRef.current = null;
            if (delta) {
                const toast = event1.currentTarget;
                const eventDetail = {
                    originalEvent: event1,
                    delta: delta
                };
                if ($054eb8030ebde76e$var$isDeltaInDirection(delta, context.swipeDirection, context.swipeThreshold)) $054eb8030ebde76e$var$handleAndDispatchCustomEvent($054eb8030ebde76e$var$TOAST_SWIPE_END, onSwipeEnd, eventDetail, {
                    discrete: true
                });
                else $054eb8030ebde76e$var$handleAndDispatchCustomEvent($054eb8030ebde76e$var$TOAST_SWIPE_CANCEL, onSwipeCancel, eventDetail, {
                    discrete: true
                });
                 // Prevent click event from triggering on items within the toast when
                // pointer up is part of a swipe gesture
                toast.addEventListener('click', (event)=>event.preventDefault()
                , {
                    once: true
                });
            }
        })
    })))), context.viewport)));
});
$054eb8030ebde76e$var$ToastImpl.propTypes = {
    type (props) {
        if (props.type && ![
            'foreground',
            'background'
        ].includes(props.type)) {
            const error = `Invalid prop \`type\` supplied to \`${$054eb8030ebde76e$var$TOAST_NAME}\`. Expected \`foreground | background\`.`;
            return new Error(error);
        }
        return null;
    }
};
/* -----------------------------------------------------------------------------------------------*/ const $054eb8030ebde76e$var$ToastAnnounce = (props)=>{
    const { __scopeToast: __scopeToast , children: children , ...announceProps } = props;
    const context = $054eb8030ebde76e$var$useToastProviderContext($054eb8030ebde76e$var$TOAST_NAME, __scopeToast);
    const [renderAnnounceText, setRenderAnnounceText] = (0,react.useState)(false);
    const [isAnnounced, setIsAnnounced] = (0,react.useState)(false); // render text content in the next frame to ensure toast is announced in NVDA
    $054eb8030ebde76e$var$useNextFrame(()=>setRenderAnnounceText(true)
    ); // cleanup after announcing
    (0,react.useEffect)(()=>{
        const timer = window.setTimeout(()=>setIsAnnounced(true)
        , 1000);
        return ()=>window.clearTimeout(timer)
        ;
    }, []);
    return isAnnounced ? null : /*#__PURE__*/ (0,react.createElement)(react_portal_dist/* Portal */.h, {
        asChild: true
    }, /*#__PURE__*/ (0,react.createElement)(react_visually_hidden_dist/* VisuallyHidden */.T, announceProps, renderAnnounceText && /*#__PURE__*/ (0,react.createElement)(react.Fragment, null, context.label, " ", children)));
};
/* -------------------------------------------------------------------------------------------------
 * ToastTitle
 * -----------------------------------------------------------------------------------------------*/ const $054eb8030ebde76e$var$TITLE_NAME = 'ToastTitle';
const $054eb8030ebde76e$export$16d42d7c29b95a4 = /*#__PURE__*/ (0,react.forwardRef)((props, forwardedRef)=>{
    const { __scopeToast: __scopeToast , ...titleProps } = props;
    return /*#__PURE__*/ (0,react.createElement)(react_primitive_dist/* Primitive.div */.WV.div, (0,esm_extends/* default */.Z)({}, titleProps, {
        ref: forwardedRef
    }));
});
/*#__PURE__*/ Object.assign($054eb8030ebde76e$export$16d42d7c29b95a4, {
    displayName: $054eb8030ebde76e$var$TITLE_NAME
});
/* -------------------------------------------------------------------------------------------------
 * ToastDescription
 * -----------------------------------------------------------------------------------------------*/ const $054eb8030ebde76e$var$DESCRIPTION_NAME = 'ToastDescription';
const $054eb8030ebde76e$export$ecddd96c53621d9a = /*#__PURE__*/ (0,react.forwardRef)((props, forwardedRef)=>{
    const { __scopeToast: __scopeToast , ...descriptionProps } = props;
    return /*#__PURE__*/ (0,react.createElement)(react_primitive_dist/* Primitive.div */.WV.div, (0,esm_extends/* default */.Z)({}, descriptionProps, {
        ref: forwardedRef
    }));
});
/*#__PURE__*/ Object.assign($054eb8030ebde76e$export$ecddd96c53621d9a, {
    displayName: $054eb8030ebde76e$var$DESCRIPTION_NAME
});
/* -------------------------------------------------------------------------------------------------
 * ToastAction
 * -----------------------------------------------------------------------------------------------*/ const $054eb8030ebde76e$var$ACTION_NAME = 'ToastAction';
const $054eb8030ebde76e$export$3019feecfda683d2 = /*#__PURE__*/ (0,react.forwardRef)((props, forwardedRef)=>{
    const { altText: altText , ...actionProps } = props;
    if (!altText) return null;
    return /*#__PURE__*/ (0,react.createElement)($054eb8030ebde76e$var$ToastAnnounceExclude, {
        altText: altText,
        asChild: true
    }, /*#__PURE__*/ (0,react.createElement)($054eb8030ebde76e$export$811e70f61c205839, (0,esm_extends/* default */.Z)({}, actionProps, {
        ref: forwardedRef
    })));
});
$054eb8030ebde76e$export$3019feecfda683d2.propTypes = {
    altText (props) {
        if (!props.altText) return new Error(`Missing prop \`altText\` expected on \`${$054eb8030ebde76e$var$ACTION_NAME}\``);
        return null;
    }
};
/*#__PURE__*/ Object.assign($054eb8030ebde76e$export$3019feecfda683d2, {
    displayName: $054eb8030ebde76e$var$ACTION_NAME
});
/* -------------------------------------------------------------------------------------------------
 * ToastClose
 * -----------------------------------------------------------------------------------------------*/ const $054eb8030ebde76e$var$CLOSE_NAME = 'ToastClose';
const $054eb8030ebde76e$export$811e70f61c205839 = /*#__PURE__*/ (0,react.forwardRef)((props, forwardedRef)=>{
    const { __scopeToast: __scopeToast , ...closeProps } = props;
    const interactiveContext = $054eb8030ebde76e$var$useToastInteractiveContext($054eb8030ebde76e$var$CLOSE_NAME, __scopeToast);
    return /*#__PURE__*/ (0,react.createElement)($054eb8030ebde76e$var$ToastAnnounceExclude, {
        asChild: true
    }, /*#__PURE__*/ (0,react.createElement)(react_primitive_dist/* Primitive.button */.WV.button, (0,esm_extends/* default */.Z)({
        type: "button"
    }, closeProps, {
        ref: forwardedRef,
        onClick: (0,dist/* composeEventHandlers */.M)(props.onClick, interactiveContext.onClose)
    })));
});
/*#__PURE__*/ Object.assign($054eb8030ebde76e$export$811e70f61c205839, {
    displayName: $054eb8030ebde76e$var$CLOSE_NAME
});
/* ---------------------------------------------------------------------------------------------- */ const $054eb8030ebde76e$var$ToastAnnounceExclude = /*#__PURE__*/ (0,react.forwardRef)((props, forwardedRef)=>{
    const { __scopeToast: __scopeToast , altText: altText , ...announceExcludeProps } = props;
    return /*#__PURE__*/ (0,react.createElement)(react_primitive_dist/* Primitive.div */.WV.div, (0,esm_extends/* default */.Z)({
        "data-radix-toast-announce-exclude": "",
        "data-radix-toast-announce-alt": altText || undefined
    }, announceExcludeProps, {
        ref: forwardedRef
    }));
});
function $054eb8030ebde76e$var$getAnnounceTextContent(container) {
    const textContent = [];
    const childNodes = Array.from(container.childNodes);
    childNodes.forEach((node)=>{
        if (node.nodeType === node.TEXT_NODE && node.textContent) textContent.push(node.textContent);
        if ($054eb8030ebde76e$var$isHTMLElement(node)) {
            const isHidden = node.ariaHidden || node.hidden || node.style.display === 'none';
            const isExcluded = node.dataset.radixToastAnnounceExclude === '';
            if (!isHidden) {
                if (isExcluded) {
                    const altText = node.dataset.radixToastAnnounceAlt;
                    if (altText) textContent.push(altText);
                } else textContent.push(...$054eb8030ebde76e$var$getAnnounceTextContent(node));
            }
        }
    }); // We return a collection of text rather than a single concatenated string.
    // This allows SR VO to naturally pause break between nodes while announcing.
    return textContent;
}
/* ---------------------------------------------------------------------------------------------- */ function $054eb8030ebde76e$var$handleAndDispatchCustomEvent(name, handler, detail, { discrete: discrete  }) {
    const currentTarget = detail.originalEvent.currentTarget;
    const event = new CustomEvent(name, {
        bubbles: true,
        cancelable: true,
        detail: detail
    });
    if (handler) currentTarget.addEventListener(name, handler, {
        once: true
    });
    if (discrete) (0,react_primitive_dist/* dispatchDiscreteCustomEvent */.jH)(currentTarget, event);
    else currentTarget.dispatchEvent(event);
}
const $054eb8030ebde76e$var$isDeltaInDirection = (delta, direction, threshold = 0)=>{
    const deltaX = Math.abs(delta.x);
    const deltaY = Math.abs(delta.y);
    const isDeltaX = deltaX > deltaY;
    if (direction === 'left' || direction === 'right') return isDeltaX && deltaX > threshold;
    else return !isDeltaX && deltaY > threshold;
};
function $054eb8030ebde76e$var$useNextFrame(callback = ()=>{}) {
    const fn = (0,react_use_callback_ref_dist/* useCallbackRef */.W)(callback);
    (0,react_use_layout_effect_dist/* useLayoutEffect */.b)(()=>{
        let raf1 = 0;
        let raf2 = 0;
        raf1 = window.requestAnimationFrame(()=>raf2 = window.requestAnimationFrame(fn)
        );
        return ()=>{
            window.cancelAnimationFrame(raf1);
            window.cancelAnimationFrame(raf2);
        };
    }, [
        fn
    ]);
}
function $054eb8030ebde76e$var$isHTMLElement(node) {
    return node.nodeType === node.ELEMENT_NODE;
}
/**
 * Returns a list of potential tabbable candidates.
 *
 * NOTE: This is only a close approximation. For example it doesn't take into account cases like when
 * elements are not visible. This cannot be worked out easily by just reading a property, but rather
 * necessitate runtime knowledge (computed styles, etc). We deal with these cases separately.
 *
 * See: https://developer.mozilla.org/en-US/docs/Web/API/TreeWalker
 * Credit: https://github.com/discord/focus-layers/blob/master/src/util/wrapFocus.tsx#L1
 */ function $054eb8030ebde76e$var$getTabbableCandidates(container) {
    const nodes = [];
    const walker = document.createTreeWalker(container, NodeFilter.SHOW_ELEMENT, {
        acceptNode: (node)=>{
            const isHiddenInput = node.tagName === 'INPUT' && node.type === 'hidden';
            if (node.disabled || node.hidden || isHiddenInput) return NodeFilter.FILTER_SKIP; // `.tabIndex` is not the same as the `tabindex` attribute. It works on the
            // runtime's understanding of tabbability, so this automatically accounts
            // for any kind of element that could be tabbed to.
            return node.tabIndex >= 0 ? NodeFilter.FILTER_ACCEPT : NodeFilter.FILTER_SKIP;
        }
    });
    while(walker.nextNode())nodes.push(walker.currentNode); // we do not take into account the order of nodes with positive `tabIndex` as it
    // hinders accessibility to have tab order different from visual order.
    return nodes;
}
function $054eb8030ebde76e$var$focusFirst(candidates) {
    const previouslyFocusedElement = document.activeElement;
    return candidates.some((candidate)=>{
        // if focus is already where we want to go, we don't want to keep going through the candidates
        if (candidate === previouslyFocusedElement) return true;
        candidate.focus();
        return document.activeElement !== previouslyFocusedElement;
    });
}
const $054eb8030ebde76e$export$2881499e37b75b9a = $054eb8030ebde76e$export$f5d03d415824e0e;
const $054eb8030ebde76e$export$d5c6c08dc2d3ca7 = $054eb8030ebde76e$export$6192c2425ecfd989;
const $054eb8030ebde76e$export$be92b6f5f03c0fe9 = $054eb8030ebde76e$export$8d8dc7d5f743331b;
const $054eb8030ebde76e$export$f99233281efd08a0 = $054eb8030ebde76e$export$16d42d7c29b95a4;
const $054eb8030ebde76e$export$393edc798c47379d = $054eb8030ebde76e$export$ecddd96c53621d9a;
const $054eb8030ebde76e$export$e19cd5f9376f8cee = $054eb8030ebde76e$export$3019feecfda683d2;
const $054eb8030ebde76e$export$f39c2d165cd861fe = $054eb8030ebde76e$export$811e70f61c205839;





//# sourceMappingURL=index.mjs.map

// EXTERNAL MODULE: ./node_modules/class-variance-authority/dist/index.mjs
var class_variance_authority_dist = __webpack_require__(12003);
// EXTERNAL MODULE: ./app/lib/utils.ts + 1 modules
var utils = __webpack_require__(73848);
;// CONCATENATED MODULE: ./app/components/ui/toast.tsx





const ToastProvider = $054eb8030ebde76e$export$2881499e37b75b9a;
const ToastViewport = /*#__PURE__*/ react.forwardRef((param, ref)=>/*#__PURE__*/ {
    let { className , ...props } = param;
    return (0,jsx_runtime.jsx)($054eb8030ebde76e$export$d5c6c08dc2d3ca7, {
        ref: ref,
        className: (0,utils.cn)("fixed top-0 z-[100] flex max-h-screen w-fit flex-col-reverse p-4 sm:top-[80px] sm:right-[2%] sm:flex-col md:max-w-[420px]", className),
        ...props
    });
});
ToastViewport.displayName = $054eb8030ebde76e$export$d5c6c08dc2d3ca7.displayName;
const toastVariants = (0,class_variance_authority_dist/* cva */.j)("group pointer-events-auto relative flex w-fit items-center justify-between space-x-4 overflow-hidden rounded-2xl py-4 px-5 shadow-lg transition-all data-[swipe=cancel]:translate-x-0 data-[swipe=end]:translate-x-[var(--radix-toast-swipe-end-x)] data-[swipe=move]:translate-x-[var(--radix-toast-swipe-move-x)] data-[swipe=move]:transition-none data-[state=open]:animate-in data-[state=closed]:animate-out data-[swipe=end]:animate-out data-[state=closed]:fade-out-80 data-[state=closed]:slide-out-to-right-full data-[state=open]:slide-in-from-top-full data-[state=open]:sm:slide-in-from-bottom-full", {
    variants: {
        variant: {
            error: "group bg-bg-red text-main-red-02 text-sm Nunito-600",
            success: "group bg-bg-green text-main-green text-sm Nunito-600"
        }
    },
    defaultVariants: {
        variant: "success"
    }
});
const Toast = /*#__PURE__*/ react.forwardRef((param, ref)=>{
    let { className , variant , ...props } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)($054eb8030ebde76e$export$be92b6f5f03c0fe9, {
        ref: ref,
        className: (0,utils.cn)(toastVariants({
            variant
        }), className),
        ...props
    });
});
Toast.displayName = $054eb8030ebde76e$export$be92b6f5f03c0fe9.displayName;
const ToastAction = /*#__PURE__*/ react.forwardRef((param, ref)=>/*#__PURE__*/ {
    let { className , ...props } = param;
    return (0,jsx_runtime.jsx)($054eb8030ebde76e$export$e19cd5f9376f8cee, {
        ref: ref,
        className: (0,utils.cn)("inline-flex h-8 shrink-0 items-center justify-center rounded-md border bg-transparent px-3 text-sm font-medium ring-offset-background transition-colors hover:bg-secondary focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2 disabled:pointer-events-none disabled:opacity-50 group-[.destructive]:border-muted/40 group-[.destructive]:hover:border-destructive/30 group-[.destructive]:hover:bg-destructive group-[.destructive]:hover:text-destructive-foreground group-[.destructive]:focus:ring-destructive", className),
        ...props
    });
});
ToastAction.displayName = $054eb8030ebde76e$export$e19cd5f9376f8cee.displayName;
/** Hiding close toast */ const ToastClose = /*#__PURE__*/ react.forwardRef((param, ref)=>/*#__PURE__*/ {
    let { className , ...props } = param;
    return (0,jsx_runtime.jsx)($054eb8030ebde76e$export$f39c2d165cd861fe, {
        ref: ref,
        className: (0,utils.cn)("absolute right-2 top-2 rounded-md p-1 text-foreground/50 opacity-0 transition-opacity hover:text-foreground focus:opacity-100 focus:outline-none focus:ring-2 group-hover:opacity-100 group-[.destructive]:text-red-300 group-[.destructive]:hover:text-red-50 group-[.destructive]:focus:ring-red-400 group-[.destructive]:focus:ring-offset-red-600", className),
        "toast-close": "",
        ...props
    });
});
ToastClose.displayName = $054eb8030ebde76e$export$f39c2d165cd861fe.displayName;
const ToastTitle = /*#__PURE__*/ react.forwardRef((param, ref)=>/*#__PURE__*/ {
    let { className , ...props } = param;
    return (0,jsx_runtime.jsx)($054eb8030ebde76e$export$f99233281efd08a0, {
        ref: ref,
        className: (0,utils.cn)("text-sm font-semibold", className),
        ...props
    });
});
ToastTitle.displayName = $054eb8030ebde76e$export$f99233281efd08a0.displayName;
const ToastDescription = /*#__PURE__*/ react.forwardRef((param, ref)=>/*#__PURE__*/ {
    let { className , ...props } = param;
    return (0,jsx_runtime.jsx)($054eb8030ebde76e$export$393edc798c47379d, {
        ref: ref,
        className: (0,utils.cn)("text-sm opacity-90", className),
        ...props
    });
});
ToastDescription.displayName = $054eb8030ebde76e$export$393edc798c47379d.displayName;


// EXTERNAL MODULE: ./app/components/ui/use-toast.ts
var use_toast = __webpack_require__(2786);
// EXTERNAL MODULE: ./app/components/icon-tsx/index.ts + 11 modules
var icon_tsx = __webpack_require__(61552);
;// CONCATENATED MODULE: ./app/components/icon-tsx/IconToastSuccess.tsx


const IconToastSuccess = ()=>{
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        width: "21",
        height: "21",
        viewBox: "0 0 21 21",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                opacity: "0.4",
                d: "M0 16.5V4.5C0 2.29086 1.79086 0.5 4 0.5H16C18.2091 0.5 20 2.29086 20 4.5V16.5C20 18.7091 18.2091 20.5 16 20.5H4C1.79086 20.5 0 18.7091 0 16.5Z",
                fill: "#00A451"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M20.5018 0.942536C20.8096 1.21963 20.8346 1.69385 20.5575 2.00173L11.8199 11.5991C10.8454 12.6819 9.19549 12.8168 8.05793 11.9068L4.53151 9.08566C4.20806 8.8269 4.15562 8.35493 4.41438 8.03149C4.67313 7.70804 5.1451 7.6556 5.46855 7.91436L8.99497 10.7355C9.51204 11.1492 10.262 11.0878 10.705 10.5956L19.4426 0.998283C19.7197 0.6904 20.1939 0.665442 20.5018 0.942536Z",
                fill: "#00A451"
            })
        ]
    });
};

;// CONCATENATED MODULE: ./app/components/ui/toaster.tsx





const TIME_DURATION = 1000;
function ToasterContainer() {
    const { toasts  } = (0,use_toast/* useToast */.pm)();
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(ToastProvider, {
        duration: TIME_DURATION,
        children: [
            toasts.map(function(param) {
                let { id , title , description , action , ...props } = param;
                return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Toast, {
                    ...props,
                    type: "background",
                    children: [
                        !!(props === null || props === void 0 ? void 0 : props.variant) && (props === null || props === void 0 ? void 0 : props.variant) === "error" ? /*#__PURE__*/ (0,jsx_runtime.jsx)(icon_tsx/* IconToastError */.z2, {}) : (props === null || props === void 0 ? void 0 : props.variant) === "success" ? /*#__PURE__*/ (0,jsx_runtime.jsx)(IconToastSuccess, {}) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {}),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "grid gap-1",
                            children: title && /*#__PURE__*/ (0,jsx_runtime.jsx)(ToastTitle, {
                                children: title
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(ToastClose, {})
                    ]
                }, id);
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ToastViewport, {})
        ]
    });
}

// EXTERNAL MODULE: ./app/containers/index.ts + 83 modules
var containers = __webpack_require__(16314);
// EXTERNAL MODULE: ./node_modules/next-i18next/dist/esm/index.js + 41 modules
var esm = __webpack_require__(93378);
// EXTERNAL MODULE: ./app/components/ui/dialog.tsx
var dialog = __webpack_require__(76500);
// EXTERNAL MODULE: ./app/components/ui/button.tsx
var ui_button = __webpack_require__(34428);
;// CONCATENATED MODULE: ./app/components/layout/CommingSoonModal.tsx







const CommingSoonModal = ()=>{
    const { t  } = (0,esm/* useTranslation */.$G)();
    const { openModal , setOpenModal  } = (0,react.useContext)(context/* AppContext */.Il);
    const handleClose = ()=>{
        setOpenModal(null);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(dialog/* Dialog */.Vq, {
        open: openModal === configs/* OPEN_MODAL.COMMINGSOON_MODAL */.a6.COMMINGSOON_MODAL,
        onOpenChange: handleClose,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dialog/* DialogContent */.cZ, {
            className: "sm:rounded-[24px] md:max-w-[320px] p-[24px] border-0 focus-visible:outline-none w-fit rounded-[24px] min-w-[300px]",
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "flex flex-col w-full mt-[20px]",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        className: "text-base text-center align-middle Nunito-700 text-bg-01 dark:text-white",
                        children: t("common.coming_soon_title")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "flex items-center justify-center w-full mt-[32px] gap-[16px]",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ui_button/* Button */.z, {
                            variant: "none",
                            className: "text-sm text-white bg-main-01 Nunito-700",
                            onClick: handleClose,
                            children: t("reward.confirm")
                        })
                    })
                ]
            })
        })
    });
};

// EXTERNAL MODULE: ./app/components/data-empty/index.tsx + 1 modules
var data_empty = __webpack_require__(98269);
// EXTERNAL MODULE: ./app/helpers/function.ts + 23 modules
var helpers_function = __webpack_require__(4203);
// EXTERNAL MODULE: ./app/services/query-fn/game/index.ts + 1 modules
var game = __webpack_require__(82190);
// EXTERNAL MODULE: ./app/services/query-fn/user/setting-mutation.ts
var setting_mutation = __webpack_require__(88663);
// EXTERNAL MODULE: ./node_modules/@radix-ui/react-scroll-area/dist/index.mjs
var react_scroll_area_dist = __webpack_require__(25443);
// EXTERNAL MODULE: ./node_modules/@tanstack/react-query/build/modern/QueryClientProvider.js
var QueryClientProvider = __webpack_require__(30202);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(25675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ./node_modules/@react-spring/web/dist/react-spring_web.modern.mjs + 3 modules
var react_spring_web_modern = __webpack_require__(66005);
;// CONCATENATED MODULE: ./app/containers/users/common/modal/ModalEditHashtag.tsx



















const LIMIT_HASHTAG = 5;
const ModalEditHashtag = ()=>{
    var _userInfo_topic_interest, _userInfo_games_interest, _userInfo_topic_interest1, _userInfo_games_interest1, _userInfo_topic_interest2, _userInfo_games_interest2;
    const { t  } = (0,esm/* useTranslation */.$G)();
    const { userInfo , themeApp , openModal , setOpenModal  } = (0,react.useContext)(context/* AppContext */.Il);
    const { isMobile  } = (0,react.useContext)(context/* MobileContext */.zw);
    const [searchValue, setSearchValue] = (0,react.useState)("");
    const queryClient = (0,QueryClientProvider/* useQueryClient */.NL)();
    const { data: otherHashtag  } = (0,query_fn/* useQueryGetHotTopic */.i9)();
    const { data: games  } = (0,game/* useQueryGetListGame */.Bu)({
        category: "",
        type: "",
        limit: 100,
        page: 1
    });
    const { mutate  } = (0,setting_mutation/* useMutationUpdateInterestTopic */.bh)();
    const addHashtagList = (withType, value)=>{
        const listTopicHashtag = withType === "hashtag" ? Array.from(new Set([
            ...userInfo === null || userInfo === void 0 ? void 0 : userInfo.topic_interest,
            value
        ])) : userInfo === null || userInfo === void 0 ? void 0 : userInfo.topic_interest;
        const listTopicGameId = withType === "game" ? Array.from(new Set([
            ...userInfo === null || userInfo === void 0 ? void 0 : userInfo.games_interest,
            value
        ])) : userInfo === null || userInfo === void 0 ? void 0 : userInfo.games_interest;
        return [
            listTopicHashtag,
            listTopicGameId
        ];
    };
    const removeHashtagList = (withType, value)=>{
        var _userInfo_topic_interest, _userInfo_games_interest;
        const listTopicHashtag = withType === "hashtag" ? userInfo === null || userInfo === void 0 ? void 0 : (_userInfo_topic_interest = userInfo.topic_interest) === null || _userInfo_topic_interest === void 0 ? void 0 : _userInfo_topic_interest.filter((item)=>item !== value) : userInfo === null || userInfo === void 0 ? void 0 : userInfo.topic_interest;
        const listTopicGameId = withType === "game" ? userInfo === null || userInfo === void 0 ? void 0 : (_userInfo_games_interest = userInfo.games_interest) === null || _userInfo_games_interest === void 0 ? void 0 : _userInfo_games_interest.filter((item)=>item !== value) : userInfo === null || userInfo === void 0 ? void 0 : userInfo.games_interest;
        return [
            listTopicHashtag,
            listTopicGameId
        ];
    };
    const handleClose = ()=>{
        var _userInfo_topic_interest, _userInfo_games_interest;
        if ((userInfo === null || userInfo === void 0 ? void 0 : (_userInfo_topic_interest = userInfo.topic_interest) === null || _userInfo_topic_interest === void 0 ? void 0 : _userInfo_topic_interest.length) + (userInfo === null || userInfo === void 0 ? void 0 : (_userInfo_games_interest = userInfo.games_interest) === null || _userInfo_games_interest === void 0 ? void 0 : _userInfo_games_interest.length) > 0) {
            setOpenModal(null);
        } else (0,use_toast/* toast */.Am)({
            variant: "error",
            title: t("news.require_favorite_hashtag")
        });
    };
    const updateMyTag = (withType, hashtag, type)=>{
        var _hash_, _hash_1;
        //  Lấy list hashtag sau khi thêm hoặc xóa theo withtype
        const hash = type === "add" ? addHashtagList(withType, hashtag) : removeHashtagList(withType, hashtag);
        // bắt buộc chọn ít nhất 1 sở thích
        if (((_hash_ = hash[0]) === null || _hash_ === void 0 ? void 0 : _hash_.length) + ((_hash_1 = hash[1]) === null || _hash_1 === void 0 ? void 0 : _hash_1.length) === 0) (0,use_toast/* toast */.Am)({
            variant: "error",
            title: t("news.require_favorite_hashtag")
        });
        else {
            var _userInfo_topic_interest, _userInfo_games_interest;
            if ((userInfo === null || userInfo === void 0 ? void 0 : (_userInfo_topic_interest = userInfo.topic_interest) === null || _userInfo_topic_interest === void 0 ? void 0 : _userInfo_topic_interest.length) + (userInfo === null || userInfo === void 0 ? void 0 : (_userInfo_games_interest = userInfo.games_interest) === null || _userInfo_games_interest === void 0 ? void 0 : _userInfo_games_interest.length) === LIMIT_HASHTAG && type === "add") {
                (0,use_toast/* toast */.Am)({
                    variant: "error",
                    title: t("news.limit_favorite_hashtag")
                });
            } else {
                mutate((0,utils/* removeNullKeyObject */.t2)({
                    topic_interest: hash[0].toString().replace(" ", ""),
                    games_interest: hash[1].toString().replace(" ", "")
                }), {
                    onSuccess (data, variables, context) {
                        queryClient.invalidateQueries({
                            queryKey: [
                                configs/* QUERY_KEY.PROFILE_INFO */.lP.PROFILE_INFO
                            ],
                            refetchType: "active"
                        });
                    },
                    onError (error, variables, context) {
                        var _error_response, _error_response_data, _error_data;
                        (0,use_toast/* toast */.Am)({
                            variant: "error",
                            title: (error === null || error === void 0 ? void 0 : (_error_response = error.response) === null || _error_response === void 0 ? void 0 : (_error_response_data = _error_response.data) === null || _error_response_data === void 0 ? void 0 : _error_response_data.message) || (error === null || error === void 0 ? void 0 : (_error_data = error.data) === null || _error_data === void 0 ? void 0 : _error_data.message)
                        });
                    }
                });
            }
        }
    };
    const onChange = (e)=>{
        var _e_target;
        setSearchValue(e === null || e === void 0 ? void 0 : (_e_target = e.target) === null || _e_target === void 0 ? void 0 : _e_target.value);
    };
    const memoGames = (0,react.useMemo)(()=>{
        if (!!(searchValue === null || searchValue === void 0 ? void 0 : searchValue.trim())) {
            return games ? games.filter((item)=>{
                var _removeVietnameseTones, _item_game_name;
                return (_removeVietnameseTones = (0,helpers_function/* removeVietnameseTones */.CQ)(item === null || item === void 0 ? void 0 : (_item_game_name = item.game_name) === null || _item_game_name === void 0 ? void 0 : _item_game_name.toLowerCase())) === null || _removeVietnameseTones === void 0 ? void 0 : _removeVietnameseTones.includes((0,helpers_function/* removeVietnameseTones */.CQ)(searchValue === null || searchValue === void 0 ? void 0 : searchValue.toLowerCase()));
            }) : [];
        }
        return games;
    }, [
        userInfo,
        searchValue,
        games
    ]);
    const memoHashtags = (0,react.useMemo)(()=>{
        if (!!(searchValue === null || searchValue === void 0 ? void 0 : searchValue.trim())) {
            return otherHashtag.filter((item)=>{
                var _item_hashtag_replaceAll, _item_hashtag;
                return (_item_hashtag_replaceAll = item === null || item === void 0 ? void 0 : (_item_hashtag = item.hashtag) === null || _item_hashtag === void 0 ? void 0 : _item_hashtag.replaceAll("#", "")) === null || _item_hashtag_replaceAll === void 0 ? void 0 : _item_hashtag_replaceAll.includes(searchValue);
            });
        }
        return otherHashtag;
    }, [
        userInfo,
        searchValue,
        otherHashtag
    ]);
    const onAddItem = (withType, hashtag)=>{
        var _userInfo_topic_interest, _userInfo_games_interest;
        if ((userInfo === null || userInfo === void 0 ? void 0 : (_userInfo_topic_interest = userInfo.topic_interest) === null || _userInfo_topic_interest === void 0 ? void 0 : _userInfo_topic_interest.indexOf(hashtag)) !== -1 || (userInfo === null || userInfo === void 0 ? void 0 : (_userInfo_games_interest = userInfo.games_interest) === null || _userInfo_games_interest === void 0 ? void 0 : _userInfo_games_interest.indexOf(hashtag)) !== -1) {
            updateMyTag(withType, hashtag, "remove");
        } else updateMyTag(withType, hashtag, "add");
    };
    var _item_icon, _item_game_name;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(dialog/* Dialog */.Vq, {
        open: openModal === configs/* OPEN_MODAL.EDIT_HASHTAG */.a6.EDIT_HASHTAG,
        onOpenChange: handleClose,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(dialog/* DialogContent */.cZ, {
            className: "sm:rounded-[16px] rounded-[16px] w-[90vw] md:w-[700px] p-[12px] md:p-[24px] dark:bg-bg-02 max-w-[90vw] md:max-w-[700px] overflow-auto max-h-[95vh] dark:border-0 gap-4 md:gap-6",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(dialog/* DialogHeader */.fK, {
                    className: "flex flex-row items-center justify-between w-full",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        className: "Nunito-700 text-[16px] text-bg-01 dark:text-main-white",
                        children: t("profile.edit_hashtag")
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "w-full space-y-[8px] md:space-y-[12px]",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "flex items-center justify-between border-b-[1px] dark:border-0 gap-4 py-3 md:max-w-[700px]",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(icon_tsx/* IconSearch */.jV, {
                                    fill: themeApp === "dark" ? "#fff" : "#100D28",
                                    className: "w-[16px] h-[16px]"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                    type: "text",
                                    value: searchValue,
                                    className: "w-full text-sm border-0 outline-none dark:bg-transparent",
                                    placeholder: t("profile.find_hashtag"),
                                    onChange: onChange
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(SelectedHashtag, {
                            games: games !== null && games !== void 0 ? games : [],
                            updateMyTag: updateMyTag
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "w-full space-y-[8px]",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                            className: "text-base text-black Nunito-700 dark:text-main-white",
                            children: "Game"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "w-full",
                            children: (memoGames === null || memoGames === void 0 ? void 0 : memoGames.length) ? /*#__PURE__*/ (0,jsx_runtime.jsx)(react_scroll_area_dist/* ScrollArea */.xr, {
                                className: "max-h-[80px] md:max-h-[112px] overflow-auto flex items-center flex-wrap gap-2 md:gap-[12px]",
                                children: memoGames === null || memoGames === void 0 ? void 0 : memoGames.map((item)=>{
                                    var _userInfo_games_interest;
                                    /*#__PURE__*/ return (0,jsx_runtime.jsxs)(ui_button/* Button */.z, {
                                        className: "flex items-center justify-center p-2 text-base w-fit h-[36px] md:h-[48px] text-bg-01 Nunito-700 gap-[8px] text-start border dark:text-main-white ".concat((userInfo === null || userInfo === void 0 ? void 0 : (_userInfo_games_interest = userInfo.games_interest) === null || _userInfo_games_interest === void 0 ? void 0 : _userInfo_games_interest.indexOf(item === null || item === void 0 ? void 0 : item.id)) === -1 ? "border-black/10 dark:border-neutral-05" : "border-main-01", " rounded-[12px]"),
                                        variant: "none",
                                        onClick: ()=>{
                                            return onAddItem("game", item === null || item === void 0 ? void 0 : item.id);
                                        },
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                                src: (_item_icon = item === null || item === void 0 ? void 0 : item.icon) !== null && _item_icon !== void 0 ? _item_icon : "",
                                                width: isMobile ? 24 : 32,
                                                height: isMobile ? 24 : 32,
                                                alt: (_item_game_name = item === null || item === void 0 ? void 0 : item.game_name) !== null && _item_game_name !== void 0 ? _item_game_name : "",
                                                className: "rounded-[8px]"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                className: "text-xs md:text-sm Nunito-600 text-bg-01 dark:text-main-white",
                                                children: item === null || item === void 0 ? void 0 : item.game_name
                                            })
                                        ]
                                    }, item === null || item === void 0 ? void 0 : item.id);
                                })
                            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "w-full flex items-center justify-center h-[200px]",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(data_empty/* DataEmpty */.$, {
                                    title: t("profile.no_data")
                                })
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "w-full space-y-[8px]",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                            className: "text-base text-black Nunito-700 dark:text-main-white",
                            children: t("profile.interest")
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "w-full",
                            children: (memoHashtags === null || memoHashtags === void 0 ? void 0 : memoHashtags.length) ? /*#__PURE__*/ (0,jsx_runtime.jsx)(react_scroll_area_dist/* ScrollArea */.xr, {
                                className: "max-h-[80px] md:max-h-[112px] overflow-auto flex items-center flex-wrap gap-2 md:gap-[12px]",
                                children: memoHashtags === null || memoHashtags === void 0 ? void 0 : memoHashtags.map((item)=>{
                                    var _userInfo_topic_interest, _item_hashtag;
                                    /*#__PURE__*/ return (0,jsx_runtime.jsxs)(ui_button/* Button */.z, {
                                        className: "flex items-center justify-center px-4 py-2 text-xs md:text-base w-fit h-[36px] md:h-[48px] text-bg-01 Nunito-600 text-start border dark:text-main-white ".concat((userInfo === null || userInfo === void 0 ? void 0 : (_userInfo_topic_interest = userInfo.topic_interest) === null || _userInfo_topic_interest === void 0 ? void 0 : _userInfo_topic_interest.indexOf(item === null || item === void 0 ? void 0 : item.hashtag)) === -1 ? "border-black/10 dark:border-neutral-05" : "border-main-01", "  rounded-[12px]"),
                                        variant: "none",
                                        onClick: ()=>{
                                            return onAddItem("hashtag", item === null || item === void 0 ? void 0 : item.hashtag);
                                        },
                                        children: [
                                            "#",
                                            item === null || item === void 0 ? void 0 : (_item_hashtag = item.hashtag) === null || _item_hashtag === void 0 ? void 0 : _item_hashtag.replaceAll("#", "")
                                        ]
                                    }, item === null || item === void 0 ? void 0 : item.hashtag);
                                })
                            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "w-full flex items-center justify-center h-[200px]",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(data_empty/* DataEmpty */.$, {
                                    title: t("profile.no_data")
                                })
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(ui_button/* Button */.z, {
                    variant: "main",
                    disabled: (userInfo === null || userInfo === void 0 ? void 0 : (_userInfo_topic_interest = userInfo.topic_interest) === null || _userInfo_topic_interest === void 0 ? void 0 : _userInfo_topic_interest.length) + (userInfo === null || userInfo === void 0 ? void 0 : (_userInfo_games_interest = userInfo.games_interest) === null || _userInfo_games_interest === void 0 ? void 0 : _userInfo_games_interest.length) === 0,
                    onClick: handleClose,
                    className: "mx-auto text-sm md:text-base w-fit Nunito-700 rounded-[16px] h-[35px] md:h-[46px] px-[16px] md:px-[24px]",
                    children: LIMIT_HASHTAG - (userInfo === null || userInfo === void 0 ? void 0 : (_userInfo_topic_interest1 = userInfo.topic_interest) === null || _userInfo_topic_interest1 === void 0 ? void 0 : _userInfo_topic_interest1.length) - (userInfo === null || userInfo === void 0 ? void 0 : (_userInfo_games_interest1 = userInfo.games_interest) === null || _userInfo_games_interest1 === void 0 ? void 0 : _userInfo_games_interest1.length) === 0 ? /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                        children: t("common.update_btn")
                    }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                        children: [
                            t("common.select_more"),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                children: [
                                    "\xa0(",
                                    LIMIT_HASHTAG - (userInfo === null || userInfo === void 0 ? void 0 : (_userInfo_topic_interest2 = userInfo.topic_interest) === null || _userInfo_topic_interest2 === void 0 ? void 0 : _userInfo_topic_interest2.length) - (userInfo === null || userInfo === void 0 ? void 0 : (_userInfo_games_interest2 = userInfo.games_interest) === null || _userInfo_games_interest2 === void 0 ? void 0 : _userInfo_games_interest2.length),
                                    ")"
                                ]
                            })
                        ]
                    })
                })
            ]
        })
    });
};
const SelectedHashtag = (param)=>{
    let { games , updateMyTag  } = param;
    var _userInfo_topic_interest, _userInfo_games_interest, _userInfo_topic_interest1, _userInfo_games_interest1;
    const { userInfo  } = (0,react.useContext)(context/* AppContext */.Il);
    const { isMobile  } = (0,react.useContext)(context/* MobileContext */.zw);
    const fade = (0,react_spring_web_modern/* useSpring */.q_)({
        opacity: 1,
        from: {
            opacity: 0
        },
        delay: 50
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: (!!(userInfo === null || userInfo === void 0 ? void 0 : (_userInfo_topic_interest = userInfo.topic_interest) === null || _userInfo_topic_interest === void 0 ? void 0 : _userInfo_topic_interest.length) || !!(userInfo === null || userInfo === void 0 ? void 0 : (_userInfo_games_interest = userInfo.games_interest) === null || _userInfo_games_interest === void 0 ? void 0 : _userInfo_games_interest.length)) && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "flex flex-wrap items-center w-full max-w-full gap-2 md:gap-[12px]",
            children: [
                react.Children.toArray(userInfo === null || userInfo === void 0 ? void 0 : (_userInfo_topic_interest1 = userInfo.topic_interest) === null || _userInfo_topic_interest1 === void 0 ? void 0 : _userInfo_topic_interest1.map((item)=>{
                    /*#__PURE__*/ return (0,jsx_runtime.jsxs)(react_spring_web_modern/* animated.div */.q.div, {
                        style: fade,
                        className: "bg-transparent text-main-01 Nunito-700 border border-main-01 text-xs md:text-sm px-3 py-[12px] flex flex-row items-center gap-[8px] h-[36px] md:h-[48px] rounded-[8px] md:rounded-[12px] max-w-full md:max-w-[33%]",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                className: "line-clamp-1",
                                children: [
                                    "#",
                                    item === null || item === void 0 ? void 0 : item.replaceAll("#", "")
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "cursor-pointer w-[16px] h-[16px]",
                                onClick: ()=>updateMyTag("hashtag", item, "remove"),
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
                                    width: "16",
                                    height: "16",
                                    viewBox: "0 0 16 16",
                                    fill: "none",
                                    xmlns: "http://www.w3.org/2000/svg",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                        d: "M10.8287 5.1716L5.17188 10.8285M10.8287 10.8284L5.17188 5.17157",
                                        stroke: "#DAD9FE",
                                        strokeWidth: "1.5",
                                        strokeLinecap: "round",
                                        strokeLinejoin: "round"
                                    })
                                })
                            })
                        ]
                    });
                })),
                react.Children.toArray(userInfo === null || userInfo === void 0 ? void 0 : (_userInfo_games_interest1 = userInfo.games_interest) === null || _userInfo_games_interest1 === void 0 ? void 0 : _userInfo_games_interest1.map((id)=>{
                    const exactGame = games === null || games === void 0 ? void 0 : games.find((game)=>game.id === id);
                    if (!!exactGame) {
                        var _exactGame_icon;
                        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(react_spring_web_modern/* animated.div */.q.div, {
                            style: fade,
                            className: "bg-transparent text-main-01 Nunito-700 border p-[6px] md:p-[8px] border-main-01 text-xs md:text-sm flex flex-row items-center h-[36px] md:h-[48px] gap-[8px] rounded-[8px] md:rounded-[12px] max-w-full md:max-w-[33%]",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                    src: (_exactGame_icon = exactGame === null || exactGame === void 0 ? void 0 : exactGame.icon) !== null && _exactGame_icon !== void 0 ? _exactGame_icon : "",
                                    alt: exactGame.icon,
                                    width: isMobile ? 24 : 32,
                                    height: isMobile ? 24 : 32,
                                    className: "rounded-[8px]"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                    className: "line-clamp-1",
                                    children: exactGame === null || exactGame === void 0 ? void 0 : exactGame.game_name
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "cursor-pointer w-[16px] h-[16px]",
                                    onClick: ()=>updateMyTag("game", id, "remove"),
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
                                        width: "16",
                                        height: "16",
                                        viewBox: "0 0 16 16",
                                        fill: "none",
                                        xmlns: "http://www.w3.org/2000/svg",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                            d: "M10.8287 5.1716L5.17188 10.8285M10.8287 10.8284L5.17188 5.17157",
                                            stroke: "#DAD9FE",
                                            strokeWidth: "1.5",
                                            strokeLinecap: "round",
                                            strokeLinejoin: "round"
                                        })
                                    })
                                })
                            ]
                        });
                    }
                }))
            ]
        })
    });
};

// EXTERNAL MODULE: ./app/components/icon-tsx/IconClose.tsx
var IconClose = __webpack_require__(51337);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./app/components/ui/input.tsx
var input = __webpack_require__(78634);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
;// CONCATENATED MODULE: ./app/containers/users/common/modal/ModalInviteCode.tsx














const ModalInviteCode = ()=>{
    const { userInfo , openModal , setOpenModal  } = (0,react.useContext)(context/* AppContext */.Il);
    const { t  } = (0,esm/* useTranslation */.$G)();
    const { toast  } = (0,use_toast/* useToast */.pm)();
    const router = (0,next_router.useRouter)();
    const queryClient = (0,QueryClientProvider/* useQueryClient */.NL)();
    const [value, setValue] = (0,react.useState)("");
    const { mutate  } = (0,setting_mutation/* useMutationUpdateInviteCode */.E2)();
    const onChangeValue = (e)=>{
        var _e_target;
        setValue(e === null || e === void 0 ? void 0 : (_e_target = e.target) === null || _e_target === void 0 ? void 0 : _e_target.value);
    };
    const onCopyLink = ()=>{
        const code = "".concat("https://playee.vn", "?referent_code=").concat(userInfo === null || userInfo === void 0 ? void 0 : userInfo.referent_code);
        navigator.clipboard.writeText(code);
        toast({
            variant: "success",
            title: t("message.copied")
        });
    };
    (0,react.useEffect)(()=>{
        var _router_query;
        const refCode = router === null || router === void 0 ? void 0 : (_router_query = router.query) === null || _router_query === void 0 ? void 0 : _router_query.referent_code;
        if (!!refCode) {
            setValue(String(refCode));
        }
    }, [
        router
    ]);
    const handleClose = ()=>{
        const { referent_code , ...otherQuery } = router === null || router === void 0 ? void 0 : router.query;
        setValue("");
        setOpenModal(null);
        router.push({
            pathname: router.pathname,
            query: otherQuery
        });
    };
    const onSubmitInviteCode = ()=>{
        mutate({
            invite_code: value === null || value === void 0 ? void 0 : value.trim()
        }, {
            onSuccess (data, variables, context) {
                queryClient.invalidateQueries({
                    queryKey: [
                        configs/* QUERY_KEY.PROFILE_INFO */.lP.PROFILE_INFO
                    ],
                    refetchType: "active"
                });
                handleClose();
            },
            onError (error, variables, context) {
                var _error_data;
                toast({
                    title: error === null || error === void 0 ? void 0 : (_error_data = error.data) === null || _error_data === void 0 ? void 0 : _error_data.message,
                    variant: "error"
                });
            }
        });
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(dialog/* Dialog */.Vq, {
        open: openModal === configs/* OPEN_MODAL.SHARE_REFER_CODE */.a6.SHARE_REFER_CODE,
        onOpenChange: handleClose,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(dialog/* DialogContent */.cZ, {
            className: "w-fit rounded-[24px] sm:rounded-[24px] md:min-w-[468px] md:max-w-[473px] px-6 py-4 dark:border-0 dark:bg-[#1A1925] min-w-[300px]",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(dialog/* DialogClose */.GG, {
                    className: "absolute transition-opacity rounded-sm right-6 top-3 focus:outline-none disabled:pointer-events-none"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "flex flex-col justify-center w-full",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "flex items-center justify-between w-full",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                    className: "text-bg-01 Nunito-700 text-base mb-[40px dark:text-main-white",
                                    children: t("profile.invite_code_title")
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "w-[32px] h-[32px] rounded-[8px] flex items-center justify-center bg-bg-button dark:bg-[#ECECEE]/10 cursor-pointer",
                                    onClick: handleClose,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(IconClose/* IconClose */.b, {})
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "w-full my-[24px] px-4 py-1 md:py-[13px] flex gap-3 border-[1px] border-black/10 rounded-2xl dark:bg-[#fff]/10 justify-between items-center",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(input/* Input */.I, {
                                    placeholder: t("common.invite_code_placeholder"),
                                    className: "border-0 p-0 max-h-[32px] dark:bg-transparent",
                                    value: value,
                                    onChange: onChangeValue
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(ui_button/* Button */.z, {
                                    variant: "main",
                                    className: "px-[12px] py-[4px] max-h-[32px]",
                                    disabled: !value,
                                    onClick: onSubmitInviteCode,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
                                        width: "24",
                                        height: "24",
                                        viewBox: "0 0 24 24",
                                        fill: "none",
                                        xmlns: "http://www.w3.org/2000/svg",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                            d: "M14 16L18 12M18 12L14 8M18 12L6 12",
                                            stroke: "#FAF8FF",
                                            strokeWidth: "1.5",
                                            strokeLinecap: "round",
                                            strokeLinejoin: "round"
                                        })
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "flex items-center justify-between w-full border-t-[1px] pt-[24px] border-black/10",
                            children: [
                                 true && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "flex w-full gap-4",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                            href: "https://www.facebook.com/sharer/sharer.php?u=".concat("https://playee.vn", "?referent_code=").concat(userInfo === null || userInfo === void 0 ? void 0 : userInfo.referent_code),
                                            target: "_blank",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
                                                width: "32",
                                                height: "32",
                                                viewBox: "0 0 48 48",
                                                fill: "none",
                                                xmlns: "http://www.w3.org/2000/svg",
                                                className: "cursor-pointer",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                                                        width: "48",
                                                        height: "48",
                                                        rx: "16",
                                                        fill: "#337FFF"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                        d: "M29.8737 25.5625L30.5576 21.2172H26.3447V18.3927C26.3447 17.2046 26.9329 16.0436 28.8136 16.0436H30.7559V12.3433C29.6248 12.1629 28.4819 12.0653 27.3364 12.0513C23.869 12.0513 21.6053 14.1357 21.6053 17.9039V21.2172H17.7617V25.5625H21.6053V36.0727H26.3447V25.5625H29.8737Z",
                                                        fill: "white"
                                                    })
                                                ]
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                            href: "https://t.me/share/url?url=".concat("https://playee.vn", "?referent_code=").concat(userInfo === null || userInfo === void 0 ? void 0 : userInfo.referent_code),
                                            target: "_blank",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
                                                width: "32",
                                                height: "32",
                                                viewBox: "0 0 48 48",
                                                fill: "none",
                                                xmlns: "http://www.w3.org/2000/svg",
                                                className: "cursor-pointer",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                                                        width: "48",
                                                        height: "48",
                                                        rx: "16",
                                                        fill: "#34AADF"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                        d: "M13.3537 23.1498C13.3537 23.1498 23.1191 19.0367 26.506 17.5884C27.8043 17.0092 32.2072 15.1553 32.2072 15.1553C32.2072 15.1553 34.2393 14.3443 34.07 16.314C34.0135 17.125 33.5619 19.9636 33.1104 23.0339C32.433 27.3788 31.6992 32.129 31.6992 32.129C31.6992 32.129 31.5863 33.4615 30.6267 33.6932C29.6671 33.9249 28.0865 32.8822 27.8043 32.6504C27.5784 32.4767 23.5707 29.8698 22.1031 28.5953C21.7079 28.2477 21.2564 27.5526 22.1595 26.7415C24.1916 24.8298 26.6188 22.4547 28.0865 20.9485C28.7639 20.2533 29.4412 18.6312 26.6188 20.6008C22.6111 23.4395 18.6598 26.1043 18.6598 26.1043C18.6598 26.1043 17.7566 26.6835 16.0632 26.1622C14.3697 25.6409 12.394 24.9456 12.394 24.9456C12.394 24.9456 11.0394 24.0767 13.3537 23.1498Z",
                                                        fill: "white"
                                                    })
                                                ]
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                            href: "https://twitter.com/intent/tweet?text=".concat("https://playee.vn", "?referent_code=").concat(userInfo === null || userInfo === void 0 ? void 0 : userInfo.referent_code),
                                            target: "_blank",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
                                                width: "32",
                                                height: "32",
                                                viewBox: "0 0 48 48",
                                                fill: "none",
                                                xmlns: "http://www.w3.org/2000/svg",
                                                className: "cursor-pointer",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                                                        width: "48",
                                                        height: "48",
                                                        rx: "16",
                                                        fill: "#0F1419"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                        d: "M25.905 22.4695L33.3512 14H31.5869L25.1184 21.3524L19.9558 14H14L21.8086 25.1192L14 34H15.7643L22.591 26.2338L28.0442 34H34L25.905 22.4695ZM23.4877 25.2168L22.6954 24.1089L16.4005 15.3015H19.1108L24.1925 22.412L24.9815 23.5199L31.5861 32.7619H28.8758L23.4877 25.2168Z",
                                                        fill: "white"
                                                    })
                                                ]
                                            })
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(ui_button/* Button */.z, {
                                    variant: "none",
                                    onClick: onCopyLink,
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
                                            width: "24",
                                            height: "24",
                                            viewBox: "0 0 24 24",
                                            fill: "none",
                                            xmlns: "http://www.w3.org/2000/svg",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                    d: "M14.1211 9.87866L9.87845 14.1213",
                                                    stroke: "#7673E6",
                                                    strokeWidth: "1.5",
                                                    strokeLinecap: "round"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                    d: "M10.332 7.00003L11.9987 5.33336C13.8396 3.49239 16.8244 3.49239 18.6654 5.33335V5.33335C20.5063 7.17431 20.5063 10.1591 18.6654 12.0001L16.9987 13.6667",
                                                    stroke: "#7673E6",
                                                    strokeWidth: "1.5",
                                                    strokeLinecap: "round"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                    d: "M13.668 17L12.0013 18.6666C10.1604 20.5076 7.17558 20.5076 5.33462 18.6666V18.6666C3.49365 16.8257 3.49365 13.8409 5.33462 11.9999L7.00129 10.3333",
                                                    stroke: "#7673E6",
                                                    strokeWidth: "1.5",
                                                    strokeLinecap: "round"
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                            className: "text-sm text-bg-01 Nunito-700 dark:text-white",
                                            children: [
                                                "\xa0\xa0",
                                                t("reward.copy")
                                            ]
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                })
            ]
        })
    });
};

// EXTERNAL MODULE: ./app/components/icon-tsx/IconCopied.tsx
var IconCopied = __webpack_require__(60303);
// EXTERNAL MODULE: ./app/components/icon-tsx/IconNonCopy.tsx
var IconNonCopy = __webpack_require__(27298);
;// CONCATENATED MODULE: ./app/components/icon-tsx/IconTime.tsx


const IconTime = ()=>{
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "16",
        height: "17",
        viewBox: "0 0 16 17",
        fill: "none",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M2 6.83349C2 4.62435 3.79086 2.8335 6 2.8335H10C12.2091 2.8335 14 4.62436 14 6.8335V11.1668C14 13.376 12.2091 15.1668 10 15.1668H6C3.79086 15.1668 2 13.376 2 11.1668V6.83349Z",
                stroke: "#7673E6"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M2 6.5H14",
                stroke: "#7673E6",
                strokeLinecap: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M5.33325 1.8335L5.33325 3.8335",
                stroke: "#7673E6",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M10.6667 1.8335V3.8335",
                stroke: "#7673E6",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("ellipse", {
                cx: "7.99992",
                cy: "10.5002",
                rx: "0.666667",
                ry: "0.666667",
                fill: "#7673E6"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("ellipse", {
                cx: "10.6667",
                cy: "10.5002",
                rx: "0.666667",
                ry: "0.666667",
                fill: "#7673E6"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("ellipse", {
                cx: "5.33342",
                cy: "10.5002",
                rx: "0.666667",
                ry: "0.666667",
                fill: "#7673E6"
            })
        ]
    });
};

// EXTERNAL MODULE: ./app/components/ui/skeleton.tsx
var skeleton = __webpack_require__(84751);
// EXTERNAL MODULE: ./app/hooks/index.tsx
var hooks = __webpack_require__(38609);
// EXTERNAL MODULE: ./app/hooks/useGAEventsTracker.ts
var useGAEventsTracker = __webpack_require__(64800);
// EXTERNAL MODULE: ./app/services/query-fn/giftcode/giftcode-query.ts
var giftcode_query = __webpack_require__(32674);
// EXTERNAL MODULE: ./node_modules/moment/moment.js
var moment = __webpack_require__(30381);
var moment_default = /*#__PURE__*/__webpack_require__.n(moment);
;// CONCATENATED MODULE: ./app/containers/giftcode/modal/GiftcodeDetailModal.tsx



















const GiftcodeDetailModal = ()=>{
    var _data_giftcode, _data_giftcode_, _data_giftcode1, _data_giftcode_1, _data_giftcode2, _data_giftcode_2, _data_giftcode3, _data_giftcode_3, _data_giftcode4, _data_giftcode_4, _data_giftcode5, _data_giftcode_5, _data_giftcode6, _data_giftcode_6, _giftcodeInfo_, _data_giftcode7, _data_giftcode_7, _giftcodeInfo_1, _data_giftcode8, _data_giftcode_8, _data_giftcode9, _data_giftcode_9;
    const { t  } = (0,esm/* useTranslation */.$G)();
    const { visibleGiftcodeDetail , setVisibleGiftcodeDetail , selectedGiftcode , setSelectedGiftcode , setVisibleUseGiftcode  } = (0,react.useContext)(context/* AppContext */.Il);
    const token = configs/* isClient */.C5 ? window.localStorage.getItem("token") : null;
    const router = (0,next_router.useRouter)();
    const { toast  } = (0,use_toast/* useToast */.pm)();
    const [copied, setIsCopied] = (0,react.useState)(false);
    const GAEventsTracker = (0,useGAEventsTracker/* default */.Z)("Giftcode");
    const { data , isLoading: loadingDetail  } = (0,giftcode_query/* useQueryGetGiftcodeDetail */.DV)({
        event_id: selectedGiftcode === null || selectedGiftcode === void 0 ? void 0 : selectedGiftcode.id
    });
    const [width] = (0,hooks/* useWindowSize */.i)();
    const { data: giftcodeInfo , error , isLoading  } = (0,giftcode_query/* useQueryGetGiftcodeInfo */.s2)({
        event_id: selectedGiftcode === null || selectedGiftcode === void 0 ? void 0 : selectedGiftcode.id
    });
    const onCopyCode = ()=>{
        var _data_giftcode, _data_giftcode_, _giftcodeInfo_;
        navigator.clipboard.writeText((data === null || data === void 0 ? void 0 : (_data_giftcode = data.giftcode) === null || _data_giftcode === void 0 ? void 0 : (_data_giftcode_ = _data_giftcode[0]) === null || _data_giftcode_ === void 0 ? void 0 : _data_giftcode_.code) || (giftcodeInfo === null || giftcodeInfo === void 0 ? void 0 : (_giftcodeInfo_ = giftcodeInfo[0]) === null || _giftcodeInfo_ === void 0 ? void 0 : _giftcodeInfo_.code) || "");
        setIsCopied(true);
    };
    (0,react.useEffect)(()=>{
        if (!!copied) {
            setTimeout(()=>{
                setIsCopied(false);
            }, 2000);
        }
    }, [
        copied
    ]);
    (0,react.useEffect)(()=>{
        var _error_data;
        const _error = error;
        if (_error && (_error === null || _error === void 0 ? void 0 : (_error_data = _error.data) === null || _error_data === void 0 ? void 0 : _error_data.errorCode) === 33 && visibleGiftcodeDetail) {
            toast({
                variant: "error",
                title: "Giftcode đ\xe3 hết. Vui l\xf2ng thử lại sau!"
            });
            setVisibleGiftcodeDetail(false);
        }
    }, [
        error,
        visibleGiftcodeDetail
    ]);
    const renderLoading = ()=>{
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "flex flex-col space-y-3",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(skeleton/* Skeleton */.O, {
                    className: "h-[80px] w-[full] rounded-xl bg-[#EAEAEA] dark:bg-[#FFFFFF]/10"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "space-y-2",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(skeleton/* Skeleton */.O, {
                            className: "h-10 w-1/2 bg-[#EAEAEA] dark:bg-[#FFFFFF]/10"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(skeleton/* Skeleton */.O, {
                            className: "h-16 w-full bg-[#EAEAEA] dark:bg-[#FFFFFF]/10"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(skeleton/* Skeleton */.O, {
                            className: "h-16 w-full bg-[#EAEAEA] dark:bg-[#FFFFFF]/10"
                        })
                    ]
                })
            ]
        });
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(dialog/* Dialog */.Vq, {
        open: visibleGiftcodeDetail,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(dialog/* DialogContent */.cZ, {
            id: "modal-giftcode-detail",
            className: "sm:rounded-[16px] h-auto min-h-fit gap-0 rounded-[16px] max-w-[100vw] md:max-w-[400px] p-[16px] border-0 focus-visible:outline-none dark:bg-bg-02 top-auto left-0 bottom-0 translate-x-0 md:top-[50%] md:left-[50%] md:translate-x-[-50%] translate-y-0 md:translate-y-[-50%]",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "flex justify-between items-center w-full mb-[8px]",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                            className: "text-bg-01 Nunito-700 text-base mb-[40px dark:text-main-white",
                            children: t("reward.detail")
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "w-[30px] h-[30px] rounded-[8px] flex items-center justify-center cursor-pointer",
                            onClick: ()=>{
                                GAEventsTracker("Giftcode_close_popup");
                                setVisibleGiftcodeDetail(false);
                                setSelectedGiftcode({});
                            },
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(IconClose/* IconClose */.b, {})
                        })
                    ]
                }),
                isLoading || loadingDetail ? renderLoading() : /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "flex items-center gap-[10px]",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                    src: data === null || data === void 0 ? void 0 : data.game_icon,
                                    className: "w-[48px] h-[48px] rounded-[12px]"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                            className: "text-[14px] Nunito-600 mb-1",
                                            children: data === null || data === void 0 ? void 0 : data.title
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "text-[10px] Nunito-500 text-main-01 dark:text-main-disable bg-bg-disable dark:bg-main-disable/10 px-[8px] h-[22px] rounded-[10px] w-fit flex items-center justify-center",
                                            children: (data === null || data === void 0 ? void 0 : data.type) === "fanpage" ? "Social" : (data === null || data === void 0 ? void 0 : data.type) === "newbie" ? t("giftcode.newbie") : (data === null || data === void 0 ? void 0 : data.type) === "vip_gamota" ? t("giftcode.vip_gamota") : (data === null || data === void 0 ? void 0 : data.type) === "mission" ? t("screen.mission") : t("giftcode.charge")
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "my-[16px] w-full h-[1px] bg-black/10 dark:bg-white/10"
                        }),
                        (data === null || data === void 0 ? void 0 : data.start_time) && (data === null || data === void 0 ? void 0 : data.end_time) && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "flex items-center text-neutral-02 dark:text-main-white text-[12px] gap-[8px]",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(IconTime, {}),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                    children: moment_default().unix(data === null || data === void 0 ? void 0 : data.start_time).format(configs/* DATE_FORMAT_3 */.Ly)
                                }),
                                " -",
                                " ",
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                    children: moment_default().unix(data === null || data === void 0 ? void 0 : data.end_time).format(configs/* DATE_FORMAT_3 */.Ly)
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "mt-[16px] flex items-center gap-[14px]",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "".concat((data === null || data === void 0 ? void 0 : (_data_giftcode = data.giftcode) === null || _data_giftcode === void 0 ? void 0 : (_data_giftcode_ = _data_giftcode[0]) === null || _data_giftcode_ === void 0 ? void 0 : _data_giftcode_.code) || giftcodeInfo ? "bg-main-01" : "bg-main-disable-02", " w-[4px] h-[4px] rounded-[4px] ml-[6px]")
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                    className: "".concat((data === null || data === void 0 ? void 0 : (_data_giftcode1 = data.giftcode) === null || _data_giftcode1 === void 0 ? void 0 : (_data_giftcode_1 = _data_giftcode1[0]) === null || _data_giftcode_1 === void 0 ? void 0 : _data_giftcode_1.code) || giftcodeInfo ? "text-neutral-02 dark:text-neutral-06" : "text-neutral-06", " text-[12px] flex-1"),
                                    dangerouslySetInnerHTML: {
                                        __html: (0,helpers_function/* removeStyle */.jo)((data === null || data === void 0 ? void 0 : data.description) || "") || ""
                                    }
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "mt-[16px] flex items-center gap-[14px]",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "".concat((data === null || data === void 0 ? void 0 : (_data_giftcode2 = data.giftcode) === null || _data_giftcode2 === void 0 ? void 0 : (_data_giftcode_2 = _data_giftcode2[0]) === null || _data_giftcode_2 === void 0 ? void 0 : _data_giftcode_2.code) || giftcodeInfo ? "bg-main-01" : "bg-main-disable-02", " w-[4px] h-[4px] rounded-[4px] ml-[6px]")
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                    className: "".concat((data === null || data === void 0 ? void 0 : (_data_giftcode3 = data.giftcode) === null || _data_giftcode3 === void 0 ? void 0 : (_data_giftcode_3 = _data_giftcode3[0]) === null || _data_giftcode_3 === void 0 ? void 0 : _data_giftcode_3.code) || giftcodeInfo ? "text-neutral-02 dark:text-neutral-06" : "text-neutral-06", " text-[12px] flex-1"),
                                    dangerouslySetInnerHTML: {
                                        __html: (0,helpers_function/* removeStyle */.jo)((data === null || data === void 0 ? void 0 : data.giftcode_description) || "") || ""
                                    }
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "mt-[16px] flex items-center gap-[8px]",
                            children: (data === null || data === void 0 ? void 0 : (_data_giftcode4 = data.giftcode) === null || _data_giftcode4 === void 0 ? void 0 : (_data_giftcode_4 = _data_giftcode4[0]) === null || _data_giftcode_4 === void 0 ? void 0 : _data_giftcode_4.code) || giftcodeInfo ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
                                        xmlns: "http://www.w3.org/2000/svg",
                                        width: "16",
                                        height: "16",
                                        viewBox: "0 0 16 16",
                                        fill: "none",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                            fillRule: "evenodd",
                                            clipRule: "evenodd",
                                            d: "M7.99992 14.6668C11.6818 14.6668 14.6666 11.6821 14.6666 8.00016C14.6666 4.31826 11.6818 1.3335 7.99992 1.3335C4.31802 1.3335 1.33325 4.31826 1.33325 8.00016C1.33325 11.6821 4.31802 14.6668 7.99992 14.6668ZM11.0613 6.30716C11.2308 6.08918 11.1915 5.77504 10.9736 5.60551C10.7556 5.43598 10.4414 5.47524 10.2719 5.69322L7.60058 9.12779C7.54118 9.20416 7.42944 9.21407 7.35753 9.14935L5.66774 7.62854C5.46248 7.44381 5.14634 7.46045 4.96161 7.6657C4.77688 7.87096 4.79352 8.1871 4.99877 8.37183L6.68856 9.89264C7.19198 10.3457 7.97412 10.2763 8.38993 9.74173L11.0613 6.30716Z",
                                            fill: "#7673E6"
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                        className: "text-[12px] text-neutral-02 dark:text-main-white",
                                        children: (selectedGiftcode === null || selectedGiftcode === void 0 ? void 0 : selectedGiftcode.has_used) ? t("reward.used") : t("giftcode.eligible")
                                    })
                                ]
                            }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
                                        xmlns: "http://www.w3.org/2000/svg",
                                        width: "16",
                                        height: "17",
                                        viewBox: "0 0 16 17",
                                        fill: "none",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                opacity: "0.4",
                                                d: "M14.6666 8.50016C14.6666 12.1821 11.6818 15.1668 7.99992 15.1668C4.31802 15.1668 1.33325 12.1821 1.33325 8.50016C1.33325 4.81826 4.31802 1.8335 7.99992 1.8335C11.6818 1.8335 14.6666 4.81826 14.6666 8.50016Z",
                                                fill: "#7673E6"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                fillRule: "evenodd",
                                                clipRule: "evenodd",
                                                d: "M9.53219 10.739C9.72746 10.9343 10.044 10.9343 10.2393 10.739C10.4346 10.5438 10.4346 10.2272 10.2393 10.0319L8.70727 8.49992L10.2393 6.9679C10.4346 6.77264 10.4346 6.45605 10.2393 6.26079C10.044 6.06553 9.72745 6.06553 9.53218 6.26079L8.00017 7.79281L6.46806 6.2607C6.2728 6.06544 5.95622 6.06544 5.76096 6.2607C5.5657 6.45597 5.5657 6.77255 5.76096 6.96781L7.29306 8.49992L5.76095 10.032C5.56569 10.2273 5.56569 10.5439 5.76095 10.7391C5.95621 10.9344 6.27279 10.9344 6.46806 10.7391L8.00017 9.20702L9.53219 10.739Z",
                                                fill: "#7673E6"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                        className: "text-[12px] text-neutral-02 dark:text-main-white",
                                        children: t("giftcode.not_eligible")
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "my-[16px]",
                            children: (data === null || data === void 0 ? void 0 : (_data_giftcode5 = data.giftcode) === null || _data_giftcode5 === void 0 ? void 0 : (_data_giftcode_5 = _data_giftcode5[0]) === null || _data_giftcode_5 === void 0 ? void 0 : _data_giftcode_5.code) || giftcodeInfo ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "p-[12px] border border-main-01 border-dashed rounded-[12px]",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "flex items-center justify-center",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                className: "text-[16px] Nunito-700 text-main-01",
                                                children: (data === null || data === void 0 ? void 0 : (_data_giftcode6 = data.giftcode) === null || _data_giftcode6 === void 0 ? void 0 : (_data_giftcode_6 = _data_giftcode6[0]) === null || _data_giftcode_6 === void 0 ? void 0 : _data_giftcode_6.code) || (giftcodeInfo === null || giftcodeInfo === void 0 ? void 0 : (_giftcodeInfo_ = giftcodeInfo[0]) === null || _giftcodeInfo_ === void 0 ? void 0 : _giftcodeInfo_.code)
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "w-[1px] h-[17px] bg-black/10 dark:text-neutral-03 opacity-30 dark:opacity-100 mx-[8px]"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "cursor-pointer w-fit",
                                                onClick: onCopyCode,
                                                children: copied ? /*#__PURE__*/ (0,jsx_runtime.jsx)(IconCopied/* IconCopied */.i, {}) : /*#__PURE__*/ (0,jsx_runtime.jsx)(IconNonCopy/* IconNonCopy */.x, {
                                                    stroke: "#D9D9DB"
                                                })
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                        className: "mt-[4px] text-center text-neutral-06 text-[10px]",
                                        children: [
                                            "HSD:",
                                            " ",
                                            moment_default().unix((data === null || data === void 0 ? void 0 : (_data_giftcode7 = data.giftcode) === null || _data_giftcode7 === void 0 ? void 0 : (_data_giftcode_7 = _data_giftcode7[0]) === null || _data_giftcode_7 === void 0 ? void 0 : _data_giftcode_7.expired) || (giftcodeInfo === null || giftcodeInfo === void 0 ? void 0 : (_giftcodeInfo_1 = giftcodeInfo[0]) === null || _giftcodeInfo_1 === void 0 ? void 0 : _giftcodeInfo_1.expired) || 0).format(configs/* DATE_FORMAT */.zT)
                                        ]
                                    })
                                ]
                            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                className: "text-center text-neutral-06 text-[12px] px-[20px]",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(esm/* Trans */.cC, {
                                    i18nKey: t("giftcode.not_eligible_desc"),
                                    components: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                            className: "cursor-pointer text-main-01 Nunito-700",
                                            onClick: ()=>{
                                                router.push("/help-center");
                                                setVisibleGiftcodeDetail(false);
                                                setSelectedGiftcode({});
                                            }
                                        }, 0)
                                    ]
                                })
                            })
                        }),
                        ((data === null || data === void 0 ? void 0 : (_data_giftcode8 = data.giftcode) === null || _data_giftcode8 === void 0 ? void 0 : (_data_giftcode_8 = _data_giftcode8[0]) === null || _data_giftcode_8 === void 0 ? void 0 : _data_giftcode_8.code) || giftcodeInfo) && !(data === null || data === void 0 ? void 0 : data.has_use) && /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                            className: "text-neutral-06 text-[12px] pb-[2px]",
                            children: t("giftcode.do_not_use_gc")
                        }),
                        !(selectedGiftcode === null || selectedGiftcode === void 0 ? void 0 : selectedGiftcode.has_used) && /*#__PURE__*/ (0,jsx_runtime.jsx)(ui_button/* Button */.z, {
                            variant: "main",
                            className: "text-[14px] Nunito-600 h-[42px]",
                            onClick: ()=>{
                                var _data_giftcode, _data_giftcode_;
                                if ((data === null || data === void 0 ? void 0 : (_data_giftcode = data.giftcode) === null || _data_giftcode === void 0 ? void 0 : (_data_giftcode_ = _data_giftcode[0]) === null || _data_giftcode_ === void 0 ? void 0 : _data_giftcode_.code) || giftcodeInfo) {
                                    if (data === null || data === void 0 ? void 0 : data.has_use) {
                                        var _giftcodeInfo_;
                                        setVisibleUseGiftcode(true);
                                        setVisibleGiftcodeDetail(false);
                                        if (giftcodeInfo === null || giftcodeInfo === void 0 ? void 0 : (_giftcodeInfo_ = giftcodeInfo[0]) === null || _giftcodeInfo_ === void 0 ? void 0 : _giftcodeInfo_.code) {
                                            setSelectedGiftcode({
                                                ...data,
                                                giftcode: [
                                                    {
                                                        ...giftcodeInfo === null || giftcodeInfo === void 0 ? void 0 : giftcodeInfo[0]
                                                    }
                                                ]
                                            });
                                        } else {
                                            setSelectedGiftcode(data);
                                        }
                                    } else {
                                        onCopyCode();
                                        GAEventsTracker("Giftcode_copied");
                                    }
                                } else {
                                    var _data_event_link;
                                    const link = (data === null || data === void 0 ? void 0 : (_data_event_link = data.event_link) === null || _data_event_link === void 0 ? void 0 : _data_event_link.includes("https://event.playee.vn" || 0)) && token ? "".concat(data === null || data === void 0 ? void 0 : data.event_link, "?token=").concat(token) : data === null || data === void 0 ? void 0 : data.event_link;
                                    if (width < 992) {
                                        window.location.href = link || "";
                                    } else {
                                        window.open(link);
                                    }
                                    GAEventsTracker("Giftcode_join_event");
                                }
                            },
                            children: (data === null || data === void 0 ? void 0 : (_data_giftcode9 = data.giftcode) === null || _data_giftcode9 === void 0 ? void 0 : (_data_giftcode_9 = _data_giftcode9[0]) === null || _data_giftcode_9 === void 0 ? void 0 : _data_giftcode_9.code) || giftcodeInfo ? (data === null || data === void 0 ? void 0 : data.has_use) ? t("giftcode.use_giftcode") : "".concat(t("reward.copy"), " giftcode") : t("giftcode.join_event")
                        })
                    ]
                })
            ]
        })
    });
};

// EXTERNAL MODULE: ./app/components/icon-tsx/IconInventory.tsx
var IconInventory = __webpack_require__(67895);
;// CONCATENATED MODULE: ./app/components/icon-tsx/IconSelectDown.tsx


const IconSelectDown = (param)=>{
    let { className  } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "14",
        height: "12",
        viewBox: "0 0 14 12",
        fill: "none",
        className: className,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            d: "M10.5179 4.59753e-07L3.48207 1.52206e-07C1.93849 8.47342e-08 0.976748 1.67443 1.75451 3.00774L5.27244 9.03847C6.0442 10.3615 7.9558 10.3615 8.72756 9.03847L12.2455 3.00774C13.0232 1.67443 12.0615 5.27225e-07 10.5179 4.59753e-07Z",
            fill: "#878693"
        })
    });
};

// EXTERNAL MODULE: ./app/components/loading-btn/index.tsx + 2 modules
var loading_btn = __webpack_require__(25327);
// EXTERNAL MODULE: ./app/components/ui/select.tsx + 3 modules
var ui_select = __webpack_require__(80522);
// EXTERNAL MODULE: ./app/hooks/useDebounceEffect.tsx
var useDebounceEffect = __webpack_require__(45724);
// EXTERNAL MODULE: ./app/services/services/Giftcode.ts
var Giftcode = __webpack_require__(56427);
// EXTERNAL MODULE: ./node_modules/@tanstack/react-query/build/modern/useMutation.js + 1 modules
var useMutation = __webpack_require__(98029);
;// CONCATENATED MODULE: ./app/services/query-fn/giftcode/giftcode-mutation.ts



const useGiftcodeFn = (body)=>{
    return Giftcode/* GiftcodeServices.useGiftcode */.t.useGiftcode(body);
};
const useMutationUseGiftcode = ()=>{
    return (0,useMutation/* useMutation */.D)({
        mutationKey: [
            configs/* QUERY_KEY.USE_GIFTCODE */.lP.USE_GIFTCODE
        ],
        mutationFn: useGiftcodeFn,
        onSuccess: (data, variables)=>{}
    });
};

;// CONCATENATED MODULE: ./app/containers/giftcode/modal/UseGiftcodeModal.tsx



















const TIME_DEBOUNCE = 300;
const UseGiftcodeModal = ()=>{
    var _dataServer_data, _dataServer_data_user, _dataServer_data1, _dataServer_data2, _dataServer_data3, _dataServer_data4, _dataServer_data_user1;
    const { t  } = (0,esm/* useTranslation */.$G)();
    const router = (0,next_router.useRouter)();
    const { userInfo  } = (0,react.useContext)(context/* AppContext */.Il);
    const { visibleUseGiftcode , setVisibleUseGiftcode , setSelectedGiftcode , selectedGiftcode  } = (0,react.useContext)(context/* AppContext */.Il);
    const { toast  } = (0,use_toast/* useToast */.pm)();
    const [game, setGame] = (0,react.useState)();
    const [server, setServer] = (0,react.useState)();
    const [role, setRole] = (0,react.useState)();
    const [userID, setUserID] = (0,react.useState)("");
    const [debounceSearch, setDebounceSearch] = (0,react.useState)("");
    const [code, setCode] = (0,react.useState)("");
    const GAEventsTracker = (0,useGAEventsTracker/* default */.Z)("Giftcode");
    const { data: listGame  } = (0,giftcode_query/* useQueryGetListGameGiftcode */.dr)();
    const { data: dataServer , isLoading: loadingGetServer  } = (0,giftcode_query/* useQueryGetListServerGiftcode */.Jn)({
        user_id: userID,
        game_id: game === null || game === void 0 ? void 0 : game.game_id
    });
    const { data: dataRole , isLoading: loadingGetRole , error  } = (0,giftcode_query/* useQueryGetListRoleGiftcode */.nv)({
        user_id: (dataServer === null || dataServer === void 0 ? void 0 : (_dataServer_data = dataServer.data) === null || _dataServer_data === void 0 ? void 0 : (_dataServer_data_user = _dataServer_data.user) === null || _dataServer_data_user === void 0 ? void 0 : _dataServer_data_user.user_id) || "",
        game_id: game === null || game === void 0 ? void 0 : game.game_id,
        server_id: server === null || server === void 0 ? void 0 : server.server_id
    });
    (0,useDebounceEffect/* useDebounceEffect */.s)(()=>setUserID(debounceSearch), TIME_DEBOUNCE, [
        debounceSearch
    ]);
    const { mutate , isPending  } = useMutationUseGiftcode();
    const queryClient = (0,QueryClientProvider/* useQueryClient */.NL)();
    const OptionGame = listGame ? Object.values(listGame) : [];
    const OptionServer = (dataServer === null || dataServer === void 0 ? void 0 : (_dataServer_data1 = dataServer.data) === null || _dataServer_data1 === void 0 ? void 0 : _dataServer_data1.servers) ? Object.entries(dataServer === null || dataServer === void 0 ? void 0 : (_dataServer_data2 = dataServer.data) === null || _dataServer_data2 === void 0 ? void 0 : _dataServer_data2.servers).map((param)=>{
        let [id, name] = param;
        return {
            server_id: id,
            server_name: name
        };
    }) : [];
    const OptionRole = (dataRole === null || dataRole === void 0 ? void 0 : dataRole.data) ? dataRole === null || dataRole === void 0 ? void 0 : dataRole.data : [];
    const onChangeGame = (value)=>{
        const _game = OptionGame.find((item)=>{
            return (item === null || item === void 0 ? void 0 : item.game_id) === value;
        });
        setGame(_game);
        setServer({});
        setRole({});
    };
    (0,react.useEffect)(()=>{
        var _dataServer_data, _dataServer_data_user;
        if (!!(dataServer === null || dataServer === void 0 ? void 0 : dataServer.data.servers) && !(dataServer === null || dataServer === void 0 ? void 0 : (_dataServer_data = dataServer.data) === null || _dataServer_data === void 0 ? void 0 : (_dataServer_data_user = _dataServer_data.user) === null || _dataServer_data_user === void 0 ? void 0 : _dataServer_data_user.user_id)) {
            toast({
                variant: "error",
                title: "Nh\xe2n vật kh\xf4ng tồn tại"
            });
        }
    }, [
        dataServer
    ]);
    const onChangeServer = (value)=>{
        const _server = OptionServer.find((item)=>{
            return (item === null || item === void 0 ? void 0 : item.server_id) === value;
        });
        setServer(_server);
        setRole({});
    };
    const onChangeRole = (value)=>{
        const _role = OptionRole.find((item)=>{
            return (item === null || item === void 0 ? void 0 : item.role_id) === value;
        });
        setRole(_role);
    };
    (0,react.useEffect)(()=>{
        var _selectedGiftcode_giftcode;
        if (selectedGiftcode === null || selectedGiftcode === void 0 ? void 0 : (_selectedGiftcode_giftcode = selectedGiftcode.giftcode) === null || _selectedGiftcode_giftcode === void 0 ? void 0 : _selectedGiftcode_giftcode[0]) {
            var _selectedGiftcode_giftcode1, _selectedGiftcode_giftcode_;
            setCode(selectedGiftcode === null || selectedGiftcode === void 0 ? void 0 : (_selectedGiftcode_giftcode1 = selectedGiftcode.giftcode) === null || _selectedGiftcode_giftcode1 === void 0 ? void 0 : (_selectedGiftcode_giftcode_ = _selectedGiftcode_giftcode1[0]) === null || _selectedGiftcode_giftcode_ === void 0 ? void 0 : _selectedGiftcode_giftcode_.code);
        }
    }, [
        selectedGiftcode
    ]);
    (0,react.useEffect)(()=>{
        var _error_data;
        const _error = error;
        if (_error && (_error === null || _error === void 0 ? void 0 : (_error_data = _error.data) === null || _error_data === void 0 ? void 0 : _error_data.errorCode) !== 0) {
            var _error_data1;
            toast({
                variant: "error",
                title: _error === null || _error === void 0 ? void 0 : (_error_data1 = _error.data) === null || _error_data1 === void 0 ? void 0 : _error_data1.message
            });
        }
    }, [
        error
    ]);
    (0,react.useEffect)(()=>{
        if ((game === null || game === void 0 ? void 0 : game.is_copub) === "no") {
            setDebounceSearch(userInfo === null || userInfo === void 0 ? void 0 : userInfo.username);
            setUserID(userInfo === null || userInfo === void 0 ? void 0 : userInfo.username);
        } else {
            setDebounceSearch("");
            setUserID("");
        }
    }, [
        game
    ]);
    (0,react.useEffect)(()=>{
        if (!!selectedGiftcode.game_id && (OptionGame === null || OptionGame === void 0 ? void 0 : OptionGame.length) > 0) {
            const _game = OptionGame.find((item)=>{
                return (item === null || item === void 0 ? void 0 : item.game_id) === (selectedGiftcode === null || selectedGiftcode === void 0 ? void 0 : selectedGiftcode.game_id);
            });
            setGame(_game);
        }
    }, [
        selectedGiftcode,
        OptionGame
    ]);
    const onChangeText = (e)=>{
        setDebounceSearch(e.target.value);
    };
    const onUseGiftcode = ()=>{
        var _dataServer_data, _dataServer_data_user;
        GAEventsTracker("Giftcode_confirmed");
        mutate({
            user_id: (dataServer === null || dataServer === void 0 ? void 0 : (_dataServer_data = dataServer.data) === null || _dataServer_data === void 0 ? void 0 : (_dataServer_data_user = _dataServer_data.user) === null || _dataServer_data_user === void 0 ? void 0 : _dataServer_data_user.user_id) || "",
            code: code,
            game_id: game === null || game === void 0 ? void 0 : game.game_id,
            role_id: role === null || role === void 0 ? void 0 : role.role_id,
            server_id: server === null || server === void 0 ? void 0 : server.server_id
        }, {
            onSuccess: ()=>{
                toast({
                    variant: "success",
                    title: "Sử dụng th\xe0nh c\xf4ng!"
                });
                setVisibleUseGiftcode(false);
                queryClient.clear();
            },
            onError (error) {
                var _error_data;
                toast({
                    variant: "error",
                    title: (error === null || error === void 0 ? void 0 : (_error_data = error.data) === null || _error_data === void 0 ? void 0 : _error_data.message) || "Sử dụng kh\xf4ng th\xe0nh c\xf4ng!"
                });
            }
        });
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(dialog/* Dialog */.Vq, {
        open: visibleUseGiftcode,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(dialog/* DialogContent */.cZ, {
            id: "modal-use-giftcode",
            className: "space-y-[16px] gap-0 md:rounded-[16px] max-w-[100vw] md:max-w-[500px] p-[24px] border-0 focus-visible:outline-none dark:bg-bg-02 translate-y-0 md:translate-y-[-50%] bottom-0 top-auto rounded-0 md:top-[50%] md:bottom-auto max-h-[100dvh] overflow-auto",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "flex justify-between items-center w-full",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                            className: "text-bg-01 Nunito-700 text-base mb-[40px dark:text-main-white",
                            children: t("giftcode.use_giftcode")
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "w-[30px] h-[30px] rounded-[8px] flex items-center justify-center cursor-pointer",
                            onClick: ()=>{
                                setVisibleUseGiftcode(false);
                                setSelectedGiftcode({});
                                setGame({});
                                setUserID("");
                                setServer({});
                                setRole({});
                                setCode("");
                            },
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(IconClose/* IconClose */.b, {})
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "mb-[8px] flex justify-between",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                    className: "text-neutral-05 text-[14px]",
                                    children: t("giftcode.enter_giftcode")
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "flex items-center gap-1 cursor-pointer",
                                    onClick: ()=>{
                                        GAEventsTracker("Giftcode_inventory");
                                        window.open("/reward-center?tab=package&item=giftcode");
                                    },
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                            className: "text-main-01 text-[12px] Nunito-500",
                                            children: t("common.inventory")
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(IconInventory/* IconInventory */.h, {
                                            className: "w-[12px]"
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(input/* Input */.I, {
                            placeholder: t("giftcode.enter_giftcode"),
                            className: "w-full h-[40px] rounded-[12px] px-[16px] border border-black/10 Nunito-400 dark:bg-white/10 dark:backdrop-blur-[20px] text-left",
                            onChange: (e)=>{
                                setCode(e.target.value);
                            },
                            value: code === null || code === void 0 ? void 0 : code.trim()
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                            className: "text-neutral-05 text-[14px] pb-[8px]",
                            children: t("common.chose_game")
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(ui_select/* Select */.Ph, {
                            value: (game === null || game === void 0 ? void 0 : game.game_id) || "",
                            onValueChange: (value)=>onChangeGame(value),
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "relative",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(ui_select/* SelectTrigger */.i4, {
                                        asChild: false,
                                        disabled: !!(selectedGiftcode === null || selectedGiftcode === void 0 ? void 0 : selectedGiftcode.game_id),
                                        className: "w-full h-[40px] rounded-[12px] px-[16px] border border-black/10 Nunito-400 dark:bg-white/10 dark:backdrop-blur-[20px] text-left",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(ui_select/* SelectValue */.ki, {
                                                placeholder: t("common.chose_game"),
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                    className: "flex-1 text-[12px] text-main-01 flex items-center Nunito-600",
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                            src: game === null || game === void 0 ? void 0 : game.icon,
                                                            className: "w-[24px] h-[24px] rounded-[6px] mr-[8px]"
                                                        }),
                                                        (game === null || game === void 0 ? void 0 : game.game_name) || ""
                                                    ]
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(IconSelectDown, {})
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(ui_select/* SelectContent */.Bw, {
                                    className: "p-1 rounded-[16px]",
                                    children: OptionGame.map((item)=>{
                                        /*#__PURE__*/ return (0,jsx_runtime.jsx)(ui_select/* SelectItem */.Ql, {
                                            value: item === null || item === void 0 ? void 0 : item.game_id,
                                            "aria-expanded": true,
                                            className: "px-3 py-2 rounded-[8px] hover:!bg-bg-disable hover:!text-main-01 Nunito-500 focus:bg-bg-disable focus:text-main-01 dark:hover:!bg-[#F1F1FC]/[.1] dark:focus:!bg-[#F1F1FC]/[.1]",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: "flex items-center",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                        src: item === null || item === void 0 ? void 0 : item.icon,
                                                        className: "w-[24px] h-[24px] rounded-[6px] mr-[8px]"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                        children: item === null || item === void 0 ? void 0 : item.game_name
                                                    })
                                                ]
                                            })
                                        }, item === null || item === void 0 ? void 0 : item.game_id);
                                    })
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                            className: "text-neutral-05 text-[14px] pb-[8px]",
                            children: t("topup.input_user_id", {
                                field: "User ID"
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(input/* Input */.I, {
                            placeholder: t("topup.input_user_id", {
                                field: "User ID"
                            }),
                            className: "w-full h-[40px] rounded-[12px] px-[16px] border border-black/10 Nunito-400 dark:bg-white/10 dark:backdrop-blur-[20px] text-left",
                            onChange: onChangeText,
                            value: debounceSearch === null || debounceSearch === void 0 ? void 0 : debounceSearch.trim()
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                            className: "text-neutral-05 text-[14px] pb-[8px]",
                            children: "Server"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(ui_select/* Select */.Ph, {
                            value: (server === null || server === void 0 ? void 0 : server.server_id) || "",
                            disabled: !(game === null || game === void 0 ? void 0 : game.game_id) || !(dataServer === null || dataServer === void 0 ? void 0 : (_dataServer_data3 = dataServer.data) === null || _dataServer_data3 === void 0 ? void 0 : _dataServer_data3.servers) || !(dataServer === null || dataServer === void 0 ? void 0 : (_dataServer_data4 = dataServer.data) === null || _dataServer_data4 === void 0 ? void 0 : (_dataServer_data_user1 = _dataServer_data4.user) === null || _dataServer_data_user1 === void 0 ? void 0 : _dataServer_data_user1.user_id),
                            onValueChange: (value)=>onChangeServer(value),
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "relative",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(ui_select/* SelectTrigger */.i4, {
                                        asChild: false,
                                        className: "w-full h-[40px] rounded-[12px] px-[16px] border border-black/10 Nunito-400 dark:bg-white/10 dark:backdrop-blur-[20px] text-left",
                                        children: [
                                            !!loadingGetServer ? /*#__PURE__*/ (0,jsx_runtime.jsx)(loading_btn/* LoadingBtnComponent */.n, {}) : /*#__PURE__*/ (0,jsx_runtime.jsx)(ui_select/* SelectValue */.ki, {
                                                placeholder: t("topup.server"),
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: "flex-1 text-[12px] flex items-center Nunito-600",
                                                    children: (server === null || server === void 0 ? void 0 : server.server_name) || ""
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(IconSelectDown, {})
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(ui_select/* SelectContent */.Bw, {
                                    className: "p-1 rounded-[16px]",
                                    children: !!loadingGetServer ? /*#__PURE__*/ (0,jsx_runtime.jsx)(loading_btn/* LoadingBtnComponent */.n, {}) : OptionServer.map((item)=>{
                                        /*#__PURE__*/ return (0,jsx_runtime.jsx)(ui_select/* SelectItem */.Ql, {
                                            value: item === null || item === void 0 ? void 0 : item.server_id,
                                            "aria-expanded": true,
                                            className: "px-3 py-2 rounded-[8px] hover:!bg-bg-disable hover:!text-main-01 Nunito-500 focus:bg-bg-disable focus:text-main-01 dark:hover:!bg-[#F1F1FC]/[.1] dark:focus:!bg-[#F1F1FC]/[.1]",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "flex items-center",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                    children: item === null || item === void 0 ? void 0 : item.server_name
                                                })
                                            })
                                        }, item === null || item === void 0 ? void 0 : item.server_id);
                                    })
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                            className: "text-neutral-05 text-[14px] pb-[8px]",
                            children: t("topup.role_name")
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(ui_select/* Select */.Ph, {
                            value: (role === null || role === void 0 ? void 0 : role.role_id) || "",
                            disabled: !(game === null || game === void 0 ? void 0 : game.game_id) || !(server === null || server === void 0 ? void 0 : server.server_id) || !(dataRole === null || dataRole === void 0 ? void 0 : dataRole.data),
                            onValueChange: (value)=>onChangeRole(value),
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "relative",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(ui_select/* SelectTrigger */.i4, {
                                        asChild: false,
                                        className: "w-full h-[40px] rounded-[12px] px-[16px] border border-black/10 Nunito-400 dark:bg-white/10 dark:backdrop-blur-[20px] text-left",
                                        children: [
                                            loadingGetRole ? /*#__PURE__*/ (0,jsx_runtime.jsx)(loading_btn/* LoadingBtnComponent */.n, {}) : /*#__PURE__*/ (0,jsx_runtime.jsx)(ui_select/* SelectValue */.ki, {
                                                placeholder: t("topup.role_name"),
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: "flex-1 text-[12px] flex items-center Nunito-600",
                                                    children: (role === null || role === void 0 ? void 0 : role.role_name) || ""
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(IconSelectDown, {})
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(ui_select/* SelectContent */.Bw, {
                                    className: "p-1 rounded-[16px]",
                                    children: loadingGetRole ? /*#__PURE__*/ (0,jsx_runtime.jsx)(loading_btn/* LoadingBtnComponent */.n, {}) : OptionRole.map((item)=>{
                                        /*#__PURE__*/ return (0,jsx_runtime.jsx)(ui_select/* SelectItem */.Ql, {
                                            value: item === null || item === void 0 ? void 0 : item.role_id,
                                            "aria-expanded": true,
                                            className: "px-3 py-2 rounded-[8px] hover:!bg-bg-disable hover:!text-main-01 Nunito-500 focus:bg-bg-disable focus:text-main-01 dark:hover:!bg-[#F1F1FC]/[.1] dark:focus:!bg-[#F1F1FC]/[.1]",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "flex items-center",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                    children: item === null || item === void 0 ? void 0 : item.role_name
                                                })
                                            })
                                        }, item === null || item === void 0 ? void 0 : item.role_id);
                                    })
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                    className: "text-[12px] text-neutral-03 dark:text-neutral-06",
                    dangerouslySetInnerHTML: {
                        __html: t("giftcode.use_giftcode_desc")
                    }
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "flex items-center gap-[8px]",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(ui_button/* Button */.z, {
                            variant: "none",
                            className: "w-full h-[46px] text-base bg-bg-button text-neutral-05 Nunito-600 rounded-[16px] dark:text-main-white dark:bg-[#ECECEE1A]",
                            autoFocus: false,
                            onClick: ()=>{
                                setVisibleUseGiftcode(false);
                                setSelectedGiftcode({});
                                setGame({});
                                setUserID("");
                                setServer({});
                                setRole({});
                                setCode("");
                                GAEventsTracker("Giftcode_cancel");
                            },
                            children: t("common.cancel")
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(ui_button/* Button */.z, {
                            variant: "main",
                            disabled: !game || !userID || !(server === null || server === void 0 ? void 0 : server.server_id) || !(role === null || role === void 0 ? void 0 : role.role_id) || !code,
                            className: "w-full h-[46px] text-base Nunito-600 rounded-[16px]",
                            onClick: onUseGiftcode,
                            children: isPending ? /*#__PURE__*/ (0,jsx_runtime.jsx)(loading_btn/* LoadingBtnComponent */.n, {}) : t("reward.confirm")
                        })
                    ]
                })
            ]
        })
    });
};

;// CONCATENATED MODULE: ./app/containers/giftcode/modal/GiftcodeModalContainer.tsx



const GiftcodeModalContainer = ()=>{
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(GiftcodeDetailModal, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(UseGiftcodeModal, {})
        ]
    });
};

;// CONCATENATED MODULE: ./app/components/layout/ModalContainer.tsx







const ModalContainer = ()=>{
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(containers/* LoginModal */._A, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(containers/* SelectCreatePostModal */.Os, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(CommingSoonModal, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ModalEditHashtag, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ModalInviteCode, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(GiftcodeModalContainer, {})
        ]
    });
};

// EXTERNAL MODULE: ./app/components/icon-tsx/IconSearch.tsx
var IconSearch = __webpack_require__(85634);
// EXTERNAL MODULE: ./app/components/header/SelectTheme.tsx
var SelectTheme = __webpack_require__(75075);
// EXTERNAL MODULE: ./app/components/header/NotificationHeader.tsx + 1 modules
var NotificationHeader = __webpack_require__(34399);
// EXTERNAL MODULE: ./app/components/ui/dropdown-menu.tsx + 2 modules
var dropdown_menu = __webpack_require__(27357);
// EXTERNAL MODULE: ./app/components/icon-tsx/IconArrowDown.tsx
var IconArrowDown = __webpack_require__(79233);
// EXTERNAL MODULE: ./app/components/icon-tsx/IconLogout.tsx
var IconLogout = __webpack_require__(79766);
// EXTERNAL MODULE: ./app/components/icon-tsx/IconSetting.tsx
var IconSetting = __webpack_require__(34748);
// EXTERNAL MODULE: ./app/components/icon-tsx/IconHelpCenter.tsx
var IconHelpCenter = __webpack_require__(27459);
// EXTERNAL MODULE: ./app/containers/users/partner/PartnerTab.tsx + 18 modules
var PartnerTab = __webpack_require__(28911);
// EXTERNAL MODULE: ./app/components/app-avatar/OnlyShowAvatar.tsx
var OnlyShowAvatar = __webpack_require__(30897);
// EXTERNAL MODULE: ./app/components/icon-tsx/IconCart.tsx
var IconCart = __webpack_require__(26008);
;// CONCATENATED MODULE: ./app/components/header/AccountHeader.tsx



















const AccountHeader = ()=>{
    const router = (0,next_router.useRouter)();
    const { t  } = (0,esm/* useTranslation */.$G)();
    const [open, setOpen] = (0,react.useState)(false);
    const { userInfo , setUserInfo  } = (0,react.useContext)(context/* AppContext */.Il);
    const queryClient = (0,QueryClientProvider/* useQueryClient */.NL)();
    const avatarSrc = (userInfo === null || userInfo === void 0 ? void 0 : userInfo.small_avatar) ? userInfo === null || userInfo === void 0 ? void 0 : userInfo.small_avatar : (userInfo === null || userInfo === void 0 ? void 0 : userInfo.avatar) ? userInfo.avatar : "";
    const GAEventsTracker = (0,useGAEventsTracker/* default */.Z)("Profile");
    const GAEventsTrackerInventory = (0,useGAEventsTracker/* default */.Z)("Inventory");
    const GAEventsTrackerHelpCenter = (0,useGAEventsTracker/* default */.Z)("HelpCenter");
    const handleLogout = ()=>{
        setOpen(false);
        router.push("/");
        localStorage.removeItem("token");
        queryClient.removeQueries({
            queryKey: [
                configs/* QUERY_KEY.PROFILE_INFO */.lP.PROFILE_INFO
            ]
        });
        queryClient.clear();
        setUserInfo({});
    };
    const handleGoToInventory = ()=>{
        setOpen(false);
        router.push("/reward-center");
        GAEventsTrackerInventory("Inventory_view");
    };
    const handleGoTransaction = ()=>{
        setOpen(false);
        router.push("/user/".concat((userInfo === null || userInfo === void 0 ? void 0 : userInfo.alias) ? userInfo === null || userInfo === void 0 ? void 0 : userInfo.alias : userInfo === null || userInfo === void 0 ? void 0 : userInfo.userid, "?tab=transaction-manager"));
    };
    const handleGoToSetting = ()=>{
        setOpen(false);
        router.push({
            pathname: "/user/[id]",
            query: (userInfo === null || userInfo === void 0 ? void 0 : userInfo.authentic) ? {
                id: !!(userInfo === null || userInfo === void 0 ? void 0 : userInfo.alias) ? userInfo === null || userInfo === void 0 ? void 0 : userInfo.alias : userInfo === null || userInfo === void 0 ? void 0 : userInfo.userid,
                tab: PartnerTab/* ENUM_PARTNER_TAB.PARTNER_SETTING */.n.PARTNER_SETTING
            } : {
                id: !!(userInfo === null || userInfo === void 0 ? void 0 : userInfo.alias) ? userInfo === null || userInfo === void 0 ? void 0 : userInfo.alias : userInfo === null || userInfo === void 0 ? void 0 : userInfo.userid
            }
        });
    };
    const handleGoToHelpCenter = ()=>{
        GAEventsTrackerHelpCenter("Help_center_view_main");
        router.push("/help-center");
    };
    const listMenuItem = [
        {
            id: "setting",
            icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(IconSetting/* IconSetting */.k, {
                className: "w-[24px] h-[24px]"
            }),
            label: t("profile.setting"),
            function: handleGoToSetting
        },
        {
            id: "transaction_manage",
            icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(IconCart/* IconCart */.k, {
                className: "w-[24px] h-[24px]"
            }),
            label: t("profile.tab_transaction"),
            function: handleGoTransaction
        },
        {
            id: "inventory",
            icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(IconInventory/* IconInventory */.h, {
                className: "w-[24px] h-[24px]"
            }),
            label: t("common.inventory"),
            function: handleGoToInventory
        },
        {
            id: "help-center",
            icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(IconHelpCenter/* IconHelpCenter */.h, {
                className: "w-[24px] h-[24px]"
            }),
            label: t("common.help_center"),
            function: handleGoToHelpCenter
        },
        {
            id: "logout",
            icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(IconLogout/* IconLogout */.g, {
                className: "w-[24px] h-[24px]"
            }),
            label: t("common.logout"),
            function: handleLogout
        }
    ];
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(dropdown_menu/* DropdownMenu */.h_, {
            open: open,
            onOpenChange: ()=>{
                setOpen(false);
            },
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(dropdown_menu/* DropdownMenuTrigger */.$F, {
                    asChild: true,
                    onClick: ()=>{
                        setOpen(true);
                    },
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "cursor-pointer relative gap-[12px] items-center flex ",
                        title: userInfo.fullname,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(OnlyShowAvatar/* OnlyShowAvatar */.T, {
                                size: 40,
                                avatarUser: userInfo
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                className: "text-[16px] Nunito-700 text-bg-01 dark:text-main-white truncate ... max-w-[100px] hidden sd:block",
                                children: userInfo.fullname
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(IconArrowDown/* IconArrowDown */.B, {
                                className: "hidden sd:block"
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(dropdown_menu/* DropdownMenuContent */.AW, {
                    className: "w-[276px] shadow-[0_3px_30px_0_rgba(0,0,0,0.15)] rounded-[16px]",
                    align: "end",
                    children: [
                        react.Children.toArray(listMenuItem.map((item)=>/*#__PURE__*/ (0,jsx_runtime.jsxs)(dropdown_menu/* DropdownMenuItem */.Xi, {
                                onClick: item.function,
                                className: "flex items-center p-[16px] gap-[12px] w-full focus:bg-bg-disable dark:focus:bg-[#F1F1FC1A] rounded-[12px] active:bg-bg-disable dark:active:bg-[#F1F1FC1A] ",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "w-[40px] h-[40px] rounded-[12px] bg-button dark:bg-[rgba(239,239,255,0.10)] flex items-center justify-center",
                                        children: item.icon
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        className: "text-[14px] text-bg-01 Nunito-700 dark:text-white",
                                        children: item.label
                                    })
                                ]
                            }))),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "flex items-center justify-between w-full p-[16px] h-[56px]",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "flex items-center gap-3",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                            href: "/term-of-services",
                                            target: "_blank",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                className: "text-sm cursor-pointer Nunito-400 text-main-01",
                                                children: "Terms"
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "w-[1px] h-[12px] bg-main-01 "
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                            href: "/privacy-policy",
                                            target: "_blank",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                className: "text-sm cursor-pointer Nunito-400 text-main-01",
                                                children: "Privacy"
                                            })
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "flex items-center gap-1",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                            href: "https://www.facebook.com/PlayeeGamePortal",
                                            target: "_blank",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "w-[24px] h-[24px] flex items-center justify-center cursor-pointer",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
                                                    width: "16",
                                                    height: "16",
                                                    viewBox: "0 0 16 16",
                                                    fill: "none",
                                                    xmlns: "http://www.w3.org/2000/svg",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                        d: "M15.2008 8.04381C15.2008 4.04305 11.9772 0.799805 8.00078 0.799805C4.02433 0.799805 0.800781 4.04305 0.800781 8.04381C0.800781 11.6594 3.4337 14.6564 6.87578 15.1998V10.1378H5.04766V8.04381H6.87578V6.44786C6.87578 4.63233 7.95072 3.62949 9.59533 3.62949C10.3828 3.62949 11.207 3.77098 11.207 3.77098V5.55368H10.2992C9.40478 5.55368 9.12578 6.11212 9.12578 6.68556V8.04381H11.1227L10.8034 10.1378H9.12578V15.1998C12.5679 14.6564 15.2008 11.6594 15.2008 8.04381Z",
                                                        fill: "#7673E6"
                                                    })
                                                })
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                            href: "mailto:contact@playee.vn",
                                            target: "_blank",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "w-[24px] h-[24px] flex items-center justify-center cursor-pointer",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
                                                    width: "15",
                                                    height: "12",
                                                    viewBox: "0 0 15 12",
                                                    fill: "none",
                                                    xmlns: "http://www.w3.org/2000/svg",
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                            d: "M1.67167 11.2997H3.89514V5.89987L0.71875 3.51758V10.3468C0.71875 10.8741 1.14597 11.2997 1.67167 11.2997Z",
                                                            fill: "#7673E6"
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                            d: "M11.5195 11.2997H13.743C14.2703 11.2997 14.6959 10.8725 14.6959 10.3468V3.51758L11.5195 5.89987",
                                                            fill: "#7673E6"
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                            d: "M11.5195 1.77105V5.90036L14.6959 3.51806V2.24751C14.6959 1.06907 13.3507 0.397261 12.4089 1.10401",
                                                            fill: "#7673E6"
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                            d: "M3.89453 5.89981V1.77051L7.7062 4.62926L11.5179 1.77051V5.89981L7.7062 8.75856",
                                                            fill: "#7673E6"
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                            d: "M0.71875 2.24751V3.51806L3.89514 5.90036V1.77105L3.00575 1.10401C2.06236 0.397261 0.71875 1.06907 0.71875 2.24751Z",
                                                            fill: "#7673E6"
                                                        })
                                                    ]
                                                })
                                            })
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                })
            ]
        })
    });
};
/* harmony default export */ var header_AccountHeader = (/*#__PURE__*/(0,react.memo)(AccountHeader));

;// CONCATENATED MODULE: ./app/components/icon-tsx/IconCreatePost.tsx



const IconCreatePost = (param)=>{
    let { className , fill  } = param;
    const { themeApp  } = (0,react.useContext)(context/* AppContext */.Il);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "16",
        height: "16",
        viewBox: "0 0 16 16",
        fill: "none",
        className: className,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M10.8492 1.06424C11.6015 0.311921 12.8213 0.311921 13.5736 1.06424L14.9358 2.42642C15.6881 3.17874 15.6881 4.39848 14.9358 5.1508L13.728 6.35856C13.6332 6.31161 13.5334 6.26085 13.43 6.20639C12.7338 5.83988 11.9077 5.32547 11.2911 4.70891C10.6746 4.09235 10.1602 3.26621 9.79364 2.57002C9.73918 2.46658 9.6884 2.36681 9.64145 2.27199L10.8492 1.06424ZM10.4072 5.5928C11.1368 6.32239 12.0647 6.89662 12.7996 7.28701L8.05003 12.0365C7.7553 12.3313 7.37291 12.5225 6.96028 12.5814L4.09969 12.9901C3.464 13.0809 2.91913 12.536 3.00994 11.9003L3.41859 9.03972C3.47754 8.62708 3.66873 8.2447 3.96347 7.94997L8.713 3.20044C9.10339 3.93529 9.67762 4.86318 10.4072 5.5928ZM1.125 14.25C0.779822 14.25 0.5 14.5298 0.5 14.875C0.5 15.2202 0.779822 15.5 1.125 15.5H14.875C15.2202 15.5 15.5 15.2202 15.5 14.875C15.5 14.5298 15.2202 14.25 14.875 14.25H1.125Z",
            fill: fill ? fill : "#FAF8FF"
        })
    });
};

;// CONCATENATED MODULE: ./app/components/icon-tsx/IconGame.tsx



const IconGame = (param)=>{
    let { fill , className  } = param;
    const { themeApp  } = (0,react.useContext)(context/* AppContext */.Il);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "25",
        height: "24",
        viewBox: "0 0 25 24",
        fill: "none",
        className: className,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M10.2141 12.46L7.16406 15.51",
                stroke: fill ? fill : "#65676B",
                strokeWidth: "1.5",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M7.19531 12.49L10.2453 15.54",
                stroke: fill ? fill : "#65676B",
                strokeWidth: "1.5",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M14.1758 14H14.1858",
                stroke: fill ? fill : "#65676B",
                strokeWidth: "2",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M18.1133 14H18.1233",
                stroke: fill ? fill : "#65676B",
                strokeWidth: "2",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M16.1445 15.98V15.96",
                stroke: fill ? fill : "#65676B",
                strokeWidth: "2",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M16.1445 12.04V12.02",
                stroke: fill ? fill : "#65676B",
                strokeWidth: "2",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M15.6445 22C20.6445 22 22.6445 20 22.6445 15V13C22.6445 8 20.6445 6 15.6445 6H9.64453C4.64453 6 2.64453 8 2.64453 13V15C2.64453 20 4.64453 22 9.64453 22H15.6445Z",
                stroke: fill ? fill : "#65676B",
                strokeWidth: "1.5",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M13.655 2L13.645 3.01C13.635 3.56 13.195 4 12.645 4H12.615C12.065 4 11.625 4.45 11.625 5C11.625 5.55 12.075 6 12.625 6H13.625",
                stroke: fill ? fill : "#65676B",
                strokeWidth: "1.5",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            })
        ]
    });
};

;// CONCATENATED MODULE: ./app/components/icon-tsx/IconNews.tsx



const IconNews = (param)=>{
    let { fill , className  } = param;
    const { themeApp  } = (0,react.useContext)(context/* AppContext */.Il);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "25",
        height: "24",
        viewBox: "0 0 25 24",
        fill: "none",
        className: className,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            d: "M8.64453 6.25C8.23032 6.25 7.89453 6.58579 7.89453 7C7.89453 7.41421 8.23032 7.75 8.64453 7.75V6.25ZM16.6445 7.75C17.0587 7.75 17.3945 7.41421 17.3945 7C17.3945 6.58579 17.0587 6.25 16.6445 6.25V7.75ZM8.64453 10.25C8.23032 10.25 7.89453 10.5858 7.89453 11C7.89453 11.4142 8.23032 11.75 8.64453 11.75V10.25ZM12.6445 11.75C13.0587 11.75 13.3945 11.4142 13.3945 11C13.3945 10.5858 13.0587 10.25 12.6445 10.25V11.75ZM7.64453 16.75H20.6445V15.25H7.64453V16.75ZM17.6445 21.25H7.64453V22.75H17.6445V21.25ZM7.64453 21.25C6.40189 21.25 5.39453 20.2426 5.39453 19H3.89453C3.89453 21.0711 5.57346 22.75 7.64453 22.75V21.25ZM17.6445 22.75C19.7156 22.75 21.3945 21.0711 21.3945 19H19.8945C19.8945 20.2426 18.8872 21.25 17.6445 21.25V22.75ZM7.64453 15.25C5.57346 15.25 3.89453 16.9289 3.89453 19H5.39453C5.39453 17.7574 6.40189 16.75 7.64453 16.75V15.25ZM7.64453 2.75H17.6445V1.25H7.64453V2.75ZM19.8945 5V19H21.3945V5H19.8945ZM5.39453 19V5H3.89453V19H5.39453ZM17.6445 2.75C18.8872 2.75 19.8945 3.75736 19.8945 5H21.3945C21.3945 2.92893 19.7156 1.25 17.6445 1.25V2.75ZM7.64453 1.25C5.57346 1.25 3.89453 2.92893 3.89453 5H5.39453C5.39453 3.75736 6.40189 2.75 7.64453 2.75V1.25ZM8.64453 7.75H16.6445V6.25H8.64453V7.75ZM8.64453 11.75H12.6445V10.25H8.64453V11.75Z",
            fill: fill ? fill : "#65676B"
        })
    });
};

// EXTERNAL MODULE: ./app/components/icon-tsx/IconStore.tsx
var IconStore = __webpack_require__(73416);
;// CONCATENATED MODULE: ./app/components/icon-tsx/IconGameFill.tsx

const IconGameFill = (param)=>{
    let { fill , className  } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        className: className,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M16.65 5.71973H7.35C4.4 5.71973 2 8.11973 2 11.0697V16.6497C2 19.5997 4.4 21.9997 7.35 21.9997H16.65C19.6 21.9997 22 19.5997 22 16.6497V11.0697C22 8.11973 19.6 5.71973 16.65 5.71973ZM14.5 12.0197C14.5 11.4697 14.95 11.0197 15.5 11.0197C16.05 11.0197 16.5 11.4697 16.5 12.0197C16.5 12.5697 16.05 13.0297 15.5 13.0297C14.95 13.0297 14.5 12.5897 14.5 12.0397V12.0197ZM10.13 16.0697C9.98 16.2197 9.79 16.2897 9.6 16.2897C9.41 16.2897 9.22 16.2197 9.07 16.0697L8.04 15.0397L7.05 16.0297C6.9 16.1797 6.71 16.2497 6.52 16.2497C6.33 16.2497 6.14 16.1797 5.99 16.0297C5.7 15.7397 5.7 15.2597 5.99 14.9697L6.98 13.9797L6.02 13.0197C5.73 12.7297 5.73 12.2497 6.02 11.9597C6.31 11.6697 6.79 11.6697 7.08 11.9597L8.04 12.9197L9.03 11.9297C9.32 11.6397 9.8 11.6397 10.09 11.9297C10.38 12.2197 10.38 12.6997 10.09 12.9897L9.1 13.9797L10.13 15.0097C10.42 15.2997 10.42 15.7797 10.13 16.0697ZM13.54 14.9997C12.99 14.9997 12.53 14.5497 12.53 13.9997C12.53 13.4497 12.97 12.9997 13.52 12.9997H13.54C14.09 12.9997 14.54 13.4497 14.54 13.9997C14.54 14.5497 14.1 14.9997 13.54 14.9997ZM15.5 16.9697C14.95 16.9697 14.5 16.5297 14.5 15.9797V15.9597C14.5 15.4097 14.95 14.9597 15.5 14.9597C16.05 14.9597 16.5 15.4097 16.5 15.9597C16.5 16.5097 16.06 16.9697 15.5 16.9697ZM17.48 14.9997C16.93 14.9997 16.47 14.5497 16.47 13.9997C16.47 13.4497 16.91 12.9997 17.46 12.9997H17.48C18.03 12.9997 18.48 13.4497 18.48 13.9997C18.48 14.5497 18.04 14.9997 17.48 14.9997Z",
                fill: fill ? fill : "#7673E6"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M13.6399 2.71L13.6299 3.65C13.6199 4.53 12.8899 5.26 11.9999 5.26C11.8499 5.26 11.7599 5.36 11.7599 5.49C11.7599 5.62 11.8599 5.72 11.9899 5.72H10.3799C10.3699 5.65 10.3599 5.57 10.3599 5.49C10.3599 4.59 11.0899 3.86 11.9799 3.86C12.1299 3.86 12.2299 3.76 12.2299 3.63L12.2399 2.69C12.2499 2.31 12.5599 2 12.9399 2H12.9499C13.3399 2 13.6399 2.32 13.6399 2.71Z",
                fill: fill ? fill : "#7673E6"
            })
        ]
    });
};

;// CONCATENATED MODULE: ./app/components/icon-tsx/IconNewsFill.tsx

const IconNewsFill = (param)=>{
    let { fill , className  } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        className: className,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M17 2H7C5.34315 2 4 3.34315 4 5V15.6458C4.79613 14.9333 5.84747 14.5 7 14.5H20V5C20 3.34315 18.6569 2 17 2ZM8 5.25C7.58579 5.25 7.25 5.58579 7.25 6C7.25 6.41421 7.58579 6.75 8 6.75H16C16.4142 6.75 16.75 6.41421 16.75 6C16.75 5.58579 16.4142 5.25 16 5.25H8ZM7.25 10C7.25 9.58579 7.58579 9.25 8 9.25H12C12.4142 9.25 12.75 9.58579 12.75 10C12.75 10.4142 12.4142 10.75 12 10.75H8C7.58579 10.75 7.25 10.4142 7.25 10ZM7 16H20V19C20 20.6569 18.6569 22 17 22H7C5.34315 22 4 20.6569 4 19C4 17.3431 5.34315 16 7 16Z",
            fill: fill ? fill : "#7673E6"
        })
    });
};

;// CONCATENATED MODULE: ./app/components/icon-tsx/IconStoreFill.tsx

const IconStoreFill = (param)=>{
    let { fill , className  } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "21",
        height: "20",
        viewBox: "0 0 21 20",
        fill: "none",
        className: className,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M20.5 4V6.25C20.5 8.32107 19.0076 10 17.1667 10C15.3257 10 13.8333 8.32107 13.8333 6.25C13.8333 8.32107 12.3409 10 10.5 10C8.65905 10 7.16667 8.32107 7.16667 6.25C7.16667 8.32107 5.67428 10 3.83333 10C1.99238 10 0.5 8.32107 0.5 6.25V4C0.5 1.79086 2.29086 0 4.5 0H16.5C18.7091 0 20.5 1.79086 20.5 4ZM17.1667 11.4999C15.8295 11.4999 14.6772 10.9373 13.8333 10.0559C12.9895 10.9373 11.8371 11.4999 10.5 11.4999C9.16288 11.4999 8.01049 10.9373 7.16667 10.0559C6.32285 10.9373 5.17046 11.4999 3.83333 11.4999C2.96672 11.4999 2.1777 11.2636 1.5 10.8573V15.9999C1.5 18.2091 3.29086 19.9999 5.5 19.9999H15.5C17.7091 19.9999 19.5 18.2091 19.5 15.9999V10.8573C18.8223 11.2636 18.0333 11.4999 17.1667 11.4999ZM14.1533 15.6317C14.3567 15.9925 14.2292 16.4499 13.8683 16.6533C12.6532 17.3384 11.6065 17.7479 10.5028 17.75C9.39781 17.7521 8.3491 17.3459 7.12915 16.6519C6.76912 16.4471 6.64329 15.9892 6.8481 15.6292C7.05292 15.2691 7.51082 15.1433 7.87085 15.3481C9.00705 15.9945 9.78212 16.2514 10.4999 16.25C11.2191 16.2486 11.9944 15.9879 13.1317 15.3467C13.4925 15.1433 13.9499 15.2708 14.1533 15.6317Z",
            fill: fill ? fill : "#7673E6"
        })
    });
};

;// CONCATENATED MODULE: ./app/components/header/MenuBar.tsx













const MenuBar = ()=>{
    const { t  } = (0,esm/* useTranslation */.$G)();
    const router = (0,next_router.useRouter)();
    const { themeApp  } = (0,react.useContext)(context/* AppContext */.Il);
    const [curTab, setCurTab] = (0,react.useState)(router.pathname);
    const GAEventsTracker = (0,useGAEventsTracker/* default */.Z)("Store");
    const GAEventsTrackerGame = (0,useGAEventsTracker/* default */.Z)("Game");
    const GAEventsTrackerNews = (0,useGAEventsTracker/* default */.Z)("News");
    const listTab = [
        {
            icon: curTab === configs/* MENU_TAB.STORE_TAB */.rK.STORE_TAB ? /*#__PURE__*/ (0,jsx_runtime.jsx)(IconStoreFill, {
                fill: themeApp === "dark" ? "#FAF8FF" : ""
            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(IconStore/* IconStore */.k, {
                fill: themeApp === "dark" ? "#FAF8FF" : "",
                className: "icon-stroke"
            }),
            title: t("common.side_bar_store"),
            path: configs/* MENU_TAB.STORE_TAB */.rK.STORE_TAB
        },
        {
            icon: curTab === configs/* MENU_TAB.GAME_TAB */.rK.GAME_TAB ? /*#__PURE__*/ (0,jsx_runtime.jsx)(IconGameFill, {
                fill: themeApp === "dark" ? "#FAF8FF" : ""
            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(IconGame, {
                fill: themeApp === "dark" ? "#FAF8FF" : "",
                className: "icon-stroke"
            }),
            title: t("common.game_tab_title"),
            path: configs/* MENU_TAB.GAME_TAB */.rK.GAME_TAB
        },
        {
            icon: curTab === configs/* MENU_TAB.NEWS_TAB */.rK.NEWS_TAB ? /*#__PURE__*/ (0,jsx_runtime.jsx)(IconNewsFill, {
                fill: themeApp === "dark" ? "#FAF8FF" : ""
            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(IconNews, {
                fill: themeApp === "dark" ? "#FAF8FF" : "",
                className: "icon-fill"
            }),
            title: t("common.news_tab_title"),
            path: configs/* MENU_TAB.NEWS_TAB */.rK.NEWS_TAB
        }
    ];
    const activeTab = listTab.find((tab)=>tab.path === curTab);
    (0,react.useEffect)(()=>{
        setCurTab(router.pathname);
    }, [
        router
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("ul", {
        className: "md:flex items-center m-auto gap-[8px] text-main-01 hidden relative",
        children: [
            listTab.map((menuItem, index)=>{
                return /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                    className: "sidebar_link cursor-pointer opacity-1 "// "hover:bg-button dark:hover:bg-main-01"
                    .concat(curTab == menuItem.path ? "sidebar_link--active Nunito-600 opacity-0" : ""),
                    onClick: ()=>{
                        if (menuItem.path === configs/* MENU_TAB.STORE_TAB */.rK.STORE_TAB) {
                            GAEventsTracker("Click_Store_Tab");
                        }
                        if (menuItem.path === configs/* MENU_TAB.GAME_TAB */.rK.GAME_TAB) {
                            GAEventsTrackerGame("Click_Games_Tab");
                        }
                        if (menuItem.path === configs/* MENU_TAB.NEWS_TAB */.rK.NEWS_TAB) {
                            GAEventsTrackerNews("Click_Games_Tab");
                        }
                        setCurTab(menuItem.path);
                        router.push(menuItem.path);
                    },
                    style: {
                        zIndex: 2
                    },
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "flex items-center w-fit gap-[8px]",
                        children: [
                            menuItem.icon,
                            " "
                        ]
                    })
                }, index);
            }),
            activeTab && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                id: "overlay",
                className: "navigation-tab-overlay z-1 flex items-center justify-center ".concat(curTab === configs/* MENU_TAB.STORE_TAB */.rK.STORE_TAB ? "left-0" : curTab === configs/* MENU_TAB.GAME_TAB */.rK.GAME_TAB ? "left-[63px]" : "left-[126px]"),
                style: {
                    zIndex: 1
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "flex items-center w-fit gap-[8px]",
                    children: [
                        activeTab === null || activeTab === void 0 ? void 0 : activeTab.icon,
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                            className: "whitespace-nowrap text-main-01 text-[14px] transition duration-500 linear lg:text-[16px] dark:text-main-white Nunito-600",
                            children: activeTab === null || activeTab === void 0 ? void 0 : activeTab.title
                        })
                    ]
                })
            })
        ]
    });
};

// EXTERNAL MODULE: ./public/img/playee_full_text.png
var playee_full_text = __webpack_require__(89038);
// EXTERNAL MODULE: ./public/img/playee_full_text_dark.png
var playee_full_text_dark = __webpack_require__(74050);
;// CONCATENATED MODULE: ./app/components/header/index.tsx
















const Header = (param)=>{
    let { expandHeader  } = param;
    const { t  } = (0,esm/* useTranslation */.$G)();
    const router = (0,next_router.useRouter)();
    const { themeApp , setOpenModal  } = (0,react.useContext)(context/* AppContext */.Il);
    const [isLogin, setIsLogin] = (0,react.useState)(false);
    const token = configs/* isClient */.C5 ? window.localStorage.getItem("token") : null;
    const [expand, setExpand] = (0,react.useState)(false);
    const [showCreate, setShowCreate] = (0,react.useState)(false);
    const [hoverIcon, setHoverIcon] = (0,react.useState)(false);
    (0,react.useEffect)(()=>{
        if (!!token) {
            setIsLogin(true);
        } else {
            setIsLogin(false);
        }
    }, [
        token
    ]);
    const { userInfo  } = (0,react.useContext)(context/* AppContext */.Il);
    const changeBackground = ()=>{
        if (window.scrollY >= 200) {
            setExpand(true);
        } else {
            setExpand(false);
        }
    };
    const onNavigateCreate = (0,react.useCallback)((type)=>{
        router.push("/create-post?type=".concat(type));
    }, [
        router
    ]);
    (0,react.useEffect)(()=>{
        if (expandHeader) {
            changeBackground();
            // adding the event when scroll change Logo
            window.addEventListener("scroll", changeBackground);
        }
        return ()=>{
            window.removeEventListener("scroll", changeBackground);
        };
    }, [
        expandHeader
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "w-full fixed top-0 z-[40] md:h-[84px] sm:h-[72px] h-[60px] transition duration-500 ".concat(expandHeader ? !expand ? "-translate-y-[84px]" : "translate-y-0" : ""),
        style: {
            boxShadow: "4px 4px 15px 0px rgba(0, 0, 0, 0.04)",
            background: "var(--bg-header)"
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("header", {
            className: "sm:px-[32px] px-[16px] flex items-center justify-between h-full xs:pr-[24px]",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    id: "header-left-side",
                    className: "flex items-center md:max-w-[150px] lg:max-w-[372px] w-full justify-between",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                            width: 142,
                            height: 49,
                            src: themeApp === "dark" ? playee_full_text_dark/* default.src */.Z.src : playee_full_text/* default.src */.Z.src,
                            className: "lg:w-[142px] lg:h-[49px] md:w-[100px] md:h-[34px] w-[105px] h-[38px] cursor-pointer",
                            alt: "logo",
                            onClick: ()=>router.push("/")
                        }),
                        !!(userInfo === null || userInfo === void 0 ? void 0 : userInfo.authentic) && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "lg:h-[56px] h-[32px] lg:px-[12px] lg:py-[10px] rounded-[16px] md:flex gap-[16px] lg:bg-main-white dark:lg:bg-bg-button-2 cursor-pointer items-center hidden opacity-100 active:opacity-60",
                            onClick: ()=>onNavigateCreate(configs/* CreateType.CREATE_POST */.q0.CREATE_POST),
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "bg-main-01 px-[16px] h-full rounded-[12px] flex",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(IconCreatePost, {
                                        className: "m-auto"
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                    className: "text-main-01 text-[16px] Nunito-600 hidden lg:block dark:text-main-white",
                                    children: t("common.create_post")
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    id: "header-center-side",
                    className: "flex flex-1 w-full",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(MenuBar, {})
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    id: "header-right-side",
                    className: "flex items-center md:gap-[24px] md:max-w-[150px] sd:max-w-[372px] w-full justify-end",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(IconSearch/* IconSearch */.j, {
                            onClick: ()=>router.push("/search"),
                            className: "cursor-pointer"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "hidden lg:inline-block",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SelectTheme/* SelectTheme */.n, {})
                        }),
                        !!isLogin ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(NotificationHeader/* default */.Z, {}),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "hidden md:flex",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(header_AccountHeader, {})
                                })
                            ]
                        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(ui_button/* Button */.z, {
                            variant: "light",
                            className: "lg:w-[150px] lg:h-[52px] hidden md:block md:text-[14px] lg:text-[16px] dark:bg-bg-button-2 h-[38px] w-[140px]",
                            onClick: ()=>setOpenModal(configs/* OPEN_MODAL.LOGIN_MODAL */.a6.LOGIN_MODAL),
                            children: t("common.login")
                        })
                    ]
                })
            ]
        })
    });
};

;// CONCATENATED MODULE: ./app/components/icon-tsx/IconHamburger.tsx


const IconHamburger = (param)=>{
    let { fill , className  } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        className: className,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M21 7.75H3C2.59 7.75 2.25 7.41 2.25 7C2.25 6.59 2.59 6.25 3 6.25H21C21.41 6.25 21.75 6.59 21.75 7C21.75 7.41 21.41 7.75 21 7.75Z",
                fill: fill ? fill : "#65676B"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M21 12.75H3C2.59 12.75 2.25 12.41 2.25 12C2.25 11.59 2.59 11.25 3 11.25H21C21.41 11.25 21.75 11.59 21.75 12C21.75 12.41 21.41 12.75 21 12.75Z",
                fill: fill ? fill : "#65676B"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M21 17.75H3C2.59 17.75 2.25 17.41 2.25 17C2.25 16.59 2.59 16.25 3 16.25H21C21.41 16.25 21.75 16.59 21.75 17C21.75 17.41 21.41 17.75 21 17.75Z",
                fill: fill ? fill : "#65676B"
            })
        ]
    });
};

;// CONCATENATED MODULE: ./app/components/layout/SideBarMobile.tsx















const SideBarMobile = ()=>{
    var _ref, _ref1;
    const { t  } = (0,esm/* useTranslation */.$G)();
    const router = (0,next_router.useRouter)();
    const { userInfo , setOpenModal  } = (0,react.useContext)(context/* AppContext */.Il);
    const [isLogin, setIsLogin] = (0,react.useState)(false);
    const { themeApp  } = (0,react.useContext)(context/* AppContext */.Il);
    const GAEventsTracker = (0,useGAEventsTracker/* default */.Z)("Store");
    const GAEventsTrackerGame = (0,useGAEventsTracker/* default */.Z)("Game");
    const GAEventsTrackerNews = (0,useGAEventsTracker/* default */.Z)("News");
    const token = configs/* isClient */.C5 ? window.localStorage.getItem("token") : null;
    (0,react.useEffect)(()=>{
        if (!!token) {
            setIsLogin(true);
        } else {
            setIsLogin(false);
        }
    }, [
        token
    ]);
    const listTab = [
        {
            icon: router.pathname === configs/* MENU_TAB.STORE_TAB */.rK.STORE_TAB ? /*#__PURE__*/ (0,jsx_runtime.jsx)(IconStoreFill, {
                fill: themeApp === "dark" ? "#FAF8FF" : ""
            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(IconStore/* IconStore */.k, {
                fill: themeApp === "dark" ? "#FAF8FF" : "",
                className: "icon-stroke"
            }),
            title: t("common.side_bar_store"),
            path: configs/* MENU_TAB.STORE_TAB */.rK.STORE_TAB
        },
        {
            icon: router.pathname === configs/* MENU_TAB.GAME_TAB */.rK.GAME_TAB ? /*#__PURE__*/ (0,jsx_runtime.jsx)(IconGameFill, {
                fill: themeApp === "dark" ? "#FAF8FF" : ""
            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(IconGame, {
                fill: themeApp === "dark" ? "#FAF8FF" : "",
                className: "icon-stroke"
            }),
            title: t("common.game_tab_title"),
            path: configs/* MENU_TAB.GAME_TAB */.rK.GAME_TAB
        },
        {
            icon: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "w-[54px] h-[40px] rounded-[50px] bg-main-01 flex items-center justify-center -translate-y-[20px]",
                style: {
                    boxShadow: "0px 4px 20px 0px rgba(118, 115, 229, 0.40)"
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
                    xmlns: "http://www.w3.org/2000/svg",
                    width: "24",
                    height: "24",
                    viewBox: "0 0 24 24",
                    fill: "none",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M12 6V18M18 12L6 12",
                        stroke: "#FAF8FF",
                        strokeWidth: "1.5",
                        strokeLinecap: "round",
                        strokeLinejoin: "round"
                    })
                })
            }),
            action: true,
            title: "",
            path: configs/* MENU_TAB.SELECT_CREATE_POST */.rK.SELECT_CREATE_POST
        },
        {
            icon: router.pathname === configs/* MENU_TAB.NEWS_TAB */.rK.NEWS_TAB ? /*#__PURE__*/ (0,jsx_runtime.jsx)(IconNewsFill, {
                fill: themeApp === "dark" ? "#FAF8FF" : ""
            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(IconNews, {
                fill: themeApp === "dark" ? "#FAF8FF" : "",
                className: "icon-fill"
            }),
            title: t("common.news_tab_title"),
            path: configs/* MENU_TAB.NEWS_TAB */.rK.NEWS_TAB
        }
    ];
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "fixed md:hidden bottom-0 left-0 z-[30] bg-white flex items-center h-[64px] w-full pb-[12px] px-[24px] dark:bg-mobile-bg",
        style: {
            boxShadow: "0px 3px 30px 0px rgba(0, 0, 0, 0.15)"
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("ul", {
            className: "list-none w-full justiy-evenly flex flex-start Nunito-600 text-[14px] h-full items-center",
            children: [
                listTab.map((menuItem, index)=>{
                    if (menuItem.path === configs/* MENU_TAB.SELECT_CREATE_POST */.rK.SELECT_CREATE_POST) {
                        if (!(userInfo === null || userInfo === void 0 ? void 0 : userInfo.authentic)) {
                            return null;
                        } else {
                            return /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                className: "sidebar_link w-full justify-center h-full ".concat(router.pathname == menuItem.path ? "border-t-[2px] border-main-01 sidebar_link--active" : "border-t-[2px] border-white dark:border-mobile-bg"),
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "flex items-center justify-center",
                                    onClick: ()=>router.push("/create-post?type=".concat(configs/* CreateType.CREATE_POST */.q0.CREATE_POST)),
                                    children: menuItem.icon
                                })
                            }, index);
                        }
                    } else return /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                        className: "sidebar_link w-full justify-center h-full ".concat(router.pathname == menuItem.path ? "border-t-[2px] border-main-01 sidebar_link--active" : "border-t-[2px] border-white dark:border-mobile-bg"),
                        onClick: ()=>{
                            if (menuItem.path === configs/* MENU_TAB.STORE_TAB */.rK.STORE_TAB) {
                                GAEventsTracker("Click_Store_Tab");
                            }
                            if (menuItem.path === configs/* MENU_TAB.GAME_TAB */.rK.GAME_TAB) {
                                GAEventsTrackerGame("Click_Games_Tab");
                            }
                            if (menuItem.path === configs/* MENU_TAB.NEWS_TAB */.rK.NEWS_TAB) {
                                GAEventsTrackerNews("Click_Games_Tab");
                            }
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                            className: "flex items-center justify-center",
                            href: menuItem.path,
                            children: menuItem.icon
                        })
                    }, index);
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                    className: "sidebar_link w-full justify-center h-full ".concat(((_ref = [
                        configs/* MENU_TAB.OPTION_PROFILE */.rK.OPTION_PROFILE,
                        configs/* MENU_TAB.USER */.rK.USER
                    ]) === null || _ref === void 0 ? void 0 : _ref.includes(router.pathname)) ? "border-t-[2px] border-main-01 sidebar_link--active" : "border-t-[2px] border-white dark:border-mobile-bg"),
                    children: isLogin ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "flex items-center justify-center",
                        onClick: ()=>router.push(configs/* MENU_TAB.OPTION_PROFILE */.rK.OPTION_PROFILE),
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(IconHamburger, {
                            fill: ((_ref1 = [
                                configs/* MENU_TAB.OPTION_PROFILE */.rK.OPTION_PROFILE,
                                configs/* MENU_TAB.USER */.rK.USER
                            ]) === null || _ref1 === void 0 ? void 0 : _ref1.includes(router.pathname)) ? "#7673E5" : themeApp === "dark" ? "#FAF8FF" : ""
                        })
                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        onClick: ()=>setOpenModal(configs/* OPEN_MODAL.LOGIN_MODAL */.a6.LOGIN_MODAL),
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(IconHamburger, {
                            fill: router.pathname === configs/* MENU_TAB.NEWS_TAB */.rK.NEWS_TAB ? "#7673E5" : themeApp === "dark" ? "#FAF8FF" : ""
                        })
                    })
                })
            ]
        })
    });
};

;// CONCATENATED MODULE: ./app/components/scroll-to-top/ScrollToTop.tsx



const ScrollToTop = ()=>{
    const [isVisible, setIsVisible] = (0,react.useState)(false);
    const { themeApp  } = (0,react.useContext)(context/* AppContext */.Il);
    const onScrollToTop = ()=>{
        if (true) {
            window.scroll({
                top: 0,
                left: 0,
                behavior: "smooth"
            });
        }
    };
    const handleScroll = ()=>{
        if (window.pageYOffset > 200) {
            setIsVisible(true);
        } else {
            setIsVisible(false);
        }
    };
    (0,react.useEffect)(()=>{
        window.addEventListener("scroll", handleScroll);
        return ()=>{
            window.removeEventListener("scroll", handleScroll);
        };
    }, []);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: isVisible && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "fixed bottom-[80px] md:bottom-[64px] right-[12px] md:right-[48px] opacity-100 hover:opacity-60 active:opacity-60 flex items-center justify-center bg-bg-button min-w-[24px] md:min-w-[40px] lg:min-w-[52px] border border-black/10 dark:border-0 aspect-square rounded-[12px] cursor-pointer z-50 dark:bg-[rgba(236,236,238,0.1)]",
            onClick: onScrollToTop,
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
                width: "28",
                height: "28",
                viewBox: "0 0 28 28",
                fill: "none",
                xmlns: "http://www.w3.org/2000/svg",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                    d: "M19.832 16.3333L13.9987 11.6666L8.16536 16.3333",
                    stroke: themeApp === "dark" ? "#fff" : "#706E7E",
                    strokeWidth: "1.5",
                    strokeLinecap: "round",
                    strokeLinejoin: "round"
                })
            })
        })
    });
};

;// CONCATENATED MODULE: ./public/img/logo_btc.png
/* harmony default export */ var logo_btc = ({"src":"/_next/static/media/logo_btc.fab00f88.png","height":113,"width":300,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAADCAYAAACuyE5IAAAAbklEQVR4nAFjAJz/Ac7c7ZPT4vNsKhsMnajK6b0OCAMLDwkD/vD2/QD4/P79AbbM5v+00+4AVTIUAMzh8wD3/P8ADwgDAPz+/wDx9/wAAdzl8qD1+fxf7vP6q4TB6MMUCAMK6Pf8/hcIAwD3/P/95Ek5fN9QKMQAAAAASUVORK5CYII=","blurWidth":8,"blurHeight":3});
;// CONCATENATED MODULE: ./app/components/footer/Footer.tsx











const Footer = ()=>{
    const { themeApp  } = (0,react.useContext)(context/* AppContext */.Il);
    const { t  } = (0,esm/* useTranslation */.$G)();
    const router = (0,next_router.useRouter)();
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "hidden sm:block w-full bg-[#F9F9F9] dark:bg-[#1A1925] border-t-[1px] border-black/10 dark:border-neutral-03",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "flex justify-center w-full py-[24px] border-b-[1px] border-black/10 dark:border-neutral-03",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "w-full pc:w-[1280px]",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "flex items-center justify-center w-full pc:justify-start gap-[20px]",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                    width: 145,
                                    height: 62,
                                    alt: "Playee logo",
                                    src: themeApp === "dark" ? playee_full_text_dark/* default.src */.Z.src : playee_full_text/* default.src */.Z.src,
                                    className: "w-[120px] h-[51px] pc:w-[145px] pc:h-[62px] object-contain"
                                }),
                                router.pathname.includes("merchandise") && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "flex pc:hidden",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                        href: "http://online.gov.vn/Home/WebDetails/115905",
                                        target: "_blank",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                            width: 100,
                                            height: 37,
                                            alt: "Merchandise Playee",
                                            src: logo_btc.src,
                                            className: "w-[100px] h-[37px] object-contain max-w-[100px] max-h-[37px]"
                                        })
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "flex flex-col pc:flex-row w-full mt-[24px] pc:mt-[32px] justify-between gap-[24px]",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "w-full pc:w-[627px] space-y-[8px] pc:space-y-[16px]",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                            className: "text-base text-center Nunito-700 text-bg-01 dark:text-main-white pc:text-start",
                                            children: t("footer.company_name")
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: "flex flex-col",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                    className: "text-sm text-center text-neutral dark:text-neutral-08 Nunito-400 pc:text-start",
                                                    children: t("footer.mst")
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                    className: "text-sm text-center text-neutral dark:text-neutral-08 Nunito-400 pc:text-start",
                                                    children: t("footer.issued_by")
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: "flex items-center justify-center gap-2 pc:justify-start",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
                                                    width: "16",
                                                    height: "17",
                                                    viewBox: "0 0 16 17",
                                                    fill: "none",
                                                    xmlns: "http://www.w3.org/2000/svg",
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                            d: "M14 7.75893C14 11.0317 10.25 15.1663 8 15.1663C5.75 15.1663 2 11.0317 2 7.75893C2 4.48614 4.68629 1.83301 8 1.83301C11.3137 1.83301 14 4.48614 14 7.75893Z",
                                                            stroke: "#7673E6"
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                            d: "M10 7.83301C10 8.93758 9.10457 9.83301 8 9.83301C6.89543 9.83301 6 8.93758 6 7.83301C6 6.72844 6.89543 5.83301 8 5.83301C9.10457 5.83301 10 6.72844 10 7.83301Z",
                                                            stroke: "#7673E6"
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                    className: "text-sm text-neutral dark:text-neutral-08 Nunito-400",
                                                    children: t("footer.address")
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: "flex items-center justify-center gap-2 pc:justify-start",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
                                                    width: "16",
                                                    height: "17",
                                                    viewBox: "0 0 16 17",
                                                    fill: "none",
                                                    xmlns: "http://www.w3.org/2000/svg",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                        d: "M14 13.1667V12.0694C14 11.5242 13.6681 11.0339 13.1619 10.8314L11.8058 10.289C11.1619 10.0314 10.4281 10.3104 10.118 10.9307L10 11.1667C10 11.1667 8.33333 10.8333 7 9.5C5.66667 8.16667 5.33333 6.5 5.33333 6.5L5.56934 6.38199C6.18959 6.07187 6.46857 5.33809 6.21103 4.69424L5.66859 3.33815C5.46611 2.83194 4.97583 2.5 4.43062 2.5H3.33333C2.59695 2.5 2 3.09695 2 3.83333C2 9.72437 6.77563 14.5 12.6667 14.5C13.403 14.5 14 13.903 14 13.1667Z",
                                                        stroke: "#7673E6",
                                                        strokeLinejoin: "round"
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                    className: "text-sm text-neutral dark:text-neutral-08 Nunito-400",
                                                    children: t("footer.phone")
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "w-full pc:w-[519px] flex flex-col pc:flex-row items-center pc:items-start justify-between gap-[12px]",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("ul", {
                                            className: "flex flex-row pc:flex-col gap-[24px] pc:gap-[16px]",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                    className: "text-sm Nunito-400 text-bg-01 dark:text-main-white tracking-[0.56px] opacity-100 active:opacity-60",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                        href: "/term-of-services",
                                                        target: "_blank",
                                                        children: t("footer.thoa_thuan_cung_cap")
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                    className: "text-sm Nunito-400 text-bg-01 dark:text-main-white tracking-[0.56px] opacity-100 active:opacity-60",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                        href: "/privacy-policy",
                                                        target: "_blank",
                                                        children: t("footer.privacy")
                                                    })
                                                }),
                                                router.pathname.includes("merchandise") && /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                    className: "hidden mt-2 pc:flex",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                        href: "http://online.gov.vn/Home/WebDetails/115905",
                                                        target: "_blank",
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                            src: logo_btc.src,
                                                            className: "w-[124px] h-[46px] object-contain max-w-[124px] max-h-[46px]"
                                                        })
                                                    })
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("ul", {
                                            className: "flex flex-row pc:flex-col gap-[24px] pc:gap-[16px]",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                    className: "text-sm Nunito-400 text-bg-01 dark:text-main-white tracking-[0.56px] opacity-100 active:opacity-60",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                        href: "/phuong-thuc-thanh-toan",
                                                        target: "_blank",
                                                        children: t("footer.phuong_thuc_thanh_toan")
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                    className: "text-sm Nunito-400 text-bg-01 dark:text-main-white tracking-[0.56px] opacity-100 active:opacity-60",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                        href: "/chinh-sach-mua-hang",
                                                        target: "_blank",
                                                        children: t("footer.chinh_sach_mua_hang")
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                    className: "text-sm Nunito-400 text-bg-01 dark:text-main-white tracking-[0.56px] opacity-100 active:opacity-60",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                        href: "/chinh-sach-giao-hang",
                                                        target: "_blank",
                                                        children: t("footer.chinh_sach_giao_hang")
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                    className: "text-sm Nunito-400 text-bg-01 dark:text-main-white tracking-[0.56px] opacity-100 active:opacity-60",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                        href: "/chinh-sach-doi-tra",
                                                        target: "_blank",
                                                        children: t("footer.chinh_sach_doi_tra")
                                                    })
                                                })
                                            ]
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "flex justify-center p-[8px]",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "flex items-center gap-[12px]",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                            className: "text-sm Nunito-400 text-neutral-06 dark:text-neutral-08 leading-[20px]",
                            children: "Copyright \xa9 2023 Playee Game Portal"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "w-[1px] h-[10px] bg-neutral-06"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                            href: "https://www.facebook.com/PlayeeGamePortal",
                            target: "_blank",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ui_button/* Button */.z, {
                                variant: "none",
                                className: "p-0 text-sm text-main-01 Nunito-400 h-[20px] active:text-main-disable",
                                children: "Facebook"
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "w-[1px] h-[10px] bg-neutral-06"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                            href: "mailto:contact@playee.vn",
                            target: "_blank",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ui_button/* Button */.z, {
                                variant: "none",
                                className: "p-0 text-sm text-main-01 Nunito-400 h-[20px] active:text-main-disable",
                                children: "contact@playee.vn"
                            })
                        })
                    ]
                })
            })
        ]
    });
};

;// CONCATENATED MODULE: ./app/hooks/useAxiosInterceptor.tsx




const useAxiosInterceptors = ($http)=>{
    const { setOpenModal  } = (0,react.useContext)(context/* AppContext */.Il);
    $http.interceptors.request.use((config)=>{
        config.params = config.params || {};
        config.params["lang"] = esm/* i18n */.ag === null || esm/* i18n */.ag === void 0 ? void 0 : esm/* i18n.language */.ag.language;
        if (configs/* isClient */.C5 && config.headers) {
            const token = localStorage.getItem("token");
            if (!!token) {
                config.headers["Game-Portal-Auth"] = "Bear ".concat(token);
            }
        }
        return config;
    });
    $http.interceptors.response.use((response)=>{
        if (response && response.request && response.request.responseURL && !response.request.responseURL.endsWith("/api/users/login") && response.data.errorCode === 1) {
            if (configs/* isClient */.C5) {
            //   do something with the error
            }
            return Promise.reject(response);
        } else if (response.data && response.data.errorCode !== 0) {
            // do something with the error
            return Promise.reject(response);
        }
        return response;
    }, (error)=>{
        if (configs/* isClient */.C5) {
            if (error.response && error.response.status === 401) {
                localStorage.removeItem("token");
                setOpenModal(configs/* OPEN_MODAL.LOGIN_MODAL */.a6.LOGIN_MODAL);
            } else if (error.data && error.data.errorCode === 1) {
            // do something with the error
            } else {
                return Promise.reject(error);
            }
            return Promise.reject();
        }
        return Promise.reject(error);
    });
};
/* harmony default export */ var useAxiosInterceptor = (useAxiosInterceptors);

// EXTERNAL MODULE: ./app/api/index.ts
var api = __webpack_require__(34224);
// EXTERNAL MODULE: ./node_modules/styled-jsx/style.js
var style = __webpack_require__(7928);
var style_default = /*#__PURE__*/__webpack_require__.n(style);
// EXTERNAL MODULE: ./node_modules/next/script.js
var script = __webpack_require__(4298);
var script_default = /*#__PURE__*/__webpack_require__.n(script);
;// CONCATENATED MODULE: ./app/components/layout/ThoThanChatbot.tsx




const ThothanChatbot = (param)=>{
    let { userName ="" , userToken =""  } = param;
    const [isClient, setIsClient] = (0,react.useState)(false);
    (0,react.useEffect)(()=>{
        setIsClient(true);
        // Initialize global config object
        if (true) {
            window.thothanChatbotConfig = {
                token: "vmqV1XL3pJXffnaT",
                baseUrl: "https://platform.thothan.ai",
                inputs: {
                    userToken: userToken,
                    userName: userName,
                    isDev: true
                }
            };
        }
    }, [
        userName,
        userToken
    ]);
    if (!isClient) return null;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        id: "thothan-chatbot-container",
        className: "jsx-42b496699448e816",
        children: [
            (0,jsx_runtime.jsx)((style_default()), {
                id: "42b496699448e816",
                children: "#thothan-chatbot-bubble-button{background-color:#1c64f2!important;z-index:1000}"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)((script_default()), {
                id: "vmqV1XL3pJXffnaT",
                src: "https://platform.thothan.ai/embed.min.js",
                onLoad: ()=>{
                    console.log("Chatbot script loaded successfully");
                },
                onError: (e)=>{
                    console.error("Error loading chatbot script:", e);
                }
            })
        ]
    });
};
/* harmony default export */ var ThoThanChatbot = (ThothanChatbot);

;// CONCATENATED MODULE: ./app/components/create-ticket-area/index.tsx




const CreateTicketArea = ()=>{
    const { t  } = (0,esm/* useTranslation */.$G)();
    const router = (0,next_router.useRouter)();
    const onNavigate = ()=>{
        router.push("/help-center/submit-ticket");
    };
    if ([
        "/help-center/submit-ticket"
    ].includes(router.pathname)) {
        return null;
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "px-[16px] xs:px-[12px] xs:py-[16px] py-[24px] rounded-l-[24px] fixed right-0 top-[42%] z-10 bg-bg-button dark:bg-bg-button/10 cursor-pointer xs:hover:pl-[85px] hover:pl-[106px] cart-container overflow-hidden",
        onClick: onNavigate,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "relative flex items-center gap-[8px] xs:text-[12px] text-[14px] Nunito-700 text-main-01 whitespace-nowrap",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                    className: "absolute xs:-left-[78px] -left-[92px] top-[50%] translate-y-[-50%] -translate-x-[10px] cart-text",
                    children: t("help_center.send_message_support")
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(IconCreatePost, {
                    className: "ml-auto mr-0 xs:w-[24px] xs:h-[18px] w-[32px] h-[24px]",
                    fill: "#7673E6"
                })
            ]
        })
    });
};

;// CONCATENATED MODULE: ./app/components/layout/Layout.tsx
















const Layout = (param)=>{
    let { children , breakLayout =false , showHeader =true , expandHeader =false , isShowSidebar =true , isHasFooter =true , isProfilePage =false  } = param;
    const { data: profileInfo  } = (0,query_fn/* useQueryProfileInfo */.LK)();
    const router = (0,next_router.useRouter)();
    const token = configs/* isClient */.C5 ? window.localStorage.getItem("token") : null;
    const { userInfo , setUserInfo , setThemeApp , themeApp , setOpenModal  } = (0,react.useContext)(context/* AppContext */.Il);
    useAxiosInterceptor(api/* http */.d);
    const isHiddenScroll = [
        "/event/dua-top-moi-ban/[id]",
        "/event/landing/[id]"
    ].includes(router.pathname);
    (0,react.useEffect)(()=>{
        var _profileInfo_data;
        if (!!(profileInfo === null || profileInfo === void 0 ? void 0 : (_profileInfo_data = profileInfo.data) === null || _profileInfo_data === void 0 ? void 0 : _profileInfo_data.data) && !!token) {
            var _profileInfo_data1, _profileInfo_data2, _profileInfo_data_data, _profileInfo_data3, _profileInfo_data_data1;
            setUserInfo(profileInfo === null || profileInfo === void 0 ? void 0 : (_profileInfo_data1 = profileInfo.data) === null || _profileInfo_data1 === void 0 ? void 0 : _profileInfo_data1.data);
            var _profileInfo_data_data_lang;
            localStorage.setItem("language", (_profileInfo_data_data_lang = profileInfo === null || profileInfo === void 0 ? void 0 : (_profileInfo_data2 = profileInfo.data) === null || _profileInfo_data2 === void 0 ? void 0 : (_profileInfo_data_data = _profileInfo_data2.data) === null || _profileInfo_data_data === void 0 ? void 0 : _profileInfo_data_data.lang) !== null && _profileInfo_data_data_lang !== void 0 ? _profileInfo_data_data_lang : configs/* LANGUAGE_OPTION.VIETNAMESE */.ZD.VIETNAMESE);
            router.push({
                pathname: router.pathname,
                query: router.query
            }, router.asPath, {
                locale: (profileInfo === null || profileInfo === void 0 ? void 0 : (_profileInfo_data3 = profileInfo.data) === null || _profileInfo_data3 === void 0 ? void 0 : (_profileInfo_data_data1 = _profileInfo_data3.data) === null || _profileInfo_data_data1 === void 0 ? void 0 : _profileInfo_data_data1.lang) || configs/* LANGUAGE_OPTION.VIETNAMESE */.ZD.VIETNAMESE
            });
        }
    }, [
        profileInfo,
        token
    ]);
    (0,react.useEffect)(()=>{
        if (typeof localStorage !== "undefined") {
            const _theme = localStorage.getItem("theme");
            if (_theme === "dark") {
                setThemeApp("dark");
                document.documentElement.classList.add("dark");
            } else {
                setThemeApp("light");
                document.documentElement.classList.remove("dark");
            }
        }
    }, [
        themeApp
    ]);
    // Auto open modal edit hashtag if not select any hashtag
    (0,react.useEffect)(()=>{
        var _userInfo_topic_interest, _userInfo_games_interest;
        if (!!userInfo && (userInfo === null || userInfo === void 0 ? void 0 : userInfo.topic_interest) && (userInfo === null || userInfo === void 0 ? void 0 : userInfo.games_interest) && (userInfo === null || userInfo === void 0 ? void 0 : (_userInfo_topic_interest = userInfo.topic_interest) === null || _userInfo_topic_interest === void 0 ? void 0 : _userInfo_topic_interest.length) + (userInfo === null || userInfo === void 0 ? void 0 : (_userInfo_games_interest = userInfo.games_interest) === null || _userInfo_games_interest === void 0 ? void 0 : _userInfo_games_interest.length) === 0) {
            setOpenModal(configs/* OPEN_MODAL.EDIT_HASHTAG */.a6.EDIT_HASHTAG);
        }
    }, [
        userInfo
    ]);
    (0,react.useEffect)(()=>{
        var _router_query;
        const refCode = router === null || router === void 0 ? void 0 : (_router_query = router.query) === null || _router_query === void 0 ? void 0 : _router_query.referent_code;
        if (!!refCode && !token) {
            setOpenModal(configs/* OPEN_MODAL.LOGIN_MODAL */.a6.LOGIN_MODAL);
        }
        if (!!refCode && !!token && !!(userInfo === null || userInfo === void 0 ? void 0 : userInfo.userid) && !(userInfo === null || userInfo === void 0 ? void 0 : userInfo.invite_code) && refCode !== (userInfo === null || userInfo === void 0 ? void 0 : userInfo.referent_code)) {
            setOpenModal(configs/* OPEN_MODAL.SHARE_REFER_CODE */.a6.SHARE_REFER_CODE);
        }
    }, [
        router,
        token,
        userInfo
    ]);
    (0,react.useEffect)(()=>{
        const button = document.getElementById("thothan-chatbot-bubble-button");
        if (!token && button && !(userInfo === null || userInfo === void 0 ? void 0 : userInfo.userid)) {
            button.style.display = "none";
        }
        if (token && button && (userInfo === null || userInfo === void 0 ? void 0 : userInfo.userid)) {
            button.style.display = "block";
        }
    }, [
        token,
        userInfo
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                id: "layout",
                className: "min-h-[100dvh] relative overflow-hidden ".concat(isShowSidebar && (isProfilePage ? "" : "pb-[100px] md:pb-[56px]"), " md:mb-0"),
                children: [
                    token && userInfo && configs/* isDev */.r8 && /*#__PURE__*/ (0,jsx_runtime.jsx)(ThoThanChatbot, {
                        userName: userInfo === null || userInfo === void 0 ? void 0 : userInfo.fullname,
                        userToken: token
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("iframe", {
                        src: "https://www.googletagmanager.com/ns.html?id=GTM-W2LT6G74",
                        height: "0",
                        width: "0",
                        style: {
                            display: "none",
                            visibility: "hidden"
                        }
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("script", {
                        src: "https://cdnjs.cloudflare.com/ajax/libs/gsap/latest/TweenMax.min.js"
                    }),
                    showHeader && /*#__PURE__*/ (0,jsx_runtime.jsx)(Header, {
                        expandHeader: expandHeader
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "".concat(!breakLayout && "max-w-[1280px] m-auto px-[16px] md:px-[48px] ".concat(showHeader && "pt-[84px]", " sm:px-[30px] pc:px-0")),
                        children: [
                            children,
                            !isHiddenScroll && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(CreateTicketArea, {}),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ScrollToTop, {})
                                ]
                            })
                        ]
                    }),
                    isShowSidebar && /*#__PURE__*/ (0,jsx_runtime.jsx)(SideBarMobile, {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ToasterContainer, {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ModalContainer, {})
                ]
            }),
            isHasFooter && /*#__PURE__*/ (0,jsx_runtime.jsx)(Footer, {})
        ]
    });
};

;// CONCATENATED MODULE: ./app/components/layout/index.ts


;// CONCATENATED MODULE: ./app/styles/globals.css
/* harmony default export */ var globals = ("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");
// EXTERNAL MODULE: ./node_modules/@tanstack/query-core/build/modern/utils.js
var modern_utils = __webpack_require__(24139);
// EXTERNAL MODULE: ./node_modules/@tanstack/query-core/build/modern/notifyManager.js
var notifyManager = __webpack_require__(27037);
// EXTERNAL MODULE: ./node_modules/@tanstack/query-core/build/modern/retryer.js
var retryer = __webpack_require__(72008);
// EXTERNAL MODULE: ./node_modules/@tanstack/query-core/build/modern/removable.js
var removable = __webpack_require__(48907);
;// CONCATENATED MODULE: ./node_modules/@tanstack/query-core/build/modern/query.js
// src/query.ts




var Query = class extends removable/* Removable */.F {
  constructor(config) {
    super();
    this.#abortSignalConsumed = false;
    this.#defaultOptions = config.defaultOptions;
    this.#setOptions(config.options);
    this.#observers = [];
    this.#cache = config.cache;
    this.queryKey = config.queryKey;
    this.queryHash = config.queryHash;
    this.#initialState = config.state || getDefaultState(this.options);
    this.state = this.#initialState;
    this.scheduleGc();
  }
  #initialState;
  #revertState;
  #cache;
  #promise;
  #retryer;
  #observers;
  #defaultOptions;
  #abortSignalConsumed;
  get meta() {
    return this.options.meta;
  }
  #setOptions(options) {
    this.options = { ...this.#defaultOptions, ...options };
    this.updateGcTime(this.options.gcTime);
  }
  optionalRemove() {
    if (!this.#observers.length && this.state.fetchStatus === "idle") {
      this.#cache.remove(this);
    }
  }
  setData(newData, options) {
    const data = (0,modern_utils/* replaceData */.oE)(this.state.data, newData, this.options);
    this.#dispatch({
      data,
      type: "success",
      dataUpdatedAt: options?.updatedAt,
      manual: options?.manual
    });
    return data;
  }
  setState(state, setStateOptions) {
    this.#dispatch({ type: "setState", state, setStateOptions });
  }
  cancel(options) {
    const promise = this.#promise;
    this.#retryer?.cancel(options);
    return promise ? promise.then(modern_utils/* noop */.ZT).catch(modern_utils/* noop */.ZT) : Promise.resolve();
  }
  destroy() {
    super.destroy();
    this.cancel({ silent: true });
  }
  reset() {
    this.destroy();
    this.setState(this.#initialState);
  }
  isActive() {
    return this.#observers.some(
      (observer) => observer.options.enabled !== false
    );
  }
  isDisabled() {
    return this.getObserversCount() > 0 && !this.isActive();
  }
  isStale() {
    return this.state.isInvalidated || !this.state.dataUpdatedAt || this.#observers.some((observer) => observer.getCurrentResult().isStale);
  }
  isStaleByTime(staleTime = 0) {
    return this.state.isInvalidated || !this.state.dataUpdatedAt || !(0,modern_utils/* timeUntilStale */.Kp)(this.state.dataUpdatedAt, staleTime);
  }
  onFocus() {
    const observer = this.#observers.find((x) => x.shouldFetchOnWindowFocus());
    observer?.refetch({ cancelRefetch: false });
    this.#retryer?.continue();
  }
  onOnline() {
    const observer = this.#observers.find((x) => x.shouldFetchOnReconnect());
    observer?.refetch({ cancelRefetch: false });
    this.#retryer?.continue();
  }
  addObserver(observer) {
    if (!this.#observers.includes(observer)) {
      this.#observers.push(observer);
      this.clearGcTimeout();
      this.#cache.notify({ type: "observerAdded", query: this, observer });
    }
  }
  removeObserver(observer) {
    if (this.#observers.includes(observer)) {
      this.#observers = this.#observers.filter((x) => x !== observer);
      if (!this.#observers.length) {
        if (this.#retryer) {
          if (this.#abortSignalConsumed) {
            this.#retryer.cancel({ revert: true });
          } else {
            this.#retryer.cancelRetry();
          }
        }
        this.scheduleGc();
      }
      this.#cache.notify({ type: "observerRemoved", query: this, observer });
    }
  }
  getObserversCount() {
    return this.#observers.length;
  }
  invalidate() {
    if (!this.state.isInvalidated) {
      this.#dispatch({ type: "invalidate" });
    }
  }
  fetch(options, fetchOptions) {
    if (this.state.fetchStatus !== "idle") {
      if (this.state.dataUpdatedAt && fetchOptions?.cancelRefetch) {
        this.cancel({ silent: true });
      } else if (this.#promise) {
        this.#retryer?.continueRetry();
        return this.#promise;
      }
    }
    if (options) {
      this.#setOptions(options);
    }
    if (!this.options.queryFn) {
      const observer = this.#observers.find((x) => x.options.queryFn);
      if (observer) {
        this.#setOptions(observer.options);
      }
    }
    if (false) {}
    const abortController = new AbortController();
    const queryFnContext = {
      queryKey: this.queryKey,
      meta: this.meta
    };
    const addSignalProperty = (object) => {
      Object.defineProperty(object, "signal", {
        enumerable: true,
        get: () => {
          this.#abortSignalConsumed = true;
          return abortController.signal;
        }
      });
    };
    addSignalProperty(queryFnContext);
    const fetchFn = () => {
      if (!this.options.queryFn) {
        return Promise.reject(
          new Error(`Missing queryFn: '${this.options.queryHash}'`)
        );
      }
      this.#abortSignalConsumed = false;
      if (this.options.persister) {
        return this.options.persister(
          this.options.queryFn,
          queryFnContext,
          this
        );
      }
      return this.options.queryFn(
        queryFnContext
      );
    };
    const context = {
      fetchOptions,
      options: this.options,
      queryKey: this.queryKey,
      state: this.state,
      fetchFn
    };
    addSignalProperty(context);
    this.options.behavior?.onFetch(
      context,
      this
    );
    this.#revertState = this.state;
    if (this.state.fetchStatus === "idle" || this.state.fetchMeta !== context.fetchOptions?.meta) {
      this.#dispatch({ type: "fetch", meta: context.fetchOptions?.meta });
    }
    const onError = (error) => {
      if (!((0,retryer/* isCancelledError */.DV)(error) && error.silent)) {
        this.#dispatch({
          type: "error",
          error
        });
      }
      if (!(0,retryer/* isCancelledError */.DV)(error)) {
        this.#cache.config.onError?.(
          error,
          this
        );
        this.#cache.config.onSettled?.(
          this.state.data,
          error,
          this
        );
      }
      if (!this.isFetchingOptimistic) {
        this.scheduleGc();
      }
      this.isFetchingOptimistic = false;
    };
    this.#retryer = (0,retryer/* createRetryer */.Mz)({
      fn: context.fetchFn,
      abort: abortController.abort.bind(abortController),
      onSuccess: (data) => {
        if (typeof data === "undefined") {
          if (false) {}
          onError(new Error(`${this.queryHash} data is undefined`));
          return;
        }
        this.setData(data);
        this.#cache.config.onSuccess?.(data, this);
        this.#cache.config.onSettled?.(
          data,
          this.state.error,
          this
        );
        if (!this.isFetchingOptimistic) {
          this.scheduleGc();
        }
        this.isFetchingOptimistic = false;
      },
      onError,
      onFail: (failureCount, error) => {
        this.#dispatch({ type: "failed", failureCount, error });
      },
      onPause: () => {
        this.#dispatch({ type: "pause" });
      },
      onContinue: () => {
        this.#dispatch({ type: "continue" });
      },
      retry: context.options.retry,
      retryDelay: context.options.retryDelay,
      networkMode: context.options.networkMode
    });
    this.#promise = this.#retryer.promise;
    return this.#promise;
  }
  #dispatch(action) {
    const reducer = (state) => {
      switch (action.type) {
        case "failed":
          return {
            ...state,
            fetchFailureCount: action.failureCount,
            fetchFailureReason: action.error
          };
        case "pause":
          return {
            ...state,
            fetchStatus: "paused"
          };
        case "continue":
          return {
            ...state,
            fetchStatus: "fetching"
          };
        case "fetch":
          return {
            ...state,
            fetchFailureCount: 0,
            fetchFailureReason: null,
            fetchMeta: action.meta ?? null,
            fetchStatus: (0,retryer/* canFetch */.Kw)(this.options.networkMode) ? "fetching" : "paused",
            ...!state.dataUpdatedAt && {
              error: null,
              status: "pending"
            }
          };
        case "success":
          return {
            ...state,
            data: action.data,
            dataUpdateCount: state.dataUpdateCount + 1,
            dataUpdatedAt: action.dataUpdatedAt ?? Date.now(),
            error: null,
            isInvalidated: false,
            status: "success",
            ...!action.manual && {
              fetchStatus: "idle",
              fetchFailureCount: 0,
              fetchFailureReason: null
            }
          };
        case "error":
          const error = action.error;
          if ((0,retryer/* isCancelledError */.DV)(error) && error.revert && this.#revertState) {
            return { ...this.#revertState, fetchStatus: "idle" };
          }
          return {
            ...state,
            error,
            errorUpdateCount: state.errorUpdateCount + 1,
            errorUpdatedAt: Date.now(),
            fetchFailureCount: state.fetchFailureCount + 1,
            fetchFailureReason: error,
            fetchStatus: "idle",
            status: "error"
          };
        case "invalidate":
          return {
            ...state,
            isInvalidated: true
          };
        case "setState":
          return {
            ...state,
            ...action.state
          };
      }
    };
    this.state = reducer(this.state);
    notifyManager/* notifyManager.batch */.V.batch(() => {
      this.#observers.forEach((observer) => {
        observer.onQueryUpdate();
      });
      this.#cache.notify({ query: this, type: "updated", action });
    });
  }
};
function getDefaultState(options) {
  const data = typeof options.initialData === "function" ? options.initialData() : options.initialData;
  const hasData = typeof data !== "undefined";
  const initialDataUpdatedAt = hasData ? typeof options.initialDataUpdatedAt === "function" ? options.initialDataUpdatedAt() : options.initialDataUpdatedAt : 0;
  return {
    data,
    dataUpdateCount: 0,
    dataUpdatedAt: hasData ? initialDataUpdatedAt ?? Date.now() : 0,
    error: null,
    errorUpdateCount: 0,
    errorUpdatedAt: 0,
    fetchFailureCount: 0,
    fetchFailureReason: null,
    fetchMeta: null,
    isInvalidated: false,
    status: hasData ? "success" : "pending",
    fetchStatus: "idle"
  };
}

//# sourceMappingURL=query.js.map
// EXTERNAL MODULE: ./node_modules/@tanstack/query-core/build/modern/subscribable.js
var subscribable = __webpack_require__(7506);
;// CONCATENATED MODULE: ./node_modules/@tanstack/query-core/build/modern/queryCache.js
// src/queryCache.ts




var QueryCache = class extends subscribable/* Subscribable */.l {
  constructor(config = {}) {
    super();
    this.config = config;
    this.#queries = /* @__PURE__ */ new Map();
  }
  #queries;
  build(client, options, state) {
    const queryKey = options.queryKey;
    const queryHash = options.queryHash ?? (0,modern_utils/* hashQueryKeyByOptions */.Rm)(queryKey, options);
    let query = this.get(queryHash);
    if (!query) {
      query = new Query({
        cache: this,
        queryKey,
        queryHash,
        options: client.defaultQueryOptions(options),
        state,
        defaultOptions: client.getQueryDefaults(queryKey)
      });
      this.add(query);
    }
    return query;
  }
  add(query) {
    if (!this.#queries.has(query.queryHash)) {
      this.#queries.set(query.queryHash, query);
      this.notify({
        type: "added",
        query
      });
    }
  }
  remove(query) {
    const queryInMap = this.#queries.get(query.queryHash);
    if (queryInMap) {
      query.destroy();
      if (queryInMap === query) {
        this.#queries.delete(query.queryHash);
      }
      this.notify({ type: "removed", query });
    }
  }
  clear() {
    notifyManager/* notifyManager.batch */.V.batch(() => {
      this.getAll().forEach((query) => {
        this.remove(query);
      });
    });
  }
  get(queryHash) {
    return this.#queries.get(queryHash);
  }
  getAll() {
    return [...this.#queries.values()];
  }
  find(filters) {
    const defaultedFilters = { exact: true, ...filters };
    return this.getAll().find(
      (query) => (0,modern_utils/* matchQuery */._x)(defaultedFilters, query)
    );
  }
  findAll(filters = {}) {
    const queries = this.getAll();
    return Object.keys(filters).length > 0 ? queries.filter((query) => (0,modern_utils/* matchQuery */._x)(filters, query)) : queries;
  }
  notify(event) {
    notifyManager/* notifyManager.batch */.V.batch(() => {
      this.listeners.forEach((listener) => {
        listener(event);
      });
    });
  }
  onFocus() {
    notifyManager/* notifyManager.batch */.V.batch(() => {
      this.getAll().forEach((query) => {
        query.onFocus();
      });
    });
  }
  onOnline() {
    notifyManager/* notifyManager.batch */.V.batch(() => {
      this.getAll().forEach((query) => {
        query.onOnline();
      });
    });
  }
};

//# sourceMappingURL=queryCache.js.map
// EXTERNAL MODULE: ./node_modules/@tanstack/query-core/build/modern/mutation.js
var modern_mutation = __webpack_require__(59289);
;// CONCATENATED MODULE: ./node_modules/@tanstack/query-core/build/modern/mutationCache.js
// src/mutationCache.ts




var MutationCache = class extends subscribable/* Subscribable */.l {
  constructor(config = {}) {
    super();
    this.config = config;
    this.#mutations = [];
    this.#mutationId = 0;
  }
  #mutations;
  #mutationId;
  #resuming;
  build(client, options, state) {
    const mutation = new modern_mutation/* Mutation */.m({
      mutationCache: this,
      mutationId: ++this.#mutationId,
      options: client.defaultMutationOptions(options),
      state
    });
    this.add(mutation);
    return mutation;
  }
  add(mutation) {
    this.#mutations.push(mutation);
    this.notify({ type: "added", mutation });
  }
  remove(mutation) {
    this.#mutations = this.#mutations.filter((x) => x !== mutation);
    this.notify({ type: "removed", mutation });
  }
  clear() {
    notifyManager/* notifyManager.batch */.V.batch(() => {
      this.#mutations.forEach((mutation) => {
        this.remove(mutation);
      });
    });
  }
  getAll() {
    return this.#mutations;
  }
  find(filters) {
    const defaultedFilters = { exact: true, ...filters };
    return this.#mutations.find(
      (mutation) => (0,modern_utils/* matchMutation */.X7)(defaultedFilters, mutation)
    );
  }
  findAll(filters = {}) {
    return this.#mutations.filter(
      (mutation) => (0,modern_utils/* matchMutation */.X7)(filters, mutation)
    );
  }
  notify(event) {
    notifyManager/* notifyManager.batch */.V.batch(() => {
      this.listeners.forEach((listener) => {
        listener(event);
      });
    });
  }
  resumePausedMutations() {
    this.#resuming = (this.#resuming ?? Promise.resolve()).then(() => {
      const pausedMutations = this.#mutations.filter((x) => x.state.isPaused);
      return notifyManager/* notifyManager.batch */.V.batch(
        () => pausedMutations.reduce(
          (promise, mutation) => promise.then(() => mutation.continue().catch(modern_utils/* noop */.ZT)),
          Promise.resolve()
        )
      );
    }).then(() => {
      this.#resuming = void 0;
    });
    return this.#resuming;
  }
};

//# sourceMappingURL=mutationCache.js.map
// EXTERNAL MODULE: ./node_modules/@tanstack/query-core/build/modern/focusManager.js
var focusManager = __webpack_require__(66474);
// EXTERNAL MODULE: ./node_modules/@tanstack/query-core/build/modern/onlineManager.js
var onlineManager = __webpack_require__(14304);
// EXTERNAL MODULE: ./node_modules/@tanstack/query-core/build/modern/infiniteQueryBehavior.js
var infiniteQueryBehavior = __webpack_require__(54948);
;// CONCATENATED MODULE: ./node_modules/@tanstack/query-core/build/modern/queryClient.js
// src/queryClient.ts







var QueryClient = class {
  #queryCache;
  #mutationCache;
  #defaultOptions;
  #queryDefaults;
  #mutationDefaults;
  #mountCount;
  #unsubscribeFocus;
  #unsubscribeOnline;
  constructor(config = {}) {
    this.#queryCache = config.queryCache || new QueryCache();
    this.#mutationCache = config.mutationCache || new MutationCache();
    this.#defaultOptions = config.defaultOptions || {};
    this.#queryDefaults = /* @__PURE__ */ new Map();
    this.#mutationDefaults = /* @__PURE__ */ new Map();
    this.#mountCount = 0;
  }
  mount() {
    this.#mountCount++;
    if (this.#mountCount !== 1)
      return;
    this.#unsubscribeFocus = focusManager/* focusManager.subscribe */.j.subscribe(() => {
      if (focusManager/* focusManager.isFocused */.j.isFocused()) {
        this.resumePausedMutations();
        this.#queryCache.onFocus();
      }
    });
    this.#unsubscribeOnline = onlineManager/* onlineManager.subscribe */.N.subscribe(() => {
      if (onlineManager/* onlineManager.isOnline */.N.isOnline()) {
        this.resumePausedMutations();
        this.#queryCache.onOnline();
      }
    });
  }
  unmount() {
    this.#mountCount--;
    if (this.#mountCount !== 0)
      return;
    this.#unsubscribeFocus?.();
    this.#unsubscribeFocus = void 0;
    this.#unsubscribeOnline?.();
    this.#unsubscribeOnline = void 0;
  }
  isFetching(filters) {
    return this.#queryCache.findAll({ ...filters, fetchStatus: "fetching" }).length;
  }
  isMutating(filters) {
    return this.#mutationCache.findAll({ ...filters, status: "pending" }).length;
  }
  getQueryData(queryKey) {
    return this.#queryCache.find({ queryKey })?.state.data;
  }
  ensureQueryData(options) {
    const cachedData = this.getQueryData(options.queryKey);
    return cachedData !== void 0 ? Promise.resolve(cachedData) : this.fetchQuery(options);
  }
  getQueriesData(filters) {
    return this.getQueryCache().findAll(filters).map(({ queryKey, state }) => {
      const data = state.data;
      return [queryKey, data];
    });
  }
  setQueryData(queryKey, updater, options) {
    const query = this.#queryCache.find({ queryKey });
    const prevData = query?.state.data;
    const data = (0,modern_utils/* functionalUpdate */.SE)(updater, prevData);
    if (typeof data === "undefined") {
      return void 0;
    }
    const defaultedOptions = this.defaultQueryOptions({ queryKey });
    return this.#queryCache.build(this, defaultedOptions).setData(data, { ...options, manual: true });
  }
  setQueriesData(filters, updater, options) {
    return notifyManager/* notifyManager.batch */.V.batch(
      () => this.getQueryCache().findAll(filters).map(({ queryKey }) => [
        queryKey,
        this.setQueryData(queryKey, updater, options)
      ])
    );
  }
  getQueryState(queryKey) {
    return this.#queryCache.find({ queryKey })?.state;
  }
  removeQueries(filters) {
    const queryCache = this.#queryCache;
    notifyManager/* notifyManager.batch */.V.batch(() => {
      queryCache.findAll(filters).forEach((query) => {
        queryCache.remove(query);
      });
    });
  }
  resetQueries(filters, options) {
    const queryCache = this.#queryCache;
    const refetchFilters = {
      type: "active",
      ...filters
    };
    return notifyManager/* notifyManager.batch */.V.batch(() => {
      queryCache.findAll(filters).forEach((query) => {
        query.reset();
      });
      return this.refetchQueries(refetchFilters, options);
    });
  }
  cancelQueries(filters = {}, cancelOptions = {}) {
    const defaultedCancelOptions = { revert: true, ...cancelOptions };
    const promises = notifyManager/* notifyManager.batch */.V.batch(
      () => this.#queryCache.findAll(filters).map((query) => query.cancel(defaultedCancelOptions))
    );
    return Promise.all(promises).then(modern_utils/* noop */.ZT).catch(modern_utils/* noop */.ZT);
  }
  invalidateQueries(filters = {}, options = {}) {
    return notifyManager/* notifyManager.batch */.V.batch(() => {
      this.#queryCache.findAll(filters).forEach((query) => {
        query.invalidate();
      });
      if (filters.refetchType === "none") {
        return Promise.resolve();
      }
      const refetchFilters = {
        ...filters,
        type: filters.refetchType ?? filters.type ?? "active"
      };
      return this.refetchQueries(refetchFilters, options);
    });
  }
  refetchQueries(filters = {}, options) {
    const fetchOptions = {
      ...options,
      cancelRefetch: options?.cancelRefetch ?? true
    };
    const promises = notifyManager/* notifyManager.batch */.V.batch(
      () => this.#queryCache.findAll(filters).filter((query) => !query.isDisabled()).map((query) => {
        let promise = query.fetch(void 0, fetchOptions);
        if (!fetchOptions.throwOnError) {
          promise = promise.catch(modern_utils/* noop */.ZT);
        }
        return query.state.fetchStatus === "paused" ? Promise.resolve() : promise;
      })
    );
    return Promise.all(promises).then(modern_utils/* noop */.ZT);
  }
  fetchQuery(options) {
    const defaultedOptions = this.defaultQueryOptions(options);
    if (typeof defaultedOptions.retry === "undefined") {
      defaultedOptions.retry = false;
    }
    const query = this.#queryCache.build(this, defaultedOptions);
    return query.isStaleByTime(defaultedOptions.staleTime) ? query.fetch(defaultedOptions) : Promise.resolve(query.state.data);
  }
  prefetchQuery(options) {
    return this.fetchQuery(options).then(modern_utils/* noop */.ZT).catch(modern_utils/* noop */.ZT);
  }
  fetchInfiniteQuery(options) {
    options.behavior = (0,infiniteQueryBehavior/* infiniteQueryBehavior */.Gm)(options.pages);
    return this.fetchQuery(options);
  }
  prefetchInfiniteQuery(options) {
    return this.fetchInfiniteQuery(options).then(modern_utils/* noop */.ZT).catch(modern_utils/* noop */.ZT);
  }
  resumePausedMutations() {
    return this.#mutationCache.resumePausedMutations();
  }
  getQueryCache() {
    return this.#queryCache;
  }
  getMutationCache() {
    return this.#mutationCache;
  }
  getDefaultOptions() {
    return this.#defaultOptions;
  }
  setDefaultOptions(options) {
    this.#defaultOptions = options;
  }
  setQueryDefaults(queryKey, options) {
    this.#queryDefaults.set((0,modern_utils/* hashKey */.Ym)(queryKey), {
      queryKey,
      defaultOptions: options
    });
  }
  getQueryDefaults(queryKey) {
    const defaults = [...this.#queryDefaults.values()];
    let result = {};
    defaults.forEach((queryDefault) => {
      if ((0,modern_utils/* partialMatchKey */.to)(queryKey, queryDefault.queryKey)) {
        result = { ...result, ...queryDefault.defaultOptions };
      }
    });
    return result;
  }
  setMutationDefaults(mutationKey, options) {
    this.#mutationDefaults.set((0,modern_utils/* hashKey */.Ym)(mutationKey), {
      mutationKey,
      defaultOptions: options
    });
  }
  getMutationDefaults(mutationKey) {
    const defaults = [...this.#mutationDefaults.values()];
    let result = {};
    defaults.forEach((queryDefault) => {
      if ((0,modern_utils/* partialMatchKey */.to)(mutationKey, queryDefault.mutationKey)) {
        result = { ...result, ...queryDefault.defaultOptions };
      }
    });
    return result;
  }
  defaultQueryOptions(options) {
    if (options?._defaulted) {
      return options;
    }
    const defaultedOptions = {
      ...this.#defaultOptions.queries,
      ...options?.queryKey && this.getQueryDefaults(options.queryKey),
      ...options,
      _defaulted: true
    };
    if (!defaultedOptions.queryHash) {
      defaultedOptions.queryHash = (0,modern_utils/* hashQueryKeyByOptions */.Rm)(
        defaultedOptions.queryKey,
        defaultedOptions
      );
    }
    if (typeof defaultedOptions.refetchOnReconnect === "undefined") {
      defaultedOptions.refetchOnReconnect = defaultedOptions.networkMode !== "always";
    }
    if (typeof defaultedOptions.throwOnError === "undefined") {
      defaultedOptions.throwOnError = !!defaultedOptions.suspense;
    }
    if (typeof defaultedOptions.networkMode === "undefined" && defaultedOptions.persister) {
      defaultedOptions.networkMode = "offlineFirst";
    }
    return defaultedOptions;
  }
  defaultMutationOptions(options) {
    if (options?._defaulted) {
      return options;
    }
    return {
      ...this.#defaultOptions.mutations,
      ...options?.mutationKey && this.getMutationDefaults(options.mutationKey),
      ...options,
      _defaulted: true
    };
  }
  clear() {
    this.#queryCache.clear();
    this.#mutationCache.clear();
  }
};

//# sourceMappingURL=queryClient.js.map
// EXTERNAL MODULE: ./node_modules/next/head.js
var head = __webpack_require__(9008);
var head_default = /*#__PURE__*/__webpack_require__.n(head);
;// CONCATENATED MODULE: ./node_modules/tailwindcss/tailwind.css
/* harmony default export */ var tailwind = ("407461696c77696e6420626173653b0a0a407461696c77696e6420636f6d706f6e656e74733b0a0a407461696c77696e64207574696c69746965733b0a");
;// CONCATENATED MODULE: ./node_modules/swiper/swiper.min.css
/* harmony default export */ var swiper_min = ("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");
;// CONCATENATED MODULE: ./node_modules/swiper/modules/pagination/pagination.min.css
/* harmony default export */ var pagination_min = ("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");
// EXTERNAL MODULE: ./app/context/RewardContext.tsx
var RewardContext = __webpack_require__(9378);
;// CONCATENATED MODULE: ./pages/_app.tsx














// interceptor(http)
function MyApp(param) {
    let { Component , pageProps  } = param;
    var _pageProps_metaPage;
    const metaPage = (_pageProps_metaPage = pageProps.metaPage) !== null && _pageProps_metaPage !== void 0 ? _pageProps_metaPage : null;
    var _pageProps_breakLayout;
    const breakLayout = (_pageProps_breakLayout = pageProps === null || pageProps === void 0 ? void 0 : pageProps.breakLayout) !== null && _pageProps_breakLayout !== void 0 ? _pageProps_breakLayout : "";
    var _pageProps_showHeader;
    const showHeader = (_pageProps_showHeader = pageProps === null || pageProps === void 0 ? void 0 : pageProps.showHeader) !== null && _pageProps_showHeader !== void 0 ? _pageProps_showHeader : true;
    var _pageProps_expandHeader;
    const expandHeader = (_pageProps_expandHeader = pageProps === null || pageProps === void 0 ? void 0 : pageProps.expandHeader) !== null && _pageProps_expandHeader !== void 0 ? _pageProps_expandHeader : false;
    var _pageProps_isShowSidebar;
    const isShowSidebar = (_pageProps_isShowSidebar = pageProps === null || pageProps === void 0 ? void 0 : pageProps.isShowSidebar) !== null && _pageProps_isShowSidebar !== void 0 ? _pageProps_isShowSidebar : true;
    var _pageProps_isHasFooter;
    const isHasFooter = (_pageProps_isHasFooter = pageProps === null || pageProps === void 0 ? void 0 : pageProps.isHasFooter) !== null && _pageProps_isHasFooter !== void 0 ? _pageProps_isHasFooter : true;
    var _pageProps_isProfilePage;
    const isProfilePage = (_pageProps_isProfilePage = pageProps === null || pageProps === void 0 ? void 0 : pageProps.isProfilePage) !== null && _pageProps_isProfilePage !== void 0 ? _pageProps_isProfilePage : false;
    const [queryClient] = react.useState(()=>new QueryClient({
            defaultOptions: configs/* defaultOptions */.$N
        }));
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)((head_default()), {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        charSet: "utf-8"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "viewport",
                        content: "width=device-width, initial-scale=1, maximum-scale=1, user-scalable=no"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        httpEquiv: "content-language",
                        content: "en"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "robots",
                        content: "all"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("title", {
                        children: metaPage && (metaPage === null || metaPage === void 0 ? void 0 : metaPage.title) !== "" ? metaPage === null || metaPage === void 0 ? void 0 : metaPage.title : configs/* meta.title */.$y.title
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "title",
                        content: metaPage && (metaPage === null || metaPage === void 0 ? void 0 : metaPage.title) !== "" ? metaPage === null || metaPage === void 0 ? void 0 : metaPage.title : configs/* meta.title */.$y.title
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "description",
                        content: metaPage && (metaPage === null || metaPage === void 0 ? void 0 : metaPage.desc) !== "" ? metaPage === null || metaPage === void 0 ? void 0 : metaPage.desc : configs/* meta.desc */.$y.desc
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "keywords",
                        content: metaPage && (metaPage === null || metaPage === void 0 ? void 0 : metaPage.keyword) !== "" ? metaPage === null || metaPage === void 0 ? void 0 : metaPage.keyword : configs/* meta.keyword */.$y.keyword
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "generator",
                        content: metaPage && (metaPage === null || metaPage === void 0 ? void 0 : metaPage.title) !== "" ? metaPage === null || metaPage === void 0 ? void 0 : metaPage.title : configs/* meta.title */.$y.title
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        property: "og:url",
                        content: metaPage && (metaPage === null || metaPage === void 0 ? void 0 : metaPage.url) !== "" ? metaPage === null || metaPage === void 0 ? void 0 : metaPage.url : configs/* meta.url */.$y.url
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        property: "og:type",
                        content: "website"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        property: "og:title",
                        content: metaPage && (metaPage === null || metaPage === void 0 ? void 0 : metaPage.title) !== "" ? metaPage === null || metaPage === void 0 ? void 0 : metaPage.title : configs/* meta.title */.$y.title
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        property: "og:description",
                        content: metaPage && (metaPage === null || metaPage === void 0 ? void 0 : metaPage.desc) !== "" ? metaPage === null || metaPage === void 0 ? void 0 : metaPage.desc : configs/* meta.desc */.$y.desc
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        property: "og:site_name",
                        content: metaPage && (metaPage === null || metaPage === void 0 ? void 0 : metaPage.site_name) !== "" ? metaPage === null || metaPage === void 0 ? void 0 : metaPage.site_name : configs/* meta.site_name */.$y.site_name
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        property: "og:image",
                        content: metaPage && (metaPage === null || metaPage === void 0 ? void 0 : metaPage.image) !== "" ? metaPage === null || metaPage === void 0 ? void 0 : metaPage.image : configs/* meta.image */.$y.image
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        property: "twitter:title",
                        content: metaPage && (metaPage === null || metaPage === void 0 ? void 0 : metaPage.title) !== "" ? metaPage === null || metaPage === void 0 ? void 0 : metaPage.title : configs/* meta.title */.$y.title
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        property: "twitter:site",
                        content: metaPage && (metaPage === null || metaPage === void 0 ? void 0 : metaPage.site_name) !== "" ? metaPage === null || metaPage === void 0 ? void 0 : metaPage.site_name : configs/* meta.site_name */.$y.site_name
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        property: "twitter:description",
                        content: metaPage && (metaPage === null || metaPage === void 0 ? void 0 : metaPage.desc) !== "" ? metaPage === null || metaPage === void 0 ? void 0 : metaPage.desc : configs/* meta.desc */.$y.desc
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        property: "twitter:image",
                        content: metaPage && (metaPage === null || metaPage === void 0 ? void 0 : metaPage.image) !== "" ? metaPage === null || metaPage === void 0 ? void 0 : metaPage.image : configs/* meta.image */.$y.image
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        property: "twitter:image:src",
                        content: metaPage && (metaPage === null || metaPage === void 0 ? void 0 : metaPage.image) !== "" ? metaPage === null || metaPage === void 0 ? void 0 : metaPage.image : configs/* meta.image */.$y.image
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
                        rel: "canonical",
                        href: metaPage && (metaPage === null || metaPage === void 0 ? void 0 : metaPage.canonical) !== "" ? metaPage === null || metaPage === void 0 ? void 0 : metaPage.canonical : configs/* meta.canonical */.$y.canonical
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        property: "twitter:card",
                        content: "summary_large_image"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "apple-mobile-web-app-status-bar-style",
                        content: "black"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "apple-mobile-web-app-capable",
                        content: "yes"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
                        rel: "preconnect",
                        href: "https://fonts.googleapis.com"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
                        rel: "icon",
                        type: "image/png",
                        href: "/img/playee_logo.png"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
                        rel: "icon",
                        type: "image/png",
                        sizes: "192x192",
                        href: "/img/playee_logo.png"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
                        rel: "icon",
                        type: "image/png",
                        sizes: "512x512",
                        href: "/img/playee_logo.png"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
                        rel: "apple-touch-icon",
                        sizes: "180x180",
                        href: "/img/playee_logo.png"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(react.Suspense, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(QueryClientProvider/* QueryClientProvider */.aH, {
                    client: queryClient,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(context/* ThemeProvider */.f6, {
                        attribute: "class",
                        storageKey: "theme",
                        defaultTheme: "light",
                        enableSystem: true,
                        themes: [
                            "light",
                            "dark"
                        ],
                        disableTransitionOnChange: true,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(context/* AppProvider */.wI, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(context/* MobileProvider */.eP, {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(RewardContext/* RewardProvider */.l, {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Layout, {
                                        breakLayout: breakLayout,
                                        showHeader: showHeader,
                                        expandHeader: expandHeader,
                                        isShowSidebar: isShowSidebar,
                                        isHasFooter: isHasFooter,
                                        isProfilePage: isProfilePage,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Component, {
                                            ...pageProps
                                        })
                                    })
                                })
                            })
                        })
                    })
                })
            })
        ]
    });
}
/* harmony default export */ var _app = ((0,esm/* appWithTranslation */.Jc)(MyApp));


/***/ }),

/***/ 21876:
/***/ (function(module) {

var __dirname = "/";
(function(){var e={675:function(e,r){"use strict";r.byteLength=byteLength;r.toByteArray=toByteArray;r.fromByteArray=fromByteArray;var t=[];var f=[];var n=typeof Uint8Array!=="undefined"?Uint8Array:Array;var i="ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/";for(var o=0,u=i.length;o<u;++o){t[o]=i[o];f[i.charCodeAt(o)]=o}f["-".charCodeAt(0)]=62;f["_".charCodeAt(0)]=63;function getLens(e){var r=e.length;if(r%4>0){throw new Error("Invalid string. Length must be a multiple of 4")}var t=e.indexOf("=");if(t===-1)t=r;var f=t===r?0:4-t%4;return[t,f]}function byteLength(e){var r=getLens(e);var t=r[0];var f=r[1];return(t+f)*3/4-f}function _byteLength(e,r,t){return(r+t)*3/4-t}function toByteArray(e){var r;var t=getLens(e);var i=t[0];var o=t[1];var u=new n(_byteLength(e,i,o));var a=0;var s=o>0?i-4:i;var h;for(h=0;h<s;h+=4){r=f[e.charCodeAt(h)]<<18|f[e.charCodeAt(h+1)]<<12|f[e.charCodeAt(h+2)]<<6|f[e.charCodeAt(h+3)];u[a++]=r>>16&255;u[a++]=r>>8&255;u[a++]=r&255}if(o===2){r=f[e.charCodeAt(h)]<<2|f[e.charCodeAt(h+1)]>>4;u[a++]=r&255}if(o===1){r=f[e.charCodeAt(h)]<<10|f[e.charCodeAt(h+1)]<<4|f[e.charCodeAt(h+2)]>>2;u[a++]=r>>8&255;u[a++]=r&255}return u}function tripletToBase64(e){return t[e>>18&63]+t[e>>12&63]+t[e>>6&63]+t[e&63]}function encodeChunk(e,r,t){var f;var n=[];for(var i=r;i<t;i+=3){f=(e[i]<<16&16711680)+(e[i+1]<<8&65280)+(e[i+2]&255);n.push(tripletToBase64(f))}return n.join("")}function fromByteArray(e){var r;var f=e.length;var n=f%3;var i=[];var o=16383;for(var u=0,a=f-n;u<a;u+=o){i.push(encodeChunk(e,u,u+o>a?a:u+o))}if(n===1){r=e[f-1];i.push(t[r>>2]+t[r<<4&63]+"==")}else if(n===2){r=(e[f-2]<<8)+e[f-1];i.push(t[r>>10]+t[r>>4&63]+t[r<<2&63]+"=")}return i.join("")}},72:function(e,r,t){"use strict";
/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <https://feross.org>
 * @license  MIT
 */var f=t(675);var n=t(783);var i=typeof Symbol==="function"&&typeof Symbol.for==="function"?Symbol.for("nodejs.util.inspect.custom"):null;r.Buffer=Buffer;r.SlowBuffer=SlowBuffer;r.INSPECT_MAX_BYTES=50;var o=2147483647;r.kMaxLength=o;Buffer.TYPED_ARRAY_SUPPORT=typedArraySupport();if(!Buffer.TYPED_ARRAY_SUPPORT&&typeof console!=="undefined"&&typeof console.error==="function"){console.error("This browser lacks typed array (Uint8Array) support which is required by "+"`buffer` v5.x. Use `buffer` v4.x if you require old browser support.")}function typedArraySupport(){try{var e=new Uint8Array(1);var r={foo:function(){return 42}};Object.setPrototypeOf(r,Uint8Array.prototype);Object.setPrototypeOf(e,r);return e.foo()===42}catch(e){return false}}Object.defineProperty(Buffer.prototype,"parent",{enumerable:true,get:function(){if(!Buffer.isBuffer(this))return undefined;return this.buffer}});Object.defineProperty(Buffer.prototype,"offset",{enumerable:true,get:function(){if(!Buffer.isBuffer(this))return undefined;return this.byteOffset}});function createBuffer(e){if(e>o){throw new RangeError('The value "'+e+'" is invalid for option "size"')}var r=new Uint8Array(e);Object.setPrototypeOf(r,Buffer.prototype);return r}function Buffer(e,r,t){if(typeof e==="number"){if(typeof r==="string"){throw new TypeError('The "string" argument must be of type string. Received type number')}return allocUnsafe(e)}return from(e,r,t)}Buffer.poolSize=8192;function from(e,r,t){if(typeof e==="string"){return fromString(e,r)}if(ArrayBuffer.isView(e)){return fromArrayLike(e)}if(e==null){throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, "+"or Array-like Object. Received type "+typeof e)}if(isInstance(e,ArrayBuffer)||e&&isInstance(e.buffer,ArrayBuffer)){return fromArrayBuffer(e,r,t)}if(typeof SharedArrayBuffer!=="undefined"&&(isInstance(e,SharedArrayBuffer)||e&&isInstance(e.buffer,SharedArrayBuffer))){return fromArrayBuffer(e,r,t)}if(typeof e==="number"){throw new TypeError('The "value" argument must not be of type number. Received type number')}var f=e.valueOf&&e.valueOf();if(f!=null&&f!==e){return Buffer.from(f,r,t)}var n=fromObject(e);if(n)return n;if(typeof Symbol!=="undefined"&&Symbol.toPrimitive!=null&&typeof e[Symbol.toPrimitive]==="function"){return Buffer.from(e[Symbol.toPrimitive]("string"),r,t)}throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, "+"or Array-like Object. Received type "+typeof e)}Buffer.from=function(e,r,t){return from(e,r,t)};Object.setPrototypeOf(Buffer.prototype,Uint8Array.prototype);Object.setPrototypeOf(Buffer,Uint8Array);function assertSize(e){if(typeof e!=="number"){throw new TypeError('"size" argument must be of type number')}else if(e<0){throw new RangeError('The value "'+e+'" is invalid for option "size"')}}function alloc(e,r,t){assertSize(e);if(e<=0){return createBuffer(e)}if(r!==undefined){return typeof t==="string"?createBuffer(e).fill(r,t):createBuffer(e).fill(r)}return createBuffer(e)}Buffer.alloc=function(e,r,t){return alloc(e,r,t)};function allocUnsafe(e){assertSize(e);return createBuffer(e<0?0:checked(e)|0)}Buffer.allocUnsafe=function(e){return allocUnsafe(e)};Buffer.allocUnsafeSlow=function(e){return allocUnsafe(e)};function fromString(e,r){if(typeof r!=="string"||r===""){r="utf8"}if(!Buffer.isEncoding(r)){throw new TypeError("Unknown encoding: "+r)}var t=byteLength(e,r)|0;var f=createBuffer(t);var n=f.write(e,r);if(n!==t){f=f.slice(0,n)}return f}function fromArrayLike(e){var r=e.length<0?0:checked(e.length)|0;var t=createBuffer(r);for(var f=0;f<r;f+=1){t[f]=e[f]&255}return t}function fromArrayBuffer(e,r,t){if(r<0||e.byteLength<r){throw new RangeError('"offset" is outside of buffer bounds')}if(e.byteLength<r+(t||0)){throw new RangeError('"length" is outside of buffer bounds')}var f;if(r===undefined&&t===undefined){f=new Uint8Array(e)}else if(t===undefined){f=new Uint8Array(e,r)}else{f=new Uint8Array(e,r,t)}Object.setPrototypeOf(f,Buffer.prototype);return f}function fromObject(e){if(Buffer.isBuffer(e)){var r=checked(e.length)|0;var t=createBuffer(r);if(t.length===0){return t}e.copy(t,0,0,r);return t}if(e.length!==undefined){if(typeof e.length!=="number"||numberIsNaN(e.length)){return createBuffer(0)}return fromArrayLike(e)}if(e.type==="Buffer"&&Array.isArray(e.data)){return fromArrayLike(e.data)}}function checked(e){if(e>=o){throw new RangeError("Attempt to allocate Buffer larger than maximum "+"size: 0x"+o.toString(16)+" bytes")}return e|0}function SlowBuffer(e){if(+e!=e){e=0}return Buffer.alloc(+e)}Buffer.isBuffer=function isBuffer(e){return e!=null&&e._isBuffer===true&&e!==Buffer.prototype};Buffer.compare=function compare(e,r){if(isInstance(e,Uint8Array))e=Buffer.from(e,e.offset,e.byteLength);if(isInstance(r,Uint8Array))r=Buffer.from(r,r.offset,r.byteLength);if(!Buffer.isBuffer(e)||!Buffer.isBuffer(r)){throw new TypeError('The "buf1", "buf2" arguments must be one of type Buffer or Uint8Array')}if(e===r)return 0;var t=e.length;var f=r.length;for(var n=0,i=Math.min(t,f);n<i;++n){if(e[n]!==r[n]){t=e[n];f=r[n];break}}if(t<f)return-1;if(f<t)return 1;return 0};Buffer.isEncoding=function isEncoding(e){switch(String(e).toLowerCase()){case"hex":case"utf8":case"utf-8":case"ascii":case"latin1":case"binary":case"base64":case"ucs2":case"ucs-2":case"utf16le":case"utf-16le":return true;default:return false}};Buffer.concat=function concat(e,r){if(!Array.isArray(e)){throw new TypeError('"list" argument must be an Array of Buffers')}if(e.length===0){return Buffer.alloc(0)}var t;if(r===undefined){r=0;for(t=0;t<e.length;++t){r+=e[t].length}}var f=Buffer.allocUnsafe(r);var n=0;for(t=0;t<e.length;++t){var i=e[t];if(isInstance(i,Uint8Array)){i=Buffer.from(i)}if(!Buffer.isBuffer(i)){throw new TypeError('"list" argument must be an Array of Buffers')}i.copy(f,n);n+=i.length}return f};function byteLength(e,r){if(Buffer.isBuffer(e)){return e.length}if(ArrayBuffer.isView(e)||isInstance(e,ArrayBuffer)){return e.byteLength}if(typeof e!=="string"){throw new TypeError('The "string" argument must be one of type string, Buffer, or ArrayBuffer. '+"Received type "+typeof e)}var t=e.length;var f=arguments.length>2&&arguments[2]===true;if(!f&&t===0)return 0;var n=false;for(;;){switch(r){case"ascii":case"latin1":case"binary":return t;case"utf8":case"utf-8":return utf8ToBytes(e).length;case"ucs2":case"ucs-2":case"utf16le":case"utf-16le":return t*2;case"hex":return t>>>1;case"base64":return base64ToBytes(e).length;default:if(n){return f?-1:utf8ToBytes(e).length}r=(""+r).toLowerCase();n=true}}}Buffer.byteLength=byteLength;function slowToString(e,r,t){var f=false;if(r===undefined||r<0){r=0}if(r>this.length){return""}if(t===undefined||t>this.length){t=this.length}if(t<=0){return""}t>>>=0;r>>>=0;if(t<=r){return""}if(!e)e="utf8";while(true){switch(e){case"hex":return hexSlice(this,r,t);case"utf8":case"utf-8":return utf8Slice(this,r,t);case"ascii":return asciiSlice(this,r,t);case"latin1":case"binary":return latin1Slice(this,r,t);case"base64":return base64Slice(this,r,t);case"ucs2":case"ucs-2":case"utf16le":case"utf-16le":return utf16leSlice(this,r,t);default:if(f)throw new TypeError("Unknown encoding: "+e);e=(e+"").toLowerCase();f=true}}}Buffer.prototype._isBuffer=true;function swap(e,r,t){var f=e[r];e[r]=e[t];e[t]=f}Buffer.prototype.swap16=function swap16(){var e=this.length;if(e%2!==0){throw new RangeError("Buffer size must be a multiple of 16-bits")}for(var r=0;r<e;r+=2){swap(this,r,r+1)}return this};Buffer.prototype.swap32=function swap32(){var e=this.length;if(e%4!==0){throw new RangeError("Buffer size must be a multiple of 32-bits")}for(var r=0;r<e;r+=4){swap(this,r,r+3);swap(this,r+1,r+2)}return this};Buffer.prototype.swap64=function swap64(){var e=this.length;if(e%8!==0){throw new RangeError("Buffer size must be a multiple of 64-bits")}for(var r=0;r<e;r+=8){swap(this,r,r+7);swap(this,r+1,r+6);swap(this,r+2,r+5);swap(this,r+3,r+4)}return this};Buffer.prototype.toString=function toString(){var e=this.length;if(e===0)return"";if(arguments.length===0)return utf8Slice(this,0,e);return slowToString.apply(this,arguments)};Buffer.prototype.toLocaleString=Buffer.prototype.toString;Buffer.prototype.equals=function equals(e){if(!Buffer.isBuffer(e))throw new TypeError("Argument must be a Buffer");if(this===e)return true;return Buffer.compare(this,e)===0};Buffer.prototype.inspect=function inspect(){var e="";var t=r.INSPECT_MAX_BYTES;e=this.toString("hex",0,t).replace(/(.{2})/g,"$1 ").trim();if(this.length>t)e+=" ... ";return"<Buffer "+e+">"};if(i){Buffer.prototype[i]=Buffer.prototype.inspect}Buffer.prototype.compare=function compare(e,r,t,f,n){if(isInstance(e,Uint8Array)){e=Buffer.from(e,e.offset,e.byteLength)}if(!Buffer.isBuffer(e)){throw new TypeError('The "target" argument must be one of type Buffer or Uint8Array. '+"Received type "+typeof e)}if(r===undefined){r=0}if(t===undefined){t=e?e.length:0}if(f===undefined){f=0}if(n===undefined){n=this.length}if(r<0||t>e.length||f<0||n>this.length){throw new RangeError("out of range index")}if(f>=n&&r>=t){return 0}if(f>=n){return-1}if(r>=t){return 1}r>>>=0;t>>>=0;f>>>=0;n>>>=0;if(this===e)return 0;var i=n-f;var o=t-r;var u=Math.min(i,o);var a=this.slice(f,n);var s=e.slice(r,t);for(var h=0;h<u;++h){if(a[h]!==s[h]){i=a[h];o=s[h];break}}if(i<o)return-1;if(o<i)return 1;return 0};function bidirectionalIndexOf(e,r,t,f,n){if(e.length===0)return-1;if(typeof t==="string"){f=t;t=0}else if(t>2147483647){t=2147483647}else if(t<-2147483648){t=-2147483648}t=+t;if(numberIsNaN(t)){t=n?0:e.length-1}if(t<0)t=e.length+t;if(t>=e.length){if(n)return-1;else t=e.length-1}else if(t<0){if(n)t=0;else return-1}if(typeof r==="string"){r=Buffer.from(r,f)}if(Buffer.isBuffer(r)){if(r.length===0){return-1}return arrayIndexOf(e,r,t,f,n)}else if(typeof r==="number"){r=r&255;if(typeof Uint8Array.prototype.indexOf==="function"){if(n){return Uint8Array.prototype.indexOf.call(e,r,t)}else{return Uint8Array.prototype.lastIndexOf.call(e,r,t)}}return arrayIndexOf(e,[r],t,f,n)}throw new TypeError("val must be string, number or Buffer")}function arrayIndexOf(e,r,t,f,n){var i=1;var o=e.length;var u=r.length;if(f!==undefined){f=String(f).toLowerCase();if(f==="ucs2"||f==="ucs-2"||f==="utf16le"||f==="utf-16le"){if(e.length<2||r.length<2){return-1}i=2;o/=2;u/=2;t/=2}}function read(e,r){if(i===1){return e[r]}else{return e.readUInt16BE(r*i)}}var a;if(n){var s=-1;for(a=t;a<o;a++){if(read(e,a)===read(r,s===-1?0:a-s)){if(s===-1)s=a;if(a-s+1===u)return s*i}else{if(s!==-1)a-=a-s;s=-1}}}else{if(t+u>o)t=o-u;for(a=t;a>=0;a--){var h=true;for(var c=0;c<u;c++){if(read(e,a+c)!==read(r,c)){h=false;break}}if(h)return a}}return-1}Buffer.prototype.includes=function includes(e,r,t){return this.indexOf(e,r,t)!==-1};Buffer.prototype.indexOf=function indexOf(e,r,t){return bidirectionalIndexOf(this,e,r,t,true)};Buffer.prototype.lastIndexOf=function lastIndexOf(e,r,t){return bidirectionalIndexOf(this,e,r,t,false)};function hexWrite(e,r,t,f){t=Number(t)||0;var n=e.length-t;if(!f){f=n}else{f=Number(f);if(f>n){f=n}}var i=r.length;if(f>i/2){f=i/2}for(var o=0;o<f;++o){var u=parseInt(r.substr(o*2,2),16);if(numberIsNaN(u))return o;e[t+o]=u}return o}function utf8Write(e,r,t,f){return blitBuffer(utf8ToBytes(r,e.length-t),e,t,f)}function asciiWrite(e,r,t,f){return blitBuffer(asciiToBytes(r),e,t,f)}function latin1Write(e,r,t,f){return asciiWrite(e,r,t,f)}function base64Write(e,r,t,f){return blitBuffer(base64ToBytes(r),e,t,f)}function ucs2Write(e,r,t,f){return blitBuffer(utf16leToBytes(r,e.length-t),e,t,f)}Buffer.prototype.write=function write(e,r,t,f){if(r===undefined){f="utf8";t=this.length;r=0}else if(t===undefined&&typeof r==="string"){f=r;t=this.length;r=0}else if(isFinite(r)){r=r>>>0;if(isFinite(t)){t=t>>>0;if(f===undefined)f="utf8"}else{f=t;t=undefined}}else{throw new Error("Buffer.write(string, encoding, offset[, length]) is no longer supported")}var n=this.length-r;if(t===undefined||t>n)t=n;if(e.length>0&&(t<0||r<0)||r>this.length){throw new RangeError("Attempt to write outside buffer bounds")}if(!f)f="utf8";var i=false;for(;;){switch(f){case"hex":return hexWrite(this,e,r,t);case"utf8":case"utf-8":return utf8Write(this,e,r,t);case"ascii":return asciiWrite(this,e,r,t);case"latin1":case"binary":return latin1Write(this,e,r,t);case"base64":return base64Write(this,e,r,t);case"ucs2":case"ucs-2":case"utf16le":case"utf-16le":return ucs2Write(this,e,r,t);default:if(i)throw new TypeError("Unknown encoding: "+f);f=(""+f).toLowerCase();i=true}}};Buffer.prototype.toJSON=function toJSON(){return{type:"Buffer",data:Array.prototype.slice.call(this._arr||this,0)}};function base64Slice(e,r,t){if(r===0&&t===e.length){return f.fromByteArray(e)}else{return f.fromByteArray(e.slice(r,t))}}function utf8Slice(e,r,t){t=Math.min(e.length,t);var f=[];var n=r;while(n<t){var i=e[n];var o=null;var u=i>239?4:i>223?3:i>191?2:1;if(n+u<=t){var a,s,h,c;switch(u){case 1:if(i<128){o=i}break;case 2:a=e[n+1];if((a&192)===128){c=(i&31)<<6|a&63;if(c>127){o=c}}break;case 3:a=e[n+1];s=e[n+2];if((a&192)===128&&(s&192)===128){c=(i&15)<<12|(a&63)<<6|s&63;if(c>2047&&(c<55296||c>57343)){o=c}}break;case 4:a=e[n+1];s=e[n+2];h=e[n+3];if((a&192)===128&&(s&192)===128&&(h&192)===128){c=(i&15)<<18|(a&63)<<12|(s&63)<<6|h&63;if(c>65535&&c<1114112){o=c}}}}if(o===null){o=65533;u=1}else if(o>65535){o-=65536;f.push(o>>>10&1023|55296);o=56320|o&1023}f.push(o);n+=u}return decodeCodePointsArray(f)}var u=4096;function decodeCodePointsArray(e){var r=e.length;if(r<=u){return String.fromCharCode.apply(String,e)}var t="";var f=0;while(f<r){t+=String.fromCharCode.apply(String,e.slice(f,f+=u))}return t}function asciiSlice(e,r,t){var f="";t=Math.min(e.length,t);for(var n=r;n<t;++n){f+=String.fromCharCode(e[n]&127)}return f}function latin1Slice(e,r,t){var f="";t=Math.min(e.length,t);for(var n=r;n<t;++n){f+=String.fromCharCode(e[n])}return f}function hexSlice(e,r,t){var f=e.length;if(!r||r<0)r=0;if(!t||t<0||t>f)t=f;var n="";for(var i=r;i<t;++i){n+=s[e[i]]}return n}function utf16leSlice(e,r,t){var f=e.slice(r,t);var n="";for(var i=0;i<f.length;i+=2){n+=String.fromCharCode(f[i]+f[i+1]*256)}return n}Buffer.prototype.slice=function slice(e,r){var t=this.length;e=~~e;r=r===undefined?t:~~r;if(e<0){e+=t;if(e<0)e=0}else if(e>t){e=t}if(r<0){r+=t;if(r<0)r=0}else if(r>t){r=t}if(r<e)r=e;var f=this.subarray(e,r);Object.setPrototypeOf(f,Buffer.prototype);return f};function checkOffset(e,r,t){if(e%1!==0||e<0)throw new RangeError("offset is not uint");if(e+r>t)throw new RangeError("Trying to access beyond buffer length")}Buffer.prototype.readUIntLE=function readUIntLE(e,r,t){e=e>>>0;r=r>>>0;if(!t)checkOffset(e,r,this.length);var f=this[e];var n=1;var i=0;while(++i<r&&(n*=256)){f+=this[e+i]*n}return f};Buffer.prototype.readUIntBE=function readUIntBE(e,r,t){e=e>>>0;r=r>>>0;if(!t){checkOffset(e,r,this.length)}var f=this[e+--r];var n=1;while(r>0&&(n*=256)){f+=this[e+--r]*n}return f};Buffer.prototype.readUInt8=function readUInt8(e,r){e=e>>>0;if(!r)checkOffset(e,1,this.length);return this[e]};Buffer.prototype.readUInt16LE=function readUInt16LE(e,r){e=e>>>0;if(!r)checkOffset(e,2,this.length);return this[e]|this[e+1]<<8};Buffer.prototype.readUInt16BE=function readUInt16BE(e,r){e=e>>>0;if(!r)checkOffset(e,2,this.length);return this[e]<<8|this[e+1]};Buffer.prototype.readUInt32LE=function readUInt32LE(e,r){e=e>>>0;if(!r)checkOffset(e,4,this.length);return(this[e]|this[e+1]<<8|this[e+2]<<16)+this[e+3]*16777216};Buffer.prototype.readUInt32BE=function readUInt32BE(e,r){e=e>>>0;if(!r)checkOffset(e,4,this.length);return this[e]*16777216+(this[e+1]<<16|this[e+2]<<8|this[e+3])};Buffer.prototype.readIntLE=function readIntLE(e,r,t){e=e>>>0;r=r>>>0;if(!t)checkOffset(e,r,this.length);var f=this[e];var n=1;var i=0;while(++i<r&&(n*=256)){f+=this[e+i]*n}n*=128;if(f>=n)f-=Math.pow(2,8*r);return f};Buffer.prototype.readIntBE=function readIntBE(e,r,t){e=e>>>0;r=r>>>0;if(!t)checkOffset(e,r,this.length);var f=r;var n=1;var i=this[e+--f];while(f>0&&(n*=256)){i+=this[e+--f]*n}n*=128;if(i>=n)i-=Math.pow(2,8*r);return i};Buffer.prototype.readInt8=function readInt8(e,r){e=e>>>0;if(!r)checkOffset(e,1,this.length);if(!(this[e]&128))return this[e];return(255-this[e]+1)*-1};Buffer.prototype.readInt16LE=function readInt16LE(e,r){e=e>>>0;if(!r)checkOffset(e,2,this.length);var t=this[e]|this[e+1]<<8;return t&32768?t|4294901760:t};Buffer.prototype.readInt16BE=function readInt16BE(e,r){e=e>>>0;if(!r)checkOffset(e,2,this.length);var t=this[e+1]|this[e]<<8;return t&32768?t|4294901760:t};Buffer.prototype.readInt32LE=function readInt32LE(e,r){e=e>>>0;if(!r)checkOffset(e,4,this.length);return this[e]|this[e+1]<<8|this[e+2]<<16|this[e+3]<<24};Buffer.prototype.readInt32BE=function readInt32BE(e,r){e=e>>>0;if(!r)checkOffset(e,4,this.length);return this[e]<<24|this[e+1]<<16|this[e+2]<<8|this[e+3]};Buffer.prototype.readFloatLE=function readFloatLE(e,r){e=e>>>0;if(!r)checkOffset(e,4,this.length);return n.read(this,e,true,23,4)};Buffer.prototype.readFloatBE=function readFloatBE(e,r){e=e>>>0;if(!r)checkOffset(e,4,this.length);return n.read(this,e,false,23,4)};Buffer.prototype.readDoubleLE=function readDoubleLE(e,r){e=e>>>0;if(!r)checkOffset(e,8,this.length);return n.read(this,e,true,52,8)};Buffer.prototype.readDoubleBE=function readDoubleBE(e,r){e=e>>>0;if(!r)checkOffset(e,8,this.length);return n.read(this,e,false,52,8)};function checkInt(e,r,t,f,n,i){if(!Buffer.isBuffer(e))throw new TypeError('"buffer" argument must be a Buffer instance');if(r>n||r<i)throw new RangeError('"value" argument is out of bounds');if(t+f>e.length)throw new RangeError("Index out of range")}Buffer.prototype.writeUIntLE=function writeUIntLE(e,r,t,f){e=+e;r=r>>>0;t=t>>>0;if(!f){var n=Math.pow(2,8*t)-1;checkInt(this,e,r,t,n,0)}var i=1;var o=0;this[r]=e&255;while(++o<t&&(i*=256)){this[r+o]=e/i&255}return r+t};Buffer.prototype.writeUIntBE=function writeUIntBE(e,r,t,f){e=+e;r=r>>>0;t=t>>>0;if(!f){var n=Math.pow(2,8*t)-1;checkInt(this,e,r,t,n,0)}var i=t-1;var o=1;this[r+i]=e&255;while(--i>=0&&(o*=256)){this[r+i]=e/o&255}return r+t};Buffer.prototype.writeUInt8=function writeUInt8(e,r,t){e=+e;r=r>>>0;if(!t)checkInt(this,e,r,1,255,0);this[r]=e&255;return r+1};Buffer.prototype.writeUInt16LE=function writeUInt16LE(e,r,t){e=+e;r=r>>>0;if(!t)checkInt(this,e,r,2,65535,0);this[r]=e&255;this[r+1]=e>>>8;return r+2};Buffer.prototype.writeUInt16BE=function writeUInt16BE(e,r,t){e=+e;r=r>>>0;if(!t)checkInt(this,e,r,2,65535,0);this[r]=e>>>8;this[r+1]=e&255;return r+2};Buffer.prototype.writeUInt32LE=function writeUInt32LE(e,r,t){e=+e;r=r>>>0;if(!t)checkInt(this,e,r,4,4294967295,0);this[r+3]=e>>>24;this[r+2]=e>>>16;this[r+1]=e>>>8;this[r]=e&255;return r+4};Buffer.prototype.writeUInt32BE=function writeUInt32BE(e,r,t){e=+e;r=r>>>0;if(!t)checkInt(this,e,r,4,4294967295,0);this[r]=e>>>24;this[r+1]=e>>>16;this[r+2]=e>>>8;this[r+3]=e&255;return r+4};Buffer.prototype.writeIntLE=function writeIntLE(e,r,t,f){e=+e;r=r>>>0;if(!f){var n=Math.pow(2,8*t-1);checkInt(this,e,r,t,n-1,-n)}var i=0;var o=1;var u=0;this[r]=e&255;while(++i<t&&(o*=256)){if(e<0&&u===0&&this[r+i-1]!==0){u=1}this[r+i]=(e/o>>0)-u&255}return r+t};Buffer.prototype.writeIntBE=function writeIntBE(e,r,t,f){e=+e;r=r>>>0;if(!f){var n=Math.pow(2,8*t-1);checkInt(this,e,r,t,n-1,-n)}var i=t-1;var o=1;var u=0;this[r+i]=e&255;while(--i>=0&&(o*=256)){if(e<0&&u===0&&this[r+i+1]!==0){u=1}this[r+i]=(e/o>>0)-u&255}return r+t};Buffer.prototype.writeInt8=function writeInt8(e,r,t){e=+e;r=r>>>0;if(!t)checkInt(this,e,r,1,127,-128);if(e<0)e=255+e+1;this[r]=e&255;return r+1};Buffer.prototype.writeInt16LE=function writeInt16LE(e,r,t){e=+e;r=r>>>0;if(!t)checkInt(this,e,r,2,32767,-32768);this[r]=e&255;this[r+1]=e>>>8;return r+2};Buffer.prototype.writeInt16BE=function writeInt16BE(e,r,t){e=+e;r=r>>>0;if(!t)checkInt(this,e,r,2,32767,-32768);this[r]=e>>>8;this[r+1]=e&255;return r+2};Buffer.prototype.writeInt32LE=function writeInt32LE(e,r,t){e=+e;r=r>>>0;if(!t)checkInt(this,e,r,4,2147483647,-2147483648);this[r]=e&255;this[r+1]=e>>>8;this[r+2]=e>>>16;this[r+3]=e>>>24;return r+4};Buffer.prototype.writeInt32BE=function writeInt32BE(e,r,t){e=+e;r=r>>>0;if(!t)checkInt(this,e,r,4,2147483647,-2147483648);if(e<0)e=4294967295+e+1;this[r]=e>>>24;this[r+1]=e>>>16;this[r+2]=e>>>8;this[r+3]=e&255;return r+4};function checkIEEE754(e,r,t,f,n,i){if(t+f>e.length)throw new RangeError("Index out of range");if(t<0)throw new RangeError("Index out of range")}function writeFloat(e,r,t,f,i){r=+r;t=t>>>0;if(!i){checkIEEE754(e,r,t,4,34028234663852886e22,-34028234663852886e22)}n.write(e,r,t,f,23,4);return t+4}Buffer.prototype.writeFloatLE=function writeFloatLE(e,r,t){return writeFloat(this,e,r,true,t)};Buffer.prototype.writeFloatBE=function writeFloatBE(e,r,t){return writeFloat(this,e,r,false,t)};function writeDouble(e,r,t,f,i){r=+r;t=t>>>0;if(!i){checkIEEE754(e,r,t,8,17976931348623157e292,-17976931348623157e292)}n.write(e,r,t,f,52,8);return t+8}Buffer.prototype.writeDoubleLE=function writeDoubleLE(e,r,t){return writeDouble(this,e,r,true,t)};Buffer.prototype.writeDoubleBE=function writeDoubleBE(e,r,t){return writeDouble(this,e,r,false,t)};Buffer.prototype.copy=function copy(e,r,t,f){if(!Buffer.isBuffer(e))throw new TypeError("argument should be a Buffer");if(!t)t=0;if(!f&&f!==0)f=this.length;if(r>=e.length)r=e.length;if(!r)r=0;if(f>0&&f<t)f=t;if(f===t)return 0;if(e.length===0||this.length===0)return 0;if(r<0){throw new RangeError("targetStart out of bounds")}if(t<0||t>=this.length)throw new RangeError("Index out of range");if(f<0)throw new RangeError("sourceEnd out of bounds");if(f>this.length)f=this.length;if(e.length-r<f-t){f=e.length-r+t}var n=f-t;if(this===e&&typeof Uint8Array.prototype.copyWithin==="function"){this.copyWithin(r,t,f)}else if(this===e&&t<r&&r<f){for(var i=n-1;i>=0;--i){e[i+r]=this[i+t]}}else{Uint8Array.prototype.set.call(e,this.subarray(t,f),r)}return n};Buffer.prototype.fill=function fill(e,r,t,f){if(typeof e==="string"){if(typeof r==="string"){f=r;r=0;t=this.length}else if(typeof t==="string"){f=t;t=this.length}if(f!==undefined&&typeof f!=="string"){throw new TypeError("encoding must be a string")}if(typeof f==="string"&&!Buffer.isEncoding(f)){throw new TypeError("Unknown encoding: "+f)}if(e.length===1){var n=e.charCodeAt(0);if(f==="utf8"&&n<128||f==="latin1"){e=n}}}else if(typeof e==="number"){e=e&255}else if(typeof e==="boolean"){e=Number(e)}if(r<0||this.length<r||this.length<t){throw new RangeError("Out of range index")}if(t<=r){return this}r=r>>>0;t=t===undefined?this.length:t>>>0;if(!e)e=0;var i;if(typeof e==="number"){for(i=r;i<t;++i){this[i]=e}}else{var o=Buffer.isBuffer(e)?e:Buffer.from(e,f);var u=o.length;if(u===0){throw new TypeError('The value "'+e+'" is invalid for argument "value"')}for(i=0;i<t-r;++i){this[i+r]=o[i%u]}}return this};var a=/[^+/0-9A-Za-z-_]/g;function base64clean(e){e=e.split("=")[0];e=e.trim().replace(a,"");if(e.length<2)return"";while(e.length%4!==0){e=e+"="}return e}function utf8ToBytes(e,r){r=r||Infinity;var t;var f=e.length;var n=null;var i=[];for(var o=0;o<f;++o){t=e.charCodeAt(o);if(t>55295&&t<57344){if(!n){if(t>56319){if((r-=3)>-1)i.push(239,191,189);continue}else if(o+1===f){if((r-=3)>-1)i.push(239,191,189);continue}n=t;continue}if(t<56320){if((r-=3)>-1)i.push(239,191,189);n=t;continue}t=(n-55296<<10|t-56320)+65536}else if(n){if((r-=3)>-1)i.push(239,191,189)}n=null;if(t<128){if((r-=1)<0)break;i.push(t)}else if(t<2048){if((r-=2)<0)break;i.push(t>>6|192,t&63|128)}else if(t<65536){if((r-=3)<0)break;i.push(t>>12|224,t>>6&63|128,t&63|128)}else if(t<1114112){if((r-=4)<0)break;i.push(t>>18|240,t>>12&63|128,t>>6&63|128,t&63|128)}else{throw new Error("Invalid code point")}}return i}function asciiToBytes(e){var r=[];for(var t=0;t<e.length;++t){r.push(e.charCodeAt(t)&255)}return r}function utf16leToBytes(e,r){var t,f,n;var i=[];for(var o=0;o<e.length;++o){if((r-=2)<0)break;t=e.charCodeAt(o);f=t>>8;n=t%256;i.push(n);i.push(f)}return i}function base64ToBytes(e){return f.toByteArray(base64clean(e))}function blitBuffer(e,r,t,f){for(var n=0;n<f;++n){if(n+t>=r.length||n>=e.length)break;r[n+t]=e[n]}return n}function isInstance(e,r){return e instanceof r||e!=null&&e.constructor!=null&&e.constructor.name!=null&&e.constructor.name===r.name}function numberIsNaN(e){return e!==e}var s=function(){var e="0123456789abcdef";var r=new Array(256);for(var t=0;t<16;++t){var f=t*16;for(var n=0;n<16;++n){r[f+n]=e[t]+e[n]}}return r}()},783:function(e,r){
/*! ieee754. BSD-3-Clause License. Feross Aboukhadijeh <https://feross.org/opensource> */
r.read=function(e,r,t,f,n){var i,o;var u=n*8-f-1;var a=(1<<u)-1;var s=a>>1;var h=-7;var c=t?n-1:0;var l=t?-1:1;var p=e[r+c];c+=l;i=p&(1<<-h)-1;p>>=-h;h+=u;for(;h>0;i=i*256+e[r+c],c+=l,h-=8){}o=i&(1<<-h)-1;i>>=-h;h+=f;for(;h>0;o=o*256+e[r+c],c+=l,h-=8){}if(i===0){i=1-s}else if(i===a){return o?NaN:(p?-1:1)*Infinity}else{o=o+Math.pow(2,f);i=i-s}return(p?-1:1)*o*Math.pow(2,i-f)};r.write=function(e,r,t,f,n,i){var o,u,a;var s=i*8-n-1;var h=(1<<s)-1;var c=h>>1;var l=n===23?Math.pow(2,-24)-Math.pow(2,-77):0;var p=f?0:i-1;var y=f?1:-1;var g=r<0||r===0&&1/r<0?1:0;r=Math.abs(r);if(isNaN(r)||r===Infinity){u=isNaN(r)?1:0;o=h}else{o=Math.floor(Math.log(r)/Math.LN2);if(r*(a=Math.pow(2,-o))<1){o--;a*=2}if(o+c>=1){r+=l/a}else{r+=l*Math.pow(2,1-c)}if(r*a>=2){o++;a/=2}if(o+c>=h){u=0;o=h}else if(o+c>=1){u=(r*a-1)*Math.pow(2,n);o=o+c}else{u=r*Math.pow(2,c-1)*Math.pow(2,n);o=0}}for(;n>=8;e[t+p]=u&255,p+=y,u/=256,n-=8){}o=o<<n|u;s+=n;for(;s>0;e[t+p]=o&255,p+=y,o/=256,s-=8){}e[t+p-y]|=g*128}}};var r={};function __nccwpck_require__(t){var f=r[t];if(f!==undefined){return f.exports}var n=r[t]={exports:{}};var i=true;try{e[t](n,n.exports,__nccwpck_require__);i=false}finally{if(i)delete r[t]}return n.exports}if(typeof __nccwpck_require__!=="undefined")__nccwpck_require__.ab=__dirname+"/";var t=__nccwpck_require__(72);module.exports=t})();

/***/ }),

/***/ 77663:
/***/ (function(module) {

var __dirname = "/";
(function(){var e={229:function(e){var t=e.exports={};var r;var n;function defaultSetTimout(){throw new Error("setTimeout has not been defined")}function defaultClearTimeout(){throw new Error("clearTimeout has not been defined")}(function(){try{if(typeof setTimeout==="function"){r=setTimeout}else{r=defaultSetTimout}}catch(e){r=defaultSetTimout}try{if(typeof clearTimeout==="function"){n=clearTimeout}else{n=defaultClearTimeout}}catch(e){n=defaultClearTimeout}})();function runTimeout(e){if(r===setTimeout){return setTimeout(e,0)}if((r===defaultSetTimout||!r)&&setTimeout){r=setTimeout;return setTimeout(e,0)}try{return r(e,0)}catch(t){try{return r.call(null,e,0)}catch(t){return r.call(this,e,0)}}}function runClearTimeout(e){if(n===clearTimeout){return clearTimeout(e)}if((n===defaultClearTimeout||!n)&&clearTimeout){n=clearTimeout;return clearTimeout(e)}try{return n(e)}catch(t){try{return n.call(null,e)}catch(t){return n.call(this,e)}}}var i=[];var o=false;var u;var a=-1;function cleanUpNextTick(){if(!o||!u){return}o=false;if(u.length){i=u.concat(i)}else{a=-1}if(i.length){drainQueue()}}function drainQueue(){if(o){return}var e=runTimeout(cleanUpNextTick);o=true;var t=i.length;while(t){u=i;i=[];while(++a<t){if(u){u[a].run()}}a=-1;t=i.length}u=null;o=false;runClearTimeout(e)}t.nextTick=function(e){var t=new Array(arguments.length-1);if(arguments.length>1){for(var r=1;r<arguments.length;r++){t[r-1]=arguments[r]}}i.push(new Item(e,t));if(i.length===1&&!o){runTimeout(drainQueue)}};function Item(e,t){this.fun=e;this.array=t}Item.prototype.run=function(){this.fun.apply(null,this.array)};t.title="browser";t.browser=true;t.env={};t.argv=[];t.version="";t.versions={};function noop(){}t.on=noop;t.addListener=noop;t.once=noop;t.off=noop;t.removeListener=noop;t.removeAllListeners=noop;t.emit=noop;t.prependListener=noop;t.prependOnceListener=noop;t.listeners=function(e){return[]};t.binding=function(e){throw new Error("process.binding is not supported")};t.cwd=function(){return"/"};t.chdir=function(e){throw new Error("process.chdir is not supported")};t.umask=function(){return 0}}};var t={};function __nccwpck_require__(r){var n=t[r];if(n!==undefined){return n.exports}var i=t[r]={exports:{}};var o=true;try{e[r](i,i.exports,__nccwpck_require__);o=false}finally{if(o)delete t[r]}return i.exports}if(typeof __nccwpck_require__!=="undefined")__nccwpck_require__.ab=__dirname+"/";var r=__nccwpck_require__(229);module.exports=r})();

/***/ }),

/***/ 99803:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";
/**
 * @license React
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var f=__webpack_require__(55784),k=Symbol.for("react.element"),l=Symbol.for("react.fragment"),m=Object.prototype.hasOwnProperty,n=f.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner,p={key:!0,ref:!0,__self:!0,__source:!0};
function q(c,a,g){var b,d={},e=null,h=null;void 0!==g&&(e=""+g);void 0!==a.key&&(e=""+a.key);void 0!==a.ref&&(h=a.ref);for(b in a)m.call(a,b)&&!p.hasOwnProperty(b)&&(d[b]=a[b]);if(c&&c.defaultProps)for(b in a=c.defaultProps,a)void 0===d[b]&&(d[b]=a[b]);return{$$typeof:k,type:c,key:e,ref:h,props:d,_owner:n.current}}exports.Fragment=l;exports.jsx=q;exports.jsxs=q;


/***/ }),

/***/ 41844:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


if (true) {
  module.exports = __webpack_require__(99803);
} else {}


/***/ }),

/***/ 5152:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports = __webpack_require__(77062)


/***/ }),

/***/ 9008:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports = __webpack_require__(55322)


/***/ }),

/***/ 25675:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports = __webpack_require__(20030)


/***/ }),

/***/ 41664:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports = __webpack_require__(4090)


/***/ }),

/***/ 11163:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports = __webpack_require__(45337)


/***/ }),

/***/ 4298:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports = __webpack_require__(6507)


/***/ }),

/***/ 92703:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var ReactPropTypesSecret = __webpack_require__(50414);

function emptyFunction() {}
function emptyFunctionWithReset() {}
emptyFunctionWithReset.resetWarningCache = emptyFunction;

module.exports = function() {
  function shim(props, propName, componentName, location, propFullName, secret) {
    if (secret === ReactPropTypesSecret) {
      // It is still safe when called from React.
      return;
    }
    var err = new Error(
      'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
      'Use PropTypes.checkPropTypes() to call them. ' +
      'Read more at http://fb.me/use-check-prop-types'
    );
    err.name = 'Invariant Violation';
    throw err;
  };
  shim.isRequired = shim;
  function getShim() {
    return shim;
  };
  // Important!
  // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
  var ReactPropTypes = {
    array: shim,
    bigint: shim,
    bool: shim,
    func: shim,
    number: shim,
    object: shim,
    string: shim,
    symbol: shim,

    any: shim,
    arrayOf: getShim,
    element: shim,
    elementType: shim,
    instanceOf: getShim,
    node: shim,
    objectOf: getShim,
    oneOf: getShim,
    oneOfType: getShim,
    shape: getShim,
    exact: getShim,

    checkPropTypes: emptyFunctionWithReset,
    resetWarningCache: emptyFunction
  };

  ReactPropTypes.PropTypes = ReactPropTypes;

  return ReactPropTypes;
};


/***/ }),

/***/ 45697:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

if (false) { var throwOnDirectAccess, ReactIs; } else {
  // By explicitly using `prop-types` you are opting into new production behavior.
  // http://fb.me/prop-types-in-prod
  module.exports = __webpack_require__(92703)();
}


/***/ }),

/***/ 50414:
/***/ (function(module) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';

module.exports = ReactPropTypesSecret;


/***/ }),

/***/ 28808:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "_W": function() { return /* binding */ DayPicker; },
  "HJ": function() { return /* binding */ useNavigation; }
});

// UNUSED EXPORTS: Button, Caption, CaptionDropdowns, CaptionLabel, CaptionNavigation, Day, DayContent, DayPickerContext, DayPickerProvider, Dropdown, FocusContext, FocusProvider, Footer, Head, HeadRow, IconDropdown, IconLeft, IconRight, InternalModifier, Months, NavigationContext, NavigationProvider, RootProvider, Row, SelectMultipleContext, SelectMultipleProvider, SelectMultipleProviderInternal, SelectRangeContext, SelectRangeProvider, SelectRangeProviderInternal, SelectSingleContext, SelectSingleProvider, SelectSingleProviderInternal, WeekNumber, addToRange, isDateAfterType, isDateBeforeType, isDateInterval, isDateRange, isDayOfWeekType, isDayPickerDefault, isDayPickerMultiple, isDayPickerRange, isDayPickerSingle, isMatch, useActiveModifiers, useDayPicker, useDayRender, useFocusContext, useInput, useSelectMultiple, useSelectRange, useSelectSingle

// EXTERNAL MODULE: ./node_modules/next/dist/compiled/react/index.js
var react = __webpack_require__(55784);
;// CONCATENATED MODULE: ./node_modules/date-fns/locale/en-US/_lib/formatDistance.mjs
const formatDistanceLocale = {
  lessThanXSeconds: {
    one: "less than a second",
    other: "less than {{count}} seconds",
  },

  xSeconds: {
    one: "1 second",
    other: "{{count}} seconds",
  },

  halfAMinute: "half a minute",

  lessThanXMinutes: {
    one: "less than a minute",
    other: "less than {{count}} minutes",
  },

  xMinutes: {
    one: "1 minute",
    other: "{{count}} minutes",
  },

  aboutXHours: {
    one: "about 1 hour",
    other: "about {{count}} hours",
  },

  xHours: {
    one: "1 hour",
    other: "{{count}} hours",
  },

  xDays: {
    one: "1 day",
    other: "{{count}} days",
  },

  aboutXWeeks: {
    one: "about 1 week",
    other: "about {{count}} weeks",
  },

  xWeeks: {
    one: "1 week",
    other: "{{count}} weeks",
  },

  aboutXMonths: {
    one: "about 1 month",
    other: "about {{count}} months",
  },

  xMonths: {
    one: "1 month",
    other: "{{count}} months",
  },

  aboutXYears: {
    one: "about 1 year",
    other: "about {{count}} years",
  },

  xYears: {
    one: "1 year",
    other: "{{count}} years",
  },

  overXYears: {
    one: "over 1 year",
    other: "over {{count}} years",
  },

  almostXYears: {
    one: "almost 1 year",
    other: "almost {{count}} years",
  },
};

const formatDistance = (token, count, options) => {
  let result;

  const tokenValue = formatDistanceLocale[token];
  if (typeof tokenValue === "string") {
    result = tokenValue;
  } else if (count === 1) {
    result = tokenValue.one;
  } else {
    result = tokenValue.other.replace("{{count}}", count.toString());
  }

  if (options?.addSuffix) {
    if (options.comparison && options.comparison > 0) {
      return "in " + result;
    } else {
      return result + " ago";
    }
  }

  return result;
};

;// CONCATENATED MODULE: ./node_modules/date-fns/locale/_lib/buildFormatLongFn.mjs
function buildFormatLongFn(args) {
  return (options = {}) => {
    // TODO: Remove String()
    const width = options.width ? String(options.width) : args.defaultWidth;
    const format = args.formats[width] || args.formats[args.defaultWidth];
    return format;
  };
}

;// CONCATENATED MODULE: ./node_modules/date-fns/locale/en-US/_lib/formatLong.mjs


const dateFormats = {
  full: "EEEE, MMMM do, y",
  long: "MMMM do, y",
  medium: "MMM d, y",
  short: "MM/dd/yyyy",
};

const timeFormats = {
  full: "h:mm:ss a zzzz",
  long: "h:mm:ss a z",
  medium: "h:mm:ss a",
  short: "h:mm a",
};

const dateTimeFormats = {
  full: "{{date}} 'at' {{time}}",
  long: "{{date}} 'at' {{time}}",
  medium: "{{date}}, {{time}}",
  short: "{{date}}, {{time}}",
};

const formatLong = {
  date: buildFormatLongFn({
    formats: dateFormats,
    defaultWidth: "full",
  }),

  time: buildFormatLongFn({
    formats: timeFormats,
    defaultWidth: "full",
  }),

  dateTime: buildFormatLongFn({
    formats: dateTimeFormats,
    defaultWidth: "full",
  }),
};

;// CONCATENATED MODULE: ./node_modules/date-fns/locale/en-US/_lib/formatRelative.mjs
const formatRelativeLocale = {
  lastWeek: "'last' eeee 'at' p",
  yesterday: "'yesterday at' p",
  today: "'today at' p",
  tomorrow: "'tomorrow at' p",
  nextWeek: "eeee 'at' p",
  other: "P",
};

const formatRelative = (token, _date, _baseDate, _options) =>
  formatRelativeLocale[token];

;// CONCATENATED MODULE: ./node_modules/date-fns/locale/_lib/buildLocalizeFn.mjs
/* eslint-disable no-unused-vars */

/**
 * The localize function argument callback which allows to convert raw value to
 * the actual type.
 *
 * @param value - The value to convert
 *
 * @returns The converted value
 */

/**
 * The map of localized values for each width.
 */

/**
 * The index type of the locale unit value. It types conversion of units of
 * values that don't start at 0 (i.e. quarters).
 */

/**
 * Converts the unit value to the tuple of values.
 */

/**
 * The tuple of localized era values. The first element represents BC,
 * the second element represents AD.
 */

/**
 * The tuple of localized quarter values. The first element represents Q1.
 */

/**
 * The tuple of localized day values. The first element represents Sunday.
 */

/**
 * The tuple of localized month values. The first element represents January.
 */

function buildLocalizeFn(args) {
  return (value, options) => {
    const context = options?.context ? String(options.context) : "standalone";

    let valuesArray;
    if (context === "formatting" && args.formattingValues) {
      const defaultWidth = args.defaultFormattingWidth || args.defaultWidth;
      const width = options?.width ? String(options.width) : defaultWidth;

      valuesArray =
        args.formattingValues[width] || args.formattingValues[defaultWidth];
    } else {
      const defaultWidth = args.defaultWidth;
      const width = options?.width ? String(options.width) : args.defaultWidth;

      valuesArray = args.values[width] || args.values[defaultWidth];
    }
    const index = args.argumentCallback ? args.argumentCallback(value) : value;

    // @ts-expect-error - For some reason TypeScript just don't want to match it, no matter how hard we try. I challenge you to try to remove it!
    return valuesArray[index];
  };
}

;// CONCATENATED MODULE: ./node_modules/date-fns/locale/en-US/_lib/localize.mjs


const eraValues = {
  narrow: ["B", "A"],
  abbreviated: ["BC", "AD"],
  wide: ["Before Christ", "Anno Domini"],
};

const quarterValues = {
  narrow: ["1", "2", "3", "4"],
  abbreviated: ["Q1", "Q2", "Q3", "Q4"],
  wide: ["1st quarter", "2nd quarter", "3rd quarter", "4th quarter"],
};

// Note: in English, the names of days of the week and months are capitalized.
// If you are making a new locale based on this one, check if the same is true for the language you're working on.
// Generally, formatted dates should look like they are in the middle of a sentence,
// e.g. in Spanish language the weekdays and months should be in the lowercase.
const monthValues = {
  narrow: ["J", "F", "M", "A", "M", "J", "J", "A", "S", "O", "N", "D"],
  abbreviated: [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec",
  ],

  wide: [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December",
  ],
};

const dayValues = {
  narrow: ["S", "M", "T", "W", "T", "F", "S"],
  short: ["Su", "Mo", "Tu", "We", "Th", "Fr", "Sa"],
  abbreviated: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
  wide: [
    "Sunday",
    "Monday",
    "Tuesday",
    "Wednesday",
    "Thursday",
    "Friday",
    "Saturday",
  ],
};

const dayPeriodValues = {
  narrow: {
    am: "a",
    pm: "p",
    midnight: "mi",
    noon: "n",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night",
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "midnight",
    noon: "noon",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night",
  },
  wide: {
    am: "a.m.",
    pm: "p.m.",
    midnight: "midnight",
    noon: "noon",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night",
  },
};

const formattingDayPeriodValues = {
  narrow: {
    am: "a",
    pm: "p",
    midnight: "mi",
    noon: "n",
    morning: "in the morning",
    afternoon: "in the afternoon",
    evening: "in the evening",
    night: "at night",
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "midnight",
    noon: "noon",
    morning: "in the morning",
    afternoon: "in the afternoon",
    evening: "in the evening",
    night: "at night",
  },
  wide: {
    am: "a.m.",
    pm: "p.m.",
    midnight: "midnight",
    noon: "noon",
    morning: "in the morning",
    afternoon: "in the afternoon",
    evening: "in the evening",
    night: "at night",
  },
};

const ordinalNumber = (dirtyNumber, _options) => {
  const number = Number(dirtyNumber);

  // If ordinal numbers depend on context, for example,
  // if they are different for different grammatical genders,
  // use `options.unit`.
  //
  // `unit` can be 'year', 'quarter', 'month', 'week', 'date', 'dayOfYear',
  // 'day', 'hour', 'minute', 'second'.

  const rem100 = number % 100;
  if (rem100 > 20 || rem100 < 10) {
    switch (rem100 % 10) {
      case 1:
        return number + "st";
      case 2:
        return number + "nd";
      case 3:
        return number + "rd";
    }
  }
  return number + "th";
};

const localize = {
  ordinalNumber,

  era: buildLocalizeFn({
    values: eraValues,
    defaultWidth: "wide",
  }),

  quarter: buildLocalizeFn({
    values: quarterValues,
    defaultWidth: "wide",
    argumentCallback: (quarter) => quarter - 1,
  }),

  month: buildLocalizeFn({
    values: monthValues,
    defaultWidth: "wide",
  }),

  day: buildLocalizeFn({
    values: dayValues,
    defaultWidth: "wide",
  }),

  dayPeriod: buildLocalizeFn({
    values: dayPeriodValues,
    defaultWidth: "wide",
    formattingValues: formattingDayPeriodValues,
    defaultFormattingWidth: "wide",
  }),
};

;// CONCATENATED MODULE: ./node_modules/date-fns/locale/_lib/buildMatchFn.mjs
function buildMatchFn(args) {
  return (string, options = {}) => {
    const width = options.width;

    const matchPattern =
      (width && args.matchPatterns[width]) ||
      args.matchPatterns[args.defaultMatchWidth];
    const matchResult = string.match(matchPattern);

    if (!matchResult) {
      return null;
    }
    const matchedString = matchResult[0];

    const parsePatterns =
      (width && args.parsePatterns[width]) ||
      args.parsePatterns[args.defaultParseWidth];

    const key = Array.isArray(parsePatterns)
      ? findIndex(parsePatterns, (pattern) => pattern.test(matchedString))
      : // eslint-disable-next-line @typescript-eslint/no-explicit-any -- I challange you to fix the type
        findKey(parsePatterns, (pattern) => pattern.test(matchedString));

    let value;

    value = args.valueCallback ? args.valueCallback(key) : key;
    value = options.valueCallback
      ? // eslint-disable-next-line @typescript-eslint/no-explicit-any -- I challange you to fix the type
        options.valueCallback(value)
      : value;

    const rest = string.slice(matchedString.length);

    return { value, rest };
  };
}

function findKey(object, predicate) {
  for (const key in object) {
    if (
      Object.prototype.hasOwnProperty.call(object, key) &&
      predicate(object[key])
    ) {
      return key;
    }
  }
  return undefined;
}

function findIndex(array, predicate) {
  for (let key = 0; key < array.length; key++) {
    if (predicate(array[key])) {
      return key;
    }
  }
  return undefined;
}

;// CONCATENATED MODULE: ./node_modules/date-fns/locale/_lib/buildMatchPatternFn.mjs
function buildMatchPatternFn(args) {
  return (string, options = {}) => {
    const matchResult = string.match(args.matchPattern);
    if (!matchResult) return null;
    const matchedString = matchResult[0];

    const parseResult = string.match(args.parsePattern);
    if (!parseResult) return null;
    let value = args.valueCallback
      ? args.valueCallback(parseResult[0])
      : parseResult[0];

    // eslint-disable-next-line @typescript-eslint/no-explicit-any -- I challange you to fix the type
    value = options.valueCallback ? options.valueCallback(value) : value;

    const rest = string.slice(matchedString.length);

    return { value, rest };
  };
}

;// CONCATENATED MODULE: ./node_modules/date-fns/locale/en-US/_lib/match.mjs



const matchOrdinalNumberPattern = /^(\d+)(th|st|nd|rd)?/i;
const parseOrdinalNumberPattern = /\d+/i;

const matchEraPatterns = {
  narrow: /^(b|a)/i,
  abbreviated: /^(b\.?\s?c\.?|b\.?\s?c\.?\s?e\.?|a\.?\s?d\.?|c\.?\s?e\.?)/i,
  wide: /^(before christ|before common era|anno domini|common era)/i,
};
const parseEraPatterns = {
  any: [/^b/i, /^(a|c)/i],
};

const matchQuarterPatterns = {
  narrow: /^[1234]/i,
  abbreviated: /^q[1234]/i,
  wide: /^[1234](th|st|nd|rd)? quarter/i,
};
const parseQuarterPatterns = {
  any: [/1/i, /2/i, /3/i, /4/i],
};

const matchMonthPatterns = {
  narrow: /^[jfmasond]/i,
  abbreviated: /^(jan|feb|mar|apr|may|jun|jul|aug|sep|oct|nov|dec)/i,
  wide: /^(january|february|march|april|may|june|july|august|september|october|november|december)/i,
};
const parseMonthPatterns = {
  narrow: [
    /^j/i,
    /^f/i,
    /^m/i,
    /^a/i,
    /^m/i,
    /^j/i,
    /^j/i,
    /^a/i,
    /^s/i,
    /^o/i,
    /^n/i,
    /^d/i,
  ],

  any: [
    /^ja/i,
    /^f/i,
    /^mar/i,
    /^ap/i,
    /^may/i,
    /^jun/i,
    /^jul/i,
    /^au/i,
    /^s/i,
    /^o/i,
    /^n/i,
    /^d/i,
  ],
};

const matchDayPatterns = {
  narrow: /^[smtwf]/i,
  short: /^(su|mo|tu|we|th|fr|sa)/i,
  abbreviated: /^(sun|mon|tue|wed|thu|fri|sat)/i,
  wide: /^(sunday|monday|tuesday|wednesday|thursday|friday|saturday)/i,
};
const parseDayPatterns = {
  narrow: [/^s/i, /^m/i, /^t/i, /^w/i, /^t/i, /^f/i, /^s/i],
  any: [/^su/i, /^m/i, /^tu/i, /^w/i, /^th/i, /^f/i, /^sa/i],
};

const matchDayPeriodPatterns = {
  narrow: /^(a|p|mi|n|(in the|at) (morning|afternoon|evening|night))/i,
  any: /^([ap]\.?\s?m\.?|midnight|noon|(in the|at) (morning|afternoon|evening|night))/i,
};
const parseDayPeriodPatterns = {
  any: {
    am: /^a/i,
    pm: /^p/i,
    midnight: /^mi/i,
    noon: /^no/i,
    morning: /morning/i,
    afternoon: /afternoon/i,
    evening: /evening/i,
    night: /night/i,
  },
};

const match = {
  ordinalNumber: buildMatchPatternFn({
    matchPattern: matchOrdinalNumberPattern,
    parsePattern: parseOrdinalNumberPattern,
    valueCallback: (value) => parseInt(value, 10),
  }),

  era: buildMatchFn({
    matchPatterns: matchEraPatterns,
    defaultMatchWidth: "wide",
    parsePatterns: parseEraPatterns,
    defaultParseWidth: "any",
  }),

  quarter: buildMatchFn({
    matchPatterns: matchQuarterPatterns,
    defaultMatchWidth: "wide",
    parsePatterns: parseQuarterPatterns,
    defaultParseWidth: "any",
    valueCallback: (index) => index + 1,
  }),

  month: buildMatchFn({
    matchPatterns: matchMonthPatterns,
    defaultMatchWidth: "wide",
    parsePatterns: parseMonthPatterns,
    defaultParseWidth: "any",
  }),

  day: buildMatchFn({
    matchPatterns: matchDayPatterns,
    defaultMatchWidth: "wide",
    parsePatterns: parseDayPatterns,
    defaultParseWidth: "any",
  }),

  dayPeriod: buildMatchFn({
    matchPatterns: matchDayPeriodPatterns,
    defaultMatchWidth: "any",
    parsePatterns: parseDayPeriodPatterns,
    defaultParseWidth: "any",
  }),
};

;// CONCATENATED MODULE: ./node_modules/date-fns/locale/en-US.mjs






/**
 * @category Locales
 * @summary English locale (United States).
 * @language English
 * @iso-639-2 eng
 * @author Sasha Koss [@kossnocorp](https://github.com/kossnocorp)
 * @author Lesha Koss [@leshakoss](https://github.com/leshakoss)
 */
const en_US_enUS = {
  code: "en-US",
  formatDistance: formatDistance,
  formatLong: formatLong,
  formatRelative: formatRelative,
  localize: localize,
  match: match,
  options: {
    weekStartsOn: 0 /* Sunday */,
    firstWeekContainsDate: 1,
  },
};

// Fallback for modularized imports:
/* harmony default export */ var en_US = ((/* unused pure expression or super */ null && (en_US_enUS)));

;// CONCATENATED MODULE: ./node_modules/date-fns/_lib/defaultOptions.mjs
let defaultOptions = {};

function getDefaultOptions() {
  return defaultOptions;
}

function setDefaultOptions(newOptions) {
  defaultOptions = newOptions;
}

;// CONCATENATED MODULE: ./node_modules/date-fns/constants.mjs
/**
 * @module constants
 * @summary Useful constants
 * @description
 * Collection of useful date constants.
 *
 * The constants could be imported from `date-fns/constants`:
 *
 * ```ts
 * import { maxTime, minTime } from "./constants/date-fns/constants";
 *
 * function isAllowedTime(time) {
 *   return time <= maxTime && time >= minTime;
 * }
 * ```
 */

/**
 * @constant
 * @name daysInWeek
 * @summary Days in 1 week.
 */
const daysInWeek = 7;

/**
 * @constant
 * @name daysInYear
 * @summary Days in 1 year.
 *
 * @description
 * How many days in a year.
 *
 * One years equals 365.2425 days according to the formula:
 *
 * > Leap year occures every 4 years, except for years that are divisable by 100 and not divisable by 400.
 * > 1 mean year = (365+1/4-1/100+1/400) days = 365.2425 days
 */
const daysInYear = 365.2425;

/**
 * @constant
 * @name maxTime
 * @summary Maximum allowed time.
 *
 * @example
 * import { maxTime } from "./constants/date-fns/constants";
 *
 * const isValid = 8640000000000001 <= maxTime;
 * //=> false
 *
 * new Date(8640000000000001);
 * //=> Invalid Date
 */
const maxTime = Math.pow(10, 8) * 24 * 60 * 60 * 1000;

/**
 * @constant
 * @name minTime
 * @summary Minimum allowed time.
 *
 * @example
 * import { minTime } from "./constants/date-fns/constants";
 *
 * const isValid = -8640000000000001 >= minTime;
 * //=> false
 *
 * new Date(-8640000000000001)
 * //=> Invalid Date
 */
const minTime = -maxTime;

/**
 * @constant
 * @name millisecondsInWeek
 * @summary Milliseconds in 1 week.
 */
const millisecondsInWeek = 604800000;

/**
 * @constant
 * @name millisecondsInDay
 * @summary Milliseconds in 1 day.
 */
const millisecondsInDay = 86400000;

/**
 * @constant
 * @name millisecondsInMinute
 * @summary Milliseconds in 1 minute
 */
const millisecondsInMinute = 60000;

/**
 * @constant
 * @name millisecondsInHour
 * @summary Milliseconds in 1 hour
 */
const millisecondsInHour = 3600000;

/**
 * @constant
 * @name millisecondsInSecond
 * @summary Milliseconds in 1 second
 */
const millisecondsInSecond = 1000;

/**
 * @constant
 * @name minutesInYear
 * @summary Minutes in 1 year.
 */
const minutesInYear = 525600;

/**
 * @constant
 * @name minutesInMonth
 * @summary Minutes in 1 month.
 */
const minutesInMonth = 43200;

/**
 * @constant
 * @name minutesInDay
 * @summary Minutes in 1 day.
 */
const minutesInDay = 1440;

/**
 * @constant
 * @name minutesInHour
 * @summary Minutes in 1 hour.
 */
const minutesInHour = 60;

/**
 * @constant
 * @name monthsInQuarter
 * @summary Months in 1 quarter.
 */
const monthsInQuarter = 3;

/**
 * @constant
 * @name monthsInYear
 * @summary Months in 1 year.
 */
const monthsInYear = 12;

/**
 * @constant
 * @name quartersInYear
 * @summary Quarters in 1 year
 */
const quartersInYear = 4;

/**
 * @constant
 * @name secondsInHour
 * @summary Seconds in 1 hour.
 */
const secondsInHour = 3600;

/**
 * @constant
 * @name secondsInMinute
 * @summary Seconds in 1 minute.
 */
const secondsInMinute = 60;

/**
 * @constant
 * @name secondsInDay
 * @summary Seconds in 1 day.
 */
const secondsInDay = secondsInHour * 24;

/**
 * @constant
 * @name secondsInWeek
 * @summary Seconds in 1 week.
 */
const secondsInWeek = secondsInDay * 7;

/**
 * @constant
 * @name secondsInYear
 * @summary Seconds in 1 year.
 */
const secondsInYear = secondsInDay * daysInYear;

/**
 * @constant
 * @name secondsInMonth
 * @summary Seconds in 1 month
 */
const secondsInMonth = secondsInYear / 12;

/**
 * @constant
 * @name secondsInQuarter
 * @summary Seconds in 1 quarter.
 */
const secondsInQuarter = secondsInMonth * 3;

;// CONCATENATED MODULE: ./node_modules/date-fns/toDate.mjs
/**
 * @name toDate
 * @category Common Helpers
 * @summary Convert the given argument to an instance of Date.
 *
 * @description
 * Convert the given argument to an instance of Date.
 *
 * If the argument is an instance of Date, the function returns its clone.
 *
 * If the argument is a number, it is treated as a timestamp.
 *
 * If the argument is none of the above, the function returns Invalid Date.
 *
 * **Note**: *all* Date arguments passed to any *date-fns* function is processed by `toDate`.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param argument - The value to convert
 *
 * @returns The parsed date in the local time zone
 *
 * @example
 * // Clone the date:
 * const result = toDate(new Date(2014, 1, 11, 11, 30, 30))
 * //=> Tue Feb 11 2014 11:30:30
 *
 * @example
 * // Convert the timestamp to date:
 * const result = toDate(1392098430000)
 * //=> Tue Feb 11 2014 11:30:30
 */
function toDate(argument) {
  const argStr = Object.prototype.toString.call(argument);

  // Clone the date
  if (
    argument instanceof Date ||
    (typeof argument === "object" && argStr === "[object Date]")
  ) {
    // Prevent the date to lose the milliseconds when passed to new Date() in IE10
    return new argument.constructor(+argument);
  } else if (
    typeof argument === "number" ||
    argStr === "[object Number]" ||
    typeof argument === "string" ||
    argStr === "[object String]"
  ) {
    // TODO: Can we get rid of as?
    return new Date(argument);
  } else {
    // TODO: Can we get rid of as?
    return new Date(NaN);
  }
}

// Fallback for modularized imports:
/* harmony default export */ var date_fns_toDate = ((/* unused pure expression or super */ null && (toDate)));

;// CONCATENATED MODULE: ./node_modules/date-fns/startOfDay.mjs


/**
 * @name startOfDay
 * @category Day Helpers
 * @summary Return the start of a day for the given date.
 *
 * @description
 * Return the start of a day for the given date.
 * The result will be in the local timezone.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The original date
 *
 * @returns The start of a day
 *
 * @example
 * // The start of a day for 2 September 2014 11:55:00:
 * const result = startOfDay(new Date(2014, 8, 2, 11, 55, 0))
 * //=> Tue Sep 02 2014 00:00:00
 */
function startOfDay(date) {
  const _date = toDate(date);
  _date.setHours(0, 0, 0, 0);
  return _date;
}

// Fallback for modularized imports:
/* harmony default export */ var date_fns_startOfDay = ((/* unused pure expression or super */ null && (startOfDay)));

;// CONCATENATED MODULE: ./node_modules/date-fns/_lib/getTimezoneOffsetInMilliseconds.mjs


/**
 * Google Chrome as of 67.0.3396.87 introduced timezones with offset that includes seconds.
 * They usually appear for dates that denote time before the timezones were introduced
 * (e.g. for 'Europe/Prague' timezone the offset is GMT+00:57:44 before 1 October 1891
 * and GMT+01:00:00 after that date)
 *
 * Date#getTimezoneOffset returns the offset in minutes and would return 57 for the example above,
 * which would lead to incorrect calculations.
 *
 * This function returns the timezone offset in milliseconds that takes seconds in account.
 */
function getTimezoneOffsetInMilliseconds(date) {
  const _date = toDate(date);
  const utcDate = new Date(
    Date.UTC(
      _date.getFullYear(),
      _date.getMonth(),
      _date.getDate(),
      _date.getHours(),
      _date.getMinutes(),
      _date.getSeconds(),
      _date.getMilliseconds(),
    ),
  );
  utcDate.setUTCFullYear(_date.getFullYear());
  return +date - +utcDate;
}

;// CONCATENATED MODULE: ./node_modules/date-fns/differenceInCalendarDays.mjs




/**
 * @name differenceInCalendarDays
 * @category Day Helpers
 * @summary Get the number of calendar days between the given dates.
 *
 * @description
 * Get the number of calendar days between the given dates. This means that the times are removed
 * from the dates and then the difference in days is calculated.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param dateLeft - The later date
 * @param dateRight - The earlier date
 *
 * @returns The number of calendar days
 *
 * @example
 * // How many calendar days are between
 * // 2 July 2011 23:00:00 and 2 July 2012 00:00:00?
 * const result = differenceInCalendarDays(
 *   new Date(2012, 6, 2, 0, 0),
 *   new Date(2011, 6, 2, 23, 0)
 * )
 * //=> 366
 * // How many calendar days are between
 * // 2 July 2011 23:59:00 and 3 July 2011 00:01:00?
 * const result = differenceInCalendarDays(
 *   new Date(2011, 6, 3, 0, 1),
 *   new Date(2011, 6, 2, 23, 59)
 * )
 * //=> 1
 */
function differenceInCalendarDays_differenceInCalendarDays(dateLeft, dateRight) {
  const startOfDayLeft = startOfDay(dateLeft);
  const startOfDayRight = startOfDay(dateRight);

  const timestampLeft =
    +startOfDayLeft - getTimezoneOffsetInMilliseconds(startOfDayLeft);
  const timestampRight =
    +startOfDayRight - getTimezoneOffsetInMilliseconds(startOfDayRight);

  // Round the number of days to the nearest integer because the number of
  // milliseconds in a day is not constant (e.g. it's different in the week of
  // the daylight saving time clock shift).
  return Math.round((timestampLeft - timestampRight) / millisecondsInDay);
}

// Fallback for modularized imports:
/* harmony default export */ var date_fns_differenceInCalendarDays = ((/* unused pure expression or super */ null && (differenceInCalendarDays_differenceInCalendarDays)));

;// CONCATENATED MODULE: ./node_modules/date-fns/constructFrom.mjs
/**
 * @name constructFrom
 * @category Generic Helpers
 * @summary Constructs a date using the reference date and the value
 *
 * @description
 * The function constructs a new date using the constructor from the reference
 * date and the given value. It helps to build generic functions that accept
 * date extensions.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The reference date to take constructor from
 * @param value - The value to create the date
 *
 * @returns Date initialized using the given date and value
 *
 * @example
 * import { constructFrom } from 'date-fns'
 *
 * // A function that clones a date preserving the original type
 * function cloneDate<DateType extends Date(date: DateType): DateType {
 *   return constructFrom(
 *     date, // Use contrustor from the given date
 *     date.getTime() // Use the date value to create a new date
 *   )
 * }
 */
function constructFrom(date, value) {
  if (date instanceof Date) {
    return new date.constructor(value);
  } else {
    return new Date(value);
  }
}

// Fallback for modularized imports:
/* harmony default export */ var date_fns_constructFrom = ((/* unused pure expression or super */ null && (constructFrom)));

;// CONCATENATED MODULE: ./node_modules/date-fns/startOfYear.mjs



/**
 * @name startOfYear
 * @category Year Helpers
 * @summary Return the start of a year for the given date.
 *
 * @description
 * Return the start of a year for the given date.
 * The result will be in the local timezone.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The original date
 *
 * @returns The start of a year
 *
 * @example
 * // The start of a year for 2 September 2014 11:55:00:
 * const result = startOfYear(new Date(2014, 8, 2, 11, 55, 00))
 * //=> Wed Jan 01 2014 00:00:00
 */
function startOfYear(date) {
  const cleanDate = toDate(date);
  const _date = constructFrom(date, 0);
  _date.setFullYear(cleanDate.getFullYear(), 0, 1);
  _date.setHours(0, 0, 0, 0);
  return _date;
}

// Fallback for modularized imports:
/* harmony default export */ var date_fns_startOfYear = ((/* unused pure expression or super */ null && (startOfYear)));

;// CONCATENATED MODULE: ./node_modules/date-fns/getDayOfYear.mjs




/**
 * @name getDayOfYear
 * @category Day Helpers
 * @summary Get the day of the year of the given date.
 *
 * @description
 * Get the day of the year of the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The given date
 *
 * @returns The day of year
 *
 * @example
 * // Which day of the year is 2 July 2014?
 * const result = getDayOfYear(new Date(2014, 6, 2))
 * //=> 183
 */
function getDayOfYear(date) {
  const _date = toDate(date);
  const diff = differenceInCalendarDays_differenceInCalendarDays(_date, startOfYear(_date));
  const dayOfYear = diff + 1;
  return dayOfYear;
}

// Fallback for modularized imports:
/* harmony default export */ var date_fns_getDayOfYear = ((/* unused pure expression or super */ null && (getDayOfYear)));

;// CONCATENATED MODULE: ./node_modules/date-fns/startOfWeek.mjs



/**
 * The {@link startOfWeek} function options.
 */

/**
 * @name startOfWeek
 * @category Week Helpers
 * @summary Return the start of a week for the given date.
 *
 * @description
 * Return the start of a week for the given date.
 * The result will be in the local timezone.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The original date
 * @param options - An object with options
 *
 * @returns The start of a week
 *
 * @example
 * // The start of a week for 2 September 2014 11:55:00:
 * const result = startOfWeek(new Date(2014, 8, 2, 11, 55, 0))
 * //=> Sun Aug 31 2014 00:00:00
 *
 * @example
 * // If the week starts on Monday, the start of the week for 2 September 2014 11:55:00:
 * const result = startOfWeek(new Date(2014, 8, 2, 11, 55, 0), { weekStartsOn: 1 })
 * //=> Mon Sep 01 2014 00:00:00
 */
function startOfWeek(date, options) {
  const defaultOptions = getDefaultOptions();
  const weekStartsOn =
    options?.weekStartsOn ??
    options?.locale?.options?.weekStartsOn ??
    defaultOptions.weekStartsOn ??
    defaultOptions.locale?.options?.weekStartsOn ??
    0;

  const _date = toDate(date);
  const day = _date.getDay();
  const diff = (day < weekStartsOn ? 7 : 0) + day - weekStartsOn;

  _date.setDate(_date.getDate() - diff);
  _date.setHours(0, 0, 0, 0);
  return _date;
}

// Fallback for modularized imports:
/* harmony default export */ var date_fns_startOfWeek = ((/* unused pure expression or super */ null && (startOfWeek)));

;// CONCATENATED MODULE: ./node_modules/date-fns/startOfISOWeek.mjs


/**
 * @name startOfISOWeek
 * @category ISO Week Helpers
 * @summary Return the start of an ISO week for the given date.
 *
 * @description
 * Return the start of an ISO week for the given date.
 * The result will be in the local timezone.
 *
 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The original date
 *
 * @returns The start of an ISO week
 *
 * @example
 * // The start of an ISO week for 2 September 2014 11:55:00:
 * const result = startOfISOWeek(new Date(2014, 8, 2, 11, 55, 0))
 * //=> Mon Sep 01 2014 00:00:00
 */
function startOfISOWeek(date) {
  return startOfWeek(date, { weekStartsOn: 1 });
}

// Fallback for modularized imports:
/* harmony default export */ var date_fns_startOfISOWeek = ((/* unused pure expression or super */ null && (startOfISOWeek)));

;// CONCATENATED MODULE: ./node_modules/date-fns/getISOWeekYear.mjs




/**
 * @name getISOWeekYear
 * @category ISO Week-Numbering Year Helpers
 * @summary Get the ISO week-numbering year of the given date.
 *
 * @description
 * Get the ISO week-numbering year of the given date,
 * which always starts 3 days before the year's first Thursday.
 *
 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The given date
 *
 * @returns The ISO week-numbering year
 *
 * @example
 * // Which ISO-week numbering year is 2 January 2005?
 * const result = getISOWeekYear(new Date(2005, 0, 2))
 * //=> 2004
 */
function getISOWeekYear(date) {
  const _date = toDate(date);
  const year = _date.getFullYear();

  const fourthOfJanuaryOfNextYear = constructFrom(date, 0);
  fourthOfJanuaryOfNextYear.setFullYear(year + 1, 0, 4);
  fourthOfJanuaryOfNextYear.setHours(0, 0, 0, 0);
  const startOfNextYear = startOfISOWeek(fourthOfJanuaryOfNextYear);

  const fourthOfJanuaryOfThisYear = constructFrom(date, 0);
  fourthOfJanuaryOfThisYear.setFullYear(year, 0, 4);
  fourthOfJanuaryOfThisYear.setHours(0, 0, 0, 0);
  const startOfThisYear = startOfISOWeek(fourthOfJanuaryOfThisYear);

  if (_date.getTime() >= startOfNextYear.getTime()) {
    return year + 1;
  } else if (_date.getTime() >= startOfThisYear.getTime()) {
    return year;
  } else {
    return year - 1;
  }
}

// Fallback for modularized imports:
/* harmony default export */ var date_fns_getISOWeekYear = ((/* unused pure expression or super */ null && (getISOWeekYear)));

;// CONCATENATED MODULE: ./node_modules/date-fns/startOfISOWeekYear.mjs




/**
 * @name startOfISOWeekYear
 * @category ISO Week-Numbering Year Helpers
 * @summary Return the start of an ISO week-numbering year for the given date.
 *
 * @description
 * Return the start of an ISO week-numbering year,
 * which always starts 3 days before the year's first Thursday.
 * The result will be in the local timezone.
 *
 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The original date
 *
 * @returns The start of an ISO week-numbering year
 *
 * @example
 * // The start of an ISO week-numbering year for 2 July 2005:
 * const result = startOfISOWeekYear(new Date(2005, 6, 2))
 * //=> Mon Jan 03 2005 00:00:00
 */
function startOfISOWeekYear(date) {
  const year = getISOWeekYear(date);
  const fourthOfJanuary = constructFrom(date, 0);
  fourthOfJanuary.setFullYear(year, 0, 4);
  fourthOfJanuary.setHours(0, 0, 0, 0);
  return startOfISOWeek(fourthOfJanuary);
}

// Fallback for modularized imports:
/* harmony default export */ var date_fns_startOfISOWeekYear = ((/* unused pure expression or super */ null && (startOfISOWeekYear)));

;// CONCATENATED MODULE: ./node_modules/date-fns/getISOWeek.mjs





/**
 * @name getISOWeek
 * @category ISO Week Helpers
 * @summary Get the ISO week of the given date.
 *
 * @description
 * Get the ISO week of the given date.
 *
 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The given date
 *
 * @returns The ISO week
 *
 * @example
 * // Which week of the ISO-week numbering year is 2 January 2005?
 * const result = getISOWeek(new Date(2005, 0, 2))
 * //=> 53
 */
function getISOWeek(date) {
  const _date = toDate(date);
  const diff = +startOfISOWeek(_date) - +startOfISOWeekYear(_date);

  // Round the number of weeks to the nearest integer because the number of
  // milliseconds in a week is not constant (e.g. it's different in the week of
  // the daylight saving time clock shift).
  return Math.round(diff / millisecondsInWeek) + 1;
}

// Fallback for modularized imports:
/* harmony default export */ var date_fns_getISOWeek = ((/* unused pure expression or super */ null && (getISOWeek)));

;// CONCATENATED MODULE: ./node_modules/date-fns/getWeekYear.mjs





/**
 * The {@link getWeekYear} function options.
 */

/**
 * @name getWeekYear
 * @category Week-Numbering Year Helpers
 * @summary Get the local week-numbering year of the given date.
 *
 * @description
 * Get the local week-numbering year of the given date.
 * The exact calculation depends on the values of
 * `options.weekStartsOn` (which is the index of the first day of the week)
 * and `options.firstWeekContainsDate` (which is the day of January, which is always in
 * the first week of the week-numbering year)
 *
 * Week numbering: https://en.wikipedia.org/wiki/Week#The_ISO_week_date_system
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The given date
 * @param options - An object with options.
 *
 * @returns The local week-numbering year
 *
 * @example
 * // Which week numbering year is 26 December 2004 with the default settings?
 * const result = getWeekYear(new Date(2004, 11, 26))
 * //=> 2005
 *
 * @example
 * // Which week numbering year is 26 December 2004 if week starts on Saturday?
 * const result = getWeekYear(new Date(2004, 11, 26), { weekStartsOn: 6 })
 * //=> 2004
 *
 * @example
 * // Which week numbering year is 26 December 2004 if the first week contains 4 January?
 * const result = getWeekYear(new Date(2004, 11, 26), { firstWeekContainsDate: 4 })
 * //=> 2004
 */
function getWeekYear(date, options) {
  const _date = toDate(date);
  const year = _date.getFullYear();

  const defaultOptions = getDefaultOptions();
  const firstWeekContainsDate =
    options?.firstWeekContainsDate ??
    options?.locale?.options?.firstWeekContainsDate ??
    defaultOptions.firstWeekContainsDate ??
    defaultOptions.locale?.options?.firstWeekContainsDate ??
    1;

  const firstWeekOfNextYear = constructFrom(date, 0);
  firstWeekOfNextYear.setFullYear(year + 1, 0, firstWeekContainsDate);
  firstWeekOfNextYear.setHours(0, 0, 0, 0);
  const startOfNextYear = startOfWeek(firstWeekOfNextYear, options);

  const firstWeekOfThisYear = constructFrom(date, 0);
  firstWeekOfThisYear.setFullYear(year, 0, firstWeekContainsDate);
  firstWeekOfThisYear.setHours(0, 0, 0, 0);
  const startOfThisYear = startOfWeek(firstWeekOfThisYear, options);

  if (_date.getTime() >= startOfNextYear.getTime()) {
    return year + 1;
  } else if (_date.getTime() >= startOfThisYear.getTime()) {
    return year;
  } else {
    return year - 1;
  }
}

// Fallback for modularized imports:
/* harmony default export */ var date_fns_getWeekYear = ((/* unused pure expression or super */ null && (getWeekYear)));

;// CONCATENATED MODULE: ./node_modules/date-fns/startOfWeekYear.mjs





/**
 * The {@link startOfWeekYear} function options.
 */

/**
 * @name startOfWeekYear
 * @category Week-Numbering Year Helpers
 * @summary Return the start of a local week-numbering year for the given date.
 *
 * @description
 * Return the start of a local week-numbering year.
 * The exact calculation depends on the values of
 * `options.weekStartsOn` (which is the index of the first day of the week)
 * and `options.firstWeekContainsDate` (which is the day of January, which is always in
 * the first week of the week-numbering year)
 *
 * Week numbering: https://en.wikipedia.org/wiki/Week#The_ISO_week_date_system
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The original date
 * @param options - An object with options
 *
 * @returns The start of a week-numbering year
 *
 * @example
 * // The start of an a week-numbering year for 2 July 2005 with default settings:
 * const result = startOfWeekYear(new Date(2005, 6, 2))
 * //=> Sun Dec 26 2004 00:00:00
 *
 * @example
 * // The start of a week-numbering year for 2 July 2005
 * // if Monday is the first day of week
 * // and 4 January is always in the first week of the year:
 * const result = startOfWeekYear(new Date(2005, 6, 2), {
 *   weekStartsOn: 1,
 *   firstWeekContainsDate: 4
 * })
 * //=> Mon Jan 03 2005 00:00:00
 */
function startOfWeekYear(date, options) {
  const defaultOptions = getDefaultOptions();
  const firstWeekContainsDate =
    options?.firstWeekContainsDate ??
    options?.locale?.options?.firstWeekContainsDate ??
    defaultOptions.firstWeekContainsDate ??
    defaultOptions.locale?.options?.firstWeekContainsDate ??
    1;

  const year = getWeekYear(date, options);
  const firstWeek = constructFrom(date, 0);
  firstWeek.setFullYear(year, 0, firstWeekContainsDate);
  firstWeek.setHours(0, 0, 0, 0);
  const _date = startOfWeek(firstWeek, options);
  return _date;
}

// Fallback for modularized imports:
/* harmony default export */ var date_fns_startOfWeekYear = ((/* unused pure expression or super */ null && (startOfWeekYear)));

;// CONCATENATED MODULE: ./node_modules/date-fns/getWeek.mjs





/**
 * The {@link getWeek} function options.
 */

/**
 * @name getWeek
 * @category Week Helpers
 * @summary Get the local week index of the given date.
 *
 * @description
 * Get the local week index of the given date.
 * The exact calculation depends on the values of
 * `options.weekStartsOn` (which is the index of the first day of the week)
 * and `options.firstWeekContainsDate` (which is the day of January, which is always in
 * the first week of the week-numbering year)
 *
 * Week numbering: https://en.wikipedia.org/wiki/Week#The_ISO_week_date_system
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The given date
 * @param options - An object with options
 *
 * @returns The week
 *
 * @example
 * // Which week of the local week numbering year is 2 January 2005 with default options?
 * const result = getWeek(new Date(2005, 0, 2))
 * //=> 2
 *
 * @example
 * // Which week of the local week numbering year is 2 January 2005,
 * // if Monday is the first day of the week,
 * // and the first week of the year always contains 4 January?
 * const result = getWeek(new Date(2005, 0, 2), {
 *   weekStartsOn: 1,
 *   firstWeekContainsDate: 4
 * })
 * //=> 53
 */

function getWeek(date, options) {
  const _date = toDate(date);
  const diff = +startOfWeek(_date, options) - +startOfWeekYear(_date, options);

  // Round the number of weeks to the nearest integer because the number of
  // milliseconds in a week is not constant (e.g. it's different in the week of
  // the daylight saving time clock shift).
  return Math.round(diff / millisecondsInWeek) + 1;
}

// Fallback for modularized imports:
/* harmony default export */ var date_fns_getWeek = ((/* unused pure expression or super */ null && (getWeek)));

;// CONCATENATED MODULE: ./node_modules/date-fns/_lib/addLeadingZeros.mjs
function addLeadingZeros(number, targetLength) {
  const sign = number < 0 ? "-" : "";
  const output = Math.abs(number).toString().padStart(targetLength, "0");
  return sign + output;
}

;// CONCATENATED MODULE: ./node_modules/date-fns/_lib/format/lightFormatters.mjs


/*
 * |     | Unit                           |     | Unit                           |
 * |-----|--------------------------------|-----|--------------------------------|
 * |  a  | AM, PM                         |  A* |                                |
 * |  d  | Day of month                   |  D  |                                |
 * |  h  | Hour [1-12]                    |  H  | Hour [0-23]                    |
 * |  m  | Minute                         |  M  | Month                          |
 * |  s  | Second                         |  S  | Fraction of second             |
 * |  y  | Year (abs)                     |  Y  |                                |
 *
 * Letters marked by * are not implemented but reserved by Unicode standard.
 */

const lightFormatters = {
  // Year
  y(date, token) {
    // From http://www.unicode.org/reports/tr35/tr35-31/tr35-dates.html#Date_Format_tokens
    // | Year     |     y | yy |   yyy |  yyyy | yyyyy |
    // |----------|-------|----|-------|-------|-------|
    // | AD 1     |     1 | 01 |   001 |  0001 | 00001 |
    // | AD 12    |    12 | 12 |   012 |  0012 | 00012 |
    // | AD 123   |   123 | 23 |   123 |  0123 | 00123 |
    // | AD 1234  |  1234 | 34 |  1234 |  1234 | 01234 |
    // | AD 12345 | 12345 | 45 | 12345 | 12345 | 12345 |

    const signedYear = date.getFullYear();
    // Returns 1 for 1 BC (which is year 0 in JavaScript)
    const year = signedYear > 0 ? signedYear : 1 - signedYear;
    return addLeadingZeros(token === "yy" ? year % 100 : year, token.length);
  },

  // Month
  M(date, token) {
    const month = date.getMonth();
    return token === "M" ? String(month + 1) : addLeadingZeros(month + 1, 2);
  },

  // Day of the month
  d(date, token) {
    return addLeadingZeros(date.getDate(), token.length);
  },

  // AM or PM
  a(date, token) {
    const dayPeriodEnumValue = date.getHours() / 12 >= 1 ? "pm" : "am";

    switch (token) {
      case "a":
      case "aa":
        return dayPeriodEnumValue.toUpperCase();
      case "aaa":
        return dayPeriodEnumValue;
      case "aaaaa":
        return dayPeriodEnumValue[0];
      case "aaaa":
      default:
        return dayPeriodEnumValue === "am" ? "a.m." : "p.m.";
    }
  },

  // Hour [1-12]
  h(date, token) {
    return addLeadingZeros(date.getHours() % 12 || 12, token.length);
  },

  // Hour [0-23]
  H(date, token) {
    return addLeadingZeros(date.getHours(), token.length);
  },

  // Minute
  m(date, token) {
    return addLeadingZeros(date.getMinutes(), token.length);
  },

  // Second
  s(date, token) {
    return addLeadingZeros(date.getSeconds(), token.length);
  },

  // Fraction of second
  S(date, token) {
    const numberOfDigits = token.length;
    const milliseconds = date.getMilliseconds();
    const fractionalSeconds = Math.trunc(
      milliseconds * Math.pow(10, numberOfDigits - 3),
    );
    return addLeadingZeros(fractionalSeconds, token.length);
  },
};

;// CONCATENATED MODULE: ./node_modules/date-fns/_lib/format/formatters.mjs








const dayPeriodEnum = {
  am: "am",
  pm: "pm",
  midnight: "midnight",
  noon: "noon",
  morning: "morning",
  afternoon: "afternoon",
  evening: "evening",
  night: "night",
};

/*
 * |     | Unit                           |     | Unit                           |
 * |-----|--------------------------------|-----|--------------------------------|
 * |  a  | AM, PM                         |  A* | Milliseconds in day            |
 * |  b  | AM, PM, noon, midnight         |  B  | Flexible day period            |
 * |  c  | Stand-alone local day of week  |  C* | Localized hour w/ day period   |
 * |  d  | Day of month                   |  D  | Day of year                    |
 * |  e  | Local day of week              |  E  | Day of week                    |
 * |  f  |                                |  F* | Day of week in month           |
 * |  g* | Modified Julian day            |  G  | Era                            |
 * |  h  | Hour [1-12]                    |  H  | Hour [0-23]                    |
 * |  i! | ISO day of week                |  I! | ISO week of year               |
 * |  j* | Localized hour w/ day period   |  J* | Localized hour w/o day period  |
 * |  k  | Hour [1-24]                    |  K  | Hour [0-11]                    |
 * |  l* | (deprecated)                   |  L  | Stand-alone month              |
 * |  m  | Minute                         |  M  | Month                          |
 * |  n  |                                |  N  |                                |
 * |  o! | Ordinal number modifier        |  O  | Timezone (GMT)                 |
 * |  p! | Long localized time            |  P! | Long localized date            |
 * |  q  | Stand-alone quarter            |  Q  | Quarter                        |
 * |  r* | Related Gregorian year         |  R! | ISO week-numbering year        |
 * |  s  | Second                         |  S  | Fraction of second             |
 * |  t! | Seconds timestamp              |  T! | Milliseconds timestamp         |
 * |  u  | Extended year                  |  U* | Cyclic year                    |
 * |  v* | Timezone (generic non-locat.)  |  V* | Timezone (location)            |
 * |  w  | Local week of year             |  W* | Week of month                  |
 * |  x  | Timezone (ISO-8601 w/o Z)      |  X  | Timezone (ISO-8601)            |
 * |  y  | Year (abs)                     |  Y  | Local week-numbering year      |
 * |  z  | Timezone (specific non-locat.) |  Z* | Timezone (aliases)             |
 *
 * Letters marked by * are not implemented but reserved by Unicode standard.
 *
 * Letters marked by ! are non-standard, but implemented by date-fns:
 * - `o` modifies the previous token to turn it into an ordinal (see `format` docs)
 * - `i` is ISO day of week. For `i` and `ii` is returns numeric ISO week days,
 *   i.e. 7 for Sunday, 1 for Monday, etc.
 * - `I` is ISO week of year, as opposed to `w` which is local week of year.
 * - `R` is ISO week-numbering year, as opposed to `Y` which is local week-numbering year.
 *   `R` is supposed to be used in conjunction with `I` and `i`
 *   for universal ISO week-numbering date, whereas
 *   `Y` is supposed to be used in conjunction with `w` and `e`
 *   for week-numbering date specific to the locale.
 * - `P` is long localized date format
 * - `p` is long localized time format
 */

const formatters = {
  // Era
  G: function (date, token, localize) {
    const era = date.getFullYear() > 0 ? 1 : 0;
    switch (token) {
      // AD, BC
      case "G":
      case "GG":
      case "GGG":
        return localize.era(era, { width: "abbreviated" });
      // A, B
      case "GGGGG":
        return localize.era(era, { width: "narrow" });
      // Anno Domini, Before Christ
      case "GGGG":
      default:
        return localize.era(era, { width: "wide" });
    }
  },

  // Year
  y: function (date, token, localize) {
    // Ordinal number
    if (token === "yo") {
      const signedYear = date.getFullYear();
      // Returns 1 for 1 BC (which is year 0 in JavaScript)
      const year = signedYear > 0 ? signedYear : 1 - signedYear;
      return localize.ordinalNumber(year, { unit: "year" });
    }

    return lightFormatters.y(date, token);
  },

  // Local week-numbering year
  Y: function (date, token, localize, options) {
    const signedWeekYear = getWeekYear(date, options);
    // Returns 1 for 1 BC (which is year 0 in JavaScript)
    const weekYear = signedWeekYear > 0 ? signedWeekYear : 1 - signedWeekYear;

    // Two digit year
    if (token === "YY") {
      const twoDigitYear = weekYear % 100;
      return addLeadingZeros(twoDigitYear, 2);
    }

    // Ordinal number
    if (token === "Yo") {
      return localize.ordinalNumber(weekYear, { unit: "year" });
    }

    // Padding
    return addLeadingZeros(weekYear, token.length);
  },

  // ISO week-numbering year
  R: function (date, token) {
    const isoWeekYear = getISOWeekYear(date);

    // Padding
    return addLeadingZeros(isoWeekYear, token.length);
  },

  // Extended year. This is a single number designating the year of this calendar system.
  // The main difference between `y` and `u` localizers are B.C. years:
  // | Year | `y` | `u` |
  // |------|-----|-----|
  // | AC 1 |   1 |   1 |
  // | BC 1 |   1 |   0 |
  // | BC 2 |   2 |  -1 |
  // Also `yy` always returns the last two digits of a year,
  // while `uu` pads single digit years to 2 characters and returns other years unchanged.
  u: function (date, token) {
    const year = date.getFullYear();
    return addLeadingZeros(year, token.length);
  },

  // Quarter
  Q: function (date, token, localize) {
    const quarter = Math.ceil((date.getMonth() + 1) / 3);
    switch (token) {
      // 1, 2, 3, 4
      case "Q":
        return String(quarter);
      // 01, 02, 03, 04
      case "QQ":
        return addLeadingZeros(quarter, 2);
      // 1st, 2nd, 3rd, 4th
      case "Qo":
        return localize.ordinalNumber(quarter, { unit: "quarter" });
      // Q1, Q2, Q3, Q4
      case "QQQ":
        return localize.quarter(quarter, {
          width: "abbreviated",
          context: "formatting",
        });
      // 1, 2, 3, 4 (narrow quarter; could be not numerical)
      case "QQQQQ":
        return localize.quarter(quarter, {
          width: "narrow",
          context: "formatting",
        });
      // 1st quarter, 2nd quarter, ...
      case "QQQQ":
      default:
        return localize.quarter(quarter, {
          width: "wide",
          context: "formatting",
        });
    }
  },

  // Stand-alone quarter
  q: function (date, token, localize) {
    const quarter = Math.ceil((date.getMonth() + 1) / 3);
    switch (token) {
      // 1, 2, 3, 4
      case "q":
        return String(quarter);
      // 01, 02, 03, 04
      case "qq":
        return addLeadingZeros(quarter, 2);
      // 1st, 2nd, 3rd, 4th
      case "qo":
        return localize.ordinalNumber(quarter, { unit: "quarter" });
      // Q1, Q2, Q3, Q4
      case "qqq":
        return localize.quarter(quarter, {
          width: "abbreviated",
          context: "standalone",
        });
      // 1, 2, 3, 4 (narrow quarter; could be not numerical)
      case "qqqqq":
        return localize.quarter(quarter, {
          width: "narrow",
          context: "standalone",
        });
      // 1st quarter, 2nd quarter, ...
      case "qqqq":
      default:
        return localize.quarter(quarter, {
          width: "wide",
          context: "standalone",
        });
    }
  },

  // Month
  M: function (date, token, localize) {
    const month = date.getMonth();
    switch (token) {
      case "M":
      case "MM":
        return lightFormatters.M(date, token);
      // 1st, 2nd, ..., 12th
      case "Mo":
        return localize.ordinalNumber(month + 1, { unit: "month" });
      // Jan, Feb, ..., Dec
      case "MMM":
        return localize.month(month, {
          width: "abbreviated",
          context: "formatting",
        });
      // J, F, ..., D
      case "MMMMM":
        return localize.month(month, {
          width: "narrow",
          context: "formatting",
        });
      // January, February, ..., December
      case "MMMM":
      default:
        return localize.month(month, { width: "wide", context: "formatting" });
    }
  },

  // Stand-alone month
  L: function (date, token, localize) {
    const month = date.getMonth();
    switch (token) {
      // 1, 2, ..., 12
      case "L":
        return String(month + 1);
      // 01, 02, ..., 12
      case "LL":
        return addLeadingZeros(month + 1, 2);
      // 1st, 2nd, ..., 12th
      case "Lo":
        return localize.ordinalNumber(month + 1, { unit: "month" });
      // Jan, Feb, ..., Dec
      case "LLL":
        return localize.month(month, {
          width: "abbreviated",
          context: "standalone",
        });
      // J, F, ..., D
      case "LLLLL":
        return localize.month(month, {
          width: "narrow",
          context: "standalone",
        });
      // January, February, ..., December
      case "LLLL":
      default:
        return localize.month(month, { width: "wide", context: "standalone" });
    }
  },

  // Local week of year
  w: function (date, token, localize, options) {
    const week = getWeek(date, options);

    if (token === "wo") {
      return localize.ordinalNumber(week, { unit: "week" });
    }

    return addLeadingZeros(week, token.length);
  },

  // ISO week of year
  I: function (date, token, localize) {
    const isoWeek = getISOWeek(date);

    if (token === "Io") {
      return localize.ordinalNumber(isoWeek, { unit: "week" });
    }

    return addLeadingZeros(isoWeek, token.length);
  },

  // Day of the month
  d: function (date, token, localize) {
    if (token === "do") {
      return localize.ordinalNumber(date.getDate(), { unit: "date" });
    }

    return lightFormatters.d(date, token);
  },

  // Day of year
  D: function (date, token, localize) {
    const dayOfYear = getDayOfYear(date);

    if (token === "Do") {
      return localize.ordinalNumber(dayOfYear, { unit: "dayOfYear" });
    }

    return addLeadingZeros(dayOfYear, token.length);
  },

  // Day of week
  E: function (date, token, localize) {
    const dayOfWeek = date.getDay();
    switch (token) {
      // Tue
      case "E":
      case "EE":
      case "EEE":
        return localize.day(dayOfWeek, {
          width: "abbreviated",
          context: "formatting",
        });
      // T
      case "EEEEE":
        return localize.day(dayOfWeek, {
          width: "narrow",
          context: "formatting",
        });
      // Tu
      case "EEEEEE":
        return localize.day(dayOfWeek, {
          width: "short",
          context: "formatting",
        });
      // Tuesday
      case "EEEE":
      default:
        return localize.day(dayOfWeek, {
          width: "wide",
          context: "formatting",
        });
    }
  },

  // Local day of week
  e: function (date, token, localize, options) {
    const dayOfWeek = date.getDay();
    const localDayOfWeek = (dayOfWeek - options.weekStartsOn + 8) % 7 || 7;
    switch (token) {
      // Numerical value (Nth day of week with current locale or weekStartsOn)
      case "e":
        return String(localDayOfWeek);
      // Padded numerical value
      case "ee":
        return addLeadingZeros(localDayOfWeek, 2);
      // 1st, 2nd, ..., 7th
      case "eo":
        return localize.ordinalNumber(localDayOfWeek, { unit: "day" });
      case "eee":
        return localize.day(dayOfWeek, {
          width: "abbreviated",
          context: "formatting",
        });
      // T
      case "eeeee":
        return localize.day(dayOfWeek, {
          width: "narrow",
          context: "formatting",
        });
      // Tu
      case "eeeeee":
        return localize.day(dayOfWeek, {
          width: "short",
          context: "formatting",
        });
      // Tuesday
      case "eeee":
      default:
        return localize.day(dayOfWeek, {
          width: "wide",
          context: "formatting",
        });
    }
  },

  // Stand-alone local day of week
  c: function (date, token, localize, options) {
    const dayOfWeek = date.getDay();
    const localDayOfWeek = (dayOfWeek - options.weekStartsOn + 8) % 7 || 7;
    switch (token) {
      // Numerical value (same as in `e`)
      case "c":
        return String(localDayOfWeek);
      // Padded numerical value
      case "cc":
        return addLeadingZeros(localDayOfWeek, token.length);
      // 1st, 2nd, ..., 7th
      case "co":
        return localize.ordinalNumber(localDayOfWeek, { unit: "day" });
      case "ccc":
        return localize.day(dayOfWeek, {
          width: "abbreviated",
          context: "standalone",
        });
      // T
      case "ccccc":
        return localize.day(dayOfWeek, {
          width: "narrow",
          context: "standalone",
        });
      // Tu
      case "cccccc":
        return localize.day(dayOfWeek, {
          width: "short",
          context: "standalone",
        });
      // Tuesday
      case "cccc":
      default:
        return localize.day(dayOfWeek, {
          width: "wide",
          context: "standalone",
        });
    }
  },

  // ISO day of week
  i: function (date, token, localize) {
    const dayOfWeek = date.getDay();
    const isoDayOfWeek = dayOfWeek === 0 ? 7 : dayOfWeek;
    switch (token) {
      // 2
      case "i":
        return String(isoDayOfWeek);
      // 02
      case "ii":
        return addLeadingZeros(isoDayOfWeek, token.length);
      // 2nd
      case "io":
        return localize.ordinalNumber(isoDayOfWeek, { unit: "day" });
      // Tue
      case "iii":
        return localize.day(dayOfWeek, {
          width: "abbreviated",
          context: "formatting",
        });
      // T
      case "iiiii":
        return localize.day(dayOfWeek, {
          width: "narrow",
          context: "formatting",
        });
      // Tu
      case "iiiiii":
        return localize.day(dayOfWeek, {
          width: "short",
          context: "formatting",
        });
      // Tuesday
      case "iiii":
      default:
        return localize.day(dayOfWeek, {
          width: "wide",
          context: "formatting",
        });
    }
  },

  // AM or PM
  a: function (date, token, localize) {
    const hours = date.getHours();
    const dayPeriodEnumValue = hours / 12 >= 1 ? "pm" : "am";

    switch (token) {
      case "a":
      case "aa":
        return localize.dayPeriod(dayPeriodEnumValue, {
          width: "abbreviated",
          context: "formatting",
        });
      case "aaa":
        return localize
          .dayPeriod(dayPeriodEnumValue, {
            width: "abbreviated",
            context: "formatting",
          })
          .toLowerCase();
      case "aaaaa":
        return localize.dayPeriod(dayPeriodEnumValue, {
          width: "narrow",
          context: "formatting",
        });
      case "aaaa":
      default:
        return localize.dayPeriod(dayPeriodEnumValue, {
          width: "wide",
          context: "formatting",
        });
    }
  },

  // AM, PM, midnight, noon
  b: function (date, token, localize) {
    const hours = date.getHours();
    let dayPeriodEnumValue;
    if (hours === 12) {
      dayPeriodEnumValue = dayPeriodEnum.noon;
    } else if (hours === 0) {
      dayPeriodEnumValue = dayPeriodEnum.midnight;
    } else {
      dayPeriodEnumValue = hours / 12 >= 1 ? "pm" : "am";
    }

    switch (token) {
      case "b":
      case "bb":
        return localize.dayPeriod(dayPeriodEnumValue, {
          width: "abbreviated",
          context: "formatting",
        });
      case "bbb":
        return localize
          .dayPeriod(dayPeriodEnumValue, {
            width: "abbreviated",
            context: "formatting",
          })
          .toLowerCase();
      case "bbbbb":
        return localize.dayPeriod(dayPeriodEnumValue, {
          width: "narrow",
          context: "formatting",
        });
      case "bbbb":
      default:
        return localize.dayPeriod(dayPeriodEnumValue, {
          width: "wide",
          context: "formatting",
        });
    }
  },

  // in the morning, in the afternoon, in the evening, at night
  B: function (date, token, localize) {
    const hours = date.getHours();
    let dayPeriodEnumValue;
    if (hours >= 17) {
      dayPeriodEnumValue = dayPeriodEnum.evening;
    } else if (hours >= 12) {
      dayPeriodEnumValue = dayPeriodEnum.afternoon;
    } else if (hours >= 4) {
      dayPeriodEnumValue = dayPeriodEnum.morning;
    } else {
      dayPeriodEnumValue = dayPeriodEnum.night;
    }

    switch (token) {
      case "B":
      case "BB":
      case "BBB":
        return localize.dayPeriod(dayPeriodEnumValue, {
          width: "abbreviated",
          context: "formatting",
        });
      case "BBBBB":
        return localize.dayPeriod(dayPeriodEnumValue, {
          width: "narrow",
          context: "formatting",
        });
      case "BBBB":
      default:
        return localize.dayPeriod(dayPeriodEnumValue, {
          width: "wide",
          context: "formatting",
        });
    }
  },

  // Hour [1-12]
  h: function (date, token, localize) {
    if (token === "ho") {
      let hours = date.getHours() % 12;
      if (hours === 0) hours = 12;
      return localize.ordinalNumber(hours, { unit: "hour" });
    }

    return lightFormatters.h(date, token);
  },

  // Hour [0-23]
  H: function (date, token, localize) {
    if (token === "Ho") {
      return localize.ordinalNumber(date.getHours(), { unit: "hour" });
    }

    return lightFormatters.H(date, token);
  },

  // Hour [0-11]
  K: function (date, token, localize) {
    const hours = date.getHours() % 12;

    if (token === "Ko") {
      return localize.ordinalNumber(hours, { unit: "hour" });
    }

    return addLeadingZeros(hours, token.length);
  },

  // Hour [1-24]
  k: function (date, token, localize) {
    let hours = date.getHours();
    if (hours === 0) hours = 24;

    if (token === "ko") {
      return localize.ordinalNumber(hours, { unit: "hour" });
    }

    return addLeadingZeros(hours, token.length);
  },

  // Minute
  m: function (date, token, localize) {
    if (token === "mo") {
      return localize.ordinalNumber(date.getMinutes(), { unit: "minute" });
    }

    return lightFormatters.m(date, token);
  },

  // Second
  s: function (date, token, localize) {
    if (token === "so") {
      return localize.ordinalNumber(date.getSeconds(), { unit: "second" });
    }

    return lightFormatters.s(date, token);
  },

  // Fraction of second
  S: function (date, token) {
    return lightFormatters.S(date, token);
  },

  // Timezone (ISO-8601. If offset is 0, output is always `'Z'`)
  X: function (date, token, _localize) {
    const timezoneOffset = date.getTimezoneOffset();

    if (timezoneOffset === 0) {
      return "Z";
    }

    switch (token) {
      // Hours and optional minutes
      case "X":
        return formatTimezoneWithOptionalMinutes(timezoneOffset);

      // Hours, minutes and optional seconds without `:` delimiter
      // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
      // so this token always has the same output as `XX`
      case "XXXX":
      case "XX": // Hours and minutes without `:` delimiter
        return formatTimezone(timezoneOffset);

      // Hours, minutes and optional seconds with `:` delimiter
      // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
      // so this token always has the same output as `XXX`
      case "XXXXX":
      case "XXX": // Hours and minutes with `:` delimiter
      default:
        return formatTimezone(timezoneOffset, ":");
    }
  },

  // Timezone (ISO-8601. If offset is 0, output is `'+00:00'` or equivalent)
  x: function (date, token, _localize) {
    const timezoneOffset = date.getTimezoneOffset();

    switch (token) {
      // Hours and optional minutes
      case "x":
        return formatTimezoneWithOptionalMinutes(timezoneOffset);

      // Hours, minutes and optional seconds without `:` delimiter
      // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
      // so this token always has the same output as `xx`
      case "xxxx":
      case "xx": // Hours and minutes without `:` delimiter
        return formatTimezone(timezoneOffset);

      // Hours, minutes and optional seconds with `:` delimiter
      // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
      // so this token always has the same output as `xxx`
      case "xxxxx":
      case "xxx": // Hours and minutes with `:` delimiter
      default:
        return formatTimezone(timezoneOffset, ":");
    }
  },

  // Timezone (GMT)
  O: function (date, token, _localize) {
    const timezoneOffset = date.getTimezoneOffset();

    switch (token) {
      // Short
      case "O":
      case "OO":
      case "OOO":
        return "GMT" + formatTimezoneShort(timezoneOffset, ":");
      // Long
      case "OOOO":
      default:
        return "GMT" + formatTimezone(timezoneOffset, ":");
    }
  },

  // Timezone (specific non-location)
  z: function (date, token, _localize) {
    const timezoneOffset = date.getTimezoneOffset();

    switch (token) {
      // Short
      case "z":
      case "zz":
      case "zzz":
        return "GMT" + formatTimezoneShort(timezoneOffset, ":");
      // Long
      case "zzzz":
      default:
        return "GMT" + formatTimezone(timezoneOffset, ":");
    }
  },

  // Seconds timestamp
  t: function (date, token, _localize) {
    const timestamp = Math.trunc(date.getTime() / 1000);
    return addLeadingZeros(timestamp, token.length);
  },

  // Milliseconds timestamp
  T: function (date, token, _localize) {
    const timestamp = date.getTime();
    return addLeadingZeros(timestamp, token.length);
  },
};

function formatTimezoneShort(offset, delimiter = "") {
  const sign = offset > 0 ? "-" : "+";
  const absOffset = Math.abs(offset);
  const hours = Math.trunc(absOffset / 60);
  const minutes = absOffset % 60;
  if (minutes === 0) {
    return sign + String(hours);
  }
  return sign + String(hours) + delimiter + addLeadingZeros(minutes, 2);
}

function formatTimezoneWithOptionalMinutes(offset, delimiter) {
  if (offset % 60 === 0) {
    const sign = offset > 0 ? "-" : "+";
    return sign + addLeadingZeros(Math.abs(offset) / 60, 2);
  }
  return formatTimezone(offset, delimiter);
}

function formatTimezone(offset, delimiter = "") {
  const sign = offset > 0 ? "-" : "+";
  const absOffset = Math.abs(offset);
  const hours = addLeadingZeros(Math.trunc(absOffset / 60), 2);
  const minutes = addLeadingZeros(absOffset % 60, 2);
  return sign + hours + delimiter + minutes;
}

;// CONCATENATED MODULE: ./node_modules/date-fns/_lib/format/longFormatters.mjs
const dateLongFormatter = (pattern, formatLong) => {
  switch (pattern) {
    case "P":
      return formatLong.date({ width: "short" });
    case "PP":
      return formatLong.date({ width: "medium" });
    case "PPP":
      return formatLong.date({ width: "long" });
    case "PPPP":
    default:
      return formatLong.date({ width: "full" });
  }
};

const timeLongFormatter = (pattern, formatLong) => {
  switch (pattern) {
    case "p":
      return formatLong.time({ width: "short" });
    case "pp":
      return formatLong.time({ width: "medium" });
    case "ppp":
      return formatLong.time({ width: "long" });
    case "pppp":
    default:
      return formatLong.time({ width: "full" });
  }
};

const dateTimeLongFormatter = (pattern, formatLong) => {
  const matchResult = pattern.match(/(P+)(p+)?/) || [];
  const datePattern = matchResult[1];
  const timePattern = matchResult[2];

  if (!timePattern) {
    return dateLongFormatter(pattern, formatLong);
  }

  let dateTimeFormat;

  switch (datePattern) {
    case "P":
      dateTimeFormat = formatLong.dateTime({ width: "short" });
      break;
    case "PP":
      dateTimeFormat = formatLong.dateTime({ width: "medium" });
      break;
    case "PPP":
      dateTimeFormat = formatLong.dateTime({ width: "long" });
      break;
    case "PPPP":
    default:
      dateTimeFormat = formatLong.dateTime({ width: "full" });
      break;
  }

  return dateTimeFormat
    .replace("{{date}}", dateLongFormatter(datePattern, formatLong))
    .replace("{{time}}", timeLongFormatter(timePattern, formatLong));
};

const longFormatters = {
  p: timeLongFormatter,
  P: dateTimeLongFormatter,
};

;// CONCATENATED MODULE: ./node_modules/date-fns/_lib/protectedTokens.mjs
const dayOfYearTokenRE = /^D+$/;
const weekYearTokenRE = /^Y+$/;

const throwTokens = ["D", "DD", "YY", "YYYY"];

function isProtectedDayOfYearToken(token) {
  return dayOfYearTokenRE.test(token);
}

function isProtectedWeekYearToken(token) {
  return weekYearTokenRE.test(token);
}

function warnOrThrowProtectedError(token, format, input) {
  const _message = message(token, format, input);
  console.warn(_message);
  if (throwTokens.includes(token)) throw new RangeError(_message);
}

function message(token, format, input) {
  const subject = token[0] === "Y" ? "years" : "days of the month";
  return `Use \`${token.toLowerCase()}\` instead of \`${token}\` (in \`${format}\`) for formatting ${subject} to the input \`${input}\`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md`;
}

;// CONCATENATED MODULE: ./node_modules/date-fns/isDate.mjs
/**
 * @name isDate
 * @category Common Helpers
 * @summary Is the given value a date?
 *
 * @description
 * Returns true if the given value is an instance of Date. The function works for dates transferred across iframes.
 *
 * @param value - The value to check
 *
 * @returns True if the given value is a date
 *
 * @example
 * // For a valid date:
 * const result = isDate(new Date())
 * //=> true
 *
 * @example
 * // For an invalid date:
 * const result = isDate(new Date(NaN))
 * //=> true
 *
 * @example
 * // For some value:
 * const result = isDate('2014-02-31')
 * //=> false
 *
 * @example
 * // For an object:
 * const result = isDate({})
 * //=> false
 */
function isDate(value) {
  return (
    value instanceof Date ||
    (typeof value === "object" &&
      Object.prototype.toString.call(value) === "[object Date]")
  );
}

// Fallback for modularized imports:
/* harmony default export */ var date_fns_isDate = ((/* unused pure expression or super */ null && (isDate)));

;// CONCATENATED MODULE: ./node_modules/date-fns/isValid.mjs



/**
 * @name isValid
 * @category Common Helpers
 * @summary Is the given date valid?
 *
 * @description
 * Returns false if argument is Invalid Date and true otherwise.
 * Argument is converted to Date using `toDate`. See [toDate](https://date-fns.org/docs/toDate)
 * Invalid Date is a Date, whose time value is NaN.
 *
 * Time value of Date: http://es5.github.io/#x15.9.1.1
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to check
 *
 * @returns The date is valid
 *
 * @example
 * // For the valid date:
 * const result = isValid(new Date(2014, 1, 31))
 * //=> true
 *
 * @example
 * // For the value, convertable into a date:
 * const result = isValid(1393804800000)
 * //=> true
 *
 * @example
 * // For the invalid date:
 * const result = isValid(new Date(''))
 * //=> false
 */
function isValid(date) {
  if (!isDate(date) && typeof date !== "number") {
    return false;
  }
  const _date = toDate(date);
  return !isNaN(Number(_date));
}

// Fallback for modularized imports:
/* harmony default export */ var date_fns_isValid = ((/* unused pure expression or super */ null && (isValid)));

;// CONCATENATED MODULE: ./node_modules/date-fns/format.mjs








// Rexports of internal for libraries to use.
// See: https://github.com/date-fns/date-fns/issues/3638#issuecomment-1877082874


// This RegExp consists of three parts separated by `|`:
// - [yYQqMLwIdDecihHKkms]o matches any available ordinal number token
//   (one of the certain letters followed by `o`)
// - (\w)\1* matches any sequences of the same letter
// - '' matches two quote characters in a row
// - '(''|[^'])+('|$) matches anything surrounded by two quote characters ('),
//   except a single quote symbol, which ends the sequence.
//   Two quote characters do not end the sequence.
//   If there is no matching single quote
//   then the sequence will continue until the end of the string.
// - . matches any single character unmatched by previous parts of the RegExps
const formattingTokensRegExp =
  /[yYQqMLwIdDecihHKkms]o|(\w)\1*|''|'(''|[^'])+('|$)|./g;

// This RegExp catches symbols escaped by quotes, and also
// sequences of symbols P, p, and the combinations like `PPPPPPPppppp`
const longFormattingTokensRegExp = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g;

const escapedStringRegExp = /^'([^]*?)'?$/;
const doubleQuoteRegExp = /''/g;
const unescapedLatinCharacterRegExp = /[a-zA-Z]/;



/**
 * The {@link format} function options.
 */

/**
 * @name format
 * @alias formatDate
 * @category Common Helpers
 * @summary Format the date.
 *
 * @description
 * Return the formatted date string in the given format. The result may vary by locale.
 *
 * > ⚠️ Please note that the `format` tokens differ from Moment.js and other libraries.
 * > See: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 *
 * The characters wrapped between two single quotes characters (') are escaped.
 * Two single quotes in a row, whether inside or outside a quoted sequence, represent a 'real' single quote.
 * (see the last example)
 *
 * Format of the string is based on Unicode Technical Standard #35:
 * https://www.unicode.org/reports/tr35/tr35-dates.html#Date_Field_Symbol_Table
 * with a few additions (see note 7 below the table).
 *
 * Accepted patterns:
 * | Unit                            | Pattern | Result examples                   | Notes |
 * |---------------------------------|---------|-----------------------------------|-------|
 * | Era                             | G..GGG  | AD, BC                            |       |
 * |                                 | GGGG    | Anno Domini, Before Christ        | 2     |
 * |                                 | GGGGG   | A, B                              |       |
 * | Calendar year                   | y       | 44, 1, 1900, 2017                 | 5     |
 * |                                 | yo      | 44th, 1st, 0th, 17th              | 5,7   |
 * |                                 | yy      | 44, 01, 00, 17                    | 5     |
 * |                                 | yyy     | 044, 001, 1900, 2017              | 5     |
 * |                                 | yyyy    | 0044, 0001, 1900, 2017            | 5     |
 * |                                 | yyyyy   | ...                               | 3,5   |
 * | Local week-numbering year       | Y       | 44, 1, 1900, 2017                 | 5     |
 * |                                 | Yo      | 44th, 1st, 1900th, 2017th         | 5,7   |
 * |                                 | YY      | 44, 01, 00, 17                    | 5,8   |
 * |                                 | YYY     | 044, 001, 1900, 2017              | 5     |
 * |                                 | YYYY    | 0044, 0001, 1900, 2017            | 5,8   |
 * |                                 | YYYYY   | ...                               | 3,5   |
 * | ISO week-numbering year         | R       | -43, 0, 1, 1900, 2017             | 5,7   |
 * |                                 | RR      | -43, 00, 01, 1900, 2017           | 5,7   |
 * |                                 | RRR     | -043, 000, 001, 1900, 2017        | 5,7   |
 * |                                 | RRRR    | -0043, 0000, 0001, 1900, 2017     | 5,7   |
 * |                                 | RRRRR   | ...                               | 3,5,7 |
 * | Extended year                   | u       | -43, 0, 1, 1900, 2017             | 5     |
 * |                                 | uu      | -43, 01, 1900, 2017               | 5     |
 * |                                 | uuu     | -043, 001, 1900, 2017             | 5     |
 * |                                 | uuuu    | -0043, 0001, 1900, 2017           | 5     |
 * |                                 | uuuuu   | ...                               | 3,5   |
 * | Quarter (formatting)            | Q       | 1, 2, 3, 4                        |       |
 * |                                 | Qo      | 1st, 2nd, 3rd, 4th                | 7     |
 * |                                 | QQ      | 01, 02, 03, 04                    |       |
 * |                                 | QQQ     | Q1, Q2, Q3, Q4                    |       |
 * |                                 | QQQQ    | 1st quarter, 2nd quarter, ...     | 2     |
 * |                                 | QQQQQ   | 1, 2, 3, 4                        | 4     |
 * | Quarter (stand-alone)           | q       | 1, 2, 3, 4                        |       |
 * |                                 | qo      | 1st, 2nd, 3rd, 4th                | 7     |
 * |                                 | qq      | 01, 02, 03, 04                    |       |
 * |                                 | qqq     | Q1, Q2, Q3, Q4                    |       |
 * |                                 | qqqq    | 1st quarter, 2nd quarter, ...     | 2     |
 * |                                 | qqqqq   | 1, 2, 3, 4                        | 4     |
 * | Month (formatting)              | M       | 1, 2, ..., 12                     |       |
 * |                                 | Mo      | 1st, 2nd, ..., 12th               | 7     |
 * |                                 | MM      | 01, 02, ..., 12                   |       |
 * |                                 | MMM     | Jan, Feb, ..., Dec                |       |
 * |                                 | MMMM    | January, February, ..., December  | 2     |
 * |                                 | MMMMM   | J, F, ..., D                      |       |
 * | Month (stand-alone)             | L       | 1, 2, ..., 12                     |       |
 * |                                 | Lo      | 1st, 2nd, ..., 12th               | 7     |
 * |                                 | LL      | 01, 02, ..., 12                   |       |
 * |                                 | LLL     | Jan, Feb, ..., Dec                |       |
 * |                                 | LLLL    | January, February, ..., December  | 2     |
 * |                                 | LLLLL   | J, F, ..., D                      |       |
 * | Local week of year              | w       | 1, 2, ..., 53                     |       |
 * |                                 | wo      | 1st, 2nd, ..., 53th               | 7     |
 * |                                 | ww      | 01, 02, ..., 53                   |       |
 * | ISO week of year                | I       | 1, 2, ..., 53                     | 7     |
 * |                                 | Io      | 1st, 2nd, ..., 53th               | 7     |
 * |                                 | II      | 01, 02, ..., 53                   | 7     |
 * | Day of month                    | d       | 1, 2, ..., 31                     |       |
 * |                                 | do      | 1st, 2nd, ..., 31st               | 7     |
 * |                                 | dd      | 01, 02, ..., 31                   |       |
 * | Day of year                     | D       | 1, 2, ..., 365, 366               | 9     |
 * |                                 | Do      | 1st, 2nd, ..., 365th, 366th       | 7     |
 * |                                 | DD      | 01, 02, ..., 365, 366             | 9     |
 * |                                 | DDD     | 001, 002, ..., 365, 366           |       |
 * |                                 | DDDD    | ...                               | 3     |
 * | Day of week (formatting)        | E..EEE  | Mon, Tue, Wed, ..., Sun           |       |
 * |                                 | EEEE    | Monday, Tuesday, ..., Sunday      | 2     |
 * |                                 | EEEEE   | M, T, W, T, F, S, S               |       |
 * |                                 | EEEEEE  | Mo, Tu, We, Th, Fr, Sa, Su        |       |
 * | ISO day of week (formatting)    | i       | 1, 2, 3, ..., 7                   | 7     |
 * |                                 | io      | 1st, 2nd, ..., 7th                | 7     |
 * |                                 | ii      | 01, 02, ..., 07                   | 7     |
 * |                                 | iii     | Mon, Tue, Wed, ..., Sun           | 7     |
 * |                                 | iiii    | Monday, Tuesday, ..., Sunday      | 2,7   |
 * |                                 | iiiii   | M, T, W, T, F, S, S               | 7     |
 * |                                 | iiiiii  | Mo, Tu, We, Th, Fr, Sa, Su        | 7     |
 * | Local day of week (formatting)  | e       | 2, 3, 4, ..., 1                   |       |
 * |                                 | eo      | 2nd, 3rd, ..., 1st                | 7     |
 * |                                 | ee      | 02, 03, ..., 01                   |       |
 * |                                 | eee     | Mon, Tue, Wed, ..., Sun           |       |
 * |                                 | eeee    | Monday, Tuesday, ..., Sunday      | 2     |
 * |                                 | eeeee   | M, T, W, T, F, S, S               |       |
 * |                                 | eeeeee  | Mo, Tu, We, Th, Fr, Sa, Su        |       |
 * | Local day of week (stand-alone) | c       | 2, 3, 4, ..., 1                   |       |
 * |                                 | co      | 2nd, 3rd, ..., 1st                | 7     |
 * |                                 | cc      | 02, 03, ..., 01                   |       |
 * |                                 | ccc     | Mon, Tue, Wed, ..., Sun           |       |
 * |                                 | cccc    | Monday, Tuesday, ..., Sunday      | 2     |
 * |                                 | ccccc   | M, T, W, T, F, S, S               |       |
 * |                                 | cccccc  | Mo, Tu, We, Th, Fr, Sa, Su        |       |
 * | AM, PM                          | a..aa   | AM, PM                            |       |
 * |                                 | aaa     | am, pm                            |       |
 * |                                 | aaaa    | a.m., p.m.                        | 2     |
 * |                                 | aaaaa   | a, p                              |       |
 * | AM, PM, noon, midnight          | b..bb   | AM, PM, noon, midnight            |       |
 * |                                 | bbb     | am, pm, noon, midnight            |       |
 * |                                 | bbbb    | a.m., p.m., noon, midnight        | 2     |
 * |                                 | bbbbb   | a, p, n, mi                       |       |
 * | Flexible day period             | B..BBB  | at night, in the morning, ...     |       |
 * |                                 | BBBB    | at night, in the morning, ...     | 2     |
 * |                                 | BBBBB   | at night, in the morning, ...     |       |
 * | Hour [1-12]                     | h       | 1, 2, ..., 11, 12                 |       |
 * |                                 | ho      | 1st, 2nd, ..., 11th, 12th         | 7     |
 * |                                 | hh      | 01, 02, ..., 11, 12               |       |
 * | Hour [0-23]                     | H       | 0, 1, 2, ..., 23                  |       |
 * |                                 | Ho      | 0th, 1st, 2nd, ..., 23rd          | 7     |
 * |                                 | HH      | 00, 01, 02, ..., 23               |       |
 * | Hour [0-11]                     | K       | 1, 2, ..., 11, 0                  |       |
 * |                                 | Ko      | 1st, 2nd, ..., 11th, 0th          | 7     |
 * |                                 | KK      | 01, 02, ..., 11, 00               |       |
 * | Hour [1-24]                     | k       | 24, 1, 2, ..., 23                 |       |
 * |                                 | ko      | 24th, 1st, 2nd, ..., 23rd         | 7     |
 * |                                 | kk      | 24, 01, 02, ..., 23               |       |
 * | Minute                          | m       | 0, 1, ..., 59                     |       |
 * |                                 | mo      | 0th, 1st, ..., 59th               | 7     |
 * |                                 | mm      | 00, 01, ..., 59                   |       |
 * | Second                          | s       | 0, 1, ..., 59                     |       |
 * |                                 | so      | 0th, 1st, ..., 59th               | 7     |
 * |                                 | ss      | 00, 01, ..., 59                   |       |
 * | Fraction of second              | S       | 0, 1, ..., 9                      |       |
 * |                                 | SS      | 00, 01, ..., 99                   |       |
 * |                                 | SSS     | 000, 001, ..., 999                |       |
 * |                                 | SSSS    | ...                               | 3     |
 * | Timezone (ISO-8601 w/ Z)        | X       | -08, +0530, Z                     |       |
 * |                                 | XX      | -0800, +0530, Z                   |       |
 * |                                 | XXX     | -08:00, +05:30, Z                 |       |
 * |                                 | XXXX    | -0800, +0530, Z, +123456          | 2     |
 * |                                 | XXXXX   | -08:00, +05:30, Z, +12:34:56      |       |
 * | Timezone (ISO-8601 w/o Z)       | x       | -08, +0530, +00                   |       |
 * |                                 | xx      | -0800, +0530, +0000               |       |
 * |                                 | xxx     | -08:00, +05:30, +00:00            | 2     |
 * |                                 | xxxx    | -0800, +0530, +0000, +123456      |       |
 * |                                 | xxxxx   | -08:00, +05:30, +00:00, +12:34:56 |       |
 * | Timezone (GMT)                  | O...OOO | GMT-8, GMT+5:30, GMT+0            |       |
 * |                                 | OOOO    | GMT-08:00, GMT+05:30, GMT+00:00   | 2     |
 * | Timezone (specific non-locat.)  | z...zzz | GMT-8, GMT+5:30, GMT+0            | 6     |
 * |                                 | zzzz    | GMT-08:00, GMT+05:30, GMT+00:00   | 2,6   |
 * | Seconds timestamp               | t       | 512969520                         | 7     |
 * |                                 | tt      | ...                               | 3,7   |
 * | Milliseconds timestamp          | T       | 512969520900                      | 7     |
 * |                                 | TT      | ...                               | 3,7   |
 * | Long localized date             | P       | 04/29/1453                        | 7     |
 * |                                 | PP      | Apr 29, 1453                      | 7     |
 * |                                 | PPP     | April 29th, 1453                  | 7     |
 * |                                 | PPPP    | Friday, April 29th, 1453          | 2,7   |
 * | Long localized time             | p       | 12:00 AM                          | 7     |
 * |                                 | pp      | 12:00:00 AM                       | 7     |
 * |                                 | ppp     | 12:00:00 AM GMT+2                 | 7     |
 * |                                 | pppp    | 12:00:00 AM GMT+02:00             | 2,7   |
 * | Combination of date and time    | Pp      | 04/29/1453, 12:00 AM              | 7     |
 * |                                 | PPpp    | Apr 29, 1453, 12:00:00 AM         | 7     |
 * |                                 | PPPppp  | April 29th, 1453 at ...           | 7     |
 * |                                 | PPPPpppp| Friday, April 29th, 1453 at ...   | 2,7   |
 * Notes:
 * 1. "Formatting" units (e.g. formatting quarter) in the default en-US locale
 *    are the same as "stand-alone" units, but are different in some languages.
 *    "Formatting" units are declined according to the rules of the language
 *    in the context of a date. "Stand-alone" units are always nominative singular:
 *
 *    `format(new Date(2017, 10, 6), 'do LLLL', {locale: cs}) //=> '6. listopad'`
 *
 *    `format(new Date(2017, 10, 6), 'do MMMM', {locale: cs}) //=> '6. listopadu'`
 *
 * 2. Any sequence of the identical letters is a pattern, unless it is escaped by
 *    the single quote characters (see below).
 *    If the sequence is longer than listed in table (e.g. `EEEEEEEEEEE`)
 *    the output will be the same as default pattern for this unit, usually
 *    the longest one (in case of ISO weekdays, `EEEE`). Default patterns for units
 *    are marked with "2" in the last column of the table.
 *
 *    `format(new Date(2017, 10, 6), 'MMM') //=> 'Nov'`
 *
 *    `format(new Date(2017, 10, 6), 'MMMM') //=> 'November'`
 *
 *    `format(new Date(2017, 10, 6), 'MMMMM') //=> 'N'`
 *
 *    `format(new Date(2017, 10, 6), 'MMMMMM') //=> 'November'`
 *
 *    `format(new Date(2017, 10, 6), 'MMMMMMM') //=> 'November'`
 *
 * 3. Some patterns could be unlimited length (such as `yyyyyyyy`).
 *    The output will be padded with zeros to match the length of the pattern.
 *
 *    `format(new Date(2017, 10, 6), 'yyyyyyyy') //=> '00002017'`
 *
 * 4. `QQQQQ` and `qqqqq` could be not strictly numerical in some locales.
 *    These tokens represent the shortest form of the quarter.
 *
 * 5. The main difference between `y` and `u` patterns are B.C. years:
 *
 *    | Year | `y` | `u` |
 *    |------|-----|-----|
 *    | AC 1 |   1 |   1 |
 *    | BC 1 |   1 |   0 |
 *    | BC 2 |   2 |  -1 |
 *
 *    Also `yy` always returns the last two digits of a year,
 *    while `uu` pads single digit years to 2 characters and returns other years unchanged:
 *
 *    | Year | `yy` | `uu` |
 *    |------|------|------|
 *    | 1    |   01 |   01 |
 *    | 14   |   14 |   14 |
 *    | 376  |   76 |  376 |
 *    | 1453 |   53 | 1453 |
 *
 *    The same difference is true for local and ISO week-numbering years (`Y` and `R`),
 *    except local week-numbering years are dependent on `options.weekStartsOn`
 *    and `options.firstWeekContainsDate` (compare [getISOWeekYear](https://date-fns.org/docs/getISOWeekYear)
 *    and [getWeekYear](https://date-fns.org/docs/getWeekYear)).
 *
 * 6. Specific non-location timezones are currently unavailable in `date-fns`,
 *    so right now these tokens fall back to GMT timezones.
 *
 * 7. These patterns are not in the Unicode Technical Standard #35:
 *    - `i`: ISO day of week
 *    - `I`: ISO week of year
 *    - `R`: ISO week-numbering year
 *    - `t`: seconds timestamp
 *    - `T`: milliseconds timestamp
 *    - `o`: ordinal number modifier
 *    - `P`: long localized date
 *    - `p`: long localized time
 *
 * 8. `YY` and `YYYY` tokens represent week-numbering years but they are often confused with years.
 *    You should enable `options.useAdditionalWeekYearTokens` to use them. See: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 *
 * 9. `D` and `DD` tokens represent days of the year but they are often confused with days of the month.
 *    You should enable `options.useAdditionalDayOfYearTokens` to use them. See: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The original date
 * @param format - The string of tokens
 * @param options - An object with options
 *
 * @returns The formatted date string
 *
 * @throws `date` must not be Invalid Date
 * @throws `options.locale` must contain `localize` property
 * @throws `options.locale` must contain `formatLong` property
 * @throws use `yyyy` instead of `YYYY` for formatting years using [format provided] to the input [input provided]; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 * @throws use `yy` instead of `YY` for formatting years using [format provided] to the input [input provided]; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 * @throws use `d` instead of `D` for formatting days of the month using [format provided] to the input [input provided]; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 * @throws use `dd` instead of `DD` for formatting days of the month using [format provided] to the input [input provided]; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 * @throws format string contains an unescaped latin alphabet character
 *
 * @example
 * // Represent 11 February 2014 in middle-endian format:
 * const result = format(new Date(2014, 1, 11), 'MM/dd/yyyy')
 * //=> '02/11/2014'
 *
 * @example
 * // Represent 2 July 2014 in Esperanto:
 * import { eoLocale } from 'date-fns/locale/eo'
 * const result = format(new Date(2014, 6, 2), "do 'de' MMMM yyyy", {
 *   locale: eoLocale
 * })
 * //=> '2-a de julio 2014'
 *
 * @example
 * // Escape string by single quote characters:
 * const result = format(new Date(2014, 6, 2, 15), "h 'o''clock'")
 * //=> "3 o'clock"
 */
function format_format(date, formatStr, options) {
  const defaultOptions = getDefaultOptions();
  const locale = options?.locale ?? defaultOptions.locale ?? en_US_enUS;

  const firstWeekContainsDate =
    options?.firstWeekContainsDate ??
    options?.locale?.options?.firstWeekContainsDate ??
    defaultOptions.firstWeekContainsDate ??
    defaultOptions.locale?.options?.firstWeekContainsDate ??
    1;

  const weekStartsOn =
    options?.weekStartsOn ??
    options?.locale?.options?.weekStartsOn ??
    defaultOptions.weekStartsOn ??
    defaultOptions.locale?.options?.weekStartsOn ??
    0;

  const originalDate = toDate(date);

  if (!isValid(originalDate)) {
    throw new RangeError("Invalid time value");
  }

  let parts = formatStr
    .match(longFormattingTokensRegExp)
    .map((substring) => {
      const firstCharacter = substring[0];
      if (firstCharacter === "p" || firstCharacter === "P") {
        const longFormatter = longFormatters[firstCharacter];
        return longFormatter(substring, locale.formatLong);
      }
      return substring;
    })
    .join("")
    .match(formattingTokensRegExp)
    .map((substring) => {
      // Replace two single quote characters with one single quote character
      if (substring === "''") {
        return { isToken: false, value: "'" };
      }

      const firstCharacter = substring[0];
      if (firstCharacter === "'") {
        return { isToken: false, value: cleanEscapedString(substring) };
      }

      if (formatters[firstCharacter]) {
        return { isToken: true, value: substring };
      }

      if (firstCharacter.match(unescapedLatinCharacterRegExp)) {
        throw new RangeError(
          "Format string contains an unescaped latin alphabet character `" +
            firstCharacter +
            "`",
        );
      }

      return { isToken: false, value: substring };
    });

  // invoke localize preprocessor (only for french locales at the moment)
  if (locale.localize.preprocessor) {
    parts = locale.localize.preprocessor(originalDate, parts);
  }

  const formatterOptions = {
    firstWeekContainsDate,
    weekStartsOn,
    locale,
  };

  return parts
    .map((part) => {
      if (!part.isToken) return part.value;

      const token = part.value;

      if (
        (!options?.useAdditionalWeekYearTokens &&
          isProtectedWeekYearToken(token)) ||
        (!options?.useAdditionalDayOfYearTokens &&
          isProtectedDayOfYearToken(token))
      ) {
        warnOrThrowProtectedError(token, formatStr, String(date));
      }

      const formatter = formatters[token[0]];
      return formatter(originalDate, token, locale.localize, formatterOptions);
    })
    .join("");
}

function cleanEscapedString(input) {
  const matched = input.match(escapedStringRegExp);

  if (!matched) {
    return input;
  }

  return matched[1].replace(doubleQuoteRegExp, "'");
}

// Fallback for modularized imports:
/* harmony default export */ var date_fns_format = ((/* unused pure expression or super */ null && (format_format)));

;// CONCATENATED MODULE: ./node_modules/date-fns/startOfMonth.mjs


/**
 * @name startOfMonth
 * @category Month Helpers
 * @summary Return the start of a month for the given date.
 *
 * @description
 * Return the start of a month for the given date.
 * The result will be in the local timezone.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The original date
 *
 * @returns The start of a month
 *
 * @example
 * // The start of a month for 2 September 2014 11:55:00:
 * const result = startOfMonth(new Date(2014, 8, 2, 11, 55, 0))
 * //=> Mon Sep 01 2014 00:00:00
 */
function startOfMonth(date) {
  const _date = toDate(date);
  _date.setDate(1);
  _date.setHours(0, 0, 0, 0);
  return _date;
}

// Fallback for modularized imports:
/* harmony default export */ var date_fns_startOfMonth = ((/* unused pure expression or super */ null && (startOfMonth)));

;// CONCATENATED MODULE: ./node_modules/date-fns/endOfMonth.mjs


/**
 * @name endOfMonth
 * @category Month Helpers
 * @summary Return the end of a month for the given date.
 *
 * @description
 * Return the end of a month for the given date.
 * The result will be in the local timezone.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The original date
 *
 * @returns The end of a month
 *
 * @example
 * // The end of a month for 2 September 2014 11:55:00:
 * const result = endOfMonth(new Date(2014, 8, 2, 11, 55, 0))
 * //=> Tue Sep 30 2014 23:59:59.999
 */
function endOfMonth(date) {
  const _date = toDate(date);
  const month = _date.getMonth();
  _date.setFullYear(_date.getFullYear(), month + 1, 0);
  _date.setHours(23, 59, 59, 999);
  return _date;
}

// Fallback for modularized imports:
/* harmony default export */ var date_fns_endOfMonth = ((/* unused pure expression or super */ null && (endOfMonth)));

;// CONCATENATED MODULE: ./node_modules/date-fns/isSameYear.mjs


/**
 * @name isSameYear
 * @category Year Helpers
 * @summary Are the given dates in the same year?
 *
 * @description
 * Are the given dates in the same year?
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param dateLeft - The first date to check
 * @param dateRight - The second date to check
 *
 * @returns The dates are in the same year
 *
 * @example
 * // Are 2 September 2014 and 25 September 2014 in the same year?
 * const result = isSameYear(new Date(2014, 8, 2), new Date(2014, 8, 25))
 * //=> true
 */
function isSameYear(dateLeft, dateRight) {
  const _dateLeft = toDate(dateLeft);
  const _dateRight = toDate(dateRight);
  return _dateLeft.getFullYear() === _dateRight.getFullYear();
}

// Fallback for modularized imports:
/* harmony default export */ var date_fns_isSameYear = ((/* unused pure expression or super */ null && (isSameYear)));

;// CONCATENATED MODULE: ./node_modules/date-fns/getDaysInMonth.mjs



/**
 * @name getDaysInMonth
 * @category Month Helpers
 * @summary Get the number of days in a month of the given date.
 *
 * @description
 * Get the number of days in a month of the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The given date
 *
 * @returns The number of days in a month
 *
 * @example
 * // How many days are in February 2000?
 * const result = getDaysInMonth(new Date(2000, 1))
 * //=> 29
 */
function getDaysInMonth(date) {
  const _date = toDate(date);
  const year = _date.getFullYear();
  const monthIndex = _date.getMonth();
  const lastDayOfMonth = constructFrom(date, 0);
  lastDayOfMonth.setFullYear(year, monthIndex + 1, 0);
  lastDayOfMonth.setHours(0, 0, 0, 0);
  return lastDayOfMonth.getDate();
}

// Fallback for modularized imports:
/* harmony default export */ var date_fns_getDaysInMonth = ((/* unused pure expression or super */ null && (getDaysInMonth)));

;// CONCATENATED MODULE: ./node_modules/date-fns/setMonth.mjs




/**
 * @name setMonth
 * @category Month Helpers
 * @summary Set the month to the given date.
 *
 * @description
 * Set the month to the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to be changed
 * @param month - The month of the new date
 *
 * @returns The new date with the month set
 *
 * @example
 * // Set February to 1 September 2014:
 * const result = setMonth(new Date(2014, 8, 1), 1)
 * //=> Sat Feb 01 2014 00:00:00
 */
function setMonth(date, month) {
  const _date = toDate(date);
  const year = _date.getFullYear();
  const day = _date.getDate();

  const dateWithDesiredMonth = constructFrom(date, 0);
  dateWithDesiredMonth.setFullYear(year, month, 15);
  dateWithDesiredMonth.setHours(0, 0, 0, 0);
  const daysInMonth = getDaysInMonth(dateWithDesiredMonth);
  // Set the last day of the new month
  // if the original date was the last day of the longer month
  _date.setMonth(month, Math.min(day, daysInMonth));
  return _date;
}

// Fallback for modularized imports:
/* harmony default export */ var date_fns_setMonth = ((/* unused pure expression or super */ null && (setMonth)));

;// CONCATENATED MODULE: ./node_modules/date-fns/setYear.mjs



/**
 * @name setYear
 * @category Year Helpers
 * @summary Set the year to the given date.
 *
 * @description
 * Set the year to the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to be changed
 * @param year - The year of the new date
 *
 * @returns The new date with the year set
 *
 * @example
 * // Set year 2013 to 1 September 2014:
 * const result = setYear(new Date(2014, 8, 1), 2013)
 * //=> Sun Sep 01 2013 00:00:00
 */
function setYear(date, year) {
  const _date = toDate(date);

  // Check if date is Invalid Date because Date.prototype.setFullYear ignores the value of Invalid Date
  if (isNaN(+_date)) {
    return constructFrom(date, NaN);
  }

  _date.setFullYear(year);
  return _date;
}

// Fallback for modularized imports:
/* harmony default export */ var date_fns_setYear = ((/* unused pure expression or super */ null && (setYear)));

;// CONCATENATED MODULE: ./node_modules/date-fns/differenceInCalendarMonths.mjs


/**
 * @name differenceInCalendarMonths
 * @category Month Helpers
 * @summary Get the number of calendar months between the given dates.
 *
 * @description
 * Get the number of calendar months between the given dates.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param dateLeft - The later date
 * @param dateRight - The earlier date
 *
 * @returns The number of calendar months
 *
 * @example
 * // How many calendar months are between 31 January 2014 and 1 September 2014?
 * const result = differenceInCalendarMonths(
 *   new Date(2014, 8, 1),
 *   new Date(2014, 0, 31)
 * )
 * //=> 8
 */
function differenceInCalendarMonths(dateLeft, dateRight) {
  const _dateLeft = toDate(dateLeft);
  const _dateRight = toDate(dateRight);

  const yearDiff = _dateLeft.getFullYear() - _dateRight.getFullYear();
  const monthDiff = _dateLeft.getMonth() - _dateRight.getMonth();

  return yearDiff * 12 + monthDiff;
}

// Fallback for modularized imports:
/* harmony default export */ var date_fns_differenceInCalendarMonths = ((/* unused pure expression or super */ null && (differenceInCalendarMonths)));

;// CONCATENATED MODULE: ./node_modules/date-fns/addMonths.mjs



/**
 * @name addMonths
 * @category Month Helpers
 * @summary Add the specified number of months to the given date.
 *
 * @description
 * Add the specified number of months to the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to be changed
 * @param amount - The amount of months to be added.
 *
 * @returns The new date with the months added
 *
 * @example
 * // Add 5 months to 1 September 2014:
 * const result = addMonths(new Date(2014, 8, 1), 5)
 * //=> Sun Feb 01 2015 00:00:00
 *
 * // Add one month to 30 January 2023:
 * const result = addMonths(new Date(2023, 0, 30), 1)
 * //=> Tue Feb 28 2023 00:00:00
 */
function addMonths(date, amount) {
  const _date = toDate(date);
  if (isNaN(amount)) return constructFrom(date, NaN);
  if (!amount) {
    // If 0 months, no-op to avoid changing times in the hour before end of DST
    return _date;
  }
  const dayOfMonth = _date.getDate();

  // The JS Date object supports date math by accepting out-of-bounds values for
  // month, day, etc. For example, new Date(2020, 0, 0) returns 31 Dec 2019 and
  // new Date(2020, 13, 1) returns 1 Feb 2021.  This is *almost* the behavior we
  // want except that dates will wrap around the end of a month, meaning that
  // new Date(2020, 13, 31) will return 3 Mar 2021 not 28 Feb 2021 as desired. So
  // we'll default to the end of the desired month by adding 1 to the desired
  // month and using a date of 0 to back up one day to the end of the desired
  // month.
  const endOfDesiredMonth = constructFrom(date, _date.getTime());
  endOfDesiredMonth.setMonth(_date.getMonth() + amount + 1, 0);
  const daysInMonth = endOfDesiredMonth.getDate();
  if (dayOfMonth >= daysInMonth) {
    // If we're already at the end of the month, then this is the correct date
    // and we're done.
    return endOfDesiredMonth;
  } else {
    // Otherwise, we now know that setting the original day-of-month value won't
    // cause an overflow, so set the desired day-of-month. Note that we can't
    // just set the date of `endOfDesiredMonth` because that object may have had
    // its time changed in the unusual case where where a DST transition was on
    // the last day of the month and its local time was in the hour skipped or
    // repeated next to a DST transition.  So we use `date` instead which is
    // guaranteed to still have the original time.
    _date.setFullYear(
      endOfDesiredMonth.getFullYear(),
      endOfDesiredMonth.getMonth(),
      dayOfMonth,
    );
    return _date;
  }
}

// Fallback for modularized imports:
/* harmony default export */ var date_fns_addMonths = ((/* unused pure expression or super */ null && (addMonths)));

;// CONCATENATED MODULE: ./node_modules/date-fns/isSameMonth.mjs


/**
 * @name isSameMonth
 * @category Month Helpers
 * @summary Are the given dates in the same month (and year)?
 *
 * @description
 * Are the given dates in the same month (and year)?
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param dateLeft - The first date to check
 * @param dateRight - The second date to check
 *
 * @returns The dates are in the same month (and year)
 *
 * @example
 * // Are 2 September 2014 and 25 September 2014 in the same month?
 * const result = isSameMonth(new Date(2014, 8, 2), new Date(2014, 8, 25))
 * //=> true
 *
 * @example
 * // Are 2 September 2014 and 25 September 2015 in the same month?
 * const result = isSameMonth(new Date(2014, 8, 2), new Date(2015, 8, 25))
 * //=> false
 */
function isSameMonth(dateLeft, dateRight) {
  const _dateLeft = toDate(dateLeft);
  const _dateRight = toDate(dateRight);
  return (
    _dateLeft.getFullYear() === _dateRight.getFullYear() &&
    _dateLeft.getMonth() === _dateRight.getMonth()
  );
}

// Fallback for modularized imports:
/* harmony default export */ var date_fns_isSameMonth = ((/* unused pure expression or super */ null && (isSameMonth)));

;// CONCATENATED MODULE: ./node_modules/date-fns/isBefore.mjs


/**
 * @name isBefore
 * @category Common Helpers
 * @summary Is the first date before the second one?
 *
 * @description
 * Is the first date before the second one?
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date that should be before the other one to return true
 * @param dateToCompare - The date to compare with
 *
 * @returns The first date is before the second date
 *
 * @example
 * // Is 10 July 1989 before 11 February 1987?
 * const result = isBefore(new Date(1989, 6, 10), new Date(1987, 1, 11))
 * //=> false
 */
function isBefore(date, dateToCompare) {
  const _date = toDate(date);
  const _dateToCompare = toDate(dateToCompare);
  return +_date < +_dateToCompare;
}

// Fallback for modularized imports:
/* harmony default export */ var date_fns_isBefore = ((/* unused pure expression or super */ null && (isBefore)));

;// CONCATENATED MODULE: ./node_modules/date-fns/addDays.mjs



/**
 * @name addDays
 * @category Day Helpers
 * @summary Add the specified number of days to the given date.
 *
 * @description
 * Add the specified number of days to the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to be changed
 * @param amount - The amount of days to be added.
 *
 * @returns The new date with the days added
 *
 * @example
 * // Add 10 days to 1 September 2014:
 * const result = addDays(new Date(2014, 8, 1), 10)
 * //=> Thu Sep 11 2014 00:00:00
 */
function addDays(date, amount) {
  const _date = toDate(date);
  if (isNaN(amount)) return constructFrom(date, NaN);
  if (!amount) {
    // If 0 days, no-op to avoid changing times in the hour before end of DST
    return _date;
  }
  _date.setDate(_date.getDate() + amount);
  return _date;
}

// Fallback for modularized imports:
/* harmony default export */ var date_fns_addDays = ((/* unused pure expression or super */ null && (addDays)));

;// CONCATENATED MODULE: ./node_modules/date-fns/isSameDay.mjs


/**
 * @name isSameDay
 * @category Day Helpers
 * @summary Are the given dates in the same day (and year and month)?
 *
 * @description
 * Are the given dates in the same day (and year and month)?
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param dateLeft - The first date to check
 * @param dateRight - The second date to check

 * @returns The dates are in the same day (and year and month)
 *
 * @example
 * // Are 4 September 06:00:00 and 4 September 18:00:00 in the same day?
 * const result = isSameDay(new Date(2014, 8, 4, 6, 0), new Date(2014, 8, 4, 18, 0))
 * //=> true
 *
 * @example
 * // Are 4 September and 4 October in the same day?
 * const result = isSameDay(new Date(2014, 8, 4), new Date(2014, 9, 4))
 * //=> false
 *
 * @example
 * // Are 4 September, 2014 and 4 September, 2015 in the same day?
 * const result = isSameDay(new Date(2014, 8, 4), new Date(2015, 8, 4))
 * //=> false
 */
function isSameDay(dateLeft, dateRight) {
  const dateLeftStartOfDay = startOfDay(dateLeft);
  const dateRightStartOfDay = startOfDay(dateRight);

  return +dateLeftStartOfDay === +dateRightStartOfDay;
}

// Fallback for modularized imports:
/* harmony default export */ var date_fns_isSameDay = ((/* unused pure expression or super */ null && (isSameDay)));

;// CONCATENATED MODULE: ./node_modules/date-fns/isAfter.mjs


/**
 * @name isAfter
 * @category Common Helpers
 * @summary Is the first date after the second one?
 *
 * @description
 * Is the first date after the second one?
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date that should be after the other one to return true
 * @param dateToCompare - The date to compare with
 *
 * @returns The first date is after the second date
 *
 * @example
 * // Is 10 July 1989 after 11 February 1987?
 * const result = isAfter(new Date(1989, 6, 10), new Date(1987, 1, 11))
 * //=> true
 */
function isAfter(date, dateToCompare) {
  const _date = toDate(date);
  const _dateToCompare = toDate(dateToCompare);
  return _date.getTime() > _dateToCompare.getTime();
}

// Fallback for modularized imports:
/* harmony default export */ var date_fns_isAfter = ((/* unused pure expression or super */ null && (isAfter)));

;// CONCATENATED MODULE: ./node_modules/date-fns/subDays.mjs


/**
 * @name subDays
 * @category Day Helpers
 * @summary Subtract the specified number of days from the given date.
 *
 * @description
 * Subtract the specified number of days from the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to be changed
 * @param amount - The amount of days to be subtracted.
 *
 * @returns The new date with the days subtracted
 *
 * @example
 * // Subtract 10 days from 1 September 2014:
 * const result = subDays(new Date(2014, 8, 1), 10)
 * //=> Fri Aug 22 2014 00:00:00
 */
function subDays(date, amount) {
  return addDays(date, -amount);
}

// Fallback for modularized imports:
/* harmony default export */ var date_fns_subDays = ((/* unused pure expression or super */ null && (subDays)));

;// CONCATENATED MODULE: ./node_modules/date-fns/addWeeks.mjs


/**
 * @name addWeeks
 * @category Week Helpers
 * @summary Add the specified number of weeks to the given date.
 *
 * @description
 * Add the specified number of week to the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to be changed
 * @param amount - The amount of weeks to be added.
 *
 * @returns The new date with the weeks added
 *
 * @example
 * // Add 4 weeks to 1 September 2014:
 * const result = addWeeks(new Date(2014, 8, 1), 4)
 * //=> Mon Sep 29 2014 00:00:00
 */
function addWeeks(date, amount) {
  const days = amount * 7;
  return addDays(date, days);
}

// Fallback for modularized imports:
/* harmony default export */ var date_fns_addWeeks = ((/* unused pure expression or super */ null && (addWeeks)));

;// CONCATENATED MODULE: ./node_modules/date-fns/addYears.mjs


/**
 * @name addYears
 * @category Year Helpers
 * @summary Add the specified number of years to the given date.
 *
 * @description
 * Add the specified number of years to the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to be changed
 * @param amount - The amount of years to be added.
 *
 * @returns The new date with the years added
 *
 * @example
 * // Add 5 years to 1 September 2014:
 * const result = addYears(new Date(2014, 8, 1), 5)
 * //=> Sun Sep 01 2019 00:00:00
 */
function addYears(date, amount) {
  return addMonths(date, amount * 12);
}

// Fallback for modularized imports:
/* harmony default export */ var date_fns_addYears = ((/* unused pure expression or super */ null && (addYears)));

;// CONCATENATED MODULE: ./node_modules/date-fns/endOfWeek.mjs



/**
 * The {@link endOfWeek} function options.
 */

/**
 * @name endOfWeek
 * @category Week Helpers
 * @summary Return the end of a week for the given date.
 *
 * @description
 * Return the end of a week for the given date.
 * The result will be in the local timezone.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The original date
 * @param options - An object with options
 *
 * @returns The end of a week
 *
 * @example
 * // The end of a week for 2 September 2014 11:55:00:
 * const result = endOfWeek(new Date(2014, 8, 2, 11, 55, 0))
 * //=> Sat Sep 06 2014 23:59:59.999
 *
 * @example
 * // If the week starts on Monday, the end of the week for 2 September 2014 11:55:00:
 * const result = endOfWeek(new Date(2014, 8, 2, 11, 55, 0), { weekStartsOn: 1 })
 * //=> Sun Sep 07 2014 23:59:59.999
 */
function endOfWeek(date, options) {
  const defaultOptions = getDefaultOptions();
  const weekStartsOn =
    options?.weekStartsOn ??
    options?.locale?.options?.weekStartsOn ??
    defaultOptions.weekStartsOn ??
    defaultOptions.locale?.options?.weekStartsOn ??
    0;

  const _date = toDate(date);
  const day = _date.getDay();
  const diff = (day < weekStartsOn ? -7 : 0) + 6 - (day - weekStartsOn);

  _date.setDate(_date.getDate() + diff);
  _date.setHours(23, 59, 59, 999);
  return _date;
}

// Fallback for modularized imports:
/* harmony default export */ var date_fns_endOfWeek = ((/* unused pure expression or super */ null && (endOfWeek)));

;// CONCATENATED MODULE: ./node_modules/date-fns/endOfISOWeek.mjs


/**
 * @name endOfISOWeek
 * @category ISO Week Helpers
 * @summary Return the end of an ISO week for the given date.
 *
 * @description
 * Return the end of an ISO week for the given date.
 * The result will be in the local timezone.
 *
 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The original date
 *
 * @returns The end of an ISO week
 *
 * @example
 * // The end of an ISO week for 2 September 2014 11:55:00:
 * const result = endOfISOWeek(new Date(2014, 8, 2, 11, 55, 0))
 * //=> Sun Sep 07 2014 23:59:59.999
 */
function endOfISOWeek(date) {
  return endOfWeek(date, { weekStartsOn: 1 });
}

// Fallback for modularized imports:
/* harmony default export */ var date_fns_endOfISOWeek = ((/* unused pure expression or super */ null && (endOfISOWeek)));

;// CONCATENATED MODULE: ./node_modules/date-fns/max.mjs


/**
 * @name max
 * @category Common Helpers
 * @summary Return the latest of the given dates.
 *
 * @description
 * Return the latest of the given dates.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param dates - The dates to compare
 *
 * @returns The latest of the dates
 *
 * @example
 * // Which of these dates is the latest?
 * const result = max([
 *   new Date(1989, 6, 10),
 *   new Date(1987, 1, 11),
 *   new Date(1995, 6, 2),
 *   new Date(1990, 0, 1)
 * ])
 * //=> Sun Jul 02 1995 00:00:00
 */
function max(dates) {
  let result;
  dates.forEach(function (dirtyDate) {
    const currentDate = toDate(dirtyDate);

    if (
      result === undefined ||
      result < currentDate ||
      isNaN(Number(currentDate))
    ) {
      result = currentDate;
    }
  });

  return result || new Date(NaN);
}

// Fallback for modularized imports:
/* harmony default export */ var date_fns_max = ((/* unused pure expression or super */ null && (max)));

;// CONCATENATED MODULE: ./node_modules/date-fns/min.mjs


/**
 * @name min
 * @category Common Helpers
 * @summary Returns the earliest of the given dates.
 *
 * @description
 * Returns the earliest of the given dates.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param dates - The dates to compare
 *
 * @returns The earliest of the dates
 *
 * @example
 * // Which of these dates is the earliest?
 * const result = min([
 *   new Date(1989, 6, 10),
 *   new Date(1987, 1, 11),
 *   new Date(1995, 6, 2),
 *   new Date(1990, 0, 1)
 * ])
 * //=> Wed Feb 11 1987 00:00:00
 */
function min(dates) {
  let result;

  dates.forEach((dirtyDate) => {
    const date = toDate(dirtyDate);
    if (!result || result > date || isNaN(+date)) {
      result = date;
    }
  });

  return result || new Date(NaN);
}

// Fallback for modularized imports:
/* harmony default export */ var date_fns_min = ((/* unused pure expression or super */ null && (min)));

;// CONCATENATED MODULE: ./node_modules/date-fns/getUnixTime.mjs


/**
 * @name getUnixTime
 * @category Timestamp Helpers
 * @summary Get the seconds timestamp of the given date.
 *
 * @description
 * Get the seconds timestamp of the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The given date
 *
 * @returns The timestamp
 *
 * @example
 * // Get the timestamp of 29 February 2012 11:45:05 CET:
 * const result = getUnixTime(new Date(2012, 1, 29, 11, 45, 5))
 * //=> 1330512305
 */
function getUnixTime(date) {
  return Math.trunc(+toDate(date) / 1000);
}

// Fallback for modularized imports:
/* harmony default export */ var date_fns_getUnixTime = ((/* unused pure expression or super */ null && (getUnixTime)));

;// CONCATENATED MODULE: ./node_modules/date-fns/differenceInCalendarWeeks.mjs




/**
 * The {@link differenceInCalendarWeeks} function options.
 */

/**
 * @name differenceInCalendarWeeks
 * @category Week Helpers
 * @summary Get the number of calendar weeks between the given dates.
 *
 * @description
 * Get the number of calendar weeks between the given dates.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param dateLeft - The later date
 * @param dateRight - The earlier date
 * @param options - An object with options.
 *
 * @returns The number of calendar weeks
 *
 * @example
 * // How many calendar weeks are between 5 July 2014 and 20 July 2014?
 * const result = differenceInCalendarWeeks(
 *   new Date(2014, 6, 20),
 *   new Date(2014, 6, 5)
 * )
 * //=> 3
 *
 * @example
 * // If the week starts on Monday,
 * // how many calendar weeks are between 5 July 2014 and 20 July 2014?
 * const result = differenceInCalendarWeeks(
 *   new Date(2014, 6, 20),
 *   new Date(2014, 6, 5),
 *   { weekStartsOn: 1 }
 * )
 * //=> 2
 */
function differenceInCalendarWeeks(dateLeft, dateRight, options) {
  const startOfWeekLeft = startOfWeek(dateLeft, options);
  const startOfWeekRight = startOfWeek(dateRight, options);

  const timestampLeft =
    +startOfWeekLeft - getTimezoneOffsetInMilliseconds(startOfWeekLeft);
  const timestampRight =
    +startOfWeekRight - getTimezoneOffsetInMilliseconds(startOfWeekRight);

  // Round the number of days to the nearest integer because the number of
  // milliseconds in a days is not constant (e.g. it's different in the week of
  // the daylight saving time clock shift).
  return Math.round((timestampLeft - timestampRight) / millisecondsInWeek);
}

// Fallback for modularized imports:
/* harmony default export */ var date_fns_differenceInCalendarWeeks = ((/* unused pure expression or super */ null && (differenceInCalendarWeeks)));

;// CONCATENATED MODULE: ./node_modules/date-fns/lastDayOfMonth.mjs


/**
 * @name lastDayOfMonth
 * @category Month Helpers
 * @summary Return the last day of a month for the given date.
 *
 * @description
 * Return the last day of a month for the given date.
 * The result will be in the local timezone.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The original date
 *
 * @returns The last day of a month
 *
 * @example
 * // The last day of a month for 2 September 2014 11:55:00:
 * const result = lastDayOfMonth(new Date(2014, 8, 2, 11, 55, 0))
 * //=> Tue Sep 30 2014 00:00:00
 */
function lastDayOfMonth(date) {
  const _date = toDate(date);
  const month = _date.getMonth();
  _date.setFullYear(_date.getFullYear(), month + 1, 0);
  _date.setHours(0, 0, 0, 0);
  return _date;
}

// Fallback for modularized imports:
/* harmony default export */ var date_fns_lastDayOfMonth = ((/* unused pure expression or super */ null && (lastDayOfMonth)));

;// CONCATENATED MODULE: ./node_modules/date-fns/getWeeksInMonth.mjs




/**
 * The {@link getWeeksInMonth} function options.
 */

/**
 * @name getWeeksInMonth
 * @category Week Helpers
 * @summary Get the number of calendar weeks a month spans.
 *
 * @description
 * Get the number of calendar weeks the month in the given date spans.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The given date
 * @param options - An object with options.
 *
 * @returns The number of calendar weeks
 *
 * @example
 * // How many calendar weeks does February 2015 span?
 * const result = getWeeksInMonth(new Date(2015, 1, 8))
 * //=> 4
 *
 * @example
 * // If the week starts on Monday,
 * // how many calendar weeks does July 2017 span?
 * const result = getWeeksInMonth(new Date(2017, 6, 5), { weekStartsOn: 1 })
 * //=> 6
 */
function getWeeksInMonth(date, options) {
  return (
    differenceInCalendarWeeks(
      lastDayOfMonth(date),
      startOfMonth(date),
      options,
    ) + 1
  );
}

// Fallback for modularized imports:
/* harmony default export */ var date_fns_getWeeksInMonth = ((/* unused pure expression or super */ null && (getWeeksInMonth)));

;// CONCATENATED MODULE: ./node_modules/react-day-picker/dist/index.esm.js




/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */
/* global Reflect, Promise, SuppressedError, Symbol */


var __assign = function() {
    __assign = Object.assign || function __assign(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};

function __rest(s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
}

function __spreadArray(to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
}

typeof SuppressedError === "function" ? SuppressedError : function (error, suppressed, message) {
    var e = new Error(message);
    return e.name = "SuppressedError", e.error = error, e.suppressed = suppressed, e;
};

var jsxRuntime = {exports: {}};

var reactJsxRuntime_development = {};

/**
 * @license React
 * react-jsx-runtime.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var hasRequiredReactJsxRuntime_development;

function requireReactJsxRuntime_development () {
	if (hasRequiredReactJsxRuntime_development) return reactJsxRuntime_development;
	hasRequiredReactJsxRuntime_development = 1;

	if (false) {}
	return reactJsxRuntime_development;
}

var reactJsxRuntime_production_min = {};

/**
 * @license React
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var hasRequiredReactJsxRuntime_production_min;

function requireReactJsxRuntime_production_min () {
	if (hasRequiredReactJsxRuntime_production_min) return reactJsxRuntime_production_min;
	hasRequiredReactJsxRuntime_production_min = 1;
var f=react,k=Symbol.for("react.element"),l=Symbol.for("react.fragment"),m=Object.prototype.hasOwnProperty,n=f.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner,p={key:!0,ref:!0,__self:!0,__source:!0};
	function q(c,a,g){var b,d={},e=null,h=null;void 0!==g&&(e=""+g);void 0!==a.key&&(e=""+a.key);void 0!==a.ref&&(h=a.ref);for(b in a)m.call(a,b)&&!p.hasOwnProperty(b)&&(d[b]=a[b]);if(c&&c.defaultProps)for(b in a=c.defaultProps,a)void 0===d[b]&&(d[b]=a[b]);return {$$typeof:k,type:c,key:e,ref:h,props:d,_owner:n.current}}reactJsxRuntime_production_min.Fragment=l;reactJsxRuntime_production_min.jsx=q;reactJsxRuntime_production_min.jsxs=q;
	return reactJsxRuntime_production_min;
}

if (true) {
  jsxRuntime.exports = requireReactJsxRuntime_production_min();
} else {}

var jsxRuntimeExports = jsxRuntime.exports;

/** Returns true when the props are of type {@link DayPickerMultipleProps}. */
function isDayPickerMultiple(props) {
    return props.mode === 'multiple';
}

/** Returns true when the props are of type {@link DayPickerRangeProps}. */
function isDayPickerRange(props) {
    return props.mode === 'range';
}

/** Returns true when the props are of type {@link DayPickerSingleProps}. */
function isDayPickerSingle(props) {
    return props.mode === 'single';
}

/**
 * The name of the default CSS classes.
 */
var defaultClassNames = {
    root: 'rdp',
    multiple_months: 'rdp-multiple_months',
    with_weeknumber: 'rdp-with_weeknumber',
    vhidden: 'rdp-vhidden',
    button_reset: 'rdp-button_reset',
    button: 'rdp-button',
    caption: 'rdp-caption',
    caption_start: 'rdp-caption_start',
    caption_end: 'rdp-caption_end',
    caption_between: 'rdp-caption_between',
    caption_label: 'rdp-caption_label',
    caption_dropdowns: 'rdp-caption_dropdowns',
    dropdown: 'rdp-dropdown',
    dropdown_month: 'rdp-dropdown_month',
    dropdown_year: 'rdp-dropdown_year',
    dropdown_icon: 'rdp-dropdown_icon',
    months: 'rdp-months',
    month: 'rdp-month',
    table: 'rdp-table',
    tbody: 'rdp-tbody',
    tfoot: 'rdp-tfoot',
    head: 'rdp-head',
    head_row: 'rdp-head_row',
    head_cell: 'rdp-head_cell',
    nav: 'rdp-nav',
    nav_button: 'rdp-nav_button',
    nav_button_previous: 'rdp-nav_button_previous',
    nav_button_next: 'rdp-nav_button_next',
    nav_icon: 'rdp-nav_icon',
    row: 'rdp-row',
    weeknumber: 'rdp-weeknumber',
    cell: 'rdp-cell',
    day: 'rdp-day',
    day_today: 'rdp-day_today',
    day_outside: 'rdp-day_outside',
    day_selected: 'rdp-day_selected',
    day_disabled: 'rdp-day_disabled',
    day_hidden: 'rdp-day_hidden',
    day_range_start: 'rdp-day_range_start',
    day_range_end: 'rdp-day_range_end',
    day_range_middle: 'rdp-day_range_middle'
};

/**
 * The default formatter for the caption.
 */
function formatCaption(month, options) {
    return format_format(month, 'LLLL y', options);
}

/**
 * The default formatter for the Day button.
 */
function formatDay(day, options) {
    return format_format(day, 'd', options);
}

/**
 * The default formatter for the Month caption.
 */
function formatMonthCaption(month, options) {
    return format_format(month, 'LLLL', options);
}

/**
 * The default formatter for the week number.
 */
function formatWeekNumber(weekNumber) {
    return "".concat(weekNumber);
}

/**
 * The default formatter for the name of the weekday.
 */
function formatWeekdayName(weekday, options) {
    return format_format(weekday, 'cccccc', options);
}

/**
 * The default formatter for the Year caption.
 */
function formatYearCaption(year, options) {
    return format_format(year, 'yyyy', options);
}

var index_esm_formatters = /*#__PURE__*/Object.freeze({
    __proto__: null,
    formatCaption: formatCaption,
    formatDay: formatDay,
    formatMonthCaption: formatMonthCaption,
    formatWeekNumber: formatWeekNumber,
    formatWeekdayName: formatWeekdayName,
    formatYearCaption: formatYearCaption
});

/**
 * The default ARIA label for the day button.
 */
var labelDay = function (day, activeModifiers, options) {
    return format_format(day, 'do MMMM (EEEE)', options);
};

/**
 * The default ARIA label for the WeekNumber element.
 */
var labelMonthDropdown = function () {
    return 'Month: ';
};

/**
 * The default ARIA label for next month button in navigation
 */
var labelNext = function () {
    return 'Go to next month';
};

/**
 * The default ARIA label for previous month button in navigation
 */
var labelPrevious = function () {
    return 'Go to previous month';
};

/**
 * The default ARIA label for the Weekday element.
 */
var labelWeekday = function (day, options) {
    return format_format(day, 'cccc', options);
};

/**
 * The default ARIA label for the WeekNumber element.
 */
var labelWeekNumber = function (n) {
    return "Week n. ".concat(n);
};

/**
 * The default ARIA label for the WeekNumber element.
 */
var labelYearDropdown = function () {
    return 'Year: ';
};

var labels = /*#__PURE__*/Object.freeze({
    __proto__: null,
    labelDay: labelDay,
    labelMonthDropdown: labelMonthDropdown,
    labelNext: labelNext,
    labelPrevious: labelPrevious,
    labelWeekNumber: labelWeekNumber,
    labelWeekday: labelWeekday,
    labelYearDropdown: labelYearDropdown
});

/**
 * Returns the default values to use in the DayPickerContext, in case they are
 * not passed down with the DayPicker initial props.
 */
function getDefaultContextValues() {
    var captionLayout = 'buttons';
    var classNames = defaultClassNames;
    var locale = en_US_enUS;
    var modifiersClassNames = {};
    var modifiers = {};
    var numberOfMonths = 1;
    var styles = {};
    var today = new Date();
    return {
        captionLayout: captionLayout,
        classNames: classNames,
        formatters: index_esm_formatters,
        labels: labels,
        locale: locale,
        modifiersClassNames: modifiersClassNames,
        modifiers: modifiers,
        numberOfMonths: numberOfMonths,
        styles: styles,
        today: today,
        mode: 'default'
    };
}

/** Return the `fromDate` and `toDate` prop values values parsing the DayPicker props. */
function parseFromToProps(props) {
    var fromYear = props.fromYear, toYear = props.toYear, fromMonth = props.fromMonth, toMonth = props.toMonth;
    var fromDate = props.fromDate, toDate = props.toDate;
    if (fromMonth) {
        fromDate = startOfMonth(fromMonth);
    }
    else if (fromYear) {
        fromDate = new Date(fromYear, 0, 1);
    }
    if (toMonth) {
        toDate = endOfMonth(toMonth);
    }
    else if (toYear) {
        toDate = new Date(toYear, 11, 31);
    }
    return {
        fromDate: fromDate ? startOfDay(fromDate) : undefined,
        toDate: toDate ? startOfDay(toDate) : undefined
    };
}

/**
 * The DayPicker context shares the props passed to DayPicker within internal
 * and custom components. It is used to set the default values and perform
 * one-time calculations required to render the days.
 *
 * Access to this context from the {@link useDayPicker} hook.
 */
var DayPickerContext = (0,react.createContext)(undefined);
/**
 * The provider for the {@link DayPickerContext}, assigning the defaults from the
 * initial DayPicker props.
 */
function DayPickerProvider(props) {
    var _a;
    var initialProps = props.initialProps;
    var defaultContextValues = getDefaultContextValues();
    var _b = parseFromToProps(initialProps), fromDate = _b.fromDate, toDate = _b.toDate;
    var captionLayout = (_a = initialProps.captionLayout) !== null && _a !== void 0 ? _a : defaultContextValues.captionLayout;
    if (captionLayout !== 'buttons' && (!fromDate || !toDate)) {
        // When no from/to dates are set, the caption is always buttons
        captionLayout = 'buttons';
    }
    var onSelect;
    if (isDayPickerSingle(initialProps) ||
        isDayPickerMultiple(initialProps) ||
        isDayPickerRange(initialProps)) {
        onSelect = initialProps.onSelect;
    }
    var value = __assign(__assign(__assign({}, defaultContextValues), initialProps), { captionLayout: captionLayout, classNames: __assign(__assign({}, defaultContextValues.classNames), initialProps.classNames), components: __assign({}, initialProps.components), formatters: __assign(__assign({}, defaultContextValues.formatters), initialProps.formatters), fromDate: fromDate, labels: __assign(__assign({}, defaultContextValues.labels), initialProps.labels), mode: initialProps.mode || defaultContextValues.mode, modifiers: __assign(__assign({}, defaultContextValues.modifiers), initialProps.modifiers), modifiersClassNames: __assign(__assign({}, defaultContextValues.modifiersClassNames), initialProps.modifiersClassNames), onSelect: onSelect, styles: __assign(__assign({}, defaultContextValues.styles), initialProps.styles), toDate: toDate });
    return (jsxRuntimeExports.jsx(DayPickerContext.Provider, { value: value, children: props.children }));
}
/**
 * Hook to access the {@link DayPickerContextValue}.
 *
 * Use the DayPicker context to access to the props passed to DayPicker inside
 * internal or custom components.
 */
function useDayPicker() {
    var context = (0,react.useContext)(DayPickerContext);
    if (!context) {
        throw new Error("useDayPicker must be used within a DayPickerProvider.");
    }
    return context;
}

/** Render the caption for the displayed month. This component is used when `captionLayout="buttons"`. */
function CaptionLabel(props) {
    var _a = useDayPicker(), locale = _a.locale, classNames = _a.classNames, styles = _a.styles, formatCaption = _a.formatters.formatCaption;
    return (jsxRuntimeExports.jsx("div", { className: classNames.caption_label, style: styles.caption_label, "aria-live": "polite", role: "presentation", id: props.id, children: formatCaption(props.displayMonth, { locale: locale }) }));
}

/**
 * Render the icon in the styled drop-down.
 */
function IconDropdown(props) {
    return (jsxRuntimeExports.jsx("svg", __assign({ width: "8px", height: "8px", viewBox: "0 0 120 120", "data-testid": "iconDropdown" }, props, { children: jsxRuntimeExports.jsx("path", { d: "M4.22182541,48.2218254 C8.44222828,44.0014225 15.2388494,43.9273804 19.5496459,47.9996989 L19.7781746,48.2218254 L60,88.443 L100.221825,48.2218254 C104.442228,44.0014225 111.238849,43.9273804 115.549646,47.9996989 L115.778175,48.2218254 C119.998577,52.4422283 120.07262,59.2388494 116.000301,63.5496459 L115.778175,63.7781746 L67.7781746,111.778175 C63.5577717,115.998577 56.7611506,116.07262 52.4503541,112.000301 L52.2218254,111.778175 L4.22182541,63.7781746 C-0.0739418023,59.4824074 -0.0739418023,52.5175926 4.22182541,48.2218254 Z", fill: "currentColor", fillRule: "nonzero" }) })));
}

/**
 * Render a styled select component – displaying a caption and a custom
 * drop-down icon.
 */
function Dropdown(props) {
    var _a, _b;
    var onChange = props.onChange, value = props.value, children = props.children, caption = props.caption, className = props.className, style = props.style;
    var dayPicker = useDayPicker();
    var IconDropdownComponent = (_b = (_a = dayPicker.components) === null || _a === void 0 ? void 0 : _a.IconDropdown) !== null && _b !== void 0 ? _b : IconDropdown;
    return (jsxRuntimeExports.jsxs("div", { className: className, style: style, children: [jsxRuntimeExports.jsx("span", { className: dayPicker.classNames.vhidden, children: props['aria-label'] }), jsxRuntimeExports.jsx("select", { name: props.name, "aria-label": props['aria-label'], className: dayPicker.classNames.dropdown, style: dayPicker.styles.dropdown, value: value, onChange: onChange, children: children }), jsxRuntimeExports.jsxs("div", { className: dayPicker.classNames.caption_label, style: dayPicker.styles.caption_label, "aria-hidden": "true", children: [caption, jsxRuntimeExports.jsx(IconDropdownComponent, { className: dayPicker.classNames.dropdown_icon, style: dayPicker.styles.dropdown_icon })] })] }));
}

/** Render the dropdown to navigate between months. */
function MonthsDropdown(props) {
    var _a;
    var _b = useDayPicker(), fromDate = _b.fromDate, toDate = _b.toDate, styles = _b.styles, locale = _b.locale, formatMonthCaption = _b.formatters.formatMonthCaption, classNames = _b.classNames, components = _b.components, labelMonthDropdown = _b.labels.labelMonthDropdown;
    // Dropdown should appear only when both from/toDate is set
    if (!fromDate)
        return jsxRuntimeExports.jsx(jsxRuntimeExports.Fragment, {});
    if (!toDate)
        return jsxRuntimeExports.jsx(jsxRuntimeExports.Fragment, {});
    var dropdownMonths = [];
    if (isSameYear(fromDate, toDate)) {
        // only display the months included in the range
        var date = startOfMonth(fromDate);
        for (var month = fromDate.getMonth(); month <= toDate.getMonth(); month++) {
            dropdownMonths.push(setMonth(date, month));
        }
    }
    else {
        // display all the 12 months
        var date = startOfMonth(new Date()); // Any date should be OK, as we just need the year
        for (var month = 0; month <= 11; month++) {
            dropdownMonths.push(setMonth(date, month));
        }
    }
    var handleChange = function (e) {
        var selectedMonth = Number(e.target.value);
        var newMonth = setMonth(startOfMonth(props.displayMonth), selectedMonth);
        props.onChange(newMonth);
    };
    var DropdownComponent = (_a = components === null || components === void 0 ? void 0 : components.Dropdown) !== null && _a !== void 0 ? _a : Dropdown;
    return (jsxRuntimeExports.jsx(DropdownComponent, { name: "months", "aria-label": labelMonthDropdown(), className: classNames.dropdown_month, style: styles.dropdown_month, onChange: handleChange, value: props.displayMonth.getMonth(), caption: formatMonthCaption(props.displayMonth, { locale: locale }), children: dropdownMonths.map(function (m) { return (jsxRuntimeExports.jsx("option", { value: m.getMonth(), children: formatMonthCaption(m, { locale: locale }) }, m.getMonth())); }) }));
}

/**
 * Render a dropdown to change the year. Take in account the `nav.fromDate` and
 * `toDate` from context.
 */
function YearsDropdown(props) {
    var _a;
    var displayMonth = props.displayMonth;
    var _b = useDayPicker(), fromDate = _b.fromDate, toDate = _b.toDate, locale = _b.locale, styles = _b.styles, classNames = _b.classNames, components = _b.components, formatYearCaption = _b.formatters.formatYearCaption, labelYearDropdown = _b.labels.labelYearDropdown;
    var years = [];
    // Dropdown should appear only when both from/toDate is set
    if (!fromDate)
        return jsxRuntimeExports.jsx(jsxRuntimeExports.Fragment, {});
    if (!toDate)
        return jsxRuntimeExports.jsx(jsxRuntimeExports.Fragment, {});
    var fromYear = fromDate.getFullYear();
    var toYear = toDate.getFullYear();
    for (var year = fromYear; year <= toYear; year++) {
        years.push(setYear(startOfYear(new Date()), year));
    }
    var handleChange = function (e) {
        var newMonth = setYear(startOfMonth(displayMonth), Number(e.target.value));
        props.onChange(newMonth);
    };
    var DropdownComponent = (_a = components === null || components === void 0 ? void 0 : components.Dropdown) !== null && _a !== void 0 ? _a : Dropdown;
    return (jsxRuntimeExports.jsx(DropdownComponent, { name: "years", "aria-label": labelYearDropdown(), className: classNames.dropdown_year, style: styles.dropdown_year, onChange: handleChange, value: displayMonth.getFullYear(), caption: formatYearCaption(displayMonth, { locale: locale }), children: years.map(function (year) { return (jsxRuntimeExports.jsx("option", { value: year.getFullYear(), children: formatYearCaption(year, { locale: locale }) }, year.getFullYear())); }) }));
}

/**
 * Helper hook for using controlled/uncontrolled values from a component props.
 *
 * When the value is not controlled, pass `undefined` as `controlledValue` and
 * use the returned setter to update it.
 *
 * When the value is controlled, pass the controlled value as second
 * argument, which will be always returned as `value`.
 */
function useControlledValue(defaultValue, controlledValue) {
    var _a = (0,react.useState)(defaultValue), uncontrolledValue = _a[0], setValue = _a[1];
    var value = controlledValue === undefined ? uncontrolledValue : controlledValue;
    return [value, setValue];
}

/** Return the initial month according to the given options. */
function getInitialMonth(context) {
    var month = context.month, defaultMonth = context.defaultMonth, today = context.today;
    var initialMonth = month || defaultMonth || today || new Date();
    var toDate = context.toDate, fromDate = context.fromDate, _a = context.numberOfMonths, numberOfMonths = _a === void 0 ? 1 : _a;
    // Fix the initialMonth if is after the to-date
    if (toDate && differenceInCalendarMonths(toDate, initialMonth) < 0) {
        var offset = -1 * (numberOfMonths - 1);
        initialMonth = addMonths(toDate, offset);
    }
    // Fix the initialMonth if is before the from-date
    if (fromDate && differenceInCalendarMonths(initialMonth, fromDate) < 0) {
        initialMonth = fromDate;
    }
    return startOfMonth(initialMonth);
}

/** Controls the navigation state. */
function useNavigationState() {
    var context = useDayPicker();
    var initialMonth = getInitialMonth(context);
    var _a = useControlledValue(initialMonth, context.month), month = _a[0], setMonth = _a[1];
    var goToMonth = function (date) {
        var _a;
        if (context.disableNavigation)
            return;
        var month = startOfMonth(date);
        setMonth(month);
        (_a = context.onMonthChange) === null || _a === void 0 ? void 0 : _a.call(context, month);
    };
    return [month, goToMonth];
}

/**
 * Return the months to display in the component according to the number of
 * months and the from/to date.
 */
function getDisplayMonths(month, _a) {
    var reverseMonths = _a.reverseMonths, numberOfMonths = _a.numberOfMonths;
    var start = startOfMonth(month);
    var end = startOfMonth(addMonths(start, numberOfMonths));
    var monthsDiff = differenceInCalendarMonths(end, start);
    var months = [];
    for (var i = 0; i < monthsDiff; i++) {
        var nextMonth = addMonths(start, i);
        months.push(nextMonth);
    }
    if (reverseMonths)
        months = months.reverse();
    return months;
}

/**
 * Returns the next month the user can navigate to according to the given
 * options.
 *
 * Please note that the next month is not always the next calendar month:
 *
 * - if after the `toDate` range, is undefined;
 * - if the navigation is paged, is the number of months displayed ahead.
 *
 */
function getNextMonth(startingMonth, options) {
    if (options.disableNavigation) {
        return undefined;
    }
    var toDate = options.toDate, pagedNavigation = options.pagedNavigation, _a = options.numberOfMonths, numberOfMonths = _a === void 0 ? 1 : _a;
    var offset = pagedNavigation ? numberOfMonths : 1;
    var month = startOfMonth(startingMonth);
    if (!toDate) {
        return addMonths(month, offset);
    }
    var monthsDiff = differenceInCalendarMonths(toDate, startingMonth);
    if (monthsDiff < numberOfMonths) {
        return undefined;
    }
    // Jump forward as the number of months when paged navigation
    return addMonths(month, offset);
}

/**
 * Returns the next previous the user can navigate to, according to the given
 * options.
 *
 * Please note that the previous month is not always the previous calendar
 * month:
 *
 * - if before the `fromDate` date, is `undefined`;
 * - if the navigation is paged, is the number of months displayed before.
 *
 */
function getPreviousMonth(startingMonth, options) {
    if (options.disableNavigation) {
        return undefined;
    }
    var fromDate = options.fromDate, pagedNavigation = options.pagedNavigation, _a = options.numberOfMonths, numberOfMonths = _a === void 0 ? 1 : _a;
    var offset = pagedNavigation ? numberOfMonths : 1;
    var month = startOfMonth(startingMonth);
    if (!fromDate) {
        return addMonths(month, -offset);
    }
    var monthsDiff = differenceInCalendarMonths(month, fromDate);
    if (monthsDiff <= 0) {
        return undefined;
    }
    // Jump back as the number of months when paged navigation
    return addMonths(month, -offset);
}

/**
 * The Navigation context shares details and methods to navigate the months in DayPicker.
 * Access this context from the {@link useNavigation} hook.
 */
var NavigationContext = (0,react.createContext)(undefined);
/** Provides the values for the {@link NavigationContext}. */
function NavigationProvider(props) {
    var dayPicker = useDayPicker();
    var _a = useNavigationState(), currentMonth = _a[0], goToMonth = _a[1];
    var displayMonths = getDisplayMonths(currentMonth, dayPicker);
    var nextMonth = getNextMonth(currentMonth, dayPicker);
    var previousMonth = getPreviousMonth(currentMonth, dayPicker);
    var isDateDisplayed = function (date) {
        return displayMonths.some(function (displayMonth) {
            return isSameMonth(date, displayMonth);
        });
    };
    var goToDate = function (date, refDate) {
        if (isDateDisplayed(date)) {
            return;
        }
        if (refDate && isBefore(date, refDate)) {
            goToMonth(addMonths(date, 1 + dayPicker.numberOfMonths * -1));
        }
        else {
            goToMonth(date);
        }
    };
    var value = {
        currentMonth: currentMonth,
        displayMonths: displayMonths,
        goToMonth: goToMonth,
        goToDate: goToDate,
        previousMonth: previousMonth,
        nextMonth: nextMonth,
        isDateDisplayed: isDateDisplayed
    };
    return (jsxRuntimeExports.jsx(NavigationContext.Provider, { value: value, children: props.children }));
}
/**
 * Hook to access the {@link NavigationContextValue}. Use this hook to navigate
 * between months or years in DayPicker.
 *
 * This hook is meant to be used inside internal or custom components.
 */
function useNavigation() {
    var context = (0,react.useContext)(NavigationContext);
    if (!context) {
        throw new Error('useNavigation must be used within a NavigationProvider');
    }
    return context;
}

/**
 * Render a caption with the dropdowns to navigate between months and years.
 */
function CaptionDropdowns(props) {
    var _a;
    var _b = useDayPicker(), classNames = _b.classNames, styles = _b.styles, components = _b.components;
    var goToMonth = useNavigation().goToMonth;
    var handleMonthChange = function (newMonth) {
        goToMonth(addMonths(newMonth, props.displayIndex ? -props.displayIndex : 0));
    };
    var CaptionLabelComponent = (_a = components === null || components === void 0 ? void 0 : components.CaptionLabel) !== null && _a !== void 0 ? _a : CaptionLabel;
    var captionLabel = (jsxRuntimeExports.jsx(CaptionLabelComponent, { id: props.id, displayMonth: props.displayMonth }));
    return (jsxRuntimeExports.jsxs("div", { className: classNames.caption_dropdowns, style: styles.caption_dropdowns, children: [jsxRuntimeExports.jsx("div", { className: classNames.vhidden, children: captionLabel }), jsxRuntimeExports.jsx(MonthsDropdown, { onChange: handleMonthChange, displayMonth: props.displayMonth }), jsxRuntimeExports.jsx(YearsDropdown, { onChange: handleMonthChange, displayMonth: props.displayMonth })] }));
}

/**
 * Render the "previous month" button in the navigation.
 */
function IconLeft(props) {
    return (jsxRuntimeExports.jsx("svg", __assign({ width: "16px", height: "16px", viewBox: "0 0 120 120" }, props, { children: jsxRuntimeExports.jsx("path", { d: "M69.490332,3.34314575 C72.6145263,0.218951416 77.6798462,0.218951416 80.8040405,3.34314575 C83.8617626,6.40086786 83.9268205,11.3179931 80.9992143,14.4548388 L80.8040405,14.6568542 L35.461,60 L80.8040405,105.343146 C83.8617626,108.400868 83.9268205,113.317993 80.9992143,116.454839 L80.8040405,116.656854 C77.7463184,119.714576 72.8291931,119.779634 69.6923475,116.852028 L69.490332,116.656854 L18.490332,65.6568542 C15.4326099,62.5991321 15.367552,57.6820069 18.2951583,54.5451612 L18.490332,54.3431458 L69.490332,3.34314575 Z", fill: "currentColor", fillRule: "nonzero" }) })));
}

/**
 * Render the "next month" button in the navigation.
 */
function IconRight(props) {
    return (jsxRuntimeExports.jsx("svg", __assign({ width: "16px", height: "16px", viewBox: "0 0 120 120" }, props, { children: jsxRuntimeExports.jsx("path", { d: "M49.8040405,3.34314575 C46.6798462,0.218951416 41.6145263,0.218951416 38.490332,3.34314575 C35.4326099,6.40086786 35.367552,11.3179931 38.2951583,14.4548388 L38.490332,14.6568542 L83.8333725,60 L38.490332,105.343146 C35.4326099,108.400868 35.367552,113.317993 38.2951583,116.454839 L38.490332,116.656854 C41.5480541,119.714576 46.4651794,119.779634 49.602025,116.852028 L49.8040405,116.656854 L100.804041,65.6568542 C103.861763,62.5991321 103.926821,57.6820069 100.999214,54.5451612 L100.804041,54.3431458 L49.8040405,3.34314575 Z", fill: "currentColor" }) })));
}

/** Render a button HTML element applying the reset class name. */
var Button = (0,react.forwardRef)(function (props, ref) {
    var _a = useDayPicker(), classNames = _a.classNames, styles = _a.styles;
    var classNamesArr = [classNames.button_reset, classNames.button];
    if (props.className) {
        classNamesArr.push(props.className);
    }
    var className = classNamesArr.join(' ');
    var style = __assign(__assign({}, styles.button_reset), styles.button);
    if (props.style) {
        Object.assign(style, props.style);
    }
    return (jsxRuntimeExports.jsx("button", __assign({}, props, { ref: ref, type: "button", className: className, style: style })));
});

/** A component rendering the navigation buttons or the drop-downs. */
function Navigation(props) {
    var _a, _b;
    var _c = useDayPicker(), dir = _c.dir, locale = _c.locale, classNames = _c.classNames, styles = _c.styles, _d = _c.labels, labelPrevious = _d.labelPrevious, labelNext = _d.labelNext, components = _c.components;
    if (!props.nextMonth && !props.previousMonth) {
        return jsxRuntimeExports.jsx(jsxRuntimeExports.Fragment, {});
    }
    var previousLabel = labelPrevious(props.previousMonth, { locale: locale });
    var previousClassName = [
        classNames.nav_button,
        classNames.nav_button_previous
    ].join(' ');
    var nextLabel = labelNext(props.nextMonth, { locale: locale });
    var nextClassName = [
        classNames.nav_button,
        classNames.nav_button_next
    ].join(' ');
    var IconRightComponent = (_a = components === null || components === void 0 ? void 0 : components.IconRight) !== null && _a !== void 0 ? _a : IconRight;
    var IconLeftComponent = (_b = components === null || components === void 0 ? void 0 : components.IconLeft) !== null && _b !== void 0 ? _b : IconLeft;
    return (jsxRuntimeExports.jsxs("div", { className: classNames.nav, style: styles.nav, children: [!props.hidePrevious && (jsxRuntimeExports.jsx(Button, { name: "previous-month", "aria-label": previousLabel, className: previousClassName, style: styles.nav_button_previous, disabled: !props.previousMonth, onClick: props.onPreviousClick, children: dir === 'rtl' ? (jsxRuntimeExports.jsx(IconRightComponent, { className: classNames.nav_icon, style: styles.nav_icon })) : (jsxRuntimeExports.jsx(IconLeftComponent, { className: classNames.nav_icon, style: styles.nav_icon })) })), !props.hideNext && (jsxRuntimeExports.jsx(Button, { name: "next-month", "aria-label": nextLabel, className: nextClassName, style: styles.nav_button_next, disabled: !props.nextMonth, onClick: props.onNextClick, children: dir === 'rtl' ? (jsxRuntimeExports.jsx(IconLeftComponent, { className: classNames.nav_icon, style: styles.nav_icon })) : (jsxRuntimeExports.jsx(IconRightComponent, { className: classNames.nav_icon, style: styles.nav_icon })) }))] }));
}

/**
 * Render a caption with a button-based navigation.
 */
function CaptionNavigation(props) {
    var numberOfMonths = useDayPicker().numberOfMonths;
    var _a = useNavigation(), previousMonth = _a.previousMonth, nextMonth = _a.nextMonth, goToMonth = _a.goToMonth, displayMonths = _a.displayMonths;
    var displayIndex = displayMonths.findIndex(function (month) {
        return isSameMonth(props.displayMonth, month);
    });
    var isFirst = displayIndex === 0;
    var isLast = displayIndex === displayMonths.length - 1;
    var hideNext = numberOfMonths > 1 && (isFirst || !isLast);
    var hidePrevious = numberOfMonths > 1 && (isLast || !isFirst);
    var handlePreviousClick = function () {
        if (!previousMonth)
            return;
        goToMonth(previousMonth);
    };
    var handleNextClick = function () {
        if (!nextMonth)
            return;
        goToMonth(nextMonth);
    };
    return (jsxRuntimeExports.jsx(Navigation, { displayMonth: props.displayMonth, hideNext: hideNext, hidePrevious: hidePrevious, nextMonth: nextMonth, previousMonth: previousMonth, onPreviousClick: handlePreviousClick, onNextClick: handleNextClick }));
}

/**
 * Render the caption of a month. The caption has a different layout when
 * setting the {@link DayPickerBase.captionLayout} prop.
 */
function Caption(props) {
    var _a;
    var _b = useDayPicker(), classNames = _b.classNames, disableNavigation = _b.disableNavigation, styles = _b.styles, captionLayout = _b.captionLayout, components = _b.components;
    var CaptionLabelComponent = (_a = components === null || components === void 0 ? void 0 : components.CaptionLabel) !== null && _a !== void 0 ? _a : CaptionLabel;
    var caption;
    if (disableNavigation) {
        caption = (jsxRuntimeExports.jsx(CaptionLabelComponent, { id: props.id, displayMonth: props.displayMonth }));
    }
    else if (captionLayout === 'dropdown') {
        caption = (jsxRuntimeExports.jsx(CaptionDropdowns, { displayMonth: props.displayMonth, id: props.id }));
    }
    else if (captionLayout === 'dropdown-buttons') {
        caption = (jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, { children: [jsxRuntimeExports.jsx(CaptionDropdowns, { displayMonth: props.displayMonth, displayIndex: props.displayIndex, id: props.id }), jsxRuntimeExports.jsx(CaptionNavigation, { displayMonth: props.displayMonth, displayIndex: props.displayIndex, id: props.id })] }));
    }
    else {
        caption = (jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, { children: [jsxRuntimeExports.jsx(CaptionLabelComponent, { id: props.id, displayMonth: props.displayMonth, displayIndex: props.displayIndex }), jsxRuntimeExports.jsx(CaptionNavigation, { displayMonth: props.displayMonth, id: props.id })] }));
    }
    return (jsxRuntimeExports.jsx("div", { className: classNames.caption, style: styles.caption, children: caption }));
}

/** Render the Footer component (empty as default).*/
// eslint-disable-next-line @typescript-eslint/no-unused-vars
function Footer(props) {
    var _a = useDayPicker(), footer = _a.footer, styles = _a.styles, tfoot = _a.classNames.tfoot;
    if (!footer)
        return jsxRuntimeExports.jsx(jsxRuntimeExports.Fragment, {});
    return (jsxRuntimeExports.jsx("tfoot", { className: tfoot, style: styles.tfoot, children: jsxRuntimeExports.jsx("tr", { children: jsxRuntimeExports.jsx("td", { colSpan: 8, children: footer }) }) }));
}

/**
 * Generate a series of 7 days, starting from the week, to use for formatting
 * the weekday names (Monday, Tuesday, etc.).
 */
function getWeekdays(locale, 
/** The index of the first day of the week (0 - Sunday). */
weekStartsOn, 
/** Use ISOWeek instead of locale/ */
ISOWeek) {
    var start = ISOWeek
        ? startOfISOWeek(new Date())
        : startOfWeek(new Date(), { locale: locale, weekStartsOn: weekStartsOn });
    var days = [];
    for (var i = 0; i < 7; i++) {
        var day = addDays(start, i);
        days.push(day);
    }
    return days;
}

/**
 * Render the HeadRow component - i.e. the table head row with the weekday names.
 */
function HeadRow() {
    var _a = useDayPicker(), classNames = _a.classNames, styles = _a.styles, showWeekNumber = _a.showWeekNumber, locale = _a.locale, weekStartsOn = _a.weekStartsOn, ISOWeek = _a.ISOWeek, formatWeekdayName = _a.formatters.formatWeekdayName, labelWeekday = _a.labels.labelWeekday;
    var weekdays = getWeekdays(locale, weekStartsOn, ISOWeek);
    return (jsxRuntimeExports.jsxs("tr", { style: styles.head_row, className: classNames.head_row, children: [showWeekNumber && (jsxRuntimeExports.jsx("td", { style: styles.head_cell, className: classNames.head_cell })), weekdays.map(function (weekday, i) { return (jsxRuntimeExports.jsx("th", { scope: "col", className: classNames.head_cell, style: styles.head_cell, "aria-label": labelWeekday(weekday, { locale: locale }), children: formatWeekdayName(weekday, { locale: locale }) }, i)); })] }));
}

/** Render the table head. */
function Head() {
    var _a;
    var _b = useDayPicker(), classNames = _b.classNames, styles = _b.styles, components = _b.components;
    var HeadRowComponent = (_a = components === null || components === void 0 ? void 0 : components.HeadRow) !== null && _a !== void 0 ? _a : HeadRow;
    return (jsxRuntimeExports.jsx("thead", { style: styles.head, className: classNames.head, children: jsxRuntimeExports.jsx(HeadRowComponent, {}) }));
}

/** Render the content of the day cell. */
function DayContent(props) {
    var _a = useDayPicker(), locale = _a.locale, formatDay = _a.formatters.formatDay;
    return jsxRuntimeExports.jsx(jsxRuntimeExports.Fragment, { children: formatDay(props.date, { locale: locale }) });
}

/**
 * The SelectMultiple context shares details about the selected days when in
 * multiple selection mode.
 *
 * Access this context from the {@link useSelectMultiple} hook.
 */
var SelectMultipleContext = (0,react.createContext)(undefined);
/** Provides the values for the {@link SelectMultipleContext}. */
function SelectMultipleProvider(props) {
    if (!isDayPickerMultiple(props.initialProps)) {
        var emptyContextValue = {
            selected: undefined,
            modifiers: {
                disabled: []
            }
        };
        return (jsxRuntimeExports.jsx(SelectMultipleContext.Provider, { value: emptyContextValue, children: props.children }));
    }
    return (jsxRuntimeExports.jsx(SelectMultipleProviderInternal, { initialProps: props.initialProps, children: props.children }));
}
function SelectMultipleProviderInternal(_a) {
    var initialProps = _a.initialProps, children = _a.children;
    var selected = initialProps.selected, min = initialProps.min, max = initialProps.max;
    var onDayClick = function (day, activeModifiers, e) {
        var _a, _b;
        (_a = initialProps.onDayClick) === null || _a === void 0 ? void 0 : _a.call(initialProps, day, activeModifiers, e);
        var isMinSelected = Boolean(activeModifiers.selected && min && (selected === null || selected === void 0 ? void 0 : selected.length) === min);
        if (isMinSelected) {
            return;
        }
        var isMaxSelected = Boolean(!activeModifiers.selected && max && (selected === null || selected === void 0 ? void 0 : selected.length) === max);
        if (isMaxSelected) {
            return;
        }
        var selectedDays = selected ? __spreadArray([], selected, true) : [];
        if (activeModifiers.selected) {
            var index = selectedDays.findIndex(function (selectedDay) {
                return isSameDay(day, selectedDay);
            });
            selectedDays.splice(index, 1);
        }
        else {
            selectedDays.push(day);
        }
        (_b = initialProps.onSelect) === null || _b === void 0 ? void 0 : _b.call(initialProps, selectedDays, day, activeModifiers, e);
    };
    var modifiers = {
        disabled: []
    };
    if (selected) {
        modifiers.disabled.push(function (day) {
            var isMaxSelected = max && selected.length > max - 1;
            var isSelected = selected.some(function (selectedDay) {
                return isSameDay(selectedDay, day);
            });
            return Boolean(isMaxSelected && !isSelected);
        });
    }
    var contextValue = {
        selected: selected,
        onDayClick: onDayClick,
        modifiers: modifiers
    };
    return (jsxRuntimeExports.jsx(SelectMultipleContext.Provider, { value: contextValue, children: children }));
}
/**
 * Hook to access the {@link SelectMultipleContextValue}.
 *
 * This hook is meant to be used inside internal or custom components.
 */
function useSelectMultiple() {
    var context = (0,react.useContext)(SelectMultipleContext);
    if (!context) {
        throw new Error('useSelectMultiple must be used within a SelectMultipleProvider');
    }
    return context;
}

/**
 * Add a day to an existing range.
 *
 * The returned range takes in account the `undefined` values and if the added
 * day is already present in the range.
 */
function addToRange(day, range) {
    var _a = range || {}, from = _a.from, to = _a.to;
    if (from && to) {
        if (isSameDay(to, day) && isSameDay(from, day)) {
            return undefined;
        }
        if (isSameDay(to, day)) {
            return { from: to, to: undefined };
        }
        if (isSameDay(from, day)) {
            return undefined;
        }
        if (isAfter(from, day)) {
            return { from: day, to: to };
        }
        return { from: from, to: day };
    }
    if (to) {
        if (isAfter(day, to)) {
            return { from: to, to: day };
        }
        return { from: day, to: to };
    }
    if (from) {
        if (isBefore(day, from)) {
            return { from: day, to: from };
        }
        return { from: from, to: day };
    }
    return { from: day, to: undefined };
}

/**
 * The SelectRange context shares details about the selected days when in
 * range selection mode.
 *
 * Access this context from the {@link useSelectRange} hook.
 */
var SelectRangeContext = (0,react.createContext)(undefined);
/** Provides the values for the {@link SelectRangeProvider}. */
function SelectRangeProvider(props) {
    if (!isDayPickerRange(props.initialProps)) {
        var emptyContextValue = {
            selected: undefined,
            modifiers: {
                range_start: [],
                range_end: [],
                range_middle: [],
                disabled: []
            }
        };
        return (jsxRuntimeExports.jsx(SelectRangeContext.Provider, { value: emptyContextValue, children: props.children }));
    }
    return (jsxRuntimeExports.jsx(SelectRangeProviderInternal, { initialProps: props.initialProps, children: props.children }));
}
function SelectRangeProviderInternal(_a) {
    var initialProps = _a.initialProps, children = _a.children;
    var selected = initialProps.selected;
    var _b = selected || {}, selectedFrom = _b.from, selectedTo = _b.to;
    var min = initialProps.min;
    var max = initialProps.max;
    var onDayClick = function (day, activeModifiers, e) {
        var _a, _b;
        (_a = initialProps.onDayClick) === null || _a === void 0 ? void 0 : _a.call(initialProps, day, activeModifiers, e);
        var newRange = addToRange(day, selected);
        (_b = initialProps.onSelect) === null || _b === void 0 ? void 0 : _b.call(initialProps, newRange, day, activeModifiers, e);
    };
    var modifiers = {
        range_start: [],
        range_end: [],
        range_middle: [],
        disabled: []
    };
    if (selectedFrom) {
        modifiers.range_start = [selectedFrom];
        if (!selectedTo) {
            modifiers.range_end = [selectedFrom];
        }
        else {
            modifiers.range_end = [selectedTo];
            if (!isSameDay(selectedFrom, selectedTo)) {
                modifiers.range_middle = [
                    {
                        after: selectedFrom,
                        before: selectedTo
                    }
                ];
            }
        }
    }
    else if (selectedTo) {
        modifiers.range_start = [selectedTo];
        modifiers.range_end = [selectedTo];
    }
    if (min) {
        if (selectedFrom && !selectedTo) {
            modifiers.disabled.push({
                after: subDays(selectedFrom, min - 1),
                before: addDays(selectedFrom, min - 1)
            });
        }
        if (selectedFrom && selectedTo) {
            modifiers.disabled.push({
                after: selectedFrom,
                before: addDays(selectedFrom, min - 1)
            });
        }
        if (!selectedFrom && selectedTo) {
            modifiers.disabled.push({
                after: subDays(selectedTo, min - 1),
                before: addDays(selectedTo, min - 1)
            });
        }
    }
    if (max) {
        if (selectedFrom && !selectedTo) {
            modifiers.disabled.push({
                before: addDays(selectedFrom, -max + 1)
            });
            modifiers.disabled.push({
                after: addDays(selectedFrom, max - 1)
            });
        }
        if (selectedFrom && selectedTo) {
            var selectedCount = differenceInCalendarDays_differenceInCalendarDays(selectedTo, selectedFrom) + 1;
            var offset = max - selectedCount;
            modifiers.disabled.push({
                before: subDays(selectedFrom, offset)
            });
            modifiers.disabled.push({
                after: addDays(selectedTo, offset)
            });
        }
        if (!selectedFrom && selectedTo) {
            modifiers.disabled.push({
                before: addDays(selectedTo, -max + 1)
            });
            modifiers.disabled.push({
                after: addDays(selectedTo, max - 1)
            });
        }
    }
    return (jsxRuntimeExports.jsx(SelectRangeContext.Provider, { value: { selected: selected, onDayClick: onDayClick, modifiers: modifiers }, children: children }));
}
/**
 * Hook to access the {@link SelectRangeContextValue}.
 *
 * This hook is meant to be used inside internal or custom components.
 */
function useSelectRange() {
    var context = (0,react.useContext)(SelectRangeContext);
    if (!context) {
        throw new Error('useSelectRange must be used within a SelectRangeProvider');
    }
    return context;
}

/** Normalize to array a matcher input. */
function matcherToArray(matcher) {
    if (Array.isArray(matcher)) {
        return __spreadArray([], matcher, true);
    }
    else if (matcher !== undefined) {
        return [matcher];
    }
    else {
        return [];
    }
}

/** Create CustomModifiers from dayModifiers */
function getCustomModifiers(dayModifiers) {
    var customModifiers = {};
    Object.entries(dayModifiers).forEach(function (_a) {
        var modifier = _a[0], matcher = _a[1];
        customModifiers[modifier] = matcherToArray(matcher);
    });
    return customModifiers;
}

/** The name of the modifiers that are used internally by DayPicker. */
var InternalModifier;
(function (InternalModifier) {
    InternalModifier["Outside"] = "outside";
    /** Name of the modifier applied to the disabled days, using the `disabled` prop. */
    InternalModifier["Disabled"] = "disabled";
    /** Name of the modifier applied to the selected days using the `selected` prop). */
    InternalModifier["Selected"] = "selected";
    /** Name of the modifier applied to the hidden days using the `hidden` prop). */
    InternalModifier["Hidden"] = "hidden";
    /** Name of the modifier applied to the day specified using the `today` prop). */
    InternalModifier["Today"] = "today";
    /** The modifier applied to the day starting a selected range, when in range selection mode.  */
    InternalModifier["RangeStart"] = "range_start";
    /** The modifier applied to the day ending a selected range, when in range selection mode.  */
    InternalModifier["RangeEnd"] = "range_end";
    /** The modifier applied to the days between the start and the end of a selected range, when in range selection mode.  */
    InternalModifier["RangeMiddle"] = "range_middle";
})(InternalModifier || (InternalModifier = {}));

var Selected = InternalModifier.Selected, Disabled = InternalModifier.Disabled, Hidden = InternalModifier.Hidden, Today = InternalModifier.Today, RangeEnd = InternalModifier.RangeEnd, RangeMiddle = InternalModifier.RangeMiddle, RangeStart = InternalModifier.RangeStart, Outside = InternalModifier.Outside;
/** Return the {@link InternalModifiers} from the DayPicker and select contexts. */
function getInternalModifiers(dayPicker, selectMultiple, selectRange) {
    var _a;
    var internalModifiers = (_a = {},
        _a[Selected] = matcherToArray(dayPicker.selected),
        _a[Disabled] = matcherToArray(dayPicker.disabled),
        _a[Hidden] = matcherToArray(dayPicker.hidden),
        _a[Today] = [dayPicker.today],
        _a[RangeEnd] = [],
        _a[RangeMiddle] = [],
        _a[RangeStart] = [],
        _a[Outside] = [],
        _a);
    if (dayPicker.fromDate) {
        internalModifiers[Disabled].push({ before: dayPicker.fromDate });
    }
    if (dayPicker.toDate) {
        internalModifiers[Disabled].push({ after: dayPicker.toDate });
    }
    if (isDayPickerMultiple(dayPicker)) {
        internalModifiers[Disabled] = internalModifiers[Disabled].concat(selectMultiple.modifiers[Disabled]);
    }
    else if (isDayPickerRange(dayPicker)) {
        internalModifiers[Disabled] = internalModifiers[Disabled].concat(selectRange.modifiers[Disabled]);
        internalModifiers[RangeStart] = selectRange.modifiers[RangeStart];
        internalModifiers[RangeMiddle] = selectRange.modifiers[RangeMiddle];
        internalModifiers[RangeEnd] = selectRange.modifiers[RangeEnd];
    }
    return internalModifiers;
}

/** The Modifiers context store the modifiers used in DayPicker. To access the value of this context, use {@link useModifiers}. */
var ModifiersContext = (0,react.createContext)(undefined);
/** Provide the value for the {@link ModifiersContext}. */
function ModifiersProvider(props) {
    var dayPicker = useDayPicker();
    var selectMultiple = useSelectMultiple();
    var selectRange = useSelectRange();
    var internalModifiers = getInternalModifiers(dayPicker, selectMultiple, selectRange);
    var customModifiers = getCustomModifiers(dayPicker.modifiers);
    var modifiers = __assign(__assign({}, internalModifiers), customModifiers);
    return (jsxRuntimeExports.jsx(ModifiersContext.Provider, { value: modifiers, children: props.children }));
}
/**
 * Return the modifiers used by DayPicker.
 *
 * This hook is meant to be used inside internal or custom components.
 * Requires to be wrapped into {@link ModifiersProvider}.
 *
 */
function useModifiers() {
    var context = (0,react.useContext)(ModifiersContext);
    if (!context) {
        throw new Error('useModifiers must be used within a ModifiersProvider');
    }
    return context;
}

/** Returns true if `matcher` is of type {@link DateInterval}. */
function isDateInterval(matcher) {
    return Boolean(matcher &&
        typeof matcher === 'object' &&
        'before' in matcher &&
        'after' in matcher);
}
/** Returns true if `value` is a {@link DateRange} type. */
function isDateRange(value) {
    return Boolean(value && typeof value === 'object' && 'from' in value);
}
/** Returns true if `value` is of type {@link DateAfter}. */
function isDateAfterType(value) {
    return Boolean(value && typeof value === 'object' && 'after' in value);
}
/** Returns true if `value` is of type {@link DateBefore}. */
function isDateBeforeType(value) {
    return Boolean(value && typeof value === 'object' && 'before' in value);
}
/** Returns true if `value` is a {@link DayOfWeek} type. */
function isDayOfWeekType(value) {
    return Boolean(value && typeof value === 'object' && 'dayOfWeek' in value);
}

/** Return `true` whether `date` is inside `range`. */
function isDateInRange(date, range) {
    var _a;
    var from = range.from, to = range.to;
    if (from && to) {
        var isRangeInverted = differenceInCalendarDays_differenceInCalendarDays(to, from) < 0;
        if (isRangeInverted) {
            _a = [to, from], from = _a[0], to = _a[1];
        }
        var isInRange = differenceInCalendarDays_differenceInCalendarDays(date, from) >= 0 &&
            differenceInCalendarDays_differenceInCalendarDays(to, date) >= 0;
        return isInRange;
    }
    if (to) {
        return isSameDay(to, date);
    }
    if (from) {
        return isSameDay(from, date);
    }
    return false;
}

/** Returns true if `value` is a Date type. */
function isDateType(value) {
    return isDate(value);
}
/** Returns true if `value` is an array of valid dates. */
function isArrayOfDates(value) {
    return Array.isArray(value) && value.every(isDate);
}
/**
 * Returns whether a day matches against at least one of the given Matchers.
 *
 * ```
 * const day = new Date(2022, 5, 19);
 * const matcher1: DateRange = {
 *    from: new Date(2021, 12, 21),
 *    to: new Date(2021, 12, 30)
 * }
 * const matcher2: DateRange = {
 *    from: new Date(2022, 5, 1),
 *    to: new Date(2022, 5, 23)
 * }
 *
 * const isMatch(day, [matcher1, matcher2]); // true, since day is in the matcher1 range.
 * ```
 * */
function isMatch(day, matchers) {
    return matchers.some(function (matcher) {
        if (typeof matcher === 'boolean') {
            return matcher;
        }
        if (isDateType(matcher)) {
            return isSameDay(day, matcher);
        }
        if (isArrayOfDates(matcher)) {
            return matcher.includes(day);
        }
        if (isDateRange(matcher)) {
            return isDateInRange(day, matcher);
        }
        if (isDayOfWeekType(matcher)) {
            return matcher.dayOfWeek.includes(day.getDay());
        }
        if (isDateInterval(matcher)) {
            var diffBefore = differenceInCalendarDays_differenceInCalendarDays(matcher.before, day);
            var diffAfter = differenceInCalendarDays_differenceInCalendarDays(matcher.after, day);
            var isDayBefore = diffBefore > 0;
            var isDayAfter = diffAfter < 0;
            var isClosedInterval = isAfter(matcher.before, matcher.after);
            if (isClosedInterval) {
                return isDayAfter && isDayBefore;
            }
            else {
                return isDayBefore || isDayAfter;
            }
        }
        if (isDateAfterType(matcher)) {
            return differenceInCalendarDays_differenceInCalendarDays(day, matcher.after) > 0;
        }
        if (isDateBeforeType(matcher)) {
            return differenceInCalendarDays_differenceInCalendarDays(matcher.before, day) > 0;
        }
        if (typeof matcher === 'function') {
            return matcher(day);
        }
        return false;
    });
}

/** Return the active modifiers for the given day. */
function getActiveModifiers(day, 
/** The modifiers to match for the given date. */
modifiers, 
/** The month where the day is displayed, to add the "outside" modifiers.  */
displayMonth) {
    var matchedModifiers = Object.keys(modifiers).reduce(function (result, key) {
        var modifier = modifiers[key];
        if (isMatch(day, modifier)) {
            result.push(key);
        }
        return result;
    }, []);
    var activeModifiers = {};
    matchedModifiers.forEach(function (modifier) { return (activeModifiers[modifier] = true); });
    if (displayMonth && !isSameMonth(day, displayMonth)) {
        activeModifiers.outside = true;
    }
    return activeModifiers;
}

/**
 * Returns the day that should be the target of the focus when DayPicker is
 * rendered the first time.
 *
 * TODO: this function doesn't consider if the day is outside the month. We
 * implemented this check in `useDayRender` but it should probably go here. See
 * https://github.com/gpbl/react-day-picker/pull/1576
 */
function getInitialFocusTarget(displayMonths, modifiers) {
    var firstDayInMonth = startOfMonth(displayMonths[0]);
    var lastDayInMonth = endOfMonth(displayMonths[displayMonths.length - 1]);
    // TODO: cleanup code
    var firstFocusableDay;
    var today;
    var date = firstDayInMonth;
    while (date <= lastDayInMonth) {
        var activeModifiers = getActiveModifiers(date, modifiers);
        var isFocusable = !activeModifiers.disabled && !activeModifiers.hidden;
        if (!isFocusable) {
            date = addDays(date, 1);
            continue;
        }
        if (activeModifiers.selected) {
            return date;
        }
        if (activeModifiers.today && !today) {
            today = date;
        }
        if (!firstFocusableDay) {
            firstFocusableDay = date;
        }
        date = addDays(date, 1);
    }
    if (today) {
        return today;
    }
    else {
        return firstFocusableDay;
    }
}

var MAX_RETRY = 365;
/** Return the next date to be focused. */
function getNextFocus(focusedDay, options) {
    var moveBy = options.moveBy, direction = options.direction, context = options.context, modifiers = options.modifiers, _a = options.retry, retry = _a === void 0 ? { count: 0, lastFocused: focusedDay } : _a;
    var weekStartsOn = context.weekStartsOn, fromDate = context.fromDate, toDate = context.toDate, locale = context.locale;
    var moveFns = {
        day: addDays,
        week: addWeeks,
        month: addMonths,
        year: addYears,
        startOfWeek: function (date) {
            return context.ISOWeek
                ? startOfISOWeek(date)
                : startOfWeek(date, { locale: locale, weekStartsOn: weekStartsOn });
        },
        endOfWeek: function (date) {
            return context.ISOWeek
                ? endOfISOWeek(date)
                : endOfWeek(date, { locale: locale, weekStartsOn: weekStartsOn });
        }
    };
    var newFocusedDay = moveFns[moveBy](focusedDay, direction === 'after' ? 1 : -1);
    if (direction === 'before' && fromDate) {
        newFocusedDay = max([fromDate, newFocusedDay]);
    }
    else if (direction === 'after' && toDate) {
        newFocusedDay = min([toDate, newFocusedDay]);
    }
    var isFocusable = true;
    if (modifiers) {
        var activeModifiers = getActiveModifiers(newFocusedDay, modifiers);
        isFocusable = !activeModifiers.disabled && !activeModifiers.hidden;
    }
    if (isFocusable) {
        return newFocusedDay;
    }
    else {
        if (retry.count > MAX_RETRY) {
            return retry.lastFocused;
        }
        return getNextFocus(newFocusedDay, {
            moveBy: moveBy,
            direction: direction,
            context: context,
            modifiers: modifiers,
            retry: __assign(__assign({}, retry), { count: retry.count + 1 })
        });
    }
}

/**
 * The Focus context shares details about the focused day for the keyboard
 *
 * Access this context from the {@link useFocusContext} hook.
 */
var FocusContext = (0,react.createContext)(undefined);
/** The provider for the {@link FocusContext}. */
function FocusProvider(props) {
    var navigation = useNavigation();
    var modifiers = useModifiers();
    var _a = (0,react.useState)(), focusedDay = _a[0], setFocusedDay = _a[1];
    var _b = (0,react.useState)(), lastFocused = _b[0], setLastFocused = _b[1];
    var initialFocusTarget = getInitialFocusTarget(navigation.displayMonths, modifiers);
    // TODO: cleanup and test obscure code below
    var focusTarget = (focusedDay !== null && focusedDay !== void 0 ? focusedDay : (lastFocused && navigation.isDateDisplayed(lastFocused)))
        ? lastFocused
        : initialFocusTarget;
    var blur = function () {
        setLastFocused(focusedDay);
        setFocusedDay(undefined);
    };
    var focus = function (date) {
        setFocusedDay(date);
    };
    var context = useDayPicker();
    var moveFocus = function (moveBy, direction) {
        if (!focusedDay)
            return;
        var nextFocused = getNextFocus(focusedDay, {
            moveBy: moveBy,
            direction: direction,
            context: context,
            modifiers: modifiers
        });
        if (isSameDay(focusedDay, nextFocused))
            return undefined;
        navigation.goToDate(nextFocused, focusedDay);
        focus(nextFocused);
    };
    var value = {
        focusedDay: focusedDay,
        focusTarget: focusTarget,
        blur: blur,
        focus: focus,
        focusDayAfter: function () { return moveFocus('day', 'after'); },
        focusDayBefore: function () { return moveFocus('day', 'before'); },
        focusWeekAfter: function () { return moveFocus('week', 'after'); },
        focusWeekBefore: function () { return moveFocus('week', 'before'); },
        focusMonthBefore: function () { return moveFocus('month', 'before'); },
        focusMonthAfter: function () { return moveFocus('month', 'after'); },
        focusYearBefore: function () { return moveFocus('year', 'before'); },
        focusYearAfter: function () { return moveFocus('year', 'after'); },
        focusStartOfWeek: function () { return moveFocus('startOfWeek', 'before'); },
        focusEndOfWeek: function () { return moveFocus('endOfWeek', 'after'); }
    };
    return (jsxRuntimeExports.jsx(FocusContext.Provider, { value: value, children: props.children }));
}
/**
 * Hook to access the {@link FocusContextValue}. Use this hook to handle the
 * focus state of the elements.
 *
 * This hook is meant to be used inside internal or custom components.
 */
function useFocusContext() {
    var context = (0,react.useContext)(FocusContext);
    if (!context) {
        throw new Error('useFocusContext must be used within a FocusProvider');
    }
    return context;
}

/**
 * Return the active modifiers for the specified day.
 *
 * This hook is meant to be used inside internal or custom components.
 *
 * @param day
 * @param displayMonth
 */
function useActiveModifiers(day, 
/**
 * The month where the date is displayed. If not the same as `date`, the day
 * is an "outside day".
 */
displayMonth) {
    var modifiers = useModifiers();
    var activeModifiers = getActiveModifiers(day, modifiers, displayMonth);
    return activeModifiers;
}

/**
 * The SelectSingle context shares details about the selected days when in
 * single selection mode.
 *
 * Access this context from the {@link useSelectSingle} hook.
 */
var SelectSingleContext = (0,react.createContext)(undefined);
/** Provides the values for the {@link SelectSingleProvider}. */
function SelectSingleProvider(props) {
    if (!isDayPickerSingle(props.initialProps)) {
        var emptyContextValue = {
            selected: undefined
        };
        return (jsxRuntimeExports.jsx(SelectSingleContext.Provider, { value: emptyContextValue, children: props.children }));
    }
    return (jsxRuntimeExports.jsx(SelectSingleProviderInternal, { initialProps: props.initialProps, children: props.children }));
}
function SelectSingleProviderInternal(_a) {
    var initialProps = _a.initialProps, children = _a.children;
    var onDayClick = function (day, activeModifiers, e) {
        var _a, _b, _c;
        (_a = initialProps.onDayClick) === null || _a === void 0 ? void 0 : _a.call(initialProps, day, activeModifiers, e);
        if (activeModifiers.selected && !initialProps.required) {
            (_b = initialProps.onSelect) === null || _b === void 0 ? void 0 : _b.call(initialProps, undefined, day, activeModifiers, e);
            return;
        }
        (_c = initialProps.onSelect) === null || _c === void 0 ? void 0 : _c.call(initialProps, day, day, activeModifiers, e);
    };
    var contextValue = {
        selected: initialProps.selected,
        onDayClick: onDayClick
    };
    return (jsxRuntimeExports.jsx(SelectSingleContext.Provider, { value: contextValue, children: children }));
}
/**
 * Hook to access the {@link SelectSingleContextValue}.
 *
 * This hook is meant to be used inside internal or custom components.
 */
function useSelectSingle() {
    var context = (0,react.useContext)(SelectSingleContext);
    if (!context) {
        throw new Error('useSelectSingle must be used within a SelectSingleProvider');
    }
    return context;
}

/**
 * This hook returns details about the content to render in the day cell.
 *
 *
 * When a day cell is rendered in the table, DayPicker can either:
 *
 * - render nothing: when the day is outside the month or has matched the
 *   "hidden" modifier.
 * - render a button when `onDayClick` or a selection mode is set.
 * - render a non-interactive element: when no selection mode is set, the day
 *   cell shouldn’t respond to any interaction. DayPicker should render a `div`
 *   or a `span`.
 *
 * ### Usage
 *
 * Use this hook to customize the behavior of the {@link Day} component. Create a
 * new `Day` component using this hook and pass it to the `components` prop.
 * The source of {@link Day} can be a good starting point.
 *
 */
function useDayEventHandlers(date, activeModifiers) {
    var dayPicker = useDayPicker();
    var single = useSelectSingle();
    var multiple = useSelectMultiple();
    var range = useSelectRange();
    var _a = useFocusContext(), focusDayAfter = _a.focusDayAfter, focusDayBefore = _a.focusDayBefore, focusWeekAfter = _a.focusWeekAfter, focusWeekBefore = _a.focusWeekBefore, blur = _a.blur, focus = _a.focus, focusMonthBefore = _a.focusMonthBefore, focusMonthAfter = _a.focusMonthAfter, focusYearBefore = _a.focusYearBefore, focusYearAfter = _a.focusYearAfter, focusStartOfWeek = _a.focusStartOfWeek, focusEndOfWeek = _a.focusEndOfWeek;
    var onClick = function (e) {
        var _a, _b, _c, _d;
        if (isDayPickerSingle(dayPicker)) {
            (_a = single.onDayClick) === null || _a === void 0 ? void 0 : _a.call(single, date, activeModifiers, e);
        }
        else if (isDayPickerMultiple(dayPicker)) {
            (_b = multiple.onDayClick) === null || _b === void 0 ? void 0 : _b.call(multiple, date, activeModifiers, e);
        }
        else if (isDayPickerRange(dayPicker)) {
            (_c = range.onDayClick) === null || _c === void 0 ? void 0 : _c.call(range, date, activeModifiers, e);
        }
        else {
            (_d = dayPicker.onDayClick) === null || _d === void 0 ? void 0 : _d.call(dayPicker, date, activeModifiers, e);
        }
    };
    var onFocus = function (e) {
        var _a;
        focus(date);
        (_a = dayPicker.onDayFocus) === null || _a === void 0 ? void 0 : _a.call(dayPicker, date, activeModifiers, e);
    };
    var onBlur = function (e) {
        var _a;
        blur();
        (_a = dayPicker.onDayBlur) === null || _a === void 0 ? void 0 : _a.call(dayPicker, date, activeModifiers, e);
    };
    var onMouseEnter = function (e) {
        var _a;
        (_a = dayPicker.onDayMouseEnter) === null || _a === void 0 ? void 0 : _a.call(dayPicker, date, activeModifiers, e);
    };
    var onMouseLeave = function (e) {
        var _a;
        (_a = dayPicker.onDayMouseLeave) === null || _a === void 0 ? void 0 : _a.call(dayPicker, date, activeModifiers, e);
    };
    var onPointerEnter = function (e) {
        var _a;
        (_a = dayPicker.onDayPointerEnter) === null || _a === void 0 ? void 0 : _a.call(dayPicker, date, activeModifiers, e);
    };
    var onPointerLeave = function (e) {
        var _a;
        (_a = dayPicker.onDayPointerLeave) === null || _a === void 0 ? void 0 : _a.call(dayPicker, date, activeModifiers, e);
    };
    var onTouchCancel = function (e) {
        var _a;
        (_a = dayPicker.onDayTouchCancel) === null || _a === void 0 ? void 0 : _a.call(dayPicker, date, activeModifiers, e);
    };
    var onTouchEnd = function (e) {
        var _a;
        (_a = dayPicker.onDayTouchEnd) === null || _a === void 0 ? void 0 : _a.call(dayPicker, date, activeModifiers, e);
    };
    var onTouchMove = function (e) {
        var _a;
        (_a = dayPicker.onDayTouchMove) === null || _a === void 0 ? void 0 : _a.call(dayPicker, date, activeModifiers, e);
    };
    var onTouchStart = function (e) {
        var _a;
        (_a = dayPicker.onDayTouchStart) === null || _a === void 0 ? void 0 : _a.call(dayPicker, date, activeModifiers, e);
    };
    var onKeyUp = function (e) {
        var _a;
        (_a = dayPicker.onDayKeyUp) === null || _a === void 0 ? void 0 : _a.call(dayPicker, date, activeModifiers, e);
    };
    var onKeyDown = function (e) {
        var _a;
        switch (e.key) {
            case 'ArrowLeft':
                e.preventDefault();
                e.stopPropagation();
                dayPicker.dir === 'rtl' ? focusDayAfter() : focusDayBefore();
                break;
            case 'ArrowRight':
                e.preventDefault();
                e.stopPropagation();
                dayPicker.dir === 'rtl' ? focusDayBefore() : focusDayAfter();
                break;
            case 'ArrowDown':
                e.preventDefault();
                e.stopPropagation();
                focusWeekAfter();
                break;
            case 'ArrowUp':
                e.preventDefault();
                e.stopPropagation();
                focusWeekBefore();
                break;
            case 'PageUp':
                e.preventDefault();
                e.stopPropagation();
                e.shiftKey ? focusYearBefore() : focusMonthBefore();
                break;
            case 'PageDown':
                e.preventDefault();
                e.stopPropagation();
                e.shiftKey ? focusYearAfter() : focusMonthAfter();
                break;
            case 'Home':
                e.preventDefault();
                e.stopPropagation();
                focusStartOfWeek();
                break;
            case 'End':
                e.preventDefault();
                e.stopPropagation();
                focusEndOfWeek();
                break;
        }
        (_a = dayPicker.onDayKeyDown) === null || _a === void 0 ? void 0 : _a.call(dayPicker, date, activeModifiers, e);
    };
    var eventHandlers = {
        onClick: onClick,
        onFocus: onFocus,
        onBlur: onBlur,
        onKeyDown: onKeyDown,
        onKeyUp: onKeyUp,
        onMouseEnter: onMouseEnter,
        onMouseLeave: onMouseLeave,
        onPointerEnter: onPointerEnter,
        onPointerLeave: onPointerLeave,
        onTouchCancel: onTouchCancel,
        onTouchEnd: onTouchEnd,
        onTouchMove: onTouchMove,
        onTouchStart: onTouchStart
    };
    return eventHandlers;
}

/**
 * Return the current selected days when DayPicker is in selection mode. Days
 * selected by the custom selection mode are not returned.
 *
 * This hook is meant to be used inside internal or custom components.
 *
 */
function useSelectedDays() {
    var dayPicker = useDayPicker();
    var single = useSelectSingle();
    var multiple = useSelectMultiple();
    var range = useSelectRange();
    var selectedDays = isDayPickerSingle(dayPicker)
        ? single.selected
        : isDayPickerMultiple(dayPicker)
            ? multiple.selected
            : isDayPickerRange(dayPicker)
                ? range.selected
                : undefined;
    return selectedDays;
}

function isInternalModifier(modifier) {
    return Object.values(InternalModifier).includes(modifier);
}
/**
 * Return the class names for the Day element, according to the given active
 * modifiers.
 *
 * Custom class names are set via `modifiersClassNames` or `classNames`,
 * where the first have the precedence.
 */
function getDayClassNames(dayPicker, activeModifiers) {
    var classNames = [dayPicker.classNames.day];
    Object.keys(activeModifiers).forEach(function (modifier) {
        var customClassName = dayPicker.modifiersClassNames[modifier];
        if (customClassName) {
            classNames.push(customClassName);
        }
        else if (isInternalModifier(modifier)) {
            var internalClassName = dayPicker.classNames["day_".concat(modifier)];
            if (internalClassName) {
                classNames.push(internalClassName);
            }
        }
    });
    return classNames;
}

/** Return the style for the Day element, according to the given active modifiers. */
function getDayStyle(dayPicker, activeModifiers) {
    var style = __assign({}, dayPicker.styles.day);
    Object.keys(activeModifiers).forEach(function (modifier) {
        var _a;
        style = __assign(__assign({}, style), (_a = dayPicker.modifiersStyles) === null || _a === void 0 ? void 0 : _a[modifier]);
    });
    return style;
}

/**
 * Return props and data used to render the {@link Day} component.
 *
 * Use this hook when creating a component to replace the built-in `Day`
 * component.
 */
function useDayRender(
/** The date to render. */
day, 
/** The month where the date is displayed (if not the same as `date`, it means it is an "outside" day). */
displayMonth, 
/** A ref to the button element that will be target of focus when rendered (if required). */
buttonRef) {
    var _a;
    var _b, _c;
    var dayPicker = useDayPicker();
    var focusContext = useFocusContext();
    var activeModifiers = useActiveModifiers(day, displayMonth);
    var eventHandlers = useDayEventHandlers(day, activeModifiers);
    var selectedDays = useSelectedDays();
    var isButton = Boolean(dayPicker.onDayClick || dayPicker.mode !== 'default');
    // Focus the button if the day is focused according to the focus context
    (0,react.useEffect)(function () {
        var _a;
        if (activeModifiers.outside)
            return;
        if (!focusContext.focusedDay)
            return;
        if (!isButton)
            return;
        if (isSameDay(focusContext.focusedDay, day)) {
            (_a = buttonRef.current) === null || _a === void 0 ? void 0 : _a.focus();
        }
    }, [
        focusContext.focusedDay,
        day,
        buttonRef,
        isButton,
        activeModifiers.outside
    ]);
    var className = getDayClassNames(dayPicker, activeModifiers).join(' ');
    var style = getDayStyle(dayPicker, activeModifiers);
    var isHidden = Boolean((activeModifiers.outside && !dayPicker.showOutsideDays) ||
        activeModifiers.hidden);
    var DayContentComponent = (_c = (_b = dayPicker.components) === null || _b === void 0 ? void 0 : _b.DayContent) !== null && _c !== void 0 ? _c : DayContent;
    var children = (jsxRuntimeExports.jsx(DayContentComponent, { date: day, displayMonth: displayMonth, activeModifiers: activeModifiers }));
    var divProps = {
        style: style,
        className: className,
        children: children,
        role: 'gridcell'
    };
    var isFocusTarget = focusContext.focusTarget &&
        isSameDay(focusContext.focusTarget, day) &&
        !activeModifiers.outside;
    var isFocused = focusContext.focusedDay && isSameDay(focusContext.focusedDay, day);
    var buttonProps = __assign(__assign(__assign({}, divProps), (_a = { disabled: activeModifiers.disabled, role: 'gridcell' }, _a['aria-selected'] = activeModifiers.selected, _a.tabIndex = isFocused || isFocusTarget ? 0 : -1, _a)), eventHandlers);
    var dayRender = {
        isButton: isButton,
        isHidden: isHidden,
        activeModifiers: activeModifiers,
        selectedDays: selectedDays,
        buttonProps: buttonProps,
        divProps: divProps
    };
    return dayRender;
}

/**
 * The content of a day cell – as a button or span element according to its
 * modifiers.
 */
function Day(props) {
    var buttonRef = (0,react.useRef)(null);
    var dayRender = useDayRender(props.date, props.displayMonth, buttonRef);
    if (dayRender.isHidden) {
        return jsxRuntimeExports.jsx("div", { role: "gridcell" });
    }
    if (!dayRender.isButton) {
        return jsxRuntimeExports.jsx("div", __assign({}, dayRender.divProps));
    }
    return jsxRuntimeExports.jsx(Button, __assign({ name: "day", ref: buttonRef }, dayRender.buttonProps));
}

/**
 * Render the week number element. If `onWeekNumberClick` is passed to DayPicker, it
 * renders a button, otherwise a span element.
 */
function WeekNumber(props) {
    var weekNumber = props.number, dates = props.dates;
    var _a = useDayPicker(), onWeekNumberClick = _a.onWeekNumberClick, styles = _a.styles, classNames = _a.classNames, locale = _a.locale, labelWeekNumber = _a.labels.labelWeekNumber, formatWeekNumber = _a.formatters.formatWeekNumber;
    var content = formatWeekNumber(Number(weekNumber), { locale: locale });
    if (!onWeekNumberClick) {
        return (jsxRuntimeExports.jsx("span", { className: classNames.weeknumber, style: styles.weeknumber, children: content }));
    }
    var label = labelWeekNumber(Number(weekNumber), { locale: locale });
    var handleClick = function (e) {
        onWeekNumberClick(weekNumber, dates, e);
    };
    return (jsxRuntimeExports.jsx(Button, { name: "week-number", "aria-label": label, className: classNames.weeknumber, style: styles.weeknumber, onClick: handleClick, children: content }));
}

/** Render a row in the calendar, with the days and the week number. */
function Row(props) {
    var _a, _b;
    var _c = useDayPicker(), styles = _c.styles, classNames = _c.classNames, showWeekNumber = _c.showWeekNumber, components = _c.components;
    var DayComponent = (_a = components === null || components === void 0 ? void 0 : components.Day) !== null && _a !== void 0 ? _a : Day;
    var WeeknumberComponent = (_b = components === null || components === void 0 ? void 0 : components.WeekNumber) !== null && _b !== void 0 ? _b : WeekNumber;
    var weekNumberCell;
    if (showWeekNumber) {
        weekNumberCell = (jsxRuntimeExports.jsx("td", { className: classNames.cell, style: styles.cell, children: jsxRuntimeExports.jsx(WeeknumberComponent, { number: props.weekNumber, dates: props.dates }) }));
    }
    return (jsxRuntimeExports.jsxs("tr", { className: classNames.row, style: styles.row, children: [weekNumberCell, props.dates.map(function (date) { return (jsxRuntimeExports.jsx("td", { className: classNames.cell, style: styles.cell, role: "presentation", children: jsxRuntimeExports.jsx(DayComponent, { displayMonth: props.displayMonth, date: date }) }, getUnixTime(date))); })] }));
}

/** Return the weeks between two dates.  */
function daysToMonthWeeks(fromDate, toDate, options) {
    var toWeek = (options === null || options === void 0 ? void 0 : options.ISOWeek)
        ? endOfISOWeek(toDate)
        : endOfWeek(toDate, options);
    var fromWeek = (options === null || options === void 0 ? void 0 : options.ISOWeek)
        ? startOfISOWeek(fromDate)
        : startOfWeek(fromDate, options);
    var nOfDays = differenceInCalendarDays_differenceInCalendarDays(toWeek, fromWeek);
    var days = [];
    for (var i = 0; i <= nOfDays; i++) {
        days.push(addDays(fromWeek, i));
    }
    var weeksInMonth = days.reduce(function (result, date) {
        var weekNumber = (options === null || options === void 0 ? void 0 : options.ISOWeek)
            ? getISOWeek(date)
            : getWeek(date, options);
        var existingWeek = result.find(function (value) { return value.weekNumber === weekNumber; });
        if (existingWeek) {
            existingWeek.dates.push(date);
            return result;
        }
        result.push({
            weekNumber: weekNumber,
            dates: [date]
        });
        return result;
    }, []);
    return weeksInMonth;
}

/**
 * Return the weeks belonging to the given month, adding the "outside days" to
 * the first and last week.
 */
function getMonthWeeks(month, options) {
    var weeksInMonth = daysToMonthWeeks(startOfMonth(month), endOfMonth(month), options);
    if (options === null || options === void 0 ? void 0 : options.useFixedWeeks) {
        // Add extra weeks to the month, up to 6 weeks
        var nrOfMonthWeeks = getWeeksInMonth(month, options);
        if (nrOfMonthWeeks < 6) {
            var lastWeek = weeksInMonth[weeksInMonth.length - 1];
            var lastDate = lastWeek.dates[lastWeek.dates.length - 1];
            var toDate = addWeeks(lastDate, 6 - nrOfMonthWeeks);
            var extraWeeks = daysToMonthWeeks(addWeeks(lastDate, 1), toDate, options);
            weeksInMonth.push.apply(weeksInMonth, extraWeeks);
        }
    }
    return weeksInMonth;
}

/** Render the table with the calendar. */
function Table(props) {
    var _a, _b, _c;
    var _d = useDayPicker(), locale = _d.locale, classNames = _d.classNames, styles = _d.styles, hideHead = _d.hideHead, fixedWeeks = _d.fixedWeeks, components = _d.components, weekStartsOn = _d.weekStartsOn, firstWeekContainsDate = _d.firstWeekContainsDate, ISOWeek = _d.ISOWeek;
    var weeks = getMonthWeeks(props.displayMonth, {
        useFixedWeeks: Boolean(fixedWeeks),
        ISOWeek: ISOWeek,
        locale: locale,
        weekStartsOn: weekStartsOn,
        firstWeekContainsDate: firstWeekContainsDate
    });
    var HeadComponent = (_a = components === null || components === void 0 ? void 0 : components.Head) !== null && _a !== void 0 ? _a : Head;
    var RowComponent = (_b = components === null || components === void 0 ? void 0 : components.Row) !== null && _b !== void 0 ? _b : Row;
    var FooterComponent = (_c = components === null || components === void 0 ? void 0 : components.Footer) !== null && _c !== void 0 ? _c : Footer;
    return (jsxRuntimeExports.jsxs("table", { id: props.id, className: classNames.table, style: styles.table, role: "grid", "aria-labelledby": props['aria-labelledby'], children: [!hideHead && jsxRuntimeExports.jsx(HeadComponent, {}), jsxRuntimeExports.jsx("tbody", { className: classNames.tbody, style: styles.tbody, children: weeks.map(function (week) { return (jsxRuntimeExports.jsx(RowComponent, { displayMonth: props.displayMonth, dates: week.dates, weekNumber: week.weekNumber }, week.weekNumber)); }) }), jsxRuntimeExports.jsx(FooterComponent, { displayMonth: props.displayMonth })] }));
}

/*
The MIT License (MIT)

Copyright (c) 2018-present, React Training LLC

Permission is hereby granted, free of charge, to any person obtaining a copy of this software and associated documentation files (the "Software"), to deal in the Software without restriction, including without limitation the rights to use, copy, modify, merge, publish, distribute, sublicense, and/or sell copies of the Software, and to permit persons to whom the Software is furnished to do so, subject to the following conditions:

The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.
*/
/* eslint-disable prefer-const */
/* eslint-disable @typescript-eslint/ban-ts-comment */
/*
 * Welcome to @reach/auto-id!
 * Let's see if we can make sense of why this hook exists and its
 * implementation.
 *
 * Some background:
 *   1. Accessibility APIs rely heavily on element IDs
 *   2. Requiring developers to put IDs on every element in Reach UI is both
 *      cumbersome and error-prone
 *   3. With a component model, we can generate IDs for them!
 *
 * Solution 1: Generate random IDs.
 *
 * This works great as long as you don't server render your app. When React (in
 * the client) tries to reuse the markup from the server, the IDs won't match
 * and React will then recreate the entire DOM tree.
 *
 * Solution 2: Increment an integer
 *
 * This sounds great. Since we're rendering the exact same tree on the server
 * and client, we can increment a counter and get a deterministic result between
 * client and server. Also, JS integers can go up to nine-quadrillion. I'm
 * pretty sure the tab will be closed before an app never needs
 * 10 quadrillion IDs!
 *
 * Problem solved, right?
 *
 * Ah, but there's a catch! React's concurrent rendering makes this approach
 * non-deterministic. While the client and server will end up with the same
 * elements in the end, depending on suspense boundaries (and possibly some user
 * input during the initial render) the incrementing integers won't always match
 * up.
 *
 * Solution 3: Don't use IDs at all on the server; patch after first render.
 *
 * What we've done here is solution 2 with some tricks. With this approach, the
 * ID returned is an empty string on the first render. This way the server and
 * client have the same markup no matter how wild the concurrent rendering may
 * have gotten.
 *
 * After the render, we patch up the components with an incremented ID. This
 * causes a double render on any components with `useId`. Shouldn't be a problem
 * since the components using this hook should be small, and we're only updating
 * the ID attribute on the DOM, nothing big is happening.
 *
 * It doesn't have to be an incremented number, though--we could do generate
 * random strings instead, but incrementing a number is probably the cheapest
 * thing we can do.
 *
 * Additionally, we only do this patchup on the very first client render ever.
 * Any calls to `useId` that happen dynamically in the client will be
 * populated immediately with a value. So, we only get the double render after
 * server hydration and never again, SO BACK OFF ALRIGHT?
 */
function canUseDOM() {
    return !!(typeof window !== 'undefined' &&
        window.document &&
        window.document.createElement);
}
/**
 * React currently throws a warning when using useLayoutEffect on the server. To
 * get around it, we can conditionally useEffect on the server (no-op) and
 * useLayoutEffect in the browser. We occasionally need useLayoutEffect to
 * ensure we don't get a render flash for certain operations, but we may also
 * need affected components to render on the server. One example is when setting
 * a component's descendants to retrieve their index values.
 *
 * Important to note that using this hook as an escape hatch will break the
 * eslint dependency warnings unless you rename the import to `useLayoutEffect`.
 * Use sparingly only when the effect won't effect the rendered HTML to avoid
 * any server/client mismatch.
 *
 * If a useLayoutEffect is needed and the result would create a mismatch, it's
 * likely that the component in question shouldn't be rendered on the server at
 * all, so a better approach would be to lazily render those in a parent
 * component after client-side hydration.
 *
 * https://gist.github.com/gaearon/e7d97cdf38a2907924ea12e4ebdf3c85
 * https://github.com/reduxjs/react-redux/blob/master/src/utils/useIsomorphicLayoutEffect.js
 *
 * @param effect
 * @param deps
 */
var useIsomorphicLayoutEffect = canUseDOM() ? react.useLayoutEffect : react.useEffect;
var serverHandoffComplete = false;
var id = 0;
function genId() {
    return "react-day-picker-".concat(++id);
}
function useId(providedId) {
    // TODO: Remove error flag when updating internal deps to React 18. None of
    // our tricks will play well with concurrent rendering anyway.
    var _a;
    // If this instance isn't part of the initial render, we don't have to do the
    // double render/patch-up dance. We can just generate the ID and return it.
    var initialId = providedId !== null && providedId !== void 0 ? providedId : (serverHandoffComplete ? genId() : null);
    var _b = (0,react.useState)(initialId), id = _b[0], setId = _b[1];
    useIsomorphicLayoutEffect(function () {
        if (id === null) {
            // Patch the ID after render. We do this in `useLayoutEffect` to avoid any
            // rendering flicker, though it'll make the first render slower (unlikely
            // to matter, but you're welcome to measure your app and let us know if
            // it's a problem).
            setId(genId());
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    (0,react.useEffect)(function () {
        if (serverHandoffComplete === false) {
            // Flag all future uses of `useId` to skip the update dance. This is in
            // `useEffect` because it goes after `useLayoutEffect`, ensuring we don't
            // accidentally bail out of the patch-up dance prematurely.
            serverHandoffComplete = true;
        }
    }, []);
    return (_a = providedId !== null && providedId !== void 0 ? providedId : id) !== null && _a !== void 0 ? _a : undefined;
}

/** Render a month. */
function Month(props) {
    var _a;
    var _b;
    var dayPicker = useDayPicker();
    var dir = dayPicker.dir, classNames = dayPicker.classNames, styles = dayPicker.styles, components = dayPicker.components;
    var displayMonths = useNavigation().displayMonths;
    var captionId = useId(dayPicker.id ? "".concat(dayPicker.id, "-").concat(props.displayIndex) : undefined);
    var tableId = dayPicker.id
        ? "".concat(dayPicker.id, "-grid-").concat(props.displayIndex)
        : undefined;
    var className = [classNames.month];
    var style = styles.month;
    var isStart = props.displayIndex === 0;
    var isEnd = props.displayIndex === displayMonths.length - 1;
    var isCenter = !isStart && !isEnd;
    if (dir === 'rtl') {
        _a = [isStart, isEnd], isEnd = _a[0], isStart = _a[1];
    }
    if (isStart) {
        className.push(classNames.caption_start);
        style = __assign(__assign({}, style), styles.caption_start);
    }
    if (isEnd) {
        className.push(classNames.caption_end);
        style = __assign(__assign({}, style), styles.caption_end);
    }
    if (isCenter) {
        className.push(classNames.caption_between);
        style = __assign(__assign({}, style), styles.caption_between);
    }
    var CaptionComponent = (_b = components === null || components === void 0 ? void 0 : components.Caption) !== null && _b !== void 0 ? _b : Caption;
    return (jsxRuntimeExports.jsxs("div", { className: className.join(' '), style: style, children: [jsxRuntimeExports.jsx(CaptionComponent, { id: captionId, displayMonth: props.displayMonth, displayIndex: props.displayIndex }), jsxRuntimeExports.jsx(Table, { id: tableId, "aria-labelledby": captionId, displayMonth: props.displayMonth })] }, props.displayIndex));
}

/**
 * Render the wrapper for the month grids.
 */
function Months(props) {
    var _a = useDayPicker(), classNames = _a.classNames, styles = _a.styles;
    return (jsxRuntimeExports.jsx("div", { className: classNames.months, style: styles.months, children: props.children }));
}

/** Render the container with the months according to the number of months to display. */
function Root(_a) {
    var _b, _c;
    var initialProps = _a.initialProps;
    var dayPicker = useDayPicker();
    var focusContext = useFocusContext();
    var navigation = useNavigation();
    var _d = (0,react.useState)(false), hasInitialFocus = _d[0], setHasInitialFocus = _d[1];
    // Focus the focus target when initialFocus is passed in
    (0,react.useEffect)(function () {
        if (!dayPicker.initialFocus)
            return;
        if (!focusContext.focusTarget)
            return;
        if (hasInitialFocus)
            return;
        focusContext.focus(focusContext.focusTarget);
        setHasInitialFocus(true);
    }, [
        dayPicker.initialFocus,
        hasInitialFocus,
        focusContext.focus,
        focusContext.focusTarget,
        focusContext
    ]);
    // Apply classnames according to props
    var classNames = [dayPicker.classNames.root, dayPicker.className];
    if (dayPicker.numberOfMonths > 1) {
        classNames.push(dayPicker.classNames.multiple_months);
    }
    if (dayPicker.showWeekNumber) {
        classNames.push(dayPicker.classNames.with_weeknumber);
    }
    var style = __assign(__assign({}, dayPicker.styles.root), dayPicker.style);
    var dataAttributes = Object.keys(initialProps)
        .filter(function (key) { return key.startsWith('data-'); })
        .reduce(function (attrs, key) {
        var _a;
        return __assign(__assign({}, attrs), (_a = {}, _a[key] = initialProps[key], _a));
    }, {});
    var MonthsComponent = (_c = (_b = initialProps.components) === null || _b === void 0 ? void 0 : _b.Months) !== null && _c !== void 0 ? _c : Months;
    return (jsxRuntimeExports.jsx("div", __assign({ className: classNames.join(' '), style: style, dir: dayPicker.dir, id: dayPicker.id, nonce: initialProps.nonce, title: initialProps.title, lang: initialProps.lang }, dataAttributes, { children: jsxRuntimeExports.jsx(MonthsComponent, { children: navigation.displayMonths.map(function (month, i) { return (jsxRuntimeExports.jsx(Month, { displayIndex: i, displayMonth: month }, i)); }) }) })));
}

/** Provide the value for all the context providers. */
function RootProvider(props) {
    var children = props.children, initialProps = __rest(props, ["children"]);
    return (jsxRuntimeExports.jsx(DayPickerProvider, { initialProps: initialProps, children: jsxRuntimeExports.jsx(NavigationProvider, { children: jsxRuntimeExports.jsx(SelectSingleProvider, { initialProps: initialProps, children: jsxRuntimeExports.jsx(SelectMultipleProvider, { initialProps: initialProps, children: jsxRuntimeExports.jsx(SelectRangeProvider, { initialProps: initialProps, children: jsxRuntimeExports.jsx(ModifiersProvider, { children: jsxRuntimeExports.jsx(FocusProvider, { children: children }) }) }) }) }) }) }));
}

/**
 * DayPicker render a date picker component to let users pick dates from a
 * calendar. See http://react-day-picker.js.org for updated documentation and
 * examples.
 *
 * ### Customization
 *
 * DayPicker offers different customization props. For example,
 *
 * - show multiple months using `numberOfMonths`
 * - display a dropdown to navigate the months via `captionLayout`
 * - display the week numbers with `showWeekNumbers`
 * - disable or hide days with `disabled` or `hidden`
 *
 * ### Controlling the months
 *
 * Change the initially displayed month using the `defaultMonth` prop. The
 * displayed months are controlled by DayPicker and stored in its internal
 * state. To control the months yourself, use `month` instead of `defaultMonth`
 * and use the `onMonthChange` event to set it.
 *
 * To limit the months the user can navigate to, use
 * `fromDate`/`fromMonth`/`fromYear` or `toDate`/`toMonth`/`toYear`.
 *
 * ### Selection modes
 *
 * DayPicker supports different selection mode that can be toggled using the
 * `mode` prop:
 *
 * - `mode="single"`: only one day can be selected. Use `required` to make the
 *   selection required. Use the `onSelect` event handler to get the selected
 *   days.
 * - `mode="multiple"`: users can select one or more days. Limit the amount of
 *   days that can be selected with the `min` or the `max` props.
 * - `mode="range"`: users can select a range of days. Limit the amount of days
 *   in the range with the `min` or the `max` props.
 * - `mode="default"` (default): the built-in selections are disabled. Implement
 *   your own selection mode with `onDayClick`.
 *
 * The selection modes should cover the most common use cases. In case you
 * need a more refined way of selecting days, use `mode="default"`. Use the
 * `selected` props and add the day event handlers to add/remove days from the
 * selection.
 *
 * ### Modifiers
 *
 * A _modifier_ represents different styles or states for the days displayed in
 * the calendar (like "selected" or "disabled"). Define custom modifiers using
 * the `modifiers` prop.
 *
 * ### Formatters and custom component
 *
 * You can customize how the content is displayed in the date picker by using
 * either the formatters or replacing the internal components.
 *
 * For the most common cases you want to use the `formatters` prop to change how
 * the content is formatted in the calendar. Use the `components` prop to
 * replace the internal components, like the navigation icons.
 *
 * ### Styling
 *
 * DayPicker comes with a default, basic style in `react-day-picker/style` – use
 * it as template for your own style.
 *
 * If you are using CSS modules, pass the imported styles object the
 * `classNames` props.
 *
 * You can also style the elements via inline styles using the `styles` prop.
 *
 * ### Form fields
 *
 * If you need to bind the date picker to a form field, you can use the
 * `useInput` hooks for a basic behavior. See the `useInput` source as an
 * example to bind the date picker with form fields.
 *
 * ### Localization
 *
 * To localize DayPicker, import the locale from `date-fns` package and use the
 * `locale` prop.
 *
 * For example, to use Spanish locale:
 *
 * ```
 * import { es } from 'date-fns/locale';
 * <DayPicker locale={es} />
 * ```
 */
function DayPicker(props) {
    return (jsxRuntimeExports.jsx(RootProvider, __assign({}, props, { children: jsxRuntimeExports.jsx(Root, { initialProps: props }) })));
}

/** @private */
function isValidDate(day) {
    return !isNaN(day.getTime());
}

/** Return props and setters for binding an input field to DayPicker. */
function useInput(options) {
    if (options === void 0) { options = {}; }
    var _a = options.locale, locale = _a === void 0 ? enUS : _a, required = options.required, _b = options.format, format$1 = _b === void 0 ? 'PP' : _b, defaultSelected = options.defaultSelected, _c = options.today, today = _c === void 0 ? new Date() : _c;
    var _d = parseFromToProps(options), fromDate = _d.fromDate, toDate = _d.toDate;
    // Shortcut to the DateFns functions
    var parseValue = function (value) { return parse(value, format$1, today, { locale: locale }); };
    // Initialize states
    var _e = useState(defaultSelected !== null && defaultSelected !== void 0 ? defaultSelected : today), month = _e[0], setMonth = _e[1];
    var _f = useState(defaultSelected), selectedDay = _f[0], setSelectedDay = _f[1];
    var defaultInputValue = defaultSelected
        ? format(defaultSelected, format$1, { locale: locale })
        : '';
    var _g = useState(defaultInputValue), inputValue = _g[0], setInputValue = _g[1];
    var reset = function () {
        setSelectedDay(defaultSelected);
        setMonth(defaultSelected !== null && defaultSelected !== void 0 ? defaultSelected : today);
        setInputValue(defaultInputValue !== null && defaultInputValue !== void 0 ? defaultInputValue : '');
    };
    var setSelected = function (date) {
        setSelectedDay(date);
        setMonth(date !== null && date !== void 0 ? date : today);
        setInputValue(date ? format(date, format$1, { locale: locale }) : '');
    };
    var handleDayClick = function (day, _a) {
        var selected = _a.selected;
        if (!required && selected) {
            setSelectedDay(undefined);
            setInputValue('');
            return;
        }
        setSelectedDay(day);
        setInputValue(day ? format(day, format$1, { locale: locale }) : '');
    };
    var handleMonthChange = function (month) {
        setMonth(month);
    };
    // When changing the input field, save its value in state and check if the
    // string is a valid date. If it is a valid day, set it as selected and update
    // the calendar’s month.
    var handleChange = function (e) {
        setInputValue(e.target.value);
        var day = parseValue(e.target.value);
        var isBefore = fromDate && differenceInCalendarDays(fromDate, day) > 0;
        var isAfter = toDate && differenceInCalendarDays(day, toDate) > 0;
        if (!isValidDate(day) || isBefore || isAfter) {
            setSelectedDay(undefined);
            return;
        }
        setSelectedDay(day);
        setMonth(day);
    };
    // Special case for _required_ fields: on blur, if the value of the input is not
    // a valid date, reset the calendar and the input value.
    var handleBlur = function (e) {
        var day = parseValue(e.target.value);
        if (!isValidDate(day)) {
            reset();
        }
    };
    // When focusing, make sure DayPicker visualizes the month of the date in the
    // input field.
    var handleFocus = function (e) {
        if (!e.target.value) {
            reset();
            return;
        }
        var day = parseValue(e.target.value);
        if (isValidDate(day)) {
            setMonth(day);
        }
    };
    var dayPickerProps = {
        month: month,
        onDayClick: handleDayClick,
        onMonthChange: handleMonthChange,
        selected: selectedDay,
        locale: locale,
        fromDate: fromDate,
        toDate: toDate,
        today: today
    };
    var inputProps = {
        onBlur: handleBlur,
        onChange: handleChange,
        onFocus: handleFocus,
        value: inputValue,
        placeholder: format(new Date(), format$1, { locale: locale })
    };
    return { dayPickerProps: dayPickerProps, inputProps: inputProps, reset: reset, setSelected: setSelected };
}

/** Returns true when the props are of type {@link DayPickerDefaultProps}. */
function isDayPickerDefault(props) {
    return props.mode === undefined || props.mode === 'default';
}


//# sourceMappingURL=index.esm.js.map


/***/ }),

/***/ 55162:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "uI": function() { return /* binding */ useDropzone; }
});

// UNUSED EXPORTS: ErrorCode, default

// EXTERNAL MODULE: ./node_modules/next/dist/compiled/react/index.js
var react = __webpack_require__(55784);
// EXTERNAL MODULE: ./node_modules/prop-types/index.js
var prop_types = __webpack_require__(45697);
var prop_types_default = /*#__PURE__*/__webpack_require__.n(prop_types);
;// CONCATENATED MODULE: ./node_modules/file-selector/node_modules/tslib/tslib.es6.js
/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */
/* global Reflect, Promise */

var extendStatics = function(d, b) {
    extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
    return extendStatics(d, b);
};

function __extends(d, b) {
    if (typeof b !== "function" && b !== null)
        throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    extendStatics(d, b);
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}

var __assign = function() {
    __assign = Object.assign || function __assign(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    }
    return __assign.apply(this, arguments);
}

function __rest(s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
}

function __decorate(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}

function __param(paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
}

function __metadata(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}

function __awaiter(thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}

function __generator(thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
}

var __createBinding = Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
        desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});

function __exportStar(m, o) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(o, p)) __createBinding(o, m, p);
}

function __values(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}

function __read(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
}

/** @deprecated */
function __spread() {
    for (var ar = [], i = 0; i < arguments.length; i++)
        ar = ar.concat(__read(arguments[i]));
    return ar;
}

/** @deprecated */
function __spreadArrays() {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
}

function __spreadArray(to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
}

function __await(v) {
    return this instanceof __await ? (this.v = v, this) : new __await(v);
}

function __asyncGenerator(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function () { return this; }, i;
    function verb(n) { if (g[n]) i[n] = function (v) { return new Promise(function (a, b) { q.push([n, v, a, b]) > 1 || resume(n, v); }); }; }
    function resume(n, v) { try { step(g[n](v)); } catch (e) { settle(q[0][3], e); } }
    function step(r) { r.value instanceof __await ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r); }
    function fulfill(value) { resume("next", value); }
    function reject(value) { resume("throw", value); }
    function settle(f, v) { if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]); }
}

function __asyncDelegator(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function (e) { throw e; }), verb("return"), i[Symbol.iterator] = function () { return this; }, i;
    function verb(n, f) { i[n] = o[n] ? function (v) { return (p = !p) ? { value: __await(o[n](v)), done: n === "return" } : f ? f(v) : v; } : f; }
}

function __asyncValues(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof __values === "function" ? __values(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function () { return this; }, i);
    function verb(n) { i[n] = o[n] && function (v) { return new Promise(function (resolve, reject) { v = o[n](v), settle(resolve, reject, v.done, v.value); }); }; }
    function settle(resolve, reject, d, v) { Promise.resolve(v).then(function(v) { resolve({ value: v, done: d }); }, reject); }
}

function __makeTemplateObject(cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};

var __setModuleDefault = Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
};

function __importStar(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
}

function __importDefault(mod) {
    return (mod && mod.__esModule) ? mod : { default: mod };
}

function __classPrivateFieldGet(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
}

function __classPrivateFieldSet(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return (kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value)), value;
}

function __classPrivateFieldIn(state, receiver) {
    if (receiver === null || (typeof receiver !== "object" && typeof receiver !== "function")) throw new TypeError("Cannot use 'in' operator on non-object");
    return typeof state === "function" ? receiver === state : state.has(receiver);
}

;// CONCATENATED MODULE: ./node_modules/file-selector/dist/es5/file.js
var COMMON_MIME_TYPES = new Map([
    // https://developer.mozilla.org/en-US/docs/Web/HTTP/Basics_of_HTTP/MIME_types/Common_types
    ['aac', 'audio/aac'],
    ['abw', 'application/x-abiword'],
    ['arc', 'application/x-freearc'],
    ['avif', 'image/avif'],
    ['avi', 'video/x-msvideo'],
    ['azw', 'application/vnd.amazon.ebook'],
    ['bin', 'application/octet-stream'],
    ['bmp', 'image/bmp'],
    ['bz', 'application/x-bzip'],
    ['bz2', 'application/x-bzip2'],
    ['cda', 'application/x-cdf'],
    ['csh', 'application/x-csh'],
    ['css', 'text/css'],
    ['csv', 'text/csv'],
    ['doc', 'application/msword'],
    ['docx', 'application/vnd.openxmlformats-officedocument.wordprocessingml.document'],
    ['eot', 'application/vnd.ms-fontobject'],
    ['epub', 'application/epub+zip'],
    ['gz', 'application/gzip'],
    ['gif', 'image/gif'],
    ['heic', 'image/heic'],
    ['heif', 'image/heif'],
    ['htm', 'text/html'],
    ['html', 'text/html'],
    ['ico', 'image/vnd.microsoft.icon'],
    ['ics', 'text/calendar'],
    ['jar', 'application/java-archive'],
    ['jpeg', 'image/jpeg'],
    ['jpg', 'image/jpeg'],
    ['js', 'text/javascript'],
    ['json', 'application/json'],
    ['jsonld', 'application/ld+json'],
    ['mid', 'audio/midi'],
    ['midi', 'audio/midi'],
    ['mjs', 'text/javascript'],
    ['mp3', 'audio/mpeg'],
    ['mp4', 'video/mp4'],
    ['mpeg', 'video/mpeg'],
    ['mpkg', 'application/vnd.apple.installer+xml'],
    ['odp', 'application/vnd.oasis.opendocument.presentation'],
    ['ods', 'application/vnd.oasis.opendocument.spreadsheet'],
    ['odt', 'application/vnd.oasis.opendocument.text'],
    ['oga', 'audio/ogg'],
    ['ogv', 'video/ogg'],
    ['ogx', 'application/ogg'],
    ['opus', 'audio/opus'],
    ['otf', 'font/otf'],
    ['png', 'image/png'],
    ['pdf', 'application/pdf'],
    ['php', 'application/x-httpd-php'],
    ['ppt', 'application/vnd.ms-powerpoint'],
    ['pptx', 'application/vnd.openxmlformats-officedocument.presentationml.presentation'],
    ['rar', 'application/vnd.rar'],
    ['rtf', 'application/rtf'],
    ['sh', 'application/x-sh'],
    ['svg', 'image/svg+xml'],
    ['swf', 'application/x-shockwave-flash'],
    ['tar', 'application/x-tar'],
    ['tif', 'image/tiff'],
    ['tiff', 'image/tiff'],
    ['ts', 'video/mp2t'],
    ['ttf', 'font/ttf'],
    ['txt', 'text/plain'],
    ['vsd', 'application/vnd.visio'],
    ['wav', 'audio/wav'],
    ['weba', 'audio/webm'],
    ['webm', 'video/webm'],
    ['webp', 'image/webp'],
    ['woff', 'font/woff'],
    ['woff2', 'font/woff2'],
    ['xhtml', 'application/xhtml+xml'],
    ['xls', 'application/vnd.ms-excel'],
    ['xlsx', 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'],
    ['xml', 'application/xml'],
    ['xul', 'application/vnd.mozilla.xul+xml'],
    ['zip', 'application/zip'],
    ['7z', 'application/x-7z-compressed'],
    // Others
    ['mkv', 'video/x-matroska'],
    ['mov', 'video/quicktime'],
    ['msg', 'application/vnd.ms-outlook']
]);
function toFileWithPath(file, path) {
    var f = withMimeType(file);
    if (typeof f.path !== 'string') { // on electron, path is already set to the absolute path
        var webkitRelativePath = file.webkitRelativePath;
        Object.defineProperty(f, 'path', {
            value: typeof path === 'string'
                ? path
                // If <input webkitdirectory> is set,
                // the File will have a {webkitRelativePath} property
                // https://developer.mozilla.org/en-US/docs/Web/API/HTMLInputElement/webkitdirectory
                : typeof webkitRelativePath === 'string' && webkitRelativePath.length > 0
                    ? webkitRelativePath
                    : file.name,
            writable: false,
            configurable: false,
            enumerable: true
        });
    }
    return f;
}
function withMimeType(file) {
    var name = file.name;
    var hasExtension = name && name.lastIndexOf('.') !== -1;
    if (hasExtension && !file.type) {
        var ext = name.split('.')
            .pop().toLowerCase();
        var type = COMMON_MIME_TYPES.get(ext);
        if (type) {
            Object.defineProperty(file, 'type', {
                value: type,
                writable: false,
                configurable: false,
                enumerable: true
            });
        }
    }
    return file;
}
//# sourceMappingURL=file.js.map
;// CONCATENATED MODULE: ./node_modules/file-selector/dist/es5/file-selector.js


var FILES_TO_IGNORE = [
    // Thumbnail cache files for macOS and Windows
    '.DS_Store',
    'Thumbs.db' // Windows
];
/**
 * Convert a DragEvent's DataTrasfer object to a list of File objects
 * NOTE: If some of the items are folders,
 * everything will be flattened and placed in the same list but the paths will be kept as a {path} property.
 *
 * EXPERIMENTAL: A list of https://developer.mozilla.org/en-US/docs/Web/API/FileSystemHandle objects can also be passed as an arg
 * and a list of File objects will be returned.
 *
 * @param evt
 */
function fromEvent(evt) {
    return __awaiter(this, void 0, void 0, function () {
        return __generator(this, function (_a) {
            if (isObject(evt) && isDataTransfer(evt.dataTransfer)) {
                return [2 /*return*/, getDataTransferFiles(evt.dataTransfer, evt.type)];
            }
            else if (isChangeEvt(evt)) {
                return [2 /*return*/, getInputFiles(evt)];
            }
            else if (Array.isArray(evt) && evt.every(function (item) { return 'getFile' in item && typeof item.getFile === 'function'; })) {
                return [2 /*return*/, getFsHandleFiles(evt)];
            }
            return [2 /*return*/, []];
        });
    });
}
function isDataTransfer(value) {
    return isObject(value);
}
function isChangeEvt(value) {
    return isObject(value) && isObject(value.target);
}
function isObject(v) {
    return typeof v === 'object' && v !== null;
}
function getInputFiles(evt) {
    return fromList(evt.target.files).map(function (file) { return toFileWithPath(file); });
}
// Ee expect each handle to be https://developer.mozilla.org/en-US/docs/Web/API/FileSystemFileHandle
function getFsHandleFiles(handles) {
    return __awaiter(this, void 0, void 0, function () {
        var files;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, Promise.all(handles.map(function (h) { return h.getFile(); }))];
                case 1:
                    files = _a.sent();
                    return [2 /*return*/, files.map(function (file) { return toFileWithPath(file); })];
            }
        });
    });
}
function getDataTransferFiles(dt, type) {
    return __awaiter(this, void 0, void 0, function () {
        var items, files;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!dt.items) return [3 /*break*/, 2];
                    items = fromList(dt.items)
                        .filter(function (item) { return item.kind === 'file'; });
                    // According to https://html.spec.whatwg.org/multipage/dnd.html#dndevents,
                    // only 'dragstart' and 'drop' has access to the data (source node)
                    if (type !== 'drop') {
                        return [2 /*return*/, items];
                    }
                    return [4 /*yield*/, Promise.all(items.map(toFilePromises))];
                case 1:
                    files = _a.sent();
                    return [2 /*return*/, noIgnoredFiles(flatten(files))];
                case 2: return [2 /*return*/, noIgnoredFiles(fromList(dt.files)
                        .map(function (file) { return toFileWithPath(file); }))];
            }
        });
    });
}
function noIgnoredFiles(files) {
    return files.filter(function (file) { return FILES_TO_IGNORE.indexOf(file.name) === -1; });
}
// IE11 does not support Array.from()
// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/from#Browser_compatibility
// https://developer.mozilla.org/en-US/docs/Web/API/FileList
// https://developer.mozilla.org/en-US/docs/Web/API/DataTransferItemList
function fromList(items) {
    if (items === null) {
        return [];
    }
    var files = [];
    // tslint:disable: prefer-for-of
    for (var i = 0; i < items.length; i++) {
        var file = items[i];
        files.push(file);
    }
    return files;
}
// https://developer.mozilla.org/en-US/docs/Web/API/DataTransferItem
function toFilePromises(item) {
    if (typeof item.webkitGetAsEntry !== 'function') {
        return fromDataTransferItem(item);
    }
    var entry = item.webkitGetAsEntry();
    // Safari supports dropping an image node from a different window and can be retrieved using
    // the DataTransferItem.getAsFile() API
    // NOTE: FileSystemEntry.file() throws if trying to get the file
    if (entry && entry.isDirectory) {
        return fromDirEntry(entry);
    }
    return fromDataTransferItem(item);
}
function flatten(items) {
    return items.reduce(function (acc, files) { return __spreadArray(__spreadArray([], __read(acc), false), __read((Array.isArray(files) ? flatten(files) : [files])), false); }, []);
}
function fromDataTransferItem(item) {
    var file = item.getAsFile();
    if (!file) {
        return Promise.reject("".concat(item, " is not a File"));
    }
    var fwp = toFileWithPath(file);
    return Promise.resolve(fwp);
}
// https://developer.mozilla.org/en-US/docs/Web/API/FileSystemEntry
function fromEntry(entry) {
    return __awaiter(this, void 0, void 0, function () {
        return __generator(this, function (_a) {
            return [2 /*return*/, entry.isDirectory ? fromDirEntry(entry) : fromFileEntry(entry)];
        });
    });
}
// https://developer.mozilla.org/en-US/docs/Web/API/FileSystemDirectoryEntry
function fromDirEntry(entry) {
    var reader = entry.createReader();
    return new Promise(function (resolve, reject) {
        var entries = [];
        function readEntries() {
            var _this = this;
            // https://developer.mozilla.org/en-US/docs/Web/API/FileSystemDirectoryEntry/createReader
            // https://developer.mozilla.org/en-US/docs/Web/API/FileSystemDirectoryReader/readEntries
            reader.readEntries(function (batch) { return __awaiter(_this, void 0, void 0, function () {
                var files, err_1, items;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            if (!!batch.length) return [3 /*break*/, 5];
                            _a.label = 1;
                        case 1:
                            _a.trys.push([1, 3, , 4]);
                            return [4 /*yield*/, Promise.all(entries)];
                        case 2:
                            files = _a.sent();
                            resolve(files);
                            return [3 /*break*/, 4];
                        case 3:
                            err_1 = _a.sent();
                            reject(err_1);
                            return [3 /*break*/, 4];
                        case 4: return [3 /*break*/, 6];
                        case 5:
                            items = Promise.all(batch.map(fromEntry));
                            entries.push(items);
                            // Continue reading
                            readEntries();
                            _a.label = 6;
                        case 6: return [2 /*return*/];
                    }
                });
            }); }, function (err) {
                reject(err);
            });
        }
        readEntries();
    });
}
// https://developer.mozilla.org/en-US/docs/Web/API/FileSystemFileEntry
function fromFileEntry(entry) {
    return __awaiter(this, void 0, void 0, function () {
        return __generator(this, function (_a) {
            return [2 /*return*/, new Promise(function (resolve, reject) {
                    entry.file(function (file) {
                        var fwp = toFileWithPath(file, entry.fullPath);
                        resolve(fwp);
                    }, function (err) {
                        reject(err);
                    });
                })];
        });
    });
}
//# sourceMappingURL=file-selector.js.map
;// CONCATENATED MODULE: ./node_modules/file-selector/dist/es5/index.js

//# sourceMappingURL=index.js.map
// EXTERNAL MODULE: ./node_modules/attr-accept/dist/es/index.js
var es = __webpack_require__(58363);
;// CONCATENATED MODULE: ./node_modules/react-dropzone/dist/es/utils/index.js
function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

 // Error codes

var FILE_INVALID_TYPE = "file-invalid-type";
var FILE_TOO_LARGE = "file-too-large";
var FILE_TOO_SMALL = "file-too-small";
var TOO_MANY_FILES = "too-many-files";
var ErrorCode = {
  FileInvalidType: FILE_INVALID_TYPE,
  FileTooLarge: FILE_TOO_LARGE,
  FileTooSmall: FILE_TOO_SMALL,
  TooManyFiles: TOO_MANY_FILES
}; // File Errors

var getInvalidTypeRejectionErr = function getInvalidTypeRejectionErr(accept) {
  accept = Array.isArray(accept) && accept.length === 1 ? accept[0] : accept;
  var messageSuffix = Array.isArray(accept) ? "one of ".concat(accept.join(", ")) : accept;
  return {
    code: FILE_INVALID_TYPE,
    message: "File type must be ".concat(messageSuffix)
  };
};
var getTooLargeRejectionErr = function getTooLargeRejectionErr(maxSize) {
  return {
    code: FILE_TOO_LARGE,
    message: "File is larger than ".concat(maxSize, " ").concat(maxSize === 1 ? "byte" : "bytes")
  };
};
var getTooSmallRejectionErr = function getTooSmallRejectionErr(minSize) {
  return {
    code: FILE_TOO_SMALL,
    message: "File is smaller than ".concat(minSize, " ").concat(minSize === 1 ? "byte" : "bytes")
  };
};
var TOO_MANY_FILES_REJECTION = {
  code: TOO_MANY_FILES,
  message: "Too many files"
}; // Firefox versions prior to 53 return a bogus MIME type for every file drag, so dragovers with
// that MIME type will always be accepted

function fileAccepted(file, accept) {
  var isAcceptable = file.type === "application/x-moz-file" || (0,es/* default */.Z)(file, accept);
  return [isAcceptable, isAcceptable ? null : getInvalidTypeRejectionErr(accept)];
}
function fileMatchSize(file, minSize, maxSize) {
  if (isDefined(file.size)) {
    if (isDefined(minSize) && isDefined(maxSize)) {
      if (file.size > maxSize) return [false, getTooLargeRejectionErr(maxSize)];
      if (file.size < minSize) return [false, getTooSmallRejectionErr(minSize)];
    } else if (isDefined(minSize) && file.size < minSize) return [false, getTooSmallRejectionErr(minSize)];else if (isDefined(maxSize) && file.size > maxSize) return [false, getTooLargeRejectionErr(maxSize)];
  }

  return [true, null];
}

function isDefined(value) {
  return value !== undefined && value !== null;
}
/**
 *
 * @param {object} options
 * @param {File[]} options.files
 * @param {string|string[]} [options.accept]
 * @param {number} [options.minSize]
 * @param {number} [options.maxSize]
 * @param {boolean} [options.multiple]
 * @param {number} [options.maxFiles]
 * @param {(f: File) => FileError|FileError[]|null} [options.validator]
 * @returns
 */


function allFilesAccepted(_ref) {
  var files = _ref.files,
      accept = _ref.accept,
      minSize = _ref.minSize,
      maxSize = _ref.maxSize,
      multiple = _ref.multiple,
      maxFiles = _ref.maxFiles,
      validator = _ref.validator;

  if (!multiple && files.length > 1 || multiple && maxFiles >= 1 && files.length > maxFiles) {
    return false;
  }

  return files.every(function (file) {
    var _fileAccepted = fileAccepted(file, accept),
        _fileAccepted2 = _slicedToArray(_fileAccepted, 1),
        accepted = _fileAccepted2[0];

    var _fileMatchSize = fileMatchSize(file, minSize, maxSize),
        _fileMatchSize2 = _slicedToArray(_fileMatchSize, 1),
        sizeMatch = _fileMatchSize2[0];

    var customErrors = validator ? validator(file) : null;
    return accepted && sizeMatch && !customErrors;
  });
} // React's synthetic events has event.isPropagationStopped,
// but to remain compatibility with other libs (Preact) fall back
// to check event.cancelBubble

function isPropagationStopped(event) {
  if (typeof event.isPropagationStopped === "function") {
    return event.isPropagationStopped();
  } else if (typeof event.cancelBubble !== "undefined") {
    return event.cancelBubble;
  }

  return false;
}
function isEvtWithFiles(event) {
  if (!event.dataTransfer) {
    return !!event.target && !!event.target.files;
  } // https://developer.mozilla.org/en-US/docs/Web/API/DataTransfer/types
  // https://developer.mozilla.org/en-US/docs/Web/API/HTML_Drag_and_Drop_API/Recommended_drag_types#file


  return Array.prototype.some.call(event.dataTransfer.types, function (type) {
    return type === "Files" || type === "application/x-moz-file";
  });
}
function isKindFile(item) {
  return _typeof(item) === "object" && item !== null && item.kind === "file";
} // allow the entire document to be a drag target

function onDocumentDragOver(event) {
  event.preventDefault();
}

function isIe(userAgent) {
  return userAgent.indexOf("MSIE") !== -1 || userAgent.indexOf("Trident/") !== -1;
}

function isEdge(userAgent) {
  return userAgent.indexOf("Edge/") !== -1;
}

function isIeOrEdge() {
  var userAgent = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : window.navigator.userAgent;
  return isIe(userAgent) || isEdge(userAgent);
}
/**
 * This is intended to be used to compose event handlers
 * They are executed in order until one of them calls `event.isPropagationStopped()`.
 * Note that the check is done on the first invoke too,
 * meaning that if propagation was stopped before invoking the fns,
 * no handlers will be executed.
 *
 * @param {Function} fns the event hanlder functions
 * @return {Function} the event handler to add to an element
 */

function composeEventHandlers() {
  for (var _len = arguments.length, fns = new Array(_len), _key = 0; _key < _len; _key++) {
    fns[_key] = arguments[_key];
  }

  return function (event) {
    for (var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
      args[_key2 - 1] = arguments[_key2];
    }

    return fns.some(function (fn) {
      if (!isPropagationStopped(event) && fn) {
        fn.apply(void 0, [event].concat(args));
      }

      return isPropagationStopped(event);
    });
  };
}
/**
 * canUseFileSystemAccessAPI checks if the [File System Access API](https://developer.mozilla.org/en-US/docs/Web/API/File_System_Access_API)
 * is supported by the browser.
 * @returns {boolean}
 */

function canUseFileSystemAccessAPI() {
  return "showOpenFilePicker" in window;
}
/**
 * Convert the `{accept}` dropzone prop to the
 * `{types}` option for https://developer.mozilla.org/en-US/docs/Web/API/window/showOpenFilePicker
 *
 * @param {AcceptProp} accept
 * @returns {{accept: string[]}[]}
 */

function pickerOptionsFromAccept(accept) {
  if (isDefined(accept)) {
    var acceptForPicker = Object.entries(accept).filter(function (_ref2) {
      var _ref3 = _slicedToArray(_ref2, 2),
          mimeType = _ref3[0],
          ext = _ref3[1];

      var ok = true;

      if (!isMIMEType(mimeType)) {
        console.warn("Skipped \"".concat(mimeType, "\" because it is not a valid MIME type. Check https://developer.mozilla.org/en-US/docs/Web/HTTP/Basics_of_HTTP/MIME_types/Common_types for a list of valid MIME types."));
        ok = false;
      }

      if (!Array.isArray(ext) || !ext.every(isExt)) {
        console.warn("Skipped \"".concat(mimeType, "\" because an invalid file extension was provided."));
        ok = false;
      }

      return ok;
    }).reduce(function (agg, _ref4) {
      var _ref5 = _slicedToArray(_ref4, 2),
          mimeType = _ref5[0],
          ext = _ref5[1];

      return _objectSpread(_objectSpread({}, agg), {}, _defineProperty({}, mimeType, ext));
    }, {});
    return [{
      // description is required due to https://crbug.com/1264708
      description: "Files",
      accept: acceptForPicker
    }];
  }

  return accept;
}
/**
 * Convert the `{accept}` dropzone prop to an array of MIME types/extensions.
 * @param {AcceptProp} accept
 * @returns {string}
 */

function acceptPropAsAcceptAttr(accept) {
  if (isDefined(accept)) {
    return Object.entries(accept).reduce(function (a, _ref6) {
      var _ref7 = _slicedToArray(_ref6, 2),
          mimeType = _ref7[0],
          ext = _ref7[1];

      return [].concat(_toConsumableArray(a), [mimeType], _toConsumableArray(ext));
    }, []) // Silently discard invalid entries as pickerOptionsFromAccept warns about these
    .filter(function (v) {
      return isMIMEType(v) || isExt(v);
    }).join(",");
  }

  return undefined;
}
/**
 * Check if v is an exception caused by aborting a request (e.g window.showOpenFilePicker()).
 *
 * See https://developer.mozilla.org/en-US/docs/Web/API/DOMException.
 * @param {any} v
 * @returns {boolean} True if v is an abort exception.
 */

function isAbort(v) {
  return v instanceof DOMException && (v.name === "AbortError" || v.code === v.ABORT_ERR);
}
/**
 * Check if v is a security error.
 *
 * See https://developer.mozilla.org/en-US/docs/Web/API/DOMException.
 * @param {any} v
 * @returns {boolean} True if v is a security error.
 */

function isSecurityError(v) {
  return v instanceof DOMException && (v.name === "SecurityError" || v.code === v.SECURITY_ERR);
}
/**
 * Check if v is a MIME type string.
 *
 * See accepted format: https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input/file#unique_file_type_specifiers.
 *
 * @param {string} v
 */

function isMIMEType(v) {
  return v === "audio/*" || v === "video/*" || v === "image/*" || v === "text/*" || /\w+\/[-+.\w]+/g.test(v);
}
/**
 * Check if v is a file extension.
 * @param {string} v
 */

function isExt(v) {
  return /^.*\.[\w]+$/.test(v);
}
/**
 * @typedef {Object.<string, string[]>} AcceptProp
 */

/**
 * @typedef {object} FileError
 * @property {string} message
 * @property {ErrorCode|string} code
 */

/**
 * @typedef {"file-invalid-type"|"file-too-large"|"file-too-small"|"too-many-files"} ErrorCode
 */
;// CONCATENATED MODULE: ./node_modules/react-dropzone/dist/es/index.js
var _excluded = ["children"],
    _excluded2 = ["open"],
    _excluded3 = ["refKey", "role", "onKeyDown", "onFocus", "onBlur", "onClick", "onDragEnter", "onDragOver", "onDragLeave", "onDrop"],
    _excluded4 = ["refKey", "onChange", "onClick"];

function es_toConsumableArray(arr) { return es_arrayWithoutHoles(arr) || es_iterableToArray(arr) || es_unsupportedIterableToArray(arr) || es_nonIterableSpread(); }

function es_nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function es_iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function es_arrayWithoutHoles(arr) { if (Array.isArray(arr)) return es_arrayLikeToArray(arr); }

function es_slicedToArray(arr, i) { return es_arrayWithHoles(arr) || es_iterableToArrayLimit(arr, i) || es_unsupportedIterableToArray(arr, i) || es_nonIterableRest(); }

function es_nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function es_unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return es_arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return es_arrayLikeToArray(o, minLen); }

function es_arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function es_iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function es_arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function es_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function es_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? es_ownKeys(Object(source), !0).forEach(function (key) { es_defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : es_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function es_defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

/* eslint prefer-template: 0 */




/**
 * Convenience wrapper component for the `useDropzone` hook
 *
 * ```jsx
 * <Dropzone>
 *   {({getRootProps, getInputProps}) => (
 *     <div {...getRootProps()}>
 *       <input {...getInputProps()} />
 *       <p>Drag 'n' drop some files here, or click to select files</p>
 *     </div>
 *   )}
 * </Dropzone>
 * ```
 */

var Dropzone = /*#__PURE__*/(0,react.forwardRef)(function (_ref, ref) {
  var children = _ref.children,
      params = _objectWithoutProperties(_ref, _excluded);

  var _useDropzone = useDropzone(params),
      open = _useDropzone.open,
      props = _objectWithoutProperties(_useDropzone, _excluded2);

  (0,react.useImperativeHandle)(ref, function () {
    return {
      open: open
    };
  }, [open]); // TODO: Figure out why react-styleguidist cannot create docs if we don't return a jsx element

  return /*#__PURE__*/react.createElement(react.Fragment, null, children(es_objectSpread(es_objectSpread({}, props), {}, {
    open: open
  })));
});
Dropzone.displayName = "Dropzone"; // Add default props for react-docgen

var defaultProps = {
  disabled: false,
  getFilesFromEvent: fromEvent,
  maxSize: Infinity,
  minSize: 0,
  multiple: true,
  maxFiles: 0,
  preventDropOnDocument: true,
  noClick: false,
  noKeyboard: false,
  noDrag: false,
  noDragEventsBubbling: false,
  validator: null,
  useFsAccessApi: true,
  autoFocus: false
};
Dropzone.defaultProps = defaultProps;
Dropzone.propTypes = {
  /**
   * Render function that exposes the dropzone state and prop getter fns
   *
   * @param {object} params
   * @param {Function} params.getRootProps Returns the props you should apply to the root drop container you render
   * @param {Function} params.getInputProps Returns the props you should apply to hidden file input you render
   * @param {Function} params.open Open the native file selection dialog
   * @param {boolean} params.isFocused Dropzone area is in focus
   * @param {boolean} params.isFileDialogActive File dialog is opened
   * @param {boolean} params.isDragActive Active drag is in progress
   * @param {boolean} params.isDragAccept Dragged files are accepted
   * @param {boolean} params.isDragReject Some dragged files are rejected
   * @param {File[]} params.acceptedFiles Accepted files
   * @param {FileRejection[]} params.fileRejections Rejected files and why they were rejected
   */
  children: (prop_types_default()).func,

  /**
   * Set accepted file types.
   * Checkout https://developer.mozilla.org/en-US/docs/Web/API/window/showOpenFilePicker types option for more information.
   * Keep in mind that mime type determination is not reliable across platforms. CSV files,
   * for example, are reported as text/plain under macOS but as application/vnd.ms-excel under
   * Windows. In some cases there might not be a mime type set at all (https://github.com/react-dropzone/react-dropzone/issues/276).
   */
  accept: prop_types_default().objectOf(prop_types_default().arrayOf((prop_types_default()).string)),

  /**
   * Allow drag 'n' drop (or selection from the file dialog) of multiple files
   */
  multiple: (prop_types_default()).bool,

  /**
   * If false, allow dropped items to take over the current browser window
   */
  preventDropOnDocument: (prop_types_default()).bool,

  /**
   * If true, disables click to open the native file selection dialog
   */
  noClick: (prop_types_default()).bool,

  /**
   * If true, disables SPACE/ENTER to open the native file selection dialog.
   * Note that it also stops tracking the focus state.
   */
  noKeyboard: (prop_types_default()).bool,

  /**
   * If true, disables drag 'n' drop
   */
  noDrag: (prop_types_default()).bool,

  /**
   * If true, stops drag event propagation to parents
   */
  noDragEventsBubbling: (prop_types_default()).bool,

  /**
   * Minimum file size (in bytes)
   */
  minSize: (prop_types_default()).number,

  /**
   * Maximum file size (in bytes)
   */
  maxSize: (prop_types_default()).number,

  /**
   * Maximum accepted number of files
   * The default value is 0 which means there is no limitation to how many files are accepted.
   */
  maxFiles: (prop_types_default()).number,

  /**
   * Enable/disable the dropzone
   */
  disabled: (prop_types_default()).bool,

  /**
   * Use this to provide a custom file aggregator
   *
   * @param {(DragEvent|Event)} event A drag event or input change event (if files were selected via the file dialog)
   */
  getFilesFromEvent: (prop_types_default()).func,

  /**
   * Cb for when closing the file dialog with no selection
   */
  onFileDialogCancel: (prop_types_default()).func,

  /**
   * Cb for when opening the file dialog
   */
  onFileDialogOpen: (prop_types_default()).func,

  /**
   * Set to true to use the https://developer.mozilla.org/en-US/docs/Web/API/File_System_Access_API
   * to open the file picker instead of using an `<input type="file">` click event.
   */
  useFsAccessApi: (prop_types_default()).bool,

  /**
   * Set to true to focus the root element on render
   */
  autoFocus: (prop_types_default()).bool,

  /**
   * Cb for when the `dragenter` event occurs.
   *
   * @param {DragEvent} event
   */
  onDragEnter: (prop_types_default()).func,

  /**
   * Cb for when the `dragleave` event occurs
   *
   * @param {DragEvent} event
   */
  onDragLeave: (prop_types_default()).func,

  /**
   * Cb for when the `dragover` event occurs
   *
   * @param {DragEvent} event
   */
  onDragOver: (prop_types_default()).func,

  /**
   * Cb for when the `drop` event occurs.
   * Note that this callback is invoked after the `getFilesFromEvent` callback is done.
   *
   * Files are accepted or rejected based on the `accept`, `multiple`, `minSize` and `maxSize` props.
   * `accept` must be a valid [MIME type](http://www.iana.org/assignments/media-types/media-types.xhtml) according to [input element specification](https://www.w3.org/wiki/HTML/Elements/input/file) or a valid file extension.
   * If `multiple` is set to false and additional files are dropped,
   * all files besides the first will be rejected.
   * Any file which does not have a size in the [`minSize`, `maxSize`] range, will be rejected as well.
   *
   * Note that the `onDrop` callback will always be invoked regardless if the dropped files were accepted or rejected.
   * If you'd like to react to a specific scenario, use the `onDropAccepted`/`onDropRejected` props.
   *
   * `onDrop` will provide you with an array of [File](https://developer.mozilla.org/en-US/docs/Web/API/File) objects which you can then process and send to a server.
   * For example, with [SuperAgent](https://github.com/visionmedia/superagent) as a http/ajax library:
   *
   * ```js
   * function onDrop(acceptedFiles) {
   *   const req = request.post('/upload')
   *   acceptedFiles.forEach(file => {
   *     req.attach(file.name, file)
   *   })
   *   req.end(callback)
   * }
   * ```
   *
   * @param {File[]} acceptedFiles
   * @param {FileRejection[]} fileRejections
   * @param {(DragEvent|Event)} event A drag event or input change event (if files were selected via the file dialog)
   */
  onDrop: (prop_types_default()).func,

  /**
   * Cb for when the `drop` event occurs.
   * Note that if no files are accepted, this callback is not invoked.
   *
   * @param {File[]} files
   * @param {(DragEvent|Event)} event
   */
  onDropAccepted: (prop_types_default()).func,

  /**
   * Cb for when the `drop` event occurs.
   * Note that if no files are rejected, this callback is not invoked.
   *
   * @param {FileRejection[]} fileRejections
   * @param {(DragEvent|Event)} event
   */
  onDropRejected: (prop_types_default()).func,

  /**
   * Cb for when there's some error from any of the promises.
   *
   * @param {Error} error
   */
  onError: (prop_types_default()).func,

  /**
   * Custom validation function. It must return null if there's no errors.
   * @param {File} file
   * @returns {FileError|FileError[]|null}
   */
  validator: (prop_types_default()).func
};
/* harmony default export */ var dist_es = ((/* unused pure expression or super */ null && (Dropzone)));
/**
 * A function that is invoked for the `dragenter`,
 * `dragover` and `dragleave` events.
 * It is not invoked if the items are not files (such as link, text, etc.).
 *
 * @callback dragCb
 * @param {DragEvent} event
 */

/**
 * A function that is invoked for the `drop` or input change event.
 * It is not invoked if the items are not files (such as link, text, etc.).
 *
 * @callback dropCb
 * @param {File[]} acceptedFiles List of accepted files
 * @param {FileRejection[]} fileRejections List of rejected files and why they were rejected
 * @param {(DragEvent|Event)} event A drag event or input change event (if files were selected via the file dialog)
 */

/**
 * A function that is invoked for the `drop` or input change event.
 * It is not invoked if the items are files (such as link, text, etc.).
 *
 * @callback dropAcceptedCb
 * @param {File[]} files List of accepted files that meet the given criteria
 * (`accept`, `multiple`, `minSize`, `maxSize`)
 * @param {(DragEvent|Event)} event A drag event or input change event (if files were selected via the file dialog)
 */

/**
 * A function that is invoked for the `drop` or input change event.
 *
 * @callback dropRejectedCb
 * @param {File[]} files List of rejected files that do not meet the given criteria
 * (`accept`, `multiple`, `minSize`, `maxSize`)
 * @param {(DragEvent|Event)} event A drag event or input change event (if files were selected via the file dialog)
 */

/**
 * A function that is used aggregate files,
 * in a asynchronous fashion, from drag or input change events.
 *
 * @callback getFilesFromEvent
 * @param {(DragEvent|Event)} event A drag event or input change event (if files were selected via the file dialog)
 * @returns {(File[]|Promise<File[]>)}
 */

/**
 * An object with the current dropzone state.
 *
 * @typedef {object} DropzoneState
 * @property {boolean} isFocused Dropzone area is in focus
 * @property {boolean} isFileDialogActive File dialog is opened
 * @property {boolean} isDragActive Active drag is in progress
 * @property {boolean} isDragAccept Dragged files are accepted
 * @property {boolean} isDragReject Some dragged files are rejected
 * @property {File[]} acceptedFiles Accepted files
 * @property {FileRejection[]} fileRejections Rejected files and why they were rejected
 */

/**
 * An object with the dropzone methods.
 *
 * @typedef {object} DropzoneMethods
 * @property {Function} getRootProps Returns the props you should apply to the root drop container you render
 * @property {Function} getInputProps Returns the props you should apply to hidden file input you render
 * @property {Function} open Open the native file selection dialog
 */

var initialState = {
  isFocused: false,
  isFileDialogActive: false,
  isDragActive: false,
  isDragAccept: false,
  isDragReject: false,
  acceptedFiles: [],
  fileRejections: []
};
/**
 * A React hook that creates a drag 'n' drop area.
 *
 * ```jsx
 * function MyDropzone(props) {
 *   const {getRootProps, getInputProps} = useDropzone({
 *     onDrop: acceptedFiles => {
 *       // do something with the File objects, e.g. upload to some server
 *     }
 *   });
 *   return (
 *     <div {...getRootProps()}>
 *       <input {...getInputProps()} />
 *       <p>Drag and drop some files here, or click to select files</p>
 *     </div>
 *   )
 * }
 * ```
 *
 * @function useDropzone
 *
 * @param {object} props
 * @param {import("./utils").AcceptProp} [props.accept] Set accepted file types.
 * Checkout https://developer.mozilla.org/en-US/docs/Web/API/window/showOpenFilePicker types option for more information.
 * Keep in mind that mime type determination is not reliable across platforms. CSV files,
 * for example, are reported as text/plain under macOS but as application/vnd.ms-excel under
 * Windows. In some cases there might not be a mime type set at all (https://github.com/react-dropzone/react-dropzone/issues/276).
 * @param {boolean} [props.multiple=true] Allow drag 'n' drop (or selection from the file dialog) of multiple files
 * @param {boolean} [props.preventDropOnDocument=true] If false, allow dropped items to take over the current browser window
 * @param {boolean} [props.noClick=false] If true, disables click to open the native file selection dialog
 * @param {boolean} [props.noKeyboard=false] If true, disables SPACE/ENTER to open the native file selection dialog.
 * Note that it also stops tracking the focus state.
 * @param {boolean} [props.noDrag=false] If true, disables drag 'n' drop
 * @param {boolean} [props.noDragEventsBubbling=false] If true, stops drag event propagation to parents
 * @param {number} [props.minSize=0] Minimum file size (in bytes)
 * @param {number} [props.maxSize=Infinity] Maximum file size (in bytes)
 * @param {boolean} [props.disabled=false] Enable/disable the dropzone
 * @param {getFilesFromEvent} [props.getFilesFromEvent] Use this to provide a custom file aggregator
 * @param {Function} [props.onFileDialogCancel] Cb for when closing the file dialog with no selection
 * @param {boolean} [props.useFsAccessApi] Set to true to use the https://developer.mozilla.org/en-US/docs/Web/API/File_System_Access_API
 * to open the file picker instead of using an `<input type="file">` click event.
 * @param {boolean} autoFocus Set to true to auto focus the root element.
 * @param {Function} [props.onFileDialogOpen] Cb for when opening the file dialog
 * @param {dragCb} [props.onDragEnter] Cb for when the `dragenter` event occurs.
 * @param {dragCb} [props.onDragLeave] Cb for when the `dragleave` event occurs
 * @param {dragCb} [props.onDragOver] Cb for when the `dragover` event occurs
 * @param {dropCb} [props.onDrop] Cb for when the `drop` event occurs.
 * Note that this callback is invoked after the `getFilesFromEvent` callback is done.
 *
 * Files are accepted or rejected based on the `accept`, `multiple`, `minSize` and `maxSize` props.
 * `accept` must be an object with keys as a valid [MIME type](http://www.iana.org/assignments/media-types/media-types.xhtml) according to [input element specification](https://www.w3.org/wiki/HTML/Elements/input/file) and the value an array of file extensions (optional).
 * If `multiple` is set to false and additional files are dropped,
 * all files besides the first will be rejected.
 * Any file which does not have a size in the [`minSize`, `maxSize`] range, will be rejected as well.
 *
 * Note that the `onDrop` callback will always be invoked regardless if the dropped files were accepted or rejected.
 * If you'd like to react to a specific scenario, use the `onDropAccepted`/`onDropRejected` props.
 *
 * `onDrop` will provide you with an array of [File](https://developer.mozilla.org/en-US/docs/Web/API/File) objects which you can then process and send to a server.
 * For example, with [SuperAgent](https://github.com/visionmedia/superagent) as a http/ajax library:
 *
 * ```js
 * function onDrop(acceptedFiles) {
 *   const req = request.post('/upload')
 *   acceptedFiles.forEach(file => {
 *     req.attach(file.name, file)
 *   })
 *   req.end(callback)
 * }
 * ```
 * @param {dropAcceptedCb} [props.onDropAccepted]
 * @param {dropRejectedCb} [props.onDropRejected]
 * @param {(error: Error) => void} [props.onError]
 *
 * @returns {DropzoneState & DropzoneMethods}
 */

function useDropzone() {
  var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  var _defaultProps$props = es_objectSpread(es_objectSpread({}, defaultProps), props),
      accept = _defaultProps$props.accept,
      disabled = _defaultProps$props.disabled,
      getFilesFromEvent = _defaultProps$props.getFilesFromEvent,
      maxSize = _defaultProps$props.maxSize,
      minSize = _defaultProps$props.minSize,
      multiple = _defaultProps$props.multiple,
      maxFiles = _defaultProps$props.maxFiles,
      onDragEnter = _defaultProps$props.onDragEnter,
      onDragLeave = _defaultProps$props.onDragLeave,
      onDragOver = _defaultProps$props.onDragOver,
      onDrop = _defaultProps$props.onDrop,
      onDropAccepted = _defaultProps$props.onDropAccepted,
      onDropRejected = _defaultProps$props.onDropRejected,
      onFileDialogCancel = _defaultProps$props.onFileDialogCancel,
      onFileDialogOpen = _defaultProps$props.onFileDialogOpen,
      useFsAccessApi = _defaultProps$props.useFsAccessApi,
      autoFocus = _defaultProps$props.autoFocus,
      preventDropOnDocument = _defaultProps$props.preventDropOnDocument,
      noClick = _defaultProps$props.noClick,
      noKeyboard = _defaultProps$props.noKeyboard,
      noDrag = _defaultProps$props.noDrag,
      noDragEventsBubbling = _defaultProps$props.noDragEventsBubbling,
      onError = _defaultProps$props.onError,
      validator = _defaultProps$props.validator;

  var acceptAttr = (0,react.useMemo)(function () {
    return acceptPropAsAcceptAttr(accept);
  }, [accept]);
  var pickerTypes = (0,react.useMemo)(function () {
    return pickerOptionsFromAccept(accept);
  }, [accept]);
  var onFileDialogOpenCb = (0,react.useMemo)(function () {
    return typeof onFileDialogOpen === "function" ? onFileDialogOpen : noop;
  }, [onFileDialogOpen]);
  var onFileDialogCancelCb = (0,react.useMemo)(function () {
    return typeof onFileDialogCancel === "function" ? onFileDialogCancel : noop;
  }, [onFileDialogCancel]);
  /**
   * @constant
   * @type {React.MutableRefObject<HTMLElement>}
   */

  var rootRef = (0,react.useRef)(null);
  var inputRef = (0,react.useRef)(null);

  var _useReducer = (0,react.useReducer)(reducer, initialState),
      _useReducer2 = es_slicedToArray(_useReducer, 2),
      state = _useReducer2[0],
      dispatch = _useReducer2[1];

  var isFocused = state.isFocused,
      isFileDialogActive = state.isFileDialogActive;
  var fsAccessApiWorksRef = (0,react.useRef)(typeof window !== "undefined" && window.isSecureContext && useFsAccessApi && canUseFileSystemAccessAPI()); // Update file dialog active state when the window is focused on

  var onWindowFocus = function onWindowFocus() {
    // Execute the timeout only if the file dialog is opened in the browser
    if (!fsAccessApiWorksRef.current && isFileDialogActive) {
      setTimeout(function () {
        if (inputRef.current) {
          var files = inputRef.current.files;

          if (!files.length) {
            dispatch({
              type: "closeDialog"
            });
            onFileDialogCancelCb();
          }
        }
      }, 300);
    }
  };

  (0,react.useEffect)(function () {
    window.addEventListener("focus", onWindowFocus, false);
    return function () {
      window.removeEventListener("focus", onWindowFocus, false);
    };
  }, [inputRef, isFileDialogActive, onFileDialogCancelCb, fsAccessApiWorksRef]);
  var dragTargetsRef = (0,react.useRef)([]);

  var onDocumentDrop = function onDocumentDrop(event) {
    if (rootRef.current && rootRef.current.contains(event.target)) {
      // If we intercepted an event for our instance, let it propagate down to the instance's onDrop handler
      return;
    }

    event.preventDefault();
    dragTargetsRef.current = [];
  };

  (0,react.useEffect)(function () {
    if (preventDropOnDocument) {
      document.addEventListener("dragover", onDocumentDragOver, false);
      document.addEventListener("drop", onDocumentDrop, false);
    }

    return function () {
      if (preventDropOnDocument) {
        document.removeEventListener("dragover", onDocumentDragOver);
        document.removeEventListener("drop", onDocumentDrop);
      }
    };
  }, [rootRef, preventDropOnDocument]); // Auto focus the root when autoFocus is true

  (0,react.useEffect)(function () {
    if (!disabled && autoFocus && rootRef.current) {
      rootRef.current.focus();
    }

    return function () {};
  }, [rootRef, autoFocus, disabled]);
  var onErrCb = (0,react.useCallback)(function (e) {
    if (onError) {
      onError(e);
    } else {
      // Let the user know something's gone wrong if they haven't provided the onError cb.
      console.error(e);
    }
  }, [onError]);
  var onDragEnterCb = (0,react.useCallback)(function (event) {
    event.preventDefault(); // Persist here because we need the event later after getFilesFromEvent() is done

    event.persist();
    stopPropagation(event);
    dragTargetsRef.current = [].concat(es_toConsumableArray(dragTargetsRef.current), [event.target]);

    if (isEvtWithFiles(event)) {
      Promise.resolve(getFilesFromEvent(event)).then(function (files) {
        if (isPropagationStopped(event) && !noDragEventsBubbling) {
          return;
        }

        var fileCount = files.length;
        var isDragAccept = fileCount > 0 && allFilesAccepted({
          files: files,
          accept: acceptAttr,
          minSize: minSize,
          maxSize: maxSize,
          multiple: multiple,
          maxFiles: maxFiles,
          validator: validator
        });
        var isDragReject = fileCount > 0 && !isDragAccept;
        dispatch({
          isDragAccept: isDragAccept,
          isDragReject: isDragReject,
          isDragActive: true,
          type: "setDraggedFiles"
        });

        if (onDragEnter) {
          onDragEnter(event);
        }
      }).catch(function (e) {
        return onErrCb(e);
      });
    }
  }, [getFilesFromEvent, onDragEnter, onErrCb, noDragEventsBubbling, acceptAttr, minSize, maxSize, multiple, maxFiles, validator]);
  var onDragOverCb = (0,react.useCallback)(function (event) {
    event.preventDefault();
    event.persist();
    stopPropagation(event);
    var hasFiles = isEvtWithFiles(event);

    if (hasFiles && event.dataTransfer) {
      try {
        event.dataTransfer.dropEffect = "copy";
      } catch (_unused) {}
      /* eslint-disable-line no-empty */

    }

    if (hasFiles && onDragOver) {
      onDragOver(event);
    }

    return false;
  }, [onDragOver, noDragEventsBubbling]);
  var onDragLeaveCb = (0,react.useCallback)(function (event) {
    event.preventDefault();
    event.persist();
    stopPropagation(event); // Only deactivate once the dropzone and all children have been left

    var targets = dragTargetsRef.current.filter(function (target) {
      return rootRef.current && rootRef.current.contains(target);
    }); // Make sure to remove a target present multiple times only once
    // (Firefox may fire dragenter/dragleave multiple times on the same element)

    var targetIdx = targets.indexOf(event.target);

    if (targetIdx !== -1) {
      targets.splice(targetIdx, 1);
    }

    dragTargetsRef.current = targets;

    if (targets.length > 0) {
      return;
    }

    dispatch({
      type: "setDraggedFiles",
      isDragActive: false,
      isDragAccept: false,
      isDragReject: false
    });

    if (isEvtWithFiles(event) && onDragLeave) {
      onDragLeave(event);
    }
  }, [rootRef, onDragLeave, noDragEventsBubbling]);
  var setFiles = (0,react.useCallback)(function (files, event) {
    var acceptedFiles = [];
    var fileRejections = [];
    files.forEach(function (file) {
      var _fileAccepted = fileAccepted(file, acceptAttr),
          _fileAccepted2 = es_slicedToArray(_fileAccepted, 2),
          accepted = _fileAccepted2[0],
          acceptError = _fileAccepted2[1];

      var _fileMatchSize = fileMatchSize(file, minSize, maxSize),
          _fileMatchSize2 = es_slicedToArray(_fileMatchSize, 2),
          sizeMatch = _fileMatchSize2[0],
          sizeError = _fileMatchSize2[1];

      var customErrors = validator ? validator(file) : null;

      if (accepted && sizeMatch && !customErrors) {
        acceptedFiles.push(file);
      } else {
        var errors = [acceptError, sizeError];

        if (customErrors) {
          errors = errors.concat(customErrors);
        }

        fileRejections.push({
          file: file,
          errors: errors.filter(function (e) {
            return e;
          })
        });
      }
    });

    if (!multiple && acceptedFiles.length > 1 || multiple && maxFiles >= 1 && acceptedFiles.length > maxFiles) {
      // Reject everything and empty accepted files
      acceptedFiles.forEach(function (file) {
        fileRejections.push({
          file: file,
          errors: [TOO_MANY_FILES_REJECTION]
        });
      });
      acceptedFiles.splice(0);
    }

    dispatch({
      acceptedFiles: acceptedFiles,
      fileRejections: fileRejections,
      type: "setFiles"
    });

    if (onDrop) {
      onDrop(acceptedFiles, fileRejections, event);
    }

    if (fileRejections.length > 0 && onDropRejected) {
      onDropRejected(fileRejections, event);
    }

    if (acceptedFiles.length > 0 && onDropAccepted) {
      onDropAccepted(acceptedFiles, event);
    }
  }, [dispatch, multiple, acceptAttr, minSize, maxSize, maxFiles, onDrop, onDropAccepted, onDropRejected, validator]);
  var onDropCb = (0,react.useCallback)(function (event) {
    event.preventDefault(); // Persist here because we need the event later after getFilesFromEvent() is done

    event.persist();
    stopPropagation(event);
    dragTargetsRef.current = [];

    if (isEvtWithFiles(event)) {
      Promise.resolve(getFilesFromEvent(event)).then(function (files) {
        if (isPropagationStopped(event) && !noDragEventsBubbling) {
          return;
        }

        setFiles(files, event);
      }).catch(function (e) {
        return onErrCb(e);
      });
    }

    dispatch({
      type: "reset"
    });
  }, [getFilesFromEvent, setFiles, onErrCb, noDragEventsBubbling]); // Fn for opening the file dialog programmatically

  var openFileDialog = (0,react.useCallback)(function () {
    // No point to use FS access APIs if context is not secure
    // https://developer.mozilla.org/en-US/docs/Web/Security/Secure_Contexts#feature_detection
    if (fsAccessApiWorksRef.current) {
      dispatch({
        type: "openDialog"
      });
      onFileDialogOpenCb(); // https://developer.mozilla.org/en-US/docs/Web/API/window/showOpenFilePicker

      var opts = {
        multiple: multiple,
        types: pickerTypes
      };
      window.showOpenFilePicker(opts).then(function (handles) {
        return getFilesFromEvent(handles);
      }).then(function (files) {
        setFiles(files, null);
        dispatch({
          type: "closeDialog"
        });
      }).catch(function (e) {
        // AbortError means the user canceled
        if (isAbort(e)) {
          onFileDialogCancelCb(e);
          dispatch({
            type: "closeDialog"
          });
        } else if (isSecurityError(e)) {
          fsAccessApiWorksRef.current = false; // CORS, so cannot use this API
          // Try using the input

          if (inputRef.current) {
            inputRef.current.value = null;
            inputRef.current.click();
          } else {
            onErrCb(new Error("Cannot open the file picker because the https://developer.mozilla.org/en-US/docs/Web/API/File_System_Access_API is not supported and no <input> was provided."));
          }
        } else {
          onErrCb(e);
        }
      });
      return;
    }

    if (inputRef.current) {
      dispatch({
        type: "openDialog"
      });
      onFileDialogOpenCb();
      inputRef.current.value = null;
      inputRef.current.click();
    }
  }, [dispatch, onFileDialogOpenCb, onFileDialogCancelCb, useFsAccessApi, setFiles, onErrCb, pickerTypes, multiple]); // Cb to open the file dialog when SPACE/ENTER occurs on the dropzone

  var onKeyDownCb = (0,react.useCallback)(function (event) {
    // Ignore keyboard events bubbling up the DOM tree
    if (!rootRef.current || !rootRef.current.isEqualNode(event.target)) {
      return;
    }

    if (event.key === " " || event.key === "Enter" || event.keyCode === 32 || event.keyCode === 13) {
      event.preventDefault();
      openFileDialog();
    }
  }, [rootRef, openFileDialog]); // Update focus state for the dropzone

  var onFocusCb = (0,react.useCallback)(function () {
    dispatch({
      type: "focus"
    });
  }, []);
  var onBlurCb = (0,react.useCallback)(function () {
    dispatch({
      type: "blur"
    });
  }, []); // Cb to open the file dialog when click occurs on the dropzone

  var onClickCb = (0,react.useCallback)(function () {
    if (noClick) {
      return;
    } // In IE11/Edge the file-browser dialog is blocking, therefore, use setTimeout()
    // to ensure React can handle state changes
    // See: https://github.com/react-dropzone/react-dropzone/issues/450


    if (isIeOrEdge()) {
      setTimeout(openFileDialog, 0);
    } else {
      openFileDialog();
    }
  }, [noClick, openFileDialog]);

  var composeHandler = function composeHandler(fn) {
    return disabled ? null : fn;
  };

  var composeKeyboardHandler = function composeKeyboardHandler(fn) {
    return noKeyboard ? null : composeHandler(fn);
  };

  var composeDragHandler = function composeDragHandler(fn) {
    return noDrag ? null : composeHandler(fn);
  };

  var stopPropagation = function stopPropagation(event) {
    if (noDragEventsBubbling) {
      event.stopPropagation();
    }
  };

  var getRootProps = (0,react.useMemo)(function () {
    return function () {
      var _ref2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
          _ref2$refKey = _ref2.refKey,
          refKey = _ref2$refKey === void 0 ? "ref" : _ref2$refKey,
          role = _ref2.role,
          onKeyDown = _ref2.onKeyDown,
          onFocus = _ref2.onFocus,
          onBlur = _ref2.onBlur,
          onClick = _ref2.onClick,
          onDragEnter = _ref2.onDragEnter,
          onDragOver = _ref2.onDragOver,
          onDragLeave = _ref2.onDragLeave,
          onDrop = _ref2.onDrop,
          rest = _objectWithoutProperties(_ref2, _excluded3);

      return es_objectSpread(es_objectSpread(es_defineProperty({
        onKeyDown: composeKeyboardHandler(composeEventHandlers(onKeyDown, onKeyDownCb)),
        onFocus: composeKeyboardHandler(composeEventHandlers(onFocus, onFocusCb)),
        onBlur: composeKeyboardHandler(composeEventHandlers(onBlur, onBlurCb)),
        onClick: composeHandler(composeEventHandlers(onClick, onClickCb)),
        onDragEnter: composeDragHandler(composeEventHandlers(onDragEnter, onDragEnterCb)),
        onDragOver: composeDragHandler(composeEventHandlers(onDragOver, onDragOverCb)),
        onDragLeave: composeDragHandler(composeEventHandlers(onDragLeave, onDragLeaveCb)),
        onDrop: composeDragHandler(composeEventHandlers(onDrop, onDropCb)),
        role: typeof role === "string" && role !== "" ? role : "presentation"
      }, refKey, rootRef), !disabled && !noKeyboard ? {
        tabIndex: 0
      } : {}), rest);
    };
  }, [rootRef, onKeyDownCb, onFocusCb, onBlurCb, onClickCb, onDragEnterCb, onDragOverCb, onDragLeaveCb, onDropCb, noKeyboard, noDrag, disabled]);
  var onInputElementClick = (0,react.useCallback)(function (event) {
    event.stopPropagation();
  }, []);
  var getInputProps = (0,react.useMemo)(function () {
    return function () {
      var _ref3 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
          _ref3$refKey = _ref3.refKey,
          refKey = _ref3$refKey === void 0 ? "ref" : _ref3$refKey,
          onChange = _ref3.onChange,
          onClick = _ref3.onClick,
          rest = _objectWithoutProperties(_ref3, _excluded4);

      var inputProps = es_defineProperty({
        accept: acceptAttr,
        multiple: multiple,
        type: "file",
        style: {
          display: "none"
        },
        onChange: composeHandler(composeEventHandlers(onChange, onDropCb)),
        onClick: composeHandler(composeEventHandlers(onClick, onInputElementClick)),
        tabIndex: -1
      }, refKey, inputRef);

      return es_objectSpread(es_objectSpread({}, inputProps), rest);
    };
  }, [inputRef, accept, multiple, onDropCb, disabled]);
  return es_objectSpread(es_objectSpread({}, state), {}, {
    isFocused: isFocused && !disabled,
    getRootProps: getRootProps,
    getInputProps: getInputProps,
    rootRef: rootRef,
    inputRef: inputRef,
    open: composeHandler(openFileDialog)
  });
}
/**
 * @param {DropzoneState} state
 * @param {{type: string} & DropzoneState} action
 * @returns {DropzoneState}
 */

function reducer(state, action) {
  /* istanbul ignore next */
  switch (action.type) {
    case "focus":
      return es_objectSpread(es_objectSpread({}, state), {}, {
        isFocused: true
      });

    case "blur":
      return es_objectSpread(es_objectSpread({}, state), {}, {
        isFocused: false
      });

    case "openDialog":
      return es_objectSpread(es_objectSpread({}, initialState), {}, {
        isFileDialogActive: true
      });

    case "closeDialog":
      return es_objectSpread(es_objectSpread({}, state), {}, {
        isFileDialogActive: false
      });

    case "setDraggedFiles":
      return es_objectSpread(es_objectSpread({}, state), {}, {
        isDragActive: action.isDragActive,
        isDragAccept: action.isDragAccept,
        isDragReject: action.isDragReject
      });

    case "setFiles":
      return es_objectSpread(es_objectSpread({}, state), {}, {
        acceptedFiles: action.acceptedFiles,
        fileRejections: action.fileRejections
      });

    case "reset":
      return es_objectSpread({}, initialState);

    default:
      return state;
  }
}

function noop() {}



/***/ }),

/***/ 49559:
/***/ (function(__unused_webpack_module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = format;
var smallWords = /^(a|an|and|as|at|but|by|en|for|if|in|nor|of|on|or|per|the|to|vs?\.?|via)$/i;
function toTitleCase(string) {
  return string.toString().trim().replace(/[A-Za-z0-9\u00C0-\u00FF]+[^\s-]*/g, function (match, index, title) {
    if (index > 0 && index + match.length !== title.length && match.search(smallWords) > -1 && title.charAt(index - 2) !== ":" && (title.charAt(index + match.length) !== "-" || title.charAt(index - 1) === "-") && title.charAt(index - 1).search(/[^\s-]/) < 0) {
      return match.toLowerCase();
    }
    if (match.substr(1).search(/[A-Z]|\../) > -1) {
      return match;
    }
    return match.charAt(0).toUpperCase() + match.substr(1);
  });
}

// See if s could be an email address. We don't want to send personal data like email.
// https://support.google.com/analytics/answer/2795983?hl=en
function mightBeEmail(s) {
  // There's no point trying to validate rfc822 fully, just look for ...@...
  return typeof s === "string" && s.indexOf("@") !== -1;
}
var redacted = "REDACTED (Potential Email Address)";
function redactEmail(string) {
  if (mightBeEmail(string)) {
    console.warn("This arg looks like an email address, redacting.");
    return redacted;
  }
  return string;
}
function format() {
  var s = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "";
  var titleCase = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
  var redactingEmail = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
  var _str = s || "";
  if (titleCase) {
    _str = toTitleCase(s);
  }
  if (redactingEmail) {
    _str = redactEmail(_str);
  }
  return _str;
}

/***/ }),

/***/ 41638:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = exports.GA4 = void 0;
var _gtag = _interopRequireDefault(__webpack_require__(76161));
var _format = _interopRequireDefault(__webpack_require__(49559));
var _excluded = ["eventCategory", "eventAction", "eventLabel", "eventValue", "hitType"],
  _excluded2 = ["title", "location"],
  _excluded3 = ["page", "hitType"];
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"]; if (null != _i) { var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1; try { if (_x = (_i = _i.call(arr)).next, 0 === i) { if (Object(_i) !== _i) return; _n = !1; } else for (; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0); } catch (err) { _d = !0, _e = err; } finally { try { if (!_n && null != _i["return"] && (_r = _i["return"](), Object(_r) !== _r)) return; } finally { if (_d) throw _e; } } return _arr; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
/*
Links
https://developers.google.com/gtagjs/reference/api
https://developers.google.com/tag-platform/gtagjs/reference
*/
/**
 * @typedef GaOptions
 * @type {Object}
 * @property {boolean} [cookieUpdate=true]
 * @property {number} [cookieExpires=63072000] Default two years
 * @property {string} [cookieDomain="auto"]
 * @property {string} [cookieFlags]
 * @property {string} [userId]
 * @property {string} [clientId]
 * @property {boolean} [anonymizeIp]
 * @property {string} [contentGroup1]
 * @property {string} [contentGroup2]
 * @property {string} [contentGroup3]
 * @property {string} [contentGroup4]
 * @property {string} [contentGroup5]
 * @property {boolean} [allowAdFeatures=true]
 * @property {boolean} [allowAdPersonalizationSignals]
 * @property {boolean} [nonInteraction]
 * @property {string} [page]
 */
/**
 * @typedef UaEventOptions
 * @type {Object}
 * @property {string} action
 * @property {string} category
 * @property {string} [label]
 * @property {number} [value]
 * @property {boolean} [nonInteraction]
 * @property {('beacon'|'xhr'|'image')} [transport]
 */
/**
 * @typedef InitOptions
 * @type {Object}
 * @property {string} trackingId
 * @property {GaOptions|any} [gaOptions]
 * @property {Object} [gtagOptions] New parameter
 */
var GA4 = /*#__PURE__*/function () {
  function GA4() {
    var _this = this;
    _classCallCheck(this, GA4);
    _defineProperty(this, "reset", function () {
      _this.isInitialized = false;
      _this._testMode = false;
      _this._currentMeasurementId;
      _this._hasLoadedGA = false;
      _this._isQueuing = false;
      _this._queueGtag = [];
    });
    _defineProperty(this, "_gtag", function () {
      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }
      if (!_this._testMode) {
        if (_this._isQueuing) {
          _this._queueGtag.push(args);
        } else {
          _gtag["default"].apply(void 0, args);
        }
      } else {
        _this._queueGtag.push(args);
      }
    });
    _defineProperty(this, "_loadGA", function (GA_MEASUREMENT_ID, nonce) {
      var gtagUrl = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : "https://www.googletagmanager.com/gtag/js";
      if (typeof window === "undefined" || typeof document === "undefined") {
        return;
      }
      if (!_this._hasLoadedGA) {
        // Global Site Tag (gtag.js) - Google Analytics
        var script = document.createElement("script");
        script.async = true;
        script.src = "".concat(gtagUrl, "?id=").concat(GA_MEASUREMENT_ID);
        if (nonce) {
          script.setAttribute("nonce", nonce);
        }
        document.body.appendChild(script);
        window.dataLayer = window.dataLayer || [];
        window.gtag = function gtag() {
          window.dataLayer.push(arguments);
        };
        _this._hasLoadedGA = true;
      }
    });
    _defineProperty(this, "_toGtagOptions", function (gaOptions) {
      if (!gaOptions) {
        return;
      }
      var mapFields = {
        // Old https://developers.google.com/analytics/devguides/collection/analyticsjs/field-reference#cookieUpdate
        // New https://developers.google.com/analytics/devguides/collection/gtagjs/cookies-user-id#cookie_update
        cookieUpdate: "cookie_update",
        cookieExpires: "cookie_expires",
        cookieDomain: "cookie_domain",
        cookieFlags: "cookie_flags",
        // must be in set method?
        userId: "user_id",
        clientId: "client_id",
        anonymizeIp: "anonymize_ip",
        // https://support.google.com/analytics/answer/2853546?hl=en#zippy=%2Cin-this-article
        contentGroup1: "content_group1",
        contentGroup2: "content_group2",
        contentGroup3: "content_group3",
        contentGroup4: "content_group4",
        contentGroup5: "content_group5",
        // https://support.google.com/analytics/answer/9050852?hl=en
        allowAdFeatures: "allow_google_signals",
        allowAdPersonalizationSignals: "allow_ad_personalization_signals",
        nonInteraction: "non_interaction",
        page: "page_path",
        hitCallback: "event_callback"
      };
      var gtagOptions = Object.entries(gaOptions).reduce(function (prev, _ref) {
        var _ref2 = _slicedToArray(_ref, 2),
          key = _ref2[0],
          value = _ref2[1];
        if (mapFields[key]) {
          prev[mapFields[key]] = value;
        } else {
          prev[key] = value;
        }
        return prev;
      }, {});
      return gtagOptions;
    });
    _defineProperty(this, "initialize", function (GA_MEASUREMENT_ID) {
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      if (!GA_MEASUREMENT_ID) {
        throw new Error("Require GA_MEASUREMENT_ID");
      }
      var initConfigs = typeof GA_MEASUREMENT_ID === "string" ? [{
        trackingId: GA_MEASUREMENT_ID
      }] : GA_MEASUREMENT_ID;
      _this._currentMeasurementId = initConfigs[0].trackingId;
      var gaOptions = options.gaOptions,
        gtagOptions = options.gtagOptions,
        nonce = options.nonce,
        _options$testMode = options.testMode,
        testMode = _options$testMode === void 0 ? false : _options$testMode,
        gtagUrl = options.gtagUrl;
      _this._testMode = testMode;
      if (!testMode) {
        _this._loadGA(_this._currentMeasurementId, nonce, gtagUrl);
      }
      if (!_this.isInitialized) {
        _this._gtag("js", new Date());
        initConfigs.forEach(function (config) {
          var mergedGtagOptions = _objectSpread(_objectSpread(_objectSpread({}, _this._toGtagOptions(_objectSpread(_objectSpread({}, gaOptions), config.gaOptions))), gtagOptions), config.gtagOptions);
          if (Object.keys(mergedGtagOptions).length) {
            _this._gtag("config", config.trackingId, mergedGtagOptions);
          } else {
            _this._gtag("config", config.trackingId);
          }
        });
      }
      _this.isInitialized = true;
      if (!testMode) {
        var queues = _toConsumableArray(_this._queueGtag);
        _this._queueGtag = [];
        _this._isQueuing = false;
        while (queues.length) {
          var queue = queues.shift();
          _this._gtag.apply(_this, _toConsumableArray(queue));
          if (queue[0] === "get") {
            _this._isQueuing = true;
          }
        }
      }
    });
    _defineProperty(this, "set", function (fieldsObject) {
      if (!fieldsObject) {
        console.warn("`fieldsObject` is required in .set()");
        return;
      }
      if (_typeof(fieldsObject) !== "object") {
        console.warn("Expected `fieldsObject` arg to be an Object");
        return;
      }
      if (Object.keys(fieldsObject).length === 0) {
        console.warn("empty `fieldsObject` given to .set()");
      }
      _this._gaCommand("set", fieldsObject);
    });
    _defineProperty(this, "_gaCommandSendEvent", function (eventCategory, eventAction, eventLabel, eventValue, fieldsObject) {
      _this._gtag("event", eventAction, _objectSpread(_objectSpread({
        event_category: eventCategory,
        event_label: eventLabel,
        value: eventValue
      }, fieldsObject && {
        non_interaction: fieldsObject.nonInteraction
      }), _this._toGtagOptions(fieldsObject)));
    });
    _defineProperty(this, "_gaCommandSendEventParameters", function () {
      for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
        args[_key2] = arguments[_key2];
      }
      if (typeof args[0] === "string") {
        _this._gaCommandSendEvent.apply(_this, _toConsumableArray(args.slice(1)));
      } else {
        var _args$ = args[0],
          eventCategory = _args$.eventCategory,
          eventAction = _args$.eventAction,
          eventLabel = _args$.eventLabel,
          eventValue = _args$.eventValue,
          hitType = _args$.hitType,
          rest = _objectWithoutProperties(_args$, _excluded);
        _this._gaCommandSendEvent(eventCategory, eventAction, eventLabel, eventValue, rest);
      }
    });
    _defineProperty(this, "_gaCommandSendTiming", function (timingCategory, timingVar, timingValue, timingLabel) {
      _this._gtag("event", "timing_complete", {
        name: timingVar,
        value: timingValue,
        event_category: timingCategory,
        event_label: timingLabel
      });
    });
    _defineProperty(this, "_gaCommandSendPageview", function (page, fieldsObject) {
      if (fieldsObject && Object.keys(fieldsObject).length) {
        var _this$_toGtagOptions = _this._toGtagOptions(fieldsObject),
          title = _this$_toGtagOptions.title,
          location = _this$_toGtagOptions.location,
          rest = _objectWithoutProperties(_this$_toGtagOptions, _excluded2);
        _this._gtag("event", "page_view", _objectSpread(_objectSpread(_objectSpread(_objectSpread({}, page && {
          page_path: page
        }), title && {
          page_title: title
        }), location && {
          page_location: location
        }), rest));
      } else if (page) {
        _this._gtag("event", "page_view", {
          page_path: page
        });
      } else {
        _this._gtag("event", "page_view");
      }
    });
    _defineProperty(this, "_gaCommandSendPageviewParameters", function () {
      for (var _len3 = arguments.length, args = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
        args[_key3] = arguments[_key3];
      }
      if (typeof args[0] === "string") {
        _this._gaCommandSendPageview.apply(_this, _toConsumableArray(args.slice(1)));
      } else {
        var _args$2 = args[0],
          page = _args$2.page,
          hitType = _args$2.hitType,
          rest = _objectWithoutProperties(_args$2, _excluded3);
        _this._gaCommandSendPageview(page, rest);
      }
    });
    _defineProperty(this, "_gaCommandSend", function () {
      for (var _len4 = arguments.length, args = new Array(_len4), _key4 = 0; _key4 < _len4; _key4++) {
        args[_key4] = arguments[_key4];
      }
      var hitType = typeof args[0] === "string" ? args[0] : args[0].hitType;
      switch (hitType) {
        case "event":
          _this._gaCommandSendEventParameters.apply(_this, args);
          break;
        case "pageview":
          _this._gaCommandSendPageviewParameters.apply(_this, args);
          break;
        case "timing":
          _this._gaCommandSendTiming.apply(_this, _toConsumableArray(args.slice(1)));
          break;
        case "screenview":
        case "transaction":
        case "item":
        case "social":
        case "exception":
          console.warn("Unsupported send command: ".concat(hitType));
          break;
        default:
          console.warn("Send command doesn't exist: ".concat(hitType));
      }
    });
    _defineProperty(this, "_gaCommandSet", function () {
      for (var _len5 = arguments.length, args = new Array(_len5), _key5 = 0; _key5 < _len5; _key5++) {
        args[_key5] = arguments[_key5];
      }
      if (typeof args[0] === "string") {
        args[0] = _defineProperty({}, args[0], args[1]);
      }
      _this._gtag("set", _this._toGtagOptions(args[0]));
    });
    _defineProperty(this, "_gaCommand", function (command) {
      for (var _len6 = arguments.length, args = new Array(_len6 > 1 ? _len6 - 1 : 0), _key6 = 1; _key6 < _len6; _key6++) {
        args[_key6 - 1] = arguments[_key6];
      }
      switch (command) {
        case "send":
          _this._gaCommandSend.apply(_this, args);
          break;
        case "set":
          _this._gaCommandSet.apply(_this, args);
          break;
        default:
          console.warn("Command doesn't exist: ".concat(command));
      }
    });
    _defineProperty(this, "ga", function () {
      for (var _len7 = arguments.length, args = new Array(_len7), _key7 = 0; _key7 < _len7; _key7++) {
        args[_key7] = arguments[_key7];
      }
      if (typeof args[0] === "string") {
        _this._gaCommand.apply(_this, args);
      } else {
        var readyCallback = args[0];
        _this._gtag("get", _this._currentMeasurementId, "client_id", function (clientId) {
          _this._isQueuing = false;
          var queues = _this._queueGtag;
          readyCallback({
            get: function get(property) {
              return property === "clientId" ? clientId : property === "trackingId" ? _this._currentMeasurementId : property === "apiVersion" ? "1" : undefined;
            }
          });
          while (queues.length) {
            var queue = queues.shift();
            _this._gtag.apply(_this, _toConsumableArray(queue));
          }
        });
        _this._isQueuing = true;
      }
      return _this.ga;
    });
    _defineProperty(this, "event", function (optionsOrName, params) {
      if (typeof optionsOrName === "string") {
        _this._gtag("event", optionsOrName, _this._toGtagOptions(params));
      } else {
        var action = optionsOrName.action,
          category = optionsOrName.category,
          label = optionsOrName.label,
          value = optionsOrName.value,
          nonInteraction = optionsOrName.nonInteraction,
          transport = optionsOrName.transport;
        if (!category || !action) {
          console.warn("args.category AND args.action are required in event()");
          return;
        }

        // Required Fields
        var fieldObject = {
          hitType: "event",
          eventCategory: (0, _format["default"])(category),
          eventAction: (0, _format["default"])(action)
        };

        // Optional Fields
        if (label) {
          fieldObject.eventLabel = (0, _format["default"])(label);
        }
        if (typeof value !== "undefined") {
          if (typeof value !== "number") {
            console.warn("Expected `args.value` arg to be a Number.");
          } else {
            fieldObject.eventValue = value;
          }
        }
        if (typeof nonInteraction !== "undefined") {
          if (typeof nonInteraction !== "boolean") {
            console.warn("`args.nonInteraction` must be a boolean.");
          } else {
            fieldObject.nonInteraction = nonInteraction;
          }
        }
        if (typeof transport !== "undefined") {
          if (typeof transport !== "string") {
            console.warn("`args.transport` must be a string.");
          } else {
            if (["beacon", "xhr", "image"].indexOf(transport) === -1) {
              console.warn("`args.transport` must be either one of these values: `beacon`, `xhr` or `image`");
            }
            fieldObject.transport = transport;
          }
        }
        _this._gaCommand("send", fieldObject);
      }
    });
    _defineProperty(this, "send", function (fieldObject) {
      _this._gaCommand("send", fieldObject);
    });
    this.reset();
  }
  _createClass(GA4, [{
    key: "gtag",
    value: function gtag() {
      this._gtag.apply(this, arguments);
    }
  }]);
  return GA4;
}();
exports.GA4 = GA4;
var _default = new GA4();
exports["default"] = _default;

/***/ }),

/***/ 76161:
/***/ (function(__unused_webpack_module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var gtag = function gtag() {
  for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
    args[_key] = arguments[_key];
  }
  if (typeof window !== "undefined") {
    var _window;
    if (typeof window.gtag === "undefined") {
      window.dataLayer = window.dataLayer || [];
      window.gtag = function gtag() {
        window.dataLayer.push(arguments);
      };
    }
    (_window = window).gtag.apply(_window, args);
  }
};
var _default = gtag;
exports["default"] = _default;

/***/ }),

/***/ 49089:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";
var __webpack_unused_export__;


function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
__webpack_unused_export__ = ({
  value: true
});
exports.ZP = __webpack_unused_export__ = void 0;
var _ga = _interopRequireWildcard(__webpack_require__(41638));
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
var ReactGAImplementation = _ga.GA4;
__webpack_unused_export__ = ReactGAImplementation;
var _default = _ga["default"];
exports.ZP = _default;

/***/ }),

/***/ 69921:
/***/ (function(__unused_webpack_module, exports) {

"use strict";
/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var b="function"===typeof Symbol&&Symbol.for,c=b?Symbol.for("react.element"):60103,d=b?Symbol.for("react.portal"):60106,e=b?Symbol.for("react.fragment"):60107,f=b?Symbol.for("react.strict_mode"):60108,g=b?Symbol.for("react.profiler"):60114,h=b?Symbol.for("react.provider"):60109,k=b?Symbol.for("react.context"):60110,l=b?Symbol.for("react.async_mode"):60111,m=b?Symbol.for("react.concurrent_mode"):60111,n=b?Symbol.for("react.forward_ref"):60112,p=b?Symbol.for("react.suspense"):60113,q=b?
Symbol.for("react.suspense_list"):60120,r=b?Symbol.for("react.memo"):60115,t=b?Symbol.for("react.lazy"):60116,v=b?Symbol.for("react.block"):60121,w=b?Symbol.for("react.fundamental"):60117,x=b?Symbol.for("react.responder"):60118,y=b?Symbol.for("react.scope"):60119;
function z(a){if("object"===typeof a&&null!==a){var u=a.$$typeof;switch(u){case c:switch(a=a.type,a){case l:case m:case e:case g:case f:case p:return a;default:switch(a=a&&a.$$typeof,a){case k:case n:case t:case r:case h:return a;default:return u}}case d:return u}}}function A(a){return z(a)===m}exports.AsyncMode=l;exports.ConcurrentMode=m;exports.ContextConsumer=k;exports.ContextProvider=h;exports.Element=c;exports.ForwardRef=n;exports.Fragment=e;exports.Lazy=t;exports.Memo=r;exports.Portal=d;
exports.Profiler=g;exports.StrictMode=f;exports.Suspense=p;exports.isAsyncMode=function(a){return A(a)||z(a)===l};exports.isConcurrentMode=A;exports.isContextConsumer=function(a){return z(a)===k};exports.isContextProvider=function(a){return z(a)===h};exports.isElement=function(a){return"object"===typeof a&&null!==a&&a.$$typeof===c};exports.isForwardRef=function(a){return z(a)===n};exports.isFragment=function(a){return z(a)===e};exports.isLazy=function(a){return z(a)===t};
exports.isMemo=function(a){return z(a)===r};exports.isPortal=function(a){return z(a)===d};exports.isProfiler=function(a){return z(a)===g};exports.isStrictMode=function(a){return z(a)===f};exports.isSuspense=function(a){return z(a)===p};
exports.isValidElementType=function(a){return"string"===typeof a||"function"===typeof a||a===e||a===m||a===g||a===f||a===p||a===q||"object"===typeof a&&null!==a&&(a.$$typeof===t||a.$$typeof===r||a.$$typeof===h||a.$$typeof===k||a.$$typeof===n||a.$$typeof===w||a.$$typeof===x||a.$$typeof===y||a.$$typeof===v)};exports.typeOf=z;


/***/ }),

/***/ 59864:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


if (true) {
  module.exports = __webpack_require__(69921);
} else {}


/***/ }),

/***/ 6223:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ Combination; }
});

;// CONCATENATED MODULE: ./node_modules/tslib/tslib.es6.mjs
/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */
/* global Reflect, Promise, SuppressedError, Symbol */

var extendStatics = function(d, b) {
  extendStatics = Object.setPrototypeOf ||
      ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
      function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
  return extendStatics(d, b);
};

function __extends(d, b) {
  if (typeof b !== "function" && b !== null)
      throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
  extendStatics(d, b);
  function __() { this.constructor = d; }
  d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}

var __assign = function() {
  __assign = Object.assign || function __assign(t) {
      for (var s, i = 1, n = arguments.length; i < n; i++) {
          s = arguments[i];
          for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
      return t;
  }
  return __assign.apply(this, arguments);
}

function __rest(s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
      t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function")
      for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
          if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
              t[p[i]] = s[p[i]];
      }
  return t;
}

function __decorate(decorators, target, key, desc) {
  var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
  else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
}

function __param(paramIndex, decorator) {
  return function (target, key) { decorator(target, key, paramIndex); }
}

function __esDecorate(ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
  function accept(f) { if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected"); return f; }
  var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
  var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
  var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
  var _, done = false;
  for (var i = decorators.length - 1; i >= 0; i--) {
      var context = {};
      for (var p in contextIn) context[p] = p === "access" ? {} : contextIn[p];
      for (var p in contextIn.access) context.access[p] = contextIn.access[p];
      context.addInitializer = function (f) { if (done) throw new TypeError("Cannot add initializers after decoration has completed"); extraInitializers.push(accept(f || null)); };
      var result = (0, decorators[i])(kind === "accessor" ? { get: descriptor.get, set: descriptor.set } : descriptor[key], context);
      if (kind === "accessor") {
          if (result === void 0) continue;
          if (result === null || typeof result !== "object") throw new TypeError("Object expected");
          if (_ = accept(result.get)) descriptor.get = _;
          if (_ = accept(result.set)) descriptor.set = _;
          if (_ = accept(result.init)) initializers.unshift(_);
      }
      else if (_ = accept(result)) {
          if (kind === "field") initializers.unshift(_);
          else descriptor[key] = _;
      }
  }
  if (target) Object.defineProperty(target, contextIn.name, descriptor);
  done = true;
};

function __runInitializers(thisArg, initializers, value) {
  var useValue = arguments.length > 2;
  for (var i = 0; i < initializers.length; i++) {
      value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
  }
  return useValue ? value : void 0;
};

function __propKey(x) {
  return typeof x === "symbol" ? x : "".concat(x);
};

function __setFunctionName(f, name, prefix) {
  if (typeof name === "symbol") name = name.description ? "[".concat(name.description, "]") : "";
  return Object.defineProperty(f, "name", { configurable: true, value: prefix ? "".concat(prefix, " ", name) : name });
};

function __metadata(metadataKey, metadataValue) {
  if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}

function __awaiter(thisArg, _arguments, P, generator) {
  function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
  return new (P || (P = Promise))(function (resolve, reject) {
      function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
      function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
      function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
      step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
}

function __generator(thisArg, body) {
  var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
  return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
  function verb(n) { return function (v) { return step([n, v]); }; }
  function step(op) {
      if (f) throw new TypeError("Generator is already executing.");
      while (g && (g = 0, op[0] && (_ = 0)), _) try {
          if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
          if (y = 0, t) op = [op[0] & 2, t.value];
          switch (op[0]) {
              case 0: case 1: t = op; break;
              case 4: _.label++; return { value: op[1], done: false };
              case 5: _.label++; y = op[1]; op = [0]; continue;
              case 7: op = _.ops.pop(); _.trys.pop(); continue;
              default:
                  if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                  if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                  if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                  if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                  if (t[2]) _.ops.pop();
                  _.trys.pop(); continue;
          }
          op = body.call(thisArg, _);
      } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
      if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
  }
}

var __createBinding = Object.create ? (function(o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  var desc = Object.getOwnPropertyDescriptor(m, k);
  if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
  }
  Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});

function __exportStar(m, o) {
  for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(o, p)) __createBinding(o, m, p);
}

function __values(o) {
  var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
  if (m) return m.call(o);
  if (o && typeof o.length === "number") return {
      next: function () {
          if (o && i >= o.length) o = void 0;
          return { value: o && o[i++], done: !o };
      }
  };
  throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}

function __read(o, n) {
  var m = typeof Symbol === "function" && o[Symbol.iterator];
  if (!m) return o;
  var i = m.call(o), r, ar = [], e;
  try {
      while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
  }
  catch (error) { e = { error: error }; }
  finally {
      try {
          if (r && !r.done && (m = i["return"])) m.call(i);
      }
      finally { if (e) throw e.error; }
  }
  return ar;
}

/** @deprecated */
function __spread() {
  for (var ar = [], i = 0; i < arguments.length; i++)
      ar = ar.concat(__read(arguments[i]));
  return ar;
}

/** @deprecated */
function __spreadArrays() {
  for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
  for (var r = Array(s), k = 0, i = 0; i < il; i++)
      for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
          r[k] = a[j];
  return r;
}

function __spreadArray(to, from, pack) {
  if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
      if (ar || !(i in from)) {
          if (!ar) ar = Array.prototype.slice.call(from, 0, i);
          ar[i] = from[i];
      }
  }
  return to.concat(ar || Array.prototype.slice.call(from));
}

function __await(v) {
  return this instanceof __await ? (this.v = v, this) : new __await(v);
}

function __asyncGenerator(thisArg, _arguments, generator) {
  if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
  var g = generator.apply(thisArg, _arguments || []), i, q = [];
  return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function () { return this; }, i;
  function verb(n) { if (g[n]) i[n] = function (v) { return new Promise(function (a, b) { q.push([n, v, a, b]) > 1 || resume(n, v); }); }; }
  function resume(n, v) { try { step(g[n](v)); } catch (e) { settle(q[0][3], e); } }
  function step(r) { r.value instanceof __await ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r); }
  function fulfill(value) { resume("next", value); }
  function reject(value) { resume("throw", value); }
  function settle(f, v) { if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]); }
}

function __asyncDelegator(o) {
  var i, p;
  return i = {}, verb("next"), verb("throw", function (e) { throw e; }), verb("return"), i[Symbol.iterator] = function () { return this; }, i;
  function verb(n, f) { i[n] = o[n] ? function (v) { return (p = !p) ? { value: __await(o[n](v)), done: false } : f ? f(v) : v; } : f; }
}

function __asyncValues(o) {
  if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
  var m = o[Symbol.asyncIterator], i;
  return m ? m.call(o) : (o = typeof __values === "function" ? __values(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function () { return this; }, i);
  function verb(n) { i[n] = o[n] && function (v) { return new Promise(function (resolve, reject) { v = o[n](v), settle(resolve, reject, v.done, v.value); }); }; }
  function settle(resolve, reject, d, v) { Promise.resolve(v).then(function(v) { resolve({ value: v, done: d }); }, reject); }
}

function __makeTemplateObject(cooked, raw) {
  if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
  return cooked;
};

var __setModuleDefault = Object.create ? (function(o, v) {
  Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
  o["default"] = v;
};

function __importStar(mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  __setModuleDefault(result, mod);
  return result;
}

function __importDefault(mod) {
  return (mod && mod.__esModule) ? mod : { default: mod };
}

function __classPrivateFieldGet(receiver, state, kind, f) {
  if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
  if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
  return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
}

function __classPrivateFieldSet(receiver, state, value, kind, f) {
  if (kind === "m") throw new TypeError("Private method is not writable");
  if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
  if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
  return (kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value)), value;
}

function __classPrivateFieldIn(state, receiver) {
  if (receiver === null || (typeof receiver !== "object" && typeof receiver !== "function")) throw new TypeError("Cannot use 'in' operator on non-object");
  return typeof state === "function" ? receiver === state : state.has(receiver);
}

function __addDisposableResource(env, value, async) {
  if (value !== null && value !== void 0) {
    if (typeof value !== "object" && typeof value !== "function") throw new TypeError("Object expected.");
    var dispose;
    if (async) {
        if (!Symbol.asyncDispose) throw new TypeError("Symbol.asyncDispose is not defined.");
        dispose = value[Symbol.asyncDispose];
    }
    if (dispose === void 0) {
        if (!Symbol.dispose) throw new TypeError("Symbol.dispose is not defined.");
        dispose = value[Symbol.dispose];
    }
    if (typeof dispose !== "function") throw new TypeError("Object not disposable.");
    env.stack.push({ value: value, dispose: dispose, async: async });
  }
  else if (async) {
    env.stack.push({ async: true });
  }
  return value;
}

var _SuppressedError = typeof SuppressedError === "function" ? SuppressedError : function (error, suppressed, message) {
  var e = new Error(message);
  return e.name = "SuppressedError", e.error = error, e.suppressed = suppressed, e;
};

function __disposeResources(env) {
  function fail(e) {
    env.error = env.hasError ? new _SuppressedError(e, env.error, "An error was suppressed during disposal.") : e;
    env.hasError = true;
  }
  function next() {
    while (env.stack.length) {
      var rec = env.stack.pop();
      try {
        var result = rec.dispose && rec.dispose.call(rec.value);
        if (rec.async) return Promise.resolve(result).then(next, function(e) { fail(e); return next(); });
      }
      catch (e) {
          fail(e);
      }
    }
    if (env.hasError) throw env.error;
  }
  return next();
}

/* harmony default export */ var tslib_es6 = ({
  __extends,
  __assign,
  __rest,
  __decorate,
  __param,
  __metadata,
  __awaiter,
  __generator,
  __createBinding,
  __exportStar,
  __values,
  __read,
  __spread,
  __spreadArrays,
  __spreadArray,
  __await,
  __asyncGenerator,
  __asyncDelegator,
  __asyncValues,
  __makeTemplateObject,
  __importStar,
  __importDefault,
  __classPrivateFieldGet,
  __classPrivateFieldSet,
  __classPrivateFieldIn,
  __addDisposableResource,
  __disposeResources,
});

// EXTERNAL MODULE: ./node_modules/next/dist/compiled/react/index.js
var react = __webpack_require__(55784);
;// CONCATENATED MODULE: ./node_modules/react-remove-scroll-bar/dist/es2015/constants.js
var zeroRightClassName = 'right-scroll-bar-position';
var fullWidthClassName = 'width-before-scroll-bar';
var noScrollbarsClassName = 'with-scroll-bars-hidden';
/**
 * Name of a CSS variable containing the amount of "hidden" scrollbar
 * ! might be undefined ! use will fallback!
 */
var removedBarSizeVariable = '--removed-body-scroll-bar-size';

;// CONCATENATED MODULE: ./node_modules/use-callback-ref/dist/es2015/assignRef.js
/**
 * Assigns a value for a given ref, no matter of the ref format
 * @param {RefObject} ref - a callback function or ref object
 * @param value - a new value
 *
 * @see https://github.com/theKashey/use-callback-ref#assignref
 * @example
 * const refObject = useRef();
 * const refFn = (ref) => {....}
 *
 * assignRef(refObject, "refValue");
 * assignRef(refFn, "refValue");
 */
function assignRef(ref, value) {
    if (typeof ref === 'function') {
        ref(value);
    }
    else if (ref) {
        ref.current = value;
    }
    return ref;
}

;// CONCATENATED MODULE: ./node_modules/use-callback-ref/dist/es2015/useRef.js

/**
 * creates a MutableRef with ref change callback
 * @param initialValue - initial ref value
 * @param {Function} callback - a callback to run when value changes
 *
 * @example
 * const ref = useCallbackRef(0, (newValue, oldValue) => console.log(oldValue, '->', newValue);
 * ref.current = 1;
 * // prints 0 -> 1
 *
 * @see https://reactjs.org/docs/hooks-reference.html#useref
 * @see https://github.com/theKashey/use-callback-ref#usecallbackref---to-replace-reactuseref
 * @returns {MutableRefObject}
 */
function useCallbackRef(initialValue, callback) {
    var ref = (0,react.useState)(function () { return ({
        // value
        value: initialValue,
        // last callback
        callback: callback,
        // "memoized" public interface
        facade: {
            get current() {
                return ref.value;
            },
            set current(value) {
                var last = ref.value;
                if (last !== value) {
                    ref.value = value;
                    ref.callback(value, last);
                }
            },
        },
    }); })[0];
    // update callback
    ref.callback = callback;
    return ref.facade;
}

;// CONCATENATED MODULE: ./node_modules/use-callback-ref/dist/es2015/useMergeRef.js



var currentValues = new WeakMap();
/**
 * Merges two or more refs together providing a single interface to set their value
 * @param {RefObject|Ref} refs
 * @returns {MutableRefObject} - a new ref, which translates all changes to {refs}
 *
 * @see {@link mergeRefs} a version without buit-in memoization
 * @see https://github.com/theKashey/use-callback-ref#usemergerefs
 * @example
 * const Component = React.forwardRef((props, ref) => {
 *   const ownRef = useRef();
 *   const domRef = useMergeRefs([ref, ownRef]); // 👈 merge together
 *   return <div ref={domRef}>...</div>
 * }
 */
function useMergeRefs(refs, defaultValue) {
    var callbackRef = useCallbackRef(defaultValue || null, function (newValue) {
        return refs.forEach(function (ref) { return assignRef(ref, newValue); });
    });
    // handle refs changes - added or removed
    react.useLayoutEffect(function () {
        var oldValue = currentValues.get(callbackRef);
        if (oldValue) {
            var prevRefs_1 = new Set(oldValue);
            var nextRefs_1 = new Set(refs);
            var current_1 = callbackRef.current;
            prevRefs_1.forEach(function (ref) {
                if (!nextRefs_1.has(ref)) {
                    assignRef(ref, null);
                }
            });
            nextRefs_1.forEach(function (ref) {
                if (!prevRefs_1.has(ref)) {
                    assignRef(ref, current_1);
                }
            });
        }
        currentValues.set(callbackRef, refs);
    }, [refs]);
    return callbackRef;
}

;// CONCATENATED MODULE: ./node_modules/use-sidecar/dist/es2015/medium.js

function ItoI(a) {
    return a;
}
function innerCreateMedium(defaults, middleware) {
    if (middleware === void 0) { middleware = ItoI; }
    var buffer = [];
    var assigned = false;
    var medium = {
        read: function () {
            if (assigned) {
                throw new Error('Sidecar: could not `read` from an `assigned` medium. `read` could be used only with `useMedium`.');
            }
            if (buffer.length) {
                return buffer[buffer.length - 1];
            }
            return defaults;
        },
        useMedium: function (data) {
            var item = middleware(data, assigned);
            buffer.push(item);
            return function () {
                buffer = buffer.filter(function (x) { return x !== item; });
            };
        },
        assignSyncMedium: function (cb) {
            assigned = true;
            while (buffer.length) {
                var cbs = buffer;
                buffer = [];
                cbs.forEach(cb);
            }
            buffer = {
                push: function (x) { return cb(x); },
                filter: function () { return buffer; },
            };
        },
        assignMedium: function (cb) {
            assigned = true;
            var pendingQueue = [];
            if (buffer.length) {
                var cbs = buffer;
                buffer = [];
                cbs.forEach(cb);
                pendingQueue = buffer;
            }
            var executeQueue = function () {
                var cbs = pendingQueue;
                pendingQueue = [];
                cbs.forEach(cb);
            };
            var cycle = function () { return Promise.resolve().then(executeQueue); };
            cycle();
            buffer = {
                push: function (x) {
                    pendingQueue.push(x);
                    cycle();
                },
                filter: function (filter) {
                    pendingQueue = pendingQueue.filter(filter);
                    return buffer;
                },
            };
        },
    };
    return medium;
}
function createMedium(defaults, middleware) {
    if (middleware === void 0) { middleware = ItoI; }
    return innerCreateMedium(defaults, middleware);
}
// eslint-disable-next-line @typescript-eslint/ban-types
function createSidecarMedium(options) {
    if (options === void 0) { options = {}; }
    var medium = innerCreateMedium(null);
    medium.options = __assign({ async: true, ssr: false }, options);
    return medium;
}

;// CONCATENATED MODULE: ./node_modules/react-remove-scroll/dist/es2015/medium.js

var effectCar = createSidecarMedium();

;// CONCATENATED MODULE: ./node_modules/react-remove-scroll/dist/es2015/UI.js





var nothing = function () {
    return;
};
/**
 * Removes scrollbar from the page and contain the scroll within the Lock
 */
var RemoveScroll = react.forwardRef(function (props, parentRef) {
    var ref = react.useRef(null);
    var _a = react.useState({
        onScrollCapture: nothing,
        onWheelCapture: nothing,
        onTouchMoveCapture: nothing,
    }), callbacks = _a[0], setCallbacks = _a[1];
    var forwardProps = props.forwardProps, children = props.children, className = props.className, removeScrollBar = props.removeScrollBar, enabled = props.enabled, shards = props.shards, sideCar = props.sideCar, noIsolation = props.noIsolation, inert = props.inert, allowPinchZoom = props.allowPinchZoom, _b = props.as, Container = _b === void 0 ? 'div' : _b, rest = __rest(props, ["forwardProps", "children", "className", "removeScrollBar", "enabled", "shards", "sideCar", "noIsolation", "inert", "allowPinchZoom", "as"]);
    var SideCar = sideCar;
    var containerRef = useMergeRefs([ref, parentRef]);
    var containerProps = __assign(__assign({}, rest), callbacks);
    return (react.createElement(react.Fragment, null,
        enabled && (react.createElement(SideCar, { sideCar: effectCar, removeScrollBar: removeScrollBar, shards: shards, noIsolation: noIsolation, inert: inert, setCallbacks: setCallbacks, allowPinchZoom: !!allowPinchZoom, lockRef: ref })),
        forwardProps ? (react.cloneElement(react.Children.only(children), __assign(__assign({}, containerProps), { ref: containerRef }))) : (react.createElement(Container, __assign({}, containerProps, { className: className, ref: containerRef }), children))));
});
RemoveScroll.defaultProps = {
    enabled: true,
    removeScrollBar: true,
    inert: false,
};
RemoveScroll.classNames = {
    fullWidth: fullWidthClassName,
    zeroRight: zeroRightClassName,
};


;// CONCATENATED MODULE: ./node_modules/use-sidecar/dist/es2015/exports.js


var SideCar = function (_a) {
    var sideCar = _a.sideCar, rest = __rest(_a, ["sideCar"]);
    if (!sideCar) {
        throw new Error('Sidecar: please provide `sideCar` property to import the right car');
    }
    var Target = sideCar.read();
    if (!Target) {
        throw new Error('Sidecar medium not found');
    }
    return react.createElement(Target, __assign({}, rest));
};
SideCar.isSideCarExport = true;
function exportSidecar(medium, exported) {
    medium.useMedium(exported);
    return SideCar;
}

;// CONCATENATED MODULE: ./node_modules/get-nonce/dist/es2015/index.js
var currentNonce;
var setNonce = function (nonce) {
    currentNonce = nonce;
};
var getNonce = function () {
    if (currentNonce) {
        return currentNonce;
    }
    if (true) {
        return __webpack_require__.nc;
    }
    return undefined;
};

;// CONCATENATED MODULE: ./node_modules/react-style-singleton/dist/es2015/singleton.js

function makeStyleTag() {
    if (!document)
        return null;
    var tag = document.createElement('style');
    tag.type = 'text/css';
    var nonce = getNonce();
    if (nonce) {
        tag.setAttribute('nonce', nonce);
    }
    return tag;
}
function injectStyles(tag, css) {
    // @ts-ignore
    if (tag.styleSheet) {
        // @ts-ignore
        tag.styleSheet.cssText = css;
    }
    else {
        tag.appendChild(document.createTextNode(css));
    }
}
function insertStyleTag(tag) {
    var head = document.head || document.getElementsByTagName('head')[0];
    head.appendChild(tag);
}
var stylesheetSingleton = function () {
    var counter = 0;
    var stylesheet = null;
    return {
        add: function (style) {
            if (counter == 0) {
                if ((stylesheet = makeStyleTag())) {
                    injectStyles(stylesheet, style);
                    insertStyleTag(stylesheet);
                }
            }
            counter++;
        },
        remove: function () {
            counter--;
            if (!counter && stylesheet) {
                stylesheet.parentNode && stylesheet.parentNode.removeChild(stylesheet);
                stylesheet = null;
            }
        },
    };
};

;// CONCATENATED MODULE: ./node_modules/react-style-singleton/dist/es2015/hook.js


/**
 * creates a hook to control style singleton
 * @see {@link styleSingleton} for a safer component version
 * @example
 * ```tsx
 * const useStyle = styleHookSingleton();
 * ///
 * useStyle('body { overflow: hidden}');
 */
var styleHookSingleton = function () {
    var sheet = stylesheetSingleton();
    return function (styles, isDynamic) {
        react.useEffect(function () {
            sheet.add(styles);
            return function () {
                sheet.remove();
            };
        }, [styles && isDynamic]);
    };
};

;// CONCATENATED MODULE: ./node_modules/react-style-singleton/dist/es2015/component.js

/**
 * create a Component to add styles on demand
 * - styles are added when first instance is mounted
 * - styles are removed when the last instance is unmounted
 * - changing styles in runtime does nothing unless dynamic is set. But with multiple components that can lead to the undefined behavior
 */
var styleSingleton = function () {
    var useStyle = styleHookSingleton();
    var Sheet = function (_a) {
        var styles = _a.styles, dynamic = _a.dynamic;
        useStyle(styles, dynamic);
        return null;
    };
    return Sheet;
};

;// CONCATENATED MODULE: ./node_modules/react-style-singleton/dist/es2015/index.js




;// CONCATENATED MODULE: ./node_modules/react-remove-scroll-bar/dist/es2015/utils.js
var zeroGap = {
    left: 0,
    top: 0,
    right: 0,
    gap: 0,
};
var parse = function (x) { return parseInt(x || '', 10) || 0; };
var getOffset = function (gapMode) {
    var cs = window.getComputedStyle(document.body);
    var left = cs[gapMode === 'padding' ? 'paddingLeft' : 'marginLeft'];
    var top = cs[gapMode === 'padding' ? 'paddingTop' : 'marginTop'];
    var right = cs[gapMode === 'padding' ? 'paddingRight' : 'marginRight'];
    return [parse(left), parse(top), parse(right)];
};
var getGapWidth = function (gapMode) {
    if (gapMode === void 0) { gapMode = 'margin'; }
    if (typeof window === 'undefined') {
        return zeroGap;
    }
    var offsets = getOffset(gapMode);
    var documentWidth = document.documentElement.clientWidth;
    var windowWidth = window.innerWidth;
    return {
        left: offsets[0],
        top: offsets[1],
        right: offsets[2],
        gap: Math.max(0, windowWidth - documentWidth + offsets[2] - offsets[0]),
    };
};

;// CONCATENATED MODULE: ./node_modules/react-remove-scroll-bar/dist/es2015/component.js




var Style = styleSingleton();
// important tip - once we measure scrollBar width and remove them
// we could not repeat this operation
// thus we are using style-singleton - only the first "yet correct" style will be applied.
var getStyles = function (_a, allowRelative, gapMode, important) {
    var left = _a.left, top = _a.top, right = _a.right, gap = _a.gap;
    if (gapMode === void 0) { gapMode = 'margin'; }
    return "\n  .".concat(noScrollbarsClassName, " {\n   overflow: hidden ").concat(important, ";\n   padding-right: ").concat(gap, "px ").concat(important, ";\n  }\n  body {\n    overflow: hidden ").concat(important, ";\n    overscroll-behavior: contain;\n    ").concat([
        allowRelative && "position: relative ".concat(important, ";"),
        gapMode === 'margin' &&
            "\n    padding-left: ".concat(left, "px;\n    padding-top: ").concat(top, "px;\n    padding-right: ").concat(right, "px;\n    margin-left:0;\n    margin-top:0;\n    margin-right: ").concat(gap, "px ").concat(important, ";\n    "),
        gapMode === 'padding' && "padding-right: ".concat(gap, "px ").concat(important, ";"),
    ]
        .filter(Boolean)
        .join(''), "\n  }\n  \n  .").concat(zeroRightClassName, " {\n    right: ").concat(gap, "px ").concat(important, ";\n  }\n  \n  .").concat(fullWidthClassName, " {\n    margin-right: ").concat(gap, "px ").concat(important, ";\n  }\n  \n  .").concat(zeroRightClassName, " .").concat(zeroRightClassName, " {\n    right: 0 ").concat(important, ";\n  }\n  \n  .").concat(fullWidthClassName, " .").concat(fullWidthClassName, " {\n    margin-right: 0 ").concat(important, ";\n  }\n  \n  body {\n    ").concat(removedBarSizeVariable, ": ").concat(gap, "px;\n  }\n");
};
/**
 * Removes page scrollbar and blocks page scroll when mounted
 */
var RemoveScrollBar = function (props) {
    var noRelative = props.noRelative, noImportant = props.noImportant, _a = props.gapMode, gapMode = _a === void 0 ? 'margin' : _a;
    /*
     gap will be measured on every component mount
     however it will be used only by the "first" invocation
     due to singleton nature of <Style
     */
    var gap = react.useMemo(function () { return getGapWidth(gapMode); }, [gapMode]);
    return react.createElement(Style, { styles: getStyles(gap, !noRelative, gapMode, !noImportant ? '!important' : '') });
};

;// CONCATENATED MODULE: ./node_modules/react-remove-scroll-bar/dist/es2015/index.js





;// CONCATENATED MODULE: ./node_modules/react-remove-scroll/dist/es2015/aggresiveCapture.js
var passiveSupported = false;
if (typeof window !== 'undefined') {
    try {
        var options = Object.defineProperty({}, 'passive', {
            get: function () {
                passiveSupported = true;
                return true;
            },
        });
        // @ts-ignore
        window.addEventListener('test', options, options);
        // @ts-ignore
        window.removeEventListener('test', options, options);
    }
    catch (err) {
        passiveSupported = false;
    }
}
var nonPassive = passiveSupported ? { passive: false } : false;

;// CONCATENATED MODULE: ./node_modules/react-remove-scroll/dist/es2015/handleScroll.js
var alwaysContainsScroll = function (node) {
    // textarea will always _contain_ scroll inside self. It only can be hidden
    return node.tagName === 'TEXTAREA';
};
var elementCanBeScrolled = function (node, overflow) {
    var styles = window.getComputedStyle(node);
    return (
    // not-not-scrollable
    styles[overflow] !== 'hidden' &&
        // contains scroll inside self
        !(styles.overflowY === styles.overflowX && !alwaysContainsScroll(node) && styles[overflow] === 'visible'));
};
var elementCouldBeVScrolled = function (node) { return elementCanBeScrolled(node, 'overflowY'); };
var elementCouldBeHScrolled = function (node) { return elementCanBeScrolled(node, 'overflowX'); };
var locationCouldBeScrolled = function (axis, node) {
    var current = node;
    do {
        // Skip over shadow root
        if (typeof ShadowRoot !== 'undefined' && current instanceof ShadowRoot) {
            current = current.host;
        }
        var isScrollable = elementCouldBeScrolled(axis, current);
        if (isScrollable) {
            var _a = getScrollVariables(axis, current), s = _a[1], d = _a[2];
            if (s > d) {
                return true;
            }
        }
        current = current.parentNode;
    } while (current && current !== document.body);
    return false;
};
var getVScrollVariables = function (_a) {
    var scrollTop = _a.scrollTop, scrollHeight = _a.scrollHeight, clientHeight = _a.clientHeight;
    return [
        scrollTop,
        scrollHeight,
        clientHeight,
    ];
};
var getHScrollVariables = function (_a) {
    var scrollLeft = _a.scrollLeft, scrollWidth = _a.scrollWidth, clientWidth = _a.clientWidth;
    return [
        scrollLeft,
        scrollWidth,
        clientWidth,
    ];
};
var elementCouldBeScrolled = function (axis, node) {
    return axis === 'v' ? elementCouldBeVScrolled(node) : elementCouldBeHScrolled(node);
};
var getScrollVariables = function (axis, node) {
    return axis === 'v' ? getVScrollVariables(node) : getHScrollVariables(node);
};
var getDirectionFactor = function (axis, direction) {
    /**
     * If the element's direction is rtl (right-to-left), then scrollLeft is 0 when the scrollbar is at its rightmost position,
     * and then increasingly negative as you scroll towards the end of the content.
     * @see https://developer.mozilla.org/en-US/docs/Web/API/Element/scrollLeft
     */
    return axis === 'h' && direction === 'rtl' ? -1 : 1;
};
var handleScroll = function (axis, endTarget, event, sourceDelta, noOverscroll) {
    var directionFactor = getDirectionFactor(axis, window.getComputedStyle(endTarget).direction);
    var delta = directionFactor * sourceDelta;
    // find scrollable target
    var target = event.target;
    var targetInLock = endTarget.contains(target);
    var shouldCancelScroll = false;
    var isDeltaPositive = delta > 0;
    var availableScroll = 0;
    var availableScrollTop = 0;
    do {
        var _a = getScrollVariables(axis, target), position = _a[0], scroll_1 = _a[1], capacity = _a[2];
        var elementScroll = scroll_1 - capacity - directionFactor * position;
        if (position || elementScroll) {
            if (elementCouldBeScrolled(axis, target)) {
                availableScroll += elementScroll;
                availableScrollTop += position;
            }
        }
        target = target.parentNode;
    } while (
    // portaled content
    (!targetInLock && target !== document.body) ||
        // self content
        (targetInLock && (endTarget.contains(target) || endTarget === target)));
    if (isDeltaPositive && ((noOverscroll && availableScroll === 0) || (!noOverscroll && delta > availableScroll))) {
        shouldCancelScroll = true;
    }
    else if (!isDeltaPositive &&
        ((noOverscroll && availableScrollTop === 0) || (!noOverscroll && -delta > availableScrollTop))) {
        shouldCancelScroll = true;
    }
    return shouldCancelScroll;
};

;// CONCATENATED MODULE: ./node_modules/react-remove-scroll/dist/es2015/SideEffect.js






var getTouchXY = function (event) {
    return 'changedTouches' in event ? [event.changedTouches[0].clientX, event.changedTouches[0].clientY] : [0, 0];
};
var getDeltaXY = function (event) { return [event.deltaX, event.deltaY]; };
var extractRef = function (ref) {
    return ref && 'current' in ref ? ref.current : ref;
};
var deltaCompare = function (x, y) { return x[0] === y[0] && x[1] === y[1]; };
var generateStyle = function (id) { return "\n  .block-interactivity-".concat(id, " {pointer-events: none;}\n  .allow-interactivity-").concat(id, " {pointer-events: all;}\n"); };
var idCounter = 0;
var lockStack = [];
function RemoveScrollSideCar(props) {
    var shouldPreventQueue = react.useRef([]);
    var touchStartRef = react.useRef([0, 0]);
    var activeAxis = react.useRef();
    var id = react.useState(idCounter++)[0];
    var Style = react.useState(function () { return styleSingleton(); })[0];
    var lastProps = react.useRef(props);
    react.useEffect(function () {
        lastProps.current = props;
    }, [props]);
    react.useEffect(function () {
        if (props.inert) {
            document.body.classList.add("block-interactivity-".concat(id));
            var allow_1 = __spreadArray([props.lockRef.current], (props.shards || []).map(extractRef), true).filter(Boolean);
            allow_1.forEach(function (el) { return el.classList.add("allow-interactivity-".concat(id)); });
            return function () {
                document.body.classList.remove("block-interactivity-".concat(id));
                allow_1.forEach(function (el) { return el.classList.remove("allow-interactivity-".concat(id)); });
            };
        }
        return;
    }, [props.inert, props.lockRef.current, props.shards]);
    var shouldCancelEvent = react.useCallback(function (event, parent) {
        if ('touches' in event && event.touches.length === 2) {
            return !lastProps.current.allowPinchZoom;
        }
        var touch = getTouchXY(event);
        var touchStart = touchStartRef.current;
        var deltaX = 'deltaX' in event ? event.deltaX : touchStart[0] - touch[0];
        var deltaY = 'deltaY' in event ? event.deltaY : touchStart[1] - touch[1];
        var currentAxis;
        var target = event.target;
        var moveDirection = Math.abs(deltaX) > Math.abs(deltaY) ? 'h' : 'v';
        // allow horizontal touch move on Range inputs. They will not cause any scroll
        if ('touches' in event && moveDirection === 'h' && target.type === 'range') {
            return false;
        }
        var canBeScrolledInMainDirection = locationCouldBeScrolled(moveDirection, target);
        if (!canBeScrolledInMainDirection) {
            return true;
        }
        if (canBeScrolledInMainDirection) {
            currentAxis = moveDirection;
        }
        else {
            currentAxis = moveDirection === 'v' ? 'h' : 'v';
            canBeScrolledInMainDirection = locationCouldBeScrolled(moveDirection, target);
            // other axis might be not scrollable
        }
        if (!canBeScrolledInMainDirection) {
            return false;
        }
        if (!activeAxis.current && 'changedTouches' in event && (deltaX || deltaY)) {
            activeAxis.current = currentAxis;
        }
        if (!currentAxis) {
            return true;
        }
        var cancelingAxis = activeAxis.current || currentAxis;
        return handleScroll(cancelingAxis, parent, event, cancelingAxis === 'h' ? deltaX : deltaY, true);
    }, []);
    var shouldPrevent = react.useCallback(function (_event) {
        var event = _event;
        if (!lockStack.length || lockStack[lockStack.length - 1] !== Style) {
            // not the last active
            return;
        }
        var delta = 'deltaY' in event ? getDeltaXY(event) : getTouchXY(event);
        var sourceEvent = shouldPreventQueue.current.filter(function (e) { return e.name === event.type && e.target === event.target && deltaCompare(e.delta, delta); })[0];
        // self event, and should be canceled
        if (sourceEvent && sourceEvent.should) {
            if (event.cancelable) {
                event.preventDefault();
            }
            return;
        }
        // outside or shard event
        if (!sourceEvent) {
            var shardNodes = (lastProps.current.shards || [])
                .map(extractRef)
                .filter(Boolean)
                .filter(function (node) { return node.contains(event.target); });
            var shouldStop = shardNodes.length > 0 ? shouldCancelEvent(event, shardNodes[0]) : !lastProps.current.noIsolation;
            if (shouldStop) {
                if (event.cancelable) {
                    event.preventDefault();
                }
            }
        }
    }, []);
    var shouldCancel = react.useCallback(function (name, delta, target, should) {
        var event = { name: name, delta: delta, target: target, should: should };
        shouldPreventQueue.current.push(event);
        setTimeout(function () {
            shouldPreventQueue.current = shouldPreventQueue.current.filter(function (e) { return e !== event; });
        }, 1);
    }, []);
    var scrollTouchStart = react.useCallback(function (event) {
        touchStartRef.current = getTouchXY(event);
        activeAxis.current = undefined;
    }, []);
    var scrollWheel = react.useCallback(function (event) {
        shouldCancel(event.type, getDeltaXY(event), event.target, shouldCancelEvent(event, props.lockRef.current));
    }, []);
    var scrollTouchMove = react.useCallback(function (event) {
        shouldCancel(event.type, getTouchXY(event), event.target, shouldCancelEvent(event, props.lockRef.current));
    }, []);
    react.useEffect(function () {
        lockStack.push(Style);
        props.setCallbacks({
            onScrollCapture: scrollWheel,
            onWheelCapture: scrollWheel,
            onTouchMoveCapture: scrollTouchMove,
        });
        document.addEventListener('wheel', shouldPrevent, nonPassive);
        document.addEventListener('touchmove', shouldPrevent, nonPassive);
        document.addEventListener('touchstart', scrollTouchStart, nonPassive);
        return function () {
            lockStack = lockStack.filter(function (inst) { return inst !== Style; });
            document.removeEventListener('wheel', shouldPrevent, nonPassive);
            document.removeEventListener('touchmove', shouldPrevent, nonPassive);
            document.removeEventListener('touchstart', scrollTouchStart, nonPassive);
        };
    }, []);
    var removeScrollBar = props.removeScrollBar, inert = props.inert;
    return (react.createElement(react.Fragment, null,
        inert ? react.createElement(Style, { styles: generateStyle(id) }) : null,
        removeScrollBar ? react.createElement(RemoveScrollBar, { gapMode: "margin" }) : null));
}

;// CONCATENATED MODULE: ./node_modules/react-remove-scroll/dist/es2015/sidecar.js



/* harmony default export */ var sidecar = (exportSidecar(effectCar, RemoveScrollSideCar));

;// CONCATENATED MODULE: ./node_modules/react-remove-scroll/dist/es2015/Combination.js




var ReactRemoveScroll = react.forwardRef(function (props, ref) { return (react.createElement(RemoveScroll, __assign({}, props, { ref: ref, sideCar: sidecar }))); });
ReactRemoveScroll.classNames = RemoveScroll.classNames;
/* harmony default export */ var Combination = (ReactRemoveScroll);


/***/ }),

/***/ 20723:
/***/ (function(__unused_webpack_module, exports) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
const connectionScript = () => {
    // @ts-ignore
    (function (f, b, e, v, n, t, s) {
        if (f.fbq)
            return;
        n = f.fbq = function () {
            n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
        };
        if (!f._fbq)
            f._fbq = n;
        n.push = n;
        n.loaded = !0;
        n.version = '2.0';
        n.queue = [];
        t = b.createElement(e);
        t.async = !0;
        t.src = v;
        s = b.getElementsByTagName(e)[0];
        s.parentNode.insertBefore(t, s);
    })(window, document, 'script', 'https://connect.facebook.net/en_US/fbevents.js');
};
exports["default"] = connectionScript;


/***/ }),

/***/ 98427:
/***/ (function(__unused_webpack_module, exports) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.TrackableEventNameEnum = void 0;
var TrackableEventNameEnum;
(function (TrackableEventNameEnum) {
    /**
     *  When payment information is added in the checkout flow.
     *
     * A person clicks on a save billing information button. */
    TrackableEventNameEnum["AddPaymentInfo"] = "AddPaymentInfo";
    /** When a product is added to the shopping cart.
     *
     * A person clicks on an add to cart button. */
    TrackableEventNameEnum["AddToCart"] = "AddToCart";
    /** When a product is added to a wishlist.
     *
     * A person clicks on an add to wishlist button. */
    TrackableEventNameEnum["AddToWishlist"] = "AddToWishlist";
    /** When a registration form is completed.
     *
     * A person submits a completed subscription or signup form. */
    TrackableEventNameEnum["CompleteRegistration"] = "CompleteRegistration";
    /** When a person initiates contact with your business via telephone, SMS, email, chat, etc.
     *
     * A person submits a question about a product. */
    TrackableEventNameEnum["Contact"] = "Contact";
    /** When a person customizes a product.
     *
     * A person selects the color of a t-shirt. */
    TrackableEventNameEnum["CustomizeProduct"] = "CustomizeProduct";
    /** When a person donates funds to your organization or cause.
     *
     * A person adds a donation to the Humane Society to their cart. */
    TrackableEventNameEnum["Donate"] = "Donate";
    /** When a person searches for a location of your store via a website or app, with an intention to visit the physical location.
     *
     * A person wants to find a specific product in a local store. */
    TrackableEventNameEnum["FindLocation"] = "FindLocation";
    /** When a person enters the checkout flow prior to completing the checkout flow.
     *
     * A person clicks on a checkout button. */
    TrackableEventNameEnum["InitiateCheckout"] = "InitiateCheckout";
    /** When a sign up is completed.
     *
     * A person clicks on pricing. */
    TrackableEventNameEnum["Lead"] = "Lead";
    /** When a purchase is made or checkout flow is completed.
     *
     * A person has finished the purchase or checkout flow and lands on thank you or confirmation page. */
    TrackableEventNameEnum["Purchase"] = "Purchase";
    /** When a person books an appointment to visit one of your locations.
     *
     * A person selects a date and time for a tennis lesson. */
    TrackableEventNameEnum["Schedule"] = "Schedule";
    /** When a search is made.
     *
     * A person searches for a product on your website.
     */
    TrackableEventNameEnum["Search"] = "Search";
    /**
     * When a person starts a free trial of a product or service you offer.
     *
     * A person selects a free week of your game.
     */
    TrackableEventNameEnum["StartTrial"] = "StartTrial";
    /**
     * When a person applies for a product, service, or program you offer.
     *
     * A person applies for a credit card, educational program, or job.
     */
    TrackableEventNameEnum["SubmitApplication"] = "SubmitApplication";
    /**
     * When a person applies to a start a paid subscription for a product or service you offer.
     *
     * A person subscribes to your streaming service.
     */
    TrackableEventNameEnum["Subscribe"] = "Subscribe";
    /**
     * A visit to a web page you care about (for example, a product page or landing page). ViewContent tells you if someone visits a web page's URL, but not what they see or do on that page.
     *
     * A person lands on a product details page.
     */
    TrackableEventNameEnum["ViewContent"] = "ViewContent";
    /**
     * Initial point for tracking.
     */
    TrackableEventNameEnum["PageView"] = "PageView";
})(TrackableEventNameEnum || (exports.TrackableEventNameEnum = TrackableEventNameEnum = {}));


/***/ }),

/***/ 18390:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";
var __importDefault=this&&this.__importDefault||function(e){return e&&e.__esModule?e:{default:e}};Object.defineProperty(exports, "__esModule", ({value:!0})),exports.TrackableEventNameEnum=exports.FacebookPixel=void 0;const connection_1=__importDefault(__webpack_require__(20723)),enums_1=__webpack_require__(98427);Object.defineProperty(exports, "TrackableEventNameEnum", ({enumerable:!0,get:function(){return enums_1.TrackableEventNameEnum}}));class FacebookPixel{constructor({pixelID:e,debug:t=!0,pageViewOnInit:i=!0,autoConfig:n=!0}){this.consolePrefix="[react-use-facebook-pixel]",this.initialized=!1,this.externalId=void 0,(0,connection_1.default)(),this.pixelID=e,this.debug=t,this.pageViewOnInit=i,this.autoConfig=n}init(e){this.initialized||(this.initialized=!0,window.fbq("set","autoConfig",this.autoConfig,this.pixelID),window.fbq("init",this.pixelID,e),e.external_id&&(this.externalId=e.external_id),this.pageViewOnInit&&this.trackEvent("PageView"),this.debug&&console.log(this.consolePrefix,(new Date).toLocaleTimeString(),"Facebook Pixel initialized"))}getExternalId(){return this.externalId}trackEvent(e,t,i){this.initialized||!this.debug?(window.fbq("track",e,t,i),this.debug&&console.log(this.consolePrefix,(new Date).toLocaleTimeString(),"\nEvent tracked.","\nEvent name: ",e,"\nEvent data: ",t,"\nEvent additiona data",i)):console.error(this.consolePrefix,(new Date).toLocaleTimeString(),"\nError","\nYou tried to track event before initialization")}}exports.FacebookPixel=FacebookPixel;

/***/ }),

/***/ 71739:
/***/ (function(module) {

/**
 * This file automatically generated from `pre-publish.js`.
 * Do not manually edit.
 */

module.exports = {
  "area": true,
  "base": true,
  "br": true,
  "col": true,
  "embed": true,
  "hr": true,
  "img": true,
  "input": true,
  "link": true,
  "meta": true,
  "param": true,
  "source": true,
  "track": true,
  "wbr": true
};


/***/ }),

/***/ 20067:
/***/ (function() {

/* (ignored) */

/***/ }),

/***/ 72061:
/***/ (function() {

/* (ignored) */

/***/ }),

/***/ 87462:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _extends; }
/* harmony export */ });
function _extends() {
  _extends = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}

/***/ }),

/***/ 42614:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "u": function() { return /* binding */ $ae6933e535247d3d$export$7d15b64cf5a3a4c4; }
/* harmony export */ });
function $ae6933e535247d3d$export$7d15b64cf5a3a4c4(value, [min, max]) {
    return Math.min(max, Math.max(min, value));
}





//# sourceMappingURL=index.mjs.map


/***/ }),

/***/ 36206:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "M": function() { return /* binding */ $e42e1063c40fb3ef$export$b9ecd428b558ff10; }
/* harmony export */ });
function $e42e1063c40fb3ef$export$b9ecd428b558ff10(originalEventHandler, ourEventHandler, { checkForDefaultPrevented: checkForDefaultPrevented = true  } = {}) {
    return function handleEvent(event) {
        originalEventHandler === null || originalEventHandler === void 0 || originalEventHandler(event);
        if (checkForDefaultPrevented === false || !event.defaultPrevented) return ourEventHandler === null || ourEventHandler === void 0 ? void 0 : ourEventHandler(event);
    };
}





//# sourceMappingURL=index.mjs.map


/***/ }),

/***/ 65936:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "B": function() { return /* binding */ $e02a7d9cb1dc128c$export$c74125a8e3af6bb2; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(55784);
/* harmony import */ var _radix_ui_react_context__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(25360);
/* harmony import */ var _radix_ui_react_compose_refs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(28771);
/* harmony import */ var _radix_ui_react_slot__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(88426);









// We have resorted to returning slots directly rather than exposing primitives that can then
// be slotted like `<CollectionItem as={Slot}>…</CollectionItem>`.
// This is because we encountered issues with generic types that cannot be statically analysed
// due to creating them dynamically via createCollection.
function $e02a7d9cb1dc128c$export$c74125a8e3af6bb2(name) {
    /* -----------------------------------------------------------------------------------------------
   * CollectionProvider
   * ---------------------------------------------------------------------------------------------*/ const PROVIDER_NAME = name + 'CollectionProvider';
    const [createCollectionContext, createCollectionScope] = (0,_radix_ui_react_context__WEBPACK_IMPORTED_MODULE_1__/* .createContextScope */ .b)(PROVIDER_NAME);
    const [CollectionProviderImpl, useCollectionContext] = createCollectionContext(PROVIDER_NAME, {
        collectionRef: {
            current: null
        },
        itemMap: new Map()
    });
    const CollectionProvider = (props)=>{
        const { scope: scope , children: children  } = props;
        const ref = react__WEBPACK_IMPORTED_MODULE_0__.useRef(null);
        const itemMap = react__WEBPACK_IMPORTED_MODULE_0__.useRef(new Map()).current;
        return /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(CollectionProviderImpl, {
            scope: scope,
            itemMap: itemMap,
            collectionRef: ref
        }, children);
    };
    /*#__PURE__*/ Object.assign(CollectionProvider, {
        displayName: PROVIDER_NAME
    });
    /* -----------------------------------------------------------------------------------------------
   * CollectionSlot
   * ---------------------------------------------------------------------------------------------*/ const COLLECTION_SLOT_NAME = name + 'CollectionSlot';
    const CollectionSlot = /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.forwardRef((props, forwardedRef)=>{
        const { scope: scope , children: children  } = props;
        const context = useCollectionContext(COLLECTION_SLOT_NAME, scope);
        const composedRefs = (0,_radix_ui_react_compose_refs__WEBPACK_IMPORTED_MODULE_2__/* .useComposedRefs */ .e)(forwardedRef, context.collectionRef);
        return /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_radix_ui_react_slot__WEBPACK_IMPORTED_MODULE_3__/* .Slot */ .g7, {
            ref: composedRefs
        }, children);
    });
    /*#__PURE__*/ Object.assign(CollectionSlot, {
        displayName: COLLECTION_SLOT_NAME
    });
    /* -----------------------------------------------------------------------------------------------
   * CollectionItem
   * ---------------------------------------------------------------------------------------------*/ const ITEM_SLOT_NAME = name + 'CollectionItemSlot';
    const ITEM_DATA_ATTR = 'data-radix-collection-item';
    const CollectionItemSlot = /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.forwardRef((props, forwardedRef)=>{
        const { scope: scope , children: children , ...itemData } = props;
        const ref = react__WEBPACK_IMPORTED_MODULE_0__.useRef(null);
        const composedRefs = (0,_radix_ui_react_compose_refs__WEBPACK_IMPORTED_MODULE_2__/* .useComposedRefs */ .e)(forwardedRef, ref);
        const context = useCollectionContext(ITEM_SLOT_NAME, scope);
        react__WEBPACK_IMPORTED_MODULE_0__.useEffect(()=>{
            context.itemMap.set(ref, {
                ref: ref,
                ...itemData
            });
            return ()=>void context.itemMap.delete(ref)
            ;
        });
        return /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_radix_ui_react_slot__WEBPACK_IMPORTED_MODULE_3__/* .Slot */ .g7, {
            [ITEM_DATA_ATTR]: '',
            ref: composedRefs
        }, children);
    });
    /*#__PURE__*/ Object.assign(CollectionItemSlot, {
        displayName: ITEM_SLOT_NAME
    });
    /* -----------------------------------------------------------------------------------------------
   * useCollection
   * ---------------------------------------------------------------------------------------------*/ function useCollection(scope) {
        const context = useCollectionContext(name + 'CollectionConsumer', scope);
        const getItems = react__WEBPACK_IMPORTED_MODULE_0__.useCallback(()=>{
            const collectionNode = context.collectionRef.current;
            if (!collectionNode) return [];
            const orderedNodes = Array.from(collectionNode.querySelectorAll(`[${ITEM_DATA_ATTR}]`));
            const items = Array.from(context.itemMap.values());
            const orderedItems = items.sort((a, b)=>orderedNodes.indexOf(a.ref.current) - orderedNodes.indexOf(b.ref.current)
            );
            return orderedItems;
        }, [
            context.collectionRef,
            context.itemMap
        ]);
        return getItems;
    }
    return [
        {
            Provider: CollectionProvider,
            Slot: CollectionSlot,
            ItemSlot: CollectionItemSlot
        },
        useCollection,
        createCollectionScope
    ];
}





//# sourceMappingURL=index.mjs.map


/***/ }),

/***/ 28771:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "F": function() { return /* binding */ $6ed0406888f73fc4$export$43e446d32b3d21af; },
/* harmony export */   "e": function() { return /* binding */ $6ed0406888f73fc4$export$c7b2cbe3552a0d05; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(55784);



/**
 * Set a given ref to a given value
 * This utility takes care of different types of refs: callback refs and RefObject(s)
 */ function $6ed0406888f73fc4$var$setRef(ref, value) {
    if (typeof ref === 'function') ref(value);
    else if (ref !== null && ref !== undefined) ref.current = value;
}
/**
 * A utility to compose multiple refs together
 * Accepts callback refs and RefObject(s)
 */ function $6ed0406888f73fc4$export$43e446d32b3d21af(...refs) {
    return (node)=>refs.forEach((ref)=>$6ed0406888f73fc4$var$setRef(ref, node)
        )
    ;
}
/**
 * A custom hook that composes multiple refs
 * Accepts callback refs and RefObject(s)
 */ function $6ed0406888f73fc4$export$c7b2cbe3552a0d05(...refs) {
    // eslint-disable-next-line react-hooks/exhaustive-deps
    return (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)($6ed0406888f73fc4$export$43e446d32b3d21af(...refs), refs);
}





//# sourceMappingURL=index.mjs.map


/***/ }),

/***/ 25360:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "b": function() { return /* binding */ $c512c27ab02ef895$export$50c7b4e9d9f19c1; },
/* harmony export */   "k": function() { return /* binding */ $c512c27ab02ef895$export$fd42f52fd3ae1109; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(55784);



function $c512c27ab02ef895$export$fd42f52fd3ae1109(rootComponentName, defaultContext) {
    const Context = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_0__.createContext)(defaultContext);
    function Provider(props) {
        const { children: children , ...context } = props; // Only re-memoize when prop values change
        // eslint-disable-next-line react-hooks/exhaustive-deps
        const value = (0,react__WEBPACK_IMPORTED_MODULE_0__.useMemo)(()=>context
        , Object.values(context));
        return /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_0__.createElement)(Context.Provider, {
            value: value
        }, children);
    }
    function useContext(consumerName) {
        const context = (0,react__WEBPACK_IMPORTED_MODULE_0__.useContext)(Context);
        if (context) return context;
        if (defaultContext !== undefined) return defaultContext; // if a defaultContext wasn't specified, it's a required context.
        throw new Error(`\`${consumerName}\` must be used within \`${rootComponentName}\``);
    }
    Provider.displayName = rootComponentName + 'Provider';
    return [
        Provider,
        useContext
    ];
}
/* -------------------------------------------------------------------------------------------------
 * createContextScope
 * -----------------------------------------------------------------------------------------------*/ function $c512c27ab02ef895$export$50c7b4e9d9f19c1(scopeName, createContextScopeDeps = []) {
    let defaultContexts = [];
    /* -----------------------------------------------------------------------------------------------
   * createContext
   * ---------------------------------------------------------------------------------------------*/ function $c512c27ab02ef895$export$fd42f52fd3ae1109(rootComponentName, defaultContext) {
        const BaseContext = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_0__.createContext)(defaultContext);
        const index = defaultContexts.length;
        defaultContexts = [
            ...defaultContexts,
            defaultContext
        ];
        function Provider(props) {
            const { scope: scope , children: children , ...context } = props;
            const Context = (scope === null || scope === void 0 ? void 0 : scope[scopeName][index]) || BaseContext; // Only re-memoize when prop values change
            // eslint-disable-next-line react-hooks/exhaustive-deps
            const value = (0,react__WEBPACK_IMPORTED_MODULE_0__.useMemo)(()=>context
            , Object.values(context));
            return /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_0__.createElement)(Context.Provider, {
                value: value
            }, children);
        }
        function useContext(consumerName, scope) {
            const Context = (scope === null || scope === void 0 ? void 0 : scope[scopeName][index]) || BaseContext;
            const context = (0,react__WEBPACK_IMPORTED_MODULE_0__.useContext)(Context);
            if (context) return context;
            if (defaultContext !== undefined) return defaultContext; // if a defaultContext wasn't specified, it's a required context.
            throw new Error(`\`${consumerName}\` must be used within \`${rootComponentName}\``);
        }
        Provider.displayName = rootComponentName + 'Provider';
        return [
            Provider,
            useContext
        ];
    }
    /* -----------------------------------------------------------------------------------------------
   * createScope
   * ---------------------------------------------------------------------------------------------*/ const createScope = ()=>{
        const scopeContexts = defaultContexts.map((defaultContext)=>{
            return /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_0__.createContext)(defaultContext);
        });
        return function useScope(scope) {
            const contexts = (scope === null || scope === void 0 ? void 0 : scope[scopeName]) || scopeContexts;
            return (0,react__WEBPACK_IMPORTED_MODULE_0__.useMemo)(()=>({
                    [`__scope${scopeName}`]: {
                        ...scope,
                        [scopeName]: contexts
                    }
                })
            , [
                scope,
                contexts
            ]);
        };
    };
    createScope.scopeName = scopeName;
    return [
        $c512c27ab02ef895$export$fd42f52fd3ae1109,
        $c512c27ab02ef895$var$composeContextScopes(createScope, ...createContextScopeDeps)
    ];
}
/* -------------------------------------------------------------------------------------------------
 * composeContextScopes
 * -----------------------------------------------------------------------------------------------*/ function $c512c27ab02ef895$var$composeContextScopes(...scopes) {
    const baseScope = scopes[0];
    if (scopes.length === 1) return baseScope;
    const createScope1 = ()=>{
        const scopeHooks = scopes.map((createScope)=>({
                useScope: createScope(),
                scopeName: createScope.scopeName
            })
        );
        return function useComposedScopes(overrideScopes) {
            const nextScopes1 = scopeHooks.reduce((nextScopes, { useScope: useScope , scopeName: scopeName  })=>{
                // We are calling a hook inside a callback which React warns against to avoid inconsistent
                // renders, however, scoping doesn't have render side effects so we ignore the rule.
                // eslint-disable-next-line react-hooks/rules-of-hooks
                const scopeProps = useScope(overrideScopes);
                const currentScope = scopeProps[`__scope${scopeName}`];
                return {
                    ...nextScopes,
                    ...currentScope
                };
            }, {});
            return (0,react__WEBPACK_IMPORTED_MODULE_0__.useMemo)(()=>({
                    [`__scope${baseScope.scopeName}`]: nextScopes1
                })
            , [
                nextScopes1
            ]);
        };
    };
    createScope1.scopeName = baseScope.scopeName;
    return createScope1;
}





//# sourceMappingURL=index.mjs.map


/***/ }),

/***/ 12854:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Dx": function() { return /* binding */ $5d3850c4d0b4e6c7$export$f99233281efd08a0; },
/* harmony export */   "VY": function() { return /* binding */ $5d3850c4d0b4e6c7$export$7c6e2c02157bb7d2; },
/* harmony export */   "aV": function() { return /* binding */ $5d3850c4d0b4e6c7$export$c6fdb837b070b4ff; },
/* harmony export */   "dk": function() { return /* binding */ $5d3850c4d0b4e6c7$export$393edc798c47379d; },
/* harmony export */   "fC": function() { return /* binding */ $5d3850c4d0b4e6c7$export$be92b6f5f03c0fe9; },
/* harmony export */   "h_": function() { return /* binding */ $5d3850c4d0b4e6c7$export$602eac185826482c; },
/* harmony export */   "hg": function() { return /* binding */ $5d3850c4d0b4e6c7$export$2e1e1122cf0cba88; },
/* harmony export */   "x8": function() { return /* binding */ $5d3850c4d0b4e6c7$export$f39c2d165cd861fe; },
/* harmony export */   "xz": function() { return /* binding */ $5d3850c4d0b4e6c7$export$41fb9f06171c75f4; }
/* harmony export */ });
/* unused harmony exports createDialogScope, Dialog, DialogPortal, DialogOverlay, DialogContent, DialogTitle, DialogDescription, DialogClose, WarningProvider */
/* harmony import */ var _babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(87462);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(55784);
/* harmony import */ var _radix_ui_primitive__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(36206);
/* harmony import */ var _radix_ui_react_compose_refs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(28771);
/* harmony import */ var _radix_ui_react_context__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(25360);
/* harmony import */ var _radix_ui_react_id__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(91276);
/* harmony import */ var _radix_ui_react_use_controllable_state__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(77342);
/* harmony import */ var _radix_ui_react_dismissable_layer__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(46063);
/* harmony import */ var _radix_ui_react_focus_scope__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(95420);
/* harmony import */ var _radix_ui_react_portal__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(42651);
/* harmony import */ var _radix_ui_react_presence__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(29115);
/* harmony import */ var _radix_ui_react_primitive__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(75320);
/* harmony import */ var _radix_ui_react_focus_guards__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(27552);
/* harmony import */ var react_remove_scroll__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(6223);
/* harmony import */ var aria_hidden__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(23541);
/* harmony import */ var _radix_ui_react_slot__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(88426);

































/* -------------------------------------------------------------------------------------------------
 * Dialog
 * -----------------------------------------------------------------------------------------------*/ const $5d3850c4d0b4e6c7$var$DIALOG_NAME = 'Dialog';
const [$5d3850c4d0b4e6c7$var$createDialogContext, $5d3850c4d0b4e6c7$export$cc702773b8ea3e41] = (0,_radix_ui_react_context__WEBPACK_IMPORTED_MODULE_1__/* .createContextScope */ .b)($5d3850c4d0b4e6c7$var$DIALOG_NAME);
const [$5d3850c4d0b4e6c7$var$DialogProvider, $5d3850c4d0b4e6c7$var$useDialogContext] = $5d3850c4d0b4e6c7$var$createDialogContext($5d3850c4d0b4e6c7$var$DIALOG_NAME);
const $5d3850c4d0b4e6c7$export$3ddf2d174ce01153 = (props)=>{
    const { __scopeDialog: __scopeDialog , children: children , open: openProp , defaultOpen: defaultOpen , onOpenChange: onOpenChange , modal: modal = true  } = props;
    const triggerRef = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(null);
    const contentRef = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(null);
    const [open = false, setOpen] = (0,_radix_ui_react_use_controllable_state__WEBPACK_IMPORTED_MODULE_2__/* .useControllableState */ .T)({
        prop: openProp,
        defaultProp: defaultOpen,
        onChange: onOpenChange
    });
    return /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_0__.createElement)($5d3850c4d0b4e6c7$var$DialogProvider, {
        scope: __scopeDialog,
        triggerRef: triggerRef,
        contentRef: contentRef,
        contentId: (0,_radix_ui_react_id__WEBPACK_IMPORTED_MODULE_3__/* .useId */ .M)(),
        titleId: (0,_radix_ui_react_id__WEBPACK_IMPORTED_MODULE_3__/* .useId */ .M)(),
        descriptionId: (0,_radix_ui_react_id__WEBPACK_IMPORTED_MODULE_3__/* .useId */ .M)(),
        open: open,
        onOpenChange: setOpen,
        onOpenToggle: (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(()=>setOpen((prevOpen)=>!prevOpen
            )
        , [
            setOpen
        ]),
        modal: modal
    }, children);
};
/*#__PURE__*/ Object.assign($5d3850c4d0b4e6c7$export$3ddf2d174ce01153, {
    displayName: $5d3850c4d0b4e6c7$var$DIALOG_NAME
});
/* -------------------------------------------------------------------------------------------------
 * DialogTrigger
 * -----------------------------------------------------------------------------------------------*/ const $5d3850c4d0b4e6c7$var$TRIGGER_NAME = 'DialogTrigger';
const $5d3850c4d0b4e6c7$export$2e1e1122cf0cba88 = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_0__.forwardRef)((props, forwardedRef)=>{
    const { __scopeDialog: __scopeDialog , ...triggerProps } = props;
    const context = $5d3850c4d0b4e6c7$var$useDialogContext($5d3850c4d0b4e6c7$var$TRIGGER_NAME, __scopeDialog);
    const composedTriggerRef = (0,_radix_ui_react_compose_refs__WEBPACK_IMPORTED_MODULE_4__/* .useComposedRefs */ .e)(forwardedRef, context.triggerRef);
    return /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_0__.createElement)(_radix_ui_react_primitive__WEBPACK_IMPORTED_MODULE_5__/* .Primitive.button */ .WV.button, (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({
        type: "button",
        "aria-haspopup": "dialog",
        "aria-expanded": context.open,
        "aria-controls": context.contentId,
        "data-state": $5d3850c4d0b4e6c7$var$getState(context.open)
    }, triggerProps, {
        ref: composedTriggerRef,
        onClick: (0,_radix_ui_primitive__WEBPACK_IMPORTED_MODULE_7__/* .composeEventHandlers */ .M)(props.onClick, context.onOpenToggle)
    }));
});
/*#__PURE__*/ Object.assign($5d3850c4d0b4e6c7$export$2e1e1122cf0cba88, {
    displayName: $5d3850c4d0b4e6c7$var$TRIGGER_NAME
});
/* -------------------------------------------------------------------------------------------------
 * DialogPortal
 * -----------------------------------------------------------------------------------------------*/ const $5d3850c4d0b4e6c7$var$PORTAL_NAME = 'DialogPortal';
const [$5d3850c4d0b4e6c7$var$PortalProvider, $5d3850c4d0b4e6c7$var$usePortalContext] = $5d3850c4d0b4e6c7$var$createDialogContext($5d3850c4d0b4e6c7$var$PORTAL_NAME, {
    forceMount: undefined
});
const $5d3850c4d0b4e6c7$export$dad7c95542bacce0 = (props)=>{
    const { __scopeDialog: __scopeDialog , forceMount: forceMount , children: children , container: container  } = props;
    const context = $5d3850c4d0b4e6c7$var$useDialogContext($5d3850c4d0b4e6c7$var$PORTAL_NAME, __scopeDialog);
    return /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_0__.createElement)($5d3850c4d0b4e6c7$var$PortalProvider, {
        scope: __scopeDialog,
        forceMount: forceMount
    }, react__WEBPACK_IMPORTED_MODULE_0__.Children.map(children, (child)=>/*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_0__.createElement)(_radix_ui_react_presence__WEBPACK_IMPORTED_MODULE_8__/* .Presence */ .z, {
            present: forceMount || context.open
        }, /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_0__.createElement)(_radix_ui_react_portal__WEBPACK_IMPORTED_MODULE_9__/* .Portal */ .h, {
            asChild: true,
            container: container
        }, child))
    ));
};
/*#__PURE__*/ Object.assign($5d3850c4d0b4e6c7$export$dad7c95542bacce0, {
    displayName: $5d3850c4d0b4e6c7$var$PORTAL_NAME
});
/* -------------------------------------------------------------------------------------------------
 * DialogOverlay
 * -----------------------------------------------------------------------------------------------*/ const $5d3850c4d0b4e6c7$var$OVERLAY_NAME = 'DialogOverlay';
const $5d3850c4d0b4e6c7$export$bd1d06c79be19e17 = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_0__.forwardRef)((props, forwardedRef)=>{
    const portalContext = $5d3850c4d0b4e6c7$var$usePortalContext($5d3850c4d0b4e6c7$var$OVERLAY_NAME, props.__scopeDialog);
    const { forceMount: forceMount = portalContext.forceMount , ...overlayProps } = props;
    const context = $5d3850c4d0b4e6c7$var$useDialogContext($5d3850c4d0b4e6c7$var$OVERLAY_NAME, props.__scopeDialog);
    return context.modal ? /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_0__.createElement)(_radix_ui_react_presence__WEBPACK_IMPORTED_MODULE_8__/* .Presence */ .z, {
        present: forceMount || context.open
    }, /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_0__.createElement)($5d3850c4d0b4e6c7$var$DialogOverlayImpl, (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({}, overlayProps, {
        ref: forwardedRef
    }))) : null;
});
/*#__PURE__*/ Object.assign($5d3850c4d0b4e6c7$export$bd1d06c79be19e17, {
    displayName: $5d3850c4d0b4e6c7$var$OVERLAY_NAME
});
const $5d3850c4d0b4e6c7$var$DialogOverlayImpl = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_0__.forwardRef)((props, forwardedRef)=>{
    const { __scopeDialog: __scopeDialog , ...overlayProps } = props;
    const context = $5d3850c4d0b4e6c7$var$useDialogContext($5d3850c4d0b4e6c7$var$OVERLAY_NAME, __scopeDialog);
    return(/*#__PURE__*/ // Make sure `Content` is scrollable even when it doesn't live inside `RemoveScroll`
    // ie. when `Overlay` and `Content` are siblings
    (0,react__WEBPACK_IMPORTED_MODULE_0__.createElement)(react_remove_scroll__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z, {
        as: _radix_ui_react_slot__WEBPACK_IMPORTED_MODULE_11__/* .Slot */ .g7,
        allowPinchZoom: true,
        shards: [
            context.contentRef
        ]
    }, /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_0__.createElement)(_radix_ui_react_primitive__WEBPACK_IMPORTED_MODULE_5__/* .Primitive.div */ .WV.div, (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({
        "data-state": $5d3850c4d0b4e6c7$var$getState(context.open)
    }, overlayProps, {
        ref: forwardedRef // We re-enable pointer-events prevented by `Dialog.Content` to allow scrolling the overlay.
        ,
        style: {
            pointerEvents: 'auto',
            ...overlayProps.style
        }
    }))));
});
/* -------------------------------------------------------------------------------------------------
 * DialogContent
 * -----------------------------------------------------------------------------------------------*/ const $5d3850c4d0b4e6c7$var$CONTENT_NAME = 'DialogContent';
const $5d3850c4d0b4e6c7$export$b6d9565de1e068cf = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_0__.forwardRef)((props, forwardedRef)=>{
    const portalContext = $5d3850c4d0b4e6c7$var$usePortalContext($5d3850c4d0b4e6c7$var$CONTENT_NAME, props.__scopeDialog);
    const { forceMount: forceMount = portalContext.forceMount , ...contentProps } = props;
    const context = $5d3850c4d0b4e6c7$var$useDialogContext($5d3850c4d0b4e6c7$var$CONTENT_NAME, props.__scopeDialog);
    return /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_0__.createElement)(_radix_ui_react_presence__WEBPACK_IMPORTED_MODULE_8__/* .Presence */ .z, {
        present: forceMount || context.open
    }, context.modal ? /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_0__.createElement)($5d3850c4d0b4e6c7$var$DialogContentModal, (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({}, contentProps, {
        ref: forwardedRef
    })) : /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_0__.createElement)($5d3850c4d0b4e6c7$var$DialogContentNonModal, (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({}, contentProps, {
        ref: forwardedRef
    })));
});
/*#__PURE__*/ Object.assign($5d3850c4d0b4e6c7$export$b6d9565de1e068cf, {
    displayName: $5d3850c4d0b4e6c7$var$CONTENT_NAME
});
/* -----------------------------------------------------------------------------------------------*/ const $5d3850c4d0b4e6c7$var$DialogContentModal = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_0__.forwardRef)((props, forwardedRef)=>{
    const context = $5d3850c4d0b4e6c7$var$useDialogContext($5d3850c4d0b4e6c7$var$CONTENT_NAME, props.__scopeDialog);
    const contentRef = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(null);
    const composedRefs = (0,_radix_ui_react_compose_refs__WEBPACK_IMPORTED_MODULE_4__/* .useComposedRefs */ .e)(forwardedRef, context.contentRef, contentRef); // aria-hide everything except the content (better supported equivalent to setting aria-modal)
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(()=>{
        const content = contentRef.current;
        if (content) return (0,aria_hidden__WEBPACK_IMPORTED_MODULE_12__/* .hideOthers */ .Ry)(content);
    }, []);
    return /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_0__.createElement)($5d3850c4d0b4e6c7$var$DialogContentImpl, (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({}, props, {
        ref: composedRefs // we make sure focus isn't trapped once `DialogContent` has been closed
        ,
        trapFocus: context.open,
        disableOutsidePointerEvents: true,
        onCloseAutoFocus: (0,_radix_ui_primitive__WEBPACK_IMPORTED_MODULE_7__/* .composeEventHandlers */ .M)(props.onCloseAutoFocus, (event)=>{
            var _context$triggerRef$c;
            event.preventDefault();
            (_context$triggerRef$c = context.triggerRef.current) === null || _context$triggerRef$c === void 0 || _context$triggerRef$c.focus();
        }),
        onPointerDownOutside: (0,_radix_ui_primitive__WEBPACK_IMPORTED_MODULE_7__/* .composeEventHandlers */ .M)(props.onPointerDownOutside, (event)=>{
            const originalEvent = event.detail.originalEvent;
            const ctrlLeftClick = originalEvent.button === 0 && originalEvent.ctrlKey === true;
            const isRightClick = originalEvent.button === 2 || ctrlLeftClick; // If the event is a right-click, we shouldn't close because
            // it is effectively as if we right-clicked the `Overlay`.
            if (isRightClick) event.preventDefault();
        }) // When focus is trapped, a `focusout` event may still happen.
        ,
        onFocusOutside: (0,_radix_ui_primitive__WEBPACK_IMPORTED_MODULE_7__/* .composeEventHandlers */ .M)(props.onFocusOutside, (event)=>event.preventDefault()
        )
    }));
});
/* -----------------------------------------------------------------------------------------------*/ const $5d3850c4d0b4e6c7$var$DialogContentNonModal = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_0__.forwardRef)((props, forwardedRef)=>{
    const context = $5d3850c4d0b4e6c7$var$useDialogContext($5d3850c4d0b4e6c7$var$CONTENT_NAME, props.__scopeDialog);
    const hasInteractedOutsideRef = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(false);
    const hasPointerDownOutsideRef = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(false);
    return /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_0__.createElement)($5d3850c4d0b4e6c7$var$DialogContentImpl, (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({}, props, {
        ref: forwardedRef,
        trapFocus: false,
        disableOutsidePointerEvents: false,
        onCloseAutoFocus: (event)=>{
            var _props$onCloseAutoFoc;
            (_props$onCloseAutoFoc = props.onCloseAutoFocus) === null || _props$onCloseAutoFoc === void 0 || _props$onCloseAutoFoc.call(props, event);
            if (!event.defaultPrevented) {
                var _context$triggerRef$c2;
                if (!hasInteractedOutsideRef.current) (_context$triggerRef$c2 = context.triggerRef.current) === null || _context$triggerRef$c2 === void 0 || _context$triggerRef$c2.focus(); // Always prevent auto focus because we either focus manually or want user agent focus
                event.preventDefault();
            }
            hasInteractedOutsideRef.current = false;
            hasPointerDownOutsideRef.current = false;
        },
        onInteractOutside: (event)=>{
            var _props$onInteractOuts, _context$triggerRef$c3;
            (_props$onInteractOuts = props.onInteractOutside) === null || _props$onInteractOuts === void 0 || _props$onInteractOuts.call(props, event);
            if (!event.defaultPrevented) {
                hasInteractedOutsideRef.current = true;
                if (event.detail.originalEvent.type === 'pointerdown') hasPointerDownOutsideRef.current = true;
            } // Prevent dismissing when clicking the trigger.
            // As the trigger is already setup to close, without doing so would
            // cause it to close and immediately open.
            const target = event.target;
            const targetIsTrigger = (_context$triggerRef$c3 = context.triggerRef.current) === null || _context$triggerRef$c3 === void 0 ? void 0 : _context$triggerRef$c3.contains(target);
            if (targetIsTrigger) event.preventDefault(); // On Safari if the trigger is inside a container with tabIndex={0}, when clicked
            // we will get the pointer down outside event on the trigger, but then a subsequent
            // focus outside event on the container, we ignore any focus outside event when we've
            // already had a pointer down outside event.
            if (event.detail.originalEvent.type === 'focusin' && hasPointerDownOutsideRef.current) event.preventDefault();
        }
    }));
});
/* -----------------------------------------------------------------------------------------------*/ const $5d3850c4d0b4e6c7$var$DialogContentImpl = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_0__.forwardRef)((props, forwardedRef)=>{
    const { __scopeDialog: __scopeDialog , trapFocus: trapFocus , onOpenAutoFocus: onOpenAutoFocus , onCloseAutoFocus: onCloseAutoFocus , ...contentProps } = props;
    const context = $5d3850c4d0b4e6c7$var$useDialogContext($5d3850c4d0b4e6c7$var$CONTENT_NAME, __scopeDialog);
    const contentRef = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(null);
    const composedRefs = (0,_radix_ui_react_compose_refs__WEBPACK_IMPORTED_MODULE_4__/* .useComposedRefs */ .e)(forwardedRef, contentRef); // Make sure the whole tree has focus guards as our `Dialog` will be
    // the last element in the DOM (beacuse of the `Portal`)
    (0,_radix_ui_react_focus_guards__WEBPACK_IMPORTED_MODULE_13__/* .useFocusGuards */ .EW)();
    return /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_0__.createElement)(react__WEBPACK_IMPORTED_MODULE_0__.Fragment, null, /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_0__.createElement)(_radix_ui_react_focus_scope__WEBPACK_IMPORTED_MODULE_14__/* .FocusScope */ .M, {
        asChild: true,
        loop: true,
        trapped: trapFocus,
        onMountAutoFocus: onOpenAutoFocus,
        onUnmountAutoFocus: onCloseAutoFocus
    }, /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_0__.createElement)(_radix_ui_react_dismissable_layer__WEBPACK_IMPORTED_MODULE_15__/* .DismissableLayer */ .XB, (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({
        role: "dialog",
        id: context.contentId,
        "aria-describedby": context.descriptionId,
        "aria-labelledby": context.titleId,
        "data-state": $5d3850c4d0b4e6c7$var$getState(context.open)
    }, contentProps, {
        ref: composedRefs,
        onDismiss: ()=>context.onOpenChange(false)
    }))), false);
});
/* -------------------------------------------------------------------------------------------------
 * DialogTitle
 * -----------------------------------------------------------------------------------------------*/ const $5d3850c4d0b4e6c7$var$TITLE_NAME = 'DialogTitle';
const $5d3850c4d0b4e6c7$export$16f7638e4a34b909 = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_0__.forwardRef)((props, forwardedRef)=>{
    const { __scopeDialog: __scopeDialog , ...titleProps } = props;
    const context = $5d3850c4d0b4e6c7$var$useDialogContext($5d3850c4d0b4e6c7$var$TITLE_NAME, __scopeDialog);
    return /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_0__.createElement)(_radix_ui_react_primitive__WEBPACK_IMPORTED_MODULE_5__/* .Primitive.h2 */ .WV.h2, (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({
        id: context.titleId
    }, titleProps, {
        ref: forwardedRef
    }));
});
/*#__PURE__*/ Object.assign($5d3850c4d0b4e6c7$export$16f7638e4a34b909, {
    displayName: $5d3850c4d0b4e6c7$var$TITLE_NAME
});
/* -------------------------------------------------------------------------------------------------
 * DialogDescription
 * -----------------------------------------------------------------------------------------------*/ const $5d3850c4d0b4e6c7$var$DESCRIPTION_NAME = 'DialogDescription';
const $5d3850c4d0b4e6c7$export$94e94c2ec2c954d5 = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_0__.forwardRef)((props, forwardedRef)=>{
    const { __scopeDialog: __scopeDialog , ...descriptionProps } = props;
    const context = $5d3850c4d0b4e6c7$var$useDialogContext($5d3850c4d0b4e6c7$var$DESCRIPTION_NAME, __scopeDialog);
    return /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_0__.createElement)(_radix_ui_react_primitive__WEBPACK_IMPORTED_MODULE_5__/* .Primitive.p */ .WV.p, (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({
        id: context.descriptionId
    }, descriptionProps, {
        ref: forwardedRef
    }));
});
/*#__PURE__*/ Object.assign($5d3850c4d0b4e6c7$export$94e94c2ec2c954d5, {
    displayName: $5d3850c4d0b4e6c7$var$DESCRIPTION_NAME
});
/* -------------------------------------------------------------------------------------------------
 * DialogClose
 * -----------------------------------------------------------------------------------------------*/ const $5d3850c4d0b4e6c7$var$CLOSE_NAME = 'DialogClose';
const $5d3850c4d0b4e6c7$export$fba2fb7cd781b7ac = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_0__.forwardRef)((props, forwardedRef)=>{
    const { __scopeDialog: __scopeDialog , ...closeProps } = props;
    const context = $5d3850c4d0b4e6c7$var$useDialogContext($5d3850c4d0b4e6c7$var$CLOSE_NAME, __scopeDialog);
    return /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_0__.createElement)(_radix_ui_react_primitive__WEBPACK_IMPORTED_MODULE_5__/* .Primitive.button */ .WV.button, (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({
        type: "button"
    }, closeProps, {
        ref: forwardedRef,
        onClick: (0,_radix_ui_primitive__WEBPACK_IMPORTED_MODULE_7__/* .composeEventHandlers */ .M)(props.onClick, ()=>context.onOpenChange(false)
        )
    }));
});
/*#__PURE__*/ Object.assign($5d3850c4d0b4e6c7$export$fba2fb7cd781b7ac, {
    displayName: $5d3850c4d0b4e6c7$var$CLOSE_NAME
});
/* -----------------------------------------------------------------------------------------------*/ function $5d3850c4d0b4e6c7$var$getState(open) {
    return open ? 'open' : 'closed';
}
const $5d3850c4d0b4e6c7$var$TITLE_WARNING_NAME = 'DialogTitleWarning';
const [$5d3850c4d0b4e6c7$export$69b62a49393917d6, $5d3850c4d0b4e6c7$var$useWarningContext] = (0,_radix_ui_react_context__WEBPACK_IMPORTED_MODULE_1__/* .createContext */ .k)($5d3850c4d0b4e6c7$var$TITLE_WARNING_NAME, {
    contentName: $5d3850c4d0b4e6c7$var$CONTENT_NAME,
    titleName: $5d3850c4d0b4e6c7$var$TITLE_NAME,
    docsSlug: 'dialog'
});
const $5d3850c4d0b4e6c7$var$TitleWarning = ({ titleId: titleId  })=>{
    const titleWarningContext = $5d3850c4d0b4e6c7$var$useWarningContext($5d3850c4d0b4e6c7$var$TITLE_WARNING_NAME);
    const MESSAGE = `\`${titleWarningContext.contentName}\` requires a \`${titleWarningContext.titleName}\` for the component to be accessible for screen reader users.

If you want to hide the \`${titleWarningContext.titleName}\`, you can wrap it with our VisuallyHidden component.

For more information, see https://radix-ui.com/primitives/docs/components/${titleWarningContext.docsSlug}`;
    $67UHm$useEffect(()=>{
        if (titleId) {
            const hasTitle = document.getElementById(titleId);
            if (!hasTitle) throw new Error(MESSAGE);
        }
    }, [
        MESSAGE,
        titleId
    ]);
    return null;
};
const $5d3850c4d0b4e6c7$var$DESCRIPTION_WARNING_NAME = 'DialogDescriptionWarning';
const $5d3850c4d0b4e6c7$var$DescriptionWarning = ({ contentRef: contentRef , descriptionId: descriptionId  })=>{
    const descriptionWarningContext = $5d3850c4d0b4e6c7$var$useWarningContext($5d3850c4d0b4e6c7$var$DESCRIPTION_WARNING_NAME);
    const MESSAGE = `Warning: Missing \`Description\` or \`aria-describedby={undefined}\` for {${descriptionWarningContext.contentName}}.`;
    $67UHm$useEffect(()=>{
        var _contentRef$current;
        const describedById = (_contentRef$current = contentRef.current) === null || _contentRef$current === void 0 ? void 0 : _contentRef$current.getAttribute('aria-describedby'); // if we have an id and the user hasn't set aria-describedby={undefined}
        if (descriptionId && describedById) {
            const hasDescription = document.getElementById(descriptionId);
            if (!hasDescription) console.warn(MESSAGE);
        }
    }, [
        MESSAGE,
        contentRef,
        descriptionId
    ]);
    return null;
};
const $5d3850c4d0b4e6c7$export$be92b6f5f03c0fe9 = $5d3850c4d0b4e6c7$export$3ddf2d174ce01153;
const $5d3850c4d0b4e6c7$export$41fb9f06171c75f4 = $5d3850c4d0b4e6c7$export$2e1e1122cf0cba88;
const $5d3850c4d0b4e6c7$export$602eac185826482c = $5d3850c4d0b4e6c7$export$dad7c95542bacce0;
const $5d3850c4d0b4e6c7$export$c6fdb837b070b4ff = $5d3850c4d0b4e6c7$export$bd1d06c79be19e17;
const $5d3850c4d0b4e6c7$export$7c6e2c02157bb7d2 = $5d3850c4d0b4e6c7$export$b6d9565de1e068cf;
const $5d3850c4d0b4e6c7$export$f99233281efd08a0 = $5d3850c4d0b4e6c7$export$16f7638e4a34b909;
const $5d3850c4d0b4e6c7$export$393edc798c47379d = $5d3850c4d0b4e6c7$export$94e94c2ec2c954d5;
const $5d3850c4d0b4e6c7$export$f39c2d165cd861fe = $5d3850c4d0b4e6c7$export$fba2fb7cd781b7ac;





//# sourceMappingURL=index.mjs.map


/***/ }),

/***/ 78990:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "gm": function() { return /* binding */ $f631663db3294ace$export$b39126d51d94e6f3; }
/* harmony export */ });
/* unused harmony exports Provider, DirectionProvider */
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(55784);



const $f631663db3294ace$var$DirectionContext = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_0__.createContext)(undefined);
/* -------------------------------------------------------------------------------------------------
 * Direction
 * -----------------------------------------------------------------------------------------------*/ const $f631663db3294ace$export$c760c09fdd558351 = (props)=>{
    const { dir: dir , children: children  } = props;
    return /*#__PURE__*/ $7Gjcd$createElement($f631663db3294ace$var$DirectionContext.Provider, {
        value: dir
    }, children);
};
/* -----------------------------------------------------------------------------------------------*/ function $f631663db3294ace$export$b39126d51d94e6f3(localDir) {
    const globalDir = (0,react__WEBPACK_IMPORTED_MODULE_0__.useContext)($f631663db3294ace$var$DirectionContext);
    return localDir || globalDir || 'ltr';
}
const $f631663db3294ace$export$2881499e37b75b9a = (/* unused pure expression or super */ null && ($f631663db3294ace$export$c760c09fdd558351));





//# sourceMappingURL=index.mjs.map


/***/ }),

/***/ 46063:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "I0": function() { return /* binding */ $5cb92bef7577960e$export$aecb2ddcb55c95be; },
  "XB": function() { return /* binding */ $5cb92bef7577960e$export$177fb62ff3ec1f22; },
  "fC": function() { return /* binding */ $5cb92bef7577960e$export$be92b6f5f03c0fe9; }
});

// UNUSED EXPORTS: DismissableLayerBranch

// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__(87462);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/react/index.js
var react = __webpack_require__(55784);
// EXTERNAL MODULE: ./node_modules/@radix-ui/primitive/dist/index.mjs
var dist = __webpack_require__(36206);
// EXTERNAL MODULE: ./node_modules/@radix-ui/react-primitive/dist/index.mjs
var react_primitive_dist = __webpack_require__(75320);
// EXTERNAL MODULE: ./node_modules/@radix-ui/react-compose-refs/dist/index.mjs
var react_compose_refs_dist = __webpack_require__(28771);
// EXTERNAL MODULE: ./node_modules/@radix-ui/react-use-callback-ref/dist/index.mjs
var react_use_callback_ref_dist = __webpack_require__(79698);
;// CONCATENATED MODULE: ./node_modules/@radix-ui/react-use-escape-keydown/dist/index.mjs





/**
 * Listens for when the escape key is down
 */ function $addc16e1bbe58fd0$export$3a72a57244d6e765(onEscapeKeyDownProp, ownerDocument = globalThis === null || globalThis === void 0 ? void 0 : globalThis.document) {
    const onEscapeKeyDown = (0,react_use_callback_ref_dist/* useCallbackRef */.W)(onEscapeKeyDownProp);
    (0,react.useEffect)(()=>{
        const handleKeyDown = (event)=>{
            if (event.key === 'Escape') onEscapeKeyDown(event);
        };
        ownerDocument.addEventListener('keydown', handleKeyDown);
        return ()=>ownerDocument.removeEventListener('keydown', handleKeyDown)
        ;
    }, [
        onEscapeKeyDown,
        ownerDocument
    ]);
}





//# sourceMappingURL=index.mjs.map

;// CONCATENATED MODULE: ./node_modules/@radix-ui/react-dismissable-layer/dist/index.mjs















/* -------------------------------------------------------------------------------------------------
 * DismissableLayer
 * -----------------------------------------------------------------------------------------------*/ const $5cb92bef7577960e$var$DISMISSABLE_LAYER_NAME = 'DismissableLayer';
const $5cb92bef7577960e$var$CONTEXT_UPDATE = 'dismissableLayer.update';
const $5cb92bef7577960e$var$POINTER_DOWN_OUTSIDE = 'dismissableLayer.pointerDownOutside';
const $5cb92bef7577960e$var$FOCUS_OUTSIDE = 'dismissableLayer.focusOutside';
let $5cb92bef7577960e$var$originalBodyPointerEvents;
const $5cb92bef7577960e$var$DismissableLayerContext = /*#__PURE__*/ (0,react.createContext)({
    layers: new Set(),
    layersWithOutsidePointerEventsDisabled: new Set(),
    branches: new Set()
});
const $5cb92bef7577960e$export$177fb62ff3ec1f22 = /*#__PURE__*/ (0,react.forwardRef)((props, forwardedRef)=>{
    var _node$ownerDocument;
    const { disableOutsidePointerEvents: disableOutsidePointerEvents = false , onEscapeKeyDown: onEscapeKeyDown , onPointerDownOutside: onPointerDownOutside , onFocusOutside: onFocusOutside , onInteractOutside: onInteractOutside , onDismiss: onDismiss , ...layerProps } = props;
    const context = (0,react.useContext)($5cb92bef7577960e$var$DismissableLayerContext);
    const [node1, setNode] = (0,react.useState)(null);
    const ownerDocument = (_node$ownerDocument = node1 === null || node1 === void 0 ? void 0 : node1.ownerDocument) !== null && _node$ownerDocument !== void 0 ? _node$ownerDocument : globalThis === null || globalThis === void 0 ? void 0 : globalThis.document;
    const [, force] = (0,react.useState)({});
    const composedRefs = (0,react_compose_refs_dist/* useComposedRefs */.e)(forwardedRef, (node)=>setNode(node)
    );
    const layers = Array.from(context.layers);
    const [highestLayerWithOutsidePointerEventsDisabled] = [
        ...context.layersWithOutsidePointerEventsDisabled
    ].slice(-1); // prettier-ignore
    const highestLayerWithOutsidePointerEventsDisabledIndex = layers.indexOf(highestLayerWithOutsidePointerEventsDisabled); // prettier-ignore
    const index = node1 ? layers.indexOf(node1) : -1;
    const isBodyPointerEventsDisabled = context.layersWithOutsidePointerEventsDisabled.size > 0;
    const isPointerEventsEnabled = index >= highestLayerWithOutsidePointerEventsDisabledIndex;
    const pointerDownOutside = $5cb92bef7577960e$var$usePointerDownOutside((event)=>{
        const target = event.target;
        const isPointerDownOnBranch = [
            ...context.branches
        ].some((branch)=>branch.contains(target)
        );
        if (!isPointerEventsEnabled || isPointerDownOnBranch) return;
        onPointerDownOutside === null || onPointerDownOutside === void 0 || onPointerDownOutside(event);
        onInteractOutside === null || onInteractOutside === void 0 || onInteractOutside(event);
        if (!event.defaultPrevented) onDismiss === null || onDismiss === void 0 || onDismiss();
    }, ownerDocument);
    const focusOutside = $5cb92bef7577960e$var$useFocusOutside((event)=>{
        const target = event.target;
        const isFocusInBranch = [
            ...context.branches
        ].some((branch)=>branch.contains(target)
        );
        if (isFocusInBranch) return;
        onFocusOutside === null || onFocusOutside === void 0 || onFocusOutside(event);
        onInteractOutside === null || onInteractOutside === void 0 || onInteractOutside(event);
        if (!event.defaultPrevented) onDismiss === null || onDismiss === void 0 || onDismiss();
    }, ownerDocument);
    $addc16e1bbe58fd0$export$3a72a57244d6e765((event)=>{
        const isHighestLayer = index === context.layers.size - 1;
        if (!isHighestLayer) return;
        onEscapeKeyDown === null || onEscapeKeyDown === void 0 || onEscapeKeyDown(event);
        if (!event.defaultPrevented && onDismiss) {
            event.preventDefault();
            onDismiss();
        }
    }, ownerDocument);
    (0,react.useEffect)(()=>{
        if (!node1) return;
        if (disableOutsidePointerEvents) {
            if (context.layersWithOutsidePointerEventsDisabled.size === 0) {
                $5cb92bef7577960e$var$originalBodyPointerEvents = ownerDocument.body.style.pointerEvents;
                ownerDocument.body.style.pointerEvents = 'none';
            }
            context.layersWithOutsidePointerEventsDisabled.add(node1);
        }
        context.layers.add(node1);
        $5cb92bef7577960e$var$dispatchUpdate();
        return ()=>{
            if (disableOutsidePointerEvents && context.layersWithOutsidePointerEventsDisabled.size === 1) ownerDocument.body.style.pointerEvents = $5cb92bef7577960e$var$originalBodyPointerEvents;
        };
    }, [
        node1,
        ownerDocument,
        disableOutsidePointerEvents,
        context
    ]);
    /**
   * We purposefully prevent combining this effect with the `disableOutsidePointerEvents` effect
   * because a change to `disableOutsidePointerEvents` would remove this layer from the stack
   * and add it to the end again so the layering order wouldn't be _creation order_.
   * We only want them to be removed from context stacks when unmounted.
   */ (0,react.useEffect)(()=>{
        return ()=>{
            if (!node1) return;
            context.layers.delete(node1);
            context.layersWithOutsidePointerEventsDisabled.delete(node1);
            $5cb92bef7577960e$var$dispatchUpdate();
        };
    }, [
        node1,
        context
    ]);
    (0,react.useEffect)(()=>{
        const handleUpdate = ()=>force({})
        ;
        document.addEventListener($5cb92bef7577960e$var$CONTEXT_UPDATE, handleUpdate);
        return ()=>document.removeEventListener($5cb92bef7577960e$var$CONTEXT_UPDATE, handleUpdate)
        ;
    }, []);
    return /*#__PURE__*/ (0,react.createElement)(react_primitive_dist/* Primitive.div */.WV.div, (0,esm_extends/* default */.Z)({}, layerProps, {
        ref: composedRefs,
        style: {
            pointerEvents: isBodyPointerEventsDisabled ? isPointerEventsEnabled ? 'auto' : 'none' : undefined,
            ...props.style
        },
        onFocusCapture: (0,dist/* composeEventHandlers */.M)(props.onFocusCapture, focusOutside.onFocusCapture),
        onBlurCapture: (0,dist/* composeEventHandlers */.M)(props.onBlurCapture, focusOutside.onBlurCapture),
        onPointerDownCapture: (0,dist/* composeEventHandlers */.M)(props.onPointerDownCapture, pointerDownOutside.onPointerDownCapture)
    }));
});
/*#__PURE__*/ Object.assign($5cb92bef7577960e$export$177fb62ff3ec1f22, {
    displayName: $5cb92bef7577960e$var$DISMISSABLE_LAYER_NAME
});
/* -------------------------------------------------------------------------------------------------
 * DismissableLayerBranch
 * -----------------------------------------------------------------------------------------------*/ const $5cb92bef7577960e$var$BRANCH_NAME = 'DismissableLayerBranch';
const $5cb92bef7577960e$export$4d5eb2109db14228 = /*#__PURE__*/ (0,react.forwardRef)((props, forwardedRef)=>{
    const context = (0,react.useContext)($5cb92bef7577960e$var$DismissableLayerContext);
    const ref = (0,react.useRef)(null);
    const composedRefs = (0,react_compose_refs_dist/* useComposedRefs */.e)(forwardedRef, ref);
    (0,react.useEffect)(()=>{
        const node = ref.current;
        if (node) {
            context.branches.add(node);
            return ()=>{
                context.branches.delete(node);
            };
        }
    }, [
        context.branches
    ]);
    return /*#__PURE__*/ (0,react.createElement)(react_primitive_dist/* Primitive.div */.WV.div, (0,esm_extends/* default */.Z)({}, props, {
        ref: composedRefs
    }));
});
/*#__PURE__*/ Object.assign($5cb92bef7577960e$export$4d5eb2109db14228, {
    displayName: $5cb92bef7577960e$var$BRANCH_NAME
});
/* -----------------------------------------------------------------------------------------------*/ /**
 * Listens for `pointerdown` outside a react subtree. We use `pointerdown` rather than `pointerup`
 * to mimic layer dismissing behaviour present in OS.
 * Returns props to pass to the node we want to check for outside events.
 */ function $5cb92bef7577960e$var$usePointerDownOutside(onPointerDownOutside, ownerDocument = globalThis === null || globalThis === void 0 ? void 0 : globalThis.document) {
    const handlePointerDownOutside = (0,react_use_callback_ref_dist/* useCallbackRef */.W)(onPointerDownOutside);
    const isPointerInsideReactTreeRef = (0,react.useRef)(false);
    const handleClickRef = (0,react.useRef)(()=>{});
    (0,react.useEffect)(()=>{
        const handlePointerDown = (event)=>{
            if (event.target && !isPointerInsideReactTreeRef.current) {
                const eventDetail = {
                    originalEvent: event
                };
                function handleAndDispatchPointerDownOutsideEvent() {
                    $5cb92bef7577960e$var$handleAndDispatchCustomEvent($5cb92bef7577960e$var$POINTER_DOWN_OUTSIDE, handlePointerDownOutside, eventDetail, {
                        discrete: true
                    });
                }
                /**
         * On touch devices, we need to wait for a click event because browsers implement
         * a ~350ms delay between the time the user stops touching the display and when the
         * browser executres events. We need to ensure we don't reactivate pointer-events within
         * this timeframe otherwise the browser may execute events that should have been prevented.
         *
         * Additionally, this also lets us deal automatically with cancellations when a click event
         * isn't raised because the page was considered scrolled/drag-scrolled, long-pressed, etc.
         *
         * This is why we also continuously remove the previous listener, because we cannot be
         * certain that it was raised, and therefore cleaned-up.
         */ if (event.pointerType === 'touch') {
                    ownerDocument.removeEventListener('click', handleClickRef.current);
                    handleClickRef.current = handleAndDispatchPointerDownOutsideEvent;
                    ownerDocument.addEventListener('click', handleClickRef.current, {
                        once: true
                    });
                } else handleAndDispatchPointerDownOutsideEvent();
            } else // We need to remove the event listener in case the outside click has been canceled.
            // See: https://github.com/radix-ui/primitives/issues/2171
            ownerDocument.removeEventListener('click', handleClickRef.current);
            isPointerInsideReactTreeRef.current = false;
        };
        /**
     * if this hook executes in a component that mounts via a `pointerdown` event, the event
     * would bubble up to the document and trigger a `pointerDownOutside` event. We avoid
     * this by delaying the event listener registration on the document.
     * This is not React specific, but rather how the DOM works, ie:
     * ```
     * button.addEventListener('pointerdown', () => {
     *   console.log('I will log');
     *   document.addEventListener('pointerdown', () => {
     *     console.log('I will also log');
     *   })
     * });
     */ const timerId = window.setTimeout(()=>{
            ownerDocument.addEventListener('pointerdown', handlePointerDown);
        }, 0);
        return ()=>{
            window.clearTimeout(timerId);
            ownerDocument.removeEventListener('pointerdown', handlePointerDown);
            ownerDocument.removeEventListener('click', handleClickRef.current);
        };
    }, [
        ownerDocument,
        handlePointerDownOutside
    ]);
    return {
        // ensures we check React component tree (not just DOM tree)
        onPointerDownCapture: ()=>isPointerInsideReactTreeRef.current = true
    };
}
/**
 * Listens for when focus happens outside a react subtree.
 * Returns props to pass to the root (node) of the subtree we want to check.
 */ function $5cb92bef7577960e$var$useFocusOutside(onFocusOutside, ownerDocument = globalThis === null || globalThis === void 0 ? void 0 : globalThis.document) {
    const handleFocusOutside = (0,react_use_callback_ref_dist/* useCallbackRef */.W)(onFocusOutside);
    const isFocusInsideReactTreeRef = (0,react.useRef)(false);
    (0,react.useEffect)(()=>{
        const handleFocus = (event)=>{
            if (event.target && !isFocusInsideReactTreeRef.current) {
                const eventDetail = {
                    originalEvent: event
                };
                $5cb92bef7577960e$var$handleAndDispatchCustomEvent($5cb92bef7577960e$var$FOCUS_OUTSIDE, handleFocusOutside, eventDetail, {
                    discrete: false
                });
            }
        };
        ownerDocument.addEventListener('focusin', handleFocus);
        return ()=>ownerDocument.removeEventListener('focusin', handleFocus)
        ;
    }, [
        ownerDocument,
        handleFocusOutside
    ]);
    return {
        onFocusCapture: ()=>isFocusInsideReactTreeRef.current = true
        ,
        onBlurCapture: ()=>isFocusInsideReactTreeRef.current = false
    };
}
function $5cb92bef7577960e$var$dispatchUpdate() {
    const event = new CustomEvent($5cb92bef7577960e$var$CONTEXT_UPDATE);
    document.dispatchEvent(event);
}
function $5cb92bef7577960e$var$handleAndDispatchCustomEvent(name, handler, detail, { discrete: discrete  }) {
    const target = detail.originalEvent.target;
    const event = new CustomEvent(name, {
        bubbles: false,
        cancelable: true,
        detail: detail
    });
    if (handler) target.addEventListener(name, handler, {
        once: true
    });
    if (discrete) (0,react_primitive_dist/* dispatchDiscreteCustomEvent */.jH)(target, event);
    else target.dispatchEvent(event);
}
const $5cb92bef7577960e$export$be92b6f5f03c0fe9 = $5cb92bef7577960e$export$177fb62ff3ec1f22;
const $5cb92bef7577960e$export$aecb2ddcb55c95be = $5cb92bef7577960e$export$4d5eb2109db14228;





//# sourceMappingURL=index.mjs.map


/***/ }),

/***/ 27552:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "EW": function() { return /* binding */ $3db38b7d1fb3fe6a$export$b7ece24a22aeda8c; }
/* harmony export */ });
/* unused harmony exports FocusGuards, Root */
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(55784);



/** Number of components which have requested interest to have focus guards */ let $3db38b7d1fb3fe6a$var$count = 0;
function $3db38b7d1fb3fe6a$export$ac5b58043b79449b(props) {
    $3db38b7d1fb3fe6a$export$b7ece24a22aeda8c();
    return props.children;
}
/**
 * Injects a pair of focus guards at the edges of the whole DOM tree
 * to ensure `focusin` & `focusout` events can be caught consistently.
 */ function $3db38b7d1fb3fe6a$export$b7ece24a22aeda8c() {
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(()=>{
        var _edgeGuards$, _edgeGuards$2;
        const edgeGuards = document.querySelectorAll('[data-radix-focus-guard]');
        document.body.insertAdjacentElement('afterbegin', (_edgeGuards$ = edgeGuards[0]) !== null && _edgeGuards$ !== void 0 ? _edgeGuards$ : $3db38b7d1fb3fe6a$var$createFocusGuard());
        document.body.insertAdjacentElement('beforeend', (_edgeGuards$2 = edgeGuards[1]) !== null && _edgeGuards$2 !== void 0 ? _edgeGuards$2 : $3db38b7d1fb3fe6a$var$createFocusGuard());
        $3db38b7d1fb3fe6a$var$count++;
        return ()=>{
            if ($3db38b7d1fb3fe6a$var$count === 1) document.querySelectorAll('[data-radix-focus-guard]').forEach((node)=>node.remove()
            );
            $3db38b7d1fb3fe6a$var$count--;
        };
    }, []);
}
function $3db38b7d1fb3fe6a$var$createFocusGuard() {
    const element = document.createElement('span');
    element.setAttribute('data-radix-focus-guard', '');
    element.tabIndex = 0;
    element.style.cssText = 'outline: none; opacity: 0; position: fixed; pointer-events: none';
    return element;
}
const $3db38b7d1fb3fe6a$export$be92b6f5f03c0fe9 = (/* unused pure expression or super */ null && ($3db38b7d1fb3fe6a$export$ac5b58043b79449b));





//# sourceMappingURL=index.mjs.map


/***/ }),

/***/ 95420:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "M": function() { return /* binding */ $d3863c46a17e8a28$export$20e40289641fbbb6; }
/* harmony export */ });
/* unused harmony export Root */
/* harmony import */ var _babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(87462);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(55784);
/* harmony import */ var _radix_ui_react_compose_refs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(28771);
/* harmony import */ var _radix_ui_react_primitive__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(75320);
/* harmony import */ var _radix_ui_react_use_callback_ref__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(79698);











const $d3863c46a17e8a28$var$AUTOFOCUS_ON_MOUNT = 'focusScope.autoFocusOnMount';
const $d3863c46a17e8a28$var$AUTOFOCUS_ON_UNMOUNT = 'focusScope.autoFocusOnUnmount';
const $d3863c46a17e8a28$var$EVENT_OPTIONS = {
    bubbles: false,
    cancelable: true
};
/* -------------------------------------------------------------------------------------------------
 * FocusScope
 * -----------------------------------------------------------------------------------------------*/ const $d3863c46a17e8a28$var$FOCUS_SCOPE_NAME = 'FocusScope';
const $d3863c46a17e8a28$export$20e40289641fbbb6 = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_0__.forwardRef)((props, forwardedRef)=>{
    const { loop: loop = false , trapped: trapped = false , onMountAutoFocus: onMountAutoFocusProp , onUnmountAutoFocus: onUnmountAutoFocusProp , ...scopeProps } = props;
    const [container1, setContainer] = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(null);
    const onMountAutoFocus = (0,_radix_ui_react_use_callback_ref__WEBPACK_IMPORTED_MODULE_1__/* .useCallbackRef */ .W)(onMountAutoFocusProp);
    const onUnmountAutoFocus = (0,_radix_ui_react_use_callback_ref__WEBPACK_IMPORTED_MODULE_1__/* .useCallbackRef */ .W)(onUnmountAutoFocusProp);
    const lastFocusedElementRef = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(null);
    const composedRefs = (0,_radix_ui_react_compose_refs__WEBPACK_IMPORTED_MODULE_2__/* .useComposedRefs */ .e)(forwardedRef, (node)=>setContainer(node)
    );
    const focusScope = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)({
        paused: false,
        pause () {
            this.paused = true;
        },
        resume () {
            this.paused = false;
        }
    }).current; // Takes care of trapping focus if focus is moved outside programmatically for example
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(()=>{
        if (trapped) {
            function handleFocusIn(event) {
                if (focusScope.paused || !container1) return;
                const target = event.target;
                if (container1.contains(target)) lastFocusedElementRef.current = target;
                else $d3863c46a17e8a28$var$focus(lastFocusedElementRef.current, {
                    select: true
                });
            }
            function handleFocusOut(event) {
                if (focusScope.paused || !container1) return;
                const relatedTarget = event.relatedTarget; // A `focusout` event with a `null` `relatedTarget` will happen in at least two cases:
                //
                // 1. When the user switches app/tabs/windows/the browser itself loses focus.
                // 2. In Google Chrome, when the focused element is removed from the DOM.
                //
                // We let the browser do its thing here because:
                //
                // 1. The browser already keeps a memory of what's focused for when the page gets refocused.
                // 2. In Google Chrome, if we try to focus the deleted focused element (as per below), it
                //    throws the CPU to 100%, so we avoid doing anything for this reason here too.
                if (relatedTarget === null) return; // If the focus has moved to an actual legitimate element (`relatedTarget !== null`)
                // that is outside the container, we move focus to the last valid focused element inside.
                if (!container1.contains(relatedTarget)) $d3863c46a17e8a28$var$focus(lastFocusedElementRef.current, {
                    select: true
                });
            } // When the focused element gets removed from the DOM, browsers move focus
            // back to the document.body. In this case, we move focus to the container
            // to keep focus trapped correctly.
            function handleMutations(mutations) {
                const focusedElement = document.activeElement;
                if (focusedElement !== document.body) return;
                for (const mutation of mutations)if (mutation.removedNodes.length > 0) $d3863c46a17e8a28$var$focus(container1);
            }
            document.addEventListener('focusin', handleFocusIn);
            document.addEventListener('focusout', handleFocusOut);
            const mutationObserver = new MutationObserver(handleMutations);
            if (container1) mutationObserver.observe(container1, {
                childList: true,
                subtree: true
            });
            return ()=>{
                document.removeEventListener('focusin', handleFocusIn);
                document.removeEventListener('focusout', handleFocusOut);
                mutationObserver.disconnect();
            };
        }
    }, [
        trapped,
        container1,
        focusScope.paused
    ]);
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(()=>{
        if (container1) {
            $d3863c46a17e8a28$var$focusScopesStack.add(focusScope);
            const previouslyFocusedElement = document.activeElement;
            const hasFocusedCandidate = container1.contains(previouslyFocusedElement);
            if (!hasFocusedCandidate) {
                const mountEvent = new CustomEvent($d3863c46a17e8a28$var$AUTOFOCUS_ON_MOUNT, $d3863c46a17e8a28$var$EVENT_OPTIONS);
                container1.addEventListener($d3863c46a17e8a28$var$AUTOFOCUS_ON_MOUNT, onMountAutoFocus);
                container1.dispatchEvent(mountEvent);
                if (!mountEvent.defaultPrevented) {
                    $d3863c46a17e8a28$var$focusFirst($d3863c46a17e8a28$var$removeLinks($d3863c46a17e8a28$var$getTabbableCandidates(container1)), {
                        select: true
                    });
                    if (document.activeElement === previouslyFocusedElement) $d3863c46a17e8a28$var$focus(container1);
                }
            }
            return ()=>{
                container1.removeEventListener($d3863c46a17e8a28$var$AUTOFOCUS_ON_MOUNT, onMountAutoFocus); // We hit a react bug (fixed in v17) with focusing in unmount.
                // We need to delay the focus a little to get around it for now.
                // See: https://github.com/facebook/react/issues/17894
                setTimeout(()=>{
                    const unmountEvent = new CustomEvent($d3863c46a17e8a28$var$AUTOFOCUS_ON_UNMOUNT, $d3863c46a17e8a28$var$EVENT_OPTIONS);
                    container1.addEventListener($d3863c46a17e8a28$var$AUTOFOCUS_ON_UNMOUNT, onUnmountAutoFocus);
                    container1.dispatchEvent(unmountEvent);
                    if (!unmountEvent.defaultPrevented) $d3863c46a17e8a28$var$focus(previouslyFocusedElement !== null && previouslyFocusedElement !== void 0 ? previouslyFocusedElement : document.body, {
                        select: true
                    });
                     // we need to remove the listener after we `dispatchEvent`
                    container1.removeEventListener($d3863c46a17e8a28$var$AUTOFOCUS_ON_UNMOUNT, onUnmountAutoFocus);
                    $d3863c46a17e8a28$var$focusScopesStack.remove(focusScope);
                }, 0);
            };
        }
    }, [
        container1,
        onMountAutoFocus,
        onUnmountAutoFocus,
        focusScope
    ]); // Takes care of looping focus (when tabbing whilst at the edges)
    const handleKeyDown = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)((event)=>{
        if (!loop && !trapped) return;
        if (focusScope.paused) return;
        const isTabKey = event.key === 'Tab' && !event.altKey && !event.ctrlKey && !event.metaKey;
        const focusedElement = document.activeElement;
        if (isTabKey && focusedElement) {
            const container = event.currentTarget;
            const [first, last] = $d3863c46a17e8a28$var$getTabbableEdges(container);
            const hasTabbableElementsInside = first && last; // we can only wrap focus if we have tabbable edges
            if (!hasTabbableElementsInside) {
                if (focusedElement === container) event.preventDefault();
            } else {
                if (!event.shiftKey && focusedElement === last) {
                    event.preventDefault();
                    if (loop) $d3863c46a17e8a28$var$focus(first, {
                        select: true
                    });
                } else if (event.shiftKey && focusedElement === first) {
                    event.preventDefault();
                    if (loop) $d3863c46a17e8a28$var$focus(last, {
                        select: true
                    });
                }
            }
        }
    }, [
        loop,
        trapped,
        focusScope.paused
    ]);
    return /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_0__.createElement)(_radix_ui_react_primitive__WEBPACK_IMPORTED_MODULE_3__/* .Primitive.div */ .WV.div, (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({
        tabIndex: -1
    }, scopeProps, {
        ref: composedRefs,
        onKeyDown: handleKeyDown
    }));
});
/*#__PURE__*/ Object.assign($d3863c46a17e8a28$export$20e40289641fbbb6, {
    displayName: $d3863c46a17e8a28$var$FOCUS_SCOPE_NAME
});
/* -------------------------------------------------------------------------------------------------
 * Utils
 * -----------------------------------------------------------------------------------------------*/ /**
 * Attempts focusing the first element in a list of candidates.
 * Stops when focus has actually moved.
 */ function $d3863c46a17e8a28$var$focusFirst(candidates, { select: select = false  } = {}) {
    const previouslyFocusedElement = document.activeElement;
    for (const candidate of candidates){
        $d3863c46a17e8a28$var$focus(candidate, {
            select: select
        });
        if (document.activeElement !== previouslyFocusedElement) return;
    }
}
/**
 * Returns the first and last tabbable elements inside a container.
 */ function $d3863c46a17e8a28$var$getTabbableEdges(container) {
    const candidates = $d3863c46a17e8a28$var$getTabbableCandidates(container);
    const first = $d3863c46a17e8a28$var$findVisible(candidates, container);
    const last = $d3863c46a17e8a28$var$findVisible(candidates.reverse(), container);
    return [
        first,
        last
    ];
}
/**
 * Returns a list of potential tabbable candidates.
 *
 * NOTE: This is only a close approximation. For example it doesn't take into account cases like when
 * elements are not visible. This cannot be worked out easily by just reading a property, but rather
 * necessitate runtime knowledge (computed styles, etc). We deal with these cases separately.
 *
 * See: https://developer.mozilla.org/en-US/docs/Web/API/TreeWalker
 * Credit: https://github.com/discord/focus-layers/blob/master/src/util/wrapFocus.tsx#L1
 */ function $d3863c46a17e8a28$var$getTabbableCandidates(container) {
    const nodes = [];
    const walker = document.createTreeWalker(container, NodeFilter.SHOW_ELEMENT, {
        acceptNode: (node)=>{
            const isHiddenInput = node.tagName === 'INPUT' && node.type === 'hidden';
            if (node.disabled || node.hidden || isHiddenInput) return NodeFilter.FILTER_SKIP; // `.tabIndex` is not the same as the `tabindex` attribute. It works on the
            // runtime's understanding of tabbability, so this automatically accounts
            // for any kind of element that could be tabbed to.
            return node.tabIndex >= 0 ? NodeFilter.FILTER_ACCEPT : NodeFilter.FILTER_SKIP;
        }
    });
    while(walker.nextNode())nodes.push(walker.currentNode); // we do not take into account the order of nodes with positive `tabIndex` as it
    // hinders accessibility to have tab order different from visual order.
    return nodes;
}
/**
 * Returns the first visible element in a list.
 * NOTE: Only checks visibility up to the `container`.
 */ function $d3863c46a17e8a28$var$findVisible(elements, container) {
    for (const element of elements){
        // we stop checking if it's hidden at the `container` level (excluding)
        if (!$d3863c46a17e8a28$var$isHidden(element, {
            upTo: container
        })) return element;
    }
}
function $d3863c46a17e8a28$var$isHidden(node, { upTo: upTo  }) {
    if (getComputedStyle(node).visibility === 'hidden') return true;
    while(node){
        // we stop at `upTo` (excluding it)
        if (upTo !== undefined && node === upTo) return false;
        if (getComputedStyle(node).display === 'none') return true;
        node = node.parentElement;
    }
    return false;
}
function $d3863c46a17e8a28$var$isSelectableInput(element) {
    return element instanceof HTMLInputElement && 'select' in element;
}
function $d3863c46a17e8a28$var$focus(element, { select: select = false  } = {}) {
    // only focus if that element is focusable
    if (element && element.focus) {
        const previouslyFocusedElement = document.activeElement; // NOTE: we prevent scrolling on focus, to minimize jarring transitions for users
        element.focus({
            preventScroll: true
        }); // only select if its not the same element, it supports selection and we need to select
        if (element !== previouslyFocusedElement && $d3863c46a17e8a28$var$isSelectableInput(element) && select) element.select();
    }
}
/* -------------------------------------------------------------------------------------------------
 * FocusScope stack
 * -----------------------------------------------------------------------------------------------*/ const $d3863c46a17e8a28$var$focusScopesStack = $d3863c46a17e8a28$var$createFocusScopesStack();
function $d3863c46a17e8a28$var$createFocusScopesStack() {
    /** A stack of focus scopes, with the active one at the top */ let stack = [];
    return {
        add (focusScope) {
            // pause the currently active focus scope (at the top of the stack)
            const activeFocusScope = stack[0];
            if (focusScope !== activeFocusScope) activeFocusScope === null || activeFocusScope === void 0 || activeFocusScope.pause();
             // remove in case it already exists (because we'll re-add it at the top of the stack)
            stack = $d3863c46a17e8a28$var$arrayRemove(stack, focusScope);
            stack.unshift(focusScope);
        },
        remove (focusScope) {
            var _stack$;
            stack = $d3863c46a17e8a28$var$arrayRemove(stack, focusScope);
            (_stack$ = stack[0]) === null || _stack$ === void 0 || _stack$.resume();
        }
    };
}
function $d3863c46a17e8a28$var$arrayRemove(array, item) {
    const updatedArray = [
        ...array
    ];
    const index = updatedArray.indexOf(item);
    if (index !== -1) updatedArray.splice(index, 1);
    return updatedArray;
}
function $d3863c46a17e8a28$var$removeLinks(items) {
    return items.filter((item)=>item.tagName !== 'A'
    );
}
const $d3863c46a17e8a28$export$be92b6f5f03c0fe9 = (/* unused pure expression or super */ null && ($d3863c46a17e8a28$export$20e40289641fbbb6));





//# sourceMappingURL=index.mjs.map


/***/ }),

/***/ 91276:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
var react__WEBPACK_IMPORTED_MODULE_0___namespace_cache;
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "M": function() { return /* binding */ $1746a345f3d73bb7$export$f680877a34711e37; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(55784);
/* harmony import */ var _radix_ui_react_use_layout_effect__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(9981);





const $1746a345f3d73bb7$var$useReactId = /*#__PURE__*/ (react__WEBPACK_IMPORTED_MODULE_0___namespace_cache || (react__WEBPACK_IMPORTED_MODULE_0___namespace_cache = __webpack_require__.t(react__WEBPACK_IMPORTED_MODULE_0__, 2)))['useId'.toString()] || (()=>undefined
);
let $1746a345f3d73bb7$var$count = 0;
function $1746a345f3d73bb7$export$f680877a34711e37(deterministicId) {
    const [id, setId] = react__WEBPACK_IMPORTED_MODULE_0__.useState($1746a345f3d73bb7$var$useReactId()); // React versions older than 18 will have client-side ids only.
    (0,_radix_ui_react_use_layout_effect__WEBPACK_IMPORTED_MODULE_1__/* .useLayoutEffect */ .b)(()=>{
        if (!deterministicId) setId((reactId)=>reactId !== null && reactId !== void 0 ? reactId : String($1746a345f3d73bb7$var$count++)
        );
    }, [
        deterministicId
    ]);
    return deterministicId || (id ? `radix-${id}` : '');
}





//# sourceMappingURL=index.mjs.map


/***/ }),

/***/ 6565:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "ee": function() { return /* binding */ $cf1ac5d9fe0e8206$export$b688253958b8dfe7; },
  "Eh": function() { return /* binding */ $cf1ac5d9fe0e8206$export$21b07c8f274aebd5; },
  "VY": function() { return /* binding */ $cf1ac5d9fe0e8206$export$7c6e2c02157bb7d2; },
  "fC": function() { return /* binding */ $cf1ac5d9fe0e8206$export$be92b6f5f03c0fe9; },
  "D7": function() { return /* binding */ $cf1ac5d9fe0e8206$export$722aac194ae923; }
});

// UNUSED EXPORTS: ALIGN_OPTIONS, Popper, PopperAnchor, PopperArrow, PopperContent, SIDE_OPTIONS

// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__(87462);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/react/index.js
var react = __webpack_require__(55784);
;// CONCATENATED MODULE: ./node_modules/@floating-ui/utils/dist/floating-ui.utils.mjs
const sides = ['top', 'right', 'bottom', 'left'];
const alignments = (/* unused pure expression or super */ null && (['start', 'end']));
const floating_ui_utils_placements = /*#__PURE__*/(/* unused pure expression or super */ null && (sides.reduce((acc, side) => acc.concat(side, side + "-" + alignments[0], side + "-" + alignments[1]), [])));
const floating_ui_utils_min = Math.min;
const floating_ui_utils_max = Math.max;
const round = Math.round;
const floor = Math.floor;
const createCoords = v => ({
  x: v,
  y: v
});
const oppositeSideMap = {
  left: 'right',
  right: 'left',
  bottom: 'top',
  top: 'bottom'
};
const oppositeAlignmentMap = {
  start: 'end',
  end: 'start'
};
function clamp(start, value, end) {
  return floating_ui_utils_max(start, floating_ui_utils_min(value, end));
}
function floating_ui_utils_evaluate(value, param) {
  return typeof value === 'function' ? value(param) : value;
}
function floating_ui_utils_getSide(placement) {
  return placement.split('-')[0];
}
function floating_ui_utils_getAlignment(placement) {
  return placement.split('-')[1];
}
function getOppositeAxis(axis) {
  return axis === 'x' ? 'y' : 'x';
}
function getAxisLength(axis) {
  return axis === 'y' ? 'height' : 'width';
}
function floating_ui_utils_getSideAxis(placement) {
  return ['top', 'bottom'].includes(floating_ui_utils_getSide(placement)) ? 'y' : 'x';
}
function getAlignmentAxis(placement) {
  return getOppositeAxis(floating_ui_utils_getSideAxis(placement));
}
function floating_ui_utils_getAlignmentSides(placement, rects, rtl) {
  if (rtl === void 0) {
    rtl = false;
  }
  const alignment = floating_ui_utils_getAlignment(placement);
  const alignmentAxis = getAlignmentAxis(placement);
  const length = getAxisLength(alignmentAxis);
  let mainAlignmentSide = alignmentAxis === 'x' ? alignment === (rtl ? 'end' : 'start') ? 'right' : 'left' : alignment === 'start' ? 'bottom' : 'top';
  if (rects.reference[length] > rects.floating[length]) {
    mainAlignmentSide = getOppositePlacement(mainAlignmentSide);
  }
  return [mainAlignmentSide, getOppositePlacement(mainAlignmentSide)];
}
function getExpandedPlacements(placement) {
  const oppositePlacement = getOppositePlacement(placement);
  return [floating_ui_utils_getOppositeAlignmentPlacement(placement), oppositePlacement, floating_ui_utils_getOppositeAlignmentPlacement(oppositePlacement)];
}
function floating_ui_utils_getOppositeAlignmentPlacement(placement) {
  return placement.replace(/start|end/g, alignment => oppositeAlignmentMap[alignment]);
}
function getSideList(side, isStart, rtl) {
  const lr = ['left', 'right'];
  const rl = ['right', 'left'];
  const tb = ['top', 'bottom'];
  const bt = ['bottom', 'top'];
  switch (side) {
    case 'top':
    case 'bottom':
      if (rtl) return isStart ? rl : lr;
      return isStart ? lr : rl;
    case 'left':
    case 'right':
      return isStart ? tb : bt;
    default:
      return [];
  }
}
function getOppositeAxisPlacements(placement, flipAlignment, direction, rtl) {
  const alignment = floating_ui_utils_getAlignment(placement);
  let list = getSideList(floating_ui_utils_getSide(placement), direction === 'start', rtl);
  if (alignment) {
    list = list.map(side => side + "-" + alignment);
    if (flipAlignment) {
      list = list.concat(list.map(floating_ui_utils_getOppositeAlignmentPlacement));
    }
  }
  return list;
}
function getOppositePlacement(placement) {
  return placement.replace(/left|right|bottom|top/g, side => oppositeSideMap[side]);
}
function expandPaddingObject(padding) {
  return {
    top: 0,
    right: 0,
    bottom: 0,
    left: 0,
    ...padding
  };
}
function floating_ui_utils_getPaddingObject(padding) {
  return typeof padding !== 'number' ? expandPaddingObject(padding) : {
    top: padding,
    right: padding,
    bottom: padding,
    left: padding
  };
}
function floating_ui_utils_rectToClientRect(rect) {
  return {
    ...rect,
    top: rect.y,
    left: rect.x,
    right: rect.x + rect.width,
    bottom: rect.y + rect.height
  };
}



;// CONCATENATED MODULE: ./node_modules/@floating-ui/react-dom/node_modules/@floating-ui/core/dist/floating-ui.core.mjs



function computeCoordsFromPlacement(_ref, placement, rtl) {
  let {
    reference,
    floating
  } = _ref;
  const sideAxis = floating_ui_utils_getSideAxis(placement);
  const alignmentAxis = getAlignmentAxis(placement);
  const alignLength = getAxisLength(alignmentAxis);
  const side = floating_ui_utils_getSide(placement);
  const isVertical = sideAxis === 'y';
  const commonX = reference.x + reference.width / 2 - floating.width / 2;
  const commonY = reference.y + reference.height / 2 - floating.height / 2;
  const commonAlign = reference[alignLength] / 2 - floating[alignLength] / 2;
  let coords;
  switch (side) {
    case 'top':
      coords = {
        x: commonX,
        y: reference.y - floating.height
      };
      break;
    case 'bottom':
      coords = {
        x: commonX,
        y: reference.y + reference.height
      };
      break;
    case 'right':
      coords = {
        x: reference.x + reference.width,
        y: commonY
      };
      break;
    case 'left':
      coords = {
        x: reference.x - floating.width,
        y: commonY
      };
      break;
    default:
      coords = {
        x: reference.x,
        y: reference.y
      };
  }
  switch (floating_ui_utils_getAlignment(placement)) {
    case 'start':
      coords[alignmentAxis] -= commonAlign * (rtl && isVertical ? -1 : 1);
      break;
    case 'end':
      coords[alignmentAxis] += commonAlign * (rtl && isVertical ? -1 : 1);
      break;
  }
  return coords;
}

/**
 * Computes the `x` and `y` coordinates that will place the floating element
 * next to a reference element when it is given a certain positioning strategy.
 *
 * This export does not have any `platform` interface logic. You will need to
 * write one for the platform you are using Floating UI with.
 */
const computePosition = async (reference, floating, config) => {
  const {
    placement = 'bottom',
    strategy = 'absolute',
    middleware = [],
    platform
  } = config;
  const validMiddleware = middleware.filter(Boolean);
  const rtl = await (platform.isRTL == null ? void 0 : platform.isRTL(floating));
  let rects = await platform.getElementRects({
    reference,
    floating,
    strategy
  });
  let {
    x,
    y
  } = computeCoordsFromPlacement(rects, placement, rtl);
  let statefulPlacement = placement;
  let middlewareData = {};
  let resetCount = 0;
  for (let i = 0; i < validMiddleware.length; i++) {
    const {
      name,
      fn
    } = validMiddleware[i];
    const {
      x: nextX,
      y: nextY,
      data,
      reset
    } = await fn({
      x,
      y,
      initialPlacement: placement,
      placement: statefulPlacement,
      strategy,
      middlewareData,
      rects,
      platform,
      elements: {
        reference,
        floating
      }
    });
    x = nextX != null ? nextX : x;
    y = nextY != null ? nextY : y;
    middlewareData = {
      ...middlewareData,
      [name]: {
        ...middlewareData[name],
        ...data
      }
    };
    if (reset && resetCount <= 50) {
      resetCount++;
      if (typeof reset === 'object') {
        if (reset.placement) {
          statefulPlacement = reset.placement;
        }
        if (reset.rects) {
          rects = reset.rects === true ? await platform.getElementRects({
            reference,
            floating,
            strategy
          }) : reset.rects;
        }
        ({
          x,
          y
        } = computeCoordsFromPlacement(rects, statefulPlacement, rtl));
      }
      i = -1;
      continue;
    }
  }
  return {
    x,
    y,
    placement: statefulPlacement,
    strategy,
    middlewareData
  };
};

/**
 * Resolves with an object of overflow side offsets that determine how much the
 * element is overflowing a given clipping boundary on each side.
 * - positive = overflowing the boundary by that number of pixels
 * - negative = how many pixels left before it will overflow
 * - 0 = lies flush with the boundary
 * @see https://floating-ui.com/docs/detectOverflow
 */
async function detectOverflow(state, options) {
  var _await$platform$isEle;
  if (options === void 0) {
    options = {};
  }
  const {
    x,
    y,
    platform,
    rects,
    elements,
    strategy
  } = state;
  const {
    boundary = 'clippingAncestors',
    rootBoundary = 'viewport',
    elementContext = 'floating',
    altBoundary = false,
    padding = 0
  } = floating_ui_utils_evaluate(options, state);
  const paddingObject = floating_ui_utils_getPaddingObject(padding);
  const altContext = elementContext === 'floating' ? 'reference' : 'floating';
  const element = elements[altBoundary ? altContext : elementContext];
  const clippingClientRect = floating_ui_utils_rectToClientRect(await platform.getClippingRect({
    element: ((_await$platform$isEle = await (platform.isElement == null ? void 0 : platform.isElement(element))) != null ? _await$platform$isEle : true) ? element : element.contextElement || (await (platform.getDocumentElement == null ? void 0 : platform.getDocumentElement(elements.floating))),
    boundary,
    rootBoundary,
    strategy
  }));
  const rect = elementContext === 'floating' ? {
    ...rects.floating,
    x,
    y
  } : rects.reference;
  const offsetParent = await (platform.getOffsetParent == null ? void 0 : platform.getOffsetParent(elements.floating));
  const offsetScale = (await (platform.isElement == null ? void 0 : platform.isElement(offsetParent))) ? (await (platform.getScale == null ? void 0 : platform.getScale(offsetParent))) || {
    x: 1,
    y: 1
  } : {
    x: 1,
    y: 1
  };
  const elementClientRect = floating_ui_utils_rectToClientRect(platform.convertOffsetParentRelativeRectToViewportRelativeRect ? await platform.convertOffsetParentRelativeRectToViewportRelativeRect({
    rect,
    offsetParent,
    strategy
  }) : rect);
  return {
    top: (clippingClientRect.top - elementClientRect.top + paddingObject.top) / offsetScale.y,
    bottom: (elementClientRect.bottom - clippingClientRect.bottom + paddingObject.bottom) / offsetScale.y,
    left: (clippingClientRect.left - elementClientRect.left + paddingObject.left) / offsetScale.x,
    right: (elementClientRect.right - clippingClientRect.right + paddingObject.right) / offsetScale.x
  };
}

/**
 * Provides data to position an inner element of the floating element so that it
 * appears centered to the reference element.
 * @see https://floating-ui.com/docs/arrow
 */
const arrow = options => ({
  name: 'arrow',
  options,
  async fn(state) {
    const {
      x,
      y,
      placement,
      rects,
      platform,
      elements,
      middlewareData
    } = state;
    // Since `element` is required, we don't Partial<> the type.
    const {
      element,
      padding = 0
    } = floating_ui_utils_evaluate(options, state) || {};
    if (element == null) {
      return {};
    }
    const paddingObject = floating_ui_utils_getPaddingObject(padding);
    const coords = {
      x,
      y
    };
    const axis = getAlignmentAxis(placement);
    const length = getAxisLength(axis);
    const arrowDimensions = await platform.getDimensions(element);
    const isYAxis = axis === 'y';
    const minProp = isYAxis ? 'top' : 'left';
    const maxProp = isYAxis ? 'bottom' : 'right';
    const clientProp = isYAxis ? 'clientHeight' : 'clientWidth';
    const endDiff = rects.reference[length] + rects.reference[axis] - coords[axis] - rects.floating[length];
    const startDiff = coords[axis] - rects.reference[axis];
    const arrowOffsetParent = await (platform.getOffsetParent == null ? void 0 : platform.getOffsetParent(element));
    let clientSize = arrowOffsetParent ? arrowOffsetParent[clientProp] : 0;

    // DOM platform can return `window` as the `offsetParent`.
    if (!clientSize || !(await (platform.isElement == null ? void 0 : platform.isElement(arrowOffsetParent)))) {
      clientSize = elements.floating[clientProp] || rects.floating[length];
    }
    const centerToReference = endDiff / 2 - startDiff / 2;

    // If the padding is large enough that it causes the arrow to no longer be
    // centered, modify the padding so that it is centered.
    const largestPossiblePadding = clientSize / 2 - arrowDimensions[length] / 2 - 1;
    const minPadding = floating_ui_utils_min(paddingObject[minProp], largestPossiblePadding);
    const maxPadding = floating_ui_utils_min(paddingObject[maxProp], largestPossiblePadding);

    // Make sure the arrow doesn't overflow the floating element if the center
    // point is outside the floating element's bounds.
    const min$1 = minPadding;
    const max = clientSize - arrowDimensions[length] - maxPadding;
    const center = clientSize / 2 - arrowDimensions[length] / 2 + centerToReference;
    const offset = clamp(min$1, center, max);

    // If the reference is small enough that the arrow's padding causes it to
    // to point to nothing for an aligned placement, adjust the offset of the
    // floating element itself. To ensure `shift()` continues to take action,
    // a single reset is performed when this is true.
    const shouldAddOffset = !middlewareData.arrow && floating_ui_utils_getAlignment(placement) != null && center != offset && rects.reference[length] / 2 - (center < min$1 ? minPadding : maxPadding) - arrowDimensions[length] / 2 < 0;
    const alignmentOffset = shouldAddOffset ? center < min$1 ? center - min$1 : center - max : 0;
    return {
      [axis]: coords[axis] + alignmentOffset,
      data: {
        [axis]: offset,
        centerOffset: center - offset - alignmentOffset,
        ...(shouldAddOffset && {
          alignmentOffset
        })
      },
      reset: shouldAddOffset
    };
  }
});

function getPlacementList(alignment, autoAlignment, allowedPlacements) {
  const allowedPlacementsSortedByAlignment = alignment ? [...allowedPlacements.filter(placement => getAlignment(placement) === alignment), ...allowedPlacements.filter(placement => getAlignment(placement) !== alignment)] : allowedPlacements.filter(placement => getSide(placement) === placement);
  return allowedPlacementsSortedByAlignment.filter(placement => {
    if (alignment) {
      return getAlignment(placement) === alignment || (autoAlignment ? getOppositeAlignmentPlacement(placement) !== placement : false);
    }
    return true;
  });
}
/**
 * Optimizes the visibility of the floating element by choosing the placement
 * that has the most space available automatically, without needing to specify a
 * preferred placement. Alternative to `flip`.
 * @see https://floating-ui.com/docs/autoPlacement
 */
const autoPlacement = function (options) {
  if (options === void 0) {
    options = {};
  }
  return {
    name: 'autoPlacement',
    options,
    async fn(state) {
      var _middlewareData$autoP, _middlewareData$autoP2, _placementsThatFitOnE;
      const {
        rects,
        middlewareData,
        placement,
        platform,
        elements
      } = state;
      const {
        crossAxis = false,
        alignment,
        allowedPlacements = placements,
        autoAlignment = true,
        ...detectOverflowOptions
      } = evaluate(options, state);
      const placements$1 = alignment !== undefined || allowedPlacements === placements ? getPlacementList(alignment || null, autoAlignment, allowedPlacements) : allowedPlacements;
      const overflow = await detectOverflow(state, detectOverflowOptions);
      const currentIndex = ((_middlewareData$autoP = middlewareData.autoPlacement) == null ? void 0 : _middlewareData$autoP.index) || 0;
      const currentPlacement = placements$1[currentIndex];
      if (currentPlacement == null) {
        return {};
      }
      const alignmentSides = getAlignmentSides(currentPlacement, rects, await (platform.isRTL == null ? void 0 : platform.isRTL(elements.floating)));

      // Make `computeCoords` start from the right place.
      if (placement !== currentPlacement) {
        return {
          reset: {
            placement: placements$1[0]
          }
        };
      }
      const currentOverflows = [overflow[getSide(currentPlacement)], overflow[alignmentSides[0]], overflow[alignmentSides[1]]];
      const allOverflows = [...(((_middlewareData$autoP2 = middlewareData.autoPlacement) == null ? void 0 : _middlewareData$autoP2.overflows) || []), {
        placement: currentPlacement,
        overflows: currentOverflows
      }];
      const nextPlacement = placements$1[currentIndex + 1];

      // There are more placements to check.
      if (nextPlacement) {
        return {
          data: {
            index: currentIndex + 1,
            overflows: allOverflows
          },
          reset: {
            placement: nextPlacement
          }
        };
      }
      const placementsSortedByMostSpace = allOverflows.map(d => {
        const alignment = getAlignment(d.placement);
        return [d.placement, alignment && crossAxis ?
        // Check along the mainAxis and main crossAxis side.
        d.overflows.slice(0, 2).reduce((acc, v) => acc + v, 0) :
        // Check only the mainAxis.
        d.overflows[0], d.overflows];
      }).sort((a, b) => a[1] - b[1]);
      const placementsThatFitOnEachSide = placementsSortedByMostSpace.filter(d => d[2].slice(0,
      // Aligned placements should not check their opposite crossAxis
      // side.
      getAlignment(d[0]) ? 2 : 3).every(v => v <= 0));
      const resetPlacement = ((_placementsThatFitOnE = placementsThatFitOnEachSide[0]) == null ? void 0 : _placementsThatFitOnE[0]) || placementsSortedByMostSpace[0][0];
      if (resetPlacement !== placement) {
        return {
          data: {
            index: currentIndex + 1,
            overflows: allOverflows
          },
          reset: {
            placement: resetPlacement
          }
        };
      }
      return {};
    }
  };
};

/**
 * Optimizes the visibility of the floating element by flipping the `placement`
 * in order to keep it in view when the preferred placement(s) will overflow the
 * clipping boundary. Alternative to `autoPlacement`.
 * @see https://floating-ui.com/docs/flip
 */
const flip = function (options) {
  if (options === void 0) {
    options = {};
  }
  return {
    name: 'flip',
    options,
    async fn(state) {
      var _middlewareData$arrow, _middlewareData$flip;
      const {
        placement,
        middlewareData,
        rects,
        initialPlacement,
        platform,
        elements
      } = state;
      const {
        mainAxis: checkMainAxis = true,
        crossAxis: checkCrossAxis = true,
        fallbackPlacements: specifiedFallbackPlacements,
        fallbackStrategy = 'bestFit',
        fallbackAxisSideDirection = 'none',
        flipAlignment = true,
        ...detectOverflowOptions
      } = floating_ui_utils_evaluate(options, state);

      // If a reset by the arrow was caused due to an alignment offset being
      // added, we should skip any logic now since `flip()` has already done its
      // work.
      // https://github.com/floating-ui/floating-ui/issues/2549#issuecomment-1719601643
      if ((_middlewareData$arrow = middlewareData.arrow) != null && _middlewareData$arrow.alignmentOffset) {
        return {};
      }
      const side = floating_ui_utils_getSide(placement);
      const isBasePlacement = floating_ui_utils_getSide(initialPlacement) === initialPlacement;
      const rtl = await (platform.isRTL == null ? void 0 : platform.isRTL(elements.floating));
      const fallbackPlacements = specifiedFallbackPlacements || (isBasePlacement || !flipAlignment ? [getOppositePlacement(initialPlacement)] : getExpandedPlacements(initialPlacement));
      if (!specifiedFallbackPlacements && fallbackAxisSideDirection !== 'none') {
        fallbackPlacements.push(...getOppositeAxisPlacements(initialPlacement, flipAlignment, fallbackAxisSideDirection, rtl));
      }
      const placements = [initialPlacement, ...fallbackPlacements];
      const overflow = await detectOverflow(state, detectOverflowOptions);
      const overflows = [];
      let overflowsData = ((_middlewareData$flip = middlewareData.flip) == null ? void 0 : _middlewareData$flip.overflows) || [];
      if (checkMainAxis) {
        overflows.push(overflow[side]);
      }
      if (checkCrossAxis) {
        const sides = floating_ui_utils_getAlignmentSides(placement, rects, rtl);
        overflows.push(overflow[sides[0]], overflow[sides[1]]);
      }
      overflowsData = [...overflowsData, {
        placement,
        overflows
      }];

      // One or more sides is overflowing.
      if (!overflows.every(side => side <= 0)) {
        var _middlewareData$flip2, _overflowsData$filter;
        const nextIndex = (((_middlewareData$flip2 = middlewareData.flip) == null ? void 0 : _middlewareData$flip2.index) || 0) + 1;
        const nextPlacement = placements[nextIndex];
        if (nextPlacement) {
          // Try next placement and re-run the lifecycle.
          return {
            data: {
              index: nextIndex,
              overflows: overflowsData
            },
            reset: {
              placement: nextPlacement
            }
          };
        }

        // First, find the candidates that fit on the mainAxis side of overflow,
        // then find the placement that fits the best on the main crossAxis side.
        let resetPlacement = (_overflowsData$filter = overflowsData.filter(d => d.overflows[0] <= 0).sort((a, b) => a.overflows[1] - b.overflows[1])[0]) == null ? void 0 : _overflowsData$filter.placement;

        // Otherwise fallback.
        if (!resetPlacement) {
          switch (fallbackStrategy) {
            case 'bestFit':
              {
                var _overflowsData$map$so;
                const placement = (_overflowsData$map$so = overflowsData.map(d => [d.placement, d.overflows.filter(overflow => overflow > 0).reduce((acc, overflow) => acc + overflow, 0)]).sort((a, b) => a[1] - b[1])[0]) == null ? void 0 : _overflowsData$map$so[0];
                if (placement) {
                  resetPlacement = placement;
                }
                break;
              }
            case 'initialPlacement':
              resetPlacement = initialPlacement;
              break;
          }
        }
        if (placement !== resetPlacement) {
          return {
            reset: {
              placement: resetPlacement
            }
          };
        }
      }
      return {};
    }
  };
};

function getSideOffsets(overflow, rect) {
  return {
    top: overflow.top - rect.height,
    right: overflow.right - rect.width,
    bottom: overflow.bottom - rect.height,
    left: overflow.left - rect.width
  };
}
function isAnySideFullyClipped(overflow) {
  return sides.some(side => overflow[side] >= 0);
}
/**
 * Provides data to hide the floating element in applicable situations, such as
 * when it is not in the same clipping context as the reference element.
 * @see https://floating-ui.com/docs/hide
 */
const hide = function (options) {
  if (options === void 0) {
    options = {};
  }
  return {
    name: 'hide',
    options,
    async fn(state) {
      const {
        rects
      } = state;
      const {
        strategy = 'referenceHidden',
        ...detectOverflowOptions
      } = floating_ui_utils_evaluate(options, state);
      switch (strategy) {
        case 'referenceHidden':
          {
            const overflow = await detectOverflow(state, {
              ...detectOverflowOptions,
              elementContext: 'reference'
            });
            const offsets = getSideOffsets(overflow, rects.reference);
            return {
              data: {
                referenceHiddenOffsets: offsets,
                referenceHidden: isAnySideFullyClipped(offsets)
              }
            };
          }
        case 'escaped':
          {
            const overflow = await detectOverflow(state, {
              ...detectOverflowOptions,
              altBoundary: true
            });
            const offsets = getSideOffsets(overflow, rects.floating);
            return {
              data: {
                escapedOffsets: offsets,
                escaped: isAnySideFullyClipped(offsets)
              }
            };
          }
        default:
          {
            return {};
          }
      }
    }
  };
};

function getBoundingRect(rects) {
  const minX = min(...rects.map(rect => rect.left));
  const minY = min(...rects.map(rect => rect.top));
  const maxX = max(...rects.map(rect => rect.right));
  const maxY = max(...rects.map(rect => rect.bottom));
  return {
    x: minX,
    y: minY,
    width: maxX - minX,
    height: maxY - minY
  };
}
function getRectsByLine(rects) {
  const sortedRects = rects.slice().sort((a, b) => a.y - b.y);
  const groups = [];
  let prevRect = null;
  for (let i = 0; i < sortedRects.length; i++) {
    const rect = sortedRects[i];
    if (!prevRect || rect.y - prevRect.y > prevRect.height / 2) {
      groups.push([rect]);
    } else {
      groups[groups.length - 1].push(rect);
    }
    prevRect = rect;
  }
  return groups.map(rect => rectToClientRect(getBoundingRect(rect)));
}
/**
 * Provides improved positioning for inline reference elements that can span
 * over multiple lines, such as hyperlinks or range selections.
 * @see https://floating-ui.com/docs/inline
 */
const inline = function (options) {
  if (options === void 0) {
    options = {};
  }
  return {
    name: 'inline',
    options,
    async fn(state) {
      const {
        placement,
        elements,
        rects,
        platform,
        strategy
      } = state;
      // A MouseEvent's client{X,Y} coords can be up to 2 pixels off a
      // ClientRect's bounds, despite the event listener being triggered. A
      // padding of 2 seems to handle this issue.
      const {
        padding = 2,
        x,
        y
      } = evaluate(options, state);
      const nativeClientRects = Array.from((await (platform.getClientRects == null ? void 0 : platform.getClientRects(elements.reference))) || []);
      const clientRects = getRectsByLine(nativeClientRects);
      const fallback = rectToClientRect(getBoundingRect(nativeClientRects));
      const paddingObject = getPaddingObject(padding);
      function getBoundingClientRect() {
        // There are two rects and they are disjoined.
        if (clientRects.length === 2 && clientRects[0].left > clientRects[1].right && x != null && y != null) {
          // Find the first rect in which the point is fully inside.
          return clientRects.find(rect => x > rect.left - paddingObject.left && x < rect.right + paddingObject.right && y > rect.top - paddingObject.top && y < rect.bottom + paddingObject.bottom) || fallback;
        }

        // There are 2 or more connected rects.
        if (clientRects.length >= 2) {
          if (getSideAxis(placement) === 'y') {
            const firstRect = clientRects[0];
            const lastRect = clientRects[clientRects.length - 1];
            const isTop = getSide(placement) === 'top';
            const top = firstRect.top;
            const bottom = lastRect.bottom;
            const left = isTop ? firstRect.left : lastRect.left;
            const right = isTop ? firstRect.right : lastRect.right;
            const width = right - left;
            const height = bottom - top;
            return {
              top,
              bottom,
              left,
              right,
              width,
              height,
              x: left,
              y: top
            };
          }
          const isLeftSide = getSide(placement) === 'left';
          const maxRight = max(...clientRects.map(rect => rect.right));
          const minLeft = min(...clientRects.map(rect => rect.left));
          const measureRects = clientRects.filter(rect => isLeftSide ? rect.left === minLeft : rect.right === maxRight);
          const top = measureRects[0].top;
          const bottom = measureRects[measureRects.length - 1].bottom;
          const left = minLeft;
          const right = maxRight;
          const width = right - left;
          const height = bottom - top;
          return {
            top,
            bottom,
            left,
            right,
            width,
            height,
            x: left,
            y: top
          };
        }
        return fallback;
      }
      const resetRects = await platform.getElementRects({
        reference: {
          getBoundingClientRect
        },
        floating: elements.floating,
        strategy
      });
      if (rects.reference.x !== resetRects.reference.x || rects.reference.y !== resetRects.reference.y || rects.reference.width !== resetRects.reference.width || rects.reference.height !== resetRects.reference.height) {
        return {
          reset: {
            rects: resetRects
          }
        };
      }
      return {};
    }
  };
};

// For type backwards-compatibility, the `OffsetOptions` type was also
// Derivable.
async function convertValueToCoords(state, options) {
  const {
    placement,
    platform,
    elements
  } = state;
  const rtl = await (platform.isRTL == null ? void 0 : platform.isRTL(elements.floating));
  const side = floating_ui_utils_getSide(placement);
  const alignment = floating_ui_utils_getAlignment(placement);
  const isVertical = floating_ui_utils_getSideAxis(placement) === 'y';
  const mainAxisMulti = ['left', 'top'].includes(side) ? -1 : 1;
  const crossAxisMulti = rtl && isVertical ? -1 : 1;
  const rawValue = floating_ui_utils_evaluate(options, state);

  // eslint-disable-next-line prefer-const
  let {
    mainAxis,
    crossAxis,
    alignmentAxis
  } = typeof rawValue === 'number' ? {
    mainAxis: rawValue,
    crossAxis: 0,
    alignmentAxis: null
  } : {
    mainAxis: 0,
    crossAxis: 0,
    alignmentAxis: null,
    ...rawValue
  };
  if (alignment && typeof alignmentAxis === 'number') {
    crossAxis = alignment === 'end' ? alignmentAxis * -1 : alignmentAxis;
  }
  return isVertical ? {
    x: crossAxis * crossAxisMulti,
    y: mainAxis * mainAxisMulti
  } : {
    x: mainAxis * mainAxisMulti,
    y: crossAxis * crossAxisMulti
  };
}

/**
 * Modifies the placement by translating the floating element along the
 * specified axes.
 * A number (shorthand for `mainAxis` or distance), or an axes configuration
 * object may be passed.
 * @see https://floating-ui.com/docs/offset
 */
const offset = function (options) {
  if (options === void 0) {
    options = 0;
  }
  return {
    name: 'offset',
    options,
    async fn(state) {
      var _middlewareData$offse, _middlewareData$arrow;
      const {
        x,
        y,
        placement,
        middlewareData
      } = state;
      const diffCoords = await convertValueToCoords(state, options);

      // If the placement is the same and the arrow caused an alignment offset
      // then we don't need to change the positioning coordinates.
      if (placement === ((_middlewareData$offse = middlewareData.offset) == null ? void 0 : _middlewareData$offse.placement) && (_middlewareData$arrow = middlewareData.arrow) != null && _middlewareData$arrow.alignmentOffset) {
        return {};
      }
      return {
        x: x + diffCoords.x,
        y: y + diffCoords.y,
        data: {
          ...diffCoords,
          placement
        }
      };
    }
  };
};

/**
 * Optimizes the visibility of the floating element by shifting it in order to
 * keep it in view when it will overflow the clipping boundary.
 * @see https://floating-ui.com/docs/shift
 */
const shift = function (options) {
  if (options === void 0) {
    options = {};
  }
  return {
    name: 'shift',
    options,
    async fn(state) {
      const {
        x,
        y,
        placement
      } = state;
      const {
        mainAxis: checkMainAxis = true,
        crossAxis: checkCrossAxis = false,
        limiter = {
          fn: _ref => {
            let {
              x,
              y
            } = _ref;
            return {
              x,
              y
            };
          }
        },
        ...detectOverflowOptions
      } = floating_ui_utils_evaluate(options, state);
      const coords = {
        x,
        y
      };
      const overflow = await detectOverflow(state, detectOverflowOptions);
      const crossAxis = floating_ui_utils_getSideAxis(floating_ui_utils_getSide(placement));
      const mainAxis = getOppositeAxis(crossAxis);
      let mainAxisCoord = coords[mainAxis];
      let crossAxisCoord = coords[crossAxis];
      if (checkMainAxis) {
        const minSide = mainAxis === 'y' ? 'top' : 'left';
        const maxSide = mainAxis === 'y' ? 'bottom' : 'right';
        const min = mainAxisCoord + overflow[minSide];
        const max = mainAxisCoord - overflow[maxSide];
        mainAxisCoord = clamp(min, mainAxisCoord, max);
      }
      if (checkCrossAxis) {
        const minSide = crossAxis === 'y' ? 'top' : 'left';
        const maxSide = crossAxis === 'y' ? 'bottom' : 'right';
        const min = crossAxisCoord + overflow[minSide];
        const max = crossAxisCoord - overflow[maxSide];
        crossAxisCoord = clamp(min, crossAxisCoord, max);
      }
      const limitedCoords = limiter.fn({
        ...state,
        [mainAxis]: mainAxisCoord,
        [crossAxis]: crossAxisCoord
      });
      return {
        ...limitedCoords,
        data: {
          x: limitedCoords.x - x,
          y: limitedCoords.y - y
        }
      };
    }
  };
};
/**
 * Built-in `limiter` that will stop `shift()` at a certain point.
 */
const limitShift = function (options) {
  if (options === void 0) {
    options = {};
  }
  return {
    options,
    fn(state) {
      const {
        x,
        y,
        placement,
        rects,
        middlewareData
      } = state;
      const {
        offset = 0,
        mainAxis: checkMainAxis = true,
        crossAxis: checkCrossAxis = true
      } = floating_ui_utils_evaluate(options, state);
      const coords = {
        x,
        y
      };
      const crossAxis = floating_ui_utils_getSideAxis(placement);
      const mainAxis = getOppositeAxis(crossAxis);
      let mainAxisCoord = coords[mainAxis];
      let crossAxisCoord = coords[crossAxis];
      const rawOffset = floating_ui_utils_evaluate(offset, state);
      const computedOffset = typeof rawOffset === 'number' ? {
        mainAxis: rawOffset,
        crossAxis: 0
      } : {
        mainAxis: 0,
        crossAxis: 0,
        ...rawOffset
      };
      if (checkMainAxis) {
        const len = mainAxis === 'y' ? 'height' : 'width';
        const limitMin = rects.reference[mainAxis] - rects.floating[len] + computedOffset.mainAxis;
        const limitMax = rects.reference[mainAxis] + rects.reference[len] - computedOffset.mainAxis;
        if (mainAxisCoord < limitMin) {
          mainAxisCoord = limitMin;
        } else if (mainAxisCoord > limitMax) {
          mainAxisCoord = limitMax;
        }
      }
      if (checkCrossAxis) {
        var _middlewareData$offse, _middlewareData$offse2;
        const len = mainAxis === 'y' ? 'width' : 'height';
        const isOriginSide = ['top', 'left'].includes(floating_ui_utils_getSide(placement));
        const limitMin = rects.reference[crossAxis] - rects.floating[len] + (isOriginSide ? ((_middlewareData$offse = middlewareData.offset) == null ? void 0 : _middlewareData$offse[crossAxis]) || 0 : 0) + (isOriginSide ? 0 : computedOffset.crossAxis);
        const limitMax = rects.reference[crossAxis] + rects.reference[len] + (isOriginSide ? 0 : ((_middlewareData$offse2 = middlewareData.offset) == null ? void 0 : _middlewareData$offse2[crossAxis]) || 0) - (isOriginSide ? computedOffset.crossAxis : 0);
        if (crossAxisCoord < limitMin) {
          crossAxisCoord = limitMin;
        } else if (crossAxisCoord > limitMax) {
          crossAxisCoord = limitMax;
        }
      }
      return {
        [mainAxis]: mainAxisCoord,
        [crossAxis]: crossAxisCoord
      };
    }
  };
};

/**
 * Provides data that allows you to change the size of the floating element —
 * for instance, prevent it from overflowing the clipping boundary or match the
 * width of the reference element.
 * @see https://floating-ui.com/docs/size
 */
const size = function (options) {
  if (options === void 0) {
    options = {};
  }
  return {
    name: 'size',
    options,
    async fn(state) {
      const {
        placement,
        rects,
        platform,
        elements
      } = state;
      const {
        apply = () => {},
        ...detectOverflowOptions
      } = floating_ui_utils_evaluate(options, state);
      const overflow = await detectOverflow(state, detectOverflowOptions);
      const side = floating_ui_utils_getSide(placement);
      const alignment = floating_ui_utils_getAlignment(placement);
      const isYAxis = floating_ui_utils_getSideAxis(placement) === 'y';
      const {
        width,
        height
      } = rects.floating;
      let heightSide;
      let widthSide;
      if (side === 'top' || side === 'bottom') {
        heightSide = side;
        widthSide = alignment === ((await (platform.isRTL == null ? void 0 : platform.isRTL(elements.floating))) ? 'start' : 'end') ? 'left' : 'right';
      } else {
        widthSide = side;
        heightSide = alignment === 'end' ? 'top' : 'bottom';
      }
      const overflowAvailableHeight = height - overflow[heightSide];
      const overflowAvailableWidth = width - overflow[widthSide];
      const noShift = !state.middlewareData.shift;
      let availableHeight = overflowAvailableHeight;
      let availableWidth = overflowAvailableWidth;
      if (isYAxis) {
        const maximumClippingWidth = width - overflow.left - overflow.right;
        availableWidth = alignment || noShift ? floating_ui_utils_min(overflowAvailableWidth, maximumClippingWidth) : maximumClippingWidth;
      } else {
        const maximumClippingHeight = height - overflow.top - overflow.bottom;
        availableHeight = alignment || noShift ? floating_ui_utils_min(overflowAvailableHeight, maximumClippingHeight) : maximumClippingHeight;
      }
      if (noShift && !alignment) {
        const xMin = floating_ui_utils_max(overflow.left, 0);
        const xMax = floating_ui_utils_max(overflow.right, 0);
        const yMin = floating_ui_utils_max(overflow.top, 0);
        const yMax = floating_ui_utils_max(overflow.bottom, 0);
        if (isYAxis) {
          availableWidth = width - 2 * (xMin !== 0 || xMax !== 0 ? xMin + xMax : floating_ui_utils_max(overflow.left, overflow.right));
        } else {
          availableHeight = height - 2 * (yMin !== 0 || yMax !== 0 ? yMin + yMax : floating_ui_utils_max(overflow.top, overflow.bottom));
        }
      }
      await apply({
        ...state,
        availableWidth,
        availableHeight
      });
      const nextDimensions = await platform.getDimensions(elements.floating);
      if (width !== nextDimensions.width || height !== nextDimensions.height) {
        return {
          reset: {
            rects: true
          }
        };
      }
      return {};
    }
  };
};



;// CONCATENATED MODULE: ./node_modules/@floating-ui/utils/dom/dist/floating-ui.utils.dom.mjs
function getNodeName(node) {
  if (isNode(node)) {
    return (node.nodeName || '').toLowerCase();
  }
  // Mocked nodes in testing environments may not be instances of Node. By
  // returning `#document` an infinite loop won't occur.
  // https://github.com/floating-ui/floating-ui/issues/2317
  return '#document';
}
function getWindow(node) {
  var _node$ownerDocument;
  return (node == null ? void 0 : (_node$ownerDocument = node.ownerDocument) == null ? void 0 : _node$ownerDocument.defaultView) || window;
}
function getDocumentElement(node) {
  var _ref;
  return (_ref = (isNode(node) ? node.ownerDocument : node.document) || window.document) == null ? void 0 : _ref.documentElement;
}
function isNode(value) {
  return value instanceof Node || value instanceof getWindow(value).Node;
}
function isElement(value) {
  return value instanceof Element || value instanceof getWindow(value).Element;
}
function isHTMLElement(value) {
  return value instanceof HTMLElement || value instanceof getWindow(value).HTMLElement;
}
function isShadowRoot(value) {
  // Browsers without `ShadowRoot` support.
  if (typeof ShadowRoot === 'undefined') {
    return false;
  }
  return value instanceof ShadowRoot || value instanceof getWindow(value).ShadowRoot;
}
function isOverflowElement(element) {
  const {
    overflow,
    overflowX,
    overflowY,
    display
  } = getComputedStyle(element);
  return /auto|scroll|overlay|hidden|clip/.test(overflow + overflowY + overflowX) && !['inline', 'contents'].includes(display);
}
function isTableElement(element) {
  return ['table', 'td', 'th'].includes(getNodeName(element));
}
function isContainingBlock(element) {
  const webkit = isWebKit();
  const css = getComputedStyle(element);

  // https://developer.mozilla.org/en-US/docs/Web/CSS/Containing_block#identifying_the_containing_block
  return css.transform !== 'none' || css.perspective !== 'none' || (css.containerType ? css.containerType !== 'normal' : false) || !webkit && (css.backdropFilter ? css.backdropFilter !== 'none' : false) || !webkit && (css.filter ? css.filter !== 'none' : false) || ['transform', 'perspective', 'filter'].some(value => (css.willChange || '').includes(value)) || ['paint', 'layout', 'strict', 'content'].some(value => (css.contain || '').includes(value));
}
function getContainingBlock(element) {
  let currentNode = getParentNode(element);
  while (isHTMLElement(currentNode) && !isLastTraversableNode(currentNode)) {
    if (isContainingBlock(currentNode)) {
      return currentNode;
    } else {
      currentNode = getParentNode(currentNode);
    }
  }
  return null;
}
function isWebKit() {
  if (typeof CSS === 'undefined' || !CSS.supports) return false;
  return CSS.supports('-webkit-backdrop-filter', 'none');
}
function isLastTraversableNode(node) {
  return ['html', 'body', '#document'].includes(getNodeName(node));
}
function getComputedStyle(element) {
  return getWindow(element).getComputedStyle(element);
}
function getNodeScroll(element) {
  if (isElement(element)) {
    return {
      scrollLeft: element.scrollLeft,
      scrollTop: element.scrollTop
    };
  }
  return {
    scrollLeft: element.pageXOffset,
    scrollTop: element.pageYOffset
  };
}
function getParentNode(node) {
  if (getNodeName(node) === 'html') {
    return node;
  }
  const result =
  // Step into the shadow DOM of the parent of a slotted node.
  node.assignedSlot ||
  // DOM Element detected.
  node.parentNode ||
  // ShadowRoot detected.
  isShadowRoot(node) && node.host ||
  // Fallback.
  getDocumentElement(node);
  return isShadowRoot(result) ? result.host : result;
}
function getNearestOverflowAncestor(node) {
  const parentNode = getParentNode(node);
  if (isLastTraversableNode(parentNode)) {
    return node.ownerDocument ? node.ownerDocument.body : node.body;
  }
  if (isHTMLElement(parentNode) && isOverflowElement(parentNode)) {
    return parentNode;
  }
  return getNearestOverflowAncestor(parentNode);
}
function getOverflowAncestors(node, list, traverseIframes) {
  var _node$ownerDocument2;
  if (list === void 0) {
    list = [];
  }
  if (traverseIframes === void 0) {
    traverseIframes = true;
  }
  const scrollableAncestor = getNearestOverflowAncestor(node);
  const isBody = scrollableAncestor === ((_node$ownerDocument2 = node.ownerDocument) == null ? void 0 : _node$ownerDocument2.body);
  const win = getWindow(scrollableAncestor);
  if (isBody) {
    return list.concat(win, win.visualViewport || [], isOverflowElement(scrollableAncestor) ? scrollableAncestor : [], win.frameElement && traverseIframes ? getOverflowAncestors(win.frameElement) : []);
  }
  return list.concat(scrollableAncestor, getOverflowAncestors(scrollableAncestor, [], traverseIframes));
}



;// CONCATENATED MODULE: ./node_modules/@floating-ui/react-dom/node_modules/@floating-ui/dom/dist/floating-ui.dom.mjs






function getCssDimensions(element) {
  const css = getComputedStyle(element);
  // In testing environments, the `width` and `height` properties are empty
  // strings for SVG elements, returning NaN. Fallback to `0` in this case.
  let width = parseFloat(css.width) || 0;
  let height = parseFloat(css.height) || 0;
  const hasOffset = isHTMLElement(element);
  const offsetWidth = hasOffset ? element.offsetWidth : width;
  const offsetHeight = hasOffset ? element.offsetHeight : height;
  const shouldFallback = round(width) !== offsetWidth || round(height) !== offsetHeight;
  if (shouldFallback) {
    width = offsetWidth;
    height = offsetHeight;
  }
  return {
    width,
    height,
    $: shouldFallback
  };
}

function unwrapElement(element) {
  return !isElement(element) ? element.contextElement : element;
}

function getScale(element) {
  const domElement = unwrapElement(element);
  if (!isHTMLElement(domElement)) {
    return createCoords(1);
  }
  const rect = domElement.getBoundingClientRect();
  const {
    width,
    height,
    $
  } = getCssDimensions(domElement);
  let x = ($ ? round(rect.width) : rect.width) / width;
  let y = ($ ? round(rect.height) : rect.height) / height;

  // 0, NaN, or Infinity should always fallback to 1.

  if (!x || !Number.isFinite(x)) {
    x = 1;
  }
  if (!y || !Number.isFinite(y)) {
    y = 1;
  }
  return {
    x,
    y
  };
}

const noOffsets = /*#__PURE__*/createCoords(0);
function getVisualOffsets(element) {
  const win = getWindow(element);
  if (!isWebKit() || !win.visualViewport) {
    return noOffsets;
  }
  return {
    x: win.visualViewport.offsetLeft,
    y: win.visualViewport.offsetTop
  };
}
function shouldAddVisualOffsets(element, isFixed, floatingOffsetParent) {
  if (isFixed === void 0) {
    isFixed = false;
  }
  if (!floatingOffsetParent || isFixed && floatingOffsetParent !== getWindow(element)) {
    return false;
  }
  return isFixed;
}

function getBoundingClientRect(element, includeScale, isFixedStrategy, offsetParent) {
  if (includeScale === void 0) {
    includeScale = false;
  }
  if (isFixedStrategy === void 0) {
    isFixedStrategy = false;
  }
  const clientRect = element.getBoundingClientRect();
  const domElement = unwrapElement(element);
  let scale = createCoords(1);
  if (includeScale) {
    if (offsetParent) {
      if (isElement(offsetParent)) {
        scale = getScale(offsetParent);
      }
    } else {
      scale = getScale(element);
    }
  }
  const visualOffsets = shouldAddVisualOffsets(domElement, isFixedStrategy, offsetParent) ? getVisualOffsets(domElement) : createCoords(0);
  let x = (clientRect.left + visualOffsets.x) / scale.x;
  let y = (clientRect.top + visualOffsets.y) / scale.y;
  let width = clientRect.width / scale.x;
  let height = clientRect.height / scale.y;
  if (domElement) {
    const win = getWindow(domElement);
    const offsetWin = offsetParent && isElement(offsetParent) ? getWindow(offsetParent) : offsetParent;
    let currentIFrame = win.frameElement;
    while (currentIFrame && offsetParent && offsetWin !== win) {
      const iframeScale = getScale(currentIFrame);
      const iframeRect = currentIFrame.getBoundingClientRect();
      const css = getComputedStyle(currentIFrame);
      const left = iframeRect.left + (currentIFrame.clientLeft + parseFloat(css.paddingLeft)) * iframeScale.x;
      const top = iframeRect.top + (currentIFrame.clientTop + parseFloat(css.paddingTop)) * iframeScale.y;
      x *= iframeScale.x;
      y *= iframeScale.y;
      width *= iframeScale.x;
      height *= iframeScale.y;
      x += left;
      y += top;
      currentIFrame = getWindow(currentIFrame).frameElement;
    }
  }
  return floating_ui_utils_rectToClientRect({
    width,
    height,
    x,
    y
  });
}

function convertOffsetParentRelativeRectToViewportRelativeRect(_ref) {
  let {
    rect,
    offsetParent,
    strategy
  } = _ref;
  const isOffsetParentAnElement = isHTMLElement(offsetParent);
  const documentElement = getDocumentElement(offsetParent);
  if (offsetParent === documentElement) {
    return rect;
  }
  let scroll = {
    scrollLeft: 0,
    scrollTop: 0
  };
  let scale = createCoords(1);
  const offsets = createCoords(0);
  if (isOffsetParentAnElement || !isOffsetParentAnElement && strategy !== 'fixed') {
    if (getNodeName(offsetParent) !== 'body' || isOverflowElement(documentElement)) {
      scroll = getNodeScroll(offsetParent);
    }
    if (isHTMLElement(offsetParent)) {
      const offsetRect = getBoundingClientRect(offsetParent);
      scale = getScale(offsetParent);
      offsets.x = offsetRect.x + offsetParent.clientLeft;
      offsets.y = offsetRect.y + offsetParent.clientTop;
    }
  }
  return {
    width: rect.width * scale.x,
    height: rect.height * scale.y,
    x: rect.x * scale.x - scroll.scrollLeft * scale.x + offsets.x,
    y: rect.y * scale.y - scroll.scrollTop * scale.y + offsets.y
  };
}

function getClientRects(element) {
  return Array.from(element.getClientRects());
}

function getWindowScrollBarX(element) {
  // If <html> has a CSS width greater than the viewport, then this will be
  // incorrect for RTL.
  return getBoundingClientRect(getDocumentElement(element)).left + getNodeScroll(element).scrollLeft;
}

// Gets the entire size of the scrollable document area, even extending outside
// of the `<html>` and `<body>` rect bounds if horizontally scrollable.
function getDocumentRect(element) {
  const html = getDocumentElement(element);
  const scroll = getNodeScroll(element);
  const body = element.ownerDocument.body;
  const width = floating_ui_utils_max(html.scrollWidth, html.clientWidth, body.scrollWidth, body.clientWidth);
  const height = floating_ui_utils_max(html.scrollHeight, html.clientHeight, body.scrollHeight, body.clientHeight);
  let x = -scroll.scrollLeft + getWindowScrollBarX(element);
  const y = -scroll.scrollTop;
  if (getComputedStyle(body).direction === 'rtl') {
    x += floating_ui_utils_max(html.clientWidth, body.clientWidth) - width;
  }
  return {
    width,
    height,
    x,
    y
  };
}

function getViewportRect(element, strategy) {
  const win = getWindow(element);
  const html = getDocumentElement(element);
  const visualViewport = win.visualViewport;
  let width = html.clientWidth;
  let height = html.clientHeight;
  let x = 0;
  let y = 0;
  if (visualViewport) {
    width = visualViewport.width;
    height = visualViewport.height;
    const visualViewportBased = isWebKit();
    if (!visualViewportBased || visualViewportBased && strategy === 'fixed') {
      x = visualViewport.offsetLeft;
      y = visualViewport.offsetTop;
    }
  }
  return {
    width,
    height,
    x,
    y
  };
}

// Returns the inner client rect, subtracting scrollbars if present.
function getInnerBoundingClientRect(element, strategy) {
  const clientRect = getBoundingClientRect(element, true, strategy === 'fixed');
  const top = clientRect.top + element.clientTop;
  const left = clientRect.left + element.clientLeft;
  const scale = isHTMLElement(element) ? getScale(element) : createCoords(1);
  const width = element.clientWidth * scale.x;
  const height = element.clientHeight * scale.y;
  const x = left * scale.x;
  const y = top * scale.y;
  return {
    width,
    height,
    x,
    y
  };
}
function getClientRectFromClippingAncestor(element, clippingAncestor, strategy) {
  let rect;
  if (clippingAncestor === 'viewport') {
    rect = getViewportRect(element, strategy);
  } else if (clippingAncestor === 'document') {
    rect = getDocumentRect(getDocumentElement(element));
  } else if (isElement(clippingAncestor)) {
    rect = getInnerBoundingClientRect(clippingAncestor, strategy);
  } else {
    const visualOffsets = getVisualOffsets(element);
    rect = {
      ...clippingAncestor,
      x: clippingAncestor.x - visualOffsets.x,
      y: clippingAncestor.y - visualOffsets.y
    };
  }
  return floating_ui_utils_rectToClientRect(rect);
}
function hasFixedPositionAncestor(element, stopNode) {
  const parentNode = getParentNode(element);
  if (parentNode === stopNode || !isElement(parentNode) || isLastTraversableNode(parentNode)) {
    return false;
  }
  return getComputedStyle(parentNode).position === 'fixed' || hasFixedPositionAncestor(parentNode, stopNode);
}

// A "clipping ancestor" is an `overflow` element with the characteristic of
// clipping (or hiding) child elements. This returns all clipping ancestors
// of the given element up the tree.
function getClippingElementAncestors(element, cache) {
  const cachedResult = cache.get(element);
  if (cachedResult) {
    return cachedResult;
  }
  let result = getOverflowAncestors(element, [], false).filter(el => isElement(el) && getNodeName(el) !== 'body');
  let currentContainingBlockComputedStyle = null;
  const elementIsFixed = getComputedStyle(element).position === 'fixed';
  let currentNode = elementIsFixed ? getParentNode(element) : element;

  // https://developer.mozilla.org/en-US/docs/Web/CSS/Containing_block#identifying_the_containing_block
  while (isElement(currentNode) && !isLastTraversableNode(currentNode)) {
    const computedStyle = getComputedStyle(currentNode);
    const currentNodeIsContaining = isContainingBlock(currentNode);
    if (!currentNodeIsContaining && computedStyle.position === 'fixed') {
      currentContainingBlockComputedStyle = null;
    }
    const shouldDropCurrentNode = elementIsFixed ? !currentNodeIsContaining && !currentContainingBlockComputedStyle : !currentNodeIsContaining && computedStyle.position === 'static' && !!currentContainingBlockComputedStyle && ['absolute', 'fixed'].includes(currentContainingBlockComputedStyle.position) || isOverflowElement(currentNode) && !currentNodeIsContaining && hasFixedPositionAncestor(element, currentNode);
    if (shouldDropCurrentNode) {
      // Drop non-containing blocks.
      result = result.filter(ancestor => ancestor !== currentNode);
    } else {
      // Record last containing block for next iteration.
      currentContainingBlockComputedStyle = computedStyle;
    }
    currentNode = getParentNode(currentNode);
  }
  cache.set(element, result);
  return result;
}

// Gets the maximum area that the element is visible in due to any number of
// clipping ancestors.
function getClippingRect(_ref) {
  let {
    element,
    boundary,
    rootBoundary,
    strategy
  } = _ref;
  const elementClippingAncestors = boundary === 'clippingAncestors' ? getClippingElementAncestors(element, this._c) : [].concat(boundary);
  const clippingAncestors = [...elementClippingAncestors, rootBoundary];
  const firstClippingAncestor = clippingAncestors[0];
  const clippingRect = clippingAncestors.reduce((accRect, clippingAncestor) => {
    const rect = getClientRectFromClippingAncestor(element, clippingAncestor, strategy);
    accRect.top = floating_ui_utils_max(rect.top, accRect.top);
    accRect.right = floating_ui_utils_min(rect.right, accRect.right);
    accRect.bottom = floating_ui_utils_min(rect.bottom, accRect.bottom);
    accRect.left = floating_ui_utils_max(rect.left, accRect.left);
    return accRect;
  }, getClientRectFromClippingAncestor(element, firstClippingAncestor, strategy));
  return {
    width: clippingRect.right - clippingRect.left,
    height: clippingRect.bottom - clippingRect.top,
    x: clippingRect.left,
    y: clippingRect.top
  };
}

function getDimensions(element) {
  return getCssDimensions(element);
}

function getRectRelativeToOffsetParent(element, offsetParent, strategy) {
  const isOffsetParentAnElement = isHTMLElement(offsetParent);
  const documentElement = getDocumentElement(offsetParent);
  const isFixed = strategy === 'fixed';
  const rect = getBoundingClientRect(element, true, isFixed, offsetParent);
  let scroll = {
    scrollLeft: 0,
    scrollTop: 0
  };
  const offsets = createCoords(0);
  if (isOffsetParentAnElement || !isOffsetParentAnElement && !isFixed) {
    if (getNodeName(offsetParent) !== 'body' || isOverflowElement(documentElement)) {
      scroll = getNodeScroll(offsetParent);
    }
    if (isOffsetParentAnElement) {
      const offsetRect = getBoundingClientRect(offsetParent, true, isFixed, offsetParent);
      offsets.x = offsetRect.x + offsetParent.clientLeft;
      offsets.y = offsetRect.y + offsetParent.clientTop;
    } else if (documentElement) {
      offsets.x = getWindowScrollBarX(documentElement);
    }
  }
  return {
    x: rect.left + scroll.scrollLeft - offsets.x,
    y: rect.top + scroll.scrollTop - offsets.y,
    width: rect.width,
    height: rect.height
  };
}

function getTrueOffsetParent(element, polyfill) {
  if (!isHTMLElement(element) || getComputedStyle(element).position === 'fixed') {
    return null;
  }
  if (polyfill) {
    return polyfill(element);
  }
  return element.offsetParent;
}

// Gets the closest ancestor positioned element. Handles some edge cases,
// such as table ancestors and cross browser bugs.
function getOffsetParent(element, polyfill) {
  const window = getWindow(element);
  if (!isHTMLElement(element)) {
    return window;
  }
  let offsetParent = getTrueOffsetParent(element, polyfill);
  while (offsetParent && isTableElement(offsetParent) && getComputedStyle(offsetParent).position === 'static') {
    offsetParent = getTrueOffsetParent(offsetParent, polyfill);
  }
  if (offsetParent && (getNodeName(offsetParent) === 'html' || getNodeName(offsetParent) === 'body' && getComputedStyle(offsetParent).position === 'static' && !isContainingBlock(offsetParent))) {
    return window;
  }
  return offsetParent || getContainingBlock(element) || window;
}

const getElementRects = async function (_ref) {
  let {
    reference,
    floating,
    strategy
  } = _ref;
  const getOffsetParentFn = this.getOffsetParent || getOffsetParent;
  const getDimensionsFn = this.getDimensions;
  return {
    reference: getRectRelativeToOffsetParent(reference, await getOffsetParentFn(floating), strategy),
    floating: {
      x: 0,
      y: 0,
      ...(await getDimensionsFn(floating))
    }
  };
};

function isRTL(element) {
  return getComputedStyle(element).direction === 'rtl';
}

const platform = {
  convertOffsetParentRelativeRectToViewportRelativeRect,
  getDocumentElement: getDocumentElement,
  getClippingRect,
  getOffsetParent,
  getElementRects,
  getClientRects,
  getDimensions,
  getScale,
  isElement: isElement,
  isRTL
};

// https://samthor.au/2021/observing-dom/
function observeMove(element, onMove) {
  let io = null;
  let timeoutId;
  const root = getDocumentElement(element);
  function cleanup() {
    clearTimeout(timeoutId);
    io && io.disconnect();
    io = null;
  }
  function refresh(skip, threshold) {
    if (skip === void 0) {
      skip = false;
    }
    if (threshold === void 0) {
      threshold = 1;
    }
    cleanup();
    const {
      left,
      top,
      width,
      height
    } = element.getBoundingClientRect();
    if (!skip) {
      onMove();
    }
    if (!width || !height) {
      return;
    }
    const insetTop = floor(top);
    const insetRight = floor(root.clientWidth - (left + width));
    const insetBottom = floor(root.clientHeight - (top + height));
    const insetLeft = floor(left);
    const rootMargin = -insetTop + "px " + -insetRight + "px " + -insetBottom + "px " + -insetLeft + "px";
    const options = {
      rootMargin,
      threshold: floating_ui_utils_max(0, floating_ui_utils_min(1, threshold)) || 1
    };
    let isFirstUpdate = true;
    function handleObserve(entries) {
      const ratio = entries[0].intersectionRatio;
      if (ratio !== threshold) {
        if (!isFirstUpdate) {
          return refresh();
        }
        if (!ratio) {
          timeoutId = setTimeout(() => {
            refresh(false, 1e-7);
          }, 100);
        } else {
          refresh(false, ratio);
        }
      }
      isFirstUpdate = false;
    }

    // Older browsers don't support a `document` as the root and will throw an
    // error.
    try {
      io = new IntersectionObserver(handleObserve, {
        ...options,
        // Handle <iframe>s
        root: root.ownerDocument
      });
    } catch (e) {
      io = new IntersectionObserver(handleObserve, options);
    }
    io.observe(element);
  }
  refresh(true);
  return cleanup;
}

/**
 * Automatically updates the position of the floating element when necessary.
 * Should only be called when the floating element is mounted on the DOM or
 * visible on the screen.
 * @returns cleanup function that should be invoked when the floating element is
 * removed from the DOM or hidden from the screen.
 * @see https://floating-ui.com/docs/autoUpdate
 */
function autoUpdate(reference, floating, update, options) {
  if (options === void 0) {
    options = {};
  }
  const {
    ancestorScroll = true,
    ancestorResize = true,
    elementResize = typeof ResizeObserver === 'function',
    layoutShift = typeof IntersectionObserver === 'function',
    animationFrame = false
  } = options;
  const referenceEl = unwrapElement(reference);
  const ancestors = ancestorScroll || ancestorResize ? [...(referenceEl ? getOverflowAncestors(referenceEl) : []), ...getOverflowAncestors(floating)] : [];
  ancestors.forEach(ancestor => {
    ancestorScroll && ancestor.addEventListener('scroll', update, {
      passive: true
    });
    ancestorResize && ancestor.addEventListener('resize', update);
  });
  const cleanupIo = referenceEl && layoutShift ? observeMove(referenceEl, update) : null;
  let reobserveFrame = -1;
  let resizeObserver = null;
  if (elementResize) {
    resizeObserver = new ResizeObserver(_ref => {
      let [firstEntry] = _ref;
      if (firstEntry && firstEntry.target === referenceEl && resizeObserver) {
        // Prevent update loops when using the `size` middleware.
        // https://github.com/floating-ui/floating-ui/issues/1740
        resizeObserver.unobserve(floating);
        cancelAnimationFrame(reobserveFrame);
        reobserveFrame = requestAnimationFrame(() => {
          resizeObserver && resizeObserver.observe(floating);
        });
      }
      update();
    });
    if (referenceEl && !animationFrame) {
      resizeObserver.observe(referenceEl);
    }
    resizeObserver.observe(floating);
  }
  let frameId;
  let prevRefRect = animationFrame ? getBoundingClientRect(reference) : null;
  if (animationFrame) {
    frameLoop();
  }
  function frameLoop() {
    const nextRefRect = getBoundingClientRect(reference);
    if (prevRefRect && (nextRefRect.x !== prevRefRect.x || nextRefRect.y !== prevRefRect.y || nextRefRect.width !== prevRefRect.width || nextRefRect.height !== prevRefRect.height)) {
      update();
    }
    prevRefRect = nextRefRect;
    frameId = requestAnimationFrame(frameLoop);
  }
  update();
  return () => {
    ancestors.forEach(ancestor => {
      ancestorScroll && ancestor.removeEventListener('scroll', update);
      ancestorResize && ancestor.removeEventListener('resize', update);
    });
    cleanupIo && cleanupIo();
    resizeObserver && resizeObserver.disconnect();
    resizeObserver = null;
    if (animationFrame) {
      cancelAnimationFrame(frameId);
    }
  };
}

/**
 * Computes the `x` and `y` coordinates that will place the floating element
 * next to a reference element when it is given a certain CSS positioning
 * strategy.
 */
const floating_ui_dom_computePosition = (reference, floating, options) => {
  // This caches the expensive `getClippingElementAncestors` function so that
  // multiple lifecycle resets re-use the same result. It only lives for a
  // single call. If other functions become expensive, we can add them as well.
  const cache = new Map();
  const mergedOptions = {
    platform,
    ...options
  };
  const platformWithCache = {
    ...mergedOptions.platform,
    _c: cache
  };
  return computePosition(reference, floating, {
    ...mergedOptions,
    platform: platformWithCache
  });
};



// EXTERNAL MODULE: ./node_modules/next/dist/compiled/react-dom/index.js
var react_dom = __webpack_require__(18369);
;// CONCATENATED MODULE: ./node_modules/@floating-ui/react-dom/dist/floating-ui.react-dom.mjs






/**
 * Provides data to position an inner element of the floating element so that it
 * appears centered to the reference element.
 * This wraps the core `arrow` middleware to allow React refs as the element.
 * @see https://floating-ui.com/docs/arrow
 */
const floating_ui_react_dom_arrow = options => {
  function isRef(value) {
    return {}.hasOwnProperty.call(value, 'current');
  }
  return {
    name: 'arrow',
    options,
    fn(state) {
      const {
        element,
        padding
      } = typeof options === 'function' ? options(state) : options;
      if (element && isRef(element)) {
        if (element.current != null) {
          return arrow({
            element: element.current,
            padding
          }).fn(state);
        }
        return {};
      } else if (element) {
        return arrow({
          element,
          padding
        }).fn(state);
      }
      return {};
    }
  };
};

var index = typeof document !== 'undefined' ? react.useLayoutEffect : react.useEffect;

// Fork of `fast-deep-equal` that only does the comparisons we need and compares
// functions
function deepEqual(a, b) {
  if (a === b) {
    return true;
  }
  if (typeof a !== typeof b) {
    return false;
  }
  if (typeof a === 'function' && a.toString() === b.toString()) {
    return true;
  }
  let length, i, keys;
  if (a && b && typeof a == 'object') {
    if (Array.isArray(a)) {
      length = a.length;
      if (length != b.length) return false;
      for (i = length; i-- !== 0;) {
        if (!deepEqual(a[i], b[i])) {
          return false;
        }
      }
      return true;
    }
    keys = Object.keys(a);
    length = keys.length;
    if (length !== Object.keys(b).length) {
      return false;
    }
    for (i = length; i-- !== 0;) {
      if (!{}.hasOwnProperty.call(b, keys[i])) {
        return false;
      }
    }
    for (i = length; i-- !== 0;) {
      const key = keys[i];
      if (key === '_owner' && a.$$typeof) {
        continue;
      }
      if (!deepEqual(a[key], b[key])) {
        return false;
      }
    }
    return true;
  }
  return a !== a && b !== b;
}

function getDPR(element) {
  if (typeof window === 'undefined') {
    return 1;
  }
  const win = element.ownerDocument.defaultView || window;
  return win.devicePixelRatio || 1;
}

function roundByDPR(element, value) {
  const dpr = getDPR(element);
  return Math.round(value * dpr) / dpr;
}

function useLatestRef(value) {
  const ref = react.useRef(value);
  index(() => {
    ref.current = value;
  });
  return ref;
}

/**
 * Provides data to position a floating element.
 * @see https://floating-ui.com/docs/useFloating
 */
function useFloating(options) {
  if (options === void 0) {
    options = {};
  }
  const {
    placement = 'bottom',
    strategy = 'absolute',
    middleware = [],
    platform,
    elements: {
      reference: externalReference,
      floating: externalFloating
    } = {},
    transform = true,
    whileElementsMounted,
    open
  } = options;
  const [data, setData] = react.useState({
    x: 0,
    y: 0,
    strategy,
    placement,
    middlewareData: {},
    isPositioned: false
  });
  const [latestMiddleware, setLatestMiddleware] = react.useState(middleware);
  if (!deepEqual(latestMiddleware, middleware)) {
    setLatestMiddleware(middleware);
  }
  const [_reference, _setReference] = react.useState(null);
  const [_floating, _setFloating] = react.useState(null);
  const setReference = react.useCallback(node => {
    if (node != referenceRef.current) {
      referenceRef.current = node;
      _setReference(node);
    }
  }, [_setReference]);
  const setFloating = react.useCallback(node => {
    if (node !== floatingRef.current) {
      floatingRef.current = node;
      _setFloating(node);
    }
  }, [_setFloating]);
  const referenceEl = externalReference || _reference;
  const floatingEl = externalFloating || _floating;
  const referenceRef = react.useRef(null);
  const floatingRef = react.useRef(null);
  const dataRef = react.useRef(data);
  const whileElementsMountedRef = useLatestRef(whileElementsMounted);
  const platformRef = useLatestRef(platform);
  const update = react.useCallback(() => {
    if (!referenceRef.current || !floatingRef.current) {
      return;
    }
    const config = {
      placement,
      strategy,
      middleware: latestMiddleware
    };
    if (platformRef.current) {
      config.platform = platformRef.current;
    }
    floating_ui_dom_computePosition(referenceRef.current, floatingRef.current, config).then(data => {
      const fullData = {
        ...data,
        isPositioned: true
      };
      if (isMountedRef.current && !deepEqual(dataRef.current, fullData)) {
        dataRef.current = fullData;
        react_dom.flushSync(() => {
          setData(fullData);
        });
      }
    });
  }, [latestMiddleware, placement, strategy, platformRef]);
  index(() => {
    if (open === false && dataRef.current.isPositioned) {
      dataRef.current.isPositioned = false;
      setData(data => ({
        ...data,
        isPositioned: false
      }));
    }
  }, [open]);
  const isMountedRef = react.useRef(false);
  index(() => {
    isMountedRef.current = true;
    return () => {
      isMountedRef.current = false;
    };
  }, []);
  index(() => {
    if (referenceEl) referenceRef.current = referenceEl;
    if (floatingEl) floatingRef.current = floatingEl;
    if (referenceEl && floatingEl) {
      if (whileElementsMountedRef.current) {
        return whileElementsMountedRef.current(referenceEl, floatingEl, update);
      } else {
        update();
      }
    }
  }, [referenceEl, floatingEl, update, whileElementsMountedRef]);
  const refs = react.useMemo(() => ({
    reference: referenceRef,
    floating: floatingRef,
    setReference,
    setFloating
  }), [setReference, setFloating]);
  const elements = react.useMemo(() => ({
    reference: referenceEl,
    floating: floatingEl
  }), [referenceEl, floatingEl]);
  const floatingStyles = react.useMemo(() => {
    const initialStyles = {
      position: strategy,
      left: 0,
      top: 0
    };
    if (!elements.floating) {
      return initialStyles;
    }
    const x = roundByDPR(elements.floating, data.x);
    const y = roundByDPR(elements.floating, data.y);
    if (transform) {
      return {
        ...initialStyles,
        transform: "translate(" + x + "px, " + y + "px)",
        ...(getDPR(elements.floating) >= 1.5 && {
          willChange: 'transform'
        })
      };
    }
    return {
      position: strategy,
      left: x,
      top: y
    };
  }, [strategy, transform, elements.floating, data.x, data.y]);
  return react.useMemo(() => ({
    ...data,
    update,
    refs,
    elements,
    floatingStyles
  }), [data, update, refs, elements, floatingStyles]);
}



// EXTERNAL MODULE: ./node_modules/@radix-ui/react-primitive/dist/index.mjs
var dist = __webpack_require__(75320);
;// CONCATENATED MODULE: ./node_modules/@radix-ui/react-arrow/dist/index.mjs







/* -------------------------------------------------------------------------------------------------
 * Arrow
 * -----------------------------------------------------------------------------------------------*/ const $7e8f5cd07187803e$var$NAME = 'Arrow';
const $7e8f5cd07187803e$export$21b07c8f274aebd5 = /*#__PURE__*/ (0,react.forwardRef)((props, forwardedRef)=>{
    const { children: children , width: width = 10 , height: height = 5 , ...arrowProps } = props;
    return /*#__PURE__*/ (0,react.createElement)(dist/* Primitive.svg */.WV.svg, (0,esm_extends/* default */.Z)({}, arrowProps, {
        ref: forwardedRef,
        width: width,
        height: height,
        viewBox: "0 0 30 10",
        preserveAspectRatio: "none"
    }), props.asChild ? children : /*#__PURE__*/ (0,react.createElement)("polygon", {
        points: "0,0 30,0 15,10"
    }));
});
/*#__PURE__*/ Object.assign($7e8f5cd07187803e$export$21b07c8f274aebd5, {
    displayName: $7e8f5cd07187803e$var$NAME
});
/* -----------------------------------------------------------------------------------------------*/ const $7e8f5cd07187803e$export$be92b6f5f03c0fe9 = $7e8f5cd07187803e$export$21b07c8f274aebd5;





//# sourceMappingURL=index.mjs.map

// EXTERNAL MODULE: ./node_modules/@radix-ui/react-compose-refs/dist/index.mjs
var react_compose_refs_dist = __webpack_require__(28771);
// EXTERNAL MODULE: ./node_modules/@radix-ui/react-context/dist/index.mjs
var react_context_dist = __webpack_require__(25360);
// EXTERNAL MODULE: ./node_modules/@radix-ui/react-use-callback-ref/dist/index.mjs
var react_use_callback_ref_dist = __webpack_require__(79698);
// EXTERNAL MODULE: ./node_modules/@radix-ui/react-use-layout-effect/dist/index.mjs
var react_use_layout_effect_dist = __webpack_require__(9981);
// EXTERNAL MODULE: ./node_modules/@radix-ui/react-use-size/dist/index.mjs
var react_use_size_dist = __webpack_require__(7546);
;// CONCATENATED MODULE: ./node_modules/@radix-ui/react-popper/dist/index.mjs





















const $cf1ac5d9fe0e8206$export$36f0086da09c4b9f = (/* unused pure expression or super */ null && ([
    'top',
    'right',
    'bottom',
    'left'
]));
const $cf1ac5d9fe0e8206$export$3671ffab7b302fc9 = (/* unused pure expression or super */ null && ([
    'start',
    'center',
    'end'
]));
/* -------------------------------------------------------------------------------------------------
 * Popper
 * -----------------------------------------------------------------------------------------------*/ const $cf1ac5d9fe0e8206$var$POPPER_NAME = 'Popper';
const [$cf1ac5d9fe0e8206$var$createPopperContext, $cf1ac5d9fe0e8206$export$722aac194ae923] = (0,react_context_dist/* createContextScope */.b)($cf1ac5d9fe0e8206$var$POPPER_NAME);
const [$cf1ac5d9fe0e8206$var$PopperProvider, $cf1ac5d9fe0e8206$var$usePopperContext] = $cf1ac5d9fe0e8206$var$createPopperContext($cf1ac5d9fe0e8206$var$POPPER_NAME);
const $cf1ac5d9fe0e8206$export$badac9ada3a0bdf9 = (props)=>{
    const { __scopePopper: __scopePopper , children: children  } = props;
    const [anchor, setAnchor] = (0,react.useState)(null);
    return /*#__PURE__*/ (0,react.createElement)($cf1ac5d9fe0e8206$var$PopperProvider, {
        scope: __scopePopper,
        anchor: anchor,
        onAnchorChange: setAnchor
    }, children);
};
/*#__PURE__*/ Object.assign($cf1ac5d9fe0e8206$export$badac9ada3a0bdf9, {
    displayName: $cf1ac5d9fe0e8206$var$POPPER_NAME
});
/* -------------------------------------------------------------------------------------------------
 * PopperAnchor
 * -----------------------------------------------------------------------------------------------*/ const $cf1ac5d9fe0e8206$var$ANCHOR_NAME = 'PopperAnchor';
const $cf1ac5d9fe0e8206$export$ecd4e1ccab6ed6d = /*#__PURE__*/ (0,react.forwardRef)((props, forwardedRef)=>{
    const { __scopePopper: __scopePopper , virtualRef: virtualRef , ...anchorProps } = props;
    const context = $cf1ac5d9fe0e8206$var$usePopperContext($cf1ac5d9fe0e8206$var$ANCHOR_NAME, __scopePopper);
    const ref = (0,react.useRef)(null);
    const composedRefs = (0,react_compose_refs_dist/* useComposedRefs */.e)(forwardedRef, ref);
    (0,react.useEffect)(()=>{
        // Consumer can anchor the popper to something that isn't
        // a DOM node e.g. pointer position, so we override the
        // `anchorRef` with their virtual ref in this case.
        context.onAnchorChange((virtualRef === null || virtualRef === void 0 ? void 0 : virtualRef.current) || ref.current);
    });
    return virtualRef ? null : /*#__PURE__*/ (0,react.createElement)(dist/* Primitive.div */.WV.div, (0,esm_extends/* default */.Z)({}, anchorProps, {
        ref: composedRefs
    }));
});
/*#__PURE__*/ Object.assign($cf1ac5d9fe0e8206$export$ecd4e1ccab6ed6d, {
    displayName: $cf1ac5d9fe0e8206$var$ANCHOR_NAME
});
/* -------------------------------------------------------------------------------------------------
 * PopperContent
 * -----------------------------------------------------------------------------------------------*/ const $cf1ac5d9fe0e8206$var$CONTENT_NAME = 'PopperContent';
const [$cf1ac5d9fe0e8206$var$PopperContentProvider, $cf1ac5d9fe0e8206$var$useContentContext] = $cf1ac5d9fe0e8206$var$createPopperContext($cf1ac5d9fe0e8206$var$CONTENT_NAME);
const $cf1ac5d9fe0e8206$export$bc4ae5855d3c4fc = /*#__PURE__*/ (0,react.forwardRef)((props, forwardedRef)=>{
    var _arrowSize$width, _arrowSize$height, _middlewareData$arrow, _middlewareData$arrow2, _middlewareData$arrow3, _middlewareData$trans, _middlewareData$trans2, _middlewareData$hide;
    const { __scopePopper: __scopePopper , side: side = 'bottom' , sideOffset: sideOffset = 0 , align: align = 'center' , alignOffset: alignOffset = 0 , arrowPadding: arrowPadding = 0 , avoidCollisions: avoidCollisions = true , collisionBoundary: collisionBoundary = [] , collisionPadding: collisionPaddingProp = 0 , sticky: sticky = 'partial' , hideWhenDetached: hideWhenDetached = false , updatePositionStrategy: updatePositionStrategy = 'optimized' , onPlaced: onPlaced , ...contentProps } = props;
    const context = $cf1ac5d9fe0e8206$var$usePopperContext($cf1ac5d9fe0e8206$var$CONTENT_NAME, __scopePopper);
    const [content, setContent] = (0,react.useState)(null);
    const composedRefs = (0,react_compose_refs_dist/* useComposedRefs */.e)(forwardedRef, (node)=>setContent(node)
    );
    const [arrow, setArrow] = (0,react.useState)(null);
    const arrowSize = (0,react_use_size_dist/* useSize */.t)(arrow);
    const arrowWidth = (_arrowSize$width = arrowSize === null || arrowSize === void 0 ? void 0 : arrowSize.width) !== null && _arrowSize$width !== void 0 ? _arrowSize$width : 0;
    const arrowHeight = (_arrowSize$height = arrowSize === null || arrowSize === void 0 ? void 0 : arrowSize.height) !== null && _arrowSize$height !== void 0 ? _arrowSize$height : 0;
    const desiredPlacement = side + (align !== 'center' ? '-' + align : '');
    const collisionPadding = typeof collisionPaddingProp === 'number' ? collisionPaddingProp : {
        top: 0,
        right: 0,
        bottom: 0,
        left: 0,
        ...collisionPaddingProp
    };
    const boundary = Array.isArray(collisionBoundary) ? collisionBoundary : [
        collisionBoundary
    ];
    const hasExplicitBoundaries = boundary.length > 0;
    const detectOverflowOptions = {
        padding: collisionPadding,
        boundary: boundary.filter($cf1ac5d9fe0e8206$var$isNotNull),
        // with `strategy: 'fixed'`, this is the only way to get it to respect boundaries
        altBoundary: hasExplicitBoundaries
    };
    const { refs: refs , floatingStyles: floatingStyles , placement: placement , isPositioned: isPositioned , middlewareData: middlewareData  } = useFloating({
        // default to `fixed` strategy so users don't have to pick and we also avoid focus scroll issues
        strategy: 'fixed',
        placement: desiredPlacement,
        whileElementsMounted: (...args)=>{
            const cleanup = autoUpdate(...args, {
                animationFrame: updatePositionStrategy === 'always'
            });
            return cleanup;
        },
        elements: {
            reference: context.anchor
        },
        middleware: [
            offset({
                mainAxis: sideOffset + arrowHeight,
                alignmentAxis: alignOffset
            }),
            avoidCollisions && shift({
                mainAxis: true,
                crossAxis: false,
                limiter: sticky === 'partial' ? limitShift() : undefined,
                ...detectOverflowOptions
            }),
            avoidCollisions && flip({
                ...detectOverflowOptions
            }),
            size({
                ...detectOverflowOptions,
                apply: ({ elements: elements , rects: rects , availableWidth: availableWidth , availableHeight: availableHeight  })=>{
                    const { width: anchorWidth , height: anchorHeight  } = rects.reference;
                    const contentStyle = elements.floating.style;
                    contentStyle.setProperty('--radix-popper-available-width', `${availableWidth}px`);
                    contentStyle.setProperty('--radix-popper-available-height', `${availableHeight}px`);
                    contentStyle.setProperty('--radix-popper-anchor-width', `${anchorWidth}px`);
                    contentStyle.setProperty('--radix-popper-anchor-height', `${anchorHeight}px`);
                }
            }),
            arrow && floating_ui_react_dom_arrow({
                element: arrow,
                padding: arrowPadding
            }),
            $cf1ac5d9fe0e8206$var$transformOrigin({
                arrowWidth: arrowWidth,
                arrowHeight: arrowHeight
            }),
            hideWhenDetached && hide({
                strategy: 'referenceHidden',
                ...detectOverflowOptions
            })
        ]
    });
    const [placedSide, placedAlign] = $cf1ac5d9fe0e8206$var$getSideAndAlignFromPlacement(placement);
    const handlePlaced = (0,react_use_callback_ref_dist/* useCallbackRef */.W)(onPlaced);
    (0,react_use_layout_effect_dist/* useLayoutEffect */.b)(()=>{
        if (isPositioned) handlePlaced === null || handlePlaced === void 0 || handlePlaced();
    }, [
        isPositioned,
        handlePlaced
    ]);
    const arrowX = (_middlewareData$arrow = middlewareData.arrow) === null || _middlewareData$arrow === void 0 ? void 0 : _middlewareData$arrow.x;
    const arrowY = (_middlewareData$arrow2 = middlewareData.arrow) === null || _middlewareData$arrow2 === void 0 ? void 0 : _middlewareData$arrow2.y;
    const cannotCenterArrow = ((_middlewareData$arrow3 = middlewareData.arrow) === null || _middlewareData$arrow3 === void 0 ? void 0 : _middlewareData$arrow3.centerOffset) !== 0;
    const [contentZIndex, setContentZIndex] = (0,react.useState)();
    (0,react_use_layout_effect_dist/* useLayoutEffect */.b)(()=>{
        if (content) setContentZIndex(window.getComputedStyle(content).zIndex);
    }, [
        content
    ]);
    return /*#__PURE__*/ (0,react.createElement)("div", {
        ref: refs.setFloating,
        "data-radix-popper-content-wrapper": "",
        style: {
            ...floatingStyles,
            transform: isPositioned ? floatingStyles.transform : 'translate(0, -200%)',
            // keep off the page when measuring
            minWidth: 'max-content',
            zIndex: contentZIndex,
            ['--radix-popper-transform-origin']: [
                (_middlewareData$trans = middlewareData.transformOrigin) === null || _middlewareData$trans === void 0 ? void 0 : _middlewareData$trans.x,
                (_middlewareData$trans2 = middlewareData.transformOrigin) === null || _middlewareData$trans2 === void 0 ? void 0 : _middlewareData$trans2.y
            ].join(' ')
        } // Floating UI interally calculates logical alignment based the `dir` attribute on
        ,
        dir: props.dir
    }, /*#__PURE__*/ (0,react.createElement)($cf1ac5d9fe0e8206$var$PopperContentProvider, {
        scope: __scopePopper,
        placedSide: placedSide,
        onArrowChange: setArrow,
        arrowX: arrowX,
        arrowY: arrowY,
        shouldHideArrow: cannotCenterArrow
    }, /*#__PURE__*/ (0,react.createElement)(dist/* Primitive.div */.WV.div, (0,esm_extends/* default */.Z)({
        "data-side": placedSide,
        "data-align": placedAlign
    }, contentProps, {
        ref: composedRefs,
        style: {
            ...contentProps.style,
            // if the PopperContent hasn't been placed yet (not all measurements done)
            // we prevent animations so that users's animation don't kick in too early referring wrong sides
            animation: !isPositioned ? 'none' : undefined,
            // hide the content if using the hide middleware and should be hidden
            opacity: (_middlewareData$hide = middlewareData.hide) !== null && _middlewareData$hide !== void 0 && _middlewareData$hide.referenceHidden ? 0 : undefined
        }
    }))));
});
/*#__PURE__*/ Object.assign($cf1ac5d9fe0e8206$export$bc4ae5855d3c4fc, {
    displayName: $cf1ac5d9fe0e8206$var$CONTENT_NAME
});
/* -------------------------------------------------------------------------------------------------
 * PopperArrow
 * -----------------------------------------------------------------------------------------------*/ const $cf1ac5d9fe0e8206$var$ARROW_NAME = 'PopperArrow';
const $cf1ac5d9fe0e8206$var$OPPOSITE_SIDE = {
    top: 'bottom',
    right: 'left',
    bottom: 'top',
    left: 'right'
};
const $cf1ac5d9fe0e8206$export$79d62cd4e10a3fd0 = /*#__PURE__*/ (0,react.forwardRef)(function $cf1ac5d9fe0e8206$export$79d62cd4e10a3fd0(props, forwardedRef) {
    const { __scopePopper: __scopePopper , ...arrowProps } = props;
    const contentContext = $cf1ac5d9fe0e8206$var$useContentContext($cf1ac5d9fe0e8206$var$ARROW_NAME, __scopePopper);
    const baseSide = $cf1ac5d9fe0e8206$var$OPPOSITE_SIDE[contentContext.placedSide];
    return(/*#__PURE__*/ // we have to use an extra wrapper because `ResizeObserver` (used by `useSize`)
    // doesn't report size as we'd expect on SVG elements.
    // it reports their bounding box which is effectively the largest path inside the SVG.
    (0,react.createElement)("span", {
        ref: contentContext.onArrowChange,
        style: {
            position: 'absolute',
            left: contentContext.arrowX,
            top: contentContext.arrowY,
            [baseSide]: 0,
            transformOrigin: {
                top: '',
                right: '0 0',
                bottom: 'center 0',
                left: '100% 0'
            }[contentContext.placedSide],
            transform: {
                top: 'translateY(100%)',
                right: 'translateY(50%) rotate(90deg) translateX(-50%)',
                bottom: `rotate(180deg)`,
                left: 'translateY(50%) rotate(-90deg) translateX(50%)'
            }[contentContext.placedSide],
            visibility: contentContext.shouldHideArrow ? 'hidden' : undefined
        }
    }, /*#__PURE__*/ (0,react.createElement)($7e8f5cd07187803e$export$be92b6f5f03c0fe9, (0,esm_extends/* default */.Z)({}, arrowProps, {
        ref: forwardedRef,
        style: {
            ...arrowProps.style,
            // ensures the element can be measured correctly (mostly for if SVG)
            display: 'block'
        }
    }))));
});
/*#__PURE__*/ Object.assign($cf1ac5d9fe0e8206$export$79d62cd4e10a3fd0, {
    displayName: $cf1ac5d9fe0e8206$var$ARROW_NAME
});
/* -----------------------------------------------------------------------------------------------*/ function $cf1ac5d9fe0e8206$var$isNotNull(value) {
    return value !== null;
}
const $cf1ac5d9fe0e8206$var$transformOrigin = (options)=>({
        name: 'transformOrigin',
        options: options,
        fn (data) {
            var _middlewareData$arrow4, _middlewareData$arrow5, _middlewareData$arrow6, _middlewareData$arrow7, _middlewareData$arrow8;
            const { placement: placement , rects: rects , middlewareData: middlewareData  } = data;
            const cannotCenterArrow = ((_middlewareData$arrow4 = middlewareData.arrow) === null || _middlewareData$arrow4 === void 0 ? void 0 : _middlewareData$arrow4.centerOffset) !== 0;
            const isArrowHidden = cannotCenterArrow;
            const arrowWidth = isArrowHidden ? 0 : options.arrowWidth;
            const arrowHeight = isArrowHidden ? 0 : options.arrowHeight;
            const [placedSide, placedAlign] = $cf1ac5d9fe0e8206$var$getSideAndAlignFromPlacement(placement);
            const noArrowAlign = {
                start: '0%',
                center: '50%',
                end: '100%'
            }[placedAlign];
            const arrowXCenter = ((_middlewareData$arrow5 = (_middlewareData$arrow6 = middlewareData.arrow) === null || _middlewareData$arrow6 === void 0 ? void 0 : _middlewareData$arrow6.x) !== null && _middlewareData$arrow5 !== void 0 ? _middlewareData$arrow5 : 0) + arrowWidth / 2;
            const arrowYCenter = ((_middlewareData$arrow7 = (_middlewareData$arrow8 = middlewareData.arrow) === null || _middlewareData$arrow8 === void 0 ? void 0 : _middlewareData$arrow8.y) !== null && _middlewareData$arrow7 !== void 0 ? _middlewareData$arrow7 : 0) + arrowHeight / 2;
            let x = '';
            let y = '';
            if (placedSide === 'bottom') {
                x = isArrowHidden ? noArrowAlign : `${arrowXCenter}px`;
                y = `${-arrowHeight}px`;
            } else if (placedSide === 'top') {
                x = isArrowHidden ? noArrowAlign : `${arrowXCenter}px`;
                y = `${rects.floating.height + arrowHeight}px`;
            } else if (placedSide === 'right') {
                x = `${-arrowHeight}px`;
                y = isArrowHidden ? noArrowAlign : `${arrowYCenter}px`;
            } else if (placedSide === 'left') {
                x = `${rects.floating.width + arrowHeight}px`;
                y = isArrowHidden ? noArrowAlign : `${arrowYCenter}px`;
            }
            return {
                data: {
                    x: x,
                    y: y
                }
            };
        }
    })
;
function $cf1ac5d9fe0e8206$var$getSideAndAlignFromPlacement(placement) {
    const [side, align = 'center'] = placement.split('-');
    return [
        side,
        align
    ];
}
const $cf1ac5d9fe0e8206$export$be92b6f5f03c0fe9 = $cf1ac5d9fe0e8206$export$badac9ada3a0bdf9;
const $cf1ac5d9fe0e8206$export$b688253958b8dfe7 = $cf1ac5d9fe0e8206$export$ecd4e1ccab6ed6d;
const $cf1ac5d9fe0e8206$export$7c6e2c02157bb7d2 = $cf1ac5d9fe0e8206$export$bc4ae5855d3c4fc;
const $cf1ac5d9fe0e8206$export$21b07c8f274aebd5 = $cf1ac5d9fe0e8206$export$79d62cd4e10a3fd0;





//# sourceMappingURL=index.mjs.map


/***/ }),

/***/ 42651:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "h": function() { return /* binding */ $f1701beae083dbae$export$602eac185826482c; }
/* harmony export */ });
/* unused harmony export Root */
/* harmony import */ var _babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(87462);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(55784);
/* harmony import */ var react_dom__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(18369);
/* harmony import */ var _radix_ui_react_primitive__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(75320);









/* -------------------------------------------------------------------------------------------------
 * Portal
 * -----------------------------------------------------------------------------------------------*/ const $f1701beae083dbae$var$PORTAL_NAME = 'Portal';
const $f1701beae083dbae$export$602eac185826482c = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_0__.forwardRef)((props, forwardedRef)=>{
    var _globalThis$document;
    const { container: container = globalThis === null || globalThis === void 0 ? void 0 : (_globalThis$document = globalThis.document) === null || _globalThis$document === void 0 ? void 0 : _globalThis$document.body , ...portalProps } = props;
    return container ? /*#__PURE__*/ react_dom__WEBPACK_IMPORTED_MODULE_1__.createPortal(/*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_0__.createElement)(_radix_ui_react_primitive__WEBPACK_IMPORTED_MODULE_2__/* .Primitive.div */ .WV.div, (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({}, portalProps, {
        ref: forwardedRef
    })), container) : null;
});
/*#__PURE__*/ Object.assign($f1701beae083dbae$export$602eac185826482c, {
    displayName: $f1701beae083dbae$var$PORTAL_NAME
});
/* -----------------------------------------------------------------------------------------------*/ const $f1701beae083dbae$export$be92b6f5f03c0fe9 = (/* unused pure expression or super */ null && ($f1701beae083dbae$export$602eac185826482c));





//# sourceMappingURL=index.mjs.map


/***/ }),

/***/ 29115:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "z": function() { return /* binding */ $921a889cee6df7e8$export$99c2b779aa4e8b8b; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(55784);
/* harmony import */ var react_dom__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(18369);
/* harmony import */ var _radix_ui_react_compose_refs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(28771);
/* harmony import */ var _radix_ui_react_use_layout_effect__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(9981);










function $fe963b355347cc68$export$3e6543de14f8614f(initialState, machine) {
    return (0,react__WEBPACK_IMPORTED_MODULE_0__.useReducer)((state, event)=>{
        const nextState = machine[state][event];
        return nextState !== null && nextState !== void 0 ? nextState : state;
    }, initialState);
}


const $921a889cee6df7e8$export$99c2b779aa4e8b8b = (props)=>{
    const { present: present , children: children  } = props;
    const presence = $921a889cee6df7e8$var$usePresence(present);
    const child = typeof children === 'function' ? children({
        present: presence.isPresent
    }) : react__WEBPACK_IMPORTED_MODULE_0__.Children.only(children);
    const ref = (0,_radix_ui_react_compose_refs__WEBPACK_IMPORTED_MODULE_2__/* .useComposedRefs */ .e)(presence.ref, child.ref);
    const forceMount = typeof children === 'function';
    return forceMount || presence.isPresent ? /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_0__.cloneElement)(child, {
        ref: ref
    }) : null;
};
$921a889cee6df7e8$export$99c2b779aa4e8b8b.displayName = 'Presence';
/* -------------------------------------------------------------------------------------------------
 * usePresence
 * -----------------------------------------------------------------------------------------------*/ function $921a889cee6df7e8$var$usePresence(present) {
    const [node1, setNode] = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)();
    const stylesRef = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)({});
    const prevPresentRef = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(present);
    const prevAnimationNameRef = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)('none');
    const initialState = present ? 'mounted' : 'unmounted';
    const [state, send] = $fe963b355347cc68$export$3e6543de14f8614f(initialState, {
        mounted: {
            UNMOUNT: 'unmounted',
            ANIMATION_OUT: 'unmountSuspended'
        },
        unmountSuspended: {
            MOUNT: 'mounted',
            ANIMATION_END: 'unmounted'
        },
        unmounted: {
            MOUNT: 'mounted'
        }
    });
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(()=>{
        const currentAnimationName = $921a889cee6df7e8$var$getAnimationName(stylesRef.current);
        prevAnimationNameRef.current = state === 'mounted' ? currentAnimationName : 'none';
    }, [
        state
    ]);
    (0,_radix_ui_react_use_layout_effect__WEBPACK_IMPORTED_MODULE_3__/* .useLayoutEffect */ .b)(()=>{
        const styles = stylesRef.current;
        const wasPresent = prevPresentRef.current;
        const hasPresentChanged = wasPresent !== present;
        if (hasPresentChanged) {
            const prevAnimationName = prevAnimationNameRef.current;
            const currentAnimationName = $921a889cee6df7e8$var$getAnimationName(styles);
            if (present) send('MOUNT');
            else if (currentAnimationName === 'none' || (styles === null || styles === void 0 ? void 0 : styles.display) === 'none') // If there is no exit animation or the element is hidden, animations won't run
            // so we unmount instantly
            send('UNMOUNT');
            else {
                /**
         * When `present` changes to `false`, we check changes to animation-name to
         * determine whether an animation has started. We chose this approach (reading
         * computed styles) because there is no `animationrun` event and `animationstart`
         * fires after `animation-delay` has expired which would be too late.
         */ const isAnimating = prevAnimationName !== currentAnimationName;
                if (wasPresent && isAnimating) send('ANIMATION_OUT');
                else send('UNMOUNT');
            }
            prevPresentRef.current = present;
        }
    }, [
        present,
        send
    ]);
    (0,_radix_ui_react_use_layout_effect__WEBPACK_IMPORTED_MODULE_3__/* .useLayoutEffect */ .b)(()=>{
        if (node1) {
            /**
       * Triggering an ANIMATION_OUT during an ANIMATION_IN will fire an `animationcancel`
       * event for ANIMATION_IN after we have entered `unmountSuspended` state. So, we
       * make sure we only trigger ANIMATION_END for the currently active animation.
       */ const handleAnimationEnd = (event)=>{
                const currentAnimationName = $921a889cee6df7e8$var$getAnimationName(stylesRef.current);
                const isCurrentAnimation = currentAnimationName.includes(event.animationName);
                if (event.target === node1 && isCurrentAnimation) // With React 18 concurrency this update is applied
                // a frame after the animation ends, creating a flash of visible content.
                // By manually flushing we ensure they sync within a frame, removing the flash.
                (0,react_dom__WEBPACK_IMPORTED_MODULE_1__.flushSync)(()=>send('ANIMATION_END')
                );
            };
            const handleAnimationStart = (event)=>{
                if (event.target === node1) // if animation occurred, store its name as the previous animation.
                prevAnimationNameRef.current = $921a889cee6df7e8$var$getAnimationName(stylesRef.current);
            };
            node1.addEventListener('animationstart', handleAnimationStart);
            node1.addEventListener('animationcancel', handleAnimationEnd);
            node1.addEventListener('animationend', handleAnimationEnd);
            return ()=>{
                node1.removeEventListener('animationstart', handleAnimationStart);
                node1.removeEventListener('animationcancel', handleAnimationEnd);
                node1.removeEventListener('animationend', handleAnimationEnd);
            };
        } else // Transition to the unmounted state if the node is removed prematurely.
        // We avoid doing so during cleanup as the node may change but still exist.
        send('ANIMATION_END');
    }, [
        node1,
        send
    ]);
    return {
        isPresent: [
            'mounted',
            'unmountSuspended'
        ].includes(state),
        ref: (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)((node)=>{
            if (node) stylesRef.current = getComputedStyle(node);
            setNode(node);
        }, [])
    };
}
/* -----------------------------------------------------------------------------------------------*/ function $921a889cee6df7e8$var$getAnimationName(styles) {
    return (styles === null || styles === void 0 ? void 0 : styles.animationName) || 'none';
}





//# sourceMappingURL=index.mjs.map


/***/ }),

/***/ 75320:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "WV": function() { return /* binding */ $8927f6f2acc4f386$export$250ffa63cdc0d034; },
/* harmony export */   "jH": function() { return /* binding */ $8927f6f2acc4f386$export$6d1a0317bde7de7f; }
/* harmony export */ });
/* unused harmony export Root */
/* harmony import */ var _babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(87462);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(55784);
/* harmony import */ var react_dom__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(18369);
/* harmony import */ var _radix_ui_react_slot__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(88426);









const $8927f6f2acc4f386$var$NODES = [
    'a',
    'button',
    'div',
    'form',
    'h2',
    'h3',
    'img',
    'input',
    'label',
    'li',
    'nav',
    'ol',
    'p',
    'span',
    'svg',
    'ul'
]; // Temporary while we await merge of this fix:
// https://github.com/DefinitelyTyped/DefinitelyTyped/pull/55396
// prettier-ignore
/* -------------------------------------------------------------------------------------------------
 * Primitive
 * -----------------------------------------------------------------------------------------------*/ const $8927f6f2acc4f386$export$250ffa63cdc0d034 = $8927f6f2acc4f386$var$NODES.reduce((primitive, node)=>{
    const Node = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_0__.forwardRef)((props, forwardedRef)=>{
        const { asChild: asChild , ...primitiveProps } = props;
        const Comp = asChild ? _radix_ui_react_slot__WEBPACK_IMPORTED_MODULE_2__/* .Slot */ .g7 : node;
        (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(()=>{
            window[Symbol.for('radix-ui')] = true;
        }, []);
        return /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_0__.createElement)(Comp, (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({}, primitiveProps, {
            ref: forwardedRef
        }));
    });
    Node.displayName = `Primitive.${node}`;
    return {
        ...primitive,
        [node]: Node
    };
}, {});
/* -------------------------------------------------------------------------------------------------
 * Utils
 * -----------------------------------------------------------------------------------------------*/ /**
 * Flush custom event dispatch
 * https://github.com/radix-ui/primitives/pull/1378
 *
 * React batches *all* event handlers since version 18, this introduces certain considerations when using custom event types.
 *
 * Internally, React prioritises events in the following order:
 *  - discrete
 *  - continuous
 *  - default
 *
 * https://github.com/facebook/react/blob/a8a4742f1c54493df00da648a3f9d26e3db9c8b5/packages/react-dom/src/events/ReactDOMEventListener.js#L294-L350
 *
 * `discrete` is an  important distinction as updates within these events are applied immediately.
 * React however, is not able to infer the priority of custom event types due to how they are detected internally.
 * Because of this, it's possible for updates from custom events to be unexpectedly batched when
 * dispatched by another `discrete` event.
 *
 * In order to ensure that updates from custom events are applied predictably, we need to manually flush the batch.
 * This utility should be used when dispatching a custom event from within another `discrete` event, this utility
 * is not nessesary when dispatching known event types, or if dispatching a custom type inside a non-discrete event.
 * For example:
 *
 * dispatching a known click 👎
 * target.dispatchEvent(new Event(‘click’))
 *
 * dispatching a custom type within a non-discrete event 👎
 * onScroll={(event) => event.target.dispatchEvent(new CustomEvent(‘customType’))}
 *
 * dispatching a custom type within a `discrete` event 👍
 * onPointerDown={(event) => dispatchDiscreteCustomEvent(event.target, new CustomEvent(‘customType’))}
 *
 * Note: though React classifies `focus`, `focusin` and `focusout` events as `discrete`, it's  not recommended to use
 * this utility with them. This is because it's possible for those handlers to be called implicitly during render
 * e.g. when focus is within a component as it is unmounted, or when managing focus on mount.
 */ function $8927f6f2acc4f386$export$6d1a0317bde7de7f(target, event) {
    if (target) (0,react_dom__WEBPACK_IMPORTED_MODULE_1__.flushSync)(()=>target.dispatchEvent(event)
    );
}
/* -----------------------------------------------------------------------------------------------*/ const $8927f6f2acc4f386$export$be92b6f5f03c0fe9 = (/* unused pure expression or super */ null && ($8927f6f2acc4f386$export$250ffa63cdc0d034));





//# sourceMappingURL=index.mjs.map


/***/ }),

/***/ 66681:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Pc": function() { return /* binding */ $d7bdfb9eb0fdf311$export$c7109489551a4f4; },
/* harmony export */   "ck": function() { return /* binding */ $d7bdfb9eb0fdf311$export$6d08773d2e66f8f2; },
/* harmony export */   "fC": function() { return /* binding */ $d7bdfb9eb0fdf311$export$be92b6f5f03c0fe9; }
/* harmony export */ });
/* unused harmony exports RovingFocusGroup, RovingFocusGroupItem */
/* harmony import */ var _babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(87462);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(55784);
/* harmony import */ var _radix_ui_primitive__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(36206);
/* harmony import */ var _radix_ui_react_collection__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(65936);
/* harmony import */ var _radix_ui_react_compose_refs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(28771);
/* harmony import */ var _radix_ui_react_context__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(25360);
/* harmony import */ var _radix_ui_react_id__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(91276);
/* harmony import */ var _radix_ui_react_primitive__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(75320);
/* harmony import */ var _radix_ui_react_use_callback_ref__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(79698);
/* harmony import */ var _radix_ui_react_use_controllable_state__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(77342);
/* harmony import */ var _radix_ui_react_direction__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(78990);























const $d7bdfb9eb0fdf311$var$ENTRY_FOCUS = 'rovingFocusGroup.onEntryFocus';
const $d7bdfb9eb0fdf311$var$EVENT_OPTIONS = {
    bubbles: false,
    cancelable: true
};
/* -------------------------------------------------------------------------------------------------
 * RovingFocusGroup
 * -----------------------------------------------------------------------------------------------*/ const $d7bdfb9eb0fdf311$var$GROUP_NAME = 'RovingFocusGroup';
const [$d7bdfb9eb0fdf311$var$Collection, $d7bdfb9eb0fdf311$var$useCollection, $d7bdfb9eb0fdf311$var$createCollectionScope] = (0,_radix_ui_react_collection__WEBPACK_IMPORTED_MODULE_1__/* .createCollection */ .B)($d7bdfb9eb0fdf311$var$GROUP_NAME);
const [$d7bdfb9eb0fdf311$var$createRovingFocusGroupContext, $d7bdfb9eb0fdf311$export$c7109489551a4f4] = (0,_radix_ui_react_context__WEBPACK_IMPORTED_MODULE_2__/* .createContextScope */ .b)($d7bdfb9eb0fdf311$var$GROUP_NAME, [
    $d7bdfb9eb0fdf311$var$createCollectionScope
]);
const [$d7bdfb9eb0fdf311$var$RovingFocusProvider, $d7bdfb9eb0fdf311$var$useRovingFocusContext] = $d7bdfb9eb0fdf311$var$createRovingFocusGroupContext($d7bdfb9eb0fdf311$var$GROUP_NAME);
const $d7bdfb9eb0fdf311$export$8699f7c8af148338 = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_0__.forwardRef)((props, forwardedRef)=>{
    return /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_0__.createElement)($d7bdfb9eb0fdf311$var$Collection.Provider, {
        scope: props.__scopeRovingFocusGroup
    }, /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_0__.createElement)($d7bdfb9eb0fdf311$var$Collection.Slot, {
        scope: props.__scopeRovingFocusGroup
    }, /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_0__.createElement)($d7bdfb9eb0fdf311$var$RovingFocusGroupImpl, (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({}, props, {
        ref: forwardedRef
    }))));
});
/*#__PURE__*/ Object.assign($d7bdfb9eb0fdf311$export$8699f7c8af148338, {
    displayName: $d7bdfb9eb0fdf311$var$GROUP_NAME
});
/* -----------------------------------------------------------------------------------------------*/ const $d7bdfb9eb0fdf311$var$RovingFocusGroupImpl = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_0__.forwardRef)((props, forwardedRef)=>{
    const { __scopeRovingFocusGroup: __scopeRovingFocusGroup , orientation: orientation , loop: loop = false , dir: dir , currentTabStopId: currentTabStopIdProp , defaultCurrentTabStopId: defaultCurrentTabStopId , onCurrentTabStopIdChange: onCurrentTabStopIdChange , onEntryFocus: onEntryFocus , ...groupProps } = props;
    const ref = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(null);
    const composedRefs = (0,_radix_ui_react_compose_refs__WEBPACK_IMPORTED_MODULE_4__/* .useComposedRefs */ .e)(forwardedRef, ref);
    const direction = (0,_radix_ui_react_direction__WEBPACK_IMPORTED_MODULE_5__/* .useDirection */ .gm)(dir);
    const [currentTabStopId = null, setCurrentTabStopId] = (0,_radix_ui_react_use_controllable_state__WEBPACK_IMPORTED_MODULE_6__/* .useControllableState */ .T)({
        prop: currentTabStopIdProp,
        defaultProp: defaultCurrentTabStopId,
        onChange: onCurrentTabStopIdChange
    });
    const [isTabbingBackOut, setIsTabbingBackOut] = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(false);
    const handleEntryFocus = (0,_radix_ui_react_use_callback_ref__WEBPACK_IMPORTED_MODULE_7__/* .useCallbackRef */ .W)(onEntryFocus);
    const getItems = $d7bdfb9eb0fdf311$var$useCollection(__scopeRovingFocusGroup);
    const isClickFocusRef = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(false);
    const [focusableItemsCount, setFocusableItemsCount] = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(0);
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(()=>{
        const node = ref.current;
        if (node) {
            node.addEventListener($d7bdfb9eb0fdf311$var$ENTRY_FOCUS, handleEntryFocus);
            return ()=>node.removeEventListener($d7bdfb9eb0fdf311$var$ENTRY_FOCUS, handleEntryFocus)
            ;
        }
    }, [
        handleEntryFocus
    ]);
    return /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_0__.createElement)($d7bdfb9eb0fdf311$var$RovingFocusProvider, {
        scope: __scopeRovingFocusGroup,
        orientation: orientation,
        dir: direction,
        loop: loop,
        currentTabStopId: currentTabStopId,
        onItemFocus: (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)((tabStopId)=>setCurrentTabStopId(tabStopId)
        , [
            setCurrentTabStopId
        ]),
        onItemShiftTab: (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(()=>setIsTabbingBackOut(true)
        , []),
        onFocusableItemAdd: (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(()=>setFocusableItemsCount((prevCount)=>prevCount + 1
            )
        , []),
        onFocusableItemRemove: (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(()=>setFocusableItemsCount((prevCount)=>prevCount - 1
            )
        , [])
    }, /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_0__.createElement)(_radix_ui_react_primitive__WEBPACK_IMPORTED_MODULE_8__/* .Primitive.div */ .WV.div, (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({
        tabIndex: isTabbingBackOut || focusableItemsCount === 0 ? -1 : 0,
        "data-orientation": orientation
    }, groupProps, {
        ref: composedRefs,
        style: {
            outline: 'none',
            ...props.style
        },
        onMouseDown: (0,_radix_ui_primitive__WEBPACK_IMPORTED_MODULE_9__/* .composeEventHandlers */ .M)(props.onMouseDown, ()=>{
            isClickFocusRef.current = true;
        }),
        onFocus: (0,_radix_ui_primitive__WEBPACK_IMPORTED_MODULE_9__/* .composeEventHandlers */ .M)(props.onFocus, (event)=>{
            // We normally wouldn't need this check, because we already check
            // that the focus is on the current target and not bubbling to it.
            // We do this because Safari doesn't focus buttons when clicked, and
            // instead, the wrapper will get focused and not through a bubbling event.
            const isKeyboardFocus = !isClickFocusRef.current;
            if (event.target === event.currentTarget && isKeyboardFocus && !isTabbingBackOut) {
                const entryFocusEvent = new CustomEvent($d7bdfb9eb0fdf311$var$ENTRY_FOCUS, $d7bdfb9eb0fdf311$var$EVENT_OPTIONS);
                event.currentTarget.dispatchEvent(entryFocusEvent);
                if (!entryFocusEvent.defaultPrevented) {
                    const items = getItems().filter((item)=>item.focusable
                    );
                    const activeItem = items.find((item)=>item.active
                    );
                    const currentItem = items.find((item)=>item.id === currentTabStopId
                    );
                    const candidateItems = [
                        activeItem,
                        currentItem,
                        ...items
                    ].filter(Boolean);
                    const candidateNodes = candidateItems.map((item)=>item.ref.current
                    );
                    $d7bdfb9eb0fdf311$var$focusFirst(candidateNodes);
                }
            }
            isClickFocusRef.current = false;
        }),
        onBlur: (0,_radix_ui_primitive__WEBPACK_IMPORTED_MODULE_9__/* .composeEventHandlers */ .M)(props.onBlur, ()=>setIsTabbingBackOut(false)
        )
    })));
});
/* -------------------------------------------------------------------------------------------------
 * RovingFocusGroupItem
 * -----------------------------------------------------------------------------------------------*/ const $d7bdfb9eb0fdf311$var$ITEM_NAME = 'RovingFocusGroupItem';
const $d7bdfb9eb0fdf311$export$ab9df7c53fe8454 = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_0__.forwardRef)((props, forwardedRef)=>{
    const { __scopeRovingFocusGroup: __scopeRovingFocusGroup , focusable: focusable = true , active: active = false , tabStopId: tabStopId , ...itemProps } = props;
    const autoId = (0,_radix_ui_react_id__WEBPACK_IMPORTED_MODULE_10__/* .useId */ .M)();
    const id = tabStopId || autoId;
    const context = $d7bdfb9eb0fdf311$var$useRovingFocusContext($d7bdfb9eb0fdf311$var$ITEM_NAME, __scopeRovingFocusGroup);
    const isCurrentTabStop = context.currentTabStopId === id;
    const getItems = $d7bdfb9eb0fdf311$var$useCollection(__scopeRovingFocusGroup);
    const { onFocusableItemAdd: onFocusableItemAdd , onFocusableItemRemove: onFocusableItemRemove  } = context;
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(()=>{
        if (focusable) {
            onFocusableItemAdd();
            return ()=>onFocusableItemRemove()
            ;
        }
    }, [
        focusable,
        onFocusableItemAdd,
        onFocusableItemRemove
    ]);
    return /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_0__.createElement)($d7bdfb9eb0fdf311$var$Collection.ItemSlot, {
        scope: __scopeRovingFocusGroup,
        id: id,
        focusable: focusable,
        active: active
    }, /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_0__.createElement)(_radix_ui_react_primitive__WEBPACK_IMPORTED_MODULE_8__/* .Primitive.span */ .WV.span, (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({
        tabIndex: isCurrentTabStop ? 0 : -1,
        "data-orientation": context.orientation
    }, itemProps, {
        ref: forwardedRef,
        onMouseDown: (0,_radix_ui_primitive__WEBPACK_IMPORTED_MODULE_9__/* .composeEventHandlers */ .M)(props.onMouseDown, (event)=>{
            // We prevent focusing non-focusable items on `mousedown`.
            // Even though the item has tabIndex={-1}, that only means take it out of the tab order.
            if (!focusable) event.preventDefault(); // Safari doesn't focus a button when clicked so we run our logic on mousedown also
            else context.onItemFocus(id);
        }),
        onFocus: (0,_radix_ui_primitive__WEBPACK_IMPORTED_MODULE_9__/* .composeEventHandlers */ .M)(props.onFocus, ()=>context.onItemFocus(id)
        ),
        onKeyDown: (0,_radix_ui_primitive__WEBPACK_IMPORTED_MODULE_9__/* .composeEventHandlers */ .M)(props.onKeyDown, (event)=>{
            if (event.key === 'Tab' && event.shiftKey) {
                context.onItemShiftTab();
                return;
            }
            if (event.target !== event.currentTarget) return;
            const focusIntent = $d7bdfb9eb0fdf311$var$getFocusIntent(event, context.orientation, context.dir);
            if (focusIntent !== undefined) {
                event.preventDefault();
                const items = getItems().filter((item)=>item.focusable
                );
                let candidateNodes = items.map((item)=>item.ref.current
                );
                if (focusIntent === 'last') candidateNodes.reverse();
                else if (focusIntent === 'prev' || focusIntent === 'next') {
                    if (focusIntent === 'prev') candidateNodes.reverse();
                    const currentIndex = candidateNodes.indexOf(event.currentTarget);
                    candidateNodes = context.loop ? $d7bdfb9eb0fdf311$var$wrapArray(candidateNodes, currentIndex + 1) : candidateNodes.slice(currentIndex + 1);
                }
                /**
         * Imperative focus during keydown is risky so we prevent React's batching updates
         * to avoid potential bugs. See: https://github.com/facebook/react/issues/20332
         */ setTimeout(()=>$d7bdfb9eb0fdf311$var$focusFirst(candidateNodes)
                );
            }
        })
    })));
});
/*#__PURE__*/ Object.assign($d7bdfb9eb0fdf311$export$ab9df7c53fe8454, {
    displayName: $d7bdfb9eb0fdf311$var$ITEM_NAME
});
/* -----------------------------------------------------------------------------------------------*/ // prettier-ignore
const $d7bdfb9eb0fdf311$var$MAP_KEY_TO_FOCUS_INTENT = {
    ArrowLeft: 'prev',
    ArrowUp: 'prev',
    ArrowRight: 'next',
    ArrowDown: 'next',
    PageUp: 'first',
    Home: 'first',
    PageDown: 'last',
    End: 'last'
};
function $d7bdfb9eb0fdf311$var$getDirectionAwareKey(key, dir) {
    if (dir !== 'rtl') return key;
    return key === 'ArrowLeft' ? 'ArrowRight' : key === 'ArrowRight' ? 'ArrowLeft' : key;
}
function $d7bdfb9eb0fdf311$var$getFocusIntent(event, orientation, dir) {
    const key = $d7bdfb9eb0fdf311$var$getDirectionAwareKey(event.key, dir);
    if (orientation === 'vertical' && [
        'ArrowLeft',
        'ArrowRight'
    ].includes(key)) return undefined;
    if (orientation === 'horizontal' && [
        'ArrowUp',
        'ArrowDown'
    ].includes(key)) return undefined;
    return $d7bdfb9eb0fdf311$var$MAP_KEY_TO_FOCUS_INTENT[key];
}
function $d7bdfb9eb0fdf311$var$focusFirst(candidates) {
    const PREVIOUSLY_FOCUSED_ELEMENT = document.activeElement;
    for (const candidate of candidates){
        // if focus is already where we want to go, we don't want to keep going through the candidates
        if (candidate === PREVIOUSLY_FOCUSED_ELEMENT) return;
        candidate.focus();
        if (document.activeElement !== PREVIOUSLY_FOCUSED_ELEMENT) return;
    }
}
/**
 * Wraps an array around itself at a given start index
 * Example: `wrapArray(['a', 'b', 'c', 'd'], 2) === ['c', 'd', 'a', 'b']`
 */ function $d7bdfb9eb0fdf311$var$wrapArray(array, startIndex) {
    return array.map((_, index)=>array[(startIndex + index) % array.length]
    );
}
const $d7bdfb9eb0fdf311$export$be92b6f5f03c0fe9 = $d7bdfb9eb0fdf311$export$8699f7c8af148338;
const $d7bdfb9eb0fdf311$export$6d08773d2e66f8f2 = $d7bdfb9eb0fdf311$export$ab9df7c53fe8454;





//# sourceMappingURL=index.mjs.map


/***/ }),

/***/ 25443:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Ns": function() { return /* binding */ $57acba87d6e25586$export$ac61190d9fc311a9; },
/* harmony export */   "fC": function() { return /* binding */ $57acba87d6e25586$export$be92b6f5f03c0fe9; },
/* harmony export */   "gb": function() { return /* binding */ $57acba87d6e25586$export$2fabd85d0eba3c57; },
/* harmony export */   "l_": function() { return /* binding */ $57acba87d6e25586$export$d5c6c08dc2d3ca7; },
/* harmony export */   "q4": function() { return /* binding */ $57acba87d6e25586$export$9fba1154677d7cd2; },
/* harmony export */   "xr": function() { return /* binding */ $57acba87d6e25586$export$ccf8d8d7bbf3c2cc; }
/* harmony export */ });
/* unused harmony exports createScrollAreaScope, ScrollAreaViewport, ScrollAreaCorner, Scrollbar, Thumb */
/* harmony import */ var _babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(87462);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(55784);
/* harmony import */ var _radix_ui_react_primitive__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(75320);
/* harmony import */ var _radix_ui_react_presence__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(29115);
/* harmony import */ var _radix_ui_react_context__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(25360);
/* harmony import */ var _radix_ui_react_compose_refs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(28771);
/* harmony import */ var _radix_ui_react_use_callback_ref__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(79698);
/* harmony import */ var _radix_ui_react_direction__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(78990);
/* harmony import */ var _radix_ui_react_use_layout_effect__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(9981);
/* harmony import */ var _radix_ui_number__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(42614);
/* harmony import */ var _radix_ui_primitive__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(36206);
























function $6c2e24571c90391f$export$3e6543de14f8614f(initialState, machine) {
    return (0,react__WEBPACK_IMPORTED_MODULE_0__.useReducer)((state, event)=>{
        const nextState = machine[state][event];
        return nextState !== null && nextState !== void 0 ? nextState : state;
    }, initialState);
}


/* -------------------------------------------------------------------------------------------------
 * ScrollArea
 * -----------------------------------------------------------------------------------------------*/ const $57acba87d6e25586$var$SCROLL_AREA_NAME = 'ScrollArea';
const [$57acba87d6e25586$var$createScrollAreaContext, $57acba87d6e25586$export$488468afe3a6f2b1] = (0,_radix_ui_react_context__WEBPACK_IMPORTED_MODULE_1__/* .createContextScope */ .b)($57acba87d6e25586$var$SCROLL_AREA_NAME);
const [$57acba87d6e25586$var$ScrollAreaProvider, $57acba87d6e25586$var$useScrollAreaContext] = $57acba87d6e25586$var$createScrollAreaContext($57acba87d6e25586$var$SCROLL_AREA_NAME);
const $57acba87d6e25586$export$ccf8d8d7bbf3c2cc = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_0__.forwardRef)((props, forwardedRef)=>{
    const { __scopeScrollArea: __scopeScrollArea , type: type = 'hover' , dir: dir , scrollHideDelay: scrollHideDelay = 600 , ...scrollAreaProps } = props;
    const [scrollArea, setScrollArea] = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(null);
    const [viewport, setViewport] = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(null);
    const [content, setContent] = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(null);
    const [scrollbarX, setScrollbarX] = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(null);
    const [scrollbarY, setScrollbarY] = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(null);
    const [cornerWidth, setCornerWidth] = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(0);
    const [cornerHeight, setCornerHeight] = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(0);
    const [scrollbarXEnabled, setScrollbarXEnabled] = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(false);
    const [scrollbarYEnabled, setScrollbarYEnabled] = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(false);
    const composedRefs = (0,_radix_ui_react_compose_refs__WEBPACK_IMPORTED_MODULE_2__/* .useComposedRefs */ .e)(forwardedRef, (node)=>setScrollArea(node)
    );
    const direction = (0,_radix_ui_react_direction__WEBPACK_IMPORTED_MODULE_3__/* .useDirection */ .gm)(dir);
    return /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_0__.createElement)($57acba87d6e25586$var$ScrollAreaProvider, {
        scope: __scopeScrollArea,
        type: type,
        dir: direction,
        scrollHideDelay: scrollHideDelay,
        scrollArea: scrollArea,
        viewport: viewport,
        onViewportChange: setViewport,
        content: content,
        onContentChange: setContent,
        scrollbarX: scrollbarX,
        onScrollbarXChange: setScrollbarX,
        scrollbarXEnabled: scrollbarXEnabled,
        onScrollbarXEnabledChange: setScrollbarXEnabled,
        scrollbarY: scrollbarY,
        onScrollbarYChange: setScrollbarY,
        scrollbarYEnabled: scrollbarYEnabled,
        onScrollbarYEnabledChange: setScrollbarYEnabled,
        onCornerWidthChange: setCornerWidth,
        onCornerHeightChange: setCornerHeight
    }, /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_0__.createElement)(_radix_ui_react_primitive__WEBPACK_IMPORTED_MODULE_4__/* .Primitive.div */ .WV.div, (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({
        dir: direction
    }, scrollAreaProps, {
        ref: composedRefs,
        style: {
            position: 'relative',
            // Pass corner sizes as CSS vars to reduce re-renders of context consumers
            ['--radix-scroll-area-corner-width']: cornerWidth + 'px',
            ['--radix-scroll-area-corner-height']: cornerHeight + 'px',
            ...props.style
        }
    })));
});
/*#__PURE__*/ Object.assign($57acba87d6e25586$export$ccf8d8d7bbf3c2cc, {
    displayName: $57acba87d6e25586$var$SCROLL_AREA_NAME
});
/* -------------------------------------------------------------------------------------------------
 * ScrollAreaViewport
 * -----------------------------------------------------------------------------------------------*/ const $57acba87d6e25586$var$VIEWPORT_NAME = 'ScrollAreaViewport';
const $57acba87d6e25586$export$a21cbf9f11fca853 = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_0__.forwardRef)((props, forwardedRef)=>{
    const { __scopeScrollArea: __scopeScrollArea , children: children , ...viewportProps } = props;
    const context = $57acba87d6e25586$var$useScrollAreaContext($57acba87d6e25586$var$VIEWPORT_NAME, __scopeScrollArea);
    const ref = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(null);
    const composedRefs = (0,_radix_ui_react_compose_refs__WEBPACK_IMPORTED_MODULE_2__/* .useComposedRefs */ .e)(forwardedRef, ref, context.onViewportChange);
    return /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_0__.createElement)(react__WEBPACK_IMPORTED_MODULE_0__.Fragment, null, /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_0__.createElement)("style", {
        dangerouslySetInnerHTML: {
            __html: `[data-radix-scroll-area-viewport]{scrollbar-width:none;-ms-overflow-style:none;-webkit-overflow-scrolling:touch;}[data-radix-scroll-area-viewport]::-webkit-scrollbar{display:none}`
        }
    }), /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_0__.createElement)(_radix_ui_react_primitive__WEBPACK_IMPORTED_MODULE_4__/* .Primitive.div */ .WV.div, (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({
        "data-radix-scroll-area-viewport": ""
    }, viewportProps, {
        ref: composedRefs,
        style: {
            /**
       * We don't support `visible` because the intention is to have at least one scrollbar
       * if this component is used and `visible` will behave like `auto` in that case
       * https://developer.mozilla.org/en-US/docs/Web/CSS/overflowed#description
       *
       * We don't handle `auto` because the intention is for the native implementation
       * to be hidden if using this component. We just want to ensure the node is scrollable
       * so could have used either `scroll` or `auto` here. We picked `scroll` to prevent
       * the browser from having to work out whether to render native scrollbars or not,
       * we tell it to with the intention of hiding them in CSS.
       */ overflowX: context.scrollbarXEnabled ? 'scroll' : 'hidden',
            overflowY: context.scrollbarYEnabled ? 'scroll' : 'hidden',
            ...props.style
        }
    }), /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_0__.createElement)("div", {
        ref: context.onContentChange,
        style: {
            minWidth: '100%',
            display: 'table'
        }
    }, children)));
});
/*#__PURE__*/ Object.assign($57acba87d6e25586$export$a21cbf9f11fca853, {
    displayName: $57acba87d6e25586$var$VIEWPORT_NAME
});
/* -------------------------------------------------------------------------------------------------
 * ScrollAreaScrollbar
 * -----------------------------------------------------------------------------------------------*/ const $57acba87d6e25586$var$SCROLLBAR_NAME = 'ScrollAreaScrollbar';
const $57acba87d6e25586$export$2fabd85d0eba3c57 = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_0__.forwardRef)((props, forwardedRef)=>{
    const { forceMount: forceMount , ...scrollbarProps } = props;
    const context = $57acba87d6e25586$var$useScrollAreaContext($57acba87d6e25586$var$SCROLLBAR_NAME, props.__scopeScrollArea);
    const { onScrollbarXEnabledChange: onScrollbarXEnabledChange , onScrollbarYEnabledChange: onScrollbarYEnabledChange  } = context;
    const isHorizontal = props.orientation === 'horizontal';
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(()=>{
        isHorizontal ? onScrollbarXEnabledChange(true) : onScrollbarYEnabledChange(true);
        return ()=>{
            isHorizontal ? onScrollbarXEnabledChange(false) : onScrollbarYEnabledChange(false);
        };
    }, [
        isHorizontal,
        onScrollbarXEnabledChange,
        onScrollbarYEnabledChange
    ]);
    return context.type === 'hover' ? /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_0__.createElement)($57acba87d6e25586$var$ScrollAreaScrollbarHover, (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({}, scrollbarProps, {
        ref: forwardedRef,
        forceMount: forceMount
    })) : context.type === 'scroll' ? /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_0__.createElement)($57acba87d6e25586$var$ScrollAreaScrollbarScroll, (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({}, scrollbarProps, {
        ref: forwardedRef,
        forceMount: forceMount
    })) : context.type === 'auto' ? /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_0__.createElement)($57acba87d6e25586$var$ScrollAreaScrollbarAuto, (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({}, scrollbarProps, {
        ref: forwardedRef,
        forceMount: forceMount
    })) : context.type === 'always' ? /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_0__.createElement)($57acba87d6e25586$var$ScrollAreaScrollbarVisible, (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({}, scrollbarProps, {
        ref: forwardedRef
    })) : null;
});
/*#__PURE__*/ Object.assign($57acba87d6e25586$export$2fabd85d0eba3c57, {
    displayName: $57acba87d6e25586$var$SCROLLBAR_NAME
});
/* -----------------------------------------------------------------------------------------------*/ const $57acba87d6e25586$var$ScrollAreaScrollbarHover = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_0__.forwardRef)((props, forwardedRef)=>{
    const { forceMount: forceMount , ...scrollbarProps } = props;
    const context = $57acba87d6e25586$var$useScrollAreaContext($57acba87d6e25586$var$SCROLLBAR_NAME, props.__scopeScrollArea);
    const [visible, setVisible] = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(false);
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(()=>{
        const scrollArea = context.scrollArea;
        let hideTimer = 0;
        if (scrollArea) {
            const handlePointerEnter = ()=>{
                window.clearTimeout(hideTimer);
                setVisible(true);
            };
            const handlePointerLeave = ()=>{
                hideTimer = window.setTimeout(()=>setVisible(false)
                , context.scrollHideDelay);
            };
            scrollArea.addEventListener('pointerenter', handlePointerEnter);
            scrollArea.addEventListener('pointerleave', handlePointerLeave);
            return ()=>{
                window.clearTimeout(hideTimer);
                scrollArea.removeEventListener('pointerenter', handlePointerEnter);
                scrollArea.removeEventListener('pointerleave', handlePointerLeave);
            };
        }
    }, [
        context.scrollArea,
        context.scrollHideDelay
    ]);
    return /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_0__.createElement)(_radix_ui_react_presence__WEBPACK_IMPORTED_MODULE_6__/* .Presence */ .z, {
        present: forceMount || visible
    }, /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_0__.createElement)($57acba87d6e25586$var$ScrollAreaScrollbarAuto, (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({
        "data-state": visible ? 'visible' : 'hidden'
    }, scrollbarProps, {
        ref: forwardedRef
    })));
});
const $57acba87d6e25586$var$ScrollAreaScrollbarScroll = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_0__.forwardRef)((props, forwardedRef)=>{
    const { forceMount: forceMount , ...scrollbarProps } = props;
    const context = $57acba87d6e25586$var$useScrollAreaContext($57acba87d6e25586$var$SCROLLBAR_NAME, props.__scopeScrollArea);
    const isHorizontal = props.orientation === 'horizontal';
    const debounceScrollEnd = $57acba87d6e25586$var$useDebounceCallback(()=>send('SCROLL_END')
    , 100);
    const [state, send] = $6c2e24571c90391f$export$3e6543de14f8614f('hidden', {
        hidden: {
            SCROLL: 'scrolling'
        },
        scrolling: {
            SCROLL_END: 'idle',
            POINTER_ENTER: 'interacting'
        },
        interacting: {
            SCROLL: 'interacting',
            POINTER_LEAVE: 'idle'
        },
        idle: {
            HIDE: 'hidden',
            SCROLL: 'scrolling',
            POINTER_ENTER: 'interacting'
        }
    });
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(()=>{
        if (state === 'idle') {
            const hideTimer = window.setTimeout(()=>send('HIDE')
            , context.scrollHideDelay);
            return ()=>window.clearTimeout(hideTimer)
            ;
        }
    }, [
        state,
        context.scrollHideDelay,
        send
    ]);
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(()=>{
        const viewport = context.viewport;
        const scrollDirection = isHorizontal ? 'scrollLeft' : 'scrollTop';
        if (viewport) {
            let prevScrollPos = viewport[scrollDirection];
            const handleScroll = ()=>{
                const scrollPos = viewport[scrollDirection];
                const hasScrollInDirectionChanged = prevScrollPos !== scrollPos;
                if (hasScrollInDirectionChanged) {
                    send('SCROLL');
                    debounceScrollEnd();
                }
                prevScrollPos = scrollPos;
            };
            viewport.addEventListener('scroll', handleScroll);
            return ()=>viewport.removeEventListener('scroll', handleScroll)
            ;
        }
    }, [
        context.viewport,
        isHorizontal,
        send,
        debounceScrollEnd
    ]);
    return /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_0__.createElement)(_radix_ui_react_presence__WEBPACK_IMPORTED_MODULE_6__/* .Presence */ .z, {
        present: forceMount || state !== 'hidden'
    }, /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_0__.createElement)($57acba87d6e25586$var$ScrollAreaScrollbarVisible, (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({
        "data-state": state === 'hidden' ? 'hidden' : 'visible'
    }, scrollbarProps, {
        ref: forwardedRef,
        onPointerEnter: (0,_radix_ui_primitive__WEBPACK_IMPORTED_MODULE_7__/* .composeEventHandlers */ .M)(props.onPointerEnter, ()=>send('POINTER_ENTER')
        ),
        onPointerLeave: (0,_radix_ui_primitive__WEBPACK_IMPORTED_MODULE_7__/* .composeEventHandlers */ .M)(props.onPointerLeave, ()=>send('POINTER_LEAVE')
        )
    })));
});
const $57acba87d6e25586$var$ScrollAreaScrollbarAuto = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_0__.forwardRef)((props, forwardedRef)=>{
    const context = $57acba87d6e25586$var$useScrollAreaContext($57acba87d6e25586$var$SCROLLBAR_NAME, props.__scopeScrollArea);
    const { forceMount: forceMount , ...scrollbarProps } = props;
    const [visible, setVisible] = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(false);
    const isHorizontal = props.orientation === 'horizontal';
    const handleResize = $57acba87d6e25586$var$useDebounceCallback(()=>{
        if (context.viewport) {
            const isOverflowX = context.viewport.offsetWidth < context.viewport.scrollWidth;
            const isOverflowY = context.viewport.offsetHeight < context.viewport.scrollHeight;
            setVisible(isHorizontal ? isOverflowX : isOverflowY);
        }
    }, 10);
    $57acba87d6e25586$var$useResizeObserver(context.viewport, handleResize);
    $57acba87d6e25586$var$useResizeObserver(context.content, handleResize);
    return /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_0__.createElement)(_radix_ui_react_presence__WEBPACK_IMPORTED_MODULE_6__/* .Presence */ .z, {
        present: forceMount || visible
    }, /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_0__.createElement)($57acba87d6e25586$var$ScrollAreaScrollbarVisible, (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({
        "data-state": visible ? 'visible' : 'hidden'
    }, scrollbarProps, {
        ref: forwardedRef
    })));
});
/* -----------------------------------------------------------------------------------------------*/ const $57acba87d6e25586$var$ScrollAreaScrollbarVisible = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_0__.forwardRef)((props, forwardedRef)=>{
    const { orientation: orientation = 'vertical' , ...scrollbarProps } = props;
    const context = $57acba87d6e25586$var$useScrollAreaContext($57acba87d6e25586$var$SCROLLBAR_NAME, props.__scopeScrollArea);
    const thumbRef = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(null);
    const pointerOffsetRef = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(0);
    const [sizes, setSizes] = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)({
        content: 0,
        viewport: 0,
        scrollbar: {
            size: 0,
            paddingStart: 0,
            paddingEnd: 0
        }
    });
    const thumbRatio = $57acba87d6e25586$var$getThumbRatio(sizes.viewport, sizes.content);
    const commonProps = {
        ...scrollbarProps,
        sizes: sizes,
        onSizesChange: setSizes,
        hasThumb: Boolean(thumbRatio > 0 && thumbRatio < 1),
        onThumbChange: (thumb)=>thumbRef.current = thumb
        ,
        onThumbPointerUp: ()=>pointerOffsetRef.current = 0
        ,
        onThumbPointerDown: (pointerPos)=>pointerOffsetRef.current = pointerPos
    };
    function getScrollPosition(pointerPos, dir) {
        return $57acba87d6e25586$var$getScrollPositionFromPointer(pointerPos, pointerOffsetRef.current, sizes, dir);
    }
    if (orientation === 'horizontal') return /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_0__.createElement)($57acba87d6e25586$var$ScrollAreaScrollbarX, (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({}, commonProps, {
        ref: forwardedRef,
        onThumbPositionChange: ()=>{
            if (context.viewport && thumbRef.current) {
                const scrollPos = context.viewport.scrollLeft;
                const offset = $57acba87d6e25586$var$getThumbOffsetFromScroll(scrollPos, sizes, context.dir);
                thumbRef.current.style.transform = `translate3d(${offset}px, 0, 0)`;
            }
        },
        onWheelScroll: (scrollPos)=>{
            if (context.viewport) context.viewport.scrollLeft = scrollPos;
        },
        onDragScroll: (pointerPos)=>{
            if (context.viewport) context.viewport.scrollLeft = getScrollPosition(pointerPos, context.dir);
        }
    }));
    if (orientation === 'vertical') return /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_0__.createElement)($57acba87d6e25586$var$ScrollAreaScrollbarY, (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({}, commonProps, {
        ref: forwardedRef,
        onThumbPositionChange: ()=>{
            if (context.viewport && thumbRef.current) {
                const scrollPos = context.viewport.scrollTop;
                const offset = $57acba87d6e25586$var$getThumbOffsetFromScroll(scrollPos, sizes);
                thumbRef.current.style.transform = `translate3d(0, ${offset}px, 0)`;
            }
        },
        onWheelScroll: (scrollPos)=>{
            if (context.viewport) context.viewport.scrollTop = scrollPos;
        },
        onDragScroll: (pointerPos)=>{
            if (context.viewport) context.viewport.scrollTop = getScrollPosition(pointerPos);
        }
    }));
    return null;
});
/* -----------------------------------------------------------------------------------------------*/ const $57acba87d6e25586$var$ScrollAreaScrollbarX = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_0__.forwardRef)((props, forwardedRef)=>{
    const { sizes: sizes , onSizesChange: onSizesChange , ...scrollbarProps } = props;
    const context = $57acba87d6e25586$var$useScrollAreaContext($57acba87d6e25586$var$SCROLLBAR_NAME, props.__scopeScrollArea);
    const [computedStyle, setComputedStyle] = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)();
    const ref = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(null);
    const composeRefs = (0,_radix_ui_react_compose_refs__WEBPACK_IMPORTED_MODULE_2__/* .useComposedRefs */ .e)(forwardedRef, ref, context.onScrollbarXChange);
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(()=>{
        if (ref.current) setComputedStyle(getComputedStyle(ref.current));
    }, [
        ref
    ]);
    return /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_0__.createElement)($57acba87d6e25586$var$ScrollAreaScrollbarImpl, (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({
        "data-orientation": "horizontal"
    }, scrollbarProps, {
        ref: composeRefs,
        sizes: sizes,
        style: {
            bottom: 0,
            left: context.dir === 'rtl' ? 'var(--radix-scroll-area-corner-width)' : 0,
            right: context.dir === 'ltr' ? 'var(--radix-scroll-area-corner-width)' : 0,
            ['--radix-scroll-area-thumb-width']: $57acba87d6e25586$var$getThumbSize(sizes) + 'px',
            ...props.style
        },
        onThumbPointerDown: (pointerPos)=>props.onThumbPointerDown(pointerPos.x)
        ,
        onDragScroll: (pointerPos)=>props.onDragScroll(pointerPos.x)
        ,
        onWheelScroll: (event, maxScrollPos)=>{
            if (context.viewport) {
                const scrollPos = context.viewport.scrollLeft + event.deltaX;
                props.onWheelScroll(scrollPos); // prevent window scroll when wheeling on scrollbar
                if ($57acba87d6e25586$var$isScrollingWithinScrollbarBounds(scrollPos, maxScrollPos)) event.preventDefault();
            }
        },
        onResize: ()=>{
            if (ref.current && context.viewport && computedStyle) onSizesChange({
                content: context.viewport.scrollWidth,
                viewport: context.viewport.offsetWidth,
                scrollbar: {
                    size: ref.current.clientWidth,
                    paddingStart: $57acba87d6e25586$var$toInt(computedStyle.paddingLeft),
                    paddingEnd: $57acba87d6e25586$var$toInt(computedStyle.paddingRight)
                }
            });
        }
    }));
});
const $57acba87d6e25586$var$ScrollAreaScrollbarY = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_0__.forwardRef)((props, forwardedRef)=>{
    const { sizes: sizes , onSizesChange: onSizesChange , ...scrollbarProps } = props;
    const context = $57acba87d6e25586$var$useScrollAreaContext($57acba87d6e25586$var$SCROLLBAR_NAME, props.__scopeScrollArea);
    const [computedStyle, setComputedStyle] = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)();
    const ref = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(null);
    const composeRefs = (0,_radix_ui_react_compose_refs__WEBPACK_IMPORTED_MODULE_2__/* .useComposedRefs */ .e)(forwardedRef, ref, context.onScrollbarYChange);
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(()=>{
        if (ref.current) setComputedStyle(getComputedStyle(ref.current));
    }, [
        ref
    ]);
    return /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_0__.createElement)($57acba87d6e25586$var$ScrollAreaScrollbarImpl, (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({
        "data-orientation": "vertical"
    }, scrollbarProps, {
        ref: composeRefs,
        sizes: sizes,
        style: {
            top: 0,
            right: context.dir === 'ltr' ? 0 : undefined,
            left: context.dir === 'rtl' ? 0 : undefined,
            bottom: 'var(--radix-scroll-area-corner-height)',
            ['--radix-scroll-area-thumb-height']: $57acba87d6e25586$var$getThumbSize(sizes) + 'px',
            ...props.style
        },
        onThumbPointerDown: (pointerPos)=>props.onThumbPointerDown(pointerPos.y)
        ,
        onDragScroll: (pointerPos)=>props.onDragScroll(pointerPos.y)
        ,
        onWheelScroll: (event, maxScrollPos)=>{
            if (context.viewport) {
                const scrollPos = context.viewport.scrollTop + event.deltaY;
                props.onWheelScroll(scrollPos); // prevent window scroll when wheeling on scrollbar
                if ($57acba87d6e25586$var$isScrollingWithinScrollbarBounds(scrollPos, maxScrollPos)) event.preventDefault();
            }
        },
        onResize: ()=>{
            if (ref.current && context.viewport && computedStyle) onSizesChange({
                content: context.viewport.scrollHeight,
                viewport: context.viewport.offsetHeight,
                scrollbar: {
                    size: ref.current.clientHeight,
                    paddingStart: $57acba87d6e25586$var$toInt(computedStyle.paddingTop),
                    paddingEnd: $57acba87d6e25586$var$toInt(computedStyle.paddingBottom)
                }
            });
        }
    }));
});
/* -----------------------------------------------------------------------------------------------*/ const [$57acba87d6e25586$var$ScrollbarProvider, $57acba87d6e25586$var$useScrollbarContext] = $57acba87d6e25586$var$createScrollAreaContext($57acba87d6e25586$var$SCROLLBAR_NAME);
const $57acba87d6e25586$var$ScrollAreaScrollbarImpl = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_0__.forwardRef)((props, forwardedRef)=>{
    const { __scopeScrollArea: __scopeScrollArea , sizes: sizes , hasThumb: hasThumb , onThumbChange: onThumbChange , onThumbPointerUp: onThumbPointerUp , onThumbPointerDown: onThumbPointerDown , onThumbPositionChange: onThumbPositionChange , onDragScroll: onDragScroll , onWheelScroll: onWheelScroll , onResize: onResize , ...scrollbarProps } = props;
    const context = $57acba87d6e25586$var$useScrollAreaContext($57acba87d6e25586$var$SCROLLBAR_NAME, __scopeScrollArea);
    const [scrollbar, setScrollbar] = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(null);
    const composeRefs = (0,_radix_ui_react_compose_refs__WEBPACK_IMPORTED_MODULE_2__/* .useComposedRefs */ .e)(forwardedRef, (node)=>setScrollbar(node)
    );
    const rectRef = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(null);
    const prevWebkitUserSelectRef = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)('');
    const viewport = context.viewport;
    const maxScrollPos = sizes.content - sizes.viewport;
    const handleWheelScroll = (0,_radix_ui_react_use_callback_ref__WEBPACK_IMPORTED_MODULE_8__/* .useCallbackRef */ .W)(onWheelScroll);
    const handleThumbPositionChange = (0,_radix_ui_react_use_callback_ref__WEBPACK_IMPORTED_MODULE_8__/* .useCallbackRef */ .W)(onThumbPositionChange);
    const handleResize = $57acba87d6e25586$var$useDebounceCallback(onResize, 10);
    function handleDragScroll(event) {
        if (rectRef.current) {
            const x = event.clientX - rectRef.current.left;
            const y = event.clientY - rectRef.current.top;
            onDragScroll({
                x: x,
                y: y
            });
        }
    }
    /**
   * We bind wheel event imperatively so we can switch off passive
   * mode for document wheel event to allow it to be prevented
   */ (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(()=>{
        const handleWheel = (event)=>{
            const element = event.target;
            const isScrollbarWheel = scrollbar === null || scrollbar === void 0 ? void 0 : scrollbar.contains(element);
            if (isScrollbarWheel) handleWheelScroll(event, maxScrollPos);
        };
        document.addEventListener('wheel', handleWheel, {
            passive: false
        });
        return ()=>document.removeEventListener('wheel', handleWheel, {
                passive: false
            })
        ;
    }, [
        viewport,
        scrollbar,
        maxScrollPos,
        handleWheelScroll
    ]);
    /**
   * Update thumb position on sizes change
   */ (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(handleThumbPositionChange, [
        sizes,
        handleThumbPositionChange
    ]);
    $57acba87d6e25586$var$useResizeObserver(scrollbar, handleResize);
    $57acba87d6e25586$var$useResizeObserver(context.content, handleResize);
    return /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_0__.createElement)($57acba87d6e25586$var$ScrollbarProvider, {
        scope: __scopeScrollArea,
        scrollbar: scrollbar,
        hasThumb: hasThumb,
        onThumbChange: (0,_radix_ui_react_use_callback_ref__WEBPACK_IMPORTED_MODULE_8__/* .useCallbackRef */ .W)(onThumbChange),
        onThumbPointerUp: (0,_radix_ui_react_use_callback_ref__WEBPACK_IMPORTED_MODULE_8__/* .useCallbackRef */ .W)(onThumbPointerUp),
        onThumbPositionChange: handleThumbPositionChange,
        onThumbPointerDown: (0,_radix_ui_react_use_callback_ref__WEBPACK_IMPORTED_MODULE_8__/* .useCallbackRef */ .W)(onThumbPointerDown)
    }, /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_0__.createElement)(_radix_ui_react_primitive__WEBPACK_IMPORTED_MODULE_4__/* .Primitive.div */ .WV.div, (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({}, scrollbarProps, {
        ref: composeRefs,
        style: {
            position: 'absolute',
            ...scrollbarProps.style
        },
        onPointerDown: (0,_radix_ui_primitive__WEBPACK_IMPORTED_MODULE_7__/* .composeEventHandlers */ .M)(props.onPointerDown, (event)=>{
            const mainPointer = 0;
            if (event.button === mainPointer) {
                const element = event.target;
                element.setPointerCapture(event.pointerId);
                rectRef.current = scrollbar.getBoundingClientRect(); // pointer capture doesn't prevent text selection in Safari
                // so we remove text selection manually when scrolling
                prevWebkitUserSelectRef.current = document.body.style.webkitUserSelect;
                document.body.style.webkitUserSelect = 'none';
                if (context.viewport) context.viewport.style.scrollBehavior = 'auto';
                handleDragScroll(event);
            }
        }),
        onPointerMove: (0,_radix_ui_primitive__WEBPACK_IMPORTED_MODULE_7__/* .composeEventHandlers */ .M)(props.onPointerMove, handleDragScroll),
        onPointerUp: (0,_radix_ui_primitive__WEBPACK_IMPORTED_MODULE_7__/* .composeEventHandlers */ .M)(props.onPointerUp, (event)=>{
            const element = event.target;
            if (element.hasPointerCapture(event.pointerId)) element.releasePointerCapture(event.pointerId);
            document.body.style.webkitUserSelect = prevWebkitUserSelectRef.current;
            if (context.viewport) context.viewport.style.scrollBehavior = '';
            rectRef.current = null;
        })
    })));
});
/* -------------------------------------------------------------------------------------------------
 * ScrollAreaThumb
 * -----------------------------------------------------------------------------------------------*/ const $57acba87d6e25586$var$THUMB_NAME = 'ScrollAreaThumb';
const $57acba87d6e25586$export$9fba1154677d7cd2 = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_0__.forwardRef)((props, forwardedRef)=>{
    const { forceMount: forceMount , ...thumbProps } = props;
    const scrollbarContext = $57acba87d6e25586$var$useScrollbarContext($57acba87d6e25586$var$THUMB_NAME, props.__scopeScrollArea);
    return /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_0__.createElement)(_radix_ui_react_presence__WEBPACK_IMPORTED_MODULE_6__/* .Presence */ .z, {
        present: forceMount || scrollbarContext.hasThumb
    }, /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_0__.createElement)($57acba87d6e25586$var$ScrollAreaThumbImpl, (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({
        ref: forwardedRef
    }, thumbProps)));
});
const $57acba87d6e25586$var$ScrollAreaThumbImpl = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_0__.forwardRef)((props, forwardedRef)=>{
    const { __scopeScrollArea: __scopeScrollArea , style: style , ...thumbProps } = props;
    const scrollAreaContext = $57acba87d6e25586$var$useScrollAreaContext($57acba87d6e25586$var$THUMB_NAME, __scopeScrollArea);
    const scrollbarContext = $57acba87d6e25586$var$useScrollbarContext($57acba87d6e25586$var$THUMB_NAME, __scopeScrollArea);
    const { onThumbPositionChange: onThumbPositionChange  } = scrollbarContext;
    const composedRef = (0,_radix_ui_react_compose_refs__WEBPACK_IMPORTED_MODULE_2__/* .useComposedRefs */ .e)(forwardedRef, (node)=>scrollbarContext.onThumbChange(node)
    );
    const removeUnlinkedScrollListenerRef = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)();
    const debounceScrollEnd = $57acba87d6e25586$var$useDebounceCallback(()=>{
        if (removeUnlinkedScrollListenerRef.current) {
            removeUnlinkedScrollListenerRef.current();
            removeUnlinkedScrollListenerRef.current = undefined;
        }
    }, 100);
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(()=>{
        const viewport = scrollAreaContext.viewport;
        if (viewport) {
            /**
       * We only bind to native scroll event so we know when scroll starts and ends.
       * When scroll starts we start a requestAnimationFrame loop that checks for
       * changes to scroll position. That rAF loop triggers our thumb position change
       * when relevant to avoid scroll-linked effects. We cancel the loop when scroll ends.
       * https://developer.mozilla.org/en-US/docs/Mozilla/Performance/Scroll-linked_effects
       */ const handleScroll = ()=>{
                debounceScrollEnd();
                if (!removeUnlinkedScrollListenerRef.current) {
                    const listener = $57acba87d6e25586$var$addUnlinkedScrollListener(viewport, onThumbPositionChange);
                    removeUnlinkedScrollListenerRef.current = listener;
                    onThumbPositionChange();
                }
            };
            onThumbPositionChange();
            viewport.addEventListener('scroll', handleScroll);
            return ()=>viewport.removeEventListener('scroll', handleScroll)
            ;
        }
    }, [
        scrollAreaContext.viewport,
        debounceScrollEnd,
        onThumbPositionChange
    ]);
    return /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_0__.createElement)(_radix_ui_react_primitive__WEBPACK_IMPORTED_MODULE_4__/* .Primitive.div */ .WV.div, (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({
        "data-state": scrollbarContext.hasThumb ? 'visible' : 'hidden'
    }, thumbProps, {
        ref: composedRef,
        style: {
            width: 'var(--radix-scroll-area-thumb-width)',
            height: 'var(--radix-scroll-area-thumb-height)',
            ...style
        },
        onPointerDownCapture: (0,_radix_ui_primitive__WEBPACK_IMPORTED_MODULE_7__/* .composeEventHandlers */ .M)(props.onPointerDownCapture, (event)=>{
            const thumb = event.target;
            const thumbRect = thumb.getBoundingClientRect();
            const x = event.clientX - thumbRect.left;
            const y = event.clientY - thumbRect.top;
            scrollbarContext.onThumbPointerDown({
                x: x,
                y: y
            });
        }),
        onPointerUp: (0,_radix_ui_primitive__WEBPACK_IMPORTED_MODULE_7__/* .composeEventHandlers */ .M)(props.onPointerUp, scrollbarContext.onThumbPointerUp)
    }));
});
/*#__PURE__*/ Object.assign($57acba87d6e25586$export$9fba1154677d7cd2, {
    displayName: $57acba87d6e25586$var$THUMB_NAME
});
/* -------------------------------------------------------------------------------------------------
 * ScrollAreaCorner
 * -----------------------------------------------------------------------------------------------*/ const $57acba87d6e25586$var$CORNER_NAME = 'ScrollAreaCorner';
const $57acba87d6e25586$export$56969d565df7cc4b = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_0__.forwardRef)((props, forwardedRef)=>{
    const context = $57acba87d6e25586$var$useScrollAreaContext($57acba87d6e25586$var$CORNER_NAME, props.__scopeScrollArea);
    const hasBothScrollbarsVisible = Boolean(context.scrollbarX && context.scrollbarY);
    const hasCorner = context.type !== 'scroll' && hasBothScrollbarsVisible;
    return hasCorner ? /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_0__.createElement)($57acba87d6e25586$var$ScrollAreaCornerImpl, (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({}, props, {
        ref: forwardedRef
    })) : null;
});
/*#__PURE__*/ Object.assign($57acba87d6e25586$export$56969d565df7cc4b, {
    displayName: $57acba87d6e25586$var$CORNER_NAME
});
/* -----------------------------------------------------------------------------------------------*/ const $57acba87d6e25586$var$ScrollAreaCornerImpl = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_0__.forwardRef)((props, forwardedRef)=>{
    const { __scopeScrollArea: __scopeScrollArea , ...cornerProps } = props;
    const context = $57acba87d6e25586$var$useScrollAreaContext($57acba87d6e25586$var$CORNER_NAME, __scopeScrollArea);
    const [width1, setWidth] = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(0);
    const [height1, setHeight] = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(0);
    const hasSize = Boolean(width1 && height1);
    $57acba87d6e25586$var$useResizeObserver(context.scrollbarX, ()=>{
        var _context$scrollbarX;
        const height = ((_context$scrollbarX = context.scrollbarX) === null || _context$scrollbarX === void 0 ? void 0 : _context$scrollbarX.offsetHeight) || 0;
        context.onCornerHeightChange(height);
        setHeight(height);
    });
    $57acba87d6e25586$var$useResizeObserver(context.scrollbarY, ()=>{
        var _context$scrollbarY;
        const width = ((_context$scrollbarY = context.scrollbarY) === null || _context$scrollbarY === void 0 ? void 0 : _context$scrollbarY.offsetWidth) || 0;
        context.onCornerWidthChange(width);
        setWidth(width);
    });
    return hasSize ? /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_0__.createElement)(_radix_ui_react_primitive__WEBPACK_IMPORTED_MODULE_4__/* .Primitive.div */ .WV.div, (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({}, cornerProps, {
        ref: forwardedRef,
        style: {
            width: width1,
            height: height1,
            position: 'absolute',
            right: context.dir === 'ltr' ? 0 : undefined,
            left: context.dir === 'rtl' ? 0 : undefined,
            bottom: 0,
            ...props.style
        }
    })) : null;
});
/* -----------------------------------------------------------------------------------------------*/ function $57acba87d6e25586$var$toInt(value) {
    return value ? parseInt(value, 10) : 0;
}
function $57acba87d6e25586$var$getThumbRatio(viewportSize, contentSize) {
    const ratio = viewportSize / contentSize;
    return isNaN(ratio) ? 0 : ratio;
}
function $57acba87d6e25586$var$getThumbSize(sizes) {
    const ratio = $57acba87d6e25586$var$getThumbRatio(sizes.viewport, sizes.content);
    const scrollbarPadding = sizes.scrollbar.paddingStart + sizes.scrollbar.paddingEnd;
    const thumbSize = (sizes.scrollbar.size - scrollbarPadding) * ratio; // minimum of 18 matches macOS minimum
    return Math.max(thumbSize, 18);
}
function $57acba87d6e25586$var$getScrollPositionFromPointer(pointerPos, pointerOffset, sizes, dir = 'ltr') {
    const thumbSizePx = $57acba87d6e25586$var$getThumbSize(sizes);
    const thumbCenter = thumbSizePx / 2;
    const offset = pointerOffset || thumbCenter;
    const thumbOffsetFromEnd = thumbSizePx - offset;
    const minPointerPos = sizes.scrollbar.paddingStart + offset;
    const maxPointerPos = sizes.scrollbar.size - sizes.scrollbar.paddingEnd - thumbOffsetFromEnd;
    const maxScrollPos = sizes.content - sizes.viewport;
    const scrollRange = dir === 'ltr' ? [
        0,
        maxScrollPos
    ] : [
        maxScrollPos * -1,
        0
    ];
    const interpolate = $57acba87d6e25586$var$linearScale([
        minPointerPos,
        maxPointerPos
    ], scrollRange);
    return interpolate(pointerPos);
}
function $57acba87d6e25586$var$getThumbOffsetFromScroll(scrollPos, sizes, dir = 'ltr') {
    const thumbSizePx = $57acba87d6e25586$var$getThumbSize(sizes);
    const scrollbarPadding = sizes.scrollbar.paddingStart + sizes.scrollbar.paddingEnd;
    const scrollbar = sizes.scrollbar.size - scrollbarPadding;
    const maxScrollPos = sizes.content - sizes.viewport;
    const maxThumbPos = scrollbar - thumbSizePx;
    const scrollClampRange = dir === 'ltr' ? [
        0,
        maxScrollPos
    ] : [
        maxScrollPos * -1,
        0
    ];
    const scrollWithoutMomentum = (0,_radix_ui_number__WEBPACK_IMPORTED_MODULE_9__/* .clamp */ .u)(scrollPos, scrollClampRange);
    const interpolate = $57acba87d6e25586$var$linearScale([
        0,
        maxScrollPos
    ], [
        0,
        maxThumbPos
    ]);
    return interpolate(scrollWithoutMomentum);
} // https://github.com/tmcw-up-for-adoption/simple-linear-scale/blob/master/index.js
function $57acba87d6e25586$var$linearScale(input, output) {
    return (value)=>{
        if (input[0] === input[1] || output[0] === output[1]) return output[0];
        const ratio = (output[1] - output[0]) / (input[1] - input[0]);
        return output[0] + ratio * (value - input[0]);
    };
}
function $57acba87d6e25586$var$isScrollingWithinScrollbarBounds(scrollPos, maxScrollPos) {
    return scrollPos > 0 && scrollPos < maxScrollPos;
} // Custom scroll handler to avoid scroll-linked effects
// https://developer.mozilla.org/en-US/docs/Mozilla/Performance/Scroll-linked_effects
const $57acba87d6e25586$var$addUnlinkedScrollListener = (node, handler = ()=>{})=>{
    let prevPosition = {
        left: node.scrollLeft,
        top: node.scrollTop
    };
    let rAF = 0;
    (function loop() {
        const position = {
            left: node.scrollLeft,
            top: node.scrollTop
        };
        const isHorizontalScroll = prevPosition.left !== position.left;
        const isVerticalScroll = prevPosition.top !== position.top;
        if (isHorizontalScroll || isVerticalScroll) handler();
        prevPosition = position;
        rAF = window.requestAnimationFrame(loop);
    })();
    return ()=>window.cancelAnimationFrame(rAF)
    ;
};
function $57acba87d6e25586$var$useDebounceCallback(callback, delay) {
    const handleCallback = (0,_radix_ui_react_use_callback_ref__WEBPACK_IMPORTED_MODULE_8__/* .useCallbackRef */ .W)(callback);
    const debounceTimerRef = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(0);
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(()=>()=>window.clearTimeout(debounceTimerRef.current)
    , []);
    return (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(()=>{
        window.clearTimeout(debounceTimerRef.current);
        debounceTimerRef.current = window.setTimeout(handleCallback, delay);
    }, [
        handleCallback,
        delay
    ]);
}
function $57acba87d6e25586$var$useResizeObserver(element, onResize) {
    const handleResize = (0,_radix_ui_react_use_callback_ref__WEBPACK_IMPORTED_MODULE_8__/* .useCallbackRef */ .W)(onResize);
    (0,_radix_ui_react_use_layout_effect__WEBPACK_IMPORTED_MODULE_10__/* .useLayoutEffect */ .b)(()=>{
        let rAF = 0;
        if (element) {
            /**
       * Resize Observer will throw an often benign error that says `ResizeObserver loop
       * completed with undelivered notifications`. This means that ResizeObserver was not
       * able to deliver all observations within a single animation frame, so we use
       * `requestAnimationFrame` to ensure we don't deliver unnecessary observations.
       * Further reading: https://github.com/WICG/resize-observer/issues/38
       */ const resizeObserver = new ResizeObserver(()=>{
                cancelAnimationFrame(rAF);
                rAF = window.requestAnimationFrame(handleResize);
            });
            resizeObserver.observe(element);
            return ()=>{
                window.cancelAnimationFrame(rAF);
                resizeObserver.unobserve(element);
            };
        }
    }, [
        element,
        handleResize
    ]);
}
/* -----------------------------------------------------------------------------------------------*/ const $57acba87d6e25586$export$be92b6f5f03c0fe9 = $57acba87d6e25586$export$ccf8d8d7bbf3c2cc;
const $57acba87d6e25586$export$d5c6c08dc2d3ca7 = $57acba87d6e25586$export$a21cbf9f11fca853;
const $57acba87d6e25586$export$9a4e88b92edfce6b = (/* unused pure expression or super */ null && ($57acba87d6e25586$export$2fabd85d0eba3c57));
const $57acba87d6e25586$export$6521433ed15a34db = (/* unused pure expression or super */ null && ($57acba87d6e25586$export$9fba1154677d7cd2));
const $57acba87d6e25586$export$ac61190d9fc311a9 = $57acba87d6e25586$export$56969d565df7cc4b;





//# sourceMappingURL=index.mjs.map


/***/ }),

/***/ 88426:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "A4": function() { return /* binding */ $5e63c961fc1ce211$export$d9f1ccf0bdb05d45; },
/* harmony export */   "g7": function() { return /* binding */ $5e63c961fc1ce211$export$8c6ed5c666ac1360; }
/* harmony export */ });
/* unused harmony export Root */
/* harmony import */ var _babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(87462);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(55784);
/* harmony import */ var _radix_ui_react_compose_refs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(28771);







/* -------------------------------------------------------------------------------------------------
 * Slot
 * -----------------------------------------------------------------------------------------------*/ const $5e63c961fc1ce211$export$8c6ed5c666ac1360 = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_0__.forwardRef)((props, forwardedRef)=>{
    const { children: children , ...slotProps } = props;
    const childrenArray = react__WEBPACK_IMPORTED_MODULE_0__.Children.toArray(children);
    const slottable = childrenArray.find($5e63c961fc1ce211$var$isSlottable);
    if (slottable) {
        // the new element to render is the one passed as a child of `Slottable`
        const newElement = slottable.props.children;
        const newChildren = childrenArray.map((child)=>{
            if (child === slottable) {
                // because the new element will be the one rendered, we are only interested
                // in grabbing its children (`newElement.props.children`)
                if (react__WEBPACK_IMPORTED_MODULE_0__.Children.count(newElement) > 1) return react__WEBPACK_IMPORTED_MODULE_0__.Children.only(null);
                return /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_0__.isValidElement)(newElement) ? newElement.props.children : null;
            } else return child;
        });
        return /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_0__.createElement)($5e63c961fc1ce211$var$SlotClone, (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)({}, slotProps, {
            ref: forwardedRef
        }), /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_0__.isValidElement)(newElement) ? /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_0__.cloneElement)(newElement, undefined, newChildren) : null);
    }
    return /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_0__.createElement)($5e63c961fc1ce211$var$SlotClone, (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)({}, slotProps, {
        ref: forwardedRef
    }), children);
});
$5e63c961fc1ce211$export$8c6ed5c666ac1360.displayName = 'Slot';
/* -------------------------------------------------------------------------------------------------
 * SlotClone
 * -----------------------------------------------------------------------------------------------*/ const $5e63c961fc1ce211$var$SlotClone = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_0__.forwardRef)((props, forwardedRef)=>{
    const { children: children , ...slotProps } = props;
    if (/*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_0__.isValidElement)(children)) return /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_0__.cloneElement)(children, {
        ...$5e63c961fc1ce211$var$mergeProps(slotProps, children.props),
        ref: forwardedRef ? (0,_radix_ui_react_compose_refs__WEBPACK_IMPORTED_MODULE_2__/* .composeRefs */ .F)(forwardedRef, children.ref) : children.ref
    });
    return react__WEBPACK_IMPORTED_MODULE_0__.Children.count(children) > 1 ? react__WEBPACK_IMPORTED_MODULE_0__.Children.only(null) : null;
});
$5e63c961fc1ce211$var$SlotClone.displayName = 'SlotClone';
/* -------------------------------------------------------------------------------------------------
 * Slottable
 * -----------------------------------------------------------------------------------------------*/ const $5e63c961fc1ce211$export$d9f1ccf0bdb05d45 = ({ children: children  })=>{
    return /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_0__.createElement)(react__WEBPACK_IMPORTED_MODULE_0__.Fragment, null, children);
};
/* ---------------------------------------------------------------------------------------------- */ function $5e63c961fc1ce211$var$isSlottable(child) {
    return /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_0__.isValidElement)(child) && child.type === $5e63c961fc1ce211$export$d9f1ccf0bdb05d45;
}
function $5e63c961fc1ce211$var$mergeProps(slotProps, childProps) {
    // all child props should override
    const overrideProps = {
        ...childProps
    };
    for(const propName in childProps){
        const slotPropValue = slotProps[propName];
        const childPropValue = childProps[propName];
        const isHandler = /^on[A-Z]/.test(propName);
        if (isHandler) {
            // if the handler exists on both, we compose them
            if (slotPropValue && childPropValue) overrideProps[propName] = (...args)=>{
                childPropValue(...args);
                slotPropValue(...args);
            };
            else if (slotPropValue) overrideProps[propName] = slotPropValue;
        } else if (propName === 'style') overrideProps[propName] = {
            ...slotPropValue,
            ...childPropValue
        };
        else if (propName === 'className') overrideProps[propName] = [
            slotPropValue,
            childPropValue
        ].filter(Boolean).join(' ');
    }
    return {
        ...slotProps,
        ...overrideProps
    };
}
const $5e63c961fc1ce211$export$be92b6f5f03c0fe9 = (/* unused pure expression or super */ null && ($5e63c961fc1ce211$export$8c6ed5c666ac1360));





//# sourceMappingURL=index.mjs.map


/***/ }),

/***/ 79698:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "W": function() { return /* binding */ $b1b2314f5f9a1d84$export$25bec8c6f54ee79a; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(55784);



/**
 * A custom hook that converts a callback to a ref to avoid triggering re-renders when passed as a
 * prop or avoid re-executing effects when passed as a dependency
 */ function $b1b2314f5f9a1d84$export$25bec8c6f54ee79a(callback) {
    const callbackRef = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(callback);
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(()=>{
        callbackRef.current = callback;
    }); // https://github.com/facebook/react/issues/19240
    return (0,react__WEBPACK_IMPORTED_MODULE_0__.useMemo)(()=>(...args)=>{
            var _callbackRef$current;
            return (_callbackRef$current = callbackRef.current) === null || _callbackRef$current === void 0 ? void 0 : _callbackRef$current.call(callbackRef, ...args);
        }
    , []);
}





//# sourceMappingURL=index.mjs.map


/***/ }),

/***/ 77342:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "T": function() { return /* binding */ $71cd76cc60e0454e$export$6f32135080cb4c3; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(55784);
/* harmony import */ var _radix_ui_react_use_callback_ref__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(79698);





function $71cd76cc60e0454e$export$6f32135080cb4c3({ prop: prop , defaultProp: defaultProp , onChange: onChange = ()=>{}  }) {
    const [uncontrolledProp, setUncontrolledProp] = $71cd76cc60e0454e$var$useUncontrolledState({
        defaultProp: defaultProp,
        onChange: onChange
    });
    const isControlled = prop !== undefined;
    const value1 = isControlled ? prop : uncontrolledProp;
    const handleChange = (0,_radix_ui_react_use_callback_ref__WEBPACK_IMPORTED_MODULE_1__/* .useCallbackRef */ .W)(onChange);
    const setValue = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)((nextValue)=>{
        if (isControlled) {
            const setter = nextValue;
            const value = typeof nextValue === 'function' ? setter(prop) : nextValue;
            if (value !== prop) handleChange(value);
        } else setUncontrolledProp(nextValue);
    }, [
        isControlled,
        prop,
        setUncontrolledProp,
        handleChange
    ]);
    return [
        value1,
        setValue
    ];
}
function $71cd76cc60e0454e$var$useUncontrolledState({ defaultProp: defaultProp , onChange: onChange  }) {
    const uncontrolledState = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(defaultProp);
    const [value] = uncontrolledState;
    const prevValueRef = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(value);
    const handleChange = (0,_radix_ui_react_use_callback_ref__WEBPACK_IMPORTED_MODULE_1__/* .useCallbackRef */ .W)(onChange);
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(()=>{
        if (prevValueRef.current !== value) {
            handleChange(value);
            prevValueRef.current = value;
        }
    }, [
        value,
        prevValueRef,
        handleChange
    ]);
    return uncontrolledState;
}





//# sourceMappingURL=index.mjs.map


/***/ }),

/***/ 9981:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "b": function() { return /* binding */ $9f79659886946c16$export$e5c5a5f917a5871c; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(55784);



/**
 * On the server, React emits a warning when calling `useLayoutEffect`.
 * This is because neither `useLayoutEffect` nor `useEffect` run on the server.
 * We use this safe version which suppresses the warning by replacing it with a noop on the server.
 *
 * See: https://reactjs.org/docs/hooks-reference.html#uselayouteffect
 */ const $9f79659886946c16$export$e5c5a5f917a5871c = Boolean(globalThis === null || globalThis === void 0 ? void 0 : globalThis.document) ? react__WEBPACK_IMPORTED_MODULE_0__.useLayoutEffect : ()=>{};





//# sourceMappingURL=index.mjs.map


/***/ }),

/***/ 57898:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "D": function() { return /* binding */ $010c2913dbd2fe3d$export$5cae361ad82dce8b; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(55784);



function $010c2913dbd2fe3d$export$5cae361ad82dce8b(value) {
    const ref = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)({
        value: value,
        previous: value
    }); // We compare values before making an update to ensure that
    // a change has been made. This ensures the previous value is
    // persisted correctly between renders.
    return (0,react__WEBPACK_IMPORTED_MODULE_0__.useMemo)(()=>{
        if (ref.current.value !== value) {
            ref.current.previous = ref.current.value;
            ref.current.value = value;
        }
        return ref.current.previous;
    }, [
        value
    ]);
}





//# sourceMappingURL=index.mjs.map


/***/ }),

/***/ 7546:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "t": function() { return /* binding */ $db6c3485150b8e66$export$1ab7ae714698c4b8; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(55784);
/* harmony import */ var _radix_ui_react_use_layout_effect__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(9981);





function $db6c3485150b8e66$export$1ab7ae714698c4b8(element) {
    const [size, setSize] = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(undefined);
    (0,_radix_ui_react_use_layout_effect__WEBPACK_IMPORTED_MODULE_1__/* .useLayoutEffect */ .b)(()=>{
        if (element) {
            // provide size as early as possible
            setSize({
                width: element.offsetWidth,
                height: element.offsetHeight
            });
            const resizeObserver = new ResizeObserver((entries)=>{
                if (!Array.isArray(entries)) return;
                 // Since we only observe the one element, we don't need to loop over the
                // array
                if (!entries.length) return;
                const entry = entries[0];
                let width;
                let height;
                if ('borderBoxSize' in entry) {
                    const borderSizeEntry = entry['borderBoxSize']; // iron out differences between browsers
                    const borderSize = Array.isArray(borderSizeEntry) ? borderSizeEntry[0] : borderSizeEntry;
                    width = borderSize['inlineSize'];
                    height = borderSize['blockSize'];
                } else {
                    // for browsers that don't support `borderBoxSize`
                    // we calculate it ourselves to get the correct border box.
                    width = element.offsetWidth;
                    height = element.offsetHeight;
                }
                setSize({
                    width: width,
                    height: height
                });
            });
            resizeObserver.observe(element, {
                box: 'border-box'
            });
            return ()=>resizeObserver.unobserve(element)
            ;
        } else // We only want to reset to `undefined` when the element becomes `null`,
        // not if it changes to another element.
        setSize(undefined);
    }, [
        element
    ]);
    return size;
}





//# sourceMappingURL=index.mjs.map


/***/ }),

/***/ 96219:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "T": function() { return /* binding */ $ea1ef594cf570d83$export$439d29a4e110a164; },
/* harmony export */   "f": function() { return /* binding */ $ea1ef594cf570d83$export$be92b6f5f03c0fe9; }
/* harmony export */ });
/* harmony import */ var _babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(87462);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(55784);
/* harmony import */ var _radix_ui_react_primitive__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(75320);







/* -------------------------------------------------------------------------------------------------
 * VisuallyHidden
 * -----------------------------------------------------------------------------------------------*/ const $ea1ef594cf570d83$var$NAME = 'VisuallyHidden';
const $ea1ef594cf570d83$export$439d29a4e110a164 = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_0__.forwardRef)((props, forwardedRef)=>{
    return /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_0__.createElement)(_radix_ui_react_primitive__WEBPACK_IMPORTED_MODULE_1__/* .Primitive.span */ .WV.span, (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({}, props, {
        ref: forwardedRef,
        style: {
            // See: https://github.com/twbs/bootstrap/blob/master/scss/mixins/_screen-reader.scss
            position: 'absolute',
            border: 0,
            width: 1,
            height: 1,
            padding: 0,
            margin: -1,
            overflow: 'hidden',
            clip: 'rect(0, 0, 0, 0)',
            whiteSpace: 'nowrap',
            wordWrap: 'normal',
            ...props.style
        }
    }));
});
/*#__PURE__*/ Object.assign($ea1ef594cf570d83$export$439d29a4e110a164, {
    displayName: $ea1ef594cf570d83$var$NAME
});
/* -----------------------------------------------------------------------------------------------*/ const $ea1ef594cf570d83$export$be92b6f5f03c0fe9 = $ea1ef594cf570d83$export$439d29a4e110a164;





//# sourceMappingURL=index.mjs.map


/***/ }),

/***/ 66005:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "q": function() { return /* binding */ animated; },
  "q_": function() { return /* reexport */ useSpring; }
});

// UNUSED EXPORTS: Any, BailSignal, Controller, FrameValue, Globals, Interpolation, Spring, SpringContext, SpringRef, SpringValue, Trail, Transition, a, config, createInterpolator, easings, inferTo, interpolate, to, update, useChain, useInView, useIsomorphicLayoutEffect, useReducedMotion, useResize, useScroll, useSpringRef, useSpringValue, useSprings, useTrail, useTransition

// EXTERNAL MODULE: ./node_modules/next/dist/compiled/react/index.js
var react = __webpack_require__(55784);
;// CONCATENATED MODULE: ./node_modules/@react-spring/shared/dist/react-spring_shared.modern.mjs
var __defProp = Object.defineProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};

// src/globals.ts
var globals_exports = {};
__export(globals_exports, {
  assign: () => react_spring_shared_modern_assign,
  colors: () => colors,
  createStringInterpolator: () => createStringInterpolator,
  skipAnimation: () => skipAnimation,
  to: () => to,
  willAdvance: () => willAdvance
});

// ../rafz/dist/react-spring_rafz.modern.mjs
var updateQueue = makeQueue();
var raf = (fn) => schedule(fn, updateQueue);
var writeQueue = makeQueue();
raf.write = (fn) => schedule(fn, writeQueue);
var onStartQueue = makeQueue();
raf.onStart = (fn) => schedule(fn, onStartQueue);
var onFrameQueue = makeQueue();
raf.onFrame = (fn) => schedule(fn, onFrameQueue);
var onFinishQueue = makeQueue();
raf.onFinish = (fn) => schedule(fn, onFinishQueue);
var timeouts = [];
raf.setTimeout = (handler, ms) => {
  const time = raf.now() + ms;
  const cancel = () => {
    const i = timeouts.findIndex((t) => t.cancel == cancel);
    if (~i)
      timeouts.splice(i, 1);
    pendingCount -= ~i ? 1 : 0;
  };
  const timeout = { time, handler, cancel };
  timeouts.splice(findTimeout(time), 0, timeout);
  pendingCount += 1;
  start();
  return timeout;
};
var findTimeout = (time) => ~(~timeouts.findIndex((t) => t.time > time) || ~timeouts.length);
raf.cancel = (fn) => {
  onStartQueue.delete(fn);
  onFrameQueue.delete(fn);
  onFinishQueue.delete(fn);
  updateQueue.delete(fn);
  writeQueue.delete(fn);
};
raf.sync = (fn) => {
  sync = true;
  raf.batchedUpdates(fn);
  sync = false;
};
raf.throttle = (fn) => {
  let lastArgs;
  function queuedFn() {
    try {
      fn(...lastArgs);
    } finally {
      lastArgs = null;
    }
  }
  function throttled(...args) {
    lastArgs = args;
    raf.onStart(queuedFn);
  }
  throttled.handler = fn;
  throttled.cancel = () => {
    onStartQueue.delete(queuedFn);
    lastArgs = null;
  };
  return throttled;
};
var nativeRaf = typeof window != "undefined" ? window.requestAnimationFrame : (
  // eslint-disable-next-line @typescript-eslint/no-empty-function
  () => {
  }
);
raf.use = (impl) => nativeRaf = impl;
raf.now = typeof performance != "undefined" ? () => performance.now() : Date.now;
raf.batchedUpdates = (fn) => fn();
raf.catch = console.error;
raf.frameLoop = "always";
raf.advance = () => {
  if (raf.frameLoop !== "demand") {
    console.warn(
      "Cannot call the manual advancement of rafz whilst frameLoop is not set as demand"
    );
  } else {
    update();
  }
};
var ts = -1;
var pendingCount = 0;
var sync = false;
function schedule(fn, queue) {
  if (sync) {
    queue.delete(fn);
    fn(0);
  } else {
    queue.add(fn);
    start();
  }
}
function start() {
  if (ts < 0) {
    ts = 0;
    if (raf.frameLoop !== "demand") {
      nativeRaf(loop);
    }
  }
}
function stop() {
  ts = -1;
}
function loop() {
  if (~ts) {
    nativeRaf(loop);
    raf.batchedUpdates(update);
  }
}
function update() {
  const prevTs = ts;
  ts = raf.now();
  const count = findTimeout(ts);
  if (count) {
    eachSafely(timeouts.splice(0, count), (t) => t.handler());
    pendingCount -= count;
  }
  if (!pendingCount) {
    stop();
    return;
  }
  onStartQueue.flush();
  updateQueue.flush(prevTs ? Math.min(64, ts - prevTs) : 16.667);
  onFrameQueue.flush();
  writeQueue.flush();
  onFinishQueue.flush();
}
function makeQueue() {
  let next = /* @__PURE__ */ new Set();
  let current = next;
  return {
    add(fn) {
      pendingCount += current == next && !next.has(fn) ? 1 : 0;
      next.add(fn);
    },
    delete(fn) {
      pendingCount -= current == next && next.has(fn) ? 1 : 0;
      return next.delete(fn);
    },
    flush(arg) {
      if (current.size) {
        next = /* @__PURE__ */ new Set();
        pendingCount -= current.size;
        eachSafely(current, (fn) => fn(arg) && next.add(fn));
        pendingCount += next.size;
        current = next;
      }
    }
  };
}
function eachSafely(values, each2) {
  values.forEach((value) => {
    try {
      each2(value);
    } catch (e) {
      raf.catch(e);
    }
  });
}

// src/helpers.ts
function noop() {
}
var defineHidden = (obj, key, value) => Object.defineProperty(obj, key, { value, writable: true, configurable: true });
var is = {
  arr: Array.isArray,
  obj: (a) => !!a && a.constructor.name === "Object",
  fun: (a) => typeof a === "function",
  str: (a) => typeof a === "string",
  num: (a) => typeof a === "number",
  und: (a) => a === void 0
};
function isEqual(a, b) {
  if (is.arr(a)) {
    if (!is.arr(b) || a.length !== b.length)
      return false;
    for (let i = 0; i < a.length; i++) {
      if (a[i] !== b[i])
        return false;
    }
    return true;
  }
  return a === b;
}
var react_spring_shared_modern_each = (obj, fn) => obj.forEach(fn);
function eachProp(obj, fn, ctx) {
  if (is.arr(obj)) {
    for (let i = 0; i < obj.length; i++) {
      fn.call(ctx, obj[i], `${i}`);
    }
    return;
  }
  for (const key in obj) {
    if (obj.hasOwnProperty(key)) {
      fn.call(ctx, obj[key], key);
    }
  }
}
var toArray = (a) => is.und(a) ? [] : is.arr(a) ? a : [a];
function flush(queue, iterator) {
  if (queue.size) {
    const items = Array.from(queue);
    queue.clear();
    react_spring_shared_modern_each(items, iterator);
  }
}
var flushCalls = (queue, ...args) => flush(queue, (fn) => fn(...args));
var isSSR = () => typeof window === "undefined" || !window.navigator || /ServerSideRendering|^Deno\//.test(window.navigator.userAgent);

// src/globals.ts
var createStringInterpolator;
var to;
var colors = null;
var skipAnimation = false;
var willAdvance = noop;
var react_spring_shared_modern_assign = (globals) => {
  if (globals.to)
    to = globals.to;
  if (globals.now)
    raf.now = globals.now;
  if (globals.colors !== void 0)
    colors = globals.colors;
  if (globals.skipAnimation != null)
    skipAnimation = globals.skipAnimation;
  if (globals.createStringInterpolator)
    createStringInterpolator = globals.createStringInterpolator;
  if (globals.requestAnimationFrame)
    raf.use(globals.requestAnimationFrame);
  if (globals.batchedUpdates)
    raf.batchedUpdates = globals.batchedUpdates;
  if (globals.willAdvance)
    willAdvance = globals.willAdvance;
  if (globals.frameLoop)
    raf.frameLoop = globals.frameLoop;
};

// src/FrameLoop.ts
var startQueue = /* @__PURE__ */ new Set();
var currentFrame = [];
var prevFrame = [];
var priority = 0;
var frameLoop = {
  get idle() {
    return !startQueue.size && !currentFrame.length;
  },
  /** Advance the given animation on every frame until idle. */
  start(animation) {
    if (priority > animation.priority) {
      startQueue.add(animation);
      raf.onStart(flushStartQueue);
    } else {
      startSafely(animation);
      raf(advance);
    }
  },
  /** Advance all animations by the given time. */
  advance,
  /** Call this when an animation's priority changes. */
  sort(animation) {
    if (priority) {
      raf.onFrame(() => frameLoop.sort(animation));
    } else {
      const prevIndex = currentFrame.indexOf(animation);
      if (~prevIndex) {
        currentFrame.splice(prevIndex, 1);
        startUnsafely(animation);
      }
    }
  },
  /**
   * Clear all animations. For testing purposes.
   *
   * ☠️ Never call this from within the frameloop.
   */
  clear() {
    currentFrame = [];
    startQueue.clear();
  }
};
function flushStartQueue() {
  startQueue.forEach(startSafely);
  startQueue.clear();
  raf(advance);
}
function startSafely(animation) {
  if (!currentFrame.includes(animation))
    startUnsafely(animation);
}
function startUnsafely(animation) {
  currentFrame.splice(
    findIndex(currentFrame, (other) => other.priority > animation.priority),
    0,
    animation
  );
}
function advance(dt) {
  const nextFrame = prevFrame;
  for (let i = 0; i < currentFrame.length; i++) {
    const animation = currentFrame[i];
    priority = animation.priority;
    if (!animation.idle) {
      willAdvance(animation);
      animation.advance(dt);
      if (!animation.idle) {
        nextFrame.push(animation);
      }
    }
  }
  priority = 0;
  prevFrame = currentFrame;
  prevFrame.length = 0;
  currentFrame = nextFrame;
  return currentFrame.length > 0;
}
function findIndex(arr, test) {
  const index = arr.findIndex(test);
  return index < 0 ? arr.length : index;
}

// src/clamp.ts
var clamp = (min, max, v) => Math.min(Math.max(v, min), max);

// src/colors.ts
var colors2 = {
  transparent: 0,
  aliceblue: 4042850303,
  antiquewhite: 4209760255,
  aqua: 16777215,
  aquamarine: 2147472639,
  azure: 4043309055,
  beige: 4126530815,
  bisque: 4293182719,
  black: 255,
  blanchedalmond: 4293643775,
  blue: 65535,
  blueviolet: 2318131967,
  brown: 2771004159,
  burlywood: 3736635391,
  burntsienna: 3934150143,
  cadetblue: 1604231423,
  chartreuse: 2147418367,
  chocolate: 3530104575,
  coral: 4286533887,
  cornflowerblue: 1687547391,
  cornsilk: 4294499583,
  crimson: 3692313855,
  cyan: 16777215,
  darkblue: 35839,
  darkcyan: 9145343,
  darkgoldenrod: 3095792639,
  darkgray: 2846468607,
  darkgreen: 6553855,
  darkgrey: 2846468607,
  darkkhaki: 3182914559,
  darkmagenta: 2332068863,
  darkolivegreen: 1433087999,
  darkorange: 4287365375,
  darkorchid: 2570243327,
  darkred: 2332033279,
  darksalmon: 3918953215,
  darkseagreen: 2411499519,
  darkslateblue: 1211993087,
  darkslategray: 793726975,
  darkslategrey: 793726975,
  darkturquoise: 13554175,
  darkviolet: 2483082239,
  deeppink: 4279538687,
  deepskyblue: 12582911,
  dimgray: 1768516095,
  dimgrey: 1768516095,
  dodgerblue: 512819199,
  firebrick: 2988581631,
  floralwhite: 4294635775,
  forestgreen: 579543807,
  fuchsia: 4278255615,
  gainsboro: 3705462015,
  ghostwhite: 4177068031,
  gold: 4292280575,
  goldenrod: 3668254975,
  gray: 2155905279,
  green: 8388863,
  greenyellow: 2919182335,
  grey: 2155905279,
  honeydew: 4043305215,
  hotpink: 4285117695,
  indianred: 3445382399,
  indigo: 1258324735,
  ivory: 4294963455,
  khaki: 4041641215,
  lavender: 3873897215,
  lavenderblush: 4293981695,
  lawngreen: 2096890111,
  lemonchiffon: 4294626815,
  lightblue: 2916673279,
  lightcoral: 4034953471,
  lightcyan: 3774873599,
  lightgoldenrodyellow: 4210742015,
  lightgray: 3553874943,
  lightgreen: 2431553791,
  lightgrey: 3553874943,
  lightpink: 4290167295,
  lightsalmon: 4288707327,
  lightseagreen: 548580095,
  lightskyblue: 2278488831,
  lightslategray: 2005441023,
  lightslategrey: 2005441023,
  lightsteelblue: 2965692159,
  lightyellow: 4294959359,
  lime: 16711935,
  limegreen: 852308735,
  linen: 4210091775,
  magenta: 4278255615,
  maroon: 2147483903,
  mediumaquamarine: 1724754687,
  mediumblue: 52735,
  mediumorchid: 3126187007,
  mediumpurple: 2473647103,
  mediumseagreen: 1018393087,
  mediumslateblue: 2070474495,
  mediumspringgreen: 16423679,
  mediumturquoise: 1221709055,
  mediumvioletred: 3340076543,
  midnightblue: 421097727,
  mintcream: 4127193855,
  mistyrose: 4293190143,
  moccasin: 4293178879,
  navajowhite: 4292783615,
  navy: 33023,
  oldlace: 4260751103,
  olive: 2155872511,
  olivedrab: 1804477439,
  orange: 4289003775,
  orangered: 4282712319,
  orchid: 3664828159,
  palegoldenrod: 4008225535,
  palegreen: 2566625535,
  paleturquoise: 2951671551,
  palevioletred: 3681588223,
  papayawhip: 4293907967,
  peachpuff: 4292524543,
  peru: 3448061951,
  pink: 4290825215,
  plum: 3718307327,
  powderblue: 2967529215,
  purple: 2147516671,
  rebeccapurple: 1714657791,
  red: 4278190335,
  rosybrown: 3163525119,
  royalblue: 1097458175,
  saddlebrown: 2336560127,
  salmon: 4202722047,
  sandybrown: 4104413439,
  seagreen: 780883967,
  seashell: 4294307583,
  sienna: 2689740287,
  silver: 3233857791,
  skyblue: 2278484991,
  slateblue: 1784335871,
  slategray: 1887473919,
  slategrey: 1887473919,
  snow: 4294638335,
  springgreen: 16744447,
  steelblue: 1182971135,
  tan: 3535047935,
  teal: 8421631,
  thistle: 3636451583,
  tomato: 4284696575,
  turquoise: 1088475391,
  violet: 4001558271,
  wheat: 4125012991,
  white: 4294967295,
  whitesmoke: 4126537215,
  yellow: 4294902015,
  yellowgreen: 2597139199
};

// src/colorMatchers.ts
var NUMBER = "[-+]?\\d*\\.?\\d+";
var PERCENTAGE = NUMBER + "%";
function call(...parts) {
  return "\\(\\s*(" + parts.join(")\\s*,\\s*(") + ")\\s*\\)";
}
var rgb = new RegExp("rgb" + call(NUMBER, NUMBER, NUMBER));
var rgba = new RegExp("rgba" + call(NUMBER, NUMBER, NUMBER, NUMBER));
var hsl = new RegExp("hsl" + call(NUMBER, PERCENTAGE, PERCENTAGE));
var hsla = new RegExp(
  "hsla" + call(NUMBER, PERCENTAGE, PERCENTAGE, NUMBER)
);
var hex3 = /^#([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})$/;
var hex4 = /^#([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})$/;
var hex6 = /^#([0-9a-fA-F]{6})$/;
var hex8 = /^#([0-9a-fA-F]{8})$/;

// src/normalizeColor.ts
function normalizeColor(color) {
  let match;
  if (typeof color === "number") {
    return color >>> 0 === color && color >= 0 && color <= 4294967295 ? color : null;
  }
  if (match = hex6.exec(color))
    return parseInt(match[1] + "ff", 16) >>> 0;
  if (colors && colors[color] !== void 0) {
    return colors[color];
  }
  if (match = rgb.exec(color)) {
    return (parse255(match[1]) << 24 | // r
    parse255(match[2]) << 16 | // g
    parse255(match[3]) << 8 | // b
    255) >>> // a
    0;
  }
  if (match = rgba.exec(color)) {
    return (parse255(match[1]) << 24 | // r
    parse255(match[2]) << 16 | // g
    parse255(match[3]) << 8 | // b
    parse1(match[4])) >>> // a
    0;
  }
  if (match = hex3.exec(color)) {
    return parseInt(
      match[1] + match[1] + // r
      match[2] + match[2] + // g
      match[3] + match[3] + // b
      "ff",
      // a
      16
    ) >>> 0;
  }
  if (match = hex8.exec(color))
    return parseInt(match[1], 16) >>> 0;
  if (match = hex4.exec(color)) {
    return parseInt(
      match[1] + match[1] + // r
      match[2] + match[2] + // g
      match[3] + match[3] + // b
      match[4] + match[4],
      // a
      16
    ) >>> 0;
  }
  if (match = hsl.exec(color)) {
    return (hslToRgb(
      parse360(match[1]),
      // h
      parsePercentage(match[2]),
      // s
      parsePercentage(match[3])
      // l
    ) | 255) >>> // a
    0;
  }
  if (match = hsla.exec(color)) {
    return (hslToRgb(
      parse360(match[1]),
      // h
      parsePercentage(match[2]),
      // s
      parsePercentage(match[3])
      // l
    ) | parse1(match[4])) >>> // a
    0;
  }
  return null;
}
function hue2rgb(p, q, t) {
  if (t < 0)
    t += 1;
  if (t > 1)
    t -= 1;
  if (t < 1 / 6)
    return p + (q - p) * 6 * t;
  if (t < 1 / 2)
    return q;
  if (t < 2 / 3)
    return p + (q - p) * (2 / 3 - t) * 6;
  return p;
}
function hslToRgb(h, s, l) {
  const q = l < 0.5 ? l * (1 + s) : l + s - l * s;
  const p = 2 * l - q;
  const r = hue2rgb(p, q, h + 1 / 3);
  const g = hue2rgb(p, q, h);
  const b = hue2rgb(p, q, h - 1 / 3);
  return Math.round(r * 255) << 24 | Math.round(g * 255) << 16 | Math.round(b * 255) << 8;
}
function parse255(str) {
  const int = parseInt(str, 10);
  if (int < 0)
    return 0;
  if (int > 255)
    return 255;
  return int;
}
function parse360(str) {
  const int = parseFloat(str);
  return (int % 360 + 360) % 360 / 360;
}
function parse1(str) {
  const num = parseFloat(str);
  if (num < 0)
    return 0;
  if (num > 1)
    return 255;
  return Math.round(num * 255);
}
function parsePercentage(str) {
  const int = parseFloat(str);
  if (int < 0)
    return 0;
  if (int > 100)
    return 1;
  return int / 100;
}

// src/colorToRgba.ts
function colorToRgba(input) {
  let int32Color = normalizeColor(input);
  if (int32Color === null)
    return input;
  int32Color = int32Color || 0;
  const r = (int32Color & 4278190080) >>> 24;
  const g = (int32Color & 16711680) >>> 16;
  const b = (int32Color & 65280) >>> 8;
  const a = (int32Color & 255) / 255;
  return `rgba(${r}, ${g}, ${b}, ${a})`;
}

// src/createInterpolator.ts
var createInterpolator = (range, output, extrapolate) => {
  if (is.fun(range)) {
    return range;
  }
  if (is.arr(range)) {
    return createInterpolator({
      range,
      output,
      extrapolate
    });
  }
  if (is.str(range.output[0])) {
    return createStringInterpolator(range);
  }
  const config = range;
  const outputRange = config.output;
  const inputRange = config.range || [0, 1];
  const extrapolateLeft = config.extrapolateLeft || config.extrapolate || "extend";
  const extrapolateRight = config.extrapolateRight || config.extrapolate || "extend";
  const easing = config.easing || ((t) => t);
  return (input) => {
    const range2 = findRange(input, inputRange);
    return interpolate(
      input,
      inputRange[range2],
      inputRange[range2 + 1],
      outputRange[range2],
      outputRange[range2 + 1],
      easing,
      extrapolateLeft,
      extrapolateRight,
      config.map
    );
  };
};
function interpolate(input, inputMin, inputMax, outputMin, outputMax, easing, extrapolateLeft, extrapolateRight, map) {
  let result = map ? map(input) : input;
  if (result < inputMin) {
    if (extrapolateLeft === "identity")
      return result;
    else if (extrapolateLeft === "clamp")
      result = inputMin;
  }
  if (result > inputMax) {
    if (extrapolateRight === "identity")
      return result;
    else if (extrapolateRight === "clamp")
      result = inputMax;
  }
  if (outputMin === outputMax)
    return outputMin;
  if (inputMin === inputMax)
    return input <= inputMin ? outputMin : outputMax;
  if (inputMin === -Infinity)
    result = -result;
  else if (inputMax === Infinity)
    result = result - inputMin;
  else
    result = (result - inputMin) / (inputMax - inputMin);
  result = easing(result);
  if (outputMin === -Infinity)
    result = -result;
  else if (outputMax === Infinity)
    result = result + outputMin;
  else
    result = result * (outputMax - outputMin) + outputMin;
  return result;
}
function findRange(input, inputRange) {
  for (var i = 1; i < inputRange.length - 1; ++i)
    if (inputRange[i] >= input)
      break;
  return i - 1;
}

// src/easings.ts
var steps = (steps2, direction = "end") => (progress2) => {
  progress2 = direction === "end" ? Math.min(progress2, 0.999) : Math.max(progress2, 1e-3);
  const expanded = progress2 * steps2;
  const rounded = direction === "end" ? Math.floor(expanded) : Math.ceil(expanded);
  return clamp(0, 1, rounded / steps2);
};
var c1 = 1.70158;
var c2 = c1 * 1.525;
var c3 = c1 + 1;
var c4 = 2 * Math.PI / 3;
var c5 = 2 * Math.PI / 4.5;
var bounceOut = (x) => {
  const n1 = 7.5625;
  const d1 = 2.75;
  if (x < 1 / d1) {
    return n1 * x * x;
  } else if (x < 2 / d1) {
    return n1 * (x -= 1.5 / d1) * x + 0.75;
  } else if (x < 2.5 / d1) {
    return n1 * (x -= 2.25 / d1) * x + 0.9375;
  } else {
    return n1 * (x -= 2.625 / d1) * x + 0.984375;
  }
};
var easings = {
  linear: (x) => x,
  easeInQuad: (x) => x * x,
  easeOutQuad: (x) => 1 - (1 - x) * (1 - x),
  easeInOutQuad: (x) => x < 0.5 ? 2 * x * x : 1 - Math.pow(-2 * x + 2, 2) / 2,
  easeInCubic: (x) => x * x * x,
  easeOutCubic: (x) => 1 - Math.pow(1 - x, 3),
  easeInOutCubic: (x) => x < 0.5 ? 4 * x * x * x : 1 - Math.pow(-2 * x + 2, 3) / 2,
  easeInQuart: (x) => x * x * x * x,
  easeOutQuart: (x) => 1 - Math.pow(1 - x, 4),
  easeInOutQuart: (x) => x < 0.5 ? 8 * x * x * x * x : 1 - Math.pow(-2 * x + 2, 4) / 2,
  easeInQuint: (x) => x * x * x * x * x,
  easeOutQuint: (x) => 1 - Math.pow(1 - x, 5),
  easeInOutQuint: (x) => x < 0.5 ? 16 * x * x * x * x * x : 1 - Math.pow(-2 * x + 2, 5) / 2,
  easeInSine: (x) => 1 - Math.cos(x * Math.PI / 2),
  easeOutSine: (x) => Math.sin(x * Math.PI / 2),
  easeInOutSine: (x) => -(Math.cos(Math.PI * x) - 1) / 2,
  easeInExpo: (x) => x === 0 ? 0 : Math.pow(2, 10 * x - 10),
  easeOutExpo: (x) => x === 1 ? 1 : 1 - Math.pow(2, -10 * x),
  easeInOutExpo: (x) => x === 0 ? 0 : x === 1 ? 1 : x < 0.5 ? Math.pow(2, 20 * x - 10) / 2 : (2 - Math.pow(2, -20 * x + 10)) / 2,
  easeInCirc: (x) => 1 - Math.sqrt(1 - Math.pow(x, 2)),
  easeOutCirc: (x) => Math.sqrt(1 - Math.pow(x - 1, 2)),
  easeInOutCirc: (x) => x < 0.5 ? (1 - Math.sqrt(1 - Math.pow(2 * x, 2))) / 2 : (Math.sqrt(1 - Math.pow(-2 * x + 2, 2)) + 1) / 2,
  easeInBack: (x) => c3 * x * x * x - c1 * x * x,
  easeOutBack: (x) => 1 + c3 * Math.pow(x - 1, 3) + c1 * Math.pow(x - 1, 2),
  easeInOutBack: (x) => x < 0.5 ? Math.pow(2 * x, 2) * ((c2 + 1) * 2 * x - c2) / 2 : (Math.pow(2 * x - 2, 2) * ((c2 + 1) * (x * 2 - 2) + c2) + 2) / 2,
  easeInElastic: (x) => x === 0 ? 0 : x === 1 ? 1 : -Math.pow(2, 10 * x - 10) * Math.sin((x * 10 - 10.75) * c4),
  easeOutElastic: (x) => x === 0 ? 0 : x === 1 ? 1 : Math.pow(2, -10 * x) * Math.sin((x * 10 - 0.75) * c4) + 1,
  easeInOutElastic: (x) => x === 0 ? 0 : x === 1 ? 1 : x < 0.5 ? -(Math.pow(2, 20 * x - 10) * Math.sin((20 * x - 11.125) * c5)) / 2 : Math.pow(2, -20 * x + 10) * Math.sin((20 * x - 11.125) * c5) / 2 + 1,
  easeInBounce: (x) => 1 - bounceOut(1 - x),
  easeOutBounce: bounceOut,
  easeInOutBounce: (x) => x < 0.5 ? (1 - bounceOut(1 - 2 * x)) / 2 : (1 + bounceOut(2 * x - 1)) / 2,
  steps
};

// src/fluids.ts
var $get = Symbol.for("FluidValue.get");
var $observers = Symbol.for("FluidValue.observers");
var hasFluidValue = (arg) => Boolean(arg && arg[$get]);
var getFluidValue = (arg) => arg && arg[$get] ? arg[$get]() : arg;
var getFluidObservers = (target) => target[$observers] || null;
function callFluidObserver(observer2, event) {
  if (observer2.eventObserved) {
    observer2.eventObserved(event);
  } else {
    observer2(event);
  }
}
function callFluidObservers(target, event) {
  const observers = target[$observers];
  if (observers) {
    observers.forEach((observer2) => {
      callFluidObserver(observer2, event);
    });
  }
}
var FluidValue = class {
  constructor(get) {
    if (!get && !(get = this.get)) {
      throw Error("Unknown getter");
    }
    setFluidGetter(this, get);
  }
};
$get, $observers;
var setFluidGetter = (target, get) => setHidden(target, $get, get);
function addFluidObserver(target, observer2) {
  if (target[$get]) {
    let observers = target[$observers];
    if (!observers) {
      setHidden(target, $observers, observers = /* @__PURE__ */ new Set());
    }
    if (!observers.has(observer2)) {
      observers.add(observer2);
      if (target.observerAdded) {
        target.observerAdded(observers.size, observer2);
      }
    }
  }
  return observer2;
}
function removeFluidObserver(target, observer2) {
  const observers = target[$observers];
  if (observers && observers.has(observer2)) {
    const count = observers.size - 1;
    if (count) {
      observers.delete(observer2);
    } else {
      target[$observers] = null;
    }
    if (target.observerRemoved) {
      target.observerRemoved(count, observer2);
    }
  }
}
var setHidden = (target, key, value) => Object.defineProperty(target, key, {
  value,
  writable: true,
  configurable: true
});

// src/regexs.ts
var numberRegex = /[+\-]?(?:0|[1-9]\d*)(?:\.\d*)?(?:[eE][+\-]?\d+)?/g;
var colorRegex = /(#(?:[0-9a-f]{2}){2,4}|(#[0-9a-f]{3})|(rgb|hsl)a?\((-?\d+%?[,\s]+){2,3}\s*[\d\.]+%?\))/gi;
var unitRegex = new RegExp(`(${numberRegex.source})(%|[a-z]+)`, "i");
var rgbaRegex = /rgba\(([0-9\.-]+), ([0-9\.-]+), ([0-9\.-]+), ([0-9\.-]+)\)/gi;
var cssVariableRegex = /var\((--[a-zA-Z0-9-_]+),? ?([a-zA-Z0-9 ()%#.,-]+)?\)/;

// src/variableToRgba.ts
var variableToRgba = (input) => {
  const [token, fallback] = parseCSSVariable(input);
  if (!token || isSSR()) {
    return input;
  }
  const value = window.getComputedStyle(document.documentElement).getPropertyValue(token);
  if (value) {
    return value.trim();
  } else if (fallback && fallback.startsWith("--")) {
    const value2 = window.getComputedStyle(document.documentElement).getPropertyValue(fallback);
    if (value2) {
      return value2;
    } else {
      return input;
    }
  } else if (fallback && cssVariableRegex.test(fallback)) {
    return variableToRgba(fallback);
  } else if (fallback) {
    return fallback;
  }
  return input;
};
var parseCSSVariable = (current) => {
  const match = cssVariableRegex.exec(current);
  if (!match)
    return [,];
  const [, token, fallback] = match;
  return [token, fallback];
};

// src/stringInterpolation.ts
var namedColorRegex;
var rgbaRound = (_, p1, p2, p3, p4) => `rgba(${Math.round(p1)}, ${Math.round(p2)}, ${Math.round(p3)}, ${p4})`;
var createStringInterpolator2 = (config) => {
  if (!namedColorRegex)
    namedColorRegex = colors ? (
      // match color names, ignore partial matches
      new RegExp(`(${Object.keys(colors).join("|")})(?!\\w)`, "g")
    ) : (
      // never match
      /^\b$/
    );
  const output = config.output.map((value) => {
    return getFluidValue(value).replace(cssVariableRegex, variableToRgba).replace(colorRegex, colorToRgba).replace(namedColorRegex, colorToRgba);
  });
  const keyframes = output.map((value) => value.match(numberRegex).map(Number));
  const outputRanges = keyframes[0].map(
    (_, i) => keyframes.map((values) => {
      if (!(i in values)) {
        throw Error('The arity of each "output" value must be equal');
      }
      return values[i];
    })
  );
  const interpolators = outputRanges.map(
    (output2) => createInterpolator({ ...config, output: output2 })
  );
  return (input) => {
    const missingUnit = !unitRegex.test(output[0]) && output.find((value) => unitRegex.test(value))?.replace(numberRegex, "");
    let i = 0;
    return output[0].replace(
      numberRegex,
      () => `${interpolators[i++](input)}${missingUnit || ""}`
    ).replace(rgbaRegex, rgbaRound);
  };
};

// src/deprecations.ts
var prefix = "react-spring: ";
var once = (fn) => {
  const func = fn;
  let called = false;
  if (typeof func != "function") {
    throw new TypeError(`${prefix}once requires a function parameter`);
  }
  return (...args) => {
    if (!called) {
      func(...args);
      called = true;
    }
  };
};
var warnInterpolate = once(console.warn);
function deprecateInterpolate() {
  warnInterpolate(
    `${prefix}The "interpolate" function is deprecated in v9 (use "to" instead)`
  );
}
var warnDirectCall = once(console.warn);
function deprecateDirectCall() {
  warnDirectCall(
    `${prefix}Directly calling start instead of using the api object is deprecated in v9 (use ".start" instead), this will be removed in later 0.X.0 versions`
  );
}

// src/isAnimatedString.ts
function isAnimatedString(value) {
  return is.str(value) && (value[0] == "#" || /\d/.test(value) || // Do not identify a CSS variable as an AnimatedString if its SSR
  !isSSR() && cssVariableRegex.test(value) || value in (colors || {}));
}

// src/dom-events/resize/resizeElement.ts
var observer;
var resizeHandlers = /* @__PURE__ */ new WeakMap();
var handleObservation = (entries) => entries.forEach(({ target, contentRect }) => {
  return resizeHandlers.get(target)?.forEach((handler) => handler(contentRect));
});
function resizeElement(handler, target) {
  if (!observer) {
    if (typeof ResizeObserver !== "undefined") {
      observer = new ResizeObserver(handleObservation);
    }
  }
  let elementHandlers = resizeHandlers.get(target);
  if (!elementHandlers) {
    elementHandlers = /* @__PURE__ */ new Set();
    resizeHandlers.set(target, elementHandlers);
  }
  elementHandlers.add(handler);
  if (observer) {
    observer.observe(target);
  }
  return () => {
    const elementHandlers2 = resizeHandlers.get(target);
    if (!elementHandlers2)
      return;
    elementHandlers2.delete(handler);
    if (!elementHandlers2.size && observer) {
      observer.unobserve(target);
    }
  };
}

// src/dom-events/resize/resizeWindow.ts
var listeners = /* @__PURE__ */ new Set();
var cleanupWindowResizeHandler;
var createResizeHandler = () => {
  const handleResize = () => {
    listeners.forEach(
      (callback) => callback({
        width: window.innerWidth,
        height: window.innerHeight
      })
    );
  };
  window.addEventListener("resize", handleResize);
  return () => {
    window.removeEventListener("resize", handleResize);
  };
};
var resizeWindow = (callback) => {
  listeners.add(callback);
  if (!cleanupWindowResizeHandler) {
    cleanupWindowResizeHandler = createResizeHandler();
  }
  return () => {
    listeners.delete(callback);
    if (!listeners.size && cleanupWindowResizeHandler) {
      cleanupWindowResizeHandler();
      cleanupWindowResizeHandler = void 0;
    }
  };
};

// src/dom-events/resize/index.ts
var react_spring_shared_modern_onResize = (callback, { container = document.documentElement } = {}) => {
  if (container === document.documentElement) {
    return resizeWindow(callback);
  } else {
    return resizeElement(callback, container);
  }
};

// src/progress.ts
var progress = (min, max, value) => max - min === 0 ? 1 : (value - min) / (max - min);

// src/dom-events/scroll/ScrollHandler.ts
var SCROLL_KEYS = {
  x: {
    length: "Width",
    position: "Left"
  },
  y: {
    length: "Height",
    position: "Top"
  }
};
var ScrollHandler = class {
  constructor(callback, container) {
    this.createAxis = () => ({
      current: 0,
      progress: 0,
      scrollLength: 0
    });
    this.updateAxis = (axisName) => {
      const axis = this.info[axisName];
      const { length, position } = SCROLL_KEYS[axisName];
      axis.current = this.container[`scroll${position}`];
      axis.scrollLength = this.container["scroll" + length] - this.container["client" + length];
      axis.progress = progress(0, axis.scrollLength, axis.current);
    };
    this.update = () => {
      this.updateAxis("x");
      this.updateAxis("y");
    };
    this.sendEvent = () => {
      this.callback(this.info);
    };
    this.advance = () => {
      this.update();
      this.sendEvent();
    };
    this.callback = callback;
    this.container = container;
    this.info = {
      time: 0,
      x: this.createAxis(),
      y: this.createAxis()
    };
  }
};

// src/dom-events/scroll/index.ts
var scrollListeners = /* @__PURE__ */ new WeakMap();
var resizeListeners = /* @__PURE__ */ new WeakMap();
var onScrollHandlers = /* @__PURE__ */ new WeakMap();
var getTarget = (container) => container === document.documentElement ? window : container;
var react_spring_shared_modern_onScroll = (callback, { container = document.documentElement } = {}) => {
  let containerHandlers = onScrollHandlers.get(container);
  if (!containerHandlers) {
    containerHandlers = /* @__PURE__ */ new Set();
    onScrollHandlers.set(container, containerHandlers);
  }
  const containerHandler = new ScrollHandler(callback, container);
  containerHandlers.add(containerHandler);
  if (!scrollListeners.has(container)) {
    const listener = () => {
      containerHandlers?.forEach((handler) => handler.advance());
      return true;
    };
    scrollListeners.set(container, listener);
    const target = getTarget(container);
    window.addEventListener("resize", listener, { passive: true });
    if (container !== document.documentElement) {
      resizeListeners.set(container, react_spring_shared_modern_onResize(listener, { container }));
    }
    target.addEventListener("scroll", listener, { passive: true });
  }
  const animateScroll = scrollListeners.get(container);
  raf(animateScroll);
  return () => {
    raf.cancel(animateScroll);
    const containerHandlers2 = onScrollHandlers.get(container);
    if (!containerHandlers2)
      return;
    containerHandlers2.delete(containerHandler);
    if (containerHandlers2.size)
      return;
    const listener = scrollListeners.get(container);
    scrollListeners.delete(container);
    if (listener) {
      getTarget(container).removeEventListener("scroll", listener);
      window.removeEventListener("resize", listener);
      resizeListeners.get(container)?.();
    }
  };
};

// src/hooks/useConstant.ts

function react_spring_shared_modern_useConstant(init) {
  const ref = useRef(null);
  if (ref.current === null) {
    ref.current = init();
  }
  return ref.current;
}

// src/hooks/useForceUpdate.ts


// src/hooks/useIsMounted.ts


// src/hooks/useIsomorphicLayoutEffect.ts

var react_spring_shared_modern_useIsomorphicLayoutEffect = isSSR() ? react.useEffect : react.useLayoutEffect;

// src/hooks/useIsMounted.ts
var useIsMounted = () => {
  const isMounted = (0,react.useRef)(false);
  react_spring_shared_modern_useIsomorphicLayoutEffect(() => {
    isMounted.current = true;
    return () => {
      isMounted.current = false;
    };
  }, []);
  return isMounted;
};

// src/hooks/useForceUpdate.ts
function useForceUpdate() {
  const update2 = (0,react.useState)()[1];
  const isMounted = useIsMounted();
  return () => {
    if (isMounted.current) {
      update2(Math.random());
    }
  };
}

// src/hooks/useMemoOne.ts

function useMemoOne(getResult, inputs) {
  const [initial] = (0,react.useState)(
    () => ({
      inputs,
      result: getResult()
    })
  );
  const committed = (0,react.useRef)();
  const prevCache = committed.current;
  let cache = prevCache;
  if (cache) {
    const useCache = Boolean(
      inputs && cache.inputs && areInputsEqual(inputs, cache.inputs)
    );
    if (!useCache) {
      cache = {
        inputs,
        result: getResult()
      };
    }
  } else {
    cache = initial;
  }
  (0,react.useEffect)(() => {
    committed.current = cache;
    if (prevCache == initial) {
      initial.inputs = initial.result = void 0;
    }
  }, [cache]);
  return cache.result;
}
function areInputsEqual(next, prev) {
  if (next.length !== prev.length) {
    return false;
  }
  for (let i = 0; i < next.length; i++) {
    if (next[i] !== prev[i]) {
      return false;
    }
  }
  return true;
}

// src/hooks/useOnce.ts

var useOnce = (effect) => (0,react.useEffect)(effect, emptyDeps);
var emptyDeps = [];

// src/hooks/usePrev.ts

function usePrev(value) {
  const prevRef = (0,react.useRef)();
  (0,react.useEffect)(() => {
    prevRef.current = value;
  });
  return prevRef.current;
}

// src/hooks/useReducedMotion.ts

var useReducedMotion = () => {
  const [reducedMotion, setReducedMotion] = useState3(null);
  react_spring_shared_modern_useIsomorphicLayoutEffect(() => {
    const mql = window.matchMedia("(prefers-reduced-motion)");
    const handleMediaChange = (e) => {
      setReducedMotion(e.matches);
      react_spring_shared_modern_assign({
        skipAnimation: e.matches
      });
    };
    handleMediaChange(mql);
    mql.addEventListener("change", handleMediaChange);
    return () => {
      mql.removeEventListener("change", handleMediaChange);
    };
  }, []);
  return reducedMotion;
};

//# sourceMappingURL=react-spring_shared.modern.mjs.map
;// CONCATENATED MODULE: ./node_modules/@react-spring/animated/dist/react-spring_animated.modern.mjs
// src/Animated.ts

var $node = Symbol.for("Animated:node");
var isAnimated = (value) => !!value && value[$node] === value;
var getAnimated = (owner) => owner && owner[$node];
var setAnimated = (owner, node) => defineHidden(owner, $node, node);
var getPayload = (owner) => owner && owner[$node] && owner[$node].getPayload();
var Animated = class {
  constructor() {
    setAnimated(this, this);
  }
  /** Get every `AnimatedValue` used by this node. */
  getPayload() {
    return this.payload || [];
  }
};

// src/AnimatedValue.ts

var AnimatedValue = class extends Animated {
  constructor(_value) {
    super();
    this._value = _value;
    this.done = true;
    this.durationProgress = 0;
    if (is.num(this._value)) {
      this.lastPosition = this._value;
    }
  }
  /** @internal */
  static create(value) {
    return new AnimatedValue(value);
  }
  getPayload() {
    return [this];
  }
  getValue() {
    return this._value;
  }
  setValue(value, step) {
    if (is.num(value)) {
      this.lastPosition = value;
      if (step) {
        value = Math.round(value / step) * step;
        if (this.done) {
          this.lastPosition = value;
        }
      }
    }
    if (this._value === value) {
      return false;
    }
    this._value = value;
    return true;
  }
  reset() {
    const { done } = this;
    this.done = false;
    if (is.num(this._value)) {
      this.elapsedTime = 0;
      this.durationProgress = 0;
      this.lastPosition = this._value;
      if (done)
        this.lastVelocity = null;
      this.v0 = null;
    }
  }
};

// src/AnimatedString.ts

var AnimatedString = class extends AnimatedValue {
  constructor(value) {
    super(0);
    this._string = null;
    this._toString = createInterpolator({
      output: [value, value]
    });
  }
  /** @internal */
  static create(value) {
    return new AnimatedString(value);
  }
  getValue() {
    const value = this._string;
    return value == null ? this._string = this._toString(this._value) : value;
  }
  setValue(value) {
    if (is.str(value)) {
      if (value == this._string) {
        return false;
      }
      this._string = value;
      this._value = 1;
    } else if (super.setValue(value)) {
      this._string = null;
    } else {
      return false;
    }
    return true;
  }
  reset(goal) {
    if (goal) {
      this._toString = createInterpolator({
        output: [this.getValue(), goal]
      });
    }
    this._value = 0;
    super.reset();
  }
};

// src/AnimatedArray.ts


// src/AnimatedObject.ts


// src/context.ts
var TreeContext = { dependencies: null };

// src/AnimatedObject.ts
var AnimatedObject = class extends Animated {
  constructor(source) {
    super();
    this.source = source;
    this.setValue(source);
  }
  getValue(animated) {
    const values = {};
    eachProp(this.source, (source, key) => {
      if (isAnimated(source)) {
        values[key] = source.getValue(animated);
      } else if (hasFluidValue(source)) {
        values[key] = getFluidValue(source);
      } else if (!animated) {
        values[key] = source;
      }
    });
    return values;
  }
  /** Replace the raw object data */
  setValue(source) {
    this.source = source;
    this.payload = this._makePayload(source);
  }
  reset() {
    if (this.payload) {
      react_spring_shared_modern_each(this.payload, (node) => node.reset());
    }
  }
  /** Create a payload set. */
  _makePayload(source) {
    if (source) {
      const payload = /* @__PURE__ */ new Set();
      eachProp(source, this._addToPayload, payload);
      return Array.from(payload);
    }
  }
  /** Add to a payload set. */
  _addToPayload(source) {
    if (TreeContext.dependencies && hasFluidValue(source)) {
      TreeContext.dependencies.add(source);
    }
    const payload = getPayload(source);
    if (payload) {
      react_spring_shared_modern_each(payload, (node) => this.add(node));
    }
  }
};

// src/AnimatedArray.ts
var AnimatedArray = class extends AnimatedObject {
  constructor(source) {
    super(source);
  }
  /** @internal */
  static create(source) {
    return new AnimatedArray(source);
  }
  getValue() {
    return this.source.map((node) => node.getValue());
  }
  setValue(source) {
    const payload = this.getPayload();
    if (source.length == payload.length) {
      return payload.map((node, i) => node.setValue(source[i])).some(Boolean);
    }
    super.setValue(source.map(makeAnimated));
    return true;
  }
};
function makeAnimated(value) {
  const nodeType = isAnimatedString(value) ? AnimatedString : AnimatedValue;
  return nodeType.create(value);
}

// src/getAnimatedType.ts

function getAnimatedType(value) {
  const parentNode = getAnimated(value);
  return parentNode ? parentNode.constructor : is.arr(value) ? AnimatedArray : isAnimatedString(value) ? AnimatedString : AnimatedValue;
}

// src/createHost.ts


// src/withAnimated.tsx



var withAnimated = (Component, host) => {
  const hasInstance = (
    // Function components must use "forwardRef" to avoid being
    // re-rendered on every animation frame.
    !is.fun(Component) || Component.prototype && Component.prototype.isReactComponent
  );
  return (0,react.forwardRef)((givenProps, givenRef) => {
    const instanceRef = (0,react.useRef)(null);
    const ref = hasInstance && // eslint-disable-next-line react-hooks/rules-of-hooks
    (0,react.useCallback)(
      (value) => {
        instanceRef.current = updateRef(givenRef, value);
      },
      [givenRef]
    );
    const [props, deps] = getAnimatedState(givenProps, host);
    const forceUpdate = useForceUpdate();
    const callback = () => {
      const instance = instanceRef.current;
      if (hasInstance && !instance) {
        return;
      }
      const didUpdate = instance ? host.applyAnimatedValues(instance, props.getValue(true)) : false;
      if (didUpdate === false) {
        forceUpdate();
      }
    };
    const observer = new PropsObserver(callback, deps);
    const observerRef = (0,react.useRef)();
    react_spring_shared_modern_useIsomorphicLayoutEffect(() => {
      observerRef.current = observer;
      react_spring_shared_modern_each(deps, (dep) => addFluidObserver(dep, observer));
      return () => {
        if (observerRef.current) {
          react_spring_shared_modern_each(
            observerRef.current.deps,
            (dep) => removeFluidObserver(dep, observerRef.current)
          );
          raf.cancel(observerRef.current.update);
        }
      };
    });
    (0,react.useEffect)(callback, []);
    useOnce(() => () => {
      const observer2 = observerRef.current;
      react_spring_shared_modern_each(observer2.deps, (dep) => removeFluidObserver(dep, observer2));
    });
    const usedProps = host.getComponentProps(props.getValue());
    return /* @__PURE__ */ react.createElement(Component, { ...usedProps, ref });
  });
};
var PropsObserver = class {
  constructor(update, deps) {
    this.update = update;
    this.deps = deps;
  }
  eventObserved(event) {
    if (event.type == "change") {
      raf.write(this.update);
    }
  }
};
function getAnimatedState(props, host) {
  const dependencies = /* @__PURE__ */ new Set();
  TreeContext.dependencies = dependencies;
  if (props.style)
    props = {
      ...props,
      style: host.createAnimatedStyle(props.style)
    };
  props = new AnimatedObject(props);
  TreeContext.dependencies = null;
  return [props, dependencies];
}
function updateRef(ref, value) {
  if (ref) {
    if (is.fun(ref))
      ref(value);
    else
      ref.current = value;
  }
  return value;
}

// src/createHost.ts
var cacheKey = Symbol.for("AnimatedComponent");
var createHost = (components, {
  applyAnimatedValues = () => false,
  createAnimatedStyle = (style) => new AnimatedObject(style),
  getComponentProps = (props) => props
} = {}) => {
  const hostConfig = {
    applyAnimatedValues,
    createAnimatedStyle,
    getComponentProps
  };
  const animated = (Component) => {
    const displayName = getDisplayName(Component) || "Anonymous";
    if (is.str(Component)) {
      Component = animated[Component] || (animated[Component] = withAnimated(Component, hostConfig));
    } else {
      Component = Component[cacheKey] || (Component[cacheKey] = withAnimated(Component, hostConfig));
    }
    Component.displayName = `Animated(${displayName})`;
    return Component;
  };
  eachProp(components, (Component, key) => {
    if (is.arr(components)) {
      key = getDisplayName(Component);
    }
    animated[key] = animated(Component);
  });
  return {
    animated
  };
};
var getDisplayName = (arg) => is.str(arg) ? arg : arg && is.str(arg.displayName) ? arg.displayName : is.fun(arg) && arg.name || null;

//# sourceMappingURL=react-spring_animated.modern.mjs.map
;// CONCATENATED MODULE: ./node_modules/@react-spring/core/dist/react-spring_core.modern.mjs
// src/hooks/useChain.ts


// src/helpers.ts

function callProp(value, ...args) {
  return is.fun(value) ? value(...args) : value;
}
var matchProp = (value, key) => value === true || !!(key && value && (is.fun(value) ? value(key) : toArray(value).includes(key)));
var resolveProp = (prop, key) => is.obj(prop) ? key && prop[key] : prop;
var getDefaultProp = (props, key) => props.default === true ? props[key] : props.default ? props.default[key] : void 0;
var noopTransform = (value) => value;
var getDefaultProps = (props, transform = noopTransform) => {
  let keys = DEFAULT_PROPS;
  if (props.default && props.default !== true) {
    props = props.default;
    keys = Object.keys(props);
  }
  const defaults2 = {};
  for (const key of keys) {
    const value = transform(props[key], key);
    if (!is.und(value)) {
      defaults2[key] = value;
    }
  }
  return defaults2;
};
var DEFAULT_PROPS = [
  "config",
  "onProps",
  "onStart",
  "onChange",
  "onPause",
  "onResume",
  "onRest"
];
var RESERVED_PROPS = {
  config: 1,
  from: 1,
  to: 1,
  ref: 1,
  loop: 1,
  reset: 1,
  pause: 1,
  cancel: 1,
  reverse: 1,
  immediate: 1,
  default: 1,
  delay: 1,
  onProps: 1,
  onStart: 1,
  onChange: 1,
  onPause: 1,
  onResume: 1,
  onRest: 1,
  onResolve: 1,
  // Transition props
  items: 1,
  trail: 1,
  sort: 1,
  expires: 1,
  initial: 1,
  enter: 1,
  update: 1,
  leave: 1,
  children: 1,
  onDestroyed: 1,
  // Internal props
  keys: 1,
  callId: 1,
  parentId: 1
};
function getForwardProps(props) {
  const forward = {};
  let count = 0;
  eachProp(props, (value, prop) => {
    if (!RESERVED_PROPS[prop]) {
      forward[prop] = value;
      count++;
    }
  });
  if (count) {
    return forward;
  }
}
function inferTo(props) {
  const to2 = getForwardProps(props);
  if (to2) {
    const out = { to: to2 };
    eachProp(props, (val, key) => key in to2 || (out[key] = val));
    return out;
  }
  return { ...props };
}
function computeGoal(value) {
  value = getFluidValue(value);
  return is.arr(value) ? value.map(computeGoal) : isAnimatedString(value) ? globals_exports.createStringInterpolator({
    range: [0, 1],
    output: [value, value]
  })(1) : value;
}
function hasProps(props) {
  for (const _ in props)
    return true;
  return false;
}
function isAsyncTo(to2) {
  return is.fun(to2) || is.arr(to2) && is.obj(to2[0]);
}
function detachRefs(ctrl, ref) {
  ctrl.ref?.delete(ctrl);
  ref?.delete(ctrl);
}
function replaceRef(ctrl, ref) {
  if (ref && ctrl.ref !== ref) {
    ctrl.ref?.delete(ctrl);
    ref.add(ctrl);
    ctrl.ref = ref;
  }
}

// src/hooks/useChain.ts
function useChain(refs, timeSteps, timeFrame = 1e3) {
  useIsomorphicLayoutEffect(() => {
    if (timeSteps) {
      let prevDelay = 0;
      each(refs, (ref, i) => {
        const controllers = ref.current;
        if (controllers.length) {
          let delay = timeFrame * timeSteps[i];
          if (isNaN(delay))
            delay = prevDelay;
          else
            prevDelay = delay;
          each(controllers, (ctrl) => {
            each(ctrl.queue, (props) => {
              const memoizedDelayProp = props.delay;
              props.delay = (key) => delay + callProp(memoizedDelayProp || 0, key);
            });
          });
          ref.start();
        }
      });
    } else {
      let p = Promise.resolve();
      each(refs, (ref) => {
        const controllers = ref.current;
        if (controllers.length) {
          const queues = controllers.map((ctrl) => {
            const q = ctrl.queue;
            ctrl.queue = [];
            return q;
          });
          p = p.then(() => {
            each(
              controllers,
              (ctrl, i) => each(queues[i] || [], (update2) => ctrl.queue.push(update2))
            );
            return Promise.all(ref.start());
          });
        }
      });
    }
  });
}

// src/hooks/useSpring.ts


// src/hooks/useSprings.ts



// src/SpringValue.ts



// src/AnimationConfig.ts


// src/constants.ts
var config = {
  default: { tension: 170, friction: 26 },
  gentle: { tension: 120, friction: 14 },
  wobbly: { tension: 180, friction: 12 },
  stiff: { tension: 210, friction: 20 },
  slow: { tension: 280, friction: 60 },
  molasses: { tension: 280, friction: 120 }
};

// src/AnimationConfig.ts
var defaults = {
  ...config.default,
  mass: 1,
  damping: 1,
  easing: easings.linear,
  clamp: false
};
var AnimationConfig = class {
  constructor() {
    /**
     * The initial velocity of one or more values.
     *
     * @default 0
     */
    this.velocity = 0;
    Object.assign(this, defaults);
  }
};
function mergeConfig(config2, newConfig, defaultConfig) {
  if (defaultConfig) {
    defaultConfig = { ...defaultConfig };
    sanitizeConfig(defaultConfig, newConfig);
    newConfig = { ...defaultConfig, ...newConfig };
  }
  sanitizeConfig(config2, newConfig);
  Object.assign(config2, newConfig);
  for (const key in defaults) {
    if (config2[key] == null) {
      config2[key] = defaults[key];
    }
  }
  let { frequency, damping } = config2;
  const { mass } = config2;
  if (!is.und(frequency)) {
    if (frequency < 0.01)
      frequency = 0.01;
    if (damping < 0)
      damping = 0;
    config2.tension = Math.pow(2 * Math.PI / frequency, 2) * mass;
    config2.friction = 4 * Math.PI * damping * mass / frequency;
  }
  return config2;
}
function sanitizeConfig(config2, props) {
  if (!is.und(props.decay)) {
    config2.duration = void 0;
  } else {
    const isTensionConfig = !is.und(props.tension) || !is.und(props.friction);
    if (isTensionConfig || !is.und(props.frequency) || !is.und(props.damping) || !is.und(props.mass)) {
      config2.duration = void 0;
      config2.decay = void 0;
    }
    if (isTensionConfig) {
      config2.frequency = void 0;
    }
  }
}

// src/Animation.ts
var emptyArray = [];
var Animation = class {
  constructor() {
    this.changed = false;
    this.values = emptyArray;
    this.toValues = null;
    this.fromValues = emptyArray;
    this.config = new AnimationConfig();
    this.immediate = false;
  }
};

// src/scheduleProps.ts

function scheduleProps(callId, { key, props, defaultProps, state, actions }) {
  return new Promise((resolve, reject) => {
    let delay;
    let timeout;
    let cancel = matchProp(props.cancel ?? defaultProps?.cancel, key);
    if (cancel) {
      onStart();
    } else {
      if (!is.und(props.pause)) {
        state.paused = matchProp(props.pause, key);
      }
      let pause = defaultProps?.pause;
      if (pause !== true) {
        pause = state.paused || matchProp(pause, key);
      }
      delay = callProp(props.delay || 0, key);
      if (pause) {
        state.resumeQueue.add(onResume);
        actions.pause();
      } else {
        actions.resume();
        onResume();
      }
    }
    function onPause() {
      state.resumeQueue.add(onResume);
      state.timeouts.delete(timeout);
      timeout.cancel();
      delay = timeout.time - raf.now();
    }
    function onResume() {
      if (delay > 0 && !globals_exports.skipAnimation) {
        state.delayed = true;
        timeout = raf.setTimeout(onStart, delay);
        state.pauseQueue.add(onPause);
        state.timeouts.add(timeout);
      } else {
        onStart();
      }
    }
    function onStart() {
      if (state.delayed) {
        state.delayed = false;
      }
      state.pauseQueue.delete(onPause);
      state.timeouts.delete(timeout);
      if (callId <= (state.cancelId || 0)) {
        cancel = true;
      }
      try {
        actions.start({ ...props, callId, cancel }, resolve);
      } catch (err) {
        reject(err);
      }
    }
  });
}

// src/runAsync.ts


// src/AnimationResult.ts
var getCombinedResult = (target, results) => results.length == 1 ? results[0] : results.some((result) => result.cancelled) ? getCancelledResult(target.get()) : results.every((result) => result.noop) ? getNoopResult(target.get()) : getFinishedResult(
  target.get(),
  results.every((result) => result.finished)
);
var getNoopResult = (value) => ({
  value,
  noop: true,
  finished: true,
  cancelled: false
});
var getFinishedResult = (value, finished, cancelled = false) => ({
  value,
  finished,
  cancelled
});
var getCancelledResult = (value) => ({
  value,
  cancelled: true,
  finished: false
});

// src/runAsync.ts
function runAsync(to2, props, state, target) {
  const { callId, parentId, onRest } = props;
  const { asyncTo: prevTo, promise: prevPromise } = state;
  if (!parentId && to2 === prevTo && !props.reset) {
    return prevPromise;
  }
  return state.promise = (async () => {
    state.asyncId = callId;
    state.asyncTo = to2;
    const defaultProps = getDefaultProps(
      props,
      (value, key) => (
        // The `onRest` prop is only called when the `runAsync` promise is resolved.
        key === "onRest" ? void 0 : value
      )
    );
    let preventBail;
    let bail;
    const bailPromise = new Promise(
      (resolve, reject) => (preventBail = resolve, bail = reject)
    );
    const bailIfEnded = (bailSignal) => {
      const bailResult = (
        // The `cancel` prop or `stop` method was used.
        callId <= (state.cancelId || 0) && getCancelledResult(target) || // The async `to` prop was replaced.
        callId !== state.asyncId && getFinishedResult(target, false)
      );
      if (bailResult) {
        bailSignal.result = bailResult;
        bail(bailSignal);
        throw bailSignal;
      }
    };
    const animate = (arg1, arg2) => {
      const bailSignal = new BailSignal();
      const skipAnimationSignal = new SkipAnimationSignal();
      return (async () => {
        if (globals_exports.skipAnimation) {
          stopAsync(state);
          skipAnimationSignal.result = getFinishedResult(target, false);
          bail(skipAnimationSignal);
          throw skipAnimationSignal;
        }
        bailIfEnded(bailSignal);
        const props2 = is.obj(arg1) ? { ...arg1 } : { ...arg2, to: arg1 };
        props2.parentId = callId;
        eachProp(defaultProps, (value, key) => {
          if (is.und(props2[key])) {
            props2[key] = value;
          }
        });
        const result2 = await target.start(props2);
        bailIfEnded(bailSignal);
        if (state.paused) {
          await new Promise((resume) => {
            state.resumeQueue.add(resume);
          });
        }
        return result2;
      })();
    };
    let result;
    if (globals_exports.skipAnimation) {
      stopAsync(state);
      return getFinishedResult(target, false);
    }
    try {
      let animating;
      if (is.arr(to2)) {
        animating = (async (queue) => {
          for (const props2 of queue) {
            await animate(props2);
          }
        })(to2);
      } else {
        animating = Promise.resolve(to2(animate, target.stop.bind(target)));
      }
      await Promise.all([animating.then(preventBail), bailPromise]);
      result = getFinishedResult(target.get(), true, false);
    } catch (err) {
      if (err instanceof BailSignal) {
        result = err.result;
      } else if (err instanceof SkipAnimationSignal) {
        result = err.result;
      } else {
        throw err;
      }
    } finally {
      if (callId == state.asyncId) {
        state.asyncId = parentId;
        state.asyncTo = parentId ? prevTo : void 0;
        state.promise = parentId ? prevPromise : void 0;
      }
    }
    if (is.fun(onRest)) {
      raf.batchedUpdates(() => {
        onRest(result, target, target.item);
      });
    }
    return result;
  })();
}
function stopAsync(state, cancelId) {
  flush(state.timeouts, (t) => t.cancel());
  state.pauseQueue.clear();
  state.resumeQueue.clear();
  state.asyncId = state.asyncTo = state.promise = void 0;
  if (cancelId)
    state.cancelId = cancelId;
}
var BailSignal = class extends Error {
  constructor() {
    super(
      "An async animation has been interrupted. You see this error because you forgot to use `await` or `.catch(...)` on its returned promise."
    );
  }
};
var SkipAnimationSignal = class extends Error {
  constructor() {
    super("SkipAnimationSignal");
  }
};

// src/FrameValue.ts


var isFrameValue = (value) => value instanceof FrameValue;
var nextId = 1;
var FrameValue = class extends FluidValue {
  constructor() {
    super(...arguments);
    this.id = nextId++;
    this._priority = 0;
  }
  get priority() {
    return this._priority;
  }
  set priority(priority) {
    if (this._priority != priority) {
      this._priority = priority;
      this._onPriorityChange(priority);
    }
  }
  /** Get the current value */
  get() {
    const node = getAnimated(this);
    return node && node.getValue();
  }
  /** Create a spring that maps our value to another value */
  to(...args) {
    return globals_exports.to(this, args);
  }
  /** @deprecated Use the `to` method instead. */
  interpolate(...args) {
    deprecateInterpolate();
    return globals_exports.to(this, args);
  }
  toJSON() {
    return this.get();
  }
  observerAdded(count) {
    if (count == 1)
      this._attach();
  }
  observerRemoved(count) {
    if (count == 0)
      this._detach();
  }
  /** Called when the first child is added. */
  _attach() {
  }
  /** Called when the last child is removed. */
  _detach() {
  }
  /** Tell our children about our new value */
  _onChange(value, idle = false) {
    callFluidObservers(this, {
      type: "change",
      parent: this,
      value,
      idle
    });
  }
  /** Tell our children about our new priority */
  _onPriorityChange(priority) {
    if (!this.idle) {
      frameLoop.sort(this);
    }
    callFluidObservers(this, {
      type: "priority",
      parent: this,
      priority
    });
  }
};

// src/SpringPhase.ts
var $P = Symbol.for("SpringPhase");
var HAS_ANIMATED = 1;
var IS_ANIMATING = 2;
var IS_PAUSED = 4;
var hasAnimated = (target) => (target[$P] & HAS_ANIMATED) > 0;
var isAnimating = (target) => (target[$P] & IS_ANIMATING) > 0;
var isPaused = (target) => (target[$P] & IS_PAUSED) > 0;
var setActiveBit = (target, active) => active ? target[$P] |= IS_ANIMATING | HAS_ANIMATED : target[$P] &= ~IS_ANIMATING;
var setPausedBit = (target, paused) => paused ? target[$P] |= IS_PAUSED : target[$P] &= ~IS_PAUSED;

// src/SpringValue.ts
var SpringValue = class extends FrameValue {
  constructor(arg1, arg2) {
    super();
    /** The animation state */
    this.animation = new Animation();
    /** Some props have customizable default values */
    this.defaultProps = {};
    /** The state for `runAsync` calls */
    this._state = {
      paused: false,
      delayed: false,
      pauseQueue: /* @__PURE__ */ new Set(),
      resumeQueue: /* @__PURE__ */ new Set(),
      timeouts: /* @__PURE__ */ new Set()
    };
    /** The promise resolvers of pending `start` calls */
    this._pendingCalls = /* @__PURE__ */ new Set();
    /** The counter for tracking `scheduleProps` calls */
    this._lastCallId = 0;
    /** The last `scheduleProps` call that changed the `to` prop */
    this._lastToId = 0;
    this._memoizedDuration = 0;
    if (!is.und(arg1) || !is.und(arg2)) {
      const props = is.obj(arg1) ? { ...arg1 } : { ...arg2, from: arg1 };
      if (is.und(props.default)) {
        props.default = true;
      }
      this.start(props);
    }
  }
  /** Equals true when not advancing on each frame. */
  get idle() {
    return !(isAnimating(this) || this._state.asyncTo) || isPaused(this);
  }
  get goal() {
    return getFluidValue(this.animation.to);
  }
  get velocity() {
    const node = getAnimated(this);
    return node instanceof AnimatedValue ? node.lastVelocity || 0 : node.getPayload().map((node2) => node2.lastVelocity || 0);
  }
  /**
   * When true, this value has been animated at least once.
   */
  get hasAnimated() {
    return hasAnimated(this);
  }
  /**
   * When true, this value has an unfinished animation,
   * which is either active or paused.
   */
  get isAnimating() {
    return isAnimating(this);
  }
  /**
   * When true, all current and future animations are paused.
   */
  get isPaused() {
    return isPaused(this);
  }
  /**
   *
   *
   */
  get isDelayed() {
    return this._state.delayed;
  }
  /** Advance the current animation by a number of milliseconds */
  advance(dt) {
    let idle = true;
    let changed = false;
    const anim = this.animation;
    let { toValues } = anim;
    const { config: config2 } = anim;
    const payload = getPayload(anim.to);
    if (!payload && hasFluidValue(anim.to)) {
      toValues = toArray(getFluidValue(anim.to));
    }
    anim.values.forEach((node2, i) => {
      if (node2.done)
        return;
      const to2 = (
        // Animated strings always go from 0 to 1.
        node2.constructor == AnimatedString ? 1 : payload ? payload[i].lastPosition : toValues[i]
      );
      let finished = anim.immediate;
      let position = to2;
      if (!finished) {
        position = node2.lastPosition;
        if (config2.tension <= 0) {
          node2.done = true;
          return;
        }
        let elapsed = node2.elapsedTime += dt;
        const from = anim.fromValues[i];
        const v0 = node2.v0 != null ? node2.v0 : node2.v0 = is.arr(config2.velocity) ? config2.velocity[i] : config2.velocity;
        let velocity;
        const precision = config2.precision || (from == to2 ? 5e-3 : Math.min(1, Math.abs(to2 - from) * 1e-3));
        if (!is.und(config2.duration)) {
          let p = 1;
          if (config2.duration > 0) {
            if (this._memoizedDuration !== config2.duration) {
              this._memoizedDuration = config2.duration;
              if (node2.durationProgress > 0) {
                node2.elapsedTime = config2.duration * node2.durationProgress;
                elapsed = node2.elapsedTime += dt;
              }
            }
            p = (config2.progress || 0) + elapsed / this._memoizedDuration;
            p = p > 1 ? 1 : p < 0 ? 0 : p;
            node2.durationProgress = p;
          }
          position = from + config2.easing(p) * (to2 - from);
          velocity = (position - node2.lastPosition) / dt;
          finished = p == 1;
        } else if (config2.decay) {
          const decay = config2.decay === true ? 0.998 : config2.decay;
          const e = Math.exp(-(1 - decay) * elapsed);
          position = from + v0 / (1 - decay) * (1 - e);
          finished = Math.abs(node2.lastPosition - position) <= precision;
          velocity = v0 * e;
        } else {
          velocity = node2.lastVelocity == null ? v0 : node2.lastVelocity;
          const restVelocity = config2.restVelocity || precision / 10;
          const bounceFactor = config2.clamp ? 0 : config2.bounce;
          const canBounce = !is.und(bounceFactor);
          const isGrowing = from == to2 ? node2.v0 > 0 : from < to2;
          let isMoving;
          let isBouncing = false;
          const step = 1;
          const numSteps = Math.ceil(dt / step);
          for (let n = 0; n < numSteps; ++n) {
            isMoving = Math.abs(velocity) > restVelocity;
            if (!isMoving) {
              finished = Math.abs(to2 - position) <= precision;
              if (finished) {
                break;
              }
            }
            if (canBounce) {
              isBouncing = position == to2 || position > to2 == isGrowing;
              if (isBouncing) {
                velocity = -velocity * bounceFactor;
                position = to2;
              }
            }
            const springForce = -config2.tension * 1e-6 * (position - to2);
            const dampingForce = -config2.friction * 1e-3 * velocity;
            const acceleration = (springForce + dampingForce) / config2.mass;
            velocity = velocity + acceleration * step;
            position = position + velocity * step;
          }
        }
        node2.lastVelocity = velocity;
        if (Number.isNaN(position)) {
          console.warn(`Got NaN while animating:`, this);
          finished = true;
        }
      }
      if (payload && !payload[i].done) {
        finished = false;
      }
      if (finished) {
        node2.done = true;
      } else {
        idle = false;
      }
      if (node2.setValue(position, config2.round)) {
        changed = true;
      }
    });
    const node = getAnimated(this);
    const currVal = node.getValue();
    if (idle) {
      const finalVal = getFluidValue(anim.to);
      if ((currVal !== finalVal || changed) && !config2.decay) {
        node.setValue(finalVal);
        this._onChange(finalVal);
      } else if (changed && config2.decay) {
        this._onChange(currVal);
      }
      this._stop();
    } else if (changed) {
      this._onChange(currVal);
    }
  }
  /** Set the current value, while stopping the current animation */
  set(value) {
    raf.batchedUpdates(() => {
      this._stop();
      this._focus(value);
      this._set(value);
    });
    return this;
  }
  /**
   * Freeze the active animation in time, as well as any updates merged
   * before `resume` is called.
   */
  pause() {
    this._update({ pause: true });
  }
  /** Resume the animation if paused. */
  resume() {
    this._update({ pause: false });
  }
  /** Skip to the end of the current animation. */
  finish() {
    if (isAnimating(this)) {
      const { to: to2, config: config2 } = this.animation;
      raf.batchedUpdates(() => {
        this._onStart();
        if (!config2.decay) {
          this._set(to2, false);
        }
        this._stop();
      });
    }
    return this;
  }
  /** Push props into the pending queue. */
  update(props) {
    const queue = this.queue || (this.queue = []);
    queue.push(props);
    return this;
  }
  start(to2, arg2) {
    let queue;
    if (!is.und(to2)) {
      queue = [is.obj(to2) ? to2 : { ...arg2, to: to2 }];
    } else {
      queue = this.queue || [];
      this.queue = [];
    }
    return Promise.all(
      queue.map((props) => {
        const up = this._update(props);
        return up;
      })
    ).then((results) => getCombinedResult(this, results));
  }
  /**
   * Stop the current animation, and cancel any delayed updates.
   *
   * Pass `true` to call `onRest` with `cancelled: true`.
   */
  stop(cancel) {
    const { to: to2 } = this.animation;
    this._focus(this.get());
    stopAsync(this._state, cancel && this._lastCallId);
    raf.batchedUpdates(() => this._stop(to2, cancel));
    return this;
  }
  /** Restart the animation. */
  reset() {
    this._update({ reset: true });
  }
  /** @internal */
  eventObserved(event) {
    if (event.type == "change") {
      this._start();
    } else if (event.type == "priority") {
      this.priority = event.priority + 1;
    }
  }
  /**
   * Parse the `to` and `from` range from the given `props` object.
   *
   * This also ensures the initial value is available to animated components
   * during the render phase.
   */
  _prepareNode(props) {
    const key = this.key || "";
    let { to: to2, from } = props;
    to2 = is.obj(to2) ? to2[key] : to2;
    if (to2 == null || isAsyncTo(to2)) {
      to2 = void 0;
    }
    from = is.obj(from) ? from[key] : from;
    if (from == null) {
      from = void 0;
    }
    const range = { to: to2, from };
    if (!hasAnimated(this)) {
      if (props.reverse)
        [to2, from] = [from, to2];
      from = getFluidValue(from);
      if (!is.und(from)) {
        this._set(from);
      } else if (!getAnimated(this)) {
        this._set(to2);
      }
    }
    return range;
  }
  /** Every update is processed by this method before merging. */
  _update({ ...props }, isLoop) {
    const { key, defaultProps } = this;
    if (props.default)
      Object.assign(
        defaultProps,
        getDefaultProps(
          props,
          (value, prop) => /^on/.test(prop) ? resolveProp(value, key) : value
        )
      );
    mergeActiveFn(this, props, "onProps");
    sendEvent(this, "onProps", props, this);
    const range = this._prepareNode(props);
    if (Object.isFrozen(this)) {
      throw Error(
        "Cannot animate a `SpringValue` object that is frozen. Did you forget to pass your component to `animated(...)` before animating its props?"
      );
    }
    const state = this._state;
    return scheduleProps(++this._lastCallId, {
      key,
      props,
      defaultProps,
      state,
      actions: {
        pause: () => {
          if (!isPaused(this)) {
            setPausedBit(this, true);
            flushCalls(state.pauseQueue);
            sendEvent(
              this,
              "onPause",
              getFinishedResult(this, checkFinished(this, this.animation.to)),
              this
            );
          }
        },
        resume: () => {
          if (isPaused(this)) {
            setPausedBit(this, false);
            if (isAnimating(this)) {
              this._resume();
            }
            flushCalls(state.resumeQueue);
            sendEvent(
              this,
              "onResume",
              getFinishedResult(this, checkFinished(this, this.animation.to)),
              this
            );
          }
        },
        start: this._merge.bind(this, range)
      }
    }).then((result) => {
      if (props.loop && result.finished && !(isLoop && result.noop)) {
        const nextProps = createLoopUpdate(props);
        if (nextProps) {
          return this._update(nextProps, true);
        }
      }
      return result;
    });
  }
  /** Merge props into the current animation */
  _merge(range, props, resolve) {
    if (props.cancel) {
      this.stop(true);
      return resolve(getCancelledResult(this));
    }
    const hasToProp = !is.und(range.to);
    const hasFromProp = !is.und(range.from);
    if (hasToProp || hasFromProp) {
      if (props.callId > this._lastToId) {
        this._lastToId = props.callId;
      } else {
        return resolve(getCancelledResult(this));
      }
    }
    const { key, defaultProps, animation: anim } = this;
    const { to: prevTo, from: prevFrom } = anim;
    let { to: to2 = prevTo, from = prevFrom } = range;
    if (hasFromProp && !hasToProp && (!props.default || is.und(to2))) {
      to2 = from;
    }
    if (props.reverse)
      [to2, from] = [from, to2];
    const hasFromChanged = !isEqual(from, prevFrom);
    if (hasFromChanged) {
      anim.from = from;
    }
    from = getFluidValue(from);
    const hasToChanged = !isEqual(to2, prevTo);
    if (hasToChanged) {
      this._focus(to2);
    }
    const hasAsyncTo = isAsyncTo(props.to);
    const { config: config2 } = anim;
    const { decay, velocity } = config2;
    if (hasToProp || hasFromProp) {
      config2.velocity = 0;
    }
    if (props.config && !hasAsyncTo) {
      mergeConfig(
        config2,
        callProp(props.config, key),
        // Avoid calling the same "config" prop twice.
        props.config !== defaultProps.config ? callProp(defaultProps.config, key) : void 0
      );
    }
    let node = getAnimated(this);
    if (!node || is.und(to2)) {
      return resolve(getFinishedResult(this, true));
    }
    const reset = (
      // When `reset` is undefined, the `from` prop implies `reset: true`,
      // except for declarative updates. When `reset` is defined, there
      // must exist a value to animate from.
      is.und(props.reset) ? hasFromProp && !props.default : !is.und(from) && matchProp(props.reset, key)
    );
    const value = reset ? from : this.get();
    const goal = computeGoal(to2);
    const isAnimatable = is.num(goal) || is.arr(goal) || isAnimatedString(goal);
    const immediate = !hasAsyncTo && (!isAnimatable || matchProp(defaultProps.immediate || props.immediate, key));
    if (hasToChanged) {
      const nodeType = getAnimatedType(to2);
      if (nodeType !== node.constructor) {
        if (immediate) {
          node = this._set(goal);
        } else
          throw Error(
            `Cannot animate between ${node.constructor.name} and ${nodeType.name}, as the "to" prop suggests`
          );
      }
    }
    const goalType = node.constructor;
    let started = hasFluidValue(to2);
    let finished = false;
    if (!started) {
      const hasValueChanged = reset || !hasAnimated(this) && hasFromChanged;
      if (hasToChanged || hasValueChanged) {
        finished = isEqual(computeGoal(value), goal);
        started = !finished;
      }
      if (!isEqual(anim.immediate, immediate) && !immediate || !isEqual(config2.decay, decay) || !isEqual(config2.velocity, velocity)) {
        started = true;
      }
    }
    if (finished && isAnimating(this)) {
      if (anim.changed && !reset) {
        started = true;
      } else if (!started) {
        this._stop(prevTo);
      }
    }
    if (!hasAsyncTo) {
      if (started || hasFluidValue(prevTo)) {
        anim.values = node.getPayload();
        anim.toValues = hasFluidValue(to2) ? null : goalType == AnimatedString ? [1] : toArray(goal);
      }
      if (anim.immediate != immediate) {
        anim.immediate = immediate;
        if (!immediate && !reset) {
          this._set(prevTo);
        }
      }
      if (started) {
        const { onRest } = anim;
        react_spring_shared_modern_each(ACTIVE_EVENTS, (type) => mergeActiveFn(this, props, type));
        const result = getFinishedResult(this, checkFinished(this, prevTo));
        flushCalls(this._pendingCalls, result);
        this._pendingCalls.add(resolve);
        if (anim.changed)
          raf.batchedUpdates(() => {
            anim.changed = !reset;
            onRest?.(result, this);
            if (reset) {
              callProp(defaultProps.onRest, result);
            } else {
              anim.onStart?.(result, this);
            }
          });
      }
    }
    if (reset) {
      this._set(value);
    }
    if (hasAsyncTo) {
      resolve(runAsync(props.to, props, this._state, this));
    } else if (started) {
      this._start();
    } else if (isAnimating(this) && !hasToChanged) {
      this._pendingCalls.add(resolve);
    } else {
      resolve(getNoopResult(value));
    }
  }
  /** Update the `animation.to` value, which might be a `FluidValue` */
  _focus(value) {
    const anim = this.animation;
    if (value !== anim.to) {
      if (getFluidObservers(this)) {
        this._detach();
      }
      anim.to = value;
      if (getFluidObservers(this)) {
        this._attach();
      }
    }
  }
  _attach() {
    let priority = 0;
    const { to: to2 } = this.animation;
    if (hasFluidValue(to2)) {
      addFluidObserver(to2, this);
      if (isFrameValue(to2)) {
        priority = to2.priority + 1;
      }
    }
    this.priority = priority;
  }
  _detach() {
    const { to: to2 } = this.animation;
    if (hasFluidValue(to2)) {
      removeFluidObserver(to2, this);
    }
  }
  /**
   * Update the current value from outside the frameloop,
   * and return the `Animated` node.
   */
  _set(arg, idle = true) {
    const value = getFluidValue(arg);
    if (!is.und(value)) {
      const oldNode = getAnimated(this);
      if (!oldNode || !isEqual(value, oldNode.getValue())) {
        const nodeType = getAnimatedType(value);
        if (!oldNode || oldNode.constructor != nodeType) {
          setAnimated(this, nodeType.create(value));
        } else {
          oldNode.setValue(value);
        }
        if (oldNode) {
          raf.batchedUpdates(() => {
            this._onChange(value, idle);
          });
        }
      }
    }
    return getAnimated(this);
  }
  _onStart() {
    const anim = this.animation;
    if (!anim.changed) {
      anim.changed = true;
      sendEvent(
        this,
        "onStart",
        getFinishedResult(this, checkFinished(this, anim.to)),
        this
      );
    }
  }
  _onChange(value, idle) {
    if (!idle) {
      this._onStart();
      callProp(this.animation.onChange, value, this);
    }
    callProp(this.defaultProps.onChange, value, this);
    super._onChange(value, idle);
  }
  // This method resets the animation state (even if already animating) to
  // ensure the latest from/to range is used, and it also ensures this spring
  // is added to the frameloop.
  _start() {
    const anim = this.animation;
    getAnimated(this).reset(getFluidValue(anim.to));
    if (!anim.immediate) {
      anim.fromValues = anim.values.map((node) => node.lastPosition);
    }
    if (!isAnimating(this)) {
      setActiveBit(this, true);
      if (!isPaused(this)) {
        this._resume();
      }
    }
  }
  _resume() {
    if (globals_exports.skipAnimation) {
      this.finish();
    } else {
      frameLoop.start(this);
    }
  }
  /**
   * Exit the frameloop and notify `onRest` listeners.
   *
   * Always wrap `_stop` calls with `batchedUpdates`.
   */
  _stop(goal, cancel) {
    if (isAnimating(this)) {
      setActiveBit(this, false);
      const anim = this.animation;
      react_spring_shared_modern_each(anim.values, (node) => {
        node.done = true;
      });
      if (anim.toValues) {
        anim.onChange = anim.onPause = anim.onResume = void 0;
      }
      callFluidObservers(this, {
        type: "idle",
        parent: this
      });
      const result = cancel ? getCancelledResult(this.get()) : getFinishedResult(this.get(), checkFinished(this, goal ?? anim.to));
      flushCalls(this._pendingCalls, result);
      if (anim.changed) {
        anim.changed = false;
        sendEvent(this, "onRest", result, this);
      }
    }
  }
};
function checkFinished(target, to2) {
  const goal = computeGoal(to2);
  const value = computeGoal(target.get());
  return isEqual(value, goal);
}
function createLoopUpdate(props, loop = props.loop, to2 = props.to) {
  const loopRet = callProp(loop);
  if (loopRet) {
    const overrides = loopRet !== true && inferTo(loopRet);
    const reverse = (overrides || props).reverse;
    const reset = !overrides || overrides.reset;
    return createUpdate({
      ...props,
      loop,
      // Avoid updating default props when looping.
      default: false,
      // Never loop the `pause` prop.
      pause: void 0,
      // For the "reverse" prop to loop as expected, the "to" prop
      // must be undefined. The "reverse" prop is ignored when the
      // "to" prop is an array or function.
      to: !reverse || isAsyncTo(to2) ? to2 : void 0,
      // Ignore the "from" prop except on reset.
      from: reset ? props.from : void 0,
      reset,
      // The "loop" prop can return a "useSpring" props object to
      // override any of the original props.
      ...overrides
    });
  }
}
function createUpdate(props) {
  const { to: to2, from } = props = inferTo(props);
  const keys = /* @__PURE__ */ new Set();
  if (is.obj(to2))
    findDefined(to2, keys);
  if (is.obj(from))
    findDefined(from, keys);
  props.keys = keys.size ? Array.from(keys) : null;
  return props;
}
function declareUpdate(props) {
  const update2 = createUpdate(props);
  if (is.und(update2.default)) {
    update2.default = getDefaultProps(update2);
  }
  return update2;
}
function findDefined(values, keys) {
  eachProp(values, (value, key) => value != null && keys.add(key));
}
var ACTIVE_EVENTS = [
  "onStart",
  "onRest",
  "onChange",
  "onPause",
  "onResume"
];
function mergeActiveFn(target, props, type) {
  target.animation[type] = props[type] !== getDefaultProp(props, type) ? resolveProp(props[type], target.key) : void 0;
}
function sendEvent(target, type, ...args) {
  target.animation[type]?.(...args);
  target.defaultProps[type]?.(...args);
}

// src/Controller.ts

var BATCHED_EVENTS = ["onStart", "onChange", "onRest"];
var nextId2 = 1;
var Controller = class {
  constructor(props, flush3) {
    this.id = nextId2++;
    /** The animated values */
    this.springs = {};
    /** The queue of props passed to the `update` method. */
    this.queue = [];
    /** The counter for tracking `scheduleProps` calls */
    this._lastAsyncId = 0;
    /** The values currently being animated */
    this._active = /* @__PURE__ */ new Set();
    /** The values that changed recently */
    this._changed = /* @__PURE__ */ new Set();
    /** Equals false when `onStart` listeners can be called */
    this._started = false;
    /** State used by the `runAsync` function */
    this._state = {
      paused: false,
      pauseQueue: /* @__PURE__ */ new Set(),
      resumeQueue: /* @__PURE__ */ new Set(),
      timeouts: /* @__PURE__ */ new Set()
    };
    /** The event queues that are flushed once per frame maximum */
    this._events = {
      onStart: /* @__PURE__ */ new Map(),
      onChange: /* @__PURE__ */ new Map(),
      onRest: /* @__PURE__ */ new Map()
    };
    this._onFrame = this._onFrame.bind(this);
    if (flush3) {
      this._flush = flush3;
    }
    if (props) {
      this.start({ default: true, ...props });
    }
  }
  /**
   * Equals `true` when no spring values are in the frameloop, and
   * no async animation is currently active.
   */
  get idle() {
    return !this._state.asyncTo && Object.values(this.springs).every((spring) => {
      return spring.idle && !spring.isDelayed && !spring.isPaused;
    });
  }
  get item() {
    return this._item;
  }
  set item(item) {
    this._item = item;
  }
  /** Get the current values of our springs */
  get() {
    const values = {};
    this.each((spring, key) => values[key] = spring.get());
    return values;
  }
  /** Set the current values without animating. */
  set(values) {
    for (const key in values) {
      const value = values[key];
      if (!is.und(value)) {
        this.springs[key].set(value);
      }
    }
  }
  /** Push an update onto the queue of each value. */
  update(props) {
    if (props) {
      this.queue.push(createUpdate(props));
    }
    return this;
  }
  /**
   * Start the queued animations for every spring, and resolve the returned
   * promise once all queued animations have finished or been cancelled.
   *
   * When you pass a queue (instead of nothing), that queue is used instead of
   * the queued animations added with the `update` method, which are left alone.
   */
  start(props) {
    let { queue } = this;
    if (props) {
      queue = toArray(props).map(createUpdate);
    } else {
      this.queue = [];
    }
    if (this._flush) {
      return this._flush(this, queue);
    }
    prepareKeys(this, queue);
    return flushUpdateQueue(this, queue);
  }
  /** @internal */
  stop(arg, keys) {
    if (arg !== !!arg) {
      keys = arg;
    }
    if (keys) {
      const springs = this.springs;
      react_spring_shared_modern_each(toArray(keys), (key) => springs[key].stop(!!arg));
    } else {
      stopAsync(this._state, this._lastAsyncId);
      this.each((spring) => spring.stop(!!arg));
    }
    return this;
  }
  /** Freeze the active animation in time */
  pause(keys) {
    if (is.und(keys)) {
      this.start({ pause: true });
    } else {
      const springs = this.springs;
      react_spring_shared_modern_each(toArray(keys), (key) => springs[key].pause());
    }
    return this;
  }
  /** Resume the animation if paused. */
  resume(keys) {
    if (is.und(keys)) {
      this.start({ pause: false });
    } else {
      const springs = this.springs;
      react_spring_shared_modern_each(toArray(keys), (key) => springs[key].resume());
    }
    return this;
  }
  /** Call a function once per spring value */
  each(iterator) {
    eachProp(this.springs, iterator);
  }
  /** @internal Called at the end of every animation frame */
  _onFrame() {
    const { onStart, onChange, onRest } = this._events;
    const active = this._active.size > 0;
    const changed = this._changed.size > 0;
    if (active && !this._started || changed && !this._started) {
      this._started = true;
      flush(onStart, ([onStart2, result]) => {
        result.value = this.get();
        onStart2(result, this, this._item);
      });
    }
    const idle = !active && this._started;
    const values = changed || idle && onRest.size ? this.get() : null;
    if (changed && onChange.size) {
      flush(onChange, ([onChange2, result]) => {
        result.value = values;
        onChange2(result, this, this._item);
      });
    }
    if (idle) {
      this._started = false;
      flush(onRest, ([onRest2, result]) => {
        result.value = values;
        onRest2(result, this, this._item);
      });
    }
  }
  /** @internal */
  eventObserved(event) {
    if (event.type == "change") {
      this._changed.add(event.parent);
      if (!event.idle) {
        this._active.add(event.parent);
      }
    } else if (event.type == "idle") {
      this._active.delete(event.parent);
    } else
      return;
    raf.onFrame(this._onFrame);
  }
};
function flushUpdateQueue(ctrl, queue) {
  return Promise.all(queue.map((props) => flushUpdate(ctrl, props))).then(
    (results) => getCombinedResult(ctrl, results)
  );
}
async function flushUpdate(ctrl, props, isLoop) {
  const { keys, to: to2, from, loop, onRest, onResolve } = props;
  const defaults2 = is.obj(props.default) && props.default;
  if (loop) {
    props.loop = false;
  }
  if (to2 === false)
    props.to = null;
  if (from === false)
    props.from = null;
  const asyncTo = is.arr(to2) || is.fun(to2) ? to2 : void 0;
  if (asyncTo) {
    props.to = void 0;
    props.onRest = void 0;
    if (defaults2) {
      defaults2.onRest = void 0;
    }
  } else {
    react_spring_shared_modern_each(BATCHED_EVENTS, (key) => {
      const handler = props[key];
      if (is.fun(handler)) {
        const queue = ctrl["_events"][key];
        props[key] = ({ finished, cancelled }) => {
          const result2 = queue.get(handler);
          if (result2) {
            if (!finished)
              result2.finished = false;
            if (cancelled)
              result2.cancelled = true;
          } else {
            queue.set(handler, {
              value: null,
              finished: finished || false,
              cancelled: cancelled || false
            });
          }
        };
        if (defaults2) {
          defaults2[key] = props[key];
        }
      }
    });
  }
  const state = ctrl["_state"];
  if (props.pause === !state.paused) {
    state.paused = props.pause;
    flushCalls(props.pause ? state.pauseQueue : state.resumeQueue);
  } else if (state.paused) {
    props.pause = true;
  }
  const promises = (keys || Object.keys(ctrl.springs)).map(
    (key) => ctrl.springs[key].start(props)
  );
  const cancel = props.cancel === true || getDefaultProp(props, "cancel") === true;
  if (asyncTo || cancel && state.asyncId) {
    promises.push(
      scheduleProps(++ctrl["_lastAsyncId"], {
        props,
        state,
        actions: {
          pause: noop,
          resume: noop,
          start(props2, resolve) {
            if (cancel) {
              stopAsync(state, ctrl["_lastAsyncId"]);
              resolve(getCancelledResult(ctrl));
            } else {
              props2.onRest = onRest;
              resolve(
                runAsync(
                  asyncTo,
                  props2,
                  state,
                  ctrl
                )
              );
            }
          }
        }
      })
    );
  }
  if (state.paused) {
    await new Promise((resume) => {
      state.resumeQueue.add(resume);
    });
  }
  const result = getCombinedResult(ctrl, await Promise.all(promises));
  if (loop && result.finished && !(isLoop && result.noop)) {
    const nextProps = createLoopUpdate(props, loop, to2);
    if (nextProps) {
      prepareKeys(ctrl, [nextProps]);
      return flushUpdate(ctrl, nextProps, true);
    }
  }
  if (onResolve) {
    raf.batchedUpdates(() => onResolve(result, ctrl, ctrl.item));
  }
  return result;
}
function getSprings(ctrl, props) {
  const springs = { ...ctrl.springs };
  if (props) {
    react_spring_shared_modern_each(toArray(props), (props2) => {
      if (is.und(props2.keys)) {
        props2 = createUpdate(props2);
      }
      if (!is.obj(props2.to)) {
        props2 = { ...props2, to: void 0 };
      }
      prepareSprings(springs, props2, (key) => {
        return createSpring(key);
      });
    });
  }
  setSprings(ctrl, springs);
  return springs;
}
function setSprings(ctrl, springs) {
  eachProp(springs, (spring, key) => {
    if (!ctrl.springs[key]) {
      ctrl.springs[key] = spring;
      addFluidObserver(spring, ctrl);
    }
  });
}
function createSpring(key, observer) {
  const spring = new SpringValue();
  spring.key = key;
  if (observer) {
    addFluidObserver(spring, observer);
  }
  return spring;
}
function prepareSprings(springs, props, create) {
  if (props.keys) {
    react_spring_shared_modern_each(props.keys, (key) => {
      const spring = springs[key] || (springs[key] = create(key));
      spring["_prepareNode"](props);
    });
  }
}
function prepareKeys(ctrl, queue) {
  react_spring_shared_modern_each(queue, (props) => {
    prepareSprings(ctrl.springs, props, (key) => {
      return createSpring(key, ctrl);
    });
  });
}

// src/SpringContext.tsx



var SpringContext = ({
  children,
  ...props
}) => {
  const inherited = (0,react.useContext)(ctx);
  const pause = props.pause || !!inherited.pause, immediate = props.immediate || !!inherited.immediate;
  props = useMemoOne(() => ({ pause, immediate }), [pause, immediate]);
  const { Provider } = ctx;
  return /* @__PURE__ */ react.createElement(Provider, { value: props }, children);
};
var ctx = makeContext(SpringContext, {});
SpringContext.Provider = ctx.Provider;
SpringContext.Consumer = ctx.Consumer;
function makeContext(target, init) {
  Object.assign(target, react.createContext(init));
  target.Provider._context = target;
  target.Consumer._context = target;
  return target;
}

// src/SpringRef.ts

var SpringRef = () => {
  const current = [];
  const SpringRef2 = function(props) {
    deprecateDirectCall();
    const results = [];
    react_spring_shared_modern_each(current, (ctrl, i) => {
      if (is.und(props)) {
        results.push(ctrl.start());
      } else {
        const update2 = _getProps(props, ctrl, i);
        if (update2) {
          results.push(ctrl.start(update2));
        }
      }
    });
    return results;
  };
  SpringRef2.current = current;
  SpringRef2.add = function(ctrl) {
    if (!current.includes(ctrl)) {
      current.push(ctrl);
    }
  };
  SpringRef2.delete = function(ctrl) {
    const i = current.indexOf(ctrl);
    if (~i)
      current.splice(i, 1);
  };
  SpringRef2.pause = function() {
    react_spring_shared_modern_each(current, (ctrl) => ctrl.pause(...arguments));
    return this;
  };
  SpringRef2.resume = function() {
    react_spring_shared_modern_each(current, (ctrl) => ctrl.resume(...arguments));
    return this;
  };
  SpringRef2.set = function(values) {
    react_spring_shared_modern_each(current, (ctrl, i) => {
      const update2 = is.fun(values) ? values(i, ctrl) : values;
      if (update2) {
        ctrl.set(update2);
      }
    });
  };
  SpringRef2.start = function(props) {
    const results = [];
    react_spring_shared_modern_each(current, (ctrl, i) => {
      if (is.und(props)) {
        results.push(ctrl.start());
      } else {
        const update2 = this._getProps(props, ctrl, i);
        if (update2) {
          results.push(ctrl.start(update2));
        }
      }
    });
    return results;
  };
  SpringRef2.stop = function() {
    react_spring_shared_modern_each(current, (ctrl) => ctrl.stop(...arguments));
    return this;
  };
  SpringRef2.update = function(props) {
    react_spring_shared_modern_each(current, (ctrl, i) => ctrl.update(this._getProps(props, ctrl, i)));
    return this;
  };
  const _getProps = function(arg, ctrl, index) {
    return is.fun(arg) ? arg(index, ctrl) : arg;
  };
  SpringRef2._getProps = _getProps;
  return SpringRef2;
};

// src/hooks/useSprings.ts
function useSprings(length, props, deps) {
  const propsFn = is.fun(props) && props;
  if (propsFn && !deps)
    deps = [];
  const ref = (0,react.useMemo)(
    () => propsFn || arguments.length == 3 ? SpringRef() : void 0,
    []
  );
  const layoutId = (0,react.useRef)(0);
  const forceUpdate = useForceUpdate();
  const state = (0,react.useMemo)(
    () => ({
      ctrls: [],
      queue: [],
      flush(ctrl, updates2) {
        const springs2 = getSprings(ctrl, updates2);
        const canFlushSync = layoutId.current > 0 && !state.queue.length && !Object.keys(springs2).some((key) => !ctrl.springs[key]);
        return canFlushSync ? flushUpdateQueue(ctrl, updates2) : new Promise((resolve) => {
          setSprings(ctrl, springs2);
          state.queue.push(() => {
            resolve(flushUpdateQueue(ctrl, updates2));
          });
          forceUpdate();
        });
      }
    }),
    []
  );
  const ctrls = (0,react.useRef)([...state.ctrls]);
  const updates = [];
  const prevLength = usePrev(length) || 0;
  (0,react.useMemo)(() => {
    react_spring_shared_modern_each(ctrls.current.slice(length, prevLength), (ctrl) => {
      detachRefs(ctrl, ref);
      ctrl.stop(true);
    });
    ctrls.current.length = length;
    declareUpdates(prevLength, length);
  }, [length]);
  (0,react.useMemo)(() => {
    declareUpdates(0, Math.min(prevLength, length));
  }, deps);
  function declareUpdates(startIndex, endIndex) {
    for (let i = startIndex; i < endIndex; i++) {
      const ctrl = ctrls.current[i] || (ctrls.current[i] = new Controller(null, state.flush));
      const update2 = propsFn ? propsFn(i, ctrl) : props[i];
      if (update2) {
        updates[i] = declareUpdate(update2);
      }
    }
  }
  const springs = ctrls.current.map((ctrl, i) => getSprings(ctrl, updates[i]));
  const context = (0,react.useContext)(SpringContext);
  const prevContext = usePrev(context);
  const hasContext = context !== prevContext && hasProps(context);
  react_spring_shared_modern_useIsomorphicLayoutEffect(() => {
    layoutId.current++;
    state.ctrls = ctrls.current;
    const { queue } = state;
    if (queue.length) {
      state.queue = [];
      react_spring_shared_modern_each(queue, (cb) => cb());
    }
    react_spring_shared_modern_each(ctrls.current, (ctrl, i) => {
      ref?.add(ctrl);
      if (hasContext) {
        ctrl.start({ default: context });
      }
      const update2 = updates[i];
      if (update2) {
        replaceRef(ctrl, update2.ref);
        if (ctrl.ref) {
          ctrl.queue.push(update2);
        } else {
          ctrl.start(update2);
        }
      }
    });
  });
  useOnce(() => () => {
    react_spring_shared_modern_each(state.ctrls, (ctrl) => ctrl.stop(true));
  });
  const values = springs.map((x) => ({ ...x }));
  return ref ? [values, ref] : values;
}

// src/hooks/useSpring.ts
function useSpring(props, deps) {
  const isFn = is.fun(props);
  const [[values], ref] = useSprings(
    1,
    isFn ? props : [props],
    isFn ? deps || [] : deps
  );
  return isFn || arguments.length == 2 ? [values, ref] : values;
}

// src/hooks/useSpringRef.ts

var initSpringRef = () => SpringRef();
var useSpringRef = () => useState(initSpringRef)[0];

// src/hooks/useSpringValue.ts

var useSpringValue = (initial, props) => {
  const springValue = useConstant(() => new SpringValue(initial, props));
  useOnce2(() => () => {
    springValue.stop();
  });
  return springValue;
};

// src/hooks/useTrail.ts

function useTrail(length, propsArg, deps) {
  const propsFn = is10.fun(propsArg) && propsArg;
  if (propsFn && !deps)
    deps = [];
  let reverse = true;
  let passedRef = void 0;
  const result = useSprings(
    length,
    (i, ctrl) => {
      const props = propsFn ? propsFn(i, ctrl) : propsArg;
      passedRef = props.ref;
      reverse = reverse && props.reverse;
      return props;
    },
    // Ensure the props function is called when no deps exist.
    // This works around the 3 argument rule.
    deps || [{}]
  );
  useIsomorphicLayoutEffect3(() => {
    each6(result[1].current, (ctrl, i) => {
      const parent = result[1].current[i + (reverse ? 1 : -1)];
      replaceRef(ctrl, passedRef);
      if (ctrl.ref) {
        if (parent) {
          ctrl.update({ to: parent.springs });
        }
        return;
      }
      if (parent) {
        ctrl.start({ to: parent.springs });
      } else {
        ctrl.start();
      }
    });
  }, deps);
  if (propsFn || arguments.length == 3) {
    const ref = passedRef ?? result[1];
    ref["_getProps"] = (propsArg2, ctrl, i) => {
      const props = is10.fun(propsArg2) ? propsArg2(i, ctrl) : propsArg2;
      if (props) {
        const parent = ref.current[i + (props.reverse ? 1 : -1)];
        if (parent)
          props.to = parent.springs;
        return props;
      }
    };
    return result;
  }
  return result[0];
}

// src/hooks/useTransition.tsx



function useTransition(data, props, deps) {
  const propsFn = is11.fun(props) && props;
  const {
    reset,
    sort,
    trail = 0,
    expires = true,
    exitBeforeEnter = false,
    onDestroyed,
    ref: propsRef,
    config: propsConfig
  } = propsFn ? propsFn() : props;
  const ref = useMemo2(
    () => propsFn || arguments.length == 3 ? SpringRef() : void 0,
    []
  );
  const items = toArray4(data);
  const transitions = [];
  const usedTransitions = useRef2(null);
  const prevTransitions = reset ? null : usedTransitions.current;
  useIsomorphicLayoutEffect4(() => {
    usedTransitions.current = transitions;
  });
  useOnce3(() => {
    each7(transitions, (t) => {
      ref?.add(t.ctrl);
      t.ctrl.ref = ref;
    });
    return () => {
      each7(usedTransitions.current, (t) => {
        if (t.expired) {
          clearTimeout(t.expirationId);
        }
        detachRefs(t.ctrl, ref);
        t.ctrl.stop(true);
      });
    };
  });
  const keys = getKeys(items, propsFn ? propsFn() : props, prevTransitions);
  const expired = reset && usedTransitions.current || [];
  useIsomorphicLayoutEffect4(
    () => each7(expired, ({ ctrl, item, key }) => {
      detachRefs(ctrl, ref);
      callProp(onDestroyed, item, key);
    })
  );
  const reused = [];
  if (prevTransitions)
    each7(prevTransitions, (t, i) => {
      if (t.expired) {
        clearTimeout(t.expirationId);
        expired.push(t);
      } else {
        i = reused[i] = keys.indexOf(t.key);
        if (~i)
          transitions[i] = t;
      }
    });
  each7(items, (item, i) => {
    if (!transitions[i]) {
      transitions[i] = {
        key: keys[i],
        item,
        phase: "mount" /* MOUNT */,
        ctrl: new Controller()
      };
      transitions[i].ctrl.item = item;
    }
  });
  if (reused.length) {
    let i = -1;
    const { leave } = propsFn ? propsFn() : props;
    each7(reused, (keyIndex, prevIndex) => {
      const t = prevTransitions[prevIndex];
      if (~keyIndex) {
        i = transitions.indexOf(t);
        transitions[i] = { ...t, item: items[keyIndex] };
      } else if (leave) {
        transitions.splice(++i, 0, t);
      }
    });
  }
  if (is11.fun(sort)) {
    transitions.sort((a, b) => sort(a.item, b.item));
  }
  let delay = -trail;
  const forceUpdate = useForceUpdate2();
  const defaultProps = getDefaultProps(props);
  const changes = /* @__PURE__ */ new Map();
  const exitingTransitions = useRef2(/* @__PURE__ */ new Map());
  const forceChange = useRef2(false);
  each7(transitions, (t, i) => {
    const key = t.key;
    const prevPhase = t.phase;
    const p = propsFn ? propsFn() : props;
    let to2;
    let phase;
    const propsDelay = callProp(p.delay || 0, key);
    if (prevPhase == "mount" /* MOUNT */) {
      to2 = p.enter;
      phase = "enter" /* ENTER */;
    } else {
      const isLeave = keys.indexOf(key) < 0;
      if (prevPhase != "leave" /* LEAVE */) {
        if (isLeave) {
          to2 = p.leave;
          phase = "leave" /* LEAVE */;
        } else if (to2 = p.update) {
          phase = "update" /* UPDATE */;
        } else
          return;
      } else if (!isLeave) {
        to2 = p.enter;
        phase = "enter" /* ENTER */;
      } else
        return;
    }
    to2 = callProp(to2, t.item, i);
    to2 = is11.obj(to2) ? inferTo(to2) : { to: to2 };
    if (!to2.config) {
      const config2 = propsConfig || defaultProps.config;
      to2.config = callProp(config2, t.item, i, phase);
    }
    delay += trail;
    const payload = {
      ...defaultProps,
      // we need to add our props.delay value you here.
      delay: propsDelay + delay,
      ref: propsRef,
      immediate: p.immediate,
      // This prevents implied resets.
      reset: false,
      // Merge any phase-specific props.
      ...to2
    };
    if (phase == "enter" /* ENTER */ && is11.und(payload.from)) {
      const p2 = propsFn ? propsFn() : props;
      const from = is11.und(p2.initial) || prevTransitions ? p2.from : p2.initial;
      payload.from = callProp(from, t.item, i);
    }
    const { onResolve } = payload;
    payload.onResolve = (result) => {
      callProp(onResolve, result);
      const transitions2 = usedTransitions.current;
      const t2 = transitions2.find((t3) => t3.key === key);
      if (!t2)
        return;
      if (result.cancelled && t2.phase != "update" /* UPDATE */) {
        return;
      }
      if (t2.ctrl.idle) {
        const idle = transitions2.every((t3) => t3.ctrl.idle);
        if (t2.phase == "leave" /* LEAVE */) {
          const expiry = callProp(expires, t2.item);
          if (expiry !== false) {
            const expiryMs = expiry === true ? 0 : expiry;
            t2.expired = true;
            if (!idle && expiryMs > 0) {
              if (expiryMs <= 2147483647)
                t2.expirationId = setTimeout(forceUpdate, expiryMs);
              return;
            }
          }
        }
        if (idle && transitions2.some((t3) => t3.expired)) {
          exitingTransitions.current.delete(t2);
          if (exitBeforeEnter) {
            forceChange.current = true;
          }
          forceUpdate();
        }
      }
    };
    const springs = getSprings(t.ctrl, payload);
    if (phase === "leave" /* LEAVE */ && exitBeforeEnter) {
      exitingTransitions.current.set(t, { phase, springs, payload });
    } else {
      changes.set(t, { phase, springs, payload });
    }
  });
  const context = useContext3(SpringContext);
  const prevContext = usePrev2(context);
  const hasContext = context !== prevContext && hasProps(context);
  useIsomorphicLayoutEffect4(() => {
    if (hasContext) {
      each7(transitions, (t) => {
        t.ctrl.start({ default: context });
      });
    }
  }, [context]);
  each7(changes, (_, t) => {
    if (exitingTransitions.current.size) {
      const ind = transitions.findIndex((state) => state.key === t.key);
      transitions.splice(ind, 1);
    }
  });
  useIsomorphicLayoutEffect4(
    () => {
      each7(
        exitingTransitions.current.size ? exitingTransitions.current : changes,
        ({ phase, payload }, t) => {
          const { ctrl } = t;
          t.phase = phase;
          ref?.add(ctrl);
          if (hasContext && phase == "enter" /* ENTER */) {
            ctrl.start({ default: context });
          }
          if (payload) {
            replaceRef(ctrl, payload.ref);
            if ((ctrl.ref || ref) && !forceChange.current) {
              ctrl.update(payload);
            } else {
              ctrl.start(payload);
              if (forceChange.current) {
                forceChange.current = false;
              }
            }
          }
        }
      );
    },
    reset ? void 0 : deps
  );
  const renderTransitions = (render) => /* @__PURE__ */ React2.createElement(React2.Fragment, null, transitions.map((t, i) => {
    const { springs } = changes.get(t) || t.ctrl;
    const elem = render({ ...springs }, t.item, t, i);
    return elem && elem.type ? /* @__PURE__ */ React2.createElement(
      elem.type,
      {
        ...elem.props,
        key: is11.str(t.key) || is11.num(t.key) ? t.key : t.ctrl.id,
        ref: elem.ref
      }
    ) : elem;
  }));
  return ref ? [renderTransitions, ref] : renderTransitions;
}
var nextKey = 1;
function getKeys(items, { key, keys = key }, prevTransitions) {
  if (keys === null) {
    const reused = /* @__PURE__ */ new Set();
    return items.map((item) => {
      const t = prevTransitions && prevTransitions.find(
        (t2) => t2.item === item && t2.phase !== "leave" /* LEAVE */ && !reused.has(t2)
      );
      if (t) {
        reused.add(t);
        return t.key;
      }
      return nextKey++;
    });
  }
  return is11.und(keys) ? items : is11.fun(keys) ? items.map(keys) : toArray4(keys);
}

// src/hooks/useScroll.ts

var useScroll = ({
  container,
  ...springOptions
} = {}) => {
  const [scrollValues, api] = useSpring(
    () => ({
      scrollX: 0,
      scrollY: 0,
      scrollXProgress: 0,
      scrollYProgress: 0,
      ...springOptions
    }),
    []
  );
  useIsomorphicLayoutEffect5(() => {
    const cleanupScroll = onScroll(
      ({ x, y }) => {
        api.start({
          scrollX: x.current,
          scrollXProgress: x.progress,
          scrollY: y.current,
          scrollYProgress: y.progress
        });
      },
      { container: container?.current || void 0 }
    );
    return () => {
      each8(Object.values(scrollValues), (value) => value.stop());
      cleanupScroll();
    };
  }, []);
  return scrollValues;
};

// src/hooks/useResize.ts

var useResize = ({
  container,
  ...springOptions
}) => {
  const [sizeValues, api] = useSpring(
    () => ({
      width: 0,
      height: 0,
      ...springOptions
    }),
    []
  );
  useIsomorphicLayoutEffect6(() => {
    const cleanupScroll = onResize(
      ({ width, height }) => {
        api.start({
          width,
          height,
          immediate: sizeValues.width.get() === 0 || sizeValues.height.get() === 0
        });
      },
      { container: container?.current || void 0 }
    );
    return () => {
      each9(Object.values(sizeValues), (value) => value.stop());
      cleanupScroll();
    };
  }, []);
  return sizeValues;
};

// src/hooks/useInView.ts


var defaultThresholdOptions = {
  any: 0,
  all: 1
};
function useInView(props, args) {
  const [isInView, setIsInView] = useState2(false);
  const ref = useRef3();
  const propsFn = is12.fun(props) && props;
  const springsProps = propsFn ? propsFn() : {};
  const { to: to2 = {}, from = {}, ...restSpringProps } = springsProps;
  const intersectionArguments = propsFn ? args : props;
  const [springs, api] = useSpring(() => ({ from, ...restSpringProps }), []);
  useIsomorphicLayoutEffect7(() => {
    const element = ref.current;
    const {
      root,
      once,
      amount = "any",
      ...restArgs
    } = intersectionArguments ?? {};
    if (!element || once && isInView || typeof IntersectionObserver === "undefined")
      return;
    const activeIntersections = /* @__PURE__ */ new WeakMap();
    const onEnter = () => {
      if (to2) {
        api.start(to2);
      }
      setIsInView(true);
      const cleanup = () => {
        if (from) {
          api.start(from);
        }
        setIsInView(false);
      };
      return once ? void 0 : cleanup;
    };
    const handleIntersection = (entries) => {
      entries.forEach((entry) => {
        const onLeave = activeIntersections.get(entry.target);
        if (entry.isIntersecting === Boolean(onLeave)) {
          return;
        }
        if (entry.isIntersecting) {
          const newOnLeave = onEnter();
          if (is12.fun(newOnLeave)) {
            activeIntersections.set(entry.target, newOnLeave);
          } else {
            observer.unobserve(entry.target);
          }
        } else if (onLeave) {
          onLeave();
          activeIntersections.delete(entry.target);
        }
      });
    };
    const observer = new IntersectionObserver(handleIntersection, {
      root: root && root.current || void 0,
      threshold: typeof amount === "number" || Array.isArray(amount) ? amount : defaultThresholdOptions[amount],
      ...restArgs
    });
    observer.observe(element);
    return () => observer.unobserve(element);
  }, [intersectionArguments]);
  if (propsFn) {
    return [ref, springs];
  }
  return [ref, isInView];
}

// src/components/Spring.tsx
function Spring({ children, ...props }) {
  return children(useSpring(props));
}

// src/components/Trail.tsx

function Trail({
  items,
  children,
  ...props
}) {
  const trails = useTrail(items.length, props);
  return items.map((item, index) => {
    const result = children(item, index);
    return is13.fun(result) ? result(trails[index]) : result;
  });
}

// src/components/Transition.tsx
function Transition({
  items,
  children,
  ...props
}) {
  return useTransition(items, props)(children);
}

// src/interpolate.ts


// src/Interpolation.ts


var Interpolation = class extends FrameValue {
  constructor(source, args) {
    super();
    this.source = source;
    /** Equals false when in the frameloop */
    this.idle = true;
    /** The inputs which are currently animating */
    this._active = /* @__PURE__ */ new Set();
    this.calc = createInterpolator(...args);
    const value = this._get();
    const nodeType = getAnimatedType(value);
    setAnimated(this, nodeType.create(value));
  }
  advance(_dt) {
    const value = this._get();
    const oldValue = this.get();
    if (!isEqual(value, oldValue)) {
      getAnimated(this).setValue(value);
      this._onChange(value, this.idle);
    }
    if (!this.idle && checkIdle(this._active)) {
      becomeIdle(this);
    }
  }
  _get() {
    const inputs = is.arr(this.source) ? this.source.map(getFluidValue) : toArray(getFluidValue(this.source));
    return this.calc(...inputs);
  }
  _start() {
    if (this.idle && !checkIdle(this._active)) {
      this.idle = false;
      react_spring_shared_modern_each(getPayload(this), (node) => {
        node.done = false;
      });
      if (globals_exports.skipAnimation) {
        raf.batchedUpdates(() => this.advance());
        becomeIdle(this);
      } else {
        frameLoop.start(this);
      }
    }
  }
  // Observe our sources only when we're observed.
  _attach() {
    let priority = 1;
    react_spring_shared_modern_each(toArray(this.source), (source) => {
      if (hasFluidValue(source)) {
        addFluidObserver(source, this);
      }
      if (isFrameValue(source)) {
        if (!source.idle) {
          this._active.add(source);
        }
        priority = Math.max(priority, source.priority + 1);
      }
    });
    this.priority = priority;
    this._start();
  }
  // Stop observing our sources once we have no observers.
  _detach() {
    react_spring_shared_modern_each(toArray(this.source), (source) => {
      if (hasFluidValue(source)) {
        removeFluidObserver(source, this);
      }
    });
    this._active.clear();
    becomeIdle(this);
  }
  /** @internal */
  eventObserved(event) {
    if (event.type == "change") {
      if (event.idle) {
        this.advance();
      } else {
        this._active.add(event.parent);
        this._start();
      }
    } else if (event.type == "idle") {
      this._active.delete(event.parent);
    } else if (event.type == "priority") {
      this.priority = toArray(this.source).reduce(
        (highest, parent) => Math.max(highest, (isFrameValue(parent) ? parent.priority : 0) + 1),
        0
      );
    }
  }
};
function isIdle(source) {
  return source.idle !== false;
}
function checkIdle(active) {
  return !active.size || Array.from(active).every(isIdle);
}
function becomeIdle(self) {
  if (!self.idle) {
    self.idle = true;
    react_spring_shared_modern_each(getPayload(self), (node) => {
      node.done = true;
    });
    callFluidObservers(self, {
      type: "idle",
      parent: self
    });
  }
}

// src/interpolate.ts
var react_spring_core_modern_to = (source, ...args) => new Interpolation(source, args);
var react_spring_core_modern_interpolate = (source, ...args) => (deprecateInterpolate2(), new Interpolation(source, args));

// src/globals.ts

globals_exports.assign({
  createStringInterpolator: createStringInterpolator2,
  to: (source, args) => new Interpolation(source, args)
});
var react_spring_core_modern_update = frameLoop.advance;

// src/index.ts



//# sourceMappingURL=react-spring_core.modern.mjs.map
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/react-dom/index.js
var react_dom = __webpack_require__(18369);
;// CONCATENATED MODULE: ./node_modules/@react-spring/web/dist/react-spring_web.modern.mjs
// src/index.ts





// src/applyAnimatedValues.ts
var isCustomPropRE = /^--/;
function dangerousStyleValue(name, value) {
  if (value == null || typeof value === "boolean" || value === "")
    return "";
  if (typeof value === "number" && value !== 0 && !isCustomPropRE.test(name) && !(isUnitlessNumber.hasOwnProperty(name) && isUnitlessNumber[name]))
    return value + "px";
  return ("" + value).trim();
}
var attributeCache = {};
function applyAnimatedValues(instance, props) {
  if (!instance.nodeType || !instance.setAttribute) {
    return false;
  }
  const isFilterElement = instance.nodeName === "filter" || instance.parentNode && instance.parentNode.nodeName === "filter";
  const { style, children, scrollTop, scrollLeft, viewBox, ...attributes } = props;
  const values = Object.values(attributes);
  const names = Object.keys(attributes).map(
    (name) => isFilterElement || instance.hasAttribute(name) ? name : attributeCache[name] || (attributeCache[name] = name.replace(
      /([A-Z])/g,
      // Attributes are written in dash case
      (n) => "-" + n.toLowerCase()
    ))
  );
  if (children !== void 0) {
    instance.textContent = children;
  }
  for (const name in style) {
    if (style.hasOwnProperty(name)) {
      const value = dangerousStyleValue(name, style[name]);
      if (isCustomPropRE.test(name)) {
        instance.style.setProperty(name, value);
      } else {
        instance.style[name] = value;
      }
    }
  }
  names.forEach((name, i) => {
    instance.setAttribute(name, values[i]);
  });
  if (scrollTop !== void 0) {
    instance.scrollTop = scrollTop;
  }
  if (scrollLeft !== void 0) {
    instance.scrollLeft = scrollLeft;
  }
  if (viewBox !== void 0) {
    instance.setAttribute("viewBox", viewBox);
  }
}
var isUnitlessNumber = {
  animationIterationCount: true,
  borderImageOutset: true,
  borderImageSlice: true,
  borderImageWidth: true,
  boxFlex: true,
  boxFlexGroup: true,
  boxOrdinalGroup: true,
  columnCount: true,
  columns: true,
  flex: true,
  flexGrow: true,
  flexPositive: true,
  flexShrink: true,
  flexNegative: true,
  flexOrder: true,
  gridRow: true,
  gridRowEnd: true,
  gridRowSpan: true,
  gridRowStart: true,
  gridColumn: true,
  gridColumnEnd: true,
  gridColumnSpan: true,
  gridColumnStart: true,
  fontWeight: true,
  lineClamp: true,
  lineHeight: true,
  opacity: true,
  order: true,
  orphans: true,
  tabSize: true,
  widows: true,
  zIndex: true,
  zoom: true,
  // SVG-related properties
  fillOpacity: true,
  floodOpacity: true,
  stopOpacity: true,
  strokeDasharray: true,
  strokeDashoffset: true,
  strokeMiterlimit: true,
  strokeOpacity: true,
  strokeWidth: true
};
var prefixKey = (prefix, key) => prefix + key.charAt(0).toUpperCase() + key.substring(1);
var prefixes = ["Webkit", "Ms", "Moz", "O"];
isUnitlessNumber = Object.keys(isUnitlessNumber).reduce((acc, prop) => {
  prefixes.forEach((prefix) => acc[prefixKey(prefix, prop)] = acc[prop]);
  return acc;
}, isUnitlessNumber);

// src/AnimatedStyle.ts


var domTransforms = /^(matrix|translate|scale|rotate|skew)/;
var pxTransforms = /^(translate)/;
var degTransforms = /^(rotate|skew)/;
var addUnit = (value, unit) => is.num(value) && value !== 0 ? value + unit : value;
var isValueIdentity = (value, id) => is.arr(value) ? value.every((v) => isValueIdentity(v, id)) : is.num(value) ? value === id : parseFloat(value) === id;
var AnimatedStyle = class extends AnimatedObject {
  constructor({ x, y, z, ...style }) {
    const inputs = [];
    const transforms = [];
    if (x || y || z) {
      inputs.push([x || 0, y || 0, z || 0]);
      transforms.push((xyz) => [
        `translate3d(${xyz.map((v) => addUnit(v, "px")).join(",")})`,
        // prettier-ignore
        isValueIdentity(xyz, 0)
      ]);
    }
    eachProp(style, (value, key) => {
      if (key === "transform") {
        inputs.push([value || ""]);
        transforms.push((transform) => [transform, transform === ""]);
      } else if (domTransforms.test(key)) {
        delete style[key];
        if (is.und(value))
          return;
        const unit = pxTransforms.test(key) ? "px" : degTransforms.test(key) ? "deg" : "";
        inputs.push(toArray(value));
        transforms.push(
          key === "rotate3d" ? ([x2, y2, z2, deg]) => [
            `rotate3d(${x2},${y2},${z2},${addUnit(deg, unit)})`,
            isValueIdentity(deg, 0)
          ] : (input) => [
            `${key}(${input.map((v) => addUnit(v, unit)).join(",")})`,
            isValueIdentity(input, key.startsWith("scale") ? 1 : 0)
          ]
        );
      }
    });
    if (inputs.length) {
      style.transform = new FluidTransform(inputs, transforms);
    }
    super(style);
  }
};
var FluidTransform = class extends FluidValue {
  constructor(inputs, transforms) {
    super();
    this.inputs = inputs;
    this.transforms = transforms;
    this._value = null;
  }
  get() {
    return this._value || (this._value = this._get());
  }
  _get() {
    let transform = "";
    let identity = true;
    react_spring_shared_modern_each(this.inputs, (input, i) => {
      const arg1 = getFluidValue(input[0]);
      const [t, id] = this.transforms[i](
        is.arr(arg1) ? arg1 : input.map(getFluidValue)
      );
      transform += " " + t;
      identity = identity && id;
    });
    return identity ? "none" : transform;
  }
  // Start observing our inputs once we have an observer.
  observerAdded(count) {
    if (count == 1)
      react_spring_shared_modern_each(
        this.inputs,
        (input) => react_spring_shared_modern_each(
          input,
          (value) => hasFluidValue(value) && addFluidObserver(value, this)
        )
      );
  }
  // Stop observing our inputs once we have no observers.
  observerRemoved(count) {
    if (count == 0)
      react_spring_shared_modern_each(
        this.inputs,
        (input) => react_spring_shared_modern_each(
          input,
          (value) => hasFluidValue(value) && removeFluidObserver(value, this)
        )
      );
  }
  eventObserved(event) {
    if (event.type == "change") {
      this._value = null;
    }
    callFluidObservers(this, event);
  }
};

// src/primitives.ts
var primitives = [
  "a",
  "abbr",
  "address",
  "area",
  "article",
  "aside",
  "audio",
  "b",
  "base",
  "bdi",
  "bdo",
  "big",
  "blockquote",
  "body",
  "br",
  "button",
  "canvas",
  "caption",
  "cite",
  "code",
  "col",
  "colgroup",
  "data",
  "datalist",
  "dd",
  "del",
  "details",
  "dfn",
  "dialog",
  "div",
  "dl",
  "dt",
  "em",
  "embed",
  "fieldset",
  "figcaption",
  "figure",
  "footer",
  "form",
  "h1",
  "h2",
  "h3",
  "h4",
  "h5",
  "h6",
  "head",
  "header",
  "hgroup",
  "hr",
  "html",
  "i",
  "iframe",
  "img",
  "input",
  "ins",
  "kbd",
  "keygen",
  "label",
  "legend",
  "li",
  "link",
  "main",
  "map",
  "mark",
  "menu",
  "menuitem",
  "meta",
  "meter",
  "nav",
  "noscript",
  "object",
  "ol",
  "optgroup",
  "option",
  "output",
  "p",
  "param",
  "picture",
  "pre",
  "progress",
  "q",
  "rp",
  "rt",
  "ruby",
  "s",
  "samp",
  "script",
  "section",
  "select",
  "small",
  "source",
  "span",
  "strong",
  "style",
  "sub",
  "summary",
  "sup",
  "table",
  "tbody",
  "td",
  "textarea",
  "tfoot",
  "th",
  "thead",
  "time",
  "title",
  "tr",
  "track",
  "u",
  "ul",
  "var",
  "video",
  "wbr",
  // SVG
  "circle",
  "clipPath",
  "defs",
  "ellipse",
  "foreignObject",
  "g",
  "image",
  "line",
  "linearGradient",
  "mask",
  "path",
  "pattern",
  "polygon",
  "polyline",
  "radialGradient",
  "rect",
  "stop",
  "svg",
  "text",
  "tspan"
];

// src/index.ts

globals_exports.assign({
  batchedUpdates: react_dom.unstable_batchedUpdates,
  createStringInterpolator: createStringInterpolator2,
  colors: colors2
});
var host = createHost(primitives, {
  applyAnimatedValues,
  createAnimatedStyle: (style) => new AnimatedStyle(style),
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  getComponentProps: ({ scrollTop, scrollLeft, ...props }) => props
});
var animated = host.animated;

//# sourceMappingURL=react-spring_web.modern.mjs.map

/***/ }),

/***/ 66474:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "j": function() { return /* binding */ focusManager; }
/* harmony export */ });
/* unused harmony export FocusManager */
/* harmony import */ var _subscribable_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7506);
/* harmony import */ var _utils_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(24139);
// src/focusManager.ts


var FocusManager = class extends _subscribable_js__WEBPACK_IMPORTED_MODULE_0__/* .Subscribable */ .l {
  #focused;
  #cleanup;
  #setup;
  constructor() {
    super();
    this.#setup = (onFocus) => {
      if (!_utils_js__WEBPACK_IMPORTED_MODULE_1__/* .isServer */ .sk && window.addEventListener) {
        const listener = () => onFocus();
        window.addEventListener("visibilitychange", listener, false);
        return () => {
          window.removeEventListener("visibilitychange", listener);
        };
      }
      return;
    };
  }
  onSubscribe() {
    if (!this.#cleanup) {
      this.setEventListener(this.#setup);
    }
  }
  onUnsubscribe() {
    if (!this.hasListeners()) {
      this.#cleanup?.();
      this.#cleanup = void 0;
    }
  }
  setEventListener(setup) {
    this.#setup = setup;
    this.#cleanup?.();
    this.#cleanup = setup((focused) => {
      if (typeof focused === "boolean") {
        this.setFocused(focused);
      } else {
        this.onFocus();
      }
    });
  }
  setFocused(focused) {
    const changed = this.#focused !== focused;
    if (changed) {
      this.#focused = focused;
      this.onFocus();
    }
  }
  onFocus() {
    this.listeners.forEach((listener) => {
      listener();
    });
  }
  isFocused() {
    if (typeof this.#focused === "boolean") {
      return this.#focused;
    }
    return globalThis.document?.visibilityState !== "hidden";
  }
};
var focusManager = new FocusManager();

//# sourceMappingURL=focusManager.js.map

/***/ }),

/***/ 54948:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Gm": function() { return /* binding */ infiniteQueryBehavior; },
/* harmony export */   "Qy": function() { return /* binding */ hasNextPage; },
/* harmony export */   "ZF": function() { return /* binding */ hasPreviousPage; }
/* harmony export */ });
/* harmony import */ var _utils_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(24139);
// src/infiniteQueryBehavior.ts

function infiniteQueryBehavior(pages) {
  return {
    onFetch: (context, query) => {
      const fetchFn = async () => {
        const options = context.options;
        const direction = context.fetchOptions?.meta?.fetchMore?.direction;
        const oldPages = context.state.data?.pages || [];
        const oldPageParams = context.state.data?.pageParams || [];
        const empty = { pages: [], pageParams: [] };
        let cancelled = false;
        const addSignalProperty = (object) => {
          Object.defineProperty(object, "signal", {
            enumerable: true,
            get: () => {
              if (context.signal.aborted) {
                cancelled = true;
              } else {
                context.signal.addEventListener("abort", () => {
                  cancelled = true;
                });
              }
              return context.signal;
            }
          });
        };
        const queryFn = context.options.queryFn || (() => Promise.reject(
          new Error(`Missing queryFn: '${context.options.queryHash}'`)
        ));
        const fetchPage = async (data, param, previous) => {
          if (cancelled) {
            return Promise.reject();
          }
          if (param == null && data.pages.length) {
            return Promise.resolve(data);
          }
          const queryFnContext = {
            queryKey: context.queryKey,
            pageParam: param,
            direction: previous ? "backward" : "forward",
            meta: context.options.meta
          };
          addSignalProperty(queryFnContext);
          const page = await queryFn(
            queryFnContext
          );
          const { maxPages } = context.options;
          const addTo = previous ? _utils_js__WEBPACK_IMPORTED_MODULE_0__/* .addToStart */ .Ht : _utils_js__WEBPACK_IMPORTED_MODULE_0__/* .addToEnd */ .VX;
          return {
            pages: addTo(data.pages, page, maxPages),
            pageParams: addTo(data.pageParams, param, maxPages)
          };
        };
        let result;
        if (direction && oldPages.length) {
          const previous = direction === "backward";
          const pageParamFn = previous ? getPreviousPageParam : getNextPageParam;
          const oldData = {
            pages: oldPages,
            pageParams: oldPageParams
          };
          const param = pageParamFn(options, oldData);
          result = await fetchPage(oldData, param, previous);
        } else {
          result = await fetchPage(
            empty,
            oldPageParams[0] ?? options.initialPageParam
          );
          const remainingPages = pages ?? oldPages.length;
          for (let i = 1; i < remainingPages; i++) {
            const param = getNextPageParam(options, result);
            result = await fetchPage(result, param);
          }
        }
        return result;
      };
      if (context.options.persister) {
        context.fetchFn = () => {
          return context.options.persister?.(
            fetchFn,
            {
              queryKey: context.queryKey,
              meta: context.options.meta,
              signal: context.signal
            },
            query
          );
        };
      } else {
        context.fetchFn = fetchFn;
      }
    }
  };
}
function getNextPageParam(options, { pages, pageParams }) {
  const lastIndex = pages.length - 1;
  return options.getNextPageParam(
    pages[lastIndex],
    pages,
    pageParams[lastIndex],
    pageParams
  );
}
function getPreviousPageParam(options, { pages, pageParams }) {
  return options.getPreviousPageParam?.(
    pages[0],
    pages,
    pageParams[0],
    pageParams
  );
}
function hasNextPage(options, data) {
  if (!data)
    return false;
  return getNextPageParam(options, data) != null;
}
function hasPreviousPage(options, data) {
  if (!data || !options.getPreviousPageParam)
    return false;
  return getPreviousPageParam(options, data) != null;
}

//# sourceMappingURL=infiniteQueryBehavior.js.map

/***/ }),

/***/ 59289:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "R": function() { return /* binding */ getDefaultState; },
/* harmony export */   "m": function() { return /* binding */ Mutation; }
/* harmony export */ });
/* harmony import */ var _notifyManager_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(27037);
/* harmony import */ var _removable_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(48907);
/* harmony import */ var _retryer_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(72008);
// src/mutation.ts



var Mutation = class extends _removable_js__WEBPACK_IMPORTED_MODULE_0__/* .Removable */ .F {
  constructor(config) {
    super();
    this.mutationId = config.mutationId;
    this.#defaultOptions = config.defaultOptions;
    this.#mutationCache = config.mutationCache;
    this.#observers = [];
    this.state = config.state || getDefaultState();
    this.setOptions(config.options);
    this.scheduleGc();
  }
  #observers;
  #defaultOptions;
  #mutationCache;
  #retryer;
  setOptions(options) {
    this.options = { ...this.#defaultOptions, ...options };
    this.updateGcTime(this.options.gcTime);
  }
  get meta() {
    return this.options.meta;
  }
  addObserver(observer) {
    if (!this.#observers.includes(observer)) {
      this.#observers.push(observer);
      this.clearGcTimeout();
      this.#mutationCache.notify({
        type: "observerAdded",
        mutation: this,
        observer
      });
    }
  }
  removeObserver(observer) {
    this.#observers = this.#observers.filter((x) => x !== observer);
    this.scheduleGc();
    this.#mutationCache.notify({
      type: "observerRemoved",
      mutation: this,
      observer
    });
  }
  optionalRemove() {
    if (!this.#observers.length) {
      if (this.state.status === "pending") {
        this.scheduleGc();
      } else {
        this.#mutationCache.remove(this);
      }
    }
  }
  continue() {
    return this.#retryer?.continue() ?? // continuing a mutation assumes that variables are set, mutation must have been dehydrated before
    this.execute(this.state.variables);
  }
  async execute(variables) {
    const executeMutation = () => {
      this.#retryer = (0,_retryer_js__WEBPACK_IMPORTED_MODULE_1__/* .createRetryer */ .Mz)({
        fn: () => {
          if (!this.options.mutationFn) {
            return Promise.reject(new Error("No mutationFn found"));
          }
          return this.options.mutationFn(variables);
        },
        onFail: (failureCount, error) => {
          this.#dispatch({ type: "failed", failureCount, error });
        },
        onPause: () => {
          this.#dispatch({ type: "pause" });
        },
        onContinue: () => {
          this.#dispatch({ type: "continue" });
        },
        retry: this.options.retry ?? 0,
        retryDelay: this.options.retryDelay,
        networkMode: this.options.networkMode
      });
      return this.#retryer.promise;
    };
    const restored = this.state.status === "pending";
    try {
      if (!restored) {
        this.#dispatch({ type: "pending", variables });
        await this.#mutationCache.config.onMutate?.(
          variables,
          this
        );
        const context = await this.options.onMutate?.(variables);
        if (context !== this.state.context) {
          this.#dispatch({
            type: "pending",
            context,
            variables
          });
        }
      }
      const data = await executeMutation();
      await this.#mutationCache.config.onSuccess?.(
        data,
        variables,
        this.state.context,
        this
      );
      await this.options.onSuccess?.(data, variables, this.state.context);
      await this.#mutationCache.config.onSettled?.(
        data,
        null,
        this.state.variables,
        this.state.context,
        this
      );
      await this.options.onSettled?.(data, null, variables, this.state.context);
      this.#dispatch({ type: "success", data });
      return data;
    } catch (error) {
      try {
        await this.#mutationCache.config.onError?.(
          error,
          variables,
          this.state.context,
          this
        );
        await this.options.onError?.(
          error,
          variables,
          this.state.context
        );
        await this.#mutationCache.config.onSettled?.(
          void 0,
          error,
          this.state.variables,
          this.state.context,
          this
        );
        await this.options.onSettled?.(
          void 0,
          error,
          variables,
          this.state.context
        );
        throw error;
      } finally {
        this.#dispatch({ type: "error", error });
      }
    }
  }
  #dispatch(action) {
    const reducer = (state) => {
      switch (action.type) {
        case "failed":
          return {
            ...state,
            failureCount: action.failureCount,
            failureReason: action.error
          };
        case "pause":
          return {
            ...state,
            isPaused: true
          };
        case "continue":
          return {
            ...state,
            isPaused: false
          };
        case "pending":
          return {
            ...state,
            context: action.context,
            data: void 0,
            failureCount: 0,
            failureReason: null,
            error: null,
            isPaused: !(0,_retryer_js__WEBPACK_IMPORTED_MODULE_1__/* .canFetch */ .Kw)(this.options.networkMode),
            status: "pending",
            variables: action.variables,
            submittedAt: Date.now()
          };
        case "success":
          return {
            ...state,
            data: action.data,
            failureCount: 0,
            failureReason: null,
            error: null,
            status: "success",
            isPaused: false
          };
        case "error":
          return {
            ...state,
            data: void 0,
            error: action.error,
            failureCount: state.failureCount + 1,
            failureReason: action.error,
            isPaused: false,
            status: "error"
          };
      }
    };
    this.state = reducer(this.state);
    _notifyManager_js__WEBPACK_IMPORTED_MODULE_2__/* .notifyManager.batch */ .V.batch(() => {
      this.#observers.forEach((observer) => {
        observer.onMutationUpdate(action);
      });
      this.#mutationCache.notify({
        mutation: this,
        type: "updated",
        action
      });
    });
  }
};
function getDefaultState() {
  return {
    context: void 0,
    data: void 0,
    error: null,
    failureCount: 0,
    failureReason: null,
    isPaused: false,
    status: "idle",
    variables: void 0,
    submittedAt: 0
  };
}

//# sourceMappingURL=mutation.js.map

/***/ }),

/***/ 27037:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "V": function() { return /* binding */ notifyManager; }
/* harmony export */ });
/* unused harmony export createNotifyManager */
/* harmony import */ var _utils_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(24139);
// src/notifyManager.ts

function createNotifyManager() {
  let queue = [];
  let transactions = 0;
  let notifyFn = (callback) => {
    callback();
  };
  let batchNotifyFn = (callback) => {
    callback();
  };
  const batch = (callback) => {
    let result;
    transactions++;
    try {
      result = callback();
    } finally {
      transactions--;
      if (!transactions) {
        flush();
      }
    }
    return result;
  };
  const schedule = (callback) => {
    if (transactions) {
      queue.push(callback);
    } else {
      (0,_utils_js__WEBPACK_IMPORTED_MODULE_0__/* .scheduleMicrotask */ .A4)(() => {
        notifyFn(callback);
      });
    }
  };
  const batchCalls = (callback) => {
    return (...args) => {
      schedule(() => {
        callback(...args);
      });
    };
  };
  const flush = () => {
    const originalQueue = queue;
    queue = [];
    if (originalQueue.length) {
      (0,_utils_js__WEBPACK_IMPORTED_MODULE_0__/* .scheduleMicrotask */ .A4)(() => {
        batchNotifyFn(() => {
          originalQueue.forEach((callback) => {
            notifyFn(callback);
          });
        });
      });
    }
  };
  const setNotifyFunction = (fn) => {
    notifyFn = fn;
  };
  const setBatchNotifyFunction = (fn) => {
    batchNotifyFn = fn;
  };
  return {
    batch,
    batchCalls,
    schedule,
    setNotifyFunction,
    setBatchNotifyFunction
  };
}
var notifyManager = createNotifyManager();

//# sourceMappingURL=notifyManager.js.map

/***/ }),

/***/ 14304:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "N": function() { return /* binding */ onlineManager; }
/* harmony export */ });
/* unused harmony export OnlineManager */
/* harmony import */ var _subscribable_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7506);
/* harmony import */ var _utils_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(24139);
// src/onlineManager.ts


var OnlineManager = class extends _subscribable_js__WEBPACK_IMPORTED_MODULE_0__/* .Subscribable */ .l {
  #online = true;
  #cleanup;
  #setup;
  constructor() {
    super();
    this.#setup = (onOnline) => {
      if (!_utils_js__WEBPACK_IMPORTED_MODULE_1__/* .isServer */ .sk && window.addEventListener) {
        const onlineListener = () => onOnline(true);
        const offlineListener = () => onOnline(false);
        window.addEventListener("online", onlineListener, false);
        window.addEventListener("offline", offlineListener, false);
        return () => {
          window.removeEventListener("online", onlineListener);
          window.removeEventListener("offline", offlineListener);
        };
      }
      return;
    };
  }
  onSubscribe() {
    if (!this.#cleanup) {
      this.setEventListener(this.#setup);
    }
  }
  onUnsubscribe() {
    if (!this.hasListeners()) {
      this.#cleanup?.();
      this.#cleanup = void 0;
    }
  }
  setEventListener(setup) {
    this.#setup = setup;
    this.#cleanup?.();
    this.#cleanup = setup(this.setOnline.bind(this));
  }
  setOnline(online) {
    const changed = this.#online !== online;
    if (changed) {
      this.#online = online;
      this.listeners.forEach((listener) => {
        listener(online);
      });
    }
  }
  isOnline() {
    return this.#online;
  }
};
var onlineManager = new OnlineManager();

//# sourceMappingURL=onlineManager.js.map

/***/ }),

/***/ 72536:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "z": function() { return /* binding */ QueryObserver; }
/* harmony export */ });
/* harmony import */ var _utils_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(24139);
/* harmony import */ var _notifyManager_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(27037);
/* harmony import */ var _focusManager_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(66474);
/* harmony import */ var _subscribable_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7506);
/* harmony import */ var _retryer_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(72008);
// src/queryObserver.ts





var QueryObserver = class extends _subscribable_js__WEBPACK_IMPORTED_MODULE_0__/* .Subscribable */ .l {
  constructor(client, options) {
    super();
    this.#currentQuery = void 0;
    this.#currentQueryInitialState = void 0;
    this.#currentResult = void 0;
    this.#trackedProps = /* @__PURE__ */ new Set();
    this.#client = client;
    this.options = options;
    this.#selectError = null;
    this.bindMethods();
    this.setOptions(options);
  }
  #client;
  #currentQuery;
  #currentQueryInitialState;
  #currentResult;
  #currentResultState;
  #currentResultOptions;
  #selectError;
  #selectFn;
  #selectResult;
  // This property keeps track of the last query with defined data.
  // It will be used to pass the previous data and query to the placeholder function between renders.
  #lastQueryWithDefinedData;
  #staleTimeoutId;
  #refetchIntervalId;
  #currentRefetchInterval;
  #trackedProps;
  bindMethods() {
    this.refetch = this.refetch.bind(this);
  }
  onSubscribe() {
    if (this.listeners.size === 1) {
      this.#currentQuery.addObserver(this);
      if (shouldFetchOnMount(this.#currentQuery, this.options)) {
        this.#executeFetch();
      } else {
        this.updateResult();
      }
      this.#updateTimers();
    }
  }
  onUnsubscribe() {
    if (!this.hasListeners()) {
      this.destroy();
    }
  }
  shouldFetchOnReconnect() {
    return shouldFetchOn(
      this.#currentQuery,
      this.options,
      this.options.refetchOnReconnect
    );
  }
  shouldFetchOnWindowFocus() {
    return shouldFetchOn(
      this.#currentQuery,
      this.options,
      this.options.refetchOnWindowFocus
    );
  }
  destroy() {
    this.listeners = /* @__PURE__ */ new Set();
    this.#clearStaleTimeout();
    this.#clearRefetchInterval();
    this.#currentQuery.removeObserver(this);
  }
  setOptions(options, notifyOptions) {
    const prevOptions = this.options;
    const prevQuery = this.#currentQuery;
    this.options = this.#client.defaultQueryOptions(options);
    if (!(0,_utils_js__WEBPACK_IMPORTED_MODULE_1__/* .shallowEqualObjects */ .VS)(prevOptions, this.options)) {
      this.#client.getQueryCache().notify({
        type: "observerOptionsUpdated",
        query: this.#currentQuery,
        observer: this
      });
    }
    if (typeof this.options.enabled !== "undefined" && typeof this.options.enabled !== "boolean") {
      throw new Error("Expected enabled to be a boolean");
    }
    if (!this.options.queryKey) {
      this.options.queryKey = prevOptions.queryKey;
    }
    this.#updateQuery();
    const mounted = this.hasListeners();
    if (mounted && shouldFetchOptionally(
      this.#currentQuery,
      prevQuery,
      this.options,
      prevOptions
    )) {
      this.#executeFetch();
    }
    this.updateResult(notifyOptions);
    if (mounted && (this.#currentQuery !== prevQuery || this.options.enabled !== prevOptions.enabled || this.options.staleTime !== prevOptions.staleTime)) {
      this.#updateStaleTimeout();
    }
    const nextRefetchInterval = this.#computeRefetchInterval();
    if (mounted && (this.#currentQuery !== prevQuery || this.options.enabled !== prevOptions.enabled || nextRefetchInterval !== this.#currentRefetchInterval)) {
      this.#updateRefetchInterval(nextRefetchInterval);
    }
  }
  getOptimisticResult(options) {
    const query = this.#client.getQueryCache().build(this.#client, options);
    const result = this.createResult(query, options);
    if (shouldAssignObserverCurrentProperties(this, result)) {
      this.#currentResult = result;
      this.#currentResultOptions = this.options;
      this.#currentResultState = this.#currentQuery.state;
    }
    return result;
  }
  getCurrentResult() {
    return this.#currentResult;
  }
  trackResult(result) {
    const trackedResult = {};
    Object.keys(result).forEach((key) => {
      Object.defineProperty(trackedResult, key, {
        configurable: false,
        enumerable: true,
        get: () => {
          this.#trackedProps.add(key);
          return result[key];
        }
      });
    });
    return trackedResult;
  }
  getCurrentQuery() {
    return this.#currentQuery;
  }
  refetch({ ...options } = {}) {
    return this.fetch({
      ...options
    });
  }
  fetchOptimistic(options) {
    const defaultedOptions = this.#client.defaultQueryOptions(options);
    const query = this.#client.getQueryCache().build(this.#client, defaultedOptions);
    query.isFetchingOptimistic = true;
    return query.fetch().then(() => this.createResult(query, defaultedOptions));
  }
  fetch(fetchOptions) {
    return this.#executeFetch({
      ...fetchOptions,
      cancelRefetch: fetchOptions.cancelRefetch ?? true
    }).then(() => {
      this.updateResult();
      return this.#currentResult;
    });
  }
  #executeFetch(fetchOptions) {
    this.#updateQuery();
    let promise = this.#currentQuery.fetch(
      this.options,
      fetchOptions
    );
    if (!fetchOptions?.throwOnError) {
      promise = promise.catch(_utils_js__WEBPACK_IMPORTED_MODULE_1__/* .noop */ .ZT);
    }
    return promise;
  }
  #updateStaleTimeout() {
    this.#clearStaleTimeout();
    if (_utils_js__WEBPACK_IMPORTED_MODULE_1__/* .isServer */ .sk || this.#currentResult.isStale || !(0,_utils_js__WEBPACK_IMPORTED_MODULE_1__/* .isValidTimeout */ .PN)(this.options.staleTime)) {
      return;
    }
    const time = (0,_utils_js__WEBPACK_IMPORTED_MODULE_1__/* .timeUntilStale */ .Kp)(
      this.#currentResult.dataUpdatedAt,
      this.options.staleTime
    );
    const timeout = time + 1;
    this.#staleTimeoutId = setTimeout(() => {
      if (!this.#currentResult.isStale) {
        this.updateResult();
      }
    }, timeout);
  }
  #computeRefetchInterval() {
    return (typeof this.options.refetchInterval === "function" ? this.options.refetchInterval(this.#currentQuery) : this.options.refetchInterval) ?? false;
  }
  #updateRefetchInterval(nextInterval) {
    this.#clearRefetchInterval();
    this.#currentRefetchInterval = nextInterval;
    if (_utils_js__WEBPACK_IMPORTED_MODULE_1__/* .isServer */ .sk || this.options.enabled === false || !(0,_utils_js__WEBPACK_IMPORTED_MODULE_1__/* .isValidTimeout */ .PN)(this.#currentRefetchInterval) || this.#currentRefetchInterval === 0) {
      return;
    }
    this.#refetchIntervalId = setInterval(() => {
      if (this.options.refetchIntervalInBackground || _focusManager_js__WEBPACK_IMPORTED_MODULE_2__/* .focusManager.isFocused */ .j.isFocused()) {
        this.#executeFetch();
      }
    }, this.#currentRefetchInterval);
  }
  #updateTimers() {
    this.#updateStaleTimeout();
    this.#updateRefetchInterval(this.#computeRefetchInterval());
  }
  #clearStaleTimeout() {
    if (this.#staleTimeoutId) {
      clearTimeout(this.#staleTimeoutId);
      this.#staleTimeoutId = void 0;
    }
  }
  #clearRefetchInterval() {
    if (this.#refetchIntervalId) {
      clearInterval(this.#refetchIntervalId);
      this.#refetchIntervalId = void 0;
    }
  }
  createResult(query, options) {
    const prevQuery = this.#currentQuery;
    const prevOptions = this.options;
    const prevResult = this.#currentResult;
    const prevResultState = this.#currentResultState;
    const prevResultOptions = this.#currentResultOptions;
    const queryChange = query !== prevQuery;
    const queryInitialState = queryChange ? query.state : this.#currentQueryInitialState;
    const { state } = query;
    let { error, errorUpdatedAt, fetchStatus, status } = state;
    let isPlaceholderData = false;
    let data;
    if (options._optimisticResults) {
      const mounted = this.hasListeners();
      const fetchOnMount = !mounted && shouldFetchOnMount(query, options);
      const fetchOptionally = mounted && shouldFetchOptionally(query, prevQuery, options, prevOptions);
      if (fetchOnMount || fetchOptionally) {
        fetchStatus = (0,_retryer_js__WEBPACK_IMPORTED_MODULE_3__/* .canFetch */ .Kw)(query.options.networkMode) ? "fetching" : "paused";
        if (!state.dataUpdatedAt) {
          status = "pending";
        }
      }
      if (options._optimisticResults === "isRestoring") {
        fetchStatus = "idle";
      }
    }
    if (options.select && typeof state.data !== "undefined") {
      if (prevResult && state.data === prevResultState?.data && options.select === this.#selectFn) {
        data = this.#selectResult;
      } else {
        try {
          this.#selectFn = options.select;
          data = options.select(state.data);
          data = (0,_utils_js__WEBPACK_IMPORTED_MODULE_1__/* .replaceData */ .oE)(prevResult?.data, data, options);
          this.#selectResult = data;
          this.#selectError = null;
        } catch (selectError) {
          this.#selectError = selectError;
        }
      }
    } else {
      data = state.data;
    }
    if (typeof options.placeholderData !== "undefined" && typeof data === "undefined" && status === "pending") {
      let placeholderData;
      if (prevResult?.isPlaceholderData && options.placeholderData === prevResultOptions?.placeholderData) {
        placeholderData = prevResult.data;
      } else {
        placeholderData = typeof options.placeholderData === "function" ? options.placeholderData(
          this.#lastQueryWithDefinedData?.state.data,
          this.#lastQueryWithDefinedData
        ) : options.placeholderData;
        if (options.select && typeof placeholderData !== "undefined") {
          try {
            placeholderData = options.select(placeholderData);
            this.#selectError = null;
          } catch (selectError) {
            this.#selectError = selectError;
          }
        }
      }
      if (typeof placeholderData !== "undefined") {
        status = "success";
        data = (0,_utils_js__WEBPACK_IMPORTED_MODULE_1__/* .replaceData */ .oE)(
          prevResult?.data,
          placeholderData,
          options
        );
        isPlaceholderData = true;
      }
    }
    if (this.#selectError) {
      error = this.#selectError;
      data = this.#selectResult;
      errorUpdatedAt = Date.now();
      status = "error";
    }
    const isFetching = fetchStatus === "fetching";
    const isPending = status === "pending";
    const isError = status === "error";
    const isLoading = isPending && isFetching;
    const result = {
      status,
      fetchStatus,
      isPending,
      isSuccess: status === "success",
      isError,
      isInitialLoading: isLoading,
      isLoading,
      data,
      dataUpdatedAt: state.dataUpdatedAt,
      error,
      errorUpdatedAt,
      failureCount: state.fetchFailureCount,
      failureReason: state.fetchFailureReason,
      errorUpdateCount: state.errorUpdateCount,
      isFetched: state.dataUpdateCount > 0 || state.errorUpdateCount > 0,
      isFetchedAfterMount: state.dataUpdateCount > queryInitialState.dataUpdateCount || state.errorUpdateCount > queryInitialState.errorUpdateCount,
      isFetching,
      isRefetching: isFetching && !isPending,
      isLoadingError: isError && state.dataUpdatedAt === 0,
      isPaused: fetchStatus === "paused",
      isPlaceholderData,
      isRefetchError: isError && state.dataUpdatedAt !== 0,
      isStale: isStale(query, options),
      refetch: this.refetch
    };
    return result;
  }
  updateResult(notifyOptions) {
    const prevResult = this.#currentResult;
    const nextResult = this.createResult(this.#currentQuery, this.options);
    this.#currentResultState = this.#currentQuery.state;
    this.#currentResultOptions = this.options;
    if (this.#currentResultState.data !== void 0) {
      this.#lastQueryWithDefinedData = this.#currentQuery;
    }
    if ((0,_utils_js__WEBPACK_IMPORTED_MODULE_1__/* .shallowEqualObjects */ .VS)(nextResult, prevResult)) {
      return;
    }
    this.#currentResult = nextResult;
    const defaultNotifyOptions = {};
    const shouldNotifyListeners = () => {
      if (!prevResult) {
        return true;
      }
      const { notifyOnChangeProps } = this.options;
      const notifyOnChangePropsValue = typeof notifyOnChangeProps === "function" ? notifyOnChangeProps() : notifyOnChangeProps;
      if (notifyOnChangePropsValue === "all" || !notifyOnChangePropsValue && !this.#trackedProps.size) {
        return true;
      }
      const includedProps = new Set(
        notifyOnChangePropsValue ?? this.#trackedProps
      );
      if (this.options.throwOnError) {
        includedProps.add("error");
      }
      return Object.keys(this.#currentResult).some((key) => {
        const typedKey = key;
        const changed = this.#currentResult[typedKey] !== prevResult[typedKey];
        return changed && includedProps.has(typedKey);
      });
    };
    if (notifyOptions?.listeners !== false && shouldNotifyListeners()) {
      defaultNotifyOptions.listeners = true;
    }
    this.#notify({ ...defaultNotifyOptions, ...notifyOptions });
  }
  #updateQuery() {
    const query = this.#client.getQueryCache().build(this.#client, this.options);
    if (query === this.#currentQuery) {
      return;
    }
    const prevQuery = this.#currentQuery;
    this.#currentQuery = query;
    this.#currentQueryInitialState = query.state;
    if (this.hasListeners()) {
      prevQuery?.removeObserver(this);
      query.addObserver(this);
    }
  }
  onQueryUpdate() {
    this.updateResult();
    if (this.hasListeners()) {
      this.#updateTimers();
    }
  }
  #notify(notifyOptions) {
    _notifyManager_js__WEBPACK_IMPORTED_MODULE_4__/* .notifyManager.batch */ .V.batch(() => {
      if (notifyOptions.listeners) {
        this.listeners.forEach((listener) => {
          listener(this.#currentResult);
        });
      }
      this.#client.getQueryCache().notify({
        query: this.#currentQuery,
        type: "observerResultsUpdated"
      });
    });
  }
};
function shouldLoadOnMount(query, options) {
  return options.enabled !== false && !query.state.dataUpdatedAt && !(query.state.status === "error" && options.retryOnMount === false);
}
function shouldFetchOnMount(query, options) {
  return shouldLoadOnMount(query, options) || query.state.dataUpdatedAt > 0 && shouldFetchOn(query, options, options.refetchOnMount);
}
function shouldFetchOn(query, options, field) {
  if (options.enabled !== false) {
    const value = typeof field === "function" ? field(query) : field;
    return value === "always" || value !== false && isStale(query, options);
  }
  return false;
}
function shouldFetchOptionally(query, prevQuery, options, prevOptions) {
  return options.enabled !== false && (query !== prevQuery || prevOptions.enabled === false) && (!options.suspense || query.state.status !== "error") && isStale(query, options);
}
function isStale(query, options) {
  return query.isStaleByTime(options.staleTime);
}
function shouldAssignObserverCurrentProperties(observer, optimisticResult) {
  if (!(0,_utils_js__WEBPACK_IMPORTED_MODULE_1__/* .shallowEqualObjects */ .VS)(observer.getCurrentResult(), optimisticResult)) {
    return true;
  }
  return false;
}

//# sourceMappingURL=queryObserver.js.map

/***/ }),

/***/ 48907:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "F": function() { return /* binding */ Removable; }
/* harmony export */ });
/* harmony import */ var _utils_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(24139);
// src/removable.ts

var Removable = class {
  #gcTimeout;
  destroy() {
    this.clearGcTimeout();
  }
  scheduleGc() {
    this.clearGcTimeout();
    if ((0,_utils_js__WEBPACK_IMPORTED_MODULE_0__/* .isValidTimeout */ .PN)(this.gcTime)) {
      this.#gcTimeout = setTimeout(() => {
        this.optionalRemove();
      }, this.gcTime);
    }
  }
  updateGcTime(newGcTime) {
    this.gcTime = Math.max(
      this.gcTime || 0,
      newGcTime ?? (_utils_js__WEBPACK_IMPORTED_MODULE_0__/* .isServer */ .sk ? Infinity : 5 * 60 * 1e3)
    );
  }
  clearGcTimeout() {
    if (this.#gcTimeout) {
      clearTimeout(this.#gcTimeout);
      this.#gcTimeout = void 0;
    }
  }
};

//# sourceMappingURL=removable.js.map

/***/ }),

/***/ 72008:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "DV": function() { return /* binding */ isCancelledError; },
/* harmony export */   "Kw": function() { return /* binding */ canFetch; },
/* harmony export */   "Mz": function() { return /* binding */ createRetryer; }
/* harmony export */ });
/* unused harmony export CancelledError */
/* harmony import */ var _focusManager_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(66474);
/* harmony import */ var _onlineManager_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(14304);
/* harmony import */ var _utils_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(24139);
// src/retryer.ts



function defaultRetryDelay(failureCount) {
  return Math.min(1e3 * 2 ** failureCount, 3e4);
}
function canFetch(networkMode) {
  return (networkMode ?? "online") === "online" ? _onlineManager_js__WEBPACK_IMPORTED_MODULE_0__/* .onlineManager.isOnline */ .N.isOnline() : true;
}
var CancelledError = class {
  constructor(options) {
    this.revert = options?.revert;
    this.silent = options?.silent;
  }
};
function isCancelledError(value) {
  return value instanceof CancelledError;
}
function createRetryer(config) {
  let isRetryCancelled = false;
  let failureCount = 0;
  let isResolved = false;
  let continueFn;
  let promiseResolve;
  let promiseReject;
  const promise = new Promise((outerResolve, outerReject) => {
    promiseResolve = outerResolve;
    promiseReject = outerReject;
  });
  const cancel = (cancelOptions) => {
    if (!isResolved) {
      reject(new CancelledError(cancelOptions));
      config.abort?.();
    }
  };
  const cancelRetry = () => {
    isRetryCancelled = true;
  };
  const continueRetry = () => {
    isRetryCancelled = false;
  };
  const shouldPause = () => !_focusManager_js__WEBPACK_IMPORTED_MODULE_1__/* .focusManager.isFocused */ .j.isFocused() || config.networkMode !== "always" && !_onlineManager_js__WEBPACK_IMPORTED_MODULE_0__/* .onlineManager.isOnline */ .N.isOnline();
  const resolve = (value) => {
    if (!isResolved) {
      isResolved = true;
      config.onSuccess?.(value);
      continueFn?.();
      promiseResolve(value);
    }
  };
  const reject = (value) => {
    if (!isResolved) {
      isResolved = true;
      config.onError?.(value);
      continueFn?.();
      promiseReject(value);
    }
  };
  const pause = () => {
    return new Promise((continueResolve) => {
      continueFn = (value) => {
        const canContinue = isResolved || !shouldPause();
        if (canContinue) {
          continueResolve(value);
        }
        return canContinue;
      };
      config.onPause?.();
    }).then(() => {
      continueFn = void 0;
      if (!isResolved) {
        config.onContinue?.();
      }
    });
  };
  const run = () => {
    if (isResolved) {
      return;
    }
    let promiseOrValue;
    try {
      promiseOrValue = config.fn();
    } catch (error) {
      promiseOrValue = Promise.reject(error);
    }
    Promise.resolve(promiseOrValue).then(resolve).catch((error) => {
      if (isResolved) {
        return;
      }
      const retry = config.retry ?? (_utils_js__WEBPACK_IMPORTED_MODULE_2__/* .isServer */ .sk ? 0 : 3);
      const retryDelay = config.retryDelay ?? defaultRetryDelay;
      const delay = typeof retryDelay === "function" ? retryDelay(failureCount, error) : retryDelay;
      const shouldRetry = retry === true || typeof retry === "number" && failureCount < retry || typeof retry === "function" && retry(failureCount, error);
      if (isRetryCancelled || !shouldRetry) {
        reject(error);
        return;
      }
      failureCount++;
      config.onFail?.(failureCount, error);
      (0,_utils_js__WEBPACK_IMPORTED_MODULE_2__/* .sleep */ ._v)(delay).then(() => {
        if (shouldPause()) {
          return pause();
        }
        return;
      }).then(() => {
        if (isRetryCancelled) {
          reject(error);
        } else {
          run();
        }
      });
    });
  };
  if (canFetch(config.networkMode)) {
    run();
  } else {
    pause().then(run);
  }
  return {
    promise,
    cancel,
    continue: () => {
      const didContinue = continueFn?.();
      return didContinue ? promise : Promise.resolve();
    },
    cancelRetry,
    continueRetry
  };
}

//# sourceMappingURL=retryer.js.map

/***/ }),

/***/ 7506:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "l": function() { return /* binding */ Subscribable; }
/* harmony export */ });
// src/subscribable.ts
var Subscribable = class {
  constructor() {
    this.listeners = /* @__PURE__ */ new Set();
    this.subscribe = this.subscribe.bind(this);
  }
  subscribe(listener) {
    this.listeners.add(listener);
    this.onSubscribe();
    return () => {
      this.listeners.delete(listener);
      this.onUnsubscribe();
    };
  }
  hasListeners() {
    return this.listeners.size > 0;
  }
  onSubscribe() {
  }
  onUnsubscribe() {
  }
};

//# sourceMappingURL=subscribable.js.map

/***/ }),

/***/ 24139:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "A4": function() { return /* binding */ scheduleMicrotask; },
/* harmony export */   "Ht": function() { return /* binding */ addToStart; },
/* harmony export */   "Kp": function() { return /* binding */ timeUntilStale; },
/* harmony export */   "PN": function() { return /* binding */ isValidTimeout; },
/* harmony export */   "Rm": function() { return /* binding */ hashQueryKeyByOptions; },
/* harmony export */   "SE": function() { return /* binding */ functionalUpdate; },
/* harmony export */   "VS": function() { return /* binding */ shallowEqualObjects; },
/* harmony export */   "VX": function() { return /* binding */ addToEnd; },
/* harmony export */   "X7": function() { return /* binding */ matchMutation; },
/* harmony export */   "Ym": function() { return /* binding */ hashKey; },
/* harmony export */   "ZT": function() { return /* binding */ noop; },
/* harmony export */   "_v": function() { return /* binding */ sleep; },
/* harmony export */   "_x": function() { return /* binding */ matchQuery; },
/* harmony export */   "oE": function() { return /* binding */ replaceData; },
/* harmony export */   "sk": function() { return /* binding */ isServer; },
/* harmony export */   "to": function() { return /* binding */ partialMatchKey; }
/* harmony export */ });
/* unused harmony exports isPlainArray, isPlainObject, keepPreviousData, replaceEqualDeep */
// src/utils.ts
var isServer = typeof window === "undefined" || "Deno" in window;
function noop() {
  return void 0;
}
function functionalUpdate(updater, input) {
  return typeof updater === "function" ? updater(input) : updater;
}
function isValidTimeout(value) {
  return typeof value === "number" && value >= 0 && value !== Infinity;
}
function timeUntilStale(updatedAt, staleTime) {
  return Math.max(updatedAt + (staleTime || 0) - Date.now(), 0);
}
function matchQuery(filters, query) {
  const {
    type = "all",
    exact,
    fetchStatus,
    predicate,
    queryKey,
    stale
  } = filters;
  if (queryKey) {
    if (exact) {
      if (query.queryHash !== hashQueryKeyByOptions(queryKey, query.options)) {
        return false;
      }
    } else if (!partialMatchKey(query.queryKey, queryKey)) {
      return false;
    }
  }
  if (type !== "all") {
    const isActive = query.isActive();
    if (type === "active" && !isActive) {
      return false;
    }
    if (type === "inactive" && isActive) {
      return false;
    }
  }
  if (typeof stale === "boolean" && query.isStale() !== stale) {
    return false;
  }
  if (typeof fetchStatus !== "undefined" && fetchStatus !== query.state.fetchStatus) {
    return false;
  }
  if (predicate && !predicate(query)) {
    return false;
  }
  return true;
}
function matchMutation(filters, mutation) {
  const { exact, status, predicate, mutationKey } = filters;
  if (mutationKey) {
    if (!mutation.options.mutationKey) {
      return false;
    }
    if (exact) {
      if (hashKey(mutation.options.mutationKey) !== hashKey(mutationKey)) {
        return false;
      }
    } else if (!partialMatchKey(mutation.options.mutationKey, mutationKey)) {
      return false;
    }
  }
  if (status && mutation.state.status !== status) {
    return false;
  }
  if (predicate && !predicate(mutation)) {
    return false;
  }
  return true;
}
function hashQueryKeyByOptions(queryKey, options) {
  const hashFn = options?.queryKeyHashFn || hashKey;
  return hashFn(queryKey);
}
function hashKey(queryKey) {
  return JSON.stringify(
    queryKey,
    (_, val) => isPlainObject(val) ? Object.keys(val).sort().reduce((result, key) => {
      result[key] = val[key];
      return result;
    }, {}) : val
  );
}
function partialMatchKey(a, b) {
  if (a === b) {
    return true;
  }
  if (typeof a !== typeof b) {
    return false;
  }
  if (a && b && typeof a === "object" && typeof b === "object") {
    return !Object.keys(b).some((key) => !partialMatchKey(a[key], b[key]));
  }
  return false;
}
function replaceEqualDeep(a, b) {
  if (a === b) {
    return a;
  }
  const array = isPlainArray(a) && isPlainArray(b);
  if (array || isPlainObject(a) && isPlainObject(b)) {
    const aSize = array ? a.length : Object.keys(a).length;
    const bItems = array ? b : Object.keys(b);
    const bSize = bItems.length;
    const copy = array ? [] : {};
    let equalItems = 0;
    for (let i = 0; i < bSize; i++) {
      const key = array ? i : bItems[i];
      copy[key] = replaceEqualDeep(a[key], b[key]);
      if (copy[key] === a[key]) {
        equalItems++;
      }
    }
    return aSize === bSize && equalItems === aSize ? a : copy;
  }
  return b;
}
function shallowEqualObjects(a, b) {
  if (a && !b || b && !a) {
    return false;
  }
  for (const key in a) {
    if (a[key] !== b[key]) {
      return false;
    }
  }
  return true;
}
function isPlainArray(value) {
  return Array.isArray(value) && value.length === Object.keys(value).length;
}
function isPlainObject(o) {
  if (!hasObjectPrototype(o)) {
    return false;
  }
  const ctor = o.constructor;
  if (typeof ctor === "undefined") {
    return true;
  }
  const prot = ctor.prototype;
  if (!hasObjectPrototype(prot)) {
    return false;
  }
  if (!prot.hasOwnProperty("isPrototypeOf")) {
    return false;
  }
  return true;
}
function hasObjectPrototype(o) {
  return Object.prototype.toString.call(o) === "[object Object]";
}
function sleep(ms) {
  return new Promise((resolve) => {
    setTimeout(resolve, ms);
  });
}
function scheduleMicrotask(callback) {
  sleep(0).then(callback);
}
function replaceData(prevData, data, options) {
  if (typeof options.structuralSharing === "function") {
    return options.structuralSharing(prevData, data);
  } else if (options.structuralSharing !== false) {
    return replaceEqualDeep(prevData, data);
  }
  return data;
}
function keepPreviousData(previousData) {
  return previousData;
}
function addToEnd(items, item, max = 0) {
  const newItems = [...items, item];
  return max && newItems.length > max ? newItems.slice(1) : newItems;
}
function addToStart(items, item, max = 0) {
  const newItems = [item, ...items];
  return max && newItems.length > max ? newItems.slice(0, -1) : newItems;
}

//# sourceMappingURL=utils.js.map

/***/ }),

/***/ 30202:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "NL": function() { return /* binding */ useQueryClient; },
/* harmony export */   "aH": function() { return /* binding */ QueryClientProvider; }
/* harmony export */ });
/* unused harmony export QueryClientContext */
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(55784);
"use client";

// src/QueryClientProvider.tsx

var QueryClientContext = react__WEBPACK_IMPORTED_MODULE_0__.createContext(
  void 0
);
var useQueryClient = (queryClient) => {
  const client = react__WEBPACK_IMPORTED_MODULE_0__.useContext(QueryClientContext);
  if (queryClient) {
    return queryClient;
  }
  if (!client) {
    throw new Error("No QueryClient set, use QueryClientProvider to set one");
  }
  return client;
};
var QueryClientProvider = ({
  client,
  children
}) => {
  react__WEBPACK_IMPORTED_MODULE_0__.useEffect(() => {
    client.mount();
    return () => {
      client.unmount();
    };
  }, [client]);
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(QueryClientContext.Provider, { value: client }, children);
};

//# sourceMappingURL=QueryClientProvider.js.map

/***/ }),

/***/ 20364:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "r": function() { return /* binding */ useBaseQuery; }
});

// EXTERNAL MODULE: ./node_modules/next/dist/compiled/react/index.js
var react = __webpack_require__(55784);
// EXTERNAL MODULE: ./node_modules/@tanstack/query-core/build/modern/notifyManager.js
var notifyManager = __webpack_require__(27037);
;// CONCATENATED MODULE: ./node_modules/@tanstack/react-query/build/modern/QueryErrorResetBoundary.js
"use client";

// src/QueryErrorResetBoundary.tsx

function createValue() {
  let isReset = false;
  return {
    clearReset: () => {
      isReset = false;
    },
    reset: () => {
      isReset = true;
    },
    isReset: () => {
      return isReset;
    }
  };
}
var QueryErrorResetBoundaryContext = react.createContext(createValue());
var useQueryErrorResetBoundary = () => react.useContext(QueryErrorResetBoundaryContext);
var QueryErrorResetBoundary = ({
  children
}) => {
  const [value] = React.useState(() => createValue());
  return /* @__PURE__ */ React.createElement(QueryErrorResetBoundaryContext.Provider, { value }, typeof children === "function" ? children(value) : children);
};

//# sourceMappingURL=QueryErrorResetBoundary.js.map
// EXTERNAL MODULE: ./node_modules/@tanstack/react-query/build/modern/QueryClientProvider.js
var QueryClientProvider = __webpack_require__(30202);
;// CONCATENATED MODULE: ./node_modules/@tanstack/react-query/build/modern/isRestoring.js
"use client";

// src/isRestoring.ts

var IsRestoringContext = react.createContext(false);
var useIsRestoring = () => react.useContext(IsRestoringContext);
var IsRestoringProvider = IsRestoringContext.Provider;

//# sourceMappingURL=isRestoring.js.map
// EXTERNAL MODULE: ./node_modules/@tanstack/react-query/build/modern/utils.js
var utils = __webpack_require__(86290);
;// CONCATENATED MODULE: ./node_modules/@tanstack/react-query/build/modern/errorBoundaryUtils.js
"use client";

// src/errorBoundaryUtils.ts


var ensurePreventErrorBoundaryRetry = (options, errorResetBoundary) => {
  if (options.suspense || options.throwOnError) {
    if (!errorResetBoundary.isReset()) {
      options.retryOnMount = false;
    }
  }
};
var useClearResetErrorBoundary = (errorResetBoundary) => {
  react.useEffect(() => {
    errorResetBoundary.clearReset();
  }, [errorResetBoundary]);
};
var getHasError = ({
  result,
  errorResetBoundary,
  throwOnError,
  query
}) => {
  return result.isError && !errorResetBoundary.isReset() && !result.isFetching && (0,utils/* shouldThrowError */.L)(throwOnError, [result.error, query]);
};

//# sourceMappingURL=errorBoundaryUtils.js.map
;// CONCATENATED MODULE: ./node_modules/@tanstack/react-query/build/modern/suspense.js
// src/suspense.ts
var defaultThrowOnError = (_error, query) => typeof query.state.data === "undefined";
var ensureStaleTime = (defaultedOptions) => {
  if (defaultedOptions.suspense) {
    if (typeof defaultedOptions.staleTime !== "number") {
      defaultedOptions.staleTime = 1e3;
    }
  }
};
var willFetch = (result, isRestoring) => result.isLoading && result.isFetching && !isRestoring;
var shouldSuspend = (defaultedOptions, result) => defaultedOptions?.suspense && result.isPending;
var fetchOptimistic = (defaultedOptions, observer, errorResetBoundary) => observer.fetchOptimistic(defaultedOptions).catch(() => {
  errorResetBoundary.clearReset();
});

//# sourceMappingURL=suspense.js.map
;// CONCATENATED MODULE: ./node_modules/@tanstack/react-query/build/modern/useBaseQuery.js
"use client";

// src/useBaseQuery.ts







function useBaseQuery(options, Observer, queryClient) {
  if (false) {}
  const client = (0,QueryClientProvider/* useQueryClient */.NL)(queryClient);
  const isRestoring = useIsRestoring();
  const errorResetBoundary = useQueryErrorResetBoundary();
  const defaultedOptions = client.defaultQueryOptions(options);
  defaultedOptions._optimisticResults = isRestoring ? "isRestoring" : "optimistic";
  ensureStaleTime(defaultedOptions);
  ensurePreventErrorBoundaryRetry(defaultedOptions, errorResetBoundary);
  useClearResetErrorBoundary(errorResetBoundary);
  const [observer] = react.useState(
    () => new Observer(
      client,
      defaultedOptions
    )
  );
  const result = observer.getOptimisticResult(defaultedOptions);
  react.useSyncExternalStore(
    react.useCallback(
      (onStoreChange) => {
        const unsubscribe = isRestoring ? () => void 0 : observer.subscribe(notifyManager/* notifyManager.batchCalls */.V.batchCalls(onStoreChange));
        observer.updateResult();
        return unsubscribe;
      },
      [observer, isRestoring]
    ),
    () => observer.getCurrentResult(),
    () => observer.getCurrentResult()
  );
  react.useEffect(() => {
    observer.setOptions(defaultedOptions, { listeners: false });
  }, [defaultedOptions, observer]);
  if (shouldSuspend(defaultedOptions, result)) {
    observer.setOptions(defaultedOptions, { listeners: false });
    throw fetchOptimistic(defaultedOptions, observer, errorResetBoundary);
  }
  if (getHasError({
    result,
    errorResetBoundary,
    throwOnError: defaultedOptions.throwOnError,
    query: observer.getCurrentQuery()
  })) {
    throw result.error;
  }
  return !defaultedOptions.notifyOnChangeProps ? observer.trackResult(result) : result;
}

//# sourceMappingURL=useBaseQuery.js.map

/***/ }),

/***/ 29726:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "N": function() { return /* binding */ useInfiniteQuery; }
});

// EXTERNAL MODULE: ./node_modules/@tanstack/query-core/build/modern/queryObserver.js
var queryObserver = __webpack_require__(72536);
// EXTERNAL MODULE: ./node_modules/@tanstack/query-core/build/modern/infiniteQueryBehavior.js
var infiniteQueryBehavior = __webpack_require__(54948);
;// CONCATENATED MODULE: ./node_modules/@tanstack/query-core/build/modern/infiniteQueryObserver.js
// src/infiniteQueryObserver.ts


var InfiniteQueryObserver = class extends queryObserver/* QueryObserver */.z {
  // eslint-disable-next-line @typescript-eslint/no-useless-constructor
  constructor(client, options) {
    super(client, options);
  }
  bindMethods() {
    super.bindMethods();
    this.fetchNextPage = this.fetchNextPage.bind(this);
    this.fetchPreviousPage = this.fetchPreviousPage.bind(this);
  }
  setOptions(options, notifyOptions) {
    super.setOptions(
      {
        ...options,
        behavior: (0,infiniteQueryBehavior/* infiniteQueryBehavior */.Gm)()
      },
      notifyOptions
    );
  }
  getOptimisticResult(options) {
    options.behavior = (0,infiniteQueryBehavior/* infiniteQueryBehavior */.Gm)();
    return super.getOptimisticResult(options);
  }
  fetchNextPage(options) {
    return this.fetch({
      ...options,
      meta: {
        fetchMore: { direction: "forward" }
      }
    });
  }
  fetchPreviousPage(options) {
    return this.fetch({
      ...options,
      meta: {
        fetchMore: { direction: "backward" }
      }
    });
  }
  createResult(query, options) {
    const { state } = query;
    const result = super.createResult(query, options);
    const { isFetching, isRefetching } = result;
    const isFetchingNextPage = isFetching && state.fetchMeta?.fetchMore?.direction === "forward";
    const isFetchingPreviousPage = isFetching && state.fetchMeta?.fetchMore?.direction === "backward";
    return {
      ...result,
      fetchNextPage: this.fetchNextPage,
      fetchPreviousPage: this.fetchPreviousPage,
      hasNextPage: (0,infiniteQueryBehavior/* hasNextPage */.Qy)(options, state.data),
      hasPreviousPage: (0,infiniteQueryBehavior/* hasPreviousPage */.ZF)(options, state.data),
      isFetchingNextPage,
      isFetchingPreviousPage,
      isRefetching: isRefetching && !isFetchingNextPage && !isFetchingPreviousPage
    };
  }
};

//# sourceMappingURL=infiniteQueryObserver.js.map
// EXTERNAL MODULE: ./node_modules/@tanstack/react-query/build/modern/useBaseQuery.js + 4 modules
var useBaseQuery = __webpack_require__(20364);
;// CONCATENATED MODULE: ./node_modules/@tanstack/react-query/build/modern/useInfiniteQuery.js
"use client";

// src/useInfiniteQuery.ts


function useInfiniteQuery(options, queryClient) {
  return (0,useBaseQuery/* useBaseQuery */.r)(
    options,
    // eslint-disable-next-line @typescript-eslint/no-unnecessary-type-assertion
    InfiniteQueryObserver,
    queryClient
  );
}

//# sourceMappingURL=useInfiniteQuery.js.map

/***/ }),

/***/ 98029:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "D": function() { return /* binding */ useMutation; }
});

// EXTERNAL MODULE: ./node_modules/next/dist/compiled/react/index.js
var react = __webpack_require__(55784);
// EXTERNAL MODULE: ./node_modules/@tanstack/query-core/build/modern/mutation.js
var mutation = __webpack_require__(59289);
// EXTERNAL MODULE: ./node_modules/@tanstack/query-core/build/modern/notifyManager.js
var notifyManager = __webpack_require__(27037);
// EXTERNAL MODULE: ./node_modules/@tanstack/query-core/build/modern/subscribable.js
var subscribable = __webpack_require__(7506);
// EXTERNAL MODULE: ./node_modules/@tanstack/query-core/build/modern/utils.js
var utils = __webpack_require__(24139);
;// CONCATENATED MODULE: ./node_modules/@tanstack/query-core/build/modern/mutationObserver.js
// src/mutationObserver.ts




var MutationObserver = class extends subscribable/* Subscribable */.l {
  constructor(client, options) {
    super();
    this.#currentResult = void 0;
    this.#client = client;
    this.setOptions(options);
    this.bindMethods();
    this.#updateResult();
  }
  #client;
  #currentResult;
  #currentMutation;
  #mutateOptions;
  bindMethods() {
    this.mutate = this.mutate.bind(this);
    this.reset = this.reset.bind(this);
  }
  setOptions(options) {
    const prevOptions = this.options;
    this.options = this.#client.defaultMutationOptions(options);
    if (!(0,utils/* shallowEqualObjects */.VS)(prevOptions, this.options)) {
      this.#client.getMutationCache().notify({
        type: "observerOptionsUpdated",
        mutation: this.#currentMutation,
        observer: this
      });
    }
    this.#currentMutation?.setOptions(this.options);
    if (prevOptions?.mutationKey && this.options.mutationKey && (0,utils/* hashKey */.Ym)(prevOptions.mutationKey) !== (0,utils/* hashKey */.Ym)(this.options.mutationKey)) {
      this.reset();
    }
  }
  onUnsubscribe() {
    if (!this.hasListeners()) {
      this.#currentMutation?.removeObserver(this);
    }
  }
  onMutationUpdate(action) {
    this.#updateResult();
    this.#notify(action);
  }
  getCurrentResult() {
    return this.#currentResult;
  }
  reset() {
    this.#currentMutation?.removeObserver(this);
    this.#currentMutation = void 0;
    this.#updateResult();
    this.#notify();
  }
  mutate(variables, options) {
    this.#mutateOptions = options;
    this.#currentMutation?.removeObserver(this);
    this.#currentMutation = this.#client.getMutationCache().build(this.#client, this.options);
    this.#currentMutation.addObserver(this);
    return this.#currentMutation.execute(variables);
  }
  #updateResult() {
    const state = this.#currentMutation?.state ?? (0,mutation/* getDefaultState */.R)();
    this.#currentResult = {
      ...state,
      isPending: state.status === "pending",
      isSuccess: state.status === "success",
      isError: state.status === "error",
      isIdle: state.status === "idle",
      mutate: this.mutate,
      reset: this.reset
    };
  }
  #notify(action) {
    notifyManager/* notifyManager.batch */.V.batch(() => {
      if (this.#mutateOptions && this.hasListeners()) {
        const variables = this.#currentResult.variables;
        const context = this.#currentResult.context;
        if (action?.type === "success") {
          this.#mutateOptions.onSuccess?.(action.data, variables, context);
          this.#mutateOptions.onSettled?.(action.data, null, variables, context);
        } else if (action?.type === "error") {
          this.#mutateOptions.onError?.(action.error, variables, context);
          this.#mutateOptions.onSettled?.(
            void 0,
            action.error,
            variables,
            context
          );
        }
      }
      this.listeners.forEach((listener) => {
        listener(this.#currentResult);
      });
    });
  }
};

//# sourceMappingURL=mutationObserver.js.map
// EXTERNAL MODULE: ./node_modules/@tanstack/react-query/build/modern/QueryClientProvider.js
var QueryClientProvider = __webpack_require__(30202);
// EXTERNAL MODULE: ./node_modules/@tanstack/react-query/build/modern/utils.js
var modern_utils = __webpack_require__(86290);
;// CONCATENATED MODULE: ./node_modules/@tanstack/react-query/build/modern/useMutation.js
"use client";

// src/useMutation.ts




function useMutation(options, queryClient) {
  const client = (0,QueryClientProvider/* useQueryClient */.NL)(queryClient);
  const [observer] = react.useState(
    () => new MutationObserver(
      client,
      options
    )
  );
  react.useEffect(() => {
    observer.setOptions(options);
  }, [observer, options]);
  const result = react.useSyncExternalStore(
    react.useCallback(
      (onStoreChange) => observer.subscribe(notifyManager/* notifyManager.batchCalls */.V.batchCalls(onStoreChange)),
      [observer]
    ),
    () => observer.getCurrentResult(),
    () => observer.getCurrentResult()
  );
  const mutate = react.useCallback(
    (variables, mutateOptions) => {
      observer.mutate(variables, mutateOptions).catch(noop);
    },
    [observer]
  );
  if (result.error && (0,modern_utils/* shouldThrowError */.L)(observer.options.throwOnError, [result.error])) {
    throw result.error;
  }
  return { ...result, mutate, mutateAsync: result.mutate };
}
function noop() {
}

//# sourceMappingURL=useMutation.js.map

/***/ }),

/***/ 78551:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "a": function() { return /* binding */ useQuery; }
/* harmony export */ });
/* harmony import */ var _tanstack_query_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(72536);
/* harmony import */ var _useBaseQuery_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(20364);
"use client";

// src/useQuery.ts


function useQuery(options, queryClient) {
  return (0,_useBaseQuery_js__WEBPACK_IMPORTED_MODULE_0__/* .useBaseQuery */ .r)(options, _tanstack_query_core__WEBPACK_IMPORTED_MODULE_1__/* .QueryObserver */ .z, queryClient);
}

//# sourceMappingURL=useQuery.js.map

/***/ }),

/***/ 86290:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "L": function() { return /* binding */ shouldThrowError; }
/* harmony export */ });
// src/utils.ts
function shouldThrowError(throwError, params) {
  if (typeof throwError === "function") {
    return throwError(...params);
  }
  return !!throwError;
}

//# sourceMappingURL=utils.js.map

/***/ }),

/***/ 70594:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ lib_axios; }
});

;// CONCATENATED MODULE: ./node_modules/axios/lib/helpers/bind.js


function bind(fn, thisArg) {
  return function wrap() {
    return fn.apply(thisArg, arguments);
  };
}

;// CONCATENATED MODULE: ./node_modules/axios/lib/utils.js




// utils is a library of generic helper functions non-specific to axios

const {toString: utils_toString} = Object.prototype;
const {getPrototypeOf} = Object;

const kindOf = (cache => thing => {
    const str = utils_toString.call(thing);
    return cache[str] || (cache[str] = str.slice(8, -1).toLowerCase());
})(Object.create(null));

const kindOfTest = (type) => {
  type = type.toLowerCase();
  return (thing) => kindOf(thing) === type
}

const typeOfTest = type => thing => typeof thing === type;

/**
 * Determine if a value is an Array
 *
 * @param {Object} val The value to test
 *
 * @returns {boolean} True if value is an Array, otherwise false
 */
const {isArray} = Array;

/**
 * Determine if a value is undefined
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if the value is undefined, otherwise false
 */
const isUndefined = typeOfTest('undefined');

/**
 * Determine if a value is a Buffer
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Buffer, otherwise false
 */
function isBuffer(val) {
  return val !== null && !isUndefined(val) && val.constructor !== null && !isUndefined(val.constructor)
    && isFunction(val.constructor.isBuffer) && val.constructor.isBuffer(val);
}

/**
 * Determine if a value is an ArrayBuffer
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is an ArrayBuffer, otherwise false
 */
const isArrayBuffer = kindOfTest('ArrayBuffer');


/**
 * Determine if a value is a view on an ArrayBuffer
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a view on an ArrayBuffer, otherwise false
 */
function isArrayBufferView(val) {
  let result;
  if ((typeof ArrayBuffer !== 'undefined') && (ArrayBuffer.isView)) {
    result = ArrayBuffer.isView(val);
  } else {
    result = (val) && (val.buffer) && (isArrayBuffer(val.buffer));
  }
  return result;
}

/**
 * Determine if a value is a String
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a String, otherwise false
 */
const isString = typeOfTest('string');

/**
 * Determine if a value is a Function
 *
 * @param {*} val The value to test
 * @returns {boolean} True if value is a Function, otherwise false
 */
const isFunction = typeOfTest('function');

/**
 * Determine if a value is a Number
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Number, otherwise false
 */
const isNumber = typeOfTest('number');

/**
 * Determine if a value is an Object
 *
 * @param {*} thing The value to test
 *
 * @returns {boolean} True if value is an Object, otherwise false
 */
const isObject = (thing) => thing !== null && typeof thing === 'object';

/**
 * Determine if a value is a Boolean
 *
 * @param {*} thing The value to test
 * @returns {boolean} True if value is a Boolean, otherwise false
 */
const isBoolean = thing => thing === true || thing === false;

/**
 * Determine if a value is a plain Object
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a plain Object, otherwise false
 */
const isPlainObject = (val) => {
  if (kindOf(val) !== 'object') {
    return false;
  }

  const prototype = getPrototypeOf(val);
  return (prototype === null || prototype === Object.prototype || Object.getPrototypeOf(prototype) === null) && !(Symbol.toStringTag in val) && !(Symbol.iterator in val);
}

/**
 * Determine if a value is a Date
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Date, otherwise false
 */
const isDate = kindOfTest('Date');

/**
 * Determine if a value is a File
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a File, otherwise false
 */
const isFile = kindOfTest('File');

/**
 * Determine if a value is a Blob
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Blob, otherwise false
 */
const isBlob = kindOfTest('Blob');

/**
 * Determine if a value is a FileList
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a File, otherwise false
 */
const isFileList = kindOfTest('FileList');

/**
 * Determine if a value is a Stream
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Stream, otherwise false
 */
const isStream = (val) => isObject(val) && isFunction(val.pipe);

/**
 * Determine if a value is a FormData
 *
 * @param {*} thing The value to test
 *
 * @returns {boolean} True if value is an FormData, otherwise false
 */
const isFormData = (thing) => {
  const pattern = '[object FormData]';
  return thing && (
    (typeof FormData === 'function' && thing instanceof FormData) ||
    utils_toString.call(thing) === pattern ||
    (isFunction(thing.toString) && thing.toString() === pattern)
  );
}

/**
 * Determine if a value is a URLSearchParams object
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a URLSearchParams object, otherwise false
 */
const isURLSearchParams = kindOfTest('URLSearchParams');

/**
 * Trim excess whitespace off the beginning and end of a string
 *
 * @param {String} str The String to trim
 *
 * @returns {String} The String freed of excess whitespace
 */
const trim = (str) => str.trim ?
  str.trim() : str.replace(/^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g, '');

/**
 * Iterate over an Array or an Object invoking a function for each item.
 *
 * If `obj` is an Array callback will be called passing
 * the value, index, and complete array for each item.
 *
 * If 'obj' is an Object callback will be called passing
 * the value, key, and complete object for each property.
 *
 * @param {Object|Array} obj The object to iterate
 * @param {Function} fn The callback to invoke for each item
 *
 * @param {Boolean} [allOwnKeys = false]
 * @returns {any}
 */
function forEach(obj, fn, {allOwnKeys = false} = {}) {
  // Don't bother if no value provided
  if (obj === null || typeof obj === 'undefined') {
    return;
  }

  let i;
  let l;

  // Force an array if not already something iterable
  if (typeof obj !== 'object') {
    /*eslint no-param-reassign:0*/
    obj = [obj];
  }

  if (isArray(obj)) {
    // Iterate over array values
    for (i = 0, l = obj.length; i < l; i++) {
      fn.call(null, obj[i], i, obj);
    }
  } else {
    // Iterate over object keys
    const keys = allOwnKeys ? Object.getOwnPropertyNames(obj) : Object.keys(obj);
    const len = keys.length;
    let key;

    for (i = 0; i < len; i++) {
      key = keys[i];
      fn.call(null, obj[key], key, obj);
    }
  }
}

function findKey(obj, key) {
  key = key.toLowerCase();
  const keys = Object.keys(obj);
  let i = keys.length;
  let _key;
  while (i-- > 0) {
    _key = keys[i];
    if (key === _key.toLowerCase()) {
      return _key;
    }
  }
  return null;
}

const _global = typeof self === "undefined" ? typeof global === "undefined" ? undefined : global : self;

const isContextDefined = (context) => !isUndefined(context) && context !== _global;

/**
 * Accepts varargs expecting each argument to be an object, then
 * immutably merges the properties of each object and returns result.
 *
 * When multiple objects contain the same key the later object in
 * the arguments list will take precedence.
 *
 * Example:
 *
 * ```js
 * var result = merge({foo: 123}, {foo: 456});
 * console.log(result.foo); // outputs 456
 * ```
 *
 * @param {Object} obj1 Object to merge
 *
 * @returns {Object} Result of all merge properties
 */
function merge(/* obj1, obj2, obj3, ... */) {
  const {caseless} = isContextDefined(this) && this || {};
  const result = {};
  const assignValue = (val, key) => {
    const targetKey = caseless && findKey(result, key) || key;
    if (isPlainObject(result[targetKey]) && isPlainObject(val)) {
      result[targetKey] = merge(result[targetKey], val);
    } else if (isPlainObject(val)) {
      result[targetKey] = merge({}, val);
    } else if (isArray(val)) {
      result[targetKey] = val.slice();
    } else {
      result[targetKey] = val;
    }
  }

  for (let i = 0, l = arguments.length; i < l; i++) {
    arguments[i] && forEach(arguments[i], assignValue);
  }
  return result;
}

/**
 * Extends object a by mutably adding to it the properties of object b.
 *
 * @param {Object} a The object to be extended
 * @param {Object} b The object to copy properties from
 * @param {Object} thisArg The object to bind function to
 *
 * @param {Boolean} [allOwnKeys]
 * @returns {Object} The resulting value of object a
 */
const extend = (a, b, thisArg, {allOwnKeys}= {}) => {
  forEach(b, (val, key) => {
    if (thisArg && isFunction(val)) {
      a[key] = bind(val, thisArg);
    } else {
      a[key] = val;
    }
  }, {allOwnKeys});
  return a;
}

/**
 * Remove byte order marker. This catches EF BB BF (the UTF-8 BOM)
 *
 * @param {string} content with BOM
 *
 * @returns {string} content value without BOM
 */
const stripBOM = (content) => {
  if (content.charCodeAt(0) === 0xFEFF) {
    content = content.slice(1);
  }
  return content;
}

/**
 * Inherit the prototype methods from one constructor into another
 * @param {function} constructor
 * @param {function} superConstructor
 * @param {object} [props]
 * @param {object} [descriptors]
 *
 * @returns {void}
 */
const inherits = (constructor, superConstructor, props, descriptors) => {
  constructor.prototype = Object.create(superConstructor.prototype, descriptors);
  constructor.prototype.constructor = constructor;
  Object.defineProperty(constructor, 'super', {
    value: superConstructor.prototype
  });
  props && Object.assign(constructor.prototype, props);
}

/**
 * Resolve object with deep prototype chain to a flat object
 * @param {Object} sourceObj source object
 * @param {Object} [destObj]
 * @param {Function|Boolean} [filter]
 * @param {Function} [propFilter]
 *
 * @returns {Object}
 */
const toFlatObject = (sourceObj, destObj, filter, propFilter) => {
  let props;
  let i;
  let prop;
  const merged = {};

  destObj = destObj || {};
  // eslint-disable-next-line no-eq-null,eqeqeq
  if (sourceObj == null) return destObj;

  do {
    props = Object.getOwnPropertyNames(sourceObj);
    i = props.length;
    while (i-- > 0) {
      prop = props[i];
      if ((!propFilter || propFilter(prop, sourceObj, destObj)) && !merged[prop]) {
        destObj[prop] = sourceObj[prop];
        merged[prop] = true;
      }
    }
    sourceObj = filter !== false && getPrototypeOf(sourceObj);
  } while (sourceObj && (!filter || filter(sourceObj, destObj)) && sourceObj !== Object.prototype);

  return destObj;
}

/**
 * Determines whether a string ends with the characters of a specified string
 *
 * @param {String} str
 * @param {String} searchString
 * @param {Number} [position= 0]
 *
 * @returns {boolean}
 */
const endsWith = (str, searchString, position) => {
  str = String(str);
  if (position === undefined || position > str.length) {
    position = str.length;
  }
  position -= searchString.length;
  const lastIndex = str.indexOf(searchString, position);
  return lastIndex !== -1 && lastIndex === position;
}


/**
 * Returns new array from array like object or null if failed
 *
 * @param {*} [thing]
 *
 * @returns {?Array}
 */
const toArray = (thing) => {
  if (!thing) return null;
  if (isArray(thing)) return thing;
  let i = thing.length;
  if (!isNumber(i)) return null;
  const arr = new Array(i);
  while (i-- > 0) {
    arr[i] = thing[i];
  }
  return arr;
}

/**
 * Checking if the Uint8Array exists and if it does, it returns a function that checks if the
 * thing passed in is an instance of Uint8Array
 *
 * @param {TypedArray}
 *
 * @returns {Array}
 */
// eslint-disable-next-line func-names
const isTypedArray = (TypedArray => {
  // eslint-disable-next-line func-names
  return thing => {
    return TypedArray && thing instanceof TypedArray;
  };
})(typeof Uint8Array !== 'undefined' && getPrototypeOf(Uint8Array));

/**
 * For each entry in the object, call the function with the key and value.
 *
 * @param {Object<any, any>} obj - The object to iterate over.
 * @param {Function} fn - The function to call for each entry.
 *
 * @returns {void}
 */
const forEachEntry = (obj, fn) => {
  const generator = obj && obj[Symbol.iterator];

  const iterator = generator.call(obj);

  let result;

  while ((result = iterator.next()) && !result.done) {
    const pair = result.value;
    fn.call(obj, pair[0], pair[1]);
  }
}

/**
 * It takes a regular expression and a string, and returns an array of all the matches
 *
 * @param {string} regExp - The regular expression to match against.
 * @param {string} str - The string to search.
 *
 * @returns {Array<boolean>}
 */
const matchAll = (regExp, str) => {
  let matches;
  const arr = [];

  while ((matches = regExp.exec(str)) !== null) {
    arr.push(matches);
  }

  return arr;
}

/* Checking if the kindOfTest function returns true when passed an HTMLFormElement. */
const isHTMLForm = kindOfTest('HTMLFormElement');

const toCamelCase = str => {
  return str.toLowerCase().replace(/[_-\s]([a-z\d])(\w*)/g,
    function replacer(m, p1, p2) {
      return p1.toUpperCase() + p2;
    }
  );
};

/* Creating a function that will check if an object has a property. */
const utils_hasOwnProperty = (({hasOwnProperty}) => (obj, prop) => hasOwnProperty.call(obj, prop))(Object.prototype);

/**
 * Determine if a value is a RegExp object
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a RegExp object, otherwise false
 */
const isRegExp = kindOfTest('RegExp');

const reduceDescriptors = (obj, reducer) => {
  const descriptors = Object.getOwnPropertyDescriptors(obj);
  const reducedDescriptors = {};

  forEach(descriptors, (descriptor, name) => {
    if (reducer(descriptor, name, obj) !== false) {
      reducedDescriptors[name] = descriptor;
    }
  });

  Object.defineProperties(obj, reducedDescriptors);
}

/**
 * Makes all methods read-only
 * @param {Object} obj
 */

const freezeMethods = (obj) => {
  reduceDescriptors(obj, (descriptor, name) => {
    // skip restricted props in strict mode
    if (isFunction(obj) && ['arguments', 'caller', 'callee'].indexOf(name) !== -1) {
      return false;
    }

    const value = obj[name];

    if (!isFunction(value)) return;

    descriptor.enumerable = false;

    if ('writable' in descriptor) {
      descriptor.writable = false;
      return;
    }

    if (!descriptor.set) {
      descriptor.set = () => {
        throw Error('Can not rewrite read-only method \'' + name + '\'');
      };
    }
  });
}

const toObjectSet = (arrayOrString, delimiter) => {
  const obj = {};

  const define = (arr) => {
    arr.forEach(value => {
      obj[value] = true;
    });
  }

  isArray(arrayOrString) ? define(arrayOrString) : define(String(arrayOrString).split(delimiter));

  return obj;
}

const noop = () => {}

const toFiniteNumber = (value, defaultValue) => {
  value = +value;
  return Number.isFinite(value) ? value : defaultValue;
}

const toJSONObject = (obj) => {
  const stack = new Array(10);

  const visit = (source, i) => {

    if (isObject(source)) {
      if (stack.indexOf(source) >= 0) {
        return;
      }

      if(!('toJSON' in source)) {
        stack[i] = source;
        const target = isArray(source) ? [] : {};

        forEach(source, (value, key) => {
          const reducedValue = visit(value, i + 1);
          !isUndefined(reducedValue) && (target[key] = reducedValue);
        });

        stack[i] = undefined;

        return target;
      }
    }

    return source;
  }

  return visit(obj, 0);
}

/* harmony default export */ var utils = ({
  isArray,
  isArrayBuffer,
  isBuffer,
  isFormData,
  isArrayBufferView,
  isString,
  isNumber,
  isBoolean,
  isObject,
  isPlainObject,
  isUndefined,
  isDate,
  isFile,
  isBlob,
  isRegExp,
  isFunction,
  isStream,
  isURLSearchParams,
  isTypedArray,
  isFileList,
  forEach,
  merge,
  extend,
  trim,
  stripBOM,
  inherits,
  toFlatObject,
  kindOf,
  kindOfTest,
  endsWith,
  toArray,
  forEachEntry,
  matchAll,
  isHTMLForm,
  hasOwnProperty: utils_hasOwnProperty,
  hasOwnProp: utils_hasOwnProperty, // an alias to avoid ESLint no-prototype-builtins detection
  reduceDescriptors,
  freezeMethods,
  toObjectSet,
  toCamelCase,
  noop,
  toFiniteNumber,
  findKey,
  global: _global,
  isContextDefined,
  toJSONObject
});

;// CONCATENATED MODULE: ./node_modules/axios/lib/core/AxiosError.js




/**
 * Create an Error with the specified message, config, error code, request and response.
 *
 * @param {string} message The error message.
 * @param {string} [code] The error code (for example, 'ECONNABORTED').
 * @param {Object} [config] The config.
 * @param {Object} [request] The request.
 * @param {Object} [response] The response.
 *
 * @returns {Error} The created error.
 */
function AxiosError(message, code, config, request, response) {
  Error.call(this);

  if (Error.captureStackTrace) {
    Error.captureStackTrace(this, this.constructor);
  } else {
    this.stack = (new Error()).stack;
  }

  this.message = message;
  this.name = 'AxiosError';
  code && (this.code = code);
  config && (this.config = config);
  request && (this.request = request);
  response && (this.response = response);
}

utils.inherits(AxiosError, Error, {
  toJSON: function toJSON() {
    return {
      // Standard
      message: this.message,
      name: this.name,
      // Microsoft
      description: this.description,
      number: this.number,
      // Mozilla
      fileName: this.fileName,
      lineNumber: this.lineNumber,
      columnNumber: this.columnNumber,
      stack: this.stack,
      // Axios
      config: utils.toJSONObject(this.config),
      code: this.code,
      status: this.response && this.response.status ? this.response.status : null
    };
  }
});

const AxiosError_prototype = AxiosError.prototype;
const descriptors = {};

[
  'ERR_BAD_OPTION_VALUE',
  'ERR_BAD_OPTION',
  'ECONNABORTED',
  'ETIMEDOUT',
  'ERR_NETWORK',
  'ERR_FR_TOO_MANY_REDIRECTS',
  'ERR_DEPRECATED',
  'ERR_BAD_RESPONSE',
  'ERR_BAD_REQUEST',
  'ERR_CANCELED',
  'ERR_NOT_SUPPORT',
  'ERR_INVALID_URL'
// eslint-disable-next-line func-names
].forEach(code => {
  descriptors[code] = {value: code};
});

Object.defineProperties(AxiosError, descriptors);
Object.defineProperty(AxiosError_prototype, 'isAxiosError', {value: true});

// eslint-disable-next-line func-names
AxiosError.from = (error, code, config, request, response, customProps) => {
  const axiosError = Object.create(AxiosError_prototype);

  utils.toFlatObject(error, axiosError, function filter(obj) {
    return obj !== Error.prototype;
  }, prop => {
    return prop !== 'isAxiosError';
  });

  AxiosError.call(axiosError, error.message, code, config, request, response);

  axiosError.cause = error;

  axiosError.name = error.name;

  customProps && Object.assign(axiosError, customProps);

  return axiosError;
};

/* harmony default export */ var core_AxiosError = (AxiosError);

// EXTERNAL MODULE: ./node_modules/form-data/lib/browser.js
var browser = __webpack_require__(6230);
;// CONCATENATED MODULE: ./node_modules/axios/lib/env/classes/FormData.js

/* harmony default export */ var classes_FormData = (browser);

;// CONCATENATED MODULE: ./node_modules/axios/lib/helpers/toFormData.js
/* provided dependency */ var Buffer = __webpack_require__(21876)["Buffer"];






/**
 * Determines if the given thing is a array or js object.
 *
 * @param {string} thing - The object or array to be visited.
 *
 * @returns {boolean}
 */
function isVisitable(thing) {
  return utils.isPlainObject(thing) || utils.isArray(thing);
}

/**
 * It removes the brackets from the end of a string
 *
 * @param {string} key - The key of the parameter.
 *
 * @returns {string} the key without the brackets.
 */
function removeBrackets(key) {
  return utils.endsWith(key, '[]') ? key.slice(0, -2) : key;
}

/**
 * It takes a path, a key, and a boolean, and returns a string
 *
 * @param {string} path - The path to the current key.
 * @param {string} key - The key of the current object being iterated over.
 * @param {string} dots - If true, the key will be rendered with dots instead of brackets.
 *
 * @returns {string} The path to the current key.
 */
function renderKey(path, key, dots) {
  if (!path) return key;
  return path.concat(key).map(function each(token, i) {
    // eslint-disable-next-line no-param-reassign
    token = removeBrackets(token);
    return !dots && i ? '[' + token + ']' : token;
  }).join(dots ? '.' : '');
}

/**
 * If the array is an array and none of its elements are visitable, then it's a flat array.
 *
 * @param {Array<any>} arr - The array to check
 *
 * @returns {boolean}
 */
function isFlatArray(arr) {
  return utils.isArray(arr) && !arr.some(isVisitable);
}

const predicates = utils.toFlatObject(utils, {}, null, function filter(prop) {
  return /^is[A-Z]/.test(prop);
});

/**
 * If the thing is a FormData object, return true, otherwise return false.
 *
 * @param {unknown} thing - The thing to check.
 *
 * @returns {boolean}
 */
function isSpecCompliant(thing) {
  return thing && utils.isFunction(thing.append) && thing[Symbol.toStringTag] === 'FormData' && thing[Symbol.iterator];
}

/**
 * Convert a data object to FormData
 *
 * @param {Object} obj
 * @param {?Object} [formData]
 * @param {?Object} [options]
 * @param {Function} [options.visitor]
 * @param {Boolean} [options.metaTokens = true]
 * @param {Boolean} [options.dots = false]
 * @param {?Boolean} [options.indexes = false]
 *
 * @returns {Object}
 **/

/**
 * It converts an object into a FormData object
 *
 * @param {Object<any, any>} obj - The object to convert to form data.
 * @param {string} formData - The FormData object to append to.
 * @param {Object<string, any>} options
 *
 * @returns
 */
function toFormData(obj, formData, options) {
  if (!utils.isObject(obj)) {
    throw new TypeError('target must be an object');
  }

  // eslint-disable-next-line no-param-reassign
  formData = formData || new (classes_FormData || FormData)();

  // eslint-disable-next-line no-param-reassign
  options = utils.toFlatObject(options, {
    metaTokens: true,
    dots: false,
    indexes: false
  }, false, function defined(option, source) {
    // eslint-disable-next-line no-eq-null,eqeqeq
    return !utils.isUndefined(source[option]);
  });

  const metaTokens = options.metaTokens;
  // eslint-disable-next-line no-use-before-define
  const visitor = options.visitor || defaultVisitor;
  const dots = options.dots;
  const indexes = options.indexes;
  const _Blob = options.Blob || typeof Blob !== 'undefined' && Blob;
  const useBlob = _Blob && isSpecCompliant(formData);

  if (!utils.isFunction(visitor)) {
    throw new TypeError('visitor must be a function');
  }

  function convertValue(value) {
    if (value === null) return '';

    if (utils.isDate(value)) {
      return value.toISOString();
    }

    if (!useBlob && utils.isBlob(value)) {
      throw new core_AxiosError('Blob is not supported. Use a Buffer instead.');
    }

    if (utils.isArrayBuffer(value) || utils.isTypedArray(value)) {
      return useBlob && typeof Blob === 'function' ? new Blob([value]) : Buffer.from(value);
    }

    return value;
  }

  /**
   * Default visitor.
   *
   * @param {*} value
   * @param {String|Number} key
   * @param {Array<String|Number>} path
   * @this {FormData}
   *
   * @returns {boolean} return true to visit the each prop of the value recursively
   */
  function defaultVisitor(value, key, path) {
    let arr = value;

    if (value && !path && typeof value === 'object') {
      if (utils.endsWith(key, '{}')) {
        // eslint-disable-next-line no-param-reassign
        key = metaTokens ? key : key.slice(0, -2);
        // eslint-disable-next-line no-param-reassign
        value = JSON.stringify(value);
      } else if (
        (utils.isArray(value) && isFlatArray(value)) ||
        (utils.isFileList(value) || utils.endsWith(key, '[]') && (arr = utils.toArray(value))
        )) {
        // eslint-disable-next-line no-param-reassign
        key = removeBrackets(key);

        arr.forEach(function each(el, index) {
          !(utils.isUndefined(el) || el === null) && formData.append(
            // eslint-disable-next-line no-nested-ternary
            indexes === true ? renderKey([key], index, dots) : (indexes === null ? key : key + '[]'),
            convertValue(el)
          );
        });
        return false;
      }
    }

    if (isVisitable(value)) {
      return true;
    }

    formData.append(renderKey(path, key, dots), convertValue(value));

    return false;
  }

  const stack = [];

  const exposedHelpers = Object.assign(predicates, {
    defaultVisitor,
    convertValue,
    isVisitable
  });

  function build(value, path) {
    if (utils.isUndefined(value)) return;

    if (stack.indexOf(value) !== -1) {
      throw Error('Circular reference detected in ' + path.join('.'));
    }

    stack.push(value);

    utils.forEach(value, function each(el, key) {
      const result = !(utils.isUndefined(el) || el === null) && visitor.call(
        formData, el, utils.isString(key) ? key.trim() : key, path, exposedHelpers
      );

      if (result === true) {
        build(el, path ? path.concat(key) : [key]);
      }
    });

    stack.pop();
  }

  if (!utils.isObject(obj)) {
    throw new TypeError('data must be an object');
  }

  build(obj);

  return formData;
}

/* harmony default export */ var helpers_toFormData = (toFormData);

;// CONCATENATED MODULE: ./node_modules/axios/lib/helpers/AxiosURLSearchParams.js




/**
 * It encodes a string by replacing all characters that are not in the unreserved set with
 * their percent-encoded equivalents
 *
 * @param {string} str - The string to encode.
 *
 * @returns {string} The encoded string.
 */
function encode(str) {
  const charMap = {
    '!': '%21',
    "'": '%27',
    '(': '%28',
    ')': '%29',
    '~': '%7E',
    '%20': '+',
    '%00': '\x00'
  };
  return encodeURIComponent(str).replace(/[!'()~]|%20|%00/g, function replacer(match) {
    return charMap[match];
  });
}

/**
 * It takes a params object and converts it to a FormData object
 *
 * @param {Object<string, any>} params - The parameters to be converted to a FormData object.
 * @param {Object<string, any>} options - The options object passed to the Axios constructor.
 *
 * @returns {void}
 */
function AxiosURLSearchParams(params, options) {
  this._pairs = [];

  params && helpers_toFormData(params, this, options);
}

const AxiosURLSearchParams_prototype = AxiosURLSearchParams.prototype;

AxiosURLSearchParams_prototype.append = function append(name, value) {
  this._pairs.push([name, value]);
};

AxiosURLSearchParams_prototype.toString = function toString(encoder) {
  const _encode = encoder ? function(value) {
    return encoder.call(this, value, encode);
  } : encode;

  return this._pairs.map(function each(pair) {
    return _encode(pair[0]) + '=' + _encode(pair[1]);
  }, '').join('&');
};

/* harmony default export */ var helpers_AxiosURLSearchParams = (AxiosURLSearchParams);

;// CONCATENATED MODULE: ./node_modules/axios/lib/helpers/buildURL.js





/**
 * It replaces all instances of the characters `:`, `$`, `,`, `+`, `[`, and `]` with their
 * URI encoded counterparts
 *
 * @param {string} val The value to be encoded.
 *
 * @returns {string} The encoded value.
 */
function buildURL_encode(val) {
  return encodeURIComponent(val).
    replace(/%3A/gi, ':').
    replace(/%24/g, '$').
    replace(/%2C/gi, ',').
    replace(/%20/g, '+').
    replace(/%5B/gi, '[').
    replace(/%5D/gi, ']');
}

/**
 * Build a URL by appending params to the end
 *
 * @param {string} url The base of the url (e.g., http://www.google.com)
 * @param {object} [params] The params to be appended
 * @param {?object} options
 *
 * @returns {string} The formatted url
 */
function buildURL(url, params, options) {
  /*eslint no-param-reassign:0*/
  if (!params) {
    return url;
  }
  
  const _encode = options && options.encode || buildURL_encode;

  const serializeFn = options && options.serialize;

  let serializedParams;

  if (serializeFn) {
    serializedParams = serializeFn(params, options);
  } else {
    serializedParams = utils.isURLSearchParams(params) ?
      params.toString() :
      new helpers_AxiosURLSearchParams(params, options).toString(_encode);
  }

  if (serializedParams) {
    const hashmarkIndex = url.indexOf("#");

    if (hashmarkIndex !== -1) {
      url = url.slice(0, hashmarkIndex);
    }
    url += (url.indexOf('?') === -1 ? '?' : '&') + serializedParams;
  }

  return url;
}

;// CONCATENATED MODULE: ./node_modules/axios/lib/core/InterceptorManager.js




class InterceptorManager {
  constructor() {
    this.handlers = [];
  }

  /**
   * Add a new interceptor to the stack
   *
   * @param {Function} fulfilled The function to handle `then` for a `Promise`
   * @param {Function} rejected The function to handle `reject` for a `Promise`
   *
   * @return {Number} An ID used to remove interceptor later
   */
  use(fulfilled, rejected, options) {
    this.handlers.push({
      fulfilled,
      rejected,
      synchronous: options ? options.synchronous : false,
      runWhen: options ? options.runWhen : null
    });
    return this.handlers.length - 1;
  }

  /**
   * Remove an interceptor from the stack
   *
   * @param {Number} id The ID that was returned by `use`
   *
   * @returns {Boolean} `true` if the interceptor was removed, `false` otherwise
   */
  eject(id) {
    if (this.handlers[id]) {
      this.handlers[id] = null;
    }
  }

  /**
   * Clear all interceptors from the stack
   *
   * @returns {void}
   */
  clear() {
    if (this.handlers) {
      this.handlers = [];
    }
  }

  /**
   * Iterate over all the registered interceptors
   *
   * This method is particularly useful for skipping over any
   * interceptors that may have become `null` calling `eject`.
   *
   * @param {Function} fn The function to call for each interceptor
   *
   * @returns {void}
   */
  forEach(fn) {
    utils.forEach(this.handlers, function forEachHandler(h) {
      if (h !== null) {
        fn(h);
      }
    });
  }
}

/* harmony default export */ var core_InterceptorManager = (InterceptorManager);

;// CONCATENATED MODULE: ./node_modules/axios/lib/defaults/transitional.js


/* harmony default export */ var defaults_transitional = ({
  silentJSONParsing: true,
  forcedJSONParsing: true,
  clarifyTimeoutError: false
});

;// CONCATENATED MODULE: ./node_modules/axios/lib/platform/browser/classes/URLSearchParams.js



/* harmony default export */ var classes_URLSearchParams = (typeof URLSearchParams !== 'undefined' ? URLSearchParams : helpers_AxiosURLSearchParams);

;// CONCATENATED MODULE: ./node_modules/axios/lib/platform/browser/classes/FormData.js


/* harmony default export */ var browser_classes_FormData = (FormData);

;// CONCATENATED MODULE: ./node_modules/axios/lib/platform/browser/index.js



/**
 * Determine if we're running in a standard browser environment
 *
 * This allows axios to run in a web worker, and react-native.
 * Both environments support XMLHttpRequest, but not fully standard globals.
 *
 * web workers:
 *  typeof window -> undefined
 *  typeof document -> undefined
 *
 * react-native:
 *  navigator.product -> 'ReactNative'
 * nativescript
 *  navigator.product -> 'NativeScript' or 'NS'
 *
 * @returns {boolean}
 */
const isStandardBrowserEnv = (() => {
  let product;
  if (typeof navigator !== 'undefined' && (
    (product = navigator.product) === 'ReactNative' ||
    product === 'NativeScript' ||
    product === 'NS')
  ) {
    return false;
  }

  return typeof window !== 'undefined' && typeof document !== 'undefined';
})();

/* harmony default export */ var platform_browser = ({
  isBrowser: true,
  classes: {
    URLSearchParams: classes_URLSearchParams,
    FormData: browser_classes_FormData,
    Blob
  },
  isStandardBrowserEnv,
  protocols: ['http', 'https', 'file', 'blob', 'url', 'data']
});

;// CONCATENATED MODULE: ./node_modules/axios/lib/helpers/toURLEncodedForm.js






function toURLEncodedForm(data, options) {
  return helpers_toFormData(data, new platform_browser.classes.URLSearchParams(), Object.assign({
    visitor: function(value, key, path, helpers) {
      if (platform_browser.isNode && utils.isBuffer(value)) {
        this.append(key, value.toString('base64'));
        return false;
      }

      return helpers.defaultVisitor.apply(this, arguments);
    }
  }, options));
}

;// CONCATENATED MODULE: ./node_modules/axios/lib/helpers/formDataToJSON.js




/**
 * It takes a string like `foo[x][y][z]` and returns an array like `['foo', 'x', 'y', 'z']
 *
 * @param {string} name - The name of the property to get.
 *
 * @returns An array of strings.
 */
function parsePropPath(name) {
  // foo[x][y][z]
  // foo.x.y.z
  // foo-x-y-z
  // foo x y z
  return utils.matchAll(/\w+|\[(\w*)]/g, name).map(match => {
    return match[0] === '[]' ? '' : match[1] || match[0];
  });
}

/**
 * Convert an array to an object.
 *
 * @param {Array<any>} arr - The array to convert to an object.
 *
 * @returns An object with the same keys and values as the array.
 */
function arrayToObject(arr) {
  const obj = {};
  const keys = Object.keys(arr);
  let i;
  const len = keys.length;
  let key;
  for (i = 0; i < len; i++) {
    key = keys[i];
    obj[key] = arr[key];
  }
  return obj;
}

/**
 * It takes a FormData object and returns a JavaScript object
 *
 * @param {string} formData The FormData object to convert to JSON.
 *
 * @returns {Object<string, any> | null} The converted object.
 */
function formDataToJSON(formData) {
  function buildPath(path, value, target, index) {
    let name = path[index++];
    const isNumericKey = Number.isFinite(+name);
    const isLast = index >= path.length;
    name = !name && utils.isArray(target) ? target.length : name;

    if (isLast) {
      if (utils.hasOwnProp(target, name)) {
        target[name] = [target[name], value];
      } else {
        target[name] = value;
      }

      return !isNumericKey;
    }

    if (!target[name] || !utils.isObject(target[name])) {
      target[name] = [];
    }

    const result = buildPath(path, value, target[name], index);

    if (result && utils.isArray(target[name])) {
      target[name] = arrayToObject(target[name]);
    }

    return !isNumericKey;
  }

  if (utils.isFormData(formData) && utils.isFunction(formData.entries)) {
    const obj = {};

    utils.forEachEntry(formData, (name, value) => {
      buildPath(parsePropPath(name), value, obj, 0);
    });

    return obj;
  }

  return null;
}

/* harmony default export */ var helpers_formDataToJSON = (formDataToJSON);

;// CONCATENATED MODULE: ./node_modules/axios/lib/defaults/index.js










const DEFAULT_CONTENT_TYPE = {
  'Content-Type': undefined
};

/**
 * It takes a string, tries to parse it, and if it fails, it returns the stringified version
 * of the input
 *
 * @param {any} rawValue - The value to be stringified.
 * @param {Function} parser - A function that parses a string into a JavaScript object.
 * @param {Function} encoder - A function that takes a value and returns a string.
 *
 * @returns {string} A stringified version of the rawValue.
 */
function stringifySafely(rawValue, parser, encoder) {
  if (utils.isString(rawValue)) {
    try {
      (parser || JSON.parse)(rawValue);
      return utils.trim(rawValue);
    } catch (e) {
      if (e.name !== 'SyntaxError') {
        throw e;
      }
    }
  }

  return (encoder || JSON.stringify)(rawValue);
}

const defaults = {

  transitional: defaults_transitional,

  adapter: ['xhr', 'http'],

  transformRequest: [function transformRequest(data, headers) {
    const contentType = headers.getContentType() || '';
    const hasJSONContentType = contentType.indexOf('application/json') > -1;
    const isObjectPayload = utils.isObject(data);

    if (isObjectPayload && utils.isHTMLForm(data)) {
      data = new FormData(data);
    }

    const isFormData = utils.isFormData(data);

    if (isFormData) {
      if (!hasJSONContentType) {
        return data;
      }
      return hasJSONContentType ? JSON.stringify(helpers_formDataToJSON(data)) : data;
    }

    if (utils.isArrayBuffer(data) ||
      utils.isBuffer(data) ||
      utils.isStream(data) ||
      utils.isFile(data) ||
      utils.isBlob(data)
    ) {
      return data;
    }
    if (utils.isArrayBufferView(data)) {
      return data.buffer;
    }
    if (utils.isURLSearchParams(data)) {
      headers.setContentType('application/x-www-form-urlencoded;charset=utf-8', false);
      return data.toString();
    }

    let isFileList;

    if (isObjectPayload) {
      if (contentType.indexOf('application/x-www-form-urlencoded') > -1) {
        return toURLEncodedForm(data, this.formSerializer).toString();
      }

      if ((isFileList = utils.isFileList(data)) || contentType.indexOf('multipart/form-data') > -1) {
        const _FormData = this.env && this.env.FormData;

        return helpers_toFormData(
          isFileList ? {'files[]': data} : data,
          _FormData && new _FormData(),
          this.formSerializer
        );
      }
    }

    if (isObjectPayload || hasJSONContentType ) {
      headers.setContentType('application/json', false);
      return stringifySafely(data);
    }

    return data;
  }],

  transformResponse: [function transformResponse(data) {
    const transitional = this.transitional || defaults.transitional;
    const forcedJSONParsing = transitional && transitional.forcedJSONParsing;
    const JSONRequested = this.responseType === 'json';

    if (data && utils.isString(data) && ((forcedJSONParsing && !this.responseType) || JSONRequested)) {
      const silentJSONParsing = transitional && transitional.silentJSONParsing;
      const strictJSONParsing = !silentJSONParsing && JSONRequested;

      try {
        return JSON.parse(data);
      } catch (e) {
        if (strictJSONParsing) {
          if (e.name === 'SyntaxError') {
            throw core_AxiosError.from(e, core_AxiosError.ERR_BAD_RESPONSE, this, null, this.response);
          }
          throw e;
        }
      }
    }

    return data;
  }],

  /**
   * A timeout in milliseconds to abort a request. If set to 0 (default) a
   * timeout is not created.
   */
  timeout: 0,

  xsrfCookieName: 'XSRF-TOKEN',
  xsrfHeaderName: 'X-XSRF-TOKEN',

  maxContentLength: -1,
  maxBodyLength: -1,

  env: {
    FormData: platform_browser.classes.FormData,
    Blob: platform_browser.classes.Blob
  },

  validateStatus: function validateStatus(status) {
    return status >= 200 && status < 300;
  },

  headers: {
    common: {
      'Accept': 'application/json, text/plain, */*'
    }
  }
};

utils.forEach(['delete', 'get', 'head'], function forEachMethodNoData(method) {
  defaults.headers[method] = {};
});

utils.forEach(['post', 'put', 'patch'], function forEachMethodWithData(method) {
  defaults.headers[method] = utils.merge(DEFAULT_CONTENT_TYPE);
});

/* harmony default export */ var lib_defaults = (defaults);

;// CONCATENATED MODULE: ./node_modules/axios/lib/helpers/parseHeaders.js




// RawAxiosHeaders whose duplicates are ignored by node
// c.f. https://nodejs.org/api/http.html#http_message_headers
const ignoreDuplicateOf = utils.toObjectSet([
  'age', 'authorization', 'content-length', 'content-type', 'etag',
  'expires', 'from', 'host', 'if-modified-since', 'if-unmodified-since',
  'last-modified', 'location', 'max-forwards', 'proxy-authorization',
  'referer', 'retry-after', 'user-agent'
]);

/**
 * Parse headers into an object
 *
 * ```
 * Date: Wed, 27 Aug 2014 08:58:49 GMT
 * Content-Type: application/json
 * Connection: keep-alive
 * Transfer-Encoding: chunked
 * ```
 *
 * @param {String} rawHeaders Headers needing to be parsed
 *
 * @returns {Object} Headers parsed into an object
 */
/* harmony default export */ var parseHeaders = (rawHeaders => {
  const parsed = {};
  let key;
  let val;
  let i;

  rawHeaders && rawHeaders.split('\n').forEach(function parser(line) {
    i = line.indexOf(':');
    key = line.substring(0, i).trim().toLowerCase();
    val = line.substring(i + 1).trim();

    if (!key || (parsed[key] && ignoreDuplicateOf[key])) {
      return;
    }

    if (key === 'set-cookie') {
      if (parsed[key]) {
        parsed[key].push(val);
      } else {
        parsed[key] = [val];
      }
    } else {
      parsed[key] = parsed[key] ? parsed[key] + ', ' + val : val;
    }
  });

  return parsed;
});

;// CONCATENATED MODULE: ./node_modules/axios/lib/core/AxiosHeaders.js





const $internals = Symbol('internals');

function normalizeHeader(header) {
  return header && String(header).trim().toLowerCase();
}

function normalizeValue(value) {
  if (value === false || value == null) {
    return value;
  }

  return utils.isArray(value) ? value.map(normalizeValue) : String(value);
}

function parseTokens(str) {
  const tokens = Object.create(null);
  const tokensRE = /([^\s,;=]+)\s*(?:=\s*([^,;]+))?/g;
  let match;

  while ((match = tokensRE.exec(str))) {
    tokens[match[1]] = match[2];
  }

  return tokens;
}

function isValidHeaderName(str) {
  return /^[-_a-zA-Z]+$/.test(str.trim());
}

function matchHeaderValue(context, value, header, filter) {
  if (utils.isFunction(filter)) {
    return filter.call(this, value, header);
  }

  if (!utils.isString(value)) return;

  if (utils.isString(filter)) {
    return value.indexOf(filter) !== -1;
  }

  if (utils.isRegExp(filter)) {
    return filter.test(value);
  }
}

function formatHeader(header) {
  return header.trim()
    .toLowerCase().replace(/([a-z\d])(\w*)/g, (w, char, str) => {
      return char.toUpperCase() + str;
    });
}

function buildAccessors(obj, header) {
  const accessorName = utils.toCamelCase(' ' + header);

  ['get', 'set', 'has'].forEach(methodName => {
    Object.defineProperty(obj, methodName + accessorName, {
      value: function(arg1, arg2, arg3) {
        return this[methodName].call(this, header, arg1, arg2, arg3);
      },
      configurable: true
    });
  });
}

class AxiosHeaders {
  constructor(headers) {
    headers && this.set(headers);
  }

  set(header, valueOrRewrite, rewrite) {
    const self = this;

    function setHeader(_value, _header, _rewrite) {
      const lHeader = normalizeHeader(_header);

      if (!lHeader) {
        throw new Error('header name must be a non-empty string');
      }

      const key = utils.findKey(self, lHeader);

      if(!key || self[key] === undefined || _rewrite === true || (_rewrite === undefined && self[key] !== false)) {
        self[key || _header] = normalizeValue(_value);
      }
    }

    const setHeaders = (headers, _rewrite) =>
      utils.forEach(headers, (_value, _header) => setHeader(_value, _header, _rewrite));

    if (utils.isPlainObject(header) || header instanceof this.constructor) {
      setHeaders(header, valueOrRewrite)
    } else if(utils.isString(header) && (header = header.trim()) && !isValidHeaderName(header)) {
      setHeaders(parseHeaders(header), valueOrRewrite);
    } else {
      header != null && setHeader(valueOrRewrite, header, rewrite);
    }

    return this;
  }

  get(header, parser) {
    header = normalizeHeader(header);

    if (header) {
      const key = utils.findKey(this, header);

      if (key) {
        const value = this[key];

        if (!parser) {
          return value;
        }

        if (parser === true) {
          return parseTokens(value);
        }

        if (utils.isFunction(parser)) {
          return parser.call(this, value, key);
        }

        if (utils.isRegExp(parser)) {
          return parser.exec(value);
        }

        throw new TypeError('parser must be boolean|regexp|function');
      }
    }
  }

  has(header, matcher) {
    header = normalizeHeader(header);

    if (header) {
      const key = utils.findKey(this, header);

      return !!(key && (!matcher || matchHeaderValue(this, this[key], key, matcher)));
    }

    return false;
  }

  delete(header, matcher) {
    const self = this;
    let deleted = false;

    function deleteHeader(_header) {
      _header = normalizeHeader(_header);

      if (_header) {
        const key = utils.findKey(self, _header);

        if (key && (!matcher || matchHeaderValue(self, self[key], key, matcher))) {
          delete self[key];

          deleted = true;
        }
      }
    }

    if (utils.isArray(header)) {
      header.forEach(deleteHeader);
    } else {
      deleteHeader(header);
    }

    return deleted;
  }

  clear() {
    return Object.keys(this).forEach(this.delete.bind(this));
  }

  normalize(format) {
    const self = this;
    const headers = {};

    utils.forEach(this, (value, header) => {
      const key = utils.findKey(headers, header);

      if (key) {
        self[key] = normalizeValue(value);
        delete self[header];
        return;
      }

      const normalized = format ? formatHeader(header) : String(header).trim();

      if (normalized !== header) {
        delete self[header];
      }

      self[normalized] = normalizeValue(value);

      headers[normalized] = true;
    });

    return this;
  }

  concat(...targets) {
    return this.constructor.concat(this, ...targets);
  }

  toJSON(asStrings) {
    const obj = Object.create(null);

    utils.forEach(this, (value, header) => {
      value != null && value !== false && (obj[header] = asStrings && utils.isArray(value) ? value.join(', ') : value);
    });

    return obj;
  }

  [Symbol.iterator]() {
    return Object.entries(this.toJSON())[Symbol.iterator]();
  }

  toString() {
    return Object.entries(this.toJSON()).map(([header, value]) => header + ': ' + value).join('\n');
  }

  get [Symbol.toStringTag]() {
    return 'AxiosHeaders';
  }

  static from(thing) {
    return thing instanceof this ? thing : new this(thing);
  }

  static concat(first, ...targets) {
    const computed = new this(first);

    targets.forEach((target) => computed.set(target));

    return computed;
  }

  static accessor(header) {
    const internals = this[$internals] = (this[$internals] = {
      accessors: {}
    });

    const accessors = internals.accessors;
    const prototype = this.prototype;

    function defineAccessor(_header) {
      const lHeader = normalizeHeader(_header);

      if (!accessors[lHeader]) {
        buildAccessors(prototype, _header);
        accessors[lHeader] = true;
      }
    }

    utils.isArray(header) ? header.forEach(defineAccessor) : defineAccessor(header);

    return this;
  }
}

AxiosHeaders.accessor(['Content-Type', 'Content-Length', 'Accept', 'Accept-Encoding', 'User-Agent']);

utils.freezeMethods(AxiosHeaders.prototype);
utils.freezeMethods(AxiosHeaders);

/* harmony default export */ var core_AxiosHeaders = (AxiosHeaders);

;// CONCATENATED MODULE: ./node_modules/axios/lib/core/transformData.js






/**
 * Transform the data for a request or a response
 *
 * @param {Array|Function} fns A single function or Array of functions
 * @param {?Object} response The response object
 *
 * @returns {*} The resulting transformed data
 */
function transformData(fns, response) {
  const config = this || lib_defaults;
  const context = response || config;
  const headers = core_AxiosHeaders.from(context.headers);
  let data = context.data;

  utils.forEach(fns, function transform(fn) {
    data = fn.call(config, data, headers.normalize(), response ? response.status : undefined);
  });

  headers.normalize();

  return data;
}

;// CONCATENATED MODULE: ./node_modules/axios/lib/cancel/isCancel.js


function isCancel(value) {
  return !!(value && value.__CANCEL__);
}

;// CONCATENATED MODULE: ./node_modules/axios/lib/cancel/CanceledError.js





/**
 * A `CanceledError` is an object that is thrown when an operation is canceled.
 *
 * @param {string=} message The message.
 * @param {Object=} config The config.
 * @param {Object=} request The request.
 *
 * @returns {CanceledError} The created error.
 */
function CanceledError(message, config, request) {
  // eslint-disable-next-line no-eq-null,eqeqeq
  core_AxiosError.call(this, message == null ? 'canceled' : message, core_AxiosError.ERR_CANCELED, config, request);
  this.name = 'CanceledError';
}

utils.inherits(CanceledError, core_AxiosError, {
  __CANCEL__: true
});

/* harmony default export */ var cancel_CanceledError = (CanceledError);

;// CONCATENATED MODULE: ./node_modules/axios/lib/helpers/null.js
// eslint-disable-next-line strict
/* harmony default export */ var helpers_null = (null);

;// CONCATENATED MODULE: ./node_modules/axios/lib/core/settle.js




/**
 * Resolve or reject a Promise based on response status.
 *
 * @param {Function} resolve A function that resolves the promise.
 * @param {Function} reject A function that rejects the promise.
 * @param {object} response The response.
 *
 * @returns {object} The response.
 */
function settle(resolve, reject, response) {
  const validateStatus = response.config.validateStatus;
  if (!response.status || !validateStatus || validateStatus(response.status)) {
    resolve(response);
  } else {
    reject(new core_AxiosError(
      'Request failed with status code ' + response.status,
      [core_AxiosError.ERR_BAD_REQUEST, core_AxiosError.ERR_BAD_RESPONSE][Math.floor(response.status / 100) - 4],
      response.config,
      response.request,
      response
    ));
  }
}

;// CONCATENATED MODULE: ./node_modules/axios/lib/helpers/cookies.js





/* harmony default export */ var cookies = (platform_browser.isStandardBrowserEnv ?

// Standard browser envs support document.cookie
  (function standardBrowserEnv() {
    return {
      write: function write(name, value, expires, path, domain, secure) {
        const cookie = [];
        cookie.push(name + '=' + encodeURIComponent(value));

        if (utils.isNumber(expires)) {
          cookie.push('expires=' + new Date(expires).toGMTString());
        }

        if (utils.isString(path)) {
          cookie.push('path=' + path);
        }

        if (utils.isString(domain)) {
          cookie.push('domain=' + domain);
        }

        if (secure === true) {
          cookie.push('secure');
        }

        document.cookie = cookie.join('; ');
      },

      read: function read(name) {
        const match = document.cookie.match(new RegExp('(^|;\\s*)(' + name + ')=([^;]*)'));
        return (match ? decodeURIComponent(match[3]) : null);
      },

      remove: function remove(name) {
        this.write(name, '', Date.now() - 86400000);
      }
    };
  })() :

// Non standard browser env (web workers, react-native) lack needed support.
  (function nonStandardBrowserEnv() {
    return {
      write: function write() {},
      read: function read() { return null; },
      remove: function remove() {}
    };
  })());

;// CONCATENATED MODULE: ./node_modules/axios/lib/helpers/isAbsoluteURL.js


/**
 * Determines whether the specified URL is absolute
 *
 * @param {string} url The URL to test
 *
 * @returns {boolean} True if the specified URL is absolute, otherwise false
 */
function isAbsoluteURL(url) {
  // A URL is considered absolute if it begins with "<scheme>://" or "//" (protocol-relative URL).
  // RFC 3986 defines scheme name as a sequence of characters beginning with a letter and followed
  // by any combination of letters, digits, plus, period, or hyphen.
  return /^([a-z][a-z\d+\-.]*:)?\/\//i.test(url);
}

;// CONCATENATED MODULE: ./node_modules/axios/lib/helpers/combineURLs.js


/**
 * Creates a new URL by combining the specified URLs
 *
 * @param {string} baseURL The base URL
 * @param {string} relativeURL The relative URL
 *
 * @returns {string} The combined URL
 */
function combineURLs(baseURL, relativeURL) {
  return relativeURL
    ? baseURL.replace(/\/+$/, '') + '/' + relativeURL.replace(/^\/+/, '')
    : baseURL;
}

;// CONCATENATED MODULE: ./node_modules/axios/lib/core/buildFullPath.js





/**
 * Creates a new URL by combining the baseURL with the requestedURL,
 * only when the requestedURL is not already an absolute URL.
 * If the requestURL is absolute, this function returns the requestedURL untouched.
 *
 * @param {string} baseURL The base URL
 * @param {string} requestedURL Absolute or relative URL to combine
 *
 * @returns {string} The combined full path
 */
function buildFullPath(baseURL, requestedURL) {
  if (baseURL && !isAbsoluteURL(requestedURL)) {
    return combineURLs(baseURL, requestedURL);
  }
  return requestedURL;
}

;// CONCATENATED MODULE: ./node_modules/axios/lib/helpers/isURLSameOrigin.js





/* harmony default export */ var isURLSameOrigin = (platform_browser.isStandardBrowserEnv ?

// Standard browser envs have full support of the APIs needed to test
// whether the request URL is of the same origin as current location.
  (function standardBrowserEnv() {
    const msie = /(msie|trident)/i.test(navigator.userAgent);
    const urlParsingNode = document.createElement('a');
    let originURL;

    /**
    * Parse a URL to discover it's components
    *
    * @param {String} url The URL to be parsed
    * @returns {Object}
    */
    function resolveURL(url) {
      let href = url;

      if (msie) {
        // IE needs attribute set twice to normalize properties
        urlParsingNode.setAttribute('href', href);
        href = urlParsingNode.href;
      }

      urlParsingNode.setAttribute('href', href);

      // urlParsingNode provides the UrlUtils interface - http://url.spec.whatwg.org/#urlutils
      return {
        href: urlParsingNode.href,
        protocol: urlParsingNode.protocol ? urlParsingNode.protocol.replace(/:$/, '') : '',
        host: urlParsingNode.host,
        search: urlParsingNode.search ? urlParsingNode.search.replace(/^\?/, '') : '',
        hash: urlParsingNode.hash ? urlParsingNode.hash.replace(/^#/, '') : '',
        hostname: urlParsingNode.hostname,
        port: urlParsingNode.port,
        pathname: (urlParsingNode.pathname.charAt(0) === '/') ?
          urlParsingNode.pathname :
          '/' + urlParsingNode.pathname
      };
    }

    originURL = resolveURL(window.location.href);

    /**
    * Determine if a URL shares the same origin as the current location
    *
    * @param {String} requestURL The URL to test
    * @returns {boolean} True if URL shares the same origin, otherwise false
    */
    return function isURLSameOrigin(requestURL) {
      const parsed = (utils.isString(requestURL)) ? resolveURL(requestURL) : requestURL;
      return (parsed.protocol === originURL.protocol &&
          parsed.host === originURL.host);
    };
  })() :

  // Non standard browser envs (web workers, react-native) lack needed support.
  (function nonStandardBrowserEnv() {
    return function isURLSameOrigin() {
      return true;
    };
  })());

;// CONCATENATED MODULE: ./node_modules/axios/lib/helpers/parseProtocol.js


function parseProtocol(url) {
  const match = /^([-+\w]{1,25})(:?\/\/|:)/.exec(url);
  return match && match[1] || '';
}

;// CONCATENATED MODULE: ./node_modules/axios/lib/helpers/speedometer.js


/**
 * Calculate data maxRate
 * @param {Number} [samplesCount= 10]
 * @param {Number} [min= 1000]
 * @returns {Function}
 */
function speedometer(samplesCount, min) {
  samplesCount = samplesCount || 10;
  const bytes = new Array(samplesCount);
  const timestamps = new Array(samplesCount);
  let head = 0;
  let tail = 0;
  let firstSampleTS;

  min = min !== undefined ? min : 1000;

  return function push(chunkLength) {
    const now = Date.now();

    const startedAt = timestamps[tail];

    if (!firstSampleTS) {
      firstSampleTS = now;
    }

    bytes[head] = chunkLength;
    timestamps[head] = now;

    let i = tail;
    let bytesCount = 0;

    while (i !== head) {
      bytesCount += bytes[i++];
      i = i % samplesCount;
    }

    head = (head + 1) % samplesCount;

    if (head === tail) {
      tail = (tail + 1) % samplesCount;
    }

    if (now - firstSampleTS < min) {
      return;
    }

    const passed = startedAt && now - startedAt;

    return  passed ? Math.round(bytesCount * 1000 / passed) : undefined;
  };
}

/* harmony default export */ var helpers_speedometer = (speedometer);

;// CONCATENATED MODULE: ./node_modules/axios/lib/adapters/xhr.js
















function progressEventReducer(listener, isDownloadStream) {
  let bytesNotified = 0;
  const _speedometer = helpers_speedometer(50, 250);

  return e => {
    const loaded = e.loaded;
    const total = e.lengthComputable ? e.total : undefined;
    const progressBytes = loaded - bytesNotified;
    const rate = _speedometer(progressBytes);
    const inRange = loaded <= total;

    bytesNotified = loaded;

    const data = {
      loaded,
      total,
      progress: total ? (loaded / total) : undefined,
      bytes: progressBytes,
      rate: rate ? rate : undefined,
      estimated: rate && total && inRange ? (total - loaded) / rate : undefined,
      event: e
    };

    data[isDownloadStream ? 'download' : 'upload'] = true;

    listener(data);
  };
}

const isXHRAdapterSupported = typeof XMLHttpRequest !== 'undefined';

/* harmony default export */ var xhr = (isXHRAdapterSupported && function (config) {
  return new Promise(function dispatchXhrRequest(resolve, reject) {
    let requestData = config.data;
    const requestHeaders = core_AxiosHeaders.from(config.headers).normalize();
    const responseType = config.responseType;
    let onCanceled;
    function done() {
      if (config.cancelToken) {
        config.cancelToken.unsubscribe(onCanceled);
      }

      if (config.signal) {
        config.signal.removeEventListener('abort', onCanceled);
      }
    }

    if (utils.isFormData(requestData) && platform_browser.isStandardBrowserEnv) {
      requestHeaders.setContentType(false); // Let the browser set it
    }

    let request = new XMLHttpRequest();

    // HTTP basic authentication
    if (config.auth) {
      const username = config.auth.username || '';
      const password = config.auth.password ? unescape(encodeURIComponent(config.auth.password)) : '';
      requestHeaders.set('Authorization', 'Basic ' + btoa(username + ':' + password));
    }

    const fullPath = buildFullPath(config.baseURL, config.url);

    request.open(config.method.toUpperCase(), buildURL(fullPath, config.params, config.paramsSerializer), true);

    // Set the request timeout in MS
    request.timeout = config.timeout;

    function onloadend() {
      if (!request) {
        return;
      }
      // Prepare the response
      const responseHeaders = core_AxiosHeaders.from(
        'getAllResponseHeaders' in request && request.getAllResponseHeaders()
      );
      const responseData = !responseType || responseType === 'text' ||  responseType === 'json' ?
        request.responseText : request.response;
      const response = {
        data: responseData,
        status: request.status,
        statusText: request.statusText,
        headers: responseHeaders,
        config,
        request
      };

      settle(function _resolve(value) {
        resolve(value);
        done();
      }, function _reject(err) {
        reject(err);
        done();
      }, response);

      // Clean up request
      request = null;
    }

    if ('onloadend' in request) {
      // Use onloadend if available
      request.onloadend = onloadend;
    } else {
      // Listen for ready state to emulate onloadend
      request.onreadystatechange = function handleLoad() {
        if (!request || request.readyState !== 4) {
          return;
        }

        // The request errored out and we didn't get a response, this will be
        // handled by onerror instead
        // With one exception: request that using file: protocol, most browsers
        // will return status as 0 even though it's a successful request
        if (request.status === 0 && !(request.responseURL && request.responseURL.indexOf('file:') === 0)) {
          return;
        }
        // readystate handler is calling before onerror or ontimeout handlers,
        // so we should call onloadend on the next 'tick'
        setTimeout(onloadend);
      };
    }

    // Handle browser request cancellation (as opposed to a manual cancellation)
    request.onabort = function handleAbort() {
      if (!request) {
        return;
      }

      reject(new core_AxiosError('Request aborted', core_AxiosError.ECONNABORTED, config, request));

      // Clean up request
      request = null;
    };

    // Handle low level network errors
    request.onerror = function handleError() {
      // Real errors are hidden from us by the browser
      // onerror should only fire if it's a network error
      reject(new core_AxiosError('Network Error', core_AxiosError.ERR_NETWORK, config, request));

      // Clean up request
      request = null;
    };

    // Handle timeout
    request.ontimeout = function handleTimeout() {
      let timeoutErrorMessage = config.timeout ? 'timeout of ' + config.timeout + 'ms exceeded' : 'timeout exceeded';
      const transitional = config.transitional || defaults_transitional;
      if (config.timeoutErrorMessage) {
        timeoutErrorMessage = config.timeoutErrorMessage;
      }
      reject(new core_AxiosError(
        timeoutErrorMessage,
        transitional.clarifyTimeoutError ? core_AxiosError.ETIMEDOUT : core_AxiosError.ECONNABORTED,
        config,
        request));

      // Clean up request
      request = null;
    };

    // Add xsrf header
    // This is only done if running in a standard browser environment.
    // Specifically not if we're in a web worker, or react-native.
    if (platform_browser.isStandardBrowserEnv) {
      // Add xsrf header
      const xsrfValue = (config.withCredentials || isURLSameOrigin(fullPath))
        && config.xsrfCookieName && cookies.read(config.xsrfCookieName);

      if (xsrfValue) {
        requestHeaders.set(config.xsrfHeaderName, xsrfValue);
      }
    }

    // Remove Content-Type if data is undefined
    requestData === undefined && requestHeaders.setContentType(null);

    // Add headers to the request
    if ('setRequestHeader' in request) {
      utils.forEach(requestHeaders.toJSON(), function setRequestHeader(val, key) {
        request.setRequestHeader(key, val);
      });
    }

    // Add withCredentials to request if needed
    if (!utils.isUndefined(config.withCredentials)) {
      request.withCredentials = !!config.withCredentials;
    }

    // Add responseType to request if needed
    if (responseType && responseType !== 'json') {
      request.responseType = config.responseType;
    }

    // Handle progress if needed
    if (typeof config.onDownloadProgress === 'function') {
      request.addEventListener('progress', progressEventReducer(config.onDownloadProgress, true));
    }

    // Not all browsers support upload events
    if (typeof config.onUploadProgress === 'function' && request.upload) {
      request.upload.addEventListener('progress', progressEventReducer(config.onUploadProgress));
    }

    if (config.cancelToken || config.signal) {
      // Handle cancellation
      // eslint-disable-next-line func-names
      onCanceled = cancel => {
        if (!request) {
          return;
        }
        reject(!cancel || cancel.type ? new cancel_CanceledError(null, config, request) : cancel);
        request.abort();
        request = null;
      };

      config.cancelToken && config.cancelToken.subscribe(onCanceled);
      if (config.signal) {
        config.signal.aborted ? onCanceled() : config.signal.addEventListener('abort', onCanceled);
      }
    }

    const protocol = parseProtocol(fullPath);

    if (protocol && platform_browser.protocols.indexOf(protocol) === -1) {
      reject(new core_AxiosError('Unsupported protocol ' + protocol + ':', core_AxiosError.ERR_BAD_REQUEST, config));
      return;
    }


    // Send the request
    request.send(requestData || null);
  });
});

;// CONCATENATED MODULE: ./node_modules/axios/lib/adapters/adapters.js





const knownAdapters = {
  http: helpers_null,
  xhr: xhr
}

utils.forEach(knownAdapters, (fn, value) => {
  if(fn) {
    try {
      Object.defineProperty(fn, 'name', {value});
    } catch (e) {
      // eslint-disable-next-line no-empty
    }
    Object.defineProperty(fn, 'adapterName', {value});
  }
});

/* harmony default export */ var adapters = ({
  getAdapter: (adapters) => {
    adapters = utils.isArray(adapters) ? adapters : [adapters];

    const {length} = adapters;
    let nameOrAdapter;
    let adapter;

    for (let i = 0; i < length; i++) {
      nameOrAdapter = adapters[i];
      if((adapter = utils.isString(nameOrAdapter) ? knownAdapters[nameOrAdapter.toLowerCase()] : nameOrAdapter)) {
        break;
      }
    }

    if (!adapter) {
      if (adapter === false) {
        throw new core_AxiosError(
          `Adapter ${nameOrAdapter} is not supported by the environment`,
          'ERR_NOT_SUPPORT'
        );
      }

      throw new Error(
        utils.hasOwnProp(knownAdapters, nameOrAdapter) ?
          `Adapter '${nameOrAdapter}' is not available in the build` :
          `Unknown adapter '${nameOrAdapter}'`
      );
    }

    if (!utils.isFunction(adapter)) {
      throw new TypeError('adapter is not a function');
    }

    return adapter;
  },
  adapters: knownAdapters
});

;// CONCATENATED MODULE: ./node_modules/axios/lib/core/dispatchRequest.js









/**
 * Throws a `CanceledError` if cancellation has been requested.
 *
 * @param {Object} config The config that is to be used for the request
 *
 * @returns {void}
 */
function throwIfCancellationRequested(config) {
  if (config.cancelToken) {
    config.cancelToken.throwIfRequested();
  }

  if (config.signal && config.signal.aborted) {
    throw new cancel_CanceledError();
  }
}

/**
 * Dispatch a request to the server using the configured adapter.
 *
 * @param {object} config The config that is to be used for the request
 *
 * @returns {Promise} The Promise to be fulfilled
 */
function dispatchRequest(config) {
  throwIfCancellationRequested(config);

  config.headers = core_AxiosHeaders.from(config.headers);

  // Transform request data
  config.data = transformData.call(
    config,
    config.transformRequest
  );

  if (['post', 'put', 'patch'].indexOf(config.method) !== -1) {
    config.headers.setContentType('application/x-www-form-urlencoded', false);
  }

  const adapter = adapters.getAdapter(config.adapter || lib_defaults.adapter);

  return adapter(config).then(function onAdapterResolution(response) {
    throwIfCancellationRequested(config);

    // Transform response data
    response.data = transformData.call(
      config,
      config.transformResponse,
      response
    );

    response.headers = core_AxiosHeaders.from(response.headers);

    return response;
  }, function onAdapterRejection(reason) {
    if (!isCancel(reason)) {
      throwIfCancellationRequested(config);

      // Transform response data
      if (reason && reason.response) {
        reason.response.data = transformData.call(
          config,
          config.transformResponse,
          reason.response
        );
        reason.response.headers = core_AxiosHeaders.from(reason.response.headers);
      }
    }

    return Promise.reject(reason);
  });
}

;// CONCATENATED MODULE: ./node_modules/axios/lib/core/mergeConfig.js





const headersToObject = (thing) => thing instanceof core_AxiosHeaders ? thing.toJSON() : thing;

/**
 * Config-specific merge-function which creates a new config-object
 * by merging two configuration objects together.
 *
 * @param {Object} config1
 * @param {Object} config2
 *
 * @returns {Object} New object resulting from merging config2 to config1
 */
function mergeConfig(config1, config2) {
  // eslint-disable-next-line no-param-reassign
  config2 = config2 || {};
  const config = {};

  function getMergedValue(target, source, caseless) {
    if (utils.isPlainObject(target) && utils.isPlainObject(source)) {
      return utils.merge.call({caseless}, target, source);
    } else if (utils.isPlainObject(source)) {
      return utils.merge({}, source);
    } else if (utils.isArray(source)) {
      return source.slice();
    }
    return source;
  }

  // eslint-disable-next-line consistent-return
  function mergeDeepProperties(a, b, caseless) {
    if (!utils.isUndefined(b)) {
      return getMergedValue(a, b, caseless);
    } else if (!utils.isUndefined(a)) {
      return getMergedValue(undefined, a, caseless);
    }
  }

  // eslint-disable-next-line consistent-return
  function valueFromConfig2(a, b) {
    if (!utils.isUndefined(b)) {
      return getMergedValue(undefined, b);
    }
  }

  // eslint-disable-next-line consistent-return
  function defaultToConfig2(a, b) {
    if (!utils.isUndefined(b)) {
      return getMergedValue(undefined, b);
    } else if (!utils.isUndefined(a)) {
      return getMergedValue(undefined, a);
    }
  }

  // eslint-disable-next-line consistent-return
  function mergeDirectKeys(a, b, prop) {
    if (prop in config2) {
      return getMergedValue(a, b);
    } else if (prop in config1) {
      return getMergedValue(undefined, a);
    }
  }

  const mergeMap = {
    url: valueFromConfig2,
    method: valueFromConfig2,
    data: valueFromConfig2,
    baseURL: defaultToConfig2,
    transformRequest: defaultToConfig2,
    transformResponse: defaultToConfig2,
    paramsSerializer: defaultToConfig2,
    timeout: defaultToConfig2,
    timeoutMessage: defaultToConfig2,
    withCredentials: defaultToConfig2,
    adapter: defaultToConfig2,
    responseType: defaultToConfig2,
    xsrfCookieName: defaultToConfig2,
    xsrfHeaderName: defaultToConfig2,
    onUploadProgress: defaultToConfig2,
    onDownloadProgress: defaultToConfig2,
    decompress: defaultToConfig2,
    maxContentLength: defaultToConfig2,
    maxBodyLength: defaultToConfig2,
    beforeRedirect: defaultToConfig2,
    transport: defaultToConfig2,
    httpAgent: defaultToConfig2,
    httpsAgent: defaultToConfig2,
    cancelToken: defaultToConfig2,
    socketPath: defaultToConfig2,
    responseEncoding: defaultToConfig2,
    validateStatus: mergeDirectKeys,
    headers: (a, b) => mergeDeepProperties(headersToObject(a), headersToObject(b), true)
  };

  utils.forEach(Object.keys(config1).concat(Object.keys(config2)), function computeConfigValue(prop) {
    const merge = mergeMap[prop] || mergeDeepProperties;
    const configValue = merge(config1[prop], config2[prop], prop);
    (utils.isUndefined(configValue) && merge !== mergeDirectKeys) || (config[prop] = configValue);
  });

  return config;
}

;// CONCATENATED MODULE: ./node_modules/axios/lib/env/data.js
const VERSION = "1.2.0";
;// CONCATENATED MODULE: ./node_modules/axios/lib/helpers/validator.js





const validators = {};

// eslint-disable-next-line func-names
['object', 'boolean', 'number', 'function', 'string', 'symbol'].forEach((type, i) => {
  validators[type] = function validator(thing) {
    return typeof thing === type || 'a' + (i < 1 ? 'n ' : ' ') + type;
  };
});

const deprecatedWarnings = {};

/**
 * Transitional option validator
 *
 * @param {function|boolean?} validator - set to false if the transitional option has been removed
 * @param {string?} version - deprecated version / removed since version
 * @param {string?} message - some message with additional info
 *
 * @returns {function}
 */
validators.transitional = function transitional(validator, version, message) {
  function formatMessage(opt, desc) {
    return '[Axios v' + VERSION + '] Transitional option \'' + opt + '\'' + desc + (message ? '. ' + message : '');
  }

  // eslint-disable-next-line func-names
  return (value, opt, opts) => {
    if (validator === false) {
      throw new core_AxiosError(
        formatMessage(opt, ' has been removed' + (version ? ' in ' + version : '')),
        core_AxiosError.ERR_DEPRECATED
      );
    }

    if (version && !deprecatedWarnings[opt]) {
      deprecatedWarnings[opt] = true;
      // eslint-disable-next-line no-console
      console.warn(
        formatMessage(
          opt,
          ' has been deprecated since v' + version + ' and will be removed in the near future'
        )
      );
    }

    return validator ? validator(value, opt, opts) : true;
  };
};

/**
 * Assert object's properties type
 *
 * @param {object} options
 * @param {object} schema
 * @param {boolean?} allowUnknown
 *
 * @returns {object}
 */

function assertOptions(options, schema, allowUnknown) {
  if (typeof options !== 'object') {
    throw new core_AxiosError('options must be an object', core_AxiosError.ERR_BAD_OPTION_VALUE);
  }
  const keys = Object.keys(options);
  let i = keys.length;
  while (i-- > 0) {
    const opt = keys[i];
    const validator = schema[opt];
    if (validator) {
      const value = options[opt];
      const result = value === undefined || validator(value, opt, options);
      if (result !== true) {
        throw new core_AxiosError('option ' + opt + ' must be ' + result, core_AxiosError.ERR_BAD_OPTION_VALUE);
      }
      continue;
    }
    if (allowUnknown !== true) {
      throw new core_AxiosError('Unknown option ' + opt, core_AxiosError.ERR_BAD_OPTION);
    }
  }
}

/* harmony default export */ var validator = ({
  assertOptions,
  validators
});

;// CONCATENATED MODULE: ./node_modules/axios/lib/core/Axios.js











const Axios_validators = validator.validators;

/**
 * Create a new instance of Axios
 *
 * @param {Object} instanceConfig The default config for the instance
 *
 * @return {Axios} A new instance of Axios
 */
class Axios {
  constructor(instanceConfig) {
    this.defaults = instanceConfig;
    this.interceptors = {
      request: new core_InterceptorManager(),
      response: new core_InterceptorManager()
    };
  }

  /**
   * Dispatch a request
   *
   * @param {String|Object} configOrUrl The config specific for this request (merged with this.defaults)
   * @param {?Object} config
   *
   * @returns {Promise} The Promise to be fulfilled
   */
  request(configOrUrl, config) {
    /*eslint no-param-reassign:0*/
    // Allow for axios('example/url'[, config]) a la fetch API
    if (typeof configOrUrl === 'string') {
      config = config || {};
      config.url = configOrUrl;
    } else {
      config = configOrUrl || {};
    }

    config = mergeConfig(this.defaults, config);

    const {transitional, paramsSerializer, headers} = config;

    if (transitional !== undefined) {
      validator.assertOptions(transitional, {
        silentJSONParsing: Axios_validators.transitional(Axios_validators.boolean),
        forcedJSONParsing: Axios_validators.transitional(Axios_validators.boolean),
        clarifyTimeoutError: Axios_validators.transitional(Axios_validators.boolean)
      }, false);
    }

    if (paramsSerializer !== undefined) {
      validator.assertOptions(paramsSerializer, {
        encode: Axios_validators.function,
        serialize: Axios_validators.function
      }, true);
    }

    // Set config.method
    config.method = (config.method || this.defaults.method || 'get').toLowerCase();

    let contextHeaders;

    // Flatten headers
    contextHeaders = headers && utils.merge(
      headers.common,
      headers[config.method]
    );

    contextHeaders && utils.forEach(
      ['delete', 'get', 'head', 'post', 'put', 'patch', 'common'],
      (method) => {
        delete headers[method];
      }
    );

    config.headers = core_AxiosHeaders.concat(contextHeaders, headers);

    // filter out skipped interceptors
    const requestInterceptorChain = [];
    let synchronousRequestInterceptors = true;
    this.interceptors.request.forEach(function unshiftRequestInterceptors(interceptor) {
      if (typeof interceptor.runWhen === 'function' && interceptor.runWhen(config) === false) {
        return;
      }

      synchronousRequestInterceptors = synchronousRequestInterceptors && interceptor.synchronous;

      requestInterceptorChain.unshift(interceptor.fulfilled, interceptor.rejected);
    });

    const responseInterceptorChain = [];
    this.interceptors.response.forEach(function pushResponseInterceptors(interceptor) {
      responseInterceptorChain.push(interceptor.fulfilled, interceptor.rejected);
    });

    let promise;
    let i = 0;
    let len;

    if (!synchronousRequestInterceptors) {
      const chain = [dispatchRequest.bind(this), undefined];
      chain.unshift.apply(chain, requestInterceptorChain);
      chain.push.apply(chain, responseInterceptorChain);
      len = chain.length;

      promise = Promise.resolve(config);

      while (i < len) {
        promise = promise.then(chain[i++], chain[i++]);
      }

      return promise;
    }

    len = requestInterceptorChain.length;

    let newConfig = config;

    i = 0;

    while (i < len) {
      const onFulfilled = requestInterceptorChain[i++];
      const onRejected = requestInterceptorChain[i++];
      try {
        newConfig = onFulfilled(newConfig);
      } catch (error) {
        onRejected.call(this, error);
        break;
      }
    }

    try {
      promise = dispatchRequest.call(this, newConfig);
    } catch (error) {
      return Promise.reject(error);
    }

    i = 0;
    len = responseInterceptorChain.length;

    while (i < len) {
      promise = promise.then(responseInterceptorChain[i++], responseInterceptorChain[i++]);
    }

    return promise;
  }

  getUri(config) {
    config = mergeConfig(this.defaults, config);
    const fullPath = buildFullPath(config.baseURL, config.url);
    return buildURL(fullPath, config.params, config.paramsSerializer);
  }
}

// Provide aliases for supported request methods
utils.forEach(['delete', 'get', 'head', 'options'], function forEachMethodNoData(method) {
  /*eslint func-names:0*/
  Axios.prototype[method] = function(url, config) {
    return this.request(mergeConfig(config || {}, {
      method,
      url,
      data: (config || {}).data
    }));
  };
});

utils.forEach(['post', 'put', 'patch'], function forEachMethodWithData(method) {
  /*eslint func-names:0*/

  function generateHTTPMethod(isForm) {
    return function httpMethod(url, data, config) {
      return this.request(mergeConfig(config || {}, {
        method,
        headers: isForm ? {
          'Content-Type': 'multipart/form-data'
        } : {},
        url,
        data
      }));
    };
  }

  Axios.prototype[method] = generateHTTPMethod();

  Axios.prototype[method + 'Form'] = generateHTTPMethod(true);
});

/* harmony default export */ var core_Axios = (Axios);

;// CONCATENATED MODULE: ./node_modules/axios/lib/cancel/CancelToken.js




/**
 * A `CancelToken` is an object that can be used to request cancellation of an operation.
 *
 * @param {Function} executor The executor function.
 *
 * @returns {CancelToken}
 */
class CancelToken {
  constructor(executor) {
    if (typeof executor !== 'function') {
      throw new TypeError('executor must be a function.');
    }

    let resolvePromise;

    this.promise = new Promise(function promiseExecutor(resolve) {
      resolvePromise = resolve;
    });

    const token = this;

    // eslint-disable-next-line func-names
    this.promise.then(cancel => {
      if (!token._listeners) return;

      let i = token._listeners.length;

      while (i-- > 0) {
        token._listeners[i](cancel);
      }
      token._listeners = null;
    });

    // eslint-disable-next-line func-names
    this.promise.then = onfulfilled => {
      let _resolve;
      // eslint-disable-next-line func-names
      const promise = new Promise(resolve => {
        token.subscribe(resolve);
        _resolve = resolve;
      }).then(onfulfilled);

      promise.cancel = function reject() {
        token.unsubscribe(_resolve);
      };

      return promise;
    };

    executor(function cancel(message, config, request) {
      if (token.reason) {
        // Cancellation has already been requested
        return;
      }

      token.reason = new cancel_CanceledError(message, config, request);
      resolvePromise(token.reason);
    });
  }

  /**
   * Throws a `CanceledError` if cancellation has been requested.
   */
  throwIfRequested() {
    if (this.reason) {
      throw this.reason;
    }
  }

  /**
   * Subscribe to the cancel signal
   */

  subscribe(listener) {
    if (this.reason) {
      listener(this.reason);
      return;
    }

    if (this._listeners) {
      this._listeners.push(listener);
    } else {
      this._listeners = [listener];
    }
  }

  /**
   * Unsubscribe from the cancel signal
   */

  unsubscribe(listener) {
    if (!this._listeners) {
      return;
    }
    const index = this._listeners.indexOf(listener);
    if (index !== -1) {
      this._listeners.splice(index, 1);
    }
  }

  /**
   * Returns an object that contains a new `CancelToken` and a function that, when called,
   * cancels the `CancelToken`.
   */
  static source() {
    let cancel;
    const token = new CancelToken(function executor(c) {
      cancel = c;
    });
    return {
      token,
      cancel
    };
  }
}

/* harmony default export */ var cancel_CancelToken = (CancelToken);

;// CONCATENATED MODULE: ./node_modules/axios/lib/helpers/spread.js


/**
 * Syntactic sugar for invoking a function and expanding an array for arguments.
 *
 * Common use case would be to use `Function.prototype.apply`.
 *
 *  ```js
 *  function f(x, y, z) {}
 *  var args = [1, 2, 3];
 *  f.apply(null, args);
 *  ```
 *
 * With `spread` this example can be re-written.
 *
 *  ```js
 *  spread(function(x, y, z) {})([1, 2, 3]);
 *  ```
 *
 * @param {Function} callback
 *
 * @returns {Function}
 */
function spread(callback) {
  return function wrap(arr) {
    return callback.apply(null, arr);
  };
}

;// CONCATENATED MODULE: ./node_modules/axios/lib/helpers/isAxiosError.js




/**
 * Determines whether the payload is an error thrown by Axios
 *
 * @param {*} payload The value to test
 *
 * @returns {boolean} True if the payload is an error thrown by Axios, otherwise false
 */
function isAxiosError(payload) {
  return utils.isObject(payload) && (payload.isAxiosError === true);
}

;// CONCATENATED MODULE: ./node_modules/axios/lib/axios.js


















/**
 * Create an instance of Axios
 *
 * @param {Object} defaultConfig The default config for the instance
 *
 * @returns {Axios} A new instance of Axios
 */
function createInstance(defaultConfig) {
  const context = new core_Axios(defaultConfig);
  const instance = bind(core_Axios.prototype.request, context);

  // Copy axios.prototype to instance
  utils.extend(instance, core_Axios.prototype, context, {allOwnKeys: true});

  // Copy context to instance
  utils.extend(instance, context, null, {allOwnKeys: true});

  // Factory for creating new instances
  instance.create = function create(instanceConfig) {
    return createInstance(mergeConfig(defaultConfig, instanceConfig));
  };

  return instance;
}

// Create the default instance to be exported
const axios = createInstance(lib_defaults);

// Expose Axios class to allow class inheritance
axios.Axios = core_Axios;

// Expose Cancel & CancelToken
axios.CanceledError = cancel_CanceledError;
axios.CancelToken = cancel_CancelToken;
axios.isCancel = isCancel;
axios.VERSION = VERSION;
axios.toFormData = helpers_toFormData;

// Expose AxiosError class
axios.AxiosError = core_AxiosError;

// alias for CanceledError for backward compatibility
axios.Cancel = axios.CanceledError;

// Expose all/spread
axios.all = function all(promises) {
  return Promise.all(promises);
};

axios.spread = spread;

// Expose isAxiosError
axios.isAxiosError = isAxiosError;

axios.AxiosHeaders = core_AxiosHeaders;

axios.formToJSON = thing => helpers_formDataToJSON(utils.isHTMLForm(thing) ? new FormData(thing) : thing);

axios.default = axios;

// this module should only have a default export
/* harmony default export */ var lib_axios = (axios);


/***/ }),

/***/ 12003:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "j": function() { return /* binding */ cva; }
/* harmony export */ });
/* unused harmony export cx */
/* harmony import */ var clsx__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(90512);

const falsyToString = (value)=>typeof value === "boolean" ? "".concat(value) : value === 0 ? "0" : value;
const cx = clsx__WEBPACK_IMPORTED_MODULE_0__/* .clsx */ .W;
const cva = (base, config)=>{
    return (props)=>{
        var ref;
        if ((config === null || config === void 0 ? void 0 : config.variants) == null) return cx(base, props === null || props === void 0 ? void 0 : props.class, props === null || props === void 0 ? void 0 : props.className);
        const { variants , defaultVariants  } = config;
        const getVariantClassNames = Object.keys(variants).map((variant)=>{
            const variantProp = props === null || props === void 0 ? void 0 : props[variant];
            const defaultVariantProp = defaultVariants === null || defaultVariants === void 0 ? void 0 : defaultVariants[variant];
            if (variantProp === null) return null;
            const variantKey = falsyToString(variantProp) || falsyToString(defaultVariantProp);
            return variants[variant][variantKey];
        });
        const propsWithoutUndefined = props && Object.entries(props).reduce((acc, param)=>{
            let [key, value] = param;
            if (value === undefined) {
                return acc;
            }
            acc[key] = value;
            return acc;
        }, {});
        const getCompoundVariantClassNames = config === null || config === void 0 ? void 0 : (ref = config.compoundVariants) === null || ref === void 0 ? void 0 : ref.reduce((acc, param1)=>{
            let { class: cvClass , className: cvClassName , ...compoundVariantOptions } = param1;
            return Object.entries(compoundVariantOptions).every((param)=>{
                let [key, value] = param;
                return Array.isArray(value) ? value.includes({
                    ...defaultVariants,
                    ...propsWithoutUndefined
                }[key]) : ({
                    ...defaultVariants,
                    ...propsWithoutUndefined
                })[key] === value;
            }) ? [
                ...acc,
                cvClass,
                cvClassName
            ] : acc;
        }, []);
        return cx(base, getVariantClassNames, getCompoundVariantClassNames, props === null || props === void 0 ? void 0 : props.class, props === null || props === void 0 ? void 0 : props.className);
    };
};


//# sourceMappingURL=index.mjs.map

/***/ }),

/***/ 90512:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "W": function() { return /* binding */ clsx; }
/* harmony export */ });
function r(e){var t,f,n="";if("string"==typeof e||"number"==typeof e)n+=e;else if("object"==typeof e)if(Array.isArray(e))for(t=0;t<e.length;t++)e[t]&&(f=r(e[t]))&&(n&&(n+=" "),n+=f);else for(t in e)e[t]&&(n&&(n+=" "),n+=t);return n}function clsx(){for(var e,t,f=0,n="";f<arguments.length;)(e=arguments[f++])&&(t=r(e))&&(n&&(n+=" "),n+=t);return n}/* unused harmony default export */ var __WEBPACK_DEFAULT_EXPORT__ = ((/* unused pure expression or super */ null && (clsx)));

/***/ }),

/***/ 61202:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "o": function() { return /* binding */ jwtDecode; }
/* harmony export */ });
/* unused harmony export InvalidTokenError */
class InvalidTokenError extends Error {
}
InvalidTokenError.prototype.name = "InvalidTokenError";
function b64DecodeUnicode(str) {
    return decodeURIComponent(atob(str).replace(/(.)/g, (m, p) => {
        let code = p.charCodeAt(0).toString(16).toUpperCase();
        if (code.length < 2) {
            code = "0" + code;
        }
        return "%" + code;
    }));
}
function base64UrlDecode(str) {
    let output = str.replace(/-/g, "+").replace(/_/g, "/");
    switch (output.length % 4) {
        case 0:
            break;
        case 2:
            output += "==";
            break;
        case 3:
            output += "=";
            break;
        default:
            throw new Error("base64 string is not of the correct length");
    }
    try {
        return b64DecodeUnicode(output);
    }
    catch (err) {
        return atob(output);
    }
}
function jwtDecode(token, options) {
    if (typeof token !== "string") {
        throw new InvalidTokenError("Invalid token specified: must be a string");
    }
    options || (options = {});
    const pos = options.header === true ? 0 : 1;
    const part = token.split(".")[pos];
    if (typeof part !== "string") {
        throw new InvalidTokenError(`Invalid token specified: missing part #${pos + 1}`);
    }
    let decoded;
    try {
        decoded = base64UrlDecode(part);
    }
    catch (e) {
        throw new InvalidTokenError(`Invalid token specified: invalid base64 for part #${pos + 1} (${e.message})`);
    }
    try {
        return JSON.parse(decoded);
    }
    catch (e) {
        throw new InvalidTokenError(`Invalid token specified: invalid json for part #${pos + 1} (${e.message})`);
    }
}


/***/ }),

/***/ 87536:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Gc": function() { return /* binding */ useFormContext; },
/* harmony export */   "KN": function() { return /* binding */ appendErrors; },
/* harmony export */   "Qr": function() { return /* binding */ Controller; },
/* harmony export */   "RV": function() { return /* binding */ FormProvider; },
/* harmony export */   "U2": function() { return /* binding */ get; },
/* harmony export */   "cI": function() { return /* binding */ useForm; },
/* harmony export */   "t8": function() { return /* binding */ set; }
/* harmony export */ });
/* unused harmony exports Form, useController, useFieldArray, useFormState, useWatch */
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(55784);


var isCheckBoxInput = (element) => element.type === 'checkbox';

var isDateObject = (value) => value instanceof Date;

var isNullOrUndefined = (value) => value == null;

const isObjectType = (value) => typeof value === 'object';
var isObject = (value) => !isNullOrUndefined(value) &&
    !Array.isArray(value) &&
    isObjectType(value) &&
    !isDateObject(value);

var getEventValue = (event) => isObject(event) && event.target
    ? isCheckBoxInput(event.target)
        ? event.target.checked
        : event.target.value
    : event;

var getNodeParentName = (name) => name.substring(0, name.search(/\.\d+(\.|$)/)) || name;

var isNameInFieldArray = (names, name) => names.has(getNodeParentName(name));

var isPlainObject = (tempObject) => {
    const prototypeCopy = tempObject.constructor && tempObject.constructor.prototype;
    return (isObject(prototypeCopy) && prototypeCopy.hasOwnProperty('isPrototypeOf'));
};

var isWeb = typeof window !== 'undefined' &&
    typeof window.HTMLElement !== 'undefined' &&
    typeof document !== 'undefined';

function cloneObject(data) {
    let copy;
    const isArray = Array.isArray(data);
    if (data instanceof Date) {
        copy = new Date(data);
    }
    else if (data instanceof Set) {
        copy = new Set(data);
    }
    else if (!(isWeb && (data instanceof Blob || data instanceof FileList)) &&
        (isArray || isObject(data))) {
        copy = isArray ? [] : {};
        if (!isArray && !isPlainObject(data)) {
            copy = data;
        }
        else {
            for (const key in data) {
                if (data.hasOwnProperty(key)) {
                    copy[key] = cloneObject(data[key]);
                }
            }
        }
    }
    else {
        return data;
    }
    return copy;
}

var compact = (value) => Array.isArray(value) ? value.filter(Boolean) : [];

var isUndefined = (val) => val === undefined;

var get = (object, path, defaultValue) => {
    if (!path || !isObject(object)) {
        return defaultValue;
    }
    const result = compact(path.split(/[,[\].]+?/)).reduce((result, key) => isNullOrUndefined(result) ? result : result[key], object);
    return isUndefined(result) || result === object
        ? isUndefined(object[path])
            ? defaultValue
            : object[path]
        : result;
};

var isBoolean = (value) => typeof value === 'boolean';

const EVENTS = {
    BLUR: 'blur',
    FOCUS_OUT: 'focusout',
    CHANGE: 'change',
};
const VALIDATION_MODE = {
    onBlur: 'onBlur',
    onChange: 'onChange',
    onSubmit: 'onSubmit',
    onTouched: 'onTouched',
    all: 'all',
};
const INPUT_VALIDATION_RULES = {
    max: 'max',
    min: 'min',
    maxLength: 'maxLength',
    minLength: 'minLength',
    pattern: 'pattern',
    required: 'required',
    validate: 'validate',
};

const HookFormContext = react__WEBPACK_IMPORTED_MODULE_0__.createContext(null);
/**
 * This custom hook allows you to access the form context. useFormContext is intended to be used in deeply nested structures, where it would become inconvenient to pass the context as a prop. To be used with {@link FormProvider}.
 *
 * @remarks
 * [API](https://react-hook-form.com/docs/useformcontext) • [Demo](https://codesandbox.io/s/react-hook-form-v7-form-context-ytudi)
 *
 * @returns return all useForm methods
 *
 * @example
 * ```tsx
 * function App() {
 *   const methods = useForm();
 *   const onSubmit = data => console.log(data);
 *
 *   return (
 *     <FormProvider {...methods} >
 *       <form onSubmit={methods.handleSubmit(onSubmit)}>
 *         <NestedInput />
 *         <input type="submit" />
 *       </form>
 *     </FormProvider>
 *   );
 * }
 *
 *  function NestedInput() {
 *   const { register } = useFormContext(); // retrieve all hook methods
 *   return <input {...register("test")} />;
 * }
 * ```
 */
const useFormContext = () => react__WEBPACK_IMPORTED_MODULE_0__.useContext(HookFormContext);
/**
 * A provider component that propagates the `useForm` methods to all children components via [React Context](https://reactjs.org/docs/context.html) API. To be used with {@link useFormContext}.
 *
 * @remarks
 * [API](https://react-hook-form.com/docs/useformcontext) • [Demo](https://codesandbox.io/s/react-hook-form-v7-form-context-ytudi)
 *
 * @param props - all useForm methods
 *
 * @example
 * ```tsx
 * function App() {
 *   const methods = useForm();
 *   const onSubmit = data => console.log(data);
 *
 *   return (
 *     <FormProvider {...methods} >
 *       <form onSubmit={methods.handleSubmit(onSubmit)}>
 *         <NestedInput />
 *         <input type="submit" />
 *       </form>
 *     </FormProvider>
 *   );
 * }
 *
 *  function NestedInput() {
 *   const { register } = useFormContext(); // retrieve all hook methods
 *   return <input {...register("test")} />;
 * }
 * ```
 */
const FormProvider = (props) => {
    const { children, ...data } = props;
    return (react__WEBPACK_IMPORTED_MODULE_0__.createElement(HookFormContext.Provider, { value: data }, children));
};

var getProxyFormState = (formState, control, localProxyFormState, isRoot = true) => {
    const result = {
        defaultValues: control._defaultValues,
    };
    for (const key in formState) {
        Object.defineProperty(result, key, {
            get: () => {
                const _key = key;
                if (control._proxyFormState[_key] !== VALIDATION_MODE.all) {
                    control._proxyFormState[_key] = !isRoot || VALIDATION_MODE.all;
                }
                localProxyFormState && (localProxyFormState[_key] = true);
                return formState[_key];
            },
        });
    }
    return result;
};

var isEmptyObject = (value) => isObject(value) && !Object.keys(value).length;

var shouldRenderFormState = (formStateData, _proxyFormState, updateFormState, isRoot) => {
    updateFormState(formStateData);
    const { name, ...formState } = formStateData;
    return (isEmptyObject(formState) ||
        Object.keys(formState).length >= Object.keys(_proxyFormState).length ||
        Object.keys(formState).find((key) => _proxyFormState[key] ===
            (!isRoot || VALIDATION_MODE.all)));
};

var convertToArrayPayload = (value) => (Array.isArray(value) ? value : [value]);

var shouldSubscribeByName = (name, signalName, exact) => !name ||
    !signalName ||
    name === signalName ||
    convertToArrayPayload(name).some((currentName) => currentName &&
        (exact
            ? currentName === signalName
            : currentName.startsWith(signalName) ||
                signalName.startsWith(currentName)));

function useSubscribe(props) {
    const _props = react__WEBPACK_IMPORTED_MODULE_0__.useRef(props);
    _props.current = props;
    react__WEBPACK_IMPORTED_MODULE_0__.useEffect(() => {
        const subscription = !props.disabled &&
            _props.current.subject &&
            _props.current.subject.subscribe({
                next: _props.current.next,
            });
        return () => {
            subscription && subscription.unsubscribe();
        };
    }, [props.disabled]);
}

/**
 * This custom hook allows you to subscribe to each form state, and isolate the re-render at the custom hook level. It has its scope in terms of form state subscription, so it would not affect other useFormState and useForm. Using this hook can reduce the re-render impact on large and complex form application.
 *
 * @remarks
 * [API](https://react-hook-form.com/docs/useformstate) • [Demo](https://codesandbox.io/s/useformstate-75xly)
 *
 * @param props - include options on specify fields to subscribe. {@link UseFormStateReturn}
 *
 * @example
 * ```tsx
 * function App() {
 *   const { register, handleSubmit, control } = useForm({
 *     defaultValues: {
 *     firstName: "firstName"
 *   }});
 *   const { dirtyFields } = useFormState({
 *     control
 *   });
 *   const onSubmit = (data) => console.log(data);
 *
 *   return (
 *     <form onSubmit={handleSubmit(onSubmit)}>
 *       <input {...register("firstName")} placeholder="First Name" />
 *       {dirtyFields.firstName && <p>Field is dirty.</p>}
 *       <input type="submit" />
 *     </form>
 *   );
 * }
 * ```
 */
function useFormState(props) {
    const methods = useFormContext();
    const { control = methods.control, disabled, name, exact } = props || {};
    const [formState, updateFormState] = react__WEBPACK_IMPORTED_MODULE_0__.useState(control._formState);
    const _mounted = react__WEBPACK_IMPORTED_MODULE_0__.useRef(true);
    const _localProxyFormState = react__WEBPACK_IMPORTED_MODULE_0__.useRef({
        isDirty: false,
        isLoading: false,
        dirtyFields: false,
        touchedFields: false,
        isValidating: false,
        isValid: false,
        errors: false,
    });
    const _name = react__WEBPACK_IMPORTED_MODULE_0__.useRef(name);
    _name.current = name;
    useSubscribe({
        disabled,
        next: (value) => _mounted.current &&
            shouldSubscribeByName(_name.current, value.name, exact) &&
            shouldRenderFormState(value, _localProxyFormState.current, control._updateFormState) &&
            updateFormState({
                ...control._formState,
                ...value,
            }),
        subject: control._subjects.state,
    });
    react__WEBPACK_IMPORTED_MODULE_0__.useEffect(() => {
        _mounted.current = true;
        _localProxyFormState.current.isValid && control._updateValid(true);
        return () => {
            _mounted.current = false;
        };
    }, [control]);
    return getProxyFormState(formState, control, _localProxyFormState.current, false);
}

var isString = (value) => typeof value === 'string';

var generateWatchOutput = (names, _names, formValues, isGlobal, defaultValue) => {
    if (isString(names)) {
        isGlobal && _names.watch.add(names);
        return get(formValues, names, defaultValue);
    }
    if (Array.isArray(names)) {
        return names.map((fieldName) => (isGlobal && _names.watch.add(fieldName), get(formValues, fieldName)));
    }
    isGlobal && (_names.watchAll = true);
    return formValues;
};

/**
 * Custom hook to subscribe to field change and isolate re-rendering at the component level.
 *
 * @remarks
 *
 * [API](https://react-hook-form.com/docs/usewatch) • [Demo](https://codesandbox.io/s/react-hook-form-v7-ts-usewatch-h9i5e)
 *
 * @example
 * ```tsx
 * const { control } = useForm();
 * const values = useWatch({
 *   name: "fieldName"
 *   control,
 * })
 * ```
 */
function useWatch(props) {
    const methods = useFormContext();
    const { control = methods.control, name, defaultValue, disabled, exact, } = props || {};
    const _name = react__WEBPACK_IMPORTED_MODULE_0__.useRef(name);
    _name.current = name;
    useSubscribe({
        disabled,
        subject: control._subjects.values,
        next: (formState) => {
            if (shouldSubscribeByName(_name.current, formState.name, exact)) {
                updateValue(cloneObject(generateWatchOutput(_name.current, control._names, formState.values || control._formValues, false, defaultValue)));
            }
        },
    });
    const [value, updateValue] = react__WEBPACK_IMPORTED_MODULE_0__.useState(control._getWatch(name, defaultValue));
    react__WEBPACK_IMPORTED_MODULE_0__.useEffect(() => control._removeUnmounted());
    return value;
}

var isKey = (value) => /^\w*$/.test(value);

var stringToPath = (input) => compact(input.replace(/["|']|\]/g, '').split(/\.|\[/));

var set = (object, path, value) => {
    let index = -1;
    const tempPath = isKey(path) ? [path] : stringToPath(path);
    const length = tempPath.length;
    const lastIndex = length - 1;
    while (++index < length) {
        const key = tempPath[index];
        let newValue = value;
        if (index !== lastIndex) {
            const objValue = object[key];
            newValue =
                isObject(objValue) || Array.isArray(objValue)
                    ? objValue
                    : !isNaN(+tempPath[index + 1])
                        ? []
                        : {};
        }
        object[key] = newValue;
        object = object[key];
    }
    return object;
};

/**
 * Custom hook to work with controlled component, this function provide you with both form and field level state. Re-render is isolated at the hook level.
 *
 * @remarks
 * [API](https://react-hook-form.com/docs/usecontroller) • [Demo](https://codesandbox.io/s/usecontroller-0o8px)
 *
 * @param props - the path name to the form field value, and validation rules.
 *
 * @returns field properties, field and form state. {@link UseControllerReturn}
 *
 * @example
 * ```tsx
 * function Input(props) {
 *   const { field, fieldState, formState } = useController(props);
 *   return (
 *     <div>
 *       <input {...field} placeholder={props.name} />
 *       <p>{fieldState.isTouched && "Touched"}</p>
 *       <p>{formState.isSubmitted ? "submitted" : ""}</p>
 *     </div>
 *   );
 * }
 * ```
 */
function useController(props) {
    const methods = useFormContext();
    const { name, disabled, control = methods.control, shouldUnregister } = props;
    const isArrayField = isNameInFieldArray(control._names.array, name);
    const value = useWatch({
        control,
        name,
        defaultValue: get(control._formValues, name, get(control._defaultValues, name, props.defaultValue)),
        exact: true,
    });
    const formState = useFormState({
        control,
        name,
    });
    const _registerProps = react__WEBPACK_IMPORTED_MODULE_0__.useRef(control.register(name, {
        ...props.rules,
        value,
        ...(isBoolean(props.disabled) ? { disabled: props.disabled } : {}),
    }));
    react__WEBPACK_IMPORTED_MODULE_0__.useEffect(() => {
        const _shouldUnregisterField = control._options.shouldUnregister || shouldUnregister;
        const updateMounted = (name, value) => {
            const field = get(control._fields, name);
            if (field) {
                field._f.mount = value;
            }
        };
        updateMounted(name, true);
        if (_shouldUnregisterField) {
            const value = cloneObject(get(control._options.defaultValues, name));
            set(control._defaultValues, name, value);
            if (isUndefined(get(control._formValues, name))) {
                set(control._formValues, name, value);
            }
        }
        return () => {
            (isArrayField
                ? _shouldUnregisterField && !control._state.action
                : _shouldUnregisterField)
                ? control.unregister(name)
                : updateMounted(name, false);
        };
    }, [name, control, isArrayField, shouldUnregister]);
    react__WEBPACK_IMPORTED_MODULE_0__.useEffect(() => {
        if (get(control._fields, name)) {
            control._updateDisabledField({
                disabled,
                fields: control._fields,
                name,
                value: get(control._fields, name)._f.value,
            });
        }
    }, [disabled, name, control]);
    return {
        field: {
            name,
            value,
            ...(isBoolean(disabled) || isBoolean(formState.disabled)
                ? { disabled: formState.disabled || disabled }
                : {}),
            onChange: react__WEBPACK_IMPORTED_MODULE_0__.useCallback((event) => _registerProps.current.onChange({
                target: {
                    value: getEventValue(event),
                    name: name,
                },
                type: EVENTS.CHANGE,
            }), [name]),
            onBlur: react__WEBPACK_IMPORTED_MODULE_0__.useCallback(() => _registerProps.current.onBlur({
                target: {
                    value: get(control._formValues, name),
                    name: name,
                },
                type: EVENTS.BLUR,
            }), [name, control]),
            ref: (elm) => {
                const field = get(control._fields, name);
                if (field && elm) {
                    field._f.ref = {
                        focus: () => elm.focus(),
                        select: () => elm.select(),
                        setCustomValidity: (message) => elm.setCustomValidity(message),
                        reportValidity: () => elm.reportValidity(),
                    };
                }
            },
        },
        formState,
        fieldState: Object.defineProperties({}, {
            invalid: {
                enumerable: true,
                get: () => !!get(formState.errors, name),
            },
            isDirty: {
                enumerable: true,
                get: () => !!get(formState.dirtyFields, name),
            },
            isTouched: {
                enumerable: true,
                get: () => !!get(formState.touchedFields, name),
            },
            error: {
                enumerable: true,
                get: () => get(formState.errors, name),
            },
        }),
    };
}

/**
 * Component based on `useController` hook to work with controlled component.
 *
 * @remarks
 * [API](https://react-hook-form.com/docs/usecontroller/controller) • [Demo](https://codesandbox.io/s/react-hook-form-v6-controller-ts-jwyzw) • [Video](https://www.youtube.com/watch?v=N2UNk_UCVyA)
 *
 * @param props - the path name to the form field value, and validation rules.
 *
 * @returns provide field handler functions, field and form state.
 *
 * @example
 * ```tsx
 * function App() {
 *   const { control } = useForm<FormValues>({
 *     defaultValues: {
 *       test: ""
 *     }
 *   });
 *
 *   return (
 *     <form>
 *       <Controller
 *         control={control}
 *         name="test"
 *         render={({ field: { onChange, onBlur, value, ref }, formState, fieldState }) => (
 *           <>
 *             <input
 *               onChange={onChange} // send value to hook form
 *               onBlur={onBlur} // notify when input is touched
 *               value={value} // return updated value
 *               ref={ref} // set ref for focus management
 *             />
 *             <p>{formState.isSubmitted ? "submitted" : ""}</p>
 *             <p>{fieldState.isTouched ? "touched" : ""}</p>
 *           </>
 *         )}
 *       />
 *     </form>
 *   );
 * }
 * ```
 */
const Controller = (props) => props.render(useController(props));

const POST_REQUEST = 'post';
/**
 * Form component to manage submission.
 *
 * @param props - to setup submission detail. {@link FormProps}
 *
 * @returns form component or headless render prop.
 *
 * @example
 * ```tsx
 * function App() {
 *   const { control, formState: { errors } } = useForm();
 *
 *   return (
 *     <Form action="/api" control={control}>
 *       <input {...register("name")} />
 *       <p>{errors?.root?.server && 'Server error'}</p>
 *       <button>Submit</button>
 *     </Form>
 *   );
 * }
 * ```
 */
function Form(props) {
    const methods = useFormContext();
    const [mounted, setMounted] = React.useState(false);
    const { control = methods.control, onSubmit, children, action, method = POST_REQUEST, headers, encType, onError, render, onSuccess, validateStatus, ...rest } = props;
    const submit = async (event) => {
        let hasError = false;
        let type = '';
        await control.handleSubmit(async (data) => {
            const formData = new FormData();
            let formDataJson = '';
            try {
                formDataJson = JSON.stringify(data);
            }
            catch (_a) { }
            for (const name of control._names.mount) {
                formData.append(name, get(data, name));
            }
            if (onSubmit) {
                await onSubmit({
                    data,
                    event,
                    method,
                    formData,
                    formDataJson,
                });
            }
            if (action) {
                try {
                    const shouldStringifySubmissionData = [
                        headers && headers['Content-Type'],
                        encType,
                    ].some((value) => value && value.includes('json'));
                    const response = await fetch(action, {
                        method,
                        headers: {
                            ...headers,
                            ...(encType ? { 'Content-Type': encType } : {}),
                        },
                        body: shouldStringifySubmissionData ? formDataJson : formData,
                    });
                    if (response &&
                        (validateStatus
                            ? !validateStatus(response.status)
                            : response.status < 200 || response.status >= 300)) {
                        hasError = true;
                        onError && onError({ response });
                        type = String(response.status);
                    }
                    else {
                        onSuccess && onSuccess({ response });
                    }
                }
                catch (error) {
                    hasError = true;
                    onError && onError({ error });
                }
            }
        })(event);
        if (hasError && props.control) {
            props.control._subjects.state.next({
                isSubmitSuccessful: false,
            });
            props.control.setError('root.server', {
                type,
            });
        }
    };
    React.useEffect(() => {
        setMounted(true);
    }, []);
    return render ? (React.createElement(React.Fragment, null, render({
        submit,
    }))) : (React.createElement("form", { noValidate: mounted, action: action, method: method, encType: encType, onSubmit: submit, ...rest }, children));
}

var appendErrors = (name, validateAllFieldCriteria, errors, type, message) => validateAllFieldCriteria
    ? {
        ...errors[name],
        types: {
            ...(errors[name] && errors[name].types ? errors[name].types : {}),
            [type]: message || true,
        },
    }
    : {};

var generateId = () => {
    const d = typeof performance === 'undefined' ? Date.now() : performance.now() * 1000;
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, (c) => {
        const r = (Math.random() * 16 + d) % 16 | 0;
        return (c == 'x' ? r : (r & 0x3) | 0x8).toString(16);
    });
};

var getFocusFieldName = (name, index, options = {}) => options.shouldFocus || isUndefined(options.shouldFocus)
    ? options.focusName ||
        `${name}.${isUndefined(options.focusIndex) ? index : options.focusIndex}.`
    : '';

var getValidationModes = (mode) => ({
    isOnSubmit: !mode || mode === VALIDATION_MODE.onSubmit,
    isOnBlur: mode === VALIDATION_MODE.onBlur,
    isOnChange: mode === VALIDATION_MODE.onChange,
    isOnAll: mode === VALIDATION_MODE.all,
    isOnTouch: mode === VALIDATION_MODE.onTouched,
});

var isWatched = (name, _names, isBlurEvent) => !isBlurEvent &&
    (_names.watchAll ||
        _names.watch.has(name) ||
        [..._names.watch].some((watchName) => name.startsWith(watchName) &&
            /^\.\w+/.test(name.slice(watchName.length))));

const iterateFieldsByAction = (fields, action, fieldsNames, abortEarly) => {
    for (const key of fieldsNames || Object.keys(fields)) {
        const field = get(fields, key);
        if (field) {
            const { _f, ...currentField } = field;
            if (_f) {
                if (_f.refs && _f.refs[0] && action(_f.refs[0], key) && !abortEarly) {
                    break;
                }
                else if (_f.ref && action(_f.ref, _f.name) && !abortEarly) {
                    break;
                }
                else {
                    iterateFieldsByAction(currentField, action);
                }
            }
            else if (isObject(currentField)) {
                iterateFieldsByAction(currentField, action);
            }
        }
    }
};

var updateFieldArrayRootError = (errors, error, name) => {
    const fieldArrayErrors = compact(get(errors, name));
    set(fieldArrayErrors, 'root', error[name]);
    set(errors, name, fieldArrayErrors);
    return errors;
};

var isFileInput = (element) => element.type === 'file';

var isFunction = (value) => typeof value === 'function';

var isHTMLElement = (value) => {
    if (!isWeb) {
        return false;
    }
    const owner = value ? value.ownerDocument : 0;
    return (value instanceof
        (owner && owner.defaultView ? owner.defaultView.HTMLElement : HTMLElement));
};

var isMessage = (value) => isString(value);

var isRadioInput = (element) => element.type === 'radio';

var isRegex = (value) => value instanceof RegExp;

const defaultResult = {
    value: false,
    isValid: false,
};
const validResult = { value: true, isValid: true };
var getCheckboxValue = (options) => {
    if (Array.isArray(options)) {
        if (options.length > 1) {
            const values = options
                .filter((option) => option && option.checked && !option.disabled)
                .map((option) => option.value);
            return { value: values, isValid: !!values.length };
        }
        return options[0].checked && !options[0].disabled
            ? // @ts-expect-error expected to work in the browser
                options[0].attributes && !isUndefined(options[0].attributes.value)
                    ? isUndefined(options[0].value) || options[0].value === ''
                        ? validResult
                        : { value: options[0].value, isValid: true }
                    : validResult
            : defaultResult;
    }
    return defaultResult;
};

const defaultReturn = {
    isValid: false,
    value: null,
};
var getRadioValue = (options) => Array.isArray(options)
    ? options.reduce((previous, option) => option && option.checked && !option.disabled
        ? {
            isValid: true,
            value: option.value,
        }
        : previous, defaultReturn)
    : defaultReturn;

function getValidateError(result, ref, type = 'validate') {
    if (isMessage(result) ||
        (Array.isArray(result) && result.every(isMessage)) ||
        (isBoolean(result) && !result)) {
        return {
            type,
            message: isMessage(result) ? result : '',
            ref,
        };
    }
}

var getValueAndMessage = (validationData) => isObject(validationData) && !isRegex(validationData)
    ? validationData
    : {
        value: validationData,
        message: '',
    };

var validateField = async (field, formValues, validateAllFieldCriteria, shouldUseNativeValidation, isFieldArray) => {
    const { ref, refs, required, maxLength, minLength, min, max, pattern, validate, name, valueAsNumber, mount, disabled, } = field._f;
    const inputValue = get(formValues, name);
    if (!mount || disabled) {
        return {};
    }
    const inputRef = refs ? refs[0] : ref;
    const setCustomValidity = (message) => {
        if (shouldUseNativeValidation && inputRef.reportValidity) {
            inputRef.setCustomValidity(isBoolean(message) ? '' : message || '');
            inputRef.reportValidity();
        }
    };
    const error = {};
    const isRadio = isRadioInput(ref);
    const isCheckBox = isCheckBoxInput(ref);
    const isRadioOrCheckbox = isRadio || isCheckBox;
    const isEmpty = ((valueAsNumber || isFileInput(ref)) &&
        isUndefined(ref.value) &&
        isUndefined(inputValue)) ||
        (isHTMLElement(ref) && ref.value === '') ||
        inputValue === '' ||
        (Array.isArray(inputValue) && !inputValue.length);
    const appendErrorsCurry = appendErrors.bind(null, name, validateAllFieldCriteria, error);
    const getMinMaxMessage = (exceedMax, maxLengthMessage, minLengthMessage, maxType = INPUT_VALIDATION_RULES.maxLength, minType = INPUT_VALIDATION_RULES.minLength) => {
        const message = exceedMax ? maxLengthMessage : minLengthMessage;
        error[name] = {
            type: exceedMax ? maxType : minType,
            message,
            ref,
            ...appendErrorsCurry(exceedMax ? maxType : minType, message),
        };
    };
    if (isFieldArray
        ? !Array.isArray(inputValue) || !inputValue.length
        : required &&
            ((!isRadioOrCheckbox && (isEmpty || isNullOrUndefined(inputValue))) ||
                (isBoolean(inputValue) && !inputValue) ||
                (isCheckBox && !getCheckboxValue(refs).isValid) ||
                (isRadio && !getRadioValue(refs).isValid))) {
        const { value, message } = isMessage(required)
            ? { value: !!required, message: required }
            : getValueAndMessage(required);
        if (value) {
            error[name] = {
                type: INPUT_VALIDATION_RULES.required,
                message,
                ref: inputRef,
                ...appendErrorsCurry(INPUT_VALIDATION_RULES.required, message),
            };
            if (!validateAllFieldCriteria) {
                setCustomValidity(message);
                return error;
            }
        }
    }
    if (!isEmpty && (!isNullOrUndefined(min) || !isNullOrUndefined(max))) {
        let exceedMax;
        let exceedMin;
        const maxOutput = getValueAndMessage(max);
        const minOutput = getValueAndMessage(min);
        if (!isNullOrUndefined(inputValue) && !isNaN(inputValue)) {
            const valueNumber = ref.valueAsNumber ||
                (inputValue ? +inputValue : inputValue);
            if (!isNullOrUndefined(maxOutput.value)) {
                exceedMax = valueNumber > maxOutput.value;
            }
            if (!isNullOrUndefined(minOutput.value)) {
                exceedMin = valueNumber < minOutput.value;
            }
        }
        else {
            const valueDate = ref.valueAsDate || new Date(inputValue);
            const convertTimeToDate = (time) => new Date(new Date().toDateString() + ' ' + time);
            const isTime = ref.type == 'time';
            const isWeek = ref.type == 'week';
            if (isString(maxOutput.value) && inputValue) {
                exceedMax = isTime
                    ? convertTimeToDate(inputValue) > convertTimeToDate(maxOutput.value)
                    : isWeek
                        ? inputValue > maxOutput.value
                        : valueDate > new Date(maxOutput.value);
            }
            if (isString(minOutput.value) && inputValue) {
                exceedMin = isTime
                    ? convertTimeToDate(inputValue) < convertTimeToDate(minOutput.value)
                    : isWeek
                        ? inputValue < minOutput.value
                        : valueDate < new Date(minOutput.value);
            }
        }
        if (exceedMax || exceedMin) {
            getMinMaxMessage(!!exceedMax, maxOutput.message, minOutput.message, INPUT_VALIDATION_RULES.max, INPUT_VALIDATION_RULES.min);
            if (!validateAllFieldCriteria) {
                setCustomValidity(error[name].message);
                return error;
            }
        }
    }
    if ((maxLength || minLength) &&
        !isEmpty &&
        (isString(inputValue) || (isFieldArray && Array.isArray(inputValue)))) {
        const maxLengthOutput = getValueAndMessage(maxLength);
        const minLengthOutput = getValueAndMessage(minLength);
        const exceedMax = !isNullOrUndefined(maxLengthOutput.value) &&
            inputValue.length > +maxLengthOutput.value;
        const exceedMin = !isNullOrUndefined(minLengthOutput.value) &&
            inputValue.length < +minLengthOutput.value;
        if (exceedMax || exceedMin) {
            getMinMaxMessage(exceedMax, maxLengthOutput.message, minLengthOutput.message);
            if (!validateAllFieldCriteria) {
                setCustomValidity(error[name].message);
                return error;
            }
        }
    }
    if (pattern && !isEmpty && isString(inputValue)) {
        const { value: patternValue, message } = getValueAndMessage(pattern);
        if (isRegex(patternValue) && !inputValue.match(patternValue)) {
            error[name] = {
                type: INPUT_VALIDATION_RULES.pattern,
                message,
                ref,
                ...appendErrorsCurry(INPUT_VALIDATION_RULES.pattern, message),
            };
            if (!validateAllFieldCriteria) {
                setCustomValidity(message);
                return error;
            }
        }
    }
    if (validate) {
        if (isFunction(validate)) {
            const result = await validate(inputValue, formValues);
            const validateError = getValidateError(result, inputRef);
            if (validateError) {
                error[name] = {
                    ...validateError,
                    ...appendErrorsCurry(INPUT_VALIDATION_RULES.validate, validateError.message),
                };
                if (!validateAllFieldCriteria) {
                    setCustomValidity(validateError.message);
                    return error;
                }
            }
        }
        else if (isObject(validate)) {
            let validationResult = {};
            for (const key in validate) {
                if (!isEmptyObject(validationResult) && !validateAllFieldCriteria) {
                    break;
                }
                const validateError = getValidateError(await validate[key](inputValue, formValues), inputRef, key);
                if (validateError) {
                    validationResult = {
                        ...validateError,
                        ...appendErrorsCurry(key, validateError.message),
                    };
                    setCustomValidity(validateError.message);
                    if (validateAllFieldCriteria) {
                        error[name] = validationResult;
                    }
                }
            }
            if (!isEmptyObject(validationResult)) {
                error[name] = {
                    ref: inputRef,
                    ...validationResult,
                };
                if (!validateAllFieldCriteria) {
                    return error;
                }
            }
        }
    }
    setCustomValidity(true);
    return error;
};

var appendAt = (data, value) => [
    ...data,
    ...convertToArrayPayload(value),
];

var fillEmptyArray = (value) => Array.isArray(value) ? value.map(() => undefined) : undefined;

function insert(data, index, value) {
    return [
        ...data.slice(0, index),
        ...convertToArrayPayload(value),
        ...data.slice(index),
    ];
}

var moveArrayAt = (data, from, to) => {
    if (!Array.isArray(data)) {
        return [];
    }
    if (isUndefined(data[to])) {
        data[to] = undefined;
    }
    data.splice(to, 0, data.splice(from, 1)[0]);
    return data;
};

var prependAt = (data, value) => [
    ...convertToArrayPayload(value),
    ...convertToArrayPayload(data),
];

function removeAtIndexes(data, indexes) {
    let i = 0;
    const temp = [...data];
    for (const index of indexes) {
        temp.splice(index - i, 1);
        i++;
    }
    return compact(temp).length ? temp : [];
}
var removeArrayAt = (data, index) => isUndefined(index)
    ? []
    : removeAtIndexes(data, convertToArrayPayload(index).sort((a, b) => a - b));

var swapArrayAt = (data, indexA, indexB) => {
    [data[indexA], data[indexB]] = [data[indexB], data[indexA]];
};

function baseGet(object, updatePath) {
    const length = updatePath.slice(0, -1).length;
    let index = 0;
    while (index < length) {
        object = isUndefined(object) ? index++ : object[updatePath[index++]];
    }
    return object;
}
function isEmptyArray(obj) {
    for (const key in obj) {
        if (obj.hasOwnProperty(key) && !isUndefined(obj[key])) {
            return false;
        }
    }
    return true;
}
function unset(object, path) {
    const paths = Array.isArray(path)
        ? path
        : isKey(path)
            ? [path]
            : stringToPath(path);
    const childObject = paths.length === 1 ? object : baseGet(object, paths);
    const index = paths.length - 1;
    const key = paths[index];
    if (childObject) {
        delete childObject[key];
    }
    if (index !== 0 &&
        ((isObject(childObject) && isEmptyObject(childObject)) ||
            (Array.isArray(childObject) && isEmptyArray(childObject)))) {
        unset(object, paths.slice(0, -1));
    }
    return object;
}

var updateAt = (fieldValues, index, value) => {
    fieldValues[index] = value;
    return fieldValues;
};

/**
 * A custom hook that exposes convenient methods to perform operations with a list of dynamic inputs that need to be appended, updated, removed etc. • [Demo](https://codesandbox.io/s/react-hook-form-usefieldarray-ssugn) • [Video](https://youtu.be/4MrbfGSFY2A)
 *
 * @remarks
 * [API](https://react-hook-form.com/docs/usefieldarray) • [Demo](https://codesandbox.io/s/react-hook-form-usefieldarray-ssugn)
 *
 * @param props - useFieldArray props
 *
 * @returns methods - functions to manipulate with the Field Arrays (dynamic inputs) {@link UseFieldArrayReturn}
 *
 * @example
 * ```tsx
 * function App() {
 *   const { register, control, handleSubmit, reset, trigger, setError } = useForm({
 *     defaultValues: {
 *       test: []
 *     }
 *   });
 *   const { fields, append } = useFieldArray({
 *     control,
 *     name: "test"
 *   });
 *
 *   return (
 *     <form onSubmit={handleSubmit(data => console.log(data))}>
 *       {fields.map((item, index) => (
 *          <input key={item.id} {...register(`test.${index}.firstName`)}  />
 *       ))}
 *       <button type="button" onClick={() => append({ firstName: "bill" })}>
 *         append
 *       </button>
 *       <input type="submit" />
 *     </form>
 *   );
 * }
 * ```
 */
function useFieldArray(props) {
    const methods = useFormContext();
    const { control = methods.control, name, keyName = 'id', shouldUnregister, } = props;
    const [fields, setFields] = React.useState(control._getFieldArray(name));
    const ids = React.useRef(control._getFieldArray(name).map(generateId));
    const _fieldIds = React.useRef(fields);
    const _name = React.useRef(name);
    const _actioned = React.useRef(false);
    _name.current = name;
    _fieldIds.current = fields;
    control._names.array.add(name);
    props.rules &&
        control.register(name, props.rules);
    useSubscribe({
        next: ({ values, name: fieldArrayName, }) => {
            if (fieldArrayName === _name.current || !fieldArrayName) {
                const fieldValues = get(values, _name.current);
                if (Array.isArray(fieldValues)) {
                    setFields(fieldValues);
                    ids.current = fieldValues.map(generateId);
                }
            }
        },
        subject: control._subjects.array,
    });
    const updateValues = React.useCallback((updatedFieldArrayValues) => {
        _actioned.current = true;
        control._updateFieldArray(name, updatedFieldArrayValues);
    }, [control, name]);
    const append = (value, options) => {
        const appendValue = convertToArrayPayload(cloneObject(value));
        const updatedFieldArrayValues = appendAt(control._getFieldArray(name), appendValue);
        control._names.focus = getFocusFieldName(name, updatedFieldArrayValues.length - 1, options);
        ids.current = appendAt(ids.current, appendValue.map(generateId));
        updateValues(updatedFieldArrayValues);
        setFields(updatedFieldArrayValues);
        control._updateFieldArray(name, updatedFieldArrayValues, appendAt, {
            argA: fillEmptyArray(value),
        });
    };
    const prepend = (value, options) => {
        const prependValue = convertToArrayPayload(cloneObject(value));
        const updatedFieldArrayValues = prependAt(control._getFieldArray(name), prependValue);
        control._names.focus = getFocusFieldName(name, 0, options);
        ids.current = prependAt(ids.current, prependValue.map(generateId));
        updateValues(updatedFieldArrayValues);
        setFields(updatedFieldArrayValues);
        control._updateFieldArray(name, updatedFieldArrayValues, prependAt, {
            argA: fillEmptyArray(value),
        });
    };
    const remove = (index) => {
        const updatedFieldArrayValues = removeArrayAt(control._getFieldArray(name), index);
        ids.current = removeArrayAt(ids.current, index);
        updateValues(updatedFieldArrayValues);
        setFields(updatedFieldArrayValues);
        control._updateFieldArray(name, updatedFieldArrayValues, removeArrayAt, {
            argA: index,
        });
    };
    const insert$1 = (index, value, options) => {
        const insertValue = convertToArrayPayload(cloneObject(value));
        const updatedFieldArrayValues = insert(control._getFieldArray(name), index, insertValue);
        control._names.focus = getFocusFieldName(name, index, options);
        ids.current = insert(ids.current, index, insertValue.map(generateId));
        updateValues(updatedFieldArrayValues);
        setFields(updatedFieldArrayValues);
        control._updateFieldArray(name, updatedFieldArrayValues, insert, {
            argA: index,
            argB: fillEmptyArray(value),
        });
    };
    const swap = (indexA, indexB) => {
        const updatedFieldArrayValues = control._getFieldArray(name);
        swapArrayAt(updatedFieldArrayValues, indexA, indexB);
        swapArrayAt(ids.current, indexA, indexB);
        updateValues(updatedFieldArrayValues);
        setFields(updatedFieldArrayValues);
        control._updateFieldArray(name, updatedFieldArrayValues, swapArrayAt, {
            argA: indexA,
            argB: indexB,
        }, false);
    };
    const move = (from, to) => {
        const updatedFieldArrayValues = control._getFieldArray(name);
        moveArrayAt(updatedFieldArrayValues, from, to);
        moveArrayAt(ids.current, from, to);
        updateValues(updatedFieldArrayValues);
        setFields(updatedFieldArrayValues);
        control._updateFieldArray(name, updatedFieldArrayValues, moveArrayAt, {
            argA: from,
            argB: to,
        }, false);
    };
    const update = (index, value) => {
        const updateValue = cloneObject(value);
        const updatedFieldArrayValues = updateAt(control._getFieldArray(name), index, updateValue);
        ids.current = [...updatedFieldArrayValues].map((item, i) => !item || i === index ? generateId() : ids.current[i]);
        updateValues(updatedFieldArrayValues);
        setFields([...updatedFieldArrayValues]);
        control._updateFieldArray(name, updatedFieldArrayValues, updateAt, {
            argA: index,
            argB: updateValue,
        }, true, false);
    };
    const replace = (value) => {
        const updatedFieldArrayValues = convertToArrayPayload(cloneObject(value));
        ids.current = updatedFieldArrayValues.map(generateId);
        updateValues([...updatedFieldArrayValues]);
        setFields([...updatedFieldArrayValues]);
        control._updateFieldArray(name, [...updatedFieldArrayValues], (data) => data, {}, true, false);
    };
    React.useEffect(() => {
        control._state.action = false;
        isWatched(name, control._names) &&
            control._subjects.state.next({
                ...control._formState,
            });
        if (_actioned.current &&
            (!getValidationModes(control._options.mode).isOnSubmit ||
                control._formState.isSubmitted)) {
            if (control._options.resolver) {
                control._executeSchema([name]).then((result) => {
                    const error = get(result.errors, name);
                    const existingError = get(control._formState.errors, name);
                    if (existingError
                        ? (!error && existingError.type) ||
                            (error &&
                                (existingError.type !== error.type ||
                                    existingError.message !== error.message))
                        : error && error.type) {
                        error
                            ? set(control._formState.errors, name, error)
                            : unset(control._formState.errors, name);
                        control._subjects.state.next({
                            errors: control._formState.errors,
                        });
                    }
                });
            }
            else {
                const field = get(control._fields, name);
                if (field && field._f) {
                    validateField(field, control._formValues, control._options.criteriaMode === VALIDATION_MODE.all, control._options.shouldUseNativeValidation, true).then((error) => !isEmptyObject(error) &&
                        control._subjects.state.next({
                            errors: updateFieldArrayRootError(control._formState.errors, error, name),
                        }));
                }
            }
        }
        control._subjects.values.next({
            name,
            values: { ...control._formValues },
        });
        control._names.focus &&
            iterateFieldsByAction(control._fields, (ref, key) => {
                if (control._names.focus &&
                    key.startsWith(control._names.focus) &&
                    ref.focus) {
                    ref.focus();
                    return 1;
                }
                return;
            });
        control._names.focus = '';
        control._updateValid();
        _actioned.current = false;
    }, [fields, name, control]);
    React.useEffect(() => {
        !get(control._formValues, name) && control._updateFieldArray(name);
        return () => {
            (control._options.shouldUnregister || shouldUnregister) &&
                control.unregister(name);
        };
    }, [name, control, keyName, shouldUnregister]);
    return {
        swap: React.useCallback(swap, [updateValues, name, control]),
        move: React.useCallback(move, [updateValues, name, control]),
        prepend: React.useCallback(prepend, [updateValues, name, control]),
        append: React.useCallback(append, [updateValues, name, control]),
        remove: React.useCallback(remove, [updateValues, name, control]),
        insert: React.useCallback(insert$1, [updateValues, name, control]),
        update: React.useCallback(update, [updateValues, name, control]),
        replace: React.useCallback(replace, [updateValues, name, control]),
        fields: React.useMemo(() => fields.map((field, index) => ({
            ...field,
            [keyName]: ids.current[index] || generateId(),
        })), [fields, keyName]),
    };
}

var createSubject = () => {
    let _observers = [];
    const next = (value) => {
        for (const observer of _observers) {
            observer.next && observer.next(value);
        }
    };
    const subscribe = (observer) => {
        _observers.push(observer);
        return {
            unsubscribe: () => {
                _observers = _observers.filter((o) => o !== observer);
            },
        };
    };
    const unsubscribe = () => {
        _observers = [];
    };
    return {
        get observers() {
            return _observers;
        },
        next,
        subscribe,
        unsubscribe,
    };
};

var isPrimitive = (value) => isNullOrUndefined(value) || !isObjectType(value);

function deepEqual(object1, object2) {
    if (isPrimitive(object1) || isPrimitive(object2)) {
        return object1 === object2;
    }
    if (isDateObject(object1) && isDateObject(object2)) {
        return object1.getTime() === object2.getTime();
    }
    const keys1 = Object.keys(object1);
    const keys2 = Object.keys(object2);
    if (keys1.length !== keys2.length) {
        return false;
    }
    for (const key of keys1) {
        const val1 = object1[key];
        if (!keys2.includes(key)) {
            return false;
        }
        if (key !== 'ref') {
            const val2 = object2[key];
            if ((isDateObject(val1) && isDateObject(val2)) ||
                (isObject(val1) && isObject(val2)) ||
                (Array.isArray(val1) && Array.isArray(val2))
                ? !deepEqual(val1, val2)
                : val1 !== val2) {
                return false;
            }
        }
    }
    return true;
}

var isMultipleSelect = (element) => element.type === `select-multiple`;

var isRadioOrCheckbox = (ref) => isRadioInput(ref) || isCheckBoxInput(ref);

var live = (ref) => isHTMLElement(ref) && ref.isConnected;

var objectHasFunction = (data) => {
    for (const key in data) {
        if (isFunction(data[key])) {
            return true;
        }
    }
    return false;
};

function markFieldsDirty(data, fields = {}) {
    const isParentNodeArray = Array.isArray(data);
    if (isObject(data) || isParentNodeArray) {
        for (const key in data) {
            if (Array.isArray(data[key]) ||
                (isObject(data[key]) && !objectHasFunction(data[key]))) {
                fields[key] = Array.isArray(data[key]) ? [] : {};
                markFieldsDirty(data[key], fields[key]);
            }
            else if (!isNullOrUndefined(data[key])) {
                fields[key] = true;
            }
        }
    }
    return fields;
}
function getDirtyFieldsFromDefaultValues(data, formValues, dirtyFieldsFromValues) {
    const isParentNodeArray = Array.isArray(data);
    if (isObject(data) || isParentNodeArray) {
        for (const key in data) {
            if (Array.isArray(data[key]) ||
                (isObject(data[key]) && !objectHasFunction(data[key]))) {
                if (isUndefined(formValues) ||
                    isPrimitive(dirtyFieldsFromValues[key])) {
                    dirtyFieldsFromValues[key] = Array.isArray(data[key])
                        ? markFieldsDirty(data[key], [])
                        : { ...markFieldsDirty(data[key]) };
                }
                else {
                    getDirtyFieldsFromDefaultValues(data[key], isNullOrUndefined(formValues) ? {} : formValues[key], dirtyFieldsFromValues[key]);
                }
            }
            else {
                dirtyFieldsFromValues[key] = !deepEqual(data[key], formValues[key]);
            }
        }
    }
    return dirtyFieldsFromValues;
}
var getDirtyFields = (defaultValues, formValues) => getDirtyFieldsFromDefaultValues(defaultValues, formValues, markFieldsDirty(formValues));

var getFieldValueAs = (value, { valueAsNumber, valueAsDate, setValueAs }) => isUndefined(value)
    ? value
    : valueAsNumber
        ? value === ''
            ? NaN
            : value
                ? +value
                : value
        : valueAsDate && isString(value)
            ? new Date(value)
            : setValueAs
                ? setValueAs(value)
                : value;

function getFieldValue(_f) {
    const ref = _f.ref;
    if (_f.refs ? _f.refs.every((ref) => ref.disabled) : ref.disabled) {
        return;
    }
    if (isFileInput(ref)) {
        return ref.files;
    }
    if (isRadioInput(ref)) {
        return getRadioValue(_f.refs).value;
    }
    if (isMultipleSelect(ref)) {
        return [...ref.selectedOptions].map(({ value }) => value);
    }
    if (isCheckBoxInput(ref)) {
        return getCheckboxValue(_f.refs).value;
    }
    return getFieldValueAs(isUndefined(ref.value) ? _f.ref.value : ref.value, _f);
}

var getResolverOptions = (fieldsNames, _fields, criteriaMode, shouldUseNativeValidation) => {
    const fields = {};
    for (const name of fieldsNames) {
        const field = get(_fields, name);
        field && set(fields, name, field._f);
    }
    return {
        criteriaMode,
        names: [...fieldsNames],
        fields,
        shouldUseNativeValidation,
    };
};

var getRuleValue = (rule) => isUndefined(rule)
    ? rule
    : isRegex(rule)
        ? rule.source
        : isObject(rule)
            ? isRegex(rule.value)
                ? rule.value.source
                : rule.value
            : rule;

var hasValidation = (options) => options.mount &&
    (options.required ||
        options.min ||
        options.max ||
        options.maxLength ||
        options.minLength ||
        options.pattern ||
        options.validate);

function schemaErrorLookup(errors, _fields, name) {
    const error = get(errors, name);
    if (error || isKey(name)) {
        return {
            error,
            name,
        };
    }
    const names = name.split('.');
    while (names.length) {
        const fieldName = names.join('.');
        const field = get(_fields, fieldName);
        const foundError = get(errors, fieldName);
        if (field && !Array.isArray(field) && name !== fieldName) {
            return { name };
        }
        if (foundError && foundError.type) {
            return {
                name: fieldName,
                error: foundError,
            };
        }
        names.pop();
    }
    return {
        name,
    };
}

var skipValidation = (isBlurEvent, isTouched, isSubmitted, reValidateMode, mode) => {
    if (mode.isOnAll) {
        return false;
    }
    else if (!isSubmitted && mode.isOnTouch) {
        return !(isTouched || isBlurEvent);
    }
    else if (isSubmitted ? reValidateMode.isOnBlur : mode.isOnBlur) {
        return !isBlurEvent;
    }
    else if (isSubmitted ? reValidateMode.isOnChange : mode.isOnChange) {
        return isBlurEvent;
    }
    return true;
};

var unsetEmptyArray = (ref, name) => !compact(get(ref, name)).length && unset(ref, name);

const defaultOptions = {
    mode: VALIDATION_MODE.onSubmit,
    reValidateMode: VALIDATION_MODE.onChange,
    shouldFocusError: true,
};
function createFormControl(props = {}, flushRootRender) {
    let _options = {
        ...defaultOptions,
        ...props,
    };
    let _formState = {
        submitCount: 0,
        isDirty: false,
        isLoading: isFunction(_options.defaultValues),
        isValidating: false,
        isSubmitted: false,
        isSubmitting: false,
        isSubmitSuccessful: false,
        isValid: false,
        touchedFields: {},
        dirtyFields: {},
        errors: _options.errors || {},
        disabled: false,
    };
    let _fields = {};
    let _defaultValues = isObject(_options.defaultValues) || isObject(_options.values)
        ? cloneObject(_options.defaultValues || _options.values) || {}
        : {};
    let _formValues = _options.shouldUnregister
        ? {}
        : cloneObject(_defaultValues);
    let _state = {
        action: false,
        mount: false,
        watch: false,
    };
    let _names = {
        mount: new Set(),
        unMount: new Set(),
        array: new Set(),
        watch: new Set(),
    };
    let delayErrorCallback;
    let timer = 0;
    const _proxyFormState = {
        isDirty: false,
        dirtyFields: false,
        touchedFields: false,
        isValidating: false,
        isValid: false,
        errors: false,
    };
    const _subjects = {
        values: createSubject(),
        array: createSubject(),
        state: createSubject(),
    };
    const shouldCaptureDirtyFields = props.resetOptions && props.resetOptions.keepDirtyValues;
    const validationModeBeforeSubmit = getValidationModes(_options.mode);
    const validationModeAfterSubmit = getValidationModes(_options.reValidateMode);
    const shouldDisplayAllAssociatedErrors = _options.criteriaMode === VALIDATION_MODE.all;
    const debounce = (callback) => (wait) => {
        clearTimeout(timer);
        timer = setTimeout(callback, wait);
    };
    const _updateValid = async (shouldUpdateValid) => {
        if (_proxyFormState.isValid || shouldUpdateValid) {
            const isValid = _options.resolver
                ? isEmptyObject((await _executeSchema()).errors)
                : await executeBuiltInValidation(_fields, true);
            if (isValid !== _formState.isValid) {
                _subjects.state.next({
                    isValid,
                });
            }
        }
    };
    const _updateIsValidating = (value) => _proxyFormState.isValidating &&
        _subjects.state.next({
            isValidating: value,
        });
    const _updateFieldArray = (name, values = [], method, args, shouldSetValues = true, shouldUpdateFieldsAndState = true) => {
        if (args && method) {
            _state.action = true;
            if (shouldUpdateFieldsAndState && Array.isArray(get(_fields, name))) {
                const fieldValues = method(get(_fields, name), args.argA, args.argB);
                shouldSetValues && set(_fields, name, fieldValues);
            }
            if (shouldUpdateFieldsAndState &&
                Array.isArray(get(_formState.errors, name))) {
                const errors = method(get(_formState.errors, name), args.argA, args.argB);
                shouldSetValues && set(_formState.errors, name, errors);
                unsetEmptyArray(_formState.errors, name);
            }
            if (_proxyFormState.touchedFields &&
                shouldUpdateFieldsAndState &&
                Array.isArray(get(_formState.touchedFields, name))) {
                const touchedFields = method(get(_formState.touchedFields, name), args.argA, args.argB);
                shouldSetValues && set(_formState.touchedFields, name, touchedFields);
            }
            if (_proxyFormState.dirtyFields) {
                _formState.dirtyFields = getDirtyFields(_defaultValues, _formValues);
            }
            _subjects.state.next({
                name,
                isDirty: _getDirty(name, values),
                dirtyFields: _formState.dirtyFields,
                errors: _formState.errors,
                isValid: _formState.isValid,
            });
        }
        else {
            set(_formValues, name, values);
        }
    };
    const updateErrors = (name, error) => {
        set(_formState.errors, name, error);
        _subjects.state.next({
            errors: _formState.errors,
        });
    };
    const _setErrors = (errors) => {
        _formState.errors = errors;
        _subjects.state.next({
            errors: _formState.errors,
            isValid: false,
        });
    };
    const updateValidAndValue = (name, shouldSkipSetValueAs, value, ref) => {
        const field = get(_fields, name);
        if (field) {
            const defaultValue = get(_formValues, name, isUndefined(value) ? get(_defaultValues, name) : value);
            isUndefined(defaultValue) ||
                (ref && ref.defaultChecked) ||
                shouldSkipSetValueAs
                ? set(_formValues, name, shouldSkipSetValueAs ? defaultValue : getFieldValue(field._f))
                : setFieldValue(name, defaultValue);
            _state.mount && _updateValid();
        }
    };
    const updateTouchAndDirty = (name, fieldValue, isBlurEvent, shouldDirty, shouldRender) => {
        let shouldUpdateField = false;
        let isPreviousDirty = false;
        const output = {
            name,
        };
        const disabledField = !!(get(_fields, name) && get(_fields, name)._f.disabled);
        if (!isBlurEvent || shouldDirty) {
            if (_proxyFormState.isDirty) {
                isPreviousDirty = _formState.isDirty;
                _formState.isDirty = output.isDirty = _getDirty();
                shouldUpdateField = isPreviousDirty !== output.isDirty;
            }
            const isCurrentFieldPristine = disabledField || deepEqual(get(_defaultValues, name), fieldValue);
            isPreviousDirty = !!(!disabledField && get(_formState.dirtyFields, name));
            isCurrentFieldPristine || disabledField
                ? unset(_formState.dirtyFields, name)
                : set(_formState.dirtyFields, name, true);
            output.dirtyFields = _formState.dirtyFields;
            shouldUpdateField =
                shouldUpdateField ||
                    (_proxyFormState.dirtyFields &&
                        isPreviousDirty !== !isCurrentFieldPristine);
        }
        if (isBlurEvent) {
            const isPreviousFieldTouched = get(_formState.touchedFields, name);
            if (!isPreviousFieldTouched) {
                set(_formState.touchedFields, name, isBlurEvent);
                output.touchedFields = _formState.touchedFields;
                shouldUpdateField =
                    shouldUpdateField ||
                        (_proxyFormState.touchedFields &&
                            isPreviousFieldTouched !== isBlurEvent);
            }
        }
        shouldUpdateField && shouldRender && _subjects.state.next(output);
        return shouldUpdateField ? output : {};
    };
    const shouldRenderByError = (name, isValid, error, fieldState) => {
        const previousFieldError = get(_formState.errors, name);
        const shouldUpdateValid = _proxyFormState.isValid &&
            isBoolean(isValid) &&
            _formState.isValid !== isValid;
        if (props.delayError && error) {
            delayErrorCallback = debounce(() => updateErrors(name, error));
            delayErrorCallback(props.delayError);
        }
        else {
            clearTimeout(timer);
            delayErrorCallback = null;
            error
                ? set(_formState.errors, name, error)
                : unset(_formState.errors, name);
        }
        if ((error ? !deepEqual(previousFieldError, error) : previousFieldError) ||
            !isEmptyObject(fieldState) ||
            shouldUpdateValid) {
            const updatedFormState = {
                ...fieldState,
                ...(shouldUpdateValid && isBoolean(isValid) ? { isValid } : {}),
                errors: _formState.errors,
                name,
            };
            _formState = {
                ..._formState,
                ...updatedFormState,
            };
            _subjects.state.next(updatedFormState);
        }
        _updateIsValidating(false);
    };
    const _executeSchema = async (name) => _options.resolver(_formValues, _options.context, getResolverOptions(name || _names.mount, _fields, _options.criteriaMode, _options.shouldUseNativeValidation));
    const executeSchemaAndUpdateState = async (names) => {
        const { errors } = await _executeSchema(names);
        if (names) {
            for (const name of names) {
                const error = get(errors, name);
                error
                    ? set(_formState.errors, name, error)
                    : unset(_formState.errors, name);
            }
        }
        else {
            _formState.errors = errors;
        }
        return errors;
    };
    const executeBuiltInValidation = async (fields, shouldOnlyCheckValid, context = {
        valid: true,
    }) => {
        for (const name in fields) {
            const field = fields[name];
            if (field) {
                const { _f, ...fieldValue } = field;
                if (_f) {
                    const isFieldArrayRoot = _names.array.has(_f.name);
                    const fieldError = await validateField(field, _formValues, shouldDisplayAllAssociatedErrors, _options.shouldUseNativeValidation && !shouldOnlyCheckValid, isFieldArrayRoot);
                    if (fieldError[_f.name]) {
                        context.valid = false;
                        if (shouldOnlyCheckValid) {
                            break;
                        }
                    }
                    !shouldOnlyCheckValid &&
                        (get(fieldError, _f.name)
                            ? isFieldArrayRoot
                                ? updateFieldArrayRootError(_formState.errors, fieldError, _f.name)
                                : set(_formState.errors, _f.name, fieldError[_f.name])
                            : unset(_formState.errors, _f.name));
                }
                fieldValue &&
                    (await executeBuiltInValidation(fieldValue, shouldOnlyCheckValid, context));
            }
        }
        return context.valid;
    };
    const _removeUnmounted = () => {
        for (const name of _names.unMount) {
            const field = get(_fields, name);
            field &&
                (field._f.refs
                    ? field._f.refs.every((ref) => !live(ref))
                    : !live(field._f.ref)) &&
                unregister(name);
        }
        _names.unMount = new Set();
    };
    const _getDirty = (name, data) => (name && data && set(_formValues, name, data),
        !deepEqual(getValues(), _defaultValues));
    const _getWatch = (names, defaultValue, isGlobal) => generateWatchOutput(names, _names, {
        ...(_state.mount
            ? _formValues
            : isUndefined(defaultValue)
                ? _defaultValues
                : isString(names)
                    ? { [names]: defaultValue }
                    : defaultValue),
    }, isGlobal, defaultValue);
    const _getFieldArray = (name) => compact(get(_state.mount ? _formValues : _defaultValues, name, props.shouldUnregister ? get(_defaultValues, name, []) : []));
    const setFieldValue = (name, value, options = {}) => {
        const field = get(_fields, name);
        let fieldValue = value;
        if (field) {
            const fieldReference = field._f;
            if (fieldReference) {
                !fieldReference.disabled &&
                    set(_formValues, name, getFieldValueAs(value, fieldReference));
                fieldValue =
                    isHTMLElement(fieldReference.ref) && isNullOrUndefined(value)
                        ? ''
                        : value;
                if (isMultipleSelect(fieldReference.ref)) {
                    [...fieldReference.ref.options].forEach((optionRef) => (optionRef.selected = fieldValue.includes(optionRef.value)));
                }
                else if (fieldReference.refs) {
                    if (isCheckBoxInput(fieldReference.ref)) {
                        fieldReference.refs.length > 1
                            ? fieldReference.refs.forEach((checkboxRef) => (!checkboxRef.defaultChecked || !checkboxRef.disabled) &&
                                (checkboxRef.checked = Array.isArray(fieldValue)
                                    ? !!fieldValue.find((data) => data === checkboxRef.value)
                                    : fieldValue === checkboxRef.value))
                            : fieldReference.refs[0] &&
                                (fieldReference.refs[0].checked = !!fieldValue);
                    }
                    else {
                        fieldReference.refs.forEach((radioRef) => (radioRef.checked = radioRef.value === fieldValue));
                    }
                }
                else if (isFileInput(fieldReference.ref)) {
                    fieldReference.ref.value = '';
                }
                else {
                    fieldReference.ref.value = fieldValue;
                    if (!fieldReference.ref.type) {
                        _subjects.values.next({
                            name,
                            values: { ..._formValues },
                        });
                    }
                }
            }
        }
        (options.shouldDirty || options.shouldTouch) &&
            updateTouchAndDirty(name, fieldValue, options.shouldTouch, options.shouldDirty, true);
        options.shouldValidate && trigger(name);
    };
    const setValues = (name, value, options) => {
        for (const fieldKey in value) {
            const fieldValue = value[fieldKey];
            const fieldName = `${name}.${fieldKey}`;
            const field = get(_fields, fieldName);
            (_names.array.has(name) ||
                !isPrimitive(fieldValue) ||
                (field && !field._f)) &&
                !isDateObject(fieldValue)
                ? setValues(fieldName, fieldValue, options)
                : setFieldValue(fieldName, fieldValue, options);
        }
    };
    const setValue = (name, value, options = {}) => {
        const field = get(_fields, name);
        const isFieldArray = _names.array.has(name);
        const cloneValue = cloneObject(value);
        set(_formValues, name, cloneValue);
        if (isFieldArray) {
            _subjects.array.next({
                name,
                values: { ..._formValues },
            });
            if ((_proxyFormState.isDirty || _proxyFormState.dirtyFields) &&
                options.shouldDirty) {
                _subjects.state.next({
                    name,
                    dirtyFields: getDirtyFields(_defaultValues, _formValues),
                    isDirty: _getDirty(name, cloneValue),
                });
            }
        }
        else {
            field && !field._f && !isNullOrUndefined(cloneValue)
                ? setValues(name, cloneValue, options)
                : setFieldValue(name, cloneValue, options);
        }
        isWatched(name, _names) && _subjects.state.next({ ..._formState });
        _subjects.values.next({
            name,
            values: { ..._formValues },
        });
        !_state.mount && flushRootRender();
    };
    const onChange = async (event) => {
        const target = event.target;
        let name = target.name;
        let isFieldValueUpdated = true;
        const field = get(_fields, name);
        const getCurrentFieldValue = () => target.type ? getFieldValue(field._f) : getEventValue(event);
        const _updateIsFieldValueUpdated = (fieldValue) => {
            isFieldValueUpdated =
                Number.isNaN(fieldValue) ||
                    fieldValue === get(_formValues, name, fieldValue);
        };
        if (field) {
            let error;
            let isValid;
            const fieldValue = getCurrentFieldValue();
            const isBlurEvent = event.type === EVENTS.BLUR || event.type === EVENTS.FOCUS_OUT;
            const shouldSkipValidation = (!hasValidation(field._f) &&
                !_options.resolver &&
                !get(_formState.errors, name) &&
                !field._f.deps) ||
                skipValidation(isBlurEvent, get(_formState.touchedFields, name), _formState.isSubmitted, validationModeAfterSubmit, validationModeBeforeSubmit);
            const watched = isWatched(name, _names, isBlurEvent);
            set(_formValues, name, fieldValue);
            if (isBlurEvent) {
                field._f.onBlur && field._f.onBlur(event);
                delayErrorCallback && delayErrorCallback(0);
            }
            else if (field._f.onChange) {
                field._f.onChange(event);
            }
            const fieldState = updateTouchAndDirty(name, fieldValue, isBlurEvent, false);
            const shouldRender = !isEmptyObject(fieldState) || watched;
            !isBlurEvent &&
                _subjects.values.next({
                    name,
                    type: event.type,
                    values: { ..._formValues },
                });
            if (shouldSkipValidation) {
                _proxyFormState.isValid && _updateValid();
                return (shouldRender &&
                    _subjects.state.next({ name, ...(watched ? {} : fieldState) }));
            }
            !isBlurEvent && watched && _subjects.state.next({ ..._formState });
            _updateIsValidating(true);
            if (_options.resolver) {
                const { errors } = await _executeSchema([name]);
                _updateIsFieldValueUpdated(fieldValue);
                if (isFieldValueUpdated) {
                    const previousErrorLookupResult = schemaErrorLookup(_formState.errors, _fields, name);
                    const errorLookupResult = schemaErrorLookup(errors, _fields, previousErrorLookupResult.name || name);
                    error = errorLookupResult.error;
                    name = errorLookupResult.name;
                    isValid = isEmptyObject(errors);
                }
            }
            else {
                error = (await validateField(field, _formValues, shouldDisplayAllAssociatedErrors, _options.shouldUseNativeValidation))[name];
                _updateIsFieldValueUpdated(fieldValue);
                if (isFieldValueUpdated) {
                    if (error) {
                        isValid = false;
                    }
                    else if (_proxyFormState.isValid) {
                        isValid = await executeBuiltInValidation(_fields, true);
                    }
                }
            }
            if (isFieldValueUpdated) {
                field._f.deps &&
                    trigger(field._f.deps);
                shouldRenderByError(name, isValid, error, fieldState);
            }
        }
    };
    const _focusInput = (ref, key) => {
        if (get(_formState.errors, key) && ref.focus) {
            ref.focus();
            return 1;
        }
        return;
    };
    const trigger = async (name, options = {}) => {
        let isValid;
        let validationResult;
        const fieldNames = convertToArrayPayload(name);
        _updateIsValidating(true);
        if (_options.resolver) {
            const errors = await executeSchemaAndUpdateState(isUndefined(name) ? name : fieldNames);
            isValid = isEmptyObject(errors);
            validationResult = name
                ? !fieldNames.some((name) => get(errors, name))
                : isValid;
        }
        else if (name) {
            validationResult = (await Promise.all(fieldNames.map(async (fieldName) => {
                const field = get(_fields, fieldName);
                return await executeBuiltInValidation(field && field._f ? { [fieldName]: field } : field);
            }))).every(Boolean);
            !(!validationResult && !_formState.isValid) && _updateValid();
        }
        else {
            validationResult = isValid = await executeBuiltInValidation(_fields);
        }
        _subjects.state.next({
            ...(!isString(name) ||
                (_proxyFormState.isValid && isValid !== _formState.isValid)
                ? {}
                : { name }),
            ...(_options.resolver || !name ? { isValid } : {}),
            errors: _formState.errors,
            isValidating: false,
        });
        options.shouldFocus &&
            !validationResult &&
            iterateFieldsByAction(_fields, _focusInput, name ? fieldNames : _names.mount);
        return validationResult;
    };
    const getValues = (fieldNames) => {
        const values = {
            ..._defaultValues,
            ...(_state.mount ? _formValues : {}),
        };
        return isUndefined(fieldNames)
            ? values
            : isString(fieldNames)
                ? get(values, fieldNames)
                : fieldNames.map((name) => get(values, name));
    };
    const getFieldState = (name, formState) => ({
        invalid: !!get((formState || _formState).errors, name),
        isDirty: !!get((formState || _formState).dirtyFields, name),
        isTouched: !!get((formState || _formState).touchedFields, name),
        error: get((formState || _formState).errors, name),
    });
    const clearErrors = (name) => {
        name &&
            convertToArrayPayload(name).forEach((inputName) => unset(_formState.errors, inputName));
        _subjects.state.next({
            errors: name ? _formState.errors : {},
        });
    };
    const setError = (name, error, options) => {
        const ref = (get(_fields, name, { _f: {} })._f || {}).ref;
        set(_formState.errors, name, {
            ...error,
            ref,
        });
        _subjects.state.next({
            name,
            errors: _formState.errors,
            isValid: false,
        });
        options && options.shouldFocus && ref && ref.focus && ref.focus();
    };
    const watch = (name, defaultValue) => isFunction(name)
        ? _subjects.values.subscribe({
            next: (payload) => name(_getWatch(undefined, defaultValue), payload),
        })
        : _getWatch(name, defaultValue, true);
    const unregister = (name, options = {}) => {
        for (const fieldName of name ? convertToArrayPayload(name) : _names.mount) {
            _names.mount.delete(fieldName);
            _names.array.delete(fieldName);
            if (!options.keepValue) {
                unset(_fields, fieldName);
                unset(_formValues, fieldName);
            }
            !options.keepError && unset(_formState.errors, fieldName);
            !options.keepDirty && unset(_formState.dirtyFields, fieldName);
            !options.keepTouched && unset(_formState.touchedFields, fieldName);
            !_options.shouldUnregister &&
                !options.keepDefaultValue &&
                unset(_defaultValues, fieldName);
        }
        _subjects.values.next({
            values: { ..._formValues },
        });
        _subjects.state.next({
            ..._formState,
            ...(!options.keepDirty ? {} : { isDirty: _getDirty() }),
        });
        !options.keepIsValid && _updateValid();
    };
    const _updateDisabledField = ({ disabled, name, field, fields, value, }) => {
        if (isBoolean(disabled)) {
            const inputValue = disabled
                ? undefined
                : isUndefined(value)
                    ? getFieldValue(field ? field._f : get(fields, name)._f)
                    : value;
            set(_formValues, name, inputValue);
            updateTouchAndDirty(name, inputValue, false, false, true);
        }
    };
    const register = (name, options = {}) => {
        let field = get(_fields, name);
        const disabledIsDefined = isBoolean(options.disabled);
        set(_fields, name, {
            ...(field || {}),
            _f: {
                ...(field && field._f ? field._f : { ref: { name } }),
                name,
                mount: true,
                ...options,
            },
        });
        _names.mount.add(name);
        if (field) {
            _updateDisabledField({
                field,
                disabled: options.disabled,
                name,
                value: options.value,
            });
        }
        else {
            updateValidAndValue(name, true, options.value);
        }
        return {
            ...(disabledIsDefined ? { disabled: options.disabled } : {}),
            ...(_options.progressive
                ? {
                    required: !!options.required,
                    min: getRuleValue(options.min),
                    max: getRuleValue(options.max),
                    minLength: getRuleValue(options.minLength),
                    maxLength: getRuleValue(options.maxLength),
                    pattern: getRuleValue(options.pattern),
                }
                : {}),
            name,
            onChange,
            onBlur: onChange,
            ref: (ref) => {
                if (ref) {
                    register(name, options);
                    field = get(_fields, name);
                    const fieldRef = isUndefined(ref.value)
                        ? ref.querySelectorAll
                            ? ref.querySelectorAll('input,select,textarea')[0] || ref
                            : ref
                        : ref;
                    const radioOrCheckbox = isRadioOrCheckbox(fieldRef);
                    const refs = field._f.refs || [];
                    if (radioOrCheckbox
                        ? refs.find((option) => option === fieldRef)
                        : fieldRef === field._f.ref) {
                        return;
                    }
                    set(_fields, name, {
                        _f: {
                            ...field._f,
                            ...(radioOrCheckbox
                                ? {
                                    refs: [
                                        ...refs.filter(live),
                                        fieldRef,
                                        ...(Array.isArray(get(_defaultValues, name)) ? [{}] : []),
                                    ],
                                    ref: { type: fieldRef.type, name },
                                }
                                : { ref: fieldRef }),
                        },
                    });
                    updateValidAndValue(name, false, undefined, fieldRef);
                }
                else {
                    field = get(_fields, name, {});
                    if (field._f) {
                        field._f.mount = false;
                    }
                    (_options.shouldUnregister || options.shouldUnregister) &&
                        !(isNameInFieldArray(_names.array, name) && _state.action) &&
                        _names.unMount.add(name);
                }
            },
        };
    };
    const _focusError = () => _options.shouldFocusError &&
        iterateFieldsByAction(_fields, _focusInput, _names.mount);
    const _disableForm = (disabled) => {
        if (isBoolean(disabled)) {
            _subjects.state.next({ disabled });
            iterateFieldsByAction(_fields, (ref, name) => {
                let requiredDisabledState = disabled;
                const currentField = get(_fields, name);
                if (currentField && isBoolean(currentField._f.disabled)) {
                    requiredDisabledState || (requiredDisabledState = currentField._f.disabled);
                }
                ref.disabled = requiredDisabledState;
            }, 0, false);
        }
    };
    const handleSubmit = (onValid, onInvalid) => async (e) => {
        if (e) {
            e.preventDefault && e.preventDefault();
            e.persist && e.persist();
        }
        let fieldValues = cloneObject(_formValues);
        _subjects.state.next({
            isSubmitting: true,
        });
        if (_options.resolver) {
            const { errors, values } = await _executeSchema();
            _formState.errors = errors;
            fieldValues = values;
        }
        else {
            await executeBuiltInValidation(_fields);
        }
        unset(_formState.errors, 'root');
        if (isEmptyObject(_formState.errors)) {
            _subjects.state.next({
                errors: {},
            });
            await onValid(fieldValues, e);
        }
        else {
            if (onInvalid) {
                await onInvalid({ ..._formState.errors }, e);
            }
            _focusError();
            setTimeout(_focusError);
        }
        _subjects.state.next({
            isSubmitted: true,
            isSubmitting: false,
            isSubmitSuccessful: isEmptyObject(_formState.errors),
            submitCount: _formState.submitCount + 1,
            errors: _formState.errors,
        });
    };
    const resetField = (name, options = {}) => {
        if (get(_fields, name)) {
            if (isUndefined(options.defaultValue)) {
                setValue(name, get(_defaultValues, name));
            }
            else {
                setValue(name, options.defaultValue);
                set(_defaultValues, name, options.defaultValue);
            }
            if (!options.keepTouched) {
                unset(_formState.touchedFields, name);
            }
            if (!options.keepDirty) {
                unset(_formState.dirtyFields, name);
                _formState.isDirty = options.defaultValue
                    ? _getDirty(name, get(_defaultValues, name))
                    : _getDirty();
            }
            if (!options.keepError) {
                unset(_formState.errors, name);
                _proxyFormState.isValid && _updateValid();
            }
            _subjects.state.next({ ..._formState });
        }
    };
    const _reset = (formValues, keepStateOptions = {}) => {
        const updatedValues = formValues ? cloneObject(formValues) : _defaultValues;
        const cloneUpdatedValues = cloneObject(updatedValues);
        const values = formValues && !isEmptyObject(formValues)
            ? cloneUpdatedValues
            : _defaultValues;
        if (!keepStateOptions.keepDefaultValues) {
            _defaultValues = updatedValues;
        }
        if (!keepStateOptions.keepValues) {
            if (keepStateOptions.keepDirtyValues || shouldCaptureDirtyFields) {
                for (const fieldName of _names.mount) {
                    get(_formState.dirtyFields, fieldName)
                        ? set(values, fieldName, get(_formValues, fieldName))
                        : setValue(fieldName, get(values, fieldName));
                }
            }
            else {
                if (isWeb && isUndefined(formValues)) {
                    for (const name of _names.mount) {
                        const field = get(_fields, name);
                        if (field && field._f) {
                            const fieldReference = Array.isArray(field._f.refs)
                                ? field._f.refs[0]
                                : field._f.ref;
                            if (isHTMLElement(fieldReference)) {
                                const form = fieldReference.closest('form');
                                if (form) {
                                    form.reset();
                                    break;
                                }
                            }
                        }
                    }
                }
                _fields = {};
            }
            _formValues = props.shouldUnregister
                ? keepStateOptions.keepDefaultValues
                    ? cloneObject(_defaultValues)
                    : {}
                : cloneObject(values);
            _subjects.array.next({
                values: { ...values },
            });
            _subjects.values.next({
                values: { ...values },
            });
        }
        _names = {
            mount: new Set(),
            unMount: new Set(),
            array: new Set(),
            watch: new Set(),
            watchAll: false,
            focus: '',
        };
        !_state.mount && flushRootRender();
        _state.mount = !_proxyFormState.isValid || !!keepStateOptions.keepIsValid;
        _state.watch = !!props.shouldUnregister;
        _subjects.state.next({
            submitCount: keepStateOptions.keepSubmitCount
                ? _formState.submitCount
                : 0,
            isDirty: keepStateOptions.keepDirty
                ? _formState.isDirty
                : !!(keepStateOptions.keepDefaultValues &&
                    !deepEqual(formValues, _defaultValues)),
            isSubmitted: keepStateOptions.keepIsSubmitted
                ? _formState.isSubmitted
                : false,
            dirtyFields: keepStateOptions.keepDirtyValues
                ? _formState.dirtyFields
                : keepStateOptions.keepDefaultValues && formValues
                    ? getDirtyFields(_defaultValues, formValues)
                    : {},
            touchedFields: keepStateOptions.keepTouched
                ? _formState.touchedFields
                : {},
            errors: keepStateOptions.keepErrors ? _formState.errors : {},
            isSubmitSuccessful: keepStateOptions.keepIsSubmitSuccessful
                ? _formState.isSubmitSuccessful
                : false,
            isSubmitting: false,
        });
    };
    const reset = (formValues, keepStateOptions) => _reset(isFunction(formValues)
        ? formValues(_formValues)
        : formValues, keepStateOptions);
    const setFocus = (name, options = {}) => {
        const field = get(_fields, name);
        const fieldReference = field && field._f;
        if (fieldReference) {
            const fieldRef = fieldReference.refs
                ? fieldReference.refs[0]
                : fieldReference.ref;
            if (fieldRef.focus) {
                fieldRef.focus();
                options.shouldSelect && fieldRef.select();
            }
        }
    };
    const _updateFormState = (updatedFormState) => {
        _formState = {
            ..._formState,
            ...updatedFormState,
        };
    };
    const _resetDefaultValues = () => isFunction(_options.defaultValues) &&
        _options.defaultValues().then((values) => {
            reset(values, _options.resetOptions);
            _subjects.state.next({
                isLoading: false,
            });
        });
    return {
        control: {
            register,
            unregister,
            getFieldState,
            handleSubmit,
            setError,
            _executeSchema,
            _getWatch,
            _getDirty,
            _updateValid,
            _removeUnmounted,
            _updateFieldArray,
            _updateDisabledField,
            _getFieldArray,
            _reset,
            _resetDefaultValues,
            _updateFormState,
            _disableForm,
            _subjects,
            _proxyFormState,
            _setErrors,
            get _fields() {
                return _fields;
            },
            get _formValues() {
                return _formValues;
            },
            get _state() {
                return _state;
            },
            set _state(value) {
                _state = value;
            },
            get _defaultValues() {
                return _defaultValues;
            },
            get _names() {
                return _names;
            },
            set _names(value) {
                _names = value;
            },
            get _formState() {
                return _formState;
            },
            set _formState(value) {
                _formState = value;
            },
            get _options() {
                return _options;
            },
            set _options(value) {
                _options = {
                    ..._options,
                    ...value,
                };
            },
        },
        trigger,
        register,
        handleSubmit,
        watch,
        setValue,
        getValues,
        reset,
        resetField,
        clearErrors,
        unregister,
        setError,
        setFocus,
        getFieldState,
    };
}

/**
 * Custom hook to manage the entire form.
 *
 * @remarks
 * [API](https://react-hook-form.com/docs/useform) • [Demo](https://codesandbox.io/s/react-hook-form-get-started-ts-5ksmm) • [Video](https://www.youtube.com/watch?v=RkXv4AXXC_4)
 *
 * @param props - form configuration and validation parameters.
 *
 * @returns methods - individual functions to manage the form state. {@link UseFormReturn}
 *
 * @example
 * ```tsx
 * function App() {
 *   const { register, handleSubmit, watch, formState: { errors } } = useForm();
 *   const onSubmit = data => console.log(data);
 *
 *   console.log(watch("example"));
 *
 *   return (
 *     <form onSubmit={handleSubmit(onSubmit)}>
 *       <input defaultValue="test" {...register("example")} />
 *       <input {...register("exampleRequired", { required: true })} />
 *       {errors.exampleRequired && <span>This field is required</span>}
 *       <button>Submit</button>
 *     </form>
 *   );
 * }
 * ```
 */
function useForm(props = {}) {
    const _formControl = react__WEBPACK_IMPORTED_MODULE_0__.useRef();
    const _values = react__WEBPACK_IMPORTED_MODULE_0__.useRef();
    const [formState, updateFormState] = react__WEBPACK_IMPORTED_MODULE_0__.useState({
        isDirty: false,
        isValidating: false,
        isLoading: isFunction(props.defaultValues),
        isSubmitted: false,
        isSubmitting: false,
        isSubmitSuccessful: false,
        isValid: false,
        submitCount: 0,
        dirtyFields: {},
        touchedFields: {},
        errors: props.errors || {},
        disabled: false,
        defaultValues: isFunction(props.defaultValues)
            ? undefined
            : props.defaultValues,
    });
    if (!_formControl.current) {
        _formControl.current = {
            ...createFormControl(props, () => updateFormState((formState) => ({ ...formState }))),
            formState,
        };
    }
    const control = _formControl.current.control;
    control._options = props;
    useSubscribe({
        subject: control._subjects.state,
        next: (value) => {
            if (shouldRenderFormState(value, control._proxyFormState, control._updateFormState, true)) {
                updateFormState({ ...control._formState });
            }
        },
    });
    react__WEBPACK_IMPORTED_MODULE_0__.useEffect(() => control._disableForm(props.disabled), [control, props.disabled]);
    react__WEBPACK_IMPORTED_MODULE_0__.useEffect(() => {
        if (control._proxyFormState.isDirty) {
            const isDirty = control._getDirty();
            if (isDirty !== formState.isDirty) {
                control._subjects.state.next({
                    isDirty,
                });
            }
        }
    }, [control, formState.isDirty]);
    react__WEBPACK_IMPORTED_MODULE_0__.useEffect(() => {
        if (props.values && !deepEqual(props.values, _values.current)) {
            control._reset(props.values, control._options.resetOptions);
            _values.current = props.values;
            updateFormState((state) => ({ ...state }));
        }
        else {
            control._resetDefaultValues();
        }
    }, [props.values, control]);
    react__WEBPACK_IMPORTED_MODULE_0__.useEffect(() => {
        if (props.errors) {
            control._setErrors(props.errors);
        }
    }, [props.errors, control]);
    react__WEBPACK_IMPORTED_MODULE_0__.useEffect(() => {
        if (!control._state.mount) {
            control._updateValid();
            control._state.mount = true;
        }
        if (control._state.watch) {
            control._state.watch = false;
            control._subjects.state.next({ ...control._formState });
        }
        control._removeUnmounted();
    });
    _formControl.current.formState = getProxyFormState(formState, control);
    return _formControl.current;
}


//# sourceMappingURL=index.esm.mjs.map


/***/ }),

/***/ 42708:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "YD": function() { return /* binding */ useInView; }
/* harmony export */ });
/* unused harmony exports InView, defaultFallbackInView, observe */
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(55784);
"use client";
var __defProp = Object.defineProperty;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __publicField = (obj, key, value) => {
  __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
  return value;
};

// src/InView.tsx


// src/observe.ts
var observerMap = /* @__PURE__ */ new Map();
var RootIds = /* @__PURE__ */ new WeakMap();
var rootId = 0;
var unsupportedValue = void 0;
function defaultFallbackInView(inView) {
  unsupportedValue = inView;
}
function getRootId(root) {
  if (!root)
    return "0";
  if (RootIds.has(root))
    return RootIds.get(root);
  rootId += 1;
  RootIds.set(root, rootId.toString());
  return RootIds.get(root);
}
function optionsToId(options) {
  return Object.keys(options).sort().filter(
    (key) => options[key] !== void 0
  ).map((key) => {
    return `${key}_${key === "root" ? getRootId(options.root) : options[key]}`;
  }).toString();
}
function createObserver(options) {
  let id = optionsToId(options);
  let instance = observerMap.get(id);
  if (!instance) {
    const elements = /* @__PURE__ */ new Map();
    let thresholds;
    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        var _a;
        const inView = entry.isIntersecting && thresholds.some((threshold) => entry.intersectionRatio >= threshold);
        if (options.trackVisibility && typeof entry.isVisible === "undefined") {
          entry.isVisible = inView;
        }
        (_a = elements.get(entry.target)) == null ? void 0 : _a.forEach((callback) => {
          callback(inView, entry);
        });
      });
    }, options);
    thresholds = observer.thresholds || (Array.isArray(options.threshold) ? options.threshold : [options.threshold || 0]);
    instance = {
      id,
      observer,
      elements
    };
    observerMap.set(id, instance);
  }
  return instance;
}
function observe(element, callback, options = {}, fallbackInView = unsupportedValue) {
  if (typeof window.IntersectionObserver === "undefined" && fallbackInView !== void 0) {
    const bounds = element.getBoundingClientRect();
    callback(fallbackInView, {
      isIntersecting: fallbackInView,
      target: element,
      intersectionRatio: typeof options.threshold === "number" ? options.threshold : 0,
      time: 0,
      boundingClientRect: bounds,
      intersectionRect: bounds,
      rootBounds: bounds
    });
    return () => {
    };
  }
  const { id, observer, elements } = createObserver(options);
  let callbacks = elements.get(element) || [];
  if (!elements.has(element)) {
    elements.set(element, callbacks);
  }
  callbacks.push(callback);
  observer.observe(element);
  return function unobserve() {
    callbacks.splice(callbacks.indexOf(callback), 1);
    if (callbacks.length === 0) {
      elements.delete(element);
      observer.unobserve(element);
    }
    if (elements.size === 0) {
      observer.disconnect();
      observerMap.delete(id);
    }
  };
}

// src/InView.tsx
function isPlainChildren(props) {
  return typeof props.children !== "function";
}
var InView = class extends react__WEBPACK_IMPORTED_MODULE_0__.Component {
  constructor(props) {
    super(props);
    __publicField(this, "node", null);
    __publicField(this, "_unobserveCb", null);
    __publicField(this, "handleNode", (node) => {
      if (this.node) {
        this.unobserve();
        if (!node && !this.props.triggerOnce && !this.props.skip) {
          this.setState({ inView: !!this.props.initialInView, entry: void 0 });
        }
      }
      this.node = node ? node : null;
      this.observeNode();
    });
    __publicField(this, "handleChange", (inView, entry) => {
      if (inView && this.props.triggerOnce) {
        this.unobserve();
      }
      if (!isPlainChildren(this.props)) {
        this.setState({ inView, entry });
      }
      if (this.props.onChange) {
        this.props.onChange(inView, entry);
      }
    });
    this.state = {
      inView: !!props.initialInView,
      entry: void 0
    };
  }
  componentDidMount() {
    this.unobserve();
    this.observeNode();
  }
  componentDidUpdate(prevProps) {
    if (prevProps.rootMargin !== this.props.rootMargin || prevProps.root !== this.props.root || prevProps.threshold !== this.props.threshold || prevProps.skip !== this.props.skip || prevProps.trackVisibility !== this.props.trackVisibility || prevProps.delay !== this.props.delay) {
      this.unobserve();
      this.observeNode();
    }
  }
  componentWillUnmount() {
    this.unobserve();
  }
  observeNode() {
    if (!this.node || this.props.skip)
      return;
    const {
      threshold,
      root,
      rootMargin,
      trackVisibility,
      delay,
      fallbackInView
    } = this.props;
    this._unobserveCb = observe(
      this.node,
      this.handleChange,
      {
        threshold,
        root,
        rootMargin,
        // @ts-ignore
        trackVisibility,
        // @ts-ignore
        delay
      },
      fallbackInView
    );
  }
  unobserve() {
    if (this._unobserveCb) {
      this._unobserveCb();
      this._unobserveCb = null;
    }
  }
  render() {
    const { children } = this.props;
    if (typeof children === "function") {
      const { inView, entry } = this.state;
      return children({ inView, entry, ref: this.handleNode });
    }
    const {
      as,
      triggerOnce,
      threshold,
      root,
      rootMargin,
      onChange,
      skip,
      trackVisibility,
      delay,
      initialInView,
      fallbackInView,
      ...props
    } = this.props;
    return React.createElement(
      as || "div",
      { ref: this.handleNode, ...props },
      children
    );
  }
};

// src/useInView.tsx

function useInView({
  threshold,
  delay,
  trackVisibility,
  rootMargin,
  root,
  triggerOnce,
  skip,
  initialInView,
  fallbackInView,
  onChange
} = {}) {
  var _a;
  const [ref, setRef] = react__WEBPACK_IMPORTED_MODULE_0__.useState(null);
  const callback = react__WEBPACK_IMPORTED_MODULE_0__.useRef();
  const [state, setState] = react__WEBPACK_IMPORTED_MODULE_0__.useState({
    inView: !!initialInView,
    entry: void 0
  });
  callback.current = onChange;
  react__WEBPACK_IMPORTED_MODULE_0__.useEffect(
    () => {
      if (skip || !ref)
        return;
      let unobserve;
      unobserve = observe(
        ref,
        (inView, entry) => {
          setState({
            inView,
            entry
          });
          if (callback.current)
            callback.current(inView, entry);
          if (entry.isIntersecting && triggerOnce && unobserve) {
            unobserve();
            unobserve = void 0;
          }
        },
        {
          root,
          rootMargin,
          threshold,
          // @ts-ignore
          trackVisibility,
          // @ts-ignore
          delay
        },
        fallbackInView
      );
      return () => {
        if (unobserve) {
          unobserve();
        }
      };
    },
    // We break the rule here, because we aren't including the actual `threshold` variable
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [
      // If the threshold is an array, convert it to a string, so it won't change between renders.
      // eslint-disable-next-line react-hooks/exhaustive-deps
      Array.isArray(threshold) ? threshold.toString() : threshold,
      ref,
      root,
      rootMargin,
      triggerOnce,
      skip,
      trackVisibility,
      fallbackInView,
      delay
    ]
  );
  const entryTarget = (_a = state.entry) == null ? void 0 : _a.target;
  const previousEntryTarget = react__WEBPACK_IMPORTED_MODULE_0__.useRef();
  if (!ref && entryTarget && !triggerOnce && !skip && previousEntryTarget.current !== entryTarget) {
    previousEntryTarget.current = entryTarget;
    setState({
      inView: !!initialInView,
      entry: void 0
    });
  }
  const result = [setRef, state.inView, state.entry];
  result.ref = result[0];
  result.inView = result[1];
  result.entry = result[2];
  return result;
}

//# sourceMappingURL=index.mjs.map

/***/ }),

/***/ 30719:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "tq": function() { return /* reexport */ Swiper; },
  "o5": function() { return /* reexport */ SwiperSlide; }
});

// UNUSED EXPORTS: useSwiper, useSwiperSlide

// EXTERNAL MODULE: ./node_modules/next/dist/compiled/react/index.js
var react = __webpack_require__(55784);
// EXTERNAL MODULE: ./node_modules/swiper/swiper.esm.js + 90 modules
var swiper_esm = __webpack_require__(71911);
;// CONCATENATED MODULE: ./node_modules/swiper/components-shared/utils.js
function isObject(o) {
  return typeof o === 'object' && o !== null && o.constructor && Object.prototype.toString.call(o).slice(8, -1) === 'Object';
}

function extend(target, src) {
  const noExtend = ['__proto__', 'constructor', 'prototype'];
  Object.keys(src).filter(key => noExtend.indexOf(key) < 0).forEach(key => {
    if (typeof target[key] === 'undefined') target[key] = src[key];else if (isObject(src[key]) && isObject(target[key]) && Object.keys(src[key]).length > 0) {
      if (src[key].__swiper__) target[key] = src[key];else extend(target[key], src[key]);
    } else {
      target[key] = src[key];
    }
  });
}

function needsNavigation(params = {}) {
  return params.navigation && typeof params.navigation.nextEl === 'undefined' && typeof params.navigation.prevEl === 'undefined';
}

function needsPagination(params = {}) {
  return params.pagination && typeof params.pagination.el === 'undefined';
}

function needsScrollbar(params = {}) {
  return params.scrollbar && typeof params.scrollbar.el === 'undefined';
}

function uniqueClasses(classNames = '') {
  const classes = classNames.split(' ').map(c => c.trim()).filter(c => !!c);
  const unique = [];
  classes.forEach(c => {
    if (unique.indexOf(c) < 0) unique.push(c);
  });
  return unique.join(' ');
}


;// CONCATENATED MODULE: ./node_modules/swiper/components-shared/params-list.js
/* underscore in name -> watch for changes */
const paramsList = ['modules', 'init', '_direction', 'touchEventsTarget', 'initialSlide', '_speed', 'cssMode', 'updateOnWindowResize', 'resizeObserver', 'nested', 'focusableElements', '_enabled', '_width', '_height', 'preventInteractionOnTransition', 'userAgent', 'url', '_edgeSwipeDetection', '_edgeSwipeThreshold', '_freeMode', '_autoHeight', 'setWrapperSize', 'virtualTranslate', '_effect', 'breakpoints', '_spaceBetween', '_slidesPerView', 'maxBackfaceHiddenSlides', '_grid', '_slidesPerGroup', '_slidesPerGroupSkip', '_slidesPerGroupAuto', '_centeredSlides', '_centeredSlidesBounds', '_slidesOffsetBefore', '_slidesOffsetAfter', 'normalizeSlideIndex', '_centerInsufficientSlides', '_watchOverflow', 'roundLengths', 'touchRatio', 'touchAngle', 'simulateTouch', '_shortSwipes', '_longSwipes', 'longSwipesRatio', 'longSwipesMs', '_followFinger', 'allowTouchMove', '_threshold', 'touchMoveStopPropagation', 'touchStartPreventDefault', 'touchStartForcePreventDefault', 'touchReleaseOnEdges', 'uniqueNavElements', '_resistance', '_resistanceRatio', '_watchSlidesProgress', '_grabCursor', 'preventClicks', 'preventClicksPropagation', '_slideToClickedSlide', '_preloadImages', 'updateOnImagesReady', '_loop', '_loopAdditionalSlides', '_loopedSlides', '_loopedSlidesLimit', '_loopFillGroupWithBlank', 'loopPreventsSlide', '_rewind', '_allowSlidePrev', '_allowSlideNext', '_swipeHandler', '_noSwiping', 'noSwipingClass', 'noSwipingSelector', 'passiveListeners', 'containerModifierClass', 'slideClass', 'slideBlankClass', 'slideActiveClass', 'slideDuplicateActiveClass', 'slideVisibleClass', 'slideDuplicateClass', 'slideNextClass', 'slideDuplicateNextClass', 'slidePrevClass', 'slideDuplicatePrevClass', 'wrapperClass', 'runCallbacksOnInit', 'observer', 'observeParents', 'observeSlideChildren', // modules
'a11y', '_autoplay', '_controller', 'coverflowEffect', 'cubeEffect', 'fadeEffect', 'flipEffect', 'creativeEffect', 'cardsEffect', 'hashNavigation', 'history', 'keyboard', 'lazy', 'mousewheel', '_navigation', '_pagination', 'parallax', '_scrollbar', '_thumbs', 'virtual', 'zoom'];

;// CONCATENATED MODULE: ./node_modules/swiper/components-shared/get-params.js




function getParams(obj = {}, splitEvents = true) {
  const params = {
    on: {}
  };
  const events = {};
  const passedParams = {};
  extend(params, swiper_esm/* default.defaults */.ZP.defaults);
  extend(params, swiper_esm/* default.extendedDefaults */.ZP.extendedDefaults);
  params._emitClasses = true;
  params.init = false;
  const rest = {};
  const allowedParams = paramsList.map(key => key.replace(/_/, ''));
  const plainObj = Object.assign({}, obj);
  Object.keys(plainObj).forEach(key => {
    if (typeof obj[key] === 'undefined') return;

    if (allowedParams.indexOf(key) >= 0) {
      if (isObject(obj[key])) {
        params[key] = {};
        passedParams[key] = {};
        extend(params[key], obj[key]);
        extend(passedParams[key], obj[key]);
      } else {
        params[key] = obj[key];
        passedParams[key] = obj[key];
      }
    } else if (key.search(/on[A-Z]/) === 0 && typeof obj[key] === 'function') {
      if (splitEvents) {
        events[`${key[2].toLowerCase()}${key.substr(3)}`] = obj[key];
      } else {
        params.on[`${key[2].toLowerCase()}${key.substr(3)}`] = obj[key];
      }
    } else {
      rest[key] = obj[key];
    }
  });
  ['navigation', 'pagination', 'scrollbar'].forEach(key => {
    if (params[key] === true) params[key] = {};
    if (params[key] === false) delete params[key];
  });
  return {
    params,
    passedParams,
    rest,
    events
  };
}


;// CONCATENATED MODULE: ./node_modules/swiper/components-shared/mount-swiper.js


function mountSwiper({
  el,
  nextEl,
  prevEl,
  paginationEl,
  scrollbarEl,
  swiper
}, swiperParams) {
  if (needsNavigation(swiperParams) && nextEl && prevEl) {
    swiper.params.navigation.nextEl = nextEl;
    swiper.originalParams.navigation.nextEl = nextEl;
    swiper.params.navigation.prevEl = prevEl;
    swiper.originalParams.navigation.prevEl = prevEl;
  }

  if (needsPagination(swiperParams) && paginationEl) {
    swiper.params.pagination.el = paginationEl;
    swiper.originalParams.pagination.el = paginationEl;
  }

  if (needsScrollbar(swiperParams) && scrollbarEl) {
    swiper.params.scrollbar.el = scrollbarEl;
    swiper.originalParams.scrollbar.el = scrollbarEl;
  }

  swiper.init(el);
}


;// CONCATENATED MODULE: ./node_modules/swiper/shared/calc-looped-slides.js

const calcLoopedSlides = (slides, swiperParams) => {
  let slidesPerViewParams = swiperParams.slidesPerView;

  if (swiperParams.breakpoints) {
    const breakpoint = swiper_esm/* default.prototype.getBreakpoint */.ZP.prototype.getBreakpoint(swiperParams.breakpoints);
    const breakpointOnlyParams = breakpoint in swiperParams.breakpoints ? swiperParams.breakpoints[breakpoint] : undefined;

    if (breakpointOnlyParams && breakpointOnlyParams.slidesPerView) {
      slidesPerViewParams = breakpointOnlyParams.slidesPerView;
    }
  }

  let loopedSlides = Math.ceil(parseFloat(swiperParams.loopedSlides || slidesPerViewParams, 10));
  loopedSlides += swiperParams.loopAdditionalSlides;

  if (loopedSlides > slides.length && swiperParams.loopedSlidesLimit) {
    loopedSlides = slides.length;
  }

  return loopedSlides;
};
;// CONCATENATED MODULE: ./node_modules/swiper/react/loop.js



function renderLoop(swiper, slides, swiperParams) {
  const modifiedSlides = slides.map((child, index) => {
    return /*#__PURE__*/react.cloneElement(child, {
      swiper,
      'data-swiper-slide-index': index
    });
  });

  function duplicateSlide(child, index, position) {
    return /*#__PURE__*/react.cloneElement(child, {
      key: `${child.key}-duplicate-${index}-${position}`,
      className: `${child.props.className || ''} ${swiperParams.slideDuplicateClass}`
    });
  }

  if (swiperParams.loopFillGroupWithBlank) {
    const blankSlidesNum = swiperParams.slidesPerGroup - modifiedSlides.length % swiperParams.slidesPerGroup;

    if (blankSlidesNum !== swiperParams.slidesPerGroup) {
      for (let i = 0; i < blankSlidesNum; i += 1) {
        const blankSlide = /*#__PURE__*/react.createElement("div", {
          className: `${swiperParams.slideClass} ${swiperParams.slideBlankClass}`
        });
        modifiedSlides.push(blankSlide);
      }
    }
  }

  if (swiperParams.slidesPerView === 'auto' && !swiperParams.loopedSlides) {
    swiperParams.loopedSlides = modifiedSlides.length;
  }

  const loopedSlides = calcLoopedSlides(modifiedSlides, swiperParams);
  const prependSlides = [];
  const appendSlides = [];

  for (let i = 0; i < loopedSlides; i += 1) {
    const index = i - Math.floor(i / modifiedSlides.length) * modifiedSlides.length;
    appendSlides.push(duplicateSlide(modifiedSlides[index], i, 'append'));
    prependSlides.unshift(duplicateSlide(modifiedSlides[modifiedSlides.length - index - 1], i, 'prepend'));
  }

  if (swiper) {
    swiper.loopedSlides = loopedSlides;
  }

  return [...prependSlides, ...modifiedSlides, ...appendSlides];
}


;// CONCATENATED MODULE: ./node_modules/swiper/components-shared/get-changed-params.js



function getChangedParams(swiperParams, oldParams, children, oldChildren, getKey) {
  const keys = [];
  if (!oldParams) return keys;

  const addKey = key => {
    if (keys.indexOf(key) < 0) keys.push(key);
  };

  if (children && oldChildren) {
    const oldChildrenKeys = oldChildren.map(getKey);
    const childrenKeys = children.map(getKey);
    if (oldChildrenKeys.join('') !== childrenKeys.join('')) addKey('children');
    if (oldChildren.length !== children.length) addKey('children');
  }

  const watchParams = paramsList.filter(key => key[0] === '_').map(key => key.replace(/_/, ''));
  watchParams.forEach(key => {
    if (key in swiperParams && key in oldParams) {
      if (isObject(swiperParams[key]) && isObject(oldParams[key])) {
        const newKeys = Object.keys(swiperParams[key]);
        const oldKeys = Object.keys(oldParams[key]);

        if (newKeys.length !== oldKeys.length) {
          addKey(key);
        } else {
          newKeys.forEach(newKey => {
            if (swiperParams[key][newKey] !== oldParams[key][newKey]) {
              addKey(key);
            }
          });
          oldKeys.forEach(oldKey => {
            if (swiperParams[key][oldKey] !== oldParams[key][oldKey]) addKey(key);
          });
        }
      } else if (swiperParams[key] !== oldParams[key]) {
        addKey(key);
      }
    }
  });
  return keys;
}


;// CONCATENATED MODULE: ./node_modules/swiper/react/get-children.js


function isChildSwiperSlide(child) {
  return child.type && child.type.displayName && child.type.displayName.includes('SwiperSlide');
}

function processChildren(c) {
  const slides = [];
  react.Children.toArray(c).forEach(child => {
    if (isChildSwiperSlide(child)) {
      slides.push(child);
    } else if (child.props && child.props.children) {
      processChildren(child.props.children).forEach(slide => slides.push(slide));
    }
  });
  return slides;
}

function getChildren(c) {
  const slides = [];
  const slots = {
    'container-start': [],
    'container-end': [],
    'wrapper-start': [],
    'wrapper-end': []
  };
  react.Children.toArray(c).forEach(child => {
    if (isChildSwiperSlide(child)) {
      slides.push(child);
    } else if (child.props && child.props.slot && slots[child.props.slot]) {
      slots[child.props.slot].push(child);
    } else if (child.props && child.props.children) {
      const foundSlides = processChildren(child.props.children);

      if (foundSlides.length > 0) {
        foundSlides.forEach(slide => slides.push(slide));
      } else {
        slots['container-end'].push(child);
      }
    } else {
      slots['container-end'].push(child);
    }
  });
  return {
    slides,
    slots
  };
}


;// CONCATENATED MODULE: ./node_modules/swiper/components-shared/update-swiper.js


function updateSwiper({
  swiper,
  slides,
  passedParams,
  changedParams,
  nextEl,
  prevEl,
  scrollbarEl,
  paginationEl
}) {
  const updateParams = changedParams.filter(key => key !== 'children' && key !== 'direction');
  const {
    params: currentParams,
    pagination,
    navigation,
    scrollbar,
    virtual,
    thumbs
  } = swiper;
  let needThumbsInit;
  let needControllerInit;
  let needPaginationInit;
  let needScrollbarInit;
  let needNavigationInit;

  if (changedParams.includes('thumbs') && passedParams.thumbs && passedParams.thumbs.swiper && currentParams.thumbs && !currentParams.thumbs.swiper) {
    needThumbsInit = true;
  }

  if (changedParams.includes('controller') && passedParams.controller && passedParams.controller.control && currentParams.controller && !currentParams.controller.control) {
    needControllerInit = true;
  }

  if (changedParams.includes('pagination') && passedParams.pagination && (passedParams.pagination.el || paginationEl) && (currentParams.pagination || currentParams.pagination === false) && pagination && !pagination.el) {
    needPaginationInit = true;
  }

  if (changedParams.includes('scrollbar') && passedParams.scrollbar && (passedParams.scrollbar.el || scrollbarEl) && (currentParams.scrollbar || currentParams.scrollbar === false) && scrollbar && !scrollbar.el) {
    needScrollbarInit = true;
  }

  if (changedParams.includes('navigation') && passedParams.navigation && (passedParams.navigation.prevEl || prevEl) && (passedParams.navigation.nextEl || nextEl) && (currentParams.navigation || currentParams.navigation === false) && navigation && !navigation.prevEl && !navigation.nextEl) {
    needNavigationInit = true;
  }

  const destroyModule = mod => {
    if (!swiper[mod]) return;
    swiper[mod].destroy();

    if (mod === 'navigation') {
      currentParams[mod].prevEl = undefined;
      currentParams[mod].nextEl = undefined;
      swiper[mod].prevEl = undefined;
      swiper[mod].nextEl = undefined;
    } else {
      currentParams[mod].el = undefined;
      swiper[mod].el = undefined;
    }
  };

  updateParams.forEach(key => {
    if (isObject(currentParams[key]) && isObject(passedParams[key])) {
      extend(currentParams[key], passedParams[key]);
    } else {
      const newValue = passedParams[key];

      if ((newValue === true || newValue === false) && (key === 'navigation' || key === 'pagination' || key === 'scrollbar')) {
        if (newValue === false) {
          destroyModule(key);
        }
      } else {
        currentParams[key] = passedParams[key];
      }
    }
  });

  if (updateParams.includes('controller') && !needControllerInit && swiper.controller && swiper.controller.control && currentParams.controller && currentParams.controller.control) {
    swiper.controller.control = currentParams.controller.control;
  }

  if (changedParams.includes('children') && slides && virtual && currentParams.virtual.enabled) {
    virtual.slides = slides;
    virtual.update(true);
  } else if (changedParams.includes('children') && swiper.lazy && swiper.params.lazy.enabled) {
    swiper.lazy.load();
  }

  if (needThumbsInit) {
    const initialized = thumbs.init();
    if (initialized) thumbs.update(true);
  }

  if (needControllerInit) {
    swiper.controller.control = currentParams.controller.control;
  }

  if (needPaginationInit) {
    if (paginationEl) currentParams.pagination.el = paginationEl;
    pagination.init();
    pagination.render();
    pagination.update();
  }

  if (needScrollbarInit) {
    if (scrollbarEl) currentParams.scrollbar.el = scrollbarEl;
    scrollbar.init();
    scrollbar.updateSize();
    scrollbar.setTranslate();
  }

  if (needNavigationInit) {
    if (nextEl) currentParams.navigation.nextEl = nextEl;
    if (prevEl) currentParams.navigation.prevEl = prevEl;
    navigation.init();
    navigation.update();
  }

  if (changedParams.includes('allowSlideNext')) {
    swiper.allowSlideNext = passedParams.allowSlideNext;
  }

  if (changedParams.includes('allowSlidePrev')) {
    swiper.allowSlidePrev = passedParams.allowSlidePrev;
  }

  if (changedParams.includes('direction')) {
    swiper.changeDirection(passedParams.direction, false);
  }

  swiper.update();
}


;// CONCATENATED MODULE: ./node_modules/swiper/react/virtual.js


function renderVirtual(swiper, slides, virtualData) {
  if (!virtualData) return null;
  const style = swiper.isHorizontal() ? {
    [swiper.rtlTranslate ? 'right' : 'left']: `${virtualData.offset}px`
  } : {
    top: `${virtualData.offset}px`
  };
  return slides.filter((child, index) => index >= virtualData.from && index <= virtualData.to).map(child => {
    return /*#__PURE__*/react.cloneElement(child, {
      swiper,
      style
    });
  });
}


;// CONCATENATED MODULE: ./node_modules/swiper/components-shared/update-on-virtual-data.js
const updateOnVirtualData = swiper => {
  if (!swiper || swiper.destroyed || !swiper.params.virtual || swiper.params.virtual && !swiper.params.virtual.enabled) return;
  swiper.updateSlides();
  swiper.updateProgress();
  swiper.updateSlidesClasses();

  if (swiper.lazy && swiper.params.lazy.enabled) {
    swiper.lazy.load();
  }

  if (swiper.parallax && swiper.params.parallax && swiper.params.parallax.enabled) {
    swiper.parallax.setTranslate();
  }
};
;// CONCATENATED MODULE: ./node_modules/swiper/react/use-isomorphic-layout-effect.js


function useIsomorphicLayoutEffect(callback, deps) {
  // eslint-disable-next-line
  if (typeof window === 'undefined') return (0,react.useEffect)(callback, deps);
  return (0,react.useLayoutEffect)(callback, deps);
}


;// CONCATENATED MODULE: ./node_modules/swiper/react/context.js

const SwiperSlideContext = /*#__PURE__*/(0,react.createContext)(null);
const useSwiperSlide = () => {
  return useContext(SwiperSlideContext);
};
const SwiperContext = /*#__PURE__*/(0,react.createContext)(null);
const useSwiper = () => {
  return useContext(SwiperContext);
};
;// CONCATENATED MODULE: ./node_modules/swiper/react/swiper.js
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }














const Swiper = /*#__PURE__*/(0,react.forwardRef)(function (_temp, externalElRef) {
  let {
    className,
    tag: Tag = 'div',
    wrapperTag: WrapperTag = 'div',
    children,
    onSwiper,
    ...rest
  } = _temp === void 0 ? {} : _temp;
  let eventsAssigned = false;
  const [containerClasses, setContainerClasses] = (0,react.useState)('swiper');
  const [virtualData, setVirtualData] = (0,react.useState)(null);
  const [breakpointChanged, setBreakpointChanged] = (0,react.useState)(false);
  const initializedRef = (0,react.useRef)(false);
  const swiperElRef = (0,react.useRef)(null);
  const swiperRef = (0,react.useRef)(null);
  const oldPassedParamsRef = (0,react.useRef)(null);
  const oldSlides = (0,react.useRef)(null);
  const nextElRef = (0,react.useRef)(null);
  const prevElRef = (0,react.useRef)(null);
  const paginationElRef = (0,react.useRef)(null);
  const scrollbarElRef = (0,react.useRef)(null);
  const {
    params: swiperParams,
    passedParams,
    rest: restProps,
    events
  } = getParams(rest);
  const {
    slides,
    slots
  } = getChildren(children);

  const onBeforeBreakpoint = () => {
    setBreakpointChanged(!breakpointChanged);
  };

  Object.assign(swiperParams.on, {
    _containerClasses(swiper, classes) {
      setContainerClasses(classes);
    }

  });

  const initSwiper = () => {
    // init swiper
    Object.assign(swiperParams.on, events);
    eventsAssigned = true;
    swiperRef.current = new swiper_esm/* default */.ZP(swiperParams);

    swiperRef.current.loopCreate = () => {};

    swiperRef.current.loopDestroy = () => {};

    if (swiperParams.loop) {
      swiperRef.current.loopedSlides = calcLoopedSlides(slides, swiperParams);
    }

    if (swiperRef.current.virtual && swiperRef.current.params.virtual.enabled) {
      swiperRef.current.virtual.slides = slides;
      const extendWith = {
        cache: false,
        slides,
        renderExternal: setVirtualData,
        renderExternalUpdate: false
      };
      extend(swiperRef.current.params.virtual, extendWith);
      extend(swiperRef.current.originalParams.virtual, extendWith);
    }
  };

  if (!swiperElRef.current) {
    initSwiper();
  } // Listen for breakpoints change


  if (swiperRef.current) {
    swiperRef.current.on('_beforeBreakpoint', onBeforeBreakpoint);
  }

  const attachEvents = () => {
    if (eventsAssigned || !events || !swiperRef.current) return;
    Object.keys(events).forEach(eventName => {
      swiperRef.current.on(eventName, events[eventName]);
    });
  };

  const detachEvents = () => {
    if (!events || !swiperRef.current) return;
    Object.keys(events).forEach(eventName => {
      swiperRef.current.off(eventName, events[eventName]);
    });
  };

  (0,react.useEffect)(() => {
    return () => {
      if (swiperRef.current) swiperRef.current.off('_beforeBreakpoint', onBeforeBreakpoint);
    };
  }); // set initialized flag

  (0,react.useEffect)(() => {
    if (!initializedRef.current && swiperRef.current) {
      swiperRef.current.emitSlidesClasses();
      initializedRef.current = true;
    }
  }); // mount swiper

  useIsomorphicLayoutEffect(() => {
    if (externalElRef) {
      externalElRef.current = swiperElRef.current;
    }

    if (!swiperElRef.current) return;

    if (swiperRef.current.destroyed) {
      initSwiper();
    }

    mountSwiper({
      el: swiperElRef.current,
      nextEl: nextElRef.current,
      prevEl: prevElRef.current,
      paginationEl: paginationElRef.current,
      scrollbarEl: scrollbarElRef.current,
      swiper: swiperRef.current
    }, swiperParams);
    if (onSwiper) onSwiper(swiperRef.current); // eslint-disable-next-line

    return () => {
      if (swiperRef.current && !swiperRef.current.destroyed) {
        swiperRef.current.destroy(true, false);
      }
    };
  }, []); // watch for params change

  useIsomorphicLayoutEffect(() => {
    attachEvents();
    const changedParams = getChangedParams(passedParams, oldPassedParamsRef.current, slides, oldSlides.current, c => c.key);
    oldPassedParamsRef.current = passedParams;
    oldSlides.current = slides;

    if (changedParams.length && swiperRef.current && !swiperRef.current.destroyed) {
      updateSwiper({
        swiper: swiperRef.current,
        slides,
        passedParams,
        changedParams,
        nextEl: nextElRef.current,
        prevEl: prevElRef.current,
        scrollbarEl: scrollbarElRef.current,
        paginationEl: paginationElRef.current
      });
    }

    return () => {
      detachEvents();
    };
  }); // update on virtual update

  useIsomorphicLayoutEffect(() => {
    updateOnVirtualData(swiperRef.current);
  }, [virtualData]); // bypass swiper instance to slides

  function renderSlides() {
    if (swiperParams.virtual) {
      return renderVirtual(swiperRef.current, slides, virtualData);
    }

    if (!swiperParams.loop || swiperRef.current && swiperRef.current.destroyed) {
      return slides.map(child => {
        return /*#__PURE__*/react.cloneElement(child, {
          swiper: swiperRef.current
        });
      });
    }

    return renderLoop(swiperRef.current, slides, swiperParams);
  }

  return /*#__PURE__*/react.createElement(Tag, _extends({
    ref: swiperElRef,
    className: uniqueClasses(`${containerClasses}${className ? ` ${className}` : ''}`)
  }, restProps), /*#__PURE__*/react.createElement(SwiperContext.Provider, {
    value: swiperRef.current
  }, slots['container-start'], /*#__PURE__*/react.createElement(WrapperTag, {
    className: "swiper-wrapper"
  }, slots['wrapper-start'], renderSlides(), slots['wrapper-end']), needsNavigation(swiperParams) && /*#__PURE__*/react.createElement(react.Fragment, null, /*#__PURE__*/react.createElement("div", {
    ref: prevElRef,
    className: "swiper-button-prev"
  }), /*#__PURE__*/react.createElement("div", {
    ref: nextElRef,
    className: "swiper-button-next"
  })), needsScrollbar(swiperParams) && /*#__PURE__*/react.createElement("div", {
    ref: scrollbarElRef,
    className: "swiper-scrollbar"
  }), needsPagination(swiperParams) && /*#__PURE__*/react.createElement("div", {
    ref: paginationElRef,
    className: "swiper-pagination"
  }), slots['container-end']));
});
Swiper.displayName = 'Swiper';

;// CONCATENATED MODULE: ./node_modules/swiper/react/swiper-slide.js
function swiper_slide_extends() { swiper_slide_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return swiper_slide_extends.apply(this, arguments); }





const SwiperSlide = /*#__PURE__*/(0,react.forwardRef)(function (_temp, externalRef) {
  let {
    tag: Tag = 'div',
    children,
    className = '',
    swiper,
    zoom,
    virtualIndex,
    ...rest
  } = _temp === void 0 ? {} : _temp;
  const slideElRef = (0,react.useRef)(null);
  const [slideClasses, setSlideClasses] = (0,react.useState)('swiper-slide');

  function updateClasses(_s, el, classNames) {
    if (el === slideElRef.current) {
      setSlideClasses(classNames);
    }
  }

  useIsomorphicLayoutEffect(() => {
    if (externalRef) {
      externalRef.current = slideElRef.current;
    }

    if (!slideElRef.current || !swiper) {
      return;
    }

    if (swiper.destroyed) {
      if (slideClasses !== 'swiper-slide') {
        setSlideClasses('swiper-slide');
      }

      return;
    }

    swiper.on('_slideClass', updateClasses); // eslint-disable-next-line

    return () => {
      if (!swiper) return;
      swiper.off('_slideClass', updateClasses);
    };
  });
  useIsomorphicLayoutEffect(() => {
    if (swiper && slideElRef.current && !swiper.destroyed) {
      setSlideClasses(swiper.getSlideClasses(slideElRef.current));
    }
  }, [swiper]);
  const slideData = {
    isActive: slideClasses.indexOf('swiper-slide-active') >= 0 || slideClasses.indexOf('swiper-slide-duplicate-active') >= 0,
    isVisible: slideClasses.indexOf('swiper-slide-visible') >= 0,
    isDuplicate: slideClasses.indexOf('swiper-slide-duplicate') >= 0,
    isPrev: slideClasses.indexOf('swiper-slide-prev') >= 0 || slideClasses.indexOf('swiper-slide-duplicate-prev') >= 0,
    isNext: slideClasses.indexOf('swiper-slide-next') >= 0 || slideClasses.indexOf('swiper-slide-duplicate-next') >= 0
  };

  const renderChildren = () => {
    return typeof children === 'function' ? children(slideData) : children;
  };

  return /*#__PURE__*/react.createElement(Tag, swiper_slide_extends({
    ref: slideElRef,
    className: uniqueClasses(`${slideClasses}${className ? ` ${className}` : ''}`),
    "data-swiper-slide-index": virtualIndex
  }, rest), /*#__PURE__*/react.createElement(SwiperSlideContext.Provider, {
    value: slideData
  }, zoom ? /*#__PURE__*/react.createElement("div", {
    className: "swiper-zoom-container",
    "data-swiper-zoom": typeof zoom === 'number' ? zoom : undefined
  }, renderChildren()) : renderChildren()));
});
SwiperSlide.displayName = 'SwiperSlide';

;// CONCATENATED MODULE: ./node_modules/swiper/react/swiper-react.js
/**
 * Swiper React 8.4.7
 * Most modern mobile touch slider and framework with hardware accelerated transitions
 * https://swiperjs.com
 *
 * Copyright 2014-2023 Vladimir Kharlampidi
 *
 * Released under the MIT License
 *
 * Released on: January 30, 2023
 */






/***/ }),

/***/ 71911:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "pt": function() { return /* reexport */ Autoplay; },
  "W_": function() { return /* reexport */ Navigation; },
  "tl": function() { return /* reexport */ Pagination; },
  "ZP": function() { return /* reexport */ core; }
});

// UNUSED EXPORTS: A11y, Controller, EffectCards, EffectCoverflow, EffectCreative, EffectCube, EffectFade, EffectFlip, FreeMode, Grid, HashNavigation, History, Keyboard, Lazy, Manipulation, Mousewheel, Parallax, Scrollbar, Swiper, Thumbs, Virtual, Zoom

;// CONCATENATED MODULE: ./node_modules/ssr-window/ssr-window.esm.js
/**
 * SSR Window 4.0.2
 * Better handling for window object in SSR environment
 * https://github.com/nolimits4web/ssr-window
 *
 * Copyright 2021, Vladimir Kharlampidi
 *
 * Licensed under MIT
 *
 * Released on: December 13, 2021
 */
/* eslint-disable no-param-reassign */
function ssr_window_esm_isObject(obj) {
    return (obj !== null &&
        typeof obj === 'object' &&
        'constructor' in obj &&
        obj.constructor === Object);
}
function extend(target = {}, src = {}) {
    Object.keys(src).forEach((key) => {
        if (typeof target[key] === 'undefined')
            target[key] = src[key];
        else if (ssr_window_esm_isObject(src[key]) &&
            ssr_window_esm_isObject(target[key]) &&
            Object.keys(src[key]).length > 0) {
            extend(target[key], src[key]);
        }
    });
}

const ssrDocument = {
    body: {},
    addEventListener() { },
    removeEventListener() { },
    activeElement: {
        blur() { },
        nodeName: '',
    },
    querySelector() {
        return null;
    },
    querySelectorAll() {
        return [];
    },
    getElementById() {
        return null;
    },
    createEvent() {
        return {
            initEvent() { },
        };
    },
    createElement() {
        return {
            children: [],
            childNodes: [],
            style: {},
            setAttribute() { },
            getElementsByTagName() {
                return [];
            },
        };
    },
    createElementNS() {
        return {};
    },
    importNode() {
        return null;
    },
    location: {
        hash: '',
        host: '',
        hostname: '',
        href: '',
        origin: '',
        pathname: '',
        protocol: '',
        search: '',
    },
};
function ssr_window_esm_getDocument() {
    const doc = typeof document !== 'undefined' ? document : {};
    extend(doc, ssrDocument);
    return doc;
}

const ssrWindow = {
    document: ssrDocument,
    navigator: {
        userAgent: '',
    },
    location: {
        hash: '',
        host: '',
        hostname: '',
        href: '',
        origin: '',
        pathname: '',
        protocol: '',
        search: '',
    },
    history: {
        replaceState() { },
        pushState() { },
        go() { },
        back() { },
    },
    CustomEvent: function CustomEvent() {
        return this;
    },
    addEventListener() { },
    removeEventListener() { },
    getComputedStyle() {
        return {
            getPropertyValue() {
                return '';
            },
        };
    },
    Image() { },
    Date() { },
    screen: {},
    setTimeout() { },
    clearTimeout() { },
    matchMedia() {
        return {};
    },
    requestAnimationFrame(callback) {
        if (typeof setTimeout === 'undefined') {
            callback();
            return null;
        }
        return setTimeout(callback, 0);
    },
    cancelAnimationFrame(id) {
        if (typeof setTimeout === 'undefined') {
            return;
        }
        clearTimeout(id);
    },
};
function ssr_window_esm_getWindow() {
    const win = typeof window !== 'undefined' ? window : {};
    extend(win, ssrWindow);
    return win;
}



;// CONCATENATED MODULE: ./node_modules/dom7/dom7.esm.js
/**
 * Dom7 4.0.6
 * Minimalistic JavaScript library for DOM manipulation, with a jQuery-compatible API
 * https://framework7.io/docs/dom7.html
 *
 * Copyright 2023, Vladimir Kharlampidi
 *
 * Licensed under MIT
 *
 * Released on: February 2, 2023
 */


/* eslint-disable no-proto */
function makeReactive(obj) {
  const proto = obj.__proto__;
  Object.defineProperty(obj, '__proto__', {
    get() {
      return proto;
    },

    set(value) {
      proto.__proto__ = value;
    }

  });
}

class Dom7 extends Array {
  constructor(items) {
    if (typeof items === 'number') {
      super(items);
    } else {
      super(...(items || []));
      makeReactive(this);
    }
  }

}

function arrayFlat(arr = []) {
  const res = [];
  arr.forEach(el => {
    if (Array.isArray(el)) {
      res.push(...arrayFlat(el));
    } else {
      res.push(el);
    }
  });
  return res;
}
function arrayFilter(arr, callback) {
  return Array.prototype.filter.call(arr, callback);
}
function arrayUnique(arr) {
  const uniqueArray = [];

  for (let i = 0; i < arr.length; i += 1) {
    if (uniqueArray.indexOf(arr[i]) === -1) uniqueArray.push(arr[i]);
  }

  return uniqueArray;
}
function toCamelCase(string) {
  return string.toLowerCase().replace(/-(.)/g, (match, group) => group.toUpperCase());
}

// eslint-disable-next-line

function qsa(selector, context) {
  if (typeof selector !== 'string') {
    return [selector];
  }

  const a = [];
  const res = context.querySelectorAll(selector);

  for (let i = 0; i < res.length; i += 1) {
    a.push(res[i]);
  }

  return a;
}

function dom7_esm_$(selector, context) {
  const window = ssr_window_esm_getWindow();
  const document = ssr_window_esm_getDocument();
  let arr = [];

  if (!context && selector instanceof Dom7) {
    return selector;
  }

  if (!selector) {
    return new Dom7(arr);
  }

  if (typeof selector === 'string') {
    const html = selector.trim();

    if (html.indexOf('<') >= 0 && html.indexOf('>') >= 0) {
      let toCreate = 'div';
      if (html.indexOf('<li') === 0) toCreate = 'ul';
      if (html.indexOf('<tr') === 0) toCreate = 'tbody';
      if (html.indexOf('<td') === 0 || html.indexOf('<th') === 0) toCreate = 'tr';
      if (html.indexOf('<tbody') === 0) toCreate = 'table';
      if (html.indexOf('<option') === 0) toCreate = 'select';
      const tempParent = document.createElement(toCreate);
      tempParent.innerHTML = html;

      for (let i = 0; i < tempParent.childNodes.length; i += 1) {
        arr.push(tempParent.childNodes[i]);
      }
    } else {
      arr = qsa(selector.trim(), context || document);
    } // arr = qsa(selector, document);

  } else if (selector.nodeType || selector === window || selector === document) {
    arr.push(selector);
  } else if (Array.isArray(selector)) {
    if (selector instanceof Dom7) return selector;
    arr = selector;
  }

  return new Dom7(arrayUnique(arr));
}

dom7_esm_$.fn = Dom7.prototype;

// eslint-disable-next-line

function addClass(...classes) {
  const classNames = arrayFlat(classes.map(c => c.split(' ')));
  this.forEach(el => {
    el.classList.add(...classNames);
  });
  return this;
}

function removeClass(...classes) {
  const classNames = arrayFlat(classes.map(c => c.split(' ')));
  this.forEach(el => {
    el.classList.remove(...classNames);
  });
  return this;
}

function toggleClass(...classes) {
  const classNames = arrayFlat(classes.map(c => c.split(' ')));
  this.forEach(el => {
    classNames.forEach(className => {
      el.classList.toggle(className);
    });
  });
}

function hasClass(...classes) {
  const classNames = arrayFlat(classes.map(c => c.split(' ')));
  return arrayFilter(this, el => {
    return classNames.filter(className => el.classList.contains(className)).length > 0;
  }).length > 0;
}

function attr(attrs, value) {
  if (arguments.length === 1 && typeof attrs === 'string') {
    // Get attr
    if (this[0]) return this[0].getAttribute(attrs);
    return undefined;
  } // Set attrs


  for (let i = 0; i < this.length; i += 1) {
    if (arguments.length === 2) {
      // String
      this[i].setAttribute(attrs, value);
    } else {
      // Object
      for (const attrName in attrs) {
        this[i][attrName] = attrs[attrName];
        this[i].setAttribute(attrName, attrs[attrName]);
      }
    }
  }

  return this;
}

function removeAttr(attr) {
  for (let i = 0; i < this.length; i += 1) {
    this[i].removeAttribute(attr);
  }

  return this;
}

function prop(props, value) {
  if (arguments.length === 1 && typeof props === 'string') {
    // Get prop
    if (this[0]) return this[0][props];
  } else {
    // Set props
    for (let i = 0; i < this.length; i += 1) {
      if (arguments.length === 2) {
        // String
        this[i][props] = value;
      } else {
        // Object
        for (const propName in props) {
          this[i][propName] = props[propName];
        }
      }
    }

    return this;
  }

  return this;
}

function data(key, value) {
  let el;

  if (typeof value === 'undefined') {
    el = this[0];
    if (!el) return undefined; // Get value

    if (el.dom7ElementDataStorage && key in el.dom7ElementDataStorage) {
      return el.dom7ElementDataStorage[key];
    }

    const dataKey = el.getAttribute(`data-${key}`);

    if (dataKey) {
      return dataKey;
    }

    return undefined;
  } // Set value


  for (let i = 0; i < this.length; i += 1) {
    el = this[i];
    if (!el.dom7ElementDataStorage) el.dom7ElementDataStorage = {};
    el.dom7ElementDataStorage[key] = value;
  }

  return this;
}

function removeData(key) {
  for (let i = 0; i < this.length; i += 1) {
    const el = this[i];

    if (el.dom7ElementDataStorage && el.dom7ElementDataStorage[key]) {
      el.dom7ElementDataStorage[key] = null;
      delete el.dom7ElementDataStorage[key];
    }
  }
}

function dataset() {
  const el = this[0];
  if (!el) return undefined;
  const dataset = {}; // eslint-disable-line

  if (el.dataset) {
    for (const dataKey in el.dataset) {
      dataset[dataKey] = el.dataset[dataKey];
    }
  } else {
    for (let i = 0; i < el.attributes.length; i += 1) {
      const attr = el.attributes[i];

      if (attr.name.indexOf('data-') >= 0) {
        dataset[toCamelCase(attr.name.split('data-')[1])] = attr.value;
      }
    }
  }

  for (const key in dataset) {
    if (dataset[key] === 'false') dataset[key] = false;else if (dataset[key] === 'true') dataset[key] = true;else if (parseFloat(dataset[key]) === dataset[key] * 1) dataset[key] *= 1;
  }

  return dataset;
}

function val(value) {
  if (typeof value === 'undefined') {
    // get value
    const el = this[0];
    if (!el) return undefined;

    if (el.multiple && el.nodeName.toLowerCase() === 'select') {
      const values = [];

      for (let i = 0; i < el.selectedOptions.length; i += 1) {
        values.push(el.selectedOptions[i].value);
      }

      return values;
    }

    return el.value;
  } // set value


  for (let i = 0; i < this.length; i += 1) {
    const el = this[i];

    if (Array.isArray(value) && el.multiple && el.nodeName.toLowerCase() === 'select') {
      for (let j = 0; j < el.options.length; j += 1) {
        el.options[j].selected = value.indexOf(el.options[j].value) >= 0;
      }
    } else {
      el.value = value;
    }
  }

  return this;
}

function value(value) {
  return this.val(value);
}

function transform(transform) {
  for (let i = 0; i < this.length; i += 1) {
    this[i].style.transform = transform;
  }

  return this;
}

function transition(duration) {
  for (let i = 0; i < this.length; i += 1) {
    this[i].style.transitionDuration = typeof duration !== 'string' ? `${duration}ms` : duration;
  }

  return this;
}

function on(...args) {
  let [eventType, targetSelector, listener, capture] = args;

  if (typeof args[1] === 'function') {
    [eventType, listener, capture] = args;
    targetSelector = undefined;
  }

  if (!capture) capture = false;

  function handleLiveEvent(e) {
    const target = e.target;
    if (!target) return;
    const eventData = e.target.dom7EventData || [];

    if (eventData.indexOf(e) < 0) {
      eventData.unshift(e);
    }

    if (dom7_esm_$(target).is(targetSelector)) listener.apply(target, eventData);else {
      const parents = dom7_esm_$(target).parents(); // eslint-disable-line

      for (let k = 0; k < parents.length; k += 1) {
        if (dom7_esm_$(parents[k]).is(targetSelector)) listener.apply(parents[k], eventData);
      }
    }
  }

  function handleEvent(e) {
    const eventData = e && e.target ? e.target.dom7EventData || [] : [];

    if (eventData.indexOf(e) < 0) {
      eventData.unshift(e);
    }

    listener.apply(this, eventData);
  }

  const events = eventType.split(' ');
  let j;

  for (let i = 0; i < this.length; i += 1) {
    const el = this[i];

    if (!targetSelector) {
      for (j = 0; j < events.length; j += 1) {
        const event = events[j];
        if (!el.dom7Listeners) el.dom7Listeners = {};
        if (!el.dom7Listeners[event]) el.dom7Listeners[event] = [];
        el.dom7Listeners[event].push({
          listener,
          proxyListener: handleEvent
        });
        el.addEventListener(event, handleEvent, capture);
      }
    } else {
      // Live events
      for (j = 0; j < events.length; j += 1) {
        const event = events[j];
        if (!el.dom7LiveListeners) el.dom7LiveListeners = {};
        if (!el.dom7LiveListeners[event]) el.dom7LiveListeners[event] = [];
        el.dom7LiveListeners[event].push({
          listener,
          proxyListener: handleLiveEvent
        });
        el.addEventListener(event, handleLiveEvent, capture);
      }
    }
  }

  return this;
}

function off(...args) {
  let [eventType, targetSelector, listener, capture] = args;

  if (typeof args[1] === 'function') {
    [eventType, listener, capture] = args;
    targetSelector = undefined;
  }

  if (!capture) capture = false;
  const events = eventType.split(' ');

  for (let i = 0; i < events.length; i += 1) {
    const event = events[i];

    for (let j = 0; j < this.length; j += 1) {
      const el = this[j];
      let handlers;

      if (!targetSelector && el.dom7Listeners) {
        handlers = el.dom7Listeners[event];
      } else if (targetSelector && el.dom7LiveListeners) {
        handlers = el.dom7LiveListeners[event];
      }

      if (handlers && handlers.length) {
        for (let k = handlers.length - 1; k >= 0; k -= 1) {
          const handler = handlers[k];

          if (listener && handler.listener === listener) {
            el.removeEventListener(event, handler.proxyListener, capture);
            handlers.splice(k, 1);
          } else if (listener && handler.listener && handler.listener.dom7proxy && handler.listener.dom7proxy === listener) {
            el.removeEventListener(event, handler.proxyListener, capture);
            handlers.splice(k, 1);
          } else if (!listener) {
            el.removeEventListener(event, handler.proxyListener, capture);
            handlers.splice(k, 1);
          }
        }
      }
    }
  }

  return this;
}

function once(...args) {
  const dom = this;
  let [eventName, targetSelector, listener, capture] = args;

  if (typeof args[1] === 'function') {
    [eventName, listener, capture] = args;
    targetSelector = undefined;
  }

  function onceHandler(...eventArgs) {
    listener.apply(this, eventArgs);
    dom.off(eventName, targetSelector, onceHandler, capture);

    if (onceHandler.dom7proxy) {
      delete onceHandler.dom7proxy;
    }
  }

  onceHandler.dom7proxy = listener;
  return dom.on(eventName, targetSelector, onceHandler, capture);
}

function trigger(...args) {
  const window = ssr_window_esm_getWindow();
  const events = args[0].split(' ');
  const eventData = args[1];

  for (let i = 0; i < events.length; i += 1) {
    const event = events[i];

    for (let j = 0; j < this.length; j += 1) {
      const el = this[j];

      if (window.CustomEvent) {
        const evt = new window.CustomEvent(event, {
          detail: eventData,
          bubbles: true,
          cancelable: true
        });
        el.dom7EventData = args.filter((data, dataIndex) => dataIndex > 0);
        el.dispatchEvent(evt);
        el.dom7EventData = [];
        delete el.dom7EventData;
      }
    }
  }

  return this;
}

function transitionStart(callback) {
  const dom = this;

  function fireCallBack(e) {
    if (e.target !== this) return;
    callback.call(this, e);
    dom.off('transitionstart', fireCallBack);
  }

  if (callback) {
    dom.on('transitionstart', fireCallBack);
  }

  return this;
}

function transitionEnd(callback) {
  const dom = this;

  function fireCallBack(e) {
    if (e.target !== this) return;
    callback.call(this, e);
    dom.off('transitionend', fireCallBack);
  }

  if (callback) {
    dom.on('transitionend', fireCallBack);
  }

  return this;
}

function animationEnd(callback) {
  const dom = this;

  function fireCallBack(e) {
    if (e.target !== this) return;
    callback.call(this, e);
    dom.off('animationend', fireCallBack);
  }

  if (callback) {
    dom.on('animationend', fireCallBack);
  }

  return this;
}

function width() {
  const window = getWindow();

  if (this[0] === window) {
    return window.innerWidth;
  }

  if (this.length > 0) {
    return parseFloat(this.css('width'));
  }

  return null;
}

function dom7_esm_outerWidth(includeMargins) {
  if (this.length > 0) {
    if (includeMargins) {
      const styles = this.styles();
      return this[0].offsetWidth + parseFloat(styles.getPropertyValue('margin-right')) + parseFloat(styles.getPropertyValue('margin-left'));
    }

    return this[0].offsetWidth;
  }

  return null;
}

function height() {
  const window = getWindow();

  if (this[0] === window) {
    return window.innerHeight;
  }

  if (this.length > 0) {
    return parseFloat(this.css('height'));
  }

  return null;
}

function dom7_esm_outerHeight(includeMargins) {
  if (this.length > 0) {
    if (includeMargins) {
      const styles = this.styles();
      return this[0].offsetHeight + parseFloat(styles.getPropertyValue('margin-top')) + parseFloat(styles.getPropertyValue('margin-bottom'));
    }

    return this[0].offsetHeight;
  }

  return null;
}

function offset() {
  if (this.length > 0) {
    const window = ssr_window_esm_getWindow();
    const document = ssr_window_esm_getDocument();
    const el = this[0];
    const box = el.getBoundingClientRect();
    const body = document.body;
    const clientTop = el.clientTop || body.clientTop || 0;
    const clientLeft = el.clientLeft || body.clientLeft || 0;
    const scrollTop = el === window ? window.scrollY : el.scrollTop;
    const scrollLeft = el === window ? window.scrollX : el.scrollLeft;
    return {
      top: box.top + scrollTop - clientTop,
      left: box.left + scrollLeft - clientLeft
    };
  }

  return null;
}

function hide() {
  for (let i = 0; i < this.length; i += 1) {
    this[i].style.display = 'none';
  }

  return this;
}

function show() {
  const window = getWindow();

  for (let i = 0; i < this.length; i += 1) {
    const el = this[i];

    if (el.style.display === 'none') {
      el.style.display = '';
    }

    if (window.getComputedStyle(el, null).getPropertyValue('display') === 'none') {
      // Still not visible
      el.style.display = 'block';
    }
  }

  return this;
}

function styles() {
  const window = ssr_window_esm_getWindow();
  if (this[0]) return window.getComputedStyle(this[0], null);
  return {};
}

function css(props, value) {
  const window = ssr_window_esm_getWindow();
  let i;

  if (arguments.length === 1) {
    if (typeof props === 'string') {
      // .css('width')
      if (this[0]) return window.getComputedStyle(this[0], null).getPropertyValue(props);
    } else {
      // .css({ width: '100px' })
      for (i = 0; i < this.length; i += 1) {
        for (const prop in props) {
          this[i].style[prop] = props[prop];
        }
      }

      return this;
    }
  }

  if (arguments.length === 2 && typeof props === 'string') {
    // .css('width', '100px')
    for (i = 0; i < this.length; i += 1) {
      this[i].style[props] = value;
    }

    return this;
  }

  return this;
}

function each(callback) {
  if (!callback) return this;
  this.forEach((el, index) => {
    callback.apply(el, [el, index]);
  });
  return this;
}

function filter(callback) {
  const result = arrayFilter(this, callback);
  return dom7_esm_$(result);
}

function html(html) {
  if (typeof html === 'undefined') {
    return this[0] ? this[0].innerHTML : null;
  }

  for (let i = 0; i < this.length; i += 1) {
    this[i].innerHTML = html;
  }

  return this;
}

function dom7_esm_text(text) {
  if (typeof text === 'undefined') {
    return this[0] ? this[0].textContent.trim() : null;
  }

  for (let i = 0; i < this.length; i += 1) {
    this[i].textContent = text;
  }

  return this;
}

function is(selector) {
  const window = ssr_window_esm_getWindow();
  const document = ssr_window_esm_getDocument();
  const el = this[0];
  let compareWith;
  let i;
  if (!el || typeof selector === 'undefined') return false;

  if (typeof selector === 'string') {
    if (el.matches) return el.matches(selector);
    if (el.webkitMatchesSelector) return el.webkitMatchesSelector(selector);
    if (el.msMatchesSelector) return el.msMatchesSelector(selector);
    compareWith = dom7_esm_$(selector);

    for (i = 0; i < compareWith.length; i += 1) {
      if (compareWith[i] === el) return true;
    }

    return false;
  }

  if (selector === document) {
    return el === document;
  }

  if (selector === window) {
    return el === window;
  }

  if (selector.nodeType || selector instanceof Dom7) {
    compareWith = selector.nodeType ? [selector] : selector;

    for (i = 0; i < compareWith.length; i += 1) {
      if (compareWith[i] === el) return true;
    }

    return false;
  }

  return false;
}

function index() {
  let child = this[0];
  let i;

  if (child) {
    i = 0; // eslint-disable-next-line

    while ((child = child.previousSibling) !== null) {
      if (child.nodeType === 1) i += 1;
    }

    return i;
  }

  return undefined;
}

function eq(index) {
  if (typeof index === 'undefined') return this;
  const length = this.length;

  if (index > length - 1) {
    return dom7_esm_$([]);
  }

  if (index < 0) {
    const returnIndex = length + index;
    if (returnIndex < 0) return dom7_esm_$([]);
    return dom7_esm_$([this[returnIndex]]);
  }

  return dom7_esm_$([this[index]]);
}

function append(...els) {
  let newChild;
  const document = ssr_window_esm_getDocument();

  for (let k = 0; k < els.length; k += 1) {
    newChild = els[k];

    for (let i = 0; i < this.length; i += 1) {
      if (typeof newChild === 'string') {
        const tempDiv = document.createElement('div');
        tempDiv.innerHTML = newChild;

        while (tempDiv.firstChild) {
          this[i].appendChild(tempDiv.firstChild);
        }
      } else if (newChild instanceof Dom7) {
        for (let j = 0; j < newChild.length; j += 1) {
          this[i].appendChild(newChild[j]);
        }
      } else {
        this[i].appendChild(newChild);
      }
    }
  }

  return this;
}

function appendTo(parent) {
  dom7_esm_$(parent).append(this);
  return this;
}

function prepend(newChild) {
  const document = ssr_window_esm_getDocument();
  let i;
  let j;

  for (i = 0; i < this.length; i += 1) {
    if (typeof newChild === 'string') {
      const tempDiv = document.createElement('div');
      tempDiv.innerHTML = newChild;

      for (j = tempDiv.childNodes.length - 1; j >= 0; j -= 1) {
        this[i].insertBefore(tempDiv.childNodes[j], this[i].childNodes[0]);
      }
    } else if (newChild instanceof Dom7) {
      for (j = 0; j < newChild.length; j += 1) {
        this[i].insertBefore(newChild[j], this[i].childNodes[0]);
      }
    } else {
      this[i].insertBefore(newChild, this[i].childNodes[0]);
    }
  }

  return this;
}

function prependTo(parent) {
  dom7_esm_$(parent).prepend(this);
  return this;
}

function insertBefore(selector) {
  const before = dom7_esm_$(selector);

  for (let i = 0; i < this.length; i += 1) {
    if (before.length === 1) {
      before[0].parentNode.insertBefore(this[i], before[0]);
    } else if (before.length > 1) {
      for (let j = 0; j < before.length; j += 1) {
        before[j].parentNode.insertBefore(this[i].cloneNode(true), before[j]);
      }
    }
  }
}

function insertAfter(selector) {
  const after = dom7_esm_$(selector);

  for (let i = 0; i < this.length; i += 1) {
    if (after.length === 1) {
      after[0].parentNode.insertBefore(this[i], after[0].nextSibling);
    } else if (after.length > 1) {
      for (let j = 0; j < after.length; j += 1) {
        after[j].parentNode.insertBefore(this[i].cloneNode(true), after[j].nextSibling);
      }
    }
  }
}

function next(selector) {
  if (this.length > 0) {
    if (selector) {
      if (this[0].nextElementSibling && dom7_esm_$(this[0].nextElementSibling).is(selector)) {
        return dom7_esm_$([this[0].nextElementSibling]);
      }

      return dom7_esm_$([]);
    }

    if (this[0].nextElementSibling) return dom7_esm_$([this[0].nextElementSibling]);
    return dom7_esm_$([]);
  }

  return dom7_esm_$([]);
}

function nextAll(selector) {
  const nextEls = [];
  let el = this[0];
  if (!el) return dom7_esm_$([]);

  while (el.nextElementSibling) {
    const next = el.nextElementSibling; // eslint-disable-line

    if (selector) {
      if (dom7_esm_$(next).is(selector)) nextEls.push(next);
    } else nextEls.push(next);

    el = next;
  }

  return dom7_esm_$(nextEls);
}

function prev(selector) {
  if (this.length > 0) {
    const el = this[0];

    if (selector) {
      if (el.previousElementSibling && dom7_esm_$(el.previousElementSibling).is(selector)) {
        return dom7_esm_$([el.previousElementSibling]);
      }

      return dom7_esm_$([]);
    }

    if (el.previousElementSibling) return dom7_esm_$([el.previousElementSibling]);
    return dom7_esm_$([]);
  }

  return dom7_esm_$([]);
}

function prevAll(selector) {
  const prevEls = [];
  let el = this[0];
  if (!el) return dom7_esm_$([]);

  while (el.previousElementSibling) {
    const prev = el.previousElementSibling; // eslint-disable-line

    if (selector) {
      if (dom7_esm_$(prev).is(selector)) prevEls.push(prev);
    } else prevEls.push(prev);

    el = prev;
  }

  return dom7_esm_$(prevEls);
}

function siblings(selector) {
  return this.nextAll(selector).add(this.prevAll(selector));
}

function dom7_esm_parent(selector) {
  const parents = []; // eslint-disable-line

  for (let i = 0; i < this.length; i += 1) {
    if (this[i].parentNode !== null) {
      if (selector) {
        if (dom7_esm_$(this[i].parentNode).is(selector)) parents.push(this[i].parentNode);
      } else {
        parents.push(this[i].parentNode);
      }
    }
  }

  return dom7_esm_$(parents);
}

function parents(selector) {
  const parents = []; // eslint-disable-line

  for (let i = 0; i < this.length; i += 1) {
    let parent = this[i].parentNode; // eslint-disable-line

    while (parent) {
      if (selector) {
        if (dom7_esm_$(parent).is(selector)) parents.push(parent);
      } else {
        parents.push(parent);
      }

      parent = parent.parentNode;
    }
  }

  return dom7_esm_$(parents);
}

function closest(selector) {
  let closest = this; // eslint-disable-line

  if (typeof selector === 'undefined') {
    return dom7_esm_$([]);
  }

  if (!closest.is(selector)) {
    closest = closest.parents(selector).eq(0);
  }

  return closest;
}

function find(selector) {
  const foundElements = [];

  for (let i = 0; i < this.length; i += 1) {
    const found = this[i].querySelectorAll(selector);

    for (let j = 0; j < found.length; j += 1) {
      foundElements.push(found[j]);
    }
  }

  return dom7_esm_$(foundElements);
}

function children(selector) {
  const children = []; // eslint-disable-line

  for (let i = 0; i < this.length; i += 1) {
    const childNodes = this[i].children;

    for (let j = 0; j < childNodes.length; j += 1) {
      if (!selector || dom7_esm_$(childNodes[j]).is(selector)) {
        children.push(childNodes[j]);
      }
    }
  }

  return dom7_esm_$(children);
}

function remove() {
  for (let i = 0; i < this.length; i += 1) {
    if (this[i].parentNode) this[i].parentNode.removeChild(this[i]);
  }

  return this;
}

function detach() {
  return this.remove();
}

function add(...els) {
  const dom = this;
  let i;
  let j;

  for (i = 0; i < els.length; i += 1) {
    const toAdd = dom7_esm_$(els[i]);

    for (j = 0; j < toAdd.length; j += 1) {
      dom.push(toAdd[j]);
    }
  }

  return dom;
}

function empty() {
  for (let i = 0; i < this.length; i += 1) {
    const el = this[i];

    if (el.nodeType === 1) {
      for (let j = 0; j < el.childNodes.length; j += 1) {
        if (el.childNodes[j].parentNode) {
          el.childNodes[j].parentNode.removeChild(el.childNodes[j]);
        }
      }

      el.textContent = '';
    }
  }

  return this;
}

// eslint-disable-next-line

function scrollTo(...args) {
  const window = getWindow();
  let [left, top, duration, easing, callback] = args;

  if (args.length === 4 && typeof easing === 'function') {
    callback = easing;
    [left, top, duration, callback, easing] = args;
  }

  if (typeof easing === 'undefined') easing = 'swing';
  return this.each(function animate() {
    const el = this;
    let currentTop;
    let currentLeft;
    let maxTop;
    let maxLeft;
    let newTop;
    let newLeft;
    let scrollTop; // eslint-disable-line

    let scrollLeft; // eslint-disable-line

    let animateTop = top > 0 || top === 0;
    let animateLeft = left > 0 || left === 0;

    if (typeof easing === 'undefined') {
      easing = 'swing';
    }

    if (animateTop) {
      currentTop = el.scrollTop;

      if (!duration) {
        el.scrollTop = top;
      }
    }

    if (animateLeft) {
      currentLeft = el.scrollLeft;

      if (!duration) {
        el.scrollLeft = left;
      }
    }

    if (!duration) return;

    if (animateTop) {
      maxTop = el.scrollHeight - el.offsetHeight;
      newTop = Math.max(Math.min(top, maxTop), 0);
    }

    if (animateLeft) {
      maxLeft = el.scrollWidth - el.offsetWidth;
      newLeft = Math.max(Math.min(left, maxLeft), 0);
    }

    let startTime = null;
    if (animateTop && newTop === currentTop) animateTop = false;
    if (animateLeft && newLeft === currentLeft) animateLeft = false;

    function render(time = new Date().getTime()) {
      if (startTime === null) {
        startTime = time;
      }

      const progress = Math.max(Math.min((time - startTime) / duration, 1), 0);
      const easeProgress = easing === 'linear' ? progress : 0.5 - Math.cos(progress * Math.PI) / 2;
      let done;
      if (animateTop) scrollTop = currentTop + easeProgress * (newTop - currentTop);
      if (animateLeft) scrollLeft = currentLeft + easeProgress * (newLeft - currentLeft);

      if (animateTop && newTop > currentTop && scrollTop >= newTop) {
        el.scrollTop = newTop;
        done = true;
      }

      if (animateTop && newTop < currentTop && scrollTop <= newTop) {
        el.scrollTop = newTop;
        done = true;
      }

      if (animateLeft && newLeft > currentLeft && scrollLeft >= newLeft) {
        el.scrollLeft = newLeft;
        done = true;
      }

      if (animateLeft && newLeft < currentLeft && scrollLeft <= newLeft) {
        el.scrollLeft = newLeft;
        done = true;
      }

      if (done) {
        if (callback) callback();
        return;
      }

      if (animateTop) el.scrollTop = scrollTop;
      if (animateLeft) el.scrollLeft = scrollLeft;
      window.requestAnimationFrame(render);
    }

    window.requestAnimationFrame(render);
  });
} // scrollTop(top, duration, easing, callback) {


function scrollTop(...args) {
  let [top, duration, easing, callback] = args;

  if (args.length === 3 && typeof easing === 'function') {
    [top, duration, callback, easing] = args;
  }

  const dom = this;

  if (typeof top === 'undefined') {
    if (dom.length > 0) return dom[0].scrollTop;
    return null;
  }

  return dom.scrollTo(undefined, top, duration, easing, callback);
}

function scrollLeft(...args) {
  let [left, duration, easing, callback] = args;

  if (args.length === 3 && typeof easing === 'function') {
    [left, duration, callback, easing] = args;
  }

  const dom = this;

  if (typeof left === 'undefined') {
    if (dom.length > 0) return dom[0].scrollLeft;
    return null;
  }

  return dom.scrollTo(left, undefined, duration, easing, callback);
}

// eslint-disable-next-line

function animate(initialProps, initialParams) {
  const window = getWindow();
  const els = this;
  const a = {
    props: Object.assign({}, initialProps),
    params: Object.assign({
      duration: 300,
      easing: 'swing' // or 'linear'

      /* Callbacks
      begin(elements)
      complete(elements)
      progress(elements, complete, remaining, start, tweenValue)
      */

    }, initialParams),
    elements: els,
    animating: false,
    que: [],

    easingProgress(easing, progress) {
      if (easing === 'swing') {
        return 0.5 - Math.cos(progress * Math.PI) / 2;
      }

      if (typeof easing === 'function') {
        return easing(progress);
      }

      return progress;
    },

    stop() {
      if (a.frameId) {
        window.cancelAnimationFrame(a.frameId);
      }

      a.animating = false;
      a.elements.each(el => {
        const element = el;
        delete element.dom7AnimateInstance;
      });
      a.que = [];
    },

    done(complete) {
      a.animating = false;
      a.elements.each(el => {
        const element = el;
        delete element.dom7AnimateInstance;
      });
      if (complete) complete(els);

      if (a.que.length > 0) {
        const que = a.que.shift();
        a.animate(que[0], que[1]);
      }
    },

    animate(props, params) {
      if (a.animating) {
        a.que.push([props, params]);
        return a;
      }

      const elements = []; // Define & Cache Initials & Units

      a.elements.each((el, index) => {
        let initialFullValue;
        let initialValue;
        let unit;
        let finalValue;
        let finalFullValue;
        if (!el.dom7AnimateInstance) a.elements[index].dom7AnimateInstance = a;
        elements[index] = {
          container: el
        };
        Object.keys(props).forEach(prop => {
          initialFullValue = window.getComputedStyle(el, null).getPropertyValue(prop).replace(',', '.');
          initialValue = parseFloat(initialFullValue);
          unit = initialFullValue.replace(initialValue, '');
          finalValue = parseFloat(props[prop]);
          finalFullValue = props[prop] + unit;
          elements[index][prop] = {
            initialFullValue,
            initialValue,
            unit,
            finalValue,
            finalFullValue,
            currentValue: initialValue
          };
        });
      });
      let startTime = null;
      let time;
      let elementsDone = 0;
      let propsDone = 0;
      let done;
      let began = false;
      a.animating = true;

      function render() {
        time = new Date().getTime();
        let progress;
        let easeProgress; // let el;

        if (!began) {
          began = true;
          if (params.begin) params.begin(els);
        }

        if (startTime === null) {
          startTime = time;
        }

        if (params.progress) {
          // eslint-disable-next-line
          params.progress(els, Math.max(Math.min((time - startTime) / params.duration, 1), 0), startTime + params.duration - time < 0 ? 0 : startTime + params.duration - time, startTime);
        }

        elements.forEach(element => {
          const el = element;
          if (done || el.done) return;
          Object.keys(props).forEach(prop => {
            if (done || el.done) return;
            progress = Math.max(Math.min((time - startTime) / params.duration, 1), 0);
            easeProgress = a.easingProgress(params.easing, progress);
            const {
              initialValue,
              finalValue,
              unit
            } = el[prop];
            el[prop].currentValue = initialValue + easeProgress * (finalValue - initialValue);
            const currentValue = el[prop].currentValue;

            if (finalValue > initialValue && currentValue >= finalValue || finalValue < initialValue && currentValue <= finalValue) {
              el.container.style[prop] = finalValue + unit;
              propsDone += 1;

              if (propsDone === Object.keys(props).length) {
                el.done = true;
                elementsDone += 1;
              }

              if (elementsDone === elements.length) {
                done = true;
              }
            }

            if (done) {
              a.done(params.complete);
              return;
            }

            el.container.style[prop] = currentValue + unit;
          });
        });
        if (done) return; // Then call

        a.frameId = window.requestAnimationFrame(render);
      }

      a.frameId = window.requestAnimationFrame(render);
      return a;
    }

  };

  if (a.elements.length === 0) {
    return els;
  }

  let animateInstance;

  for (let i = 0; i < a.elements.length; i += 1) {
    if (a.elements[i].dom7AnimateInstance) {
      animateInstance = a.elements[i].dom7AnimateInstance;
    } else a.elements[i].dom7AnimateInstance = a;
  }

  if (!animateInstance) {
    animateInstance = a;
  }

  if (initialProps === 'stop') {
    animateInstance.stop();
  } else {
    animateInstance.animate(a.props, a.params);
  }

  return els;
}

function stop() {
  const els = this;

  for (let i = 0; i < els.length; i += 1) {
    if (els[i].dom7AnimateInstance) {
      els[i].dom7AnimateInstance.stop();
    }
  }
}

const noTrigger = 'resize scroll'.split(' ');

function shortcut(name) {
  function eventHandler(...args) {
    if (typeof args[0] === 'undefined') {
      for (let i = 0; i < this.length; i += 1) {
        if (noTrigger.indexOf(name) < 0) {
          if (name in this[i]) this[i][name]();else {
            dom7_esm_$(this[i]).trigger(name);
          }
        }
      }

      return this;
    }

    return this.on(name, ...args);
  }

  return eventHandler;
}

const click = shortcut('click');
const dom7_esm_blur = shortcut('blur');
const dom7_esm_focus = shortcut('focus');
const focusin = shortcut('focusin');
const focusout = shortcut('focusout');
const keyup = shortcut('keyup');
const keydown = shortcut('keydown');
const keypress = shortcut('keypress');
const dom7_esm_submit = shortcut('submit');
const change = shortcut('change');
const mousedown = shortcut('mousedown');
const mousemove = shortcut('mousemove');
const mouseup = shortcut('mouseup');
const mouseenter = shortcut('mouseenter');
const mouseleave = shortcut('mouseleave');
const mouseout = shortcut('mouseout');
const mouseover = shortcut('mouseover');
const touchstart = shortcut('touchstart');
const touchend = shortcut('touchend');
const touchmove = shortcut('touchmove');
const resize = shortcut('resize');
const dom7_esm_scroll = shortcut('scroll');

/* harmony default export */ var dom7_esm = ((/* unused pure expression or super */ null && (dom7_esm_$)));


;// CONCATENATED MODULE: ./node_modules/swiper/shared/dom.js

const Methods = {
  addClass: addClass,
  removeClass: removeClass,
  hasClass: hasClass,
  toggleClass: toggleClass,
  attr: attr,
  removeAttr: removeAttr,
  transform: transform,
  transition: transition,
  on: on,
  off: off,
  trigger: trigger,
  transitionEnd: transitionEnd,
  outerWidth: dom7_esm_outerWidth,
  outerHeight: dom7_esm_outerHeight,
  styles: styles,
  offset: offset,
  css: css,
  each: each,
  html: html,
  text: dom7_esm_text,
  is: is,
  index: index,
  eq: eq,
  append: append,
  prepend: prepend,
  next: next,
  nextAll: nextAll,
  prev: prev,
  prevAll: prevAll,
  parent: dom7_esm_parent,
  parents: parents,
  closest: closest,
  find: find,
  children: children,
  filter: filter,
  remove: remove
};
Object.keys(Methods).forEach(methodName => {
  Object.defineProperty(dom7_esm_$.fn, methodName, {
    value: Methods[methodName],
    writable: true
  });
});
/* harmony default export */ var dom = (dom7_esm_$);
;// CONCATENATED MODULE: ./node_modules/swiper/shared/utils.js


function deleteProps(obj) {
  const object = obj;
  Object.keys(object).forEach(key => {
    try {
      object[key] = null;
    } catch (e) {// no getter for object
    }

    try {
      delete object[key];
    } catch (e) {// something got wrong
    }
  });
}

function utils_nextTick(callback, delay = 0) {
  return setTimeout(callback, delay);
}

function utils_now() {
  return Date.now();
}

function utils_getComputedStyle(el) {
  const window = ssr_window_esm_getWindow();
  let style;

  if (window.getComputedStyle) {
    style = window.getComputedStyle(el, null);
  }

  if (!style && el.currentStyle) {
    style = el.currentStyle;
  }

  if (!style) {
    style = el.style;
  }

  return style;
}

function utils_getTranslate(el, axis = 'x') {
  const window = ssr_window_esm_getWindow();
  let matrix;
  let curTransform;
  let transformMatrix;
  const curStyle = utils_getComputedStyle(el, null);

  if (window.WebKitCSSMatrix) {
    curTransform = curStyle.transform || curStyle.webkitTransform;

    if (curTransform.split(',').length > 6) {
      curTransform = curTransform.split(', ').map(a => a.replace(',', '.')).join(', ');
    } // Some old versions of Webkit choke when 'none' is passed; pass
    // empty string instead in this case


    transformMatrix = new window.WebKitCSSMatrix(curTransform === 'none' ? '' : curTransform);
  } else {
    transformMatrix = curStyle.MozTransform || curStyle.OTransform || curStyle.MsTransform || curStyle.msTransform || curStyle.transform || curStyle.getPropertyValue('transform').replace('translate(', 'matrix(1, 0, 0, 1,');
    matrix = transformMatrix.toString().split(',');
  }

  if (axis === 'x') {
    // Latest Chrome and webkits Fix
    if (window.WebKitCSSMatrix) curTransform = transformMatrix.m41; // Crazy IE10 Matrix
    else if (matrix.length === 16) curTransform = parseFloat(matrix[12]); // Normal Browsers
    else curTransform = parseFloat(matrix[4]);
  }

  if (axis === 'y') {
    // Latest Chrome and webkits Fix
    if (window.WebKitCSSMatrix) curTransform = transformMatrix.m42; // Crazy IE10 Matrix
    else if (matrix.length === 16) curTransform = parseFloat(matrix[13]); // Normal Browsers
    else curTransform = parseFloat(matrix[5]);
  }

  return curTransform || 0;
}

function utils_isObject(o) {
  return typeof o === 'object' && o !== null && o.constructor && Object.prototype.toString.call(o).slice(8, -1) === 'Object';
}

function isNode(node) {
  // eslint-disable-next-line
  if (typeof window !== 'undefined' && typeof window.HTMLElement !== 'undefined') {
    return node instanceof HTMLElement;
  }

  return node && (node.nodeType === 1 || node.nodeType === 11);
}

function utils_extend(...args) {
  const to = Object(args[0]);
  const noExtend = ['__proto__', 'constructor', 'prototype'];

  for (let i = 1; i < args.length; i += 1) {
    const nextSource = args[i];

    if (nextSource !== undefined && nextSource !== null && !isNode(nextSource)) {
      const keysArray = Object.keys(Object(nextSource)).filter(key => noExtend.indexOf(key) < 0);

      for (let nextIndex = 0, len = keysArray.length; nextIndex < len; nextIndex += 1) {
        const nextKey = keysArray[nextIndex];
        const desc = Object.getOwnPropertyDescriptor(nextSource, nextKey);

        if (desc !== undefined && desc.enumerable) {
          if (utils_isObject(to[nextKey]) && utils_isObject(nextSource[nextKey])) {
            if (nextSource[nextKey].__swiper__) {
              to[nextKey] = nextSource[nextKey];
            } else {
              utils_extend(to[nextKey], nextSource[nextKey]);
            }
          } else if (!utils_isObject(to[nextKey]) && utils_isObject(nextSource[nextKey])) {
            to[nextKey] = {};

            if (nextSource[nextKey].__swiper__) {
              to[nextKey] = nextSource[nextKey];
            } else {
              utils_extend(to[nextKey], nextSource[nextKey]);
            }
          } else {
            to[nextKey] = nextSource[nextKey];
          }
        }
      }
    }
  }

  return to;
}

function utils_setCSSProperty(el, varName, varValue) {
  el.style.setProperty(varName, varValue);
}

function animateCSSModeScroll({
  swiper,
  targetPosition,
  side
}) {
  const window = ssr_window_esm_getWindow();
  const startPosition = -swiper.translate;
  let startTime = null;
  let time;
  const duration = swiper.params.speed;
  swiper.wrapperEl.style.scrollSnapType = 'none';
  window.cancelAnimationFrame(swiper.cssModeFrameID);
  const dir = targetPosition > startPosition ? 'next' : 'prev';

  const isOutOfBound = (current, target) => {
    return dir === 'next' && current >= target || dir === 'prev' && current <= target;
  };

  const animate = () => {
    time = new Date().getTime();

    if (startTime === null) {
      startTime = time;
    }

    const progress = Math.max(Math.min((time - startTime) / duration, 1), 0);
    const easeProgress = 0.5 - Math.cos(progress * Math.PI) / 2;
    let currentPosition = startPosition + easeProgress * (targetPosition - startPosition);

    if (isOutOfBound(currentPosition, targetPosition)) {
      currentPosition = targetPosition;
    }

    swiper.wrapperEl.scrollTo({
      [side]: currentPosition
    });

    if (isOutOfBound(currentPosition, targetPosition)) {
      swiper.wrapperEl.style.overflow = 'hidden';
      swiper.wrapperEl.style.scrollSnapType = '';
      setTimeout(() => {
        swiper.wrapperEl.style.overflow = '';
        swiper.wrapperEl.scrollTo({
          [side]: currentPosition
        });
      });
      window.cancelAnimationFrame(swiper.cssModeFrameID);
      return;
    }

    swiper.cssModeFrameID = window.requestAnimationFrame(animate);
  };

  animate();
}


;// CONCATENATED MODULE: ./node_modules/swiper/shared/get-support.js

let support;

function calcSupport() {
  const window = ssr_window_esm_getWindow();
  const document = ssr_window_esm_getDocument();
  return {
    smoothScroll: document.documentElement && 'scrollBehavior' in document.documentElement.style,
    touch: !!('ontouchstart' in window || window.DocumentTouch && document instanceof window.DocumentTouch),
    passiveListener: function checkPassiveListener() {
      let supportsPassive = false;

      try {
        const opts = Object.defineProperty({}, 'passive', {
          // eslint-disable-next-line
          get() {
            supportsPassive = true;
          }

        });
        window.addEventListener('testPassiveListener', null, opts);
      } catch (e) {// No support
      }

      return supportsPassive;
    }(),
    gestures: function checkGestures() {
      return 'ongesturestart' in window;
    }()
  };
}

function getSupport() {
  if (!support) {
    support = calcSupport();
  }

  return support;
}


;// CONCATENATED MODULE: ./node_modules/swiper/shared/get-device.js


let deviceCached;

function calcDevice({
  userAgent
} = {}) {
  const support = getSupport();
  const window = ssr_window_esm_getWindow();
  const platform = window.navigator.platform;
  const ua = userAgent || window.navigator.userAgent;
  const device = {
    ios: false,
    android: false
  };
  const screenWidth = window.screen.width;
  const screenHeight = window.screen.height;
  const android = ua.match(/(Android);?[\s\/]+([\d.]+)?/); // eslint-disable-line

  let ipad = ua.match(/(iPad).*OS\s([\d_]+)/);
  const ipod = ua.match(/(iPod)(.*OS\s([\d_]+))?/);
  const iphone = !ipad && ua.match(/(iPhone\sOS|iOS)\s([\d_]+)/);
  const windows = platform === 'Win32';
  let macos = platform === 'MacIntel'; // iPadOs 13 fix

  const iPadScreens = ['1024x1366', '1366x1024', '834x1194', '1194x834', '834x1112', '1112x834', '768x1024', '1024x768', '820x1180', '1180x820', '810x1080', '1080x810'];

  if (!ipad && macos && support.touch && iPadScreens.indexOf(`${screenWidth}x${screenHeight}`) >= 0) {
    ipad = ua.match(/(Version)\/([\d.]+)/);
    if (!ipad) ipad = [0, 1, '13_0_0'];
    macos = false;
  } // Android


  if (android && !windows) {
    device.os = 'android';
    device.android = true;
  }

  if (ipad || iphone || ipod) {
    device.os = 'ios';
    device.ios = true;
  } // Export object


  return device;
}

function getDevice(overrides = {}) {
  if (!deviceCached) {
    deviceCached = calcDevice(overrides);
  }

  return deviceCached;
}


;// CONCATENATED MODULE: ./node_modules/swiper/shared/get-browser.js

let browser;

function calcBrowser() {
  const window = ssr_window_esm_getWindow();

  function isSafari() {
    const ua = window.navigator.userAgent.toLowerCase();
    return ua.indexOf('safari') >= 0 && ua.indexOf('chrome') < 0 && ua.indexOf('android') < 0;
  }

  return {
    isSafari: isSafari(),
    isWebView: /(iPhone|iPod|iPad).*AppleWebKit(?!.*Safari)/i.test(window.navigator.userAgent)
  };
}

function getBrowser() {
  if (!browser) {
    browser = calcBrowser();
  }

  return browser;
}


;// CONCATENATED MODULE: ./node_modules/swiper/core/modules/resize/resize.js

function Resize({
  swiper,
  on,
  emit
}) {
  const window = ssr_window_esm_getWindow();
  let observer = null;
  let animationFrame = null;

  const resizeHandler = () => {
    if (!swiper || swiper.destroyed || !swiper.initialized) return;
    emit('beforeResize');
    emit('resize');
  };

  const createObserver = () => {
    if (!swiper || swiper.destroyed || !swiper.initialized) return;
    observer = new ResizeObserver(entries => {
      animationFrame = window.requestAnimationFrame(() => {
        const {
          width,
          height
        } = swiper;
        let newWidth = width;
        let newHeight = height;
        entries.forEach(({
          contentBoxSize,
          contentRect,
          target
        }) => {
          if (target && target !== swiper.el) return;
          newWidth = contentRect ? contentRect.width : (contentBoxSize[0] || contentBoxSize).inlineSize;
          newHeight = contentRect ? contentRect.height : (contentBoxSize[0] || contentBoxSize).blockSize;
        });

        if (newWidth !== width || newHeight !== height) {
          resizeHandler();
        }
      });
    });
    observer.observe(swiper.el);
  };

  const removeObserver = () => {
    if (animationFrame) {
      window.cancelAnimationFrame(animationFrame);
    }

    if (observer && observer.unobserve && swiper.el) {
      observer.unobserve(swiper.el);
      observer = null;
    }
  };

  const orientationChangeHandler = () => {
    if (!swiper || swiper.destroyed || !swiper.initialized) return;
    emit('orientationchange');
  };

  on('init', () => {
    if (swiper.params.resizeObserver && typeof window.ResizeObserver !== 'undefined') {
      createObserver();
      return;
    }

    window.addEventListener('resize', resizeHandler);
    window.addEventListener('orientationchange', orientationChangeHandler);
  });
  on('destroy', () => {
    removeObserver();
    window.removeEventListener('resize', resizeHandler);
    window.removeEventListener('orientationchange', orientationChangeHandler);
  });
}
;// CONCATENATED MODULE: ./node_modules/swiper/core/modules/observer/observer.js

function Observer({
  swiper,
  extendParams,
  on,
  emit
}) {
  const observers = [];
  const window = ssr_window_esm_getWindow();

  const attach = (target, options = {}) => {
    const ObserverFunc = window.MutationObserver || window.WebkitMutationObserver;
    const observer = new ObserverFunc(mutations => {
      // The observerUpdate event should only be triggered
      // once despite the number of mutations.  Additional
      // triggers are redundant and are very costly
      if (mutations.length === 1) {
        emit('observerUpdate', mutations[0]);
        return;
      }

      const observerUpdate = function observerUpdate() {
        emit('observerUpdate', mutations[0]);
      };

      if (window.requestAnimationFrame) {
        window.requestAnimationFrame(observerUpdate);
      } else {
        window.setTimeout(observerUpdate, 0);
      }
    });
    observer.observe(target, {
      attributes: typeof options.attributes === 'undefined' ? true : options.attributes,
      childList: typeof options.childList === 'undefined' ? true : options.childList,
      characterData: typeof options.characterData === 'undefined' ? true : options.characterData
    });
    observers.push(observer);
  };

  const init = () => {
    if (!swiper.params.observer) return;

    if (swiper.params.observeParents) {
      const containerParents = swiper.$el.parents();

      for (let i = 0; i < containerParents.length; i += 1) {
        attach(containerParents[i]);
      }
    } // Observe container


    attach(swiper.$el[0], {
      childList: swiper.params.observeSlideChildren
    }); // Observe wrapper

    attach(swiper.$wrapperEl[0], {
      attributes: false
    });
  };

  const destroy = () => {
    observers.forEach(observer => {
      observer.disconnect();
    });
    observers.splice(0, observers.length);
  };

  extendParams({
    observer: false,
    observeParents: false,
    observeSlideChildren: false
  });
  on('init', init);
  on('destroy', destroy);
}
;// CONCATENATED MODULE: ./node_modules/swiper/core/events-emitter.js
/* eslint-disable no-underscore-dangle */
/* harmony default export */ var events_emitter = ({
  on(events, handler, priority) {
    const self = this;
    if (!self.eventsListeners || self.destroyed) return self;
    if (typeof handler !== 'function') return self;
    const method = priority ? 'unshift' : 'push';
    events.split(' ').forEach(event => {
      if (!self.eventsListeners[event]) self.eventsListeners[event] = [];
      self.eventsListeners[event][method](handler);
    });
    return self;
  },

  once(events, handler, priority) {
    const self = this;
    if (!self.eventsListeners || self.destroyed) return self;
    if (typeof handler !== 'function') return self;

    function onceHandler(...args) {
      self.off(events, onceHandler);

      if (onceHandler.__emitterProxy) {
        delete onceHandler.__emitterProxy;
      }

      handler.apply(self, args);
    }

    onceHandler.__emitterProxy = handler;
    return self.on(events, onceHandler, priority);
  },

  onAny(handler, priority) {
    const self = this;
    if (!self.eventsListeners || self.destroyed) return self;
    if (typeof handler !== 'function') return self;
    const method = priority ? 'unshift' : 'push';

    if (self.eventsAnyListeners.indexOf(handler) < 0) {
      self.eventsAnyListeners[method](handler);
    }

    return self;
  },

  offAny(handler) {
    const self = this;
    if (!self.eventsListeners || self.destroyed) return self;
    if (!self.eventsAnyListeners) return self;
    const index = self.eventsAnyListeners.indexOf(handler);

    if (index >= 0) {
      self.eventsAnyListeners.splice(index, 1);
    }

    return self;
  },

  off(events, handler) {
    const self = this;
    if (!self.eventsListeners || self.destroyed) return self;
    if (!self.eventsListeners) return self;
    events.split(' ').forEach(event => {
      if (typeof handler === 'undefined') {
        self.eventsListeners[event] = [];
      } else if (self.eventsListeners[event]) {
        self.eventsListeners[event].forEach((eventHandler, index) => {
          if (eventHandler === handler || eventHandler.__emitterProxy && eventHandler.__emitterProxy === handler) {
            self.eventsListeners[event].splice(index, 1);
          }
        });
      }
    });
    return self;
  },

  emit(...args) {
    const self = this;
    if (!self.eventsListeners || self.destroyed) return self;
    if (!self.eventsListeners) return self;
    let events;
    let data;
    let context;

    if (typeof args[0] === 'string' || Array.isArray(args[0])) {
      events = args[0];
      data = args.slice(1, args.length);
      context = self;
    } else {
      events = args[0].events;
      data = args[0].data;
      context = args[0].context || self;
    }

    data.unshift(context);
    const eventsArray = Array.isArray(events) ? events : events.split(' ');
    eventsArray.forEach(event => {
      if (self.eventsAnyListeners && self.eventsAnyListeners.length) {
        self.eventsAnyListeners.forEach(eventHandler => {
          eventHandler.apply(context, [event, ...data]);
        });
      }

      if (self.eventsListeners && self.eventsListeners[event]) {
        self.eventsListeners[event].forEach(eventHandler => {
          eventHandler.apply(context, data);
        });
      }
    });
    return self;
  }

});
;// CONCATENATED MODULE: ./node_modules/swiper/core/update/updateSize.js
function updateSize() {
  const swiper = this;
  let width;
  let height;
  const $el = swiper.$el;

  if (typeof swiper.params.width !== 'undefined' && swiper.params.width !== null) {
    width = swiper.params.width;
  } else {
    width = $el[0].clientWidth;
  }

  if (typeof swiper.params.height !== 'undefined' && swiper.params.height !== null) {
    height = swiper.params.height;
  } else {
    height = $el[0].clientHeight;
  }

  if (width === 0 && swiper.isHorizontal() || height === 0 && swiper.isVertical()) {
    return;
  } // Subtract paddings


  width = width - parseInt($el.css('padding-left') || 0, 10) - parseInt($el.css('padding-right') || 0, 10);
  height = height - parseInt($el.css('padding-top') || 0, 10) - parseInt($el.css('padding-bottom') || 0, 10);
  if (Number.isNaN(width)) width = 0;
  if (Number.isNaN(height)) height = 0;
  Object.assign(swiper, {
    width,
    height,
    size: swiper.isHorizontal() ? width : height
  });
}
;// CONCATENATED MODULE: ./node_modules/swiper/core/update/updateSlides.js

function updateSlides() {
  const swiper = this;

  function getDirectionLabel(property) {
    if (swiper.isHorizontal()) {
      return property;
    } // prettier-ignore


    return {
      'width': 'height',
      'margin-top': 'margin-left',
      'margin-bottom ': 'margin-right',
      'margin-left': 'margin-top',
      'margin-right': 'margin-bottom',
      'padding-left': 'padding-top',
      'padding-right': 'padding-bottom',
      'marginRight': 'marginBottom'
    }[property];
  }

  function getDirectionPropertyValue(node, label) {
    return parseFloat(node.getPropertyValue(getDirectionLabel(label)) || 0);
  }

  const params = swiper.params;
  const {
    $wrapperEl,
    size: swiperSize,
    rtlTranslate: rtl,
    wrongRTL
  } = swiper;
  const isVirtual = swiper.virtual && params.virtual.enabled;
  const previousSlidesLength = isVirtual ? swiper.virtual.slides.length : swiper.slides.length;
  const slides = $wrapperEl.children(`.${swiper.params.slideClass}`);
  const slidesLength = isVirtual ? swiper.virtual.slides.length : slides.length;
  let snapGrid = [];
  const slidesGrid = [];
  const slidesSizesGrid = [];
  let offsetBefore = params.slidesOffsetBefore;

  if (typeof offsetBefore === 'function') {
    offsetBefore = params.slidesOffsetBefore.call(swiper);
  }

  let offsetAfter = params.slidesOffsetAfter;

  if (typeof offsetAfter === 'function') {
    offsetAfter = params.slidesOffsetAfter.call(swiper);
  }

  const previousSnapGridLength = swiper.snapGrid.length;
  const previousSlidesGridLength = swiper.slidesGrid.length;
  let spaceBetween = params.spaceBetween;
  let slidePosition = -offsetBefore;
  let prevSlideSize = 0;
  let index = 0;

  if (typeof swiperSize === 'undefined') {
    return;
  }

  if (typeof spaceBetween === 'string' && spaceBetween.indexOf('%') >= 0) {
    spaceBetween = parseFloat(spaceBetween.replace('%', '')) / 100 * swiperSize;
  }

  swiper.virtualSize = -spaceBetween; // reset margins

  if (rtl) slides.css({
    marginLeft: '',
    marginBottom: '',
    marginTop: ''
  });else slides.css({
    marginRight: '',
    marginBottom: '',
    marginTop: ''
  }); // reset cssMode offsets

  if (params.centeredSlides && params.cssMode) {
    utils_setCSSProperty(swiper.wrapperEl, '--swiper-centered-offset-before', '');
    utils_setCSSProperty(swiper.wrapperEl, '--swiper-centered-offset-after', '');
  }

  const gridEnabled = params.grid && params.grid.rows > 1 && swiper.grid;

  if (gridEnabled) {
    swiper.grid.initSlides(slidesLength);
  } // Calc slides


  let slideSize;
  const shouldResetSlideSize = params.slidesPerView === 'auto' && params.breakpoints && Object.keys(params.breakpoints).filter(key => {
    return typeof params.breakpoints[key].slidesPerView !== 'undefined';
  }).length > 0;

  for (let i = 0; i < slidesLength; i += 1) {
    slideSize = 0;
    const slide = slides.eq(i);

    if (gridEnabled) {
      swiper.grid.updateSlide(i, slide, slidesLength, getDirectionLabel);
    }

    if (slide.css('display') === 'none') continue; // eslint-disable-line

    if (params.slidesPerView === 'auto') {
      if (shouldResetSlideSize) {
        slides[i].style[getDirectionLabel('width')] = ``;
      }

      const slideStyles = getComputedStyle(slide[0]);
      const currentTransform = slide[0].style.transform;
      const currentWebKitTransform = slide[0].style.webkitTransform;

      if (currentTransform) {
        slide[0].style.transform = 'none';
      }

      if (currentWebKitTransform) {
        slide[0].style.webkitTransform = 'none';
      }

      if (params.roundLengths) {
        slideSize = swiper.isHorizontal() ? slide.outerWidth(true) : slide.outerHeight(true);
      } else {
        // eslint-disable-next-line
        const width = getDirectionPropertyValue(slideStyles, 'width');
        const paddingLeft = getDirectionPropertyValue(slideStyles, 'padding-left');
        const paddingRight = getDirectionPropertyValue(slideStyles, 'padding-right');
        const marginLeft = getDirectionPropertyValue(slideStyles, 'margin-left');
        const marginRight = getDirectionPropertyValue(slideStyles, 'margin-right');
        const boxSizing = slideStyles.getPropertyValue('box-sizing');

        if (boxSizing && boxSizing === 'border-box') {
          slideSize = width + marginLeft + marginRight;
        } else {
          const {
            clientWidth,
            offsetWidth
          } = slide[0];
          slideSize = width + paddingLeft + paddingRight + marginLeft + marginRight + (offsetWidth - clientWidth);
        }
      }

      if (currentTransform) {
        slide[0].style.transform = currentTransform;
      }

      if (currentWebKitTransform) {
        slide[0].style.webkitTransform = currentWebKitTransform;
      }

      if (params.roundLengths) slideSize = Math.floor(slideSize);
    } else {
      slideSize = (swiperSize - (params.slidesPerView - 1) * spaceBetween) / params.slidesPerView;
      if (params.roundLengths) slideSize = Math.floor(slideSize);

      if (slides[i]) {
        slides[i].style[getDirectionLabel('width')] = `${slideSize}px`;
      }
    }

    if (slides[i]) {
      slides[i].swiperSlideSize = slideSize;
    }

    slidesSizesGrid.push(slideSize);

    if (params.centeredSlides) {
      slidePosition = slidePosition + slideSize / 2 + prevSlideSize / 2 + spaceBetween;
      if (prevSlideSize === 0 && i !== 0) slidePosition = slidePosition - swiperSize / 2 - spaceBetween;
      if (i === 0) slidePosition = slidePosition - swiperSize / 2 - spaceBetween;
      if (Math.abs(slidePosition) < 1 / 1000) slidePosition = 0;
      if (params.roundLengths) slidePosition = Math.floor(slidePosition);
      if (index % params.slidesPerGroup === 0) snapGrid.push(slidePosition);
      slidesGrid.push(slidePosition);
    } else {
      if (params.roundLengths) slidePosition = Math.floor(slidePosition);
      if ((index - Math.min(swiper.params.slidesPerGroupSkip, index)) % swiper.params.slidesPerGroup === 0) snapGrid.push(slidePosition);
      slidesGrid.push(slidePosition);
      slidePosition = slidePosition + slideSize + spaceBetween;
    }

    swiper.virtualSize += slideSize + spaceBetween;
    prevSlideSize = slideSize;
    index += 1;
  }

  swiper.virtualSize = Math.max(swiper.virtualSize, swiperSize) + offsetAfter;

  if (rtl && wrongRTL && (params.effect === 'slide' || params.effect === 'coverflow')) {
    $wrapperEl.css({
      width: `${swiper.virtualSize + params.spaceBetween}px`
    });
  }

  if (params.setWrapperSize) {
    $wrapperEl.css({
      [getDirectionLabel('width')]: `${swiper.virtualSize + params.spaceBetween}px`
    });
  }

  if (gridEnabled) {
    swiper.grid.updateWrapperSize(slideSize, snapGrid, getDirectionLabel);
  } // Remove last grid elements depending on width


  if (!params.centeredSlides) {
    const newSlidesGrid = [];

    for (let i = 0; i < snapGrid.length; i += 1) {
      let slidesGridItem = snapGrid[i];
      if (params.roundLengths) slidesGridItem = Math.floor(slidesGridItem);

      if (snapGrid[i] <= swiper.virtualSize - swiperSize) {
        newSlidesGrid.push(slidesGridItem);
      }
    }

    snapGrid = newSlidesGrid;

    if (Math.floor(swiper.virtualSize - swiperSize) - Math.floor(snapGrid[snapGrid.length - 1]) > 1) {
      snapGrid.push(swiper.virtualSize - swiperSize);
    }
  }

  if (snapGrid.length === 0) snapGrid = [0];

  if (params.spaceBetween !== 0) {
    const key = swiper.isHorizontal() && rtl ? 'marginLeft' : getDirectionLabel('marginRight');
    slides.filter((_, slideIndex) => {
      if (!params.cssMode) return true;

      if (slideIndex === slides.length - 1) {
        return false;
      }

      return true;
    }).css({
      [key]: `${spaceBetween}px`
    });
  }

  if (params.centeredSlides && params.centeredSlidesBounds) {
    let allSlidesSize = 0;
    slidesSizesGrid.forEach(slideSizeValue => {
      allSlidesSize += slideSizeValue + (params.spaceBetween ? params.spaceBetween : 0);
    });
    allSlidesSize -= params.spaceBetween;
    const maxSnap = allSlidesSize - swiperSize;
    snapGrid = snapGrid.map(snap => {
      if (snap < 0) return -offsetBefore;
      if (snap > maxSnap) return maxSnap + offsetAfter;
      return snap;
    });
  }

  if (params.centerInsufficientSlides) {
    let allSlidesSize = 0;
    slidesSizesGrid.forEach(slideSizeValue => {
      allSlidesSize += slideSizeValue + (params.spaceBetween ? params.spaceBetween : 0);
    });
    allSlidesSize -= params.spaceBetween;

    if (allSlidesSize < swiperSize) {
      const allSlidesOffset = (swiperSize - allSlidesSize) / 2;
      snapGrid.forEach((snap, snapIndex) => {
        snapGrid[snapIndex] = snap - allSlidesOffset;
      });
      slidesGrid.forEach((snap, snapIndex) => {
        slidesGrid[snapIndex] = snap + allSlidesOffset;
      });
    }
  }

  Object.assign(swiper, {
    slides,
    snapGrid,
    slidesGrid,
    slidesSizesGrid
  });

  if (params.centeredSlides && params.cssMode && !params.centeredSlidesBounds) {
    utils_setCSSProperty(swiper.wrapperEl, '--swiper-centered-offset-before', `${-snapGrid[0]}px`);
    utils_setCSSProperty(swiper.wrapperEl, '--swiper-centered-offset-after', `${swiper.size / 2 - slidesSizesGrid[slidesSizesGrid.length - 1] / 2}px`);
    const addToSnapGrid = -swiper.snapGrid[0];
    const addToSlidesGrid = -swiper.slidesGrid[0];
    swiper.snapGrid = swiper.snapGrid.map(v => v + addToSnapGrid);
    swiper.slidesGrid = swiper.slidesGrid.map(v => v + addToSlidesGrid);
  }

  if (slidesLength !== previousSlidesLength) {
    swiper.emit('slidesLengthChange');
  }

  if (snapGrid.length !== previousSnapGridLength) {
    if (swiper.params.watchOverflow) swiper.checkOverflow();
    swiper.emit('snapGridLengthChange');
  }

  if (slidesGrid.length !== previousSlidesGridLength) {
    swiper.emit('slidesGridLengthChange');
  }

  if (params.watchSlidesProgress) {
    swiper.updateSlidesOffset();
  }

  if (!isVirtual && !params.cssMode && (params.effect === 'slide' || params.effect === 'fade')) {
    const backFaceHiddenClass = `${params.containerModifierClass}backface-hidden`;
    const hasClassBackfaceClassAdded = swiper.$el.hasClass(backFaceHiddenClass);

    if (slidesLength <= params.maxBackfaceHiddenSlides) {
      if (!hasClassBackfaceClassAdded) swiper.$el.addClass(backFaceHiddenClass);
    } else if (hasClassBackfaceClassAdded) {
      swiper.$el.removeClass(backFaceHiddenClass);
    }
  }
}
;// CONCATENATED MODULE: ./node_modules/swiper/core/update/updateAutoHeight.js

function updateAutoHeight(speed) {
  const swiper = this;
  const activeSlides = [];
  const isVirtual = swiper.virtual && swiper.params.virtual.enabled;
  let newHeight = 0;
  let i;

  if (typeof speed === 'number') {
    swiper.setTransition(speed);
  } else if (speed === true) {
    swiper.setTransition(swiper.params.speed);
  }

  const getSlideByIndex = index => {
    if (isVirtual) {
      return swiper.slides.filter(el => parseInt(el.getAttribute('data-swiper-slide-index'), 10) === index)[0];
    }

    return swiper.slides.eq(index)[0];
  }; // Find slides currently in view


  if (swiper.params.slidesPerView !== 'auto' && swiper.params.slidesPerView > 1) {
    if (swiper.params.centeredSlides) {
      (swiper.visibleSlides || dom([])).each(slide => {
        activeSlides.push(slide);
      });
    } else {
      for (i = 0; i < Math.ceil(swiper.params.slidesPerView); i += 1) {
        const index = swiper.activeIndex + i;
        if (index > swiper.slides.length && !isVirtual) break;
        activeSlides.push(getSlideByIndex(index));
      }
    }
  } else {
    activeSlides.push(getSlideByIndex(swiper.activeIndex));
  } // Find new height from highest slide in view


  for (i = 0; i < activeSlides.length; i += 1) {
    if (typeof activeSlides[i] !== 'undefined') {
      const height = activeSlides[i].offsetHeight;
      newHeight = height > newHeight ? height : newHeight;
    }
  } // Update Height


  if (newHeight || newHeight === 0) swiper.$wrapperEl.css('height', `${newHeight}px`);
}
;// CONCATENATED MODULE: ./node_modules/swiper/core/update/updateSlidesOffset.js
function updateSlidesOffset() {
  const swiper = this;
  const slides = swiper.slides;

  for (let i = 0; i < slides.length; i += 1) {
    slides[i].swiperSlideOffset = swiper.isHorizontal() ? slides[i].offsetLeft : slides[i].offsetTop;
  }
}
;// CONCATENATED MODULE: ./node_modules/swiper/core/update/updateSlidesProgress.js

function updateSlidesProgress(translate = this && this.translate || 0) {
  const swiper = this;
  const params = swiper.params;
  const {
    slides,
    rtlTranslate: rtl,
    snapGrid
  } = swiper;
  if (slides.length === 0) return;
  if (typeof slides[0].swiperSlideOffset === 'undefined') swiper.updateSlidesOffset();
  let offsetCenter = -translate;
  if (rtl) offsetCenter = translate; // Visible Slides

  slides.removeClass(params.slideVisibleClass);
  swiper.visibleSlidesIndexes = [];
  swiper.visibleSlides = [];

  for (let i = 0; i < slides.length; i += 1) {
    const slide = slides[i];
    let slideOffset = slide.swiperSlideOffset;

    if (params.cssMode && params.centeredSlides) {
      slideOffset -= slides[0].swiperSlideOffset;
    }

    const slideProgress = (offsetCenter + (params.centeredSlides ? swiper.minTranslate() : 0) - slideOffset) / (slide.swiperSlideSize + params.spaceBetween);
    const originalSlideProgress = (offsetCenter - snapGrid[0] + (params.centeredSlides ? swiper.minTranslate() : 0) - slideOffset) / (slide.swiperSlideSize + params.spaceBetween);
    const slideBefore = -(offsetCenter - slideOffset);
    const slideAfter = slideBefore + swiper.slidesSizesGrid[i];
    const isVisible = slideBefore >= 0 && slideBefore < swiper.size - 1 || slideAfter > 1 && slideAfter <= swiper.size || slideBefore <= 0 && slideAfter >= swiper.size;

    if (isVisible) {
      swiper.visibleSlides.push(slide);
      swiper.visibleSlidesIndexes.push(i);
      slides.eq(i).addClass(params.slideVisibleClass);
    }

    slide.progress = rtl ? -slideProgress : slideProgress;
    slide.originalProgress = rtl ? -originalSlideProgress : originalSlideProgress;
  }

  swiper.visibleSlides = dom(swiper.visibleSlides);
}
;// CONCATENATED MODULE: ./node_modules/swiper/core/update/updateProgress.js
function updateProgress(translate) {
  const swiper = this;

  if (typeof translate === 'undefined') {
    const multiplier = swiper.rtlTranslate ? -1 : 1; // eslint-disable-next-line

    translate = swiper && swiper.translate && swiper.translate * multiplier || 0;
  }

  const params = swiper.params;
  const translatesDiff = swiper.maxTranslate() - swiper.minTranslate();
  let {
    progress,
    isBeginning,
    isEnd
  } = swiper;
  const wasBeginning = isBeginning;
  const wasEnd = isEnd;

  if (translatesDiff === 0) {
    progress = 0;
    isBeginning = true;
    isEnd = true;
  } else {
    progress = (translate - swiper.minTranslate()) / translatesDiff;
    isBeginning = progress <= 0;
    isEnd = progress >= 1;
  }

  Object.assign(swiper, {
    progress,
    isBeginning,
    isEnd
  });
  if (params.watchSlidesProgress || params.centeredSlides && params.autoHeight) swiper.updateSlidesProgress(translate);

  if (isBeginning && !wasBeginning) {
    swiper.emit('reachBeginning toEdge');
  }

  if (isEnd && !wasEnd) {
    swiper.emit('reachEnd toEdge');
  }

  if (wasBeginning && !isBeginning || wasEnd && !isEnd) {
    swiper.emit('fromEdge');
  }

  swiper.emit('progress', progress);
}
;// CONCATENATED MODULE: ./node_modules/swiper/core/update/updateSlidesClasses.js
function updateSlidesClasses() {
  const swiper = this;
  const {
    slides,
    params,
    $wrapperEl,
    activeIndex,
    realIndex
  } = swiper;
  const isVirtual = swiper.virtual && params.virtual.enabled;
  slides.removeClass(`${params.slideActiveClass} ${params.slideNextClass} ${params.slidePrevClass} ${params.slideDuplicateActiveClass} ${params.slideDuplicateNextClass} ${params.slideDuplicatePrevClass}`);
  let activeSlide;

  if (isVirtual) {
    activeSlide = swiper.$wrapperEl.find(`.${params.slideClass}[data-swiper-slide-index="${activeIndex}"]`);
  } else {
    activeSlide = slides.eq(activeIndex);
  } // Active classes


  activeSlide.addClass(params.slideActiveClass);

  if (params.loop) {
    // Duplicate to all looped slides
    if (activeSlide.hasClass(params.slideDuplicateClass)) {
      $wrapperEl.children(`.${params.slideClass}:not(.${params.slideDuplicateClass})[data-swiper-slide-index="${realIndex}"]`).addClass(params.slideDuplicateActiveClass);
    } else {
      $wrapperEl.children(`.${params.slideClass}.${params.slideDuplicateClass}[data-swiper-slide-index="${realIndex}"]`).addClass(params.slideDuplicateActiveClass);
    }
  } // Next Slide


  let nextSlide = activeSlide.nextAll(`.${params.slideClass}`).eq(0).addClass(params.slideNextClass);

  if (params.loop && nextSlide.length === 0) {
    nextSlide = slides.eq(0);
    nextSlide.addClass(params.slideNextClass);
  } // Prev Slide


  let prevSlide = activeSlide.prevAll(`.${params.slideClass}`).eq(0).addClass(params.slidePrevClass);

  if (params.loop && prevSlide.length === 0) {
    prevSlide = slides.eq(-1);
    prevSlide.addClass(params.slidePrevClass);
  }

  if (params.loop) {
    // Duplicate to all looped slides
    if (nextSlide.hasClass(params.slideDuplicateClass)) {
      $wrapperEl.children(`.${params.slideClass}:not(.${params.slideDuplicateClass})[data-swiper-slide-index="${nextSlide.attr('data-swiper-slide-index')}"]`).addClass(params.slideDuplicateNextClass);
    } else {
      $wrapperEl.children(`.${params.slideClass}.${params.slideDuplicateClass}[data-swiper-slide-index="${nextSlide.attr('data-swiper-slide-index')}"]`).addClass(params.slideDuplicateNextClass);
    }

    if (prevSlide.hasClass(params.slideDuplicateClass)) {
      $wrapperEl.children(`.${params.slideClass}:not(.${params.slideDuplicateClass})[data-swiper-slide-index="${prevSlide.attr('data-swiper-slide-index')}"]`).addClass(params.slideDuplicatePrevClass);
    } else {
      $wrapperEl.children(`.${params.slideClass}.${params.slideDuplicateClass}[data-swiper-slide-index="${prevSlide.attr('data-swiper-slide-index')}"]`).addClass(params.slideDuplicatePrevClass);
    }
  }

  swiper.emitSlidesClasses();
}
;// CONCATENATED MODULE: ./node_modules/swiper/core/update/updateActiveIndex.js
function updateActiveIndex(newActiveIndex) {
  const swiper = this;
  const translate = swiper.rtlTranslate ? swiper.translate : -swiper.translate;
  const {
    slidesGrid,
    snapGrid,
    params,
    activeIndex: previousIndex,
    realIndex: previousRealIndex,
    snapIndex: previousSnapIndex
  } = swiper;
  let activeIndex = newActiveIndex;
  let snapIndex;

  if (typeof activeIndex === 'undefined') {
    for (let i = 0; i < slidesGrid.length; i += 1) {
      if (typeof slidesGrid[i + 1] !== 'undefined') {
        if (translate >= slidesGrid[i] && translate < slidesGrid[i + 1] - (slidesGrid[i + 1] - slidesGrid[i]) / 2) {
          activeIndex = i;
        } else if (translate >= slidesGrid[i] && translate < slidesGrid[i + 1]) {
          activeIndex = i + 1;
        }
      } else if (translate >= slidesGrid[i]) {
        activeIndex = i;
      }
    } // Normalize slideIndex


    if (params.normalizeSlideIndex) {
      if (activeIndex < 0 || typeof activeIndex === 'undefined') activeIndex = 0;
    }
  }

  if (snapGrid.indexOf(translate) >= 0) {
    snapIndex = snapGrid.indexOf(translate);
  } else {
    const skip = Math.min(params.slidesPerGroupSkip, activeIndex);
    snapIndex = skip + Math.floor((activeIndex - skip) / params.slidesPerGroup);
  }

  if (snapIndex >= snapGrid.length) snapIndex = snapGrid.length - 1;

  if (activeIndex === previousIndex) {
    if (snapIndex !== previousSnapIndex) {
      swiper.snapIndex = snapIndex;
      swiper.emit('snapIndexChange');
    }

    return;
  } // Get real index


  const realIndex = parseInt(swiper.slides.eq(activeIndex).attr('data-swiper-slide-index') || activeIndex, 10);
  Object.assign(swiper, {
    snapIndex,
    realIndex,
    previousIndex,
    activeIndex
  });
  swiper.emit('activeIndexChange');
  swiper.emit('snapIndexChange');

  if (previousRealIndex !== realIndex) {
    swiper.emit('realIndexChange');
  }

  if (swiper.initialized || swiper.params.runCallbacksOnInit) {
    swiper.emit('slideChange');
  }
}
;// CONCATENATED MODULE: ./node_modules/swiper/core/update/updateClickedSlide.js

function updateClickedSlide(e) {
  const swiper = this;
  const params = swiper.params;
  const slide = dom(e).closest(`.${params.slideClass}`)[0];
  let slideFound = false;
  let slideIndex;

  if (slide) {
    for (let i = 0; i < swiper.slides.length; i += 1) {
      if (swiper.slides[i] === slide) {
        slideFound = true;
        slideIndex = i;
        break;
      }
    }
  }

  if (slide && slideFound) {
    swiper.clickedSlide = slide;

    if (swiper.virtual && swiper.params.virtual.enabled) {
      swiper.clickedIndex = parseInt(dom(slide).attr('data-swiper-slide-index'), 10);
    } else {
      swiper.clickedIndex = slideIndex;
    }
  } else {
    swiper.clickedSlide = undefined;
    swiper.clickedIndex = undefined;
    return;
  }

  if (params.slideToClickedSlide && swiper.clickedIndex !== undefined && swiper.clickedIndex !== swiper.activeIndex) {
    swiper.slideToClickedSlide();
  }
}
;// CONCATENATED MODULE: ./node_modules/swiper/core/update/index.js









/* harmony default export */ var update = ({
  updateSize: updateSize,
  updateSlides: updateSlides,
  updateAutoHeight: updateAutoHeight,
  updateSlidesOffset: updateSlidesOffset,
  updateSlidesProgress: updateSlidesProgress,
  updateProgress: updateProgress,
  updateSlidesClasses: updateSlidesClasses,
  updateActiveIndex: updateActiveIndex,
  updateClickedSlide: updateClickedSlide
});
;// CONCATENATED MODULE: ./node_modules/swiper/core/translate/getTranslate.js

function getSwiperTranslate(axis = this.isHorizontal() ? 'x' : 'y') {
  const swiper = this;
  const {
    params,
    rtlTranslate: rtl,
    translate,
    $wrapperEl
  } = swiper;

  if (params.virtualTranslate) {
    return rtl ? -translate : translate;
  }

  if (params.cssMode) {
    return translate;
  }

  let currentTranslate = utils_getTranslate($wrapperEl[0], axis);
  if (rtl) currentTranslate = -currentTranslate;
  return currentTranslate || 0;
}
;// CONCATENATED MODULE: ./node_modules/swiper/core/translate/setTranslate.js
function setTranslate(translate, byController) {
  const swiper = this;
  const {
    rtlTranslate: rtl,
    params,
    $wrapperEl,
    wrapperEl,
    progress
  } = swiper;
  let x = 0;
  let y = 0;
  const z = 0;

  if (swiper.isHorizontal()) {
    x = rtl ? -translate : translate;
  } else {
    y = translate;
  }

  if (params.roundLengths) {
    x = Math.floor(x);
    y = Math.floor(y);
  }

  if (params.cssMode) {
    wrapperEl[swiper.isHorizontal() ? 'scrollLeft' : 'scrollTop'] = swiper.isHorizontal() ? -x : -y;
  } else if (!params.virtualTranslate) {
    $wrapperEl.transform(`translate3d(${x}px, ${y}px, ${z}px)`);
  }

  swiper.previousTranslate = swiper.translate;
  swiper.translate = swiper.isHorizontal() ? x : y; // Check if we need to update progress

  let newProgress;
  const translatesDiff = swiper.maxTranslate() - swiper.minTranslate();

  if (translatesDiff === 0) {
    newProgress = 0;
  } else {
    newProgress = (translate - swiper.minTranslate()) / translatesDiff;
  }

  if (newProgress !== progress) {
    swiper.updateProgress(translate);
  }

  swiper.emit('setTranslate', swiper.translate, byController);
}
;// CONCATENATED MODULE: ./node_modules/swiper/core/translate/minTranslate.js
function minTranslate() {
  return -this.snapGrid[0];
}
;// CONCATENATED MODULE: ./node_modules/swiper/core/translate/maxTranslate.js
function maxTranslate() {
  return -this.snapGrid[this.snapGrid.length - 1];
}
;// CONCATENATED MODULE: ./node_modules/swiper/core/translate/translateTo.js

function translateTo(translate = 0, speed = this.params.speed, runCallbacks = true, translateBounds = true, internal) {
  const swiper = this;
  const {
    params,
    wrapperEl
  } = swiper;

  if (swiper.animating && params.preventInteractionOnTransition) {
    return false;
  }

  const minTranslate = swiper.minTranslate();
  const maxTranslate = swiper.maxTranslate();
  let newTranslate;
  if (translateBounds && translate > minTranslate) newTranslate = minTranslate;else if (translateBounds && translate < maxTranslate) newTranslate = maxTranslate;else newTranslate = translate; // Update progress

  swiper.updateProgress(newTranslate);

  if (params.cssMode) {
    const isH = swiper.isHorizontal();

    if (speed === 0) {
      wrapperEl[isH ? 'scrollLeft' : 'scrollTop'] = -newTranslate;
    } else {
      if (!swiper.support.smoothScroll) {
        animateCSSModeScroll({
          swiper,
          targetPosition: -newTranslate,
          side: isH ? 'left' : 'top'
        });
        return true;
      }

      wrapperEl.scrollTo({
        [isH ? 'left' : 'top']: -newTranslate,
        behavior: 'smooth'
      });
    }

    return true;
  }

  if (speed === 0) {
    swiper.setTransition(0);
    swiper.setTranslate(newTranslate);

    if (runCallbacks) {
      swiper.emit('beforeTransitionStart', speed, internal);
      swiper.emit('transitionEnd');
    }
  } else {
    swiper.setTransition(speed);
    swiper.setTranslate(newTranslate);

    if (runCallbacks) {
      swiper.emit('beforeTransitionStart', speed, internal);
      swiper.emit('transitionStart');
    }

    if (!swiper.animating) {
      swiper.animating = true;

      if (!swiper.onTranslateToWrapperTransitionEnd) {
        swiper.onTranslateToWrapperTransitionEnd = function transitionEnd(e) {
          if (!swiper || swiper.destroyed) return;
          if (e.target !== this) return;
          swiper.$wrapperEl[0].removeEventListener('transitionend', swiper.onTranslateToWrapperTransitionEnd);
          swiper.$wrapperEl[0].removeEventListener('webkitTransitionEnd', swiper.onTranslateToWrapperTransitionEnd);
          swiper.onTranslateToWrapperTransitionEnd = null;
          delete swiper.onTranslateToWrapperTransitionEnd;

          if (runCallbacks) {
            swiper.emit('transitionEnd');
          }
        };
      }

      swiper.$wrapperEl[0].addEventListener('transitionend', swiper.onTranslateToWrapperTransitionEnd);
      swiper.$wrapperEl[0].addEventListener('webkitTransitionEnd', swiper.onTranslateToWrapperTransitionEnd);
    }
  }

  return true;
}
;// CONCATENATED MODULE: ./node_modules/swiper/core/translate/index.js





/* harmony default export */ var translate = ({
  getTranslate: getSwiperTranslate,
  setTranslate: setTranslate,
  minTranslate: minTranslate,
  maxTranslate: maxTranslate,
  translateTo: translateTo
});
;// CONCATENATED MODULE: ./node_modules/swiper/core/transition/setTransition.js
function setTransition(duration, byController) {
  const swiper = this;

  if (!swiper.params.cssMode) {
    swiper.$wrapperEl.transition(duration);
  }

  swiper.emit('setTransition', duration, byController);
}
;// CONCATENATED MODULE: ./node_modules/swiper/core/transition/transitionEmit.js
function transitionEmit({
  swiper,
  runCallbacks,
  direction,
  step
}) {
  const {
    activeIndex,
    previousIndex
  } = swiper;
  let dir = direction;

  if (!dir) {
    if (activeIndex > previousIndex) dir = 'next';else if (activeIndex < previousIndex) dir = 'prev';else dir = 'reset';
  }

  swiper.emit(`transition${step}`);

  if (runCallbacks && activeIndex !== previousIndex) {
    if (dir === 'reset') {
      swiper.emit(`slideResetTransition${step}`);
      return;
    }

    swiper.emit(`slideChangeTransition${step}`);

    if (dir === 'next') {
      swiper.emit(`slideNextTransition${step}`);
    } else {
      swiper.emit(`slidePrevTransition${step}`);
    }
  }
}
;// CONCATENATED MODULE: ./node_modules/swiper/core/transition/transitionStart.js

function transitionStart_transitionStart(runCallbacks = true, direction) {
  const swiper = this;
  const {
    params
  } = swiper;
  if (params.cssMode) return;

  if (params.autoHeight) {
    swiper.updateAutoHeight();
  }

  transitionEmit({
    swiper,
    runCallbacks,
    direction,
    step: 'Start'
  });
}
;// CONCATENATED MODULE: ./node_modules/swiper/core/transition/transitionEnd.js

function transitionEnd_transitionEnd(runCallbacks = true, direction) {
  const swiper = this;
  const {
    params
  } = swiper;
  swiper.animating = false;
  if (params.cssMode) return;
  swiper.setTransition(0);
  transitionEmit({
    swiper,
    runCallbacks,
    direction,
    step: 'End'
  });
}
;// CONCATENATED MODULE: ./node_modules/swiper/core/transition/index.js



/* harmony default export */ var core_transition = ({
  setTransition: setTransition,
  transitionStart: transitionStart_transitionStart,
  transitionEnd: transitionEnd_transitionEnd
});
;// CONCATENATED MODULE: ./node_modules/swiper/core/slide/slideTo.js

function slideTo(index = 0, speed = this.params.speed, runCallbacks = true, internal, initial) {
  if (typeof index !== 'number' && typeof index !== 'string') {
    throw new Error(`The 'index' argument cannot have type other than 'number' or 'string'. [${typeof index}] given.`);
  }

  if (typeof index === 'string') {
    /**
     * The `index` argument converted from `string` to `number`.
     * @type {number}
     */
    const indexAsNumber = parseInt(index, 10);
    /**
     * Determines whether the `index` argument is a valid `number`
     * after being converted from the `string` type.
     * @type {boolean}
     */

    const isValidNumber = isFinite(indexAsNumber);

    if (!isValidNumber) {
      throw new Error(`The passed-in 'index' (string) couldn't be converted to 'number'. [${index}] given.`);
    } // Knowing that the converted `index` is a valid number,
    // we can update the original argument's value.


    index = indexAsNumber;
  }

  const swiper = this;
  let slideIndex = index;
  if (slideIndex < 0) slideIndex = 0;
  const {
    params,
    snapGrid,
    slidesGrid,
    previousIndex,
    activeIndex,
    rtlTranslate: rtl,
    wrapperEl,
    enabled
  } = swiper;

  if (swiper.animating && params.preventInteractionOnTransition || !enabled && !internal && !initial) {
    return false;
  }

  const skip = Math.min(swiper.params.slidesPerGroupSkip, slideIndex);
  let snapIndex = skip + Math.floor((slideIndex - skip) / swiper.params.slidesPerGroup);
  if (snapIndex >= snapGrid.length) snapIndex = snapGrid.length - 1;
  const translate = -snapGrid[snapIndex]; // Normalize slideIndex

  if (params.normalizeSlideIndex) {
    for (let i = 0; i < slidesGrid.length; i += 1) {
      const normalizedTranslate = -Math.floor(translate * 100);
      const normalizedGrid = Math.floor(slidesGrid[i] * 100);
      const normalizedGridNext = Math.floor(slidesGrid[i + 1] * 100);

      if (typeof slidesGrid[i + 1] !== 'undefined') {
        if (normalizedTranslate >= normalizedGrid && normalizedTranslate < normalizedGridNext - (normalizedGridNext - normalizedGrid) / 2) {
          slideIndex = i;
        } else if (normalizedTranslate >= normalizedGrid && normalizedTranslate < normalizedGridNext) {
          slideIndex = i + 1;
        }
      } else if (normalizedTranslate >= normalizedGrid) {
        slideIndex = i;
      }
    }
  } // Directions locks


  if (swiper.initialized && slideIndex !== activeIndex) {
    if (!swiper.allowSlideNext && translate < swiper.translate && translate < swiper.minTranslate()) {
      return false;
    }

    if (!swiper.allowSlidePrev && translate > swiper.translate && translate > swiper.maxTranslate()) {
      if ((activeIndex || 0) !== slideIndex) return false;
    }
  }

  if (slideIndex !== (previousIndex || 0) && runCallbacks) {
    swiper.emit('beforeSlideChangeStart');
  } // Update progress


  swiper.updateProgress(translate);
  let direction;
  if (slideIndex > activeIndex) direction = 'next';else if (slideIndex < activeIndex) direction = 'prev';else direction = 'reset'; // Update Index

  if (rtl && -translate === swiper.translate || !rtl && translate === swiper.translate) {
    swiper.updateActiveIndex(slideIndex); // Update Height

    if (params.autoHeight) {
      swiper.updateAutoHeight();
    }

    swiper.updateSlidesClasses();

    if (params.effect !== 'slide') {
      swiper.setTranslate(translate);
    }

    if (direction !== 'reset') {
      swiper.transitionStart(runCallbacks, direction);
      swiper.transitionEnd(runCallbacks, direction);
    }

    return false;
  }

  if (params.cssMode) {
    const isH = swiper.isHorizontal();
    const t = rtl ? translate : -translate;

    if (speed === 0) {
      const isVirtual = swiper.virtual && swiper.params.virtual.enabled;

      if (isVirtual) {
        swiper.wrapperEl.style.scrollSnapType = 'none';
        swiper._immediateVirtual = true;
      }

      wrapperEl[isH ? 'scrollLeft' : 'scrollTop'] = t;

      if (isVirtual) {
        requestAnimationFrame(() => {
          swiper.wrapperEl.style.scrollSnapType = '';
          swiper._swiperImmediateVirtual = false;
        });
      }
    } else {
      if (!swiper.support.smoothScroll) {
        animateCSSModeScroll({
          swiper,
          targetPosition: t,
          side: isH ? 'left' : 'top'
        });
        return true;
      }

      wrapperEl.scrollTo({
        [isH ? 'left' : 'top']: t,
        behavior: 'smooth'
      });
    }

    return true;
  }

  swiper.setTransition(speed);
  swiper.setTranslate(translate);
  swiper.updateActiveIndex(slideIndex);
  swiper.updateSlidesClasses();
  swiper.emit('beforeTransitionStart', speed, internal);
  swiper.transitionStart(runCallbacks, direction);

  if (speed === 0) {
    swiper.transitionEnd(runCallbacks, direction);
  } else if (!swiper.animating) {
    swiper.animating = true;

    if (!swiper.onSlideToWrapperTransitionEnd) {
      swiper.onSlideToWrapperTransitionEnd = function transitionEnd(e) {
        if (!swiper || swiper.destroyed) return;
        if (e.target !== this) return;
        swiper.$wrapperEl[0].removeEventListener('transitionend', swiper.onSlideToWrapperTransitionEnd);
        swiper.$wrapperEl[0].removeEventListener('webkitTransitionEnd', swiper.onSlideToWrapperTransitionEnd);
        swiper.onSlideToWrapperTransitionEnd = null;
        delete swiper.onSlideToWrapperTransitionEnd;
        swiper.transitionEnd(runCallbacks, direction);
      };
    }

    swiper.$wrapperEl[0].addEventListener('transitionend', swiper.onSlideToWrapperTransitionEnd);
    swiper.$wrapperEl[0].addEventListener('webkitTransitionEnd', swiper.onSlideToWrapperTransitionEnd);
  }

  return true;
}
;// CONCATENATED MODULE: ./node_modules/swiper/core/slide/slideToLoop.js
function slideToLoop(index = 0, speed = this.params.speed, runCallbacks = true, internal) {
  if (typeof index === 'string') {
    /**
     * The `index` argument converted from `string` to `number`.
     * @type {number}
     */
    const indexAsNumber = parseInt(index, 10);
    /**
     * Determines whether the `index` argument is a valid `number`
     * after being converted from the `string` type.
     * @type {boolean}
     */

    const isValidNumber = isFinite(indexAsNumber);

    if (!isValidNumber) {
      throw new Error(`The passed-in 'index' (string) couldn't be converted to 'number'. [${index}] given.`);
    } // Knowing that the converted `index` is a valid number,
    // we can update the original argument's value.


    index = indexAsNumber;
  }

  const swiper = this;
  let newIndex = index;

  if (swiper.params.loop) {
    newIndex += swiper.loopedSlides;
  }

  return swiper.slideTo(newIndex, speed, runCallbacks, internal);
}
;// CONCATENATED MODULE: ./node_modules/swiper/core/slide/slideNext.js
/* eslint no-unused-vars: "off" */
function slideNext(speed = this.params.speed, runCallbacks = true, internal) {
  const swiper = this;
  const {
    animating,
    enabled,
    params
  } = swiper;
  if (!enabled) return swiper;
  let perGroup = params.slidesPerGroup;

  if (params.slidesPerView === 'auto' && params.slidesPerGroup === 1 && params.slidesPerGroupAuto) {
    perGroup = Math.max(swiper.slidesPerViewDynamic('current', true), 1);
  }

  const increment = swiper.activeIndex < params.slidesPerGroupSkip ? 1 : perGroup;

  if (params.loop) {
    if (animating && params.loopPreventsSlide) return false;
    swiper.loopFix(); // eslint-disable-next-line

    swiper._clientLeft = swiper.$wrapperEl[0].clientLeft;
  }

  if (params.rewind && swiper.isEnd) {
    return swiper.slideTo(0, speed, runCallbacks, internal);
  }

  return swiper.slideTo(swiper.activeIndex + increment, speed, runCallbacks, internal);
}
;// CONCATENATED MODULE: ./node_modules/swiper/core/slide/slidePrev.js
/* eslint no-unused-vars: "off" */
function slidePrev(speed = this.params.speed, runCallbacks = true, internal) {
  const swiper = this;
  const {
    params,
    animating,
    snapGrid,
    slidesGrid,
    rtlTranslate,
    enabled
  } = swiper;
  if (!enabled) return swiper;

  if (params.loop) {
    if (animating && params.loopPreventsSlide) return false;
    swiper.loopFix(); // eslint-disable-next-line

    swiper._clientLeft = swiper.$wrapperEl[0].clientLeft;
  }

  const translate = rtlTranslate ? swiper.translate : -swiper.translate;

  function normalize(val) {
    if (val < 0) return -Math.floor(Math.abs(val));
    return Math.floor(val);
  }

  const normalizedTranslate = normalize(translate);
  const normalizedSnapGrid = snapGrid.map(val => normalize(val));
  let prevSnap = snapGrid[normalizedSnapGrid.indexOf(normalizedTranslate) - 1];

  if (typeof prevSnap === 'undefined' && params.cssMode) {
    let prevSnapIndex;
    snapGrid.forEach((snap, snapIndex) => {
      if (normalizedTranslate >= snap) {
        // prevSnap = snap;
        prevSnapIndex = snapIndex;
      }
    });

    if (typeof prevSnapIndex !== 'undefined') {
      prevSnap = snapGrid[prevSnapIndex > 0 ? prevSnapIndex - 1 : prevSnapIndex];
    }
  }

  let prevIndex = 0;

  if (typeof prevSnap !== 'undefined') {
    prevIndex = slidesGrid.indexOf(prevSnap);
    if (prevIndex < 0) prevIndex = swiper.activeIndex - 1;

    if (params.slidesPerView === 'auto' && params.slidesPerGroup === 1 && params.slidesPerGroupAuto) {
      prevIndex = prevIndex - swiper.slidesPerViewDynamic('previous', true) + 1;
      prevIndex = Math.max(prevIndex, 0);
    }
  }

  if (params.rewind && swiper.isBeginning) {
    const lastIndex = swiper.params.virtual && swiper.params.virtual.enabled && swiper.virtual ? swiper.virtual.slides.length - 1 : swiper.slides.length - 1;
    return swiper.slideTo(lastIndex, speed, runCallbacks, internal);
  }

  return swiper.slideTo(prevIndex, speed, runCallbacks, internal);
}
;// CONCATENATED MODULE: ./node_modules/swiper/core/slide/slideReset.js
/* eslint no-unused-vars: "off" */
function slideReset(speed = this.params.speed, runCallbacks = true, internal) {
  const swiper = this;
  return swiper.slideTo(swiper.activeIndex, speed, runCallbacks, internal);
}
;// CONCATENATED MODULE: ./node_modules/swiper/core/slide/slideToClosest.js
/* eslint no-unused-vars: "off" */
function slideToClosest(speed = this.params.speed, runCallbacks = true, internal, threshold = 0.5) {
  const swiper = this;
  let index = swiper.activeIndex;
  const skip = Math.min(swiper.params.slidesPerGroupSkip, index);
  const snapIndex = skip + Math.floor((index - skip) / swiper.params.slidesPerGroup);
  const translate = swiper.rtlTranslate ? swiper.translate : -swiper.translate;

  if (translate >= swiper.snapGrid[snapIndex]) {
    // The current translate is on or after the current snap index, so the choice
    // is between the current index and the one after it.
    const currentSnap = swiper.snapGrid[snapIndex];
    const nextSnap = swiper.snapGrid[snapIndex + 1];

    if (translate - currentSnap > (nextSnap - currentSnap) * threshold) {
      index += swiper.params.slidesPerGroup;
    }
  } else {
    // The current translate is before the current snap index, so the choice
    // is between the current index and the one before it.
    const prevSnap = swiper.snapGrid[snapIndex - 1];
    const currentSnap = swiper.snapGrid[snapIndex];

    if (translate - prevSnap <= (currentSnap - prevSnap) * threshold) {
      index -= swiper.params.slidesPerGroup;
    }
  }

  index = Math.max(index, 0);
  index = Math.min(index, swiper.slidesGrid.length - 1);
  return swiper.slideTo(index, speed, runCallbacks, internal);
}
;// CONCATENATED MODULE: ./node_modules/swiper/core/slide/slideToClickedSlide.js


function slideToClickedSlide() {
  const swiper = this;
  const {
    params,
    $wrapperEl
  } = swiper;
  const slidesPerView = params.slidesPerView === 'auto' ? swiper.slidesPerViewDynamic() : params.slidesPerView;
  let slideToIndex = swiper.clickedIndex;
  let realIndex;

  if (params.loop) {
    if (swiper.animating) return;
    realIndex = parseInt(dom(swiper.clickedSlide).attr('data-swiper-slide-index'), 10);

    if (params.centeredSlides) {
      if (slideToIndex < swiper.loopedSlides - slidesPerView / 2 || slideToIndex > swiper.slides.length - swiper.loopedSlides + slidesPerView / 2) {
        swiper.loopFix();
        slideToIndex = $wrapperEl.children(`.${params.slideClass}[data-swiper-slide-index="${realIndex}"]:not(.${params.slideDuplicateClass})`).eq(0).index();
        utils_nextTick(() => {
          swiper.slideTo(slideToIndex);
        });
      } else {
        swiper.slideTo(slideToIndex);
      }
    } else if (slideToIndex > swiper.slides.length - slidesPerView) {
      swiper.loopFix();
      slideToIndex = $wrapperEl.children(`.${params.slideClass}[data-swiper-slide-index="${realIndex}"]:not(.${params.slideDuplicateClass})`).eq(0).index();
      utils_nextTick(() => {
        swiper.slideTo(slideToIndex);
      });
    } else {
      swiper.slideTo(slideToIndex);
    }
  } else {
    swiper.slideTo(slideToIndex);
  }
}
;// CONCATENATED MODULE: ./node_modules/swiper/core/slide/index.js







/* harmony default export */ var slide = ({
  slideTo: slideTo,
  slideToLoop: slideToLoop,
  slideNext: slideNext,
  slidePrev: slidePrev,
  slideReset: slideReset,
  slideToClosest: slideToClosest,
  slideToClickedSlide: slideToClickedSlide
});
;// CONCATENATED MODULE: ./node_modules/swiper/core/loop/loopCreate.js


function loopCreate() {
  const swiper = this;
  const document = ssr_window_esm_getDocument();
  const {
    params,
    $wrapperEl
  } = swiper; // Remove duplicated slides

  const $selector = $wrapperEl.children().length > 0 ? dom($wrapperEl.children()[0].parentNode) : $wrapperEl;
  $selector.children(`.${params.slideClass}.${params.slideDuplicateClass}`).remove();
  let slides = $selector.children(`.${params.slideClass}`);

  if (params.loopFillGroupWithBlank) {
    const blankSlidesNum = params.slidesPerGroup - slides.length % params.slidesPerGroup;

    if (blankSlidesNum !== params.slidesPerGroup) {
      for (let i = 0; i < blankSlidesNum; i += 1) {
        const blankNode = dom(document.createElement('div')).addClass(`${params.slideClass} ${params.slideBlankClass}`);
        $selector.append(blankNode);
      }

      slides = $selector.children(`.${params.slideClass}`);
    }
  }

  if (params.slidesPerView === 'auto' && !params.loopedSlides) params.loopedSlides = slides.length;
  swiper.loopedSlides = Math.ceil(parseFloat(params.loopedSlides || params.slidesPerView, 10));
  swiper.loopedSlides += params.loopAdditionalSlides;

  if (swiper.loopedSlides > slides.length && swiper.params.loopedSlidesLimit) {
    swiper.loopedSlides = slides.length;
  }

  const prependSlides = [];
  const appendSlides = [];
  slides.each((el, index) => {
    const slide = dom(el);
    slide.attr('data-swiper-slide-index', index);
  });

  for (let i = 0; i < swiper.loopedSlides; i += 1) {
    const index = i - Math.floor(i / slides.length) * slides.length;
    appendSlides.push(slides.eq(index)[0]);
    prependSlides.unshift(slides.eq(slides.length - index - 1)[0]);
  }

  for (let i = 0; i < appendSlides.length; i += 1) {
    $selector.append(dom(appendSlides[i].cloneNode(true)).addClass(params.slideDuplicateClass));
  }

  for (let i = prependSlides.length - 1; i >= 0; i -= 1) {
    $selector.prepend(dom(prependSlides[i].cloneNode(true)).addClass(params.slideDuplicateClass));
  }
}
;// CONCATENATED MODULE: ./node_modules/swiper/core/loop/loopFix.js
function loopFix() {
  const swiper = this;
  swiper.emit('beforeLoopFix');
  const {
    activeIndex,
    slides,
    loopedSlides,
    allowSlidePrev,
    allowSlideNext,
    snapGrid,
    rtlTranslate: rtl
  } = swiper;
  let newIndex;
  swiper.allowSlidePrev = true;
  swiper.allowSlideNext = true;
  const snapTranslate = -snapGrid[activeIndex];
  const diff = snapTranslate - swiper.getTranslate(); // Fix For Negative Oversliding

  if (activeIndex < loopedSlides) {
    newIndex = slides.length - loopedSlides * 3 + activeIndex;
    newIndex += loopedSlides;
    const slideChanged = swiper.slideTo(newIndex, 0, false, true);

    if (slideChanged && diff !== 0) {
      swiper.setTranslate((rtl ? -swiper.translate : swiper.translate) - diff);
    }
  } else if (activeIndex >= slides.length - loopedSlides) {
    // Fix For Positive Oversliding
    newIndex = -slides.length + activeIndex + loopedSlides;
    newIndex += loopedSlides;
    const slideChanged = swiper.slideTo(newIndex, 0, false, true);

    if (slideChanged && diff !== 0) {
      swiper.setTranslate((rtl ? -swiper.translate : swiper.translate) - diff);
    }
  }

  swiper.allowSlidePrev = allowSlidePrev;
  swiper.allowSlideNext = allowSlideNext;
  swiper.emit('loopFix');
}
;// CONCATENATED MODULE: ./node_modules/swiper/core/loop/loopDestroy.js
function loopDestroy() {
  const swiper = this;
  const {
    $wrapperEl,
    params,
    slides
  } = swiper;
  $wrapperEl.children(`.${params.slideClass}.${params.slideDuplicateClass},.${params.slideClass}.${params.slideBlankClass}`).remove();
  slides.removeAttr('data-swiper-slide-index');
}
;// CONCATENATED MODULE: ./node_modules/swiper/core/loop/index.js



/* harmony default export */ var loop = ({
  loopCreate: loopCreate,
  loopFix: loopFix,
  loopDestroy: loopDestroy
});
;// CONCATENATED MODULE: ./node_modules/swiper/core/grab-cursor/setGrabCursor.js
function setGrabCursor(moving) {
  const swiper = this;
  if (swiper.support.touch || !swiper.params.simulateTouch || swiper.params.watchOverflow && swiper.isLocked || swiper.params.cssMode) return;
  const el = swiper.params.touchEventsTarget === 'container' ? swiper.el : swiper.wrapperEl;
  el.style.cursor = 'move';
  el.style.cursor = moving ? 'grabbing' : 'grab';
}
;// CONCATENATED MODULE: ./node_modules/swiper/core/grab-cursor/unsetGrabCursor.js
function unsetGrabCursor() {
  const swiper = this;

  if (swiper.support.touch || swiper.params.watchOverflow && swiper.isLocked || swiper.params.cssMode) {
    return;
  }

  swiper[swiper.params.touchEventsTarget === 'container' ? 'el' : 'wrapperEl'].style.cursor = '';
}
;// CONCATENATED MODULE: ./node_modules/swiper/core/grab-cursor/index.js


/* harmony default export */ var grab_cursor = ({
  setGrabCursor: setGrabCursor,
  unsetGrabCursor: unsetGrabCursor
});
;// CONCATENATED MODULE: ./node_modules/swiper/core/events/onTouchStart.js


 // Modified from https://stackoverflow.com/questions/54520554/custom-element-getrootnode-closest-function-crossing-multiple-parent-shadowd

function closestElement(selector, base = this) {
  function __closestFrom(el) {
    if (!el || el === ssr_window_esm_getDocument() || el === ssr_window_esm_getWindow()) return null;
    if (el.assignedSlot) el = el.assignedSlot;
    const found = el.closest(selector);

    if (!found && !el.getRootNode) {
      return null;
    }

    return found || __closestFrom(el.getRootNode().host);
  }

  return __closestFrom(base);
}

function onTouchStart(event) {
  const swiper = this;
  const document = ssr_window_esm_getDocument();
  const window = ssr_window_esm_getWindow();
  const data = swiper.touchEventsData;
  const {
    params,
    touches,
    enabled
  } = swiper;
  if (!enabled) return;

  if (swiper.animating && params.preventInteractionOnTransition) {
    return;
  }

  if (!swiper.animating && params.cssMode && params.loop) {
    swiper.loopFix();
  }

  let e = event;
  if (e.originalEvent) e = e.originalEvent;
  let $targetEl = dom(e.target);

  if (params.touchEventsTarget === 'wrapper') {
    if (!$targetEl.closest(swiper.wrapperEl).length) return;
  }

  data.isTouchEvent = e.type === 'touchstart';
  if (!data.isTouchEvent && 'which' in e && e.which === 3) return;
  if (!data.isTouchEvent && 'button' in e && e.button > 0) return;
  if (data.isTouched && data.isMoved) return; // change target el for shadow root component

  const swipingClassHasValue = !!params.noSwipingClass && params.noSwipingClass !== ''; // eslint-disable-next-line

  const eventPath = event.composedPath ? event.composedPath() : event.path;

  if (swipingClassHasValue && e.target && e.target.shadowRoot && eventPath) {
    $targetEl = dom(eventPath[0]);
  }

  const noSwipingSelector = params.noSwipingSelector ? params.noSwipingSelector : `.${params.noSwipingClass}`;
  const isTargetShadow = !!(e.target && e.target.shadowRoot); // use closestElement for shadow root element to get the actual closest for nested shadow root element

  if (params.noSwiping && (isTargetShadow ? closestElement(noSwipingSelector, $targetEl[0]) : $targetEl.closest(noSwipingSelector)[0])) {
    swiper.allowClick = true;
    return;
  }

  if (params.swipeHandler) {
    if (!$targetEl.closest(params.swipeHandler)[0]) return;
  }

  touches.currentX = e.type === 'touchstart' ? e.targetTouches[0].pageX : e.pageX;
  touches.currentY = e.type === 'touchstart' ? e.targetTouches[0].pageY : e.pageY;
  const startX = touches.currentX;
  const startY = touches.currentY; // Do NOT start if iOS edge swipe is detected. Otherwise iOS app cannot swipe-to-go-back anymore

  const edgeSwipeDetection = params.edgeSwipeDetection || params.iOSEdgeSwipeDetection;
  const edgeSwipeThreshold = params.edgeSwipeThreshold || params.iOSEdgeSwipeThreshold;

  if (edgeSwipeDetection && (startX <= edgeSwipeThreshold || startX >= window.innerWidth - edgeSwipeThreshold)) {
    if (edgeSwipeDetection === 'prevent') {
      event.preventDefault();
    } else {
      return;
    }
  }

  Object.assign(data, {
    isTouched: true,
    isMoved: false,
    allowTouchCallbacks: true,
    isScrolling: undefined,
    startMoving: undefined
  });
  touches.startX = startX;
  touches.startY = startY;
  data.touchStartTime = utils_now();
  swiper.allowClick = true;
  swiper.updateSize();
  swiper.swipeDirection = undefined;
  if (params.threshold > 0) data.allowThresholdMove = false;

  if (e.type !== 'touchstart') {
    let preventDefault = true;

    if ($targetEl.is(data.focusableElements)) {
      preventDefault = false;

      if ($targetEl[0].nodeName === 'SELECT') {
        data.isTouched = false;
      }
    }

    if (document.activeElement && dom(document.activeElement).is(data.focusableElements) && document.activeElement !== $targetEl[0]) {
      document.activeElement.blur();
    }

    const shouldPreventDefault = preventDefault && swiper.allowTouchMove && params.touchStartPreventDefault;

    if ((params.touchStartForcePreventDefault || shouldPreventDefault) && !$targetEl[0].isContentEditable) {
      e.preventDefault();
    }
  }

  if (swiper.params.freeMode && swiper.params.freeMode.enabled && swiper.freeMode && swiper.animating && !params.cssMode) {
    swiper.freeMode.onTouchStart();
  }

  swiper.emit('touchStart', e);
}
;// CONCATENATED MODULE: ./node_modules/swiper/core/events/onTouchMove.js



function onTouchMove(event) {
  const document = ssr_window_esm_getDocument();
  const swiper = this;
  const data = swiper.touchEventsData;
  const {
    params,
    touches,
    rtlTranslate: rtl,
    enabled
  } = swiper;
  if (!enabled) return;
  let e = event;
  if (e.originalEvent) e = e.originalEvent;

  if (!data.isTouched) {
    if (data.startMoving && data.isScrolling) {
      swiper.emit('touchMoveOpposite', e);
    }

    return;
  }

  if (data.isTouchEvent && e.type !== 'touchmove') return;
  const targetTouch = e.type === 'touchmove' && e.targetTouches && (e.targetTouches[0] || e.changedTouches[0]);
  const pageX = e.type === 'touchmove' ? targetTouch.pageX : e.pageX;
  const pageY = e.type === 'touchmove' ? targetTouch.pageY : e.pageY;

  if (e.preventedByNestedSwiper) {
    touches.startX = pageX;
    touches.startY = pageY;
    return;
  }

  if (!swiper.allowTouchMove) {
    if (!dom(e.target).is(data.focusableElements)) {
      swiper.allowClick = false;
    }

    if (data.isTouched) {
      Object.assign(touches, {
        startX: pageX,
        startY: pageY,
        currentX: pageX,
        currentY: pageY
      });
      data.touchStartTime = utils_now();
    }

    return;
  }

  if (data.isTouchEvent && params.touchReleaseOnEdges && !params.loop) {
    if (swiper.isVertical()) {
      // Vertical
      if (pageY < touches.startY && swiper.translate <= swiper.maxTranslate() || pageY > touches.startY && swiper.translate >= swiper.minTranslate()) {
        data.isTouched = false;
        data.isMoved = false;
        return;
      }
    } else if (pageX < touches.startX && swiper.translate <= swiper.maxTranslate() || pageX > touches.startX && swiper.translate >= swiper.minTranslate()) {
      return;
    }
  }

  if (data.isTouchEvent && document.activeElement) {
    if (e.target === document.activeElement && dom(e.target).is(data.focusableElements)) {
      data.isMoved = true;
      swiper.allowClick = false;
      return;
    }
  }

  if (data.allowTouchCallbacks) {
    swiper.emit('touchMove', e);
  }

  if (e.targetTouches && e.targetTouches.length > 1) return;
  touches.currentX = pageX;
  touches.currentY = pageY;
  const diffX = touches.currentX - touches.startX;
  const diffY = touches.currentY - touches.startY;
  if (swiper.params.threshold && Math.sqrt(diffX ** 2 + diffY ** 2) < swiper.params.threshold) return;

  if (typeof data.isScrolling === 'undefined') {
    let touchAngle;

    if (swiper.isHorizontal() && touches.currentY === touches.startY || swiper.isVertical() && touches.currentX === touches.startX) {
      data.isScrolling = false;
    } else {
      // eslint-disable-next-line
      if (diffX * diffX + diffY * diffY >= 25) {
        touchAngle = Math.atan2(Math.abs(diffY), Math.abs(diffX)) * 180 / Math.PI;
        data.isScrolling = swiper.isHorizontal() ? touchAngle > params.touchAngle : 90 - touchAngle > params.touchAngle;
      }
    }
  }

  if (data.isScrolling) {
    swiper.emit('touchMoveOpposite', e);
  }

  if (typeof data.startMoving === 'undefined') {
    if (touches.currentX !== touches.startX || touches.currentY !== touches.startY) {
      data.startMoving = true;
    }
  }

  if (data.isScrolling) {
    data.isTouched = false;
    return;
  }

  if (!data.startMoving) {
    return;
  }

  swiper.allowClick = false;

  if (!params.cssMode && e.cancelable) {
    e.preventDefault();
  }

  if (params.touchMoveStopPropagation && !params.nested) {
    e.stopPropagation();
  }

  if (!data.isMoved) {
    if (params.loop && !params.cssMode) {
      swiper.loopFix();
    }

    data.startTranslate = swiper.getTranslate();
    swiper.setTransition(0);

    if (swiper.animating) {
      swiper.$wrapperEl.trigger('webkitTransitionEnd transitionend');
    }

    data.allowMomentumBounce = false; // Grab Cursor

    if (params.grabCursor && (swiper.allowSlideNext === true || swiper.allowSlidePrev === true)) {
      swiper.setGrabCursor(true);
    }

    swiper.emit('sliderFirstMove', e);
  }

  swiper.emit('sliderMove', e);
  data.isMoved = true;
  let diff = swiper.isHorizontal() ? diffX : diffY;
  touches.diff = diff;
  diff *= params.touchRatio;
  if (rtl) diff = -diff;
  swiper.swipeDirection = diff > 0 ? 'prev' : 'next';
  data.currentTranslate = diff + data.startTranslate;
  let disableParentSwiper = true;
  let resistanceRatio = params.resistanceRatio;

  if (params.touchReleaseOnEdges) {
    resistanceRatio = 0;
  }

  if (diff > 0 && data.currentTranslate > swiper.minTranslate()) {
    disableParentSwiper = false;
    if (params.resistance) data.currentTranslate = swiper.minTranslate() - 1 + (-swiper.minTranslate() + data.startTranslate + diff) ** resistanceRatio;
  } else if (diff < 0 && data.currentTranslate < swiper.maxTranslate()) {
    disableParentSwiper = false;
    if (params.resistance) data.currentTranslate = swiper.maxTranslate() + 1 - (swiper.maxTranslate() - data.startTranslate - diff) ** resistanceRatio;
  }

  if (disableParentSwiper) {
    e.preventedByNestedSwiper = true;
  } // Directions locks


  if (!swiper.allowSlideNext && swiper.swipeDirection === 'next' && data.currentTranslate < data.startTranslate) {
    data.currentTranslate = data.startTranslate;
  }

  if (!swiper.allowSlidePrev && swiper.swipeDirection === 'prev' && data.currentTranslate > data.startTranslate) {
    data.currentTranslate = data.startTranslate;
  }

  if (!swiper.allowSlidePrev && !swiper.allowSlideNext) {
    data.currentTranslate = data.startTranslate;
  } // Threshold


  if (params.threshold > 0) {
    if (Math.abs(diff) > params.threshold || data.allowThresholdMove) {
      if (!data.allowThresholdMove) {
        data.allowThresholdMove = true;
        touches.startX = touches.currentX;
        touches.startY = touches.currentY;
        data.currentTranslate = data.startTranslate;
        touches.diff = swiper.isHorizontal() ? touches.currentX - touches.startX : touches.currentY - touches.startY;
        return;
      }
    } else {
      data.currentTranslate = data.startTranslate;
      return;
    }
  }

  if (!params.followFinger || params.cssMode) return; // Update active index in free mode

  if (params.freeMode && params.freeMode.enabled && swiper.freeMode || params.watchSlidesProgress) {
    swiper.updateActiveIndex();
    swiper.updateSlidesClasses();
  }

  if (swiper.params.freeMode && params.freeMode.enabled && swiper.freeMode) {
    swiper.freeMode.onTouchMove();
  } // Update progress


  swiper.updateProgress(data.currentTranslate); // Update translate

  swiper.setTranslate(data.currentTranslate);
}
;// CONCATENATED MODULE: ./node_modules/swiper/core/events/onTouchEnd.js

function onTouchEnd(event) {
  const swiper = this;
  const data = swiper.touchEventsData;
  const {
    params,
    touches,
    rtlTranslate: rtl,
    slidesGrid,
    enabled
  } = swiper;
  if (!enabled) return;
  let e = event;
  if (e.originalEvent) e = e.originalEvent;

  if (data.allowTouchCallbacks) {
    swiper.emit('touchEnd', e);
  }

  data.allowTouchCallbacks = false;

  if (!data.isTouched) {
    if (data.isMoved && params.grabCursor) {
      swiper.setGrabCursor(false);
    }

    data.isMoved = false;
    data.startMoving = false;
    return;
  } // Return Grab Cursor


  if (params.grabCursor && data.isMoved && data.isTouched && (swiper.allowSlideNext === true || swiper.allowSlidePrev === true)) {
    swiper.setGrabCursor(false);
  } // Time diff


  const touchEndTime = utils_now();
  const timeDiff = touchEndTime - data.touchStartTime; // Tap, doubleTap, Click

  if (swiper.allowClick) {
    const pathTree = e.path || e.composedPath && e.composedPath();
    swiper.updateClickedSlide(pathTree && pathTree[0] || e.target);
    swiper.emit('tap click', e);

    if (timeDiff < 300 && touchEndTime - data.lastClickTime < 300) {
      swiper.emit('doubleTap doubleClick', e);
    }
  }

  data.lastClickTime = utils_now();
  utils_nextTick(() => {
    if (!swiper.destroyed) swiper.allowClick = true;
  });

  if (!data.isTouched || !data.isMoved || !swiper.swipeDirection || touches.diff === 0 || data.currentTranslate === data.startTranslate) {
    data.isTouched = false;
    data.isMoved = false;
    data.startMoving = false;
    return;
  }

  data.isTouched = false;
  data.isMoved = false;
  data.startMoving = false;
  let currentPos;

  if (params.followFinger) {
    currentPos = rtl ? swiper.translate : -swiper.translate;
  } else {
    currentPos = -data.currentTranslate;
  }

  if (params.cssMode) {
    return;
  }

  if (swiper.params.freeMode && params.freeMode.enabled) {
    swiper.freeMode.onTouchEnd({
      currentPos
    });
    return;
  } // Find current slide


  let stopIndex = 0;
  let groupSize = swiper.slidesSizesGrid[0];

  for (let i = 0; i < slidesGrid.length; i += i < params.slidesPerGroupSkip ? 1 : params.slidesPerGroup) {
    const increment = i < params.slidesPerGroupSkip - 1 ? 1 : params.slidesPerGroup;

    if (typeof slidesGrid[i + increment] !== 'undefined') {
      if (currentPos >= slidesGrid[i] && currentPos < slidesGrid[i + increment]) {
        stopIndex = i;
        groupSize = slidesGrid[i + increment] - slidesGrid[i];
      }
    } else if (currentPos >= slidesGrid[i]) {
      stopIndex = i;
      groupSize = slidesGrid[slidesGrid.length - 1] - slidesGrid[slidesGrid.length - 2];
    }
  }

  let rewindFirstIndex = null;
  let rewindLastIndex = null;

  if (params.rewind) {
    if (swiper.isBeginning) {
      rewindLastIndex = swiper.params.virtual && swiper.params.virtual.enabled && swiper.virtual ? swiper.virtual.slides.length - 1 : swiper.slides.length - 1;
    } else if (swiper.isEnd) {
      rewindFirstIndex = 0;
    }
  } // Find current slide size


  const ratio = (currentPos - slidesGrid[stopIndex]) / groupSize;
  const increment = stopIndex < params.slidesPerGroupSkip - 1 ? 1 : params.slidesPerGroup;

  if (timeDiff > params.longSwipesMs) {
    // Long touches
    if (!params.longSwipes) {
      swiper.slideTo(swiper.activeIndex);
      return;
    }

    if (swiper.swipeDirection === 'next') {
      if (ratio >= params.longSwipesRatio) swiper.slideTo(params.rewind && swiper.isEnd ? rewindFirstIndex : stopIndex + increment);else swiper.slideTo(stopIndex);
    }

    if (swiper.swipeDirection === 'prev') {
      if (ratio > 1 - params.longSwipesRatio) {
        swiper.slideTo(stopIndex + increment);
      } else if (rewindLastIndex !== null && ratio < 0 && Math.abs(ratio) > params.longSwipesRatio) {
        swiper.slideTo(rewindLastIndex);
      } else {
        swiper.slideTo(stopIndex);
      }
    }
  } else {
    // Short swipes
    if (!params.shortSwipes) {
      swiper.slideTo(swiper.activeIndex);
      return;
    }

    const isNavButtonTarget = swiper.navigation && (e.target === swiper.navigation.nextEl || e.target === swiper.navigation.prevEl);

    if (!isNavButtonTarget) {
      if (swiper.swipeDirection === 'next') {
        swiper.slideTo(rewindFirstIndex !== null ? rewindFirstIndex : stopIndex + increment);
      }

      if (swiper.swipeDirection === 'prev') {
        swiper.slideTo(rewindLastIndex !== null ? rewindLastIndex : stopIndex);
      }
    } else if (e.target === swiper.navigation.nextEl) {
      swiper.slideTo(stopIndex + increment);
    } else {
      swiper.slideTo(stopIndex);
    }
  }
}
;// CONCATENATED MODULE: ./node_modules/swiper/core/events/onResize.js
function onResize() {
  const swiper = this;
  const {
    params,
    el
  } = swiper;
  if (el && el.offsetWidth === 0) return; // Breakpoints

  if (params.breakpoints) {
    swiper.setBreakpoint();
  } // Save locks


  const {
    allowSlideNext,
    allowSlidePrev,
    snapGrid
  } = swiper; // Disable locks on resize

  swiper.allowSlideNext = true;
  swiper.allowSlidePrev = true;
  swiper.updateSize();
  swiper.updateSlides();
  swiper.updateSlidesClasses();

  if ((params.slidesPerView === 'auto' || params.slidesPerView > 1) && swiper.isEnd && !swiper.isBeginning && !swiper.params.centeredSlides) {
    swiper.slideTo(swiper.slides.length - 1, 0, false, true);
  } else {
    swiper.slideTo(swiper.activeIndex, 0, false, true);
  }

  if (swiper.autoplay && swiper.autoplay.running && swiper.autoplay.paused) {
    swiper.autoplay.run();
  } // Return locks after resize


  swiper.allowSlidePrev = allowSlidePrev;
  swiper.allowSlideNext = allowSlideNext;

  if (swiper.params.watchOverflow && snapGrid !== swiper.snapGrid) {
    swiper.checkOverflow();
  }
}
;// CONCATENATED MODULE: ./node_modules/swiper/core/events/onClick.js
function onClick(e) {
  const swiper = this;
  if (!swiper.enabled) return;

  if (!swiper.allowClick) {
    if (swiper.params.preventClicks) e.preventDefault();

    if (swiper.params.preventClicksPropagation && swiper.animating) {
      e.stopPropagation();
      e.stopImmediatePropagation();
    }
  }
}
;// CONCATENATED MODULE: ./node_modules/swiper/core/events/onScroll.js
function onScroll() {
  const swiper = this;
  const {
    wrapperEl,
    rtlTranslate,
    enabled
  } = swiper;
  if (!enabled) return;
  swiper.previousTranslate = swiper.translate;

  if (swiper.isHorizontal()) {
    swiper.translate = -wrapperEl.scrollLeft;
  } else {
    swiper.translate = -wrapperEl.scrollTop;
  } // eslint-disable-next-line


  if (swiper.translate === 0) swiper.translate = 0;
  swiper.updateActiveIndex();
  swiper.updateSlidesClasses();
  let newProgress;
  const translatesDiff = swiper.maxTranslate() - swiper.minTranslate();

  if (translatesDiff === 0) {
    newProgress = 0;
  } else {
    newProgress = (swiper.translate - swiper.minTranslate()) / translatesDiff;
  }

  if (newProgress !== swiper.progress) {
    swiper.updateProgress(rtlTranslate ? -swiper.translate : swiper.translate);
  }

  swiper.emit('setTranslate', swiper.translate, false);
}
;// CONCATENATED MODULE: ./node_modules/swiper/core/events/index.js







let dummyEventAttached = false;

function dummyEventListener() {}

const events = (swiper, method) => {
  const document = ssr_window_esm_getDocument();
  const {
    params,
    touchEvents,
    el,
    wrapperEl,
    device,
    support
  } = swiper;
  const capture = !!params.nested;
  const domMethod = method === 'on' ? 'addEventListener' : 'removeEventListener';
  const swiperMethod = method; // Touch Events

  if (!support.touch) {
    el[domMethod](touchEvents.start, swiper.onTouchStart, false);
    document[domMethod](touchEvents.move, swiper.onTouchMove, capture);
    document[domMethod](touchEvents.end, swiper.onTouchEnd, false);
  } else {
    const passiveListener = touchEvents.start === 'touchstart' && support.passiveListener && params.passiveListeners ? {
      passive: true,
      capture: false
    } : false;
    el[domMethod](touchEvents.start, swiper.onTouchStart, passiveListener);
    el[domMethod](touchEvents.move, swiper.onTouchMove, support.passiveListener ? {
      passive: false,
      capture
    } : capture);
    el[domMethod](touchEvents.end, swiper.onTouchEnd, passiveListener);

    if (touchEvents.cancel) {
      el[domMethod](touchEvents.cancel, swiper.onTouchEnd, passiveListener);
    }
  } // Prevent Links Clicks


  if (params.preventClicks || params.preventClicksPropagation) {
    el[domMethod]('click', swiper.onClick, true);
  }

  if (params.cssMode) {
    wrapperEl[domMethod]('scroll', swiper.onScroll);
  } // Resize handler


  if (params.updateOnWindowResize) {
    swiper[swiperMethod](device.ios || device.android ? 'resize orientationchange observerUpdate' : 'resize observerUpdate', onResize, true);
  } else {
    swiper[swiperMethod]('observerUpdate', onResize, true);
  }
};

function attachEvents() {
  const swiper = this;
  const document = ssr_window_esm_getDocument();
  const {
    params,
    support
  } = swiper;
  swiper.onTouchStart = onTouchStart.bind(swiper);
  swiper.onTouchMove = onTouchMove.bind(swiper);
  swiper.onTouchEnd = onTouchEnd.bind(swiper);

  if (params.cssMode) {
    swiper.onScroll = onScroll.bind(swiper);
  }

  swiper.onClick = onClick.bind(swiper);

  if (support.touch && !dummyEventAttached) {
    document.addEventListener('touchstart', dummyEventListener);
    dummyEventAttached = true;
  }

  events(swiper, 'on');
}

function detachEvents() {
  const swiper = this;
  events(swiper, 'off');
}

/* harmony default export */ var core_events = ({
  attachEvents,
  detachEvents
});
;// CONCATENATED MODULE: ./node_modules/swiper/core/breakpoints/setBreakpoint.js


const isGridEnabled = (swiper, params) => {
  return swiper.grid && params.grid && params.grid.rows > 1;
};

function setBreakpoint() {
  const swiper = this;
  const {
    activeIndex,
    initialized,
    loopedSlides = 0,
    params,
    $el
  } = swiper;
  const breakpoints = params.breakpoints;
  if (!breakpoints || breakpoints && Object.keys(breakpoints).length === 0) return; // Get breakpoint for window width and update parameters

  const breakpoint = swiper.getBreakpoint(breakpoints, swiper.params.breakpointsBase, swiper.el);
  if (!breakpoint || swiper.currentBreakpoint === breakpoint) return;
  const breakpointOnlyParams = breakpoint in breakpoints ? breakpoints[breakpoint] : undefined;
  const breakpointParams = breakpointOnlyParams || swiper.originalParams;
  const wasMultiRow = isGridEnabled(swiper, params);
  const isMultiRow = isGridEnabled(swiper, breakpointParams);
  const wasEnabled = params.enabled;

  if (wasMultiRow && !isMultiRow) {
    $el.removeClass(`${params.containerModifierClass}grid ${params.containerModifierClass}grid-column`);
    swiper.emitContainerClasses();
  } else if (!wasMultiRow && isMultiRow) {
    $el.addClass(`${params.containerModifierClass}grid`);

    if (breakpointParams.grid.fill && breakpointParams.grid.fill === 'column' || !breakpointParams.grid.fill && params.grid.fill === 'column') {
      $el.addClass(`${params.containerModifierClass}grid-column`);
    }

    swiper.emitContainerClasses();
  } // Toggle navigation, pagination, scrollbar


  ['navigation', 'pagination', 'scrollbar'].forEach(prop => {
    const wasModuleEnabled = params[prop] && params[prop].enabled;
    const isModuleEnabled = breakpointParams[prop] && breakpointParams[prop].enabled;

    if (wasModuleEnabled && !isModuleEnabled) {
      swiper[prop].disable();
    }

    if (!wasModuleEnabled && isModuleEnabled) {
      swiper[prop].enable();
    }
  });
  const directionChanged = breakpointParams.direction && breakpointParams.direction !== params.direction;
  const needsReLoop = params.loop && (breakpointParams.slidesPerView !== params.slidesPerView || directionChanged);

  if (directionChanged && initialized) {
    swiper.changeDirection();
  }

  utils_extend(swiper.params, breakpointParams);
  const isEnabled = swiper.params.enabled;
  Object.assign(swiper, {
    allowTouchMove: swiper.params.allowTouchMove,
    allowSlideNext: swiper.params.allowSlideNext,
    allowSlidePrev: swiper.params.allowSlidePrev
  });

  if (wasEnabled && !isEnabled) {
    swiper.disable();
  } else if (!wasEnabled && isEnabled) {
    swiper.enable();
  }

  swiper.currentBreakpoint = breakpoint;
  swiper.emit('_beforeBreakpoint', breakpointParams);

  if (needsReLoop && initialized) {
    swiper.loopDestroy();
    swiper.loopCreate();
    swiper.updateSlides();
    swiper.slideTo(activeIndex - loopedSlides + swiper.loopedSlides, 0, false);
  }

  swiper.emit('breakpoint', breakpointParams);
}
;// CONCATENATED MODULE: ./node_modules/swiper/core/breakpoints/getBreakpoint.js

function getBreakpoint(breakpoints, base = 'window', containerEl) {
  if (!breakpoints || base === 'container' && !containerEl) return undefined;
  let breakpoint = false;
  const window = ssr_window_esm_getWindow();
  const currentHeight = base === 'window' ? window.innerHeight : containerEl.clientHeight;
  const points = Object.keys(breakpoints).map(point => {
    if (typeof point === 'string' && point.indexOf('@') === 0) {
      const minRatio = parseFloat(point.substr(1));
      const value = currentHeight * minRatio;
      return {
        value,
        point
      };
    }

    return {
      value: point,
      point
    };
  });
  points.sort((a, b) => parseInt(a.value, 10) - parseInt(b.value, 10));

  for (let i = 0; i < points.length; i += 1) {
    const {
      point,
      value
    } = points[i];

    if (base === 'window') {
      if (window.matchMedia(`(min-width: ${value}px)`).matches) {
        breakpoint = point;
      }
    } else if (value <= containerEl.clientWidth) {
      breakpoint = point;
    }
  }

  return breakpoint || 'max';
}
;// CONCATENATED MODULE: ./node_modules/swiper/core/breakpoints/index.js


/* harmony default export */ var breakpoints = ({
  setBreakpoint: setBreakpoint,
  getBreakpoint: getBreakpoint
});
;// CONCATENATED MODULE: ./node_modules/swiper/core/classes/addClasses.js
function prepareClasses(entries, prefix) {
  const resultClasses = [];
  entries.forEach(item => {
    if (typeof item === 'object') {
      Object.keys(item).forEach(classNames => {
        if (item[classNames]) {
          resultClasses.push(prefix + classNames);
        }
      });
    } else if (typeof item === 'string') {
      resultClasses.push(prefix + item);
    }
  });
  return resultClasses;
}

function addClasses() {
  const swiper = this;
  const {
    classNames,
    params,
    rtl,
    $el,
    device,
    support
  } = swiper; // prettier-ignore

  const suffixes = prepareClasses(['initialized', params.direction, {
    'pointer-events': !support.touch
  }, {
    'free-mode': swiper.params.freeMode && params.freeMode.enabled
  }, {
    'autoheight': params.autoHeight
  }, {
    'rtl': rtl
  }, {
    'grid': params.grid && params.grid.rows > 1
  }, {
    'grid-column': params.grid && params.grid.rows > 1 && params.grid.fill === 'column'
  }, {
    'android': device.android
  }, {
    'ios': device.ios
  }, {
    'css-mode': params.cssMode
  }, {
    'centered': params.cssMode && params.centeredSlides
  }, {
    'watch-progress': params.watchSlidesProgress
  }], params.containerModifierClass);
  classNames.push(...suffixes);
  $el.addClass([...classNames].join(' '));
  swiper.emitContainerClasses();
}
;// CONCATENATED MODULE: ./node_modules/swiper/core/classes/removeClasses.js
function removeClasses() {
  const swiper = this;
  const {
    $el,
    classNames
  } = swiper;
  $el.removeClass(classNames.join(' '));
  swiper.emitContainerClasses();
}
;// CONCATENATED MODULE: ./node_modules/swiper/core/classes/index.js


/* harmony default export */ var classes = ({
  addClasses: addClasses,
  removeClasses: removeClasses
});
;// CONCATENATED MODULE: ./node_modules/swiper/core/images/loadImage.js


function loadImage(imageEl, src, srcset, sizes, checkForComplete, callback) {
  const window = ssr_window_esm_getWindow();
  let image;

  function onReady() {
    if (callback) callback();
  }

  const isPicture = dom(imageEl).parent('picture')[0];

  if (!isPicture && (!imageEl.complete || !checkForComplete)) {
    if (src) {
      image = new window.Image();
      image.onload = onReady;
      image.onerror = onReady;

      if (sizes) {
        image.sizes = sizes;
      }

      if (srcset) {
        image.srcset = srcset;
      }

      if (src) {
        image.src = src;
      }
    } else {
      onReady();
    }
  } else {
    // image already loaded...
    onReady();
  }
}
;// CONCATENATED MODULE: ./node_modules/swiper/core/images/preloadImages.js
function preloadImages() {
  const swiper = this;
  swiper.imagesToLoad = swiper.$el.find('img');

  function onReady() {
    if (typeof swiper === 'undefined' || swiper === null || !swiper || swiper.destroyed) return;
    if (swiper.imagesLoaded !== undefined) swiper.imagesLoaded += 1;

    if (swiper.imagesLoaded === swiper.imagesToLoad.length) {
      if (swiper.params.updateOnImagesReady) swiper.update();
      swiper.emit('imagesReady');
    }
  }

  for (let i = 0; i < swiper.imagesToLoad.length; i += 1) {
    const imageEl = swiper.imagesToLoad[i];
    swiper.loadImage(imageEl, imageEl.currentSrc || imageEl.getAttribute('src'), imageEl.srcset || imageEl.getAttribute('srcset'), imageEl.sizes || imageEl.getAttribute('sizes'), true, onReady);
  }
}
;// CONCATENATED MODULE: ./node_modules/swiper/core/images/index.js


/* harmony default export */ var core_images = ({
  loadImage: loadImage,
  preloadImages: preloadImages
});
;// CONCATENATED MODULE: ./node_modules/swiper/core/check-overflow/index.js
function checkOverflow() {
  const swiper = this;
  const {
    isLocked: wasLocked,
    params
  } = swiper;
  const {
    slidesOffsetBefore
  } = params;

  if (slidesOffsetBefore) {
    const lastSlideIndex = swiper.slides.length - 1;
    const lastSlideRightEdge = swiper.slidesGrid[lastSlideIndex] + swiper.slidesSizesGrid[lastSlideIndex] + slidesOffsetBefore * 2;
    swiper.isLocked = swiper.size > lastSlideRightEdge;
  } else {
    swiper.isLocked = swiper.snapGrid.length === 1;
  }

  if (params.allowSlideNext === true) {
    swiper.allowSlideNext = !swiper.isLocked;
  }

  if (params.allowSlidePrev === true) {
    swiper.allowSlidePrev = !swiper.isLocked;
  }

  if (wasLocked && wasLocked !== swiper.isLocked) {
    swiper.isEnd = false;
  }

  if (wasLocked !== swiper.isLocked) {
    swiper.emit(swiper.isLocked ? 'lock' : 'unlock');
  }
}

/* harmony default export */ var check_overflow = ({
  checkOverflow
});
;// CONCATENATED MODULE: ./node_modules/swiper/core/defaults.js
/* harmony default export */ var defaults = ({
  init: true,
  direction: 'horizontal',
  touchEventsTarget: 'wrapper',
  initialSlide: 0,
  speed: 300,
  cssMode: false,
  updateOnWindowResize: true,
  resizeObserver: true,
  nested: false,
  createElements: false,
  enabled: true,
  focusableElements: 'input, select, option, textarea, button, video, label',
  // Overrides
  width: null,
  height: null,
  //
  preventInteractionOnTransition: false,
  // ssr
  userAgent: null,
  url: null,
  // To support iOS's swipe-to-go-back gesture (when being used in-app).
  edgeSwipeDetection: false,
  edgeSwipeThreshold: 20,
  // Autoheight
  autoHeight: false,
  // Set wrapper width
  setWrapperSize: false,
  // Virtual Translate
  virtualTranslate: false,
  // Effects
  effect: 'slide',
  // 'slide' or 'fade' or 'cube' or 'coverflow' or 'flip'
  // Breakpoints
  breakpoints: undefined,
  breakpointsBase: 'window',
  // Slides grid
  spaceBetween: 0,
  slidesPerView: 1,
  slidesPerGroup: 1,
  slidesPerGroupSkip: 0,
  slidesPerGroupAuto: false,
  centeredSlides: false,
  centeredSlidesBounds: false,
  slidesOffsetBefore: 0,
  // in px
  slidesOffsetAfter: 0,
  // in px
  normalizeSlideIndex: true,
  centerInsufficientSlides: false,
  // Disable swiper and hide navigation when container not overflow
  watchOverflow: true,
  // Round length
  roundLengths: false,
  // Touches
  touchRatio: 1,
  touchAngle: 45,
  simulateTouch: true,
  shortSwipes: true,
  longSwipes: true,
  longSwipesRatio: 0.5,
  longSwipesMs: 300,
  followFinger: true,
  allowTouchMove: true,
  threshold: 0,
  touchMoveStopPropagation: false,
  touchStartPreventDefault: true,
  touchStartForcePreventDefault: false,
  touchReleaseOnEdges: false,
  // Unique Navigation Elements
  uniqueNavElements: true,
  // Resistance
  resistance: true,
  resistanceRatio: 0.85,
  // Progress
  watchSlidesProgress: false,
  // Cursor
  grabCursor: false,
  // Clicks
  preventClicks: true,
  preventClicksPropagation: true,
  slideToClickedSlide: false,
  // Images
  preloadImages: true,
  updateOnImagesReady: true,
  // loop
  loop: false,
  loopAdditionalSlides: 0,
  loopedSlides: null,
  loopedSlidesLimit: true,
  loopFillGroupWithBlank: false,
  loopPreventsSlide: true,
  // rewind
  rewind: false,
  // Swiping/no swiping
  allowSlidePrev: true,
  allowSlideNext: true,
  swipeHandler: null,
  // '.swipe-handler',
  noSwiping: true,
  noSwipingClass: 'swiper-no-swiping',
  noSwipingSelector: null,
  // Passive Listeners
  passiveListeners: true,
  maxBackfaceHiddenSlides: 10,
  // NS
  containerModifierClass: 'swiper-',
  // NEW
  slideClass: 'swiper-slide',
  slideBlankClass: 'swiper-slide-invisible-blank',
  slideActiveClass: 'swiper-slide-active',
  slideDuplicateActiveClass: 'swiper-slide-duplicate-active',
  slideVisibleClass: 'swiper-slide-visible',
  slideDuplicateClass: 'swiper-slide-duplicate',
  slideNextClass: 'swiper-slide-next',
  slideDuplicateNextClass: 'swiper-slide-duplicate-next',
  slidePrevClass: 'swiper-slide-prev',
  slideDuplicatePrevClass: 'swiper-slide-duplicate-prev',
  wrapperClass: 'swiper-wrapper',
  // Callbacks
  runCallbacksOnInit: true,
  // Internals
  _emitClasses: false
});
;// CONCATENATED MODULE: ./node_modules/swiper/core/moduleExtendParams.js

function moduleExtendParams(params, allModulesParams) {
  return function extendParams(obj = {}) {
    const moduleParamName = Object.keys(obj)[0];
    const moduleParams = obj[moduleParamName];

    if (typeof moduleParams !== 'object' || moduleParams === null) {
      utils_extend(allModulesParams, obj);
      return;
    }

    if (['navigation', 'pagination', 'scrollbar'].indexOf(moduleParamName) >= 0 && params[moduleParamName] === true) {
      params[moduleParamName] = {
        auto: true
      };
    }

    if (!(moduleParamName in params && 'enabled' in moduleParams)) {
      utils_extend(allModulesParams, obj);
      return;
    }

    if (params[moduleParamName] === true) {
      params[moduleParamName] = {
        enabled: true
      };
    }

    if (typeof params[moduleParamName] === 'object' && !('enabled' in params[moduleParamName])) {
      params[moduleParamName].enabled = true;
    }

    if (!params[moduleParamName]) params[moduleParamName] = {
      enabled: false
    };
    utils_extend(allModulesParams, obj);
  };
}
;// CONCATENATED MODULE: ./node_modules/swiper/core/core.js
/* eslint no-param-reassign: "off" */






















const prototypes = {
  eventsEmitter: events_emitter,
  update: update,
  translate: translate,
  transition: core_transition,
  slide: slide,
  loop: loop,
  grabCursor: grab_cursor,
  events: core_events,
  breakpoints: breakpoints,
  checkOverflow: check_overflow,
  classes: classes,
  images: core_images
};
const extendedDefaults = {};

class Swiper {
  constructor(...args) {
    let el;
    let params;

    if (args.length === 1 && args[0].constructor && Object.prototype.toString.call(args[0]).slice(8, -1) === 'Object') {
      params = args[0];
    } else {
      [el, params] = args;
    }

    if (!params) params = {};
    params = utils_extend({}, params);
    if (el && !params.el) params.el = el;

    if (params.el && dom(params.el).length > 1) {
      const swipers = [];
      dom(params.el).each(containerEl => {
        const newParams = utils_extend({}, params, {
          el: containerEl
        });
        swipers.push(new Swiper(newParams));
      }); // eslint-disable-next-line no-constructor-return

      return swipers;
    } // Swiper Instance


    const swiper = this;
    swiper.__swiper__ = true;
    swiper.support = getSupport();
    swiper.device = getDevice({
      userAgent: params.userAgent
    });
    swiper.browser = getBrowser();
    swiper.eventsListeners = {};
    swiper.eventsAnyListeners = [];
    swiper.modules = [...swiper.__modules__];

    if (params.modules && Array.isArray(params.modules)) {
      swiper.modules.push(...params.modules);
    }

    const allModulesParams = {};
    swiper.modules.forEach(mod => {
      mod({
        swiper,
        extendParams: moduleExtendParams(params, allModulesParams),
        on: swiper.on.bind(swiper),
        once: swiper.once.bind(swiper),
        off: swiper.off.bind(swiper),
        emit: swiper.emit.bind(swiper)
      });
    }); // Extend defaults with modules params

    const swiperParams = utils_extend({}, defaults, allModulesParams); // Extend defaults with passed params

    swiper.params = utils_extend({}, swiperParams, extendedDefaults, params);
    swiper.originalParams = utils_extend({}, swiper.params);
    swiper.passedParams = utils_extend({}, params); // add event listeners

    if (swiper.params && swiper.params.on) {
      Object.keys(swiper.params.on).forEach(eventName => {
        swiper.on(eventName, swiper.params.on[eventName]);
      });
    }

    if (swiper.params && swiper.params.onAny) {
      swiper.onAny(swiper.params.onAny);
    } // Save Dom lib


    swiper.$ = dom; // Extend Swiper

    Object.assign(swiper, {
      enabled: swiper.params.enabled,
      el,
      // Classes
      classNames: [],
      // Slides
      slides: dom(),
      slidesGrid: [],
      snapGrid: [],
      slidesSizesGrid: [],

      // isDirection
      isHorizontal() {
        return swiper.params.direction === 'horizontal';
      },

      isVertical() {
        return swiper.params.direction === 'vertical';
      },

      // Indexes
      activeIndex: 0,
      realIndex: 0,
      //
      isBeginning: true,
      isEnd: false,
      // Props
      translate: 0,
      previousTranslate: 0,
      progress: 0,
      velocity: 0,
      animating: false,
      // Locks
      allowSlideNext: swiper.params.allowSlideNext,
      allowSlidePrev: swiper.params.allowSlidePrev,
      // Touch Events
      touchEvents: function touchEvents() {
        const touch = ['touchstart', 'touchmove', 'touchend', 'touchcancel'];
        const desktop = ['pointerdown', 'pointermove', 'pointerup'];
        swiper.touchEventsTouch = {
          start: touch[0],
          move: touch[1],
          end: touch[2],
          cancel: touch[3]
        };
        swiper.touchEventsDesktop = {
          start: desktop[0],
          move: desktop[1],
          end: desktop[2]
        };
        return swiper.support.touch || !swiper.params.simulateTouch ? swiper.touchEventsTouch : swiper.touchEventsDesktop;
      }(),
      touchEventsData: {
        isTouched: undefined,
        isMoved: undefined,
        allowTouchCallbacks: undefined,
        touchStartTime: undefined,
        isScrolling: undefined,
        currentTranslate: undefined,
        startTranslate: undefined,
        allowThresholdMove: undefined,
        // Form elements to match
        focusableElements: swiper.params.focusableElements,
        // Last click time
        lastClickTime: utils_now(),
        clickTimeout: undefined,
        // Velocities
        velocities: [],
        allowMomentumBounce: undefined,
        isTouchEvent: undefined,
        startMoving: undefined
      },
      // Clicks
      allowClick: true,
      // Touches
      allowTouchMove: swiper.params.allowTouchMove,
      touches: {
        startX: 0,
        startY: 0,
        currentX: 0,
        currentY: 0,
        diff: 0
      },
      // Images
      imagesToLoad: [],
      imagesLoaded: 0
    });
    swiper.emit('_swiper'); // Init

    if (swiper.params.init) {
      swiper.init();
    } // Return app instance
    // eslint-disable-next-line no-constructor-return


    return swiper;
  }

  enable() {
    const swiper = this;
    if (swiper.enabled) return;
    swiper.enabled = true;

    if (swiper.params.grabCursor) {
      swiper.setGrabCursor();
    }

    swiper.emit('enable');
  }

  disable() {
    const swiper = this;
    if (!swiper.enabled) return;
    swiper.enabled = false;

    if (swiper.params.grabCursor) {
      swiper.unsetGrabCursor();
    }

    swiper.emit('disable');
  }

  setProgress(progress, speed) {
    const swiper = this;
    progress = Math.min(Math.max(progress, 0), 1);
    const min = swiper.minTranslate();
    const max = swiper.maxTranslate();
    const current = (max - min) * progress + min;
    swiper.translateTo(current, typeof speed === 'undefined' ? 0 : speed);
    swiper.updateActiveIndex();
    swiper.updateSlidesClasses();
  }

  emitContainerClasses() {
    const swiper = this;
    if (!swiper.params._emitClasses || !swiper.el) return;
    const cls = swiper.el.className.split(' ').filter(className => {
      return className.indexOf('swiper') === 0 || className.indexOf(swiper.params.containerModifierClass) === 0;
    });
    swiper.emit('_containerClasses', cls.join(' '));
  }

  getSlideClasses(slideEl) {
    const swiper = this;
    if (swiper.destroyed) return '';
    return slideEl.className.split(' ').filter(className => {
      return className.indexOf('swiper-slide') === 0 || className.indexOf(swiper.params.slideClass) === 0;
    }).join(' ');
  }

  emitSlidesClasses() {
    const swiper = this;
    if (!swiper.params._emitClasses || !swiper.el) return;
    const updates = [];
    swiper.slides.each(slideEl => {
      const classNames = swiper.getSlideClasses(slideEl);
      updates.push({
        slideEl,
        classNames
      });
      swiper.emit('_slideClass', slideEl, classNames);
    });
    swiper.emit('_slideClasses', updates);
  }

  slidesPerViewDynamic(view = 'current', exact = false) {
    const swiper = this;
    const {
      params,
      slides,
      slidesGrid,
      slidesSizesGrid,
      size: swiperSize,
      activeIndex
    } = swiper;
    let spv = 1;

    if (params.centeredSlides) {
      let slideSize = slides[activeIndex].swiperSlideSize;
      let breakLoop;

      for (let i = activeIndex + 1; i < slides.length; i += 1) {
        if (slides[i] && !breakLoop) {
          slideSize += slides[i].swiperSlideSize;
          spv += 1;
          if (slideSize > swiperSize) breakLoop = true;
        }
      }

      for (let i = activeIndex - 1; i >= 0; i -= 1) {
        if (slides[i] && !breakLoop) {
          slideSize += slides[i].swiperSlideSize;
          spv += 1;
          if (slideSize > swiperSize) breakLoop = true;
        }
      }
    } else {
      // eslint-disable-next-line
      if (view === 'current') {
        for (let i = activeIndex + 1; i < slides.length; i += 1) {
          const slideInView = exact ? slidesGrid[i] + slidesSizesGrid[i] - slidesGrid[activeIndex] < swiperSize : slidesGrid[i] - slidesGrid[activeIndex] < swiperSize;

          if (slideInView) {
            spv += 1;
          }
        }
      } else {
        // previous
        for (let i = activeIndex - 1; i >= 0; i -= 1) {
          const slideInView = slidesGrid[activeIndex] - slidesGrid[i] < swiperSize;

          if (slideInView) {
            spv += 1;
          }
        }
      }
    }

    return spv;
  }

  update() {
    const swiper = this;
    if (!swiper || swiper.destroyed) return;
    const {
      snapGrid,
      params
    } = swiper; // Breakpoints

    if (params.breakpoints) {
      swiper.setBreakpoint();
    }

    swiper.updateSize();
    swiper.updateSlides();
    swiper.updateProgress();
    swiper.updateSlidesClasses();

    function setTranslate() {
      const translateValue = swiper.rtlTranslate ? swiper.translate * -1 : swiper.translate;
      const newTranslate = Math.min(Math.max(translateValue, swiper.maxTranslate()), swiper.minTranslate());
      swiper.setTranslate(newTranslate);
      swiper.updateActiveIndex();
      swiper.updateSlidesClasses();
    }

    let translated;

    if (swiper.params.freeMode && swiper.params.freeMode.enabled) {
      setTranslate();

      if (swiper.params.autoHeight) {
        swiper.updateAutoHeight();
      }
    } else {
      if ((swiper.params.slidesPerView === 'auto' || swiper.params.slidesPerView > 1) && swiper.isEnd && !swiper.params.centeredSlides) {
        translated = swiper.slideTo(swiper.slides.length - 1, 0, false, true);
      } else {
        translated = swiper.slideTo(swiper.activeIndex, 0, false, true);
      }

      if (!translated) {
        setTranslate();
      }
    }

    if (params.watchOverflow && snapGrid !== swiper.snapGrid) {
      swiper.checkOverflow();
    }

    swiper.emit('update');
  }

  changeDirection(newDirection, needUpdate = true) {
    const swiper = this;
    const currentDirection = swiper.params.direction;

    if (!newDirection) {
      // eslint-disable-next-line
      newDirection = currentDirection === 'horizontal' ? 'vertical' : 'horizontal';
    }

    if (newDirection === currentDirection || newDirection !== 'horizontal' && newDirection !== 'vertical') {
      return swiper;
    }

    swiper.$el.removeClass(`${swiper.params.containerModifierClass}${currentDirection}`).addClass(`${swiper.params.containerModifierClass}${newDirection}`);
    swiper.emitContainerClasses();
    swiper.params.direction = newDirection;
    swiper.slides.each(slideEl => {
      if (newDirection === 'vertical') {
        slideEl.style.width = '';
      } else {
        slideEl.style.height = '';
      }
    });
    swiper.emit('changeDirection');
    if (needUpdate) swiper.update();
    return swiper;
  }

  changeLanguageDirection(direction) {
    const swiper = this;
    if (swiper.rtl && direction === 'rtl' || !swiper.rtl && direction === 'ltr') return;
    swiper.rtl = direction === 'rtl';
    swiper.rtlTranslate = swiper.params.direction === 'horizontal' && swiper.rtl;

    if (swiper.rtl) {
      swiper.$el.addClass(`${swiper.params.containerModifierClass}rtl`);
      swiper.el.dir = 'rtl';
    } else {
      swiper.$el.removeClass(`${swiper.params.containerModifierClass}rtl`);
      swiper.el.dir = 'ltr';
    }

    swiper.update();
  }

  mount(el) {
    const swiper = this;
    if (swiper.mounted) return true; // Find el

    const $el = dom(el || swiper.params.el);
    el = $el[0];

    if (!el) {
      return false;
    }

    el.swiper = swiper;

    const getWrapperSelector = () => {
      return `.${(swiper.params.wrapperClass || '').trim().split(' ').join('.')}`;
    };

    const getWrapper = () => {
      if (el && el.shadowRoot && el.shadowRoot.querySelector) {
        const res = dom(el.shadowRoot.querySelector(getWrapperSelector())); // Children needs to return slot items

        res.children = options => $el.children(options);

        return res;
      }

      if (!$el.children) {
        return dom($el).children(getWrapperSelector());
      }

      return $el.children(getWrapperSelector());
    }; // Find Wrapper


    let $wrapperEl = getWrapper();

    if ($wrapperEl.length === 0 && swiper.params.createElements) {
      const document = ssr_window_esm_getDocument();
      const wrapper = document.createElement('div');
      $wrapperEl = dom(wrapper);
      wrapper.className = swiper.params.wrapperClass;
      $el.append(wrapper);
      $el.children(`.${swiper.params.slideClass}`).each(slideEl => {
        $wrapperEl.append(slideEl);
      });
    }

    Object.assign(swiper, {
      $el,
      el,
      $wrapperEl,
      wrapperEl: $wrapperEl[0],
      mounted: true,
      // RTL
      rtl: el.dir.toLowerCase() === 'rtl' || $el.css('direction') === 'rtl',
      rtlTranslate: swiper.params.direction === 'horizontal' && (el.dir.toLowerCase() === 'rtl' || $el.css('direction') === 'rtl'),
      wrongRTL: $wrapperEl.css('display') === '-webkit-box'
    });
    return true;
  }

  init(el) {
    const swiper = this;
    if (swiper.initialized) return swiper;
    const mounted = swiper.mount(el);
    if (mounted === false) return swiper;
    swiper.emit('beforeInit'); // Set breakpoint

    if (swiper.params.breakpoints) {
      swiper.setBreakpoint();
    } // Add Classes


    swiper.addClasses(); // Create loop

    if (swiper.params.loop) {
      swiper.loopCreate();
    } // Update size


    swiper.updateSize(); // Update slides

    swiper.updateSlides();

    if (swiper.params.watchOverflow) {
      swiper.checkOverflow();
    } // Set Grab Cursor


    if (swiper.params.grabCursor && swiper.enabled) {
      swiper.setGrabCursor();
    }

    if (swiper.params.preloadImages) {
      swiper.preloadImages();
    } // Slide To Initial Slide


    if (swiper.params.loop) {
      swiper.slideTo(swiper.params.initialSlide + swiper.loopedSlides, 0, swiper.params.runCallbacksOnInit, false, true);
    } else {
      swiper.slideTo(swiper.params.initialSlide, 0, swiper.params.runCallbacksOnInit, false, true);
    } // Attach events


    swiper.attachEvents(); // Init Flag

    swiper.initialized = true; // Emit

    swiper.emit('init');
    swiper.emit('afterInit');
    return swiper;
  }

  destroy(deleteInstance = true, cleanStyles = true) {
    const swiper = this;
    const {
      params,
      $el,
      $wrapperEl,
      slides
    } = swiper;

    if (typeof swiper.params === 'undefined' || swiper.destroyed) {
      return null;
    }

    swiper.emit('beforeDestroy'); // Init Flag

    swiper.initialized = false; // Detach events

    swiper.detachEvents(); // Destroy loop

    if (params.loop) {
      swiper.loopDestroy();
    } // Cleanup styles


    if (cleanStyles) {
      swiper.removeClasses();
      $el.removeAttr('style');
      $wrapperEl.removeAttr('style');

      if (slides && slides.length) {
        slides.removeClass([params.slideVisibleClass, params.slideActiveClass, params.slideNextClass, params.slidePrevClass].join(' ')).removeAttr('style').removeAttr('data-swiper-slide-index');
      }
    }

    swiper.emit('destroy'); // Detach emitter events

    Object.keys(swiper.eventsListeners).forEach(eventName => {
      swiper.off(eventName);
    });

    if (deleteInstance !== false) {
      swiper.$el[0].swiper = null;
      deleteProps(swiper);
    }

    swiper.destroyed = true;
    return null;
  }

  static extendDefaults(newDefaults) {
    utils_extend(extendedDefaults, newDefaults);
  }

  static get extendedDefaults() {
    return extendedDefaults;
  }

  static get defaults() {
    return defaults;
  }

  static installModule(mod) {
    if (!Swiper.prototype.__modules__) Swiper.prototype.__modules__ = [];
    const modules = Swiper.prototype.__modules__;

    if (typeof mod === 'function' && modules.indexOf(mod) < 0) {
      modules.push(mod);
    }
  }

  static use(module) {
    if (Array.isArray(module)) {
      module.forEach(m => Swiper.installModule(m));
      return Swiper;
    }

    Swiper.installModule(module);
    return Swiper;
  }

}

Object.keys(prototypes).forEach(prototypeGroup => {
  Object.keys(prototypes[prototypeGroup]).forEach(protoMethod => {
    Swiper.prototype[protoMethod] = prototypes[prototypeGroup][protoMethod];
  });
});
Swiper.use([Resize, Observer]);
/* harmony default export */ var core = (Swiper);
;// CONCATENATED MODULE: ./node_modules/swiper/modules/virtual/virtual.js


function Virtual({
  swiper,
  extendParams,
  on,
  emit
}) {
  extendParams({
    virtual: {
      enabled: false,
      slides: [],
      cache: true,
      renderSlide: null,
      renderExternal: null,
      renderExternalUpdate: true,
      addSlidesBefore: 0,
      addSlidesAfter: 0
    }
  });
  let cssModeTimeout;
  swiper.virtual = {
    cache: {},
    from: undefined,
    to: undefined,
    slides: [],
    offset: 0,
    slidesGrid: []
  };

  function renderSlide(slide, index) {
    const params = swiper.params.virtual;

    if (params.cache && swiper.virtual.cache[index]) {
      return swiper.virtual.cache[index];
    }

    const $slideEl = params.renderSlide ? $(params.renderSlide.call(swiper, slide, index)) : $(`<div class="${swiper.params.slideClass}" data-swiper-slide-index="${index}">${slide}</div>`);
    if (!$slideEl.attr('data-swiper-slide-index')) $slideEl.attr('data-swiper-slide-index', index);
    if (params.cache) swiper.virtual.cache[index] = $slideEl;
    return $slideEl;
  }

  function update(force) {
    const {
      slidesPerView,
      slidesPerGroup,
      centeredSlides
    } = swiper.params;
    const {
      addSlidesBefore,
      addSlidesAfter
    } = swiper.params.virtual;
    const {
      from: previousFrom,
      to: previousTo,
      slides,
      slidesGrid: previousSlidesGrid,
      offset: previousOffset
    } = swiper.virtual;

    if (!swiper.params.cssMode) {
      swiper.updateActiveIndex();
    }

    const activeIndex = swiper.activeIndex || 0;
    let offsetProp;
    if (swiper.rtlTranslate) offsetProp = 'right';else offsetProp = swiper.isHorizontal() ? 'left' : 'top';
    let slidesAfter;
    let slidesBefore;

    if (centeredSlides) {
      slidesAfter = Math.floor(slidesPerView / 2) + slidesPerGroup + addSlidesAfter;
      slidesBefore = Math.floor(slidesPerView / 2) + slidesPerGroup + addSlidesBefore;
    } else {
      slidesAfter = slidesPerView + (slidesPerGroup - 1) + addSlidesAfter;
      slidesBefore = slidesPerGroup + addSlidesBefore;
    }

    const from = Math.max((activeIndex || 0) - slidesBefore, 0);
    const to = Math.min((activeIndex || 0) + slidesAfter, slides.length - 1);
    const offset = (swiper.slidesGrid[from] || 0) - (swiper.slidesGrid[0] || 0);
    Object.assign(swiper.virtual, {
      from,
      to,
      offset,
      slidesGrid: swiper.slidesGrid
    });

    function onRendered() {
      swiper.updateSlides();
      swiper.updateProgress();
      swiper.updateSlidesClasses();

      if (swiper.lazy && swiper.params.lazy.enabled) {
        swiper.lazy.load();
      }

      emit('virtualUpdate');
    }

    if (previousFrom === from && previousTo === to && !force) {
      if (swiper.slidesGrid !== previousSlidesGrid && offset !== previousOffset) {
        swiper.slides.css(offsetProp, `${offset}px`);
      }

      swiper.updateProgress();
      emit('virtualUpdate');
      return;
    }

    if (swiper.params.virtual.renderExternal) {
      swiper.params.virtual.renderExternal.call(swiper, {
        offset,
        from,
        to,
        slides: function getSlides() {
          const slidesToRender = [];

          for (let i = from; i <= to; i += 1) {
            slidesToRender.push(slides[i]);
          }

          return slidesToRender;
        }()
      });

      if (swiper.params.virtual.renderExternalUpdate) {
        onRendered();
      } else {
        emit('virtualUpdate');
      }

      return;
    }

    const prependIndexes = [];
    const appendIndexes = [];

    if (force) {
      swiper.$wrapperEl.find(`.${swiper.params.slideClass}`).remove();
    } else {
      for (let i = previousFrom; i <= previousTo; i += 1) {
        if (i < from || i > to) {
          swiper.$wrapperEl.find(`.${swiper.params.slideClass}[data-swiper-slide-index="${i}"]`).remove();
        }
      }
    }

    for (let i = 0; i < slides.length; i += 1) {
      if (i >= from && i <= to) {
        if (typeof previousTo === 'undefined' || force) {
          appendIndexes.push(i);
        } else {
          if (i > previousTo) appendIndexes.push(i);
          if (i < previousFrom) prependIndexes.push(i);
        }
      }
    }

    appendIndexes.forEach(index => {
      swiper.$wrapperEl.append(renderSlide(slides[index], index));
    });
    prependIndexes.sort((a, b) => b - a).forEach(index => {
      swiper.$wrapperEl.prepend(renderSlide(slides[index], index));
    });
    swiper.$wrapperEl.children('.swiper-slide').css(offsetProp, `${offset}px`);
    onRendered();
  }

  function appendSlide(slides) {
    if (typeof slides === 'object' && 'length' in slides) {
      for (let i = 0; i < slides.length; i += 1) {
        if (slides[i]) swiper.virtual.slides.push(slides[i]);
      }
    } else {
      swiper.virtual.slides.push(slides);
    }

    update(true);
  }

  function prependSlide(slides) {
    const activeIndex = swiper.activeIndex;
    let newActiveIndex = activeIndex + 1;
    let numberOfNewSlides = 1;

    if (Array.isArray(slides)) {
      for (let i = 0; i < slides.length; i += 1) {
        if (slides[i]) swiper.virtual.slides.unshift(slides[i]);
      }

      newActiveIndex = activeIndex + slides.length;
      numberOfNewSlides = slides.length;
    } else {
      swiper.virtual.slides.unshift(slides);
    }

    if (swiper.params.virtual.cache) {
      const cache = swiper.virtual.cache;
      const newCache = {};
      Object.keys(cache).forEach(cachedIndex => {
        const $cachedEl = cache[cachedIndex];
        const cachedElIndex = $cachedEl.attr('data-swiper-slide-index');

        if (cachedElIndex) {
          $cachedEl.attr('data-swiper-slide-index', parseInt(cachedElIndex, 10) + numberOfNewSlides);
        }

        newCache[parseInt(cachedIndex, 10) + numberOfNewSlides] = $cachedEl;
      });
      swiper.virtual.cache = newCache;
    }

    update(true);
    swiper.slideTo(newActiveIndex, 0);
  }

  function removeSlide(slidesIndexes) {
    if (typeof slidesIndexes === 'undefined' || slidesIndexes === null) return;
    let activeIndex = swiper.activeIndex;

    if (Array.isArray(slidesIndexes)) {
      for (let i = slidesIndexes.length - 1; i >= 0; i -= 1) {
        swiper.virtual.slides.splice(slidesIndexes[i], 1);

        if (swiper.params.virtual.cache) {
          delete swiper.virtual.cache[slidesIndexes[i]];
        }

        if (slidesIndexes[i] < activeIndex) activeIndex -= 1;
        activeIndex = Math.max(activeIndex, 0);
      }
    } else {
      swiper.virtual.slides.splice(slidesIndexes, 1);

      if (swiper.params.virtual.cache) {
        delete swiper.virtual.cache[slidesIndexes];
      }

      if (slidesIndexes < activeIndex) activeIndex -= 1;
      activeIndex = Math.max(activeIndex, 0);
    }

    update(true);
    swiper.slideTo(activeIndex, 0);
  }

  function removeAllSlides() {
    swiper.virtual.slides = [];

    if (swiper.params.virtual.cache) {
      swiper.virtual.cache = {};
    }

    update(true);
    swiper.slideTo(0, 0);
  }

  on('beforeInit', () => {
    if (!swiper.params.virtual.enabled) return;
    swiper.virtual.slides = swiper.params.virtual.slides;
    swiper.classNames.push(`${swiper.params.containerModifierClass}virtual`);
    swiper.params.watchSlidesProgress = true;
    swiper.originalParams.watchSlidesProgress = true;

    if (!swiper.params.initialSlide) {
      update();
    }
  });
  on('setTranslate', () => {
    if (!swiper.params.virtual.enabled) return;

    if (swiper.params.cssMode && !swiper._immediateVirtual) {
      clearTimeout(cssModeTimeout);
      cssModeTimeout = setTimeout(() => {
        update();
      }, 100);
    } else {
      update();
    }
  });
  on('init update resize', () => {
    if (!swiper.params.virtual.enabled) return;

    if (swiper.params.cssMode) {
      setCSSProperty(swiper.wrapperEl, '--swiper-virtual-size', `${swiper.virtualSize}px`);
    }
  });
  Object.assign(swiper.virtual, {
    appendSlide,
    prependSlide,
    removeSlide,
    removeAllSlides,
    update
  });
}
;// CONCATENATED MODULE: ./node_modules/swiper/modules/keyboard/keyboard.js
/* eslint-disable consistent-return */


function Keyboard({
  swiper,
  extendParams,
  on,
  emit
}) {
  const document = getDocument();
  const window = getWindow();
  swiper.keyboard = {
    enabled: false
  };
  extendParams({
    keyboard: {
      enabled: false,
      onlyInViewport: true,
      pageUpDown: true
    }
  });

  function handle(event) {
    if (!swiper.enabled) return;
    const {
      rtlTranslate: rtl
    } = swiper;
    let e = event;
    if (e.originalEvent) e = e.originalEvent; // jquery fix

    const kc = e.keyCode || e.charCode;
    const pageUpDown = swiper.params.keyboard.pageUpDown;
    const isPageUp = pageUpDown && kc === 33;
    const isPageDown = pageUpDown && kc === 34;
    const isArrowLeft = kc === 37;
    const isArrowRight = kc === 39;
    const isArrowUp = kc === 38;
    const isArrowDown = kc === 40; // Directions locks

    if (!swiper.allowSlideNext && (swiper.isHorizontal() && isArrowRight || swiper.isVertical() && isArrowDown || isPageDown)) {
      return false;
    }

    if (!swiper.allowSlidePrev && (swiper.isHorizontal() && isArrowLeft || swiper.isVertical() && isArrowUp || isPageUp)) {
      return false;
    }

    if (e.shiftKey || e.altKey || e.ctrlKey || e.metaKey) {
      return undefined;
    }

    if (document.activeElement && document.activeElement.nodeName && (document.activeElement.nodeName.toLowerCase() === 'input' || document.activeElement.nodeName.toLowerCase() === 'textarea')) {
      return undefined;
    }

    if (swiper.params.keyboard.onlyInViewport && (isPageUp || isPageDown || isArrowLeft || isArrowRight || isArrowUp || isArrowDown)) {
      let inView = false; // Check that swiper should be inside of visible area of window

      if (swiper.$el.parents(`.${swiper.params.slideClass}`).length > 0 && swiper.$el.parents(`.${swiper.params.slideActiveClass}`).length === 0) {
        return undefined;
      }

      const $el = swiper.$el;
      const swiperWidth = $el[0].clientWidth;
      const swiperHeight = $el[0].clientHeight;
      const windowWidth = window.innerWidth;
      const windowHeight = window.innerHeight;
      const swiperOffset = swiper.$el.offset();
      if (rtl) swiperOffset.left -= swiper.$el[0].scrollLeft;
      const swiperCoord = [[swiperOffset.left, swiperOffset.top], [swiperOffset.left + swiperWidth, swiperOffset.top], [swiperOffset.left, swiperOffset.top + swiperHeight], [swiperOffset.left + swiperWidth, swiperOffset.top + swiperHeight]];

      for (let i = 0; i < swiperCoord.length; i += 1) {
        const point = swiperCoord[i];

        if (point[0] >= 0 && point[0] <= windowWidth && point[1] >= 0 && point[1] <= windowHeight) {
          if (point[0] === 0 && point[1] === 0) continue; // eslint-disable-line

          inView = true;
        }
      }

      if (!inView) return undefined;
    }

    if (swiper.isHorizontal()) {
      if (isPageUp || isPageDown || isArrowLeft || isArrowRight) {
        if (e.preventDefault) e.preventDefault();else e.returnValue = false;
      }

      if ((isPageDown || isArrowRight) && !rtl || (isPageUp || isArrowLeft) && rtl) swiper.slideNext();
      if ((isPageUp || isArrowLeft) && !rtl || (isPageDown || isArrowRight) && rtl) swiper.slidePrev();
    } else {
      if (isPageUp || isPageDown || isArrowUp || isArrowDown) {
        if (e.preventDefault) e.preventDefault();else e.returnValue = false;
      }

      if (isPageDown || isArrowDown) swiper.slideNext();
      if (isPageUp || isArrowUp) swiper.slidePrev();
    }

    emit('keyPress', kc);
    return undefined;
  }

  function enable() {
    if (swiper.keyboard.enabled) return;
    $(document).on('keydown', handle);
    swiper.keyboard.enabled = true;
  }

  function disable() {
    if (!swiper.keyboard.enabled) return;
    $(document).off('keydown', handle);
    swiper.keyboard.enabled = false;
  }

  on('init', () => {
    if (swiper.params.keyboard.enabled) {
      enable();
    }
  });
  on('destroy', () => {
    if (swiper.keyboard.enabled) {
      disable();
    }
  });
  Object.assign(swiper.keyboard, {
    enable,
    disable
  });
}
;// CONCATENATED MODULE: ./node_modules/swiper/modules/mousewheel/mousewheel.js
/* eslint-disable consistent-return */



function Mousewheel({
  swiper,
  extendParams,
  on,
  emit
}) {
  const window = getWindow();
  extendParams({
    mousewheel: {
      enabled: false,
      releaseOnEdges: false,
      invert: false,
      forceToAxis: false,
      sensitivity: 1,
      eventsTarget: 'container',
      thresholdDelta: null,
      thresholdTime: null
    }
  });
  swiper.mousewheel = {
    enabled: false
  };
  let timeout;
  let lastScrollTime = now();
  let lastEventBeforeSnap;
  const recentWheelEvents = [];

  function normalize(e) {
    // Reasonable defaults
    const PIXEL_STEP = 10;
    const LINE_HEIGHT = 40;
    const PAGE_HEIGHT = 800;
    let sX = 0;
    let sY = 0; // spinX, spinY

    let pX = 0;
    let pY = 0; // pixelX, pixelY
    // Legacy

    if ('detail' in e) {
      sY = e.detail;
    }

    if ('wheelDelta' in e) {
      sY = -e.wheelDelta / 120;
    }

    if ('wheelDeltaY' in e) {
      sY = -e.wheelDeltaY / 120;
    }

    if ('wheelDeltaX' in e) {
      sX = -e.wheelDeltaX / 120;
    } // side scrolling on FF with DOMMouseScroll


    if ('axis' in e && e.axis === e.HORIZONTAL_AXIS) {
      sX = sY;
      sY = 0;
    }

    pX = sX * PIXEL_STEP;
    pY = sY * PIXEL_STEP;

    if ('deltaY' in e) {
      pY = e.deltaY;
    }

    if ('deltaX' in e) {
      pX = e.deltaX;
    }

    if (e.shiftKey && !pX) {
      // if user scrolls with shift he wants horizontal scroll
      pX = pY;
      pY = 0;
    }

    if ((pX || pY) && e.deltaMode) {
      if (e.deltaMode === 1) {
        // delta in LINE units
        pX *= LINE_HEIGHT;
        pY *= LINE_HEIGHT;
      } else {
        // delta in PAGE units
        pX *= PAGE_HEIGHT;
        pY *= PAGE_HEIGHT;
      }
    } // Fall-back if spin cannot be determined


    if (pX && !sX) {
      sX = pX < 1 ? -1 : 1;
    }

    if (pY && !sY) {
      sY = pY < 1 ? -1 : 1;
    }

    return {
      spinX: sX,
      spinY: sY,
      pixelX: pX,
      pixelY: pY
    };
  }

  function handleMouseEnter() {
    if (!swiper.enabled) return;
    swiper.mouseEntered = true;
  }

  function handleMouseLeave() {
    if (!swiper.enabled) return;
    swiper.mouseEntered = false;
  }

  function animateSlider(newEvent) {
    if (swiper.params.mousewheel.thresholdDelta && newEvent.delta < swiper.params.mousewheel.thresholdDelta) {
      // Prevent if delta of wheel scroll delta is below configured threshold
      return false;
    }

    if (swiper.params.mousewheel.thresholdTime && now() - lastScrollTime < swiper.params.mousewheel.thresholdTime) {
      // Prevent if time between scrolls is below configured threshold
      return false;
    } // If the movement is NOT big enough and
    // if the last time the user scrolled was too close to the current one (avoid continuously triggering the slider):
    //   Don't go any further (avoid insignificant scroll movement).


    if (newEvent.delta >= 6 && now() - lastScrollTime < 60) {
      // Return false as a default
      return true;
    } // If user is scrolling towards the end:
    //   If the slider hasn't hit the latest slide or
    //   if the slider is a loop and
    //   if the slider isn't moving right now:
    //     Go to next slide and
    //     emit a scroll event.
    // Else (the user is scrolling towards the beginning) and
    // if the slider hasn't hit the first slide or
    // if the slider is a loop and
    // if the slider isn't moving right now:
    //   Go to prev slide and
    //   emit a scroll event.


    if (newEvent.direction < 0) {
      if ((!swiper.isEnd || swiper.params.loop) && !swiper.animating) {
        swiper.slideNext();
        emit('scroll', newEvent.raw);
      }
    } else if ((!swiper.isBeginning || swiper.params.loop) && !swiper.animating) {
      swiper.slidePrev();
      emit('scroll', newEvent.raw);
    } // If you got here is because an animation has been triggered so store the current time


    lastScrollTime = new window.Date().getTime(); // Return false as a default

    return false;
  }

  function releaseScroll(newEvent) {
    const params = swiper.params.mousewheel;

    if (newEvent.direction < 0) {
      if (swiper.isEnd && !swiper.params.loop && params.releaseOnEdges) {
        // Return true to animate scroll on edges
        return true;
      }
    } else if (swiper.isBeginning && !swiper.params.loop && params.releaseOnEdges) {
      // Return true to animate scroll on edges
      return true;
    }

    return false;
  }

  function handle(event) {
    let e = event;
    let disableParentSwiper = true;
    if (!swiper.enabled) return;
    const params = swiper.params.mousewheel;

    if (swiper.params.cssMode) {
      e.preventDefault();
    }

    let target = swiper.$el;

    if (swiper.params.mousewheel.eventsTarget !== 'container') {
      target = $(swiper.params.mousewheel.eventsTarget);
    }

    if (!swiper.mouseEntered && !target[0].contains(e.target) && !params.releaseOnEdges) return true;
    if (e.originalEvent) e = e.originalEvent; // jquery fix

    let delta = 0;
    const rtlFactor = swiper.rtlTranslate ? -1 : 1;
    const data = normalize(e);

    if (params.forceToAxis) {
      if (swiper.isHorizontal()) {
        if (Math.abs(data.pixelX) > Math.abs(data.pixelY)) delta = -data.pixelX * rtlFactor;else return true;
      } else if (Math.abs(data.pixelY) > Math.abs(data.pixelX)) delta = -data.pixelY;else return true;
    } else {
      delta = Math.abs(data.pixelX) > Math.abs(data.pixelY) ? -data.pixelX * rtlFactor : -data.pixelY;
    }

    if (delta === 0) return true;
    if (params.invert) delta = -delta; // Get the scroll positions

    let positions = swiper.getTranslate() + delta * params.sensitivity;
    if (positions >= swiper.minTranslate()) positions = swiper.minTranslate();
    if (positions <= swiper.maxTranslate()) positions = swiper.maxTranslate(); // When loop is true:
    //     the disableParentSwiper will be true.
    // When loop is false:
    //     if the scroll positions is not on edge,
    //     then the disableParentSwiper will be true.
    //     if the scroll on edge positions,
    //     then the disableParentSwiper will be false.

    disableParentSwiper = swiper.params.loop ? true : !(positions === swiper.minTranslate() || positions === swiper.maxTranslate());
    if (disableParentSwiper && swiper.params.nested) e.stopPropagation();

    if (!swiper.params.freeMode || !swiper.params.freeMode.enabled) {
      // Register the new event in a variable which stores the relevant data
      const newEvent = {
        time: now(),
        delta: Math.abs(delta),
        direction: Math.sign(delta),
        raw: event
      }; // Keep the most recent events

      if (recentWheelEvents.length >= 2) {
        recentWheelEvents.shift(); // only store the last N events
      }

      const prevEvent = recentWheelEvents.length ? recentWheelEvents[recentWheelEvents.length - 1] : undefined;
      recentWheelEvents.push(newEvent); // If there is at least one previous recorded event:
      //   If direction has changed or
      //   if the scroll is quicker than the previous one:
      //     Animate the slider.
      // Else (this is the first time the wheel is moved):
      //     Animate the slider.

      if (prevEvent) {
        if (newEvent.direction !== prevEvent.direction || newEvent.delta > prevEvent.delta || newEvent.time > prevEvent.time + 150) {
          animateSlider(newEvent);
        }
      } else {
        animateSlider(newEvent);
      } // If it's time to release the scroll:
      //   Return now so you don't hit the preventDefault.


      if (releaseScroll(newEvent)) {
        return true;
      }
    } else {
      // Freemode or scrollContainer:
      // If we recently snapped after a momentum scroll, then ignore wheel events
      // to give time for the deceleration to finish. Stop ignoring after 500 msecs
      // or if it's a new scroll (larger delta or inverse sign as last event before
      // an end-of-momentum snap).
      const newEvent = {
        time: now(),
        delta: Math.abs(delta),
        direction: Math.sign(delta)
      };
      const ignoreWheelEvents = lastEventBeforeSnap && newEvent.time < lastEventBeforeSnap.time + 500 && newEvent.delta <= lastEventBeforeSnap.delta && newEvent.direction === lastEventBeforeSnap.direction;

      if (!ignoreWheelEvents) {
        lastEventBeforeSnap = undefined;

        if (swiper.params.loop) {
          swiper.loopFix();
        }

        let position = swiper.getTranslate() + delta * params.sensitivity;
        const wasBeginning = swiper.isBeginning;
        const wasEnd = swiper.isEnd;
        if (position >= swiper.minTranslate()) position = swiper.minTranslate();
        if (position <= swiper.maxTranslate()) position = swiper.maxTranslate();
        swiper.setTransition(0);
        swiper.setTranslate(position);
        swiper.updateProgress();
        swiper.updateActiveIndex();
        swiper.updateSlidesClasses();

        if (!wasBeginning && swiper.isBeginning || !wasEnd && swiper.isEnd) {
          swiper.updateSlidesClasses();
        }

        if (swiper.params.freeMode.sticky) {
          // When wheel scrolling starts with sticky (aka snap) enabled, then detect
          // the end of a momentum scroll by storing recent (N=15?) wheel events.
          // 1. do all N events have decreasing or same (absolute value) delta?
          // 2. did all N events arrive in the last M (M=500?) msecs?
          // 3. does the earliest event have an (absolute value) delta that's
          //    at least P (P=1?) larger than the most recent event's delta?
          // 4. does the latest event have a delta that's smaller than Q (Q=6?) pixels?
          // If 1-4 are "yes" then we're near the end of a momentum scroll deceleration.
          // Snap immediately and ignore remaining wheel events in this scroll.
          // See comment above for "remaining wheel events in this scroll" determination.
          // If 1-4 aren't satisfied, then wait to snap until 500ms after the last event.
          clearTimeout(timeout);
          timeout = undefined;

          if (recentWheelEvents.length >= 15) {
            recentWheelEvents.shift(); // only store the last N events
          }

          const prevEvent = recentWheelEvents.length ? recentWheelEvents[recentWheelEvents.length - 1] : undefined;
          const firstEvent = recentWheelEvents[0];
          recentWheelEvents.push(newEvent);

          if (prevEvent && (newEvent.delta > prevEvent.delta || newEvent.direction !== prevEvent.direction)) {
            // Increasing or reverse-sign delta means the user started scrolling again. Clear the wheel event log.
            recentWheelEvents.splice(0);
          } else if (recentWheelEvents.length >= 15 && newEvent.time - firstEvent.time < 500 && firstEvent.delta - newEvent.delta >= 1 && newEvent.delta <= 6) {
            // We're at the end of the deceleration of a momentum scroll, so there's no need
            // to wait for more events. Snap ASAP on the next tick.
            // Also, because there's some remaining momentum we'll bias the snap in the
            // direction of the ongoing scroll because it's better UX for the scroll to snap
            // in the same direction as the scroll instead of reversing to snap.  Therefore,
            // if it's already scrolled more than 20% in the current direction, keep going.
            const snapToThreshold = delta > 0 ? 0.8 : 0.2;
            lastEventBeforeSnap = newEvent;
            recentWheelEvents.splice(0);
            timeout = nextTick(() => {
              swiper.slideToClosest(swiper.params.speed, true, undefined, snapToThreshold);
            }, 0); // no delay; move on next tick
          }

          if (!timeout) {
            // if we get here, then we haven't detected the end of a momentum scroll, so
            // we'll consider a scroll "complete" when there haven't been any wheel events
            // for 500ms.
            timeout = nextTick(() => {
              const snapToThreshold = 0.5;
              lastEventBeforeSnap = newEvent;
              recentWheelEvents.splice(0);
              swiper.slideToClosest(swiper.params.speed, true, undefined, snapToThreshold);
            }, 500);
          }
        } // Emit event


        if (!ignoreWheelEvents) emit('scroll', e); // Stop autoplay

        if (swiper.params.autoplay && swiper.params.autoplayDisableOnInteraction) swiper.autoplay.stop(); // Return page scroll on edge positions

        if (position === swiper.minTranslate() || position === swiper.maxTranslate()) return true;
      }
    }

    if (e.preventDefault) e.preventDefault();else e.returnValue = false;
    return false;
  }

  function events(method) {
    let target = swiper.$el;

    if (swiper.params.mousewheel.eventsTarget !== 'container') {
      target = $(swiper.params.mousewheel.eventsTarget);
    }

    target[method]('mouseenter', handleMouseEnter);
    target[method]('mouseleave', handleMouseLeave);
    target[method]('wheel', handle);
  }

  function enable() {
    if (swiper.params.cssMode) {
      swiper.wrapperEl.removeEventListener('wheel', handle);
      return true;
    }

    if (swiper.mousewheel.enabled) return false;
    events('on');
    swiper.mousewheel.enabled = true;
    return true;
  }

  function disable() {
    if (swiper.params.cssMode) {
      swiper.wrapperEl.addEventListener(event, handle);
      return true;
    }

    if (!swiper.mousewheel.enabled) return false;
    events('off');
    swiper.mousewheel.enabled = false;
    return true;
  }

  on('init', () => {
    if (!swiper.params.mousewheel.enabled && swiper.params.cssMode) {
      disable();
    }

    if (swiper.params.mousewheel.enabled) enable();
  });
  on('destroy', () => {
    if (swiper.params.cssMode) {
      enable();
    }

    if (swiper.mousewheel.enabled) disable();
  });
  Object.assign(swiper.mousewheel, {
    enable,
    disable
  });
}
;// CONCATENATED MODULE: ./node_modules/swiper/shared/create-element-if-not-defined.js

function create_element_if_not_defined_createElementIfNotDefined(swiper, originalParams, params, checkProps) {
  const document = ssr_window_esm_getDocument();

  if (swiper.params.createElements) {
    Object.keys(checkProps).forEach(key => {
      if (!params[key] && params.auto === true) {
        let element = swiper.$el.children(`.${checkProps[key]}`)[0];

        if (!element) {
          element = document.createElement('div');
          element.className = checkProps[key];
          swiper.$el.append(element);
        }

        params[key] = element;
        originalParams[key] = element;
      }
    });
  }

  return params;
}
;// CONCATENATED MODULE: ./node_modules/swiper/modules/navigation/navigation.js


function Navigation({
  swiper,
  extendParams,
  on,
  emit
}) {
  extendParams({
    navigation: {
      nextEl: null,
      prevEl: null,
      hideOnClick: false,
      disabledClass: 'swiper-button-disabled',
      hiddenClass: 'swiper-button-hidden',
      lockClass: 'swiper-button-lock',
      navigationDisabledClass: 'swiper-navigation-disabled'
    }
  });
  swiper.navigation = {
    nextEl: null,
    $nextEl: null,
    prevEl: null,
    $prevEl: null
  };

  function getEl(el) {
    let $el;

    if (el) {
      $el = dom(el);

      if (swiper.params.uniqueNavElements && typeof el === 'string' && $el.length > 1 && swiper.$el.find(el).length === 1) {
        $el = swiper.$el.find(el);
      }
    }

    return $el;
  }

  function toggleEl($el, disabled) {
    const params = swiper.params.navigation;

    if ($el && $el.length > 0) {
      $el[disabled ? 'addClass' : 'removeClass'](params.disabledClass);
      if ($el[0] && $el[0].tagName === 'BUTTON') $el[0].disabled = disabled;

      if (swiper.params.watchOverflow && swiper.enabled) {
        $el[swiper.isLocked ? 'addClass' : 'removeClass'](params.lockClass);
      }
    }
  }

  function update() {
    // Update Navigation Buttons
    if (swiper.params.loop) return;
    const {
      $nextEl,
      $prevEl
    } = swiper.navigation;
    toggleEl($prevEl, swiper.isBeginning && !swiper.params.rewind);
    toggleEl($nextEl, swiper.isEnd && !swiper.params.rewind);
  }

  function onPrevClick(e) {
    e.preventDefault();
    if (swiper.isBeginning && !swiper.params.loop && !swiper.params.rewind) return;
    swiper.slidePrev();
    emit('navigationPrev');
  }

  function onNextClick(e) {
    e.preventDefault();
    if (swiper.isEnd && !swiper.params.loop && !swiper.params.rewind) return;
    swiper.slideNext();
    emit('navigationNext');
  }

  function init() {
    const params = swiper.params.navigation;
    swiper.params.navigation = create_element_if_not_defined_createElementIfNotDefined(swiper, swiper.originalParams.navigation, swiper.params.navigation, {
      nextEl: 'swiper-button-next',
      prevEl: 'swiper-button-prev'
    });
    if (!(params.nextEl || params.prevEl)) return;
    const $nextEl = getEl(params.nextEl);
    const $prevEl = getEl(params.prevEl);

    if ($nextEl && $nextEl.length > 0) {
      $nextEl.on('click', onNextClick);
    }

    if ($prevEl && $prevEl.length > 0) {
      $prevEl.on('click', onPrevClick);
    }

    Object.assign(swiper.navigation, {
      $nextEl,
      nextEl: $nextEl && $nextEl[0],
      $prevEl,
      prevEl: $prevEl && $prevEl[0]
    });

    if (!swiper.enabled) {
      if ($nextEl) $nextEl.addClass(params.lockClass);
      if ($prevEl) $prevEl.addClass(params.lockClass);
    }
  }

  function destroy() {
    const {
      $nextEl,
      $prevEl
    } = swiper.navigation;

    if ($nextEl && $nextEl.length) {
      $nextEl.off('click', onNextClick);
      $nextEl.removeClass(swiper.params.navigation.disabledClass);
    }

    if ($prevEl && $prevEl.length) {
      $prevEl.off('click', onPrevClick);
      $prevEl.removeClass(swiper.params.navigation.disabledClass);
    }
  }

  on('init', () => {
    if (swiper.params.navigation.enabled === false) {
      // eslint-disable-next-line
      disable();
    } else {
      init();
      update();
    }
  });
  on('toEdge fromEdge lock unlock', () => {
    update();
  });
  on('destroy', () => {
    destroy();
  });
  on('enable disable', () => {
    const {
      $nextEl,
      $prevEl
    } = swiper.navigation;

    if ($nextEl) {
      $nextEl[swiper.enabled ? 'removeClass' : 'addClass'](swiper.params.navigation.lockClass);
    }

    if ($prevEl) {
      $prevEl[swiper.enabled ? 'removeClass' : 'addClass'](swiper.params.navigation.lockClass);
    }
  });
  on('click', (_s, e) => {
    const {
      $nextEl,
      $prevEl
    } = swiper.navigation;
    const targetEl = e.target;

    if (swiper.params.navigation.hideOnClick && !dom(targetEl).is($prevEl) && !dom(targetEl).is($nextEl)) {
      if (swiper.pagination && swiper.params.pagination && swiper.params.pagination.clickable && (swiper.pagination.el === targetEl || swiper.pagination.el.contains(targetEl))) return;
      let isHidden;

      if ($nextEl) {
        isHidden = $nextEl.hasClass(swiper.params.navigation.hiddenClass);
      } else if ($prevEl) {
        isHidden = $prevEl.hasClass(swiper.params.navigation.hiddenClass);
      }

      if (isHidden === true) {
        emit('navigationShow');
      } else {
        emit('navigationHide');
      }

      if ($nextEl) {
        $nextEl.toggleClass(swiper.params.navigation.hiddenClass);
      }

      if ($prevEl) {
        $prevEl.toggleClass(swiper.params.navigation.hiddenClass);
      }
    }
  });

  const enable = () => {
    swiper.$el.removeClass(swiper.params.navigation.navigationDisabledClass);
    init();
    update();
  };

  const disable = () => {
    swiper.$el.addClass(swiper.params.navigation.navigationDisabledClass);
    destroy();
  };

  Object.assign(swiper.navigation, {
    enable,
    disable,
    update,
    init,
    destroy
  });
}
;// CONCATENATED MODULE: ./node_modules/swiper/shared/classes-to-selector.js
function classes_to_selector_classesToSelector(classes = '') {
  return `.${classes.trim().replace(/([\.:!\/])/g, '\\$1') // eslint-disable-line
  .replace(/ /g, '.')}`;
}
;// CONCATENATED MODULE: ./node_modules/swiper/modules/pagination/pagination.js



function Pagination({
  swiper,
  extendParams,
  on,
  emit
}) {
  const pfx = 'swiper-pagination';
  extendParams({
    pagination: {
      el: null,
      bulletElement: 'span',
      clickable: false,
      hideOnClick: false,
      renderBullet: null,
      renderProgressbar: null,
      renderFraction: null,
      renderCustom: null,
      progressbarOpposite: false,
      type: 'bullets',
      // 'bullets' or 'progressbar' or 'fraction' or 'custom'
      dynamicBullets: false,
      dynamicMainBullets: 1,
      formatFractionCurrent: number => number,
      formatFractionTotal: number => number,
      bulletClass: `${pfx}-bullet`,
      bulletActiveClass: `${pfx}-bullet-active`,
      modifierClass: `${pfx}-`,
      currentClass: `${pfx}-current`,
      totalClass: `${pfx}-total`,
      hiddenClass: `${pfx}-hidden`,
      progressbarFillClass: `${pfx}-progressbar-fill`,
      progressbarOppositeClass: `${pfx}-progressbar-opposite`,
      clickableClass: `${pfx}-clickable`,
      lockClass: `${pfx}-lock`,
      horizontalClass: `${pfx}-horizontal`,
      verticalClass: `${pfx}-vertical`,
      paginationDisabledClass: `${pfx}-disabled`
    }
  });
  swiper.pagination = {
    el: null,
    $el: null,
    bullets: []
  };
  let bulletSize;
  let dynamicBulletIndex = 0;

  function isPaginationDisabled() {
    return !swiper.params.pagination.el || !swiper.pagination.el || !swiper.pagination.$el || swiper.pagination.$el.length === 0;
  }

  function setSideBullets($bulletEl, position) {
    const {
      bulletActiveClass
    } = swiper.params.pagination;
    $bulletEl[position]().addClass(`${bulletActiveClass}-${position}`)[position]().addClass(`${bulletActiveClass}-${position}-${position}`);
  }

  function update() {
    // Render || Update Pagination bullets/items
    const rtl = swiper.rtl;
    const params = swiper.params.pagination;
    if (isPaginationDisabled()) return;
    const slidesLength = swiper.virtual && swiper.params.virtual.enabled ? swiper.virtual.slides.length : swiper.slides.length;
    const $el = swiper.pagination.$el; // Current/Total

    let current;
    const total = swiper.params.loop ? Math.ceil((slidesLength - swiper.loopedSlides * 2) / swiper.params.slidesPerGroup) : swiper.snapGrid.length;

    if (swiper.params.loop) {
      current = Math.ceil((swiper.activeIndex - swiper.loopedSlides) / swiper.params.slidesPerGroup);

      if (current > slidesLength - 1 - swiper.loopedSlides * 2) {
        current -= slidesLength - swiper.loopedSlides * 2;
      }

      if (current > total - 1) current -= total;
      if (current < 0 && swiper.params.paginationType !== 'bullets') current = total + current;
    } else if (typeof swiper.snapIndex !== 'undefined') {
      current = swiper.snapIndex;
    } else {
      current = swiper.activeIndex || 0;
    } // Types


    if (params.type === 'bullets' && swiper.pagination.bullets && swiper.pagination.bullets.length > 0) {
      const bullets = swiper.pagination.bullets;
      let firstIndex;
      let lastIndex;
      let midIndex;

      if (params.dynamicBullets) {
        bulletSize = bullets.eq(0)[swiper.isHorizontal() ? 'outerWidth' : 'outerHeight'](true);
        $el.css(swiper.isHorizontal() ? 'width' : 'height', `${bulletSize * (params.dynamicMainBullets + 4)}px`);

        if (params.dynamicMainBullets > 1 && swiper.previousIndex !== undefined) {
          dynamicBulletIndex += current - (swiper.previousIndex - swiper.loopedSlides || 0);

          if (dynamicBulletIndex > params.dynamicMainBullets - 1) {
            dynamicBulletIndex = params.dynamicMainBullets - 1;
          } else if (dynamicBulletIndex < 0) {
            dynamicBulletIndex = 0;
          }
        }

        firstIndex = Math.max(current - dynamicBulletIndex, 0);
        lastIndex = firstIndex + (Math.min(bullets.length, params.dynamicMainBullets) - 1);
        midIndex = (lastIndex + firstIndex) / 2;
      }

      bullets.removeClass(['', '-next', '-next-next', '-prev', '-prev-prev', '-main'].map(suffix => `${params.bulletActiveClass}${suffix}`).join(' '));

      if ($el.length > 1) {
        bullets.each(bullet => {
          const $bullet = dom(bullet);
          const bulletIndex = $bullet.index();

          if (bulletIndex === current) {
            $bullet.addClass(params.bulletActiveClass);
          }

          if (params.dynamicBullets) {
            if (bulletIndex >= firstIndex && bulletIndex <= lastIndex) {
              $bullet.addClass(`${params.bulletActiveClass}-main`);
            }

            if (bulletIndex === firstIndex) {
              setSideBullets($bullet, 'prev');
            }

            if (bulletIndex === lastIndex) {
              setSideBullets($bullet, 'next');
            }
          }
        });
      } else {
        const $bullet = bullets.eq(current);
        const bulletIndex = $bullet.index();
        $bullet.addClass(params.bulletActiveClass);

        if (params.dynamicBullets) {
          const $firstDisplayedBullet = bullets.eq(firstIndex);
          const $lastDisplayedBullet = bullets.eq(lastIndex);

          for (let i = firstIndex; i <= lastIndex; i += 1) {
            bullets.eq(i).addClass(`${params.bulletActiveClass}-main`);
          }

          if (swiper.params.loop) {
            if (bulletIndex >= bullets.length) {
              for (let i = params.dynamicMainBullets; i >= 0; i -= 1) {
                bullets.eq(bullets.length - i).addClass(`${params.bulletActiveClass}-main`);
              }

              bullets.eq(bullets.length - params.dynamicMainBullets - 1).addClass(`${params.bulletActiveClass}-prev`);
            } else {
              setSideBullets($firstDisplayedBullet, 'prev');
              setSideBullets($lastDisplayedBullet, 'next');
            }
          } else {
            setSideBullets($firstDisplayedBullet, 'prev');
            setSideBullets($lastDisplayedBullet, 'next');
          }
        }
      }

      if (params.dynamicBullets) {
        const dynamicBulletsLength = Math.min(bullets.length, params.dynamicMainBullets + 4);
        const bulletsOffset = (bulletSize * dynamicBulletsLength - bulletSize) / 2 - midIndex * bulletSize;
        const offsetProp = rtl ? 'right' : 'left';
        bullets.css(swiper.isHorizontal() ? offsetProp : 'top', `${bulletsOffset}px`);
      }
    }

    if (params.type === 'fraction') {
      $el.find(classes_to_selector_classesToSelector(params.currentClass)).text(params.formatFractionCurrent(current + 1));
      $el.find(classes_to_selector_classesToSelector(params.totalClass)).text(params.formatFractionTotal(total));
    }

    if (params.type === 'progressbar') {
      let progressbarDirection;

      if (params.progressbarOpposite) {
        progressbarDirection = swiper.isHorizontal() ? 'vertical' : 'horizontal';
      } else {
        progressbarDirection = swiper.isHorizontal() ? 'horizontal' : 'vertical';
      }

      const scale = (current + 1) / total;
      let scaleX = 1;
      let scaleY = 1;

      if (progressbarDirection === 'horizontal') {
        scaleX = scale;
      } else {
        scaleY = scale;
      }

      $el.find(classes_to_selector_classesToSelector(params.progressbarFillClass)).transform(`translate3d(0,0,0) scaleX(${scaleX}) scaleY(${scaleY})`).transition(swiper.params.speed);
    }

    if (params.type === 'custom' && params.renderCustom) {
      $el.html(params.renderCustom(swiper, current + 1, total));
      emit('paginationRender', $el[0]);
    } else {
      emit('paginationUpdate', $el[0]);
    }

    if (swiper.params.watchOverflow && swiper.enabled) {
      $el[swiper.isLocked ? 'addClass' : 'removeClass'](params.lockClass);
    }
  }

  function render() {
    // Render Container
    const params = swiper.params.pagination;
    if (isPaginationDisabled()) return;
    const slidesLength = swiper.virtual && swiper.params.virtual.enabled ? swiper.virtual.slides.length : swiper.slides.length;
    const $el = swiper.pagination.$el;
    let paginationHTML = '';

    if (params.type === 'bullets') {
      let numberOfBullets = swiper.params.loop ? Math.ceil((slidesLength - swiper.loopedSlides * 2) / swiper.params.slidesPerGroup) : swiper.snapGrid.length;

      if (swiper.params.freeMode && swiper.params.freeMode.enabled && !swiper.params.loop && numberOfBullets > slidesLength) {
        numberOfBullets = slidesLength;
      }

      for (let i = 0; i < numberOfBullets; i += 1) {
        if (params.renderBullet) {
          paginationHTML += params.renderBullet.call(swiper, i, params.bulletClass);
        } else {
          paginationHTML += `<${params.bulletElement} class="${params.bulletClass}"></${params.bulletElement}>`;
        }
      }

      $el.html(paginationHTML);
      swiper.pagination.bullets = $el.find(classes_to_selector_classesToSelector(params.bulletClass));
    }

    if (params.type === 'fraction') {
      if (params.renderFraction) {
        paginationHTML = params.renderFraction.call(swiper, params.currentClass, params.totalClass);
      } else {
        paginationHTML = `<span class="${params.currentClass}"></span>` + ' / ' + `<span class="${params.totalClass}"></span>`;
      }

      $el.html(paginationHTML);
    }

    if (params.type === 'progressbar') {
      if (params.renderProgressbar) {
        paginationHTML = params.renderProgressbar.call(swiper, params.progressbarFillClass);
      } else {
        paginationHTML = `<span class="${params.progressbarFillClass}"></span>`;
      }

      $el.html(paginationHTML);
    }

    if (params.type !== 'custom') {
      emit('paginationRender', swiper.pagination.$el[0]);
    }
  }

  function init() {
    swiper.params.pagination = create_element_if_not_defined_createElementIfNotDefined(swiper, swiper.originalParams.pagination, swiper.params.pagination, {
      el: 'swiper-pagination'
    });
    const params = swiper.params.pagination;
    if (!params.el) return;
    let $el = dom(params.el);
    if ($el.length === 0) return;

    if (swiper.params.uniqueNavElements && typeof params.el === 'string' && $el.length > 1) {
      $el = swiper.$el.find(params.el); // check if it belongs to another nested Swiper

      if ($el.length > 1) {
        $el = $el.filter(el => {
          if (dom(el).parents('.swiper')[0] !== swiper.el) return false;
          return true;
        });
      }
    }

    if (params.type === 'bullets' && params.clickable) {
      $el.addClass(params.clickableClass);
    }

    $el.addClass(params.modifierClass + params.type);
    $el.addClass(swiper.isHorizontal() ? params.horizontalClass : params.verticalClass);

    if (params.type === 'bullets' && params.dynamicBullets) {
      $el.addClass(`${params.modifierClass}${params.type}-dynamic`);
      dynamicBulletIndex = 0;

      if (params.dynamicMainBullets < 1) {
        params.dynamicMainBullets = 1;
      }
    }

    if (params.type === 'progressbar' && params.progressbarOpposite) {
      $el.addClass(params.progressbarOppositeClass);
    }

    if (params.clickable) {
      $el.on('click', classes_to_selector_classesToSelector(params.bulletClass), function onClick(e) {
        e.preventDefault();
        let index = dom(this).index() * swiper.params.slidesPerGroup;
        if (swiper.params.loop) index += swiper.loopedSlides;
        swiper.slideTo(index);
      });
    }

    Object.assign(swiper.pagination, {
      $el,
      el: $el[0]
    });

    if (!swiper.enabled) {
      $el.addClass(params.lockClass);
    }
  }

  function destroy() {
    const params = swiper.params.pagination;
    if (isPaginationDisabled()) return;
    const $el = swiper.pagination.$el;
    $el.removeClass(params.hiddenClass);
    $el.removeClass(params.modifierClass + params.type);
    $el.removeClass(swiper.isHorizontal() ? params.horizontalClass : params.verticalClass);
    if (swiper.pagination.bullets && swiper.pagination.bullets.removeClass) swiper.pagination.bullets.removeClass(params.bulletActiveClass);

    if (params.clickable) {
      $el.off('click', classes_to_selector_classesToSelector(params.bulletClass));
    }
  }

  on('init', () => {
    if (swiper.params.pagination.enabled === false) {
      // eslint-disable-next-line
      disable();
    } else {
      init();
      render();
      update();
    }
  });
  on('activeIndexChange', () => {
    if (swiper.params.loop) {
      update();
    } else if (typeof swiper.snapIndex === 'undefined') {
      update();
    }
  });
  on('snapIndexChange', () => {
    if (!swiper.params.loop) {
      update();
    }
  });
  on('slidesLengthChange', () => {
    if (swiper.params.loop) {
      render();
      update();
    }
  });
  on('snapGridLengthChange', () => {
    if (!swiper.params.loop) {
      render();
      update();
    }
  });
  on('destroy', () => {
    destroy();
  });
  on('enable disable', () => {
    const {
      $el
    } = swiper.pagination;

    if ($el) {
      $el[swiper.enabled ? 'removeClass' : 'addClass'](swiper.params.pagination.lockClass);
    }
  });
  on('lock unlock', () => {
    update();
  });
  on('click', (_s, e) => {
    const targetEl = e.target;
    const {
      $el
    } = swiper.pagination;

    if (swiper.params.pagination.el && swiper.params.pagination.hideOnClick && $el && $el.length > 0 && !dom(targetEl).hasClass(swiper.params.pagination.bulletClass)) {
      if (swiper.navigation && (swiper.navigation.nextEl && targetEl === swiper.navigation.nextEl || swiper.navigation.prevEl && targetEl === swiper.navigation.prevEl)) return;
      const isHidden = $el.hasClass(swiper.params.pagination.hiddenClass);

      if (isHidden === true) {
        emit('paginationShow');
      } else {
        emit('paginationHide');
      }

      $el.toggleClass(swiper.params.pagination.hiddenClass);
    }
  });

  const enable = () => {
    swiper.$el.removeClass(swiper.params.pagination.paginationDisabledClass);

    if (swiper.pagination.$el) {
      swiper.pagination.$el.removeClass(swiper.params.pagination.paginationDisabledClass);
    }

    init();
    render();
    update();
  };

  const disable = () => {
    swiper.$el.addClass(swiper.params.pagination.paginationDisabledClass);

    if (swiper.pagination.$el) {
      swiper.pagination.$el.addClass(swiper.params.pagination.paginationDisabledClass);
    }

    destroy();
  };

  Object.assign(swiper.pagination, {
    enable,
    disable,
    render,
    update,
    init,
    destroy
  });
}
;// CONCATENATED MODULE: ./node_modules/swiper/modules/scrollbar/scrollbar.js




function Scrollbar({
  swiper,
  extendParams,
  on,
  emit
}) {
  const document = getDocument();
  let isTouched = false;
  let timeout = null;
  let dragTimeout = null;
  let dragStartPos;
  let dragSize;
  let trackSize;
  let divider;
  extendParams({
    scrollbar: {
      el: null,
      dragSize: 'auto',
      hide: false,
      draggable: false,
      snapOnRelease: true,
      lockClass: 'swiper-scrollbar-lock',
      dragClass: 'swiper-scrollbar-drag',
      scrollbarDisabledClass: 'swiper-scrollbar-disabled',
      horizontalClass: `swiper-scrollbar-horizontal`,
      verticalClass: `swiper-scrollbar-vertical`
    }
  });
  swiper.scrollbar = {
    el: null,
    dragEl: null,
    $el: null,
    $dragEl: null
  };

  function setTranslate() {
    if (!swiper.params.scrollbar.el || !swiper.scrollbar.el) return;
    const {
      scrollbar,
      rtlTranslate: rtl,
      progress
    } = swiper;
    const {
      $dragEl,
      $el
    } = scrollbar;
    const params = swiper.params.scrollbar;
    let newSize = dragSize;
    let newPos = (trackSize - dragSize) * progress;

    if (rtl) {
      newPos = -newPos;

      if (newPos > 0) {
        newSize = dragSize - newPos;
        newPos = 0;
      } else if (-newPos + dragSize > trackSize) {
        newSize = trackSize + newPos;
      }
    } else if (newPos < 0) {
      newSize = dragSize + newPos;
      newPos = 0;
    } else if (newPos + dragSize > trackSize) {
      newSize = trackSize - newPos;
    }

    if (swiper.isHorizontal()) {
      $dragEl.transform(`translate3d(${newPos}px, 0, 0)`);
      $dragEl[0].style.width = `${newSize}px`;
    } else {
      $dragEl.transform(`translate3d(0px, ${newPos}px, 0)`);
      $dragEl[0].style.height = `${newSize}px`;
    }

    if (params.hide) {
      clearTimeout(timeout);
      $el[0].style.opacity = 1;
      timeout = setTimeout(() => {
        $el[0].style.opacity = 0;
        $el.transition(400);
      }, 1000);
    }
  }

  function setTransition(duration) {
    if (!swiper.params.scrollbar.el || !swiper.scrollbar.el) return;
    swiper.scrollbar.$dragEl.transition(duration);
  }

  function updateSize() {
    if (!swiper.params.scrollbar.el || !swiper.scrollbar.el) return;
    const {
      scrollbar
    } = swiper;
    const {
      $dragEl,
      $el
    } = scrollbar;
    $dragEl[0].style.width = '';
    $dragEl[0].style.height = '';
    trackSize = swiper.isHorizontal() ? $el[0].offsetWidth : $el[0].offsetHeight;
    divider = swiper.size / (swiper.virtualSize + swiper.params.slidesOffsetBefore - (swiper.params.centeredSlides ? swiper.snapGrid[0] : 0));

    if (swiper.params.scrollbar.dragSize === 'auto') {
      dragSize = trackSize * divider;
    } else {
      dragSize = parseInt(swiper.params.scrollbar.dragSize, 10);
    }

    if (swiper.isHorizontal()) {
      $dragEl[0].style.width = `${dragSize}px`;
    } else {
      $dragEl[0].style.height = `${dragSize}px`;
    }

    if (divider >= 1) {
      $el[0].style.display = 'none';
    } else {
      $el[0].style.display = '';
    }

    if (swiper.params.scrollbar.hide) {
      $el[0].style.opacity = 0;
    }

    if (swiper.params.watchOverflow && swiper.enabled) {
      scrollbar.$el[swiper.isLocked ? 'addClass' : 'removeClass'](swiper.params.scrollbar.lockClass);
    }
  }

  function getPointerPosition(e) {
    if (swiper.isHorizontal()) {
      return e.type === 'touchstart' || e.type === 'touchmove' ? e.targetTouches[0].clientX : e.clientX;
    }

    return e.type === 'touchstart' || e.type === 'touchmove' ? e.targetTouches[0].clientY : e.clientY;
  }

  function setDragPosition(e) {
    const {
      scrollbar,
      rtlTranslate: rtl
    } = swiper;
    const {
      $el
    } = scrollbar;
    let positionRatio;
    positionRatio = (getPointerPosition(e) - $el.offset()[swiper.isHorizontal() ? 'left' : 'top'] - (dragStartPos !== null ? dragStartPos : dragSize / 2)) / (trackSize - dragSize);
    positionRatio = Math.max(Math.min(positionRatio, 1), 0);

    if (rtl) {
      positionRatio = 1 - positionRatio;
    }

    const position = swiper.minTranslate() + (swiper.maxTranslate() - swiper.minTranslate()) * positionRatio;
    swiper.updateProgress(position);
    swiper.setTranslate(position);
    swiper.updateActiveIndex();
    swiper.updateSlidesClasses();
  }

  function onDragStart(e) {
    const params = swiper.params.scrollbar;
    const {
      scrollbar,
      $wrapperEl
    } = swiper;
    const {
      $el,
      $dragEl
    } = scrollbar;
    isTouched = true;
    dragStartPos = e.target === $dragEl[0] || e.target === $dragEl ? getPointerPosition(e) - e.target.getBoundingClientRect()[swiper.isHorizontal() ? 'left' : 'top'] : null;
    e.preventDefault();
    e.stopPropagation();
    $wrapperEl.transition(100);
    $dragEl.transition(100);
    setDragPosition(e);
    clearTimeout(dragTimeout);
    $el.transition(0);

    if (params.hide) {
      $el.css('opacity', 1);
    }

    if (swiper.params.cssMode) {
      swiper.$wrapperEl.css('scroll-snap-type', 'none');
    }

    emit('scrollbarDragStart', e);
  }

  function onDragMove(e) {
    const {
      scrollbar,
      $wrapperEl
    } = swiper;
    const {
      $el,
      $dragEl
    } = scrollbar;
    if (!isTouched) return;
    if (e.preventDefault) e.preventDefault();else e.returnValue = false;
    setDragPosition(e);
    $wrapperEl.transition(0);
    $el.transition(0);
    $dragEl.transition(0);
    emit('scrollbarDragMove', e);
  }

  function onDragEnd(e) {
    const params = swiper.params.scrollbar;
    const {
      scrollbar,
      $wrapperEl
    } = swiper;
    const {
      $el
    } = scrollbar;
    if (!isTouched) return;
    isTouched = false;

    if (swiper.params.cssMode) {
      swiper.$wrapperEl.css('scroll-snap-type', '');
      $wrapperEl.transition('');
    }

    if (params.hide) {
      clearTimeout(dragTimeout);
      dragTimeout = nextTick(() => {
        $el.css('opacity', 0);
        $el.transition(400);
      }, 1000);
    }

    emit('scrollbarDragEnd', e);

    if (params.snapOnRelease) {
      swiper.slideToClosest();
    }
  }

  function events(method) {
    const {
      scrollbar,
      touchEventsTouch,
      touchEventsDesktop,
      params,
      support
    } = swiper;
    const $el = scrollbar.$el;
    if (!$el) return;
    const target = $el[0];
    const activeListener = support.passiveListener && params.passiveListeners ? {
      passive: false,
      capture: false
    } : false;
    const passiveListener = support.passiveListener && params.passiveListeners ? {
      passive: true,
      capture: false
    } : false;
    if (!target) return;
    const eventMethod = method === 'on' ? 'addEventListener' : 'removeEventListener';

    if (!support.touch) {
      target[eventMethod](touchEventsDesktop.start, onDragStart, activeListener);
      document[eventMethod](touchEventsDesktop.move, onDragMove, activeListener);
      document[eventMethod](touchEventsDesktop.end, onDragEnd, passiveListener);
    } else {
      target[eventMethod](touchEventsTouch.start, onDragStart, activeListener);
      target[eventMethod](touchEventsTouch.move, onDragMove, activeListener);
      target[eventMethod](touchEventsTouch.end, onDragEnd, passiveListener);
    }
  }

  function enableDraggable() {
    if (!swiper.params.scrollbar.el || !swiper.scrollbar.el) return;
    events('on');
  }

  function disableDraggable() {
    if (!swiper.params.scrollbar.el || !swiper.scrollbar.el) return;
    events('off');
  }

  function init() {
    const {
      scrollbar,
      $el: $swiperEl
    } = swiper;
    swiper.params.scrollbar = createElementIfNotDefined(swiper, swiper.originalParams.scrollbar, swiper.params.scrollbar, {
      el: 'swiper-scrollbar'
    });
    const params = swiper.params.scrollbar;
    if (!params.el) return;
    let $el = $(params.el);

    if (swiper.params.uniqueNavElements && typeof params.el === 'string' && $el.length > 1 && $swiperEl.find(params.el).length === 1) {
      $el = $swiperEl.find(params.el);
    }

    $el.addClass(swiper.isHorizontal() ? params.horizontalClass : params.verticalClass);
    let $dragEl = $el.find(`.${swiper.params.scrollbar.dragClass}`);

    if ($dragEl.length === 0) {
      $dragEl = $(`<div class="${swiper.params.scrollbar.dragClass}"></div>`);
      $el.append($dragEl);
    }

    Object.assign(scrollbar, {
      $el,
      el: $el[0],
      $dragEl,
      dragEl: $dragEl[0]
    });

    if (params.draggable) {
      enableDraggable();
    }

    if ($el) {
      $el[swiper.enabled ? 'removeClass' : 'addClass'](swiper.params.scrollbar.lockClass);
    }
  }

  function destroy() {
    const params = swiper.params.scrollbar;
    const $el = swiper.scrollbar.$el;

    if ($el) {
      $el.removeClass(swiper.isHorizontal() ? params.horizontalClass : params.verticalClass);
    }

    disableDraggable();
  }

  on('init', () => {
    if (swiper.params.scrollbar.enabled === false) {
      // eslint-disable-next-line
      disable();
    } else {
      init();
      updateSize();
      setTranslate();
    }
  });
  on('update resize observerUpdate lock unlock', () => {
    updateSize();
  });
  on('setTranslate', () => {
    setTranslate();
  });
  on('setTransition', (_s, duration) => {
    setTransition(duration);
  });
  on('enable disable', () => {
    const {
      $el
    } = swiper.scrollbar;

    if ($el) {
      $el[swiper.enabled ? 'removeClass' : 'addClass'](swiper.params.scrollbar.lockClass);
    }
  });
  on('destroy', () => {
    destroy();
  });

  const enable = () => {
    swiper.$el.removeClass(swiper.params.scrollbar.scrollbarDisabledClass);

    if (swiper.scrollbar.$el) {
      swiper.scrollbar.$el.removeClass(swiper.params.scrollbar.scrollbarDisabledClass);
    }

    init();
    updateSize();
    setTranslate();
  };

  const disable = () => {
    swiper.$el.addClass(swiper.params.scrollbar.scrollbarDisabledClass);

    if (swiper.scrollbar.$el) {
      swiper.scrollbar.$el.addClass(swiper.params.scrollbar.scrollbarDisabledClass);
    }

    destroy();
  };

  Object.assign(swiper.scrollbar, {
    enable,
    disable,
    updateSize,
    setTranslate,
    init,
    destroy
  });
}
;// CONCATENATED MODULE: ./node_modules/swiper/modules/parallax/parallax.js

function Parallax({
  swiper,
  extendParams,
  on
}) {
  extendParams({
    parallax: {
      enabled: false
    }
  });

  const setTransform = (el, progress) => {
    const {
      rtl
    } = swiper;
    const $el = $(el);
    const rtlFactor = rtl ? -1 : 1;
    const p = $el.attr('data-swiper-parallax') || '0';
    let x = $el.attr('data-swiper-parallax-x');
    let y = $el.attr('data-swiper-parallax-y');
    const scale = $el.attr('data-swiper-parallax-scale');
    const opacity = $el.attr('data-swiper-parallax-opacity');

    if (x || y) {
      x = x || '0';
      y = y || '0';
    } else if (swiper.isHorizontal()) {
      x = p;
      y = '0';
    } else {
      y = p;
      x = '0';
    }

    if (x.indexOf('%') >= 0) {
      x = `${parseInt(x, 10) * progress * rtlFactor}%`;
    } else {
      x = `${x * progress * rtlFactor}px`;
    }

    if (y.indexOf('%') >= 0) {
      y = `${parseInt(y, 10) * progress}%`;
    } else {
      y = `${y * progress}px`;
    }

    if (typeof opacity !== 'undefined' && opacity !== null) {
      const currentOpacity = opacity - (opacity - 1) * (1 - Math.abs(progress));
      $el[0].style.opacity = currentOpacity;
    }

    if (typeof scale === 'undefined' || scale === null) {
      $el.transform(`translate3d(${x}, ${y}, 0px)`);
    } else {
      const currentScale = scale - (scale - 1) * (1 - Math.abs(progress));
      $el.transform(`translate3d(${x}, ${y}, 0px) scale(${currentScale})`);
    }
  };

  const setTranslate = () => {
    const {
      $el,
      slides,
      progress,
      snapGrid
    } = swiper;
    $el.children('[data-swiper-parallax], [data-swiper-parallax-x], [data-swiper-parallax-y], [data-swiper-parallax-opacity], [data-swiper-parallax-scale]').each(el => {
      setTransform(el, progress);
    });
    slides.each((slideEl, slideIndex) => {
      let slideProgress = slideEl.progress;

      if (swiper.params.slidesPerGroup > 1 && swiper.params.slidesPerView !== 'auto') {
        slideProgress += Math.ceil(slideIndex / 2) - progress * (snapGrid.length - 1);
      }

      slideProgress = Math.min(Math.max(slideProgress, -1), 1);
      $(slideEl).find('[data-swiper-parallax], [data-swiper-parallax-x], [data-swiper-parallax-y], [data-swiper-parallax-opacity], [data-swiper-parallax-scale]').each(el => {
        setTransform(el, slideProgress);
      });
    });
  };

  const setTransition = (duration = swiper.params.speed) => {
    const {
      $el
    } = swiper;
    $el.find('[data-swiper-parallax], [data-swiper-parallax-x], [data-swiper-parallax-y], [data-swiper-parallax-opacity], [data-swiper-parallax-scale]').each(parallaxEl => {
      const $parallaxEl = $(parallaxEl);
      let parallaxDuration = parseInt($parallaxEl.attr('data-swiper-parallax-duration'), 10) || duration;
      if (duration === 0) parallaxDuration = 0;
      $parallaxEl.transition(parallaxDuration);
    });
  };

  on('beforeInit', () => {
    if (!swiper.params.parallax.enabled) return;
    swiper.params.watchSlidesProgress = true;
    swiper.originalParams.watchSlidesProgress = true;
  });
  on('init', () => {
    if (!swiper.params.parallax.enabled) return;
    setTranslate();
  });
  on('setTranslate', () => {
    if (!swiper.params.parallax.enabled) return;
    setTranslate();
  });
  on('setTransition', (_swiper, duration) => {
    if (!swiper.params.parallax.enabled) return;
    setTransition(duration);
  });
}
;// CONCATENATED MODULE: ./node_modules/swiper/modules/zoom/zoom.js



function Zoom({
  swiper,
  extendParams,
  on,
  emit
}) {
  const window = getWindow();
  extendParams({
    zoom: {
      enabled: false,
      maxRatio: 3,
      minRatio: 1,
      toggle: true,
      containerClass: 'swiper-zoom-container',
      zoomedSlideClass: 'swiper-slide-zoomed'
    }
  });
  swiper.zoom = {
    enabled: false
  };
  let currentScale = 1;
  let isScaling = false;
  let gesturesEnabled;
  let fakeGestureTouched;
  let fakeGestureMoved;
  const gesture = {
    $slideEl: undefined,
    slideWidth: undefined,
    slideHeight: undefined,
    $imageEl: undefined,
    $imageWrapEl: undefined,
    maxRatio: 3
  };
  const image = {
    isTouched: undefined,
    isMoved: undefined,
    currentX: undefined,
    currentY: undefined,
    minX: undefined,
    minY: undefined,
    maxX: undefined,
    maxY: undefined,
    width: undefined,
    height: undefined,
    startX: undefined,
    startY: undefined,
    touchesStart: {},
    touchesCurrent: {}
  };
  const velocity = {
    x: undefined,
    y: undefined,
    prevPositionX: undefined,
    prevPositionY: undefined,
    prevTime: undefined
  };
  let scale = 1;
  Object.defineProperty(swiper.zoom, 'scale', {
    get() {
      return scale;
    },

    set(value) {
      if (scale !== value) {
        const imageEl = gesture.$imageEl ? gesture.$imageEl[0] : undefined;
        const slideEl = gesture.$slideEl ? gesture.$slideEl[0] : undefined;
        emit('zoomChange', value, imageEl, slideEl);
      }

      scale = value;
    }

  });

  function getDistanceBetweenTouches(e) {
    if (e.targetTouches.length < 2) return 1;
    const x1 = e.targetTouches[0].pageX;
    const y1 = e.targetTouches[0].pageY;
    const x2 = e.targetTouches[1].pageX;
    const y2 = e.targetTouches[1].pageY;
    const distance = Math.sqrt((x2 - x1) ** 2 + (y2 - y1) ** 2);
    return distance;
  } // Events


  function onGestureStart(e) {
    const support = swiper.support;
    const params = swiper.params.zoom;
    fakeGestureTouched = false;
    fakeGestureMoved = false;

    if (!support.gestures) {
      if (e.type !== 'touchstart' || e.type === 'touchstart' && e.targetTouches.length < 2) {
        return;
      }

      fakeGestureTouched = true;
      gesture.scaleStart = getDistanceBetweenTouches(e);
    }

    if (!gesture.$slideEl || !gesture.$slideEl.length) {
      gesture.$slideEl = $(e.target).closest(`.${swiper.params.slideClass}`);
      if (gesture.$slideEl.length === 0) gesture.$slideEl = swiper.slides.eq(swiper.activeIndex);
      gesture.$imageEl = gesture.$slideEl.find(`.${params.containerClass}`).eq(0).find('picture, img, svg, canvas, .swiper-zoom-target').eq(0);
      gesture.$imageWrapEl = gesture.$imageEl.parent(`.${params.containerClass}`);
      gesture.maxRatio = gesture.$imageWrapEl.attr('data-swiper-zoom') || params.maxRatio;

      if (gesture.$imageWrapEl.length === 0) {
        gesture.$imageEl = undefined;
        return;
      }
    }

    if (gesture.$imageEl) {
      gesture.$imageEl.transition(0);
    }

    isScaling = true;
  }

  function onGestureChange(e) {
    const support = swiper.support;
    const params = swiper.params.zoom;
    const zoom = swiper.zoom;

    if (!support.gestures) {
      if (e.type !== 'touchmove' || e.type === 'touchmove' && e.targetTouches.length < 2) {
        return;
      }

      fakeGestureMoved = true;
      gesture.scaleMove = getDistanceBetweenTouches(e);
    }

    if (!gesture.$imageEl || gesture.$imageEl.length === 0) {
      if (e.type === 'gesturechange') onGestureStart(e);
      return;
    }

    if (support.gestures) {
      zoom.scale = e.scale * currentScale;
    } else {
      zoom.scale = gesture.scaleMove / gesture.scaleStart * currentScale;
    }

    if (zoom.scale > gesture.maxRatio) {
      zoom.scale = gesture.maxRatio - 1 + (zoom.scale - gesture.maxRatio + 1) ** 0.5;
    }

    if (zoom.scale < params.minRatio) {
      zoom.scale = params.minRatio + 1 - (params.minRatio - zoom.scale + 1) ** 0.5;
    }

    gesture.$imageEl.transform(`translate3d(0,0,0) scale(${zoom.scale})`);
  }

  function onGestureEnd(e) {
    const device = swiper.device;
    const support = swiper.support;
    const params = swiper.params.zoom;
    const zoom = swiper.zoom;

    if (!support.gestures) {
      if (!fakeGestureTouched || !fakeGestureMoved) {
        return;
      }

      if (e.type !== 'touchend' || e.type === 'touchend' && e.changedTouches.length < 2 && !device.android) {
        return;
      }

      fakeGestureTouched = false;
      fakeGestureMoved = false;
    }

    if (!gesture.$imageEl || gesture.$imageEl.length === 0) return;
    zoom.scale = Math.max(Math.min(zoom.scale, gesture.maxRatio), params.minRatio);
    gesture.$imageEl.transition(swiper.params.speed).transform(`translate3d(0,0,0) scale(${zoom.scale})`);
    currentScale = zoom.scale;
    isScaling = false;
    if (zoom.scale === 1) gesture.$slideEl = undefined;
  }

  function onTouchStart(e) {
    const device = swiper.device;
    if (!gesture.$imageEl || gesture.$imageEl.length === 0) return;
    if (image.isTouched) return;
    if (device.android && e.cancelable) e.preventDefault();
    image.isTouched = true;
    image.touchesStart.x = e.type === 'touchstart' ? e.targetTouches[0].pageX : e.pageX;
    image.touchesStart.y = e.type === 'touchstart' ? e.targetTouches[0].pageY : e.pageY;
  }

  function onTouchMove(e) {
    const zoom = swiper.zoom;
    if (!gesture.$imageEl || gesture.$imageEl.length === 0) return;
    swiper.allowClick = false;
    if (!image.isTouched || !gesture.$slideEl) return;

    if (!image.isMoved) {
      image.width = gesture.$imageEl[0].offsetWidth;
      image.height = gesture.$imageEl[0].offsetHeight;
      image.startX = getTranslate(gesture.$imageWrapEl[0], 'x') || 0;
      image.startY = getTranslate(gesture.$imageWrapEl[0], 'y') || 0;
      gesture.slideWidth = gesture.$slideEl[0].offsetWidth;
      gesture.slideHeight = gesture.$slideEl[0].offsetHeight;
      gesture.$imageWrapEl.transition(0);
    } // Define if we need image drag


    const scaledWidth = image.width * zoom.scale;
    const scaledHeight = image.height * zoom.scale;
    if (scaledWidth < gesture.slideWidth && scaledHeight < gesture.slideHeight) return;
    image.minX = Math.min(gesture.slideWidth / 2 - scaledWidth / 2, 0);
    image.maxX = -image.minX;
    image.minY = Math.min(gesture.slideHeight / 2 - scaledHeight / 2, 0);
    image.maxY = -image.minY;
    image.touchesCurrent.x = e.type === 'touchmove' ? e.targetTouches[0].pageX : e.pageX;
    image.touchesCurrent.y = e.type === 'touchmove' ? e.targetTouches[0].pageY : e.pageY;

    if (!image.isMoved && !isScaling) {
      if (swiper.isHorizontal() && (Math.floor(image.minX) === Math.floor(image.startX) && image.touchesCurrent.x < image.touchesStart.x || Math.floor(image.maxX) === Math.floor(image.startX) && image.touchesCurrent.x > image.touchesStart.x)) {
        image.isTouched = false;
        return;
      }

      if (!swiper.isHorizontal() && (Math.floor(image.minY) === Math.floor(image.startY) && image.touchesCurrent.y < image.touchesStart.y || Math.floor(image.maxY) === Math.floor(image.startY) && image.touchesCurrent.y > image.touchesStart.y)) {
        image.isTouched = false;
        return;
      }
    }

    if (e.cancelable) {
      e.preventDefault();
    }

    e.stopPropagation();
    image.isMoved = true;
    image.currentX = image.touchesCurrent.x - image.touchesStart.x + image.startX;
    image.currentY = image.touchesCurrent.y - image.touchesStart.y + image.startY;

    if (image.currentX < image.minX) {
      image.currentX = image.minX + 1 - (image.minX - image.currentX + 1) ** 0.8;
    }

    if (image.currentX > image.maxX) {
      image.currentX = image.maxX - 1 + (image.currentX - image.maxX + 1) ** 0.8;
    }

    if (image.currentY < image.minY) {
      image.currentY = image.minY + 1 - (image.minY - image.currentY + 1) ** 0.8;
    }

    if (image.currentY > image.maxY) {
      image.currentY = image.maxY - 1 + (image.currentY - image.maxY + 1) ** 0.8;
    } // Velocity


    if (!velocity.prevPositionX) velocity.prevPositionX = image.touchesCurrent.x;
    if (!velocity.prevPositionY) velocity.prevPositionY = image.touchesCurrent.y;
    if (!velocity.prevTime) velocity.prevTime = Date.now();
    velocity.x = (image.touchesCurrent.x - velocity.prevPositionX) / (Date.now() - velocity.prevTime) / 2;
    velocity.y = (image.touchesCurrent.y - velocity.prevPositionY) / (Date.now() - velocity.prevTime) / 2;
    if (Math.abs(image.touchesCurrent.x - velocity.prevPositionX) < 2) velocity.x = 0;
    if (Math.abs(image.touchesCurrent.y - velocity.prevPositionY) < 2) velocity.y = 0;
    velocity.prevPositionX = image.touchesCurrent.x;
    velocity.prevPositionY = image.touchesCurrent.y;
    velocity.prevTime = Date.now();
    gesture.$imageWrapEl.transform(`translate3d(${image.currentX}px, ${image.currentY}px,0)`);
  }

  function onTouchEnd() {
    const zoom = swiper.zoom;
    if (!gesture.$imageEl || gesture.$imageEl.length === 0) return;

    if (!image.isTouched || !image.isMoved) {
      image.isTouched = false;
      image.isMoved = false;
      return;
    }

    image.isTouched = false;
    image.isMoved = false;
    let momentumDurationX = 300;
    let momentumDurationY = 300;
    const momentumDistanceX = velocity.x * momentumDurationX;
    const newPositionX = image.currentX + momentumDistanceX;
    const momentumDistanceY = velocity.y * momentumDurationY;
    const newPositionY = image.currentY + momentumDistanceY; // Fix duration

    if (velocity.x !== 0) momentumDurationX = Math.abs((newPositionX - image.currentX) / velocity.x);
    if (velocity.y !== 0) momentumDurationY = Math.abs((newPositionY - image.currentY) / velocity.y);
    const momentumDuration = Math.max(momentumDurationX, momentumDurationY);
    image.currentX = newPositionX;
    image.currentY = newPositionY; // Define if we need image drag

    const scaledWidth = image.width * zoom.scale;
    const scaledHeight = image.height * zoom.scale;
    image.minX = Math.min(gesture.slideWidth / 2 - scaledWidth / 2, 0);
    image.maxX = -image.minX;
    image.minY = Math.min(gesture.slideHeight / 2 - scaledHeight / 2, 0);
    image.maxY = -image.minY;
    image.currentX = Math.max(Math.min(image.currentX, image.maxX), image.minX);
    image.currentY = Math.max(Math.min(image.currentY, image.maxY), image.minY);
    gesture.$imageWrapEl.transition(momentumDuration).transform(`translate3d(${image.currentX}px, ${image.currentY}px,0)`);
  }

  function onTransitionEnd() {
    const zoom = swiper.zoom;

    if (gesture.$slideEl && swiper.previousIndex !== swiper.activeIndex) {
      if (gesture.$imageEl) {
        gesture.$imageEl.transform('translate3d(0,0,0) scale(1)');
      }

      if (gesture.$imageWrapEl) {
        gesture.$imageWrapEl.transform('translate3d(0,0,0)');
      }

      zoom.scale = 1;
      currentScale = 1;
      gesture.$slideEl = undefined;
      gesture.$imageEl = undefined;
      gesture.$imageWrapEl = undefined;
    }
  }

  function zoomIn(e) {
    const zoom = swiper.zoom;
    const params = swiper.params.zoom;

    if (!gesture.$slideEl) {
      if (e && e.target) {
        gesture.$slideEl = $(e.target).closest(`.${swiper.params.slideClass}`);
      }

      if (!gesture.$slideEl) {
        if (swiper.params.virtual && swiper.params.virtual.enabled && swiper.virtual) {
          gesture.$slideEl = swiper.$wrapperEl.children(`.${swiper.params.slideActiveClass}`);
        } else {
          gesture.$slideEl = swiper.slides.eq(swiper.activeIndex);
        }
      }

      gesture.$imageEl = gesture.$slideEl.find(`.${params.containerClass}`).eq(0).find('picture, img, svg, canvas, .swiper-zoom-target').eq(0);
      gesture.$imageWrapEl = gesture.$imageEl.parent(`.${params.containerClass}`);
    }

    if (!gesture.$imageEl || gesture.$imageEl.length === 0 || !gesture.$imageWrapEl || gesture.$imageWrapEl.length === 0) return;

    if (swiper.params.cssMode) {
      swiper.wrapperEl.style.overflow = 'hidden';
      swiper.wrapperEl.style.touchAction = 'none';
    }

    gesture.$slideEl.addClass(`${params.zoomedSlideClass}`);
    let touchX;
    let touchY;
    let offsetX;
    let offsetY;
    let diffX;
    let diffY;
    let translateX;
    let translateY;
    let imageWidth;
    let imageHeight;
    let scaledWidth;
    let scaledHeight;
    let translateMinX;
    let translateMinY;
    let translateMaxX;
    let translateMaxY;
    let slideWidth;
    let slideHeight;

    if (typeof image.touchesStart.x === 'undefined' && e) {
      touchX = e.type === 'touchend' ? e.changedTouches[0].pageX : e.pageX;
      touchY = e.type === 'touchend' ? e.changedTouches[0].pageY : e.pageY;
    } else {
      touchX = image.touchesStart.x;
      touchY = image.touchesStart.y;
    }

    zoom.scale = gesture.$imageWrapEl.attr('data-swiper-zoom') || params.maxRatio;
    currentScale = gesture.$imageWrapEl.attr('data-swiper-zoom') || params.maxRatio;

    if (e) {
      slideWidth = gesture.$slideEl[0].offsetWidth;
      slideHeight = gesture.$slideEl[0].offsetHeight;
      offsetX = gesture.$slideEl.offset().left + window.scrollX;
      offsetY = gesture.$slideEl.offset().top + window.scrollY;
      diffX = offsetX + slideWidth / 2 - touchX;
      diffY = offsetY + slideHeight / 2 - touchY;
      imageWidth = gesture.$imageEl[0].offsetWidth;
      imageHeight = gesture.$imageEl[0].offsetHeight;
      scaledWidth = imageWidth * zoom.scale;
      scaledHeight = imageHeight * zoom.scale;
      translateMinX = Math.min(slideWidth / 2 - scaledWidth / 2, 0);
      translateMinY = Math.min(slideHeight / 2 - scaledHeight / 2, 0);
      translateMaxX = -translateMinX;
      translateMaxY = -translateMinY;
      translateX = diffX * zoom.scale;
      translateY = diffY * zoom.scale;

      if (translateX < translateMinX) {
        translateX = translateMinX;
      }

      if (translateX > translateMaxX) {
        translateX = translateMaxX;
      }

      if (translateY < translateMinY) {
        translateY = translateMinY;
      }

      if (translateY > translateMaxY) {
        translateY = translateMaxY;
      }
    } else {
      translateX = 0;
      translateY = 0;
    }

    gesture.$imageWrapEl.transition(300).transform(`translate3d(${translateX}px, ${translateY}px,0)`);
    gesture.$imageEl.transition(300).transform(`translate3d(0,0,0) scale(${zoom.scale})`);
  }

  function zoomOut() {
    const zoom = swiper.zoom;
    const params = swiper.params.zoom;

    if (!gesture.$slideEl) {
      if (swiper.params.virtual && swiper.params.virtual.enabled && swiper.virtual) {
        gesture.$slideEl = swiper.$wrapperEl.children(`.${swiper.params.slideActiveClass}`);
      } else {
        gesture.$slideEl = swiper.slides.eq(swiper.activeIndex);
      }

      gesture.$imageEl = gesture.$slideEl.find(`.${params.containerClass}`).eq(0).find('picture, img, svg, canvas, .swiper-zoom-target').eq(0);
      gesture.$imageWrapEl = gesture.$imageEl.parent(`.${params.containerClass}`);
    }

    if (!gesture.$imageEl || gesture.$imageEl.length === 0 || !gesture.$imageWrapEl || gesture.$imageWrapEl.length === 0) return;

    if (swiper.params.cssMode) {
      swiper.wrapperEl.style.overflow = '';
      swiper.wrapperEl.style.touchAction = '';
    }

    zoom.scale = 1;
    currentScale = 1;
    gesture.$imageWrapEl.transition(300).transform('translate3d(0,0,0)');
    gesture.$imageEl.transition(300).transform('translate3d(0,0,0) scale(1)');
    gesture.$slideEl.removeClass(`${params.zoomedSlideClass}`);
    gesture.$slideEl = undefined;
  } // Toggle Zoom


  function zoomToggle(e) {
    const zoom = swiper.zoom;

    if (zoom.scale && zoom.scale !== 1) {
      // Zoom Out
      zoomOut();
    } else {
      // Zoom In
      zoomIn(e);
    }
  }

  function getListeners() {
    const support = swiper.support;
    const passiveListener = swiper.touchEvents.start === 'touchstart' && support.passiveListener && swiper.params.passiveListeners ? {
      passive: true,
      capture: false
    } : false;
    const activeListenerWithCapture = support.passiveListener ? {
      passive: false,
      capture: true
    } : true;
    return {
      passiveListener,
      activeListenerWithCapture
    };
  }

  function getSlideSelector() {
    return `.${swiper.params.slideClass}`;
  }

  function toggleGestures(method) {
    const {
      passiveListener
    } = getListeners();
    const slideSelector = getSlideSelector();
    swiper.$wrapperEl[method]('gesturestart', slideSelector, onGestureStart, passiveListener);
    swiper.$wrapperEl[method]('gesturechange', slideSelector, onGestureChange, passiveListener);
    swiper.$wrapperEl[method]('gestureend', slideSelector, onGestureEnd, passiveListener);
  }

  function enableGestures() {
    if (gesturesEnabled) return;
    gesturesEnabled = true;
    toggleGestures('on');
  }

  function disableGestures() {
    if (!gesturesEnabled) return;
    gesturesEnabled = false;
    toggleGestures('off');
  } // Attach/Detach Events


  function enable() {
    const zoom = swiper.zoom;
    if (zoom.enabled) return;
    zoom.enabled = true;
    const support = swiper.support;
    const {
      passiveListener,
      activeListenerWithCapture
    } = getListeners();
    const slideSelector = getSlideSelector(); // Scale image

    if (support.gestures) {
      swiper.$wrapperEl.on(swiper.touchEvents.start, enableGestures, passiveListener);
      swiper.$wrapperEl.on(swiper.touchEvents.end, disableGestures, passiveListener);
    } else if (swiper.touchEvents.start === 'touchstart') {
      swiper.$wrapperEl.on(swiper.touchEvents.start, slideSelector, onGestureStart, passiveListener);
      swiper.$wrapperEl.on(swiper.touchEvents.move, slideSelector, onGestureChange, activeListenerWithCapture);
      swiper.$wrapperEl.on(swiper.touchEvents.end, slideSelector, onGestureEnd, passiveListener);

      if (swiper.touchEvents.cancel) {
        swiper.$wrapperEl.on(swiper.touchEvents.cancel, slideSelector, onGestureEnd, passiveListener);
      }
    } // Move image


    swiper.$wrapperEl.on(swiper.touchEvents.move, `.${swiper.params.zoom.containerClass}`, onTouchMove, activeListenerWithCapture);
  }

  function disable() {
    const zoom = swiper.zoom;
    if (!zoom.enabled) return;
    const support = swiper.support;
    zoom.enabled = false;
    const {
      passiveListener,
      activeListenerWithCapture
    } = getListeners();
    const slideSelector = getSlideSelector(); // Scale image

    if (support.gestures) {
      swiper.$wrapperEl.off(swiper.touchEvents.start, enableGestures, passiveListener);
      swiper.$wrapperEl.off(swiper.touchEvents.end, disableGestures, passiveListener);
    } else if (swiper.touchEvents.start === 'touchstart') {
      swiper.$wrapperEl.off(swiper.touchEvents.start, slideSelector, onGestureStart, passiveListener);
      swiper.$wrapperEl.off(swiper.touchEvents.move, slideSelector, onGestureChange, activeListenerWithCapture);
      swiper.$wrapperEl.off(swiper.touchEvents.end, slideSelector, onGestureEnd, passiveListener);

      if (swiper.touchEvents.cancel) {
        swiper.$wrapperEl.off(swiper.touchEvents.cancel, slideSelector, onGestureEnd, passiveListener);
      }
    } // Move image


    swiper.$wrapperEl.off(swiper.touchEvents.move, `.${swiper.params.zoom.containerClass}`, onTouchMove, activeListenerWithCapture);
  }

  on('init', () => {
    if (swiper.params.zoom.enabled) {
      enable();
    }
  });
  on('destroy', () => {
    disable();
  });
  on('touchStart', (_s, e) => {
    if (!swiper.zoom.enabled) return;
    onTouchStart(e);
  });
  on('touchEnd', (_s, e) => {
    if (!swiper.zoom.enabled) return;
    onTouchEnd(e);
  });
  on('doubleTap', (_s, e) => {
    if (!swiper.animating && swiper.params.zoom.enabled && swiper.zoom.enabled && swiper.params.zoom.toggle) {
      zoomToggle(e);
    }
  });
  on('transitionEnd', () => {
    if (swiper.zoom.enabled && swiper.params.zoom.enabled) {
      onTransitionEnd();
    }
  });
  on('slideChange', () => {
    if (swiper.zoom.enabled && swiper.params.zoom.enabled && swiper.params.cssMode) {
      onTransitionEnd();
    }
  });
  Object.assign(swiper.zoom, {
    enable,
    disable,
    in: zoomIn,
    out: zoomOut,
    toggle: zoomToggle
  });
}
;// CONCATENATED MODULE: ./node_modules/swiper/modules/lazy/lazy.js


function Lazy({
  swiper,
  extendParams,
  on,
  emit
}) {
  extendParams({
    lazy: {
      checkInView: false,
      enabled: false,
      loadPrevNext: false,
      loadPrevNextAmount: 1,
      loadOnTransitionStart: false,
      scrollingElement: '',
      elementClass: 'swiper-lazy',
      loadingClass: 'swiper-lazy-loading',
      loadedClass: 'swiper-lazy-loaded',
      preloaderClass: 'swiper-lazy-preloader'
    }
  });
  swiper.lazy = {};
  let scrollHandlerAttached = false;
  let initialImageLoaded = false;

  function loadInSlide(index, loadInDuplicate = true) {
    const params = swiper.params.lazy;
    if (typeof index === 'undefined') return;
    if (swiper.slides.length === 0) return;
    const isVirtual = swiper.virtual && swiper.params.virtual.enabled;
    const $slideEl = isVirtual ? swiper.$wrapperEl.children(`.${swiper.params.slideClass}[data-swiper-slide-index="${index}"]`) : swiper.slides.eq(index);
    const $images = $slideEl.find(`.${params.elementClass}:not(.${params.loadedClass}):not(.${params.loadingClass})`);

    if ($slideEl.hasClass(params.elementClass) && !$slideEl.hasClass(params.loadedClass) && !$slideEl.hasClass(params.loadingClass)) {
      $images.push($slideEl[0]);
    }

    if ($images.length === 0) return;
    $images.each(imageEl => {
      const $imageEl = $(imageEl);
      $imageEl.addClass(params.loadingClass);
      const background = $imageEl.attr('data-background');
      const src = $imageEl.attr('data-src');
      const srcset = $imageEl.attr('data-srcset');
      const sizes = $imageEl.attr('data-sizes');
      const $pictureEl = $imageEl.parent('picture');
      swiper.loadImage($imageEl[0], src || background, srcset, sizes, false, () => {
        if (typeof swiper === 'undefined' || swiper === null || !swiper || swiper && !swiper.params || swiper.destroyed) return;

        if (background) {
          $imageEl.css('background-image', `url("${background}")`);
          $imageEl.removeAttr('data-background');
        } else {
          if (srcset) {
            $imageEl.attr('srcset', srcset);
            $imageEl.removeAttr('data-srcset');
          }

          if (sizes) {
            $imageEl.attr('sizes', sizes);
            $imageEl.removeAttr('data-sizes');
          }

          if ($pictureEl.length) {
            $pictureEl.children('source').each(sourceEl => {
              const $source = $(sourceEl);

              if ($source.attr('data-srcset')) {
                $source.attr('srcset', $source.attr('data-srcset'));
                $source.removeAttr('data-srcset');
              }
            });
          }

          if (src) {
            $imageEl.attr('src', src);
            $imageEl.removeAttr('data-src');
          }
        }

        $imageEl.addClass(params.loadedClass).removeClass(params.loadingClass);
        $slideEl.find(`.${params.preloaderClass}`).remove();

        if (swiper.params.loop && loadInDuplicate) {
          const slideOriginalIndex = $slideEl.attr('data-swiper-slide-index');

          if ($slideEl.hasClass(swiper.params.slideDuplicateClass)) {
            const originalSlide = swiper.$wrapperEl.children(`[data-swiper-slide-index="${slideOriginalIndex}"]:not(.${swiper.params.slideDuplicateClass})`);
            loadInSlide(originalSlide.index(), false);
          } else {
            const duplicatedSlide = swiper.$wrapperEl.children(`.${swiper.params.slideDuplicateClass}[data-swiper-slide-index="${slideOriginalIndex}"]`);
            loadInSlide(duplicatedSlide.index(), false);
          }
        }

        emit('lazyImageReady', $slideEl[0], $imageEl[0]);

        if (swiper.params.autoHeight) {
          swiper.updateAutoHeight();
        }
      });
      emit('lazyImageLoad', $slideEl[0], $imageEl[0]);
    });
  }

  function load() {
    const {
      $wrapperEl,
      params: swiperParams,
      slides,
      activeIndex
    } = swiper;
    const isVirtual = swiper.virtual && swiperParams.virtual.enabled;
    const params = swiperParams.lazy;
    let slidesPerView = swiperParams.slidesPerView;

    if (slidesPerView === 'auto') {
      slidesPerView = 0;
    }

    function slideExist(index) {
      if (isVirtual) {
        if ($wrapperEl.children(`.${swiperParams.slideClass}[data-swiper-slide-index="${index}"]`).length) {
          return true;
        }
      } else if (slides[index]) return true;

      return false;
    }

    function slideIndex(slideEl) {
      if (isVirtual) {
        return $(slideEl).attr('data-swiper-slide-index');
      }

      return $(slideEl).index();
    }

    if (!initialImageLoaded) initialImageLoaded = true;

    if (swiper.params.watchSlidesProgress) {
      $wrapperEl.children(`.${swiperParams.slideVisibleClass}`).each(slideEl => {
        const index = isVirtual ? $(slideEl).attr('data-swiper-slide-index') : $(slideEl).index();
        loadInSlide(index);
      });
    } else if (slidesPerView > 1) {
      for (let i = activeIndex; i < activeIndex + slidesPerView; i += 1) {
        if (slideExist(i)) loadInSlide(i);
      }
    } else {
      loadInSlide(activeIndex);
    }

    if (params.loadPrevNext) {
      if (slidesPerView > 1 || params.loadPrevNextAmount && params.loadPrevNextAmount > 1) {
        const amount = params.loadPrevNextAmount;
        const spv = Math.ceil(slidesPerView);
        const maxIndex = Math.min(activeIndex + spv + Math.max(amount, spv), slides.length);
        const minIndex = Math.max(activeIndex - Math.max(spv, amount), 0); // Next Slides

        for (let i = activeIndex + spv; i < maxIndex; i += 1) {
          if (slideExist(i)) loadInSlide(i);
        } // Prev Slides


        for (let i = minIndex; i < activeIndex; i += 1) {
          if (slideExist(i)) loadInSlide(i);
        }
      } else {
        const nextSlide = $wrapperEl.children(`.${swiperParams.slideNextClass}`);
        if (nextSlide.length > 0) loadInSlide(slideIndex(nextSlide));
        const prevSlide = $wrapperEl.children(`.${swiperParams.slidePrevClass}`);
        if (prevSlide.length > 0) loadInSlide(slideIndex(prevSlide));
      }
    }
  }

  function checkInViewOnLoad() {
    const window = getWindow();
    if (!swiper || swiper.destroyed) return;
    const $scrollElement = swiper.params.lazy.scrollingElement ? $(swiper.params.lazy.scrollingElement) : $(window);
    const isWindow = $scrollElement[0] === window;
    const scrollElementWidth = isWindow ? window.innerWidth : $scrollElement[0].offsetWidth;
    const scrollElementHeight = isWindow ? window.innerHeight : $scrollElement[0].offsetHeight;
    const swiperOffset = swiper.$el.offset();
    const {
      rtlTranslate: rtl
    } = swiper;
    let inView = false;
    if (rtl) swiperOffset.left -= swiper.$el[0].scrollLeft;
    const swiperCoord = [[swiperOffset.left, swiperOffset.top], [swiperOffset.left + swiper.width, swiperOffset.top], [swiperOffset.left, swiperOffset.top + swiper.height], [swiperOffset.left + swiper.width, swiperOffset.top + swiper.height]];

    for (let i = 0; i < swiperCoord.length; i += 1) {
      const point = swiperCoord[i];

      if (point[0] >= 0 && point[0] <= scrollElementWidth && point[1] >= 0 && point[1] <= scrollElementHeight) {
        if (point[0] === 0 && point[1] === 0) continue; // eslint-disable-line

        inView = true;
      }
    }

    const passiveListener = swiper.touchEvents.start === 'touchstart' && swiper.support.passiveListener && swiper.params.passiveListeners ? {
      passive: true,
      capture: false
    } : false;

    if (inView) {
      load();
      $scrollElement.off('scroll', checkInViewOnLoad, passiveListener);
    } else if (!scrollHandlerAttached) {
      scrollHandlerAttached = true;
      $scrollElement.on('scroll', checkInViewOnLoad, passiveListener);
    }
  }

  on('beforeInit', () => {
    if (swiper.params.lazy.enabled && swiper.params.preloadImages) {
      swiper.params.preloadImages = false;
    }
  });
  on('init', () => {
    if (swiper.params.lazy.enabled) {
      if (swiper.params.lazy.checkInView) {
        checkInViewOnLoad();
      } else {
        load();
      }
    }
  });
  on('scroll', () => {
    if (swiper.params.freeMode && swiper.params.freeMode.enabled && !swiper.params.freeMode.sticky) {
      load();
    }
  });
  on('scrollbarDragMove resize _freeModeNoMomentumRelease', () => {
    if (swiper.params.lazy.enabled) {
      if (swiper.params.lazy.checkInView) {
        checkInViewOnLoad();
      } else {
        load();
      }
    }
  });
  on('transitionStart', () => {
    if (swiper.params.lazy.enabled) {
      if (swiper.params.lazy.loadOnTransitionStart || !swiper.params.lazy.loadOnTransitionStart && !initialImageLoaded) {
        if (swiper.params.lazy.checkInView) {
          checkInViewOnLoad();
        } else {
          load();
        }
      }
    }
  });
  on('transitionEnd', () => {
    if (swiper.params.lazy.enabled && !swiper.params.lazy.loadOnTransitionStart) {
      if (swiper.params.lazy.checkInView) {
        checkInViewOnLoad();
      } else {
        load();
      }
    }
  });
  on('slideChange', () => {
    const {
      lazy,
      cssMode,
      watchSlidesProgress,
      touchReleaseOnEdges,
      resistanceRatio
    } = swiper.params;

    if (lazy.enabled && (cssMode || watchSlidesProgress && (touchReleaseOnEdges || resistanceRatio === 0))) {
      load();
    }
  });
  on('destroy', () => {
    if (!swiper.$el) return;
    swiper.$el.find(`.${swiper.params.lazy.loadingClass}`).removeClass(swiper.params.lazy.loadingClass);
  });
  Object.assign(swiper.lazy, {
    load,
    loadInSlide
  });
}
;// CONCATENATED MODULE: ./node_modules/swiper/modules/controller/controller.js
/* eslint no-bitwise: ["error", { "allow": [">>"] }] */

function Controller({
  swiper,
  extendParams,
  on
}) {
  extendParams({
    controller: {
      control: undefined,
      inverse: false,
      by: 'slide' // or 'container'

    }
  });
  swiper.controller = {
    control: undefined
  };

  function LinearSpline(x, y) {
    const binarySearch = function search() {
      let maxIndex;
      let minIndex;
      let guess;
      return (array, val) => {
        minIndex = -1;
        maxIndex = array.length;

        while (maxIndex - minIndex > 1) {
          guess = maxIndex + minIndex >> 1;

          if (array[guess] <= val) {
            minIndex = guess;
          } else {
            maxIndex = guess;
          }
        }

        return maxIndex;
      };
    }();

    this.x = x;
    this.y = y;
    this.lastIndex = x.length - 1; // Given an x value (x2), return the expected y2 value:
    // (x1,y1) is the known point before given value,
    // (x3,y3) is the known point after given value.

    let i1;
    let i3;

    this.interpolate = function interpolate(x2) {
      if (!x2) return 0; // Get the indexes of x1 and x3 (the array indexes before and after given x2):

      i3 = binarySearch(this.x, x2);
      i1 = i3 - 1; // We have our indexes i1 & i3, so we can calculate already:
      // y2 := ((x2−x1) × (y3−y1)) ÷ (x3−x1) + y1

      return (x2 - this.x[i1]) * (this.y[i3] - this.y[i1]) / (this.x[i3] - this.x[i1]) + this.y[i1];
    };

    return this;
  } // xxx: for now i will just save one spline function to to


  function getInterpolateFunction(c) {
    if (!swiper.controller.spline) {
      swiper.controller.spline = swiper.params.loop ? new LinearSpline(swiper.slidesGrid, c.slidesGrid) : new LinearSpline(swiper.snapGrid, c.snapGrid);
    }
  }

  function setTranslate(_t, byController) {
    const controlled = swiper.controller.control;
    let multiplier;
    let controlledTranslate;
    const Swiper = swiper.constructor;

    function setControlledTranslate(c) {
      // this will create an Interpolate function based on the snapGrids
      // x is the Grid of the scrolled scroller and y will be the controlled scroller
      // it makes sense to create this only once and recall it for the interpolation
      // the function does a lot of value caching for performance
      const translate = swiper.rtlTranslate ? -swiper.translate : swiper.translate;

      if (swiper.params.controller.by === 'slide') {
        getInterpolateFunction(c); // i am not sure why the values have to be multiplicated this way, tried to invert the snapGrid
        // but it did not work out

        controlledTranslate = -swiper.controller.spline.interpolate(-translate);
      }

      if (!controlledTranslate || swiper.params.controller.by === 'container') {
        multiplier = (c.maxTranslate() - c.minTranslate()) / (swiper.maxTranslate() - swiper.minTranslate());
        controlledTranslate = (translate - swiper.minTranslate()) * multiplier + c.minTranslate();
      }

      if (swiper.params.controller.inverse) {
        controlledTranslate = c.maxTranslate() - controlledTranslate;
      }

      c.updateProgress(controlledTranslate);
      c.setTranslate(controlledTranslate, swiper);
      c.updateActiveIndex();
      c.updateSlidesClasses();
    }

    if (Array.isArray(controlled)) {
      for (let i = 0; i < controlled.length; i += 1) {
        if (controlled[i] !== byController && controlled[i] instanceof Swiper) {
          setControlledTranslate(controlled[i]);
        }
      }
    } else if (controlled instanceof Swiper && byController !== controlled) {
      setControlledTranslate(controlled);
    }
  }

  function setTransition(duration, byController) {
    const Swiper = swiper.constructor;
    const controlled = swiper.controller.control;
    let i;

    function setControlledTransition(c) {
      c.setTransition(duration, swiper);

      if (duration !== 0) {
        c.transitionStart();

        if (c.params.autoHeight) {
          nextTick(() => {
            c.updateAutoHeight();
          });
        }

        c.$wrapperEl.transitionEnd(() => {
          if (!controlled) return;

          if (c.params.loop && swiper.params.controller.by === 'slide') {
            c.loopFix();
          }

          c.transitionEnd();
        });
      }
    }

    if (Array.isArray(controlled)) {
      for (i = 0; i < controlled.length; i += 1) {
        if (controlled[i] !== byController && controlled[i] instanceof Swiper) {
          setControlledTransition(controlled[i]);
        }
      }
    } else if (controlled instanceof Swiper && byController !== controlled) {
      setControlledTransition(controlled);
    }
  }

  function removeSpline() {
    if (!swiper.controller.control) return;

    if (swiper.controller.spline) {
      swiper.controller.spline = undefined;
      delete swiper.controller.spline;
    }
  }

  on('beforeInit', () => {
    swiper.controller.control = swiper.params.controller.control;
  });
  on('update', () => {
    removeSpline();
  });
  on('resize', () => {
    removeSpline();
  });
  on('observerUpdate', () => {
    removeSpline();
  });
  on('setTranslate', (_s, translate, byController) => {
    if (!swiper.controller.control) return;
    swiper.controller.setTranslate(translate, byController);
  });
  on('setTransition', (_s, duration, byController) => {
    if (!swiper.controller.control) return;
    swiper.controller.setTransition(duration, byController);
  });
  Object.assign(swiper.controller, {
    setTranslate,
    setTransition
  });
}
;// CONCATENATED MODULE: ./node_modules/swiper/modules/a11y/a11y.js


function A11y({
  swiper,
  extendParams,
  on
}) {
  extendParams({
    a11y: {
      enabled: true,
      notificationClass: 'swiper-notification',
      prevSlideMessage: 'Previous slide',
      nextSlideMessage: 'Next slide',
      firstSlideMessage: 'This is the first slide',
      lastSlideMessage: 'This is the last slide',
      paginationBulletMessage: 'Go to slide {{index}}',
      slideLabelMessage: '{{index}} / {{slidesLength}}',
      containerMessage: null,
      containerRoleDescriptionMessage: null,
      itemRoleDescriptionMessage: null,
      slideRole: 'group',
      id: null
    }
  });
  swiper.a11y = {
    clicked: false
  };
  let liveRegion = null;

  function notify(message) {
    const notification = liveRegion;
    if (notification.length === 0) return;
    notification.html('');
    notification.html(message);
  }

  function getRandomNumber(size = 16) {
    const randomChar = () => Math.round(16 * Math.random()).toString(16);

    return 'x'.repeat(size).replace(/x/g, randomChar);
  }

  function makeElFocusable($el) {
    $el.attr('tabIndex', '0');
  }

  function makeElNotFocusable($el) {
    $el.attr('tabIndex', '-1');
  }

  function addElRole($el, role) {
    $el.attr('role', role);
  }

  function addElRoleDescription($el, description) {
    $el.attr('aria-roledescription', description);
  }

  function addElControls($el, controls) {
    $el.attr('aria-controls', controls);
  }

  function addElLabel($el, label) {
    $el.attr('aria-label', label);
  }

  function addElId($el, id) {
    $el.attr('id', id);
  }

  function addElLive($el, live) {
    $el.attr('aria-live', live);
  }

  function disableEl($el) {
    $el.attr('aria-disabled', true);
  }

  function enableEl($el) {
    $el.attr('aria-disabled', false);
  }

  function onEnterOrSpaceKey(e) {
    if (e.keyCode !== 13 && e.keyCode !== 32) return;
    const params = swiper.params.a11y;
    const $targetEl = $(e.target);

    if (swiper.navigation && swiper.navigation.$nextEl && $targetEl.is(swiper.navigation.$nextEl)) {
      if (!(swiper.isEnd && !swiper.params.loop)) {
        swiper.slideNext();
      }

      if (swiper.isEnd) {
        notify(params.lastSlideMessage);
      } else {
        notify(params.nextSlideMessage);
      }
    }

    if (swiper.navigation && swiper.navigation.$prevEl && $targetEl.is(swiper.navigation.$prevEl)) {
      if (!(swiper.isBeginning && !swiper.params.loop)) {
        swiper.slidePrev();
      }

      if (swiper.isBeginning) {
        notify(params.firstSlideMessage);
      } else {
        notify(params.prevSlideMessage);
      }
    }

    if (swiper.pagination && $targetEl.is(classesToSelector(swiper.params.pagination.bulletClass))) {
      $targetEl[0].click();
    }
  }

  function updateNavigation() {
    if (swiper.params.loop || swiper.params.rewind || !swiper.navigation) return;
    const {
      $nextEl,
      $prevEl
    } = swiper.navigation;

    if ($prevEl && $prevEl.length > 0) {
      if (swiper.isBeginning) {
        disableEl($prevEl);
        makeElNotFocusable($prevEl);
      } else {
        enableEl($prevEl);
        makeElFocusable($prevEl);
      }
    }

    if ($nextEl && $nextEl.length > 0) {
      if (swiper.isEnd) {
        disableEl($nextEl);
        makeElNotFocusable($nextEl);
      } else {
        enableEl($nextEl);
        makeElFocusable($nextEl);
      }
    }
  }

  function hasPagination() {
    return swiper.pagination && swiper.pagination.bullets && swiper.pagination.bullets.length;
  }

  function hasClickablePagination() {
    return hasPagination() && swiper.params.pagination.clickable;
  }

  function updatePagination() {
    const params = swiper.params.a11y;
    if (!hasPagination()) return;
    swiper.pagination.bullets.each(bulletEl => {
      const $bulletEl = $(bulletEl);

      if (swiper.params.pagination.clickable) {
        makeElFocusable($bulletEl);

        if (!swiper.params.pagination.renderBullet) {
          addElRole($bulletEl, 'button');
          addElLabel($bulletEl, params.paginationBulletMessage.replace(/\{\{index\}\}/, $bulletEl.index() + 1));
        }
      }

      if ($bulletEl.is(`.${swiper.params.pagination.bulletActiveClass}`)) {
        $bulletEl.attr('aria-current', 'true');
      } else {
        $bulletEl.removeAttr('aria-current');
      }
    });
  }

  const initNavEl = ($el, wrapperId, message) => {
    makeElFocusable($el);

    if ($el[0].tagName !== 'BUTTON') {
      addElRole($el, 'button');
      $el.on('keydown', onEnterOrSpaceKey);
    }

    addElLabel($el, message);
    addElControls($el, wrapperId);
  };

  const handlePointerDown = () => {
    swiper.a11y.clicked = true;
  };

  const handlePointerUp = () => {
    requestAnimationFrame(() => {
      requestAnimationFrame(() => {
        if (!swiper.destroyed) {
          swiper.a11y.clicked = false;
        }
      });
    });
  };

  const handleFocus = e => {
    if (swiper.a11y.clicked) return;
    const slideEl = e.target.closest(`.${swiper.params.slideClass}`);
    if (!slideEl || !swiper.slides.includes(slideEl)) return;
    const isActive = swiper.slides.indexOf(slideEl) === swiper.activeIndex;
    const isVisible = swiper.params.watchSlidesProgress && swiper.visibleSlides && swiper.visibleSlides.includes(slideEl);
    if (isActive || isVisible) return;
    if (e.sourceCapabilities && e.sourceCapabilities.firesTouchEvents) return;

    if (swiper.isHorizontal()) {
      swiper.el.scrollLeft = 0;
    } else {
      swiper.el.scrollTop = 0;
    }

    swiper.slideTo(swiper.slides.indexOf(slideEl), 0);
  };

  const initSlides = () => {
    const params = swiper.params.a11y;

    if (params.itemRoleDescriptionMessage) {
      addElRoleDescription($(swiper.slides), params.itemRoleDescriptionMessage);
    }

    if (params.slideRole) {
      addElRole($(swiper.slides), params.slideRole);
    }

    const slidesLength = swiper.params.loop ? swiper.slides.filter(el => !el.classList.contains(swiper.params.slideDuplicateClass)).length : swiper.slides.length;

    if (params.slideLabelMessage) {
      swiper.slides.each((slideEl, index) => {
        const $slideEl = $(slideEl);
        const slideIndex = swiper.params.loop ? parseInt($slideEl.attr('data-swiper-slide-index'), 10) : index;
        const ariaLabelMessage = params.slideLabelMessage.replace(/\{\{index\}\}/, slideIndex + 1).replace(/\{\{slidesLength\}\}/, slidesLength);
        addElLabel($slideEl, ariaLabelMessage);
      });
    }
  };

  const init = () => {
    const params = swiper.params.a11y;
    swiper.$el.append(liveRegion); // Container

    const $containerEl = swiper.$el;

    if (params.containerRoleDescriptionMessage) {
      addElRoleDescription($containerEl, params.containerRoleDescriptionMessage);
    }

    if (params.containerMessage) {
      addElLabel($containerEl, params.containerMessage);
    } // Wrapper


    const $wrapperEl = swiper.$wrapperEl;
    const wrapperId = params.id || $wrapperEl.attr('id') || `swiper-wrapper-${getRandomNumber(16)}`;
    const live = swiper.params.autoplay && swiper.params.autoplay.enabled ? 'off' : 'polite';
    addElId($wrapperEl, wrapperId);
    addElLive($wrapperEl, live); // Slide

    initSlides(); // Navigation

    let $nextEl;
    let $prevEl;

    if (swiper.navigation && swiper.navigation.$nextEl) {
      $nextEl = swiper.navigation.$nextEl;
    }

    if (swiper.navigation && swiper.navigation.$prevEl) {
      $prevEl = swiper.navigation.$prevEl;
    }

    if ($nextEl && $nextEl.length) {
      initNavEl($nextEl, wrapperId, params.nextSlideMessage);
    }

    if ($prevEl && $prevEl.length) {
      initNavEl($prevEl, wrapperId, params.prevSlideMessage);
    } // Pagination


    if (hasClickablePagination()) {
      swiper.pagination.$el.on('keydown', classesToSelector(swiper.params.pagination.bulletClass), onEnterOrSpaceKey);
    } // Tab focus


    swiper.$el.on('focus', handleFocus, true);
    swiper.$el.on('pointerdown', handlePointerDown, true);
    swiper.$el.on('pointerup', handlePointerUp, true);
  };

  function destroy() {
    if (liveRegion && liveRegion.length > 0) liveRegion.remove();
    let $nextEl;
    let $prevEl;

    if (swiper.navigation && swiper.navigation.$nextEl) {
      $nextEl = swiper.navigation.$nextEl;
    }

    if (swiper.navigation && swiper.navigation.$prevEl) {
      $prevEl = swiper.navigation.$prevEl;
    }

    if ($nextEl) {
      $nextEl.off('keydown', onEnterOrSpaceKey);
    }

    if ($prevEl) {
      $prevEl.off('keydown', onEnterOrSpaceKey);
    } // Pagination


    if (hasClickablePagination()) {
      swiper.pagination.$el.off('keydown', classesToSelector(swiper.params.pagination.bulletClass), onEnterOrSpaceKey);
    } // Tab focus


    swiper.$el.off('focus', handleFocus, true);
    swiper.$el.off('pointerdown', handlePointerDown, true);
    swiper.$el.off('pointerup', handlePointerUp, true);
  }

  on('beforeInit', () => {
    liveRegion = $(`<span class="${swiper.params.a11y.notificationClass}" aria-live="assertive" aria-atomic="true"></span>`);
  });
  on('afterInit', () => {
    if (!swiper.params.a11y.enabled) return;
    init();
  });
  on('slidesLengthChange snapGridLengthChange slidesGridLengthChange', () => {
    if (!swiper.params.a11y.enabled) return;
    initSlides();
  });
  on('fromEdge toEdge afterInit lock unlock', () => {
    if (!swiper.params.a11y.enabled) return;
    updateNavigation();
  });
  on('paginationUpdate', () => {
    if (!swiper.params.a11y.enabled) return;
    updatePagination();
  });
  on('destroy', () => {
    if (!swiper.params.a11y.enabled) return;
    destroy();
  });
}
;// CONCATENATED MODULE: ./node_modules/swiper/modules/history/history.js

function History({
  swiper,
  extendParams,
  on
}) {
  extendParams({
    history: {
      enabled: false,
      root: '',
      replaceState: false,
      key: 'slides',
      keepQuery: false
    }
  });
  let initialized = false;
  let paths = {};

  const slugify = text => {
    return text.toString().replace(/\s+/g, '-').replace(/[^\w-]+/g, '').replace(/--+/g, '-').replace(/^-+/, '').replace(/-+$/, '');
  };

  const getPathValues = urlOverride => {
    const window = getWindow();
    let location;

    if (urlOverride) {
      location = new URL(urlOverride);
    } else {
      location = window.location;
    }

    const pathArray = location.pathname.slice(1).split('/').filter(part => part !== '');
    const total = pathArray.length;
    const key = pathArray[total - 2];
    const value = pathArray[total - 1];
    return {
      key,
      value
    };
  };

  const setHistory = (key, index) => {
    const window = getWindow();
    if (!initialized || !swiper.params.history.enabled) return;
    let location;

    if (swiper.params.url) {
      location = new URL(swiper.params.url);
    } else {
      location = window.location;
    }

    const slide = swiper.slides.eq(index);
    let value = slugify(slide.attr('data-history'));

    if (swiper.params.history.root.length > 0) {
      let root = swiper.params.history.root;
      if (root[root.length - 1] === '/') root = root.slice(0, root.length - 1);
      value = `${root}/${key}/${value}`;
    } else if (!location.pathname.includes(key)) {
      value = `${key}/${value}`;
    }

    if (swiper.params.history.keepQuery) {
      value += location.search;
    }

    const currentState = window.history.state;

    if (currentState && currentState.value === value) {
      return;
    }

    if (swiper.params.history.replaceState) {
      window.history.replaceState({
        value
      }, null, value);
    } else {
      window.history.pushState({
        value
      }, null, value);
    }
  };

  const scrollToSlide = (speed, value, runCallbacks) => {
    if (value) {
      for (let i = 0, length = swiper.slides.length; i < length; i += 1) {
        const slide = swiper.slides.eq(i);
        const slideHistory = slugify(slide.attr('data-history'));

        if (slideHistory === value && !slide.hasClass(swiper.params.slideDuplicateClass)) {
          const index = slide.index();
          swiper.slideTo(index, speed, runCallbacks);
        }
      }
    } else {
      swiper.slideTo(0, speed, runCallbacks);
    }
  };

  const setHistoryPopState = () => {
    paths = getPathValues(swiper.params.url);
    scrollToSlide(swiper.params.speed, paths.value, false);
  };

  const init = () => {
    const window = getWindow();
    if (!swiper.params.history) return;

    if (!window.history || !window.history.pushState) {
      swiper.params.history.enabled = false;
      swiper.params.hashNavigation.enabled = true;
      return;
    }

    initialized = true;
    paths = getPathValues(swiper.params.url);
    if (!paths.key && !paths.value) return;
    scrollToSlide(0, paths.value, swiper.params.runCallbacksOnInit);

    if (!swiper.params.history.replaceState) {
      window.addEventListener('popstate', setHistoryPopState);
    }
  };

  const destroy = () => {
    const window = getWindow();

    if (!swiper.params.history.replaceState) {
      window.removeEventListener('popstate', setHistoryPopState);
    }
  };

  on('init', () => {
    if (swiper.params.history.enabled) {
      init();
    }
  });
  on('destroy', () => {
    if (swiper.params.history.enabled) {
      destroy();
    }
  });
  on('transitionEnd _freeModeNoMomentumRelease', () => {
    if (initialized) {
      setHistory(swiper.params.history.key, swiper.activeIndex);
    }
  });
  on('slideChange', () => {
    if (initialized && swiper.params.cssMode) {
      setHistory(swiper.params.history.key, swiper.activeIndex);
    }
  });
}
;// CONCATENATED MODULE: ./node_modules/swiper/modules/hash-navigation/hash-navigation.js


function HashNavigation({
  swiper,
  extendParams,
  emit,
  on
}) {
  let initialized = false;
  const document = getDocument();
  const window = getWindow();
  extendParams({
    hashNavigation: {
      enabled: false,
      replaceState: false,
      watchState: false
    }
  });

  const onHashChange = () => {
    emit('hashChange');
    const newHash = document.location.hash.replace('#', '');
    const activeSlideHash = swiper.slides.eq(swiper.activeIndex).attr('data-hash');

    if (newHash !== activeSlideHash) {
      const newIndex = swiper.$wrapperEl.children(`.${swiper.params.slideClass}[data-hash="${newHash}"]`).index();
      if (typeof newIndex === 'undefined') return;
      swiper.slideTo(newIndex);
    }
  };

  const setHash = () => {
    if (!initialized || !swiper.params.hashNavigation.enabled) return;

    if (swiper.params.hashNavigation.replaceState && window.history && window.history.replaceState) {
      window.history.replaceState(null, null, `#${swiper.slides.eq(swiper.activeIndex).attr('data-hash')}` || '');
      emit('hashSet');
    } else {
      const slide = swiper.slides.eq(swiper.activeIndex);
      const hash = slide.attr('data-hash') || slide.attr('data-history');
      document.location.hash = hash || '';
      emit('hashSet');
    }
  };

  const init = () => {
    if (!swiper.params.hashNavigation.enabled || swiper.params.history && swiper.params.history.enabled) return;
    initialized = true;
    const hash = document.location.hash.replace('#', '');

    if (hash) {
      const speed = 0;

      for (let i = 0, length = swiper.slides.length; i < length; i += 1) {
        const slide = swiper.slides.eq(i);
        const slideHash = slide.attr('data-hash') || slide.attr('data-history');

        if (slideHash === hash && !slide.hasClass(swiper.params.slideDuplicateClass)) {
          const index = slide.index();
          swiper.slideTo(index, speed, swiper.params.runCallbacksOnInit, true);
        }
      }
    }

    if (swiper.params.hashNavigation.watchState) {
      $(window).on('hashchange', onHashChange);
    }
  };

  const destroy = () => {
    if (swiper.params.hashNavigation.watchState) {
      $(window).off('hashchange', onHashChange);
    }
  };

  on('init', () => {
    if (swiper.params.hashNavigation.enabled) {
      init();
    }
  });
  on('destroy', () => {
    if (swiper.params.hashNavigation.enabled) {
      destroy();
    }
  });
  on('transitionEnd _freeModeNoMomentumRelease', () => {
    if (initialized) {
      setHash();
    }
  });
  on('slideChange', () => {
    if (initialized && swiper.params.cssMode) {
      setHash();
    }
  });
}
;// CONCATENATED MODULE: ./node_modules/swiper/modules/autoplay/autoplay.js
/* eslint no-underscore-dangle: "off" */

/* eslint no-use-before-define: "off" */


function Autoplay({
  swiper,
  extendParams,
  on,
  emit
}) {
  let timeout;
  swiper.autoplay = {
    running: false,
    paused: false
  };
  extendParams({
    autoplay: {
      enabled: false,
      delay: 3000,
      waitForTransition: true,
      disableOnInteraction: true,
      stopOnLastSlide: false,
      reverseDirection: false,
      pauseOnMouseEnter: false
    }
  });

  function run() {
    if (!swiper.size) {
      swiper.autoplay.running = false;
      swiper.autoplay.paused = false;
      return;
    }

    const $activeSlideEl = swiper.slides.eq(swiper.activeIndex);
    let delay = swiper.params.autoplay.delay;

    if ($activeSlideEl.attr('data-swiper-autoplay')) {
      delay = $activeSlideEl.attr('data-swiper-autoplay') || swiper.params.autoplay.delay;
    }

    clearTimeout(timeout);
    timeout = utils_nextTick(() => {
      let autoplayResult;

      if (swiper.params.autoplay.reverseDirection) {
        if (swiper.params.loop) {
          swiper.loopFix();
          autoplayResult = swiper.slidePrev(swiper.params.speed, true, true);
          emit('autoplay');
        } else if (!swiper.isBeginning) {
          autoplayResult = swiper.slidePrev(swiper.params.speed, true, true);
          emit('autoplay');
        } else if (!swiper.params.autoplay.stopOnLastSlide) {
          autoplayResult = swiper.slideTo(swiper.slides.length - 1, swiper.params.speed, true, true);
          emit('autoplay');
        } else {
          stop();
        }
      } else if (swiper.params.loop) {
        swiper.loopFix();
        autoplayResult = swiper.slideNext(swiper.params.speed, true, true);
        emit('autoplay');
      } else if (!swiper.isEnd) {
        autoplayResult = swiper.slideNext(swiper.params.speed, true, true);
        emit('autoplay');
      } else if (!swiper.params.autoplay.stopOnLastSlide) {
        autoplayResult = swiper.slideTo(0, swiper.params.speed, true, true);
        emit('autoplay');
      } else {
        stop();
      }

      if (swiper.params.cssMode && swiper.autoplay.running) run();else if (autoplayResult === false) {
        run();
      }
    }, delay);
  }

  function start() {
    if (typeof timeout !== 'undefined') return false;
    if (swiper.autoplay.running) return false;
    swiper.autoplay.running = true;
    emit('autoplayStart');
    run();
    return true;
  }

  function stop() {
    if (!swiper.autoplay.running) return false;
    if (typeof timeout === 'undefined') return false;

    if (timeout) {
      clearTimeout(timeout);
      timeout = undefined;
    }

    swiper.autoplay.running = false;
    emit('autoplayStop');
    return true;
  }

  function pause(speed) {
    if (!swiper.autoplay.running) return;
    if (swiper.autoplay.paused) return;
    if (timeout) clearTimeout(timeout);
    swiper.autoplay.paused = true;

    if (speed === 0 || !swiper.params.autoplay.waitForTransition) {
      swiper.autoplay.paused = false;
      run();
    } else {
      ['transitionend', 'webkitTransitionEnd'].forEach(event => {
        swiper.$wrapperEl[0].addEventListener(event, onTransitionEnd);
      });
    }
  }

  function onVisibilityChange() {
    const document = ssr_window_esm_getDocument();

    if (document.visibilityState === 'hidden' && swiper.autoplay.running) {
      pause();
    }

    if (document.visibilityState === 'visible' && swiper.autoplay.paused) {
      run();
      swiper.autoplay.paused = false;
    }
  }

  function onTransitionEnd(e) {
    if (!swiper || swiper.destroyed || !swiper.$wrapperEl) return;
    if (e.target !== swiper.$wrapperEl[0]) return;
    ['transitionend', 'webkitTransitionEnd'].forEach(event => {
      swiper.$wrapperEl[0].removeEventListener(event, onTransitionEnd);
    });
    swiper.autoplay.paused = false;

    if (!swiper.autoplay.running) {
      stop();
    } else {
      run();
    }
  }

  function onMouseEnter() {
    if (swiper.params.autoplay.disableOnInteraction) {
      stop();
    } else {
      emit('autoplayPause');
      pause();
    }

    ['transitionend', 'webkitTransitionEnd'].forEach(event => {
      swiper.$wrapperEl[0].removeEventListener(event, onTransitionEnd);
    });
  }

  function onMouseLeave() {
    if (swiper.params.autoplay.disableOnInteraction) {
      return;
    }

    swiper.autoplay.paused = false;
    emit('autoplayResume');
    run();
  }

  function attachMouseEvents() {
    if (swiper.params.autoplay.pauseOnMouseEnter) {
      swiper.$el.on('mouseenter', onMouseEnter);
      swiper.$el.on('mouseleave', onMouseLeave);
    }
  }

  function detachMouseEvents() {
    swiper.$el.off('mouseenter', onMouseEnter);
    swiper.$el.off('mouseleave', onMouseLeave);
  }

  on('init', () => {
    if (swiper.params.autoplay.enabled) {
      start();
      const document = ssr_window_esm_getDocument();
      document.addEventListener('visibilitychange', onVisibilityChange);
      attachMouseEvents();
    }
  });
  on('beforeTransitionStart', (_s, speed, internal) => {
    if (swiper.autoplay.running) {
      if (internal || !swiper.params.autoplay.disableOnInteraction) {
        swiper.autoplay.pause(speed);
      } else {
        stop();
      }
    }
  });
  on('sliderFirstMove', () => {
    if (swiper.autoplay.running) {
      if (swiper.params.autoplay.disableOnInteraction) {
        stop();
      } else {
        pause();
      }
    }
  });
  on('touchEnd', () => {
    if (swiper.params.cssMode && swiper.autoplay.paused && !swiper.params.autoplay.disableOnInteraction) {
      run();
    }
  });
  on('destroy', () => {
    detachMouseEvents();

    if (swiper.autoplay.running) {
      stop();
    }

    const document = ssr_window_esm_getDocument();
    document.removeEventListener('visibilitychange', onVisibilityChange);
  });
  Object.assign(swiper.autoplay, {
    pause,
    run,
    start,
    stop
  });
}
;// CONCATENATED MODULE: ./node_modules/swiper/modules/thumbs/thumbs.js


function Thumb({
  swiper,
  extendParams,
  on
}) {
  extendParams({
    thumbs: {
      swiper: null,
      multipleActiveThumbs: true,
      autoScrollOffset: 0,
      slideThumbActiveClass: 'swiper-slide-thumb-active',
      thumbsContainerClass: 'swiper-thumbs'
    }
  });
  let initialized = false;
  let swiperCreated = false;
  swiper.thumbs = {
    swiper: null
  };

  function onThumbClick() {
    const thumbsSwiper = swiper.thumbs.swiper;
    if (!thumbsSwiper || thumbsSwiper.destroyed) return;
    const clickedIndex = thumbsSwiper.clickedIndex;
    const clickedSlide = thumbsSwiper.clickedSlide;
    if (clickedSlide && $(clickedSlide).hasClass(swiper.params.thumbs.slideThumbActiveClass)) return;
    if (typeof clickedIndex === 'undefined' || clickedIndex === null) return;
    let slideToIndex;

    if (thumbsSwiper.params.loop) {
      slideToIndex = parseInt($(thumbsSwiper.clickedSlide).attr('data-swiper-slide-index'), 10);
    } else {
      slideToIndex = clickedIndex;
    }

    if (swiper.params.loop) {
      let currentIndex = swiper.activeIndex;

      if (swiper.slides.eq(currentIndex).hasClass(swiper.params.slideDuplicateClass)) {
        swiper.loopFix(); // eslint-disable-next-line

        swiper._clientLeft = swiper.$wrapperEl[0].clientLeft;
        currentIndex = swiper.activeIndex;
      }

      const prevIndex = swiper.slides.eq(currentIndex).prevAll(`[data-swiper-slide-index="${slideToIndex}"]`).eq(0).index();
      const nextIndex = swiper.slides.eq(currentIndex).nextAll(`[data-swiper-slide-index="${slideToIndex}"]`).eq(0).index();
      if (typeof prevIndex === 'undefined') slideToIndex = nextIndex;else if (typeof nextIndex === 'undefined') slideToIndex = prevIndex;else if (nextIndex - currentIndex < currentIndex - prevIndex) slideToIndex = nextIndex;else slideToIndex = prevIndex;
    }

    swiper.slideTo(slideToIndex);
  }

  function init() {
    const {
      thumbs: thumbsParams
    } = swiper.params;
    if (initialized) return false;
    initialized = true;
    const SwiperClass = swiper.constructor;

    if (thumbsParams.swiper instanceof SwiperClass) {
      swiper.thumbs.swiper = thumbsParams.swiper;
      Object.assign(swiper.thumbs.swiper.originalParams, {
        watchSlidesProgress: true,
        slideToClickedSlide: false
      });
      Object.assign(swiper.thumbs.swiper.params, {
        watchSlidesProgress: true,
        slideToClickedSlide: false
      });
    } else if (isObject(thumbsParams.swiper)) {
      const thumbsSwiperParams = Object.assign({}, thumbsParams.swiper);
      Object.assign(thumbsSwiperParams, {
        watchSlidesProgress: true,
        slideToClickedSlide: false
      });
      swiper.thumbs.swiper = new SwiperClass(thumbsSwiperParams);
      swiperCreated = true;
    }

    swiper.thumbs.swiper.$el.addClass(swiper.params.thumbs.thumbsContainerClass);
    swiper.thumbs.swiper.on('tap', onThumbClick);
    return true;
  }

  function update(initial) {
    const thumbsSwiper = swiper.thumbs.swiper;
    if (!thumbsSwiper || thumbsSwiper.destroyed) return;
    const slidesPerView = thumbsSwiper.params.slidesPerView === 'auto' ? thumbsSwiper.slidesPerViewDynamic() : thumbsSwiper.params.slidesPerView; // Activate thumbs

    let thumbsToActivate = 1;
    const thumbActiveClass = swiper.params.thumbs.slideThumbActiveClass;

    if (swiper.params.slidesPerView > 1 && !swiper.params.centeredSlides) {
      thumbsToActivate = swiper.params.slidesPerView;
    }

    if (!swiper.params.thumbs.multipleActiveThumbs) {
      thumbsToActivate = 1;
    }

    thumbsToActivate = Math.floor(thumbsToActivate);
    thumbsSwiper.slides.removeClass(thumbActiveClass);

    if (thumbsSwiper.params.loop || thumbsSwiper.params.virtual && thumbsSwiper.params.virtual.enabled) {
      for (let i = 0; i < thumbsToActivate; i += 1) {
        thumbsSwiper.$wrapperEl.children(`[data-swiper-slide-index="${swiper.realIndex + i}"]`).addClass(thumbActiveClass);
      }
    } else {
      for (let i = 0; i < thumbsToActivate; i += 1) {
        thumbsSwiper.slides.eq(swiper.realIndex + i).addClass(thumbActiveClass);
      }
    }

    const autoScrollOffset = swiper.params.thumbs.autoScrollOffset;
    const useOffset = autoScrollOffset && !thumbsSwiper.params.loop;

    if (swiper.realIndex !== thumbsSwiper.realIndex || useOffset) {
      let currentThumbsIndex = thumbsSwiper.activeIndex;
      let newThumbsIndex;
      let direction;

      if (thumbsSwiper.params.loop) {
        if (thumbsSwiper.slides.eq(currentThumbsIndex).hasClass(thumbsSwiper.params.slideDuplicateClass)) {
          thumbsSwiper.loopFix(); // eslint-disable-next-line

          thumbsSwiper._clientLeft = thumbsSwiper.$wrapperEl[0].clientLeft;
          currentThumbsIndex = thumbsSwiper.activeIndex;
        } // Find actual thumbs index to slide to


        const prevThumbsIndex = thumbsSwiper.slides.eq(currentThumbsIndex).prevAll(`[data-swiper-slide-index="${swiper.realIndex}"]`).eq(0).index();
        const nextThumbsIndex = thumbsSwiper.slides.eq(currentThumbsIndex).nextAll(`[data-swiper-slide-index="${swiper.realIndex}"]`).eq(0).index();

        if (typeof prevThumbsIndex === 'undefined') {
          newThumbsIndex = nextThumbsIndex;
        } else if (typeof nextThumbsIndex === 'undefined') {
          newThumbsIndex = prevThumbsIndex;
        } else if (nextThumbsIndex - currentThumbsIndex === currentThumbsIndex - prevThumbsIndex) {
          newThumbsIndex = thumbsSwiper.params.slidesPerGroup > 1 ? nextThumbsIndex : currentThumbsIndex;
        } else if (nextThumbsIndex - currentThumbsIndex < currentThumbsIndex - prevThumbsIndex) {
          newThumbsIndex = nextThumbsIndex;
        } else {
          newThumbsIndex = prevThumbsIndex;
        }

        direction = swiper.activeIndex > swiper.previousIndex ? 'next' : 'prev';
      } else {
        newThumbsIndex = swiper.realIndex;
        direction = newThumbsIndex > swiper.previousIndex ? 'next' : 'prev';
      }

      if (useOffset) {
        newThumbsIndex += direction === 'next' ? autoScrollOffset : -1 * autoScrollOffset;
      }

      if (thumbsSwiper.visibleSlidesIndexes && thumbsSwiper.visibleSlidesIndexes.indexOf(newThumbsIndex) < 0) {
        if (thumbsSwiper.params.centeredSlides) {
          if (newThumbsIndex > currentThumbsIndex) {
            newThumbsIndex = newThumbsIndex - Math.floor(slidesPerView / 2) + 1;
          } else {
            newThumbsIndex = newThumbsIndex + Math.floor(slidesPerView / 2) - 1;
          }
        } else if (newThumbsIndex > currentThumbsIndex && thumbsSwiper.params.slidesPerGroup === 1) {// newThumbsIndex = newThumbsIndex - slidesPerView + 1;
        }

        thumbsSwiper.slideTo(newThumbsIndex, initial ? 0 : undefined);
      }
    }
  }

  on('beforeInit', () => {
    const {
      thumbs
    } = swiper.params;
    if (!thumbs || !thumbs.swiper) return;
    init();
    update(true);
  });
  on('slideChange update resize observerUpdate', () => {
    update();
  });
  on('setTransition', (_s, duration) => {
    const thumbsSwiper = swiper.thumbs.swiper;
    if (!thumbsSwiper || thumbsSwiper.destroyed) return;
    thumbsSwiper.setTransition(duration);
  });
  on('beforeDestroy', () => {
    const thumbsSwiper = swiper.thumbs.swiper;
    if (!thumbsSwiper || thumbsSwiper.destroyed) return;

    if (swiperCreated) {
      thumbsSwiper.destroy();
    }
  });
  Object.assign(swiper.thumbs, {
    init,
    update
  });
}
;// CONCATENATED MODULE: ./node_modules/swiper/modules/free-mode/free-mode.js

function freeMode({
  swiper,
  extendParams,
  emit,
  once
}) {
  extendParams({
    freeMode: {
      enabled: false,
      momentum: true,
      momentumRatio: 1,
      momentumBounce: true,
      momentumBounceRatio: 1,
      momentumVelocityRatio: 1,
      sticky: false,
      minimumVelocity: 0.02
    }
  });

  function onTouchStart() {
    const translate = swiper.getTranslate();
    swiper.setTranslate(translate);
    swiper.setTransition(0);
    swiper.touchEventsData.velocities.length = 0;
    swiper.freeMode.onTouchEnd({
      currentPos: swiper.rtl ? swiper.translate : -swiper.translate
    });
  }

  function onTouchMove() {
    const {
      touchEventsData: data,
      touches
    } = swiper; // Velocity

    if (data.velocities.length === 0) {
      data.velocities.push({
        position: touches[swiper.isHorizontal() ? 'startX' : 'startY'],
        time: data.touchStartTime
      });
    }

    data.velocities.push({
      position: touches[swiper.isHorizontal() ? 'currentX' : 'currentY'],
      time: now()
    });
  }

  function onTouchEnd({
    currentPos
  }) {
    const {
      params,
      $wrapperEl,
      rtlTranslate: rtl,
      snapGrid,
      touchEventsData: data
    } = swiper; // Time diff

    const touchEndTime = now();
    const timeDiff = touchEndTime - data.touchStartTime;

    if (currentPos < -swiper.minTranslate()) {
      swiper.slideTo(swiper.activeIndex);
      return;
    }

    if (currentPos > -swiper.maxTranslate()) {
      if (swiper.slides.length < snapGrid.length) {
        swiper.slideTo(snapGrid.length - 1);
      } else {
        swiper.slideTo(swiper.slides.length - 1);
      }

      return;
    }

    if (params.freeMode.momentum) {
      if (data.velocities.length > 1) {
        const lastMoveEvent = data.velocities.pop();
        const velocityEvent = data.velocities.pop();
        const distance = lastMoveEvent.position - velocityEvent.position;
        const time = lastMoveEvent.time - velocityEvent.time;
        swiper.velocity = distance / time;
        swiper.velocity /= 2;

        if (Math.abs(swiper.velocity) < params.freeMode.minimumVelocity) {
          swiper.velocity = 0;
        } // this implies that the user stopped moving a finger then released.
        // There would be no events with distance zero, so the last event is stale.


        if (time > 150 || now() - lastMoveEvent.time > 300) {
          swiper.velocity = 0;
        }
      } else {
        swiper.velocity = 0;
      }

      swiper.velocity *= params.freeMode.momentumVelocityRatio;
      data.velocities.length = 0;
      let momentumDuration = 1000 * params.freeMode.momentumRatio;
      const momentumDistance = swiper.velocity * momentumDuration;
      let newPosition = swiper.translate + momentumDistance;
      if (rtl) newPosition = -newPosition;
      let doBounce = false;
      let afterBouncePosition;
      const bounceAmount = Math.abs(swiper.velocity) * 20 * params.freeMode.momentumBounceRatio;
      let needsLoopFix;

      if (newPosition < swiper.maxTranslate()) {
        if (params.freeMode.momentumBounce) {
          if (newPosition + swiper.maxTranslate() < -bounceAmount) {
            newPosition = swiper.maxTranslate() - bounceAmount;
          }

          afterBouncePosition = swiper.maxTranslate();
          doBounce = true;
          data.allowMomentumBounce = true;
        } else {
          newPosition = swiper.maxTranslate();
        }

        if (params.loop && params.centeredSlides) needsLoopFix = true;
      } else if (newPosition > swiper.minTranslate()) {
        if (params.freeMode.momentumBounce) {
          if (newPosition - swiper.minTranslate() > bounceAmount) {
            newPosition = swiper.minTranslate() + bounceAmount;
          }

          afterBouncePosition = swiper.minTranslate();
          doBounce = true;
          data.allowMomentumBounce = true;
        } else {
          newPosition = swiper.minTranslate();
        }

        if (params.loop && params.centeredSlides) needsLoopFix = true;
      } else if (params.freeMode.sticky) {
        let nextSlide;

        for (let j = 0; j < snapGrid.length; j += 1) {
          if (snapGrid[j] > -newPosition) {
            nextSlide = j;
            break;
          }
        }

        if (Math.abs(snapGrid[nextSlide] - newPosition) < Math.abs(snapGrid[nextSlide - 1] - newPosition) || swiper.swipeDirection === 'next') {
          newPosition = snapGrid[nextSlide];
        } else {
          newPosition = snapGrid[nextSlide - 1];
        }

        newPosition = -newPosition;
      }

      if (needsLoopFix) {
        once('transitionEnd', () => {
          swiper.loopFix();
        });
      } // Fix duration


      if (swiper.velocity !== 0) {
        if (rtl) {
          momentumDuration = Math.abs((-newPosition - swiper.translate) / swiper.velocity);
        } else {
          momentumDuration = Math.abs((newPosition - swiper.translate) / swiper.velocity);
        }

        if (params.freeMode.sticky) {
          // If freeMode.sticky is active and the user ends a swipe with a slow-velocity
          // event, then durations can be 20+ seconds to slide one (or zero!) slides.
          // It's easy to see this when simulating touch with mouse events. To fix this,
          // limit single-slide swipes to the default slide duration. This also has the
          // nice side effect of matching slide speed if the user stopped moving before
          // lifting finger or mouse vs. moving slowly before lifting the finger/mouse.
          // For faster swipes, also apply limits (albeit higher ones).
          const moveDistance = Math.abs((rtl ? -newPosition : newPosition) - swiper.translate);
          const currentSlideSize = swiper.slidesSizesGrid[swiper.activeIndex];

          if (moveDistance < currentSlideSize) {
            momentumDuration = params.speed;
          } else if (moveDistance < 2 * currentSlideSize) {
            momentumDuration = params.speed * 1.5;
          } else {
            momentumDuration = params.speed * 2.5;
          }
        }
      } else if (params.freeMode.sticky) {
        swiper.slideToClosest();
        return;
      }

      if (params.freeMode.momentumBounce && doBounce) {
        swiper.updateProgress(afterBouncePosition);
        swiper.setTransition(momentumDuration);
        swiper.setTranslate(newPosition);
        swiper.transitionStart(true, swiper.swipeDirection);
        swiper.animating = true;
        $wrapperEl.transitionEnd(() => {
          if (!swiper || swiper.destroyed || !data.allowMomentumBounce) return;
          emit('momentumBounce');
          swiper.setTransition(params.speed);
          setTimeout(() => {
            swiper.setTranslate(afterBouncePosition);
            $wrapperEl.transitionEnd(() => {
              if (!swiper || swiper.destroyed) return;
              swiper.transitionEnd();
            });
          }, 0);
        });
      } else if (swiper.velocity) {
        emit('_freeModeNoMomentumRelease');
        swiper.updateProgress(newPosition);
        swiper.setTransition(momentumDuration);
        swiper.setTranslate(newPosition);
        swiper.transitionStart(true, swiper.swipeDirection);

        if (!swiper.animating) {
          swiper.animating = true;
          $wrapperEl.transitionEnd(() => {
            if (!swiper || swiper.destroyed) return;
            swiper.transitionEnd();
          });
        }
      } else {
        swiper.updateProgress(newPosition);
      }

      swiper.updateActiveIndex();
      swiper.updateSlidesClasses();
    } else if (params.freeMode.sticky) {
      swiper.slideToClosest();
      return;
    } else if (params.freeMode) {
      emit('_freeModeNoMomentumRelease');
    }

    if (!params.freeMode.momentum || timeDiff >= params.longSwipesMs) {
      swiper.updateProgress();
      swiper.updateActiveIndex();
      swiper.updateSlidesClasses();
    }
  }

  Object.assign(swiper, {
    freeMode: {
      onTouchStart,
      onTouchMove,
      onTouchEnd
    }
  });
}
;// CONCATENATED MODULE: ./node_modules/swiper/modules/effect-cube/effect-cube.js


function EffectCube({
  swiper,
  extendParams,
  on
}) {
  extendParams({
    cubeEffect: {
      slideShadows: true,
      shadow: true,
      shadowOffset: 20,
      shadowScale: 0.94
    }
  });

  const createSlideShadows = ($slideEl, progress, isHorizontal) => {
    let shadowBefore = isHorizontal ? $slideEl.find('.swiper-slide-shadow-left') : $slideEl.find('.swiper-slide-shadow-top');
    let shadowAfter = isHorizontal ? $slideEl.find('.swiper-slide-shadow-right') : $slideEl.find('.swiper-slide-shadow-bottom');

    if (shadowBefore.length === 0) {
      shadowBefore = $(`<div class="swiper-slide-shadow-${isHorizontal ? 'left' : 'top'}"></div>`);
      $slideEl.append(shadowBefore);
    }

    if (shadowAfter.length === 0) {
      shadowAfter = $(`<div class="swiper-slide-shadow-${isHorizontal ? 'right' : 'bottom'}"></div>`);
      $slideEl.append(shadowAfter);
    }

    if (shadowBefore.length) shadowBefore[0].style.opacity = Math.max(-progress, 0);
    if (shadowAfter.length) shadowAfter[0].style.opacity = Math.max(progress, 0);
  };

  const recreateShadows = () => {
    // create new ones
    const isHorizontal = swiper.isHorizontal();
    swiper.slides.each(slideEl => {
      const progress = Math.max(Math.min(slideEl.progress, 1), -1);
      createSlideShadows($(slideEl), progress, isHorizontal);
    });
  };

  const setTranslate = () => {
    const {
      $el,
      $wrapperEl,
      slides,
      width: swiperWidth,
      height: swiperHeight,
      rtlTranslate: rtl,
      size: swiperSize,
      browser
    } = swiper;
    const params = swiper.params.cubeEffect;
    const isHorizontal = swiper.isHorizontal();
    const isVirtual = swiper.virtual && swiper.params.virtual.enabled;
    let wrapperRotate = 0;
    let $cubeShadowEl;

    if (params.shadow) {
      if (isHorizontal) {
        $cubeShadowEl = $wrapperEl.find('.swiper-cube-shadow');

        if ($cubeShadowEl.length === 0) {
          $cubeShadowEl = $('<div class="swiper-cube-shadow"></div>');
          $wrapperEl.append($cubeShadowEl);
        }

        $cubeShadowEl.css({
          height: `${swiperWidth}px`
        });
      } else {
        $cubeShadowEl = $el.find('.swiper-cube-shadow');

        if ($cubeShadowEl.length === 0) {
          $cubeShadowEl = $('<div class="swiper-cube-shadow"></div>');
          $el.append($cubeShadowEl);
        }
      }
    }

    for (let i = 0; i < slides.length; i += 1) {
      const $slideEl = slides.eq(i);
      let slideIndex = i;

      if (isVirtual) {
        slideIndex = parseInt($slideEl.attr('data-swiper-slide-index'), 10);
      }

      let slideAngle = slideIndex * 90;
      let round = Math.floor(slideAngle / 360);

      if (rtl) {
        slideAngle = -slideAngle;
        round = Math.floor(-slideAngle / 360);
      }

      const progress = Math.max(Math.min($slideEl[0].progress, 1), -1);
      let tx = 0;
      let ty = 0;
      let tz = 0;

      if (slideIndex % 4 === 0) {
        tx = -round * 4 * swiperSize;
        tz = 0;
      } else if ((slideIndex - 1) % 4 === 0) {
        tx = 0;
        tz = -round * 4 * swiperSize;
      } else if ((slideIndex - 2) % 4 === 0) {
        tx = swiperSize + round * 4 * swiperSize;
        tz = swiperSize;
      } else if ((slideIndex - 3) % 4 === 0) {
        tx = -swiperSize;
        tz = 3 * swiperSize + swiperSize * 4 * round;
      }

      if (rtl) {
        tx = -tx;
      }

      if (!isHorizontal) {
        ty = tx;
        tx = 0;
      }

      const transform = `rotateX(${isHorizontal ? 0 : -slideAngle}deg) rotateY(${isHorizontal ? slideAngle : 0}deg) translate3d(${tx}px, ${ty}px, ${tz}px)`;

      if (progress <= 1 && progress > -1) {
        wrapperRotate = slideIndex * 90 + progress * 90;
        if (rtl) wrapperRotate = -slideIndex * 90 - progress * 90;
      }

      $slideEl.transform(transform);

      if (params.slideShadows) {
        createSlideShadows($slideEl, progress, isHorizontal);
      }
    }

    $wrapperEl.css({
      '-webkit-transform-origin': `50% 50% -${swiperSize / 2}px`,
      'transform-origin': `50% 50% -${swiperSize / 2}px`
    });

    if (params.shadow) {
      if (isHorizontal) {
        $cubeShadowEl.transform(`translate3d(0px, ${swiperWidth / 2 + params.shadowOffset}px, ${-swiperWidth / 2}px) rotateX(90deg) rotateZ(0deg) scale(${params.shadowScale})`);
      } else {
        const shadowAngle = Math.abs(wrapperRotate) - Math.floor(Math.abs(wrapperRotate) / 90) * 90;
        const multiplier = 1.5 - (Math.sin(shadowAngle * 2 * Math.PI / 360) / 2 + Math.cos(shadowAngle * 2 * Math.PI / 360) / 2);
        const scale1 = params.shadowScale;
        const scale2 = params.shadowScale / multiplier;
        const offset = params.shadowOffset;
        $cubeShadowEl.transform(`scale3d(${scale1}, 1, ${scale2}) translate3d(0px, ${swiperHeight / 2 + offset}px, ${-swiperHeight / 2 / scale2}px) rotateX(-90deg)`);
      }
    }

    const zFactor = browser.isSafari || browser.isWebView ? -swiperSize / 2 : 0;
    $wrapperEl.transform(`translate3d(0px,0,${zFactor}px) rotateX(${swiper.isHorizontal() ? 0 : wrapperRotate}deg) rotateY(${swiper.isHorizontal() ? -wrapperRotate : 0}deg)`);
    $wrapperEl[0].style.setProperty('--swiper-cube-translate-z', `${zFactor}px`);
  };

  const setTransition = duration => {
    const {
      $el,
      slides
    } = swiper;
    slides.transition(duration).find('.swiper-slide-shadow-top, .swiper-slide-shadow-right, .swiper-slide-shadow-bottom, .swiper-slide-shadow-left').transition(duration);

    if (swiper.params.cubeEffect.shadow && !swiper.isHorizontal()) {
      $el.find('.swiper-cube-shadow').transition(duration);
    }
  };

  effectInit({
    effect: 'cube',
    swiper,
    on,
    setTranslate,
    setTransition,
    recreateShadows,
    getEffectParams: () => swiper.params.cubeEffect,
    perspective: () => true,
    overwriteParams: () => ({
      slidesPerView: 1,
      slidesPerGroup: 1,
      watchSlidesProgress: true,
      resistanceRatio: 0,
      spaceBetween: 0,
      centeredSlides: false,
      virtualTranslate: true
    })
  });
}
;// CONCATENATED MODULE: ./node_modules/swiper/shared/create-shadow.js

function create_shadow_createShadow(params, $slideEl, side) {
  const shadowClass = `swiper-slide-shadow${side ? `-${side}` : ''}`;
  const $shadowContainer = params.transformEl ? $slideEl.find(params.transformEl) : $slideEl;
  let $shadowEl = $shadowContainer.children(`.${shadowClass}`);

  if (!$shadowEl.length) {
    $shadowEl = $(`<div class="swiper-slide-shadow${side ? `-${side}` : ''}"></div>`);
    $shadowContainer.append($shadowEl);
  }

  return $shadowEl;
}
;// CONCATENATED MODULE: ./node_modules/swiper/modules/effect-flip/effect-flip.js





function EffectFlip({
  swiper,
  extendParams,
  on
}) {
  extendParams({
    flipEffect: {
      slideShadows: true,
      limitRotation: true,
      transformEl: null
    }
  });

  const createSlideShadows = ($slideEl, progress, params) => {
    let shadowBefore = swiper.isHorizontal() ? $slideEl.find('.swiper-slide-shadow-left') : $slideEl.find('.swiper-slide-shadow-top');
    let shadowAfter = swiper.isHorizontal() ? $slideEl.find('.swiper-slide-shadow-right') : $slideEl.find('.swiper-slide-shadow-bottom');

    if (shadowBefore.length === 0) {
      shadowBefore = createShadow(params, $slideEl, swiper.isHorizontal() ? 'left' : 'top');
    }

    if (shadowAfter.length === 0) {
      shadowAfter = createShadow(params, $slideEl, swiper.isHorizontal() ? 'right' : 'bottom');
    }

    if (shadowBefore.length) shadowBefore[0].style.opacity = Math.max(-progress, 0);
    if (shadowAfter.length) shadowAfter[0].style.opacity = Math.max(progress, 0);
  };

  const recreateShadows = () => {
    // Set shadows
    const params = swiper.params.flipEffect;
    swiper.slides.each(slideEl => {
      const $slideEl = $(slideEl);
      let progress = $slideEl[0].progress;

      if (swiper.params.flipEffect.limitRotation) {
        progress = Math.max(Math.min(slideEl.progress, 1), -1);
      }

      createSlideShadows($slideEl, progress, params);
    });
  };

  const setTranslate = () => {
    const {
      slides,
      rtlTranslate: rtl
    } = swiper;
    const params = swiper.params.flipEffect;

    for (let i = 0; i < slides.length; i += 1) {
      const $slideEl = slides.eq(i);
      let progress = $slideEl[0].progress;

      if (swiper.params.flipEffect.limitRotation) {
        progress = Math.max(Math.min($slideEl[0].progress, 1), -1);
      }

      const offset = $slideEl[0].swiperSlideOffset;
      const rotate = -180 * progress;
      let rotateY = rotate;
      let rotateX = 0;
      let tx = swiper.params.cssMode ? -offset - swiper.translate : -offset;
      let ty = 0;

      if (!swiper.isHorizontal()) {
        ty = tx;
        tx = 0;
        rotateX = -rotateY;
        rotateY = 0;
      } else if (rtl) {
        rotateY = -rotateY;
      }

      $slideEl[0].style.zIndex = -Math.abs(Math.round(progress)) + slides.length;

      if (params.slideShadows) {
        createSlideShadows($slideEl, progress, params);
      }

      const transform = `translate3d(${tx}px, ${ty}px, 0px) rotateX(${rotateX}deg) rotateY(${rotateY}deg)`;
      const $targetEl = effectTarget(params, $slideEl);
      $targetEl.transform(transform);
    }
  };

  const setTransition = duration => {
    const {
      transformEl
    } = swiper.params.flipEffect;
    const $transitionElements = transformEl ? swiper.slides.find(transformEl) : swiper.slides;
    $transitionElements.transition(duration).find('.swiper-slide-shadow-top, .swiper-slide-shadow-right, .swiper-slide-shadow-bottom, .swiper-slide-shadow-left').transition(duration);
    effectVirtualTransitionEnd({
      swiper,
      duration,
      transformEl
    });
  };

  effectInit({
    effect: 'flip',
    swiper,
    on,
    setTranslate,
    setTransition,
    recreateShadows,
    getEffectParams: () => swiper.params.flipEffect,
    perspective: () => true,
    overwriteParams: () => ({
      slidesPerView: 1,
      slidesPerGroup: 1,
      watchSlidesProgress: true,
      spaceBetween: 0,
      virtualTranslate: !swiper.params.cssMode
    })
  });
}
;// CONCATENATED MODULE: ./node_modules/swiper/modules/effect-coverflow/effect-coverflow.js



function EffectCoverflow({
  swiper,
  extendParams,
  on
}) {
  extendParams({
    coverflowEffect: {
      rotate: 50,
      stretch: 0,
      depth: 100,
      scale: 1,
      modifier: 1,
      slideShadows: true,
      transformEl: null
    }
  });

  const setTranslate = () => {
    const {
      width: swiperWidth,
      height: swiperHeight,
      slides,
      slidesSizesGrid
    } = swiper;
    const params = swiper.params.coverflowEffect;
    const isHorizontal = swiper.isHorizontal();
    const transform = swiper.translate;
    const center = isHorizontal ? -transform + swiperWidth / 2 : -transform + swiperHeight / 2;
    const rotate = isHorizontal ? params.rotate : -params.rotate;
    const translate = params.depth; // Each slide offset from center

    for (let i = 0, length = slides.length; i < length; i += 1) {
      const $slideEl = slides.eq(i);
      const slideSize = slidesSizesGrid[i];
      const slideOffset = $slideEl[0].swiperSlideOffset;
      const centerOffset = (center - slideOffset - slideSize / 2) / slideSize;
      const offsetMultiplier = typeof params.modifier === 'function' ? params.modifier(centerOffset) : centerOffset * params.modifier;
      let rotateY = isHorizontal ? rotate * offsetMultiplier : 0;
      let rotateX = isHorizontal ? 0 : rotate * offsetMultiplier; // var rotateZ = 0

      let translateZ = -translate * Math.abs(offsetMultiplier);
      let stretch = params.stretch; // Allow percentage to make a relative stretch for responsive sliders

      if (typeof stretch === 'string' && stretch.indexOf('%') !== -1) {
        stretch = parseFloat(params.stretch) / 100 * slideSize;
      }

      let translateY = isHorizontal ? 0 : stretch * offsetMultiplier;
      let translateX = isHorizontal ? stretch * offsetMultiplier : 0;
      let scale = 1 - (1 - params.scale) * Math.abs(offsetMultiplier); // Fix for ultra small values

      if (Math.abs(translateX) < 0.001) translateX = 0;
      if (Math.abs(translateY) < 0.001) translateY = 0;
      if (Math.abs(translateZ) < 0.001) translateZ = 0;
      if (Math.abs(rotateY) < 0.001) rotateY = 0;
      if (Math.abs(rotateX) < 0.001) rotateX = 0;
      if (Math.abs(scale) < 0.001) scale = 0;
      const slideTransform = `translate3d(${translateX}px,${translateY}px,${translateZ}px)  rotateX(${rotateX}deg) rotateY(${rotateY}deg) scale(${scale})`;
      const $targetEl = effectTarget(params, $slideEl);
      $targetEl.transform(slideTransform);
      $slideEl[0].style.zIndex = -Math.abs(Math.round(offsetMultiplier)) + 1;

      if (params.slideShadows) {
        // Set shadows
        let $shadowBeforeEl = isHorizontal ? $slideEl.find('.swiper-slide-shadow-left') : $slideEl.find('.swiper-slide-shadow-top');
        let $shadowAfterEl = isHorizontal ? $slideEl.find('.swiper-slide-shadow-right') : $slideEl.find('.swiper-slide-shadow-bottom');

        if ($shadowBeforeEl.length === 0) {
          $shadowBeforeEl = createShadow(params, $slideEl, isHorizontal ? 'left' : 'top');
        }

        if ($shadowAfterEl.length === 0) {
          $shadowAfterEl = createShadow(params, $slideEl, isHorizontal ? 'right' : 'bottom');
        }

        if ($shadowBeforeEl.length) $shadowBeforeEl[0].style.opacity = offsetMultiplier > 0 ? offsetMultiplier : 0;
        if ($shadowAfterEl.length) $shadowAfterEl[0].style.opacity = -offsetMultiplier > 0 ? -offsetMultiplier : 0;
      }
    }
  };

  const setTransition = duration => {
    const {
      transformEl
    } = swiper.params.coverflowEffect;
    const $transitionElements = transformEl ? swiper.slides.find(transformEl) : swiper.slides;
    $transitionElements.transition(duration).find('.swiper-slide-shadow-top, .swiper-slide-shadow-right, .swiper-slide-shadow-bottom, .swiper-slide-shadow-left').transition(duration);
  };

  effectInit({
    effect: 'coverflow',
    swiper,
    on,
    setTranslate,
    setTransition,
    perspective: () => true,
    overwriteParams: () => ({
      watchSlidesProgress: true
    })
  });
}
;// CONCATENATED MODULE: ./node_modules/swiper/modules/effect-creative/effect-creative.js




function EffectCreative({
  swiper,
  extendParams,
  on
}) {
  extendParams({
    creativeEffect: {
      transformEl: null,
      limitProgress: 1,
      shadowPerProgress: false,
      progressMultiplier: 1,
      perspective: true,
      prev: {
        translate: [0, 0, 0],
        rotate: [0, 0, 0],
        opacity: 1,
        scale: 1
      },
      next: {
        translate: [0, 0, 0],
        rotate: [0, 0, 0],
        opacity: 1,
        scale: 1
      }
    }
  });

  const getTranslateValue = value => {
    if (typeof value === 'string') return value;
    return `${value}px`;
  };

  const setTranslate = () => {
    const {
      slides,
      $wrapperEl,
      slidesSizesGrid
    } = swiper;
    const params = swiper.params.creativeEffect;
    const {
      progressMultiplier: multiplier
    } = params;
    const isCenteredSlides = swiper.params.centeredSlides;

    if (isCenteredSlides) {
      const margin = slidesSizesGrid[0] / 2 - swiper.params.slidesOffsetBefore || 0;
      $wrapperEl.transform(`translateX(calc(50% - ${margin}px))`);
    }

    for (let i = 0; i < slides.length; i += 1) {
      const $slideEl = slides.eq(i);
      const slideProgress = $slideEl[0].progress;
      const progress = Math.min(Math.max($slideEl[0].progress, -params.limitProgress), params.limitProgress);
      let originalProgress = progress;

      if (!isCenteredSlides) {
        originalProgress = Math.min(Math.max($slideEl[0].originalProgress, -params.limitProgress), params.limitProgress);
      }

      const offset = $slideEl[0].swiperSlideOffset;
      const t = [swiper.params.cssMode ? -offset - swiper.translate : -offset, 0, 0];
      const r = [0, 0, 0];
      let custom = false;

      if (!swiper.isHorizontal()) {
        t[1] = t[0];
        t[0] = 0;
      }

      let data = {
        translate: [0, 0, 0],
        rotate: [0, 0, 0],
        scale: 1,
        opacity: 1
      };

      if (progress < 0) {
        data = params.next;
        custom = true;
      } else if (progress > 0) {
        data = params.prev;
        custom = true;
      } // set translate


      t.forEach((value, index) => {
        t[index] = `calc(${value}px + (${getTranslateValue(data.translate[index])} * ${Math.abs(progress * multiplier)}))`;
      }); // set rotates

      r.forEach((value, index) => {
        r[index] = data.rotate[index] * Math.abs(progress * multiplier);
      });
      $slideEl[0].style.zIndex = -Math.abs(Math.round(slideProgress)) + slides.length;
      const translateString = t.join(', ');
      const rotateString = `rotateX(${r[0]}deg) rotateY(${r[1]}deg) rotateZ(${r[2]}deg)`;
      const scaleString = originalProgress < 0 ? `scale(${1 + (1 - data.scale) * originalProgress * multiplier})` : `scale(${1 - (1 - data.scale) * originalProgress * multiplier})`;
      const opacityString = originalProgress < 0 ? 1 + (1 - data.opacity) * originalProgress * multiplier : 1 - (1 - data.opacity) * originalProgress * multiplier;
      const transform = `translate3d(${translateString}) ${rotateString} ${scaleString}`; // Set shadows

      if (custom && data.shadow || !custom) {
        let $shadowEl = $slideEl.children('.swiper-slide-shadow');

        if ($shadowEl.length === 0 && data.shadow) {
          $shadowEl = createShadow(params, $slideEl);
        }

        if ($shadowEl.length) {
          const shadowOpacity = params.shadowPerProgress ? progress * (1 / params.limitProgress) : progress;
          $shadowEl[0].style.opacity = Math.min(Math.max(Math.abs(shadowOpacity), 0), 1);
        }
      }

      const $targetEl = effectTarget(params, $slideEl);
      $targetEl.transform(transform).css({
        opacity: opacityString
      });

      if (data.origin) {
        $targetEl.css('transform-origin', data.origin);
      }
    }
  };

  const setTransition = duration => {
    const {
      transformEl
    } = swiper.params.creativeEffect;
    const $transitionElements = transformEl ? swiper.slides.find(transformEl) : swiper.slides;
    $transitionElements.transition(duration).find('.swiper-slide-shadow').transition(duration);
    effectVirtualTransitionEnd({
      swiper,
      duration,
      transformEl,
      allSlides: true
    });
  };

  effectInit({
    effect: 'creative',
    swiper,
    on,
    setTranslate,
    setTransition,
    perspective: () => swiper.params.creativeEffect.perspective,
    overwriteParams: () => ({
      watchSlidesProgress: true,
      virtualTranslate: !swiper.params.cssMode
    })
  });
}
;// CONCATENATED MODULE: ./node_modules/swiper/modules/effect-cards/effect-cards.js




function EffectCards({
  swiper,
  extendParams,
  on
}) {
  extendParams({
    cardsEffect: {
      slideShadows: true,
      transformEl: null,
      rotate: true,
      perSlideRotate: 2,
      perSlideOffset: 8
    }
  });

  const setTranslate = () => {
    const {
      slides,
      activeIndex
    } = swiper;
    const params = swiper.params.cardsEffect;
    const {
      startTranslate,
      isTouched
    } = swiper.touchEventsData;
    const currentTranslate = swiper.translate;

    for (let i = 0; i < slides.length; i += 1) {
      const $slideEl = slides.eq(i);
      const slideProgress = $slideEl[0].progress;
      const progress = Math.min(Math.max(slideProgress, -4), 4);
      let offset = $slideEl[0].swiperSlideOffset;

      if (swiper.params.centeredSlides && !swiper.params.cssMode) {
        swiper.$wrapperEl.transform(`translateX(${swiper.minTranslate()}px)`);
      }

      if (swiper.params.centeredSlides && swiper.params.cssMode) {
        offset -= slides[0].swiperSlideOffset;
      }

      let tX = swiper.params.cssMode ? -offset - swiper.translate : -offset;
      let tY = 0;
      const tZ = -100 * Math.abs(progress);
      let scale = 1;
      let rotate = -params.perSlideRotate * progress;
      let tXAdd = params.perSlideOffset - Math.abs(progress) * 0.75;
      const slideIndex = swiper.virtual && swiper.params.virtual.enabled ? swiper.virtual.from + i : i;
      const isSwipeToNext = (slideIndex === activeIndex || slideIndex === activeIndex - 1) && progress > 0 && progress < 1 && (isTouched || swiper.params.cssMode) && currentTranslate < startTranslate;
      const isSwipeToPrev = (slideIndex === activeIndex || slideIndex === activeIndex + 1) && progress < 0 && progress > -1 && (isTouched || swiper.params.cssMode) && currentTranslate > startTranslate;

      if (isSwipeToNext || isSwipeToPrev) {
        const subProgress = (1 - Math.abs((Math.abs(progress) - 0.5) / 0.5)) ** 0.5;
        rotate += -28 * progress * subProgress;
        scale += -0.5 * subProgress;
        tXAdd += 96 * subProgress;
        tY = `${-25 * subProgress * Math.abs(progress)}%`;
      }

      if (progress < 0) {
        // next
        tX = `calc(${tX}px + (${tXAdd * Math.abs(progress)}%))`;
      } else if (progress > 0) {
        // prev
        tX = `calc(${tX}px + (-${tXAdd * Math.abs(progress)}%))`;
      } else {
        tX = `${tX}px`;
      }

      if (!swiper.isHorizontal()) {
        const prevY = tY;
        tY = tX;
        tX = prevY;
      }

      const scaleString = progress < 0 ? `${1 + (1 - scale) * progress}` : `${1 - (1 - scale) * progress}`;
      const transform = `
        translate3d(${tX}, ${tY}, ${tZ}px)
        rotateZ(${params.rotate ? rotate : 0}deg)
        scale(${scaleString})
      `;

      if (params.slideShadows) {
        // Set shadows
        let $shadowEl = $slideEl.find('.swiper-slide-shadow');

        if ($shadowEl.length === 0) {
          $shadowEl = createShadow(params, $slideEl);
        }

        if ($shadowEl.length) $shadowEl[0].style.opacity = Math.min(Math.max((Math.abs(progress) - 0.5) / 0.5, 0), 1);
      }

      $slideEl[0].style.zIndex = -Math.abs(Math.round(slideProgress)) + slides.length;
      const $targetEl = effectTarget(params, $slideEl);
      $targetEl.transform(transform);
    }
  };

  const setTransition = duration => {
    const {
      transformEl
    } = swiper.params.cardsEffect;
    const $transitionElements = transformEl ? swiper.slides.find(transformEl) : swiper.slides;
    $transitionElements.transition(duration).find('.swiper-slide-shadow').transition(duration);
    effectVirtualTransitionEnd({
      swiper,
      duration,
      transformEl
    });
  };

  effectInit({
    effect: 'cards',
    swiper,
    on,
    setTranslate,
    setTransition,
    perspective: () => true,
    overwriteParams: () => ({
      watchSlidesProgress: true,
      virtualTranslate: !swiper.params.cssMode
    })
  });
}
;// CONCATENATED MODULE: ./node_modules/swiper/swiper.esm.js
/**
 * Swiper 8.4.7
 * Most modern mobile touch slider and framework with hardware accelerated transitions
 * https://swiperjs.com
 *
 * Copyright 2014-2023 Vladimir Kharlampidi
 *
 * Released under the MIT License
 *
 * Released on: January 30, 2023
 */



























/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [179], function() { return __webpack_exec__(6840), __webpack_exec__(45337); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);